
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire62ed"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire62ed"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("goxuX", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $bef8df49949e79b1$export$ffb0004e005737fa; }, function (v) { return $bef8df49949e79b1$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $bef8df49949e79b1$export$34b9dba7ce09269b; }, function (v) { return $bef8df49949e79b1$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $bef8df49949e79b1$export$25062201e9e25d76; }, function (v) { return $bef8df49949e79b1$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bef8df49949e79b1$export$ffb0004e005737fa;
var $bef8df49949e79b1$export$34b9dba7ce09269b;
var $bef8df49949e79b1$export$25062201e9e25d76;
"use strict";

(function() {
    function getComponentNameFromType(type) {
        if (null == type) return null;
        if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
        if ("string" === typeof type) return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
            case REACT_ACTIVITY_TYPE:
                return "Activity";
        }
        if ("object" === typeof type) switch("number" === typeof type.tag && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), type.$$typeof){
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_CONTEXT_TYPE:
                return type.displayName || "Context";
            case REACT_CONSUMER_TYPE:
                return (type._context.displayName || "Context") + ".Consumer";
            case REACT_FORWARD_REF_TYPE:
                var innerType = type.render;
                type = type.displayName;
                type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
                return type;
            case REACT_MEMO_TYPE:
                return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                innerType = type._payload;
                type = type._init;
                try {
                    return getComponentNameFromType(type(innerType));
                } catch (x) {}
        }
        return null;
    }
    function testStringCoercion(value) {
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        try {
            testStringCoercion(value);
            var JSCompiler_inline_result = !1;
        } catch (e) {
            JSCompiler_inline_result = !0;
        }
        if (JSCompiler_inline_result) {
            JSCompiler_inline_result = console;
            var JSCompiler_temp_const = JSCompiler_inline_result.error;
            var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
            JSCompiler_temp_const.call(JSCompiler_inline_result, "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", JSCompiler_inline_result$jscomp$0);
            return testStringCoercion(value);
        }
    }
    function getTaskName(type) {
        if (type === REACT_FRAGMENT_TYPE) return "<>";
        if ("object" === typeof type && null !== type && type.$$typeof === REACT_LAZY_TYPE) return "<...>";
        try {
            var name = getComponentNameFromType(type);
            return name ? "<" + name + ">" : "<...>";
        } catch (x) {
            return "<...>";
        }
    }
    function getOwner() {
        var dispatcher = ReactSharedInternals.A;
        return null === dispatcher ? null : dispatcher.getOwner();
    }
    function UnknownOwner() {
        return Error("react-stack-top-frame");
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return !1;
        }
        return void 0 !== config.key;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        function warnAboutAccessingKey() {
            specialPropKeyWarningShown || (specialPropKeyWarningShown = !0, console.error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)", displayName));
        }
        warnAboutAccessingKey.isReactWarning = !0;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: !0
        });
    }
    function elementRefGetterWithDeprecationWarning() {
        var componentName = getComponentNameFromType(this.type);
        didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = !0, console.error("Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."));
        componentName = this.props.ref;
        return void 0 !== componentName ? componentName : null;
    }
    function ReactElement(type, key, props, owner, debugStack, debugTask) {
        var refProp = props.ref;
        type = {
            $$typeof: REACT_ELEMENT_TYPE,
            type: type,
            key: key,
            props: props,
            _owner: owner
        };
        null !== (void 0 !== refProp ? refProp : null) ? Object.defineProperty(type, "ref", {
            enumerable: !1,
            get: elementRefGetterWithDeprecationWarning
        }) : Object.defineProperty(type, "ref", {
            enumerable: !1,
            value: null
        });
        type._store = {};
        Object.defineProperty(type._store, "validated", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: 0
        });
        Object.defineProperty(type, "_debugInfo", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: null
        });
        Object.defineProperty(type, "_debugStack", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: debugStack
        });
        Object.defineProperty(type, "_debugTask", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: debugTask
        });
        Object.freeze && (Object.freeze(type.props), Object.freeze(type));
        return type;
    }
    function jsxDEVImpl(type, config, maybeKey, isStaticChildren, debugStack, debugTask) {
        var children = config.children;
        if (void 0 !== children) {
            if (isStaticChildren) {
                if (isArrayImpl(children)) {
                    for(isStaticChildren = 0; isStaticChildren < children.length; isStaticChildren++)validateChildKeys(children[isStaticChildren]);
                    Object.freeze && Object.freeze(children);
                } else console.error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            } else validateChildKeys(children);
        }
        if (hasOwnProperty.call(config, "key")) {
            children = getComponentNameFromType(type);
            var keys = Object.keys(config).filter(function(k) {
                return "key" !== k;
            });
            isStaticChildren = 0 < keys.length ? "{key: someKey, " + keys.join(": ..., ") + ": ...}" : "{key: someKey}";
            didWarnAboutKeySpread[children + isStaticChildren] || (keys = 0 < keys.length ? "{" + keys.join(": ..., ") + ": ...}" : "{}", console.error('A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />', isStaticChildren, children, keys, children), didWarnAboutKeySpread[children + isStaticChildren] = !0);
        }
        children = null;
        void 0 !== maybeKey && (checkKeyStringCoercion(maybeKey), children = "" + maybeKey);
        hasValidKey(config) && (checkKeyStringCoercion(config.key), children = "" + config.key);
        if ("key" in config) {
            maybeKey = {};
            for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
        } else maybeKey = config;
        children && defineKeyPropWarningGetter(maybeKey, "function" === typeof type ? type.displayName || type.name || "Unknown" : type);
        return ReactElement(type, children, maybeKey, getOwner(), debugStack, debugTask);
    }
    function validateChildKeys(node) {
        isValidElement(node) ? node._store && (node._store.validated = 1) : "object" === typeof node && null !== node && node.$$typeof === REACT_LAZY_TYPE && ("fulfilled" === node._payload.status ? isValidElement(node._payload.value) && node._payload.value._store && (node._payload.value._store.validated = 1) : node._store && (node._store.validated = 1));
    }
    function isValidElement(object) {
        return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var React = (parcelRequire("2xPiy")), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, hasOwnProperty = Object.prototype.hasOwnProperty, isArrayImpl = Array.isArray, createTask = console.createTask ? console.createTask : function() {
        return null;
    };
    React = {
        react_stack_bottom_frame: function(callStackForError) {
            return callStackForError();
        }
    };
    var specialPropKeyWarningShown;
    var didWarnAboutElementRef = {};
    var unknownOwnerDebugStack = React.react_stack_bottom_frame.bind(React, UnknownOwner)();
    var unknownOwnerDebugTask = createTask(getTaskName(UnknownOwner));
    var didWarnAboutKeySpread = {};
    $bef8df49949e79b1$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $bef8df49949e79b1$export$34b9dba7ce09269b = function(type, config, maybeKey) {
        var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
        return jsxDEVImpl(type, config, maybeKey, !1, trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack, trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask);
    };
    $bef8df49949e79b1$export$25062201e9e25d76 = function(type, config, maybeKey) {
        var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
        return jsxDEVImpl(type, config, maybeKey, !0, trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack, trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask);
    };
})();

});
parcelRegister("2xPiy", function(module, exports) {
'use strict';

module.exports = (parcelRequire("c00La"));

});
parcelRegister("c00La", function(module, exports) {
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    function defineDeprecationWarning(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                console.warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
            }
        });
    }
    function getIteratorFn(maybeIterable) {
        if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
        maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
        return "function" === typeof maybeIterable ? maybeIterable : null;
    }
    function warnNoop(publicInstance, callerName) {
        publicInstance = (publicInstance = publicInstance.constructor) && (publicInstance.displayName || publicInstance.name) || "ReactClass";
        var warningKey = publicInstance + "." + callerName;
        didWarnStateUpdateForUnmountedComponent[warningKey] || (console.error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, publicInstance), didWarnStateUpdateForUnmountedComponent[warningKey] = !0);
    }
    function Component(props, context, updater) {
        this.props = props;
        this.context = context;
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    function ComponentDummy() {}
    function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context;
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    function noop() {}
    function testStringCoercion(value) {
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        try {
            testStringCoercion(value);
            var JSCompiler_inline_result = !1;
        } catch (e) {
            JSCompiler_inline_result = !0;
        }
        if (JSCompiler_inline_result) {
            JSCompiler_inline_result = console;
            var JSCompiler_temp_const = JSCompiler_inline_result.error;
            var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
            JSCompiler_temp_const.call(JSCompiler_inline_result, "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", JSCompiler_inline_result$jscomp$0);
            return testStringCoercion(value);
        }
    }
    function getComponentNameFromType(type) {
        if (null == type) return null;
        if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
        if ("string" === typeof type) return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
            case REACT_ACTIVITY_TYPE:
                return "Activity";
        }
        if ("object" === typeof type) switch("number" === typeof type.tag && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), type.$$typeof){
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_CONTEXT_TYPE:
                return type.displayName || "Context";
            case REACT_CONSUMER_TYPE:
                return (type._context.displayName || "Context") + ".Consumer";
            case REACT_FORWARD_REF_TYPE:
                var innerType = type.render;
                type = type.displayName;
                type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
                return type;
            case REACT_MEMO_TYPE:
                return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                innerType = type._payload;
                type = type._init;
                try {
                    return getComponentNameFromType(type(innerType));
                } catch (x) {}
        }
        return null;
    }
    function getTaskName(type) {
        if (type === REACT_FRAGMENT_TYPE) return "<>";
        if ("object" === typeof type && null !== type && type.$$typeof === REACT_LAZY_TYPE) return "<...>";
        try {
            var name = getComponentNameFromType(type);
            return name ? "<" + name + ">" : "<...>";
        } catch (x) {
            return "<...>";
        }
    }
    function getOwner() {
        var dispatcher = ReactSharedInternals.A;
        return null === dispatcher ? null : dispatcher.getOwner();
    }
    function UnknownOwner() {
        return Error("react-stack-top-frame");
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return !1;
        }
        return void 0 !== config.key;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        function warnAboutAccessingKey() {
            specialPropKeyWarningShown || (specialPropKeyWarningShown = !0, console.error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)", displayName));
        }
        warnAboutAccessingKey.isReactWarning = !0;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: !0
        });
    }
    function elementRefGetterWithDeprecationWarning() {
        var componentName = getComponentNameFromType(this.type);
        didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = !0, console.error("Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."));
        componentName = this.props.ref;
        return void 0 !== componentName ? componentName : null;
    }
    function ReactElement(type, key, props, owner, debugStack, debugTask) {
        var refProp = props.ref;
        type = {
            $$typeof: REACT_ELEMENT_TYPE,
            type: type,
            key: key,
            props: props,
            _owner: owner
        };
        null !== (void 0 !== refProp ? refProp : null) ? Object.defineProperty(type, "ref", {
            enumerable: !1,
            get: elementRefGetterWithDeprecationWarning
        }) : Object.defineProperty(type, "ref", {
            enumerable: !1,
            value: null
        });
        type._store = {};
        Object.defineProperty(type._store, "validated", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: 0
        });
        Object.defineProperty(type, "_debugInfo", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: null
        });
        Object.defineProperty(type, "_debugStack", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: debugStack
        });
        Object.defineProperty(type, "_debugTask", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: debugTask
        });
        Object.freeze && (Object.freeze(type.props), Object.freeze(type));
        return type;
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        newKey = ReactElement(oldElement.type, newKey, oldElement.props, oldElement._owner, oldElement._debugStack, oldElement._debugTask);
        oldElement._store && (newKey._store.validated = oldElement._store.validated);
        return newKey;
    }
    function validateChildKeys(node) {
        isValidElement(node) ? node._store && (node._store.validated = 1) : "object" === typeof node && null !== node && node.$$typeof === REACT_LAZY_TYPE && ("fulfilled" === node._payload.status ? isValidElement(node._payload.value) && node._payload.value._store && (node._payload.value._store.validated = 1) : node._store && (node._store.validated = 1));
    }
    function isValidElement(object) {
        return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function escape(key) {
        var escaperLookup = {
            "=": "=0",
            ":": "=2"
        };
        return "$" + key.replace(/[=:]/g, function(match) {
            return escaperLookup[match];
        });
    }
    function getElementKey(element, index) {
        return "object" === typeof element && null !== element && null != element.key ? (checkKeyStringCoercion(element.key), escape("" + element.key)) : index.toString(36);
    }
    function resolveThenable(thenable) {
        switch(thenable.status){
            case "fulfilled":
                return thenable.value;
            case "rejected":
                throw thenable.reason;
            default:
                switch("string" === typeof thenable.status ? thenable.then(noop, noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                    "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
                }, function(error) {
                    "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
                })), thenable.status){
                    case "fulfilled":
                        return thenable.value;
                    case "rejected":
                        throw thenable.reason;
                }
        }
        throw thenable;
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if ("undefined" === type || "boolean" === type) children = null;
        var invokeCallback = !1;
        if (null === children) invokeCallback = !0;
        else switch(type){
            case "bigint":
            case "string":
            case "number":
                invokeCallback = !0;
                break;
            case "object":
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = !0;
                        break;
                    case REACT_LAZY_TYPE:
                        return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
                }
        }
        if (invokeCallback) {
            invokeCallback = children;
            callback = callback(invokeCallback);
            var childKey = "" === nameSoFar ? "." + getElementKey(invokeCallback, 0) : nameSoFar;
            isArrayImpl(callback) ? (escapedPrefix = "", null != childKey && (escapedPrefix = childKey.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
                return c;
            })) : null != callback && (isValidElement(callback) && (null != callback.key && (invokeCallback && invokeCallback.key === callback.key || checkKeyStringCoercion(callback.key)), escapedPrefix = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || invokeCallback && invokeCallback.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + childKey), "" !== nameSoFar && null != invokeCallback && isValidElement(invokeCallback) && null == invokeCallback.key && invokeCallback._store && !invokeCallback._store.validated && (escapedPrefix._store.validated = 2), callback = escapedPrefix), array.push(callback));
            return 1;
        }
        invokeCallback = 0;
        childKey = "" === nameSoFar ? "." : nameSoFar + ":";
        if (isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = childKey + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
        else if (i = getIteratorFn(children), "function" === typeof i) for(i === children.entries && (didWarnAboutMaps || console.warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), didWarnAboutMaps = !0), children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = childKey + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
        else if ("object" === type) {
            if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
            array = String(children);
            throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
        }
        return invokeCallback;
    }
    function mapChildren(children, func, context) {
        if (null == children) return children;
        var result = [], count = 0;
        mapIntoArray(children, result, "", "", function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    function lazyInitializer(payload) {
        if (-1 === payload._status) {
            var ioInfo = payload._ioInfo;
            null != ioInfo && (ioInfo.start = ioInfo.end = performance.now());
            ioInfo = payload._result;
            var thenable = ioInfo();
            thenable.then(function(moduleObject) {
                if (0 === payload._status || -1 === payload._status) {
                    payload._status = 1;
                    payload._result = moduleObject;
                    var _ioInfo = payload._ioInfo;
                    null != _ioInfo && (_ioInfo.end = performance.now());
                    void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
                }
            }, function(error) {
                if (0 === payload._status || -1 === payload._status) {
                    payload._status = 2;
                    payload._result = error;
                    var _ioInfo2 = payload._ioInfo;
                    null != _ioInfo2 && (_ioInfo2.end = performance.now());
                    void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
                }
            });
            ioInfo = payload._ioInfo;
            if (null != ioInfo) {
                ioInfo.value = thenable;
                var displayName = thenable.displayName;
                "string" === typeof displayName && (ioInfo.name = displayName);
            }
            -1 === payload._status && (payload._status = 0, payload._result = thenable);
        }
        if (1 === payload._status) return ioInfo = payload._result, void 0 === ioInfo && console.error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", ioInfo), "default" in ioInfo || console.error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", ioInfo), ioInfo.default;
        throw payload._result;
    }
    function resolveDispatcher() {
        var dispatcher = ReactSharedInternals.H;
        null === dispatcher && console.error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.");
        return dispatcher;
    }
    function releaseAsyncTransition() {
        ReactSharedInternals.asyncTransitions--;
    }
    function enqueueTask(task) {
        if (null === enqueueTaskImpl) try {
            var requireString = ("require" + Math.random()).slice(0, 7);
            enqueueTaskImpl = (module && module[requireString]).call(module, "timers").setImmediate;
        } catch (_err) {
            enqueueTaskImpl = function(callback) {
                !1 === didWarnAboutMessageChannel && (didWarnAboutMessageChannel = !0, "undefined" === typeof MessageChannel && console.error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
                var channel = new MessageChannel();
                channel.port1.onmessage = callback;
                channel.port2.postMessage(void 0);
            };
        }
        return enqueueTaskImpl(task);
    }
    function aggregateErrors(errors) {
        return 1 < errors.length && "function" === typeof AggregateError ? new AggregateError(errors) : errors[0];
    }
    function popActScope(prevActQueue, prevActScopeDepth) {
        prevActScopeDepth !== actScopeDepth - 1 && console.error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
        actScopeDepth = prevActScopeDepth;
    }
    function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
        var queue = ReactSharedInternals.actQueue;
        if (null !== queue) {
            if (0 !== queue.length) try {
                flushActQueue(queue);
                enqueueTask(function() {
                    return recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                });
                return;
            } catch (error) {
                ReactSharedInternals.thrownErrors.push(error);
            }
            else ReactSharedInternals.actQueue = null;
        }
        0 < ReactSharedInternals.thrownErrors.length ? (queue = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, reject(queue)) : resolve(returnValue);
    }
    function flushActQueue(queue) {
        if (!isFlushing) {
            isFlushing = !0;
            var i = 0;
            try {
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do {
                        ReactSharedInternals.didUsePromise = !1;
                        var continuation = callback(!1);
                        if (null !== continuation) {
                            if (ReactSharedInternals.didUsePromise) {
                                queue[i] = callback;
                                queue.splice(0, i);
                                return;
                            }
                            callback = continuation;
                        } else break;
                    }while (1);
                }
                queue.length = 0;
            } catch (error) {
                queue.splice(0, i + 1), ReactSharedInternals.thrownErrors.push(error);
            } finally{
                isFlushing = !1;
            }
        }
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator, didWarnStateUpdateForUnmountedComponent = {}, ReactNoopUpdateQueue = {
        isMounted: function() {
            return !1;
        },
        enqueueForceUpdate: function(publicInstance) {
            warnNoop(publicInstance, "forceUpdate");
        },
        enqueueReplaceState: function(publicInstance) {
            warnNoop(publicInstance, "replaceState");
        },
        enqueueSetState: function(publicInstance) {
            warnNoop(publicInstance, "setState");
        }
    }, assign = Object.assign, emptyObject = {};
    Object.freeze(emptyObject);
    Component.prototype.isReactComponent = {};
    Component.prototype.setState = function(partialState, callback) {
        if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, "setState");
    };
    Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
    };
    var deprecatedAPIs = {
        isMounted: [
            "isMounted",
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            "replaceState",
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    for(fnName in deprecatedAPIs)deprecatedAPIs.hasOwnProperty(fnName) && defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    ComponentDummy.prototype = Component.prototype;
    deprecatedAPIs = PureComponent.prototype = new ComponentDummy();
    deprecatedAPIs.constructor = PureComponent;
    assign(deprecatedAPIs, Component.prototype);
    deprecatedAPIs.isPureReactComponent = !0;
    var isArrayImpl = Array.isArray, REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), ReactSharedInternals = {
        H: null,
        A: null,
        T: null,
        S: null,
        actQueue: null,
        asyncTransitions: 0,
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1,
        didUsePromise: !1,
        thrownErrors: [],
        getCurrentStack: null,
        recentlyCreatedOwnerStacks: 0
    }, hasOwnProperty = Object.prototype.hasOwnProperty, createTask = console.createTask ? console.createTask : function() {
        return null;
    };
    deprecatedAPIs = {
        react_stack_bottom_frame: function(callStackForError) {
            return callStackForError();
        }
    };
    var specialPropKeyWarningShown, didWarnAboutOldJSXRuntime;
    var didWarnAboutElementRef = {};
    var unknownOwnerDebugStack = deprecatedAPIs.react_stack_bottom_frame.bind(deprecatedAPIs, UnknownOwner)();
    var unknownOwnerDebugTask = createTask(getTaskName(UnknownOwner));
    var didWarnAboutMaps = !1, userProvidedKeyEscapeRegex = /\/+/g, reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
        if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
            var event = new window.ErrorEvent("error", {
                bubbles: !0,
                cancelable: !0,
                message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
                error: error
            });
            if (!window.dispatchEvent(event)) return;
        }
        console.error(error);
    }, didWarnAboutMessageChannel = !1, enqueueTaskImpl = null, actScopeDepth = 0, didWarnNoAwaitAct = !1, isFlushing = !1, queueSeveralMicrotasks = "function" === typeof queueMicrotask ? function(callback) {
        queueMicrotask(function() {
            return queueMicrotask(callback);
        });
    } : enqueueTask;
    deprecatedAPIs = Object.freeze({
        __proto__: null,
        c: function(size) {
            return resolveDispatcher().useMemoCache(size);
        }
    });
    var fnName = {
        map: mapChildren,
        forEach: function(children, forEachFunc, forEachContext) {
            mapChildren(children, function() {
                forEachFunc.apply(this, arguments);
            }, forEachContext);
        },
        count: function(children) {
            var n = 0;
            mapChildren(children, function() {
                n++;
            });
            return n;
        },
        toArray: function(children) {
            return mapChildren(children, function(child) {
                return child;
            }) || [];
        },
        only: function(children) {
            if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
            return children;
        }
    };
    exports.Activity = REACT_ACTIVITY_TYPE;
    exports.Children = fnName;
    exports.Component = Component;
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.Profiler = REACT_PROFILER_TYPE;
    exports.PureComponent = PureComponent;
    exports.StrictMode = REACT_STRICT_MODE_TYPE;
    exports.Suspense = REACT_SUSPENSE_TYPE;
    exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
    exports.__COMPILER_RUNTIME = deprecatedAPIs;
    exports.act = function(callback) {
        var prevActQueue = ReactSharedInternals.actQueue, prevActScopeDepth = actScopeDepth;
        actScopeDepth++;
        var queue = ReactSharedInternals.actQueue = null !== prevActQueue ? prevActQueue : [], didAwaitActCall = !1;
        try {
            var result = callback();
        } catch (error) {
            ReactSharedInternals.thrownErrors.push(error);
        }
        if (0 < ReactSharedInternals.thrownErrors.length) throw popActScope(prevActQueue, prevActScopeDepth), callback = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, callback;
        if (null !== result && "object" === typeof result && "function" === typeof result.then) {
            var thenable = result;
            queueSeveralMicrotasks(function() {
                didAwaitActCall || didWarnNoAwaitAct || (didWarnNoAwaitAct = !0, console.error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
            });
            return {
                then: function(resolve, reject) {
                    didAwaitActCall = !0;
                    thenable.then(function(returnValue) {
                        popActScope(prevActQueue, prevActScopeDepth);
                        if (0 === prevActScopeDepth) {
                            try {
                                flushActQueue(queue), enqueueTask(function() {
                                    return recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                                });
                            } catch (error$0) {
                                ReactSharedInternals.thrownErrors.push(error$0);
                            }
                            if (0 < ReactSharedInternals.thrownErrors.length) {
                                var _thrownError = aggregateErrors(ReactSharedInternals.thrownErrors);
                                ReactSharedInternals.thrownErrors.length = 0;
                                reject(_thrownError);
                            }
                        } else resolve(returnValue);
                    }, function(error) {
                        popActScope(prevActQueue, prevActScopeDepth);
                        0 < ReactSharedInternals.thrownErrors.length ? (error = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, reject(error)) : reject(error);
                    });
                }
            };
        }
        var returnValue$jscomp$0 = result;
        popActScope(prevActQueue, prevActScopeDepth);
        0 === prevActScopeDepth && (flushActQueue(queue), 0 !== queue.length && queueSeveralMicrotasks(function() {
            didAwaitActCall || didWarnNoAwaitAct || (didWarnNoAwaitAct = !0, console.error("A component suspended inside an `act` scope, but the `act` call was not awaited. When testing React components that depend on asynchronous data, you must await the result:\n\nawait act(() => ...)"));
        }), ReactSharedInternals.actQueue = null);
        if (0 < ReactSharedInternals.thrownErrors.length) throw callback = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, callback;
        return {
            then: function(resolve, reject) {
                didAwaitActCall = !0;
                0 === prevActScopeDepth ? (ReactSharedInternals.actQueue = queue, enqueueTask(function() {
                    return recursivelyFlushAsyncActWork(returnValue$jscomp$0, resolve, reject);
                })) : resolve(returnValue$jscomp$0);
            }
        };
    };
    exports.cache = function(fn) {
        return function() {
            return fn.apply(null, arguments);
        };
    };
    exports.cacheSignal = function() {
        return null;
    };
    exports.captureOwnerStack = function() {
        var getCurrentStack = ReactSharedInternals.getCurrentStack;
        return null === getCurrentStack ? null : getCurrentStack();
    };
    exports.cloneElement = function(element, config, children) {
        if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
        var props = assign({}, element.props), key = element.key, owner = element._owner;
        if (null != config) {
            var JSCompiler_inline_result;
            a: {
                if (hasOwnProperty.call(config, "ref") && (JSCompiler_inline_result = Object.getOwnPropertyDescriptor(config, "ref").get) && JSCompiler_inline_result.isReactWarning) {
                    JSCompiler_inline_result = !1;
                    break a;
                }
                JSCompiler_inline_result = void 0 !== config.ref;
            }
            JSCompiler_inline_result && (owner = getOwner());
            hasValidKey(config) && (checkKeyStringCoercion(config.key), key = "" + config.key);
            for(propName in config)!hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
        }
        var propName = arguments.length - 2;
        if (1 === propName) props.children = children;
        else if (1 < propName) {
            JSCompiler_inline_result = Array(propName);
            for(var i = 0; i < propName; i++)JSCompiler_inline_result[i] = arguments[i + 2];
            props.children = JSCompiler_inline_result;
        }
        props = ReactElement(element.type, key, props, owner, element._debugStack, element._debugTask);
        for(key = 2; key < arguments.length; key++)validateChildKeys(arguments[key]);
        return props;
    };
    exports.createContext = function(defaultValue) {
        defaultValue = {
            $$typeof: REACT_CONTEXT_TYPE,
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            _threadCount: 0,
            Provider: null,
            Consumer: null
        };
        defaultValue.Provider = defaultValue;
        defaultValue.Consumer = {
            $$typeof: REACT_CONSUMER_TYPE,
            _context: defaultValue
        };
        defaultValue._currentRenderer = null;
        defaultValue._currentRenderer2 = null;
        return defaultValue;
    };
    exports.createElement = function(type, config, children) {
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i]);
        i = {};
        var key = null;
        if (null != config) for(propName in didWarnAboutOldJSXRuntime || !("__self" in config) || "key" in config || (didWarnAboutOldJSXRuntime = !0, console.warn("Your app (or one of its dependencies) is using an outdated JSX transform. Update to the modern JSX transform for faster performance: https://react.dev/link/new-jsx-transform")), hasValidKey(config) && (checkKeyStringCoercion(config.key), key = "" + config.key), config)hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (i[propName] = config[propName]);
        var childrenLength = arguments.length - 2;
        if (1 === childrenLength) i.children = children;
        else if (1 < childrenLength) {
            for(var childArray = Array(childrenLength), _i = 0; _i < childrenLength; _i++)childArray[_i] = arguments[_i + 2];
            Object.freeze && Object.freeze(childArray);
            i.children = childArray;
        }
        if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === i[propName] && (i[propName] = childrenLength[propName]);
        key && defineKeyPropWarningGetter(i, "function" === typeof type ? type.displayName || type.name || "Unknown" : type);
        var propName = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
        return ReactElement(type, key, i, getOwner(), propName ? Error("react-stack-top-frame") : unknownOwnerDebugStack, propName ? createTask(getTaskName(type)) : unknownOwnerDebugTask);
    };
    exports.createRef = function() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    };
    exports.forwardRef = function(render) {
        null != render && render.$$typeof === REACT_MEMO_TYPE ? console.error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : "function" !== typeof render ? console.error("forwardRef requires a render function but was given %s.", null === render ? "null" : typeof render) : 0 !== render.length && 2 !== render.length && console.error("forwardRef render functions accept exactly two parameters: props and ref. %s", 1 === render.length ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
        null != render && null != render.defaultProps && console.error("forwardRef render functions do not support defaultProps. Did you accidentally pass a React component?");
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        }, ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name;
                render.name || render.displayName || (Object.defineProperty(render, "name", {
                    value: name
                }), render.displayName = name);
            }
        });
        return elementType;
    };
    exports.isValidElement = isValidElement;
    exports.lazy = function(ctor) {
        ctor = {
            _status: -1,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: ctor,
            _init: lazyInitializer
        }, ioInfo = {
            name: "lazy",
            start: -1,
            end: -1,
            value: null,
            owner: null,
            debugStack: Error("react-stack-top-frame"),
            debugTask: console.createTask ? console.createTask("lazy()") : null
        };
        ctor._ioInfo = ioInfo;
        lazyType._debugInfo = [
            {
                awaited: ioInfo
            }
        ];
        return lazyType;
    };
    exports.memo = function(type, compare) {
        null == type && console.error("memo: The first argument must be a component. Instead received: %s", null === type ? "null" : typeof type);
        compare = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: void 0 === compare ? null : compare
        };
        var ownName;
        Object.defineProperty(compare, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name;
                type.name || type.displayName || (Object.defineProperty(type, "name", {
                    value: name
                }), type.displayName = name);
            }
        });
        return compare;
    };
    exports.startTransition = function(scope) {
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        currentTransition._updatedFibers = new Set();
        ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && (ReactSharedInternals.asyncTransitions++, returnValue.then(releaseAsyncTransition, releaseAsyncTransition), returnValue.then(noop, reportGlobalError));
        } catch (error) {
            reportGlobalError(error);
        } finally{
            null === prevTransition && currentTransition._updatedFibers && (scope = currentTransition._updatedFibers.size, currentTransition._updatedFibers.clear(), 10 < scope && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.")), null !== prevTransition && null !== currentTransition.types && (null !== prevTransition.types && prevTransition.types !== currentTransition.types && console.error("We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."), prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
        }
    };
    exports.unstable_useCacheRefresh = function() {
        return resolveDispatcher().useCacheRefresh();
    };
    exports.use = function(usable) {
        return resolveDispatcher().use(usable);
    };
    exports.useActionState = function(action, initialState, permalink) {
        return resolveDispatcher().useActionState(action, initialState, permalink);
    };
    exports.useCallback = function(callback, deps) {
        return resolveDispatcher().useCallback(callback, deps);
    };
    exports.useContext = function(Context) {
        var dispatcher = resolveDispatcher();
        Context.$$typeof === REACT_CONSUMER_TYPE && console.error("Calling useContext(Context.Consumer) is not supported and will cause bugs. Did you mean to call useContext(Context) instead?");
        return dispatcher.useContext(Context);
    };
    exports.useDebugValue = function(value, formatterFn) {
        return resolveDispatcher().useDebugValue(value, formatterFn);
    };
    exports.useDeferredValue = function(value, initialValue) {
        return resolveDispatcher().useDeferredValue(value, initialValue);
    };
    exports.useEffect = function(create, deps) {
        null == create && console.warn("React Hook useEffect requires an effect callback. Did you forget to pass a callback to the hook?");
        return resolveDispatcher().useEffect(create, deps);
    };
    exports.useEffectEvent = function(callback) {
        return resolveDispatcher().useEffectEvent(callback);
    };
    exports.useId = function() {
        return resolveDispatcher().useId();
    };
    exports.useImperativeHandle = function(ref, create, deps) {
        return resolveDispatcher().useImperativeHandle(ref, create, deps);
    };
    exports.useInsertionEffect = function(create, deps) {
        null == create && console.warn("React Hook useInsertionEffect requires an effect callback. Did you forget to pass a callback to the hook?");
        return resolveDispatcher().useInsertionEffect(create, deps);
    };
    exports.useLayoutEffect = function(create, deps) {
        null == create && console.warn("React Hook useLayoutEffect requires an effect callback. Did you forget to pass a callback to the hook?");
        return resolveDispatcher().useLayoutEffect(create, deps);
    };
    exports.useMemo = function(create, deps) {
        return resolveDispatcher().useMemo(create, deps);
    };
    exports.useOptimistic = function(passthrough, reducer) {
        return resolveDispatcher().useOptimistic(passthrough, reducer);
    };
    exports.useReducer = function(reducer, initialArg, init) {
        return resolveDispatcher().useReducer(reducer, initialArg, init);
    };
    exports.useRef = function(initialValue) {
        return resolveDispatcher().useRef(initialValue);
    };
    exports.useState = function(initialState) {
        return resolveDispatcher().useState(initialState);
    };
    exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
        return resolveDispatcher().useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    };
    exports.useTransition = function() {
        return resolveDispatcher().useTransition();
    };
    exports.version = "19.2.8";
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});



parcelRegister("47AzO", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $30043039f0950692$export$882461b6382ed46c; }, function (v) { return $30043039f0950692$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $30043039f0950692$export$757ceba2d55c277e; }, function (v) { return $30043039f0950692$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $30043039f0950692$export$83d89fbfd8236492; }, function (v) { return $30043039f0950692$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $30043039f0950692$export$882461b6382ed46c;
var $30043039f0950692$export$757ceba2d55c277e;
var $30043039f0950692$export$83d89fbfd8236492;
"use strict";



(function() {
    function findHook(fiber, id) {
        for(fiber = fiber.memoizedState; null !== fiber && 0 < id;)fiber = fiber.next, id--;
        return fiber;
    }
    function copyWithSetImpl(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index], updated = isArrayImpl(obj) ? obj.slice() : assign({}, obj);
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    }
    function copyWithRename(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) console.warn("copyWithRename() expects paths of the same length");
        else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                console.warn("copyWithRename() expects paths to be the same except for the deepest key");
                return;
            }
            return copyWithRenameImpl(obj, oldPath, newPath, 0);
        }
    }
    function copyWithRenameImpl(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index], updated = isArrayImpl(obj) ? obj.slice() : assign({}, obj);
        index + 1 === oldPath.length ? (updated[newPath[index]] = updated[oldKey], isArrayImpl(updated) ? updated.splice(oldKey, 1) : delete updated[oldKey]) : updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    }
    function copyWithDeleteImpl(obj, path, index) {
        var key = path[index], updated = isArrayImpl(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === path.length) return isArrayImpl(updated) ? updated.splice(key, 1) : delete updated[key], updated;
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    }
    function shouldSuspendImpl() {
        return !1;
    }
    function shouldErrorImpl() {
        return null;
    }
    function warnInvalidHookAccess() {
        console.error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://react.dev/link/rules-of-hooks");
    }
    function warnInvalidContextAccess() {
        console.error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    }
    function noop() {}
    function warnForMissingKey() {}
    function setToSortedString(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(", ");
    }
    function createFiber(tag, pendingProps, key, mode) {
        return new FiberNode(tag, pendingProps, key, mode);
    }
    function scheduleRoot(root, element) {
        root.context === emptyContextObject && (updateContainerImpl(root.current, 2, element, root, null, null), flushSyncWork$1());
    }
    function scheduleRefresh(root, update) {
        if (null !== resolveFamily) {
            var staleFamilies = update.staleFamilies;
            update = update.updatedFamilies;
            flushPendingEffects();
            scheduleFibersWithFamiliesRecursively(root.current, update, staleFamilies);
            flushSyncWork$1();
        }
    }
    function setRefreshHandler(handler) {
        resolveFamily = handler;
    }
    function isValidContainer(node) {
        return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
    }
    function getNearestMountedFiber(fiber) {
        var node = fiber, nearestMounted = fiber;
        if (fiber.alternate) for(; node.return;)node = node.return;
        else {
            fiber = node;
            do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
            while (fiber);
        }
        return 3 === node.tag ? nearestMounted : null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (13 === fiber.tag) {
            var suspenseState = fiber.memoizedState;
            null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
            if (null !== suspenseState) return suspenseState.dehydrated;
        }
        return null;
    }
    function getActivityInstanceFromFiber(fiber) {
        if (31 === fiber.tag) {
            var activityState = fiber.memoizedState;
            null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
            if (null !== activityState) return activityState.dehydrated;
        }
        return null;
    }
    function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) throw Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            alternate = getNearestMountedFiber(fiber);
            if (null === alternate) throw Error("Unable to find node on an unmounted component.");
            return alternate !== fiber ? null : fiber;
        }
        for(var a = fiber, b = alternate;;){
            var parentA = a.return;
            if (null === parentA) break;
            var parentB = parentA.alternate;
            if (null === parentB) {
                b = parentA.return;
                if (null !== b) {
                    a = b;
                    continue;
                }
                break;
            }
            if (parentA.child === parentB.child) {
                for(parentB = parentA.child; parentB;){
                    if (parentB === a) return assertIsMounted(parentA), fiber;
                    if (parentB === b) return assertIsMounted(parentA), alternate;
                    parentB = parentB.sibling;
                }
                throw Error("Unable to find node on an unmounted component.");
            }
            if (a.return !== b.return) a = parentA, b = parentB;
            else {
                for(var didFindChild = !1, _child = parentA.child; _child;){
                    if (_child === a) {
                        didFindChild = !0;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = !0;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    for(_child = parentB.child; _child;){
                        if (_child === a) {
                            didFindChild = !0;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = !0;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (a.alternate !== b) throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (3 !== a.tag) throw Error("Unable to find node on an unmounted component.");
        return a.stateNode.current === a ? fiber : alternate;
    }
    function findCurrentHostFiberImpl(node) {
        var tag = node.tag;
        if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
        for(node = node.child; null !== node;){
            tag = findCurrentHostFiberImpl(node);
            if (null !== tag) return tag;
            node = node.sibling;
        }
        return null;
    }
    function getIteratorFn(maybeIterable) {
        if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
        maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
        return "function" === typeof maybeIterable ? maybeIterable : null;
    }
    function getComponentNameFromType(type) {
        if (null == type) return null;
        if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
        if ("string" === typeof type) return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
            case REACT_ACTIVITY_TYPE:
                return "Activity";
        }
        if ("object" === typeof type) switch("number" === typeof type.tag && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), type.$$typeof){
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_CONTEXT_TYPE:
                return type.displayName || "Context";
            case REACT_CONSUMER_TYPE:
                return (type._context.displayName || "Context") + ".Consumer";
            case REACT_FORWARD_REF_TYPE:
                var innerType = type.render;
                type = type.displayName;
                type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
                return type;
            case REACT_MEMO_TYPE:
                return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                innerType = type._payload;
                type = type._init;
                try {
                    return getComponentNameFromType(type(innerType));
                } catch (x) {}
        }
        return null;
    }
    function getComponentNameFromOwner(owner) {
        return "number" === typeof owner.tag ? getComponentNameFromFiber(owner) : "string" === typeof owner.name ? owner.name : null;
    }
    function getComponentNameFromFiber(fiber) {
        var type = fiber.type;
        switch(fiber.tag){
            case 31:
                return "Activity";
            case 24:
                return "Cache";
            case 9:
                return (type._context.displayName || "Context") + ".Consumer";
            case 10:
                return type.displayName || "Context";
            case 18:
                return "DehydratedFragment";
            case 11:
                return fiber = type.render, fiber = fiber.displayName || fiber.name || "", type.displayName || ("" !== fiber ? "ForwardRef(" + fiber + ")" : "ForwardRef");
            case 7:
                return "Fragment";
            case 26:
            case 27:
            case 5:
                return type;
            case 4:
                return "Portal";
            case 3:
                return "Root";
            case 6:
                return "Text";
            case 16:
                return getComponentNameFromType(type);
            case 8:
                return type === REACT_STRICT_MODE_TYPE ? "StrictMode" : "Mode";
            case 22:
                return "Offscreen";
            case 12:
                return "Profiler";
            case 21:
                return "Scope";
            case 13:
                return "Suspense";
            case 19:
                return "SuspenseList";
            case 25:
                return "TracingMarker";
            case 1:
            case 0:
            case 14:
            case 15:
                if ("function" === typeof type) return type.displayName || type.name || null;
                if ("string" === typeof type) return type;
                break;
            case 29:
                type = fiber._debugInfo;
                if (null != type) {
                    for(var i = type.length - 1; 0 <= i; i--)if ("string" === typeof type[i].name) return type[i].name;
                }
                if (null !== fiber.return) return getComponentNameFromFiber(fiber.return);
        }
        return null;
    }
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        0 > index$jscomp$0 ? console.error("Unexpected pop.") : (fiber !== fiberStack[index$jscomp$0] && console.error("Unexpected Fiber popped."), cursor.current = valueStack[index$jscomp$0], valueStack[index$jscomp$0] = null, fiberStack[index$jscomp$0] = null, index$jscomp$0--);
    }
    function push(cursor, value, fiber) {
        index$jscomp$0++;
        valueStack[index$jscomp$0] = cursor.current;
        fiberStack[index$jscomp$0] = fiber;
        cursor.current = value;
    }
    function requiredContext(c) {
        null === c && console.error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        push(rootInstanceStackCursor, nextRootInstance, fiber);
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor, null, fiber);
        var nextRootContext = nextRootInstance.nodeType;
        switch(nextRootContext){
            case 9:
            case 11:
                nextRootContext = 9 === nextRootContext ? "#document" : "#fragment";
                nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? getOwnHostContext(nextRootInstance) : HostContextNamespaceNone : HostContextNamespaceNone;
                break;
            default:
                if (nextRootContext = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = getOwnHostContext(nextRootInstance), nextRootInstance = getChildHostContextProd(nextRootInstance, nextRootContext);
                else switch(nextRootContext){
                    case "svg":
                        nextRootInstance = HostContextNamespaceSvg;
                        break;
                    case "math":
                        nextRootInstance = HostContextNamespaceMath;
                        break;
                    default:
                        nextRootInstance = HostContextNamespaceNone;
                }
        }
        nextRootContext = nextRootContext.toLowerCase();
        nextRootContext = updatedAncestorInfoDev(null, nextRootContext);
        nextRootContext = {
            context: nextRootInstance,
            ancestorInfo: nextRootContext
        };
        pop(contextStackCursor, fiber);
        push(contextStackCursor, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        return requiredContext(contextStackCursor.current);
    }
    function pushHostContext(fiber) {
        null !== fiber.memoizedState && push(hostTransitionProviderCursor, fiber, fiber);
        var context = requiredContext(contextStackCursor.current);
        var type = fiber.type;
        var nextContext = getChildHostContextProd(context.context, type);
        type = updatedAncestorInfoDev(context.ancestorInfo, type);
        nextContext = {
            context: nextContext,
            ancestorInfo: type
        };
        context !== nextContext && (push(contextFiberStackCursor, fiber, fiber), push(contextStackCursor, nextContext, fiber));
    }
    function popHostContext(fiber) {
        contextFiberStackCursor.current === fiber && (pop(contextStackCursor, fiber), pop(contextFiberStackCursor, fiber));
        hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor, fiber), HostTransitionContext._currentValue = NotPendingTransition);
    }
    function disabledLog() {}
    function disableLogs() {
        if (0 === disabledDepth) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
                configurable: !0,
                enumerable: !0,
                value: disabledLog,
                writable: !0
            };
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (0 === disabledDepth) {
            var props = {
                configurable: !0,
                enumerable: !0,
                writable: !0
            };
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        }
        0 > disabledDepth && console.error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    function formatOwnerStack(error) {
        var prevPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        error = error.stack;
        Error.prepareStackTrace = prevPrepareStackTrace;
        error.startsWith("Error: react-stack-top-frame\n") && (error = error.slice(29));
        prevPrepareStackTrace = error.indexOf("\n");
        -1 !== prevPrepareStackTrace && (error = error.slice(prevPrepareStackTrace + 1));
        prevPrepareStackTrace = error.indexOf("react_stack_bottom_frame");
        -1 !== prevPrepareStackTrace && (prevPrepareStackTrace = error.lastIndexOf("\n", prevPrepareStackTrace));
        if (-1 !== prevPrepareStackTrace) error = error.slice(0, prevPrepareStackTrace);
        else return "";
        return error;
    }
    function describeBuiltInComponentFrame(name) {
        if (void 0 === prefix) try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
            suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
        return "\n" + prefix + name + suffix;
    }
    function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (void 0 !== frame) return frame;
        reentry = !0;
        frame = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher = null;
        previousDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = null;
        disableLogs();
        try {
            var RunInRootFrame = {
                DetermineComponentFrameRoot: function() {
                    try {
                        if (construct) {
                            var Fake = function() {
                                throw Error();
                            };
                            Object.defineProperty(Fake.prototype, "props", {
                                set: function() {
                                    throw Error();
                                }
                            });
                            if ("object" === typeof Reflect && Reflect.construct) {
                                try {
                                    Reflect.construct(Fake, []);
                                } catch (x) {
                                    var control = x;
                                }
                                Reflect.construct(fn, [], Fake);
                            } else {
                                try {
                                    Fake.call();
                                } catch (x$0) {
                                    control = x$0;
                                }
                                fn.call(Fake.prototype);
                            }
                        } else {
                            try {
                                throw Error();
                            } catch (x$1) {
                                control = x$1;
                            }
                            (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                        }
                    } catch (sample) {
                        if (sample && control && "string" === typeof sample.stack) return [
                            sample.stack,
                            control.stack
                        ];
                    }
                    return [
                        null,
                        null
                    ];
                }
            };
            RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
            var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
            namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
                value: "DetermineComponentFrameRoot"
            });
            var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
            if (sampleStack && controlStack) {
                var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
                for(_RunInRootFrame$Deter = namePropDescriptor = 0; namePropDescriptor < sampleLines.length && !sampleLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
                for(; _RunInRootFrame$Deter < controlLines.length && !controlLines[_RunInRootFrame$Deter].includes("DetermineComponentFrameRoot");)_RunInRootFrame$Deter++;
                if (namePropDescriptor === sampleLines.length || _RunInRootFrame$Deter === controlLines.length) for(namePropDescriptor = sampleLines.length - 1, _RunInRootFrame$Deter = controlLines.length - 1; 1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter && sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter];)_RunInRootFrame$Deter--;
                for(; 1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter; namePropDescriptor--, _RunInRootFrame$Deter--)if (sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]) {
                    if (1 !== namePropDescriptor || 1 !== _RunInRootFrame$Deter) {
                        do if (namePropDescriptor--, _RunInRootFrame$Deter--, 0 > _RunInRootFrame$Deter || sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]) {
                            var _frame = "\n" + sampleLines[namePropDescriptor].replace(" at new ", " at ");
                            fn.displayName && _frame.includes("<anonymous>") && (_frame = _frame.replace("<anonymous>", fn.displayName));
                            "function" === typeof fn && componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                        while (1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter);
                    }
                    break;
                }
            }
        } finally{
            reentry = !1, ReactSharedInternals.H = previousDispatcher, reenableLogs(), Error.prepareStackTrace = frame;
        }
        sampleLines = (sampleLines = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(sampleLines) : "";
        "function" === typeof fn && componentFrameCache.set(fn, sampleLines);
        return sampleLines;
    }
    function describeFiber(fiber, childFiber) {
        switch(fiber.tag){
            case 26:
            case 27:
            case 5:
                return describeBuiltInComponentFrame(fiber.type);
            case 16:
                return describeBuiltInComponentFrame("Lazy");
            case 13:
                return fiber.child !== childFiber && null !== childFiber ? describeBuiltInComponentFrame("Suspense Fallback") : describeBuiltInComponentFrame("Suspense");
            case 19:
                return describeBuiltInComponentFrame("SuspenseList");
            case 0:
            case 15:
                return describeNativeComponentFrame(fiber.type, !1);
            case 11:
                return describeNativeComponentFrame(fiber.type.render, !1);
            case 1:
                return describeNativeComponentFrame(fiber.type, !0);
            case 31:
                return describeBuiltInComponentFrame("Activity");
            default:
                return "";
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = "", previous = null;
            do {
                info += describeFiber(workInProgress, previous);
                var debugInfo = workInProgress._debugInfo;
                if (debugInfo) for(var i = debugInfo.length - 1; 0 <= i; i--){
                    var entry = debugInfo[i];
                    if ("string" === typeof entry.name) {
                        var JSCompiler_temp_const = info;
                        a: {
                            var name = entry.name, env = entry.env, location = entry.debugLocation;
                            if (null != location) {
                                var childStack = formatOwnerStack(location), idx = childStack.lastIndexOf("\n"), lastLine = -1 === idx ? childStack : childStack.slice(idx + 1);
                                if (-1 !== lastLine.indexOf(name)) {
                                    var JSCompiler_inline_result = "\n" + lastLine;
                                    break a;
                                }
                            }
                            JSCompiler_inline_result = describeBuiltInComponentFrame(name + (env ? " [" + env + "]" : ""));
                        }
                        info = JSCompiler_temp_const + JSCompiler_inline_result;
                    }
                }
                previous = workInProgress;
                workInProgress = workInProgress.return;
            }while (workInProgress);
            return info;
        } catch (x) {
            return "\nError generating stack: " + x.message + "\n" + x.stack;
        }
    }
    function describeFunctionComponentFrameWithoutLineNumber(fn) {
        return (fn = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(fn) : "";
    }
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (null === current) return null;
        var owner = current._debugOwner;
        return null != owner ? getComponentNameFromOwner(owner) : null;
    }
    function getCurrentFiberStackInDev() {
        if (null === current) return "";
        var workInProgress = current;
        try {
            var info = "";
            6 === workInProgress.tag && (workInProgress = workInProgress.return);
            switch(workInProgress.tag){
                case 26:
                case 27:
                case 5:
                    info += describeBuiltInComponentFrame(workInProgress.type);
                    break;
                case 13:
                    info += describeBuiltInComponentFrame("Suspense");
                    break;
                case 19:
                    info += describeBuiltInComponentFrame("SuspenseList");
                    break;
                case 31:
                    info += describeBuiltInComponentFrame("Activity");
                    break;
                case 30:
                case 0:
                case 15:
                case 1:
                    workInProgress._debugOwner || "" !== info || (info += describeFunctionComponentFrameWithoutLineNumber(workInProgress.type));
                    break;
                case 11:
                    workInProgress._debugOwner || "" !== info || (info += describeFunctionComponentFrameWithoutLineNumber(workInProgress.type.render));
            }
            for(; workInProgress;)if ("number" === typeof workInProgress.tag) {
                var fiber = workInProgress;
                workInProgress = fiber._debugOwner;
                var debugStack = fiber._debugStack;
                if (workInProgress && debugStack) {
                    var formattedStack = formatOwnerStack(debugStack);
                    "" !== formattedStack && (info += "\n" + formattedStack);
                }
            } else if (null != workInProgress.debugStack) {
                var ownerStack = workInProgress.debugStack;
                (workInProgress = workInProgress.owner) && ownerStack && (info += "\n" + formatOwnerStack(ownerStack));
            } else break;
            var JSCompiler_inline_result = info;
        } catch (x) {
            JSCompiler_inline_result = "\nError generating stack: " + x.message + "\n" + x.stack;
        }
        return JSCompiler_inline_result;
    }
    function runWithFiberInDEV(fiber, callback, arg0, arg1, arg2, arg3, arg4) {
        var previousFiber = current;
        setCurrentFiber(fiber);
        try {
            return null !== fiber && fiber._debugTask ? fiber._debugTask.run(callback.bind(null, arg0, arg1, arg2, arg3, arg4)) : callback(arg0, arg1, arg2, arg3, arg4);
        } finally{
            setCurrentFiber(previousFiber);
        }
        throw Error("runWithFiberInDEV should never be called in production. This is a bug in React.");
    }
    function setCurrentFiber(fiber) {
        ReactSharedInternals.getCurrentStack = null === fiber ? null : getCurrentFiberStackInDev;
        isRendering = !1;
        current = fiber;
    }
    function typeName(value) {
        return "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
    }
    function willCoercionThrow(value) {
        try {
            return testStringCoercion(value), !1;
        } catch (e) {
            return !0;
        }
    }
    function testStringCoercion(value) {
        return "" + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
        if (willCoercionThrow(value)) return console.error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before using it here.", attributeName, typeName(value)), testStringCoercion(value);
    }
    function checkCSSPropertyStringCoercion(value, propName) {
        if (willCoercionThrow(value)) return console.error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before using it here.", propName, typeName(value)), testStringCoercion(value);
    }
    function checkFormFieldValueStringCoercion(value) {
        if (willCoercionThrow(value)) return console.error("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before using it here.", typeName(value)), testStringCoercion(value);
    }
    function injectInternals(internals) {
        if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) return !0;
        if (!hook.supportsFiber) return console.error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://react.dev/link/react-devtools"), !0;
        try {
            rendererID = hook.inject(internals), injectedHook = hook;
        } catch (err) {
            console.error("React instrumentation encountered an error: %o.", err);
        }
        return hook.checkDCE ? !0 : !1;
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
        "function" === typeof log$1 && unstable_setDisableYieldValue(newIsStrictMode);
        if (injectedHook && "function" === typeof injectedHook.setStrictMode) try {
            injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {
            hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
        }
    }
    function clz32Fallback(x) {
        x >>>= 0;
        return 0 === x ? 32 : 31 - (log(x) / LN2 | 0) | 0;
    }
    function getHighestPriorityLanes(lanes) {
        var pendingSyncLanes = lanes & 42;
        if (0 !== pendingSyncLanes) return pendingSyncLanes;
        switch(lanes & -lanes){
            case 1:
                return 1;
            case 2:
                return 2;
            case 4:
                return 4;
            case 8:
                return 8;
            case 16:
                return 16;
            case 32:
                return 32;
            case 64:
                return 64;
            case 128:
                return 128;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
                return lanes & 261888;
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return lanes & 3932160;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                return lanes & 62914560;
            case 67108864:
                return 67108864;
            case 134217728:
                return 134217728;
            case 268435456:
                return 268435456;
            case 536870912:
                return 536870912;
            case 1073741824:
                return 0;
            default:
                return console.error("Should have found matching lanes. This is a bug in React."), lanes;
        }
    }
    function getNextLanes(root, wipLanes, rootHasPendingCommit) {
        var pendingLanes = root.pendingLanes;
        if (0 === pendingLanes) return 0;
        var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
        root = root.warmLanes;
        var nonIdlePendingLanes = pendingLanes & 134217727;
        0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
        return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
    }
    function checkIfRootIsPrerendering(root, renderLanes) {
        return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
    }
    function computeExpirationTime(lane, currentTime) {
        switch(lane){
            case 1:
            case 2:
            case 4:
            case 8:
            case 64:
                return currentTime + 250;
            case 16:
            case 32:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return currentTime + 5e3;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                return -1;
            case 67108864:
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
                return -1;
            default:
                return console.error("Should have found matching lanes. This is a bug in React."), -1;
        }
    }
    function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;
        0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
        return lane;
    }
    function createLaneMap(initial) {
        for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated$1(root, updateLane) {
        root.pendingLanes |= updateLane;
        268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
    }
    function markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
        var previouslyPendingLanes = root.pendingLanes;
        root.pendingLanes = remainingLanes;
        root.suspendedLanes = 0;
        root.pingedLanes = 0;
        root.warmLanes = 0;
        root.expiredLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        root.errorRecoveryDisabledLanes &= remainingLanes;
        root.shellSuspendCounter = 0;
        var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
        for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
            var index = 31 - clz32(remainingLanes), lane = 1 << index;
            entanglements[index] = 0;
            expirationTimes[index] = -1;
            var hiddenUpdatesForLane = hiddenUpdates[index];
            if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index] = null, index = 0; index < hiddenUpdatesForLane.length; index++){
                var update = hiddenUpdatesForLane[index];
                null !== update && (update.lane &= -536870913);
            }
            remainingLanes &= ~lane;
        }
        0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, 0);
        0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
    }
    function markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
        root.pendingLanes |= spawnedLane;
        root.suspendedLanes &= ~spawnedLane;
        var spawnedLaneIndex = 31 - clz32(spawnedLane);
        root.entangledLanes |= spawnedLane;
        root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
    }
    function markRootEntangled(root, entangledLanes) {
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        for(root = root.entanglements; rootEntangledLanes;){
            var index = 31 - clz32(rootEntangledLanes), lane = 1 << index;
            lane & entangledLanes | root[index] & entangledLanes && (root[index] |= entangledLanes);
            rootEntangledLanes &= ~lane;
        }
    }
    function getBumpedLaneForHydration(root, renderLanes) {
        var renderLane = renderLanes & -renderLanes;
        renderLane = 0 !== (renderLane & 42) ? 1 : getBumpedLaneForHydrationByLane(renderLane);
        return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
    }
    function getBumpedLaneForHydrationByLane(lane) {
        switch(lane){
            case 2:
                lane = 1;
                break;
            case 8:
                lane = 4;
                break;
            case 32:
                lane = 16;
                break;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                lane = 128;
                break;
            case 268435456:
                lane = 134217728;
                break;
            default:
                lane = 0;
        }
        return lane;
    }
    function addFiberToLanesMap(root, fiber, lanes) {
        if (isDevToolsPresent) for(root = root.pendingUpdatersLaneMap; 0 < lanes;){
            var index = 31 - clz32(lanes), lane = 1 << index;
            root[index].add(fiber);
            lanes &= ~lane;
        }
    }
    function movePendingFibersToMemoized(root, lanes) {
        if (isDevToolsPresent) for(var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap, memoizedUpdaters = root.memoizedUpdaters; 0 < lanes;){
            var index = 31 - clz32(lanes);
            root = 1 << index;
            index = pendingUpdatersLaneMap[index];
            0 < index.size && (index.forEach(function(fiber) {
                var alternate = fiber.alternate;
                null !== alternate && memoizedUpdaters.has(alternate) || memoizedUpdaters.add(fiber);
            }), index.clear());
            lanes &= ~root;
        }
    }
    function lanesToEventPriority(lanes) {
        lanes &= -lanes;
        return 0 !== DiscreteEventPriority && DiscreteEventPriority < lanes ? 0 !== ContinuousEventPriority && ContinuousEventPriority < lanes ? 0 !== (lanes & 134217727) ? DefaultEventPriority : IdleEventPriority : ContinuousEventPriority : DiscreteEventPriority;
    }
    function resolveUpdatePriority() {
        var updatePriority = ReactDOMSharedInternals.p;
        if (0 !== updatePriority) return updatePriority;
        updatePriority = window.event;
        return void 0 === updatePriority ? DefaultEventPriority : getEventPriority(updatePriority.type);
    }
    function runWithPriority(priority, fn) {
        var previousPriority = ReactDOMSharedInternals.p;
        try {
            return ReactDOMSharedInternals.p = priority, fn();
        } finally{
            ReactDOMSharedInternals.p = previousPriority;
        }
    }
    function detachDeletedInstance(node) {
        delete node[internalInstanceKey];
        delete node[internalPropsKey];
        delete node[internalEventHandlersKey];
        delete node[internalEventHandlerListenersKey];
        delete node[internalEventHandlesSetKey];
    }
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) return targetInst;
        for(var parentNode = targetNode.parentNode; parentNode;){
            if (targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey]) {
                parentNode = targetInst.alternate;
                if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = getParentHydrationBoundary(targetNode); null !== targetNode;){
                    if (parentNode = targetNode[internalInstanceKey]) return parentNode;
                    targetNode = getParentHydrationBoundary(targetNode);
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    function getInstanceFromNode(node) {
        if (node = node[internalInstanceKey] || node[internalContainerInstanceKey]) {
            var tag = node.tag;
            if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
        }
        return null;
    }
    function getNodeFromInstance(inst) {
        var tag = inst.tag;
        if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
        throw Error("getNodeFromInstance: Invalid argument.");
    }
    function getResourcesFromRoot(root) {
        var resources = root[internalRootNodeResourcesKey];
        resources || (resources = root[internalRootNodeResourcesKey] = {
            hoistableStyles: new Map(),
            hoistableScripts: new Map()
        });
        return resources;
    }
    function markNodeAsHoistable(node) {
        node[internalHoistableMarker] = !0;
    }
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + "Capture", dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        registrationNameDependencies[registrationName] && console.error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        "onDoubleClick" === registrationName && (possibleRegistrationNames.ondblclick = registrationName);
        for(registrationName = 0; registrationName < dependencies.length; registrationName++)allNativeEvents.add(dependencies[registrationName]);
    }
    function checkControlledValueProps(tagName, props) {
        hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || null == props.value || ("select" === tagName ? console.error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set `onChange`.") : console.error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."));
        props.onChange || props.readOnly || props.disabled || null == props.checked || console.error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return !0;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return !1;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return validatedAttributeNameCache[attributeName] = !0;
        illegalAttributeNameCache[attributeName] = !0;
        console.error("Invalid attribute name: `%s`", attributeName);
        return !1;
    }
    function getValueForAttributeOnCustomComponent(node, name, expected) {
        if (isAttributeNameSafe(name)) {
            if (!node.hasAttribute(name)) {
                switch(typeof expected){
                    case "symbol":
                    case "object":
                        return expected;
                    case "function":
                        return expected;
                    case "boolean":
                        if (!1 === expected) return expected;
                }
                return void 0 === expected ? void 0 : null;
            }
            node = node.getAttribute(name);
            if ("" === node && !0 === expected) return !0;
            checkAttributeStringCoercion(expected, name);
            return node === "" + expected ? expected : node;
        }
    }
    function setValueForAttribute(node, name, value) {
        if (isAttributeNameSafe(name)) {
            if (null === value) node.removeAttribute(name);
            else {
                switch(typeof value){
                    case "undefined":
                    case "function":
                    case "symbol":
                        node.removeAttribute(name);
                        return;
                    case "boolean":
                        var prefix = name.toLowerCase().slice(0, 5);
                        if ("data-" !== prefix && "aria-" !== prefix) {
                            node.removeAttribute(name);
                            return;
                        }
                }
                checkAttributeStringCoercion(value, name);
                node.setAttribute(name, "" + value);
            }
        }
    }
    function setValueForKnownAttribute(node, name, value) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                case "boolean":
                    node.removeAttribute(name);
                    return;
            }
            checkAttributeStringCoercion(value, name);
            node.setAttribute(name, "" + value);
        }
    }
    function setValueForNamespacedAttribute(node, namespace, name, value) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                case "boolean":
                    node.removeAttribute(name);
                    return;
            }
            checkAttributeStringCoercion(value, name);
            node.setAttributeNS(namespace, name, "" + value);
        }
    }
    function getToStringValue(value) {
        switch(typeof value){
            case "bigint":
            case "boolean":
            case "number":
            case "string":
            case "undefined":
                return value;
            case "object":
                return checkFormFieldValueStringCoercion(value), value;
            default:
                return "";
        }
    }
    function isCheckable(elem) {
        var type = elem.type;
        return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
    }
    function trackValueOnNode(node, valueField, currentValue) {
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
            var get = descriptor.get, set = descriptor.set;
            Object.defineProperty(node, valueField, {
                configurable: !0,
                get: function() {
                    return get.call(this);
                },
                set: function(value) {
                    checkFormFieldValueStringCoercion(value);
                    currentValue = "" + value;
                    set.call(this, value);
                }
            });
            Object.defineProperty(node, valueField, {
                enumerable: descriptor.enumerable
            });
            return {
                getValue: function() {
                    return currentValue;
                },
                setValue: function(value) {
                    checkFormFieldValueStringCoercion(value);
                    currentValue = "" + value;
                },
                stopTracking: function() {
                    node._valueTracker = null;
                    delete node[valueField];
                }
            };
        }
    }
    function track(node) {
        if (!node._valueTracker) {
            var valueField = isCheckable(node) ? "checked" : "value";
            node._valueTracker = trackValueOnNode(node, valueField, "" + node[valueField]);
        }
    }
    function updateValueIfChanged(node) {
        if (!node) return !1;
        var tracker = node._valueTracker;
        if (!tracker) return !0;
        var lastValue = tracker.getValue();
        var value = "";
        node && (value = isCheckable(node) ? node.checked ? "true" : "false" : node.value);
        node = value;
        return node !== lastValue ? (tracker.setValue(node), !0) : !1;
    }
    function getActiveElement(doc) {
        doc = doc || ("undefined" !== typeof document ? document : void 0);
        if ("undefined" === typeof doc) return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    function escapeSelectorAttributeValueInsideDoubleQuotes(value) {
        return value.replace(escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
            return "\\" + ch.charCodeAt(0).toString(16) + " ";
        });
    }
    function validateInputProps(element, props) {
        void 0 === props.checked || void 0 === props.defaultChecked || didWarnCheckedDefaultChecked || (console.error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type), didWarnCheckedDefaultChecked = !0);
        void 0 === props.value || void 0 === props.defaultValue || didWarnValueDefaultValue$1 || (console.error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type), didWarnValueDefaultValue$1 = !0);
    }
    function updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
        element.name = "";
        null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? (checkAttributeStringCoercion(type, "type"), element.type = type) : element.removeAttribute("type");
        if (null != value) {
            if ("number" === type) {
                if (0 === value && "" === element.value || element.value != value) element.value = "" + getToStringValue(value);
            } else element.value !== "" + getToStringValue(value) && (element.value = "" + getToStringValue(value));
        } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
        null != value ? setDefaultValue(element, type, getToStringValue(value)) : null != defaultValue ? setDefaultValue(element, type, getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
        null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
        null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
        null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? (checkAttributeStringCoercion(name, "name"), element.name = "" + getToStringValue(name)) : element.removeAttribute("name");
    }
    function initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
        null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (checkAttributeStringCoercion(type, "type"), element.type = type);
        if (null != value || null != defaultValue) {
            if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
                track(element);
                return;
            }
            defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
            value = null != value ? "" + getToStringValue(value) : defaultValue;
            isHydrating || value === element.value || (element.value = value);
            element.defaultValue = value;
        }
        checked = null != checked ? checked : defaultChecked;
        checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
        element.checked = isHydrating ? element.checked : !!checked;
        element.defaultChecked = !!checked;
        null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (checkAttributeStringCoercion(name, "name"), element.name = name);
        track(element);
    }
    function setDefaultValue(node, type, value) {
        "number" === type && getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
    }
    function validateOptionProps(element, props) {
        null == props.value && ("object" === typeof props.children && null !== props.children ? React.Children.forEach(props.children, function(child) {
            null == child || "string" === typeof child || "number" === typeof child || "bigint" === typeof child || didWarnInvalidChild || (didWarnInvalidChild = !0, console.error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>."));
        }) : null == props.dangerouslySetInnerHTML || didWarnInvalidInnerHTML || (didWarnInvalidInnerHTML = !0, console.error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")));
        null == props.selected || didWarnSelectedSetOnOption || (console.error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), didWarnSelectedSetOnOption = !0);
    }
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        return ownerName ? "\n\nCheck the render method of `" + ownerName + "`." : "";
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        node = node.options;
        if (multiple) {
            multiple = {};
            for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
            for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
        } else {
            propValue = "" + getToStringValue(propValue);
            multiple = null;
            for(i = 0; i < node.length; i++){
                if (node[i].value === propValue) {
                    node[i].selected = !0;
                    setDefaultSelected && (node[i].defaultSelected = !0);
                    return;
                }
                null !== multiple || node[i].disabled || (multiple = node[i]);
            }
            null !== multiple && (multiple.selected = !0);
        }
    }
    function validateSelectProps(element, props) {
        for(element = 0; element < valuePropNames.length; element++){
            var propName = valuePropNames[element];
            if (null != props[propName]) {
                var propNameIsArray = isArrayImpl(props[propName]);
                props.multiple && !propNameIsArray ? console.error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum()) : !props.multiple && propNameIsArray && console.error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
            }
        }
        void 0 === props.value || void 0 === props.defaultValue || didWarnValueDefaultValue || (console.error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://react.dev/link/controlled-components"), didWarnValueDefaultValue = !0);
    }
    function validateTextareaProps(element, props) {
        void 0 === props.value || void 0 === props.defaultValue || didWarnValDefaultVal || (console.error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://react.dev/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component"), didWarnValDefaultVal = !0);
        null != props.children && null == props.value && console.error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
    }
    function updateTextarea(element, value, defaultValue) {
        if (null != value && (value = "" + getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
            element.defaultValue !== value && (element.defaultValue = value);
            return;
        }
        element.defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
    }
    function initTextarea(element, value, defaultValue, children) {
        if (null == value) {
            if (null != children) {
                if (null != defaultValue) throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                if (isArrayImpl(children)) {
                    if (1 < children.length) throw Error("<textarea> can only have at most one child.");
                    children = children[0];
                }
                defaultValue = children;
            }
            null == defaultValue && (defaultValue = "");
            value = defaultValue;
        }
        defaultValue = getToStringValue(value);
        element.defaultValue = defaultValue;
        children = element.textContent;
        children === defaultValue && "" !== children && null !== children && (element.value = children);
        track(element);
    }
    function findNotableNode(node, indent) {
        return void 0 === node.serverProps && 0 === node.serverTail.length && 1 === node.children.length && 3 < node.distanceFromLeaf && node.distanceFromLeaf > 15 - indent ? findNotableNode(node.children[0], indent) : node;
    }
    function indentation(indent) {
        return "  " + "  ".repeat(indent);
    }
    function added(indent) {
        return "+ " + "  ".repeat(indent);
    }
    function removed(indent) {
        return "- " + "  ".repeat(indent);
    }
    function describeFiberType(fiber) {
        switch(fiber.tag){
            case 26:
            case 27:
            case 5:
                return fiber.type;
            case 16:
                return "Lazy";
            case 31:
                return "Activity";
            case 13:
                return "Suspense";
            case 19:
                return "SuspenseList";
            case 0:
            case 15:
                return fiber = fiber.type, fiber.displayName || fiber.name || null;
            case 11:
                return fiber = fiber.type.render, fiber.displayName || fiber.name || null;
            case 1:
                return fiber = fiber.type, fiber.displayName || fiber.name || null;
            default:
                return null;
        }
    }
    function describeTextNode(content, maxLength) {
        return needsEscaping.test(content) ? (content = JSON.stringify(content), content.length > maxLength - 2 ? 8 > maxLength ? '{"..."}' : "{" + content.slice(0, maxLength - 7) + '..."}' : "{" + content + "}") : content.length > maxLength ? 5 > maxLength ? '{"..."}' : content.slice(0, maxLength - 3) + "..." : content;
    }
    function describeTextDiff(clientText, serverProps, indent) {
        var maxLength = 120 - 2 * indent;
        if (null === serverProps) return added(indent) + describeTextNode(clientText, maxLength) + "\n";
        if ("string" === typeof serverProps) {
            for(var firstDiff = 0; firstDiff < serverProps.length && firstDiff < clientText.length && serverProps.charCodeAt(firstDiff) === clientText.charCodeAt(firstDiff); firstDiff++);
            firstDiff > maxLength - 8 && 10 < firstDiff && (clientText = "..." + clientText.slice(firstDiff - 8), serverProps = "..." + serverProps.slice(firstDiff - 8));
            return added(indent) + describeTextNode(clientText, maxLength) + "\n" + removed(indent) + describeTextNode(serverProps, maxLength) + "\n";
        }
        return indentation(indent) + describeTextNode(clientText, maxLength) + "\n";
    }
    function objectName(object) {
        return Object.prototype.toString.call(object).replace(/^\[object (.*)\]$/, function(m, p0) {
            return p0;
        });
    }
    function describeValue(value, maxLength) {
        switch(typeof value){
            case "string":
                return value = JSON.stringify(value), value.length > maxLength ? 5 > maxLength ? '"..."' : value.slice(0, maxLength - 4) + '..."' : value;
            case "object":
                if (null === value) return "null";
                if (isArrayImpl(value)) return "[...]";
                if (value.$$typeof === REACT_ELEMENT_TYPE) return (maxLength = getComponentNameFromType(value.type)) ? "<" + maxLength + ">" : "<...>";
                var name = objectName(value);
                if ("Object" === name) {
                    name = "";
                    maxLength -= 2;
                    for(var propName in value)if (value.hasOwnProperty(propName)) {
                        var jsonPropName = JSON.stringify(propName);
                        jsonPropName !== '"' + propName + '"' && (propName = jsonPropName);
                        maxLength -= propName.length - 2;
                        jsonPropName = describeValue(value[propName], 15 > maxLength ? maxLength : 15);
                        maxLength -= jsonPropName.length;
                        if (0 > maxLength) {
                            name += "" === name ? "..." : ", ...";
                            break;
                        }
                        name += ("" === name ? "" : ",") + propName + ":" + jsonPropName;
                    }
                    return "{" + name + "}";
                }
                return name;
            case "function":
                return (maxLength = value.displayName || value.name) ? "function " + maxLength : "function";
            default:
                return String(value);
        }
    }
    function describePropValue(value, maxLength) {
        return "string" !== typeof value || needsEscaping.test(value) ? "{" + describeValue(value, maxLength - 2) + "}" : value.length > maxLength - 2 ? 5 > maxLength ? '"..."' : '"' + value.slice(0, maxLength - 5) + '..."' : '"' + value + '"';
    }
    function describeExpandedElement(type, props, rowPrefix) {
        var remainingRowLength = 120 - rowPrefix.length - type.length, properties = [], propName;
        for(propName in props)if (props.hasOwnProperty(propName) && "children" !== propName) {
            var propValue = describePropValue(props[propName], 120 - rowPrefix.length - propName.length - 1);
            remainingRowLength -= propName.length + propValue.length + 2;
            properties.push(propName + "=" + propValue);
        }
        return 0 === properties.length ? rowPrefix + "<" + type + ">\n" : 0 < remainingRowLength ? rowPrefix + "<" + type + " " + properties.join(" ") + ">\n" : rowPrefix + "<" + type + "\n" + rowPrefix + "  " + properties.join("\n" + rowPrefix + "  ") + "\n" + rowPrefix + ">\n";
    }
    function describePropertiesDiff(clientObject, serverObject, indent) {
        var properties = "", remainingServerProperties = assign({}, serverObject), propName;
        for(propName in clientObject)if (clientObject.hasOwnProperty(propName)) {
            delete remainingServerProperties[propName];
            var maxLength = 120 - 2 * indent - propName.length - 2, clientPropValue = describeValue(clientObject[propName], maxLength);
            serverObject.hasOwnProperty(propName) ? (maxLength = describeValue(serverObject[propName], maxLength), properties += added(indent) + propName + ": " + clientPropValue + "\n", properties += removed(indent) + propName + ": " + maxLength + "\n") : properties += added(indent) + propName + ": " + clientPropValue + "\n";
        }
        for(var _propName in remainingServerProperties)remainingServerProperties.hasOwnProperty(_propName) && (clientObject = describeValue(remainingServerProperties[_propName], 120 - 2 * indent - _propName.length - 2), properties += removed(indent) + _propName + ": " + clientObject + "\n");
        return properties;
    }
    function describeElementDiff(type, clientProps, serverProps, indent) {
        var content = "", serverPropNames = new Map();
        for(propName$jscomp$0 in serverProps)serverProps.hasOwnProperty(propName$jscomp$0) && serverPropNames.set(propName$jscomp$0.toLowerCase(), propName$jscomp$0);
        if (1 === serverPropNames.size && serverPropNames.has("children")) content += describeExpandedElement(type, clientProps, indentation(indent));
        else {
            for(var _propName2 in clientProps)if (clientProps.hasOwnProperty(_propName2) && "children" !== _propName2) {
                var maxLength$jscomp$0 = 120 - 2 * (indent + 1) - _propName2.length - 1, serverPropName = serverPropNames.get(_propName2.toLowerCase());
                if (void 0 !== serverPropName) {
                    serverPropNames.delete(_propName2.toLowerCase());
                    var propName$jscomp$0 = clientProps[_propName2];
                    serverPropName = serverProps[serverPropName];
                    var clientPropValue = describePropValue(propName$jscomp$0, maxLength$jscomp$0);
                    maxLength$jscomp$0 = describePropValue(serverPropName, maxLength$jscomp$0);
                    "object" === typeof propName$jscomp$0 && null !== propName$jscomp$0 && "object" === typeof serverPropName && null !== serverPropName && "Object" === objectName(propName$jscomp$0) && "Object" === objectName(serverPropName) && (2 < Object.keys(propName$jscomp$0).length || 2 < Object.keys(serverPropName).length || -1 < clientPropValue.indexOf("...") || -1 < maxLength$jscomp$0.indexOf("...")) ? content += indentation(indent + 1) + _propName2 + "={{\n" + describePropertiesDiff(propName$jscomp$0, serverPropName, indent + 2) + indentation(indent + 1) + "}}\n" : (content += added(indent + 1) + _propName2 + "=" + clientPropValue + "\n", content += removed(indent + 1) + _propName2 + "=" + maxLength$jscomp$0 + "\n");
                } else content += indentation(indent + 1) + _propName2 + "=" + describePropValue(clientProps[_propName2], maxLength$jscomp$0) + "\n";
            }
            serverPropNames.forEach(function(propName) {
                if ("children" !== propName) {
                    var maxLength = 120 - 2 * (indent + 1) - propName.length - 1;
                    content += removed(indent + 1) + propName + "=" + describePropValue(serverProps[propName], maxLength) + "\n";
                }
            });
            content = "" === content ? indentation(indent) + "<" + type + ">\n" : indentation(indent) + "<" + type + "\n" + content + indentation(indent) + ">\n";
        }
        type = serverProps.children;
        clientProps = clientProps.children;
        if ("string" === typeof type || "number" === typeof type || "bigint" === typeof type) {
            serverPropNames = "";
            if ("string" === typeof clientProps || "number" === typeof clientProps || "bigint" === typeof clientProps) serverPropNames = "" + clientProps;
            content += describeTextDiff(serverPropNames, "" + type, indent + 1);
        } else if ("string" === typeof clientProps || "number" === typeof clientProps || "bigint" === typeof clientProps) content = null == type ? content + describeTextDiff("" + clientProps, null, indent + 1) : content + describeTextDiff("" + clientProps, void 0, indent + 1);
        return content;
    }
    function describeSiblingFiber(fiber, indent) {
        var type = describeFiberType(fiber);
        if (null === type) {
            type = "";
            for(fiber = fiber.child; fiber;)type += describeSiblingFiber(fiber, indent), fiber = fiber.sibling;
            return type;
        }
        return indentation(indent) + "<" + type + ">\n";
    }
    function describeNode(node, indent) {
        var skipToNode = findNotableNode(node, indent);
        if (skipToNode !== node && (1 !== node.children.length || node.children[0] !== skipToNode)) return indentation(indent) + "...\n" + describeNode(skipToNode, indent + 1);
        skipToNode = "";
        var debugInfo = node.fiber._debugInfo;
        if (debugInfo) for(var i = 0; i < debugInfo.length; i++){
            var serverComponentName = debugInfo[i].name;
            "string" === typeof serverComponentName && (skipToNode += indentation(indent) + "<" + serverComponentName + ">\n", indent++);
        }
        debugInfo = "";
        i = node.fiber.pendingProps;
        if (6 === node.fiber.tag) debugInfo = describeTextDiff(i, node.serverProps, indent), indent++;
        else if (serverComponentName = describeFiberType(node.fiber), null !== serverComponentName) {
            if (void 0 === node.serverProps) {
                debugInfo = indent;
                var maxLength = 120 - 2 * debugInfo - serverComponentName.length - 2, content = "";
                for(propName in i)if (i.hasOwnProperty(propName) && "children" !== propName) {
                    var propValue = describePropValue(i[propName], 15);
                    maxLength -= propName.length + propValue.length + 2;
                    if (0 > maxLength) {
                        content += " ...";
                        break;
                    }
                    content += " " + propName + "=" + propValue;
                }
                debugInfo = indentation(debugInfo) + "<" + serverComponentName + content + ">\n";
                indent++;
            } else null === node.serverProps ? (debugInfo = describeExpandedElement(serverComponentName, i, added(indent)), indent++) : "string" === typeof node.serverProps ? console.error("Should not have matched a non HostText fiber to a Text node. This is a bug in React.") : (debugInfo = describeElementDiff(serverComponentName, i, node.serverProps, indent), indent++);
        }
        var propName = "";
        i = node.fiber.child;
        for(serverComponentName = 0; i && serverComponentName < node.children.length;)maxLength = node.children[serverComponentName], maxLength.fiber === i ? (propName += describeNode(maxLength, indent), serverComponentName++) : propName += describeSiblingFiber(i, indent), i = i.sibling;
        i && 0 < node.children.length && (propName += indentation(indent) + "...\n");
        i = node.serverTail;
        null === node.serverProps && indent--;
        for(node = 0; node < i.length; node++)serverComponentName = i[node], propName = "string" === typeof serverComponentName ? propName + (removed(indent) + describeTextNode(serverComponentName, 120 - 2 * indent) + "\n") : propName + describeExpandedElement(serverComponentName.type, serverComponentName.props, removed(indent));
        return skipToNode + debugInfo + propName;
    }
    function describeDiff(rootNode) {
        try {
            return "\n\n" + describeNode(rootNode, 0);
        } catch (x) {
            return "";
        }
    }
    function describeAncestors(ancestor, child, props) {
        for(var fiber = child, node = null, distanceFromLeaf = 0; fiber;)fiber === ancestor && (distanceFromLeaf = 0), node = {
            fiber: fiber,
            children: null !== node ? [
                node
            ] : [],
            serverProps: fiber === child ? props : fiber === ancestor ? null : void 0,
            serverTail: [],
            distanceFromLeaf: distanceFromLeaf
        }, distanceFromLeaf++, fiber = fiber.return;
        return null !== node ? describeDiff(node).replaceAll(/^[+-]/gm, ">") : "";
    }
    function updatedAncestorInfoDev(oldInfo, tag) {
        var ancestorInfo = assign({}, oldInfo || emptyAncestorInfoDev), info = {
            tag: tag
        };
        -1 !== inScopeTags.indexOf(tag) && (ancestorInfo.aTagInScope = null, ancestorInfo.buttonTagInScope = null, ancestorInfo.nobrTagInScope = null);
        -1 !== buttonScopeTags.indexOf(tag) && (ancestorInfo.pTagInButtonScope = null);
        -1 !== specialTags.indexOf(tag) && "address" !== tag && "div" !== tag && "p" !== tag && (ancestorInfo.listItemTagAutoclosing = null, ancestorInfo.dlItemTagAutoclosing = null);
        ancestorInfo.current = info;
        "form" === tag && (ancestorInfo.formTag = info);
        "a" === tag && (ancestorInfo.aTagInScope = info);
        "button" === tag && (ancestorInfo.buttonTagInScope = info);
        "nobr" === tag && (ancestorInfo.nobrTagInScope = info);
        "p" === tag && (ancestorInfo.pTagInButtonScope = info);
        "li" === tag && (ancestorInfo.listItemTagAutoclosing = info);
        if ("dd" === tag || "dt" === tag) ancestorInfo.dlItemTagAutoclosing = info;
        "#document" === tag || "html" === tag ? ancestorInfo.containerTagInScope = null : ancestorInfo.containerTagInScope || (ancestorInfo.containerTagInScope = info);
        null !== oldInfo || "#document" !== tag && "html" !== tag && "body" !== tag ? !0 === ancestorInfo.implicitRootScope && (ancestorInfo.implicitRootScope = !1) : ancestorInfo.implicitRootScope = !0;
        return ancestorInfo;
    }
    function isTagValidWithParent(tag, parentTag, implicitRootScope) {
        switch(parentTag){
            case "select":
                return "hr" === tag || "option" === tag || "optgroup" === tag || "script" === tag || "template" === tag || "#text" === tag;
            case "optgroup":
                return "option" === tag || "#text" === tag;
            case "option":
                return "#text" === tag;
            case "tr":
                return "th" === tag || "td" === tag || "style" === tag || "script" === tag || "template" === tag;
            case "tbody":
            case "thead":
            case "tfoot":
                return "tr" === tag || "style" === tag || "script" === tag || "template" === tag;
            case "colgroup":
                return "col" === tag || "template" === tag;
            case "table":
                return "caption" === tag || "colgroup" === tag || "tbody" === tag || "tfoot" === tag || "thead" === tag || "style" === tag || "script" === tag || "template" === tag;
            case "head":
                return "base" === tag || "basefont" === tag || "bgsound" === tag || "link" === tag || "meta" === tag || "title" === tag || "noscript" === tag || "noframes" === tag || "style" === tag || "script" === tag || "template" === tag;
            case "html":
                if (implicitRootScope) break;
                return "head" === tag || "body" === tag || "frameset" === tag;
            case "frameset":
                return "frame" === tag;
            case "#document":
                if (!implicitRootScope) return "html" === tag;
        }
        switch(tag){
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return "h1" !== parentTag && "h2" !== parentTag && "h3" !== parentTag && "h4" !== parentTag && "h5" !== parentTag && "h6" !== parentTag;
            case "rp":
            case "rt":
                return -1 === impliedEndTags.indexOf(parentTag);
            case "caption":
            case "col":
            case "colgroup":
            case "frameset":
            case "frame":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
                return null == parentTag;
            case "head":
                return implicitRootScope || null === parentTag;
            case "html":
                return implicitRootScope && "#document" === parentTag || null === parentTag;
            case "body":
                return implicitRootScope && ("#document" === parentTag || "html" === parentTag) || null === parentTag;
        }
        return !0;
    }
    function findInvalidAncestorForTag(tag, ancestorInfo) {
        switch(tag){
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return ancestorInfo.pTagInButtonScope;
            case "form":
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case "li":
                return ancestorInfo.listItemTagAutoclosing;
            case "dd":
            case "dt":
                return ancestorInfo.dlItemTagAutoclosing;
            case "button":
                return ancestorInfo.buttonTagInScope;
            case "a":
                return ancestorInfo.aTagInScope;
            case "nobr":
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    }
    function findAncestor(parent, tagName) {
        for(; parent;){
            switch(parent.tag){
                case 5:
                case 26:
                case 27:
                    if (parent.type === tagName) return parent;
            }
            parent = parent.return;
        }
        return null;
    }
    function validateDOMNesting(childTag, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfoDev;
        var parentInfo = ancestorInfo.current;
        ancestorInfo = (parentInfo = isTagValidWithParent(childTag, parentInfo && parentInfo.tag, ancestorInfo.implicitRootScope) ? null : parentInfo) ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        ancestorInfo = parentInfo || ancestorInfo;
        if (!ancestorInfo) return !0;
        var ancestorTag = ancestorInfo.tag;
        ancestorInfo = String(!!parentInfo) + "|" + childTag + "|" + ancestorTag;
        if (didWarn[ancestorInfo]) return !1;
        didWarn[ancestorInfo] = !0;
        var ancestor = (ancestorInfo = current) ? findAncestor(ancestorInfo.return, ancestorTag) : null, ancestorDescription = null !== ancestorInfo && null !== ancestor ? describeAncestors(ancestor, ancestorInfo, null) : "", tagDisplayName = "<" + childTag + ">";
        parentInfo ? (parentInfo = "", "table" === ancestorTag && "tr" === childTag && (parentInfo += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), console.error("In HTML, %s cannot be a child of <%s>.%s\nThis will cause a hydration error.%s", tagDisplayName, ancestorTag, parentInfo, ancestorDescription)) : console.error("In HTML, %s cannot be a descendant of <%s>.\nThis will cause a hydration error.%s", tagDisplayName, ancestorTag, ancestorDescription);
        ancestorInfo && (childTag = ancestorInfo.return, null === ancestor || null === childTag || ancestor === childTag && childTag._debugOwner === ancestorInfo._debugOwner || runWithFiberInDEV(ancestor, function() {
            console.error("<%s> cannot contain a nested %s.\nSee this log for the ancestor stack trace.", ancestorTag, tagDisplayName);
        }));
        return !1;
    }
    function validateTextNesting(childText, parentTag, implicitRootScope) {
        if (implicitRootScope || isTagValidWithParent("#text", parentTag, !1)) return !0;
        implicitRootScope = "#text|" + parentTag;
        if (didWarn[implicitRootScope]) return !1;
        didWarn[implicitRootScope] = !0;
        var ancestor = (implicitRootScope = current) ? findAncestor(implicitRootScope, parentTag) : null;
        implicitRootScope = null !== implicitRootScope && null !== ancestor ? describeAncestors(ancestor, implicitRootScope, 6 !== implicitRootScope.tag ? {
            children: null
        } : null) : "";
        /\S/.test(childText) ? console.error("In HTML, text nodes cannot be a child of <%s>.\nThis will cause a hydration error.%s", parentTag, implicitRootScope) : console.error("In HTML, whitespace text nodes cannot be a child of <%s>. Make sure you don't have any extra whitespace between tags on each line of your source code.\nThis will cause a hydration error.%s", parentTag, implicitRootScope);
        return !1;
    }
    function setTextContent(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    }
    function camelize(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    }
    function setValueForStyle(style, styleName, value) {
        var isCustomProperty = 0 === styleName.indexOf("--");
        isCustomProperty || (-1 < styleName.indexOf("-") ? warnedStyleNames.hasOwnProperty(styleName) && warnedStyleNames[styleName] || (warnedStyleNames[styleName] = !0, console.error("Unsupported style property %s. Did you mean %s?", styleName, camelize(styleName.replace(msPattern, "ms-")))) : badVendoredStyleNamePattern.test(styleName) ? warnedStyleNames.hasOwnProperty(styleName) && warnedStyleNames[styleName] || (warnedStyleNames[styleName] = !0, console.error("Unsupported vendor-prefixed style property %s. Did you mean %s?", styleName, styleName.charAt(0).toUpperCase() + styleName.slice(1))) : !badStyleValueWithSemicolonPattern.test(value) || warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value] || (warnedStyleValues[value] = !0, console.error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', styleName, value.replace(badStyleValueWithSemicolonPattern, ""))), "number" === typeof value && (isNaN(value) ? warnedForNaNValue || (warnedForNaNValue = !0, console.error("`NaN` is an invalid value for the `%s` css style property.", styleName)) : isFinite(value) || warnedForInfinityValue || (warnedForInfinityValue = !0, console.error("`Infinity` is an invalid value for the `%s` css style property.", styleName))));
        null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : (checkCSSPropertyStringCoercion(value, styleName), style[styleName] = ("" + value).trim()) : style[styleName] = value + "px";
    }
    function setValueForStyles(node, styles, prevStyles) {
        if (null != styles && "object" !== typeof styles) throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
        styles && Object.freeze(styles);
        node = node.style;
        if (null != prevStyles) {
            if (styles) {
                var expandedUpdates = {};
                if (prevStyles) {
                    for(var key in prevStyles)if (prevStyles.hasOwnProperty(key) && !styles.hasOwnProperty(key)) for(var longhands = shorthandToLonghand[key] || [
                        key
                    ], i = 0; i < longhands.length; i++)expandedUpdates[longhands[i]] = key;
                }
                for(var _key in styles)if (styles.hasOwnProperty(_key) && (!prevStyles || prevStyles[_key] !== styles[_key])) for(key = shorthandToLonghand[_key] || [
                    _key
                ], longhands = 0; longhands < key.length; longhands++)expandedUpdates[key[longhands]] = _key;
                _key = {};
                for(var key$jscomp$0 in styles)for(key = shorthandToLonghand[key$jscomp$0] || [
                    key$jscomp$0
                ], longhands = 0; longhands < key.length; longhands++)_key[key[longhands]] = key$jscomp$0;
                key$jscomp$0 = {};
                for(var _key2 in expandedUpdates)if (key = expandedUpdates[_key2], (longhands = _key[_key2]) && key !== longhands && (i = key + "," + longhands, !key$jscomp$0[i])) {
                    key$jscomp$0[i] = !0;
                    i = console;
                    var value = styles[key];
                    i.error.call(i, "%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", null == value || "boolean" === typeof value || "" === value ? "Removing" : "Updating", key, longhands);
                }
            }
            for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
            for(var _styleName in styles)_key2 = styles[_styleName], styles.hasOwnProperty(_styleName) && prevStyles[_styleName] !== _key2 && setValueForStyle(node, _styleName, _key2);
        } else for(expandedUpdates in styles)styles.hasOwnProperty(expandedUpdates) && setValueForStyle(node, expandedUpdates, styles[expandedUpdates]);
    }
    function isCustomElement(tagName) {
        if (-1 === tagName.indexOf("-")) return !1;
        switch(tagName){
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return !1;
            default:
                return !0;
        }
    }
    function getAttributeAlias(name) {
        return aliases.get(name) || name;
    }
    function validateProperty$1(tagName, name) {
        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return !0;
        if (rARIACamel$1.test(name)) {
            tagName = "aria-" + name.slice(4).toLowerCase();
            tagName = ariaProperties.hasOwnProperty(tagName) ? tagName : null;
            if (null == tagName) return console.error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name), warnedProperties$1[name] = !0;
            if (name !== tagName) return console.error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, tagName), warnedProperties$1[name] = !0;
        }
        if (rARIA$1.test(name)) {
            tagName = name.toLowerCase();
            tagName = ariaProperties.hasOwnProperty(tagName) ? tagName : null;
            if (null == tagName) return warnedProperties$1[name] = !0, !1;
            name !== tagName && (console.error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, tagName), warnedProperties$1[name] = !0);
        }
        return !0;
    }
    function validateProperties$2(type, props) {
        var invalidProps = [], key;
        for(key in props)validateProperty$1(type, key) || invalidProps.push(key);
        props = invalidProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        1 === invalidProps.length ? console.error("Invalid aria prop %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props", props, type) : 1 < invalidProps.length && console.error("Invalid aria props %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props", props, type);
    }
    function validateProperty(tagName, name, value, eventRegistry) {
        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) return !0;
        var lowerCasedName = name.toLowerCase();
        if ("onfocusin" === lowerCasedName || "onfocusout" === lowerCasedName) return console.error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), warnedProperties[name] = !0;
        if ("function" === typeof value && ("form" === tagName && "action" === name || "input" === tagName && "formAction" === name || "button" === tagName && "formAction" === name)) return !0;
        if (null != eventRegistry) {
            tagName = eventRegistry.possibleRegistrationNames;
            if (eventRegistry.registrationNameDependencies.hasOwnProperty(name)) return !0;
            eventRegistry = tagName.hasOwnProperty(lowerCasedName) ? tagName[lowerCasedName] : null;
            if (null != eventRegistry) return console.error("Invalid event handler property `%s`. Did you mean `%s`?", name, eventRegistry), warnedProperties[name] = !0;
            if (EVENT_NAME_REGEX.test(name)) return console.error("Unknown event handler property `%s`. It will be ignored.", name), warnedProperties[name] = !0;
        } else if (EVENT_NAME_REGEX.test(name)) return INVALID_EVENT_NAME_REGEX.test(name) && console.error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name), warnedProperties[name] = !0;
        if (rARIA.test(name) || rARIACamel.test(name)) return !0;
        if ("innerhtml" === lowerCasedName) return console.error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), warnedProperties[name] = !0;
        if ("aria" === lowerCasedName) return console.error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), warnedProperties[name] = !0;
        if ("is" === lowerCasedName && null !== value && void 0 !== value && "string" !== typeof value) return console.error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value), warnedProperties[name] = !0;
        if ("number" === typeof value && isNaN(value)) return console.error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name), warnedProperties[name] = !0;
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            if (lowerCasedName = possibleStandardNames[lowerCasedName], lowerCasedName !== name) return console.error("Invalid DOM property `%s`. Did you mean `%s`?", name, lowerCasedName), warnedProperties[name] = !0;
        } else if (name !== lowerCasedName) return console.error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName), warnedProperties[name] = !0;
        switch(name){
            case "dangerouslySetInnerHTML":
            case "children":
            case "style":
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "defaultValue":
            case "defaultChecked":
            case "innerHTML":
            case "ref":
                return !0;
            case "innerText":
            case "textContent":
                return !0;
        }
        switch(typeof value){
            case "boolean":
                switch(name){
                    case "autoFocus":
                    case "checked":
                    case "multiple":
                    case "muted":
                    case "selected":
                    case "contentEditable":
                    case "spellCheck":
                    case "draggable":
                    case "value":
                    case "autoReverse":
                    case "externalResourcesRequired":
                    case "focusable":
                    case "preserveAlpha":
                    case "allowFullScreen":
                    case "async":
                    case "autoPlay":
                    case "controls":
                    case "default":
                    case "defer":
                    case "disabled":
                    case "disablePictureInPicture":
                    case "disableRemotePlayback":
                    case "formNoValidate":
                    case "hidden":
                    case "loop":
                    case "noModule":
                    case "noValidate":
                    case "open":
                    case "playsInline":
                    case "readOnly":
                    case "required":
                    case "reversed":
                    case "scoped":
                    case "seamless":
                    case "itemScope":
                    case "capture":
                    case "download":
                    case "inert":
                        return !0;
                    default:
                        lowerCasedName = name.toLowerCase().slice(0, 5);
                        if ("data-" === lowerCasedName || "aria-" === lowerCasedName) return !0;
                        value ? console.error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name) : console.error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
                        return warnedProperties[name] = !0;
                }
            case "function":
            case "symbol":
                return warnedProperties[name] = !0, !1;
            case "string":
                if ("false" === value || "true" === value) {
                    switch(name){
                        case "checked":
                        case "selected":
                        case "multiple":
                        case "muted":
                        case "allowFullScreen":
                        case "async":
                        case "autoPlay":
                        case "controls":
                        case "default":
                        case "defer":
                        case "disabled":
                        case "disablePictureInPicture":
                        case "disableRemotePlayback":
                        case "formNoValidate":
                        case "hidden":
                        case "loop":
                        case "noModule":
                        case "noValidate":
                        case "open":
                        case "playsInline":
                        case "readOnly":
                        case "required":
                        case "reversed":
                        case "scoped":
                        case "seamless":
                        case "itemScope":
                        case "inert":
                            break;
                        default:
                            return !0;
                    }
                    console.error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, "false" === value ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
                    warnedProperties[name] = !0;
                }
        }
        return !0;
    }
    function warnUnknownProperties(type, props, eventRegistry) {
        var unknownProps = [], key;
        for(key in props)validateProperty(type, key, props[key], eventRegistry) || unknownProps.push(key);
        props = unknownProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        1 === unknownProps.length ? console.error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://react.dev/link/attribute-behavior ", props, type) : 1 < unknownProps.length && console.error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://react.dev/link/attribute-behavior ", props, type);
    }
    function sanitizeURL(url) {
        return isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
    }
    function noop$1() {}
    function getEventTarget(nativeEvent) {
        nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
        nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
        return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
    }
    function restoreStateOfTarget(target) {
        var internalInstance = getInstanceFromNode(target);
        if (internalInstance && (target = internalInstance.stateNode)) {
            var props = target[internalPropsKey] || null;
            a: switch(target = internalInstance.stateNode, internalInstance.type){
                case "input":
                    updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                    internalInstance = props.name;
                    if ("radio" === props.type && null != internalInstance) {
                        for(props = target; props.parentNode;)props = props.parentNode;
                        checkAttributeStringCoercion(internalInstance, "name");
                        props = props.querySelectorAll('input[name="' + escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                        for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                            var otherNode = props[internalInstance];
                            if (otherNode !== target && otherNode.form === target.form) {
                                var otherProps = otherNode[internalPropsKey] || null;
                                if (!otherProps) throw Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                                updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                            }
                        }
                        for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && updateValueIfChanged(otherNode);
                    }
                    break a;
                case "textarea":
                    updateTextarea(target, props.value, props.defaultValue);
                    break a;
                case "select":
                    internalInstance = props.value, null != internalInstance && updateOptions(target, !!props.multiple, internalInstance, !1);
            }
        }
    }
    function batchedUpdates$1(fn, a, b) {
        if (isInsideEventHandler) return fn(a, b);
        isInsideEventHandler = !0;
        try {
            var JSCompiler_inline_result = fn(a);
            return JSCompiler_inline_result;
        } finally{
            if (isInsideEventHandler = !1, null !== restoreTarget || null !== restoreQueue) {
                if (flushSyncWork$1(), restoreTarget && (a = restoreTarget, fn = restoreQueue, restoreQueue = restoreTarget = null, restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)restoreStateOfTarget(fn[a]);
            }
        }
    }
    function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (null === stateNode) return null;
        var props = stateNode[internalPropsKey] || null;
        if (null === props) return null;
        stateNode = props[registrationName];
        a: switch(registrationName){
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
                (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
                inst = !props;
                break a;
            default:
                inst = !1;
        }
        if (inst) return null;
        if (stateNode && "function" !== typeof stateNode) throw Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof stateNode + "` type.");
        return stateNode;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start, startValue = startText, startLength = startValue.length, end, endValue = "value" in root ? root.value : root.textContent, endLength = endValue.length;
        for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
        return fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
    }
    function getEventCharCode(nativeEvent) {
        var keyCode = nativeEvent.keyCode;
        "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
        10 === nativeEvent && (nativeEvent = 13);
        return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
    }
    function functionThatReturnsTrue() {
        return !0;
    }
    function functionThatReturnsFalse() {
        return !1;
    }
    function createSyntheticEvent(Interface) {
        function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
            this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? functionThatReturnsTrue : functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
                this.defaultPrevented = !0;
                var event = this.nativeEvent;
                event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = functionThatReturnsTrue);
            },
            stopPropagation: function() {
                var event = this.nativeEvent;
                event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = functionThatReturnsTrue);
            },
            persist: function() {},
            isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    function modifierStateGetter(keyArg) {
        var nativeEvent = this.nativeEvent;
        return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
    }
    function getEventModifierState() {
        return modifierStateGetter;
    }
    function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case "keyup":
                return -1 !== END_KEYCODES.indexOf(nativeEvent.keyCode);
            case "keydown":
                return nativeEvent.keyCode !== START_KEYCODE;
            case "keypress":
            case "mousedown":
            case "focusout":
                return !0;
            default:
                return !1;
        }
    }
    function getDataFromCustomEvent(nativeEvent) {
        nativeEvent = nativeEvent.detail;
        return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case "compositionend":
                return getDataFromCustomEvent(nativeEvent);
            case "keypress":
                if (nativeEvent.which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = !0;
                return SPACEBAR_CHAR;
            case "textInput":
                return domEventName = nativeEvent.data, domEventName === SPACEBAR_CHAR && hasSpaceKeypress ? null : domEventName;
            default:
                return null;
        }
    }
    function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        if (isComposing) return "compositionend" === domEventName || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = getData(), fallbackText = startText = root = null, isComposing = !1, domEventName) : null;
        switch(domEventName){
            case "paste":
                return null;
            case "keypress":
                if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                    if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                    if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case "compositionend":
                return useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return "input" === nodeName ? !!supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
    }
    function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return !1;
        eventNameSuffix = "on" + eventNameSuffix;
        var isSupported = eventNameSuffix in document;
        isSupported || (isSupported = document.createElement("div"), isSupported.setAttribute(eventNameSuffix, "return;"), isSupported = "function" === typeof isSupported[eventNameSuffix]);
        return isSupported;
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        restoreTarget ? restoreQueue ? restoreQueue.push(target) : restoreQueue = [
            target
        ] : restoreTarget = target;
        inst = accumulateTwoPhaseListeners(inst, "onChange");
        0 < inst.length && (nativeEvent = new SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
            event: nativeEvent,
            listeners: inst
        }));
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if ("change" === domEventName) return targetInst;
    }
    function stopWatchingForValueChange() {
        activeElement$1 && (activeElement$1.detachEvent("onpropertychange", handlePropertyChange), activeElementInst$1 = activeElement$1 = null);
    }
    function handlePropertyChange(nativeEvent) {
        if ("value" === nativeEvent.propertyName && getInstIfValueChanged(activeElementInst$1)) {
            var dispatchQueue = [];
            createAndAccumulateChangeEvent(dispatchQueue, activeElementInst$1, nativeEvent, getEventTarget(nativeEvent));
            batchedUpdates$1(runEventInBatch, dispatchQueue);
        }
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        "focusin" === domEventName ? (stopWatchingForValueChange(), activeElement$1 = target, activeElementInst$1 = targetInst, activeElement$1.attachEvent("onpropertychange", handlePropertyChange)) : "focusout" === domEventName && stopWatchingForValueChange();
    }
    function getTargetInstForInputEventPolyfill(domEventName) {
        if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return getInstIfValueChanged(activeElementInst$1);
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if ("click" === domEventName) return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if ("input" === domEventName || "change" === domEventName) return getInstIfValueChanged(targetInst);
    }
    function is(x, y) {
        return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
    }
    function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return !0;
        if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
        var keysA = Object.keys(objA), keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return !1;
        for(keysB = 0; keysB < keysA.length; keysB++){
            var currentKey = keysA[keysB];
            if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return !1;
        }
        return !0;
    }
    function getLeafNode(node) {
        for(; node && node.firstChild;)node = node.firstChild;
        return node;
    }
    function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        root = 0;
        for(var nodeEnd; node;){
            if (3 === node.nodeType) {
                nodeEnd = root + node.textContent.length;
                if (root <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - root
                };
                root = nodeEnd;
            }
            a: {
                for(; node;){
                    if (node.nextSibling) {
                        node = node.nextSibling;
                        break a;
                    }
                    node = node.parentNode;
                }
                node = void 0;
            }
            node = getLeafNode(node);
        }
    }
    function containsNode(outerNode, innerNode) {
        return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
    }
    function getActiveElementDeep(containerInfo) {
        containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
        for(var element = getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
            try {
                var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
            } catch (err) {
                JSCompiler_inline_result = !1;
            }
            if (JSCompiler_inline_result) containerInfo = element.contentWindow;
            else break;
            element = getActiveElement(containerInfo.document);
        }
        return element;
    }
    function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
    }
    function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
        mouseDown || null == activeElement || activeElement !== getActiveElement(doc) || (doc = activeElement, "selectionStart" in doc && hasSelectionCapabilities(doc) ? doc = {
            start: doc.selectionStart,
            end: doc.selectionEnd
        } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
            anchorNode: doc.anchorNode,
            anchorOffset: doc.anchorOffset,
            focusNode: doc.focusNode,
            focusOffset: doc.focusOffset
        }), lastSelection && shallowEqual(lastSelection, doc) || (lastSelection = doc, doc = accumulateTwoPhaseListeners(activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
            event: nativeEvent,
            listeners: doc
        }), nativeEvent.target = activeElement)));
    }
    function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes["Webkit" + styleProp] = "webkit" + eventName;
        prefixes["Moz" + styleProp] = "moz" + eventName;
        return prefixes;
    }
    function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName], styleProp;
        for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        return eventName;
    }
    function registerSimpleEvent(domEventName, reactName) {
        topLevelEventsToReactNames.set(domEventName, reactName);
        registerTwoPhaseEvent(reactName, [
            domEventName
        ]);
    }
    function getArrayKind(array) {
        for(var kind = EMPTY_ARRAY, i = 0; i < array.length; i++){
            var value = array[i];
            if ("object" === typeof value && null !== value) {
                if (isArrayImpl(value) && 2 === value.length && "string" === typeof value[0]) {
                    if (kind !== EMPTY_ARRAY && kind !== ENTRIES_ARRAY) return COMPLEX_ARRAY;
                    kind = ENTRIES_ARRAY;
                } else return COMPLEX_ARRAY;
            } else {
                if ("function" === typeof value || "string" === typeof value && 50 < value.length || kind !== EMPTY_ARRAY && kind !== PRIMITIVE_ARRAY) return COMPLEX_ARRAY;
                kind = PRIMITIVE_ARRAY;
            }
        }
        return kind;
    }
    function addObjectToProperties(object, properties, indent, prefix) {
        for(var key in object)hasOwnProperty.call(object, key) && "_" !== key[0] && addValueToProperties(key, object[key], properties, indent, prefix);
    }
    function addValueToProperties(propertyName, value, properties, indent, prefix) {
        switch(typeof value){
            case "object":
                if (null === value) {
                    value = "null";
                    break;
                } else {
                    if (value.$$typeof === REACT_ELEMENT_TYPE) {
                        var typeName = getComponentNameFromType(value.type) || "\u2026", key = value.key;
                        value = value.props;
                        var propsKeys = Object.keys(value), propsLength = propsKeys.length;
                        if (null == key && 0 === propsLength) {
                            value = "<" + typeName + " />";
                            break;
                        }
                        if (3 > indent || 1 === propsLength && "children" === propsKeys[0] && null == key) {
                            value = "<" + typeName + " \u2026 />";
                            break;
                        }
                        properties.push([
                            prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
                            "<" + typeName
                        ]);
                        null !== key && addValueToProperties("key", key, properties, indent + 1, prefix);
                        propertyName = !1;
                        for(var propKey in value)"children" === propKey ? null != value.children && (!isArrayImpl(value.children) || 0 < value.children.length) && (propertyName = !0) : hasOwnProperty.call(value, propKey) && "_" !== propKey[0] && addValueToProperties(propKey, value[propKey], properties, indent + 1, prefix);
                        properties.push([
                            "",
                            propertyName ? ">\u2026</" + typeName + ">" : "/>"
                        ]);
                        return;
                    }
                    typeName = Object.prototype.toString.call(value);
                    typeName = typeName.slice(8, typeName.length - 1);
                    if ("Array" === typeName) {
                        if (propKey = getArrayKind(value), propKey === PRIMITIVE_ARRAY || propKey === EMPTY_ARRAY) {
                            value = JSON.stringify(value);
                            break;
                        } else if (propKey === ENTRIES_ARRAY) {
                            properties.push([
                                prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
                                ""
                            ]);
                            for(propertyName = 0; propertyName < value.length; propertyName++)typeName = value[propertyName], addValueToProperties(typeName[0], typeName[1], properties, indent + 1, prefix);
                            return;
                        }
                    }
                    if ("Promise" === typeName) {
                        if ("fulfilled" === value.status) {
                            if (typeName = properties.length, addValueToProperties(propertyName, value.value, properties, indent, prefix), properties.length > typeName) {
                                properties = properties[typeName];
                                properties[1] = "Promise<" + (properties[1] || "Object") + ">";
                                return;
                            }
                        } else if ("rejected" === value.status && (typeName = properties.length, addValueToProperties(propertyName, value.reason, properties, indent, prefix), properties.length > typeName)) {
                            properties = properties[typeName];
                            properties[1] = "Rejected Promise<" + properties[1] + ">";
                            return;
                        }
                        properties.push([
                            "\u00a0\u00a0".repeat(indent) + propertyName,
                            "Promise"
                        ]);
                        return;
                    }
                    "Object" === typeName && (propKey = Object.getPrototypeOf(value)) && "function" === typeof propKey.constructor && (typeName = propKey.constructor.name);
                    properties.push([
                        prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
                        "Object" === typeName ? 3 > indent ? "" : "\u2026" : typeName
                    ]);
                    3 > indent && addObjectToProperties(value, properties, indent + 1, prefix);
                    return;
                }
            case "function":
                value = "" === value.name ? "() => {}" : value.name + "() {}";
                break;
            case "string":
                value = value === OMITTED_PROP_ERROR ? "\u2026" : JSON.stringify(value);
                break;
            case "undefined":
                value = "undefined";
                break;
            case "boolean":
                value = value ? "true" : "false";
                break;
            default:
                value = String(value);
        }
        properties.push([
            prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
            value
        ]);
    }
    function addObjectDiffToProperties(prev, next, properties, indent) {
        var isDeeplyEqual = !0;
        for(key in prev)key in next || (properties.push([
            REMOVED + "\u00a0\u00a0".repeat(indent) + key,
            "\u2026"
        ]), isDeeplyEqual = !1);
        for(var _key in next)if (_key in prev) {
            var key = prev[_key];
            var nextValue = next[_key];
            if (key !== nextValue) {
                if (0 === indent && "children" === _key) isDeeplyEqual = "\u00a0\u00a0".repeat(indent) + _key, properties.push([
                    REMOVED + isDeeplyEqual,
                    "\u2026"
                ], [
                    ADDED + isDeeplyEqual,
                    "\u2026"
                ]);
                else {
                    if (!(3 <= indent)) {
                        if ("object" === typeof key && "object" === typeof nextValue && null !== key && null !== nextValue && key.$$typeof === nextValue.$$typeof) {
                            if (nextValue.$$typeof === REACT_ELEMENT_TYPE) {
                                if (key.type === nextValue.type && key.key === nextValue.key) {
                                    key = getComponentNameFromType(nextValue.type) || "\u2026";
                                    isDeeplyEqual = "\u00a0\u00a0".repeat(indent) + _key;
                                    key = "<" + key + " \u2026 />";
                                    properties.push([
                                        REMOVED + isDeeplyEqual,
                                        key
                                    ], [
                                        ADDED + isDeeplyEqual,
                                        key
                                    ]);
                                    isDeeplyEqual = !1;
                                    continue;
                                }
                            } else {
                                var prevKind = Object.prototype.toString.call(key), nextKind = Object.prototype.toString.call(nextValue);
                                if (prevKind === nextKind && ("[object Object]" === nextKind || "[object Array]" === nextKind)) {
                                    prevKind = [
                                        UNCHANGED + "\u00a0\u00a0".repeat(indent) + _key,
                                        "[object Array]" === nextKind ? "Array" : ""
                                    ];
                                    properties.push(prevKind);
                                    nextKind = properties.length;
                                    addObjectDiffToProperties(key, nextValue, properties, indent + 1) ? nextKind === properties.length && (prevKind[1] = "Referentially unequal but deeply equal objects. Consider memoization.") : isDeeplyEqual = !1;
                                    continue;
                                }
                            }
                        } else if ("function" === typeof key && "function" === typeof nextValue && key.name === nextValue.name && key.length === nextValue.length && (prevKind = Function.prototype.toString.call(key), nextKind = Function.prototype.toString.call(nextValue), prevKind === nextKind)) {
                            key = "" === nextValue.name ? "() => {}" : nextValue.name + "() {}";
                            properties.push([
                                UNCHANGED + "\u00a0\u00a0".repeat(indent) + _key,
                                key + " Referentially unequal function closure. Consider memoization."
                            ]);
                            continue;
                        }
                    }
                    addValueToProperties(_key, key, properties, indent, REMOVED);
                    addValueToProperties(_key, nextValue, properties, indent, ADDED);
                }
                isDeeplyEqual = !1;
            }
        } else properties.push([
            ADDED + "\u00a0\u00a0".repeat(indent) + _key,
            "\u2026"
        ]), isDeeplyEqual = !1;
        return isDeeplyEqual;
    }
    function setCurrentTrackFromLanes(lanes) {
        currentTrack = lanes & 63 ? "Blocking" : lanes & 64 ? "Gesture" : lanes & 4194176 ? "Transition" : lanes & 62914560 ? "Suspense" : lanes & 2080374784 ? "Idle" : "Other";
    }
    function logComponentTrigger(fiber, startTime, endTime, trigger) {
        supportsUserTiming && (reusableComponentOptions.start = startTime, reusableComponentOptions.end = endTime, reusableComponentDevToolDetails.color = "warning", reusableComponentDevToolDetails.tooltipText = trigger, reusableComponentDevToolDetails.properties = null, (fiber = fiber._debugTask) ? fiber.run(performance.measure.bind(performance, trigger, reusableComponentOptions)) : performance.measure(trigger, reusableComponentOptions));
    }
    function logComponentReappeared(fiber, startTime, endTime) {
        logComponentTrigger(fiber, startTime, endTime, "Reconnect");
    }
    function logComponentRender(fiber, startTime, endTime, wasHydrated, committedLanes) {
        var name = getComponentNameFromFiber(fiber);
        if (null !== name && supportsUserTiming) {
            var alternate = fiber.alternate, selfTime = fiber.actualDuration;
            if (null === alternate || alternate.child !== fiber.child) for(var child = fiber.child; null !== child; child = child.sibling)selfTime -= child.actualDuration;
            wasHydrated = 0.5 > selfTime ? wasHydrated ? "tertiary-light" : "primary-light" : 10 > selfTime ? wasHydrated ? "tertiary" : "primary" : 100 > selfTime ? wasHydrated ? "tertiary-dark" : "primary-dark" : "error";
            var props = fiber.memoizedProps;
            selfTime = fiber._debugTask;
            null !== props && null !== alternate && alternate.memoizedProps !== props ? (child = [
                resuableChangedPropsEntry
            ], props = addObjectDiffToProperties(alternate.memoizedProps, props, child, 0), 1 < child.length && (props && !alreadyWarnedForDeepEquality && 0 === (alternate.lanes & committedLanes) && 100 < fiber.actualDuration ? (alreadyWarnedForDeepEquality = !0, child[0] = reusableDeeplyEqualPropsEntry, reusableComponentDevToolDetails.color = "warning", reusableComponentDevToolDetails.tooltipText = DEEP_EQUALITY_WARNING) : (reusableComponentDevToolDetails.color = wasHydrated, reusableComponentDevToolDetails.tooltipText = name), reusableComponentDevToolDetails.properties = child, reusableComponentOptions.start = startTime, reusableComponentOptions.end = endTime, null != selfTime ? selfTime.run(performance.measure.bind(performance, "\u200b" + name, reusableComponentOptions)) : performance.measure("\u200b" + name, reusableComponentOptions))) : null != selfTime ? selfTime.run(console.timeStamp.bind(console, name, startTime, endTime, COMPONENTS_TRACK, void 0, wasHydrated)) : console.timeStamp(name, startTime, endTime, COMPONENTS_TRACK, void 0, wasHydrated);
        }
    }
    function logComponentErrored(fiber, startTime, endTime, errors) {
        if (supportsUserTiming) {
            var name = getComponentNameFromFiber(fiber);
            if (null !== name) {
                for(var debugTask = null, properties = [], i = 0; i < errors.length; i++){
                    var capturedValue = errors[i];
                    null == debugTask && null !== capturedValue.source && (debugTask = capturedValue.source._debugTask);
                    capturedValue = capturedValue.value;
                    properties.push([
                        "Error",
                        "object" === typeof capturedValue && null !== capturedValue && "string" === typeof capturedValue.message ? String(capturedValue.message) : String(capturedValue)
                    ]);
                }
                null !== fiber.key && addValueToProperties("key", fiber.key, properties, 0, "");
                null !== fiber.memoizedProps && addObjectToProperties(fiber.memoizedProps, properties, 0, "");
                null == debugTask && (debugTask = fiber._debugTask);
                fiber = {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            color: "error",
                            track: COMPONENTS_TRACK,
                            tooltipText: 13 === fiber.tag ? "Hydration failed" : "Error boundary caught an error",
                            properties: properties
                        }
                    }
                };
                debugTask ? debugTask.run(performance.measure.bind(performance, "\u200b" + name, fiber)) : performance.measure("\u200b" + name, fiber);
            }
        }
    }
    function logComponentEffect(fiber, startTime, endTime, selfTime, errors) {
        if (null !== errors) {
            if (supportsUserTiming) {
                var name = getComponentNameFromFiber(fiber);
                if (null !== name) {
                    selfTime = [];
                    for(var i = 0; i < errors.length; i++){
                        var error = errors[i].value;
                        selfTime.push([
                            "Error",
                            "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error)
                        ]);
                    }
                    null !== fiber.key && addValueToProperties("key", fiber.key, selfTime, 0, "");
                    null !== fiber.memoizedProps && addObjectToProperties(fiber.memoizedProps, selfTime, 0, "");
                    startTime = {
                        start: startTime,
                        end: endTime,
                        detail: {
                            devtools: {
                                color: "error",
                                track: COMPONENTS_TRACK,
                                tooltipText: "A lifecycle or effect errored",
                                properties: selfTime
                            }
                        }
                    };
                    (fiber = fiber._debugTask) ? fiber.run(performance.measure.bind(performance, "\u200b" + name, startTime)) : performance.measure("\u200b" + name, startTime);
                }
            }
        } else name = getComponentNameFromFiber(fiber), null !== name && supportsUserTiming && (errors = 1 > selfTime ? "secondary-light" : 100 > selfTime ? "secondary" : 500 > selfTime ? "secondary-dark" : "error", (fiber = fiber._debugTask) ? fiber.run(console.timeStamp.bind(console, name, startTime, endTime, COMPONENTS_TRACK, void 0, errors)) : console.timeStamp(name, startTime, endTime, COMPONENTS_TRACK, void 0, errors));
    }
    function logRenderPhase(startTime, endTime, lanes, debugTask) {
        if (supportsUserTiming && !(endTime <= startTime)) {
            var color = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark";
            lanes = (lanes & 536870912) === lanes ? "Prepared" : (lanes & 201326741) === lanes ? "Hydrated" : "Render";
            debugTask ? debugTask.run(console.timeStamp.bind(console, lanes, startTime, endTime, currentTrack, LANES_TRACK_GROUP, color)) : console.timeStamp(lanes, startTime, endTime, currentTrack, LANES_TRACK_GROUP, color);
        }
    }
    function logSuspendedRenderPhase(startTime, endTime, lanes, debugTask) {
        !supportsUserTiming || endTime <= startTime || (lanes = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark", debugTask ? debugTask.run(console.timeStamp.bind(console, "Prewarm", startTime, endTime, currentTrack, LANES_TRACK_GROUP, lanes)) : console.timeStamp("Prewarm", startTime, endTime, currentTrack, LANES_TRACK_GROUP, lanes));
    }
    function logSuspendedWithDelayPhase(startTime, endTime, lanes, debugTask) {
        !supportsUserTiming || endTime <= startTime || (lanes = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark", debugTask ? debugTask.run(console.timeStamp.bind(console, "Suspended", startTime, endTime, currentTrack, LANES_TRACK_GROUP, lanes)) : console.timeStamp("Suspended", startTime, endTime, currentTrack, LANES_TRACK_GROUP, lanes));
    }
    function logRecoveredRenderPhase(startTime, endTime, lanes, recoverableErrors, hydrationFailed, debugTask) {
        if (supportsUserTiming && !(endTime <= startTime)) {
            lanes = [];
            for(var i = 0; i < recoverableErrors.length; i++){
                var error = recoverableErrors[i].value;
                lanes.push([
                    "Recoverable Error",
                    "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error)
                ]);
            }
            startTime = {
                start: startTime,
                end: endTime,
                detail: {
                    devtools: {
                        color: "primary-dark",
                        track: currentTrack,
                        trackGroup: LANES_TRACK_GROUP,
                        tooltipText: hydrationFailed ? "Hydration Failed" : "Recovered after Error",
                        properties: lanes
                    }
                }
            };
            debugTask ? debugTask.run(performance.measure.bind(performance, "Recovered", startTime)) : performance.measure("Recovered", startTime);
        }
    }
    function logErroredRenderPhase(startTime, endTime, lanes, debugTask) {
        !supportsUserTiming || endTime <= startTime || (debugTask ? debugTask.run(console.timeStamp.bind(console, "Errored", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "error")) : console.timeStamp("Errored", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "error"));
    }
    function logSuspendedCommitPhase(startTime, endTime, reason, debugTask) {
        !supportsUserTiming || endTime <= startTime || (debugTask ? debugTask.run(console.timeStamp.bind(console, reason, startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light")) : console.timeStamp(reason, startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light"));
    }
    function logCommitErrored(startTime, endTime, errors, passive, debugTask) {
        if (supportsUserTiming && !(endTime <= startTime)) {
            for(var properties = [], i = 0; i < errors.length; i++){
                var error = errors[i].value;
                properties.push([
                    "Error",
                    "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error)
                ]);
            }
            startTime = {
                start: startTime,
                end: endTime,
                detail: {
                    devtools: {
                        color: "error",
                        track: currentTrack,
                        trackGroup: LANES_TRACK_GROUP,
                        tooltipText: passive ? "Remaining Effects Errored" : "Commit Errored",
                        properties: properties
                    }
                }
            };
            debugTask ? debugTask.run(performance.measure.bind(performance, "Errored", startTime)) : performance.measure("Errored", startTime);
        }
    }
    function logAnimatingPhase(startTime, endTime, debugTask) {
        !supportsUserTiming || endTime <= startTime || (debugTask ? debugTask.run(console.timeStamp.bind(console, "Animating", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-dark")) : console.timeStamp("Animating", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-dark"));
    }
    function finishQueueingConcurrentUpdates() {
        for(var endIndex = concurrentQueuesIndex, i = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i < endIndex;){
            var fiber = concurrentQueues[i];
            concurrentQueues[i++] = null;
            var queue = concurrentQueues[i];
            concurrentQueues[i++] = null;
            var update = concurrentQueues[i];
            concurrentQueues[i++] = null;
            var lane = concurrentQueues[i];
            concurrentQueues[i++] = null;
            if (null !== queue && null !== update) {
                var pending = queue.pending;
                null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
                queue.pending = update;
            }
            0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
        }
    }
    function enqueueUpdate$1(fiber, queue, update, lane) {
        concurrentQueues[concurrentQueuesIndex++] = fiber;
        concurrentQueues[concurrentQueuesIndex++] = queue;
        concurrentQueues[concurrentQueuesIndex++] = update;
        concurrentQueues[concurrentQueuesIndex++] = lane;
        concurrentlyUpdatedLanes |= lane;
        fiber.lanes |= lane;
        fiber = fiber.alternate;
        null !== fiber && (fiber.lanes |= lane);
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
        enqueueUpdate$1(fiber, queue, update, lane);
        return getRootForUpdatedFiber(fiber);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
        enqueueUpdate$1(fiber, null, null, lane);
        return getRootForUpdatedFiber(fiber);
    }
    function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
        sourceFiber.lanes |= lane;
        var alternate = sourceFiber.alternate;
        null !== alternate && (alternate.lanes |= lane);
        for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & OffscreenVisible || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
        return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
            update
        ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
    }
    function getRootForUpdatedFiber(sourceFiber) {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) throw nestedPassiveUpdateCount = nestedUpdateCount = 0, rootWithPassiveNestedUpdates = rootWithNestedUpdates = null, Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT && (nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null, console.error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
        null === sourceFiber.alternate && 0 !== (sourceFiber.flags & 4098) && warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        for(var node = sourceFiber, parent = node.return; null !== parent;)null === node.alternate && 0 !== (node.flags & 4098) && warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber), node = parent, parent = node.return;
        return 3 === node.tag ? node.stateNode : null;
    }
    function resolveFunctionForHotReloading(type) {
        if (null === resolveFamily) return type;
        var family = resolveFamily(type);
        return void 0 === family ? type : family.current;
    }
    function resolveForwardRefForHotReloading(type) {
        if (null === resolveFamily) return type;
        var family = resolveFamily(type);
        return void 0 === family ? null !== type && void 0 !== type && "function" === typeof type.render && (family = resolveFunctionForHotReloading(type.render), type.render !== family) ? (family = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: family
        }, void 0 !== type.displayName && (family.displayName = type.displayName), family) : type : family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (null === resolveFamily) return !1;
        var prevType = fiber.elementType;
        element = element.type;
        var needsCompareFamilies = !1, $$typeofNextType = "object" === typeof element && null !== element ? element.$$typeof : null;
        switch(fiber.tag){
            case 1:
                "function" === typeof element && (needsCompareFamilies = !0);
                break;
            case 0:
                "function" === typeof element ? needsCompareFamilies = !0 : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = !0);
                break;
            case 11:
                $$typeofNextType === REACT_FORWARD_REF_TYPE ? needsCompareFamilies = !0 : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = !0);
                break;
            case 14:
            case 15:
                $$typeofNextType === REACT_MEMO_TYPE ? needsCompareFamilies = !0 : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = !0);
                break;
            default:
                return !1;
        }
        return needsCompareFamilies && (fiber = resolveFamily(prevType), void 0 !== fiber && fiber === resolveFamily(element)) ? !0 : !1;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        null !== resolveFamily && "function" === typeof WeakSet && (null === failedBoundaries && (failedBoundaries = new WeakSet()), failedBoundaries.add(fiber));
    }
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        do {
            var _fiber = fiber, alternate = _fiber.alternate, child = _fiber.child, sibling = _fiber.sibling, tag = _fiber.tag;
            _fiber = _fiber.type;
            var candidateType = null;
            switch(tag){
                case 0:
                case 15:
                case 1:
                    candidateType = _fiber;
                    break;
                case 11:
                    candidateType = _fiber.render;
            }
            if (null === resolveFamily) throw Error("Expected resolveFamily to be set during hot reload.");
            var needsRender = !1;
            _fiber = !1;
            null !== candidateType && (candidateType = resolveFamily(candidateType), void 0 !== candidateType && (staleFamilies.has(candidateType) ? _fiber = !0 : updatedFamilies.has(candidateType) && (1 === tag ? _fiber = !0 : needsRender = !0)));
            null !== failedBoundaries && (failedBoundaries.has(fiber) || null !== alternate && failedBoundaries.has(alternate)) && (_fiber = !0);
            _fiber && (fiber._debugNeedsRemount = !0);
            if (_fiber || needsRender) alternate = enqueueConcurrentRenderForLane(fiber, 2), null !== alternate && scheduleUpdateOnFiber(alternate, fiber, 2);
            null === child || _fiber || scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
            if (null === sibling) break;
            fiber = sibling;
        }while (1);
    }
    function FiberNode(tag, pendingProps, key, mode) {
        this.tag = tag;
        this.key = key;
        this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
        this.index = 0;
        this.refCleanup = this.ref = null;
        this.pendingProps = pendingProps;
        this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
        this.mode = mode;
        this.subtreeFlags = this.flags = 0;
        this.deletions = null;
        this.childLanes = this.lanes = 0;
        this.alternate = null;
        this.actualDuration = -0;
        this.actualStartTime = -1.1;
        this.treeBaseDuration = this.selfBaseDuration = -0;
        this._debugTask = this._debugStack = this._debugOwner = this._debugInfo = null;
        this._debugNeedsRemount = !1;
        this._debugHookTypes = null;
        hasBadMapPolyfill || "function" !== typeof Object.preventExtensions || Object.preventExtensions(this);
    }
    function shouldConstruct(Component) {
        Component = Component.prototype;
        return !(!Component || !Component.isReactComponent);
    }
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        null === workInProgress ? (workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress._debugOwner = current._debugOwner, workInProgress._debugStack = current._debugStack, workInProgress._debugTask = current._debugTask, workInProgress._debugHookTypes = current._debugHookTypes, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.actualDuration = -0, workInProgress.actualStartTime = -1.1);
        workInProgress.flags = current.flags & 65011712;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue;
        pendingProps = current.dependencies;
        workInProgress.dependencies = null === pendingProps ? null : {
            lanes: pendingProps.lanes,
            firstContext: pendingProps.firstContext,
            _debugThenableState: pendingProps._debugThenableState
        };
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.refCleanup = current.refCleanup;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugInfo = current._debugInfo;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case 0:
            case 15:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case 1:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case 11:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
        }
        return workInProgress;
    }
    function resetWorkInProgress(workInProgress, renderLanes) {
        workInProgress.flags &= 65011714;
        var current = workInProgress.alternate;
        null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null, workInProgress.selfBaseDuration = 0, workInProgress.treeBaseDuration = 0) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
            lanes: renderLanes.lanes,
            firstContext: renderLanes.firstContext,
            _debugThenableState: renderLanes._debugThenableState
        }, workInProgress.selfBaseDuration = current.selfBaseDuration, workInProgress.treeBaseDuration = current.treeBaseDuration);
        return workInProgress;
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = 0, resolvedType = type;
        if ("function" === typeof type) shouldConstruct(type) && (fiberTag = 1), resolvedType = resolveFunctionForHotReloading(resolvedType);
        else if ("string" === typeof type) fiberTag = getHostContext(), fiberTag = isHostHoistableType(type, pendingProps, fiberTag) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
        else a: switch(type){
            case REACT_ACTIVITY_TYPE:
                return key = createFiber(31, pendingProps, key, mode), key.elementType = REACT_ACTIVITY_TYPE, key.lanes = lanes, key;
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_STRICT_MODE_TYPE:
                fiberTag = 8;
                mode |= StrictLegacyMode;
                mode |= StrictEffectsMode;
                break;
            case REACT_PROFILER_TYPE:
                return type = pendingProps, owner = mode, "string" !== typeof type.id && console.error('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof type.id), key = createFiber(12, type, key, owner | ProfileMode), key.elementType = REACT_PROFILER_TYPE, key.lanes = lanes, key.stateNode = {
                    effectDuration: 0,
                    passiveEffectDuration: 0
                }, key;
            case REACT_SUSPENSE_TYPE:
                return key = createFiber(13, pendingProps, key, mode), key.elementType = REACT_SUSPENSE_TYPE, key.lanes = lanes, key;
            case REACT_SUSPENSE_LIST_TYPE:
                return key = createFiber(19, pendingProps, key, mode), key.elementType = REACT_SUSPENSE_LIST_TYPE, key.lanes = lanes, key;
            default:
                if ("object" === typeof type && null !== type) switch(type.$$typeof){
                    case REACT_CONTEXT_TYPE:
                        fiberTag = 10;
                        break a;
                    case REACT_CONSUMER_TYPE:
                        fiberTag = 9;
                        break a;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = 11;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break a;
                    case REACT_MEMO_TYPE:
                        fiberTag = 14;
                        break a;
                    case REACT_LAZY_TYPE:
                        fiberTag = 16;
                        resolvedType = null;
                        break a;
                }
                resolvedType = "";
                if (void 0 === type || "object" === typeof type && null !== type && 0 === Object.keys(type).length) resolvedType += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                null === type ? pendingProps = "null" : isArrayImpl(type) ? pendingProps = "array" : void 0 !== type && type.$$typeof === REACT_ELEMENT_TYPE ? (pendingProps = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />", resolvedType = " Did you accidentally export a JSX literal instead of a component?") : pendingProps = typeof type;
                (fiberTag = owner ? getComponentNameFromOwner(owner) : null) && (resolvedType += "\n\nCheck the render method of `" + fiberTag + "`.");
                fiberTag = 29;
                pendingProps = Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (pendingProps + "." + resolvedType));
                resolvedType = null;
        }
        key = createFiber(fiberTag, pendingProps, key, mode);
        key.elementType = type;
        key.type = resolvedType;
        key.lanes = lanes;
        key._debugOwner = owner;
        return key;
    }
    function createFiberFromElement(element, mode, lanes) {
        mode = createFiberFromTypeAndProps(element.type, element.key, element.props, element._owner, mode, lanes);
        mode._debugOwner = element._owner;
        mode._debugStack = element._debugStack;
        mode._debugTask = element._debugTask;
        return mode;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        elements = createFiber(7, elements, key, mode);
        elements.lanes = lanes;
        return elements;
    }
    function createFiberFromText(content, mode, lanes) {
        content = createFiber(6, content, null, mode);
        content.lanes = lanes;
        return content;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(18, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        mode = createFiber(4, null !== portal.children ? portal.children : [], portal.key, mode);
        mode.lanes = lanes;
        mode.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            implementation: portal.implementation
        };
        return mode;
    }
    function createCapturedValueAtFiber(value, source) {
        if ("object" === typeof value && null !== value) {
            var existing = CapturedStacks.get(value);
            if (void 0 !== existing) return existing;
            source = {
                value: value,
                source: source,
                stack: getStackByFiberInDevAndProd(source)
            };
            CapturedStacks.set(value, source);
            return source;
        }
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
    }
    function pushTreeFork(workInProgress, totalChildren) {
        warnIfNotHydrating();
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress, totalChildren, index) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        workInProgress = treeContextOverflow;
        var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
        baseIdWithLeadingBit &= ~(1 << baseLength);
        index += 1;
        var length = 32 - clz32(totalChildren) + baseLength;
        if (30 < length) {
            var numberOfOverflowBits = baseLength - baseLength % 5;
            length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
            baseIdWithLeadingBit >>= numberOfOverflowBits;
            baseLength -= numberOfOverflowBits;
            treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
            treeContextOverflow = length + workInProgress;
        } else treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress;
    }
    function pushMaterializedTreeId(workInProgress) {
        warnIfNotHydrating();
        null !== workInProgress.return && (pushTreeFork(workInProgress, 1), pushTreeId(workInProgress, 1, 0));
    }
    function popTreeContext(workInProgress) {
        for(; workInProgress === treeForkProvider;)treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
        for(; workInProgress === treeContextProvider;)treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
    }
    function getSuspendedTreeContext() {
        warnIfNotHydrating();
        return null !== treeContextProvider ? {
            id: treeContextId,
            overflow: treeContextOverflow
        } : null;
    }
    function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress;
    }
    function warnIfNotHydrating() {
        isHydrating || console.error("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    function buildHydrationDiffNode(fiber, distanceFromLeaf) {
        if (null === fiber.return) {
            if (null === hydrationDiffRootDEV) hydrationDiffRootDEV = {
                fiber: fiber,
                children: [],
                serverProps: void 0,
                serverTail: [],
                distanceFromLeaf: distanceFromLeaf
            };
            else {
                if (hydrationDiffRootDEV.fiber !== fiber) throw Error("Saw multiple hydration diff roots in a pass. This is a bug in React.");
                hydrationDiffRootDEV.distanceFromLeaf > distanceFromLeaf && (hydrationDiffRootDEV.distanceFromLeaf = distanceFromLeaf);
            }
            return hydrationDiffRootDEV;
        }
        var siblings = buildHydrationDiffNode(fiber.return, distanceFromLeaf + 1).children;
        if (0 < siblings.length && siblings[siblings.length - 1].fiber === fiber) return siblings = siblings[siblings.length - 1], siblings.distanceFromLeaf > distanceFromLeaf && (siblings.distanceFromLeaf = distanceFromLeaf), siblings;
        distanceFromLeaf = {
            fiber: fiber,
            children: [],
            serverProps: void 0,
            serverTail: [],
            distanceFromLeaf: distanceFromLeaf
        };
        siblings.push(distanceFromLeaf);
        return distanceFromLeaf;
    }
    function warnIfHydrating() {
        isHydrating && console.error("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function warnNonHydratedInstance(fiber, rejectedCandidate) {
        didSuspendOrErrorDEV || (fiber = buildHydrationDiffNode(fiber, 0), fiber.serverProps = null, null !== rejectedCandidate && (rejectedCandidate = describeHydratableInstanceForDevWarnings(rejectedCandidate), fiber.serverTail.push(rejectedCandidate)));
    }
    function throwOnHydrationMismatch(fiber) {
        var fromText = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : !1, diff = "", diffRoot = hydrationDiffRootDEV;
        null !== diffRoot && (hydrationDiffRootDEV = null, diff = describeDiff(diffRoot));
        queueHydrationError(createCapturedValueAtFiber(Error("Hydration failed because the server rendered " + (fromText ? "text" : "HTML") + " didn't match the client. As a result this tree will be regenerated on the client. This can happen if a SSR-ed Client Component used:\n\n- A server/client branch `if (typeof window !== 'undefined')`.\n- Variable input such as `Date.now()` or `Math.random()` which changes each time it's called.\n- Date formatting in a user's locale which doesn't match the server.\n- External changing data without sending a snapshot of it along with the HTML.\n- Invalid HTML tag nesting.\n\nIt can also happen if the client has a browser extension installed which messes with the HTML before React loaded.\n\nhttps://react.dev/link/hydration-mismatch" + diff), fiber));
        throw HydrationMismatchException;
    }
    function prepareToHydrateHostInstance(fiber) {
        var didHydrate = fiber.stateNode;
        var type = fiber.type, props = fiber.memoizedProps;
        didHydrate[internalInstanceKey] = fiber;
        didHydrate[internalPropsKey] = props;
        validatePropertiesInDevelopment(type, props);
        switch(type){
            case "dialog":
                listenToNonDelegatedEvent("cancel", didHydrate);
                listenToNonDelegatedEvent("close", didHydrate);
                break;
            case "iframe":
            case "object":
            case "embed":
                listenToNonDelegatedEvent("load", didHydrate);
                break;
            case "video":
            case "audio":
                for(type = 0; type < mediaEventTypes.length; type++)listenToNonDelegatedEvent(mediaEventTypes[type], didHydrate);
                break;
            case "source":
                listenToNonDelegatedEvent("error", didHydrate);
                break;
            case "img":
            case "image":
            case "link":
                listenToNonDelegatedEvent("error", didHydrate);
                listenToNonDelegatedEvent("load", didHydrate);
                break;
            case "details":
                listenToNonDelegatedEvent("toggle", didHydrate);
                break;
            case "input":
                checkControlledValueProps("input", props);
                listenToNonDelegatedEvent("invalid", didHydrate);
                validateInputProps(didHydrate, props);
                initInput(didHydrate, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
                break;
            case "option":
                validateOptionProps(didHydrate, props);
                break;
            case "select":
                checkControlledValueProps("select", props);
                listenToNonDelegatedEvent("invalid", didHydrate);
                validateSelectProps(didHydrate, props);
                break;
            case "textarea":
                checkControlledValueProps("textarea", props), listenToNonDelegatedEvent("invalid", didHydrate), validateTextareaProps(didHydrate, props), initTextarea(didHydrate, props.value, props.defaultValue, props.children);
        }
        type = props.children;
        "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || didHydrate.textContent === "" + type || !0 === props.suppressHydrationWarning || checkForUnmatchedText(didHydrate.textContent, type) ? (null != props.popover && (listenToNonDelegatedEvent("beforetoggle", didHydrate), listenToNonDelegatedEvent("toggle", didHydrate)), null != props.onScroll && listenToNonDelegatedEvent("scroll", didHydrate), null != props.onScrollEnd && listenToNonDelegatedEvent("scrollend", didHydrate), null != props.onClick && (didHydrate.onclick = noop$1), didHydrate = !0) : didHydrate = !1;
        didHydrate || throwOnHydrationMismatch(fiber, !0);
    }
    function popToNextHostParent(fiber) {
        for(hydrationParentFiber = fiber.return; hydrationParentFiber;)switch(hydrationParentFiber.tag){
            case 5:
            case 31:
            case 13:
                rootOrSingletonContext = !1;
                return;
            case 27:
            case 3:
                rootOrSingletonContext = !0;
                return;
            default:
                hydrationParentFiber = hydrationParentFiber.return;
        }
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) return !1;
        if (!isHydrating) return popToNextHostParent(fiber), isHydrating = !0, !1;
        var tag = fiber.tag, JSCompiler_temp;
        if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
            if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || shouldSetTextContent(fiber.type, fiber.memoizedProps);
            JSCompiler_temp = !JSCompiler_temp;
        }
        if (JSCompiler_temp && nextHydratableInstance) {
            for(JSCompiler_temp = nextHydratableInstance; JSCompiler_temp;){
                var diffNode = buildHydrationDiffNode(fiber, 0), description = describeHydratableInstanceForDevWarnings(JSCompiler_temp);
                diffNode.serverTail.push(description);
                JSCompiler_temp = "Suspense" === description.type ? getNextHydratableInstanceAfterHydrationBoundary(JSCompiler_temp) : getNextHydratable(JSCompiler_temp.nextSibling);
            }
            throwOnHydrationMismatch(fiber);
        }
        popToNextHostParent(fiber);
        if (13 === tag) {
            fiber = fiber.memoizedState;
            fiber = null !== fiber ? fiber.dehydrated : null;
            if (!fiber) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
            nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
        } else if (31 === tag) {
            fiber = fiber.memoizedState;
            fiber = null !== fiber ? fiber.dehydrated : null;
            if (!fiber) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
            nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
        } else 27 === tag ? (tag = nextHydratableInstance, isSingletonScope(fiber.type) ? (fiber = previousHydratableOnEnteringScopedSingleton, previousHydratableOnEnteringScopedSingleton = null, nextHydratableInstance = fiber) : nextHydratableInstance = tag) : nextHydratableInstance = hydrationParentFiber ? getNextHydratable(fiber.stateNode.nextSibling) : null;
        return !0;
    }
    function resetHydrationState() {
        nextHydratableInstance = hydrationParentFiber = null;
        didSuspendOrErrorDEV = isHydrating = !1;
    }
    function upgradeHydrationErrorsToRecoverable() {
        var queuedErrors = hydrationErrors;
        null !== queuedErrors && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = queuedErrors : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, queuedErrors), hydrationErrors = null);
        return queuedErrors;
    }
    function queueHydrationError(error) {
        null === hydrationErrors ? hydrationErrors = [
            error
        ] : hydrationErrors.push(error);
    }
    function emitPendingHydrationWarnings() {
        var diffRoot = hydrationDiffRootDEV;
        if (null !== diffRoot) {
            hydrationDiffRootDEV = null;
            for(var diff = describeDiff(diffRoot); 0 < diffRoot.children.length;)diffRoot = diffRoot.children[0];
            runWithFiberInDEV(diffRoot.fiber, function() {
                console.error("A tree hydrated but some attributes of the server rendered HTML didn't match the client properties. This won't be patched up. This can happen if a SSR-ed Client Component used:\n\n- A server/client branch `if (typeof window !== 'undefined')`.\n- Variable input such as `Date.now()` or `Math.random()` which changes each time it's called.\n- Date formatting in a user's locale which doesn't match the server.\n- External changing data without sending a snapshot of it along with the HTML.\n- Invalid HTML tag nesting.\n\nIt can also happen if the client has a browser extension installed which messes with the HTML before React loaded.\n\n%s%s", "https://react.dev/link/hydration-mismatch", diff);
            });
        }
    }
    function resetContextDependencies() {
        lastContextDependency = currentlyRenderingFiber$1 = null;
        isDisallowedContextReadInDEV = !1;
    }
    function pushProvider(providerFiber, context, nextValue) {
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        push(rendererCursorDEV, context._currentRenderer, providerFiber);
        void 0 !== context._currentRenderer && null !== context._currentRenderer && context._currentRenderer !== rendererSigil && console.error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(context, providerFiber) {
        context._currentValue = valueCursor.current;
        var currentRenderer = rendererCursorDEV.current;
        pop(rendererCursorDEV, providerFiber);
        context._currentRenderer = currentRenderer;
        pop(valueCursor, providerFiber);
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        for(; null !== parent;){
            var alternate = parent.alternate;
            (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
            if (parent === propagationRoot) break;
            parent = parent.return;
        }
        parent !== propagationRoot && console.error("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
        var fiber = workInProgress.child;
        null !== fiber && (fiber.return = workInProgress);
        for(; null !== fiber;){
            var list = fiber.dependencies;
            if (null !== list) {
                var nextFiber = fiber.child;
                list = list.firstContext;
                a: for(; null !== list;){
                    var dependency = list;
                    list = fiber;
                    for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                        list.lanes |= renderLanes;
                        dependency = list.alternate;
                        null !== dependency && (dependency.lanes |= renderLanes);
                        scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                        forcePropagateEntireTree || (nextFiber = null);
                        break a;
                    }
                    list = dependency.next;
                }
            } else if (18 === fiber.tag) {
                nextFiber = fiber.return;
                if (null === nextFiber) throw Error("We just came from a parent so we must have had a parent. This is a bug in React.");
                nextFiber.lanes |= renderLanes;
                list = nextFiber.alternate;
                null !== list && (list.lanes |= renderLanes);
                scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
                nextFiber = null;
            } else nextFiber = fiber.child;
            if (null !== nextFiber) nextFiber.return = fiber;
            else for(nextFiber = fiber; null !== nextFiber;){
                if (nextFiber === workInProgress) {
                    nextFiber = null;
                    break;
                }
                fiber = nextFiber.sibling;
                if (null !== fiber) {
                    fiber.return = nextFiber.return;
                    nextFiber = fiber;
                    break;
                }
                nextFiber = nextFiber.return;
            }
            fiber = nextFiber;
        }
    }
    function propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
        current = null;
        for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
            if (!isInsidePropagationBailout) {
                if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
                else if (0 !== (parent.flags & 262144)) break;
            }
            if (10 === parent.tag) {
                var currentParent = parent.alternate;
                if (null === currentParent) throw Error("Should have a current fiber. This is a bug in React.");
                currentParent = currentParent.memoizedProps;
                if (null !== currentParent) {
                    var context = parent.type;
                    objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                        context
                    ]);
                }
            } else if (parent === hostTransitionProviderCursor.current) {
                currentParent = parent.alternate;
                if (null === currentParent) throw Error("Should have a current fiber. This is a bug in React.");
                currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push(HostTransitionContext) : current = [
                    HostTransitionContext
                ]);
            }
            parent = parent.return;
        }
        null !== current && propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
        workInProgress.flags |= 262144;
    }
    function checkIfContextChanged(currentDependencies) {
        for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
            if (!objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
            currentDependencies = currentDependencies.next;
        }
        return !1;
    }
    function prepareToReadContext(workInProgress) {
        currentlyRenderingFiber$1 = workInProgress;
        lastContextDependency = null;
        workInProgress = workInProgress.dependencies;
        null !== workInProgress && (workInProgress.firstContext = null);
    }
    function readContext(context) {
        isDisallowedContextReadInDEV && console.error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        return readContextForConsumer(currentlyRenderingFiber$1, context);
    }
    function readContextDuringReconciliation(consumer, context) {
        null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
        return readContextForConsumer(consumer, context);
    }
    function readContextForConsumer(consumer, context) {
        var value = context._currentValue;
        context = {
            context: context,
            memoizedValue: value,
            next: null
        };
        if (null === lastContextDependency) {
            if (null === consumer) throw Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
            lastContextDependency = context;
            consumer.dependencies = {
                lanes: 0,
                firstContext: context,
                _debugThenableState: null
            };
            consumer.flags |= 524288;
        } else lastContextDependency = lastContextDependency.next = context;
        return value;
    }
    function createCache() {
        return {
            controller: new AbortControllerLocal(),
            data: new Map(),
            refCount: 0
        };
    }
    function retainCache(cache) {
        cache.controller.signal.aborted && console.warn("A cache instance was retained after it was already freed. This likely indicates a bug in React.");
        cache.refCount++;
    }
    function releaseCache(cache) {
        cache.refCount--;
        0 > cache.refCount && console.warn("A cache instance was released after it was already freed. This likely indicates a bug in React.");
        0 === cache.refCount && scheduleCallback$2(NormalPriority, function() {
            cache.controller.abort();
        });
    }
    function startUpdateTimerByLane(lane, method, fiber) {
        if (0 !== (lane & 127)) 0 > blockingUpdateTime && (blockingUpdateTime = now(), blockingUpdateTask = createTask(method), blockingUpdateMethodName = method, null != fiber && (blockingUpdateComponentName = getComponentNameFromFiber(fiber)), (executionContext & (RenderContext | CommitContext)) !== NoContext && (componentEffectSpawnedUpdate = !0, blockingUpdateType = SPAWNED_UPDATE), lane = resolveEventTimeStamp(), method = resolveEventType(), lane !== blockingEventRepeatTime || method !== blockingEventType ? blockingEventRepeatTime = -1.1 : null !== method && (blockingUpdateType = SPAWNED_UPDATE), blockingEventTime = lane, blockingEventType = method);
        else if (0 !== (lane & 4194048) && 0 > transitionUpdateTime && (transitionUpdateTime = now(), transitionUpdateTask = createTask(method), transitionUpdateMethodName = method, null != fiber && (transitionUpdateComponentName = getComponentNameFromFiber(fiber)), 0 > transitionStartTime)) {
            lane = resolveEventTimeStamp();
            method = resolveEventType();
            if (lane !== transitionEventRepeatTime || method !== transitionEventType) transitionEventRepeatTime = -1.1;
            transitionEventTime = lane;
            transitionEventType = method;
        }
    }
    function startHostActionTimer(fiber) {
        if (0 > blockingUpdateTime) {
            blockingUpdateTime = now();
            blockingUpdateTask = null != fiber._debugTask ? fiber._debugTask : null;
            (executionContext & (RenderContext | CommitContext)) !== NoContext && (blockingUpdateType = SPAWNED_UPDATE);
            var newEventTime = resolveEventTimeStamp(), newEventType = resolveEventType();
            newEventTime !== blockingEventRepeatTime || newEventType !== blockingEventType ? blockingEventRepeatTime = -1.1 : null !== newEventType && (blockingUpdateType = SPAWNED_UPDATE);
            blockingEventTime = newEventTime;
            blockingEventType = newEventType;
        }
        if (0 > transitionUpdateTime && (transitionUpdateTime = now(), transitionUpdateTask = null != fiber._debugTask ? fiber._debugTask : null, 0 > transitionStartTime)) {
            fiber = resolveEventTimeStamp();
            newEventTime = resolveEventType();
            if (fiber !== transitionEventRepeatTime || newEventTime !== transitionEventType) transitionEventRepeatTime = -1.1;
            transitionEventTime = fiber;
            transitionEventType = newEventTime;
        }
    }
    function pushNestedEffectDurations() {
        var prevEffectDuration = profilerEffectDuration;
        profilerEffectDuration = 0;
        return prevEffectDuration;
    }
    function popNestedEffectDurations(prevEffectDuration) {
        var elapsedTime = profilerEffectDuration;
        profilerEffectDuration = prevEffectDuration;
        return elapsedTime;
    }
    function bubbleNestedEffectDurations(prevEffectDuration) {
        var elapsedTime = profilerEffectDuration;
        profilerEffectDuration += prevEffectDuration;
        return elapsedTime;
    }
    function resetComponentEffectTimers() {
        componentEffectEndTime = componentEffectStartTime = -1.1;
    }
    function pushComponentEffectStart() {
        var prevEffectStart = componentEffectStartTime;
        componentEffectStartTime = -1.1;
        return prevEffectStart;
    }
    function popComponentEffectStart(prevEffectStart) {
        0 <= prevEffectStart && (componentEffectStartTime = prevEffectStart);
    }
    function pushComponentEffectDuration() {
        var prevEffectDuration = componentEffectDuration;
        componentEffectDuration = -0;
        return prevEffectDuration;
    }
    function popComponentEffectDuration(prevEffectDuration) {
        0 <= prevEffectDuration && (componentEffectDuration = prevEffectDuration);
    }
    function pushComponentEffectErrors() {
        var prevErrors = componentEffectErrors;
        componentEffectErrors = null;
        return prevErrors;
    }
    function pushComponentEffectDidSpawnUpdate() {
        var prev = componentEffectSpawnedUpdate;
        componentEffectSpawnedUpdate = !1;
        return prev;
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now();
        0 > fiber.actualStartTime && (fiber.actualStartTime = profilerStartTime);
    }
    function stopProfilerTimerIfRunningAndRecordDuration(fiber) {
        if (0 <= profilerStartTime) {
            var elapsedTime = now() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function stopProfilerTimerIfRunningAndRecordIncompleteDuration(fiber) {
        if (0 <= profilerStartTime) {
            var elapsedTime = now() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            profilerStartTime = -1;
        }
    }
    function recordEffectDuration() {
        if (0 <= profilerStartTime) {
            var endTime = now(), elapsedTime = endTime - profilerStartTime;
            profilerStartTime = -1;
            profilerEffectDuration += elapsedTime;
            componentEffectDuration += elapsedTime;
            componentEffectEndTime = endTime;
        }
    }
    function recordEffectError(errorInfo) {
        null === componentEffectErrors && (componentEffectErrors = []);
        componentEffectErrors.push(errorInfo);
        null === commitErrors && (commitErrors = []);
        commitErrors.push(errorInfo);
    }
    function startEffectTimer() {
        profilerStartTime = now();
        0 > componentEffectStartTime && (componentEffectStartTime = profilerStartTime);
    }
    function transferActualDuration(fiber) {
        for(var child = fiber.child; child;)fiber.actualDuration += child.actualDuration, child = child.sibling;
    }
    function entangleAsyncAction(transition, thenable) {
        if (null === currentEntangledListeners) {
            var entangledListeners = currentEntangledListeners = [];
            currentEntangledPendingCount = 0;
            currentEntangledLane = requestTransitionLane();
            currentEntangledActionThenable = {
                status: "pending",
                value: void 0,
                then: function(resolve) {
                    entangledListeners.push(resolve);
                }
            };
        }
        currentEntangledPendingCount++;
        thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
        return thenable;
    }
    function pingEngtangledActionScope() {
        if (0 === --currentEntangledPendingCount && (-1 < transitionUpdateTime || (transitionStartTime = -1.1), null !== currentEntangledListeners)) {
            null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
            var listeners = currentEntangledListeners;
            currentEntangledListeners = null;
            currentEntangledLane = 0;
            currentEntangledActionThenable = null;
            for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
        }
    }
    function chainThenableValue(thenable, result) {
        var listeners = [], thenableWithOverride = {
            status: "pending",
            value: null,
            reason: null,
            then: function(resolve) {
                listeners.push(resolve);
            }
        };
        thenable.then(function() {
            thenableWithOverride.status = "fulfilled";
            thenableWithOverride.value = result;
            for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
        }, function(error) {
            thenableWithOverride.status = "rejected";
            thenableWithOverride.reason = error;
            for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
        });
        return thenableWithOverride;
    }
    function peekCacheFromPool() {
        var cacheResumedFromPreviousRender = resumedCache.current;
        return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
    }
    function pushTransition(offscreenWorkInProgress, prevCachePool) {
        null === prevCachePool ? push(resumedCache, resumedCache.current, offscreenWorkInProgress) : push(resumedCache, prevCachePool.pool, offscreenWorkInProgress);
    }
    function getSuspendedCache() {
        var cacheFromPool = peekCacheFromPool();
        return null === cacheFromPool ? null : {
            parent: CacheContext._currentValue,
            pool: cacheFromPool
        };
    }
    function createThenableState() {
        return {
            didWarnAboutUncachedPromise: !1,
            thenables: []
        };
    }
    function isThenableResolved(thenable) {
        thenable = thenable.status;
        return "fulfilled" === thenable || "rejected" === thenable;
    }
    function trackUsedThenable(thenableState, thenable, index) {
        null !== ReactSharedInternals.actQueue && (ReactSharedInternals.didUsePromise = !0);
        var trackedThenables = thenableState.thenables;
        index = trackedThenables[index];
        void 0 === index ? trackedThenables.push(thenable) : index !== thenable && (thenableState.didWarnAboutUncachedPromise || (thenableState.didWarnAboutUncachedPromise = !0, console.error("A component was suspended by an uncached promise. Creating promises inside a Client Component or hook is not yet supported, except via a Suspense-compatible library or framework.")), thenable.then(noop$1, noop$1), thenable = index);
        if (void 0 === thenable._debugInfo) {
            thenableState = performance.now();
            trackedThenables = thenable.displayName;
            var ioInfo = {
                name: "string" === typeof trackedThenables ? trackedThenables : "Promise",
                start: thenableState,
                end: thenableState,
                value: thenable
            };
            thenable._debugInfo = [
                {
                    awaited: ioInfo
                }
            ];
            "fulfilled" !== thenable.status && "rejected" !== thenable.status && (thenableState = function() {
                ioInfo.end = performance.now();
            }, thenable.then(thenableState, thenableState));
        }
        switch(thenable.status){
            case "fulfilled":
                return thenable.value;
            case "rejected":
                throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            default:
                if ("string" === typeof thenable.status) thenable.then(noop$1, noop$1);
                else {
                    thenableState = workInProgressRoot;
                    if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error("An unknown Component is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.");
                    thenableState = thenable;
                    thenableState.status = "pending";
                    thenableState.then(function(fulfilledValue) {
                        if ("pending" === thenable.status) {
                            var fulfilledThenable = thenable;
                            fulfilledThenable.status = "fulfilled";
                            fulfilledThenable.value = fulfilledValue;
                        }
                    }, function(error) {
                        if ("pending" === thenable.status) {
                            var rejectedThenable = thenable;
                            rejectedThenable.status = "rejected";
                            rejectedThenable.reason = error;
                        }
                    });
                }
                switch(thenable.status){
                    case "fulfilled":
                        return thenable.value;
                    case "rejected":
                        throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
                }
                suspendedThenable = thenable;
                needsToResetSuspendedThenableDEV = !0;
                throw SuspenseException;
        }
    }
    function resolveLazy(lazyType) {
        try {
            return callLazyInitInDEV(lazyType);
        } catch (x) {
            if (null !== x && "object" === typeof x && "function" === typeof x.then) throw suspendedThenable = x, needsToResetSuspendedThenableDEV = !0, SuspenseException;
            throw x;
        }
    }
    function getSuspendedThenable() {
        if (null === suspendedThenable) throw Error("Expected a suspended thenable. This is a bug in React. Please file an issue.");
        var thenable = suspendedThenable;
        suspendedThenable = null;
        needsToResetSuspendedThenableDEV = !1;
        return thenable;
    }
    function checkIfUseWrappedInAsyncCatch(rejectedReason) {
        if (rejectedReason === SuspenseException || rejectedReason === SuspenseActionException) throw Error("Hooks are not supported inside an async component. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.");
    }
    function pushDebugInfo(debugInfo) {
        var previousDebugInfo = currentDebugInfo;
        null != debugInfo && (currentDebugInfo = null === previousDebugInfo ? debugInfo : previousDebugInfo.concat(debugInfo));
        return previousDebugInfo;
    }
    function getCurrentDebugTask() {
        var debugInfo = currentDebugInfo;
        if (null != debugInfo) {
            for(var i = debugInfo.length - 1; 0 <= i; i--)if (null != debugInfo[i].name) {
                var debugTask = debugInfo[i].debugTask;
                if (null != debugTask) return debugTask;
            }
        }
        return null;
    }
    function validateFragmentProps(element, fiber, returnFiber) {
        for(var keys = Object.keys(element.props), i = 0; i < keys.length; i++){
            var key = keys[i];
            if ("children" !== key && "key" !== key) {
                null === fiber && (fiber = createFiberFromElement(element, returnFiber.mode, 0), fiber._debugInfo = currentDebugInfo, fiber.return = returnFiber);
                runWithFiberInDEV(fiber, function(erroredKey) {
                    console.error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", erroredKey);
                }, key);
                break;
            }
        }
    }
    function unwrapThenable(thenable) {
        var index = thenableIndexCounter$1;
        thenableIndexCounter$1 += 1;
        null === thenableState$1 && (thenableState$1 = createThenableState());
        return trackUsedThenable(thenableState$1, thenable, index);
    }
    function coerceRef(workInProgress, element) {
        element = element.props.ref;
        workInProgress.ref = void 0 !== element ? element : null;
    }
    function throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
        if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE) throw Error('A React Element from an older version of React was rendered. This is not supported. It can happen if:\n- Multiple copies of the "react" package is used.\n- A library pre-bundled an old copy of "react" or "react/jsx-runtime".\n- A compiler tries to "inline" JSX instead of using the runtime.');
        returnFiber = Object.prototype.toString.call(newChild);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber) + "). If you meant to render a collection of children, use an array instead.");
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        var debugTask = getCurrentDebugTask();
        null !== debugTask ? debugTask.run(throwOnInvalidObjectTypeImpl.bind(null, returnFiber, newChild)) : throwOnInvalidObjectTypeImpl(returnFiber, newChild);
    }
    function warnOnFunctionTypeImpl(returnFiber, invalidChild) {
        var parentName = getComponentNameFromFiber(returnFiber) || "Component";
        ownerHasFunctionTypeWarning[parentName] || (ownerHasFunctionTypeWarning[parentName] = !0, invalidChild = invalidChild.displayName || invalidChild.name || "Component", 3 === returnFiber.tag ? console.error("Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.\n  root.render(%s)", invalidChild, invalidChild, invalidChild) : console.error("Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.\n  <%s>{%s}</%s>", invalidChild, invalidChild, parentName, invalidChild, parentName));
    }
    function warnOnFunctionType(returnFiber, invalidChild) {
        var debugTask = getCurrentDebugTask();
        null !== debugTask ? debugTask.run(warnOnFunctionTypeImpl.bind(null, returnFiber, invalidChild)) : warnOnFunctionTypeImpl(returnFiber, invalidChild);
    }
    function warnOnSymbolTypeImpl(returnFiber, invalidChild) {
        var parentName = getComponentNameFromFiber(returnFiber) || "Component";
        ownerHasSymbolTypeWarning[parentName] || (ownerHasSymbolTypeWarning[parentName] = !0, invalidChild = String(invalidChild), 3 === returnFiber.tag ? console.error("Symbols are not valid as a React child.\n  root.render(%s)", invalidChild) : console.error("Symbols are not valid as a React child.\n  <%s>%s</%s>", parentName, invalidChild, parentName));
    }
    function warnOnSymbolType(returnFiber, invalidChild) {
        var debugTask = getCurrentDebugTask();
        null !== debugTask ? debugTask.run(warnOnSymbolTypeImpl.bind(null, returnFiber, invalidChild)) : warnOnSymbolTypeImpl(returnFiber, invalidChild);
    }
    function createChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (shouldTrackSideEffects) {
                var deletions = returnFiber.deletions;
                null === deletions ? (returnFiber.deletions = [
                    childToDelete
                ], returnFiber.flags |= 16) : deletions.push(childToDelete);
            }
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) return null;
            for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
            return null;
        }
        function mapRemainingChildren(currentFirstChild) {
            for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            fiber = createWorkInProgress(fiber, pendingProps);
            fiber.index = 0;
            fiber.sibling = null;
            return fiber;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
            newIndex = newFiber.alternate;
            if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
            newFiber.flags |= 67108866;
            return lastPlacedIndex;
        }
        function placeSingleChild(newFiber) {
            shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (null === current || 6 !== current.tag) return current = createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current._debugOwner = returnFiber, current._debugTask = returnFiber._debugTask, current._debugInfo = currentDebugInfo, current;
            current = useFiber(current, textContent);
            current.return = returnFiber;
            current._debugInfo = currentDebugInfo;
            return current;
        }
        function updateElement(returnFiber, current, element, lanes) {
            var elementType = element.type;
            if (elementType === REACT_FRAGMENT_TYPE) return current = updateFragment(returnFiber, current, element.props.children, lanes, element.key), validateFragmentProps(element, current, returnFiber), current;
            if (null !== current && (current.elementType === elementType || isCompatibleFamilyForHotReloading(current, element) || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), coerceRef(current, element), current.return = returnFiber, current._debugOwner = element._owner, current._debugInfo = currentDebugInfo, current;
            current = createFiberFromElement(element, returnFiber.mode, lanes);
            coerceRef(current, element);
            current.return = returnFiber;
            current._debugInfo = currentDebugInfo;
            return current;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current._debugInfo = currentDebugInfo, current;
            current = useFiber(current, portal.children || []);
            current.return = returnFiber;
            current._debugInfo = currentDebugInfo;
            return current;
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (null === current || 7 !== current.tag) return current = createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current._debugOwner = returnFiber, current._debugTask = returnFiber._debugTask, current._debugInfo = currentDebugInfo, current;
            current = useFiber(current, fragment);
            current.return = returnFiber;
            current._debugInfo = currentDebugInfo;
            return current;
        }
        function createChild(returnFiber, newChild, lanes) {
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild._debugOwner = returnFiber, newChild._debugTask = returnFiber._debugTask, newChild._debugInfo = currentDebugInfo, newChild;
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return lanes = createFiberFromElement(newChild, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = pushDebugInfo(newChild._debugInfo), lanes._debugInfo = currentDebugInfo, currentDebugInfo = returnFiber, lanes;
                    case REACT_PORTAL_TYPE:
                        return newChild = createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild._debugInfo = currentDebugInfo, newChild;
                    case REACT_LAZY_TYPE:
                        var _prevDebugInfo = pushDebugInfo(newChild._debugInfo);
                        newChild = resolveLazy(newChild);
                        returnFiber = createChild(returnFiber, newChild, lanes);
                        currentDebugInfo = _prevDebugInfo;
                        return returnFiber;
                }
                if (isArrayImpl(newChild) || getIteratorFn(newChild)) return lanes = createFiberFromFragment(newChild, returnFiber.mode, lanes, null), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, returnFiber = pushDebugInfo(newChild._debugInfo), lanes._debugInfo = currentDebugInfo, currentDebugInfo = returnFiber, lanes;
                if ("function" === typeof newChild.then) return _prevDebugInfo = pushDebugInfo(newChild._debugInfo), returnFiber = createChild(returnFiber, unwrapThenable(newChild), lanes), currentDebugInfo = _prevDebugInfo, returnFiber;
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return createChild(returnFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
            "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            var key = null !== oldFiber ? oldFiber.key : null;
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return newChild.key === key ? (key = pushDebugInfo(newChild._debugInfo), returnFiber = updateElement(returnFiber, oldFiber, newChild, lanes), currentDebugInfo = key, returnFiber) : null;
                    case REACT_PORTAL_TYPE:
                        return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                    case REACT_LAZY_TYPE:
                        return key = pushDebugInfo(newChild._debugInfo), newChild = resolveLazy(newChild), returnFiber = updateSlot(returnFiber, oldFiber, newChild, lanes), currentDebugInfo = key, returnFiber;
                }
                if (isArrayImpl(newChild) || getIteratorFn(newChild)) {
                    if (null !== key) return null;
                    key = pushDebugInfo(newChild._debugInfo);
                    returnFiber = updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                    currentDebugInfo = key;
                    return returnFiber;
                }
                if ("function" === typeof newChild.then) return key = pushDebugInfo(newChild._debugInfo), returnFiber = updateSlot(returnFiber, oldFiber, unwrapThenable(newChild), lanes), currentDebugInfo = key, returnFiber;
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
            "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return newIdx = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, existingChildren = pushDebugInfo(newChild._debugInfo), returnFiber = updateElement(returnFiber, newIdx, newChild, lanes), currentDebugInfo = existingChildren, returnFiber;
                    case REACT_PORTAL_TYPE:
                        return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                    case REACT_LAZY_TYPE:
                        var _prevDebugInfo7 = pushDebugInfo(newChild._debugInfo);
                        newChild = resolveLazy(newChild);
                        returnFiber = updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
                        currentDebugInfo = _prevDebugInfo7;
                        return returnFiber;
                }
                if (isArrayImpl(newChild) || getIteratorFn(newChild)) return newIdx = existingChildren.get(newIdx) || null, existingChildren = pushDebugInfo(newChild._debugInfo), returnFiber = updateFragment(returnFiber, newIdx, newChild, lanes, null), currentDebugInfo = existingChildren, returnFiber;
                if ("function" === typeof newChild.then) return _prevDebugInfo7 = pushDebugInfo(newChild._debugInfo), returnFiber = updateFromMap(existingChildren, returnFiber, newIdx, unwrapThenable(newChild), lanes), currentDebugInfo = _prevDebugInfo7, returnFiber;
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
            "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
            return null;
        }
        function warnOnInvalidKey(returnFiber, workInProgress, child, knownKeys) {
            if ("object" !== typeof child || null === child) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(returnFiber, workInProgress, child);
                    var key = child.key;
                    if ("string" !== typeof key) break;
                    if (null === knownKeys) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    runWithFiberInDEV(workInProgress, function() {
                        console.error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    });
                    break;
                case REACT_LAZY_TYPE:
                    child = resolveLazy(child), warnOnInvalidKey(returnFiber, workInProgress, child, knownKeys);
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            for(var knownKeys = null, resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
                oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (null === newFiber) {
                    null === oldFiber && (oldFiber = nextOldFiber);
                    break;
                }
                knownKeys = warnOnInvalidKey(returnFiber, newFiber, newChildren[newIdx], knownKeys);
                shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
                currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
                null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
            if (null === oldFiber) {
                for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (knownKeys = warnOnInvalidKey(returnFiber, oldFiber, newChildren[newIdx], knownKeys), currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
                isHydrating && pushTreeFork(returnFiber, newIdx);
                return resultingFirstChild;
            }
            for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (knownKeys = warnOnInvalidKey(returnFiber, nextOldFiber, newChildren[newIdx], knownKeys), shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
            shouldTrackSideEffects && oldFiber.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
            if (null == newChildren) throw Error("An iterable object provided no iterator.");
            for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, knownKeys = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
                oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (null === newFiber) {
                    null === oldFiber && (oldFiber = nextOldFiber);
                    break;
                }
                knownKeys = warnOnInvalidKey(returnFiber, newFiber, step.value, knownKeys);
                shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
                currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
                null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
            if (null === oldFiber) {
                for(; !step.done; newIdx++, step = newChildren.next())oldFiber = createChild(returnFiber, step.value, lanes), null !== oldFiber && (knownKeys = warnOnInvalidKey(returnFiber, oldFiber, step.value, knownKeys), currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
                isHydrating && pushTreeFork(returnFiber, newIdx);
                return resultingFirstChild;
            }
            for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== nextOldFiber && (knownKeys = warnOnInvalidKey(returnFiber, nextOldFiber, step.value, knownKeys), shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
            shouldTrackSideEffects && oldFiber.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
            "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE && null === newChild.key && (validateFragmentProps(newChild, null, returnFiber), newChild = newChild.props.children);
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var prevDebugInfo = pushDebugInfo(newChild._debugInfo);
                        a: {
                            for(var key = newChild.key; null !== currentFirstChild;){
                                if (currentFirstChild.key === key) {
                                    key = newChild.type;
                                    if (key === REACT_FRAGMENT_TYPE) {
                                        if (7 === currentFirstChild.tag) {
                                            deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                            lanes = useFiber(currentFirstChild, newChild.props.children);
                                            lanes.return = returnFiber;
                                            lanes._debugOwner = newChild._owner;
                                            lanes._debugInfo = currentDebugInfo;
                                            validateFragmentProps(newChild, lanes, returnFiber);
                                            returnFiber = lanes;
                                            break a;
                                        }
                                    } else if (currentFirstChild.elementType === key || isCompatibleFamilyForHotReloading(currentFirstChild, newChild) || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && resolveLazy(key) === currentFirstChild.type) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props);
                                        coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        lanes._debugOwner = newChild._owner;
                                        lanes._debugInfo = currentDebugInfo;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                } else deleteChild(returnFiber, currentFirstChild);
                                currentFirstChild = currentFirstChild.sibling;
                            }
                            newChild.type === REACT_FRAGMENT_TYPE ? (lanes = createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, lanes._debugInfo = currentDebugInfo, validateFragmentProps(newChild, lanes, returnFiber), returnFiber = lanes) : (lanes = createFiberFromElement(newChild, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes._debugInfo = currentDebugInfo, returnFiber = lanes);
                        }
                        returnFiber = placeSingleChild(returnFiber);
                        currentDebugInfo = prevDebugInfo;
                        return returnFiber;
                    case REACT_PORTAL_TYPE:
                        a: {
                            prevDebugInfo = newChild;
                            for(newChild = prevDebugInfo.key; null !== currentFirstChild;){
                                if (currentFirstChild.key === newChild) {
                                    if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === prevDebugInfo.containerInfo && currentFirstChild.stateNode.implementation === prevDebugInfo.implementation) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, prevDebugInfo.children || []);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    } else {
                                        deleteRemainingChildren(returnFiber, currentFirstChild);
                                        break;
                                    }
                                } else deleteChild(returnFiber, currentFirstChild);
                                currentFirstChild = currentFirstChild.sibling;
                            }
                            lanes = createFiberFromPortal(prevDebugInfo, returnFiber.mode, lanes);
                            lanes.return = returnFiber;
                            returnFiber = lanes;
                        }
                        return placeSingleChild(returnFiber);
                    case REACT_LAZY_TYPE:
                        return prevDebugInfo = pushDebugInfo(newChild._debugInfo), newChild = resolveLazy(newChild), returnFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes), currentDebugInfo = prevDebugInfo, returnFiber;
                }
                if (isArrayImpl(newChild)) return prevDebugInfo = pushDebugInfo(newChild._debugInfo), returnFiber = reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes), currentDebugInfo = prevDebugInfo, returnFiber;
                if (getIteratorFn(newChild)) {
                    prevDebugInfo = pushDebugInfo(newChild._debugInfo);
                    key = getIteratorFn(newChild);
                    if ("function" !== typeof key) throw Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
                    var newChildren = key.call(newChild);
                    if (newChildren === newChild) {
                        if (0 !== returnFiber.tag || "[object GeneratorFunction]" !== Object.prototype.toString.call(returnFiber.type) || "[object Generator]" !== Object.prototype.toString.call(newChildren)) didWarnAboutGenerators || console.error("Using Iterators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. You can also use an Iterable that can iterate multiple times over the same items."), didWarnAboutGenerators = !0;
                    } else newChild.entries !== key || didWarnAboutMaps || (console.error("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), didWarnAboutMaps = !0);
                    returnFiber = reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes);
                    currentDebugInfo = prevDebugInfo;
                    return returnFiber;
                }
                if ("function" === typeof newChild.then) return prevDebugInfo = pushDebugInfo(newChild._debugInfo), returnFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, unwrapThenable(newChild), lanes), currentDebugInfo = prevDebugInfo, returnFiber;
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return prevDebugInfo = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, prevDebugInfo), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(prevDebugInfo, returnFiber.mode, lanes), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, lanes._debugInfo = currentDebugInfo, returnFiber = lanes), placeSingleChild(returnFiber);
            "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
            "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return function(returnFiber, currentFirstChild, newChild, lanes) {
            var prevDebugInfo = currentDebugInfo;
            currentDebugInfo = null;
            try {
                thenableIndexCounter$1 = 0;
                var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
                thenableState$1 = null;
                return firstChildFiber;
            } catch (x) {
                if (x === SuspenseException || x === SuspenseActionException) throw x;
                var fiber = createFiber(29, x, null, returnFiber.mode);
                fiber.lanes = lanes;
                fiber.return = returnFiber;
                var debugInfo = fiber._debugInfo = currentDebugInfo;
                fiber._debugOwner = returnFiber._debugOwner;
                fiber._debugTask = returnFiber._debugTask;
                if (null != debugInfo) {
                    for(var i = debugInfo.length - 1; 0 <= i; i--)if ("string" === typeof debugInfo[i].stack) {
                        fiber._debugOwner = debugInfo[i];
                        fiber._debugTask = debugInfo[i].debugTask;
                        break;
                    }
                }
                return fiber;
            } finally{
                currentDebugInfo = prevDebugInfo;
            }
        };
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isAnArray = isArrayImpl(childSlot);
        childSlot = !isAnArray && "function" === typeof getIteratorFn(childSlot);
        return isAnArray || childSlot ? (isAnArray = isAnArray ? "array" : "iterable", console.error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", isAnArray, index, isAnArray), !1) : !0;
    }
    function initializeUpdateQueue(fiber) {
        fiber.updateQueue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                lanes: 0,
                hiddenCallbacks: null
            },
            callbacks: null
        };
    }
    function cloneUpdateQueue(current, workInProgress) {
        current = current.updateQueue;
        workInProgress.updateQueue === current && (workInProgress.updateQueue = {
            baseState: current.baseState,
            firstBaseUpdate: current.firstBaseUpdate,
            lastBaseUpdate: current.lastBaseUpdate,
            shared: current.shared,
            callbacks: null
        });
    }
    function createUpdate(lane) {
        return {
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
    }
    function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;
        if (null === updateQueue) return null;
        updateQueue = updateQueue.shared;
        if (currentlyProcessingQueue === updateQueue && !didWarnUpdateInsideUpdate) {
            var componentName = getComponentNameFromFiber(fiber);
            console.error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.\n\nPlease update the following component: %s", componentName);
            didWarnUpdateInsideUpdate = !0;
        }
        if ((executionContext & RenderContext) !== NoContext) return componentName = updateQueue.pending, null === componentName ? update.next = update : (update.next = componentName.next, componentName.next = update), updateQueue.pending = update, update = getRootForUpdatedFiber(fiber), markUpdateLaneFromFiberToRoot(fiber, null, lane), update;
        enqueueUpdate$1(fiber, updateQueue, update, lane);
        return getRootForUpdatedFiber(fiber);
    }
    function entangleTransitions(root, fiber, lane) {
        fiber = fiber.updateQueue;
        if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
            var queueLanes = fiber.lanes;
            queueLanes &= root.pendingLanes;
            lane |= queueLanes;
            fiber.lanes = lane;
            markRootEntangled(root, lane);
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        var queue = workInProgress.updateQueue, current = workInProgress.alternate;
        if (null !== current && (current = current.updateQueue, queue === current)) {
            var newFirst = null, newLast = null;
            queue = queue.firstBaseUpdate;
            if (null !== queue) {
                do {
                    var clone = {
                        lane: queue.lane,
                        tag: queue.tag,
                        payload: queue.payload,
                        callback: null,
                        next: null
                    };
                    null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                    queue = queue.next;
                }while (null !== queue);
                null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
            } else newFirst = newLast = capturedUpdate;
            queue = {
                baseState: current.baseState,
                firstBaseUpdate: newFirst,
                lastBaseUpdate: newLast,
                shared: current.shared,
                callbacks: current.callbacks
            };
            workInProgress.updateQueue = queue;
            return;
        }
        workInProgress = queue.lastBaseUpdate;
        null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function suspendIfUpdateReadFromEntangledAsyncAction() {
        if (didReadFromEntangledAsyncAction) {
            var entangledActionThenable = currentEntangledActionThenable;
            if (null !== entangledActionThenable) throw entangledActionThenable;
        }
    }
    function processUpdateQueue(workInProgress, props, instance$jscomp$0, renderLanes) {
        didReadFromEntangledAsyncAction = !1;
        var queue = workInProgress.updateQueue;
        hasForceUpdate = !1;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
        if (null !== pendingQueue) {
            queue.shared.pending = null;
            var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null;
            null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate;
            var current = workInProgress.alternate;
            null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
        }
        if (null !== firstBaseUpdate) {
            var newState = queue.baseState;
            lastBaseUpdate = 0;
            current = firstPendingUpdate = lastPendingUpdate = null;
            pendingQueue = firstBaseUpdate;
            do {
                var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
                if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                    0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                    null !== current && (current = current.next = {
                        lane: 0,
                        tag: pendingQueue.tag,
                        payload: pendingQueue.payload,
                        callback: null,
                        next: null
                    });
                    a: {
                        updateLane = workInProgress;
                        var partialState = pendingQueue;
                        var nextProps = props, instance = instance$jscomp$0;
                        switch(partialState.tag){
                            case ReplaceState:
                                partialState = partialState.payload;
                                if ("function" === typeof partialState) {
                                    isDisallowedContextReadInDEV = !0;
                                    var nextState = partialState.call(instance, newState, nextProps);
                                    if (updateLane.mode & StrictLegacyMode) {
                                        setIsStrictModeForDevtools(!0);
                                        try {
                                            partialState.call(instance, newState, nextProps);
                                        } finally{
                                            setIsStrictModeForDevtools(!1);
                                        }
                                    }
                                    isDisallowedContextReadInDEV = !1;
                                    newState = nextState;
                                    break a;
                                }
                                newState = partialState;
                                break a;
                            case CaptureUpdate:
                                updateLane.flags = updateLane.flags & -65537 | 128;
                            case UpdateState:
                                nextState = partialState.payload;
                                if ("function" === typeof nextState) {
                                    isDisallowedContextReadInDEV = !0;
                                    partialState = nextState.call(instance, newState, nextProps);
                                    if (updateLane.mode & StrictLegacyMode) {
                                        setIsStrictModeForDevtools(!0);
                                        try {
                                            nextState.call(instance, newState, nextProps);
                                        } finally{
                                            setIsStrictModeForDevtools(!1);
                                        }
                                    }
                                    isDisallowedContextReadInDEV = !1;
                                } else partialState = nextState;
                                if (null === partialState || void 0 === partialState) break a;
                                newState = assign({}, newState, partialState);
                                break a;
                            case ForceUpdate:
                                hasForceUpdate = !0;
                        }
                    }
                    updateLane = pendingQueue.callback;
                    null !== updateLane && (workInProgress.flags |= 64, isHiddenUpdate && (workInProgress.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                        updateLane
                    ] : isHiddenUpdate.push(updateLane));
                } else isHiddenUpdate = {
                    lane: updateLane,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: pendingQueue.callback,
                    next: null
                }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
                pendingQueue = pendingQueue.next;
                if (null === pendingQueue) {
                    if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                    else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
                }
            }while (1);
            null === current && (lastPendingUpdate = newState);
            queue.baseState = lastPendingUpdate;
            queue.firstBaseUpdate = firstPendingUpdate;
            queue.lastBaseUpdate = current;
            null === firstBaseUpdate && (queue.shared.lanes = 0);
            workInProgressRootSkippedLanes |= lastBaseUpdate;
            workInProgress.lanes = lastBaseUpdate;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if ("function" !== typeof callback) throw Error("Invalid argument passed as callback. Expected a function. Instead received: " + callback);
        callback.call(context);
    }
    function commitHiddenCallbacks(updateQueue, context) {
        var hiddenCallbacks = updateQueue.shared.hiddenCallbacks;
        if (null !== hiddenCallbacks) for(updateQueue.shared.hiddenCallbacks = null, updateQueue = 0; updateQueue < hiddenCallbacks.length; updateQueue++)callCallback(hiddenCallbacks[updateQueue], context);
    }
    function commitCallbacks(updateQueue, context) {
        var callbacks = updateQueue.callbacks;
        if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)callCallback(callbacks[updateQueue], context);
    }
    function pushHiddenContext(fiber, context) {
        var prevEntangledRenderLanes = entangledRenderLanes;
        push(prevEntangledRenderLanesCursor, prevEntangledRenderLanes, fiber);
        push(currentTreeHiddenStackCursor, context, fiber);
        entangledRenderLanes = prevEntangledRenderLanes | context.baseLanes;
    }
    function reuseHiddenContextOnStack(fiber) {
        push(prevEntangledRenderLanesCursor, entangledRenderLanes, fiber);
        push(currentTreeHiddenStackCursor, currentTreeHiddenStackCursor.current, fiber);
    }
    function popHiddenContext(fiber) {
        entangledRenderLanes = prevEntangledRenderLanesCursor.current;
        pop(currentTreeHiddenStackCursor, fiber);
        pop(prevEntangledRenderLanesCursor, fiber);
    }
    function pushPrimaryTreeSuspenseHandler(handler) {
        var current = handler.alternate;
        push(suspenseStackCursor, suspenseStackCursor.current & SubtreeSuspenseContextMask, handler);
        push(suspenseHandlerStackCursor, handler, handler);
        null === shellBoundary && (null === current || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current.memoizedState && (shellBoundary = handler));
    }
    function pushDehydratedActivitySuspenseHandler(fiber) {
        push(suspenseStackCursor, suspenseStackCursor.current, fiber);
        push(suspenseHandlerStackCursor, fiber, fiber);
        null === shellBoundary && (shellBoundary = fiber);
    }
    function pushOffscreenSuspenseHandler(fiber) {
        22 === fiber.tag ? (push(suspenseStackCursor, suspenseStackCursor.current, fiber), push(suspenseHandlerStackCursor, fiber, fiber), null === shellBoundary && (shellBoundary = fiber)) : reuseSuspenseHandlerOnStack(fiber);
    }
    function reuseSuspenseHandlerOnStack(fiber) {
        push(suspenseStackCursor, suspenseStackCursor.current, fiber);
        push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current, fiber);
    }
    function popSuspenseHandler(fiber) {
        pop(suspenseHandlerStackCursor, fiber);
        shellBoundary === fiber && (shellBoundary = null);
        pop(suspenseStackCursor, fiber);
    }
    function findFirstSuspended(row) {
        for(var node = row; null !== node;){
            if (13 === node.tag) {
                var state = node.memoizedState;
                if (null !== state && (state = state.dehydrated, null === state || isSuspenseInstancePending(state) || isSuspenseInstanceFallback(state))) return node;
            } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
                if (0 !== (node.flags & 128)) return node;
            } else if (null !== node.child) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        null === hookTypesDev ? hookTypesDev = [
            hookName
        ] : hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (null !== hookTypesDev && (hookTypesUpdateIndexDev++, hookTypesDev[hookTypesUpdateIndexDev] !== hookName)) {
            var componentName = getComponentNameFromFiber(currentlyRenderingFiber);
            if (!didWarnAboutMismatchedHooksForComponent.has(componentName) && (didWarnAboutMismatchedHooksForComponent.add(componentName), null !== hookTypesDev)) {
                for(var table = "", i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i], newHookName = i === hookTypesUpdateIndexDev ? hookName : oldHookName;
                    for(oldHookName = i + 1 + ". " + oldHookName; 30 > oldHookName.length;)oldHookName += " ";
                    oldHookName += newHookName + "\n";
                    table += oldHookName;
                }
                console.error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://react.dev/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function checkDepsAreArrayDev(deps) {
        void 0 === deps || null === deps || isArrayImpl(deps) || console.error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnUseFormStateInDev() {
        var componentName = getComponentNameFromFiber(currentlyRenderingFiber);
        didWarnAboutUseFormState.has(componentName) || (didWarnAboutUseFormState.add(componentName), console.error("ReactDOM.useFormState has been renamed to React.useActionState. Please update %s to use React.useActionState.", componentName));
    }
    function throwInvalidHookError() {
        throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) return !1;
        if (null === prevDeps) return console.error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev), !1;
        nextDeps.length !== prevDeps.length && console.error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(", ") + "]", "[" + nextDeps.join(", ") + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!objectIs(nextDeps[i], prevDeps[i])) return !1;
        return !0;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber = workInProgress;
        hookTypesDev = null !== current ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1;
        ignorePreviousDependencies = null !== current && current.type !== workInProgress.type;
        if ("[object AsyncFunction]" === Object.prototype.toString.call(Component) || "[object AsyncGeneratorFunction]" === Object.prototype.toString.call(Component)) nextRenderLanes = getComponentNameFromFiber(currentlyRenderingFiber), didWarnAboutAsyncClientComponent.has(nextRenderLanes) || (didWarnAboutAsyncClientComponent.add(nextRenderLanes), console.error("%s is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.", null === nextRenderLanes ? "An unknown Component" : "<" + nextRenderLanes + ">"));
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = 0;
        ReactSharedInternals.H = null !== current && null !== current.memoizedState ? HooksDispatcherOnUpdateInDEV : null !== hookTypesDev ? HooksDispatcherOnMountWithHookTypesInDEV : HooksDispatcherOnMountInDEV;
        shouldDoubleInvokeUserFnsInHooksDEV = nextRenderLanes = (workInProgress.mode & StrictLegacyMode) !== NoMode;
        var children = callComponentInDEV(Component, props, secondArg);
        shouldDoubleInvokeUserFnsInHooksDEV = !1;
        didScheduleRenderPhaseUpdateDuringThisPass && (children = renderWithHooksAgain(workInProgress, Component, props, secondArg));
        if (nextRenderLanes) {
            setIsStrictModeForDevtools(!0);
            try {
                children = renderWithHooksAgain(workInProgress, Component, props, secondArg);
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        finishRenderingHooks(current, workInProgress);
        return children;
    }
    function finishRenderingHooks(current, workInProgress) {
        workInProgress._debugHookTypes = hookTypesDev;
        null === workInProgress.dependencies ? null !== thenableState && (workInProgress.dependencies = {
            lanes: 0,
            firstContext: null,
            _debugThenableState: thenableState
        }) : workInProgress.dependencies._debugThenableState = thenableState;
        ReactSharedInternals.H = ContextOnlyDispatcher;
        var didRenderTooFewHooks = null !== currentHook && null !== currentHook.next;
        renderLanes = 0;
        hookTypesDev = currentHookNameInDev = workInProgressHook = currentHook = currentlyRenderingFiber = null;
        hookTypesUpdateIndexDev = -1;
        null !== current && (current.flags & 65011712) !== (workInProgress.flags & 65011712) && console.error("Internal React error: Expected static flag was missing. Please notify the React team.");
        didScheduleRenderPhaseUpdate = !1;
        thenableIndexCounter = 0;
        thenableState = null;
        if (didRenderTooFewHooks) throw Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        null === current || didReceiveUpdate || (current = current.dependencies, null !== current && checkIfContextChanged(current) && (didReceiveUpdate = !0));
        needsToResetSuspendedThenableDEV ? (needsToResetSuspendedThenableDEV = !1, current = !0) : current = !1;
        current && (workInProgress = getComponentNameFromFiber(workInProgress) || "Unknown", didWarnAboutUseWrappedInTryCatch.has(workInProgress) || didWarnAboutAsyncClientComponent.has(workInProgress) || (didWarnAboutUseWrappedInTryCatch.add(workInProgress), console.error("`use` was called from inside a try/catch block. This is not allowed and can lead to unexpected behavior. To handle errors triggered by `use`, wrap your component in a error boundary.")));
    }
    function renderWithHooksAgain(workInProgress, Component, props, secondArg) {
        currentlyRenderingFiber = workInProgress;
        var numberOfReRenders = 0;
        do {
            didScheduleRenderPhaseUpdateDuringThisPass && (thenableState = null);
            thenableIndexCounter = 0;
            didScheduleRenderPhaseUpdateDuringThisPass = !1;
            if (numberOfReRenders >= RE_RENDER_LIMIT) throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
            numberOfReRenders += 1;
            ignorePreviousDependencies = !1;
            workInProgressHook = currentHook = null;
            if (null != workInProgress.updateQueue) {
                var children = workInProgress.updateQueue;
                children.lastEffect = null;
                children.events = null;
                children.stores = null;
                null != children.memoCache && (children.memoCache.index = 0);
            }
            hookTypesUpdateIndexDev = -1;
            ReactSharedInternals.H = HooksDispatcherOnRerenderInDEV;
            children = callComponentInDEV(Component, props, secondArg);
        }while (didScheduleRenderPhaseUpdateDuringThisPass);
        return children;
    }
    function TransitionAwareHostComponent() {
        var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
        maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
        dispatcher = dispatcher.useState()[0];
        (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber.flags |= 1024);
        return maybeThenable;
    }
    function checkDidRenderIdHook() {
        var didRenderIdHook = 0 !== localIdCounter;
        localIdCounter = 0;
        return didRenderIdHook;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue;
        workInProgress.flags = (workInProgress.mode & StrictEffectsMode) !== NoMode ? workInProgress.flags & -402655237 : workInProgress.flags & -2053;
        current.lanes &= ~lanes;
    }
    function resetHooksOnUnwind(workInProgress) {
        if (didScheduleRenderPhaseUpdate) {
            for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
                var queue = workInProgress.queue;
                null !== queue && (queue.pending = null);
                workInProgress = workInProgress.next;
            }
            didScheduleRenderPhaseUpdate = !1;
        }
        renderLanes = 0;
        hookTypesDev = workInProgressHook = currentHook = currentlyRenderingFiber = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        didScheduleRenderPhaseUpdateDuringThisPass = !1;
        thenableIndexCounter = localIdCounter = 0;
        thenableState = null;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        if (null === currentHook) {
            var nextCurrentHook = currentlyRenderingFiber.alternate;
            nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber.memoizedState : workInProgressHook.next;
        if (null !== nextWorkInProgressHook) workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
        else {
            if (null === nextCurrentHook) {
                if (null === currentlyRenderingFiber.alternate) throw Error("Update hook called on initial render. This is likely a bug in React. Please file an issue.");
                throw Error("Rendered more hooks than during the previous render.");
            }
            currentHook = nextCurrentHook;
            nextCurrentHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null,
            events: null,
            stores: null,
            memoCache: null
        };
    }
    function useThenable(thenable) {
        var index = thenableIndexCounter;
        thenableIndexCounter += 1;
        null === thenableState && (thenableState = createThenableState());
        thenable = trackUsedThenable(thenableState, thenable, index);
        index = currentlyRenderingFiber;
        null === (null === workInProgressHook ? index.memoizedState : workInProgressHook.next) && (index = index.alternate, ReactSharedInternals.H = null !== index && null !== index.memoizedState ? HooksDispatcherOnUpdateInDEV : HooksDispatcherOnMountInDEV);
        return thenable;
    }
    function use(usable) {
        if (null !== usable && "object" === typeof usable) {
            if ("function" === typeof usable.then) return useThenable(usable);
            if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
        }
        throw Error("An unsupported type was passed to use(): " + String(usable));
    }
    function useMemoCache(size) {
        var memoCache = null, updateQueue = currentlyRenderingFiber.updateQueue;
        null !== updateQueue && (memoCache = updateQueue.memoCache);
        if (null == memoCache) {
            var current = currentlyRenderingFiber.alternate;
            null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
                data: current.data.map(function(array) {
                    return array.slice();
                }),
                index: 0
            })));
        }
        null == memoCache && (memoCache = {
            data: [],
            index: 0
        });
        null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = updateQueue);
        updateQueue.memoCache = memoCache;
        updateQueue = memoCache.data[memoCache.index];
        if (void 0 === updateQueue || ignorePreviousDependencies) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = REACT_MEMO_CACHE_SENTINEL;
        else updateQueue.length !== size && console.error("Expected a constant size argument for each invocation of useMemoCache. The previous cache was allocated with size %s but size %s was requested.", updateQueue.length, size);
        memoCache.index++;
        return updateQueue;
    }
    function basicStateReducer(state, action) {
        return "function" === typeof action ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    }
    function updateReducer(reducer) {
        var hook = updateWorkInProgressHook();
        return updateReducerImpl(hook, currentHook, reducer);
    }
    function updateReducerImpl(hook, current, reducer) {
        var queue = hook.queue;
        if (null === queue) throw Error("Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)");
        queue.lastRenderedReducer = reducer;
        var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
        if (null !== pendingQueue) {
            if (null !== baseQueue) {
                var baseFirst = baseQueue.next;
                baseQueue.next = pendingQueue.next;
                pendingQueue.next = baseFirst;
            }
            current.baseQueue !== baseQueue && console.error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        pendingQueue = hook.baseState;
        if (null === baseQueue) hook.memoizedState = pendingQueue;
        else {
            current = baseQueue.next;
            var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction = !1;
            do {
                var updateLane = update.lane & -536870913;
                if (updateLane !== update.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                    var revertLane = update.revertLane;
                    if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                        lane: 0,
                        revertLane: 0,
                        gesture: null,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                    else if ((renderLanes & revertLane) === revertLane) {
                        update = update.next;
                        revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                        continue;
                    } else updateLane = {
                        lane: 0,
                        revertLane: update.revertLane,
                        gesture: null,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
                    updateLane = update.action;
                    shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                    pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
                } else revertLane = {
                    lane: updateLane,
                    revertLane: update.revertLane,
                    gesture: update.gesture,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
                update = update.next;
            }while (null !== update && update !== current);
            null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
            if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = !0, didReadFromEntangledAsyncAction && (reducer = currentEntangledActionThenable, null !== reducer))) throw reducer;
            hook.memoizedState = pendingQueue;
            hook.baseState = baseFirst;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = pendingQueue;
        }
        null === baseQueue && (queue.lanes = 0);
        return [
            hook.memoizedState,
            queue.dispatch
        ];
    }
    function rerenderReducer(reducer) {
        var hook = updateWorkInProgressHook(), queue = hook.queue;
        if (null === queue) throw Error("Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)");
        queue.lastRenderedReducer = reducer;
        var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
        if (null !== lastRenderPhaseUpdate) {
            queue.pending = null;
            var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            do newState = reducer(newState, update.action), update = update.next;
            while (update !== lastRenderPhaseUpdate);
            objectIs(newState, hook.memoizedState) || (didReceiveUpdate = !0);
            hook.memoizedState = newState;
            null === hook.baseQueue && (hook.baseState = newState);
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber, hook = mountWorkInProgressHook();
        if (isHydrating) {
            if (void 0 === getServerSnapshot) throw Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            var nextSnapshot = getServerSnapshot();
            didWarnUncachedGetSnapshot || nextSnapshot === getServerSnapshot() || (console.error("The result of getServerSnapshot should be cached to avoid an infinite loop"), didWarnUncachedGetSnapshot = !0);
        } else {
            nextSnapshot = getSnapshot();
            didWarnUncachedGetSnapshot || (getServerSnapshot = getSnapshot(), objectIs(nextSnapshot, getServerSnapshot) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), didWarnUncachedGetSnapshot = !0));
            if (null === workInProgressRoot) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            0 !== (workInProgressRootRenderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        }
        hook.memoizedState = nextSnapshot;
        getServerSnapshot = {
            value: nextSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = getServerSnapshot;
        mountEffect(subscribeToStore.bind(null, fiber, getServerSnapshot, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        pushSimpleEffect(HasEffect | Passive, {
            destroy: void 0
        }, updateStoreInstance.bind(null, fiber, getServerSnapshot, nextSnapshot, getSnapshot), null);
        return nextSnapshot;
    }
    function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
        if (isHydrating$jscomp$0) {
            if (void 0 === getServerSnapshot) throw Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            getServerSnapshot = getServerSnapshot();
        } else if (getServerSnapshot = getSnapshot(), !didWarnUncachedGetSnapshot) {
            var cachedSnapshot = getSnapshot();
            objectIs(getServerSnapshot, cachedSnapshot) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), didWarnUncachedGetSnapshot = !0);
        }
        if (cachedSnapshot = !objectIs((currentHook || hook).memoizedState, getServerSnapshot)) hook.memoizedState = getServerSnapshot, didReceiveUpdate = !0;
        hook = hook.queue;
        var create = subscribeToStore.bind(null, fiber, hook, subscribe);
        updateEffectImpl(2048, Passive, create, [
            subscribe
        ]);
        if (hook.getSnapshot !== getSnapshot || cachedSnapshot || null !== workInProgressHook && workInProgressHook.memoizedState.tag & HasEffect) {
            fiber.flags |= 2048;
            pushSimpleEffect(HasEffect | Passive, {
                destroy: void 0
            }, updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
            if (null === workInProgressRoot) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            isHydrating$jscomp$0 || 0 !== (renderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        return getServerSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= 16384;
        fiber = {
            getSnapshot: getSnapshot,
            value: renderedSnapshot
        };
        getSnapshot = currentlyRenderingFiber.updateQueue;
        null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
            fiber
        ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
            fiber
        ] : renderedSnapshot.push(fiber));
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe) {
        return subscribe(function() {
            checkIfSnapshotChanged(inst) && (startUpdateTimerByLane(2, "updateSyncExternalStore()", fiber), forceStoreRerender(fiber));
        });
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        inst = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(inst, nextValue);
        } catch (error) {
            return !0;
        }
    }
    function forceStoreRerender(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, 2);
        null !== root && scheduleUpdateOnFiber(root, fiber, 2);
    }
    function mountStateImpl(initialState) {
        var hook = mountWorkInProgressHook();
        if ("function" === typeof initialState) {
            var initialStateInitializer = initialState;
            initialState = initialStateInitializer();
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    initialStateInitializer();
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
        }
        hook.memoizedState = hook.baseState = initialState;
        hook.queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        return hook;
    }
    function mountState(initialState) {
        initialState = mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    }
    function mountOptimistic(passthrough) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    }
    function updateOptimistic(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
    }
    function updateOptimisticImpl(hook, current, passthrough, reducer) {
        hook.baseState = passthrough;
        return updateReducerImpl(hook, currentHook, "function" === typeof reducer ? reducer : basicStateReducer);
    }
    function rerenderOptimistic(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        if (null !== currentHook) return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    }
    function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
        if (isRenderPhaseUpdate(fiber)) throw Error("Cannot update form state while rendering.");
        fiber = actionQueue.action;
        if (null !== fiber) {
            var actionNode = {
                payload: payload,
                action: fiber,
                next: null,
                isTransition: !0,
                status: "pending",
                value: null,
                reason: null,
                listeners: [],
                then: function(listener) {
                    actionNode.listeners.push(listener);
                }
            };
            null !== ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
            setState(actionNode);
            setPendingState = actionQueue.pending;
            null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
        }
    }
    function runActionStateAction(actionQueue, node) {
        var action = node.action, payload = node.payload, prevState = actionQueue.state;
        if (node.isTransition) {
            var prevTransition = ReactSharedInternals.T, currentTransition = {};
            currentTransition._updatedFibers = new Set();
            ReactSharedInternals.T = currentTransition;
            try {
                var returnValue = action(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
                null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
                handleActionReturnValue(actionQueue, node, returnValue);
            } catch (error) {
                onActionError(actionQueue, node, error);
            } finally{
                null !== prevTransition && null !== currentTransition.types && (null !== prevTransition.types && prevTransition.types !== currentTransition.types && console.error("We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."), prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition, null === prevTransition && currentTransition._updatedFibers && (actionQueue = currentTransition._updatedFibers.size, currentTransition._updatedFibers.clear(), 10 < actionQueue && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."));
            }
        } else try {
            currentTransition = action(prevState, payload), handleActionReturnValue(actionQueue, node, currentTransition);
        } catch (error$4) {
            onActionError(actionQueue, node, error$4);
        }
    }
    function handleActionReturnValue(actionQueue, node, returnValue) {
        null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? (ReactSharedInternals.asyncTransitions++, returnValue.then(releaseAsyncTransition, releaseAsyncTransition), returnValue.then(function(nextState) {
            onActionSuccess(actionQueue, node, nextState);
        }, function(error) {
            return onActionError(actionQueue, node, error);
        }), node.isTransition || console.error("An async function with useActionState was called outside of a transition. This is likely not what you intended (for example, isPending will not update correctly). Either call the returned function inside startTransition, or pass it to an `action` or `formAction` prop.")) : onActionSuccess(actionQueue, node, returnValue);
    }
    function onActionSuccess(actionQueue, actionNode, nextState) {
        actionNode.status = "fulfilled";
        actionNode.value = nextState;
        notifyActionListeners(actionNode);
        actionQueue.state = nextState;
        actionNode = actionQueue.pending;
        null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
    }
    function onActionError(actionQueue, actionNode, error) {
        var last = actionQueue.pending;
        actionQueue.pending = null;
        if (null !== last) {
            last = last.next;
            do actionNode.status = "rejected", actionNode.reason = error, notifyActionListeners(actionNode), actionNode = actionNode.next;
            while (actionNode !== last);
        }
        actionQueue.action = null;
    }
    function notifyActionListeners(actionNode) {
        actionNode = actionNode.listeners;
        for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
    }
    function actionStateReducer(oldState, newState) {
        return newState;
    }
    function mountActionState(action, initialStateProp) {
        if (isHydrating) {
            var ssrFormState = workInProgressRoot.formState;
            if (null !== ssrFormState) {
                a: {
                    var isMatching = currentlyRenderingFiber;
                    if (isHydrating) {
                        if (nextHydratableInstance) {
                            b: {
                                var markerInstance = nextHydratableInstance;
                                for(var inRootOrSingleton = rootOrSingletonContext; 8 !== markerInstance.nodeType;){
                                    if (!inRootOrSingleton) {
                                        markerInstance = null;
                                        break b;
                                    }
                                    markerInstance = getNextHydratable(markerInstance.nextSibling);
                                    if (null === markerInstance) {
                                        markerInstance = null;
                                        break b;
                                    }
                                }
                                inRootOrSingleton = markerInstance.data;
                                markerInstance = inRootOrSingleton === FORM_STATE_IS_MATCHING || inRootOrSingleton === FORM_STATE_IS_NOT_MATCHING ? markerInstance : null;
                            }
                            if (markerInstance) {
                                nextHydratableInstance = getNextHydratable(markerInstance.nextSibling);
                                isMatching = markerInstance.data === FORM_STATE_IS_MATCHING;
                                break a;
                            }
                        }
                        throwOnHydrationMismatch(isMatching);
                    }
                    isMatching = !1;
                }
                isMatching && (initialStateProp = ssrFormState[0]);
            }
        }
        ssrFormState = mountWorkInProgressHook();
        ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
        isMatching = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: actionStateReducer,
            lastRenderedState: initialStateProp
        };
        ssrFormState.queue = isMatching;
        ssrFormState = dispatchSetState.bind(null, currentlyRenderingFiber, isMatching);
        isMatching.dispatch = ssrFormState;
        isMatching = mountStateImpl(!1);
        inRootOrSingleton = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !1, isMatching.queue);
        isMatching = mountWorkInProgressHook();
        markerInstance = {
            state: initialStateProp,
            dispatch: null,
            action: action,
            pending: null
        };
        isMatching.queue = markerInstance;
        ssrFormState = dispatchActionState.bind(null, currentlyRenderingFiber, markerInstance, inRootOrSingleton, ssrFormState);
        markerInstance.dispatch = ssrFormState;
        isMatching.memoizedState = action;
        return [
            initialStateProp,
            ssrFormState,
            !1
        ];
    }
    function updateActionState(action) {
        var stateHook = updateWorkInProgressHook();
        return updateActionStateImpl(stateHook, currentHook, action);
    }
    function updateActionStateImpl(stateHook, currentStateHook, action) {
        currentStateHook = updateReducerImpl(stateHook, currentStateHook, actionStateReducer)[0];
        stateHook = updateReducer(basicStateReducer)[0];
        if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
            var state = useThenable(currentStateHook);
        } catch (x) {
            if (x === SuspenseException) throw SuspenseActionException;
            throw x;
        }
        else state = currentStateHook;
        currentStateHook = updateWorkInProgressHook();
        var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
        action !== currentStateHook.memoizedState && (currentlyRenderingFiber.flags |= 2048, pushSimpleEffect(HasEffect | Passive, {
            destroy: void 0
        }, actionStateActionEffect.bind(null, actionQueue, action), null));
        return [
            state,
            dispatch,
            stateHook
        ];
    }
    function actionStateActionEffect(actionQueue, action) {
        actionQueue.action = action;
    }
    function rerenderActionState(action) {
        var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
        if (null !== currentStateHook) return updateActionStateImpl(stateHook, currentStateHook, action);
        updateWorkInProgressHook();
        stateHook = stateHook.memoizedState;
        currentStateHook = updateWorkInProgressHook();
        var dispatch = currentStateHook.queue.dispatch;
        currentStateHook.memoizedState = action;
        return [
            stateHook,
            dispatch,
            !1
        ];
    }
    function pushSimpleEffect(tag, inst, create, deps) {
        tag = {
            tag: tag,
            create: create,
            deps: deps,
            inst: inst,
            next: null
        };
        inst = currentlyRenderingFiber.updateQueue;
        null === inst && (inst = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = inst);
        create = inst.lastEffect;
        null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
        return tag;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        currentlyRenderingFiber.flags |= fiberFlags;
        hook.memoizedState = pushSimpleEffect(HasEffect | hookFlags, {
            destroy: void 0
        }, create, void 0 === deps ? null : deps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var inst = hook.memoizedState.inst;
        null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushSimpleEffect(hookFlags, inst, create, deps) : (currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = pushSimpleEffect(HasEffect | hookFlags, inst, create, deps));
    }
    function mountEffect(create, deps) {
        (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode ? mountEffectImpl(276826112, Passive, create, deps) : mountEffectImpl(8390656, Passive, create, deps);
    }
    function useEffectEventImpl(payload) {
        currentlyRenderingFiber.flags |= 4;
        var componentUpdateQueue = currentlyRenderingFiber.updateQueue;
        if (null === componentUpdateQueue) componentUpdateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
            payload
        ];
        else {
            var events = componentUpdateQueue.events;
            null === events ? componentUpdateQueue.events = [
                payload
            ] : events.push(payload);
        }
    }
    function mountEvent(callback) {
        var hook = mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if ((executionContext & RenderContext) !== NoContext) throw Error("A function wrapped in useEffectEvent can't be called during rendering.");
            return ref.impl.apply(void 0, arguments);
        };
    }
    function updateEvent(callback) {
        var ref = updateWorkInProgressHook().memoizedState;
        useEffectEventImpl({
            ref: ref,
            nextImpl: callback
        });
        return function() {
            if ((executionContext & RenderContext) !== NoContext) throw Error("A function wrapped in useEffectEvent can't be called during rendering.");
            return ref.impl.apply(void 0, arguments);
        };
    }
    function mountLayoutEffect(create, deps) {
        var fiberFlags = 4194308;
        (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode && (fiberFlags |= 134217728);
        return mountEffectImpl(fiberFlags, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if ("function" === typeof ref) {
            create = create();
            var refCleanup = ref(create);
            return function() {
                "function" === typeof refCleanup ? refCleanup() : ref(null);
            };
        }
        if (null !== ref && void 0 !== ref) return ref.hasOwnProperty("current") || console.error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(ref).join(", ") + "}"), create = create(), ref.current = create, function() {
            ref.current = null;
        };
    }
    function mountImperativeHandle(ref, create, deps) {
        "function" !== typeof create && console.error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", null !== create ? typeof create : "null");
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        var fiberFlags = 4194308;
        (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode && (fiberFlags |= 134217728);
        mountEffectImpl(fiberFlags, Layout, imperativeHandleEffect.bind(null, create, ref), deps);
    }
    function updateImperativeHandle(ref, create, deps) {
        "function" !== typeof create && console.error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", null !== create ? typeof create : "null");
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        updateEffectImpl(4, Layout, imperativeHandleEffect.bind(null, create, ref), deps);
    }
    function mountCallback(callback, deps) {
        mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var prevState = hook.memoizedState;
        if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
        hook.memoizedState = [
            callback,
            deps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var prevState = hook.memoizedState;
        if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
        prevState = nextCreate();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            prevState,
            deps
        ];
        return prevState;
    }
    function mountDeferredValue(value, initialValue) {
        var hook = mountWorkInProgressHook();
        return mountDeferredValueImpl(hook, value, initialValue);
    }
    function updateDeferredValue(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    }
    function rerenderDeferredValue(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    }
    function mountDeferredValueImpl(hook, value, initialValue) {
        if (void 0 === initialValue || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
        hook.memoizedState = initialValue;
        hook = requestDeferredLane();
        currentlyRenderingFiber.lanes |= hook;
        workInProgressRootSkippedLanes |= hook;
        return initialValue;
    }
    function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
        if (objectIs(value, prevValue)) return value;
        if (null !== currentTreeHiddenStackCursor.current) return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = !0), hook;
        if (0 === (renderLanes & 42) || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930)) return didReceiveUpdate = !0, hook.memoizedState = value;
        hook = requestDeferredLane();
        currentlyRenderingFiber.lanes |= hook;
        workInProgressRootSkippedLanes |= hook;
        return prevValue;
    }
    function releaseAsyncTransition() {
        ReactSharedInternals.asyncTransitions--;
    }
    function startTransition(fiber, queue, pendingState, finishedState, callback) {
        var previousPriority = ReactDOMSharedInternals.p;
        ReactDOMSharedInternals.p = 0 !== previousPriority && previousPriority < ContinuousEventPriority ? previousPriority : ContinuousEventPriority;
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        currentTransition._updatedFibers = new Set();
        ReactSharedInternals.T = currentTransition;
        dispatchOptimisticSetState(fiber, !1, queue, pendingState);
        try {
            var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
                ReactSharedInternals.asyncTransitions++;
                returnValue.then(releaseAsyncTransition, releaseAsyncTransition);
                var thenableForFinishedState = chainThenableValue(returnValue, finishedState);
                dispatchSetStateInternal(fiber, queue, thenableForFinishedState, requestUpdateLane(fiber));
            } else dispatchSetStateInternal(fiber, queue, finishedState, requestUpdateLane(fiber));
        } catch (error) {
            dispatchSetStateInternal(fiber, queue, {
                then: function() {},
                status: "rejected",
                reason: error
            }, requestUpdateLane(fiber));
        } finally{
            ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (null !== prevTransition.types && prevTransition.types !== currentTransition.types && console.error("We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."), prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition, null === prevTransition && currentTransition._updatedFibers && (fiber = currentTransition._updatedFibers.size, currentTransition._updatedFibers.clear(), 10 < fiber && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."));
        }
    }
    function startHostTransition(formFiber, pendingState, action, formData) {
        if (5 !== formFiber.tag) throw Error("Expected the form instance to be a HostComponent. This is a bug in React.");
        var queue = ensureFormComponentIsStateful(formFiber).queue;
        startHostActionTimer(formFiber);
        startTransition(formFiber, queue, pendingState, NotPendingTransition, null === action ? noop : function() {
            requestFormReset$1(formFiber);
            return action(formData);
        });
    }
    function ensureFormComponentIsStateful(formFiber) {
        var existingStateHook = formFiber.memoizedState;
        if (null !== existingStateHook) return existingStateHook;
        existingStateHook = {
            memoizedState: NotPendingTransition,
            baseState: NotPendingTransition,
            baseQueue: null,
            queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: basicStateReducer,
                lastRenderedState: NotPendingTransition
            },
            next: null
        };
        var initialResetState = {};
        existingStateHook.next = {
            memoizedState: initialResetState,
            baseState: initialResetState,
            baseQueue: null,
            queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: basicStateReducer,
                lastRenderedState: initialResetState
            },
            next: null
        };
        formFiber.memoizedState = existingStateHook;
        formFiber = formFiber.alternate;
        null !== formFiber && (formFiber.memoizedState = existingStateHook);
        return existingStateHook;
    }
    function requestFormReset$1(formFiber) {
        null === ReactSharedInternals.T && console.error("requestFormReset was called outside a transition or action. To fix, move to an action, or wrap with startTransition.");
        var stateHook = ensureFormComponentIsStateful(formFiber);
        null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
        dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, requestUpdateLane(formFiber));
    }
    function mountTransition() {
        var stateHook = mountStateImpl(!1);
        stateHook = startTransition.bind(null, currentlyRenderingFiber, stateHook.queue, !0, !1);
        mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    }
    function updateTransition() {
        var booleanOrThenable = updateReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    }
    function rerenderTransition() {
        var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    }
    function useHostTransitionStatus() {
        return readContext(HostTransitionContext);
    }
    function mountId() {
        var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
        if (isHydrating) {
            var treeId = treeContextOverflow;
            var idWithLeadingBit = treeContextId;
            treeId = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + treeId;
            identifierPrefix = "_" + identifierPrefix + "R_" + treeId;
            treeId = localIdCounter++;
            0 < treeId && (identifierPrefix += "H" + treeId.toString(32));
            identifierPrefix += "_";
        } else treeId = globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + treeId.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    }
    function mountRefresh() {
        return mountWorkInProgressHook().memoizedState = refreshCache.bind(null, currentlyRenderingFiber);
    }
    function refreshCache(fiber, seedKey) {
        for(var provider = fiber.return; null !== provider;){
            switch(provider.tag){
                case 24:
                case 3:
                    var lane = requestUpdateLane(provider), refreshUpdate = createUpdate(lane), root = enqueueUpdate(provider, refreshUpdate, lane);
                    null !== root && (startUpdateTimerByLane(lane, "refresh()", fiber), scheduleUpdateOnFiber(root, provider, lane), entangleTransitions(root, provider, lane));
                    fiber = createCache();
                    null !== seedKey && void 0 !== seedKey && null !== root && console.error("The seed argument is not enabled outside experimental channels.");
                    refreshUpdate.payload = {
                        cache: fiber
                    };
                    return;
            }
            provider = provider.return;
        }
    }
    function dispatchReducerAction(fiber, queue, action) {
        var args = arguments;
        "function" === typeof args[3] && console.error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        args = requestUpdateLane(fiber);
        var update = {
            lane: args,
            revertLane: 0,
            gesture: null,
            action: action,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue, update) : (update = enqueueConcurrentHookUpdate(fiber, queue, update, args), null !== update && (startUpdateTimerByLane(args, "dispatch()", fiber), scheduleUpdateOnFiber(update, fiber, args), entangleTransitionUpdate(update, queue, args)));
    }
    function dispatchSetState(fiber, queue, action) {
        var args = arguments;
        "function" === typeof args[3] && console.error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        args = requestUpdateLane(fiber);
        dispatchSetStateInternal(fiber, queue, action, args) && startUpdateTimerByLane(args, "setState()", fiber);
    }
    function dispatchSetStateInternal(fiber, queue, action, lane) {
        var update = {
            lane: lane,
            revertLane: 0,
            gesture: null,
            action: action,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var alternate = fiber.alternate;
            if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) {
                var prevDispatcher = ReactSharedInternals.H;
                ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
                try {
                    var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
                    update.hasEagerState = !0;
                    update.eagerState = eagerState;
                    if (objectIs(eagerState, currentState)) return enqueueUpdate$1(fiber, queue, update, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), !1;
                } catch (error) {} finally{
                    ReactSharedInternals.H = prevDispatcher;
                }
            }
            action = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (null !== action) return scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane), !0;
        }
        return !1;
    }
    function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
        null === ReactSharedInternals.T && 0 === currentEntangledLane && console.error("An optimistic state update occurred outside a transition or action. To fix, move the update to an action, or wrap with startTransition.");
        action = {
            lane: 2,
            revertLane: requestTransitionLane(),
            gesture: null,
            action: action,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) {
            if (throwIfDuringRender) throw Error("Cannot update optimistic state while rendering.");
            console.error("Cannot call startTransition while rendering.");
        } else throwIfDuringRender = enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && (startUpdateTimerByLane(2, "setOptimistic()", fiber), scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2));
    }
    function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber || null !== alternate && alternate === currentlyRenderingFiber;
    }
    function enqueueRenderPhaseUpdate(queue, update) {
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = !0;
        var pending = queue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        queue.pending = update;
    }
    function entangleTransitionUpdate(root, queue, lane) {
        if (0 !== (lane & 4194048)) {
            var queueLanes = queue.lanes;
            queueLanes &= root.pendingLanes;
            lane |= queueLanes;
            queue.lanes = lane;
            markRootEntangled(root, lane);
        }
    }
    function warnOnInvalidCallback(callback) {
        if (null !== callback && "function" !== typeof callback) {
            var key = String(callback);
            didWarnOnInvalidCallback.has(key) || (didWarnOnInvalidCallback.add(key), console.error("Expected the last optional `callback` argument to be a function. Instead received: %s.", callback));
        }
    }
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState, partialState = getDerivedStateFromProps(nextProps, prevState);
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(!0);
            try {
                partialState = getDerivedStateFromProps(nextProps, prevState);
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        void 0 === partialState && (ctor = getComponentNameFromType(ctor) || "Component", didWarnAboutUndefinedDerivedState.has(ctor) || (didWarnAboutUndefinedDerivedState.add(ctor), console.error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", ctor)));
        prevState = null === partialState || void 0 === partialState ? prevState : assign({}, prevState, partialState);
        workInProgress.memoizedState = prevState;
        0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = prevState);
    }
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if ("function" === typeof instance.shouldComponentUpdate) {
            oldProps = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(!0);
                try {
                    oldProps = instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
            void 0 === oldProps && console.error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentNameFromType(ctor) || "Component");
            return oldProps;
        }
        return ctor.prototype && ctor.prototype.isPureReactComponent ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState) : !0;
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
        "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        instance.state !== oldState && (workInProgress = getComponentNameFromFiber(workInProgress) || "Component", didWarnAboutStateAssignmentForComponent.has(workInProgress) || (didWarnAboutStateAssignmentForComponent.add(workInProgress), console.error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", workInProgress)), classComponentUpdater.enqueueReplaceState(instance, instance.state, null));
    }
    function resolveClassComponentProps(Component, baseProps) {
        var newProps = baseProps;
        if ("ref" in baseProps) {
            newProps = {};
            for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
        }
        if (Component = Component.defaultProps) {
            newProps === baseProps && (newProps = assign({}, newProps));
            for(var _propName in Component)void 0 === newProps[_propName] && (newProps[_propName] = Component[_propName]);
        }
        return newProps;
    }
    function defaultOnUncaughtError(error) {
        reportGlobalError(error);
        console.warn("%s\n\n%s\n", componentName ? "An error occurred in the <" + componentName + "> component." : "An error occurred in one of your React components.", "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://react.dev/link/error-boundaries to learn more about error boundaries.");
    }
    function defaultOnCaughtError(error) {
        var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component." : "The above error occurred in one of your React components.", recreateMessage = "React will try to recreate this component tree from scratch using the error boundary you provided, " + ((errorBoundaryName || "Anonymous") + ".");
        if ("object" === typeof error && null !== error && "string" === typeof error.environmentName) {
            var JSCompiler_inline_result = error.environmentName;
            error = [
                "%o\n\n%s\n\n%s\n",
                error,
                componentNameMessage,
                recreateMessage
            ].slice(0);
            "string" === typeof error[0] ? error.splice(0, 1, badgeFormat + " " + error[0], badgeStyle, pad + JSCompiler_inline_result + pad, resetStyle) : error.splice(0, 0, badgeFormat, badgeStyle, pad + JSCompiler_inline_result + pad, resetStyle);
            error.unshift(console);
            JSCompiler_inline_result = bind.apply(console.error, error);
            JSCompiler_inline_result();
        } else console.error("%o\n\n%s\n\n%s\n", error, componentNameMessage, recreateMessage);
    }
    function defaultOnRecoverableError(error) {
        reportGlobalError(error);
    }
    function logUncaughtError(root, errorInfo) {
        try {
            componentName = errorInfo.source ? getComponentNameFromFiber(errorInfo.source) : null;
            errorBoundaryName = null;
            var error = errorInfo.value;
            if (null !== ReactSharedInternals.actQueue) ReactSharedInternals.thrownErrors.push(error);
            else {
                var onUncaughtError = root.onUncaughtError;
                onUncaughtError(error, {
                    componentStack: errorInfo.stack
                });
            }
        } catch (e$5) {
            setTimeout(function() {
                throw e$5;
            });
        }
    }
    function logCaughtError(root, boundary, errorInfo) {
        try {
            componentName = errorInfo.source ? getComponentNameFromFiber(errorInfo.source) : null;
            errorBoundaryName = getComponentNameFromFiber(boundary);
            var onCaughtError = root.onCaughtError;
            onCaughtError(errorInfo.value, {
                componentStack: errorInfo.stack,
                errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
            });
        } catch (e$6) {
            setTimeout(function() {
                throw e$6;
            });
        }
    }
    function createRootErrorUpdate(root, errorInfo, lane) {
        lane = createUpdate(lane);
        lane.tag = CaptureUpdate;
        lane.payload = {
            element: null
        };
        lane.callback = function() {
            runWithFiberInDEV(errorInfo.source, logUncaughtError, root, errorInfo);
        };
        return lane;
    }
    function createClassErrorUpdate(lane) {
        lane = createUpdate(lane);
        lane.tag = CaptureUpdate;
        return lane;
    }
    function initializeClassErrorUpdate(update, root, fiber, errorInfo) {
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if ("function" === typeof getDerivedStateFromError) {
            var error = errorInfo.value;
            update.payload = function() {
                return getDerivedStateFromError(error);
            };
            update.callback = function() {
                markFailedErrorBoundaryForHotReloading(fiber);
                runWithFiberInDEV(errorInfo.source, logCaughtError, root, fiber, errorInfo);
            };
        }
        var inst = fiber.stateNode;
        null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
            markFailedErrorBoundaryForHotReloading(fiber);
            runWithFiberInDEV(errorInfo.source, logCaughtError, root, fiber, errorInfo);
            "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = new Set([
                this
            ]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
            callComponentDidCatchInDEV(this, errorInfo);
            "function" === typeof getDerivedStateFromError || 0 === (fiber.lanes & 2) && console.error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentNameFromFiber(fiber) || "Unknown");
        });
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        sourceFiber.flags |= 32768;
        isDevToolsPresent && restorePendingUpdaters(root, rootRenderLanes);
        if (null !== value && "object" === typeof value && "function" === typeof value.then) {
            returnFiber = sourceFiber.alternate;
            null !== returnFiber && propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
            isHydrating && (didSuspendOrErrorDEV = !0);
            sourceFiber = suspenseHandlerStackCursor.current;
            if (null !== sourceFiber) {
                switch(sourceFiber.tag){
                    case 31:
                    case 13:
                        return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && workInProgressRootExitStatus === RootInProgress && (workInProgressRootExitStatus = RootSuspended), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                            value
                        ]) : returnFiber.add(value), attachPingListener(root, value, rootRenderLanes)), !1;
                    case 22:
                        return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                            transitions: null,
                            markerInstances: null,
                            retryQueue: new Set([
                                value
                            ])
                        }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                            value
                        ]) : sourceFiber.add(value)), attachPingListener(root, value, rootRenderLanes)), !1;
                }
                throw Error("Unexpected Suspense handler tag (" + sourceFiber.tag + "). This is a bug in React.");
            }
            attachPingListener(root, value, rootRenderLanes);
            renderDidSuspendDelayIfPossible();
            return !1;
        }
        if (isHydrating) return didSuspendOrErrorDEV = !0, returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && queueHydrationError(createCapturedValueAtFiber(Error("There was an error while hydrating but React was able to recover by instead client rendering from the nearest Suspense boundary.", {
            cause: value
        }), sourceFiber))) : (value !== HydrationMismatchException && queueHydrationError(createCapturedValueAtFiber(Error("There was an error while hydrating but React was able to recover by instead client rendering the entire root.", {
            cause: value
        }), sourceFiber)), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(root.stateNode, value, rootRenderLanes), enqueueCapturedUpdate(root, rootRenderLanes), workInProgressRootExitStatus !== RootSuspendedWithDelay && (workInProgressRootExitStatus = RootErrored)), !1;
        var error = createCapturedValueAtFiber(Error("There was an error during concurrent rendering but React was able to recover by instead synchronously rendering the entire root.", {
            cause: value
        }), sourceFiber);
        null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [
            error
        ] : workInProgressRootConcurrentErrors.push(error);
        workInProgressRootExitStatus !== RootSuspendedWithDelay && (workInProgressRootExitStatus = RootErrored);
        if (null === returnFiber) return !0;
        value = createCapturedValueAtFiber(value, sourceFiber);
        sourceFiber = returnFiber;
        do {
            switch(sourceFiber.tag){
                case 3:
                    return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = createRootErrorUpdate(sourceFiber.stateNode, value, root), enqueueCapturedUpdate(sourceFiber, root), !1;
                case 1:
                    if (returnFiber = sourceFiber.type, error = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== error && "function" === typeof error.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(error)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
            }
            sourceFiber = sourceFiber.return;
        }while (null !== sourceFiber);
        return !1;
    }
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        workInProgress.child = null === current ? mountChildFibers(workInProgress, null, nextChildren, renderLanes) : reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        Component = Component.render;
        var ref = workInProgress.ref;
        if ("ref" in nextProps) {
            var propsWithoutRef = {};
            for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
        } else propsWithoutRef = nextProps;
        prepareToReadContext(workInProgress);
        nextProps = renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
        key = checkDidRenderIdHook();
        if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        isHydrating && key && pushMaterializedTreeId(workInProgress);
        workInProgress.flags |= 1;
        reconcileChildren(current, workInProgress, nextProps, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (null === current) {
            var type = Component.type;
            if ("function" === typeof type && !shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return Component = resolveFunctionForHotReloading(type), workInProgress.tag = 15, workInProgress.type = Component, validateFunctionComponentInDev(workInProgress, type), updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes);
            current = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            current.ref = workInProgress.ref;
            current.return = workInProgress;
            return workInProgress.child = current;
        }
        type = current.child;
        if (!checkScheduledUpdateOrContext(current, renderLanes)) {
            var prevProps = type.memoizedProps;
            Component = Component.compare;
            Component = null !== Component ? Component : shallowEqual;
            if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        workInProgress.flags |= 1;
        current = createWorkInProgress(type, nextProps);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (null !== current) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                if (didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && (didReceiveUpdate = !0);
                else return workInProgress.lanes = current.lanes, bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
        var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
        null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
            _visibility: OffscreenVisible,
            _pendingMarkers: null,
            _retryCache: null,
            _transitions: null
        });
        if ("hidden" === nextProps.mode) {
            if (0 !== (workInProgress.flags & 128)) {
                prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
                if (null !== current) {
                    nextProps = workInProgress.child = current.child;
                    for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                    nextProps = nextChildren & ~prevState;
                } else nextProps = 0, workInProgress.child = null;
                return deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
            }
            if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, null !== current && pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? pushHiddenContext(workInProgress, prevState) : reuseHiddenContextOnStack(workInProgress), pushOffscreenSuspenseHandler(workInProgress);
            else return nextProps = workInProgress.lanes = 536870912, deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
        } else null !== prevState ? (pushTransition(workInProgress, prevState.cachePool), pushHiddenContext(workInProgress, prevState), reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && pushTransition(workInProgress, null), reuseHiddenContextOnStack(workInProgress), reuseSuspenseHandlerOnStack(workInProgress));
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function bailoutOffscreenComponent(current, workInProgress) {
        null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
            _visibility: OffscreenVisible,
            _pendingMarkers: null,
            _retryCache: null,
            _transitions: null
        });
        return workInProgress.sibling;
    }
    function deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
        var JSCompiler_inline_result = peekCacheFromPool();
        JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
            parent: CacheContext._currentValue,
            pool: JSCompiler_inline_result
        };
        workInProgress.memoizedState = {
            baseLanes: nextBaseLanes,
            cachePool: JSCompiler_inline_result
        };
        null !== current && pushTransition(workInProgress, null);
        reuseHiddenContextOnStack(workInProgress);
        pushOffscreenSuspenseHandler(workInProgress);
        null !== current && propagateParentContextChanges(current, workInProgress, renderLanes, !0);
        workInProgress.childLanes = remainingChildLanes;
        return null;
    }
    function mountActivityChildren(workInProgress, nextProps) {
        var hiddenProp = nextProps.hidden;
        void 0 !== hiddenProp && console.error('<Activity> doesn\'t accept a hidden prop. Use mode="hidden" instead.\n- <Activity %s>\n+ <Activity %s>', !0 === hiddenProp ? "hidden" : !1 === hiddenProp ? "hidden={false}" : "hidden={...}", hiddenProp ? 'mode="hidden"' : 'mode="visible"');
        nextProps = mountWorkInProgressOffscreenFiber({
            mode: nextProps.mode,
            children: nextProps.children
        }, workInProgress.mode);
        nextProps.ref = workInProgress.ref;
        workInProgress.child = nextProps;
        nextProps.return = workInProgress;
        return nextProps;
    }
    function retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        current = mountActivityChildren(workInProgress, workInProgress.pendingProps);
        current.flags |= 2;
        popSuspenseHandler(workInProgress);
        workInProgress.memoizedState = null;
        return current;
    }
    function updateActivityComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
        workInProgress.flags &= -129;
        if (null === current) {
            if (isHydrating) {
                if ("hidden" === nextProps.mode) return current = mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, bailoutOffscreenComponent(null, current);
                pushDehydratedActivitySuspenseHandler(workInProgress);
                (current = nextHydratableInstance) ? (renderLanes = canHydrateHydrationBoundary(current, rootOrSingletonContext), renderLanes = null !== renderLanes && renderLanes.data === ACTIVITY_START_DATA ? renderLanes : null, null !== renderLanes && (nextProps = {
                    dehydrated: renderLanes,
                    treeContext: getSuspendedTreeContext(),
                    retryLane: 536870912,
                    hydrationErrors: null
                }, workInProgress.memoizedState = nextProps, nextProps = createFiberFromDehydratedFragment(renderLanes), nextProps.return = workInProgress, workInProgress.child = nextProps, hydrationParentFiber = workInProgress, nextHydratableInstance = null)) : renderLanes = null;
                if (null === renderLanes) throw warnNonHydratedInstance(workInProgress, current), throwOnHydrationMismatch(workInProgress);
                workInProgress.lanes = 536870912;
                return null;
            }
            return mountActivityChildren(workInProgress, nextProps);
        }
        var prevState = current.memoizedState;
        if (null !== prevState) {
            var activityInstance = prevState.dehydrated;
            pushDehydratedActivitySuspenseHandler(workInProgress);
            if (didSuspend) {
                if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
                else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
                else throw Error("Client rendering an Activity suspended it again. This is a bug in React.");
            } else if (warnIfHydrating(), 0 !== (renderLanes & 536870912) && markRenderDerivedCause(workInProgress), didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || didSuspend) {
                nextProps = workInProgressRoot;
                if (null !== nextProps && (activityInstance = getBumpedLaneForHydration(nextProps, renderLanes), 0 !== activityInstance && activityInstance !== prevState.retryLane)) throw prevState.retryLane = activityInstance, enqueueConcurrentRenderForLane(current, activityInstance), scheduleUpdateOnFiber(nextProps, current, activityInstance), SelectiveHydrationException;
                renderDidSuspendDelayIfPossible();
                workInProgress = retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            } else current = prevState.treeContext, nextHydratableInstance = getNextHydratable(activityInstance.nextSibling), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, didSuspendOrErrorDEV = !1, hydrationDiffRootDEV = null, rootOrSingletonContext = !1, null !== current && restoreSuspendedTreeContext(workInProgress, current), workInProgress = mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
            return workInProgress;
        }
        prevState = current.child;
        nextProps = {
            mode: nextProps.mode,
            children: nextProps.children
        };
        0 !== (renderLanes & 536870912) && 0 !== (renderLanes & current.lanes) && markRenderDerivedCause(workInProgress);
        current = createWorkInProgress(prevState, nextProps);
        current.ref = workInProgress.ref;
        workInProgress.child = current;
        current.return = workInProgress;
        return current;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
        else {
            if ("function" !== typeof ref && "object" !== typeof ref) throw Error("Expected ref to be a function, an object returned by React.createRef(), or undefined/null.");
            if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
        }
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (Component.prototype && "function" === typeof Component.prototype.render) {
            var componentName = getComponentNameFromType(Component) || "Unknown";
            didWarnAboutBadClass[componentName] || (console.error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName), didWarnAboutBadClass[componentName] = !0);
        }
        workInProgress.mode & StrictLegacyMode && ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        null === current && (validateFunctionComponentInDev(workInProgress, workInProgress.type), Component.contextTypes && (componentName = getComponentNameFromType(Component) || "Unknown", didWarnAboutContextTypes[componentName] || (didWarnAboutContextTypes[componentName] = !0, console.error("%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with React.useContext() instead. (https://react.dev/link/legacy-context)", componentName))));
        prepareToReadContext(workInProgress);
        Component = renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
        nextProps = checkDidRenderIdHook();
        if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        isHydrating && nextProps && pushMaterializedTreeId(workInProgress);
        workInProgress.flags |= 1;
        reconcileChildren(current, workInProgress, Component, renderLanes);
        return workInProgress.child;
    }
    function replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
        prepareToReadContext(workInProgress);
        hookTypesUpdateIndexDev = -1;
        ignorePreviousDependencies = null !== current && current.type !== workInProgress.type;
        workInProgress.updateQueue = null;
        nextProps = renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
        finishRenderingHooks(current, workInProgress);
        Component = checkDidRenderIdHook();
        if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        isHydrating && Component && pushMaterializedTreeId(workInProgress);
        workInProgress.flags |= 1;
        reconcileChildren(current, workInProgress, nextProps, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        switch(shouldErrorImpl(workInProgress)){
            case !1:
                var _instance = workInProgress.stateNode, state = new workInProgress.type(workInProgress.memoizedProps, _instance.context).state;
                _instance.updater.enqueueSetState(_instance, state, null);
                break;
            case !0:
                workInProgress.flags |= 128;
                workInProgress.flags |= 65536;
                _instance = Error("Simulated error coming from DevTools");
                var lane = renderLanes & -renderLanes;
                workInProgress.lanes |= lane;
                state = workInProgressRoot;
                if (null === state) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
                lane = createClassErrorUpdate(lane);
                initializeClassErrorUpdate(lane, state, workInProgress, createCapturedValueAtFiber(_instance, workInProgress));
                enqueueCapturedUpdate(workInProgress, lane);
        }
        prepareToReadContext(workInProgress);
        if (null === workInProgress.stateNode) {
            state = emptyContextObject;
            _instance = Component.contextType;
            "contextType" in Component && null !== _instance && (void 0 === _instance || _instance.$$typeof !== REACT_CONTEXT_TYPE) && !didWarnAboutInvalidateContextType.has(Component) && (didWarnAboutInvalidateContextType.add(Component), lane = void 0 === _instance ? " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : "object" !== typeof _instance ? " However, it is set to a " + typeof _instance + "." : _instance.$$typeof === REACT_CONSUMER_TYPE ? " Did you accidentally pass the Context.Consumer instead?" : " However, it is set to an object with keys {" + Object.keys(_instance).join(", ") + "}.", console.error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(Component) || "Component", lane));
            "object" === typeof _instance && null !== _instance && (state = readContext(_instance));
            _instance = new Component(nextProps, state);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(!0);
                try {
                    _instance = new Component(nextProps, state);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
            state = workInProgress.memoizedState = null !== _instance.state && void 0 !== _instance.state ? _instance.state : null;
            _instance.updater = classComponentUpdater;
            workInProgress.stateNode = _instance;
            _instance._reactInternals = workInProgress;
            _instance._reactInternalInstance = fakeInternalInstance;
            "function" === typeof Component.getDerivedStateFromProps && null === state && (state = getComponentNameFromType(Component) || "Component", didWarnAboutUninitializedState.has(state) || (didWarnAboutUninitializedState.add(state), console.error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", state, null === _instance.state ? "null" : "undefined", state)));
            if ("function" === typeof Component.getDerivedStateFromProps || "function" === typeof _instance.getSnapshotBeforeUpdate) {
                var foundWillUpdateName = lane = state = null;
                "function" === typeof _instance.componentWillMount && !0 !== _instance.componentWillMount.__suppressDeprecationWarning ? state = "componentWillMount" : "function" === typeof _instance.UNSAFE_componentWillMount && (state = "UNSAFE_componentWillMount");
                "function" === typeof _instance.componentWillReceiveProps && !0 !== _instance.componentWillReceiveProps.__suppressDeprecationWarning ? lane = "componentWillReceiveProps" : "function" === typeof _instance.UNSAFE_componentWillReceiveProps && (lane = "UNSAFE_componentWillReceiveProps");
                "function" === typeof _instance.componentWillUpdate && !0 !== _instance.componentWillUpdate.__suppressDeprecationWarning ? foundWillUpdateName = "componentWillUpdate" : "function" === typeof _instance.UNSAFE_componentWillUpdate && (foundWillUpdateName = "UNSAFE_componentWillUpdate");
                if (null !== state || null !== lane || null !== foundWillUpdateName) {
                    _instance = getComponentNameFromType(Component) || "Component";
                    var newApiName = "function" === typeof Component.getDerivedStateFromProps ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                    didWarnAboutLegacyLifecyclesAndDerivedState.has(_instance) || (didWarnAboutLegacyLifecyclesAndDerivedState.add(_instance), console.error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://react.dev/link/unsafe-component-lifecycles", _instance, newApiName, null !== state ? "\n  " + state : "", null !== lane ? "\n  " + lane : "", null !== foundWillUpdateName ? "\n  " + foundWillUpdateName : ""));
                }
            }
            _instance = workInProgress.stateNode;
            state = getComponentNameFromType(Component) || "Component";
            _instance.render || (Component.prototype && "function" === typeof Component.prototype.render ? console.error("No `render` method found on the %s instance: did you accidentally return an object from the constructor?", state) : console.error("No `render` method found on the %s instance: you may have forgotten to define `render`.", state));
            !_instance.getInitialState || _instance.getInitialState.isReactClassApproved || _instance.state || console.error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", state);
            _instance.getDefaultProps && !_instance.getDefaultProps.isReactClassApproved && console.error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", state);
            _instance.contextType && console.error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", state);
            Component.childContextTypes && !didWarnAboutChildContextTypes.has(Component) && (didWarnAboutChildContextTypes.add(Component), console.error("%s uses the legacy childContextTypes API which was removed in React 19. Use React.createContext() instead. (https://react.dev/link/legacy-context)", state));
            Component.contextTypes && !didWarnAboutContextTypes$1.has(Component) && (didWarnAboutContextTypes$1.add(Component), console.error("%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with static contextType instead. (https://react.dev/link/legacy-context)", state));
            "function" === typeof _instance.componentShouldUpdate && console.error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", state);
            Component.prototype && Component.prototype.isPureReactComponent && "undefined" !== typeof _instance.shouldComponentUpdate && console.error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(Component) || "A pure component");
            "function" === typeof _instance.componentDidUnmount && console.error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", state);
            "function" === typeof _instance.componentDidReceiveProps && console.error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", state);
            "function" === typeof _instance.componentWillRecieveProps && console.error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", state);
            "function" === typeof _instance.UNSAFE_componentWillRecieveProps && console.error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", state);
            lane = _instance.props !== nextProps;
            void 0 !== _instance.props && lane && console.error("When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", state);
            _instance.defaultProps && console.error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", state, state);
            "function" !== typeof _instance.getSnapshotBeforeUpdate || "function" === typeof _instance.componentDidUpdate || didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(Component) || (didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(Component), console.error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(Component)));
            "function" === typeof _instance.getDerivedStateFromProps && console.error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", state);
            "function" === typeof _instance.getDerivedStateFromError && console.error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", state);
            "function" === typeof Component.getSnapshotBeforeUpdate && console.error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", state);
            (lane = _instance.state) && ("object" !== typeof lane || isArrayImpl(lane)) && console.error("%s.state: must be set to an object or null", state);
            "function" === typeof _instance.getChildContext && "object" !== typeof Component.childContextTypes && console.error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", state);
            _instance = workInProgress.stateNode;
            _instance.props = nextProps;
            _instance.state = workInProgress.memoizedState;
            _instance.refs = {};
            initializeUpdateQueue(workInProgress);
            state = Component.contextType;
            _instance.context = "object" === typeof state && null !== state ? readContext(state) : emptyContextObject;
            _instance.state === nextProps && (state = getComponentNameFromType(Component) || "Component", didWarnAboutDirectlyAssigningPropsToState.has(state) || (didWarnAboutDirectlyAssigningPropsToState.add(state), console.error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", state)));
            workInProgress.mode & StrictLegacyMode && ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, _instance);
            ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, _instance);
            _instance.state = workInProgress.memoizedState;
            state = Component.getDerivedStateFromProps;
            "function" === typeof state && (applyDerivedStateFromProps(workInProgress, Component, state, nextProps), _instance.state = workInProgress.memoizedState);
            "function" === typeof Component.getDerivedStateFromProps || "function" === typeof _instance.getSnapshotBeforeUpdate || "function" !== typeof _instance.UNSAFE_componentWillMount && "function" !== typeof _instance.componentWillMount || (state = _instance.state, "function" === typeof _instance.componentWillMount && _instance.componentWillMount(), "function" === typeof _instance.UNSAFE_componentWillMount && _instance.UNSAFE_componentWillMount(), state !== _instance.state && (console.error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromFiber(workInProgress) || "Component"), classComponentUpdater.enqueueReplaceState(_instance, _instance.state, null)), processUpdateQueue(workInProgress, nextProps, _instance, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction(), _instance.state = workInProgress.memoizedState);
            "function" === typeof _instance.componentDidMount && (workInProgress.flags |= 4194308);
            (workInProgress.mode & StrictEffectsMode) !== NoMode && (workInProgress.flags |= 134217728);
            _instance = !0;
        } else if (null === current) {
            _instance = workInProgress.stateNode;
            var unresolvedOldProps = workInProgress.memoizedProps;
            lane = resolveClassComponentProps(Component, unresolvedOldProps);
            _instance.props = lane;
            var oldContext = _instance.context;
            foundWillUpdateName = Component.contextType;
            state = emptyContextObject;
            "object" === typeof foundWillUpdateName && null !== foundWillUpdateName && (state = readContext(foundWillUpdateName));
            newApiName = Component.getDerivedStateFromProps;
            foundWillUpdateName = "function" === typeof newApiName || "function" === typeof _instance.getSnapshotBeforeUpdate;
            unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
            foundWillUpdateName || "function" !== typeof _instance.UNSAFE_componentWillReceiveProps && "function" !== typeof _instance.componentWillReceiveProps || (unresolvedOldProps || oldContext !== state) && callComponentWillReceiveProps(workInProgress, _instance, nextProps, state);
            hasForceUpdate = !1;
            var oldState = workInProgress.memoizedState;
            _instance.state = oldState;
            processUpdateQueue(workInProgress, nextProps, _instance, renderLanes);
            suspendIfUpdateReadFromEntangledAsyncAction();
            oldContext = workInProgress.memoizedState;
            unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof newApiName && (applyDerivedStateFromProps(workInProgress, Component, newApiName, nextProps), oldContext = workInProgress.memoizedState), (lane = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, lane, nextProps, oldState, oldContext, state)) ? (foundWillUpdateName || "function" !== typeof _instance.UNSAFE_componentWillMount && "function" !== typeof _instance.componentWillMount || ("function" === typeof _instance.componentWillMount && _instance.componentWillMount(), "function" === typeof _instance.UNSAFE_componentWillMount && _instance.UNSAFE_componentWillMount()), "function" === typeof _instance.componentDidMount && (workInProgress.flags |= 4194308), (workInProgress.mode & StrictEffectsMode) !== NoMode && (workInProgress.flags |= 134217728)) : ("function" === typeof _instance.componentDidMount && (workInProgress.flags |= 4194308), (workInProgress.mode & StrictEffectsMode) !== NoMode && (workInProgress.flags |= 134217728), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), _instance.props = nextProps, _instance.state = oldContext, _instance.context = state, _instance = lane) : ("function" === typeof _instance.componentDidMount && (workInProgress.flags |= 4194308), (workInProgress.mode & StrictEffectsMode) !== NoMode && (workInProgress.flags |= 134217728), _instance = !1);
        } else {
            _instance = workInProgress.stateNode;
            cloneUpdateQueue(current, workInProgress);
            state = workInProgress.memoizedProps;
            foundWillUpdateName = resolveClassComponentProps(Component, state);
            _instance.props = foundWillUpdateName;
            newApiName = workInProgress.pendingProps;
            oldState = _instance.context;
            oldContext = Component.contextType;
            lane = emptyContextObject;
            "object" === typeof oldContext && null !== oldContext && (lane = readContext(oldContext));
            unresolvedOldProps = Component.getDerivedStateFromProps;
            (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof _instance.getSnapshotBeforeUpdate) || "function" !== typeof _instance.UNSAFE_componentWillReceiveProps && "function" !== typeof _instance.componentWillReceiveProps || (state !== newApiName || oldState !== lane) && callComponentWillReceiveProps(workInProgress, _instance, nextProps, lane);
            hasForceUpdate = !1;
            oldState = workInProgress.memoizedState;
            _instance.state = oldState;
            processUpdateQueue(workInProgress, nextProps, _instance, renderLanes);
            suspendIfUpdateReadFromEntangledAsyncAction();
            var newState = workInProgress.memoizedState;
            state !== newApiName || oldState !== newState || hasForceUpdate || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (foundWillUpdateName = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, foundWillUpdateName, nextProps, oldState, newState, lane) || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof _instance.UNSAFE_componentWillUpdate && "function" !== typeof _instance.componentWillUpdate || ("function" === typeof _instance.componentWillUpdate && _instance.componentWillUpdate(nextProps, newState, lane), "function" === typeof _instance.UNSAFE_componentWillUpdate && _instance.UNSAFE_componentWillUpdate(nextProps, newState, lane)), "function" === typeof _instance.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof _instance.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof _instance.componentDidUpdate || state === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof _instance.getSnapshotBeforeUpdate || state === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), _instance.props = nextProps, _instance.state = newState, _instance.context = lane, _instance = foundWillUpdateName) : ("function" !== typeof _instance.componentDidUpdate || state === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof _instance.getSnapshotBeforeUpdate || state === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), _instance = !1);
        }
        lane = _instance;
        markRef(current, workInProgress);
        state = 0 !== (workInProgress.flags & 128);
        if (lane || state) {
            lane = workInProgress.stateNode;
            setCurrentFiber(workInProgress);
            if (state && "function" !== typeof Component.getDerivedStateFromError) Component = null, profilerStartTime = -1;
            else if (Component = callRenderInDEV(lane), workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(!0);
                try {
                    callRenderInDEV(lane);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
            workInProgress.flags |= 1;
            null !== current && state ? (workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = reconcileChildFibers(workInProgress, null, Component, renderLanes)) : reconcileChildren(current, workInProgress, Component, renderLanes);
            workInProgress.memoizedState = lane.state;
            current = workInProgress.child;
        } else current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        renderLanes = workInProgress.stateNode;
        _instance && renderLanes.props !== nextProps && (didWarnAboutReassigningProps || console.error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromFiber(workInProgress) || "a component"), didWarnAboutReassigningProps = !0);
        return current;
    }
    function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
        resetHydrationState();
        workInProgress.flags |= 256;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        Component && Component.childContextTypes && console.error("childContextTypes cannot be defined on a function component.\n  %s.childContextTypes = ...", Component.displayName || Component.name || "Component");
        "function" === typeof Component.getDerivedStateFromProps && (workInProgress = getComponentNameFromType(Component) || "Unknown", didWarnAboutGetDerivedStateOnFunctionComponent[workInProgress] || (console.error("%s: Function components do not support getDerivedStateFromProps.", workInProgress), didWarnAboutGetDerivedStateOnFunctionComponent[workInProgress] = !0));
        "object" === typeof Component.contextType && null !== Component.contextType && (Component = getComponentNameFromType(Component) || "Unknown", didWarnAboutContextTypeOnFunctionComponent[Component] || (console.error("%s: Function components do not support contextType.", Component), didWarnAboutContextTypeOnFunctionComponent[Component] = !0));
    }
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes,
            cachePool: getSuspendedCache()
        };
    }
    function getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
        current = null !== current ? current.childLanes & ~renderLanes : 0;
        primaryTreeDidDefer && (current |= workInProgressDeferredLane);
        return current;
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var JSCompiler_object_inline_digest_2724;
        var JSCompiler_object_inline_stack_2725 = workInProgress.pendingProps;
        shouldSuspendImpl(workInProgress) && (workInProgress.flags |= 128);
        var JSCompiler_object_inline_message_2723 = !1;
        var didSuspend = 0 !== (workInProgress.flags & 128);
        (JSCompiler_object_inline_digest_2724 = didSuspend) || (JSCompiler_object_inline_digest_2724 = null !== current && null === current.memoizedState ? !1 : 0 !== (suspenseStackCursor.current & ForceSuspenseFallback));
        JSCompiler_object_inline_digest_2724 && (JSCompiler_object_inline_message_2723 = !0, workInProgress.flags &= -129);
        JSCompiler_object_inline_digest_2724 = 0 !== (workInProgress.flags & 32);
        workInProgress.flags &= -33;
        if (null === current) {
            if (isHydrating) {
                JSCompiler_object_inline_message_2723 ? pushPrimaryTreeSuspenseHandler(workInProgress) : reuseSuspenseHandlerOnStack(workInProgress);
                (current = nextHydratableInstance) ? (renderLanes = canHydrateHydrationBoundary(current, rootOrSingletonContext), renderLanes = null !== renderLanes && renderLanes.data !== ACTIVITY_START_DATA ? renderLanes : null, null !== renderLanes && (JSCompiler_object_inline_digest_2724 = {
                    dehydrated: renderLanes,
                    treeContext: getSuspendedTreeContext(),
                    retryLane: 536870912,
                    hydrationErrors: null
                }, workInProgress.memoizedState = JSCompiler_object_inline_digest_2724, JSCompiler_object_inline_digest_2724 = createFiberFromDehydratedFragment(renderLanes), JSCompiler_object_inline_digest_2724.return = workInProgress, workInProgress.child = JSCompiler_object_inline_digest_2724, hydrationParentFiber = workInProgress, nextHydratableInstance = null)) : renderLanes = null;
                if (null === renderLanes) throw warnNonHydratedInstance(workInProgress, current), throwOnHydrationMismatch(workInProgress);
                isSuspenseInstanceFallback(renderLanes) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
                return null;
            }
            var nextPrimaryChildren = JSCompiler_object_inline_stack_2725.children;
            JSCompiler_object_inline_stack_2725 = JSCompiler_object_inline_stack_2725.fallback;
            if (JSCompiler_object_inline_message_2723) {
                reuseSuspenseHandlerOnStack(workInProgress);
                var mode = workInProgress.mode;
                nextPrimaryChildren = mountWorkInProgressOffscreenFiber({
                    mode: "hidden",
                    children: nextPrimaryChildren
                }, mode);
                JSCompiler_object_inline_stack_2725 = createFiberFromFragment(JSCompiler_object_inline_stack_2725, mode, renderLanes, null);
                nextPrimaryChildren.return = workInProgress;
                JSCompiler_object_inline_stack_2725.return = workInProgress;
                nextPrimaryChildren.sibling = JSCompiler_object_inline_stack_2725;
                workInProgress.child = nextPrimaryChildren;
                JSCompiler_object_inline_stack_2725 = workInProgress.child;
                JSCompiler_object_inline_stack_2725.memoizedState = mountSuspenseOffscreenState(renderLanes);
                JSCompiler_object_inline_stack_2725.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_object_inline_digest_2724, renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return bailoutOffscreenComponent(null, JSCompiler_object_inline_stack_2725);
            }
            pushPrimaryTreeSuspenseHandler(workInProgress);
            return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
        }
        var prevState = current.memoizedState;
        if (null !== prevState) {
            var JSCompiler_object_inline_componentStack_2726 = prevState.dehydrated;
            if (null !== JSCompiler_object_inline_componentStack_2726) {
                if (didSuspend) workInProgress.flags & 256 ? (pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? (reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : (reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = JSCompiler_object_inline_stack_2725.fallback, mode = workInProgress.mode, JSCompiler_object_inline_stack_2725 = mountWorkInProgressOffscreenFiber({
                    mode: "visible",
                    children: JSCompiler_object_inline_stack_2725.children
                }, mode), nextPrimaryChildren = createFiberFromFragment(nextPrimaryChildren, mode, renderLanes, null), nextPrimaryChildren.flags |= 2, JSCompiler_object_inline_stack_2725.return = workInProgress, nextPrimaryChildren.return = workInProgress, JSCompiler_object_inline_stack_2725.sibling = nextPrimaryChildren, workInProgress.child = JSCompiler_object_inline_stack_2725, reconcileChildFibers(workInProgress, current.child, null, renderLanes), JSCompiler_object_inline_stack_2725 = workInProgress.child, JSCompiler_object_inline_stack_2725.memoizedState = mountSuspenseOffscreenState(renderLanes), JSCompiler_object_inline_stack_2725.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_object_inline_digest_2724, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, workInProgress = bailoutOffscreenComponent(null, JSCompiler_object_inline_stack_2725));
                else if (pushPrimaryTreeSuspenseHandler(workInProgress), warnIfHydrating(), 0 !== (renderLanes & 536870912) && markRenderDerivedCause(workInProgress), isSuspenseInstanceFallback(JSCompiler_object_inline_componentStack_2726)) {
                    JSCompiler_object_inline_digest_2724 = JSCompiler_object_inline_componentStack_2726.nextSibling && JSCompiler_object_inline_componentStack_2726.nextSibling.dataset;
                    if (JSCompiler_object_inline_digest_2724) {
                        nextPrimaryChildren = JSCompiler_object_inline_digest_2724.dgst;
                        var message = JSCompiler_object_inline_digest_2724.msg;
                        mode = JSCompiler_object_inline_digest_2724.stck;
                        var componentStack = JSCompiler_object_inline_digest_2724.cstck;
                    }
                    JSCompiler_object_inline_message_2723 = message;
                    JSCompiler_object_inline_digest_2724 = nextPrimaryChildren;
                    JSCompiler_object_inline_stack_2725 = mode;
                    JSCompiler_object_inline_componentStack_2726 = componentStack;
                    nextPrimaryChildren = JSCompiler_object_inline_message_2723;
                    mode = JSCompiler_object_inline_componentStack_2726;
                    nextPrimaryChildren = nextPrimaryChildren ? Error(nextPrimaryChildren) : Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
                    nextPrimaryChildren.stack = JSCompiler_object_inline_stack_2725 || "";
                    nextPrimaryChildren.digest = JSCompiler_object_inline_digest_2724;
                    JSCompiler_object_inline_digest_2724 = void 0 === mode ? null : mode;
                    JSCompiler_object_inline_stack_2725 = {
                        value: nextPrimaryChildren,
                        source: null,
                        stack: JSCompiler_object_inline_digest_2724
                    };
                    "string" === typeof JSCompiler_object_inline_digest_2724 && CapturedStacks.set(nextPrimaryChildren, JSCompiler_object_inline_stack_2725);
                    queueHydrationError(JSCompiler_object_inline_stack_2725);
                    workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
                } else if (didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_object_inline_digest_2724 = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || JSCompiler_object_inline_digest_2724) {
                    JSCompiler_object_inline_digest_2724 = workInProgressRoot;
                    if (null !== JSCompiler_object_inline_digest_2724 && (JSCompiler_object_inline_stack_2725 = getBumpedLaneForHydration(JSCompiler_object_inline_digest_2724, renderLanes), 0 !== JSCompiler_object_inline_stack_2725 && JSCompiler_object_inline_stack_2725 !== prevState.retryLane)) throw prevState.retryLane = JSCompiler_object_inline_stack_2725, enqueueConcurrentRenderForLane(current, JSCompiler_object_inline_stack_2725), scheduleUpdateOnFiber(JSCompiler_object_inline_digest_2724, current, JSCompiler_object_inline_stack_2725), SelectiveHydrationException;
                    isSuspenseInstancePending(JSCompiler_object_inline_componentStack_2726) || renderDidSuspendDelayIfPossible();
                    workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
                } else isSuspenseInstancePending(JSCompiler_object_inline_componentStack_2726) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, nextHydratableInstance = getNextHydratable(JSCompiler_object_inline_componentStack_2726.nextSibling), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, didSuspendOrErrorDEV = !1, hydrationDiffRootDEV = null, rootOrSingletonContext = !1, null !== current && restoreSuspendedTreeContext(workInProgress, current), workInProgress = mountSuspensePrimaryChildren(workInProgress, JSCompiler_object_inline_stack_2725.children), workInProgress.flags |= 4096);
                return workInProgress;
            }
        }
        if (JSCompiler_object_inline_message_2723) return reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = JSCompiler_object_inline_stack_2725.fallback, mode = workInProgress.mode, componentStack = current.child, JSCompiler_object_inline_componentStack_2726 = componentStack.sibling, JSCompiler_object_inline_stack_2725 = createWorkInProgress(componentStack, {
            mode: "hidden",
            children: JSCompiler_object_inline_stack_2725.children
        }), JSCompiler_object_inline_stack_2725.subtreeFlags = componentStack.subtreeFlags & 65011712, null !== JSCompiler_object_inline_componentStack_2726 ? nextPrimaryChildren = createWorkInProgress(JSCompiler_object_inline_componentStack_2726, nextPrimaryChildren) : (nextPrimaryChildren = createFiberFromFragment(nextPrimaryChildren, mode, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, JSCompiler_object_inline_stack_2725.return = workInProgress, JSCompiler_object_inline_stack_2725.sibling = nextPrimaryChildren, workInProgress.child = JSCompiler_object_inline_stack_2725, bailoutOffscreenComponent(null, JSCompiler_object_inline_stack_2725), JSCompiler_object_inline_stack_2725 = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = mountSuspenseOffscreenState(renderLanes) : (mode = nextPrimaryChildren.cachePool, null !== mode ? (componentStack = CacheContext._currentValue, mode = mode.parent !== componentStack ? {
            parent: componentStack,
            pool: componentStack
        } : mode) : mode = getSuspendedCache(), nextPrimaryChildren = {
            baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
            cachePool: mode
        }), JSCompiler_object_inline_stack_2725.memoizedState = nextPrimaryChildren, JSCompiler_object_inline_stack_2725.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_object_inline_digest_2724, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(current.child, JSCompiler_object_inline_stack_2725);
        null !== prevState && (renderLanes & 62914560) === renderLanes && 0 !== (renderLanes & current.lanes) && markRenderDerivedCause(workInProgress);
        pushPrimaryTreeSuspenseHandler(workInProgress);
        renderLanes = current.child;
        current = renderLanes.sibling;
        renderLanes = createWorkInProgress(renderLanes, {
            mode: "visible",
            children: JSCompiler_object_inline_stack_2725.children
        });
        renderLanes.return = workInProgress;
        renderLanes.sibling = null;
        null !== current && (JSCompiler_object_inline_digest_2724 = workInProgress.deletions, null === JSCompiler_object_inline_digest_2724 ? (workInProgress.deletions = [
            current
        ], workInProgress.flags |= 16) : JSCompiler_object_inline_digest_2724.push(current));
        workInProgress.child = renderLanes;
        workInProgress.memoizedState = null;
        return renderLanes;
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
        primaryChildren = mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: primaryChildren
        }, workInProgress.mode);
        primaryChildren.return = workInProgress;
        return workInProgress.child = primaryChildren;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
        offscreenProps = createFiber(22, offscreenProps, null, mode);
        offscreenProps.lanes = 0;
        return offscreenProps;
    }
    function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        current = mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
        current.flags |= 2;
        workInProgress.memoizedState = null;
        return current;
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes |= renderLanes;
        var alternate = fiber.alternate;
        null !== alternate && (alternate.lanes |= renderLanes);
        scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
        var renderState = workInProgress.memoizedState;
        null === renderState ? workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode,
            treeForkCount: treeForkCount
        } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
    }
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail, newChildren = nextProps.children, suspenseContext = suspenseStackCursor.current;
        (nextProps = 0 !== (suspenseContext & ForceSuspenseFallback)) ? (suspenseContext = suspenseContext & SubtreeSuspenseContextMask | ForceSuspenseFallback, workInProgress.flags |= 128) : suspenseContext &= SubtreeSuspenseContextMask;
        push(suspenseStackCursor, suspenseContext, workInProgress);
        suspenseContext = null == revealOrder ? "null" : revealOrder;
        if ("forwards" !== revealOrder && "unstable_legacy-backwards" !== revealOrder && "together" !== revealOrder && "independent" !== revealOrder && !didWarnAboutRevealOrder[suspenseContext]) {
            if (didWarnAboutRevealOrder[suspenseContext] = !0, null == revealOrder) console.error('The default for the <SuspenseList revealOrder="..."> prop is changing. To be future compatible you must explictly specify either "independent" (the current default), "together", "forwards" or "legacy_unstable-backwards".');
            else if ("backwards" === revealOrder) console.error('The rendering order of <SuspenseList revealOrder="backwards"> is changing. To be future compatible you must specify revealOrder="legacy_unstable-backwards" instead.');
            else if ("string" === typeof revealOrder) switch(revealOrder.toLowerCase()){
                case "together":
                case "forwards":
                case "backwards":
                case "independent":
                    console.error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case "forward":
                case "backward":
                    console.error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    console.error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?', revealOrder);
            }
            else console.error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?', revealOrder);
        }
        suspenseContext = null == tailMode ? "null" : tailMode;
        if (!didWarnAboutTailOptions[suspenseContext]) {
            if (null == tailMode) {
                if ("forwards" === revealOrder || "backwards" === revealOrder || "unstable_legacy-backwards" === revealOrder) didWarnAboutTailOptions[suspenseContext] = !0, console.error('The default for the <SuspenseList tail="..."> prop is changing. To be future compatible you must explictly specify either "visible" (the current default), "collapsed" or "hidden".');
            } else "visible" !== tailMode && "collapsed" !== tailMode && "hidden" !== tailMode ? (didWarnAboutTailOptions[suspenseContext] = !0, console.error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "visible", "collapsed" or "hidden"?', tailMode)) : "forwards" !== revealOrder && "backwards" !== revealOrder && "unstable_legacy-backwards" !== revealOrder && (didWarnAboutTailOptions[suspenseContext] = !0, console.error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode));
        }
        a: if (("forwards" === revealOrder || "backwards" === revealOrder || "unstable_legacy-backwards" === revealOrder) && void 0 !== newChildren && null !== newChildren && !1 !== newChildren) {
            if (isArrayImpl(newChildren)) for(suspenseContext = 0; suspenseContext < newChildren.length; suspenseContext++){
                if (!validateSuspenseListNestedChild(newChildren[suspenseContext], suspenseContext)) break a;
            }
            else if (suspenseContext = getIteratorFn(newChildren), "function" === typeof suspenseContext) {
                if (suspenseContext = suspenseContext.call(newChildren)) for(var step = suspenseContext.next(), _i = 0; !step.done; step = suspenseContext.next()){
                    if (!validateSuspenseListNestedChild(step.value, _i)) break a;
                    _i++;
                }
            } else console.error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
        }
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        isHydrating ? (warnIfNotHydrating(), newChildren = treeForkCount) : newChildren = 0;
        if (!nextProps && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        switch(revealOrder){
            case "forwards":
                renderLanes = workInProgress.child;
                for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
                renderLanes = revealOrder;
                null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
                initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, newChildren);
                break;
            case "backwards":
            case "unstable_legacy-backwards":
                renderLanes = null;
                revealOrder = workInProgress.child;
                for(workInProgress.child = null; null !== revealOrder;){
                    current = revealOrder.alternate;
                    if (null !== current && null === findFirstSuspended(current)) {
                        workInProgress.child = revealOrder;
                        break;
                    }
                    current = revealOrder.sibling;
                    revealOrder.sibling = renderLanes;
                    renderLanes = revealOrder;
                    revealOrder = current;
                }
                initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, newChildren);
                break;
            case "together":
                initSuspenseListRenderState(workInProgress, !1, null, null, void 0, newChildren);
                break;
            default:
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        null !== current && (workInProgress.dependencies = current.dependencies);
        profilerStartTime = -1;
        workInProgressRootSkippedLanes |= workInProgress.lanes;
        if (0 === (renderLanes & workInProgress.childLanes)) {
            if (null !== current) {
                if (propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
            } else return null;
        }
        if (null !== current && workInProgress.child !== current.child) throw Error("Resuming work not yet implemented.");
        if (null !== workInProgress.child) {
            current = workInProgress.child;
            renderLanes = createWorkInProgress(current, current.pendingProps);
            workInProgress.child = renderLanes;
            for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
            renderLanes.sibling = null;
        }
        return workInProgress.child;
    }
    function checkScheduledUpdateOrContext(current, renderLanes) {
        if (0 !== (current.lanes & renderLanes)) return !0;
        current = current.dependencies;
        return null !== current && checkIfContextChanged(current) ? !0 : !1;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        switch(workInProgress.tag){
            case 3:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
                resetHydrationState();
                break;
            case 27:
            case 5:
                pushHostContext(workInProgress);
                break;
            case 4:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
            case 10:
                pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
                break;
            case 12:
                0 !== (renderLanes & workInProgress.childLanes) && (workInProgress.flags |= 4);
                workInProgress.flags |= 2048;
                var stateNode = workInProgress.stateNode;
                stateNode.effectDuration = -0;
                stateNode.passiveEffectDuration = -0;
                break;
            case 31:
                if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, pushDehydratedActivitySuspenseHandler(workInProgress), null;
                break;
            case 13:
                stateNode = workInProgress.memoizedState;
                if (null !== stateNode) {
                    if (null !== stateNode.dehydrated) return pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                    if (0 !== (renderLanes & workInProgress.child.childLanes)) return updateSuspenseComponent(current, workInProgress, renderLanes);
                    pushPrimaryTreeSuspenseHandler(workInProgress);
                    current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                    return null !== current ? current.sibling : null;
                }
                pushPrimaryTreeSuspenseHandler(workInProgress);
                break;
            case 19:
                var didSuspendBefore = 0 !== (current.flags & 128);
                stateNode = 0 !== (renderLanes & workInProgress.childLanes);
                stateNode || (propagateParentContextChanges(current, workInProgress, renderLanes, !1), stateNode = 0 !== (renderLanes & workInProgress.childLanes));
                if (didSuspendBefore) {
                    if (stateNode) return updateSuspenseListComponent(current, workInProgress, renderLanes);
                    workInProgress.flags |= 128;
                }
                didSuspendBefore = workInProgress.memoizedState;
                null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
                push(suspenseStackCursor, suspenseStackCursor.current, workInProgress);
                if (stateNode) break;
                else return null;
            case 22:
                return workInProgress.lanes = 0, updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
            case 24:
                pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
        }
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    function beginWork(current, workInProgress, renderLanes) {
        if (workInProgress._debugNeedsRemount && null !== current) {
            renderLanes = createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes);
            renderLanes._debugStack = workInProgress._debugStack;
            renderLanes._debugTask = workInProgress._debugTask;
            var returnFiber = workInProgress.return;
            if (null === returnFiber) throw Error("Cannot swap the root fiber.");
            current.alternate = null;
            workInProgress.alternate = null;
            renderLanes.index = workInProgress.index;
            renderLanes.sibling = workInProgress.sibling;
            renderLanes.return = workInProgress.return;
            renderLanes.ref = workInProgress.ref;
            renderLanes._debugInfo = workInProgress._debugInfo;
            if (workInProgress === returnFiber.child) returnFiber.child = renderLanes;
            else {
                var prevSibling = returnFiber.child;
                if (null === prevSibling) throw Error("Expected parent to have a child.");
                for(; prevSibling.sibling !== workInProgress;)if (prevSibling = prevSibling.sibling, null === prevSibling) throw Error("Expected to find the previous sibling.");
                prevSibling.sibling = renderLanes;
            }
            workInProgress = returnFiber.deletions;
            null === workInProgress ? (returnFiber.deletions = [
                current
            ], returnFiber.flags |= 16) : workInProgress.push(current);
            renderLanes.flags |= 2;
            return renderLanes;
        }
        if (null !== current) {
            if (current.memoizedProps !== workInProgress.pendingProps || workInProgress.type !== current.type) didReceiveUpdate = !0;
            else {
                if (!checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return didReceiveUpdate = !1, attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
                didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
            }
        } else {
            didReceiveUpdate = !1;
            if (returnFiber = isHydrating) warnIfNotHydrating(), returnFiber = 0 !== (workInProgress.flags & 1048576);
            returnFiber && (returnFiber = workInProgress.index, warnIfNotHydrating(), pushTreeId(workInProgress, treeForkCount, returnFiber));
        }
        workInProgress.lanes = 0;
        switch(workInProgress.tag){
            case 16:
                a: if (returnFiber = workInProgress.pendingProps, current = resolveLazy(workInProgress.elementType), workInProgress.type = current, "function" === typeof current) shouldConstruct(current) ? (returnFiber = resolveClassComponentProps(current, returnFiber), workInProgress.tag = 1, workInProgress.type = current = resolveFunctionForHotReloading(current), workInProgress = updateClassComponent(null, workInProgress, current, returnFiber, renderLanes)) : (workInProgress.tag = 0, validateFunctionComponentInDev(workInProgress, current), workInProgress.type = current = resolveFunctionForHotReloading(current), workInProgress = updateFunctionComponent(null, workInProgress, current, returnFiber, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        if (prevSibling = current.$$typeof, prevSibling === REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress.type = current = resolveForwardRefForHotReloading(current);
                            workInProgress = updateForwardRef(null, workInProgress, current, returnFiber, renderLanes);
                            break a;
                        } else if (prevSibling === REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = updateMemoComponent(null, workInProgress, current, returnFiber, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = "";
                    null !== current && "object" === typeof current && current.$$typeof === REACT_LAZY_TYPE && (workInProgress = " Did you wrap a component in React.lazy() more than once?");
                    renderLanes = getComponentNameFromType(current) || current;
                    throw Error("Element type is invalid. Received a promise that resolves to: " + renderLanes + ". Lazy element type must resolve to a class or function." + workInProgress);
                }
                return workInProgress;
            case 0:
                return updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 1:
                return returnFiber = workInProgress.type, prevSibling = resolveClassComponentProps(returnFiber, workInProgress.pendingProps), updateClassComponent(current, workInProgress, returnFiber, prevSibling, renderLanes);
            case 3:
                a: {
                    pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                    if (null === current) throw Error("Should have a current fiber. This is a bug in React.");
                    returnFiber = workInProgress.pendingProps;
                    var prevState = workInProgress.memoizedState;
                    prevSibling = prevState.element;
                    cloneUpdateQueue(current, workInProgress);
                    processUpdateQueue(workInProgress, returnFiber, null, renderLanes);
                    var nextState = workInProgress.memoizedState;
                    returnFiber = nextState.cache;
                    pushProvider(workInProgress, CacheContext, returnFiber);
                    returnFiber !== prevState.cache && propagateContextChanges(workInProgress, [
                        CacheContext
                    ], renderLanes, !0);
                    suspendIfUpdateReadFromEntangledAsyncAction();
                    returnFiber = nextState.element;
                    if (prevState.isDehydrated) {
                        if (prevState = {
                            element: returnFiber,
                            isDehydrated: !1,
                            cache: nextState.cache
                        }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                            workInProgress = mountHostRootWithoutHydrating(current, workInProgress, returnFiber, renderLanes);
                            break a;
                        } else if (returnFiber !== prevSibling) {
                            prevSibling = createCapturedValueAtFiber(Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), workInProgress);
                            queueHydrationError(prevSibling);
                            workInProgress = mountHostRootWithoutHydrating(current, workInProgress, returnFiber, renderLanes);
                            break a;
                        } else {
                            current = workInProgress.stateNode.containerInfo;
                            switch(current.nodeType){
                                case 9:
                                    current = current.body;
                                    break;
                                default:
                                    current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                            }
                            nextHydratableInstance = getNextHydratable(current.firstChild);
                            hydrationParentFiber = workInProgress;
                            isHydrating = !0;
                            hydrationErrors = null;
                            didSuspendOrErrorDEV = !1;
                            hydrationDiffRootDEV = null;
                            rootOrSingletonContext = !0;
                            renderLanes = mountChildFibers(workInProgress, null, returnFiber, renderLanes);
                            for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                        }
                    } else {
                        resetHydrationState();
                        if (returnFiber === prevSibling) {
                            workInProgress = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                            break a;
                        }
                        reconcileChildren(current, workInProgress, returnFiber, renderLanes);
                    }
                    workInProgress = workInProgress.child;
                }
                return workInProgress;
            case 26:
                return markRef(current, workInProgress), null === current ? (renderLanes = getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, returnFiber = requiredContext(rootInstanceStackCursor.current), returnFiber = getOwnerDocumentFromRootContainer(returnFiber).createElement(renderLanes), returnFiber[internalInstanceKey] = workInProgress, returnFiber[internalPropsKey] = current, setInitialProperties(returnFiber, renderLanes, current), markNodeAsHoistable(returnFiber), workInProgress.stateNode = returnFiber) : workInProgress.memoizedState = getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
            case 27:
                return pushHostContext(workInProgress), null === current && isHydrating && (returnFiber = requiredContext(rootInstanceStackCursor.current), prevSibling = getHostContext(), returnFiber = workInProgress.stateNode = resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, returnFiber, prevSibling, !1), didSuspendOrErrorDEV || (prevSibling = diffHydratedProperties(returnFiber, workInProgress.type, workInProgress.pendingProps, prevSibling), null !== prevSibling && (buildHydrationDiffNode(workInProgress, 0).serverProps = prevSibling)), hydrationParentFiber = workInProgress, rootOrSingletonContext = !0, prevSibling = nextHydratableInstance, isSingletonScope(workInProgress.type) ? (previousHydratableOnEnteringScopedSingleton = prevSibling, nextHydratableInstance = getNextHydratable(returnFiber.firstChild)) : nextHydratableInstance = prevSibling), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
            case 5:
                return null === current && isHydrating && (prevState = getHostContext(), returnFiber = validateDOMNesting(workInProgress.type, prevState.ancestorInfo), prevSibling = nextHydratableInstance, (nextState = !prevSibling) || (nextState = canHydrateInstance(prevSibling, workInProgress.type, workInProgress.pendingProps, rootOrSingletonContext), null !== nextState ? (workInProgress.stateNode = nextState, didSuspendOrErrorDEV || (prevState = diffHydratedProperties(nextState, workInProgress.type, workInProgress.pendingProps, prevState), null !== prevState && (buildHydrationDiffNode(workInProgress, 0).serverProps = prevState)), hydrationParentFiber = workInProgress, nextHydratableInstance = getNextHydratable(nextState.firstChild), rootOrSingletonContext = !1, prevState = !0) : prevState = !1, nextState = !prevState), nextState && (returnFiber && warnNonHydratedInstance(workInProgress, prevSibling), throwOnHydrationMismatch(workInProgress))), pushHostContext(workInProgress), prevSibling = workInProgress.type, prevState = workInProgress.pendingProps, nextState = null !== current ? current.memoizedProps : null, returnFiber = prevState.children, shouldSetTextContent(prevSibling, prevState) ? returnFiber = null : null !== nextState && shouldSetTextContent(prevSibling, nextState) && (workInProgress.flags |= 32), null !== workInProgress.memoizedState && (prevSibling = renderWithHooks(current, workInProgress, TransitionAwareHostComponent, null, null, renderLanes), HostTransitionContext._currentValue = prevSibling), markRef(current, workInProgress), reconcileChildren(current, workInProgress, returnFiber, renderLanes), workInProgress.child;
            case 6:
                return null === current && isHydrating && (renderLanes = workInProgress.pendingProps, current = getHostContext(), returnFiber = current.ancestorInfo.current, renderLanes = null != returnFiber ? validateTextNesting(renderLanes, returnFiber.tag, current.ancestorInfo.implicitRootScope) : !0, current = nextHydratableInstance, (returnFiber = !current) || (returnFiber = canHydrateTextInstance(current, workInProgress.pendingProps, rootOrSingletonContext), null !== returnFiber ? (workInProgress.stateNode = returnFiber, hydrationParentFiber = workInProgress, nextHydratableInstance = null, returnFiber = !0) : returnFiber = !1, returnFiber = !returnFiber), returnFiber && (renderLanes && warnNonHydratedInstance(workInProgress, current), throwOnHydrationMismatch(workInProgress))), null;
            case 13:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case 4:
                return pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), returnFiber = workInProgress.pendingProps, null === current ? workInProgress.child = reconcileChildFibers(workInProgress, null, returnFiber, renderLanes) : reconcileChildren(current, workInProgress, returnFiber, renderLanes), workInProgress.child;
            case 11:
                return updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 7:
                return reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
            case 8:
                return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
            case 12:
                return workInProgress.flags |= 4, workInProgress.flags |= 2048, returnFiber = workInProgress.stateNode, returnFiber.effectDuration = -0, returnFiber.passiveEffectDuration = -0, reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
            case 10:
                return returnFiber = workInProgress.type, prevSibling = workInProgress.pendingProps, prevState = prevSibling.value, "value" in prevSibling || hasWarnedAboutUsingNoValuePropOnContextProvider || (hasWarnedAboutUsingNoValuePropOnContextProvider = !0, console.error("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?")), pushProvider(workInProgress, returnFiber, prevState), reconcileChildren(current, workInProgress, prevSibling.children, renderLanes), workInProgress.child;
            case 9:
                return prevSibling = workInProgress.type._context, returnFiber = workInProgress.pendingProps.children, "function" !== typeof returnFiber && console.error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), prepareToReadContext(workInProgress), prevSibling = readContext(prevSibling), returnFiber = callComponentInDEV(returnFiber, prevSibling, void 0), workInProgress.flags |= 1, reconcileChildren(current, workInProgress, returnFiber, renderLanes), workInProgress.child;
            case 14:
                return updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 15:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 19:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case 31:
                return updateActivityComponent(current, workInProgress, renderLanes);
            case 22:
                return updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
            case 24:
                return prepareToReadContext(workInProgress), returnFiber = readContext(CacheContext), null === current ? (prevSibling = peekCacheFromPool(), null === prevSibling && (prevSibling = workInProgressRoot, prevState = createCache(), prevSibling.pooledCache = prevState, retainCache(prevState), null !== prevState && (prevSibling.pooledCacheLanes |= renderLanes), prevSibling = prevState), workInProgress.memoizedState = {
                    parent: returnFiber,
                    cache: prevSibling
                }, initializeUpdateQueue(workInProgress), pushProvider(workInProgress, CacheContext, prevSibling)) : (0 !== (current.lanes & renderLanes) && (cloneUpdateQueue(current, workInProgress), processUpdateQueue(workInProgress, null, null, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction()), prevSibling = current.memoizedState, prevState = workInProgress.memoizedState, prevSibling.parent !== returnFiber ? (prevSibling = {
                    parent: returnFiber,
                    cache: returnFiber
                }, workInProgress.memoizedState = prevSibling, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = prevSibling), pushProvider(workInProgress, CacheContext, returnFiber)) : (returnFiber = prevState.cache, pushProvider(workInProgress, CacheContext, returnFiber), returnFiber !== prevSibling.cache && propagateContextChanges(workInProgress, [
                    CacheContext
                ], renderLanes, !0))), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
            case 29:
                throw workInProgress.pendingProps;
        }
        throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function markUpdate(workInProgress) {
        workInProgress.flags |= 4;
    }
    function preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
        if (type = (workInProgress.mode & SuspenseyImagesMode) !== NoMode) type = !1;
        if (type) {
            if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
                if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
                else if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
                else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
            }
        } else workInProgress.flags &= -16777217;
    }
    function preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
        if ("stylesheet" !== resource.type || (resource.state.loading & Inserted) !== NotLoaded) workInProgress.flags &= -16777217;
        else if (workInProgress.flags |= 16777216, !preloadResource(resource)) {
            if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
        }
    }
    function scheduleRetryEffect(workInProgress, retryQueue) {
        null !== retryQueue && (workInProgress.flags |= 4);
        workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
    }
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (!isHydrating) switch(renderState.tailMode){
            case "hidden":
                hasRenderedATailFallback = renderState.tail;
                for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
                null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
                break;
            case "collapsed":
                lastTailNode = renderState.tail;
                for(var _lastTailNode = null; null !== lastTailNode;)null !== lastTailNode.alternate && (_lastTailNode = lastTailNode), lastTailNode = lastTailNode.sibling;
                null === _lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : _lastTailNode.sibling = null;
        }
    }
    function bubbleProperties(completedWork) {
        var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
        if (didBailout) {
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                for(var _treeBaseDuration = completedWork.selfBaseDuration, _child2 = completedWork.child; null !== _child2;)newChildLanes |= _child2.lanes | _child2.childLanes, subtreeFlags |= _child2.subtreeFlags & 65011712, subtreeFlags |= _child2.flags & 65011712, _treeBaseDuration += _child2.treeBaseDuration, _child2 = _child2.sibling;
                completedWork.treeBaseDuration = _treeBaseDuration;
            } else for(_treeBaseDuration = completedWork.child; null !== _treeBaseDuration;)newChildLanes |= _treeBaseDuration.lanes | _treeBaseDuration.childLanes, subtreeFlags |= _treeBaseDuration.subtreeFlags & 65011712, subtreeFlags |= _treeBaseDuration.flags & 65011712, _treeBaseDuration.return = completedWork, _treeBaseDuration = _treeBaseDuration.sibling;
        } else if ((completedWork.mode & ProfileMode) !== NoMode) {
            _treeBaseDuration = completedWork.actualDuration;
            _child2 = completedWork.selfBaseDuration;
            for(var child = completedWork.child; null !== child;)newChildLanes |= child.lanes | child.childLanes, subtreeFlags |= child.subtreeFlags, subtreeFlags |= child.flags, _treeBaseDuration += child.actualDuration, _child2 += child.treeBaseDuration, child = child.sibling;
            completedWork.actualDuration = _treeBaseDuration;
            completedWork.treeBaseDuration = _child2;
        } else for(_treeBaseDuration = completedWork.child; null !== _treeBaseDuration;)newChildLanes |= _treeBaseDuration.lanes | _treeBaseDuration.childLanes, subtreeFlags |= _treeBaseDuration.subtreeFlags, subtreeFlags |= _treeBaseDuration.flags, _treeBaseDuration.return = completedWork, _treeBaseDuration = _treeBaseDuration.sibling;
        completedWork.subtreeFlags |= subtreeFlags;
        completedWork.childLanes = newChildLanes;
        return didBailout;
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps;
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
                return bubbleProperties(workInProgress), null;
            case 1:
                return bubbleProperties(workInProgress), null;
            case 3:
                renderLanes = workInProgress.stateNode;
                newProps = null;
                null !== current && (newProps = current.memoizedState.cache);
                workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
                popProvider(CacheContext, workInProgress);
                popHostContainer(workInProgress);
                renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
                if (null === current || null === current.child) popHydrationState(workInProgress) ? (emitPendingHydrationWarnings(), markUpdate(workInProgress)) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, upgradeHydrationErrorsToRecoverable());
                bubbleProperties(workInProgress);
                return null;
            case 26:
                var type = workInProgress.type, nextResource = workInProgress.memoizedState;
                null === current ? (markUpdate(workInProgress), null !== nextResource ? (bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? (markUpdate(workInProgress), bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && markUpdate(workInProgress), bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
                return null;
            case 27:
                popHostContext(workInProgress);
                renderLanes = requiredContext(rootInstanceStackCursor.current);
                type = workInProgress.type;
                if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
                else {
                    if (!newProps) {
                        if (null === workInProgress.stateNode) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                        bubbleProperties(workInProgress);
                        return null;
                    }
                    current = getHostContext();
                    popHydrationState(workInProgress) ? prepareToHydrateHostInstance(workInProgress, current) : (current = resolveSingletonInstance(type, newProps, renderLanes, current, !0), workInProgress.stateNode = current, markUpdate(workInProgress));
                }
                bubbleProperties(workInProgress);
                return null;
            case 5:
                popHostContext(workInProgress);
                type = workInProgress.type;
                if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
                else {
                    if (!newProps) {
                        if (null === workInProgress.stateNode) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                        bubbleProperties(workInProgress);
                        return null;
                    }
                    var _currentHostContext = getHostContext();
                    if (popHydrationState(workInProgress)) prepareToHydrateHostInstance(workInProgress, _currentHostContext);
                    else {
                        nextResource = requiredContext(rootInstanceStackCursor.current);
                        validateDOMNesting(type, _currentHostContext.ancestorInfo);
                        _currentHostContext = _currentHostContext.context;
                        nextResource = getOwnerDocumentFromRootContainer(nextResource);
                        switch(_currentHostContext){
                            case HostContextNamespaceSvg:
                                nextResource = nextResource.createElementNS(SVG_NAMESPACE, type);
                                break;
                            case HostContextNamespaceMath:
                                nextResource = nextResource.createElementNS(MATH_NAMESPACE, type);
                                break;
                            default:
                                switch(type){
                                    case "svg":
                                        nextResource = nextResource.createElementNS(SVG_NAMESPACE, type);
                                        break;
                                    case "math":
                                        nextResource = nextResource.createElementNS(MATH_NAMESPACE, type);
                                        break;
                                    case "script":
                                        nextResource = nextResource.createElement("div");
                                        nextResource.innerHTML = "<script>\x3c/script>";
                                        nextResource = nextResource.removeChild(nextResource.firstChild);
                                        break;
                                    case "select":
                                        nextResource = "string" === typeof newProps.is ? nextResource.createElement("select", {
                                            is: newProps.is
                                        }) : nextResource.createElement("select");
                                        newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                        break;
                                    default:
                                        nextResource = "string" === typeof newProps.is ? nextResource.createElement(type, {
                                            is: newProps.is
                                        }) : nextResource.createElement(type), -1 === type.indexOf("-") && (type !== type.toLowerCase() && console.error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type), "[object HTMLUnknownElement]" !== Object.prototype.toString.call(nextResource) || hasOwnProperty.call(warnedUnknownTags, type) || (warnedUnknownTags[type] = !0, console.error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type)));
                                }
                        }
                        nextResource[internalInstanceKey] = workInProgress;
                        nextResource[internalPropsKey] = newProps;
                        a: for(_currentHostContext = workInProgress.child; null !== _currentHostContext;){
                            if (5 === _currentHostContext.tag || 6 === _currentHostContext.tag) nextResource.appendChild(_currentHostContext.stateNode);
                            else if (4 !== _currentHostContext.tag && 27 !== _currentHostContext.tag && null !== _currentHostContext.child) {
                                _currentHostContext.child.return = _currentHostContext;
                                _currentHostContext = _currentHostContext.child;
                                continue;
                            }
                            if (_currentHostContext === workInProgress) break a;
                            for(; null === _currentHostContext.sibling;){
                                if (null === _currentHostContext.return || _currentHostContext.return === workInProgress) break a;
                                _currentHostContext = _currentHostContext.return;
                            }
                            _currentHostContext.sibling.return = _currentHostContext.return;
                            _currentHostContext = _currentHostContext.sibling;
                        }
                        workInProgress.stateNode = nextResource;
                        a: switch(setInitialProperties(nextResource, type, newProps), type){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                newProps = !!newProps.autoFocus;
                                break a;
                            case "img":
                                newProps = !0;
                                break a;
                            default:
                                newProps = !1;
                        }
                        newProps && markUpdate(workInProgress);
                    }
                }
                bubbleProperties(workInProgress);
                preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
                return null;
            case 6:
                if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
                else {
                    if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                    current = requiredContext(rootInstanceStackCursor.current);
                    renderLanes = getHostContext();
                    if (popHydrationState(workInProgress)) {
                        current = workInProgress.stateNode;
                        renderLanes = workInProgress.memoizedProps;
                        type = !didSuspendOrErrorDEV;
                        newProps = null;
                        nextResource = hydrationParentFiber;
                        if (null !== nextResource) switch(nextResource.tag){
                            case 3:
                                type && (type = diffHydratedTextForDevWarnings(current, renderLanes, newProps), null !== type && (buildHydrationDiffNode(workInProgress, 0).serverProps = type));
                                break;
                            case 27:
                            case 5:
                                newProps = nextResource.memoizedProps, type && (type = diffHydratedTextForDevWarnings(current, renderLanes, newProps), null !== type && (buildHydrationDiffNode(workInProgress, 0).serverProps = type));
                        }
                        current[internalInstanceKey] = workInProgress;
                        current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                        current || throwOnHydrationMismatch(workInProgress, !0);
                    } else type = renderLanes.ancestorInfo.current, null != type && validateTextNesting(newProps, type.tag, renderLanes.ancestorInfo.implicitRootScope), current = getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
                }
                bubbleProperties(workInProgress);
                return null;
            case 31:
                renderLanes = workInProgress.memoizedState;
                if (null === current || null !== current.memoizedState) {
                    newProps = popHydrationState(workInProgress);
                    if (null !== renderLanes) {
                        if (null === current) {
                            if (!newProps) throw Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                            current = workInProgress.memoizedState;
                            current = null !== current ? current.dehydrated : null;
                            if (!current) throw Error("Expected to have a hydrated activity instance. This error is likely caused by a bug in React. Please file an issue.");
                            current[internalInstanceKey] = workInProgress;
                            bubbleProperties(workInProgress);
                            (workInProgress.mode & ProfileMode) !== NoMode && null !== renderLanes && (current = workInProgress.child, null !== current && (workInProgress.treeBaseDuration -= current.treeBaseDuration));
                        } else emitPendingHydrationWarnings(), resetHydrationState(), 0 === (workInProgress.flags & 128) && (renderLanes = workInProgress.memoizedState = null), workInProgress.flags |= 4, bubbleProperties(workInProgress), (workInProgress.mode & ProfileMode) !== NoMode && null !== renderLanes && (current = workInProgress.child, null !== current && (workInProgress.treeBaseDuration -= current.treeBaseDuration));
                        current = !1;
                    } else renderLanes = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                    if (!current) {
                        if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                        popSuspenseHandler(workInProgress);
                        return null;
                    }
                    if (0 !== (workInProgress.flags & 128)) throw Error("Client rendering an Activity suspended it again. This is a bug in React.");
                }
                bubbleProperties(workInProgress);
                return null;
            case 13:
                newProps = workInProgress.memoizedState;
                if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                    type = newProps;
                    nextResource = popHydrationState(workInProgress);
                    if (null !== type && null !== type.dehydrated) {
                        if (null === current) {
                            if (!nextResource) throw Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                            nextResource = workInProgress.memoizedState;
                            nextResource = null !== nextResource ? nextResource.dehydrated : null;
                            if (!nextResource) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
                            nextResource[internalInstanceKey] = workInProgress;
                            bubbleProperties(workInProgress);
                            (workInProgress.mode & ProfileMode) !== NoMode && null !== type && (type = workInProgress.child, null !== type && (workInProgress.treeBaseDuration -= type.treeBaseDuration));
                        } else emitPendingHydrationWarnings(), resetHydrationState(), 0 === (workInProgress.flags & 128) && (type = workInProgress.memoizedState = null), workInProgress.flags |= 4, bubbleProperties(workInProgress), (workInProgress.mode & ProfileMode) !== NoMode && null !== type && (type = workInProgress.child, null !== type && (workInProgress.treeBaseDuration -= type.treeBaseDuration));
                        type = !1;
                    } else type = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                    if (!type) {
                        if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                        popSuspenseHandler(workInProgress);
                        return null;
                    }
                }
                popSuspenseHandler(workInProgress);
                if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress;
                renderLanes = null !== newProps;
                current = null !== current && null !== current.memoizedState;
                renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
                renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
                scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
                bubbleProperties(workInProgress);
                (workInProgress.mode & ProfileMode) !== NoMode && renderLanes && (current = workInProgress.child, null !== current && (workInProgress.treeBaseDuration -= current.treeBaseDuration));
                return null;
            case 4:
                return popHostContainer(workInProgress), null === current && listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), bubbleProperties(workInProgress), null;
            case 10:
                return popProvider(workInProgress.type, workInProgress), bubbleProperties(workInProgress), null;
            case 19:
                pop(suspenseStackCursor, workInProgress);
                newProps = workInProgress.memoizedState;
                if (null === newProps) return bubbleProperties(workInProgress), null;
                type = 0 !== (workInProgress.flags & 128);
                nextResource = newProps.rendering;
                if (null === nextResource) {
                    if (type) cutOffTailIfNeeded(newProps, !1);
                    else {
                        if (workInProgressRootExitStatus !== RootInProgress || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                            nextResource = findFirstSuspended(current);
                            if (null !== nextResource) {
                                workInProgress.flags |= 128;
                                cutOffTailIfNeeded(newProps, !1);
                                current = nextResource.updateQueue;
                                workInProgress.updateQueue = current;
                                scheduleRetryEffect(workInProgress, current);
                                workInProgress.subtreeFlags = 0;
                                current = renderLanes;
                                for(renderLanes = workInProgress.child; null !== renderLanes;)resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                                push(suspenseStackCursor, suspenseStackCursor.current & SubtreeSuspenseContextMask | ForceSuspenseFallback, workInProgress);
                                isHydrating && pushTreeFork(workInProgress, newProps.treeForkCount);
                                return workInProgress.child;
                            }
                            current = current.sibling;
                        }
                        null !== newProps.tail && now$1() > workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                    }
                } else {
                    if (!type) {
                        if (current = findFirstSuspended(nextResource), null !== current) {
                            if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, scheduleRetryEffect(workInProgress, current), cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !isHydrating) return bubbleProperties(workInProgress), null;
                        } else 2 * now$1() - newProps.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                    }
                    newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
                }
                if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = now$1(), current.sibling = null, renderLanes = suspenseStackCursor.current, renderLanes = type ? renderLanes & SubtreeSuspenseContextMask | ForceSuspenseFallback : renderLanes & SubtreeSuspenseContextMask, push(suspenseStackCursor, renderLanes, workInProgress), isHydrating && pushTreeFork(workInProgress, newProps.treeForkCount), current;
                bubbleProperties(workInProgress);
                return null;
            case 22:
            case 23:
                return popSuspenseHandler(workInProgress), popHiddenContext(workInProgress), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && (bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && pop(resumedCache, workInProgress), null;
            case 24:
                return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), popProvider(CacheContext, workInProgress), bubbleProperties(workInProgress), null;
            case 25:
                return null;
            case 30:
                return null;
        }
        throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function unwindWork(current, workInProgress) {
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case 1:
                return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress) : null;
            case 3:
                return popProvider(CacheContext, workInProgress), popHostContainer(workInProgress), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
            case 26:
            case 27:
            case 5:
                return popHostContext(workInProgress), null;
            case 31:
                if (null !== workInProgress.memoizedState) {
                    popSuspenseHandler(workInProgress);
                    if (null === workInProgress.alternate) throw Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                current = workInProgress.flags;
                return current & 65536 ? (workInProgress.flags = current & -65537 | 128, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress) : null;
            case 13:
                popSuspenseHandler(workInProgress);
                current = workInProgress.memoizedState;
                if (null !== current && null !== current.dehydrated) {
                    if (null === workInProgress.alternate) throw Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                current = workInProgress.flags;
                return current & 65536 ? (workInProgress.flags = current & -65537 | 128, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress) : null;
            case 19:
                return pop(suspenseStackCursor, workInProgress), null;
            case 4:
                return popHostContainer(workInProgress), null;
            case 10:
                return popProvider(workInProgress.type, workInProgress), null;
            case 22:
            case 23:
                return popSuspenseHandler(workInProgress), popHiddenContext(workInProgress), null !== current && pop(resumedCache, workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress) : null;
            case 24:
                return popProvider(CacheContext, workInProgress), null;
            case 25:
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(current, interruptedWork) {
        popTreeContext(interruptedWork);
        switch(interruptedWork.tag){
            case 3:
                popProvider(CacheContext, interruptedWork);
                popHostContainer(interruptedWork);
                break;
            case 26:
            case 27:
            case 5:
                popHostContext(interruptedWork);
                break;
            case 4:
                popHostContainer(interruptedWork);
                break;
            case 31:
                null !== interruptedWork.memoizedState && popSuspenseHandler(interruptedWork);
                break;
            case 13:
                popSuspenseHandler(interruptedWork);
                break;
            case 19:
                pop(suspenseStackCursor, interruptedWork);
                break;
            case 10:
                popProvider(interruptedWork.type, interruptedWork);
                break;
            case 22:
            case 23:
                popSuspenseHandler(interruptedWork);
                popHiddenContext(interruptedWork);
                null !== current && pop(resumedCache, interruptedWork);
                break;
            case 24:
                popProvider(CacheContext, interruptedWork);
        }
    }
    function shouldProfile(current) {
        return (current.mode & ProfileMode) !== NoMode;
    }
    function commitHookLayoutEffects(finishedWork, hookFlags) {
        shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListMount(hookFlags, finishedWork), recordEffectDuration()) : commitHookEffectListMount(hookFlags, finishedWork);
    }
    function commitHookLayoutUnmountEffects(finishedWork, nearestMountedAncestor, hookFlags) {
        shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListUnmount(hookFlags, finishedWork, nearestMountedAncestor), recordEffectDuration()) : commitHookEffectListUnmount(hookFlags, finishedWork, nearestMountedAncestor);
    }
    function commitHookEffectListMount(flags, finishedWork) {
        try {
            var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
            if (null !== lastEffect) {
                var firstEffect = lastEffect.next;
                updateQueue = firstEffect;
                do {
                    if ((updateQueue.tag & flags) === flags && (lastEffect = void 0, (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = !0), lastEffect = runWithFiberInDEV(finishedWork, callCreateInDEV, updateQueue), (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = !1), void 0 !== lastEffect && "function" !== typeof lastEffect)) {
                        var hookName = void 0;
                        hookName = 0 !== (updateQueue.tag & Layout) ? "useLayoutEffect" : 0 !== (updateQueue.tag & Insertion) ? "useInsertionEffect" : "useEffect";
                        var addendum = void 0;
                        addendum = null === lastEffect ? " You returned null. If your effect does not require clean up, return undefined (or nothing)." : "function" === typeof lastEffect.then ? "\n\nIt looks like you wrote " + hookName + "(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\n" + hookName + "(() => {\n  async function fetchData() {\n    // You can await here\n    const response = await MyAPI.getData(someId);\n    // ...\n  }\n  fetchData();\n}, [someId]); // Or [] if effect doesn't need props or state\n\nLearn more about data fetching with Hooks: https://react.dev/link/hooks-data-fetching" : " You returned: " + lastEffect;
                        runWithFiberInDEV(finishedWork, function(n, a) {
                            console.error("%s must not return anything besides a function, which is used for clean-up.%s", n, a);
                        }, hookName, addendum);
                    }
                    updateQueue = updateQueue.next;
                }while (updateQueue !== firstEffect);
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
        try {
            var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
            if (null !== lastEffect) {
                var firstEffect = lastEffect.next;
                updateQueue = firstEffect;
                do {
                    if ((updateQueue.tag & flags) === flags) {
                        var inst = updateQueue.inst, destroy = inst.destroy;
                        void 0 !== destroy && (inst.destroy = void 0, (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = !0), lastEffect = finishedWork, runWithFiberInDEV(lastEffect, callDestroyInDEV, lastEffect, nearestMountedAncestor, destroy), (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = !1));
                    }
                    updateQueue = updateQueue.next;
                }while (updateQueue !== firstEffect);
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitHookPassiveMountEffects(finishedWork, hookFlags) {
        shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListMount(hookFlags, finishedWork), recordEffectDuration()) : commitHookEffectListMount(hookFlags, finishedWork);
    }
    function commitHookPassiveUnmountEffects(finishedWork, nearestMountedAncestor, hookFlags) {
        shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListUnmount(hookFlags, finishedWork, nearestMountedAncestor), recordEffectDuration()) : commitHookEffectListUnmount(hookFlags, finishedWork, nearestMountedAncestor);
    }
    function commitClassCallbacks(finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        if (null !== updateQueue) {
            var instance = finishedWork.stateNode;
            finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (instance.props !== finishedWork.memoizedProps && console.error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"), instance.state !== finishedWork.memoizedState && console.error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"));
            try {
                runWithFiberInDEV(finishedWork, commitCallbacks, updateQueue, instance);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
        }
    }
    function callGetSnapshotBeforeUpdates(instance, prevProps, prevState) {
        return instance.getSnapshotBeforeUpdate(prevProps, prevState);
    }
    function commitClassSnapshot(finishedWork, current) {
        var prevProps = current.memoizedProps, prevState = current.memoizedState;
        current = finishedWork.stateNode;
        finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (current.props !== finishedWork.memoizedProps && console.error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"), current.state !== finishedWork.memoizedState && console.error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"));
        try {
            var resolvedPrevProps = resolveClassComponentProps(finishedWork.type, prevProps);
            var snapshot = runWithFiberInDEV(finishedWork, callGetSnapshotBeforeUpdates, current, resolvedPrevProps, prevState);
            prevProps = didWarnAboutUndefinedSnapshotBeforeUpdate;
            void 0 !== snapshot || prevProps.has(finishedWork.type) || (prevProps.add(finishedWork.type), runWithFiberInDEV(finishedWork, function() {
                console.error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentNameFromFiber(finishedWork));
            }));
            current.__reactInternalSnapshotBeforeUpdate = snapshot;
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        instance.props = resolveClassComponentProps(current.type, current.memoizedProps);
        instance.state = current.memoizedState;
        shouldProfile(current) ? (startEffectTimer(), runWithFiberInDEV(current, callComponentWillUnmountInDEV, current, nearestMountedAncestor, instance), recordEffectDuration()) : runWithFiberInDEV(current, callComponentWillUnmountInDEV, current, nearestMountedAncestor, instance);
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (null !== ref) {
            switch(finishedWork.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = finishedWork.stateNode;
                    break;
                case 30:
                    instanceToUse = finishedWork.stateNode;
                    break;
                default:
                    instanceToUse = finishedWork.stateNode;
            }
            if ("function" === typeof ref) {
                if (shouldProfile(finishedWork)) try {
                    startEffectTimer(), finishedWork.refCleanup = ref(instanceToUse);
                } finally{
                    recordEffectDuration();
                }
                else finishedWork.refCleanup = ref(instanceToUse);
            } else "string" === typeof ref ? console.error("String refs are no longer supported.") : ref.hasOwnProperty("current") || console.error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentNameFromFiber(finishedWork)), ref.current = instanceToUse;
        }
    }
    function safelyAttachRef(current, nearestMountedAncestor) {
        try {
            runWithFiberInDEV(current, commitAttachRef, current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref, refCleanup = current.refCleanup;
        if (null !== ref) {
            if ("function" === typeof refCleanup) try {
                if (shouldProfile(current)) try {
                    startEffectTimer(), runWithFiberInDEV(current, refCleanup);
                } finally{
                    recordEffectDuration(current);
                }
                else runWithFiberInDEV(current, refCleanup);
            } catch (error) {
                captureCommitPhaseError(current, nearestMountedAncestor, error);
            } finally{
                current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
            }
            else if ("function" === typeof ref) try {
                if (shouldProfile(current)) try {
                    startEffectTimer(), runWithFiberInDEV(current, ref, null);
                } finally{
                    recordEffectDuration(current);
                }
                else runWithFiberInDEV(current, ref, null);
            } catch (error$7) {
                captureCommitPhaseError(current, nearestMountedAncestor, error$7);
            }
            else ref.current = null;
        }
    }
    function commitProfiler(finishedWork, current, commitStartTime, effectDuration) {
        var _finishedWork$memoize = finishedWork.memoizedProps, id = _finishedWork$memoize.id, onCommit = _finishedWork$memoize.onCommit;
        _finishedWork$memoize = _finishedWork$memoize.onRender;
        current = null === current ? "mount" : "update";
        currentUpdateIsNested && (current = "nested-update");
        "function" === typeof _finishedWork$memoize && _finishedWork$memoize(id, current, finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitStartTime);
        "function" === typeof onCommit && onCommit(id, current, effectDuration, commitStartTime);
    }
    function commitProfilerPostCommitImpl(finishedWork, current, commitStartTime, passiveEffectDuration) {
        var _finishedWork$memoize2 = finishedWork.memoizedProps;
        finishedWork = _finishedWork$memoize2.id;
        _finishedWork$memoize2 = _finishedWork$memoize2.onPostCommit;
        current = null === current ? "mount" : "update";
        currentUpdateIsNested && (current = "nested-update");
        "function" === typeof _finishedWork$memoize2 && _finishedWork$memoize2(finishedWork, current, passiveEffectDuration, commitStartTime);
    }
    function commitHostMount(finishedWork) {
        var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
        try {
            runWithFiberInDEV(finishedWork, commitMount, instance, type, props, finishedWork);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitHostUpdate(finishedWork, newProps, oldProps) {
        try {
            runWithFiberInDEV(finishedWork, commitUpdate, finishedWork.stateNode, finishedWork.type, oldProps, newProps, finishedWork);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function isHostParent(fiber) {
        return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && isSingletonScope(fiber.type) || 4 === fiber.tag;
    }
    function getHostSibling(fiber) {
        a: for(;;){
            for(; null === fiber.sibling;){
                if (null === fiber.return || isHostParent(fiber.return)) return null;
                fiber = fiber.return;
            }
            fiber.sibling.return = fiber.return;
            for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
                if (27 === fiber.tag && isSingletonScope(fiber.type)) continue a;
                if (fiber.flags & 2) continue a;
                if (null === fiber.child || 4 === fiber.tag) continue a;
                else fiber.child.return = fiber, fiber = fiber.child;
            }
            if (!(fiber.flags & 2)) return fiber.stateNode;
        }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        if (5 === tag || 6 === tag) node = node.stateNode, before ? (warnForReactChildrenConflict(parent), (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before)) : (warnForReactChildrenConflict(parent), before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = noop$1));
        else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for(insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
        else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for(insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
    }
    function commitPlacement(finishedWork) {
        for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
            if (isHostParent(parentFiber)) {
                hostParentFiber = parentFiber;
                break;
            }
            parentFiber = parentFiber.return;
        }
        if (null == hostParentFiber) throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        switch(hostParentFiber.tag){
            case 27:
                hostParentFiber = hostParentFiber.stateNode;
                parentFiber = getHostSibling(finishedWork);
                insertOrAppendPlacementNode(finishedWork, parentFiber, hostParentFiber);
                break;
            case 5:
                parentFiber = hostParentFiber.stateNode;
                hostParentFiber.flags & 32 && (resetTextContent(parentFiber), hostParentFiber.flags &= -33);
                hostParentFiber = getHostSibling(finishedWork);
                insertOrAppendPlacementNode(finishedWork, hostParentFiber, parentFiber);
                break;
            case 3:
            case 4:
                hostParentFiber = hostParentFiber.stateNode.containerInfo;
                parentFiber = getHostSibling(finishedWork);
                insertOrAppendPlacementNodeIntoContainer(finishedWork, parentFiber, hostParentFiber);
                break;
            default:
                throw Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function commitHostSingletonAcquisition(finishedWork) {
        var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
        try {
            runWithFiberInDEV(finishedWork, acquireSingletonInstance, finishedWork.type, props, singleton, finishedWork);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function isHydratingParent(current, finishedWork) {
        return 31 === finishedWork.tag ? (finishedWork = finishedWork.memoizedState, null !== current.memoizedState && null === finishedWork) : 13 === finishedWork.tag ? (current = current.memoizedState, finishedWork = finishedWork.memoizedState, null !== current && null !== current.dehydrated && (null === finishedWork || null === finishedWork.dehydrated)) : 3 === finishedWork.tag ? current.memoizedState.isDehydrated && 0 === (finishedWork.flags & 256) : !1;
    }
    function commitBeforeMutationEffects(root, firstChild) {
        root = root.containerInfo;
        eventsEnabled = _enabled;
        root = getActiveElementDeep(root);
        if (hasSelectionCapabilities(root)) {
            if ("selectionStart" in root) var JSCompiler_temp = {
                start: root.selectionStart,
                end: root.selectionEnd
            };
            else a: {
                JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
                var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
                if (selection && 0 !== selection.rangeCount) {
                    JSCompiler_temp = selection.anchorNode;
                    var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                    selection = selection.focusOffset;
                    try {
                        JSCompiler_temp.nodeType, focusNode.nodeType;
                    } catch (e$2) {
                        JSCompiler_temp = null;
                        break a;
                    }
                    var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                    b: for(;;){
                        for(var next;;){
                            node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                            node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                            3 === node.nodeType && (length += node.nodeValue.length);
                            if (null === (next = node.firstChild)) break;
                            parentNode = node;
                            node = next;
                        }
                        for(;;){
                            if (node === root) break b;
                            parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                            parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                            if (null !== (next = node.nextSibling)) break;
                            node = parentNode;
                            parentNode = node.parentNode;
                        }
                        node = next;
                    }
                    JSCompiler_temp = -1 === start || -1 === end ? null : {
                        start: start,
                        end: end
                    };
                } else JSCompiler_temp = null;
            }
            JSCompiler_temp = JSCompiler_temp || {
                start: 0,
                end: 0
            };
        } else JSCompiler_temp = null;
        selectionInformation = {
            focusedElem: root,
            selectionRange: JSCompiler_temp
        };
        _enabled = !1;
        for(nextEffect = firstChild; null !== nextEffect;)if (firstChild = nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, nextEffect = root;
        else for(; null !== nextEffect;){
            root = firstChild = nextEffect;
            JSCompiler_temp = root.alternate;
            anchorOffset = root.flags;
            switch(root.tag){
                case 0:
                    if (0 !== (anchorOffset & 4) && (root = root.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                    break;
                case 11:
                case 15:
                    break;
                case 1:
                    0 !== (anchorOffset & 1024) && null !== JSCompiler_temp && commitClassSnapshot(root, JSCompiler_temp);
                    break;
                case 3:
                    if (0 !== (anchorOffset & 1024)) {
                        if (root = root.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) clearContainerSparingly(root);
                        else if (1 === JSCompiler_temp) switch(root.nodeName){
                            case "HEAD":
                            case "HTML":
                            case "BODY":
                                clearContainerSparingly(root);
                                break;
                            default:
                                root.textContent = "";
                        }
                    }
                    break;
                case 5:
                case 26:
                case 27:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    if (0 !== (anchorOffset & 1024)) throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
            root = firstChild.sibling;
            if (null !== root) {
                root.return = firstChild.return;
                nextEffect = root;
                break;
            }
            nextEffect = firstChild.return;
        }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                flags & 4 && commitHookLayoutEffects(finishedWork, Layout | HasEffect);
                break;
            case 1:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                if (flags & 4) {
                    if (finishedRoot = finishedWork.stateNode, null === current) finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (finishedRoot.props !== finishedWork.memoizedProps && console.error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"), finishedRoot.state !== finishedWork.memoizedState && console.error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance")), shouldProfile(finishedWork) ? (startEffectTimer(), runWithFiberInDEV(finishedWork, callComponentDidMountInDEV, finishedWork, finishedRoot), recordEffectDuration()) : runWithFiberInDEV(finishedWork, callComponentDidMountInDEV, finishedWork, finishedRoot);
                    else {
                        var prevProps = resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                        current = current.memoizedState;
                        finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (finishedRoot.props !== finishedWork.memoizedProps && console.error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"), finishedRoot.state !== finishedWork.memoizedState && console.error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"));
                        shouldProfile(finishedWork) ? (startEffectTimer(), runWithFiberInDEV(finishedWork, callComponentDidUpdateInDEV, finishedWork, finishedRoot, prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate), recordEffectDuration()) : runWithFiberInDEV(finishedWork, callComponentDidUpdateInDEV, finishedWork, finishedRoot, prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    }
                }
                flags & 64 && commitClassCallbacks(finishedWork);
                flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 3:
                current = pushNestedEffectDurations();
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                    prevProps = null;
                    if (null !== finishedWork.child) switch(finishedWork.child.tag){
                        case 27:
                        case 5:
                            prevProps = finishedWork.child.stateNode;
                            break;
                        case 1:
                            prevProps = finishedWork.child.stateNode;
                    }
                    try {
                        runWithFiberInDEV(finishedWork, commitCallbacks, flags, prevProps);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                finishedRoot.effectDuration += popNestedEffectDurations(current);
                break;
            case 27:
                null === current && flags & 4 && commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                if (null === current) {
                    if (flags & 4) commitHostMount(finishedWork);
                    else if (flags & 64) {
                        finishedRoot = finishedWork.type;
                        current = finishedWork.memoizedProps;
                        prevProps = finishedWork.stateNode;
                        try {
                            runWithFiberInDEV(finishedWork, commitHydratedInstance, prevProps, finishedRoot, current, finishedWork);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                if (flags & 4) {
                    flags = pushNestedEffectDurations();
                    recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                    finishedRoot = finishedWork.stateNode;
                    finishedRoot.effectDuration += bubbleNestedEffectDurations(flags);
                    try {
                        runWithFiberInDEV(finishedWork, commitProfiler, finishedWork, current, commitStartTime, finishedRoot.effectDuration);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                } else recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                break;
            case 31:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (flags = retryDehydratedSuspenseBoundary.bind(null, finishedWork), registerSuspenseInstanceRetry(finishedRoot, flags))));
                break;
            case 22:
                flags = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
                if (!flags) {
                    current = null !== current && null !== current.memoizedState || offscreenSubtreeWasHidden;
                    prevProps = offscreenSubtreeIsHidden;
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeIsHidden = flags;
                    (offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? (recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)), (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentReappeared(finishedWork, componentEffectStartTime, componentEffectEndTime)) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                    offscreenSubtreeIsHidden = prevProps;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                }
                break;
            case 30:
                break;
            default:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors), null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && 0.05 < componentEffectEndTime - componentEffectStartTime && (isHydratingParent(finishedWork.return.alternate, finishedWork.return) || logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Mount")));
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;
        null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
        fiber.child = null;
        fiber.deletions = null;
        fiber.sibling = null;
        5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
        fiber.stateNode = null;
        fiber._debugOwner = null;
        fiber.return = null;
        fiber.dependencies = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.stateNode = null;
        fiber.updateQueue = null;
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        for(parent = parent.child; null !== parent;)commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount) try {
            injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
        } catch (err) {
            hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
        }
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
        switch(deletedFiber.tag){
            case 26:
                offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (finishedRoot = deletedFiber.stateNode, finishedRoot.parentNode.removeChild(finishedRoot));
                break;
            case 27:
                offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
                var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
                isSingletonScope(deletedFiber.type) && (hostParent = deletedFiber.stateNode, hostParentIsContainer = !1);
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                runWithFiberInDEV(deletedFiber, releaseSingletonInstance, deletedFiber.stateNode);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                break;
            case 5:
                offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            case 6:
                prevHostParent = hostParent;
                prevHostParentIsContainer = hostParentIsContainer;
                hostParent = null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                if (null !== hostParent) {
                    if (hostParentIsContainer) try {
                        runWithFiberInDEV(deletedFiber, removeChildFromContainer, hostParent, deletedFiber.stateNode);
                    } catch (error) {
                        captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                    }
                    else try {
                        runWithFiberInDEV(deletedFiber, removeChild, hostParent, deletedFiber.stateNode);
                    } catch (error) {
                        captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                    }
                }
                break;
            case 18:
                null !== hostParent && (hostParentIsContainer ? (finishedRoot = hostParent, clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), retryIfBlockedOn(finishedRoot)) : clearHydrationBoundary(hostParent, deletedFiber.stateNode));
                break;
            case 4:
                prevHostParent = hostParent;
                prevHostParentIsContainer = hostParentIsContainer;
                hostParent = deletedFiber.stateNode.containerInfo;
                hostParentIsContainer = !0;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                break;
            case 0:
            case 11:
            case 14:
            case 15:
                commitHookEffectListUnmount(Insertion, deletedFiber, nearestMountedAncestor);
                offscreenSubtreeWasHidden || commitHookLayoutUnmountEffects(deletedFiber, nearestMountedAncestor, Layout);
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 1:
                offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 21:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 22:
                offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                offscreenSubtreeWasHidden = prevHostParent;
                break;
            default:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
        }
        (deletedFiber.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(deletedFiber, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
        if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
            finishedRoot = finishedRoot.dehydrated;
            try {
                runWithFiberInDEV(finishedWork, commitHydratedActivityInstance, finishedRoot);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
        }
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
            runWithFiberInDEV(finishedWork, commitHydratedSuspenseInstance, finishedRoot);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function getRetryCache(finishedWork) {
        switch(finishedWork.tag){
            case 31:
            case 13:
            case 19:
                var retryCache = finishedWork.stateNode;
                null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
                return retryCache;
            case 22:
                return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
            default:
                throw Error("Unexpected Suspense handler tag (" + finishedWork.tag + "). This is a bug in React.");
        }
    }
    function attachSuspenseRetryListeners(finishedWork, wakeables) {
        var retryCache = getRetryCache(finishedWork);
        wakeables.forEach(function(wakeable) {
            if (!retryCache.has(wakeable)) {
                retryCache.add(wakeable);
                if (isDevToolsPresent) {
                    if (null !== inProgressLanes && null !== inProgressRoot) restorePendingUpdaters(inProgressRoot, inProgressLanes);
                    else throw Error("Expected finished root and lanes to be set. This is a bug in React.");
                }
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                wakeable.then(retry, retry);
            }
        });
    }
    function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
        var deletions = parentFiber.deletions;
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var root = root$jscomp$0, returnFiber = parentFiber, deletedFiber = deletions[i], prevEffectStart = pushComponentEffectStart(), parent = returnFiber;
            a: for(; null !== parent;){
                switch(parent.tag){
                    case 27:
                        if (isSingletonScope(parent.type)) {
                            hostParent = parent.stateNode;
                            hostParentIsContainer = !1;
                            break a;
                        }
                        break;
                    case 5:
                        hostParent = parent.stateNode;
                        hostParentIsContainer = !1;
                        break a;
                    case 3:
                    case 4:
                        hostParent = parent.stateNode.containerInfo;
                        hostParentIsContainer = !0;
                        break a;
                }
                parent = parent.return;
            }
            if (null === hostParent) throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
            commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
            hostParent = null;
            hostParentIsContainer = !1;
            (deletedFiber.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(deletedFiber, componentEffectStartTime, componentEffectEndTime, "Unmount");
            popComponentEffectStart(prevEffectStart);
            root = deletedFiber;
            returnFiber = root.alternate;
            null !== returnFiber && (returnFiber.return = null);
            root.return = null;
        }
        if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
    }
    function commitMutationEffectsOnFiber(finishedWork, root) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), current = finishedWork.alternate, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 4 && (commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork.return), commitHookEffectListMount(Insertion | HasEffect, finishedWork), commitHookLayoutUnmountEffects(finishedWork, finishedWork.return, Layout | HasEffect));
                break;
            case 1:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                if (flags & 64 && offscreenSubtreeIsHidden && (flags = finishedWork.updateQueue, null !== flags && (current = flags.callbacks, null !== current))) {
                    var existingHiddenCallbacks = flags.shared.hiddenCallbacks;
                    flags.shared.hiddenCallbacks = null === existingHiddenCallbacks ? current : existingHiddenCallbacks.concat(current);
                }
                break;
            case 26:
                existingHiddenCallbacks = currentHoistableRoot;
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                if (flags & 4) {
                    var currentResource = null !== current ? current.memoizedState : null;
                    flags = finishedWork.memoizedState;
                    if (null === current) {
                        if (null === flags) {
                            if (null === finishedWork.stateNode) {
                                a: {
                                    flags = finishedWork.type;
                                    current = finishedWork.memoizedProps;
                                    existingHiddenCallbacks = existingHiddenCallbacks.ownerDocument || existingHiddenCallbacks;
                                    b: switch(flags){
                                        case "title":
                                            currentResource = existingHiddenCallbacks.getElementsByTagName("title")[0];
                                            if (!currentResource || currentResource[internalHoistableMarker] || currentResource[internalInstanceKey] || currentResource.namespaceURI === SVG_NAMESPACE || currentResource.hasAttribute("itemprop")) currentResource = existingHiddenCallbacks.createElement(flags), existingHiddenCallbacks.head.insertBefore(currentResource, existingHiddenCallbacks.querySelector("head > title"));
                                            setInitialProperties(currentResource, flags, current);
                                            currentResource[internalInstanceKey] = finishedWork;
                                            markNodeAsHoistable(currentResource);
                                            flags = currentResource;
                                            break a;
                                        case "link":
                                            var maybeNodes = getHydratableHoistableCache("link", "href", existingHiddenCallbacks).get(flags + (current.href || ""));
                                            if (maybeNodes) {
                                                for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                    maybeNodes.splice(i, 1);
                                                    break b;
                                                }
                                            }
                                            currentResource = existingHiddenCallbacks.createElement(flags);
                                            setInitialProperties(currentResource, flags, current);
                                            existingHiddenCallbacks.head.appendChild(currentResource);
                                            break;
                                        case "meta":
                                            if (maybeNodes = getHydratableHoistableCache("meta", "content", existingHiddenCallbacks).get(flags + (current.content || ""))) {
                                                for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], checkAttributeStringCoercion(current.content, "content"), currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                    maybeNodes.splice(i, 1);
                                                    break b;
                                                }
                                            }
                                            currentResource = existingHiddenCallbacks.createElement(flags);
                                            setInitialProperties(currentResource, flags, current);
                                            existingHiddenCallbacks.head.appendChild(currentResource);
                                            break;
                                        default:
                                            throw Error('getNodesForType encountered a type it did not expect: "' + flags + '". This is a bug in React.');
                                    }
                                    currentResource[internalInstanceKey] = finishedWork;
                                    markNodeAsHoistable(currentResource);
                                    flags = currentResource;
                                }
                                finishedWork.stateNode = flags;
                            } else mountHoistable(existingHiddenCallbacks, finishedWork.type, finishedWork.stateNode);
                        } else finishedWork.stateNode = acquireResource(existingHiddenCallbacks, flags, finishedWork.memoizedProps);
                    } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? mountHoistable(existingHiddenCallbacks, finishedWork.type, finishedWork.stateNode) : acquireResource(existingHiddenCallbacks, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
                }
                break;
            case 27:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                null !== current && flags & 4 && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
                break;
            case 5:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                if (finishedWork.flags & 32) {
                    existingHiddenCallbacks = finishedWork.stateNode;
                    try {
                        runWithFiberInDEV(finishedWork, resetTextContent, existingHiddenCallbacks);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                flags & 4 && null != finishedWork.stateNode && (existingHiddenCallbacks = finishedWork.memoizedProps, commitHostUpdate(finishedWork, existingHiddenCallbacks, null !== current ? current.memoizedProps : existingHiddenCallbacks));
                flags & 1024 && (needsFormReset = !0, "form" !== finishedWork.type && console.error("Unexpected host component type. Expected a form. This is a bug in React."));
                break;
            case 6:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & 4) {
                    if (null === finishedWork.stateNode) throw Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                    flags = finishedWork.memoizedProps;
                    current = null !== current ? current.memoizedProps : flags;
                    existingHiddenCallbacks = finishedWork.stateNode;
                    try {
                        runWithFiberInDEV(finishedWork, commitTextUpdate, existingHiddenCallbacks, current, flags);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                break;
            case 3:
                existingHiddenCallbacks = pushNestedEffectDurations();
                tagCaches = null;
                currentResource = currentHoistableRoot;
                currentHoistableRoot = getHoistableRoot(root.containerInfo);
                recursivelyTraverseMutationEffects(root, finishedWork);
                currentHoistableRoot = currentResource;
                commitReconciliationEffects(finishedWork);
                if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                    runWithFiberInDEV(finishedWork, commitHydratedContainer, root.containerInfo);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                needsFormReset && (needsFormReset = !1, recursivelyResetForms(finishedWork));
                root.effectDuration += popNestedEffectDurations(existingHiddenCallbacks);
                break;
            case 4:
                flags = currentHoistableRoot;
                currentHoistableRoot = getHoistableRoot(finishedWork.stateNode.containerInfo);
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                currentHoistableRoot = flags;
                break;
            case 12:
                flags = pushNestedEffectDurations();
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                finishedWork.stateNode.effectDuration += bubbleNestedEffectDurations(flags);
                break;
            case 31:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
                break;
            case 13:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && (globalMostRecentFallbackTime = now$1());
                flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
                break;
            case 22:
                existingHiddenCallbacks = null !== finishedWork.memoizedState;
                var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || existingHiddenCallbacks;
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
                recursivelyTraverseMutationEffects(root, finishedWork);
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                wasHidden && !existingHiddenCallbacks && !prevOffscreenSubtreeIsHidden && !prevOffscreenSubtreeWasHidden && (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentReappeared(finishedWork, componentEffectStartTime, componentEffectEndTime);
                commitReconciliationEffects(finishedWork);
                if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = existingHiddenCallbacks ? root._visibility & ~OffscreenVisible : root._visibility | OffscreenVisible, !existingHiddenCallbacks || null === current || wasHidden || offscreenSubtreeIsHidden || offscreenSubtreeWasHidden || (recursivelyTraverseDisappearLayoutEffects(finishedWork), (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Disconnect")), current = null, root = finishedWork;;){
                    if (5 === root.tag || 26 === root.tag) {
                        if (null === current) {
                            wasHidden = current = root;
                            try {
                                currentResource = wasHidden.stateNode, existingHiddenCallbacks ? runWithFiberInDEV(wasHidden, hideInstance, currentResource) : runWithFiberInDEV(wasHidden, unhideInstance, wasHidden.stateNode, wasHidden.memoizedProps);
                            } catch (error) {
                                captureCommitPhaseError(wasHidden, wasHidden.return, error);
                            }
                        }
                    } else if (6 === root.tag) {
                        if (null === current) {
                            wasHidden = root;
                            try {
                                maybeNodes = wasHidden.stateNode, existingHiddenCallbacks ? runWithFiberInDEV(wasHidden, hideTextInstance, maybeNodes) : runWithFiberInDEV(wasHidden, unhideTextInstance, maybeNodes, wasHidden.memoizedProps);
                            } catch (error) {
                                captureCommitPhaseError(wasHidden, wasHidden.return, error);
                            }
                        }
                    } else if (18 === root.tag) {
                        if (null === current) {
                            wasHidden = root;
                            try {
                                i = wasHidden.stateNode, existingHiddenCallbacks ? runWithFiberInDEV(wasHidden, hideDehydratedBoundary, i) : runWithFiberInDEV(wasHidden, unhideDehydratedBoundary, wasHidden.stateNode);
                            } catch (error) {
                                captureCommitPhaseError(wasHidden, wasHidden.return, error);
                            }
                        }
                    } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                        root.child.return = root;
                        root = root.child;
                        continue;
                    }
                    if (root === finishedWork) break a;
                    for(; null === root.sibling;){
                        if (null === root.return || root.return === finishedWork) break a;
                        current === root && (current = null);
                        root = root.return;
                    }
                    current === root && (current = null);
                    root.sibling.return = root.return;
                    root = root.sibling;
                }
                flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, attachSuspenseRetryListeners(finishedWork, current))));
                break;
            case 19:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
                break;
            case 30:
                break;
            case 21:
                break;
            default:
                recursivelyTraverseMutationEffects(root, finishedWork), commitReconciliationEffects(finishedWork);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors), null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && 0.05 < componentEffectEndTime - componentEffectStartTime && (isHydratingParent(finishedWork.return.alternate, finishedWork.return) || logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Mount")));
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function commitReconciliationEffects(finishedWork) {
        var flags = finishedWork.flags;
        if (flags & 2) {
            try {
                runWithFiberInDEV(finishedWork, commitPlacement, finishedWork);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            finishedWork.flags &= -3;
        }
        flags & 4096 && (finishedWork.flags &= -4097);
    }
    function recursivelyResetForms(parentFiber) {
        if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
            var fiber = parentFiber;
            recursivelyResetForms(fiber);
            5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
            parentFiber = parentFiber.sibling;
        }
    }
    function recursivelyTraverseLayoutEffects(root, parentFiber) {
        if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
    }
    function disappearLayoutEffects(finishedWork) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                commitHookLayoutUnmountEffects(finishedWork, finishedWork.return, Layout);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                runWithFiberInDEV(finishedWork, releaseSingletonInstance, finishedWork.stateNode);
            case 26:
            case 5:
                safelyDetachRef(finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
        for(parentFiber = parentFiber.child; null !== parentFiber;)disappearLayoutEffects(parentFiber), parentFiber = parentFiber.sibling;
    }
    function reappearLayoutEffects(finishedRoot, current, finishedWork, includeWorkInProgressEffects) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                commitHookLayoutEffects(finishedWork, Layout);
                break;
            case 1:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork.stateNode;
                "function" === typeof current.componentDidMount && runWithFiberInDEV(finishedWork, callComponentDidMountInDEV, finishedWork, current);
                current = finishedWork.updateQueue;
                if (null !== current) {
                    finishedRoot = finishedWork.stateNode;
                    try {
                        runWithFiberInDEV(finishedWork, commitHiddenCallbacks, current, finishedRoot);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && commitClassCallbacks(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && commitHostMount(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                if (includeWorkInProgressEffects && flags & 4) {
                    flags = pushNestedEffectDurations();
                    recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                    includeWorkInProgressEffects = finishedWork.stateNode;
                    includeWorkInProgressEffects.effectDuration += bubbleNestedEffectDurations(flags);
                    try {
                        runWithFiberInDEV(finishedWork, commitProfiler, finishedWork, current, commitStartTime, includeWorkInProgressEffects.effectDuration);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                } else recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function recursivelyTraverseReappearLayoutEffects(finishedRoot, parentFiber, includeWorkInProgressEffects) {
        includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
        for(parentFiber = parentFiber.child; null !== parentFiber;)reappearLayoutEffects(finishedRoot, parentFiber.alternate, parentFiber, includeWorkInProgressEffects), parentFiber = parentFiber.sibling;
    }
    function commitOffscreenPassiveMountEffects(current, finishedWork) {
        var previousCache = null;
        null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
        current = null;
        null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
        current !== previousCache && (null != current && retainCache(current), null != previousCache && releaseCache(previousCache));
    }
    function commitCachePassiveMountEffect(current, finishedWork) {
        current = null;
        null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
        finishedWork = finishedWork.memoizedState.cache;
        finishedWork !== current && (retainCache(finishedWork), null != current && releaseCache(current));
    }
    function recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions, endTime) {
        if (parentFiber.subtreeFlags & 10256 || 0 !== parentFiber.actualDuration && (null === parentFiber.alternate || parentFiber.alternate.child !== parentFiber.child)) for(parentFiber = parentFiber.child; null !== parentFiber;){
            var nextSibling = parentFiber.sibling;
            commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions, null !== nextSibling ? nextSibling.actualStartTime : endTime);
            parentFiber = nextSibling;
        }
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), prevDeepEquality = alreadyWarnedForDeepEquality, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                (finishedWork.mode & ProfileMode) !== NoMode && 0 < finishedWork.actualStartTime && 0 !== (finishedWork.flags & 1) && logComponentRender(finishedWork, finishedWork.actualStartTime, endTime, inHydratedSubtree, committedLanes);
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                flags & 2048 && commitHookPassiveMountEffects(finishedWork, Passive | HasEffect);
                break;
            case 1:
                (finishedWork.mode & ProfileMode) !== NoMode && 0 < finishedWork.actualStartTime && (0 !== (finishedWork.flags & 128) ? logComponentErrored(finishedWork, finishedWork.actualStartTime, endTime, []) : 0 !== (finishedWork.flags & 1) && logComponentRender(finishedWork, finishedWork.actualStartTime, endTime, inHydratedSubtree, committedLanes));
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                break;
            case 3:
                var prevProfilerEffectDuration = pushNestedEffectDurations(), wasInHydratedSubtree = inHydratedSubtree;
                inHydratedSubtree = null !== finishedWork.alternate && finishedWork.alternate.memoizedState.isDehydrated && 0 === (finishedWork.flags & 256);
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                inHydratedSubtree = wasInHydratedSubtree;
                flags & 2048 && (committedLanes = null, null !== finishedWork.alternate && (committedLanes = finishedWork.alternate.memoizedState.cache), committedTransitions = finishedWork.memoizedState.cache, committedTransitions !== committedLanes && (retainCache(committedTransitions), null != committedLanes && releaseCache(committedLanes)));
                finishedRoot.passiveEffectDuration += popNestedEffectDurations(prevProfilerEffectDuration);
                break;
            case 12:
                if (flags & 2048) {
                    flags = pushNestedEffectDurations();
                    recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                    finishedRoot = finishedWork.stateNode;
                    finishedRoot.passiveEffectDuration += bubbleNestedEffectDurations(flags);
                    try {
                        runWithFiberInDEV(finishedWork, commitProfilerPostCommitImpl, finishedWork, finishedWork.alternate, commitStartTime, finishedRoot.passiveEffectDuration);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                } else recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                break;
            case 31:
                flags = inHydratedSubtree;
                prevProfilerEffectDuration = null !== finishedWork.alternate ? finishedWork.alternate.memoizedState : null;
                wasInHydratedSubtree = finishedWork.memoizedState;
                null !== prevProfilerEffectDuration && null === wasInHydratedSubtree ? (wasInHydratedSubtree = finishedWork.deletions, null !== wasInHydratedSubtree && 0 < wasInHydratedSubtree.length && 18 === wasInHydratedSubtree[0].tag ? (inHydratedSubtree = !1, prevProfilerEffectDuration = prevProfilerEffectDuration.hydrationErrors, null !== prevProfilerEffectDuration && logComponentErrored(finishedWork, finishedWork.actualStartTime, endTime, prevProfilerEffectDuration)) : inHydratedSubtree = !0) : inHydratedSubtree = !1;
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                inHydratedSubtree = flags;
                break;
            case 13:
                flags = inHydratedSubtree;
                prevProfilerEffectDuration = null !== finishedWork.alternate ? finishedWork.alternate.memoizedState : null;
                wasInHydratedSubtree = finishedWork.memoizedState;
                null === prevProfilerEffectDuration || null === prevProfilerEffectDuration.dehydrated || null !== wasInHydratedSubtree && null !== wasInHydratedSubtree.dehydrated ? inHydratedSubtree = !1 : (wasInHydratedSubtree = finishedWork.deletions, null !== wasInHydratedSubtree && 0 < wasInHydratedSubtree.length && 18 === wasInHydratedSubtree[0].tag ? (inHydratedSubtree = !1, prevProfilerEffectDuration = prevProfilerEffectDuration.hydrationErrors, null !== prevProfilerEffectDuration && logComponentErrored(finishedWork, finishedWork.actualStartTime, endTime, prevProfilerEffectDuration)) : inHydratedSubtree = !0);
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                inHydratedSubtree = flags;
                break;
            case 23:
                break;
            case 22:
                wasInHydratedSubtree = finishedWork.stateNode;
                prevProfilerEffectDuration = finishedWork.alternate;
                null !== finishedWork.memoizedState ? wasInHydratedSubtree._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) : wasInHydratedSubtree._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) : (wasInHydratedSubtree._visibility |= OffscreenPassiveEffectsConnected, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || 0 !== finishedWork.actualDuration && (null === finishedWork.alternate || finishedWork.alternate.child !== finishedWork.child), endTime), (finishedWork.mode & ProfileMode) === NoMode || inHydratedSubtree || (finishedRoot = finishedWork.actualStartTime, 0 <= finishedRoot && 0.05 < endTime - finishedRoot && logComponentReappeared(finishedWork, finishedRoot, endTime), 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentReappeared(finishedWork, componentEffectStartTime, componentEffectEndTime)));
                flags & 2048 && commitOffscreenPassiveMountEffects(prevProfilerEffectDuration, finishedWork);
                break;
            case 24:
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
        }
        if ((finishedWork.mode & ProfileMode) !== NoMode) {
            if (finishedRoot = !inHydratedSubtree && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate) committedLanes = finishedWork.actualStartTime, 0 <= committedLanes && 0.05 < endTime - committedLanes && logComponentTrigger(finishedWork, committedLanes, endTime, "Mount");
            0 <= componentEffectStartTime && 0 <= componentEffectEndTime && ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors), finishedRoot && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Mount"));
        }
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
        alreadyWarnedForDeepEquality = prevDeepEquality;
    }
    function recursivelyTraverseReconnectPassiveEffects(finishedRoot, parentFiber, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime) {
        includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || 0 !== parentFiber.actualDuration && (null === parentFiber.alternate || parentFiber.alternate.child !== parentFiber.child));
        for(parentFiber = parentFiber.child; null !== parentFiber;){
            var nextSibling = parentFiber.sibling;
            reconnectPassiveEffects(finishedRoot, parentFiber, committedLanes, committedTransitions, includeWorkInProgressEffects, null !== nextSibling ? nextSibling.actualStartTime : endTime);
            parentFiber = nextSibling;
        }
    }
    function reconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), prevDeepEquality = alreadyWarnedForDeepEquality;
        includeWorkInProgressEffects && (finishedWork.mode & ProfileMode) !== NoMode && 0 < finishedWork.actualStartTime && 0 !== (finishedWork.flags & 1) && logComponentRender(finishedWork, finishedWork.actualStartTime, endTime, inHydratedSubtree, committedLanes);
        var flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime);
                commitHookPassiveMountEffects(finishedWork, Passive);
                break;
            case 23:
                break;
            case 22:
                var _instance2 = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? _instance2._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) : (_instance2._visibility |= OffscreenPassiveEffectsConnected, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime));
                includeWorkInProgressEffects && flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime);
                includeWorkInProgressEffects && flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
        alreadyWarnedForDeepEquality = prevDeepEquality;
    }
    function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, endTime$jscomp$0) {
        if (parentFiber.subtreeFlags & 10256 || 0 !== parentFiber.actualDuration && (null === parentFiber.alternate || parentFiber.alternate.child !== parentFiber.child)) for(var child = parentFiber.child; null !== child;){
            parentFiber = child.sibling;
            var finishedRoot = finishedRoot$jscomp$0, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, endTime = null !== parentFiber ? parentFiber.actualStartTime : endTime$jscomp$0, prevDeepEquality = alreadyWarnedForDeepEquality;
            (child.mode & ProfileMode) !== NoMode && 0 < child.actualStartTime && 0 !== (child.flags & 1) && logComponentRender(child, child.actualStartTime, endTime, inHydratedSubtree, committedLanes);
            var flags = child.flags;
            switch(child.tag){
                case 22:
                    recursivelyTraverseAtomicPassiveEffects(finishedRoot, child, committedLanes, committedTransitions, endTime);
                    flags & 2048 && commitOffscreenPassiveMountEffects(child.alternate, child);
                    break;
                case 24:
                    recursivelyTraverseAtomicPassiveEffects(finishedRoot, child, committedLanes, committedTransitions, endTime);
                    flags & 2048 && commitCachePassiveMountEffect(child.alternate, child);
                    break;
                default:
                    recursivelyTraverseAtomicPassiveEffects(finishedRoot, child, committedLanes, committedTransitions, endTime);
            }
            alreadyWarnedForDeepEquality = prevDeepEquality;
            child = parentFiber;
        }
    }
    function recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
        if (parentFiber.subtreeFlags & suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
    }
    function accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
        switch(fiber.tag){
            case 26:
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
                fiber.flags & suspenseyCommitFlag && null !== fiber.memoizedState && suspendResource(suspendedState, currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
                break;
            case 5:
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
                break;
            case 3:
            case 4:
                var previousHoistableRoot = currentHoistableRoot;
                currentHoistableRoot = getHoistableRoot(fiber.stateNode.containerInfo);
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
                currentHoistableRoot = previousHoistableRoot;
                break;
            case 22:
                null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), suspenseyCommitFlag = previousHoistableRoot) : recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
                break;
            default:
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
        }
    }
    function detachAlternateSiblings(parentFiber) {
        var previousFiber = parentFiber.alternate;
        if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
            previousFiber.child = null;
            do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
            while (null !== parentFiber);
        }
    }
    function recursivelyTraversePassiveUnmountEffects(parentFiber) {
        var deletions = parentFiber.deletions;
        if (0 !== (parentFiber.flags & 16)) {
            if (null !== deletions) for(var i = 0; i < deletions.length; i++){
                var childToDelete = deletions[i], prevEffectStart = pushComponentEffectStart();
                nextEffect = childToDelete;
                commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
                (childToDelete.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(childToDelete, componentEffectStartTime, componentEffectEndTime, "Unmount");
                popComponentEffectStart(prevEffectStart);
            }
            detachAlternateSiblings(parentFiber);
        }
        if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraversePassiveUnmountEffects(finishedWork);
                finishedWork.flags & 2048 && commitHookPassiveUnmountEffects(finishedWork, finishedWork.return, Passive | HasEffect);
                break;
            case 3:
                var prevProfilerEffectDuration = pushNestedEffectDurations();
                recursivelyTraversePassiveUnmountEffects(finishedWork);
                finishedWork.stateNode.passiveEffectDuration += popNestedEffectDurations(prevProfilerEffectDuration);
                break;
            case 12:
                prevProfilerEffectDuration = pushNestedEffectDurations();
                recursivelyTraversePassiveUnmountEffects(finishedWork);
                finishedWork.stateNode.passiveEffectDuration += bubbleNestedEffectDurations(prevProfilerEffectDuration);
                break;
            case 22:
                prevProfilerEffectDuration = finishedWork.stateNode;
                null !== finishedWork.memoizedState && prevProfilerEffectDuration._visibility & OffscreenPassiveEffectsConnected && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (prevProfilerEffectDuration._visibility &= ~OffscreenPassiveEffectsConnected, recursivelyTraverseDisconnectPassiveEffects(finishedWork), (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Disconnect")) : recursivelyTraversePassiveUnmountEffects(finishedWork);
                break;
            default:
                recursivelyTraversePassiveUnmountEffects(finishedWork);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
        componentEffectErrors = prevEffectErrors;
    }
    function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
        var deletions = parentFiber.deletions;
        if (0 !== (parentFiber.flags & 16)) {
            if (null !== deletions) for(var i = 0; i < deletions.length; i++){
                var childToDelete = deletions[i], prevEffectStart = pushComponentEffectStart();
                nextEffect = childToDelete;
                commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
                (childToDelete.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(childToDelete, componentEffectStartTime, componentEffectEndTime, "Unmount");
                popComponentEffectStart(prevEffectStart);
            }
            detachAlternateSiblings(parentFiber);
        }
        for(parentFiber = parentFiber.child; null !== parentFiber;)disconnectPassiveEffect(parentFiber), parentFiber = parentFiber.sibling;
    }
    function disconnectPassiveEffect(finishedWork) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                commitHookPassiveUnmountEffects(finishedWork, finishedWork.return, Passive);
                recursivelyTraverseDisconnectPassiveEffects(finishedWork);
                break;
            case 22:
                var instance = finishedWork.stateNode;
                instance._visibility & OffscreenPassiveEffectsConnected && (instance._visibility &= ~OffscreenPassiveEffectsConnected, recursivelyTraverseDisconnectPassiveEffects(finishedWork));
                break;
            default:
                recursivelyTraverseDisconnectPassiveEffects(finishedWork);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
        componentEffectErrors = prevEffectErrors;
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor$jscomp$0) {
        for(; null !== nextEffect;){
            var fiber = nextEffect, current = fiber, nearestMountedAncestor = nearestMountedAncestor$jscomp$0, prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
            switch(current.tag){
                case 0:
                case 11:
                case 15:
                    commitHookPassiveUnmountEffects(current, nearestMountedAncestor, Passive);
                    break;
                case 23:
                case 22:
                    null !== current.memoizedState && null !== current.memoizedState.cachePool && (nearestMountedAncestor = current.memoizedState.cachePool.pool, null != nearestMountedAncestor && retainCache(nearestMountedAncestor));
                    break;
                case 24:
                    releaseCache(current.memoizedState.cache);
            }
            (current.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(current, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
            popComponentEffectStart(prevEffectStart);
            popComponentEffectDuration(prevEffectDuration);
            componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
            componentEffectErrors = prevEffectErrors;
            current = fiber.child;
            if (null !== current) current.return = fiber, nextEffect = current;
            else a: for(fiber = deletedSubtreeRoot; null !== nextEffect;){
                current = nextEffect;
                prevEffectStart = current.sibling;
                prevEffectDuration = current.return;
                detachFiberAfterEffects(current);
                if (current === fiber) {
                    nextEffect = null;
                    break a;
                }
                if (null !== prevEffectStart) {
                    prevEffectStart.return = prevEffectDuration;
                    nextEffect = prevEffectStart;
                    break a;
                }
                nextEffect = prevEffectDuration;
            }
        }
    }
    function onCommitRoot() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    function isConcurrentActEnvironment() {
        var isReactActEnvironmentGlobal = "undefined" !== typeof IS_REACT_ACT_ENVIRONMENT ? IS_REACT_ACT_ENVIRONMENT : void 0;
        isReactActEnvironmentGlobal || null === ReactSharedInternals.actQueue || console.error("The current testing environment is not configured to support act(...)");
        return isReactActEnvironmentGlobal;
    }
    function requestUpdateLane(fiber) {
        if ((executionContext & RenderContext) !== NoContext && 0 !== workInProgressRootRenderLanes) return workInProgressRootRenderLanes & -workInProgressRootRenderLanes;
        var transition = ReactSharedInternals.T;
        return null !== transition ? (transition._updatedFibers || (transition._updatedFibers = new Set()), transition._updatedFibers.add(fiber), requestTransitionLane()) : resolveUpdatePriority();
    }
    function requestDeferredLane() {
        if (0 === workInProgressDeferredLane) {
            if (0 === (workInProgressRootRenderLanes & 536870912) || isHydrating) {
                var lane = nextTransitionDeferredLane;
                nextTransitionDeferredLane <<= 1;
                0 === (nextTransitionDeferredLane & 3932160) && (nextTransitionDeferredLane = 262144);
                workInProgressDeferredLane = lane;
            } else workInProgressDeferredLane = 536870912;
        }
        lane = suspenseHandlerStackCursor.current;
        null !== lane && (lane.flags |= 32);
        return workInProgressDeferredLane;
    }
    function scheduleUpdateOnFiber(root, fiber, lane) {
        isRunningInsertionEffect && console.error("useInsertionEffect must not schedule updates.");
        isFlushingPassiveEffects && (didScheduleUpdateDuringPassiveEffects = !0);
        if (root === workInProgressRoot && (workInProgressSuspendedReason === SuspendedOnData || workInProgressSuspendedReason === SuspendedOnAction) || null !== root.cancelPendingCommit) prepareFreshStack(root, 0), markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
        markRootUpdated$1(root, lane);
        if ((executionContext & RenderContext) !== NoContext && root === workInProgressRoot) {
            if (isRendering) switch(fiber.tag){
                case 0:
                case 11:
                case 15:
                    root = workInProgress && getComponentNameFromFiber(workInProgress) || "Unknown";
                    didWarnAboutUpdateInRenderForAnotherComponent.has(root) || (didWarnAboutUpdateInRenderForAnotherComponent.add(root), fiber = getComponentNameFromFiber(fiber) || "Unknown", console.error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://react.dev/link/setstate-in-render", fiber, root, root));
                    break;
                case 1:
                    didWarnAboutUpdateInRender || (console.error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), didWarnAboutUpdateInRender = !0);
            }
        } else isDevToolsPresent && addFiberToLanesMap(root, fiber, lane), warnIfUpdatesNotWrappedWithActDEV(fiber), root === workInProgressRoot && ((executionContext & RenderContext) === NoContext && (workInProgressRootInterleavedUpdatedLanes |= lane), workInProgressRootExitStatus === RootSuspendedWithDelay && markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1)), ensureRootIsScheduled(root);
    }
    function performWorkOnRoot(root, lanes, forceSync) {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw Error("Should not already be working.");
        if (0 !== workInProgressRootRenderLanes && null !== workInProgress) {
            var yieldedFiber = workInProgress, yieldEndTime = now$1();
            switch(yieldReason){
                case SuspendedOnImmediate:
                case SuspendedOnData:
                    var startTime = yieldStartTime;
                    supportsUserTiming && ((yieldedFiber = yieldedFiber._debugTask) ? yieldedFiber.run(console.timeStamp.bind(console, "Suspended", startTime, yieldEndTime, COMPONENTS_TRACK, void 0, "primary-light")) : console.timeStamp("Suspended", startTime, yieldEndTime, COMPONENTS_TRACK, void 0, "primary-light"));
                    break;
                case SuspendedOnAction:
                    startTime = yieldStartTime;
                    supportsUserTiming && ((yieldedFiber = yieldedFiber._debugTask) ? yieldedFiber.run(console.timeStamp.bind(console, "Action", startTime, yieldEndTime, COMPONENTS_TRACK, void 0, "primary-light")) : console.timeStamp("Action", startTime, yieldEndTime, COMPONENTS_TRACK, void 0, "primary-light"));
                    break;
                default:
                    supportsUserTiming && (yieldedFiber = yieldEndTime - yieldStartTime, 3 > yieldedFiber || console.timeStamp("Blocked", yieldStartTime, yieldEndTime, COMPONENTS_TRACK, void 0, 5 > yieldedFiber ? "primary-light" : 10 > yieldedFiber ? "primary" : 100 > yieldedFiber ? "primary-dark" : "error"));
            }
        }
        startTime = (forceSync = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root.expiredLanes) || checkIfRootIsPrerendering(root, lanes)) ? renderRootConcurrent(root, lanes) : renderRootSync(root, lanes, !0);
        var renderWasConcurrent = forceSync;
        do {
            if (startTime === RootInProgress) {
                workInProgressRootIsPrerendering && !forceSync && markRootSuspended(root, lanes, 0, !1);
                lanes = workInProgressSuspendedReason;
                yieldStartTime = now();
                yieldReason = lanes;
                break;
            } else {
                yieldedFiber = now$1();
                yieldEndTime = root.current.alternate;
                if (renderWasConcurrent && !isRenderConsistentWithExternalStores(yieldEndTime)) {
                    setCurrentTrackFromLanes(lanes);
                    yieldEndTime = renderStartTime;
                    startTime = yieldedFiber;
                    !supportsUserTiming || startTime <= yieldEndTime || (workInProgressUpdateTask ? workInProgressUpdateTask.run(console.timeStamp.bind(console, "Teared Render", yieldEndTime, startTime, currentTrack, LANES_TRACK_GROUP, "error")) : console.timeStamp("Teared Render", yieldEndTime, startTime, currentTrack, LANES_TRACK_GROUP, "error"));
                    finalizeRender(lanes, yieldedFiber);
                    startTime = renderRootSync(root, lanes, !1);
                    renderWasConcurrent = !1;
                    continue;
                }
                if (startTime === RootErrored) {
                    renderWasConcurrent = lanes;
                    if (root.errorRecoveryDisabledLanes & renderWasConcurrent) var errorRetryLanes = 0;
                    else errorRetryLanes = root.pendingLanes & -536870913, errorRetryLanes = 0 !== errorRetryLanes ? errorRetryLanes : errorRetryLanes & 536870912 ? 536870912 : 0;
                    if (0 !== errorRetryLanes) {
                        setCurrentTrackFromLanes(lanes);
                        logErroredRenderPhase(renderStartTime, yieldedFiber, lanes, workInProgressUpdateTask);
                        finalizeRender(lanes, yieldedFiber);
                        lanes = errorRetryLanes;
                        a: {
                            yieldedFiber = root;
                            startTime = renderWasConcurrent;
                            renderWasConcurrent = workInProgressRootConcurrentErrors;
                            var wasRootDehydrated = yieldedFiber.current.memoizedState.isDehydrated;
                            wasRootDehydrated && (prepareFreshStack(yieldedFiber, errorRetryLanes).flags |= 256);
                            errorRetryLanes = renderRootSync(yieldedFiber, errorRetryLanes, !1);
                            if (errorRetryLanes !== RootErrored) {
                                if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                    yieldedFiber.errorRecoveryDisabledLanes |= startTime;
                                    workInProgressRootInterleavedUpdatedLanes |= startTime;
                                    startTime = RootSuspendedWithDelay;
                                    break a;
                                }
                                yieldedFiber = workInProgressRootRecoverableErrors;
                                workInProgressRootRecoverableErrors = renderWasConcurrent;
                                null !== yieldedFiber && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = yieldedFiber : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, yieldedFiber));
                            }
                            startTime = errorRetryLanes;
                        }
                        renderWasConcurrent = !1;
                        if (startTime !== RootErrored) continue;
                        else yieldedFiber = now$1();
                    }
                }
                if (startTime === RootFatalErrored) {
                    setCurrentTrackFromLanes(lanes);
                    logErroredRenderPhase(renderStartTime, yieldedFiber, lanes, workInProgressUpdateTask);
                    finalizeRender(lanes, yieldedFiber);
                    prepareFreshStack(root, 0);
                    markRootSuspended(root, lanes, 0, !0);
                    break;
                }
                a: {
                    forceSync = root;
                    switch(startTime){
                        case RootInProgress:
                        case RootFatalErrored:
                            throw Error("Root did not complete. This is a bug in React.");
                        case RootSuspendedWithDelay:
                            if ((lanes & 4194048) !== lanes) break;
                        case RootSuspendedAtTheShell:
                            setCurrentTrackFromLanes(lanes);
                            logSuspendedRenderPhase(renderStartTime, yieldedFiber, lanes, workInProgressUpdateTask);
                            finalizeRender(lanes, yieldedFiber);
                            yieldEndTime = lanes;
                            0 !== (yieldEndTime & 127) ? blockingSuspendedTime = yieldedFiber : 0 !== (yieldEndTime & 4194048) && (transitionSuspendedTime = yieldedFiber);
                            markRootSuspended(forceSync, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        case RootErrored:
                            workInProgressRootRecoverableErrors = null;
                            break;
                        case RootSuspended:
                        case RootCompleted:
                            break;
                        default:
                            throw Error("Unknown root exit status.");
                    }
                    if (null !== ReactSharedInternals.actQueue) commitRoot(forceSync, yieldEndTime, lanes, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, startTime, null, null, renderStartTime, yieldedFiber);
                    else {
                        if ((lanes & 62914560) === lanes && (renderWasConcurrent = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now$1(), 10 < renderWasConcurrent)) {
                            markRootSuspended(forceSync, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                            if (0 !== getNextLanes(forceSync, 0, !0)) break a;
                            pendingEffectsLanes = lanes;
                            forceSync.timeoutHandle = scheduleTimeout(commitRootWhenReady.bind(null, forceSync, yieldEndTime, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, startTime, "Throttled", renderStartTime, yieldedFiber), renderWasConcurrent);
                            break a;
                        }
                        commitRootWhenReady(forceSync, yieldEndTime, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, startTime, null, renderStartTime, yieldedFiber);
                    }
                }
            }
            break;
        }while (1);
        ensureRootIsScheduled(root);
    }
    function commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
        root.timeoutHandle = noTimeout;
        var subtreeFlags = finishedWork.subtreeFlags, suspendedState = null;
        if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
            if (suspendedState = {
                stylesheets: null,
                count: 0,
                imgCount: 0,
                imgBytes: 0,
                suspenseyImages: [],
                waitingForImages: !0,
                waitingForViewTransition: !1,
                unsuspend: noop$1
            }, accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedState), subtreeFlags = (lanes & 62914560) === lanes ? globalMostRecentFallbackTime - now$1() : (lanes & 4194048) === lanes ? globalMostRecentTransitionTime - now$1() : 0, subtreeFlags = waitForCommitToBeReady(suspendedState, subtreeFlags), null !== subtreeFlags) {
                pendingEffectsLanes = lanes;
                root.cancelPendingCommit = subtreeFlags(commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedState, suspendedState.waitingForViewTransition ? "Waiting for the previous Animation" : 0 < suspendedState.count ? 0 < suspendedState.imgCount ? "Suspended on CSS and Images" : "Suspended on CSS" : 1 === suspendedState.imgCount ? "Suspended on an Image" : 0 < suspendedState.imgCount ? "Suspended on Images" : null, completedRenderStartTime, completedRenderEndTime));
                markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
                return;
            }
        }
        commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedState, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
        for(var node = finishedWork;;){
            var tag = node.tag;
            if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
                var check = tag[i], getSnapshot = check.getSnapshot;
                check = check.value;
                try {
                    if (!objectIs(getSnapshot(), check)) return !1;
                } catch (error) {
                    return !1;
                }
            }
            tag = node.child;
            if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
            else {
                if (node === finishedWork) break;
                for(; null === node.sibling;){
                    if (null === node.return || node.return === finishedWork) return !0;
                    node = node.return;
                }
                node.sibling.return = node.return;
                node = node.sibling;
            }
        }
        return !0;
    }
    function markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
        suspendedLanes &= ~workInProgressRootPingedLanes;
        suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes;
        didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
        didAttemptEntireTree = root.expirationTimes;
        for(var lanes = suspendedLanes; 0 < lanes;){
            var index = 31 - clz32(lanes), lane = 1 << index;
            didAttemptEntireTree[index] = -1;
            lanes &= ~lane;
        }
        0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
    }
    function flushSyncWork$1() {
        return (executionContext & (RenderContext | CommitContext)) === NoContext ? (flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
    }
    function resetWorkInProgressStack() {
        if (null !== workInProgress) {
            if (workInProgressSuspendedReason === NotSuspended) var interruptedWork = workInProgress.return;
            else interruptedWork = workInProgress, resetContextDependencies(), resetHooksOnUnwind(interruptedWork), thenableState$1 = null, thenableIndexCounter$1 = 0, interruptedWork = workInProgress;
            for(; null !== interruptedWork;)unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
            workInProgress = null;
        }
    }
    function finalizeRender(lanes, finalizationTime) {
        0 !== (lanes & 127) && (blockingClampTime = finalizationTime);
        0 !== (lanes & 4194048) && (transitionClampTime = finalizationTime);
        0 !== (lanes & 62914560) && (retryClampTime = finalizationTime);
        0 !== (lanes & 2080374784) && (idleClampTime = finalizationTime);
    }
    function prepareFreshStack(root, lanes) {
        supportsUserTiming && (console.timeStamp("Blocking Track", 0.003, 0.003, "Blocking", LANES_TRACK_GROUP, "primary-light"), console.timeStamp("Transition Track", 0.003, 0.003, "Transition", LANES_TRACK_GROUP, "primary-light"), console.timeStamp("Suspense Track", 0.003, 0.003, "Suspense", LANES_TRACK_GROUP, "primary-light"), console.timeStamp("Idle Track", 0.003, 0.003, "Idle", LANES_TRACK_GROUP, "primary-light"));
        var previousRenderStartTime = renderStartTime;
        renderStartTime = now();
        if (0 !== workInProgressRootRenderLanes && 0 < previousRenderStartTime) {
            setCurrentTrackFromLanes(workInProgressRootRenderLanes);
            if (workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootSuspendedWithDelay) logSuspendedRenderPhase(previousRenderStartTime, renderStartTime, lanes, workInProgressUpdateTask);
            else {
                var endTime = renderStartTime, debugTask = workInProgressUpdateTask;
                if (supportsUserTiming && !(endTime <= previousRenderStartTime)) {
                    var color = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark", label = (lanes & 536870912) === lanes ? "Prewarm" : (lanes & 201326741) === lanes ? "Interrupted Hydration" : "Interrupted Render";
                    debugTask ? debugTask.run(console.timeStamp.bind(console, label, previousRenderStartTime, endTime, currentTrack, LANES_TRACK_GROUP, color)) : console.timeStamp(label, previousRenderStartTime, endTime, currentTrack, LANES_TRACK_GROUP, color);
                }
            }
            finalizeRender(workInProgressRootRenderLanes, renderStartTime);
        }
        previousRenderStartTime = workInProgressUpdateTask;
        workInProgressUpdateTask = null;
        if (0 !== (lanes & 127)) {
            workInProgressUpdateTask = blockingUpdateTask;
            debugTask = 0 <= blockingUpdateTime && blockingUpdateTime < blockingClampTime ? blockingClampTime : blockingUpdateTime;
            endTime = 0 <= blockingEventTime && blockingEventTime < blockingClampTime ? blockingClampTime : blockingEventTime;
            color = 0 <= endTime ? endTime : 0 <= debugTask ? debugTask : renderStartTime;
            0 <= blockingSuspendedTime ? (setCurrentTrackFromLanes(2), logSuspendedWithDelayPhase(blockingSuspendedTime, color, lanes, previousRenderStartTime)) : 0 !== (animatingLanes & 127) && (setCurrentTrackFromLanes(2), logAnimatingPhase(blockingClampTime, color, animatingTask));
            previousRenderStartTime = debugTask;
            var eventTime = endTime, eventType = blockingEventType, eventIsRepeat = 0 < blockingEventRepeatTime, isSpawnedUpdate = blockingUpdateType === SPAWNED_UPDATE, isPingedUpdate = blockingUpdateType === PINGED_UPDATE;
            debugTask = renderStartTime;
            endTime = blockingUpdateTask;
            color = blockingUpdateMethodName;
            label = blockingUpdateComponentName;
            if (supportsUserTiming) {
                currentTrack = "Blocking";
                0 < previousRenderStartTime ? previousRenderStartTime > debugTask && (previousRenderStartTime = debugTask) : previousRenderStartTime = debugTask;
                0 < eventTime ? eventTime > previousRenderStartTime && (eventTime = previousRenderStartTime) : eventTime = previousRenderStartTime;
                if (null !== eventType && previousRenderStartTime > eventTime) {
                    var color$jscomp$0 = eventIsRepeat ? "secondary-light" : "warning";
                    endTime ? endTime.run(console.timeStamp.bind(console, eventIsRepeat ? "Consecutive" : "Event: " + eventType, eventTime, previousRenderStartTime, currentTrack, LANES_TRACK_GROUP, color$jscomp$0)) : console.timeStamp(eventIsRepeat ? "Consecutive" : "Event: " + eventType, eventTime, previousRenderStartTime, currentTrack, LANES_TRACK_GROUP, color$jscomp$0);
                }
                debugTask > previousRenderStartTime && (eventTime = isSpawnedUpdate ? "error" : (lanes & 738197653) === lanes ? "tertiary-light" : "primary-light", isSpawnedUpdate = isPingedUpdate ? "Promise Resolved" : isSpawnedUpdate ? "Cascading Update" : 5 < debugTask - previousRenderStartTime ? "Update Blocked" : "Update", isPingedUpdate = [], null != label && isPingedUpdate.push([
                    "Component name",
                    label
                ]), null != color && isPingedUpdate.push([
                    "Method name",
                    color
                ]), previousRenderStartTime = {
                    start: previousRenderStartTime,
                    end: debugTask,
                    detail: {
                        devtools: {
                            properties: isPingedUpdate,
                            track: currentTrack,
                            trackGroup: LANES_TRACK_GROUP,
                            color: eventTime
                        }
                    }
                }, endTime ? endTime.run(performance.measure.bind(performance, isSpawnedUpdate, previousRenderStartTime)) : performance.measure(isSpawnedUpdate, previousRenderStartTime));
            }
            blockingUpdateTime = -1.1;
            blockingUpdateType = 0;
            blockingUpdateComponentName = blockingUpdateMethodName = null;
            blockingSuspendedTime = -1.1;
            blockingEventRepeatTime = blockingEventTime;
            blockingEventTime = -1.1;
            blockingClampTime = now();
        }
        0 !== (lanes & 4194048) && (workInProgressUpdateTask = transitionUpdateTask, debugTask = 0 <= transitionStartTime && transitionStartTime < transitionClampTime ? transitionClampTime : transitionStartTime, previousRenderStartTime = 0 <= transitionUpdateTime && transitionUpdateTime < transitionClampTime ? transitionClampTime : transitionUpdateTime, endTime = 0 <= transitionEventTime && transitionEventTime < transitionClampTime ? transitionClampTime : transitionEventTime, color = 0 <= endTime ? endTime : 0 <= previousRenderStartTime ? previousRenderStartTime : renderStartTime, 0 <= transitionSuspendedTime ? (setCurrentTrackFromLanes(256), logSuspendedWithDelayPhase(transitionSuspendedTime, color, lanes, workInProgressUpdateTask)) : 0 !== (animatingLanes & 4194048) && (setCurrentTrackFromLanes(256), logAnimatingPhase(transitionClampTime, color, animatingTask)), isPingedUpdate = endTime, eventTime = transitionEventType, eventType = 0 < transitionEventRepeatTime, eventIsRepeat = transitionUpdateType === PINGED_UPDATE, color = renderStartTime, endTime = transitionUpdateTask, label = transitionUpdateMethodName, isSpawnedUpdate = transitionUpdateComponentName, supportsUserTiming && (currentTrack = "Transition", 0 < previousRenderStartTime ? previousRenderStartTime > color && (previousRenderStartTime = color) : previousRenderStartTime = color, 0 < debugTask ? debugTask > previousRenderStartTime && (debugTask = previousRenderStartTime) : debugTask = previousRenderStartTime, 0 < isPingedUpdate ? isPingedUpdate > debugTask && (isPingedUpdate = debugTask) : isPingedUpdate = debugTask, debugTask > isPingedUpdate && null !== eventTime && (color$jscomp$0 = eventType ? "secondary-light" : "warning", endTime ? endTime.run(console.timeStamp.bind(console, eventType ? "Consecutive" : "Event: " + eventTime, isPingedUpdate, debugTask, currentTrack, LANES_TRACK_GROUP, color$jscomp$0)) : console.timeStamp(eventType ? "Consecutive" : "Event: " + eventTime, isPingedUpdate, debugTask, currentTrack, LANES_TRACK_GROUP, color$jscomp$0)), previousRenderStartTime > debugTask && (endTime ? endTime.run(console.timeStamp.bind(console, "Action", debugTask, previousRenderStartTime, currentTrack, LANES_TRACK_GROUP, "primary-dark")) : console.timeStamp("Action", debugTask, previousRenderStartTime, currentTrack, LANES_TRACK_GROUP, "primary-dark")), color > previousRenderStartTime && (debugTask = eventIsRepeat ? "Promise Resolved" : 5 < color - previousRenderStartTime ? "Update Blocked" : "Update", isPingedUpdate = [], null != isSpawnedUpdate && isPingedUpdate.push([
            "Component name",
            isSpawnedUpdate
        ]), null != label && isPingedUpdate.push([
            "Method name",
            label
        ]), previousRenderStartTime = {
            start: previousRenderStartTime,
            end: color,
            detail: {
                devtools: {
                    properties: isPingedUpdate,
                    track: currentTrack,
                    trackGroup: LANES_TRACK_GROUP,
                    color: "primary-light"
                }
            }
        }, endTime ? endTime.run(performance.measure.bind(performance, debugTask, previousRenderStartTime)) : performance.measure(debugTask, previousRenderStartTime))), transitionUpdateTime = transitionStartTime = -1.1, transitionUpdateType = 0, transitionSuspendedTime = -1.1, transitionEventRepeatTime = transitionEventTime, transitionEventTime = -1.1, transitionClampTime = now());
        0 !== (lanes & 62914560) && 0 !== (animatingLanes & 62914560) && (setCurrentTrackFromLanes(4194304), logAnimatingPhase(retryClampTime, renderStartTime, animatingTask));
        0 !== (lanes & 2080374784) && 0 !== (animatingLanes & 2080374784) && (setCurrentTrackFromLanes(268435456), logAnimatingPhase(idleClampTime, renderStartTime, animatingTask));
        previousRenderStartTime = root.timeoutHandle;
        previousRenderStartTime !== noTimeout && (root.timeoutHandle = noTimeout, cancelTimeout(previousRenderStartTime));
        previousRenderStartTime = root.cancelPendingCommit;
        null !== previousRenderStartTime && (root.cancelPendingCommit = null, previousRenderStartTime());
        pendingEffectsLanes = 0;
        resetWorkInProgressStack();
        workInProgressRoot = root;
        workInProgress = previousRenderStartTime = createWorkInProgress(root.current, null);
        workInProgressRootRenderLanes = lanes;
        workInProgressSuspendedReason = NotSuspended;
        workInProgressThrownValue = null;
        workInProgressRootDidSkipSuspendedSiblings = !1;
        workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
        workInProgressRootDidAttachPingListener = !1;
        workInProgressRootExitStatus = RootInProgress;
        workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = 0;
        workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
        workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
        0 !== (lanes & 8) && (lanes |= lanes & 32);
        endTime = root.entangledLanes;
        if (0 !== endTime) for(root = root.entanglements, endTime &= lanes; 0 < endTime;)debugTask = 31 - clz32(endTime), color = 1 << debugTask, lanes |= root[debugTask], endTime &= ~color;
        entangledRenderLanes = lanes;
        finishQueueingConcurrentUpdates();
        root = getCurrentTime();
        1e3 < root - lastResetTime && (ReactSharedInternals.recentlyCreatedOwnerStacks = 0, lastResetTime = root);
        ReactStrictModeWarnings.discardPendingWarnings();
        return previousRenderStartTime;
    }
    function handleThrow(root, thrownValue) {
        currentlyRenderingFiber = null;
        ReactSharedInternals.H = ContextOnlyDispatcher;
        ReactSharedInternals.getCurrentStack = null;
        isRendering = !1;
        current = null;
        thrownValue === SuspenseException || thrownValue === SuspenseActionException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = SuspendedOnImmediate) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = SuspendedOnInstance) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? SuspendedOnHydration : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? SuspendedOnDeprecatedThrowPromise : SuspendedOnError;
        workInProgressThrownValue = thrownValue;
        var erroredWork = workInProgress;
        null === erroredWork ? (workInProgressRootExitStatus = RootFatalErrored, logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current))) : erroredWork.mode & ProfileMode && stopProfilerTimerIfRunningAndRecordDuration(erroredWork);
    }
    function shouldRemainOnPreviousScreen() {
        var handler = suspenseHandlerStackCursor.current;
        return null === handler ? !0 : (workInProgressRootRenderLanes & 4194048) === workInProgressRootRenderLanes ? null === shellBoundary ? !0 : !1 : (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes || 0 !== (workInProgressRootRenderLanes & 536870912) ? handler === shellBoundary : !1;
    }
    function pushDispatcher() {
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = ContextOnlyDispatcher;
        return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
    }
    function pushAsyncDispatcher() {
        var prevAsyncDispatcher = ReactSharedInternals.A;
        ReactSharedInternals.A = DefaultAsyncDispatcher;
        return prevAsyncDispatcher;
    }
    function markRenderDerivedCause(fiber) {
        null === workInProgressUpdateTask && (workInProgressUpdateTask = null == fiber._debugTask ? null : fiber._debugTask);
    }
    function renderDidSuspendDelayIfPossible() {
        workInProgressRootExitStatus = RootSuspendedWithDelay;
        workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194048) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = !0);
        0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(workInProgressRoot, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
    }
    function renderRootSync(root, lanes, shouldYieldForPrerendering) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                0 < memoizedUpdaters.size && (restorePendingUpdaters(root, workInProgressRootRenderLanes), memoizedUpdaters.clear());
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = null;
            prepareFreshStack(root, lanes);
        }
        lanes = !1;
        memoizedUpdaters = workInProgressRootExitStatus;
        a: do try {
            if (workInProgressSuspendedReason !== NotSuspended && null !== workInProgress) {
                var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
                switch(workInProgressSuspendedReason){
                    case SuspendedOnHydration:
                        resetWorkInProgressStack();
                        memoizedUpdaters = RootSuspendedAtTheShell;
                        break a;
                    case SuspendedOnImmediate:
                    case SuspendedOnData:
                    case SuspendedOnAction:
                    case SuspendedOnDeprecatedThrowPromise:
                        null === suspenseHandlerStackCursor.current && (lanes = !0);
                        var reason = workInProgressSuspendedReason;
                        workInProgressSuspendedReason = NotSuspended;
                        workInProgressThrownValue = null;
                        throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                        if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                            memoizedUpdaters = RootInProgress;
                            break a;
                        }
                        break;
                    default:
                        reason = workInProgressSuspendedReason, workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                }
            }
            workLoopSync();
            memoizedUpdaters = workInProgressRootExitStatus;
            break;
        } catch (thrownValue$8) {
            handleThrow(root, thrownValue$8);
        }
        while (1);
        lanes && root.shellSuspendCounter++;
        resetContextDependencies();
        executionContext = prevExecutionContext;
        ReactSharedInternals.H = prevDispatcher;
        ReactSharedInternals.A = prevAsyncDispatcher;
        null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
        return memoizedUpdaters;
    }
    function workLoopSync() {
        for(; null !== workInProgress;)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                0 < memoizedUpdaters.size && (restorePendingUpdaters(root, workInProgressRootRenderLanes), memoizedUpdaters.clear());
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = null;
            workInProgressRootRenderTargetTime = now$1() + RENDER_TIMEOUT_MS;
            prepareFreshStack(root, lanes);
        } else workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
        a: do try {
            if (workInProgressSuspendedReason !== NotSuspended && null !== workInProgress) b: switch(lanes = workInProgress, memoizedUpdaters = workInProgressThrownValue, workInProgressSuspendedReason){
                case SuspendedOnError:
                    workInProgressSuspendedReason = NotSuspended;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, memoizedUpdaters, SuspendedOnError);
                    break;
                case SuspendedOnData:
                case SuspendedOnAction:
                    if (isThenableResolved(memoizedUpdaters)) {
                        workInProgressSuspendedReason = NotSuspended;
                        workInProgressThrownValue = null;
                        replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        workInProgressSuspendedReason !== SuspendedOnData && workInProgressSuspendedReason !== SuspendedOnAction || workInProgressRoot !== root || (workInProgressSuspendedReason = SuspendedAndReadyToContinue);
                        ensureRootIsScheduled(root);
                    };
                    memoizedUpdaters.then(lanes, lanes);
                    break a;
                case SuspendedOnImmediate:
                    workInProgressSuspendedReason = SuspendedAndReadyToContinue;
                    break a;
                case SuspendedOnInstance:
                    workInProgressSuspendedReason = SuspendedOnInstanceAndReadyToContinue;
                    break a;
                case SuspendedAndReadyToContinue:
                    isThenableResolved(memoizedUpdaters) ? (workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, lanes, memoizedUpdaters, SuspendedAndReadyToContinue));
                    break;
                case SuspendedOnInstanceAndReadyToContinue:
                    var resource = null;
                    switch(workInProgress.tag){
                        case 26:
                            resource = workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = workInProgress;
                            if (resource ? preloadResource(resource) : hostFiber.stateNode.complete) {
                                workInProgressSuspendedReason = NotSuspended;
                                workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                                }
                                break b;
                            }
                            break;
                        default:
                            console.error("Unexpected type of fiber triggered a suspensey commit. This is a bug in React.");
                    }
                    workInProgressSuspendedReason = NotSuspended;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, memoizedUpdaters, SuspendedOnInstanceAndReadyToContinue);
                    break;
                case SuspendedOnDeprecatedThrowPromise:
                    workInProgressSuspendedReason = NotSuspended;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, memoizedUpdaters, SuspendedOnDeprecatedThrowPromise);
                    break;
                case SuspendedOnHydration:
                    resetWorkInProgressStack();
                    workInProgressRootExitStatus = RootSuspendedAtTheShell;
                    break a;
                default:
                    throw Error("Unexpected SuspendedReason. This is a bug in React.");
            }
            null !== ReactSharedInternals.actQueue ? workLoopSync() : workLoopConcurrentByScheduler();
            break;
        } catch (thrownValue$9) {
            handleThrow(root, thrownValue$9);
        }
        while (1);
        resetContextDependencies();
        ReactSharedInternals.H = prevDispatcher;
        ReactSharedInternals.A = prevAsyncDispatcher;
        executionContext = prevExecutionContext;
        if (null !== workInProgress) return RootInProgress;
        workInProgressRoot = null;
        workInProgressRootRenderLanes = 0;
        finishQueueingConcurrentUpdates();
        return workInProgressRootExitStatus;
    }
    function workLoopConcurrentByScheduler() {
        for(; null !== workInProgress && !shouldYield();)performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        var current = unitOfWork.alternate;
        (unitOfWork.mode & ProfileMode) !== NoMode ? (startProfilerTimer(unitOfWork), current = runWithFiberInDEV(unitOfWork, beginWork, current, unitOfWork, entangledRenderLanes), stopProfilerTimerIfRunningAndRecordDuration(unitOfWork)) : current = runWithFiberInDEV(unitOfWork, beginWork, current, unitOfWork, entangledRenderLanes);
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        null === current ? completeUnitOfWork(unitOfWork) : workInProgress = current;
    }
    function replaySuspendedUnitOfWork(unitOfWork) {
        var next = runWithFiberInDEV(unitOfWork, replayBeginWork, unitOfWork);
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
    }
    function replayBeginWork(unitOfWork) {
        var current = unitOfWork.alternate, isProfilingMode = (unitOfWork.mode & ProfileMode) !== NoMode;
        isProfilingMode && startProfilerTimer(unitOfWork);
        switch(unitOfWork.tag){
            case 15:
            case 0:
                current = replayFunctionComponent(current, unitOfWork, unitOfWork.pendingProps, unitOfWork.type, void 0, workInProgressRootRenderLanes);
                break;
            case 11:
                current = replayFunctionComponent(current, unitOfWork, unitOfWork.pendingProps, unitOfWork.type.render, unitOfWork.ref, workInProgressRootRenderLanes);
                break;
            case 5:
                resetHooksOnUnwind(unitOfWork);
            default:
                unwindInterruptedWork(current, unitOfWork), unitOfWork = workInProgress = resetWorkInProgress(unitOfWork, entangledRenderLanes), current = beginWork(current, unitOfWork, entangledRenderLanes);
        }
        isProfilingMode && stopProfilerTimerIfRunningAndRecordDuration(unitOfWork);
        return current;
    }
    function throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
        resetContextDependencies();
        resetHooksOnUnwind(unitOfWork);
        thenableState$1 = null;
        thenableIndexCounter$1 = 0;
        var returnFiber = unitOfWork.return;
        try {
            if (throwException(root, returnFiber, unitOfWork, thrownValue, workInProgressRootRenderLanes)) {
                workInProgressRootExitStatus = RootFatalErrored;
                logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
                workInProgress = null;
                return;
            }
        } catch (error) {
            if (null !== returnFiber) throw workInProgress = returnFiber, error;
            workInProgressRootExitStatus = RootFatalErrored;
            logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
            workInProgress = null;
            return;
        }
        if (unitOfWork.flags & 32768) {
            if (isHydrating || suspendedReason === SuspendedOnError) root = !0;
            else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912)) root = !1;
            else if (workInProgressRootDidSkipSuspendedSiblings = root = !0, suspendedReason === SuspendedOnData || suspendedReason === SuspendedOnAction || suspendedReason === SuspendedOnImmediate || suspendedReason === SuspendedOnDeprecatedThrowPromise) suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
            unwindUnitOfWork(unitOfWork, root);
        } else completeUnitOfWork(unitOfWork);
    }
    function completeUnitOfWork(unitOfWork) {
        var completedWork = unitOfWork;
        do {
            if (0 !== (completedWork.flags & 32768)) {
                unwindUnitOfWork(completedWork, workInProgressRootDidSkipSuspendedSiblings);
                return;
            }
            var current = completedWork.alternate;
            unitOfWork = completedWork.return;
            startProfilerTimer(completedWork);
            current = runWithFiberInDEV(completedWork, completeWork, current, completedWork, entangledRenderLanes);
            (completedWork.mode & ProfileMode) !== NoMode && stopProfilerTimerIfRunningAndRecordIncompleteDuration(completedWork);
            if (null !== current) {
                workInProgress = current;
                return;
            }
            completedWork = completedWork.sibling;
            if (null !== completedWork) {
                workInProgress = completedWork;
                return;
            }
            workInProgress = completedWork = unitOfWork;
        }while (null !== completedWork);
        workInProgressRootExitStatus === RootInProgress && (workInProgressRootExitStatus = RootCompleted);
    }
    function unwindUnitOfWork(unitOfWork, skipSiblings) {
        do {
            var next = unwindWork(unitOfWork.alternate, unitOfWork);
            if (null !== next) {
                next.flags &= 32767;
                workInProgress = next;
                return;
            }
            if ((unitOfWork.mode & ProfileMode) !== NoMode) {
                stopProfilerTimerIfRunningAndRecordIncompleteDuration(unitOfWork);
                next = unitOfWork.actualDuration;
                for(var child = unitOfWork.child; null !== child;)next += child.actualDuration, child = child.sibling;
                unitOfWork.actualDuration = next;
            }
            next = unitOfWork.return;
            null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
            if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
                workInProgress = unitOfWork;
                return;
            }
            workInProgress = unitOfWork = next;
        }while (null !== unitOfWork);
        workInProgressRootExitStatus = RootSuspendedAtTheShell;
        workInProgress = null;
    }
    function commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedState, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
        root.cancelPendingCommit = null;
        do flushPendingEffects();
        while (pendingEffectsStatus !== NO_PENDING_EFFECTS);
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw Error("Should not already be working.");
        setCurrentTrackFromLanes(lanes);
        exitStatus === RootErrored ? logErroredRenderPhase(completedRenderStartTime, completedRenderEndTime, lanes, workInProgressUpdateTask) : null !== recoverableErrors ? logRecoveredRenderPhase(completedRenderStartTime, completedRenderEndTime, lanes, recoverableErrors, null !== finishedWork && null !== finishedWork.alternate && finishedWork.alternate.memoizedState.isDehydrated && 0 !== (finishedWork.flags & 256), workInProgressUpdateTask) : logRenderPhase(completedRenderStartTime, completedRenderEndTime, lanes, workInProgressUpdateTask);
        if (null !== finishedWork) {
            0 === lanes && console.error("finishedLanes should not be empty during a commit. This is a bug in React.");
            if (finishedWork === root.current) throw Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
            didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
            didIncludeRenderPhaseUpdate |= concurrentlyUpdatedLanes;
            markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
            root === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
            pendingFinishedWork = finishedWork;
            pendingEffectsRoot = root;
            pendingEffectsLanes = lanes;
            pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
            pendingPassiveTransitions = transitions;
            pendingRecoverableErrors = recoverableErrors;
            pendingEffectsRenderEndTime = completedRenderEndTime;
            pendingSuspendedCommitReason = suspendedCommitReason;
            pendingDelayedCommitReason = IMMEDIATE_COMMIT;
            pendingSuspendedViewTransitionReason = null;
            0 !== finishedWork.actualDuration || 0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, scheduleCallback$1(NormalPriority$1, function() {
                schedulerEvent = window.event;
                pendingDelayedCommitReason === IMMEDIATE_COMMIT && (pendingDelayedCommitReason = DELAYED_PASSIVE_COMMIT);
                flushPassiveEffects();
                return null;
            })) : (root.callbackNode = null, root.callbackPriority = 0);
            commitErrors = null;
            commitStartTime = now();
            null !== suspendedCommitReason && logSuspendedCommitPhase(completedRenderEndTime, commitStartTime, suspendedCommitReason, workInProgressUpdateTask);
            recoverableErrors = 0 !== (finishedWork.flags & 13878);
            if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
                recoverableErrors = ReactSharedInternals.T;
                ReactSharedInternals.T = null;
                transitions = ReactDOMSharedInternals.p;
                ReactDOMSharedInternals.p = DiscreteEventPriority;
                spawnedLane = executionContext;
                executionContext |= CommitContext;
                try {
                    commitBeforeMutationEffects(root, finishedWork, lanes);
                } finally{
                    executionContext = spawnedLane, ReactDOMSharedInternals.p = transitions, ReactSharedInternals.T = recoverableErrors;
                }
            }
            pendingEffectsStatus = PENDING_MUTATION_PHASE;
            flushMutationEffects();
            flushLayoutEffects();
            flushSpawnedWork();
        }
    }
    function flushMutationEffects() {
        if (pendingEffectsStatus === PENDING_MUTATION_PHASE) {
            pendingEffectsStatus = NO_PENDING_EFFECTS;
            var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
            if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
                rootMutationHasEffect = ReactSharedInternals.T;
                ReactSharedInternals.T = null;
                var previousPriority = ReactDOMSharedInternals.p;
                ReactDOMSharedInternals.p = DiscreteEventPriority;
                var prevExecutionContext = executionContext;
                executionContext |= CommitContext;
                try {
                    inProgressLanes = lanes;
                    inProgressRoot = root;
                    resetComponentEffectTimers();
                    commitMutationEffectsOnFiber(finishedWork, root);
                    inProgressRoot = inProgressLanes = null;
                    lanes = selectionInformation;
                    var curFocusedElem = getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                    if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                        if (null !== priorSelectionRange && hasSelectionCapabilities(priorFocusedElem)) {
                            var start = priorSelectionRange.start, end = priorSelectionRange.end;
                            void 0 === end && (end = start);
                            if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                            else {
                                var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                                if (win.getSelection) {
                                    var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                    !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                    var startMarker = getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                    if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                        var range = doc.createRange();
                                        range.setStart(startMarker.node, startMarker.offset);
                                        selection.removeAllRanges();
                                        start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                    }
                                }
                            }
                        }
                        doc = [];
                        for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                            element: selection,
                            left: selection.scrollLeft,
                            top: selection.scrollTop
                        });
                        "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                        for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                            var info = doc[priorFocusedElem];
                            info.element.scrollLeft = info.left;
                            info.element.scrollTop = info.top;
                        }
                    }
                    _enabled = !!eventsEnabled;
                    selectionInformation = eventsEnabled = null;
                } finally{
                    executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootMutationHasEffect;
                }
            }
            root.current = finishedWork;
            pendingEffectsStatus = PENDING_LAYOUT_PHASE;
        }
    }
    function flushLayoutEffects() {
        if (pendingEffectsStatus === PENDING_LAYOUT_PHASE) {
            pendingEffectsStatus = NO_PENDING_EFFECTS;
            var suspendedViewTransitionReason = pendingSuspendedViewTransitionReason;
            if (null !== suspendedViewTransitionReason) {
                commitStartTime = now();
                var startTime = commitEndTime, endTime = commitStartTime;
                !supportsUserTiming || endTime <= startTime || (animatingTask ? animatingTask.run(console.timeStamp.bind(console, suspendedViewTransitionReason, startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light")) : console.timeStamp(suspendedViewTransitionReason, startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light"));
            }
            suspendedViewTransitionReason = pendingEffectsRoot;
            startTime = pendingFinishedWork;
            endTime = pendingEffectsLanes;
            var rootHasLayoutEffect = 0 !== (startTime.flags & 8772);
            if (0 !== (startTime.subtreeFlags & 8772) || rootHasLayoutEffect) {
                rootHasLayoutEffect = ReactSharedInternals.T;
                ReactSharedInternals.T = null;
                var _previousPriority = ReactDOMSharedInternals.p;
                ReactDOMSharedInternals.p = DiscreteEventPriority;
                var _prevExecutionContext = executionContext;
                executionContext |= CommitContext;
                try {
                    inProgressLanes = endTime, inProgressRoot = suspendedViewTransitionReason, resetComponentEffectTimers(), commitLayoutEffectOnFiber(suspendedViewTransitionReason, startTime.alternate, startTime), inProgressRoot = inProgressLanes = null;
                } finally{
                    executionContext = _prevExecutionContext, ReactDOMSharedInternals.p = _previousPriority, ReactSharedInternals.T = rootHasLayoutEffect;
                }
            }
            suspendedViewTransitionReason = pendingEffectsRenderEndTime;
            startTime = pendingSuspendedCommitReason;
            commitEndTime = now();
            suspendedViewTransitionReason = null === startTime ? suspendedViewTransitionReason : commitStartTime;
            startTime = commitEndTime;
            endTime = pendingDelayedCommitReason === ABORTED_VIEW_TRANSITION_COMMIT;
            rootHasLayoutEffect = workInProgressUpdateTask;
            null !== commitErrors ? logCommitErrored(suspendedViewTransitionReason, startTime, commitErrors, !1, rootHasLayoutEffect) : !supportsUserTiming || startTime <= suspendedViewTransitionReason || (rootHasLayoutEffect ? rootHasLayoutEffect.run(console.timeStamp.bind(console, endTime ? "Commit Interrupted View Transition" : "Commit", suspendedViewTransitionReason, startTime, currentTrack, LANES_TRACK_GROUP, endTime ? "error" : "secondary-dark")) : console.timeStamp(endTime ? "Commit Interrupted View Transition" : "Commit", suspendedViewTransitionReason, startTime, currentTrack, LANES_TRACK_GROUP, endTime ? "error" : "secondary-dark"));
            pendingEffectsStatus = PENDING_AFTER_MUTATION_PHASE;
        }
    }
    function flushSpawnedWork() {
        if (pendingEffectsStatus === PENDING_SPAWNED_WORK || pendingEffectsStatus === PENDING_AFTER_MUTATION_PHASE) {
            if (pendingEffectsStatus === PENDING_SPAWNED_WORK) {
                var startViewTransitionStartTime = commitEndTime;
                commitEndTime = now();
                var endTime = commitEndTime, abortedViewTransition = pendingDelayedCommitReason === ABORTED_VIEW_TRANSITION_COMMIT;
                !supportsUserTiming || endTime <= startViewTransitionStartTime || (animatingTask ? animatingTask.run(console.timeStamp.bind(console, abortedViewTransition ? "Interrupted View Transition" : "Starting Animation", startViewTransitionStartTime, endTime, currentTrack, LANES_TRACK_GROUP, abortedViewTransition ? "error" : "secondary-light")) : console.timeStamp(abortedViewTransition ? "Interrupted View Transition" : "Starting Animation", startViewTransitionStartTime, endTime, currentTrack, LANES_TRACK_GROUP, abortedViewTransition ? " error" : "secondary-light"));
                pendingDelayedCommitReason !== ABORTED_VIEW_TRANSITION_COMMIT && (pendingDelayedCommitReason = ANIMATION_STARTED_COMMIT);
            }
            pendingEffectsStatus = NO_PENDING_EFFECTS;
            requestPaint();
            startViewTransitionStartTime = pendingEffectsRoot;
            var finishedWork = pendingFinishedWork;
            endTime = pendingEffectsLanes;
            abortedViewTransition = pendingRecoverableErrors;
            var rootDidHavePassiveEffects = 0 !== finishedWork.actualDuration || 0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256);
            rootDidHavePassiveEffects ? pendingEffectsStatus = PENDING_PASSIVE_PHASE : (pendingEffectsStatus = NO_PENDING_EFFECTS, pendingFinishedWork = pendingEffectsRoot = null, releaseRootPooledCache(startViewTransitionStartTime, startViewTransitionStartTime.pendingLanes), nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null);
            var remainingLanes = startViewTransitionStartTime.pendingLanes;
            0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
            rootDidHavePassiveEffects || commitDoubleInvokeEffectsInDEV(startViewTransitionStartTime);
            remainingLanes = lanesToEventPriority(endTime);
            finishedWork = finishedWork.stateNode;
            if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot) try {
                var didError = 128 === (finishedWork.current.flags & 128);
                switch(remainingLanes){
                    case DiscreteEventPriority:
                        var schedulerPriority = ImmediatePriority;
                        break;
                    case ContinuousEventPriority:
                        schedulerPriority = UserBlockingPriority;
                        break;
                    case DefaultEventPriority:
                        schedulerPriority = NormalPriority$1;
                        break;
                    case IdleEventPriority:
                        schedulerPriority = IdlePriority;
                        break;
                    default:
                        schedulerPriority = NormalPriority$1;
                }
                injectedHook.onCommitFiberRoot(rendererID, finishedWork, schedulerPriority, didError);
            } catch (err) {
                hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
            }
            isDevToolsPresent && startViewTransitionStartTime.memoizedUpdaters.clear();
            onCommitRoot();
            if (null !== abortedViewTransition) {
                didError = ReactSharedInternals.T;
                schedulerPriority = ReactDOMSharedInternals.p;
                ReactDOMSharedInternals.p = DiscreteEventPriority;
                ReactSharedInternals.T = null;
                try {
                    var onRecoverableError = startViewTransitionStartTime.onRecoverableError;
                    for(finishedWork = 0; finishedWork < abortedViewTransition.length; finishedWork++){
                        var recoverableError = abortedViewTransition[finishedWork], errorInfo = makeErrorInfo(recoverableError.stack);
                        runWithFiberInDEV(recoverableError.source, onRecoverableError, recoverableError.value, errorInfo);
                    }
                } finally{
                    ReactSharedInternals.T = didError, ReactDOMSharedInternals.p = schedulerPriority;
                }
            }
            0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
            ensureRootIsScheduled(startViewTransitionStartTime);
            remainingLanes = startViewTransitionStartTime.pendingLanes;
            0 !== (endTime & 261930) && 0 !== (remainingLanes & 42) ? (nestedUpdateScheduled = !0, startViewTransitionStartTime === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = startViewTransitionStartTime)) : nestedUpdateCount = 0;
            rootDidHavePassiveEffects || finalizeRender(endTime, commitEndTime);
            flushSyncWorkAcrossRoots_impl(0, !1);
        }
    }
    function makeErrorInfo(componentStack) {
        componentStack = {
            componentStack: componentStack
        };
        Object.defineProperty(componentStack, "digest", {
            get: function() {
                console.error('You are accessing "digest" from the errorInfo object passed to onRecoverableError. This property is no longer provided as part of errorInfo but can be accessed as a property of the Error instance itself.');
            }
        });
        return componentStack;
    }
    function releaseRootPooledCache(root, remainingLanes) {
        0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, releaseCache(remainingLanes)));
    }
    function flushPendingEffects() {
        flushMutationEffects();
        flushLayoutEffects();
        flushSpawnedWork();
        return flushPassiveEffects();
    }
    function flushPassiveEffects() {
        if (pendingEffectsStatus !== PENDING_PASSIVE_PHASE) return !1;
        var root = pendingEffectsRoot, remainingLanes = pendingEffectsRemainingLanes;
        pendingEffectsRemainingLanes = 0;
        var renderPriority = lanesToEventPriority(pendingEffectsLanes), priority = 0 === DefaultEventPriority || DefaultEventPriority > renderPriority ? DefaultEventPriority : renderPriority;
        renderPriority = ReactSharedInternals.T;
        var previousPriority = ReactDOMSharedInternals.p;
        try {
            ReactDOMSharedInternals.p = priority;
            ReactSharedInternals.T = null;
            var transitions = pendingPassiveTransitions;
            pendingPassiveTransitions = null;
            priority = pendingEffectsRoot;
            var lanes = pendingEffectsLanes;
            pendingEffectsStatus = NO_PENDING_EFFECTS;
            pendingFinishedWork = pendingEffectsRoot = null;
            pendingEffectsLanes = 0;
            if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw Error("Cannot flush passive effects while already rendering.");
            setCurrentTrackFromLanes(lanes);
            isFlushingPassiveEffects = !0;
            didScheduleUpdateDuringPassiveEffects = !1;
            var passiveEffectStartTime = 0;
            commitErrors = null;
            passiveEffectStartTime = now$1();
            if (pendingDelayedCommitReason === ANIMATION_STARTED_COMMIT) logAnimatingPhase(commitEndTime, passiveEffectStartTime, animatingTask);
            else {
                var startTime = commitEndTime, endTime = passiveEffectStartTime, delayedUntilPaint = pendingDelayedCommitReason === DELAYED_PASSIVE_COMMIT;
                !supportsUserTiming || endTime <= startTime || (workInProgressUpdateTask ? workInProgressUpdateTask.run(console.timeStamp.bind(console, delayedUntilPaint ? "Waiting for Paint" : "Waiting", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light")) : console.timeStamp(delayedUntilPaint ? "Waiting for Paint" : "Waiting", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light"));
            }
            startTime = executionContext;
            executionContext |= CommitContext;
            var finishedWork = priority.current;
            resetComponentEffectTimers();
            commitPassiveUnmountOnFiber(finishedWork);
            var finishedWork$jscomp$0 = priority.current;
            finishedWork = pendingEffectsRenderEndTime;
            resetComponentEffectTimers();
            commitPassiveMountOnFiber(priority, finishedWork$jscomp$0, lanes, transitions, finishedWork);
            commitDoubleInvokeEffectsInDEV(priority);
            executionContext = startTime;
            var passiveEffectsEndTime = now$1();
            finishedWork$jscomp$0 = passiveEffectStartTime;
            finishedWork = workInProgressUpdateTask;
            null !== commitErrors ? logCommitErrored(finishedWork$jscomp$0, passiveEffectsEndTime, commitErrors, !0, finishedWork) : !supportsUserTiming || passiveEffectsEndTime <= finishedWork$jscomp$0 || (finishedWork ? finishedWork.run(console.timeStamp.bind(console, "Remaining Effects", finishedWork$jscomp$0, passiveEffectsEndTime, currentTrack, LANES_TRACK_GROUP, "secondary-dark")) : console.timeStamp("Remaining Effects", finishedWork$jscomp$0, passiveEffectsEndTime, currentTrack, LANES_TRACK_GROUP, "secondary-dark"));
            finalizeRender(lanes, passiveEffectsEndTime);
            flushSyncWorkAcrossRoots_impl(0, !1);
            didScheduleUpdateDuringPassiveEffects ? priority === rootWithPassiveNestedUpdates ? nestedPassiveUpdateCount++ : (nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = priority) : nestedPassiveUpdateCount = 0;
            didScheduleUpdateDuringPassiveEffects = isFlushingPassiveEffects = !1;
            if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot) try {
                injectedHook.onPostCommitFiberRoot(rendererID, priority);
            } catch (err) {
                hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
            }
            var stateNode = priority.current.stateNode;
            stateNode.effectDuration = 0;
            stateNode.passiveEffectDuration = 0;
            return !0;
        } finally{
            ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = renderPriority, releaseRootPooledCache(root, remainingLanes);
        }
    }
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
        recordEffectError(sourceFiber);
        sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
        rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
        null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
        isRunningInsertionEffect = !1;
        if (3 === sourceFiber.tag) captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
        else {
            for(; null !== nearestMountedAncestor;){
                if (3 === nearestMountedAncestor.tag) {
                    captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
                    return;
                }
                if (1 === nearestMountedAncestor.tag) {
                    var instance = nearestMountedAncestor.stateNode;
                    if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                        sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
                        recordEffectError(sourceFiber);
                        error = createClassErrorUpdate(2);
                        instance = enqueueUpdate(nearestMountedAncestor, error, 2);
                        null !== instance && (initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
                        return;
                    }
                }
                nearestMountedAncestor = nearestMountedAncestor.return;
            }
            console.error("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Potential causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s", error);
        }
    }
    function attachPingListener(root, wakeable, lanes) {
        var pingCache = root.pingCache;
        if (null === pingCache) {
            pingCache = root.pingCache = new PossiblyWeakMap();
            var threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
        threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), pingCache = pingSuspendedRoot.bind(null, root, wakeable, lanes), isDevToolsPresent && restorePendingUpdaters(root, lanes), wakeable.then(pingCache, pingCache));
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        null !== pingCache && pingCache.delete(wakeable);
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
        root.warmLanes &= ~pingedLanes;
        0 !== (pingedLanes & 127) ? 0 > blockingUpdateTime && (blockingClampTime = blockingUpdateTime = now(), blockingUpdateTask = createTask("Promise Resolved"), blockingUpdateType = PINGED_UPDATE) : 0 !== (pingedLanes & 4194048) && 0 > transitionUpdateTime && (transitionClampTime = transitionUpdateTime = now(), transitionUpdateTask = createTask("Promise Resolved"), transitionUpdateType = PINGED_UPDATE);
        isConcurrentActEnvironment() && null === ReactSharedInternals.actQueue && console.error("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act");
        workInProgressRoot === root && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && now$1() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS ? (executionContext & RenderContext) === NoContext && prepareFreshStack(root, 0) : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
        ensureRootIsScheduled(root);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        0 === retryLane && (retryLane = claimNextRetryLane());
        boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
        null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
        null !== suspenseState && (retryLane = suspenseState.retryLane);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = 0;
        switch(boundaryFiber.tag){
            case 31:
            case 13:
                var retryCache = boundaryFiber.stateNode;
                var suspenseState = boundaryFiber.memoizedState;
                null !== suspenseState && (retryLane = suspenseState.retryLane);
                break;
            case 19:
                retryCache = boundaryFiber.stateNode;
                break;
            case 22:
                retryCache = boundaryFiber.stateNode._retryCache;
                break;
            default:
                throw Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        null !== retryCache && retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function recursivelyTraverseAndDoubleInvokeEffectsInDEV(root$jscomp$0, parentFiber, isInStrictMode) {
        if (0 !== (parentFiber.subtreeFlags & 67117056)) for(parentFiber = parentFiber.child; null !== parentFiber;){
            var root = root$jscomp$0, fiber = parentFiber, isStrictModeFiber = fiber.type === REACT_STRICT_MODE_TYPE;
            isStrictModeFiber = isInStrictMode || isStrictModeFiber;
            22 !== fiber.tag ? fiber.flags & 67108864 ? isStrictModeFiber && runWithFiberInDEV(fiber, doubleInvokeEffectsOnFiber, root, fiber) : recursivelyTraverseAndDoubleInvokeEffectsInDEV(root, fiber, isStrictModeFiber) : null === fiber.memoizedState && (isStrictModeFiber && fiber.flags & 8192 ? runWithFiberInDEV(fiber, doubleInvokeEffectsOnFiber, root, fiber) : fiber.subtreeFlags & 67108864 && runWithFiberInDEV(fiber, recursivelyTraverseAndDoubleInvokeEffectsInDEV, root, fiber, isStrictModeFiber));
            parentFiber = parentFiber.sibling;
        }
    }
    function doubleInvokeEffectsOnFiber(root, fiber) {
        setIsStrictModeForDevtools(!0);
        try {
            disappearLayoutEffects(fiber), disconnectPassiveEffect(fiber), reappearLayoutEffects(root, fiber.alternate, fiber, !1), reconnectPassiveEffects(root, fiber, 0, null, !1, 0);
        } finally{
            setIsStrictModeForDevtools(!1);
        }
    }
    function commitDoubleInvokeEffectsInDEV(root) {
        var doubleInvokeEffects = !0;
        root.current.mode & (StrictLegacyMode | StrictEffectsMode) || (doubleInvokeEffects = !1);
        recursivelyTraverseAndDoubleInvokeEffectsInDEV(root, root.current, doubleInvokeEffects);
    }
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) === NoContext) {
            var tag = fiber.tag;
            if (3 === tag || 1 === tag || 0 === tag || 11 === tag || 14 === tag || 15 === tag) {
                tag = getComponentNameFromFiber(fiber) || "ReactComponent";
                if (null !== didWarnStateUpdateForNotYetMountedComponent) {
                    if (didWarnStateUpdateForNotYetMountedComponent.has(tag)) return;
                    didWarnStateUpdateForNotYetMountedComponent.add(tag);
                } else didWarnStateUpdateForNotYetMountedComponent = new Set([
                    tag
                ]);
                runWithFiberInDEV(fiber, function() {
                    console.error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously tries to update the component. Move this work to useEffect instead.");
                });
            }
        }
    }
    function restorePendingUpdaters(root, lanes) {
        isDevToolsPresent && root.memoizedUpdaters.forEach(function(schedulingFiber) {
            addFiberToLanesMap(root, schedulingFiber, lanes);
        });
    }
    function scheduleCallback$1(priorityLevel, callback) {
        var actQueue = ReactSharedInternals.actQueue;
        return null !== actQueue ? (actQueue.push(callback), fakeActCallbackNode$1) : scheduleCallback$3(priorityLevel, callback);
    }
    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
        isConcurrentActEnvironment() && null === ReactSharedInternals.actQueue && runWithFiberInDEV(fiber, function() {
            console.error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act", getComponentNameFromFiber(fiber));
        });
    }
    function ensureRootIsScheduled(root) {
        root !== lastScheduledRoot && null === root.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root : lastScheduledRoot = lastScheduledRoot.next = root);
        mightHavePendingSyncWork = !0;
        null !== ReactSharedInternals.actQueue ? didScheduleMicrotask_act || (didScheduleMicrotask_act = !0, scheduleImmediateRootScheduleTask()) : didScheduleMicrotask || (didScheduleMicrotask = !0, scheduleImmediateRootScheduleTask());
    }
    function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
        if (!isFlushingWork && mightHavePendingSyncWork) {
            isFlushingWork = !0;
            do {
                var didPerformSomeWork = !1;
                for(var root = firstScheduledRoot; null !== root;){
                    if (!onlyLegacy) {
                        if (0 !== syncTransitionLanes) {
                            var pendingLanes = root.pendingLanes;
                            if (0 === pendingLanes) var nextLanes = 0;
                            else {
                                var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
                                nextLanes = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
                                nextLanes &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                                nextLanes = nextLanes & 201326741 ? nextLanes & 201326741 | 1 : nextLanes ? nextLanes | 2 : 0;
                            }
                            0 !== nextLanes && (didPerformSomeWork = !0, performSyncWorkOnRoot(root, nextLanes));
                        } else nextLanes = workInProgressRootRenderLanes, nextLanes = getNextLanes(root, root === workInProgressRoot ? nextLanes : 0, null !== root.cancelPendingCommit || root.timeoutHandle !== noTimeout), 0 === (nextLanes & 3) || checkIfRootIsPrerendering(root, nextLanes) || (didPerformSomeWork = !0, performSyncWorkOnRoot(root, nextLanes));
                    }
                    root = root.next;
                }
            }while (didPerformSomeWork);
            isFlushingWork = !1;
        }
    }
    function processRootScheduleInImmediateTask() {
        schedulerEvent = window.event;
        processRootScheduleInMicrotask();
    }
    function processRootScheduleInMicrotask() {
        mightHavePendingSyncWork = didScheduleMicrotask_act = didScheduleMicrotask = !1;
        var syncTransitionLanes = 0;
        0 !== currentEventTransitionLane && shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane);
        for(var currentTime = now$1(), prev = null, root = firstScheduledRoot; null !== root;){
            var next = root.next, nextLanes = scheduleTaskForRootDuringMicrotask(root, currentTime);
            if (0 === nextLanes) root.next = null, null === prev ? firstScheduledRoot = next : prev.next = next, null === next && (lastScheduledRoot = prev);
            else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) mightHavePendingSyncWork = !0;
            root = next;
        }
        pendingEffectsStatus !== NO_PENDING_EFFECTS && pendingEffectsStatus !== PENDING_PASSIVE_PHASE || flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
        0 !== currentEventTransitionLane && (currentEventTransitionLane = 0);
    }
    function scheduleTaskForRootDuringMicrotask(root, currentTime) {
        for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
            var index = 31 - clz32(lanes), lane = 1 << index, expirationTime = expirationTimes[index];
            if (-1 === expirationTime) {
                if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else expirationTime <= currentTime && (root.expiredLanes |= lane);
            lanes &= ~lane;
        }
        currentTime = workInProgressRoot;
        suspendedLanes = workInProgressRootRenderLanes;
        suspendedLanes = getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || root.timeoutHandle !== noTimeout);
        pingedLanes = root.callbackNode;
        if (0 === suspendedLanes || root === currentTime && (workInProgressSuspendedReason === SuspendedOnData || workInProgressSuspendedReason === SuspendedOnAction) || null !== root.cancelPendingCommit) return null !== pingedLanes && cancelCallback(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
        if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root, suspendedLanes)) {
            currentTime = suspendedLanes & -suspendedLanes;
            if (currentTime !== root.callbackPriority || null !== ReactSharedInternals.actQueue && pingedLanes !== fakeActCallbackNode) cancelCallback(pingedLanes);
            else return currentTime;
            switch(lanesToEventPriority(suspendedLanes)){
                case DiscreteEventPriority:
                case ContinuousEventPriority:
                    suspendedLanes = UserBlockingPriority;
                    break;
                case DefaultEventPriority:
                    suspendedLanes = NormalPriority$1;
                    break;
                case IdleEventPriority:
                    suspendedLanes = IdlePriority;
                    break;
                default:
                    suspendedLanes = NormalPriority$1;
            }
            pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root);
            null !== ReactSharedInternals.actQueue ? (ReactSharedInternals.actQueue.push(pingedLanes), suspendedLanes = fakeActCallbackNode) : suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
            root.callbackPriority = currentTime;
            root.callbackNode = suspendedLanes;
            return currentTime;
        }
        null !== pingedLanes && cancelCallback(pingedLanes);
        root.callbackPriority = 2;
        root.callbackNode = null;
        return 2;
    }
    function performWorkOnRootViaSchedulerTask(root, didTimeout) {
        nestedUpdateScheduled = currentUpdateIsNested = !1;
        schedulerEvent = window.event;
        if (pendingEffectsStatus !== NO_PENDING_EFFECTS && pendingEffectsStatus !== PENDING_PASSIVE_PHASE) return root.callbackNode = null, root.callbackPriority = 0, null;
        var originalCallbackNode = root.callbackNode;
        pendingDelayedCommitReason === IMMEDIATE_COMMIT && (pendingDelayedCommitReason = DELAYED_PASSIVE_COMMIT);
        if (flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
        var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
        workInProgressRootRenderLanes$jscomp$0 = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || root.timeoutHandle !== noTimeout);
        if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
        performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
        scheduleTaskForRootDuringMicrotask(root, now$1());
        return null != root.callbackNode && root.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root) : null;
    }
    function performSyncWorkOnRoot(root, lanes) {
        if (flushPendingEffects()) return null;
        currentUpdateIsNested = nestedUpdateScheduled;
        nestedUpdateScheduled = !1;
        performWorkOnRoot(root, lanes, !0);
    }
    function cancelCallback(callbackNode) {
        callbackNode !== fakeActCallbackNode && null !== callbackNode && cancelCallback$1(callbackNode);
    }
    function scheduleImmediateRootScheduleTask() {
        null !== ReactSharedInternals.actQueue && ReactSharedInternals.actQueue.push(function() {
            processRootScheduleInMicrotask();
            return null;
        });
        scheduleMicrotask(function() {
            (executionContext & (RenderContext | CommitContext)) !== NoContext ? scheduleCallback$3(ImmediatePriority, processRootScheduleInImmediateTask) : processRootScheduleInMicrotask();
        });
    }
    function requestTransitionLane() {
        if (0 === currentEventTransitionLane) {
            var actionScopeLane = currentEntangledLane;
            0 === actionScopeLane && (actionScopeLane = nextTransitionUpdateLane, nextTransitionUpdateLane <<= 1, 0 === (nextTransitionUpdateLane & 261888) && (nextTransitionUpdateLane = 256));
            currentEventTransitionLane = actionScopeLane;
        }
        return currentEventTransitionLane;
    }
    function coerceFormActionProp(actionProp) {
        if (null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp) return null;
        if ("function" === typeof actionProp) return actionProp;
        checkAttributeStringCoercion(actionProp, "action");
        return sanitizeURL("" + actionProp);
    }
    function createFormDataWithSubmitter(form, submitter) {
        var temp = submitter.ownerDocument.createElement("input");
        temp.name = submitter.name;
        temp.value = submitter.value;
        form.id && temp.setAttribute("form", form.id);
        submitter.parentNode.insertBefore(temp, submitter);
        form = new FormData(form);
        temp.parentNode.removeChild(temp);
        return form;
    }
    function extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
        if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
            var action = coerceFormActionProp((nativeEventTarget[internalPropsKey] || null).action), submitter = nativeEvent.submitter;
            submitter && (domEventName = (domEventName = submitter[internalPropsKey] || null) ? coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
            var event = new SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: [
                    {
                        instance: null,
                        listener: function() {
                            if (nativeEvent.defaultPrevented) {
                                if (0 !== currentEventTransitionLane) {
                                    var formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), pendingState = {
                                        pending: !0,
                                        data: formData,
                                        method: nativeEventTarget.method,
                                        action: action
                                    };
                                    Object.freeze(pendingState);
                                    startHostTransition(maybeTargetInst, pendingState, null, formData);
                                }
                            } else "function" === typeof action && (event.preventDefault(), formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), pendingState = {
                                pending: !0,
                                data: formData,
                                method: nativeEventTarget.method,
                                action: action
                            }, Object.freeze(pendingState), startHostTransition(maybeTargetInst, pendingState, action, formData));
                        },
                        currentTarget: nativeEventTarget
                    }
                ]
            });
        }
    }
    function executeDispatch(event, listener, currentTarget) {
        event.currentTarget = currentTarget;
        try {
            listener(event);
        } catch (error) {
            reportGlobalError(error);
        }
        event.currentTarget = null;
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        eventSystemFlags = 0 !== (eventSystemFlags & 4);
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i];
            a: {
                var previousInstance = void 0, event = _dispatchQueue$i.event;
                _dispatchQueue$i = _dispatchQueue$i.listeners;
                if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                    var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                    _dispatchListeners$i = _dispatchListeners$i.listener;
                    if (instance !== previousInstance && event.isPropagationStopped()) break a;
                    null !== instance ? runWithFiberInDEV(instance, executeDispatch, event, _dispatchListeners$i, currentTarget) : executeDispatch(event, _dispatchListeners$i, currentTarget);
                    previousInstance = instance;
                }
                else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                    _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                    instance = _dispatchListeners$i.instance;
                    currentTarget = _dispatchListeners$i.currentTarget;
                    _dispatchListeners$i = _dispatchListeners$i.listener;
                    if (instance !== previousInstance && event.isPropagationStopped()) break a;
                    null !== instance ? runWithFiberInDEV(instance, executeDispatch, event, _dispatchListeners$i, currentTarget) : executeDispatch(event, _dispatchListeners$i, currentTarget);
                    previousInstance = instance;
                }
            }
        }
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        nonDelegatedEvents.has(domEventName) || console.error('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', domEventName);
        var listenerSet = targetElement[internalEventHandlersKey];
        void 0 === listenerSet && (listenerSet = targetElement[internalEventHandlersKey] = new Set());
        var listenerSetKey = domEventName + "__bubble";
        listenerSet.has(listenerSetKey) || (addTrappedEventListener(targetElement, domEventName, 2, !1), listenerSet.add(listenerSetKey));
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
        nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener && console.error('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', domEventName);
        var eventSystemFlags = 0;
        isCapturePhaseListener && (eventSystemFlags |= 4);
        addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
    }
    function listenToAllSupportedEvents(rootContainerElement) {
        if (!rootContainerElement[listeningMarker]) {
            rootContainerElement[listeningMarker] = !0;
            allNativeEvents.forEach(function(domEventName) {
                "selectionchange" !== domEventName && (nonDelegatedEvents.has(domEventName) || listenToNativeEvent(domEventName, !1, rootContainerElement), listenToNativeEvent(domEventName, !0, rootContainerElement));
            });
            var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
            null === ownerDocument || ownerDocument[listeningMarker] || (ownerDocument[listeningMarker] = !0, listenToNativeEvent("selectionchange", !1, ownerDocument));
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
        switch(getEventPriority(domEventName)){
            case DiscreteEventPriority:
                var listenerWrapper = dispatchDiscreteEvent;
                break;
            case ContinuousEventPriority:
                listenerWrapper = dispatchContinuousEvent;
                break;
            default:
                listenerWrapper = dispatchEvent;
        }
        eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
        listenerWrapper = void 0;
        !passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
        isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
            capture: !0,
            passive: listenerWrapper
        }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
            passive: listenerWrapper
        }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
        var ancestorInst = targetInst$jscomp$0;
        if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
            if (null === targetInst$jscomp$0) return;
            var nodeTag = targetInst$jscomp$0.tag;
            if (3 === nodeTag || 4 === nodeTag) {
                var container = targetInst$jscomp$0.stateNode.containerInfo;
                if (container === targetContainer) break;
                if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                    var grandTag = nodeTag.tag;
                    if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                    nodeTag = nodeTag.return;
                }
                for(; null !== container;){
                    nodeTag = getClosestInstanceFromNode(container);
                    if (null === nodeTag) return;
                    grandTag = nodeTag.tag;
                    if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                        targetInst$jscomp$0 = ancestorInst = nodeTag;
                        continue a;
                    }
                    container = container.parentNode;
                }
            }
            targetInst$jscomp$0 = targetInst$jscomp$0.return;
        }
        batchedUpdates$1(function() {
            var targetInst = ancestorInst, nativeEventTarget = getEventTarget(nativeEvent), dispatchQueue = [];
            a: {
                var reactName = topLevelEventsToReactNames.get(domEventName);
                if (void 0 !== reactName) {
                    var SyntheticEventCtor = SyntheticEvent, reactEventType = domEventName;
                    switch(domEventName){
                        case "keypress":
                            if (0 === getEventCharCode(nativeEvent)) break a;
                        case "keydown":
                        case "keyup":
                            SyntheticEventCtor = SyntheticKeyboardEvent;
                            break;
                        case "focusin":
                            reactEventType = "focus";
                            SyntheticEventCtor = SyntheticFocusEvent;
                            break;
                        case "focusout":
                            reactEventType = "blur";
                            SyntheticEventCtor = SyntheticFocusEvent;
                            break;
                        case "beforeblur":
                        case "afterblur":
                            SyntheticEventCtor = SyntheticFocusEvent;
                            break;
                        case "click":
                            if (2 === nativeEvent.button) break a;
                        case "auxclick":
                        case "dblclick":
                        case "mousedown":
                        case "mousemove":
                        case "mouseup":
                        case "mouseout":
                        case "mouseover":
                        case "contextmenu":
                            SyntheticEventCtor = SyntheticMouseEvent;
                            break;
                        case "drag":
                        case "dragend":
                        case "dragenter":
                        case "dragexit":
                        case "dragleave":
                        case "dragover":
                        case "dragstart":
                        case "drop":
                            SyntheticEventCtor = SyntheticDragEvent;
                            break;
                        case "touchcancel":
                        case "touchend":
                        case "touchmove":
                        case "touchstart":
                            SyntheticEventCtor = SyntheticTouchEvent;
                            break;
                        case ANIMATION_END:
                        case ANIMATION_ITERATION:
                        case ANIMATION_START:
                            SyntheticEventCtor = SyntheticAnimationEvent;
                            break;
                        case TRANSITION_END:
                            SyntheticEventCtor = SyntheticTransitionEvent;
                            break;
                        case "scroll":
                        case "scrollend":
                            SyntheticEventCtor = SyntheticUIEvent;
                            break;
                        case "wheel":
                            SyntheticEventCtor = SyntheticWheelEvent;
                            break;
                        case "copy":
                        case "cut":
                        case "paste":
                            SyntheticEventCtor = SyntheticClipboardEvent;
                            break;
                        case "gotpointercapture":
                        case "lostpointercapture":
                        case "pointercancel":
                        case "pointerdown":
                        case "pointermove":
                        case "pointerout":
                        case "pointerover":
                        case "pointerup":
                            SyntheticEventCtor = SyntheticPointerEvent;
                            break;
                        case "toggle":
                        case "beforetoggle":
                            SyntheticEventCtor = SyntheticToggleEvent;
                    }
                    var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                    inCapturePhase = [];
                    for(var instance = targetInst, lastHostComponent; null !== instance;){
                        var _instance2 = instance;
                        lastHostComponent = _instance2.stateNode;
                        _instance2 = _instance2.tag;
                        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === lastHostComponent || null === reactEventName || (_instance2 = getListener(instance, reactEventName), null != _instance2 && inCapturePhase.push(createDispatchListener(instance, _instance2, lastHostComponent)));
                        if (accumulateTargetOnly) break;
                        instance = instance.return;
                    }
                    0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                        event: reactName,
                        listeners: inCapturePhase
                    }));
                }
            }
            if (0 === (eventSystemFlags & 7)) {
                a: {
                    reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                    SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                    if (reactName && nativeEvent !== currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && (getClosestInstanceFromNode(reactEventType) || reactEventType[internalContainerInstanceKey])) break a;
                    if (SyntheticEventCtor || reactName) {
                        reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                        if (SyntheticEventCtor) {
                            if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                        } else SyntheticEventCtor = null, reactEventType = targetInst;
                        if (SyntheticEventCtor !== reactEventType) {
                            inCapturePhase = SyntheticMouseEvent;
                            _instance2 = "onMouseLeave";
                            reactEventName = "onMouseEnter";
                            instance = "mouse";
                            if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = SyntheticPointerEvent, _instance2 = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                            accumulateTargetOnly = null == SyntheticEventCtor ? reactName : getNodeFromInstance(SyntheticEventCtor);
                            lastHostComponent = null == reactEventType ? reactName : getNodeFromInstance(reactEventType);
                            reactName = new inCapturePhase(_instance2, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                            reactName.target = accumulateTargetOnly;
                            reactName.relatedTarget = lastHostComponent;
                            _instance2 = null;
                            getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance2 = inCapturePhase);
                            accumulateTargetOnly = _instance2;
                            if (SyntheticEventCtor && reactEventType) b: {
                                inCapturePhase = getParent;
                                reactEventName = SyntheticEventCtor;
                                instance = reactEventType;
                                lastHostComponent = 0;
                                for(_instance2 = reactEventName; _instance2; _instance2 = inCapturePhase(_instance2))lastHostComponent++;
                                _instance2 = 0;
                                for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance2++;
                                for(; 0 < lastHostComponent - _instance2;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                                for(; 0 < _instance2 - lastHostComponent;)instance = inCapturePhase(instance), _instance2--;
                                for(; lastHostComponent--;){
                                    if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                        inCapturePhase = reactEventName;
                                        break b;
                                    }
                                    reactEventName = inCapturePhase(reactEventName);
                                    instance = inCapturePhase(instance);
                                }
                                inCapturePhase = null;
                            }
                            else inCapturePhase = null;
                            null !== SyntheticEventCtor && accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                            null !== reactEventType && null !== accumulateTargetOnly && accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                        }
                    }
                }
                a: {
                    reactName = targetInst ? getNodeFromInstance(targetInst) : window;
                    SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                    if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = getTargetInstForChangeEvent;
                    else if (isTextInputElement(reactName)) {
                        if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
                        else {
                            getTargetInstFunc = getTargetInstForInputEventPolyfill;
                            var handleEventFunc = handleEventsForInputEventPolyfill;
                        }
                    } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && isCustomElement(targetInst.elementType) && (getTargetInstFunc = getTargetInstForChangeEvent) : getTargetInstFunc = getTargetInstForClickEvent;
                    if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                        createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                        break a;
                    }
                    handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                    "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && setDefaultValue(reactName, "number", reactName.value);
                }
                handleEventFunc = targetInst ? getNodeFromInstance(targetInst) : window;
                switch(domEventName){
                    case "focusin":
                        if (isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) activeElement = handleEventFunc, activeElementInst = targetInst, lastSelection = null;
                        break;
                    case "focusout":
                        lastSelection = activeElementInst = activeElement = null;
                        break;
                    case "mousedown":
                        mouseDown = !0;
                        break;
                    case "contextmenu":
                    case "mouseup":
                    case "dragend":
                        mouseDown = !1;
                        constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                        break;
                    case "selectionchange":
                        if (skipSelectionChangeEvent) break;
                    case "keydown":
                    case "keyup":
                        constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                }
                var fallbackData;
                if (canUseCompositionEvent) b: {
                    switch(domEventName){
                        case "compositionstart":
                            var eventType = "onCompositionStart";
                            break b;
                        case "compositionend":
                            eventType = "onCompositionEnd";
                            break b;
                        case "compositionupdate":
                            eventType = "onCompositionUpdate";
                            break b;
                    }
                    eventType = void 0;
                }
                else isComposing ? isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && nativeEvent.keyCode === START_KEYCODE && (eventType = "onCompositionStart");
                eventType && (useFallbackCompositionData && "ko" !== nativeEvent.locale && (isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && isComposing && (fallbackData = getData()) : (root = nativeEventTarget, startText = "value" in root ? root.value : root.textContent, isComposing = !0)), handleEventFunc = accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: eventType,
                    listeners: handleEventFunc
                }), fallbackData ? eventType.data = fallbackData : (fallbackData = getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
                if (fallbackData = canUseTextInputEvent ? getNativeBeforeInputChars(domEventName, nativeEvent) : getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new SyntheticInputEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: handleEventFunc,
                    listeners: eventType
                }), handleEventFunc.data = fallbackData);
                extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            }
            processDispatchQueue(dispatchQueue, eventSystemFlags);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
            var _instance3 = targetFiber, stateNode = _instance3.stateNode;
            _instance3 = _instance3.tag;
            5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (_instance3 = getListener(targetFiber, captureName), null != _instance3 && listeners.unshift(createDispatchListener(targetFiber, _instance3, stateNode)), _instance3 = getListener(targetFiber, reactName), null != _instance3 && listeners.push(createDispatchListener(targetFiber, _instance3, stateNode)));
            if (3 === targetFiber.tag) return listeners;
            targetFiber = targetFiber.return;
        }
        return [];
    }
    function getParent(inst) {
        if (null === inst) return null;
        do inst = inst.return;
        while (inst && 5 !== inst.tag && 27 !== inst.tag);
        return inst ? inst : null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
            var _instance4 = target, alternate = _instance4.alternate, stateNode = _instance4.stateNode;
            _instance4 = _instance4.tag;
            if (null !== alternate && alternate === common) break;
            5 !== _instance4 && 26 !== _instance4 && 27 !== _instance4 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = getListener(target, registrationName), null != stateNode && listeners.unshift(createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = getListener(target, registrationName), null != stateNode && listeners.push(createDispatchListener(target, stateNode, alternate))));
            target = target.return;
        }
        0 !== listeners.length && dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    }
    function validatePropertiesInDevelopment(type, props) {
        validateProperties$2(type, props);
        "input" !== type && "textarea" !== type && "select" !== type || null == props || null !== props.value || didWarnValueNull || (didWarnValueNull = !0, "select" === type && props.multiple ? console.error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type) : console.error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type));
        var eventRegistry = {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        };
        isCustomElement(type) || "string" === typeof props.is || warnUnknownProperties(type, props, eventRegistry);
        props.contentEditable && !props.suppressContentEditableWarning && null != props.children && console.error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
    }
    function warnForPropDifference(propName, serverValue, clientValue, serverDifferences) {
        serverValue !== clientValue && (clientValue = normalizeMarkupForTextOrAttribute(clientValue), normalizeMarkupForTextOrAttribute(serverValue) !== clientValue && (serverDifferences[propName] = serverValue));
    }
    function warnForExtraAttributes(domElement, attributeNames, serverDifferences) {
        attributeNames.forEach(function(attributeName) {
            serverDifferences[getPropNameFromAttributeName(attributeName)] = "style" === attributeName ? getStylesObjectFromElement(domElement) : domElement.getAttribute(attributeName);
        });
    }
    function warnForInvalidEventListener(registrationName, listener) {
        !1 === listener ? console.error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName) : console.error("Expected `%s` listener to be a function, instead got a value of `%s` type.", registrationName, typeof listener);
    }
    function normalizeHTML(parent, html) {
        parent = parent.namespaceURI === MATH_NAMESPACE || parent.namespaceURI === SVG_NAMESPACE ? parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName) : parent.ownerDocument.createElement(parent.tagName);
        parent.innerHTML = html;
        return parent.innerHTML;
    }
    function normalizeMarkupForTextOrAttribute(markup) {
        willCoercionThrow(markup) && (console.error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before using it here.", typeName(markup)), testStringCoercion(markup));
        return ("string" === typeof markup ? markup : "" + markup).replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
    }
    function checkForUnmatchedText(serverText, clientText) {
        clientText = normalizeMarkupForTextOrAttribute(clientText);
        return normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
    }
    function setProp(domElement, tag, key, value, props, prevValue) {
        switch(key){
            case "children":
                if ("string" === typeof value) validateTextNesting(value, tag, !1), "body" === tag || "textarea" === tag && "" === value || setTextContent(domElement, value);
                else if ("number" === typeof value || "bigint" === typeof value) validateTextNesting("" + value, tag, !1), "body" !== tag && setTextContent(domElement, "" + value);
                break;
            case "className":
                setValueForKnownAttribute(domElement, "class", value);
                break;
            case "tabIndex":
                setValueForKnownAttribute(domElement, "tabindex", value);
                break;
            case "dir":
            case "role":
            case "viewBox":
            case "width":
            case "height":
                setValueForKnownAttribute(domElement, key, value);
                break;
            case "style":
                setValueForStyles(domElement, value, prevValue);
                break;
            case "data":
                if ("object" !== tag) {
                    setValueForKnownAttribute(domElement, "data", value);
                    break;
                }
            case "src":
            case "href":
                if ("" === value && ("a" !== tag || "href" !== key)) {
                    "src" === key ? console.error('An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.', key, key) : console.error('An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.', key, key);
                    domElement.removeAttribute(key);
                    break;
                }
                if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                    domElement.removeAttribute(key);
                    break;
                }
                checkAttributeStringCoercion(value, key);
                value = sanitizeURL("" + value);
                domElement.setAttribute(key, value);
                break;
            case "action":
            case "formAction":
                null != value && ("form" === tag ? "formAction" === key ? console.error("You can only pass the formAction prop to <input> or <button>. Use the action prop on <form>.") : "function" === typeof value && (null == props.encType && null == props.method || didWarnFormActionMethod || (didWarnFormActionMethod = !0, console.error("Cannot specify a encType or method for a form that specifies a function as the action. React provides those automatically. They will get overridden.")), null == props.target || didWarnFormActionTarget || (didWarnFormActionTarget = !0, console.error("Cannot specify a target for a form that specifies a function as the action. The function will always be executed in the same window."))) : "input" === tag || "button" === tag ? "action" === key ? console.error("You can only pass the action prop to <form>. Use the formAction prop on <input> or <button>.") : "input" !== tag || "submit" === props.type || "image" === props.type || didWarnFormActionType ? "button" !== tag || null == props.type || "submit" === props.type || didWarnFormActionType ? "function" === typeof value && (null == props.name || didWarnFormActionName || (didWarnFormActionName = !0, console.error('Cannot specify a "name" prop for a button that specifies a function as a formAction. React needs it to encode which action should be invoked. It will get overridden.')), null == props.formEncType && null == props.formMethod || didWarnFormActionMethod || (didWarnFormActionMethod = !0, console.error("Cannot specify a formEncType or formMethod for a button that specifies a function as a formAction. React provides those automatically. They will get overridden.")), null == props.formTarget || didWarnFormActionTarget || (didWarnFormActionTarget = !0, console.error("Cannot specify a formTarget for a button that specifies a function as a formAction. The function will always be executed in the same window."))) : (didWarnFormActionType = !0, console.error('A button can only specify a formAction along with type="submit" or no type.')) : (didWarnFormActionType = !0, console.error('An input can only specify a formAction along with type="submit" or type="image".')) : "action" === key ? console.error("You can only pass the action prop to <form>.") : console.error("You can only pass the formAction prop to <input> or <button>."));
                if ("function" === typeof value) {
                    domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                    break;
                } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && setProp(domElement, tag, "name", props.name, props, null), setProp(domElement, tag, "formEncType", props.formEncType, props, null), setProp(domElement, tag, "formMethod", props.formMethod, props, null), setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : (setProp(domElement, tag, "encType", props.encType, props, null), setProp(domElement, tag, "method", props.method, props, null), setProp(domElement, tag, "target", props.target, props, null)));
                if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                    domElement.removeAttribute(key);
                    break;
                }
                checkAttributeStringCoercion(value, key);
                value = sanitizeURL("" + value);
                domElement.setAttribute(key, value);
                break;
            case "onClick":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), domElement.onclick = noop$1);
                break;
            case "onScroll":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scroll", domElement));
                break;
            case "onScrollEnd":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scrollend", domElement));
                break;
            case "dangerouslySetInnerHTML":
                if (null != value) {
                    if ("object" !== typeof value || !("__html" in value)) throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information.");
                    key = value.__html;
                    if (null != key) {
                        if (null != props.children) throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
                        domElement.innerHTML = key;
                    }
                }
                break;
            case "multiple":
                domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
                break;
            case "muted":
                domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
                break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "defaultValue":
            case "defaultChecked":
            case "innerHTML":
            case "ref":
                break;
            case "autoFocus":
                break;
            case "xlinkHref":
                if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                    domElement.removeAttribute("xlink:href");
                    break;
                }
                checkAttributeStringCoercion(value, key);
                key = sanitizeURL("" + value);
                domElement.setAttributeNS(xlinkNamespace, "xlink:href", key);
                break;
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
                null != value && "function" !== typeof value && "symbol" !== typeof value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, "" + value)) : domElement.removeAttribute(key);
                break;
            case "inert":
                "" !== value || didWarnForNewBooleanPropsWithEmptyValue[key] || (didWarnForNewBooleanPropsWithEmptyValue[key] = !0, console.error("Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.", key));
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
                value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
                break;
            case "capture":
            case "download":
                !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value)) : domElement.removeAttribute(key);
                break;
            case "cols":
            case "rows":
            case "size":
            case "span":
                null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value)) : domElement.removeAttribute(key);
                break;
            case "rowSpan":
            case "start":
                null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value));
                break;
            case "popover":
                listenToNonDelegatedEvent("beforetoggle", domElement);
                listenToNonDelegatedEvent("toggle", domElement);
                setValueForAttribute(domElement, "popover", value);
                break;
            case "xlinkActuate":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:actuate", value);
                break;
            case "xlinkArcrole":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:arcrole", value);
                break;
            case "xlinkRole":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:role", value);
                break;
            case "xlinkShow":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:show", value);
                break;
            case "xlinkTitle":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:title", value);
                break;
            case "xlinkType":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:type", value);
                break;
            case "xmlBase":
                setValueForNamespacedAttribute(domElement, xmlNamespace, "xml:base", value);
                break;
            case "xmlLang":
                setValueForNamespacedAttribute(domElement, xmlNamespace, "xml:lang", value);
                break;
            case "xmlSpace":
                setValueForNamespacedAttribute(domElement, xmlNamespace, "xml:space", value);
                break;
            case "is":
                null != prevValue && console.error('Cannot update the "is" prop after it has been initialized.');
                setValueForAttribute(domElement, "is", value);
                break;
            case "innerText":
            case "textContent":
                break;
            case "popoverTarget":
                didWarnPopoverTargetObject || null == value || "object" !== typeof value || (didWarnPopoverTargetObject = !0, console.error("The `popoverTarget` prop expects the ID of an Element as a string. Received %s instead.", value));
            default:
                !(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1] ? (key = getAttributeAlias(key), setValueForAttribute(domElement, key, value)) : registrationNameDependencies.hasOwnProperty(key) && null != value && "function" !== typeof value && warnForInvalidEventListener(key, value);
        }
    }
    function setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
        switch(key){
            case "style":
                setValueForStyles(domElement, value, prevValue);
                break;
            case "dangerouslySetInnerHTML":
                if (null != value) {
                    if ("object" !== typeof value || !("__html" in value)) throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information.");
                    key = value.__html;
                    if (null != key) {
                        if (null != props.children) throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
                        domElement.innerHTML = key;
                    }
                }
                break;
            case "children":
                "string" === typeof value ? setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && setTextContent(domElement, "" + value);
                break;
            case "onScroll":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scroll", domElement));
                break;
            case "onScrollEnd":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scrollend", domElement));
                break;
            case "onClick":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), domElement.onclick = noop$1);
                break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "innerHTML":
            case "ref":
                break;
            case "innerText":
            case "textContent":
                break;
            default:
                if (registrationNameDependencies.hasOwnProperty(key)) null != value && "function" !== typeof value && warnForInvalidEventListener(key, value);
                else a: {
                    if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                        "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                        domElement.addEventListener(tag, value, props);
                        break a;
                    }
                    key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : setValueForAttribute(domElement, key, value);
                }
        }
    }
    function setInitialProperties(domElement, tag, props) {
        validatePropertiesInDevelopment(tag, props);
        switch(tag){
            case "div":
            case "span":
            case "svg":
            case "path":
            case "a":
            case "g":
            case "p":
            case "li":
                break;
            case "img":
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                var hasSrc = !1, hasSrcSet = !1, propKey;
                for(propKey in props)if (props.hasOwnProperty(propKey)) {
                    var propValue = props[propKey];
                    if (null != propValue) switch(propKey){
                        case "src":
                            hasSrc = !0;
                            break;
                        case "srcSet":
                            hasSrcSet = !0;
                            break;
                        case "children":
                        case "dangerouslySetInnerHTML":
                            throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                        default:
                            setProp(domElement, tag, propKey, propValue, props, null);
                    }
                }
                hasSrcSet && setProp(domElement, tag, "srcSet", props.srcSet, props, null);
                hasSrc && setProp(domElement, tag, "src", props.src, props, null);
                return;
            case "input":
                checkControlledValueProps("input", props);
                listenToNonDelegatedEvent("invalid", domElement);
                var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
                for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                    var _propValue = props[hasSrc];
                    if (null != _propValue) switch(hasSrc){
                        case "name":
                            hasSrcSet = _propValue;
                            break;
                        case "type":
                            propValue = _propValue;
                            break;
                        case "checked":
                            checked = _propValue;
                            break;
                        case "defaultChecked":
                            defaultChecked = _propValue;
                            break;
                        case "value":
                            propKey = _propValue;
                            break;
                        case "defaultValue":
                            defaultValue = _propValue;
                            break;
                        case "children":
                        case "dangerouslySetInnerHTML":
                            if (null != _propValue) throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                            break;
                        default:
                            setProp(domElement, tag, hasSrc, _propValue, props, null);
                    }
                }
                validateInputProps(domElement, props);
                initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
                return;
            case "select":
                checkControlledValueProps("select", props);
                listenToNonDelegatedEvent("invalid", domElement);
                hasSrc = propValue = propKey = null;
                for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                    case "value":
                        propKey = defaultValue;
                        break;
                    case "defaultValue":
                        propValue = defaultValue;
                        break;
                    case "multiple":
                        hasSrc = defaultValue;
                    default:
                        setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
                }
                validateSelectProps(domElement, props);
                tag = propKey;
                props = propValue;
                domElement.multiple = !!hasSrc;
                null != tag ? updateOptions(domElement, !!hasSrc, tag, !1) : null != props && updateOptions(domElement, !!hasSrc, props, !0);
                return;
            case "textarea":
                checkControlledValueProps("textarea", props);
                listenToNonDelegatedEvent("invalid", domElement);
                propKey = hasSrcSet = hasSrc = null;
                for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                    case "value":
                        hasSrc = defaultValue;
                        break;
                    case "defaultValue":
                        hasSrcSet = defaultValue;
                        break;
                    case "children":
                        propKey = defaultValue;
                        break;
                    case "dangerouslySetInnerHTML":
                        if (null != defaultValue) throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
                        break;
                    default:
                        setProp(domElement, tag, propValue, defaultValue, props, null);
                }
                validateTextareaProps(domElement, props);
                initTextarea(domElement, hasSrc, hasSrcSet, propKey);
                return;
            case "option":
                validateOptionProps(domElement, props);
                for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                    case "selected":
                        domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                        break;
                    default:
                        setProp(domElement, tag, checked, hasSrc, props, null);
                }
                return;
            case "dialog":
                listenToNonDelegatedEvent("beforetoggle", domElement);
                listenToNonDelegatedEvent("toggle", domElement);
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                break;
            case "iframe":
            case "object":
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "video":
            case "audio":
                for(hasSrc = 0; hasSrc < mediaEventTypes.length; hasSrc++)listenToNonDelegatedEvent(mediaEventTypes[hasSrc], domElement);
                break;
            case "image":
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "details":
                listenToNonDelegatedEvent("toggle", domElement);
                break;
            case "embed":
            case "source":
            case "link":
                listenToNonDelegatedEvent("error", domElement), listenToNonDelegatedEvent("load", domElement);
            case "area":
            case "base":
            case "br":
            case "col":
            case "hr":
            case "keygen":
            case "meta":
            case "param":
            case "track":
            case "wbr":
            case "menuitem":
                for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                    default:
                        setProp(domElement, tag, defaultChecked, hasSrc, props, null);
                }
                return;
            default:
                if (isCustomElement(tag)) {
                    for(_propValue in props)props.hasOwnProperty(_propValue) && (hasSrc = props[_propValue], void 0 !== hasSrc && setPropOnCustomElement(domElement, tag, _propValue, hasSrc, props, void 0));
                    return;
                }
        }
        for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && setProp(domElement, tag, defaultValue, hasSrc, props, null));
    }
    function updateProperties(domElement, tag, lastProps, nextProps) {
        validatePropertiesInDevelopment(tag, nextProps);
        switch(tag){
            case "div":
            case "span":
            case "svg":
            case "path":
            case "a":
            case "g":
            case "p":
            case "li":
                break;
            case "input":
                var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
                for(propKey in lastProps){
                    var lastProp = lastProps[propKey];
                    if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                        case "checked":
                            break;
                        case "value":
                            break;
                        case "defaultValue":
                            lastDefaultValue = lastProp;
                        default:
                            nextProps.hasOwnProperty(propKey) || setProp(domElement, tag, propKey, null, nextProps, lastProp);
                    }
                }
                for(var _propKey8 in nextProps){
                    var propKey = nextProps[_propKey8];
                    lastProp = lastProps[_propKey8];
                    if (nextProps.hasOwnProperty(_propKey8) && (null != propKey || null != lastProp)) switch(_propKey8){
                        case "type":
                            type = propKey;
                            break;
                        case "name":
                            name = propKey;
                            break;
                        case "checked":
                            checked = propKey;
                            break;
                        case "defaultChecked":
                            defaultChecked = propKey;
                            break;
                        case "value":
                            value = propKey;
                            break;
                        case "defaultValue":
                            defaultValue = propKey;
                            break;
                        case "children":
                        case "dangerouslySetInnerHTML":
                            if (null != propKey) throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                            break;
                        default:
                            propKey !== lastProp && setProp(domElement, tag, _propKey8, propKey, nextProps, lastProp);
                    }
                }
                tag = "checkbox" === lastProps.type || "radio" === lastProps.type ? null != lastProps.checked : null != lastProps.value;
                nextProps = "checkbox" === nextProps.type || "radio" === nextProps.type ? null != nextProps.checked : null != nextProps.value;
                tag || !nextProps || didWarnUncontrolledToControlled || (console.error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"), didWarnUncontrolledToControlled = !0);
                !tag || nextProps || didWarnControlledToUncontrolled || (console.error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"), didWarnControlledToUncontrolled = !0);
                updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
                return;
            case "select":
                propKey = value = defaultValue = _propKey8 = null;
                for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                    case "value":
                        break;
                    case "multiple":
                        propKey = lastDefaultValue;
                    default:
                        nextProps.hasOwnProperty(type) || setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
                }
                for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                    case "value":
                        _propKey8 = type;
                        break;
                    case "defaultValue":
                        defaultValue = type;
                        break;
                    case "multiple":
                        value = type;
                    default:
                        type !== lastDefaultValue && setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
                }
                nextProps = defaultValue;
                tag = value;
                lastProps = propKey;
                null != _propKey8 ? updateOptions(domElement, !!tag, _propKey8, !1) : !!lastProps !== !!tag && (null != nextProps ? updateOptions(domElement, !!tag, nextProps, !0) : updateOptions(domElement, !!tag, tag ? [] : "", !1));
                return;
            case "textarea":
                propKey = _propKey8 = null;
                for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                    case "value":
                        break;
                    case "children":
                        break;
                    default:
                        setProp(domElement, tag, defaultValue, null, nextProps, name);
                }
                for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                    case "value":
                        _propKey8 = name;
                        break;
                    case "defaultValue":
                        propKey = name;
                        break;
                    case "children":
                        break;
                    case "dangerouslySetInnerHTML":
                        if (null != name) throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
                        break;
                    default:
                        name !== type && setProp(domElement, tag, value, name, nextProps, type);
                }
                updateTextarea(domElement, _propKey8, propKey);
                return;
            case "option":
                for(var _propKey13 in lastProps)if (_propKey8 = lastProps[_propKey13], lastProps.hasOwnProperty(_propKey13) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey13)) switch(_propKey13){
                    case "selected":
                        domElement.selected = !1;
                        break;
                    default:
                        setProp(domElement, tag, _propKey13, null, nextProps, _propKey8);
                }
                for(lastDefaultValue in nextProps)if (_propKey8 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && _propKey8 !== propKey && (null != _propKey8 || null != propKey)) switch(lastDefaultValue){
                    case "selected":
                        domElement.selected = _propKey8 && "function" !== typeof _propKey8 && "symbol" !== typeof _propKey8;
                        break;
                    default:
                        setProp(domElement, tag, lastDefaultValue, _propKey8, nextProps, propKey);
                }
                return;
            case "img":
            case "link":
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "keygen":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
            case "menuitem":
                for(var _propKey15 in lastProps)_propKey8 = lastProps[_propKey15], lastProps.hasOwnProperty(_propKey15) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey15) && setProp(domElement, tag, _propKey15, null, nextProps, _propKey8);
                for(checked in nextProps)if (_propKey8 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && _propKey8 !== propKey && (null != _propKey8 || null != propKey)) switch(checked){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != _propKey8) throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                        break;
                    default:
                        setProp(domElement, tag, checked, _propKey8, nextProps, propKey);
                }
                return;
            default:
                if (isCustomElement(tag)) {
                    for(var _propKey17 in lastProps)_propKey8 = lastProps[_propKey17], lastProps.hasOwnProperty(_propKey17) && void 0 !== _propKey8 && !nextProps.hasOwnProperty(_propKey17) && setPropOnCustomElement(domElement, tag, _propKey17, void 0, nextProps, _propKey8);
                    for(defaultChecked in nextProps)_propKey8 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || _propKey8 === propKey || void 0 === _propKey8 && void 0 === propKey || setPropOnCustomElement(domElement, tag, defaultChecked, _propKey8, nextProps, propKey);
                    return;
                }
        }
        for(var _propKey19 in lastProps)_propKey8 = lastProps[_propKey19], lastProps.hasOwnProperty(_propKey19) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey19) && setProp(domElement, tag, _propKey19, null, nextProps, _propKey8);
        for(lastProp in nextProps)_propKey8 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || _propKey8 === propKey || null == _propKey8 && null == propKey || setProp(domElement, tag, lastProp, _propKey8, nextProps, propKey);
    }
    function getPropNameFromAttributeName(attrName) {
        switch(attrName){
            case "class":
                return "className";
            case "for":
                return "htmlFor";
            default:
                return attrName;
        }
    }
    function getStylesObjectFromElement(domElement) {
        var serverValueInObjectForm = {};
        domElement = domElement.style;
        for(var i = 0; i < domElement.length; i++){
            var styleName = domElement[i];
            serverValueInObjectForm[styleName] = domElement.getPropertyValue(styleName);
        }
        return serverValueInObjectForm;
    }
    function diffHydratedStyles(domElement, value$jscomp$0, serverDifferences) {
        if (null != value$jscomp$0 && "object" !== typeof value$jscomp$0) console.error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
        else {
            var clientValue;
            var delimiter = clientValue = "", styleName;
            for(styleName in value$jscomp$0)if (value$jscomp$0.hasOwnProperty(styleName)) {
                var value = value$jscomp$0[styleName];
                null != value && "boolean" !== typeof value && "" !== value && (0 === styleName.indexOf("--") ? (checkCSSPropertyStringCoercion(value, styleName), clientValue += delimiter + styleName + ":" + ("" + value).trim()) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? (checkCSSPropertyStringCoercion(value, styleName), clientValue += delimiter + styleName.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern$1, "-ms-") + ":" + ("" + value).trim()) : clientValue += delimiter + styleName.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern$1, "-ms-") + ":" + value + "px", delimiter = ";");
            }
            clientValue = clientValue || null;
            value$jscomp$0 = domElement.getAttribute("style");
            value$jscomp$0 !== clientValue && (clientValue = normalizeMarkupForTextOrAttribute(clientValue), normalizeMarkupForTextOrAttribute(value$jscomp$0) !== clientValue && (serverDifferences.style = getStylesObjectFromElement(domElement)));
        }
    }
    function hydrateAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                return;
        }
        else if (null != value) switch(typeof value){
            case "function":
            case "symbol":
            case "boolean":
                break;
            default:
                if (checkAttributeStringCoercion(value, propKey), domElement === "" + value) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateBooleanAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) {
            switch(typeof value){
                case "function":
                case "symbol":
                    return;
            }
            if (!value) return;
        } else switch(typeof value){
            case "function":
            case "symbol":
                break;
            default:
                if (value) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateBooleanishAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
                return;
        }
        else if (null != value) switch(typeof value){
            case "function":
            case "symbol":
                break;
            default:
                if (checkAttributeStringCoercion(value, attributeName), domElement === "" + value) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateNumericAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                return;
            default:
                if (isNaN(value)) return;
        }
        else if (null != value) switch(typeof value){
            case "function":
            case "symbol":
            case "boolean":
                break;
            default:
                if (!isNaN(value) && (checkAttributeStringCoercion(value, propKey), domElement === "" + value)) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateSanitizedAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                return;
        }
        else if (null != value) switch(typeof value){
            case "function":
            case "symbol":
            case "boolean":
                break;
            default:
                if (checkAttributeStringCoercion(value, propKey), attributeName = sanitizeURL("" + value), domElement === attributeName) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function diffHydratedProperties(domElement, tag, props, hostContext) {
        for(var serverDifferences = {}, extraAttributes = new Set(), attributes = domElement.attributes, i = 0; i < attributes.length; i++)switch(attributes[i].name.toLowerCase()){
            case "value":
                break;
            case "checked":
                break;
            case "selected":
                break;
            default:
                extraAttributes.add(attributes[i].name);
        }
        if (isCustomElement(tag)) {
            for(var propKey in props)if (props.hasOwnProperty(propKey)) {
                var value = props[propKey];
                if (null != value) {
                    if (registrationNameDependencies.hasOwnProperty(propKey)) "function" !== typeof value && warnForInvalidEventListener(propKey, value);
                    else if (!0 !== props.suppressHydrationWarning) switch(propKey){
                        case "children":
                            "string" !== typeof value && "number" !== typeof value || warnForPropDifference("children", domElement.textContent, value, serverDifferences);
                            continue;
                        case "suppressContentEditableWarning":
                        case "suppressHydrationWarning":
                        case "defaultValue":
                        case "defaultChecked":
                        case "innerHTML":
                        case "ref":
                            continue;
                        case "dangerouslySetInnerHTML":
                            attributes = domElement.innerHTML;
                            value = value ? value.__html : void 0;
                            null != value && (value = normalizeHTML(domElement, value), warnForPropDifference(propKey, attributes, value, serverDifferences));
                            continue;
                        case "style":
                            extraAttributes.delete(propKey);
                            diffHydratedStyles(domElement, value, serverDifferences);
                            continue;
                        case "offsetParent":
                        case "offsetTop":
                        case "offsetLeft":
                        case "offsetWidth":
                        case "offsetHeight":
                        case "isContentEditable":
                        case "outerText":
                        case "outerHTML":
                            extraAttributes.delete(propKey.toLowerCase());
                            console.error("Assignment to read-only property will result in a no-op: `%s`", propKey);
                            continue;
                        case "className":
                            extraAttributes.delete("class");
                            attributes = getValueForAttributeOnCustomComponent(domElement, "class", value);
                            warnForPropDifference("className", attributes, value, serverDifferences);
                            continue;
                        default:
                            hostContext.context === HostContextNamespaceNone && "svg" !== tag && "math" !== tag ? extraAttributes.delete(propKey.toLowerCase()) : extraAttributes.delete(propKey), attributes = getValueForAttributeOnCustomComponent(domElement, propKey, value), warnForPropDifference(propKey, attributes, value, serverDifferences);
                    }
                }
            }
        } else for(value in props)if (props.hasOwnProperty(value) && (propKey = props[value], null != propKey)) {
            if (registrationNameDependencies.hasOwnProperty(value)) "function" !== typeof propKey && warnForInvalidEventListener(value, propKey);
            else if (!0 !== props.suppressHydrationWarning) switch(value){
                case "children":
                    "string" !== typeof propKey && "number" !== typeof propKey || warnForPropDifference("children", domElement.textContent, propKey, serverDifferences);
                    continue;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                case "value":
                case "checked":
                case "selected":
                case "defaultValue":
                case "defaultChecked":
                case "innerHTML":
                case "ref":
                    continue;
                case "dangerouslySetInnerHTML":
                    attributes = domElement.innerHTML;
                    propKey = propKey ? propKey.__html : void 0;
                    null != propKey && (propKey = normalizeHTML(domElement, propKey), attributes !== propKey && (serverDifferences[value] = {
                        __html: attributes
                    }));
                    continue;
                case "className":
                    hydrateAttribute(domElement, value, "class", propKey, extraAttributes, serverDifferences);
                    continue;
                case "tabIndex":
                    hydrateAttribute(domElement, value, "tabindex", propKey, extraAttributes, serverDifferences);
                    continue;
                case "style":
                    extraAttributes.delete(value);
                    diffHydratedStyles(domElement, propKey, serverDifferences);
                    continue;
                case "multiple":
                    extraAttributes.delete(value);
                    warnForPropDifference(value, domElement.multiple, propKey, serverDifferences);
                    continue;
                case "muted":
                    extraAttributes.delete(value);
                    warnForPropDifference(value, domElement.muted, propKey, serverDifferences);
                    continue;
                case "autoFocus":
                    extraAttributes.delete("autofocus");
                    warnForPropDifference(value, domElement.autofocus, propKey, serverDifferences);
                    continue;
                case "data":
                    if ("object" !== tag) {
                        extraAttributes.delete(value);
                        attributes = domElement.getAttribute("data");
                        warnForPropDifference(value, attributes, propKey, serverDifferences);
                        continue;
                    }
                case "src":
                case "href":
                    if (!("" !== propKey || "a" === tag && "href" === value || "object" === tag && "data" === value)) {
                        "src" === value ? console.error('An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.', value, value) : console.error('An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.', value, value);
                        continue;
                    }
                    hydrateSanitizedAttribute(domElement, value, value, propKey, extraAttributes, serverDifferences);
                    continue;
                case "action":
                case "formAction":
                    attributes = domElement.getAttribute(value);
                    if ("function" === typeof propKey) {
                        extraAttributes.delete(value.toLowerCase());
                        "formAction" === value ? (extraAttributes.delete("name"), extraAttributes.delete("formenctype"), extraAttributes.delete("formmethod"), extraAttributes.delete("formtarget")) : (extraAttributes.delete("enctype"), extraAttributes.delete("method"), extraAttributes.delete("target"));
                        continue;
                    } else if (attributes === EXPECTED_FORM_ACTION_URL) {
                        extraAttributes.delete(value.toLowerCase());
                        warnForPropDifference(value, "function", propKey, serverDifferences);
                        continue;
                    }
                    hydrateSanitizedAttribute(domElement, value, value.toLowerCase(), propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkHref":
                    hydrateSanitizedAttribute(domElement, value, "xlink:href", propKey, extraAttributes, serverDifferences);
                    continue;
                case "contentEditable":
                    hydrateBooleanishAttribute(domElement, value, "contenteditable", propKey, extraAttributes, serverDifferences);
                    continue;
                case "spellCheck":
                    hydrateBooleanishAttribute(domElement, value, "spellcheck", propKey, extraAttributes, serverDifferences);
                    continue;
                case "draggable":
                case "autoReverse":
                case "externalResourcesRequired":
                case "focusable":
                case "preserveAlpha":
                    hydrateBooleanishAttribute(domElement, value, value, propKey, extraAttributes, serverDifferences);
                    continue;
                case "allowFullScreen":
                case "async":
                case "autoPlay":
                case "controls":
                case "default":
                case "defer":
                case "disabled":
                case "disablePictureInPicture":
                case "disableRemotePlayback":
                case "formNoValidate":
                case "hidden":
                case "loop":
                case "noModule":
                case "noValidate":
                case "open":
                case "playsInline":
                case "readOnly":
                case "required":
                case "reversed":
                case "scoped":
                case "seamless":
                case "itemScope":
                    hydrateBooleanAttribute(domElement, value, value.toLowerCase(), propKey, extraAttributes, serverDifferences);
                    continue;
                case "capture":
                case "download":
                    a: {
                        i = domElement;
                        var attributeName = attributes = value, serverDifferences$jscomp$0 = serverDifferences;
                        extraAttributes.delete(attributeName);
                        i = i.getAttribute(attributeName);
                        if (null === i) switch(typeof propKey){
                            case "undefined":
                            case "function":
                            case "symbol":
                                break a;
                            default:
                                if (!1 === propKey) break a;
                        }
                        else if (null != propKey) switch(typeof propKey){
                            case "function":
                            case "symbol":
                                break;
                            case "boolean":
                                if (!0 === propKey && "" === i) break a;
                                break;
                            default:
                                if (checkAttributeStringCoercion(propKey, attributes), i === "" + propKey) break a;
                        }
                        warnForPropDifference(attributes, i, propKey, serverDifferences$jscomp$0);
                    }
                    continue;
                case "cols":
                case "rows":
                case "size":
                case "span":
                    a: {
                        i = domElement;
                        attributeName = attributes = value;
                        serverDifferences$jscomp$0 = serverDifferences;
                        extraAttributes.delete(attributeName);
                        i = i.getAttribute(attributeName);
                        if (null === i) switch(typeof propKey){
                            case "undefined":
                            case "function":
                            case "symbol":
                            case "boolean":
                                break a;
                            default:
                                if (isNaN(propKey) || 1 > propKey) break a;
                        }
                        else if (null != propKey) switch(typeof propKey){
                            case "function":
                            case "symbol":
                            case "boolean":
                                break;
                            default:
                                if (!(isNaN(propKey) || 1 > propKey) && (checkAttributeStringCoercion(propKey, attributes), i === "" + propKey)) break a;
                        }
                        warnForPropDifference(attributes, i, propKey, serverDifferences$jscomp$0);
                    }
                    continue;
                case "rowSpan":
                    hydrateNumericAttribute(domElement, value, "rowspan", propKey, extraAttributes, serverDifferences);
                    continue;
                case "start":
                    hydrateNumericAttribute(domElement, value, value, propKey, extraAttributes, serverDifferences);
                    continue;
                case "xHeight":
                    hydrateAttribute(domElement, value, "x-height", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkActuate":
                    hydrateAttribute(domElement, value, "xlink:actuate", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkArcrole":
                    hydrateAttribute(domElement, value, "xlink:arcrole", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkRole":
                    hydrateAttribute(domElement, value, "xlink:role", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkShow":
                    hydrateAttribute(domElement, value, "xlink:show", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkTitle":
                    hydrateAttribute(domElement, value, "xlink:title", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkType":
                    hydrateAttribute(domElement, value, "xlink:type", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xmlBase":
                    hydrateAttribute(domElement, value, "xml:base", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xmlLang":
                    hydrateAttribute(domElement, value, "xml:lang", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xmlSpace":
                    hydrateAttribute(domElement, value, "xml:space", propKey, extraAttributes, serverDifferences);
                    continue;
                case "inert":
                    "" !== propKey || didWarnForNewBooleanPropsWithEmptyValue[value] || (didWarnForNewBooleanPropsWithEmptyValue[value] = !0, console.error("Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.", value));
                    hydrateBooleanAttribute(domElement, value, value, propKey, extraAttributes, serverDifferences);
                    continue;
                default:
                    if (!(2 < value.length) || "o" !== value[0] && "O" !== value[0] || "n" !== value[1] && "N" !== value[1]) {
                        i = getAttributeAlias(value);
                        attributes = !1;
                        hostContext.context === HostContextNamespaceNone && "svg" !== tag && "math" !== tag ? extraAttributes.delete(i.toLowerCase()) : (attributeName = value.toLowerCase(), attributeName = possibleStandardNames.hasOwnProperty(attributeName) ? possibleStandardNames[attributeName] || null : null, null !== attributeName && attributeName !== value && (attributes = !0, extraAttributes.delete(attributeName)), extraAttributes.delete(i));
                        a: if (attributeName = domElement, serverDifferences$jscomp$0 = i, i = propKey, isAttributeNameSafe(serverDifferences$jscomp$0)) {
                            if (attributeName.hasAttribute(serverDifferences$jscomp$0)) attributeName = attributeName.getAttribute(serverDifferences$jscomp$0), checkAttributeStringCoercion(i, serverDifferences$jscomp$0), i = attributeName === "" + i ? i : attributeName;
                            else {
                                switch(typeof i){
                                    case "function":
                                    case "symbol":
                                        break a;
                                    case "boolean":
                                        if (attributeName = serverDifferences$jscomp$0.toLowerCase().slice(0, 5), "data-" !== attributeName && "aria-" !== attributeName) break a;
                                }
                                i = void 0 === i ? void 0 : null;
                            }
                        } else i = void 0;
                        attributes || warnForPropDifference(value, i, propKey, serverDifferences);
                    }
            }
        }
        0 < extraAttributes.size && !0 !== props.suppressHydrationWarning && warnForExtraAttributes(domElement, extraAttributes, serverDifferences);
        return 0 === Object.keys(serverDifferences).length ? null : serverDifferences;
    }
    function propNamesListJoin(list, combinator) {
        switch(list.length){
            case 0:
                return "";
            case 1:
                return list[0];
            case 2:
                return list[0] + " " + combinator + " " + list[1];
            default:
                return list.slice(0, -1).join(", ") + ", " + combinator + " " + list[list.length - 1];
        }
    }
    function isLikelyStaticResource(initiatorType) {
        switch(initiatorType){
            case "css":
            case "script":
            case "font":
            case "img":
            case "image":
            case "input":
            case "link":
                return !0;
            default:
                return !1;
        }
    }
    function estimateBandwidth() {
        if ("function" === typeof performance.getEntriesByType) {
            for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
                var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
                if (transferSize && duration && isLikelyStaticResource(initiatorType)) {
                    initiatorType = 0;
                    duration = entry.responseEnd;
                    for(i += 1; i < resourceEntries.length; i++){
                        var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                        if (overlapStartTime > duration) break;
                        var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                        overlapTransferSize && isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                    }
                    --i;
                    bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                    count++;
                    if (10 < count) break;
                }
            }
            if (0 < count) return bits / count / 1e6;
        }
        return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function getOwnHostContext(namespaceURI) {
        switch(namespaceURI){
            case SVG_NAMESPACE:
                return HostContextNamespaceSvg;
            case MATH_NAMESPACE:
                return HostContextNamespaceMath;
            default:
                return HostContextNamespaceNone;
        }
    }
    function getChildHostContextProd(parentNamespace, type) {
        if (parentNamespace === HostContextNamespaceNone) switch(type){
            case "svg":
                return HostContextNamespaceSvg;
            case "math":
                return HostContextNamespaceMath;
            default:
                return HostContextNamespaceNone;
        }
        return parentNamespace === HostContextNamespaceSvg && "foreignObject" === type ? HostContextNamespaceNone : parentNamespace;
    }
    function shouldSetTextContent(type, props) {
        return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
    }
    function shouldAttemptEagerTransition() {
        var event = window.event;
        if (event && "popstate" === event.type) {
            if (event === currentPopstateTransitionEvent) return !1;
            currentPopstateTransitionEvent = event;
            return !0;
        }
        currentPopstateTransitionEvent = null;
        return !1;
    }
    function resolveEventType() {
        var event = window.event;
        return event && event !== schedulerEvent ? event.type : null;
    }
    function resolveEventTimeStamp() {
        var event = window.event;
        return event && event !== schedulerEvent ? event.timeStamp : -1.1;
    }
    function handleErrorInNextTick(error) {
        setTimeout(function() {
            throw error;
        });
    }
    function commitMount(domElement, type, newProps) {
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                newProps.autoFocus && domElement.focus();
                break;
            case "img":
                newProps.src ? domElement.src = newProps.src : newProps.srcSet && (domElement.srcset = newProps.srcSet);
        }
    }
    function commitHydratedInstance() {}
    function commitUpdate(domElement, type, oldProps, newProps) {
        updateProperties(domElement, type, oldProps, newProps);
        domElement[internalPropsKey] = newProps;
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, "");
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function warnForReactChildrenConflict(container) {
        if (!container.__reactWarnedAboutChildrenConflict) {
            var props = container[internalPropsKey] || null;
            if (null !== props) {
                var fiber = getInstanceFromNode(container);
                null !== fiber && ("string" === typeof props.children || "number" === typeof props.children ? (container.__reactWarnedAboutChildrenConflict = !0, runWithFiberInDEV(fiber, function() {
                    console.error('Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets "children" text content using React. It should be a leaf with no children. Otherwise it\'s ambiguous which children should be used.');
                })) : null != props.dangerouslySetInnerHTML && (container.__reactWarnedAboutChildrenConflict = !0, runWithFiberInDEV(fiber, function() {
                    console.error('Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets "dangerouslySetInnerHTML" using React. It should be a leaf with no children. Otherwise it\'s ambiguous which children should be used.');
                })));
            }
        }
    }
    function isSingletonScope(type) {
        return "head" === type;
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        (9 === container.nodeType ? container.body : "HTML" === container.nodeName ? container.ownerDocument.body : container).removeChild(child);
    }
    function clearHydrationBoundary(parentInstance, hydrationInstance) {
        var node = hydrationInstance, depth = 0;
        do {
            var nextNode = node.nextSibling;
            parentInstance.removeChild(node);
            if (nextNode && 8 === nextNode.nodeType) {
                if (node = nextNode.data, node === SUSPENSE_END_DATA || node === ACTIVITY_END_DATA) {
                    if (0 === depth) {
                        parentInstance.removeChild(nextNode);
                        retryIfBlockedOn(hydrationInstance);
                        return;
                    }
                    depth--;
                } else if (node === SUSPENSE_START_DATA || node === SUSPENSE_PENDING_START_DATA || node === SUSPENSE_QUEUED_START_DATA || node === SUSPENSE_FALLBACK_START_DATA || node === ACTIVITY_START_DATA) depth++;
                else if (node === PREAMBLE_CONTRIBUTION_HTML) releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
                else if (node === PREAMBLE_CONTRIBUTION_HEAD) {
                    node = parentInstance.ownerDocument.head;
                    releaseSingletonInstance(node);
                    for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                        var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                        node$jscomp$0[internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                        node$jscomp$0 = nextNode$jscomp$0;
                    }
                } else node === PREAMBLE_CONTRIBUTION_BODY && releaseSingletonInstance(parentInstance.ownerDocument.body);
            }
            node = nextNode;
        }while (node);
        retryIfBlockedOn(hydrationInstance);
    }
    function hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
        var node = suspenseInstance;
        suspenseInstance = 0;
        do {
            var nextNode = node.nextSibling;
            1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
            if (nextNode && 8 === nextNode.nodeType) {
                if (node = nextNode.data, node === SUSPENSE_END_DATA) {
                    if (0 === suspenseInstance) break;
                    else suspenseInstance--;
                } else node !== SUSPENSE_START_DATA && node !== SUSPENSE_PENDING_START_DATA && node !== SUSPENSE_QUEUED_START_DATA && node !== SUSPENSE_FALLBACK_START_DATA || suspenseInstance++;
            }
            node = nextNode;
        }while (node);
    }
    function hideDehydratedBoundary(suspenseInstance) {
        hideOrUnhideDehydratedBoundary(suspenseInstance, !0);
    }
    function hideInstance(instance) {
        instance = instance.style;
        "function" === typeof instance.setProperty ? instance.setProperty("display", "none", "important") : instance.display = "none";
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = "";
    }
    function unhideDehydratedBoundary(dehydratedInstance) {
        hideOrUnhideDehydratedBoundary(dehydratedInstance, !1);
    }
    function unhideInstance(instance, props) {
        props = props[STYLE];
        props = void 0 !== props && null !== props && props.hasOwnProperty("display") ? props.display : null;
        instance.style.display = null == props || "boolean" === typeof props ? "" : ("" + props).trim();
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function clearContainerSparingly(container) {
        var nextNode = container.firstChild;
        nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
        for(; nextNode;){
            var node = nextNode;
            nextNode = nextNode.nextSibling;
            switch(node.nodeName){
                case "HTML":
                case "HEAD":
                case "BODY":
                    clearContainerSparingly(node);
                    detachDeletedInstance(node);
                    continue;
                case "SCRIPT":
                case "STYLE":
                    continue;
                case "LINK":
                    if ("stylesheet" === node.rel.toLowerCase()) continue;
            }
            container.removeChild(node);
        }
    }
    function canHydrateInstance(instance, type, props, inRootOrSingleton) {
        for(; 1 === instance.nodeType;){
            var anyProps = props;
            if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
                if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
            } else if (!inRootOrSingleton) {
                if ("input" === type && "hidden" === instance.type) {
                    checkAttributeStringCoercion(anyProps.name, "name");
                    var name = null == anyProps.name ? null : "" + anyProps.name;
                    if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
                } else return instance;
            } else if (!instance[internalHoistableMarker]) switch(type){
                case "meta":
                    if (!instance.hasAttribute("itemprop")) break;
                    return instance;
                case "link":
                    name = instance.getAttribute("rel");
                    if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                    else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                    return instance;
                case "style":
                    if (instance.hasAttribute("data-precedence")) break;
                    return instance;
                case "script":
                    name = instance.getAttribute("src");
                    if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                    return instance;
                default:
                    return instance;
            }
            instance = getNextHydratable(instance.nextSibling);
            if (null === instance) break;
        }
        return null;
    }
    function canHydrateTextInstance(instance, text, inRootOrSingleton) {
        if ("" === text) return null;
        for(; 3 !== instance.nodeType;){
            if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
            instance = getNextHydratable(instance.nextSibling);
            if (null === instance) return null;
        }
        return instance;
    }
    function canHydrateHydrationBoundary(instance, inRootOrSingleton) {
        for(; 8 !== instance.nodeType;){
            if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
            instance = getNextHydratable(instance.nextSibling);
            if (null === instance) return null;
        }
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA || instance.data === SUSPENSE_QUEUED_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA || instance.data === SUSPENSE_PENDING_START_DATA && instance.ownerDocument.readyState !== DOCUMENT_READY_STATE_LOADING;
    }
    function registerSuspenseInstanceRetry(instance, callback) {
        var ownerDocument = instance.ownerDocument;
        if (instance.data === SUSPENSE_QUEUED_START_DATA) instance._reactRetry = callback;
        else if (instance.data !== SUSPENSE_PENDING_START_DATA || ownerDocument.readyState !== DOCUMENT_READY_STATE_LOADING) callback();
        else {
            var listener = function() {
                callback();
                ownerDocument.removeEventListener("DOMContentLoaded", listener);
            };
            ownerDocument.addEventListener("DOMContentLoaded", listener);
            instance._reactRetry = listener;
        }
    }
    function getNextHydratable(node) {
        for(; null != node; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (1 === nodeType || 3 === nodeType) break;
            if (8 === nodeType) {
                nodeType = node.data;
                if (nodeType === SUSPENSE_START_DATA || nodeType === SUSPENSE_FALLBACK_START_DATA || nodeType === SUSPENSE_PENDING_START_DATA || nodeType === SUSPENSE_QUEUED_START_DATA || nodeType === ACTIVITY_START_DATA || nodeType === FORM_STATE_IS_MATCHING || nodeType === FORM_STATE_IS_NOT_MATCHING) break;
                if (nodeType === SUSPENSE_END_DATA || nodeType === ACTIVITY_END_DATA) return null;
            }
        }
        return node;
    }
    function describeHydratableInstanceForDevWarnings(instance) {
        if (1 === instance.nodeType) {
            for(var JSCompiler_temp_const = instance.nodeName.toLowerCase(), serverDifferences = {}, attributes = instance.attributes, i = 0; i < attributes.length; i++){
                var attr = attributes[i];
                serverDifferences[getPropNameFromAttributeName(attr.name)] = "style" === attr.name.toLowerCase() ? getStylesObjectFromElement(instance) : attr.value;
            }
            return {
                type: JSCompiler_temp_const,
                props: serverDifferences
            };
        }
        return 8 === instance.nodeType ? instance.data === ACTIVITY_START_DATA ? {
            type: "Activity",
            props: {}
        } : {
            type: "Suspense",
            props: {}
        } : instance.nodeValue;
    }
    function diffHydratedTextForDevWarnings(textInstance, text, parentProps) {
        return null === parentProps || !0 !== parentProps[SUPPRESS_HYDRATION_WARNING] ? (textInstance.nodeValue === text ? textInstance = null : (text = normalizeMarkupForTextOrAttribute(text), textInstance = normalizeMarkupForTextOrAttribute(textInstance.nodeValue) === text ? null : textInstance.nodeValue), textInstance) : null;
    }
    function getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
        hydrationInstance = hydrationInstance.nextSibling;
        for(var depth = 0; hydrationInstance;){
            if (8 === hydrationInstance.nodeType) {
                var data = hydrationInstance.data;
                if (data === SUSPENSE_END_DATA || data === ACTIVITY_END_DATA) {
                    if (0 === depth) return getNextHydratable(hydrationInstance.nextSibling);
                    depth--;
                } else data !== SUSPENSE_START_DATA && data !== SUSPENSE_FALLBACK_START_DATA && data !== SUSPENSE_PENDING_START_DATA && data !== SUSPENSE_QUEUED_START_DATA && data !== ACTIVITY_START_DATA || depth++;
            }
            hydrationInstance = hydrationInstance.nextSibling;
        }
        return null;
    }
    function getParentHydrationBoundary(targetInstance) {
        targetInstance = targetInstance.previousSibling;
        for(var depth = 0; targetInstance;){
            if (8 === targetInstance.nodeType) {
                var data = targetInstance.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_QUEUED_START_DATA || data === ACTIVITY_START_DATA) {
                    if (0 === depth) return targetInstance;
                    depth--;
                } else data !== SUSPENSE_END_DATA && data !== ACTIVITY_END_DATA || depth++;
            }
            targetInstance = targetInstance.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        retryIfBlockedOn(container);
    }
    function commitHydratedActivityInstance(activityInstance) {
        retryIfBlockedOn(activityInstance);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        retryIfBlockedOn(suspenseInstance);
    }
    function resolveSingletonInstance(type, props, rootContainerInstance, hostContext, validateDOMNestingDev) {
        validateDOMNestingDev && validateDOMNesting(type, hostContext.ancestorInfo);
        props = getOwnerDocumentFromRootContainer(rootContainerInstance);
        switch(type){
            case "html":
                type = props.documentElement;
                if (!type) throw Error("React expected an <html> element (document.documentElement) to exist in the Document but one was not found. React never removes the documentElement for any Document it renders into so the cause is likely in some other script running on this page.");
                return type;
            case "head":
                type = props.head;
                if (!type) throw Error("React expected a <head> element (document.head) to exist in the Document but one was not found. React never removes the head for any Document it renders into so the cause is likely in some other script running on this page.");
                return type;
            case "body":
                type = props.body;
                if (!type) throw Error("React expected a <body> element (document.body) to exist in the Document but one was not found. React never removes the body for any Document it renders into so the cause is likely in some other script running on this page.");
                return type;
            default:
                throw Error("resolveSingletonInstance was called with an element type that is not supported. This is a bug in React.");
        }
    }
    function acquireSingletonInstance(type, props, instance, internalInstanceHandle) {
        if (!instance[internalContainerInstanceKey] && getInstanceFromNode(instance)) {
            var tagName = instance.tagName.toLowerCase();
            console.error("You are mounting a new %s component when a previous one has not first unmounted. It is an error to render more than one %s component at a time and attributes and children of these components will likely fail in unpredictable ways. Please only render a single instance of <%s> and if you need to mount a new one, ensure any previous ones have unmounted first.", tagName, tagName, tagName);
        }
        switch(type){
            case "html":
            case "head":
            case "body":
                break;
            default:
                console.error("acquireSingletonInstance was called with an element type that is not supported. This is a bug in React.");
        }
        for(tagName = instance.attributes; tagName.length;)instance.removeAttributeNode(tagName[0]);
        setInitialProperties(instance, type, props);
        instance[internalInstanceKey] = internalInstanceHandle;
        instance[internalPropsKey] = props;
    }
    function releaseSingletonInstance(instance) {
        for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
        detachDeletedInstance(instance);
    }
    function getHoistableRoot(container) {
        return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
    }
    function preconnectAs(rel, href, crossOrigin) {
        var ownerDocument = globalDocument;
        if (ownerDocument && "string" === typeof href && href) {
            var limitedEscapedHref = escapeSelectorAttributeValueInsideDoubleQuotes(href);
            limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
            "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
            preconnectsSet.has(limitedEscapedHref) || (preconnectsSet.add(limitedEscapedHref), rel = {
                rel: rel,
                crossOrigin: crossOrigin,
                href: href
            }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), setInitialProperties(href, "link", rel), markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
        }
    }
    function getResource(type, currentProps, pendingProps, currentResource) {
        var resourceRoot = (resourceRoot = rootInstanceStackCursor.current) ? getHoistableRoot(resourceRoot) : null;
        if (!resourceRoot) throw Error('"resourceRoot" was expected to exist. This is a bug in React.');
        switch(type){
            case "meta":
            case "title":
                return null;
            case "style":
                return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = getStyleKey(pendingProps.href), currentProps = getResourcesFromRoot(resourceRoot).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                    type: "style",
                    instance: null,
                    count: 0,
                    state: null
                }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                    type: "void",
                    instance: null,
                    count: 0,
                    state: null
                };
            case "link":
                if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                    type = getStyleKey(pendingProps.href);
                    var _styles = getResourcesFromRoot(resourceRoot).hoistableStyles, _resource = _styles.get(type);
                    if (!_resource && (resourceRoot = resourceRoot.ownerDocument || resourceRoot, _resource = {
                        type: "stylesheet",
                        instance: null,
                        count: 0,
                        state: {
                            loading: NotLoaded,
                            preload: null
                        }
                    }, _styles.set(type, _resource), (_styles = resourceRoot.querySelector(getStylesheetSelectorFromKey(type))) && !_styles._p && (_resource.instance = _styles, _resource.state.loading = Loaded | Inserted), !preloadPropsMap.has(type))) {
                        var preloadProps = {
                            rel: "preload",
                            as: "style",
                            href: pendingProps.href,
                            crossOrigin: pendingProps.crossOrigin,
                            integrity: pendingProps.integrity,
                            media: pendingProps.media,
                            hrefLang: pendingProps.hrefLang,
                            referrerPolicy: pendingProps.referrerPolicy
                        };
                        preloadPropsMap.set(type, preloadProps);
                        _styles || preloadStylesheet(resourceRoot, type, preloadProps, _resource.state);
                    }
                    if (currentProps && null === currentResource) throw pendingProps = "\n\n  - " + describeLinkForResourceErrorDEV(currentProps) + "\n  + " + describeLinkForResourceErrorDEV(pendingProps), Error("Expected <link> not to update to be updated to a stylesheet with precedence. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + pendingProps);
                    return _resource;
                }
                if (currentProps && null !== currentResource) throw pendingProps = "\n\n  - " + describeLinkForResourceErrorDEV(currentProps) + "\n  + " + describeLinkForResourceErrorDEV(pendingProps), Error("Expected stylesheet with precedence to not be updated to a different kind of <link>. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + pendingProps);
                return null;
            case "script":
                return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = getScriptKey(pendingProps), currentProps = getResourcesFromRoot(resourceRoot).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                    type: "script",
                    instance: null,
                    count: 0,
                    state: null
                }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                    type: "void",
                    instance: null,
                    count: 0,
                    state: null
                };
            default:
                throw Error('getResource encountered a type it did not expect: "' + type + '". this is a bug in React.');
        }
    }
    function describeLinkForResourceErrorDEV(props) {
        var describedProps = 0, description = "<link";
        "string" === typeof props.rel ? (describedProps++, description += ' rel="' + props.rel + '"') : hasOwnProperty.call(props, "rel") && (describedProps++, description += ' rel="' + (null === props.rel ? "null" : "invalid type " + typeof props.rel) + '"');
        "string" === typeof props.href ? (describedProps++, description += ' href="' + props.href + '"') : hasOwnProperty.call(props, "href") && (describedProps++, description += ' href="' + (null === props.href ? "null" : "invalid type " + typeof props.href) + '"');
        "string" === typeof props.precedence ? (describedProps++, description += ' precedence="' + props.precedence + '"') : hasOwnProperty.call(props, "precedence") && (describedProps++, description += " precedence={" + (null === props.precedence ? "null" : "invalid type " + typeof props.precedence) + "}");
        Object.getOwnPropertyNames(props).length > describedProps && (description += " ...");
        return description + " />";
    }
    function getStyleKey(href) {
        return 'href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
    }
    function getStylesheetSelectorFromKey(key) {
        return 'link[rel="stylesheet"][' + key + "]";
    }
    function stylesheetPropsFromRawProps(rawProps) {
        return assign({}, rawProps, {
            "data-precedence": rawProps.precedence,
            precedence: null
        });
    }
    function preloadStylesheet(ownerDocument, key, preloadProps, state) {
        ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = Loaded : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
            return state.loading |= Loaded;
        }), key.addEventListener("error", function() {
            return state.loading |= Errored;
        }), setInitialProperties(key, "link", preloadProps), markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
    }
    function getScriptKey(src) {
        return '[src="' + escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
    }
    function getScriptSelectorFromKey(key) {
        return "script[async]" + key;
    }
    function acquireResource(hoistableRoot, resource, props) {
        resource.count++;
        if (null === resource.instance) switch(resource.type){
            case "style":
                var instance = hoistableRoot.querySelector('style[data-href~="' + escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
                if (instance) return resource.instance = instance, markNodeAsHoistable(instance), instance;
                var styleProps = assign({}, props, {
                    "data-href": props.href,
                    "data-precedence": props.precedence,
                    href: null,
                    precedence: null
                });
                instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
                markNodeAsHoistable(instance);
                setInitialProperties(instance, "style", styleProps);
                insertStylesheet(instance, props.precedence, hoistableRoot);
                return resource.instance = instance;
            case "stylesheet":
                styleProps = getStyleKey(props.href);
                var _instance = hoistableRoot.querySelector(getStylesheetSelectorFromKey(styleProps));
                if (_instance) return resource.state.loading |= Inserted, resource.instance = _instance, markNodeAsHoistable(_instance), _instance;
                instance = stylesheetPropsFromRawProps(props);
                (styleProps = preloadPropsMap.get(styleProps)) && adoptPreloadPropsForStylesheet(instance, styleProps);
                _instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
                markNodeAsHoistable(_instance);
                var linkInstance = _instance;
                linkInstance._p = new Promise(function(resolve, reject) {
                    linkInstance.onload = resolve;
                    linkInstance.onerror = reject;
                });
                setInitialProperties(_instance, "link", instance);
                resource.state.loading |= Inserted;
                insertStylesheet(_instance, props.precedence, hoistableRoot);
                return resource.instance = _instance;
            case "script":
                _instance = getScriptKey(props.src);
                if (styleProps = hoistableRoot.querySelector(getScriptSelectorFromKey(_instance))) return resource.instance = styleProps, markNodeAsHoistable(styleProps), styleProps;
                instance = props;
                if (styleProps = preloadPropsMap.get(_instance)) instance = assign({}, props), adoptPreloadPropsForScript(instance, styleProps);
                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                styleProps = hoistableRoot.createElement("script");
                markNodeAsHoistable(styleProps);
                setInitialProperties(styleProps, "link", instance);
                hoistableRoot.head.appendChild(styleProps);
                return resource.instance = styleProps;
            case "void":
                return null;
            default:
                throw Error('acquireResource encountered a resource type it did not expect: "' + resource.type + '". this is a bug in React.');
        }
        else "stylesheet" === resource.type && (resource.state.loading & Inserted) === NotLoaded && (instance = resource.instance, resource.state.loading |= Inserted, insertStylesheet(instance, props.precedence, hoistableRoot));
        return resource.instance;
    }
    function insertStylesheet(instance, precedence, root) {
        for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
            var node = nodes[i];
            if (node.dataset.precedence === precedence) prior = node;
            else if (prior !== last) break;
        }
        prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
    }
    function adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
        null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
        null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
        null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
    }
    function adoptPreloadPropsForScript(scriptProps, preloadProps) {
        null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
        null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
        null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
    }
    function getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
        if (null === tagCaches) {
            var cache = new Map();
            var caches = tagCaches = new Map();
            caches.set(ownerDocument, cache);
        } else caches = tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
        if (cache.has(type)) return cache;
        cache.set(type, null);
        ownerDocument = ownerDocument.getElementsByTagName(type);
        for(caches = 0; caches < ownerDocument.length; caches++){
            var node = ownerDocument[caches];
            if (!(node[internalHoistableMarker] || node[internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && node.namespaceURI !== SVG_NAMESPACE) {
                var nodeKey = node.getAttribute(keyAttribute) || "";
                nodeKey = type + nodeKey;
                var existing = cache.get(nodeKey);
                existing ? existing.push(node) : cache.set(nodeKey, [
                    node
                ]);
            }
        }
        return cache;
    }
    function mountHoistable(hoistableRoot, type, instance) {
        hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
        hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
    }
    function isHostHoistableType(type, props, hostContext) {
        var outsideHostContainerContext = !hostContext.ancestorInfo.containerTagInScope;
        if (hostContext.context === HostContextNamespaceSvg || null != props.itemProp) return !outsideHostContainerContext || null == props.itemProp || "meta" !== type && "title" !== type && "style" !== type && "link" !== type && "script" !== type || console.error("Cannot render a <%s> outside the main document if it has an `itemProp` prop. `itemProp` suggests the tag belongs to an `itemScope` which can appear anywhere in the DOM. If you were intending for React to hoist this <%s> remove the `itemProp` prop. Otherwise, try moving this tag into the <head> or <body> of the Document.", type, type), !1;
        switch(type){
            case "meta":
            case "title":
                return !0;
            case "style":
                if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) {
                    outsideHostContainerContext && console.error('Cannot render a <style> outside the main document without knowing its precedence and a unique href key. React can hoist and deduplicate <style> tags if you provide a `precedence` prop along with an `href` prop that does not conflict with the `href` values used in any other hoisted <style> or <link rel="stylesheet" ...> tags.  Note that hoisting <style> tags is considered an advanced feature that most will not use directly. Consider moving the <style> tag to the <head> or consider adding a `precedence="default"` and `href="some unique resource identifier"`.');
                    break;
                }
                return !0;
            case "link":
                if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) {
                    if ("stylesheet" === props.rel && "string" === typeof props.precedence) {
                        type = props.href;
                        var onError = props.onError, disabled = props.disabled;
                        hostContext = [];
                        props.onLoad && hostContext.push("`onLoad`");
                        onError && hostContext.push("`onError`");
                        null != disabled && hostContext.push("`disabled`");
                        onError = propNamesListJoin(hostContext, "and");
                        onError += 1 === hostContext.length ? " prop" : " props";
                        disabled = 1 === hostContext.length ? "an " + onError : "the " + onError;
                        hostContext.length && console.error('React encountered a <link rel="stylesheet" href="%s" ... /> with a `precedence` prop that also included %s. The presence of loading and error handlers indicates an intent to manage the stylesheet loading state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the %s, otherwise remove the `precedence` prop.', type, disabled, onError);
                    }
                    outsideHostContainerContext && ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href ? console.error("Cannot render a <link> outside the main document without a `rel` and `href` prop. Try adding a `rel` and/or `href` prop to this <link> or moving the link into the <head> tag") : (props.onError || props.onLoad) && console.error("Cannot render a <link> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."));
                    break;
                }
                switch(props.rel){
                    case "stylesheet":
                        return type = props.precedence, props = props.disabled, "string" !== typeof type && outsideHostContainerContext && console.error('Cannot render a <link rel="stylesheet" /> outside the main document without knowing its precedence. Consider adding precedence="default" or moving it into the root <head> tag.'), "string" === typeof type && null == props;
                    default:
                        return !0;
                }
            case "script":
                type = props.async && "function" !== typeof props.async && "symbol" !== typeof props.async;
                if (!type || props.onLoad || props.onError || !props.src || "string" !== typeof props.src) {
                    outsideHostContainerContext && (type ? props.onLoad || props.onError ? console.error("Cannot render a <script> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>.") : console.error("Cannot render a <script> outside the main document without `async={true}` and a non-empty `src` prop. Ensure there is a valid `src` and either make the script async or move it into the root <head> tag or somewhere in the <body>.") : console.error('Cannot render a sync or defer <script> outside the main document without knowing its order. Try adding async="" or moving it into the root <head> tag.'));
                    break;
                }
                return !0;
            case "noscript":
            case "template":
                outsideHostContainerContext && console.error("Cannot render <%s> outside the main document. Try moving it into the root <head> tag.", type);
        }
        return !1;
    }
    function preloadResource(resource) {
        return "stylesheet" === resource.type && (resource.state.loading & Settled) === NotLoaded ? !1 : !0;
    }
    function suspendResource(state, hoistableRoot, resource, props) {
        if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && (resource.state.loading & Inserted) === NotLoaded) {
            if (null === resource.instance) {
                var key = getStyleKey(props.href), instance = hoistableRoot.querySelector(getStylesheetSelectorFromKey(key));
                if (instance) {
                    hoistableRoot = instance._p;
                    null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = onUnsuspend.bind(state), hoistableRoot.then(state, state));
                    resource.state.loading |= Inserted;
                    resource.instance = instance;
                    markNodeAsHoistable(instance);
                    return;
                }
                instance = hoistableRoot.ownerDocument || hoistableRoot;
                props = stylesheetPropsFromRawProps(props);
                (key = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(props, key);
                instance = instance.createElement("link");
                markNodeAsHoistable(instance);
                var linkInstance = instance;
                linkInstance._p = new Promise(function(resolve, reject) {
                    linkInstance.onload = resolve;
                    linkInstance.onerror = reject;
                });
                setInitialProperties(instance, "link", props);
                resource.instance = instance;
            }
            null === state.stylesheets && (state.stylesheets = new Map());
            state.stylesheets.set(resource, hoistableRoot);
            (hoistableRoot = resource.state.preload) && (resource.state.loading & Settled) === NotLoaded && (state.count++, resource = onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
        }
    }
    function waitForCommitToBeReady(state, timeoutOffset) {
        state.stylesheets && 0 === state.count && insertSuspendedStylesheets(state, state.stylesheets);
        return 0 < state.count || 0 < state.imgCount ? function(commit) {
            var stylesheetTimer = setTimeout(function() {
                state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets);
                if (state.unsuspend) {
                    var unsuspend = state.unsuspend;
                    state.unsuspend = null;
                    unsuspend();
                }
            }, SUSPENSEY_STYLESHEET_TIMEOUT + timeoutOffset);
            0 < state.imgBytes && 0 === estimatedBytesWithinLimit && (estimatedBytesWithinLimit = 125 * estimateBandwidth() * SUSPENSEY_IMAGE_TIME_ESTIMATE);
            var imgTimer = setTimeout(function() {
                state.waitingForImages = !1;
                if (0 === state.count && (state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                    var unsuspend = state.unsuspend;
                    state.unsuspend = null;
                    unsuspend();
                }
            }, (state.imgBytes > estimatedBytesWithinLimit ? 50 : SUSPENSEY_IMAGE_TIMEOUT) + timeoutOffset);
            state.unsuspend = commit;
            return function() {
                state.unsuspend = null;
                clearTimeout(stylesheetTimer);
                clearTimeout(imgTimer);
            };
        } : null;
    }
    function onUnsuspend() {
        this.count--;
        if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
            if (this.stylesheets) insertSuspendedStylesheets(this, this.stylesheets);
            else if (this.unsuspend) {
                var unsuspend = this.unsuspend;
                this.unsuspend = null;
                unsuspend();
            }
        }
    }
    function insertSuspendedStylesheets(state, resources) {
        state.stylesheets = null;
        null !== state.unsuspend && (state.count++, precedencesByRoot = new Map(), resources.forEach(insertStylesheetIntoRoot, state), precedencesByRoot = null, onUnsuspend.call(state));
    }
    function insertStylesheetIntoRoot(root, resource) {
        if (!(resource.state.loading & Inserted)) {
            var precedences = precedencesByRoot.get(root);
            if (precedences) var last = precedences.get(LAST_PRECEDENCE);
            else {
                precedences = new Map();
                precedencesByRoot.set(root, precedences);
                for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                    var node = nodes[i];
                    if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
                }
                last && precedences.set(LAST_PRECEDENCE, last);
            }
            nodes = resource.instance;
            node = nodes.getAttribute("data-precedence");
            i = precedences.get(node) || last;
            i === last && precedences.set(LAST_PRECEDENCE, nodes);
            precedences.set(node, nodes);
            this.count++;
            last = onUnsuspend.bind(this);
            nodes.addEventListener("load", last);
            nodes.addEventListener("error", last);
            i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
            resource.state.loading |= Inserted;
        }
    }
    function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
        this.tag = 1;
        this.containerInfo = containerInfo;
        this.pingCache = this.current = this.pendingChildren = null;
        this.timeoutHandle = noTimeout;
        this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
        this.callbackPriority = 0;
        this.expirationTimes = createLaneMap(-1);
        this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
        this.entanglements = createLaneMap(0);
        this.hiddenUpdates = createLaneMap(null);
        this.identifierPrefix = identifierPrefix;
        this.onUncaughtError = onUncaughtError;
        this.onCaughtError = onCaughtError;
        this.onRecoverableError = onRecoverableError;
        this.pooledCache = null;
        this.pooledCacheLanes = 0;
        this.formState = formState;
        this.incompleteTransitions = new Map();
        this.passiveEffectDuration = this.effectDuration = -0;
        this.memoizedUpdaters = new Set();
        containerInfo = this.pendingUpdatersLaneMap = [];
        for(tag = 0; 31 > tag; tag++)containerInfo.push(new Set());
        this._debugRootType = hydrate ? "hydrateRoot()" : "createRoot()";
    }
    function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
        containerInfo = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
        tag = ConcurrentMode;
        !0 === isStrictMode && (tag |= StrictLegacyMode | StrictEffectsMode);
        tag |= ProfileMode;
        isStrictMode = createFiber(3, null, null, tag);
        containerInfo.current = isStrictMode;
        isStrictMode.stateNode = containerInfo;
        tag = createCache();
        retainCache(tag);
        containerInfo.pooledCache = tag;
        retainCache(tag);
        isStrictMode.memoizedState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: tag
        };
        initializeUpdateQueue(isStrictMode);
        return containerInfo;
    }
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        parentComponent = emptyContextObject;
        return parentComponent;
    }
    function updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
        if (injectedHook && "function" === typeof injectedHook.onScheduleFiberRoot) try {
            injectedHook.onScheduleFiberRoot(rendererID, container, element);
        } catch (err) {
            hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
        }
        parentComponent = getContextForSubtree(parentComponent);
        null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
        isRendering && null !== current && !didWarnAboutNestedUpdates && (didWarnAboutNestedUpdates = !0, console.error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentNameFromFiber(current) || "Unknown"));
        container = createUpdate(lane);
        container.payload = {
            element: element
        };
        callback = void 0 === callback ? null : callback;
        null !== callback && ("function" !== typeof callback && console.error("Expected the last optional `callback` argument to be a function. Instead received: %s.", callback), container.callback = callback);
        element = enqueueUpdate(rootFiber, container, lane);
        null !== element && (startUpdateTimerByLane(lane, "root.render()", null), scheduleUpdateOnFiber(element, rootFiber, lane), entangleTransitions(element, rootFiber, lane));
    }
    function markRetryLaneImpl(fiber, retryLane) {
        fiber = fiber.memoizedState;
        if (null !== fiber && null !== fiber.dehydrated) {
            var a = fiber.retryLane;
            fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
        }
    }
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
    }
    function attemptContinuousHydration(fiber) {
        if (13 === fiber.tag || 31 === fiber.tag) {
            var root = enqueueConcurrentRenderForLane(fiber, 67108864);
            null !== root && scheduleUpdateOnFiber(root, fiber, 67108864);
            markRetryLaneIfNotHydrated(fiber, 67108864);
        }
    }
    function attemptHydrationAtCurrentPriority(fiber) {
        if (13 === fiber.tag || 31 === fiber.tag) {
            var lane = requestUpdateLane(fiber);
            lane = getBumpedLaneForHydrationByLane(lane);
            var root = enqueueConcurrentRenderForLane(fiber, lane);
            null !== root && scheduleUpdateOnFiber(root, fiber, lane);
            markRetryLaneIfNotHydrated(fiber, lane);
        }
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var prevTransition = ReactSharedInternals.T;
        ReactSharedInternals.T = null;
        var previousPriority = ReactDOMSharedInternals.p;
        try {
            ReactDOMSharedInternals.p = DiscreteEventPriority, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
        }
    }
    function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var prevTransition = ReactSharedInternals.T;
        ReactSharedInternals.T = null;
        var previousPriority = ReactDOMSharedInternals.p;
        try {
            ReactDOMSharedInternals.p = ContinuousEventPriority, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
        }
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (_enabled) {
            var blockedOn = findInstanceBlockingEvent(nativeEvent);
            if (null === blockedOn) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer), clearIfContinuousEvent(domEventName, nativeEvent);
            else if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
            else if (clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < discreteReplayableEvents.indexOf(domEventName)) {
                for(; null !== blockedOn;){
                    var fiber = getInstanceFromNode(blockedOn);
                    if (null !== fiber) switch(fiber.tag){
                        case 3:
                            fiber = fiber.stateNode;
                            if (fiber.current.memoizedState.isDehydrated) {
                                var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                                if (0 !== lanes) {
                                    var root = fiber;
                                    root.pendingLanes |= 2;
                                    for(root.entangledLanes |= 2; lanes;){
                                        var lane = 1 << 31 - clz32(lanes);
                                        root.entanglements[1] |= lane;
                                        lanes &= ~lane;
                                    }
                                    ensureRootIsScheduled(fiber);
                                    (executionContext & (RenderContext | CommitContext)) === NoContext && (workInProgressRootRenderTargetTime = now$1() + RENDER_TIMEOUT_MS, flushSyncWorkAcrossRoots_impl(0, !1));
                                }
                            }
                            break;
                        case 31:
                        case 13:
                            root = enqueueConcurrentRenderForLane(fiber, 2), null !== root && scheduleUpdateOnFiber(root, fiber, 2), flushSyncWork$1(), markRetryLaneIfNotHydrated(fiber, 2);
                    }
                    fiber = findInstanceBlockingEvent(nativeEvent);
                    null === fiber && dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                    if (fiber === blockedOn) break;
                    blockedOn = fiber;
                }
                null !== blockedOn && nativeEvent.stopPropagation();
            } else dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
        }
    }
    function findInstanceBlockingEvent(nativeEvent) {
        nativeEvent = getEventTarget(nativeEvent);
        return findInstanceBlockingTarget(nativeEvent);
    }
    function findInstanceBlockingTarget(targetNode) {
        return_targetInst = null;
        targetNode = getClosestInstanceFromNode(targetNode);
        if (null !== targetNode) {
            var nearestMounted = getNearestMountedFiber(targetNode);
            if (null === nearestMounted) targetNode = null;
            else {
                var tag = nearestMounted.tag;
                if (13 === tag) {
                    targetNode = getSuspenseInstanceFromFiber(nearestMounted);
                    if (null !== targetNode) return targetNode;
                    targetNode = null;
                } else if (31 === tag) {
                    targetNode = getActivityInstanceFromFiber(nearestMounted);
                    if (null !== targetNode) return targetNode;
                    targetNode = null;
                } else if (3 === tag) {
                    if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                    targetNode = null;
                } else nearestMounted !== targetNode && (targetNode = null);
            }
        }
        return_targetInst = targetNode;
        return null;
    }
    function getEventPriority(domEventName) {
        switch(domEventName){
            case "beforetoggle":
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "toggle":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            case "beforeblur":
            case "afterblur":
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
                return DiscreteEventPriority;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "touchmove":
            case "wheel":
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
                return ContinuousEventPriority;
            case "message":
                switch(getCurrentPriorityLevel()){
                    case ImmediatePriority:
                        return DiscreteEventPriority;
                    case UserBlockingPriority:
                        return ContinuousEventPriority;
                    case NormalPriority$1:
                    case LowPriority:
                        return DefaultEventPriority;
                    case IdlePriority:
                        return IdleEventPriority;
                    default:
                        return DefaultEventPriority;
                }
            default:
                return DefaultEventPriority;
        }
    }
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case "focusin":
            case "focusout":
                queuedFocus = null;
                break;
            case "dragenter":
            case "dragleave":
                queuedDrag = null;
                break;
            case "mouseover":
            case "mouseout":
                queuedMouse = null;
                break;
            case "pointerover":
            case "pointerout":
                queuedPointers.delete(nativeEvent.pointerId);
                break;
            case "gotpointercapture":
            case "lostpointercapture":
                queuedPointerCaptures.delete(nativeEvent.pointerId);
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        }, null !== blockedOn && (blockedOn = getInstanceFromNode(blockedOn), null !== blockedOn && attemptContinuousHydration(blockedOn)), existingQueuedEvent;
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        blockedOn = existingQueuedEvent.targetContainers;
        null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        switch(domEventName){
            case "focusin":
                return queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
            case "dragenter":
                return queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
            case "mouseover":
                return queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
            case "pointerover":
                var pointerId = nativeEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
                return !0;
            case "gotpointercapture":
                return pointerId = nativeEvent.pointerId, queuedPointerCaptures.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
        }
        return !1;
    }
    function attemptExplicitHydrationTarget(queuedTarget) {
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (null !== targetInst) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (null !== nearestMounted) {
                if (targetInst = nearestMounted.tag, 13 === targetInst) {
                    if (targetInst = getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                        queuedTarget.blockedOn = targetInst;
                        runWithPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (31 === targetInst) {
                    if (targetInst = getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                        queuedTarget.blockedOn = targetInst;
                        runWithPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                    queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                    return;
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (null !== queuedEvent.blockedOn) return !1;
        for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
            var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.nativeEvent);
            if (null === nextBlockedOn) {
                nextBlockedOn = queuedEvent.nativeEvent;
                var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn), event = nativeEventClone;
                null !== currentReplayingEvent && console.error("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue.");
                currentReplayingEvent = event;
                nextBlockedOn.target.dispatchEvent(nativeEventClone);
                null === currentReplayingEvent && console.error("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue.");
                currentReplayingEvent = null;
            } else return targetContainers = getInstanceFromNode(nextBlockedOn), null !== targetContainers && attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
            targetContainers.shift();
        }
        return !0;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = !1;
        null !== queuedFocus && attemptReplayContinuousQueuedEvent(queuedFocus) && (queuedFocus = null);
        null !== queuedDrag && attemptReplayContinuousQueuedEvent(queuedDrag) && (queuedDrag = null);
        null !== queuedMouse && attemptReplayContinuousQueuedEvent(queuedMouse) && (queuedMouse = null);
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, hasScheduledReplayAttempt || (hasScheduledReplayAttempt = !0, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents)));
    }
    function scheduleReplayQueueIfNeeded(formReplayingQueue) {
        lastScheduledReplayQueue !== formReplayingQueue && (lastScheduledReplayQueue = formReplayingQueue, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, function() {
            lastScheduledReplayQueue === formReplayingQueue && (lastScheduledReplayQueue = null);
            for(var i = 0; i < formReplayingQueue.length; i += 3){
                var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
                if ("function" !== typeof submitterOrAction) {
                    if (null === findInstanceBlockingTarget(submitterOrAction || form)) continue;
                    else break;
                }
                var formInst = getInstanceFromNode(form);
                null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, form = {
                    pending: !0,
                    data: formData,
                    method: form.method,
                    action: submitterOrAction
                }, Object.freeze(form), startHostTransition(formInst, form, submitterOrAction, formData));
            }
        }));
    }
    function retryIfBlockedOn(unblocked) {
        function unblock(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        }
        null !== queuedFocus && scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        null !== queuedDrag && scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        null !== queuedMouse && scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var i = 0; i < queuedExplicitHydrationTargets.length; i++){
            var queuedTarget = queuedExplicitHydrationTargets[i];
            queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
        }
        for(; 0 < queuedExplicitHydrationTargets.length && (i = queuedExplicitHydrationTargets[0], null === i.blockedOn);)attemptExplicitHydrationTarget(i), null === i.blockedOn && queuedExplicitHydrationTargets.shift();
        i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
        if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
            var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[internalPropsKey] || null;
            if ("function" === typeof submitterOrAction) formProps || scheduleReplayQueueIfNeeded(i);
            else if (formProps) {
                var action = null;
                if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                    if (form = submitterOrAction, formProps = submitterOrAction[internalPropsKey] || null) action = formProps.formAction;
                    else {
                        if (null !== findInstanceBlockingTarget(form)) continue;
                    }
                } else action = formProps.action;
                "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
                scheduleReplayQueueIfNeeded(i);
            }
        }
    }
    function defaultOnDefaultTransitionIndicator() {
        function handleNavigate(event) {
            event.canIntercept && "react-transition" === event.info && event.intercept({
                handler: function() {
                    return new Promise(function(resolve) {
                        return pendingResolve = resolve;
                    });
                },
                focusReset: "manual",
                scroll: "manual"
            });
        }
        function handleNavigateComplete() {
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
            isCancelled || setTimeout(startFakeNavigation, 20);
        }
        function startFakeNavigation() {
            if (!isCancelled && !navigation.transition) {
                var currentEntry = navigation.currentEntry;
                currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                    state: currentEntry.getState(),
                    info: "react-transition",
                    history: "replace"
                });
            }
        }
        if ("object" === typeof navigation) {
            var isCancelled = !1, pendingResolve = null;
            navigation.addEventListener("navigate", handleNavigate);
            navigation.addEventListener("navigatesuccess", handleNavigateComplete);
            navigation.addEventListener("navigateerror", handleNavigateComplete);
            setTimeout(startFakeNavigation, 100);
            return function() {
                isCancelled = !0;
                navigation.removeEventListener("navigate", handleNavigate);
                navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
                navigation.removeEventListener("navigateerror", handleNavigateComplete);
                null !== pendingResolve && (pendingResolve(), pendingResolve = null);
            };
        }
    }
    function ReactDOMRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function ReactDOMHydrationRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function warnIfReactDOMContainerInDEV(container) {
        container[internalContainerInstanceKey] && (container._reactRootContainer ? console.error("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : console.error("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var Scheduler = (parcelRequire("hlTax")), React = (parcelRequire("2xPiy")), ReactDOM = (parcelRequire("cX5wj")), assign = Object.assign, REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy");
    Symbol.for("react.scope");
    var REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
    Symbol.for("react.legacy_hidden");
    Symbol.for("react.tracing_marker");
    var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
    Symbol.for("react.view_transition");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator, REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), isArrayImpl = Array.isArray, ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, NotPending = Object.freeze({
        pending: !1,
        data: null,
        method: null,
        action: null
    }), valueStack = [];
    var fiberStack = [];
    var index$jscomp$0 = -1, contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null), disabledDepth = 0, prevLog, prevInfo, prevWarn, prevError, prevGroup, prevGroupCollapsed, prevGroupEnd;
    disabledLog.__reactDisabledLog = !0;
    var prefix, suffix, reentry = !1;
    var componentFrameCache = new ("function" === typeof WeakMap ? WeakMap : Map)();
    var current = null, isRendering = !1, hasOwnProperty = Object.prototype.hasOwnProperty, scheduleCallback$3 = Scheduler.unstable_scheduleCallback, cancelCallback$1 = Scheduler.unstable_cancelCallback, shouldYield = Scheduler.unstable_shouldYield, requestPaint = Scheduler.unstable_requestPaint, now$1 = Scheduler.unstable_now, getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, ImmediatePriority = Scheduler.unstable_ImmediatePriority, UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler.unstable_NormalPriority, LowPriority = Scheduler.unstable_LowPriority, IdlePriority = Scheduler.unstable_IdlePriority, log$1 = Scheduler.log, unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue, rendererID = null, injectedHook = null, hasLoggedError = !1, isDevToolsPresent = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__, clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log = Math.log, LN2 = Math.LN2, nextTransitionUpdateLane = 256, nextTransitionDeferredLane = 262144, nextRetryLane = 4194304, DiscreteEventPriority = 2, ContinuousEventPriority = 8, DefaultEventPriority = 32, IdleEventPriority = 268435456, randomKey = Math.random().toString(36).slice(2), internalInstanceKey = "__reactFiber$" + randomKey, internalPropsKey = "__reactProps$" + randomKey, internalContainerInstanceKey = "__reactContainer$" + randomKey, internalEventHandlersKey = "__reactEvents$" + randomKey, internalEventHandlerListenersKey = "__reactListeners$" + randomKey, internalEventHandlesSetKey = "__reactHandles$" + randomKey, internalRootNodeResourcesKey = "__reactResources$" + randomKey, internalHoistableMarker = "__reactMarker$" + randomKey, allNativeEvents = new Set(), registrationNameDependencies = {}, possibleRegistrationNames = {}, hasReadOnlyValue = {
        button: !0,
        checkbox: !0,
        image: !0,
        hidden: !0,
        radio: !0,
        reset: !0,
        submit: !0
    }, VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), illegalAttributeNameCache = {}, validatedAttributeNameCache = {}, escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g, didWarnValueDefaultValue$1 = !1, didWarnCheckedDefaultChecked = !1, didWarnSelectedSetOnOption = !1, didWarnInvalidChild = !1, didWarnInvalidInnerHTML = !1;
    var didWarnValueDefaultValue = !1;
    var valuePropNames = [
        "value",
        "defaultValue"
    ], didWarnValDefaultVal = !1, needsEscaping = /["'&<>\n\t]|^\s|\s$/, specialTags = "address applet area article aside base basefont bgsound blockquote body br button caption center col colgroup dd details dir div dl dt embed fieldset figcaption figure footer form frame frameset h1 h2 h3 h4 h5 h6 head header hgroup hr html iframe img input isindex li link listing main marquee menu menuitem meta nav noembed noframes noscript object ol p param plaintext pre script section select source style summary table tbody td template textarea tfoot th thead title tr track ul wbr xmp".split(" "), inScopeTags = "applet caption html table td th marquee object template foreignObject desc title".split(" "), buttonScopeTags = inScopeTags.concat([
        "button"
    ]), impliedEndTags = "dd dt li option optgroup p rp rt".split(" "), emptyAncestorInfoDev = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null,
        containerTagInScope: null,
        implicitRootScope: !1
    }, didWarn = {}, shorthandToLonghand = {
        animation: "animationDelay animationDirection animationDuration animationFillMode animationIterationCount animationName animationPlayState animationTimingFunction".split(" "),
        background: "backgroundAttachment backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPositionX backgroundPositionY backgroundRepeat backgroundSize".split(" "),
        backgroundPosition: [
            "backgroundPositionX",
            "backgroundPositionY"
        ],
        border: "borderBottomColor borderBottomStyle borderBottomWidth borderImageOutset borderImageRepeat borderImageSlice borderImageSource borderImageWidth borderLeftColor borderLeftStyle borderLeftWidth borderRightColor borderRightStyle borderRightWidth borderTopColor borderTopStyle borderTopWidth".split(" "),
        borderBlockEnd: [
            "borderBlockEndColor",
            "borderBlockEndStyle",
            "borderBlockEndWidth"
        ],
        borderBlockStart: [
            "borderBlockStartColor",
            "borderBlockStartStyle",
            "borderBlockStartWidth"
        ],
        borderBottom: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth"
        ],
        borderColor: [
            "borderBottomColor",
            "borderLeftColor",
            "borderRightColor",
            "borderTopColor"
        ],
        borderImage: [
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth"
        ],
        borderInlineEnd: [
            "borderInlineEndColor",
            "borderInlineEndStyle",
            "borderInlineEndWidth"
        ],
        borderInlineStart: [
            "borderInlineStartColor",
            "borderInlineStartStyle",
            "borderInlineStartWidth"
        ],
        borderLeft: [
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth"
        ],
        borderRadius: [
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
            "borderTopLeftRadius",
            "borderTopRightRadius"
        ],
        borderRight: [
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth"
        ],
        borderStyle: [
            "borderBottomStyle",
            "borderLeftStyle",
            "borderRightStyle",
            "borderTopStyle"
        ],
        borderTop: [
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderWidth: [
            "borderBottomWidth",
            "borderLeftWidth",
            "borderRightWidth",
            "borderTopWidth"
        ],
        columnRule: [
            "columnRuleColor",
            "columnRuleStyle",
            "columnRuleWidth"
        ],
        columns: [
            "columnCount",
            "columnWidth"
        ],
        flex: [
            "flexBasis",
            "flexGrow",
            "flexShrink"
        ],
        flexFlow: [
            "flexDirection",
            "flexWrap"
        ],
        font: "fontFamily fontFeatureSettings fontKerning fontLanguageOverride fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition fontWeight lineHeight".split(" "),
        fontVariant: "fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition".split(" "),
        gap: [
            "columnGap",
            "rowGap"
        ],
        grid: "gridAutoColumns gridAutoFlow gridAutoRows gridTemplateAreas gridTemplateColumns gridTemplateRows".split(" "),
        gridArea: [
            "gridColumnEnd",
            "gridColumnStart",
            "gridRowEnd",
            "gridRowStart"
        ],
        gridColumn: [
            "gridColumnEnd",
            "gridColumnStart"
        ],
        gridColumnGap: [
            "columnGap"
        ],
        gridGap: [
            "columnGap",
            "rowGap"
        ],
        gridRow: [
            "gridRowEnd",
            "gridRowStart"
        ],
        gridRowGap: [
            "rowGap"
        ],
        gridTemplate: [
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        listStyle: [
            "listStyleImage",
            "listStylePosition",
            "listStyleType"
        ],
        margin: [
            "marginBottom",
            "marginLeft",
            "marginRight",
            "marginTop"
        ],
        marker: [
            "markerEnd",
            "markerMid",
            "markerStart"
        ],
        mask: "maskClip maskComposite maskImage maskMode maskOrigin maskPositionX maskPositionY maskRepeat maskSize".split(" "),
        maskPosition: [
            "maskPositionX",
            "maskPositionY"
        ],
        outline: [
            "outlineColor",
            "outlineStyle",
            "outlineWidth"
        ],
        overflow: [
            "overflowX",
            "overflowY"
        ],
        padding: [
            "paddingBottom",
            "paddingLeft",
            "paddingRight",
            "paddingTop"
        ],
        placeContent: [
            "alignContent",
            "justifyContent"
        ],
        placeItems: [
            "alignItems",
            "justifyItems"
        ],
        placeSelf: [
            "alignSelf",
            "justifySelf"
        ],
        textDecoration: [
            "textDecorationColor",
            "textDecorationLine",
            "textDecorationStyle"
        ],
        textEmphasis: [
            "textEmphasisColor",
            "textEmphasisStyle"
        ],
        transition: [
            "transitionDelay",
            "transitionDuration",
            "transitionProperty",
            "transitionTimingFunction"
        ],
        wordWrap: [
            "overflowWrap"
        ]
    }, uppercasePattern = /([A-Z])/g, msPattern$1 = /^ms-/, badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/, msPattern = /^-ms-/, hyphenPattern = /-(.)/g, badStyleValueWithSemicolonPattern = /;\s*$/, warnedStyleNames = {}, warnedStyleValues = {}, warnedForNaNValue = !1, warnedForInfinityValue = !1, unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" ")), MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML", SVG_NAMESPACE = "http://www.w3.org/2000/svg", aliases = new Map([
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ],
        [
            "crossOrigin",
            "crossorigin"
        ],
        [
            "accentHeight",
            "accent-height"
        ],
        [
            "alignmentBaseline",
            "alignment-baseline"
        ],
        [
            "arabicForm",
            "arabic-form"
        ],
        [
            "baselineShift",
            "baseline-shift"
        ],
        [
            "capHeight",
            "cap-height"
        ],
        [
            "clipPath",
            "clip-path"
        ],
        [
            "clipRule",
            "clip-rule"
        ],
        [
            "colorInterpolation",
            "color-interpolation"
        ],
        [
            "colorInterpolationFilters",
            "color-interpolation-filters"
        ],
        [
            "colorProfile",
            "color-profile"
        ],
        [
            "colorRendering",
            "color-rendering"
        ],
        [
            "dominantBaseline",
            "dominant-baseline"
        ],
        [
            "enableBackground",
            "enable-background"
        ],
        [
            "fillOpacity",
            "fill-opacity"
        ],
        [
            "fillRule",
            "fill-rule"
        ],
        [
            "floodColor",
            "flood-color"
        ],
        [
            "floodOpacity",
            "flood-opacity"
        ],
        [
            "fontFamily",
            "font-family"
        ],
        [
            "fontSize",
            "font-size"
        ],
        [
            "fontSizeAdjust",
            "font-size-adjust"
        ],
        [
            "fontStretch",
            "font-stretch"
        ],
        [
            "fontStyle",
            "font-style"
        ],
        [
            "fontVariant",
            "font-variant"
        ],
        [
            "fontWeight",
            "font-weight"
        ],
        [
            "glyphName",
            "glyph-name"
        ],
        [
            "glyphOrientationHorizontal",
            "glyph-orientation-horizontal"
        ],
        [
            "glyphOrientationVertical",
            "glyph-orientation-vertical"
        ],
        [
            "horizAdvX",
            "horiz-adv-x"
        ],
        [
            "horizOriginX",
            "horiz-origin-x"
        ],
        [
            "imageRendering",
            "image-rendering"
        ],
        [
            "letterSpacing",
            "letter-spacing"
        ],
        [
            "lightingColor",
            "lighting-color"
        ],
        [
            "markerEnd",
            "marker-end"
        ],
        [
            "markerMid",
            "marker-mid"
        ],
        [
            "markerStart",
            "marker-start"
        ],
        [
            "overlinePosition",
            "overline-position"
        ],
        [
            "overlineThickness",
            "overline-thickness"
        ],
        [
            "paintOrder",
            "paint-order"
        ],
        [
            "panose-1",
            "panose-1"
        ],
        [
            "pointerEvents",
            "pointer-events"
        ],
        [
            "renderingIntent",
            "rendering-intent"
        ],
        [
            "shapeRendering",
            "shape-rendering"
        ],
        [
            "stopColor",
            "stop-color"
        ],
        [
            "stopOpacity",
            "stop-opacity"
        ],
        [
            "strikethroughPosition",
            "strikethrough-position"
        ],
        [
            "strikethroughThickness",
            "strikethrough-thickness"
        ],
        [
            "strokeDasharray",
            "stroke-dasharray"
        ],
        [
            "strokeDashoffset",
            "stroke-dashoffset"
        ],
        [
            "strokeLinecap",
            "stroke-linecap"
        ],
        [
            "strokeLinejoin",
            "stroke-linejoin"
        ],
        [
            "strokeMiterlimit",
            "stroke-miterlimit"
        ],
        [
            "strokeOpacity",
            "stroke-opacity"
        ],
        [
            "strokeWidth",
            "stroke-width"
        ],
        [
            "textAnchor",
            "text-anchor"
        ],
        [
            "textDecoration",
            "text-decoration"
        ],
        [
            "textRendering",
            "text-rendering"
        ],
        [
            "transformOrigin",
            "transform-origin"
        ],
        [
            "underlinePosition",
            "underline-position"
        ],
        [
            "underlineThickness",
            "underline-thickness"
        ],
        [
            "unicodeBidi",
            "unicode-bidi"
        ],
        [
            "unicodeRange",
            "unicode-range"
        ],
        [
            "unitsPerEm",
            "units-per-em"
        ],
        [
            "vAlphabetic",
            "v-alphabetic"
        ],
        [
            "vHanging",
            "v-hanging"
        ],
        [
            "vIdeographic",
            "v-ideographic"
        ],
        [
            "vMathematical",
            "v-mathematical"
        ],
        [
            "vectorEffect",
            "vector-effect"
        ],
        [
            "vertAdvY",
            "vert-adv-y"
        ],
        [
            "vertOriginX",
            "vert-origin-x"
        ],
        [
            "vertOriginY",
            "vert-origin-y"
        ],
        [
            "wordSpacing",
            "word-spacing"
        ],
        [
            "writingMode",
            "writing-mode"
        ],
        [
            "xmlnsXlink",
            "xmlns:xlink"
        ],
        [
            "xHeight",
            "x-height"
        ]
    ]), possibleStandardNames = {
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        fetchpriority: "fetchPriority",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        inert: "inert",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        popover: "popover",
        popovertarget: "popoverTarget",
        popovertargetaction: "popoverTargetAction",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        transformorigin: "transformOrigin",
        "transform-origin": "transformOrigin",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
    }, ariaProperties = {
        "aria-current": 0,
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        "aria-hidden": 0,
        "aria-invalid": 0,
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0,
        "aria-braillelabel": 0,
        "aria-brailleroledescription": 0,
        "aria-colindextext": 0,
        "aria-rowindextext": 0
    }, warnedProperties$1 = {}, rARIA$1 = RegExp("^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), rARIACamel$1 = RegExp("^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), didWarnValueNull = !1, warnedProperties = {}, EVENT_NAME_REGEX = /^on./, INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/, rARIA = RegExp("^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), rARIACamel = RegExp("^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i, currentReplayingEvent = null, restoreTarget = null, restoreQueue = null, isInsideEventHandler = !1, canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), passiveBrowserEventsSupported = !1;
    if (canUseDOM) try {
        var options$jscomp$0 = {};
        Object.defineProperty(options$jscomp$0, "passive", {
            get: function() {
                passiveBrowserEventsSupported = !0;
            }
        });
        window.addEventListener("test", options$jscomp$0, options$jscomp$0);
        window.removeEventListener("test", options$jscomp$0, options$jscomp$0);
    } catch (e) {
        passiveBrowserEventsSupported = !1;
    }
    var root = null, startText = null, fallbackText = null, EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    }, SyntheticEvent = createSyntheticEvent(EventInterface), UIEventInterface = assign({}, EventInterface, {
        view: 0,
        detail: 0
    }), SyntheticUIEvent = createSyntheticEvent(UIEventInterface), lastMovementX, lastMovementY, lastMouseEvent, MouseEventInterface = assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function(event) {
            return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
        },
        movementX: function(event) {
            if ("movementX" in event) return event.movementX;
            event !== lastMouseEvent && (lastMouseEvent && "mousemove" === event.type ? (lastMovementX = event.screenX - lastMouseEvent.screenX, lastMovementY = event.screenY - lastMouseEvent.screenY) : lastMovementY = lastMovementX = 0, lastMouseEvent = event);
            return lastMovementX;
        },
        movementY: function(event) {
            return "movementY" in event ? event.movementY : lastMovementY;
        }
    }), SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface), DragEventInterface = assign({}, MouseEventInterface, {
        dataTransfer: 0
    }), SyntheticDragEvent = createSyntheticEvent(DragEventInterface), FocusEventInterface = assign({}, UIEventInterface, {
        relatedTarget: 0
    }), SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface), AnimationEventInterface = assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    }), SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface), ClipboardEventInterface = assign({}, EventInterface, {
        clipboardData: function(event) {
            return "clipboardData" in event ? event.clipboardData : window.clipboardData;
        }
    }), SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface), CompositionEventInterface = assign({}, EventInterface, {
        data: 0
    }), SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface), SyntheticInputEvent = SyntheticCompositionEvent, normalizeKey = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
    }, translateToKey = {
        8: "Backspace",
        9: "Tab",
        12: "Clear",
        13: "Enter",
        16: "Shift",
        17: "Control",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Escape",
        32: " ",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "ArrowLeft",
        38: "ArrowUp",
        39: "ArrowRight",
        40: "ArrowDown",
        45: "Insert",
        46: "Delete",
        112: "F1",
        113: "F2",
        114: "F3",
        115: "F4",
        116: "F5",
        117: "F6",
        118: "F7",
        119: "F8",
        120: "F9",
        121: "F10",
        122: "F11",
        123: "F12",
        144: "NumLock",
        145: "ScrollLock",
        224: "Meta"
    }, modifierKeyToProp = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
    }, KeyboardEventInterface = assign({}, UIEventInterface, {
        key: function(nativeEvent) {
            if (nativeEvent.key) {
                var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
                if ("Unidentified" !== key) return key;
            }
            return "keypress" === nativeEvent.type ? (nativeEvent = getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
        },
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        charCode: function(event) {
            return "keypress" === event.type ? getEventCharCode(event) : 0;
        },
        keyCode: function(event) {
            return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
        },
        which: function(event) {
            return "keypress" === event.type ? getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
        }
    }), SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface), PointerEventInterface = assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    }), SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface), TouchEventInterface = assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    }), SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface), TransitionEventInterface = assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    }), SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface), WheelEventInterface = assign({}, MouseEventInterface, {
        deltaX: function(event) {
            return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        deltaMode: 0
    }), SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface), ToggleEventInterface = assign({}, EventInterface, {
        newState: 0,
        oldState: 0
    }), SyntheticToggleEvent = createSyntheticEvent(ToggleEventInterface), END_KEYCODES = [
        9,
        13,
        27,
        32
    ], START_KEYCODE = 229, canUseCompositionEvent = canUseDOM && "CompositionEvent" in window, documentMode = null;
    canUseDOM && "documentMode" in document && (documentMode = document.documentMode);
    var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode, useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && 8 < documentMode && 11 >= documentMode), SPACEBAR_CODE = 32, SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE), hasSpaceKeypress = !1, isComposing = !1, supportedInputTypes = {
        color: !0,
        date: !0,
        datetime: !0,
        "datetime-local": !0,
        email: !0,
        month: !0,
        number: !0,
        password: !0,
        range: !0,
        search: !0,
        tel: !0,
        text: !0,
        time: !0,
        url: !0,
        week: !0
    }, activeElement$1 = null, activeElementInst$1 = null, isInputEventSupported = !1;
    canUseDOM && (isInputEventSupported = isEventSupported("input") && (!document.documentMode || 9 < document.documentMode));
    var objectIs = "function" === typeof Object.is ? Object.is : is, skipSelectionChangeEvent = canUseDOM && "documentMode" in document && 11 >= document.documentMode, activeElement = null, activeElementInst = null, lastSelection = null, mouseDown = !1, vendorPrefixes = {
        animationend: makePrefixMap("Animation", "AnimationEnd"),
        animationiteration: makePrefixMap("Animation", "AnimationIteration"),
        animationstart: makePrefixMap("Animation", "AnimationStart"),
        transitionrun: makePrefixMap("Transition", "TransitionRun"),
        transitionstart: makePrefixMap("Transition", "TransitionStart"),
        transitioncancel: makePrefixMap("Transition", "TransitionCancel"),
        transitionend: makePrefixMap("Transition", "TransitionEnd")
    }, prefixedEventNames = {}, style = {};
    canUseDOM && (style = document.createElement("div").style, "AnimationEvent" in window || (delete vendorPrefixes.animationend.animation, delete vendorPrefixes.animationiteration.animation, delete vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete vendorPrefixes.transitionend.transition);
    var ANIMATION_END = getVendorPrefixedEventName("animationend"), ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration"), ANIMATION_START = getVendorPrefixedEventName("animationstart"), TRANSITION_RUN = getVendorPrefixedEventName("transitionrun"), TRANSITION_START = getVendorPrefixedEventName("transitionstart"), TRANSITION_CANCEL = getVendorPrefixedEventName("transitioncancel"), TRANSITION_END = getVendorPrefixedEventName("transitionend"), topLevelEventsToReactNames = new Map(), simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
    simpleEventPluginEvents.push("scrollEnd");
    var lastResetTime = 0;
    if ("object" === typeof performance && "function" === typeof performance.now) {
        var localPerformance = performance;
        var getCurrentTime = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        getCurrentTime = function() {
            return localDate.now();
        };
    }
    var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
        if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
            var event = new window.ErrorEvent("error", {
                bubbles: !0,
                cancelable: !0,
                message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
                error: error
            });
            if (!window.dispatchEvent(event)) return;
        }
        console.error(error);
    }, OMITTED_PROP_ERROR = "This object has been omitted by React in the console log to avoid sending too much data from the server. Try logging smaller or more specific objects.", EMPTY_ARRAY = 0, COMPLEX_ARRAY = 1, PRIMITIVE_ARRAY = 2, ENTRIES_ARRAY = 3, REMOVED = "\u2013\u00a0", ADDED = "+\u00a0", UNCHANGED = "\u2007\u00a0", supportsUserTiming = "undefined" !== typeof console && "function" === typeof console.timeStamp && "undefined" !== typeof performance && "function" === typeof performance.measure, COMPONENTS_TRACK = "Components \u269b", LANES_TRACK_GROUP = "Scheduler \u269b", currentTrack = "Blocking", alreadyWarnedForDeepEquality = !1, reusableComponentDevToolDetails = {
        color: "primary",
        properties: null,
        tooltipText: "",
        track: COMPONENTS_TRACK
    }, reusableComponentOptions = {
        start: -0,
        end: -0,
        detail: {
            devtools: reusableComponentDevToolDetails
        }
    }, resuableChangedPropsEntry = [
        "Changed Props",
        ""
    ], DEEP_EQUALITY_WARNING = "This component received deeply equal props. It might benefit from useMemo or the React Compiler in its owner.", reusableDeeplyEqualPropsEntry = [
        "Changed Props",
        DEEP_EQUALITY_WARNING
    ], OffscreenVisible = 1, OffscreenPassiveEffectsConnected = 2, concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0, emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var resolveFamily = null, failedBoundaries = null, NoMode = 0, ConcurrentMode = 1, ProfileMode = 2, StrictLegacyMode = 8, StrictEffectsMode = 16, SuspenseyImagesMode = 32;
    var hasBadMapPolyfill = !1;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    } catch (e$3) {
        hasBadMapPolyfill = !0;
    }
    var CapturedStacks = new WeakMap(), forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "", hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = !1, didSuspendOrErrorDEV = !1, hydrationDiffRootDEV = null, hydrationErrors = null, rootOrSingletonContext = !1, HydrationMismatchException = Error("Hydration Mismatch Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."), valueCursor = createCursor(null);
    var rendererCursorDEV = createCursor(null);
    var rendererSigil = {};
    var currentlyRenderingFiber$1 = null, lastContextDependency = null, isDisallowedContextReadInDEV = !1, AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
        var listeners = [], signal = this.signal = {
            aborted: !1,
            addEventListener: function(type, listener) {
                listeners.push(listener);
            }
        };
        this.abort = function() {
            signal.aborted = !0;
            listeners.forEach(function(listener) {
                return listener();
            });
        };
    }, scheduleCallback$2 = Scheduler.unstable_scheduleCallback, NormalPriority = Scheduler.unstable_NormalPriority, CacheContext = {
        $$typeof: REACT_CONTEXT_TYPE,
        Consumer: null,
        Provider: null,
        _currentValue: null,
        _currentValue2: null,
        _threadCount: 0,
        _currentRenderer: null,
        _currentRenderer2: null
    }, now = Scheduler.unstable_now, createTask = console.createTask ? console.createTask : function() {
        return null;
    }, SPAWNED_UPDATE = 1, PINGED_UPDATE = 2, renderStartTime = -0, commitStartTime = -0, commitEndTime = -0, commitErrors = null, profilerStartTime = -1.1, profilerEffectDuration = -0, componentEffectDuration = -0, componentEffectStartTime = -1.1, componentEffectEndTime = -1.1, componentEffectErrors = null, componentEffectSpawnedUpdate = !1, blockingClampTime = -0, blockingUpdateTime = -1.1, blockingUpdateTask = null, blockingUpdateType = 0, blockingUpdateMethodName = null, blockingUpdateComponentName = null, blockingEventTime = -1.1, blockingEventType = null, blockingEventRepeatTime = -1.1, blockingSuspendedTime = -1.1, transitionClampTime = -0, transitionStartTime = -1.1, transitionUpdateTime = -1.1, transitionUpdateType = 0, transitionUpdateTask = null, transitionUpdateMethodName = null, transitionUpdateComponentName = null, transitionEventTime = -1.1, transitionEventType = null, transitionEventRepeatTime = -1.1, transitionSuspendedTime = -1.1, retryClampTime = -0, idleClampTime = -0, animatingLanes = 0, animatingTask = null, yieldReason = 0, yieldStartTime = -1.1, currentUpdateIsNested = !1, nestedUpdateScheduled = !1, currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null, prevOnStartTransitionFinish = ReactSharedInternals.S;
    ReactSharedInternals.S = function(transition, returnValue) {
        globalMostRecentTransitionTime = now$1();
        if ("object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then) {
            if (0 > transitionStartTime && 0 > transitionUpdateTime) {
                transitionStartTime = now();
                var newEventTime = resolveEventTimeStamp(), newEventType = resolveEventType();
                if (newEventTime !== transitionEventRepeatTime || newEventType !== transitionEventType) transitionEventRepeatTime = -1.1;
                transitionEventTime = newEventTime;
                transitionEventType = newEventType;
            }
            entangleAsyncAction(transition, returnValue);
        }
        null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
    };
    var resumedCache = createCursor(null), ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function() {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function() {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    }, pendingComponentWillMountWarnings = [], pendingUNSAFE_ComponentWillMountWarnings = [], pendingComponentWillReceivePropsWarnings = [], pendingUNSAFE_ComponentWillReceivePropsWarnings = [], pendingComponentWillUpdateWarnings = [], pendingUNSAFE_ComponentWillUpdateWarnings = [], didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        didWarnAboutUnsafeLifecycles.has(fiber.type) || ("function" === typeof instance.componentWillMount && !0 !== instance.componentWillMount.__suppressDeprecationWarning && pendingComponentWillMountWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillMount && pendingUNSAFE_ComponentWillMountWarnings.push(fiber), "function" === typeof instance.componentWillReceiveProps && !0 !== instance.componentWillReceiveProps.__suppressDeprecationWarning && pendingComponentWillReceivePropsWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillReceiveProps && pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber), "function" === typeof instance.componentWillUpdate && !0 !== instance.componentWillUpdate.__suppressDeprecationWarning && pendingComponentWillUpdateWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillUpdate && pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber));
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        var componentWillMountUniqueNames = new Set();
        0 < pendingComponentWillMountWarnings.length && (pendingComponentWillMountWarnings.forEach(function(fiber) {
            componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingComponentWillMountWarnings = []);
        var UNSAFE_componentWillMountUniqueNames = new Set();
        0 < pendingUNSAFE_ComponentWillMountWarnings.length && (pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
            UNSAFE_componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingUNSAFE_ComponentWillMountWarnings = []);
        var componentWillReceivePropsUniqueNames = new Set();
        0 < pendingComponentWillReceivePropsWarnings.length && (pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
            componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingComponentWillReceivePropsWarnings = []);
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        0 < pendingUNSAFE_ComponentWillReceivePropsWarnings.length && (pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
            UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingUNSAFE_ComponentWillReceivePropsWarnings = []);
        var componentWillUpdateUniqueNames = new Set();
        0 < pendingComponentWillUpdateWarnings.length && (pendingComponentWillUpdateWarnings.forEach(function(fiber) {
            componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingComponentWillUpdateWarnings = []);
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        0 < pendingUNSAFE_ComponentWillUpdateWarnings.length && (pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
            UNSAFE_componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingUNSAFE_ComponentWillUpdateWarnings = []);
        if (0 < UNSAFE_componentWillMountUniqueNames.size) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            console.error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        0 < UNSAFE_componentWillReceivePropsUniqueNames.size && (sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames), console.error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state\n\nPlease update the following components: %s", sortedNames));
        0 < UNSAFE_componentWillUpdateUniqueNames.size && (sortedNames = setToSortedString(UNSAFE_componentWillUpdateUniqueNames), console.error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", sortedNames));
        0 < componentWillMountUniqueNames.size && (sortedNames = setToSortedString(componentWillMountUniqueNames), console.warn("componentWillMount has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", sortedNames));
        0 < componentWillReceivePropsUniqueNames.size && (sortedNames = setToSortedString(componentWillReceivePropsUniqueNames), console.warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", sortedNames));
        0 < componentWillUpdateUniqueNames.size && (sortedNames = setToSortedString(componentWillUpdateUniqueNames), console.warn("componentWillUpdate has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", sortedNames));
    };
    var pendingLegacyContextWarning = new Map(), didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = null;
        for(var node = fiber; null !== node;)node.mode & StrictLegacyMode && (strictRoot = node), node = node.return;
        null === strictRoot ? console.error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.") : !didWarnAboutLegacyContext.has(fiber.type) && (node = pendingLegacyContextWarning.get(strictRoot), null != fiber.type.contextTypes || null != fiber.type.childContextTypes || null !== instance && "function" === typeof instance.getChildContext) && (void 0 === node && (node = [], pendingLegacyContextWarning.set(strictRoot, node)), node.push(fiber));
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray) {
            if (0 !== fiberArray.length) {
                var firstFiber = fiberArray[0], uniqueNames = new Set();
                fiberArray.forEach(function(fiber) {
                    uniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                    didWarnAboutLegacyContext.add(fiber.type);
                });
                var sortedNames = setToSortedString(uniqueNames);
                runWithFiberInDEV(firstFiber, function() {
                    console.error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://react.dev/link/legacy-context", sortedNames);
                });
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    var callComponent = {
        react_stack_bottom_frame: function(Component, props, secondArg) {
            var wasRendering = isRendering;
            isRendering = !0;
            try {
                return Component(props, secondArg);
            } finally{
                isRendering = wasRendering;
            }
        }
    }, callComponentInDEV = callComponent.react_stack_bottom_frame.bind(callComponent), callRender = {
        react_stack_bottom_frame: function(instance) {
            var wasRendering = isRendering;
            isRendering = !0;
            try {
                return instance.render();
            } finally{
                isRendering = wasRendering;
            }
        }
    }, callRenderInDEV = callRender.react_stack_bottom_frame.bind(callRender), callComponentDidMount = {
        react_stack_bottom_frame: function(finishedWork, instance) {
            try {
                instance.componentDidMount();
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
        }
    }, callComponentDidMountInDEV = callComponentDidMount.react_stack_bottom_frame.bind(callComponentDidMount), callComponentDidUpdate = {
        react_stack_bottom_frame: function(finishedWork, instance, prevProps, prevState, snapshot) {
            try {
                instance.componentDidUpdate(prevProps, prevState, snapshot);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
        }
    }, callComponentDidUpdateInDEV = callComponentDidUpdate.react_stack_bottom_frame.bind(callComponentDidUpdate), callComponentDidCatch = {
        react_stack_bottom_frame: function(instance, errorInfo) {
            var stack = errorInfo.stack;
            instance.componentDidCatch(errorInfo.value, {
                componentStack: null !== stack ? stack : ""
            });
        }
    }, callComponentDidCatchInDEV = callComponentDidCatch.react_stack_bottom_frame.bind(callComponentDidCatch), callComponentWillUnmount = {
        react_stack_bottom_frame: function(current, nearestMountedAncestor, instance) {
            try {
                instance.componentWillUnmount();
            } catch (error) {
                captureCommitPhaseError(current, nearestMountedAncestor, error);
            }
        }
    }, callComponentWillUnmountInDEV = callComponentWillUnmount.react_stack_bottom_frame.bind(callComponentWillUnmount), callCreate = {
        react_stack_bottom_frame: function(effect) {
            var create = effect.create;
            effect = effect.inst;
            create = create();
            return effect.destroy = create;
        }
    }, callCreateInDEV = callCreate.react_stack_bottom_frame.bind(callCreate), callDestroy = {
        react_stack_bottom_frame: function(current, nearestMountedAncestor, destroy) {
            try {
                destroy();
            } catch (error) {
                captureCommitPhaseError(current, nearestMountedAncestor, error);
            }
        }
    }, callDestroyInDEV = callDestroy.react_stack_bottom_frame.bind(callDestroy), callLazyInit = {
        react_stack_bottom_frame: function(lazy) {
            var init = lazy._init;
            return init(lazy._payload);
        }
    }, callLazyInitInDEV = callLazyInit.react_stack_bottom_frame.bind(callLazyInit), SuspenseException = Error("Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`."), SuspenseyCommitException = Error("Suspense Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."), SuspenseActionException = Error("Suspense Exception: This is not a real error! It's an implementation detail of `useActionState` to interrupt the current render. You must either rethrow it immediately, or move the `useActionState` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary."), noopSuspenseyCommitThenable = {
        then: function() {
            console.error('Internal React error: A listener was unexpectedly attached to a "noop" thenable. This is a bug in React. Please file an issue.');
        }
    }, suspendedThenable = null, needsToResetSuspendedThenableDEV = !1, thenableState$1 = null, thenableIndexCounter$1 = 0, currentDebugInfo = null, didWarnAboutMaps;
    var didWarnAboutGenerators = didWarnAboutMaps = !1;
    var ownerHasKeyUseWarning = {};
    var ownerHasFunctionTypeWarning = {};
    var ownerHasSymbolTypeWarning = {};
    warnForMissingKey = function(returnFiber, workInProgress, child) {
        if (null !== child && "object" === typeof child && child._store && (!child._store.validated && null == child.key || 2 === child._store.validated)) {
            if ("object" !== typeof child._store) throw Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
            child._store.validated = 1;
            var componentName = getComponentNameFromFiber(returnFiber), componentKey = componentName || "null";
            if (!ownerHasKeyUseWarning[componentKey]) {
                ownerHasKeyUseWarning[componentKey] = !0;
                child = child._owner;
                returnFiber = returnFiber._debugOwner;
                var currentComponentErrorInfo = "";
                returnFiber && "number" === typeof returnFiber.tag && (componentKey = getComponentNameFromFiber(returnFiber)) && (currentComponentErrorInfo = "\n\nCheck the render method of `" + componentKey + "`.");
                currentComponentErrorInfo || componentName && (currentComponentErrorInfo = "\n\nCheck the top-level render call using <" + componentName + ">.");
                var childOwnerAppendix = "";
                null != child && returnFiber !== child && (componentName = null, "number" === typeof child.tag ? componentName = getComponentNameFromFiber(child) : "string" === typeof child.name && (componentName = child.name), componentName && (childOwnerAppendix = " It was passed a child from " + componentName + "."));
                runWithFiberInDEV(workInProgress, function() {
                    console.error('Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.', currentComponentErrorInfo, childOwnerAppendix);
                });
            }
        }
    };
    var reconcileChildFibers = createChildReconciler(!0), mountChildFibers = createChildReconciler(!1), UpdateState = 0, ReplaceState = 1, ForceUpdate = 2, CaptureUpdate = 3, hasForceUpdate = !1;
    var didWarnUpdateInsideUpdate = !1;
    var currentlyProcessingQueue = null;
    var didReadFromEntangledAsyncAction = !1, currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0), suspenseHandlerStackCursor = createCursor(null), shellBoundary = null, SubtreeSuspenseContextMask = 1, ForceSuspenseFallback = 2, suspenseStackCursor = createCursor(0), NoFlags = 0, HasEffect = 1, Insertion = 2, Layout = 4, Passive = 8, didWarnUncachedGetSnapshot;
    var didWarnAboutMismatchedHooksForComponent = new Set();
    var didWarnAboutUseWrappedInTryCatch = new Set();
    var didWarnAboutAsyncClientComponent = new Set();
    var didWarnAboutUseFormState = new Set();
    var renderLanes = 0, currentlyRenderingFiber = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = !1, didScheduleRenderPhaseUpdateDuringThisPass = !1, shouldDoubleInvokeUserFnsInHooksDEV = !1, localIdCounter = 0, thenableIndexCounter = 0, thenableState = null, globalClientIdCounter = 0, RE_RENDER_LIMIT = 25, currentHookNameInDev = null, hookTypesDev = null, hookTypesUpdateIndexDev = -1, ignorePreviousDependencies = !1, ContextOnlyDispatcher = {
        readContext: readContext,
        use: use,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        useHostTransitionStatus: throwInvalidHookError,
        useFormState: throwInvalidHookError,
        useActionState: throwInvalidHookError,
        useOptimistic: throwInvalidHookError,
        useMemoCache: throwInvalidHookError,
        useCacheRefresh: throwInvalidHookError
    };
    ContextOnlyDispatcher.useEffectEvent = throwInvalidHookError;
    var HooksDispatcherOnMountInDEV = null, HooksDispatcherOnMountWithHookTypesInDEV = null, HooksDispatcherOnUpdateInDEV = null, HooksDispatcherOnRerenderInDEV = null, InvalidNestedHooksDispatcherOnMountInDEV = null, InvalidNestedHooksDispatcherOnUpdateInDEV = null, InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    HooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        use: use,
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            mountEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            mountHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            mountHookTypesDev();
            return mountDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            mountHookTypesDev();
            return mountTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            mountHookTypesDev();
            return mountId();
        },
        useFormState: function(action, initialState) {
            currentHookNameInDev = "useFormState";
            mountHookTypesDev();
            warnOnUseFormStateInDev();
            return mountActionState(action, initialState);
        },
        useActionState: function(action, initialState) {
            currentHookNameInDev = "useActionState";
            mountHookTypesDev();
            return mountActionState(action, initialState);
        },
        useOptimistic: function(passthrough) {
            currentHookNameInDev = "useOptimistic";
            mountHookTypesDev();
            return mountOptimistic(passthrough);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useMemoCache: useMemoCache,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            mountHookTypesDev();
            return mountRefresh();
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            mountHookTypesDev();
            return mountEvent(callback);
        }
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        use: use,
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            mountEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return mountDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return mountTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return mountId();
        },
        useActionState: function(action, initialState) {
            currentHookNameInDev = "useActionState";
            updateHookTypesDev();
            return mountActionState(action, initialState);
        },
        useFormState: function(action, initialState) {
            currentHookNameInDev = "useFormState";
            updateHookTypesDev();
            warnOnUseFormStateInDev();
            return mountActionState(action, initialState);
        },
        useOptimistic: function(passthrough) {
            currentHookNameInDev = "useOptimistic";
            updateHookTypesDev();
            return mountOptimistic(passthrough);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useMemoCache: useMemoCache,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return mountRefresh();
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            updateHookTypesDev();
            return mountEvent(callback);
        }
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        use: use,
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            updateEffectImpl(2048, Passive, create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateEffectImpl(4, Layout, create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function() {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useState: function() {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(basicStateReducer);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return updateDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return updateTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useFormState: function(action) {
            currentHookNameInDev = "useFormState";
            updateHookTypesDev();
            warnOnUseFormStateInDev();
            return updateActionState(action);
        },
        useActionState: function(action) {
            currentHookNameInDev = "useActionState";
            updateHookTypesDev();
            return updateActionState(action);
        },
        useOptimistic: function(passthrough, reducer) {
            currentHookNameInDev = "useOptimistic";
            updateHookTypesDev();
            return updateOptimistic(passthrough, reducer);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useMemoCache: useMemoCache,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            updateHookTypesDev();
            return updateEvent(callback);
        }
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        use: use,
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            updateEffectImpl(2048, Passive, create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateEffectImpl(4, Layout, create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function() {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useState: function() {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(basicStateReducer);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return rerenderDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return rerenderTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useFormState: function(action) {
            currentHookNameInDev = "useFormState";
            updateHookTypesDev();
            warnOnUseFormStateInDev();
            return rerenderActionState(action);
        },
        useActionState: function(action) {
            currentHookNameInDev = "useActionState";
            updateHookTypesDev();
            return rerenderActionState(action);
        },
        useOptimistic: function(passthrough, reducer) {
            currentHookNameInDev = "useOptimistic";
            updateHookTypesDev();
            return rerenderOptimistic(passthrough, reducer);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useMemoCache: useMemoCache,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            updateHookTypesDev();
            return updateEvent(callback);
        }
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        use: function(usable) {
            warnInvalidHookAccess();
            return use(usable);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            mountEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountId();
        },
        useFormState: function(action, initialState) {
            currentHookNameInDev = "useFormState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountActionState(action, initialState);
        },
        useActionState: function(action, initialState) {
            currentHookNameInDev = "useActionState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountActionState(action, initialState);
        },
        useOptimistic: function(passthrough) {
            currentHookNameInDev = "useOptimistic";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountOptimistic(passthrough);
        },
        useMemoCache: function(size) {
            warnInvalidHookAccess();
            return useMemoCache(size);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            mountHookTypesDev();
            return mountRefresh();
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEvent(callback);
        }
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        use: function(usable) {
            warnInvalidHookAccess();
            return use(usable);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            updateEffectImpl(2048, Passive, create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffectImpl(4, Layout, create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function() {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useState: function() {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(basicStateReducer);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useFormState: function(action) {
            currentHookNameInDev = "useFormState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateActionState(action);
        },
        useActionState: function(action) {
            currentHookNameInDev = "useActionState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateActionState(action);
        },
        useOptimistic: function(passthrough, reducer) {
            currentHookNameInDev = "useOptimistic";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateOptimistic(passthrough, reducer);
        },
        useMemoCache: function(size) {
            warnInvalidHookAccess();
            return useMemoCache(size);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEvent(callback);
        }
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        use: function(usable) {
            warnInvalidHookAccess();
            return use(usable);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            updateEffectImpl(2048, Passive, create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffectImpl(4, Layout, create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function() {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useState: function() {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(basicStateReducer);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useFormState: function(action) {
            currentHookNameInDev = "useFormState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderActionState(action);
        },
        useActionState: function(action) {
            currentHookNameInDev = "useActionState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderActionState(action);
        },
        useOptimistic: function(passthrough, reducer) {
            currentHookNameInDev = "useOptimistic";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderOptimistic(passthrough, reducer);
        },
        useMemoCache: function(size) {
            warnInvalidHookAccess();
            return useMemoCache(size);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEvent(callback);
        }
    };
    var fakeInternalInstance = {};
    var didWarnAboutStateAssignmentForComponent = new Set();
    var didWarnAboutUninitializedState = new Set();
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    var didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    var didWarnAboutDirectlyAssigningPropsToState = new Set();
    var didWarnAboutUndefinedDerivedState = new Set();
    var didWarnAboutContextTypes$1 = new Set();
    var didWarnAboutChildContextTypes = new Set();
    var didWarnAboutInvalidateContextType = new Set();
    var didWarnOnInvalidCallback = new Set();
    Object.freeze(fakeInternalInstance);
    var classComponentUpdater = {
        enqueueSetState: function(inst, payload, callback) {
            inst = inst._reactInternals;
            var lane = requestUpdateLane(inst), update = createUpdate(lane);
            update.payload = payload;
            void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update.callback = callback);
            payload = enqueueUpdate(inst, update, lane);
            null !== payload && (startUpdateTimerByLane(lane, "this.setState()", inst), scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
        },
        enqueueReplaceState: function(inst, payload, callback) {
            inst = inst._reactInternals;
            var lane = requestUpdateLane(inst), update = createUpdate(lane);
            update.tag = ReplaceState;
            update.payload = payload;
            void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update.callback = callback);
            payload = enqueueUpdate(inst, update, lane);
            null !== payload && (startUpdateTimerByLane(lane, "this.replaceState()", inst), scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
        },
        enqueueForceUpdate: function(inst, callback) {
            inst = inst._reactInternals;
            var lane = requestUpdateLane(inst), update = createUpdate(lane);
            update.tag = ForceUpdate;
            void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update.callback = callback);
            callback = enqueueUpdate(inst, update, lane);
            null !== callback && (startUpdateTimerByLane(lane, "this.forceUpdate()", inst), scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
        }
    }, componentName = null, errorBoundaryName = null, SelectiveHydrationException = Error("This is not a real error. It's an implementation detail of React's selective hydration feature. If this leaks into userspace, it's a bug in React. Please file an issue."), didReceiveUpdate = !1;
    var didWarnAboutBadClass = {};
    var didWarnAboutContextTypeOnFunctionComponent = {};
    var didWarnAboutContextTypes = {};
    var didWarnAboutGetDerivedStateOnFunctionComponent = {};
    var didWarnAboutReassigningProps = !1;
    var didWarnAboutRevealOrder = {};
    var didWarnAboutTailOptions = {};
    var SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: 0,
        hydrationErrors: null
    }, hasWarnedAboutUsingNoValuePropOnContextProvider = !1, didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    var offscreenSubtreeIsHidden = !1, offscreenSubtreeWasHidden = !1, needsFormReset = !1, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null, inProgressLanes = null, inProgressRoot = null, hostParent = null, hostParentIsContainer = !1, currentHoistableRoot = null, inHydratedSubtree = !1, suspenseyCommitFlag = 8192, DefaultAsyncDispatcher = {
        getCacheForType: function(resourceType) {
            var cache = readContext(CacheContext), cacheForType = cache.data.get(resourceType);
            void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
            return cacheForType;
        },
        cacheSignal: function() {
            return readContext(CacheContext).controller.signal;
        },
        getOwner: function() {
            return current;
        }
    };
    if ("function" === typeof Symbol && Symbol.for) {
        var symbolFor = Symbol.for;
        symbolFor("selector.component");
        symbolFor("selector.has_pseudo_class");
        symbolFor("selector.role");
        symbolFor("selector.test_id");
        symbolFor("selector.text");
    }
    var commitHooks = [], PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, NoContext = 0, RenderContext = 2, CommitContext = 4, RootInProgress = 0, RootFatalErrored = 1, RootErrored = 2, RootSuspended = 3, RootSuspendedWithDelay = 4, RootSuspendedAtTheShell = 6, RootCompleted = 5, executionContext = NoContext, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, NotSuspended = 0, SuspendedOnError = 1, SuspendedOnData = 2, SuspendedOnImmediate = 3, SuspendedOnInstance = 4, SuspendedOnInstanceAndReadyToContinue = 5, SuspendedOnDeprecatedThrowPromise = 6, SuspendedAndReadyToContinue = 7, SuspendedOnHydration = 8, SuspendedOnAction = 9, workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = !1, workInProgressRootIsPrerendering = !1, workInProgressRootDidAttachPingListener = !1, entangledRenderLanes = 0, workInProgressRootExitStatus = RootInProgress, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = !1, globalMostRecentFallbackTime = 0, globalMostRecentTransitionTime = 0, FALLBACK_THROTTLE_MS = 300, workInProgressRootRenderTargetTime = Infinity, RENDER_TIMEOUT_MS = 500, workInProgressTransitions = null, workInProgressUpdateTask = null, legacyErrorBoundariesThatAlreadyFailed = null, IMMEDIATE_COMMIT = 0, ABORTED_VIEW_TRANSITION_COMMIT = 1, DELAYED_PASSIVE_COMMIT = 2, ANIMATION_STARTED_COMMIT = 3, NO_PENDING_EFFECTS = 0, PENDING_MUTATION_PHASE = 1, PENDING_LAYOUT_PHASE = 2, PENDING_AFTER_MUTATION_PHASE = 3, PENDING_SPAWNED_WORK = 4, PENDING_PASSIVE_PHASE = 5, pendingEffectsStatus = 0, pendingEffectsRoot = null, pendingFinishedWork = null, pendingEffectsLanes = 0, pendingEffectsRemainingLanes = 0, pendingEffectsRenderEndTime = -0, pendingPassiveTransitions = null, pendingRecoverableErrors = null, pendingSuspendedCommitReason = null, pendingDelayedCommitReason = IMMEDIATE_COMMIT, pendingSuspendedViewTransitionReason = null, NESTED_UPDATE_LIMIT = 50, nestedUpdateCount = 0, rootWithNestedUpdates = null, isFlushingPassiveEffects = !1, didScheduleUpdateDuringPassiveEffects = !1, NESTED_PASSIVE_UPDATE_LIMIT = 50, nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null, isRunningInsertionEffect = !1, didWarnStateUpdateForNotYetMountedComponent = null, didWarnAboutUpdateInRender = !1;
    var didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    var fakeActCallbackNode$1 = {}, firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = !1, didScheduleMicrotask_act = !1, mightHavePendingSyncWork = !1, isFlushingWork = !1, currentEventTransitionLane = 0, fakeActCallbackNode = {};
    (function() {
        for(var i = 0; i < simpleEventPluginEvents.length; i++){
            var eventName = simpleEventPluginEvents[i], domEventName = eventName.toLowerCase();
            eventName = eventName[0].toUpperCase() + eventName.slice(1);
            registerSimpleEvent(domEventName, "on" + eventName);
        }
        registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
        registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
        registerSimpleEvent(ANIMATION_START, "onAnimationStart");
        registerSimpleEvent("dblclick", "onDoubleClick");
        registerSimpleEvent("focusin", "onFocus");
        registerSimpleEvent("focusout", "onBlur");
        registerSimpleEvent(TRANSITION_RUN, "onTransitionRun");
        registerSimpleEvent(TRANSITION_START, "onTransitionStart");
        registerSimpleEvent(TRANSITION_CANCEL, "onTransitionCancel");
        registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
    })();
    registerDirectEvent("onMouseEnter", [
        "mouseout",
        "mouseover"
    ]);
    registerDirectEvent("onMouseLeave", [
        "mouseout",
        "mouseover"
    ]);
    registerDirectEvent("onPointerEnter", [
        "pointerout",
        "pointerover"
    ]);
    registerDirectEvent("onPointerLeave", [
        "pointerout",
        "pointerover"
    ]);
    registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
    registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
    registerTwoPhaseEvent("onBeforeInput", [
        "compositionend",
        "keypress",
        "textInput",
        "paste"
    ]);
    registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
    registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
    registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
    var mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(mediaEventTypes)), listeningMarker = "_reactListening" + Math.random().toString(36).slice(2), didWarnControlledToUncontrolled = !1, didWarnUncontrolledToControlled = !1, didWarnFormActionType = !1, didWarnFormActionName = !1, didWarnFormActionTarget = !1, didWarnFormActionMethod = !1, didWarnPopoverTargetObject = !1;
    var didWarnForNewBooleanPropsWithEmptyValue = {};
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g, NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g, xlinkNamespace = "http://www.w3.org/1999/xlink", xmlNamespace = "http://www.w3.org/XML/1998/namespace", EXPECTED_FORM_ACTION_URL = "javascript:throw new Error('React form unexpectedly submitted.')", SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning", ACTIVITY_START_DATA = "&", ACTIVITY_END_DATA = "/&", SUSPENSE_START_DATA = "$", SUSPENSE_END_DATA = "/$", SUSPENSE_PENDING_START_DATA = "$?", SUSPENSE_QUEUED_START_DATA = "$~", SUSPENSE_FALLBACK_START_DATA = "$!", PREAMBLE_CONTRIBUTION_HTML = "html", PREAMBLE_CONTRIBUTION_BODY = "body", PREAMBLE_CONTRIBUTION_HEAD = "head", FORM_STATE_IS_MATCHING = "F!", FORM_STATE_IS_NOT_MATCHING = "F", DOCUMENT_READY_STATE_LOADING = "loading", STYLE = "style", HostContextNamespaceNone = 0, HostContextNamespaceSvg = 1, HostContextNamespaceMath = 2, eventsEnabled = null, selectionInformation = null, warnedUnknownTags = {
        dialog: !0,
        webview: !0
    }, currentPopstateTransitionEvent = null, schedulerEvent = void 0, scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, noTimeout = -1, localPromise = "function" === typeof Promise ? Promise : void 0, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof localPromise ? function(callback) {
        return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
    } : scheduleTimeout, previousHydratableOnEnteringScopedSingleton = null, NotLoaded = 0, Loaded = 1, Errored = 2, Settled = 3, Inserted = 4, preloadPropsMap = new Map(), preconnectsSet = new Set(), previousDispatcher = ReactDOMSharedInternals.d;
    ReactDOMSharedInternals.d = {
        f: function() {
            var previousWasRendering = previousDispatcher.f(), wasRendering = flushSyncWork$1();
            return previousWasRendering || wasRendering;
        },
        r: function(form) {
            var formInst = getInstanceFromNode(form);
            null !== formInst && 5 === formInst.tag && "form" === formInst.type ? requestFormReset$1(formInst) : previousDispatcher.r(form);
        },
        D: function(href) {
            previousDispatcher.D(href);
            preconnectAs("dns-prefetch", href, null);
        },
        C: function(href, crossOrigin) {
            previousDispatcher.C(href, crossOrigin);
            preconnectAs("preconnect", href, crossOrigin);
        },
        L: function(href, as, options) {
            previousDispatcher.L(href, as, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && href && as) {
                var preloadSelector = 'link[rel="preload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
                "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
                var key = preloadSelector;
                switch(as){
                    case "style":
                        key = getStyleKey(href);
                        break;
                    case "script":
                        key = getScriptKey(href);
                }
                preloadPropsMap.has(key) || (href = assign({
                    rel: "preload",
                    href: "image" === as && options && options.imageSrcSet ? void 0 : href,
                    as: as
                }, options), preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector(getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector(getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), setInitialProperties(as, "link", href), markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
            }
        },
        m: function(href, options) {
            previousDispatcher.m(href, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && href) {
                var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
                switch(as){
                    case "audioworklet":
                    case "paintworklet":
                    case "serviceworker":
                    case "sharedworker":
                    case "worker":
                    case "script":
                        key = getScriptKey(href);
                }
                if (!preloadPropsMap.has(key) && (href = assign({
                    rel: "modulepreload",
                    href: href
                }, options), preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
                    switch(as){
                        case "audioworklet":
                        case "paintworklet":
                        case "serviceworker":
                        case "sharedworker":
                        case "worker":
                        case "script":
                            if (ownerDocument.querySelector(getScriptSelectorFromKey(key))) return;
                    }
                    as = ownerDocument.createElement("link");
                    setInitialProperties(as, "link", href);
                    markNodeAsHoistable(as);
                    ownerDocument.head.appendChild(as);
                }
            }
        },
        X: function(src, options) {
            previousDispatcher.X(src, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && src) {
                var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
                resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
                    src: src,
                    async: !0
                }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
                    type: "script",
                    instance: resource,
                    count: 1,
                    state: null
                }, scripts.set(key, resource));
            }
        },
        S: function(href, precedence, options) {
            previousDispatcher.S(href, precedence, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && href) {
                var styles = getResourcesFromRoot(ownerDocument).hoistableStyles, key = getStyleKey(href);
                precedence = precedence || "default";
                var resource = styles.get(key);
                if (!resource) {
                    var state = {
                        loading: NotLoaded,
                        preload: null
                    };
                    if (resource = ownerDocument.querySelector(getStylesheetSelectorFromKey(key))) state.loading = Loaded | Inserted;
                    else {
                        href = assign({
                            rel: "stylesheet",
                            href: href,
                            "data-precedence": precedence
                        }, options);
                        (options = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(href, options);
                        var link = resource = ownerDocument.createElement("link");
                        markNodeAsHoistable(link);
                        setInitialProperties(link, "link", href);
                        link._p = new Promise(function(resolve, reject) {
                            link.onload = resolve;
                            link.onerror = reject;
                        });
                        link.addEventListener("load", function() {
                            state.loading |= Loaded;
                        });
                        link.addEventListener("error", function() {
                            state.loading |= Errored;
                        });
                        state.loading |= Inserted;
                        insertStylesheet(resource, precedence, ownerDocument);
                    }
                    resource = {
                        type: "stylesheet",
                        instance: resource,
                        count: 1,
                        state: state
                    };
                    styles.set(key, resource);
                }
            }
        },
        M: function(src, options) {
            previousDispatcher.M(src, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && src) {
                var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
                resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
                    src: src,
                    async: !0,
                    type: "module"
                }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
                    type: "script",
                    instance: resource,
                    count: 1,
                    state: null
                }, scripts.set(key, resource));
            }
        }
    };
    var globalDocument = "undefined" === typeof document ? null : document, tagCaches = null, SUSPENSEY_STYLESHEET_TIMEOUT = 6e4, SUSPENSEY_IMAGE_TIMEOUT = 800, SUSPENSEY_IMAGE_TIME_ESTIMATE = 500, estimatedBytesWithinLimit = 0, LAST_PRECEDENCE = null, precedencesByRoot = null, NotPendingTransition = NotPending, HostTransitionContext = {
        $$typeof: REACT_CONTEXT_TYPE,
        Provider: null,
        Consumer: null,
        _currentValue: NotPendingTransition,
        _currentValue2: NotPendingTransition,
        _threadCount: 0
    }, badgeFormat = "%c%s%c", badgeStyle = "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", resetStyle = "", pad = " ", bind = Function.prototype.bind;
    var didWarnAboutNestedUpdates = !1;
    var overrideHookState = null, overrideHookStateDeletePath = null, overrideHookStateRenamePath = null, overrideProps = null, overridePropsDeletePath = null, overridePropsRenamePath = null, scheduleUpdate = null, scheduleRetry = null, setErrorHandler = null, setSuspenseHandler = null;
    overrideHookState = function(fiber, id, path, value) {
        id = findHook(fiber, id);
        null !== id && (path = copyWithSetImpl(id.memoizedState, path, 0, value), id.memoizedState = path, id.baseState = path, fiber.memoizedProps = assign({}, fiber.memoizedProps), path = enqueueConcurrentRenderForLane(fiber, 2), null !== path && scheduleUpdateOnFiber(path, fiber, 2));
    };
    overrideHookStateDeletePath = function(fiber, id, path) {
        id = findHook(fiber, id);
        null !== id && (path = copyWithDeleteImpl(id.memoizedState, path, 0), id.memoizedState = path, id.baseState = path, fiber.memoizedProps = assign({}, fiber.memoizedProps), path = enqueueConcurrentRenderForLane(fiber, 2), null !== path && scheduleUpdateOnFiber(path, fiber, 2));
    };
    overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
        id = findHook(fiber, id);
        null !== id && (oldPath = copyWithRename(id.memoizedState, oldPath, newPath), id.memoizedState = oldPath, id.baseState = oldPath, fiber.memoizedProps = assign({}, fiber.memoizedProps), oldPath = enqueueConcurrentRenderForLane(fiber, 2), null !== oldPath && scheduleUpdateOnFiber(oldPath, fiber, 2));
    };
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSetImpl(fiber.memoizedProps, path, 0, value);
        fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
        path = enqueueConcurrentRenderForLane(fiber, 2);
        null !== path && scheduleUpdateOnFiber(path, fiber, 2);
    };
    overridePropsDeletePath = function(fiber, path) {
        fiber.pendingProps = copyWithDeleteImpl(fiber.memoizedProps, path, 0);
        fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
        path = enqueueConcurrentRenderForLane(fiber, 2);
        null !== path && scheduleUpdateOnFiber(path, fiber, 2);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
        oldPath = enqueueConcurrentRenderForLane(fiber, 2);
        null !== oldPath && scheduleUpdateOnFiber(oldPath, fiber, 2);
    };
    scheduleUpdate = function(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, 2);
        null !== root && scheduleUpdateOnFiber(root, fiber, 2);
    };
    scheduleRetry = function(fiber) {
        var lane = claimNextRetryLane(), root = enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && scheduleUpdateOnFiber(root, fiber, lane);
    };
    setErrorHandler = function(newShouldErrorImpl) {
        shouldErrorImpl = newShouldErrorImpl;
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    var _enabled = !0, return_targetInst = null, hasScheduledReplayAttempt = !1, queuedFocus = null, queuedDrag = null, queuedMouse = null, queuedPointers = new Map(), queuedPointerCaptures = new Map(), queuedExplicitHydrationTargets = [], discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" "), lastScheduledReplayQueue = null;
    ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (null === root) throw Error("Cannot update an unmounted root.");
        var args = arguments;
        "function" === typeof args[1] ? console.error("does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : isValidContainer(args[1]) ? console.error("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : "undefined" !== typeof args[1] && console.error("You passed a second argument to root.render(...) but it only accepts one argument.");
        args = children;
        var current = root.current, lane = requestUpdateLane(current);
        updateContainerImpl(current, lane, args, root, null, null);
    };
    ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
        var args = arguments;
        "function" === typeof args[0] && console.error("does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        args = this._internalRoot;
        if (null !== args) {
            this._internalRoot = null;
            var container = args.containerInfo;
            (executionContext & (RenderContext | CommitContext)) !== NoContext && console.error("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.");
            updateContainerImpl(args.current, 2, null, args, null, null);
            flushSyncWork$1();
            container[internalContainerInstanceKey] = null;
        }
    };
    ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
        if (target) {
            var updatePriority = resolveUpdatePriority();
            target = {
                blockedOn: null,
                target: target,
                priority: updatePriority
            };
            for(var i = 0; i < queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < queuedExplicitHydrationTargets[i].priority; i++);
            queuedExplicitHydrationTargets.splice(i, 0, target);
            0 === i && attemptExplicitHydrationTarget(target);
        }
    };
    (function() {
        var isomorphicReactPackageVersion = React.version;
        if ("19.2.8" !== isomorphicReactPackageVersion) throw Error('Incompatible React versions: The "react" and "react-dom" packages must have the exact same version. Instead got:\n  - react:      ' + (isomorphicReactPackageVersion + "\n  - react-dom:  19.2.8\nLearn more: https://react.dev/warnings/version-mismatch"));
    })();
    "function" === typeof Map && null != Map.prototype && "function" === typeof Map.prototype.forEach && "function" === typeof Set && null != Set.prototype && "function" === typeof Set.prototype.clear && "function" === typeof Set.prototype.forEach || console.error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://react.dev/link/react-polyfills");
    ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
        var fiber = componentOrElement._reactInternals;
        if (void 0 === fiber) {
            if ("function" === typeof componentOrElement.render) throw Error("Unable to find node on an unmounted component.");
            componentOrElement = Object.keys(componentOrElement).join(",");
            throw Error("Argument appears to not be a ReactComponent. Keys: " + componentOrElement);
        }
        componentOrElement = findCurrentFiberUsingSlowPath(fiber);
        componentOrElement = null !== componentOrElement ? findCurrentHostFiberImpl(componentOrElement) : null;
        componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
        return componentOrElement;
    };
    if (!function() {
        var internals = {
            bundleType: 1,
            version: "19.2.8",
            rendererPackageName: "react-dom",
            currentDispatcherRef: ReactSharedInternals,
            reconcilerVersion: "19.2.8"
        };
        internals.overrideHookState = overrideHookState;
        internals.overrideHookStateDeletePath = overrideHookStateDeletePath;
        internals.overrideHookStateRenamePath = overrideHookStateRenamePath;
        internals.overrideProps = overrideProps;
        internals.overridePropsDeletePath = overridePropsDeletePath;
        internals.overridePropsRenamePath = overridePropsRenamePath;
        internals.scheduleUpdate = scheduleUpdate;
        internals.scheduleRetry = scheduleRetry;
        internals.setErrorHandler = setErrorHandler;
        internals.setSuspenseHandler = setSuspenseHandler;
        internals.scheduleRefresh = scheduleRefresh;
        internals.scheduleRoot = scheduleRoot;
        internals.setRefreshHandler = setRefreshHandler;
        internals.getCurrentFiber = getCurrentFiberForDevTools;
        return injectInternals(internals);
    }() && canUseDOM && window.top === window.self && (-1 < navigator.userAgent.indexOf("Chrome") && -1 === navigator.userAgent.indexOf("Edge") || -1 < navigator.userAgent.indexOf("Firefox"))) {
        var protocol = window.location.protocol;
        /^(https?|file):$/.test(protocol) && console.info("%cDownload the React DevTools for a better development experience: https://react.dev/link/react-devtools" + ("file:" === protocol ? "\nYou might need to use a local HTTP server (instead of file://): https://react.dev/link/react-devtools-faq" : ""), "font-weight:bold");
    }
    $30043039f0950692$export$882461b6382ed46c = function(container, options) {
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError;
        null !== options && void 0 !== options && (options.hydrate ? console.warn("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : "object" === typeof options && null !== options && options.$$typeof === REACT_ELEMENT_TYPE && console.error("You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);"), !0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
        options = createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, defaultOnDefaultTransitionIndicator);
        container[internalContainerInstanceKey] = options.current;
        listenToAllSupportedEvents(container);
        return new ReactDOMRoot(options);
    };
    $30043039f0950692$export$757ceba2d55c277e = function(container, initialChildren, options) {
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        void 0 === initialChildren && console.error("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
        var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, formState = null;
        null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
        initialChildren = createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, defaultOnDefaultTransitionIndicator);
        initialChildren.context = getContextForSubtree(null);
        options = initialChildren.current;
        isStrictMode = requestUpdateLane(options);
        isStrictMode = getBumpedLaneForHydrationByLane(isStrictMode);
        identifierPrefix = createUpdate(isStrictMode);
        identifierPrefix.callback = null;
        enqueueUpdate(options, identifierPrefix, isStrictMode);
        startUpdateTimerByLane(isStrictMode, "hydrateRoot()", null);
        options = isStrictMode;
        initialChildren.current.lanes = options;
        markRootUpdated$1(initialChildren, options);
        ensureRootIsScheduled(initialChildren);
        container[internalContainerInstanceKey] = initialChildren.current;
        listenToAllSupportedEvents(container);
        return new ReactDOMHydrationRoot(initialChildren);
    };
    $30043039f0950692$export$83d89fbfd8236492 = "19.2.8";
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});
parcelRegister("hlTax", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kMXaK"));

});
parcelRegister("kMXaK", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $f22630baaa71b0ff$export$c4744153514ff05d; }, function (v) { return $f22630baaa71b0ff$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $f22630baaa71b0ff$export$3e506c1ccc9cc1a7; }, function (v) { return $f22630baaa71b0ff$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $f22630baaa71b0ff$export$e26fe2ed2fa76875; }, function (v) { return $f22630baaa71b0ff$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $f22630baaa71b0ff$export$502329bbf4b505b1; }, function (v) { return $f22630baaa71b0ff$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $f22630baaa71b0ff$export$6e3807111c4874c4; }, function (v) { return $f22630baaa71b0ff$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $f22630baaa71b0ff$export$c27134553091fb3a; }, function (v) { return $f22630baaa71b0ff$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $f22630baaa71b0ff$export$33ee1acdc04fd2a2; }, function (v) { return $f22630baaa71b0ff$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $f22630baaa71b0ff$export$b00a404bbd5edef2; }, function (v) { return $f22630baaa71b0ff$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $f22630baaa71b0ff$export$d66a1c1c77bd778b; }, function (v) { return $f22630baaa71b0ff$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $f22630baaa71b0ff$export$d3dfb8e4810cb555; }, function (v) { return $f22630baaa71b0ff$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $f22630baaa71b0ff$export$72fdf0e06517287b; }, function (v) { return $f22630baaa71b0ff$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $f22630baaa71b0ff$export$816d2913ae6b83b1; }, function (v) { return $f22630baaa71b0ff$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $f22630baaa71b0ff$export$61bcfe829111a1d0; }, function (v) { return $f22630baaa71b0ff$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $f22630baaa71b0ff$export$7ee8c9beb337bc3f; }, function (v) { return $f22630baaa71b0ff$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $f22630baaa71b0ff$export$b5836b71941fa3ed; }, function (v) { return $f22630baaa71b0ff$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $f22630baaa71b0ff$export$cf845f2c119da08a; }, function (v) { return $f22630baaa71b0ff$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f22630baaa71b0ff$export$c4744153514ff05d;
var $f22630baaa71b0ff$export$3e506c1ccc9cc1a7;
var $f22630baaa71b0ff$export$e26fe2ed2fa76875;
var $f22630baaa71b0ff$export$502329bbf4b505b1;
var $f22630baaa71b0ff$export$6e3807111c4874c4;
var $f22630baaa71b0ff$export$c27134553091fb3a;
var $f22630baaa71b0ff$export$33ee1acdc04fd2a2;
var $f22630baaa71b0ff$export$b00a404bbd5edef2;
var $f22630baaa71b0ff$export$d66a1c1c77bd778b;
var $f22630baaa71b0ff$export$d3dfb8e4810cb555;
var $f22630baaa71b0ff$export$72fdf0e06517287b;
var $f22630baaa71b0ff$export$816d2913ae6b83b1;
var $f22630baaa71b0ff$export$61bcfe829111a1d0;
var $f22630baaa71b0ff$export$7ee8c9beb337bc3f;
var $f22630baaa71b0ff$export$b5836b71941fa3ed;
var $f22630baaa71b0ff$export$cf845f2c119da08a;
"use strict";
(function() {
    function performWorkUntilDeadline() {
        needsPaint = !1;
        if (isMessageLoopRunning) {
            var currentTime = $f22630baaa71b0ff$export$c4744153514ff05d();
            startTime = currentTime;
            var hasMoreWork = !0;
            try {
                a: {
                    isHostCallbackScheduled = !1;
                    isHostTimeoutScheduled && (isHostTimeoutScheduled = !1, localClearTimeout(taskTimeoutID), taskTimeoutID = -1);
                    isPerformingWork = !0;
                    var previousPriorityLevel = currentPriorityLevel;
                    try {
                        b: {
                            advanceTimers(currentTime);
                            for(currentTask = peek(taskQueue); null !== currentTask && !(currentTask.expirationTime > currentTime && shouldYieldToHost());){
                                var callback = currentTask.callback;
                                if ("function" === typeof callback) {
                                    currentTask.callback = null;
                                    currentPriorityLevel = currentTask.priorityLevel;
                                    var continuationCallback = callback(currentTask.expirationTime <= currentTime);
                                    currentTime = $f22630baaa71b0ff$export$c4744153514ff05d();
                                    if ("function" === typeof continuationCallback) {
                                        currentTask.callback = continuationCallback;
                                        advanceTimers(currentTime);
                                        hasMoreWork = !0;
                                        break b;
                                    }
                                    currentTask === peek(taskQueue) && pop(taskQueue);
                                    advanceTimers(currentTime);
                                } else pop(taskQueue);
                                currentTask = peek(taskQueue);
                            }
                            if (null !== currentTask) hasMoreWork = !0;
                            else {
                                var firstTimer = peek(timerQueue);
                                null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
                                hasMoreWork = !1;
                            }
                        }
                        break a;
                    } finally{
                        currentTask = null, currentPriorityLevel = previousPriorityLevel, isPerformingWork = !1;
                    }
                    hasMoreWork = void 0;
                }
            } finally{
                hasMoreWork ? schedulePerformWorkUntilDeadline() : isMessageLoopRunning = !1;
            }
        }
    }
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        a: for(; 0 < index;){
            var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
            if (0 < compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
            else break a;
        }
    }
    function peek(heap) {
        return 0 === heap.length ? null : heap[0];
    }
    function pop(heap) {
        if (0 === heap.length) return null;
        var first = heap[0], last = heap.pop();
        if (last !== first) {
            heap[0] = last;
            a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
                var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
                if (0 > compare(left, last)) rightIndex < length && 0 > compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
                else if (rightIndex < length && 0 > compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
                else break a;
            }
        }
        return first;
    }
    function compare(a, b) {
        var diff = a.sortIndex - b.sortIndex;
        return 0 !== diff ? diff : a.id - b.id;
    }
    function advanceTimers(currentTime) {
        for(var timer = peek(timerQueue); null !== timer;){
            if (null === timer.callback) pop(timerQueue);
            else if (timer.startTime <= currentTime) pop(timerQueue), timer.sortIndex = timer.expirationTime, push(taskQueue, timer);
            else break;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = !1;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (null !== peek(taskQueue)) isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline());
            else {
                var firstTimer = peek(timerQueue);
                null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function shouldYieldToHost() {
        return needsPaint ? !0 : $f22630baaa71b0ff$export$c4744153514ff05d() - startTime < frameInterval ? !1 : !0;
    }
    function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function() {
            callback($f22630baaa71b0ff$export$c4744153514ff05d());
        }, ms);
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    $f22630baaa71b0ff$export$c4744153514ff05d = void 0;
    if ("object" === typeof performance && "function" === typeof performance.now) {
        var localPerformance = performance;
        $f22630baaa71b0ff$export$c4744153514ff05d = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date, initialTime = localDate.now();
        $f22630baaa71b0ff$export$c4744153514ff05d = function() {
            return localDate.now() - initialTime;
        };
    }
    var taskQueue = [], timerQueue = [], taskIdCounter = 1, currentTask = null, currentPriorityLevel = 3, isPerformingWork = !1, isHostCallbackScheduled = !1, isHostTimeoutScheduled = !1, needsPaint = !1, localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null, isMessageLoopRunning = !1, taskTimeoutID = -1, frameInterval = 5, startTime = -1;
    if ("function" === typeof localSetImmediate) var schedulePerformWorkUntilDeadline = function() {
        localSetImmediate(performWorkUntilDeadline);
    };
    else if ("undefined" !== typeof MessageChannel) {
        var channel = new MessageChannel(), port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        schedulePerformWorkUntilDeadline = function() {
            port.postMessage(null);
        };
    } else schedulePerformWorkUntilDeadline = function() {
        localSetTimeout(performWorkUntilDeadline, 0);
    };
    $f22630baaa71b0ff$export$3e506c1ccc9cc1a7 = 5;
    $f22630baaa71b0ff$export$e26fe2ed2fa76875 = 1;
    $f22630baaa71b0ff$export$502329bbf4b505b1 = 4;
    $f22630baaa71b0ff$export$6e3807111c4874c4 = 3;
    $f22630baaa71b0ff$export$c27134553091fb3a = null;
    $f22630baaa71b0ff$export$33ee1acdc04fd2a2 = 2;
    $f22630baaa71b0ff$export$b00a404bbd5edef2 = function(task) {
        task.callback = null;
    };
    $f22630baaa71b0ff$export$d66a1c1c77bd778b = function(fps) {
        0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
    };
    $f22630baaa71b0ff$export$d3dfb8e4810cb555 = function() {
        return currentPriorityLevel;
    };
    $f22630baaa71b0ff$export$72fdf0e06517287b = function(eventHandler) {
        switch(currentPriorityLevel){
            case 1:
            case 2:
            case 3:
                var priorityLevel = 3;
                break;
            default:
                priorityLevel = currentPriorityLevel;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    };
    $f22630baaa71b0ff$export$816d2913ae6b83b1 = function() {
        needsPaint = !0;
    };
    $f22630baaa71b0ff$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            default:
                priorityLevel = 3;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    };
    $f22630baaa71b0ff$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
        var currentTime = $f22630baaa71b0ff$export$c4744153514ff05d();
        "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
        switch(priorityLevel){
            case 1:
                var timeout = -1;
                break;
            case 2:
                timeout = 250;
                break;
            case 5:
                timeout = 1073741823;
                break;
            case 4:
                timeout = 1e4;
                break;
            default:
                timeout = 5e3;
        }
        timeout = options + timeout;
        priorityLevel = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: options,
            expirationTime: timeout,
            sortIndex: -1
        };
        options > currentTime ? (priorityLevel.sortIndex = options, push(timerQueue, priorityLevel), null === peek(taskQueue) && priorityLevel === peek(timerQueue) && (isHostTimeoutScheduled ? (localClearTimeout(taskTimeoutID), taskTimeoutID = -1) : isHostTimeoutScheduled = !0, requestHostTimeout(handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, push(taskQueue, priorityLevel), isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline())));
        return priorityLevel;
    };
    $f22630baaa71b0ff$export$b5836b71941fa3ed = shouldYieldToHost;
    $f22630baaa71b0ff$export$cf845f2c119da08a = function(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    };
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});


parcelRegister("cX5wj", function(module, exports) {
'use strict';
function $96df46e65dca936b$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
}

module.exports = (parcelRequire("b4fWx"));

});
parcelRegister("b4fWx", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $80ec6f6f272bb611$export$69ce8ef3fe5cead0; }, function (v) { return $80ec6f6f272bb611$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $80ec6f6f272bb611$export$d39a5bbd09211389; }, function (v) { return $80ec6f6f272bb611$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $80ec6f6f272bb611$export$cd75ccfd720a3cd4; }, function (v) { return $80ec6f6f272bb611$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $80ec6f6f272bb611$export$a0816fa17a9e79be; }, function (v) { return $80ec6f6f272bb611$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $80ec6f6f272bb611$export$7292efcadded39f3; }, function (v) { return $80ec6f6f272bb611$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $80ec6f6f272bb611$export$da407abadb9b8f86; }, function (v) { return $80ec6f6f272bb611$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $80ec6f6f272bb611$export$314cfea32580671c; }, function (v) { return $80ec6f6f272bb611$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $80ec6f6f272bb611$export$513ccb98c53b8039; }, function (v) { return $80ec6f6f272bb611$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $80ec6f6f272bb611$export$dbca993bc2d264a; }, function (v) { return $80ec6f6f272bb611$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $80ec6f6f272bb611$export$4797a8006f0655d0; }, function (v) { return $80ec6f6f272bb611$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $80ec6f6f272bb611$export$c78a37762a8d58e1; }, function (v) { return $80ec6f6f272bb611$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $80ec6f6f272bb611$export$606f11b2eb45ecc6; }, function (v) { return $80ec6f6f272bb611$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $80ec6f6f272bb611$export$f7e8a0bf92324b1e; }, function (v) { return $80ec6f6f272bb611$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $80ec6f6f272bb611$export$83d89fbfd8236492; }, function (v) { return $80ec6f6f272bb611$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $80ec6f6f272bb611$export$69ce8ef3fe5cead0;
var $80ec6f6f272bb611$export$d39a5bbd09211389;
var $80ec6f6f272bb611$export$cd75ccfd720a3cd4;
var $80ec6f6f272bb611$export$a0816fa17a9e79be;
var $80ec6f6f272bb611$export$7292efcadded39f3;
var $80ec6f6f272bb611$export$da407abadb9b8f86;
var $80ec6f6f272bb611$export$314cfea32580671c;
var $80ec6f6f272bb611$export$513ccb98c53b8039;
var $80ec6f6f272bb611$export$dbca993bc2d264a;
var $80ec6f6f272bb611$export$4797a8006f0655d0;
var $80ec6f6f272bb611$export$c78a37762a8d58e1;
var $80ec6f6f272bb611$export$606f11b2eb45ecc6;
var $80ec6f6f272bb611$export$f7e8a0bf92324b1e;
var $80ec6f6f272bb611$export$83d89fbfd8236492;
"use strict";

(function() {
    function noop() {}
    function testStringCoercion(value) {
        return "" + value;
    }
    function createPortal$1(children, containerInfo, implementation) {
        var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
        try {
            testStringCoercion(key);
            var JSCompiler_inline_result = !1;
        } catch (e) {
            JSCompiler_inline_result = !0;
        }
        JSCompiler_inline_result && (console.error("The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", "function" === typeof Symbol && Symbol.toStringTag && key[Symbol.toStringTag] || key.constructor.name || "Object"), testStringCoercion(key));
        return {
            $$typeof: REACT_PORTAL_TYPE,
            key: null == key ? null : "" + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    function getCrossOriginStringAs(as, input) {
        if ("font" === as) return "";
        if ("string" === typeof input) return "use-credentials" === input ? input : "";
    }
    function getValueDescriptorExpectingObjectForWarning(thing) {
        return null === thing ? "`null`" : void 0 === thing ? "`undefined`" : "" === thing ? "an empty string" : 'something with type "' + typeof thing + '"';
    }
    function getValueDescriptorExpectingEnumForWarning(thing) {
        return null === thing ? "`null`" : void 0 === thing ? "`undefined`" : "" === thing ? "an empty string" : "string" === typeof thing ? JSON.stringify(thing) : "number" === typeof thing ? "`" + thing + "`" : 'something with type "' + typeof thing + '"';
    }
    function resolveDispatcher() {
        var dispatcher = ReactSharedInternals.H;
        null === dispatcher && console.error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.");
        return dispatcher;
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React = (parcelRequire("2xPiy")), Internals = {
        d: {
            f: noop,
            r: function() {
                throw Error("Invalid form element. requestFormReset must be passed a form that was rendered by React.");
            },
            D: noop,
            C: noop,
            L: noop,
            m: noop,
            X: noop,
            S: noop,
            M: noop
        },
        p: 0,
        findDOMNode: null
    }, REACT_PORTAL_TYPE = Symbol.for("react.portal"), ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    "function" === typeof Map && null != Map.prototype && "function" === typeof Map.prototype.forEach && "function" === typeof Set && null != Set.prototype && "function" === typeof Set.prototype.clear && "function" === typeof Set.prototype.forEach || console.error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    $80ec6f6f272bb611$export$69ce8ef3fe5cead0 = Internals;
    $80ec6f6f272bb611$export$d39a5bbd09211389 = function(children, container) {
        var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
        if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error("Target container is not a DOM element.");
        return createPortal$1(children, container, null, key);
    };
    $80ec6f6f272bb611$export$cd75ccfd720a3cd4 = function(fn) {
        var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
        try {
            if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
        } finally{
            ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f() && console.error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
        }
    };
    $80ec6f6f272bb611$export$a0816fa17a9e79be = function(href, options) {
        "string" === typeof href && href ? null != options && "object" !== typeof options ? console.error("ReactDOM.preconnect(): Expected the `options` argument (second) to be an object but encountered %s instead. The only supported option at this time is `crossOrigin` which accepts a string.", getValueDescriptorExpectingEnumForWarning(options)) : null != options && "string" !== typeof options.crossOrigin && console.error("ReactDOM.preconnect(): Expected the `crossOrigin` option (second argument) to be a string but encountered %s instead. Try removing this option or passing a string value instead.", getValueDescriptorExpectingObjectForWarning(options.crossOrigin)) : console.error("ReactDOM.preconnect(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", getValueDescriptorExpectingObjectForWarning(href));
        "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
    };
    $80ec6f6f272bb611$export$7292efcadded39f3 = function(href) {
        if ("string" !== typeof href || !href) console.error("ReactDOM.prefetchDNS(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", getValueDescriptorExpectingObjectForWarning(href));
        else if (1 < arguments.length) {
            var options = arguments[1];
            "object" === typeof options && options.hasOwnProperty("crossOrigin") ? console.error("ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. It looks like the you are attempting to set a crossOrigin property for this DNS lookup hint. Browsers do not perform DNS queries using CORS and setting this attribute on the resource hint has no effect. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.", getValueDescriptorExpectingEnumForWarning(options)) : console.error("ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.", getValueDescriptorExpectingEnumForWarning(options));
        }
        "string" === typeof href && Internals.d.D(href);
    };
    $80ec6f6f272bb611$export$da407abadb9b8f86 = function(href, options) {
        "string" === typeof href && href ? null == options || "object" !== typeof options ? console.error("ReactDOM.preinit(): Expected the `options` argument (second) to be an object with an `as` property describing the type of resource to be preinitialized but encountered %s instead.", getValueDescriptorExpectingEnumForWarning(options)) : "style" !== options.as && "script" !== options.as && console.error('ReactDOM.preinit(): Expected the `as` property in the `options` argument (second) to contain a valid value describing the type of resource to be preinitialized but encountered %s instead. Valid values for `as` are "style" and "script".', getValueDescriptorExpectingEnumForWarning(options.as)) : console.error("ReactDOM.preinit(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", getValueDescriptorExpectingObjectForWarning(href));
        if ("string" === typeof href && options && "string" === typeof options.as) {
            var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
            "style" === as ? Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
                crossOrigin: crossOrigin,
                integrity: integrity,
                fetchPriority: fetchPriority
            }) : "script" === as && Internals.d.X(href, {
                crossOrigin: crossOrigin,
                integrity: integrity,
                fetchPriority: fetchPriority,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0
            });
        }
    };
    $80ec6f6f272bb611$export$314cfea32580671c = function(href, options) {
        var encountered = "";
        "string" === typeof href && href || (encountered += " The `href` argument encountered was " + getValueDescriptorExpectingObjectForWarning(href) + ".");
        void 0 !== options && "object" !== typeof options ? encountered += " The `options` argument encountered was " + getValueDescriptorExpectingObjectForWarning(options) + "." : options && "as" in options && "script" !== options.as && (encountered += " The `as` option encountered was " + getValueDescriptorExpectingEnumForWarning(options.as) + ".");
        if (encountered) console.error("ReactDOM.preinitModule(): Expected up to two arguments, a non-empty `href` string and, optionally, an `options` object with a valid `as` property.%s", encountered);
        else switch(encountered = options && "string" === typeof options.as ? options.as : "script", encountered){
            case "script":
                break;
            default:
                encountered = getValueDescriptorExpectingEnumForWarning(encountered), console.error('ReactDOM.preinitModule(): Currently the only supported "as" type for this function is "script" but received "%s" instead. This warning was generated for `href` "%s". In the future other module types will be supported, aligning with the import-attributes proposal. Learn more here: (https://github.com/tc39/proposal-import-attributes)', encountered, href);
        }
        if ("string" === typeof href) {
            if ("object" === typeof options && null !== options) {
                if (null == options.as || "script" === options.as) encountered = getCrossOriginStringAs(options.as, options.crossOrigin), Internals.d.M(href, {
                    crossOrigin: encountered,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            } else null == options && Internals.d.M(href);
        }
    };
    $80ec6f6f272bb611$export$513ccb98c53b8039 = function(href, options) {
        var encountered = "";
        "string" === typeof href && href || (encountered += " The `href` argument encountered was " + getValueDescriptorExpectingObjectForWarning(href) + ".");
        null == options || "object" !== typeof options ? encountered += " The `options` argument encountered was " + getValueDescriptorExpectingObjectForWarning(options) + "." : "string" === typeof options.as && options.as || (encountered += " The `as` option encountered was " + getValueDescriptorExpectingObjectForWarning(options.as) + ".");
        encountered && console.error('ReactDOM.preload(): Expected two arguments, a non-empty `href` string and an `options` object with an `as` property valid for a `<link rel="preload" as="..." />` tag.%s', encountered);
        if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
            encountered = options.as;
            var crossOrigin = getCrossOriginStringAs(encountered, options.crossOrigin);
            Internals.d.L(href, encountered, {
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                type: "string" === typeof options.type ? options.type : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
                referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
                imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
                imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
                media: "string" === typeof options.media ? options.media : void 0
            });
        }
    };
    $80ec6f6f272bb611$export$dbca993bc2d264a = function(href, options) {
        var encountered = "";
        "string" === typeof href && href || (encountered += " The `href` argument encountered was " + getValueDescriptorExpectingObjectForWarning(href) + ".");
        void 0 !== options && "object" !== typeof options ? encountered += " The `options` argument encountered was " + getValueDescriptorExpectingObjectForWarning(options) + "." : options && "as" in options && "string" !== typeof options.as && (encountered += " The `as` option encountered was " + getValueDescriptorExpectingObjectForWarning(options.as) + ".");
        encountered && console.error('ReactDOM.preloadModule(): Expected two arguments, a non-empty `href` string and, optionally, an `options` object with an `as` property valid for a `<link rel="modulepreload" as="..." />` tag.%s', encountered);
        "string" === typeof href && (options ? (encountered = getCrossOriginStringAs(options.as, options.crossOrigin), Internals.d.m(href, {
            as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
            crossOrigin: encountered,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0
        })) : Internals.d.m(href));
    };
    $80ec6f6f272bb611$export$4797a8006f0655d0 = function(form) {
        Internals.d.r(form);
    };
    $80ec6f6f272bb611$export$c78a37762a8d58e1 = function(fn, a) {
        return fn(a);
    };
    $80ec6f6f272bb611$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
        return resolveDispatcher().useFormState(action, initialState, permalink);
    };
    $80ec6f6f272bb611$export$f7e8a0bf92324b1e = function() {
        return resolveDispatcher().useHostTransitionStatus();
    };
    $80ec6f6f272bb611$export$83d89fbfd8236492 = "19.2.8";
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});



parcelRegister("iA1nz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "isStyledComponent", function () { return $d86ca8a585e036e5$export$7ba318d8d2f06c76; });
$parcel$export(module.exports, "version", function () { return $d86ca8a585e036e5$export$83d89fbfd8236492; });
$parcel$export(module.exports, "StyleSheetContext", function () { return $d86ca8a585e036e5$export$8c190ef828af4c86; });
$parcel$export(module.exports, "StyleSheetConsumer", function () { return $d86ca8a585e036e5$export$91317688fc694efa; });
$parcel$export(module.exports, "StyleSheetManager", function () { return $d86ca8a585e036e5$export$a473771da2f0ff7c; });
$parcel$export(module.exports, "css", function () { return $d86ca8a585e036e5$export$dbf350e5966cf602; });
$parcel$export(module.exports, "ThemeContext", function () { return $d86ca8a585e036e5$export$2c657da244d00bd6; });
$parcel$export(module.exports, "ThemeConsumer", function () { return $d86ca8a585e036e5$export$b631efc24e9d5e2f; });
$parcel$export(module.exports, "ThemeProvider", function () { return $d86ca8a585e036e5$export$d8964aec282183a3; });
$parcel$export(module.exports, "createGlobalStyle", function () { return $d86ca8a585e036e5$export$f0f03736edb61697; });
$parcel$export(module.exports, "keyframes", function () { return $d86ca8a585e036e5$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ServerStyleSheet", function () { return $d86ca8a585e036e5$export$ae8c7d15c8b89a20; });
$parcel$export(module.exports, "withTheme", function () { return $d86ca8a585e036e5$export$e8748c6a27b910dc; });
$parcel$export(module.exports, "useTheme", function () { return $d86ca8a585e036e5$export$93d4e7f90805808f; });
$parcel$export(module.exports, "__PRIVATE__", function () { return $d86ca8a585e036e5$export$5c87cfe6c475f500; });
$parcel$export(module.exports, "default", function () { return $d86ca8a585e036e5$export$2e2bcd8739ae039; });

var $3tTaq = parcelRequire("3tTaq");

var $2xPiy = parcelRequire("2xPiy");

var $1KWAq = parcelRequire("1KWAq");

var $2Y8kj = parcelRequire("2Y8kj");

var $cX87O = parcelRequire("cX87O");

var $5Uup5 = parcelRequire("5Uup5");

var $liOrM = parcelRequire("liOrM");
function $d86ca8a585e036e5$var$v() {
    return ($d86ca8a585e036e5$var$v = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $d86ca8a585e036e5$var$g = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $d86ca8a585e036e5$var$S = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $3tTaq.typeOf)(t);
}, $d86ca8a585e036e5$var$w = Object.freeze([]), $d86ca8a585e036e5$var$E = Object.freeze({});
function $d86ca8a585e036e5$var$b(e) {
    return "function" == typeof e;
}
function $d86ca8a585e036e5$var$_(e) {
    return "string" == typeof e && e || e.displayName || e.name || "Component";
}
function $d86ca8a585e036e5$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $d86ca8a585e036e5$var$A = "data-styled", $d86ca8a585e036e5$export$83d89fbfd8236492 = "5.3.10", $d86ca8a585e036e5$var$I = "undefined" != typeof window && "HTMLElement" in window, $d86ca8a585e036e5$var$P = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : false), $d86ca8a585e036e5$var$O = {}, $d86ca8a585e036e5$var$R = {
    1: "Cannot create styled-component for component: %s.\n\n",
    2: "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
    3: "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
    4: "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
    5: "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
    6: "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
    7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',
    8: 'ThemeProvider: Please make your "theme" prop an object.\n\n',
    9: "Missing document `<head>`\n\n",
    10: "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
    11: "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
    12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
    13: "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",
    14: 'ThemeProvider: "theme" prop is required.\n\n',
    15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
    16: "Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",
    17: "CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n"
};
function $d86ca8a585e036e5$var$D() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $d86ca8a585e036e5$var$j(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error($d86ca8a585e036e5$var$D.apply(void 0, [
        $d86ca8a585e036e5$var$R[e]
    ].concat(n)).trim());
}
var $d86ca8a585e036e5$var$T = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $d86ca8a585e036e5$var$j(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $d86ca8a585e036e5$var$x = new Map, $d86ca8a585e036e5$var$k = new Map, $d86ca8a585e036e5$var$V = 1, $d86ca8a585e036e5$var$B = function(e) {
    if ($d86ca8a585e036e5$var$x.has(e)) return $d86ca8a585e036e5$var$x.get(e);
    for(; $d86ca8a585e036e5$var$k.has($d86ca8a585e036e5$var$V);)$d86ca8a585e036e5$var$V++;
    var t = $d86ca8a585e036e5$var$V++;
    return ((0 | t) < 0 || t > 1073741824) && $d86ca8a585e036e5$var$j(16, "" + t), $d86ca8a585e036e5$var$x.set(e, t), $d86ca8a585e036e5$var$k.set(t, e), t;
}, $d86ca8a585e036e5$var$z = function(e) {
    return $d86ca8a585e036e5$var$k.get(e);
}, $d86ca8a585e036e5$var$M = function(e, t) {
    t >= $d86ca8a585e036e5$var$V && ($d86ca8a585e036e5$var$V = t + 1), $d86ca8a585e036e5$var$x.set(e, t), $d86ca8a585e036e5$var$k.set(t, e);
}, $d86ca8a585e036e5$var$G = "style[" + $d86ca8a585e036e5$var$A + '][data-styled-version="5.3.10"]', $d86ca8a585e036e5$var$L = new RegExp("^" + $d86ca8a585e036e5$var$A + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $d86ca8a585e036e5$var$F = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $d86ca8a585e036e5$var$Y = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($d86ca8a585e036e5$var$L);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($d86ca8a585e036e5$var$M(u, c), $d86ca8a585e036e5$var$F(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $d86ca8a585e036e5$var$q = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $d86ca8a585e036e5$var$H = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($d86ca8a585e036e5$var$A)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($d86ca8a585e036e5$var$A, "active"), r.setAttribute("data-styled-version", "5.3.10");
    var i = $d86ca8a585e036e5$var$q();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $d86ca8a585e036e5$var$$ = function() {
    function e(e) {
        var t = this.element = $d86ca8a585e036e5$var$H(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $d86ca8a585e036e5$var$j(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $d86ca8a585e036e5$var$W = function() {
    function e(e) {
        var t = this.element = $d86ca8a585e036e5$var$H(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $d86ca8a585e036e5$var$U = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $d86ca8a585e036e5$var$J = $d86ca8a585e036e5$var$I, $d86ca8a585e036e5$var$X = {
    isServer: !$d86ca8a585e036e5$var$I,
    useCSSOMInjection: !$d86ca8a585e036e5$var$P
}, $d86ca8a585e036e5$var$Z = function() {
    function e(e, t, n) {
        void 0 === e && (e = $d86ca8a585e036e5$var$E), void 0 === t && (t = {}), this.options = $d86ca8a585e036e5$var$v({}, $d86ca8a585e036e5$var$X, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $d86ca8a585e036e5$var$I && $d86ca8a585e036e5$var$J && ($d86ca8a585e036e5$var$J = !1, function(e) {
            for(var t = document.querySelectorAll($d86ca8a585e036e5$var$G), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($d86ca8a585e036e5$var$A) && ($d86ca8a585e036e5$var$Y(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $d86ca8a585e036e5$var$B(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($d86ca8a585e036e5$var$v({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $d86ca8a585e036e5$var$U(o) : r ? new $d86ca8a585e036e5$var$$(o) : new $d86ca8a585e036e5$var$W(o), new $d86ca8a585e036e5$var$T(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($d86ca8a585e036e5$var$B(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($d86ca8a585e036e5$var$B(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($d86ca8a585e036e5$var$B(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $d86ca8a585e036e5$var$z(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $d86ca8a585e036e5$var$A + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $d86ca8a585e036e5$var$K = /(a)(d)/gi, $d86ca8a585e036e5$var$Q = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $d86ca8a585e036e5$var$ee(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $d86ca8a585e036e5$var$Q(t % 52) + n;
    return ($d86ca8a585e036e5$var$Q(t % 52) + n).replace($d86ca8a585e036e5$var$K, "$1-$2");
}
var $d86ca8a585e036e5$var$te = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $d86ca8a585e036e5$var$ne = function(e) {
    return $d86ca8a585e036e5$var$te(5381, e);
};
function $d86ca8a585e036e5$var$re(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($d86ca8a585e036e5$var$b(n) && !$d86ca8a585e036e5$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $d86ca8a585e036e5$var$oe = $d86ca8a585e036e5$var$ne("5.3.10"), $d86ca8a585e036e5$var$se = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = false, this.componentId = t, this.baseHash = $d86ca8a585e036e5$var$te($d86ca8a585e036e5$var$oe, t), this.baseStyle = n, $d86ca8a585e036e5$var$Z.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $d86ca8a585e036e5$var$Ne(this.rules, e, t, n).join(""), i = $d86ca8a585e036e5$var$ee($d86ca8a585e036e5$var$te(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $d86ca8a585e036e5$var$te(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h, u = $d86ca8a585e036e5$var$te(u, h + d);
                else if (h) {
                    var p = $d86ca8a585e036e5$var$Ne(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $d86ca8a585e036e5$var$te(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $d86ca8a585e036e5$var$ee(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $d86ca8a585e036e5$var$ie = /^\s*\/\/.*$/gm, $d86ca8a585e036e5$var$ae = [
    ":",
    "[",
    ".",
    "#"
];
function $d86ca8a585e036e5$var$ce(e) {
    var t, n, r, o, s = void 0 === e ? $d86ca8a585e036e5$var$E : e, i = s.options, a = void 0 === i ? $d86ca8a585e036e5$var$E : i, c = s.plugins, u = void 0 === c ? $d86ca8a585e036e5$var$w : c, l = new (0, $2Y8kj.default)(a), d = [], h = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $d86ca8a585e036e5$var$ae.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($d86ca8a585e036e5$var$ie, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        h,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $d86ca8a585e036e5$var$j(15), $d86ca8a585e036e5$var$te(e, t.name);
    }, 5381).toString() : "", m;
}
var $d86ca8a585e036e5$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createContext(), $d86ca8a585e036e5$export$91317688fc694efa = $d86ca8a585e036e5$export$8c190ef828af4c86.Consumer, $d86ca8a585e036e5$var$de = (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createContext(), $d86ca8a585e036e5$var$he = ($d86ca8a585e036e5$var$de.Consumer, new $d86ca8a585e036e5$var$Z), $d86ca8a585e036e5$var$pe = $d86ca8a585e036e5$var$ce();
function $d86ca8a585e036e5$var$fe() {
    return (0, $2xPiy.useContext)($d86ca8a585e036e5$export$8c190ef828af4c86) || $d86ca8a585e036e5$var$he;
}
function $d86ca8a585e036e5$var$me() {
    return (0, $2xPiy.useContext)($d86ca8a585e036e5$var$de) || $d86ca8a585e036e5$var$pe;
}
function $d86ca8a585e036e5$export$a473771da2f0ff7c(e) {
    var t = (0, $2xPiy.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $d86ca8a585e036e5$var$fe(), u = (0, $2xPiy.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $2xPiy.useMemo)(function() {
        return $d86ca8a585e036e5$var$ce({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $2xPiy.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($1KWAq)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($d86ca8a585e036e5$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($d86ca8a585e036e5$var$de.Provider, {
        value: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).Children.only(e.children)));
}
var $d86ca8a585e036e5$var$ve = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $d86ca8a585e036e5$var$pe);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $d86ca8a585e036e5$var$j(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $d86ca8a585e036e5$var$pe), this.name + e.hash;
    }, e;
}(), $d86ca8a585e036e5$var$ge = /([A-Z])/, $d86ca8a585e036e5$var$Se = /([A-Z])/g, $d86ca8a585e036e5$var$we = /^ms-/, $d86ca8a585e036e5$var$Ee = function(e) {
    return "-" + e.toLowerCase();
};
function $d86ca8a585e036e5$var$be(e) {
    return $d86ca8a585e036e5$var$ge.test(e) ? e.replace($d86ca8a585e036e5$var$Se, $d86ca8a585e036e5$var$Ee).replace($d86ca8a585e036e5$var$we, "-ms-") : e;
}
var $d86ca8a585e036e5$var$_e = function(e) {
    return null == e || !1 === e || "" === e;
};
function $d86ca8a585e036e5$var$Ne(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $d86ca8a585e036e5$var$Ne(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($d86ca8a585e036e5$var$_e(e)) return "";
    if ($d86ca8a585e036e5$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($d86ca8a585e036e5$var$b(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return (0, $3tTaq.isElement)(u) && console.warn($d86ca8a585e036e5$var$_(e) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), $d86ca8a585e036e5$var$Ne(u, n, r, o);
    }
    var l;
    return e instanceof $d86ca8a585e036e5$var$ve ? r ? (e.inject(r, o), e.getName(o)) : e : $d86ca8a585e036e5$var$S(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$d86ca8a585e036e5$var$_e(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $d86ca8a585e036e5$var$b(t[i]) ? s.push($d86ca8a585e036e5$var$be(i) + ":", t[i], ";") : $d86ca8a585e036e5$var$S(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($d86ca8a585e036e5$var$be(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $cX87O.default) || r.startsWith("--") ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $d86ca8a585e036e5$var$Ae = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $d86ca8a585e036e5$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $d86ca8a585e036e5$var$b(e) || $d86ca8a585e036e5$var$S(e) ? $d86ca8a585e036e5$var$Ae($d86ca8a585e036e5$var$Ne($d86ca8a585e036e5$var$g($d86ca8a585e036e5$var$w, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $d86ca8a585e036e5$var$Ae($d86ca8a585e036e5$var$Ne($d86ca8a585e036e5$var$g(e, n)));
}
var $d86ca8a585e036e5$var$Ie = /invalid hook call/i, $d86ca8a585e036e5$var$Pe = new Set, $d86ca8a585e036e5$var$Oe = function(e, t) {
    var n = "The component " + e + (t ? ' with the id of "' + t + '"' : "") + " has been created dynamically.\nYou may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.", r = console.error;
    try {
        var o = !0;
        console.error = function(e) {
            if ($d86ca8a585e036e5$var$Ie.test(e)) o = !1, $d86ca8a585e036e5$var$Pe.delete(n);
            else {
                for(var t = arguments.length, s = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)s[i - 1] = arguments[i];
                r.apply(void 0, [
                    e
                ].concat(s));
            }
        }, (0, $2xPiy.useRef)(), o && !$d86ca8a585e036e5$var$Pe.has(n) && (console.warn(n), $d86ca8a585e036e5$var$Pe.add(n));
    } catch (e) {
        $d86ca8a585e036e5$var$Ie.test(e.message) && $d86ca8a585e036e5$var$Pe.delete(n);
    } finally{
        console.error = r;
    }
}, $d86ca8a585e036e5$var$Re = function(e, t, n) {
    return void 0 === n && (n = $d86ca8a585e036e5$var$E), e.theme !== n.theme && e.theme || t || n.theme;
}, $d86ca8a585e036e5$var$De = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $d86ca8a585e036e5$var$je = /(^-|-$)/g;
function $d86ca8a585e036e5$var$Te(e) {
    return e.replace($d86ca8a585e036e5$var$De, "-").replace($d86ca8a585e036e5$var$je, "");
}
var $d86ca8a585e036e5$var$xe = function(e) {
    return $d86ca8a585e036e5$var$ee($d86ca8a585e036e5$var$ne(e) >>> 0);
};
function $d86ca8a585e036e5$var$ke(e) {
    return "string" == typeof e && e.charAt(0) === e.charAt(0).toLowerCase();
}
var $d86ca8a585e036e5$var$Ve = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $d86ca8a585e036e5$var$Be = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $d86ca8a585e036e5$var$ze(e, t, n) {
    var r = e[n];
    $d86ca8a585e036e5$var$Ve(t) && $d86ca8a585e036e5$var$Ve(r) ? $d86ca8a585e036e5$var$Me(r, t) : e[n] = t;
}
function $d86ca8a585e036e5$var$Me(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($d86ca8a585e036e5$var$Ve(i)) for(var a in i)$d86ca8a585e036e5$var$Be(a) && $d86ca8a585e036e5$var$ze(e, i[a], a);
    }
    return e;
}
var $d86ca8a585e036e5$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createContext(), $d86ca8a585e036e5$export$b631efc24e9d5e2f = $d86ca8a585e036e5$export$2c657da244d00bd6.Consumer;
function $d86ca8a585e036e5$export$d8964aec282183a3(e) {
    var t = (0, $2xPiy.useContext)($d86ca8a585e036e5$export$2c657da244d00bd6), n = (0, $2xPiy.useMemo)(function() {
        return function(e, t) {
            if (!e) return $d86ca8a585e036e5$var$j(14);
            if ($d86ca8a585e036e5$var$b(e)) {
                var n = e(t);
                return null !== n && !Array.isArray(n) && "object" == typeof n ? n : $d86ca8a585e036e5$var$j(7);
            }
            return Array.isArray(e) || "object" != typeof e ? $d86ca8a585e036e5$var$j(8) : t ? $d86ca8a585e036e5$var$v({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($d86ca8a585e036e5$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $d86ca8a585e036e5$var$Ye = {};
function $d86ca8a585e036e5$var$qe(e, t, n) {
    var o = $d86ca8a585e036e5$export$7ba318d8d2f06c76(e), i = !$d86ca8a585e036e5$var$ke(e), a = t.attrs, c = void 0 === a ? $d86ca8a585e036e5$var$w : a, d = t.componentId, h = void 0 === d ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $d86ca8a585e036e5$var$Te(e);
        $d86ca8a585e036e5$var$Ye[n] = ($d86ca8a585e036e5$var$Ye[n] || 0) + 1;
        var r = n + "-" + $d86ca8a585e036e5$var$xe("5.3.10" + n + $d86ca8a585e036e5$var$Ye[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : d, p = t.displayName, f = void 0 === p ? function(e) {
        return $d86ca8a585e036e5$var$ke(e) ? "styled." + e : "Styled(" + $d86ca8a585e036e5$var$_(e) + ")";
    }(e) : p, g = t.displayName && t.componentId ? $d86ca8a585e036e5$var$Te(t.displayName) + "-" + t.componentId : t.componentId || h, S = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, A = t.shouldForwardProp;
    o && e.shouldForwardProp && (A = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var C, I = new $d86ca8a585e036e5$var$se(n, g, o ? e.componentStyle : void 0), P = I.isStatic && 0 === c.length, O = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, d = e.shouldForwardProp, h = e.styledComponentId, p = e.target;
            (0, $2xPiy.useDebugValue)(h);
            var f = function(e, t, n) {
                void 0 === e && (e = $d86ca8a585e036e5$var$E);
                var r = $d86ca8a585e036e5$var$v({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $d86ca8a585e036e5$var$b(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($d86ca8a585e036e5$var$Re(t, (0, $2xPiy.useContext)($d86ca8a585e036e5$export$2c657da244d00bd6), a) || $d86ca8a585e036e5$var$E, t, o), y = f[0], g = f[1], S = function(e, t, n, r) {
                var o = $d86ca8a585e036e5$var$fe(), s = $d86ca8a585e036e5$var$me(), i = t ? e.generateAndInjectStyles($d86ca8a585e036e5$var$E, o, s) : e.generateAndInjectStyles(n, o, s);
                return (0, $2xPiy.useDebugValue)(i), !t && r && r(i), i;
            }(i, r, y, (0, e.warnTooManyClasses)), w = n, _ = g.$as || t.$as || g.as || t.as || p, N = $d86ca8a585e036e5$var$ke(_), A = g !== t ? $d86ca8a585e036e5$var$v({}, t, {}, g) : t, C = {};
            for(var I in A)"$" !== I[0] && "as" !== I && ("forwardedAs" === I ? C.as = A[I] : (d ? d(I, (0, $5Uup5.default), _) : !N || (0, $5Uup5.default)(I)) && (C[I] = A[I]));
            return t.style && g.style !== t.style && (C.style = $d86ca8a585e036e5$var$v({}, t.style, {}, g.style)), C.className = Array.prototype.concat(c, h, S !== h ? S : null, t.className, g.className).filter(Boolean).join(" "), C.ref = w, (0, $2xPiy.createElement)(_, C);
        }(C, e, t, P);
    };
    return O.displayName = f, (C = (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).forwardRef(O)).attrs = S, C.componentStyle = I, C.displayName = f, C.shouldForwardProp = A, C.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $d86ca8a585e036e5$var$w, C.styledComponentId = g, C.target = o ? e.target : e, C.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($d86ca8a585e036e5$var$ke(e) ? e : $d86ca8a585e036e5$var$Te($d86ca8a585e036e5$var$_(e)));
        return $d86ca8a585e036e5$var$qe(e, $d86ca8a585e036e5$var$v({}, o, {
            attrs: S,
            componentId: s
        }), n);
    }, Object.defineProperty(C, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $d86ca8a585e036e5$var$Me({}, e.defaultProps, t) : t;
        }
    }), $d86ca8a585e036e5$var$Oe(f, g), C.warnTooManyClasses = function(e, t) {
        var n = {}, r = !1;
        return function(o) {
            if (!r && (n[o] = !0, Object.keys(n).length >= 200)) {
                var s = t ? ' with the id of "' + t + '"' : "";
                console.warn("Over 200 classes were generated for component " + e + s + ".\nConsider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"), r = !0, n = {};
            }
        };
    }(f, g), Object.defineProperty(C, "toString", {
        value: function() {
            return "." + C.styledComponentId;
        }
    }), i && (0, (/*@__PURE__*/$parcel$interopDefault($liOrM)))(C, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), C;
}
var $d86ca8a585e036e5$var$He = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $d86ca8a585e036e5$var$E), !(0, $3tTaq.isValidElementType)(r)) return $d86ca8a585e036e5$var$j(1, String(r));
        var s = function() {
            return t(r, o, $d86ca8a585e036e5$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $d86ca8a585e036e5$var$v({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $d86ca8a585e036e5$var$v({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($d86ca8a585e036e5$var$qe, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $d86ca8a585e036e5$var$He[e] = $d86ca8a585e036e5$var$He(e);
});
var $d86ca8a585e036e5$var$$e = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $d86ca8a585e036e5$var$re(e), $d86ca8a585e036e5$var$Z.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($d86ca8a585e036e5$var$Ne(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $d86ca8a585e036e5$var$Z.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $d86ca8a585e036e5$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $d86ca8a585e036e5$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $d86ca8a585e036e5$var$xe(JSON.stringify(i)), u = new $d86ca8a585e036e5$var$$e(i, a);
    function l(e) {
        var t = $d86ca8a585e036e5$var$fe(), n = $d86ca8a585e036e5$var$me(), o = (0, $2xPiy.useContext)($d86ca8a585e036e5$export$2c657da244d00bd6), l = (0, $2xPiy.useRef)(t.allocateGSInstance(a)).current;
        return (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).Children.count(e.children) && console.warn("The global style component " + a + " was given child JSX. createGlobalStyle does not render children."), i.some(function(e) {
            return "string" == typeof e && -1 !== e.indexOf("@import");
        }) && console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."), t.server && h(l, e, t, o, n), (0, $2xPiy.useLayoutEffect)(function() {
            if (!t.server) return h(l, e, t, o, n), function() {
                return u.removeStyles(l, t);
            };
        }, [
            l,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $d86ca8a585e036e5$var$O, n, o);
        else {
            var s = $d86ca8a585e036e5$var$v({}, t, {
                theme: $d86ca8a585e036e5$var$Re(t, r, l.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return $d86ca8a585e036e5$var$Oe(a), (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).memo(l);
}
function $d86ca8a585e036e5$export$d25ddfdf17c3ad3e(e) {
    "undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $d86ca8a585e036e5$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $d86ca8a585e036e5$var$xe(o);
    return new $d86ca8a585e036e5$var$ve(s, o);
}
var $d86ca8a585e036e5$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $d86ca8a585e036e5$var$q();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $d86ca8a585e036e5$var$A + '="true"',
                'data-styled-version="5.3.10"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $d86ca8a585e036e5$var$j(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $d86ca8a585e036e5$var$j(2);
            var n = ((t = {})[$d86ca8a585e036e5$var$A] = "", t["data-styled-version"] = "5.3.10", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $d86ca8a585e036e5$var$q();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("style", $d86ca8a585e036e5$var$v({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $d86ca8a585e036e5$var$Z({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $d86ca8a585e036e5$var$j(2) : (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($d86ca8a585e036e5$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $d86ca8a585e036e5$var$j(3);
    }, e;
}(), $d86ca8a585e036e5$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).forwardRef(function(t, n) {
        var o = (0, $2xPiy.useContext)($d86ca8a585e036e5$export$2c657da244d00bd6), i = e.defaultProps, a = $d86ca8a585e036e5$var$Re(t, o, i);
        return void 0 === a && console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "' + $d86ca8a585e036e5$var$_(e) + '"'), (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(e, $d86ca8a585e036e5$var$v({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($liOrM)))(t, e), t.displayName = "WithTheme(" + $d86ca8a585e036e5$var$_(e) + ")", t;
}, $d86ca8a585e036e5$export$93d4e7f90805808f = function() {
    return (0, $2xPiy.useContext)($d86ca8a585e036e5$export$2c657da244d00bd6);
}, $d86ca8a585e036e5$export$5c87cfe6c475f500 = {
    StyleSheet: $d86ca8a585e036e5$var$Z,
    masterSheet: $d86ca8a585e036e5$var$he
};
"undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native"), "undefined" != typeof window && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, 1 === window["__styled-components-init__"] && console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."), window["__styled-components-init__"] += 1);
var $d86ca8a585e036e5$export$2e2bcd8739ae039 = $d86ca8a585e036e5$var$He;

});
parcelRegister("3tTaq", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fYRmv"));

});
parcelRegister("fYRmv", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $ba25da33b02baf5b$export$a7c73072b1a182ae; }, function (v) { return $ba25da33b02baf5b$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $ba25da33b02baf5b$export$9f27bc3417b4524d; }, function (v) { return $ba25da33b02baf5b$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $ba25da33b02baf5b$export$db77ccec0bb4ccac; }, function (v) { return $ba25da33b02baf5b$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $ba25da33b02baf5b$export$8392c0c9d3dcbd35; }, function (v) { return $ba25da33b02baf5b$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $ba25da33b02baf5b$export$ffb0004e005737fa; }, function (v) { return $ba25da33b02baf5b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $ba25da33b02baf5b$export$b624eff549462981; }, function (v) { return $ba25da33b02baf5b$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $ba25da33b02baf5b$export$7897aa7841a5380c; }, function (v) { return $ba25da33b02baf5b$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $ba25da33b02baf5b$export$602eac185826482c; }, function (v) { return $ba25da33b02baf5b$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $ba25da33b02baf5b$export$e2c29f18771995cb; }, function (v) { return $ba25da33b02baf5b$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $ba25da33b02baf5b$export$5f8d39834fd61797; }, function (v) { return $ba25da33b02baf5b$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $ba25da33b02baf5b$export$74bf444e3cd11ea5; }, function (v) { return $ba25da33b02baf5b$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $ba25da33b02baf5b$export$998bcd577473dd93; }, function (v) { return $ba25da33b02baf5b$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $ba25da33b02baf5b$export$b706b080d889d2c9; }, function (v) { return $ba25da33b02baf5b$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $ba25da33b02baf5b$export$5be5a87408f70ddc; }, function (v) { return $ba25da33b02baf5b$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $ba25da33b02baf5b$export$45a5e7f76e0caa8d; }, function (v) { return $ba25da33b02baf5b$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $ba25da33b02baf5b$export$455c2e768291efa6; }, function (v) { return $ba25da33b02baf5b$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $ba25da33b02baf5b$export$9522e17588c12572; }, function (v) { return $ba25da33b02baf5b$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $ba25da33b02baf5b$export$2110ac352bb060b9; }, function (v) { return $ba25da33b02baf5b$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $ba25da33b02baf5b$export$56885ab8b9c456ab; }, function (v) { return $ba25da33b02baf5b$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $ba25da33b02baf5b$export$d927fcb6adf8f9de; }, function (v) { return $ba25da33b02baf5b$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $ba25da33b02baf5b$export$b82d16f27459e05a; }, function (v) { return $ba25da33b02baf5b$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $ba25da33b02baf5b$export$522c17b4f5e123e8; }, function (v) { return $ba25da33b02baf5b$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $ba25da33b02baf5b$export$1aabd8a0274ecfd6; }, function (v) { return $ba25da33b02baf5b$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $ba25da33b02baf5b$export$3d6c20d97e46b957; }, function (v) { return $ba25da33b02baf5b$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $ba25da33b02baf5b$export$9b621391a187a31a; }, function (v) { return $ba25da33b02baf5b$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $ba25da33b02baf5b$export$f5bbd400c2f4426f; }, function (v) { return $ba25da33b02baf5b$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ba25da33b02baf5b$export$a7c73072b1a182ae;
var $ba25da33b02baf5b$export$9f27bc3417b4524d;
var $ba25da33b02baf5b$export$db77ccec0bb4ccac;
var $ba25da33b02baf5b$export$8392c0c9d3dcbd35;
var $ba25da33b02baf5b$export$ffb0004e005737fa;
var $ba25da33b02baf5b$export$b624eff549462981;
var $ba25da33b02baf5b$export$7897aa7841a5380c;
var $ba25da33b02baf5b$export$602eac185826482c;
var $ba25da33b02baf5b$export$e2c29f18771995cb;
var $ba25da33b02baf5b$export$5f8d39834fd61797;
var $ba25da33b02baf5b$export$74bf444e3cd11ea5;
var $ba25da33b02baf5b$export$998bcd577473dd93;
var $ba25da33b02baf5b$export$b706b080d889d2c9;
var $ba25da33b02baf5b$export$5be5a87408f70ddc;
var $ba25da33b02baf5b$export$45a5e7f76e0caa8d;
var $ba25da33b02baf5b$export$455c2e768291efa6;
var $ba25da33b02baf5b$export$9522e17588c12572;
var $ba25da33b02baf5b$export$2110ac352bb060b9;
var $ba25da33b02baf5b$export$56885ab8b9c456ab;
var $ba25da33b02baf5b$export$d927fcb6adf8f9de;
var $ba25da33b02baf5b$export$b82d16f27459e05a;
var $ba25da33b02baf5b$export$522c17b4f5e123e8;
var $ba25da33b02baf5b$export$1aabd8a0274ecfd6;
var $ba25da33b02baf5b$export$3d6c20d97e46b957;
var $ba25da33b02baf5b$export$9b621391a187a31a;
var $ba25da33b02baf5b$export$f5bbd400c2f4426f;
"use strict";
(function() {
    function typeOf(object) {
        if ("object" === typeof object && null !== object) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    switch(object = object.type, object){
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                        case REACT_SUSPENSE_LIST_TYPE:
                        case REACT_VIEW_TRANSITION_TYPE:
                            return object;
                        default:
                            switch(object = object && object.$$typeof, object){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                    return object;
                                case REACT_CONSUMER_TYPE:
                                    return object;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
    }
    var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
    $ba25da33b02baf5b$export$a7c73072b1a182ae = REACT_CONSUMER_TYPE;
    $ba25da33b02baf5b$export$9f27bc3417b4524d = REACT_CONTEXT_TYPE;
    $ba25da33b02baf5b$export$db77ccec0bb4ccac = REACT_ELEMENT_TYPE;
    $ba25da33b02baf5b$export$8392c0c9d3dcbd35 = REACT_FORWARD_REF_TYPE;
    $ba25da33b02baf5b$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $ba25da33b02baf5b$export$b624eff549462981 = REACT_LAZY_TYPE;
    $ba25da33b02baf5b$export$7897aa7841a5380c = REACT_MEMO_TYPE;
    $ba25da33b02baf5b$export$602eac185826482c = REACT_PORTAL_TYPE;
    $ba25da33b02baf5b$export$e2c29f18771995cb = REACT_PROFILER_TYPE;
    $ba25da33b02baf5b$export$5f8d39834fd61797 = REACT_STRICT_MODE_TYPE;
    $ba25da33b02baf5b$export$74bf444e3cd11ea5 = REACT_SUSPENSE_TYPE;
    $ba25da33b02baf5b$export$998bcd577473dd93 = REACT_SUSPENSE_LIST_TYPE;
    $ba25da33b02baf5b$export$b706b080d889d2c9 = function(object) {
        return typeOf(object) === REACT_CONSUMER_TYPE;
    };
    $ba25da33b02baf5b$export$5be5a87408f70ddc = function(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    };
    $ba25da33b02baf5b$export$45a5e7f76e0caa8d = function(object) {
        return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    };
    $ba25da33b02baf5b$export$455c2e768291efa6 = function(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    };
    $ba25da33b02baf5b$export$9522e17588c12572 = function(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    };
    $ba25da33b02baf5b$export$2110ac352bb060b9 = function(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    };
    $ba25da33b02baf5b$export$56885ab8b9c456ab = function(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    };
    $ba25da33b02baf5b$export$d927fcb6adf8f9de = function(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    };
    $ba25da33b02baf5b$export$b82d16f27459e05a = function(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    };
    $ba25da33b02baf5b$export$522c17b4f5e123e8 = function(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    };
    $ba25da33b02baf5b$export$1aabd8a0274ecfd6 = function(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    };
    $ba25da33b02baf5b$export$3d6c20d97e46b957 = function(object) {
        return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    };
    $ba25da33b02baf5b$export$9b621391a187a31a = function(type) {
        return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
    };
    $ba25da33b02baf5b$export$f5bbd400c2f4426f = typeOf;
})();

});


parcelRegister("1KWAq", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});

parcelRegister("2Y8kj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2297a4e0e644cdd4$export$2e2bcd8739ae039; });
function $2297a4e0e644cdd4$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $2297a4e0e644cdd4$export$2e2bcd8739ae039 = $2297a4e0e644cdd4$var$stylis_min;

});

parcelRegister("cX87O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96e14c2b0ac6b273$export$2e2bcd8739ae039; });
var $96e14c2b0ac6b273$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $96e14c2b0ac6b273$export$2e2bcd8739ae039 = $96e14c2b0ac6b273$var$unitlessKeys;

});

parcelRegister("5Uup5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44d9c43afd1dd051$export$2e2bcd8739ae039; });

var $Z0ikY = parcelRequire("Z0ikY");
var $44d9c43afd1dd051$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $44d9c43afd1dd051$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $Z0ikY.default)(function(prop) {
    return $44d9c43afd1dd051$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("Z0ikY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b75ed273fc852e0$export$2e2bcd8739ae039; });
function $0b75ed273fc852e0$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("liOrM", function(module, exports) {
'use strict';

var $9H152 = parcelRequire("9H152");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $f8226923532d4716$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $f8226923532d4716$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $f8226923532d4716$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $f8226923532d4716$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $f8226923532d4716$var$TYPE_STATICS = {};
$f8226923532d4716$var$TYPE_STATICS[$9H152.ForwardRef] = $f8226923532d4716$var$FORWARD_REF_STATICS;
$f8226923532d4716$var$TYPE_STATICS[$9H152.Memo] = $f8226923532d4716$var$MEMO_STATICS;
function $f8226923532d4716$var$getStatics(component) {
    // React v16.11 and below
    if ($9H152.isMemo(component)) return $f8226923532d4716$var$MEMO_STATICS;
     // React v16.12 and above
    return $f8226923532d4716$var$TYPE_STATICS[component['$$typeof']] || $f8226923532d4716$var$REACT_STATICS;
}
var $f8226923532d4716$var$defineProperty = Object.defineProperty;
var $f8226923532d4716$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $f8226923532d4716$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f8226923532d4716$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $f8226923532d4716$var$getPrototypeOf = Object.getPrototypeOf;
var $f8226923532d4716$var$objectPrototype = Object.prototype;
function $f8226923532d4716$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($f8226923532d4716$var$objectPrototype) {
            var inheritedComponent = $f8226923532d4716$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $f8226923532d4716$var$objectPrototype) $f8226923532d4716$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $f8226923532d4716$var$getOwnPropertyNames(sourceComponent);
        if ($f8226923532d4716$var$getOwnPropertySymbols) keys = keys.concat($f8226923532d4716$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $f8226923532d4716$var$getStatics(targetComponent);
        var sourceStatics = $f8226923532d4716$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$f8226923532d4716$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $f8226923532d4716$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $f8226923532d4716$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $f8226923532d4716$var$hoistNonReactStatics;

});
parcelRegister("9H152", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8uyl0"));

});
parcelRegister("8uyl0", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $62ebc2d74b7821db$export$2b8d127b894957b9; }, function (v) { return $62ebc2d74b7821db$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $62ebc2d74b7821db$export$cea3a54a6425200c; }, function (v) { return $62ebc2d74b7821db$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $62ebc2d74b7821db$export$a7c73072b1a182ae; }, function (v) { return $62ebc2d74b7821db$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $62ebc2d74b7821db$export$9f27bc3417b4524d; }, function (v) { return $62ebc2d74b7821db$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $62ebc2d74b7821db$export$db77ccec0bb4ccac; }, function (v) { return $62ebc2d74b7821db$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $62ebc2d74b7821db$export$8392c0c9d3dcbd35; }, function (v) { return $62ebc2d74b7821db$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $62ebc2d74b7821db$export$ffb0004e005737fa; }, function (v) { return $62ebc2d74b7821db$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $62ebc2d74b7821db$export$b624eff549462981; }, function (v) { return $62ebc2d74b7821db$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $62ebc2d74b7821db$export$7897aa7841a5380c; }, function (v) { return $62ebc2d74b7821db$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $62ebc2d74b7821db$export$602eac185826482c; }, function (v) { return $62ebc2d74b7821db$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $62ebc2d74b7821db$export$e2c29f18771995cb; }, function (v) { return $62ebc2d74b7821db$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $62ebc2d74b7821db$export$5f8d39834fd61797; }, function (v) { return $62ebc2d74b7821db$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $62ebc2d74b7821db$export$74bf444e3cd11ea5; }, function (v) { return $62ebc2d74b7821db$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $62ebc2d74b7821db$export$92387174baf9b227; }, function (v) { return $62ebc2d74b7821db$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $62ebc2d74b7821db$export$ec112efeb987d9c6; }, function (v) { return $62ebc2d74b7821db$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $62ebc2d74b7821db$export$b706b080d889d2c9; }, function (v) { return $62ebc2d74b7821db$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $62ebc2d74b7821db$export$5be5a87408f70ddc; }, function (v) { return $62ebc2d74b7821db$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $62ebc2d74b7821db$export$45a5e7f76e0caa8d; }, function (v) { return $62ebc2d74b7821db$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $62ebc2d74b7821db$export$455c2e768291efa6; }, function (v) { return $62ebc2d74b7821db$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $62ebc2d74b7821db$export$9522e17588c12572; }, function (v) { return $62ebc2d74b7821db$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $62ebc2d74b7821db$export$2110ac352bb060b9; }, function (v) { return $62ebc2d74b7821db$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $62ebc2d74b7821db$export$56885ab8b9c456ab; }, function (v) { return $62ebc2d74b7821db$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $62ebc2d74b7821db$export$d927fcb6adf8f9de; }, function (v) { return $62ebc2d74b7821db$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $62ebc2d74b7821db$export$b82d16f27459e05a; }, function (v) { return $62ebc2d74b7821db$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $62ebc2d74b7821db$export$522c17b4f5e123e8; }, function (v) { return $62ebc2d74b7821db$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $62ebc2d74b7821db$export$1aabd8a0274ecfd6; }, function (v) { return $62ebc2d74b7821db$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $62ebc2d74b7821db$export$9b621391a187a31a; }, function (v) { return $62ebc2d74b7821db$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $62ebc2d74b7821db$export$f5bbd400c2f4426f; }, function (v) { return $62ebc2d74b7821db$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $62ebc2d74b7821db$export$2b8d127b894957b9;
var $62ebc2d74b7821db$export$cea3a54a6425200c;
var $62ebc2d74b7821db$export$a7c73072b1a182ae;
var $62ebc2d74b7821db$export$9f27bc3417b4524d;
var $62ebc2d74b7821db$export$db77ccec0bb4ccac;
var $62ebc2d74b7821db$export$8392c0c9d3dcbd35;
var $62ebc2d74b7821db$export$ffb0004e005737fa;
var $62ebc2d74b7821db$export$b624eff549462981;
var $62ebc2d74b7821db$export$7897aa7841a5380c;
var $62ebc2d74b7821db$export$602eac185826482c;
var $62ebc2d74b7821db$export$e2c29f18771995cb;
var $62ebc2d74b7821db$export$5f8d39834fd61797;
var $62ebc2d74b7821db$export$74bf444e3cd11ea5;
var $62ebc2d74b7821db$export$92387174baf9b227;
var $62ebc2d74b7821db$export$ec112efeb987d9c6;
var $62ebc2d74b7821db$export$b706b080d889d2c9;
var $62ebc2d74b7821db$export$5be5a87408f70ddc;
var $62ebc2d74b7821db$export$45a5e7f76e0caa8d;
var $62ebc2d74b7821db$export$455c2e768291efa6;
var $62ebc2d74b7821db$export$9522e17588c12572;
var $62ebc2d74b7821db$export$2110ac352bb060b9;
var $62ebc2d74b7821db$export$56885ab8b9c456ab;
var $62ebc2d74b7821db$export$d927fcb6adf8f9de;
var $62ebc2d74b7821db$export$b82d16f27459e05a;
var $62ebc2d74b7821db$export$522c17b4f5e123e8;
var $62ebc2d74b7821db$export$1aabd8a0274ecfd6;
var $62ebc2d74b7821db$export$9b621391a187a31a;
var $62ebc2d74b7821db$export$f5bbd400c2f4426f;
'use strict';
(function() {
    'use strict';
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
    function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $62ebc2d74b7821db$export$2b8d127b894957b9 = AsyncMode;
    $62ebc2d74b7821db$export$cea3a54a6425200c = ConcurrentMode;
    $62ebc2d74b7821db$export$a7c73072b1a182ae = ContextConsumer;
    $62ebc2d74b7821db$export$9f27bc3417b4524d = ContextProvider;
    $62ebc2d74b7821db$export$db77ccec0bb4ccac = Element;
    $62ebc2d74b7821db$export$8392c0c9d3dcbd35 = ForwardRef;
    $62ebc2d74b7821db$export$ffb0004e005737fa = Fragment;
    $62ebc2d74b7821db$export$b624eff549462981 = Lazy;
    $62ebc2d74b7821db$export$7897aa7841a5380c = Memo;
    $62ebc2d74b7821db$export$602eac185826482c = Portal;
    $62ebc2d74b7821db$export$e2c29f18771995cb = Profiler;
    $62ebc2d74b7821db$export$5f8d39834fd61797 = StrictMode;
    $62ebc2d74b7821db$export$74bf444e3cd11ea5 = Suspense;
    $62ebc2d74b7821db$export$92387174baf9b227 = isAsyncMode;
    $62ebc2d74b7821db$export$ec112efeb987d9c6 = isConcurrentMode;
    $62ebc2d74b7821db$export$b706b080d889d2c9 = isContextConsumer;
    $62ebc2d74b7821db$export$5be5a87408f70ddc = isContextProvider;
    $62ebc2d74b7821db$export$45a5e7f76e0caa8d = isElement;
    $62ebc2d74b7821db$export$455c2e768291efa6 = isForwardRef;
    $62ebc2d74b7821db$export$9522e17588c12572 = isFragment;
    $62ebc2d74b7821db$export$2110ac352bb060b9 = isLazy;
    $62ebc2d74b7821db$export$56885ab8b9c456ab = isMemo;
    $62ebc2d74b7821db$export$d927fcb6adf8f9de = isPortal;
    $62ebc2d74b7821db$export$b82d16f27459e05a = isProfiler;
    $62ebc2d74b7821db$export$522c17b4f5e123e8 = isStrictMode;
    $62ebc2d74b7821db$export$1aabd8a0274ecfd6 = isSuspense;
    $62ebc2d74b7821db$export$9b621391a187a31a = isValidElementType;
    $62ebc2d74b7821db$export$f5bbd400c2f4426f = typeOf;
})();

});




parcelRegister("dyr1f", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $eDnaA = parcelRequire("eDnaA");
// By explicitly using `prop-types` you are opting into new development behavior.
// http://fb.me/prop-types-in-prod
var $9de368c94eeeeccf$var$throwOnDirectAccess = true;

module.exports = (parcelRequire("hp7CS"))($eDnaA.isElement, $9de368c94eeeeccf$var$throwOnDirectAccess);

});
parcelRegister("eDnaA", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gb5re"));

});
parcelRegister("gb5re", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $bc71e455a4e717ee$export$2b8d127b894957b9; }, function (v) { return $bc71e455a4e717ee$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $bc71e455a4e717ee$export$cea3a54a6425200c; }, function (v) { return $bc71e455a4e717ee$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $bc71e455a4e717ee$export$a7c73072b1a182ae; }, function (v) { return $bc71e455a4e717ee$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $bc71e455a4e717ee$export$9f27bc3417b4524d; }, function (v) { return $bc71e455a4e717ee$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $bc71e455a4e717ee$export$db77ccec0bb4ccac; }, function (v) { return $bc71e455a4e717ee$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $bc71e455a4e717ee$export$8392c0c9d3dcbd35; }, function (v) { return $bc71e455a4e717ee$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $bc71e455a4e717ee$export$ffb0004e005737fa; }, function (v) { return $bc71e455a4e717ee$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $bc71e455a4e717ee$export$b624eff549462981; }, function (v) { return $bc71e455a4e717ee$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $bc71e455a4e717ee$export$7897aa7841a5380c; }, function (v) { return $bc71e455a4e717ee$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $bc71e455a4e717ee$export$602eac185826482c; }, function (v) { return $bc71e455a4e717ee$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $bc71e455a4e717ee$export$e2c29f18771995cb; }, function (v) { return $bc71e455a4e717ee$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $bc71e455a4e717ee$export$5f8d39834fd61797; }, function (v) { return $bc71e455a4e717ee$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $bc71e455a4e717ee$export$74bf444e3cd11ea5; }, function (v) { return $bc71e455a4e717ee$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $bc71e455a4e717ee$export$92387174baf9b227; }, function (v) { return $bc71e455a4e717ee$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $bc71e455a4e717ee$export$ec112efeb987d9c6; }, function (v) { return $bc71e455a4e717ee$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $bc71e455a4e717ee$export$b706b080d889d2c9; }, function (v) { return $bc71e455a4e717ee$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $bc71e455a4e717ee$export$5be5a87408f70ddc; }, function (v) { return $bc71e455a4e717ee$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $bc71e455a4e717ee$export$45a5e7f76e0caa8d; }, function (v) { return $bc71e455a4e717ee$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $bc71e455a4e717ee$export$455c2e768291efa6; }, function (v) { return $bc71e455a4e717ee$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $bc71e455a4e717ee$export$9522e17588c12572; }, function (v) { return $bc71e455a4e717ee$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $bc71e455a4e717ee$export$2110ac352bb060b9; }, function (v) { return $bc71e455a4e717ee$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $bc71e455a4e717ee$export$56885ab8b9c456ab; }, function (v) { return $bc71e455a4e717ee$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $bc71e455a4e717ee$export$d927fcb6adf8f9de; }, function (v) { return $bc71e455a4e717ee$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $bc71e455a4e717ee$export$b82d16f27459e05a; }, function (v) { return $bc71e455a4e717ee$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $bc71e455a4e717ee$export$522c17b4f5e123e8; }, function (v) { return $bc71e455a4e717ee$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $bc71e455a4e717ee$export$1aabd8a0274ecfd6; }, function (v) { return $bc71e455a4e717ee$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $bc71e455a4e717ee$export$9b621391a187a31a; }, function (v) { return $bc71e455a4e717ee$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $bc71e455a4e717ee$export$f5bbd400c2f4426f; }, function (v) { return $bc71e455a4e717ee$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bc71e455a4e717ee$export$2b8d127b894957b9;
var $bc71e455a4e717ee$export$cea3a54a6425200c;
var $bc71e455a4e717ee$export$a7c73072b1a182ae;
var $bc71e455a4e717ee$export$9f27bc3417b4524d;
var $bc71e455a4e717ee$export$db77ccec0bb4ccac;
var $bc71e455a4e717ee$export$8392c0c9d3dcbd35;
var $bc71e455a4e717ee$export$ffb0004e005737fa;
var $bc71e455a4e717ee$export$b624eff549462981;
var $bc71e455a4e717ee$export$7897aa7841a5380c;
var $bc71e455a4e717ee$export$602eac185826482c;
var $bc71e455a4e717ee$export$e2c29f18771995cb;
var $bc71e455a4e717ee$export$5f8d39834fd61797;
var $bc71e455a4e717ee$export$74bf444e3cd11ea5;
var $bc71e455a4e717ee$export$92387174baf9b227;
var $bc71e455a4e717ee$export$ec112efeb987d9c6;
var $bc71e455a4e717ee$export$b706b080d889d2c9;
var $bc71e455a4e717ee$export$5be5a87408f70ddc;
var $bc71e455a4e717ee$export$45a5e7f76e0caa8d;
var $bc71e455a4e717ee$export$455c2e768291efa6;
var $bc71e455a4e717ee$export$9522e17588c12572;
var $bc71e455a4e717ee$export$2110ac352bb060b9;
var $bc71e455a4e717ee$export$56885ab8b9c456ab;
var $bc71e455a4e717ee$export$d927fcb6adf8f9de;
var $bc71e455a4e717ee$export$b82d16f27459e05a;
var $bc71e455a4e717ee$export$522c17b4f5e123e8;
var $bc71e455a4e717ee$export$1aabd8a0274ecfd6;
var $bc71e455a4e717ee$export$9b621391a187a31a;
var $bc71e455a4e717ee$export$f5bbd400c2f4426f;
'use strict';
(function() {
    'use strict';
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
    function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $bc71e455a4e717ee$export$2b8d127b894957b9 = AsyncMode;
    $bc71e455a4e717ee$export$cea3a54a6425200c = ConcurrentMode;
    $bc71e455a4e717ee$export$a7c73072b1a182ae = ContextConsumer;
    $bc71e455a4e717ee$export$9f27bc3417b4524d = ContextProvider;
    $bc71e455a4e717ee$export$db77ccec0bb4ccac = Element;
    $bc71e455a4e717ee$export$8392c0c9d3dcbd35 = ForwardRef;
    $bc71e455a4e717ee$export$ffb0004e005737fa = Fragment;
    $bc71e455a4e717ee$export$b624eff549462981 = Lazy;
    $bc71e455a4e717ee$export$7897aa7841a5380c = Memo;
    $bc71e455a4e717ee$export$602eac185826482c = Portal;
    $bc71e455a4e717ee$export$e2c29f18771995cb = Profiler;
    $bc71e455a4e717ee$export$5f8d39834fd61797 = StrictMode;
    $bc71e455a4e717ee$export$74bf444e3cd11ea5 = Suspense;
    $bc71e455a4e717ee$export$92387174baf9b227 = isAsyncMode;
    $bc71e455a4e717ee$export$ec112efeb987d9c6 = isConcurrentMode;
    $bc71e455a4e717ee$export$b706b080d889d2c9 = isContextConsumer;
    $bc71e455a4e717ee$export$5be5a87408f70ddc = isContextProvider;
    $bc71e455a4e717ee$export$45a5e7f76e0caa8d = isElement;
    $bc71e455a4e717ee$export$455c2e768291efa6 = isForwardRef;
    $bc71e455a4e717ee$export$9522e17588c12572 = isFragment;
    $bc71e455a4e717ee$export$2110ac352bb060b9 = isLazy;
    $bc71e455a4e717ee$export$56885ab8b9c456ab = isMemo;
    $bc71e455a4e717ee$export$d927fcb6adf8f9de = isPortal;
    $bc71e455a4e717ee$export$b82d16f27459e05a = isProfiler;
    $bc71e455a4e717ee$export$522c17b4f5e123e8 = isStrictMode;
    $bc71e455a4e717ee$export$1aabd8a0274ecfd6 = isSuspense;
    $bc71e455a4e717ee$export$9b621391a187a31a = isValidElementType;
    $bc71e455a4e717ee$export$f5bbd400c2f4426f = typeOf;
})();

});


parcelRegister("hp7CS", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $eDnaA = parcelRequire("eDnaA");

var $7ItS5 = parcelRequire("7ItS5");

var $gIIXx = parcelRequire("gIIXx");

var $81caI = parcelRequire("81caI");

var $4b13q = parcelRequire("4b13q");
var $cabaafd44b338383$var$printWarning = function() {};
$cabaafd44b338383$var$printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
function $cabaafd44b338383$var$emptyFunctionThatReturnsNull() {
    return null;
}
module.exports = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === 'function') return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = '<<anonymous>>';
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bigint: createPrimitiveTypeChecker('bigint'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === 'object' ? data : {};
        this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== $gIIXx) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = 'Invariant Violation';
                    throw err;
                } else if (typeof console !== 'undefined') {
                    // Old behavior for people using React.PropTypes
                    var cacheKey = componentName + ':' + propName;
                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                    manualPropTypeWarningCount < 3) {
                        $cabaafd44b338383$var$printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
                        manualPropTypeCallCache[cacheKey] = true;
                        manualPropTypeWarningCount++;
                    }
                }
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
                    expectedType: expectedType
                });
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker($cabaafd44b338383$var$emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', $gIIXx);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!$eDnaA.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
            {
                if (arguments.length > 1) $cabaafd44b338383$var$printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
                else $cabaafd44b338383$var$printWarning('Invalid argument supplied to oneOf, expected an array.');
            }
            return $cabaafd44b338383$var$emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === 'symbol') return String(value);
                return value;
            });
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
            for(var key in propValue)if ($81caI(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, $gIIXx);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
            $cabaafd44b338383$var$printWarning('Invalid argument supplied to oneOfType, expected an instance of array.');
            return $cabaafd44b338383$var$emptyFunctionThatReturnsNull;
        }
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== 'function') {
                $cabaafd44b338383$var$printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
                return $cabaafd44b338383$var$emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, $gIIXx);
                if (checkerResult == null) return null;
                if (checkerResult.data && $81caI(checkerResult.data, 'expectedType')) expectedTypes.push(checkerResult.data.expectedType);
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $gIIXx);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            // We need to check all keys in case some are required but missing from props.
            var allKeys = $7ItS5({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if ($81caI(shapeTypes, key) && typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                if (!checker) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $gIIXx);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case 'number':
            case 'string':
            case 'undefined':
                return true;
            case 'boolean':
                return !propValue;
            case 'object':
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue['@@toStringTag'] === 'Symbol') return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === 'function' && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return 'array';
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
        if (isSymbol(propType, propValue)) return 'symbol';
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) return '' + propValue;
        var propType = getPropType(propValue);
        if (propType === 'object') {
            if (propValue instanceof Date) return 'date';
            else if (propValue instanceof RegExp) return 'regexp';
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case 'array':
            case 'object':
                return 'an ' + type;
            case 'boolean':
            case 'date':
            case 'regexp':
                return 'a ' + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = $4b13q;
    ReactPropTypes.resetWarningCache = $4b13q.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("7ItS5", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $59e3d0504ae72d7d$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $59e3d0504ae72d7d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $59e3d0504ae72d7d$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $59e3d0504ae72d7d$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $59e3d0504ae72d7d$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $59e3d0504ae72d7d$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $59e3d0504ae72d7d$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($59e3d0504ae72d7d$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($59e3d0504ae72d7d$var$getOwnPropertySymbols) {
            symbols = $59e3d0504ae72d7d$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($59e3d0504ae72d7d$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("gIIXx", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $c2c3a15cce962901$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $c2c3a15cce962901$var$ReactPropTypesSecret;

});

parcelRegister("81caI", function(module, exports) {
module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

});

parcelRegister("4b13q", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $30a901dea44bb587$var$printWarning = function() {};

var $gIIXx = parcelRequire("gIIXx");
var $30a901dea44bb587$var$loggedTypeFailures = {};

var $81caI = parcelRequire("81caI");
$30a901dea44bb587$var$printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function $30a901dea44bb587$var$checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    for(var typeSpecName in typeSpecs)if ($81caI(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                err.name = 'Invariant Violation';
                throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, $gIIXx);
        } catch (ex) {
            error = ex;
        }
        if (error && !(error instanceof Error)) $30a901dea44bb587$var$printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        if (error instanceof Error && !(error.message in $30a901dea44bb587$var$loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            $30a901dea44bb587$var$loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            $30a901dea44bb587$var$printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
    }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ $30a901dea44bb587$var$checkPropTypes.resetWarningCache = function() {
    $30a901dea44bb587$var$loggedTypeFailures = {};
};
module.exports = $30a901dea44bb587$var$checkPropTypes;

});



parcelRegister("8Fliv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $64f2ac4daf3bd4b6$export$2e2bcd8739ae039; });

var $9DW5B = parcelRequire("9DW5B");
// eslint-disable-next-line no-undef
var $64f2ac4daf3bd4b6$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $64f2ac4daf3bd4b6$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9DW5B.default)(function(prop) {
    return $64f2ac4daf3bd4b6$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("9DW5B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7054d0eec6690cbd$export$2e2bcd8739ae039; });
function $7054d0eec6690cbd$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("herDu", function(module, exports) {

$parcel$export(module.exports, "observable", function () { return observable; });
$parcel$export(module.exports, "computed", function () { return computed; });
$parcel$export(module.exports, "getDependencyTree", function () { return getDependencyTree; });
$parcel$export(module.exports, "Reaction", function () { return Reaction; });
$parcel$export(module.exports, "action", function () { return action; });
$parcel$export(module.exports, "configure", function () { return configure; });
$parcel$export(module.exports, "makeObservable", function () { return makeObservable; });
$parcel$export(module.exports, "runInAction", function () { return runInAction; });
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = niceErrors;
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e = typeof error === "string" ? error : errors[error];
    if (typeof e === "function") e = e.apply(null, args);
    throw new Error("[MobX] " + e);
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("`Proxy` objects are not available in the current environment. Please configure MobX to enable a fallback implementation.`");
}
function warnAboutProxyRequirement(msg) {
    if (globalState.verifyProxies) die("MobX is currently configured to be able to run in ES5 mode, but in ES5 MobX won't be able to " + msg);
}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function isPlainES6Map(thing) {
    var mapProto = Object.getPrototypeOf(thing);
    var objectProto = Object.getPrototypeOf(mapProto);
    var nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _construct(t, e, r) {
    if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && _setPrototypeOf(p, r.prototype), p;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function() {
        return !!t;
    })();
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return _wrapNativeSuper = function(t) {
        if (null === t || !_isNativeFunction(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return _construct(t, arguments, _getPrototypeOf(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), _setPrototypeOf(Wrapper, t);
    }, _wrapNativeSuper(t);
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    // @override must override something
    if (isOverride(annotation) && !hasProp(prototype[storedAnnotationsSymbol], key)) {
        var fieldName = prototype.constructor.name + ".prototype." + key.toString();
        die("'" + fieldName + "' is decorated with 'override', " + "but no such decorated member was found on prototype.");
    }
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    if (!isOverride(annotation) && hasProp(prototype[storedAnnotationsSymbol], key)) {
        var fieldName = prototype.constructor.name + ".prototype." + key.toString();
        var currentAnnotationType = prototype[storedAnnotationsSymbol][key].annotationType_;
        var requestedAnnotationType = annotation.annotationType_;
        die("Cannot apply '@" + requestedAnnotationType + "' to '" + fieldName + "':" + ("\nThe field is already decorated with '@" + currentAnnotationType + "'.") + "\nRe-decorating fields is not allowed." + "\nUse '@override' decorator for methods overridden by subclass.");
    }
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {
    if (!types.includes(context.kind)) die("The decorator applied to '" + String(context.name) + "' cannot be used on a " + context.kind + " element");
}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom@" + getNextId();
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    };
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return _createClass(Atom, [
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, Atom.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
    die("The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (isObservable(v)) die("observable.struct should not be used with observable values");
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    // Must not be plain object
    if (adm.isPlainObject_) die("Cannot apply '" + this.annotationType_ + "' to '" + adm.name_ + "." + key.toString() + "':" + ("\n'" + this.annotationType_ + "' cannot be used on plain objects."));
    // Must override something
    if (!hasProp(adm.appliedAnnotations_, key)) die("'" + adm.name_ + "." + key.toString() + "' is annotated with '" + this.annotationType_ + "', " + "but no such annotated member was found on prototype.");
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    assert20223DecoratorType(context, [
        "method",
        "field"
    ]);
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        var mthd = initMthd;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            mthd = mthd.bind(this);
            mthd.isMobxAction = true;
        }
        return mthd;
    };
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
    if (!isFunction(value)) die("Cannot apply '" + annotationType_ + "' to '" + adm.name_ + "." + key.toString() + "':" + ("\n'" + annotationType_ + "' can only be used on properties with a function value."));
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    assert20223DecoratorType(context, [
        "method"
    ]);
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
    if (!isFunction(value)) die("Cannot apply '" + annotationType_ + "' to '" + adm.name_ + "." + key.toString() + "':" + ("\n'" + annotationType_ + "' can only be used on properties with a generator function value."));
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    assert20223DecoratorType(context, [
        "getter"
    ]);
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    var computedValues;
    // Defer ComputedValue creation until first access — avoids allocating
    // ComputedValues for getters that are never read on a given instance.
    // The factory is materialised by ObservableObjectAdministration on demand.
    function createComputedValue(target, adm) {
        var options = _extends({}, ann.options_, {
            get: get,
            context: target
        });
        options.name || (options.name = adm.name_ + "." + key.toString());
        return new ComputedValue(options);
    }
    addInitializer(function() {
        var _adm$lazyComputedKeys;
        var adm = asObservableObject(this)[$mobx];
        var target = this;
        var observable = adm.values_.get(key);
        if (observable instanceof ComputedValue && observable.derivation !== get) adm.values_["delete"](key);
        ((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null ? _adm$lazyComputedKeys : adm.lazyComputedKeys_ = new Map()).set(key, function() {
            return createComputedValue(target, adm);
        });
    });
    return function() {
        var adm = this[$mobx];
        var observable = adm.values_.get(key);
        if (observable instanceof ComputedValue && observable.derivation !== get) {
            var _computedValues;
            var computed = (_computedValues = computedValues) == null ? void 0 : _computedValues.get(this);
            if (!computed) {
                var _computedValues2;
                computed = createComputedValue(this, adm);
                ((_computedValues2 = computedValues) != null ? _computedValues2 : computedValues = new WeakMap()).set(this, computed);
            }
            return computed.get();
        }
        return adm.getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
    if (!get) die("Cannot apply '" + annotationType_ + "' to '" + adm.name_ + "." + key.toString() + "':" + ("\n'" + annotationType_ + "' can only be used on getter(+setter) properties."));
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    if (context.kind === "field") throw die("Please use `@observable accessor " + String(context.name) + "` instead of `@observable " + String(context.name) + "`");
    assert20223DecoratorType(context, [
        "accessor"
    ]);
    var ann = this;
    var kind = context.kind, name = context.name;
    if (kind !== "accessor") return;
    // Defer ObservableValue construction until first access. The factory is
    // materialised by ObservableObjectAdministration on demand, so unused
    // fields on wide classes never pay the per-instance allocation cost.
    function registerLazy(target, value) {
        var _adm$lazyObservableKe;
        var adm = asObservableObject(target)[$mobx];
        ((_adm$lazyObservableKe = adm.lazyObservableKeys_) != null ? _adm$lazyObservableKe : adm.lazyObservableKeys_ = new Map()).set(name, function() {
            var _ann$options_$enhance, _ann$options_;
            return new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, adm.name_ + "." + name.toString(), false);
        });
        return adm;
    }
    return {
        get: function get() {
            var _this$$mobx;
            var adm = (_this$$mobx = this[$mobx]) != null ? _this$$mobx : registerLazy(this, desc.get.call(this));
            return adm.getObservablePropValue_(name);
        },
        set: function set(value) {
            var _this$$mobx2;
            var adm = (_this$$mobx2 = this[$mobx]) != null ? _this$$mobx2 : registerLazy(this, value);
            return adm.setObservablePropValue_(name, value);
        },
        init: function init(value) {
            registerLazy(this, value);
            return value;
        }
    };
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
    if (!("value" in descriptor)) die("Cannot apply '" + annotationType_ + "' to '" + adm.name_ + "." + key.toString() + "':" + ("\n'" + annotationType_ + "' cannot be used on getter/setter properties"));
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = isAction(descriptor.set) ? descriptor.set // See #4553
         : createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    if (!isFunction(arg1)) die("First argument to `computed` should be an expression.");
    if (isFunction(arg2)) die("A setter as second argument is no longer supported, use `{ set: fn }` option instead");
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    if (!isFunction(fn)) die("`action` can only be invoked on functions");
    if (typeof actionName !== "string" || !actionName) die("actions should have valid names, got: '" + actionName + "'");
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = isSpyEnabled() && !!actionName;
    var startTime_ = 0;
    if (notifySpy_) {
        startTime_ = Date.now();
        var flattenedArgs = args ? Array.from(args) : EMPTY_ARRAY;
        spyReportStart({
            type: ACTION,
            name: actionName,
            object: scope,
            arguments: flattenedArgs
        });
    }
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    if (runInfo.notifySpy_) spyReportEnd({
        time: Date.now() - runInfo.startTime_
    });
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var CREATE = "create";
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue@" + getNextId();
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        if (notifySpy && isSpyEnabled()) {
            var _this$value_;
            // only notify spy if this is a stand-alone observable
            spyReport({
                type: CREATE,
                object: _this,
                observableKind: "value",
                debugObjectName: _this.name_,
                newValue: "" + ((_this$value_ = _this.value_) == null ? void 0 : _this$value_.toString())
            });
        }
        return _this;
    }
    _inheritsLoose(ObservableValue, _Atom);
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            if (notifySpy) spyReportStart({
                type: UPDATE,
                object: this,
                observableKind: "value",
                debugObjectName: this.name_,
                newValue: newValue,
                oldValue: oldValue
            });
            this.setNewValue_(newValue);
            if (notifySpy) spyReportEnd();
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /*#__PURE__*/ function() {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue@" + getNextId();
        if (options.set) this.setter_ = createAction(this.name_ + "-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) {
            this.value_ = newValue;
            if (isSpyEnabled()) spyReport({
                observableKind: "computed",
                debugObjectName: this.name_,
                object: this.scope_,
                type: "update",
                oldValue: oldValue,
                newValue: newValue
            });
        }
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
            if (this.isTracing_ !== TraceMode.NONE) console.log("[mobx.trace] Computed value '" + this.name_ + "' was suspended and it will recompute on the next access.");
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        if (this.isTracing_ !== TraceMode.NONE) console.log("[mobx.trace] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute.");
        if (typeof this.requiresReaction_ === "boolean" ? this.requiresReaction_ : globalState.computedRequiresReaction) console.warn("[mobx] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute.");
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers = atom.observers_.size > 0;
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!globalState.allowStateChanges && (hasObservers || globalState.enforceActions === "always")) console.warn("[MobX] " + (globalState.enforceActions ? "Since strict-mode is enabled, changing (observed) observable values without using an action is not allowed. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, a computed value or the render function of a React component? You can wrap side effects in 'runInAction' (or decorate functions with 'action') if needed. Tried to modify: ") + atom.name_);
}
function checkIfStateReadsAreAllowed(observable) {
    if (!globalState.allowStateReads && globalState.observableRequiresReaction) console.warn("[mobx] Observable '" + observable.name_ + "' being read outside a reactive context.");
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    if (derivation.observing_.length !== 0) return;
    if (typeof derivation.requiresObservable_ === "boolean" ? derivation.requiresObservable_ : globalState.reactionRequiresObservable) console.warn("[mobx] Derivation '" + derivation.name_ + "' is created/updated without reading any observable value.");
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue === 0) removeObserver(_dep, derivation);
        _dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue === 1) {
            _dep2.diffValue = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */ this.version = 6;
    /**
   * globally unique token to signal unchanged
   */ this.UNCHANGED = {};
    /**
   * Currently running derivation
   */ this.trackingDerivation = null;
    /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */ this.trackingContext = null;
    /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */ this.runId = 0;
    /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */ this.mobxGuid = 0;
    /**
   * Are we in a batch block? (and how many of them)
   */ this.inBatch = 0;
    /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */ this.pendingUnobservations = [];
    /**
   * List of scheduled, not yet executed, reactions.
   */ this.pendingReactions = [];
    /**
   * Are we currently processing reactions?
   */ this.isRunningReactions = false;
    /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */ this.allowStateChanges = false;
    /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */ this.allowStateReads = true;
    /**
   * If strict mode is enabled, state changes are by default not allowed
   */ this.enforceActions = true;
    /**
   * Spy callbacks
   */ this.spyListeners = [];
    /**
   * Globally attached error handlers that react specifically to errors in reactions
   */ this.globalReactionErrorHandlers = [];
    /**
   * Warn if computed values are accessed outside a reactive context
   */ this.computedRequiresReaction = false;
    /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */ this.reactionRequiresObservable = false;
    /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */ this.observableRequiresReaction = false;
    /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */ this.disableErrorBoundaries = false;
    /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */ this.suppressReactionErrors = false;
    this.useProxies = true;
    /*
   * print warnings about code that would fail if proxies weren't available
   */ this.verifyProxies = false;
    /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */ this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            if (d.isTracing_ !== TraceMode.NONE) logTraceInfo(d, observable);
            d.onBecomeStale_();
        }
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) {
            d.dependenciesState_ = IDerivationState_.STALE_;
            if (d.isTracing_ !== TraceMode.NONE) logTraceInfo(d, observable);
        } else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "\t".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction@" + getNextId();
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed) {
            startBatch();
            this.isScheduled = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                    if (this.isTrackPending && isSpyEnabled()) // onInvalidate didn't trigger track right away..
                    spyReport({
                        name: this.name_,
                        type: "scheduled-reaction"
                    });
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        if (notify) {
            startTime = Date.now();
            spyReportStart({
                name: this.name_,
                type: "reaction"
            });
        }
        this.isRunning = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        if (notify) spyReportEnd({
            time: Date.now() - startTime
        });
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
        else console.warn("[mobx] (error in reaction '" + this.name_ + "' suppressed, fix error of causing action below)");
         // prettier-ignore
        if (isSpyEnabled()) spyReport({
            type: "error",
            name: this.name_,
            message: message,
            error: "" + error
        });
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        if ("dispose" in Symbol && typeof Symbol.dispose === "symbol") dispose[Symbol.dispose] = dispose;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return _createClass(Reaction, [
        {
            key: "isDisposed",
            get: function get() {
                return getFlag(this.flags_, Reaction.isDisposedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
            }
        },
        {
            key: "isScheduled",
            get: function get() {
                return getFlag(this.flags_, Reaction.isScheduledMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
            }
        },
        {
            key: "isTrackPending",
            get: function get() {
                return getFlag(this.flags_, Reaction.isTrackPendingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return getFlag(this.flags_, Reaction.isRunningMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." + (" Probably there is a cycle in the reactive function: " + allReactions[0]));
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return !!globalState.spyListeners.length;
}
function spyReport(event) {
    if (!globalState.spyListeners.length) return;
    var listeners = globalState.spyListeners;
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](event);
}
function spyReportStart(event) {
    var change = _extends({}, event, {
        spyReportStart: true
    });
    spyReport(change);
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    if (change) spyReport(_extends({}, change, {
        type: "report-end",
        spyReportEnd: true
    }));
    else spyReport(END_EVENT);
}
function spy(listener) {
    globalState.spyListeners.push(listener);
    return once(function() {
        globalState.spyListeners = globalState.spyListeners.filter(function(l) {
            return l !== listener;
        });
    });
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
        die("Invalid arguments for `action`");
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    if (!isFunction(view)) die("Autorun expects a function as first argument");
    if (isAction(view)) die("Autorun does not accept actions since actions are untrackable");
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : view.name || "Autorun@" + getNextId();
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    if (!isFunction(expression) || !isFunction(effect)) die("First and second argument to reaction should be functions");
    if (!isPlainObject(opts)) die("Third argument of reactions should be an object");
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction@" + getNextId();
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (globalState.disableErrorBoundaries === true) console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled.");
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    if (arguments.length > 4) die("'extendObservable' expected 2-4 arguments");
    if (typeof target !== "object") die("'extendObservable' expects an object as first argument");
    if (isObservableMap(target)) die("'extendObservable' should not be used on maps, use map.merge instead");
    if (!isPlainObject(properties)) die("'extendObservable' only accepts plain objects as second argument");
    if (isObservable(properties) || isObservable(annotations)) die("Extending an object with another observable (object) is not supported");
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
var FlowCancellationError = /*#__PURE__*/ function(_Error) {
    function FlowCancellationError() {
        var _this;
        _this = _Error.call(this, "FLOW_CANCELLED") || this;
        Object.setPrototypeOf(_this, (this instanceof FlowCancellationError ? this.constructor : void 0).prototype);
        _this.name = "FlowCancellationError";
        return _this;
    }
    _inheritsLoose(FlowCancellationError, _Error);
    var _proto = FlowCancellationError.prototype;
    _proto.toString = function toString() {
        return "Error: " + this.message;
    };
    return FlowCancellationError;
}(/*#__PURE__*/ _wrapNativeSuper(Error));
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    // flow(fn)
    if (arguments.length !== 1) die("Flow expects single argument with generator function");
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) {
        if (!isStringish(propOrHandler)) return die("InterceptReads can only be used with a specific property, not with an object in general");
        target = getAdministration(thing, propOrHandler);
    } else return die("Expected observable map, object or array as first array");
    if (target.dehancer !== undefined) return die("An intercept reader was already established");
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    var _adm$lazyComputedKeys;
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    var adm = value[$mobx];
    if ((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null && _adm$lazyComputedKeys.has(property)) return true;
    if (!adm.values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    if (arguments.length > 1) return die("isComputed expects only 1 argument. Use isComputedProp to inspect the observability of a property");
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    if (!isStringish(propName)) return die("isComputed expected a property name as second argument");
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableMap(value) || isObservableArray(value)) return die("isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.");
        if (isObservableObject(value)) {
            var _adm$lazyComputedKeys, _adm$lazyObservableKe;
            var adm = value[$mobx];
            return adm.values_.has(property) || !!((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null && _adm$lazyComputedKeys.has(property)) || !!((_adm$lazyObservableKe = adm.lazyObservableKeys_) != null && _adm$lazyObservableKe.has(property));
        }
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    if (arguments.length !== 1) die("isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property");
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    if (!isStringish(propName)) return die("expected a property name as second argument");
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    if (options) die("toJS no longer supports options");
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint = false;
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (typeof args[args.length - 1] === "boolean") enterBreakPoint = args.pop();
    var derivation = getAtomFromArgs(args);
    if (!derivation) return die("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    if (derivation.isTracing_ === TraceMode.NONE) console.log("[mobx.trace] '" + derivation.name_ + "' tracing enabled");
    derivation.isTracing_ = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = opts.name || "When@" + getNextId();
    var effectAction = createAction(opts.name + "-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts && opts.onError) return die("the options 'onError' and 'promise' cannot be combined");
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        if (globalState.trackingDerivation) warnAboutProxyRequirement("detect new properties using the 'in' operator. Use 'has' from 'mobx' instead.");
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        if (!getAdm(target).values_.has(name)) warnAboutProxyRequirement("add a new observable property through direct assignment. Use 'set' from 'mobx' instead.");
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        warnAboutProxyRequirement("delete properties from an observable object. Use 'remove' from 'mobx' instead.");
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        warnAboutProxyRequirement("define property on an observable object. Use 'defineProperty' from 'mobx' instead.");
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        if (globalState.trackingDerivation) warnAboutProxyRequirement("iterate keys to detect added / removed properties. Use 'keys' from 'mobx' instead.");
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        if (annotations && target[storedAnnotationsSymbol]) die("makeObservable second arg must be nullish when using decorators. Mixing @decorator syntax with annotations is not supported.");
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    if (!isPlainObject(target) && !isPlainObject(Object.getPrototypeOf(target))) die("'makeAutoObservable' can only be used for classes that don't have a superclass");
    if (isObservableObject(target)) die("makeAutoObservable can only be used on objects not already made observable");
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray@" + getNextId();
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name + "[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        this.legacyMode_;
        var lengthDelta = newItems.length - deleteCount;
        this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        // The reason why this is on right hand side here (and not above), is this way the uglifier will drop it, but it won't
        // cause any runtime overhead in development mode without NODE_ENV set, unless spying is enabled
        if (notifySpy) spyReportStart(change);
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
        if (notifySpy) spyReportEnd();
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        if (notifySpy) spyReportStart(change);
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
        if (notifySpy) spyReportEnd();
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + this.values_.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    // since "this" is the real array we need to pass its proxy
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray@" + getNextId();
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/ function() {
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap@" + getNextId();
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom(_this.name_ + ".keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, this.name_ + "." + stringifyKey(key) + "?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            if (notifySpy) spyReportStart(_change);
             // TODO fix type
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            if (notifySpy) spyReportEnd();
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            if (notifySpy) spyReportStart(change);
             // TODO fix type
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
            if (notifySpy) spyReportEnd();
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, _this4.name_ + "." + stringifyKey(key), false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notifySpy) spyReportStart(change);
         // TODO fix type
        if (notify) notifyListeners(this, change);
        if (notifySpy) spyReportEnd();
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.getOrInsert = function getOrInsert(key, value) {
        if (!this.has(key)) this.set(key, value);
        return this.get(key);
    };
    _proto.getOrInsertComputed = function getOrInsertComputed(key, callback) {
        if (!this.has(key)) this.set(key, callback(key));
        return this.get(key);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[Symbol.iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    };
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (!isPlainES6Map(other)) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === true) die("`observe` doesn't support fireImmediately=true in combination with maps.");
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    return _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function makeIterableForMap(iterator) {
    iterator[Symbol.toStringTag] = "MapIterator";
    return makeIterable(iterator);
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet@" + getNextId();
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
            // implemented reassignment same as it's done for ObservableMap
            value = change.newValue;
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notifySpy && true) spyReportStart(_change);
            if (notify) notifyListeners(this, _change);
            if (notifySpy && true) spyReportEnd();
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            if (notifySpy && true) spyReportStart(_change2);
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            if (notifySpy && true) spyReportEnd();
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var values = this.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next = values.next(), value = _values$next.value, done = _values$next.done;
                return !done ? {
                    value: [
                        value,
                        value
                    ],
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var values = this.data_.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next2 = values.next(), value = _values$next2.value, done = _values$next2.done;
                return !done ? {
                    value: self1.dehanceValue_(value),
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.intersection = function intersection(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.intersection(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    };
    _proto.union = function union(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.union(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    };
    _proto.difference = function difference(otherSet) {
        return new Set(this).difference(otherSet);
    };
    _proto.symmetricDifference = function symmetricDifference(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.symmetricDifference(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    };
    _proto.isSubsetOf = function isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    };
    _proto.isSupersetOf = function isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    };
    _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        // ... 'fireImmediately' could also be true?
        if (fireImmediately === true) die("`observe` doesn't support fireImmediately=true in combination with sets.");
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[Symbol.iterator] = function() {
        return this.values();
    };
    return _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Set";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
function makeIterableForSet(iterator) {
    iterator[Symbol.toStringTag] = "SetIterator";
    return makeIterable(iterator);
}
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.lazyComputedKeys_ = void 0;
        this.lazyObservableKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom(this.name_ + ".keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
        if (!isAnnotation(this.defaultAnnotation_)) die("defaultAnnotation must be valid annotation");
        // Prepare structure for tracking which fields were already annotated
        this.appliedAnnotations_ = {};
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        var _ref, _this$values_$get;
        // Hot path: single map lookup. Lazy entries (rare) take the materialise branch.
        var observable = (_ref = (_this$values_$get = this.values_.get(key)) != null ? _this$values_$get : this.materializeLazyComputed_(key)) != null ? _ref : this.materializeLazyObservable_(key);
        return observable.get();
    };
    _proto.materializeLazyComputed_ = function materializeLazyComputed_(key) {
        var _this$lazyComputedKey;
        var factory = (_this$lazyComputedKey = this.lazyComputedKeys_) == null ? void 0 : _this$lazyComputedKey.get(key);
        if (!factory) return undefined;
        this.lazyComputedKeys_["delete"](key);
        if (this.lazyComputedKeys_.size === 0) this.lazyComputedKeys_ = undefined;
        var computed = factory();
        this.values_.set(key, computed);
        return computed;
    };
    _proto.materializeLazyObservable_ = function materializeLazyObservable_(key) {
        var _this$lazyObservableK;
        var factory = (_this$lazyObservableK = this.lazyObservableKeys_) == null ? void 0 : _this$lazyObservableK.get(key);
        if (!factory) return undefined;
        this.lazyObservableKeys_["delete"](key);
        if (this.lazyObservableKeys_.size === 0) this.lazyObservableKeys_ = undefined;
        var observable = factory();
        this.values_.set(key, observable);
        return observable;
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var _ref2, _this$values_$get2;
        var observable = (_ref2 = (_this$values_$get2 = this.values_.get(key)) != null ? _this$values_$get2 : this.materializeLazyComputed_(key)) != null ? _ref2 : this.materializeLazyObservable_(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            if (notifySpy) spyReportStart(_change);
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
            if (notifySpy) spyReportEnd();
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    };
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, this.name_ + "." + stringifyKey(key) + "?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    };
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    };
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    };
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, this.name_ + "." + key.toString(), false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = this.name_ + "." + key.toString());
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            delete this.appliedAnnotations_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notifySpy) spyReportStart(_change2);
                if (notify) notifyListeners(this, _change2);
                if (notifySpy) spyReportEnd();
            }
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.observe_ = function observe_(callback, fireImmediately) {
        if (fireImmediately === true) die("`observe` doesn't support the fire immediately property for observable objects.");
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        var notify = hasListeners(this);
        var notifySpy = isSpyEnabled();
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notifySpy) spyReportStart(change);
            if (notify) notifyListeners(this, change);
            if (notifySpy) spyReportEnd();
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (options && isObservableObject(target)) die("Options can't be provided for already observable objects.");
    if (hasProp(target, $mobx)) {
        if (!(getAdministration(target) instanceof ObservableObjectAdministration)) die("Cannot convert '" + getDebugName(target) + "' into observable object:" + "\nThe target is already observable of different type." + "\nExtending builtins is not supported.");
        return target;
    }
    if (!Object.isExtensible(target)) die("Cannot make the designated object observable; it is not extensible");
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : (isPlainObject(target) ? "ObservableObject" : target.constructor.name) + "@" + getNextId();
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    adm.appliedAnnotations_[key] = annotation;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    // Valid annotation
    if (!isAnnotation(annotation)) die("Cannot annotate '" + adm.name_ + "." + key.toString() + "': Invalid annotation.");
    /*
  // Configurable, not sealed, not frozen
  // Possibly not needed, just a little better error then the one thrown by engine.
  // Cases where this would be useful the most (subclass field initializer) are not interceptable by this.
  if (__DEV__) {
      const configurable = getDescriptor(adm.target_, key)?.configurable
      const frozen = Object.isFrozen(adm.target_)
      const sealed = Object.isSealed(adm.target_)
      if (!configurable || frozen || sealed) {
          const fieldName = `${adm.name_}.${key.toString()}`
          const requestedAnnotationType = annotation.annotationType_
          let error = `Cannot apply '${requestedAnnotationType}' to '${fieldName}':`
          if (frozen) {
              error += `\nObject is frozen.`
          }
          if (sealed) {
              error += `\nObject is sealed.`
          }
          if (!configurable) {
              error += `\nproperty is not configurable.`
              // Mention only if caused by us to avoid confusion
              if (hasProp(adm.appliedAnnotations!, key)) {
                  error += `\nTo prevent accidental re-definition of a field by a subclass, `
                  error += `all annotated fields of non-plain objects (classes) are not configurable.`
              }
          }
          die(error)
      }
  }
  */ // Not annotated
    if (!isOverride(annotation) && hasProp(adm.appliedAnnotations_, key)) {
        var fieldName = adm.name_ + "." + key.toString();
        var currentAnnotationType = adm.appliedAnnotations_[key].annotationType_;
        var requestedAnnotationType = annotation.annotationType_;
        die("Cannot apply '" + requestedAnnotationType + "' to '" + fieldName + "':" + ("\nThe field is already annotated with '" + currentAnnotationType + "'.") + "\nRe-annotating fields is not allowed." + "\nUse 'override' annotation for methods overridden by subclass.");
    }
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray@" + getNextId();
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _this;
            addHiddenFinalProp(_this, $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_this, "0", ENTRY_0);
        });
        return _this;
    }
    _inheritsLoose(LegacyObservableArray, _StubArray);
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    return _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            var _ref, _adm$values_$get;
            if (!property) return die(26);
            var adm = thing[$mobx];
            var _observable = (_ref = (_adm$values_$get = adm.values_.get(property)) != null ? _adm$values_$get : adm.materializeLazyComputed_(property)) != null ? _ref : adm.materializeLazyObservable_(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Modified: "Deep compare objects" part to iterate over keys in forward order instead of reverse order.
//
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var _length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== _length) return false;
        for(var i = 0; i < _length; i++){
            // Deep compare each member
            var key = keys[i];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
var _global$Iterator;
// safely get iterator prototype if available
var global$1 = /*#__PURE__*/ getGlobal();
var maybeIteratorPrototype = ((_global$Iterator = global$1.Iterator) == null ? void 0 : _global$Iterator.prototype) || {};
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return Object.assign(Object.create(maybeIteratorPrototype), iterator);
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("9E7TZ", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $705dfaa51b6e104f$export$306c0aa65ff9ec16; }, function (v) { return $705dfaa51b6e104f$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $705dfaa51b6e104f$export$306c0aa65ff9ec16;
"use strict";

(function() {
    function is(x, y) {
        return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
    }
    function useSyncExternalStore$2(subscribe, getSnapshot) {
        didWarnOld18Alpha || void 0 === React.startTransition || (didWarnOld18Alpha = !0, console.error("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
        var value = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedValue = getSnapshot();
            objectIs(value, cachedValue) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), didWarnUncachedGetSnapshot = !0);
        }
        cachedValue = useState({
            inst: {
                value: value,
                getSnapshot: getSnapshot
            }
        });
        var inst = cachedValue[0].inst, forceUpdate = cachedValue[1];
        useLayoutEffect(function() {
            inst.value = value;
            inst.getSnapshot = getSnapshot;
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        }, [
            subscribe,
            value,
            getSnapshot
        ]);
        useEffect(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
            return subscribe(function() {
                checkIfSnapshotChanged(inst) && forceUpdate({
                    inst: inst
                });
            });
        }, [
            subscribe
        ]);
        useDebugValue(value);
        return value;
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        inst = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(inst, nextValue);
        } catch (error) {
            return !0;
        }
    }
    function useSyncExternalStore$1(subscribe, getSnapshot) {
        return getSnapshot();
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React = (parcelRequire("2xPiy")), objectIs = "function" === typeof Object.is ? Object.is : is, useState = React.useState, useEffect = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue = React.useDebugValue, didWarnOld18Alpha = !1, didWarnUncachedGetSnapshot = !1, shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
    $705dfaa51b6e104f$export$306c0aa65ff9ec16 = void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});

parcelRegister("jjB6N", function(module, exports) {
/* eslint-env browser */ /**
 * This is the web browser implementation of `debug()`.
 */ exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (()=>{
    let warned = false;
    return ()=>{
        if (!warned) {
            warned = true;
            console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
        }
    };
})();
/**
 * Colors.
 */ exports.colors = [
    '#0000CC',
    '#0000FF',
    '#0033CC',
    '#0033FF',
    '#0066CC',
    '#0066FF',
    '#0099CC',
    '#0099FF',
    '#00CC00',
    '#00CC33',
    '#00CC66',
    '#00CC99',
    '#00CCCC',
    '#00CCFF',
    '#3300CC',
    '#3300FF',
    '#3333CC',
    '#3333FF',
    '#3366CC',
    '#3366FF',
    '#3399CC',
    '#3399FF',
    '#33CC00',
    '#33CC33',
    '#33CC66',
    '#33CC99',
    '#33CCCC',
    '#33CCFF',
    '#6600CC',
    '#6600FF',
    '#6633CC',
    '#6633FF',
    '#66CC00',
    '#66CC33',
    '#9900CC',
    '#9900FF',
    '#9933CC',
    '#9933FF',
    '#99CC00',
    '#99CC33',
    '#CC0000',
    '#CC0033',
    '#CC0066',
    '#CC0099',
    '#CC00CC',
    '#CC00FF',
    '#CC3300',
    '#CC3333',
    '#CC3366',
    '#CC3399',
    '#CC33CC',
    '#CC33FF',
    '#CC6600',
    '#CC6633',
    '#CC9900',
    '#CC9933',
    '#CCCC00',
    '#CCCC33',
    '#FF0000',
    '#FF0033',
    '#FF0066',
    '#FF0099',
    '#FF00CC',
    '#FF00FF',
    '#FF3300',
    '#FF3333',
    '#FF3366',
    '#FF3399',
    '#FF33CC',
    '#FF33FF',
    '#FF6600',
    '#FF6633',
    '#FF9900',
    '#FF9933',
    '#FFCC00',
    '#FFCC33'
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ // eslint-disable-next-line complexity
function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    let m;
    // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    // eslint-disable-next-line no-return-assign
    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && (m = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(m[1], 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);
    if (!this.useColors) return;
    const c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit');
    // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    let index = 0;
    let lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, (match)=>{
        if (match === '%%') return;
        index++;
        if (match === '%c') // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */ exports.log = console.debug || console.log || (()=>{});
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (namespaces) exports.storage.setItem('debug', namespaces);
        else exports.storage.removeItem('debug');
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    let r;
    try {
        r = exports.storage.getItem('debug') || exports.storage.getItem('DEBUG');
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    r;
    return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
        // The Browser also has localStorage in the global context.
        return localStorage;
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}

module.exports = (parcelRequire("aFCac"))(exports);
const { formatters } = module.exports;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (error) {
        return '[UnexpectedJSONParseError]: ' + error.message;
    }
};

});
parcelRegister("aFCac", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */ 
function $7c4b562d4971c24d$var$setup(env) {
    createDebug.debug = createDebug;
    createDebug.default = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = (parcelRequire("jRbES"));
    createDebug.destroy = destroy;
    Object.keys(env).forEach((key)=>{
        createDebug[key] = env[key];
    });
    /**
	* The currently active debug mode names, and names to skip.
	*/ createDebug.names = [];
    createDebug.skips = [];
    /**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/ createDebug.formatters = {};
    /**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/ function selectColor(namespace) {
        let hash = 0;
        for(let i = 0; i < namespace.length; i++){
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
        }
        return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;
    /**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/ function createDebug(namespace) {
        let prevTime;
        let enableOverride = null;
        let namespacesCache;
        let enabledCache;
        function debug(...args) {
            // Disabled?
            if (!debug.enabled) return;
            const self = debug;
            // Set `diff` timestamp
            const curr = Number(new Date());
            const ms = curr - (prevTime || curr);
            self.diff = ms;
            self.prev = prevTime;
            self.curr = curr;
            prevTime = curr;
            args[0] = createDebug.coerce(args[0]);
            if (typeof args[0] !== 'string') // Anything else let's inspect with %O
            args.unshift('%O');
            // Apply any `formatters` transformations
            let index = 0;
            args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format)=>{
                // If we encounter an escaped % then don't increase the array index
                if (match === '%%') return '%';
                index++;
                const formatter = createDebug.formatters[format];
                if (typeof formatter === 'function') {
                    const val = args[index];
                    match = formatter.call(self, val);
                    // Now we need to remove `args[index]` since it's inlined in the `format`
                    args.splice(index, 1);
                    index--;
                }
                return match;
            });
            // Apply env-specific formatting (colors, etc.)
            createDebug.formatArgs.call(self, args);
            const logFn = self.log || createDebug.log;
            logFn.apply(self, args);
        }
        debug.namespace = namespace;
        debug.useColors = createDebug.useColors();
        debug.color = createDebug.selectColor(namespace);
        debug.extend = extend;
        debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.
        Object.defineProperty(debug, 'enabled', {
            enumerable: true,
            configurable: false,
            get: ()=>{
                if (enableOverride !== null) return enableOverride;
                if (namespacesCache !== createDebug.namespaces) {
                    namespacesCache = createDebug.namespaces;
                    enabledCache = createDebug.enabled(namespace);
                }
                return enabledCache;
            },
            set: (v)=>{
                enableOverride = v;
            }
        });
        // Env-specific initialization logic for debug instances
        if (typeof createDebug.init === 'function') createDebug.init(debug);
        return debug;
    }
    function extend(namespace, delimiter) {
        const newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
        newDebug.log = this.log;
        return newDebug;
    }
    /**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/ function enable(namespaces) {
        createDebug.save(namespaces);
        createDebug.namespaces = namespaces;
        createDebug.names = [];
        createDebug.skips = [];
        const split = (typeof namespaces === 'string' ? namespaces : '').trim().replace(/\s+/g, ',').split(',').filter(Boolean);
        for (const ns of split)if (ns[0] === '-') createDebug.skips.push(ns.slice(1));
        else createDebug.names.push(ns);
    }
    /**
	 * Checks if the given string matches a namespace template, honoring
	 * asterisks as wildcards.
	 *
	 * @param {String} search
	 * @param {String} template
	 * @return {Boolean}
	 */ function matchesTemplate(search, template) {
        let searchIndex = 0;
        let templateIndex = 0;
        let starIndex = -1;
        let matchIndex = 0;
        while(searchIndex < search.length){
            if (templateIndex < template.length && (template[templateIndex] === search[searchIndex] || template[templateIndex] === '*')) {
                // Match character or proceed with wildcard
                if (template[templateIndex] === '*') {
                    starIndex = templateIndex;
                    matchIndex = searchIndex;
                    templateIndex++; // Skip the '*'
                } else {
                    searchIndex++;
                    templateIndex++;
                }
            } else if (starIndex !== -1) {
                // Backtrack to the last '*' and try to match more characters
                templateIndex = starIndex + 1;
                matchIndex++;
                searchIndex = matchIndex;
            } else return false; // No match
        }
        // Handle trailing '*' in template
        while(templateIndex < template.length && template[templateIndex] === '*')templateIndex++;
        return templateIndex === template.length;
    }
    /**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/ function disable() {
        const namespaces = [
            ...createDebug.names,
            ...createDebug.skips.map((namespace)=>'-' + namespace)
        ].join(',');
        createDebug.enable('');
        return namespaces;
    }
    /**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/ function enabled(name) {
        for (const skip of createDebug.skips){
            if (matchesTemplate(name, skip)) return false;
        }
        for (const ns of createDebug.names){
            if (matchesTemplate(name, ns)) return true;
        }
        return false;
    }
    /**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/ function coerce(val) {
        if (val instanceof Error) return val.stack || val.message;
        return val;
    }
    /**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/ function destroy() {
        console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
    }
    createDebug.enable(createDebug.load());
    return createDebug;
}
module.exports = $7c4b562d4971c24d$var$setup;

});
parcelRegister("jRbES", function(module, exports) {
/**
 * Helpers.
 */ var $e74c02a89aa1b8e0$var$s = 1000;
var $e74c02a89aa1b8e0$var$m = $e74c02a89aa1b8e0$var$s * 60;
var $e74c02a89aa1b8e0$var$h = $e74c02a89aa1b8e0$var$m * 60;
var $e74c02a89aa1b8e0$var$d = $e74c02a89aa1b8e0$var$h * 24;
var $e74c02a89aa1b8e0$var$w = $e74c02a89aa1b8e0$var$d * 7;
var $e74c02a89aa1b8e0$var$y = $e74c02a89aa1b8e0$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $e74c02a89aa1b8e0$var$parse(val);
    else if (type === 'number' && isFinite(val)) return options.long ? $e74c02a89aa1b8e0$var$fmtLong(val) : $e74c02a89aa1b8e0$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $e74c02a89aa1b8e0$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $e74c02a89aa1b8e0$var$y;
        case 'weeks':
        case 'week':
        case 'w':
            return n * $e74c02a89aa1b8e0$var$w;
        case 'days':
        case 'day':
        case 'd':
            return n * $e74c02a89aa1b8e0$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $e74c02a89aa1b8e0$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $e74c02a89aa1b8e0$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $e74c02a89aa1b8e0$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $e74c02a89aa1b8e0$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $e74c02a89aa1b8e0$var$d) return Math.round(ms / $e74c02a89aa1b8e0$var$d) + 'd';
    if (msAbs >= $e74c02a89aa1b8e0$var$h) return Math.round(ms / $e74c02a89aa1b8e0$var$h) + 'h';
    if (msAbs >= $e74c02a89aa1b8e0$var$m) return Math.round(ms / $e74c02a89aa1b8e0$var$m) + 'm';
    if (msAbs >= $e74c02a89aa1b8e0$var$s) return Math.round(ms / $e74c02a89aa1b8e0$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $e74c02a89aa1b8e0$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $e74c02a89aa1b8e0$var$d) return $e74c02a89aa1b8e0$var$plural(ms, msAbs, $e74c02a89aa1b8e0$var$d, 'day');
    if (msAbs >= $e74c02a89aa1b8e0$var$h) return $e74c02a89aa1b8e0$var$plural(ms, msAbs, $e74c02a89aa1b8e0$var$h, 'hour');
    if (msAbs >= $e74c02a89aa1b8e0$var$m) return $e74c02a89aa1b8e0$var$plural(ms, msAbs, $e74c02a89aa1b8e0$var$m, 'minute');
    if (msAbs >= $e74c02a89aa1b8e0$var$s) return $e74c02a89aa1b8e0$var$plural(ms, msAbs, $e74c02a89aa1b8e0$var$s, 'second');
    return ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $e74c02a89aa1b8e0$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

});



parcelRegister("3YqNT", function(module, exports) {
module.exports = JSON.parse("{\"button\":{\"busy\":\"button is in a busy state\",\"success\":\"button action succeeded\"},\"calendar\":{\"previousMove\":\"Moved to {date}\",\"previous\":\"Go to {date}\",\"nextMove\":\"Moved to {date}\",\"next\":\"Go to {date}\"},\"cards\":{\"moved\":\"Card moved to position {source} of {target}\",\"reorderHint\":\"Use arrow keys to reorder cards. Changes are applied immediately.\",\"description\":\"sortable card\"},\"carousel\":{\"previous\":\"Go to slide {slide}\",\"next\":\"Go to slide {slide}\",\"jump\":\"Jump to slide {slide}\"},\"dateInput\":{\"openCalendar\":\"Press space to open calendar\",\"enterCalendar\":\"Calendar is open, use arrow keys and enter to select a date.\",\"exitCalendar\":\"Exited calendar dialog\",\"outOfBounds\":\"Date is out of the allowed range. Enter a date between {start} and {end}.\"},\"dataChart\":{\"detailTitle\":\"Data chart\",\"detailFocus\":\"Use the left and right arrow keys to navigate the chart data.\"},\"dataFilters\":{\"clear\":\"Clear filters\",\"heading\":\"Filters\",\"open\":\"Open filters\",\"openSet\":{\"singular\":\"Open filters, {number} filter applied\",\"plural\":\"Open filters, {number} filters applied\"}},\"dataForm\":{\"submit\":\"Apply filters\"},\"dataSearch\":{\"label\":\"Search\",\"open\":\"Open search\"},\"dataSort\":{\"ascending\":\"Ascending\",\"by\":\"Sort by\",\"descending\":\"Descending\",\"direction\":\"Sort direction\",\"open\":\"Open sort\"},\"dataSummary\":{\"filtered\":\"{filteredTotal} results of {total} {items}\",\"filteredSingle\":\"{filteredTotal} result of {total} {items}\",\"items\":\"items\",\"itemsSingle\":\"item\",\"selected\":\"{selected} selected\",\"total\":\"{total} {items}\",\"totalSingle\":\"{total} {items}\"},\"dataTable\":{\"ascending\":\"ascending\",\"collapse\":\"collapse {label}\",\"collapseAll\":\"collapse all\",\"decrease\":\"Decrease {headerText} column width\",\"descending\":\"descending\",\"increase\":\"Increase {headerText} column width\",\"expand\":\"expand {label}\",\"expandAll\":\"expand all\",\"resizerAria\":\"Resize {headerText} column\",\"rows\":\"rows\",\"rowsChanged\":\"Number of rows changed\",\"rowsSingle\":\"row\",\"searchBy\":\"Open search by {property}\",\"total\":\"{total} {rows}\",\"totalSingle\":\"{total} {rows}\"},\"dataTableColumns\":{\"open\":\"Open column selector\",\"order\":\"Order columns\",\"pinned\":\"Column locked, order cannot be changed.\",\"select\":\"Select columns\",\"tip\":\"Manage columns\",\"selectAria\":\"Select which columns to show in the data table\",\"orderAria\":\"Reorder the visible columns in the data table\"},\"dataTableGroupBy\":{\"clear\":\"Clear group\",\"label\":\"Group by\"},\"dataView\":{\"label\":\"View\"},\"fileInput\":{\"alert\":{\"maxFile\":\"Error, {fileName} exceeds {maxFile} files limit.\",\"maxSize\":\"Error, {fileName} exceeds {maxSize} limit.\"},\"browse\":\"browse\",\"dropPrompt\":\"Drop file here or\",\"dropPromptMultiple\":\"Drop files here or\",\"files\":\"files\",\"maxFile\":\"Attach a maximum of {max} files only.\",\"maxSizeSingle\":\"The file is too large. Select a file no larger than {maxSize}.\",\"maxSizeMultiple\":{\"singular\":\"{fileName} file is too large. Select files which are no larger than {maxSize}.\",\"plural\":\"{numOfFiles} files are too large. Select files which are no larger than {maxSize}.\"},\"remove\":\"remove {fileName}\",\"removeAll\":\"remove all\"},\"form\":{\"invalid\":\"invalid\",\"required\":\"required\"},\"formField\":{\"maxCharacters\":{\"remaining\":{\"singular\":\"{number} character left\",\"plural\":\"{number} characters left\"},\"overLimit\":{\"singular\":\"{number} character over limit\",\"plural\":\"{number} characters over limit\"}}},\"input\":{\"readOnlyCopy\":{\"prompt\":\"Copy to clipboard\",\"validation\":\"Copied\"}},\"list\":{\"pinned\":\"Item pinned, order cannot be changed.\"},\"menu\":{\"openMenu\":\"Open Menu\",\"closeMenu\":\"Close Menu\"},\"meter\":{\"bar\":{\"singular\":\"Bar meter with value {meterValue} out of {max}\",\"plural\":\"Bar meter with values {meterValue} out of {max}\"},\"circle\":{\"singular\":\"Circle meter with value {meterValue} out of {max}\",\"plural\":\"Circle meter with values {meterValue} out of {max}\"},\"pie\":{\"singular\":\"Pie meter with value {meterValue} out of {max}\",\"plural\":\"Pie meter with values {meterValue} out of {max}\"},\"semicircle\":{\"singular\":\"Semicircle meter with value {meterValue} out of {max}\",\"plural\":\"Semicircle meter with values {meterValue} out of {max}\"}},\"notification\":{\"close\":\"Dismiss notification\"},\"pagination\":{\"stepLabel\":\"Items per page\",\"summary\":\"Showing {start}-{end} of {total}\",\"summaryNoItems\":\"0 items\"},\"rangeSelector\":{\"lower\":\"Lower Bounds\",\"upper\":\"Upper Bounds\"},\"select\":{\"optionsA11y\":\"list of options\",\"multiple\":\"multiple\",\"searchA11y\":\"Search options\",\"selected\":\"; Selected: {currentSelectedValue}\"},\"selectMultiple\":{\"clearAll\":\"Clear All\",\"clearAllA11y\":\"{selected} options selected. Clear all?\",\"open\":\"Open drop\",\"optionNotSelected\":\"{optionLabel} not selected\",\"optionsA11y\":\"list of options\",\"optionSelected\":\"{optionLabel} selected\",\"search\":\"Search to filter options\",\"selectAll\":\"Select All\",\"selectAllA11y\":\"Select all {total} options\",\"selectDrop\":\"Select dropdown\",\"selected\":\"{selected} selected\",\"selectedOfTotal\":\"{selected} selected of {total}\",\"selectedOptions\":\"Selected options\",\"showMore\":\"+ {remaining} more\",\"summarizedValue\":\"{selected} selected\"},\"skipLinks\":{\"skipTo\":\"Skip To:\"},\"stepper\":{\"progress\":\"Progress\",\"step\":\"Step {step} of {total}: {title}\"},\"tabs\":{\"nextTab\":\"Next Tab\",\"previousTab\":\"Previous Tab\",\"tabContents\":\"Tab Contents\"},\"tag\":{\"removeLabel\":{\"nameAndValue\":\"Remove {name}: {value}\",\"valueOnly\":\"Remove {value}\"}},\"textInput\":{\"enterSelect\":\"(Press Enter to Select)\",\"suggestionsCount\":\"suggestions available\",\"suggestionsExist\":\"This input has suggestions use arrow keys to navigate\",\"suggestionIsOpen\":\"Suggestions drop is open, continue to use arrow keys to navigate\"},\"timeInput\":{\"inputLabel\":\"Time input\",\"chooseTime\":\"Choose time\",\"currentValue\":\"Current time {hour}:{minute}:{second}{period}\",\"activeSection\":\"{section} selected\",\"activeSectionValue\":\"{value} {section}\",\"activePeriodValue\":\"{period} period\",\"openDrop\":\"Press space to open time picker\",\"invalidTime\":\"Invalid time value\",\"sectionHours\":\"hours\",\"sectionMinutes\":\"minutes\",\"sectionSeconds\":\"seconds\",\"sectionMeridiem\":\"meridiem\"},\"video\":{\"audioDescriptions\":\"video audio description\",\"captions\":\"closed captions\",\"closeMenu\":\"close menu\",\"description\":\"video audio description\",\"fullScreen\":\"full screen\",\"progressMeter\":\"video progress\",\"scrubber\":\"scrubber\",\"openMenu\":\"open menu\",\"pauseButton\":\"pause\",\"playButton\":\"play\",\"volumeDown\":\"volume down\",\"volumeUp\":\"volume up\"}}");

});

parcelRegister("5I6jx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "RuleType", function () { return $4285f5a477e73240$export$e0aa44767d8750d5; });
$parcel$export(module.exports, "compiler", function () { return $4285f5a477e73240$export$69f434acfbdb0b32; });
$parcel$export(module.exports, "default", function () { return $4285f5a477e73240$export$2e2bcd8739ae039; });

var $2xPiy = parcelRequire("2xPiy");
function $4285f5a477e73240$var$n() {
    return $4285f5a477e73240$var$n = Object.assign ? Object.assign.bind() : function(e) {
        for(var n = 1; n < arguments.length; n++){
            var r = arguments[n];
            for(var t in r)Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
        }
        return e;
    }, $4285f5a477e73240$var$n.apply(this, arguments);
}
var $4285f5a477e73240$export$e0aa44767d8750d5, $4285f5a477e73240$var$t, $4285f5a477e73240$var$i = [
    "children",
    "options"
];
!function(e) {
    e.blockQuote = "0", e.breakLine = "1", e.breakThematic = "2", e.codeBlock = "3", e.codeFenced = "4", e.codeInline = "5", e.footnote = "6", e.footnoteReference = "7", e.gfmTask = "8", e.heading = "9", e.headingSetext = "10", e.htmlBlock = "11", e.htmlComment = "12", e.htmlSelfClosing = "13", e.image = "14", e.link = "15", e.linkAngleBraceStyleDetector = "16", e.linkBareUrlDetector = "17", e.linkMailtoDetector = "18", e.newlineCoalescer = "19", e.orderedList = "20", e.paragraph = "21", e.ref = "22", e.refImage = "23", e.refLink = "24", e.table = "25", e.tableSeparator = "26", e.text = "27", e.textBolded = "28", e.textEmphasized = "29", e.textEscaped = "30", e.textMarked = "31", e.textStrikethroughed = "32", e.unorderedList = "33";
}($4285f5a477e73240$export$e0aa44767d8750d5 || ($4285f5a477e73240$export$e0aa44767d8750d5 = {})), function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($4285f5a477e73240$var$t || ($4285f5a477e73240$var$t = {}));
var $4285f5a477e73240$var$a = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "className",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce(function(e, n) {
    return e[n.toLowerCase()] = n, e;
}, {
    for: "htmlFor"
}), $4285f5a477e73240$var$o = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $4285f5a477e73240$var$c = [
    "style",
    "script"
], $4285f5a477e73240$var$l = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $4285f5a477e73240$var$u = /mailto:/i, $4285f5a477e73240$var$s = /\n{2,}$/, $4285f5a477e73240$var$f = /^( *>[^\n]+(\n[^\n]+)*\n*)+\n{2,}/, $4285f5a477e73240$var$d = /^ *> ?/gm, $4285f5a477e73240$var$p = /^ {2,}\n/, $4285f5a477e73240$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $4285f5a477e73240$var$m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, $4285f5a477e73240$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $4285f5a477e73240$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $4285f5a477e73240$var$v = /^(?:\n *)*\n/, $4285f5a477e73240$var$k = /\r\n?/g, $4285f5a477e73240$var$x = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $4285f5a477e73240$var$b = /^\[\^([^\]]+)]/, $4285f5a477e73240$var$w = /\f/g, $4285f5a477e73240$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $4285f5a477e73240$var$S = /^\s*?\[(x|\s)\]/, $4285f5a477e73240$var$C = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $4285f5a477e73240$var$$ = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $4285f5a477e73240$var$A = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $4285f5a477e73240$var$O = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?([^>]*)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $4285f5a477e73240$var$T = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $4285f5a477e73240$var$L = /^<!--[\s\S]*?(?:-->)/, $4285f5a477e73240$var$R = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $4285f5a477e73240$var$z = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $4285f5a477e73240$var$M = /^\{.*\}$/, $4285f5a477e73240$var$I = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $4285f5a477e73240$var$U = /^<([^ >]+@[^ >]+)>/, $4285f5a477e73240$var$j = /^<([^ >]+:\/[^ >]+)>/, $4285f5a477e73240$var$B = /-([a-z])?/gi, $4285f5a477e73240$var$N = /^(.*\|?.*)\n *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*)\n?/, $4285f5a477e73240$var$H = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $4285f5a477e73240$var$D = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $4285f5a477e73240$var$P = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $4285f5a477e73240$var$_ = /(\[|\])/g, $4285f5a477e73240$var$F = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $4285f5a477e73240$var$W = /\t/g, $4285f5a477e73240$var$G = /^ *\| */, $4285f5a477e73240$var$Z = /(^ *\||\| *$)/g, $4285f5a477e73240$var$q = / *$/, $4285f5a477e73240$var$V = /^ *:-+: *$/, $4285f5a477e73240$var$X = /^ *:-+ *$/, $4285f5a477e73240$var$Q = /^ *-+: *$/, $4285f5a477e73240$var$J = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $4285f5a477e73240$var$K = new RegExp("^([*_])\\1" + $4285f5a477e73240$var$J + "\\1\\1(?!\\1)"), $4285f5a477e73240$var$Y = new RegExp("^([*_])" + $4285f5a477e73240$var$J + "\\1(?!\\1|\\w)"), $4285f5a477e73240$var$ee = new RegExp("^==" + $4285f5a477e73240$var$J + "=="), $4285f5a477e73240$var$ne = new RegExp("^~~" + $4285f5a477e73240$var$J + "~~"), $4285f5a477e73240$var$re = /^\\([^0-9A-Za-z\s])/, $4285f5a477e73240$var$te = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $4285f5a477e73240$var$ie = /^\n+/, $4285f5a477e73240$var$ae = /^([ \t]*)/, $4285f5a477e73240$var$oe = /\\([^\\])/g, $4285f5a477e73240$var$ce = / *\n+$/, $4285f5a477e73240$var$le = /(?:^|\n)( *)$/, $4285f5a477e73240$var$ue = "(?:\\d+\\.)", $4285f5a477e73240$var$se = "(?:[*+-])";
function $4285f5a477e73240$var$fe(e) {
    return "( *)(" + (1 === e ? $4285f5a477e73240$var$ue : $4285f5a477e73240$var$se) + ") +";
}
var $4285f5a477e73240$var$de = $4285f5a477e73240$var$fe(1), $4285f5a477e73240$var$pe = $4285f5a477e73240$var$fe(2);
function $4285f5a477e73240$var$he(e) {
    return new RegExp("^" + (1 === e ? $4285f5a477e73240$var$de : $4285f5a477e73240$var$pe));
}
var $4285f5a477e73240$var$me = $4285f5a477e73240$var$he(1), $4285f5a477e73240$var$ge = $4285f5a477e73240$var$he(2);
function $4285f5a477e73240$var$ye(e) {
    return new RegExp("^" + (1 === e ? $4285f5a477e73240$var$de : $4285f5a477e73240$var$pe) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $4285f5a477e73240$var$ue : $4285f5a477e73240$var$se) + " )[^\\n]*)*(\\n|$)", "gm");
}
var $4285f5a477e73240$var$ve = $4285f5a477e73240$var$ye(1), $4285f5a477e73240$var$ke = $4285f5a477e73240$var$ye(2);
function $4285f5a477e73240$var$xe(e) {
    var n = 1 === e ? $4285f5a477e73240$var$ue : $4285f5a477e73240$var$se;
    return new RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
}
var $4285f5a477e73240$var$be = $4285f5a477e73240$var$xe(1), $4285f5a477e73240$var$we = $4285f5a477e73240$var$xe(2);
function $4285f5a477e73240$var$Ee(e, n) {
    var r = 1 === n, t = r ? $4285f5a477e73240$var$be : $4285f5a477e73240$var$we, i = r ? $4285f5a477e73240$var$ve : $4285f5a477e73240$var$ke, a = r ? $4285f5a477e73240$var$me : $4285f5a477e73240$var$ge;
    return {
        match: function(e, n, r) {
            var i = $4285f5a477e73240$var$le.exec(r);
            return i && (n.list || !n.inline && !n.simple) ? t.exec(e = i[1] + e) : null;
        },
        order: 1,
        parse: function(e, n, t) {
            var o = r ? +e[2] : void 0, c = e[0].replace($4285f5a477e73240$var$s, "\n").match(i), l = !1;
            return {
                items: c.map(function(e, r) {
                    var i = a.exec(e)[0].length, o = new RegExp("^ {1," + i + "}", "gm"), u = e.replace(o, "").replace(a, ""), s = r === c.length - 1, f = -1 !== u.indexOf("\n\n") || s && l;
                    l = f;
                    var d, p = t.inline, h = t.list;
                    t.list = !0, f ? (t.inline = !1, d = u.replace($4285f5a477e73240$var$ce, "\n\n")) : (t.inline = !0, d = u.replace($4285f5a477e73240$var$ce, ""));
                    var m = n(d, t);
                    return t.inline = p, t.list = h, m;
                }),
                ordered: r,
                start: o
            };
        },
        render: function(n, r, t) {
            return e(n.ordered ? "ol" : "ul", {
                key: t.key,
                start: "20" === n.type ? n.start : void 0
            }, n.items.map(function(n, i) {
                return e("li", {
                    key: i
                }, r(n, t));
            }));
        }
    };
}
var $4285f5a477e73240$var$Se = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $4285f5a477e73240$var$Ce = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $4285f5a477e73240$var$$e = [
    $4285f5a477e73240$var$f,
    $4285f5a477e73240$var$m,
    $4285f5a477e73240$var$g,
    $4285f5a477e73240$var$C,
    $4285f5a477e73240$var$A,
    $4285f5a477e73240$var$$,
    $4285f5a477e73240$var$L,
    $4285f5a477e73240$var$N,
    $4285f5a477e73240$var$ve,
    $4285f5a477e73240$var$be,
    $4285f5a477e73240$var$ke,
    $4285f5a477e73240$var$we
], $4285f5a477e73240$var$Ae = [].concat($4285f5a477e73240$var$$e, [
    /^[^\n]+(?:  \n|\n{2,})/,
    $4285f5a477e73240$var$O,
    $4285f5a477e73240$var$z
]);
function $4285f5a477e73240$var$Oe(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $4285f5a477e73240$var$Te(e) {
    return $4285f5a477e73240$var$Q.test(e) ? "right" : $4285f5a477e73240$var$V.test(e) ? "center" : $4285f5a477e73240$var$X.test(e) ? "left" : null;
}
function $4285f5a477e73240$var$Le(e, n, r) {
    var t = r.inTable;
    r.inTable = !0;
    var i = n(e.trim(), r);
    r.inTable = t;
    var a = [
        []
    ];
    return i.forEach(function(e, n) {
        "26" === e.type ? 0 !== n && n !== i.length - 1 && a.push([]) : ("27" !== e.type || null != i[n + 1] && "26" !== i[n + 1].type || (e.text = e.text.replace($4285f5a477e73240$var$q, "")), a[a.length - 1].push(e));
    }), a;
}
function $4285f5a477e73240$var$Re(e, n, r) {
    r.inline = !0;
    var t = $4285f5a477e73240$var$Le(e[1], n, r), i = e[2].replace($4285f5a477e73240$var$Z, "").split("|").map($4285f5a477e73240$var$Te), a = function(e, n, r) {
        return e.trim().split("\n").map(function(e) {
            return $4285f5a477e73240$var$Le(e, n, r);
        });
    }(e[3], n, r);
    return r.inline = !1, {
        align: i,
        cells: a,
        header: t,
        type: "25"
    };
}
function $4285f5a477e73240$var$ze(e, n) {
    return null == e.align[n] ? {} : {
        textAlign: e.align[n]
    };
}
function $4285f5a477e73240$var$Me(e) {
    return function(n, r) {
        return r.inline ? e.exec(n) : null;
    };
}
function $4285f5a477e73240$var$Ie(e) {
    return function(n, r) {
        return r.inline || r.simple ? e.exec(n) : null;
    };
}
function $4285f5a477e73240$var$Ue(e) {
    return function(n, r) {
        return r.inline || r.simple ? null : e.exec(n);
    };
}
function $4285f5a477e73240$var$je(e) {
    return function(n) {
        return e.exec(n);
    };
}
function $4285f5a477e73240$var$Be(e, n, r) {
    if (n.inline || n.simple) return null;
    if (r && !r.endsWith("\n")) return null;
    var t = "";
    e.split("\n").every(function(e) {
        return !$4285f5a477e73240$var$$e.some(function(n) {
            return n.test(e);
        }) && (t += e + "\n", e.trim());
    });
    var i = t.trimEnd();
    return "" == i ? null : [
        t,
        i
    ];
}
function $4285f5a477e73240$var$Ne(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return;
    } catch (e) {
        return null;
    }
    return e;
}
function $4285f5a477e73240$var$He(e) {
    return e.replace($4285f5a477e73240$var$oe, "$1");
}
function $4285f5a477e73240$var$De(e, n, r) {
    var t = r.inline || !1, i = r.simple || !1;
    r.inline = !0, r.simple = !0;
    var a = e(n, r);
    return r.inline = t, r.simple = i, a;
}
function $4285f5a477e73240$var$Pe(e, n, r) {
    var t = r.inline || !1, i = r.simple || !1;
    r.inline = !1, r.simple = !0;
    var a = e(n, r);
    return r.inline = t, r.simple = i, a;
}
function $4285f5a477e73240$var$_e(e, n, r) {
    return r.inline = !1, e(n, r);
}
var $4285f5a477e73240$var$Fe = function(e, n, r) {
    return {
        children: $4285f5a477e73240$var$De(n, e[1], r)
    };
};
function $4285f5a477e73240$var$We() {
    return {};
}
function $4285f5a477e73240$var$Ge() {
    return null;
}
function $4285f5a477e73240$var$Ze() {
    return [].slice.call(arguments).filter(Boolean).join(" ");
}
function $4285f5a477e73240$var$qe(e, n, r) {
    for(var t = e, i = n.split("."); i.length && void 0 !== (t = t[i[0]]);)i.shift();
    return t || r;
}
function $4285f5a477e73240$var$Ve(e, n) {
    var r = $4285f5a477e73240$var$qe(n, e);
    return r ? "function" == typeof r || "object" == typeof r && "render" in r ? r : $4285f5a477e73240$var$qe(n, e + ".component", e) : e;
}
function $4285f5a477e73240$export$69f434acfbdb0b32(r, t) {
    var i;
    void 0 === r && (r = ""), void 0 === t && (t = {}), t.overrides = t.overrides || {}, t.slugify = t.slugify || $4285f5a477e73240$var$Oe, t.namedCodesToUnicode = t.namedCodesToUnicode ? $4285f5a477e73240$var$n({}, $4285f5a477e73240$var$o, t.namedCodesToUnicode) : $4285f5a477e73240$var$o;
    var s = t.createElement || $2xPiy.createElement;
    function Z(e, r) {
        var i = $4285f5a477e73240$var$qe(t.overrides, e + ".props", {});
        return s.apply(void 0, [
            $4285f5a477e73240$var$Ve(e, t.overrides),
            $4285f5a477e73240$var$n({}, r, i, {
                className: $4285f5a477e73240$var$Ze(null == r ? void 0 : r.className, i.className) || void 0
            })
        ].concat([].slice.call(arguments, 2)));
    }
    function q(n) {
        n = n.replace($4285f5a477e73240$var$E, "");
        var r = !1;
        t.forceInline ? r = !0 : t.forceBlock || (r = !1 === $4285f5a477e73240$var$F.test(n));
        for(var i = le(ce(r ? n : n.trimEnd().replace($4285f5a477e73240$var$ie, "") + "\n\n", {
            inline: r
        })); "string" == typeof i[i.length - 1] && !i[i.length - 1].trim();)i.pop();
        if (null === t.wrapper) return i;
        var a, o = t.wrapper || (r ? "span" : "div");
        if (i.length > 1 || t.forceWrapper) a = i;
        else {
            if (1 === i.length) return "string" == typeof (a = i[0]) ? Z("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $2xPiy.createElement(o, {
            key: "outer"
        }, a);
    }
    function V(n) {
        var r = n.match($4285f5a477e73240$var$l);
        return r ? r.reduce(function(n, r, t) {
            var i = r.indexOf("=");
            if (-1 !== i) {
                var o = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($4285f5a477e73240$var$R) && (e = e.replace($4285f5a477e73240$var$B, function(e, n) {
                        return n.toUpperCase();
                    })), e;
                })(r.slice(0, i)).trim(), c = function(e) {
                    var n = e[0];
                    return ('"' === n || "'" === n) && e.length >= 2 && e[e.length - 1] === n ? e.slice(1, -1) : e;
                }(r.slice(i + 1).trim()), l = $4285f5a477e73240$var$a[o] || o, u = n[l] = function(e, n) {
                    return "style" === e ? n.split(/;\s?/).reduce(function(e, n) {
                        var r = n.slice(0, n.indexOf(":"));
                        return e[r.trim().replace(/(-[a-z])/g, function(e) {
                            return e[1].toUpperCase();
                        })] = n.slice(r.length + 1).trim(), e;
                    }, {}) : "href" === e || "src" === e ? $4285f5a477e73240$var$Ne(n) : (n.match($4285f5a477e73240$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(o, c);
                "string" == typeof u && ($4285f5a477e73240$var$O.test(u) || $4285f5a477e73240$var$z.test(u)) && (n[l] = $2xPiy.cloneElement(q(u.trim()), {
                    key: t
                }));
            } else "style" !== r && (n[$4285f5a477e73240$var$a[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    var X = [], Q = {}, J = ((i = {})[0] = {
        match: $4285f5a477e73240$var$Ue($4285f5a477e73240$var$f),
        order: 1,
        parse: function(e, n, r) {
            return {
                children: n(e[0].replace($4285f5a477e73240$var$d, ""), r)
            };
        },
        render: function(e, n, r) {
            return Z("blockquote", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[1] = {
        match: $4285f5a477e73240$var$je($4285f5a477e73240$var$p),
        order: 1,
        parse: $4285f5a477e73240$var$We,
        render: function(e, n, r) {
            return Z("br", {
                key: r.key
            });
        }
    }, i[2] = {
        match: $4285f5a477e73240$var$Ue($4285f5a477e73240$var$h),
        order: 1,
        parse: $4285f5a477e73240$var$We,
        render: function(e, n, r) {
            return Z("hr", {
                key: r.key
            });
        }
    }, i[3] = {
        match: $4285f5a477e73240$var$Ue($4285f5a477e73240$var$g),
        order: 0,
        parse: function(e) {
            return {
                lang: void 0,
                text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
            };
        },
        render: function(e, r, t) {
            return Z("pre", {
                key: t.key
            }, Z("code", $4285f5a477e73240$var$n({}, e.attrs, {
                className: e.lang ? "lang-" + e.lang : ""
            }), e.text));
        }
    }, i[4] = {
        match: $4285f5a477e73240$var$Ue($4285f5a477e73240$var$m),
        order: 0,
        parse: function(e) {
            return {
                attrs: V(e[3] || ""),
                lang: e[2] || void 0,
                text: e[4],
                type: "3"
            };
        }
    }, i[5] = {
        match: $4285f5a477e73240$var$Ie($4285f5a477e73240$var$y),
        order: 3,
        parse: function(e) {
            return {
                text: e[2]
            };
        },
        render: function(e, n, r) {
            return Z("code", {
                key: r.key
            }, e.text);
        }
    }, i[6] = {
        match: $4285f5a477e73240$var$Ue($4285f5a477e73240$var$x),
        order: 0,
        parse: function(e) {
            return X.push({
                footnote: e[2],
                identifier: e[1]
            }), {};
        },
        render: $4285f5a477e73240$var$Ge
    }, i[7] = {
        match: $4285f5a477e73240$var$Me($4285f5a477e73240$var$b),
        order: 1,
        parse: function(e) {
            return {
                target: "#" + t.slugify(e[1]),
                text: e[1]
            };
        },
        render: function(e, n, r) {
            return Z("a", {
                key: r.key,
                href: $4285f5a477e73240$var$Ne(e.target)
            }, Z("sup", {
                key: r.key
            }, e.text));
        }
    }, i[8] = {
        match: $4285f5a477e73240$var$Me($4285f5a477e73240$var$S),
        order: 1,
        parse: function(e) {
            return {
                completed: "x" === e[1].toLowerCase()
            };
        },
        render: function(e, n, r) {
            return Z("input", {
                checked: e.completed,
                key: r.key,
                readOnly: !0,
                type: "checkbox"
            });
        }
    }, i[9] = {
        match: $4285f5a477e73240$var$Ue(t.enforceAtxHeadings ? $4285f5a477e73240$var$$ : $4285f5a477e73240$var$C),
        order: 1,
        parse: function(e, n, r) {
            return {
                children: $4285f5a477e73240$var$De(n, e[2], r),
                id: t.slugify(e[2]),
                level: e[1].length
            };
        },
        render: function(e, n, r) {
            return Z("h" + e.level, {
                id: e.id,
                key: r.key
            }, n(e.children, r));
        }
    }, i[10] = {
        match: $4285f5a477e73240$var$Ue($4285f5a477e73240$var$A),
        order: 0,
        parse: function(e, n, r) {
            return {
                children: $4285f5a477e73240$var$De(n, e[1], r),
                level: "=" === e[2] ? 1 : 2,
                type: "9"
            };
        }
    }, i[11] = {
        match: $4285f5a477e73240$var$je($4285f5a477e73240$var$O),
        order: 1,
        parse: function(e, n, r) {
            var t, i = e[3].match($4285f5a477e73240$var$ae), a = new RegExp("^" + i[1], "gm"), o = e[3].replace(a, ""), l = (t = o, $4285f5a477e73240$var$Ae.some(function(e) {
                return e.test(t);
            }) ? $4285f5a477e73240$var$_e : $4285f5a477e73240$var$De), u = e[1].toLowerCase(), s = -1 !== $4285f5a477e73240$var$c.indexOf(u), f = {
                attrs: V(e[2]),
                noInnerParse: s,
                tag: (s ? u : e[1]).trim()
            };
            return r.inAnchor = r.inAnchor || "a" === u, s ? f.text = e[3] : f.children = l(n, o, r), r.inAnchor = !1, f;
        },
        render: function(e, r, t) {
            return Z(e.tag, $4285f5a477e73240$var$n({
                key: t.key
            }, e.attrs), e.text || r(e.children, t));
        }
    }, i[13] = {
        match: $4285f5a477e73240$var$je($4285f5a477e73240$var$z),
        order: 1,
        parse: function(e) {
            return {
                attrs: V(e[2] || ""),
                tag: e[1].trim()
            };
        },
        render: function(e, r, t) {
            return Z(e.tag, $4285f5a477e73240$var$n({}, e.attrs, {
                key: t.key
            }));
        }
    }, i[12] = {
        match: $4285f5a477e73240$var$je($4285f5a477e73240$var$L),
        order: 1,
        parse: function() {
            return {};
        },
        render: $4285f5a477e73240$var$Ge
    }, i[14] = {
        match: $4285f5a477e73240$var$Ie($4285f5a477e73240$var$Ce),
        order: 1,
        parse: function(e) {
            return {
                alt: e[1],
                target: $4285f5a477e73240$var$He(e[2]),
                title: e[3]
            };
        },
        render: function(e, n, r) {
            return Z("img", {
                key: r.key,
                alt: e.alt || void 0,
                title: e.title || void 0,
                src: $4285f5a477e73240$var$Ne(e.target)
            });
        }
    }, i[15] = {
        match: $4285f5a477e73240$var$Me($4285f5a477e73240$var$Se),
        order: 3,
        parse: function(e, n, r) {
            return {
                children: $4285f5a477e73240$var$Pe(n, e[1], r),
                target: $4285f5a477e73240$var$He(e[2]),
                title: e[3]
            };
        },
        render: function(e, n, r) {
            return Z("a", {
                key: r.key,
                href: $4285f5a477e73240$var$Ne(e.target),
                title: e.title
            }, n(e.children, r));
        }
    }, i[16] = {
        match: $4285f5a477e73240$var$Me($4285f5a477e73240$var$j),
        order: 0,
        parse: function(e) {
            return {
                children: [
                    {
                        text: e[1],
                        type: "27"
                    }
                ],
                target: e[1],
                type: "15"
            };
        }
    }, i[17] = {
        match: function(e, n) {
            return n.inAnchor ? null : $4285f5a477e73240$var$Me($4285f5a477e73240$var$I)(e, n);
        },
        order: 0,
        parse: function(e) {
            return {
                children: [
                    {
                        text: e[1],
                        type: "27"
                    }
                ],
                target: e[1],
                title: void 0,
                type: "15"
            };
        }
    }, i[18] = {
        match: $4285f5a477e73240$var$Me($4285f5a477e73240$var$U),
        order: 0,
        parse: function(e) {
            var n = e[1], r = e[1];
            return $4285f5a477e73240$var$u.test(r) || (r = "mailto:" + r), {
                children: [
                    {
                        text: n.replace("mailto:", ""),
                        type: "27"
                    }
                ],
                target: r,
                type: "15"
            };
        }
    }, i[20] = $4285f5a477e73240$var$Ee(Z, 1), i[33] = $4285f5a477e73240$var$Ee(Z, 2), i[19] = {
        match: $4285f5a477e73240$var$Ue($4285f5a477e73240$var$v),
        order: 3,
        parse: $4285f5a477e73240$var$We,
        render: function() {
            return "\n";
        }
    }, i[21] = {
        match: $4285f5a477e73240$var$Be,
        order: 3,
        parse: $4285f5a477e73240$var$Fe,
        render: function(e, n, r) {
            return Z("p", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[22] = {
        match: $4285f5a477e73240$var$Me($4285f5a477e73240$var$H),
        order: 0,
        parse: function(e) {
            return Q[e[1]] = {
                target: e[2],
                title: e[4]
            }, {};
        },
        render: $4285f5a477e73240$var$Ge
    }, i[23] = {
        match: $4285f5a477e73240$var$Ie($4285f5a477e73240$var$D),
        order: 0,
        parse: function(e) {
            return {
                alt: e[1] || void 0,
                ref: e[2]
            };
        },
        render: function(e, n, r) {
            return Q[e.ref] ? Z("img", {
                key: r.key,
                alt: e.alt,
                src: $4285f5a477e73240$var$Ne(Q[e.ref].target),
                title: Q[e.ref].title
            }) : null;
        }
    }, i[24] = {
        match: $4285f5a477e73240$var$Me($4285f5a477e73240$var$P),
        order: 0,
        parse: function(e, n, r) {
            return {
                children: n(e[1], r),
                fallbackChildren: n(e[0].replace($4285f5a477e73240$var$_, "\\$1"), r),
                ref: e[2]
            };
        },
        render: function(e, n, r) {
            return Q[e.ref] ? Z("a", {
                key: r.key,
                href: $4285f5a477e73240$var$Ne(Q[e.ref].target),
                title: Q[e.ref].title
            }, n(e.children, r)) : Z("span", {
                key: r.key
            }, n(e.fallbackChildren, r));
        }
    }, i[25] = {
        match: $4285f5a477e73240$var$Ue($4285f5a477e73240$var$N),
        order: 1,
        parse: $4285f5a477e73240$var$Re,
        render: function(e, n, r) {
            return Z("table", {
                key: r.key
            }, Z("thead", null, Z("tr", null, e.header.map(function(t, i) {
                return Z("th", {
                    key: i,
                    style: $4285f5a477e73240$var$ze(e, i)
                }, n(t, r));
            }))), Z("tbody", null, e.cells.map(function(t, i) {
                return Z("tr", {
                    key: i
                }, t.map(function(t, i) {
                    return Z("td", {
                        key: i,
                        style: $4285f5a477e73240$var$ze(e, i)
                    }, n(t, r));
                }));
            })));
        }
    }, i[26] = {
        match: function(e, n) {
            return n.inTable ? (n.inline = !0, $4285f5a477e73240$var$G.exec(e)) : null;
        },
        order: 1,
        parse: function() {
            return {
                type: "26"
            };
        },
        render: function() {
            return " | ";
        }
    }, i[27] = {
        match: $4285f5a477e73240$var$je($4285f5a477e73240$var$te),
        order: 4,
        parse: function(e) {
            return {
                text: e[0].replace($4285f5a477e73240$var$T, function(e, n) {
                    return t.namedCodesToUnicode[n] ? t.namedCodesToUnicode[n] : e;
                })
            };
        },
        render: function(e) {
            return e.text;
        }
    }, i[28] = {
        match: $4285f5a477e73240$var$Ie($4285f5a477e73240$var$K),
        order: 2,
        parse: function(e, n, r) {
            return {
                children: n(e[2], r)
            };
        },
        render: function(e, n, r) {
            return Z("strong", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[29] = {
        match: $4285f5a477e73240$var$Ie($4285f5a477e73240$var$Y),
        order: 3,
        parse: function(e, n, r) {
            return {
                children: n(e[2], r)
            };
        },
        render: function(e, n, r) {
            return Z("em", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[30] = {
        match: $4285f5a477e73240$var$Ie($4285f5a477e73240$var$re),
        order: 1,
        parse: function(e) {
            return {
                text: e[1],
                type: "27"
            };
        }
    }, i[31] = {
        match: $4285f5a477e73240$var$Ie($4285f5a477e73240$var$ee),
        order: 3,
        parse: $4285f5a477e73240$var$Fe,
        render: function(e, n, r) {
            return Z("mark", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[32] = {
        match: $4285f5a477e73240$var$Ie($4285f5a477e73240$var$ne),
        order: 3,
        parse: $4285f5a477e73240$var$Fe,
        render: function(e, n, r) {
            return Z("del", {
                key: r.key
            }, n(e.children, r));
        }
    }, i);
    !0 === t.disableParsingRawHTML && (delete J[11], delete J[13]);
    var oe, ce = function(e) {
        var n = Object.keys(e);
        function r(t, i) {
            for(var a = [], o = ""; t;)for(var c = 0; c < n.length;){
                var l = n[c], u = e[l], s = u.match(t, i, o);
                if (s) {
                    var f = s[0];
                    t = t.substring(f.length);
                    var d = u.parse(s, r, i);
                    null == d.type && (d.type = l), a.push(d), o = f;
                    break;
                }
                c++;
            }
            return a;
        }
        return n.sort(function(n, r) {
            var t = e[n].order, i = e[r].order;
            return t !== i ? t - i : n < r ? -1 : 1;
        }), function(e, n) {
            return r(function(e) {
                return e.replace($4285f5a477e73240$var$k, "\n").replace($4285f5a477e73240$var$w, "").replace($4285f5a477e73240$var$W, "    ");
            }(e), n);
        };
    }(J), le = (oe = function(e, n) {
        return function(r, t, i) {
            var a = e[r.type].render;
            return n ? n(function() {
                return a(r, t, i);
            }, r, t, i) : a(r, t, i);
        };
    }(J, t.renderRule), function e(n, r) {
        if (void 0 === r && (r = {}), Array.isArray(n)) {
            for(var t = r.key, i = [], a = !1, o = 0; o < n.length; o++){
                r.key = o;
                var c = e(n[o], r), l = "string" == typeof c;
                l && a ? i[i.length - 1] += c : null !== c && i.push(c), a = l;
            }
            return r.key = t, i;
        }
        return oe(n, e, r);
    }), ue = q(r);
    return X.length ? Z("div", null, ue, Z("footer", {
        key: "footer"
    }, X.map(function(e) {
        return Z("div", {
            id: t.slugify(e.identifier),
            key: e.identifier
        }, e.identifier, le(ce(e.footnote, {
            inline: !0
        })));
    }))) : ue;
}
function $4285f5a477e73240$export$2e2bcd8739ae039(n) {
    var r = n.children, t = void 0 === r ? "" : r, a = n.options, o = function(e, n) {
        if (null == e) return {};
        var r, t, i = {}, a = Object.keys(e);
        for(t = 0; t < a.length; t++)n.indexOf(r = a[t]) >= 0 || (i[r] = e[r]);
        return i;
    }(n, $4285f5a477e73240$var$i);
    return $2xPiy.cloneElement($4285f5a477e73240$export$69f434acfbdb0b32(t, a), o);
}

});

parcelRegister("3fkHd", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });

var $cjt0R = parcelRequire("cjt0R");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $cjt0R.isBrowserBundle)() && Object.prototype.toString.call(0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 * @deprecated This function will be removed in the next major version.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @param existingModule module to use for requiring
 * @returns possibly required module
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        // eslint-disable-next-line deprecation/deprecation
        mod = dynamicRequire(existingModule, moduleName);
    } catch (e) {
    // no-empty
    }
    if (!mod) try {
        // eslint-disable-next-line deprecation/deprecation
        const { cwd } = dynamicRequire(existingModule, 'process');
        // eslint-disable-next-line deprecation/deprecation
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("cjt0R", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $8f6dc3b86eab351a$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $8f6dc3b86eab351a$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $8f6dc3b86eab351a$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $8f6dc3b86eab351a$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}

});


parcelRegister("1hFlE", function(module, exports) {
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = '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';
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = 'strict';
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                'normal',
                'auto',
                'loose'
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === 'strict' ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: 'normal',
            wordBreak: 'normal'
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ''
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = '';
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case 'rem':
            case 'em':
                return 16 * token.number; // TODO use correct font-size
            case 'px':
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(' ');
        switch(sideOrCorner){
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: 'color',
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    'top',
                    'left',
                    'right',
                    'bottom'
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return acc;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case 'at':
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'center':
                        position.push(FIFTY_PERCENT);
                        return false;
                    case 'top':
                    case 'left':
                        position.push(ZERO_LENGTH);
                        return false;
                    case 'right':
                    case 'bottom':
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: 'image',
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === 'none') && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };
    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(' ');
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case 'no-repeat':
                return 1 /* NO_REPEAT */ ;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */ ;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */ ;
            case 'repeat':
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: 'transparent',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'color'
        };
    };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: '0 0',
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: 'solid',
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case 'none':
                        return 0 /* NONE */ ;
                    case 'dashed':
                        return 2 /* DASHED */ ;
                    case 'dotted':
                        return 3 /* DOTTED */ ;
                    case 'double':
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: '0',
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');
    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case 'rtl':
                    return 1 /* RTL */ ;
                case 'ltr':
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */ ;
            case 'inline':
                return 4 /* INLINE */ ;
            case 'run-in':
                return 8 /* RUN_IN */ ;
            case 'flow':
                return 16 /* FLOW */ ;
            case 'flow-root':
                return 32 /* FLOW_ROOT */ ;
            case 'table':
                return 64 /* TABLE */ ;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */ ;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */ ;
            case 'ruby':
                return 512 /* RUBY */ ;
            case 'subgrid':
                return 1024 /* SUBGRID */ ;
            case 'list-item':
                return 2048 /* LIST_ITEM */ ;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */ ;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case 'table-row':
                return 32768 /* TABLE_ROW */ ;
            case 'table-cell':
                return 65536 /* TABLE_CELL */ ;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */ ;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */ ;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */ ;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */ ;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case 'contents':
                return 16777216 /* CONTENTS */ ;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */ ;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */ ;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */ ;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case 'left':
                    return 1 /* LEFT */ ;
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'inline-start':
                    return 3 /* INLINE_START */ ;
                case 'inline-end':
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'normal') return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'inside':
                    return 0 /* INSIDE */ ;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case 'disc':
                    return 0 /* DISC */ ;
                case 'circle':
                    return 1 /* CIRCLE */ ;
                case 'square':
                    return 2 /* SQUARE */ ;
                case 'decimal':
                    return 3 /* DECIMAL */ ;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */ ;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */ ;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */ ;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */ ;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */ ;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */ ;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */ ;
                case 'armenian':
                    return 12 /* ARMENIAN */ ;
                case 'bengali':
                    return 13 /* BENGALI */ ;
                case 'cambodian':
                    return 14 /* CAMBODIAN */ ;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case 'devanagari':
                    return 18 /* DEVANAGARI */ ;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case 'georgian':
                    return 20 /* GEORGIAN */ ;
                case 'gujarati':
                    return 21 /* GUJARATI */ ;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */ ;
                case 'hebrew':
                    return 22 /* HEBREW */ ;
                case 'hiragana':
                    return 23 /* HIRAGANA */ ;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */ ;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */ ;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */ ;
                case 'kannada':
                    return 27 /* KANNADA */ ;
                case 'katakana':
                    return 28 /* KATAKANA */ ;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */ ;
                case 'khmer':
                    return 30 /* KHMER */ ;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case 'lao':
                    return 34 /* LAO */ ;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */ ;
                case 'malayalam':
                    return 36 /* MALAYALAM */ ;
                case 'mongolian':
                    return 37 /* MONGOLIAN */ ;
                case 'myanmar':
                    return 38 /* MYANMAR */ ;
                case 'oriya':
                    return 39 /* ORIYA */ ;
                case 'persian':
                    return 40 /* PERSIAN */ ;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case 'tamil':
                    return 43 /* TAMIL */ ;
                case 'telugu':
                    return 44 /* TELUGU */ ;
                case 'thai':
                    return 45 /* THAI */ ;
                case 'tibetan':
                    return 46 /* TIBETAN */ ;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */ ;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */ ;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case 'none':
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: '0',
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case 'hidden':
                        return 1 /* HIDDEN */ ;
                    case 'scroll':
                        return 2 /* SCROLL */ ;
                    case 'clip':
                        return 3 /* CLIP */ ;
                    case 'auto':
                        return 4 /* AUTO */ ;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'break-word':
                    return "break-word" /* BREAK_WORD */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: '0',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'length-percentage'
        };
    };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */ ;
                case 'left':
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'relative':
                    return 1 /* RELATIVE */ ;
                case 'absolute':
                    return 2 /* ABSOLUTE */ ;
                case 'fixed':
                    return 3 /* FIXED */ ;
                case 'sticky':
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case 'uppercase':
                    return 2 /* UPPERCASE */ ;
                case 'lowercase':
                    return 1 /* LOWERCASE */ ;
                case 'capitalize':
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case 'hidden':
                    return 1 /* HIDDEN */ ;
                case 'collapse':
                    return 2 /* COLLAPSE */ ;
                case 'visible':
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: 'time',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case 's':
                    return 1000 * value.number;
                case 'ms':
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case 'underline':
                        return 1 /* UNDERLINE */ ;
                    case 'overline':
                        return 2 /* OVERLINE */ ;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */ ;
                    case 'none':
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(' '));
            return results.map(function(result) {
                return result.indexOf(' ') === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'length'
    };
    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case 'bold':
                    return 700;
                case 'normal':
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'oblique':
                    return "oblique" /* OBLIQUE */ ;
                case 'italic':
                    return "italic" /* ITALIC */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return '';
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return '';
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case 'stroke':
                        layers.push(1 /* STROKE */ );
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */ );
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case 'all':
                return 1 /* ALL */ ;
            case 'clone':
                return 2 /* CLONE */ ;
            case 'parse':
                return 3 /* PARSE */ ;
            case 'render':
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = '0s';
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = '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';
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== 'undefined';
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === 'string';
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error('Node has no owner document');
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'grapheme'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        'OL',
        'UL',
        'MENU'
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function(node) {
        return node.tagName === 'LI';
    };
    var isOLElement = function(node) {
        return node.tagName === 'OL';
    };
    var isInputElement = function(node) {
        return node.tagName === 'INPUT';
    };
    var isHTMLElement = function(node) {
        return node.tagName === 'HTML';
    };
    var isSVGElement = function(node) {
        return node.tagName === 'svg';
    };
    var isBodyElement = function(node) {
        return node.tagName === 'BODY';
    };
    var isCanvasElement = function(node) {
        return node.tagName === 'CANVAS';
    };
    var isVideoElement = function(node) {
        return node.tagName === 'VIDEO';
    };
    var isImageElement = function(node) {
        return node.tagName === 'IMG';
    };
    var isIFrameElement = function(node) {
        return node.tagName === 'IFRAME';
    };
    var isStyleElement = function(node) {
        return node.tagName === 'STYLE';
    };
    var isScriptElement = function(node) {
        return node.tagName === 'SCRIPT';
    };
    var isTextareaElement = function(node) {
        return node.tagName === 'TEXTAREA';
    };
    var isSelectElement = function(node) {
        return node.tagName === 'SELECT';
    };
    var isSlotElement = function(node) {
        return node.tagName === 'SLOT';
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf('-') > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            'M',
            'CM',
            'D',
            'CD',
            'C',
            'XC',
            'L',
            'XL',
            'X',
            'IX',
            'V',
            'IV',
            'I'
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = '. ';
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? "\u3001" : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error('Cloned element does not have an owner document');
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn('Unable to restore scroll position for cloned document');
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === 'undefined') return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === 'function') return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') clone.loading = 'eager';
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === 'string') return css + rule.cssText;
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ':before');
                var styleAfter = window1.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ''));
                    } else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : '';
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case 'open-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case 'close-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += "\"" + doctype.publicId + "\"";
            if (doctype.systemId) str += "\"" + doctype.systemId + "\"";
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return 'about:blank';
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === 'string' && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = 'anonymous';
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error('No proxy defined');
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === 'text') resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener('error', function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === 'blob';
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === 'number' && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === 'number';
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === 'undefined') return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === 'normal' || variant === 'small-caps';
            }).join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return 'center';
            case 2 /* RIGHT */ :
                return 'right';
            case 0 /* LEFT */ :
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        '-apple-system',
        'system-ui'
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== 'object') return [
                            2 /*return*/ ,
                            Promise.reject('Invalid element provided as first argument')
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string' ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});

});

parcelRegister("jZSRR", function(module, exports) {
module.exports = $parcel$import("7RHJA").then(()=>parcelRequire('donUU'));

});

parcelRegister("lTgs1", function(module, exports) {
module.exports = $parcel$import("k2aSQ").then(()=>parcelRequire('647s0'));

});

var $6fec743f64cdc1de$exports = {};
$parcel$extendImportMap({
    "h3WyE": "dev-favicon.b45ae051.png",
    "i07th": "flag_of_Quebec.eb8b425f.png",
    "7RHJA": "purify.22499b4d.js",
    "k2aSQ": "index.es.4e620fb1.js"
});

var $cb4cc5db45d03478$exports = {};
'use strict';

$cb4cc5db45d03478$exports = (parcelRequire("goxuX"));



var $2xPiy = parcelRequire("2xPiy");
var $e713b0fd8096c0fb$exports = {};
'use strict';
function $e713b0fd8096c0fb$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
}

$e713b0fd8096c0fb$exports = (parcelRequire("47AzO"));



var $2xPiy = parcelRequire("2xPiy");

var $2xPiy = parcelRequire("2xPiy");
var $552761796ac1c5b0$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $552761796ac1c5b0$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $14868379a5bb57da$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $14868379a5bb57da$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($552761796ac1c5b0$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($14868379a5bb57da$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $14868379a5bb57da$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $14868379a5bb57da$var$i = /^\s*$/, $14868379a5bb57da$var$s = Object.create(null);
function $14868379a5bb57da$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($14868379a5bb57da$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "\x3c!--" + t.comment + "--\x3e";
    }
}
var $14868379a5bb57da$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $14868379a5bb57da$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($14868379a5bb57da$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("\x3c!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $14868379a5bb57da$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $14868379a5bb57da$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $14868379a5bb57da$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $14868379a5bb57da$var$a("", t);
        }, "");
    }
};
var $14868379a5bb57da$export$2e2bcd8739ae039 = $14868379a5bb57da$var$c;


function $498542c3be54d66c$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if ($498542c3be54d66c$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
        console.warn(...args);
    }
}
const $498542c3be54d66c$var$alreadyWarned = {};
function $498542c3be54d66c$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if ($498542c3be54d66c$export$844ec244b1367d54(args[0]) && $498542c3be54d66c$var$alreadyWarned[args[0]]) return;
    if ($498542c3be54d66c$export$844ec244b1367d54(args[0])) $498542c3be54d66c$var$alreadyWarned[args[0]] = new Date();
    $498542c3be54d66c$export$c106dd0671a0fc2d(...args);
}
const $498542c3be54d66c$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $498542c3be54d66c$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $498542c3be54d66c$var$loadedClb(i18n, cb));
};
const $498542c3be54d66c$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($498542c3be54d66c$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $498542c3be54d66c$var$loadedClb(i18n, cb));
};
const $498542c3be54d66c$var$oldI18nextHasLoadedNamespace = function(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const lng = i18n.languages[0];
    const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    const lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    const loadNotPending = (l, n)=>{
        const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
};
const $498542c3be54d66c$export$93d9ee97c1ad3f31 = function(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $498542c3be54d66c$export$5b28268982f175ba('i18n.languages were undefined or empty', i18n.languages);
        return true;
    }
    const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $498542c3be54d66c$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $498542c3be54d66c$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($498542c3be54d66c$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
const $498542c3be54d66c$export$844ec244b1367d54 = (obj)=>typeof obj === 'string';
const $498542c3be54d66c$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'object' && obj !== null;


const $d05b453ac4a1340e$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $d05b453ac4a1340e$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $d05b453ac4a1340e$var$unescapeHtmlEntity = (m)=>$d05b453ac4a1340e$var$htmlEntities[m];
const $d05b453ac4a1340e$export$e8bacd2802a88316 = (text)=>text.replace($d05b453ac4a1340e$var$matchHtmlEntity, $d05b453ac4a1340e$var$unescapeHtmlEntity);


let $0b33cbd6e5e585b3$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $d05b453ac4a1340e$export$e8bacd2802a88316
};
const $0b33cbd6e5e585b3$export$2e2366488d12e20d = function() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $0b33cbd6e5e585b3$var$defaultOptions = {
        ...$0b33cbd6e5e585b3$var$defaultOptions,
        ...options
    };
};
const $0b33cbd6e5e585b3$export$212bb2fc580a90a8 = ()=>$0b33cbd6e5e585b3$var$defaultOptions;


let $11368ea821f9cb79$var$i18nInstance;
const $11368ea821f9cb79$export$a039134f2fc7e0 = (instance)=>{
    $11368ea821f9cb79$var$i18nInstance = instance;
};
const $11368ea821f9cb79$export$64af334f494c2f47 = ()=>$11368ea821f9cb79$var$i18nInstance;


const $c15eb28cb3425b5b$var$hasChildren = (node, checkLength)=>{
    if (!node) return false;
    const base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $c15eb28cb3425b5b$var$getChildren = (node)=>{
    if (!node) return [];
    const children = node.props ? node.props.children : node.children;
    return node.props && node.props.i18nIsDynamicList ? $c15eb28cb3425b5b$var$getAsArray(children) : children;
};
const $c15eb28cb3425b5b$var$hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, $2xPiy.isValidElement));
const $c15eb28cb3425b5b$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $c15eb28cb3425b5b$var$mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
};
const $c15eb28cb3425b5b$export$4f7a36dd898f1267 = (children, i18nOptions)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $c15eb28cb3425b5b$var$getAsArray(children);
    const keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $498542c3be54d66c$export$844ec244b1367d54)(child)) stringNode += `${child}`;
        else if ((0, $2xPiy.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) stringNode += `<${type}/>`;
            else if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) stringNode += `<${childIndex}></${childIndex}>`;
            else if (shouldKeepChild && childPropsCount === 1 && (0, $498542c3be54d66c$export$844ec244b1367d54)(childChildren)) stringNode += `<${type}>${childChildren}</${type}>`;
            else {
                const content = $c15eb28cb3425b5b$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += `<${childIndex}>${content}</${childIndex}>`;
            }
        } else if (child === null) (0, $498542c3be54d66c$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a null child.`);
        else if ((0, $498542c3be54d66c$export$a6cdc56e425d0d0a)(child)) {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
            } else (0, $498542c3be54d66c$export$c106dd0671a0fc2d)(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
        } else (0, $498542c3be54d66c$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    });
    return stringNode;
};
const $c15eb28cb3425b5b$var$renderNodes = (children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = {};
    const getData = (childs)=>{
        const childrenArray = $c15eb28cb3425b5b$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $498542c3be54d66c$export$844ec244b1367d54)(child)) return;
            if ($c15eb28cb3425b5b$var$hasChildren(child)) getData($c15eb28cb3425b5b$var$getChildren(child));
            else if ((0, $498542c3be54d66c$export$a6cdc56e425d0d0a)(child) && !(0, $2xPiy.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const ast = (0, $14868379a5bb57da$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        const childs = $c15eb28cb3425b5b$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $c15eb28cb3425b5b$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props && child.props.i18nIsDynamicList ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $2xPiy.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $2xPiy.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, $2xPiy.createElement)(c.type, {
                ...props,
                key: i,
                ref: c.ref
            }, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $c15eb28cb3425b5b$var$getAsArray(reactNode);
        const astNodes = $c15eb28cb3425b5b$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $c15eb28cb3425b5b$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $2xPiy.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $c15eb28cb3425b5b$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $498542c3be54d66c$export$a6cdc56e425d0d0a)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $498542c3be54d66c$export$a6cdc56e425d0d0a)(children) && Object.hasOwnProperty.call(children, node.name);
                if ((0, $498542c3be54d66c$export$844ec244b1367d54)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($c15eb28cb3425b5b$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $2xPiy.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $2xPiy.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $498542c3be54d66c$export$a6cdc56e425d0d0a)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $2xPiy.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $c15eb28cb3425b5b$var$getAsArray(children || []));
    return $c15eb28cb3425b5b$var$getChildren(result[0]);
};
function $c15eb28cb3425b5b$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const i18n = i18nFromProps || (0, $11368ea821f9cb79$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $498542c3be54d66c$export$5b28268982f175ba)('You will need to pass in an i18next instance by using i18nextReactModule');
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, $0b33cbd6e5e585b3$export$212bb2fc580a90a8)(),
        ...i18n.options && i18n.options.react
    };
    let namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = (0, $498542c3be54d66c$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const nodeAsString = $c15eb28cb3425b5b$export$4f7a36dd898f1267(children, reactI18nextOptions);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options && i18n.options.interpolation && i18n.options.interpolation.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const interpolationOverride = values || count !== undefined || !children ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...tOptions,
        context: context || tOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    if (components) Object.keys(components).forEach((c)=>{
        const comp = components[c];
        if (typeof comp.type === 'function' || !comp.props || !comp.props.children || translation.indexOf(`${c}/>`) < 0 && translation.indexOf(`${c} />`) < 0) return;
        function Componentized() {
            return (0, $2xPiy.createElement)((0, $2xPiy.Fragment), null, comp);
        }
        components[c] = (0, $2xPiy.createElement)(Componentized);
    });
    const content = $c15eb28cb3425b5b$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $2xPiy.createElement)(useAsParent, additionalProps, content) : content;
}



var $2xPiy = parcelRequire("2xPiy");




const $abb9f84ea4370813$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $0b33cbd6e5e585b3$export$2e2366488d12e20d)(instance.options.react);
        (0, $11368ea821f9cb79$export$a039134f2fc7e0)(instance);
    }
};


const $b29848e967d3fe77$export$5603ab5ced17ce64 = (0, $2xPiy.createContext)();
class $b29848e967d3fe77$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces = ()=>Object.keys(this.usedNamespaces);
}
const $b29848e967d3fe77$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        const componentsInitialProps = ForComponent.getInitialProps ? await ForComponent.getInitialProps(ctx) : {};
        const i18nInitialProps = $b29848e967d3fe77$export$704200e5d0b9e8f();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const $b29848e967d3fe77$export$704200e5d0b9e8f = ()=>{
    const i18n = (0, $11368ea821f9cb79$export$64af334f494c2f47)();
    const namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};


function $ab9c7af03149020d$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $2xPiy.useContext)((0, $b29848e967d3fe77$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $11368ea821f9cb79$export$64af334f494c2f47)();
    const t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $c15eb28cb3425b5b$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $2xPiy = parcelRequire("2xPiy");


const $10bacddb66d871e8$var$usePrevious = (value, ignore)=>{
    const ref = (0, $2xPiy.useRef)();
    (0, $2xPiy.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
const $10bacddb66d871e8$var$alwaysNewT = (i18n, language, namespace, keyPrefix)=>i18n.getFixedT(language, namespace, keyPrefix);
const $10bacddb66d871e8$var$useMemoizedT = (i18n, language, namespace, keyPrefix)=>(0, $2xPiy.useCallback)($10bacddb66d871e8$var$alwaysNewT(i18n, language, namespace, keyPrefix), [
        i18n,
        language,
        namespace,
        keyPrefix
    ]);
const $10bacddb66d871e8$export$9fc83ad70ead8663 = function(ns) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $2xPiy.useContext)((0, $b29848e967d3fe77$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $11368ea821f9cb79$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $b29848e967d3fe77$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $498542c3be54d66c$export$5b28268982f175ba)('You will need to pass in an i18next instance by using initReactI18next');
        const notReadyT = (k, optsOrDefaultValue)=>{
            if ((0, $498542c3be54d66c$export$844ec244b1367d54)(optsOrDefaultValue)) return optsOrDefaultValue;
            if ((0, $498542c3be54d66c$export$a6cdc56e425d0d0a)(optsOrDefaultValue) && (0, $498542c3be54d66c$export$844ec244b1367d54)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $498542c3be54d66c$export$5b28268982f175ba)('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    const i18nOptions = {
        ...(0, $0b33cbd6e5e585b3$export$212bb2fc580a90a8)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = (0, $498542c3be54d66c$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $498542c3be54d66c$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
    const memoGetT = $10bacddb66d871e8$var$useMemoizedT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const getT = ()=>memoGetT;
    const getNewT = ()=>$10bacddb66d871e8$var$alwaysNewT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const [t, setT] = (0, $2xPiy.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $10bacddb66d871e8$var$usePrevious(joinedNS);
    const isMounted = (0, $2xPiy.useRef)(true);
    (0, $2xPiy.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $498542c3be54d66c$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
            else (0, $498542c3be54d66c$export$83be934b53fff43b)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getNewT);
        const boundReset = ()=>{
            if (isMounted.current) setT(getNewT);
        };
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(' ').forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (isMounted.current && ready) setT(getT);
    }, [
        i18n,
        keyPrefix,
        ready
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $498542c3be54d66c$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $498542c3be54d66c$export$83be934b53fff43b)(i18n, namespaces, ()=>resolve());
    });
};



var $2xPiy = parcelRequire("2xPiy");


const $2b5a752a0a593366$export$2dcb0053efd21124 = function(ns) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            let { forwardedRef: forwardedRef, ...rest } = _ref;
            const [t, i18n, ready] = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $2xPiy.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $498542c3be54d66c$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $2xPiy.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $2xPiy.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
};



function $9364a92533c0c846$export$b63289fbda65eed1(props) {
    const { ns: ns, children: children, ...options } = props;
    const [t, i18n, ready] = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}



var $2xPiy = parcelRequire("2xPiy");

function $e4dc18bb21711c28$export$1325e8699caa160f(_ref) {
    let { i18n: i18n, defaultNS: defaultNS, children: children } = _ref;
    const value = (0, $2xPiy.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $2xPiy.createElement)((0, $b29848e967d3fe77$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $2xPiy = parcelRequire("2xPiy");

var $2xPiy = parcelRequire("2xPiy");

const $e5ec1f0066228872$export$3526fb65ade8d8b7 = function(initialI18nStore, initialLanguage) {
    let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $2xPiy.useContext)((0, $b29848e967d3fe77$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $11368ea821f9cb79$export$64af334f494c2f47)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};




const $65c2d322a3b9a763$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            let { initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest } = _ref;
            (0, $e5ec1f0066228872$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $2xPiy.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $b29848e967d3fe77$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $498542c3be54d66c$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };







const $ad2996ce69703bc0$export$324d90190a8b822a = ()=>'';
const $ad2996ce69703bc0$export$2da9be4cfdb689b1 = ()=>'';
const $ad2996ce69703bc0$export$98e628dec113755e = ()=>'';
const $ad2996ce69703bc0$export$2e6c959c16ff56b8 = ()=>'';
const $ad2996ce69703bc0$export$4e35d5c922a95490 = ()=>'';
const $ad2996ce69703bc0$export$720a3b9db04b7a0f = ()=>'';


/**
 * React Router DOM v6.30.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $2xPiy = parcelRequire("2xPiy");

var $cX5wj = parcelRequire("cX5wj");
/**
 * @remix-run/router v1.23.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $28152332635c962a$var$_extends() {
    return $28152332635c962a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $28152332635c962a$var$_extends.apply(null, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $28152332635c962a$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($28152332635c962a$export$e19cd5f9376f8cee || ($28152332635c962a$export$e19cd5f9376f8cee = {}));
const $28152332635c962a$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $28152332635c962a$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $28152332635c962a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $28152332635c962a$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $28152332635c962a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $28152332635c962a$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $28152332635c962a$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $28152332635c962a$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $28152332635c962a$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $28152332635c962a$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $28152332635c962a$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $28152332635c962a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $28152332635c962a$export$fe53371bee54353d(to);
    }
    return $28152332635c962a$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $28152332635c962a$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $28152332635c962a$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $28152332635c962a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $28152332635c962a$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $28152332635c962a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $28152332635c962a$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $28152332635c962a$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $28152332635c962a$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $28152332635c962a$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $28152332635c962a$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $28152332635c962a$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $28152332635c962a$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $28152332635c962a$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $28152332635c962a$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $28152332635c962a$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $28152332635c962a$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $28152332635c962a$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $28152332635c962a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($28152332635c962a$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $28152332635c962a$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $28152332635c962a$export$e19cd5f9376f8cee.Push;
        let location = $28152332635c962a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $28152332635c962a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $28152332635c962a$export$e19cd5f9376f8cee.Replace;
        let location = $28152332635c962a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $28152332635c962a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $28152332635c962a$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $28152332635c962a$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($28152332635c962a$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($28152332635c962a$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $28152332635c962a$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($28152332635c962a$var$ResultType || ($28152332635c962a$var$ResultType = {}));
const $28152332635c962a$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $28152332635c962a$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $28152332635c962a$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $28152332635c962a$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $28152332635c962a$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($28152332635c962a$var$isIndexRoute(route)) {
            let indexRoute = $28152332635c962a$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $28152332635c962a$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $28152332635c962a$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $28152332635c962a$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $28152332635c962a$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $28152332635c962a$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $28152332635c962a$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $28152332635c962a$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $28152332635c962a$var$flattenRoutes(routes);
    $28152332635c962a$var$rankRouteBranches(branches);
    let matches = null;
    let decoded = $28152332635c962a$export$30d21fd6d7295f52(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)// Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    matches = $28152332635c962a$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $28152332635c962a$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $28152332635c962a$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $28152332635c962a$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $28152332635c962a$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $28152332635c962a$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $28152332635c962a$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $28152332635c962a$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $28152332635c962a$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $28152332635c962a$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $28152332635c962a$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $28152332635c962a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $28152332635c962a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $28152332635c962a$var$paramRe = /^:[\w-]+$/;
const $28152332635c962a$var$dynamicSegmentValue = 3;
const $28152332635c962a$var$indexRouteValue = 2;
const $28152332635c962a$var$emptySegmentValue = 1;
const $28152332635c962a$var$staticSegmentValue = 10;
const $28152332635c962a$var$splatPenalty = -2;
const $28152332635c962a$var$isSplat = (s)=>s === "*";
function $28152332635c962a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($28152332635c962a$var$isSplat)) initialScore += $28152332635c962a$var$splatPenalty;
    if (index) initialScore += $28152332635c962a$var$indexRouteValue;
    return segments.filter((s)=>!$28152332635c962a$var$isSplat(s)).reduce((score, segment)=>score + ($28152332635c962a$var$paramRe.test(segment) ? $28152332635c962a$var$dynamicSegmentValue : segment === "" ? $28152332635c962a$var$emptySegmentValue : $28152332635c962a$var$staticSegmentValue), initialScore);
}
function $28152332635c962a$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $28152332635c962a$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $28152332635c962a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $28152332635c962a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $28152332635c962a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $28152332635c962a$export$a5c6d149b50c1d86($28152332635c962a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $28152332635c962a$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $28152332635c962a$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $28152332635c962a$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $28152332635c962a$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $28152332635c962a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $28152332635c962a$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $28152332635c962a$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $28152332635c962a$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $28152332635c962a$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $28152332635c962a$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $28152332635c962a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $28152332635c962a$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $28152332635c962a$var$isAbsoluteUrl = (url)=>$28152332635c962a$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $28152332635c962a$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $28152332635c962a$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($28152332635c962a$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = $28152332635c962a$var$removeDoubleSlashes(toPathname);
                $28152332635c962a$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $28152332635c962a$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $28152332635c962a$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $28152332635c962a$var$normalizeSearch(search),
        hash: $28152332635c962a$var$normalizeHash(hash)
    };
}
function $28152332635c962a$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $28152332635c962a$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $28152332635c962a$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $28152332635c962a$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $28152332635c962a$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $28152332635c962a$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $28152332635c962a$export$8ccf933b0513f8d0(toArg);
    else {
        to = $28152332635c962a$var$_extends({}, toArg);
        $28152332635c962a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $28152332635c962a$var$getInvalidPathError("?", "pathname", "search", to));
        $28152332635c962a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $28152332635c962a$var$getInvalidPathError("#", "pathname", "hash", to));
        $28152332635c962a$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $28152332635c962a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $28152332635c962a$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $28152332635c962a$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $28152332635c962a$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
const $28152332635c962a$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
/**
 * @private
 */ const $28152332635c962a$export$86d9a7913e44197e = (paths)=>$28152332635c962a$var$removeDoubleSlashes(paths.join("/"));
/**
 * @private
 */ const $28152332635c962a$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $28152332635c962a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $28152332635c962a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $28152332635c962a$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $28152332635c962a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $28152332635c962a$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $28152332635c962a$export$4051a07651545597(data, init) {
    return new $28152332635c962a$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $28152332635c962a$export$42a99a7a4bc0e76a extends Error {
}
class $28152332635c962a$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $28152332635c962a$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $28152332635c962a$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $28152332635c962a$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $28152332635c962a$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $28152332635c962a$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $28152332635c962a$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $28152332635c962a$var$unwrapTrackedPromise(value) {
    if (!$28152332635c962a$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $28152332635c962a$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $28152332635c962a$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $28152332635c962a$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $28152332635c962a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $28152332635c962a$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $28152332635c962a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $28152332635c962a$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $28152332635c962a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $28152332635c962a$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $28152332635c962a$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $28152332635c962a$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $28152332635c962a$var$validMutationMethods = new Set($28152332635c962a$var$validMutationMethodsArr);
const $28152332635c962a$var$validRequestMethodsArr = [
    "get",
    ...$28152332635c962a$var$validMutationMethodsArr
];
const $28152332635c962a$var$validRequestMethods = new Set($28152332635c962a$var$validRequestMethodsArr);
const $28152332635c962a$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $28152332635c962a$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $28152332635c962a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $28152332635c962a$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $28152332635c962a$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $28152332635c962a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $28152332635c962a$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $28152332635c962a$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $28152332635c962a$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $28152332635c962a$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $28152332635c962a$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $28152332635c962a$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $28152332635c962a$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $28152332635c962a$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $28152332635c962a$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $28152332635c962a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $28152332635c962a$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$28152332635c962a$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$28152332635c962a$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $28152332635c962a$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $28152332635c962a$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $28152332635c962a$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $28152332635c962a$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $28152332635c962a$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$28152332635c962a$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($28152332635c962a$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $28152332635c962a$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $28152332635c962a$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $28152332635c962a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $28152332635c962a$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $28152332635c962a$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $28152332635c962a$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $28152332635c962a$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $28152332635c962a$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $28152332635c962a$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($28152332635c962a$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $28152332635c962a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $28152332635c962a$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $28152332635c962a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $28152332635c962a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $28152332635c962a$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $28152332635c962a$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $28152332635c962a$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $28152332635c962a$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $28152332635c962a$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $28152332635c962a$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $28152332635c962a$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $28152332635c962a$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $28152332635c962a$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $28152332635c962a$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $28152332635c962a$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $28152332635c962a$var$findNearestBoundary(matches).route.id,
            {
                type: $28152332635c962a$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $28152332635c962a$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($28152332635c962a$var$isErrorResult(result) && $28152332635c962a$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $28152332635c962a$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $28152332635c962a$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $28152332635c962a$var$_extends({
            matches: updatedMatches || matches
        }, $28152332635c962a$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $28152332635c962a$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $28152332635c962a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $28152332635c962a$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $28152332635c962a$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $28152332635c962a$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $28152332635c962a$var$ResultType.error,
            error: $28152332635c962a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($28152332635c962a$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $28152332635c962a$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($28152332635c962a$var$isDeferredResult(result)) throw $28152332635c962a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($28152332635c962a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $28152332635c962a$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $28152332635c962a$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $28152332635c962a$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $28152332635c962a$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($28152332635c962a$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $28152332635c962a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $28152332635c962a$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $28152332635c962a$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $28152332635c962a$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $28152332635c962a$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $28152332635c962a$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $28152332635c962a$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $28152332635c962a$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $28152332635c962a$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $28152332635c962a$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$28152332635c962a$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $28152332635c962a$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $28152332635c962a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $28152332635c962a$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $28152332635c962a$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $28152332635c962a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $28152332635c962a$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $28152332635c962a$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $28152332635c962a$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $28152332635c962a$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $28152332635c962a$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $28152332635c962a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $28152332635c962a$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($28152332635c962a$var$isRedirectResult(actionResult) || $28152332635c962a$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $28152332635c962a$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($28152332635c962a$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $28152332635c962a$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $28152332635c962a$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($28152332635c962a$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($28152332635c962a$var$isDeferredResult(actionResult)) throw $28152332635c962a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $28152332635c962a$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $28152332635c962a$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $28152332635c962a$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $28152332635c962a$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $28152332635c962a$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $28152332635c962a$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $28152332635c962a$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $28152332635c962a$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $28152332635c962a$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $28152332635c962a$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $28152332635c962a$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $28152332635c962a$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $28152332635c962a$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $28152332635c962a$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $28152332635c962a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $28152332635c962a$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($28152332635c962a$var$isDeferredResult(result)) result = await $28152332635c962a$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $28152332635c962a$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($28152332635c962a$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $28152332635c962a$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($28152332635c962a$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $28152332635c962a$export$3e9cee6b33872309(!$28152332635c962a$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $28152332635c962a$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $28152332635c962a$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $28152332635c962a$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $28152332635c962a$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($28152332635c962a$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $28152332635c962a$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $28152332635c962a$export$e19cd5f9376f8cee.Replace : $28152332635c962a$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $28152332635c962a$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($28152332635c962a$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $28152332635c962a$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $28152332635c962a$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $28152332635c962a$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $28152332635c962a$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $28152332635c962a$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($28152332635c962a$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $28152332635c962a$var$ResultType.redirect,
                response: $28152332635c962a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $28152332635c962a$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $28152332635c962a$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $28152332635c962a$var$ResultType.error,
                    error: $28152332635c962a$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $28152332635c962a$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $28152332635c962a$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $28152332635c962a$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $28152332635c962a$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $28152332635c962a$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $28152332635c962a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $28152332635c962a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $28152332635c962a$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $28152332635c962a$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $28152332635c962a$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $28152332635c962a$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $28152332635c962a$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $28152332635c962a$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $28152332635c962a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$28152332635c962a$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $28152332635c962a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $28152332635c962a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $28152332635c962a$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $28152332635c962a$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $28152332635c962a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $28152332635c962a$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $28152332635c962a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $28152332635c962a$export$4d0306f8f6a4585b = Symbol("deferred");
function $28152332635c962a$export$3336b097a6fbc59a(routes, opts) {
    $28152332635c962a$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $28152332635c962a$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $28152332635c962a$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $28152332635c962a$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $28152332635c962a$var$createLocation("", $28152332635c962a$export$fe53371bee54353d(url), null, "default");
        let matches = $28152332635c962a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$28152332635c962a$var$isValidMethod(method) && method !== "HEAD") {
            let error = $28152332635c962a$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $28152332635c962a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $28152332635c962a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $28152332635c962a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($28152332635c962a$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $28152332635c962a$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $28152332635c962a$var$createLocation("", $28152332635c962a$export$fe53371bee54353d(url), null, "default");
        let matches = $28152332635c962a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$28152332635c962a$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $28152332635c962a$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $28152332635c962a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $28152332635c962a$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $28152332635c962a$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $28152332635c962a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($28152332635c962a$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$28152332635c962a$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $28152332635c962a$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($28152332635c962a$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $28152332635c962a$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $28152332635c962a$var$isResponse(result) ? result : $28152332635c962a$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($28152332635c962a$var$isDataStrategyResult(e) && $28152332635c962a$var$isResponse(e.result)) {
                if (e.type === $28152332635c962a$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($28152332635c962a$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $28152332635c962a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $28152332635c962a$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $28152332635c962a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($28152332635c962a$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($28152332635c962a$var$isDeferredResult(result)) {
            let error = $28152332635c962a$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $28152332635c962a$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($28152332635c962a$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($28152332635c962a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $28152332635c962a$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $28152332635c962a$var$_extends({}, context, {
                statusCode: $28152332635c962a$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $28152332635c962a$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $28152332635c962a$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $28152332635c962a$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $28152332635c962a$var$isErrorResult(pendingActionResult[1]) ? $28152332635c962a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $28152332635c962a$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $28152332635c962a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $28152332635c962a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $28152332635c962a$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $28152332635c962a$var$callDataStrategyImpl(dataStrategy || $28152332635c962a$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($28152332635c962a$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $28152332635c962a$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($28152332635c962a$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $28152332635c962a$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $28152332635c962a$export$fec11da027c70692(routes, context, error) {
    let newContext = $28152332635c962a$var$_extends({}, context, {
        statusCode: $28152332635c962a$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $28152332635c962a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $28152332635c962a$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $28152332635c962a$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $28152332635c962a$export$cae722b0cc860f13(to ? to : ".", $28152332635c962a$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $28152332635c962a$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $28152332635c962a$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $28152332635c962a$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $28152332635c962a$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $28152332635c962a$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$28152332635c962a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$28152332635c962a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $28152332635c962a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $28152332635c962a$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $28152332635c962a$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$28152332635c962a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$28152332635c962a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $28152332635c962a$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $28152332635c962a$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $28152332635c962a$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $28152332635c962a$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $28152332635c962a$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($28152332635c962a$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $28152332635c962a$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $28152332635c962a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $28152332635c962a$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $28152332635c962a$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $28152332635c962a$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $28152332635c962a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $28152332635c962a$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $28152332635c962a$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $28152332635c962a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $28152332635c962a$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($28152332635c962a$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $28152332635c962a$var$shouldRevalidateLoader(match, $28152332635c962a$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $28152332635c962a$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $28152332635c962a$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $28152332635c962a$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $28152332635c962a$var$shouldRevalidateLoader(fetcherMatch, $28152332635c962a$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $28152332635c962a$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $28152332635c962a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $28152332635c962a$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $28152332635c962a$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $28152332635c962a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $28152332635c962a$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$28152332635c962a$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $28152332635c962a$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $28152332635c962a$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$28152332635c962a$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $28152332635c962a$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $28152332635c962a$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $28152332635c962a$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$28152332635c962a$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $28152332635c962a$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $28152332635c962a$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $28152332635c962a$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $28152332635c962a$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $28152332635c962a$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $28152332635c962a$var$ResultType.data,
                result: undefined
            });
        };
        return $28152332635c962a$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $28152332635c962a$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $28152332635c962a$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $28152332635c962a$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $28152332635c962a$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $28152332635c962a$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $28152332635c962a$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $28152332635c962a$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($28152332635c962a$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $28152332635c962a$var$ResultType.error,
                error: e
            };
        }
        if (type === $28152332635c962a$var$ResultType.error) return {
            type: $28152332635c962a$var$ResultType.error,
            error: new $28152332635c962a$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $28152332635c962a$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $28152332635c962a$var$ResultType.error) {
        if ($28152332635c962a$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $28152332635c962a$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $28152332635c962a$var$ResultType.error,
                error: new $28152332635c962a$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $28152332635c962a$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $28152332635c962a$var$ResultType.error,
            error: result,
            statusCode: $28152332635c962a$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($28152332635c962a$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $28152332635c962a$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($28152332635c962a$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $28152332635c962a$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $28152332635c962a$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $28152332635c962a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $28152332635c962a$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$28152332635c962a$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $28152332635c962a$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $28152332635c962a$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($28152332635c962a$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $28152332635c962a$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $28152332635c962a$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $28152332635c962a$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($28152332635c962a$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $28152332635c962a$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $28152332635c962a$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $28152332635c962a$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $28152332635c962a$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $28152332635c962a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $28152332635c962a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $28152332635c962a$export$3e9cee6b33872309(!$28152332635c962a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($28152332635c962a$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $28152332635c962a$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $28152332635c962a$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($28152332635c962a$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $28152332635c962a$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $28152332635c962a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $28152332635c962a$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($28152332635c962a$var$isErrorResult(result)) {
            let boundaryMatch = $28152332635c962a$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $28152332635c962a$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($28152332635c962a$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $28152332635c962a$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($28152332635c962a$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $28152332635c962a$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $28152332635c962a$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $28152332635c962a$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $28152332635c962a$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $28152332635c962a$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $28152332635c962a$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $28152332635c962a$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $28152332635c962a$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $28152332635c962a$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $28152332635c962a$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $28152332635c962a$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($28152332635c962a$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $28152332635c962a$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $28152332635c962a$export$8ccf933b0513f8d0(path) : path;
    return $28152332635c962a$export$fe53371bee54353d($28152332635c962a$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $28152332635c962a$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $28152332635c962a$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $28152332635c962a$var$ResultType.data || result.type === $28152332635c962a$var$ResultType.error);
}
function $28152332635c962a$var$isRedirectDataStrategyResultResult(result) {
    return $28152332635c962a$var$isResponse(result.result) && $28152332635c962a$var$redirectStatusCodes.has(result.result.status);
}
function $28152332635c962a$var$isDeferredResult(result) {
    return result.type === $28152332635c962a$var$ResultType.deferred;
}
function $28152332635c962a$var$isErrorResult(result) {
    return result.type === $28152332635c962a$var$ResultType.error;
}
function $28152332635c962a$var$isRedirectResult(result) {
    return (result && result.type) === $28152332635c962a$var$ResultType.redirect;
}
function $28152332635c962a$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $28152332635c962a$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $28152332635c962a$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $28152332635c962a$var$isRedirectResponse(result) {
    if (!$28152332635c962a$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $28152332635c962a$var$isValidMethod(method) {
    return $28152332635c962a$var$validRequestMethods.has(method.toLowerCase());
}
function $28152332635c962a$var$isMutationMethod(method) {
    return $28152332635c962a$var$validMutationMethods.has(method.toLowerCase());
}
async function $28152332635c962a$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$28152332635c962a$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($28152332635c962a$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $28152332635c962a$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $28152332635c962a$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($28152332635c962a$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $28152332635c962a$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $28152332635c962a$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $28152332635c962a$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $28152332635c962a$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $28152332635c962a$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $28152332635c962a$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $28152332635c962a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $28152332635c962a$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $28152332635c962a$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $28152332635c962a$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $28152332635c962a$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $28152332635c962a$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $28152332635c962a$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $28152332635c962a$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $28152332635c962a$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $28152332635c962a$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $28152332635c962a$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $28152332635c962a$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($28152332635c962a$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $28152332635c962a$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($28152332635c962a$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $28152332635c962a$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $2xPiy = parcelRequire("2xPiy");

function $62d58f5c28b15c2e$var$_extends() {
    return $62d58f5c28b15c2e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $62d58f5c28b15c2e$var$_extends.apply(null, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $62d58f5c28b15c2e$export$3add0d5dce533e2e = /*#__PURE__*/ $2xPiy.createContext(null);
$62d58f5c28b15c2e$export$3add0d5dce533e2e.displayName = "DataRouter";
const $62d58f5c28b15c2e$export$145dfa71566a64dc = /*#__PURE__*/ $2xPiy.createContext(null);
$62d58f5c28b15c2e$export$145dfa71566a64dc.displayName = "DataRouterState";
const $62d58f5c28b15c2e$var$AwaitContext = /*#__PURE__*/ $2xPiy.createContext(null);
$62d58f5c28b15c2e$var$AwaitContext.displayName = "Await";
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $62d58f5c28b15c2e$export$26749e8557646306 = /*#__PURE__*/ $2xPiy.createContext(null);
$62d58f5c28b15c2e$export$26749e8557646306.displayName = "Navigation";
const $62d58f5c28b15c2e$export$c7914228fb69b0f5 = /*#__PURE__*/ $2xPiy.createContext(null);
$62d58f5c28b15c2e$export$c7914228fb69b0f5.displayName = "Location";
const $62d58f5c28b15c2e$export$9072aa6dd1f93057 = /*#__PURE__*/ $2xPiy.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$62d58f5c28b15c2e$export$9072aa6dd1f93057.displayName = "Route";
const $62d58f5c28b15c2e$var$RouteErrorContext = /*#__PURE__*/ $2xPiy.createContext(null);
$62d58f5c28b15c2e$var$RouteErrorContext.displayName = "RouteError";
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $62d58f5c28b15c2e$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$62d58f5c28b15c2e$export$9c954a9d03d32f4a() && (0, $28152332635c962a$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component.");
    let { basename: basename, navigator: navigator } = $2xPiy.useContext($62d58f5c28b15c2e$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $62d58f5c28b15c2e$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $28152332635c962a$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $62d58f5c28b15c2e$export$9c954a9d03d32f4a() {
    return $2xPiy.useContext($62d58f5c28b15c2e$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $62d58f5c28b15c2e$export$45d76561a5302f2b() {
    !$62d58f5c28b15c2e$export$9c954a9d03d32f4a() && (0, $28152332635c962a$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component.");
    return $2xPiy.useContext($62d58f5c28b15c2e$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $62d58f5c28b15c2e$export$1b3f31771c5d07c() {
    return $2xPiy.useContext($62d58f5c28b15c2e$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $62d58f5c28b15c2e$export$6c330e8992e8a295(pattern) {
    !$62d58f5c28b15c2e$export$9c954a9d03d32f4a() && (0, $28152332635c962a$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useMatch() may be used only in the context of a <Router> component.");
    let { pathname: pathname } = $62d58f5c28b15c2e$export$45d76561a5302f2b();
    return $2xPiy.useMemo(()=>(0, $28152332635c962a$export$81336c211d5ff295)(pattern, (0, $28152332635c962a$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $62d58f5c28b15c2e$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $62d58f5c28b15c2e$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $2xPiy.useContext($62d58f5c28b15c2e$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $2xPiy.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $62d58f5c28b15c2e$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $2xPiy.useContext($62d58f5c28b15c2e$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $62d58f5c28b15c2e$var$useNavigateStable() : $62d58f5c28b15c2e$var$useNavigateUnstable();
}
function $62d58f5c28b15c2e$var$useNavigateUnstable() {
    !$62d58f5c28b15c2e$export$9c954a9d03d32f4a() && (0, $28152332635c962a$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component.");
    let dataRouterContext = $2xPiy.useContext($62d58f5c28b15c2e$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $2xPiy.useContext($62d58f5c28b15c2e$export$26749e8557646306);
    let { matches: matches } = $2xPiy.useContext($62d58f5c28b15c2e$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $62d58f5c28b15c2e$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $28152332635c962a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $2xPiy.useRef(false);
    $62d58f5c28b15c2e$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $2xPiy.useCallback(function(to, options) {
        if (options === void 0) options = {};
        (0, $28152332635c962a$export$c0e02632e14916fd)(activeRef.current, $62d58f5c28b15c2e$var$navigateEffectWarning);
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $28152332635c962a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $28152332635c962a$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $62d58f5c28b15c2e$var$OutletContext = /*#__PURE__*/ $2xPiy.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $62d58f5c28b15c2e$export$4138103a3ae699cc() {
    return $2xPiy.useContext($62d58f5c28b15c2e$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $62d58f5c28b15c2e$export$a3be3530d8e40d0b(context) {
    let outlet = $2xPiy.useContext($62d58f5c28b15c2e$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $2xPiy.createElement($62d58f5c28b15c2e$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $62d58f5c28b15c2e$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $2xPiy.useContext($62d58f5c28b15c2e$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $62d58f5c28b15c2e$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $2xPiy.useContext($62d58f5c28b15c2e$export$26749e8557646306);
    let { matches: matches } = $2xPiy.useContext($62d58f5c28b15c2e$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $62d58f5c28b15c2e$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $28152332635c962a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $2xPiy.useMemo(()=>(0, $28152332635c962a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $62d58f5c28b15c2e$export$5d3fca4a98652595(routes, locationArg) {
    return $62d58f5c28b15c2e$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $62d58f5c28b15c2e$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$62d58f5c28b15c2e$export$9c954a9d03d32f4a() && (0, $28152332635c962a$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component.");
    let { navigator: navigator } = $2xPiy.useContext($62d58f5c28b15c2e$export$26749e8557646306);
    let { matches: parentMatches } = $2xPiy.useContext($62d58f5c28b15c2e$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    {
        // You won't get a warning about 2 different <Routes> under a <Route>
        // without a trailing *, but this is a best-effort warning anyway since we
        // cannot even give the warning unless they land at the parent route.
        //
        // Example:
        //
        // <Routes>
        //   {/* This route path MUST end with /* because otherwise
        //       it will never match /blog/post/123 */}
        //   <Route path="blog" element={<Blog />} />
        //   <Route path="blog/feed" element={<BlogFeed />} />
        // </Routes>
        //
        // function Blog() {
        //   return (
        //     <Routes>
        //       <Route path="post/:id" element={<Post />} />
        //     </Routes>
        //   );
        // }
        let parentPath = parentRoute && parentRoute.path || "";
        $62d58f5c28b15c2e$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*"), "You rendered descendant <Routes> (or called `useRoutes()`) at " + ("\"" + parentPathname + "\" (under <Route path=\"" + parentPath + "\">) but the ") + "parent route path has no trailing \"*\". This means if you navigate " + "deeper, the parent won't match anymore and therefore the child " + "routes will never render.\n\n" + ("Please change the parent <Route path=\"" + parentPath + "\"> to <Route ") + ("path=\"" + (parentPath === "/" ? "*" : parentPath + "/*") + "\">."));
    }
    let locationFromContext = $62d58f5c28b15c2e$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $28152332635c962a$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $28152332635c962a$export$3e9cee6b33872309)(false, "When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was " + ("matched by all parent routes. The current pathname base is \"" + parentPathnameBase + "\" ") + ("but pathname \"" + parsedLocationArg.pathname + "\" was given in the `location` prop."));
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $28152332635c962a$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    (0, $28152332635c962a$export$c0e02632e14916fd)(parentRoute || matches != null, "No routes matched location \"" + location.pathname + location.search + location.hash + "\" ");
    (0, $28152332635c962a$export$c0e02632e14916fd)(matches == null || matches[matches.length - 1].route.element !== undefined || matches[matches.length - 1].route.Component !== undefined || matches[matches.length - 1].route.lazy !== undefined, "Matched leaf route at location \"" + location.pathname + location.search + location.hash + "\" " + "does not have an element or Component. This means it will render an <Outlet /> with a " + "null value by default resulting in an \"empty\" page.");
    let renderedMatches = $62d58f5c28b15c2e$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $28152332635c962a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $28152332635c962a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $2xPiy.createElement($62d58f5c28b15c2e$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $62d58f5c28b15c2e$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $28152332635c962a$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $62d58f5c28b15c2e$var$DefaultErrorComponent() {
    let error = $62d58f5c28b15c2e$export$ed527bf60f6e05f2();
    let message = (0, $28152332635c962a$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    console.error("Error handled by React Router default ErrorBoundary:", error);
    devInfo = /*#__PURE__*/ $2xPiy.createElement($2xPiy.Fragment, null, /*#__PURE__*/ $2xPiy.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /*#__PURE__*/ $2xPiy.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /*#__PURE__*/ $2xPiy.createElement("code", {
        style: codeStyles
    }, "ErrorBoundary"), " or", " ", /*#__PURE__*/ $2xPiy.createElement("code", {
        style: codeStyles
    }, "errorElement"), " prop on your route."));
    return /*#__PURE__*/ $2xPiy.createElement($2xPiy.Fragment, null, /*#__PURE__*/ $2xPiy.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $2xPiy.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $2xPiy.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $62d58f5c28b15c2e$var$defaultErrorElement = /*#__PURE__*/ $2xPiy.createElement($62d58f5c28b15c2e$var$DefaultErrorComponent, null);
class $62d58f5c28b15c2e$var$RenderErrorBoundary extends $2xPiy.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $2xPiy.createElement($62d58f5c28b15c2e$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $2xPiy.createElement($62d58f5c28b15c2e$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $62d58f5c28b15c2e$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $2xPiy.useContext($62d58f5c28b15c2e$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $2xPiy.createElement($62d58f5c28b15c2e$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $62d58f5c28b15c2e$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $28152332635c962a$export$3e9cee6b33872309)(false, "Could not find a matching route for errors on route IDs: " + Object.keys(errors).join(","));
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $62d58f5c28b15c2e$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $62d58f5c28b15c2e$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $2xPiy.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $2xPiy.createElement($62d58f5c28b15c2e$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $2xPiy.createElement($62d58f5c28b15c2e$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $62d58f5c28b15c2e$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($62d58f5c28b15c2e$var$DataRouterHook || {});
var $62d58f5c28b15c2e$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($62d58f5c28b15c2e$var$DataRouterStateHook || {});
function $62d58f5c28b15c2e$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $62d58f5c28b15c2e$var$useDataRouterContext(hookName) {
    let ctx = $2xPiy.useContext($62d58f5c28b15c2e$export$3add0d5dce533e2e);
    !ctx && (0, $28152332635c962a$export$3e9cee6b33872309)(false, $62d58f5c28b15c2e$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $62d58f5c28b15c2e$var$useDataRouterState(hookName) {
    let state = $2xPiy.useContext($62d58f5c28b15c2e$export$145dfa71566a64dc);
    !state && (0, $28152332635c962a$export$3e9cee6b33872309)(false, $62d58f5c28b15c2e$var$getDataRouterConsoleError(hookName));
    return state;
}
function $62d58f5c28b15c2e$var$useRouteContext(hookName) {
    let route = $2xPiy.useContext($62d58f5c28b15c2e$export$9072aa6dd1f93057);
    !route && (0, $28152332635c962a$export$3e9cee6b33872309)(false, $62d58f5c28b15c2e$var$getDataRouterConsoleError(hookName));
    return route;
}
// Internal version with hookName-aware debugging
function $62d58f5c28b15c2e$var$useCurrentRouteId(hookName) {
    let route = $62d58f5c28b15c2e$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $28152332635c962a$export$3e9cee6b33872309)(false, hookName + " can only be used on routes that contain a unique \"id\"");
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $62d58f5c28b15c2e$export$5fc8298006ad9e58() {
    return $62d58f5c28b15c2e$var$useCurrentRouteId($62d58f5c28b15c2e$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $62d58f5c28b15c2e$export$d0fd4b7106de2769() {
    let state = $62d58f5c28b15c2e$var$useDataRouterState($62d58f5c28b15c2e$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $62d58f5c28b15c2e$export$600dc272ed516c15() {
    let dataRouterContext = $62d58f5c28b15c2e$var$useDataRouterContext($62d58f5c28b15c2e$var$DataRouterHook.UseRevalidator);
    let state = $62d58f5c28b15c2e$var$useDataRouterState($62d58f5c28b15c2e$var$DataRouterStateHook.UseRevalidator);
    return $2xPiy.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $62d58f5c28b15c2e$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $62d58f5c28b15c2e$var$useDataRouterState($62d58f5c28b15c2e$var$DataRouterStateHook.UseMatches);
    return $2xPiy.useMemo(()=>matches.map((m)=>(0, $28152332635c962a$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $62d58f5c28b15c2e$export$1448a5050d252c4d() {
    let state = $62d58f5c28b15c2e$var$useDataRouterState($62d58f5c28b15c2e$var$DataRouterStateHook.UseLoaderData);
    let routeId = $62d58f5c28b15c2e$var$useCurrentRouteId($62d58f5c28b15c2e$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $62d58f5c28b15c2e$export$fd5d37484eab868d(routeId) {
    let state = $62d58f5c28b15c2e$var$useDataRouterState($62d58f5c28b15c2e$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $62d58f5c28b15c2e$export$fdc00f3f26066d5e() {
    let state = $62d58f5c28b15c2e$var$useDataRouterState($62d58f5c28b15c2e$var$DataRouterStateHook.UseActionData);
    let routeId = $62d58f5c28b15c2e$var$useCurrentRouteId($62d58f5c28b15c2e$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $62d58f5c28b15c2e$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $2xPiy.useContext($62d58f5c28b15c2e$var$RouteErrorContext);
    let state = $62d58f5c28b15c2e$var$useDataRouterState($62d58f5c28b15c2e$var$DataRouterStateHook.UseRouteError);
    let routeId = $62d58f5c28b15c2e$var$useCurrentRouteId($62d58f5c28b15c2e$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $62d58f5c28b15c2e$export$78a72ddb39bdd145() {
    let value = $2xPiy.useContext($62d58f5c28b15c2e$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $62d58f5c28b15c2e$export$17f53340677d5831() {
    let value = $2xPiy.useContext($62d58f5c28b15c2e$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $62d58f5c28b15c2e$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $62d58f5c28b15c2e$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $62d58f5c28b15c2e$var$useDataRouterContext($62d58f5c28b15c2e$var$DataRouterHook.UseBlocker);
    let state = $62d58f5c28b15c2e$var$useDataRouterState($62d58f5c28b15c2e$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $2xPiy.useState("");
    let blockerFunction = $2xPiy.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $62d58f5c28b15c2e$var$_extends({}, currentLocation, {
                pathname: (0, $28152332635c962a$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $62d58f5c28b15c2e$var$_extends({}, nextLocation, {
                pathname: (0, $28152332635c962a$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $2xPiy.useEffect(()=>{
        let key = String(++$62d58f5c28b15c2e$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $2xPiy.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $28152332635c962a$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $62d58f5c28b15c2e$var$useNavigateStable() {
    let { router: router } = $62d58f5c28b15c2e$var$useDataRouterContext($62d58f5c28b15c2e$var$DataRouterHook.UseNavigateStable);
    let id = $62d58f5c28b15c2e$var$useCurrentRouteId($62d58f5c28b15c2e$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $2xPiy.useRef(false);
    $62d58f5c28b15c2e$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $2xPiy.useCallback(function(to, options) {
        if (options === void 0) options = {};
        (0, $28152332635c962a$export$c0e02632e14916fd)(activeRef.current, $62d58f5c28b15c2e$var$navigateEffectWarning);
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $62d58f5c28b15c2e$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $62d58f5c28b15c2e$var$alreadyWarned$1 = {};
function $62d58f5c28b15c2e$var$warningOnce(key, cond, message) {
    if (!cond && !$62d58f5c28b15c2e$var$alreadyWarned$1[key]) {
        $62d58f5c28b15c2e$var$alreadyWarned$1[key] = true;
        (0, $28152332635c962a$export$c0e02632e14916fd)(false, message);
    }
}
const $62d58f5c28b15c2e$var$alreadyWarned = {};
function $62d58f5c28b15c2e$var$warnOnce(key, message) {
    if (!$62d58f5c28b15c2e$var$alreadyWarned[message]) {
        $62d58f5c28b15c2e$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}
const $62d58f5c28b15c2e$var$logDeprecation = (flag, msg, link)=>$62d58f5c28b15c2e$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $62d58f5c28b15c2e$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $62d58f5c28b15c2e$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $62d58f5c28b15c2e$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $62d58f5c28b15c2e$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $62d58f5c28b15c2e$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $62d58f5c28b15c2e$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $62d58f5c28b15c2e$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $62d58f5c28b15c2e$var$START_TRANSITION = "startTransition";
const $62d58f5c28b15c2e$var$startTransitionImpl = $2xPiy[$62d58f5c28b15c2e$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $62d58f5c28b15c2e$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $2xPiy.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $2xPiy.useCallback((newState)=>{
        if (v7_startTransition && $62d58f5c28b15c2e$var$startTransitionImpl) $62d58f5c28b15c2e$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $2xPiy.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $2xPiy.useEffect(()=>{
        (0, $28152332635c962a$export$c0e02632e14916fd)(fallbackElement == null || !router.future.v7_partialHydration, "`<RouterProvider fallbackElement>` is deprecated when using `v7_partialHydration`, use a `HydrateFallback` component instead");
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $2xPiy.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $2xPiy.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $2xPiy.useEffect(()=>$62d58f5c28b15c2e$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $2xPiy.createElement($2xPiy.Fragment, null, /*#__PURE__*/ $2xPiy.createElement($62d58f5c28b15c2e$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $2xPiy.createElement($62d58f5c28b15c2e$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $2xPiy.createElement($62d58f5c28b15c2e$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $2xPiy.createElement($62d58f5c28b15c2e$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $62d58f5c28b15c2e$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $62d58f5c28b15c2e$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $62d58f5c28b15c2e$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $2xPiy.useRef();
    if (historyRef.current == null) historyRef.current = (0, $28152332635c962a$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $2xPiy.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $2xPiy.useCallback((newState)=>{
        v7_startTransition && $62d58f5c28b15c2e$var$startTransitionImpl ? $62d58f5c28b15c2e$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $2xPiy.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $2xPiy.useEffect(()=>$62d58f5c28b15c2e$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $2xPiy.createElement($62d58f5c28b15c2e$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $62d58f5c28b15c2e$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$62d58f5c28b15c2e$export$9c954a9d03d32f4a() && (0, $28152332635c962a$export$3e9cee6b33872309)(false, // the router loaded. We can help them understand how to avoid that.
    "<Navigate> may be used only in the context of a <Router> component.");
    let { future: future, static: isStatic } = $2xPiy.useContext($62d58f5c28b15c2e$export$26749e8557646306);
    (0, $28152332635c962a$export$c0e02632e14916fd)(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    let { matches: matches } = $2xPiy.useContext($62d58f5c28b15c2e$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $62d58f5c28b15c2e$export$45d76561a5302f2b();
    let navigate = $62d58f5c28b15c2e$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $28152332635c962a$export$cae722b0cc860f13)(to, (0, $28152332635c962a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $2xPiy.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $62d58f5c28b15c2e$export$910ae8079b2c2852(props) {
    return $62d58f5c28b15c2e$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $62d58f5c28b15c2e$export$e7b0ac011bb776c6(_props) {
    (0, $28152332635c962a$export$3e9cee6b33872309)(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $62d58f5c28b15c2e$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $28152332635c962a$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$62d58f5c28b15c2e$export$9c954a9d03d32f4a() && (0, $28152332635c962a$export$3e9cee6b33872309)(false, "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $2xPiy.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $62d58f5c28b15c2e$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $28152332635c962a$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $2xPiy.useMemo(()=>{
        let trailingPathname = (0, $28152332635c962a$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    (0, $28152332635c962a$export$c0e02632e14916fd)(locationContext != null, "<Router basename=\"" + basename + "\"> is not able to match the URL " + ("\"" + pathname + search + hash + "\" because it does not start with the ") + "basename, so the <Router> won't render anything.");
    if (locationContext == null) return null;
    return /*#__PURE__*/ $2xPiy.createElement($62d58f5c28b15c2e$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $2xPiy.createElement($62d58f5c28b15c2e$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $62d58f5c28b15c2e$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $62d58f5c28b15c2e$export$5d3fca4a98652595($62d58f5c28b15c2e$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $62d58f5c28b15c2e$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $2xPiy.createElement($62d58f5c28b15c2e$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $2xPiy.createElement($62d58f5c28b15c2e$var$ResolveAwait, null, children));
}
var $62d58f5c28b15c2e$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($62d58f5c28b15c2e$var$AwaitRenderStatus || {});
const $62d58f5c28b15c2e$var$neverSettledPromise = new Promise(()=>{});
class $62d58f5c28b15c2e$var$AwaitErrorBoundary extends $2xPiy.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $62d58f5c28b15c2e$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $62d58f5c28b15c2e$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $62d58f5c28b15c2e$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $62d58f5c28b15c2e$var$AwaitRenderStatus.error : "_data" in promise ? $62d58f5c28b15c2e$var$AwaitRenderStatus.success : $62d58f5c28b15c2e$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $62d58f5c28b15c2e$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $62d58f5c28b15c2e$var$AwaitRenderStatus.error && promise._error instanceof (0, $28152332635c962a$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $62d58f5c28b15c2e$var$neverSettledPromise;
        if (status === $62d58f5c28b15c2e$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $62d58f5c28b15c2e$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $2xPiy.createElement($62d58f5c28b15c2e$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $62d58f5c28b15c2e$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $2xPiy.createElement($62d58f5c28b15c2e$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $62d58f5c28b15c2e$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $62d58f5c28b15c2e$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $2xPiy.createElement($2xPiy.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $62d58f5c28b15c2e$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $2xPiy.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $2xPiy.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $2xPiy.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $62d58f5c28b15c2e$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $62d58f5c28b15c2e$export$e7b0ac011bb776c6) && (0, $28152332635c962a$export$3e9cee6b33872309)(false, "[" + (typeof element.type === "string" ? element.type : element.type.name) + "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>");
        !(!element.props.index || !element.props.children) && (0, $28152332635c962a$export$3e9cee6b33872309)(false, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $62d58f5c28b15c2e$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $62d58f5c28b15c2e$export$daf73786167a7f72(matches) {
    return $62d58f5c28b15c2e$var$_renderMatches(matches);
}
function $62d58f5c28b15c2e$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if (route.element) (0, $28152332635c962a$export$c0e02632e14916fd)(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        Object.assign(updates, {
            element: /*#__PURE__*/ $2xPiy.createElement(route.Component),
            Component: undefined
        });
    }
    if (route.HydrateFallback) {
        if (route.hydrateFallbackElement) (0, $28152332635c962a$export$c0e02632e14916fd)(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        Object.assign(updates, {
            hydrateFallbackElement: /*#__PURE__*/ $2xPiy.createElement(route.HydrateFallback),
            HydrateFallback: undefined
        });
    }
    if (route.ErrorBoundary) {
        if (route.errorElement) (0, $28152332635c962a$export$c0e02632e14916fd)(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        Object.assign(updates, {
            errorElement: /*#__PURE__*/ $2xPiy.createElement(route.ErrorBoundary),
            ErrorBoundary: undefined
        });
    }
    return updates;
}
function $62d58f5c28b15c2e$export$f30f7e456d254e83(routes, opts) {
    return (0, $28152332635c962a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $62d58f5c28b15c2e$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $28152332635c962a$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $62d58f5c28b15c2e$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $79bcac94ca400be1$var$_extends() {
    return $79bcac94ca400be1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $79bcac94ca400be1$var$_extends.apply(null, arguments);
}
function $79bcac94ca400be1$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $79bcac94ca400be1$var$defaultMethod = "get";
const $79bcac94ca400be1$var$defaultEncType = "application/x-www-form-urlencoded";
function $79bcac94ca400be1$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $79bcac94ca400be1$var$isButtonElement(object) {
    return $79bcac94ca400be1$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $79bcac94ca400be1$var$isFormElement(object) {
    return $79bcac94ca400be1$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $79bcac94ca400be1$var$isInputElement(object) {
    return $79bcac94ca400be1$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $79bcac94ca400be1$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $79bcac94ca400be1$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$79bcac94ca400be1$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $79bcac94ca400be1$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $79bcac94ca400be1$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $79bcac94ca400be1$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $79bcac94ca400be1$var$_formDataSupportsSubmitter = null;
function $79bcac94ca400be1$var$isFormDataSubmitterSupported() {
    if ($79bcac94ca400be1$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $79bcac94ca400be1$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $79bcac94ca400be1$var$_formDataSupportsSubmitter = true;
    }
    return $79bcac94ca400be1$var$_formDataSupportsSubmitter;
}
const $79bcac94ca400be1$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $79bcac94ca400be1$var$getFormEncType(encType) {
    if (encType != null && !$79bcac94ca400be1$var$supportedFormEncTypes.has(encType)) {
        (0, $28152332635c962a$export$c0e02632e14916fd)(false, "\"" + encType + "\" is not a valid `encType` for `<Form>`/`<fetcher.Form>` " + ("and will default to \"" + $79bcac94ca400be1$var$defaultEncType + "\""));
        return null;
    }
    return encType;
}
function $79bcac94ca400be1$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($79bcac94ca400be1$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $28152332635c962a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $79bcac94ca400be1$var$defaultMethod;
        encType = $79bcac94ca400be1$var$getFormEncType(target.getAttribute("enctype")) || $79bcac94ca400be1$var$defaultEncType;
        formData = new FormData(target);
    } else if ($79bcac94ca400be1$var$isButtonElement(target) || $79bcac94ca400be1$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $28152332635c962a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $79bcac94ca400be1$var$defaultMethod;
        encType = $79bcac94ca400be1$var$getFormEncType(target.getAttribute("formenctype")) || $79bcac94ca400be1$var$getFormEncType(form.getAttribute("enctype")) || $79bcac94ca400be1$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$79bcac94ca400be1$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($79bcac94ca400be1$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $79bcac94ca400be1$var$defaultMethod;
        action = null;
        encType = $79bcac94ca400be1$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $79bcac94ca400be1$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $79bcac94ca400be1$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $79bcac94ca400be1$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $79bcac94ca400be1$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $79bcac94ca400be1$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $79bcac94ca400be1$export$1f3f55432a00e06d(routes, opts) {
    return (0, $28152332635c962a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $79bcac94ca400be1$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $28152332635c962a$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $79bcac94ca400be1$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $62d58f5c28b15c2e$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $79bcac94ca400be1$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $28152332635c962a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $79bcac94ca400be1$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $28152332635c962a$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $79bcac94ca400be1$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $62d58f5c28b15c2e$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $79bcac94ca400be1$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $79bcac94ca400be1$var$_extends({}, state, {
        errors: $79bcac94ca400be1$var$deserializeErrors(state.errors)
    });
    return state;
}
function $79bcac94ca400be1$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $28152332635c962a$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $79bcac94ca400be1$export$7ad602f0e94e62d1 = /*#__PURE__*/ $2xPiy.createContext({
    isTransitioning: false
});
$79bcac94ca400be1$export$7ad602f0e94e62d1.displayName = "ViewTransition";
const $79bcac94ca400be1$export$148fd98d095596d4 = /*#__PURE__*/ $2xPiy.createContext(new Map());
$79bcac94ca400be1$export$148fd98d095596d4.displayName = "Fetchers";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $79bcac94ca400be1$var$START_TRANSITION = "startTransition";
const $79bcac94ca400be1$var$startTransitionImpl = $2xPiy[$79bcac94ca400be1$var$START_TRANSITION];
const $79bcac94ca400be1$var$FLUSH_SYNC = "flushSync";
const $79bcac94ca400be1$var$flushSyncImpl = $cX5wj[$79bcac94ca400be1$var$FLUSH_SYNC];
const $79bcac94ca400be1$var$USE_ID = "useId";
const $79bcac94ca400be1$var$useIdImpl = $2xPiy[$79bcac94ca400be1$var$USE_ID];
function $79bcac94ca400be1$var$startTransitionSafe(cb) {
    if ($79bcac94ca400be1$var$startTransitionImpl) $79bcac94ca400be1$var$startTransitionImpl(cb);
    else cb();
}
function $79bcac94ca400be1$var$flushSyncSafe(cb) {
    if ($79bcac94ca400be1$var$flushSyncImpl) $79bcac94ca400be1$var$flushSyncImpl(cb);
    else cb();
}
class $79bcac94ca400be1$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $79bcac94ca400be1$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $2xPiy.useState(router.state);
    let [pendingState, setPendingState] = $2xPiy.useState();
    let [vtContext, setVtContext] = $2xPiy.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $2xPiy.useState();
    let [transition, setTransition] = $2xPiy.useState();
    let [interruption, setInterruption] = $2xPiy.useState();
    let fetcherData = $2xPiy.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $2xPiy.useCallback((cb)=>{
        if (v7_startTransition) $79bcac94ca400be1$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $2xPiy.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $79bcac94ca400be1$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $79bcac94ca400be1$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $79bcac94ca400be1$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $79bcac94ca400be1$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $79bcac94ca400be1$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $2xPiy.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $2xPiy.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $79bcac94ca400be1$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $2xPiy.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $2xPiy.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $2xPiy.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $2xPiy.useEffect(()=>{
        (0, $28152332635c962a$export$c0e02632e14916fd)(fallbackElement == null || !router.future.v7_partialHydration, "`<RouterProvider fallbackElement>` is deprecated when using `v7_partialHydration`, use a `HydrateFallback` component instead");
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $2xPiy.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $2xPiy.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $2xPiy.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $2xPiy.useEffect(()=>(0, $62d58f5c28b15c2e$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $2xPiy.createElement($2xPiy.Fragment, null, /*#__PURE__*/ $2xPiy.createElement((0, $62d58f5c28b15c2e$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $2xPiy.createElement((0, $62d58f5c28b15c2e$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $2xPiy.createElement($79bcac94ca400be1$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $2xPiy.createElement($79bcac94ca400be1$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $2xPiy.createElement((0, $62d58f5c28b15c2e$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $2xPiy.createElement($79bcac94ca400be1$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $79bcac94ca400be1$var$MemoizedDataRoutes = /*#__PURE__*/ $2xPiy.memo($79bcac94ca400be1$var$DataRoutes);
function $79bcac94ca400be1$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $62d58f5c28b15c2e$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $79bcac94ca400be1$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $2xPiy.useRef();
    if (historyRef.current == null) historyRef.current = (0, $28152332635c962a$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $2xPiy.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $2xPiy.useCallback((newState)=>{
        v7_startTransition && $79bcac94ca400be1$var$startTransitionImpl ? $79bcac94ca400be1$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $2xPiy.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $2xPiy.useEffect(()=>(0, $62d58f5c28b15c2e$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $2xPiy.createElement((0, $62d58f5c28b15c2e$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $79bcac94ca400be1$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $2xPiy.useRef();
    if (historyRef.current == null) historyRef.current = (0, $28152332635c962a$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $2xPiy.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $2xPiy.useCallback((newState)=>{
        v7_startTransition && $79bcac94ca400be1$var$startTransitionImpl ? $79bcac94ca400be1$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $2xPiy.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $2xPiy.useEffect(()=>(0, $62d58f5c28b15c2e$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $2xPiy.createElement((0, $62d58f5c28b15c2e$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $79bcac94ca400be1$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $2xPiy.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $2xPiy.useCallback((newState)=>{
        v7_startTransition && $79bcac94ca400be1$var$startTransitionImpl ? $79bcac94ca400be1$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $2xPiy.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $2xPiy.useEffect(()=>(0, $62d58f5c28b15c2e$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $2xPiy.createElement((0, $62d58f5c28b15c2e$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
$79bcac94ca400be1$export$eefb0c834599897e.displayName = "unstable_HistoryRouter";
const $79bcac94ca400be1$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $79bcac94ca400be1$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $79bcac94ca400be1$export$a6c7ac8248d6e38a = /*#__PURE__*/ $2xPiy.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $79bcac94ca400be1$var$_objectWithoutPropertiesLoose(_ref7, $79bcac94ca400be1$var$_excluded);
    let { basename: basename } = $2xPiy.useContext((0, $62d58f5c28b15c2e$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $79bcac94ca400be1$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($79bcac94ca400be1$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $28152332635c962a$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            // We can't do external URL detection without a valid URL
            (0, $28152332635c962a$export$c0e02632e14916fd)(false, "<Link to=\"" + to + "\"> contains an invalid URL which will probably break " + "when clicked - please update to a valid URL path.");
        }
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $62d58f5c28b15c2e$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $79bcac94ca400be1$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $2xPiy.createElement("a", $79bcac94ca400be1$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
$79bcac94ca400be1$export$a6c7ac8248d6e38a.displayName = "Link";
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $79bcac94ca400be1$export$b0d92dbee9b5b60d = /*#__PURE__*/ $2xPiy.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $79bcac94ca400be1$var$_objectWithoutPropertiesLoose(_ref8, $79bcac94ca400be1$var$_excluded2);
    let path = (0, $62d58f5c28b15c2e$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $62d58f5c28b15c2e$export$45d76561a5302f2b)();
    let routerState = $2xPiy.useContext((0, $62d58f5c28b15c2e$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $2xPiy.useContext((0, $62d58f5c28b15c2e$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $79bcac94ca400be1$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $28152332635c962a$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $2xPiy.createElement($79bcac94ca400be1$export$a6c7ac8248d6e38a, $79bcac94ca400be1$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
$79bcac94ca400be1$export$b0d92dbee9b5b60d.displayName = "NavLink";
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $79bcac94ca400be1$export$a7fed597f4b8afd8 = /*#__PURE__*/ $2xPiy.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $79bcac94ca400be1$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $79bcac94ca400be1$var$_objectWithoutPropertiesLoose(_ref9, $79bcac94ca400be1$var$_excluded3);
    let submit = $79bcac94ca400be1$export$47c85c6e3a081d3();
    let formAction = $79bcac94ca400be1$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $2xPiy.createElement("form", $79bcac94ca400be1$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
$79bcac94ca400be1$export$a7fed597f4b8afd8.displayName = "Form";
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $79bcac94ca400be1$export$11aac1aab828f1fa(_ref0) {
    let { getKey: getKey, storageKey: storageKey } = _ref0;
    $79bcac94ca400be1$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
$79bcac94ca400be1$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $79bcac94ca400be1$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($79bcac94ca400be1$var$DataRouterHook || ($79bcac94ca400be1$var$DataRouterHook = {}));
var $79bcac94ca400be1$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($79bcac94ca400be1$var$DataRouterStateHook || ($79bcac94ca400be1$var$DataRouterStateHook = {}));
// Internal hooks
function $79bcac94ca400be1$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $79bcac94ca400be1$var$useDataRouterContext(hookName) {
    let ctx = $2xPiy.useContext((0, $62d58f5c28b15c2e$export$3add0d5dce533e2e));
    !ctx && (0, $28152332635c962a$export$3e9cee6b33872309)(false, $79bcac94ca400be1$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $79bcac94ca400be1$var$useDataRouterState(hookName) {
    let state = $2xPiy.useContext((0, $62d58f5c28b15c2e$export$145dfa71566a64dc));
    !state && (0, $28152332635c962a$export$3e9cee6b33872309)(false, $79bcac94ca400be1$var$getDataRouterConsoleError(hookName));
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $79bcac94ca400be1$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    let location = (0, $62d58f5c28b15c2e$export$45d76561a5302f2b)();
    let path = (0, $62d58f5c28b15c2e$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $2xPiy.useCallback((event)=>{
        if ($79bcac94ca400be1$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $28152332635c962a$export$fe53371bee54353d)(location) === (0, $28152332635c962a$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $79bcac94ca400be1$export$f1a78c17382fe22a(defaultInit) {
    (0, $28152332635c962a$export$c0e02632e14916fd)(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
    let defaultSearchParamsRef = $2xPiy.useRef($79bcac94ca400be1$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $2xPiy.useRef(false);
    let location = (0, $62d58f5c28b15c2e$export$45d76561a5302f2b)();
    let searchParams = $2xPiy.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $79bcac94ca400be1$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    let setSearchParams = $2xPiy.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $79bcac94ca400be1$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $79bcac94ca400be1$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $79bcac94ca400be1$var$fetcherId = 0;
let $79bcac94ca400be1$var$getUniqueFetcherId = ()=>"__" + String(++$79bcac94ca400be1$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $79bcac94ca400be1$export$47c85c6e3a081d3() {
    let { router: router } = $79bcac94ca400be1$var$useDataRouterContext($79bcac94ca400be1$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $2xPiy.useContext((0, $62d58f5c28b15c2e$export$26749e8557646306));
    let currentRouteId = (0, $62d58f5c28b15c2e$export$5fc8298006ad9e58)();
    return $2xPiy.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $79bcac94ca400be1$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $79bcac94ca400be1$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $79bcac94ca400be1$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $79bcac94ca400be1$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $2xPiy.useContext((0, $62d58f5c28b15c2e$export$26749e8557646306));
    let routeContext = $2xPiy.useContext((0, $62d58f5c28b15c2e$export$9072aa6dd1f93057));
    !routeContext && (0, $28152332635c962a$export$3e9cee6b33872309)(false, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $79bcac94ca400be1$var$_extends({}, (0, $62d58f5c28b15c2e$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $62d58f5c28b15c2e$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $28152332635c962a$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $28152332635c962a$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $79bcac94ca400be1$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $79bcac94ca400be1$var$useDataRouterContext($79bcac94ca400be1$var$DataRouterHook.UseFetcher);
    let state = $79bcac94ca400be1$var$useDataRouterState($79bcac94ca400be1$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $2xPiy.useContext($79bcac94ca400be1$export$148fd98d095596d4);
    let route = $2xPiy.useContext((0, $62d58f5c28b15c2e$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $28152332635c962a$export$3e9cee6b33872309)(false, "useFetcher must be used inside a FetchersContext");
    !route && (0, $28152332635c962a$export$3e9cee6b33872309)(false, "useFetcher must be used inside a RouteContext");
    !(routeId != null) && (0, $28152332635c962a$export$3e9cee6b33872309)(false, "useFetcher can only be used on routes that contain a unique \"id\"");
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $79bcac94ca400be1$var$useIdImpl ? $79bcac94ca400be1$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $2xPiy.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($79bcac94ca400be1$var$getUniqueFetcherId());
    // Registration/cleanup
    $2xPiy.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $2xPiy.useCallback((href, opts)=>{
        !routeId && (0, $28152332635c962a$export$3e9cee6b33872309)(false, "No routeId available for fetcher.load()");
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $79bcac94ca400be1$export$47c85c6e3a081d3();
    let submit = $2xPiy.useCallback((target, opts)=>{
        submitImpl(target, $79bcac94ca400be1$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $2xPiy.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $2xPiy.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $2xPiy.createElement($79bcac94ca400be1$export$a7fed597f4b8afd8, $79bcac94ca400be1$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        FetcherForm.displayName = "fetcher.Form";
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $28152332635c962a$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $2xPiy.useMemo(()=>$79bcac94ca400be1$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $79bcac94ca400be1$export$fa996778a3a31087() {
    let state = $79bcac94ca400be1$var$useDataRouterState($79bcac94ca400be1$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref1)=>{
        let [key, fetcher] = _ref1;
        return $79bcac94ca400be1$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $79bcac94ca400be1$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $79bcac94ca400be1$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $79bcac94ca400be1$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $79bcac94ca400be1$var$useDataRouterContext($79bcac94ca400be1$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $79bcac94ca400be1$var$useDataRouterState($79bcac94ca400be1$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $2xPiy.useContext((0, $62d58f5c28b15c2e$export$26749e8557646306));
    let location = (0, $62d58f5c28b15c2e$export$45d76561a5302f2b)();
    let matches = (0, $62d58f5c28b15c2e$export$2378eb7f5ff86053)();
    let navigation = (0, $62d58f5c28b15c2e$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $2xPiy.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $79bcac94ca400be1$var$usePageHide($2xPiy.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $79bcac94ca400be1$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $79bcac94ca400be1$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($79bcac94ca400be1$var$savedScrollPositions));
        } catch (error) {
            (0, $28152332635c962a$export$c0e02632e14916fd)(false, "Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (" + error + ").");
        }
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $2xPiy.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $79bcac94ca400be1$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $79bcac94ca400be1$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $2xPiy.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($79bcac94ca400be1$var$_extends({}, location, {
                    pathname: (0, $28152332635c962a$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($79bcac94ca400be1$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $2xPiy.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $79bcac94ca400be1$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $2xPiy.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $79bcac94ca400be1$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $2xPiy.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $79bcac94ca400be1$export$39f4eb3dbd812741(_ref10) {
    let { when: when, message: message } = _ref10;
    let blocker = (0, $62d58f5c28b15c2e$export$b273b3273281a049)(when);
    $2xPiy.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $2xPiy.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $79bcac94ca400be1$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $2xPiy.useContext($79bcac94ca400be1$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $28152332635c962a$export$3e9cee6b33872309)(false, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $79bcac94ca400be1$var$useDataRouterContext($79bcac94ca400be1$var$DataRouterHook.useViewTransitionState);
    let path = (0, $62d58f5c28b15c2e$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $28152332635c962a$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $28152332635c962a$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $28152332635c962a$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $28152332635c962a$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $2xPiy = parcelRequire("2xPiy");
function $c8805d3298ae7833$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $c8805d3298ae7833$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $c8805d3298ae7833$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $c8805d3298ae7833$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $c8805d3298ae7833$export$2e2bcd8739ae039 = $c8805d3298ae7833$export$4f5d2d50c9deca37;


"use client";
var $05d5739209a21833$var$L = (t)=>typeof t == "number" && !isNaN(t), $05d5739209a21833$var$N = (t)=>typeof t == "string", $05d5739209a21833$var$P = (t)=>typeof t == "function", $05d5739209a21833$var$ut = (t)=>$05d5739209a21833$var$N(t) || $05d5739209a21833$var$L(t), $05d5739209a21833$var$z = (t)=>$05d5739209a21833$var$N(t) || $05d5739209a21833$var$P(t) ? t : null, $05d5739209a21833$var$yt = (t, o)=>t === !1 || $05d5739209a21833$var$L(t) && t > 0 ? t : o, $05d5739209a21833$var$F = (t)=>(0, $2xPiy.isValidElement)(t) || $05d5739209a21833$var$N(t) || $05d5739209a21833$var$P(t) || $05d5739209a21833$var$L(t);
function $05d5739209a21833$export$184cca501f1aed7f(t, o, e = 300) {
    let { scrollHeight: r, style: a } = t;
    requestAnimationFrame(()=>{
        a.minHeight = "initial", a.height = r + "px", a.transition = `all ${e}ms`, requestAnimationFrame(()=>{
            a.height = "0", a.padding = "0", a.margin = "0", setTimeout(o, e);
        });
    });
}
function $05d5739209a21833$export$3ff7dc44d332d222({ enter: t, exit: o, appendPosition: e = !1, collapse: r = !0, collapseDuration: a = 300 }) {
    return function({ children: s, position: f, preventExitTransition: c, done: T, nodeRef: g, isIn: v, playToast: x }) {
        let C = e ? `${t}--${f}` : t, S = e ? `${o}--${f}` : o, E = (0, $2xPiy.useRef)(0);
        return (0, $2xPiy.useLayoutEffect)(()=>{
            let d = g.current, p = C.split(" "), b = (n)=>{
                n.target === g.current && (x(), d.removeEventListener("animationend", b), d.removeEventListener("animationcancel", b), E.current === 0 && n.type !== "animationcancel" && d.classList.remove(...p));
            };
            d.classList.add(...p), d.addEventListener("animationend", b), d.addEventListener("animationcancel", b);
        }, []), (0, $2xPiy.useEffect)(()=>{
            let d = g.current, p = ()=>{
                d.removeEventListener("animationend", p), r ? $05d5739209a21833$export$184cca501f1aed7f(d, T, a) : T();
            };
            v || (c ? p() : (E.current = 1, d.className += ` ${S}`, d.addEventListener("animationend", p)));
        }, [
            v
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).Fragment, null, s);
    };
}
function $05d5739209a21833$var$tt(t, o) {
    return {
        content: $05d5739209a21833$var$ot(t.content, t.props),
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        reason: t.removalReason,
        status: o
    };
}
function $05d5739209a21833$var$ot(t, o, e = !1) {
    return (0, $2xPiy.isValidElement)(t) && !$05d5739209a21833$var$N(t.type) ? (0, $2xPiy.cloneElement)(t, {
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : $05d5739209a21833$var$P(t) ? t({
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : t;
}
function $05d5739209a21833$var$gt({ closeToast: t, theme: o, ariaLabel: e = "close" }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (r)=>{
            r.stopPropagation(), t(!0);
        },
        "aria-label": e
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $05d5739209a21833$var$bt({ delay: t, isRunning: o, closeToast: e, type: r = "default", hide: a, className: l, controlledProgress: s, progress: f, rtl: c, isIn: T, theme: g }) {
    let v = a || s && f === 0, x = {
        animationDuration: `${t}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    s && (x.transform = `scaleX(${f})`);
    let C = (0, $c8805d3298ae7833$export$2e2bcd8739ae039)("Toastify__progress-bar", s ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${r}`, {
        ["Toastify__progress-bar--rtl"]: c
    }), S = $05d5739209a21833$var$P(l) ? l({
        rtl: c,
        type: r,
        defaultClassName: C
    }) : (0, $c8805d3298ae7833$export$2e2bcd8739ae039)(C, l), E = {
        [s && f >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: s && f < 1 ? null : ()=>{
            T && e();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${r}`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("div", {
        role: "progressbar",
        "aria-hidden": v ? "true" : "false",
        "aria-label": "notification timer",
        "aria-valuenow": s ? Math.round(f * 100) : void 0,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        className: S,
        style: x,
        ...E
    }));
}
var $05d5739209a21833$var$Qt = 1, $05d5739209a21833$var$st = ()=>`${$05d5739209a21833$var$Qt++}`;
function $05d5739209a21833$var$vt(t, o, e) {
    let r = 1, a = 0, l = [], s = [], f = o, c = new Map, T = new Set, g = (i)=>(T.add(i), ()=>T.delete(i)), v = ()=>{
        s = Array.from(c.values()), T.forEach((i)=>i());
    }, x = ({ containerId: i, toastId: n, updateId: u })=>{
        let h = i ? i !== t : t !== 1, m = c.has(n) && u == null;
        return h || m;
    }, C = (i, n)=>{
        c.forEach((u)=>{
            var h;
            (n == null || n === u.props.toastId) && ((h = u.toggle) == null || h.call(u, i));
        });
    }, S = (i)=>{
        var n, u;
        i.isActive && ((u = (n = i.props) == null ? void 0 : n.onClose) == null || u.call(n, i.removalReason), i.isActive = !1, e($05d5739209a21833$var$tt(i, "removed")));
    }, E = (i)=>{
        if (i == null) c.forEach(S);
        else {
            let n = c.get(i);
            n && S(n);
        }
        v();
    }, d = ()=>{
        a -= l.length, l = [];
    }, p = (i)=>{
        var m, _;
        let { toastId: n, updateId: u } = i.props, h = u == null;
        i.staleId && c.delete(i.staleId), i.isActive = !0, c.set(n, i), v(), e($05d5739209a21833$var$tt(i, h ? "added" : "updated")), h && ((_ = (m = i.props).onOpen) == null || _.call(m));
    };
    return {
        id: t,
        props: f,
        observe: g,
        toggle: C,
        removeToast: E,
        toasts: c,
        clearQueue: d,
        buildToast: (i, n)=>{
            if (x(n)) return;
            let { toastId: u, updateId: h, data: m, staleId: _, delay: k } = n, D = h == null;
            D && a++;
            let A = {
                ...f,
                style: f.toastStyle,
                key: r++,
                ...Object.fromEntries(Object.entries(n).filter(([M, $])=>$ != null)),
                toastId: u,
                updateId: h,
                data: m,
                isIn: !1,
                className: $05d5739209a21833$var$z(n.className || f.toastClassName),
                progressClassName: $05d5739209a21833$var$z(n.progressClassName || f.progressClassName),
                autoClose: n.isLoading ? !1 : $05d5739209a21833$var$yt(n.autoClose, f.autoClose),
                closeToast (M) {
                    let $ = c.get(u);
                    $ && ($.removalReason = M, E(u));
                },
                deleteToast () {
                    if (c.get(u) != null) {
                        if (c.delete(u), a--, a < 0 && (a = 0), l.length > 0) {
                            p(l.shift());
                            return;
                        }
                        v();
                    }
                }
            };
            A.closeButton = f.closeButton, n.closeButton === !1 || $05d5739209a21833$var$F(n.closeButton) ? A.closeButton = n.closeButton : n.closeButton === !0 && (A.closeButton = $05d5739209a21833$var$F(f.closeButton) ? f.closeButton : !0);
            let B = {
                content: i,
                props: A,
                staleId: _
            };
            f.limit && f.limit > 0 && a > f.limit && D ? l.push(B) : $05d5739209a21833$var$L(k) ? setTimeout(()=>{
                p(B);
            }, k) : p(B);
        },
        setProps (i) {
            f = i;
        },
        setToggle: (i, n)=>{
            let u = c.get(i);
            u && (u.toggle = n);
        },
        isToastActive: (i)=>{
            var n;
            return (n = c.get(i)) == null ? void 0 : n.isActive;
        },
        getSnapshot: ()=>s
    };
}
var $05d5739209a21833$var$I = new Map, $05d5739209a21833$var$U = [], $05d5739209a21833$var$rt = new Set, $05d5739209a21833$var$Wt = (t)=>$05d5739209a21833$var$rt.forEach((o)=>o(t)), $05d5739209a21833$var$ht = ()=>$05d5739209a21833$var$I.size > 0;
function $05d5739209a21833$var$Gt() {
    $05d5739209a21833$var$U.forEach((t)=>$05d5739209a21833$var$nt(t.content, t.options)), $05d5739209a21833$var$U = [];
}
var $05d5739209a21833$var$Ct = (t, { containerId: o })=>{
    var e;
    return (e = $05d5739209a21833$var$I.get(o || 1)) == null ? void 0 : e.toasts.get(t);
};
function $05d5739209a21833$var$X(t, o) {
    var r;
    if (o) return !!((r = $05d5739209a21833$var$I.get(o)) != null && r.isToastActive(t));
    let e = !1;
    return $05d5739209a21833$var$I.forEach((a)=>{
        a.isToastActive(t) && (e = !0);
    }), e;
}
function $05d5739209a21833$var$xt(t) {
    if (!$05d5739209a21833$var$ht()) {
        $05d5739209a21833$var$U = $05d5739209a21833$var$U.filter((o)=>t != null && o.options.toastId !== t);
        return;
    }
    if (t == null || $05d5739209a21833$var$ut(t)) $05d5739209a21833$var$I.forEach((o)=>{
        o.removeToast(t);
    });
    else if (t && ("containerId" in t || "id" in t)) {
        let o = $05d5739209a21833$var$I.get(t.containerId);
        o ? o.removeToast(t.id) : $05d5739209a21833$var$I.forEach((e)=>{
            e.removeToast(t.id);
        });
    }
}
var $05d5739209a21833$var$Et = (t = {})=>{
    $05d5739209a21833$var$I.forEach((o)=>{
        o.props.limit && (!t.containerId || o.id === t.containerId) && o.clearQueue();
    });
};
function $05d5739209a21833$var$nt(t, o) {
    $05d5739209a21833$var$F(t) && ($05d5739209a21833$var$ht() || $05d5739209a21833$var$U.push({
        content: t,
        options: o
    }), $05d5739209a21833$var$I.forEach((e)=>{
        e.buildToast(t, o);
    }));
}
function $05d5739209a21833$var$Pt(t) {
    var o;
    (o = $05d5739209a21833$var$I.get(t.containerId || 1)) == null || o.setToggle(t.id, t.fn);
}
function $05d5739209a21833$var$it(t, o) {
    $05d5739209a21833$var$I.forEach((e)=>{
        (o == null || !(o != null && o.containerId) || (o == null ? void 0 : o.containerId) === e.id) && e.toggle(t, o == null ? void 0 : o.id);
    });
}
function $05d5739209a21833$var$It(t) {
    let o = t.containerId || 1;
    return {
        subscribe (e) {
            let r = $05d5739209a21833$var$vt(o, t, $05d5739209a21833$var$Wt);
            $05d5739209a21833$var$I.set(o, r);
            let a = r.observe(e);
            return $05d5739209a21833$var$Gt(), ()=>{
                a(), $05d5739209a21833$var$I.delete(o);
            };
        },
        setProps (e) {
            var r;
            (r = $05d5739209a21833$var$I.get(o)) == null || r.setProps(e);
        },
        getSnapshot () {
            var e;
            return (e = $05d5739209a21833$var$I.get(o)) == null ? void 0 : e.getSnapshot();
        }
    };
}
function $05d5739209a21833$var$St(t) {
    return $05d5739209a21833$var$rt.add(t), ()=>{
        $05d5739209a21833$var$rt.delete(t);
    };
}
function $05d5739209a21833$var$qt(t) {
    return t && ($05d5739209a21833$var$N(t.toastId) || $05d5739209a21833$var$L(t.toastId)) ? t.toastId : $05d5739209a21833$var$st();
}
function $05d5739209a21833$var$H(t, o) {
    return $05d5739209a21833$var$nt(t, o), o.toastId;
}
function $05d5739209a21833$var$Q(t, o) {
    return {
        ...o,
        type: o && o.type || t,
        toastId: $05d5739209a21833$var$qt(o)
    };
}
function $05d5739209a21833$var$W(t) {
    return (o, e)=>$05d5739209a21833$var$H(o, $05d5739209a21833$var$Q(t, e));
}
function $05d5739209a21833$export$b410431fab84fa58(t, o) {
    return $05d5739209a21833$var$H(t, $05d5739209a21833$var$Q("default", o));
}
$05d5739209a21833$export$b410431fab84fa58.loading = (t, o)=>$05d5739209a21833$var$H(t, $05d5739209a21833$var$Q("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...o
    }));
function $05d5739209a21833$var$Kt(t, { pending: o, error: e, success: r }, a) {
    let l;
    o && (l = $05d5739209a21833$var$N(o) ? $05d5739209a21833$export$b410431fab84fa58.loading(o, a) : $05d5739209a21833$export$b410431fab84fa58.loading(o.render, {
        ...a,
        ...o
    }));
    let s = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, f = (T, g, v)=>{
        if (g == null) {
            $05d5739209a21833$export$b410431fab84fa58.dismiss(l);
            return;
        }
        let x = {
            type: T,
            ...s,
            ...a,
            data: v
        }, C = $05d5739209a21833$var$N(g) ? {
            render: g
        } : g;
        return l ? $05d5739209a21833$export$b410431fab84fa58.update(l, {
            ...x,
            ...C
        }) : $05d5739209a21833$export$b410431fab84fa58(C.render, {
            ...x,
            ...C
        }), v;
    }, c = $05d5739209a21833$var$P(t) ? t() : t;
    return c.then((T)=>f("success", r, T)).catch((T)=>f("error", e, T)), c;
}
$05d5739209a21833$export$b410431fab84fa58.promise = $05d5739209a21833$var$Kt;
$05d5739209a21833$export$b410431fab84fa58.success = $05d5739209a21833$var$W("success");
$05d5739209a21833$export$b410431fab84fa58.info = $05d5739209a21833$var$W("info");
$05d5739209a21833$export$b410431fab84fa58.error = $05d5739209a21833$var$W("error");
$05d5739209a21833$export$b410431fab84fa58.warning = $05d5739209a21833$var$W("warning");
$05d5739209a21833$export$b410431fab84fa58.warn = $05d5739209a21833$export$b410431fab84fa58.warning;
$05d5739209a21833$export$b410431fab84fa58.dark = (t, o)=>$05d5739209a21833$var$H(t, $05d5739209a21833$var$Q("default", {
        theme: "dark",
        ...o
    }));
function $05d5739209a21833$var$Yt(t) {
    $05d5739209a21833$var$xt(t);
}
$05d5739209a21833$export$b410431fab84fa58.dismiss = $05d5739209a21833$var$Yt;
$05d5739209a21833$export$b410431fab84fa58.clearWaitingQueue = $05d5739209a21833$var$Et;
$05d5739209a21833$export$b410431fab84fa58.isActive = $05d5739209a21833$var$X;
$05d5739209a21833$export$b410431fab84fa58.update = (t, o = {})=>{
    let e = $05d5739209a21833$var$Ct(t, o);
    if (e) {
        let { props: r, content: a } = e, l = {
            delay: 100,
            ...r,
            ...o,
            toastId: o.toastId || t,
            updateId: $05d5739209a21833$var$st()
        };
        l.toastId !== t && (l.staleId = t);
        let s = l.render || a;
        delete l.render, $05d5739209a21833$var$H(s, l);
    }
};
$05d5739209a21833$export$b410431fab84fa58.done = (t)=>{
    $05d5739209a21833$export$b410431fab84fa58.update(t, {
        progress: 1
    });
};
$05d5739209a21833$export$b410431fab84fa58.onChange = $05d5739209a21833$var$St;
$05d5739209a21833$export$b410431fab84fa58.play = (t)=>$05d5739209a21833$var$it(!0, t);
$05d5739209a21833$export$b410431fab84fa58.pause = (t)=>$05d5739209a21833$var$it(!1, t);
function $05d5739209a21833$var$kt(t) {
    var s;
    let { subscribe: o, getSnapshot: e, setProps: r } = (0, $2xPiy.useRef)($05d5739209a21833$var$It(t)).current;
    r(t);
    let a = (s = (0, $2xPiy.useSyncExternalStore)(o, e, e)) == null ? void 0 : s.slice();
    function l(f) {
        if (!a) return [];
        let c = new Map;
        return t.newestOnTop && a.reverse(), a.forEach((T)=>{
            let { position: g } = T.props;
            c.has(g) || c.set(g, []), c.get(g).push(T);
        }), Array.from(c, (T)=>f(T[0], T[1]));
    }
    return {
        getToastToRender: l,
        isToastActive: $05d5739209a21833$var$X,
        count: a == null ? void 0 : a.length
    };
}
function $05d5739209a21833$var$Nt(t) {
    let [o, e] = (0, $2xPiy.useState)(!1), [r, a] = (0, $2xPiy.useState)(!1), l = (0, $2xPiy.useRef)(null), s = (0, $2xPiy.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: f, pauseOnHover: c, closeToast: T, onClick: g, closeOnClick: v } = t;
    $05d5739209a21833$var$Pt({
        id: t.toastId,
        containerId: t.containerId,
        fn: e
    }), (0, $2xPiy.useEffect)(()=>{
        if (t.pauseOnFocusLoss) return x(), ()=>{
            C();
        };
    }, [
        t.pauseOnFocusLoss
    ]);
    function x() {
        document.hasFocus() || p(), window.addEventListener("focus", d), window.addEventListener("blur", p);
    }
    function C() {
        window.removeEventListener("focus", d), window.removeEventListener("blur", p);
    }
    function S(m) {
        if (t.draggable === !0 || t.draggable === m.pointerType) {
            b();
            let _ = l.current;
            s.canCloseOnClick = !0, s.canDrag = !0, _.style.transition = "none", t.draggableDirection === "x" ? (s.start = m.clientX, s.removalDistance = _.offsetWidth * (t.draggablePercent / 100)) : (s.start = m.clientY, s.removalDistance = _.offsetHeight * (t.draggablePercent === 80 ? t.draggablePercent * 1.5 : t.draggablePercent) / 100);
        }
    }
    function E(m) {
        let { top: _, bottom: k, left: D, right: A } = l.current.getBoundingClientRect();
        m.pointerType === "mouse" && t.pauseOnHover && m.clientX >= D && m.clientX <= A && m.clientY >= _ && m.clientY <= k ? p() : d();
    }
    function d() {
        e(!0);
    }
    function p() {
        e(!1);
    }
    function b() {
        s.didMove = !1, document.addEventListener("pointermove", n), document.addEventListener("pointerup", u);
    }
    function i() {
        document.removeEventListener("pointermove", n), document.removeEventListener("pointerup", u);
    }
    function n(m) {
        let _ = l.current;
        if (s.canDrag && _) {
            s.didMove = !0, o && p(), t.draggableDirection === "x" ? s.delta = m.clientX - s.start : s.delta = m.clientY - s.start, s.start !== m.clientX && (s.canCloseOnClick = !1);
            let k = t.draggableDirection === "x" ? `${s.delta}px, var(--y)` : `0, calc(${s.delta}px + var(--y))`;
            _.style.transform = `translate3d(${k},0)`, _.style.opacity = `${1 - Math.abs(s.delta / s.removalDistance)}`;
        }
    }
    function u() {
        i();
        let m = l.current;
        if (s.canDrag && s.didMove && m) {
            if (s.canDrag = !1, Math.abs(s.delta) > s.removalDistance) {
                a(!0), t.closeToast(!0), t.collapseAll();
                return;
            }
            m.style.transition = "transform 0.2s, opacity 0.2s", m.style.removeProperty("transform"), m.style.removeProperty("opacity");
        }
    }
    let h = {
        onPointerDown: S,
        onPointerUp: E
    };
    return f && c && (h.onMouseEnter = p, t.stacked || (h.onMouseLeave = d)), v && (h.onClick = (m)=>{
        g && g(m), s.canCloseOnClick && T(!0);
    }), {
        playToast: d,
        pauseToast: p,
        isRunning: o,
        preventExitTransition: r,
        toastRef: l,
        eventHandlers: h
    };
}
var $05d5739209a21833$var$G = typeof window != "undefined" ? (0, $2xPiy.useLayoutEffect) : (0, $2xPiy.useEffect);
var $05d5739209a21833$var$K = ({ theme: t, type: o, isLoading: e, ...r })=>(0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...r
    });
function $05d5739209a21833$var$ro(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($05d5739209a21833$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
    }));
}
function $05d5739209a21833$var$no(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($05d5739209a21833$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
    }));
}
function $05d5739209a21833$var$io(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($05d5739209a21833$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
    }));
}
function $05d5739209a21833$var$lo(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($05d5739209a21833$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
    }));
}
function $05d5739209a21833$var$fo() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("div", {
        className: "Toastify__spinner"
    });
}
var $05d5739209a21833$export$4f13f83fd8bb1dac = {
    info: $05d5739209a21833$var$no,
    warning: $05d5739209a21833$var$ro,
    success: $05d5739209a21833$var$io,
    error: $05d5739209a21833$var$lo,
    spinner: $05d5739209a21833$var$fo
}, $05d5739209a21833$var$co = (t)=>t in $05d5739209a21833$export$4f13f83fd8bb1dac;
function $05d5739209a21833$var$wt({ theme: t, type: o, isLoading: e, icon: r }) {
    let a = null, l = {
        theme: t,
        type: o
    };
    return r === !1 || ($05d5739209a21833$var$P(r) ? a = r({
        ...l,
        isLoading: e
    }) : (0, $2xPiy.isValidElement)(r) ? a = (0, $2xPiy.cloneElement)(r, l) : e ? a = $05d5739209a21833$export$4f13f83fd8bb1dac.spinner() : $05d5739209a21833$var$co(o) && (a = $05d5739209a21833$export$4f13f83fd8bb1dac[o](l))), a;
}
var $05d5739209a21833$var$Dt = (t)=>{
    let { isRunning: o, preventExitTransition: e, toastRef: r, eventHandlers: a, playToast: l } = $05d5739209a21833$var$Nt(t), { closeButton: s, children: f, autoClose: c, onClick: T, type: g, hideProgressBar: v, closeToast: x, transition: C, position: S, className: E, style: d, progressClassName: p, updateId: b, role: i, progress: n, rtl: u, toastId: h, deleteToast: m, isIn: _, isLoading: k, closeOnClick: D, theme: A, ariaLabel: B } = t, M = (0, $c8805d3298ae7833$export$2e2bcd8739ae039)("Toastify__toast", `Toastify__toast-theme--${A}`, `Toastify__toast--${g}`, {
        ["Toastify__toast--rtl"]: u
    }, {
        ["Toastify__toast--close-on-click"]: D
    }), $ = $05d5739209a21833$var$P(E) ? E({
        rtl: u,
        position: S,
        type: g,
        defaultClassName: M
    }) : (0, $c8805d3298ae7833$export$2e2bcd8739ae039)(M, E), mt = $05d5739209a21833$var$wt(t), pt = !!n || !c, Z = {
        closeToast: x,
        type: g,
        theme: A
    }, V = null;
    return s === !1 || ($05d5739209a21833$var$P(s) ? V = s(Z) : (0, $2xPiy.isValidElement)(s) ? V = (0, $2xPiy.cloneElement)(s, Z) : V = $05d5739209a21833$var$gt(Z)), (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(C, {
        isIn: _,
        done: m,
        position: S,
        preventExitTransition: e,
        nodeRef: r,
        playToast: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("div", {
        id: h,
        tabIndex: 0,
        onClick: T,
        "data-in": _,
        className: $,
        ...a,
        style: d,
        ref: r,
        ..._ && {
            role: i,
            "aria-label": B
        }
    }, mt != null && (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("div", {
        className: (0, $c8805d3298ae7833$export$2e2bcd8739ae039)("Toastify__toast-icon", {
            ["Toastify--animate-icon Toastify__zoom-enter"]: !k
        })
    }, mt), $05d5739209a21833$var$ot(f, t, !o), V, !t.customProgressBar && (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($05d5739209a21833$var$bt, {
        ...b && !pt ? {
            key: `p-${b}`
        } : {},
        rtl: u,
        theme: A,
        delay: c,
        isRunning: o,
        isIn: _,
        closeToast: x,
        hide: v,
        type: g,
        className: p,
        controlledProgress: pt,
        progress: n || 0
    })));
};
var $05d5739209a21833$var$j = (t, o = !1)=>({
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: o
    }), $05d5739209a21833$export$d20e79fdc3899e95 = $05d5739209a21833$export$3ff7dc44d332d222($05d5739209a21833$var$j("bounce", !0)), $05d5739209a21833$export$d8dc01b5c85a37b9 = $05d5739209a21833$export$3ff7dc44d332d222($05d5739209a21833$var$j("slide", !0)), $05d5739209a21833$export$65cfd44a2050f99 = $05d5739209a21833$export$3ff7dc44d332d222($05d5739209a21833$var$j("zoom")), $05d5739209a21833$export$4d2fae537bd90431 = $05d5739209a21833$export$3ff7dc44d332d222($05d5739209a21833$var$j("flip"));
var $05d5739209a21833$var$vo = {
    position: "top-right",
    transition: $05d5739209a21833$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light",
    "aria-label": "Notifications Alt+T",
    hotKeys: (t)=>t.altKey && t.code === "KeyT"
};
function $05d5739209a21833$var$dt(t) {
    let o = {
        ...$05d5739209a21833$var$vo,
        ...t
    }, e = t.stacked, [r, a] = (0, $2xPiy.useState)(!0), l = (0, $2xPiy.useRef)(null), { getToastToRender: s, isToastActive: f, count: c } = $05d5739209a21833$var$kt(o), { className: T, style: g, rtl: v, containerId: x, hotKeys: C } = o;
    function S(d) {
        let p = (0, $c8805d3298ae7833$export$2e2bcd8739ae039)("Toastify__toast-container", `Toastify__toast-container--${d}`, {
            ["Toastify__toast-container--rtl"]: v
        });
        return $05d5739209a21833$var$P(T) ? T({
            position: d,
            rtl: v,
            defaultClassName: p
        }) : (0, $c8805d3298ae7833$export$2e2bcd8739ae039)(p, $05d5739209a21833$var$z(T));
    }
    function E() {
        e && (a(!0), $05d5739209a21833$export$b410431fab84fa58.play());
    }
    return $05d5739209a21833$var$G(()=>{
        var d;
        if (e) {
            let p = l.current.querySelectorAll('[data-in="true"]'), b = 12, i = (d = o.position) == null ? void 0 : d.includes("top"), n = 0, u = 0;
            Array.from(p).reverse().forEach((h, m)=>{
                let _ = h;
                _.classList.add("Toastify__toast--stacked"), m > 0 && (_.dataset.collapsed = `${r}`), _.dataset.pos || (_.dataset.pos = i ? "top" : "bot");
                let k = n * (r ? .2 : 1) + (r ? 0 : b * m), D = Math.max(.5, 1 - (r ? u : 0));
                _.style.setProperty("--y", `${i ? k : k * -1}px`), _.style.setProperty("--g", `${b}`), _.style.setProperty("--s", `${D}`), n += _.offsetHeight, u += .025;
            });
        }
    }, [
        r,
        c,
        e
    ]), (0, $2xPiy.useEffect)(()=>{
        function d(p) {
            var i;
            let b = l.current;
            C(p) && ((i = b == null ? void 0 : b.querySelector('[tabIndex="0"]')) == null || i.focus(), a(!1), $05d5739209a21833$export$b410431fab84fa58.pause()), p.key === "Escape" && (document.activeElement === b || b != null && b.contains(document.activeElement)) && (a(!0), $05d5739209a21833$export$b410431fab84fa58.play());
        }
        return document.addEventListener("keydown", d), ()=>{
            document.removeEventListener("keydown", d);
        };
    }, [
        C
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("section", {
        ref: l,
        className: "Toastify",
        id: x,
        onMouseEnter: ()=>{
            e && (a(!1), $05d5739209a21833$export$b410431fab84fa58.pause());
        },
        onMouseLeave: E,
        "aria-live": "polite",
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        "aria-label": o["aria-label"]
    }, s((d, p)=>{
        let b = p.length ? {
            ...g
        } : {
            ...g,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("div", {
            tabIndex: -1,
            className: S(d),
            "data-stacked": e,
            style: b,
            key: `c-${d}`
        }, p.map(({ content: i, props: n })=>(0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($05d5739209a21833$var$Dt, {
                ...n,
                stacked: e,
                collapseAll: E,
                isIn: f(n.toastId, n.containerId),
                key: `t-${n.key}`
            }, i)));
    }));
}
var $05d5739209a21833$var$Mt = `:root {
  --toastify-color-light: #fff;
  --toastify-color-dark: #121212;
  --toastify-color-info: #3498db;
  --toastify-color-success: #07bc0c;
  --toastify-color-warning: #f1c40f;
  --toastify-color-error: hsl(6, 78%, 57%);
  --toastify-color-transparent: rgba(255, 255, 255, 0.7);

  --toastify-icon-color-info: var(--toastify-color-info);
  --toastify-icon-color-success: var(--toastify-color-success);
  --toastify-icon-color-warning: var(--toastify-color-warning);
  --toastify-icon-color-error: var(--toastify-color-error);

  --toastify-container-width: fit-content;
  --toastify-toast-width: 320px;
  --toastify-toast-offset: 16px;
  --toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));
  --toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));
  --toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));
  --toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));
  --toastify-toast-background: #fff;
  --toastify-toast-padding: 14px;
  --toastify-toast-min-height: 64px;
  --toastify-toast-max-height: 800px;
  --toastify-toast-bd-radius: 6px;
  --toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  --toastify-font-family: sans-serif;
  --toastify-z-index: 9999;
  --toastify-text-color-light: #757575;
  --toastify-text-color-dark: #fff;

  /* Used only for colored theme */
  --toastify-text-color-info: #fff;
  --toastify-text-color-success: #fff;
  --toastify-text-color-warning: #fff;
  --toastify-text-color-error: #fff;

  --toastify-spinner-color: #616161;
  --toastify-spinner-color-empty-area: #e0e0e0;
  --toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);
  --toastify-color-progress-dark: #bb86fc;
  --toastify-color-progress-info: var(--toastify-color-info);
  --toastify-color-progress-success: var(--toastify-color-success);
  --toastify-color-progress-warning: var(--toastify-color-warning);
  --toastify-color-progress-error: var(--toastify-color-error);
  /* used to control the opacity of the progress trail */
  --toastify-color-progress-bgo: 0.2;
}

.Toastify__toast-container {
  z-index: var(--toastify-z-index);
  -webkit-transform: translate3d(0, 0, var(--toastify-z-index));
  position: fixed;
  width: var(--toastify-container-width);
  box-sizing: border-box;
  color: #fff;
  display: flex;
  flex-direction: column;
}

.Toastify__toast-container--top-left {
  top: var(--toastify-toast-top);
  left: var(--toastify-toast-left);
}
.Toastify__toast-container--top-center {
  top: var(--toastify-toast-top);
  left: 50%;
  transform: translateX(-50%);
  align-items: center;
}
.Toastify__toast-container--top-right {
  top: var(--toastify-toast-top);
  right: var(--toastify-toast-right);
  align-items: end;
}
.Toastify__toast-container--bottom-left {
  bottom: var(--toastify-toast-bottom);
  left: var(--toastify-toast-left);
}
.Toastify__toast-container--bottom-center {
  bottom: var(--toastify-toast-bottom);
  left: 50%;
  transform: translateX(-50%);
  align-items: center;
}
.Toastify__toast-container--bottom-right {
  bottom: var(--toastify-toast-bottom);
  right: var(--toastify-toast-right);
  align-items: end;
}

.Toastify__toast {
  --y: 0px;
  position: relative;
  touch-action: none;
  width: var(--toastify-toast-width);
  min-height: var(--toastify-toast-min-height);
  box-sizing: border-box;
  margin-bottom: 1rem;
  padding: var(--toastify-toast-padding);
  border-radius: var(--toastify-toast-bd-radius);
  box-shadow: var(--toastify-toast-shadow);
  max-height: var(--toastify-toast-max-height);
  font-family: var(--toastify-font-family);
  /* webkit only issue #791 */
  z-index: 0;
  /* inner swag */
  display: flex;
  flex: 1 auto;
  align-items: center;
  word-break: break-word;
}

@media only screen and (max-width: 480px) {
  .Toastify__toast-container {
    width: 100vw;
    left: env(safe-area-inset-left);
    margin: 0;
  }
  .Toastify__toast-container--top-left,
  .Toastify__toast-container--top-center,
  .Toastify__toast-container--top-right {
    top: env(safe-area-inset-top);
    transform: translateX(0);
  }
  .Toastify__toast-container--bottom-left,
  .Toastify__toast-container--bottom-center,
  .Toastify__toast-container--bottom-right {
    bottom: env(safe-area-inset-bottom);
    transform: translateX(0);
  }
  .Toastify__toast-container--rtl {
    right: env(safe-area-inset-right);
    left: initial;
  }
  .Toastify__toast {
    --toastify-toast-width: 100%;
    margin-bottom: 0;
    border-radius: 0;
  }
}

.Toastify__toast-container[data-stacked='true'] {
  width: var(--toastify-toast-width);
}

@media only screen and (max-width: 480px) {
  .Toastify__toast-container[data-stacked='true'] {
    width: 100vw;
  }
}

.Toastify__toast--stacked {
  position: absolute;
  width: 100%;
  transform: translate3d(0, var(--y), 0) scale(var(--s));
  transition: transform 0.3s;
}

.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,
.Toastify__toast--stacked[data-collapsed] .Toastify__close-button {
  transition: opacity 0.1s;
}

.Toastify__toast--stacked[data-collapsed='false'] {
  overflow: visible;
}

.Toastify__toast--stacked[data-collapsed='true']:not(:last-child) > * {
  opacity: 0;
}

.Toastify__toast--stacked:after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  height: calc(var(--g) * 1px);
  bottom: 100%;
}

.Toastify__toast--stacked[data-pos='top'] {
  top: 0;
}

.Toastify__toast--stacked[data-pos='bot'] {
  bottom: 0;
}

.Toastify__toast--stacked[data-pos='bot'].Toastify__toast--stacked:before {
  transform-origin: top;
}

.Toastify__toast--stacked[data-pos='top'].Toastify__toast--stacked:before {
  transform-origin: bottom;
}

.Toastify__toast--stacked:before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  transform: scaleY(3);
  z-index: -1;
}

.Toastify__toast--rtl {
  direction: rtl;
}

.Toastify__toast--close-on-click {
  cursor: pointer;
}

.Toastify__toast-icon {
  margin-inline-end: 10px;
  width: 22px;
  flex-shrink: 0;
  display: flex;
}

.Toastify--animate {
  animation-fill-mode: both;
  animation-duration: 0.5s;
}

.Toastify--animate-icon {
  animation-fill-mode: both;
  animation-duration: 0.3s;
}

.Toastify__toast-theme--dark {
  background: var(--toastify-color-dark);
  color: var(--toastify-text-color-dark);
}

.Toastify__toast-theme--light {
  background: var(--toastify-color-light);
  color: var(--toastify-text-color-light);
}

.Toastify__toast-theme--colored.Toastify__toast--default {
  background: var(--toastify-color-light);
  color: var(--toastify-text-color-light);
}

.Toastify__toast-theme--colored.Toastify__toast--info {
  color: var(--toastify-text-color-info);
  background: var(--toastify-color-info);
}

.Toastify__toast-theme--colored.Toastify__toast--success {
  color: var(--toastify-text-color-success);
  background: var(--toastify-color-success);
}

.Toastify__toast-theme--colored.Toastify__toast--warning {
  color: var(--toastify-text-color-warning);
  background: var(--toastify-color-warning);
}

.Toastify__toast-theme--colored.Toastify__toast--error {
  color: var(--toastify-text-color-error);
  background: var(--toastify-color-error);
}

.Toastify__progress-bar-theme--light {
  background: var(--toastify-color-progress-light);
}

.Toastify__progress-bar-theme--dark {
  background: var(--toastify-color-progress-dark);
}

.Toastify__progress-bar--info {
  background: var(--toastify-color-progress-info);
}

.Toastify__progress-bar--success {
  background: var(--toastify-color-progress-success);
}

.Toastify__progress-bar--warning {
  background: var(--toastify-color-progress-warning);
}

.Toastify__progress-bar--error {
  background: var(--toastify-color-progress-error);
}

.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {
  background: var(--toastify-color-transparent);
}

.Toastify__close-button {
  color: #fff;
  position: absolute;
  top: 6px;
  right: 6px;
  background: transparent;
  outline: none;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: 0.7;
  transition: 0.3s ease;
  z-index: 1;
}

.Toastify__toast--rtl .Toastify__close-button {
  left: 6px;
  right: unset;
}

.Toastify__close-button--light {
  color: #000;
  opacity: 0.3;
}

.Toastify__close-button > svg {
  fill: currentColor;
  height: 16px;
  width: 14px;
}

.Toastify__close-button:hover,
.Toastify__close-button:focus {
  opacity: 1;
}

@keyframes Toastify__trackProgress {
  0% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(0);
  }
}

.Toastify__progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0.7;
  transform-origin: left;
}

.Toastify__progress-bar--animated {
  animation: Toastify__trackProgress linear 1 forwards;
}

.Toastify__progress-bar--controlled {
  transition: transform 0.2s;
}

.Toastify__progress-bar--rtl {
  right: 0;
  left: initial;
  transform-origin: right;
  border-bottom-left-radius: initial;
}

.Toastify__progress-bar--wrp {
  position: absolute;
  overflow: hidden;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5px;
  border-bottom-left-radius: var(--toastify-toast-bd-radius);
  border-bottom-right-radius: var(--toastify-toast-bd-radius);
}

.Toastify__progress-bar--wrp[data-hidden='true'] {
  opacity: 0;
}

.Toastify__progress-bar--bg {
  opacity: var(--toastify-color-progress-bgo);
  width: 100%;
  height: 100%;
}

.Toastify__spinner {
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: var(--toastify-spinner-color-empty-area);
  border-right-color: var(--toastify-spinner-color);
  animation: Toastify__spin 0.65s linear infinite;
}

@keyframes Toastify__bounceInRight {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    transform: translate3d(10px, 0, 0);
  }
  90% {
    transform: translate3d(-5px, 0, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutRight {
  20% {
    opacity: 1;
    transform: translate3d(-20px, var(--y), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(2000px, var(--y), 0);
  }
}

@keyframes Toastify__bounceInLeft {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutLeft {
  20% {
    opacity: 1;
    transform: translate3d(20px, var(--y), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(-2000px, var(--y), 0);
  }
}

@keyframes Toastify__bounceInUp {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  75% {
    transform: translate3d(0, 10px, 0);
  }
  90% {
    transform: translate3d(0, -5px, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}

@keyframes Toastify__bounceOutUp {
  20% {
    transform: translate3d(0, calc(var(--y) - 10px), 0);
  }
  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, calc(var(--y) + 20px), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
}

@keyframes Toastify__bounceInDown {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0);
  }
  75% {
    transform: translate3d(0, -10px, 0);
  }
  90% {
    transform: translate3d(0, 5px, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutDown {
  20% {
    transform: translate3d(0, calc(var(--y) - 10px), 0);
  }
  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, calc(var(--y) + 20px), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
}

.Toastify__bounce-enter--top-left,
.Toastify__bounce-enter--bottom-left {
  animation-name: Toastify__bounceInLeft;
}

.Toastify__bounce-enter--top-right,
.Toastify__bounce-enter--bottom-right {
  animation-name: Toastify__bounceInRight;
}

.Toastify__bounce-enter--top-center {
  animation-name: Toastify__bounceInDown;
}

.Toastify__bounce-enter--bottom-center {
  animation-name: Toastify__bounceInUp;
}

.Toastify__bounce-exit--top-left,
.Toastify__bounce-exit--bottom-left {
  animation-name: Toastify__bounceOutLeft;
}

.Toastify__bounce-exit--top-right,
.Toastify__bounce-exit--bottom-right {
  animation-name: Toastify__bounceOutRight;
}

.Toastify__bounce-exit--top-center {
  animation-name: Toastify__bounceOutUp;
}

.Toastify__bounce-exit--bottom-center {
  animation-name: Toastify__bounceOutDown;
}

@keyframes Toastify__zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}

@keyframes Toastify__zoomOut {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: translate3d(0, var(--y), 0) scale3d(0.3, 0.3, 0.3);
  }
  to {
    opacity: 0;
  }
}

.Toastify__zoom-enter {
  animation-name: Toastify__zoomIn;
}

.Toastify__zoom-exit {
  animation-name: Toastify__zoomOut;
}

@keyframes Toastify__flipIn {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }
  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }
  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }
  to {
    transform: perspective(400px);
  }
}

@keyframes Toastify__flipOut {
  from {
    transform: translate3d(0, var(--y), 0) perspective(400px);
  }
  30% {
    transform: translate3d(0, var(--y), 0) perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1;
  }
  to {
    transform: translate3d(0, var(--y), 0) perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0;
  }
}

.Toastify__flip-enter {
  animation-name: Toastify__flipIn;
}

.Toastify__flip-exit {
  animation-name: Toastify__flipOut;
}

@keyframes Toastify__slideInRight {
  from {
    transform: translate3d(110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInLeft {
  from {
    transform: translate3d(-110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInUp {
  from {
    transform: translate3d(0, 110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInDown {
  from {
    transform: translate3d(0, -110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideOutRight {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(110%, var(--y), 0);
  }
}

@keyframes Toastify__slideOutLeft {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(-110%, var(--y), 0);
  }
}

@keyframes Toastify__slideOutDown {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, 500px, 0);
  }
}

@keyframes Toastify__slideOutUp {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, -500px, 0);
  }
}

.Toastify__slide-enter--top-left,
.Toastify__slide-enter--bottom-left {
  animation-name: Toastify__slideInLeft;
}

.Toastify__slide-enter--top-right,
.Toastify__slide-enter--bottom-right {
  animation-name: Toastify__slideInRight;
}

.Toastify__slide-enter--top-center {
  animation-name: Toastify__slideInDown;
}

.Toastify__slide-enter--bottom-center {
  animation-name: Toastify__slideInUp;
}

.Toastify__slide-exit--top-left,
.Toastify__slide-exit--bottom-left {
  animation-name: Toastify__slideOutLeft;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--top-right,
.Toastify__slide-exit--bottom-right {
  animation-name: Toastify__slideOutRight;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--top-center {
  animation-name: Toastify__slideOutUp;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--bottom-center {
  animation-name: Toastify__slideOutDown;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

@keyframes Toastify__spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`;
var $05d5739209a21833$var$$t = new Map, $05d5739209a21833$var$Rt = (t, o)=>{
    $05d5739209a21833$var$G(()=>{
        if (!t || typeof document == "undefined") return;
        let e = document, r = $05d5739209a21833$var$$t.get(e);
        if (r) {
            o && r.setAttribute("nonce", o);
            return;
        }
        let a = e.createElement("style");
        a.textContent = t, o && a.setAttribute("nonce", o), e.head.appendChild(a), $05d5739209a21833$var$$t.set(e, a);
    }, [
        o
    ]);
};
function $05d5739209a21833$export$f2815235e76a62b9(t) {
    return $05d5739209a21833$var$Rt($05d5739209a21833$var$Mt, t.nonce), (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($05d5739209a21833$var$dt, {
        ...t
    });
}



var $9e75c35ac10ca972$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $9e75c35ac10ca972$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $9e75c35ac10ca972$var$__typeError("Cannot " + msg);
var $9e75c35ac10ca972$export$18a094aefa070634 = (obj, member, getter)=>($9e75c35ac10ca972$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $9e75c35ac10ca972$export$addf369becd23283 = (obj, member, value1)=>member.has(obj) ? $9e75c35ac10ca972$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
var $9e75c35ac10ca972$export$42432efe6614d3b4 = (obj, member, value1, setter)=>($9e75c35ac10ca972$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value1) : member.set(obj, value1), value1);
var $9e75c35ac10ca972$export$fa92d15b718fce20 = (obj, member, method)=>($9e75c35ac10ca972$var$__accessCheck(obj, member, "access private method"), method);
var $9e75c35ac10ca972$export$b1fe7cbb4502036b = (obj, member, setter, getter)=>({
        set _ (value){
            $9e75c35ac10ca972$export$42432efe6614d3b4(obj, member, value, setter);
        },
        get _ () {
            return $9e75c35ac10ca972$export$18a094aefa070634(obj, member, getter);
        }
    });




// src/timeoutManager.ts
var $102735a5227aa434$export$d235812f9125bf47 = {
    // We need the wrapper function syntax below instead of direct references to
    // global setTimeout etc.
    //
    // BAD: `setTimeout: setTimeout`
    // GOOD: `setTimeout: (cb, delay) => setTimeout(cb, delay)`
    //
    // If we use direct references here, then anything that wants to spy on or
    // replace the global setTimeout (like tests) won't work since we'll already
    // have a hard reference to the original implementation at the time when this
    // file was imported.
    setTimeout: (callback, delay)=>setTimeout(callback, delay),
    clearTimeout: (timeoutId)=>clearTimeout(timeoutId),
    setInterval: (callback, delay)=>setInterval(callback, delay),
    clearInterval: (intervalId)=>clearInterval(intervalId)
};
var $102735a5227aa434$var$_provider, $102735a5227aa434$var$_providerCalled;
var $102735a5227aa434$export$6336d90323f0ab52 = class {
    constructor(){
        // We cannot have TimeoutManager<T> as we must instantiate it with a concrete
        // type at app boot; and if we leave that type, then any new timer provider
        // would need to support the default provider's concrete timer ID, which is
        // infeasible across environments.
        //
        // We settle for type safety for the TimeoutProvider type, and accept that
        // this class is unsafe internally to allow for extension.
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $102735a5227aa434$var$_provider, $102735a5227aa434$export$d235812f9125bf47);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $102735a5227aa434$var$_providerCalled, false);
    }
    setTimeoutProvider(provider) {
        if ((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $102735a5227aa434$var$_providerCalled) && provider !== (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $102735a5227aa434$var$_provider)) console.error(`[timeoutManager]: Switching provider after calls to previous provider might result in unexpected behavior.`, {
            previous: (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $102735a5227aa434$var$_provider),
            provider: provider
        });
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $102735a5227aa434$var$_provider, provider);
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $102735a5227aa434$var$_providerCalled, false);
    }
    setTimeout(callback, delay) {
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $102735a5227aa434$var$_providerCalled, true);
        return (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $102735a5227aa434$var$_provider).setTimeout(callback, delay);
    }
    clearTimeout(timeoutId) {
        (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $102735a5227aa434$var$_provider).clearTimeout(timeoutId);
    }
    setInterval(callback, delay) {
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $102735a5227aa434$var$_providerCalled, true);
        return (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $102735a5227aa434$var$_provider).setInterval(callback, delay);
    }
    clearInterval(intervalId) {
        (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $102735a5227aa434$var$_provider).clearInterval(intervalId);
    }
};
$102735a5227aa434$var$_provider = new WeakMap();
$102735a5227aa434$var$_providerCalled = new WeakMap();
var $102735a5227aa434$export$94a2700736e69372 = new $102735a5227aa434$export$6336d90323f0ab52();
function $102735a5227aa434$export$5086591e51e32a18(callback) {
    setTimeout(callback, 0);
}


var $43eecd02f94428b5$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $43eecd02f94428b5$export$8793edee2d425525() {}
function $43eecd02f94428b5$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $43eecd02f94428b5$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $43eecd02f94428b5$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $43eecd02f94428b5$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $43eecd02f94428b5$export$8c88ee6f2357230d(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function $43eecd02f94428b5$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $43eecd02f94428b5$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$43eecd02f94428b5$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $43eecd02f94428b5$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($43eecd02f94428b5$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $43eecd02f94428b5$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$43eecd02f94428b5$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $43eecd02f94428b5$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $43eecd02f94428b5$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $43eecd02f94428b5$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$43eecd02f94428b5$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $43eecd02f94428b5$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return Object.keys(b).every((key)=>$43eecd02f94428b5$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
var $43eecd02f94428b5$var$hasOwn = Object.prototype.hasOwnProperty;
function $43eecd02f94428b5$export$77a71fc411098696(a, b, depth = 0) {
    if (a === b) return a;
    if (depth > 500) return b;
    const array = $43eecd02f94428b5$export$7a8558113332b71e(a) && $43eecd02f94428b5$export$7a8558113332b71e(b);
    if (!array && !($43eecd02f94428b5$export$53b83ca8eaab0383(a) && $43eecd02f94428b5$export$53b83ca8eaab0383(b))) return b;
    const aItems = array ? a : Object.keys(a);
    const aSize = aItems.length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? new Array(bSize) : {};
    let equalItems = 0;
    for(let i = 0; i < bSize; i++){
        const key = array ? i : bItems[i];
        const aItem = a[key];
        const bItem = b[key];
        if (aItem === bItem) {
            copy[key] = aItem;
            if (array ? i < aSize : $43eecd02f94428b5$var$hasOwn.call(a, key)) equalItems++;
            continue;
        }
        if (aItem === null || bItem === null || typeof aItem !== "object" || typeof bItem !== "object") {
            copy[key] = bItem;
            continue;
        }
        const v = $43eecd02f94428b5$export$77a71fc411098696(aItem, bItem, depth + 1);
        copy[key] = v;
        if (v === aItem) equalItems++;
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
}
function $43eecd02f94428b5$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $43eecd02f94428b5$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $43eecd02f94428b5$export$53b83ca8eaab0383(o) {
    if (!$43eecd02f94428b5$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$43eecd02f94428b5$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $43eecd02f94428b5$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $43eecd02f94428b5$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        (0, $102735a5227aa434$export$94a2700736e69372).setTimeout(resolve, timeout);
    });
}
function $43eecd02f94428b5$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        try {
            return $43eecd02f94428b5$export$77a71fc411098696(prevData, data);
        } catch (error) {
            console.error(`Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${options.queryHash}]: ${error}`);
            throw error;
        }
        return $43eecd02f94428b5$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $43eecd02f94428b5$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $43eecd02f94428b5$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $43eecd02f94428b5$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $43eecd02f94428b5$export$1aa5a89531b7670d = /* @__PURE__ */ Symbol();
function $43eecd02f94428b5$export$c71c44209368a3bc(options, fetchOptions) {
    if (options.queryFn === $43eecd02f94428b5$export$1aa5a89531b7670d) console.error(`Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${options.queryHash}'`);
    if (!options.queryFn && (fetchOptions == null ? void 0 : fetchOptions.initialPromise)) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $43eecd02f94428b5$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}
function $43eecd02f94428b5$export$2072f68e6c3507cf(throwOnError, params) {
    if (typeof throwOnError === "function") return throwOnError(...params);
    return !!throwOnError;
}
function $43eecd02f94428b5$export$83f813cd1f8a4973(object, getSignal, onCancelled) {
    let consumed = false;
    let signal;
    Object.defineProperty(object, "signal", {
        enumerable: true,
        get: ()=>{
            signal ?? (signal = getSignal());
            if (consumed) return signal;
            consumed = true;
            if (signal.aborted) onCancelled();
            else signal.addEventListener("abort", onCancelled, {
                once: true
            });
            return signal;
        }
    });
    return object;
}








var $c7defa80f1ead432$export$7c76da44185e6090 = (0, $102735a5227aa434$export$5086591e51e32a18);
function $c7defa80f1ead432$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = $c7defa80f1ead432$export$7c76da44185e6090;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var $c7defa80f1ead432$export$520687f44db6e1ab = $c7defa80f1ead432$export$316a8efd03cd1458();





// src/subscribable.ts
var $9e2bfa130a0bbb51$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};


var $f2135b4901caba4c$var$_focused, $f2135b4901caba4c$var$_cleanup, $f2135b4901caba4c$var$_setup;
var $f2135b4901caba4c$export$86f1af424b2ca4de = class extends (0, $9e2bfa130a0bbb51$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $f2135b4901caba4c$var$_focused);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $f2135b4901caba4c$var$_cleanup);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $f2135b4901caba4c$var$_setup);
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $f2135b4901caba4c$var$_setup, (onFocus)=>{
            if (typeof window !== "undefined" && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $f2135b4901caba4c$var$_cleanup)) this.setEventListener((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $f2135b4901caba4c$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $f2135b4901caba4c$var$_cleanup)) == null || _a.call(this);
            (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $f2135b4901caba4c$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $f2135b4901caba4c$var$_setup, setup);
        (_a = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $f2135b4901caba4c$var$_cleanup)) == null || _a.call(this);
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $f2135b4901caba4c$var$_cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $f2135b4901caba4c$var$_focused) !== focused;
        if (changed) {
            (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $f2135b4901caba4c$var$_focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $f2135b4901caba4c$var$_focused) === "boolean") return (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $f2135b4901caba4c$var$_focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
$f2135b4901caba4c$var$_focused = new WeakMap();
$f2135b4901caba4c$var$_cleanup = new WeakMap();
$f2135b4901caba4c$var$_setup = new WeakMap();
var $f2135b4901caba4c$export$6bf54661be5b02cf = new $f2135b4901caba4c$export$86f1af424b2ca4de();




var $85cf0e0b83899bf8$var$_online, $85cf0e0b83899bf8$var$_cleanup, $85cf0e0b83899bf8$var$_setup;
var $85cf0e0b83899bf8$export$58774fb55d5ff7fc = class extends (0, $9e2bfa130a0bbb51$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $85cf0e0b83899bf8$var$_online, true);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $85cf0e0b83899bf8$var$_cleanup);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $85cf0e0b83899bf8$var$_setup);
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $85cf0e0b83899bf8$var$_setup, (onOnline)=>{
            if (typeof window !== "undefined" && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $85cf0e0b83899bf8$var$_cleanup)) this.setEventListener((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $85cf0e0b83899bf8$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $85cf0e0b83899bf8$var$_cleanup)) == null || _a.call(this);
            (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $85cf0e0b83899bf8$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $85cf0e0b83899bf8$var$_setup, setup);
        (_a = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $85cf0e0b83899bf8$var$_cleanup)) == null || _a.call(this);
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $85cf0e0b83899bf8$var$_cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $85cf0e0b83899bf8$var$_online) !== online;
        if (changed) {
            (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $85cf0e0b83899bf8$var$_online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $85cf0e0b83899bf8$var$_online);
    }
};
$85cf0e0b83899bf8$var$_online = new WeakMap();
$85cf0e0b83899bf8$var$_cleanup = new WeakMap();
$85cf0e0b83899bf8$var$_setup = new WeakMap();
var $85cf0e0b83899bf8$export$b113e788b2dd3fdc = new $85cf0e0b83899bf8$export$58774fb55d5ff7fc();




function $4e3c58cfd6cd9f22$export$d54630db02a12b72() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value: value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason: reason
        });
        reject(reason);
    };
    return thenable;
}
function $4e3c58cfd6cd9f22$export$216296c47a9d1275(promise) {
    var _a;
    let data;
    (_a = promise.then((result)=>{
        data = result;
        return result;
    }, (0, $43eecd02f94428b5$export$8793edee2d425525))) == null || _a.catch((0, $43eecd02f94428b5$export$8793edee2d425525));
    if (data !== void 0) return {
        data: data
    };
    return void 0;
}




var $c0530cae3e8bcdd2$export$2d935f1a9c9d3f3e = /* @__PURE__ */ (()=>{
    let isServerFn = ()=>(0, $43eecd02f94428b5$export$6acf61af03e62db);
    return {
        /**
     * Returns whether the current runtime should be treated as a server environment.
     */ isServer () {
            return isServerFn();
        },
        /**
     * Overrides the server check globally.
     */ setIsServer (isServerValue) {
            isServerFn = isServerValue;
        }
    };
})();



function $53fcf2fd81a8ad80$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $53fcf2fd81a8ad80$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $85cf0e0b83899bf8$export$b113e788b2dd3fdc).isOnline() : true;
}
var $53fcf2fd81a8ad80$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function $53fcf2fd81a8ad80$export$986cc6445c1d323(value) {
    return value instanceof $53fcf2fd81a8ad80$export$a8430ed4188f35a9;
}
function $53fcf2fd81a8ad80$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let continueFn;
    const thenable = (0, $4e3c58cfd6cd9f22$export$d54630db02a12b72)();
    const isResolved = ()=>thenable.status !== "pending";
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved()) {
            const error = new $53fcf2fd81a8ad80$export$a8430ed4188f35a9(cancelOptions);
            reject(error);
            (_a = config.onCancel) == null || _a.call(config, error);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $f2135b4901caba4c$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $85cf0e0b83899bf8$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$53fcf2fd81a8ad80$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved()) {
            continueFn == null || continueFn();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved()) {
            continueFn == null || continueFn();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                if (isResolved() || canContinue()) continueResolve(value);
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved()) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved()) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved()) return;
            const retry = config.retry ?? ((0, $c0530cae3e8bcdd2$export$2d935f1a9c9d3f3e).isServer() ? 0 : 3);
            const retryDelay = config.retryDelay ?? $53fcf2fd81a8ad80$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, $43eecd02f94428b5$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        status: ()=>thenable.status,
        cancel: cancel,
        continue: ()=>{
            continueFn == null || continueFn();
            return thenable;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}






var $9579c402b754475f$var$_gcTimeout;
var $9579c402b754475f$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $9579c402b754475f$var$_gcTimeout);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $43eecd02f94428b5$export$e539f754e934e270)(this.gcTime)) (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $9579c402b754475f$var$_gcTimeout, (0, $102735a5227aa434$export$94a2700736e69372).setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $c0530cae3e8bcdd2$export$2d935f1a9c9d3f3e).isServer() ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $9579c402b754475f$var$_gcTimeout)) {
            (0, $102735a5227aa434$export$94a2700736e69372).clearTimeout((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $9579c402b754475f$var$_gcTimeout));
            (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $9579c402b754475f$var$_gcTimeout, void 0);
        }
    }
};
$9579c402b754475f$var$_gcTimeout = new WeakMap();


var $73e4f980fbd6b4b1$var$_initialState, $73e4f980fbd6b4b1$var$_revertState, $73e4f980fbd6b4b1$var$_cache, $73e4f980fbd6b4b1$var$_client, $73e4f980fbd6b4b1$var$_retryer, $73e4f980fbd6b4b1$var$_defaultOptions, $73e4f980fbd6b4b1$var$_abortSignalConsumed, $73e4f980fbd6b4b1$var$_Query_instances, $73e4f980fbd6b4b1$var$isInitialPausedFetch_fn, $73e4f980fbd6b4b1$var$dispatch_fn;
var $73e4f980fbd6b4b1$export$62297b13309008b2 = class extends (0, $9579c402b754475f$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $73e4f980fbd6b4b1$var$_Query_instances);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $73e4f980fbd6b4b1$var$_initialState);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $73e4f980fbd6b4b1$var$_revertState);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $73e4f980fbd6b4b1$var$_cache);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $73e4f980fbd6b4b1$var$_client);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $73e4f980fbd6b4b1$var$_retryer);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $73e4f980fbd6b4b1$var$_defaultOptions);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $73e4f980fbd6b4b1$var$_abortSignalConsumed);
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $73e4f980fbd6b4b1$var$_abortSignalConsumed, false);
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $73e4f980fbd6b4b1$var$_defaultOptions, config.defaultOptions);
        this.setOptions(config.options);
        this.observers = [];
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $73e4f980fbd6b4b1$var$_client, config.client);
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $73e4f980fbd6b4b1$var$_cache, (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_client).getQueryCache());
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $73e4f980fbd6b4b1$var$_initialState, $73e4f980fbd6b4b1$var$getDefaultState(this.options));
        this.state = config.state ?? (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get promise() {
        var _a;
        return (_a = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_retryer)) == null ? void 0 : _a.promise;
    }
    setOptions(options) {
        this.options = {
            ...(0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
        if (this.state && this.state.data === void 0) {
            const defaultState = $73e4f980fbd6b4b1$var$getDefaultState(this.options);
            if (defaultState.data !== void 0) {
                this.setState($73e4f980fbd6b4b1$var$successState(defaultState.data, defaultState.dataUpdatedAt));
                (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $73e4f980fbd6b4b1$var$_initialState, defaultState);
            }
        }
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, $43eecd02f94428b5$export$17619bac5b909b23)(this.state.data, newData, this.options);
        (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $73e4f980fbd6b4b1$var$_Query_instances, $73e4f980fbd6b4b1$var$dispatch_fn).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $73e4f980fbd6b4b1$var$_Query_instances, $73e4f980fbd6b4b1$var$dispatch_fn).call(this, {
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _a, _b;
        const promise = (_a = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_retryer)) == null ? void 0 : _a.promise;
        (_b = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_retryer)) == null || _b.cancel(options);
        return promise ? promise.then((0, $43eecd02f94428b5$export$8793edee2d425525)).catch((0, $43eecd02f94428b5$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    get resetState() {
        return (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_initialState);
    }
    reset() {
        this.destroy();
        this.setState(this.resetState);
    }
    isActive() {
        return this.observers.some((observer)=>(0, $43eecd02f94428b5$export$8c88ee6f2357230d)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $43eecd02f94428b5$export$1aa5a89531b7670d) || !this.isFetched();
    }
    isFetched() {
        return this.state.dataUpdateCount + this.state.errorUpdateCount > 0;
    }
    isStatic() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>(0, $43eecd02f94428b5$export$cb3145f011bda3ac)(observer.options.staleTime, this) === "static");
        return false;
    }
    isStale() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0 || this.state.isInvalidated;
    }
    isStaleByTime(staleTime = 0) {
        if (this.state.data === void 0) return true;
        if (staleTime === "static") return false;
        if (this.state.isInvalidated) return true;
        return !(0, $43eecd02f94428b5$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_cache).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if ((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_retryer)) {
                    if ((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_abortSignalConsumed) || (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $73e4f980fbd6b4b1$var$_Query_instances, $73e4f980fbd6b4b1$var$isInitialPausedFetch_fn).call(this)) (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_retryer).cancel({
                        revert: true
                    });
                    else (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_cache).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $73e4f980fbd6b4b1$var$_Query_instances, $73e4f980fbd6b4b1$var$dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    async fetch(options, fetchOptions) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
        if (this.state.fetchStatus !== "idle" && // If the promise in the retryer is already rejected, we have to definitely
        // re-start the fetch; there is a chance that the query is still in a
        // pending state when that happens
        ((_a = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_retryer)) == null ? void 0 : _a.status()) !== "rejected") {
            if (this.state.data !== void 0 && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_retryer)) {
                (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_retryer).continueRetry();
                return (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_retryer).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        if (!Array.isArray(this.options.queryKey)) console.error(`As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']`);
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $73e4f980fbd6b4b1$var$_abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $43eecd02f94428b5$export$c71c44209368a3bc)(this.options, fetchOptions);
            const createQueryFnContext = ()=>{
                const queryFnContext2 = {
                    client: (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_client),
                    queryKey: this.queryKey,
                    meta: this.meta
                };
                addSignalProperty(queryFnContext2);
                return queryFnContext2;
            };
            const queryFnContext = createQueryFnContext();
            (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $73e4f980fbd6b4b1$var$_abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const createFetchContext = ()=>{
            const context2 = {
                fetchOptions: fetchOptions,
                options: this.options,
                queryKey: this.queryKey,
                client: (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_client),
                state: this.state,
                fetchFn: fetchFn
            };
            addSignalProperty(context2);
            return context2;
        };
        const context = createFetchContext();
        (_b = this.options.behavior) == null || _b.onFetch(context, this);
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $73e4f980fbd6b4b1$var$_revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_c = context.fetchOptions) == null ? void 0 : _c.meta)) (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $73e4f980fbd6b4b1$var$_Query_instances, $73e4f980fbd6b4b1$var$dispatch_fn).call(this, {
            type: "fetch",
            meta: (_d = context.fetchOptions) == null ? void 0 : _d.meta
        });
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $73e4f980fbd6b4b1$var$_retryer, (0, $53fcf2fd81a8ad80$export$2cbd00fe8a2c8d85)({
            initialPromise: fetchOptions == null ? void 0 : fetchOptions.initialPromise,
            fn: context.fetchFn,
            onCancel: (error)=>{
                if (error instanceof (0, $53fcf2fd81a8ad80$export$a8430ed4188f35a9) && error.revert) this.setState({
                    ...(0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_revertState),
                    fetchStatus: "idle"
                });
                abortController.abort();
            },
            onFail: (failureCount, error)=>{
                (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $73e4f980fbd6b4b1$var$_Query_instances, $73e4f980fbd6b4b1$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $73e4f980fbd6b4b1$var$_Query_instances, $73e4f980fbd6b4b1$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $73e4f980fbd6b4b1$var$_Query_instances, $73e4f980fbd6b4b1$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        }));
        try {
            const data = await (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_retryer).start();
            if (data === void 0) {
                console.error(`Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`);
                throw new Error(`${this.queryHash} data is undefined`);
            }
            this.setData(data);
            (_f = (_e = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_cache).config).onSuccess) == null || _f.call(_e, data, this);
            (_h = (_g = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_cache).config).onSettled) == null || _h.call(_g, data, this.state.error, this);
            return data;
        } catch (error) {
            if (error instanceof (0, $53fcf2fd81a8ad80$export$a8430ed4188f35a9)) {
                if (error.silent) return (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_retryer).promise;
                else if (error.revert) {
                    if (this.state.data === void 0) throw error;
                    return this.state.data;
                }
            }
            (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $73e4f980fbd6b4b1$var$_Query_instances, $73e4f980fbd6b4b1$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            (_j = (_i = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_cache).config).onError) == null || _j.call(_i, error, this);
            (_l = (_k = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_cache).config).onSettled) == null || _l.call(_k, this.state.data, error, this);
            throw error;
        } finally{
            this.scheduleGc();
        }
    }
};
$73e4f980fbd6b4b1$var$_initialState = new WeakMap();
$73e4f980fbd6b4b1$var$_revertState = new WeakMap();
$73e4f980fbd6b4b1$var$_cache = new WeakMap();
$73e4f980fbd6b4b1$var$_client = new WeakMap();
$73e4f980fbd6b4b1$var$_retryer = new WeakMap();
$73e4f980fbd6b4b1$var$_defaultOptions = new WeakMap();
$73e4f980fbd6b4b1$var$_abortSignalConsumed = new WeakMap();
$73e4f980fbd6b4b1$var$_Query_instances = new WeakSet();
$73e4f980fbd6b4b1$var$isInitialPausedFetch_fn = function() {
    return this.state.fetchStatus === "paused" && this.state.status === "pending";
};
$73e4f980fbd6b4b1$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    ...$73e4f980fbd6b4b1$export$f3df9013f2b58bce(state.data, this.options),
                    fetchMeta: action.meta ?? null
                };
            case "success":
                const newState = {
                    ...state,
                    ...$73e4f980fbd6b4b1$var$successState(action.data, action.dataUpdatedAt),
                    dataUpdateCount: state.dataUpdateCount + 1,
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
                (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $73e4f980fbd6b4b1$var$_revertState, action.manual ? newState : void 0);
                return newState;
            case "error":
                const error = action.error;
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error",
                    // flag existing data as invalidated if we get a background error
                    // note that "no data" always means stale so we can set unconditionally here
                    isInvalidated: true
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $c7defa80f1ead432$export$520687f44db6e1ab).batch(()=>{
        this.observers.forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73e4f980fbd6b4b1$var$_cache).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
};
function $73e4f980fbd6b4b1$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $53fcf2fd81a8ad80$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $73e4f980fbd6b4b1$var$successState(data, dataUpdatedAt) {
    return {
        data: data,
        dataUpdatedAt: dataUpdatedAt ?? Date.now(),
        error: null,
        isInvalidated: false,
        status: "success"
    };
}
function $73e4f980fbd6b4b1$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $b68418de0ebb195d$var$_queries;
var $b68418de0ebb195d$export$5dde0cd941da8468 = class extends (0, $9e2bfa130a0bbb51$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $b68418de0ebb195d$var$_queries);
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $b68418de0ebb195d$var$_queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $43eecd02f94428b5$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $73e4f980fbd6b4b1$export$62297b13309008b2)({
                client: client,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $b68418de0ebb195d$var$_queries).has(query.queryHash)) {
            (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $b68418de0ebb195d$var$_queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $b68418de0ebb195d$var$_queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $b68418de0ebb195d$var$_queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $c7defa80f1ead432$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $b68418de0ebb195d$var$_queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $b68418de0ebb195d$var$_queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $43eecd02f94428b5$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $43eecd02f94428b5$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $c7defa80f1ead432$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $c7defa80f1ead432$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $c7defa80f1ead432$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
$b68418de0ebb195d$var$_queries = new WeakMap();








var $bc1d1366ad71f960$var$_client, $bc1d1366ad71f960$var$_observers, $bc1d1366ad71f960$var$_mutationCache, $bc1d1366ad71f960$var$_retryer, $bc1d1366ad71f960$var$_Mutation_instances, $bc1d1366ad71f960$var$dispatch_fn;
var $bc1d1366ad71f960$export$17b8b19c814bcf56 = class extends (0, $9579c402b754475f$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $bc1d1366ad71f960$var$_Mutation_instances);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $bc1d1366ad71f960$var$_client);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $bc1d1366ad71f960$var$_observers);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $bc1d1366ad71f960$var$_mutationCache);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $bc1d1366ad71f960$var$_retryer);
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $bc1d1366ad71f960$var$_client, config.client);
        this.mutationId = config.mutationId;
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $bc1d1366ad71f960$var$_mutationCache, config.mutationCache);
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $bc1d1366ad71f960$var$_observers, []);
        this.state = config.state || $bc1d1366ad71f960$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $bc1d1366ad71f960$var$_observers).includes(observer)) {
            (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $bc1d1366ad71f960$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $bc1d1366ad71f960$var$_mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $bc1d1366ad71f960$var$_observers, (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $bc1d1366ad71f960$var$_observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $bc1d1366ad71f960$var$_mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $bc1d1366ad71f960$var$_observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $bc1d1366ad71f960$var$_mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $bc1d1366ad71f960$var$_retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
        const onContinue = ()=>{
            (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $bc1d1366ad71f960$var$_Mutation_instances, $bc1d1366ad71f960$var$dispatch_fn).call(this, {
                type: "continue"
            });
        };
        const mutationFnContext = {
            client: (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $bc1d1366ad71f960$var$_client),
            meta: this.options.meta,
            mutationKey: this.options.mutationKey
        };
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $bc1d1366ad71f960$var$_retryer, (0, $53fcf2fd81a8ad80$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables, mutationFnContext);
            },
            onFail: (failureCount, error)=>{
                (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $bc1d1366ad71f960$var$_Mutation_instances, $bc1d1366ad71f960$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $bc1d1366ad71f960$var$_Mutation_instances, $bc1d1366ad71f960$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: onContinue,
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>(0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $bc1d1366ad71f960$var$_mutationCache).canRun(this)
        }));
        const restored = this.state.status === "pending";
        const isPaused = !(0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $bc1d1366ad71f960$var$_retryer).canStart();
        try {
            if (restored) onContinue();
            else {
                (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $bc1d1366ad71f960$var$_Mutation_instances, $bc1d1366ad71f960$var$dispatch_fn).call(this, {
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                if ((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $bc1d1366ad71f960$var$_mutationCache).config.onMutate) await (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $bc1d1366ad71f960$var$_mutationCache).config.onMutate(variables, this, mutationFnContext);
                const context = await ((_b = (_a = this.options).onMutate) == null ? void 0 : _b.call(_a, variables, mutationFnContext));
                if (context !== this.state.context) (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $bc1d1366ad71f960$var$_Mutation_instances, $bc1d1366ad71f960$var$dispatch_fn).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $bc1d1366ad71f960$var$_retryer).start();
            await ((_d = (_c = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $bc1d1366ad71f960$var$_mutationCache).config).onSuccess) == null ? void 0 : _d.call(_c, data, variables, this.state.context, this, mutationFnContext));
            await ((_f = (_e = this.options).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, mutationFnContext));
            await ((_h = (_g = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $bc1d1366ad71f960$var$_mutationCache).config).onSettled) == null ? void 0 : _h.call(_g, data, null, this.state.variables, this.state.context, this, mutationFnContext));
            await ((_j = (_i = this.options).onSettled) == null ? void 0 : _j.call(_i, data, null, variables, this.state.context, mutationFnContext));
            (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $bc1d1366ad71f960$var$_Mutation_instances, $bc1d1366ad71f960$var$dispatch_fn).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await ((_l = (_k = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $bc1d1366ad71f960$var$_mutationCache).config).onError) == null ? void 0 : _l.call(_k, error, variables, this.state.context, this, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await ((_n = (_m = this.options).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await ((_p = (_o = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $bc1d1366ad71f960$var$_mutationCache).config).onSettled) == null ? void 0 : _p.call(_o, void 0, error, this.state.variables, this.state.context, this, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await ((_r = (_q = this.options).onSettled) == null ? void 0 : _r.call(_q, void 0, error, variables, this.state.context, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $bc1d1366ad71f960$var$_Mutation_instances, $bc1d1366ad71f960$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            throw error;
        } finally{
            (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $bc1d1366ad71f960$var$_mutationCache).runNext(this);
        }
    }
};
$bc1d1366ad71f960$var$_client = new WeakMap();
$bc1d1366ad71f960$var$_observers = new WeakMap();
$bc1d1366ad71f960$var$_mutationCache = new WeakMap();
$bc1d1366ad71f960$var$_retryer = new WeakMap();
$bc1d1366ad71f960$var$_Mutation_instances = new WeakSet();
$bc1d1366ad71f960$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: action.isPaused,
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $c7defa80f1ead432$export$520687f44db6e1ab).batch(()=>{
        (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $bc1d1366ad71f960$var$_observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $bc1d1366ad71f960$var$_mutationCache).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
};
function $bc1d1366ad71f960$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}




var $3aac2dc3f0eb8b77$var$_mutations, $3aac2dc3f0eb8b77$var$_scopes, $3aac2dc3f0eb8b77$var$_mutationId;
var $3aac2dc3f0eb8b77$export$1fcfd9a244434844 = class extends (0, $9e2bfa130a0bbb51$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $3aac2dc3f0eb8b77$var$_mutations);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $3aac2dc3f0eb8b77$var$_scopes);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $3aac2dc3f0eb8b77$var$_mutationId);
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $3aac2dc3f0eb8b77$var$_mutations, /* @__PURE__ */ new Set());
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $3aac2dc3f0eb8b77$var$_scopes, /* @__PURE__ */ new Map());
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $3aac2dc3f0eb8b77$var$_mutationId, 0);
    }
    build(client, options, state) {
        const mutation = new (0, $bc1d1366ad71f960$export$17b8b19c814bcf56)({
            client: client,
            mutationCache: this,
            mutationId: ++(0, $9e75c35ac10ca972$export$b1fe7cbb4502036b)(this, $3aac2dc3f0eb8b77$var$_mutationId)._,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $3aac2dc3f0eb8b77$var$_mutations).add(mutation);
        const scope = $3aac2dc3f0eb8b77$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $3aac2dc3f0eb8b77$var$_scopes).get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $3aac2dc3f0eb8b77$var$_scopes).set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        if ((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $3aac2dc3f0eb8b77$var$_mutations).delete(mutation)) {
            const scope = $3aac2dc3f0eb8b77$var$scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $3aac2dc3f0eb8b77$var$_scopes).get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $3aac2dc3f0eb8b77$var$_scopes).delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        const scope = $3aac2dc3f0eb8b77$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $3aac2dc3f0eb8b77$var$_scopes).get(scope);
            const firstPendingMutation = mutationsWithSameScope == null ? void 0 : mutationsWithSameScope.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    runNext(mutation) {
        var _a;
        const scope = $3aac2dc3f0eb8b77$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const foundMutation = (_a = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $3aac2dc3f0eb8b77$var$_scopes).get(scope)) == null ? void 0 : _a.find((m)=>m !== mutation && m.state.isPaused);
            return (foundMutation == null ? void 0 : foundMutation.continue()) ?? Promise.resolve();
        } else return Promise.resolve();
    }
    clear() {
        (0, $c7defa80f1ead432$export$520687f44db6e1ab).batch(()=>{
            (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $3aac2dc3f0eb8b77$var$_mutations).forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            });
            (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $3aac2dc3f0eb8b77$var$_mutations).clear();
            (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $3aac2dc3f0eb8b77$var$_scopes).clear();
        });
    }
    getAll() {
        return Array.from((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $3aac2dc3f0eb8b77$var$_mutations));
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $43eecd02f94428b5$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $43eecd02f94428b5$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $c7defa80f1ead432$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $c7defa80f1ead432$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $43eecd02f94428b5$export$8793edee2d425525)))));
    }
};
$3aac2dc3f0eb8b77$var$_mutations = new WeakMap();
$3aac2dc3f0eb8b77$var$_scopes = new WeakMap();
$3aac2dc3f0eb8b77$var$_mutationId = new WeakMap();
function $3aac2dc3f0eb8b77$var$scopeFor(mutation) {
    var _a;
    return (_a = mutation.options.scope) == null ? void 0 : _a.id;
}







function $ee973f0a6b22cb32$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            var _a, _b, _c, _d, _e;
            const options = context.options;
            const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
            const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
            const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    (0, $43eecd02f94428b5$export$83f813cd1f8a4973)(object, ()=>context.signal, ()=>cancelled = true);
                };
                const queryFn = (0, $43eecd02f94428b5$export$c71c44209368a3bc)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const createQueryFnContext = ()=>{
                        const queryFnContext2 = {
                            client: context.client,
                            queryKey: context.queryKey,
                            pageParam: param,
                            direction: previous ? "backward" : "forward",
                            meta: context.options.meta
                        };
                        addSignalProperty(queryFnContext2);
                        return queryFnContext2;
                    };
                    const queryFnContext = createQueryFnContext();
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $43eecd02f94428b5$export$8c6246b73dd61f4a) : (0, $43eecd02f94428b5$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $ee973f0a6b22cb32$var$getPreviousPageParam : $ee973f0a6b22cb32$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : $ee973f0a6b22cb32$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a2, _b2;
                return (_b2 = (_a2 = context.options).persister) == null ? void 0 : _b2.call(_a2, fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $ee973f0a6b22cb32$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $ee973f0a6b22cb32$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _a;
    return pages.length > 0 ? (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $ee973f0a6b22cb32$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $ee973f0a6b22cb32$var$getNextPageParam(options, data) != null;
}
function $ee973f0a6b22cb32$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $ee973f0a6b22cb32$var$getPreviousPageParam(options, data) != null;
}


var $73c27837fee14e76$var$_queryCache, $73c27837fee14e76$var$_mutationCache, $73c27837fee14e76$var$_defaultOptions, $73c27837fee14e76$var$_queryDefaults, $73c27837fee14e76$var$_mutationDefaults, $73c27837fee14e76$var$_mountCount, $73c27837fee14e76$var$_unsubscribeFocus, $73c27837fee14e76$var$_unsubscribeOnline;
var $73c27837fee14e76$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $73c27837fee14e76$var$_queryCache);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $73c27837fee14e76$var$_mutationCache);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $73c27837fee14e76$var$_defaultOptions);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $73c27837fee14e76$var$_queryDefaults);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $73c27837fee14e76$var$_mutationDefaults);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $73c27837fee14e76$var$_mountCount);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $73c27837fee14e76$var$_unsubscribeFocus);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $73c27837fee14e76$var$_unsubscribeOnline);
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $73c27837fee14e76$var$_queryCache, config.queryCache || new (0, $b68418de0ebb195d$export$5dde0cd941da8468)());
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $73c27837fee14e76$var$_mutationCache, config.mutationCache || new (0, $3aac2dc3f0eb8b77$export$1fcfd9a244434844)());
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $73c27837fee14e76$var$_defaultOptions, config.defaultOptions || {});
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $73c27837fee14e76$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $73c27837fee14e76$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $73c27837fee14e76$var$_mountCount, 0);
    }
    mount() {
        (0, $9e75c35ac10ca972$export$b1fe7cbb4502036b)(this, $73c27837fee14e76$var$_mountCount)._++;
        if ((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_mountCount) !== 1) return;
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $73c27837fee14e76$var$_unsubscribeFocus, (0, $f2135b4901caba4c$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_queryCache).onFocus();
            }
        }));
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $73c27837fee14e76$var$_unsubscribeOnline, (0, $85cf0e0b83899bf8$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, $9e75c35ac10ca972$export$b1fe7cbb4502036b)(this, $73c27837fee14e76$var$_mountCount)._--;
        if ((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_mountCount) !== 0) return;
        (_a = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_unsubscribeFocus)) == null || _a.call(this);
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $73c27837fee14e76$var$_unsubscribeFocus, void 0);
        (_b = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_unsubscribeOnline)) == null || _b.call(this);
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $73c27837fee14e76$var$_unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */ getQueryData(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_queryCache).build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $43eecd02f94428b5$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    getQueriesData(filters) {
        return (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_queryCache).findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_queryCache).get(defaultedOptions.queryHash);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $43eecd02f94428b5$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return void 0;
        return (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $c7defa80f1ead432$export$520687f44db6e1ab).batch(()=>(0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_queryCache).findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_queryCache);
        (0, $c7defa80f1ead432$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_queryCache);
        return (0, $c7defa80f1ead432$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries({
                type: "active",
                ...filters
            }, options);
        });
    }
    cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $c7defa80f1ead432$export$520687f44db6e1ab).batch(()=>(0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $43eecd02f94428b5$export$8793edee2d425525)).catch((0, $43eecd02f94428b5$export$8793edee2d425525));
    }
    invalidateQueries(filters, options = {}) {
        return (0, $c7defa80f1ead432$export$520687f44db6e1ab).batch(()=>{
            (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if ((filters == null ? void 0 : filters.refetchType) === "none") return Promise.resolve();
            return this.refetchQueries({
                ...filters,
                type: (filters == null ? void 0 : filters.refetchType) ?? (filters == null ? void 0 : filters.type) ?? "active"
            }, options);
        });
    }
    refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, $c7defa80f1ead432$export$520687f44db6e1ab).batch(()=>(0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_queryCache).findAll(filters).filter((query)=>!query.isDisabled() && !query.isStatic()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $43eecd02f94428b5$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $43eecd02f94428b5$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_queryCache).build(this, defaultedOptions);
        return query.isStaleByTime((0, $43eecd02f94428b5$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $43eecd02f94428b5$export$8793edee2d425525)).catch((0, $43eecd02f94428b5$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $ee973f0a6b22cb32$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $43eecd02f94428b5$export$8793edee2d425525)).catch((0, $43eecd02f94428b5$export$8793edee2d425525));
    }
    ensureInfiniteQueryData(options) {
        options.behavior = (0, $ee973f0a6b22cb32$export$84470d1367601e8d)(options.pages);
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, $85cf0e0b83899bf8$export$b113e788b2dd3fdc).isOnline()) return (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_mutationCache).resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_queryCache);
    }
    getMutationCache() {
        return (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_mutationCache);
    }
    getDefaultOptions() {
        return (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_defaultOptions);
    }
    setDefaultOptions(options) {
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $73c27837fee14e76$var$_defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_queryDefaults).set((0, $43eecd02f94428b5$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_queryDefaults).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $43eecd02f94428b5$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_mutationDefaults).set((0, $43eecd02f94428b5$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_mutationDefaults).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $43eecd02f94428b5$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_defaultOptions).queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $43eecd02f94428b5$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $43eecd02f94428b5$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_queryCache).clear();
        (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $73c27837fee14e76$var$_mutationCache).clear();
    }
};
$73c27837fee14e76$var$_queryCache = new WeakMap();
$73c27837fee14e76$var$_mutationCache = new WeakMap();
$73c27837fee14e76$var$_defaultOptions = new WeakMap();
$73c27837fee14e76$var$_queryDefaults = new WeakMap();
$73c27837fee14e76$var$_mutationDefaults = new WeakMap();
$73c27837fee14e76$var$_mountCount = new WeakMap();
$73c27837fee14e76$var$_unsubscribeFocus = new WeakMap();
$73c27837fee14e76$var$_unsubscribeOnline = new WeakMap();


var $2xPiy = parcelRequire("2xPiy");

"use client";
var $bccbe1b43ff3d0cc$export$da112d31b0149f31 = $2xPiy.createContext(void 0);
var $bccbe1b43ff3d0cc$export$22e77b9572c4fded = (queryClient)=>{
    const client = $2xPiy.useContext($bccbe1b43ff3d0cc$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $bccbe1b43ff3d0cc$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $2xPiy.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $cb4cc5db45d03478$exports.jsx)($bccbe1b43ff3d0cc$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};



var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");

var $2xPiy = parcelRequire("2xPiy");
var $18ec84c72847fc8a$export$64a849364cd772b4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createContext(typeof document === 'object' ? document.body : undefined);


var $2xPiy = parcelRequire("2xPiy");

var $dyr1f = parcelRequire("dyr1f");
var $25a3992d69a7a213$var$PropType = {};
$25a3992d69a7a213$var$PropType = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func
};
var $25a3992d69a7a213$export$4c170dc5df56b17c = $25a3992d69a7a213$var$PropType;


var $10007abd86899141$export$51e389dae84ec233 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createContext(undefined);
$10007abd86899141$export$51e389dae84ec233.propTypes = (0, $25a3992d69a7a213$export$4c170dc5df56b17c);


var $2xPiy = parcelRequire("2xPiy");

var $dyr1f = parcelRequire("dyr1f");

var $iA1nz = parcelRequire("iA1nz");
function $cdf577e3272e3992$var$_extends() {
    return $cdf577e3272e3992$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cdf577e3272e3992$var$_extends.apply(null, arguments);
}
var $cdf577e3272e3992$export$a6cdc56e425d0d0a = function isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
};
var $cdf577e3272e3992$export$7e32b29e1cb162e1 = function deepFreeze(obj) {
    Object.keys(obj).forEach(function(key) {
        return key && $cdf577e3272e3992$export$a6cdc56e425d0d0a(obj[key]) && Object.freeze(obj[key]);
    });
    return Object.freeze(obj);
};
var $cdf577e3272e3992$export$6969335ea1e4e77c = function deepMerge(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    // making sure to not change target (immutable)
    var output = $cdf577e3272e3992$var$_extends({}, target);
    sources.forEach(function(source) {
        if ($cdf577e3272e3992$export$a6cdc56e425d0d0a(source)) Object.keys(source).forEach(function(key) {
            if ($cdf577e3272e3992$export$a6cdc56e425d0d0a(source[key])) {
                if (!output[key]) output[key] = $cdf577e3272e3992$var$_extends({}, source[key]);
                else output[key] = $cdf577e3272e3992$export$6969335ea1e4e77c(output[key], source[key]);
            } else output[key] = source[key];
        });
    });
    return output;
};
var $cdf577e3272e3992$export$c499305a875a8ee9 = function removeUndefined(obj) {
    var result = {};
    Object.keys(obj).forEach(function(key) {
        if (obj[key] !== undefined) result[key] = obj[key];
    });
    return result;
};



var $dyr1f = parcelRequire("dyr1f");
var $184fb57a50f1df87$var$PropType = {};
$184fb57a50f1df87$var$PropType = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({})
};
var $184fb57a50f1df87$export$b969a6543dfc7938 = $184fb57a50f1df87$var$PropType;


(0, $iA1nz.ThemeContext).Extend = function(_ref) {
    var children = _ref.children, value = _ref.value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $iA1nz.ThemeContext).Consumer, null, function(theme) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $iA1nz.ThemeContext).Provider, {
            value: (0, $cdf577e3272e3992$export$6969335ea1e4e77c)(theme, value)
        }, children);
    });
};
(0, $iA1nz.ThemeContext).Extend.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({}).isRequired
};
(0, $iA1nz.ThemeContext).propTypes = (0, $184fb57a50f1df87$export$b969a6543dfc7938);


var $iA1nz = parcelRequire("iA1nz");

var $iA1nz = parcelRequire("iA1nz");
// Track which deprecated colors have already been warned about
var $11317b0e49e0d157$var$warnedColors = new Set();
var $11317b0e49e0d157$var$checkColorDeprecation = function checkColorDeprecation(color, theme, dark) {
    var _theme$global$depreca;
    if ((_theme$global$depreca = theme.global.deprecated) != null && _theme$global$depreca.colors && true) {
        var colorKey = color;
        if (typeof color === 'object') {
            if (dark === true || dark === undefined && theme.dark) colorKey = color.dark;
            else colorKey = color.light;
        }
        if (!$11317b0e49e0d157$var$warnedColors.has(colorKey)) {
            var deprecatedColor;
            if (typeof color === 'string') deprecatedColor = theme.global.deprecated.colors.find(function(item) {
                return item.name === color;
            });
            else if (typeof color === 'object') deprecatedColor = theme.global.deprecated.colors.find(function(item) {
                return item.name === color.light || item.name === color.dark;
            });
            if (deprecatedColor) {
                $11317b0e49e0d157$var$warnedColors.add(colorKey);
                console.warn(deprecatedColor.message || colorKey + " is deprecated.");
            }
        }
    }
};
// Returns the specific color that should be used according to the theme.
// If 'dark' is supplied, it takes precedence over 'theme.dark'.
// Can return undefined.
var $11317b0e49e0d157$export$4cde5df63f53f473 = function normalizeColor(color, theme, dark) {
    $11317b0e49e0d157$var$checkColorDeprecation(color, theme, dark);
    var colorSpec = theme.global && theme.global.colors[color] !== undefined ? theme.global.colors[color] : color;
    // If the color has a light or dark object, use that
    var result = colorSpec;
    if (colorSpec) {
        if ((dark === true || dark === undefined && theme.dark) && colorSpec.dark !== undefined) result = colorSpec.dark;
        else if ((dark === false || !theme.dark) && colorSpec.light !== undefined) result = colorSpec.light;
    }
    // allow one level of indirection in color names
    if (result && theme.global && theme.global.colors[result] !== undefined) result = $11317b0e49e0d157$export$4cde5df63f53f473(result, theme, dark);
    return result;
};
var $11317b0e49e0d157$var$parseHexToRGB = function parseHexToRGB(color) {
    return color.length < 7 // 7 is what's needed for '#RRGGBB'
     ? color.match(/[A-Za-z0-9]{1}/g).map(function(v) {
        return parseInt("" + v + v, 16);
    }) : // https://stackoverflow.com/a/42429333
    color.match(/[A-Za-z0-9]{2}/g).map(function(v) {
        return parseInt(v, 16);
    });
};
// From: https://stackoverflow.com/a/9493060/8513067
// Converts an HSL color value to RGB. Conversion formula
// adapted from http://en.wikipedia.org/wiki/HSL_color_space.
// Assumes h, s, and l are contained in the set [0, 1] and
// returns r, g, and b in the set [0, 255].
var $11317b0e49e0d157$var$hslToRGB = function hslToRGB(h, s, l) {
    var r;
    var g;
    var b;
    if (s === 0 || s === '0') {
        // achromatic
        r = l;
        g = l;
        b = l;
    } else {
        var hue2rgb = function hue2rgb(p, q, inT) {
            var t = inT;
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 0.16666667) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 0.66666667) return p + (q - p) * (0.66666667 - t) * 6;
            return p;
        };
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 0.33333333);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 0.33333333);
    }
    return [
        Math.round(r * 255),
        Math.round(g * 255),
        Math.round(b * 255)
    ];
};
// allow for alpha: #RGB, #RGBA, #RRGGBB, or #RRGGBBAA
var $11317b0e49e0d157$var$hexExp = /^#[A-Za-z0-9]{3,4}$|^#[A-Za-z0-9]{6,8}$/;
var $11317b0e49e0d157$var$rgbExp = /^rgba?\(\s?([0-9]*)\s?,\s?([0-9]*)\s?,\s?([0-9]*)\s?\)/;
var $11317b0e49e0d157$var$rgbaExp = /^rgba?\(\s?([0-9]*)\s?,\s?([0-9]*)\s?,\s?([0-9]*)\s?,\s?([.0-9]*)\s?\)/;
// e.g. hsl(240, 60%, 50%)
var $11317b0e49e0d157$var$hslExp = /^hsla?\(\s?([0-9]*)\s?,\s?([0-9]*)%?\s?,\s?([0-9]*)%?\s?.*?\)/;
var $11317b0e49e0d157$export$6d62a0650580a0ff = function canExtractRGBArray(color) {
    return $11317b0e49e0d157$var$hexExp.test(color) || $11317b0e49e0d157$var$rgbExp.test(color) || $11317b0e49e0d157$var$rgbaExp.test(color) || $11317b0e49e0d157$var$hslExp.test(color);
};
var $11317b0e49e0d157$export$5bcd173cc9a0dca = function getRGBArray(color) {
    if ($11317b0e49e0d157$var$hexExp.test(color)) {
        var _parseHexToRGB = $11317b0e49e0d157$var$parseHexToRGB(color), red = _parseHexToRGB[0], green = _parseHexToRGB[1], blue = _parseHexToRGB[2], alpha = _parseHexToRGB[3];
        return [
            red,
            green,
            blue,
            alpha !== undefined ? alpha / 255.0 : undefined
        ];
    }
    var match = color.match($11317b0e49e0d157$var$rgbExp);
    if (match) return match.splice(1).map(function(v) {
        return parseInt(v, 10);
    });
    match = color.match($11317b0e49e0d157$var$rgbaExp);
    if (match) return match.splice(1).map(function(v) {
        return parseFloat(v, 10);
    });
    match = color.match($11317b0e49e0d157$var$hslExp);
    if (match) {
        var _match$splice$map = match.splice(1).map(function(v) {
            return parseInt(v, 10);
        }), h = _match$splice$map[0], s = _match$splice$map[1], l = _match$splice$map[2];
        return $11317b0e49e0d157$var$hslToRGB(h / 360.0, s / 100.0, l / 100.0);
    }
    return color;
};
var $11317b0e49e0d157$export$76249e090d1c76db = function colorIsDark(color) {
    if (color && $11317b0e49e0d157$export$6d62a0650580a0ff(color)) {
        var _getRGBArray = $11317b0e49e0d157$export$5bcd173cc9a0dca(color), red = _getRGBArray[0], green = _getRGBArray[1], blue = _getRGBArray[2], alpha = _getRGBArray[3];
        // if there is an alpha and it's greater than 50%, we can't really tell
        if (alpha < 0.5) return undefined;
        var brightness = (299 * red + 587 * green + 114 * blue) / 1000;
        // From: http://www.had2know.com/technology/color-contrast-calculator-web-design.html
        // Above domain is no longer registered.
        return brightness < 125;
    }
    return undefined;
};
var $11317b0e49e0d157$export$c24a0a5c5129b2e1 = function getRGBA(color, opacity) {
    if (color && $11317b0e49e0d157$export$6d62a0650580a0ff(color)) {
        var _getRGBArray2 = $11317b0e49e0d157$export$5bcd173cc9a0dca(color), red = _getRGBArray2[0], green = _getRGBArray2[1], blue = _getRGBArray2[2], alpha = _getRGBArray2[3];
        var normalizedAlpha;
        if (opacity !== undefined) normalizedAlpha = opacity;
        else if (alpha !== undefined) normalizedAlpha = alpha;
        else normalizedAlpha = 1;
        return "rgba(" + red + ", " + green + ", " + blue + ", " + normalizedAlpha + ")";
    }
    return undefined;
};


// evalStyle() converts a styled-components item into a string
var $0b4a347e23c22183$var$evalStyle = function evalStyle(arg, theme) {
    if (arg && Array.isArray(arg) && typeof arg[0] === 'function') return arg[0]({
        theme: theme
    });
    return arg;
};
var $0b4a347e23c22183$export$7b802385d70a5af9 = function normalizeBackground(backgroundArg, theme) {
    var _theme$global$backgro;
    var background = ((_theme$global$backgro = theme.global.backgrounds) == null ? void 0 : _theme$global$backgro[backgroundArg]) || backgroundArg;
    var result = background;
    // If the background has a light or dark object, use that
    if (background) {
        if (theme.dark && background.dark && typeof background.dark !== 'boolean') result = background.dark;
        else if (!theme.dark && background.light && typeof background.light !== 'boolean') result = background.light;
        result = $0b4a347e23c22183$var$evalStyle(result, theme);
    }
    return result;
};
var $0b4a347e23c22183$var$normalizeBackgroundColor = function normalizeBackgroundColor(backgroundArg, theme) {
    var _theme$global$backgro2;
    var background = backgroundArg.color || backgroundArg;
    var result = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(// Background color may be defined by theme.global.backgrounds or
    // theme.global.colors.
    ((_theme$global$backgro2 = theme.global.backgrounds) == null ? void 0 : _theme$global$backgro2[background]) || background, theme, backgroundArg.dark);
    return result;
};
var $0b4a347e23c22183$var$_normalizeBackgroundImage = function normalizeBackgroundImage(background, theme) {
    var result;
    if (background.image) {
        var _theme$global$backgro3, _theme$global$backgro4;
        result = $0b4a347e23c22183$export$7b802385d70a5af9(background.dark ? (_theme$global$backgro3 = theme.global.backgrounds) == null || (_theme$global$backgro3 = _theme$global$backgro3[background.image]) == null ? void 0 : _theme$global$backgro3.dark : (_theme$global$backgro4 = theme.global.backgrounds) == null ? void 0 : _theme$global$backgro4[background.image], theme) || background.image;
    } else {
        var _theme$global$backgro5;
        var normalized = $0b4a347e23c22183$export$7b802385d70a5af9((_theme$global$backgro5 = theme.global.backgrounds) == null ? void 0 : _theme$global$backgro5[background], theme);
        result = typeof normalized === 'object' ? $0b4a347e23c22183$var$_normalizeBackgroundImage(normalized, theme) : normalized;
    }
    return result;
};
var $0b4a347e23c22183$var$rotateBackground = function rotateBackground(background, theme) {
    var backgroundImage = $0b4a347e23c22183$var$_normalizeBackgroundImage(background, theme);
    var result = backgroundImage;
    if (backgroundImage.lastIndexOf('linear-gradient', 0) === 0) {
        var regex = /\d{1,}deg\b,/gm; // Contains rotation specified in degrees. Only targets 'deg' string with a trailing comma. Do not match 'deg' string for hsl, etc..
        result = backgroundImage.lastIndexOf('deg,') >= 0 ? backgroundImage.replace(regex, background.rotate + "deg,") : backgroundImage.replace('linear-gradient(', "linear-gradient(" + background.rotate + "deg, ");
    } else console.warn("'background.rotate' property only supports 'background.image' containing a linear-gradient string.");
    return result;
};
var $0b4a347e23c22183$export$d285dc898c6a4d11 = function backgroundIsDark(backgroundArg, theme) {
    var background = $0b4a347e23c22183$export$7b802385d70a5af9(backgroundArg, theme);
    var result;
    if (background) {
        if (typeof background === 'object') {
            var color = background.color, dark = background.dark, opacity = background.opacity;
            if (typeof dark === 'boolean') result = dark;
            else if (color && // weak opacity means we keep the existing darkness
            (!opacity || opacity !== 'weak')) {
                var backgroundColor = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(background.color, theme);
                if (backgroundColor) result = (0, $11317b0e49e0d157$export$76249e090d1c76db)(backgroundColor);
            }
        } else {
            var _color = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(background, theme);
            if (_color) result = (0, $11317b0e49e0d157$export$76249e090d1c76db)(_color);
        }
    }
    return result;
};
var $0b4a347e23c22183$var$darkContext = function darkContext(backgroundColor) {
    var isDark = (0, $11317b0e49e0d157$export$76249e090d1c76db)(backgroundColor);
    if (isDark === undefined) return undefined;
    return isDark ? 'dark' : 'light';
};
var $0b4a347e23c22183$export$51f19bd17c18b682 = function backgroundAndTextColors(backgroundArg, textArg, theme) {
    if (!backgroundArg) return [
        undefined,
        textArg
    ];
    var global = theme.global;
    var background = $0b4a347e23c22183$export$7b802385d70a5af9(backgroundArg, theme);
    var text = textArg || global.colors.text;
    var backgroundColor;
    var textColor;
    if (typeof background === 'object') {
        if (background.dark === false) textColor = text.light || text;
        else if (background.dark) textColor = text.dark || text;
        if (background.color) {
            var color = $0b4a347e23c22183$var$normalizeBackgroundColor(background, theme);
            var opacity = background.opacity === true ? global.opacity.medium : global.opacity[background.opacity] || background.opacity;
            backgroundColor = (0, $11317b0e49e0d157$export$c24a0a5c5129b2e1)(color, opacity) || color;
            // If we don't have a textColor already, and we aren't too translucent,
            // set the textColor to have the best contrast against the background
            // color.
            if (!textColor && (opacity === undefined || opacity > 0.3)) {
                var shade = $0b4a347e23c22183$var$darkContext(backgroundColor, theme);
                textColor = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(shade && text[shade] || text, theme);
            }
        }
    } else {
        backgroundColor = $0b4a347e23c22183$var$normalizeBackgroundColor(background, theme);
        var _shade = $0b4a347e23c22183$var$darkContext(backgroundColor, theme);
        var transparent;
        if (backgroundColor && (0, $11317b0e49e0d157$export$6d62a0650580a0ff)(backgroundColor)) {
            var colorArray = (0, $11317b0e49e0d157$export$5bcd173cc9a0dca)(backgroundColor);
            // check if the alpha value is less than 0.5
            if (colorArray[3] < 0.5) transparent = true;
        }
        if (_shade) textColor = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(text[_shade] || text, theme, _shade === 'dark');
        else if (transparent && text) textColor = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(text, theme);
        else {
            // If we can't determine the shade, we assume this isn't a simple color.
            // It could be a gradient. backgroundStyle() will take care of that case.
            if (backgroundColor !== 'transparent') backgroundColor = undefined;
            if (text) textColor = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(text, theme);
        }
    }
    // if textArg is false, we don't want the textColor, used for Button hover
    if (textArg === false) textColor = undefined;
    return [
        backgroundColor,
        textColor
    ];
};
var $0b4a347e23c22183$export$e43a4f0de05cb7e9 = function backgroundStyle(backgroundArg, theme, textColorArg) {
    // for Grommet component, if the background isn't defined, don't set it
    if (backgroundArg === undefined) return undefined;
    var background = $0b4a347e23c22183$export$7b802385d70a5af9(backgroundArg, theme);
    var _backgroundAndTextCol = $0b4a347e23c22183$export$51f19bd17c18b682(background, textColorArg, theme), backgroundColor = _backgroundAndTextCol[0], textColor = _backgroundAndTextCol[1];
    var backgroundImage = background.rotate ? $0b4a347e23c22183$var$rotateBackground(background, theme) : $0b4a347e23c22183$var$_normalizeBackgroundImage(background, theme);
    var backgroundClipStyle = '';
    if (background.clip) backgroundClipStyle = background.clip === 'text' ? "-webkit-text-fill-color: transparent; \n           -webkit-background-clip: text; \n           background-clip: text;" : "background-clip: " + background.clip + ";";
    if (typeof background === 'string' && background.lastIndexOf('url', 0) === 0) return (0, $iA1nz.css)([
        "background:",
        " no-repeat center center;background-size:cover;"
    ], background);
    if (backgroundImage) {
        var backgroundStyles = "\n      " + (backgroundColor ? "background-color: " + backgroundColor + ";" : '') + "\n      background-image: " + backgroundImage + ";\n      background-repeat: " + (typeof background === 'object' && background.repeat || 'no-repeat') + ";\n      background-position: " + (background.position || 'center center') + ";\n      background-size: " + (background.size || 'cover') + ";\n      " + backgroundClipStyle + "\n    ";
        // allow both background color and image, in case the image doesn't fill
        // when image and opacity are used together, we need to use pseudo :before
        // to ensure that only image and background color are affected by opacity
        // but not the container contents
        return (0, $iA1nz.css)([
            "",
            " ",
            ""
        ], textColor ? "color: " + textColor + ";" : '', !background.opacity ? backgroundStyles : "position: relative;\n        z-index: 0;\n        &:before {\n          content: '';\n          position: absolute;\n          top: 0;\n          right: 0;\n          left: 0;\n          bottom: 0;\n          z-index: -1;\n          border-radius: inherit;\n          " + backgroundStyles + "\n          opacity: " + (background.opacity === true ? theme.global.opacity.medium : theme.global.opacity[background.opacity] || background.opacity) + ";\n        }");
    }
    if (backgroundColor) return (0, $iA1nz.css)([
        "background-color:",
        ";",
        ""
    ], backgroundColor, textColor ? "color: " + textColor + ";" : '');
    if (typeof background === 'string') // This case takes care of gradients
    // or theme colors that use CSS names like 'crimson' that we don't parse
    return (0, $iA1nz.css)([
        "background:",
        ";"
    ], (0, $11317b0e49e0d157$export$4cde5df63f53f473)(background, theme));
    return undefined;
};
var $0b4a347e23c22183$export$d51670144e8c59cf = (0, $iA1nz.css)([
    "",
    ""
], function(props) {
    return $0b4a347e23c22183$export$e43a4f0de05cb7e9((0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.theme.global.active.background, props.theme), props.theme, props.theme.global.active.color);
});
var $0b4a347e23c22183$export$a7abb1b3dc25813f = (0, $iA1nz.css)([
    "",
    ""
], function(props) {
    return $0b4a347e23c22183$export$e43a4f0de05cb7e9((0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.theme.global.selected.background, props.theme), props.theme, props.theme.global.selected.color);
});
var $0b4a347e23c22183$export$172ca055ee2bcc62 = function getHoverIndicatorStyle(hoverIndicator, theme) {
    var background;
    var elevation;
    if (hoverIndicator === true || hoverIndicator === 'background') background = theme.global.hover.background;
    else if (typeof hoverIndicator === 'object') {
        if (hoverIndicator.elevation || hoverIndicator.background) {
            elevation = hoverIndicator.elevation;
            background = hoverIndicator.background;
        } else background = hoverIndicator;
    } else background = hoverIndicator;
    return (0, $iA1nz.css)([
        "",
        " ",
        ""
    ], $0b4a347e23c22183$export$e43a4f0de05cb7e9(background, theme, theme.global.hover.color), elevation && "box-shadow: " + theme.global.elevation[theme.dark ? 'dark' : 'light'][elevation] + ";");
};


var $iA1nz = parcelRequire("iA1nz");
var $5b8209df25a8ed95$export$1eb095b00b926404 = function getBreakpoint(viewportWidth, theme) {
    var sortedBreakpoints = Object.keys(theme.global.breakpoints).sort(function(a, b) {
        var first = theme.global.breakpoints[a];
        var second = theme.global.breakpoints[b];
        if (!first) return 1;
        if (!second) return -1;
        if (!first.value) return 1;
        if (!second.value) return -1;
        return first.value - second.value;
    });
    // the last breakpoint on the sorted array should have
    // no windowWidth boundaries
    var lastBreakpoint = sortedBreakpoints[sortedBreakpoints.length - 1];
    var result = sortedBreakpoints.find(function(name) {
        var breakpoint = theme.global.breakpoints[name];
        return !breakpoint.value || breakpoint.value >= viewportWidth ? name : false;
    });
    return result || lastBreakpoint;
};
var $5b8209df25a8ed95$export$4244a62ea87934e9 = function getDeviceBreakpoint(type, theme) {
    return theme.global.deviceBreakpoints[type];
};
var $5b8209df25a8ed95$export$56780e7bbaff61f9 = function getBreakpointStyle(theme, breakpointSize) {
    var breakpoint = breakpointSize && theme.global.breakpoints[breakpointSize] || {};
    if (!breakpoint.edgeSize) breakpoint.edgeSize = theme.global.edgeSize;
    if (!breakpoint.borderSize) breakpoint.borderSize = theme.global.borderSize;
    if (!breakpoint.radius) breakpoint.radius = theme.global.radius;
    if (!breakpoint.size) breakpoint.size = theme.global.size;
    return breakpoint;
};
var $5b8209df25a8ed95$export$813595e92b2e7a6f = function isSmall(size) {
    return [
        'xsmall',
        'small'
    ].includes(size);
};
var $5b8209df25a8ed95$export$f207ad4bd0549009 = function deviceResponsive(userAgent, theme) {
    // log('--deviceResponsive', userAgent, theme);
    /*
   * Regexes provided for mobile and tablet detection are meant to replace
   * a full-featured specific library due to contributing a considerable size
   * into the bundle.
   *
   * User agents found https://deviceatlas.com/blog/list-of-user-agent-strings
   */ if (userAgent) {
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobile))/i.test(userAgent)) return $5b8209df25a8ed95$export$4244a62ea87934e9('tablet', theme);
        if (/Mobile|iPhone|Android/.test(userAgent)) return $5b8209df25a8ed95$export$4244a62ea87934e9('phone', theme);
        return $5b8209df25a8ed95$export$4244a62ea87934e9('computer', theme);
    }
    return undefined;
};
// styled-components v6 and later do not have a withComponent
// method. We need v6 or later to support container queries.
var $5b8209df25a8ed95$var$testComp = (0, $iA1nz.default).div.withConfig({
    displayName: "responsive__testComp",
    componentId: "sc-336m7y-0"
})([
    "display:flex;"
]);
var $5b8209df25a8ed95$export$6fa2a3092624a8f5 = function supportsContainerQueries() {
    var isPreV6 = typeof $5b8209df25a8ed95$var$testComp.withComponent === 'function';
    return !isPreV6;
};


var $2xPiy = parcelRequire("2xPiy");
var $3cecef11d3b9c451$export$61dc559f8a0b9bcf = function useForwardedRef(ref) {
    var innerRef = (0, $2xPiy.useRef)(null);
    (0, $2xPiy.useImperativeHandle)(ref, function() {
        return innerRef.current;
    }, [
        innerRef
    ]);
    return innerRef;
};


var $1de8541bdd93d251$exports = {};

$parcel$export($1de8541bdd93d251$exports, "__esModule", function () { return $1de8541bdd93d251$export$1e511d4a378977f5; }, function (v) { return $1de8541bdd93d251$export$1e511d4a378977f5 = v; });
$parcel$export($1de8541bdd93d251$exports, "Actions", function () { return $1de8541bdd93d251$export$b52183d5cfb26dc9; }, function (v) { return $1de8541bdd93d251$export$b52183d5cfb26dc9 = v; });
var $1de8541bdd93d251$export$1e511d4a378977f5;
var $1de8541bdd93d251$export$b52183d5cfb26dc9;
"use strict";
$1de8541bdd93d251$export$1e511d4a378977f5 = true;
$1de8541bdd93d251$export$b52183d5cfb26dc9 = void 0;

var $1de8541bdd93d251$var$_react = $1de8541bdd93d251$var$_interopRequireWildcard((parcelRequire("2xPiy")));
var $0a9c4ff31cc3584b$export$1e511d4a378977f5;
var $0a9c4ff31cc3584b$export$7c8f159da0dc916;
"use strict";
$0a9c4ff31cc3584b$export$1e511d4a378977f5 = true;
$0a9c4ff31cc3584b$export$7c8f159da0dc916 = void 0;

var $0a9c4ff31cc3584b$var$_react = $0a9c4ff31cc3584b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $0a9c4ff31cc3584b$var$_styledComponents = $0a9c4ff31cc3584b$var$_interopRequireWildcard((parcelRequire("iA1nz")));
var $0bc2fbca34350308$export$1e511d4a378977f5;
var $0bc2fbca34350308$export$582fa4e2a9b13dde;
var $0bc2fbca34350308$export$9c21a3269931e1e6;
"use strict";
$0bc2fbca34350308$export$1e511d4a378977f5 = true;
$0bc2fbca34350308$export$582fa4e2a9b13dde = $0bc2fbca34350308$export$9c21a3269931e1e6 = void 0;
var $1b754218be0a6592$export$1e511d4a378977f5;
var $1b754218be0a6592$export$6969335ea1e4e77c;
var $1b754218be0a6592$export$3794798abb123ff6;
var $1b754218be0a6592$export$2e2bcd8739ae039;
var $1b754218be0a6592$export$bce3b4bc0d2e7a0e;
var $1b754218be0a6592$export$a6cdc56e425d0d0a;
var $1b754218be0a6592$export$333c2219d71d27ce;
var $1b754218be0a6592$export$56a2e46cd4a7c217;
"use strict";
$1b754218be0a6592$export$1e511d4a378977f5 = true;
$1b754218be0a6592$export$6969335ea1e4e77c = $1b754218be0a6592$var$deepMerge;
$1b754218be0a6592$export$3794798abb123ff6 = $1b754218be0a6592$export$2e2bcd8739ae039 = void 0;
$1b754218be0a6592$export$bce3b4bc0d2e7a0e = $1b754218be0a6592$var$iconPad;
$1b754218be0a6592$export$a6cdc56e425d0d0a = $1b754218be0a6592$var$isObject;
$1b754218be0a6592$export$333c2219d71d27ce = void 0;
$1b754218be0a6592$export$56a2e46cd4a7c217 = $1b754218be0a6592$var$useScaleProps;

var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");
function $1b754218be0a6592$var$_extends() {
    return $1b754218be0a6592$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1b754218be0a6592$var$_extends.apply(null, arguments);
}
function $1b754218be0a6592$var$isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}
function $1b754218be0a6592$var$deepMerge(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    // making sure to not change target (immutable)
    var output = $1b754218be0a6592$var$_extends({}, target);
    sources.forEach(function(source) {
        if ($1b754218be0a6592$var$isObject(source)) Object.keys(source).forEach(function(key) {
            if ($1b754218be0a6592$var$isObject(source[key])) {
                if (!output[key]) output[key] = $1b754218be0a6592$var$_extends({}, source[key]);
                else output[key] = $1b754218be0a6592$var$deepMerge(output[key], source[key]);
            } else output[key] = source[key];
        });
    });
    return output;
}
var $1b754218be0a6592$var$parseMetricToNum = $1b754218be0a6592$export$333c2219d71d27ce = function parseMetricToNum(string) {
    if (string === void 0) string = '';
    return parseFloat(string.match(/\d+(\.\d+)?/), 10);
};
// scaleProps sets path properties to prevent scaling the stroke
// when the theme doesn't want it for small sizes.
function $1b754218be0a6592$var$useScaleProps(props) {
    var _theme$icon;
    var theme = (0, $2xPiy.useContext)($iA1nz.ThemeContext);
    var size = props.size;
    var result = {};
    if (theme != null && (_theme$icon = theme.icon) != null && _theme$icon.disableScaleDown) {
        var dimension = $1b754218be0a6592$var$parseMetricToNum(theme.icon.size[size] || size);
        if (dimension < 24) result.vectorEffect = 'non-scaling-stroke';
    }
    return result;
}
var $1b754218be0a6592$var$calculatePad = function calculatePad(value, iconDimension) {
    return (value - iconDimension) / 2 + "px";
};
// iconPad applies padding to icon to ensure it aligns
// with text line-height or desired width
function $1b754218be0a6592$var$iconPad(props) {
    var _theme$icon2, _theme$text, _theme$text2;
    var height = props.height, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, width = props.width;
    var theme = (0, $2xPiy.useContext)($iA1nz.ThemeContext);
    var iconDimension = $1b754218be0a6592$var$parseMetricToNum((theme == null || (_theme$icon2 = theme.icon) == null || (_theme$icon2 = _theme$icon2.size) == null ? void 0 : _theme$icon2[size]) || size);
    var style = '';
    // browser default is 16px, but accommodate if app has modified
    // include fallback in case window is undefined
    var FALLBACK = '16px';
    var rootFontSize = $1b754218be0a6592$var$parseMetricToNum(FALLBACK);
    if (typeof window !== 'undefined') {
        var _window;
        rootFontSize = $1b754218be0a6592$var$parseMetricToNum(((_window = window) == null ? void 0 : _window.getComputedStyle(document.body).getPropertyValue('font-size')) || FALLBACK);
    }
    if (height && theme != null && (_theme$text = theme.text) != null && (_theme$text = _theme$text[height]) != null && _theme$text.height) {
        // the unit on theme text
        var _theme$text$height$he = theme.text[height].height.match(/(px|rem)/), unit = _theme$text$height$he[0];
        var lineHeight = $1b754218be0a6592$var$parseMetricToNum(theme.text[height].height);
        if (unit === 'rem') lineHeight *= rootFontSize;
        if (lineHeight > iconDimension) {
            var pad = $1b754218be0a6592$var$calculatePad(lineHeight, iconDimension);
            style += "padding-top: " + pad + "; padding-bottom: " + pad + ";";
        }
    }
    if (width && theme != null && (_theme$text2 = theme.text) != null && (_theme$text2 = _theme$text2[width]) != null && _theme$text2.height) {
        // the unit on theme text
        var _theme$text$width$hei = theme.text[width].height.match(/(px|rem)/), _unit = _theme$text$width$hei[0];
        var desiredWidth = $1b754218be0a6592$var$parseMetricToNum(theme.text[width].height);
        if (_unit === 'rem') desiredWidth *= rootFontSize;
        if (desiredWidth > iconDimension) {
            var _pad = $1b754218be0a6592$var$calculatePad(desiredWidth, iconDimension);
            style += "padding-left: " + _pad + "; padding-right: " + _pad + ";";
        }
    }
    return style;
}
// ensure icons that rely on urls don't have id collision
// Date.now + Math.random is unique enough for icon use cases
var $1b754218be0a6592$var$generatePrefix = $1b754218be0a6592$export$3794798abb123ff6 = function generatePrefix(name) {
    return "_grommeticons-" + name + "-" + (Date.now() + Math.random());
};
var $1b754218be0a6592$var$_default = $1b754218be0a6592$export$2e2bcd8739ae039 = {
    deepMerge: $1b754218be0a6592$var$deepMerge,
    isObject: $1b754218be0a6592$var$isObject,
    parseMetricToNum: $1b754218be0a6592$var$parseMetricToNum,
    iconPad: $1b754218be0a6592$var$iconPad,
    useScaleProps: $1b754218be0a6592$var$useScaleProps
};


var $ea0760afe108d996$export$1e511d4a378977f5;
var $ea0760afe108d996$export$e2253033e6e1df16;
"use strict";
$ea0760afe108d996$export$1e511d4a378977f5 = true;
$ea0760afe108d996$export$e2253033e6e1df16 = void 0;
var $07da00c9c00f6352$export$1e511d4a378977f5;
var $07da00c9c00f6352$export$e2253033e6e1df16;
"use strict";
$07da00c9c00f6352$export$1e511d4a378977f5 = true;
$07da00c9c00f6352$export$e2253033e6e1df16 = void 0;
var $07da00c9c00f6352$var$base = $07da00c9c00f6352$export$e2253033e6e1df16 = {
    global: {
        colors: {
            icon: '#666666'
        }
    },
    icon: {
        size: {
            small: '12px',
            medium: '24px',
            large: '48px',
            xlarge: '96px'
        }
    }
};


$ea0760afe108d996$export$e2253033e6e1df16 = $07da00c9c00f6352$export$e2253033e6e1df16;


var $0bc2fbca34350308$var$defaultProps = $0bc2fbca34350308$export$9c21a3269931e1e6 = {
    theme: $ea0760afe108d996$export$e2253033e6e1df16
};
var $0bc2fbca34350308$var$extendDefaultTheme = $0bc2fbca34350308$export$582fa4e2a9b13dde = function extendDefaultTheme(theme) {
    $0bc2fbca34350308$var$defaultProps.theme = (0, $1b754218be0a6592$export$6969335ea1e4e77c)($ea0760afe108d996$export$e2253033e6e1df16, theme);
};



var $0a9c4ff31cc3584b$var$_excluded = [
    "a11yTitle",
    "color",
    "size",
    "theme"
];
function $0a9c4ff31cc3584b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0a9c4ff31cc3584b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0a9c4ff31cc3584b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0a9c4ff31cc3584b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0a9c4ff31cc3584b$var$_extends() {
    return $0a9c4ff31cc3584b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0a9c4ff31cc3584b$var$_extends.apply(null, arguments);
}
function $0a9c4ff31cc3584b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Returns the specific color that should be used according to the theme.
// If 'dark' is supplied, it takes precedence over 'theme.dark'.
// Can return undefined.
var $0a9c4ff31cc3584b$var$normalizeColor = function normalizeColor(color, theme, dark) {
    var colorSpec = theme.global && theme.global.colors[color] !== undefined ? theme.global.colors[color] : color;
    // If the color has a light or dark object, use that
    var result = colorSpec;
    if (colorSpec) {
        if ((dark === true || dark === undefined && theme.dark) && colorSpec.dark !== undefined) result = colorSpec.dark;
        else if ((dark === false || !theme.dark) && colorSpec.light !== undefined) result = colorSpec.light;
    }
    // allow one level of indirection in color names
    if (result && theme.global && theme.global.colors[result] !== undefined) result = normalizeColor(result, theme, dark);
    return result;
};
var $0a9c4ff31cc3584b$var$colorStyle = function colorStyle(name, value, theme, required) {
    return (0, $0a9c4ff31cc3584b$var$_styledComponents.css)([
        "",
        ":",
        ";"
    ], name, $0a9c4ff31cc3584b$var$normalizeColor(value, theme, required));
};
var $0a9c4ff31cc3584b$var$colorCss = (0, $0a9c4ff31cc3584b$var$_styledComponents.css)([
    "",
    " ",
    " g{fill:inherit;stroke:inherit;}*:not([stroke]){&[fill='none']{stroke-width:0;}}*[stroke*='#'],*[STROKE*='#']{stroke:inherit;fill:none;}*[fill-rule],*[FILL-RULE],*[fill*='#'],*[FILL*='#']{fill:inherit;stroke:none;}"
], function(props) {
    return $0a9c4ff31cc3584b$var$colorStyle('fill', props.color || props.theme.global.colors.icon, props.theme);
}, function(props) {
    return $0a9c4ff31cc3584b$var$colorStyle('stroke', props.color || props.theme.global.colors.icon, props.theme);
});
var $0a9c4ff31cc3584b$var$IconInner = /*#__PURE__*/ (0, $0a9c4ff31cc3584b$var$_react.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, color = _ref.color, size = _ref.size, theme = _ref.theme, rest = $0a9c4ff31cc3584b$var$_objectWithoutPropertiesLoose(_ref, $0a9c4ff31cc3584b$var$_excluded);
    return /*#__PURE__*/ $0a9c4ff31cc3584b$var$_react["default"].createElement("svg", $0a9c4ff31cc3584b$var$_extends({
        ref: ref,
        "aria-label": a11yTitle
    }, rest));
});
$0a9c4ff31cc3584b$var$IconInner.displayName = 'Icon';
var $0a9c4ff31cc3584b$var$StyledIcon = $0a9c4ff31cc3584b$export$7c8f159da0dc916 = (0, $0a9c4ff31cc3584b$var$_styledComponents["default"])($0a9c4ff31cc3584b$var$IconInner).withConfig({
    // don't let height attribute leak to DOM
    // https://styled-components.com/docs/api#shouldforwardprop
    shouldForwardProp: function shouldForwardProp(prop) {
        return ![
            'height',
            'width'
        ].includes(prop);
    }
}).withConfig({
    displayName: "StyledIcon",
    componentId: "sc-ofa7kd-0"
})([
    "display:inline-block;flex:0 0 auto;",
    " ",
    " ",
    " ",
    ""
], function(_ref2) {
    var _size$match;
    var _ref2$size = _ref2.size, sizeProp = _ref2$size === void 0 ? 'medium' : _ref2$size, theme = _ref2.theme, viewBox = _ref2.viewBox;
    var _split = (viewBox || '0 0 24 24').split(' '), w = _split[2], h = _split[3];
    var scale = w / h;
    var size = theme.icon.size[sizeProp] || sizeProp;
    var dimension = (0, $1b754218be0a6592$export$333c2219d71d27ce)(size);
    // grab rem, em, px value from resolved size value
    var unit = ((_size$match = size.match(/[a-z]+$/)) == null ? void 0 : _size$match[0]) || 'px';
    if (w < h) return "\n      width: " + dimension + unit + ";\n      height: " + dimension / scale + unit + ";\n    ";
    if (h < w) return "\n      width: " + dimension * scale + unit + ";\n      height: " + dimension + unit + ";\n    ";
    return "\n      width: " + dimension + unit + ";\n      height: " + dimension + unit + ";\n    ";
}, function(_ref3) {
    var color = _ref3.color;
    return color !== 'plain' && $0a9c4ff31cc3584b$var$colorCss;
}, function(props) {
    return (props.height || props.width) && (0, $1b754218be0a6592$export$bce3b4bc0d2e7a0e)(props);
}, function(_ref4) {
    var theme = _ref4.theme;
    return theme && theme.icon.extend;
});
$0a9c4ff31cc3584b$var$StyledIcon.defaultProps = {};
Object.setPrototypeOf($0a9c4ff31cc3584b$var$StyledIcon.defaultProps, $0bc2fbca34350308$export$9c21a3269931e1e6);


function $1de8541bdd93d251$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1de8541bdd93d251$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1de8541bdd93d251$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $1de8541bdd93d251$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1de8541bdd93d251$var$_extends() {
    return $1de8541bdd93d251$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1de8541bdd93d251$var$_extends.apply(null, arguments);
}
var $1de8541bdd93d251$var$Actions = $1de8541bdd93d251$export$b52183d5cfb26dc9 = /*#__PURE__*/ (0, $1de8541bdd93d251$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $1de8541bdd93d251$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $1de8541bdd93d251$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Actions"
    }, props), /*#__PURE__*/ $1de8541bdd93d251$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 17.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zm0-11V1m0 22v-5.5M1 12h5.5m11 0H23M4.437 4.437l4.125 4.125m6.876 6.876 4.124 4.124m0-15.125-4.125 4.125m-6.874 6.876-4.126 4.124"
    }));
});
$1de8541bdd93d251$var$Actions.displayName = 'Actions';


var $2504912870405b96$exports = {};

$parcel$export($2504912870405b96$exports, "__esModule", function () { return $2504912870405b96$export$1e511d4a378977f5; }, function (v) { return $2504912870405b96$export$1e511d4a378977f5 = v; });
$parcel$export($2504912870405b96$exports, "AssistListening", function () { return $2504912870405b96$export$c92b43e49fa6c65b; }, function (v) { return $2504912870405b96$export$c92b43e49fa6c65b = v; });
var $2504912870405b96$export$1e511d4a378977f5;
var $2504912870405b96$export$c92b43e49fa6c65b;
"use strict";
$2504912870405b96$export$1e511d4a378977f5 = true;
$2504912870405b96$export$c92b43e49fa6c65b = void 0;

var $2504912870405b96$var$_react = $2504912870405b96$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $2504912870405b96$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2504912870405b96$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2504912870405b96$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $2504912870405b96$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $2504912870405b96$var$_extends() {
    return $2504912870405b96$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2504912870405b96$var$_extends.apply(null, arguments);
}
var $2504912870405b96$var$AssistListening = $2504912870405b96$export$c92b43e49fa6c65b = /*#__PURE__*/ (0, $2504912870405b96$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $2504912870405b96$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $2504912870405b96$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "AssistListening"
    }, props), /*#__PURE__*/ $2504912870405b96$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M11 21c.757.667 1.424 1 2 1 2 0 3-1 3-3 0-1.333.667-2.667 2-4 1.267-1.267 2-3.067 2-5a7 7 0 0 0-14 0m11 0a4 4 0 1 0-8 0M3 20l5-6 1 4 5-6"
    }));
});
$2504912870405b96$var$AssistListening.displayName = 'AssistListening';


var $8943ffd4a7fe1a81$exports = {};

$parcel$export($8943ffd4a7fe1a81$exports, "__esModule", function () { return $8943ffd4a7fe1a81$export$1e511d4a378977f5; }, function (v) { return $8943ffd4a7fe1a81$export$1e511d4a378977f5 = v; });
$parcel$export($8943ffd4a7fe1a81$exports, "CircleInformation", function () { return $8943ffd4a7fe1a81$export$7036cd8426a1245b; }, function (v) { return $8943ffd4a7fe1a81$export$7036cd8426a1245b = v; });
var $8943ffd4a7fe1a81$export$1e511d4a378977f5;
var $8943ffd4a7fe1a81$export$7036cd8426a1245b;
"use strict";
$8943ffd4a7fe1a81$export$1e511d4a378977f5 = true;
$8943ffd4a7fe1a81$export$7036cd8426a1245b = void 0;

var $8943ffd4a7fe1a81$var$_react = $8943ffd4a7fe1a81$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $8943ffd4a7fe1a81$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8943ffd4a7fe1a81$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8943ffd4a7fe1a81$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $8943ffd4a7fe1a81$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8943ffd4a7fe1a81$var$_extends() {
    return $8943ffd4a7fe1a81$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8943ffd4a7fe1a81$var$_extends.apply(null, arguments);
}
var $8943ffd4a7fe1a81$var$CircleInformation = $8943ffd4a7fe1a81$export$7036cd8426a1245b = /*#__PURE__*/ (0, $8943ffd4a7fe1a81$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $8943ffd4a7fe1a81$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $8943ffd4a7fe1a81$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CircleInformation"
    }, props), /*#__PURE__*/ $8943ffd4a7fe1a81$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-12v8m0-12v2"
    }));
});
$8943ffd4a7fe1a81$var$CircleInformation.displayName = 'CircleInformation';


var $173838d506ca9170$exports = {};

$parcel$export($173838d506ca9170$exports, "__esModule", function () { return $173838d506ca9170$export$1e511d4a378977f5; }, function (v) { return $173838d506ca9170$export$1e511d4a378977f5 = v; });
$parcel$export($173838d506ca9170$exports, "ClosedCaption", function () { return $173838d506ca9170$export$237eddafb41f13f6; }, function (v) { return $173838d506ca9170$export$237eddafb41f13f6 = v; });
var $173838d506ca9170$export$1e511d4a378977f5;
var $173838d506ca9170$export$237eddafb41f13f6;
"use strict";
$173838d506ca9170$export$1e511d4a378977f5 = true;
$173838d506ca9170$export$237eddafb41f13f6 = void 0;

var $173838d506ca9170$var$_react = $173838d506ca9170$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $173838d506ca9170$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($173838d506ca9170$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $173838d506ca9170$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $173838d506ca9170$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $173838d506ca9170$var$_extends() {
    return $173838d506ca9170$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $173838d506ca9170$var$_extends.apply(null, arguments);
}
var $173838d506ca9170$var$ClosedCaption = $173838d506ca9170$export$237eddafb41f13f6 = /*#__PURE__*/ (0, $173838d506ca9170$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $173838d506ca9170$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $173838d506ca9170$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ClosedCaption"
    }, props), /*#__PURE__*/ $173838d506ca9170$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 12c0-7 1.5-8 11-8s11 1 11 8-1.5 8-11 8-11-1-11-8zm4.25 2c0 1.5.75 2 2.5 2s2.5-.5 2.5-2h-.271c0 1.25-1 2-2.229 2-1.23 0-2.229-.75-2.229-2v-4C5.5 8.75 6.5 8 7.75 8s2.25.75 2.229 2h.271c0-1.25-1.021-2-2.5-2s-2.5.75-2.5 2v4zm8 0c0 1.5.75 2 2.5 2s2.5-.5 2.5-2h-.271c0 1.25-1 2-2.229 2-1.23 0-2.229-.75-2.229-2v-4c-.021-1.25.979-2 2.229-2s2.25.75 2.229 2h.271c0-1.25-1.021-2-2.5-2s-2.5.75-2.5 2v4z"
    }));
});
$173838d506ca9170$var$ClosedCaption.displayName = 'ClosedCaption';


var $210911c17625cb22$exports = {};

$parcel$export($210911c17625cb22$exports, "__esModule", function () { return $210911c17625cb22$export$1e511d4a378977f5; }, function (v) { return $210911c17625cb22$export$1e511d4a378977f5 = v; });
$parcel$export($210911c17625cb22$exports, "Expand", function () { return $210911c17625cb22$export$49bd1dfb0ad29c40; }, function (v) { return $210911c17625cb22$export$49bd1dfb0ad29c40 = v; });
var $210911c17625cb22$export$1e511d4a378977f5;
var $210911c17625cb22$export$49bd1dfb0ad29c40;
"use strict";
$210911c17625cb22$export$1e511d4a378977f5 = true;
$210911c17625cb22$export$49bd1dfb0ad29c40 = void 0;

var $210911c17625cb22$var$_react = $210911c17625cb22$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $210911c17625cb22$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($210911c17625cb22$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $210911c17625cb22$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $210911c17625cb22$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $210911c17625cb22$var$_extends() {
    return $210911c17625cb22$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $210911c17625cb22$var$_extends.apply(null, arguments);
}
var $210911c17625cb22$var$Expand = $210911c17625cb22$export$49bd1dfb0ad29c40 = /*#__PURE__*/ (0, $210911c17625cb22$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $210911c17625cb22$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $210911c17625cb22$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Expand"
    }, props), /*#__PURE__*/ $210911c17625cb22$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m10 14-8 8m-1-7v8h8M22 2l-8 8m1-9h8v8"
    }));
});
$210911c17625cb22$var$Expand.displayName = 'Expand';


var $7aaaa7abc2375846$exports = {};

$parcel$export($7aaaa7abc2375846$exports, "__esModule", function () { return $7aaaa7abc2375846$export$1e511d4a378977f5; }, function (v) { return $7aaaa7abc2375846$export$1e511d4a378977f5 = v; });
$parcel$export($7aaaa7abc2375846$exports, "FormCheckmark", function () { return $7aaaa7abc2375846$export$dec84e69d20720b4; }, function (v) { return $7aaaa7abc2375846$export$dec84e69d20720b4 = v; });
var $7aaaa7abc2375846$export$1e511d4a378977f5;
var $7aaaa7abc2375846$export$dec84e69d20720b4;
"use strict";
$7aaaa7abc2375846$export$1e511d4a378977f5 = true;
$7aaaa7abc2375846$export$dec84e69d20720b4 = void 0;

var $7aaaa7abc2375846$var$_react = $7aaaa7abc2375846$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $7aaaa7abc2375846$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7aaaa7abc2375846$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7aaaa7abc2375846$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $7aaaa7abc2375846$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7aaaa7abc2375846$var$_extends() {
    return $7aaaa7abc2375846$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7aaaa7abc2375846$var$_extends.apply(null, arguments);
}
var $7aaaa7abc2375846$var$FormCheckmark = $7aaaa7abc2375846$export$dec84e69d20720b4 = /*#__PURE__*/ (0, $7aaaa7abc2375846$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $7aaaa7abc2375846$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $7aaaa7abc2375846$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormCheckmark"
    }, props), /*#__PURE__*/ $7aaaa7abc2375846$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m6 13 4.2 3.6L18 7"
    }));
});
$7aaaa7abc2375846$var$FormCheckmark.displayName = 'FormCheckmark';


var $da76b8daacd39c4f$exports = {};

$parcel$export($da76b8daacd39c4f$exports, "__esModule", function () { return $da76b8daacd39c4f$export$1e511d4a378977f5; }, function (v) { return $da76b8daacd39c4f$export$1e511d4a378977f5 = v; });
$parcel$export($da76b8daacd39c4f$exports, "FormClose", function () { return $da76b8daacd39c4f$export$fe20cfcdd41aa0ef; }, function (v) { return $da76b8daacd39c4f$export$fe20cfcdd41aa0ef = v; });
var $da76b8daacd39c4f$export$1e511d4a378977f5;
var $da76b8daacd39c4f$export$fe20cfcdd41aa0ef;
"use strict";
$da76b8daacd39c4f$export$1e511d4a378977f5 = true;
$da76b8daacd39c4f$export$fe20cfcdd41aa0ef = void 0;

var $da76b8daacd39c4f$var$_react = $da76b8daacd39c4f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $da76b8daacd39c4f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($da76b8daacd39c4f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $da76b8daacd39c4f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $da76b8daacd39c4f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $da76b8daacd39c4f$var$_extends() {
    return $da76b8daacd39c4f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $da76b8daacd39c4f$var$_extends.apply(null, arguments);
}
var $da76b8daacd39c4f$var$FormClose = $da76b8daacd39c4f$export$fe20cfcdd41aa0ef = /*#__PURE__*/ (0, $da76b8daacd39c4f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $da76b8daacd39c4f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $da76b8daacd39c4f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormClose"
    }, props), /*#__PURE__*/ $da76b8daacd39c4f$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m7 7 10 10M7 17 17 7"
    }));
});
$da76b8daacd39c4f$var$FormClose.displayName = 'FormClose';


var $08156255a6733056$exports = {};

$parcel$export($08156255a6733056$exports, "__esModule", function () { return $08156255a6733056$export$1e511d4a378977f5; }, function (v) { return $08156255a6733056$export$1e511d4a378977f5 = v; });
$parcel$export($08156255a6733056$exports, "FormDown", function () { return $08156255a6733056$export$cd1a8f5a55d5e9d3; }, function (v) { return $08156255a6733056$export$cd1a8f5a55d5e9d3 = v; });
var $08156255a6733056$export$1e511d4a378977f5;
var $08156255a6733056$export$cd1a8f5a55d5e9d3;
"use strict";
$08156255a6733056$export$1e511d4a378977f5 = true;
$08156255a6733056$export$cd1a8f5a55d5e9d3 = void 0;

var $08156255a6733056$var$_react = $08156255a6733056$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $08156255a6733056$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($08156255a6733056$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $08156255a6733056$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $08156255a6733056$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $08156255a6733056$var$_extends() {
    return $08156255a6733056$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $08156255a6733056$var$_extends.apply(null, arguments);
}
var $08156255a6733056$var$FormDown = $08156255a6733056$export$cd1a8f5a55d5e9d3 = /*#__PURE__*/ (0, $08156255a6733056$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $08156255a6733056$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $08156255a6733056$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormDown"
    }, props), /*#__PURE__*/ $08156255a6733056$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m18 9-6 6-6-6"
    }));
});
$08156255a6733056$var$FormDown.displayName = 'FormDown';


var $0736b9499c5aa664$exports = {};

$parcel$export($0736b9499c5aa664$exports, "__esModule", function () { return $0736b9499c5aa664$export$1e511d4a378977f5; }, function (v) { return $0736b9499c5aa664$export$1e511d4a378977f5 = v; });
$parcel$export($0736b9499c5aa664$exports, "FormNext", function () { return $0736b9499c5aa664$export$a8d2f61b02c7b95f; }, function (v) { return $0736b9499c5aa664$export$a8d2f61b02c7b95f = v; });
var $0736b9499c5aa664$export$1e511d4a378977f5;
var $0736b9499c5aa664$export$a8d2f61b02c7b95f;
"use strict";
$0736b9499c5aa664$export$1e511d4a378977f5 = true;
$0736b9499c5aa664$export$a8d2f61b02c7b95f = void 0;

var $0736b9499c5aa664$var$_react = $0736b9499c5aa664$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0736b9499c5aa664$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0736b9499c5aa664$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0736b9499c5aa664$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0736b9499c5aa664$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0736b9499c5aa664$var$_extends() {
    return $0736b9499c5aa664$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0736b9499c5aa664$var$_extends.apply(null, arguments);
}
var $0736b9499c5aa664$var$FormNext = $0736b9499c5aa664$export$a8d2f61b02c7b95f = /*#__PURE__*/ (0, $0736b9499c5aa664$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0736b9499c5aa664$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0736b9499c5aa664$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormNext"
    }, props), /*#__PURE__*/ $0736b9499c5aa664$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m9 6 6 6-6 6"
    }));
});
$0736b9499c5aa664$var$FormNext.displayName = 'FormNext';


var $e416b67dbaf66fc1$exports = {};

$parcel$export($e416b67dbaf66fc1$exports, "__esModule", function () { return $e416b67dbaf66fc1$export$1e511d4a378977f5; }, function (v) { return $e416b67dbaf66fc1$export$1e511d4a378977f5 = v; });
$parcel$export($e416b67dbaf66fc1$exports, "FormPrevious", function () { return $e416b67dbaf66fc1$export$a14ca6bc44f029a6; }, function (v) { return $e416b67dbaf66fc1$export$a14ca6bc44f029a6 = v; });
var $e416b67dbaf66fc1$export$1e511d4a378977f5;
var $e416b67dbaf66fc1$export$a14ca6bc44f029a6;
"use strict";
$e416b67dbaf66fc1$export$1e511d4a378977f5 = true;
$e416b67dbaf66fc1$export$a14ca6bc44f029a6 = void 0;

var $e416b67dbaf66fc1$var$_react = $e416b67dbaf66fc1$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e416b67dbaf66fc1$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e416b67dbaf66fc1$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e416b67dbaf66fc1$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e416b67dbaf66fc1$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e416b67dbaf66fc1$var$_extends() {
    return $e416b67dbaf66fc1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e416b67dbaf66fc1$var$_extends.apply(null, arguments);
}
var $e416b67dbaf66fc1$var$FormPrevious = $e416b67dbaf66fc1$export$a14ca6bc44f029a6 = /*#__PURE__*/ (0, $e416b67dbaf66fc1$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e416b67dbaf66fc1$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e416b67dbaf66fc1$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormPrevious"
    }, props), /*#__PURE__*/ $e416b67dbaf66fc1$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m15 6-6 6 6 6"
    }));
});
$e416b67dbaf66fc1$var$FormPrevious.displayName = 'FormPrevious';


var $ef56e12f46c6eb58$exports = {};

$parcel$export($ef56e12f46c6eb58$exports, "__esModule", function () { return $ef56e12f46c6eb58$export$1e511d4a378977f5; }, function (v) { return $ef56e12f46c6eb58$export$1e511d4a378977f5 = v; });
$parcel$export($ef56e12f46c6eb58$exports, "FormUp", function () { return $ef56e12f46c6eb58$export$7dd0724a362def6d; }, function (v) { return $ef56e12f46c6eb58$export$7dd0724a362def6d = v; });
var $ef56e12f46c6eb58$export$1e511d4a378977f5;
var $ef56e12f46c6eb58$export$7dd0724a362def6d;
"use strict";
$ef56e12f46c6eb58$export$1e511d4a378977f5 = true;
$ef56e12f46c6eb58$export$7dd0724a362def6d = void 0;

var $ef56e12f46c6eb58$var$_react = $ef56e12f46c6eb58$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $ef56e12f46c6eb58$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ef56e12f46c6eb58$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ef56e12f46c6eb58$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ef56e12f46c6eb58$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ef56e12f46c6eb58$var$_extends() {
    return $ef56e12f46c6eb58$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ef56e12f46c6eb58$var$_extends.apply(null, arguments);
}
var $ef56e12f46c6eb58$var$FormUp = $ef56e12f46c6eb58$export$7dd0724a362def6d = /*#__PURE__*/ (0, $ef56e12f46c6eb58$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $ef56e12f46c6eb58$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ef56e12f46c6eb58$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormUp"
    }, props), /*#__PURE__*/ $ef56e12f46c6eb58$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m18 15-6-6-6 6"
    }));
});
$ef56e12f46c6eb58$var$FormUp.displayName = 'FormUp';


var $395d1107a5183b93$exports = {};

$parcel$export($395d1107a5183b93$exports, "__esModule", function () { return $395d1107a5183b93$export$1e511d4a378977f5; }, function (v) { return $395d1107a5183b93$export$1e511d4a378977f5 = v; });
$parcel$export($395d1107a5183b93$exports, "Next", function () { return $395d1107a5183b93$export$b820fc49f2736e85; }, function (v) { return $395d1107a5183b93$export$b820fc49f2736e85 = v; });
var $395d1107a5183b93$export$1e511d4a378977f5;
var $395d1107a5183b93$export$b820fc49f2736e85;
"use strict";
$395d1107a5183b93$export$1e511d4a378977f5 = true;
$395d1107a5183b93$export$b820fc49f2736e85 = void 0;

var $395d1107a5183b93$var$_react = $395d1107a5183b93$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $395d1107a5183b93$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($395d1107a5183b93$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $395d1107a5183b93$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $395d1107a5183b93$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $395d1107a5183b93$var$_extends() {
    return $395d1107a5183b93$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $395d1107a5183b93$var$_extends.apply(null, arguments);
}
var $395d1107a5183b93$var$Next = $395d1107a5183b93$export$b820fc49f2736e85 = /*#__PURE__*/ (0, $395d1107a5183b93$var$_react.forwardRef)(function(props, ref) {
    var scaleProps = (0, $1b754218be0a6592$export$56a2e46cd4a7c217)(props);
    return /*#__PURE__*/ $395d1107a5183b93$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $395d1107a5183b93$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Next"
    }, props), /*#__PURE__*/ $395d1107a5183b93$var$_react["default"].createElement("path", $395d1107a5183b93$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m7 2 10 10L7 22"
    }, scaleProps)));
});
$395d1107a5183b93$var$Next.displayName = 'Next';


var $e751bc12b719d8f4$exports = {};

$parcel$export($e751bc12b719d8f4$exports, "__esModule", function () { return $e751bc12b719d8f4$export$1e511d4a378977f5; }, function (v) { return $e751bc12b719d8f4$export$1e511d4a378977f5 = v; });
$parcel$export($e751bc12b719d8f4$exports, "Pause", function () { return $e751bc12b719d8f4$export$59704c468e1a1527; }, function (v) { return $e751bc12b719d8f4$export$59704c468e1a1527 = v; });
var $e751bc12b719d8f4$export$1e511d4a378977f5;
var $e751bc12b719d8f4$export$59704c468e1a1527;
"use strict";
$e751bc12b719d8f4$export$1e511d4a378977f5 = true;
$e751bc12b719d8f4$export$59704c468e1a1527 = void 0;

var $e751bc12b719d8f4$var$_react = $e751bc12b719d8f4$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e751bc12b719d8f4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e751bc12b719d8f4$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e751bc12b719d8f4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e751bc12b719d8f4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e751bc12b719d8f4$var$_extends() {
    return $e751bc12b719d8f4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e751bc12b719d8f4$var$_extends.apply(null, arguments);
}
var $e751bc12b719d8f4$var$Pause = $e751bc12b719d8f4$export$59704c468e1a1527 = /*#__PURE__*/ (0, $e751bc12b719d8f4$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e751bc12b719d8f4$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e751bc12b719d8f4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Pause"
    }, props), /*#__PURE__*/ $e751bc12b719d8f4$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M3 21h6V3H3v18zm12 0h6V3h-6v18z"
    }));
});
$e751bc12b719d8f4$var$Pause.displayName = 'Pause';


var $82c01c28d93e7046$exports = {};

$parcel$export($82c01c28d93e7046$exports, "__esModule", function () { return $82c01c28d93e7046$export$1e511d4a378977f5; }, function (v) { return $82c01c28d93e7046$export$1e511d4a378977f5 = v; });
$parcel$export($82c01c28d93e7046$exports, "Play", function () { return $82c01c28d93e7046$export$480db61f4dcd7727; }, function (v) { return $82c01c28d93e7046$export$480db61f4dcd7727 = v; });
var $82c01c28d93e7046$export$1e511d4a378977f5;
var $82c01c28d93e7046$export$480db61f4dcd7727;
"use strict";
$82c01c28d93e7046$export$1e511d4a378977f5 = true;
$82c01c28d93e7046$export$480db61f4dcd7727 = void 0;

var $82c01c28d93e7046$var$_react = $82c01c28d93e7046$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $82c01c28d93e7046$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($82c01c28d93e7046$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $82c01c28d93e7046$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $82c01c28d93e7046$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $82c01c28d93e7046$var$_extends() {
    return $82c01c28d93e7046$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $82c01c28d93e7046$var$_extends.apply(null, arguments);
}
var $82c01c28d93e7046$var$Play = $82c01c28d93e7046$export$480db61f4dcd7727 = /*#__PURE__*/ (0, $82c01c28d93e7046$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $82c01c28d93e7046$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $82c01c28d93e7046$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Play"
    }, props), /*#__PURE__*/ $82c01c28d93e7046$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m3 22 18-10L3 2z"
    }));
});
$82c01c28d93e7046$var$Play.displayName = 'Play';


var $5c441c37eb1f2356$exports = {};

$parcel$export($5c441c37eb1f2356$exports, "__esModule", function () { return $5c441c37eb1f2356$export$1e511d4a378977f5; }, function (v) { return $5c441c37eb1f2356$export$1e511d4a378977f5 = v; });
$parcel$export($5c441c37eb1f2356$exports, "FormPin", function () { return $5c441c37eb1f2356$export$5423378d28f4447c; }, function (v) { return $5c441c37eb1f2356$export$5423378d28f4447c = v; });
var $5c441c37eb1f2356$export$1e511d4a378977f5;
var $5c441c37eb1f2356$export$5423378d28f4447c;
"use strict";
$5c441c37eb1f2356$export$1e511d4a378977f5 = true;
$5c441c37eb1f2356$export$5423378d28f4447c = void 0;

var $5c441c37eb1f2356$var$_react = $5c441c37eb1f2356$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5c441c37eb1f2356$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5c441c37eb1f2356$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5c441c37eb1f2356$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5c441c37eb1f2356$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5c441c37eb1f2356$var$_extends() {
    return $5c441c37eb1f2356$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5c441c37eb1f2356$var$_extends.apply(null, arguments);
}
var $5c441c37eb1f2356$var$FormPin = $5c441c37eb1f2356$export$5423378d28f4447c = /*#__PURE__*/ (0, $5c441c37eb1f2356$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5c441c37eb1f2356$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5c441c37eb1f2356$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormPin"
    }, props), /*#__PURE__*/ $5c441c37eb1f2356$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m4 19 4.455-4.454M12.273 5 18 10.727m-4.454-4.454L9.727 10.09s-2.545-.636-4.454 1.273l6.363 6.363c1.91-1.909 1.273-4.454 1.273-4.454l3.818-3.818-3.181-3.182Z"
    }));
});
$5c441c37eb1f2356$var$FormPin.displayName = 'FormPin';


var $2ce319e09672cf9d$exports = {};

$parcel$export($2ce319e09672cf9d$exports, "__esModule", function () { return $2ce319e09672cf9d$export$1e511d4a378977f5; }, function (v) { return $2ce319e09672cf9d$export$1e511d4a378977f5 = v; });
$parcel$export($2ce319e09672cf9d$exports, "Previous", function () { return $2ce319e09672cf9d$export$a499fb457891d86e; }, function (v) { return $2ce319e09672cf9d$export$a499fb457891d86e = v; });
var $2ce319e09672cf9d$export$1e511d4a378977f5;
var $2ce319e09672cf9d$export$a499fb457891d86e;
"use strict";
$2ce319e09672cf9d$export$1e511d4a378977f5 = true;
$2ce319e09672cf9d$export$a499fb457891d86e = void 0;

var $2ce319e09672cf9d$var$_react = $2ce319e09672cf9d$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $2ce319e09672cf9d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2ce319e09672cf9d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2ce319e09672cf9d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $2ce319e09672cf9d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $2ce319e09672cf9d$var$_extends() {
    return $2ce319e09672cf9d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2ce319e09672cf9d$var$_extends.apply(null, arguments);
}
var $2ce319e09672cf9d$var$Previous = $2ce319e09672cf9d$export$a499fb457891d86e = /*#__PURE__*/ (0, $2ce319e09672cf9d$var$_react.forwardRef)(function(props, ref) {
    var scaleProps = (0, $1b754218be0a6592$export$56a2e46cd4a7c217)(props);
    return /*#__PURE__*/ $2ce319e09672cf9d$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $2ce319e09672cf9d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Previous"
    }, props), /*#__PURE__*/ $2ce319e09672cf9d$var$_react["default"].createElement("path", $2ce319e09672cf9d$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M17 2 7 12l10 10"
    }, scaleProps)));
});
$2ce319e09672cf9d$var$Previous.displayName = 'Previous';


var $845b68b8616c04e1$exports = {};

$parcel$export($845b68b8616c04e1$exports, "__esModule", function () { return $845b68b8616c04e1$export$1e511d4a378977f5; }, function (v) { return $845b68b8616c04e1$export$1e511d4a378977f5 = v; });
$parcel$export($845b68b8616c04e1$exports, "StatusCriticalSmall", function () { return $845b68b8616c04e1$export$32f199c975b240fb; }, function (v) { return $845b68b8616c04e1$export$32f199c975b240fb = v; });
var $845b68b8616c04e1$export$1e511d4a378977f5;
var $845b68b8616c04e1$export$32f199c975b240fb;
"use strict";
$845b68b8616c04e1$export$1e511d4a378977f5 = true;
$845b68b8616c04e1$export$32f199c975b240fb = void 0;

var $845b68b8616c04e1$var$_react = $845b68b8616c04e1$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $845b68b8616c04e1$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($845b68b8616c04e1$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $845b68b8616c04e1$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $845b68b8616c04e1$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $845b68b8616c04e1$var$_extends() {
    return $845b68b8616c04e1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $845b68b8616c04e1$var$_extends.apply(null, arguments);
}
var $845b68b8616c04e1$var$StatusCriticalSmall = $845b68b8616c04e1$export$32f199c975b240fb = /*#__PURE__*/ (0, $845b68b8616c04e1$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $845b68b8616c04e1$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $845b68b8616c04e1$var$_extends({
        ref: ref,
        viewBox: "0 0 12 12",
        a11yTitle: "Status is critical"
    }, props), /*#__PURE__*/ $845b68b8616c04e1$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        stroke: "#000",
        d: "M6.712 1.263a1.005 1.005 0 0 0-1.424 0L1.263 5.288a1.005 1.005 0 0 0 0 1.424l4.025 4.025a1.005 1.005 0 0 0 1.424 0l4.025-4.025a1.005 1.005 0 0 0 0-1.424L6.712 1.263z"
    }));
});
$845b68b8616c04e1$var$StatusCriticalSmall.displayName = 'StatusCriticalSmall';


var $e82314c0e829446b$exports = {};

$parcel$export($e82314c0e829446b$exports, "__esModule", function () { return $e82314c0e829446b$export$1e511d4a378977f5; }, function (v) { return $e82314c0e829446b$export$1e511d4a378977f5 = v; });
$parcel$export($e82314c0e829446b$exports, "StatusGoodSmall", function () { return $e82314c0e829446b$export$a09254dff7a942de; }, function (v) { return $e82314c0e829446b$export$a09254dff7a942de = v; });
var $e82314c0e829446b$export$1e511d4a378977f5;
var $e82314c0e829446b$export$a09254dff7a942de;
"use strict";
$e82314c0e829446b$export$1e511d4a378977f5 = true;
$e82314c0e829446b$export$a09254dff7a942de = void 0;

var $e82314c0e829446b$var$_react = $e82314c0e829446b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e82314c0e829446b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e82314c0e829446b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e82314c0e829446b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e82314c0e829446b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e82314c0e829446b$var$_extends() {
    return $e82314c0e829446b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e82314c0e829446b$var$_extends.apply(null, arguments);
}
var $e82314c0e829446b$var$StatusGoodSmall = $e82314c0e829446b$export$a09254dff7a942de = /*#__PURE__*/ (0, $e82314c0e829446b$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e82314c0e829446b$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e82314c0e829446b$var$_extends({
        ref: ref,
        viewBox: "0 0 12 12",
        a11yTitle: "Status is okay"
    }, props), /*#__PURE__*/ $e82314c0e829446b$var$_react["default"].createElement("circle", {
        cx: "6",
        cy: "6",
        r: "5",
        fillRule: "evenodd",
        stroke: "#000"
    }));
});
$e82314c0e829446b$var$StatusGoodSmall.displayName = 'StatusGoodSmall';


var $b90cae8b1dd80e4e$exports = {};

$parcel$export($b90cae8b1dd80e4e$exports, "__esModule", function () { return $b90cae8b1dd80e4e$export$1e511d4a378977f5; }, function (v) { return $b90cae8b1dd80e4e$export$1e511d4a378977f5 = v; });
$parcel$export($b90cae8b1dd80e4e$exports, "StatusWarningSmall", function () { return $b90cae8b1dd80e4e$export$ead8eef644cb6ffc; }, function (v) { return $b90cae8b1dd80e4e$export$ead8eef644cb6ffc = v; });
var $b90cae8b1dd80e4e$export$1e511d4a378977f5;
var $b90cae8b1dd80e4e$export$ead8eef644cb6ffc;
"use strict";
$b90cae8b1dd80e4e$export$1e511d4a378977f5 = true;
$b90cae8b1dd80e4e$export$ead8eef644cb6ffc = void 0;

var $b90cae8b1dd80e4e$var$_react = $b90cae8b1dd80e4e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $b90cae8b1dd80e4e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b90cae8b1dd80e4e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b90cae8b1dd80e4e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $b90cae8b1dd80e4e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b90cae8b1dd80e4e$var$_extends() {
    return $b90cae8b1dd80e4e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b90cae8b1dd80e4e$var$_extends.apply(null, arguments);
}
var $b90cae8b1dd80e4e$var$StatusWarningSmall = $b90cae8b1dd80e4e$export$ead8eef644cb6ffc = /*#__PURE__*/ (0, $b90cae8b1dd80e4e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $b90cae8b1dd80e4e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $b90cae8b1dd80e4e$var$_extends({
        ref: ref,
        viewBox: "0 0 12 12",
        a11yTitle: "Status is warning"
    }, props), /*#__PURE__*/ $b90cae8b1dd80e4e$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        stroke: "#000",
        strokeLinejoin: "round",
        d: "m6 1 5 9H1z"
    }));
});
$b90cae8b1dd80e4e$var$StatusWarningSmall.displayName = 'StatusWarningSmall';


var $cf8d6a20ce9c71c6$exports = {};

$parcel$export($cf8d6a20ce9c71c6$exports, "__esModule", function () { return $cf8d6a20ce9c71c6$export$1e511d4a378977f5; }, function (v) { return $cf8d6a20ce9c71c6$export$1e511d4a378977f5 = v; });
$parcel$export($cf8d6a20ce9c71c6$exports, "StatusUnknownSmall", function () { return $cf8d6a20ce9c71c6$export$525b879776bb0ada; }, function (v) { return $cf8d6a20ce9c71c6$export$525b879776bb0ada = v; });
var $cf8d6a20ce9c71c6$export$1e511d4a378977f5;
var $cf8d6a20ce9c71c6$export$525b879776bb0ada;
"use strict";
$cf8d6a20ce9c71c6$export$1e511d4a378977f5 = true;
$cf8d6a20ce9c71c6$export$525b879776bb0ada = void 0;

var $cf8d6a20ce9c71c6$var$_react = $cf8d6a20ce9c71c6$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $cf8d6a20ce9c71c6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($cf8d6a20ce9c71c6$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $cf8d6a20ce9c71c6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $cf8d6a20ce9c71c6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $cf8d6a20ce9c71c6$var$_extends() {
    return $cf8d6a20ce9c71c6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cf8d6a20ce9c71c6$var$_extends.apply(null, arguments);
}
var $cf8d6a20ce9c71c6$var$StatusUnknownSmall = $cf8d6a20ce9c71c6$export$525b879776bb0ada = /*#__PURE__*/ (0, $cf8d6a20ce9c71c6$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $cf8d6a20ce9c71c6$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $cf8d6a20ce9c71c6$var$_extends({
        ref: ref,
        viewBox: "0 0 12 12",
        a11yTitle: "Status is unknown"
    }, props), /*#__PURE__*/ $cf8d6a20ce9c71c6$var$_react["default"].createElement("rect", {
        width: "10",
        height: "10",
        x: "1",
        y: "1",
        fillRule: "evenodd",
        stroke: "#000",
        rx: "1"
    }));
});
$cf8d6a20ce9c71c6$var$StatusUnknownSmall.displayName = 'StatusUnknownSmall';


var $6a2802ef8f2bd5f5$exports = {};

$parcel$export($6a2802ef8f2bd5f5$exports, "__esModule", function () { return $6a2802ef8f2bd5f5$export$1e511d4a378977f5; }, function (v) { return $6a2802ef8f2bd5f5$export$1e511d4a378977f5 = v; });
$parcel$export($6a2802ef8f2bd5f5$exports, "Subtract", function () { return $6a2802ef8f2bd5f5$export$8bc67ae85ef4b74f; }, function (v) { return $6a2802ef8f2bd5f5$export$8bc67ae85ef4b74f = v; });
var $6a2802ef8f2bd5f5$export$1e511d4a378977f5;
var $6a2802ef8f2bd5f5$export$8bc67ae85ef4b74f;
"use strict";
$6a2802ef8f2bd5f5$export$1e511d4a378977f5 = true;
$6a2802ef8f2bd5f5$export$8bc67ae85ef4b74f = void 0;

var $6a2802ef8f2bd5f5$var$_react = $6a2802ef8f2bd5f5$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $6a2802ef8f2bd5f5$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6a2802ef8f2bd5f5$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6a2802ef8f2bd5f5$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6a2802ef8f2bd5f5$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6a2802ef8f2bd5f5$var$_extends() {
    return $6a2802ef8f2bd5f5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6a2802ef8f2bd5f5$var$_extends.apply(null, arguments);
}
var $6a2802ef8f2bd5f5$var$Subtract = $6a2802ef8f2bd5f5$export$8bc67ae85ef4b74f = /*#__PURE__*/ (0, $6a2802ef8f2bd5f5$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $6a2802ef8f2bd5f5$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $6a2802ef8f2bd5f5$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Subtract"
    }, props), /*#__PURE__*/ $6a2802ef8f2bd5f5$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 12h20"
    }));
});
$6a2802ef8f2bd5f5$var$Subtract.displayName = 'Subtract';


var $230d45e2108d7875$exports = {};

$parcel$export($230d45e2108d7875$exports, "__esModule", function () { return $230d45e2108d7875$export$1e511d4a378977f5; }, function (v) { return $230d45e2108d7875$export$1e511d4a378977f5 = v; });
$parcel$export($230d45e2108d7875$exports, "Volume", function () { return $230d45e2108d7875$export$dde279e52d625429; }, function (v) { return $230d45e2108d7875$export$dde279e52d625429 = v; });
var $230d45e2108d7875$export$1e511d4a378977f5;
var $230d45e2108d7875$export$dde279e52d625429;
"use strict";
$230d45e2108d7875$export$1e511d4a378977f5 = true;
$230d45e2108d7875$export$dde279e52d625429 = void 0;

var $230d45e2108d7875$var$_react = $230d45e2108d7875$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $230d45e2108d7875$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($230d45e2108d7875$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $230d45e2108d7875$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $230d45e2108d7875$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $230d45e2108d7875$var$_extends() {
    return $230d45e2108d7875$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $230d45e2108d7875$var$_extends.apply(null, arguments);
}
var $230d45e2108d7875$var$Volume = $230d45e2108d7875$export$dde279e52d625429 = /*#__PURE__*/ (0, $230d45e2108d7875$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $230d45e2108d7875$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $230d45e2108d7875$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Volume"
    }, props), /*#__PURE__*/ $230d45e2108d7875$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M15 16a4 4 0 0 0 0-8m0 12c5 0 8-3.589 8-8s-3.589-8-8-8M1 12V8h5l6-5v18l-6-5H1v-4"
    }));
});
$230d45e2108d7875$var$Volume.displayName = 'Volume';


var $f6223518e88a1b05$exports = {};

$parcel$export($f6223518e88a1b05$exports, "__esModule", function () { return $f6223518e88a1b05$export$1e511d4a378977f5; }, function (v) { return $f6223518e88a1b05$export$1e511d4a378977f5 = v; });
$parcel$export($f6223518e88a1b05$exports, "VolumeLow", function () { return $f6223518e88a1b05$export$679a525edce53a0a; }, function (v) { return $f6223518e88a1b05$export$679a525edce53a0a = v; });
var $f6223518e88a1b05$export$1e511d4a378977f5;
var $f6223518e88a1b05$export$679a525edce53a0a;
"use strict";
$f6223518e88a1b05$export$1e511d4a378977f5 = true;
$f6223518e88a1b05$export$679a525edce53a0a = void 0;

var $f6223518e88a1b05$var$_react = $f6223518e88a1b05$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f6223518e88a1b05$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f6223518e88a1b05$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f6223518e88a1b05$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f6223518e88a1b05$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f6223518e88a1b05$var$_extends() {
    return $f6223518e88a1b05$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f6223518e88a1b05$var$_extends.apply(null, arguments);
}
var $f6223518e88a1b05$var$VolumeLow = $f6223518e88a1b05$export$679a525edce53a0a = /*#__PURE__*/ (0, $f6223518e88a1b05$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f6223518e88a1b05$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f6223518e88a1b05$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "VolumeLow"
    }, props), /*#__PURE__*/ $f6223518e88a1b05$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 8v8h5.099L12 21V3L6 8H1zm14 8a4 4 0 1 0 0-8"
    }));
});
$f6223518e88a1b05$var$VolumeLow.displayName = 'VolumeLow';





var $iA1nz = parcelRequire("iA1nz");
var $cdf517d38d72c2bc$export$333c2219d71d27ce = function parseMetricToNum(metric) {
    if (typeof metric === 'number') return metric;
    if (metric.match(/\s/) && true) console.warn("Invalid single measurement value: \"" + metric + "\"");
    return parseFloat(metric.match(/\d+(\.\d+)?/), 10);
};
var $cdf517d38d72c2bc$export$d3510c15440bd3f3 = function edgeToNum(size, theme) {
    return size ? $cdf517d38d72c2bc$export$333c2219d71d27ce(theme.global.edgeSize[size] || size) : 0;
};
var $cdf517d38d72c2bc$export$85e3c3ca0c6fb93 = function fontSize(size, lineHeight) {
    return (0, $iA1nz.css)([
        "font-size:",
        ";line-height:",
        ";"
    ], function(props) {
        return $cdf517d38d72c2bc$export$333c2219d71d27ce(size) / $cdf517d38d72c2bc$export$333c2219d71d27ce(props.theme.global.font.size) * 1 + "rem";
    }, function(props) {
        return lineHeight || Math.ceil($cdf517d38d72c2bc$export$333c2219d71d27ce(size) / $cdf517d38d72c2bc$export$333c2219d71d27ce(props.theme.global.lineHeight)) * ($cdf517d38d72c2bc$export$333c2219d71d27ce(props.theme.global.lineHeight) / $cdf517d38d72c2bc$export$333c2219d71d27ce(size)) + "px";
    });
};
var $cdf517d38d72c2bc$export$2180d12f0a299a89 = function breakpointStyle(breakpoint, content, responsive) {
    var px = typeof (breakpoint == null ? void 0 : breakpoint.value) === 'string' && breakpoint.value.endsWith('px') ? '' : 'px';
    var st = responsive === 'container' ? (0, $iA1nz.css)([
        "@container ",
        "{",
        ";}"
    ], breakpoint.value && "(max-width: " + breakpoint.value + px + ")", content) : (0, $iA1nz.css)([
        "@media only screen ",
        "{",
        ";}"
    ], breakpoint.value && "and (max-width: " + breakpoint.value + px + ")", content);
    return st;
};
var $cdf517d38d72c2bc$export$fdd5e64c0e8495bb = function findAllByType(component, type) {
    var matches = [];
    if (component.type === type) matches.push(component);
    if (component.children) component.children.forEach(function(child) {
        matches = matches.concat($cdf517d38d72c2bc$export$fdd5e64c0e8495bb(child, type));
    });
    return matches;
};
var $cdf517d38d72c2bc$export$319d1f43f7cd3019 = function getAvailableAtBadge(availableAt, componentType) {
    return [
        {
            url: "https://storybook.grommet.io/?selectedKind=" + componentType + "-" + availableAt + "&full=0&stories=1&panelRight=0",
            badge: 'https://cdn-images-1.medium.com/fit/c/120/120/1*TD1P0HtIH9zF0UEH28zYtw.png',
            label: 'Storybook'
        },
        {
            url: "https://codesandbox.io/s/github/grommet/grommet-sandbox?initialpath=/" + availableAt.toLowerCase() + "&module=%2Fsrc%2F" + availableAt + ".js",
            badge: 'https://codesandbox.io/static/img/play-codesandbox.svg',
            label: 'CodeSandbox'
        }
    ];
};


function $182c1f23b2371be0$var$_extends() {
    return $182c1f23b2371be0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $182c1f23b2371be0$var$_extends.apply(null, arguments);
}
var $182c1f23b2371be0$var$brandColor = '#7D4CDB';
var $182c1f23b2371be0$var$accentColors = [
    '#6FFFB0',
    '#FD6FFF',
    '#81FCED',
    '#FFCA58'
];
var $182c1f23b2371be0$var$neutralColors = [
    '#00873D',
    '#3D138D',
    '#00739D',
    '#A2423D'
];
var $182c1f23b2371be0$var$statusColors = {
    critical: '#EB0000',
    error: '#B30000',
    warning: '#C27B00',
    ok: '#009E67',
    unknown: '#919191',
    disabled: '#CCCCCC'
};
var $182c1f23b2371be0$var$darkColors = [
    '#333333',
    '#555555',
    '#777777',
    '#999999',
    '#999999',
    '#999999'
];
var $182c1f23b2371be0$var$lightColors = [
    '#F8F8F8',
    '#F2F2F2',
    '#EDEDED',
    '#DADADA',
    '#DADADA',
    '#DADADA'
];
var $182c1f23b2371be0$var$focusColor = $182c1f23b2371be0$var$accentColors[0];
var $182c1f23b2371be0$var$colors = {
    active: 'rgba(221, 221, 221, 0.5)',
    'background-back': {
        dark: '#33333308',
        light: '#EDEDED'
    },
    'background-front': {
        dark: '#444444',
        light: '#FFFFFF'
    },
    'background-contrast': {
        light: '#33333310',
        dark: '#FFFFFF18'
    },
    'active-background': 'background-contrast',
    'active-text': 'text-strong',
    black: '#000000',
    border: {
        dark: 'rgba(255, 255, 255, 0.33)',
        light: 'rgba(0, 0, 0, 0.33)'
    },
    brand: $182c1f23b2371be0$var$brandColor,
    control: {
        dark: 'accent-1',
        light: 'brand'
    },
    focus: $182c1f23b2371be0$var$focusColor,
    'graph-0': 'accent-1',
    'graph-1': 'neutral-1',
    'graph-2': 'neutral-2',
    'graph-3': 'neutral-3',
    'graph-4': 'neutral-4',
    placeholder: '#AAAAAA',
    selected: 'brand',
    text: {
        dark: '#f8f8f8',
        light: '#444444'
    },
    'text-strong': {
        dark: '#FFFFFF',
        light: '#000000'
    },
    'text-weak': {
        dark: '#CCCCCC',
        light: '#555555'
    },
    'text-xweak': {
        dark: '#BBBBBB',
        light: '#666666'
    },
    icon: {
        dark: '#f8f8f8',
        light: '#666666'
    },
    'selected-background': 'brand',
    'selected-text': 'text-strong',
    white: '#FFFFFF'
};
var $182c1f23b2371be0$var$colorArray = function colorArray(array, prefix) {
    return array.forEach(function(color, index) {
        $182c1f23b2371be0$var$colors[prefix + "-" + (index + 1)] = color;
    });
};
$182c1f23b2371be0$var$colorArray($182c1f23b2371be0$var$accentColors, 'accent');
$182c1f23b2371be0$var$colorArray($182c1f23b2371be0$var$darkColors, 'dark');
$182c1f23b2371be0$var$colorArray($182c1f23b2371be0$var$lightColors, 'light');
$182c1f23b2371be0$var$colorArray($182c1f23b2371be0$var$neutralColors, 'neutral');
Object.keys($182c1f23b2371be0$var$statusColors).forEach(function(color) {
    $182c1f23b2371be0$var$colors["status-" + color] = $182c1f23b2371be0$var$statusColors[color];
});
var $182c1f23b2371be0$export$80d376111cc09ad7 = function generate(baseSpacing, scale) {
    if (baseSpacing === void 0) baseSpacing = 24;
    if (scale === void 0) scale = 6;
    // 24
    var baseFontSize = baseSpacing * 0.75; // 18
    var fontScale = baseSpacing / scale; // 4
    var fontSizing = function fontSizing(factor) {
        return {
            size: baseFontSize + factor * fontScale + "px",
            height: baseSpacing + factor * fontScale + "px",
            // maxWidth chosen to be ~50 characters wide
            // see: https://ux.stackexchange.com/a/34125
            maxWidth: baseSpacing * (baseFontSize + factor * fontScale) + "px"
        };
    };
    var borderWidth = 2;
    var controlBorderWidth = 1;
    var result = (0, $cdf577e3272e3992$export$6969335ea1e4e77c)((0, $07da00c9c00f6352$export$e2253033e6e1df16), {
        global: {
            active: {
                background: {
                    color: 'active',
                    opacity: 'medium'
                },
                color: {
                    dark: 'white',
                    light: 'black'
                }
            },
            animation: {
                duration: '1s',
                jiggle: {
                    duration: '0.1s'
                }
            },
            // backgrounds: undefined,
            borderSize: {
                xsmall: '1px',
                small: '2px',
                medium: baseSpacing / 6 + "px",
                // 4
                large: baseSpacing / 2 + "px",
                // 12
                xlarge: baseSpacing + "px" // 24
            },
            breakpoints: {
                small: {
                    value: baseSpacing * 32,
                    // 768
                    borderSize: {
                        xsmall: '1px',
                        small: '2px',
                        medium: baseSpacing / 6 + "px",
                        // 4
                        large: baseSpacing / 4 + "px",
                        // 6
                        xlarge: baseSpacing / 2 + "px" // 12
                    },
                    edgeSize: {
                        none: '0px',
                        hair: '1px',
                        // for Chart
                        xxsmall: '2px',
                        xsmall: baseSpacing / 8 + "px",
                        // 3
                        small: baseSpacing / 4 + "px",
                        // 6
                        medium: baseSpacing / 2 + "px",
                        // 12
                        large: baseSpacing + "px",
                        // 24
                        xlarge: baseSpacing * 2 + "px" // 48
                    },
                    // radius: {},
                    size: {
                        xxsmall: baseSpacing + "px",
                        // 24
                        xsmall: baseSpacing * 2 + "px",
                        // 48
                        small: baseSpacing * 4 + "px",
                        // 96
                        medium: baseSpacing * 8 + "px",
                        // 192
                        large: baseSpacing * 16 + "px",
                        // 384
                        xlarge: baseSpacing * 32 + "px",
                        // 768
                        full: '100%'
                    }
                },
                medium: {
                    value: baseSpacing * 64 // 1536
                },
                large: {} // anything above 'medium'
            },
            // Breakpoints used at Server Side Rendering for the initial rendering
            // These values correspond to the theme breakpoints
            deviceBreakpoints: {
                phone: 'small',
                tablet: 'medium',
                computer: 'large'
            },
            colors: $182c1f23b2371be0$var$colors,
            control: {
                border: {
                    width: controlBorderWidth + "px",
                    radius: '4px',
                    color: 'border'
                },
                disabled: {
                    opacity: 0.3
                }
            },
            // The time to wait after the user stopped typing, measured in ms.
            // A half second (500ms) debounce can be a helpful starting point.
            // You want to give the user time to fill out a field, but capture
            // their attention before they move on past it. 2 second (2000ms)
            // might be too long depending on how fast people type, and 200ms
            // would be an eye blink
            debounceDelay: 500,
            // deprecated: {
            //   backgrounds: [
            //     {
            //       name: string,
            //       message: string,
            //     },
            //   ],
            //   colors: [
            //     {
            //       name: string,
            //       message: string,
            //     },
            //   ],
            //   button: {
            //     kind: [
            //       {
            //         name: string,
            //         message: string,
            //       },
            //     ],
            //   },
            // },
            drop: {
                // intelligentMargin: undefined,
                background: {
                    dark: 'black',
                    light: 'white'
                },
                border: {
                    radius: '0px'
                },
                // margin: undefined
                shadowSize: 'small',
                // shadowSize is deprecated, use 'elevation'
                zIndex: '20'
            },
            edgeSize: {
                none: '0px',
                hair: '1px',
                // for Chart
                xxsmall: baseSpacing / 8 + "px",
                // 3
                xsmall: baseSpacing / 4 + "px",
                // 6
                small: baseSpacing / 2 + "px",
                // 12
                medium: baseSpacing + "px",
                // 24
                large: baseSpacing * 2 + "px",
                // 48
                xlarge: baseSpacing * 4 + "px",
                // 96
                responsiveBreakpoint: 'small'
            },
            elevation: {
                light: {
                    none: 'none',
                    xsmall: '0px 1px 2px rgba(0, 0, 0, 0.20)',
                    small: '0px 2px 4px rgba(0, 0, 0, 0.20)',
                    medium: '0px 4px 8px rgba(0, 0, 0, 0.20)',
                    large: '0px 8px 16px rgba(0, 0, 0, 0.20)',
                    xlarge: '0px 12px 24px rgba(0, 0, 0, 0.20)'
                },
                dark: {
                    none: 'none',
                    xsmall: '0px 2px 2px rgba(255, 255, 255, 0.40)',
                    small: '0px 4px 4px rgba(255, 255, 255, 0.40)',
                    medium: '0px 6px 8px rgba(255, 255, 255, 0.40)',
                    large: '0px 8px 16px rgba(255, 255, 255, 0.40)',
                    xlarge: '0px 12px 24px rgba(255, 255, 255, 0.40)'
                }
            },
            focus: {
                // shadow or outline are required for accessibility
                border: {
                    // remove to only have shadow
                    color: 'focus'
                },
                // outline: { color: undefined, size: undefined },
                shadow: {
                    color: 'focus',
                    size: '2px'
                },
                twoColor: undefined,
                inset: {
                    border: {
                        // remove to only have shadow
                        color: 'focus'
                    },
                    outline: {
                        color: 'focus',
                        size: '2px',
                        offset: '-2px'
                    },
                    shadow: undefined,
                    twoColor: undefined
                }
            },
            font: $182c1f23b2371be0$var$_extends({}, fontSizing(0)),
            hover: {
                background: {
                    color: 'active',
                    opacity: 'medium'
                },
                color: {
                    dark: 'white',
                    light: 'black'
                }
            },
            input: {
                padding: {
                    horizontal: (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(baseSpacing / 2 + "px") - (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(controlBorderWidth + "px") + "px",
                    vertical: (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(baseSpacing / 2 + "px") - (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(controlBorderWidth + "px") + "px"
                },
                font: {
                    // size: undefined,
                    // height: undefined,
                    weight: 600
                },
                // deprecate in v3
                // weight: undefined,
                readOnly: {
                }
            },
            opacity: {
                strong: 0.8,
                medium: 0.4,
                weak: 0.1
            },
            // radius: {},
            selected: {
                background: 'selected',
                color: 'white'
            },
            spacing: baseSpacing + "px",
            size: {
                xxsmall: baseSpacing * 2 + "px",
                // 48
                xsmall: baseSpacing * 4 + "px",
                // 96
                small: baseSpacing * 8 + "px",
                // 192
                medium: baseSpacing * 16 + "px",
                // 384
                large: baseSpacing * 32 + "px",
                // 768
                xlarge: baseSpacing * 48 + "px",
                // 1152
                xxlarge: baseSpacing * 64 + "px",
                // 1536
                full: '100%'
            }
        },
        // icon: {
        //   extend: undefined,
        //   matchSize: undefined,
        //   size: undefined,
        // },
        accordion: {
            icon: {
                container: {
                    pad: {
                        horizontal: 'small'
                    }
                }
            },
            label: {
                container: {
                    pad: {
                        horizontal: 'xsmall'
                    }
                }
            },
            panel: {
            },
            border: {
                side: 'bottom',
                color: 'border'
            },
            heading: {
                level: '4' // level ranges from 1-6
            },
            hover: {
                // background: undefined,
                color: {
                    dark: 'light-4',
                    light: 'dark-3'
                },
                // deprecated
                heading: {
                    color: {
                        dark: 'light-4',
                        light: 'dark-3'
                    }
                }
            },
            icons: {
                collapse: (0, $ef56e12f46c6eb58$export$7dd0724a362def6d),
                expand: (0, $08156255a6733056$export$cd1a8f5a55d5e9d3)
            }
        },
        anchor: {
            color: {
                dark: 'accent-1',
                light: 'brand'
            },
            gap: 'small',
            hover: {
                textDecoration: 'underline'
            },
            // icon: {
            //   color: undefined
            // },
            iconOnly: {
                pad: 'small'
            },
            textDecoration: 'none',
            fontWeight: 600
        },
        avatar: {
            // extend: undefined,
            size: {
                xsmall: baseSpacing * 0.75 + "px",
                // 18px
                small: baseSpacing + "px",
                // 24px
                medium: baseSpacing * 2 + "px",
                // default 48px
                large: baseSpacing * 3 + "px",
                // 72px
                xlarge: baseSpacing * 4 + "px",
                // 96px
                '2xl': baseSpacing * 5 + "px",
                // 120px
                '3xl': baseSpacing * 6 + "px",
                // 144px
                '4xl': baseSpacing * 7 + "px",
                // 168px
                '5xl': baseSpacing * 8 + "px" // 192px
            },
            text: {
                size: {
                    xsmall: 'small',
                    // 14px
                    small: 'medium',
                    // 18px
                    medium: 'large',
                    // 22px
                    large: 'xlarge',
                    // 26px
                    xlarge: 'xxlarge',
                    // 34px
                    '2xl': '3xl',
                    // 42px
                    '3xl': '4xl',
                    // 54px
                    '4xl': '5xl',
                    // 70px
                    '5xl': '6xl' // 90px
                }
            }
        },
        box: {
            border: {
                offset: 'xsmall'
            },
            responsiveBreakpoint: 'small' // when we switch rows to columns
        },
        button: {
            intelligentPad: true,
            // background: undefined,
            badge: {
                // align: undefined,,
                container: {
                    background: 'brand'
                },
                size: {
                    medium: baseSpacing + "px" // 24px
                },
                text: {
                    size: {
                        medium: 'small' // 14px
                    }
                }
            },
            busy: {
                gap: 'small'
            },
            gap: 'small',
            size: {
                small: {
                    border: {
                        radius: baseSpacing * 0.75 + "px"
                    },
                    pad: {
                        vertical: baseSpacing / 4 - borderWidth + "px",
                        // 4px
                        horizontal: baseSpacing - borderWidth * 2 + "px" // 20px,
                    }
                },
                medium: {
                    border: {
                        radius: baseSpacing * 0.75 + "px" // 18px
                    },
                    pad: {
                        vertical: baseSpacing / 4 - borderWidth + "px",
                        // 4px
                        horizontal: baseSpacing - borderWidth + "px" // 22px
                    }
                },
                large: {
                    border: {
                        radius: baseSpacing + "px" // 24px
                    },
                    pad: {
                        vertical: baseSpacing / 4 + borderWidth + "px",
                        // 8px
                        horizontal: baseSpacing + borderWidth * 4 + "px" // 32px,
                    }
                }
            },
            border: {
                // color: { dark: undefined, light: undefined }
                width: borderWidth + "px",
                radius: baseSpacing * 0.75 + "px"
            },
            // color: { dark: undefined, light: undefined },
            // elevation: undefined,
            // default: {
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   direction: undefined,
            //   elevation: undefined,
            //   font: {
            //     size: undefined,
            //     weight: undefined,
            //   },
            //   icon: undefined,
            //   padding: {
            //     vertical: undefined,
            //     horizontal: undefined,
            //   },
            //   reverse: undefined,
            //   extend: undefined,
            // },
            // primary: {
            //   font: {
            //     size: undefined,
            //     weight: undefined,
            //   },
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   direction: undefined,
            //   elevation: undefined,
            //   icon: undefined,
            //   padding: {
            //     vertical: undefined,
            //     horizontal: undefined,
            //   },
            //   reverse: undefined,
            //   extend: undefined,
            // },
            // secondary: {
            //   font: {
            //     size: undefined,
            //     weight: undefined,
            //   },
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   direction: undefined,
            //   elevation: undefined,
            //   icon: undefined,
            //   padding: {
            //     vertical: undefined,
            //     horizontal: undefined,
            //   },
            //   reverse: undefined,
            //   extend: undefined,
            // },
            // option: {
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   direction: undefined,
            //   elevation: undefined,
            //   icon: undefined,
            //   padding: {
            //     vertical: undefined,
            //     horizontal: undefined,
            //   },
            //   reverse: undefined,
            //   extend: undefined,
            // },
            active: {
                background: 'active-background',
                //   border: undefined,
                color: 'active-text'
            },
            disabled: {
                //   background: undefined,
                //   border: undefined,
                //   color: undefined,
                opacity: 0.3
            },
            // hover: {
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   extend: undefined,
            //   default: {},
            //   primary: {},
            //   secondary: {},
            // },
            padding: {
                vertical: baseSpacing / 4 - borderWidth + "px",
                horizontal: baseSpacing - borderWidth + "px"
            },
            transition: {
                timing: 'ease-in-out',
                duration: 0.1,
                properties: [
                    'color',
                    'background-color',
                    'border-color',
                    'box-shadow'
                ]
            },
            skeleton: {
                width: {
                    min: '100px'
                }
            }
        },
        calendar: {
            day: {
                // adjacent: {
                //   color: undefined,
                // },
                hover: {
                    background: 'active-background'
                },
                selected: {
                    // background: undefined,
                    // color: undefined,
                    font: {
                        weight: 'bold'
                    }
                },
                inRange: {
                    // color: undefined,
                    font: {
                        weight: 'bold'
                    }
                }
            },
            // range: {
            //   background: undefined,
            // },
            // daySize must align with global.size
            small: {
                // day: {
                //   round: undefined,
                // },
                // range: {
                //   round: undefined,
                //   start: {
                //     round: undefined,
                //   },
                //   end: {
                //     round: undefined,
                //   },
                // },
                // title: {},
                fontSize: baseFontSize - fontScale + "px",
                title: {
                    container: {
                        pad: {
                            horizontal: 'xsmall'
                        }
                    }
                },
                lineHeight: 1.375,
                daySize: baseSpacing * 8 / 7 + "px",
                slideDuration: '0.2s'
            },
            medium: {
                // day: {
                //   round: undefined,
                // },
                // range: {
                //   round: undefined,
                //   start: {
                //     round: undefined,
                //   },
                //   end: {
                //     round: undefined,
                //   },
                // },
                // title: {},
                fontSize: baseFontSize + "px",
                title: {
                    container: {
                        pad: {
                            horizontal: 'small'
                        }
                    }
                },
                lineHeight: 1.45,
                daySize: baseSpacing * 16 / 7 + "px",
                slideDuration: '0.5s'
            },
            large: {
                // day: {
                //   round: undefined,
                // },
                // range: {
                //   round: undefined,
                //   start: {
                //     round: undefined,
                //   },
                //   end: {
                //     round: undefined,
                //   },
                // },
                // title: {},
                fontSize: baseFontSize + 3 * fontScale + "px",
                title: {
                    container: {
                        pad: {
                            horizontal: 'medium'
                        }
                    }
                },
                lineHeight: 1.11,
                daySize: baseSpacing * 32 / 7 + "px",
                slideDuration: '0.8s'
            },
            icons: {
                previous: (0, $2ce319e09672cf9d$export$a499fb457891d86e),
                next: (0, $395d1107a5183b93$export$b820fc49f2736e85),
                small: {
                    previous: (0, $e416b67dbaf66fc1$export$a14ca6bc44f029a6),
                    next: (0, $0736b9499c5aa664$export$a8d2f61b02c7b95f)
                }
            },
            heading: {
                level: '4'
            } // level ranges from 1-6
        },
        card: {
            container: {
                round: 'small',
                elevation: 'small'
            },
            // hover: {
            //   container: {
            //     elevation: undefined,
            //   },
            // },
            header: {},
            body: {},
            footer: {}
        },
        cards: {
            container: {
                // any box props
                gap: 'xsmall'
            },
            grid: {
                columns: 'small',
                gap: 'medium'
            }
        },
        carousel: {
            icons: {
                current: (0, $6a2802ef8f2bd5f5$export$8bc67ae85ef4b74f),
                next: (0, $395d1107a5183b93$export$b820fc49f2736e85),
                previous: (0, $2ce319e09672cf9d$export$a499fb457891d86e)
            },
            animation: {
                duration: 1000
            },
            disabled: {
                icons: {
                }
            }
        },
        chart: {
            color: 'graph-0',
            height: 'small',
            thickness: 'medium',
            width: 'medium'
        },
        checkBox: {
            border: {
                color: {
                    dark: 'rgba(255, 255, 255, 0.5)',
                    light: 'rgba(0, 0, 0, 0.15)'
                },
                width: '2px'
            },
            check: {
                // extend: undefined,
                radius: '4px',
                thickness: '4px'
            },
            label: {
                align: 'center'
            },
            // color: { dark: undefined, light: undefined },
            // extend: undefined,
            gap: 'small',
            hover: {
                border: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    }
                }
            },
            icon: {
            },
            icons: {
            },
            // pad: undefined,
            size: baseSpacing + "px",
            toggle: {
                // background: undefined
                color: {
                    dark: '#d9d9d9',
                    light: '#d9d9d9'
                },
                knob: {
                },
                radius: baseSpacing + "px",
                size: baseSpacing * 2 + "px"
            }
        },
        checkBoxGroup: {
            container: {
                //   // any box props
                //   extend: undefined,
                gap: 'small'
            }
        },
        clock: {
            analog: {
                // extend: undefined,
                hour: {
                    color: {
                        dark: 'light-2',
                        light: 'dark-3'
                    },
                    width: baseSpacing / 3 + "px",
                    size: baseSpacing + "px",
                    shape: 'round'
                },
                minute: {
                    color: {
                        dark: 'light-4',
                        light: 'dark-3'
                    },
                    width: baseSpacing / 6 + "px",
                    size: Math.round(baseSpacing / 2) + "px",
                    shape: 'round'
                },
                second: {
                    color: {
                        dark: 'accent-1',
                        light: 'accent-1'
                    },
                    width: baseSpacing / 8 + "px",
                    size: Math.round(baseSpacing / 2.666) + "px",
                    shape: 'round'
                },
                size: {
                    xsmall: baseSpacing * 2 + "px",
                    small: baseSpacing * 3 + "px",
                    medium: baseSpacing * 4 + "px",
                    large: baseSpacing * 6 + "px",
                    xlarge: baseSpacing * 9 + "px",
                    xxlarge: baseSpacing * 12 + "px",
                    huge: baseSpacing * 12 + "px" // kept for backwards compatibility
                }
            },
            digital: {
                text: {
                    xsmall: {
                        size: baseFontSize - 2 * fontScale + "px",
                        height: 1.5
                    },
                    small: {
                        size: baseFontSize - fontScale + "px",
                        height: 1.43
                    },
                    medium: {
                        size: baseFontSize + "px",
                        height: 1.375
                    },
                    large: {
                        size: baseFontSize + fontScale + "px",
                        height: 1.167
                    },
                    xlarge: {
                        size: baseFontSize + 2 * fontScale + "px",
                        height: 1.1875
                    },
                    xxlarge: {
                        size: baseFontSize + 4 * fontScale + "px",
                        height: 1.125
                    }
                }
            }
        },
        collapsible: {
            minSpeed: 200,
            baseline: 500
        },
        data: {
            // button: {
            //   kind: undefined,
            // },
            drop: {
                pad: 'small'
            },
            toolbar: {
                gap: 'medium'
            }
        },
        dataChart: {
            // colors: [],
            gap: 'small',
            // granularity: {
            //   y: {},
            // },
            detail: {
                gap: 'xsmall',
                pad: 'small'
            },
            halfPad: {
                xlarge: 'large',
                large: 'medium',
                medium: 'small',
                small: 'xsmall',
                xsmall: 'xxsmall'
            },
            legend: {
                margin: {
                    top: 'small'
                },
                gap: 'small',
                item: {
                    gap: 'xsmall',
                    pad: {
                        horizontal: 'small',
                        vertical: 'xsmall'
                    }
                }
            },
            // orderedSizes: undefined,
            size: {
                height: 'small'
            },
            thickness: {
                veryDense: 'hair',
                dense: 'xsmall',
                heavy: 'small',
                moderate: 'medium',
                light: 'large',
                sparse: 'xlarge'
            },
            thicknessPad: {
                xlarge: 'large',
                large: 'medium',
                medium: 'small',
                small: 'xsmall',
                xsmall: 'xxsmall'
            }
        },
        dataFilter: {
            rangeSelector: {
                size: 'full',
                round: 'small'
            },
            selectMultiple: {
                dropHeight: 'medium'
            }
        },
        dataFilters: {
            // icons: {
            //   close: undefined,
            //   filter: undefined,
            // }
            footer: {
                actions: {
                    margin: {
                        top: 'medium'
                    },
                    gap: 'small'
                }
            },
            clearControl: {
                margin: {
                    start: 'small'
                }
            },
            pad: 'medium',
            width: {
                min: 'medium'
            }
        },
        dateInput: {
            button: {
                margin: 'small'
            },
            container: {
                round: 'xxsmall'
            },
            icon: {
                // calendar: undefined,
                size: 'medium'
            }
        },
        dataSearch: {
        },
        dataSort: {
        },
        dataSummary: {
            margin: {
                vertical: 'xsmall'
            },
            separator: {
                margin: {
                    horizontal: 'small'
                }
            }
        },
        dataTable: {
            // body: {
            //   extend: undefined,
            //   row: {
            //     extend: undefined,
            //   }
            //   selected: undefined,
            // },
            expand: {
                size: 'xxsmall'
            },
            pinned: {
                // body: {
                //    background: undefined,
                //    extend: undefined,
                // },
                header: {
                    background: {
                        opacity: 'strong'
                    }
                },
                footer: {
                    background: {
                        opacity: 'strong'
                    }
                }
            },
            container: {
                // any box props
                gap: 'xsmall'
            },
            groupHeader: {
            },
            groupEnd: {
                border: {
                    side: 'bottom',
                    size: 'xsmall'
                }
            },
            header: {
                // background: undefined,
                // border: undefined,
                // color: undefined,
                // extend: undefined,
                // font: {
                //   weight: undefined,
                //   size: undefined,
                // },
                gap: 'small',
                // hover: {
                //   background: undefined,
                // },
                // pad: undefined,
                units: {
                    color: 'text-xweak',
                    margin: {
                        left: 'xsmall'
                    },
                    alignSelf: 'end'
                }
            },
            icons: {
                ascending: (0, $08156255a6733056$export$cd1a8f5a55d5e9d3),
                contract: (0, $ef56e12f46c6eb58$export$7dd0724a362def6d),
                descending: (0, $ef56e12f46c6eb58$export$7dd0724a362def6d),
                expand: (0, $08156255a6733056$export$cd1a8f5a55d5e9d3)
            },
            primary: {
                weight: 'bold'
            },
            resize: {
                border: {
                    color: 'border',
                    side: 'end'
                },
                // hover: {
                //   border: {
                //     color: undefined,
                //     side: undefined,
                //     size: undefined,
                //   },
                // },
                padding: {
                    vertical: 'xsmall'
                }
            },
            search: {
                pad: {
                    left: 'small'
                },
                text: {
                    pad: {
                        horizontal: 'small'
                    }
                }
            },
            sort: {
                gap: 'xsmall'
            }
        },
        dataTableColumns: {
            // icons: {
            //   control: undefined,
            //   pinned: undefined,
            //   search: undefined,
            // }
            tabs: {
                pad: 'small'
            },
            selectColumns: {
                pad: {
                    vertical: 'small'
                },
                gap: 'xsmall'
            },
            orderColumns: {
                pad: {
                    top: 'small'
                }
            }
        },
        diagram: {
            // extend: undefined,
            line: {
                color: 'graph-0'
            }
        },
        distribution: {
            gap: 'xsmall'
        },
        // drop: {
        //   extend: undefined,
        //   maxHeight: undefined,
        // },
        fileInput: {
            anchor: {
                margin: 'small'
            },
            // background: {},
            border: {
                // color: undefined,
                side: 'all',
                size: 'small',
                style: 'dashed'
            },
            dragOver: {
                border: {
                    color: 'control'
                }
            },
            hover: {
                border: {
                    color: 'brand'
                }
            },
            icons: {
                // error: undefined,
                remove: (0, $da76b8daacd39c4f$export$fe20cfcdd41aa0ef)
            },
            // pad: {},
            label: {
                gap: 'xsmall',
                margin: 'small'
            },
            message: {
                margin: 'small'
            }
        },
        footer: {
            gap: 'medium'
        },
        formField: {
            // [inputname]: {
            //  container: {
            //    extend: undefined,
            //   }
            // }
            border: {
                color: 'border',
                error: {
                    color: {
                        dark: 'white',
                        light: 'status-critical'
                    }
                },
                position: 'inner',
                side: 'bottom'
            },
            // checkBox: {
            //   pad: undefined,
            // },
            content: {
                // margin: undefined,
                pad: 'small'
            },
            disabled: {
                background: {
                    color: 'status-disabled',
                    opacity: 'medium'
                }
            },
            focus: {
                containerFocus: true
            },
            error: {
                color: 'status-critical',
                margin: {
                    vertical: 'xsmall',
                    horizontal: 'small'
                }
            },
            // extend: undefined,
            help: {
                color: 'dark-2',
                margin: {
                    start: 'small'
                }
            },
            info: {
                color: 'text-xweak',
                margin: {
                    vertical: 'xsmall',
                    horizontal: 'small'
                }
            },
            label: {
                margin: {
                    vertical: 'xsmall',
                    horizontal: 'small'
                }
            },
            margin: {
                bottom: 'small'
            },
            // round: undefined,
            survey: {
                label: {
                    margin: {
                        bottom: 'xsmall'
                    },
                    size: 'medium',
                    weight: 400
                }
            }
        },
        grommet: {
        },
        header: {
            sticky: {
                zIndex: '20'
            },
            gap: 'medium'
        },
        heading: {
            // color: undefined,
            font: {
            },
            level: {
                1: {
                    font: {
                    },
                    small: $182c1f23b2371be0$var$_extends({}, fontSizing(4)),
                    medium: $182c1f23b2371be0$var$_extends({}, fontSizing(8)),
                    large: $182c1f23b2371be0$var$_extends({}, fontSizing(16)),
                    xlarge: $182c1f23b2371be0$var$_extends({}, fontSizing(24))
                },
                2: {
                    font: {
                    },
                    small: $182c1f23b2371be0$var$_extends({}, fontSizing(2)),
                    medium: $182c1f23b2371be0$var$_extends({}, fontSizing(4)),
                    large: $182c1f23b2371be0$var$_extends({}, fontSizing(8)),
                    xlarge: $182c1f23b2371be0$var$_extends({}, fontSizing(12))
                },
                3: {
                    font: {
                    },
                    small: $182c1f23b2371be0$var$_extends({}, fontSizing(1)),
                    medium: $182c1f23b2371be0$var$_extends({}, fontSizing(2)),
                    large: $182c1f23b2371be0$var$_extends({}, fontSizing(4)),
                    xlarge: $182c1f23b2371be0$var$_extends({}, fontSizing(6))
                },
                4: {
                    font: {
                    },
                    small: $182c1f23b2371be0$var$_extends({}, fontSizing(0)),
                    medium: $182c1f23b2371be0$var$_extends({}, fontSizing(0)),
                    large: $182c1f23b2371be0$var$_extends({}, fontSizing(0)),
                    xlarge: $182c1f23b2371be0$var$_extends({}, fontSizing(0))
                },
                5: {
                    font: {
                    },
                    small: $182c1f23b2371be0$var$_extends({}, fontSizing(-0.5)),
                    medium: $182c1f23b2371be0$var$_extends({}, fontSizing(-0.5)),
                    large: $182c1f23b2371be0$var$_extends({}, fontSizing(-0.5)),
                    xlarge: $182c1f23b2371be0$var$_extends({}, fontSizing(-0.5))
                },
                6: {
                    font: {
                    },
                    small: $182c1f23b2371be0$var$_extends({}, fontSizing(-1)),
                    medium: $182c1f23b2371be0$var$_extends({}, fontSizing(-1)),
                    large: $182c1f23b2371be0$var$_extends({}, fontSizing(-1)),
                    xlarge: $182c1f23b2371be0$var$_extends({}, fontSizing(-1))
                }
            },
            responsiveBreakpoint: 'small',
            // when we scale the font size down
            weight: 600,
            skeleton: {
                width: {
                    min: '150px',
                    max: '200px'
                }
            }
        },
        layer: {
            background: {
                dark: 'black',
                light: 'white'
            },
            border: {
                radius: '4px'
            },
            container: {
                // elevation: undefined,
                zIndex: '20',
                height: {
                    min: 'xxsmall'
                }
            },
            // extend: undefined,
            overlay: {
                background: 'rgba(0, 0, 0, 0.5)'
            },
            responsiveBreakpoint: 'small',
            // when Layer takes over the full screen
            zIndex: '20'
        },
        list: {
            container: {
                // any box props
                gap: 'xsmall'
            },
            item: {
                // background: undefined,
                border: 'horizontal',
                disabled: {
                    color: 'status-disabled',
                    cursor: 'default'
                },
                gap: 'medium',
                pinned: {
                    background: 'background-contrast',
                    icon: {
                        size: 'medium',
                        pad: 'small'
                    }
                },
                pad: {
                    horizontal: 'medium',
                    vertical: 'small'
                }
            },
            primaryKey: {
                // any text props
                weight: 'bold'
            },
            icons: {
                down: (0, $08156255a6733056$export$cd1a8f5a55d5e9d3),
                up: (0, $ef56e12f46c6eb58$export$7dd0724a362def6d),
                pin: (0, $5c441c37eb1f2356$export$5423378d28f4447c)
            }
        },
        maskedInput: {
        },
        menu: {
            // background: undefined,
            // extend: undefined,
            // item: undefined,
            drop: {
                align: {
                    top: 'top',
                    left: 'left'
                }
            },
            // container: {
            //   // any box props
            // },
            group: {
                container: {
                    pad: {
                        vertical: 'xsmall'
                    }
                },
                separator: {
                    color: 'border',
                    size: 'xsmall',
                    pad: {
                        horizontal: 'small'
                    }
                }
            },
            icons: {
                down: (0, $08156255a6733056$export$cd1a8f5a55d5e9d3)
            }
        },
        meter: {
            background: {
                color: 'light-2',
                opacity: 'medium'
            },
            color: 'graph-0'
        },
        nameValueList: {
            gap: {
                column: 'large',
                row: 'small'
            },
            pair: {
                column: {
                    gap: {
                        column: 'large',
                        row: 'medium'
                    }
                }
            },
            name: {
                width: 'small'
            },
            value: {
                width: 'medium'
            }
        },
        nameValuePair: {
            column: {
                gap: 'xxsmall'
            },
            name: {
                // any text props
                color: 'text',
                weight: 'bold'
            },
            value: {
                // any text props
                color: 'text'
            }
        },
        nav: {
            gap: 'medium'
        },
        notification: {
            actions: {
                // any anchor props
                margin: {
                    right: 'xsmall'
                }
            },
            direction: 'column',
            container: {
                // any box props
                round: 'xsmall',
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                },
                background: {
                    color: 'background-front'
                }
            },
            gap: 'small',
            global: {
                direction: 'row',
                container: {
                    // any box props
                    round: 'none',
                    pad: {
                        horizontal: 'large',
                        vertical: 'xsmall'
                    }
                }
            },
            toast: {
                // direction: undefined,
                container: {
                    // any box props
                    elevation: 'medium',
                    width: 'medium'
                },
                layer: {
                    position: 'top',
                    margin: 'medium'
                },
                time: 8000
            },
            iconContainer: {
                // any box props
                pad: {
                    right: 'small'
                },
                flex: false
            },
            textContainer: {
                // any box props
                gap: 'medium'
            },
            title: {
                // any text props
                weight: 'bold'
            },
            message: {
                // any text props
                margin: 'none',
                // fill: undefined,
                text: {
                    margin: {
                        right: 'xsmall'
                    }
                }
            },
            close: {
                icon: (0, $da76b8daacd39c4f$export$fe20cfcdd41aa0ef)
            },
            critical: {
                icon: (0, $845b68b8616c04e1$export$32f199c975b240fb),
                background: {
                    color: 'status-critical',
                    opacity: 'weak'
                },
                color: 'status-critical',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            warning: {
                icon: (0, $b90cae8b1dd80e4e$export$ead8eef644cb6ffc),
                background: {
                    color: 'status-warning',
                    opacity: 'weak'
                },
                color: 'status-warning',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            normal: {
                icon: (0, $e82314c0e829446b$export$a09254dff7a942de),
                background: {
                    color: 'status-ok',
                    opacity: 'weak'
                },
                color: 'status-ok',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            info: {
                icon: (0, $8943ffd4a7fe1a81$export$7036cd8426a1245b),
                background: 'background-contrast',
                color: 'text-strong',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            unknown: {
                icon: (0, $cf8d6a20ce9c71c6$export$525b879776bb0ada),
                background: {
                    color: 'status-unknown',
                    opacity: 'weak'
                },
                color: 'status-unknown',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            // deprecate "undefined" in v3
            // and if undefined, no icon
            undefined: {
                icon: (0, $cf8d6a20ce9c71c6$export$525b879776bb0ada),
                // background: undefined,
                color: 'status-unknown'
            }
        },
        page: {
            wide: {
                alignSelf: 'center',
                width: {
                    min: 'medium',
                    max: 'xxlarge'
                },
                small: {
                    pad: {
                        horizontal: 'large'
                    }
                },
                medium: {
                    pad: {
                        horizontal: 'medium'
                    }
                },
                large: {
                    pad: {
                        horizontal: 'large'
                    }
                }
            },
            narrow: {
                alignSelf: 'center',
                width: {
                    min: 'medium',
                    max: 'large'
                },
                small: {
                    pad: {
                        horizontal: 'large'
                    }
                },
                medium: {
                    pad: {
                        horizontal: 'medium'
                    }
                },
                large: {
                    pad: {
                        horizontal: 'large'
                    }
                }
            },
            full: {
                alignSelf: 'start',
                width: {
                    min: 'medium',
                    max: '100%'
                },
                small: {
                    pad: {
                        horizontal: 'large'
                    }
                },
                medium: {
                    pad: {
                        horizontal: 'medium'
                    }
                },
                large: {
                    pad: {
                        horizontal: 'large'
                    }
                }
            }
        },
        pageHeader: {
            actions: {
                // any box props
                align: 'end'
            },
            pad: {
                top: 'large',
                bottom: 'medium'
            },
            parent: {
                // any box props
                align: 'start'
            },
            responsive: {
                actions: {
                    // any box props
                    align: 'start',
                    pad: {
                        top: 'small'
                    }
                },
                areas: [
                    [
                        'parent'
                    ],
                    [
                        'title'
                    ],
                    [
                        'subtitle'
                    ],
                    [
                        'actions'
                    ]
                ],
                breakpoints: [
                    'small'
                ],
                columns: [
                    'auto'
                ],
                rows: [
                    'auto'
                ]
            },
            subtitle: {
                // any paragraph props
                margin: 'none'
            },
            title: {
                // any heading props
                margin: 'none',
                fill: true
            },
            size: {
                small: {
                    pad: {
                        top: 'medium',
                        bottom: 'small'
                    },
                    subtitle: {
                        size: 'small'
                    },
                    title: {
                        size: 'small'
                    }
                },
                // medium: {
                //   // pad: undefined,
                //   // subtitle: {},
                //   // title: {},
                // },
                large: {
                    pad: {
                        top: 'xlarge',
                        bottom: 'large'
                    },
                    subtitle: {
                        size: 'large'
                    },
                    title: {
                        size: 'large'
                    }
                }
            },
            small: {
                areas: [
                    [
                        'parent',
                        'parent'
                    ],
                    [
                        'title',
                        'actions'
                    ],
                    [
                        'subtitle',
                        'actions'
                    ]
                ],
                columns: [
                    [
                        'small',
                        'flex'
                    ],
                    'auto'
                ],
                rows: [
                    'auto',
                    'auto',
                    'auto'
                ],
                gap: {
                    row: 'xsmall',
                    column: 'large'
                }
            },
            medium: {
                areas: [
                    [
                        'parent',
                        'parent'
                    ],
                    [
                        'title',
                        'actions'
                    ],
                    [
                        'subtitle',
                        'actions'
                    ]
                ],
                columns: [
                    [
                        'medium',
                        'flex'
                    ],
                    'auto'
                ],
                rows: [
                    'auto',
                    'auto',
                    'auto'
                ],
                gap: {
                    row: 'xsmall',
                    column: 'medium'
                }
            },
            large: {
                areas: [
                    [
                        'parent',
                        'parent'
                    ],
                    [
                        'title',
                        'actions'
                    ],
                    [
                        'subtitle',
                        'actions'
                    ]
                ],
                columns: [
                    [
                        'medium',
                        'flex'
                    ],
                    'auto'
                ],
                rows: [
                    'auto',
                    'auto',
                    'auto'
                ],
                gap: {
                    row: 'xsmall',
                    column: 'large'
                }
            }
        },
        pagination: {
            button: {
                active: {
                    background: {
                        color: 'active-background'
                    }
                },
                color: 'text-strong',
                hover: {
                    background: {
                        color: 'background-contrast'
                    },
                    color: undefined
                },
                size: {
                    small: {
                        border: {
                            radius: baseSpacing / 8 + "px",
                            // 3
                            width: '2px'
                        },
                        pad: {
                            vertical: "4px",
                            horizontal: "4px"
                        },
                        font: $182c1f23b2371be0$var$_extends({}, fontSizing(-1)),
                        height: baseSpacing * 1.25 + "px",
                        width: baseSpacing * 1.25 + "px"
                    },
                    medium: {
                        border: {
                            radius: baseSpacing / 6 + "px",
                            // 4
                            width: '2px'
                        },
                        pad: {
                            vertical: "4px",
                            horizontal: "4px"
                        },
                        font: $182c1f23b2371be0$var$_extends({}, fontSizing(0)),
                        height: baseSpacing * 1.5 + "px",
                        width: baseSpacing * 1.5 + "px"
                    },
                    large: {
                        border: {
                            radius: baseSpacing / 4 + "px",
                            // 6
                            width: '2px'
                        },
                        pad: {
                            vertical: "4px",
                            horizontal: "4px"
                        },
                        font: $182c1f23b2371be0$var$_extends({}, fontSizing(1)),
                        height: baseSpacing * 2 + "px",
                        width: baseSpacing * 2 + "px"
                    }
                }
            },
            container: {
                gap: {
                    column: 'xsmall',
                    row: 'small'
                }
            },
            controls: {
                align: 'center',
                direction: 'row',
                gap: 'xxsmall',
                margin: 'none',
                pad: 'none'
            },
            icons: {
                // color: undefined,
                next: (0, $395d1107a5183b93$export$b820fc49f2736e85),
                previous: (0, $2ce319e09672cf9d$export$a499fb457891d86e)
            },
            step: {
                container: {
                    gap: 'xsmall'
                }
            }
        },
        paragraph: {
            font: {
            },
            small: $182c1f23b2371be0$var$_extends({}, fontSizing(-1)),
            medium: $182c1f23b2371be0$var$_extends({}, fontSizing(0)),
            large: $182c1f23b2371be0$var$_extends({}, fontSizing(1)),
            xlarge: $182c1f23b2371be0$var$_extends({}, fontSizing(2)),
            xxlarge: $182c1f23b2371be0$var$_extends({}, fontSizing(4)),
            skeleton: {
                gap: 'xsmall'
            }
        },
        thumbsRating: {
        },
        spinner: {
            container: {
                animation: 'rotateRight',
                color: 'brand',
                pad: 'small',
                round: 'full',
                size: 'small'
            },
            // icon: undefined
            responsive: true,
            size: {
                xsmall: baseSpacing * 0.75 + "px",
                small: baseSpacing + "px",
                // default 24
                medium: baseSpacing * 2 + "px",
                large: baseSpacing * 3 + "px",
                xlarge: baseSpacing * 4 + "px"
            }
        },
        radioButton: {
            border: {
                color: {
                    dark: 'rgba(255, 255, 255, 0.5)',
                    light: 'rgba(0, 0, 0, 0.15)'
                },
                width: '2px'
            },
            // background: {
            //   color: undefined,
            // },
            check: {
                radius: '100%'
            },
            // color: undefined,
            hover: {
                // background: {
                //   color: undefined,
                // },
                border: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    }
                }
            },
            icon: {
            },
            icons: {
            },
            gap: 'small',
            size: baseSpacing + "px",
            font: {
            },
            container: {
            }
        },
        radioButtonGroup: {
            // any box props
            container: {
                gap: 'small'
            }
        },
        rangeInput: {
            disabled: {
                opacity: 0.3
            },
            // extend: undefined
            track: {
                height: '4px',
                color: 'border'
            },
            thumb: {
            }
        },
        rangeSelector: {
            background: {
                invert: {
                    color: 'light-4'
                }
            },
            edge: {
            },
            label: {
                margin: {
                    horizontal: 'small'
                }
            }
        },
        select: {
            // background: undefined,
            clear: {
                container: {
                    pad: 'small',
                    background: 'background-contrast'
                },
                // any box props
                text: {
                    color: 'text-weak'
                } // any text props
            },
            container: {
            },
            control: {
            },
            // emptySearchMessage: {
            //   container: {}, // any box props
            //   text: {}, // any text props
            // },
            icons: {
                // color: { dark: undefined, light: undefined },
                margin: {
                    horizontal: 'small'
                },
                down: (0, $08156255a6733056$export$cd1a8f5a55d5e9d3)
            },
            // listbox: {
            //   extend: undefined,
            // },
            options: {
                container: {
                    align: 'start',
                    pad: 'small'
                },
                text: {
                    margin: 'none'
                }
            },
            search: {
                pad: 'xsmall'
            },
            // searchInput: undefined,
            step: 20
        },
        selectMultiple: {
            help: {
                container: {
                    pad: 'xsmall'
                }
            },
            maxInline: 5,
            // listbox: {
            //   extend: () => undefined,
            // },
            option: {
                pad: 'xsmall'
            },
            search: {
                pad: 'xsmall'
            },
            showMore: {
                pad: {
                    horizontal: 'small',
                    bottom: 'small',
                    top: 'xsmall'
                }
            },
            summary: {
                gap: 'small',
                height: {
                    min: 'xxsmall'
                },
                pad: 'xsmall',
                showSelectedInline: {
                    pad: {
                        left: 'xsmall',
                        vertical: 'xsmall'
                    }
                }
            }
        },
        sidebar: {
            gap: 'large',
            pad: 'small'
        },
        skeleton: {
            border: false,
            colors: {
                dark: [
                    'background',
                    'background-front'
                ],
                light: [
                    'background',
                    'background-back'
                ]
            }
        },
        skipLinks: {
            position: 'top',
            container: {
                elevation: 'large',
                round: 'small',
                pad: 'medium'
            },
            label: {
                margin: {
                    bottom: 'medium'
                },
                size: 'medium'
            }
        },
        starRating: {
        },
        tab: {
            active: {
                color: 'text'
            },
            // background: undefined,
            border: {
                side: 'bottom',
                size: 'small',
                color: {
                    dark: 'accent-1',
                    light: 'brand'
                },
                active: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    }
                },
                disabled: {
                },
                hover: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    }
                }
            },
            color: 'control',
            // disabled: {
            //   color: undefined,
            // },
            // extend: undefined,
            gap: 'small',
            hover: {
                // background: undefined,
                // extend: undefined,
                color: {
                    dark: 'white',
                    light: 'black'
                }
            },
            margin: {
                vertical: 'xxsmall',
                horizontal: 'small'
            },
            pad: {
                bottom: 'xsmall'
            }
        },
        tabs: {
            // background: undefined,
            // extend: undefined,
            // gap: undefined,
            header: {
                // alignSelf: undefined,
                // background: undefined,
                // border: {
                //   side: undefined,
                //   size: undefined,
                //   style: undefined,
                //   color: undefined,
                // },
                // extend: undefined,
                nextButton: {
                    // icon: undefined,
                    pad: {
                        horizontal: 'small',
                        vertical: 'xsmall'
                    }
                },
                previousButton: {
                    // icon: undefined,
                    pad: {
                        horizontal: 'small',
                        vertical: 'xsmall'
                    }
                }
            },
            panel: {
            },
            step: {
                small: 1,
                medium: 3,
                large: 3
            }
        },
        stepper: {
            indicator: {
                size: 'medium',
                // 'small' | 'medium' | 'large'
                border: {
                    width: '2px'
                }
            },
            label: {
                size: 'medium',
                substep: {
                    size: 'small'
                }
            },
            connector: {
                stroke: {
                    width: '2px'
                }
            },
            description: {
                size: 'small',
                color: 'text-weak'
            },
            helperText: {
                size: 'xsmall',
                color: 'text-weak'
            },
            // States: [component].[state].[element].[property]
            pending: {
                indicator: {
                    background: 'background-front',
                    color: 'text-strong',
                    border: 'text-xweak',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        background: 'background-front',
                        border: 'text-strong'
                    }
                },
                label: {
                    color: 'text'
                },
                connector: {
                    color: 'border'
                }
            },
            current: {
                indicator: {
                    icon: (0, $e82314c0e829446b$export$a09254dff7a942de),
                    iconSize: 'medium',
                    background: 'brand',
                    color: 'white',
                    border: 'brand',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        color: 'white'
                    }
                },
                label: {
                    color: {
                        dark: 'text-strong',
                        light: 'brand'
                    }
                }
            },
            currentCompleted: {
                indicator: {
                    icon: (0, $7aaaa7abc2375846$export$dec84e69d20720b4),
                    iconSize: 'medium',
                    background: 'brand',
                    color: 'white',
                    border: 'brand',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        color: 'white'
                    }
                },
                label: {
                    color: {
                        dark: 'text-strong',
                        light: 'brand'
                    }
                }
            },
            completed: {
                indicator: {
                    icon: (0, $7aaaa7abc2375846$export$dec84e69d20720b4),
                    iconSize: 'medium',
                    background: 'background-front',
                    color: 'brand',
                    border: 'brand',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        background: 'background-front'
                    }
                },
                label: {
                    color: 'text-weak'
                },
                connector: {
                    color: 'brand'
                }
            },
            error: {
                indicator: {
                    icon: (0, $845b68b8616c04e1$export$32f199c975b240fb),
                    background: 'background-front',
                    color: 'status-critical',
                    border: 'status-critical',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        background: 'background-front'
                    }
                },
                label: {
                    color: 'text'
                },
                connector: {
                    color: 'status-critical'
                },
                helperText: {
                    color: 'status-critical'
                }
            },
            currentError: {
                indicator: {
                    icon: (0, $845b68b8616c04e1$export$32f199c975b240fb),
                    background: 'status-critical',
                    color: 'white',
                    border: 'status-critical',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        color: 'white'
                    }
                },
                label: {
                    color: 'status-critical'
                }
            },
            disabled: {
                indicator: {
                    background: 'background-contrast',
                    color: 'text-weak',
                    border: 'border',
                    substep: {
                        iconSize: 'small'
                    }
                },
                label: {
                    color: 'text-weak'
                },
                connector: {
                    color: 'border'
                }
            }
        },
        table: {
            caption: {
                margin: {
                    bottom: 'xxsmall'
                }
            },
            header: {
                align: 'start',
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                },
                border: 'bottom'
            },
            body: {
                align: 'start',
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                }
            },
            // row: {
            //   hover: {
            //     background: undefined,
            //     color: undefined,
            //   },
            // },
            footer: {
                align: 'start',
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                },
                border: 'top'
            }
        },
        tag: {
            // background: undefined,
            border: true,
            // hover: {
            //   background: undefined,
            //   border: undefined,
            // },
            round: 'large',
            // name: undefined,
            pad: {
                horizontal: 'small',
                vertical: 'xsmall'
            },
            remove: {
                margin: {
                    right: 'xsmall'
                }
            },
            separator: ' : ',
            size: {
                xsmall: {
                    pad: {
                        horizontal: baseSpacing / 3 + "px",
                        vertical: 'xxsmall'
                    },
                    icon: {
                        size: baseSpacing * 0.75 + "px"
                    }
                },
                small: {
                    pad: {
                        horizontal: baseSpacing * 0.4 + "px",
                        vertical: 'xxsmall'
                    },
                    icon: {
                        size: baseSpacing * 0.75 + "px"
                    }
                },
                large: {
                    pad: {
                        horizontal: baseSpacing / 3 * 2 + "px",
                        vertical: "xsmall"
                    },
                    icon: {
                        size: baseSpacing * 1.25 + "px"
                    }
                },
                xlarge: {
                    pad: {
                        horizontal: baseSpacing * 0.75 + "px",
                        vertical: 'xsmall'
                    },
                    icon: {
                        size: baseSpacing * 1.5 + "px"
                    }
                }
            },
            value: {
                weight: 600
            },
            icons: {
                remove: (0, $da76b8daacd39c4f$export$fe20cfcdd41aa0ef)
            }
        },
        text: {
            font: {
            },
            xsmall: $182c1f23b2371be0$var$_extends({}, fontSizing(-1.5)),
            small: $182c1f23b2371be0$var$_extends({}, fontSizing(-1)),
            medium: $182c1f23b2371be0$var$_extends({}, fontSizing(0)),
            // 18px
            large: $182c1f23b2371be0$var$_extends({}, fontSizing(1)),
            // 22px
            xlarge: $182c1f23b2371be0$var$_extends({}, fontSizing(2)),
            xxlarge: $182c1f23b2371be0$var$_extends({}, fontSizing(4)),
            '2xl': $182c1f23b2371be0$var$_extends({}, fontSizing(4)),
            '3xl': $182c1f23b2371be0$var$_extends({}, fontSizing(6)),
            '4xl': $182c1f23b2371be0$var$_extends({}, fontSizing(9)),
            '5xl': $182c1f23b2371be0$var$_extends({}, fontSizing(13)),
            '6xl': $182c1f23b2371be0$var$_extends({}, fontSizing(18)),
            skeleton: {
                width: {
                    width: '100px',
                    min: '100px'
                },
                margin: {
                    vertical: 'xsmall'
                },
                colors: {
                    dark: [
                        'border',
                        'border'
                    ],
                    light: [
                        'background-front',
                        'background-back'
                    ]
                }
            }
        },
        textArea: {
        },
        textInput: {
        },
        timeInput: {
            button: {
                margin: {
                    right: 'small'
                }
            },
            container: {
                round: 'xxsmall'
            },
            active: {
                background: 'active-background',
                pad: 'xxsmall',
                indicator: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    },
                    size: 'small'
                }
            },
            drop: {
                option: {
                    // background: undefined,
                    hover: {
                        background: 'active-background'
                    },
                    selected: {
                        background: 'selected',
                        color: 'white',
                        hover: {
                        }
                    }
                }
            },
            icon: {
            }
        },
        tip: {
            content: {
                // any Box props
                background: 'background-contrast',
                elevation: 'small',
                margin: 'xsmall',
                pad: {
                    vertical: 'xsmall',
                    horizontal: 'small'
                },
                round: 'small'
            },
            drop: {
                // any props for the drop
                align: {
                    top: 'bottom'
                },
                // most common use case is Header with Buttons
                background: 'none',
                elevation: 'none',
                margin: 'none'
            }
        },
        toggleGroup: {
            button: {
                // border: {
                //   radius: undefined,
                // }
                // iconOnly: {
                //   pad: undefined,
                // },
                // kind: undefined,
                pad: {
                    horizontal: '11px',
                    vertical: '11px'
                }
            },
            container: {
                round: 'xsmall',
                border: true
            },
            divider: {
                color: 'border'
            }
        },
        toolbar: {
            small: {
                gap: 'small'
            },
            gap: 'small'
        },
        video: {
            captions: {
                background: 'rgba(0, 0, 0, 0.7)'
            },
            // controls: { background: undefined },
            icons: {
                closedCaption: (0, $173838d506ca9170$export$237eddafb41f13f6),
                configure: (0, $1de8541bdd93d251$export$b52183d5cfb26dc9),
                fullScreen: (0, $210911c17625cb22$export$49bd1dfb0ad29c40),
                pause: (0, $e751bc12b719d8f4$export$59704c468e1a1527),
                play: (0, $82c01c28d93e7046$export$480db61f4dcd7727),
                reduceVolume: (0, $f6223518e88a1b05$export$679a525edce53a0a),
                volume: (0, $230d45e2108d7875$export$dde279e52d625429),
                description: (0, $2504912870405b96$export$c92b43e49fa6c65b)
            },
            scrubber: {
                color: 'light-4',
                interval: 10,
                // track: { color: undefined }
                thickness: 'small'
            },
            time: {
                container: {
                    pad: {
                        horizontal: 'small'
                    }
                }
            }
        },
        worldMap: {
            color: 'light-3',
            continent: {
                active: '8px',
                base: '6px'
            },
            hover: {
                color: 'light-4'
            },
            place: {
                active: '20px',
                base: '8px'
            }
        }
    });
    return (0, $cdf577e3272e3992$export$7e32b29e1cb162e1)(result);
};
var $182c1f23b2371be0$export$e2253033e6e1df16 = $182c1f23b2371be0$export$80d376111cc09ad7(24);



var $iA1nz = parcelRequire("iA1nz");

var $iA1nz = parcelRequire("iA1nz");

var $8Fliv = parcelRequire("8Fliv");




var $73ba8e2d301b823f$export$373e75d802fd707 = {
    shouldForwardProp: (0, $8Fliv.default)
};
var $73ba8e2d301b823f$export$360b744af11007ac = (0, $iA1nz.css)([
    "font-family:",
    ";font-size:",
    ";line-height:",
    ";font-weight:",
    ";",
    " ",
    " box-sizing:border-box;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;"
], function(props) {
    return props.theme.global.font.family;
}, function(props) {
    return props.theme.global.font.size;
}, function(props) {
    return props.theme.global.font.height;
}, function(props) {
    return props.theme.global.font.weight;
}, function(props) {
    return props.theme.global.font.variant && "\n    font-variant:" + props.theme.global.font.variant + ";\n  ";
}, function(props) {
    return !props.plain && (0, $0b4a347e23c22183$export$e43a4f0de05cb7e9)(props.theme.baseBackground, props.theme);
});
var $73ba8e2d301b823f$export$717407de81592eca = (0, $iA1nz.css)([
    "border:",
    " solid ",
    ";border-radius:",
    ";"
], function(props) {
    return props.theme.global.control.border.width;
}, function(props) {
    return (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.theme.global.control.border.color || 'border', props.theme);
}, function(props) {
    return props.theme.global.control.border.radius;
});
var $73ba8e2d301b823f$export$944a9710f9445eee = function edgeStyle(kind, data, responsive, responsiveBreakpoint, theme) {
    var breakpoint = (0, $5b8209df25a8ed95$export$56780e7bbaff61f9)(theme, responsiveBreakpoint);
    if (typeof data === 'string') {
        var value = theme.global.edgeSize[data] || data;
        var responsiveValue = responsive && breakpoint && breakpoint.edgeSize[data];
        return (0, $iA1nz.css)([
            "",
            ":",
            ";",
            ";"
        ], kind, value, responsiveValue ? (0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "\n        " + kind + ": " + responsiveValue + ";\n      ", responsive) : '');
    }
    var result = [];
    var horizontal = data.horizontal, vertical = data.vertical, top = data.top, bottom = data.bottom, left = data.left, right = data.right;
    // if horizontal and vertical are equal OR all sides are equal,
    // we can just return a single css value such as padding: 12px
    // instead of breaking out by sides.
    var horizontalVerticalEqual = horizontal && vertical && horizontal === vertical;
    var allSidesEqual = top && bottom && left && right && top === bottom === left === right;
    if (horizontalVerticalEqual || allSidesEqual) {
        // since the values will be the same between vertical & horizontal OR
        // left, right, top, & bottom, we can just choose one
        var allSidesValue = horizontalVerticalEqual ? horizontal : top;
        var allSidesResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[allSidesValue];
        return (0, $iA1nz.css)([
            "",
            ":",
            ";",
            ";"
        ], kind, theme.global.edgeSize[allSidesValue] || allSidesValue, allSidesResponsiveValue ? (0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "\n        " + kind + ": " + allSidesResponsiveValue + ";\n      ", responsive) : '');
    }
    if (horizontal) {
        var horizontalResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[horizontal];
        result.push((0, $iA1nz.css)([
            "",
            "-left:",
            ";",
            "-right:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[horizontal] || horizontal, kind, theme.global.edgeSize[horizontal] || horizontal, horizontalResponsiveValue ? (0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "\n          " + kind + "-left: " + horizontalResponsiveValue + ";\n          " + kind + "-right: " + horizontalResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (vertical) {
        var verticalResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[vertical];
        result.push((0, $iA1nz.css)([
            "",
            "-top:",
            ";",
            "-bottom:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[vertical] || vertical, kind, theme.global.edgeSize[vertical] || vertical, verticalResponsiveValue ? (0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "\n          " + kind + "-top: " + verticalResponsiveValue + ";\n          " + kind + "-bottom: " + verticalResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (top) {
        var topResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[top];
        result.push((0, $iA1nz.css)([
            "",
            "-top:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[top] || top, topResponsiveValue ? (0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "\n          " + kind + "-top: " + topResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (bottom) {
        var bottomResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[bottom];
        result.push((0, $iA1nz.css)([
            "",
            "-bottom:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[bottom] || bottom, bottomResponsiveValue ? (0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "\n          " + kind + "-bottom: " + bottomResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (left) {
        var leftResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[left];
        result.push((0, $iA1nz.css)([
            "",
            "-left:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[left] || left, leftResponsiveValue ? (0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "\n          " + kind + "-left: " + leftResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (right) {
        var rightResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[right];
        result.push((0, $iA1nz.css)([
            "",
            "-right:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[right] || right, rightResponsiveValue ? (0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "\n          " + kind + "-right: " + rightResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (data.start) {
        var startResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[data.start];
        result.push((0, $iA1nz.css)([
            "",
            "-inline-start:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[data.start] || data.start, startResponsiveValue ? (0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "\n          " + kind + "-inline-start: " + startResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (data.end) {
        var endResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[data.end];
        result.push((0, $iA1nz.css)([
            "",
            "-inline-end:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[data.end] || data.end, endResponsiveValue ? (0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "\n          " + kind + "-inline-end: " + endResponsiveValue + ";\n        ", responsive) : ''));
    }
    return result;
};
var $73ba8e2d301b823f$export$7d12e60b29024244 = function fillStyle(fillProp) {
    if (fillProp === 'horizontal') return 'width: 100%;';
    if (fillProp === 'vertical') return 'height: 100%;';
    if (fillProp) return "\n      width: 100%;\n      height: 100%;\n    ";
    return undefined;
};
var $73ba8e2d301b823f$var$focusStyles = function focusStyles(props, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, forceOutline = _ref.forceOutline, justBorder = _ref.justBorder, insetFocus = _ref.inset;
    var generateFocusStyle = function generateFocusStyle(focus) {
        var compoundFocusStyle = '';
        if (!focus || forceOutline && !focus.outline) {
            var color = (0, $11317b0e49e0d157$export$4cde5df63f53f473)('focus', props.theme);
            if (color) return "outline: 2px solid " + color + ";";
            return ''; // native
        }
        if (focus.outline && (!focus.border || !justBorder)) {
            if (typeof focus.outline === 'object') {
                var _color = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(focus.outline.color || 'focus', props.theme);
                var size = focus.outline.size || '2px';
                var offset = focus.outline.offset || '0px';
                var outlineStyle = "\n        outline-offset: " + offset + ";\n        outline: " + size + " solid " + _color + ";\n      ";
                compoundFocusStyle += outlineStyle;
                if (!focus.twoColor) return outlineStyle;
            } else {
                var _outlineStyle = "outline: " + focus.outline + ";";
                compoundFocusStyle += _outlineStyle;
                if (!focus.twoColor) return _outlineStyle;
            }
        }
        if (focus.shadow && (!focus.border || !justBorder)) {
            if (typeof focus.shadow === 'object') {
                var _color2 = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(// If there is a focus.border.color, use that for shadow too.
                // This is for backwards compatibility in v2.
                focus.border && focus.border.color || focus.shadow.color || 'focus', props.theme);
                var _size = focus.shadow.size || '2px'; // backwards compatible default
                var blur = focus.shadow.blur || _size; // backwards compatible default
                var inset = focus.shadow.inset ? 'inset ' : '';
                var shadowStyle = "box-shadow: 0 0 " + blur + " " + _size + " " + _color2 + (inset ? " " + inset : '') + ";";
                compoundFocusStyle += shadowStyle;
                if (!focus.twoColor) return "\n        outline: none;\n      " + shadowStyle;
            } else {
                var _shadowStyle = "box-shadow: " + focus.shadow + ";";
                compoundFocusStyle += _shadowStyle;
                if (!focus.twoColor) return "outline: none; " + _shadowStyle;
            }
        }
        if (focus.border) {
            var _color3 = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(focus.border.color || 'focus', props.theme);
            var borderStyle = "border-color: " + _color3 + ";";
            compoundFocusStyle += borderStyle;
            if (!focus.twoColor) return "outline: none; " + borderStyle;
        }
        if (focus.twoColor && compoundFocusStyle.length) return compoundFocusStyle;
        return ''; // defensive
    };
    if (insetFocus && props.theme.global.focus.inset) return generateFocusStyle(props.theme.global.focus.inset);
    return generateFocusStyle(props.theme.global.focus);
};
var $73ba8e2d301b823f$var$unfocusStyles = function unfocusStyles(props, _temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2, forceOutline = _ref2.forceOutline, justBorder = _ref2.justBorder;
    var focus = props.theme.global.focus;
    var compoundFocusStyle = '';
    if (!focus || forceOutline && !focus.outline) {
        var color = (0, $11317b0e49e0d157$export$4cde5df63f53f473)('focus', props.theme);
        if (color) return "outline: none;";
        return ''; // native
    }
    if (focus.outline && (!focus.border || !justBorder)) {
        if (typeof focus.outline === 'object') {
            var outlineStyle = "\n        outline-offset: 0px;\n        outline: none;\n      ";
            compoundFocusStyle += outlineStyle;
            if (!focus.twoColor) return "\n        outline-offset: 0px;\n        outline: none;\n      ";
        } else {
            var _outlineStyle2 = "outline: none;";
            compoundFocusStyle += _outlineStyle2;
            if (!focus.twoColor) return _outlineStyle2;
        }
    }
    if (focus.shadow && (!focus.border || !justBorder)) {
        if (typeof focus.shadow === 'object') {
            var shadowStyle = "\n        outline: none;\n        box-shadow: none;\n      ";
            compoundFocusStyle += shadowStyle;
            if (!focus.twoColor) return shadowStyle;
        } else {
            var _shadowStyle2 = "\n        outline: none;\n        box-shadow: none;\n      ";
            compoundFocusStyle += _shadowStyle2;
            if (!focus.twoColor) return _shadowStyle2;
        }
    }
    if (focus.border) {
        var borderStyle = "\n      outline: none;\n      border-color: none;\n    ";
        compoundFocusStyle += borderStyle;
        if (!focus.twoColor) return borderStyle;
    }
    if (focus.twoColor && compoundFocusStyle.length) return compoundFocusStyle;
    return ''; // defensive
};
var $73ba8e2d301b823f$export$efbff472cb39d8b = function focusStyle(_temp3) {
    var _ref3 = _temp3 === void 0 ? {} : _temp3, forceOutline = _ref3.forceOutline, inset = _ref3.inset, justBorder = _ref3.justBorder, skipSvgChildren = _ref3.skipSvgChildren;
    return (0, $iA1nz.css)([
        "",
        " ",
        " ",
        ""
    ], function(props) {
        return !skipSvgChildren && "\n  > circle,\n  > ellipse,\n  > line,\n  > path,\n  > polygon,\n  > polyline,\n  > rect {\n    " + $73ba8e2d301b823f$var$focusStyles(props) + "\n  }";
    }, function(props) {
        return $73ba8e2d301b823f$var$focusStyles(props, {
            forceOutline: forceOutline,
            inset: inset,
            justBorder: justBorder
        });
    }, !forceOutline && "\n  ::-moz-focus-inner {\n    border: 0;\n  }\n  ");
};
var $73ba8e2d301b823f$export$525440aaa2c64805 = function unfocusStyle(_temp4) {
    var _ref4 = _temp4 === void 0 ? {} : _temp4, forceOutline = _ref4.forceOutline, justBorder = _ref4.justBorder, skipSvgChildren = _ref4.skipSvgChildren;
    return (0, $iA1nz.css)([
        "",
        " ",
        " ",
        ""
    ], function(props) {
        return !skipSvgChildren && "\n  > circle,\n  > ellipse,\n  > line,\n  > path,\n  > polygon,\n  > polyline,\n  > rect {\n    " + $73ba8e2d301b823f$var$unfocusStyles(props) + "\n  }";
    }, function(props) {
        return $73ba8e2d301b823f$var$unfocusStyles(props, {
            forceOutline: forceOutline,
            justBorder: justBorder
        });
    }, !forceOutline && "\n  ::-moz-focus-inner {\n    border: 0;\n  }\n  ");
};
// For backwards compatibility we need to add back the control border width.
// Based on how grommet was functioning prior to https://github.com/grommet/grommet/pull/3939,
// the padding was subtracting the border width from the theme value, but the
// placeholder was not. Because we're now placing the subtraction into the
// theme itself, we have to add back in the border width here.
// This is used for placeholder/icon in TextInput and MaskedInput.
var $73ba8e2d301b823f$var$adjustPad = function adjustPad(props, value) {
    return (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)((props.theme.global.edgeSize[value] || value) + "px") + (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(props.theme.global.control.border.width + "px") + "px";
};
var $73ba8e2d301b823f$export$c98305b6d8dc560 = function getInputPadBySide(props, side) {
    if (typeof props.theme.global.input.padding !== 'object') {
        var _adjustedPad = $73ba8e2d301b823f$var$adjustPad(props, props.theme.global.input.padding);
        return _adjustedPad;
    }
    var orientation;
    if (side === 'left' || side === 'right') orientation = 'horizontal';
    else if (side === 'top' || side === 'bottom') orientation = 'vertical';
    else orientation = undefined;
    // if individual side isn't available, fallback to the
    // orientation if possible
    var pad = props.theme.global.input.padding[side] || props.theme.global.input.padding[orientation];
    var adjustedPad = $73ba8e2d301b823f$var$adjustPad(props, pad);
    return adjustedPad;
};
var $73ba8e2d301b823f$var$placeholderColor = (0, $iA1nz.css)([
    "color:",
    ";"
], function(props) {
    return (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.theme.global.colors.placeholder, props.theme);
});
var $73ba8e2d301b823f$var$placeholderStyle = (0, $iA1nz.css)([
    "&::-webkit-input-placeholder{",
    ";}&::-moz-placeholder{",
    ";}&:-ms-input-placeholder{",
    ";}"
], $73ba8e2d301b823f$var$placeholderColor, $73ba8e2d301b823f$var$placeholderColor, $73ba8e2d301b823f$var$placeholderColor);
var $73ba8e2d301b823f$var$inputSizeStyle = function inputSizeStyle(props) {
    var data = props.theme.text[props.size];
    if (!data) return (0, $iA1nz.css)([
        "font-size:",
        ";"
    ], props.size);
    return (0, $iA1nz.css)([
        "font-size:",
        ";line-height:",
        ";"
    ], data.size, data.height);
};
var $73ba8e2d301b823f$export$533edcdef9a0af13 = (0, $iA1nz.css)([
    "box-sizing:border-box;",
    " font-family:inherit;border:none;-webkit-appearance:none;background:transparent;color:inherit;width:100%;",
    " ",
    " ",
    " margin:0;",
    " &:focus{",
    ";}",
    " ",
    " ::-webkit-search-decoration{-webkit-appearance:none;}&::-moz-focus-inner{border:none;outline:none;}&:-moz-placeholder,&::-moz-placeholder{opacity:1;}",
    ""
], function(props) {
    var _props$theme$text$pro;
    return "font-size: " + (props.theme.global.input.font.size ? ((_props$theme$text$pro = props.theme.text[props.theme.global.input.font.size]) == null ? void 0 : _props$theme$text$pro.size) || props.theme.global.input.font.size : 'inherit') + ";";
}, function(props) {
    return props.theme.global.input.font.height && "line-height: " + props.theme.global.input.font.height + ";";
}, function(props) {
    return props.theme.global.input.padding && typeof props.theme.global.input.padding !== 'object' ? // just the edgeStyle could remain. Currently, this is needed for
    // backwards compatibility since we are placing the calculation in
    // base.js
    "padding: " + ((0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(props.theme.global.edgeSize[props.theme.global.input.padding] || props.theme.global.input.padding) - (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(props.theme.global.control.border.width)) + "px;" : $73ba8e2d301b823f$export$944a9710f9445eee('padding', props.theme.global.input.padding, props.responsive, props.theme.box.responsiveBreakpoint, props.theme);
}, function(props) {
    return(// for backwards compatibility, check if props.theme.global.input.weight
    (props.theme.global.input.weight || props.theme.global.input.font.weight) && (0, $iA1nz.css)([
        "font-weight:",
        ";"
    ], props.theme.global.input.weight || props.theme.global.input.font.weight));
}, function(props) {
    return props.size && $73ba8e2d301b823f$var$inputSizeStyle(props);
}, function(props) {
    return (!props.plain || props.focusIndicator) && $73ba8e2d301b823f$export$efbff472cb39d8b();
}, $73ba8e2d301b823f$export$717407de81592eca, $73ba8e2d301b823f$var$placeholderStyle, function(props) {
    return props.theme.global.input.extend;
});
var $73ba8e2d301b823f$export$cd595fd57f72dbc4 = (0, $iA1nz.css)([
    "",
    ""
], function(props) {
    var _props$theme, _props$theme$icon;
    var pad = (_props$theme = props.theme) != null && (_props$theme = _props$theme.icon) != null && _props$theme.matchSize ? (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)((_props$theme$icon = props.theme.icon) == null || (_props$theme$icon = _props$theme$icon.size) == null ? void 0 : _props$theme$icon[(props == null ? void 0 : props.size) || 'medium']) + (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(props.theme.global.edgeSize.medium) + "px" : props.theme.global.edgeSize.large;
    return props.reverse ? "padding-right: " + pad + ";" : "padding-left: " + pad + ";";
});
var $73ba8e2d301b823f$export$5938e7adc3ab8d08 = function overflowStyle(overflowProp) {
    if (typeof overflowProp === 'string') return (0, $iA1nz.css)([
        "overflow:",
        ";"
    ], overflowProp);
    return (0, $iA1nz.css)([
        "",
        " ",
        ";"
    ], overflowProp.horizontal && "overflow-x: " + overflowProp.horizontal + ";", overflowProp.vertical && "overflow-y: " + overflowProp.vertical + ";");
};
var $73ba8e2d301b823f$var$ALIGN_SELF_MAP = {
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch',
    baseline: 'baseline'
};
var $73ba8e2d301b823f$export$a157b298d219a801 = (0, $iA1nz.css)([
    "",
    " ",
    " ",
    ""
], function(props) {
    return props.alignSelf && "align-self: " + $73ba8e2d301b823f$var$ALIGN_SELF_MAP[props.alignSelf] + ";";
}, function(props) {
    return props.gridArea && "grid-area: " + props.gridArea + ";";
}, function(props) {
    return props.margin && props.theme.global && $73ba8e2d301b823f$export$944a9710f9445eee('margin', props.margin, props.responsive, props.theme.global.edgeSize.responsiveBreakpoint, props.theme);
});
var $73ba8e2d301b823f$export$adf3fcef8e5e1347 = function disabledStyle(componentStyle) {
    return (0, $iA1nz.css)([
        "opacity:",
        ";cursor:default;"
    ], function(props) {
        return componentStyle || props.theme.global.control.disabled.opacity;
    });
};
var $73ba8e2d301b823f$export$cb60038e9cf9f581 = function sizeStyle(name, value, theme) {
    return (0, $iA1nz.css)([
        "",
        ":",
        ";"
    ], name, theme.global.size[value] || value);
};
var $73ba8e2d301b823f$export$f9510e7ca63c26e5 = (0, $iA1nz.css)([
    "outline:none;border:none;"
]);
var $73ba8e2d301b823f$export$b4ff7c828301ce9f = function elevationStyle(elevation) {
    return (0, $iA1nz.css)([
        "box-shadow:",
        ";"
    ], function(props) {
        return props.theme.global.elevation[props.theme.dark ? 'dark' : 'light'][elevation];
    });
};
var $73ba8e2d301b823f$export$73d7bd5e5b0271ce = function kindPartStyles(obj, theme, colorValue) {
    var styles = [];
    if (obj.padding || obj.pad) {
        // button uses `padding` but other components use Grommet `pad`
        var pad = obj.padding || obj.pad;
        if (pad.vertical || pad.horizontal) styles.push("padding: " + (theme.global.edgeSize[pad.vertical] || pad.vertical || 0) + " " + (theme.global.edgeSize[pad.horizontal] || pad.horizontal || 0) + ";");
        else styles.push("padding: " + (theme.global.edgeSize[pad] || pad || 0) + ";");
    }
    if (obj.background) styles.push((0, $0b4a347e23c22183$export$e43a4f0de05cb7e9)(colorValue || obj.background, theme, obj.color || (Object.prototype.hasOwnProperty.call(obj, 'color') && obj.color === undefined ? false : undefined)));
    else if (obj.color) styles.push("color: " + (0, $11317b0e49e0d157$export$4cde5df63f53f473)(obj.color, theme) + ";");
    if (obj.border) {
        if (obj.border.width) styles.push((0, $iA1nz.css)([
            "border-style:solid;border-width:",
            ";"
        ], obj.border.width));
        if (obj.border.color) styles.push((0, $iA1nz.css)([
            "border-color:",
            ";"
        ], (0, $11317b0e49e0d157$export$4cde5df63f53f473)(!obj.background && colorValue || obj.border.color || 'border', theme)));
        if (obj.border.radius) styles.push((0, $iA1nz.css)([
            "border-radius:",
            ";"
        ], obj.border.radius));
    } else if (obj.border === false) styles.push('border: none;');
    if (colorValue && !obj.border && !obj.background) styles.push("color: " + (0, $11317b0e49e0d157$export$4cde5df63f53f473)(colorValue, theme) + ";");
    if (obj.font) {
        if (obj.font.size) styles.push("font-size: " + (theme.text[obj.font.size].size || obj.font.size) + ";");
        if (obj.font.height) styles.push("line-height: " + obj.font.height + ";");
        if (obj.font.weight) styles.push("font-weight: " + obj.font.weight + ";");
    }
    if (obj.opacity) {
        var opacity = obj.opacity === true ? theme.global.opacity.medium : theme.global.opacity[obj.opacity] || obj.opacity;
        styles.push("opacity: " + opacity + ";");
    }
    if (obj.elevation) styles.push($73ba8e2d301b823f$export$b4ff7c828301ce9f(obj.elevation));
    if (obj.extend) styles.push(obj.extend);
    return styles;
};
var $73ba8e2d301b823f$var$ROUND_MAP = {
    full: '100%'
};
var $73ba8e2d301b823f$export$98483643daf52539 = function roundStyle(data, responsive, theme) {
    var breakpoint = (0, $5b8209df25a8ed95$export$56780e7bbaff61f9)(theme, theme.box.responsiveBreakpoint);
    // fallback to edgeSize for backwards compatibility
    var radius = theme.global.radius ? 'radius' : 'edgeSize';
    var styles = [];
    if (typeof data === 'object') {
        var _breakpoint$radius;
        var size = $73ba8e2d301b823f$var$ROUND_MAP[data.size] || theme.global[radius][data.size || 'medium'] || data.size;
        var responsiveSize = responsive && breakpoint && ((_breakpoint$radius = breakpoint[radius]) == null ? void 0 : _breakpoint$radius[data.size]) && (breakpoint[radius][data.size] || data.size);
        if (data.corner === 'top') {
            styles.push((0, $iA1nz.css)([
                "border-top-left-radius:",
                ";border-top-right-radius:",
                ";"
            ], size, size));
            if (responsiveSize) styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "\n          border-top-left-radius: " + responsiveSize + ";\n          border-top-right-radius: " + responsiveSize + ";\n        ", responsive));
        } else if (data.corner === 'bottom') {
            styles.push((0, $iA1nz.css)([
                "border-bottom-left-radius:",
                ";border-bottom-right-radius:",
                ";"
            ], size, size));
            if (responsiveSize) styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "\n          border-bottom-left-radius: " + responsiveSize + ";\n          border-bottom-right-radius: " + responsiveSize + ";\n        ", responsive));
        } else if (data.corner === 'left') {
            styles.push((0, $iA1nz.css)([
                "border-top-left-radius:",
                ";border-bottom-left-radius:",
                ";"
            ], size, size));
            if (responsiveSize) styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "\n          border-top-left-radius: " + responsiveSize + ";\n          border-bottom-left-radius: " + responsiveSize + ";\n        ", responsive));
        } else if (data.corner === 'right') {
            styles.push((0, $iA1nz.css)([
                "border-top-right-radius:",
                ";border-bottom-right-radius:",
                ";"
            ], size, size));
            if (responsiveSize) styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "\n          border-top-right-radius: " + responsiveSize + ";\n          border-bottom-right-radius: " + responsiveSize + ";\n        ", responsive));
        } else if (data.corner) {
            styles.push((0, $iA1nz.css)([
                "border-",
                "-radius:",
                ";"
            ], data.corner, size));
            if (responsiveSize) styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "\n          border-" + data.corner + "-radius: " + responsiveSize + ";\n        ", responsive));
        } else {
            styles.push((0, $iA1nz.css)([
                "border-radius:",
                ";"
            ], size));
            if (responsiveSize) styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "\n          border-radius: " + responsiveSize + ";\n        ", responsive));
        }
    } else {
        var _theme$global$radius, _breakpoint$radius2;
        var _size2 = data === true ? 'medium' : data;
        styles.push((0, $iA1nz.css)([
            "border-radius:",
            ";"
        ], $73ba8e2d301b823f$var$ROUND_MAP[_size2] || ((_theme$global$radius = theme.global[radius]) == null ? void 0 : _theme$global$radius[_size2]) || _size2));
        var _responsiveSize = responsive && breakpoint && ((_breakpoint$radius2 = breakpoint[radius]) == null ? void 0 : _breakpoint$radius2[_size2]);
        if (_responsiveSize) styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "\n        border-radius: " + _responsiveSize + ";\n      ", responsive));
    }
    return styles;
};
var $73ba8e2d301b823f$var$TEXT_ALIGN_MAP = {
    center: 'center',
    end: 'right',
    justify: 'justify',
    start: 'left'
};
var $73ba8e2d301b823f$export$4fc8e4871b69e1d6 = (0, $iA1nz.css)([
    "text-align:",
    ";"
], function(props) {
    return $73ba8e2d301b823f$var$TEXT_ALIGN_MAP[props.textAlign];
});
var $73ba8e2d301b823f$var$ALIGN_ITEMS_MAP = {
    baseline: 'baseline',
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch'
};
var $73ba8e2d301b823f$export$f530b7ab00e4c68d = (0, $iA1nz.css)([
    "align-items:",
    ";"
], function(props) {
    var _ALIGN_ITEMS_MAP$prop;
    return (_ALIGN_ITEMS_MAP$prop = $73ba8e2d301b823f$var$ALIGN_ITEMS_MAP[props.align]) != null ? _ALIGN_ITEMS_MAP$prop : props.align;
});
var $73ba8e2d301b823f$var$ALIGN_CONTENT_MAP = {
    around: 'space-around',
    baseline: 'baseline',
    between: 'space-between',
    center: 'center',
    evenly: 'space-evenly',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch'
};
var $73ba8e2d301b823f$export$93b5fb4351939c1c = (0, $iA1nz.css)([
    "align-content:",
    ";"
], function(props) {
    var _ALIGN_CONTENT_MAP$pr;
    return (_ALIGN_CONTENT_MAP$pr = $73ba8e2d301b823f$var$ALIGN_CONTENT_MAP[props.alignContent]) != null ? _ALIGN_CONTENT_MAP$pr : props.alignContent;
});
var $73ba8e2d301b823f$var$getSize = function getSize(theme, size) {
    return theme.global.size[size] || size;
};
var $73ba8e2d301b823f$var$widthObjectStyle = function widthObjectStyle(width, theme) {
    var result = [];
    if (width.max) result.push((0, $iA1nz.css)([
        "max-width:",
        ";"
    ], $73ba8e2d301b823f$var$getSize(theme, width.max)));
    if (width.min) result.push((0, $iA1nz.css)([
        "min-width:",
        ";"
    ], $73ba8e2d301b823f$var$getSize(theme, width.min)));
    if (width.width) result.push((0, $iA1nz.css)([
        "width:",
        ";"
    ], $73ba8e2d301b823f$var$getSize(theme, width.width)));
    return result;
};
var $73ba8e2d301b823f$var$widthStringStyle = function widthStringStyle(width, theme) {
    return (0, $iA1nz.css)([
        "width:",
        ";"
    ], $73ba8e2d301b823f$var$getSize(theme, width));
};
var $73ba8e2d301b823f$export$c12f8e3e33f3bef7 = function widthStyle(width, theme) {
    return typeof width === 'object' ? $73ba8e2d301b823f$var$widthObjectStyle(width, theme) : $73ba8e2d301b823f$var$widthStringStyle(width, theme);
};
var $73ba8e2d301b823f$var$heightObjectStyle = function heightObjectStyle(height, theme) {
    var result = [];
    if (height.max) result.push((0, $iA1nz.css)([
        "max-height:",
        ";"
    ], $73ba8e2d301b823f$var$getSize(theme, height.max)));
    if (height.min) result.push((0, $iA1nz.css)([
        "min-height:",
        ";"
    ], $73ba8e2d301b823f$var$getSize(theme, height.min)));
    // backwards compatibile
    if (height.width) result.push((0, $iA1nz.css)([
        "height:",
        ";"
    ], $73ba8e2d301b823f$var$getSize(theme, height.height)));
    if (height.height) result.push((0, $iA1nz.css)([
        "height:",
        ";"
    ], $73ba8e2d301b823f$var$getSize(theme, height.height)));
    return result;
};
var $73ba8e2d301b823f$var$heightStringStyle = function heightStringStyle(height, theme) {
    return (0, $iA1nz.css)([
        "height:",
        ";"
    ], $73ba8e2d301b823f$var$getSize(theme, height));
};
var $73ba8e2d301b823f$export$9f8046d1e2885811 = function heightStyle(height, theme) {
    return typeof height === 'object' ? $73ba8e2d301b823f$var$heightObjectStyle(height, theme) : $73ba8e2d301b823f$var$heightStringStyle(height, theme);
};


var $fec22355ed2f9dce$var$fullStyle = function fullStyle(full) {
    if (full === 'min') return (0, $iA1nz.css)([
        "min-height:100vh;"
    ]);
    return (0, $iA1nz.css)([
        "width:100vw;height:100vh;overflow:auto;"
    ]);
};
var $fec22355ed2f9dce$export$455b75b425a04280 = (0, $iA1nz.default).div.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledGrommet",
    componentId: "sc-19lkkz7-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return !props.plain && (0, $73ba8e2d301b823f$export$360b744af11007ac);
}, function(props) {
    return props.full && $fec22355ed2f9dce$var$fullStyle(props.full);
}, function(props) {
    return props.theme.global.font.face;
}, function(props) {
    return props.theme.grommet.extend;
}, function(props) {
    return props.cssVars && Object.keys(props.theme.global.colors).filter(function(k) {
        return typeof props.theme.global.colors[k] === 'string';
    }).map(function(k) {
        return "--" + k + ": " + props.theme.global.colors[k] + ";";
    }).join('\n');
});



var $2xPiy = parcelRequire("2xPiy");
var $3e3684d130c81252$export$1eeeeda725eeeda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createContext(undefined);
var $3e3684d130c81252$export$79ef40724920756d = function useRoots() {
    // If FocusedContainer is within Grommet React tree, there will be a value
    // from RootsContext. If not, set up a default value that can be passed
    // to drops that might open from within a drop.
    var defaultRoots = (0, $2xPiy.useRef)([]);
    var defaultValue = (0, $2xPiy.useMemo)(function() {
        return {
            roots: defaultRoots
        };
    }, []);
    var existingRoots = (0, $2xPiy.useContext)($3e3684d130c81252$export$1eeeeda725eeeda);
    return {
        contextValue: existingRoots || defaultValue,
        hasRoots: (existingRoots == null ? void 0 : existingRoots.roots) !== undefined
    };
};



var $2xPiy = parcelRequire("2xPiy");
var $cc9e28c6770f7140$export$b709306b005c3ef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createContext({});



var $2xPiy = parcelRequire("2xPiy");
var $8ce858273382c9a0$exports = {};
$8ce858273382c9a0$exports = JSON.parse("{\"button\":{\"busy\":\"button is in a busy state\",\"success\":\"button action succeeded\"},\"calendar\":{\"previousMove\":\"Moved to {date}\",\"previous\":\"Go to {date}\",\"nextMove\":\"Moved to {date}\",\"next\":\"Go to {date}\"},\"cards\":{\"moved\":\"Card moved to position {source} of {target}\",\"reorderHint\":\"Use arrow keys to reorder cards. Changes are applied immediately.\",\"description\":\"sortable card\"},\"carousel\":{\"previous\":\"Go to slide {slide}\",\"next\":\"Go to slide {slide}\",\"jump\":\"Jump to slide {slide}\"},\"dateInput\":{\"openCalendar\":\"Press space to open calendar\",\"enterCalendar\":\"Calendar is open, use arrow keys and enter to select a date.\",\"exitCalendar\":\"Exited calendar dialog\",\"outOfBounds\":\"Date is out of the allowed range. Enter a date between {start} and {end}.\"},\"dataChart\":{\"detailTitle\":\"Data chart\",\"detailFocus\":\"Use the left and right arrow keys to navigate the chart data.\"},\"dataFilters\":{\"clear\":\"Clear filters\",\"heading\":\"Filters\",\"open\":\"Open filters\",\"openSet\":{\"singular\":\"Open filters, {number} filter applied\",\"plural\":\"Open filters, {number} filters applied\"}},\"dataForm\":{\"submit\":\"Apply filters\"},\"dataSearch\":{\"label\":\"Search\",\"open\":\"Open search\"},\"dataSort\":{\"ascending\":\"Ascending\",\"by\":\"Sort by\",\"descending\":\"Descending\",\"direction\":\"Sort direction\",\"open\":\"Open sort\"},\"dataSummary\":{\"filtered\":\"{filteredTotal} results of {total} {items}\",\"filteredSingle\":\"{filteredTotal} result of {total} {items}\",\"items\":\"items\",\"itemsSingle\":\"item\",\"selected\":\"{selected} selected\",\"total\":\"{total} {items}\",\"totalSingle\":\"{total} {items}\"},\"dataTable\":{\"ascending\":\"ascending\",\"collapse\":\"collapse {label}\",\"collapseAll\":\"collapse all\",\"decrease\":\"Decrease {headerText} column width\",\"descending\":\"descending\",\"increase\":\"Increase {headerText} column width\",\"expand\":\"expand {label}\",\"expandAll\":\"expand all\",\"resizerAria\":\"Resize {headerText} column\",\"rows\":\"rows\",\"rowsChanged\":\"Number of rows changed\",\"rowsSingle\":\"row\",\"searchBy\":\"Open search by {property}\",\"total\":\"{total} {rows}\",\"totalSingle\":\"{total} {rows}\"},\"dataTableColumns\":{\"open\":\"Open column selector\",\"order\":\"Order columns\",\"pinned\":\"Column locked, order cannot be changed.\",\"select\":\"Select columns\",\"tip\":\"Manage columns\",\"selectAria\":\"Select which columns to show in the data table\",\"orderAria\":\"Reorder the visible columns in the data table\"},\"dataTableGroupBy\":{\"clear\":\"Clear group\",\"label\":\"Group by\"},\"dataView\":{\"label\":\"View\"},\"fileInput\":{\"alert\":{\"maxFile\":\"Error, {fileName} exceeds {maxFile} files limit.\",\"maxSize\":\"Error, {fileName} exceeds {maxSize} limit.\"},\"browse\":\"browse\",\"dropPrompt\":\"Drop file here or\",\"dropPromptMultiple\":\"Drop files here or\",\"files\":\"files\",\"maxFile\":\"Attach a maximum of {max} files only.\",\"maxSizeSingle\":\"The file is too large. Select a file no larger than {maxSize}.\",\"maxSizeMultiple\":{\"singular\":\"{fileName} file is too large. Select files which are no larger than {maxSize}.\",\"plural\":\"{numOfFiles} files are too large. Select files which are no larger than {maxSize}.\"},\"remove\":\"remove {fileName}\",\"removeAll\":\"remove all\"},\"form\":{\"invalid\":\"invalid\",\"required\":\"required\"},\"formField\":{\"maxCharacters\":{\"remaining\":{\"singular\":\"{number} character left\",\"plural\":\"{number} characters left\"},\"overLimit\":{\"singular\":\"{number} character over limit\",\"plural\":\"{number} characters over limit\"}}},\"input\":{\"readOnlyCopy\":{\"prompt\":\"Copy to clipboard\",\"validation\":\"Copied\"}},\"list\":{\"pinned\":\"Item pinned, order cannot be changed.\"},\"menu\":{\"openMenu\":\"Open Menu\",\"closeMenu\":\"Close Menu\"},\"meter\":{\"bar\":{\"singular\":\"Bar meter with value {meterValue} out of {max}\",\"plural\":\"Bar meter with values {meterValue} out of {max}\"},\"circle\":{\"singular\":\"Circle meter with value {meterValue} out of {max}\",\"plural\":\"Circle meter with values {meterValue} out of {max}\"},\"pie\":{\"singular\":\"Pie meter with value {meterValue} out of {max}\",\"plural\":\"Pie meter with values {meterValue} out of {max}\"},\"semicircle\":{\"singular\":\"Semicircle meter with value {meterValue} out of {max}\",\"plural\":\"Semicircle meter with values {meterValue} out of {max}\"}},\"notification\":{\"close\":\"Dismiss notification\"},\"pagination\":{\"stepLabel\":\"Items per page\",\"summary\":\"Showing {start}-{end} of {total}\",\"summaryNoItems\":\"0 items\"},\"rangeSelector\":{\"lower\":\"Lower Bounds\",\"upper\":\"Upper Bounds\"},\"select\":{\"optionsA11y\":\"list of options\",\"multiple\":\"multiple\",\"searchA11y\":\"Search options\",\"selected\":\"; Selected: {currentSelectedValue}\"},\"selectMultiple\":{\"clearAll\":\"Clear All\",\"clearAllA11y\":\"{selected} options selected. Clear all?\",\"open\":\"Open drop\",\"optionNotSelected\":\"{optionLabel} not selected\",\"optionsA11y\":\"list of options\",\"optionSelected\":\"{optionLabel} selected\",\"search\":\"Search to filter options\",\"selectAll\":\"Select All\",\"selectAllA11y\":\"Select all {total} options\",\"selectDrop\":\"Select dropdown\",\"selected\":\"{selected} selected\",\"selectedOfTotal\":\"{selected} selected of {total}\",\"selectedOptions\":\"Selected options\",\"showMore\":\"+ {remaining} more\",\"summarizedValue\":\"{selected} selected\"},\"skipLinks\":{\"skipTo\":\"Skip To:\"},\"stepper\":{\"progress\":\"Progress\",\"step\":\"Step {step} of {total}: {title}\"},\"tabs\":{\"nextTab\":\"Next Tab\",\"previousTab\":\"Previous Tab\",\"tabContents\":\"Tab Contents\"},\"tag\":{\"removeLabel\":{\"nameAndValue\":\"Remove {name}: {value}\",\"valueOnly\":\"Remove {value}\"}},\"textInput\":{\"enterSelect\":\"(Press Enter to Select)\",\"suggestionsCount\":\"suggestions available\",\"suggestionsExist\":\"This input has suggestions use arrow keys to navigate\",\"suggestionIsOpen\":\"Suggestions drop is open, continue to use arrow keys to navigate\"},\"timeInput\":{\"inputLabel\":\"Time input\",\"chooseTime\":\"Choose time\",\"currentValue\":\"Current time {hour}:{minute}:{second}{period}\",\"activeSection\":\"{section} selected\",\"activeSectionValue\":\"{value} {section}\",\"activePeriodValue\":\"{period} period\",\"openDrop\":\"Press space to open time picker\",\"invalidTime\":\"Invalid time value\",\"sectionHours\":\"hours\",\"sectionMinutes\":\"minutes\",\"sectionSeconds\":\"seconds\",\"sectionMeridiem\":\"meridiem\"},\"video\":{\"audioDescriptions\":\"video audio description\",\"captions\":\"closed captions\",\"closeMenu\":\"close menu\",\"description\":\"video audio description\",\"fullScreen\":\"full screen\",\"progressMeter\":\"video progress\",\"scrubber\":\"scrubber\",\"openMenu\":\"open menu\",\"pauseButton\":\"pause\",\"playButton\":\"play\",\"volumeDown\":\"volume down\",\"volumeUp\":\"volume up\"}}");


// options:
//   id: message id
//   messages: (optional) an object of message overrides
//   values: (optional) currently unused but in the future
//     will be an object with substitution values for
//     positional variables in the message text.
//   defaultMessage: (optional) default message to use if
//     the message isn't found elsewhere.
var $f1ad7bf122eed3b0$export$d9468344d3651243 = function format(options, messages) {
    var _options$id;
    // Message id's are hierarchical. For the component-specific
    // message objects passed as options.messages, just use the last
    // component in the id for backwards compatibility.
    //
    // For overall messages passed to grommet, use the hierarchical
    // id. For that messages object, the messages are in an object
    // hierarchy by component, similar to how the theme works.
    //
    // Applications that typically keep their messages in flat
    // objects with a single key string per message can override
    // this format function to get the grommet messages from
    // their bundles that way and don't need to pass the messages
    // themselves in this property, just the format function.
    var idParts = ((_options$id = options.id) == null ? void 0 : _options$id.split('.')) || [];
    // eslint-disable-next-line no-unsafe-optional-chaining
    var baseId = idParts[(idParts == null ? void 0 : idParts.length) - 1];
    var messageObj = messages;
    idParts.forEach(function(idPart) {
        if (typeof messageObj === 'object') messageObj = messageObj[idPart];
    });
    var message = (options.messages ? options.messages[baseId] : undefined) || messageObj || options.defaultMessage;
    var values = options.values;
    var newMessage = message;
    var tokens = message == null ? void 0 : message.match(/\{(.+?)\}/g);
    tokens == null || tokens.forEach(function(token) {
        var names = token.substr(1, token.length - 2);
        var value = values[names];
        newMessage = newMessage.replace(token, value);
    });
    return values ? newMessage : message;
};
var $f1ad7bf122eed3b0$var$defaultValue = {
    messages: (0, (/*@__PURE__*/$parcel$interopDefault($8ce858273382c9a0$exports))),
    format: function format(options) {
        return $f1ad7bf122eed3b0$export$d9468344d3651243(options, (0, (/*@__PURE__*/$parcel$interopDefault($8ce858273382c9a0$exports))));
    }
};
var $f1ad7bf122eed3b0$export$b060d577040138d8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createContext($f1ad7bf122eed3b0$var$defaultValue);




var $dyr1f = parcelRequire("dyr1f");

var $dyr1f = parcelRequire("dyr1f");
var $ab32ce3df36aa105$export$eb55925152858bde = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string;
var $ab32ce3df36aa105$export$5dd51d61a30477bc = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'baseline',
        'center',
        'end',
        'start',
        'stretch'
    ]),
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
]);
var $ab32ce3df36aa105$var$ANIMATION_TYPE = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
    'fadeIn',
    'fadeOut',
    'jiggle',
    'pulse',
    'rotateLeft',
    'rotateRight',
    'slideUp',
    'slideDown',
    'slideLeft',
    'slideRight',
    'zoomIn',
    'zoomOut'
]);
var $ab32ce3df36aa105$var$ANIMATION_SHAPE = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
    type: $ab32ce3df36aa105$var$ANIMATION_TYPE,
    delay: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ])
});
var $ab32ce3df36aa105$export$6054792fa1afa765 = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
    $ab32ce3df36aa105$var$ANIMATION_TYPE,
    $ab32ce3df36aa105$var$ANIMATION_SHAPE,
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        $ab32ce3df36aa105$var$ANIMATION_TYPE,
        $ab32ce3df36aa105$var$ANIMATION_SHAPE
    ]))
]);
var $ab32ce3df36aa105$export$fc4c368d97afb623 = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        light: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    })
]);
var $ab32ce3df36aa105$export$f8a44c6979fe9fe5 = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        clip: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
                'text'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        color: $ab32ce3df36aa105$export$fc4c368d97afb623,
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        position: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        opacity: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
                'weak',
                'medium',
                'strong'
            ])
        ]),
        repeat: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
                'no-repeat',
                'repeat'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        rotate: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
                'cover',
                'contain'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        light: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    })
]);
var $ab32ce3df36aa105$export$aa372966d47f02af = $ab32ce3df36aa105$export$f8a44c6979fe9fe5;
var $ab32ce3df36aa105$export$7d9f2aeb8f1f7c3f = [
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge'
];
var $ab32ce3df36aa105$export$7ece648387045365 = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'none'
    ].concat($ab32ce3df36aa105$export$7d9f2aeb8f1f7c3f)),
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        bottom: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ab32ce3df36aa105$export$7d9f2aeb8f1f7c3f),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        end: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ab32ce3df36aa105$export$7d9f2aeb8f1f7c3f),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ab32ce3df36aa105$export$7d9f2aeb8f1f7c3f),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        left: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ab32ce3df36aa105$export$7d9f2aeb8f1f7c3f),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        right: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ab32ce3df36aa105$export$7d9f2aeb8f1f7c3f),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        start: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ab32ce3df36aa105$export$7d9f2aeb8f1f7c3f),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        top: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ab32ce3df36aa105$export$7d9f2aeb8f1f7c3f),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        vertical: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ab32ce3df36aa105$export$7d9f2aeb8f1f7c3f),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ])
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
]);
var $ab32ce3df36aa105$var$PAD_SIZES = [
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge'
];
var $ab32ce3df36aa105$export$b91a2ef62736aae3 = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'none'
    ].concat($ab32ce3df36aa105$var$PAD_SIZES)),
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        bottom: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ab32ce3df36aa105$var$PAD_SIZES),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        end: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ab32ce3df36aa105$var$PAD_SIZES),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ab32ce3df36aa105$var$PAD_SIZES),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        left: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ab32ce3df36aa105$var$PAD_SIZES),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        right: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ab32ce3df36aa105$var$PAD_SIZES),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        start: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ab32ce3df36aa105$var$PAD_SIZES),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        top: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ab32ce3df36aa105$var$PAD_SIZES),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        vertical: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ab32ce3df36aa105$var$PAD_SIZES),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ])
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
]);
var $ab32ce3df36aa105$export$ffe37ff34eeb9e21 = {
    a11yTitle: $ab32ce3df36aa105$export$eb55925152858bde,
    alignSelf: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'start',
        'center',
        'end',
        'stretch',
        'baseline'
    ]),
    gridArea: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    margin: $ab32ce3df36aa105$export$7ece648387045365
};
var $ab32ce3df36aa105$export$d9c9382fb5d26cc7 = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'none',
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ]),
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
]);
var $ab32ce3df36aa105$export$e4126213490fff97 = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'background'
    ]),
    $ab32ce3df36aa105$export$f8a44c6979fe9fe5,
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        background: $ab32ce3df36aa105$export$f8a44c6979fe9fe5,
        elevation: $ab32ce3df36aa105$export$d9c9382fb5d26cc7
    })
]);
var $ab32ce3df36aa105$export$fe1f7946fa764688 = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
    'circle',
    'diamond',
    'square',
    'star',
    'triangle',
    'triangleDown'
]);
var $ab32ce3df36aa105$export$4be843ac40f484c6 = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
    'squares',
    'circles',
    'stripesHorizontal',
    'stripesVertical',
    'stripesDiagonalDown',
    'stripesDiagonalUp'
]);
var $ab32ce3df36aa105$export$fcb8c87299e05542 = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge',
        'full'
    ]),
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        corner: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'top',
            'left',
            'bottom',
            'right',
            'top-left',
            'top-right',
            'bottom-left',
            'bottom-right'
        ]),
        size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
                'xsmall',
                'small',
                'medium',
                'large',
                'xlarge'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ])
    })
]);
var $ab32ce3df36aa105$export$d3e0bc3700258305 = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
    dark: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string),
    light: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string)
});
var $ab32ce3df36aa105$export$2f3082f340019e9a = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        animation: $ab32ce3df36aa105$export$6054792fa1afa765,
        colors: $ab32ce3df36aa105$export$d3e0bc3700258305,
        depth: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
        message: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                start: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                end: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            })
        ])
    })
]);
var $ab32ce3df36aa105$var$dimSizeType = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge',
    'xxlarge'
]);
var $ab32ce3df36aa105$export$674efdc47ecf99e9 = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
    $ab32ce3df36aa105$var$dimSizeType,
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        height: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            $ab32ce3df36aa105$var$dimSizeType,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        min: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            $ab32ce3df36aa105$var$dimSizeType,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        max: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            $ab32ce3df36aa105$var$dimSizeType,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ])
    })
]);
var $ab32ce3df36aa105$export$7d45d0e6b7abd5e2 = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
    $ab32ce3df36aa105$var$dimSizeType,
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        width: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            $ab32ce3df36aa105$var$dimSizeType,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        min: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            $ab32ce3df36aa105$var$dimSizeType,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        max: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            $ab32ce3df36aa105$var$dimSizeType,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ])
    })
]);
var $ab32ce3df36aa105$export$5b49d53be3c37c69 = [
    'auto',
    'hidden',
    'scroll',
    'visible'
];


var $4cbda5d5a2a8b3ad$var$PropType = {};
$4cbda5d5a2a8b3ad$var$PropType = {
    background: (0, $ab32ce3df36aa105$export$aa372966d47f02af),
    dir: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'rtl'
    ]),
    full: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'min'
        ])
    ]),
    options: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        box: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            cssGap: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
        }),
        button: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            childrenPlain: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
        }),
        layer: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            singleId: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
        }),
        drop: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            checkContainingBlock: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
        })
    }),
    plain: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    cssVars: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object,
    themeMode: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'dark',
        'light',
        'auto'
    ]),
    userAgent: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    containerTarget: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object,
    messages: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        format: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
        messages: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            button: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                busy: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                success: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            calendar: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                previousMove: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                previous: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                nextMove: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                next: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            cards: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                moved: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                reorderHint: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                description: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            carousel: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                previous: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                next: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                jump: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            dateInput: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                openCalendar: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                enterCalendar: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                exitCalendar: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                outOfBounds: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            dataChart: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                detailTitle: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                detailFocus: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            dataFilters: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                clear: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                heading: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                open: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                openSet: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                    singular: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                    plural: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
                })
            }),
            dataForm: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                submit: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            dataSearch: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                label: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                open: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            dataSort: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                ascending: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                by: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                descending: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                direction: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                open: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            dataSummary: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                filtered: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                filteredSingle: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                items: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                itemsSingle: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                selected: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                total: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                totalSingle: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            dataTable: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                ascending: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                collapse: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                collapseAll: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                decrease: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                descending: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                increase: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                expand: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                expandAll: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                resizerAria: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                rows: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                rowsChanged: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                rowsSingle: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                searchBy: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                total: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                totalSingle: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            dataTableColumns: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                open: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                order: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                pinned: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                select: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                tip: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                selectAria: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                orderAria: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            dataTableGroupBy: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                clear: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                label: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            dataView: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                label: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            fileInput: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                alert: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                    maxFile: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                    maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
                }),
                browse: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                dropPrompt: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                dropPromptMultiple: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                files: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                maxFile: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                maxSizeSingle: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                maxSizeMultiple: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                    singular: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                    plural: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
                }),
                remove: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                removeAll: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            form: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                invalid: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                required: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            formField: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                maxCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                    remaining: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                        singular: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                        plural: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
                    }),
                    overLimit: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                        singular: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                        plural: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
                    })
                })
            }),
            list: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                pinned: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            menu: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                openMenu: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                closeMenu: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            meter: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                bar: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                    singular: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                    plural: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
                }),
                circle: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                    singular: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                    plural: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
                }),
                pie: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                    singular: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                    plural: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
                }),
                semicirlce: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                    singular: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                    plural: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
                })
            }),
            notifcation: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                close: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            pagination: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                stepLabel: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                summary: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                summaryNoItems: $4cbda5d5a2a8b3ad$var$PropType.string
            }),
            rangeSelector: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                lower: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                upper: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            select: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                optionsA11y: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                multiple: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                searchA11y: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                selected: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            selectMultiple: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                clearAll: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                clearAllA11y: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                open: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                optionSelected: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                optionNotSelected: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                optionsA11y: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                search: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                selectAll: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                selectAllA11y: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                selected: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                selectedOfTotal: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                selectDrop: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                selectedOptions: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                showMore: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                summarizedValue: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            skipLinks: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                skipTo: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            stepper: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                progress: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                step: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            tabs: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                nextTab: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                previousTab: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                tabContents: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            tag: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                removeLabel: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                    nameAndValue: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                    valueOnly: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
                })
            }),
            textInput: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                enterSelect: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                suggestionsCount: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                suggestionsExist: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                suggestionIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            timeInput: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                activePeriodValue: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                activeSection: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                activeSectionValue: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                chooseTime: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                currentValue: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                inputLabel: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                invalidTime: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                openDrop: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                sectionHours: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                sectionMeridiem: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                sectionMinutes: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                sectionSeconds: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            }),
            video: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                audioDescriptions: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                captions: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                closeMenu: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                description: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                fullScreen: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                progressMeter: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                scrubber: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                openMenu: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                pauseButton: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                playButton: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                volumeDown: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                volumeUp: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            })
        }),
        onAnalytics: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func
    })
};
var $4cbda5d5a2a8b3ad$export$5d086f0c0fa8cc7a = $4cbda5d5a2a8b3ad$var$PropType;



var $2xPiy = parcelRequire("2xPiy");
var $5bd12fcfcb46b8f6$export$83cd6c3eba7d8d9e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createContext(function() {});
var $5bd12fcfcb46b8f6$export$e955abb82869dc84 = function useAnalytics() {
    return (0, $2xPiy.useContext)($5bd12fcfcb46b8f6$export$83cd6c3eba7d8d9e);
};
var $5bd12fcfcb46b8f6$export$1b581a2ec13e37f1 = function AnalyticsProvider(_ref) {
    var onAnalytics = _ref.onAnalytics, children = _ref.children;
    var lastUrlRef = (0, $2xPiy.useRef)();
    var sendAnalytics = (0, $2xPiy.useCallback)(function(data) {
        return onAnalytics && onAnalytics(data);
    }, [
        onAnalytics
    ]);
    (0, $2xPiy.useEffect)(function() {
        var observer;
        if (onAnalytics) {
            observer = new window.MutationObserver(function() {
                var _window;
                var url = (_window = window) == null || (_window = _window.location) == null ? void 0 : _window.href;
                var previousUrl = lastUrlRef.current;
                if (url !== previousUrl) {
                    lastUrlRef.current = url;
                    sendAnalytics({
                        type: 'pageView',
                        url: url,
                        previousUrl: previousUrl
                    });
                }
            });
            observer.observe(document, {
                subtree: true,
                childList: true
            });
        }
        return function() {
            var _observer;
            return (_observer = observer) == null ? void 0 : _observer.disconnect();
        };
    }, [
        sendAnalytics,
        onAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($5bd12fcfcb46b8f6$export$83cd6c3eba7d8d9e.Provider, {
        value: sendAnalytics
    }, children);
};


var $df54d7f5d50e45c1$var$_excluded = [
    "children",
    "full",
    "containerTarget",
    "theme",
    "options",
    "messages",
    "onAnalytics"
];
function $df54d7f5d50e45c1$var$_extends() {
    return $df54d7f5d50e45c1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $df54d7f5d50e45c1$var$_extends.apply(null, arguments);
}
function $df54d7f5d50e45c1$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $df54d7f5d50e45c1$var$FullGlobalStyle = (0, $iA1nz.createGlobalStyle)([
    "body{margin:0;}"
]);
var $df54d7f5d50e45c1$var$defaultOptions = {};
var $df54d7f5d50e45c1$export$efa1b86658154a31 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    var children = props.children, full = props.full, _props$containerTarge = props.containerTarget, containerTarget = _props$containerTarge === void 0 ? typeof document === 'object' ? document.body : undefined : _props$containerTarge, themeProp = props.theme, _props$options = props.options, options = _props$options === void 0 ? $df54d7f5d50e45c1$var$defaultOptions : _props$options, messagesProp = props.messages, onAnalytics = props.onAnalytics, rest = $df54d7f5d50e45c1$var$_objectWithoutPropertiesLoose(props, $df54d7f5d50e45c1$var$_excluded);
    var background = props.background, dir = props.dir, themeMode = props.themeMode, userAgent = props.userAgent;
    var _useState = (0, $2xPiy.useState)(), stateResponsive = _useState[0], setResponsive = _useState[1];
    var theme = (0, $2xPiy.useMemo)(function() {
        var nextTheme = (0, $cdf577e3272e3992$export$6969335ea1e4e77c)((0, $182c1f23b2371be0$export$e2253033e6e1df16), themeProp || {});
        // if user provides specific menu alignment, we don't want
        // the defaults to be included at all (can cause issues with controlMirror)
        // override merged value with themeProp value
        if (themeProp && themeProp.menu && themeProp.menu.drop && themeProp.menu.drop.align) {
            delete nextTheme.menu.drop.align;
            nextTheme.menu.drop.align = themeProp.menu.drop.align;
        }
        var themeBackground = nextTheme.global.colors.background;
        nextTheme.dark = (themeMode || nextTheme.defaultMode) === 'dark';
        if (themeMode === 'auto' && typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) nextTheme.dark = true;
        var color = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(background || themeBackground, nextTheme);
        nextTheme.dark = (0, $0b4a347e23c22183$export$d285dc898c6a4d11)(color, nextTheme);
        nextTheme.baseBackground = background || themeBackground;
        // This allows DataTable to intelligently set the background of a pinned
        // header or footer.
        nextTheme.background = nextTheme.baseBackground;
        if (dir) nextTheme.dir = dir;
        return nextTheme;
    }, [
        background,
        dir,
        themeMode,
        themeProp
    ]);
    var messages = (0, $2xPiy.useMemo)(function() {
        // combine the passed in messages, if any, with the default
        // messages and format function.
        var nextMessages = (0, $cdf577e3272e3992$export$6969335ea1e4e77c)((0, (/*@__PURE__*/$parcel$interopDefault($8ce858273382c9a0$exports))), (messagesProp == null ? void 0 : messagesProp.messages) || {});
        return {
            messages: nextMessages,
            format: function format(opts) {
                var message = (messagesProp == null ? void 0 : messagesProp.format) && messagesProp.format(opts);
                return typeof message !== 'undefined' ? message : (0, $f1ad7bf122eed3b0$export$d9468344d3651243)(opts, nextMessages);
            }
        };
    }, [
        messagesProp
    ]);
    (0, $2xPiy.useEffect)(function() {
        var onResize = function onResize() {
            var _document$body$client, _document$body;
            setResponsive((0, $5b8209df25a8ed95$export$1eb095b00b926404)((_document$body$client = (_document$body = document.body) == null ? void 0 : _document$body.clientWidth) != null ? _document$body$client : window.innerWidth, theme));
        };
        window.addEventListener('resize', onResize);
        onResize();
        return function() {
            window.removeEventListener('resize', onResize);
        };
    }, [
        theme
    ]);
    var responsive = stateResponsive || (0, $5b8209df25a8ed95$export$f207ad4bd0549009)(userAgent, theme) || theme.global.deviceBreakpoints.tablet;
    var grommetRef = (0, $3cecef11d3b9c451$export$61dc559f8a0b9bcf)(ref);
    // track open FocusedContainers in a global array to manage
    // focus event listeners for trapFocus
    var roots = (0, $2xPiy.useRef)([]);
    (0, $2xPiy.useEffect)(function() {
        if (grommetRef.current) roots.current.push(grommetRef.current);
    }, [
        grommetRef
    ]);
    var rootsContextValue = (0, $2xPiy.useMemo)(function() {
        return {
            roots: roots
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $iA1nz.ThemeContext).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $10007abd86899141$export$51e389dae84ec233).Provider, {
        value: responsive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3e3684d130c81252$export$1eeeeda725eeeda).Provider, {
        value: rootsContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18ec84c72847fc8a$export$64a849364cd772b4).Provider, {
        value: containerTarget
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $cc9e28c6770f7140$export$b709306b005c3ef).Provider, {
        value: options
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $f1ad7bf122eed3b0$export$b060d577040138d8).Provider, {
        value: messages
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $5bd12fcfcb46b8f6$export$1b581a2ec13e37f1), {
        onAnalytics: onAnalytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $fec22355ed2f9dce$export$455b75b425a04280), $df54d7f5d50e45c1$var$_extends({
        full: full
    }, rest, {
        ref: grommetRef
    }), children), full && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($df54d7f5d50e45c1$var$FullGlobalStyle, null))))))));
});
$df54d7f5d50e45c1$export$efa1b86658154a31.displayName = 'Grommet';
$df54d7f5d50e45c1$export$efa1b86658154a31.propTypes = (0, $4cbda5d5a2a8b3ad$export$5d086f0c0fa8cc7a);



var $herDu = parcelRequire("herDu");

var $2xPiy = parcelRequire("2xPiy");
if (!(0, $2xPiy.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $herDu.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");



var $cX5wj = parcelRequire("cX5wj");


var $cX5wj = parcelRequire("cX5wj");

var $herDu = parcelRequire("herDu");
function $77d89eb2aeb15306$export$fb2daceae6f5097a(callback) {
    callback();
}
function $77d89eb2aeb15306$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) {
        reactionScheduler = $77d89eb2aeb15306$export$fb2daceae6f5097a;
        console.warn("[MobX] Failed to get unstable_batched updates from react-dom / react-native");
    }
    (0, $herDu.configure)({
        reactionScheduler: reactionScheduler
    });
}
var $77d89eb2aeb15306$export$13ce1459b9a04b51 = function() {
    console.warn("[MobX] Deprecated");
    return true;
};


var $87c6e9c9a3415ad6$var$deprecatedMessages = [];
function $87c6e9c9a3415ad6$export$be38475be17599d(msg) {
    if (!$87c6e9c9a3415ad6$var$deprecatedMessages.includes(msg)) {
        $87c6e9c9a3415ad6$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}



var $herDu = parcelRequire("herDu");

var $2xPiy = parcelRequire("2xPiy");

var $herDu = parcelRequire("herDu");
function $2f9267fcbdea1be7$export$ef795f1f307682c7(v) {
    return (0, $herDu.getDependencyTree)(v);
}


var $da546f689bf2d40e$var$globalIsUsingStaticRendering = false;
function $da546f689bf2d40e$export$5d52eaa7c0f24c9e(enable) {
    $da546f689bf2d40e$var$globalIsUsingStaticRendering = enable;
}
function $da546f689bf2d40e$export$55979271896d643e() {
    return $da546f689bf2d40e$var$globalIsUsingStaticRendering;
}


var $f622643f4ce17800$export$e901ba0ffe10ba41 = 10000;
var $f622643f4ce17800$export$1ae22ce5a82f26b6 = 10000;
var $f622643f4ce17800$export$b7a00d372cedeedd = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(maxAge) {
                if (maxAge === void 0) maxAge = $f622643f4ce17800$export$e901ba0ffe10ba41;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(target, value, token) {
            this.registrations.set(token, {
                value: value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $f622643f4ce17800$export$1ae22ce5a82f26b6);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var $f622643f4ce17800$export$da5d55a244964b51 = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $f622643f4ce17800$export$b7a00d372cedeedd;


var $eb9973f37456124f$export$10e8a12fbfd8583c = new (0, $f622643f4ce17800$export$da5d55a244964b51)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});


var $f0d31c84c34aaaa3$exports = {};
'use strict';

$f0d31c84c34aaaa3$exports = (parcelRequire("9E7TZ"));


function $b9176ce190a11530$var$createReaction(adm) {
    adm.reaction = new (0, $herDu.Reaction)("observer".concat(adm.name), function() {
        var _a;
        adm.stateVersion = Symbol();
        // onStoreChange won't be available until the component "mounts".
        // If state changes in between initial render and mount,
        // `useSyncExternalStore` should handle that by checking the state version and issuing update.
        (_a = adm.onStoreChange) === null || _a === void 0 || _a.call(adm);
    });
}
function $b9176ce190a11530$export$b9c7ecd090a87b14(render, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $da546f689bf2d40e$export$55979271896d643e)()) return render();
    var admRef = (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).useRef(null);
    if (!admRef.current) {
        // First render
        var adm_1 = {
            reaction: null,
            onStoreChange: null,
            stateVersion: Symbol(),
            name: baseComponentName,
            subscribe: function(onStoreChange) {
                // Do NOT access admRef here!
                (0, $eb9973f37456124f$export$10e8a12fbfd8583c).unregister(adm_1);
                adm_1.onStoreChange = onStoreChange;
                if (!adm_1.reaction) {
                    // We've lost our reaction and therefore all subscriptions, occurs when:
                    // 1. Timer based finalization registry disposed reaction before component mounted.
                    // 2. React "re-mounts" same component without calling render in between (typically <StrictMode>).
                    // We have to recreate reaction and schedule re-render to recreate subscriptions,
                    // even if state did not change.
                    $b9176ce190a11530$var$createReaction(adm_1);
                    // `onStoreChange` won't force update if subsequent `getSnapshot` returns same value.
                    // So we make sure that is not the case
                    adm_1.stateVersion = Symbol();
                }
                return function() {
                    var _a;
                    // Do NOT access admRef here!
                    adm_1.onStoreChange = null;
                    (_a = adm_1.reaction) === null || _a === void 0 || _a.dispose();
                    adm_1.reaction = null;
                };
            },
            getSnapshot: function() {
                // Do NOT access admRef here!
                return adm_1.stateVersion;
            }
        };
        admRef.current = adm_1;
    }
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or reaction was disposed by registry before subscribe
        $b9176ce190a11530$var$createReaction(adm);
        // StrictMode/ConcurrentMode/Suspense may mean that our component is
        // rendered and abandoned multiple times, so we need to track leaked
        // Reactions.
        (0, $eb9973f37456124f$export$10e8a12fbfd8583c).register(admRef, adm, adm);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).useDebugValue(adm.reaction, (0, $2f9267fcbdea1be7$export$ef795f1f307682c7));
    (0, $f0d31c84c34aaaa3$exports.useSyncExternalStore)(// Both of these must be stable, otherwise it would keep resubscribing every render.
    adm.subscribe, adm.getSnapshot, adm.getSnapshot);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var renderResult;
    var exception;
    adm.reaction.track(function() {
        try {
            renderResult = render();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return renderResult;
}





var $2xPiy = parcelRequire("2xPiy");


var $89048ae0dfc4e98d$var$_a, $89048ae0dfc4e98d$var$_b;
var $89048ae0dfc4e98d$var$warnObserverOptionsDeprecated = true;
var $89048ae0dfc4e98d$var$warnLegacyContextTypes = true;
var $89048ae0dfc4e98d$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $89048ae0dfc4e98d$var$isFunctionNameConfigurable = ($89048ae0dfc4e98d$var$_b = ($89048ae0dfc4e98d$var$_a = Object.getOwnPropertyDescriptor(function() {}, "name")) === null || $89048ae0dfc4e98d$var$_a === void 0 ? void 0 : $89048ae0dfc4e98d$var$_a.configurable) !== null && $89048ae0dfc4e98d$var$_b !== void 0 ? $89048ae0dfc4e98d$var$_b : false;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $89048ae0dfc4e98d$var$ReactForwardRefSymbol = $89048ae0dfc4e98d$var$hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, $2xPiy.forwardRef) === "function" && (0, $2xPiy.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $89048ae0dfc4e98d$var$ReactMemoSymbol = $89048ae0dfc4e98d$var$hasSymbol ? Symbol.for("react.memo") : typeof (0, $2xPiy.memo) === "function" && (0, $2xPiy.memo)(function(props) {
    return null;
})["$$typeof"];
function $89048ae0dfc4e98d$export$b6ae1bc530f4c149(baseComponent, // TODO remove in next major
options) {
    var _a;
    if ($89048ae0dfc4e98d$var$warnObserverOptionsDeprecated && options) {
        $89048ae0dfc4e98d$var$warnObserverOptionsDeprecated = false;
        console.warn("[mobx-react-lite] `observer(fn, { forwardRef: true })` is deprecated, use `observer(React.forwardRef(fn))`");
    }
    if ($89048ae0dfc4e98d$var$ReactMemoSymbol && baseComponent["$$typeof"] === $89048ae0dfc4e98d$var$ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $da546f689bf2d40e$export$55979271896d643e)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($89048ae0dfc4e98d$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $89048ae0dfc4e98d$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function(props, ref) {
        return (0, $b9176ce190a11530$export$b9c7ecd090a87b14)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    observerComponent.displayName = baseComponent.displayName;
    if ($89048ae0dfc4e98d$var$isFunctionNameConfigurable) Object.defineProperty(observerComponent, "name", {
        value: baseComponent.name,
        writable: true,
        configurable: true
    });
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) {
        observerComponent.contextTypes = baseComponent.contextTypes;
        if ($89048ae0dfc4e98d$var$warnLegacyContextTypes) {
            $89048ae0dfc4e98d$var$warnLegacyContextTypes = false;
            console.warn("[mobx-react-lite] Support for Legacy Context in function components will be removed in the next major release.");
        }
    }
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $2xPiy.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $2xPiy.memo)(observerComponent);
    $89048ae0dfc4e98d$var$copyStaticProperties(baseComponent, observerComponent);
    Object.defineProperty(observerComponent, "contextTypes", {
        set: function() {
            var _a, _b;
            throw new Error("[mobx-react-lite] `".concat(this.displayName || ((_a = this.type) === null || _a === void 0 ? void 0 : _a.displayName) || ((_b = this.type) === null || _b === void 0 ? void 0 : _b.name) || "Component", ".contextTypes` must be set before applying `observer`."));
        }
    });
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $89048ae0dfc4e98d$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $89048ae0dfc4e98d$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$89048ae0dfc4e98d$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}



function $29d17ff8baff4c9a$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    if (children && render) console.error("MobX Observer: Do not use children and render in the same time in `Observer`");
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $b9176ce190a11530$export$b9c7ecd090a87b14)(component);
}
$29d17ff8baff4c9a$export$c1cbdee04e18ea8b.propTypes = {
    children: $29d17ff8baff4c9a$var$ObserverPropsCheck,
    render: $29d17ff8baff4c9a$var$ObserverPropsCheck
};
$29d17ff8baff4c9a$export$c1cbdee04e18ea8b.displayName = "Observer";
function $29d17ff8baff4c9a$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to" + " `" + componentName + "`, expected `function`.");
}



var $herDu = parcelRequire("herDu");

var $2xPiy = parcelRequire("2xPiy");
function $fce242babd1405db$export$aa207039f277c5f(initializer, annotations) {
    return (0, $2xPiy.useState)(function() {
        return (0, $herDu.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}



var $herDu = parcelRequire("herDu");

var $2xPiy = parcelRequire("2xPiy");



var $herDu = parcelRequire("herDu");

var $2xPiy = parcelRequire("2xPiy");
function $c362ad2453aee3b7$export$e0ded3646391939c(current) {
    (0, $87c6e9c9a3415ad6$export$be38475be17599d)("[mobx-react-lite] 'useAsObservableSource' is deprecated, please store the values directly in an observable, for example by using 'useLocalObservable', and sync future updates using 'useEffect' when needed. See the README for examples.");
    // We're deliberately not using idiomatic destructuring for the hook here.
    // Accessing the state value as an array element prevents TypeScript from generating unnecessary helpers in the resulting code.
    // For further details, please refer to mobxjs/mobx#3842.
    var res = (0, $2xPiy.useState)(function() {
        return (0, $herDu.observable)(current, {}, {
            deep: false
        });
    })[0];
    (0, $herDu.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}


function $6a660d06824f7010$export$f5b97ae82d1eeaf3(initializer, current) {
    (0, $87c6e9c9a3415ad6$export$be38475be17599d)("[mobx-react-lite] 'useLocalStore' is deprecated, use 'useLocalObservable' instead.");
    var source = current && (0, $c362ad2453aee3b7$export$e0ded3646391939c)(current);
    return (0, $2xPiy.useState)(function() {
        return (0, $herDu.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}



var $8132e90656ed4d43$var$_a;
(0, $77d89eb2aeb15306$export$294943bbc3c74f4f)((0, $cX5wj.unstable_batchedUpdates));
var $8132e90656ed4d43$export$469d51fb8d268227 = ($8132e90656ed4d43$var$_a = (0, $eb9973f37456124f$export$10e8a12fbfd8583c)["finalizeAllImmediately"]) !== null && $8132e90656ed4d43$var$_a !== void 0 ? $8132e90656ed4d43$var$_a : function() {};
function $8132e90656ed4d43$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    (0, $87c6e9c9a3415ad6$export$be38475be17599d)("[mobx-react-lite] 'useObserver(fn)' is deprecated. Use `<Observer>{fn}</Observer>` instead, or wrap the entire component in `observer`.");
    return (0, $b9176ce190a11530$export$b9c7ecd090a87b14)(fn, baseComponentName);
}
function $8132e90656ed4d43$export$7613124ee4202834(enable) {
    console.warn("[mobx-react-lite] 'useStaticRendering' is deprecated, use 'enableStaticRendering' instead");
    (0, $da546f689bf2d40e$export$5d52eaa7c0f24c9e)(enable);
}


var $111d14fdfd9806e4$exports = {};
$111d14fdfd9806e4$exports = $parcel$resolve("h3WyE");




const $861eff1f71c0dec6$var$getEnvironmentVariable = (unvalidatedEnvironmentVariable, defaultValue)=>{
    if (!unvalidatedEnvironmentVariable) {
        if (defaultValue !== undefined) return defaultValue;
        throw new Error(`Couldn't find environment variable: ${unvalidatedEnvironmentVariable}`);
    } else return unvalidatedEnvironmentVariable;
};
const $861eff1f71c0dec6$export$e506a1d27d1eaa20 = {
    nodeEnv: $861eff1f71c0dec6$var$getEnvironmentVariable("development"),
    client: {
        url: $861eff1f71c0dec6$var$getEnvironmentVariable("https://app-dev.usefuse.com/", 'http://localhost:1234'),
        basePageTitle: $861eff1f71c0dec6$var$getEnvironmentVariable(undefined, 'FuSE')
    },
    api: {
        url: $861eff1f71c0dec6$var$getEnvironmentVariable("https://app-backend-dev.usefuse.com/"),
        version: $861eff1f71c0dec6$var$getEnvironmentVariable("v1"),
        useCredentials: $861eff1f71c0dec6$var$getEnvironmentVariable("true", 'false') === 'true',
        credentialsType: $861eff1f71c0dec6$var$getEnvironmentVariable("include", 'include')
    },
    logs: {
        rootNamespace: $861eff1f71c0dec6$var$getEnvironmentVariable("fuse-app", 'fuse-frontend')
    },
    urls: {
        fuseWebsiteUrl: $861eff1f71c0dec6$var$getEnvironmentVariable("https://www.usefuse.com/"),
        fuseSupportUrl: $861eff1f71c0dec6$var$getEnvironmentVariable("https://usefuse.gitbook.io/fuse-user-guide"),
        privacyPolicyUrl: $861eff1f71c0dec6$var$getEnvironmentVariable("https://www.usefuse.com/privacy-policy/"),
        apiDataUrl: $861eff1f71c0dec6$var$getEnvironmentVariable("https://chargepoint-api.onrender.com/")
    },
    maps: {
        nominatimUrl: $861eff1f71c0dec6$var$getEnvironmentVariable("https://nominatim.openstreetmap.org/search"),
        googleMapsApiKey: $861eff1f71c0dec6$var$getEnvironmentVariable("AIzaSyCmX7SXHcyq-65GNOVRWVmctytx7Wz9zjY", ''),
        cartoBasemapsApiKey: $861eff1f71c0dec6$var$getEnvironmentVariable("cb1_2o8p_1_8d8f4f731e9f86bf1eada719", '')
    },
    sentry: {
        dsn: $861eff1f71c0dec6$var$getEnvironmentVariable("https://4c012a73aaa23ae6048ec3b31146b504@o4507629272432640.ingest.us.sentry.io/4507726268006400"),
        tracesSampleRate: parseFloat($861eff1f71c0dec6$var$getEnvironmentVariable("1.0", '1.0')),
        replaysSessionSampleRate: parseFloat($861eff1f71c0dec6$var$getEnvironmentVariable("0.1", '0.1')),
        replaysOnErrorSampleRate: parseFloat($861eff1f71c0dec6$var$getEnvironmentVariable("1.0", '1.0'))
    },
    stripe: {
        platformAccountId: $861eff1f71c0dec6$var$getEnvironmentVariable("acct_1RBj76RAam5Cb8xd", '')
    },
    documents: {
        refreshIntervalMs: parseInt($861eff1f71c0dec6$var$getEnvironmentVariable("5000", '5000'), 10) || 5000
    }
};



const $5a060c72de474321$var$isString = (obj)=>typeof obj === 'string';
const $5a060c72de474321$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $5a060c72de474321$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $5a060c72de474321$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $5a060c72de474321$var$lastOfPathSeparatorRegExp = /###/g;
const $5a060c72de474321$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($5a060c72de474321$var$lastOfPathSeparatorRegExp, '.') : key;
const $5a060c72de474321$var$canNotTraverseDeeper = (object)=>!object || $5a060c72de474321$var$isString(object);
const $5a060c72de474321$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$5a060c72de474321$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($5a060c72de474321$var$canNotTraverseDeeper(object)) return {};
        const key = $5a060c72de474321$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($5a060c72de474321$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $5a060c72de474321$var$cleanKey(stack[stackIndex])
    };
};
const $5a060c72de474321$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $5a060c72de474321$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $5a060c72de474321$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $5a060c72de474321$var$getLastOfPath(object, p, Object);
        if (last && last.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $5a060c72de474321$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $5a060c72de474321$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $5a060c72de474321$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $5a060c72de474321$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
};
const $5a060c72de474321$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $5a060c72de474321$var$getPath(data, key);
    if (value !== undefined) return value;
    return $5a060c72de474321$var$getPath(defaultData, key);
};
const $5a060c72de474321$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($5a060c72de474321$var$isString(target[prop]) || target[prop] instanceof String || $5a060c72de474321$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $5a060c72de474321$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $5a060c72de474321$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $5a060c72de474321$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $5a060c72de474321$var$escape = (data)=>{
    if ($5a060c72de474321$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$5a060c72de474321$var$_entityMap[s]);
    return data;
};
class $5a060c72de474321$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $5a060c72de474321$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $5a060c72de474321$var$looksLikeObjectPathRegExpCache = new $5a060c72de474321$var$RegExpCache(20);
const $5a060c72de474321$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $5a060c72de474321$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $5a060c72de474321$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $5a060c72de474321$var$deepFind = function(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $5a060c72de474321$var$getCleanedCode = (code)=>code && code.replace('_', '-');
const $5a060c72de474321$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class $5a060c72de474321$var$Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $5a060c72de474321$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, 'log', '', true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, 'warn', '', true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, 'error', '');
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($5a060c72de474321$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $5a060c72de474321$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $5a060c72de474321$var$Logger(this.logger, options);
    }
}
var $5a060c72de474321$var$baseLogger = new $5a060c72de474321$var$Logger();
class $5a060c72de474321$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach((_ref)=>{
                let [observer, numTimesAdded] = _ref;
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach((_ref2)=>{
                let [observer, numTimesAdded] = _ref2;
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
class $5a060c72de474321$var$ResourceStore extends $5a060c72de474321$var$EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($5a060c72de474321$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $5a060c72de474321$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$5a060c72de474321$var$isString(key)) return result;
        return $5a060c72de474321$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $5a060c72de474321$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if ($5a060c72de474321$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false,
            skipCopy: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $5a060c72de474321$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $5a060c72de474321$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $5a060c72de474321$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === 'v1') return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $5a060c72de474321$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const $5a060c72de474321$var$checkedLoadedFor = {};
class $5a060c72de474321$var$Translator extends $5a060c72de474321$var$EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $5a060c72de474321$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $5a060c72de474321$var$baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$5a060c72de474321$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $5a060c72de474321$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $5a060c72de474321$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== 'object' && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === 'object') options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return '';
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = !$5a060c72de474321$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !($5a060c72de474321$var$isString(joinArrays) && Array.isArray(res))) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(res);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $5a060c72de474321$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && !$5a060c72de474321$var$isString(options.count);
            const hasDefaultValue = $5a060c72de474321$var$Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : '';
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, options);
                        if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== 'v1') res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = $5a060c72de474321$var$isString(res) && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && !$5a060c72de474321$var$isString(options.replace) ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language || resolved.usedLng, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== 'v1' && resolved && resolved.res) options.lng = this.language || resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = $5a060c72de474321$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $5a060c72de474321$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(options)
            },
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($5a060c72de474321$var$isString(keys)) keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && !$5a060c72de474321$var$isString(options.count);
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && ($5a060c72de474321$var$isString(options.context) || typeof options.context === 'number') && options.context !== '';
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$5a060c72de474321$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    $5a060c72de474321$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$5a060c72de474321$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
const $5a060c72de474321$var$capitalize = (string)=>string.charAt(0).toUpperCase() + string.slice(1);
class $5a060c72de474321$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $5a060c72de474321$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $5a060c72de474321$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $5a060c72de474321$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($5a060c72de474321$var$isString(code) && code.indexOf('-') > -1) {
            if (typeof Intl !== 'undefined' && typeof Intl.getCanonicalLocales !== 'undefined') try {
                let formattedCode = Intl.getCanonicalLocales(code)[0];
                if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
                if (formattedCode) return formattedCode;
            } catch (e) {}
            const specialCases = [
                'hans',
                'hant',
                'latn',
                'cyrl',
                'cans',
                'mong',
                'arab'
            ];
            let p = code.split('-');
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $5a060c72de474321$var$capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $5a060c72de474321$var$capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $5a060c72de474321$var$capitalize(p[2].toLowerCase());
            }
            return p.join('-');
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($5a060c72de474321$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($5a060c72de474321$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($5a060c72de474321$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
let $5a060c72de474321$var$sets = [
    {
        lngs: [
            'ach',
            'ak',
            'am',
            'arn',
            'br',
            'fil',
            'gun',
            'ln',
            'mfe',
            'mg',
            'mi',
            'oc',
            'pt',
            'pt-BR',
            'tg',
            'tl',
            'ti',
            'tr',
            'uz',
            'wa'
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            'af',
            'an',
            'ast',
            'az',
            'bg',
            'bn',
            'ca',
            'da',
            'de',
            'dev',
            'el',
            'en',
            'eo',
            'es',
            'et',
            'eu',
            'fi',
            'fo',
            'fur',
            'fy',
            'gl',
            'gu',
            'ha',
            'hi',
            'hu',
            'hy',
            'ia',
            'it',
            'kk',
            'kn',
            'ku',
            'lb',
            'mai',
            'ml',
            'mn',
            'mr',
            'nah',
            'nap',
            'nb',
            'ne',
            'nl',
            'nn',
            'no',
            'nso',
            'pa',
            'pap',
            'pms',
            'ps',
            'pt-PT',
            'rm',
            'sco',
            'se',
            'si',
            'so',
            'son',
            'sq',
            'sv',
            'sw',
            'ta',
            'te',
            'tk',
            'ur',
            'yo'
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            'ay',
            'bo',
            'cgg',
            'fa',
            'ht',
            'id',
            'ja',
            'jbo',
            'ka',
            'km',
            'ko',
            'ky',
            'lo',
            'ms',
            'sah',
            'su',
            'th',
            'tt',
            'ug',
            'vi',
            'wo',
            'zh'
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            'be',
            'bs',
            'cnr',
            'dz',
            'hr',
            'ru',
            'sr',
            'uk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            'ar'
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            'cs',
            'sk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            'csb',
            'pl'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            'cy'
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            'fr'
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            'ga'
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            'gd'
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            'is'
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            'jv'
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            'kw'
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            'lt'
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            'lv'
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            'mk'
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            'mnk'
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            'mt'
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            'or'
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            'ro'
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            'sl'
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            'he',
            'iw'
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let $5a060c72de474321$var$_rulesPluralsTypes = {
    1: (n)=>Number(n > 1),
    2: (n)=>Number(n != 1),
    3: (n)=>0,
    4: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    5: (n)=>Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5),
    6: (n)=>Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2),
    7: (n)=>Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    8: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3),
    9: (n)=>Number(n >= 2),
    10: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4),
    11: (n)=>Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3),
    12: (n)=>Number(n % 10 != 1 || n % 100 == 11),
    13: (n)=>Number(n !== 0),
    14: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3),
    15: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    16: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2),
    17: (n)=>Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1),
    18: (n)=>Number(n == 0 ? 0 : n == 1 ? 1 : 2),
    19: (n)=>Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3),
    20: (n)=>Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2),
    21: (n)=>Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0),
    22: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3)
};
const $5a060c72de474321$var$nonIntlVersions = [
    'v1',
    'v2',
    'v3'
];
const $5a060c72de474321$var$intlVersions = [
    'v4'
];
const $5a060c72de474321$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $5a060c72de474321$var$createRules = ()=>{
    const rules = {};
    $5a060c72de474321$var$sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: $5a060c72de474321$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
};
class $5a060c72de474321$var$PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $5a060c72de474321$var$baseLogger.create('pluralResolver');
        if ((!this.options.compatibilityJSON || $5a060c72de474321$var$intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
            this.options.compatibilityJSON = 'v3';
            this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
        }
        this.rules = $5a060c72de474321$var$createRules();
        this.pluralRulesCache = {};
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) {
            const cleanedCode = $5a060c72de474321$var$getCleanedCode(code === 'dev' ? 'en' : code);
            const type = options.ordinal ? 'ordinal' : 'cardinal';
            const cacheKey = JSON.stringify({
                cleanedCode: cleanedCode,
                type: type
            });
            if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
            let rule;
            try {
                rule = new Intl.PluralRules(cleanedCode, {
                    type: type
                });
            } catch (err) {
                if (!code.match(/-|_/)) return;
                const lngPart = this.languageUtils.getLanguagePartFromCode(code);
                rule = this.getRule(lngPart, options);
            }
            this.pluralRulesCache[cacheKey] = rule;
            return rule;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$5a060c72de474321$var$suffixesOrder[pluralCategory1] - $5a060c72de474321$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return '';
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = 'plural';
            else if (suffix === 1) suffix = '';
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === 'v1') {
            if (suffix === 1) return '';
            if (typeof suffix === 'number') return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === 'v2') return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !$5a060c72de474321$var$nonIntlVersions.includes(this.options.compatibilityJSON);
    }
}
const $5a060c72de474321$var$deepFindWithDefaults = function(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $5a060c72de474321$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $5a060c72de474321$var$isString(key)) {
        path = $5a060c72de474321$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $5a060c72de474321$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $5a060c72de474321$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $5a060c72de474321$var$Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $5a060c72de474321$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $5a060c72de474321$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $5a060c72de474321$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $5a060c72de474321$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $5a060c72de474321$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $5a060c72de474321$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $5a060c72de474321$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $5a060c72de474321$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp && existingRegExp.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $5a060c72de474321$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($5a060c72de474321$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$5a060c72de474321$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $5a060c72de474321$var$regexSafe(this.escape(val)) : $5a060c72de474321$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $5a060c72de474321$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$5a060c72de474321$var$isString(value) && !this.useRawValueToEscape) value = $5a060c72de474321$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$5a060c72de474321$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$5a060c72de474321$var$isString(value)) return value;
            if (!$5a060c72de474321$var$isString(value)) value = $5a060c72de474321$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $5a060c72de474321$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $5a060c72de474321$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (val, lng, options)=>{
        let optForCache = options;
        if (options && options.interpolationkey && options.formatParams && options.formatParams[options.interpolationkey] && options[options.interpolationkey]) optForCache = {
            ...optForCache,
            [options.interpolationkey]: undefined
        };
        const key = lng + JSON.stringify(optForCache);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($5a060c72de474321$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
};
class $5a060c72de474321$var$Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $5a060c72de474321$var$baseLogger.create('formatter');
        this.options = options;
        this.formats = {
            number: $5a060c72de474321$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $5a060c72de474321$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $5a060c72de474321$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $5a060c72de474321$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: $5a060c72de474321$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        this.formatSeparator = options.interpolation.formatSeparator || ',';
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $5a060c72de474321$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $5a060c72de474321$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $5a060c72de474321$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $5a060c72de474321$var$Connector extends $5a060c72de474321$var$EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $5a060c72de474321$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $5a060c72de474321$var$pushPath(q.loaded, [
                lng
            ], ns);
            $5a060c72de474321$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($5a060c72de474321$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($5a060c72de474321$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $5a060c72de474321$var$get = ()=>({
        debug: false,
        initImmediate: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($5a060c72de474321$var$isString(args[1])) ret.defaultValue = args[1];
            if ($5a060c72de474321$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        }
    });
const $5a060c72de474321$var$transformOptions = (options)=>{
    if ($5a060c72de474321$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($5a060c72de474321$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($5a060c72de474321$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
};
const $5a060c72de474321$var$noop = ()=>{};
const $5a060c72de474321$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $5a060c72de474321$var$I18n extends $5a060c72de474321$var$EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $5a060c72de474321$var$transformOptions(options);
        this.services = {};
        this.logger = $5a060c72de474321$var$baseLogger;
        this.modules = {
            external: []
        };
        $5a060c72de474321$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if ($5a060c72de474321$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $5a060c72de474321$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$5a060c72de474321$var$transformOptions(options)
        };
        if (this.options.compatibilityAPI !== 'v1') this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $5a060c72de474321$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $5a060c72de474321$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== 'undefined') formatter = $5a060c72de474321$var$Formatter;
            const lu = new $5a060c72de474321$var$LanguageUtil(this.options);
            this.store = new $5a060c72de474321$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $5a060c72de474321$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $5a060c72de474321$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $5a060c72de474321$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $5a060c72de474321$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $5a060c72de474321$var$Translator(this.services, this.options);
            this.translator.on('*', function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $5a060c72de474321$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $5a060c72de474321$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== 'v1' && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $5a060c72de474321$var$noop;
        let usedCallback = callback;
        const usedLng = $5a060c72de474321$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $5a060c72de474321$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $5a060c72de474321$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $5a060c72de474321$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $5a060c72de474321$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit('languageChanged', l);
                this.logger.log('languageChanged', l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = $5a060c72de474321$var$isString(lngs) ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== 'object') {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            if (options.keyPrefix !== '') options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || '.';
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if ($5a060c72de474321$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $5a060c72de474321$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($5a060c72de474321$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $5a060c72de474321$var$defer();
        if ($5a060c72de474321$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services && this.services.languageUtils || new $5a060c72de474321$var$LanguageUtil($5a060c72de474321$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $5a060c72de474321$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $5a060c72de474321$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $5a060c72de474321$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new $5a060c72de474321$var$ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $5a060c72de474321$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $5a060c72de474321$export$2e2bcd8739ae039 = $5a060c72de474321$var$I18n.createInstance();
$5a060c72de474321$export$2e2bcd8739ae039.createInstance = $5a060c72de474321$var$I18n.createInstance;
const $5a060c72de474321$export$99152e8d49ca4e7d = $5a060c72de474321$export$2e2bcd8739ae039.createInstance;
const $5a060c72de474321$export$147ec2801e896265 = $5a060c72de474321$export$2e2bcd8739ae039.dir;
const $5a060c72de474321$export$2cd8252107eb640b = $5a060c72de474321$export$2e2bcd8739ae039.init;
const $5a060c72de474321$export$d3d08d944062d7e = $5a060c72de474321$export$2e2bcd8739ae039.loadResources;
const $5a060c72de474321$export$a5d9bf5d83fcab09 = $5a060c72de474321$export$2e2bcd8739ae039.reloadResources;
const $5a060c72de474321$export$1f96ae73734a86cc = $5a060c72de474321$export$2e2bcd8739ae039.use;
const $5a060c72de474321$export$61465194746e7fd2 = $5a060c72de474321$export$2e2bcd8739ae039.changeLanguage;
const $5a060c72de474321$export$f90d180fc7da3b3b = $5a060c72de474321$export$2e2bcd8739ae039.getFixedT;
const $5a060c72de474321$export$625550452a3fa3ec = $5a060c72de474321$export$2e2bcd8739ae039.t;
const $5a060c72de474321$export$f7e9f41ea797a17 = $5a060c72de474321$export$2e2bcd8739ae039.exists;
const $5a060c72de474321$export$2b4b218e406d2d00 = $5a060c72de474321$export$2e2bcd8739ae039.setDefaultNamespace;
const $5a060c72de474321$export$93d9ee97c1ad3f31 = $5a060c72de474321$export$2e2bcd8739ae039.hasLoadedNamespace;
const $5a060c72de474321$export$83be934b53fff43b = $5a060c72de474321$export$2e2bcd8739ae039.loadNamespaces;
const $5a060c72de474321$export$8cd7e7a54fa865bc = $5a060c72de474321$export$2e2bcd8739ae039.loadLanguages;


function $cfaf9b8a0bcd80f9$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


function $ede463c6538a9864$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $ede463c6538a9864$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ede463c6538a9864$export$2e2bcd8739ae039(o);
}



function $011e9984edc0bd8c$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $ede463c6538a9864$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $ede463c6538a9864$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $128a815847b44ef2$export$2e2bcd8739ae039(t) {
    var i = (0, $011e9984edc0bd8c$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $ede463c6538a9864$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $fa2c86fcce8fa2e2$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $128a815847b44ef2$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $fa2c86fcce8fa2e2$export$2e2bcd8739ae039(e, r, t) {
    return r && $fa2c86fcce8fa2e2$var$_defineProperties(e.prototype, r), t && $fa2c86fcce8fa2e2$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


var $a6873cffd63c6d43$var$arr = [];
var $a6873cffd63c6d43$var$each = $a6873cffd63c6d43$var$arr.forEach;
var $a6873cffd63c6d43$var$slice = $a6873cffd63c6d43$var$arr.slice;
function $a6873cffd63c6d43$var$defaults(obj) {
    $a6873cffd63c6d43$var$each.call($a6873cffd63c6d43$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $a6873cffd63c6d43$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $a6873cffd63c6d43$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || '/';
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!$a6873cffd63c6d43$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!$a6873cffd63c6d43$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    return str;
};
var $a6873cffd63c6d43$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $a6873cffd63c6d43$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, '', -1);
    }
};
var $a6873cffd63c6d43$var$cookie$1 = {
    name: 'cookie',
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== 'undefined') {
            var c = $a6873cffd63c6d43$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== 'undefined') $a6873cffd63c6d43$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $a6873cffd63c6d43$var$querystring = {
    name: 'querystring',
    lookup: function lookup(options) {
        var found;
        if (typeof window !== 'undefined') {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            var query = search.substring(1);
            var params = query.split('&');
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf('=');
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $a6873cffd63c6d43$var$hasLocalStorageSupport = null;
var $a6873cffd63c6d43$var$localStorageAvailable = function localStorageAvailable() {
    if ($a6873cffd63c6d43$var$hasLocalStorageSupport !== null) return $a6873cffd63c6d43$var$hasLocalStorageSupport;
    try {
        $a6873cffd63c6d43$var$hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
        var testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $a6873cffd63c6d43$var$hasLocalStorageSupport = false;
    }
    return $a6873cffd63c6d43$var$hasLocalStorageSupport;
};
var $a6873cffd63c6d43$var$localStorage = {
    name: 'localStorage',
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $a6873cffd63c6d43$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $a6873cffd63c6d43$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $a6873cffd63c6d43$var$hasSessionStorageSupport = null;
var $a6873cffd63c6d43$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($a6873cffd63c6d43$var$hasSessionStorageSupport !== null) return $a6873cffd63c6d43$var$hasSessionStorageSupport;
    try {
        $a6873cffd63c6d43$var$hasSessionStorageSupport = window !== 'undefined' && window.sessionStorage !== null;
        var testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $a6873cffd63c6d43$var$hasSessionStorageSupport = false;
    }
    return $a6873cffd63c6d43$var$hasSessionStorageSupport;
};
var $a6873cffd63c6d43$var$sessionStorage = {
    name: 'sessionStorage',
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $a6873cffd63c6d43$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $a6873cffd63c6d43$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $a6873cffd63c6d43$var$navigator$1 = {
    name: 'navigator',
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== 'undefined') {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $a6873cffd63c6d43$var$htmlTag = {
    name: 'htmlTag',
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === 'function') found = htmlTag.getAttribute('lang');
        return found;
    }
};
var $a6873cffd63c6d43$var$path = {
    name: 'path',
    lookup: function lookup(options) {
        var found;
        if (typeof window !== 'undefined') {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === 'number') {
                    if (typeof language[options.lookupFromPathIndex] !== 'string') return undefined;
                    found = language[options.lookupFromPathIndex].replace('/', '');
                } else found = language[0].replace('/', '');
            }
        }
        return found;
    }
};
var $a6873cffd63c6d43$var$subdomain = {
    name: 'subdomain',
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === 'number' ? options.lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== 'undefined' && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
// some environments, throws when accessing document.cookie
var $a6873cffd63c6d43$var$canCookies = false;
try {
    // eslint-disable-next-line no-unused-expressions
    document.cookie;
    $a6873cffd63c6d43$var$canCookies = true;
// eslint-disable-next-line no-empty
} catch (e) {}
var $a6873cffd63c6d43$var$order = [
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag'
];
if (!$a6873cffd63c6d43$var$canCookies) $a6873cffd63c6d43$var$order.splice(1, 1);
function $a6873cffd63c6d43$var$getDefaults() {
    return {
        order: $a6873cffd63c6d43$var$order,
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: function convertDetectedLanguage(l) {
            return l;
        }
    };
}
var $a6873cffd63c6d43$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $cfaf9b8a0bcd80f9$export$2e2bcd8739ae039)(this, Browser);
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    return (0, $fa2c86fcce8fa2e2$export$2e2bcd8739ae039)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services || {
                    languageUtils: {}
                }; // this way the language detector can be used without i18next
                this.options = $a6873cffd63c6d43$var$defaults(options, this.options || {}, $a6873cffd63c6d43$var$getDefaults());
                if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) this.options.convertDetectedLanguage = function(l) {
                    return l.replace('-', '_');
                };
                // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($a6873cffd63c6d43$var$cookie$1);
                this.addDetector($a6873cffd63c6d43$var$querystring);
                this.addDetector($a6873cffd63c6d43$var$localStorage);
                this.addDetector($a6873cffd63c6d43$var$sessionStorage);
                this.addDetector($a6873cffd63c6d43$var$navigator$1);
                this.addDetector($a6873cffd63c6d43$var$htmlTag);
                this.addDetector($a6873cffd63c6d43$var$path);
                this.addDetector($a6873cffd63c6d43$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
                return this;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === 'string') lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                detected = detected.map(function(d) {
                    return _this.options.convertDetectedLanguage(d);
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
}();
$a6873cffd63c6d43$export$2e2bcd8739ae039.type = 'languageDetector';


var $3e17fc7b6f879ba7$exports = {};
$3e17fc7b6f879ba7$exports = JSON.parse("{\"apiData\":{\"title\":\"Api Data\",\"stationTitle\":\"Chargers\",\"sessionTitle\":\"Sessions\",\"chartTitle\":\"Charts\",\"apiDataSearch\":\"Search\",\"selectColumns\":\"Select Columns\",\"columnSettings\":\"Columns Settings\",\"sessionsView\":\"Sessions\",\"chargersView\":\"Chargers\",\"chartView\":\"Charts\",\"download\":\"Download\",\"perPage\":\"per page\",\"timeframe\":\"Timeframe\",\"range\":\"Range\",\"rangeHelperText\":\"After start date\",\"startRange\":\"Start Range\",\"endRange\":\"End Range\",\"stations\":\"Stations\",\"timeframe_days\":\"Days\",\"timeframe_months\":\"Months\",\"timeframe_quarters\":\"Quarters\",\"timeframe_years\":\"Years\",\"range_current\":\"Current\",\"range_days90\":\"90 days\",\"range_months6\":\"6 months\",\"range_year1\":\"1 year\",\"range_year2\":\"2 years\",\"range_year3\":\"3 years\",\"range_year4\":\"4 years\",\"range_year5\":\"5 years\",\"range_year6\":\"6 years\",\"range_year7\":\"7 years\",\"range_custom\":\"Custom\",\"totalEnergy\":\"Total Energy (kWh)\",\"notificationStationSelect\":\"You must select stations first to see the charts\",\"startDateFilter\":\"Date Range From\",\"endDateFilter\":\"Date Range To\",\"chargingNetworkFilter\":\"Charging Network\",\"chargerLevelFilter\":\"Charger Level\",\"subOrganizationFilter\":\"Sub-Organization\",\"serialNumberFilter\":\"Serial Number\",\"serialNumberSearchHint\":\"Type at least {{min}} characters to search\",\"filtersDisclaimer\":\"Leaving a filter unselected includes all of its options.\",\"stateFilter\":\"State/Province\",\"searchFilters\":\"SEARCH\",\"noFilters\":\"Select filters and click Search to load data!\",\"noData\":\"No data found\",\"noColumns\":\"No columns selected. Use the column settings to choose which columns to show.\"}}");


var $d220cacd4bfe6ba5$exports = {};
$d220cacd4bfe6ba5$exports = JSON.parse('{"client":{"details":"Details","clientList":"Client List","allClients":"All Clients","fuseStart":"Fuse Start","addClient":"Add Client","contacts":"Contacts","documents":"Documents","companyLegalName":"Company Legal Name","websiteURL":"Website URL","clientStatus":"Client Status","fuseStartDate":"Fuse Start Date","fuseEndDate":"Fuse End Date","feinBusinessNumber":"FEIN or Business Number","corporateAddress":"Corporate Address","programCountry":"Program Country","country":"Country","countryPlaceholder":"Choose your program\'s country","unitedStates":"United States","canada":"Canada","remittanceInformation":"Remittance Information","remittanceAddress":"Remittance Address","bankingInformation":"Banking Information","bankName":"Bank Name","bankAccountType":"Bank Account Type","bankAccountNumber":"Bank Account Number","bankRoutingNumber":"Bank Routing Number","stripeDetails":"Stripe Details","noStripeAccountConnected":"No Stripe Account Connected","addStripeDetails":"Add Stripe Details","stripeUnavailableForCanada":"Stripe payouts are currently not available for clients located in Canada.","accountDetails":"Account Details","displayName":"Display Name","noDisplayName":"No display name","contactEmail":"Contact Email","enterEmailAddress":"Enter email address","linkedBankAccount":"Linked Bank Account","updateBankAccount":"Update Bank Account","completeBankingDetails":"Complete Banking Details","routingNumber":"Routing Number","last4":"Last 4","retired":"Retired","retireClient":"Retire Client","retire":"Retire","retireButton":"RETIRE","retiringButton":"RETIRING...","lastReportingPeriod":"Last Reporting Period","retireWarning":"Warning: Retiring this Client will retire all its Facilities, Equipment, and any Equipment Usage data","retireWarningEnd":"will be discarded.","theLastReportingPeriod":"the last reporting period","retireConfirmation1":"I understand that retiring this Client will also retire all its Facilities and Equipment.","retireConfirmation2Start":"I understand that all usage data","retireConfirmation2End":"will be discarded.","selectPeriod":"Select Period...","noProgramMessage":"A program must be added to this client before selecting the last reporting period."},"contacts":{"pointsOfContact":"Points of Contact","pointsOfContactDescription":"All Admin users for this {{entityType}} will be considered points of contact.","pointsOfContactDescriptionClient":"All Admin users for this Client and {{entityType}} will be considered points of contact.","client":"Client","corporateContacts":"Corporate Contacts","remittanceContacts":"Remittance Contacts","facilityContacts":"Facility Contacts","contact":"Contact","contactRole":"Contact Role","contactName":"Contact Name","contactEmail":"Contact Email","contactPhone":"Contact Phone","choose":"Choose..."},"documents":{"title":"Document Library","uploadDocument":"Upload Document","documentName":"Document Name","documentType":"Document Type","dateUploaded":"Date Uploaded","uploadedBy":"Uploaded By","noDocumentsFound":"No Documents Found","noDocumentsMatchFilters":"No documents match the selected filters","clearFilters":"Clear Filters","characterLimit":"/500 characters","noComments":"No comments","saveChanges":"Save Changes","cancelEditing":"Cancel Editing","downloadDocument":"Download Document","seeMore":"See More","collapse":"Collapse","editComments":"Edit Comments","deleteDocument":"Delete Document","deleteDocumentWarning":"Are you sure you want to delete this document?","deleteDocumentConfirm":"I understand this action cannot be undone.","processing":"Processing","needsReview":"Needs Review","selectDocumentType":"Select Document Type","addComments":"Add Comments (optional)","cancel":"Cancel","upload":"Upload","dropFiles":"Drop file here or click to","browse":"browse","selectedFile":"Selected File","cannotDownloadWhileProcessing":"Cannot download while processing","cannotDownloadFileNeedsReview":"Cannot download \u2014 file needs review","searchByName":"Search by name","downloadSelected":"Download Selected","preparingDownload":"Preparing...","all":"All","filterDocuments":"Filter Documents","bulkDownloadPartial":"{{downloaded}} document(s) downloaded, {{skipped}} skipped (processing or needs review).","bulkDownloadUnavailable":"{{count}} selected document(s) cannot be downloaded right now (processing or needs review)."},"statements":{"statements":"Statements","statementList":"Statement List","incentiveStatements":"Incentive Statements","summary":"Summary (Printable)","details":"Details (Printable)","viewIndividualPrograms":"View Individual Programs","hideIndividualPrograms":"Hide Individual Programs","viewIndividualProgram":"View Individual Program","hideIndividualProgram":"Hide Individual Program","noStatementsFound":"No Statements found","allPrograms":"All Programs","individualStatement":"Individual Statement","downloadPDF":"Download PDF","downloadCSV":"Download CSV","detailedStatement":"Detailed Statement","incentiveStatement":"Incentive Statement","credits":"Credits","accountEndingIn":"Account ending in","creditPrice":"Credit Price","totalValue":"Total Value","recCost":"REC Cost","brokerCost":"Broker Cost","taxesOnCreditSale":"Taxes on Credit Sale","taxesOnServices":"Taxes on Services","fuseServiceFee":"FuSE Service Fee","netIncentive":"Net Incentive","totals":"Totals","costRecoup":"Cost Recoup (if Applicable)","grandTotal":"Grand Total","calculationKey":"Calculation Key","definition":"Definition","taxesOnCreditSaleDefinition":"Applicable only to the BC LCFS program. Taxes assessed at 5% of Total Value.","taxesOnServicesDefinition":"Applicable GST, HST, and PST assessed based on the Client headquarters province.","creditsDefinition":"Credit generation is based on the amount of reported kWh used/dispensed by your electric equipment.","creditPriceDefinition":"Credit price is determined by the value of each credit sold to regulated entities (oil & gas companies) on the open market.","recCostDefinition":"Renewable Energy Certificates (RECs) are megawatt-hrs. of clean electricity procured on your behalf to enhance the amount of credits generated, when financially beneficial. Purchasing RECs at this cost increases credits and revenue generated.","brokerCostDefinition":"Administrative cost associated with brokerage services, REC procurement, and contracting with regulated entities.","fuseServiceFeeDefinition":"Agreed upon commission retained by FuSE after REC Cost and Broker Cost are subtracted.","caFuseServiceFeeDefinition":"Agreed upon commission retained by FuSE.","costRecoupDefinition":"Funds withheld in cases where FuSE has fronted cost of metering hardware or other Exchange activities.","netIncentiveDefinition":"Amount remitted to your organization after all costs and fees have been subtracted.","incentiveStatementNotice":"The incentive statement below reflects the credits generated by your organization\'s enrolled electric asset/equipment in applicable state, provincial, or federal clean fuel standard program. For questions or additional information, please contact our team at support@usefuse.com, or through the chat feature in the app."},"commissions":{"commissions":"Commissions","fuseCommissions":"FuSE Commissions","percentage":"Percentage","fixedRate":"Fixed Rate","effectiveStartDate":"Effective Start Date","effectiveEndDate":"Effective End Date","salesCommissions":"Sales Commissions","referralCommissions":"Referral Commissions","referralPartner":"Referral Partner"},"user":{"user":"User","users":"Users","company":"Company","lastLogin":"Last Login","userList":"User List","addUser":"Add User","userRole":"User Role","userStatus":"User Status","inactive":"Inactive","email":"Email","phone":"Phone","noUsersFound":"No Users found","userInformation":"User Information","contactInformation":"Contact Information","created":"Created","updatePassword":"Update Password","currentPassword":"Current Password","newPassword":"New Password","confirmNewPassword":"Confirm New Password","passwordRegex":"Password must be at least 16 characters long and must contain at least one uppercase letter, one lowercase letter, one number, and one special character (!@#$%^&*)"}}');


var $15140eded40257ac$exports = {};
$15140eded40257ac$exports = JSON.parse("{\"common\":{\"saveChanges\":\"SAVE CHANGES\",\"savingChanges\":\"SAVING CHANGES...\",\"cancel\":\"CANCEL\",\"title\":\"Sign In\",\"signIn\":\"SIGN IN\",\"save\":\"Save\",\"troubleSigningIn\":\"Trouble Signing In?\",\"resetPassword\":\"Reset Password\",\"email\":\"Email\",\"password\":\"Password\",\"findFieldByName\":\"Find field by name...\",\"find\":\"Find\",\"by\":\"By\",\"choose\":\"Choose...\",\"selectPeriod\":\"Select Period...\",\"reasonForRetiring\":\"Reason for Retiring\",\"selectReason\":\"Select Reason...\",\"selectAll\":\"Select All\",\"clearAll\":\"Clear All\",\"selectedCount\":\"{{count}} selected\",\"otherReasonDescription\":\"Please Specify the Reason\",\"address\":\"Address\",\"addressContinued\":\"Address (continued)\",\"city\":\"City\",\"stateProvince\":\"State / Province\",\"postalCode\":\"Postal Code\",\"requiredField\":\"* Required field\",\"apply\":\"APPLY\",\"applying\":\"APPLYING...\",\"clear\":\"CLEAR\",\"filters\":\"Filters\",\"loading\":\"Loading...\",\"yes\":\"Yes\",\"no\":\"No\",\"close\":\"Close\",\"after\":\"after\",\"viewDashboard\":\"View Dashboard\",\"enterName\":\"Enter Name\",\"alreadyHaveAccount\":\"Already have an account?\",\"enterEmailAssociatedWithAccount\":\"Enter the email address associated with your account and we'll send you a link to reset your password.\",\"restartPageTour\":\"Restart page tour\",\"status\":\"Status\",\"name\":\"Name\",\"active\":\"Active\",\"retired\":\"Retired\",\"all\":\"All\",\"comments\":\"Comments\",\"finalized\":\"Finalized\",\"firstReportingPeriod\":\"First Reporting Period\",\"lastReportingPeriod\":\"Last Reporting Period\",\"theLastReportingPeriod\":\"the last reporting period\",\"retire\":\"Retire\",\"retireButton\":\"RETIRE\",\"retiringButton\":\"RETIRING...\",\"program\":\"Program\",\"reportingPeriod\":\"Reporting Period\",\"totalKwh\":\"Total kWh\",\"clientName\":\"Client Name\",\"remittanceMethod\":\"Remittance Method\",\"generalInfo\":\"General Information\",\"facility\":\"Facility\",\"facilities\":\"Facilities\",\"unsavedFilters\":\"Filters were not applied\"},\"language\":{\"en\":\"English\",\"fc\":\"French\"}}");


var $1e503e3739d008c0$exports = {};
$1e503e3739d008c0$exports = JSON.parse("{\"dashboard\":{\"exportPDF\":\"Export to PDF\",\"yourFacilities\":\"Your Facilities\",\"companyPageLink\":\"Go to Company page\",\"kwhConsumed\":\"kWh Consumed\",\"energyConsumption\":\"Energy Consumption Used For Reporting\",\"mtCo2eDisplaced\":\"MT CO2e Displaced\",\"equalToCreditsGeneratedToDate\":\"Equal To Credits Generated To Date\",\"totalNetRevenueToDate\":\"Total Net Revenue To Date\",\"valueOfCreditsTransacted\":\"Value Of Credits Transacted\",\"avgCostPerKwh\":\"Avg. $/kWh\",\"enrolledVehiclesAndEquipment\":\"Enrolled Vehicles & Equipment\",\"totalNumberOfAssetsProducingCredits\":\"Total Number of Assets Producing Credits\",\"daysToNextCreditMinting\":\"Days To Next Credit Minting\",\"periodIncentiveRevenue\":\"Period Incentive Revenue\",\"cumulativeEnrollmentTrends\":\"Cumulative Enrollment Trends\",\"revenueBreakdown\":\"Revenue Breakdown\",\"byEquipmentType\":\"By Equipment Type\",\"byProgram\":\"By Program\",\"equipmentTypeByFacility\":\"Equipment Type By Facility\",\"currentFacilityLocations\":\"Current Facility Locations\",\"percentRevenueByEquipmenttype\":\"Percent Revenue By Equipment Type\",\"percentRevenueByProgram\":\"Percent Revenue By Program\"}}");


var $2f25af50a9e13990$exports = {};
$2f25af50a9e13990$exports = JSON.parse("{\"equipment\":{\"add\":\"Add\",\"equipment\":\"Equipment\",\"equipmentList\":\"Equipment List\",\"equipmentDetails\":\"Equipment Details\",\"viewEquipmentDetails\":\"View Equipment Details\",\"filterEquipment\":\"Filter Equipment\",\"equipmentActions\":\"Equipment Actions\",\"equipmentUseCase\":\"Equipment Use Case\",\"chargingType\":\"Charging Type\",\"meter\":\"Meter\",\"serialVin\":\"Serial / VIN\",\"manufacturer\":\"Manufacturer\",\"modelYear\":\"Model Year\",\"modelNumber\":\"Model Number\",\"unitNo\":\"Unit Number\",\"meteredKwh\":\"Metered kWh\",\"activityStatus\":\"Activity Status\",\"meterType\":\"Meter Type\",\"editMetered\":\"Edit Metered\",\"editUnmetered\":\"Edit Unmetered\",\"addEquipment\":\"Add Equipment\",\"viewEquipmentId\":\"View Equipment ID\",\"save\":\"Save\",\"metered\":\"Metered\",\"unmetered\":\"Unmetered\",\"updateMeteredEquipmentUsage\":\"Update Metered Equipment Usage\",\"bulkEditAllKwh\":\"Bulk edit all metered kWh\",\"bulkEditAllKwhHelp\":\"This value will be applied to every metered equipment unit for this reporting period.\",\"noMeteredEquipmentUsageDataFound\":\"No metered equipment usage data was found for this quarter.\",\"noUsageDataFound\":\"No usage data was found for this equipment.\",\"operationDetails\":\"Operation Details\",\"chargingCyclesShift\":\"Charging Cycles / Shift\",\"shiftsDay\":\"Shifts / Day\",\"workDaysQuarter\":\"Work Days / Quarter\",\"percentUptime\":\"Uptime\",\"maxSiteDeliverabilityKw\":\"Max Site Deliverability (kW)\",\"chargerEfficiencyRating\":\"Charger Efficiency Rating\",\"chargeReturnFactor\":\"Charge Return Factor\",\"depthOfDischarge\":\"Depth of Discharge\",\"periodHasBeenLockedAndCannotBeEdited\":\"This period has been locked and cannot be edited.\",\"periodHasBeenFinalizedAndCanNoLongerBeEdited\":\"This period has been finalized and can no longer be edited.\",\"whatAreYouChargingOrPowering\":\"What are you charging or powering?\",\"equipmentCategory\":\"Equipment Category\",\"equipmentType\":\"Equipment Type\",\"serialNumber\":\"Serial Number\",\"nameplateRating\":\"Nameplate Rating (kW)\",\"unitNumber\":\"Unit Number\",\"chargingNetwork\":\"CNO/CMS\",\"retireEquipment\":\"Retire Equipment\",\"deleteEquipment\":\"Delete Equipment\",\"returnToFacility\":\"Return to Facility\",\"addNewEquipment\":\"Add New Equipment\",\"forkliftClassification\":\"Forklift Classification\",\"firstActiveReportingPeriod\":\"First Active Reporting Period\",\"fseRegistrationStatus\":\"FSE Registration Status\",\"approved\":\"Approved\",\"location\":\"Location\",\"latitude\":\"Latitude\",\"longitude\":\"Longitude\",\"createdBy\":\"Created By\",\"createdAt\":\"Created Date\",\"equipmentUsage\":\"Equipment Usage\",\"saveUsage\":\"SAVE USAGE\",\"saveChangesTo\":\"Save changes to\",\"searchBySerial\":\"Search by Serial / VIN\",\"viewing\":\"Viewing\",\"pausedForSeasonality\":\"Paused for Seasonality\",\"fuelPathwayCode\":\"Fuel Pathway Code\",\"filterByCode\":\"Filter by Code...\",\"bookAndClaim\":\"Book & Claim\",\"applied\":\"Applied\",\"notApplied\":\"Not Applied\",\"batteryCapacityAh\":\"Battery Capacity (Ah)\",\"voltage\":\"Voltage\",\"chargeCyclesShift\":\"Charge Cycles / Shift\",\"usages\":\"Usages\",\"usage\":\"Usage\",\"usageDetails\":\"Usage Details\",\"category\":\"Category\",\"type\":\"Type\",\"recsRequired\":\"RECs Required\",\"creditsGenerated\":\"Credits Generated\",\"kwhPerChargeCycle\":\"kWh / Charge Cycle\",\"retireWarning\":\"Warning: Retiring this Equipment will discard any Usage data\",\"retireConfirmation\":\"I understand that all usage data after {{period}} will be discarded.\",\"retireMultipleConfirmation\":\"I understand that {{count}} selected equipment will be retired and all usage data after {{period}} will be discarded.\",\"deleteMultipleConfirmation\":\"I understand that {{count}} selected equipment will be permanently deleted and this cannot be undone.\",\"firstDayInService\":\"First Day in Service\",\"creatorDetails\":\"Creator Details\"}}");


var $6ebaa3671b324879$exports = {};
$6ebaa3671b324879$exports = JSON.parse("{\"facility\":{\"facilityList\":\"Facility List\",\"facilityActions\":\"Facility Actions\",\"addFacility\":\"Add Facility\",\"retireFacilities\":\"Retire Facilities\",\"deleteFacilities\":\"Delete Facilities\",\"searchByAddress\":\"Search by address\",\"filterFacilities\":\"Filter Facilities\",\"activityStatus\":\"Activity Status\",\"facilityInfo\":\"Facility Information\",\"chooseProgram\":\"Choose...\",\"utility\":\"FSE Utility\",\"assetOverview\":\"Asset Overview\",\"chooseUtility\":\"Choose...\",\"noPrograms\":\"No Programs are registered for this {{regionType}}.\",\"chooseProgramHelp\":\"Choose a {{regionType}} and first reporting period to see Programs.\",\"chooseUtilityHelp\":\"Choose a state to see available Utilities.\",\"noUtilities\":\"No Utilities found.\",\"retireFacility\":\"Retire Facility\",\"deleteFacility\":\"Delete Facility\",\"assetList\":\"Asset List\",\"retireWarning\":\"Warning: Retiring this Facility will retire all its Equipment, and any Equipment Usage data\",\"retireWarningEnd\":\"will be discarded.\",\"retireConfirmation1\":\"I understand that retiring this Facility will also retire all its Equipment.\",\"retireConfirmation2Start\":\"I understand that all usage data\",\"retireConfirmation2End\":\"will be discarded.\",\"retireMultipleConfirmation_one\":\"I understand that {{count}} selected facility will be retired along with all of its equipment.\",\"retireMultipleConfirmation_other\":\"I understand that {{count}} selected facilities will be retired along with all of their equipment.\",\"deleteMultipleConfirmation_one\":\"I understand that {{count}} selected facility will be permanently deleted and this cannot be undone.\",\"deleteMultipleConfirmation_other\":\"I understand that {{count}} selected facilities will be permanently deleted and this cannot be undone.\"}}");


var $f3922b6fd16ab0c0$exports = {};
$f3922b6fd16ab0c0$exports = JSON.parse("{\"navigation\":{\"dashboard\":\"Dashboard\",\"clients\":\"Clients\",\"facilities\":\"Facilities\",\"equipment\":\"Equipment\",\"users\":\"Users\",\"reports\":\"Reports\",\"apiData\":\"API Data\",\"fuseAdmin\":\"FuSE Admin\",\"unresolvedLogs\":\"Unresolved Logs\",\"viewAllChangeLogs\":\"View All Change Logs\",\"noUnresolvedChangeLogs\":\"No unresolved change logs found.\",\"settings\":\"Settings\",\"company\":\"Company\",\"statements\":\"Statements\",\"support\":\"View support page\",\"adminSearch\":\"Quickly find Clients, Facilities, Equipment, or Users\",\"signedInAs\":\"Signed in as\",\"editProfile\":\"Edit Profile\",\"logout\":\"Log Out\"}}");


var $551908dd362bf8e2$exports = {};
$551908dd362bf8e2$exports = JSON.parse('{"client":{"details":"D\xe9tails","clientList":"Liste des clients","allClients":"Tous les clients","fuseStart":"Date de d\xe9but FuSE","addClient":"Ajouter un client","contacts":"Coordonn\xe9es","documents":"Documents","companyLegalName":"D\xe9nomination sociale de la soci\xe9t\xe9","websiteURL":"URL du site Web","clientStatus":"Statut du client","fuseStartDate":"Date de d\xe9but FuSE","fuseEndDate":"Date de fin FuSE","feinBusinessNumber":"Num\xe9ro d\'identification d\'employeur f\xe9d\xe9ral (FEIN) ou num\xe9ro d\'entreprise","corporateAddress":"Adresse de l\'entreprise","programCountry":"Pays du programme","country":"Pays","countryPlaceholder":"Choisissez le pays de votre programme","unitedStates":"\xc9tats-Unis","canada":"Canada","remittanceInformation":"Informations sur le versement","remittanceAddress":"Adresse de versement","bankingInformation":"Informations bancaires","bankName":"Nom de la banque","bankAccountNumber":"Num\xe9ro de compte bancaire","bankRoutingNumber":"Num\xe9ro de routage de la banque","bankAccountType":"Type de compte bancaire","stripeDetails":"D\xe9tails Stripe","noStripeAccountConnected":"Aucun compte Stripe connect\xe9","addStripeDetails":"Ajouter les d\xe9tails Stripe","stripeUnavailableForCanada":"Les paiements Stripe ne sont pas disponibles pour les clients situ\xe9s au Canada.","accountDetails":"D\xe9tails du compte","displayName":"Nom d\'affichage","noDisplayName":"Aucun nom d\'affichage","contactEmail":"Courriel de contact","enterEmailAddress":"Entrer l\'adresse courriel","linkedBankAccount":"Compte bancaire li\xe9","updateBankAccount":"Mettre \xe0 jour le compte bancaire","completeBankingDetails":"Compl\xe9ter les d\xe9tails bancaires","routingNumber":"Num\xe9ro de routage","last4":"4 derniers","retired":"Retir\xe9","retireClient":"Retirer le client","retire":"Retirer","lastReportingPeriod":"Derni\xe8re p\xe9riode de d\xe9claration","retireButton":"RETIRER","retiringButton":"RETRAIT EN COURS...","retireWarning":"Avertissement : Le retrait de ce client retirera \xe9galement tous ses \xe9quipements, et toutes les donn\xe9es d\'utilisation de l\'\xe9quipement","retireWarningEnd":"seront supprim\xe9es.","theLastReportingPeriod":"la derni\xe8re p\xe9riode de d\xe9claration","retireConfirmation1":"Je comprends que le retrait de ce client retirera \xe9galement tous ses \xe9quipements.","retireConfirmation2Start":"Je comprends que toutes les donn\xe9es d\'utilisation de l\'\xe9quipement","retireConfirmation2End":"seront supprim\xe9es.","selectPeriod":"S\xe9lectionner une p\xe9riode\u2026","noProgramMessage":"Un programme doit \xeatre ajout\xe9 \xe0 ce client avant de s\xe9lectionner la derni\xe8re p\xe9riode de reporting."},"contacts":{"pointsOfContact":"Points de contact","pointsOfContactDescription":"Tous les utilisateurs Admin de cette {{entityType}} seront consid\xe9r\xe9s comme des points de contact.","pointsOfContactDescriptionClient":"Tous les utilisateurs Admin de ce Client et {{entityType}} seront consid\xe9r\xe9s comme des points de contact.","client":"Client","corporateContacts":"Coordonn\xe9es professionnelles","remittanceContacts":"Coordonn\xe9es de versement","facilityContacts":"Coordonn\xe9es d\'installation","contact":"Contact","contactRole":"R\xf4le du contact","contactName":"Nom du contact","contactEmail":"Courriel du contact","contactPhone":"T\xe9l\xe9phone du contact","choose":"Choisir..."},"documents":{"title":"Biblioth\xe8que de documents","uploadDocument":"T\xe9l\xe9charger le document","documentName":"Nom du document","documentType":"Type de document","dateUploaded":"Date de t\xe9l\xe9charg\xe9e","uploadedBy":"T\xe9l\xe9charg\xe9 par","noDocumentsFound":"Aucun document trouv\xe9","noDocumentsMatchFilters":"Aucun document ne correspond aux filtres s\xe9lectionn\xe9s","clearFilters":"Effacer les filtres","characterLimit":"/500 caract\xe8res","noComments":"Aucun commentaire","saveChanges":"Enregistrer les modifications","cancelEditing":"Annuler l\'\xe9dition","downloadDocument":"T\xe9l\xe9charger le document","seeMore":"Voir plus","collapse":"R\xe9duire","editComments":"Modifier les commentaires","deleteDocument":"Supprimer le document","deleteDocumentWarning":"Voulez-vous vraiment supprimer ce document?","deleteDocumentConfirm":"Je comprends que cette action est irr\xe9versible.","processing":"En cours de traitement","needsReview":"En attente de revue","selectDocumentType":"S\xe9lectionner le type de document","addComments":"Ajouter des commentaires (facultatif)","cancel":"Annuler","upload":"T\xe9l\xe9charger","dropFiles":"D\xe9posez les fichiers ici ou cliquez pour","browse":"parcourir","selectedFile":"Fichier s\xe9lectionn\xe9","cannotDownloadWhileProcessing":"Impossible de t\xe9l\xe9charger le document en cours de traitement","cannotDownloadFileNeedsReview":"Impossible de t\xe9l\xe9charger le document en attente de revue","searchByName":"Recherche par nom","downloadSelected":"T\xe9l\xe9charger la s\xe9lection","preparingDownload":"Pr\xe9paration...","all":"Tous","filterDocuments":"Filtrer les documents","bulkDownloadPartial":"{{downloaded}} document(s) t\xe9l\xe9charg\xe9(s), {{skipped}} ignor\xe9(s) (en traitement ou en attente de revue).","bulkDownloadUnavailable":"{{count}} document(s) s\xe9lectionn\xe9(s) ne peuvent pas \xeatre t\xe9l\xe9charg\xe9s pour le moment (en traitement ou en attente de revue)."},"statements":{"statements":"Relev\xe9s","statementList":"Liste des relev\xe9s","incentiveStatements":"Relev\xe9s d\'incitatifs","summary":"R\xe9sum\xe9 (imprimable)","details":"D\xe9tails (imprimable)","viewIndividualPrograms":"Voir les programmes individuels","hideIndividualPrograms":"Masquer les programmes individuels","viewIndividualProgram":"Voir le programme individuel","hideIndividualProgram":"Masquer le programme individuel","noStatementsFound":"Aucun relev\xe9 trouv\xe9","allPrograms":"Tous les programmes","individualStatement":"Relev\xe9 individuel","downloadPDF":"T\xe9l\xe9charger PDF","downloadCSV":"T\xe9l\xe9charger CSV","detailedStatement":"Relev\xe9 d\xe9taill\xe9","incentiveStatement":"Relev\xe9 d\'incitatifs","credits":"Cr\xe9dits","accountEndingIn":"Compte terminant par","creditPrice":"Prix du cr\xe9dit","totalValue":"Valeur totale","recCost":"Co\xfbt des RECs","brokerCost":"Co\xfbt de courtage","taxesOnCreditSale":"Taxes sur la vente de cr\xe9dits","taxesOnServices":"Taxes sur les services","fuseServiceFee":"Frais de service FuSE","netIncentive":"Incitatif net","totals":"Totaux","costRecoup":"Recouvrement des co\xfbts (si applicable)","grandTotal":"Total g\xe9n\xe9ral","calculationKey":"Cl\xe9 de calcul","definition":"D\xe9finition","taxesOnCreditSaleDefinition":"Applicable uniquement au programme BC LCFS. Taxes calcul\xe9es \xe0 5 % de la valeur totale.","taxesOnServicesDefinition":"TPS, TVH et TVP applicables, calcul\xe9es selon la province du si\xe8ge social du client.","caFuseServiceFeeDefinition":"Commission convenue retenue par FuSE.","creditsDefinition":"La g\xe9n\xe9ration de cr\xe9dits est bas\xe9e sur la quantit\xe9 de kWh d\xe9clar\xe9s, utilis\xe9s ou distribu\xe9s par votre \xe9quipement \xe9lectrique.","creditPriceDefinition":"Le prix du cr\xe9dit est d\xe9termin\xe9 par la valeur de chaque cr\xe9dit vendu \xe0 des entit\xe9s r\xe9glement\xe9es (soci\xe9t\xe9s p\xe9troli\xe8res et gazi\xe8res) sur le march\xe9 libre.","recCostDefinition":"Les certificats d\'\xe9nergie renouvelable (RECs) sont des m\xe9gawattheures d\'\xe9lectricit\xe9 propre achet\xe9s en votre nom afin d\'augmenter le nombre de cr\xe9dits g\xe9n\xe9r\xe9s, lorsque cela est financi\xe8rement avantageux. L\'achat de RECs \xe0 ce co\xfbt entra\xeene une augmentation des cr\xe9dits et des revenus g\xe9n\xe9r\xe9s.","brokerCostDefinition":"Co\xfbt administratif associ\xe9 aux services de courtage, \xe0 l\'achat de RECs et \xe0 la conclusion de contrats avec des entit\xe9s r\xe9glement\xe9es.","fuseServiceFeeDefinition":"Commission convenue retenue par FuSE apr\xe8s la soustraction du co\xfbt des RECs et du co\xfbt de courtage.","costRecoupDefinition":"Fonds retenus lorsque FuSE a avanc\xe9 le co\xfbt du mat\xe9riel de mesure ou d\'autres activit\xe9s d\'Exchange.","netIncentiveDefinition":"Montant remis \xe0 votre organisation apr\xe8s que tous les co\xfbts et les frais ont \xe9t\xe9 soustraits.","incentiveStatementNotice":"Le relev\xe9 d\'incitatifs ci-dessous refl\xe8te les cr\xe9dits g\xe9n\xe9r\xe9s par la flotte/l\'\xe9quipement \xe9lectrique inscrit de votre organisation dans le cadre d\'un programme de norme sur les carburants propres applicable \xe0 l\'\xc9tat, \xe0 la province ou au niveau f\xe9d\xe9ral. Pour toute question ou information suppl\xe9mentaire, veuillez contacter notre \xe9quipe \xe0 support@usefuse.com ou via la fonction de chat dans l\'application."},"commissions":{"commissions":"Commissions","fuseCommissions":"Commissions FuSE","percentage":"Pourcentage","fixedRate":"Taux fixe","effectiveStartDate":"Date de d\xe9but effective","effectiveEndDate":"Date de fin effective","salesCommissions":"Commissions de vente","referralCommissions":"Commissions de r\xe9f\xe9rence","referralPartner":"Partenaire de r\xe9f\xe9rence"},"user":{"user":"Utilisateur","users":"Utilisateurs","userList":"Liste des utilisateurs","company":"Compagnie","lastLogin":"Derni\xe8re connexion","addUser":"Ajouter un utilisateur","userRole":"R\xf4le utilisateur","userStatus":"Statut utilisateur","inactive":"Inactif","email":"Courriel","phone":"T\xe9l\xe9phone","noUsersFound":"Aucun utilisateur trouv\xe9","userInformation":"Informations utilisateur","contactInformation":"Informations de contact","created":"Cr\xe9\xe9","updatePassword":"Mettre \xe0 jour le mot de passe","currentPassword":"Mot de passe actuel","newPassword":"Nouveau mot de passe","confirmNewPassword":"Confirmer le nouveau mot de passe","passwordRegex":"Le mot de passe doit contenir au moins 16 caract\xe8res et doit contenir au moins une lettre majuscule, une lettre minuscule, un chiffre et un caract\xe8re sp\xe9cial (!@#$%^&*)"}}');


var $5a1833716288cabd$exports = {};
$5a1833716288cabd$exports = JSON.parse('{"common":{"saveChanges":"ENREGISTRER LES MODIFICATIONS","savingChanges":"ENREGISTREMENT EN COURS...","cancel":"ANNULER","title":"Connectez-vous","signIn":"CONNEXION","save":"Enregistrer","troubleSigningIn":"Probl\xe8me de connexion?","resetPassword":"R\xe9initialiser le mot de passe","email":"Courriel","password":"Mot de passe","findFieldByName":"Trouver un champ par nom...","find":"Trouver","by":"Par","choose":"Choisir...","selectPeriod":"S\xe9lectionner une p\xe9riode...","reasonForRetiring":"Raison du retrait","selectReason":"S\xe9lectionner la raison...","selectAll":"Tout s\xe9lectionner","clearAll":"Tout effacer","selectedCount_one":"{{count}} s\xe9lectionn\xe9","selectedCount_other":"{{count}} s\xe9lectionn\xe9s","otherReasonDescription":"Veuillez pr\xe9ciser la raison","address":"Adresse","addressContinued":"Adresse (continu\xe9e)","city":"Ville","stateProvince":"\xc9tat / Province","postalCode":"Code postal","requiredField":"* Champ obligatoire","apply":"APPLIQUER","applying":"APPLIQUANT...","clear":"EFFACER","filters":"Filtrer","loading":"Chargement...","yes":"Oui","no":"Non","close":"Fermer","after":"apr\xe8s","viewDashboard":"Afficher le tableau de bord","enterName":"Entrez un nom","alreadyHaveAccount":"Vous avez d\xe9j\xe0 un compte?","enterEmailAssociatedWithAccount":"Entrez l\'adresse e-mail associ\xe9e \xe0 votre compte et nous vous enverrons un lien pour r\xe9initialiser votre mot de passe.","restartPageTour":"Red\xe9marrer la visite guid\xe9e","status":"\xc9tat","name":"Nom","active":"Actif","retired":"Retir\xe9","all":"Tout","comments":"Commentaires","finalized":"Finalis\xe9","firstReportingPeriod":"Premi\xe8re p\xe9riode de d\xe9claration","lastReportingPeriod":"Derni\xe8re p\xe9riode de d\xe9claration","theLastReportingPeriod":"la derni\xe8re p\xe9riode de d\xe9claration","retire":"Retirer","retireButton":"RETIRER","retiringButton":"RETRAIT EN COURS...","program":"Programme","reportingPeriod":"P\xe9riode de rapports","totalKwh":"kWh Totaux","clientName":"Nom du client","remittanceMethod":"M\xe9thode de versement","generalInfo":"Informations g\xe9n\xe9rales","facility":"Installation","facilities":"Installations","unsavedFilters":"Les filtres n\'ont pas \xe9t\xe9 appliqu\xe9s"},"language":{"en":"English","fc":"Fran\xe7ais"}}');


var $7457814a7ba202f5$exports = {};
$7457814a7ba202f5$exports = JSON.parse('{"dashboard":{"exportPDF":"Exporter au format PDF","yourFacilities":"Vos installations","companyPageLink":"Aller \xe0 la page Compagnie","kwhConsumed":"kWh consomm\xe9s","energyConsumption":"Consommation d\'\xe9nergie utilis\xe9e pour les rapports","mtCo2eDisplaced":"MT CO2e d\xe9plac\xe9s","equalToCreditsGeneratedToDate":"\xc9gal aux cr\xe9dits g\xe9n\xe9r\xe9s \xe0 ce jour","totalNetRevenueToDate":"Revenu net total \xe0 ce jour","valueOfCreditsTransacted":"Valeur des cr\xe9dits \xe9chang\xe9s","avgCostPerKwh":"Moy. $/kWh","enrolledVehiclesAndEquipment":"V\xe9hicules et \xe9quipement inscrits","totalNumberOfAssetsProducingCredits":"Nombre total d\'actifs produisant des cr\xe9dits","daysToNextCreditMinting":"Jours avant le prochain forgeage de cr\xe9dits","periodIncentiveRevenue":"P\xe9riode de revenu incitatif","cumulativeEnrollmentTrends":"Tendances cumul\xe9es des inscriptions","revenueBreakdown":"Ventilation des revenus","byEquipmentType":"Par type d\'\xe9quipement","byProgram":"Par programme","equipmentTypeByFacility":"Type d\'\xe9quipement par installation","currentFacilityLocations":"Emplacements actuels des installations","percentRevenueByEquipmenttype":"Pourcentage de revenu par type d\'\xe9quipement","percentRevenueByProgram":"Pourcentage de revenu par programme"}}');


var $1e137cd45bdd3053$exports = {};
$1e137cd45bdd3053$exports = JSON.parse('{"equipment":{"add":"Ajouter","equipment":"\xc9quipement","equipmentList":"Liste d\'\xe9quipements","equipmentDetails":"D\xe9tails de l\'\xe9quipement","viewEquipmentDetails":"Voir les d\xe9tails de l\'\xe9quipement","filterEquipment":"Filtrer par \xc9quipement","equipmentActions":"Actions relatives \xe0 l\'\xe9quipement","equipmentUseCase":"Cas d\'utilisation de l\'\xe9quipement","chargingType":"Type de charge","meter":"Compteur","serialVin":"S\xe9rie / NIV","manufacturer":"Manufacturier","modelYear":"Ann\xe9e de mod\xe8le","modelNumber":"Num\xe9ro de mod\xe8le","unitNo":"Num\xe9ro d\'unit\xe9","meteredKwh":"kWh mesur\xe9s","activityStatus":"Statut d\'activit\xe9","meterType":"Type de compteur","editMetered":"Modifier mesur\xe9","editUnmetered":"Modifier non mesur\xe9","addEquipment":"Ajouter un \xe9quipement","viewEquipmentId":"Voir l\'ID de l\'\xe9quipement","save":"Enregistrer","searchBySerial":"Rechercher par num\xe9ro de s\xe9rie / NIV","metered":"Mesur\xe9","unmetered":"Non mesur\xe9","updateMeteredEquipmentUsage":"Mettre \xe0 jour l\'utilisation de l\'\xe9quipement mesur\xe9e","bulkEditAllKwh":"Modifier en bloc tous les kWh mesur\xe9s","bulkEditAllKwhHelp":"Cette valeur sera appliqu\xe9e \xe0 tous les \xe9quipements mesur\xe9s pour cette p\xe9riode de d\xe9claration.","noMeteredEquipmentUsageDataFound":"Aucune donn\xe9e d\'utilisation d\'\xe9quipement mesur\xe9e trouv\xe9e pour cette trimestre.","noUsageDataFound":"Aucune donn\xe9e d\'utilisation d\'\xe9quipement trouv\xe9e pour cet \xe9quipement.","operationDetails":"D\xe9tails de l\'op\xe9ration","chargingCyclesShift":"Cycles de charge / Quart","shiftsDay":"Quarts / Jour","workDaysQuarter":"Jours de travail / Trimestre","percentUptime":"Temps de disponibilit\xe9","maxSiteDeliverabilityKw":"Puissance maximale du site (kW)","chargerEfficiencyRating":"Taux d\'efficacit\xe9 du chargeur","chargeReturnFactor":"Facteur de retour de charge","depthOfDischarge":"Profondeur de d\xe9charge","periodHasBeenLockedAndCannotBeEdited":"Cette p\xe9riode a \xe9t\xe9 verrouill\xe9e et ne peut plus \xeatre modifi\xe9e.","periodHasBeenFinalizedAndCanNoLongerBeEdited":"Cette p\xe9riode a \xe9t\xe9 finalis\xe9e et ne peut plus \xeatre modifi\xe9e.","whatAreYouChargingOrPowering":"Que chargez-vous ou alimentez-vous?","equipmentCategory":"Cat\xe9gorie d\'\xe9quipement","equipmentType":"Type d\'\xe9quipement","serialNumber":"Num\xe9ro de s\xe9rie","nameplateRating":"Puissance nominale (kW)","unitNumber":"Num\xe9ro d\'unit\xe9","chargingNetwork":"CNO/CMS","forkliftClassification":"Classification de chariot \xe9l\xe9vateur","firstActiveReportingPeriod":"Premi\xe8re p\xe9riode d\'activit\xe9","retireEquipment":"Retirer l\'\xe9quipement","deleteEquipment":"Supprimer l\'\xe9quipement","returnToFacility":"Retour \xe0 l\'installation","addNewEquipment":"Ajouter un nouvel \xe9quipement","fseRegistrationStatus":"Statut d\'enregistrement FSE","approved":"Approuv\xe9","location":"Emplacement","latitude":"Latitude","longitude":"Longitude","createdBy":"Cr\xe9\xe9 par","createdAt":"Date de cr\xe9ation","equipmentUsage":"Utilisation de l\'\xe9quipement","saveUsage":"ENREGISTRER L\'UTILISATION","saveChangesTo":"Enregistrer les modifications \xe0","viewing":"Affichage","pausedForSeasonality":"En pause pour saisonnalit\xe9","fuelPathwayCode":"Code de voie de carburant","filterByCode":"Filtrer par code...","bookAndClaim":"R\xe9server et r\xe9clamer","applied":"Appliqu\xe9","notApplied":"Non appliqu\xe9","batteryCapacityAh":"Capacit\xe9 de la batterie (Ah)","voltage":"Tension","chargeCyclesShift":"Cycles de charge / Quarts","usages":"Utilisations","usage":"Utilisation","usageDetails":"D\xe9tails d\'utilisation","category":"Cat\xe9gorie","type":"Type","recsRequired":"RECs requis","creditsGenerated":"Cr\xe9dits g\xe9n\xe9r\xe9s","kwhPerChargeCycle":"kWh / Cycle de charge","retireWarning":"Avertissement : Le retrait de cet \xe9quipement supprimera toutes les donn\xe9es d\'utilisation","retireConfirmation":"Je comprends que toutes les donn\xe9es d\'utilisation apr\xe8s {{period}} seront supprim\xe9es.","retireMultipleConfirmation_one":"Je comprends que {{count}} \xe9quipement s\xe9lectionn\xe9 sera retir\xe9 et que toutes les donn\xe9es d\'utilisation apr\xe8s {{period}} seront supprim\xe9es.","retireMultipleConfirmation_other":"Je comprends que {{count}} \xe9quipements s\xe9lectionn\xe9s seront retir\xe9s et que toutes les donn\xe9es d\'utilisation apr\xe8s {{period}} seront supprim\xe9es.","deleteMultipleConfirmation_one":"Je comprends que {{count}} \xe9quipement s\xe9lectionn\xe9 sera supprim\xe9 d\xe9finitivement et que cette action est irr\xe9versible.","deleteMultipleConfirmation_other":"Je comprends que {{count}} \xe9quipements s\xe9lectionn\xe9s seront supprim\xe9s d\xe9finitivement et que cette action est irr\xe9versible.","firstDayInService":"Premier jour en service","creatorDetails":"D\xe9tails du cr\xe9ateur"}}');


var $38075919c61d97c6$exports = {};
$38075919c61d97c6$exports = JSON.parse('{"facility":{"facilityList":"Liste des installations","facilityActions":"Actions sur les installations","addFacility":"Ajouter une installation","retireFacilities":"Retirer les installations","deleteFacilities":"Supprimer les installations","searchByAddress":"Rechercher par adresse","filterFacilities":"Filtrer les installations","activityStatus":"Statut d\'activit\xe9","facilityInfo":"Informations sur les installations","chooseProgram":"Choisir...","utility":"Service public de charge finale","assetOverview":"Aper\xe7u des actifs","chooseUtility":"Choisir...","noPrograms":"Aucun programme n\'est enregistr\xe9 pour cette {{regionType}}.","chooseProgramHelp":"Choisissez une {{regionType}} et une premi\xe8re p\xe9riode de d\xe9claration pour voir les programmes.","chooseUtilityHelp":"Choisissez un \xe9tat pour afficher les services publics disponibles.","noUtilities":"Aucun service public trouv\xe9.","retireFacility":"Retirer l\'installation","deleteFacility":"Supprimer l\'installation","assetList":"Liste des actifs","retireWarning":"Avertissement : Le retrait de cette installation retirera tous ses \xe9quipements, et toutes les donn\xe9es d\'utilisation de l\'\xe9quipement","retireWarningEnd":"seront supprim\xe9es.","retireConfirmation1":"Je comprends que le retrait de cette installation retirera \xe9galement tous ses \xe9quipements.","retireConfirmation2Start":"Je comprends que toutes les donn\xe9es d\'utilisation de l\'\xe9quipement","retireConfirmation2End":"seront supprim\xe9es.","retireMultipleConfirmation_one":"Je comprends que {{count}} installation s\xe9lectionn\xe9e sera retir\xe9e ainsi que tous ses \xe9quipements.","retireMultipleConfirmation_other":"Je comprends que {{count}} installations s\xe9lectionn\xe9es seront retir\xe9es ainsi que tous leurs \xe9quipements.","deleteMultipleConfirmation_one":"Je comprends que {{count}} installation s\xe9lectionn\xe9e sera supprim\xe9e d\xe9finitivement et que cette action est irr\xe9versible.","deleteMultipleConfirmation_other":"Je comprends que {{count}} installations s\xe9lectionn\xe9es seront supprim\xe9es d\xe9finitivement et que cette action est irr\xe9versible."}}');


var $d31173df7ed15dfe$exports = {};
$d31173df7ed15dfe$exports = JSON.parse('{"navigation":{"dashboard":"Tableau de bord","clients":"Clients","facilities":"Installations","equipment":"\xc9quipements","users":"Utilisateurs","apiData":"Donn\xe9es API","fuseAdmin":"FuSE Admin","reports":"Rapports","unresolvedLogs":"Logs non r\xe9solus","viewAllChangeLogs":"Voir tous les journaux de changement","noUnresolvedChangeLogs":"Aucun journal de changement non r\xe9solu trouv\xe9.","settings":"Param\xe8tres","company":"Compagnie","statements":"Relev\xe9s","support":"Afficher la page d\'assistance","adminSearch":"Trouvez rapidement des clients, des installations, des \xe9quipements ou des utilisateurs","signedInAs":"Connect\xe9 en tant que","editProfile":"Modifier le profil","logout":"Se d\xe9connecter"}}');


const $71ae756b61e29b21$export$bc99aaabaf7b70a7 = {
    en: {
        ...(0, (/*@__PURE__*/$parcel$interopDefault($15140eded40257ac$exports))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($f3922b6fd16ab0c0$exports))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1e503e3739d008c0$exports))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($d220cacd4bfe6ba5$exports))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($2f25af50a9e13990$exports))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($6ebaa3671b324879$exports))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($3e17fc7b6f879ba7$exports)))
    },
    fc: {
        ...(0, (/*@__PURE__*/$parcel$interopDefault($5a1833716288cabd$exports))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($d31173df7ed15dfe$exports))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($7457814a7ba202f5$exports))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($551908dd362bf8e2$exports))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1e137cd45bdd3053$exports))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($38075919c61d97c6$exports)))
    }
};
(0, $5a060c72de474321$export$2e2bcd8739ae039).use((0, $a6873cffd63c6d43$export$2e2bcd8739ae039)).use((0, $abb9f84ea4370813$export$ae7e14d40d89f296)).init({
    resources: $71ae756b61e29b21$export$bc99aaabaf7b70a7,
    fallbackLng: 'en',
    defaultNS: 'common',
    keySeparator: false,
    ns: Object.keys($71ae756b61e29b21$export$bc99aaabaf7b70a7.en),
    interpolation: {
        escapeValue: false
    },
    detection: {
        order: [
            'localStorage',
            'navigator'
        ],
        caches: [
            'localStorage'
        ]
    }
});
var $71ae756b61e29b21$export$2e2bcd8739ae039 = (0, $5a060c72de474321$export$2e2bcd8739ae039);




var $2xPiy = parcelRequire("2xPiy");


var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");
var $83f2052c15a18307$export$6a1689aaa66d814c = function findScrollParent(element, horizontal) {
    var result;
    if (element) {
        var parent = element.parentNode;
        while(!result && parent && parent.getBoundingClientRect){
            var rect = parent.getBoundingClientRect();
            // 10px is to account for borders and scrollbars in a lazy way
            if (horizontal) {
                if (rect.width && parent.scrollWidth > rect.width + 10) result = parent;
            } else if (rect.height && parent.scrollHeight > rect.height + 10) result = parent;
            parent = parent.parentNode;
        }
        // last scrollable element will be the document
        // if nothing else is scrollable in the page
        if (!result) result = document;
        else if (result.tagName.toLowerCase() === 'body') result = document;
    }
    return result;
};
var $83f2052c15a18307$var$documentTags = [
    'html',
    'body'
];
var $83f2052c15a18307$export$14e46d92eb0648e = function findScrollParents(element, horizontal) {
    var result = [];
    if (element) {
        var parent = element.parentNode;
        while(parent && parent.getBoundingClientRect){
            var rect = parent.getBoundingClientRect();
            // 10px is to account for borders and scrollbars in a lazy way
            if (horizontal) {
                if (rect.width && parent.scrollWidth > rect.width + 10) result.push(parent);
            } else if (rect.height && parent.scrollHeight > rect.height + 10) result.push(parent);
            parent = parent.parentNode;
        }
        if (result.length && $83f2052c15a18307$var$documentTags.includes(result[0].tagName.toLowerCase())) result.length = 0;
        // last scrollable element will be the document
        result.push(document);
    }
    return result;
};
var $83f2052c15a18307$export$b03135936dd040ba = function containsFocus(node) {
    var root = node.getRootNode();
    var element = root.activeElement;
    while(element){
        if (element === node) break;
        element = element.parentElement;
    }
    return !!element;
};
var $83f2052c15a18307$export$357c244c06d83dec = function withinDropPortal(node, portalContext) {
    var root = node == null ? void 0 : node.getRootNode();
    var element = node;
    var portalId;
    while(element && element !== root)if (element.hasAttribute('data-g-portal-id')) {
        portalId = element.getAttribute('data-g-portal-id');
        element = root;
    } else element = element.parentElement;
    // if portalContext doesn't contain the portalId then the
    // portal is new and node is within a drop that just opened
    if (portalId === undefined || portalContext.indexOf(parseInt(portalId, 10)) !== -1) return false;
    return true;
};
var $83f2052c15a18307$export$4c063cf1350e6fed = function isFocusable(element) {
    var tagName = element.tagName.toLowerCase();
    return tagName === 'input' || tagName === 'select' || tagName === 'textarea';
};
var $83f2052c15a18307$export$e957a3ef02119493 = function getFirstFocusableDescendant(element) {
    var children = element.getElementsByTagName('*');
    for(var i = 0; i < children.length; i += 1){
        var child = children[i];
        if ($83f2052c15a18307$export$4c063cf1350e6fed(child)) return child;
    }
    return undefined;
};
var $83f2052c15a18307$export$19f1b4b3dc25c57 = function shouldKeepFocus(root) {
    var element = root.activeElement;
    if ($83f2052c15a18307$export$4c063cf1350e6fed(element)) return true;
    return !!$83f2052c15a18307$export$e957a3ef02119493(element);
};
var $83f2052c15a18307$export$1cad4a11c7ad1375 = function getNewContainer(target, targetChildPosition) {
    if (target === void 0) target = document.body;
    // setup DOM
    var container = document.createElement('div');
    if (targetChildPosition === 'first') // for SkipLinks
    target.prepend(container);
    else target.appendChild(container);
    return container;
};
var $83f2052c15a18307$export$99137e580254b26a = function setFocusWithoutScroll(element) {
    var x = window.scrollX;
    var y = window.scrollY;
    element.focus();
    window.scrollTo(x, y);
};
var $83f2052c15a18307$var$TABINDEX = 'tabindex';
var $83f2052c15a18307$var$TABINDEX_STATE = 'data-g-tabindex';
var $83f2052c15a18307$export$d25257a562ca003b = function makeNodeFocusable(node) {
    // do not touch aria live containers so that announcements work
    if (!node.hasAttribute('aria-live')) {
        node.removeAttribute('aria-hidden');
        // allow children to receive focus again
        var elements = node.getElementsByTagName('*');
        // only reset elements we've changed in makeNodeUnfocusable()
        Array.prototype.filter.call(elements || [], function(element) {
            return element.hasAttribute($83f2052c15a18307$var$TABINDEX_STATE);
        }).forEach(function(element) {
            var prior = element.getAttribute($83f2052c15a18307$var$TABINDEX_STATE);
            if (prior >= 0) element.setAttribute($83f2052c15a18307$var$TABINDEX, element.getAttribute($83f2052c15a18307$var$TABINDEX_STATE));
            else if (prior === 'none') element.removeAttribute($83f2052c15a18307$var$TABINDEX);
            element.removeAttribute($83f2052c15a18307$var$TABINDEX_STATE);
        });
    }
};
// Using ^ and $ to match the whole tagName, and not e.g. <meta> and <data>.
var $83f2052c15a18307$var$autoFocusingTags = /^(a|area|input|select|textarea|button|iframe)$/;
var $83f2052c15a18307$export$f17a564c864b60a0 = function makeNodeUnfocusable(node) {
    // do not touch aria live containers so that announcements work
    if (!node.hasAttribute('aria-live')) {
        node.setAttribute('aria-hidden', true);
        // prevent children to receive focus
        var elements = node.getElementsByTagName('*');
        // first, save off the tabIndex of any element with one
        Array.prototype.filter.call(elements || [], function(element) {
            return element.getAttribute($83f2052c15a18307$var$TABINDEX) !== null;
        }).forEach(function(element) {
            // if TABINDEX_STATE already exists, it's holding the original value
            if (!element.getAttribute($83f2052c15a18307$var$TABINDEX_STATE)) element.setAttribute($83f2052c15a18307$var$TABINDEX_STATE, element.getAttribute($83f2052c15a18307$var$TABINDEX));
            element.setAttribute($83f2052c15a18307$var$TABINDEX, -1);
        });
        // then, if any element is inherently focusable and not handled above,
        // give it a tabIndex of -1 so it can't receive focus
        Array.prototype.filter.call(elements || [], function(element) {
            var currentTag = element.tagName.toLowerCase();
            return currentTag.match($83f2052c15a18307$var$autoFocusingTags) && element.focus && element.getAttribute($83f2052c15a18307$var$TABINDEX_STATE) === null;
        }).forEach(function(element) {
            element.setAttribute($83f2052c15a18307$var$TABINDEX_STATE, 'none');
            element.setAttribute($83f2052c15a18307$var$TABINDEX, -1);
        });
    }
};
var $83f2052c15a18307$export$4fe2c44731a76aa0 = function findVisibleParent(element) {
    if (element) // Get the closest ancestor element that is positioned.
    return element.offsetParent ? element : $83f2052c15a18307$export$4fe2c44731a76aa0(element.parentElement) || element;
    return undefined;
};
var $83f2052c15a18307$export$27af05f039e10378 = function isNodeAfterScroll(node, target) {
    var _node$getBoundingClie = node.getBoundingClientRect(), bottom = _node$getBoundingClie.bottom;
    // target will be the document from findScrollParent()
    var _ref = target.getBoundingClientRect ? target.getBoundingClientRect() : {
        height: 0,
        top: 0
    }, height = _ref.height, top = _ref.top;
    return bottom >= top + height;
};
var $83f2052c15a18307$export$54c9800883215719 = function isNodeBeforeScroll(node, target) {
    var _node$getBoundingClie2 = node.getBoundingClientRect(), top = _node$getBoundingClie2.top;
    // target will be the document from findScrollParent()
    var _ref2 = target.getBoundingClientRect ? target.getBoundingClientRect() : {
        top: 0
    }, targetTop = _ref2.top;
    return top <= targetTop;
};
var $83f2052c15a18307$export$37a8984127440e55 = function findButtonParent(element) {
    if (element && element.nodeName !== 'BUTTON' && element.nodeName !== 'A') return $83f2052c15a18307$export$37a8984127440e55(element.parentElement);
    return element;
};


var $2xPiy = parcelRequire("2xPiy");
var $0a9f81b63fff2436$export$a123f939253731a8 = function useSizedIcon(icon, size, theme) {
    var _theme$icon;
    return icon && theme != null && (_theme$icon = theme.icon) != null && _theme$icon.matchSize && !icon.props.size ? /*#__PURE__*/ (0, $2xPiy.cloneElement)(icon, {
        size: size
    }) : icon;
};



var $dyr1f = parcelRequire("dyr1f");

function $5dfd77e0cc14bfcb$var$_extends() {
    return $5dfd77e0cc14bfcb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5dfd77e0cc14bfcb$var$_extends.apply(null, arguments);
}
var $5dfd77e0cc14bfcb$var$PropType = {};
$5dfd77e0cc14bfcb$var$PropType = $5dfd77e0cc14bfcb$var$_extends({}, (0, $ab32ce3df36aa105$export$ffe37ff34eeb9e21), {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node
    ]),
    active: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).elementType
    ]),
    badge: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            background: (0, $ab32ce3df36aa105$export$f8a44c6979fe9fe5),
            max: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number
            ])
        })
    ]),
    busy: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    color: (0, $ab32ce3df36aa105$export$fc4c368d97afb623),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    fill: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'horizontal',
            'vertical'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
    ]),
    focusIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'inset'
        ])
    ]),
    gap: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'none',
            'xxsmall',
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    hoverIndicator: (0, $ab32ce3df36aa105$export$e4126213490fff97),
    href: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).element,
    justify: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'around',
        'between',
        'center',
        'end',
        'evenly',
        'start',
        'stretch'
    ]),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node,
    messages: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        busy: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        success: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    }),
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    pad: (0, $ab32ce3df36aa105$export$b91a2ef62736aae3),
    plain: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    primary: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    reverse: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    secondary: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'small',
            'medium',
            'large'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    success: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    target: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            '_self',
            '_blank',
            '_parent',
            '_top'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    tip: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            content: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node,
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            ]),
            dropProps: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({}),
            plain: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    type: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'button',
        'reset',
        'submit'
    ])
});
var $5dfd77e0cc14bfcb$export$932f054f6b4bba8d = $5dfd77e0cc14bfcb$var$PropType;



var $2xPiy = parcelRequire("2xPiy");

var $dyr1f = parcelRequire("dyr1f");
var $801b12eb37c58588$var$PropType = {};
$801b12eb37c58588$var$PropType = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func
};
var $801b12eb37c58588$export$33f2254b5dbf828a = $801b12eb37c58588$var$PropType;


var $c8f61343d2547c6a$var$DEFAULT_MODE = 'polite';
var $c8f61343d2547c6a$var$invisibleChars = [
    "\u200B",
    "\uFEFF",
    "\u200C",
    "\u200D"
];
var $c8f61343d2547c6a$var$createAnnouncer = function createAnnouncer() {
    var announcer = document.createElement('div');
    announcer.id = 'grommet-announcer';
    announcer.setAttribute('aria-live', $c8f61343d2547c6a$var$DEFAULT_MODE);
    announcer.setAttribute('aria-atomic', 'true');
    announcer.style.left = '-100%';
    announcer.style.right = '100%';
    announcer.style.position = 'fixed';
    announcer.style['z-index'] = '-1';
    document.body.insertBefore(announcer, document.body.firstChild);
    return announcer;
};
var $c8f61343d2547c6a$var$announceCounter = 0; // Counter to ensure unique announcements
var $c8f61343d2547c6a$var$clearTimeoutId; // Variable to hold the timeout ID for clearing
var $c8f61343d2547c6a$export$dcc8f4bff0d51f50 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createContext(function(message, mode, timeout) {
    if (mode === void 0) mode = $c8f61343d2547c6a$var$DEFAULT_MODE;
    if (timeout === void 0) timeout = 500;
    // we only create a new container if we don't have one already
    // we create a separate node so that grommet does not set aria-hidden to it
    var announcer = document.body.querySelector("#grommet-announcer[aria-live]") || $c8f61343d2547c6a$var$createAnnouncer();
    announcer.setAttribute('aria-live', mode);
    // Clear any existing timeout before setting a new one
    if ($c8f61343d2547c6a$var$clearTimeoutId) clearTimeout($c8f61343d2547c6a$var$clearTimeoutId);
    if (mode === 'polite') // using setTimeout for polite mode pushes to next event loop tick,
    // giving time for the browser to process the change
    setTimeout(function() {
        var uniqueChar = $c8f61343d2547c6a$var$invisibleChars[$c8f61343d2547c6a$var$announceCounter % $c8f61343d2547c6a$var$invisibleChars.length];
        $c8f61343d2547c6a$var$announceCounter += 1; // Increment the counter for the next call
        // set the message with a unique invisible character to ensure
        // it is registered as different by screen readers
        announcer.textContent = "" + message + uniqueChar;
    }, 0);
    else announcer.textContent = message;
    // clear the message after the specified timeout
    $c8f61343d2547c6a$var$clearTimeoutId = setTimeout(function() {
        announcer.textContent = '';
    }, timeout);
});
$c8f61343d2547c6a$export$dcc8f4bff0d51f50.propTypes = (0, $801b12eb37c58588$export$33f2254b5dbf828a);





var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");


var $2xPiy = parcelRequire("2xPiy");

var $dyr1f = parcelRequire("dyr1f");
var $5b90066d7addec35$var$PropType = {};
$5b90066d7addec35$var$PropType = {
    target: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'component',
        'document'
    ]),
    onBackspace: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onComma: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onDown: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onEsc: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onLeft: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onRight: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onShift: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onSpace: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onTab: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onUp: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func
};
var $5b90066d7addec35$export$52e12bf50c10ce6a = $5b90066d7addec35$var$PropType;


var $168667f04da9206c$var$_excluded = [
    "capture",
    "target",
    "children",
    "onKeyDown"
];
function $168667f04da9206c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $168667f04da9206c$var$KEYS = {
    8: 'onBackspace',
    9: 'onTab',
    13: 'onEnter',
    27: 'onEsc',
    32: 'onSpace',
    37: 'onLeft',
    38: 'onUp',
    39: 'onRight',
    40: 'onDown',
    188: 'onComma',
    16: 'onShift'
};
var $168667f04da9206c$export$16e4d70cc375e707 = function Keyboard(_ref) {
    var capture = _ref.capture, target = _ref.target, children = _ref.children, onKeyDown = _ref.onKeyDown, restProps = $168667f04da9206c$var$_objectWithoutPropertiesLoose(_ref, $168667f04da9206c$var$_excluded);
    var onKeyDownHandler = (0, $2xPiy.useCallback)(function(event) {
        var key = event.keyCode ? event.keyCode : event.which;
        var callbackName = $168667f04da9206c$var$KEYS[key];
        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
        if (callbackName && restProps[callbackName]) restProps[callbackName].apply(restProps, [
            event
        ].concat(rest));
        if (onKeyDown) onKeyDown.apply(void 0, [
            event
        ].concat(rest));
    }, [
        onKeyDown,
        restProps
    ]);
    (0, $2xPiy.useEffect)(function() {
        if (target === 'document') document.addEventListener('keydown', onKeyDownHandler, capture);
        return function() {
            if (target === 'document') document.removeEventListener('keydown', onKeyDownHandler, capture);
        };
    }, [
        capture,
        onKeyDownHandler,
        target
    ]);
    return target === 'document' ? children : /*#__PURE__*/ (0, $2xPiy.cloneElement)((0, $2xPiy.Children).only(children), {
        onKeyDown: onKeyDownHandler
    });
};
$168667f04da9206c$export$16e4d70cc375e707.propTypes = (0, $5b90066d7addec35$export$52e12bf50c10ce6a);



var $iA1nz = parcelRequire("iA1nz");

var $8Fliv = parcelRequire("8Fliv");

var $iA1nz = parcelRequire("iA1nz");


var $1d37a3883a1c6277$export$e6d7d76967e857a7 = function responsiveBorderStyle(data, theme) {
    var color = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(data.color || 'border', theme);
    var borderSize = data.size || 'xsmall';
    var style = data.style || 'solid';
    var side = typeof data === 'string' ? data : data.side || 'all';
    var breakpoint = theme.box.responsiveBreakpoint && theme.global.breakpoints[theme.box.responsiveBreakpoint];
    if (!breakpoint.borderSize) breakpoint.borderSize = theme.global.borderSize;
    var value = breakpoint && (breakpoint.borderSize[borderSize] || borderSize) && style + " " + (breakpoint.borderSize[borderSize] || borderSize) + " " + color;
    if (!value) return undefined;
    if (side === 'top' || side === 'bottom' || side === 'left' || side === 'right') return "border-" + side + ": " + value + ";";
    if (side === 'end' || side === 'start') return "border-inline-" + side + ": " + value + ";";
    if (side === 'vertical') return "\n      border-left: " + value + ";\n      border-right: " + value + ";\n    ";
    if (side === 'horizontal') return "\n      border-top: " + value + ";\n      border-bottom: " + value + ";\n    ";
    if (side === 'between') return undefined; // no-op
    return "border: " + value + ";";
};
var $1d37a3883a1c6277$export$4d0a7f76ad443516 = function borderStyle(borderData, responsive, theme) {
    var borderStyles = [];
    (Array.isArray(borderData) ? borderData : [
        borderData
    ]).forEach(function(data) {
        var styles = [];
        var color = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(data.color || 'border', theme);
        var borderSize = data.size || 'xsmall';
        var style = data.style || 'solid';
        var side = typeof data === 'string' ? data : data.side || 'all';
        var value = style + " " + (theme.global.borderSize[borderSize] || borderSize) + " " + color;
        var responsiveStyle = responsive && $1d37a3883a1c6277$export$e6d7d76967e857a7(data, theme);
        var breakpoint = responsiveStyle && theme.box.responsiveBreakpoint && theme.global.breakpoints[theme.box.responsiveBreakpoint];
        if (side === 'top' || side === 'bottom' || side === 'left' || side === 'right') {
            styles.push("border-" + side + ": " + value + ";");
            if (responsiveStyle) styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, responsiveStyle, responsive));
        } else if (side === 'end' || side === 'start') {
            styles.push((0, $iA1nz.css)([
                "border-inline-",
                ":",
                ";"
            ], side, value));
            if (responsiveStyle) styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, responsiveStyle, responsive));
        } else if (side === 'vertical') {
            styles.push((0, $iA1nz.css)([
                "border-left:",
                ";border-right:",
                ";"
            ], value, value));
            if (responsiveStyle) styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, responsiveStyle, responsive));
        } else if (side === 'horizontal') {
            styles.push((0, $iA1nz.css)([
                "border-top:",
                ";border-bottom:",
                ";"
            ], value, value));
            if (responsiveStyle) styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, responsiveStyle, responsive));
        } else if (side === 'between') ;
        else {
            styles.push((0, $iA1nz.css)([
                "border:",
                ";"
            ], value));
            if (responsiveStyle) styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, responsiveStyle, responsive));
        }
        borderStyles.push(styles);
    });
    return borderStyles;
};




var $iA1nz = parcelRequire("iA1nz");
var $94e6d0642b9bdaa4$var$PULSE_SIZES = {
    xsmall: 1.001,
    small: 1.01,
    medium: 1.1,
    large: 1.5,
    xlarge: 2
};
var $94e6d0642b9bdaa4$var$SLIDE_SIZES = {
    xsmall: 1,
    small: 5,
    medium: 10,
    large: 50,
    xlarge: 200
};
var $94e6d0642b9bdaa4$var$JIGGLE_SIZES = {
    xsmall: 0.1,
    small: 1,
    medium: 5,
    large: 400,
    xlarge: 1000
};
var $94e6d0642b9bdaa4$var$ZOOM_SIZES = {
    xsmall: 0.001,
    small: 0.01,
    medium: 0.05,
    large: 0.1,
    xlarge: 0.5
};
var $94e6d0642b9bdaa4$export$106a9d8bc0bca92a = function animationBounds(type, size) {
    if (size === void 0) size = 'medium';
    if (type === 'draw') return [
        '',
        "stroke-dashoffset: 0"
    ];
    if (type === 'fadeIn') return [
        'opacity: 0;',
        'opacity: 1;'
    ];
    if (type === 'fadeOut') return [
        'opacity: 1;',
        'opacity: 0;'
    ];
    if (type === 'jiggle') {
        var deg = $94e6d0642b9bdaa4$var$JIGGLE_SIZES[size];
        return [
            "transform: rotate(-" + deg + "deg);",
            "transform: rotate(" + deg + "deg);"
        ];
    }
    if (type === 'pulse') return [
        'transform: scale(1);',
        "transform: scale(" + $94e6d0642b9bdaa4$var$PULSE_SIZES[size] + ")"
    ];
    if (type === 'rotateRight') return [
        "transform: rotate(0deg);",
        "transform: rotate(359deg);"
    ];
    if (type === 'rotateLeft') return [
        "transform: rotate(0deg);",
        "transform: rotate(-359deg);"
    ];
    if (type === 'flipIn') return [
        'transform: rotateY(90deg);',
        'transform: rotateY(0);'
    ];
    if (type === 'flipOut') return [
        'transform: rotateY(0);',
        'transform: rotateY(90deg);'
    ];
    if (type === 'slideDown') return [
        "transform: translateY(-" + $94e6d0642b9bdaa4$var$SLIDE_SIZES[size] + "%);",
        'transform: none;'
    ];
    if (type === 'slideLeft') return [
        "transform: translateX(" + $94e6d0642b9bdaa4$var$SLIDE_SIZES[size] + "%);",
        'transform: none;'
    ];
    if (type === 'slideRight') return [
        "transform: translateX(-" + $94e6d0642b9bdaa4$var$SLIDE_SIZES[size] + "%);",
        'transform: none;'
    ];
    if (type === 'slideUp') return [
        "transform: translateY(" + $94e6d0642b9bdaa4$var$SLIDE_SIZES[size] + "%);",
        'transform: none;'
    ];
    if (type === 'zoomIn') return [
        "transform: scale(" + (1 - $94e6d0642b9bdaa4$var$ZOOM_SIZES[size]) + ");",
        'transform: none;'
    ];
    if (type === 'zoomOut') return [
        "transform: scale(" + (1 + $94e6d0642b9bdaa4$var$ZOOM_SIZES[size]) + ");",
        'transform: none;'
    ];
    return [];
};
var $94e6d0642b9bdaa4$export$9eb47d7051add002 = function normalizeTiming(time, defaultTiming) {
    return typeof time === 'number' ? time / 1000.0 + "s" : time || defaultTiming;
};
var $94e6d0642b9bdaa4$export$cc25916ed0a5fe3a = function animationEnding(type) {
    if (type === 'draw') return 'linear forwards';
    if (type === 'jiggle') return 'alternate infinite';
    if (type === 'pulse') return 'alternate infinite';
    if (type === 'rotateRight' || type === 'rotateLeft') return 'infinite linear';
    return 'forwards';
};
var $94e6d0642b9bdaa4$export$1d0c30b40b07398 = function animationObjectStyle(animation, theme, themeObj) {
    var bounds = $94e6d0642b9bdaa4$export$106a9d8bc0bca92a(animation.type, animation.size);
    var animationTheme = themeObj && themeObj.animation || theme.global.animation;
    if (bounds) {
        var animationTransition = (0, $iA1nz.css)([
            "from{",
            ";}to{",
            ";}"
        ], bounds[0], bounds[1]);
        var defaultDuration = function defaultDuration() {
            return $94e6d0642b9bdaa4$export$9eb47d7051add002(animationTheme[animation.type] ? animationTheme[animation.type].duration : animation.duration, animationTheme.duration);
        };
        return (0, $iA1nz.css)([
            "",
            " ",
            " ",
            " ",
            ""
        ], (0, $iA1nz.keyframes)([
            "",
            ""
        ], animationTransition), $94e6d0642b9bdaa4$export$9eb47d7051add002(animation.duration, defaultDuration()), $94e6d0642b9bdaa4$export$9eb47d7051add002(animation.delay, '0s'), $94e6d0642b9bdaa4$export$cc25916ed0a5fe3a(animation.type));
    }
    return '';
};


var $2d39c5abd1eb876f$var$_FLEX_MAP;
function $2d39c5abd1eb876f$var$_extends() {
    return $2d39c5abd1eb876f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2d39c5abd1eb876f$var$_extends.apply(null, arguments);
}
var $2d39c5abd1eb876f$var$BASIS_MAP = {
    auto: 'auto',
    full: '100%',
    '1/2': '50%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    '1/3': '33.33%',
    '2/3': '66.66%'
};
var $2d39c5abd1eb876f$var$basisStyle = (0, $iA1nz.css)([
    "flex-basis:",
    ";"
], function(props) {
    return $2d39c5abd1eb876f$var$BASIS_MAP[props.basis] || props.theme.global.size[props.basis] || props.basis;
});
// min-width and min-height needed because of this
// https://stackoverflow.com/questions/36247140/why-doesnt-flex-item-shrink-past-content-size
// we assume we are in the context of a Box going the other direction
// TODO: revisit this
var $2d39c5abd1eb876f$var$directionStyle = function directionStyle(direction, responsive, theme) {
    var styles = [
        (0, $iA1nz.css)([
            "min-width:0;min-height:0;flex-direction:",
            ";"
        ], direction === 'row-responsive' ? 'row' : direction)
    ];
    if (direction === 'row-responsive' && theme.box.responsiveBreakpoint) {
        var breakpoint = (0, $5b8209df25a8ed95$export$56780e7bbaff61f9)(theme, theme.box.responsiveBreakpoint);
        if (breakpoint) styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "\n        flex-direction: column;\n        flex-basis: auto;\n        justify-content: flex-start;\n        align-items: stretch;\n      ", responsive));
    }
    return styles;
};
var $2d39c5abd1eb876f$var$FLEX_MAP = ($2d39c5abd1eb876f$var$_FLEX_MAP = {}, $2d39c5abd1eb876f$var$_FLEX_MAP[true] = '1 1', $2d39c5abd1eb876f$var$_FLEX_MAP[false] = '0 0', $2d39c5abd1eb876f$var$_FLEX_MAP.grow = '1 0', $2d39c5abd1eb876f$var$_FLEX_MAP.shrink = '0 1', $2d39c5abd1eb876f$var$_FLEX_MAP);
var $2d39c5abd1eb876f$var$flexGrowShrinkProp = function flexGrowShrinkProp(flex) {
    if (typeof flex === 'boolean' || typeof flex === 'string') return $2d39c5abd1eb876f$var$FLEX_MAP[flex];
    return (flex.grow ? flex.grow : 0) + " " + (flex.shrink ? flex.shrink : 0);
};
var $2d39c5abd1eb876f$var$flexStyle = (0, $iA1nz.css)([
    "flex:",
    ";"
], function(props) {
    return "" + $2d39c5abd1eb876f$var$flexGrowShrinkProp(props.flex) + (props.flex !== true && !props.basis ? ' auto' : '');
});
var $2d39c5abd1eb876f$var$JUSTIFY_MAP = {
    around: 'space-around',
    between: 'space-between',
    center: 'center',
    end: 'flex-end',
    evenly: 'space-evenly',
    start: 'flex-start'
};
var $2d39c5abd1eb876f$var$justifyStyle = (0, $iA1nz.css)([
    "justify-content:",
    ";"
], function(props) {
    return $2d39c5abd1eb876f$var$JUSTIFY_MAP[props.justify];
});
var $2d39c5abd1eb876f$var$WRAP_MAP = {
    "true": 'wrap',
    reverse: 'wrap-reverse'
};
var $2d39c5abd1eb876f$var$wrapStyle = (0, $iA1nz.css)([
    "flex-wrap:",
    ";"
], function(props) {
    return $2d39c5abd1eb876f$var$WRAP_MAP[props.wrapProp];
});
var $2d39c5abd1eb876f$var$_animationItemStyle = function animationItemStyle(item, theme) {
    if (typeof item === 'string') return (0, $94e6d0642b9bdaa4$export$1d0c30b40b07398)({
        type: item
    }, theme);
    if (Array.isArray(item)) return item.reduce(function(style, a, index) {
        return (0, $iA1nz.css)([
            "",
            "",
            " ",
            ""
        ], style, index > 0 ? ',' : '', $2d39c5abd1eb876f$var$_animationItemStyle(a, theme));
    }, '');
    if (typeof item === 'object') return (0, $94e6d0642b9bdaa4$export$1d0c30b40b07398)(item, theme);
    return '';
};
var $2d39c5abd1eb876f$var$animationAncilaries = function animationAncilaries(animation) {
    if (animation.type === 'flipIn' || animation.type === 'flipOut') return 'perspective: 1000px; transform-style: preserve-3d;';
    return '';
};
var $2d39c5abd1eb876f$var$animationObjectInitialStyle = function animationObjectInitialStyle(animation) {
    var bounds = (0, $94e6d0642b9bdaa4$export$106a9d8bc0bca92a)(animation.type, animation.size);
    if (bounds) return bounds[0] + " " + $2d39c5abd1eb876f$var$animationAncilaries(animation);
    return '';
};
var $2d39c5abd1eb876f$var$animationInitialStyle = function animationInitialStyle(item) {
    if (typeof item === 'string') return $2d39c5abd1eb876f$var$animationObjectInitialStyle({
        type: item
    });
    if (Array.isArray(item)) return item.map(function(a) {
        return typeof a === 'string' ? $2d39c5abd1eb876f$var$animationObjectInitialStyle({
            type: a
        }) : $2d39c5abd1eb876f$var$animationObjectInitialStyle(a);
    }).join('');
    if (typeof item === 'object') return $2d39c5abd1eb876f$var$animationObjectInitialStyle(item);
    return '';
};
var $2d39c5abd1eb876f$var$animationStyle = (0, $iA1nz.css)([
    "",
    ";"
], function(props) {
    return (0, $iA1nz.css)([
        "",
        " animation:",
        ";"
    ], $2d39c5abd1eb876f$var$animationInitialStyle(props.animation), $2d39c5abd1eb876f$var$_animationItemStyle(props.animation, props.theme));
});
var $2d39c5abd1eb876f$var$interactiveStyle = (0, $iA1nz.css)([
    "cursor:pointer;&:hover{",
    " ",
    "}"
], function(props) {
    var _props$kindProp;
    return ((_props$kindProp = props.kindProp) == null ? void 0 : _props$kindProp.hover) && (0, $0b4a347e23c22183$export$172ca055ee2bcc62)(props.kindProp.hover, props.theme);
}, function(props) {
    return props.hoverIndicator && (0, $0b4a347e23c22183$export$172ca055ee2bcc62)(props.hoverIndicator, props.theme);
});
var $2d39c5abd1eb876f$var$gapStyle = function gapStyle(directionProp, gap, responsive, wrap, theme) {
    var metric = theme.global.edgeSize[gap] || gap;
    var breakpoint = (0, $5b8209df25a8ed95$export$56780e7bbaff61f9)(theme, theme.box.responsiveBreakpoint);
    var responsiveMetric = responsive && breakpoint && breakpoint.edgeSize[gap];
    var styles = [];
    if (typeof gap === 'object') {
        var responsiveColumnMetric = responsive && breakpoint && breakpoint.edgeSize[gap.column];
        var responsiveRowMetric = responsive && breakpoint && breakpoint.edgeSize[gap.row];
        if (gap.row !== undefined && gap.column !== undefined) {
            styles.push("gap: " + (theme.global.edgeSize[gap.row] || gap.row) + " " + (theme.global.edgeSize[gap.column] || gap.column) + ";");
            if (responsiveRowMetric || responsiveColumnMetric) styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "gap: " + (responsiveRowMetric || gap.row) + " " + (responsiveColumnMetric || gap.column) + ";", responsive));
        } else if (gap.row !== undefined) {
            styles.push("row-gap: " + (theme.global.edgeSize[gap.row] || gap.row) + ";");
            if (responsiveRowMetric) styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "row-gap: " + responsiveRowMetric + ";", responsive));
        } else if (gap.column !== undefined) {
            styles.push("column-gap: " + (theme.global.edgeSize[gap.column] || gap.column) + ";");
            if (responsiveColumnMetric) styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "column-gap: " + responsiveColumnMetric + ";", responsive));
        }
    } else if (directionProp === 'column' || directionProp === 'column-reverse') {
        styles.push("row-gap: " + metric + ";");
        if (responsiveMetric) styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "row-gap: " + responsiveMetric + ";", responsive));
    } else {
        styles.push("column-gap: " + metric + ";");
        if (wrap) styles.push("row-gap: " + metric + ";");
        if (responsiveMetric) {
            if (directionProp === 'row' || directionProp === 'row-reverse') styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "column-gap: " + responsiveMetric + ";", responsive));
            else if (directionProp === 'row-responsive') styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "row-gap: " + responsiveMetric + ";", responsive));
        }
    }
    return styles;
};
var $2d39c5abd1eb876f$var$responsiveContainerStyle = (0, $iA1nz.css)([
    "container-type:inline-size;"
]);
// NOTE: basis must be after flex! Otherwise, flex overrides basis
// After upgrading to react 19 the 'selected' prop is leaking through
// to the DOM, added a check to prevent this.
var $2d39c5abd1eb876f$export$d675f139b342d51a = (0, $iA1nz.default).div.withConfig({
    shouldForwardProp: function shouldForwardProp(prop) {
        return (0, $8Fliv.default)(prop) && ![
            'selected'
        ].includes(prop);
    }
}).withConfig({
    displayName: "StyledBox",
    componentId: "sc-13pk1d4-0"
})([
    "display:flex;box-sizing:border-box;",
    ";",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return !props.basis && 'max-width: 100%;';
}, (0, $73ba8e2d301b823f$export$a157b298d219a801), function(props) {
    return props.align && (0, $73ba8e2d301b823f$export$f530b7ab00e4c68d);
}, function(props) {
    return props.alignContent && (0, $73ba8e2d301b823f$export$93b5fb4351939c1c);
}, function(props) {
    return props.background && (0, $0b4a347e23c22183$export$e43a4f0de05cb7e9)(props.background, props.theme);
}, function(props) {
    return props.border && (0, $1d37a3883a1c6277$export$4d0a7f76ad443516)(props.border, props.responsive, props.theme);
}, function(props) {
    return props.directionProp && $2d39c5abd1eb876f$var$directionStyle(props.directionProp, props.responsive, props.theme);
}, function(props) {
    return props.heightProp && (0, $73ba8e2d301b823f$export$9f8046d1e2885811)(props.heightProp, props.theme);
}, function(props) {
    return props.widthProp && (0, $73ba8e2d301b823f$export$c12f8e3e33f3bef7)(props.widthProp, props.theme);
}, function(props) {
    return props.flex !== undefined && $2d39c5abd1eb876f$var$flexStyle;
}, function(props) {
    return props.basis && $2d39c5abd1eb876f$var$basisStyle;
}, function(props) {
    return props.fillProp && (0, $73ba8e2d301b823f$export$7d12e60b29024244)(props.fillProp);
}, function(props) {
    return props.justify && $2d39c5abd1eb876f$var$justifyStyle;
}, function(props) {
    return props.pad && (0, $73ba8e2d301b823f$export$944a9710f9445eee)('padding', props.pad, props.responsive, props.theme.box.responsiveBreakpoint, props.theme);
}, function(props) {
    return props.round && (0, $73ba8e2d301b823f$export$98483643daf52539)(props.round, props.responsive, props.theme);
}, function(props) {
    return props.wrapProp && $2d39c5abd1eb876f$var$wrapStyle;
}, function(props) {
    return props.overflowProp && (0, $73ba8e2d301b823f$export$5938e7adc3ab8d08)(props.overflowProp);
}, function(props) {
    return props.elevationProp && (0, $73ba8e2d301b823f$export$b4ff7c828301ce9f)(props.elevationProp);
}, function(props) {
    return props.gap && $2d39c5abd1eb876f$var$gapStyle(props.directionProp, props.gap, props.responsive, props.wrapProp, props.theme);
}, function(props) {
    return props.animation && $2d39c5abd1eb876f$var$animationStyle;
}, function(props) {
    return props.onClick && $2d39c5abd1eb876f$var$interactiveStyle;
}, function(props) {
    return props.onClick && props.focus && props.focusIndicator !== false && // only show focus styles when using keyboard navigation
    // but not with mouse
    (0, $iA1nz.css)([
        "",
        " &:focus:not(:focus-visible){",
        "}"
    ], (0, $73ba8e2d301b823f$export$efbff472cb39d8b)(), (0, $73ba8e2d301b823f$export$525440aaa2c64805)());
}, function(props) {
    return props.theme.box && props.theme.box.extend;
}, function(props) {
    return props.kindProp && props.kindProp.extend;
}, function(props) {
    return props.responsiveContainer ? $2d39c5abd1eb876f$var$responsiveContainerStyle : '';
});
var $2d39c5abd1eb876f$var$gapGapStyle = function gapGapStyle(directionProp, gap, responsive, border, theme) {
    var metric = theme.global.edgeSize[gap] || gap;
    var breakpoint = (0, $5b8209df25a8ed95$export$56780e7bbaff61f9)(theme, theme.box.responsiveBreakpoint);
    var responsiveMetric = responsive && breakpoint && breakpoint.edgeSize[gap];
    var styles = [];
    if (directionProp === 'column' || directionProp === 'column-reverse') {
        styles.push("height: " + metric + ";");
        if (responsiveMetric) styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "height: " + responsiveMetric + ";", responsive));
    } else {
        styles.push("width: " + metric + ";");
        if (responsiveMetric) {
            if (directionProp === 'row' || directionProp === 'row-reverse') styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "width: " + responsiveMetric + ";", responsive));
            else if (directionProp === 'row-responsive') styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "\n          width: auto;\n          height: " + responsiveMetric + ";\n        ", responsive));
        }
    }
    if (border === 'between' || border && border.side === 'between') {
        var borderSize = border.size || theme.box.border.offset;
        var borderMetric = theme.global.borderSize[borderSize] || borderSize;
        var borderOffset = (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(metric) / 2 - (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(borderMetric) / 2 + "px";
        var responsiveBorderMetric = responsive && breakpoint && (breakpoint.borderSize[borderSize] || borderSize);
        var responsiveBorderOffset = responsiveBorderMetric && (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(responsiveMetric || metric) / 2 - (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(responsiveBorderMetric) / 2 + "px";
        if (directionProp === 'column' || directionProp === 'column-reverse') {
            var adjustedBorder = typeof border === 'string' ? 'top' : $2d39c5abd1eb876f$var$_extends({}, border, {
                side: 'top'
            });
            styles.push((0, $iA1nz.css)([
                "position:relative;&:after{content:'';position:absolute;width:100%;top:",
                ";",
                "}"
            ], borderOffset, (0, $1d37a3883a1c6277$export$4d0a7f76ad443516)(adjustedBorder, responsive, theme)));
            if (responsiveBorderOffset) styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "\n            &:after {\n              content: '';\n              top: " + responsiveBorderOffset + ";\n            }", responsive));
        } else {
            var _adjustedBorder = typeof border === 'string' ? 'left' : $2d39c5abd1eb876f$var$_extends({}, border, {
                side: 'left'
            });
            styles.push((0, $iA1nz.css)([
                "position:relative;&:after{content:'';position:absolute;height:100%;left:",
                ";",
                "}"
            ], borderOffset, (0, $1d37a3883a1c6277$export$4d0a7f76ad443516)(_adjustedBorder, directionProp !== 'row-responsive' && responsive, theme)));
            if (responsiveBorderOffset) {
                if (directionProp === 'row' || directionProp === 'row-reverse') styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "\n              &:after {\n                content: '';\n                left: " + responsiveBorderOffset + ";\n              }", responsive));
                else if (directionProp === 'row-responsive') {
                    var adjustedBorder2 = typeof border === 'string' ? 'top' : $2d39c5abd1eb876f$var$_extends({}, border, {
                        side: 'top'
                    });
                    styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "\n              &:after {\n                content: '';\n                height: auto;\n                left: unset;\n                width: 100%;\n                top: " + responsiveBorderOffset + ";\n                border-left: none;\n                " + (0, $1d37a3883a1c6277$export$e6d7d76967e857a7)(adjustedBorder2, theme) + "\n              }", responsive));
                }
            }
        }
    }
    return styles;
};
var $2d39c5abd1eb876f$export$a800d5caa1dbbca6 = (0, $iA1nz.default).div.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledBox__StyledBoxGap",
    componentId: "sc-13pk1d4-1"
})([
    "flex:0 0 auto;align-self:stretch;",
    ";"
], function(props) {
    return props.gap && $2d39c5abd1eb876f$var$gapGapStyle(props.directionProp, props.gap, props.responsive, props.border, props.theme);
});



var $dyr1f = parcelRequire("dyr1f");

function $54bb74eb9aed4887$var$_extends() {
    return $54bb74eb9aed4887$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $54bb74eb9aed4887$var$_extends.apply(null, arguments);
}
var $54bb74eb9aed4887$var$OVERFLOW_VALUES = [
    'auto',
    'hidden',
    'scroll',
    'visible'
];
var $54bb74eb9aed4887$var$BORDER_SHAPE = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
    color: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            light: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        })
    ]),
    side: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'top',
        'left',
        'bottom',
        'right',
        'start',
        'end',
        'horizontal',
        'vertical',
        'all',
        'between'
    ]),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    style: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'solid',
        'dashed',
        'dotted',
        'double',
        'groove',
        'ridge',
        'inset',
        'outset',
        'hidden'
    ])
});
// if you update values here, make sure to update in Drop/doc too.
var $54bb74eb9aed4887$var$overflowPropType = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($54bb74eb9aed4887$var$OVERFLOW_VALUES),
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($54bb74eb9aed4887$var$OVERFLOW_VALUES),
        vertical: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($54bb74eb9aed4887$var$OVERFLOW_VALUES)
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
]);
var $54bb74eb9aed4887$var$PropType = {};
$54bb74eb9aed4887$var$PropType = $54bb74eb9aed4887$var$_extends({}, (0, $ab32ce3df36aa105$export$ffe37ff34eeb9e21), {
    align: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'baseline',
            'center',
            'end',
            'start',
            'stretch'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    alignContent: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'around',
            'baseline',
            'between',
            'center',
            'evenly',
            'end',
            'start',
            'stretch'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    animation: (0, $ab32ce3df36aa105$export$6054792fa1afa765),
    background: (0, $ab32ce3df36aa105$export$aa372966d47f02af),
    basis: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'xxsmall',
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            'xxlarge',
            'full',
            '1/2',
            '1/3',
            '2/3',
            '1/4',
            '2/4',
            '3/4',
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    border: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'top',
            'left',
            'bottom',
            'right',
            'start',
            'end',
            'horizontal',
            'vertical',
            'all',
            'between'
        ]),
        $54bb74eb9aed4887$var$BORDER_SHAPE,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf($54bb74eb9aed4887$var$BORDER_SHAPE)
    ]),
    cssGap: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'row',
        'column',
        'row-responsive',
        'row-reverse',
        'column-reverse'
    ]),
    elevation: (0, $ab32ce3df36aa105$export$d9c9382fb5d26cc7),
    flex: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'grow',
            'shrink'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            grow: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
            shrink: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number
        })
    ]),
    fill: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'horizontal',
            'vertical'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
    ]),
    focusIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    gap: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'none',
            'xxsmall',
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            row: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            column: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        })
    ]),
    height: (0, $ab32ce3df36aa105$export$674efdc47ecf99e9),
    hoverIndicator: (0, $ab32ce3df36aa105$export$e4126213490fff97),
    justify: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'around',
        'between',
        'center',
        'end',
        'evenly',
        'start',
        'stretch'
    ]),
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    overflow: $54bb74eb9aed4887$var$overflowPropType,
    pad: (0, $ab32ce3df36aa105$export$b91a2ef62736aae3),
    responsive: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'container'
        ])
    ]),
    round: (0, $ab32ce3df36aa105$export$fcb8c87299e05542),
    skeleton: (0, $ab32ce3df36aa105$export$2f3082f340019e9a),
    tag: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func
    ]),
    as: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).elementType
    ]),
    width: (0, $ab32ce3df36aa105$export$7d45d0e6b7abd5e2),
    wrap: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'reverse'
        ])
    ])
});
var $54bb74eb9aed4887$export$39ef5a49fe6b4917 = $54bb74eb9aed4887$var$PropType;



var $2xPiy = parcelRequire("2xPiy");
var $b03c62556e524549$export$74e166679b1f49ee = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createContext();
var $b03c62556e524549$export$9489db5f14593d18 = function useSkeleton() {
    return (0, $2xPiy.useContext)($b03c62556e524549$export$74e166679b1f49ee);
};





var $2xPiy = parcelRequire("2xPiy");
var $f328f122e8cc98b2$export$505da1fc32900905 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createContext(false);



var $2xPiy = parcelRequire("2xPiy");


// The value of ResponsiveContainerContext
// when we're within a responsive container
var $cdff5c309cbc54a7$var$responsiveContainerValue = true;
var $cdff5c309cbc54a7$export$cc532883f3610b88 = function ResponsiveContainerProvider(_ref) {
    var container = _ref.container, theme = _ref.theme, children = _ref.children;
    var _useState = (0, $2xPiy.useState)(function() {
        var _theme$global;
        return (0, $5b8209df25a8ed95$export$f207ad4bd0549009)(navigator.userAgent, theme) || (theme == null || (_theme$global = theme.global) == null ? void 0 : _theme$global.deviceBreakpoints.tablet);
    }), value = _useState[0], setValue = _useState[1];
    (0, $2xPiy.useEffect)(function() {
        if (!container) return undefined;
        // Track what breakpoint width of the container is at
        // and update the ResponsiveContext value accordingly.
        var resizeObserver;
        if (typeof window !== 'undefined' && window.ResizeObserver) {
            resizeObserver = new window.ResizeObserver(function(entries) {
                window.requestAnimationFrame(function() {
                    var _entries$;
                    if (!Array.isArray(entries) || !entries.length) return;
                    var size = (_entries$ = entries[0]) == null || (_entries$ = _entries$.borderBoxSize) == null || (_entries$ = _entries$[0]) == null ? void 0 : _entries$.inlineSize;
                    if (size) setValue((0, $5b8209df25a8ed95$export$1eb095b00b926404)(size, theme));
                });
            });
            resizeObserver.observe(container);
        }
        // Initial size for ResponsiveContext in responsive container mode.
        // Also is a fallback for server side rendering
        var containerWidth = container.getBoundingClientRect().width;
        setValue((0, $5b8209df25a8ed95$export$1eb095b00b926404)(containerWidth, theme));
        return function() {
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        container,
        theme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $f328f122e8cc98b2$export$505da1fc32900905).Provider, {
        value: $cdff5c309cbc54a7$var$responsiveContainerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $10007abd86899141$export$51e389dae84ec233).Provider, {
        value: value
    }, children));
};



var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");


var $9ad09efd47c5d358$export$9c21a3269931e1e6 = {
    theme: (0, $182c1f23b2371be0$export$e2253033e6e1df16)
};
var $9ad09efd47c5d358$export$582fa4e2a9b13dde = function extendDefaultTheme(theme) {
    $9ad09efd47c5d358$export$9c21a3269931e1e6.theme = (0, $cdf577e3272e3992$export$6969335ea1e4e77c)((0, $182c1f23b2371be0$export$e2253033e6e1df16), theme);
};
var $9ad09efd47c5d358$export$e8748c6a27b910dc = function withTheme(props) {
    return {
        theme: (0, $cdf577e3272e3992$export$6969335ea1e4e77c)($9ad09efd47c5d358$export$9c21a3269931e1e6.theme, props.theme)
    };
};


function $f360c61b32a63078$var$_extends() {
    return $f360c61b32a63078$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f360c61b32a63078$var$_extends.apply(null, arguments);
}
/*
  Hook that returns theme value along with a flag to determine if we are 
  outside of a theme context provider, if so pass the base theme.
  If used outside of `<Grommet>` wrapper, falls back to base theme.
*/ var $f360c61b32a63078$export$b86e7a765e389e8f = function useThemeValue() {
    var context = (0, $2xPiy.useContext)((0, $iA1nz.ThemeContext));
    var theme = context || (0, $9ad09efd47c5d358$export$9c21a3269931e1e6).theme;
    return {
        theme: theme,
        passThemeFlag: $f360c61b32a63078$var$_extends({}, context === undefined ? {
            theme: theme
        } : {})
    };
};



var $18c0523379e5dd9d$var$_excluded = [
    "a11yTitle",
    "background",
    "border",
    "children",
    "cssGap",
    "direction",
    "elevation",
    "fill",
    "gap",
    "kind",
    "onBlur",
    "onClick",
    "onFocus",
    "overflow",
    "responsive",
    "tag",
    "as",
    "wrap",
    "width",
    "height",
    "tabIndex",
    "skeleton"
], $18c0523379e5dd9d$var$_excluded2 = [
    "colors",
    "size"
];
function $18c0523379e5dd9d$var$_extends() {
    return $18c0523379e5dd9d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $18c0523379e5dd9d$var$_extends.apply(null, arguments);
}
function $18c0523379e5dd9d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $18c0523379e5dd9d$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, refProp) {
    var _theme$global$depreca2;
    var a11yTitle = _ref.a11yTitle, backgroundProp = _ref.background, border = _ref.border, children = _ref.children, cssGap = _ref.cssGap, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? 'column' : _ref$direction, elevation = _ref.elevation, fill = _ref.fill, gap = _ref.gap, kind = _ref.kind, _onBlur = _ref.onBlur, onClick = _ref.onClick, _onFocus = _ref.onFocus, overflow = _ref.overflow, _ref$responsive = _ref.responsive, responsiveProp = _ref$responsive === void 0 ? true : _ref$responsive, tag = _ref.tag, as = _ref.as, wrap = _ref.wrap, width = _ref.width, height = _ref.height, tabIndex = _ref.tabIndex, skeletonProp = _ref.skeleton, rest = $18c0523379e5dd9d$var$_objectWithoutPropertiesLoose(_ref, $18c0523379e5dd9d$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    // boxOptions was created to preserve backwards compatibility but
    // should not be supported in v3
    var _useContext = (0, $2xPiy.useContext)((0, $cc9e28c6770f7140$export$b709306b005c3ef)), boxOptions = _useContext.box;
    var skeleton = (0, $b03c62556e524549$export$9489db5f14593d18)();
    var _useState = (0, $2xPiy.useState)(undefined), containerElement = _useState[0], setContainerElement = _useState[1];
    var responsiveContainer = (0, $2xPiy.useContext)((0, $f328f122e8cc98b2$export$505da1fc32900905));
    var responsive = responsiveContainer && responsiveProp ? 'container' : responsiveProp;
    var background = backgroundProp;
    (0, $2xPiy.useEffect)(function() {
        var _theme$global$depreca;
        if (backgroundProp && (_theme$global$depreca = theme.global.deprecated) != null && _theme$global$depreca.backgrounds) {
            var deprecatedBackground;
            if (typeof backgroundProp === 'string') deprecatedBackground = theme.global.deprecated.backgrounds.find(function(item) {
                return item.name === backgroundProp;
            });
            else if (typeof backgroundProp === 'object') deprecatedBackground = theme.global.deprecated.backgrounds.find(function(item) {
                return item.name === backgroundProp.image || item.name === backgroundProp.color;
            });
            if (deprecatedBackground) console.warn(deprecatedBackground.message || "The background " + deprecatedBackground.name + " is deprecated.");
        }
    }, [
        backgroundProp,
        (_theme$global$depreca2 = theme.global.deprecated) == null ? void 0 : _theme$global$depreca2.backgrounds
    ]);
    var announce = (0, $2xPiy.useContext)((0, $c8f61343d2547c6a$export$dcc8f4bff0d51f50));
    var containerRef = (0, $3cecef11d3b9c451$export$61dc559f8a0b9bcf)(refProp);
    // Save the ref as a state if we're in a responsive container.
    // We only need it in the responsive container case and it
    // needs to be in a state to cause a re-render.
    (0, $2xPiy.useEffect)(function() {
        if (responsiveProp === 'container' && containerRef.current) setContainerElement(containerRef.current);
    }, [
        containerRef,
        responsiveProp
    ]);
    (0, $2xPiy.useEffect)(function() {
        if (typeof as === 'function') {
            if (refProp) console.warn('ref and as={function} are incompatible. The ref will not get set.');
            if (responsiveProp === 'container') console.warn(// eslint-disable-next-line max-len
            'responsive="container" and as={function} are incompatible. Use one or the other.');
        }
    }, [
        refProp,
        as,
        responsiveProp
    ]);
    (0, $2xPiy.useEffect)(function() {
        var _skeletonProp$message;
        if (skeletonProp != null && (_skeletonProp$message = skeletonProp.message) != null && _skeletonProp$message.start) announce(skeletonProp.message.start);
        else if (typeof (skeletonProp == null ? void 0 : skeletonProp.message) === 'string') announce(skeletonProp.message);
        return function() {
            var _skeletonProp$message2;
            return (skeletonProp == null || (_skeletonProp$message2 = skeletonProp.message) == null ? void 0 : _skeletonProp$message2.end) && announce(skeletonProp.message.end);
        };
    }, [
        announce,
        skeletonProp
    ]);
    var focusable = (0, $2xPiy.useMemo)(function() {
        return onClick && !(tabIndex < 0);
    }, [
        onClick,
        tabIndex
    ]);
    var _useState2 = (0, $2xPiy.useState)(), focus = _useState2[0], setFocus = _useState2[1];
    var clickProps = (0, $2xPiy.useMemo)(function() {
        if (focusable) return {
            onClick: onClick,
            onFocus: function onFocus(event) {
                setFocus(true);
                if (_onFocus) _onFocus(event);
            },
            onBlur: function onBlur(event) {
                setFocus(false);
                if (_onBlur) _onBlur(event);
            }
        };
        var result = {};
        if (_onBlur) result.onBlur = _onBlur;
        if (onClick) result.onClick = onClick;
        if (_onFocus) result.onFocus = _onFocus;
        return result;
    }, [
        focusable,
        onClick,
        _onFocus,
        _onBlur
    ]);
    var adjustedTabIndex = (0, $2xPiy.useMemo)(function() {
        if (tabIndex !== undefined) return tabIndex;
        if (focusable) return 0;
        return undefined;
    }, [
        focusable,
        tabIndex
    ]);
    if ((border === 'between' || border && border.side === 'between' || Array.isArray(border) && border.find(function(b) {
        return b.side === 'between';
    })) && !gap) console.warn('Box must have a gap to use border between');
    var contents = children;
    if (gap && gap !== 'none' && (!(boxOptions != null && boxOptions.cssGap || cssGap || typeof gap === 'object') || // need this approach to show border between
    border === 'between' || (border == null ? void 0 : border.side) === 'between' || Array.isArray(border) && border.find(function(b) {
        return b.side === 'between';
    }))) {
        // if border is an array, we need to extract the border between object
        var styledBoxGapBorder = Array.isArray(border) ? border.find(function(b) {
            return b.side === 'between';
        }) : border;
        var boxAs = !as && tag ? tag : as;
        contents = [];
        var firstIndex;
        (0, $2xPiy.Children).forEach(children, function(child, index) {
            if (child) {
                if (firstIndex === undefined) firstIndex = index;
                else contents.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $2d39c5abd1eb876f$export$a800d5caa1dbbca6), $18c0523379e5dd9d$var$_extends({
                    key: "gap-" + index,
                    as: boxAs === 'span' ? boxAs : 'div',
                    gap: gap,
                    directionProp: direction,
                    responsive: responsive,
                    border: styledBoxGapBorder
                }, passThemeFlag)));
            }
            contents.push(child);
        });
    }
    var nextSkeleton = (0, $2xPiy.useMemo)(function() {
        // Decide if we need to add a new SkeletonContext. We need one if:
        //   1. skeleton info was set in a property OR
        //   2. there already is a SkeletonContext but this box has a
        //      background or border. This means the box probably is more
        //      distinguishable from the area around it.
        // We keep track of a depth so we know how to alternate backgrounds.
        if (skeletonProp || (background || border) && skeleton) {
            var depth = skeleton ? skeleton.depth + 1 : 0;
            return $18c0523379e5dd9d$var$_extends({}, skeleton, {
                depth: depth
            }, typeof skeletonProp === 'object' ? skeletonProp : {});
        }
        return undefined;
    }, [
        background,
        border,
        skeleton,
        skeletonProp
    ]);
    var skeletonProps = {};
    if (nextSkeleton) {
        var _theme$skeleton = theme.skeleton, skeletonThemeColors = _theme$skeleton.colors, skeletonThemeSize = _theme$skeleton.size, skeletonThemeProps = $18c0523379e5dd9d$var$_objectWithoutPropertiesLoose(_theme$skeleton, $18c0523379e5dd9d$var$_excluded2);
        var skeletonColors = nextSkeleton.colors ? nextSkeleton.colors[theme.dark ? 'dark' : 'light'] : skeletonThemeColors == null ? void 0 : skeletonThemeColors[theme.dark ? 'dark' : 'light'];
        skeletonProps = $18c0523379e5dd9d$var$_extends({}, skeletonThemeProps);
        background = skeletonColors[nextSkeleton.depth % skeletonColors.length];
        if (skeletonProp != null && skeletonProp.animation) skeletonProps.animation = skeletonProp.animation;
        contents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $b03c62556e524549$export$74e166679b1f49ee).Provider, {
            value: nextSkeleton
        }, contents);
    }
    // construct a new theme object in case we have a background that wants
    // to change the background color context
    var nextTheme = (0, $2xPiy.useMemo)(function() {
        var result;
        if (background || theme.darkChanged) {
            var dark = (0, $0b4a347e23c22183$export$d285dc898c6a4d11)(background, theme);
            var darkChanged = dark !== undefined && dark !== theme.dark;
            if (darkChanged || theme.darkChanged) {
                result = $18c0523379e5dd9d$var$_extends({}, theme);
                result.dark = dark === undefined ? theme.dark : dark;
                result.background = background;
            } else if (background) {
                // This allows DataTable to intelligently set the background
                // of a pinned header or footer.
                result = $18c0523379e5dd9d$var$_extends({}, theme);
                result.background = background;
            }
        }
        return result || theme;
    }, [
        background,
        theme
    ]);
    // Only pass along the ref if the as prop is not a function.
    // The styled component will throw a warning if we try to pass
    // a ref when the as prop is a function. We do a console.warn
    // about this above in this case.
    var ref = typeof as === 'function' ? undefined : containerRef;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $2d39c5abd1eb876f$export$d675f139b342d51a), $18c0523379e5dd9d$var$_extends({
        as: !as && tag ? tag : as,
        "aria-label": a11yTitle,
        background: background,
        border: border,
        ref: ref,
        directionProp: direction,
        elevationProp: elevation,
        fillProp: fill,
        focus: focus,
        gap: ((boxOptions == null ? void 0 : boxOptions.cssGap) || cssGap || typeof gap === 'object') && gap && gap !== 'none' && border !== 'between' && (border == null ? void 0 : border.side) !== 'between' && (!Array.isArray(border) || !border.find(function(b) {
            return b.side === 'between';
        })) && gap,
        kindProp: kind,
        overflowProp: overflow,
        wrapProp: wrap,
        widthProp: width,
        heightProp: height,
        responsive: responsive,
        responsiveContainer: responsiveProp === 'container',
        tabIndex: adjustedTabIndex
    }, clickProps, passThemeFlag, rest, skeletonProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $iA1nz.ThemeContext).Provider, {
        value: nextTheme
    }, contents));
    if (responsiveProp === 'container') {
        if ((0, $5b8209df25a8ed95$export$6fa2a3092624a8f5)()) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $cdff5c309cbc54a7$export$cc532883f3610b88), {
            container: containerElement,
            theme: theme
        }, content);
        else console.warn('<Box responsive="container"> requires styled-components v6 or later');
    }
    if (onClick) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $168667f04da9206c$export$16e4d70cc375e707), {
        onEnter: onClick,
        onSpace: function onSpace(e) {
            e.preventDefault(); // prevent page scroll
            onClick(e);
        }
    }, content);
    return content;
});
$18c0523379e5dd9d$export$e71c4d32a2263218.displayName = 'Box';
$18c0523379e5dd9d$export$e71c4d32a2263218.propTypes = (0, $54bb74eb9aed4887$export$39ef5a49fe6b4917);



var $2xPiy = parcelRequire("2xPiy");


var $2xPiy = parcelRequire("2xPiy");

var $cX5wj = parcelRequire("cX5wj");


var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");


var $2xPiy = parcelRequire("2xPiy");


var $203385cade677f5b$var$_excluded = [
    "hidden",
    "restrictScroll",
    "children",
    "trapFocus"
];
function $203385cade677f5b$var$_extends() {
    return $203385cade677f5b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $203385cade677f5b$var$_extends.apply(null, arguments);
}
function $203385cade677f5b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $203385cade677f5b$var$isFocusable = function isFocusable(element) {
    if ((element == null ? void 0 : element.tabIndex) < 0 || element != null && element.disabled) return false;
    switch(element == null ? void 0 : element.nodeName){
        case 'A':
            return !!element.href && element.rel !== 'ignore';
        case 'INPUT':
            return element.type !== 'hidden';
        case 'BUTTON':
        case 'SELECT':
        case 'TEXTAREA':
            return true;
        case 'DIV':
            return element.tabIndex >= 0;
        default:
            return false;
    }
};
var $203385cade677f5b$export$b0cd6833c93fb94d = function FocusedContainer(_ref) {
    var _ref$hidden = _ref.hidden, hidden = _ref$hidden === void 0 ? false : _ref$hidden, _ref$restrictScroll = _ref.restrictScroll, restrictScroll = _ref$restrictScroll === void 0 ? false : _ref$restrictScroll, children = _ref.children, trapFocus = _ref.trapFocus, rest = $203385cade677f5b$var$_objectWithoutPropertiesLoose(_ref, $203385cade677f5b$var$_excluded);
    var _useState = (0, $2xPiy.useState)(''), bodyOverflowStyle = _useState[0], setBodyOverflowStyle = _useState[1];
    var ref = (0, $2xPiy.useRef)(null);
    var preNodeRef = (0, $2xPiy.useRef)(null);
    var postNodeRef = (0, $2xPiy.useRef)(null);
    var _useRoots = (0, $3e3684d130c81252$export$79ef40724920756d)(), contextValue = _useRoots.contextValue, hasRoots = _useRoots.hasRoots;
    var contextRoots = contextValue.roots;
    // When attemptFocus moves focus around to find the focusable element,
    // set this to true so handleTrapFocus doesn't focus the element.
    var ignoreUtilFocusRef = (0, $2xPiy.useRef)(false);
    var lastFocusRef = (0, $2xPiy.useRef)(null);
    (0, $2xPiy.useEffect)(function() {
        var container = ref.current;
        var roots = contextRoots.current;
        var attemptFocus = function attemptFocus(element) {
            // Check if the element is focusable; if not, return false
            if (!$203385cade677f5b$var$isFocusable(element)) return false;
            ignoreUtilFocusRef.current = true;
            try {
                element.focus();
            } catch (_unused) {
            // continue regardless of error
            }
            ignoreUtilFocusRef.current = false;
            // Return true if the element is currently the active element or has focus
            return document.activeElement === element;
        };
        var _focusFirstDescendant = function focusFirstDescendant(element) {
            // Iterate through all child nodes of the provided element
            for(var i = 0; i < element.childNodes.length; i += 1){
                var child = element.childNodes[i];
                if (attemptFocus(child) || _focusFirstDescendant(child)) return true;
            }
            // If no focusable child or descendant was found, return false
            return false;
        };
        var _focusLastDescendant = function focusLastDescendant(element) {
            for(var i = element.childNodes.length - 1; i >= 0; i -= 1){
                var child = element.childNodes[i];
                if (attemptFocus(child) || _focusLastDescendant(child)) return true;
            }
            return false;
        };
        var handleTrapFocus = function handleTrapFocus(e) {
            if (!hidden && trapFocus && ignoreUtilFocusRef.current === false && container && // only perform focus if this is the most recently opened drop
            roots[roots.length - 1] === container) {
                if (container.contains(e.target)) lastFocusRef.current = e.target;
                else {
                    _focusFirstDescendant(container);
                    if (lastFocusRef.current === document.activeElement) _focusLastDescendant(container);
                    lastFocusRef.current = document.activeElement;
                }
            }
        };
        // add container to the global roots
        if (container) roots.push(container);
        // Create and insert focusable nodes to help track when focus
        // has left this container but without letting focus be noticeably
        // placed on anything outside the container
        if (!hidden && trapFocus) {
            var preDiv = document.createElement('div');
            var postDiv = document.createElement('div');
            var commonStyles = {
                position: 'absolute',
                height: '1px',
                left: '0',
                right: '0'
            };
            Object.assign(preDiv.style, $203385cade677f5b$var$_extends({}, commonStyles, {
                top: '0'
            }));
            Object.assign(postDiv.style, $203385cade677f5b$var$_extends({}, commonStyles, {
                bottom: '0'
            }));
            preNodeRef.current = container.parentNode.insertBefore(preDiv, container);
            postNodeRef.current = container.parentNode.insertBefore(postDiv, container.nextSibling);
            preNodeRef.current.tabIndex = 0;
            postNodeRef.current.tabIndex = 0;
        }
        document.addEventListener('focus', handleTrapFocus, true);
        return function() {
            var _preNodeRef$current, _postNodeRef$current;
            // remove from global roots array
            if (roots.includes(container)) roots.splice(roots.indexOf(container), 1);
            document.removeEventListener('focus', handleTrapFocus, true);
            if (roots != null && roots[roots.length - 1]) (0, $83f2052c15a18307$export$d25257a562ca003b)(roots[roots.length - 1]);
            preNodeRef == null || (_preNodeRef$current = preNodeRef.current) == null || _preNodeRef$current.remove();
            postNodeRef == null || (_postNodeRef$current = postNodeRef.current) == null || _postNodeRef$current.remove();
        };
    }, [
        hidden,
        contextRoots,
        trapFocus
    ]);
    (0, $2xPiy.useEffect)(function() {
        if (bodyOverflowStyle !== 'hidden' && !hidden && restrictScroll && trapFocus) {
            setBodyOverflowStyle(document.body.style.overflow);
            document.body.style.overflow = 'hidden';
        }
        return function() {
            if (bodyOverflowStyle !== 'hidden' && !hidden && restrictScroll && trapFocus) document.body.style.overflow = bodyOverflowStyle;
        };
    }, [
        bodyOverflowStyle,
        hidden,
        trapFocus,
        restrictScroll
    ]);
    (0, $2xPiy.useEffect)(function() {
        var roots = contextRoots.current;
        var timer = setTimeout(function() {
            if (!hidden && trapFocus) // make every root before this one unfocusable
            roots == null || roots.forEach(function(root, index) {
                if (index < roots.length - 1) (0, $83f2052c15a18307$export$f17a564c864b60a0)(root);
            });
        }, 0);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        hidden,
        contextRoots,
        trapFocus
    ]);
    var focusedContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("div", $203385cade677f5b$var$_extends({
        ref: ref,
        "aria-hidden": hidden
    }, rest), children);
    if (hasRoots) return focusedContainer;
    return(/*#__PURE__*/ // for cases outside of Grommet React tree, manage trapFocus when
    // Drop/Layer opens another Drop/Layer
    (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3e3684d130c81252$export$1eeeeda725eeeda).Provider, {
        value: contextValue
    }, focusedContainer));
};



var $2xPiy = parcelRequire("2xPiy");
var $fe63d32c9ed46844$export$60d741e20e0aa309 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createContext([]);




var $iA1nz = parcelRequire("iA1nz");



function $3a37b79c2b5eabb8$var$getTransformOriginStyle(align) {
    var vertical = 'top';
    if (align.bottom) vertical = 'bottom';
    var horizontal = 'left';
    if (align.right) horizontal = 'right';
    return vertical + " " + horizontal;
}
var $3a37b79c2b5eabb8$var$dropKeyFrames = (0, $iA1nz.keyframes)([
    "0%{opacity:0.5;transform:scale(0.8);}100%{opacity:1;transform:scale(1);}"
]);
// The desired margin may be adjusted depending on drops alignment
var $3a37b79c2b5eabb8$var$marginStyle = function marginStyle(theme, align, data, responsive, marginProp) {
    // NOTE: If marginProp is passed, it overrides the alignment-aware
    //  margin logic and uses the provided value instead.
    var margin = theme.global.edgeSize[data] || data;
    var adjustedMargin = {};
    // if user provides CSS string such as '50px 12px', apply that always
    var customCSS = typeof margin === 'string' && margin.split(' ').length > 1;
    if (theme.global.drop.intelligentMargin === true && !customCSS && typeof margin === 'string') {
        if (align.top === 'bottom') adjustedMargin.top = margin;
        else if (align.bottom === 'top') adjustedMargin.bottom = margin;
        if (align.right === 'left') adjustedMargin.left = "-" + margin;
        else if (align.left === 'right') adjustedMargin.left = margin;
        if (!Object.keys(adjustedMargin)) adjustedMargin = 'none';
    } else return (0, $73ba8e2d301b823f$export$944a9710f9445eee)('margin', marginProp || theme.global.drop.margin, responsive, theme.global.edgeSize.responsiveBreakpoint, theme);
    return (0, $73ba8e2d301b823f$export$944a9710f9445eee)('margin', marginProp || adjustedMargin, responsive, theme.global.edgeSize.responsiveBreakpoint, theme);
};
var $3a37b79c2b5eabb8$export$b726e6b8eaa2acc7 = (0, $iA1nz.default)((0, $18c0523379e5dd9d$export$e71c4d32a2263218)).withConfig({
    displayName: "StyledDrop",
    componentId: "sc-16s5rx8-0"
})([
    "",
    " ",
    " position:fixed;z-index:",
    ";outline:none;",
    " ",
    " opacity:0;transform-origin:",
    ";animation:",
    " 0.1s forwards;animation-delay:0.01s;@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){display:flex;align-items:stretch;}",
    ""
], (0, $73ba8e2d301b823f$export$360b744af11007ac), function(props) {
    return !props.plain && (props.round && (0, $73ba8e2d301b823f$export$98483643daf52539)(props.round, props.responsive || true, props.theme) || "border-radius: " + props.theme.global.drop.border.radius + ";");
}, function(props) {
    return props.theme.global.drop.zIndex;
}, function(props) {
    return !props.plain && (0, $0b4a347e23c22183$export$e43a4f0de05cb7e9)(props.background || props.theme.global.drop.background, props.theme);
}, function(props) {
    return !props.plain && (props.margin || props.theme.global.drop.margin) && props.theme.global && $3a37b79c2b5eabb8$var$marginStyle(props.theme, props.alignProp, props.theme.global.drop.margin, props.responsive, props.margin);
}, function(props) {
    return $3a37b79c2b5eabb8$var$getTransformOriginStyle(props.alignProp);
}, $3a37b79c2b5eabb8$var$dropKeyFrames, function(props) {
    return props.theme.global.drop && props.theme.global.drop.extend;
});




var $d49512c18c022b7e$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "align",
    "background",
    "onAlign",
    "children",
    "dropTarget",
    "elevation",
    "onClickOutside",
    "onEsc",
    "onKeyDown",
    "overflow",
    "plain",
    "responsive",
    "restrictFocus",
    "stretch",
    "trapFocus"
];
function $d49512c18c022b7e$var$_extends() {
    return $d49512c18c022b7e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d49512c18c022b7e$var$_extends.apply(null, arguments);
}
function $d49512c18c022b7e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// using react synthetic event to be able to stop propagation that
// would otherwise close the layer on ESC.
var $d49512c18c022b7e$var$preventLayerClose = function preventLayerClose(event) {
    var key = event.keyCode ? event.keyCode : event.which;
    if (key === 27) event.stopPropagation();
};
// Gets the closest ancestor positioned element
var $d49512c18c022b7e$var$getParentNode = function getParentNode(element) {
    var _element$offsetParent;
    return (_element$offsetParent = element.offsetParent) != null ? _element$offsetParent : element.parentNode;
};
// return the containing block
var $d49512c18c022b7e$var$getContainingBlock = function getContainingBlock(element) {
    var currentNode = $d49512c18c022b7e$var$getParentNode(element);
    while(currentNode instanceof window.HTMLElement && ![
        'html',
        'body'
    ].includes(currentNode.nodeName.toLowerCase())){
        var _currentNode;
        var css = window.getComputedStyle(currentNode);
        // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if ((css.transform ? css.transform !== 'none' : false) || (css.perspective ? css.perspective !== 'none' : false) || (css.backdropFilter ? css.backdropFilter !== 'none' : false) || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].includes(css.willChange) || css.willChange === 'filter' || (css.filter ? css.filter !== 'none' : false)) return currentNode;
        currentNode = (_currentNode = currentNode) == null ? void 0 : _currentNode.parentNode;
    }
    return null;
};
var $d49512c18c022b7e$var$defaultAlign = {
    top: 'top',
    left: 'left'
};
var $d49512c18c022b7e$export$aabdb120602c28c3 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], _ref$align = _ref.align, align = _ref$align === void 0 ? $d49512c18c022b7e$var$defaultAlign : _ref$align, background = _ref.background, onAlign = _ref.onAlign, children = _ref.children, dropTarget = _ref.dropTarget, elevation = _ref.elevation, onClickOutside = _ref.onClickOutside, onEsc = _ref.onEsc, onKeyDown = _ref.onKeyDown, _ref$overflow = _ref.overflow, overflow = _ref$overflow === void 0 ? 'auto' : _ref$overflow, plain = _ref.plain, _ref$responsive = _ref.responsive, responsive = _ref$responsive === void 0 ? true : _ref$responsive, restrictFocus = _ref.restrictFocus, _ref$stretch = _ref.stretch, stretch = _ref$stretch === void 0 ? 'width' : _ref$stretch, trapFocus = _ref.trapFocus, rest = $d49512c18c022b7e$var$_objectWithoutPropertiesLoose(_ref, $d49512c18c022b7e$var$_excluded);
    var containerTarget = (0, $2xPiy.useContext)((0, $18ec84c72847fc8a$export$64a849364cd772b4));
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    // dropOptions was created to preserve backwards compatibility
    var _useContext = (0, $2xPiy.useContext)((0, $cc9e28c6770f7140$export$b709306b005c3ef)), dropOptions = _useContext.drop;
    var portalContext = (0, $2xPiy.useContext)((0, $fe63d32c9ed46844$export$60d741e20e0aa309));
    var portalId = (0, $2xPiy.useMemo)(function() {
        return portalContext.length;
    }, [
        portalContext
    ]);
    var nextPortalContext = (0, $2xPiy.useMemo)(function() {
        return [].concat(portalContext, [
            portalId
        ]);
    }, [
        portalContext,
        portalId
    ]);
    var dropRef = (0, $3cecef11d3b9c451$export$61dc559f8a0b9bcf)(ref);
    (0, $2xPiy.useEffect)(function() {
        var onClickDocument = function onClickDocument(event) {
            // determine which portal id the target is in, if any
            var clickedPortalId = null;
            var node = event.composed && event.composedPath()[0] || event.target;
            while(clickedPortalId === null && node && node !== document && !(node instanceof ShadowRoot)){
                var attr = node.getAttribute('data-g-portal-id');
                if (attr !== null) clickedPortalId = parseInt(attr, 10);
                node = node.parentNode;
            }
            // Check if the click happened within the dropTarget
            var clickInsideDropTarget = (dropTarget == null ? void 0 : dropTarget.current) && dropTarget.current.contains(event.target) || dropTarget && typeof dropTarget.contains === 'function' && dropTarget.contains(event.target);
            if (!clickInsideDropTarget && clickedPortalId === null || portalContext.indexOf(clickedPortalId) !== -1) onClickOutside(event);
        };
        if (onClickOutside) document.addEventListener('mousedown', onClickDocument);
        return function() {
            if (onClickOutside) document.removeEventListener('mousedown', onClickDocument);
        };
    }, [
        onClickOutside,
        containerTarget,
        portalContext,
        dropTarget
    ]);
    (0, $2xPiy.useEffect)(function() {
        var target = (dropTarget == null ? void 0 : dropTarget.current) || dropTarget;
        var notifyAlign = function notifyAlign() {
            var _dropRef$current;
            var styleCurrent = dropRef == null || (_dropRef$current = dropRef.current) == null ? void 0 : _dropRef$current.style;
            var alignControl = (styleCurrent == null ? void 0 : styleCurrent.top) !== '' ? 'top' : 'bottom';
            onAlign(alignControl);
        };
        // We try to preserve the maxHeight as changing it causes any scroll
        // position to be lost. We set the maxHeight on mount and if the window
        // is resized.
        var place = function place(preserveHeight) {
            var windowWidth = window.innerWidth;
            var windowHeight = window.innerHeight;
            var container = dropRef.current;
            if (container && target) {
                var _containingBlockRect$, _containingBlockRect, _containingBlockRect$2, _containingBlockRect2, _containingBlockRect$3, _containingBlockRect3, _containingBlock$scro, _containingBlock2, _containingBlock$scro2, _containingBlock3;
                // clear prior styling
                container.style.left = '';
                container.style.top = '';
                container.style.bottom = '';
                container.style.width = '';
                if (!preserveHeight) container.style.maxHeight = '';
                // get bounds
                var targetRect = target.getBoundingClientRect();
                var containerRect = container.getBoundingClientRect();
                // determine width
                var width;
                if (stretch) width = Math.min(stretch === 'align' ? Math.min(targetRect.width, containerRect.width) : Math.max(targetRect.width, containerRect.width), windowWidth);
                else width = Math.min(containerRect.width, windowWidth);
                // set left position
                var left;
                if (align.left) {
                    if (align.left === 'left') left = targetRect.left;
                    else if (align.left === 'right') left = targetRect.left + targetRect.width;
                } else if (align.right) {
                    if (align.right === 'left') left = targetRect.left - width;
                    else if (align.right === 'right') left = targetRect.left + targetRect.width - width;
                } else left = targetRect.left + targetRect.width / 2 - width / 2;
                if (left + width > windowWidth) left -= left + width - windowWidth;
                else if (left < 0) left = 0;
                // set top or bottom position
                var top;
                var bottom;
                var maxHeight = containerRect.height;
                /* If responsive is true and the Drop doesn't have enough room
          to be fully visible and there is more room in the other
          direction, change the Drop to display above/below. If neither
          direction has enough room for the full Drop, prefer the side
          with more available space rather than clamping to the side
          originally requested. */ if (responsive && // drop is above target
                align.bottom === 'top' && // drop is overflowing above window
                targetRect.top - containerRect.height <= 0 && // there is room to display the drop below the target
                targetRect.bottom + containerRect.height < windowHeight) {
                    // top of drop is aligned to bottom of target
                    top = targetRect.bottom;
                    maxHeight = top;
                } else if (responsive && // top of drop is aligned to top of target
                align.top === 'top' && // drop is overflowing below window
                targetRect.top + containerRect.height >= windowHeight && // height of the drop is larger than the target.
                targetRect.top + containerRect.height > targetRect.bottom && // there is room to display the drop above the target
                targetRect.bottom - containerRect.height > 0) {
                    // bottom of drop is aligned to bottom of target
                    bottom = targetRect.bottom;
                    maxHeight = top;
                } else if (responsive && // top of drop is aligned to bottom of target
                align.top === 'bottom' && // drop is overflowing below window
                targetRect.bottom + containerRect.height >= windowHeight && // there is room to display the drop above the target
                targetRect.top - containerRect.height > 0) {
                    // bottom of drop is aligned to top of target
                    bottom = targetRect.top;
                    maxHeight = bottom;
                } else if (responsive && // bottom of drop is aligned to bottom of target
                align.bottom === 'bottom' && // drop is overflowing above window
                targetRect.bottom - containerRect.height <= 0 && // height of the drop is larger than the target.
                targetRect.bottom - containerRect.height > targetRect.top && // there is room to display the drop below the target
                targetRect.top + containerRect.height > 0) {
                    // top of drop is aligned to top of target
                    top = targetRect.top;
                    maxHeight = bottom;
                } else if (responsive && // top of drop is aligned to bottom of target (open below)
                align.top === 'bottom' && // drop is overflowing below window
                targetRect.bottom + containerRect.height >= windowHeight && // the flip anchor (target's top) is on-screen — otherwise
                // flipping pins the drop's bottom off-screen
                targetRect.top > 0 && // there is more room above the target than below it — neither
                // side fits the full drop, so prefer the larger side rather
                // than clamping to the smaller requested side.
                targetRect.top > windowHeight - targetRect.bottom) {
                    // bottom of drop is aligned to top of target
                    bottom = targetRect.top;
                    maxHeight = bottom;
                } else if (responsive && // top of drop is aligned to top of target (open below)
                align.top === 'top' && // drop is overflowing below window
                targetRect.top + containerRect.height >= windowHeight && // height of the drop is larger than the target — otherwise the
                // drop already fits inside the target's vertical span and a
                // flip would pin its bottom to a potentially off-screen
                // target.bottom (mirrors the safety in branch #2 above).
                targetRect.top + containerRect.height > targetRect.bottom && // there is more room above the target than below it
                targetRect.bottom > windowHeight - targetRect.top) {
                    // bottom of drop is aligned to bottom of target
                    bottom = targetRect.bottom;
                    maxHeight = bottom;
                } else if (responsive && // bottom of drop is aligned to top of target (open above)
                align.bottom === 'top' && // drop is overflowing above window
                targetRect.top - containerRect.height <= 0 && // the flip anchor (target's bottom) is on-screen
                targetRect.bottom < windowHeight && // there is more room below the target than above it
                windowHeight - targetRect.bottom > targetRect.top) {
                    // top of drop is aligned to bottom of target
                    top = targetRect.bottom;
                    maxHeight = windowHeight - top;
                } else if (responsive && // bottom of drop is aligned to bottom of target (open above)
                align.bottom === 'bottom' && // drop is overflowing above window
                targetRect.bottom - containerRect.height <= 0 && // height of the drop is larger than the target (mirrors the
                // safety in branch #4 above)
                targetRect.bottom - containerRect.height < targetRect.top && // there is more room below the target than above it
                windowHeight - targetRect.top > targetRect.bottom) {
                    // top of drop is aligned to top of target
                    top = targetRect.top;
                    maxHeight = windowHeight - top;
                } else if (align.top === 'top') {
                    top = targetRect.top;
                    maxHeight = windowHeight - top;
                } else if (align.top === 'bottom') {
                    top = targetRect.bottom;
                    maxHeight = windowHeight - top;
                } else if (align.bottom === 'top') {
                    bottom = targetRect.top;
                    maxHeight = bottom;
                } else if (align.bottom === 'bottom') {
                    bottom = targetRect.bottom;
                    maxHeight = bottom;
                } else top = targetRect.top + targetRect.height / 2 - containerRect.height / 2;
                var containingBlock;
                var containingBlockRect;
                // dropOptions was created to preserve backwards compatibility
                if (dropOptions != null && dropOptions.checkContainingBlock) {
                    var _containingBlock;
                    // return the containing block for absolute elements or `null`
                    // for fixed elements
                    containingBlock = $d49512c18c022b7e$var$getContainingBlock(container);
                    containingBlockRect = (_containingBlock = containingBlock) == null ? void 0 : _containingBlock.getBoundingClientRect();
                }
                // compute viewport offsets
                var viewportOffsetLeft = (_containingBlockRect$ = (_containingBlockRect = containingBlockRect) == null ? void 0 : _containingBlockRect.left) != null ? _containingBlockRect$ : 0;
                var viewportOffsetTop = (_containingBlockRect$2 = (_containingBlockRect2 = containingBlockRect) == null ? void 0 : _containingBlockRect2.top) != null ? _containingBlockRect$2 : 0;
                var viewportOffsetBottom = (_containingBlockRect$3 = (_containingBlockRect3 = containingBlockRect) == null ? void 0 : _containingBlockRect3.bottom) != null ? _containingBlockRect$3 : windowHeight;
                var containerOffsetLeft = (_containingBlock$scro = (_containingBlock2 = containingBlock) == null ? void 0 : _containingBlock2.scrollLeft) != null ? _containingBlock$scro : 0;
                var containerOffsetTop = (_containingBlock$scro2 = (_containingBlock3 = containingBlock) == null ? void 0 : _containingBlock3.scrollTop) != null ? _containingBlock$scro2 : 0;
                container.style.left = left - viewportOffsetLeft + containerOffsetLeft + "px";
                if (stretch) // offset width by 0.1 to avoid a bug in ie11 that
                // unnecessarily wraps the text if width is the same
                // NOTE: turned off for now
                container.style.width = width + 0.1 + "px";
                // the (position:absolute + scrollTop)
                // is presenting issues with desktop scroll flickering
                if (top !== '') container.style.top = top - viewportOffsetTop + containerOffsetTop + "px";
                if (bottom !== '') container.style.bottom = viewportOffsetBottom - bottom - containerOffsetTop + "px";
                if (!preserveHeight) {
                    if (theme.drop && theme.drop.maxHeight) maxHeight = Math.min(maxHeight, (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(theme.drop.maxHeight));
                    container.style.maxHeight = maxHeight + "px";
                }
            }
            if (onAlign) notifyAlign();
        };
        var scrollParents;
        var addScrollListeners = function addScrollListeners() {
            scrollParents = (0, $83f2052c15a18307$export$14e46d92eb0648e)(target);
            scrollParents.forEach(function(scrollParent) {
                return scrollParent.addEventListener('scroll', place);
            });
        };
        var removeScrollListeners = function removeScrollListeners() {
            scrollParents.forEach(function(scrollParent) {
                return scrollParent.removeEventListener('scroll', place);
            });
            scrollParents = [];
        };
        var onResize = function onResize() {
            removeScrollListeners();
            addScrollListeners();
            place(false);
        };
        addScrollListeners();
        window.addEventListener('resize', onResize);
        place(false);
        return function() {
            removeScrollListeners();
            window.removeEventListener('resize', onResize);
        };
    }, [
        align,
        containerTarget,
        onAlign,
        dropTarget,
        portalContext,
        portalId,
        responsive,
        restrictFocus,
        stretch,
        theme.drop,
        dropRef,
        dropOptions
    ]);
    // Once drop is open the focus will be put on the drop container
    // if restrictFocus is true. If the caller put focus
    // on an element already, we honor that. Otherwise, we put
    // the focus on the drop container.
    (0, $2xPiy.useEffect)(function() {
        if (restrictFocus) {
            var dropContainer = dropRef.current;
            if (dropContainer) {
                if (!dropContainer.contains(document.activeElement)) dropContainer.focus();
            }
        }
    }, [
        dropRef,
        restrictFocus
    ]);
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3a37b79c2b5eabb8$export$b726e6b8eaa2acc7), $d49512c18c022b7e$var$_extends({
        "aria-label": a11yTitle || ariaLabel,
        ref: dropRef,
        background: background,
        plain: plain,
        elevation: !plain ? elevation || theme.global.drop.elevation || theme.global.drop.shadowSize || // backward compatibility
        'small' : undefined,
        tabIndex: "-1",
        alignProp: align,
        overflow: overflow,
        "data-g-portal-id": portalId
    }, passThemeFlag, rest), children);
    var themeContextValue = (0, $2xPiy.useMemo)(function() {
        var dark;
        if (background || theme.global.drop.background) dark = (0, $0b4a347e23c22183$export$d285dc898c6a4d11)(background || theme.global.drop.background, theme);
        return $d49512c18c022b7e$var$_extends({}, theme, {
            dark: dark
        });
    }, [
        background,
        theme
    ]);
    var dark = themeContextValue.dark;
    if (dark !== undefined && dark !== theme.dark) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $iA1nz.ThemeContext).Provider, {
        value: themeContextValue
    }, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $fe63d32c9ed46844$export$60d741e20e0aa309).Provider, {
        value: nextPortalContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $203385cade677f5b$export$b0cd6833c93fb94d), {
        onKeyDown: onEsc && $d49512c18c022b7e$var$preventLayerClose,
        trapFocus: trapFocus
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $168667f04da9206c$export$16e4d70cc375e707), {
        capture: true,
        onEsc: onEsc ? function(event) {
            event.stopPropagation();
            onEsc(event);
        } : undefined,
        onKeyDown: onKeyDown,
        target: "document"
    }, content)));
});




var $dyr1f = parcelRequire("dyr1f");

// if you update values here, make sure to update in Box too.
var $f21de7a662d54ab3$var$dropOverflowPropTypes = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf((0, $ab32ce3df36aa105$export$5b49d53be3c37c69)),
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf((0, $ab32ce3df36aa105$export$5b49d53be3c37c69)),
        vertical: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf((0, $ab32ce3df36aa105$export$5b49d53be3c37c69))
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
]);
var $f21de7a662d54ab3$var$PropType = {};
$f21de7a662d54ab3$var$PropType = {
    align: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        top: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'top',
            'bottom'
        ]),
        bottom: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'top',
            'bottom'
        ]),
        right: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'left',
            'right'
        ]),
        left: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'left',
            'right'
        ])
    }),
    background: (0, $ab32ce3df36aa105$export$aa372966d47f02af),
    elevation: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'none',
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    inline: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    margin: (0, $ab32ce3df36aa105$export$7ece648387045365),
    onClickOutside: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onEsc: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    overflow: $f21de7a662d54ab3$var$dropOverflowPropTypes,
    plain: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    responsive: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    restrictFocus: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    round: (0, $ab32ce3df36aa105$export$fcb8c87299e05542),
    stretch: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'align'
        ])
    ]),
    target: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object.isRequired,
    trapFocus: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
};
var $f21de7a662d54ab3$export$9863f458227ea225 = $f21de7a662d54ab3$var$PropType;



var $9f4217ea4a25a271$var$_excluded = [
    "inline",
    "restrictFocus",
    "target",
    "trapFocus"
];
function $9f4217ea4a25a271$var$_extends() {
    return $9f4217ea4a25a271$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9f4217ea4a25a271$var$_extends.apply(null, arguments);
}
function $9f4217ea4a25a271$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $9f4217ea4a25a271$export$aaa698cd7aa517d6 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var inline = _ref.inline, restrictFocus = _ref.restrictFocus, dropTarget = _ref.target, _ref$trapFocus = _ref.trapFocus, trapFocus = _ref$trapFocus === void 0 ? true : _ref$trapFocus, rest = $9f4217ea4a25a271$var$_objectWithoutPropertiesLoose(_ref, $9f4217ea4a25a271$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useState = (0, $2xPiy.useState)(), originalFocusedElement = _useState[0], setOriginalFocusedElement = _useState[1];
    (0, $2xPiy.useEffect)(function() {
        return setOriginalFocusedElement(document.activeElement);
    }, []);
    var _useState2 = (0, $2xPiy.useState)(), dropContainer = _useState2[0], setDropContainer = _useState2[1];
    var containerTarget = (0, $2xPiy.useContext)((0, $18ec84c72847fc8a$export$64a849364cd772b4));
    var containerChildNodesLength = (0, $2xPiy.useRef)(null);
    (0, $2xPiy.useEffect)(function() {
        // we need this condition to prevent getNewContainer to run multiple times
        // in the event that the component gets created, destroyed, and recreated.
        // see https://reactjs.org/docs/strict-mode.html#ensuring-reusable-state
        if (!(containerChildNodesLength != null && containerChildNodesLength.current)) {
            containerChildNodesLength.current = containerTarget.childNodes.length;
            setDropContainer(!inline ? (0, $83f2052c15a18307$export$1cad4a11c7ad1375)(containerTarget) : undefined);
        }
    }, [
        containerTarget,
        inline
    ]);
    // just a few things to clean up when the Drop is unmounted
    (0, $2xPiy.useEffect)(function() {
        return function() {
            if (restrictFocus && originalFocusedElement) {
                if (originalFocusedElement.focus) (0, $83f2052c15a18307$export$99137e580254b26a)(originalFocusedElement);
                else if (originalFocusedElement.parentNode && originalFocusedElement.parentNode.focus) // required for IE11 and Edge
                (0, $83f2052c15a18307$export$99137e580254b26a)(originalFocusedElement.parentNode);
            }
            if (dropContainer) containerTarget.removeChild(dropContainer);
        };
    }, [
        containerTarget,
        dropContainer,
        originalFocusedElement,
        restrictFocus
    ]);
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $d49512c18c022b7e$export$aabdb120602c28c3), $9f4217ea4a25a271$var$_extends({
        ref: ref,
        dir: theme && theme.dir,
        dropTarget: dropTarget,
        restrictFocus: restrictFocus,
        trapFocus: trapFocus
    }, rest));
    if (inline) return content;
    if (dropContainer) return /*#__PURE__*/ (0, $cX5wj.createPortal)(content, dropContainer);
    return null;
});
$9f4217ea4a25a271$export$aaa698cd7aa517d6.displayName = 'Drop';
$9f4217ea4a25a271$export$aaa698cd7aa517d6.propTypes = (0, $f21de7a662d54ab3$export$9863f458227ea225);




var $2xPiy = parcelRequire("2xPiy");
var $fc2b59dcdb1fd3de$export$8f71654801c2f7cd = function useKeyboard() {
    var _useState = (0, $2xPiy.useState)(), usingKeyboard = _useState[0], setUsingKeyboard = _useState[1];
    (0, $2xPiy.useEffect)(function() {
        var onMouseDown = function onMouseDown() {
            return setUsingKeyboard(false);
        };
        var onKeyDown = function onKeyDown() {
            return setUsingKeyboard(true);
        };
        document.addEventListener('mousedown', onMouseDown);
        document.addEventListener('keydown', onKeyDown);
        return function() {
            document.removeEventListener('mousedown', onMouseDown);
            document.removeEventListener('keydown', onKeyDown);
        };
    }, []);
    return usingKeyboard;
};
var $fc2b59dcdb1fd3de$export$2e2bcd8739ae039 = $fc2b59dcdb1fd3de$export$8f71654801c2f7cd;



var $dyr1f = parcelRequire("dyr1f");
var $9ac9876fed4c0c3d$var$PropType = {};
$9ac9876fed4c0c3d$var$PropType = {
    content: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node,
    dropProps: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object,
    plain: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    defaultVisible: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
};
var $9ac9876fed4c0c3d$export$475ce0081ee75899 = $9ac9876fed4c0c3d$var$PropType;



function $ceab9ef72b825454$var$_extends() {
    return $ceab9ef72b825454$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ceab9ef72b825454$var$_extends.apply(null, arguments);
}
/*
 * This function getReactNodeRef is adapted from
 * [Material UI] (https://github.com/mui/material-ui)
 * Licensed under the MIT License (c) 2024 aarongarciah
 * The function has been modified from its original version.
 */ var $ceab9ef72b825454$var$getReactNodeRef = function getReactNodeRef(element) {
    if (!element || !/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).isValidElement(element)) return null;
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to
    // children in older versions
    return ({}).propertyIsEnumerable.call(element.props, 'ref') ? element.props.ref : element.ref;
};
var $ceab9ef72b825454$export$c92c6401b52a9298 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, tipRef) {
    var children = _ref.children, content = _ref.content, _ref$defaultVisible = _ref.defaultVisible, defaultVisible = _ref$defaultVisible === void 0 ? false : _ref$defaultVisible, dropProps = _ref.dropProps, plain = _ref.plain;
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useState = (0, $2xPiy.useState)(false), over = _useState[0], setOver = _useState[1];
    var _useState2 = (0, $2xPiy.useState)(false), tooltipOver = _useState2[0], setTooltipOver = _useState2[1];
    var usingKeyboard = (0, $fc2b59dcdb1fd3de$export$8f71654801c2f7cd)();
    var componentRef = (0, $3cecef11d3b9c451$export$61dc559f8a0b9bcf)(tipRef);
    // Three use case for children
    // 1. Tip has a single child + it is a React Element => Great!
    // 2. Tip has a single child +  not React Element =>
    // span will wrap the child so we can use ref and events.
    // 3. Tip has more than one child => Abort, display Children.only error
    var child = (0, $2xPiy.Children).count(children) <= 1 && !/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).isValidElement(children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("span", null, children) || (0, $2xPiy.Children).only(children);
    var clonedChild = /*#__PURE__*/ (0, $2xPiy.cloneElement)(child, {
        onMouseEnter: function onMouseEnter(event) {
            var _child$props;
            setOver(true);
            if ((_child$props = child.props) != null && _child$props.onMouseEnter) child.props.onMouseEnter(event);
        },
        onMouseLeave: function onMouseLeave(event) {
            var _child$props2;
            setOver(false);
            if ((_child$props2 = child.props) != null && _child$props2.onMouseLeave) child.props.onMouseLeave(event);
        },
        onFocus: function onFocus(event) {
            var _child$props3;
            if (usingKeyboard) setOver(true);
            if ((_child$props3 = child.props) != null && _child$props3.onFocus) child.props.onFocus(event);
        },
        onBlur: function onBlur(event) {
            var _child$props4;
            if (usingKeyboard) setOver(false);
            if ((_child$props4 = child.props) != null && _child$props4.onBlur) child.props.onBlur(event);
        },
        key: 'tip-child',
        ref: function ref(node) {
            // https://github.com/facebook/react/issues/8873#issuecomment-287873307
            if (typeof componentRef === 'function') componentRef(node);
            else if (componentRef) componentRef.current = node;
            // Call the original ref, if any
            var callerRef = $ceab9ef72b825454$var$getReactNodeRef(child);
            if (typeof callerRef === 'function') callerRef(node);
            else if (callerRef) callerRef.current = node;
        }
    });
    (0, $2xPiy.useEffect)(function() {
        setOver(defaultVisible);
    }, [
        defaultVisible
    ]);
    return [
        clonedChild,
        (over || tooltipOver) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $168667f04da9206c$export$16e4d70cc375e707), {
            key: "tip-keyboard",
            onEsc: function onEsc() {
                setOver(false);
                setTooltipOver(false);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $9f4217ea4a25a271$export$aaa698cd7aa517d6), $ceab9ef72b825454$var$_extends({
            target: componentRef.current,
            trapFocus: false,
            key: "tip-drop"
        }, theme.tip.drop, dropProps, {
            onMouseEnter: function onMouseEnter() {
                return setTooltipOver(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setTooltipOver(false);
            }
        }), plain ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), theme.tip.content, content)))
    ];
});
$ceab9ef72b825454$export$c92c6401b52a9298.displayName = 'Tip';
$ceab9ef72b825454$export$c92c6401b52a9298.propTypes = (0, $9ac9876fed4c0c3d$export$475ce0081ee75899);



var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");

/* eslint-disable no-restricted-imports */ 
var $2xPiy = parcelRequire("2xPiy");
var $9462599f26e06396$export$e5c5a5f917a5871c = typeof window !== 'undefined' ? (0, $2xPiy.useLayoutEffect) : (0, $2xPiy.useEffect);
var $9462599f26e06396$export$2e2bcd8739ae039 = $9462599f26e06396$export$e5c5a5f917a5871c;




var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");

var $69c6a9fba5b59476$var$fillStyle = (0, $iA1nz.css)([
    "",
    " ",
    " flex-grow:1;display:flex;"
], function(props) {
    return props.fillContainer === true || props.fillContainer === 'horizontal' ? "\n        width: 100%;\n        max-width: none;\n      " : '';
}, function(props) {
    return props.fillContainer === true || props.fillContainer === 'vertical' ? 'height: 100%;' : '';
});
var $69c6a9fba5b59476$export$8a7fb03b17c12e52 = (0, $iA1nz.default).div.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledStack",
    componentId: "sc-ajspsk-0"
})([
    "position:relative;",
    " ",
    " ",
    ""
], (0, $73ba8e2d301b823f$export$a157b298d219a801), function(props) {
    return props.fillContainer && $69c6a9fba5b59476$var$fillStyle;
}, function(props) {
    return props.theme.stack && props.theme.stack.extend;
});
var $69c6a9fba5b59476$var$styleMap = {
    fill: "\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n  ",
    center: "\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  ",
    left: "\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n  ",
    right: "\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n  ",
    top: "\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n  ",
    bottom: "\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n  ",
    'top-left': "\n    top: 0;\n    left: 0;\n  ",
    'bottom-left': "\n    bottom: 0;\n    left: 0;\n  ",
    'top-right': "\n    top: 0;\n    right: 0;\n  ",
    'bottom-right': "\n    bottom: 0;\n    right: 0;\n  "
};
var $69c6a9fba5b59476$export$5946a5a83aaaa916 = (0, $iA1nz.default).div.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledStack__StyledStackLayer",
    componentId: "sc-ajspsk-1"
})([
    "position:",
    ";",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return props.guiding ? 'relative' : 'absolute';
}, function(props) {
    return props.guiding && 'display: block;';
}, function(props) {
    return !props.guiding && $69c6a9fba5b59476$var$styleMap[props.anchor || 'fill'] + ";";
}, function(props) {
    return props.fillContainer && "\n    width: 100%;\n    height: 100%;\n  ";
}, function(props) {
    return !props.interactive && "pointer-events: none;";
});



var $dyr1f = parcelRequire("dyr1f");

function $a6ef55858a9f0689$var$_extends() {
    return $a6ef55858a9f0689$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a6ef55858a9f0689$var$_extends.apply(null, arguments);
}
var $a6ef55858a9f0689$var$PropType = {};
$a6ef55858a9f0689$var$PropType = $a6ef55858a9f0689$var$_extends({}, (0, $ab32ce3df36aa105$export$ffe37ff34eeb9e21), {
    anchor: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'center',
        'left',
        'right',
        'top',
        'bottom',
        'top-left',
        'bottom-left',
        'top-right',
        'bottom-right'
    ]),
    fill: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'horizontal',
            'vertical'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
    ]),
    guidingChild: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'first',
            'last'
        ])
    ]),
    interactiveChild: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'first',
            'last'
        ])
    ])
});
var $a6ef55858a9f0689$export$ae929f3c1850d7bc = $a6ef55858a9f0689$var$PropType;



var $1e7958766884f71d$var$_excluded = [
    "anchor",
    "children",
    "fill",
    "guidingChild",
    "interactiveChild"
];
function $1e7958766884f71d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $1e7958766884f71d$var$_extends() {
    return $1e7958766884f71d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1e7958766884f71d$var$_extends.apply(null, arguments);
}
var $1e7958766884f71d$var$buildStyledChildren = function buildStyledChildren(_ref) {
    var anchor = _ref.anchor, fill = _ref.fill, guidingIndex = _ref.guidingIndex, interactiveChild = _ref.interactiveChild, interactiveIndex = _ref.interactiveIndex;
    return function(child, index) {
        var interactive = interactiveChild === undefined || interactiveIndex === index;
        var isGuidingIndex = index === guidingIndex;
        var props = isGuidingIndex ? {
            guiding: true,
            fillContainer: fill
        } : {
            anchor: anchor
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $69c6a9fba5b59476$export$5946a5a83aaaa916), $1e7958766884f71d$var$_extends({
            key: index,
            interactive: interactive
        }, props), child);
    };
};
var $1e7958766884f71d$export$694e0d28c7ffc90c = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref2, ref) {
    var anchor = _ref2.anchor, children = _ref2.children, fill = _ref2.fill, guidingChild = _ref2.guidingChild, interactiveChild = _ref2.interactiveChild, rest = $1e7958766884f71d$var$_objectWithoutPropertiesLoose(_ref2, $1e7958766884f71d$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var prunedChildren = (0, $2xPiy.Children).toArray(children).filter(function(c) {
        return c;
    });
    var toChildIndex = function toChildIndex(child) {
        var index = child;
        if (index === 'first' || !index) index = 0;
        else if (index === 'last') index = prunedChildren.length - 1;
        return index;
    };
    var guidingIndex = toChildIndex(guidingChild);
    var interactiveIndex = interactiveChild && toChildIndex(interactiveChild);
    var styledChildren = prunedChildren.map($1e7958766884f71d$var$buildStyledChildren({
        anchor: anchor,
        fill: fill,
        guidingIndex: guidingIndex,
        interactiveChild: interactiveChild,
        interactiveIndex: interactiveIndex
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $69c6a9fba5b59476$export$8a7fb03b17c12e52), $1e7958766884f71d$var$_extends({
        ref: ref,
        fillContainer: fill
    }, passThemeFlag, rest), styledChildren);
});
$1e7958766884f71d$export$694e0d28c7ffc90c.displayName = 'Stack';
$1e7958766884f71d$export$694e0d28c7ffc90c.propTypes = (0, $a6ef55858a9f0689$export$ae929f3c1850d7bc);



var $2xPiy = parcelRequire("2xPiy");


var $iA1nz = parcelRequire("iA1nz");

var $92c36f06cd3c9549$var$sizeStyle = function sizeStyle(props) {
    var size = props.size || 'medium';
    var data = props.theme.text[size];
    if (data) return (0, $iA1nz.css)([
        "font-size:",
        ";line-height:",
        ";"
    ], data.size, data.height);
    return (0, $iA1nz.css)([
        "font-size:",
        ";line-height:normal;"
    ], size);
};
var $92c36f06cd3c9549$var$truncateStyle = "\n  white-space: nowrap;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n";
var $92c36f06cd3c9549$var$colorStyle = (0, $iA1nz.css)([
    "color:",
    ";"
], function(props) {
    return (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.colorProp, props.theme);
});
var $92c36f06cd3c9549$var$weightStyle = (0, $iA1nz.css)([
    "font-weight:",
    ";"
], function(props) {
    return props.weight;
});
var $92c36f06cd3c9549$var$wordBreakStyle = (0, $iA1nz.css)([
    "word-break:",
    ";"
], function(props) {
    return props.wordBreak;
});
var $92c36f06cd3c9549$var$fontFamily = (0, $iA1nz.css)([
    "font-family:",
    ";"
], function(props) {
    return props.theme.text.font.family;
});
var $92c36f06cd3c9549$export$31ea92f3997410dd = (0, $iA1nz.default)('span').withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledText",
    componentId: "sc-1sadyjn-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], (0, $73ba8e2d301b823f$export$a157b298d219a801), function(props) {
    return $92c36f06cd3c9549$var$sizeStyle(props);
}, function(props) {
    return props.textAlign && (0, $73ba8e2d301b823f$export$4fc8e4871b69e1d6);
}, function(props) {
    return props.truncate && $92c36f06cd3c9549$var$truncateStyle;
}, function(props) {
    return props.colorProp && $92c36f06cd3c9549$var$colorStyle;
}, function(props) {
    return props.weight && $92c36f06cd3c9549$var$weightStyle;
}, function(props) {
    return props.wordBreak && $92c36f06cd3c9549$var$wordBreakStyle;
}, function(props) {
    return props.theme.text.font && props.theme.text.font.family && $92c36f06cd3c9549$var$fontFamily;
}, function(props) {
    return props.theme.text && props.theme.text.extend;
});





var $dyr1f = parcelRequire("dyr1f");

function $28446c0caa2027f9$var$_extends() {
    return $28446c0caa2027f9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $28446c0caa2027f9$var$_extends.apply(null, arguments);
}
var $28446c0caa2027f9$var$PropType = {};
$28446c0caa2027f9$var$PropType = $28446c0caa2027f9$var$_extends({}, (0, $ab32ce3df36aa105$export$ffe37ff34eeb9e21), {
    color: (0, $ab32ce3df36aa105$export$fc4c368d97afb623),
    margin: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'none'
        ].concat((0, $ab32ce3df36aa105$export$7d9f2aeb8f1f7c3f))),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            bottom: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf((0, $ab32ce3df36aa105$export$7d9f2aeb8f1f7c3f)),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            ]),
            end: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf((0, $ab32ce3df36aa105$export$7d9f2aeb8f1f7c3f)),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            ]),
            horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf((0, $ab32ce3df36aa105$export$7d9f2aeb8f1f7c3f)),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            ]),
            left: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf((0, $ab32ce3df36aa105$export$7d9f2aeb8f1f7c3f)),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            ]),
            right: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf((0, $ab32ce3df36aa105$export$7d9f2aeb8f1f7c3f)),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            ]),
            start: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf((0, $ab32ce3df36aa105$export$7d9f2aeb8f1f7c3f)),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            ]),
            top: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf((0, $ab32ce3df36aa105$export$7d9f2aeb8f1f7c3f)),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            ]),
            vertical: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf((0, $ab32ce3df36aa105$export$7d9f2aeb8f1f7c3f)),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            ])
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            'xxlarge',
            '2xl',
            '3xl',
            '4xl',
            '5xl',
            '6xl'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    skeleton: (0, $ab32ce3df36aa105$export$2f3082f340019e9a),
    tag: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func
    ]),
    as: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).element
    ]),
    textAlign: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'start',
        'center',
        'end',
        'justify'
    ]),
    tip: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            content: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node,
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            ]),
            dropProps: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({}),
            plain: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    truncate: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'tip'
        ])
    ]),
    weight: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'normal',
            'bold',
            'bolder',
            'lighter'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number
    ]),
    wordBreak: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'normal',
        'break-all',
        'keep-all',
        'break-word'
    ])
});
var $28446c0caa2027f9$export$da9fd56aa591dacf = $28446c0caa2027f9$var$PropType;




var $2xPiy = parcelRequire("2xPiy");

var $2xPiy = parcelRequire("2xPiy");

var $dyr1f = parcelRequire("dyr1f");

function $07ebaf1cedf50732$var$_extends() {
    return $07ebaf1cedf50732$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $07ebaf1cedf50732$var$_extends.apply(null, arguments);
}
var $07ebaf1cedf50732$var$PropType = {};
$07ebaf1cedf50732$var$PropType = $07ebaf1cedf50732$var$_extends({}, (0, $ab32ce3df36aa105$export$ffe37ff34eeb9e21), {
    as: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).element
    ]),
    colors: (0, $ab32ce3df36aa105$export$d3e0bc3700258305),
    height: (0, $ab32ce3df36aa105$export$674efdc47ecf99e9),
    pad: (0, $ab32ce3df36aa105$export$b91a2ef62736aae3),
    round: (0, $ab32ce3df36aa105$export$fcb8c87299e05542),
    width: (0, $ab32ce3df36aa105$export$7d45d0e6b7abd5e2)
});
var $07ebaf1cedf50732$export$6c09f2c2b39894c = $07ebaf1cedf50732$var$PropType;




var $iA1nz = parcelRequire("iA1nz");


var $a285c085178828f2$export$e4ecddc59e33f387 = (0, $iA1nz.default).div.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledSkeleton",
    componentId: "sc-1omqm6u-0"
})([
    "display:flex;box-sizing:border-box;",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], (0, $73ba8e2d301b823f$export$a157b298d219a801), function(props) {
    return props.background && (0, $0b4a347e23c22183$export$e43a4f0de05cb7e9)(props.background, props.theme);
}, function(props) {
    var _props$theme$text;
    return (0, $73ba8e2d301b823f$export$9f8046d1e2885811)(props.heightProp || ((_props$theme$text = props.theme.text) == null || (_props$theme$text = _props$theme$text.medium) == null ? void 0 : _props$theme$text.height), props.theme);
}, function(props) {
    return (0, $73ba8e2d301b823f$export$c12f8e3e33f3bef7)(props.widthProp || '100%', props.theme);
}, function(props) {
    return props.pad && (0, $73ba8e2d301b823f$export$944a9710f9445eee)('padding', props.pad, props.responsive, props.theme.box.responsiveBreakpoint, props.theme);
}, function(props) {
    return props.round && (0, $73ba8e2d301b823f$export$98483643daf52539)(props.round, props.responsive, props.theme);
}, function(props) {
    var _props$theme;
    return (_props$theme = props.theme) == null || (_props$theme = _props$theme.skeleton) == null ? void 0 : _props$theme.extend;
}, function(props) {
    return props.responsiveSize && (0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(props.responsiveSize.breakpoint, (0, $73ba8e2d301b823f$export$9f8046d1e2885811)(props.responsiveSize.height, props.theme), props.responsive);
});




var $3c6eab35cbfc0e04$var$_excluded = [
    "as",
    "colors",
    "width",
    "height",
    "responsive"
];
function $3c6eab35cbfc0e04$var$_extends() {
    return $3c6eab35cbfc0e04$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3c6eab35cbfc0e04$var$_extends.apply(null, arguments);
}
function $3c6eab35cbfc0e04$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $3c6eab35cbfc0e04$export$8f31e4c4a37b8e9c = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var _theme$skeleton;
    var as = _ref.as, colorsProp = _ref.colors, widthProp = _ref.width, heightProp = _ref.height, responsiveProp = _ref.responsive, rest = $3c6eab35cbfc0e04$var$_objectWithoutPropertiesLoose(_ref, $3c6eab35cbfc0e04$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var skeleton = (0, $b03c62556e524549$export$9489db5f14593d18)();
    var depth = (skeleton == null ? void 0 : skeleton.depth) || 0;
    var responsiveContainer = (0, $2xPiy.useContext)((0, $f328f122e8cc98b2$export$505da1fc32900905));
    var responsive = responsiveContainer && responsiveProp ? 'container' : responsiveProp;
    var colors = colorsProp || (theme == null || (_theme$skeleton = theme.skeleton) == null ? void 0 : _theme$skeleton.colors);
    var themeColors = colors[theme.dark ? 'dark' : 'light'];
    var background = themeColors[(depth + 1) % themeColors.length];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $a285c085178828f2$export$e4ecddc59e33f387), $3c6eab35cbfc0e04$var$_extends({
        "aria-hidden": "true",
        ref: ref,
        as: as,
        background: background,
        widthProp: widthProp,
        heightProp: heightProp,
        responsive: responsive
    }, passThemeFlag, rest));
});
$3c6eab35cbfc0e04$export$8f31e4c4a37b8e9c.displayName = 'Skeleton';
$3c6eab35cbfc0e04$export$8f31e4c4a37b8e9c.propTypes = (0, $07ebaf1cedf50732$export$6c09f2c2b39894c);



var $cee60514eff9bcea$var$_excluded = [
    "as",
    "size"
];
function $cee60514eff9bcea$var$_extends() {
    return $cee60514eff9bcea$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cee60514eff9bcea$var$_extends.apply(null, arguments);
}
function $cee60514eff9bcea$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $cee60514eff9bcea$export$8334ddaea41520f1 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var as = _ref.as, sizeProp = _ref.size, rest = $cee60514eff9bcea$var$_objectWithoutPropertiesLoose(_ref, $cee60514eff9bcea$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var size = sizeProp || 'medium';
    var data = theme.text[size];
    var height = data ? data.size : sizeProp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3c6eab35cbfc0e04$export$8f31e4c4a37b8e9c), $cee60514eff9bcea$var$_extends({
        ref: ref,
        as: as,
        height: height
    }, theme.text.skeleton, rest));
});
$cee60514eff9bcea$export$8334ddaea41520f1.displayName = 'TextSkeleton';



var $2xPiy = parcelRequire("2xPiy");
var $fb9a4f68d412304d$export$9afb8bc826b033ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createContext({});



var $281e2fcec27a8e6b$var$_excluded = [
    "children",
    "color",
    "tag",
    "as",
    "tip",
    "a11yTitle",
    "truncate",
    "size",
    "skeleton",
    "level"
];
function $281e2fcec27a8e6b$var$_extends() {
    return $281e2fcec27a8e6b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $281e2fcec27a8e6b$var$_extends.apply(null, arguments);
}
function $281e2fcec27a8e6b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $281e2fcec27a8e6b$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var children = _ref.children, color = _ref.color, tag = _ref.tag, as = _ref.as, tipProp = _ref.tip, _ref$a11yTitle = _ref.a11yTitle, a11yTitle = _ref$a11yTitle === void 0 ? typeof tipProp === 'string' && tipProp || (tipProp == null ? void 0 : tipProp.content) || undefined : _ref$a11yTitle, truncate = _ref.truncate, size = _ref.size, skeletonProp = _ref.skeleton, _ref$level = _ref.level, level = _ref$level === void 0 ? 1 : _ref$level, rest = $281e2fcec27a8e6b$var$_objectWithoutPropertiesLoose(_ref, $281e2fcec27a8e6b$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var textRef = (0, $3cecef11d3b9c451$export$61dc559f8a0b9bcf)(ref);
    var _useState = (0, $2xPiy.useState)(false), textTruncated = _useState[0], setTextTruncated = _useState[1];
    var textContextValue = (0, $2xPiy.useMemo)(function() {
        return {
            size: size
        };
    }, [
        size
    ]);
    var skeleton = (0, $b03c62556e524549$export$9489db5f14593d18)();
    (0, $9462599f26e06396$export$e5c5a5f917a5871c)(function() {
        var updateTip = function updateTip() {
            setTextTruncated(false);
            if (truncate === 'tip' && textRef.current && textRef.current.scrollWidth > textRef.current.offsetWidth) setTextTruncated(true);
        };
        window.addEventListener('resize', updateTip);
        window.addEventListener('pagechange', updateTip);
        updateTip();
        return function() {
            window.removeEventListener('resize', updateTip);
            window.removeEventListener('pagechange', updateTip);
        };
    }, [
        textRef,
        truncate
    ]);
    if (skeleton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $cee60514eff9bcea$export$8334ddaea41520f1), $281e2fcec27a8e6b$var$_extends({
        ref: ref,
        as: as,
        level: level,
        size: size
    }, skeletonProp, rest));
    var styledTextResult = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $92c36f06cd3c9549$export$31ea92f3997410dd), $281e2fcec27a8e6b$var$_extends({
        as: !as && tag ? tag : as,
        colorProp: color,
        "aria-label": a11yTitle,
        level: level,
        truncate: truncate,
        size: size
    }, passThemeFlag, rest, {
        ref: textRef
    }), children !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $fb9a4f68d412304d$export$9afb8bc826b033ea).Provider, {
        value: textContextValue
    }, children) : undefined);
    var tipProps = tipProp && typeof tipProp === 'object' ? tipProp : {};
    if (tipProp || textTruncated) {
        // place the text content in a tip if truncate === 'tip'
        // and the text has been truncated
        if (textTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $ceab9ef72b825454$export$c92c6401b52a9298), $281e2fcec27a8e6b$var$_extends({
            content: children
        }, tipProps), styledTextResult);
        // place the text content in a tip if truncate !== 'tip'
        // it displays even if the text has not truncated
        if (truncate !== 'tip') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $ceab9ef72b825454$export$c92c6401b52a9298), tipProps, styledTextResult);
    }
    return styledTextResult;
});
$281e2fcec27a8e6b$export$5f1af8db9871e1d6.displayName = 'Text';
$281e2fcec27a8e6b$export$5f1af8db9871e1d6.propTypes = (0, $28446c0caa2027f9$export$da9fd56aa591dacf);



function $d7e482005a2fe598$var$_extends() {
    return $d7e482005a2fe598$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d7e482005a2fe598$var$_extends.apply(null, arguments);
}
var $d7e482005a2fe598$var$StyledBadgeContainer = (0, $iA1nz.default)((0, $18c0523379e5dd9d$export$e71c4d32a2263218)).withConfig({
    displayName: "Badge__StyledBadgeContainer",
    componentId: "sc-1es4ws1-0"
})([
    "",
    ""
], function(props) {
    return props.theme.button.badge.container.extend;
});
var $d7e482005a2fe598$export$37acb3580601e69a = function Badge(_ref) {
    var children = _ref.children, content = _ref.content;
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var containerRef = (0, $2xPiy.useRef)();
    var contentRef = (0, $2xPiy.useRef)();
    var stackRef = (0, $2xPiy.useRef)();
    var defaultBadgeDimension = typeof content === 'boolean' || content && content.value && typeof content.value === 'boolean' ? // after experimenting with various values
    (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(theme.button.badge.size.medium) / 2 + "px" : theme.button.badge.size.medium;
    // scale badge to fit its contents, leaving space horizontally
    // that is proportional to vertical space
    (0, $9462599f26e06396$export$e5c5a5f917a5871c)(function() {
        // when window resizes and hits a responsive breakpoint, width of the badge
        // can change (because pad is responsive, etc.). we want to recalculate
        // width since badge offset is reliant on its dimensions.
        var onResize = function onResize() {
            if (containerRef != null && containerRef.current) {
                containerRef.current.style.minHeight = '';
                containerRef.current.style.minWidth = '';
                if (contentRef != null && contentRef.current) {
                    if (typeof content === 'number' || typeof content === 'object' && content.value) {
                        containerRef.current.style.minHeight = defaultBadgeDimension;
                        containerRef.current.style.minWidth = defaultBadgeDimension;
                        var _contentRef$current$g = contentRef.current.getBoundingClientRect(), contentHeight = _contentRef$current$g.height, contentWidth = _contentRef$current$g.width;
                        // only adjust the width if contentHeight > 0
                        // jest returns 0 for all getBoundingClientRect values,
                        // so this ensures snapshots are closer to correct values
                        if (contentHeight) {
                            // height of content includes extra space around font from
                            // line-height. account for this extra space with 2.5 multiplier
                            // to add proportional horizontal space
                            var height = defaultBadgeDimension;
                            var width = defaultBadgeDimension;
                            var verticalSpace = ((0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(height) - contentHeight) * 2.5;
                            containerRef.current.style.minHeight = height;
                            containerRef.current.style.minWidth = Math.max((0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(width), Math.ceil(contentWidth + verticalSpace)) + "px";
                        }
                    } else {
                        // caller has provided custom JSX
                        containerRef.current.style.minHeight = contentRef.current.getBoundingClientRect().width;
                        containerRef.current.style.minWidth = contentRef.current.getBoundingClientRect().height;
                    }
                } else {
                    containerRef.current.style.minHeight = defaultBadgeDimension;
                    containerRef.current.style.minWidth = defaultBadgeDimension;
                }
            }
        };
        window.addEventListener('resize', onResize);
        onResize();
        return function() {
            window.removeEventListener('resize', onResize);
        };
    }, [
        content,
        defaultBadgeDimension
    ]);
    // offset the badge so it overlaps content
    (0, $9462599f26e06396$export$e5c5a5f917a5871c)(function() {
        if (stackRef != null && stackRef.current) {
            // when badge has content, offset should be 50%.
            // when badge is empty, offset by a smaller amount to keep the badge
            // closer to the content. this value was chosen as a reasonable default
            // after testing with various grommet icons.
            var offset = typeof content === 'boolean' || content && content.value === true ? '25%' : '50%';
            // second child of Stack is the div that receives absolute positioning
            // and contains our badge content
            stackRef.current.children[1].style.top = 0;
            stackRef.current.children[1].style.right = 0;
            // eslint-disable-next-line max-len
            stackRef.current.children[1].style.transform = "translate(" + offset + ", -" + offset + ")";
            stackRef.current.children[1].style.transformOrigin = '100% 0%';
        }
    }, [
        content
    ]);
    var value;
    if (typeof content === 'number') value = content;
    else if (typeof content === 'object') value = content.value;
    var badge;
    if (typeof value === 'number' || typeof value === 'boolean' || typeof content === 'boolean') {
        if (typeof value === 'number') {
            var max = content.max || 9;
            badge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), {
                color: "text-strong",
                size: theme.button.badge.text.size.medium,
                weight: "normal",
                ref: contentRef
            }, value > max ? max + "+" : value);
        }
        badge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($d7e482005a2fe598$var$StyledBadgeContainer, $d7e482005a2fe598$var$_extends({
            ref: containerRef,
            align: "center",
            background: content.background || theme.button.badge.container.background,
            flex: false,
            justify: "center",
            round: true,
            pad: !(typeof value === 'boolean' || typeof content === 'boolean') ? theme.button.badge.container.pad : undefined
        }, passThemeFlag), badge);
    // caller has provided their own JSX and we will just render that
    } else badge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        ref: contentRef
    }, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $1e7958766884f71d$export$694e0d28c7ffc90c), {
        ref: stackRef,
        anchor: "top-right"
    }, children, badge);
};



var $iA1nz = parcelRequire("iA1nz");


var $acc243cee91cb62f$var$radiusStyle = function radiusStyle(props) {
    // border.radius shouldn't impact an only-icon rendering.
    var isIconOnly = props.hasIcon && !props.hasLabel;
    var size = props.sizeProp;
    if (!isIconOnly && size && props.theme.button.size && props.theme.button.size[size]) return props.theme.button.size[size].border.radius;
    return props.theme.button.border.radius;
};
var $acc243cee91cb62f$var$fontStyle = function fontStyle(props) {
    var size = props.sizeProp || 'medium';
    var data = props.theme.text[size];
    return (0, $iA1nz.css)([
        "font-size:",
        ";line-height:",
        ";"
    ], data.size, data.height);
};
var $acc243cee91cb62f$var$padStyle = function padStyle(props) {
    var size = props.sizeProp;
    if (size && props.theme.button.size && props.theme.button.size[size]) return (0, $iA1nz.css)([
        "",
        " ",
        ""
    ], props.theme.button.size[size].pad.vertical, props.theme.button.size[size].pad.horizontal);
    return (0, $iA1nz.css)([
        "",
        " ",
        ""
    ], props.theme.button.padding.vertical, props.theme.button.padding.horizontal);
};
var $acc243cee91cb62f$var$basicStyle = function basicStyle(props) {
    return (0, $iA1nz.css)([
        "border:",
        " solid ",
        ";border-radius:",
        ";",
        " color:",
        ";padding:",
        ";",
        ""
    ], props.theme.button.border.width, (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.colorValue || props.theme.button.border.color || 'control', props.theme), $acc243cee91cb62f$var$radiusStyle(props), props.theme.button.elevation && (0, $73ba8e2d301b823f$export$b4ff7c828301ce9f)(props.theme.button.elevation), (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.theme.button.color || 'text', props.theme), $acc243cee91cb62f$var$padStyle(props), $acc243cee91cb62f$var$fontStyle(props));
};
var $acc243cee91cb62f$var$primaryStyle = function primaryStyle(props) {
    var _props$theme$button$p, _props$theme$button$p2;
    return (0, $iA1nz.css)([
        "",
        " border-radius:",
        ";",
        " ",
        ""
    ], (0, $0b4a347e23c22183$export$e43a4f0de05cb7e9)((0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.colorValue || props.theme.button.primary && props.theme.button.primary.color || 'control', props.theme), props.theme, props.theme.button.color), $acc243cee91cb62f$var$radiusStyle(props), ((_props$theme$button$p = props.theme.button.primary) == null ? void 0 : _props$theme$button$p.elevation) && (0, $73ba8e2d301b823f$export$b4ff7c828301ce9f)((_props$theme$button$p2 = props.theme.button.primary) == null ? void 0 : _props$theme$button$p2.elevation), props.theme.button.primary && props.theme.button.primary.extend);
};
function $acc243cee91cb62f$var$getHoverColor(props) {
    if (props.colorValue) return (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.colorValue, props.theme);
    if (props.active && props.primary && props.theme.button.primary && props.theme.button.primary.active && props.theme.button.primary.active.border && props.theme.button.primary.active.border.color) return (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.theme.button.primary.active.border.color, props.theme);
    return (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.theme.button.border.color || 'control', props.theme);
}
var $acc243cee91cb62f$var$hoverStyle = (0, $iA1nz.css)([
    "&:hover{",
    " ",
    ";}"
], function(props) {
    return props.hoverIndicator && (0, $0b4a347e23c22183$export$172ca055ee2bcc62)(props.hoverIndicator, props.theme);
}, function(props) {
    return !props.plain && (0, $iA1nz.css)([
        "box-shadow:0px 0px 0px 2px ",
        ";"
    ], $acc243cee91cb62f$var$getHoverColor(props));
});
var $acc243cee91cb62f$var$fillStyle = function fillStyle(fillContainer) {
    if (fillContainer === 'horizontal') return 'width: 100%;';
    if (fillContainer === 'vertical') return 'height: 100%;';
    if (fillContainer) return "\n      width: 100%;\n      height: 100%;\n      max-width: none;\n      flex: 1 0 auto;\n    ";
    return undefined;
};
var $acc243cee91cb62f$var$plainStyle = function plainStyle(props) {
    return (0, $iA1nz.css)([
        "color:",
        ";outline:none;border:none;padding:0;text-align:inherit;"
    ], (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.colorValue || 'inherit', props.theme));
};
var $acc243cee91cb62f$var$activeButtonStyle = function activeButtonStyle(props) {
    return (0, $iA1nz.css)([
        "",
        " ",
        " ",
        ""
    ], (0, $0b4a347e23c22183$export$d51670144e8c59cf), props.primary && props.theme.button.primary && props.theme.button.primary.active && props.theme.button.primary.active.border && props.theme.button.primary.active.border.color && "border: " + props.theme.button.border.width + " solid\n    " + (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.theme.button.primary.active.border.color, props.theme) + ";\n    ", props.primary && props.theme.button.primary && props.theme.button.primary.active && props.theme.button.primary.active.extend);
};
var $acc243cee91cb62f$var$disabledButtonStyle = function disabledButtonStyle(props) {
    return (0, $iA1nz.css)([
        "",
        " ",
        " ",
        " ",
        ""
    ], (0, $73ba8e2d301b823f$export$adf3fcef8e5e1347)(props.theme.button.disabled.opacity), !props.plain && props.theme.button.disabled.border && props.theme.button.disabled.border.color && "border: " + props.theme.button.border.width + " solid\n    " + (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.theme.button.disabled.border.color, props.theme) + ";", props.theme.button.disabled.color && // if primary button, apply disabled color to background. otherwise,
    // apply disabled color to the label
    (props.primary ? (0, $0b4a347e23c22183$export$e43a4f0de05cb7e9)((0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.theme.button.disabled.color, props.theme), props.theme, props.theme.button.color) : "color: " + (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.theme.button.disabled.color, props.theme) + ";"), props.theme.button.disabled && props.theme.button.disabled.extend);
};
// Deprecate props.theme.button.disabled.opacity in V3
var $acc243cee91cb62f$export$2d5d2ba3c7c8c40b = (0, $iA1nz.default).button.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledButton",
    componentId: "sc-323bzc-0"
})([
    "display:inline-block;box-sizing:border-box;cursor:pointer;font:inherit;text-decoration:none;margin:0;background:transparent;overflow:visible;text-transform:none;",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " &:focus{",
    "}&:focus:not(:focus-visible){",
    "}",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], (0, $73ba8e2d301b823f$export$a157b298d219a801), function(props) {
    return props.plain && $acc243cee91cb62f$var$plainStyle(props);
}, function(props) {
    return !props.plain && $acc243cee91cb62f$var$basicStyle(props);
}, function(props) {
    return props.primary && $acc243cee91cb62f$var$primaryStyle(props);
}, function(props) {
    return !props.disabled && !props.selected && !props.focus && !props.busy && !props.success && $acc243cee91cb62f$var$hoverStyle;
}, function(props) {
    return !props.disabled && props.active && $acc243cee91cb62f$var$activeButtonStyle(props);
}, function(props) {
    return props.disabled && props.theme.button && props.theme.button.disabled && $acc243cee91cb62f$var$disabledButtonStyle(props);
}, function(props) {
    return (!props.plain || props.focusIndicator) && (0, $73ba8e2d301b823f$export$efbff472cb39d8b)({
        inset: props.focusIndicator === 'inset'
    });
}, (0, $73ba8e2d301b823f$export$525440aaa2c64805)(), function(props) {
    return !props.plain && props.theme.button.transition && "\n    transition-property: " + props.theme.button.transition.properties.join(',') + ";\n    transition-duration: " + props.theme.button.transition.duration + "s;\n    transition-timing-function: " + props.theme.button.transition.timing + ";\n  ";
}, function(props) {
    return props.fillContainer && $acc243cee91cb62f$var$fillStyle(props.fillContainer);
}, function(props) {
    return props.hasIcon && !props.hasLabel && "\n    line-height: 0;\n  ";
}, function(props) {
    return props.pad === true && props.hasIcon && !props.hasLabel && "\n    padding: " + props.theme.global.edgeSize.small + ";\n  ";
}, function(props) {
    return !props.plain && props.pad && (0, $73ba8e2d301b823f$export$944a9710f9445eee)('padding', props.pad, false, undefined, props.theme);
}, function(props) {
    return props.theme.button && props.theme.button.extend;
}, function(props) {
    return (props.busy || props.success) && "\n    cursor: default;\n  ";
});



var $iA1nz = parcelRequire("iA1nz");

var $8Fliv = parcelRequire("8Fliv");

var $1b3f33d771eb3e47$var$radiusStyle = function radiusStyle(props) {
    var size = props.sizeProp;
    // caller has specified a themeObj to use for styling
    // relevant for cases like pagination which looks to theme.pagination.button
    var themeObj = typeof props.kind === 'object' ? props.kind : props.theme.button;
    if (size && themeObj.size && themeObj.size[size]) return (0, $iA1nz.css)([
        "border-radius:",
        ";"
    ], themeObj.size[size].border.radius);
    if (themeObj.border && themeObj.border.radius) return (0, $iA1nz.css)([
        "border-radius:",
        ";"
    ], themeObj.border.radius);
    return '';
};
var $1b3f33d771eb3e47$var$fontStyle = function fontStyle(props) {
    var size = props.sizeProp || 'medium';
    var data = props.theme.text[size];
    return (0, $iA1nz.css)([
        "font-size:",
        ";line-height:",
        ";"
    ], data.size, props.hasIcon && !props.hasLabel ? 0 : data.height);
};
var $1b3f33d771eb3e47$var$padFromTheme = function padFromTheme(size, theme, themeObj, kind, iconOnly) {
    var _themeObj$size, _themeObj$size3;
    if (size === void 0) size = 'medium';
    if (size && iconOnly && themeObj != null && (_themeObj$size = themeObj.size) != null && (_themeObj$size = _themeObj$size[size]) != null && (_themeObj$size = _themeObj$size.iconOnly) != null && _themeObj$size.pad) {
        var _themeObj$size2;
        var pad = themeObj == null || (_themeObj$size2 = themeObj.size) == null || (_themeObj$size2 = _themeObj$size2[size]) == null || (_themeObj$size2 = _themeObj$size2.iconOnly) == null ? void 0 : _themeObj$size2.pad;
        return {
            vertical: typeof pad === 'string' ? pad : pad.vertical,
            horizontal: typeof pad === 'string' ? pad : pad.horizontal
        };
    }
    if (size && themeObj != null && (_themeObj$size3 = themeObj.size) != null && (_themeObj$size3 = _themeObj$size3[size]) != null && (_themeObj$size3 = _themeObj$size3[kind]) != null && _themeObj$size3.pad) return themeObj.size[size][kind].pad;
    if (size && themeObj.size && themeObj.size[size] && themeObj.size[size].pad) return {
        vertical: themeObj.size[size].pad.vertical,
        horizontal: themeObj.size[size].pad.horizontal
    };
    if (theme.button.padding) return {
        vertical: theme.global.edgeSize[theme.button.padding.vertical] || theme.button.padding.vertical,
        horizontal: theme.global.edgeSize[theme.button.padding.horizontal] || theme.button.padding.horizontal
    };
    return undefined;
};
var $1b3f33d771eb3e47$var$padStyle = function padStyle(_ref) {
    var hasIcon = _ref.hasIcon, hasLabel = _ref.hasLabel, size = _ref.sizeProp, theme = _ref.theme, kind = _ref.kind;
    // caller has specified a themeObj to use for styling
    // relevant for cases like pagination which looks to theme.pagination.button
    var themeObj = typeof kind === 'object' ? kind : theme.button;
    var iconOnly = hasIcon && !hasLabel;
    var pad = $1b3f33d771eb3e47$var$padFromTheme(size, theme, themeObj, kind, iconOnly);
    return pad ? (0, $iA1nz.css)([
        "padding:",
        " ",
        ";"
    ], pad.vertical, pad.horizontal) : '';
};
var $1b3f33d771eb3e47$var$basicStyle = function basicStyle(props) {
    return (0, $iA1nz.css)([
        "border:none;",
        ";",
        " ",
        " ",
        ""
    ], $1b3f33d771eb3e47$var$radiusStyle(props), $1b3f33d771eb3e47$var$padStyle(props), $1b3f33d771eb3e47$var$fontStyle(props), props.icon && "\n    > svg {\n      display: flex;\n      align-self: center;\n      vertical-align: middle;\n    }\n  ");
};
var $1b3f33d771eb3e47$var$getPath = function getPath(theme, path) {
    var obj;
    if (path) {
        obj = theme;
        var parts = path.split('.');
        while(obj && parts.length)obj = obj[parts.shift()];
    }
    return obj;
};
var $1b3f33d771eb3e47$var$adjustPadStyle = function adjustPadStyle(pad, width, theme) {
    var _theme$button;
    var intelligentPad = theme == null || (_theme$button = theme.button) == null ? void 0 : _theme$button.intelligentPad;
    if (intelligentPad === true) {
        var offset = (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(width);
        return (0, $iA1nz.css)([
            "padding:",
            "px ",
            "px;"
        ], Math.max((0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(pad.vertical) - offset, 0), Math.max((0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(pad.horizontal) - offset, 0));
    }
    // If intelligentPad is false return padding without adjustment
    return (0, $iA1nz.css)([
        "padding:",
        " ",
        ";"
    ], pad.vertical, pad.horizontal);
};
// build up CSS from basic to specific based on the supplied sub-object paths
var $1b3f33d771eb3e47$var$kindStyle = function kindStyle(_ref2) {
    var busy = _ref2.busy, colorValue = _ref2.colorValue, hasIcon = _ref2.hasIcon, hasLabel = _ref2.hasLabel, kind = _ref2.kind, size = _ref2.sizeProp, success = _ref2.success, themePaths = _ref2.themePaths, theme = _ref2.theme;
    var styles = [];
    // caller has specified a themeObj to use for styling
    // relevant for cases like pagination which looks to theme.pagination.button
    var themeObj = typeof kind === 'object' ? kind : theme.button;
    var iconOnly = hasIcon && !hasLabel;
    var pad = $1b3f33d771eb3e47$var$padFromTheme(size, theme, themeObj, kind, iconOnly);
    themePaths.base.forEach(function(themePath) {
        var obj = $1b3f33d771eb3e47$var$getPath(themeObj, themePath);
        if (obj) {
            styles.push((0, $73ba8e2d301b823f$export$73d7bd5e5b0271ce)(obj, theme, colorValue));
            if (obj.border && obj.border.width && pad && !obj.padding) // Adjust padding from the button.size or just top button.padding
            // to deal with the kind's border width. But don't override any
            // padding in the kind itself for backward compatibility
            styles.push($1b3f33d771eb3e47$var$adjustPadStyle(pad, obj.border.width, theme));
        }
    });
    // do the styling from the root of the object if caller passes one
    if (!themePaths.base.length && typeof kind === 'object') {
        var obj = kind;
        if (obj) {
            styles.push((0, $73ba8e2d301b823f$export$73d7bd5e5b0271ce)(obj, theme, colorValue));
            if (obj.border && obj.border.width && pad && !obj.padding) // Adjust padding from the button.size or just top button.padding
            // to deal with the kind's border width. But don't override any
            // padding in the kind itself for backward compatibility
            styles.push($1b3f33d771eb3e47$var$adjustPadStyle(pad, obj.border.width, theme));
        }
    }
    themePaths.hover.forEach(function(themePath) {
        var obj = $1b3f33d771eb3e47$var$getPath(themeObj, themePath);
        if (obj) {
            var partStyles = (0, $73ba8e2d301b823f$export$73d7bd5e5b0271ce)(obj, theme);
            var adjPadStyles = '';
            if (obj.border && obj.border.width && pad && !obj.padding) // Adjust padding from the button.size or just top button.padding
            // to deal with the hover's border width. But don't override any
            // padding in the hover or hover.kind itself for backward compatibility
            adjPadStyles = $1b3f33d771eb3e47$var$adjustPadStyle(pad, obj.border.width, theme);
            if (partStyles.length > 0 && !busy && !success) styles.push((0, $iA1nz.css)([
                "&:hover{",
                " ",
                "}"
            ], partStyles, adjPadStyles));
        }
    });
    return styles;
};
var $1b3f33d771eb3e47$var$hoverIndicatorStyle = function hoverIndicatorStyle(_ref3) {
    var hoverIndicator = _ref3.hoverIndicator, theme = _ref3.theme;
    var themishObj = {};
    if (hoverIndicator === true || hoverIndicator === 'background') themishObj.background = theme.global.hover.background;
    else if (hoverIndicator.color || hoverIndicator.background) {
        if (hoverIndicator.background) themishObj.background = hoverIndicator.background;
        if (hoverIndicator.color) themishObj.color = hoverIndicator.color;
    } else themishObj.background = hoverIndicator;
    var styles = (0, $73ba8e2d301b823f$export$73d7bd5e5b0271ce)(themishObj, theme);
    if (styles.length > 0) return (0, $iA1nz.css)([
        "&:hover{",
        "}"
    ], styles);
    return '';
};
var $1b3f33d771eb3e47$var$fillStyle = function fillStyle(fillContainer) {
    if (fillContainer === 'horizontal') return 'width: 100%;';
    if (fillContainer === 'vertical') return 'height: 100%;';
    if (fillContainer) return "\n      width: 100%;\n      height: 100%;\n      max-width: none;\n      flex: 1 0 auto;\n    ";
    return undefined;
};
var $1b3f33d771eb3e47$var$plainStyle = function plainStyle(props) {
    return (0, $iA1nz.css)([
        "outline:none;border:none;padding:0;text-align:inherit;color:inherit;",
        " ",
        ""
    ], props.icon && "\n    > svg {\n      display: flex;\n      align-self: center;\n      vertical-align: middle;\n    }\n  ", props.hasIcon && !props.hasLabel && "line-height: 0;");
};
var $1b3f33d771eb3e47$export$64e6768d853ca4b8 = (0, $iA1nz.default).button.withConfig({
    shouldForwardProp: function shouldForwardProp(prop) {
        return (0, $8Fliv.default)(prop) && ![
            'kind'
        ].includes(prop);
    }
}).withConfig({
    displayName: "StyledButtonKind",
    componentId: "sc-1vhfpnt-0"
})([
    "display:inline-block;box-sizing:border-box;cursor:pointer;font:inherit;text-decoration:none;margin:0;background:transparent;overflow:visible;text-transform:none;",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " &:focus{",
    "}&:focus:not(:focus-visible){",
    "}",
    " ",
    " ",
    " ",
    ""
], (0, $73ba8e2d301b823f$export$a157b298d219a801), function(props) {
    return props.plain && $1b3f33d771eb3e47$var$plainStyle(props);
}, function(props) {
    return !props.disabled && props.active && (0, $0b4a347e23c22183$export$d51670144e8c59cf);
}, function(props) {
    return !props.plain && $1b3f33d771eb3e47$var$basicStyle(props);
}, function(props) {
    return !props.plain && $1b3f33d771eb3e47$var$kindStyle(props);
}, function(props) {
    return !props.plain && props.pad && (0, $73ba8e2d301b823f$export$944a9710f9445eee)('padding', props.pad, false, undefined, props.theme);
}, function(props) {
    return !props.plain && props.align && "\n    text-align: " + props.align + ";\n    ";
}, function(props) {
    return !props.disabled && props.hoverIndicator && !props.busy && !props.success && $1b3f33d771eb3e47$var$hoverIndicatorStyle(props);
}, function(props) {
    return props.disabled && (0, $73ba8e2d301b823f$export$adf3fcef8e5e1347)(props.theme.button.disabled.opacity);
}, function(props) {
    return (!props.plain || props.focusIndicator) && (0, $73ba8e2d301b823f$export$efbff472cb39d8b)({
        inset: props.focusIndicator === 'inset'
    });
}, (0, $73ba8e2d301b823f$export$525440aaa2c64805)(), function(props) {
    return !props.plain && props.theme.button.transition && "\n    transition-property: " + props.theme.button.transition.properties.join(',') + ";\n    transition-duration: " + props.theme.button.transition.duration + "s;\n    transition-timing-function: " + props.theme.button.transition.timing + ";\n  ";
}, function(props) {
    return props.fillContainer && $1b3f33d771eb3e47$var$fillStyle(props.fillContainer);
}, function(props) {
    return props.theme.button && props.theme.button.extend;
}, function(props) {
    return (props.busy || props.success) && "\n    cursor: default;\n  ";
});





var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");
var $efa3551e30470d99$exports = {};

$parcel$export($efa3551e30470d99$exports, "__esModule", function () { return $efa3551e30470d99$export$1e511d4a378977f5; }, function (v) { return $efa3551e30470d99$export$1e511d4a378977f5 = v; });
$parcel$export($efa3551e30470d99$exports, "Checkmark", function () { return $efa3551e30470d99$export$4f481e0a96cfbed6; }, function (v) { return $efa3551e30470d99$export$4f481e0a96cfbed6 = v; });
var $efa3551e30470d99$export$1e511d4a378977f5;
var $efa3551e30470d99$export$4f481e0a96cfbed6;
"use strict";
$efa3551e30470d99$export$1e511d4a378977f5 = true;
$efa3551e30470d99$export$4f481e0a96cfbed6 = void 0;

var $efa3551e30470d99$var$_react = $efa3551e30470d99$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $efa3551e30470d99$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($efa3551e30470d99$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $efa3551e30470d99$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $efa3551e30470d99$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $efa3551e30470d99$var$_extends() {
    return $efa3551e30470d99$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $efa3551e30470d99$var$_extends.apply(null, arguments);
}
var $efa3551e30470d99$var$Checkmark = $efa3551e30470d99$export$4f481e0a96cfbed6 = /*#__PURE__*/ (0, $efa3551e30470d99$var$_react.forwardRef)(function(props, ref) {
    var scaleProps = (0, $1b754218be0a6592$export$56a2e46cd4a7c217)(props);
    return /*#__PURE__*/ $efa3551e30470d99$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $efa3551e30470d99$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Checkmark"
    }, props), /*#__PURE__*/ $efa3551e30470d99$var$_react["default"].createElement("path", $efa3551e30470d99$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m2 14 7 6L22 4"
    }, scaleProps)));
});
$efa3551e30470d99$var$Checkmark.displayName = 'Checkmark';





var $a22c1255c918d2af$var$bounceDelay = (0, $iA1nz.keyframes)([
    "0%,80%,100%{transform:scale(0.4);}40%{transform:scale(0.8);}"
]);
var $a22c1255c918d2af$var$bounceDelayRule = (0, $iA1nz.css)([
    "animation:",
    " 1.4s infinite ease-in-out both;"
], $a22c1255c918d2af$var$bounceDelay);
var $a22c1255c918d2af$var$Dot = (0, $iA1nz.default)((0, $18c0523379e5dd9d$export$e71c4d32a2263218)).withConfig({
    displayName: "BusyAnimation__Dot",
    componentId: "sc-feuivs-0"
})([
    "background-color:currentColor;width:8px;height:8px;border-radius:100%;display:inline-block;",
    " ",
    ""
], $a22c1255c918d2af$var$bounceDelayRule, function(props) {
    return props.delay && "animation-delay: " + props.delay + ";";
});
var $a22c1255c918d2af$export$ac1e1252ed898bd3 = function EllipsisAnimation() {
    var _theme$button;
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        style: {
            position: 'absolute'
        },
        fill: true,
        alignContent: "center",
        justify: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        alignSelf: "center",
        direction: "row",
        gap: (_theme$button = theme.button) == null || (_theme$button = _theme$button.busy) == null ? void 0 : _theme$button.gap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($a22c1255c918d2af$var$Dot, {
        delay: "-0.32s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($a22c1255c918d2af$var$Dot, {
        delay: "-0.16s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($a22c1255c918d2af$var$Dot, null)));
};
var $a22c1255c918d2af$var$grow = (0, $iA1nz.keyframes)([
    "0%{opacity:0;transform:scale(.3);}20%{opacity:1;transform:scale(1.15);}30%{transform:scale(.9);}45%{transform:scale(1.05);}55%{transform:scale(1);}100%{transform:scale(1);}"
]);
var $a22c1255c918d2af$export$b9551c1d2e56e841 = (0, $iA1nz.default)((0, $efa3551e30470d99$export$4f481e0a96cfbed6)).withConfig({
    displayName: "BusyAnimation__GrowCheckmark",
    componentId: "sc-feuivs-1"
})([
    "position:absolute;align-self:center;animation:",
    " 0.9s ease-in-out;"
], $a22c1255c918d2af$var$grow);
var $a22c1255c918d2af$export$8bc5e3952d9f3838 = (0, $iA1nz.default).div.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "BusyAnimation__StyledBusyContents",
    componentId: "sc-feuivs-2"
})([
    "opacity:",
    ";}"
], function(props) {
    return props.animating ? 0 : 1;
});



var $102e2aa1ff54ae51$var$_excluded = [
    "active",
    "align",
    "aria-label",
    "badge",
    "busy",
    "color",
    "children",
    "disabled",
    "icon",
    "focusIndicator",
    "gap",
    "fill",
    "href",
    "justify",
    "kind",
    "label",
    "messages",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseOut",
    "onMouseOver",
    "pad",
    "plain",
    "primary",
    "reverse",
    "secondary",
    "selected",
    "size",
    "success",
    "tip",
    "type",
    "a11yTitle",
    "as"
];
function $102e2aa1ff54ae51$var$_extends() {
    return $102e2aa1ff54ae51$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $102e2aa1ff54ae51$var$_extends.apply(null, arguments);
}
function $102e2aa1ff54ae51$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $102e2aa1ff54ae51$var$RelativeBox = (0, $iA1nz.default)((0, $18c0523379e5dd9d$export$e71c4d32a2263218)).withConfig({
    displayName: "Button__RelativeBox",
    componentId: "sc-zuqsuw-0"
})([
    "position:relative;"
]);
// We have two Styled* components to separate
// the newer default|primary|secondary approach,
// which we use the term "kind" to refer to,
// from the previous approach. Hopefully, when we get to grommet v3,
// we can drop the old way and just use kind.
//
// In the kind approach, we rely on the basic structure of the theme
// being repeated. For example: button.default, button.active,
// button.active.default all refer to a similar object containing
// { background, border, color, padding }.
// This allows us to use the same code to evaluate color and generate CSS.
// We just need to build up CSS, since selectors override previous ones.
// See StyledButtonKind.kindStyles() for this.
// And we build down to determine icon color, once we have a color from
// the latest applicable state, we can stop. See Button.getIconColor() for this.
// backgroundAndTextColor() is used in both cases to ensure we are determining
// color in the same way, so the icon and label align.
// only when default is in the theme
// Used to get the color for the icon to match what StyledButtonKind
// and backgroundStyle() will do for the label.
// The paths are ordered from basic to specific. Go through them
// specific to base until we find one that has a color and use that.
var $102e2aa1ff54ae51$var$getIconColor = function getIconColor(paths, theme, colorProp, kind) {
    if (paths === void 0) paths = [];
    var result = [];
    var index = paths.length - 1;
    // caller has specified a themeObj to use for styling
    // relevant for cases like pagination which looks to theme.pagination.button
    if (typeof kind === 'object') index = 0;
    // stop when we have a color or no more paths
    while(index >= 0 && !result[1]){
        var baseObj = typeof kind === 'object' && kind || theme.button;
        var obj = baseObj;
        // find sub-object under the button theme that corresponds with this path
        // for example: 'active.primary'
        if (paths[index]) {
            var parts = paths[index].split('.');
            while(obj && parts.length)obj = obj[parts.shift()];
        }
        if (obj) {
            var _obj;
            // use passed in color for background if the theme has a background color
            var background = colorProp && obj.background && obj.background.color ? colorProp : obj.background;
            // if theme object explicitly sets the color to undefined, pass false
            // to indicate that the theme doesn't want any text color
            var objColor = obj.color || (Object.prototype.hasOwnProperty.call(obj, 'color') && obj.color === undefined ? false : undefined);
            var color = void 0;
            if ((_obj = obj) != null && (_obj = _obj.icon) != null && (_obj = _obj.props) != null && _obj.color) color = obj.icon.props.color;
            else if (paths[index + 1]) {
                var _obj2;
                var _parts = paths[index + 1].split('.');
                while(baseObj && _parts.length)obj = baseObj[_parts.shift()];
                if ((_obj2 = obj) != null && (_obj2 = _obj2.icon) != null && (_obj2 = _obj2.props) != null && _obj2.color) color = obj.icon.props.color;
            }
            // use passed in color for text if the theme doesn't have
            // background or border color
            if (!color) color = colorProp && (!obj.background || !obj.background.color) && (!obj.border || !obj.border.color) ? colorProp : objColor;
            result = (0, $0b4a347e23c22183$export$51f19bd17c18b682)(background, color, theme);
        }
        index -= 1;
    }
    return result[1] || undefined;
};
// get the icon for the current button state
var $102e2aa1ff54ae51$var$getKindIcon = function getKindIcon(paths, theme, kind) {
    if (paths === void 0) paths = [];
    var result;
    var index = paths.length - 1;
    // caller has specified a themeObj to use for styling
    // relevant for cases like pagination which looks to theme.pagination.button
    if (typeof kind === 'object') index = 0;
    // stop when we have a color or no more paths
    while(index >= 0 && !result){
        var _obj3;
        var obj = typeof kind === 'object' && kind || theme.button;
        // find sub-object under the button theme that corresponds with this path
        // for example: 'active.primary'
        if (paths[index]) {
            var parts = paths[index].split('.');
            while(obj && parts.length)obj = obj[parts.shift()];
        }
        if ((_obj3 = obj) != null && _obj3.icon) result = obj.icon;
        index -= 1;
    }
    return result || undefined;
};
var $102e2aa1ff54ae51$var$getPropertyColor = function getPropertyColor(property, paths, theme, kind, primary) {
    if (paths === void 0) paths = [];
    var result;
    if (kind) {
        var obj = typeof kind === 'object' && kind || theme.button;
        // index 0 is default state
        if (paths[0]) {
            var parts = paths[0].split('.');
            while(obj && parts.length)obj = obj[parts.shift()];
        }
        if (obj) result = obj[property] || obj[property] && obj[property].color;
    } else if (primary && theme && theme.button && theme.button.primary) result = theme.button.primary[property] || theme.button.primary[property] && theme.button.primary[property].color;
    else result = theme && theme.button && theme.button[property] || theme && theme.button && theme.button[property] && theme.button[property].color;
    return result;
};
var $102e2aa1ff54ae51$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var _theme$global$depreca2, _theme$button$kind, _theme$button2;
    var active = _ref.active, _ref$align = _ref.align, align = _ref$align === void 0 ? 'center' : _ref$align, ariaLabel = _ref['aria-label'], badgeProp = _ref.badge, busy = _ref.busy, color = _ref.color, children = _ref.children, disabled = _ref.disabled, icon = _ref.icon, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, gap = _ref.gap, fill = _ref.fill, href = _ref.href, justify = _ref.justify, kindArg = _ref.kind, label = _ref.label, messages = _ref.messages, _onBlur = _ref.onBlur, onClickProp = _ref.onClick, _onFocus = _ref.onFocus, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, pad = _ref.pad, plain = _ref.plain, primary = _ref.primary, reverseProp = _ref.reverse, secondary = _ref.secondary, selected = _ref.selected, sizeProp = _ref.size, success = _ref.success, tip = _ref.tip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$a11yTitle = _ref.a11yTitle, a11yTitle = _ref$a11yTitle === void 0 ? typeof tip === 'string' ? tip : undefined : _ref$a11yTitle, as = _ref.as, rest = $102e2aa1ff54ae51$var$_objectWithoutPropertiesLoose(_ref, $102e2aa1ff54ae51$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useContext = (0, $2xPiy.useContext)((0, $cc9e28c6770f7140$export$b709306b005c3ef)), buttonOptions = _useContext.button;
    var _useState = (0, $2xPiy.useState)(), focus = _useState[0], setFocus = _useState[1];
    var _useState2 = (0, $2xPiy.useState)(false), hover = _useState2[0], setHover = _useState2[1];
    var announce = (0, $2xPiy.useContext)((0, $c8f61343d2547c6a$export$dcc8f4bff0d51f50));
    var _useContext2 = (0, $2xPiy.useContext)((0, $f1ad7bf122eed3b0$export$b060d577040138d8)), format = _useContext2.format;
    if (busy && success) console.warn('Button cannot have both busy and success set to true.');
    (0, $2xPiy.useEffect)(function() {
        if (busy) announce(format({
            id: 'button.busy',
            messages: messages
        }));
        else if (success) announce(format({
            id: 'button.success',
            messages: messages
        }));
    }, [
        announce,
        busy,
        format,
        messages,
        success
    ]);
    if ((icon || label) && children) console.warn('Button should not have children if icon or label is provided');
    (0, $2xPiy.useEffect)(function() {
        var _theme$global$depreca;
        if ((_theme$global$depreca = theme.global.deprecated) != null && (_theme$global$depreca = _theme$global$depreca.button) != null && _theme$global$depreca.kind && kindArg) {
            var deprecatedKind = theme.global.deprecated.button.kind.find(function(item) {
                return item.name === kindArg;
            });
            if (deprecatedKind) console.warn(deprecatedKind.message || kindArg + " is deprecated.");
        }
    }, [
        kindArg,
        (_theme$global$depreca2 = theme.global.deprecated) == null || (_theme$global$depreca2 = _theme$global$depreca2.button) == null ? void 0 : _theme$global$depreca2.kind
    ]);
    var skeleton = (0, $b03c62556e524549$export$9489db5f14593d18)();
    var sendAnalytics = (0, $5bd12fcfcb46b8f6$export$e955abb82869dc84)();
    var onClick = (0, $2xPiy.useCallback)(function(event) {
        sendAnalytics({
            type: 'buttonClick',
            element: (0, $83f2052c15a18307$export$37a8984127440e55)(event.target),
            event: event,
            href: href,
            label: typeof label === 'string' ? label : undefined
        });
        if (onClickProp) onClickProp(event);
    }, [
        onClickProp,
        sendAnalytics,
        href,
        label
    ]);
    // kindArg is object if we are referencing a theme object
    // outside of theme.button
    var kindObj = (0, $2xPiy.useMemo)(function() {
        return typeof kindArg === 'object';
    }, [
        kindArg
    ]);
    // if the theme has button.default, what kind of Button is this
    var kind = (0, $2xPiy.useMemo)(function() {
        if (theme.button["default"] || kindObj) {
            if (kindArg) return kindArg;
            if (primary) return 'primary';
            if (secondary) return 'secondary';
            return 'default';
        }
        return undefined; // pre-default, no kind
    }, [
        kindArg,
        kindObj,
        primary,
        secondary,
        theme
    ]);
    // for backwards compatibility, no-kind button theme did not
    // default to size "medium" on buttons with no size prop
    var size = sizeProp || kind && 'medium' || undefined;
    // When we have a kind and are not plain, themePaths stores the relative
    // paths within the theme for the current kind and state of the button.
    // These paths are used with getIconColor() above and kindStyle() within
    // StyledButtonKind.
    var themePaths = (0, $2xPiy.useMemo)(function() {
        if (!kind || plain) return undefined;
        var result = {
            base: [],
            hover: []
        };
        if (!kindObj) result.base.push(kind);
        if (selected) {
            result.base.push('selected');
            if (!kindObj) result.base.push("selected." + kind);
        }
        if (disabled) {
            result.base.push('disabled');
            if (!kindObj) result.base.push("disabled." + kind);
        } else {
            if (active) {
                result.base.push('active');
                if (!kindObj) result.base.push("active." + kind);
            }
            result.hover.push('hover');
            if (!kindObj) result.hover.push("hover." + kind);
            if (active) {
                result.hover.push("hover.active");
                if (!kindObj) result.hover.push("hover.active." + kind);
            }
        }
        return result;
    }, [
        active,
        disabled,
        kind,
        kindObj,
        plain,
        selected
    ]);
    // only used when theme does not have button.default
    var isDarkBackground = function isDarkBackground() {
        var backgroundColor = (0, $0b4a347e23c22183$export$7b802385d70a5af9)((0, $11317b0e49e0d157$export$4cde5df63f53f473)(color || theme.button.primary && theme.button.primary.color || theme.global.colors.control || 'brand', theme), theme);
        return (0, $11317b0e49e0d157$export$76249e090d1c76db)(backgroundColor, theme);
    };
    var onMouseOverButton = function onMouseOverButton(event) {
        setHover(true);
        if (onMouseOver) onMouseOver(event);
    };
    var onMouseOutButton = function onMouseOutButton(event) {
        setHover(false);
        if (onMouseOut) onMouseOut(event);
    };
    var kindIcon = hover && $102e2aa1ff54ae51$var$getKindIcon(themePaths == null ? void 0 : themePaths.hover, theme, kind) || $102e2aa1ff54ae51$var$getKindIcon(themePaths == null ? void 0 : themePaths.base, theme, kind);
    var buttonIcon = icon || kindIcon;
    // only change color if user did not specify the color themselves...
    if (icon && !icon.props.color) {
        if (kind) {
            if (!plain) {
                // match what the label will use
                var iconColor = hover && $102e2aa1ff54ae51$var$getIconColor(themePaths.hover, theme) || $102e2aa1ff54ae51$var$getIconColor(themePaths.base, theme, color, kind);
                if (iconColor) buttonIcon = /*#__PURE__*/ (0, $2xPiy.cloneElement)(icon, {
                    color: iconColor
                });
            }
        } else if (primary) buttonIcon = /*#__PURE__*/ (0, $2xPiy.cloneElement)(icon, {
            color: theme.global.colors.text[isDarkBackground() ? 'dark' : 'light']
        });
    } else if (kindIcon && !plain) {
        var _iconColor = hover && $102e2aa1ff54ae51$var$getIconColor(themePaths.hover, theme) || $102e2aa1ff54ae51$var$getIconColor(themePaths.base, theme, color, kind);
        if (_iconColor) buttonIcon = /*#__PURE__*/ (0, $2xPiy.cloneElement)(kindIcon, {
            color: _iconColor
        });
    }
    buttonIcon = (0, $0a9f81b63fff2436$export$a123f939253731a8)(buttonIcon, size, theme);
    if (skeleton) {
        var _theme$text, _theme$button$size;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3c6eab35cbfc0e04$export$8f31e4c4a37b8e9c), $102e2aa1ff54ae51$var$_extends({
            ref: ref,
            height: ((_theme$text = theme.text[size || 'medium']) == null ? void 0 : _theme$text.height) || size,
            a11yTitle: a11yTitle
        }, rest, (_theme$button$size = theme.button.size) == null ? void 0 : _theme$button$size[size || 'medium'], theme.button.skeleton));
    }
    var reverse = reverseProp != null ? reverseProp : (_theme$button$kind = theme.button[kind]) == null ? void 0 : _theme$button$kind.reverse;
    var domTag = !as && href ? 'a' : as;
    var first = reverse ? label : buttonIcon;
    var second = reverse ? buttonIcon : label;
    var contents;
    if (first && second) {
        var _theme$button;
        contents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            direction: ((_theme$button = theme.button) == null || (_theme$button = _theme$button[kind]) == null ? void 0 : _theme$button.direction) || 'row',
            align: "center",
            justify: justify || (align === 'center' ? 'center' : 'between'),
            gap: gap || theme.button.gap,
            responsive: false
        }, first, second);
    } else if (typeof children === 'function') contents = children({
        active: active,
        disabled: disabled,
        hover: hover,
        focus: focus
    });
    else contents = first || second || children;
    var background = $102e2aa1ff54ae51$var$getPropertyColor('background', themePaths && themePaths.base, theme, kind, primary);
    var border = $102e2aa1ff54ae51$var$getPropertyColor('border', themePaths && themePaths.base, theme, kind, primary);
    // set the badge relative to the button content
    // when the button doesn't have background or border
    // (!kind && icon && !label) is necessary because for old button logic,
    // if button has icon but not label, it will be considered "plain",
    // so no border or background will be applied
    var innerBadge = ((_theme$button2 = theme.button) == null || (_theme$button2 = _theme$button2.badge) == null ? void 0 : _theme$button2.align) !== 'container' && (!background && !border || !kind && icon && !label);
    if (badgeProp && innerBadge) contents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $d7e482005a2fe598$export$37acb3580601e69a), {
        content: badgeProp
    }, contents);
    if (busy || success) {
        var _theme$button3;
        // match what the label will use
        var animationColor;
        if (kind) {
            if (!plain) animationColor = hover && $102e2aa1ff54ae51$var$getIconColor(themePaths.hover, theme) || $102e2aa1ff54ae51$var$getIconColor(themePaths.base, theme, color, kind);
        } else if (primary) animationColor = theme.global.colors.text[isDarkBackground() ? 'dark' : 'light'];
        contents = /*#__PURE__*/ // position relative is necessary to have the animation
        // display over the button content
        (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($102e2aa1ff54ae51$var$RelativeBox, {
            flex: false
        }, busy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $a22c1255c918d2af$export$ac1e1252ed898bd3), null), success && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            style: {
                position: 'absolute'
            },
            fill: true,
            alignContent: "center",
            justify: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $a22c1255c918d2af$export$b9551c1d2e56e841), {
            color: animationColor,
            "aria-hidden": true,
            as: (_theme$button3 = theme.button) == null || (_theme$button3 = _theme$button3.busy) == null || (_theme$button3 = _theme$button3.icons) == null ? void 0 : _theme$button3.success
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $a22c1255c918d2af$export$8bc5e3952d9f3838), {
            animating: busy || success
        }, contents));
    }
    var styledButtonResult;
    if (kind) styledButtonResult = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $1b3f33d771eb3e47$export$64e6768d853ca4b8), $102e2aa1ff54ae51$var$_extends({}, rest, {
        as: domTag,
        ref: ref,
        active: active,
        align: align,
        "aria-label": ariaLabel || a11yTitle,
        busy: busy,
        badge: badgeProp,
        colorValue: color,
        disabled: disabled,
        hasIcon: !!icon,
        gap: gap,
        hasLabel: !!label,
        icon: icon,
        fillContainer: fill,
        focus: focus,
        focusIndicator: focusIndicator,
        href: href,
        kind: kind,
        themePaths: themePaths,
        onClick: !busy && !success ? onClick : undefined,
        onFocus: function onFocus(event) {
            setFocus(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        onMouseOver: onMouseOverButton,
        onMouseOut: onMouseOutButton,
        pad: pad,
        plain: plain || (buttonOptions == null ? void 0 : buttonOptions.childrenPlain) !== false && (0, $2xPiy.Children).count(children) > 0,
        primary: primary,
        selected: selected,
        sizeProp: size,
        success: success,
        type: !href ? type : undefined
    }, passThemeFlag), contents);
    else styledButtonResult = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $acc243cee91cb62f$export$2d5d2ba3c7c8c40b), $102e2aa1ff54ae51$var$_extends({}, rest, {
        as: domTag,
        ref: ref,
        "aria-label": ariaLabel || a11yTitle,
        busy: busy,
        colorValue: color,
        active: active,
        selected: selected,
        disabled: disabled,
        hasIcon: !!icon,
        gap: gap,
        hasLabel: !!label,
        fillContainer: fill,
        focus: focus,
        focusIndicator: focusIndicator,
        href: href,
        kind: kind,
        themePaths: themePaths,
        onClick: !busy && !success ? onClick : undefined,
        onFocus: function onFocus(event) {
            setFocus(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        onMouseOver: onMouseOverButton,
        onMouseOut: onMouseOutButton,
        pad: pad || !plain,
        plain: typeof plain !== 'undefined' ? plain : (buttonOptions == null ? void 0 : buttonOptions.childrenPlain) !== false && (0, $2xPiy.Children).count(children) > 0 || icon && !label,
        primary: primary,
        sizeProp: size,
        success: success,
        type: !href ? type : undefined
    }, passThemeFlag), contents);
    if (tip) {
        if (typeof tip === 'string') styledButtonResult = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $ceab9ef72b825454$export$c92c6401b52a9298), {
            content: tip
        }, styledButtonResult);
        else styledButtonResult = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $ceab9ef72b825454$export$c92c6401b52a9298), tip, styledButtonResult);
    }
    // if button has background or border, place badge relative
    // to outer edge of button
    if (badgeProp && !innerBadge) styledButtonResult = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $d7e482005a2fe598$export$37acb3580601e69a), {
        content: badgeProp
    }, styledButtonResult);
    return styledButtonResult;
});
$102e2aa1ff54ae51$export$353f5b6fc5456de1.displayName = 'Button';
$102e2aa1ff54ae51$export$353f5b6fc5456de1.propTypes = (0, $5dfd77e0cc14bfcb$export$932f054f6b4bba8d);



const $85ab7488c493b81c$export$6d88ebe453be59d7 = (props)=>{
    const { label: label, targetUrl: targetUrl, onClick: onClick, color: color, icon: icon, disabled: disabled, reverse: reverse, tip: tip, toUpperCase: toUpperCase = true, ...boxProps } = props;
    const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const [isHover, setIsHover] = (0, $2xPiy.useState)(false);
    const isMobile = (0, $2xPiy.useMemo)(()=>screenSize === 'small' || screenSize === 'xsmall', [
        screenSize
    ]);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
        plain: true,
        disabled: disabled,
        tip: tip,
        onClick: ()=>onClick ? onClick() : navigate(targetUrl ?? ''),
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            height: isMobile ? undefined : 'xxlarge',
            alignSelf: "center",
            onMouseOver: ()=>setIsHover(true),
            onMouseOut: ()=>setIsHover(false),
            style: {
                boxShadow: isHover ? 'rgba(0, 0, 0, 0.2) 0 10px 10px -10px' : ''
            },
            transitionProperty: "background, color, box-shadow, padding-bottom",
            transitionDuration: "0.15s, 0.15s, 0.15s, 0.15s",
            transitionTimingFunction: "ease, ease, ease, ease",
            background: "white",
            direction: "row",
            pad: {
                horizontal: '0.75rem',
                vertical: isMobile ? '0.5rem' : undefined,
                bottom: isHover ? '1px' : undefined
            },
            gap: "xsmall",
            border: {
                color: 'light-5',
                size: '0.8px'
            },
            borderRadius: "6px",
            ...boxProps,
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                direction: "row",
                gap: "xsmall",
                align: "center",
                children: [
                    icon && !reverse && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        justify: "center",
                        children: icon
                    }),
                    label && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        textAlign: "center",
                        alignSelf: "center",
                        size: isMobile ? 'small' : 'medium',
                        lineHeight: isMobile ? '1rem' : undefined,
                        color: color,
                        toUpperCase: toUpperCase,
                        children: label
                    }),
                    icon && reverse && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        justify: "center",
                        children: icon
                    })
                ]
            })
        })
    });
};




var $2xPiy = parcelRequire("2xPiy");



const $ad3dfa44adb42595$export$353f5b6fc5456de1 = (props)=>{
    const { label: label, targetUrl: targetUrl, onClick: onClick, color: color, icon: icon, disabled: disabled, reverse: reverse, tip: tip, toUpperCase: toUpperCase = true, 'aria-expanded': ariaExpanded, ...boxProps } = props;
    const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const [isHover, setIsHover] = (0, $2xPiy.useState)(false);
    const isMobile = (0, $2xPiy.useMemo)(()=>screenSize === 'small' || screenSize === 'xsmall', [
        screenSize
    ]);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        height: isMobile ? undefined : 'xxlarge',
        alignSelf: "center",
        onMouseOver: ()=>setIsHover(true),
        onMouseOut: ()=>setIsHover(false),
        style: {
            boxShadow: isHover ? 'rgba(0, 0, 0, 0.2) 0 10px 10px -10px' : ''
        },
        transitionProperty: "background, color, box-shadow, padding-bottom",
        transitionDuration: "0.15s, 0.15s, 0.15s, 0.15s",
        transitionTimingFunction: "ease, ease, ease, ease",
        background: "white",
        direction: "row",
        pad: {
            horizontal: '0.75rem',
            vertical: isMobile ? '0.5rem' : undefined,
            bottom: isHover ? '1px' : undefined
        },
        gap: "xsmall",
        border: {
            color: 'light-5',
            size: '0.8px'
        },
        borderRadius: "6px",
        ...boxProps,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
            plain: true,
            disabled: disabled,
            tip: tip,
            fill: true,
            "aria-expanded": ariaExpanded,
            onClick: ()=>onClick ? onClick() : navigate(targetUrl ?? ''),
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                direction: "row",
                gap: "xsmall",
                justify: "center",
                children: [
                    icon && !reverse && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        justify: "center",
                        children: icon
                    }),
                    label && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        textAlign: "center",
                        alignSelf: "center",
                        size: isMobile ? 'small' : 'medium',
                        lineHeight: isMobile ? '1rem' : undefined,
                        color: color,
                        toUpperCase: toUpperCase,
                        children: label
                    }),
                    icon && reverse && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        justify: "center",
                        children: icon
                    })
                ]
            })
        })
    });
};




var $2xPiy = parcelRequire("2xPiy");


const $7ac54c23a62de8c7$export$4ecda0163efe6d1d = (props)=>{
    const { onClick: onClick, label: label, loadingLabel: loadingLabel, isLoading: isLoading, disabled: disabled, type: type, background: background = 'accent-1', hoverBackground: hoverBackground = 'button-hover', color: color = 'white', hoverColor: hoverColor = 'white', boxProps: boxProps } = props;
    const [isSelected, setIsSelected] = (0, $2xPiy.useState)(false);
    const [isHover, setIsHover] = (0, $2xPiy.useState)(false);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
        type: type,
        onClick: ()=>onClick(),
        onMouseOver: ()=>setIsHover(true),
        onMouseOut: ()=>setIsHover(false),
        onFocus: ()=>setIsSelected(true),
        onBlur: ()=>setIsSelected(false),
        disabled: disabled,
        fill: "horizontal",
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            pad: "0.75rem",
            background: isLoading ? 'light-2' : isSelected || isHover ? hoverBackground : background,
            borderRadius: "6px",
            style: {
                boxShadow: isSelected || isHover ? 'rgba(0, 0, 0, 0.2) 0 10px 10px -10px' : ''
            },
            transitionProperty: "background, box-shadow",
            transitionDuration: "0.15s, 0.15s",
            transitionTimingFunction: "ease, ease",
            ...boxProps,
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                alignSelf: "center",
                size: "medium",
                weight: 500,
                color: isSelected || isHover ? hoverColor : color,
                children: !isLoading ? label || 'SUBMIT' : loadingLabel || 'SUBMITTING...'
            })
        })
    });
};






var $2xPiy = parcelRequire("2xPiy");



var $2xPiy = parcelRequire("2xPiy");


function $fdccc762800a972d$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $fdccc762800a972d$var$_extends() {
    return $fdccc762800a972d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fdccc762800a972d$var$_extends.apply(null, arguments);
}
var $fdccc762800a972d$export$851de33184ecdac4 = function CardBody(_ref) {
    var rest = $fdccc762800a972d$var$_extends({}, ($fdccc762800a972d$var$_objectDestructuringEmpty(_ref), _ref));
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), $fdccc762800a972d$var$_extends({
        flex: true
    }, theme.card.body, rest));
};



var $2xPiy = parcelRequire("2xPiy");

var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");

var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");
function $c043e17d1ada851a$var$_extends() {
    return $c043e17d1ada851a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c043e17d1ada851a$var$_extends.apply(null, arguments);
}
function $c043e17d1ada851a$export$a6cdc56e425d0d0a(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}
function $c043e17d1ada851a$export$6969335ea1e4e77c(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    // making sure to not change target (immutable)
    var output = $c043e17d1ada851a$var$_extends({}, target);
    sources.forEach(function(source) {
        if ($c043e17d1ada851a$export$a6cdc56e425d0d0a(source)) Object.keys(source).forEach(function(key) {
            if ($c043e17d1ada851a$export$a6cdc56e425d0d0a(source[key])) {
                if (!output[key]) output[key] = $c043e17d1ada851a$var$_extends({}, source[key]);
                else output[key] = $c043e17d1ada851a$export$6969335ea1e4e77c(output[key], source[key]);
            } else output[key] = source[key];
        });
    });
    return output;
}
var $c043e17d1ada851a$export$333c2219d71d27ce = function parseMetricToNum(string) {
    if (string === void 0) string = '';
    return parseFloat(string.match(/\d+(\.\d+)?/), 10);
};
function $c043e17d1ada851a$export$56a2e46cd4a7c217(props) {
    var _theme$icon;
    var theme = (0, $2xPiy.useContext)((0, $iA1nz.ThemeContext));
    var size = props.size;
    var result = {};
    if (theme != null && (_theme$icon = theme.icon) != null && _theme$icon.disableScaleDown) {
        var dimension = $c043e17d1ada851a$export$333c2219d71d27ce(theme.icon.size[size] || size);
        if (dimension < 24) result.vectorEffect = 'non-scaling-stroke';
    }
    return result;
}
var $c043e17d1ada851a$var$calculatePad = function calculatePad(value, iconDimension) {
    return (value - iconDimension) / 2 + "px";
};
function $c043e17d1ada851a$export$bce3b4bc0d2e7a0e(props) {
    var _theme$icon2, _theme$text, _theme$text2;
    var height = props.height, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, width = props.width;
    var theme = (0, $2xPiy.useContext)((0, $iA1nz.ThemeContext));
    var iconDimension = $c043e17d1ada851a$export$333c2219d71d27ce((theme == null || (_theme$icon2 = theme.icon) == null || (_theme$icon2 = _theme$icon2.size) == null ? void 0 : _theme$icon2[size]) || size);
    var style = '';
    // browser default is 16px, but accommodate if app has modified
    // include fallback in case window is undefined
    var FALLBACK = '16px';
    var rootFontSize = $c043e17d1ada851a$export$333c2219d71d27ce(FALLBACK);
    if (typeof window !== 'undefined') {
        var _window;
        rootFontSize = $c043e17d1ada851a$export$333c2219d71d27ce(((_window = window) == null ? void 0 : _window.getComputedStyle(document.body).getPropertyValue('font-size')) || FALLBACK);
    }
    if (height && theme != null && (_theme$text = theme.text) != null && (_theme$text = _theme$text[height]) != null && _theme$text.height) {
        // the unit on theme text
        var _theme$text$height$he = theme.text[height].height.match(/(px|rem)/), unit = _theme$text$height$he[0];
        var lineHeight = $c043e17d1ada851a$export$333c2219d71d27ce(theme.text[height].height);
        if (unit === 'rem') lineHeight *= rootFontSize;
        if (lineHeight > iconDimension) {
            var pad = $c043e17d1ada851a$var$calculatePad(lineHeight, iconDimension);
            style += "padding-top: " + pad + "; padding-bottom: " + pad + ";";
        }
    }
    if (width && theme != null && (_theme$text2 = theme.text) != null && (_theme$text2 = _theme$text2[width]) != null && _theme$text2.height) {
        // the unit on theme text
        var _theme$text$width$hei = theme.text[width].height.match(/(px|rem)/), _unit = _theme$text$width$hei[0];
        var desiredWidth = $c043e17d1ada851a$export$333c2219d71d27ce(theme.text[width].height);
        if (_unit === 'rem') desiredWidth *= rootFontSize;
        if (desiredWidth > iconDimension) {
            var _pad = $c043e17d1ada851a$var$calculatePad(desiredWidth, iconDimension);
            style += "padding-left: " + _pad + "; padding-right: " + _pad + ";";
        }
    }
    return style;
}
var $c043e17d1ada851a$export$3794798abb123ff6 = function generatePrefix(name) {
    return "_grommeticons-" + name + "-" + (Date.now() + Math.random());
};
var $c043e17d1ada851a$export$2e2bcd8739ae039 = {
    deepMerge: $c043e17d1ada851a$export$6969335ea1e4e77c,
    isObject: $c043e17d1ada851a$export$a6cdc56e425d0d0a,
    parseMetricToNum: $c043e17d1ada851a$export$333c2219d71d27ce,
    iconPad: $c043e17d1ada851a$export$bce3b4bc0d2e7a0e,
    useScaleProps: $c043e17d1ada851a$export$56a2e46cd4a7c217
};


var $ac3762a2c00a976b$export$e2253033e6e1df16 = {
    global: {
        colors: {
            icon: '#666666'
        }
    },
    icon: {
        size: {
            small: '12px',
            medium: '24px',
            large: '48px',
            xlarge: '96px'
        }
    }
};


var $5061addb2fab23e7$export$9c21a3269931e1e6 = {
    theme: (0, $ac3762a2c00a976b$export$e2253033e6e1df16)
};
var $5061addb2fab23e7$export$582fa4e2a9b13dde = function extendDefaultTheme(theme) {
    $5061addb2fab23e7$export$9c21a3269931e1e6.theme = (0, $c043e17d1ada851a$export$6969335ea1e4e77c)((0, $ac3762a2c00a976b$export$e2253033e6e1df16), theme);
};



var $896826bebe64fe04$var$_excluded = [
    "a11yTitle",
    "color",
    "size",
    "theme"
];
function $896826bebe64fe04$var$_extends() {
    return $896826bebe64fe04$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $896826bebe64fe04$var$_extends.apply(null, arguments);
}
function $896826bebe64fe04$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Returns the specific color that should be used according to the theme.
// If 'dark' is supplied, it takes precedence over 'theme.dark'.
// Can return undefined.
var $896826bebe64fe04$var$normalizeColor = function normalizeColor(color, theme, dark) {
    var colorSpec = theme.global && theme.global.colors[color] !== undefined ? theme.global.colors[color] : color;
    // If the color has a light or dark object, use that
    var result = colorSpec;
    if (colorSpec) {
        if ((dark === true || dark === undefined && theme.dark) && colorSpec.dark !== undefined) result = colorSpec.dark;
        else if ((dark === false || !theme.dark) && colorSpec.light !== undefined) result = colorSpec.light;
    }
    // allow one level of indirection in color names
    if (result && theme.global && theme.global.colors[result] !== undefined) result = normalizeColor(result, theme, dark);
    return result;
};
var $896826bebe64fe04$var$colorStyle = function colorStyle(name, value, theme, required) {
    return (0, $iA1nz.css)([
        "",
        ":",
        ";"
    ], name, $896826bebe64fe04$var$normalizeColor(value, theme, required));
};
var $896826bebe64fe04$var$colorCss = (0, $iA1nz.css)([
    "",
    " ",
    " g{fill:inherit;stroke:inherit;}*:not([stroke]){&[fill='none']{stroke-width:0;}}*[stroke*='#'],*[STROKE*='#']{stroke:inherit;fill:none;}*[fill-rule],*[FILL-RULE],*[fill*='#'],*[FILL*='#']{fill:inherit;stroke:none;}"
], function(props) {
    return $896826bebe64fe04$var$colorStyle('fill', props.color || props.theme.global.colors.icon, props.theme);
}, function(props) {
    return $896826bebe64fe04$var$colorStyle('stroke', props.color || props.theme.global.colors.icon, props.theme);
});
var $896826bebe64fe04$var$IconInner = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, color = _ref.color, size = _ref.size, theme = _ref.theme, rest = $896826bebe64fe04$var$_objectWithoutPropertiesLoose(_ref, $896826bebe64fe04$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("svg", $896826bebe64fe04$var$_extends({
        ref: ref,
        "aria-label": a11yTitle
    }, rest));
});
$896826bebe64fe04$var$IconInner.displayName = 'Icon';
var $896826bebe64fe04$export$7c8f159da0dc916 = (0, $iA1nz.default)($896826bebe64fe04$var$IconInner).withConfig({
    // don't let height attribute leak to DOM
    // https://styled-components.com/docs/api#shouldforwardprop
    shouldForwardProp: function shouldForwardProp(prop) {
        return ![
            'height',
            'width'
        ].includes(prop);
    }
}).withConfig({
    displayName: "StyledIcon",
    componentId: "sc-ofa7kd-0"
})([
    "display:inline-block;flex:0 0 auto;",
    " ",
    " ",
    " ",
    ""
], function(_ref2) {
    var _size$match;
    var _ref2$size = _ref2.size, sizeProp = _ref2$size === void 0 ? 'medium' : _ref2$size, theme = _ref2.theme, viewBox = _ref2.viewBox;
    var _split = (viewBox || '0 0 24 24').split(' '), w = _split[2], h = _split[3];
    var scale = w / h;
    var size = theme.icon.size[sizeProp] || sizeProp;
    var dimension = (0, $c043e17d1ada851a$export$333c2219d71d27ce)(size);
    // grab rem, em, px value from resolved size value
    var unit = ((_size$match = size.match(/[a-z]+$/)) == null ? void 0 : _size$match[0]) || 'px';
    if (w < h) return "\n      width: " + dimension + unit + ";\n      height: " + dimension / scale + unit + ";\n    ";
    if (h < w) return "\n      width: " + dimension * scale + unit + ";\n      height: " + dimension + unit + ";\n    ";
    return "\n      width: " + dimension + unit + ";\n      height: " + dimension + unit + ";\n    ";
}, function(_ref3) {
    var color = _ref3.color;
    return color !== 'plain' && $896826bebe64fe04$var$colorCss;
}, function(props) {
    return (props.height || props.width) && (0, $c043e17d1ada851a$export$bce3b4bc0d2e7a0e)(props);
}, function(_ref4) {
    var theme = _ref4.theme;
    return theme && theme.icon.extend;
});
$896826bebe64fe04$export$7c8f159da0dc916.defaultProps = {};
Object.setPrototypeOf($896826bebe64fe04$export$7c8f159da0dc916.defaultProps, (0, $5061addb2fab23e7$export$9c21a3269931e1e6));


function $7dacb42a28be9c15$var$_extends() {
    return $7dacb42a28be9c15$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7dacb42a28be9c15$var$_extends.apply(null, arguments);
}
var $7dacb42a28be9c15$export$7036cd8426a1245b = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $7dacb42a28be9c15$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CircleInformation"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-12v8m0-12v2"
    }));
});
$7dacb42a28be9c15$export$7036cd8426a1245b.displayName = 'CircleInformation';






var $2xPiy = parcelRequire("2xPiy");

var $herDu = parcelRequire("herDu");

var $herDu = parcelRequire("herDu");
class $0402375deeb915a2$export$f2e832acab1bdd79 extends Error {
    url;
    status;
    statusText;
    body;
    request;
    constructor(request, response, message){
        super(message);
        this.name = 'ApiError';
        this.url = response.url;
        this.status = response.status;
        this.statusText = response.statusText;
        this.body = response.body;
        this.request = request;
    }
}






/* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ class $0b9c4bcf60738d6a$export$d7f5e52d091a66db extends Error {
    constructor(message){
        super(message);
        this.name = 'CancelError';
    }
    get isCancelled() {
        return true;
    }
}
class $0b9c4bcf60738d6a$export$551a058e9626aa5a {
    #isResolved;
    #isRejected;
    #isCancelled;
    #cancelHandlers;
    #promise;
    #resolve;
    #reject;
    constructor(executor){
        this.#isResolved = false;
        this.#isRejected = false;
        this.#isCancelled = false;
        this.#cancelHandlers = [];
        this.#promise = new Promise((resolve, reject)=>{
            this.#resolve = resolve;
            this.#reject = reject;
            const onResolve = (value)=>{
                if (this.#isResolved || this.#isRejected || this.#isCancelled) return;
                this.#isResolved = true;
                this.#resolve?.(value);
            };
            const onReject = (reason)=>{
                if (this.#isResolved || this.#isRejected || this.#isCancelled) return;
                this.#isRejected = true;
                this.#reject?.(reason);
            };
            const onCancel = (cancelHandler)=>{
                if (this.#isResolved || this.#isRejected || this.#isCancelled) return;
                this.#cancelHandlers.push(cancelHandler);
            };
            Object.defineProperty(onCancel, 'isResolved', {
                get: ()=>this.#isResolved
            });
            Object.defineProperty(onCancel, 'isRejected', {
                get: ()=>this.#isRejected
            });
            Object.defineProperty(onCancel, 'isCancelled', {
                get: ()=>this.#isCancelled
            });
            return executor(onResolve, onReject, onCancel);
        });
    }
    get [Symbol.toStringTag]() {
        return 'Cancellable Promise';
    }
    then(onFulfilled, onRejected) {
        return this.#promise.then(onFulfilled, onRejected);
    }
    catch(onRejected) {
        return this.#promise.catch(onRejected);
    }
    finally(onFinally) {
        return this.#promise.finally(onFinally);
    }
    cancel() {
        if (this.#isResolved || this.#isRejected || this.#isCancelled) return;
        this.#isCancelled = true;
        if (this.#cancelHandlers.length) try {
            for (const cancelHandler of this.#cancelHandlers)cancelHandler();
        } catch (error) {
            console.warn('Cancellation threw an error', error);
            return;
        }
        this.#cancelHandlers.length = 0;
        this.#reject?.(new $0b9c4bcf60738d6a$export$d7f5e52d091a66db('Request aborted'));
    }
    get isCancelled() {
        return this.#isCancelled;
    }
}


var $92efedf222e01e8e$exports = {};
$92efedf222e01e8e$exports = JSON.parse("{\"name\":\"fuse-frontend\",\"version\":\"2.38.0\",\"private\":true,\"description\":\"Frontend for the FuSE 2.0 app\",\"scripts\":{\"build\":\"yarn lint && parcel build public/index.html\",\"build:test\":\"parcel build public/index.html\",\"serve:test\":\"yarn build:test && serve -s dist -l 1234\",\"dev\":\"DEBUG=fuse* parcel public/index.html\",\"start\":\"parcel public/index.html\",\"start:dev\":\"env-cmd -f .env.development.local yarn start\",\"start:local\":\"env-cmd -f .env.local yarn start\",\"clean\":\"rm -rf .parcel-cache\",\"test\":\"playwright test\",\"lint\":\"eslint src --ext .ts,.tsx --max-warnings 0\",\"lint:fix\":\"eslint src --ext .ts,.tsx --fix\",\"typecheck\":\"tsc --noEmit\",\"format\":\"prettier --write \\\"src/**/*.{ts,tsx,js,jsx,json,md}\\\"\",\"check-format\":\"prettier --check \\\"src/**/*.{ts,tsx,js,jsx,json,md}\\\"\",\"validate\":\"yarn lint && yarn check-format && yarn test\"},\"engines\":{\"node\":\"24.22.1\"},\"browserslist\":\"> 0.5%, last 2 versions, not dead\",\"dependencies\":{\"@sentry/react\":\"^8.26.0\",\"@tanstack/react-query\":\"^5.96.2\",\"apexcharts\":\"^3.44.1\",\"dayjs\":\"^1.11.10\",\"debug\":\"^4.3.4\",\"driver.js\":\"^1.4.0\",\"env-cmd\":\"10\",\"grommet\":\"^2.32.0\",\"grommet-icons\":\"^4.11.0\",\"html2canvas\":\"^1.4.1\",\"i18next\":\"^23.10.0\",\"i18next-browser-languagedetector\":\"^7.2.0\",\"jsonwebtoken\":\"^9.0.0\",\"jspdf\":\"^3.0.0\",\"leaflet\":\"^1.9.4\",\"mobx\":\"^6.9.0\",\"mobx-react-lite\":\"^4.1.0\",\"react\":\"^19.0.0\",\"react-apexcharts\":\"^1.4.1\",\"react-dom\":\"^19.0.0\",\"react-error-boundary\":\"^4.0.4\",\"react-i18next\":\"^14.0.5\",\"react-leaflet\":\"^5.0.0\",\"react-router-dom\":\"^6.11.2\",\"react-toastify\":\"^11\",\"styled-components\":\"5.3.10\"},\"devDependencies\":{\"@parcel/css\":\"^1.14.0\",\"@parcel/transformer-svg-react\":\"^2.10.2\",\"@playwright/test\":\"^1.45.3\",\"@trivago/prettier-plugin-sort-imports\":\"^4.3.0\",\"@types/debug\":\"^4.1.12\",\"@types/google.maps\":\"^3.58.1\",\"@types/jsonwebtoken\":\"^9.0.2\",\"@types/leaflet\":\"^1.9.8\",\"@types/node\":\"24.4.0\",\"@types/react\":\"^19.0.0\",\"@types/react-dom\":\"^19.0.0\",\"@typescript-eslint/eslint-plugin\":\"^5.59.6\",\"@typescript-eslint/parser\":\"^5.59.6\",\"buffer\":\"^5.5.0\",\"crypto-browserify\":\"^3.12.0\",\"eslint\":\"^8.49.0\",\"eslint-config-prettier\":\"^10.0.1\",\"eslint-plugin-jsx-a11y\":\"^6.7.1\",\"eslint-plugin-prettier\":\"^5.5.4\",\"eslint-plugin-react\":\"^7.32.2\",\"eslint-plugin-react-hooks\":\"^4.6.0\",\"events\":\"^3.1.0\",\"parcel\":\"^2.10.2\",\"prettier\":\"^3.0.3\",\"process\":\"^0.11.10\",\"react-is\":\"^19.0.0\",\"serve\":\"^14.2.0\",\"stream-browserify\":\"^3.0.0\",\"svgo\":\"^3\",\"typescript\":\"5.0.4\",\"url\":\"^0.11.0\",\"util\":\"^0.12.3\",\"xlsx\":\"^0.18.5\"},\"resolutions\":{\"csstype\":\"^3.2.3\"}}");



const $cb036f6eccd47057$export$3bbbb17165d6e0ef = {
    BASE: `/${(0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).api.version}`,
    VERSION: (0, (/*@__PURE__*/$parcel$interopDefault($92efedf222e01e8e$exports))).version,
    USE_CREDENTIALS: (0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).api.useCredentials,
    CREDENTIALS: (0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).api.credentialsType,
    TOKEN: undefined,
    USERNAME: undefined,
    PASSWORD: undefined,
    HEADERS: undefined,
    ENCODE_PATH: undefined
};




let $c5482855026ef46a$var$unauthorizedHandler;
let $c5482855026ef46a$var$activityHandler;
const $c5482855026ef46a$export$df74a7f975458b43 = (handler)=>{
    $c5482855026ef46a$var$unauthorizedHandler = handler;
};
const $c5482855026ef46a$export$28821114e1994a07 = (handler)=>{
    $c5482855026ef46a$var$activityHandler = handler;
};
const $c5482855026ef46a$var$isSessionUnauthorized = (body)=>{
    if (!body || typeof body !== 'object') return false;
    const { errors: errors, message: message } = body;
    if (message === 'Inactive user') return true;
    return !!errors?.some((e)=>typeof e.message === 'string' && e.message.startsWith('E_UNAUTHORIZED_ACCESS'));
};
const $c5482855026ef46a$export$775816c0de911c24 = (body)=>{
    if (!$c5482855026ef46a$var$isSessionUnauthorized(body)) return;
    $c5482855026ef46a$var$unauthorizedHandler?.();
};
const $c5482855026ef46a$export$2a6f26e250ceed55 = ()=>{
    try {
        $c5482855026ef46a$var$activityHandler?.();
    } catch (err) {
        console.error(err);
    }
};



/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d00bde13af3333af$export$a143d493d941bafc;
var $d00bde13af3333af$export$e4cf37d7f6fb9e0a;
var $d00bde13af3333af$export$f99ded8fe4b79145;
var $d00bde13af3333af$export$599f31c3813fae4d;
'use strict';
var $e00b90ee5833b14b$export$a48f0734ac7c2329;
var $e00b90ee5833b14b$export$d622b2ad8d90c771;
var $e00b90ee5833b14b$export$6100ba28696e12de;
'use strict';
$e00b90ee5833b14b$export$a48f0734ac7c2329 = $e00b90ee5833b14b$var$byteLength;
$e00b90ee5833b14b$export$d622b2ad8d90c771 = $e00b90ee5833b14b$var$toByteArray;
$e00b90ee5833b14b$export$6100ba28696e12de = $e00b90ee5833b14b$var$fromByteArray;
var $e00b90ee5833b14b$var$lookup = [];
var $e00b90ee5833b14b$var$revLookup = [];
var $e00b90ee5833b14b$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $e00b90ee5833b14b$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $e00b90ee5833b14b$var$i = 0, $e00b90ee5833b14b$var$len = $e00b90ee5833b14b$var$code.length; $e00b90ee5833b14b$var$i < $e00b90ee5833b14b$var$len; ++$e00b90ee5833b14b$var$i){
    $e00b90ee5833b14b$var$lookup[$e00b90ee5833b14b$var$i] = $e00b90ee5833b14b$var$code[$e00b90ee5833b14b$var$i];
    $e00b90ee5833b14b$var$revLookup[$e00b90ee5833b14b$var$code.charCodeAt($e00b90ee5833b14b$var$i)] = $e00b90ee5833b14b$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$e00b90ee5833b14b$var$revLookup['-'.charCodeAt(0)] = 62;
$e00b90ee5833b14b$var$revLookup['_'.charCodeAt(0)] = 63;
function $e00b90ee5833b14b$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $e00b90ee5833b14b$var$byteLength(b64) {
    var lens = $e00b90ee5833b14b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e00b90ee5833b14b$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e00b90ee5833b14b$var$toByteArray(b64) {
    var tmp;
    var lens = $e00b90ee5833b14b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $e00b90ee5833b14b$var$Arr($e00b90ee5833b14b$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $e00b90ee5833b14b$var$revLookup[b64.charCodeAt(i)] << 18 | $e00b90ee5833b14b$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $e00b90ee5833b14b$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $e00b90ee5833b14b$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $e00b90ee5833b14b$var$revLookup[b64.charCodeAt(i)] << 2 | $e00b90ee5833b14b$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $e00b90ee5833b14b$var$revLookup[b64.charCodeAt(i)] << 10 | $e00b90ee5833b14b$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $e00b90ee5833b14b$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $e00b90ee5833b14b$var$tripletToBase64(num) {
    return $e00b90ee5833b14b$var$lookup[num >> 18 & 0x3F] + $e00b90ee5833b14b$var$lookup[num >> 12 & 0x3F] + $e00b90ee5833b14b$var$lookup[num >> 6 & 0x3F] + $e00b90ee5833b14b$var$lookup[num & 0x3F];
}
function $e00b90ee5833b14b$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($e00b90ee5833b14b$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $e00b90ee5833b14b$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($e00b90ee5833b14b$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($e00b90ee5833b14b$var$lookup[tmp >> 2] + $e00b90ee5833b14b$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($e00b90ee5833b14b$var$lookup[tmp >> 10] + $e00b90ee5833b14b$var$lookup[tmp >> 4 & 0x3F] + $e00b90ee5833b14b$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $11854c5662d1aed1$export$aafa59e2e03f2942;
var $11854c5662d1aed1$export$68d8715fc104d294;
$11854c5662d1aed1$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$11854c5662d1aed1$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $d00bde13af3333af$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$d00bde13af3333af$export$a143d493d941bafc = $d00bde13af3333af$var$Buffer;
$d00bde13af3333af$export$e4cf37d7f6fb9e0a = $d00bde13af3333af$var$SlowBuffer;
$d00bde13af3333af$export$f99ded8fe4b79145 = 50;
var $d00bde13af3333af$var$K_MAX_LENGTH = 0x7fffffff;
$d00bde13af3333af$export$599f31c3813fae4d = $d00bde13af3333af$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d00bde13af3333af$var$Buffer.TYPED_ARRAY_SUPPORT = $d00bde13af3333af$var$typedArraySupport();
if (!$d00bde13af3333af$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d00bde13af3333af$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d00bde13af3333af$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$d00bde13af3333af$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d00bde13af3333af$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$d00bde13af3333af$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d00bde13af3333af$var$createBuffer(length) {
    if (length > $d00bde13af3333af$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d00bde13af3333af$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d00bde13af3333af$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d00bde13af3333af$var$allocUnsafe(arg);
    }
    return $d00bde13af3333af$var$from(arg, encodingOrOffset, length);
}
$d00bde13af3333af$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d00bde13af3333af$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $d00bde13af3333af$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d00bde13af3333af$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d00bde13af3333af$var$isInstance(value, ArrayBuffer) || value && $d00bde13af3333af$var$isInstance(value.buffer, ArrayBuffer)) return $d00bde13af3333af$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($d00bde13af3333af$var$isInstance(value, SharedArrayBuffer) || value && $d00bde13af3333af$var$isInstance(value.buffer, SharedArrayBuffer))) return $d00bde13af3333af$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d00bde13af3333af$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $d00bde13af3333af$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $d00bde13af3333af$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d00bde13af3333af$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d00bde13af3333af$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d00bde13af3333af$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d00bde13af3333af$var$Buffer, Uint8Array);
function $d00bde13af3333af$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d00bde13af3333af$var$alloc(size, fill, encoding) {
    $d00bde13af3333af$var$assertSize(size);
    if (size <= 0) return $d00bde13af3333af$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $d00bde13af3333af$var$createBuffer(size).fill(fill, encoding) : $d00bde13af3333af$var$createBuffer(size).fill(fill);
    return $d00bde13af3333af$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d00bde13af3333af$var$Buffer.alloc = function(size, fill, encoding) {
    return $d00bde13af3333af$var$alloc(size, fill, encoding);
};
function $d00bde13af3333af$var$allocUnsafe(size) {
    $d00bde13af3333af$var$assertSize(size);
    return $d00bde13af3333af$var$createBuffer(size < 0 ? 0 : $d00bde13af3333af$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d00bde13af3333af$var$Buffer.allocUnsafe = function(size) {
    return $d00bde13af3333af$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d00bde13af3333af$var$Buffer.allocUnsafeSlow = function(size) {
    return $d00bde13af3333af$var$allocUnsafe(size);
};
function $d00bde13af3333af$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$d00bde13af3333af$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $d00bde13af3333af$var$byteLength(string, encoding) | 0;
    var buf = $d00bde13af3333af$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d00bde13af3333af$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $d00bde13af3333af$var$checked(array.length) | 0;
    var buf = $d00bde13af3333af$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d00bde13af3333af$var$fromArrayView(arrayView) {
    if ($d00bde13af3333af$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $d00bde13af3333af$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d00bde13af3333af$var$fromArrayLike(arrayView);
}
function $d00bde13af3333af$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d00bde13af3333af$var$Buffer.prototype);
    return buf;
}
function $d00bde13af3333af$var$fromObject(obj) {
    if ($d00bde13af3333af$var$Buffer.isBuffer(obj)) {
        var len = $d00bde13af3333af$var$checked(obj.length) | 0;
        var buf = $d00bde13af3333af$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $d00bde13af3333af$var$numberIsNaN(obj.length)) return $d00bde13af3333af$var$createBuffer(0);
        return $d00bde13af3333af$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $d00bde13af3333af$var$fromArrayLike(obj.data);
}
function $d00bde13af3333af$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d00bde13af3333af$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d00bde13af3333af$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $d00bde13af3333af$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d00bde13af3333af$var$Buffer.alloc(+length);
}
$d00bde13af3333af$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d00bde13af3333af$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d00bde13af3333af$var$Buffer.compare = function compare(a, b) {
    if ($d00bde13af3333af$var$isInstance(a, Uint8Array)) a = $d00bde13af3333af$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d00bde13af3333af$var$isInstance(b, Uint8Array)) b = $d00bde13af3333af$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d00bde13af3333af$var$Buffer.isBuffer(a) || !$d00bde13af3333af$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d00bde13af3333af$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$d00bde13af3333af$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d00bde13af3333af$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $d00bde13af3333af$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($d00bde13af3333af$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $d00bde13af3333af$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d00bde13af3333af$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d00bde13af3333af$var$byteLength(string, encoding) {
    if ($d00bde13af3333af$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d00bde13af3333af$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $d00bde13af3333af$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $d00bde13af3333af$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d00bde13af3333af$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d00bde13af3333af$var$Buffer.byteLength = $d00bde13af3333af$var$byteLength;
function $d00bde13af3333af$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $d00bde13af3333af$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $d00bde13af3333af$var$utf8Slice(this, start, end);
        case 'ascii':
            return $d00bde13af3333af$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $d00bde13af3333af$var$latin1Slice(this, start, end);
        case 'base64':
            return $d00bde13af3333af$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d00bde13af3333af$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d00bde13af3333af$var$Buffer.prototype._isBuffer = true;
function $d00bde13af3333af$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d00bde13af3333af$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$d00bde13af3333af$var$swap(this, i, i + 1);
    return this;
};
$d00bde13af3333af$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $d00bde13af3333af$var$swap(this, i, i + 3);
        $d00bde13af3333af$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d00bde13af3333af$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $d00bde13af3333af$var$swap(this, i, i + 7);
        $d00bde13af3333af$var$swap(this, i + 1, i + 6);
        $d00bde13af3333af$var$swap(this, i + 2, i + 5);
        $d00bde13af3333af$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d00bde13af3333af$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $d00bde13af3333af$var$utf8Slice(this, 0, length);
    return $d00bde13af3333af$var$slowToString.apply(this, arguments);
};
$d00bde13af3333af$var$Buffer.prototype.toLocaleString = $d00bde13af3333af$var$Buffer.prototype.toString;
$d00bde13af3333af$var$Buffer.prototype.equals = function equals(b) {
    if (!$d00bde13af3333af$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $d00bde13af3333af$var$Buffer.compare(this, b) === 0;
};
$d00bde13af3333af$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $d00bde13af3333af$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($d00bde13af3333af$var$customInspectSymbol) $d00bde13af3333af$var$Buffer.prototype[$d00bde13af3333af$var$customInspectSymbol] = $d00bde13af3333af$var$Buffer.prototype.inspect;
$d00bde13af3333af$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d00bde13af3333af$var$isInstance(target, Uint8Array)) target = $d00bde13af3333af$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d00bde13af3333af$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d00bde13af3333af$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d00bde13af3333af$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $d00bde13af3333af$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d00bde13af3333af$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d00bde13af3333af$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d00bde13af3333af$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $d00bde13af3333af$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d00bde13af3333af$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d00bde13af3333af$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d00bde13af3333af$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d00bde13af3333af$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d00bde13af3333af$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d00bde13af3333af$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d00bde13af3333af$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d00bde13af3333af$var$utf8Write(buf, string, offset, length) {
    return $d00bde13af3333af$var$blitBuffer($d00bde13af3333af$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d00bde13af3333af$var$asciiWrite(buf, string, offset, length) {
    return $d00bde13af3333af$var$blitBuffer($d00bde13af3333af$var$asciiToBytes(string), buf, offset, length);
}
function $d00bde13af3333af$var$base64Write(buf, string, offset, length) {
    return $d00bde13af3333af$var$blitBuffer($d00bde13af3333af$var$base64ToBytes(string), buf, offset, length);
}
function $d00bde13af3333af$var$ucs2Write(buf, string, offset, length) {
    return $d00bde13af3333af$var$blitBuffer($d00bde13af3333af$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d00bde13af3333af$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $d00bde13af3333af$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $d00bde13af3333af$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $d00bde13af3333af$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $d00bde13af3333af$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d00bde13af3333af$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d00bde13af3333af$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d00bde13af3333af$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $e00b90ee5833b14b$export$6100ba28696e12de(buf);
    else return $e00b90ee5833b14b$export$6100ba28696e12de(buf.slice(start, end));
}
function $d00bde13af3333af$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d00bde13af3333af$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $d00bde13af3333af$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d00bde13af3333af$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $d00bde13af3333af$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d00bde13af3333af$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d00bde13af3333af$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d00bde13af3333af$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d00bde13af3333af$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $d00bde13af3333af$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d00bde13af3333af$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d00bde13af3333af$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d00bde13af3333af$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d00bde13af3333af$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$d00bde13af3333af$var$Buffer.prototype.readUintLE = $d00bde13af3333af$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d00bde13af3333af$var$Buffer.prototype.readUintBE = $d00bde13af3333af$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d00bde13af3333af$var$Buffer.prototype.readUint8 = $d00bde13af3333af$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d00bde13af3333af$var$Buffer.prototype.readUint16LE = $d00bde13af3333af$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d00bde13af3333af$var$Buffer.prototype.readUint16BE = $d00bde13af3333af$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d00bde13af3333af$var$Buffer.prototype.readUint32LE = $d00bde13af3333af$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d00bde13af3333af$var$Buffer.prototype.readUint32BE = $d00bde13af3333af$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d00bde13af3333af$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d00bde13af3333af$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d00bde13af3333af$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d00bde13af3333af$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d00bde13af3333af$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d00bde13af3333af$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d00bde13af3333af$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d00bde13af3333af$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkOffset(offset, 4, this.length);
    return $11854c5662d1aed1$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$d00bde13af3333af$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkOffset(offset, 4, this.length);
    return $11854c5662d1aed1$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$d00bde13af3333af$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkOffset(offset, 8, this.length);
    return $11854c5662d1aed1$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$d00bde13af3333af$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkOffset(offset, 8, this.length);
    return $11854c5662d1aed1$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $d00bde13af3333af$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d00bde13af3333af$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$d00bde13af3333af$var$Buffer.prototype.writeUintLE = $d00bde13af3333af$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d00bde13af3333af$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d00bde13af3333af$var$Buffer.prototype.writeUintBE = $d00bde13af3333af$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d00bde13af3333af$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d00bde13af3333af$var$Buffer.prototype.writeUint8 = $d00bde13af3333af$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d00bde13af3333af$var$Buffer.prototype.writeUint16LE = $d00bde13af3333af$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d00bde13af3333af$var$Buffer.prototype.writeUint16BE = $d00bde13af3333af$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d00bde13af3333af$var$Buffer.prototype.writeUint32LE = $d00bde13af3333af$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d00bde13af3333af$var$Buffer.prototype.writeUint32BE = $d00bde13af3333af$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d00bde13af3333af$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d00bde13af3333af$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d00bde13af3333af$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d00bde13af3333af$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d00bde13af3333af$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d00bde13af3333af$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d00bde13af3333af$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d00bde13af3333af$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d00bde13af3333af$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d00bde13af3333af$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $d00bde13af3333af$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $11854c5662d1aed1$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d00bde13af3333af$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d00bde13af3333af$var$writeFloat(this, value, offset, true, noAssert);
};
$d00bde13af3333af$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d00bde13af3333af$var$writeFloat(this, value, offset, false, noAssert);
};
function $d00bde13af3333af$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d00bde13af3333af$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $11854c5662d1aed1$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d00bde13af3333af$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d00bde13af3333af$var$writeDouble(this, value, offset, true, noAssert);
};
$d00bde13af3333af$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d00bde13af3333af$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d00bde13af3333af$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d00bde13af3333af$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d00bde13af3333af$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$d00bde13af3333af$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $d00bde13af3333af$var$Buffer.isBuffer(val) ? val : $d00bde13af3333af$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $d00bde13af3333af$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d00bde13af3333af$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d00bde13af3333af$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $d00bde13af3333af$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $d00bde13af3333af$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d00bde13af3333af$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d00bde13af3333af$var$base64ToBytes(str) {
    return $e00b90ee5833b14b$export$d622b2ad8d90c771($d00bde13af3333af$var$base64clean(str));
}
function $d00bde13af3333af$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d00bde13af3333af$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d00bde13af3333af$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $d00bde13af3333af$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $fe63a2be2027e28c$require$Buffer = $d00bde13af3333af$export$a143d493d941bafc;
const $fe63a2be2027e28c$var$isDefined = (value)=>{
    return value !== undefined && value !== null;
};
const $fe63a2be2027e28c$var$isString = (value)=>{
    return typeof value === 'string';
};
const $fe63a2be2027e28c$var$isStringWithValue = (value)=>{
    return $fe63a2be2027e28c$var$isString(value) && value !== '';
};
const $fe63a2be2027e28c$var$isBlob = (value)=>{
    return typeof value === 'object' && value !== null && typeof value.type === 'string' && typeof value.stream === 'function' && typeof value.arrayBuffer === 'function' && typeof value.constructor === 'function' && typeof value.constructor.name === 'string' && /^(Blob|File)$/.test(value.constructor.name) && /^(Blob|File)$/.test(value[Symbol.toStringTag]);
};
const $fe63a2be2027e28c$var$isFormData = (value)=>{
    return value instanceof FormData;
};
const $fe63a2be2027e28c$var$base64 = (str)=>{
    try {
        return btoa(str);
    } catch (err) {
        return $fe63a2be2027e28c$require$Buffer.from(str).toString('base64');
    }
};
const $fe63a2be2027e28c$var$getQueryString = (params, useArrayBrackets = false)=>{
    const qs = [];
    const append = (key, value)=>{
        qs.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
    };
    const process = (key, value, useArrayBrackets = false)=>{
        if ($fe63a2be2027e28c$var$isDefined(value)) {
            if (Array.isArray(value)) value.forEach((v)=>{
                if (useArrayBrackets) process(key + '[]', v, useArrayBrackets);
                else // Keep backward compatibility with other possible requests
                process(key, v, useArrayBrackets);
            });
            else if (typeof value === 'object') Object.entries(value).forEach(([k, v])=>{
                process(`${key}[${k}]`, v, useArrayBrackets);
            });
            else append(key, value);
        }
    };
    Object.entries(params).forEach(([key, value])=>{
        process(key, value, useArrayBrackets);
    });
    if (qs.length > 0) return `?${qs.join('&')}`;
    return '';
};
const $fe63a2be2027e28c$export$1b98eaf73d37f034 = ()=>new URL((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).api.version, (0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).api.url).href;
const $fe63a2be2027e28c$var$getUrl = (config, options)=>{
    const encoder = config.ENCODE_PATH || encodeURI;
    const path = options.url.replace(/{(.*?)}/g, (substring, group)=>{
        if (options.path && Object.prototype.hasOwnProperty.call(options.path, group)) return encoder(String(options.path[group]));
        return substring;
    });
    const apiUrl = $fe63a2be2027e28c$export$1b98eaf73d37f034();
    const url = `${apiUrl}${path}`;
    if (options.query) {
        const queryString = $fe63a2be2027e28c$var$getQueryString(options.query, options.useArrayBrackets);
        return `${url}${queryString}`;
    }
    return url;
};
const $fe63a2be2027e28c$var$getFormData = (options)=>{
    if (options.formData) {
        const formData = new FormData();
        const process = (key, value)=>{
            if ($fe63a2be2027e28c$var$isString(value) || $fe63a2be2027e28c$var$isBlob(value)) formData.append(key, value);
            else formData.append(key, JSON.stringify(value));
        };
        Object.entries(options.formData).filter(([, value])=>$fe63a2be2027e28c$var$isDefined(value)).forEach(([key, value])=>{
            if (Array.isArray(value)) value.forEach((v)=>process(key, v));
            else process(key, value);
        });
        return formData;
    }
    return undefined;
};
const $fe63a2be2027e28c$var$resolve = async (options, resolver)=>{
    if (typeof resolver === 'function') return resolver(options);
    return resolver;
};
const $fe63a2be2027e28c$var$getHeaders = async (config, options)=>{
    const token = await $fe63a2be2027e28c$var$resolve(options, config.TOKEN);
    const username = await $fe63a2be2027e28c$var$resolve(options, config.USERNAME);
    const password = await $fe63a2be2027e28c$var$resolve(options, config.PASSWORD);
    const additionalHeaders = await $fe63a2be2027e28c$var$resolve(options, config.HEADERS);
    const headers = Object.entries({
        Accept: 'application/json',
        ...additionalHeaders,
        ...options.headers
    }).filter(([, value])=>$fe63a2be2027e28c$var$isDefined(value)).reduce((headers, [key, value])=>({
            ...headers,
            [key]: String(value)
        }), {});
    if ($fe63a2be2027e28c$var$isStringWithValue(token)) headers['Authorization'] = `Bearer ${token}`;
    if ($fe63a2be2027e28c$var$isStringWithValue(username) && $fe63a2be2027e28c$var$isStringWithValue(password)) {
        const credentials = $fe63a2be2027e28c$var$base64(`${username}:${password}`);
        headers['Authorization'] = `Basic ${credentials}`;
    }
    if (options.body) {
        if (options.mediaType) headers['Content-Type'] = options.mediaType;
        else if ($fe63a2be2027e28c$var$isBlob(options.body)) headers['Content-Type'] = options.body.type || 'application/octet-stream';
        else if ($fe63a2be2027e28c$var$isString(options.body)) headers['Content-Type'] = 'text/plain';
        else if (!$fe63a2be2027e28c$var$isFormData(options.body)) headers['Content-Type'] = 'application/json';
    }
    return new Headers(headers);
};
const $fe63a2be2027e28c$var$getRequestBody = (options)=>{
    if (options.body !== undefined) {
        if (options.mediaType?.includes('/json')) return JSON.stringify(options.body);
        else if ($fe63a2be2027e28c$var$isString(options.body) || $fe63a2be2027e28c$var$isBlob(options.body) || $fe63a2be2027e28c$var$isFormData(options.body)) return options.body;
        else return JSON.stringify(options.body);
    }
    return undefined;
};
const $fe63a2be2027e28c$export$d5a1e65f8aa21b51 = async (config, options, url, body, formData, headers, onCancel)=>{
    const controller = new AbortController();
    const request = {
        headers: headers,
        body: body ?? formData,
        method: options.method,
        signal: controller.signal
    };
    if (config.USE_CREDENTIALS) request.credentials = config.CREDENTIALS;
    onCancel(()=>controller.abort());
    return await fetch(url, request);
};
const $fe63a2be2027e28c$var$getResponseHeader = (response, responseHeader)=>{
    if (responseHeader) {
        const content = response.headers.get(responseHeader);
        if ($fe63a2be2027e28c$var$isString(content)) return content;
    }
    return undefined;
};
const $fe63a2be2027e28c$var$getResponseBody = async (response)=>{
    if (response.status !== 204) try {
        const contentType = response.headers.get('Content-Type');
        if (contentType) {
            const jsonTypes = [
                'application/json',
                'application/problem+json'
            ];
            const isJSON = jsonTypes.some((type)=>contentType.toLowerCase().startsWith(type));
            if (isJSON) return await response.json();
            else return await response.text();
        }
    } catch (err) {
        console.error(err);
    }
    return undefined;
};
const $fe63a2be2027e28c$var$catchErrorCodes = (options, result)=>{
    const errors = {
        400: 'Bad Request',
        401: 'Unauthorized',
        403: 'Forbidden',
        404: 'Not Found',
        422: 'Unprocessable Content',
        500: 'Internal Server Error',
        502: 'Bad Gateway',
        503: 'Service Unavailable',
        ...options.errors
    };
    const error = errors[result.status];
    if (error) {
        if (result.status === 401) (0, $c5482855026ef46a$export$775816c0de911c24)(result.body);
        throw new (0, $0402375deeb915a2$export$f2e832acab1bdd79)(options, result, error);
    }
    if (!result.ok) throw new (0, $0402375deeb915a2$export$f2e832acab1bdd79)(options, result, 'Generic Error');
};
const $fe63a2be2027e28c$export$b5fe3f66a567bec0 = (config, options)=>{
    return new (0, $0b9c4bcf60738d6a$export$551a058e9626aa5a)(async (resolve, reject, onCancel)=>{
        try {
            const url = $fe63a2be2027e28c$var$getUrl(config, options);
            const formData = $fe63a2be2027e28c$var$getFormData(options);
            const body = $fe63a2be2027e28c$var$getRequestBody(options);
            const headers = await $fe63a2be2027e28c$var$getHeaders(config, options);
            if (!onCancel.isCancelled) {
                const response = await $fe63a2be2027e28c$export$d5a1e65f8aa21b51(config, options, url, body, formData, headers, onCancel);
                const responseBody = await $fe63a2be2027e28c$var$getResponseBody(response);
                const responseHeader = $fe63a2be2027e28c$var$getResponseHeader(response, options.responseHeader);
                const result = {
                    url: url,
                    ok: response.ok,
                    status: response.status,
                    statusText: response.statusText,
                    body: responseHeader ?? responseBody
                };
                if (config.TOKEN && result.status !== 401) (0, $c5482855026ef46a$export$2a6f26e250ceed55)();
                $fe63a2be2027e28c$var$catchErrorCodes(options, result);
                resolve(result.body);
            }
        } catch (err) {
            console.error(err);
            reject(err);
        }
    });
};





class $36341b54d925eabe$export$92946eb4461f5ea1 {
    /**
   * Get Address
   * @param email string
   * @param password string
   * @returns Address Address
   * @throws ApiError
   */ static getAddress({ id: id }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/addresses/{id}',
            path: {
                id: id
            }
        });
    }
    /**
   * Create Address
   * @param address Address
   * @returns Address Address
   * @throws ApiError
   */ static createAddress({ client_id: client_id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/clients/{client_id}/addresses',
            path: {
                client_id: client_id
            },
            body: req
        });
    }
}



class $73e0bc33ecac5b93$export$69d4516a6fd8e701 {
    /**
   * Login
   * @param loginRequest TLoginRequest
   * @returns object JSONWebToken
   * @throws ApiError
   */ static login(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/login',
            body: req
        });
    }
    /**
   * Logout
   * @returns object TLogoutResponse
   * @throws ApiError
   */ static logout() {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/logout'
        });
    }
}




class $f54e9d7b4c02cd74$export$46ccbb23832f3e86 {
    /**
   * Run a bulk credit calculation. Validation errors return as JSON; on success the
   * response streams SSE events (line, then done/failed/cancelled) until completion.
   * Aborting the request cancels the calculation server-side.
   * @param req TCalculateCreditsRequest
   * @returns Response
   */ static calculate(req, signal) {
        const token = typeof (0, $cb036f6eccd47057$export$3bbbb17165d6e0ef).TOKEN === 'string' ? (0, $cb036f6eccd47057$export$3bbbb17165d6e0ef).TOKEN : undefined;
        return fetch(`${(0, $fe63a2be2027e28c$export$1b98eaf73d37f034)()}/calculateCredits`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json, text/event-stream',
                ...token !== undefined ? {
                    Authorization: `Bearer ${token}`
                } : {}
            },
            body: JSON.stringify(req),
            signal: signal,
            ...(0, $cb036f6eccd47057$export$3bbbb17165d6e0ef).USE_CREDENTIALS ? {
                credentials: (0, $cb036f6eccd47057$export$3bbbb17165d6e0ef).CREDENTIALS
            } : {}
        });
    }
}




class $3c4d1dd9732ea0da$export$e8b677291114e035 {
    /**
   * List ClientFiles
   * @returns ClientFile[]
   */ static listClientFiles(clientId, params) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: `/clients/${clientId}/clientFiles`,
            query: params
        });
    }
    /**
   * Get ClientFile
   * @returns ClientFile
   */ static getClientFile(id) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: `/clientFiles/${id}`
        });
    }
    /**
   * Get ClientFile URL
   * @returns { url: string }
   */ static getClientFileUrl(id) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: `/clientFiles/${id}/fileUrl`
        });
    }
    /**
   * Create ClientFile
   * @returns ClientFile
   */ static createClientFile(clientId, data) {
        const typeId = typeof data.client_file_type_id === 'object' ? data.client_file_type_id.id : Number(data.client_file_type_id);
        const formData = new FormData();
        formData.append('file', data.file);
        formData.append('client_file_type_id', typeId.toString());
        formData.append('overwrite', (data.overwrite ?? true).toString());
        formData.append('comments', data.comments === null ? '' : data.comments);
        const requestConfig = {
            method: 'POST',
            url: `/clients/${clientId}/clientFiles`,
            body: formData,
            headers: {
                Accept: 'application/json'
            }
        };
        const promise = (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), requestConfig);
        promise.catch(async (error)=>{
            console.error('File upload error details:', {
                status: error.status,
                statusText: error.statusText,
                message: error.message
            });
            if (error.response) try {
                const errorBody = await error.response.text();
                console.error('Error response body:', errorBody);
                try {
                    const jsonError = JSON.parse(errorBody);
                    console.error('Parsed error response:', jsonError);
                } catch (e) {
                    console.error('Error response is not JSON:', errorBody);
                }
            } catch (e) {
                console.error('Could not read error response:', e);
            }
        });
        return promise;
    }
    /**
   * Update ClientFile
   * @returns ClientFile
   */ static updateClientFile(id, data) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: `/clientFiles/${id}`,
            body: data
        });
    }
    /**
   * Delete ClientFile
   */ static deleteClientFile(id) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'DELETE',
            url: `/clientFiles/${id}`
        });
    }
}



class $37f79218b8708603$export$225d8bcca10eefa2 {
    /**
   * List Client Reporting Periods
   */ static list({ client_id: client_id, program_id: program_id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/clients/{client_id}/programs/{program_id}/clientProgramReportingPeriods',
            path: {
                client_id: client_id,
                program_id: program_id
            },
            query: req
        });
    }
    /**
   * List Client Reporting Periods for all programs
   */ static listForClient({ client_id: client_id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/clients/{client_id}/fullClientProgramReportingPeriods',
            path: {
                client_id: client_id
            },
            query: req
        });
    }
    /**
   * Finalize Client Reporting Period
   */ static finalize({ id: id }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/clientReportingPeriods/{id}/finalize',
            path: {
                id: id
            }
        });
    }
    /**
   * Preview Finalized Reporting Period Results
   */ static preview({ id: id }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/clientReportingPeriods/{id}/previewResults',
            path: {
                id: id
            }
        });
    }
}



class $5b927e2d9307efbc$export$15fb21390f08bb4c {
    /**
   * List Clients
   * @returns Client[]
   * @throws ApiError
   */ static list(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/clients',
            query: req
        });
    }
    /**
   * List Client Addresses
   * @throws ApiError
   */ static listClientAddresses() {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/clients/addresses'
        });
    }
    /**
   * List Client Programs
   * @returns Program[]
   * @throws ApiError
   */ static listClientPrograms({ id: id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/clients/{id}/clientPrograms',
            path: {
                id: id
            },
            query: req
        });
    }
    /**
   * List Client Users
   * @returns User[]
   * @throws ApiError
   */ static listClientUsers({ id: id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/clients/{id}/users',
            path: {
                id: id
            },
            query: req
        });
    }
    /**
   * List Client Names
   * @returns ClientName
   * @throws ApiError
   */ static listClientNames(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/clients/names',
            query: req,
            useArrayBrackets: true
        });
    }
    /**
   * Get Client
   * @param email string
   * @param password string
   * @returns Client
   * @throws ApiError
   */ static get({ id: id }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/clients/{id}',
            path: {
                id: id
            }
        });
    }
    /**
   * Create Client
   * @param client Client
   * @returns Client
   * @throws ApiError
   */ static create(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/clients',
            body: req
        });
    }
    /**
   * Update Client
   * @param client Client
   * @returns Client
   * @throws ApiError
   */ static update(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/clients/{id}',
            path: {
                id: req.id
            },
            body: req
        });
    }
    /**
   * Retire Client
   * @throws ApiError
   */ static retire({ id: id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/clients/{id}/retire',
            path: {
                id: id
            },
            body: req
        });
    }
}



class $1cc8a6e678e39737$export$e198101443caf8af {
    /**
   * Get Admin Dashboard Data
   * @returns DashboardData
   * @throws ApiError
   */ static getAdminView({ country: country }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/dashboard/{country}',
            path: {
                country: country
            }
        });
    }
    /**
   * Get Client Dashboard Data
   * @returns DashboardData
   * @throws ApiError
   */ static getClientView({ client_id: client_id }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/dashboard/{client_id}',
            path: {
                client_id: client_id
            }
        });
    }
}



class $d17911beca13351e$export$63e6e4d9a672e282 {
    /**
   * List Equipment Categories
   * @returns EquipmentCategory[] EquipmentCategory[]
   * @throws ApiError
   */ static listEquipmentCategories(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/equipmentCategories',
            query: req
        });
    }
}



class $64087c41a5036744$export$f3cdcae448e94402 {
    /**
   * List Equipment by Facility
   * @returns Equipment[] Equipment[]
   * @throws ApiError
   */ static list({ facility_id: facility_id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/facilities/{facility_id}/equipment',
            path: {
                facility_id: facility_id
            },
            query: req
        });
    }
    /**
   * List Equipment by Client
   * @returns Equipment[] Equipment[]
   * @throws ApiError
   */ static listByClient({ client_id: client_id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/clients/{client_id}/equipment',
            path: {
                client_id: client_id
            },
            query: req
        });
    }
    /**
   * List All Equipment
   * @returns Equipment[] Equipment[]
   * @throws ApiError
   */ static listAll(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/equipment',
            query: req
        });
    }
    /**
   * Get Equipment
   * @returns Equipment Equipment
   * @throws ApiError
   */ static get({ id: id }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/equipment/{id}',
            path: {
                id: id
            }
        });
    }
    /**
   * Create Equipment - Internal Users
   * @param equipment Equipment
   * @returns Equipment Equipment
   * @throws ApiError
   */ static createInternal({ facility_id: facility_id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/facilities/{facility_id}/equipment/internalUser',
            path: {
                facility_id: facility_id
            },
            body: req
        });
    }
    /**
   * Create Equipment - External Users
   * @param equipment Equipment
   * @returns Equipment Equipment
   * @throws ApiError
   */ static createExternal({ facility_id: facility_id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/facilities/{facility_id}/equipment/externalUser',
            path: {
                facility_id: facility_id
            },
            body: req
        });
    }
    /**
   * Update NonFinalized Equipment - Internal Users
   * @param equipment Equipment
   * @returns Equipment Equipment
   * @throws ApiError
   */ static updateNonFinalizedInternal({ id: id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/equipment/{id}/internalUser/notFinalized',
            path: {
                id: id
            },
            body: req
        });
    }
    /**
   * Update Finalized Equipment - Internal Users
   * @param equipment Equipment
   * @returns Equipment Equipment
   * @throws ApiError
   */ static updateFinalizedInternal({ id: id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/equipment/{id}/internalUser/finalized',
            path: {
                id: id
            },
            body: req
        });
    }
    /**
   * Update Pending Equipment - External Users
   * @param equipment Equipment
   * @returns Equipment Equipment
   * @throws ApiError
   */ static updatePendingExternal({ id: id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/equipment/{id}/externalUser/pending',
            path: {
                id: id
            },
            body: req
        });
    }
    /**
   * Update Non-Pending Equipment - External Users
   * @param equipment Equipment
   * @returns Equipment Equipment
   * @throws ApiError
   */ static updateNonPendingExternal({ id: id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/equipment/{id}/externalUser/notPending',
            path: {
                id: id
            },
            body: req
        });
    }
    /**
   * Retire Equipment
   * @throws ApiError
   */ static retire(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/equipment/retire',
            body: req
        });
    }
    /**
   * Delete Equipment
   * @throws ApiError
   */ static delete(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'DELETE',
            url: '/equipment',
            body: req
        });
    }
}



class $a5a0335c656802a5$export$89132588ea848e29 {
    /**
   * List Equipment Usages
   * @returns {EquipmentUsage[]}
   * @throws ApiError
   */ static list({ equipment_id: equipment_id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/equipment/{equipment_id}/equipmentUsages',
            path: {
                equipment_id: equipment_id
            },
            query: req
        });
    }
    /**
   * List Equipment Usages by Facility Reporting Period
   * @returns {EquipmentUsage[]}
   * @throws ApiError
   */ static listByFacilityReportingPeriod({ facility_id: facility_id, client_program_reporting_period_id: client_program_reporting_period_id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/facilities/{facility_id}/clientProgramReportingPeriods/{client_program_reporting_period_id}/equipmentUsages',
            path: {
                facility_id: facility_id,
                client_program_reporting_period_id: client_program_reporting_period_id
            },
            query: req
        });
    }
    /**
   * Get Equipment Usage
   * @returns EquipmentUsage EquipmentUsage
   * @throws ApiError
   */ static get({ id: id }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/equipmentUsages/{id}',
            path: {
                id: id
            }
        });
    }
    /**
   * Update - Metered Equipment Usage as Internal User
   * @returns void
   * @throws ApiError
   */ static updateMeteredAsInternalUser({ equipment_usage_id: equipment_usage_id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/equipmentUsages/{equipment_usage_id}/internalUser/metered',
            path: {
                equipment_usage_id: equipment_usage_id
            },
            body: req
        });
    }
    /**
   * Update - Metered Equipment Usage as External User
   * @returns void
   * @throws ApiError
   */ static updateMeteredAsExternalUser({ equipment_usage_id: equipment_usage_id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/equipmentUsages/{equipment_usage_id}/externalUser/metered',
            path: {
                equipment_usage_id: equipment_usage_id
            },
            body: req
        });
    }
    /**
   * Update - Unmetered Equipment Usage as Internal User
   * @returns void
   * @throws ApiError
   */ static updateUnmeteredAsInternalUser({ equipment_usage_id: equipment_usage_id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/equipmentUsages/{equipment_usage_id}/internalUser/unmetered',
            path: {
                equipment_usage_id: equipment_usage_id
            },
            body: req
        });
    }
    /**
   * Update - Unmetered Equipment Usage as External User
   * @returns void
   * @throws ApiError
   */ static updateUnmeteredAsExternalUser({ equipment_usage_id: equipment_usage_id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/equipmentUsages/{equipment_usage_id}/externalUser/unmetered',
            path: {
                equipment_usage_id: equipment_usage_id
            },
            body: req
        });
    }
    /**
   * Update - Multiple Metered Equipment Usage
   * @returns void
   * @throws ApiError
   */ static updateMultipleMetered({ facility_id: facility_id, client_program_reporting_period_id: client_program_reporting_period_id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/facilities/{facility_id}/clientProgramReportingPeriods/{client_program_reporting_period_id}/equipmentUsages/multipleMetered',
            path: {
                facility_id: facility_id,
                client_program_reporting_period_id: client_program_reporting_period_id
            },
            body: req
        });
    }
    /**
   * Update - Multiple Unmetered Equipment Usage
   * @returns void
   * @throws ApiError
   */ static updateMultipleUnmetered({ facility_id: facility_id, client_program_reporting_period_id: client_program_reporting_period_id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/facilities/{facility_id}/clientProgramReportingPeriods/{client_program_reporting_period_id}/equipmentUsages/multipleUnmetered',
            path: {
                facility_id: facility_id,
                client_program_reporting_period_id: client_program_reporting_period_id
            },
            body: req
        });
    }
}



class $2f95a0926656d8e2$export$c270777027a9c841 {
    /**
   * List Facilities
   * @returns Facility Facility
   * @throws ApiError
   */ static list({ client_id: client_id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/clients/{client_id}/facilities',
            path: {
                client_id: client_id
            },
            query: req
        });
    }
    /**
   * List Facility Addresses
   * @throws ApiError
   */ static listFacilityAddresses() {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/facilities/addresses'
        });
    }
    /**
   * List All Facilities
   * @returns Facility Facility
   * @throws ApiError
   */ static listAll(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/facilities',
            query: req
        });
    }
    /**
   * Get Facility
   * @returns Facility Facility
   * @throws ApiError
   */ static get({ id: id }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/facilities/{id}',
            path: {
                id: id
            }
        });
    }
    /**
   * Create Facility
   * @returns Facility Facility
   * @throws ApiError
   */ static create({ client_id: client_id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/clients/{client_id}/facilities',
            path: {
                client_id: client_id
            },
            body: req
        });
    }
    /**
   * Update Unfinalized Facility
   * @returns Facility Facility
   * @throws ApiError
   */ static updateUnfinalized({ id: id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/facilities/{id}/notFinalized',
            path: {
                id: id
            },
            body: req
        });
    }
    /**
   * Update Finalized Facility
   * @returns Facility Facility
   * @throws ApiError
   */ static updateFinalized({ id: id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/facilities/{id}/finalized',
            path: {
                id: id
            },
            body: req
        });
    }
    /**
   * Retire Facility
   * @throws ApiError
   */ static retire(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/facilities/retire',
            body: req
        });
    }
    /**
   * Delete Facility
   * @throws ApiError
   */ static delete(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'DELETE',
            url: '/facilities',
            body: req
        });
    }
}



class $d6dddabef9527262$export$47f5a8b2675bf9f0 {
    /**
   * List FSERegistrationStatuses
   * @returns FSERegistrationStatus[] FSERegistrationStatus[]
   * @throws ApiError
   */ static listFSERegistrationStatuses() {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/fseRegistrationStatuses'
        });
    }
}



class $7d36359e85b6c632$export$f92f70e00c5fb03f {
    /**
   * Get Referral Commission
   * @param id Referral commission ID
   * @returns ReferralCommission
   * @throws ApiError
   */ static getReferralCommission({ id: id }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/referralCommissionRates/{id}',
            path: {
                id: id
            }
        });
    }
    /**
   * Create Referral Commission
   * @param req Create referral commission request
   * @returns ReferralCommission
   * @throws ApiError
   */ static createReferralCommission(req) {
        const { client_id: client_id, ...requestBody } = req;
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: `/clients/${client_id}/referralCommissionRates`,
            body: requestBody
        });
    }
}



class $b0af269f4f630763$export$40b243bf31bf9421 {
    /**
   * List FuelPathways
   * @returns FuelPathway[] FuelPathway[]
   * @throws ApiError
   */ static list(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/fuelPathways',
            query: req
        });
    }
}



class $56a7168c8945bbf5$export$c90fd1a7cde0dffa {
    /**
   * List Incentive Statement Reporting Periods
   * @returns IncentiveStatementReportingPeriod[]
   * @throws ApiError
   */ static listIncentiveStatementReportingPeriods({ client_id: client_id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/clients/{client_id}/incentiveStatementReportingPeriods',
            path: {
                client_id: client_id
            },
            query: req
        });
    }
    /**
   * Get Incentive Statement Reporting Period (Combined)
   * @returns IncentiveStatement
   * @throws ApiError
   */ static getIncentiveStatementReportingPeriod({ id: id }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/incentiveStatementReportingPeriods/{id}',
            path: {
                id: id
            }
        });
    }
    /**
   * Get Incentive Statement
   * @returns IncentiveStatement
   * @throws ApiError
   */ static getIncentiveStatement({ id: id }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/incentiveStatements/{id}',
            path: {
                id: id
            }
        });
    }
}



class $05bcb43788f04b5c$export$ef093b57d2fc4c08 {
    /**
   * List Model Audit Logs
   * @throws ApiError
   */ static list(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/modelAuditLogs',
            query: req
        });
    }
    /**
   * List Model Audit Log States
   * @throws ApiError
   */ static listStates(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/modelAuditLogStates',
            query: req
        });
    }
    /**
   * Get Model Audit Log
   * @throws ApiError
   */ static get({ id: id }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/modelAuditLogs/{id}',
            path: {
                id: id
            }
        });
    }
    /**
   * Update Model Audit Log State
   * @throws ApiError
   */ static updateState({ model_audit_log_id: model_audit_log_id, ...req }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/modelAuditLogs/{model_audit_log_id}/updateState',
            path: {
                model_audit_log_id: model_audit_log_id
            },
            body: req
        });
    }
}



class $06590284a0c4fd89$export$84ac2881c878ff18 {
    /**
   * List Programs
   * @returns Program[] Program[]
   * @throws ApiError
   */ static list(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/programs',
            query: req
        });
    }
}



class $8a34d767b5bdff06$export$b0a97e3fab168231 {
    /**
   * List Reporting Period Types
   */ static list() {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/reportingPeriodTypes'
        });
    }
}



class $1840877422ff944e$export$12a0075dc4fe634f {
    /**
   * List Retirement Reasons
   * @returns RetirementReason[]
   * @throws ApiError
   */ static list(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/retirementReasons',
            query: req
        });
    }
}



class $1b556df194d0289b$export$bb170c807acfe5f {
    /**
   * List Roles
   * @returns Role[]
   * @throws ApiError
   */ static list(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/roles',
            query: req
        });
    }
}



class $48810180e2a8cd58$export$98959fd4ac26ac2e {
    /**
   * List Sales Commissions
   * @returns SalesCommission[] SalesCommission[]
   * @throws ApiError
   */ static listSalesCommissions(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/salesCommissionRates',
            query: req?.page ? {
                page: req.page
            } : undefined
        });
    }
    /**
   * Get Sales Commission
   * @param email string
   * @param password string
   * @returns SalesCommission SalesCommission
   * @throws ApiError
   */ static getSalesCommission({ id: id }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/salesCommissionRates/{id}',
            path: {
                id: id
            }
        });
    }
    /**
   * Create Sales Commission
   * @param salesCommission SalesCommission
   * @returns SalesCommission SalesCommission
   * @throws ApiError
   */ static createSalesCommission(req) {
        const { client_id: client_id, ...requestBody } = req;
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: `/clients/${client_id}/salesCommissionRates`,
            body: requestBody
        });
    }
}



class $1f30379e064ebff4$export$a81c579a392aa9d2 {
    /**
   * List Users
   * @returns User[] User[]
   * @throws ApiError
   */ static list(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/users',
            query: req
        });
    }
    /**
   * Get User
   * @param email string
   * @param password string
   * @returns User User
   * @throws ApiError
   */ static get({ id: id }, options) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)(options ?? (0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/users/{id}',
            path: {
                id: id
            }
        });
    }
    /**
   * Create User
   * @param user User
   * @returns User User
   * @throws ApiError
   */ static create(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/users',
            body: req
        });
    }
    /**
   * Update User
   * @param user User
   * @returns User User
   * @throws ApiError
   */ static update(id, req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/users/{id}',
            path: {
                id: id
            },
            body: req
        });
    }
    /**
   * Update User
   * @param user User
   * @returns User User
   * @throws ApiError
   */ static updateEmail(id, req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/users/{id}/updateEmail',
            path: {
                id: id
            },
            body: req
        });
    }
    /**
   * Update Password
   * @param request TUpdatePasswordRequest
   * @returns object JSONWebToken
   * @throws ApiError
   */ static updatePassword(id, req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/users/{id}/updatePassword',
            path: {
                id: id
            },
            body: req
        });
    }
    /**
   * Reset Password
   * @param request TResetPasswordRequest
   * @returns object JSONWebToken
   * @throws ApiError
   */ static resetPassword(token, req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/users/updateForgottenPassword/{token}',
            path: {
                token: token
            },
            body: req
        });
    }
    /**
   * Send Password Reset Email
   * @param request TRequestPasswordResetRequest
   * @returns object JSONWebToken
   * @throws ApiError
   */ static requestPasswordReset(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/users/forgotPassword',
            body: req
        });
    }
    /**
   * Generate Password Reset URL
   * @param request TRequestPasswordResetRequest
   * @returns object JSONWebToken
   * @throws ApiError
   */ static generatePasswordResetUrl(user_id) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/users/{user_id}/generatePasswordResetUrl',
            path: {
                user_id: user_id
            }
        });
    }
    /**
   * Verify Email Address
   * @throws ApiError
   */ static verifyEmail(token) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/users/verifyEmail/{token}',
            path: {
                token: token
            }
        });
    }
}



class $554ab5093ad5ab37$export$6d7a392c12f13470 {
    /**
   * List Utilities
   * @returns Utility[] Utility[]
   * @throws ApiError
   */ static listUtilities({ region_id: region_id }) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/utilities',
            query: {
                region_id: region_id
            }
        });
    }
}
















































class $c0c39e1b1209be87$export$2e2bcd8739ae039 {
    rootStore;
    constructor(rootStore){
        this.rootStore = rootStore;
    }
}


var $0badf5665deea2b2$export$b63330adaddce5a3 = /*#__PURE__*/ function(Regions) {
    // United States
    Regions["AL"] = "AL";
    Regions["AK"] = "AK";
    Regions["AZ"] = "AZ";
    Regions["AR"] = "AR";
    Regions["CA"] = "CA";
    Regions["CO"] = "CO";
    Regions["CT"] = "CT";
    Regions["DE"] = "DE";
    Regions["FL"] = "FL";
    Regions["GA"] = "GA";
    Regions["HI"] = "HI";
    Regions["ID"] = "ID";
    Regions["IL"] = "IL";
    Regions["IN"] = "IN";
    Regions["IA"] = "IA";
    Regions["KS"] = "KS";
    Regions["KY"] = "KY";
    Regions["LA"] = "LA";
    Regions["ME"] = "ME";
    Regions["MD"] = "MD";
    Regions["MA"] = "MA";
    Regions["MI"] = "MI";
    Regions["MN"] = "MN";
    Regions["MS"] = "MS";
    Regions["MO"] = "MO";
    Regions["MT"] = "MT";
    Regions["NE"] = "NE";
    Regions["NV"] = "NV";
    Regions["NH"] = "NH";
    Regions["NJ"] = "NJ";
    Regions["NM"] = "NM";
    Regions["NY"] = "NY";
    Regions["NC"] = "NC";
    Regions["ND"] = "ND";
    Regions["OH"] = "OH";
    Regions["OK"] = "OK";
    Regions["OR"] = "OR";
    Regions["PA"] = "PA";
    Regions["RI"] = "RI";
    Regions["SC"] = "SC";
    Regions["SD"] = "SD";
    Regions["TN"] = "TN";
    Regions["TX"] = "TX";
    Regions["UT"] = "UT";
    Regions["VT"] = "VT";
    Regions["VA"] = "VA";
    Regions["WA"] = "WA";
    Regions["WV"] = "WV";
    Regions["WI"] = "WI";
    Regions["WY"] = "WY";
    // Canada
    Regions["AB"] = "AB";
    Regions["BC"] = "BC";
    Regions["MB"] = "MB";
    Regions["NB"] = "NB";
    Regions["NL"] = "NL";
    Regions["NT"] = "NT";
    Regions["NS"] = "NS";
    Regions["NU"] = "NU";
    Regions["ON"] = "ON";
    Regions["PE"] = "PE";
    Regions["QC"] = "QC";
    Regions["SK"] = "SK";
    Regions["YT"] = "YT";
    return Regions;
}({});
var $0badf5665deea2b2$export$bdfc9528aeaa6307 = /*#__PURE__*/ function(CountryName) {
    CountryName["Canada"] = "canada";
    CountryName["USA"] = "usa";
    CountryName["Combined"] = "combined";
    return CountryName;
}({});
var $0badf5665deea2b2$export$b77c37614753bffb = /*#__PURE__*/ function(CountryId) {
    CountryId[CountryId["USA"] = 1] = "USA";
    CountryId[CountryId["Canada"] = 2] = "Canada";
    return CountryId;
}({});
var $0badf5665deea2b2$export$a121e4a6c908fa8f = /*#__PURE__*/ function(ReportingPeriodType) {
    ReportingPeriodType[ReportingPeriodType["Quarterly"] = 1] = "Quarterly";
    ReportingPeriodType[ReportingPeriodType["Yearly"] = 2] = "Yearly";
    return ReportingPeriodType;
}({});
var $0badf5665deea2b2$export$25c0d5b425a20ec = /*#__PURE__*/ function(StorageKeys) {
    StorageKeys["Theme"] = "theme";
    StorageKeys["CurrentDashboardId"] = "currentDashboardId";
    StorageKeys["SelectedDashboardData"] = "selectedDashboardData";
    StorageKeys["SelectedClient"] = "selectedClient";
    StorageKeys["SelectedClientID"] = "selectedClientId";
    StorageKeys["ActiveClientId"] = "activeClientId";
    StorageKeys["SelectedUser"] = "selectedUser";
    StorageKeys["SelectedUserID"] = "selectedUserId";
    StorageKeys["UserClients"] = "userClients";
    StorageKeys["UserClientsMeta"] = "userClientsMeta";
    StorageKeys["SessionToken"] = "sessionToken";
    StorageKeys["SessionUser"] = "sessionUser";
    StorageKeys["SessionExpiration"] = "sessionExpiration";
    StorageKeys["SessionTtl"] = "sessionTtl";
    StorageKeys["Session"] = "session";
    return StorageKeys;
}({});
var $0badf5665deea2b2$export$67a5acd59cd593a6 = /*#__PURE__*/ function(LeafletOutputFormats) {
    LeafletOutputFormats["JSON"] = "json";
    LeafletOutputFormats["GeoJSON"] = "geojson";
    LeafletOutputFormats["GeocodeJSON"] = "geocodejson";
    return LeafletOutputFormats;
}({});
var $0badf5665deea2b2$export$dd8643a5f2fdbfa5 = /*#__PURE__*/ function(ModelType) {
    ModelType["Clients"] = "Clients";
    ModelType["Facilities"] = "Facilities";
    ModelType["Equipment"] = "Equipment";
    ModelType["Users"] = "Users";
    return ModelType;
}({});
var $0badf5665deea2b2$export$3f6d0f4ada384a91 = /*#__PURE__*/ function(EntityStatus) {
    EntityStatus["Active"] = "Active";
    EntityStatus["Inactive"] = "Inactive";
    EntityStatus["Retired"] = "Retired";
    return EntityStatus;
}({});
var $0badf5665deea2b2$export$3e3dc826e36eaf2b = /*#__PURE__*/ function(MeteredStatus) {
    MeteredStatus["Metered"] = "Metered";
    MeteredStatus["Unmetered"] = "Unmetered";
    return MeteredStatus;
}({});
var $0badf5665deea2b2$export$aef5f7424b651af0 = /*#__PURE__*/ function(QuarterMonths) {
    QuarterMonths["Q1"] = "01";
    QuarterMonths["Q2"] = "04";
    QuarterMonths["Q3"] = "07";
    QuarterMonths["Q4"] = "10";
    return QuarterMonths;
}({});
var $0badf5665deea2b2$export$1e617fb43dd54874 = /*#__PURE__*/ function(FinalizedStatus) {
    FinalizedStatus[FinalizedStatus["NotFinalized"] = 0] = "NotFinalized";
    FinalizedStatus[FinalizedStatus["Finalized"] = 1] = "Finalized";
    return FinalizedStatus;
}({});
var $0badf5665deea2b2$export$cf1043bb7509db30 = /*#__PURE__*/ function(LockedStatus) {
    LockedStatus[LockedStatus["NotLocked"] = 0] = "NotLocked";
    LockedStatus[LockedStatus["Locked"] = 1] = "Locked";
    return LockedStatus;
}({});
var $0badf5665deea2b2$export$2cc06ea48a9a0a41 = /*#__PURE__*/ function(FSERegistrationStatusIds) {
    FSERegistrationStatusIds[FSERegistrationStatusIds["Pending Client Information"] = 1] = "Pending Client Information";
    FSERegistrationStatusIds[FSERegistrationStatusIds["Pending CARB Review"] = 2] = "Pending CARB Review";
    FSERegistrationStatusIds[FSERegistrationStatusIds["Approved"] = 3] = "Approved";
    FSERegistrationStatusIds[FSERegistrationStatusIds["Not Approved"] = 4] = "Not Approved";
    FSERegistrationStatusIds[FSERegistrationStatusIds["Deduct from PoS"] = 5] = "Deduct from PoS";
    FSERegistrationStatusIds[FSERegistrationStatusIds["Paused"] = 6] = "Paused";
    return FSERegistrationStatusIds;
}({});
var $0badf5665deea2b2$export$9f619beb6face5a = /*#__PURE__*/ function(InfoFormFieldType) {
    InfoFormFieldType["Input"] = "Input";
    InfoFormFieldType["Select"] = "Select";
    InfoFormFieldType["SelectMultiple"] = "SelectMultiple";
    InfoFormFieldType["Password"] = "Password";
    return InfoFormFieldType;
}({});
var $0badf5665deea2b2$export$f4dd91be846acd3a = /*#__PURE__*/ function(ModelAuditLogEventType) {
    ModelAuditLogEventType["Create"] = "Create";
    ModelAuditLogEventType["Update"] = "Update";
    ModelAuditLogEventType["Delete"] = "Delete";
    return ModelAuditLogEventType;
}({});
var $0badf5665deea2b2$export$b60056a547589254 = /*#__PURE__*/ function(ModelAuditLogState) {
    ModelAuditLogState[ModelAuditLogState["Unresolved"] = 1] = "Unresolved";
    ModelAuditLogState[ModelAuditLogState["Resolved"] = 2] = "Resolved";
    return ModelAuditLogState;
}({});
var $0badf5665deea2b2$export$61d688781044f006 = /*#__PURE__*/ function(AuditorType) {
    AuditorType["System"] = "SYSTEM";
    AuditorType["InternalUser"] = "INTERNAL_USER";
    AuditorType["ExternalUser"] = "EXTERNAL_USER";
    return AuditorType;
}({});


var $f755eb4d30815c93$exports = {};
!function(t, e) {
    $f755eb4d30815c93$exports = e();
}($f755eb4d30815c93$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), Y = _.prototype;
    return O.prototype = Y, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        Y[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


const $2e4d07611f552ce8$export$371e338370561054 = (email)=>{
    if (!email) return false;
    const [, fqd] = email.split('@');
    if (!fqd) return false;
    const [, tld] = fqd.split('.');
    // one-character TLDs are possible, but none currently exist: https://www.iana.org/domains/root/db
    if (!tld || tld.length === 1) return false;
    return true;
};
const $2e4d07611f552ce8$export$7bfc8d23d9761690 = (user, clientId)=>{
    return user.clients?.findIndex((client)=>client.id === clientId) !== -1;
};
const $2e4d07611f552ce8$export$9d2757a220e824d7 = (isExternalUser, usage)=>usage ? isExternalUser ? !usage.is_finalized && !usage.client_program_reporting_period.is_client_locked : !usage.is_finalized : false;
const $2e4d07611f552ce8$export$874b2b5637613a99 = (facility)=>facility?.address_region?.short_code?.toLowerCase() === 'or' || facility?.address_region?.short_code?.toLowerCase() === 'wa';
const $2e4d07611f552ce8$var$isPastReportingPeriod = (last)=>!!last && !(0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(last).isAfter((0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(), 'day');
const $2e4d07611f552ce8$export$d63e24584009432 = (equipment)=>$2e4d07611f552ce8$var$isPastReportingPeriod(equipment?.last_active_reporting_quarter);
const $2e4d07611f552ce8$export$5fba76fc92fefb38 = (facility)=>$2e4d07611f552ce8$var$isPastReportingPeriod(facility?.last_active_reporting_quarter);
const $2e4d07611f552ce8$export$f35193465aab1579 = (client)=>$2e4d07611f552ce8$var$isPastReportingPeriod(client?.last_active_reporting_quarter);
const $2e4d07611f552ce8$export$c729434f4f29c53 = (key, value, formValues, setFormValues, formErrors, setFormErrors)=>{
    setFormValues({
        ...formValues,
        [key]: value
    });
    if (formErrors[key]) setFormErrors({
        ...formErrors,
        [key]: ''
    });
};
const $2e4d07611f552ce8$export$debb760848ca95a = (obj)=>JSON.parse(JSON.stringify(obj));



const $084681c8221d0a24$export$5fafec8d1b047c0 = (formFields, formValues)=>{
    const errors = {};
    Object.keys(formFields).forEach((fieldName)=>{
        const { label: label, min: min, max: max, minValue: minValue, maxValue: maxValue, nonZero: nonZero, required: required, before: before, sameOrBefore: sameOrBefore, after: after, sameOrAfter: sameOrAfter } = formFields[fieldName];
        const formValue = formValues[fieldName];
        if (formValue !== undefined && formValue !== null && !Number.isNaN(formValue) && formValue !== '') {
            // Non-zero
            if (nonZero) {
                const numericValue = typeof formValue === 'string' ? parseFloat(formValue) : Number(formValue);
                if (numericValue === 0) errors[fieldName] = `${label} cannot be zero`;
            }
            // Min/max characters
            if (typeof formValue === 'string') {
                if (min && formValue.length < min) errors[fieldName] = `${label} must be more than ${min} characters`;
                if (max && formValue.length > max) errors[fieldName] = `${label} must be less than ${max} characters`;
            }
            // Min/max value
            const numericValue = typeof formValue === 'string' ? parseFloat(formValue) : Number(formValue);
            if (minValue && numericValue < minValue) errors[fieldName] = `${label} must be more than ${minValue}`;
            if (maxValue && numericValue > maxValue) errors[fieldName] = `${label} must be less than or equal to ${maxValue}`;
            // Date Comparisons
            if (before || sameOrBefore || after || sameOrAfter) try {
                const dateValue = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(formValue);
                if (before) {
                    const beforeValue = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(before);
                    if (dateValue.isSame(beforeValue) || dateValue.isAfter(beforeValue)) errors[fieldName] = `${label} cannot be after first reporting period`;
                }
                if (sameOrBefore && dateValue.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(sameOrBefore))) errors[fieldName] = `${label} cannot be after first reporting period`;
                if (after) {
                    const afterValue = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(after);
                    if (dateValue.isSame(afterValue) || dateValue.isBefore(afterValue)) errors[fieldName] = `${label} cannot be before first reporting period`;
                }
                if (sameOrAfter && dateValue.isBefore((0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(sameOrAfter))) errors[fieldName] = `${label} cannot be before first reporting period`;
            } catch (_) {
            // formValue isn't a valid DateString, so let's move on
            }
        } else if (required) errors[fieldName] = `${label} is required`;
        // Lat/Long validation
        if (typeof formValue === 'string') {
            if (fieldName.toLowerCase().includes('latitude') && (formValue.split('.')[1]?.length ?? 0) !== 6) errors[fieldName] = 'Latitude values must have 6 decimal places';
            if (fieldName.toLowerCase().includes('longitude') && (formValue.split('.')[1]?.length ?? 0) !== 6) errors[fieldName] = 'Longitude values must have 6 decimal places';
        }
    });
    if (Object.keys(errors).length) return errors;
};



















var $e325a86eb2295b0b$export$c5ae10d7c88c4d3e = /*#__PURE__*/ function(FileType) {
    FileType["CSV"] = "csv";
    FileType["DOC"] = "doc";
    FileType["DOCX"] = "docx";
    FileType["PDF"] = "pdf";
    FileType["TXT"] = "txt";
    FileType["XLS"] = "xls";
    FileType["XLSX"] = "xlsx";
    return FileType;
}({});














var $acc57f855dc3e03c$export$1f9784bf50bfea54 = /*#__PURE__*/ function(EquipmentCategoryId) {
    EquipmentCategoryId[EquipmentCategoryId["CA_LCFS_LIGHT_DUTY_FCI"] = 133] = "CA_LCFS_LIGHT_DUTY_FCI";
    EquipmentCategoryId[EquipmentCategoryId["CA_LCFS_HEAVY_DUTY_FCI"] = 134] = "CA_LCFS_HEAVY_DUTY_FCI";
    EquipmentCategoryId[EquipmentCategoryId["OR_CFP_LIGHT_DUTY_FCI"] = 135] = "OR_CFP_LIGHT_DUTY_FCI";
    EquipmentCategoryId[EquipmentCategoryId["OR_CFP_HEAVY_DUTY_FCI"] = 136] = "OR_CFP_HEAVY_DUTY_FCI";
    EquipmentCategoryId[EquipmentCategoryId["WA_CFS_LIGHT_DUTY_FCI"] = 137] = "WA_CFS_LIGHT_DUTY_FCI";
    EquipmentCategoryId[EquipmentCategoryId["WA_CFS_HEAVY_DUTY_FCI"] = 138] = "WA_CFS_HEAVY_DUTY_FCI";
    return EquipmentCategoryId;
}({});
const $acc57f855dc3e03c$export$4d8cc36f63bac04a = new Set([
    133,
    134,
    135,
    136,
    137,
    138
]);
const $acc57f855dc3e03c$export$e8efcaf51aaf349d = (equipmentCategoryId)=>equipmentCategoryId != null && $acc57f855dc3e03c$export$4d8cc36f63bac04a.has(equipmentCategoryId);


var $de66c3e79d71b403$export$a6efb9e04a27a0a2 = /*#__PURE__*/ function(EquipmentTypeId) {
    EquipmentTypeId[EquipmentTypeId["PRE_2011_ELECTRIC_FORKLIFT"] = 14] = "PRE_2011_ELECTRIC_FORKLIFT";
    EquipmentTypeId[EquipmentTypeId["POST_2010_ELECTRIC_FORKLIFT"] = 15] = "POST_2010_ELECTRIC_FORKLIFT";
    EquipmentTypeId[EquipmentTypeId["POST_2022_FIXED_GUIDEWAY_LIGHT_RAIL"] = 82] = "POST_2022_FIXED_GUIDEWAY_LIGHT_RAIL";
    EquipmentTypeId[EquipmentTypeId["PRE_2023_FIXED_GUIDEWAY_LIGHT_RAIL"] = 83] = "PRE_2023_FIXED_GUIDEWAY_LIGHT_RAIL";
    return EquipmentTypeId;
}({});
const $de66c3e79d71b403$export$2f6e4edbc5428162 = new Set([
    15,
    14,
    82,
    83
]);
















const $049b0cfdd8ac4942$export$e0c1ba76f119f8b1 = (response)=>{
    return {
        programs: response.programs,
        totals: {
            total_kwh: response.total_kwh,
            credits: response.credits,
            total_value: response.total_value,
            rec_cost: response.rec_cost,
            broker_cost: response.broker_cost,
            taxes_on_credit_sale: response.taxes_on_credit_sale,
            taxes_on_services: response.taxes_on_services,
            fuse_service_fee: response.fuse_service_fee,
            net_incentive: response.net_incentive
        },
        client_name: response.client,
        reporting_period: response.reporting_period
    };
};


var $1132a1d774d1082e$export$8fde3cbed0ae03c0 = /*#__PURE__*/ function(ModelName) {
    ModelName["Client"] = "Client";
    ModelName["ClientFile"] = "ClientFile";
    ModelName["Facility"] = "Facility";
    ModelName["Equipment"] = "Equipment";
    ModelName["EquipmentUsage"] = "EquipmentUsage";
    ModelName["User"] = "User";
    return ModelName;
}({});




































const $47b7f1ecedcfeb5f$export$3ac33485b394649b = 'Other';


var $a65473e9746b33bb$export$2cb4a31baf73b247 = /*#__PURE__*/ function(RoleTypes) {
    RoleTypes[RoleTypes["FuseAdmin"] = 1] = "FuseAdmin";
    RoleTypes[RoleTypes["FuseSalesRep"] = 2] = "FuseSalesRep";
    RoleTypes[RoleTypes["ClientAdmin"] = 3] = "ClientAdmin";
    RoleTypes[RoleTypes["FacilityAdmin"] = 4] = "FacilityAdmin";
    return RoleTypes;
}({});
const $a65473e9746b33bb$export$5d277a5d95a5046e = [
    1,
    2
];
const $a65473e9746b33bb$export$ed05588e9f6a56d = [
    2
];
const $a65473e9746b33bb$export$4104e3cb244d8c3a = [
    3
];
const $a65473e9746b33bb$export$f0dfb0bb769e5823 = [
    4
];
const $a65473e9746b33bb$export$39d571c105d2314f = [
    ...$a65473e9746b33bb$export$4104e3cb244d8c3a,
    ...$a65473e9746b33bb$export$f0dfb0bb769e5823
];
const $a65473e9746b33bb$export$7853a174aac8e6fa = [
    1,
    3,
    4
];
const $a65473e9746b33bb$export$e96fc2b06c25bc5e = [
    {
        id: 1,
        name: 'Admin'
    },
    {
        id: 2,
        name: 'Sales Rep'
    },
    {
        id: 3,
        name: 'Client Admin'
    },
    {
        id: 4,
        name: 'Facility Admin'
    }
];
const $a65473e9746b33bb$export$2db3bb45591f9fdc = [
    {
        value: 1,
        label: 'Admin'
    },
    {
        value: 2,
        label: 'Sales Rep'
    },
    {
        value: 3,
        label: 'Client Admin'
    },
    {
        value: 4,
        label: 'Facility Admin'
    }
];












var $6db26f7304b7efb4$export$b664f3cc034a10ef = /*#__PURE__*/ function(UserEmailVerificationStatus) {
    UserEmailVerificationStatus["Verified"] = "Verified";
    UserEmailVerificationStatus["Unverified"] = "Not Verified";
    return UserEmailVerificationStatus;
}({});







const $00658ccd6ec0135a$export$9a00dee1beb8f576 = (input)=>{
    const words = input.split(' ');
    if (words.length === 1) return input[0].toUpperCase() + input.slice(1);
    else return words.map((word)=>word[0].toUpperCase() + word.slice(1)).join(' ');
};
const $00658ccd6ec0135a$export$16264c5d2d58746c = (snakeCase)=>{
    const words = snakeCase.split('_');
    if (!words.length) return '';
    if (words.length === 1) return words[0];
    let camelCase = words[0];
    for(let i = 1; i < words.length; i++)camelCase += $00658ccd6ec0135a$export$9a00dee1beb8f576(words[i]);
    return camelCase;
};
const $00658ccd6ec0135a$export$cc8b315fc368b20a = (input)=>input.toLowerCase().replace(/ /g, '_');
const $00658ccd6ec0135a$export$7a79460e9abc6302 = (camelCase)=>$00658ccd6ec0135a$export$cc8b315fc368b20a($00658ccd6ec0135a$export$87429743646c3257(camelCase));
const $00658ccd6ec0135a$export$f5dd818bff069720 = (input, addCommas = true, isCurrency = false, isFinancial = false, toFixed)=>{
    if (!input) return '';
    if (typeof input === 'number' && Number.isNaN(input)) return '0';
    input = typeof input === 'number' ? toFixed ? input.toFixed(toFixed) : input.toString() : input;
    let result = input;
    if (addCommas) {
        const splitDecimal = input.split('.');
        const inputString = splitDecimal[0];
        if (inputString.length > 3) {
            let loopString = inputString;
            const outputStrings = [];
            for(let i = 0; i < inputString.length; i += 1)if (i !== 0 && i % 3 === 0) {
                const sliceIndex = inputString.length - i;
                const stringAfter = loopString.slice(sliceIndex);
                const stringBefore = loopString.slice(0, sliceIndex);
                outputStrings.push(stringAfter);
                loopString = stringBefore;
                if (sliceIndex <= 3) outputStrings.push(stringBefore);
            }
            result = outputStrings.reverse().join(',');
        } else result = inputString;
        if (splitDecimal?.[1]) result = `${result}.${splitDecimal[1]}`;
        else if (toFixed) {
            result += '.';
            for(let i = 0; i < toFixed; i += 1)result += '0';
        }
    }
    if (isFinancial && result[0] === '-') result = `(${result.slice(result[1] === ',' ? 2 : 1)})`;
    else if (isCurrency) result = `$${result}`;
    return result;
};
const $00658ccd6ec0135a$export$919ca5000217590c = (size)=>size?.toLowerCase().includes('px');
const $00658ccd6ec0135a$export$dbd2438c8f5569e9 = (pxSize)=>typeof pxSize === 'string' ? $00658ccd6ec0135a$export$919ca5000217590c(pxSize) ? `${parseFloat(pxSize.slice(0, -2)) / 16}rem` : pxSize : `${pxSize / 16}rem`;
const $00658ccd6ec0135a$export$ed800035e096ef02 = (pxSize)=>typeof pxSize === 'string' ? $00658ccd6ec0135a$export$919ca5000217590c(pxSize) ? `${parseFloat(pxSize.slice(0, -2)) * 0.75}pt` : pxSize : `${pxSize * 0.75}pt`;
const $00658ccd6ec0135a$export$de9bdbce6502b027 = (name, separator = ' ')=>{
    if (!name) return '';
    const words = name.split(separator);
    if (words.length === 1) return words[0][0].toUpperCase();
    else return `${words[0][0].toUpperCase()}${words[words.length - 1][0].toUpperCase()}`;
};
const $00658ccd6ec0135a$export$e7459906f76aa375 = (type = 'numbers', outputLength = 9)=>{
    let randomStr = '';
    for(let i = 0; i < outputLength; i++)if (type === 'numbers') randomStr += (Math.random() * 9).toString();
    return randomStr;
};
const $00658ccd6ec0135a$export$e774cbf6b137c816 = (dateString)=>{
    if (!dateString) return '';
    const input = new Date(dateString);
    const quarters = {
        0: 'Q1',
        1: 'Q1',
        2: 'Q1',
        3: 'Q2',
        4: 'Q2',
        5: 'Q2',
        6: 'Q3',
        7: 'Q3',
        8: 'Q3',
        9: 'Q4',
        10: 'Q4',
        11: 'Q4'
    };
    return `${quarters[input.getUTCMonth()]} ${input.getUTCFullYear()}`;
};
const $00658ccd6ec0135a$export$6a2a5264dcc16b56 = (input)=>{
    if (!input) return '';
    const quarters = {
        0: 'Q1',
        1: 'Q1',
        2: 'Q1',
        3: 'Q2',
        4: 'Q2',
        5: 'Q2',
        6: 'Q3',
        7: 'Q3',
        8: 'Q3',
        9: 'Q4',
        10: 'Q4',
        11: 'Q4'
    };
    return `${quarters[input.getUTCMonth()]} ${input.getUTCFullYear()}`;
};
const $00658ccd6ec0135a$export$961bde6bd33f5db2 = (input)=>{
    const months = {
        Q1: '01',
        Q2: '04',
        Q3: '07',
        Q4: '10'
    };
    const [quarter, year] = input.split(' ');
    return `${year}-${months[quarter]}-01`;
};
const $00658ccd6ec0135a$export$c335365bcf02a1ed = (input)=>{
    return `${(0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(input).format('MMMM DD, YYYY')} - ${(0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(input).add(2, 'months').endOf('month').format('MMMM DD, YYYY')}`;
};
const $00658ccd6ec0135a$export$9a237e2a87264fbb = (input)=>(0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(input).year().toString();
const $00658ccd6ec0135a$export$edb1a34d61ff6218 = (input)=>(0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(input).year().toString();
const $00658ccd6ec0135a$export$af07fade2660cbdc = (input)=>(0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(input).set('month', 0).set('date', 1).format('YYYY-MM-DD');
const $00658ccd6ec0135a$export$17e213d8c10b7032 = (input)=>{
    return `${(0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(input).set('month', 0).set('date', 1).format('MMMM DD, YYYY')} - ${(0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(input).set('month', 11).set('date', 31).format('MMMM DD, YYYY')}`;
};
const $00658ccd6ec0135a$export$25fe81f0e0c5bc4 = (input, isCanada)=>{
    if (!input) return '';
    const date = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(input);
    if (!date.isValid()) {
        console.warn(`Invalid date string: ${input}`);
        return '';
    }
    return isCanada ? (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(date).format('YYYY-MM-DD') : (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(date).format('M/D/YYYY');
};
const $00658ccd6ec0135a$export$f96ebb633255a704 = (input, isYearly)=>{
    if (!input) return '';
    const date = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(input);
    if (!date.isValid()) {
        console.warn(`Invalid date: ${input}`);
        return '';
    }
    return isYearly ? $00658ccd6ec0135a$export$9a237e2a87264fbb(input) : $00658ccd6ec0135a$export$e774cbf6b137c816(input);
};
const $00658ccd6ec0135a$export$122b076c0e3c63f7 = (input, isYearly)=>isYearly ? $00658ccd6ec0135a$export$edb1a34d61ff6218(input) : $00658ccd6ec0135a$export$6a2a5264dcc16b56(input);
const $00658ccd6ec0135a$export$254c7990ecbe689e = (input, isYearly)=>isYearly ? $00658ccd6ec0135a$export$17e213d8c10b7032(input) : $00658ccd6ec0135a$export$c335365bcf02a1ed(input);
const $00658ccd6ec0135a$export$55326c15f59f164f = (filter, options)=>{
    const exp = new RegExp(filter.toLowerCase().replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
    const filtered = options.filter((option)=>exp.test(option.toLowerCase()));
    return filtered;
};
const $00658ccd6ec0135a$export$b5513415b3f92e76 = (filter, options)=>{
    const exp = new RegExp(filter.toLowerCase().replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
    const filtered = options.filter(({ label: label })=>exp.test(label.toLowerCase()));
    return filtered;
};
const $00658ccd6ec0135a$export$e2de15bbd9edf9c6 = (queryString)=>{
    const queryParams = {};
    queryString.slice(1).split('&').map((kv)=>kv.split('=')).forEach((v)=>queryParams[v[0]] = v[1]);
    return queryParams;
};
const $00658ccd6ec0135a$export$426d0e35b67696d3 = (facility, full)=>{
    if (facility) {
        let label = facility.name ?? `${facility.address_line1}${facility.address_line2 ? ` ${facility.address_line2}` : ''}`;
        if (full) label += `, ${facility.address_city}, ${facility.address_region?.short_code ?? ''} ${facility.address_post_code}`;
        return label;
    }
    return '';
};
const $00658ccd6ec0135a$export$6cc1800f355fe600 = (addressLine)=>addressLine.replace(/\./g, '').replace(/North|north/g, 'N').replace(/South|south/g, 'S').replace(/East|east/g, 'E').replace(/West|west/g, 'W').replace(/Avenue|avenue/g, 'Ave').replace(/Street|street/g, 'St').replace(/Road|road/g, 'Rd').replace(/Boulevard|boulevard/g, 'Blvd').replace(/Parkway|parkway/g, 'Pkwy');
const $00658ccd6ec0135a$export$21d9a7ab505601f9 = (result, selectedEntity)=>{
    let url = '';
    let label = '';
    switch(selectedEntity){
        case (0, $0badf5665deea2b2$export$dd8643a5f2fdbfa5).Clients:
            url = `/clients/${result.id}`;
            label = result.name;
            break;
        case (0, $0badf5665deea2b2$export$dd8643a5f2fdbfa5).Facilities:
            url = `/clients/${result.client?.id}/facilities/${result.id}`;
            label = $00658ccd6ec0135a$export$426d0e35b67696d3(result);
            break;
        case (0, $0badf5665deea2b2$export$dd8643a5f2fdbfa5).Equipment:
            url = `/clients/${result.client?.id}/equipment/${result.id}`;
            label = `${result.unit_number} (${result.model_year} ${result.manufacturer}) ${result.model_number}`;
            break;
        case (0, $0badf5665deea2b2$export$dd8643a5f2fdbfa5).Users:
            url = `/users/${result.id}`;
            label = result.name;
            break;
        default:
            break;
    }
    return {
        url: url,
        label: label
    };
};
const $00658ccd6ec0135a$export$d9d91b4addd2e9b8 = (model, modelName)=>{
    if (!model) return '';
    let data = model;
    switch(modelName){
        case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Client:
            data;
            return `/clients/${data.id}`;
        case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).ClientFile:
            data;
            return `/clients/${data.client_id}`;
        case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Facility:
            data;
            return `/clients/${data.client_id}/facilities/${data.id}`;
        case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Equipment:
            data;
            return `/clients/${data.client_id}/equipment/${data.id}`;
        case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).EquipmentUsage:
            data;
            return `/clients/${data.client_id}/equipment/${data.equipment_id}/usages/${data.id}`;
        case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).User:
            data;
            return `/users/${data.id}`;
        default:
            return '';
    }
};
const $00658ccd6ec0135a$export$83ca57d51225263a = (model, modelName)=>{
    switch(modelName){
        case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Client:
            return model?.name ?? '';
        case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).ClientFile:
            return model?.name ?? '';
        case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Facility:
            return `${model?.address_line1 ?? ''}`;
        case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Equipment:
            return `${model?.manufacturer ?? ''}: ${model?.serial_number ?? ''}`;
        case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).EquipmentUsage:
            return model?.start_reporting_quarter ? $00658ccd6ec0135a$export$e774cbf6b137c816(model.start_reporting_quarter) : '';
        case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).User:
            return model?.name ?? '';
    }
};
const $00658ccd6ec0135a$export$87429743646c3257 = (camelCase)=>{
    if (!camelCase.length) return '';
    let result = camelCase[0].toUpperCase();
    for(let i = 1; i < camelCase.length; i++)result += $00658ccd6ec0135a$export$aebd617640818cda(camelCase[i]) ? ` ${camelCase[i]}` : camelCase[i];
    return result;
};
const $00658ccd6ec0135a$export$aebd617640818cda = (letter)=>letter === 'A' || letter === 'B' || letter === 'C' || letter === 'D' || letter === 'E' || letter === 'F' || letter === 'G' || letter === 'H' || letter === 'I' || letter === 'J' || letter === 'K' || letter === 'L' || letter === 'M' || letter === 'N' || letter === 'O' || letter === 'P' || letter === 'Q' || letter === 'R' || letter === 'S' || letter === 'T' || letter === 'U' || letter === 'V' || letter === 'W' || letter === 'X' || letter === 'Y' || letter === 'Z';
const $00658ccd6ec0135a$export$54fd2c36b5cc6731 = (input)=>{
    try {
        return JSON.parse(input);
    } catch (_) {
        return;
    }
};
const $00658ccd6ec0135a$export$21625637effda04 = (input)=>{
    try {
        return JSON.stringify(input);
    } catch (_) {
        return;
    }
};
const $00658ccd6ec0135a$export$23286240952da4c9 = (base, ...titles)=>titles.length ? [
        base,
        ...titles
    ].join(' - ') : base;
const $00658ccd6ec0135a$export$b3ab20afa21fa2d4 = (reportingPeriods, direction = 'desc')=>reportingPeriods.sort((a, b)=>a.start_reporting_quarter > b.start_reporting_quarter ? direction === 'asc' ? 1 : -1 : direction === 'asc' ? -1 : 1);
const $00658ccd6ec0135a$export$ccc472524c48b71f = (reportingPeriodOptions, direction = 'desc')=>reportingPeriodOptions.sort((a, b)=>a.value > b.value ? direction === 'asc' ? 1 : -1 : direction === 'asc' ? -1 : 1);
const $00658ccd6ec0135a$export$42dd1e93e775969e = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{16,}$/;



var $jjB6N = parcelRequire("jjB6N");

const $75741656711071e5$export$af88d00dbe7f521 = (namespace)=>(0, (/*@__PURE__*/$parcel$interopDefault($jjB6N)))(`${(0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).logs.rootNamespace}:${namespace}`);


const $c78c1ae45d5bdd4b$export$f227e7d1d6c64976 = (input, roundStep = 5)=>{
    const padded = Math.round(input + input * 0.25);
    return !(padded % roundStep) ? padded : padded + (roundStep - padded % roundStep);
};




const $9c41c53e999a77b0$export$70d175fe2fbaa383 = ()=>{
    const token = (0, $72b598b09e32bbcf$export$2e2bcd8739ae039).get((0, $0badf5665deea2b2$export$25c0d5b425a20ec).SessionToken);
    if (!token || typeof token !== 'object') return undefined;
    const sessionToken = token;
    return typeof sessionToken.token === 'string' ? sessionToken : undefined;
};
const $9c41c53e999a77b0$export$46b0b91198def893 = (token)=>{
    (0, $72b598b09e32bbcf$export$2e2bcd8739ae039).set((0, $0badf5665deea2b2$export$25c0d5b425a20ec).SessionToken, token);
};
const $9c41c53e999a77b0$export$cd1eacef65db9ebc = ()=>{
    (0, $72b598b09e32bbcf$export$2e2bcd8739ae039).remove((0, $0badf5665deea2b2$export$25c0d5b425a20ec).SessionToken);
};
const $9c41c53e999a77b0$export$a79e7ef8c396bb0e = ()=>{
    const user = (0, $72b598b09e32bbcf$export$2e2bcd8739ae039).get((0, $0badf5665deea2b2$export$25c0d5b425a20ec).SessionUser);
    if (!user || typeof user !== 'object') return undefined;
    const sessionUser = user;
    return typeof sessionUser.id === 'number' && !!sessionUser.role?.id ? sessionUser : undefined;
};
const $9c41c53e999a77b0$export$97851c88c0bf33aa = (user)=>{
    (0, $72b598b09e32bbcf$export$2e2bcd8739ae039).set((0, $0badf5665deea2b2$export$25c0d5b425a20ec).SessionUser, user);
};
const $9c41c53e999a77b0$export$b0ef8831976e9d68 = ()=>{
    (0, $72b598b09e32bbcf$export$2e2bcd8739ae039).remove((0, $0badf5665deea2b2$export$25c0d5b425a20ec).SessionUser);
};
const $9c41c53e999a77b0$export$2e02e7520508bf06 = 1800000;
const $9c41c53e999a77b0$export$c37e141db7d79f56 = 'sessionExpired';
const $9c41c53e999a77b0$export$2854321f90be4314 = (ttlMs)=>{
    (0, $72b598b09e32bbcf$export$2e2bcd8739ae039).set((0, $0badf5665deea2b2$export$25c0d5b425a20ec).SessionTtl, ttlMs);
};
const $9c41c53e999a77b0$var$getSessionTtl = ()=>{
    const ttl = (0, $72b598b09e32bbcf$export$2e2bcd8739ae039).get((0, $0badf5665deea2b2$export$25c0d5b425a20ec).SessionTtl);
    return typeof ttl === 'number' && ttl > 0 ? ttl : $9c41c53e999a77b0$export$2e02e7520508bf06;
};
const $9c41c53e999a77b0$export$305bb539294c13f8 = ()=>{
    (0, $72b598b09e32bbcf$export$2e2bcd8739ae039).remove((0, $0badf5665deea2b2$export$25c0d5b425a20ec).SessionTtl);
};
const $9c41c53e999a77b0$export$599cd8c85ed06f71 = ()=>{
    const value = (0, $72b598b09e32bbcf$export$2e2bcd8739ae039).get((0, $0badf5665deea2b2$export$25c0d5b425a20ec).SessionExpiration);
    return typeof value === 'number' ? value : undefined;
};
const $9c41c53e999a77b0$export$d7dfbce2d184dd6 = (expiresAt)=>{
    (0, $72b598b09e32bbcf$export$2e2bcd8739ae039).set((0, $0badf5665deea2b2$export$25c0d5b425a20ec).SessionExpiration, expiresAt);
};
const $9c41c53e999a77b0$export$6d845b163d151800 = ()=>{
    (0, $72b598b09e32bbcf$export$2e2bcd8739ae039).remove((0, $0badf5665deea2b2$export$25c0d5b425a20ec).SessionExpiration);
};
const $9c41c53e999a77b0$export$41c56a5e2126fc6e = ()=>{
    $9c41c53e999a77b0$export$d7dfbce2d184dd6(Date.now() + $9c41c53e999a77b0$var$getSessionTtl());
};
const $9c41c53e999a77b0$export$6d174f73f8547532 = ()=>{
    const expiresAt = $9c41c53e999a77b0$export$599cd8c85ed06f71();
    return expiresAt !== undefined && Date.now() >= expiresAt;
};
const $9c41c53e999a77b0$export$12151e9ef3722552 = ()=>{
    return (0, $72b598b09e32bbcf$export$2e2bcd8739ae039).get((0, $0badf5665deea2b2$export$25c0d5b425a20ec).Session);
};
const $9c41c53e999a77b0$export$b94982631f8f9752 = (loginData)=>{
    (0, $72b598b09e32bbcf$export$2e2bcd8739ae039).set((0, $0badf5665deea2b2$export$25c0d5b425a20ec).Session, loginData);
};
const $9c41c53e999a77b0$export$f66bc3d755e0fe90 = ()=>{
    (0, $72b598b09e32bbcf$export$2e2bcd8739ae039).remove((0, $0badf5665deea2b2$export$25c0d5b425a20ec).Session);
};


class $72b598b09e32bbcf$var$Storage {
    get(key, defaultValue = '') {
        if (typeof window !== 'undefined') {
            const value = localStorage.getItem(key);
            if (value) return JSON.parse(value);
            return defaultValue;
        }
        return false;
    }
    set(key, value) {
        if (typeof window !== 'undefined') {
            const valueToStr = JSON.stringify(value || '');
            localStorage.setItem(key, valueToStr);
        }
    }
    remove(key) {
        if (typeof window !== 'undefined') localStorage.removeItem(key);
    }
    removeAll() {
        if (typeof window !== 'undefined') localStorage.clear();
    }
}
const $72b598b09e32bbcf$var$storage = new $72b598b09e32bbcf$var$Storage();
var $72b598b09e32bbcf$export$2e2bcd8739ae039 = $72b598b09e32bbcf$var$storage;


const $18588a518ac6fdc7$export$2ac00d7098bf223 = (screenSize)=>screenSize === 'small' || screenSize === 'xsmall';
const $18588a518ac6fdc7$export$34a848fd9af39cb = (screenSize)=>screenSize === 'medium';
const $18588a518ac6fdc7$export$1bc9b22fe8fe3ea9 = (param)=>parseInt(param?.replace(/[^0-9]/g, '') || '');
const $18588a518ac6fdc7$export$5efb213c26c6e236 = (params = [])=>params.map((param)=>Number.isNaN(param)).reduce((isAllInvalid, isParamInvalid)=>isParamInvalid ? true : isAllInvalid, false);





const $28a8a7ab0535f0b3$var$allClientsOption = {
    label: 'All Clients',
    value: 0
};
class $28a8a7ab0535f0b3$export$2e2bcd8739ae039 extends (0, $c0c39e1b1209be87$export$2e2bcd8739ae039) {
    defaultClientOptions = [];
    clientOptions;
    selectedClient;
    _selectedClientId;
    // activeClient?: Client;
    _activeClientId;
    reportingPeriods = [];
    reportingPeriodOptions;
    reportingPeriodsClientId;
    selectedReportingPeriod;
    constructor(rootStore){
        super(rootStore);
        (0, $herDu.makeObservable)(this, {
            defaultClientOptions: (0, $herDu.observable),
            clientOptions: (0, $herDu.observable),
            selectedClient: (0, $herDu.observable),
            _selectedClientId: (0, $herDu.observable),
            // activeClient: observable,
            _activeClientId: (0, $herDu.observable),
            reportingPeriods: (0, $herDu.observable),
            reportingPeriodOptions: (0, $herDu.observable),
            reportingPeriodsClientId: (0, $herDu.observable),
            selectedReportingPeriod: (0, $herDu.observable),
            nextReportingPeriod: (0, $herDu.computed),
            previousReportingPeriod: (0, $herDu.computed),
            selectedClientId: (0, $herDu.computed),
            selectedClientName: (0, $herDu.computed),
            selectedClientUsers: (0, $herDu.computed),
            restoreSelectedClientId: (0, $herDu.action),
            restoreActiveClientId: (0, $herDu.action),
            filterClientOptions: (0, $herDu.action),
            fetchClientOptions: (0, $herDu.action),
            setSelectedClient: (0, $herDu.action),
            setSelectedClientId: (0, $herDu.action),
            // setActiveClient: action,
            setActiveClientId: (0, $herDu.action),
            setClientOptions: (0, $herDu.action),
            setDefaultClientOptions: (0, $herDu.action),
            setReportingPeriods: (0, $herDu.action),
            setReportingPeriodOptions: (0, $herDu.action),
            setReportingPeriodsClientId: (0, $herDu.action),
            setSelectedReportingPeriod: (0, $herDu.action),
            fetchClientReportingPeriods: (0, $herDu.action)
        });
    }
    get nextReportingPeriod() {
        const index = this.reportingPeriods.findIndex((period)=>period.id === this.selectedReportingPeriod?.id);
        if (typeof index === 'number') return this.reportingPeriods[index - 1];
    }
    get previousReportingPeriod() {
        const index = this.reportingPeriods.findIndex((period)=>period.id === this.selectedReportingPeriod?.id);
        if (typeof index === 'number') return this.reportingPeriods[index + 1];
    }
    get allClientsOption() {
        return {
            label: 'All Clients',
            value: 0
        };
    }
    get selectedClientName() {
        return this.selectedClient?.name;
    }
    get selectedClientUsers() {
        return this.selectedClient?.users;
    }
    get selectedClientId() {
        if (!this._selectedClientId) this.restoreSelectedClientId();
        return this._selectedClientId;
    }
    set selectedClientId(selectedClientId) {
        this._selectedClientId = selectedClientId;
    }
    get activeClient() {
        return this.rootStore.userStore.getUserClient(this.activeClientId);
    }
    get activeClientId() {
        if (!this._activeClientId) this.restoreActiveClientId();
        return this._activeClientId;
    }
    restoreSelectedClientId = ()=>{
        const value = (0, $72b598b09e32bbcf$export$2e2bcd8739ae039).get((0, $0badf5665deea2b2$export$25c0d5b425a20ec).SelectedClientID);
        this._selectedClientId = typeof value === 'number' ? value : undefined;
    };
    restoreActiveClientId = ()=>{
        const value = (0, $72b598b09e32bbcf$export$2e2bcd8739ae039).get((0, $0badf5665deea2b2$export$25c0d5b425a20ec).ActiveClientId);
        this._activeClientId = typeof value === 'number' ? value : undefined;
    };
    filterClientOptions = (nameFilter)=>{
        this.clientOptions = (0, $00658ccd6ec0135a$export$b5513415b3f92e76)(nameFilter, this.defaultClientOptions);
    };
    fetchClientOptions = async ()=>{
        const userStore = this.rootStore.userStore;
        if (!userStore.user) return;
        const clientNames = userStore.user?.role.is_internal ? await (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).listClientNames() : userStore.user?.clients ?? [];
        let options = clientNames.map(({ name: name, id: id })=>({
                label: name,
                value: id
            }));
        if (userStore.isFuseAdmin) options = [
            $28a8a7ab0535f0b3$var$allClientsOption,
            ...options
        ];
        this.setClientOptions(options);
        this.setDefaultClientOptions(options);
        if (options.length && !this.selectedClientId) this.selectedClientId = options[0]?.value;
    };
    setClientOptions = (options)=>{
        this.clientOptions = options;
        if (options.length && !this.selectedClientId) this.selectedClientId = options[0]?.value;
    };
    setDefaultClientOptions = (options)=>{
        this.defaultClientOptions = options;
    };
    setSelectedClient = (client)=>{
        this.selectedClient = client;
    };
    setSelectedClientId = (clientId)=>{
        this._selectedClientId = clientId;
    };
    // setActiveClient = (client?: Client) => {
    //   this.activeClient = client;
    //   this.setActiveClientId(client?.id);
    // };
    setActiveClientId = (clientId)=>{
        this._activeClientId = clientId;
        (0, $72b598b09e32bbcf$export$2e2bcd8739ae039).set((0, $0badf5665deea2b2$export$25c0d5b425a20ec).ActiveClientId, clientId);
    };
    setReportingPeriods = (reportingPeriods)=>{
        this.reportingPeriods = reportingPeriods ?? [];
    };
    setReportingPeriodOptions = (reportingPeriodOptions)=>{
        this.reportingPeriodOptions = reportingPeriodOptions;
    };
    setReportingPeriodsClientId = (clientId)=>{
        this.reportingPeriodsClientId = clientId;
    };
    setSelectedReportingPeriod = (selectedReportingPeriod)=>{
        this.selectedReportingPeriod = selectedReportingPeriod;
    };
    fetchClientReportingPeriods = async (clientId, reportingPeriodTypeId, showAll, hideLocked, programId, fullClientLoad)=>{
        if (!this.rootStore.userStore.user) return [];
        if (!programId && !fullClientLoad) return [];
        const baseRequest = {
            client_id: clientId,
            limit: 1000,
            reporting_period_type_id: reportingPeriodTypeId
        };
        if (!showAll) baseRequest.is_finalized = (0, $0badf5665deea2b2$export$1e617fb43dd54874).NotFinalized;
        if (hideLocked) baseRequest.is_client_locked = (0, $0badf5665deea2b2$export$cf1043bb7509db30).NotLocked;
        try {
            const response = fullClientLoad ? await (0, $37f79218b8708603$export$225d8bcca10eefa2).listForClient(baseRequest) : await (0, $37f79218b8708603$export$225d8bcca10eefa2).list({
                ...baseRequest,
                program_id: programId
            });
            const data = response.data;
            const options = data.map((period)=>({
                    label: period.reporting_period_type_id === 1 ? (0, $00658ccd6ec0135a$export$e774cbf6b137c816)(period.start_reporting_quarter) : period.start_reporting_quarter.slice(0, 4),
                    value: period.start_reporting_quarter
                }));
            this.setReportingPeriods(data);
            this.setReportingPeriodOptions(options);
            this.setReportingPeriodsClientId(clientId);
            return data;
        } catch (error) {
            console.error('Error fetching client reporting periods:', error);
            return [];
        }
    };
}



var $herDu = parcelRequire("herDu");




const $03d7a5c50d97fb14$var$toNumber = (value)=>value ? parseFloat(value.toString()) : 0;
const $03d7a5c50d97fb14$var$mergeCombinedAdminDashboards = (usa, canada)=>({
        kwh_consumed: $03d7a5c50d97fb14$var$toNumber(usa.kwh_consumed) + $03d7a5c50d97fb14$var$toNumber(canada.kwh_consumed),
        mt_cO2e_displaced: $03d7a5c50d97fb14$var$toNumber(usa.mt_cO2e_displaced) + $03d7a5c50d97fb14$var$toNumber(canada.mt_cO2e_displaced),
        total_recs_required: ($03d7a5c50d97fb14$var$toNumber(usa.total_recs_required) + $03d7a5c50d97fb14$var$toNumber(canada.total_recs_required)).toFixed(2),
        num_enrolled_equipment: usa.num_enrolled_equipment + canada.num_enrolled_equipment,
        days_to_next_credit_minting: usa.days_to_next_credit_minting,
        reporting_period_type_id: usa.reporting_period_type_id,
        total_net_revenue: '0',
        average_dollar_per_kwh: '0',
        percent_revenue_per_equipment_category: [],
        percent_revenue_per_program: [],
        reporting_periods: [],
        facilities: [],
        countries: [
            {
                country_id: (0, $0badf5665deea2b2$export$b77c37614753bffb).USA,
                currency_code: 'USD',
                total_net_revenue: usa.total_net_revenue,
                average_dollar_per_kwh: usa.average_dollar_per_kwh,
                percent_revenue_per_program: usa.percent_revenue_per_program,
                percent_revenue_per_equipment_category: usa.percent_revenue_per_equipment_category
            },
            {
                country_id: (0, $0badf5665deea2b2$export$b77c37614753bffb).Canada,
                currency_code: 'CAD',
                total_net_revenue: canada.total_net_revenue,
                average_dollar_per_kwh: canada.average_dollar_per_kwh,
                percent_revenue_per_program: canada.percent_revenue_per_program,
                percent_revenue_per_equipment_category: canada.percent_revenue_per_equipment_category
            }
        ]
    });
class $03d7a5c50d97fb14$export$2e2bcd8739ae039 extends (0, $c0c39e1b1209be87$export$2e2bcd8739ae039) {
    dashboardData;
    defaultCountry = (0, $0badf5665deea2b2$export$bdfc9528aeaa6307).USA;
    constructor(rootStore){
        super(rootStore);
        (0, $herDu.makeObservable)(this, {
            dashboardData: (0, $herDu.observable),
            defaultCountry: (0, $herDu.observable),
            setDashboardData: (0, $herDu.action),
            clearDashboardData: (0, $herDu.action),
            getAdminView: (0, $herDu.action),
            getCombinedAdminView: (0, $herDu.action),
            getClientView: (0, $herDu.action)
        });
    }
    setDashboardData = (dashboardData)=>{
        this.dashboardData = dashboardData;
    };
    clearDashboardData = ()=>{
        this.dashboardData = undefined;
    };
    getAdminView = async (country = this.defaultCountry)=>{
        if (!this.rootStore.userStore.isAdminUser) return;
        const dashboardData = await (0, $1cc8a6e678e39737$export$e198101443caf8af).getAdminView({
            country: country.toLowerCase()
        });
        this.setDashboardData({
            client_id: 0,
            ...dashboardData
        });
    };
    getCombinedAdminView = async ()=>{
        if (!this.rootStore.userStore.isAdminUser) return;
        const [usa, canada] = await Promise.all([
            (0, $1cc8a6e678e39737$export$e198101443caf8af).getAdminView({
                country: (0, $0badf5665deea2b2$export$bdfc9528aeaa6307).USA
            }),
            (0, $1cc8a6e678e39737$export$e198101443caf8af).getAdminView({
                country: (0, $0badf5665deea2b2$export$bdfc9528aeaa6307).Canada
            })
        ]);
        this.setDashboardData({
            client_id: 0,
            ...$03d7a5c50d97fb14$var$mergeCombinedAdminDashboards(usa, canada)
        });
    };
    getClientView = async (clientId)=>{
        if (!this.rootStore.userStore.user || this.rootStore.userStore.isExternalUser && !(0, $2e4d07611f552ce8$export$7bfc8d23d9761690)(this.rootStore.userStore.user, clientId)) return;
        const dashboardData = await (0, $1cc8a6e678e39737$export$e198101443caf8af).getClientView({
            client_id: clientId
        });
        this.setDashboardData({
            client_id: clientId,
            ...dashboardData
        });
    };
}




var $herDu = parcelRequire("herDu");


class $ab4a6d5758e27442$export$228f07cb35da672b {
    /**
   * List Charging Networks
   * @returns ChargingNetwork[]
   * @throws ApiError
   */ static listChargingNetworks() {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/chargingNetworks'
        });
    }
    /**
   * Create Charging Network
   * @returns ChargingNetwork
   * @throws ApiError
   */ static create(data) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/chargingNetworks',
            body: data
        });
    }
}



class $2955a8122ceaa8f4$export$13b01c6196094ffc {
    /**
   * List Charging Type
   * @returns ChargingType[]
   * @throws ApiError
   */ static listChargingTypes() {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/chargingTypes'
        });
    }
}



class $cfcb3cb7def4b952$export$dfb92ceb222acf8e {
    /**
   * List Equipment Use Cases
   * @returns EquipmentUseCase[]
   * @throws ApiError
   */ static listEquipmentUseCases() {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/equipmentUseCases'
        });
    }
}



class $4d14ac2f251954cc$export$b155df3a3f128ba4 {
    /**
   * List Forklift Classifications
   * @returns ForkliftClassifications[]
   * @throws ApiError
   */ static listForkliftClassifications() {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/forkliftClassifications'
        });
    }
}






class $17e7d70dd4c4d3ca$export$2e2bcd8739ae039 extends (0, $c0c39e1b1209be87$export$2e2bcd8739ae039) {
    // Equipment
    equipment;
    equipmentCategories;
    equipmentList;
    equipmentListMeta;
    equipmentUsagesList;
    equipmentUsagesListMeta;
    facilityEquipmentUsagesList;
    facilityEquipmentUsagesListMeta;
    meteredEquipmentList;
    meteredEquipmentListMeta;
    // FSE Registration Statuses
    fseRegistrationStatuses;
    // Charging Networks
    chargingNetworks;
    // Forklift Classifications
    forkliftClassifications;
    //Equipment Use Case
    equipmentUseCases;
    //Charging Type
    charingTypes;
    // Forms
    formValues = this.defaultFormValues;
    formErrors = {};
    constructor(rootStore){
        super(rootStore);
        (0, $herDu.makeObservable)(this, {
            equipment: (0, $herDu.observable),
            equipmentCategories: (0, $herDu.observable),
            equipmentList: (0, $herDu.observable),
            equipmentListMeta: (0, $herDu.observable),
            equipmentUsagesList: (0, $herDu.observable),
            equipmentUsagesListMeta: (0, $herDu.observable),
            facilityEquipmentUsagesList: (0, $herDu.observable),
            facilityEquipmentUsagesListMeta: (0, $herDu.observable),
            meteredEquipmentList: (0, $herDu.observable),
            meteredEquipmentListMeta: (0, $herDu.observable),
            fseRegistrationStatuses: (0, $herDu.observable),
            formValues: (0, $herDu.observable),
            formErrors: (0, $herDu.observable),
            defaultFormValues: (0, $herDu.computed),
            isApproved: (0, $herDu.computed)
        });
    }
    get defaultFormValues() {
        return {
            facility_id: NaN,
            category_name: '',
            equipment_category_id: NaN,
            equipment_type_id: undefined,
            unit_number: '',
            serial_number: '',
            manufacturer: '',
            model_number: '',
            model_year: '',
            is_metered: true,
            latitude: '',
            longitude: '',
            fse_registration_status_id: NaN,
            fse_id: '',
            fse_ru: '',
            comments: '',
            first_day_in_service: '',
            first_active_reporting_quarter: '',
            nameplate_rating_kw: null,
            last_active_reporting_quarter: null,
            charging_network_id: null,
            forklift_classification_id: null,
            equipment_use_case_id: null,
            charging_type_id: null
        };
    }
    get isApproved() {
        return this.formValues.fse_registration_status_id === (0, $0badf5665deea2b2$export$2cc06ea48a9a0a41).Approved || this.formValues.fse_registration_status_id === (0, $0badf5665deea2b2$export$2cc06ea48a9a0a41).Paused;
    }
    /**
   * Forms
   */ setFormValues = (formValues)=>{
        (0, $herDu.runInAction)(()=>{
            this.formValues = formValues;
        });
    };
    setFormErrors = (formErrors)=>{
        (0, $herDu.runInAction)(()=>{
            this.formErrors = formErrors;
        });
    };
    updateFormValue = (key, value)=>{
        this.setFormValues({
            ...this.formValues,
            [key]: value
        });
        if (this.formErrors[key]) this.setFormErrors({
            ...this.formErrors,
            [key]: ''
        });
    };
    resetForm = ()=>{
        this.setFormValues(this.defaultFormValues);
        this.setFormErrors({});
    };
    /**
   * CRUD
   */ listEquipment = async (facilityId)=>{
        if (!this.rootStore.userStore.user) return;
        const { meta: meta, data: data } = await (0, $64087c41a5036744$export$f3cdcae448e94402).list({
            facility_id: facilityId
        });
        (0, $herDu.runInAction)(()=>{
            this.equipmentList = data;
            this.equipmentListMeta = meta;
        });
    };
    fetchEquipment = async (id)=>{
        if (!this.rootStore.userStore.user) return;
        const equipment = await (0, $64087c41a5036744$export$f3cdcae448e94402).get({
            id: id
        });
        (0, $herDu.runInAction)(()=>{
            this.equipment = equipment;
        });
        return equipment;
    };
    fetchEquipmentCategories = async (programId)=>{
        if (!this.rootStore.userStore.user) return;
        const categories = await (0, $d17911beca13351e$export$63e6e4d9a672e282).listEquipmentCategories({
            program_id: programId
        });
        (0, $herDu.runInAction)(()=>{
            this.equipmentCategories = categories;
        });
        return categories;
    };
    listMeteredEquipment = async (facilityId)=>{
        if (!this.rootStore.userStore.user) return;
        const { meta: meta, data: data } = await (0, $64087c41a5036744$export$f3cdcae448e94402).list({
            facility_id: facilityId
        });
        (0, $herDu.runInAction)(()=>{
            this.meteredEquipmentListMeta = meta;
            this.meteredEquipmentList = data;
        });
        return data;
    };
    fetchFSERegistrationStatuses = async ()=>{
        if (!this.rootStore.userStore.user) return;
        const data = await (0, $d6dddabef9527262$export$47f5a8b2675bf9f0).listFSERegistrationStatuses();
        (0, $herDu.runInAction)(()=>{
            this.fseRegistrationStatuses = data;
        });
    };
    fetchChargingNetworks = async ()=>{
        if (!this.rootStore.userStore.user) return;
        const data = await (0, $ab4a6d5758e27442$export$228f07cb35da672b).listChargingNetworks();
        (0, $herDu.runInAction)(()=>{
            this.chargingNetworks = data;
        });
    };
    fetchForkliftClassifications = async ()=>{
        if (!this.rootStore.userStore.user) return;
        const data = await (0, $4d14ac2f251954cc$export$b155df3a3f128ba4).listForkliftClassifications();
        (0, $herDu.runInAction)(()=>{
            this.forkliftClassifications = data;
        });
    };
    fetchEquipmentUseCases = async ()=>{
        if (!this.rootStore.userStore.user) return;
        const data = await (0, $cfcb3cb7def4b952$export$dfb92ceb222acf8e).listEquipmentUseCases();
        (0, $herDu.runInAction)(()=>{
            this.equipmentUseCases = data;
        });
    };
    fetchChargingTypes = async ()=>{
        if (!this.rootStore.userStore.user) return;
        const data = await (0, $2955a8122ceaa8f4$export$13b01c6196094ffc).listChargingTypes();
        (0, $herDu.runInAction)(()=>{
            this.charingTypes = data;
        });
    };
    clearMeteredEquipment = ()=>{
        (0, $herDu.runInAction)(()=>{
            this.meteredEquipmentList = undefined;
            this.meteredEquipmentListMeta = undefined;
        });
    };
    /**
   * Create Equipment - Internal Users
   *
   * @param facility Facility this Equipment belongs to.
   * @param formValues Equipment data.
   * @returns Promise<void>
   */ createEquipmentInternal = async (facility)=>{
        if (!this.rootStore.userStore.isInternalUser) return;
        const formFields = {
            facility_id: {
                label: 'Facility',
                required: true
            },
            category_name: {
                label: 'Equipment category',
                required: true
            },
            equipment_type_id: {
                label: 'Equipment type',
                required: true
            },
            unit_number: {
                label: 'Unit number',
                max: 100
            },
            serial_number: {
                label: 'Serial number',
                max: 50,
                required: true
            },
            manufacturer: {
                label: 'Manufacturer',
                max: 100,
                required: true
            },
            model_number: {
                label: 'Model number',
                max: 50
            },
            model_year: {
                label: 'Model year',
                minValue: 1900,
                maxValue: 3000,
                required: true
            },
            latitude: {
                label: 'Latitude',
                required: true
            },
            longitude: {
                label: 'Longitude',
                required: true
            },
            fse_registration_status_id: {
                label: 'FSE registration status',
                required: true
            },
            first_active_reporting_quarter: {
                label: 'First Reporting Period',
                required: true
            },
            fse_ru: {
                label: 'FSE RU',
                max: 100
            },
            comments: {
                label: 'Comments',
                max: 500
            }
        };
        if (facility.program?.id === 1 && this.formValues.equipment_category_id === 5) formFields.forklift_classification_id = {
            label: 'Forklift Classification',
            required: true
        };
        if (facility.program?.id === 4 || facility.program?.id === 5) {
            formFields.equipment_use_case_id = {
                label: 'Equipment Use Case',
                required: true
            };
            formFields.charging_type_id = {
                label: 'Charging Type',
                required: true
            };
        }
        if ((0, $acc57f855dc3e03c$export$e8efcaf51aaf349d)(this.formValues.equipment_category_id)) formFields.nameplate_rating_kw = {
            label: 'Nameplate Rating (kW)',
            required: true,
            minValue: 0,
            maxValue: 9999.99
        };
        const facilityRegionCode = facility.address_region?.short_code?.toLowerCase();
        if (facilityRegionCode === 'or' || facilityRegionCode === 'wa') {
            const nextPeriodStartDate = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(this.formValues.first_active_reporting_quarter).add(3, 'months').format('YYYY-MM-DD');
            formFields.first_day_in_service = {
                label: 'First day in service',
                required: true,
                before: nextPeriodStartDate
            };
        }
        if (this.isApproved) formFields.fse_id = {
            label: 'FSE ID',
            max: 50,
            required: true
        };
        if (this.formValues.is_metered) formFields.charging_network_id = {
            label: 'Charging network',
            required: true
        };
        const errors = (0, $084681c8221d0a24$export$5fafec8d1b047c0)(formFields, this.formValues);
        if (errors) {
            this.setFormErrors(errors);
            return;
        }
        const newEquipment = {
            facility_id: this.formValues.facility_id ?? 0,
            equipment_type_id: this.formValues.equipment_type_id ?? 0,
            unit_number: this.formValues.unit_number || null,
            serial_number: this.formValues.serial_number,
            manufacturer: this.formValues.manufacturer,
            model_number: this.formValues.model_number || null,
            model_year: parseInt(this.formValues.model_year),
            is_metered: this.formValues.is_metered,
            latitude: parseFloat(this.formValues.latitude).toFixed(6),
            longitude: parseFloat(this.formValues.longitude).toFixed(6),
            fse_registration_status_id: this.formValues.fse_registration_status_id,
            fse_id: this.formValues.fse_id || null,
            fse_ru: this.formValues.fse_ru || null,
            comments: this.formValues.comments || null,
            first_day_in_service: this.formValues.first_day_in_service || null,
            first_active_reporting_quarter: this.formValues.first_active_reporting_quarter || null,
            charging_network_id: this.formValues.is_metered ? this.formValues.charging_network_id || null : null,
            equipment_use_case_id: this.formValues.equipment_use_case_id || null,
            charging_type_id: this.formValues.charging_type_id || null,
            nameplate_rating_kw: this.formValues.nameplate_rating_kw || null,
            forklift_classification_id: facility.program?.id === 1 && this.formValues.equipment_category_id === 5 ? this.formValues.forklift_classification_id : null
        };
        const result = await (0, $64087c41a5036744$export$f3cdcae448e94402).createInternal(newEquipment);
        return result;
    };
    /**
   * Create Equipment - External Users
   *
   * @param facility Facility this Equipment belongs to.
   * @param formValues Equipment data.
   * @returns Promise<void>
   */ createEquipmentExternal = async (facility)=>{
        if (!this.rootStore.userStore.isExternalUser) return;
        const formFields = {
            facility_id: {
                label: 'Facility',
                required: true
            },
            equipment_type_id: {
                label: 'Equipment type',
                required: true
            },
            category_name: {
                label: 'Equipment category',
                required: true
            },
            unit_number: {
                label: 'Unit number',
                max: 100
            },
            serial_number: {
                label: 'Serial number',
                max: 50,
                required: true
            },
            manufacturer: {
                label: 'Manufacturer',
                max: 100,
                required: true
            },
            model_number: {
                label: 'Model number',
                max: 50
            },
            model_year: {
                label: 'Model year',
                minValue: 1900,
                maxValue: 3000,
                required: true
            },
            latitude: {
                label: 'Latitude',
                required: true
            },
            longitude: {
                label: 'Longitude',
                required: true
            },
            comments: {
                label: 'Comments',
                max: 500
            }
        };
        const facilityRegionCode = facility.address_region?.short_code?.toLowerCase();
        if (facilityRegionCode === 'or' || facilityRegionCode === 'wa') {
            const nextPeriodStartDate = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(this.formValues.first_active_reporting_quarter).add(3, 'months').format('YYYY-MM-DD');
            formFields.first_day_in_service = {
                label: 'First day in service',
                required: true,
                before: nextPeriodStartDate
            };
        }
        if ((0, $acc57f855dc3e03c$export$e8efcaf51aaf349d)(this.formValues.equipment_category_id)) formFields.nameplate_rating_kw = {
            label: 'Nameplate Rating (kW)',
            required: true,
            minValue: 0,
            maxValue: 9999.99
        };
        if (this.formValues.is_metered) formFields.charging_network_id = {
            label: 'Charging network',
            required: true
        };
        const errors = (0, $084681c8221d0a24$export$5fafec8d1b047c0)(formFields, this.formValues);
        if (errors) {
            this.setFormErrors(errors);
            return;
        }
        const newEquipment = {
            facility_id: this.formValues.facility_id ?? -1,
            equipment_type_id: this.formValues.equipment_type_id ?? -1,
            unit_number: this.formValues.unit_number || null,
            serial_number: this.formValues.serial_number,
            manufacturer: this.formValues.manufacturer,
            model_number: this.formValues.model_number || null,
            model_year: parseInt(this.formValues.model_year),
            first_active_reporting_quarter: this.formValues.first_active_reporting_quarter || null,
            first_day_in_service: this.formValues.first_day_in_service || null,
            is_metered: this.formValues.is_metered,
            latitude: parseFloat(this.formValues.latitude).toFixed(6),
            longitude: parseFloat(this.formValues.longitude).toFixed(6),
            comments: this.formValues.comments || null,
            charging_network_id: this.formValues.is_metered ? this.formValues.charging_network_id || null : null,
            equipment_use_case_id: this.formValues.equipment_use_case_id || null,
            charging_type_id: this.formValues.charging_type_id || null,
            nameplate_rating_kw: this.formValues.nameplate_rating_kw || null,
            forklift_classification_id: this.formValues.forklift_classification_id || null
        };
        return await (0, $64087c41a5036744$export$f3cdcae448e94402).createExternal(newEquipment);
    };
    /**
   * Update Non-Finalized Equipment - Internal Users
   */ updateNonFinalizedInternal = async (equipment)=>{
        if (!this.rootStore.userStore.isInternalUser) return;
        const formFields = {
            category_name: {
                label: 'Equipment category',
                required: true
            },
            equipment_type_id: {
                label: 'Equipment type',
                required: true
            },
            unit_number: {
                label: 'Unit number',
                max: 100
            },
            serial_number: {
                label: 'Serial number',
                max: 50,
                required: true
            },
            manufacturer: {
                label: 'Manufacturer',
                max: 100,
                required: true
            },
            model_number: {
                label: 'Model number',
                max: 50
            },
            model_year: {
                label: 'Model year',
                minValue: 1900,
                maxValue: 3000,
                required: true
            },
            first_active_reporting_quarter: {
                label: 'First reporting period',
                required: true
            },
            latitude: {
                label: 'Latitude',
                required: true
            },
            longitude: {
                label: 'Longitude',
                required: true
            },
            fse_registration_status_id: {
                label: 'FSE registration status',
                required: true
            },
            fse_ru: {
                label: 'FSE RU',
                max: 100
            },
            comments: {
                label: 'Comments',
                max: 500
            }
        };
        if ((0, $acc57f855dc3e03c$export$e8efcaf51aaf349d)(this.formValues.equipment_category_id)) formFields.nameplate_rating_kw = {
            label: 'Nameplate Rating (kW)',
            required: true,
            minValue: 0,
            maxValue: 9999.99
        };
        if (this.isApproved) formFields.fse_id = {
            label: 'FSE ID',
            max: 50,
            required: true
        };
        if (this.formValues.is_metered) formFields.charging_network_id = {
            label: 'Charging network',
            required: true
        };
        const facilityRegionCode = equipment.facility?.address_region?.short_code?.toLowerCase();
        if (facilityRegionCode === 'or' || facilityRegionCode === 'wa') {
            const nextPeriodStartDate = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(this.formValues.first_active_reporting_quarter).add(3, 'months').format('YYYY-MM-DD');
            formFields.first_day_in_service = {
                label: 'First day in service',
                required: true,
                before: nextPeriodStartDate
            };
        }
        const errors = (0, $084681c8221d0a24$export$5fafec8d1b047c0)(formFields, this.formValues);
        if (errors) {
            this.setFormErrors(errors);
            return;
        }
        this.setFormErrors({});
        const updatedEquipment = {
            id: equipment.id,
            equipment_type_id: this.formValues.equipment_type_id ?? -1,
            unit_number: this.formValues.unit_number || null,
            serial_number: this.formValues.serial_number,
            manufacturer: this.formValues.manufacturer,
            model_number: this.formValues.model_number || null,
            model_year: parseInt(this.formValues.model_year),
            first_active_reporting_quarter: this.formValues.first_active_reporting_quarter || null,
            first_day_in_service: this.formValues.first_day_in_service || null,
            is_metered: this.formValues.is_metered,
            latitude: parseFloat(this.formValues.latitude).toFixed(6),
            longitude: parseFloat(this.formValues.longitude).toFixed(6),
            fse_registration_status_id: this.formValues.fse_registration_status_id,
            fse_id: this.formValues.fse_id || null,
            fse_ru: this.formValues.fse_ru || null,
            comments: this.formValues.comments || null,
            charging_network_id: this.formValues.is_metered ? this.formValues.charging_network_id || null : null,
            equipment_use_case_id: this.formValues.equipment_use_case_id || null,
            charging_type_id: this.formValues.charging_type_id || null,
            nameplate_rating_kw: this.formValues.nameplate_rating_kw || null,
            forklift_classification_id: this.formValues.forklift_classification_id || null
        };
        return await (0, $64087c41a5036744$export$f3cdcae448e94402).updateNonFinalizedInternal(updatedEquipment);
    };
    /**
   * Update Finalized Equipment - Internal Users
   */ updateFinalizedInternal = async (equipmentId)=>{
        if (!this.rootStore.userStore.isInternalUser) return;
        const formFields = {
            latitude: {
                label: 'Latitude',
                required: true
            },
            longitude: {
                label: 'Longitude',
                required: true
            },
            unit_number: {
                label: 'Unit number',
                max: 100
            },
            comments: {
                label: 'Comments',
                max: 500
            },
            nameplate_rating_kw: {
                label: 'Nameplate Rating (kW)',
                minValue: 0,
                maxValue: 9999.99
            }
        };
        const errors = (0, $084681c8221d0a24$export$5fafec8d1b047c0)(formFields, this.formValues);
        if (errors) {
            this.setFormErrors(errors);
            return;
        }
        return await (0, $64087c41a5036744$export$f3cdcae448e94402).updateFinalizedInternal({
            id: equipmentId,
            latitude: parseFloat(this.formValues.latitude).toFixed(6),
            longitude: parseFloat(this.formValues.longitude).toFixed(6),
            unit_number: this.formValues.unit_number || null,
            comments: this.formValues.comments || null
        });
    };
    /**
   * Update Pending Equipment - External Users
   */ updatePendingExternal = async (equipment)=>{
        if (!this.rootStore.userStore.isExternalUser) return;
        const formFields = {
            category_name: {
                label: 'Equipment category',
                required: true
            },
            equipment_type_id: {
                label: 'Equipment type',
                required: true
            },
            unit_number: {
                label: 'Unit number',
                max: 100
            },
            serial_number: {
                label: 'Serial number',
                max: 50,
                required: true
            },
            manufacturer: {
                label: 'Manufacturer',
                max: 100,
                required: true
            },
            model_number: {
                label: 'Model number',
                max: 50
            },
            model_year: {
                label: 'Model year',
                minValue: 1900,
                maxValue: 3000,
                required: true
            },
            first_active_reporting_quarter: {
                label: 'First reporting period',
                required: true
            },
            latitude: {
                label: 'Latitude',
                required: true
            },
            longitude: {
                label: 'Longitude',
                required: true
            },
            comments: {
                label: 'Comments',
                max: 500
            }
        };
        if ((0, $acc57f855dc3e03c$export$e8efcaf51aaf349d)(this.formValues.equipment_category_id)) formFields.nameplate_rating_kw = {
            label: 'Nameplate Rating (kW)',
            required: true,
            minValue: 0,
            maxValue: 9999.99
        };
        const facilityRegionCode = equipment.facility?.address_region?.short_code?.toLowerCase();
        if (facilityRegionCode === 'or' || facilityRegionCode === 'wa') {
            const nextPeriodStartDate = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(this.formValues.first_active_reporting_quarter).add(3, 'months').format('YYYY-MM-DD');
            formFields.first_day_in_service = {
                label: 'First day in service',
                required: true,
                before: nextPeriodStartDate
            };
        }
        if (this.formValues.is_metered) formFields.charging_network_id = {
            label: 'Charging network',
            required: true
        };
        const errors = (0, $084681c8221d0a24$export$5fafec8d1b047c0)(formFields, this.formValues);
        if (errors) {
            this.setFormErrors(errors);
            return;
        }
        this.setFormErrors({});
        const updatedEquipment = {
            id: equipment.id,
            equipment_type_id: this.formValues.equipment_type_id ?? -1,
            unit_number: this.formValues.unit_number || null,
            serial_number: this.formValues.serial_number,
            manufacturer: this.formValues.manufacturer,
            model_number: this.formValues.model_number || null,
            model_year: parseInt(this.formValues.model_year),
            first_active_reporting_quarter: this.formValues.first_active_reporting_quarter || null,
            first_day_in_service: this.formValues.first_day_in_service || null,
            is_metered: this.formValues.is_metered,
            latitude: parseFloat(this.formValues.latitude).toFixed(6),
            longitude: parseFloat(this.formValues.longitude).toFixed(6),
            comments: this.formValues.comments || null,
            charging_network_id: this.formValues.is_metered ? this.formValues.charging_network_id || null : null,
            equipment_use_case_id: this.formValues.equipment_use_case_id || null,
            charging_type_id: this.formValues.charging_type_id || null,
            nameplate_rating_kw: this.formValues.nameplate_rating_kw || null,
            forklift_classification_id: this.formValues.forklift_classification_id || null
        };
        return await (0, $64087c41a5036744$export$f3cdcae448e94402).updatePendingExternal(updatedEquipment);
    };
    /**
   * Update Non-Pending Equipment - External Users
   */ updateNonPendingExternal = async (equipmentId)=>{
        if (!this.rootStore.userStore.isExternalUser) return;
        const formFields = {
            latitude: {
                label: 'Latitude',
                required: true
            },
            longitude: {
                label: 'Longitude',
                required: true
            },
            unit_number: {
                label: 'Unit number',
                max: 100
            },
            comments: {
                label: 'Comments',
                max: 500
            },
            nameplate_rating_kw: {
                label: 'Nameplate Rating (kW)',
                minValue: 0,
                maxValue: 9999.99
            }
        };
        const errors = (0, $084681c8221d0a24$export$5fafec8d1b047c0)(formFields, this.formValues);
        if (errors) {
            this.setFormErrors(errors);
            return;
        }
        return await (0, $64087c41a5036744$export$f3cdcae448e94402).updateNonPendingExternal({
            id: equipmentId,
            latitude: parseFloat(this.formValues.latitude).toFixed(6),
            longitude: parseFloat(this.formValues.longitude).toFixed(6),
            unit_number: this.formValues.unit_number || null,
            comments: this.formValues.comments || null
        });
    };
}



var $herDu = parcelRequire("herDu");


class $81801cf2aed93d2d$export$2e2bcd8739ae039 extends (0, $c0c39e1b1209be87$export$2e2bcd8739ae039) {
    // Equipment Usages
    equipmentUsages;
    equipmentUsagesRequest;
    equipmentUsagesMeta;
    facilityEquipmentUsages;
    facilityEquipmentUsagesRequest;
    facilityEquipmentUsagesMeta;
    // Fuel Pathways
    defaultFuelPathwayOptions = [];
    fuelPathwayOptions = [];
    fuelPathways;
    limit = 20;
    currentPage = 1;
    constructor(rootStore){
        super(rootStore);
        (0, $herDu.makeObservable)(this, {
            limit: (0, $herDu.observable),
            currentPage: (0, $herDu.observable),
            equipmentUsages: (0, $herDu.observable),
            equipmentUsagesRequest: (0, $herDu.observable),
            equipmentUsagesMeta: (0, $herDu.observable),
            facilityEquipmentUsages: (0, $herDu.observable),
            facilityEquipmentUsagesRequest: (0, $herDu.observable),
            facilityEquipmentUsagesMeta: (0, $herDu.observable),
            defaultFuelPathwayOptions: (0, $herDu.observable),
            fuelPathwayOptions: (0, $herDu.observable),
            fuelPathways: (0, $herDu.observable)
        });
    }
    setLimit = (limit)=>{
        (0, $herDu.runInAction)(()=>{
            this.limit = limit;
        });
    };
    setCurrentPage = (currentPage)=>{
        (0, $herDu.runInAction)(()=>{
            this.currentPage = currentPage;
        });
    };
    setFuelPathwayOptions = (options)=>{
        (0, $herDu.runInAction)(()=>{
            this.fuelPathwayOptions = options;
        });
    };
    setDefaultFuelPathwayOptions = (options)=>{
        (0, $herDu.runInAction)(()=>{
            this.defaultFuelPathwayOptions = options;
        });
    };
    setFuelPathways = (fuelPathways)=>{
        (0, $herDu.runInAction)(()=>{
            this.fuelPathways = fuelPathways;
        });
    };
    setEquipmentUsages = (equipmentUsages)=>{
        (0, $herDu.runInAction)(()=>{
            this.equipmentUsages = equipmentUsages;
        });
    };
    setEquipmentUsagesRequest = (equipmentUsagesRequest)=>{
        (0, $herDu.runInAction)(()=>{
            this.equipmentUsagesRequest = equipmentUsagesRequest;
        });
    };
    setEquipmentUsagesMeta = (equipmentUsagesMeta)=>{
        (0, $herDu.runInAction)(()=>{
            this.equipmentUsagesMeta = equipmentUsagesMeta;
        });
    };
    setFacilityEquipmentUsages = (equipmentUsages)=>{
        (0, $herDu.runInAction)(()=>{
            this.facilityEquipmentUsages = equipmentUsages;
        });
    };
    setFacilityEquipmentUsagesRequest = (equipmentUsagesRequest)=>{
        (0, $herDu.runInAction)(()=>{
            this.facilityEquipmentUsagesRequest = equipmentUsagesRequest;
        });
    };
    setFacilityEquipmentUsagesMeta = (equipmentUsagesMeta)=>{
        (0, $herDu.runInAction)(()=>{
            this.facilityEquipmentUsagesMeta = equipmentUsagesMeta;
        });
    };
    fetchFuelPathways = async (programId, regionId, startReportingQuarter, endReportingQuarter)=>{
        const pathways = await (0, $b0af269f4f630763$export$40b243bf31bf9421).list({
            program_id: programId,
            region_id: regionId,
            start_reporting_quarter: startReportingQuarter,
            end_reporting_quarter: endReportingQuarter
        });
        const pathwayOptions = pathways.map((p)=>({
                label: p.code,
                value: p.id
            }));
        this.setFuelPathways(pathways);
        this.setFuelPathwayOptions(pathwayOptions);
        this.setDefaultFuelPathwayOptions(pathwayOptions);
        return pathways;
    };
    listEquipmentUsages = async (request)=>{
        if (!this.rootStore.userStore.user) return;
        const { meta: meta, data: data } = await (0, $a5a0335c656802a5$export$89132588ea848e29).list(request);
        this.setFacilityEquipmentUsages(data);
        this.setFacilityEquipmentUsagesMeta(meta);
        return data;
    };
    getEquipmentUsage = async (request)=>{
        if (!this.rootStore.userStore.user) return;
        const equipmentUsage = await (0, $a5a0335c656802a5$export$89132588ea848e29).get(request);
        return equipmentUsage;
    };
    listEquipmentUsagesByFacility = async (request)=>{
        if (!this.rootStore.userStore.user) return;
        const { meta: meta, data: data } = await (0, $a5a0335c656802a5$export$89132588ea848e29).listByFacilityReportingPeriod(request);
        const allData = [
            ...data
        ];
        const shouldFetchAllPages = request.page === undefined;
        if (shouldFetchAllPages && meta) for(let page = meta.current_page + 1; page <= meta.last_page; page++){
            const { data: pageData } = await (0, $a5a0335c656802a5$export$89132588ea848e29).listByFacilityReportingPeriod({
                ...request,
                page: page,
                limit: meta.per_page
            });
            allData.push(...pageData);
        }
        allData.sort((a, b)=>(a.equipment_id ?? '') > (b.equipment_id ?? '') ? 1 : a.equipment_id === b.equipment_id ? 0 : -1);
        this.setFacilityEquipmentUsages(allData);
        this.setFacilityEquipmentUsagesMeta(meta);
        return allData;
    };
    /**
   * Update Multiple Metered Equipment Usages
   */ updateMultipleMeteredEquipmentUsages = async (request)=>{
        await (0, $a5a0335c656802a5$export$89132588ea848e29).updateMultipleMetered(request);
    };
    /**
   * Update Single Metered Equipment Usage
   */ updateMeteredEquipmentUsage = async (request)=>{
        if (this.rootStore.userStore.isInternalUser) await (0, $a5a0335c656802a5$export$89132588ea848e29).updateMeteredAsInternalUser(request);
        else {
            const externalRequest = {
                equipment_usage_id: request.equipment_usage_id,
                total_kwh: request.total_kwh,
                percent_uptime: request.percent_uptime || null,
                max_site_deliverability_kw: request.max_site_deliverability_kw || null
            };
            await (0, $a5a0335c656802a5$export$89132588ea848e29).updateMeteredAsExternalUser(externalRequest);
        }
    };
    /**
   * Update Multiple Unmetered Equipment Usages
   */ updateMultipleUnmeteredEquipmentUsages = async (request)=>{
        await (0, $a5a0335c656802a5$export$89132588ea848e29).updateMultipleUnmetered(request);
    };
    /**
   * Update Single Unmetered Equipment Usage
   */ updateUnmeteredEquipmentUsage = async (request)=>{
        if (this.rootStore.userStore.isInternalUser) await (0, $a5a0335c656802a5$export$89132588ea848e29).updateUnmeteredAsInternalUser(request);
        else await (0, $a5a0335c656802a5$export$89132588ea848e29).updateUnmeteredAsExternalUser(request);
    };
}



var $herDu = parcelRequire("herDu");


class $1aaee08d1fdcd860$export$2e2bcd8739ae039 extends (0, $c0c39e1b1209be87$export$2e2bcd8739ae039) {
    facility;
    facilities = [];
    facilitiesMetadata;
    facilityEquipmentUsages;
    facilityEquipmentUsagesMeta;
    limit = 20;
    currentPage = 1;
    constructor(rootStore){
        super(rootStore);
        (0, $herDu.makeObservable)(this, {
            facility: (0, $herDu.observable),
            facilities: (0, $herDu.observable),
            facilitiesMetadata: (0, $herDu.observable),
            facilityEquipmentUsages: (0, $herDu.observable),
            facilityEquipmentUsagesMeta: (0, $herDu.observable),
            limit: (0, $herDu.observable),
            currentPage: (0, $herDu.observable),
            setFacility: (0, $herDu.action),
            setFacilityEquipmentUsages: (0, $herDu.action),
            setFacilityEquipmentUsagesMeta: (0, $herDu.action),
            fetchFacility: (0, $herDu.action),
            fetchFacilities: (0, $herDu.action)
        });
    }
    setFacility = (facility)=>{
        this.facility = facility;
    };
    setFacilityEquipmentUsages = (equipmentUsages)=>{
        this.facilityEquipmentUsages = equipmentUsages;
    };
    setFacilityEquipmentUsagesMeta = (equipmentUsagesMeta)=>{
        this.facilityEquipmentUsagesMeta = equipmentUsagesMeta;
    };
    fetchFacility = async (facilityId)=>{
        if (!this.rootStore.userStore.user) return;
        const facility = await (0, $2f95a0926656d8e2$export$c270777027a9c841).get({
            id: facilityId
        });
        this.setFacility(facility);
        return facility;
    };
    fetchFacilities = async (clientId)=>{
        if (!this.rootStore.userStore.user) return;
        const { meta: meta, data: data } = clientId ? await (0, $2f95a0926656d8e2$export$c270777027a9c841).list({
            client_id: clientId,
            page: this.currentPage
        }) : await (0, $2f95a0926656d8e2$export$c270777027a9c841).listAll({});
        this.facilities = data;
        this.facilitiesMetadata = meta;
    };
}





var $herDu = parcelRequire("herDu");


class $aab6e7692a93396d$export$fec76eb589c20b4f {
    /**
   * List Referral Partners
   * @returns ReferralPartner[]
   * @throws ApiError
   */ static list() {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/referralPartners'
        });
    }
    /**
   * Create Referral Partner
   * @returns ReferralPartner
   * @throws ApiError
   */ static create(data) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/referralPartners',
            body: data
        });
    }
}



class $054fb6e98ac05e97$export$4dcb2623fe0a1f40 {
    /**
   * List Regions
   * @returns Region[] Region[]
   * @throws ApiError
   */ static listRegions() {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/regions'
        });
    }
}



const $d0d6382a5bdf6377$export$d8bd0967cb58683 = {
    // Used on RootErrorPage
    default: 'Something went wrong! Refresh the page to try again.',
    // Login
    invalidLogin: 'Invalid username or password',
    // Tokens
    invalidPasswordResetToken: 'This token is invalid or has expired. Please request a new token by clicking "Reset Password" on the Login page.',
    invalidVerifyEmailToken: 'This token is invalid or has expired. To request a new verification email, re-enter your new email address on your User Profile page.',
    // Searches
    clientNameSearchNoResult: 'No Companies found with that name.',
    fuelPathwayNameSearchNoResult: 'No fuel pathways found with that name.',
    // Passwords
    notCurrentPassword: 'Must provide current password',
    passwordNotConfirmed: 'Must confirm password',
    passwordNotEntered: 'Must enter password',
    passwordTooShort: 'Password must be at least 16 characters',
    passwordTooShortGeneric: 'Password must be longer',
    passwordsNotMatch: 'Passwords must match',
    invalidCurrentPassword: 'Invalid current password',
    passwordMinLength: 'Password must be at least 16 characters',
    passwordRequiresUppercase: 'Password must contain at least one uppercase letter',
    passwordRequiresLowercase: 'Password must contain at least one lowercase letter',
    passwordRequiresNumber: 'Password must contain at least one number',
    passwordRequiresSpecial: 'Password must contain at least one special character (!@#$%^&*)',
    passwordComplexityRequirements: 'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character (!@#$%^&*)'
};



const $a75b88ce77ba4923$export$40fb018dd4c59f8 = {
    generic: {
        loading: 'Loading...',
        success: 'Success.',
        error: ()=>'An error has occurred.'
    },
    // File Validation
    fileValidation: {
        loading: 'Validating file...',
        success: 'File is valid.',
        error: (err)=>err?.message || 'Invalid file format or content',
        invalidExcelFile: 'Please select an Excel (.xlsx) file',
        requiredFile: 'Please select a file first'
    },
    // Statements
    statements: {
        loading: 'Loading statements...',
        success: 'Statements loaded successfully.',
        error: ()=>'Could not load statements.'
    },
    // Forms
    formValidation: {
        loading: 'Validating...',
        success: 'Success.',
        error: (fieldName)=>`${fieldName} is required.`,
        requiredFields: 'Please fill in all required fields.',
        commissionTotal: 'Sales and referral commissions combined must not exceed 100%'
    },
    // Search
    search: {
        loading: 'Searching...',
        success: 'Search successful.',
        error: ()=>'There was an issue completing the search.'
    },
    // Change Logs
    fetchAuditLog: {
        loading: 'Loading change log...',
        success: 'Change log was loaded successfully.',
        error: ()=>'Could not load change log.'
    },
    listAuditLogs: {
        loading: 'Loading change logs list...',
        success: 'Change logs list was loaded successfully.',
        error: ()=>'Could not load change logs list.'
    },
    resolveAuditLog: {
        loading: 'Resolving change log...',
        success: 'Change log was marked as resolved.',
        error: ()=>'An error occurred while resolving log.'
    },
    resolveAuditLogs: {
        loading: 'Resolving change logs...',
        success: 'Change logs were marked as resolved.',
        error: ()=>'An error occurred while resolving logs.'
    },
    // Authentication
    login: {
        loading: 'Logging in...',
        success: 'Successfully logged in.',
        error: ()=>'There was an error logging in.'
    },
    logout: {
        loading: 'Logging out...',
        success: 'Successfully logged out.',
        error: ()=>'There was an error logging out.'
    },
    updatePassword: {
        loading: 'Updating password...',
        success: 'Password was updated successfully.',
        error: ()=>'Could not update password.'
    },
    resetPassword: {
        loading: 'Setting new password...',
        success: 'Password was updated successfully.',
        error: ()=>'Could not set new password.'
    },
    requestPasswordReset: {
        loading: 'Sending password reset email...',
        success: 'Password reset email sent successfully.',
        error: ()=>'Could not send password reset email.'
    },
    sessionExpired: {
        loading: 'Session expired...',
        success: 'Your session has expired. Please login again.',
        error: ()=>'Could not expire session.'
    },
    // Roles
    listRoles: {
        loading: 'Loading user roles...',
        success: 'Roles were loaded successfully.',
        error: ()=>'Could not load user roles.'
    },
    // Clients
    fetchClient: {
        loading: 'Loading Client...',
        success: 'Client was loaded successfully.',
        error: ()=>'Could not load Client.'
    },
    listClients: {
        loading: 'Loading Clients list...',
        success: 'Clients list was loaded successfully.',
        error: ()=>'Could not load Clients list.'
    },
    createClient: {
        loading: 'Creating Client...',
        success: 'Client was created successfully.',
        error: ()=>'Could not create Client.'
    },
    updateClient: {
        loading: 'Updating Client...',
        success: 'Client details updated successfully.',
        error: ()=>'Could not update Client.'
    },
    listClientReportingPeriods: {
        loading: 'Loading Client Reporting Periods list...',
        success: 'Client Reporting Periods list was loaded successfully.',
        error: ()=>'Could not load Client Reporting Periods list.'
    },
    retireClient: {
        loading: 'Retiring Client...',
        success: 'Client was retired successfully.',
        error: ()=>'Could not retire Client.'
    },
    // Commissions
    fetchCommission: {
        loading: 'Loading Commission...',
        success: 'Commission was loaded successfully.',
        error: ()=>'Could not load Commission.'
    },
    listCommissions: {
        loading: 'Loading Commissions list...',
        success: 'Commissions list was loaded successfully.',
        error: ()=>'Could not load Commissions list.'
    },
    createCommission: {
        loading: 'Creating Company...',
        success: 'Company was created successfully.',
        error: ()=>'Could not create Company.'
    },
    updateCommission: {
        loading: 'Updating Commission...',
        success: 'Commission was updated successfully.',
        error: ()=>'Could not update Commission.'
    },
    // Dashboard
    fetchDashboard: {
        loading: 'Loading Dashboard...',
        success: 'Dashboard was loaded successfully.',
        error: ()=>'Could not load Dashboard.'
    },
    // Equipment
    fetchEquipment: {
        loading: 'Loading Equipment...',
        success: 'Equipment was loaded successfully.',
        error: ()=>'Could not load Equipment.'
    },
    listEquipment: {
        loading: 'Loading Equipment list...',
        success: 'Equipment list was loaded successfully.',
        error: ()=>'Could not load Equipment list.'
    },
    listEquipmentCategories: {
        loading: 'Loading Equipment categories list...',
        success: 'Equipment categories were loaded successfully.',
        error: ()=>'Could not load Equipment categories.'
    },
    createEquipment: {
        loading: 'Creating Equipment...',
        success: 'Equipment was created successfully.',
        error: ()=>'Could not create Equipment.'
    },
    updateEquipment: {
        loading: 'Updating Equipment...',
        success: 'Equipment details updated successfully.',
        error: ()=>'Could not update Equipment.'
    },
    retireEquipment: {
        loading: 'Retiring Equipment...',
        success: 'Equipment was retired successfully.',
        error: ()=>'Could not retire Equipment.'
    },
    deleteEquipment: {
        loading: 'Deleting Equipment...',
        success: 'Equipment was deleted successfully.',
        error: ()=>'Could not delete Equipment.'
    },
    updateMultipleMeteredEquipment: {
        loading: 'Bulk updating metered Equipment...',
        success: 'Metered Equipment was updated successfully.',
        error: ()=>'An error occurred while bulk updating metered Equipment.'
    },
    // Equipment Usages
    fetchEquipmentUsage: {
        loading: 'Loading Equipment usage data...',
        success: 'Equipment usage data was loaded successfully.',
        error: ()=>'Could not load Equipment usage data.'
    },
    listEquipmentUsages: {
        loading: 'Loading Equipment usages list...',
        success: 'Equipment usages list was loaded successfully.',
        error: ()=>'Could not load Equipment usages list.'
    },
    updateEquipmentUsage: {
        loading: 'Updating Equipment usage data...',
        success: 'Equipment usage data was updated successfully.',
        error: ()=>'Could not update Equipment usage data.'
    },
    // Facilities
    fetchFacility: {
        loading: 'Loading Facility...',
        success: 'Facility was loaded successfully.',
        error: ()=>'Could not load Facility.'
    },
    listFacilities: {
        loading: 'Loading Facilities list...',
        success: 'Facilities list was loaded successfully.',
        error: ()=>'Could not load Facilities list.'
    },
    createFacility: {
        loading: 'Creating Facility...',
        success: 'Facility was created successfully.',
        error: ()=>'Could not create Facility.'
    },
    updateFacility: {
        loading: 'Updating Facility...',
        success: 'Facility details updated successfully.',
        error: (err)=>{
            const errors = err?.body?.errors;
            if (errors?.some((e)=>e.field === 'name' && e.rule === 'unique')) return 'A facility with this name already exists.';
            return 'Could not update Facility.';
        }
    },
    retireFacility: {
        loading: 'Retiring Facility...',
        success: 'Facility was retired successfully.',
        error: ()=>'Could not retire Facility.'
    },
    deleteFacility: {
        loading: 'Deleting Facility...',
        success: 'Facility was deleted successfully.',
        error: ()=>'Could not delete Facility.'
    },
    updateNonMeteredEquipment: {
        loading: 'Bulk updating non-metered Equipment...',
        success: 'Unmetered Equipment was updated successfully.',
        error: ()=>'An error occurred while bulk updating non-metered Equipment.'
    },
    duplicateFacility: {
        loading: '',
        success: '',
        error: (err)=>`${err.body?.program_name} already has a Facility with this address.`
    },
    duplicateFacilityName: {
        loading: '',
        success: '',
        error: ()=>'A Facility with this name already exists.'
    },
    // FSE Registration Types
    listFSERegistrationStatuses: {
        loading: 'Loading FSE registration types list...',
        success: 'FSE registration types were loaded successfully.',
        error: ()=>'Could not load FSE registration types.'
    },
    // Fuel Pathways
    listFuelPathways: {
        loading: 'Loading Fuel pathways list...',
        success: 'Fuel pathways were loaded successfully.',
        error: ()=>'Could not load Fuel pathways.'
    },
    // Incentive Statements
    listIncentiveStatements: {
        loading: 'Loading Incentive Statement list...',
        success: 'Incentive Statements were loaded successfully.',
        error: ()=>'Could not load Incentive Statements.'
    },
    getIncentiveStatement: {
        loading: 'Loading Incentive Statement...',
        success: 'Incentive Statement was loaded successfully.',
        error: ()=>'Could not load Incentive Statement.'
    },
    // Programs
    listPrograms: {
        loading: 'Loading Programs list...',
        success: 'Programs were loaded successfully.',
        error: ()=>'Could not load Programs.'
    },
    // Regions
    listRegions: {
        loading: 'Loading Regions list...',
        success: 'Regions were loaded successfully.',
        error: ()=>'Could not load Regions.'
    },
    // Remittance Methods
    listRemittanceMethods: {
        loading: 'Loading remittance methods list...',
        success: 'remittance methods were loaded successfully.',
        error: ()=>'Could not load remittance methods.'
    },
    // Documents
    fetchDocuments: {
        loading: 'Loading documents...',
        success: 'Documents loaded successfully.',
        error: (err)=>err?.message || 'Could not load documents.'
    },
    uploadDocument: {
        loading: 'Uploading document...',
        success: 'Document uploaded successfully.',
        error: (err)=>{
            if (err?.status === 413) return 'File is too large for document upload.';
            const errors = err?.body?.errors;
            const extnameError = errors?.find((e)=>e.rule === 'file.extname');
            if (extnameError) {
                const extnames = extnameError.args?.extnames;
                const allowed = Array.isArray(extnames) ? extnames.join(', ') : undefined;
                return allowed ? `Invalid file type. Allowed types: ${allowed}.` : 'Invalid file type.';
            }
            return err?.message || 'Could not upload document.';
        }
    },
    updateDocument: {
        loading: 'Updating document...',
        success: 'Document updated successfully.',
        error: (err)=>err?.message || 'Could not update document.'
    },
    deleteDocument: {
        loading: 'Deleting document...',
        success: 'Document deleted successfully.',
        error: (err)=>err?.message || 'Could not delete document.'
    },
    downloadDocument: {
        loading: 'Preparing download...',
        success: 'Document download started.',
        error: (err)=>err?.message || 'Could not download document.'
    },
    bulkDownloadDocuments: {
        loading: 'Preparing documents...',
        success: 'Documents download started.',
        error: (err)=>err?.message || 'Could not download documents.'
    },
    documentProcessing: {
        loading: 'Processing document...',
        success: 'Document processed successfully.',
        error: (err)=>err?.message || 'Could not process document.'
    },
    // Users
    fetchUser: {
        loading: 'Loading User...',
        success: 'User was loaded successfully.',
        error: ()=>'Could not load User.'
    },
    listUsers: {
        loading: 'Loading Users list...',
        success: 'Users list was loaded successfully.',
        error: ()=>'Could not load Users list.'
    },
    createUser: {
        loading: 'Creating User...',
        success: 'User was created successfully.',
        error: ()=>'Could not create User.'
    },
    updateUser: {
        loading: 'Updating User...',
        success: 'User details updated successfully.',
        error: (err)=>{
            const errors = err?.body?.errors;
            if (errors?.some((e)=>e.field === 'email' && e.rule === 'unique')) return 'A user with this email address already exists.';
            return 'Could not update User.';
        }
    },
    updateEmail: {
        loading: 'Updating email address...',
        success: 'Email address was updated successfully.',
        error: ()=>'Could not update email address.'
    },
    verifyEmail: {
        loading: 'Verifying email address...',
        success: 'Email address was successfully verified. You may now log in with this email.',
        error: ()=>'There was an error verifying this email address.'
    },
    // Stripe Recipients
    createStripeRecipient: {
        loading: 'Creating Stripe Recipient...',
        success: 'Stripe Recipient was created successfully.',
        error: ()=>'Could not create Stripe Recipient.'
    },
    updateStripeRecipient: {
        loading: 'Updating Stripe Recipient...',
        success: 'Stripe Recipient was updated successfully.',
        error: ()=>'Could not update Stripe Recipient.'
    },
    deleteStripeRecipient: {
        loading: 'Deleting Stripe Recipient...',
        success: 'Stripe Recipient was deleted successfully.',
        error: ()=>'Could not delete Stripe Recipient.'
    },
    addStripeBankAccount: {
        loading: 'Adding Stripe Bank Account...',
        success: 'Bank Account was added successfully.',
        error: ()=>'Could not add Bank Account.'
    },
    moneyStripeTransfer: {
        loading: 'Processing money transfer...',
        success: 'Money sent successfully!',
        error: (err)=>`Could not send money: ${err?.message || 'An unknown error occurred'}`,
        invalidAmount: 'Please enter a valid positive amount.',
        missingInfo: 'Please select an account, ensure bank account is loaded, and enter an amount.'
    },
    // Referral Partners
    listReferralPartners: {
        loading: 'Loading Referral Partners list...',
        success: 'Referral Partners list was loaded successfully.',
        error: ()=>'Could not load Referral Partners list.'
    },
    createReferralPartner: {
        loading: 'Creating Referral Partner...',
        success: 'Referral Partner was created successfully.',
        error: (err)=>{
            const errors = err?.body?.errors;
            if (errors?.[0]?.message) return 'Referral Partner already exists.';
            return err?.message || 'Could not create Referral Partner.';
        },
        requiredFields: 'Partner name is required.'
    },
    // Charging Networks
    listChargingNetworks: {
        loading: 'Loading Charging Networks list...',
        success: 'Charging Networks list was loaded successfully.',
        error: ()=>'Could not load Charging Networks list.'
    },
    createChargingNetwork: {
        loading: 'Creating Charging Network...',
        success: 'Charging Network was created successfully.',
        error: (err)=>{
            const errors = err?.body?.errors;
            if (errors?.[0]?.message) return 'Charging Network already exists.';
            return err?.message || 'Could not create Charging Network.';
        },
        requiredFields: 'Network name is required.'
    },
    // Credit Calculations
    calculateCredits: {
        loading: 'Starting credit calculation...',
        success: 'Credit calculation started.',
        error: (err)=>err?.body?.message ?? 'Could not start the credit calculation.'
    },
    // Api Data
    listApiData: {
        loading: 'Loading Api Data...',
        success: 'Api Data was loaded successfully.',
        error: ()=>'Could not load Api Data.'
    },
    filtersApiData: {
        loading: 'Loading Api Data Filters...',
        success: 'Api Data Filters was loaded successfully.',
        error: ()=>'Could not load Api Data Filters.'
    },
    downloadData: {
        loading: 'Preparing download...',
        success: 'Document download started.',
        error: (err)=>err?.message || 'Could not download document.'
    }
};



class $da1e9dbc7eafb1f8$export$2e2bcd8739ae039 extends (0, $c0c39e1b1209be87$export$2e2bcd8739ae039) {
    isLoading = true;
    referralPartners = [];
    regions = [];
    regionOptions;
    roles = [];
    reportingQuarterOptions = [];
    reportingYearOptions = [];
    reportingPeriodTypes = [];
    fuelPathways;
    fseRegistrationStatuses;
    previousPath;
    _currentQuarter;
    _previousQuarter;
    // Flags
    didAnimateHeader = false;
    didAnimateDashboard = false;
    constructor(rootStore){
        super(rootStore);
        (0, $herDu.makeObservable)(this, {
            // Observables
            isLoading: (0, $herDu.observable),
            regions: (0, $herDu.observable),
            regionOptions: (0, $herDu.observable),
            roles: (0, $herDu.observable),
            reportingQuarterOptions: (0, $herDu.observable),
            reportingYearOptions: (0, $herDu.observable),
            reportingPeriodTypes: (0, $herDu.observable),
            fuelPathways: (0, $herDu.observable),
            fseRegistrationStatuses: (0, $herDu.observable),
            previousPath: (0, $herDu.observable),
            didAnimateHeader: (0, $herDu.observable),
            didAnimateDashboard: (0, $herDu.observable)
        });
        this.fetchAll();
    }
    fetchAll = async ()=>{
        (0, $herDu.runInAction)(()=>{
            this.isLoading = true;
        });
        try {
            await Promise.all([
                this.fetchRoles(),
                this.fetchPeriods(),
                this.fetchReportingPeriodTypes(),
                this.fetchRegions(),
                this.fetchReferralPartners()
            ]);
        } finally{
            (0, $herDu.runInAction)(()=>{
                this.isLoading = false;
            });
        }
    };
    get currentQuarter() {
        const quarter = (0, $00658ccd6ec0135a$export$6a2a5264dcc16b56)(new Date());
        if (!this._currentQuarter) this._currentQuarter = quarter;
        return quarter;
    }
    get previousQuarter() {
        const quarter = (0, $00658ccd6ec0135a$export$6a2a5264dcc16b56)((0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))((0, $00658ccd6ec0135a$export$961bde6bd33f5db2)(this.currentQuarter)).subtract(3, 'months').toDate());
        if (!this._previousQuarter) this._previousQuarter = quarter;
        return quarter;
    }
    setPreviousPath = (previousPath)=>{
        (0, $herDu.runInAction)(()=>{
            this.previousPath = previousPath;
        });
    };
    fetchRoles = async ()=>{
        (0, $herDu.runInAction)(()=>{
            this.roles = (0, $a65473e9746b33bb$export$e96fc2b06c25bc5e);
        });
    };
    fetchPeriods = ()=>{
        if (!this.rootStore.userStore.user) return;
        const firstDate = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))().subtract(12, 'months');
        const lastDate = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))();
        const quarterOptions = [];
        const yearOptions = [];
        let dateCursor = firstDate;
        while(dateCursor.isBefore(lastDate) || dateCursor.isSame(lastDate)){
            const quarter = (0, $00658ccd6ec0135a$export$6a2a5264dcc16b56)(dateCursor.toDate());
            const quarterDateString = (0, $00658ccd6ec0135a$export$961bde6bd33f5db2)(quarter);
            quarterOptions.push({
                label: quarter,
                value: quarterDateString
            });
            const year = dateCursor.year().toString();
            const yearDateString = (0, $00658ccd6ec0135a$export$af07fade2660cbdc)(year);
            if (!yearOptions.find((y)=>y.value === yearDateString)) yearOptions.push({
                label: year,
                value: yearDateString
            });
            dateCursor = dateCursor.add(3, 'months');
        }
        (0, $herDu.runInAction)(()=>{
            const q1_2024 = (0, $00658ccd6ec0135a$export$961bde6bd33f5db2)('Q1 2024');
            if (!quarterOptions.find((q)=>q.value === q1_2024)) quarterOptions.push({
                label: 'Q1 2024',
                value: q1_2024
            });
            this.reportingQuarterOptions = quarterOptions.sort((a, b)=>a.value > b.value ? -1 : 1);
            this.reportingYearOptions = yearOptions.sort((a, b)=>a.value > b.value ? -1 : 1);
        });
    };
    fetchReportingPeriodTypes = async ()=>{
        if (!this.rootStore.userStore.user) return;
        try {
            const data = await (0, $8a34d767b5bdff06$export$b0a97e3fab168231).list();
            (0, $herDu.runInAction)(()=>{
                this.reportingPeriodTypes = data;
            });
        } catch (err) {
            this.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).generic.error);
        }
    };
    fetchRegions = async ()=>{
        if (!this.rootStore.userStore.user) return;
        try {
            const data = await (0, $054fb6e98ac05e97$export$4dcb2623fe0a1f40).listRegions();
            (0, $herDu.runInAction)(()=>{
                this.regions = data.filter((r)=>!!r.short_code && !!r.country_id).sort((a, b)=>(a.short_code ?? '') > (b.short_code ?? '') ? 1 : (a.short_code ?? 0) < (b.short_code ?? 0) ? -1 : 0).sort((a, b)=>(a.country_id ?? 0) - (b.country_id ?? 0));
            });
        } catch (err) {
            this.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).generic.error);
        }
    };
    fetchReferralPartners = async ()=>{
        try {
            const response = await (0, $aab6e7692a93396d$export$fec76eb589c20b4f).list();
            (0, $herDu.runInAction)(()=>{
                this.referralPartners = response;
            });
        } catch (error) {
            console.error('Failed to fetch referral partners:', error);
        }
    };
    fetchFSERegistrationStatuses = async ()=>{
        if (!this.rootStore.userStore.user) return;
        try {
            const data = await (0, $d6dddabef9527262$export$47f5a8b2675bf9f0).listFSERegistrationStatuses();
            (0, $herDu.runInAction)(()=>{
                this.fseRegistrationStatuses = data;
            });
        } catch (err) {
            this.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).generic.error);
        }
    };
    handleApiError = (error, messageFunc)=>{
        (0, $herDu.runInAction)(()=>{
            console.error(error);
            if (error.body?.message?.toLowerCase() === 'invalid credentials') (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $d0d6382a5bdf6377$export$d8bd0967cb58683).invalidLogin);
            else if (error.status !== 401 && messageFunc) (0, $05d5739209a21833$export$b410431fab84fa58).error(messageFunc(error));
        });
    };
    setDidAnimateHeader = (didAnimate)=>{
        (0, $herDu.runInAction)(()=>{
            this.didAnimateHeader = didAnimate;
        });
    };
    setDidAnimateDashboard = (didAnimate)=>{
        (0, $herDu.runInAction)(()=>{
            this.didAnimateDashboard = didAnimate;
        });
    };
    getRegionById = (regionId)=>{
        return this.regions?.find((region)=>region.id === regionId);
    };
}



var $herDu = parcelRequire("herDu");
const $21dd70935d6be03f$var$MAX_ENTRIES = 30;
class $21dd70935d6be03f$export$2e2bcd8739ae039 {
    entries = new Map();
    pendingRestorePathname = null;
    constructor(){
        (0, $herDu.makeObservable)(this, {
            entries: (0, $herDu.observable),
            pendingRestorePathname: (0, $herDu.observable),
            setState: (0, $herDu.action),
            clearState: (0, $herDu.action),
            clearAll: (0, $herDu.action),
            signalRestore: (0, $herDu.action),
            consumeRestore: (0, $herDu.action)
        });
    }
    signalRestore(pathname) {
        this.pendingRestorePathname = pathname;
    }
    consumeRestore(pathname) {
        if (this.pendingRestorePathname === pathname) {
            this.pendingRestorePathname = null;
            return true;
        }
        return false;
    }
    getState(key) {
        return this.entries.get(key)?.state;
    }
    setState(key, state) {
        if (!this.entries.has(key) && this.entries.size >= $21dd70935d6be03f$var$MAX_ENTRIES) {
            let oldestKey;
            let oldestTime = Infinity;
            this.entries.forEach((entry, k)=>{
                if (entry.updatedAt < oldestTime) {
                    oldestTime = entry.updatedAt;
                    oldestKey = k;
                }
            });
            if (oldestKey) this.entries.delete(oldestKey);
        }
        this.entries.set(key, {
            state: state,
            updatedAt: Date.now()
        });
    }
    clearState(key) {
        this.entries.delete(key);
    }
    clearAll() {
        this.entries.clear();
        this.pendingRestorePathname = null;
    }
}



var $herDu = parcelRequire("herDu");




class $e52dc6da75964ced$export$2e2bcd8739ae039 extends (0, $c0c39e1b1209be87$export$2e2bcd8739ae039) {
    isLoading = true;
    modelAuditLog;
    modelAuditLogs;
    modelAuditLogsMeta;
    modelAuditLogStates = [];
    selectedModelAuditLog;
    fieldAliases = {
        Fein: 'FEIN'
    };
    currentPage = 1;
    limit = 20;
    constructor(rootStore){
        super(rootStore);
        (0, $herDu.makeObservable)(this, {
            isLoading: (0, $herDu.observable),
            modelAuditLog: (0, $herDu.observable),
            modelAuditLogs: (0, $herDu.observable),
            modelAuditLogsMeta: (0, $herDu.observable),
            modelAuditLogStates: (0, $herDu.observable),
            selectedModelAuditLog: (0, $herDu.observable),
            fieldAliases: (0, $herDu.observable),
            currentPage: (0, $herDu.observable),
            limit: (0, $herDu.observable),
            setIsLoading: (0, $herDu.action),
            setModelAuditLog: (0, $herDu.action),
            setModelAuditLogs: (0, $herDu.action),
            setModelAuditLogsMeta: (0, $herDu.action),
            setModelAuditLogStates: (0, $herDu.action),
            setSelectedModelAuditLog: (0, $herDu.action),
            setCurrentPage: (0, $herDu.action),
            setLimit: (0, $herDu.action),
            reset: (0, $herDu.action),
            fetchModelAuditLog: (0, $herDu.action),
            fetchModelAuditLogs: (0, $herDu.action),
            fetchModelAuditLogStates: (0, $herDu.action),
            updateModelAuditLogState: (0, $herDu.action)
        });
    }
    setIsLoading = (isLoading)=>{
        this.isLoading = isLoading;
    };
    setModelAuditLog = (modelAuditLog)=>{
        this.modelAuditLog = modelAuditLog;
    };
    setModelAuditLogs = (modelAuditLogs)=>{
        this.modelAuditLogs = modelAuditLogs;
    };
    setModelAuditLogsMeta = (modelAuditLogsMeta)=>{
        this.modelAuditLogsMeta = modelAuditLogsMeta;
    };
    setModelAuditLogStates = (modelAuditLogStates)=>{
        this.modelAuditLogStates = modelAuditLogStates;
    };
    setSelectedModelAuditLog = (modelAuditLog)=>{
        this.selectedModelAuditLog = modelAuditLog;
    };
    setCurrentPage = (currentPage)=>{
        this.currentPage = currentPage;
    };
    setLimit = (limit)=>{
        this.limit = limit;
    };
    reset = ()=>{
        this.setModelAuditLogs(undefined);
        this.setModelAuditLogsMeta(undefined);
    };
    fetchModelAuditLog = async (id)=>{
        if (!this.rootStore.userStore.isFuseAdmin) return;
        if (!this.modelAuditLogs) await this.fetchModelAuditLogs();
        const auditLog = (this.modelAuditLogs ?? []).find((log)=>log.id === id);
        this.setModelAuditLog(auditLog);
    };
    fetchModelAuditLogs = async (req)=>{
        if (!this.rootStore.userStore.isFuseAdmin) {
            this.setIsLoading(false);
            this.setModelAuditLogs([]);
            return;
        }
        this.setIsLoading(true);
        try {
            const response = await (0, $05bcb43788f04b5c$export$ef093b57d2fc4c08).list({
                page: this.currentPage,
                limit: this.limit,
                ...req
            });
            const { meta: meta, data: data } = response;
            this.setModelAuditLogs(data.filter((log)=>log.model && Object.values((0, $1132a1d774d1082e$export$8fde3cbed0ae03c0)).includes(log.model_name)));
            this.setModelAuditLogsMeta(meta);
        } catch (err) {
            this.rootStore.globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listAuditLogs.error);
        } finally{
            this.setIsLoading(false);
        }
    };
    fetchModelAuditLogStates = async (req)=>{
        if (!this.rootStore.userStore.isFuseAdmin) return;
        try {
            const data = await (0, $05bcb43788f04b5c$export$ef093b57d2fc4c08).listStates(req);
            this.setModelAuditLogStates(data);
        // this.setModelAuditLogStates(
        //   data?.length > 0 ? [defaultUnresolvedStatus, ...data] : [defaultUnresolvedStatus, defaultResolvedStatus]
        // );
        } catch (err) {
            this.rootStore.globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listAuditLogs.error);
        }
    };
    updateModelAuditLogState = async (req)=>{
        if (!this.rootStore.userStore.isFuseAdmin) return;
        await (0, $05bcb43788f04b5c$export$ef093b57d2fc4c08).updateState(req);
    };
}



var $herDu = parcelRequire("herDu");




class $34f6f5ae8ad2009c$export$2e2bcd8739ae039 extends (0, $c0c39e1b1209be87$export$2e2bcd8739ae039) {
    isSearching = false;
    error;
    results;
    resultsMetadata;
    currentPage = 1;
    limit = 20;
    /** Select Entity **/ entityFilter = '';
    isEntityFocused = false;
    searchEntity;
    /** Select Field **/ fieldFilter = '';
    isFieldFocused = false;
    searchField;
    /** Select Query **/ isQueryFocused = false;
    searchOption;
    searchQuery = '';
    fields = {
        Clients: [
            {
                label: 'Name',
                value: 'name'
            }
        ],
        Facilities: [
            {
                label: 'Name',
                value: 'name'
            },
            {
                label: 'Street Address',
                value: 'address_line1'
            },
            {
                label: 'City',
                value: 'address_city'
            },
            {
                label: 'Postal Code',
                value: 'address_post_code'
            },
            {
                label: 'Program',
                value: 'program_id'
            },
            {
                label: 'Utility',
                value: 'utility_id'
            },
            {
                label: 'Active Status',
                value: 'is_active'
            }
        ],
        Equipment: [
            {
                label: 'Unit Number',
                value: 'unit_number'
            },
            {
                label: 'Serial Number',
                value: 'serial_number'
            },
            {
                label: 'Equipment Type',
                value: 'equipment_type_id'
            },
            {
                label: 'Model Year',
                value: 'model_year'
            },
            {
                label: 'Manufacturer',
                value: 'manufacturer'
            },
            {
                label: 'Model Number',
                value: 'model_number'
            },
            {
                label: 'Active Status',
                value: 'is_active'
            },
            {
                label: 'Metered Status',
                value: 'is_metered'
            },
            {
                label: 'Fuel Pathway',
                value: 'fuel_pathway_id'
            },
            {
                label: 'FSE Registration Status',
                value: 'fse_registration_status_id'
            },
            {
                label: 'FSE ID',
                value: 'fse_id'
            },
            {
                label: 'FSE RU',
                value: 'fse_ru'
            }
        ],
        Users: [
            {
                label: 'Name',
                value: 'name'
            },
            {
                label: 'Role',
                value: 'role_id'
            },
            {
                label: 'Active Status',
                value: 'is_active'
            }
        ]
    };
    selectFields = [
        'program_id',
        'utility_id',
        'is_active',
        'equipment_type_id',
        'is_active',
        'is_metered',
        'fuel_pathway_id',
        'fse_registration_status_id',
        'role_id',
        'is_active'
    ];
    constructor(rootStore){
        super(rootStore);
        (0, $herDu.makeObservable)(this, {
            isSearching: (0, $herDu.observable),
            error: (0, $herDu.observable),
            results: (0, $herDu.observable),
            resultsMetadata: (0, $herDu.observable),
            currentPage: (0, $herDu.observable),
            limit: (0, $herDu.observable),
            searchEntity: (0, $herDu.observable),
            searchField: (0, $herDu.observable),
            searchOption: (0, $herDu.observable),
            entityFilter: (0, $herDu.observable),
            fieldFilter: (0, $herDu.observable),
            searchQuery: (0, $herDu.observable),
            isEntityFocused: (0, $herDu.observable),
            isFieldFocused: (0, $herDu.observable),
            isQueryFocused: (0, $herDu.observable)
        });
    }
    setIsSearching = (isSearching)=>{
        (0, $herDu.runInAction)(()=>{
            this.isSearching = isSearching;
        });
    };
    setError = (error)=>{
        (0, $herDu.runInAction)(()=>{
            this.error = error;
        });
    };
    setResults = (results)=>{
        (0, $herDu.runInAction)(()=>{
            this.results = results;
        });
    };
    setResultsMetadata = (resultsMetadata)=>{
        (0, $herDu.runInAction)(()=>{
            this.resultsMetadata = resultsMetadata;
        });
    };
    /** Select Entity **/ setSearchEntity = (searchEntity)=>{
        (0, $herDu.runInAction)(()=>{
            this.searchEntity = searchEntity;
            this.setSearchField('');
            this.clear();
        });
    };
    setSearchField = (searchField)=>{
        (0, $herDu.runInAction)(()=>{
            this.searchField = searchField;
            this.setSearchQuery('');
            this.clear();
            this.setSearchOption({
                label: '',
                value: NaN
            });
        });
    };
    setSearchOption = (searchOption)=>{
        (0, $herDu.runInAction)(()=>{
            this.searchOption = searchOption;
        });
    };
    setEntityFilter = (entityFilter)=>{
        (0, $herDu.runInAction)(()=>{
            this.entityFilter = entityFilter;
        });
    };
    setFieldFilter = (fieldFilter)=>{
        (0, $herDu.runInAction)(()=>{
            this.fieldFilter = fieldFilter;
        });
    };
    setSearchQuery = (searchQuery)=>{
        (0, $herDu.runInAction)(()=>{
            this.searchQuery = searchQuery;
        });
    };
    setIsEntityFocused = (isEntityFocused)=>{
        (0, $herDu.runInAction)(()=>{
            this.isEntityFocused = isEntityFocused;
        });
    };
    setIsFieldFocused = (isFieldFocused)=>{
        (0, $herDu.runInAction)(()=>{
            this.isFieldFocused = isFieldFocused;
        });
    };
    setIsQueryFocused = (isQueryFocused)=>{
        (0, $herDu.runInAction)(()=>{
            this.isQueryFocused = isQueryFocused;
        });
    };
    setCurrentPage = async (currentPage)=>{
        (0, $herDu.runInAction)(()=>{
            this.currentPage = currentPage;
        });
    };
    setLimit = async (limit)=>{
        (0, $herDu.runInAction)(()=>{
            this.limit = limit;
        });
    };
    search = async (currentPage)=>{
        const userStore = this.rootStore.userStore;
        const clientStore = this.rootStore.clientStore;
        if (!userStore.user || userStore.isExternalUser && !clientStore.activeClientId) {
            if (!userStore.user) console.warn('No User found');
            if (userStore.isExternalUser && !clientStore.activeClientId) console.warn('User is external but has no `activeClientId`');
            return;
        }
        if (this.isSearching || !this.searchEntity || !this.searchField || !this.searchQuery && !this.searchOption?.value) return;
        const field = this.fields[this.searchEntity]?.find((f)=>f.label === this.searchField);
        if (!field) return;
        const isSelectField = this.selectFields.includes(field.value.toLowerCase());
        if (!isSelectField && !this.searchQuery) return;
        else if (isSelectField && !this.searchOption?.value) return;
        const page = currentPage ?? this.currentPage;
        this.setResults(undefined);
        this.setResultsMetadata(undefined);
        this.setIsSearching(true);
        let resultsMetadata;
        let results;
        try {
            // Client Search
            if (this.searchEntity === (0, $0badf5665deea2b2$export$dd8643a5f2fdbfa5).Clients) {
                const req = {
                    page: page
                };
                if (field.value === 'name') req.name = this.searchQuery;
                const { meta: meta, data: data } = await (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).list(req);
                resultsMetadata = meta;
                results = [
                    ...this.results ?? [],
                    ...data
                ];
            } else if (this.searchEntity === (0, $0badf5665deea2b2$export$dd8643a5f2fdbfa5).Facilities) {
                const req = {
                    page: page
                };
                if (field.value === 'name') req.name = this.searchQuery;
                else if (field.value === 'address_line1') req.address_line1 = this.searchQuery;
                else if (field.value === 'address_city') req.address_city = this.searchQuery;
                else if (field.value === 'address_post_code') req.address_post_code = this.searchQuery;
                if (this.searchOption?.value) {
                    if (field.value === 'program_id') req.program_id = typeof this.searchOption.value === 'string' ? parseInt(this.searchOption.value) : this.searchOption.value;
                    else if (field.value === 'utility_id') req.utility_id = typeof this.searchOption.value === 'string' ? parseInt(this.searchOption.value) : this.searchOption.value;
                    else if (field.value === 'is_active') req.is_active = this.searchOption.value === (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Active;
                }
                const { meta: meta, data: data } = userStore.isInternalUser ? await (0, $2f95a0926656d8e2$export$c270777027a9c841).listAll(req) : await (0, $2f95a0926656d8e2$export$c270777027a9c841).list({
                    client_id: clientStore.activeClientId ?? 0,
                    ...req
                });
                resultsMetadata = meta;
                results = [
                    ...this.results ?? [],
                    ...data
                ];
            } else if (this.searchEntity === (0, $0badf5665deea2b2$export$dd8643a5f2fdbfa5).Equipment) {
                const req = {
                    page: page
                };
                if (field.value === 'equipment_type_id') req.equipment_type_id = typeof this.searchOption?.value === 'string' ? parseInt(this.searchOption.value) : this.searchOption?.value;
                if (field.value === 'fuel_pathway_id') req.fuel_pathway_id = typeof this.searchOption?.value === 'string' ? parseInt(this.searchOption.value) : this.searchOption?.value;
                if (field.value === 'unit_number') req.unit_number = this.searchQuery;
                if (field.value === 'serial_number') req.serial_number = this.searchQuery;
                if (field.value === 'manufacturer') req.manufacturer = this.searchQuery;
                if (field.value === 'model_number') req.model_number = this.searchQuery;
                if (field.value === 'model_year') req.model_year = parseInt(this.searchQuery);
                if (field.value === 'fse_registration_status_id') req.fse_registration_status_id = typeof this.searchOption?.value === 'string' ? parseInt(this.searchOption.value) : this.searchOption?.value;
                if (field.value === 'fse_id') req.fse_id = this.searchQuery;
                if (field.value === 'fse_ru') req.fse_ru = this.searchQuery;
                else if (field.value === 'is_active') req.is_active = this.searchOption?.value === (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Active;
                else if (field.value === 'is_metered') req.is_metered = this.searchOption?.value === (0, $0badf5665deea2b2$export$3e3dc826e36eaf2b).Metered;
                const { meta: meta, data: data } = userStore.isInternalUser ? await (0, $64087c41a5036744$export$f3cdcae448e94402).listAll(req) : await (0, $64087c41a5036744$export$f3cdcae448e94402).listByClient({
                    client_id: clientStore.activeClientId ?? 0,
                    ...req
                });
                resultsMetadata = meta;
                results = [
                    ...this.results ?? [],
                    ...data
                ];
            } else if (this.searchEntity === (0, $0badf5665deea2b2$export$dd8643a5f2fdbfa5).Users) {
                const req = {
                    page: page
                };
                if (field.value === 'name') req.name = this.searchQuery;
                if (field.value === 'role_id') req.role_id = typeof this.searchOption?.value === 'string' ? parseInt(this.searchOption.value) : this.searchOption?.value;
                const { meta: meta, data: data } = userStore.isInternalUser ? await (0, $1f30379e064ebff4$export$a81c579a392aa9d2).list(req) : await (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).listClientUsers({
                    id: clientStore.activeClientId ?? 0,
                    ...req
                });
                resultsMetadata = meta;
                results = [
                    ...this.results ?? [],
                    ...data
                ];
            }
            (0, $herDu.runInAction)(()=>{
                this.setResultsMetadata(resultsMetadata);
                this.setCurrentPage(resultsMetadata.current_page);
                this.setResults(results);
            });
        } catch (err) {
            this.setError(err);
            this.rootStore.globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).search.error);
        } finally{
            this.setIsSearching(false);
        }
    };
    clear = ()=>{
        // Clear results
        this.setCurrentPage(1);
        this.setResults(undefined);
        this.setResultsMetadata(undefined);
        // Clear query
        this.setSearchOption({
            label: '',
            value: NaN
        });
        this.setSearchQuery('');
    };
    reset = ()=>{
        // Unfocus
        this.setIsEntityFocused(false);
        this.setIsFieldFocused(false);
        this.setIsQueryFocused(false);
        // Clear results & query
        this.clear();
        // Clear fields
        this.setFieldFilter('');
        this.setSearchField('');
        // Clear entity
        this.setEntityFilter('');
        this.setSearchEntity('');
    };
}


// This is a magic string replaced by rollup
const $4c4488a883ef31f7$export$31499a9cd224b78c = "8.55.2";



/** Get's the global object for the current JavaScript runtime */ const $af8853bd97d114cc$export$f1a6cdb1459e81d1 = globalThis;
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $af8853bd97d114cc$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $af8853bd97d114cc$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const versionedCarrier = __SENTRY__[0, $4c4488a883ef31f7$export$31499a9cd224b78c] = __SENTRY__[0, $4c4488a883ef31f7$export$31499a9cd224b78c] || {};
    return versionedCarrier[name] || (versionedCarrier[name] = creator());
}


/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $2efcafe7a288277a$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $2efcafe7a288277a$export$c8bfa33e4e8ae492((0, $af8853bd97d114cc$export$f1a6cdb1459e81d1));
    return 0, $af8853bd97d114cc$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $2efcafe7a288277a$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $4c4488a883ef31f7$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $4c4488a883ef31f7$export$31499a9cd224b78c] = __SENTRY__[0, $4c4488a883ef31f7$export$31499a9cd224b78c] || {};
}




// eslint-disable-next-line @typescript-eslint/unbound-method
const $5d145fc2c94d286e$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5d145fc2c94d286e$export$e6127cc7fe7395c3(wat) {
    switch($5d145fc2c94d286e$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $5d145fc2c94d286e$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $5d145fc2c94d286e$var$isBuiltin(wat, className) {
    return $5d145fc2c94d286e$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5d145fc2c94d286e$export$9f9636d330b71954(wat) {
    return $5d145fc2c94d286e$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5d145fc2c94d286e$export$ef9e2056653f0c8e(wat) {
    return $5d145fc2c94d286e$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5d145fc2c94d286e$export$12e869b2a583f783(wat) {
    return $5d145fc2c94d286e$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5d145fc2c94d286e$export$844ec244b1367d54(wat) {
    return $5d145fc2c94d286e$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5d145fc2c94d286e$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5d145fc2c94d286e$export$c3825b437cbdea5c(wat) {
    return wat === null || $5d145fc2c94d286e$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5d145fc2c94d286e$export$53b83ca8eaab0383(wat) {
    return $5d145fc2c94d286e$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5d145fc2c94d286e$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $5d145fc2c94d286e$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5d145fc2c94d286e$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $5d145fc2c94d286e$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5d145fc2c94d286e$export$49841c62b9eff15(wat) {
    return $5d145fc2c94d286e$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $5d145fc2c94d286e$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5d145fc2c94d286e$export$bc2894c7158efbac(wat) {
    return $5d145fc2c94d286e$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $5d145fc2c94d286e$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5d145fc2c94d286e$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}



const $efa6e113a375d8ac$var$WINDOW = (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1);
const $efa6e113a375d8ac$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $efa6e113a375d8ac$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $efa6e113a375d8ac$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $efa6e113a375d8ac$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $efa6e113a375d8ac$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($efa6e113a375d8ac$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $5d145fc2c94d286e$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $efa6e113a375d8ac$export$1cfafeee2987818b() {
    try {
        return $efa6e113a375d8ac$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existence of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 *
 * @deprecated This method is deprecated and will be removed in the next major version.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $efa6e113a375d8ac$export$c660c1f3ab49225c(selector) {
    if ($efa6e113a375d8ac$var$WINDOW.document && $efa6e113a375d8ac$var$WINDOW.document.querySelector) return $efa6e113a375d8ac$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $efa6e113a375d8ac$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$efa6e113a375d8ac$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $398ec29dacbd7df2$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;





/** Prefix for logging strings */ const $2c5c4ba32bebd8b3$var$PREFIX = 'Sentry Logger ';
const $2c5c4ba32bebd8b3$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $2c5c4ba32bebd8b3$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $2c5c4ba32bebd8b3$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($2c5c4ba32bebd8b3$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $2c5c4ba32bebd8b3$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $2c5c4ba32bebd8b3$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $398ec29dacbd7df2$export$16a28057038b10ef) $2c5c4ba32bebd8b3$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $2c5c4ba32bebd8b3$export$cda52e2a8927a2ca(()=>{
                (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1).console[name](`${$2c5c4ba32bebd8b3$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $2c5c4ba32bebd8b3$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $2c5c4ba32bebd8b3$export$af88d00dbe7f521 = (0, $af8853bd97d114cc$export$7e223ec222791509)('logger', $2c5c4ba32bebd8b3$var$makeLogger);



/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $b846d2d7ea7b5879$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $b846d2d7ea7b5879$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $b846d2d7ea7b5879$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $5d145fc2c94d286e$export$7916fad0ebc23f48)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $b846d2d7ea7b5879$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $5d145fc2c94d286e$export$844ec244b1367d54)(value)) return false;
    if ((0, $5d145fc2c94d286e$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $5d145fc2c94d286e$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $b846d2d7ea7b5879$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$b846d2d7ea7b5879$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $9d45b9df9881c412$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $9d45b9df9881c412$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch (e) {
        (0, $398ec29dacbd7df2$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $9d45b9df9881c412$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $398ec29dacbd7df2$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $9d45b9df9881c412$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $9d45b9df9881c412$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $9d45b9df9881c412$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 *
 * @deprecated This function is deprecated and will be removed in the next major version of the SDK.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9d45b9df9881c412$export$9ef804feabbcbaf1(object) {
    return Object.entries(object).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $9d45b9df9881c412$export$62ff257738bf57f5(value) {
    if ((0, $5d145fc2c94d286e$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$9d45b9df9881c412$var$getOwnProperties(value)
    };
    else if ((0, $5d145fc2c94d286e$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $9d45b9df9881c412$var$serializeEventTarget(value.target),
            currentTarget: $9d45b9df9881c412$var$serializeEventTarget(value.currentTarget),
            ...$9d45b9df9881c412$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $5d145fc2c94d286e$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $9d45b9df9881c412$var$serializeEventTarget(target) {
    try {
        return (0, $5d145fc2c94d286e$export$45a5e7f76e0caa8d)(target) ? (0, $efa6e113a375d8ac$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $9d45b9df9881c412$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $9d45b9df9881c412$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($9d45b9df9881c412$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return '[object has no keys]';
    if (firstKey.length >= maxLength) return (0, $b846d2d7ea7b5879$export$6a506b36fdea397d)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $b846d2d7ea7b5879$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $9d45b9df9881c412$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $9d45b9df9881c412$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $9d45b9df9881c412$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($9d45b9df9881c412$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.getOwnPropertyNames(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $9d45b9df9881c412$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($9d45b9df9881c412$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $9d45b9df9881c412$var$isPojo(input) {
    if (!(0, $5d145fc2c94d286e$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e2) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $9d45b9df9881c412$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $5d145fc2c94d286e$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}



const $958146d03402aa5e$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $958146d03402aa5e$export$7740643b9eeaf0c4() {
    return Date.now() / $958146d03402aa5e$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $958146d03402aa5e$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $958146d03402aa5e$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $958146d03402aa5e$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $958146d03402aa5e$export$ee52dced521e3e18 = $958146d03402aa5e$var$createUnixTimestampInSecondsFunc();
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 *
 * @deprecated This variable will be removed in the next major version.
 */ let $958146d03402aa5e$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $958146d03402aa5e$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        // eslint-disable-next-line deprecation/deprecation
        $958146d03402aa5e$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            // eslint-disable-next-line deprecation/deprecation
            $958146d03402aa5e$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            // eslint-disable-next-line deprecation/deprecation
            $958146d03402aa5e$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    // eslint-disable-next-line deprecation/deprecation
    $958146d03402aa5e$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();





/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $3340a52637a7f113$export$19f53698e68b2496() {
    const gbl = (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $3340a52637a7f113$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $3340a52637a7f113$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $3340a52637a7f113$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $3340a52637a7f113$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $3340a52637a7f113$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $3340a52637a7f113$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $3340a52637a7f113$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $3340a52637a7f113$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $3340a52637a7f113$export$d364f2020ab30578(input) {
    const match = input.match($3340a52637a7f113$var$SEMVER_REGEXP) || [];
    const major = $3340a52637a7f113$var$_parseInt(match[1]);
    const minor = $3340a52637a7f113$var$_parseInt(match[2]);
    const patch = $3340a52637a7f113$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $3340a52637a7f113$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $b846d2d7ea7b5879$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $b846d2d7ea7b5879$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $b846d2d7ea7b5879$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $3340a52637a7f113$export$6de4ffac6a2f1098(exception) {
    if ($3340a52637a7f113$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $9d45b9df9881c412$export$e73679ffaf56810e)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $3340a52637a7f113$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch (e) {} // eslint-disable-line no-empty
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 *
 * @deprecated This function has been deprecated and will not be replaced.
 */ function $3340a52637a7f113$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $72eac955b1607be8$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $958146d03402aa5e$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $3340a52637a7f113$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$72eac955b1607be8$var$sessionToJSON(session)
    };
    if (context) $72eac955b1607be8$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $72eac955b1607be8$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $958146d03402aa5e$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $3340a52637a7f113$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $72eac955b1607be8$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $72eac955b1607be8$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $72eac955b1607be8$var$sessionToJSON(session) {
    return (0, $9d45b9df9881c412$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}






/**
 * Returns a new minimal propagation context.
 *
 * @deprecated Use `generateTraceId` and `generateSpanId` instead.
 */ function $3135b6e87c14d175$export$37f0f2f9cf343e5e() {
    return {
        traceId: $3135b6e87c14d175$export$dc6d7ea554bcce10(),
        spanId: $3135b6e87c14d175$export$295213bc4d0c54ad()
    };
}
/**
 * Generate a random, valid trace ID.
 */ function $3135b6e87c14d175$export$dc6d7ea554bcce10() {
    return (0, $3340a52637a7f113$export$19f53698e68b2496)();
}
/**
 * Generate a random, valid span ID.
 */ function $3135b6e87c14d175$export$295213bc4d0c54ad() {
    return (0, $3340a52637a7f113$export$19f53698e68b2496)().substring(16);
}



/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $2ca8d67afb83b542$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && mergeObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $2ca8d67afb83b542$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}



const $ee9e4ca60d4b7ed9$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $ee9e4ca60d4b7ed9$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $9d45b9df9881c412$export$e73679ffaf56810e)(scope, $ee9e4ca60d4b7ed9$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$ee9e4ca60d4b7ed9$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $ee9e4ca60d4b7ed9$export$91f063ebb8eff307(scope) {
    return scope[$ee9e4ca60d4b7ed9$var$SCOPE_SPAN_FIELD];
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $29c58ba512e41a0d$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information.
 */ class $29c58ba512e41a0d$var$ScopeClass {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** Request Mode Session Status */ // eslint-disable-next-line deprecation/deprecation
    /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $3135b6e87c14d175$export$dc6d7ea554bcce10)(),
            spanId: (0, $3135b6e87c14d175$export$295213bc4d0c54ad)()
        };
    }
    /**
   * @inheritDoc
   */ clone() {
        const newScope = new $29c58ba512e41a0d$var$ScopeClass();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $ee9e4ca60d4b7ed9$export$3f25fa50c18e20ca)(newScope, (0, $ee9e4ca60d4b7ed9$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * @inheritDoc
   */ setClient(client) {
        this._client = client;
    }
    /**
   * @inheritDoc
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this._client;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $72eac955b1607be8$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const [scopeInstance, requestSession] = scopeToMerge instanceof $29c58ba512e41a0d$export$775b6bb06e53a214 ? [
            scopeToMerge.getScopeData(),
            scopeToMerge.getRequestSession()
        ] : (0, $5d145fc2c94d286e$export$53b83ca8eaab0383)(scopeToMerge) ? [
            captureContext,
            captureContext.requestSession
        ] : [];
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (requestSession) this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._session = undefined;
        (0, $ee9e4ca60d4b7ed9$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $3135b6e87c14d175$export$dc6d7ea554bcce10)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $29c58ba512e41a0d$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $958146d03402aa5e$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            if (this._client) this._client.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $ee9e4ca60d4b7ed9$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * @inheritDoc
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $2ca8d67afb83b542$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = {
            // eslint-disable-next-line deprecation/deprecation
            spanId: (0, $3135b6e87c14d175$export$295213bc4d0c54ad)(),
            ...context
        };
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $3340a52637a7f113$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $3340a52637a7f113$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $3340a52637a7f113$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Holds additional event information.
 */ const $29c58ba512e41a0d$export$775b6bb06e53a214 = $29c58ba512e41a0d$var$ScopeClass;



/** Get the default current scope. */ function $8cc92c088b440bc3$export$6f1b9191db9c4d5() {
    return (0, $af8853bd97d114cc$export$7e223ec222791509)('defaultCurrentScope', ()=>new (0, $29c58ba512e41a0d$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $8cc92c088b440bc3$export$de9862929b76bf57() {
    return (0, $af8853bd97d114cc$export$7e223ec222791509)('defaultIsolationScope', ()=>new (0, $29c58ba512e41a0d$export$775b6bb06e53a214)());
}





/**
 * This is an object that holds a stack of scopes.
 */ class $d9c7e025bdd07039$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $29c58ba512e41a0d$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $29c58ba512e41a0d$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $5d145fc2c94d286e$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $d9c7e025bdd07039$var$getAsyncContextStack() {
    const registry = (0, $2efcafe7a288277a$export$19eade501500c6c1)();
    const sentry = (0, $2efcafe7a288277a$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $d9c7e025bdd07039$export$d36ec451f120cfba((0, $8cc92c088b440bc3$export$6f1b9191db9c4d5)(), (0, $8cc92c088b440bc3$export$de9862929b76bf57)());
}
function $d9c7e025bdd07039$var$withScope(callback) {
    return $d9c7e025bdd07039$var$getAsyncContextStack().withScope(callback);
}
function $d9c7e025bdd07039$var$withSetScope(scope, callback) {
    const stack = $d9c7e025bdd07039$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $d9c7e025bdd07039$var$withIsolationScope(callback) {
    return $d9c7e025bdd07039$var$getAsyncContextStack().withScope(()=>{
        return callback($d9c7e025bdd07039$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $d9c7e025bdd07039$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $d9c7e025bdd07039$var$withIsolationScope,
        withScope: $d9c7e025bdd07039$var$withScope,
        withSetScope: $d9c7e025bdd07039$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $d9c7e025bdd07039$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$d9c7e025bdd07039$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$d9c7e025bdd07039$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $c744881b70afcb3e$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $2efcafe7a288277a$export$19eade501500c6c1)();
    const sentry = (0, $2efcafe7a288277a$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $c744881b70afcb3e$export$f639b0c2752203be(carrier) {
    const sentry = (0, $2efcafe7a288277a$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $d9c7e025bdd07039$export$329d4d4d54e42710)();
}






/**
 * Get the currently active scope.
 */ function $a383148e3fcc828a$export$c7be4b0125a10cba() {
    const carrier = (0, $2efcafe7a288277a$export$19eade501500c6c1)();
    const acs = (0, $c744881b70afcb3e$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $a383148e3fcc828a$export$68f3af03034c9e90() {
    const carrier = (0, $2efcafe7a288277a$export$19eade501500c6c1)();
    const acs = (0, $c744881b70afcb3e$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $a383148e3fcc828a$export$aa55d5ab8e05984f() {
    return (0, $af8853bd97d114cc$export$7e223ec222791509)('globalScope', ()=>new (0, $29c58ba512e41a0d$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $a383148e3fcc828a$export$ec58d9285c204497(...rest) {
    const carrier = (0, $2efcafe7a288277a$export$19eade501500c6c1)();
    const acs = (0, $c744881b70afcb3e$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $a383148e3fcc828a$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $2efcafe7a288277a$export$19eade501500c6c1)();
    const acs = (0, $c744881b70afcb3e$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $a383148e3fcc828a$export$6bb76d6eba7e258c() {
    return $a383148e3fcc828a$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $a383148e3fcc828a$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    // TODO(v9): Use generateSpanId() instead of spanId
    // eslint-disable-next-line deprecation/deprecation
    const { traceId: traceId, spanId: spanId, parentSpanId: parentSpanId } = propagationContext;
    const traceContext = (0, $9d45b9df9881c412$export$d25f2688db1bb433)({
        trace_id: traceId,
        span_id: spanId,
        parent_span_id: parentSpanId
    });
    return traceContext;
}



var $herDu = parcelRequire("herDu");







class $a3bea7317ea5c3cc$export$2e2bcd8739ae039 extends (0, $c0c39e1b1209be87$export$2e2bcd8739ae039) {
    users = [];
    _user;
    _token;
    selectedUser;
    constructor(rootStore){
        super(rootStore);
        if (this.token) (0, $cb036f6eccd47057$export$3bbbb17165d6e0ef).TOKEN = this.token.token;
        (0, $herDu.makeObservable)(this, {
            users: (0, $herDu.observable),
            _user: (0, $herDu.observable),
            _token: (0, $herDu.observable),
            selectedUser: (0, $herDu.observable),
            isLoggedIn: (0, $herDu.computed),
            user: (0, $herDu.computed),
            token: (0, $herDu.computed),
            roleId: (0, $herDu.computed),
            isInternalUser: (0, $herDu.computed),
            isExternalUser: (0, $herDu.computed),
            isAdminUser: (0, $herDu.computed),
            isFuseAdmin: (0, $herDu.computed),
            isSalesUser: (0, $herDu.computed),
            isClientUser: (0, $herDu.computed),
            isClientAdmin: (0, $herDu.computed),
            isFacilityUser: (0, $herDu.computed),
            isFacilityAdmin: (0, $herDu.computed),
            selectedUserName: (0, $herDu.computed),
            selectedUserId: (0, $herDu.computed),
            setSelectedUser: (0, $herDu.action),
            fetchUsers: (0, $herDu.action),
            restoreFromStorage: (0, $herDu.action),
            refreshUser: (0, $herDu.action),
            login: (0, $herDu.action),
            logout: (0, $herDu.action)
        });
    }
    get isLoggedIn() {
        return !!this._user && !!this._token;
    }
    get user() {
        if (!this._user) this.restoreFromStorage();
        return this._user;
    }
    get token() {
        if (!this._token) this.restoreFromStorage();
        return this._token;
    }
    get roleId() {
        if (!this._user) this.restoreFromStorage();
        return this._user?.role.id;
    }
    get isFuseAdmin() {
        if (!this._user) this.restoreFromStorage();
        return this.roleId === (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FuseAdmin;
    }
    get isInternalUser() {
        if (!this._user) this.restoreFromStorage();
        return this.roleId ? (0, $a65473e9746b33bb$export$5d277a5d95a5046e).includes(this.roleId) : false;
    }
    get isExternalUser() {
        if (!this._user) this.restoreFromStorage();
        return this.roleId ? (0, $a65473e9746b33bb$export$39d571c105d2314f).includes(this.roleId) : false;
    }
    get isAdminUser() {
        if (!this._user) this.restoreFromStorage();
        return this.roleId ? (0, $a65473e9746b33bb$export$7853a174aac8e6fa).includes(this.roleId) : false;
    }
    get isSalesUser() {
        if (!this._user) this.restoreFromStorage();
        return this.roleId ? (0, $a65473e9746b33bb$export$ed05588e9f6a56d).includes(this.roleId) : false;
    }
    get isClientUser() {
        if (!this._user) this.restoreFromStorage();
        return this.roleId ? (0, $a65473e9746b33bb$export$4104e3cb244d8c3a).includes(this.roleId) : false;
    }
    get isClientAdmin() {
        if (!this._user) this.restoreFromStorage();
        return this.roleId ? this.roleId === (0, $a65473e9746b33bb$export$2cb4a31baf73b247).ClientAdmin : false;
    }
    get isFacilityUser() {
        if (!this._user) this.restoreFromStorage();
        return this.roleId ? (0, $a65473e9746b33bb$export$f0dfb0bb769e5823).includes(this.roleId) : false;
    }
    get isFacilityAdmin() {
        if (!this._user) this.restoreFromStorage();
        return this.roleId ? this.roleId === (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FacilityAdmin : false;
    }
    get selectedUserName() {
        return this.selectedUser?.name;
    }
    get selectedUserId() {
        return this.selectedUser?.id;
    }
    getUserClient = (clientId)=>{
        return this.user?.clients?.find((client)=>client.id === clientId);
    };
    setSelectedUser = (user)=>{
        this.selectedUser = user;
    };
    fetchUsers = async (req)=>{
        try {
            const response = await (0, $1f30379e064ebff4$export$a81c579a392aa9d2).list({
                limit: 1000,
                ...req
            });
            (0, $herDu.runInAction)(()=>{
                this.users = Array.isArray(response) ? response : response.data ?? [];
            });
        } catch (error) {
            (0, $herDu.runInAction)(()=>{
                this.users = [];
            });
        }
    };
    restoreFromStorage = ()=>{
        const token = (0, $9c41c53e999a77b0$export$70d175fe2fbaa383)();
        const user = (0, $9c41c53e999a77b0$export$a79e7ef8c396bb0e)();
        if (token && user) {
            this._user = user;
            this._token = token;
            (0, $cb036f6eccd47057$export$3bbbb17165d6e0ef).TOKEN = token.token;
        }
    };
    refreshUser = async ()=>{
        if (!this._user) return;
        const user = await (0, $1f30379e064ebff4$export$a81c579a392aa9d2).get({
            id: this._user.id
        });
        (0, $herDu.runInAction)(()=>{
            this._user = user;
        });
        (0, $9c41c53e999a77b0$export$97851c88c0bf33aa)(user);
    };
    login = async (req)=>{
        const { token: token, user: loggedInUser } = await (0, $73e0bc33ecac5b93$export$69d4516a6fd8e701).login(req);
        (0, $cb036f6eccd47057$export$3bbbb17165d6e0ef).TOKEN = token.token;
        const user = loggedInUser.role.is_internal ? loggedInUser : await (0, $1f30379e064ebff4$export$a81c579a392aa9d2).get({
            id: loggedInUser.id
        });
        (0, $herDu.runInAction)(()=>{
            this._user = user;
            this._token = token;
        });
        (0, $9c41c53e999a77b0$export$97851c88c0bf33aa)(user);
        (0, $9c41c53e999a77b0$export$46b0b91198def893)(token);
        (0, $9c41c53e999a77b0$export$2854321f90be4314)(new Date(token.expires_at).getTime() - Date.now());
        (0, $9c41c53e999a77b0$export$41c56a5e2126fc6e)();
        $a383148e3fcc828a$export$c7be4b0125a10cba().setUser({
            id: user.id,
            email: user.email
        });
        (0, $72b598b09e32bbcf$export$2e2bcd8739ae039).remove((0, $0badf5665deea2b2$export$25c0d5b425a20ec).ActiveClientId);
        this.rootStore.clientStore?.setActiveClientId(undefined);
        return user;
    };
    logout = ()=>{
        this._user = undefined;
        this._token = undefined;
        (0, $cb036f6eccd47057$export$3bbbb17165d6e0ef).TOKEN = undefined;
        (0, $9c41c53e999a77b0$export$b0ef8831976e9d68)();
        (0, $9c41c53e999a77b0$export$cd1eacef65db9ebc)();
        (0, $9c41c53e999a77b0$export$6d845b163d151800)();
        (0, $9c41c53e999a77b0$export$305bb539294c13f8)();
        (0, $72b598b09e32bbcf$export$2e2bcd8739ae039).remove((0, $0badf5665deea2b2$export$25c0d5b425a20ec).SelectedUserID);
        (0, $72b598b09e32bbcf$export$2e2bcd8739ae039).remove((0, $0badf5665deea2b2$export$25c0d5b425a20ec).ActiveClientId);
        $a383148e3fcc828a$export$c7be4b0125a10cba().setUser(null);
        this.rootStore.clientStore?.setActiveClientId(undefined);
        this.rootStore.clientStore?.setSelectedClientId(undefined);
        this.rootStore.dashboardStore?.clearDashboardData();
        this.rootStore.listRestoreStore?.clearAll();
    };
}


class $b48ea90902c249a6$export$2e2bcd8739ae039 {
    clientStore;
    dashboardStore;
    equipmentStore;
    equipmentUsageStore;
    facilityStore;
    userStore;
    searchStore;
    globalStore;
    modelAuditLogStore;
    listRestoreStore;
    constructor(){
        this.dashboardStore = new (0, $03d7a5c50d97fb14$export$2e2bcd8739ae039)(this);
        this.equipmentStore = new (0, $17e7d70dd4c4d3ca$export$2e2bcd8739ae039)(this);
        this.equipmentUsageStore = new (0, $81801cf2aed93d2d$export$2e2bcd8739ae039)(this);
        this.facilityStore = new (0, $1aaee08d1fdcd860$export$2e2bcd8739ae039)(this);
        this.userStore = new (0, $a3bea7317ea5c3cc$export$2e2bcd8739ae039)(this);
        this.searchStore = new (0, $34f6f5ae8ad2009c$export$2e2bcd8739ae039)(this);
        this.clientStore = new (0, $28a8a7ab0535f0b3$export$2e2bcd8739ae039)(this);
        this.globalStore = new (0, $da1e9dbc7eafb1f8$export$2e2bcd8739ae039)(this);
        this.modelAuditLogStore = new (0, $e52dc6da75964ced$export$2e2bcd8739ae039)(this);
        this.listRestoreStore = new (0, $21dd70935d6be03f$export$2e2bcd8739ae039)();
        (0, $herDu.makeObservable)(this, {
            clientStore: (0, $herDu.observable),
            dashboardStore: (0, $herDu.observable),
            equipmentStore: (0, $herDu.observable),
            equipmentUsageStore: (0, $herDu.observable),
            facilityStore: (0, $herDu.observable),
            userStore: (0, $herDu.observable),
            searchStore: (0, $herDu.observable),
            globalStore: (0, $herDu.observable),
            modelAuditLogStore: (0, $herDu.observable),
            listRestoreStore: (0, $herDu.observable)
        });
    }
}


const $116967e0234c3770$var$RootContext = /*#__PURE__*/ (0, $2xPiy.createContext)(undefined);
function $116967e0234c3770$export$5bc58655df8395ab() {
    const context = (0, $2xPiy.useContext)($116967e0234c3770$var$RootContext);
    if (context === undefined) throw new Error('useRootStore must be used within RootContextProvider');
    return context;
}
function $116967e0234c3770$export$3b47afa599c78f61() {
    const { clientStore: clientStore } = $116967e0234c3770$export$5bc58655df8395ab();
    if (clientStore === undefined) throw new Error('useClientStore must be used within RootContextProvider');
    return clientStore;
}
function $116967e0234c3770$export$176f58333fc13682() {
    const { dashboardStore: dashboardStore } = $116967e0234c3770$export$5bc58655df8395ab();
    if (dashboardStore === undefined) throw new Error('useDashboardStore must be used within RootContextProvider');
    return dashboardStore;
}
function $116967e0234c3770$export$728bc2cead7f2c5a() {
    const { equipmentStore: equipmentStore } = $116967e0234c3770$export$5bc58655df8395ab();
    if (equipmentStore === undefined) throw new Error('useEquipmentStore must be used within RootContextProvider');
    return equipmentStore;
}
function $116967e0234c3770$export$f93886ff234de9d1() {
    const { equipmentUsageStore: equipmentUsageStore } = $116967e0234c3770$export$5bc58655df8395ab();
    if (equipmentUsageStore === undefined) throw new Error('useEquipmentUsageStore must be used within RootContextProvider');
    return equipmentUsageStore;
}
function $116967e0234c3770$export$1fa40d59fe105eba() {
    const { facilityStore: facilityStore } = $116967e0234c3770$export$5bc58655df8395ab();
    if (facilityStore === undefined) throw new Error('useFacilityStore must be used within RootContextProvider');
    return facilityStore;
}
function $116967e0234c3770$export$ea7f481060e2c12e() {
    const { globalStore: globalStore } = $116967e0234c3770$export$5bc58655df8395ab();
    if (globalStore === undefined) throw new Error('useGlobalStore must be used within RootContextProvider');
    return globalStore;
}
function $116967e0234c3770$export$8992e2c9f8b2a805() {
    const { searchStore: searchStore } = $116967e0234c3770$export$5bc58655df8395ab();
    if (searchStore === undefined) throw new Error('useSearchStore must be used within RootContextProvider');
    return searchStore;
}
function $116967e0234c3770$export$cc885caaa8b7ab4e() {
    const { userStore: userStore } = $116967e0234c3770$export$5bc58655df8395ab();
    if (userStore === undefined) throw new Error('useUserStore must be used within RootContextProvider');
    return userStore;
}
function $116967e0234c3770$export$88b0cc0fc4818e39() {
    const { modelAuditLogStore: modelAuditLogStore } = $116967e0234c3770$export$5bc58655df8395ab();
    if (modelAuditLogStore === undefined) throw new Error('modelAuditLogStore must be used within RootContextProvider');
    return modelAuditLogStore;
}
function $116967e0234c3770$export$7c25846276568136() {
    const { listRestoreStore: listRestoreStore } = $116967e0234c3770$export$5bc58655df8395ab();
    if (listRestoreStore === undefined) throw new Error('useListRestoreStore must be used within RootContextProvider');
    return listRestoreStore;
}
function $116967e0234c3770$export$773ef8ccef99e88a({ children: children }) {
    const [store] = (0, $2xPiy.useState)(()=>new (0, $b48ea90902c249a6$export$2e2bcd8739ae039)());
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)($116967e0234c3770$var$RootContext, {
        value: store,
        children: children
    });
}




const $d597772cdbe12609$export$4713da6aa4410043 = ()=>{
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    return {
        // Search
        adminSearch: t('navigation:adminSearch', 'Quickly find Clients, Facilities, Equipment, or Users'),
        clearSearch: t('search:clearSearch', 'Clear the current results'),
        resetSearch: t('search:resetSearch', 'Reset the search box'),
        // Common actions
        close: t('common:close', 'Close'),
        copyToClipboard: 'Copy to clipboard',
        support: t('navigation:support', 'Support'),
        // Navigation
        companyPageLink: t('dashboard:companyPageLink', 'Go to Company page'),
        equipmentPageLink: 'Go to Equipment page',
        equipmentUsagePageLink: 'Go to Equipment Usage page',
        facilityPageLink: 'Go to Facility page',
        userPageLink: 'Go to User page',
        previousPeriod: t('common:previousPeriod', 'Previous Period'),
        nextPeriod: t('common:nextPeriod', 'Next Period'),
        // Logs
        logNotifications: 'Audit recent change logs',
        filterLogs: 'Filter Logs',
        viewLogDetails: 'View Log Details',
        logStatus: 'Only logs generated by external users have a resolution status.',
        // Statements
        viewPrintableStatement: 'View printable version',
        // Clients
        setActiveClientInfo: 'The active company can be changed at any time by clicking the "Set Active Company" link in the User menu.',
        // Facilities
        filterFacilities: t('facility:filterFacilities', 'Filter Facilities'),
        // Equipment
        filterEquipment: t('equipment:filterEquipment', 'Filter Equipment'),
        equipmentActions: t('equipment:equipmentActions', 'Equipment Actions'),
        viewEquipmentDetails: t('equipment:viewEquipmentDetails', 'View Equipment Details'),
        viewEquipmentId: t('equipment:viewEquipmentId', 'View Equipment ID'),
        // Commission actions
        addCommission: 'Add Commission',
        removeCommission: 'Remove Commission',
        addSalesCommission: 'Add Sales Commission',
        addReferralCommission: 'Add Referral Commission',
        // Documents
        saveChanges: t('clients:documents.saveChanges', 'Save Changes'),
        cancelEditing: t('clients:documents.cancelEditing', 'Cancel Editing'),
        editComments: t('clients:documents.editComments', 'Edit Comments'),
        deleteDocument: t('clients:documents.deleteDocument', 'Delete Document'),
        processing: t('clients:documents.processing', 'Processing'),
        needsReview: t('clients:documents.needsReview', 'Needs Review'),
        cannotDownloadWhileProcessing: t('clients:documents.cannotDownloadWhileProcessing', 'Cannot Download While Processing'),
        filterDocuments: t('documents:filterDocuments', 'Filter Documents'),
        // User actions
        addAnotherCompany: 'Add another company',
        // Api Data
        columnSettings: t('apiData:columnSettings')
    };
};



const $0d5d171277c7fe9b$export$3e19e9f19f11a807 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { user: user, setIsVisible: setIsVisible } = props;
    /** Context **/ const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const dashboardStore = (0, $116967e0234c3770$export$176f58333fc13682)();
    const clientStore = (0, $116967e0234c3770$export$3b47afa599c78f61)();
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const tooltips = (0, $d597772cdbe12609$export$4713da6aa4410043)();
    /** State **/ const [selectedClientId, setSelectedClientId] = (0, $2xPiy.useState)();
    /** Computed **/ const isMobile = (0, $18588a518ac6fdc7$export$2ac00d7098bf223)(screenSize);
    const clientOptions = user?.clients?.map((client)=>({
            label: client.name,
            value: client.id
        })) ?? [];
    const isLoading = !clientOptions;
    /** Methods **/ const setActiveClient = ()=>{
        if (!selectedClientId || !user) return;
        const activeClient = user.clients.find((client)=>client.id === selectedClientId);
        // TODO: figure out how to handle this situation
        if (!activeClient) {
            console.warn('Couldn\'t find Active Client with ID "%s" in User Clients list', selectedClientId);
            return;
        }
        clientStore.setActiveClientId(selectedClientId);
        (0, $05d5739209a21833$export$b410431fab84fa58).success(`Active company changed to ${activeClient.name}`);
        dashboardStore.clearDashboardData();
        navigate('/', {
            replace: true
        });
        setIsVisible(false);
    };
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        width: !isMobile ? '33%' : '50%',
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
            flex: "shrink",
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                    title: "Set Active Company",
                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d8fcb0015cca0f72$export$825a3c81a577bf46), {
                        entityName: (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Client
                    })
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $fdccc762800a972d$export$851de33184ecdac4), {
                    gap: "none",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            elevation: "small",
                            pad: "1.5rem",
                            gap: "1rem",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                    name: "active_company",
                                    width: "50%",
                                    label: "Company",
                                    placeholder: "Choose...",
                                    value: selectedClientId,
                                    setValue: setSelectedClientId,
                                    options: clientOptions,
                                    hideRequiredMarker: true,
                                    required: true,
                                    fill: "horizontal"
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7dacb42a28be9c15$export$7036cd8426a1245b), {
                                            size: "16px"
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                            fontFamily: "Lato, sans-serif",
                                            children: tooltips.setActiveClientInfo
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            row: true,
                            fill: "horizontal",
                            justify: "between",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    pad: "1.5rem",
                                    width: "33%",
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7ac54c23a62de8c7$export$4ecda0163efe6d1d), {
                                        type: "submit",
                                        label: "SAVE",
                                        loadingLabel: "SAVING...",
                                        isLoading: isLoading,
                                        onClick: setActiveClient,
                                        disabled: !selectedClientId
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    pad: "1.5rem",
                                    width: "33%",
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7ac54c23a62de8c7$export$4ecda0163efe6d1d), {
                                        type: "submit",
                                        label: "LOGOUT",
                                        loadingLabel: "LOGGING OUT...",
                                        isLoading: isLoading,
                                        onClick: ()=>navigate('/logout', {
                                                replace: true
                                            }),
                                        background: "white",
                                        hoverBackground: "light-4",
                                        color: "text",
                                        hoverColor: "text"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
});




var $2xPiy = parcelRequire("2xPiy");






const $e31e2b64690d9b7f$export$626f1e8296fbac24 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    /* Props */ const { formValues: formValues, updateFormValue: updateFormValue, formErrors: formErrors, id: id, onSubmit: onSubmit } = props;
    /* Context */ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const isMobile = (0, $18588a518ac6fdc7$export$2ac00d7098bf223)(screenSize);
    const handlePlaceSelected = (0, $2xPiy.useCallback)((place)=>{
        if (place.line2) updateFormValue('hq_address_line2', place.line2);
        if (place.city) updateFormValue('hq_address_city', place.city);
        if (place.postCode) updateFormValue('hq_address_post_code', place.postCode);
        if (place.stateShortCode) {
            const region = globalStore.regions.find((r)=>r.short_code?.toLowerCase() === place.stateShortCode.toLowerCase());
            if (region) updateFormValue('hq_address_region_id', region.id);
        }
    }, [
        updateFormValue,
        globalStore.regions
    ]);
    const isDisabled = !userStore.isFuseAdmin && (!userStore.isAdminUser || !userStore.isClientUser);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
        id: id,
        title: t('client:corporateAddress'),
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            margin: {
                bottom: '1rem'
            },
            gap: "1rem",
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d3e44ef4a726de02$export$db97b1df0d4d83fb), {
                    name: "hq_address_line1",
                    label: t('common:address'),
                    value: formValues.hq_address_line1,
                    setValue: (value)=>updateFormValue('hq_address_line1', value),
                    onPlaceSelected: handlePlaceSelected,
                    error: formErrors['hq_address_line1'],
                    onSubmit: onSubmit,
                    required: true,
                    disabled: isDisabled
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                    name: "hq_address_line2",
                    label: t('common:addressContinued'),
                    value: formValues.hq_address_line2 ?? '',
                    setValue: (value)=>updateFormValue('hq_address_line2', value),
                    error: formErrors['hq_address_line2'],
                    onSubmit: onSubmit,
                    disabled: isDisabled
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    direction: isMobile ? 'column' : 'row',
                    gap: "1rem",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            flex: "grow",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                name: "hq_address_city",
                                label: t('common:city'),
                                value: formValues.hq_address_city,
                                setValue: (value)=>updateFormValue('hq_address_city', value),
                                error: formErrors['hq_address_city'],
                                onSubmit: onSubmit,
                                required: true,
                                disabled: isDisabled
                            })
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            flex: "grow",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                name: "hq_address_region_id",
                                label: t('common:stateProvince'),
                                value: formValues.hq_address_region_id,
                                setValue: (value)=>updateFormValue('hq_address_region_id', value),
                                options: globalStore.regions.map((region)=>({
                                        label: `${region.name} (${region.short_code})`,
                                        value: region.id
                                    })),
                                error: formErrors['hq_address_region_id'],
                                required: true,
                                disabled: isDisabled
                            })
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            flex: "grow",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                name: "hq_address_post_code",
                                label: t('common:postalCode'),
                                value: formValues.hq_address_post_code,
                                setValue: (value)=>updateFormValue('hq_address_post_code', value),
                                error: formErrors['hq_address_post_code'],
                                onSubmit: onSubmit,
                                required: true,
                                disabled: isDisabled
                            })
                        })
                    ]
                })
            ]
        })
    });
});



parcelRequire("2xPiy");





const $6b8a0ccd47eb1071$export$d0e26fee1e9d154b = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { formValues: formValues, updateFormValue: updateFormValue, formErrors: formErrors, id: id, disabled: disabled } = props;
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const isDisabled = disabled || !userStore.isFuseAdmin && (!userStore.isAdminUser || !userStore.isClientUser);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
        id: id,
        title: t('client:programCountry'),
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            margin: {
                bottom: '1rem'
            },
            gap: "1rem",
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                name: "country_id",
                label: t('client:country'),
                placeholder: t('client:countryPlaceholder'),
                value: Number.isNaN(formValues.country_id) ? undefined : formValues.country_id,
                setValue: (value)=>updateFormValue('country_id', value),
                options: [
                    {
                        label: t('client:unitedStates'),
                        value: (0, $0badf5665deea2b2$export$b77c37614753bffb).USA
                    },
                    {
                        label: t('client:canada'),
                        value: (0, $0badf5665deea2b2$export$b77c37614753bffb).Canada
                    }
                ],
                error: formErrors['country_id'],
                required: true,
                disabled: isDisabled
            })
        })
    });
});





var $2xPiy = parcelRequire("2xPiy");



var $2xPiy = parcelRequire("2xPiy");
var $c66bbd4f602cf841$export$58d75f9829cbe158 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createContext({
    data: [],
    addToolbarKey: function addToolbarKey() {}
});






var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");





var $2xPiy = parcelRequire("2xPiy");


var $2xPiy = parcelRequire("2xPiy");
// When not a descendant of a Form, FormContext still provides a basic
// useFormInput. It doesn't do anything for components like TextInput.
// But, it does store the value for components like CheckBox or Select
// where the grommet component needs to know the value in order to
// render custom visuals.
var $55ac84ad3d20c8d4$var$useFormInput = function useFormInput(_ref) {
    var valueProp = _ref.value, initialValue = _ref.initialValue;
    var _useState = (0, $2xPiy.useState)(valueProp !== undefined ? valueProp : initialValue), value = _useState[0], setValue = _useState[1];
    // Returns an array [value and function to set the value]
    return [
        valueProp !== undefined ? valueProp : value,
        function(nextValue) {
            if (initialValue !== undefined) setValue(nextValue);
        }
    ];
};
var $55ac84ad3d20c8d4$var$useFormField = function useFormField(_ref2) {
    var error = _ref2.error, info = _ref2.info, disabled = _ref2.disabled;
    return {
        error: error,
        info: info,
        disabled: disabled
    };
};
var $55ac84ad3d20c8d4$export$c24727297075ec6a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createContext({
    useFormField: $55ac84ad3d20c8d4$var$useFormField,
    useFormInput: $55ac84ad3d20c8d4$var$useFormInput
});



var $dyr1f = parcelRequire("dyr1f");

var $f41fd893b2054d9b$var$PropType = {};
$f41fd893b2054d9b$var$PropType = {
    a11yTitle: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    checked: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    fill: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    pad: (0, $ab32ce3df36aa105$export$b91a2ef62736aae3),
    reverse: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    toggle: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    indeterminate: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
};
var $f41fd893b2054d9b$export$7aa8af94cfcf92cd = $f41fd893b2054d9b$var$PropType;



var $iA1nz = parcelRequire("iA1nz");


// Note: since `fillStyle` is only used in one place, `justify-content` was
// added to it to simplify its logic. If this is ever reused somewhere else,
// consider the need of separating those once again.
var $e75307a5c950d0d8$var$fillStyle = function fillStyle() {
    return "\n      width: auto;\n      height: 100%;\n      max-width: none;\n      flex: 1 0 auto;\n      justify-content: space-between;\n    ";
};
var $e75307a5c950d0d8$var$disabledStyle = "\n  opacity: 0.5;\n  cursor: default;\n";
var $e75307a5c950d0d8$var$hoverStyle = (0, $iA1nz.css)([
    "&:hover input:not([disabled]) + div,&:hover input:not([disabled]) + span{border-color:",
    ";",
    "}&:hover{background-color:",
    ";}"
], function(props) {
    var _props$theme$checkBox;
    return (0, $11317b0e49e0d157$export$4cde5df63f53f473)((_props$theme$checkBox = props.theme.checkBox.hover) == null || (_props$theme$checkBox = _props$theme$checkBox.border) == null ? void 0 : _props$theme$checkBox.color, props.theme);
}, function(props) {
    var _props$theme$checkBox2;
    return (_props$theme$checkBox2 = props.theme.checkBox.hover) == null ? void 0 : _props$theme$checkBox2.extend;
}, function(props) {
    var _props$theme$checkBox3;
    return (0, $11317b0e49e0d157$export$4cde5df63f53f473)(!props.disabled && ((_props$theme$checkBox3 = props.theme.checkBox.hover) == null || (_props$theme$checkBox3 = _props$theme$checkBox3.background) == null ? void 0 : _props$theme$checkBox3.color), props.theme);
});
var $e75307a5c950d0d8$export$59aa90b6aef14a9a = (0, $iA1nz.default).svg.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxIcon",
    componentId: "sc-1dbk5ju-0"
})([
    "box-sizing:border-box;stroke-width:",
    ";stroke:",
    ";width:",
    ";height:",
    ";",
    ";"
], function(props) {
    return props.theme.checkBox.check.thickness;
}, function(props) {
    return (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.theme.checkBox.color || 'control', props.theme);
}, function(props) {
    return props.theme.checkBox.icon.size || props.theme.checkBox.size;
}, function(props) {
    return props.theme.checkBox.icon.size || props.theme.checkBox.size;
}, function(props) {
    return props.theme.checkBox.icon.extend;
});
var $e75307a5c950d0d8$export$644eb5002e1279aa = (0, $iA1nz.default).label.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxContainer",
    componentId: "sc-1dbk5ju-1"
})([
    "display:flex;flex-direction:row;align-items:",
    ";user-select:none;-webkit-user-select:none;",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return typeof props.labelProp === 'string' ? props.theme.checkBox.label.align : undefined;
}, function(props) {
    return props.fillProp ? $e75307a5c950d0d8$var$fillStyle() : 'width: fit-content;';
}, function(props) {
    return (props.pad || props.theme.checkBox.pad) && (0, $73ba8e2d301b823f$export$944a9710f9445eee)('padding', props.pad || props.theme.checkBox.pad, props.responsive, props.theme.box.responsiveBreakpoint, props.theme);
}, function(props) {
    return props.disabled && $e75307a5c950d0d8$var$disabledStyle;
}, function(props) {
    return !props.disabled && 'cursor: pointer;';
}, $e75307a5c950d0d8$var$hoverStyle, function(props) {
    var _props$theme$checkBox4, _props$theme$checkBox5;
    return props.focus && !props.focusIndicator && "\n    input:not([disabled]) + div,\n    input:not([disabled]) + span {\n      border-color: " + (0, $11317b0e49e0d157$export$4cde5df63f53f473)((_props$theme$checkBox4 = props.theme.checkBox.hover) == null || (_props$theme$checkBox4 = _props$theme$checkBox4.border) == null ? void 0 : _props$theme$checkBox4.color, props.theme) + ";\n    }\n\n    background-color: " + (0, $11317b0e49e0d157$export$4cde5df63f53f473)(!props.disabled && ((_props$theme$checkBox5 = props.theme.checkBox.hover) == null || (_props$theme$checkBox5 = _props$theme$checkBox5.background) == null ? void 0 : _props$theme$checkBox5.color), props.theme) + ";";
}, function(props) {
    return props.theme.checkBox.extend;
});
var $e75307a5c950d0d8$export$cfaa8b267e569e86 = (0, $iA1nz.default).input.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxInput",
    componentId: "sc-1dbk5ju-2"
})([
    "opacity:0;-moz-appearance:none;width:0;height:0;margin:0;",
    " &:checked + span > span{",
    ":calc( ",
    " - ",
    " );background:",
    ";}"
], function(props) {
    return !props.disabled && 'cursor: pointer;';
}, function(props) {
    return !props.theme.dir ? 'left' : 'right';
}, function(props) {
    return props.theme.checkBox.toggle.size;
}, function(props) {
    return props.theme.checkBox.size;
}, function(props) {
    return (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.theme.checkBox.color || 'control', props.theme);
});
var $e75307a5c950d0d8$export$85d649873caec356 = (0, $iA1nz.default)((0, $18c0523379e5dd9d$export$e71c4d32a2263218)).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxBox",
    componentId: "sc-1dbk5ju-3"
})([
    "",
    ";",
    ";"
], function(props) {
    return props.focus && props.focusIndicator && (0, $73ba8e2d301b823f$export$efbff472cb39d8b)();
}, function(props) {
    return props.theme.checkBox.check.extend;
});
var $e75307a5c950d0d8$export$3bdb76e4c33903d5 = (0, $iA1nz.default).span.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxToggle",
    componentId: "sc-1dbk5ju-4"
})([
    "box-sizing:border-box;vertical-align:middle;display:inline-block;width:",
    ";height:",
    ";border:",
    " solid;border-color:",
    ";border-radius:",
    ";background-color:",
    ";",
    ";",
    ";"
], function(props) {
    return props.theme.checkBox.toggle.size;
}, function(props) {
    return props.theme.checkBox.size;
}, function(props) {
    return props.theme.checkBox.border.width;
}, function(props) {
    return (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.theme.checkBox.border.color, props.theme);
}, function(props) {
    return props.theme.checkBox.toggle.radius;
}, function(props) {
    return props.theme.checkBox.toggle.background ? (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.theme.checkBox.toggle.background, props.theme) : 'transparent';
}, function(props) {
    return props.focus && props.focusIndicator && (0, $73ba8e2d301b823f$export$efbff472cb39d8b)();
}, function(props) {
    return props.theme.checkBox.toggle.extend;
});
var $e75307a5c950d0d8$export$848dcdc388a1c52f = (0, $iA1nz.default).span.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxKnob",
    componentId: "sc-1dbk5ju-5"
})([
    "box-sizing:border-box;position:relative;display:inherit;top:-",
    ";",
    ":-",
    ";transition:all 0.3s;width:",
    ";height:",
    ";background:",
    ";border-radius:",
    ";",
    ";"
], function(props) {
    return props.theme.checkBox.border.width;
}, function(props) {
    return !props.theme.dir ? 'left' : 'right';
}, function(props) {
    return props.theme.checkBox.border.width;
}, function(props) {
    return props.theme.checkBox.size;
}, function(props) {
    return props.theme.checkBox.size;
}, function(props) {
    return (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.theme.checkBox.toggle.color, props.theme);
}, function(props) {
    return props.theme.checkBox.toggle.radius;
}, function(props) {
    return props.theme.checkBox.toggle.knob.extend;
});
var $e75307a5c950d0d8$export$150f188f805089fa = (0, $iA1nz.default)((0, $18c0523379e5dd9d$export$e71c4d32a2263218)).withConfig({
    displayName: "StyledCheckBox",
    componentId: "sc-1dbk5ju-6"
})([
    "flex-shrink:0;"
]);




var $2c7296f45cd5dd1d$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "checked",
    "children",
    "containerProps",
    "defaultChecked",
    "disabled",
    "fill",
    "focus",
    "focusIndicator",
    "id",
    "label",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseOut",
    "onMouseOver",
    "pad",
    "reverse",
    "toggle",
    "indeterminate"
];
function $2c7296f45cd5dd1d$var$_extends() {
    return $2c7296f45cd5dd1d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2c7296f45cd5dd1d$var$_extends.apply(null, arguments);
}
function $2c7296f45cd5dd1d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $2c7296f45cd5dd1d$var$stopLabelClick = function stopLabelClick(event) {
    // prevents clicking on the label trigging the event twice
    // https://stackoverflow.com/questions/24501497/why-the-onclick-element-will-trigger-twice-for-label-element
    if (event.target.type !== 'checkbox') event.stopPropagation();
};
var $2c7296f45cd5dd1d$export$ea5f704b89d806f6 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var _ref2;
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], checkedProp = _ref.checked, children = _ref.children, containerProps = _ref.containerProps, _ref$defaultChecked = _ref.defaultChecked, defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked, disabled = _ref.disabled, fill = _ref.fill, focusProp = _ref.focus, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, id = _ref.id, label = _ref.label, name = _ref.name, _onBlur = _ref.onBlur, _onChange = _ref.onChange, _onFocus = _ref.onFocus, _onMouseEnter = _ref.onMouseEnter, _onMouseLeave = _ref.onMouseLeave, _onMouseOut = _ref.onMouseOut, _onMouseOver = _ref.onMouseOver, pad = _ref.pad, reverse = _ref.reverse, toggle = _ref.toggle, indeterminate = _ref.indeterminate, rest = $2c7296f45cd5dd1d$var$_objectWithoutPropertiesLoose(_ref, $2c7296f45cd5dd1d$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var formContext = (0, $2xPiy.useContext)((0, $55ac84ad3d20c8d4$export$c24727297075ec6a));
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: checkedProp,
        initialValue: defaultChecked
    }), checked = _formContext$useFormI[0], setChecked = _formContext$useFormI[1];
    var _useState = (0, $2xPiy.useState)(focusProp), focus = _useState[0], setFocus = _useState[1];
    (0, $2xPiy.useEffect)(function() {
        // don't allow checkbox to have focus when disabled
        if (disabled && focusProp) setFocus(false);
        else setFocus(focusProp);
    }, [
        disabled,
        focusProp
    ]);
    (0, $2xPiy.useEffect)(function() {
        if (checkedProp && indeterminate) console.warn('Checkbox cannot be "checked" and "indeterminate" at the same time.');
        if (toggle && indeterminate) console.warn('Checkbox of type toggle does not have "indeterminate" state.');
    }, [
        checkedProp,
        toggle,
        indeterminate
    ]);
    var themeableProps = {
        checked: checked,
        disabled: disabled,
        focus: focus,
        // when contained in a FormField, focusIndicator = false,
        // so that the FormField has focus style. However, we still
        // need to visually indicate when a CheckBox is active.
        // If focus = true but focusIndicator = false,
        // we will apply the hover treament.
        focusIndicator: focusIndicator,
        reverse: reverse,
        toggle: toggle,
        indeterminate: indeterminate
    };
    var hidden;
    if (disabled && checked) hidden = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("input", {
        name: name,
        type: "hidden",
        value: "true"
    });
    var _theme$checkBox$icons = theme.checkBox.icons, CheckedIcon = _theme$checkBox$icons.checked, IndeterminateIcon = _theme$checkBox$icons.indeterminate;
    var borderColor = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(theme.checkBox.border.color, theme);
    if (checked) borderColor = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(theme.checkBox.color || 'control', theme);
    var visual = toggle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $e75307a5c950d0d8$export$3bdb76e4c33903d5), $2c7296f45cd5dd1d$var$_extends({}, passThemeFlag, themeableProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $e75307a5c950d0d8$export$848dcdc388a1c52f), $2c7296f45cd5dd1d$var$_extends({}, passThemeFlag, themeableProps))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $e75307a5c950d0d8$export$85d649873caec356), $2c7296f45cd5dd1d$var$_extends({
        align: "center",
        justify: "center",
        width: theme.checkBox.size,
        height: theme.checkBox.size,
        border: {
            size: theme.checkBox.border.width,
            color: borderColor
        },
        round: theme.checkBox.check.radius
    }, passThemeFlag, themeableProps), !indeterminate && checked && (CheckedIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(CheckedIcon, {
        theme: theme,
        as: (0, $e75307a5c950d0d8$export$59aa90b6aef14a9a)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $e75307a5c950d0d8$export$59aa90b6aef14a9a), $2c7296f45cd5dd1d$var$_extends({
        theme: theme,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "xMidYMid meet"
    }, themeableProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        d: "M6,11.3 L10.3,16 L18,6.2"
    }))), !checked && indeterminate && (IndeterminateIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(IndeterminateIcon, {
        theme: theme,
        as: (0, $e75307a5c950d0d8$export$59aa90b6aef14a9a)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $e75307a5c950d0d8$export$59aa90b6aef14a9a), $2c7296f45cd5dd1d$var$_extends({
        theme: theme,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "xMidYMid meet"
    }, themeableProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        d: "M6,12 L18,12"
    }))));
    var side = !reverse !== !theme.dir ? 'left' : 'right';
    var checkBoxNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $e75307a5c950d0d8$export$150f188f805089fa), $2c7296f45cd5dd1d$var$_extends({
        align: "center",
        justify: "center",
        margin: label && (_ref2 = {}, _ref2[side] = theme.checkBox.gap, _ref2)
    }, themeableProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $e75307a5c950d0d8$export$cfaa8b267e569e86), $2c7296f45cd5dd1d$var$_extends({
        "aria-label": ariaLabel || a11yTitle
    }, passThemeFlag, rest, {
        ref: ref,
        type: "checkbox"
    }, (0, $cdf577e3272e3992$export$c499305a875a8ee9)({
        id: id,
        name: name,
        checked: checked,
        disabled: disabled
    }), themeableProps, {
        onFocus: function onFocus(event) {
            setFocus(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        onChange: function onChange(event) {
            setChecked(event.target.checked);
            if (_onChange) _onChange(event);
        }
    })), children ? children({
        checked: checked,
        indeterminate: indeterminate
    }) : visual, hidden);
    var normalizedLabel = typeof label === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("span", null, label) : label;
    var first = reverse ? normalizedLabel : checkBoxNode;
    var second = reverse ? checkBoxNode : normalizedLabel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $e75307a5c950d0d8$export$644eb5002e1279aa), $2c7296f45cd5dd1d$var$_extends({
        fillProp: fill,
        reverse: reverse
    }, (0, $cdf577e3272e3992$export$c499305a875a8ee9)({
        htmlFor: id,
        disabled: disabled
    }), {
        checked: checked,
        labelProp: label,
        onClick: $2c7296f45cd5dd1d$var$stopLabelClick,
        pad: pad,
        onMouseEnter: function onMouseEnter(event) {
            return _onMouseEnter == null ? void 0 : _onMouseEnter(event);
        },
        onMouseOver: function onMouseOver(event) {
            return _onMouseOver == null ? void 0 : _onMouseOver(event);
        },
        onMouseLeave: function onMouseLeave(event) {
            return _onMouseLeave == null ? void 0 : _onMouseLeave(event);
        },
        onMouseOut: function onMouseOut(event) {
            return _onMouseOut == null ? void 0 : _onMouseOut(event);
        }
    }, passThemeFlag, themeableProps, containerProps), first, second);
});
$2c7296f45cd5dd1d$export$ea5f704b89d806f6.displayName = 'CheckBox';
$2c7296f45cd5dd1d$export$ea5f704b89d806f6.propTypes = (0, $f41fd893b2054d9b$export$7aa8af94cfcf92cd);



var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");




var $2xPiy = parcelRequire("2xPiy");
var $4aaa96463ff2e808$export$93e4b0b2cc49b648 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createContext(undefined);



var $iA1nz = parcelRequire("iA1nz");

var $9de0322d52c6c5ff$var$SIZE_MAP = {
    '1/2': '50%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    '1/3': '33.33%',
    '2/3': '66.66%'
};
var $9de0322d52c6c5ff$var$sizeStyle = (0, $iA1nz.css)([
    "width:",
    ";max-width:",
    ";overflow:hidden;"
], function(props) {
    return props.size === 'auto' ? // setting width to a small value will allow
    // the cell to fit width of its content. this
    // is a commonly implemented CSS pattern to
    // allow an auto-width behavior on fixed table
    // layouts (which is what DataTable applies)
    // https://stackoverflow.com/questions/4757844/css-table-column-autowidth?noredirect=1&lq=1
    '1px' : $9de0322d52c6c5ff$var$SIZE_MAP[props.size] || props.theme.global.size[props.size] || props.size;
}, function(props) {
    return props.size !== 'auto' ? $9de0322d52c6c5ff$var$SIZE_MAP[props.size] || props.theme.global.size[props.size] || props.size : undefined;
});
var $9de0322d52c6c5ff$export$9253e4f716553796 = (0, $iA1nz.default).td.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledTable__StyledTableCell",
    componentId: "sc-1m3u5g-0"
})([
    "margin:0;padding:0;font-weight:inherit;text-align:inherit;",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return props.size && $9de0322d52c6c5ff$var$sizeStyle;
}, function(props) {
    return props.verticalAlign && "vertical-align: " + props.verticalAlign + ";";
}, function(props) {
    return props.align && "text-align: " + props.align + ";";
}, function(props) {
    return props.background && (0, $0b4a347e23c22183$export$e43a4f0de05cb7e9)(props.background, props.theme);
}, function(props) {
    return props.border && (0, $1d37a3883a1c6277$export$4d0a7f76ad443516)(props.border, props.responsive, props.theme);
}, function(props) {
    return props.pad && (0, $73ba8e2d301b823f$export$944a9710f9445eee)('padding', props.pad, props.responsive, props.theme.box.responsiveBreakpoint, props.theme);
}, function(props) {
    return props.tableContextTheme && props.tableContextTheme.extend;
});
var $9de0322d52c6c5ff$export$9c29fe8f594afe44 = (0, $iA1nz.default).caption.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledTable__StyledTableDataCaption",
    componentId: "sc-1m3u5g-1"
})([
    "",
    ""
], function(props) {
    return (0, $73ba8e2d301b823f$export$944a9710f9445eee)('margin', props.theme.table.caption.margin, false, props.theme.global.edgeSize.responsiveBreakpoint, props.theme);
});
var $9de0322d52c6c5ff$export$8a602e750662ba27 = (0, $iA1nz.default).tr.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledTable__StyledTableRow",
    componentId: "sc-1m3u5g-2"
})([
    ""
]);
var $9de0322d52c6c5ff$export$cd928bb20d3ce93f = (0, $iA1nz.default).tbody.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledTable__StyledTableBody",
    componentId: "sc-1m3u5g-3"
})([
    ""
]);
var $9de0322d52c6c5ff$export$7f6303d004e2beb = (0, $iA1nz.default).thead.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledTable__StyledTableHeader",
    componentId: "sc-1m3u5g-4"
})([
    ""
]);
var $9de0322d52c6c5ff$export$246ad668d62a675a = (0, $iA1nz.default).tfoot.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledTable__StyledTableFooter",
    componentId: "sc-1m3u5g-5"
})([
    ""
]);
var $9de0322d52c6c5ff$export$a6cc9d741fb2f287 = (0, $iA1nz.default).table.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledTable",
    componentId: "sc-1m3u5g-6"
})([
    "border-spacing:0;border-collapse:collapse;width:inherit;",
    " ",
    ";"
], (0, $73ba8e2d301b823f$export$a157b298d219a801), function(props) {
    return props.theme.table && props.theme.table.extend;
});



var $dyr1f = parcelRequire("dyr1f");
var $8238cf810e8163dc$var$BORDER_SHAPE = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
    color: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            light: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        })
    ]),
    side: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'top',
        'left',
        'bottom',
        'right',
        'start',
        'end',
        'horizontal',
        'vertical',
        'all',
        'between'
    ]),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    style: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'solid',
        'dashed',
        'dotted',
        'double',
        'groove',
        'ridge',
        'inset',
        'outset',
        'hidden'
    ])
});
var $8238cf810e8163dc$var$PropType = {};
$8238cf810e8163dc$var$PropType = {
    border: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'top',
            'left',
            'bottom',
            'right',
            'start',
            'end',
            'horizontal',
            'vertical',
            'all'
        ]),
        $8238cf810e8163dc$var$BORDER_SHAPE,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf($8238cf810e8163dc$var$BORDER_SHAPE)
    ]),
    plain: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'noPad'
        ])
    ]),
    scope: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'col',
        'row'
    ]),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'xxsmall',
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            '1/2',
            '1/3',
            '2/3',
            '1/4',
            '2/4',
            '3/4'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    verticalAlign: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'top',
        'middle',
        'bottom'
    ]),
    align: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'left',
            'right',
            'center',
            'justify',
            'inherit',
            'start',
            'end'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ])
};
var $8238cf810e8163dc$export$28beafd39afe4e80 = $8238cf810e8163dc$var$PropType;



var $ab315163778b3d77$var$_excluded = [
    "align",
    "aria-disabled",
    "background",
    "border",
    "children",
    "className",
    "colSpan",
    "onResize",
    "onWidth",
    "pad",
    "plain",
    "rowSpan",
    "scope",
    "size",
    "verticalAlign",
    "property"
];
function $ab315163778b3d77$var$_extends() {
    return $ab315163778b3d77$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ab315163778b3d77$var$_extends.apply(null, arguments);
}
function $ab315163778b3d77$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $ab315163778b3d77$export$4671998ee1170a79 = {
    middle: 'center',
    top: 'start',
    bottom: 'end'
};
var $ab315163778b3d77$export$1e4baea7053fc0e3 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var align = _ref.align, ariaDisabled = _ref['aria-disabled'], background = _ref.background, border = _ref.border, children = _ref.children, className = _ref.className, colSpan = _ref.colSpan, onResize = _ref.onResize, onWidth = _ref.onWidth, pad = _ref.pad, plain = _ref.plain, rowSpan = _ref.rowSpan, scope = _ref.scope, size = _ref.size, verticalAlign = _ref.verticalAlign, property = _ref.property, rest = $ab315163778b3d77$var$_objectWithoutPropertiesLoose(_ref, $ab315163778b3d77$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var tableContext = (0, $2xPiy.useContext)((0, $4aaa96463ff2e808$export$93e4b0b2cc49b648));
    var cellRef = (0, $3cecef11d3b9c451$export$61dc559f8a0b9bcf)(ref);
    var containerRef = (0, $2xPiy.useRef)();
    var widthRef = (0, $2xPiy.useRef)();
    // if the screen is resized, we need to recalculate the width
    (0, $9462599f26e06396$export$e5c5a5f917a5871c)(function() {
        var handleResize = function handleResize() {
            if (onResize && property && cellRef.current) {
                var _cellRef$current$getB = cellRef.current.getBoundingClientRect(), width = _cellRef$current$getB.width;
                onResize(property, width);
            }
        };
        window.addEventListener('resize', handleResize);
        return function() {
            return window.removeEventListener('resize', handleResize);
        };
    }, [
        cellRef,
        onResize,
        property
    ]);
    (0, $9462599f26e06396$export$e5c5a5f917a5871c)(function() {
        var resizeObserver;
        var element = cellRef.current;
        if (onWidth) {
            if (typeof window !== 'undefined' && window.ResizeObserver) {
                resizeObserver = new window.ResizeObserver(function(entries) {
                    var entry = entries[0].borderBoxSize[0];
                    var width = entry == null ? void 0 : entry.inlineSize;
                    if (widthRef.current !== width) {
                        widthRef.current = width;
                        onWidth(width);
                    }
                });
                if (element) resizeObserver.observe(cellRef.current);
            } else {
                // fallback for server side rendering
                var _cellRef$current$getB2 = cellRef.current.getBoundingClientRect(), width = _cellRef$current$getB2.width;
                if (widthRef.current !== width) {
                    widthRef.current = width;
                    onWidth(width);
                }
            }
        }
        return function() {
            if (resizeObserver && element) resizeObserver.unobserve(element);
        };
    }, [
        onWidth,
        cellRef,
        widthRef
    ]);
    // if window resizes, recalculate cell height so that content
    // will continue to fill the height if the dimensions of the cell
    // have changed
    (0, $2xPiy.useEffect)(function() {
        var updateHeight = function updateHeight() {
            if (plain === 'noPad') {
                var cell = cellRef.current;
                var container = containerRef.current;
                if (cell && container) {
                    container.style.height = '';
                    var cellRect = cell.getBoundingClientRect();
                    // height must match cell height otherwise table will apply some
                    // margin around the cell content
                    container.style.height = Math.max(cellRect.height - (border || theme.table[tableContext].border ? theme.global.borderSize.xsmall.replace('px', '') : 0), 0) + "px";
                }
            }
        };
        window.addEventListener('resize', updateHeight);
        updateHeight();
        return function() {
            window.removeEventListener('resize', updateHeight);
        };
    }, [
        border,
        cellRef,
        plain,
        tableContext,
        theme.global.borderSize,
        theme.table
    ]);
    var tableContextTheme;
    if (tableContext === 'header') tableContextTheme = theme.table && theme.table.header;
    else if (tableContext === 'footer') tableContextTheme = theme.table && theme.table.footer;
    else tableContextTheme = theme.table && theme.table.body;
    // merge tableContextTheme and rest
    var mergedProps = $ab315163778b3d77$var$_extends({}, tableContextTheme, rest);
    Object.keys(mergedProps).forEach(function(key) {
        if (rest[key] === undefined) mergedProps[key] = tableContextTheme[key];
    });
    // split out background, border, pad, and aria-disabled
    var cellProps = {
        align: align || mergedProps.align || undefined,
        'aria-disabled': ariaDisabled || undefined,
        background: background || mergedProps.background || undefined,
        border: border || mergedProps.border || undefined,
        pad: plain !== 'noPad' ? pad || mergedProps.pad || undefined : undefined,
        verticalAlign: verticalAlign || mergedProps.verticalAlign || undefined
    };
    delete mergedProps.align;
    delete mergedProps.ariaDisabled;
    delete mergedProps.background;
    delete mergedProps.border;
    delete mergedProps.pad;
    delete mergedProps.verticalAlign;
    var content = children;
    if (plain === 'noPad' && children) // a Box with explicitly set height is necessary
    // for the child contents to be able to fill the
    // TableCell
    content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        ref: containerRef,
        justify: verticalAlign ? $ab315163778b3d77$export$4671998ee1170a79[verticalAlign] : 'center'
    }, children);
    // construct a new theme object in case we have a background that wants
    // to change the background color context
    var nextTheme = (0, $2xPiy.useMemo)(function() {
        var result;
        if (cellProps.background || theme.darkChanged) {
            var dark = (0, $0b4a347e23c22183$export$d285dc898c6a4d11)(cellProps.background, theme);
            var darkChanged = dark !== undefined && dark !== theme.dark;
            if (darkChanged || theme.darkChanged) {
                result = $ab315163778b3d77$var$_extends({}, theme);
                result.dark = dark === undefined ? theme.dark : dark;
                result.background = cellProps.background;
            } else if (cellProps.background) {
                // This allows DataTable to intelligently set the background
                // of a pinned header or footer.
                result = $ab315163778b3d77$var$_extends({}, theme);
                result.background = cellProps.background;
            }
        }
        return result || theme;
    }, [
        cellProps.background,
        theme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $iA1nz.ThemeContext).Provider, {
        value: nextTheme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $9de0322d52c6c5ff$export$9253e4f716553796), $ab315163778b3d77$var$_extends({
        ref: cellRef,
        as: scope ? 'th' : undefined,
        scope: scope,
        size: size,
        colSpan: colSpan,
        rowSpan: rowSpan,
        tableContext: tableContext,
        tableContextTheme: tableContextTheme
    }, plain === true ? mergedProps : {}, cellProps, {
        className: className
    }, passThemeFlag), plain || !Object.keys(mergedProps).length ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), $ab315163778b3d77$var$_extends({}, mergedProps, {
        align: align,
        justify: $ab315163778b3d77$export$4671998ee1170a79[verticalAlign]
    }), children)));
});
$ab315163778b3d77$export$1e4baea7053fc0e3.displayName = 'TableCell';
$ab315163778b3d77$export$1e4baea7053fc0e3.propTypes = (0, $8238cf810e8163dc$export$28beafd39afe4e80);




var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");
var $7996618d0f2a9e28$exports = {};

$parcel$export($7996618d0f2a9e28$exports, "__esModule", function () { return $7996618d0f2a9e28$export$1e511d4a378977f5; }, function (v) { return $7996618d0f2a9e28$export$1e511d4a378977f5 = v; });
$parcel$export($7996618d0f2a9e28$exports, "Add", function () { return $7996618d0f2a9e28$export$d0265b2c425512d6; }, function (v) { return $7996618d0f2a9e28$export$d0265b2c425512d6 = v; });
var $7996618d0f2a9e28$export$1e511d4a378977f5;
var $7996618d0f2a9e28$export$d0265b2c425512d6;
"use strict";
$7996618d0f2a9e28$export$1e511d4a378977f5 = true;
$7996618d0f2a9e28$export$d0265b2c425512d6 = void 0;

var $7996618d0f2a9e28$var$_react = $7996618d0f2a9e28$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $7996618d0f2a9e28$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7996618d0f2a9e28$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7996618d0f2a9e28$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $7996618d0f2a9e28$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7996618d0f2a9e28$var$_extends() {
    return $7996618d0f2a9e28$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7996618d0f2a9e28$var$_extends.apply(null, arguments);
}
var $7996618d0f2a9e28$var$Add = $7996618d0f2a9e28$export$d0265b2c425512d6 = /*#__PURE__*/ (0, $7996618d0f2a9e28$var$_react.forwardRef)(function(props, ref) {
    var scaleProps = (0, $1b754218be0a6592$export$56a2e46cd4a7c217)(props);
    return /*#__PURE__*/ $7996618d0f2a9e28$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $7996618d0f2a9e28$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Add"
    }, props), /*#__PURE__*/ $7996618d0f2a9e28$var$_react["default"].createElement("path", $7996618d0f2a9e28$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22V2M2 12h20"
    }, scaleProps)));
});
$7996618d0f2a9e28$var$Add.displayName = 'Add';






var $2xPiy = parcelRequire("2xPiy");




var $dyr1f = parcelRequire("dyr1f");

function $512f808ea5704fe3$var$_extends() {
    return $512f808ea5704fe3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $512f808ea5704fe3$var$_extends.apply(null, arguments);
}
var $512f808ea5704fe3$var$PropType = {};
$512f808ea5704fe3$var$PropType = $512f808ea5704fe3$var$_extends({}, (0, $ab32ce3df36aa105$export$ffe37ff34eeb9e21), {
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    dropAlign: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        top: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'top',
            'bottom'
        ]),
        bottom: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'top',
            'bottom'
        ]),
        right: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'left',
            'right'
        ]),
        left: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'left',
            'right'
        ])
    }),
    dropContent: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).element.isRequired,
    dropTarget: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object,
    dropProps: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    open: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
});
var $512f808ea5704fe3$export$4962ab15dba8ac7 = $512f808ea5704fe3$var$PropType;


var $c9158ac1cba12f75$var$_excluded = [
    "a11yTitle",
    "onAlign",
    "disabled",
    "dropAlign",
    "dropProps",
    "dropContent",
    "dropTarget",
    "id",
    "open",
    "onClick",
    "onClose",
    "onOpen"
];
function $c9158ac1cba12f75$var$_extends() {
    return $c9158ac1cba12f75$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c9158ac1cba12f75$var$_extends.apply(null, arguments);
}
function $c9158ac1cba12f75$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $c9158ac1cba12f75$var$defaultDropAlign = {
    top: 'top',
    left: 'left'
};
var $c9158ac1cba12f75$export$64fff40e709e8b2e = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var _ref$a11yTitle = _ref.a11yTitle, a11yTitle = _ref$a11yTitle === void 0 ? 'Open Drop' : _ref$a11yTitle, onAlign = _ref.onAlign, disabled = _ref.disabled, _ref$dropAlign = _ref.dropAlign, dropAlign = _ref$dropAlign === void 0 ? $c9158ac1cba12f75$var$defaultDropAlign : _ref$dropAlign, dropProps = _ref.dropProps, dropContent = _ref.dropContent, dropTarget = _ref.dropTarget, id = _ref.id, open = _ref.open, onClick = _ref.onClick, onClose = _ref.onClose, onOpen = _ref.onOpen, rest = $c9158ac1cba12f75$var$_objectWithoutPropertiesLoose(_ref, $c9158ac1cba12f75$var$_excluded);
    var buttonRef = (0, $3cecef11d3b9c451$export$61dc559f8a0b9bcf)(ref);
    var _useState = (0, $2xPiy.useState)(), show = _useState[0], setShow = _useState[1];
    (0, $2xPiy.useEffect)(function() {
        if (open !== undefined && open !== show) setShow(open);
    }, [
        open,
        show
    ]);
    var onDropClose = (0, $2xPiy.useCallback)(function(event) {
        // if the user has clicked on our Button, don't do anything here,
        // handle that in onClickInternal() below.
        var node = event.composed && event.composedPath()[0] || event.target;
        while(node && node !== document && !(node instanceof ShadowRoot) && node !== buttonRef.current)node = node.parentNode;
        if (node !== buttonRef.current) {
            // don't change internal state if caller is driving
            if (open === undefined) setShow(false);
            if (onClose) onClose(event);
        }
    }, [
        buttonRef,
        onClose,
        open
    ]);
    var onClickInternal = (0, $2xPiy.useCallback)(function(event) {
        if (!show) {
            setShow(true);
            if (onOpen) onOpen(event);
        } else {
            setShow(false);
            if (onClose) onClose(event);
        }
        if (onClick) onClick(event);
    }, [
        onClick,
        onClose,
        onOpen,
        show
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), $c9158ac1cba12f75$var$_extends({
        id: id,
        ref: buttonRef,
        a11yTitle: a11yTitle,
        disabled: disabled
    }, rest, {
        onClick: onClickInternal
    })), show && buttonRef.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $9f4217ea4a25a271$export$aaa698cd7aa517d6), $c9158ac1cba12f75$var$_extends({
        id: id ? id + "__drop" : undefined,
        onAlign: onAlign,
        restrictFocus: true,
        align: dropAlign,
        target: dropTarget || buttonRef,
        onClickOutside: onDropClose,
        onEsc: onDropClose
    }, dropProps), dropContent));
});
$c9158ac1cba12f75$export$64fff40e709e8b2e.displayName = 'DropButton';
$c9158ac1cba12f75$export$64fff40e709e8b2e.propTypes = (0, $512f808ea5704fe3$export$4962ab15dba8ac7);






// We determined 12 empirically as being wide enough to hit but
// not too wide to cause false hits.
var $17c91cc89c150a92$var$STEP = 12; // Used to determine the width change on resize
var $17c91cc89c150a92$var$resizerWidth = 24; // minimum width required for WCAG compliance
var $17c91cc89c150a92$var$StyledResizer = (0, $iA1nz.default)((0, $c9158ac1cba12f75$export$64fff40e709e8b2e)).withConfig({
    displayName: "Resizer__StyledResizer",
    componentId: "sc-8l808w-0"
})([
    "display:flex;justify-content:center;",
    ";",
    ";",
    " ",
    " ",
    " ",
    " position:absolute;width:",
    "px;height:100%;top:0;cursor:col-resize;z-index:1;"
], function(props) {
    var _props$theme$dataTabl;
    return (0, $73ba8e2d301b823f$export$944a9710f9445eee)('padding-top', (_props$theme$dataTabl = props.theme.dataTable) == null || (_props$theme$dataTabl = _props$theme$dataTabl.resize) == null || (_props$theme$dataTabl = _props$theme$dataTabl.padding) == null ? void 0 : _props$theme$dataTabl.vertical, false, props.theme.global.edgeSize.responsiveBreakpoint, props.theme);
}, function(props) {
    var _props$theme$dataTabl2;
    return (0, $73ba8e2d301b823f$export$944a9710f9445eee)('padding-bottom', (_props$theme$dataTabl2 = props.theme.dataTable) == null || (_props$theme$dataTabl2 = _props$theme$dataTabl2.resize) == null || (_props$theme$dataTabl2 = _props$theme$dataTabl2.padding) == null ? void 0 : _props$theme$dataTabl2.vertical, false, props.theme.global.edgeSize.responsiveBreakpoint, props.theme);
}, function(props) {
    return props.side === 'start' && "margin-left: -" + ($17c91cc89c150a92$var$resizerWidth / 2 - props.theme.global.borderSize.xsmall.replace('px', '')) + "px;";
}, function(props) {
    return props.side === 'start' && "left: 0;";
}, function(props) {
    return props.side === 'end' && "margin-right: -" + ($17c91cc89c150a92$var$resizerWidth / 2 - props.theme.global.borderSize.xsmall.replace('px', '')) + "px;";
}, function(props) {
    return props.side === 'end' && "right: 0;";
}, $17c91cc89c150a92$var$resizerWidth);
var $17c91cc89c150a92$export$48a76196cafe3b93 = function Resizer(_ref) {
    var _theme$dataTable$icon, _theme$dataTable$icon2, _border;
    var onResize = _ref.onResize, property = _ref.property, headerText = _ref.headerText, messages = _ref.messages, headerId = _ref.headerId;
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useState = (0, $2xPiy.useState)(false), active = _useState[0], setActive = _useState[1];
    var _useState2 = (0, $2xPiy.useState)(), start = _useState2[0], setStart = _useState2[1];
    var _useState3 = (0, $2xPiy.useState)(0), width = _useState3[0], setWidth = _useState3[1];
    var ref = (0, $2xPiy.useRef)();
    var thRef = (0, $2xPiy.useRef)();
    var _useContext = (0, $2xPiy.useContext)((0, $f1ad7bf122eed3b0$export$b060d577040138d8)), format = _useContext.format;
    var ResizeIncreaseIcon = ((_theme$dataTable$icon = theme.dataTable.icons) == null ? void 0 : _theme$dataTable$icon.resizeIncrease) || (0, $7996618d0f2a9e28$export$d0265b2c425512d6);
    var ResizeDecreaseIcon = ((_theme$dataTable$icon2 = theme.dataTable.icons) == null ? void 0 : _theme$dataTable$icon2.resizeDecrease) || (0, $6a2802ef8f2bd5f5$export$8bc67ae85ef4b74f);
    // Set the initial width based on the TH element's width and
    // store th element ref
    (0, $2xPiy.useEffect)(function() {
        if (ref.current) {
            var element = ref.current;
            // find TH parent
            while(element && element.nodeName !== 'TH')element = element.parentNode;
            thRef.current = element;
            var rect = element.getBoundingClientRect();
            // Set initial width based on the TH element's width
            setWidth(rect.width);
        }
    }, []);
    var onResizeStart = (0, $2xPiy.useCallback)(function(event) {
        var clientX = event.touches ? event.touches[0].clientX : event.clientX;
        if (thRef.current) {
            var element = thRef.current;
            var rect = element.getBoundingClientRect();
            setStart(clientX);
            setWidth(rect.width);
            setActive(true);
        }
    }, []);
    var onResizeMove = (0, $2xPiy.useCallback)(function(event) {
        var clientX = event.touches ? event.touches[0].clientX : event.clientX;
        var nextWidth = Math.max($17c91cc89c150a92$var$STEP, width + (clientX - start));
        onResize(property, nextWidth);
    }, [
        onResize,
        property,
        start,
        width
    ]);
    var onResizeEnd = (0, $2xPiy.useCallback)(function() {
        setActive(false);
        setStart(undefined);
        setWidth(undefined);
    }, []);
    (0, $2xPiy.useEffect)(function() {
        var remove = function remove() {
            document.removeEventListener('mouseup', onResizeEnd);
            document.removeEventListener('mousemove', onResizeMove);
            document.removeEventListener('touchend', onResizeEnd);
            document.removeEventListener('touchmove', onResizeMove);
        };
        if (active) {
            document.addEventListener('mouseup', onResizeEnd);
            document.addEventListener('mousemove', onResizeMove);
            document.addEventListener('touchend', onResizeEnd);
            document.addEventListener('touchmove', onResizeMove);
            return remove;
        }
        remove();
        return undefined;
    }, [
        active,
        onResizeMove,
        onResizeEnd
    ]);
    var border;
    if (theme.dataTable.resize.border.color && theme.dataTable.resize.border.side) {
        var _theme$dataTable$resi = theme.dataTable.resize.border, color = _theme$dataTable$resi.color, _theme$dataTable$resi2 = _theme$dataTable$resi.side, side = _theme$dataTable$resi2 === void 0 ? 'end' : _theme$dataTable$resi2;
        border = {
            color: color,
            side: side
        };
    }
    var hoverBorder = border;
    if (theme.dataTable.resize.hover && theme.dataTable.resize.hover.border) {
        var _theme$dataTable$resi3 = theme.dataTable.resize.hover.border, _color = _theme$dataTable$resi3.color, _theme$dataTable$resi4 = _theme$dataTable$resi3.side, _side = _theme$dataTable$resi4 === void 0 ? 'end' : _theme$dataTable$resi4, size = _theme$dataTable$resi3.size;
        hoverBorder = {
            color: _color,
            side: _side,
            size: size
        };
    }
    var onKeyDown = (0, $2xPiy.useCallback)(function(event) {
        event.preventDefault();
        if (!ref.current) return;
        if (thRef.current) {
            var element = thRef.current;
            var currentWidth = element.getBoundingClientRect().width;
            // Used STEP here to align with the value set in onMouseMove
            var delta = event.key === 'ArrowLeft' ? -$17c91cc89c150a92$var$STEP : $17c91cc89c150a92$var$STEP;
            onResize(property, currentWidth + delta);
            setWidth(currentWidth + delta);
        }
    }, [
        onResize,
        property
    ]);
    var onDecrease = (0, $2xPiy.useCallback)(function() {
        if (thRef.current) {
            var element = thRef.current;
            var rect = element.getBoundingClientRect();
            var currentWidth = rect.width;
            var nextWidth = Math.max($17c91cc89c150a92$var$STEP, currentWidth - $17c91cc89c150a92$var$STEP);
            setWidth(nextWidth);
            onResize(property, nextWidth);
        }
    }, [
        onResize,
        property
    ]);
    var onIncrease = (0, $2xPiy.useCallback)(function() {
        if (thRef.current) {
            var element = thRef.current;
            var rect = element.getBoundingClientRect();
            var currentWidth = rect.width;
            var nextWidth = Math.max($17c91cc89c150a92$var$STEP, currentWidth + $17c91cc89c150a92$var$STEP);
            setWidth(nextWidth);
            onResize(property, nextWidth);
        }
    }, [
        onResize,
        property
    ]);
    var _useState4 = (0, $2xPiy.useState)(false), hover = _useState4[0], setHover = _useState4[1];
    var ariaLabel = format({
        id: 'dataTable.resizerAria',
        values: {
            headerText: headerText
        },
        messages: messages
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $168667f04da9206c$export$16e4d70cc375e707), {
        onLeft: onKeyDown,
        onRight: onKeyDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($17c91cc89c150a92$var$StyledResizer, {
        "aria-label": width ? ariaLabel + " " + Math.trunc(width) + " pixels" : ariaLabel,
        onMouseEnter: function onMouseEnter() {
            return setHover(true);
        },
        onMouseLeave: function onMouseLeave() {
            return setHover(false);
        },
        ref: ref,
        role: "separator",
        "aria-valuenow": width,
        "aria-valuetext": width ? ariaLabel + " " + Math.trunc(width) + " pixels" : ariaLabel,
        "aria-controls": headerId,
        "aria-orientation": "vertical",
        onMouseDown: onResizeStart,
        onMouseMove: start !== undefined ? onResizeMove : undefined,
        onMouseUp: start !== undefined ? onResizeEnd : undefined,
        onTouchStart: onResizeStart,
        onTouchMove: start !== undefined ? onResizeMove : undefined,
        onTouchEnd: start !== undefined ? onResizeEnd : undefined,
        dropContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            direction: "row",
            pad: "xsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
            "aria-label": format({
                id: 'dataTable.decrease',
                values: {
                    headerText: headerText
                },
                messages: messages
            }),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(ResizeDecreaseIcon, null),
            onClick: onDecrease,
            autoFocus: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
            "aria-label": format({
                id: 'dataTable.increase',
                values: {
                    headerText: headerText
                },
                messages: messages
            }),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(ResizeIncreaseIcon, null),
            onClick: onIncrease
        })),
        dropAlign: {
            top: 'bottom'
        },
        side: (_border = border) == null ? void 0 : _border.side
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        border: hover || active ? hoverBorder : border,
        height: "100%",
        alignSelf: "center"
    })));
};
$17c91cc89c150a92$export$48a76196cafe3b93.displayName = 'Resizer';



var $2xPiy = parcelRequire("2xPiy");
var $5e76eb42ddcb97c1$exports = {};

$parcel$export($5e76eb42ddcb97c1$exports, "__esModule", function () { return $5e76eb42ddcb97c1$export$1e511d4a378977f5; }, function (v) { return $5e76eb42ddcb97c1$export$1e511d4a378977f5 = v; });
$parcel$export($5e76eb42ddcb97c1$exports, "FormSearch", function () { return $5e76eb42ddcb97c1$export$620e475702cadb1e; }, function (v) { return $5e76eb42ddcb97c1$export$620e475702cadb1e = v; });
var $5e76eb42ddcb97c1$export$1e511d4a378977f5;
var $5e76eb42ddcb97c1$export$620e475702cadb1e;
"use strict";
$5e76eb42ddcb97c1$export$1e511d4a378977f5 = true;
$5e76eb42ddcb97c1$export$620e475702cadb1e = void 0;

var $5e76eb42ddcb97c1$var$_react = $5e76eb42ddcb97c1$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5e76eb42ddcb97c1$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5e76eb42ddcb97c1$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5e76eb42ddcb97c1$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5e76eb42ddcb97c1$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5e76eb42ddcb97c1$var$_extends() {
    return $5e76eb42ddcb97c1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5e76eb42ddcb97c1$var$_extends.apply(null, arguments);
}
var $5e76eb42ddcb97c1$var$FormSearch = $5e76eb42ddcb97c1$export$620e475702cadb1e = /*#__PURE__*/ (0, $5e76eb42ddcb97c1$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5e76eb42ddcb97c1$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5e76eb42ddcb97c1$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormSearch"
    }, props), /*#__PURE__*/ $5e76eb42ddcb97c1$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M13.8 13.8 18 18l-4.2-4.2zM10.5 15a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9z"
    }));
});
$5e76eb42ddcb97c1$var$FormSearch.displayName = 'FormSearch';







var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");




var $2xPiy = parcelRequire("2xPiy");




var $dyr1f = parcelRequire("dyr1f");
var $0f6e454d24e9fefa$var$PropType = {};
$0f6e454d24e9fefa$var$PropType = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    items: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).any),
    onMore: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    renderMarker: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    show: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
    step: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number
};
var $0f6e454d24e9fefa$export$2cd935ea72beacbd = $0f6e454d24e9fefa$var$PropType;


function $26613b622f673475$var$_readOnlyError(r) {
    throw new TypeError('"' + r + '" is read-only');
}
var $26613b622f673475$var$calculateLastPageBound = function calculateLastPageBound(show, step) {
    return show ? Math.floor((show + step) / step) - 1 : 0;
};
var $26613b622f673475$export$c5295390d6167a3e = function InfiniteScroll(_ref) {
    var children = _ref.children, _ref$items = _ref.items, items = _ref$items === void 0 ? [] : _ref$items, onMore = _ref.onMore, renderMarker = _ref.renderMarker, replace = _ref.replace, show = _ref.show, _ref$step = _ref.step, step = _ref$step === void 0 ? 50 : _ref$step;
    // item index to be made visible initially
    var _useState = (0, $2xPiy.useState)(), scrollShow = _useState[0], setScrollShow = _useState[1];
    // the last page we have items for
    var lastPage = (0, $2xPiy.useMemo)(function() {
        return Math.max(0, Math.ceil(items.length / step) - 1);
    }, [
        items.length,
        step
    ]);
    // the pages we are rendering
    var _useState2 = (0, $2xPiy.useState)([
        0,
        $26613b622f673475$var$calculateLastPageBound(show, step)
    ]), renderPageBounds = _useState2[0], setRenderPageBounds = _useState2[1];
    // the heights of the pages, approximated after we render the first page
    // and then updated for pages that have rendered
    var _useState3 = (0, $2xPiy.useState)([]), pageHeights = _useState3[0], setPageHeights = _useState3[1];
    // what we're waiting for onMore to give us
    var _useState4 = (0, $2xPiy.useState)(0), pendingLength = _useState4[0], setPendingLength = _useState4[1];
    var aboveMarkerRef = (0, $2xPiy.useRef)(); // only when replacing
    var belowMarkerRef = (0, $2xPiy.useRef)();
    // scroll and resize handling
    (0, $2xPiy.useEffect)(function() {
        var scrollParents;
        var evaluate = function evaluate() {
            if (!scrollParents) return;
            var scrollParent = scrollParents[0];
            // Determine the scroll position of the scroll container
            var top;
            var height;
            if (scrollParent === document) {
                top = document.documentElement.scrollTop || document.body.scrollTop;
                height = window.innerHeight;
            } else {
                top = scrollParent.scrollTop;
                var rect = scrollParent.getBoundingClientRect();
                height = rect.height;
            }
            var offset = height / 4; // so we pre-load when the user scrolls slowly
            // Use the pageHeights to determine what pages we should render based
            // on the current scroll window.
            var nextBeginPage = 0;
            var index = 0;
            var pagesHeight = pageHeights[index] || 0;
            while(pageHeights[index + 1] && pagesHeight < top - offset){
                index += 1;
                nextBeginPage += 1;
                pagesHeight += pageHeights[index];
            }
            var nextEndPage = nextBeginPage;
            while(pageHeights[index] !== undefined && pagesHeight < top + height + offset){
                index += 1;
                nextEndPage += 1;
                // when we haven't rendered the nextEndPage and we aren't replacing,
                // we might not have a height for it yet
                pagesHeight += pageHeights[index] || 0;
            }
            if (!replace) {
                // when not replacing, never shrink bounds
                nextBeginPage = 0;
                nextEndPage = Math.max(renderPageBounds[1], nextEndPage);
            }
            if (show) {
                // ensure we try to render any show page
                var showPage = $26613b622f673475$var$calculateLastPageBound(show, step);
                nextBeginPage = Math.min(showPage, nextBeginPage);
                nextEndPage = Math.max(showPage, nextEndPage);
            }
            if (nextBeginPage !== renderPageBounds[0] || nextEndPage !== renderPageBounds[1]) setRenderPageBounds([
                nextBeginPage,
                nextEndPage
            ]);
        };
        var timer;
        var debounce = function debounce() {
            clearTimeout(timer);
            timer = setTimeout(evaluate, 10);
        };
        // might not be there yet or might have already rendered everything
        if (belowMarkerRef.current) {
            scrollParents = (0, $83f2052c15a18307$export$14e46d92eb0648e)(belowMarkerRef.current);
            scrollParents.forEach(function(sp) {
                return sp.addEventListener('scroll', debounce);
            });
        }
        window.addEventListener('resize', debounce);
        evaluate();
        return function() {
            if (scrollParents) scrollParents.forEach(function(sp) {
                return sp.removeEventListener('scroll', debounce);
            });
            window.removeEventListener('resize', debounce);
            clearTimeout(timer);
        };
    }, [
        pageHeights,
        renderPageBounds,
        replace,
        show,
        step
    ]);
    // check if we need to ask for more
    (0, $2xPiy.useEffect)(function() {
        if (onMore && renderPageBounds[1] === lastPage && items.length >= pendingLength && items.length > 0) {
            // remember we've asked for more, so we don't keep asking if it takes
            // a while
            setPendingLength(items.length + 1);
            onMore();
        }
    }, [
        items.length,
        lastPage,
        onMore,
        pendingLength,
        renderPageBounds,
        step
    ]);
    (0, $2xPiy.useEffect)(function() {
        if (items.length === 0 && lastPage === 0 && pendingLength !== 0) {
            setPageHeights([]);
            setPendingLength(0);
            setRenderPageBounds([
                0,
                $26613b622f673475$var$calculateLastPageBound(show, step)
            ]);
        }
    }, [
        lastPage,
        pendingLength,
        show,
        step,
        items.length
    ]);
    // scroll to any 'show'
    (0, $9462599f26e06396$export$e5c5a5f917a5871c)(function() {
        // ride out any animation delays, 100ms empirically measured
        var timer = setTimeout(function() {
            if (show && belowMarkerRef.current && show !== scrollShow) {
                // calculate show index based on beginPage
                var showIndex = show - renderPageBounds[0] * step + (renderPageBounds[0] ? 1 : 0);
                var showNode = belowMarkerRef.current.parentNode.children.item(showIndex);
                if (showNode) {
                    var scrollParent = (0, $83f2052c15a18307$export$6a1689aaa66d814c)(showNode);
                    if ((0, $83f2052c15a18307$export$54c9800883215719)(showNode, scrollParent)) showNode.scrollIntoView(true);
                    else if ((0, $83f2052c15a18307$export$27af05f039e10378)(showNode, scrollParent)) showNode.scrollIntoView(false);
                    // clean up after having shown
                    setScrollShow(show);
                }
            }
        }, 100);
        return function() {
            return clearTimeout(timer);
        };
    // Omitting scrollShow as a dependency due to concern that setScrollShow
    // is being called within the timer. If left included, re-renders and other
    // dependency values could change in an unpredictable manner during timer
    // and potentially result in an infinite loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        renderPageBounds,
        show,
        step
    ]);
    // calculate and keep track of page heights
    (0, $9462599f26e06396$export$e5c5a5f917a5871c)(function() {
        // if don't have a belowMarker, we must have rendered everything already
        if (!belowMarkerRef.current) return;
        // calculate page heights for rendered pages
        var rendered = belowMarkerRef.current.parentNode.children;
        // ensure we've rendered the state we have
        // above? + items in rendered pages + below === rendered DOM elements length
        if ((aboveMarkerRef.current ? 1 : 0) + (renderPageBounds[1] - renderPageBounds[0] + 1) * step + 1 === rendered.length) {
            var nextPageHeights;
            // step through each page
            var i = renderPageBounds[0];
            var lastBottom;
            while(i <= renderPageBounds[1]){
                var topIndex = (aboveMarkerRef.current ? 1 : 0) + (i - renderPageBounds[0]) * step;
                var bottomIndex = Math.min(topIndex + step - 1, rendered.length - 1);
                // we use lastBottom for top to ensure grid layouts work
                var top = lastBottom !== undefined ? lastBottom : rendered.item(topIndex).getBoundingClientRect().top;
                var _rendered$item$getBou = rendered.item(bottomIndex).getBoundingClientRect(), bottom = _rendered$item$getBou.bottom;
                var height = bottom - top;
                if (bottom && (!pageHeights || pageHeights[i] !== height)) {
                    if (!nextPageHeights) nextPageHeights = [].concat(pageHeights || []);
                    nextPageHeights[i] = height;
                }
                lastBottom = bottom;
                i += 1;
            }
            // estimate page heights for pages we haven't rendered yet
            while(replace && i <= lastPage){
                if (!pageHeights[i] && pageHeights[i] !== pageHeights[0]) {
                    if (!nextPageHeights) nextPageHeights = [].concat(pageHeights || []);
                    // set to first page height
                    var _nextPageHeights = nextPageHeights;
                    nextPageHeights[i] = _nextPageHeights[0];
                }
                i += 1;
            }
            if (nextPageHeights) setPageHeights(nextPageHeights);
        }
    }, [
        lastPage,
        pageHeights,
        renderPageBounds,
        replace,
        step
    ]);
    // calculate the height above the first rendered page using the pageHeights
    var aboveHeight = (0, $2xPiy.useMemo)(function() {
        if (!replace) return 0;
        var height = 0;
        var i = 0;
        while(i < renderPageBounds[0]){
            height += pageHeights[i] || 0;
            i += 1;
        }
        return height;
    }, [
        pageHeights,
        renderPageBounds,
        replace
    ]);
    // calculate the height below the last rendered page using the pageHeights
    var belowHeight = (0, $2xPiy.useMemo)(function() {
        if (!replace) return 0;
        var height = 0;
        var i = renderPageBounds[1] + 1;
        while(i <= lastPage){
            height += pageHeights[i] || 0;
            i += 1;
        }
        return height;
    }, [
        lastPage,
        pageHeights,
        renderPageBounds,
        replace
    ]);
    var firstIndex = renderPageBounds[0] * step;
    var lastIndex = Math.min((renderPageBounds[1] + 1) * step, items.length) - 1;
    var result = [];
    if (aboveHeight) {
        var marker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            key: "above",
            ref: aboveMarkerRef,
            flex: false,
            height: aboveHeight + "px"
        });
        if (renderMarker) // need to give it a key
        marker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).cloneElement(renderMarker(marker), {
            key: 'above'
        });
        result.push(marker);
    }
    items.slice(firstIndex, lastIndex + 1).forEach(function(item, index) {
        var itemsIndex = firstIndex + index;
        var child = children(item, itemsIndex);
        result.push(child);
    });
    if (replace || renderPageBounds[1] < lastPage || onMore) {
        var _marker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            key: "below",
            ref: !renderMarker && belowMarkerRef || undefined,
            flex: false,
            height: (belowHeight || 0) + "px"
        });
        if (renderMarker) {
            // need to give it a key
            var renderedMarker = renderMarker(_marker);
            _marker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).cloneElement(renderedMarker, {
                key: 'below',
                // We need to make sure our belowMarkerRef is tied to a component
                // that has the same parent as the items being rendered. This is so
                // we can use belowMarkerRef.current.parentNode.children to
                // get a reference to the items in the DOM for calculating pageHeights.
                //
                // Since the caller might have included a ref in what their
                // renderMarker returns, we have to take care of both refs.
                // https://github.com/facebook/react/issues/8873#issuecomment-489579878
                ref: function ref(node) {
                    // Keep your own reference
                    belowMarkerRef.current = node;
                    // Call the original ref, if any
                    var ref = renderedMarker.ref;
                    if (typeof ref === 'function') ref(node);
                    else if (ref !== null) ref.current = node;
                }
            });
        }
        result.push(_marker);
    }
    return result;
};
$26613b622f673475$export$c5295390d6167a3e.propTypes = (0, $0f6e454d24e9fefa$export$2cd935ea72beacbd);







var $iA1nz = parcelRequire("iA1nz");



var $iA1nz = parcelRequire("iA1nz");


var $546d8bf2981e1998$export$28ff5f3fef0ffa78 = function readOnlyStyle(theme) {
    var _theme$global$input$r, _theme$global$input$r2, _theme$global$input$r3;
    var styles = [];
    if (theme != null && (_theme$global$input$r = theme.global.input.readOnly) != null && (_theme$global$input$r = _theme$global$input$r.border) != null && _theme$global$input$r.color) styles.push((0, $iA1nz.css)([
        "border-color:",
        ";"
    ], (0, $11317b0e49e0d157$export$4cde5df63f53f473)(theme.global.input.readOnly.border.color, theme)));
    if (theme != null && (_theme$global$input$r2 = theme.global.input.readOnly) != null && _theme$global$input$r2.background) styles.push((0, $0b4a347e23c22183$export$e43a4f0de05cb7e9)((_theme$global$input$r3 = theme.global.input.readOnly) == null ? void 0 : _theme$global$input$r3.background, theme));
    return styles;
};


var $71e4375a7ac36747$var$getPlainStyle = function getPlainStyle(plain) {
    if (plain === 'full') return (0, $iA1nz.css)([
        "",
        " padding:0;"
    ], (0, $73ba8e2d301b823f$export$f9510e7ca63c26e5));
    return plain && (0, $73ba8e2d301b823f$export$f9510e7ca63c26e5);
};
var $71e4375a7ac36747$export$46d060c4400937ed = (0, $iA1nz.default).input.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledTextInput",
    componentId: "sc-1x30a0s-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ";"
], (0, $73ba8e2d301b823f$export$533edcdef9a0af13), function(props) {
    return props.readOnlyCopy ? "padding-" + (props.reverse ? 'left' : 'right') + ": 0px;" : '';
}, function(props) {
    return props.readOnly && "border: none;";
}, function(props) {
    return $71e4375a7ac36747$var$getPlainStyle(props.plain);
}, function(props) {
    return props.icon && (0, $73ba8e2d301b823f$export$cd595fd57f72dbc4);
}, function(props) {
    return props.disabled && (0, $73ba8e2d301b823f$export$adf3fcef8e5e1347)(props.theme.textInput.disabled && props.theme.textInput.disabled.opacity);
}, function(props) {
    return props.textAlign && (0, $73ba8e2d301b823f$export$4fc8e4871b69e1d6);
}, function(props) {
    return props.widthProp && !props.readOnly && (0, $73ba8e2d301b823f$export$c12f8e3e33f3bef7)(props.widthProp, props.theme);
}, function(props) {
    return props.theme.textInput && props.theme.textInput.extend;
});
var $71e4375a7ac36747$export$4aa9d16f7efe0fb6 = (0, $iA1nz.default).div.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledTextInput__StyledTextInputContainer",
    componentId: "sc-1x30a0s-1"
})([
    "position:relative;width:100%;",
    " ",
    ";",
    ";",
    " ",
    ";"
], function(props) {
    return props.widthProp && props.readOnlyProp && (0, $73ba8e2d301b823f$export$c12f8e3e33f3bef7)(props.widthProp, props.theme);
}, function(props) {
    return props.readOnlyProp && !props.plain && (0, $73ba8e2d301b823f$export$717407de81592eca);
}, function(props) {
    return props.readOnlyCopy && "\n    box-sizing: border-box;\n    flex-direction: row;\n    display: flex;\n  ";
}, function(props) {
    return props.readOnlyProp && !props.plain && (0, $546d8bf2981e1998$export$28ff5f3fef0ffa78)(props.theme);
}, function(props) {
    return props.theme.textInput && props.theme.textInput.container && props.theme.textInput.container.extend;
});
var $71e4375a7ac36747$export$333ccef64da8eec4 = (0, $iA1nz.default).div.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledTextInput__StyledPlaceholder",
    componentId: "sc-1x30a0s-2"
})([
    "position:absolute;left:",
    "px;top:50%;transform:translateY(-50%);display:flex;justify-content:center;pointer-events:none;",
    ";"
], function(props) {
    return (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)((0, $73ba8e2d301b823f$export$c98305b6d8dc560)(props, 'left')) - (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(props.theme.global.control.border.width);
}, function(props) {
    return props.theme.textInput && props.theme.textInput.placeholder && props.theme.textInput.placeholder.extend;
});
var $71e4375a7ac36747$export$7c8f159da0dc916 = (0, $iA1nz.default).div.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledTextInput__StyledIcon",
    componentId: "sc-1x30a0s-3"
})([
    "position:absolute;display:flex;justify:center;top:50%;transform:translateY(-50%);pointer-events:none;",
    ""
], function(props) {
    return props.reverse ? "right: " + (0, $73ba8e2d301b823f$export$c98305b6d8dc560)(props, 'right') + ";" : "left: " + (0, $73ba8e2d301b823f$export$c98305b6d8dc560)(props, 'left') + ";";
});
var $71e4375a7ac36747$export$2f5b00b01ab6676b = (0, $iA1nz.default).ol.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledTextInput__StyledSuggestions",
    componentId: "sc-1x30a0s-4"
})([
    "border-top-left-radius:0;border-top-right-radius:0;margin:0;padding:0;list-style-type:none;",
    ";"
], function(props) {
    return props.theme.textInput && props.theme.textInput.suggestions && props.theme.textInput.suggestions.extend;
});




var $dyr1f = parcelRequire("dyr1f");

var $7f9c5cbf5f2cf702$var$PropType = {};
$7f9c5cbf5f2cf702$var$PropType = {
    a11yTitle: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    defaultSuggestion: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
    dropAlign: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        top: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'top',
            'bottom'
        ]),
        bottom: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'top',
            'bottom'
        ]),
        right: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'left',
            'right'
        ]),
        left: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'left',
            'right'
        ])
    }),
    dropHeight: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    dropTarget: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object,
    dropProps: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).element,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    focusIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    messages: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        enterSelect: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        suggestionsCount: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        suggestionsExist: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        suggestionIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    }),
    name: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onSuggestionSelect: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onSuggestionsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onSuggestionsClose: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node,
    plain: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'full'
        ])
    ]),
    readOnlyCopy: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    reverse: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            'xxlarge',
            '2xl',
            '3xl',
            '4xl',
            '5xl',
            '6xl'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    suggestions: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            label: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node,
            // eslint-disable-next-line
            value: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).any // this is intentional any
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ])),
    textAlign: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'start',
        'center',
        'end'
    ]),
    value: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number
    ]),
    width: (0, $ab32ce3df36aa105$export$7d45d0e6b7abd5e2)
};
var $7f9c5cbf5f2cf702$export$2cabbaef9a75cbd2 = $7f9c5cbf5f2cf702$var$PropType;



var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");
var $cf62a042166a0000$exports = {};

$parcel$export($cf62a042166a0000$exports, "__esModule", function () { return $cf62a042166a0000$export$1e511d4a378977f5; }, function (v) { return $cf62a042166a0000$export$1e511d4a378977f5 = v; });
$parcel$export($cf62a042166a0000$exports, "Copy", function () { return $cf62a042166a0000$export$92ce62e1201c4fc0; }, function (v) { return $cf62a042166a0000$export$92ce62e1201c4fc0 = v; });
var $cf62a042166a0000$export$1e511d4a378977f5;
var $cf62a042166a0000$export$92ce62e1201c4fc0;
"use strict";
$cf62a042166a0000$export$1e511d4a378977f5 = true;
$cf62a042166a0000$export$92ce62e1201c4fc0 = void 0;

var $cf62a042166a0000$var$_react = $cf62a042166a0000$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $cf62a042166a0000$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($cf62a042166a0000$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $cf62a042166a0000$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $cf62a042166a0000$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $cf62a042166a0000$var$_extends() {
    return $cf62a042166a0000$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cf62a042166a0000$var$_extends.apply(null, arguments);
}
var $cf62a042166a0000$var$Copy = $cf62a042166a0000$export$92ce62e1201c4fc0 = /*#__PURE__*/ (0, $cf62a042166a0000$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $cf62a042166a0000$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $cf62a042166a0000$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Copy"
    }, props), /*#__PURE__*/ $cf62a042166a0000$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M9 15h8-8zm0-4h10H9zm0-4h4-4zm7-6v6h6M6 5H2v18h16v-4m4 0H6V1h11l5 5v13z"
    }));
});
$cf62a042166a0000$var$Copy.displayName = 'Copy';






function $313d8d7c610a335e$var$_extends() {
    return $313d8d7c610a335e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $313d8d7c610a335e$var$_extends.apply(null, arguments);
}
// to overcome `plain` styling due to (icon && !label) condition
// in buttons without theme.button.default, apply the padding here
var $313d8d7c610a335e$var$StyledButton = (0, $iA1nz.default)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1)).withConfig({
    displayName: "CopyButton__StyledButton",
    componentId: "sc-1bp1m18-0"
})([
    "border-radius:",
    ";",
    ""
], function(props) {
    return props.theme.global.control.border.radius;
}, function(props) {
    return !props.theme.button["default"] ? (0, $73ba8e2d301b823f$export$944a9710f9445eee)('padding', props.pad, false, undefined, props.theme) : '';
});
var $313d8d7c610a335e$export$4f2558dd25106ae2 = function CopyButton(_ref) {
    var _theme$textInput, _theme$global$input$p, _theme$global$input$p2, _theme$global$input$p3;
    var disabled = _ref.disabled, onClickCopy = _ref.onClickCopy, onBlurCopy = _ref.onBlurCopy, readOnlyCopyPrompt = _ref.readOnlyCopyPrompt, tip = _ref.tip, value = _ref.value;
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var CopyIcon = ((_theme$textInput = theme.textInput) == null || (_theme$textInput = _theme$textInput.icons) == null ? void 0 : _theme$textInput.copy) || (0, $cf62a042166a0000$export$92ce62e1201c4fc0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $ceab9ef72b825454$export$c92c6401b52a9298), {
        dropProps: {
            align: {
                bottom: 'top'
            }
        },
        content: tip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($313d8d7c610a335e$var$StyledButton, $313d8d7c610a335e$var$_extends({
        disabled: disabled,
        onClick: onClickCopy,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(CopyIcon, null),
        pad: {
            horizontal: (_theme$global$input$p = theme.global.input.padding) == null ? void 0 : _theme$global$input$p.horizontal,
            left: (_theme$global$input$p2 = theme.global.input.padding) == null ? void 0 : _theme$global$input$p2.left,
            right: (_theme$global$input$p3 = theme.global.input.padding) == null ? void 0 : _theme$global$input$p3.right,
            // only apply horizontal padding since button will
            // fill height of input
            top: '0',
            bottom: '0'
        },
        onBlur: onBlurCopy,
        onMouseOut: onBlurCopy,
        "aria-label": readOnlyCopyPrompt + " " + value
    }, passThemeFlag)));
};



var $8c9c99ffe8765a99$var$_excluded = [
    "a11yTitle",
    "defaultSuggestion",
    "defaultValue",
    "disabled",
    "dropAlign",
    "dropHeight",
    "dropTarget",
    "dropProps",
    "focusIndicator",
    "icon",
    "id",
    "messages",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onKeyDown",
    "onSelect",
    "onSuggestionSelect",
    "onSuggestionsClose",
    "onSuggestionsOpen",
    "placeholder",
    "plain",
    "readOnly",
    "readOnlyCopy",
    "reverse",
    "suggestions",
    "textAlign",
    "value",
    "width"
];
function $8c9c99ffe8765a99$var$_extends() {
    return $8c9c99ffe8765a99$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8c9c99ffe8765a99$var$_extends.apply(null, arguments);
}
function $8c9c99ffe8765a99$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $8c9c99ffe8765a99$var$renderLabel = function renderLabel(suggestion) {
    if (suggestion && typeof suggestion === 'object') return suggestion.label || suggestion.value;
    return suggestion;
};
var $8c9c99ffe8765a99$var$stringLabel = function stringLabel(suggestion) {
    if (suggestion && typeof suggestion === 'object') {
        if (suggestion.label && typeof suggestion.label === 'string') return suggestion.label;
        return suggestion.value;
    }
    return suggestion;
};
var $8c9c99ffe8765a99$var$ContainerBox = (0, $iA1nz.default)((0, $18c0523379e5dd9d$export$e71c4d32a2263218)).withConfig({
    displayName: "TextInput__ContainerBox",
    componentId: "sc-1ai0c08-0"
})([
    "",
    ";@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){width:100%;}"
], function(props) {
    return props.dropHeight ? (0, $73ba8e2d301b823f$export$cb60038e9cf9f581)('max-height', props.dropHeight, props.theme) : 'max-height: inherit;';
});
var $8c9c99ffe8765a99$var$defaultDropAlign = {
    top: 'bottom',
    left: 'left'
};
var $8c9c99ffe8765a99$export$c86715117507e8e5 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var _inputRef$current, _inputRef$current2;
    var a11yTitle = _ref.a11yTitle, defaultSuggestion = _ref.defaultSuggestion, defaultValue = _ref.defaultValue, disabled = _ref.disabled, _ref$dropAlign = _ref.dropAlign, dropAlign = _ref$dropAlign === void 0 ? $8c9c99ffe8765a99$var$defaultDropAlign : _ref$dropAlign, dropHeight = _ref.dropHeight, dropTarget = _ref.dropTarget, dropProps = _ref.dropProps, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, icon = _ref.icon, id = _ref.id, messages = _ref.messages, name = _ref.name, _onBlur = _ref.onBlur, onChange = _ref.onChange, _onFocus = _ref.onFocus, onKeyDown = _ref.onKeyDown, onSelect = _ref.onSelect, onSuggestionSelect = _ref.onSuggestionSelect, onSuggestionsClose = _ref.onSuggestionsClose, onSuggestionsOpen = _ref.onSuggestionsOpen, placeholder = _ref.placeholder, plain = _ref.plain, readOnlyProp = _ref.readOnly, readOnlyCopy = _ref.readOnlyCopy, reverse = _ref.reverse, suggestions = _ref.suggestions, textAlign = _ref.textAlign, valueProp = _ref.value, widthProp = _ref.width, rest = $8c9c99ffe8765a99$var$_objectWithoutPropertiesLoose(_ref, $8c9c99ffe8765a99$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useContext = (0, $2xPiy.useContext)((0, $f1ad7bf122eed3b0$export$b060d577040138d8)), format = _useContext.format;
    var announce = (0, $2xPiy.useContext)((0, $c8f61343d2547c6a$export$dcc8f4bff0d51f50));
    var formContext = (0, $2xPiy.useContext)((0, $55ac84ad3d20c8d4$export$c24727297075ec6a));
    var inputRef = (0, $3cecef11d3b9c451$export$61dc559f8a0b9bcf)(ref);
    var dropRef = (0, $2xPiy.useRef)();
    var suggestionsRef = (0, $2xPiy.useRef)();
    var readOnly = readOnlyProp || readOnlyCopy;
    // if this is a readOnly property, don't set a name with the form context
    // this allows Select to control the form context for the name.
    var _formContext$useFormI = formContext.useFormInput({
        name: readOnly ? undefined : name,
        value: valueProp
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    var _useState = (0, $2xPiy.useState)(), focus = _useState[0], setFocus = _useState[1];
    var _useState2 = (0, $2xPiy.useState)(false), showDrop = _useState2[0], setShowDrop = _useState2[1];
    var handleSuggestionSelect = (0, $2xPiy.useMemo)(function() {
        return onSelect && !onSuggestionSelect ? onSelect : onSuggestionSelect;
    }, [
        onSelect,
        onSuggestionSelect
    ]);
    var handleTextSelect = (0, $2xPiy.useMemo)(function() {
        return onSelect && onSuggestionSelect ? onSelect : undefined;
    }, [
        onSelect,
        onSuggestionSelect
    ]);
    var _useState3 = (0, $2xPiy.useState)(), suggestionsAtClose = _useState3[0], setSuggestionsAtClose = _useState3[1];
    var readOnlyCopyValidation = format({
        id: 'input.readOnlyCopy.validation',
        messages: messages
    });
    var readOnlyCopyPrompt = format({
        id: 'input.readOnlyCopy.prompt',
        messages: messages
    });
    var _useState4 = (0, $2xPiy.useState)(readOnlyCopyPrompt), tip = _useState4[0], setTip = _useState4[1];
    var onClickCopy = function onClickCopy() {
        navigator.clipboard.writeText(value);
        announce(readOnlyCopyValidation, 'assertive');
        setTip(readOnlyCopyValidation);
    };
    var onBlurCopy = function onBlurCopy() {
        if (tip === readOnlyCopyValidation) setTip(readOnlyCopyPrompt);
    };
    var openDrop = (0, $2xPiy.useCallback)(function() {
        setShowDrop(true);
        announce(format({
            id: 'textInput.suggestionIsOpen',
            messages: messages
        }));
        announce(suggestions.length + " " + format({
            id: 'textInput.suggestionsCount',
            messages: messages
        }));
        if (onSuggestionsOpen) onSuggestionsOpen();
    }, [
        announce,
        messages,
        format,
        onSuggestionsOpen,
        suggestions
    ]);
    var closeDrop = (0, $2xPiy.useCallback)(function() {
        setSuggestionsAtClose(suggestions); // must be before closing drop
        setShowDrop(false);
        if (onSuggestionsClose) onSuggestionsClose();
    }, [
        onSuggestionsClose,
        suggestions
    ]);
    var clickOutside = (0, $2xPiy.useCallback)(function(event) {
        if (event.target !== inputRef.current) closeDrop();
    }, [
        inputRef,
        closeDrop
    ]);
    // Handle scenarios where we have focus, the drop isn't showing,
    // and the suggestions change. We don't want to open the drop if
    // the drop has been closed by onEsc and the suggestions haven't
    // changed. So, we remember the suggestions we are showing when
    // the drop was closed and only re-open it when the suggestions
    // subsequently change.
    (0, $2xPiy.useEffect)(function() {
        if (focus && !showDrop && suggestions && suggestions.length && (!suggestionsAtClose || suggestionsAtClose.length !== suggestions.length)) openDrop();
    }, [
        focus,
        openDrop,
        showDrop,
        suggestions,
        suggestionsAtClose
    ]);
    // if we have no suggestions, close drop if it's open
    (0, $2xPiy.useEffect)(function() {
        if (showDrop && (!suggestions || !suggestions.length)) closeDrop();
    }, [
        closeDrop,
        showDrop,
        suggestions
    ]);
    var valueSuggestionIndex = (0, $2xPiy.useMemo)(function() {
        return suggestions ? suggestions.map(function(suggestion) {
            return typeof suggestion === 'object' ? suggestion.value : suggestion;
        }).indexOf(value) : -1;
    }, [
        suggestions,
        value
    ]);
    // choose the best suggestion, either the explicit default or the one
    // that matches the current value
    var resetSuggestionIndex = (0, $2xPiy.useMemo)(function() {
        if (valueSuggestionIndex === -1 && typeof defaultSuggestion === 'number') return defaultSuggestion;
        return valueSuggestionIndex;
    }, [
        defaultSuggestion,
        valueSuggestionIndex
    ]);
    // activeSuggestionIndex unifies mouse and keyboard interaction of
    // the suggestions
    var _useState5 = (0, $2xPiy.useState)(resetSuggestionIndex), activeSuggestionIndex = _useState5[0], setActiveSuggestionIndex = _useState5[1];
    // Only update active suggestion index when the mouse actually moves,
    // not when suggestions are moving under the mouse.
    var _useState6 = (0, $2xPiy.useState)(), mouseMovedSinceLastKey = _useState6[0], setMouseMovedSinceLastKey = _useState6[1];
    // set activeSuggestionIndex when value changes
    (0, $2xPiy.useEffect)(function() {
        return setActiveSuggestionIndex(valueSuggestionIndex);
    }, [
        valueSuggestionIndex
    ]);
    // reset activeSuggestionIndex when the drop is closed
    (0, $2xPiy.useEffect)(function() {
        if (!showDrop) setActiveSuggestionIndex(resetSuggestionIndex);
    }, [
        resetSuggestionIndex,
        showDrop
    ]);
    // announce active suggestion
    (0, $2xPiy.useEffect)(function() {
        if (activeSuggestionIndex >= 0) {
            var label = $8c9c99ffe8765a99$var$stringLabel(suggestions[activeSuggestionIndex]);
            announce(label + " " + format({
                id: 'textInput.enterSelect',
                messages: messages
            }));
        }
    }, [
        activeSuggestionIndex,
        announce,
        messages,
        format,
        suggestions
    ]);
    // make sure activeSuggestion is visible in scroll
    (0, $2xPiy.useEffect)(function() {
        var timer = setTimeout(function() {
            var list = suggestionsRef.current;
            if (showDrop && activeSuggestionIndex !== -1 && list) {
                var container = list.parentNode;
                var item = list.children[activeSuggestionIndex];
                if (container.scrollTo) {
                    if ((0, $83f2052c15a18307$export$27af05f039e10378)(item, container)) container.scrollTo(0, item.offsetTop - (container.getBoundingClientRect().height - item.getBoundingClientRect().height));
                    else if ((0, $83f2052c15a18307$export$54c9800883215719)(item, container)) container.scrollTo(0, item.offsetTop);
                }
            }
        }, 50); // delay to allow Drop to animate in
        return function() {
            return clearTimeout(timer);
        };
    }, [
        activeSuggestionIndex,
        showDrop
    ]);
    (0, $2xPiy.useEffect)(function() {
        if (readOnly && inputRef != null && inputRef.current && inputRef.current.scrollLeft > 0) inputRef.current.scrollLeft = 0;
    }, [
        readOnly,
        inputRef,
        inputRef == null || (_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.scrollLeft
    ]);
    var setValueFromSuggestion = function setValueFromSuggestion(event, suggestion) {
        // if we stole the focus in the drop, perhaps by interacting with
        // a suggestion button or the scrollbar, give it back
        inputRef.current.focus();
        inputRef.current.value = suggestion; // needed for uncontrolled cases
        closeDrop();
        if (handleSuggestionSelect) {
            if (event.persist) event.persist();
            var adjustedEvent = event;
            adjustedEvent.suggestion = suggestion;
            handleSuggestionSelect(adjustedEvent);
        }
        setValue(suggestion);
    };
    var onNextSuggestion = (0, $2xPiy.useCallback)(function(event) {
        event.preventDefault();
        var nextActiveIndex = Math.min(activeSuggestionIndex + 1, suggestions.length - 1);
        setActiveSuggestionIndex(nextActiveIndex);
        setMouseMovedSinceLastKey(false);
    }, [
        activeSuggestionIndex,
        suggestions
    ]);
    var onPreviousSuggestion = (0, $2xPiy.useCallback)(function(event) {
        event.preventDefault();
        var nextActiveIndex = Math.max(activeSuggestionIndex - 1, 0);
        setActiveSuggestionIndex(nextActiveIndex);
        setMouseMovedSinceLastKey(false);
    }, [
        activeSuggestionIndex
    ]);
    // account for input value in both controlled and uncontrolled scenarios
    var hasValue = value || ((_inputRef$current2 = inputRef.current) == null ? void 0 : _inputRef$current2.value);
    var showStyledPlaceholder = (0, $2xPiy.useMemo)(function() {
        return placeholder && typeof placeholder !== 'string' && !hasValue;
    }, [
        hasValue,
        placeholder
    ]);
    var drop;
    var extraProps = {
        onSelect: handleTextSelect
    };
    if (showDrop) drop = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $9f4217ea4a25a271$export$aaa698cd7aa517d6), $8c9c99ffe8765a99$var$_extends({
        ref: dropRef,
        id: id ? "text-input-drop__" + id : undefined,
        align: dropAlign,
        responsive: false,
        target: dropTarget || inputRef.current,
        onClickOutside: clickOutside,
        onEsc: closeDrop,
        trapFocus: false
    }, dropProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($8c9c99ffe8765a99$var$ContainerBox, $8c9c99ffe8765a99$var$_extends({
        id: id ? "listbox__" + id : undefined,
        role: "listbox",
        overflow: "auto",
        dropHeight: dropHeight,
        onMouseMove: function onMouseMove() {
            return setMouseMovedSinceLastKey(true);
        }
    }, passThemeFlag), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $71e4375a7ac36747$export$2f5b00b01ab6676b), $8c9c99ffe8765a99$var$_extends({
        ref: suggestionsRef
    }, passThemeFlag), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $26613b622f673475$export$c5295390d6167a3e), {
        items: suggestions,
        step: theme.select.step,
        show: activeSuggestionIndex !== -1 ? activeSuggestionIndex : undefined
    }, function(suggestion, index, itemRef) {
        var active = activeSuggestionIndex === index;
        var selected = suggestion === value;
        // Determine whether the label is done as a child or
        // as an option Button kind property.
        var renderedLabel = $8c9c99ffe8765a99$var$renderLabel(suggestion);
        var child;
        if (typeof renderedLabel !== 'string') // must be an element rendered by suggestions.label
        child = renderedLabel;
        else if (!theme.button.option) // don't have theme support, need to layout here
        /*
        Not adding a theme object now because this code path
        is not used in the HPE theme, but we may add theme
        support here in the future.
        */ child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            align: "start",
            pad: "small"
        }, renderedLabel);
        // if we have a child, turn on plain
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("li", {
            key: $8c9c99ffe8765a99$var$stringLabel(suggestion) + "-" + index,
            ref: itemRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
            id: id ? "listbox-option-" + index + "__" + id : undefined,
            role: "option",
            "aria-selected": selected ? 'true' : 'false',
            active: active,
            fill: "horizontal",
            plain: !child ? undefined : true,
            align: "start",
            kind: !child ? 'option' : undefined,
            label: !child ? renderedLabel : undefined,
            onClick: function onClick(event) {
                return setValueFromSuggestion(event, suggestion);
            },
            onMouseMove: mouseMovedSinceLastKey && activeSuggestionIndex !== index ? function() {
                return setActiveSuggestionIndex(index);
            } : undefined,
            keyboard: !mouseMovedSinceLastKey
        }, child));
    }))));
    var keyboardProps = {
        onKeyDown: onKeyDown
    };
    if (showDrop) {
        keyboardProps.onEnter = function(event) {
            // prevent submitting forms via Enter when the drop is open
            event.preventDefault();
            if (activeSuggestionIndex >= 0) setValueFromSuggestion(event, suggestions[activeSuggestionIndex]);
            else closeDrop();
        };
        if (activeSuggestionIndex > 0) keyboardProps.onUp = onPreviousSuggestion;
        if (activeSuggestionIndex < suggestions.length - 1) keyboardProps.onDown = onNextSuggestion;
        keyboardProps.onTab = closeDrop;
    } else if (suggestions && suggestions.length > 0) keyboardProps.onDown = openDrop;
    /*
  If the text input has a list of suggestions, add the WAI-ARIA 1.2
  combobox role and states.
  */ var comboboxProps = {};
    var activeOptionID;
    if (id && (suggestions == null ? void 0 : suggestions.length) > -1) {
        if (showDrop && activeSuggestionIndex > -1) activeOptionID = "listbox-option-" + activeSuggestionIndex + "__" + id;
        comboboxProps = {
            'aria-activedescendant': activeOptionID,
            'aria-autocomplete': 'list',
            'aria-expanded': showDrop ? 'true' : 'false',
            'aria-controls': showDrop ? "listbox__" + id : undefined,
            role: 'combobox'
        };
    }
    // For the Keyboard target below, if we have focus,
    // either on the input element or within the drop,
    // then we set the target to the document,
    // otherwise we only listen to onDown on the input element itself,
    // primarily for tests.
    var textInputIcon = (0, $0a9f81b63fff2436$export$a123f939253731a8)(icon, rest.size, theme);
    var ReadOnlyCopyButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $313d8d7c610a335e$export$4f2558dd25106ae2), {
        disabled: disabled,
        onBlurCopy: onBlurCopy,
        onClickCopy: onClickCopy,
        readOnlyCopyPrompt: readOnlyCopyPrompt,
        tip: tip,
        value: value
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $71e4375a7ac36747$export$4aa9d16f7efe0fb6), $8c9c99ffe8765a99$var$_extends({
        readOnlyProp: readOnly // readOnlyProp to avoid passing to DOM
        ,
        readOnlyCopy: readOnlyCopy,
        plain: plain,
        border: !plain,
        widthProp: widthProp,
        onMouseMove: function onMouseMove() {
            return setMouseMovedSinceLastKey(true);
        }
    }, passThemeFlag), reverse && readOnlyCopy && ReadOnlyCopyButton, showStyledPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $71e4375a7ac36747$export$333ccef64da8eec4), passThemeFlag, placeholder), textInputIcon && !readOnlyCopy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $71e4375a7ac36747$export$7c8f159da0dc916), {
        reverse: reverse,
        theme: theme
    }, textInputIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $168667f04da9206c$export$16e4d70cc375e707), $8c9c99ffe8765a99$var$_extends({
        target: focus ? 'document' : undefined
    }, keyboardProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $71e4375a7ac36747$export$46d060c4400937ed), $8c9c99ffe8765a99$var$_extends({
        "aria-label": a11yTitle,
        ref: inputRef,
        id: id,
        name: name,
        autoComplete: "off",
        disabled: disabled,
        plain: plain,
        placeholder: typeof placeholder === 'string' ? placeholder : undefined,
        icon: !readOnlyCopy && icon,
        reverse: reverse,
        focus: focus,
        focusIndicator: focusIndicator,
        textAlign: textAlign,
        widthProp: widthProp
    }, passThemeFlag, rest, extraProps, comboboxProps, {
        defaultValue: $8c9c99ffe8765a99$var$renderLabel(defaultValue),
        value: $8c9c99ffe8765a99$var$renderLabel(value),
        readOnly: readOnly,
        readOnlyCopy: readOnlyCopy,
        onFocus: function onFocus(event) {
            // Don't do anything if we are acting like we already have
            // focus. This can happen when this input loses focus temporarily
            // to our drop, see onBlur() handler below.
            if (!focus) {
                setFocus(true);
                if (suggestions && suggestions.length > 0) {
                    announce(format({
                        id: 'textInput.suggestionsExist',
                        messages: messages
                    }));
                    openDrop();
                }
                if (_onFocus) _onFocus(event);
            }
        },
        onBlur: function onBlur(event) {
            // Only treat it as a blur if the element receiving focus
            // isn't in our drop. The relatedTarget will be our drop
            // when the user clicks on a suggestion or interacts with the
            // scrollbar in the drop.
            if (!event.relatedTarget || event.relatedTarget !== dropRef.current) {
                setFocus(false);
                if (_onBlur) _onBlur(event);
            }
        },
        onChange: readOnly ? undefined : function(event) {
            // when TextInput is not contained in a Form, no re-render
            // will come from this onChange and remove the placeholder
            // so we need to update state to ensure the styled
            // placeholder only appears when there is no value
            if (suggestions && focus && !showDrop) openDrop();
            setValue(event.target.value);
            setActiveSuggestionIndex(resetSuggestionIndex);
            if (onChange) onChange(event);
        }
    }))), !reverse && readOnlyCopy && ReadOnlyCopyButton, !readOnly && drop);
});
$8c9c99ffe8765a99$export$c86715117507e8e5.displayName = 'TextInput';
$8c9c99ffe8765a99$export$c86715117507e8e5.propTypes = (0, $7f9c5cbf5f2cf702$export$2cabbaef9a75cbd2);





var $c3667cdebad52eb7$export$25746e77c1b1a497 = function Searcher(_ref) {
    var _theme$dataTable, _theme$dataTable$sear, _theme$dataTable$sear2;
    var filtering = _ref.filtering, filters = _ref.filters, focusIndicator = _ref.focusIndicator, messages = _ref.messages, onFilter = _ref.onFilter, onFiltering = _ref.onFiltering, property = _ref.property;
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var inputRef = (0, $2xPiy.useRef)();
    var buttonRef = (0, $2xPiy.useRef)();
    var needsFocus = filtering === property;
    var _useState = (0, $2xPiy.useState)(false), buttonNeedsFocus = _useState[0], setButtonNeedsFocus = _useState[1];
    var _useContext = (0, $2xPiy.useContext)((0, $f1ad7bf122eed3b0$export$b060d577040138d8)), format = _useContext.format;
    var SearchIcon = ((_theme$dataTable = theme.dataTable) == null || (_theme$dataTable = _theme$dataTable.icons) == null ? void 0 : _theme$dataTable.search) || (0, $5e76eb42ddcb97c1$export$620e475702cadb1e);
    (0, $2xPiy.useEffect)(function() {
        if (inputRef && needsFocus) inputRef.current.focus();
    }, [
        needsFocus,
        inputRef
    ]);
    // Focus the button after closing the search
    (0, $2xPiy.useEffect)(function() {
        if (buttonNeedsFocus && buttonRef.current) {
            buttonRef.current.focus();
            setButtonNeedsFocus(false);
        }
    }, [
        buttonNeedsFocus
    ]);
    var a11yTitle = format({
        id: 'dataTable.searchBy',
        messages: messages,
        values: {
            property: property
        }
    });
    return filtering === property ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $168667f04da9206c$export$16e4d70cc375e707), {
        onEsc: function onEsc() {
            onFiltering(undefined);
            setButtonNeedsFocus(true);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        width: {
            min: 'xsmall'
        },
        flex: true,
        pad: (_theme$dataTable$sear = theme.dataTable.search) == null ? void 0 : _theme$dataTable$sear.pad
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $8c9c99ffe8765a99$export$c86715117507e8e5), {
        name: "search-" + property,
        a11yTitle: a11yTitle,
        ref: inputRef,
        value: filters[property],
        onChange: function onChange(event) {
            return onFilter(property, event.target.value);
        },
        onBlur: function onBlur() {
            return onFiltering(undefined);
        }
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).Fragment, null, filters[property] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        flex: false,
        pad: (_theme$dataTable$sear2 = theme.dataTable.search) == null || (_theme$dataTable$sear2 = _theme$dataTable$sear2.text) == null ? void 0 : _theme$dataTable$sear2.pad,
        direction: "row",
        align: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), null, filters[property])) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
        ref: buttonRef,
        a11yTitle: a11yTitle,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(SearchIcon, {
            color: (0, $11317b0e49e0d157$export$4cde5df63f53f473)(filtering === property ? 'brand' : 'border', theme)
        }),
        hoverIndicator: true,
        focusIndicator: focusIndicator,
        onClick: function onClick() {
            return onFiltering(filtering === property ? undefined : property);
        }
    }));
};
$c3667cdebad52eb7$export$25746e77c1b1a497.displayName = 'Searcher';



var $2xPiy = parcelRequire("2xPiy");
var $763c3cd9aa07485e$exports = {};

$parcel$export($763c3cd9aa07485e$exports, "__esModule", function () { return $763c3cd9aa07485e$export$1e511d4a378977f5; }, function (v) { return $763c3cd9aa07485e$export$1e511d4a378977f5 = v; });
$parcel$export($763c3cd9aa07485e$exports, "Blank", function () { return $763c3cd9aa07485e$export$eb38fb18cfba1d64; }, function (v) { return $763c3cd9aa07485e$export$eb38fb18cfba1d64 = v; });
var $763c3cd9aa07485e$export$1e511d4a378977f5;
var $763c3cd9aa07485e$export$eb38fb18cfba1d64;
"use strict";
$763c3cd9aa07485e$export$1e511d4a378977f5 = true;
$763c3cd9aa07485e$export$eb38fb18cfba1d64 = void 0;

var $763c3cd9aa07485e$var$_react = $763c3cd9aa07485e$var$_interopRequireDefault((parcelRequire("2xPiy")));

function $763c3cd9aa07485e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $763c3cd9aa07485e$var$_extends() {
    return $763c3cd9aa07485e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $763c3cd9aa07485e$var$_extends.apply(null, arguments);
}
var $763c3cd9aa07485e$var$Blank = $763c3cd9aa07485e$export$eb38fb18cfba1d64 = function Blank(props) {
    return /*#__PURE__*/ $763c3cd9aa07485e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $763c3cd9aa07485e$var$_extends({
        viewBox: "0 0 24 24",
        "aria-hidden": true
    }, props));
};








var $224208e7799fa405$var$_excluded = [
    "context",
    "expanded",
    "onToggle",
    "messages",
    "pad",
    "expandLabel"
], $224208e7799fa405$var$_excluded2 = [
    "background",
    "border",
    "context",
    "expandLabel"
];
function $224208e7799fa405$var$_extends() {
    return $224208e7799fa405$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $224208e7799fa405$var$_extends.apply(null, arguments);
}
function $224208e7799fa405$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// ExpanderControl is separated from ExpanderCell to give TableCell a chance
// to set the ThemeContext dark context.
var $224208e7799fa405$var$ExpanderControl = function ExpanderControl(_ref) {
    var context = _ref.context, expanded = _ref.expanded, onToggle = _ref.onToggle, messages = _ref.messages, pad = _ref.pad, expandLabel = _ref.expandLabel, rest = $224208e7799fa405$var$_objectWithoutPropertiesLoose(_ref, $224208e7799fa405$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useContext = (0, $2xPiy.useContext)((0, $f1ad7bf122eed3b0$export$b060d577040138d8)), format = _useContext.format;
    var content;
    if (onToggle) {
        var ExpandIcon = theme.dataTable.icons[expanded ? 'contract' : 'expand'];
        content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(ExpandIcon, {
            color: (0, $11317b0e49e0d157$export$4cde5df63f53f473)('border', theme)
        });
    } else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $763c3cd9aa07485e$export$eb38fb18cfba1d64), null);
    var normalizedThemeProps = $224208e7799fa405$var$_extends({}, theme.table[context], theme.dataTable[context]);
    delete normalizedThemeProps.background;
    delete normalizedThemeProps.border;
    delete normalizedThemeProps.pad;
    content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), $224208e7799fa405$var$_extends({}, normalizedThemeProps, rest, {
        align: "center",
        fill: true,
        pad: pad
    }), content);
    if (onToggle) {
        var expandText = format({
            id: 'dataTable.expand',
            messages: messages,
            values: {
                label: expandLabel || ''
            }
        });
        var collapseText = format({
            id: 'dataTable.collapse',
            messages: messages,
            values: {
                label: expandLabel || ''
            }
        });
        var expandAllText = format({
            id: 'dataTable.expandAll',
            messages: messages
        });
        var collapseAllText = format({
            id: 'dataTable.collapseAll',
            messages: messages
        });
        var a11yTitle;
        if (expandLabel) a11yTitle = format({
            id: expanded ? 'dataTable.collapse' : 'dataTable.expand',
            messages: messages,
            values: {
                label: expandLabel
            }
        });
        else if (context === 'header') a11yTitle = expanded ? collapseAllText : expandAllText;
        else a11yTitle = expanded ? collapseText : expandText;
        content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
            fill: true,
            "aria-expanded": expanded ? 'true' : 'false',
            a11yTitle: a11yTitle,
            hoverIndicator: true,
            focusIndicator: "inset",
            onClick: onToggle,
            plain: true
        }, content);
    }
    return content;
};
var $224208e7799fa405$export$8ebdff051337858b = function ExpanderCell(_ref2) {
    var _theme$dataTable$expa;
    var background = _ref2.background, border = _ref2.border, context = _ref2.context, expandLabel = _ref2.expandLabel, rest = $224208e7799fa405$var$_objectWithoutPropertiesLoose(_ref2, $224208e7799fa405$var$_excluded2);
    var _useThemeValue2 = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue2.theme;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $ab315163778b3d77$export$1e4baea7053fc0e3), {
        background: background,
        border: border,
        size: (_theme$dataTable$expa = theme.dataTable.expand) == null ? void 0 : _theme$dataTable$expa.size,
        plain: "noPad",
        verticalAlign: context === 'groupEnd' ? 'bottom' : 'top'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($224208e7799fa405$var$ExpanderControl, $224208e7799fa405$var$_extends({
        context: context,
        expandLabel: expandLabel
    }, rest)));
};
$224208e7799fa405$export$8ebdff051337858b.displayName = 'ExpanderCell';



var $iA1nz = parcelRequire("iA1nz");



var $2xPiy = parcelRequire("2xPiy");

function $551c43fc27d858fa$var$_extends() {
    return $551c43fc27d858fa$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $551c43fc27d858fa$var$_extends.apply(null, arguments);
}
var $551c43fc27d858fa$export$b05581f4e764e162 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $9de0322d52c6c5ff$export$8a602e750662ba27), $551c43fc27d858fa$var$_extends({
        ref: ref
    }, props));
});
$551c43fc27d858fa$export$b05581f4e764e162.displayName = 'TableRow';



var $2xPiy = parcelRequire("2xPiy");


var $dyr1f = parcelRequire("dyr1f");

function $81dec22d9095ace8$var$_extends() {
    return $81dec22d9095ace8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $81dec22d9095ace8$var$_extends.apply(null, arguments);
}
var $81dec22d9095ace8$var$PropType = {};
$81dec22d9095ace8$var$PropType = $81dec22d9095ace8$var$_extends({}, (0, $ab32ce3df36aa105$export$ffe37ff34eeb9e21), {
    caption: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
});
var $81dec22d9095ace8$export$6602ef7e207d68a0 = $81dec22d9095ace8$var$PropType;



var $db5bdbb5ed7980e0$var$_excluded = [
    "caption",
    "children"
];
function $db5bdbb5ed7980e0$var$_extends() {
    return $db5bdbb5ed7980e0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $db5bdbb5ed7980e0$var$_extends.apply(null, arguments);
}
function $db5bdbb5ed7980e0$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $db5bdbb5ed7980e0$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var caption = _ref.caption, children = _ref.children, rest = $db5bdbb5ed7980e0$var$_objectWithoutPropertiesLoose(_ref, $db5bdbb5ed7980e0$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $9de0322d52c6c5ff$export$a6cc9d741fb2f287), $db5bdbb5ed7980e0$var$_extends({
        ref: ref
    }, passThemeFlag, rest), caption ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $9de0322d52c6c5ff$export$9c29fe8f594afe44), passThemeFlag, caption) : null, children);
});
$db5bdbb5ed7980e0$export$54ec01a60f47d33d.propTypes = (0, $81dec22d9095ace8$export$6602ef7e207d68a0);



var $2xPiy = parcelRequire("2xPiy");


function $5d12037769f7acde$var$_extends() {
    return $5d12037769f7acde$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5d12037769f7acde$var$_extends.apply(null, arguments);
}
var $5d12037769f7acde$export$76ccd210b9029917 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $4aaa96463ff2e808$export$93e4b0b2cc49b648).Provider, {
        value: "body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $9de0322d52c6c5ff$export$cd928bb20d3ce93f), $5d12037769f7acde$var$_extends({
        ref: ref
    }, props)));
});
$5d12037769f7acde$export$76ccd210b9029917.displayName = 'TableBody';




var $2xPiy = parcelRequire("2xPiy");


function $9a8cd9b190c1a99e$var$_extends() {
    return $9a8cd9b190c1a99e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9a8cd9b190c1a99e$var$_extends.apply(null, arguments);
}
var $9a8cd9b190c1a99e$export$f850895b287ef28e = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $4aaa96463ff2e808$export$93e4b0b2cc49b648).Provider, {
        value: "header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $9de0322d52c6c5ff$export$7f6303d004e2beb), $9a8cd9b190c1a99e$var$_extends({
        ref: ref
    }, props)));
});
$9a8cd9b190c1a99e$export$f850895b287ef28e.displayName = 'TableHeader';



var $2xPiy = parcelRequire("2xPiy");


function $87b440e738a7dd77$var$_extends() {
    return $87b440e738a7dd77$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $87b440e738a7dd77$var$_extends.apply(null, arguments);
}
var $87b440e738a7dd77$export$1f116082bba1f9a8 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $4aaa96463ff2e808$export$93e4b0b2cc49b648).Provider, {
        value: "footer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $9de0322d52c6c5ff$export$246ad668d62a675a), $87b440e738a7dd77$var$_extends({
        ref: ref
    }, props)));
});
$87b440e738a7dd77$export$1f116082bba1f9a8.displayName = 'TableFooter';


// border-collapse: separate is needed so pinned header/footer borders work
var $baa3c9c2b8eedc6c$export$551fccb2985765ce = (0, $iA1nz.default)((0, $db5bdbb5ed7980e0$export$54ec01a60f47d33d)).withConfig({
    displayName: "StyledDataTable",
    componentId: "sc-xrlyjm-0"
})([
    "position:relative;border-spacing:0;border-collapse:separate;",
    " ",
    " ",
    ";"
], (0, $73ba8e2d301b823f$export$a157b298d219a801), function(props) {
    return props.fillProp && (0, $73ba8e2d301b823f$export$7d12e60b29024244)(props.fillProp);
}, function(props) {
    return props.theme.dataTable && props.theme.dataTable.body && props.theme.dataTable.body.extend;
});
// when paginated, this wraps the data table and pagination component
var $baa3c9c2b8eedc6c$export$1d41361302b577a1 = (0, $iA1nz.default)((0, $18c0523379e5dd9d$export$e71c4d32a2263218)).withConfig({
    displayName: "StyledDataTable__StyledContainer",
    componentId: "sc-xrlyjm-1"
})([
    "",
    ";"
], function(props) {
    return props.theme.dataTable && props.theme.dataTable.container && props.theme.dataTable.container.extend;
});
var $baa3c9c2b8eedc6c$var$hoverStyle = (0, $iA1nz.css)([
    "",
    " color:",
    ";"
], function(props) {
    return (0, $0b4a347e23c22183$export$e43a4f0de05cb7e9)((0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.theme.table && props.theme.table.row && props.theme.table.row.hover && props.theme.table.row.hover.background || props.theme.global.hover.background, props.theme), props.theme);
}, function(props) {
    return (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.theme.table && props.theme.table.row && props.theme.table.row.hover && props.theme.table.row.hover.color || props.theme.global.hover.color, props.theme);
});
var $baa3c9c2b8eedc6c$var$rowStyles = (0, $iA1nz.css)([
    "",
    " ",
    " ",
    ""
], function(props) {
    return props.size && "display: table;\n    width: 100%;\n    table-layout: fixed;\n  ";
}, function(props) {
    return props.onClick && "cursor: pointer;";
}, function(props) {
    return props.active && $baa3c9c2b8eedc6c$var$hoverStyle;
});
var $baa3c9c2b8eedc6c$export$35ee3cab512e9b03 = (0, $iA1nz.default)((0, $551c43fc27d858fa$export$b05581f4e764e162)).withConfig({
    displayName: "StyledDataTable__StyledDataTableRow",
    componentId: "sc-xrlyjm-2"
})([
    "&:focus{",
    "}&:focus:not(:focus-visible){",
    "}",
    ";",
    ""
], (0, $73ba8e2d301b823f$export$efbff472cb39d8b)(), (0, $73ba8e2d301b823f$export$525440aaa2c64805)(), function(props) {
    var _props$theme$dataTabl;
    return (_props$theme$dataTabl = props.theme.dataTable) == null || (_props$theme$dataTabl = _props$theme$dataTabl.body) == null || (_props$theme$dataTabl = _props$theme$dataTabl.row) == null ? void 0 : _props$theme$dataTabl.extend;
}, $baa3c9c2b8eedc6c$var$rowStyles);
var $baa3c9c2b8eedc6c$export$c9510f1c30960d9b = (0, $iA1nz.default)((0, $551c43fc27d858fa$export$b05581f4e764e162)).withConfig({
    displayName: "StyledDataTable__StyledDataTableRowHeader",
    componentId: "sc-xrlyjm-3"
})([
    "",
    ""
], $baa3c9c2b8eedc6c$var$rowStyles);
// focus styling other than outline doesn't work on <tbody />
var $baa3c9c2b8eedc6c$export$d272165a8a43ec6 = (0, $iA1nz.default)((0, $5d12037769f7acde$export$76ccd210b9029917)).withConfig({
    displayName: "StyledDataTable__StyledDataTableBody",
    componentId: "sc-xrlyjm-4"
})([
    "",
    " &:focus{",
    "}&:focus:not(:focus-visible){",
    "}"
], function(props) {
    return props.size && "\n    display: block;\n    width: 100%;\n    max-height: " + (props.theme.global.size[props.size] || props.size) + ";\n    overflow: auto;\n  ";
}, (0, $73ba8e2d301b823f$export$efbff472cb39d8b)({
    skipSvgChildren: true,
    forceOutline: true
}), (0, $73ba8e2d301b823f$export$525440aaa2c64805)({
    skipSvgChildren: true,
    forceOutline: true
}));
var $baa3c9c2b8eedc6c$export$f632e2e61f1007ab = (0, $iA1nz.default)((0, $9a8cd9b190c1a99e$export$f850895b287ef28e)).withConfig({
    displayName: "StyledDataTable__StyledDataTableHeader",
    componentId: "sc-xrlyjm-5"
})([
    "",
    ""
], function(props) {
    return props.size && "\n    height: fit-content;\n    display: table;\n    width: calc(100% - " + props.scrollOffset + "px);\n    table-layout: fixed;\n  ";
});
var $baa3c9c2b8eedc6c$export$27a3c65e9acad7cd = (0, $iA1nz.default)((0, $87b440e738a7dd77$export$1f116082bba1f9a8)).withConfig({
    displayName: "StyledDataTable__StyledDataTableFooter",
    componentId: "sc-xrlyjm-6"
})([
    "",
    " ",
    ""
], function(props) {
    return props.size && "\n    display: table;\n    width: calc(100% - " + props.scrollOffset + "px);\n    table-layout: fixed;\n  ";
}, function(props) {
    return props.pin && "\n      /* Safari needs the relative positioning of tfoot specified */\n      position: sticky;\n      bottom: 0;\n      z-index: 1;\n  ";
});
var $baa3c9c2b8eedc6c$export$ffaac7a4853e1cb0 = (0, $iA1nz.default)((0, $ab315163778b3d77$export$1e4baea7053fc0e3)).withConfig({
    displayName: "StyledDataTable__StyledDataTableCell",
    componentId: "sc-xrlyjm-7"
})([
    "",
    ";",
    " ",
    ""
], function(props) {
    return props.context === 'header' && props.theme.dataTable && props.theme.dataTable.header && props.theme.dataTable.header.extend;
}, function(props) {
    return props.pin && props.pin.length > 0 && "position: sticky;\n    " + props.pin.map(function(p) {
        return p + ": " + (props.pinnedOffset && props.pinnedOffset[p] && props.pinnedOffset[p] + "px" || 0) + ";";
    }).join(' ') + "\n    z-index: " + Object.keys(props.pin).length + ";\n  ";
}, function(props) {
    return props.pin && props.pin.length > 0 && props.theme.dataTable.pinned && props.theme.dataTable.pinned[props.context] && props.theme.dataTable.pinned[props.context].extend ? props.theme.dataTable.pinned[props.context].extend : '';
});
var $baa3c9c2b8eedc6c$export$333ccef64da8eec4 = (0, $iA1nz.default)('caption').withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledDataTable__StyledPlaceholder",
    componentId: "sc-xrlyjm-8"
})([
    "position:absolute;",
    " ",
    " left:0;right:0;"
], function(props) {
    return "top: " + (props.top || 0) + "px;";
}, function(props) {
    return "bottom: " + (props.bottom || 0) + "px;";
});


function $0169a8904a4129ab$var$_extends() {
    return $0169a8904a4129ab$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0169a8904a4129ab$var$_extends.apply(null, arguments);
}
var $0169a8904a4129ab$export$adaa4cf7ef1b65be = function set(obj, path, value) {
    var parts = path;
    if (Object(obj) !== obj) return obj;
    if (!Array.isArray(path)) parts = path.toString().match(/[^.[\]]+/g) || [];
    parts.slice(0, -1).reduce(function(acc, item, index) {
        if (Object(acc[item]) === acc[item]) return acc[item];
        acc[item] = (parts[index + 1], parts[index + 1], {});
        return acc[item];
    }, obj)[parts[parts.length - 1]] = value;
    return obj;
};
// get the value for the property in the datum object
var $0169a8904a4129ab$export$682ea250e758ab92 = function datumValue(datum, property) {
    if (!property || !datum) return undefined;
    var parts = property.split('.');
    if (parts.length === 1) return datum[property];
    if (!datum[parts[0]]) return undefined;
    return $0169a8904a4129ab$export$682ea250e758ab92(datum[parts[0]], parts.slice(1).join('.'));
};
var $0169a8904a4129ab$export$e29cd744291e9244 = function normalizePrimaryProperty(columns, primaryKey) {
    var result;
    if (typeof primaryKey === 'string' || typeof primaryKey === 'boolean') result = primaryKey;
    else if (primaryKey === null) console.warn('null is not a supported value for primaryKey. See supported values: https://v2.grommet.io/datatable#primaryKey');
    if (result === undefined) columns.forEach(function(column) {
        // remember the first key property
        if (column.primary && !result) result = column.property;
    });
    if (result === undefined && columns.length > 0) result = columns[0].property;
    return result;
};
var $0169a8904a4129ab$export$3e02c678c13755e4 = function initializeFilters(columns) {
    var result = {};
    columns.forEach(function(column) {
        if (column.search) result[column.property] = '';
    });
    return result;
};
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
var $0169a8904a4129ab$var$escapeRegExp = function escapeRegExp(input) {
    return input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
var $0169a8904a4129ab$export$a4789ef9776cfd0d = function filterAndSortData(data, filters, onSearch, sort) {
    var result = data;
    if (!onSearch) {
        var regexps = {};
        Object.keys(filters).filter(function(n) {
            return filters[n];
        }).forEach(function(n) {
            regexps[n] = new RegExp($0169a8904a4129ab$var$escapeRegExp(filters[n]), 'i');
        });
        if (Object.keys(regexps).length > 0) result = data.filter(function(datum) {
            return !Object.keys(regexps).some(function(property) {
                return !regexps[property].test($0169a8904a4129ab$export$682ea250e758ab92(datum, property));
            });
        });
    }
    if (sort && !sort.external) {
        var property = sort.property, direction = sort.direction;
        result = result === data ? [].concat(data) : result; // don't sort caller's data
        var sortAsc = direction === 'asc';
        var before = sortAsc ? 1 : -1;
        var after = sortAsc ? -1 : 1;
        result.sort(function(d1, d2) {
            var d1Val = $0169a8904a4129ab$export$682ea250e758ab92(d1, property);
            var d2Val = $0169a8904a4129ab$export$682ea250e758ab92(d2, property);
            if (typeof d1Val === 'string' && typeof d2Val === 'string' || typeof d1Val === 'string' && !d2Val || typeof d2Val === 'string' && !d1Val) {
                var sortResult = (d1Val || '').localeCompare(d2Val || '', undefined, {
                    sensitivity: 'base'
                });
                return sortAsc ? sortResult : -sortResult;
            }
            if (d1Val > d2Val) return before;
            if (d1Val < d2Val) return after;
            return 0;
        });
    }
    return result;
};
// aggregate reducers
var $0169a8904a4129ab$var$sumReducer = function sumReducer(accumulated, next) {
    return accumulated + next;
};
var $0169a8904a4129ab$var$minReducer = function minReducer(accumulated, next) {
    return accumulated === undefined ? next : Math.min(accumulated, next);
};
var $0169a8904a4129ab$var$maxReducer = function maxReducer(accumulated, next) {
    return accumulated === undefined ? next : Math.max(accumulated, next);
};
var $0169a8904a4129ab$var$reducers = {
    max: $0169a8904a4129ab$var$maxReducer,
    min: $0169a8904a4129ab$var$minReducer,
    sum: $0169a8904a4129ab$var$sumReducer
};
// aggregate reducers init values
var $0169a8904a4129ab$var$reducersInitValues = {
    min: Number.MAX_VALUE,
    max: Number.MIN_VALUE,
    sum: 0
};
// aggregate a single column
var $0169a8904a4129ab$var$aggregateColumn = function aggregateColumn(column, data) {
    var value;
    if (column.aggregate === 'avg') {
        value = data.map(function(d) {
            return $0169a8904a4129ab$export$682ea250e758ab92(d, column.property);
        }).reduce($0169a8904a4129ab$var$sumReducer);
        value /= data.length;
    } else value = data.map(function(d) {
        return $0169a8904a4129ab$export$682ea250e758ab92(d, column.property);
    }).reduce($0169a8904a4129ab$var$reducers[column.aggregate], $0169a8904a4129ab$var$reducersInitValues[column.aggregate]);
    return value;
};
// aggregate all columns that can
var $0169a8904a4129ab$var$aggregate = function aggregate(columns, data) {
    var result = {};
    columns.forEach(function(column) {
        if (column.aggregate) {
            var value = $0169a8904a4129ab$var$aggregateColumn(column, data);
            result = $0169a8904a4129ab$export$adaa4cf7ef1b65be(result, column.property, value);
        }
    });
    return result;
};
var $0169a8904a4129ab$export$bde56fd39aca7865 = function buildFooterValues(columns, data) {
    var aggregateValues = $0169a8904a4129ab$var$aggregate(columns, data);
    var result = {};
    columns.forEach(function(column) {
        if (column.footer) {
            if (column.footer.aggregate) {
                var value = $0169a8904a4129ab$export$682ea250e758ab92(aggregateValues, column.property);
                result = $0169a8904a4129ab$export$adaa4cf7ef1b65be(result, column.property, value);
            } else result = $0169a8904a4129ab$export$adaa4cf7ef1b65be(result, column.property, column.footer);
        }
    });
    return result;
};
var $0169a8904a4129ab$export$680f59e10d3eb269 = function buildGroups(columns, data, groupBy, primaryProperty) {
    var result;
    if (groupBy != null && groupBy.property || typeof groupBy === 'string') {
        result = [];
        var groupMap = {};
        data.forEach(function(datum) {
            var _groupBy$expandable;
            var key = $0169a8904a4129ab$export$682ea250e758ab92(datum, primaryProperty);
            var isGroup = key && ((_groupBy$expandable = groupBy.expandable) == null ? void 0 : _groupBy$expandable.includes(key));
            var groupByProperty = groupBy.property ? groupBy.property : groupBy;
            var groupValue = isGroup ? key : $0169a8904a4129ab$export$682ea250e758ab92(datum, groupByProperty);
            if (!groupMap[groupValue]) {
                var group = {
                    data: [],
                    datum: isGroup ? datum : {},
                    key: groupValue
                };
                group.datum[groupByProperty] = groupValue;
                result.push(group);
                groupMap[groupValue] = group;
            }
            if (!isGroup) groupMap[groupValue].data.push(datum);
        });
        // include any aggregate column values across the data for each group
        // If expandable was specified we let the onUpdate callback do it since
        // we may not have access to all the data to aggregate it.
        if (!groupBy.expandable) columns.forEach(function(column) {
            if (column.aggregate) result.forEach(function(group) {
                var datum = group.datum;
                datum[column.property] = $0169a8904a4129ab$var$aggregateColumn(column, group.data);
            });
        });
    } else if (groupBy != null && groupBy.expandable) result = groupBy.expandable.map(function(key) {
        return {
            data: [],
            datum: {},
            key: key
        };
    });
    return result;
};
var $0169a8904a4129ab$export$dd1eb10ac590717 = function buildGroupState(groups, groupBy) {
    var result = {};
    if (groups) groups.forEach(function(_ref) {
        var key = _ref.key;
        if (key !== undefined) result[key] = {
            expanded: false
        };
    });
    if (groupBy && groupBy.expand) groupBy.expand.forEach(function(value) {
        result[value] = {
            expanded: true
        };
    });
    return result;
};
var $0169a8904a4129ab$export$e8312bf6b7d1344d = function normalizeBackgroundColor(theme) {
    var background = theme.background; // context background
    if (typeof background === 'string') return background;
    if (background.light && background.dark) return background;
    if (background.color) return background.color;
    return undefined;
};
var $0169a8904a4129ab$export$ad33e27b4a0251a4 = function normalizeRowProp(name, rowProp, prop) {
    if (rowProp && rowProp[name]) return rowProp[name];
    return prop;
};
var $0169a8904a4129ab$var$tableContextNames = [
    'header',
    'body',
    'footer',
    'groupHeader'
];
var $0169a8904a4129ab$var$cellPropertyNames = [
    'background',
    'border',
    'pad'
];
var $0169a8904a4129ab$export$4553511e3ef6f0d3 = function normalizeCellProps(props, theme) {
    var _theme$dataTable3;
    var result = {};
    $0169a8904a4129ab$var$tableContextNames.forEach(function(context) {
        result[context] = {
            pinned: {}
        };
        $0169a8904a4129ab$var$cellPropertyNames.forEach(function(propName) {
            var _props$propName, _theme$dataTable, _theme$table, _props$propName3, _props$propName5, _theme$dataTable2;
            var value = (props == null || (_props$propName = props[propName]) == null ? void 0 : _props$propName[context]) || // if the propName is used without context, it applies to all contexts
            $0169a8904a4129ab$var$tableContextNames.every(function(n) {
                var _props$propName2;
                return !(props != null && (_props$propName2 = props[propName]) != null && _props$propName2[n]);
            }) && (props == null ? void 0 : props[propName]) || (theme == null || (_theme$dataTable = theme.dataTable) == null || (_theme$dataTable = _theme$dataTable[context]) == null ? void 0 : _theme$dataTable[propName]) || (theme == null || (_theme$table = theme.table) == null || (_theme$table = _theme$table[context]) == null ? void 0 : _theme$table[propName]);
            if (value !== undefined) result[context][propName] = value;
            // pinned case
            value = (props == null || (_props$propName3 = props[propName]) == null || (_props$propName3 = _props$propName3.pinned) == null ? void 0 : _props$propName3[context]) || context === 'body' && $0169a8904a4129ab$var$tableContextNames.every(function(n) {
                var _props$propName4;
                return !(props != null && (_props$propName4 = props[propName]) != null && (_props$propName4 = _props$propName4.pinned) != null && _props$propName4[n]);
            }) && (props == null || (_props$propName5 = props[propName]) == null ? void 0 : _props$propName5.pinned) || (theme == null || (_theme$dataTable2 = theme.dataTable) == null || (_theme$dataTable2 = _theme$dataTable2.pinned) == null || (_theme$dataTable2 = _theme$dataTable2[context]) == null ? void 0 : _theme$dataTable2[propName]);
            if (value !== undefined) {
                if (propName === 'background' && theme.background && value.opacity && !value.color) // theme context has an active background color but the
                // theme doesn't set an explicit color, repeat the context
                // background explicitly
                value.color = $0169a8904a4129ab$export$e8312bf6b7d1344d(theme);
                if (context === 'body') // in case we have pinned columns, store the pinned stuff in
                // cellProps.body.pinned
                result[context].pinned[propName] = value;
                else if (props.pin === true || props.pin === context) // this context is pinned, use the pinned value directly
                result[context][propName] = value;
            }
        });
    });
    result.body.selected = $0169a8904a4129ab$var$_extends({}, theme == null || (_theme$dataTable3 = theme.dataTable) == null || (_theme$dataTable3 = _theme$dataTable3.body) == null ? void 0 : _theme$dataTable3.selected);
    return result;
};
var $0169a8904a4129ab$export$b3f0e4b3a6cf0421 = function normalizeRowCellProps(rowProps, cellProps, primaryKey, index) {
    var result = {
        pinned: {},
        selected: cellProps.selected
    };
    [
        'background',
        'border',
        'pad'
    ].forEach(function(propName) {
        var _rowProps$primaryKey;
        var row = primaryKey && rowProps && (rowProps == null || (_rowProps$primaryKey = rowProps[primaryKey]) == null ? void 0 : _rowProps$primaryKey[propName]);
        var cell = cellProps[propName];
        var value = row && (Array.isArray(row) ? row[index % row.length] : row) || (Array.isArray(cell) ? cell[index % cell.length] : cell);
        if (value !== undefined) result[propName] = value;
        var rowPin = rowProps && rowProps.pinned && rowProps.pinned[propName];
        var cellPin = cellProps.pinned[propName];
        value = rowPin && (Array.isArray(rowPin) ? rowPin[index % rowPin.length] : rowPin) || (Array.isArray(cellPin) ? cellPin[index % cellPin.length] : cellPin);
        if (value !== undefined) result.pinned[propName] = value;
    });
    return result;
};





var $c302317b33637455$var$_excluded = [
    "background",
    "border",
    "color",
    "font",
    "gap",
    "pad",
    "units"
], $c302317b33637455$var$_excluded2 = [
    "allowSelectAll",
    "cellProps",
    "columns",
    "data",
    "disabled",
    "fill",
    "filtering",
    "filters",
    "groupBy",
    "groups",
    "groupState",
    "messages",
    "onFilter",
    "onFiltering",
    "onResize",
    "onSelect",
    "onSort",
    "onToggle",
    "onWidths",
    "pin",
    "pinnedOffset",
    "primaryProperty",
    "selected",
    "rowDetails",
    "sort",
    "widths",
    "verticalAlign"
];
function $c302317b33637455$var$_extends() {
    return $c302317b33637455$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c302317b33637455$var$_extends.apply(null, arguments);
}
function $c302317b33637455$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// delay before triggering width update. This allows most/all header resizes
// to be batched together causing fewer render passes
var $c302317b33637455$var$WIDTH_UPDATE_DELAY = 100;
// separate theme values into groupings depending on what
// part of header cell they should style
var $c302317b33637455$var$separateThemeProps = function separateThemeProps(theme) {
    var _theme$dataTable$head = theme.dataTable.header, background = _theme$dataTable$head.background, border = _theme$dataTable$head.border, color = _theme$dataTable$head.color, font = _theme$dataTable$head.font, gap = _theme$dataTable$head.gap, pad = _theme$dataTable$head.pad, units = _theme$dataTable$head.units, rest = $c302317b33637455$var$_objectWithoutPropertiesLoose(_theme$dataTable$head, $c302317b33637455$var$_excluded);
    var textProps = $c302317b33637455$var$_extends({
        color: color
    }, font);
    var iconProps = {
        color: color
    };
    var layoutProps = $c302317b33637455$var$_extends({}, rest);
    return [
        layoutProps,
        textProps,
        iconProps
    ];
};
// build up CSS from basic to specific based on the supplied sub-object paths.
// adapted from StyledButtonKind to only include parts relevant for DataTable
var $c302317b33637455$var$buttonStyle = function buttonStyle(_ref) {
    var pad = _ref.pad, theme = _ref.theme, verticalAlign = _ref.verticalAlign;
    var styles = [];
    var _separateThemeProps = $c302317b33637455$var$separateThemeProps(theme), layoutProps = _separateThemeProps[0], iconProps = _separateThemeProps[2];
    // if cell is sortable, we want pad to be applied
    // to the button instead of the cell
    if (pad) styles.push((0, $73ba8e2d301b823f$export$73d7bd5e5b0271ce)({
        pad: pad
    }, theme));
    if (layoutProps) styles.push((0, $73ba8e2d301b823f$export$73d7bd5e5b0271ce)(layoutProps, theme));
    if (layoutProps.hover) {
        // CSS for this sub-object in the theme
        var partStyles = (0, $73ba8e2d301b823f$export$73d7bd5e5b0271ce)(layoutProps.hover, theme);
        if (partStyles.length > 0) styles.push((0, $iA1nz.css)([
            "&:hover{",
            "}"
        ], partStyles));
    }
    if (iconProps.color) styles.push((0, $iA1nz.css)([
        "svg{stroke:",
        ";fill:",
        ";}"
    ], (0, $11317b0e49e0d157$export$4cde5df63f53f473)(iconProps.color, theme), (0, $11317b0e49e0d157$export$4cde5df63f53f473)(iconProps.color, theme)));
    var align = 'center';
    if (verticalAlign === 'bottom') align = 'end';
    if (verticalAlign === 'top') align = 'start';
    if (verticalAlign) styles.push((0, $iA1nz.css)([
        "display:inline-flex;align-items:",
        ";"
    ], align));
    return styles;
};
var $c302317b33637455$var$StyledHeaderCellButton = (0, $iA1nz.default)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1)).withConfig({
    displayName: "Header__StyledHeaderCellButton",
    componentId: "sc-1baku5q-0"
})([
    "",
    ""
], function(props) {
    return $c302317b33637455$var$buttonStyle(props);
});
// allow extend to spread onto Box that surrounds column label
var $c302317b33637455$var$StyledContentBox = (0, $iA1nz.default)((0, $18c0523379e5dd9d$export$e71c4d32a2263218)).withConfig({
    displayName: "Header__StyledContentBox",
    componentId: "sc-1baku5q-1"
})([
    "",
    ""
], function(props) {
    return props.extend;
});
var $c302317b33637455$export$8b251419efc915eb = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref2, ref) {
    var _theme$dataTable$expa;
    var allowSelectAll = _ref2.allowSelectAll, cellProps = _ref2.cellProps, columns = _ref2.columns, data = _ref2.data, disabled = _ref2.disabled, fill = _ref2.fill, filtering = _ref2.filtering, filters = _ref2.filters, groupBy = _ref2.groupBy, groups = _ref2.groups, groupState = _ref2.groupState, messages = _ref2.messages, onFilter = _ref2.onFilter, onFiltering = _ref2.onFiltering, _onResize = _ref2.onResize, onSelect = _ref2.onSelect, onSort = _ref2.onSort, onToggle = _ref2.onToggle, onWidths = _ref2.onWidths, pinProp = _ref2.pin, pinnedOffset = _ref2.pinnedOffset, primaryProperty = _ref2.primaryProperty, selected = _ref2.selected, rowDetails = _ref2.rowDetails, sort = _ref2.sort, widths = _ref2.widths, verticalAlign = _ref2.verticalAlign, rest = $c302317b33637455$var$_objectWithoutPropertiesLoose(_ref2, $c302317b33637455$var$_excluded2);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _separateThemeProps2 = $c302317b33637455$var$separateThemeProps(theme), layoutProps = _separateThemeProps2[0], textProps = _separateThemeProps2[1];
    var _useContext = (0, $2xPiy.useContext)((0, $c66bbd4f602cf841$export$58d75f9829cbe158)), contextTotal = _useContext.total;
    var _useContext2 = (0, $2xPiy.useContext)((0, $f1ad7bf122eed3b0$export$b060d577040138d8)), format = _useContext2.format;
    var cellWidthsRef = (0, $2xPiy.useRef)({});
    var timerRef = (0, $2xPiy.useRef)();
    var handleWidths = (0, $2xPiy.useCallback)(function() {
        var cellWidths = cellWidthsRef.current;
        if (onWidths && cellWidths) {
            var internalColumnWidths = selected || onSelect ? [
                cellWidths._grommetDataTableSelect
            ] : [];
            onWidths([].concat(internalColumnWidths, columns.map(function(_ref3) {
                var property = _ref3.property;
                return cellWidths[property];
            })));
        }
    }, [
        columns,
        onSelect,
        onWidths,
        selected
    ]);
    var updateWidths = (0, $2xPiy.useCallback)(function(property, width) {
        if (typeof width !== 'number') return;
        // Only update if width actually changed
        if ((cellWidthsRef == null ? void 0 : cellWidthsRef.current[property]) !== width) {
            cellWidthsRef.current[property] = width;
            if (timerRef.current) clearTimeout(timerRef.current);
            timerRef.current = setTimeout(handleWidths, $c302317b33637455$var$WIDTH_UPDATE_DELAY);
        }
    }, [
        handleWidths
    ]);
    var pin = pinProp ? [
        'top'
    ] : [];
    var selectPin = pinnedOffset != null && pinnedOffset._grommetDataTableSelect ? [].concat(pin, [
        'left'
    ]) : pin;
    var totalSelectedGroups = groupBy != null && groupBy.select ? Object.keys(groupBy.select).reduce(function(total, cur) {
        return cur && groupBy.select[cur] === 'all' ? total + 1 : total;
    }, 0) : 0;
    var totalSelected = ((selected == null ? void 0 : selected.length) || 0) + totalSelectedGroups;
    var onChangeSelection = (0, $2xPiy.useCallback)(function() {
        var nextSelected = [].concat(selected);
        var nextGroupSelected = {};
        // get primary values for current data view
        var primaryValues = data.map(function(datum) {
            return (0, $0169a8904a4129ab$export$682ea250e758ab92)(datum, primaryProperty);
        }) || [];
        // enabled includes what can be changed
        var enabled = disabled && primaryValues.filter(function(v) {
            return !disabled.includes(v);
        }) || primaryValues;
        // enabledSelected includes what can be changed and is currently selected
        var enabledSelected = selected && enabled.filter(function(v) {
            return selected.includes(v);
        }) || primaryValues;
        var allSelected = groupBy != null && groupBy.select ? groupBy.select[''] === 'all' : enabledSelected.length === enabled.length;
        // if all enabled are already selected, remove them from selected,
        // otherwise add them.
        if (allSelected) {
            enabledSelected.forEach(function(p) {
                var index = nextSelected.indexOf(p);
                if (index >= 0) nextSelected.splice(index, 1);
            });
            nextGroupSelected[''] = 'none';
        } else {
            var _groupBy$expandable;
            enabled.forEach(function(p) {
                if (!nextSelected.includes(p)) nextSelected.push(p);
            });
            nextGroupSelected[''] = 'all';
            groupBy == null || (_groupBy$expandable = groupBy.expandable) == null || _groupBy$expandable.forEach(function(key) {
                nextGroupSelected[key] = 'all';
            });
        }
        if (groupBy != null && groupBy.onSelect) groupBy.onSelect(nextSelected, undefined, nextGroupSelected);
        else onSelect(nextSelected);
    }, [
        data,
        disabled,
        groupBy,
        onSelect,
        primaryProperty,
        selected
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $baa3c9c2b8eedc6c$export$f632e2e61f1007ab), $c302317b33637455$var$_extends({
        ref: ref,
        fillProp: fill
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $baa3c9c2b8eedc6c$export$c9510f1c30960d9b), null, groups && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $224208e7799fa405$export$8ebdff051337858b), {
        background: cellProps.background,
        border: cellProps.border,
        context: "header",
        expanded: Object.keys(groupState).filter(function(k) {
            return !groupState[k].expanded;
        }).length === 0,
        onToggle: onToggle,
        pad: cellProps.pad
    }), (selected || onSelect) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $baa3c9c2b8eedc6c$export$ffaac7a4853e1cb0), $c302317b33637455$var$_extends({
        background: cellProps.background,
        onWidth: function onWidth(width) {
            return updateWidths('_grommetDataTableSelect', width);
        },
        plain: "noPad",
        size: "auto",
        context: "header",
        scope: "col",
        pin: selectPin,
        pinnedOffset: pinnedOffset == null ? void 0 : pinnedOffset._grommetDataTableSelect,
        verticalAlign: verticalAlign
    }, passThemeFlag), onSelect && allowSelectAll && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
        a11yTitle: totalSelected === data.length ? 'unselect all' : 'select all',
        checked: groupBy != null && groupBy.select ? groupBy.select[''] === 'all' : totalSelected > 0 && data.length > 0 && totalSelected === (contextTotal || data.length),
        indeterminate: groupBy != null && groupBy.select ? groupBy.select[''] === 'some' : totalSelected > 0 && totalSelected < (contextTotal || data.length),
        onChange: onChangeSelection,
        pad: cellProps.pad
    })), rowDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $ab315163778b3d77$export$1e4baea7053fc0e3), {
        size: (_theme$dataTable$expa = theme.dataTable.expand) == null ? void 0 : _theme$dataTable$expa.size,
        plain: true,
        pad: "none"
    }), columns.map(function(_ref4) {
        var property = _ref4.property, header = _ref4.header, align = _ref4.align, columnPin = _ref4.pin, search = _ref4.search, sortable = _ref4.sortable, columnVerticalAlign = _ref4.verticalAlign, size = _ref4.size, units = _ref4.units;
        var content;
        var unitsContent = units ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), $c302317b33637455$var$_extends({}, textProps, theme.dataTable.header.units), units) : undefined;
        if (typeof header === 'string') {
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), textProps, header);
            if (Object.keys(layoutProps).length && (sortable === false || !onSort)) // apply rest of layout styling if cell is not sortable,
            // otherwise this styling will be applied by
            // StyledHeaderCellButton
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($c302317b33637455$var$StyledContentBox, layoutProps, content);
        } else content = header;
        if (unitsContent) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            justify: align,
            direction: "row"
        }, content, unitsContent);
        if (verticalAlign || columnVerticalAlign) {
            var vertical = verticalAlign || columnVerticalAlign;
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                height: "100%",
                justify: (0, $ab315163778b3d77$export$4671998ee1170a79)[vertical]
            }, content);
        }
        var ariaSort;
        if (onSort && sortable !== false) {
            var _theme$dataTable$sort;
            var Icon;
            var iconAriaLabel;
            if (onSort && sortable !== false) {
                if (sort && sort.property === property) {
                    Icon = theme.dataTable.icons[sort.direction !== 'asc' ? 'ascending' : 'descending'];
                    if (sort.direction === 'asc') {
                        ariaSort = 'ascending';
                        iconAriaLabel = format({
                            id: 'dataTable.ascending',
                            messages: messages
                        });
                    } else if (sort.direction === 'desc') {
                        ariaSort = 'descending';
                        iconAriaLabel = format({
                            id: 'dataTable.descending',
                            messages: messages
                        });
                    }
                } else if (theme.dataTable.icons.sortable) Icon = theme.dataTable.icons.sortable;
            }
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($c302317b33637455$var$StyledHeaderCellButton, $c302317b33637455$var$_extends({
                plain: true,
                column: property,
                fill: "vertical",
                focusIndicator: size ? 'inset' : undefined,
                onClick: onSort(property),
                sort: sort,
                pad: cellProps.pad,
                sortable: true,
                verticalAlign: verticalAlign || columnVerticalAlign
            }, passThemeFlag), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                direction: "row",
                align: "center",
                gap: (_theme$dataTable$sort = theme.dataTable.sort) == null ? void 0 : _theme$dataTable$sort.gap,
                justify: align
            }, content, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(Icon, {
                "aria-label": iconAriaLabel
            })));
        }
        // content should fill any available space in cell
        // If `onResize` or `search` is true we need to explicitly set
        // fill because later if either of these props is true content
        // will be wrapped with an additional Box, preventing this Box
        // from automatically filling the vertical space.
        content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            flex: _onResize || search ? {
                grow: 1,
                shrink: 1
            } : 'grow',
            fill: _onResize || search ? 'vertical' : false,
            justify: !align && 'center' || align
        }, content);
        if (search) {
            var searcher = search && filters ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $c3667cdebad52eb7$export$25746e77c1b1a497), {
                filtering: filtering,
                filters: filters,
                focusIndicator: size ? 'inset' : undefined,
                messages: messages,
                property: property,
                onFilter: onFilter,
                onFiltering: onFiltering
            }) : null;
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                direction: "row",
                align: "center",
                justify: !align || align === 'start' ? 'between' : align,
                gap: theme.dataTable.header.gap,
                fill: "vertical",
                style: _onResize ? {
                    position: 'relative'
                } : undefined
            }, content, searcher && _onResize ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                flex: {
                    shrink: filtering === property ? 1 : 0
                },
                direction: filtering === property ? 'column' : 'row',
                margin: {
                    right: '12px'
                }
            }, searcher) : searcher);
        }
        var cellPin = [].concat(pin);
        if (columnPin) cellPin.push('left');
        var headerId = "grommet-data-table-header-" + property;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $baa3c9c2b8eedc6c$export$ffaac7a4853e1cb0), $c302317b33637455$var$_extends({
            "aria-sort": ariaSort,
            key: property,
            align: align,
            context: "header",
            verticalAlign: verticalAlign || columnVerticalAlign,
            background: cellProps.background,
            border: cellProps.border,
            id: headerId,
            onWidth: function onWidth(width) {
                return updateWidths(property, width);
            },
            pad: sortable === false || !onSort ? cellProps.pad : 'none',
            pin: cellPin,
            plain: true,
            pinnedOffset: pinnedOffset && pinnedOffset[property],
            scope: "col",
            size: widths && widths[property] ? undefined : size,
            style: {
                width: widths != null && widths[property] ? widths[property] + "px" : undefined,
                boxSizing: _onResize ? 'border-box' : undefined,
                // Don't override positioning when DataTable has pin prop
                position: _onResize && !columnPin && !pinProp ? 'relative' : undefined,
                overflow: _onResize ? 'visible' : undefined
            },
            onResize: _onResize,
            property: property
        }, passThemeFlag), content, _onResize && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $17c91cc89c150a92$export$48a76196cafe3b93), {
            property: property,
            onResize: function onResize(prop, width) {
                _onResize(prop, width);
                updateWidths(prop, width);
            },
            headerText: typeof header === 'string' ? header : property,
            messages: messages,
            headerId: headerId
        }));
    })));
});
$c302317b33637455$export$8b251419efc915eb.displayName = 'Header';



var $2xPiy = parcelRequire("2xPiy");



var $2xPiy = parcelRequire("2xPiy");





var $62b76240ebbeb53a$var$_excluded = [
    "background",
    "border",
    "column",
    "datum",
    "pad",
    "pin",
    "pinnedOffset",
    "primaryProperty",
    "scope",
    "verticalAlign"
];
function $62b76240ebbeb53a$var$_extends() {
    return $62b76240ebbeb53a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $62b76240ebbeb53a$var$_extends.apply(null, arguments);
}
function $62b76240ebbeb53a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $62b76240ebbeb53a$export$f6f0c3fe4ec306ea = /*#__PURE__*/ (0, $2xPiy.memo)(function(_ref) {
    var background = _ref.background, border = _ref.border, _ref$column = _ref.column, align = _ref$column.align, columnPin = _ref$column.pin, plain = _ref$column.plain, footer = _ref$column.footer, property = _ref$column.property, render = _ref$column.render, columnVerticalAlign = _ref$column.verticalAlign, size = _ref$column.size, datum = _ref.datum, pad = _ref.pad, cellPin = _ref.pin, pinnedOffset = _ref.pinnedOffset, primaryProperty = _ref.primaryProperty, scope = _ref.scope, verticalAlign = _ref.verticalAlign, rest = $62b76240ebbeb53a$var$_objectWithoutPropertiesLoose(_ref, $62b76240ebbeb53a$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var value = (0, $0169a8904a4129ab$export$682ea250e758ab92)(datum, property);
    var context = (0, $2xPiy.useContext)((0, $4aaa96463ff2e808$export$93e4b0b2cc49b648));
    var renderContexts = context === 'body' || context === 'footer' && footer && footer.aggregate;
    var content;
    if (render && renderContexts) content = render(datum);
    else if (value !== undefined) {
        if (typeof value === 'string' || typeof value === 'number' || /*#__PURE__*/ (0, $2xPiy.isValidElement)(value)) content = value;
    }
    if (typeof content === 'string' || typeof content === 'number') {
        var textProps = property === primaryProperty ? theme.dataTable.primary : {};
        content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), textProps, content);
    }
    var pin = [];
    if (cellPin) pin.push.apply(pin, cellPin);
    if (columnPin) pin.push('left');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $baa3c9c2b8eedc6c$export$ffaac7a4853e1cb0), $62b76240ebbeb53a$var$_extends({
        scope: scope
    }, theme.dataTable[context], {
        align: align,
        context: context,
        verticalAlign: verticalAlign || columnVerticalAlign,
        size: size,
        background: background,
        pinnedOffset: pinnedOffset,
        border: border,
        pad: pad,
        pin: pin,
        plain: plain ? 'noPad' : undefined
    }, passThemeFlag, rest), content);
});
$62b76240ebbeb53a$export$f6f0c3fe4ec306ea.displayName = 'Cell';




var $06fe048ff15827f8$var$_excluded = [
    "cellProps",
    "columns",
    "fill",
    "footerValues",
    "groups",
    "onSelect",
    "pin",
    "pinnedOffset",
    "primaryProperty",
    "selected",
    "verticalAlign"
];
function $06fe048ff15827f8$var$_extends() {
    return $06fe048ff15827f8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $06fe048ff15827f8$var$_extends.apply(null, arguments);
}
function $06fe048ff15827f8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $06fe048ff15827f8$export$a06f1c675e846f6f = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var _theme$dataTable$expa;
    var cellProps = _ref.cellProps, columns = _ref.columns, fill = _ref.fill, footerValues = _ref.footerValues, groups = _ref.groups, onSelect = _ref.onSelect, pinProp = _ref.pin, pinnedOffset = _ref.pinnedOffset, primaryProperty = _ref.primaryProperty, selected = _ref.selected, verticalAlign = _ref.verticalAlign, rest = $06fe048ff15827f8$var$_objectWithoutPropertiesLoose(_ref, $06fe048ff15827f8$var$_excluded);
    var pin = pinProp ? [
        'bottom'
    ] : [];
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var _useThemeValue2 = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue2.theme;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $baa3c9c2b8eedc6c$export$27a3c65e9acad7cd), $06fe048ff15827f8$var$_extends({
        ref: ref,
        fillProp: fill,
        pin: pinProp
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $551c43fc27d858fa$export$b05581f4e764e162), null, groups && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $ab315163778b3d77$export$1e4baea7053fc0e3), {
        plain: true,
        size: (_theme$dataTable$expa = theme.dataTable.expand) == null ? void 0 : _theme$dataTable$expa.size,
        pad: "none",
        verticalAlign: "top",
        background: cellProps.background,
        border: cellProps.border
    }), (selected || onSelect) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $baa3c9c2b8eedc6c$export$ffaac7a4853e1cb0), $06fe048ff15827f8$var$_extends({
        background: cellProps.background,
        context: "footer",
        pin: pin,
        verticalAlign: verticalAlign
    }, passThemeFlag)), columns.map(function(column) {
        var cellPin = [].concat(pin);
        if (column.pin) cellPin.push('left');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $62b76240ebbeb53a$export$f6f0c3fe4ec306ea), {
            key: column.property,
            background: column.pin && cellProps.pinned.background || cellProps.background,
            border: column.pin && cellProps.pinned.border || cellProps.border,
            context: "footer",
            column: column,
            datum: footerValues,
            pad: column.pin && cellProps.pinned.pad || cellProps.pad,
            pin: pin.length ? pin : undefined,
            pinnedOffset: pinnedOffset && pinnedOffset[column.property],
            primaryProperty: primaryProperty,
            verticalAlign: verticalAlign
        });
    })));
});
$06fe048ff15827f8$export$a06f1c675e846f6f.displayName = 'Footer';



var $2xPiy = parcelRequire("2xPiy");











var $b4e3f955e73545f0$var$_excluded = [
    "cellProps",
    "columns",
    "data",
    "disabled",
    "onMore",
    "replace",
    "onClickRow",
    "onSelect",
    "pinnedOffset",
    "primaryProperty",
    "rowProps",
    "selected",
    "rowDetails",
    "show",
    "size",
    "step",
    "rowExpand",
    "setRowExpand",
    "verticalAlign"
];
function $b4e3f955e73545f0$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $b4e3f955e73545f0$var$_extends() {
    return $b4e3f955e73545f0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b4e3f955e73545f0$var$_extends.apply(null, arguments);
}
var $b4e3f955e73545f0$var$Row = /*#__PURE__*/ (0, $2xPiy.memo)(function(_ref) {
    var expandLabel = _ref.expandLabel, cellProps = _ref.cellProps, primaryValue = _ref.primaryValue, index = _ref.index, rowRef = _ref.rowRef, size = _ref.size, active = _ref.active, focused = _ref.focused, lastFocused = _ref.lastFocused, onClickRow = _ref.onClickRow, datum = _ref.datum, selected = _ref.selected, onSelect = _ref.onSelect, passThemeFlag = _ref.passThemeFlag, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, rowDetails = _ref.rowDetails, isRowExpanded = _ref.isRowExpanded, setActive = _ref.setActive, setFocused = _ref.setFocused, setRowExpand = _ref.setRowExpand, rowExpand = _ref.rowExpand, columns = _ref.columns, pinnedOffset = _ref.pinnedOffset, primaryProperty = _ref.primaryProperty, verticalAlign = _ref.verticalAlign, onRowRefChange = _ref.onRowRefChange;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $baa3c9c2b8eedc6c$export$35ee3cab512e9b03), $b4e3f955e73545f0$var$_extends({
        ref: function ref(element) {
            // Store the row element in the parent's ref map
            if (onRowRefChange) onRowRefChange(index, element);
            // Also call the original rowRef if it exists
            if (rowRef) {
                if (typeof rowRef === 'function') rowRef(element);
                else if (rowRef && typeof rowRef === 'object' && 'current' in rowRef) {
                    var refObj = rowRef;
                    refObj.current = element;
                }
            }
        },
        size: size,
        active: active,
        "aria-disabled": onClickRow && isDisabled || undefined,
        onClick: onClickRow ? function(event) {
            if (onClickRow && !isDisabled) {
                setFocused(index);
                setActive(index);
                if (typeof onClickRow === 'function') {
                    // extract from React's synthetic event pool
                    event.persist();
                    var adjustedEvent = event;
                    adjustedEvent.datum = datum;
                    adjustedEvent.index = index;
                    onClickRow(adjustedEvent);
                } else if (onClickRow === 'select') {
                    if (isSelected) onSelect(selected.filter(function(s) {
                        return s !== primaryValue;
                    }), datum);
                    else onSelect([].concat(selected, [
                        primaryValue
                    ]), datum);
                }
            }
        } : undefined,
        onFocus: function onFocus() {
            if (onClickRow && !isDisabled) {
                setFocused(index);
                setActive(index);
            }
        },
        onMouseOver: onClickRow && !isDisabled ? function() {
            return setActive(index);
        } : undefined,
        tabIndex: // eslint-disable-next-line no-nested-ternary
        !onClickRow ? undefined : // If this row is focused, it should be focusable
        // If no row is focused and this is the first row, make it focusable
        focused !== undefined && focused === index || focused === undefined && lastFocused === index || focused === undefined && index === 0 ? 0 : // Otherwise, not in tab order
        -1
    }, passThemeFlag), (selected || onSelect) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $62b76240ebbeb53a$export$f6f0c3fe4ec306ea), {
        background: isSelected && cellProps.selected.background || (pinnedOffset == null ? void 0 : pinnedOffset._grommetDataTableSelect) && cellProps.pinned.background || cellProps.background,
        border: cellProps.pinned.border || cellProps.border,
        pinnedOffset: pinnedOffset == null ? void 0 : pinnedOffset._grommetDataTableSelect,
        "aria-disabled": isDisabled || !onSelect || undefined,
        column: {
            pin: Boolean(pinnedOffset == null ? void 0 : pinnedOffset._grommetDataTableSelect),
            plain: 'noPad',
            size: 'auto',
            render: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                    tabIndex: onClickRow === 'select' ? -1 : undefined,
                    a11yTitle: (isSelected ? 'unselect' : 'select') + " " + primaryValue,
                    checked: isSelected,
                    disabled: isDisabled || !onSelect,
                    onChange: function onChange() {
                        if (isSelected) onSelect(selected.filter(function(s) {
                            return s !== primaryValue;
                        }), datum);
                        else onSelect([].concat(selected, [
                            primaryValue
                        ]), datum);
                    },
                    pad: cellProps.pad
                });
            }
        },
        verticalAlign: verticalAlign
    }), rowDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $224208e7799fa405$export$8ebdff051337858b), {
        background: isSelected && cellProps.selected.background,
        context: isRowExpanded ? 'groupHeader' : 'body',
        expanded: isRowExpanded,
        expandLabel: expandLabel,
        onToggle: function onToggle() {
            var nextRowExpand;
            var rowKey = primaryValue || index;
            if (isRowExpanded) nextRowExpand = rowExpand.filter(function(s) {
                return s !== rowKey;
            });
            else nextRowExpand = [].concat(rowExpand, [
                rowKey
            ]);
            if (rowDetails.onExpand) rowDetails.onExpand(nextRowExpand, datum);
            else setRowExpand(nextRowExpand);
        },
        pad: cellProps.pad,
        verticalAlign: verticalAlign
    }), columns.map(function(column) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $62b76240ebbeb53a$export$f6f0c3fe4ec306ea), {
            key: column.property,
            background: isSelected && cellProps.selected.background || column.pin && cellProps.pinned.background || cellProps.background,
            border: column.pin && cellProps.pinned.border || cellProps.border,
            context: "body",
            column: column,
            datum: datum,
            isSelected: isSelected,
            pad: column.pin && cellProps.pinned.pad || cellProps.pad,
            pinnedOffset: pinnedOffset && pinnedOffset[column.property],
            primaryProperty: primaryProperty,
            scope: column.primary || column.property === primaryProperty ? 'row' : undefined,
            verticalAlign: verticalAlign
        });
    })), rowDetails && isRowExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $baa3c9c2b8eedc6c$export$35ee3cab512e9b03), {
        key: index.toString() + "_expand"
    }, (selected || onSelect) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $ab315163778b3d77$export$1e4baea7053fc0e3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $ab315163778b3d77$export$1e4baea7053fc0e3), {
        colSpan: columns.length + 1
    }, rowDetails.render ? rowDetails.render(datum) : rowDetails(datum))));
});
var $b4e3f955e73545f0$export$4b2c32e08f77ff18 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref2, ref) {
    var cellPropsProp = _ref2.cellProps, columns = _ref2.columns, data = _ref2.data, disabled = _ref2.disabled, onMore = _ref2.onMore, replace = _ref2.replace, onClickRow = _ref2.onClickRow, onSelect = _ref2.onSelect, pinnedOffset = _ref2.pinnedOffset, primaryProperty = _ref2.primaryProperty, rowProps = _ref2.rowProps, selected = _ref2.selected, rowDetails = _ref2.rowDetails, show = _ref2.show, size = _ref2.size, step = _ref2.step, rowExpand = _ref2.rowExpand, setRowExpand = _ref2.setRowExpand, verticalAlign = _ref2.verticalAlign, rest = $b4e3f955e73545f0$var$_objectWithoutPropertiesLoose(_ref2, $b4e3f955e73545f0$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).useState(), focused = _React$useState[0], setFocused = _React$useState[1];
    var _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).useState(), lastFocused = _React$useState2[0], setLastFocused = _React$useState2[1];
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).useState(), active = _React$useState3[0], setActive = _React$useState3[1];
    var _React$useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).useState(), scroll = _React$useState4[0], setScroll = _React$useState4[1];
    var containerRef = (0, $3cecef11d3b9c451$export$61dc559f8a0b9bcf)(ref);
    // Store refs for each row to enable direct focus management
    var rowRefs = (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).useRef(new Map());
    // Callback to store row references
    var handleRowRefChange = (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).useCallback(function(index, element) {
        if (element) rowRefs.current.set(index, element);
        else rowRefs.current["delete"](index);
    }, []);
    var activePrimaryValue = active >= 0 ? (0, $0169a8904a4129ab$export$682ea250e758ab92)(data[active], primaryProperty) : undefined;
    var selectRow = function selectRow() {
        if (activePrimaryValue !== undefined) {
            if (selected && selected.includes(activePrimaryValue)) onSelect(selected.filter(function(s) {
                return s !== activePrimaryValue;
            }));
            else onSelect([].concat(selected, [
                activePrimaryValue
            ]));
        }
    };
    var clickableRow = onClickRow && active >= 0 && (!disabled || activePrimaryValue !== undefined && !disabled.includes(activePrimaryValue));
    // Determine if the DataTable body is scrollable
    (0, $2xPiy.useEffect)(function() {
        if (containerRef.current) {
            var element = containerRef.current;
            if (element.scrollHeight > element.offsetHeight) setScroll(true);
        }
    }, [
        containerRef
    ]);
    // roving tab index, ensure row (when onClickRow) has DOM focus
    (0, $2xPiy.useEffect)(function() {
        if (focused !== undefined && rowRefs.current.has(focused)) {
            var focusedRowElement = rowRefs.current.get(focused);
            if (focusedRowElement && focusedRowElement.focus) focusedRowElement.focus();
        }
    }, [
        focused
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $168667f04da9206c$export$16e4d70cc375e707), {
        onEnter: clickableRow ? function(event) {
            if (clickableRow) {
                if (typeof onClickRow === 'function') {
                    event.persist();
                    var adjustedEvent = event;
                    adjustedEvent.datum = data[focused];
                    onClickRow(adjustedEvent);
                } else if (onClickRow === 'select') selectRow();
            }
        } : undefined,
        onSpace: clickableRow ? function(event) {
            event.preventDefault();
            if (typeof onClickRow === 'function') {
                event.persist();
                var adjustedEvent = event;
                adjustedEvent.datum = data == null ? void 0 : data[focused];
                onClickRow(adjustedEvent);
            } else if (onClickRow === 'select') selectRow();
        } : undefined,
        onUp: onClickRow && focused ? function() {
            var previousIndex = focused - 1;
            setFocused(previousIndex);
            setActive(previousIndex);
        } : undefined,
        onDown: onClickRow && data.length && focused < data.length - 1 ? function(event) {
            event.preventDefault();
            var nextIndex = (focused != null ? focused : -1) + 1;
            setFocused(nextIndex);
            setActive(nextIndex);
        } : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $baa3c9c2b8eedc6c$export$d272165a8a43ec6), $b4e3f955e73545f0$var$_extends({
        ref: containerRef,
        size: size,
        tabIndex: !onClickRow && scroll ? 0 : undefined,
        onMouseOut: function onMouseOut() {
            return setActive(undefined);
        },
        onBlur: function onBlur(event) {
            // only reset focused if the focus is leaving the table
            // and not moving to a child element of the table
            if (containerRef.current && !containerRef.current.contains(event.relatedTarget)) {
                setLastFocused(focused);
                setFocused(undefined);
                setActive(undefined);
            }
        }
    }, passThemeFlag, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $26613b622f673475$export$c5295390d6167a3e), {
        items: data,
        onMore: onMore,
        replace: replace,
        renderMarker: function renderMarker(marker) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $551c43fc27d858fa$export$b05581f4e764e162), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $ab315163778b3d77$export$1e4baea7053fc0e3), null, marker));
        },
        show: show,
        step: step
    }, function(datum, index, rowRef) {
        var primaryValue = primaryProperty ? (0, $0169a8904a4129ab$export$682ea250e758ab92)(datum, primaryProperty) : undefined;
        var isSelected = selected && selected.includes(primaryValue);
        var isDisabled = disabled && disabled.includes(primaryValue);
        var isRowExpanded = rowExpand && rowExpand.includes(primaryValue || index);
        var cellProps = (0, $0169a8904a4129ab$export$b3f0e4b3a6cf0421)(rowProps, cellPropsProp, primaryValue, index);
        var expandLabel;
        if (typeof rowDetails === 'object' && typeof rowDetails.expandLabel === 'function') expandLabel = rowDetails.expandLabel(datum);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($b4e3f955e73545f0$var$Row, {
            expandLabel: expandLabel,
            key: primaryValue != null ? primaryValue : index,
            setActive: setActive,
            rowRef: rowRef,
            cellProps: cellProps,
            primaryValue: primaryValue,
            isDisabled: isDisabled,
            isSelected: isSelected,
            isRowExpanded: isRowExpanded,
            index: index,
            size: size,
            active: active >= 0 ? active === index : undefined,
            focused: focused,
            lastFocused: lastFocused,
            setFocused: setFocused,
            onRowRefChange: handleRowRefChange,
            onClickRow: onClickRow,
            passThemeFlag: passThemeFlag,
            datum: datum,
            selected: selected,
            onSelect: onSelect,
            rowDetails: rowDetails,
            setRowExpand: setRowExpand,
            rowExpand: rowExpand,
            columns: columns,
            primaryProperty: primaryProperty,
            rowProps: rowProps,
            data: data,
            theme: theme,
            pinnedOffset: pinnedOffset,
            verticalAlign: verticalAlign
        });
    })));
});



var $2xPiy = parcelRequire("2xPiy");









var $249ab81a6ca40f54$var$_excluded = [
    "cellProps",
    "columns",
    "data",
    "disabled",
    "groupBy",
    "groups",
    "groupState",
    "messages",
    "pinnedOffset",
    "primaryProperty",
    "onMore",
    "onSelect",
    "onToggle",
    "onUpdate",
    "replace",
    "rowProps",
    "selected",
    "size",
    "step",
    "verticalAlign"
];
function $249ab81a6ca40f54$var$_extends() {
    return $249ab81a6ca40f54$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $249ab81a6ca40f54$var$_extends.apply(null, arguments);
}
function $249ab81a6ca40f54$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $249ab81a6ca40f54$export$298bfb09deaa1b80 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var cellPropsProp = _ref.cellProps, columns = _ref.columns, data = _ref.data, disabled = _ref.disabled, groupBy = _ref.groupBy, groups = _ref.groups, groupState = _ref.groupState, messages = _ref.messages, pinnedOffset = _ref.pinnedOffset, primaryProperty = _ref.primaryProperty, onMore = _ref.onMore, onSelect = _ref.onSelect, onToggle = _ref.onToggle, onUpdate = _ref.onUpdate, replace = _ref.replace, rowProps = _ref.rowProps, selected = _ref.selected, size = _ref.size, step = _ref.step, verticalAlign = _ref.verticalAlign, rest = $249ab81a6ca40f54$var$_objectWithoutPropertiesLoose(_ref, $249ab81a6ca40f54$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var items = (0, $2xPiy.useMemo)(function() {
        var nextItems = [];
        groups.forEach(function(group) {
            var _ref2 = groupState[group.key] || {
                expanded: true
            }, expanded = _ref2.expanded;
            var memberCount = group.data.length;
            var groupSelected = [];
            var isGroupSelected = false;
            var groupDisabled = [];
            var isGroupDisabled = false;
            if (memberCount > 1 || onUpdate && group.key !== undefined) {
                // need a header
                var primaryKeys = group.data.map(function(datum) {
                    return datum[primaryProperty];
                });
                groupSelected = primaryKeys && selected ? primaryKeys.filter(function(val) {
                    return selected.includes(val);
                }) : [];
                isGroupSelected = groupBy.select ? groupBy.select[group.key] === 'all' : groupSelected.length === group.data.length && groupSelected.length > 0;
                var indeterminate = groupBy.select ? groupBy.select[group.key] === 'some' : groupSelected.length > 0 && groupSelected.length < group.data.length;
                groupDisabled = primaryKeys && disabled ? primaryKeys.filter(function(val) {
                    return disabled.includes(val);
                }) : [];
                isGroupDisabled = groupBy.disable ? groupBy.disable[group.key] === 'all' : groupDisabled.length === group.data.length && groupDisabled.length > 0;
                nextItems.push({
                    expanded: expanded,
                    key: group.key,
                    primaryValue: group.key,
                    datum: group.datum,
                    context: 'groupHeader',
                    isDisabled: isGroupDisabled,
                    isSelected: isGroupSelected,
                    indeterminate: indeterminate,
                    onChange: function onChange() {
                        var nextSelected = isGroupSelected || indeterminate ? selected.filter(function(s) {
                            return !groupSelected.includes(s);
                        }) : [].concat(selected, primaryKeys);
                        if (groupBy.onSelect) groupBy.onSelect(nextSelected, group.datum, groupBy.select);
                        else onSelect(nextSelected, group.datum);
                    }
                });
            }
            if (!onUpdate && memberCount === 1 || expanded) // add the group members
            group.data.forEach(function(datum, index) {
                var primaryValue = primaryProperty ? (0, $0169a8904a4129ab$export$682ea250e758ab92)(datum, primaryProperty) : undefined;
                var isSelected = selected == null ? void 0 : selected.includes(primaryValue);
                var isDisabled = disabled == null ? void 0 : disabled.includes(primaryValue);
                nextItems.push({
                    key: datum[primaryProperty],
                    primaryValue: primaryProperty ? (0, $0169a8904a4129ab$export$682ea250e758ab92)(datum, primaryProperty) : undefined,
                    datum: datum,
                    context: memberCount > 1 && index === memberCount - 1 ? 'groupEnd' : 'body',
                    isDisabled: isDisabled,
                    isSelected: isSelected,
                    onChange: function onChange() {
                        var nextSelected = isSelected ? selected.filter(function(s) {
                            return s !== primaryValue;
                        }) : [].concat(selected, [
                            primaryValue
                        ]);
                        onSelect(nextSelected, datum);
                    }
                });
            });
        });
        return nextItems;
    }, [
        disabled,
        groups,
        groupBy,
        groupState,
        primaryProperty,
        selected,
        onSelect,
        onUpdate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $baa3c9c2b8eedc6c$export$d272165a8a43ec6), $249ab81a6ca40f54$var$_extends({
        ref: ref,
        size: size
    }, passThemeFlag, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $26613b622f673475$export$c5295390d6167a3e), {
        items: items,
        onMore: onMore,
        replace: replace,
        renderMarker: function renderMarker(marker) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $551c43fc27d858fa$export$b05581f4e764e162), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $ab315163778b3d77$export$1e4baea7053fc0e3), null, marker));
        },
        step: step
    }, function(row, index, rowRef) {
        var context = row.context, datum = row.datum, expanded = row.expanded, indeterminate = row.indeterminate, isDisabled = row.isDisabled, isSelected = row.isSelected, key = row.key, onChange = row.onChange, primaryValue = row.primaryValue;
        var cellProps = (0, $0169a8904a4129ab$export$b3f0e4b3a6cf0421)(rowProps, context === 'groupHeader' ? cellPropsProp.groupHeader : cellPropsProp.body, primaryValue, index);
        var ariaLabel;
        if (typeof groupBy === 'object' && typeof groupBy.expandLabel === 'function') {
            var labelRow = context === 'groupHeader' ? row.datum : row.datum;
            ariaLabel = groupBy.expandLabel(labelRow);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $baa3c9c2b8eedc6c$export$35ee3cab512e9b03), $249ab81a6ca40f54$var$_extends({
            ref: rowRef,
            key: key,
            size: size
        }, passThemeFlag), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $224208e7799fa405$export$8ebdff051337858b), {
            background: isSelected && cellProps.selected.background || cellProps.background,
            expandLabel: ariaLabel,
            border: cellProps.border,
            context: context,
            messages: messages,
            pad: cellProps.pad,
            onToggle: context === 'groupHeader' ? onToggle(key) : undefined,
            expanded: expanded,
            verticalAlign: verticalAlign
        }), (selected || onSelect) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $ab315163778b3d77$export$1e4baea7053fc0e3), {
            background: isSelected && cellProps.selected.background || cellProps.background,
            border: cellProps.pinned.border || cellProps.border,
            plain: "noPad",
            size: "auto",
            verticalAlign: verticalAlign,
            "aria-disabled": isDisabled || !onSelect || undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
            a11yTitle: (isSelected ? 'unselect' : 'select') + " " + (context === 'groupHeader' ? key : primaryValue),
            checked: isSelected,
            indeterminate: indeterminate,
            disabled: isDisabled || !onSelect,
            onChange: onChange,
            pad: cellProps.pad
        })), columns.map(function(column) {
            var scope;
            if (context === 'groupHeader') scope = column.property === groupBy.property ? 'row' : undefined;
            else scope = column.primary ? 'row' : undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $62b76240ebbeb53a$export$f6f0c3fe4ec306ea), {
                key: column.property,
                background: isSelected && cellProps.selected.background || cellProps.background,
                border: cellProps.border,
                context: context,
                column: column,
                datum: datum,
                pad: cellProps.pad,
                scope: scope,
                pinnedOffset: pinnedOffset && pinnedOffset[column.property],
                verticalAlign: verticalAlign
            });
        }));
    }));
});



var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");



var $2xPiy = parcelRequire("2xPiy");


function $2f0cb182ea7bd57a$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $2f0cb182ea7bd57a$var$_extends() {
    return $2f0cb182ea7bd57a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2f0cb182ea7bd57a$var$_extends.apply(null, arguments);
}
var $2f0cb182ea7bd57a$export$39140c7d8b0ba7b3 = function Nav(_ref) {
    var _theme$nav;
    var rest = $2f0cb182ea7bd57a$var$_extends({}, ($2f0cb182ea7bd57a$var$_objectDestructuringEmpty(_ref), _ref));
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), $2f0cb182ea7bd57a$var$_extends({
        as: "nav",
        flex: false,
        gap: (_theme$nav = theme.nav) == null ? void 0 : _theme$nav.gap
    }, rest));
};



var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");



var $99b04cc334c2c14b$var$sizeStyle = function sizeStyle(props) {
    var style = props.theme.pagination.button && props.theme.pagination.button.size && props.theme.pagination.button.size[props.size || 'medium'];
    return style ? {
        content: {
            fontSize: style.font && style.font.size,
            // fix for safari, apply line-height 0 on next/previous
            // icon-only buttons
            lineHeight: style.font && props.hasLabel ? style.font.height : 0
        },
        container: {
            height: style.height,
            minWidth: style.width
        }
    } : '';
};
var $99b04cc334c2c14b$export$84e27f887f319440 = (0, $iA1nz.default)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1)).withConfig({
    displayName: "StyledPageControl__StyledPaginationButton",
    componentId: "sc-1vlfaez-0"
})([
    "> svg{margin:0 auto;}",
    ";"
], function(props) {
    return $99b04cc334c2c14b$var$sizeStyle(props).content;
});
var $99b04cc334c2c14b$export$1d41361302b577a1 = (0, $iA1nz.default).div.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledPageControl__StyledContainer",
    componentId: "sc-1vlfaez-1"
})([
    "display:flex;align-items:center;justify-content:center;max-width:100%;",
    ";",
    ";"
], function(props) {
    return $99b04cc334c2c14b$var$sizeStyle(props).container;
}, function(props) {
    return props.theme.pagination.control && props.theme.pagination.control.extend;
});
var $99b04cc334c2c14b$export$6d7013b439c96bfa = (0, $iA1nz.default)((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6)).withConfig({
    displayName: "StyledPageControl__StyledSeparator",
    componentId: "sc-1vlfaez-2"
})([
    "font-weight:bold;",
    ";",
    ";"
], function(props) {
    return "font-size: " + ($99b04cc334c2c14b$var$sizeStyle(props).content && $99b04cc334c2c14b$var$sizeStyle(props).content.fontSize);
}, function(props) {
    return "line-height: " + ($99b04cc334c2c14b$var$sizeStyle(props).content && $99b04cc334c2c14b$var$sizeStyle(props).content.lineHeight);
});



var $4ff9a69e05662c2e$var$_excluded = [
    "control",
    "separator",
    "size"
];
function $4ff9a69e05662c2e$var$_extends() {
    return $4ff9a69e05662c2e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4ff9a69e05662c2e$var$_extends.apply(null, arguments);
}
function $4ff9a69e05662c2e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $4ff9a69e05662c2e$export$4109320283c508e = function PageControl(_ref) {
    var control = _ref.control, separator = _ref.separator, sizeProp = _ref.size, rest = $4ff9a69e05662c2e$var$_objectWithoutPropertiesLoose(_ref, $4ff9a69e05662c2e$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var size = sizeProp || 'medium';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $99b04cc334c2c14b$export$1d41361302b577a1), $4ff9a69e05662c2e$var$_extends({
        as: "li",
        size: size
    }, passThemeFlag), separator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $99b04cc334c2c14b$export$6d7013b439c96bfa), $4ff9a69e05662c2e$var$_extends({
        size: size
    }, passThemeFlag), "\u2026") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $99b04cc334c2c14b$export$84e27f887f319440), $4ff9a69e05662c2e$var$_extends({
        a11yTitle: "Go to page " + control,
        fill: true,
        kind: theme.pagination.button,
        label: control,
        size: size
    }, passThemeFlag, rest)));
};



var $2xPiy = parcelRequire("2xPiy");


var $2xPiy = parcelRequire("2xPiy");





var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");
var $ac084058cd06093e$exports = {};

$parcel$export($ac084058cd06093e$exports, "__esModule", function () { return $ac084058cd06093e$export$1e511d4a378977f5; }, function (v) { return $ac084058cd06093e$export$1e511d4a378977f5 = v; });
$parcel$export($ac084058cd06093e$exports, "Search", function () { return $ac084058cd06093e$export$4b85d3515bd863a5; }, function (v) { return $ac084058cd06093e$export$4b85d3515bd863a5 = v; });
var $ac084058cd06093e$export$1e511d4a378977f5;
var $ac084058cd06093e$export$4b85d3515bd863a5;
"use strict";
$ac084058cd06093e$export$1e511d4a378977f5 = true;
$ac084058cd06093e$export$4b85d3515bd863a5 = void 0;

var $ac084058cd06093e$var$_react = $ac084058cd06093e$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $ac084058cd06093e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ac084058cd06093e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ac084058cd06093e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ac084058cd06093e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ac084058cd06093e$var$_extends() {
    return $ac084058cd06093e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ac084058cd06093e$var$_extends.apply(null, arguments);
}
var $ac084058cd06093e$var$Search = $ac084058cd06093e$export$4b85d3515bd863a5 = /*#__PURE__*/ (0, $ac084058cd06093e$var$_react.forwardRef)(function(props, ref) {
    var scaleProps = (0, $1b754218be0a6592$export$56a2e46cd4a7c217)(props);
    return /*#__PURE__*/ $ac084058cd06093e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ac084058cd06093e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Search"
    }, props), /*#__PURE__*/ $ac084058cd06093e$var$_react["default"].createElement("path", $ac084058cd06093e$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m15 15 7 7-7-7zm-5.5 2a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15z"
    }, scaleProps)));
});
$ac084058cd06093e$var$Search.displayName = 'Search';











var $iA1nz = parcelRequire("iA1nz");





var $72edb32352a5dc2f$export$1d41361302b577a1 = (0, $iA1nz.default)((0, $18c0523379e5dd9d$export$e71c4d32a2263218)).withConfig({
    displayName: "StyledSelect__StyledContainer",
    componentId: "sc-znp66n-0"
})([
    "@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){width:100%;}",
    ";",
    ";"
], function(props) {
    return props.dropHeight ? (0, $73ba8e2d301b823f$export$cb60038e9cf9f581)('max-height', props.dropHeight, props.theme) : 'max-height: inherit;';
}, function(props) {
    return props.theme.select.container && props.theme.select.container.extend;
});
var $72edb32352a5dc2f$export$1a780bb4ae54ddec = (0, $iA1nz.default).div.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledSelect__OptionsContainer",
    componentId: "sc-znp66n-1"
})([
    "position:relative;scroll-behavior:smooth;overflow:auto;outline:none;",
    ";"
], function(props) {
    if (props.selectMultiple) return props.theme.selectMultiple.listbox && props.theme.selectMultiple.listbox.extend;
    return props.theme.select.listbox && props.theme.select.listbox.extend;
});
var $72edb32352a5dc2f$export$7196851310a3d0bf = (0, $iA1nz.default).input.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledSelect__HiddenInput",
    componentId: "sc-znp66n-2"
})([
    "display:none;"
]);
var $72edb32352a5dc2f$export$11a8a1ea41bf55d8 = (0, $iA1nz.default)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1)).withConfig({
    displayName: "StyledSelect__SelectOption",
    componentId: "sc-znp66n-3"
})([
    "",
    " ",
    " &:focus{",
    "}display:block;width:100%;",
    ";"
], function(props) {
    return props.selected && props.textComponent && (0, $0b4a347e23c22183$export$a7abb1b3dc25813f);
}, function(props) {
    return props.active && (0, $0b4a347e23c22183$export$172ca055ee2bcc62)(!props.children && !props.theme.select.options ? undefined : 'background', props.theme);
}, function(props) {
    return props.active && (0, $0b4a347e23c22183$export$172ca055ee2bcc62)(!props.children && !props.theme.select.options ? undefined : 'background', props.theme);
}, function(props) {
    return props["aria-disabled"] && "cursor: default";
});
var $72edb32352a5dc2f$export$b34b5c37a9633c78 = (0, $iA1nz.default)((0, $8c9c99ffe8765a99$export$c86715117507e8e5)).withConfig({
    displayName: "StyledSelect__SelectTextInput",
    componentId: "sc-znp66n-4"
})([
    "cursor:",
    ";"
], function(props) {
    return props.defaultCursor ? 'default' : 'pointer';
});
var $72edb32352a5dc2f$export$923536af422910c8 = (0, $iA1nz.default)((0, $c9158ac1cba12f75$export$64fff40e709e8b2e)).withConfig({
    displayName: "StyledSelect__StyledSelectDropButton",
    componentId: "sc-znp66n-5"
})([
    "",
    ";",
    ";",
    ";"
], function(props) {
    return !props.plainSelect && (0, $73ba8e2d301b823f$export$717407de81592eca);
}, function(props) {
    var _props$theme$select;
    return (_props$theme$select = props.theme.select) == null || (_props$theme$select = _props$theme$select.control) == null ? void 0 : _props$theme$select.extend;
}, function(props) {
    var _props$theme$select2;
    return props.open && ((_props$theme$select2 = props.theme.select) == null || (_props$theme$select2 = _props$theme$select2.control) == null ? void 0 : _props$theme$select2.open);
});



var $2xPiy = parcelRequire("2xPiy");

var $f3173fa86fa0c94f$export$f9e47df77939ed56 = function applyKey(option, key) {
    if (/*#__PURE__*/ (0, $2xPiy.isValidElement)(option)) return option;
    if (option === undefined || option === null) return undefined;
    if (typeof key === 'object') return $f3173fa86fa0c94f$export$f9e47df77939ed56(option, key.key);
    if (typeof key === 'function') return key(option);
    if (key !== undefined && typeof option === 'object') return option[key];
    if (typeof option === 'object' && Object.keys(option).length > 0) return option[Object.keys(option)[0]];
    return option;
};
var $f3173fa86fa0c94f$export$dac6ace3020563ca = function getOptionLabel(index, options, labelKey) {
    return $f3173fa86fa0c94f$export$f9e47df77939ed56(options[index], labelKey);
};
var $f3173fa86fa0c94f$export$40be908210c5a79c = function getOptionValue(index, options, valueKey) {
    return $f3173fa86fa0c94f$export$f9e47df77939ed56(options[index], valueKey);
};
var $f3173fa86fa0c94f$export$2921b90f3ed1b63a = function getOptionIndex(options, i, valueKey) {
    if (options) {
        if (typeof i === 'object') return options.findIndex(function(x) {
            return $f3173fa86fa0c94f$export$f9e47df77939ed56(x, valueKey) === $f3173fa86fa0c94f$export$f9e47df77939ed56(i, valueKey);
        });
        return options.indexOf(i);
    }
    return undefined;
};
var $f3173fa86fa0c94f$export$22012a5c726bef55 = function arrayIncludes(arr, i, valueKey) {
    if (arr) {
        if (typeof i === 'object') return arr.some(function(x) {
            return $f3173fa86fa0c94f$export$f9e47df77939ed56(x, valueKey) === $f3173fa86fa0c94f$export$f9e47df77939ed56(i, valueKey);
        });
        return arr.includes(i);
    }
    return undefined;
};
var $f3173fa86fa0c94f$export$c763bb7a184a0f11 = function useDisabled(disabled, disabledKey, options, valueKey) {
    return (0, $2xPiy.useCallback)(function(index) {
        var option = options[index];
        var result;
        if (disabledKey) result = $f3173fa86fa0c94f$export$f9e47df77939ed56(option, disabledKey);
        else if (Array.isArray(disabled)) {
            if (typeof disabled[0] === 'number') result = disabled.indexOf(index) !== -1;
            else {
                var optionVal = $f3173fa86fa0c94f$export$40be908210c5a79c(index, options, valueKey);
                result = $f3173fa86fa0c94f$export$2921b90f3ed1b63a(disabled, options[index], valueKey) !== -1 || $f3173fa86fa0c94f$export$2921b90f3ed1b63a(disabled, optionVal, valueKey) !== -1;
            }
        }
        return result;
    }, [
        disabled,
        disabledKey,
        options,
        valueKey
    ]);
};
var $f3173fa86fa0c94f$export$49df40d5c24cf7e3 = function getNormalizedValue(value, valueKey) {
    if (Array.isArray(value)) return value.map(function(v) {
        return valueKey && valueKey.reduce ? v : $f3173fa86fa0c94f$export$f9e47df77939ed56(v, valueKey);
    });
    return valueKey && valueKey.reduce ? value : $f3173fa86fa0c94f$export$f9e47df77939ed56(value, valueKey);
};
var $f3173fa86fa0c94f$export$922aead9cd650d86 = function changeEvent(inputRef, nextValue) {
    // Calling set value function directly on input because React library
    // overrides setter `event.target.value =` and loses original event
    // target fidelity.
    // https://stackoverflow.com/a/46012210
    var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    nativeInputValueSetter.call(inputRef.current, nextValue);
    var event = new Event('input', {
        bubbles: true
    });
    inputRef.current.dispatchEvent(event);
};
var $f3173fa86fa0c94f$export$ea6782b1ec892245 = function getSelectIcon(icon, theme, open) {
    var SelectIcon;
    switch(icon){
        case false:
            break;
        case true:
        case undefined:
            SelectIcon = open && theme.select.icons.up ? theme.select.icons.up : theme.select.icons.down;
            break;
        default:
            SelectIcon = icon;
    }
    return SelectIcon;
};
var $f3173fa86fa0c94f$export$7e4915d842d2c2e = function getDisplayLabelKey(labelKey, allOptions, optionIndexesInValue, selectValue) {
    var optionLabelKey = $f3173fa86fa0c94f$export$f9e47df77939ed56(allOptions[optionIndexesInValue[0]], labelKey);
    if (!selectValue && optionIndexesInValue.length === 1 && typeof optionLabelKey === 'object') return optionLabelKey;
    return undefined;
};
var $f3173fa86fa0c94f$export$bb417e0702eb86b5 = function getIconColor(theme) {
    return (0, $11317b0e49e0d157$export$4cde5df63f53f473)(theme.select.icons.color || 'control', theme);
};
var $f3173fa86fa0c94f$export$fe7dc70cd4404dea = function formatValueForA11y(value, labelKey) {
    if (typeof value === 'string') return value;
    if (/*#__PURE__*/ (0, $2xPiy.isValidElement)(value)) return value.toString();
    if (Array.isArray(value)) return value.map(function(item) {
        return $f3173fa86fa0c94f$export$fe7dc70cd4404dea(item, labelKey);
    }).join(', ');
    return $f3173fa86fa0c94f$export$f9e47df77939ed56(value, labelKey);
};
var $f3173fa86fa0c94f$export$6f8d7bb3dad10aa1 = (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).use ? true : '';
var $f3173fa86fa0c94f$export$abfa4f6a3fb2b741 = function selectInputId(id) {
    return id + "__input";
};



var $2xPiy = parcelRequire("2xPiy");


function $8c72eb2f36aa176e$var$_extends() {
    return $8c72eb2f36aa176e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8c72eb2f36aa176e$var$_extends.apply(null, arguments);
}
var $8c72eb2f36aa176e$export$e87a5b03dc8a6193 = function EmptySearchOption(_ref) {
    var _theme$select, _theme$select2, _theme$select3;
    var emptySearchMessage = _ref.emptySearchMessage, selectOptionsStyle = _ref.selectOptionsStyle, theme = _ref.theme;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), (theme == null || (_theme$select = theme.select) == null || (_theme$select = _theme$select.emptySearchMessage) == null ? void 0 : _theme$select.container) || selectOptionsStyle, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), $8c72eb2f36aa176e$var$_extends({
        "aria-live": "polite",
        role: "alert"
    }, (theme == null || (_theme$select2 = theme.select) == null || (_theme$select2 = _theme$select2.emptySearchMessage) == null ? void 0 : _theme$select2.text) || ((_theme$select3 = theme.select) == null || (_theme$select3 = _theme$select3.options) == null ? void 0 : _theme$select3.text)), emptySearchMessage));
};



var $2d5956cb936b8932$var$_excluded = [
    "clear",
    "onClear",
    "name",
    "theme"
];
function $2d5956cb936b8932$var$_extends() {
    return $2d5956cb936b8932$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2d5956cb936b8932$var$_extends.apply(null, arguments);
}
function $2d5956cb936b8932$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// ensure ClearButton receives visual indication of keyboard
var $2d5956cb936b8932$var$StyledButton = (0, $iA1nz.default)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1)).withConfig({
    displayName: "SelectContainer__StyledButton",
    componentId: "sc-1wi0ul8-0"
})([
    "&:focus{",
    "}"
], function(props) {
    return (0, $0b4a347e23c22183$export$172ca055ee2bcc62)('background', props.theme);
});
var $2d5956cb936b8932$var$ClearButton = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var _theme$select$clear, _theme$select$clear2, _theme$select$clear3;
    var clear = _ref.clear, onClear = _ref.onClear, name = _ref.name, theme = _ref.theme, rest = $2d5956cb936b8932$var$_objectWithoutPropertiesLoose(_ref, $2d5956cb936b8932$var$_excluded);
    var label = clear.label, position = clear.position;
    var align = position !== 'bottom' ? 'start' : 'center';
    var buttonLabel = label || "Clear " + (name || 'selection');
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var buttonKind = (_theme$select$clear = theme.select.clear) == null ? void 0 : _theme$select$clear.button;
    var containerProps = ((_theme$select$clear2 = theme.select.clear) == null ? void 0 : _theme$select$clear2.container) || {};
    var textProps = ((_theme$select$clear3 = theme.select.clear) == null ? void 0 : _theme$select$clear3.text) || {};
    var buttonProps = $2d5956cb936b8932$var$_extends({
        a11yTitle: buttonLabel + ". Or, press " + (position === 'bottom' ? 'shift tab' : 'down arrow') + " to move to select options",
        align: align,
        fill: 'horizontal',
        onClick: onClear,
        ref: ref
    }, passThemeFlag, rest);
    if (buttonKind) // new structure when `theme.select.clear.button` is defined
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), $2d5956cb936b8932$var$_extends({
        flex: "grow"
    }, containerProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), $2d5956cb936b8932$var$_extends({
        kind: buttonKind,
        label: textProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), textProps, buttonLabel) : buttonLabel
    }, buttonProps)));
    // default structure when `theme.select.clear.button` is not defined
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($2d5956cb936b8932$var$StyledButton, $2d5956cb936b8932$var$_extends({
        focusIndicator: false,
        plain: true
    }, buttonProps), function(_ref2) {
        var _theme$select$clear4;
        var hover = _ref2.hover;
        var boxProps = $2d5956cb936b8932$var$_extends({}, theme.select.clear.container);
        delete boxProps.hover; // avoid passing hover object to Box
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), $2d5956cb936b8932$var$_extends({}, boxProps, hover ? (_theme$select$clear4 = theme.select.clear) == null || (_theme$select$clear4 = _theme$select$clear4.container) == null ? void 0 : _theme$select$clear4.hover : {}, {
            align: align
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), theme.select.clear.text, buttonLabel));
    });
});
var $2d5956cb936b8932$export$446eebadefe1123b = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref3, ref) {
    var _theme$select$icons, _theme$select;
    var clear = _ref3.clear, _ref3$children = _ref3.children, children = _ref3$children === void 0 ? null : _ref3$children, disabled = _ref3.disabled, disabledKey = _ref3.disabledKey, dropHeight = _ref3.dropHeight, _ref3$emptySearchMess = _ref3.emptySearchMessage, emptySearchMessage = _ref3$emptySearchMess === void 0 ? 'No matches found' : _ref3$emptySearchMess, id = _ref3.id, labelKey = _ref3.labelKey, messages = _ref3.messages, multiple = _ref3.multiple, name = _ref3.name, onChange = _ref3.onChange, onKeyDown = _ref3.onKeyDown, onMore = _ref3.onMore, onSearch = _ref3.onSearch, optionIndexesInValue = _ref3.optionIndexesInValue, options = _ref3.options, allOptions = _ref3.allOptions, searchPlaceholder = _ref3.searchPlaceholder, search = _ref3.search, setSearch = _ref3.setSearch, selected = _ref3.selected, usingKeyboard = _ref3.usingKeyboard, _ref3$value = _ref3.value, value = _ref3$value === void 0 ? '' : _ref3$value, valueKey = _ref3.valueKey, _ref3$replace = _ref3.replace, replace = _ref3$replace === void 0 ? true : _ref3$replace;
    var _useThemeValue2 = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue2.theme, passThemeFlag = _useThemeValue2.passThemeFlag;
    var shouldShowClearButton = (0, $2xPiy.useCallback)(function(position) {
        var hasValue = Boolean(multiple && value ? value.length : value);
        var showAtPosition = position === 'bottom' ? (clear == null ? void 0 : clear.position) === 'bottom' : (clear == null ? void 0 : clear.position) !== 'bottom';
        return clear && hasValue && showAtPosition;
    }, [
        clear,
        multiple,
        value
    ]);
    var isDisabled = (0, $f3173fa86fa0c94f$export$c763bb7a184a0f11)(disabled, disabledKey, options, valueKey || labelKey);
    var _useState = (0, $2xPiy.useState)(usingKeyboard && !shouldShowClearButton('top') && !onSearch ? 0 : -1), activeIndex = _useState[0], setActiveIndex = _useState[1];
    var _useState2 = (0, $2xPiy.useState)(usingKeyboard), keyboardNavigation = _useState2[0], setKeyboardNavigation = _useState2[1];
    var searchRef = (0, $2xPiy.useRef)();
    var optionsRef = (0, $2xPiy.useRef)();
    var clearRef = (0, $2xPiy.useRef)();
    var activeRef = (0, $2xPiy.useRef)();
    var _useContext = (0, $2xPiy.useContext)((0, $f1ad7bf122eed3b0$export$b060d577040138d8)), format = _useContext.format;
    var searchIcon = ((_theme$select$icons = theme.select.icons) == null ? void 0 : _theme$select$icons.search) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $ac084058cd06093e$export$4b85d3515bd863a5), {
        "aria-hidden": true
    });
    // for keyboard/screenreader, keep the active option in focus
    (0, $2xPiy.useEffect)(function() {
        var _activeRef$current;
        if (activeIndex >= 0) (_activeRef$current = activeRef.current) == null || _activeRef$current.focus();
    }, [
        activeIndex
    ]);
    // set initial focus
    (0, $2xPiy.useEffect)(function() {
        // need to wait for Drop to be ready
        var timer = setTimeout(function() {
            var optionsNode = optionsRef.current;
            var clearButton = clearRef.current;
            if (onSearch) {
                var searchInput = searchRef.current;
                if (searchInput && searchInput.focus && !activeRef.current) (0, $83f2052c15a18307$export$99137e580254b26a)(searchInput);
            } else if (clear && clearButton && clearButton.focus && clear.position !== 'bottom') (0, $83f2052c15a18307$export$99137e580254b26a)(clearButton);
            else if (usingKeyboard && activeRef.current) (0, $83f2052c15a18307$export$99137e580254b26a)(activeRef.current);
            else if (optionsNode) (0, $83f2052c15a18307$export$99137e580254b26a)(optionsNode);
        }, 100);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        onSearch,
        usingKeyboard,
        clear
    ]);
    var isSelected = (0, $2xPiy.useCallback)(function(index) {
        var result;
        if (selected) // deprecated in favor of value
        result = selected.indexOf(index) !== -1;
        else {
            var optionVal = (0, $f3173fa86fa0c94f$export$40be908210c5a79c)(index, options, valueKey);
            if (Array.isArray(value)) {
                if (value.length === 0) result = false;
                else if (typeof value[0] !== 'object') result = value.indexOf(optionVal) !== -1;
                else if (valueKey) result = value.some(function(valueItem) {
                    var valueValue = typeof valueKey === 'function' ? valueKey(valueItem) : valueItem[valueKey] || valueItem[valueKey.key];
                    return valueValue === optionVal;
                });
            } else if (valueKey && value !== null && typeof value === 'object') {
                var valueValue = typeof valueKey === 'function' ? valueKey(value) : value[valueKey];
                result = valueValue === optionVal;
            } else result = value === optionVal;
        }
        return result;
    }, [
        selected,
        value,
        valueKey,
        options
    ]);
    var selectOption = (0, $2xPiy.useCallback)(function(index) {
        return function(event) {
            if (onChange) {
                var nextValue;
                var nextSelected;
                if (multiple) {
                    var nextOptionIndexesInValue = optionIndexesInValue.slice(0);
                    var allOptionsIndex = allOptions.indexOf(options[index]);
                    var valueIndex = optionIndexesInValue.indexOf(allOptionsIndex);
                    if (valueIndex === -1) nextOptionIndexesInValue.push(allOptionsIndex);
                    else nextOptionIndexesInValue.splice(valueIndex, 1);
                    nextValue = nextOptionIndexesInValue.map(function(i) {
                        return valueKey && valueKey.reduce ? (0, $f3173fa86fa0c94f$export$f9e47df77939ed56)(allOptions[i], valueKey) : allOptions[i];
                    });
                    nextSelected = nextOptionIndexesInValue;
                } else {
                    nextValue = valueKey && valueKey.reduce ? (0, $f3173fa86fa0c94f$export$f9e47df77939ed56)(options[index], valueKey) : options[index];
                    nextSelected = index;
                }
                onChange(event, {
                    option: options[index],
                    value: nextValue,
                    selected: nextSelected
                });
            }
        };
    }, [
        multiple,
        onChange,
        optionIndexesInValue,
        options,
        allOptions,
        valueKey
    ]);
    var onClear = (0, $2xPiy.useCallback)(function(event) {
        onChange(event, {
            option: undefined,
            value: '',
            selected: ''
        });
    }, [
        onChange
    ]);
    var onNextOption = (0, $2xPiy.useCallback)(function(event) {
        event.preventDefault();
        var nextActiveIndex = activeIndex + 1;
        while(nextActiveIndex < options.length && isDisabled(nextActiveIndex))nextActiveIndex += 1;
        if (nextActiveIndex !== options.length) {
            setActiveIndex(nextActiveIndex);
            setKeyboardNavigation(true);
        }
    }, [
        activeIndex,
        options,
        isDisabled
    ]);
    var onPreviousOption = (0, $2xPiy.useCallback)(function(event) {
        event.preventDefault();
        var nextActiveIndex = activeIndex - 1;
        if (nextActiveIndex === -1) {
            var searchInput = searchRef.current;
            var clearButton = clearRef.current;
            if (clearButton && clearButton.focus && shouldShowClearButton('top')) {
                setActiveIndex(nextActiveIndex);
                (0, $83f2052c15a18307$export$99137e580254b26a)(clearButton);
            } else if (searchInput && searchInput.focus) {
                setActiveIndex(nextActiveIndex);
                (0, $83f2052c15a18307$export$99137e580254b26a)(searchInput);
            }
        }
        while(nextActiveIndex >= 0 && isDisabled(nextActiveIndex))nextActiveIndex -= 1;
        if (nextActiveIndex >= 0) {
            setActiveIndex(nextActiveIndex);
            setKeyboardNavigation(true);
        }
    }, [
        activeIndex,
        isDisabled,
        shouldShowClearButton
    ]);
    var onKeyDownOption = (0, $2xPiy.useCallback)(function(event) {
        if (!onSearch) {
            var nextActiveIndex = options.findIndex(function(e, index) {
                var label;
                if (typeof e === 'object') label = e.label || (0, $f3173fa86fa0c94f$export$f9e47df77939ed56)(e, labelKey);
                else label = e;
                return typeof label === 'string' && label.charAt(0).toLowerCase() === event.key.toLowerCase() && !isDisabled(index);
            });
            if (nextActiveIndex >= 0) {
                event.preventDefault();
                setActiveIndex(nextActiveIndex);
                setKeyboardNavigation(true);
            }
        }
        if (onKeyDown) onKeyDown(event);
    }, [
        isDisabled,
        labelKey,
        onKeyDown,
        options,
        onSearch
    ]);
    var onActiveOption = (0, $2xPiy.useCallback)(function(index) {
        return function() {
            if (!keyboardNavigation) setActiveIndex(index);
        };
    }, [
        keyboardNavigation
    ]);
    var onSelectOption = (0, $2xPiy.useCallback)(function(event) {
        if ((shouldShowClearButton('bottom') || shouldShowClearButton('top')) && (0, $83f2052c15a18307$export$b03135936dd040ba)(clearRef.current)) onChange(event, {
            option: undefined,
            value: '',
            selected: ''
        });
        else if (activeIndex >= 0 && activeIndex < options.length) {
            event.preventDefault(); // prevent submitting forms
            selectOption(activeIndex)(event);
        }
    }, [
        activeIndex,
        selectOption,
        options,
        onChange,
        shouldShowClearButton
    ]);
    var customSearchInput = theme.select.searchInput;
    var SelectTextInput = customSearchInput || (0, $8c9c99ffe8765a99$export$c86715117507e8e5);
    var selectOptionsStyle = theme.select.options ? $2d5956cb936b8932$var$_extends({}, theme.select.options.box, theme.select.options.container) : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $168667f04da9206c$export$16e4d70cc375e707), {
        onEnter: onSelectOption,
        onSpace: onSelectOption,
        onUp: onPreviousOption,
        onDown: onNextOption,
        onKeyDown: onKeyDownOption
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $72edb32352a5dc2f$export$1d41361302b577a1), $2d5956cb936b8932$var$_extends({
        ref: ref,
        id: id ? id + "__select-drop" : undefined,
        dropHeight: dropHeight
    }, passThemeFlag), onSearch && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        pad: !customSearchInput ? (_theme$select = theme.select) == null || (_theme$select = _theme$select.search) == null ? void 0 : _theme$select.pad : undefined,
        flex: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(SelectTextInput, {
        "aria-label": format({
            id: 'select.searchA11y',
            messages: messages
        }),
        focusIndicator: !customSearchInput,
        size: "small",
        ref: searchRef,
        type: "search",
        value: search || '',
        placeholder: searchPlaceholder,
        onChange: function onChange(event) {
            var nextSearch = event.target.value;
            setSearch(nextSearch);
            setActiveIndex(-1);
            onSearch(nextSearch);
        },
        onFocus: function onFocus() {
            return setActiveIndex(-1);
        },
        icon: searchIcon
    })), shouldShowClearButton('top') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($2d5956cb936b8932$var$ClearButton, {
        ref: clearRef,
        clear: clear,
        name: name,
        onClear: onClear,
        onFocus: function onFocus() {
            return setActiveIndex(-1);
        },
        onMouseOver: function onMouseOver() {
            return setActiveIndex(-1);
        },
        theme: theme
    }), options.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $72edb32352a5dc2f$export$1a780bb4ae54ddec), {
        "aria-label": format({
            id: 'select.optionsA11y',
            messages: messages
        }),
        role: "listbox",
        tabIndex: "-1",
        ref: optionsRef,
        "aria-multiselectable": multiple,
        onMouseMove: function onMouseMove() {
            return setKeyboardNavigation(false);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $26613b622f673475$export$c5295390d6167a3e), {
        items: options,
        step: theme.select.step,
        onMore: onMore,
        replace: replace,
        show: activeIndex !== -1 ? activeIndex : undefined
    }, function(option, index, optionRef) {
        var optionDisabled = isDisabled(index);
        var optionSelected = isSelected(index);
        var optionActive = activeIndex === index;
        // Determine whether the label is done as a child or
        // as an option Button kind property.
        var child;
        var textComponent = false;
        if (children) {
            child = children(option, index, options, {
                active: optionActive,
                disabled: optionDisabled,
                selected: optionSelected
            });
            if (typeof child === 'string' || child.props && child.props.children && typeof child.props.children === 'string') textComponent = true;
        } else if (theme.select.options) {
            child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), selectOptionsStyle, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), theme.select.options.text, (0, $f3173fa86fa0c94f$export$dac6ace3020563ca)(index, options, labelKey)));
            textComponent = true;
        }
        // if we have a child, turn on plain, and hoverIndicator
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $72edb32352a5dc2f$export$11a8a1ea41bf55d8), $2d5956cb936b8932$var$_extends({
            key: index,
            ref: function ref(node) {
                // eslint-disable-next-line no-param-reassign
                if (optionRef) optionRef.current = node;
                if (optionActive) activeRef.current = node;
            },
            tabIndex: optionSelected || activeIndex === index || // when nothing is selected and entering listbox
            // first option should be focused
            (!value || Array.isArray(value) && value.length === 0) && activeIndex === -1 && index === 0 ? '0' : '-1',
            role: "option",
            "aria-setsize": options.length,
            "aria-posinset": index + 1,
            "aria-selected": optionSelected,
            "aria-disabled": optionDisabled || undefined,
            plain: !child ? undefined : true,
            align: "start",
            kind: !child ? 'option' : undefined,
            label: !child ? (0, $f3173fa86fa0c94f$export$dac6ace3020563ca)(index, options, labelKey || valueKey) : undefined,
            disabled: optionDisabled || undefined,
            active: optionActive,
            selected: optionSelected,
            onFocus: function onFocus() {
                return setActiveIndex(index);
            },
            onMouseOver: !optionDisabled ? onActiveOption(index) : undefined,
            onMouseOut: !optionDisabled ? onActiveOption(-1) : undefined,
            onClick: !optionDisabled ? selectOption(index) : undefined,
            textComponent: textComponent
        }, passThemeFlag), child);
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $8c72eb2f36aa176e$export$e87a5b03dc8a6193), {
        emptySearchMessage: emptySearchMessage,
        selectOptionsStyle: selectOptionsStyle,
        theme: theme
    }), shouldShowClearButton('bottom') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($2d5956cb936b8932$var$ClearButton, {
        ref: clearRef,
        clear: clear,
        name: name,
        onClear: onClear,
        onFocus: function onFocus() {
            return setActiveIndex(-1);
        },
        onMouseOver: function onMouseOver() {
            return setActiveIndex(-1);
        },
        theme: theme
    })));
});





var $2xPiy = parcelRequire("2xPiy");

var $7b0983d1c6b6547c$var$_excluded = [
    "disabled",
    "id"
];
function $7b0983d1c6b6547c$var$_extends() {
    return $7b0983d1c6b6547c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7b0983d1c6b6547c$var$_extends.apply(null, arguments);
}
function $7b0983d1c6b6547c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $7b0983d1c6b6547c$export$2307ecc6c2fea308 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var disabled = _ref.disabled, id = _ref.id, rest = $7b0983d1c6b6547c$var$_objectWithoutPropertiesLoose(_ref, $7b0983d1c6b6547c$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $72edb32352a5dc2f$export$b34b5c37a9633c78), $7b0983d1c6b6547c$var$_extends({
        defaultCursor: disabled === true || undefined,
        focusIndicator: false,
        id: id ? id + "__input" : undefined,
        ref: ref
    }, rest, {
        tabIndex: "-1",
        type: "text",
        plain: true,
        readOnly: true
    }));
});




var $dyr1f = parcelRequire("dyr1f");

function $5f8300a4b3c3eeae$var$_extends() {
    return $5f8300a4b3c3eeae$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5f8300a4b3c3eeae$var$_extends.apply(null, arguments);
}
var $5f8300a4b3c3eeae$export$257cf46788f4f52b = $5f8300a4b3c3eeae$var$_extends({}, (0, $ab32ce3df36aa105$export$ffe37ff34eeb9e21), {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object
        ]))
    ]),
    disabledKey: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func
    ]),
    dropAlign: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        top: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'top',
            'bottom'
        ]),
        bottom: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'top',
            'bottom'
        ]),
        right: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'left',
            'right'
        ]),
        left: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'left',
            'right'
        ])
    }),
    dropHeight: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    dropTarget: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object,
    dropProps: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object,
    emptySearchMessage: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node
    ]),
    focusIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).elementType
    ]),
    labelKey: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func
    ]),
    messages: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        optionsA11y: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        multiple: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        searchA11y: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        selected: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    }),
    name: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onSearch: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onMore: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object
    ])).isRequired,
    open: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node
    ]),
    plain: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    searchPlaceholder: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node
    ]),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    valueLabel: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func
    ]),
    valueKey: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            key: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            reduce: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
        })
    ])
});
var $5f8300a4b3c3eeae$var$PropType = {};
$5f8300a4b3c3eeae$var$PropType = $5f8300a4b3c3eeae$var$_extends({}, $5f8300a4b3c3eeae$export$257cf46788f4f52b, {
    clear: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            position: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
                'top',
                'bottom'
            ]),
            label: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        })
    ]),
    closeOnChange: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number
        ]))
    ]),
    multiple: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number)
    ]),
    value: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).element,
        // deprecated, use valueLabel
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number
        ]))
    ])
});
var $5f8300a4b3c3eeae$export$e340aafd6bd05c16 = $5f8300a4b3c3eeae$var$PropType;



var $b3fb5add06fccd6e$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "aria-labelledby",
    "alignSelf",
    "children",
    "clear",
    "closeOnChange",
    "defaultValue",
    "disabled",
    "disabledKey",
    "dropAlign",
    "dropHeight",
    "dropProps",
    "dropTarget",
    "emptySearchMessage",
    "focusIndicator",
    "gridArea",
    "id",
    "icon",
    "labelKey",
    "margin",
    "messages",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onClose",
    "onFocus",
    "onKeyDown",
    "onMore",
    "onOpen",
    "onSearch",
    "open",
    "options",
    "placeholder",
    "plain",
    "replace",
    "searchPlaceholder",
    "selected",
    "size",
    "value",
    "valueKey",
    "valueLabel"
];
function $b3fb5add06fccd6e$var$_extends() {
    return $b3fb5add06fccd6e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b3fb5add06fccd6e$var$_extends.apply(null, arguments);
}
function $b3fb5add06fccd6e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $b3fb5add06fccd6e$var$defaultDropAlign = {
    top: 'bottom',
    left: 'left'
};
var $b3fb5add06fccd6e$export$ef9b1a59e592288f = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], ariaLabelledByProp = _ref['aria-labelledby'], alignSelf = _ref.alignSelf, children = _ref.children, _ref$clear = _ref.clear, clear = _ref$clear === void 0 ? false : _ref$clear, _ref$closeOnChange = _ref.closeOnChange, closeOnChange = _ref$closeOnChange === void 0 ? true : _ref$closeOnChange, defaultValue = _ref.defaultValue, disabled = _ref.disabled, disabledKey = _ref.disabledKey, _ref$dropAlign = _ref.dropAlign, dropAlign = _ref$dropAlign === void 0 ? $b3fb5add06fccd6e$var$defaultDropAlign : _ref$dropAlign, dropHeight = _ref.dropHeight, dropProps = _ref.dropProps, dropTarget = _ref.dropTarget, emptySearchMessage = _ref.emptySearchMessage, focusIndicator = _ref.focusIndicator, gridArea = _ref.gridArea, id = _ref.id, icon = _ref.icon, labelKeyProp = _ref.labelKey, margin = _ref.margin, messages = _ref.messages, multiple = _ref.multiple, name = _ref.name, onBlur = _ref.onBlur, onChange = _ref.onChange, onClick = _ref.onClick, onClose = _ref.onClose, onFocus = _ref.onFocus, onKeyDown = _ref.onKeyDown, onMore = _ref.onMore, onOpen = _ref.onOpen, onSearch = _ref.onSearch, propOpen = _ref.open, optionsProp = _ref.options, placeholder = _ref.placeholder, plain = _ref.plain, replace = _ref.replace, searchPlaceholder = _ref.searchPlaceholder, selected = _ref.selected, size = _ref.size, valueProp = _ref.value, valueKeyProp = _ref.valueKey, valueLabel = _ref.valueLabel, rest = $b3fb5add06fccd6e$var$_objectWithoutPropertiesLoose(_ref, $b3fb5add06fccd6e$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var inputRef = (0, $2xPiy.useRef)();
    var formContext = (0, $2xPiy.useContext)((0, $55ac84ad3d20c8d4$export$c24727297075ec6a));
    var _useContext = (0, $2xPiy.useContext)((0, $f1ad7bf122eed3b0$export$b060d577040138d8)), format = _useContext.format;
    // For greater resilience, use labelKey if valueKey isn't provided and
    // vice versa. https://github.com/grommet/grommet/pull/6299
    var valueKey = valueKeyProp || labelKeyProp;
    var labelKey = labelKeyProp || valueKeyProp;
    var formFieldData = formContext == null ? void 0 : formContext.useFormField({});
    // Determine if the Select is opened with the keyboard. If so,
    // focus should be set on the first option when the drop opens
    // see set initial focus code in SelectContainer.js
    var usingKeyboard = (0, $fc2b59dcdb1fd3de$export$8f71654801c2f7cd)();
    // value is used for what we receive in valueProp and the basis for
    // what we send with onChange
    // When 'valueKey' sets 'reduce', the value(s) here should match
    // what the 'valueKey' would return for the corresponding
    // selected option object.
    // Otherwise, the value(s) should match the selected options.
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp,
        initialValue: defaultValue || ''
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    // normalizedValue is the value mapped with any valueKey applied
    // When the options array contains objects, this property indicates how
    // to retrieve the value of each option.
    // If a string is provided, it is used as the key to retrieve a
    // property of an option object.
    // If a function is provided, it is called with the option and should
    // return the value.
    // If reduce is true, this value will be used for the 'value'
    // delivered via 'onChange'.
    var normalizedValue = (0, $2xPiy.useMemo)(function() {
        return (0, $f3173fa86fa0c94f$export$49df40d5c24cf7e3)(value, valueKey);
    }, [
        value,
        valueKey
    ]);
    // search input value
    var _useState = (0, $2xPiy.useState)(), search = _useState[0], setSearch = _useState[1];
    // All select option indices and values
    var _useState2 = (0, $2xPiy.useState)(optionsProp), allOptions = _useState2[0], setAllOptions = _useState2[1];
    // Track changes to options property, except when options are being
    // updated due to search activity. Allows option's initial index value
    // to be referenced when filtered by search.
    (0, $2xPiy.useEffect)(function() {
        if (!search) setAllOptions(optionsProp);
    }, [
        optionsProp,
        search
    ]);
    // the option indexes present in the value
    var optionIndexesInValue = (0, $2xPiy.useMemo)(function() {
        var result = [];
        if (selected !== undefined) {
            if (Array.isArray(selected)) {
                var validSelections = selected.filter(function(i) {
                    return i in allOptions;
                });
                result.push.apply(result, validSelections);
            } else if (selected in allOptions) result.push(selected);
        } else if (Array.isArray(normalizedValue)) normalizedValue.forEach(function(v) {
            var index = allOptions.map(function(option) {
                return (0, $f3173fa86fa0c94f$export$f9e47df77939ed56)(option, valueKey);
            }).indexOf(v);
            if (index !== -1) result.push(index);
        });
        else {
            var index = allOptions.map(function(option) {
                return (0, $f3173fa86fa0c94f$export$f9e47df77939ed56)(option, valueKey);
            }).indexOf(normalizedValue);
            if (index !== -1) result.push(index);
        }
        return result;
    }, [
        allOptions,
        selected,
        valueKey,
        normalizedValue
    ]);
    var _useState3 = (0, $2xPiy.useState)(propOpen), open = _useState3[0], setOpen = _useState3[1];
    (0, $2xPiy.useEffect)(function() {
        return setOpen(propOpen);
    }, [
        propOpen
    ]);
    var onRequestOpen = (0, $2xPiy.useCallback)(function() {
        if (open) return;
        setOpen(true);
        if (onOpen) onOpen();
    }, [
        onOpen,
        open
    ]);
    var onRequestClose = (0, $2xPiy.useCallback)(function() {
        setOpen(false);
        if (onClose) onClose();
        setSearch();
    }, [
        onClose
    ]);
    var triggerChangeEvent = (0, $2xPiy.useCallback)(function(nextValue) {
        return (0, $f3173fa86fa0c94f$export$922aead9cd650d86)(inputRef, nextValue);
    }, []);
    var onSelectChange = (0, $2xPiy.useCallback)(function(event, _ref2) {
        var option = _ref2.option, nextValue = _ref2.value, nextSelected = _ref2.selected;
        if (closeOnChange) onRequestClose();
        // nextValue must not be of type object to set value directly on the
        // input. if it is an object, then the user has not provided necessary
        // props to reduce object option
        if ((typeof nextValue !== 'object' || multiple) && nextValue !== event.target.value && inputRef.current) // select registers changing option as a click event or keydown.
        // when in a form, we need to programatically trigger a change
        // event in order for the change event to be registered upstream
        // necessary for change validation in form
        triggerChangeEvent(nextValue);
        setValue(nextValue);
        if (onChange) {
            event.persist();
            var adjustedEvent;
            // support for native event used by Preact
            if (event instanceof Event) {
                adjustedEvent = new event.constructor(event.type, event);
                Object.defineProperties(adjustedEvent, {
                    target: {
                        value: inputRef.current
                    },
                    value: {
                        value: nextValue
                    },
                    option: {
                        value: option
                    },
                    selected: {
                        value: nextSelected
                    }
                });
            } else {
                adjustedEvent = event;
                adjustedEvent.target = inputRef.current;
                adjustedEvent.value = nextValue;
                adjustedEvent.option = option;
                adjustedEvent.selected = nextSelected;
            }
            onChange(adjustedEvent);
        }
    }, [
        closeOnChange,
        multiple,
        onChange,
        onRequestClose,
        setValue,
        triggerChangeEvent
    ]);
    var SelectIcon = (0, $f3173fa86fa0c94f$export$ea6782b1ec892245)(icon, theme, open);
    // element to show, trumps inputValue
    var selectValue = (0, $2xPiy.useMemo)(function() {
        if (valueLabel instanceof Function) {
            if (value || value === 0 || value === false) return valueLabel(value);
        } else if (valueLabel) return valueLabel;
        else if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).isValidElement(value)) return value; // deprecated
        return undefined;
    }, [
        value,
        valueLabel
    ]);
    var displayLabelKey = (0, $2xPiy.useMemo)(function() {
        return (0, $f3173fa86fa0c94f$export$7e4915d842d2c2e)(labelKey, allOptions, optionIndexesInValue, selectValue);
    }, [
        labelKey,
        allOptions,
        optionIndexesInValue,
        selectValue
    ]);
    // text to show
    // When the options array contains objects, this property indicates how
    // to retrieve the value of each option.
    // If a string is provided, it is used as the key to retrieve a
    // property of an option object.
    // If a function is provided, it is called with the option and should
    // return the value.
    // If reduce is true, this value will be used for the 'value'
    // delivered via 'onChange'.
    var inputValue = (0, $2xPiy.useMemo)(function() {
        if (!selectValue) {
            if (optionIndexesInValue.length === 0) return '';
            if (optionIndexesInValue.length === 1) return (0, $f3173fa86fa0c94f$export$f9e47df77939ed56)(allOptions[optionIndexesInValue[0]], labelKey);
            return format({
                id: 'select.multiple',
                messages: messages
            });
        }
        return undefined;
    }, [
        labelKey,
        messages,
        format,
        optionIndexesInValue,
        allOptions,
        selectValue
    ]);
    var iconColor = (0, $f3173fa86fa0c94f$export$bb417e0702eb86b5)(theme);
    var _useState4 = (0, $2xPiy.useState)(), ariaLabelledBy = _useState4[0], setAriaLabelledBy = _useState4[1];
    (0, $2xPiy.useEffect)(function() {
        if (formFieldData != null && formFieldData.inForm && id && !ariaLabel && !placeholder && typeof document !== 'undefined') {
            var labelElement = document.getElementById("grommet-" + id + "__input__label");
            if (labelElement) setAriaLabelledBy("grommet-" + id + "__input__label " + id);
        }
    }, [
        formFieldData == null ? void 0 : formFieldData.inForm,
        id,
        ariaLabel,
        placeholder
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $168667f04da9206c$export$16e4d70cc375e707), {
        onDown: onRequestOpen,
        onUp: onRequestOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $72edb32352a5dc2f$export$923536af422910c8), {
        ref: ref,
        a11yTitle: "" + (ariaLabel || a11yTitle || placeholder || 'Open Drop') + (value ? format({
            id: 'select.selected',
            messages: messages,
            values: {
                currentSelectedValue: (0, $f3173fa86fa0c94f$export$fe7dc70cd4404dea)(value, labelKey)
            }
        }) : ''),
        "aria-expanded": Boolean(open),
        "aria-labelledby": ariaLabelledByProp || ariaLabelledBy,
        "aria-haspopup": "listbox",
        id: id,
        disabled: disabled === true || undefined,
        dropAlign: dropAlign,
        dropTarget: dropTarget,
        open: open,
        alignSelf: alignSelf,
        focusIndicator: plain ? focusIndicator : true,
        onFocus: onFocus,
        onBlur: onBlur,
        gridArea: gridArea,
        margin: margin,
        onOpen: onRequestOpen,
        onClose: onRequestClose,
        onClick: onClick,
        dropContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $2d5956cb936b8932$export$446eebadefe1123b), {
            clear: clear,
            disabled: disabled,
            disabledKey: disabledKey,
            dropHeight: dropHeight,
            emptySearchMessage: emptySearchMessage,
            id: id,
            labelKey: labelKey,
            messages: messages,
            multiple: multiple,
            name: name,
            onChange: onSelectChange,
            onKeyDown: onKeyDown,
            onMore: onMore,
            onSearch: onSearch,
            options: optionsProp,
            allOptions: allOptions,
            optionIndexesInValue: optionIndexesInValue,
            replace: replace,
            searchPlaceholder: searchPlaceholder,
            search: search,
            setSearch: setSearch,
            selected: selected,
            usingKeyboard: usingKeyboard,
            value: value,
            valueKey: valueKey
        }, children),
        plainSelect: plain,
        plain: true // Button should be plain
        ,
        dropProps: dropProps,
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        align: "center",
        direction: "row",
        justify: "between",
        background: theme.select.background
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        direction: "row",
        flex: true,
        basis: "auto"
    }, selectValue || displayLabelKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).Fragment, null, selectValue || displayLabelKey, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $72edb32352a5dc2f$export$7196851310a3d0bf), {
        type: "text",
        name: name,
        id: id ? (0, $f3173fa86fa0c94f$export$abfa4f6a3fb2b741)(id) : undefined,
        inert: (0, $f3173fa86fa0c94f$export$6f8d7bb3dad10aa1),
        value: inputValue,
        ref: inputRef,
        readOnly: true
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $7b0983d1c6b6547c$export$2307ecc6c2fea308), $b3fb5add06fccd6e$var$_extends({
        a11yTitle: (ariaLabel || a11yTitle) && "" + (ariaLabel || a11yTitle) + (value && typeof value === 'string' ? ", " + value : ''),
        disabled: disabled,
        id: id,
        inert: (0, $f3173fa86fa0c94f$export$6f8d7bb3dad10aa1),
        name: name,
        ref: inputRef,
        placeholder: placeholder,
        value: inputValue,
        size: size,
        theme: theme
    }, rest))), SelectIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        margin: theme.select.icons.margin,
        flex: false,
        style: {
            minWidth: 'auto'
        }
    }, /*#__PURE__*/ (0, $2xPiy.isValidElement)(SelectIcon) ? SelectIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(SelectIcon, {
        color: iconColor,
        size: size
    })))));
});
$b3fb5add06fccd6e$export$ef9b1a59e592288f.displayName = 'Select';
$b3fb5add06fccd6e$export$ef9b1a59e592288f.propTypes = (0, $5f8300a4b3c3eeae$export$e340aafd6bd05c16);





var $ad0defc16752e294$var$_excluded = [
    "messages",
    "onChange",
    "options",
    "step"
];
function $ad0defc16752e294$var$_extends() {
    return $ad0defc16752e294$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ad0defc16752e294$var$_extends.apply(null, arguments);
}
function $ad0defc16752e294$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $ad0defc16752e294$export$5035dc52aa18dae0 = function PaginationStep(_ref) {
    var _theme$pagination;
    var messages = _ref.messages, onChange = _ref.onChange, _ref$options = _ref.options, options = _ref$options === void 0 ? [
        10,
        25,
        50,
        100
    ] : _ref$options, step = _ref.step, rest = $ad0defc16752e294$var$_objectWithoutPropertiesLoose(_ref, $ad0defc16752e294$var$_excluded);
    var _useContext = (0, $2xPiy.useContext)((0, $f1ad7bf122eed3b0$export$b060d577040138d8)), formatMessage = _useContext.format;
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), $ad0defc16752e294$var$_extends({
        direction: "row",
        align: "center",
        gap: (_theme$pagination = theme.pagination) == null || (_theme$pagination = _theme$pagination.step) == null || (_theme$pagination = _theme$pagination.container) == null ? void 0 : _theme$pagination.gap
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), null, formatMessage({
        id: 'pagination.stepLabel',
        messages: messages
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $b3fb5add06fccd6e$export$ef9b1a59e592288f), {
        options: options,
        value: step,
        "aria-label": formatMessage({
            id: 'pagination.stepLabel',
            messages: messages
        }),
        valueLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), $ad0defc16752e294$var$_extends({}, theme.global.input, {
            pad: theme.global.input.padding
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), theme.global.input.font, step)),
        onChange: onChange
    }));
};



var $2xPiy = parcelRequire("2xPiy");



var $2b7e1db93d235888$var$_excluded = [
    "messages",
    "numberItems",
    "page",
    "step"
];
function $2b7e1db93d235888$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $2b7e1db93d235888$export$94528e113b92ad1e = function PaginationSummary(_ref) {
    var messages = _ref.messages, numberItems = _ref.numberItems, page = _ref.page, step = _ref.step, rest = $2b7e1db93d235888$var$_objectWithoutPropertiesLoose(_ref, $2b7e1db93d235888$var$_excluded);
    var _useContext = (0, $2xPiy.useContext)((0, $f1ad7bf122eed3b0$export$b060d577040138d8)), formatMessage = _useContext.format;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), rest, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), null, numberItems > 0 ? formatMessage({
        id: 'pagination.summary',
        messages: messages,
        values: {
            start: "" + ((page - 1) * step + 1),
            end: "" + Math.min(page * step, numberItems),
            total: numberItems
        }
    }) : formatMessage({
        id: 'pagination.summaryNoItems',
        messages: messages
    })));
};



var $dyr1f = parcelRequire("dyr1f");

function $5b7fa6d527717ca8$var$_extends() {
    return $5b7fa6d527717ca8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5b7fa6d527717ca8$var$_extends.apply(null, arguments);
}
var $5b7fa6d527717ca8$var$PropType = {};
$5b7fa6d527717ca8$var$PropType = $5b7fa6d527717ca8$var$_extends({}, (0, $ab32ce3df36aa105$export$ffe37ff34eeb9e21), {
    numberEdgePages: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
    numberItems: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
    numberMiddlePages: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    page: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'small',
        'medium',
        'large'
    ]),
    step: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
    stepOptions: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).element,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object
        ]))
    ]),
    summary: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    messages: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        stepLabel: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        summary: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        summaryNoItems: $5b7fa6d527717ca8$var$PropType.string
    })
});
var $5b7fa6d527717ca8$export$c8661a4aa71cec2a = $5b7fa6d527717ca8$var$PropType;



var $ffccbada2139938a$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "numberItems",
    "numberEdgePages",
    "numberMiddlePages",
    "onChange",
    "messages",
    "page",
    "size",
    "step",
    "stepOptions",
    "summary"
];
function $ffccbada2139938a$var$_extends() {
    return $ffccbada2139938a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ffccbada2139938a$var$_extends.apply(null, arguments);
}
function $ffccbada2139938a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $ffccbada2139938a$var$StyledPaginationContainer = (0, $iA1nz.default)((0, $18c0523379e5dd9d$export$e71c4d32a2263218)).withConfig({
    displayName: "Pagination__StyledPaginationContainer",
    componentId: "sc-rnlw6m-0"
})([
    "",
    ""
], function(props) {
    return props.theme.pagination.container && props.theme.pagination.container.extend;
});
var $ffccbada2139938a$var$getPageIndices = function getPageIndices(begin, end) {
    var indices = [];
    for(var i = begin; i <= end; i += 1)indices.push(i);
    return indices;
};
var $ffccbada2139938a$export$68f5e1453c188a82 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var _ref2, _theme$pagination$con;
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], numberItems = _ref.numberItems, _ref$numberEdgePages = _ref.numberEdgePages, numberEdgePages = _ref$numberEdgePages === void 0 ? 1 : _ref$numberEdgePages, _ref$numberMiddlePage = _ref.numberMiddlePages, numberMiddlePagesProp = _ref$numberMiddlePage === void 0 ? 3 : _ref$numberMiddlePage, onChange = _ref.onChange, messages = _ref.messages, pageProp = _ref.page, size = _ref.size, stepProp = _ref.step, stepOptions = _ref.stepOptions, summary = _ref.summary, rest = $ffccbada2139938a$var$_objectWithoutPropertiesLoose(_ref, $ffccbada2139938a$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useContext = (0, $2xPiy.useContext)((0, $c66bbd4f602cf841$export$58d75f9829cbe158)), onView = _useContext.onView, filteredTotal = _useContext.filteredTotal, view = _useContext.view;
    var _useState = (0, $2xPiy.useState)(stepProp || (view == null ? void 0 : view.step) || 10), step = _useState[0], setStep = _useState[1];
    var total = (_ref2 = numberItems != null ? numberItems : filteredTotal) != null ? _ref2 : 0;
    var page = pageProp || (view == null ? void 0 : view.page) || 1;
    /* Calculate total number pages */ var totalPages = Math.ceil(total / step);
    var _useState2 = (0, $2xPiy.useState)(Math.min(page, totalPages) || 1), activePage = _useState2[0], setActivePage = _useState2[1];
    (0, $2xPiy.useEffect)(function() {
        if (stepProp) setStep(stepProp);
    }, [
        stepProp
    ]);
    (0, $2xPiy.useEffect)(function() {
        setActivePage(page);
        var pageEvent = new Event('pagechange');
        window.dispatchEvent(pageEvent);
    }, [
        page
    ]);
    (0, $2xPiy.useEffect)(function() {
        // if we are getting the step or page from outside the view,
        // update the Data's view in case it needs to filter.
        if (onView && ((view == null ? void 0 : view.step) !== step || (view == null ? void 0 : view.page) !== page)) onView($ffccbada2139938a$var$_extends({}, view, {
            page: page,
            step: step
        }));
    }, [
        onView,
        page,
        step,
        view
    ]);
    /* Define page indices to display */ var beginPages = $ffccbada2139938a$var$getPageIndices(1, Math.min(numberEdgePages, totalPages));
    var endPages = $ffccbada2139938a$var$getPageIndices(Math.max(totalPages - numberEdgePages + 1, numberEdgePages + 1), totalPages);
    var numberMiddlePages;
    if (numberMiddlePagesProp < 1) {
        numberMiddlePages = 1;
        console.warn("Property \"numberMiddlePages\" should not be < 1. One middle page button will be shown. Set \"numberMiddlePages\" >= 1 to remove this warning.");
    } else numberMiddlePages = numberMiddlePagesProp;
    var startingMiddlePages;
    // odd
    if (numberMiddlePages % 2) startingMiddlePages = Math.min(activePage - Math.floor(numberMiddlePages / 2), totalPages - numberEdgePages - numberMiddlePages);
    else startingMiddlePages = Math.min(activePage - Math.floor(numberMiddlePages / 2) + 1, totalPages - numberEdgePages - numberMiddlePages);
    var middlePagesBegin = Math.max(startingMiddlePages, numberEdgePages + 2);
    var middlePagesEnd = Math.min(Math.max(activePage + Math.floor(numberMiddlePages / 2), numberEdgePages + numberMiddlePages + 1), endPages.length > 0 ? endPages[0] - 2 : totalPages - 1);
    var middlePages = $ffccbada2139938a$var$getPageIndices(middlePagesBegin, middlePagesEnd);
    var beginFlex = [];
    if (middlePagesBegin > numberEdgePages + 2) beginFlex = [
        'more-prev'
    ];
    else if (numberEdgePages + 1 < totalPages - numberEdgePages) beginFlex = [
        numberEdgePages + 1
    ];
    var endFlex = [];
    if (middlePagesEnd < totalPages - numberEdgePages - 1) endFlex = [
        'more-next'
    ];
    else if (totalPages - numberEdgePages > numberEdgePages) endFlex = [
        totalPages - numberEdgePages
    ];
    var getItemIndices = function getItemIndices(nextPage) {
        var startIndex = step * (nextPage - 1);
        var endIndex = startIndex + step;
        return {
            startIndex: startIndex,
            endIndex: endIndex
        };
    };
    var handleClick = function handleClick(event, nextPage) {
        setActivePage(nextPage);
        if (onView) onView($ffccbada2139938a$var$_extends({}, view, {
            page: nextPage
        }));
        if (onChange) {
            event.persist();
            var adjustedEvent = event;
            adjustedEvent.page = nextPage;
            // for controlled use cases, provide user with info on
            // what range of indices should be displayed given the active page
            var _getItemIndices = getItemIndices(nextPage), startIndex = _getItemIndices.startIndex, endIndex = _getItemIndices.endIndex;
            adjustedEvent.startIndex = startIndex;
            adjustedEvent.endIndex = endIndex;
            onChange(adjustedEvent);
        }
    };
    var NextIcon = theme.pagination.icons.next;
    var PreviousIcon = theme.pagination.icons.previous;
    var iconColor = theme.pagination.icons.color;
    var navProps = {
        next: {
            // https://a11y-style-guide.com/style-guide/section-navigation.html#kssref-navigation-pagination
            'aria-disabled': activePage === totalPages ? 'true' : undefined,
            disabled: activePage === totalPages || !total,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(NextIcon, {
                color: iconColor
            }),
            onClick: function onClick(event) {
                var nextPage = activePage + 1;
                handleClick(event, nextPage);
            },
            label: undefined
        },
        previous: {
            'aria-disabled': activePage === 1 ? 'true' : undefined,
            disabled: activePage === 1 || !total,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(PreviousIcon, {
                color: iconColor
            }),
            onClick: function onClick(event) {
                var previousPage = activePage - 1;
                handleClick(event, previousPage);
            },
            label: undefined
        }
    };
    var controls = [
        'previous'
    ].concat(beginPages, beginFlex, middlePages, endFlex, endPages, [
        'next'
    ]);
    /* Set props for each page index. Each page index should display a
   * clickable index, control, or placeholder (e.g. ellipsis) indicating
   * more pages are available.
   */ controls = controls.map(function(control) {
        return $ffccbada2139938a$var$_extends({
            active: control === activePage,
            a11yTitle: typeof control === 'number' ? "Go to page " + control : "Go to " + control + " page",
            // https://a11y-style-guide.com/style-guide/section-navigation.html#kssref-navigation-pagination
            // https://www.w3.org/TR/wai-aria-1.1/#aria-current
            'aria-current': control === activePage ? 'page' : undefined,
            control: control,
            onClick: function onClick(event) {
                handleClick(event, control);
            },
            separator: control === 'more-prev' || control === 'more-next'
        }, navProps[control]);
    });
    var paginationControls = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $2f0cb182ea7bd57a$export$39140c7d8b0ba7b3), {
        a11yTitle: ariaLabel || a11yTitle || 'Pagination Navigation',
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), $ffccbada2139938a$var$_extends({
        as: "ul"
    }, theme.pagination.controls, {
        cssGap: true
    }), controls.map(function(control, index) {
        return(/*#__PURE__*/ /* Using index as key (as opposed to a unique id) seems to
       * help React prioritize rendering the updated controls as
       * desired. Whereas, using a unique id resulted in rendering
       * the active control with an undesired lag. */ // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $4ff9a69e05662c2e$export$4109320283c508e), $ffccbada2139938a$var$_extends({
            key: index,
            size: size
        }, control)));
    })));
    // for backwards compatibility
    if (!summary && !stepOptions) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($ffccbada2139938a$var$StyledPaginationContainer, $ffccbada2139938a$var$_extends({
        flex: false
    }, $ffccbada2139938a$var$_extends({}, theme.pagination.container, {
        gap: undefined
    }), passThemeFlag, rest), paginationControls);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($ffccbada2139938a$var$StyledPaginationContainer, $ffccbada2139938a$var$_extends({
        direction: "row",
        align: "center",
        wrap: true,
        flex: false
    }, theme.pagination.container, passThemeFlag, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        flex: "grow"
    }, summary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $2b7e1db93d235888$export$94528e113b92ad1e), {
        messages: messages,
        page: activePage,
        step: step,
        numberItems: total
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        align: "center",
        direction: "row",
        gap: (_theme$pagination$con = theme.pagination.container) == null ? void 0 : _theme$pagination$con.gap,
        wrap: true
    }, stepOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $ad0defc16752e294$export$5035dc52aa18dae0), {
        messages: messages,
        options: Array.isArray(stepOptions) ? stepOptions : undefined,
        step: step,
        onChange: function onChange(_ref3) {
            var value = _ref3.value;
            return setStep(value);
        }
    }), paginationControls));
});
$ffccbada2139938a$export$68f5e1453c188a82.displayName = 'Pagination';
$ffccbada2139938a$export$68f5e1453c188a82.propTypes = (0, $5b7fa6d527717ca8$export$c8661a4aa71cec2a);




var $2xPiy = parcelRequire("2xPiy");
var $cb695b171fe4ef95$var$_excluded = [
    "data",
    "page",
    "step"
];
function $cb695b171fe4ef95$var$_extends() {
    return $cb695b171fe4ef95$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cb695b171fe4ef95$var$_extends.apply(null, arguments);
}
function $cb695b171fe4ef95$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $cb695b171fe4ef95$export$4bb2737d7e3380a3 = function normalizeShow(showProp, step) {
    var page;
    // by default, show refers to the index of an item,
    // but if using pagination, show can take the form of { page: # },
    // where page refers to the page # to show
    if (typeof showProp === 'number') page = Math.ceil((showProp + 1) / step);
    else if (typeof showProp === 'object' && 'page' in showProp) page = showProp.page;
    return page;
};
var $cb695b171fe4ef95$export$f80c710216eae131 = function usePagination(_ref) {
    var data = _ref.data, page = _ref.page, step = _ref.step, rest = $cb695b171fe4ef95$var$_objectWithoutPropertiesLoose(_ref, $cb695b171fe4ef95$var$_excluded);
    var totalPages = data ? Math.ceil(data.length / step) : 0;
    var _useState = (0, $2xPiy.useState)(Math.min(page, totalPages) || 1), activePage = _useState[0], setActivePage = _useState[1];
    // ensure activePage is never lower than 1 to ensure that itemsBeginIndex
    // and itemsEndIndex aren't negative
    if (activePage > totalPages && (data == null ? void 0 : data.length) > 0) setActivePage(Math.max(totalPages, 1));
    var itemsBeginIndex = step * (activePage - 1);
    var itemsEndIndex = itemsBeginIndex + step;
    var currentItems = (0, $2xPiy.useMemo)(function() {
        if (Array.isArray(data)) return data.slice(itemsBeginIndex, itemsEndIndex);
        return [];
    }, [
        data,
        itemsBeginIndex,
        itemsEndIndex
    ]);
    var paginationProps = $cb695b171fe4ef95$var$_extends({
        numberItems: data && data.length,
        onChange: function onChange(event) {
            return setActivePage(event.page);
        },
        page: activePage,
        step: step
    }, rest);
    return [
        currentItems,
        paginationProps
    ];
};




var $dyr1f = parcelRequire("dyr1f");

function $8a0e4de190db403a$var$_extends() {
    return $8a0e4de190db403a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8a0e4de190db403a$var$_extends.apply(null, arguments);
}
var $8a0e4de190db403a$var$sizes = [
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge'
];
var $8a0e4de190db403a$var$sides = [
    'horizontal',
    'vertical',
    'top',
    'bottom',
    'left',
    'right'
];
var $8a0e4de190db403a$var$parts = [
    'header',
    'body',
    'footer'
];
var $8a0e4de190db403a$var$verticalAlign = [
    'bottom',
    'middle',
    'top'
];
var $8a0e4de190db403a$var$padShapeSides = {};
$8a0e4de190db403a$var$sides.forEach(function(side) {
    $8a0e4de190db403a$var$padShapeSides[side] = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($8a0e4de190db403a$var$sizes),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]);
});
var $8a0e4de190db403a$var$padShapeParts = {};
$8a0e4de190db403a$var$parts.forEach(function(part) {
    $8a0e4de190db403a$var$padShapeParts[part] = {};
    $8a0e4de190db403a$var$sides.forEach(function(side) {
        $8a0e4de190db403a$var$padShapeParts[part][side] = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($8a0e4de190db403a$var$sizes);
    });
});
var $8a0e4de190db403a$var$backgroundShape = {};
[].concat($8a0e4de190db403a$var$parts, [
    'pinned'
]).forEach(function(part) {
    $8a0e4de190db403a$var$backgroundShape[part] = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            light: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string)
    ]);
});
var $8a0e4de190db403a$var$borderTypes = [
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($8a0e4de190db403a$var$sides),
    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        color: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                light: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            })
        ]),
        side: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($8a0e4de190db403a$var$sides),
        size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($8a0e4de190db403a$var$sizes),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ])
    })
];
var $8a0e4de190db403a$var$borderShape = {};
$8a0e4de190db403a$var$parts.forEach(function(part) {
    $8a0e4de190db403a$var$borderShape[part] = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType($8a0e4de190db403a$var$borderTypes);
});
var $8a0e4de190db403a$var$PropType = {};
$8a0e4de190db403a$var$PropType = $8a0e4de190db403a$var$_extends({}, (0, $ab32ce3df36aa105$export$ffe37ff34eeb9e21), {
    allowSelectAll: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    background: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape($8a0e4de190db403a$var$backgroundShape)
    ]),
    border: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([].concat($8a0e4de190db403a$var$borderTypes, [
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape($8a0e4de190db403a$var$borderShape)
    ])),
    columns: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        align: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'center',
            'start',
            'end'
        ]),
        aggregate: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'avg',
            'max',
            'min',
            'sum'
        ]),
        footer: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                aggregate: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
            })
        ]),
        header: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
                aggregate: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
            })
        ]),
        pin: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        plain: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        primary: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        property: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string.isRequired,
        render: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        sortable: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
                'small',
                'medium',
                'large',
                'xlarge',
                '1/2',
                '1/4',
                '2/4',
                '3/4',
                '1/3',
                '2/3'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ]),
        units: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        verticalAlign: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'middle',
            'top',
            'bottom'
        ])
    })),
    data: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({})),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number
    ])),
    fill: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'horizontal',
            'vertical'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
    ]),
    groupBy: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            property: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            expand: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string),
            expandable: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string),
            expandLabel: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
            select: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
                'all',
                'some',
                'none'
            ])),
            onExpand: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
            onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func
        })
    ]),
    messages: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        ascending: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        collapse: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        collapseAll: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        decrease: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        descending: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        increase: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        expand: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        expandAll: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        resizerAria: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        rows: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        rowsChanged: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        rowsSingle: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        searchBy: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        total: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        totalSingle: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    }),
    onClickRow: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'select'
        ])
    ]),
    rowDetails: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            render: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func.isRequired,
            expand: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number
            ])),
            expandLabel: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
            onExpand: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func
        })
    ]),
    onMore: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onSearch: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onSort: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    pad: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($8a0e4de190db403a$var$sizes),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape($8a0e4de190db403a$var$padShapeSides),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape($8a0e4de190db403a$var$padShapeParts)
    ]),
    paginate: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object
    ]),
    pin: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'header',
            'footer'
        ])
    ]),
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node
    ]),
    primaryKey: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
    ]),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    resizeable: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    rowProps: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({}),
    select: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number
    ])),
    show: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            page: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number
        })
    ]),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    sort: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        direction: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'asc',
            'desc'
        ]),
        external: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        property: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string.isRequired
    }),
    sortable: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    step: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
    verticalAlign: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($8a0e4de190db403a$var$verticalAlign),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            header: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($8a0e4de190db403a$var$verticalAlign),
            body: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($8a0e4de190db403a$var$verticalAlign),
            footer: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($8a0e4de190db403a$var$verticalAlign)
        })
    ])
});
var $8a0e4de190db403a$export$c2a4947702a2f5bb = $8a0e4de190db403a$var$PropType;



var $2xPiy = parcelRequire("2xPiy");
var $6fa5ff79752924d4$export$ac217b2d9dd1ba17 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? [] : _ref$columns, onSelect = _ref.onSelect, children = _ref.children;
    var colSpan = Math.max(columns.length + (onSelect ? 1 : 0), 1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("tbody", {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("td", {
        colSpan: colSpan
    }, children)));
});



var $6312252410d7d442$var$_excluded = [
    "allowSelectAll",
    "background",
    "border",
    "columns",
    "data",
    "disabled",
    "fill",
    "groupBy",
    "messages",
    "onClickRow",
    "onMore",
    "onSearch",
    "onSelect",
    "onSort",
    "onUpdate",
    "replace",
    "pad",
    "paginate",
    "pin",
    "placeholder",
    "primaryKey",
    "resizeable",
    "rowProps",
    "select",
    "show",
    "size",
    "sort",
    "sortable",
    "rowDetails",
    "step",
    "verticalAlign"
];
function $6312252410d7d442$var$_extends() {
    return $6312252410d7d442$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6312252410d7d442$var$_extends.apply(null, arguments);
}
function $6312252410d7d442$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $6312252410d7d442$var$emptyData = [];
function $6312252410d7d442$var$useGroupState(groups, groupBy) {
    var _useState = (0, $2xPiy.useState)(function() {
        return (0, $0169a8904a4129ab$export$dd1eb10ac590717)(groups, groupBy);
    }), groupState = _useState[0], setGroupState = _useState[1];
    var _useState2 = (0, $2xPiy.useState)({
        groups: groups,
        groupBy: groupBy
    }), prevDeps = _useState2[0], setPrevDeps = _useState2[1];
    var prevGroups = prevDeps.groups, prevGroupBy = prevDeps.groupBy;
    if (groups !== prevGroups || groupBy !== prevGroupBy) {
        setPrevDeps({
            groups: groups,
            groupBy: groupBy
        });
        var nextGroupState = (0, $0169a8904a4129ab$export$dd1eb10ac590717)(groups, groupBy);
        setGroupState(nextGroupState);
        return [
            nextGroupState,
            setGroupState
        ];
    }
    return [
        groupState,
        setGroupState
    ];
}
var $6312252410d7d442$export$df30df7ec97b32b5 = function DataTable(_ref) {
    var _ref$allowSelectAll = _ref.allowSelectAll, allowSelectAll = _ref$allowSelectAll === void 0 ? true : _ref$allowSelectAll, background = _ref.background, border = _ref.border, columnsProp = _ref.columns, dataProp = _ref.data, disabled = _ref.disabled, fill = _ref.fill, groupByProp = _ref.groupBy, messages = _ref.messages, onClickRow = _ref.onClickRow, onMore = _ref.onMore, onSearch = _ref.onSearch, onSelect = _ref.onSelect, onSortProp = _ref.onSort, onUpdate = _ref.onUpdate, replace = _ref.replace, pad = _ref.pad, paginate = _ref.paginate, pin = _ref.pin, placeholder = _ref.placeholder, primaryKey = _ref.primaryKey, resizeable = _ref.resizeable, rowProps = _ref.rowProps, select = _ref.select, showProp = _ref.show, size = _ref.size, sortProp = _ref.sort, sortable = _ref.sortable, rowDetails = _ref.rowDetails, _ref$step = _ref.step, step = _ref$step === void 0 ? 50 : _ref$step, verticalAlign = _ref.verticalAlign, rest = $6312252410d7d442$var$_objectWithoutPropertiesLoose(_ref, $6312252410d7d442$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useContext = (0, $2xPiy.useContext)((0, $c66bbd4f602cf841$export$58d75f9829cbe158)), view = _useContext.view, contextData = _useContext.data, properties = _useContext.properties, onView = _useContext.onView, setSelectedDataContext = _useContext.setSelected;
    var data = dataProp || contextData || $6312252410d7d442$var$emptyData;
    var columns = (0, $2xPiy.useMemo)(function() {
        var result = [];
        if (columnsProp) result = columnsProp;
        else if (properties) result = Object.keys(properties).map(function(p) {
            return $6312252410d7d442$var$_extends({
                property: p
            }, properties[p]);
        });
        else if (data.length) result = Object.keys(data[0]).map(function(p) {
            return {
                property: p
            };
        });
        if (view != null && view.columns) result = result.filter(function(c) {
            return view.columns.includes(c.property);
        }).sort(function(c1, c2) {
            return view.columns.indexOf(c1.property) - view.columns.indexOf(c2.property);
        });
        return result;
    }, [
        columnsProp,
        data,
        properties,
        view
    ]);
    // property name of the primary property
    var primaryProperty = (0, $2xPiy.useMemo)(function() {
        return (0, $0169a8904a4129ab$export$e29cd744291e9244)(columns, primaryKey);
    }, [
        columns,
        primaryKey
    ]);
    // whether or not we should show a footer
    var showFooter = (0, $2xPiy.useMemo)(function() {
        return columns.filter(function(c) {
            return c.footer;
        }).length > 0;
    }, [
        columns
    ]);
    // what column we are actively capturing filter input on
    var _useState3 = (0, $2xPiy.useState)(), filtering = _useState3[0], setFiltering = _useState3[1];
    // the currently active filters
    var _useState4 = (0, $2xPiy.useState)((0, $0169a8904a4129ab$export$3e02c678c13755e4)(columns)), filters = _useState4[0], setFilters = _useState4[1];
    // which column we are sorting on, with direction
    var _useState5 = (0, $2xPiy.useState)(sortProp || {}), sort = _useState5[0], setSort = _useState5[1];
    (0, $2xPiy.useEffect)(function() {
        if (sortProp) setSort(sortProp);
        else if (view != null && view.sort) setSort(view.sort);
    }, [
        sortProp,
        view
    ]);
    // what we are grouping on
    var groupBy = (view == null ? void 0 : view.groupBy) || groupByProp;
    // the data filtered and sorted, if needed
    // Note: onUpdate mode expects the data to be passed
    //   in completely filtered and sorted already.
    var adjustedData = (0, $2xPiy.useMemo)(function() {
        return onUpdate ? data : (0, $0169a8904a4129ab$export$a4789ef9776cfd0d)(data, filters, onSearch, sort);
    }, [
        data,
        filters,
        onSearch,
        onUpdate,
        sort
    ]);
    // the values to put in the footer cells
    var footerValues = (0, $2xPiy.useMemo)(function() {
        return (0, $0169a8904a4129ab$export$bde56fd39aca7865)(columns, adjustedData);
    }, [
        adjustedData,
        columns
    ]);
    // cell styling properties: background, border, pad
    var cellProps = (0, $2xPiy.useMemo)(function() {
        return (0, $0169a8904a4129ab$export$4553511e3ef6f0d3)({
            background: background,
            border: border,
            pad: pad,
            pin: pin
        }, theme);
    }, [
        background,
        border,
        pad,
        pin,
        theme
    ]);
    // if groupBy, an array with one item per unique groupBy key value
    var groups = (0, $2xPiy.useMemo)(function() {
        return (0, $0169a8904a4129ab$export$680f59e10d3eb269)(columns, adjustedData, groupBy, primaryProperty);
    }, [
        adjustedData,
        columns,
        groupBy,
        primaryProperty
    ]);
    // an object indicating which group values are expanded
    var _useGroupState = $6312252410d7d442$var$useGroupState(groups, groupBy), groupState = _useGroupState[0], setGroupState = _useGroupState[1];
    var _useState6 = (0, $2xPiy.useState)(step), limit = _useState6[0], setLimit = _useState6[1];
    var announce = (0, $2xPiy.useContext)((0, $c8f61343d2547c6a$export$dcc8f4bff0d51f50));
    var _useContext2 = (0, $2xPiy.useContext)((0, $f1ad7bf122eed3b0$export$b060d577040138d8)), format = _useContext2.format;
    // only announce number of rows that are rendered
    // when outside of DataContext, otherwise
    // Data will make this announcement
    (0, $2xPiy.useEffect)(function() {
        if (dataProp) {
            var messageId;
            var rows = format({
                id: adjustedData.length === 1 ? 'dataTable.rowsSingle' : 'dataTable.rows',
                messages: messages
            });
            // when less than one page returned, use specific amount
            if (adjustedData.length < limit) {
                if (adjustedData.length === 1) messageId = 'dataTable.totalSingle';
                else messageId = 'dataTable.total';
            } else messageId = 'dataTable.rowsChanged';
            announce(format({
                id: messageId,
                messages: messages,
                values: {
                    total: adjustedData.length,
                    rows: rows
                }
            }));
        }
    }, [
        dataProp,
        adjustedData,
        announce,
        format,
        limit,
        messages,
        paginate
    ]);
    var _useState7 = (0, $2xPiy.useState)(select || onSelect && [] || undefined), selected = _useState7[0], setSelected = _useState7[1];
    (0, $2xPiy.useEffect)(function() {
        return setSelected(select || onSelect && [] || undefined);
    }, [
        onSelect,
        select
    ]);
    (0, $2xPiy.useEffect)(function() {
        if (select && setSelectedDataContext) setSelectedDataContext(select.length);
    }, [
        select,
        setSelectedDataContext
    ]);
    var _useState8 = (0, $2xPiy.useState)((rowDetails == null ? void 0 : rowDetails.expand) || []), rowExpand = _useState8[0], setRowExpand = _useState8[1];
    (0, $2xPiy.useEffect)(function() {
        if (rowDetails != null && rowDetails.expand) setRowExpand(rowDetails.expand);
    }, [
        rowDetails == null ? void 0 : rowDetails.expand
    ]);
    // any customized column widths
    var _useState9 = (0, $2xPiy.useState)({}), widths = _useState9[0], setWidths = _useState9[1];
    // placeholder placement stuff
    var headerRef = (0, $2xPiy.useRef)();
    var bodyRef = (0, $2xPiy.useRef)();
    var footerRef = (0, $2xPiy.useRef)();
    var _useState0 = (0, $2xPiy.useState)(), headerHeight = _useState0[0], setHeaderHeight = _useState0[1];
    var _useState1 = (0, $2xPiy.useState)(), footerHeight = _useState1[0], setFooterHeight = _useState1[1];
    // offset compensation when body overflows
    var _useState10 = (0, $2xPiy.useState)(0), scrollOffset = _useState10[0], setScrollOffset = _useState10[1];
    // multiple pinned columns offset
    var _useState11 = (0, $2xPiy.useState)(), pinnedOffset = _useState11[0], setPinnedOffset = _useState11[1];
    var onHeaderWidths = (0, $2xPiy.useCallback)(function(columnWidths) {
        var hasSelectColumn = Boolean(select || onSelect);
        var pinnedProperties = columns.map(function(pinnedColumn) {
            return pinnedColumn.pin && pinnedColumn.property;
        }).filter(function(n) {
            return n;
        });
        if (hasSelectColumn && pinnedProperties.length > 0) pinnedProperties = [
            '_grommetDataTableSelect'
        ].concat(pinnedProperties);
        var nextPinnedOffset = {};
        if (columnWidths.length !== 0) {
            pinnedProperties.forEach(function(property, index) {
                var columnIndex = property === '_grommetDataTableSelect' ? 0 : columns.findIndex(function(column) {
                    return column.property === property;
                }) + hasSelectColumn;
                if (columnWidths[columnIndex]) nextPinnedOffset[property] = {
                    width: columnWidths[columnIndex],
                    left: index === 0 ? 0 : nextPinnedOffset[pinnedProperties[index - 1]].left + nextPinnedOffset[pinnedProperties[index - 1]].width
                };
            });
            setPinnedOffset(nextPinnedOffset);
        }
    }, [
        columns,
        setPinnedOffset,
        select,
        onSelect
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $9462599f26e06396$export$e5c5a5f917a5871c)(function() {
        var _bodyRef$current$pare;
        var nextScrollOffset = (((_bodyRef$current$pare = bodyRef.current.parentElement) == null ? void 0 : _bodyRef$current$pare.clientWidth) || 0) - bodyRef.current.clientWidth;
        if (nextScrollOffset !== scrollOffset) setScrollOffset(nextScrollOffset);
    });
    (0, $9462599f26e06396$export$e5c5a5f917a5871c)(function() {
        if (placeholder) {
            if (headerRef.current) {
                var nextHeaderHeight = headerRef.current.getBoundingClientRect().height;
                setHeaderHeight(nextHeaderHeight);
            } else setHeaderHeight(0);
            if (footerRef.current) {
                var nextFooterHeight = footerRef.current.getBoundingClientRect().height;
                setFooterHeight(nextFooterHeight);
            } else setFooterHeight(0);
        }
    }, [
        footerRef,
        headerRef,
        placeholder
    ]);
    // remember that we are filtering on this property
    var onFiltering = function onFiltering(property) {
        return setFiltering(property);
    };
    // remember the search text we should filter this property by
    var onFilter = function onFilter(property, value) {
        var nextFilters = $6312252410d7d442$var$_extends({}, filters);
        nextFilters[property] = value;
        setFilters(nextFilters);
        // Let caller know about search, if interested
        if (onSearch) onSearch(nextFilters);
    };
    // toggle the sort direction on this property
    var onSort = function onSort(property) {
        return function() {
            var external = sort ? sort.external : false;
            var direction;
            if (!sort || property !== sort.property) direction = 'asc';
            else if (sort.direction === 'asc') direction = 'desc';
            else direction = 'asc';
            var nextSort = {
                property: property,
                direction: direction,
                external: external
            };
            setSort(nextSort);
            if (onView) onView($6312252410d7d442$var$_extends({}, view, {
                sort: {
                    property: property,
                    direction: direction
                }
            }));
            if (onUpdate) {
                var opts = {
                    count: limit,
                    sort: nextSort
                };
                if (groups) opts.expanded = Object.keys(groupState).filter(function(k) {
                    return groupState[k].expanded;
                });
                if (showProp) opts.show = showProp;
                onUpdate(opts);
            }
            if (onSortProp) onSortProp(nextSort);
        };
    };
    // toggle whether the group is expanded
    var onToggleGroup = function onToggleGroup(groupValue) {
        return function() {
            var nextGroupState = $6312252410d7d442$var$_extends({}, groupState);
            nextGroupState[groupValue] = $6312252410d7d442$var$_extends({}, nextGroupState[groupValue], {
                expanded: !nextGroupState[groupValue].expanded
            });
            setGroupState(nextGroupState);
            var expandedKeys = Object.keys(nextGroupState).filter(function(k) {
                return nextGroupState[k].expanded;
            });
            if (onUpdate) {
                var opts = {
                    expanded: expandedKeys,
                    count: limit
                };
                if (sort != null && sort.property) opts.sort = sort;
                if (showProp) opts.show = showProp;
                onUpdate(opts);
            }
            if (groupBy.onExpand) groupBy.onExpand(expandedKeys);
        };
    };
    // toggle whether all groups are expanded
    var onToggleGroups = function onToggleGroups() {
        var expanded = Object.keys(groupState).filter(function(k) {
            return !groupState[k].expanded;
        }).length === 0;
        var nextGroupState = {};
        Object.keys(groupState).forEach(function(k) {
            nextGroupState[k] = $6312252410d7d442$var$_extends({}, groupState[k], {
                expanded: !expanded
            });
        });
        setGroupState(nextGroupState);
        var expandedKeys = Object.keys(nextGroupState).filter(function(k) {
            return nextGroupState[k].expanded;
        });
        if (onUpdate) {
            var opts = {
                expanded: expandedKeys,
                count: limit
            };
            if (showProp) opts.show = showProp;
            if (sort != null && sort.property) opts.sort = sort;
            onUpdate(opts);
        }
        if (groupBy.onExpand) groupBy.onExpand(expandedKeys);
    };
    // remember the width this property's column should be
    var onResize = (0, $2xPiy.useCallback)(function(property, width) {
        if (widths[property] !== width) {
            var nextWidths = $6312252410d7d442$var$_extends({}, widths);
            nextWidths[property] = width;
            setWidths(nextWidths);
        }
    }, [
        widths
    ]);
    if (size && resizeable) console.warn('DataTable cannot combine "size" and "resizeable".');
    if (onUpdate && onMore) console.warn('DataTable cannot combine "onUpdate" and "onMore".');
    var _usePagination = (0, $cb695b171fe4ef95$export$f80c710216eae131)($6312252410d7d442$var$_extends({
        data: adjustedData,
        page: (0, $cb695b171fe4ef95$export$4bb2737d7e3380a3)(showProp, step),
        step: step
    }, paginate)), items = _usePagination[0], paginationProps = _usePagination[1];
    var paginationStep = paginationProps.step;
    var Container = paginate ? (0, $baa3c9c2b8eedc6c$export$1d41361302b577a1) : (0, $2xPiy.Fragment);
    var containterProps = paginate ? $6312252410d7d442$var$_extends({}, theme.dataTable.container, {
        fill: fill
    }, passThemeFlag) : undefined;
    // DataTable should overflow if paginating but pagination component
    // should remain in its location
    var OverflowContainer = paginate ? (0, $18c0523379e5dd9d$export$e71c4d32a2263218) : (0, $2xPiy.Fragment);
    var overflowContainerProps = paginate ? {
        overflow: {
            horizontal: 'auto'
        }
    } : undefined;
    // necessary for Firefox, otherwise paginated DataTable will
    // not fill its container like it does by default on other
    // browsers like Chrome/Safari
    var paginatedDataTableProps = paginate && (fill === true || fill === 'horizontal') ? {
        style: {
            minWidth: '100%'
        }
    } : undefined;
    var placeholderContent = placeholder;
    if (placeholder && typeof placeholder === 'string') placeholderContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        background: {
            color: 'background-front',
            opacity: 'strong'
        },
        align: "center",
        justify: "center",
        fill: "vertical"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), null, placeholder));
    var handleSelect = function handleSelect(nextSelected, row) {
        setSelected(nextSelected);
        if (setSelectedDataContext) setSelectedDataContext(nextSelected.length);
        if (row) onSelect(nextSelected, row);
        else onSelect(nextSelected);
    };
    var bodyContent = groups ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $249ab81a6ca40f54$export$298bfb09deaa1b80), {
        ref: bodyRef,
        cellProps: {
            body: cellProps.body,
            groupHeader: $6312252410d7d442$var$_extends({}, cellProps.body, cellProps.groupHeader)
        },
        columns: columns,
        disabled: disabled,
        groupBy: typeof groupBy === 'string' ? {
            property: groupBy
        } : groupBy,
        groups: groups,
        groupState: groupState,
        messages: messages,
        pinnedOffset: pinnedOffset,
        primaryProperty: primaryProperty,
        onMore: onUpdate ? function() {
            if (adjustedData.length === limit) {
                var opts = {
                    expanded: Object.keys(groupState).filter(function(k) {
                        return groupState[k].expanded;
                    }),
                    count: limit + paginationStep
                };
                if (sort != null && sort.property) opts.sort = sort;
                if (showProp) opts.show = showProp;
                onUpdate(opts);
                setLimit(function(prev) {
                    return prev + paginationStep;
                });
            }
        } : onMore,
        onSelect: onSelect ? handleSelect : undefined,
        onToggle: onToggleGroup,
        onUpdate: onUpdate,
        replace: replace,
        rowProps: rowProps,
        selected: selected,
        size: size,
        step: paginationStep,
        verticalAlign: typeof verticalAlign === 'string' ? verticalAlign : verticalAlign == null ? void 0 : verticalAlign.body
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $b4e3f955e73545f0$export$4b2c32e08f77ff18), {
        ref: bodyRef,
        cellProps: cellProps.body,
        columns: columns,
        data: !paginate ? adjustedData : items,
        disabled: disabled,
        onMore: onUpdate ? function() {
            if (adjustedData.length === limit) {
                var opts = {
                    count: limit + paginationStep
                };
                if (sort != null && sort.property) opts.sort = sort;
                if (showProp) opts.show = showProp;
                onUpdate(opts);
                setLimit(function(prev) {
                    return prev + paginationStep;
                });
            }
        } : onMore,
        replace: replace,
        onClickRow: onClickRow,
        onSelect: onSelect ? handleSelect : undefined,
        pinnedCellProps: cellProps.pinned,
        pinnedOffset: pinnedOffset,
        primaryProperty: primaryProperty,
        rowProps: rowProps,
        selected: selected,
        show: !paginate ? showProp : undefined,
        size: size,
        step: paginationStep,
        rowDetails: rowDetails,
        rowExpand: rowExpand,
        setRowExpand: setRowExpand,
        verticalAlign: typeof verticalAlign === 'string' ? verticalAlign : verticalAlign == null ? void 0 : verticalAlign.body
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(Container, containterProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(OverflowContainer, overflowContainerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $baa3c9c2b8eedc6c$export$551fccb2985765ce), $6312252410d7d442$var$_extends({
        fillProp: !paginate ? fill : undefined
    }, paginatedDataTableProps, passThemeFlag, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $c302317b33637455$export$8b251419efc915eb), {
        ref: headerRef,
        allowSelectAll: allowSelectAll,
        cellProps: cellProps.header,
        columns: columns,
        data: adjustedData,
        disabled: disabled,
        fill: fill,
        filtering: filtering,
        filters: filters,
        groupBy: groupBy,
        groups: groups,
        groupState: groupState,
        pin: pin === true || pin === 'header',
        pinnedOffset: pinnedOffset,
        selected: selected,
        size: size,
        sort: sort,
        widths: widths,
        messages: messages,
        onFiltering: onFiltering,
        onFilter: onFilter,
        onResize: resizeable ? onResize : undefined,
        onSelect: onSelect ? handleSelect : undefined,
        onSort: sortable || sortProp || onSortProp ? onSort : undefined,
        onToggle: onToggleGroups,
        onWidths: onHeaderWidths,
        primaryProperty: primaryProperty,
        scrollOffset: scrollOffset,
        rowDetails: rowDetails,
        verticalAlign: typeof verticalAlign === 'string' ? verticalAlign : verticalAlign == null ? void 0 : verticalAlign.header
    }), placeholder && (!items || items.length === 0) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $6fa5ff79752924d4$export$ac217b2d9dd1ba17), {
        ref: bodyRef,
        columns: columns,
        onSelect: onSelect
    }, placeholderContent) : bodyContent, showFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $06fe048ff15827f8$export$a06f1c675e846f6f), {
        ref: footerRef,
        cellProps: cellProps.footer,
        columns: columns,
        fill: fill,
        footerValues: footerValues,
        groups: groups,
        onSelect: onSelect,
        pin: pin === true || pin === 'footer',
        pinnedOffset: pinnedOffset,
        primaryProperty: primaryProperty,
        scrollOffset: scrollOffset,
        selected: selected,
        size: size,
        verticalAlign: typeof verticalAlign === 'string' ? verticalAlign : verticalAlign == null ? void 0 : verticalAlign.footer
    }), placeholder && items && items.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $baa3c9c2b8eedc6c$export$333ccef64da8eec4), {
        top: headerHeight,
        bottom: footerHeight
    }, placeholderContent))), paginate && adjustedData.length > paginationStep && items && items.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $ffccbada2139938a$export$68f5e1453c188a82), $6312252410d7d442$var$_extends({
        alignSelf: "end"
    }, paginationProps)) : null);
};
$6312252410d7d442$export$df30df7ec97b32b5.propTypes = (0, $8a0e4de190db403a$export$c2a4947702a2f5bb);



var $2xPiy = parcelRequire("2xPiy");

function $1aed433c8cc8fc70$var$_extends() {
    return $1aed433c8cc8fc70$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1aed433c8cc8fc70$var$_extends.apply(null, arguments);
}
var $1aed433c8cc8fc70$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $1aed433c8cc8fc70$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Link"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M16.125 2.42a2.009 2.009 0 0 1 2.84-.001l2.616 2.617a2 2 0 0 1-.001 2.839l-3.705 3.705a2.009 2.009 0 0 1-2.84.001L12.42 8.964a2 2 0 0 1 .001-2.839l3.705-3.705zm-10 10a2.009 2.009 0 0 1 2.84-.001l2.616 2.617a2 2 0 0 1-.001 2.839L7.875 21.58a2.009 2.009 0 0 1-2.84.001L2.42 18.964a2 2 0 0 1 .001-2.839l3.705-3.705zM7 17 17 7"
    }));
});
$1aed433c8cc8fc70$export$a6c7ac8248d6e38a.displayName = 'Link';



parcelRequire("2xPiy");

var $e78646567f384248$exports = {};

$parcel$export($e78646567f384248$exports, "__esModule", function () { return $e78646567f384248$export$1e511d4a378977f5; }, function (v) { return $e78646567f384248$export$1e511d4a378977f5 = v; });
$parcel$export($e78646567f384248$exports, "Anchor", function () { return $e78646567f384248$export$b688253958b8dfe7; }, function (v) { return $e78646567f384248$export$b688253958b8dfe7 = v; });
var $e78646567f384248$export$1e511d4a378977f5;
var $e78646567f384248$export$b688253958b8dfe7;
"use strict";
$e78646567f384248$export$1e511d4a378977f5 = true;
$e78646567f384248$export$b688253958b8dfe7 = void 0;
var $484de1138b3f84d8$export$1e511d4a378977f5;
var $484de1138b3f84d8$export$b688253958b8dfe7;
"use strict";
$484de1138b3f84d8$export$1e511d4a378977f5 = true;
$484de1138b3f84d8$export$b688253958b8dfe7 = void 0;

var $484de1138b3f84d8$var$_react = $484de1138b3f84d8$var$_interopRequireWildcard((parcelRequire("2xPiy")));
var $4113023f9e0bafa0$exports = {};
"use strict";
$4113023f9e0bafa0$exports.__esModule = true;
var $a0261dac70a40f19$exports = {};

$parcel$export($a0261dac70a40f19$exports, "__esModule", function () { return $a0261dac70a40f19$export$1e511d4a378977f5; }, function (v) { return $a0261dac70a40f19$export$1e511d4a378977f5 = v; });
$parcel$export($a0261dac70a40f19$exports, "normalizeTiming", function () { return $a0261dac70a40f19$export$9eb47d7051add002; }, function (v) { return $a0261dac70a40f19$export$9eb47d7051add002 = v; });
$parcel$export($a0261dac70a40f19$exports, "animationObjectStyle", function () { return $a0261dac70a40f19$export$1d0c30b40b07398; }, function (v) { return $a0261dac70a40f19$export$1d0c30b40b07398 = v; });
$parcel$export($a0261dac70a40f19$exports, "animationEnding", function () { return $a0261dac70a40f19$export$cc25916ed0a5fe3a; }, function (v) { return $a0261dac70a40f19$export$cc25916ed0a5fe3a = v; });
$parcel$export($a0261dac70a40f19$exports, "animationBounds", function () { return $a0261dac70a40f19$export$106a9d8bc0bca92a; }, function (v) { return $a0261dac70a40f19$export$106a9d8bc0bca92a = v; });
var $a0261dac70a40f19$export$1e511d4a378977f5;
var $a0261dac70a40f19$export$9eb47d7051add002;
var $a0261dac70a40f19$export$1d0c30b40b07398;
var $a0261dac70a40f19$export$cc25916ed0a5fe3a;
var $a0261dac70a40f19$export$106a9d8bc0bca92a;
"use strict";
$a0261dac70a40f19$export$1e511d4a378977f5 = true;
$a0261dac70a40f19$export$9eb47d7051add002 = $a0261dac70a40f19$export$1d0c30b40b07398 = $a0261dac70a40f19$export$cc25916ed0a5fe3a = $a0261dac70a40f19$export$106a9d8bc0bca92a = void 0;

var $iA1nz = parcelRequire("iA1nz");
var $a0261dac70a40f19$var$PULSE_SIZES = {
    xsmall: 1.001,
    small: 1.01,
    medium: 1.1,
    large: 1.5,
    xlarge: 2
};
var $a0261dac70a40f19$var$SLIDE_SIZES = {
    xsmall: 1,
    small: 5,
    medium: 10,
    large: 50,
    xlarge: 200
};
var $a0261dac70a40f19$var$JIGGLE_SIZES = {
    xsmall: 0.1,
    small: 1,
    medium: 5,
    large: 400,
    xlarge: 1000
};
var $a0261dac70a40f19$var$ZOOM_SIZES = {
    xsmall: 0.001,
    small: 0.01,
    medium: 0.05,
    large: 0.1,
    xlarge: 0.5
};
var $a0261dac70a40f19$var$animationBounds = $a0261dac70a40f19$export$106a9d8bc0bca92a = function animationBounds(type, size) {
    if (size === void 0) size = 'medium';
    if (type === 'draw') return [
        '',
        "stroke-dashoffset: 0"
    ];
    if (type === 'fadeIn') return [
        'opacity: 0;',
        'opacity: 1;'
    ];
    if (type === 'fadeOut') return [
        'opacity: 1;',
        'opacity: 0;'
    ];
    if (type === 'jiggle') {
        var deg = $a0261dac70a40f19$var$JIGGLE_SIZES[size];
        return [
            "transform: rotate(-" + deg + "deg);",
            "transform: rotate(" + deg + "deg);"
        ];
    }
    if (type === 'pulse') return [
        'transform: scale(1);',
        "transform: scale(" + $a0261dac70a40f19$var$PULSE_SIZES[size] + ")"
    ];
    if (type === 'rotateRight') return [
        "transform: rotate(0deg);",
        "transform: rotate(359deg);"
    ];
    if (type === 'rotateLeft') return [
        "transform: rotate(0deg);",
        "transform: rotate(-359deg);"
    ];
    if (type === 'flipIn') return [
        'transform: rotateY(90deg);',
        'transform: rotateY(0);'
    ];
    if (type === 'flipOut') return [
        'transform: rotateY(0);',
        'transform: rotateY(90deg);'
    ];
    if (type === 'slideDown') return [
        "transform: translateY(-" + $a0261dac70a40f19$var$SLIDE_SIZES[size] + "%);",
        'transform: none;'
    ];
    if (type === 'slideLeft') return [
        "transform: translateX(" + $a0261dac70a40f19$var$SLIDE_SIZES[size] + "%);",
        'transform: none;'
    ];
    if (type === 'slideRight') return [
        "transform: translateX(-" + $a0261dac70a40f19$var$SLIDE_SIZES[size] + "%);",
        'transform: none;'
    ];
    if (type === 'slideUp') return [
        "transform: translateY(" + $a0261dac70a40f19$var$SLIDE_SIZES[size] + "%);",
        'transform: none;'
    ];
    if (type === 'zoomIn') return [
        "transform: scale(" + (1 - $a0261dac70a40f19$var$ZOOM_SIZES[size]) + ");",
        'transform: none;'
    ];
    if (type === 'zoomOut') return [
        "transform: scale(" + (1 + $a0261dac70a40f19$var$ZOOM_SIZES[size]) + ");",
        'transform: none;'
    ];
    return [];
};
var $a0261dac70a40f19$var$normalizeTiming = $a0261dac70a40f19$export$9eb47d7051add002 = function normalizeTiming(time, defaultTiming) {
    return typeof time === 'number' ? time / 1000.0 + "s" : time || defaultTiming;
};
var $a0261dac70a40f19$var$animationEnding = $a0261dac70a40f19$export$cc25916ed0a5fe3a = function animationEnding(type) {
    if (type === 'draw') return 'linear forwards';
    if (type === 'jiggle') return 'alternate infinite';
    if (type === 'pulse') return 'alternate infinite';
    if (type === 'rotateRight' || type === 'rotateLeft') return 'infinite linear';
    return 'forwards';
};
var $a0261dac70a40f19$var$animationObjectStyle = $a0261dac70a40f19$export$1d0c30b40b07398 = function animationObjectStyle(animation, theme, themeObj) {
    var bounds = $a0261dac70a40f19$var$animationBounds(animation.type, animation.size);
    var animationTheme = themeObj && themeObj.animation || theme.global.animation;
    if (bounds) {
        var animationTransition = (0, $iA1nz.css)([
            "from{",
            ";}to{",
            ";}"
        ], bounds[0], bounds[1]);
        var defaultDuration = function defaultDuration() {
            return $a0261dac70a40f19$var$normalizeTiming(animationTheme[animation.type] ? animationTheme[animation.type].duration : animation.duration, animationTheme.duration);
        };
        return (0, $iA1nz.css)([
            "",
            " ",
            " ",
            " ",
            ""
        ], (0, $iA1nz.keyframes)([
            "",
            ""
        ], animationTransition), $a0261dac70a40f19$var$normalizeTiming(animation.duration, defaultDuration()), $a0261dac70a40f19$var$normalizeTiming(animation.delay, '0s'), $a0261dac70a40f19$var$animationEnding(animation.type));
    }
    return '';
};


Object.keys($a0261dac70a40f19$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4113023f9e0bafa0$exports && $4113023f9e0bafa0$exports[key] === $a0261dac70a40f19$exports[key]) return;
    $4113023f9e0bafa0$exports[key] = $a0261dac70a40f19$exports[key];
});
var $d65b270127c3c07e$exports = {};

$parcel$export($d65b270127c3c07e$exports, "__esModule", function () { return $d65b270127c3c07e$export$1e511d4a378977f5; }, function (v) { return $d65b270127c3c07e$export$1e511d4a378977f5 = v; });
$parcel$export($d65b270127c3c07e$exports, "parseMetricToNum", function () { return $d65b270127c3c07e$export$333c2219d71d27ce; }, function (v) { return $d65b270127c3c07e$export$333c2219d71d27ce = v; });
$parcel$export($d65b270127c3c07e$exports, "getAvailableAtBadge", function () { return $d65b270127c3c07e$export$319d1f43f7cd3019; }, function (v) { return $d65b270127c3c07e$export$319d1f43f7cd3019 = v; });
$parcel$export($d65b270127c3c07e$exports, "fontSize", function () { return $d65b270127c3c07e$export$85e3c3ca0c6fb93; }, function (v) { return $d65b270127c3c07e$export$85e3c3ca0c6fb93 = v; });
$parcel$export($d65b270127c3c07e$exports, "findAllByType", function () { return $d65b270127c3c07e$export$fdd5e64c0e8495bb; }, function (v) { return $d65b270127c3c07e$export$fdd5e64c0e8495bb = v; });
$parcel$export($d65b270127c3c07e$exports, "edgeToNum", function () { return $d65b270127c3c07e$export$d3510c15440bd3f3; }, function (v) { return $d65b270127c3c07e$export$d3510c15440bd3f3 = v; });
$parcel$export($d65b270127c3c07e$exports, "breakpointStyle", function () { return $d65b270127c3c07e$export$2180d12f0a299a89; }, function (v) { return $d65b270127c3c07e$export$2180d12f0a299a89 = v; });
var $d65b270127c3c07e$export$1e511d4a378977f5;
var $d65b270127c3c07e$export$333c2219d71d27ce;
var $d65b270127c3c07e$export$319d1f43f7cd3019;
var $d65b270127c3c07e$export$85e3c3ca0c6fb93;
var $d65b270127c3c07e$export$fdd5e64c0e8495bb;
var $d65b270127c3c07e$export$d3510c15440bd3f3;
var $d65b270127c3c07e$export$2180d12f0a299a89;
"use strict";
$d65b270127c3c07e$export$1e511d4a378977f5 = true;
$d65b270127c3c07e$export$333c2219d71d27ce = $d65b270127c3c07e$export$319d1f43f7cd3019 = $d65b270127c3c07e$export$85e3c3ca0c6fb93 = $d65b270127c3c07e$export$fdd5e64c0e8495bb = $d65b270127c3c07e$export$d3510c15440bd3f3 = $d65b270127c3c07e$export$2180d12f0a299a89 = void 0;

var $iA1nz = parcelRequire("iA1nz");
var $d65b270127c3c07e$var$parseMetricToNum = $d65b270127c3c07e$export$333c2219d71d27ce = function parseMetricToNum(metric) {
    if (typeof metric === 'number') return metric;
    if (metric.match(/\s/) && true) console.warn("Invalid single measurement value: \"" + metric + "\"");
    return parseFloat(metric.match(/\d+(\.\d+)?/), 10);
};
var $d65b270127c3c07e$var$edgeToNum = $d65b270127c3c07e$export$d3510c15440bd3f3 = function edgeToNum(size, theme) {
    return size ? $d65b270127c3c07e$var$parseMetricToNum(theme.global.edgeSize[size] || size) : 0;
};
var $d65b270127c3c07e$var$fontSize = $d65b270127c3c07e$export$85e3c3ca0c6fb93 = function fontSize(size, lineHeight) {
    return (0, $iA1nz.css)([
        "font-size:",
        ";line-height:",
        ";"
    ], function(props) {
        return $d65b270127c3c07e$var$parseMetricToNum(size) / $d65b270127c3c07e$var$parseMetricToNum(props.theme.global.font.size) * 1 + "rem";
    }, function(props) {
        return lineHeight || Math.ceil($d65b270127c3c07e$var$parseMetricToNum(size) / $d65b270127c3c07e$var$parseMetricToNum(props.theme.global.lineHeight)) * ($d65b270127c3c07e$var$parseMetricToNum(props.theme.global.lineHeight) / $d65b270127c3c07e$var$parseMetricToNum(size)) + "px";
    });
};
var $d65b270127c3c07e$var$breakpointStyle = $d65b270127c3c07e$export$2180d12f0a299a89 = function breakpointStyle(breakpoint, content, responsive) {
    var px = typeof (breakpoint == null ? void 0 : breakpoint.value) === 'string' && breakpoint.value.endsWith('px') ? '' : 'px';
    var st = responsive === 'container' ? (0, $iA1nz.css)([
        "@container ",
        "{",
        ";}"
    ], breakpoint.value && "(max-width: " + breakpoint.value + px + ")", content) : (0, $iA1nz.css)([
        "@media only screen ",
        "{",
        ";}"
    ], breakpoint.value && "and (max-width: " + breakpoint.value + px + ")", content);
    return st;
};
var $d65b270127c3c07e$var$_findAllByType = $d65b270127c3c07e$export$fdd5e64c0e8495bb = function findAllByType(component, type) {
    var matches = [];
    if (component.type === type) matches.push(component);
    if (component.children) component.children.forEach(function(child) {
        matches = matches.concat($d65b270127c3c07e$var$_findAllByType(child, type));
    });
    return matches;
};
var $d65b270127c3c07e$var$getAvailableAtBadge = $d65b270127c3c07e$export$319d1f43f7cd3019 = function getAvailableAtBadge(availableAt, componentType) {
    return [
        {
            url: "https://storybook.grommet.io/?selectedKind=" + componentType + "-" + availableAt + "&full=0&stories=1&panelRight=0",
            badge: 'https://cdn-images-1.medium.com/fit/c/120/120/1*TD1P0HtIH9zF0UEH28zYtw.png',
            label: 'Storybook'
        },
        {
            url: "https://codesandbox.io/s/github/grommet/grommet-sandbox?initialpath=/" + availableAt.toLowerCase() + "&module=%2Fsrc%2F" + availableAt + ".js",
            badge: 'https://codesandbox.io/static/img/play-codesandbox.svg',
            label: 'CodeSandbox'
        }
    ];
};


Object.keys($d65b270127c3c07e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4113023f9e0bafa0$exports && $4113023f9e0bafa0$exports[key] === $d65b270127c3c07e$exports[key]) return;
    $4113023f9e0bafa0$exports[key] = $d65b270127c3c07e$exports[key];
});
var $cdcfbcf0f8cd48ba$exports = {};

$parcel$export($cdcfbcf0f8cd48ba$exports, "__esModule", function () { return $cdcfbcf0f8cd48ba$export$1e511d4a378977f5; }, function (v) { return $cdcfbcf0f8cd48ba$export$1e511d4a378977f5 = v; });
$parcel$export($cdcfbcf0f8cd48ba$exports, "selectedStyle", function () { return $cdcfbcf0f8cd48ba$export$a7abb1b3dc25813f; }, function (v) { return $cdcfbcf0f8cd48ba$export$a7abb1b3dc25813f = v; });
$parcel$export($cdcfbcf0f8cd48ba$exports, "normalizeBackground", function () { return $cdcfbcf0f8cd48ba$export$7b802385d70a5af9; }, function (v) { return $cdcfbcf0f8cd48ba$export$7b802385d70a5af9 = v; });
$parcel$export($cdcfbcf0f8cd48ba$exports, "getHoverIndicatorStyle", function () { return $cdcfbcf0f8cd48ba$export$172ca055ee2bcc62; }, function (v) { return $cdcfbcf0f8cd48ba$export$172ca055ee2bcc62 = v; });
$parcel$export($cdcfbcf0f8cd48ba$exports, "backgroundStyle", function () { return $cdcfbcf0f8cd48ba$export$e43a4f0de05cb7e9; }, function (v) { return $cdcfbcf0f8cd48ba$export$e43a4f0de05cb7e9 = v; });
$parcel$export($cdcfbcf0f8cd48ba$exports, "backgroundIsDark", function () { return $cdcfbcf0f8cd48ba$export$d285dc898c6a4d11; }, function (v) { return $cdcfbcf0f8cd48ba$export$d285dc898c6a4d11 = v; });
$parcel$export($cdcfbcf0f8cd48ba$exports, "backgroundAndTextColors", function () { return $cdcfbcf0f8cd48ba$export$51f19bd17c18b682; }, function (v) { return $cdcfbcf0f8cd48ba$export$51f19bd17c18b682 = v; });
$parcel$export($cdcfbcf0f8cd48ba$exports, "activeStyle", function () { return $cdcfbcf0f8cd48ba$export$d51670144e8c59cf; }, function (v) { return $cdcfbcf0f8cd48ba$export$d51670144e8c59cf = v; });
var $cdcfbcf0f8cd48ba$export$1e511d4a378977f5;
var $cdcfbcf0f8cd48ba$export$a7abb1b3dc25813f;
var $cdcfbcf0f8cd48ba$export$7b802385d70a5af9;
var $cdcfbcf0f8cd48ba$export$172ca055ee2bcc62;
var $cdcfbcf0f8cd48ba$export$e43a4f0de05cb7e9;
var $cdcfbcf0f8cd48ba$export$d285dc898c6a4d11;
var $cdcfbcf0f8cd48ba$export$51f19bd17c18b682;
var $cdcfbcf0f8cd48ba$export$d51670144e8c59cf;
"use strict";
$cdcfbcf0f8cd48ba$export$1e511d4a378977f5 = true;
$cdcfbcf0f8cd48ba$export$a7abb1b3dc25813f = $cdcfbcf0f8cd48ba$export$7b802385d70a5af9 = $cdcfbcf0f8cd48ba$export$172ca055ee2bcc62 = $cdcfbcf0f8cd48ba$export$e43a4f0de05cb7e9 = $cdcfbcf0f8cd48ba$export$d285dc898c6a4d11 = $cdcfbcf0f8cd48ba$export$51f19bd17c18b682 = $cdcfbcf0f8cd48ba$export$d51670144e8c59cf = void 0;

var $iA1nz = parcelRequire("iA1nz");
var $62e050f1cfc78056$exports = {};

$parcel$export($62e050f1cfc78056$exports, "__esModule", function () { return $62e050f1cfc78056$export$1e511d4a378977f5; }, function (v) { return $62e050f1cfc78056$export$1e511d4a378977f5 = v; });
$parcel$export($62e050f1cfc78056$exports, "normalizeColor", function () { return $62e050f1cfc78056$export$4cde5df63f53f473; }, function (v) { return $62e050f1cfc78056$export$4cde5df63f53f473 = v; });
$parcel$export($62e050f1cfc78056$exports, "getRGBArray", function () { return $62e050f1cfc78056$export$5bcd173cc9a0dca; }, function (v) { return $62e050f1cfc78056$export$5bcd173cc9a0dca = v; });
$parcel$export($62e050f1cfc78056$exports, "getRGBA", function () { return $62e050f1cfc78056$export$c24a0a5c5129b2e1; }, function (v) { return $62e050f1cfc78056$export$c24a0a5c5129b2e1 = v; });
$parcel$export($62e050f1cfc78056$exports, "colorIsDark", function () { return $62e050f1cfc78056$export$76249e090d1c76db; }, function (v) { return $62e050f1cfc78056$export$76249e090d1c76db = v; });
$parcel$export($62e050f1cfc78056$exports, "canExtractRGBArray", function () { return $62e050f1cfc78056$export$6d62a0650580a0ff; }, function (v) { return $62e050f1cfc78056$export$6d62a0650580a0ff = v; });
var $62e050f1cfc78056$export$1e511d4a378977f5;
var $62e050f1cfc78056$export$4cde5df63f53f473;
var $62e050f1cfc78056$export$5bcd173cc9a0dca;
var $62e050f1cfc78056$export$c24a0a5c5129b2e1;
var $62e050f1cfc78056$export$76249e090d1c76db;
var $62e050f1cfc78056$export$6d62a0650580a0ff;
"use strict";
$62e050f1cfc78056$export$1e511d4a378977f5 = true;
$62e050f1cfc78056$export$4cde5df63f53f473 = $62e050f1cfc78056$export$5bcd173cc9a0dca = $62e050f1cfc78056$export$c24a0a5c5129b2e1 = $62e050f1cfc78056$export$76249e090d1c76db = $62e050f1cfc78056$export$6d62a0650580a0ff = void 0;
// Track which deprecated colors have already been warned about
var $62e050f1cfc78056$var$warnedColors = new Set();
var $62e050f1cfc78056$var$checkColorDeprecation = function checkColorDeprecation(color, theme, dark) {
    var _theme$global$depreca;
    if ((_theme$global$depreca = theme.global.deprecated) != null && _theme$global$depreca.colors && true) {
        var colorKey = color;
        if (typeof color === 'object') {
            if (dark === true || dark === undefined && theme.dark) colorKey = color.dark;
            else colorKey = color.light;
        }
        if (!$62e050f1cfc78056$var$warnedColors.has(colorKey)) {
            var deprecatedColor;
            if (typeof color === 'string') deprecatedColor = theme.global.deprecated.colors.find(function(item) {
                return item.name === color;
            });
            else if (typeof color === 'object') deprecatedColor = theme.global.deprecated.colors.find(function(item) {
                return item.name === color.light || item.name === color.dark;
            });
            if (deprecatedColor) {
                $62e050f1cfc78056$var$warnedColors.add(colorKey);
                console.warn(deprecatedColor.message || colorKey + " is deprecated.");
            }
        }
    }
};
// Returns the specific color that should be used according to the theme.
// If 'dark' is supplied, it takes precedence over 'theme.dark'.
// Can return undefined.
var $62e050f1cfc78056$var$_normalizeColor = $62e050f1cfc78056$export$4cde5df63f53f473 = function normalizeColor(color, theme, dark) {
    $62e050f1cfc78056$var$checkColorDeprecation(color, theme, dark);
    var colorSpec = theme.global && theme.global.colors[color] !== undefined ? theme.global.colors[color] : color;
    // If the color has a light or dark object, use that
    var result = colorSpec;
    if (colorSpec) {
        if ((dark === true || dark === undefined && theme.dark) && colorSpec.dark !== undefined) result = colorSpec.dark;
        else if ((dark === false || !theme.dark) && colorSpec.light !== undefined) result = colorSpec.light;
    }
    // allow one level of indirection in color names
    if (result && theme.global && theme.global.colors[result] !== undefined) result = $62e050f1cfc78056$var$_normalizeColor(result, theme, dark);
    return result;
};
var $62e050f1cfc78056$var$parseHexToRGB = function parseHexToRGB(color) {
    return color.length < 7 // 7 is what's needed for '#RRGGBB'
     ? color.match(/[A-Za-z0-9]{1}/g).map(function(v) {
        return parseInt("" + v + v, 16);
    }) : // https://stackoverflow.com/a/42429333
    color.match(/[A-Za-z0-9]{2}/g).map(function(v) {
        return parseInt(v, 16);
    });
};
// From: https://stackoverflow.com/a/9493060/8513067
// Converts an HSL color value to RGB. Conversion formula
// adapted from http://en.wikipedia.org/wiki/HSL_color_space.
// Assumes h, s, and l are contained in the set [0, 1] and
// returns r, g, and b in the set [0, 255].
var $62e050f1cfc78056$var$hslToRGB = function hslToRGB(h, s, l) {
    var r;
    var g;
    var b;
    if (s === 0 || s === '0') {
        // achromatic
        r = l;
        g = l;
        b = l;
    } else {
        var hue2rgb = function hue2rgb(p, q, inT) {
            var t = inT;
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 0.16666667) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 0.66666667) return p + (q - p) * (0.66666667 - t) * 6;
            return p;
        };
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 0.33333333);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 0.33333333);
    }
    return [
        Math.round(r * 255),
        Math.round(g * 255),
        Math.round(b * 255)
    ];
};
// allow for alpha: #RGB, #RGBA, #RRGGBB, or #RRGGBBAA
var $62e050f1cfc78056$var$hexExp = /^#[A-Za-z0-9]{3,4}$|^#[A-Za-z0-9]{6,8}$/;
var $62e050f1cfc78056$var$rgbExp = /^rgba?\(\s?([0-9]*)\s?,\s?([0-9]*)\s?,\s?([0-9]*)\s?\)/;
var $62e050f1cfc78056$var$rgbaExp = /^rgba?\(\s?([0-9]*)\s?,\s?([0-9]*)\s?,\s?([0-9]*)\s?,\s?([.0-9]*)\s?\)/;
// e.g. hsl(240, 60%, 50%)
var $62e050f1cfc78056$var$hslExp = /^hsla?\(\s?([0-9]*)\s?,\s?([0-9]*)%?\s?,\s?([0-9]*)%?\s?.*?\)/;
var $62e050f1cfc78056$var$canExtractRGBArray = $62e050f1cfc78056$export$6d62a0650580a0ff = function canExtractRGBArray(color) {
    return $62e050f1cfc78056$var$hexExp.test(color) || $62e050f1cfc78056$var$rgbExp.test(color) || $62e050f1cfc78056$var$rgbaExp.test(color) || $62e050f1cfc78056$var$hslExp.test(color);
};
var $62e050f1cfc78056$var$getRGBArray = $62e050f1cfc78056$export$5bcd173cc9a0dca = function getRGBArray(color) {
    if ($62e050f1cfc78056$var$hexExp.test(color)) {
        var _parseHexToRGB = $62e050f1cfc78056$var$parseHexToRGB(color), red = _parseHexToRGB[0], green = _parseHexToRGB[1], blue = _parseHexToRGB[2], alpha = _parseHexToRGB[3];
        return [
            red,
            green,
            blue,
            alpha !== undefined ? alpha / 255.0 : undefined
        ];
    }
    var match = color.match($62e050f1cfc78056$var$rgbExp);
    if (match) return match.splice(1).map(function(v) {
        return parseInt(v, 10);
    });
    match = color.match($62e050f1cfc78056$var$rgbaExp);
    if (match) return match.splice(1).map(function(v) {
        return parseFloat(v, 10);
    });
    match = color.match($62e050f1cfc78056$var$hslExp);
    if (match) {
        var _match$splice$map = match.splice(1).map(function(v) {
            return parseInt(v, 10);
        }), h = _match$splice$map[0], s = _match$splice$map[1], l = _match$splice$map[2];
        return $62e050f1cfc78056$var$hslToRGB(h / 360.0, s / 100.0, l / 100.0);
    }
    return color;
};
var $62e050f1cfc78056$var$colorIsDark = $62e050f1cfc78056$export$76249e090d1c76db = function colorIsDark(color) {
    if (color && $62e050f1cfc78056$var$canExtractRGBArray(color)) {
        var _getRGBArray = $62e050f1cfc78056$var$getRGBArray(color), red = _getRGBArray[0], green = _getRGBArray[1], blue = _getRGBArray[2], alpha = _getRGBArray[3];
        // if there is an alpha and it's greater than 50%, we can't really tell
        if (alpha < 0.5) return undefined;
        var brightness = (299 * red + 587 * green + 114 * blue) / 1000;
        // From: http://www.had2know.com/technology/color-contrast-calculator-web-design.html
        // Above domain is no longer registered.
        return brightness < 125;
    }
    return undefined;
};
var $62e050f1cfc78056$var$getRGBA = $62e050f1cfc78056$export$c24a0a5c5129b2e1 = function getRGBA(color, opacity) {
    if (color && $62e050f1cfc78056$var$canExtractRGBArray(color)) {
        var _getRGBArray2 = $62e050f1cfc78056$var$getRGBArray(color), red = _getRGBArray2[0], green = _getRGBArray2[1], blue = _getRGBArray2[2], alpha = _getRGBArray2[3];
        var normalizedAlpha;
        if (opacity !== undefined) normalizedAlpha = opacity;
        else if (alpha !== undefined) normalizedAlpha = alpha;
        else normalizedAlpha = 1;
        return "rgba(" + red + ", " + green + ", " + blue + ", " + normalizedAlpha + ")";
    }
    return undefined;
};


// evalStyle() converts a styled-components item into a string
var $cdcfbcf0f8cd48ba$var$evalStyle = function evalStyle(arg, theme) {
    if (arg && Array.isArray(arg) && typeof arg[0] === 'function') return arg[0]({
        theme: theme
    });
    return arg;
};
var $cdcfbcf0f8cd48ba$var$normalizeBackground = $cdcfbcf0f8cd48ba$export$7b802385d70a5af9 = function normalizeBackground(backgroundArg, theme) {
    var _theme$global$backgro;
    var background = ((_theme$global$backgro = theme.global.backgrounds) == null ? void 0 : _theme$global$backgro[backgroundArg]) || backgroundArg;
    var result = background;
    // If the background has a light or dark object, use that
    if (background) {
        if (theme.dark && background.dark && typeof background.dark !== 'boolean') result = background.dark;
        else if (!theme.dark && background.light && typeof background.light !== 'boolean') result = background.light;
        result = $cdcfbcf0f8cd48ba$var$evalStyle(result, theme);
    }
    return result;
};
var $cdcfbcf0f8cd48ba$var$normalizeBackgroundColor = function normalizeBackgroundColor(backgroundArg, theme) {
    var _theme$global$backgro2;
    var background = backgroundArg.color || backgroundArg;
    var result = (0, $62e050f1cfc78056$export$4cde5df63f53f473)(// Background color may be defined by theme.global.backgrounds or
    // theme.global.colors.
    ((_theme$global$backgro2 = theme.global.backgrounds) == null ? void 0 : _theme$global$backgro2[background]) || background, theme, backgroundArg.dark);
    return result;
};
var $cdcfbcf0f8cd48ba$var$_normalizeBackgroundImage = function normalizeBackgroundImage(background, theme) {
    var result;
    if (background.image) {
        var _theme$global$backgro3, _theme$global$backgro4;
        result = $cdcfbcf0f8cd48ba$var$normalizeBackground(background.dark ? (_theme$global$backgro3 = theme.global.backgrounds) == null || (_theme$global$backgro3 = _theme$global$backgro3[background.image]) == null ? void 0 : _theme$global$backgro3.dark : (_theme$global$backgro4 = theme.global.backgrounds) == null ? void 0 : _theme$global$backgro4[background.image], theme) || background.image;
    } else {
        var _theme$global$backgro5;
        var normalized = $cdcfbcf0f8cd48ba$var$normalizeBackground((_theme$global$backgro5 = theme.global.backgrounds) == null ? void 0 : _theme$global$backgro5[background], theme);
        result = typeof normalized === 'object' ? $cdcfbcf0f8cd48ba$var$_normalizeBackgroundImage(normalized, theme) : normalized;
    }
    return result;
};
var $cdcfbcf0f8cd48ba$var$rotateBackground = function rotateBackground(background, theme) {
    var backgroundImage = $cdcfbcf0f8cd48ba$var$_normalizeBackgroundImage(background, theme);
    var result = backgroundImage;
    if (backgroundImage.lastIndexOf('linear-gradient', 0) === 0) {
        var regex = /\d{1,}deg\b,/gm; // Contains rotation specified in degrees. Only targets 'deg' string with a trailing comma. Do not match 'deg' string for hsl, etc..
        result = backgroundImage.lastIndexOf('deg,') >= 0 ? backgroundImage.replace(regex, background.rotate + "deg,") : backgroundImage.replace('linear-gradient(', "linear-gradient(" + background.rotate + "deg, ");
    } else console.warn("'background.rotate' property only supports 'background.image' containing a linear-gradient string.");
    return result;
};
var $cdcfbcf0f8cd48ba$var$backgroundIsDark = $cdcfbcf0f8cd48ba$export$d285dc898c6a4d11 = function backgroundIsDark(backgroundArg, theme) {
    var background = $cdcfbcf0f8cd48ba$var$normalizeBackground(backgroundArg, theme);
    var result;
    if (background) {
        if (typeof background === 'object') {
            var color = background.color, dark = background.dark, opacity = background.opacity;
            if (typeof dark === 'boolean') result = dark;
            else if (color && // weak opacity means we keep the existing darkness
            (!opacity || opacity !== 'weak')) {
                var backgroundColor = (0, $62e050f1cfc78056$export$4cde5df63f53f473)(background.color, theme);
                if (backgroundColor) result = (0, $62e050f1cfc78056$export$76249e090d1c76db)(backgroundColor);
            }
        } else {
            var _color = (0, $62e050f1cfc78056$export$4cde5df63f53f473)(background, theme);
            if (_color) result = (0, $62e050f1cfc78056$export$76249e090d1c76db)(_color);
        }
    }
    return result;
};
var $cdcfbcf0f8cd48ba$var$darkContext = function darkContext(backgroundColor) {
    var isDark = (0, $62e050f1cfc78056$export$76249e090d1c76db)(backgroundColor);
    if (isDark === undefined) return undefined;
    return isDark ? 'dark' : 'light';
};
// Returns an array of two CSS colors: [background, color]
// Either could be undefined.
// background could be a CSS gradient, like "linear-gradient(...)"
var $cdcfbcf0f8cd48ba$var$backgroundAndTextColors = $cdcfbcf0f8cd48ba$export$51f19bd17c18b682 = function backgroundAndTextColors(backgroundArg, textArg, theme) {
    if (!backgroundArg) return [
        undefined,
        textArg
    ];
    var global = theme.global;
    var background = $cdcfbcf0f8cd48ba$var$normalizeBackground(backgroundArg, theme);
    var text = textArg || global.colors.text;
    var backgroundColor;
    var textColor;
    if (typeof background === 'object') {
        if (background.dark === false) textColor = text.light || text;
        else if (background.dark) textColor = text.dark || text;
        if (background.color) {
            var color = $cdcfbcf0f8cd48ba$var$normalizeBackgroundColor(background, theme);
            var opacity = background.opacity === true ? global.opacity.medium : global.opacity[background.opacity] || background.opacity;
            backgroundColor = (0, $62e050f1cfc78056$export$c24a0a5c5129b2e1)(color, opacity) || color;
            // If we don't have a textColor already, and we aren't too translucent,
            // set the textColor to have the best contrast against the background
            // color.
            if (!textColor && (opacity === undefined || opacity > 0.3)) {
                var shade = $cdcfbcf0f8cd48ba$var$darkContext(backgroundColor, theme);
                textColor = (0, $62e050f1cfc78056$export$4cde5df63f53f473)(shade && text[shade] || text, theme);
            }
        }
    } else {
        backgroundColor = $cdcfbcf0f8cd48ba$var$normalizeBackgroundColor(background, theme);
        var _shade = $cdcfbcf0f8cd48ba$var$darkContext(backgroundColor, theme);
        var transparent;
        if (backgroundColor && (0, $62e050f1cfc78056$export$6d62a0650580a0ff)(backgroundColor)) {
            var colorArray = (0, $62e050f1cfc78056$export$5bcd173cc9a0dca)(backgroundColor);
            // check if the alpha value is less than 0.5
            if (colorArray[3] < 0.5) transparent = true;
        }
        if (_shade) textColor = (0, $62e050f1cfc78056$export$4cde5df63f53f473)(text[_shade] || text, theme, _shade === 'dark');
        else if (transparent && text) textColor = (0, $62e050f1cfc78056$export$4cde5df63f53f473)(text, theme);
        else {
            // If we can't determine the shade, we assume this isn't a simple color.
            // It could be a gradient. backgroundStyle() will take care of that case.
            if (backgroundColor !== 'transparent') backgroundColor = undefined;
            if (text) textColor = (0, $62e050f1cfc78056$export$4cde5df63f53f473)(text, theme);
        }
    }
    // if textArg is false, we don't want the textColor, used for Button hover
    if (textArg === false) textColor = undefined;
    return [
        backgroundColor,
        textColor
    ];
};
var $cdcfbcf0f8cd48ba$var$backgroundStyle = $cdcfbcf0f8cd48ba$export$e43a4f0de05cb7e9 = function backgroundStyle(backgroundArg, theme, textColorArg) {
    // for Grommet component, if the background isn't defined, don't set it
    if (backgroundArg === undefined) return undefined;
    var background = $cdcfbcf0f8cd48ba$var$normalizeBackground(backgroundArg, theme);
    var _backgroundAndTextCol = $cdcfbcf0f8cd48ba$var$backgroundAndTextColors(background, textColorArg, theme), backgroundColor = _backgroundAndTextCol[0], textColor = _backgroundAndTextCol[1];
    var backgroundImage = background.rotate ? $cdcfbcf0f8cd48ba$var$rotateBackground(background, theme) : $cdcfbcf0f8cd48ba$var$_normalizeBackgroundImage(background, theme);
    var backgroundClipStyle = '';
    if (background.clip) backgroundClipStyle = background.clip === 'text' ? "-webkit-text-fill-color: transparent; \n           -webkit-background-clip: text; \n           background-clip: text;" : "background-clip: " + background.clip + ";";
    if (typeof background === 'string' && background.lastIndexOf('url', 0) === 0) return (0, $iA1nz.css)([
        "background:",
        " no-repeat center center;background-size:cover;"
    ], background);
    if (backgroundImage) {
        var backgroundStyles = "\n      " + (backgroundColor ? "background-color: " + backgroundColor + ";" : '') + "\n      background-image: " + backgroundImage + ";\n      background-repeat: " + (typeof background === 'object' && background.repeat || 'no-repeat') + ";\n      background-position: " + (background.position || 'center center') + ";\n      background-size: " + (background.size || 'cover') + ";\n      " + backgroundClipStyle + "\n    ";
        // allow both background color and image, in case the image doesn't fill
        // when image and opacity are used together, we need to use pseudo :before
        // to ensure that only image and background color are affected by opacity
        // but not the container contents
        return (0, $iA1nz.css)([
            "",
            " ",
            ""
        ], textColor ? "color: " + textColor + ";" : '', !background.opacity ? backgroundStyles : "position: relative;\n        z-index: 0;\n        &:before {\n          content: '';\n          position: absolute;\n          top: 0;\n          right: 0;\n          left: 0;\n          bottom: 0;\n          z-index: -1;\n          border-radius: inherit;\n          " + backgroundStyles + "\n          opacity: " + (background.opacity === true ? theme.global.opacity.medium : theme.global.opacity[background.opacity] || background.opacity) + ";\n        }");
    }
    if (backgroundColor) return (0, $iA1nz.css)([
        "background-color:",
        ";",
        ""
    ], backgroundColor, textColor ? "color: " + textColor + ";" : '');
    if (typeof background === 'string') // This case takes care of gradients
    // or theme colors that use CSS names like 'crimson' that we don't parse
    return (0, $iA1nz.css)([
        "background:",
        ";"
    ], (0, $62e050f1cfc78056$export$4cde5df63f53f473)(background, theme));
    return undefined;
};
var $cdcfbcf0f8cd48ba$var$activeStyle = $cdcfbcf0f8cd48ba$export$d51670144e8c59cf = (0, $iA1nz.css)([
    "",
    ""
], function(props) {
    return $cdcfbcf0f8cd48ba$var$backgroundStyle((0, $62e050f1cfc78056$export$4cde5df63f53f473)(props.theme.global.active.background, props.theme), props.theme, props.theme.global.active.color);
});
var $cdcfbcf0f8cd48ba$var$selectedStyle = $cdcfbcf0f8cd48ba$export$a7abb1b3dc25813f = (0, $iA1nz.css)([
    "",
    ""
], function(props) {
    return $cdcfbcf0f8cd48ba$var$backgroundStyle((0, $62e050f1cfc78056$export$4cde5df63f53f473)(props.theme.global.selected.background, props.theme), props.theme, props.theme.global.selected.color);
});
var $cdcfbcf0f8cd48ba$var$getHoverIndicatorStyle = $cdcfbcf0f8cd48ba$export$172ca055ee2bcc62 = function getHoverIndicatorStyle(hoverIndicator, theme) {
    var background;
    var elevation;
    if (hoverIndicator === true || hoverIndicator === 'background') background = theme.global.hover.background;
    else if (typeof hoverIndicator === 'object') {
        if (hoverIndicator.elevation || hoverIndicator.background) {
            elevation = hoverIndicator.elevation;
            background = hoverIndicator.background;
        } else background = hoverIndicator;
    } else background = hoverIndicator;
    return (0, $iA1nz.css)([
        "",
        " ",
        ""
    ], $cdcfbcf0f8cd48ba$var$backgroundStyle(background, theme, theme.global.hover.color), elevation && "box-shadow: " + theme.global.elevation[theme.dark ? 'dark' : 'light'][elevation] + ";");
};


Object.keys($cdcfbcf0f8cd48ba$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4113023f9e0bafa0$exports && $4113023f9e0bafa0$exports[key] === $cdcfbcf0f8cd48ba$exports[key]) return;
    $4113023f9e0bafa0$exports[key] = $cdcfbcf0f8cd48ba$exports[key];
});
var $68cccbbc8d28d3ec$exports = {};

$parcel$export($68cccbbc8d28d3ec$exports, "__esModule", function () { return $68cccbbc8d28d3ec$export$1e511d4a378977f5; }, function (v) { return $68cccbbc8d28d3ec$export$1e511d4a378977f5 = v; });
$parcel$export($68cccbbc8d28d3ec$exports, "responsiveBorderStyle", function () { return $68cccbbc8d28d3ec$export$e6d7d76967e857a7; }, function (v) { return $68cccbbc8d28d3ec$export$e6d7d76967e857a7 = v; });
$parcel$export($68cccbbc8d28d3ec$exports, "borderStyle", function () { return $68cccbbc8d28d3ec$export$4d0a7f76ad443516; }, function (v) { return $68cccbbc8d28d3ec$export$4d0a7f76ad443516 = v; });
var $68cccbbc8d28d3ec$export$1e511d4a378977f5;
var $68cccbbc8d28d3ec$export$e6d7d76967e857a7;
var $68cccbbc8d28d3ec$export$4d0a7f76ad443516;
"use strict";
$68cccbbc8d28d3ec$export$1e511d4a378977f5 = true;
$68cccbbc8d28d3ec$export$e6d7d76967e857a7 = $68cccbbc8d28d3ec$export$4d0a7f76ad443516 = void 0;

var $iA1nz = parcelRequire("iA1nz");


var $68cccbbc8d28d3ec$var$responsiveBorderStyle = $68cccbbc8d28d3ec$export$e6d7d76967e857a7 = function responsiveBorderStyle(data, theme) {
    var color = (0, $62e050f1cfc78056$export$4cde5df63f53f473)(data.color || 'border', theme);
    var borderSize = data.size || 'xsmall';
    var style = data.style || 'solid';
    var side = typeof data === 'string' ? data : data.side || 'all';
    var breakpoint = theme.box.responsiveBreakpoint && theme.global.breakpoints[theme.box.responsiveBreakpoint];
    if (!breakpoint.borderSize) breakpoint.borderSize = theme.global.borderSize;
    var value = breakpoint && (breakpoint.borderSize[borderSize] || borderSize) && style + " " + (breakpoint.borderSize[borderSize] || borderSize) + " " + color;
    if (!value) return undefined;
    if (side === 'top' || side === 'bottom' || side === 'left' || side === 'right') return "border-" + side + ": " + value + ";";
    if (side === 'end' || side === 'start') return "border-inline-" + side + ": " + value + ";";
    if (side === 'vertical') return "\n      border-left: " + value + ";\n      border-right: " + value + ";\n    ";
    if (side === 'horizontal') return "\n      border-top: " + value + ";\n      border-bottom: " + value + ";\n    ";
    if (side === 'between') return undefined; // no-op
    return "border: " + value + ";";
};
var $68cccbbc8d28d3ec$var$borderStyle = $68cccbbc8d28d3ec$export$4d0a7f76ad443516 = function borderStyle(borderData, responsive, theme) {
    var borderStyles = [];
    (Array.isArray(borderData) ? borderData : [
        borderData
    ]).forEach(function(data) {
        var styles = [];
        var color = (0, $62e050f1cfc78056$export$4cde5df63f53f473)(data.color || 'border', theme);
        var borderSize = data.size || 'xsmall';
        var style = data.style || 'solid';
        var side = typeof data === 'string' ? data : data.side || 'all';
        var value = style + " " + (theme.global.borderSize[borderSize] || borderSize) + " " + color;
        var responsiveStyle = responsive && $68cccbbc8d28d3ec$var$responsiveBorderStyle(data, theme);
        var breakpoint = responsiveStyle && theme.box.responsiveBreakpoint && theme.global.breakpoints[theme.box.responsiveBreakpoint];
        if (side === 'top' || side === 'bottom' || side === 'left' || side === 'right') {
            styles.push("border-" + side + ": " + value + ";");
            if (responsiveStyle) styles.push((0, $d65b270127c3c07e$export$2180d12f0a299a89)(breakpoint, responsiveStyle, responsive));
        } else if (side === 'end' || side === 'start') {
            styles.push((0, $iA1nz.css)([
                "border-inline-",
                ":",
                ";"
            ], side, value));
            if (responsiveStyle) styles.push((0, $d65b270127c3c07e$export$2180d12f0a299a89)(breakpoint, responsiveStyle, responsive));
        } else if (side === 'vertical') {
            styles.push((0, $iA1nz.css)([
                "border-left:",
                ";border-right:",
                ";"
            ], value, value));
            if (responsiveStyle) styles.push((0, $d65b270127c3c07e$export$2180d12f0a299a89)(breakpoint, responsiveStyle, responsive));
        } else if (side === 'horizontal') {
            styles.push((0, $iA1nz.css)([
                "border-top:",
                ";border-bottom:",
                ";"
            ], value, value));
            if (responsiveStyle) styles.push((0, $d65b270127c3c07e$export$2180d12f0a299a89)(breakpoint, responsiveStyle, responsive));
        } else if (side === 'between') ;
        else {
            styles.push((0, $iA1nz.css)([
                "border:",
                ";"
            ], value));
            if (responsiveStyle) styles.push((0, $d65b270127c3c07e$export$2180d12f0a299a89)(breakpoint, responsiveStyle, responsive));
        }
        borderStyles.push(styles);
    });
    return borderStyles;
};


Object.keys($68cccbbc8d28d3ec$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4113023f9e0bafa0$exports && $4113023f9e0bafa0$exports[key] === $68cccbbc8d28d3ec$exports[key]) return;
    $4113023f9e0bafa0$exports[key] = $68cccbbc8d28d3ec$exports[key];
});

Object.keys($62e050f1cfc78056$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4113023f9e0bafa0$exports && $4113023f9e0bafa0$exports[key] === $62e050f1cfc78056$exports[key]) return;
    $4113023f9e0bafa0$exports[key] = $62e050f1cfc78056$exports[key];
});
var $7f85f6d695ff3bb5$exports = {};

$parcel$export($7f85f6d695ff3bb5$exports, "__esModule", function () { return $7f85f6d695ff3bb5$export$1e511d4a378977f5; }, function (v) { return $7f85f6d695ff3bb5$export$1e511d4a378977f5 = v; });
$parcel$export($7f85f6d695ff3bb5$exports, "setHoursWithOffset", function () { return $7f85f6d695ff3bb5$export$c739ab4d3d4926aa; }, function (v) { return $7f85f6d695ff3bb5$export$c739ab4d3d4926aa = v; });
var $7f85f6d695ff3bb5$export$1e511d4a378977f5;
var $7f85f6d695ff3bb5$export$c739ab4d3d4926aa;
"use strict";
$7f85f6d695ff3bb5$export$1e511d4a378977f5 = true;
$7f85f6d695ff3bb5$export$c739ab4d3d4926aa = void 0;
var $7f85f6d695ff3bb5$var$setHoursWithOffset = $7f85f6d695ff3bb5$export$c739ab4d3d4926aa = function setHoursWithOffset(date) {
    var newDate = new Date(date);
    if ((date == null ? void 0 : date.indexOf('T')) === -1) {
        var offset = newDate.getTimezoneOffset();
        var hour = newDate.getHours();
        newDate.setHours(hour, offset < 0 ? -offset : offset);
    }
    return newDate;
};


Object.keys($7f85f6d695ff3bb5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4113023f9e0bafa0$exports && $4113023f9e0bafa0$exports[key] === $7f85f6d695ff3bb5$exports[key]) return;
    $4113023f9e0bafa0$exports[key] = $7f85f6d695ff3bb5$exports[key];
});
var $336882a0c45ba3cd$exports = {};

$parcel$export($336882a0c45ba3cd$exports, "__esModule", function () { return $336882a0c45ba3cd$export$1e511d4a378977f5; }, function (v) { return $336882a0c45ba3cd$export$1e511d4a378977f5 = v; });
$parcel$export($336882a0c45ba3cd$exports, "withinDropPortal", function () { return $336882a0c45ba3cd$export$357c244c06d83dec; }, function (v) { return $336882a0c45ba3cd$export$357c244c06d83dec = v; });
$parcel$export($336882a0c45ba3cd$exports, "shouldKeepFocus", function () { return $336882a0c45ba3cd$export$19f1b4b3dc25c57; }, function (v) { return $336882a0c45ba3cd$export$19f1b4b3dc25c57 = v; });
$parcel$export($336882a0c45ba3cd$exports, "setFocusWithoutScroll", function () { return $336882a0c45ba3cd$export$99137e580254b26a; }, function (v) { return $336882a0c45ba3cd$export$99137e580254b26a = v; });
$parcel$export($336882a0c45ba3cd$exports, "makeNodeUnfocusable", function () { return $336882a0c45ba3cd$export$f17a564c864b60a0; }, function (v) { return $336882a0c45ba3cd$export$f17a564c864b60a0 = v; });
$parcel$export($336882a0c45ba3cd$exports, "makeNodeFocusable", function () { return $336882a0c45ba3cd$export$d25257a562ca003b; }, function (v) { return $336882a0c45ba3cd$export$d25257a562ca003b = v; });
$parcel$export($336882a0c45ba3cd$exports, "isNodeBeforeScroll", function () { return $336882a0c45ba3cd$export$54c9800883215719; }, function (v) { return $336882a0c45ba3cd$export$54c9800883215719 = v; });
$parcel$export($336882a0c45ba3cd$exports, "isNodeAfterScroll", function () { return $336882a0c45ba3cd$export$27af05f039e10378; }, function (v) { return $336882a0c45ba3cd$export$27af05f039e10378 = v; });
$parcel$export($336882a0c45ba3cd$exports, "isFocusable", function () { return $336882a0c45ba3cd$export$4c063cf1350e6fed; }, function (v) { return $336882a0c45ba3cd$export$4c063cf1350e6fed = v; });
$parcel$export($336882a0c45ba3cd$exports, "getNewContainer", function () { return $336882a0c45ba3cd$export$1cad4a11c7ad1375; }, function (v) { return $336882a0c45ba3cd$export$1cad4a11c7ad1375 = v; });
$parcel$export($336882a0c45ba3cd$exports, "getFirstFocusableDescendant", function () { return $336882a0c45ba3cd$export$e957a3ef02119493; }, function (v) { return $336882a0c45ba3cd$export$e957a3ef02119493 = v; });
$parcel$export($336882a0c45ba3cd$exports, "findVisibleParent", function () { return $336882a0c45ba3cd$export$4fe2c44731a76aa0; }, function (v) { return $336882a0c45ba3cd$export$4fe2c44731a76aa0 = v; });
$parcel$export($336882a0c45ba3cd$exports, "findScrollParents", function () { return $336882a0c45ba3cd$export$14e46d92eb0648e; }, function (v) { return $336882a0c45ba3cd$export$14e46d92eb0648e = v; });
$parcel$export($336882a0c45ba3cd$exports, "findScrollParent", function () { return $336882a0c45ba3cd$export$6a1689aaa66d814c; }, function (v) { return $336882a0c45ba3cd$export$6a1689aaa66d814c = v; });
$parcel$export($336882a0c45ba3cd$exports, "findButtonParent", function () { return $336882a0c45ba3cd$export$37a8984127440e55; }, function (v) { return $336882a0c45ba3cd$export$37a8984127440e55 = v; });
$parcel$export($336882a0c45ba3cd$exports, "containsFocus", function () { return $336882a0c45ba3cd$export$b03135936dd040ba; }, function (v) { return $336882a0c45ba3cd$export$b03135936dd040ba = v; });
var $336882a0c45ba3cd$export$1e511d4a378977f5;
var $336882a0c45ba3cd$export$357c244c06d83dec;
var $336882a0c45ba3cd$export$19f1b4b3dc25c57;
var $336882a0c45ba3cd$export$99137e580254b26a;
var $336882a0c45ba3cd$export$f17a564c864b60a0;
var $336882a0c45ba3cd$export$d25257a562ca003b;
var $336882a0c45ba3cd$export$54c9800883215719;
var $336882a0c45ba3cd$export$27af05f039e10378;
var $336882a0c45ba3cd$export$4c063cf1350e6fed;
var $336882a0c45ba3cd$export$1cad4a11c7ad1375;
var $336882a0c45ba3cd$export$e957a3ef02119493;
var $336882a0c45ba3cd$export$4fe2c44731a76aa0;
var $336882a0c45ba3cd$export$14e46d92eb0648e;
var $336882a0c45ba3cd$export$6a1689aaa66d814c;
var $336882a0c45ba3cd$export$37a8984127440e55;
var $336882a0c45ba3cd$export$b03135936dd040ba;
"use strict";
$336882a0c45ba3cd$export$1e511d4a378977f5 = true;
$336882a0c45ba3cd$export$357c244c06d83dec = $336882a0c45ba3cd$export$19f1b4b3dc25c57 = $336882a0c45ba3cd$export$99137e580254b26a = $336882a0c45ba3cd$export$f17a564c864b60a0 = $336882a0c45ba3cd$export$d25257a562ca003b = $336882a0c45ba3cd$export$54c9800883215719 = $336882a0c45ba3cd$export$27af05f039e10378 = $336882a0c45ba3cd$export$4c063cf1350e6fed = $336882a0c45ba3cd$export$1cad4a11c7ad1375 = $336882a0c45ba3cd$export$e957a3ef02119493 = $336882a0c45ba3cd$export$4fe2c44731a76aa0 = $336882a0c45ba3cd$export$14e46d92eb0648e = $336882a0c45ba3cd$export$6a1689aaa66d814c = $336882a0c45ba3cd$export$37a8984127440e55 = $336882a0c45ba3cd$export$b03135936dd040ba = void 0;
var $336882a0c45ba3cd$var$findScrollParent = $336882a0c45ba3cd$export$6a1689aaa66d814c = function findScrollParent(element, horizontal) {
    var result;
    if (element) {
        var parent = element.parentNode;
        while(!result && parent && parent.getBoundingClientRect){
            var rect = parent.getBoundingClientRect();
            // 10px is to account for borders and scrollbars in a lazy way
            if (horizontal) {
                if (rect.width && parent.scrollWidth > rect.width + 10) result = parent;
            } else if (rect.height && parent.scrollHeight > rect.height + 10) result = parent;
            parent = parent.parentNode;
        }
        // last scrollable element will be the document
        // if nothing else is scrollable in the page
        if (!result) result = document;
        else if (result.tagName.toLowerCase() === 'body') result = document;
    }
    return result;
};
var $336882a0c45ba3cd$var$documentTags = [
    'html',
    'body'
];
var $336882a0c45ba3cd$var$findScrollParents = $336882a0c45ba3cd$export$14e46d92eb0648e = function findScrollParents(element, horizontal) {
    var result = [];
    if (element) {
        var parent = element.parentNode;
        while(parent && parent.getBoundingClientRect){
            var rect = parent.getBoundingClientRect();
            // 10px is to account for borders and scrollbars in a lazy way
            if (horizontal) {
                if (rect.width && parent.scrollWidth > rect.width + 10) result.push(parent);
            } else if (rect.height && parent.scrollHeight > rect.height + 10) result.push(parent);
            parent = parent.parentNode;
        }
        if (result.length && $336882a0c45ba3cd$var$documentTags.includes(result[0].tagName.toLowerCase())) result.length = 0;
        // last scrollable element will be the document
        result.push(document);
    }
    return result;
};
var $336882a0c45ba3cd$var$containsFocus = $336882a0c45ba3cd$export$b03135936dd040ba = function containsFocus(node) {
    var root = node.getRootNode();
    var element = root.activeElement;
    while(element){
        if (element === node) break;
        element = element.parentElement;
    }
    return !!element;
};
var $336882a0c45ba3cd$var$withinDropPortal = $336882a0c45ba3cd$export$357c244c06d83dec = function withinDropPortal(node, portalContext) {
    var root = node == null ? void 0 : node.getRootNode();
    var element = node;
    var portalId;
    while(element && element !== root)if (element.hasAttribute('data-g-portal-id')) {
        portalId = element.getAttribute('data-g-portal-id');
        element = root;
    } else element = element.parentElement;
    // if portalContext doesn't contain the portalId then the
    // portal is new and node is within a drop that just opened
    if (portalId === undefined || portalContext.indexOf(parseInt(portalId, 10)) !== -1) return false;
    return true;
};
// Check if the element.tagName is an input, select or textarea
var $336882a0c45ba3cd$var$isFocusable = $336882a0c45ba3cd$export$4c063cf1350e6fed = function isFocusable(element) {
    var tagName = element.tagName.toLowerCase();
    return tagName === 'input' || tagName === 'select' || tagName === 'textarea';
};
// Get the first element that can receive focus
var $336882a0c45ba3cd$var$getFirstFocusableDescendant = $336882a0c45ba3cd$export$e957a3ef02119493 = function getFirstFocusableDescendant(element) {
    var children = element.getElementsByTagName('*');
    for(var i = 0; i < children.length; i += 1){
        var child = children[i];
        if ($336882a0c45ba3cd$var$isFocusable(child)) return child;
    }
    return undefined;
};
var $336882a0c45ba3cd$var$shouldKeepFocus = $336882a0c45ba3cd$export$19f1b4b3dc25c57 = function shouldKeepFocus(root) {
    var element = root.activeElement;
    if ($336882a0c45ba3cd$var$isFocusable(element)) return true;
    return !!$336882a0c45ba3cd$var$getFirstFocusableDescendant(element);
};
var $336882a0c45ba3cd$var$getNewContainer = $336882a0c45ba3cd$export$1cad4a11c7ad1375 = function getNewContainer(target, targetChildPosition) {
    if (target === void 0) target = document.body;
    // setup DOM
    var container = document.createElement('div');
    if (targetChildPosition === 'first') // for SkipLinks
    target.prepend(container);
    else target.appendChild(container);
    return container;
};
var $336882a0c45ba3cd$var$setFocusWithoutScroll = $336882a0c45ba3cd$export$99137e580254b26a = function setFocusWithoutScroll(element) {
    var x = window.scrollX;
    var y = window.scrollY;
    element.focus();
    window.scrollTo(x, y);
};
var $336882a0c45ba3cd$var$TABINDEX = 'tabindex';
var $336882a0c45ba3cd$var$TABINDEX_STATE = 'data-g-tabindex';
var $336882a0c45ba3cd$var$makeNodeFocusable = $336882a0c45ba3cd$export$d25257a562ca003b = function makeNodeFocusable(node) {
    // do not touch aria live containers so that announcements work
    if (!node.hasAttribute('aria-live')) {
        node.removeAttribute('aria-hidden');
        // allow children to receive focus again
        var elements = node.getElementsByTagName('*');
        // only reset elements we've changed in makeNodeUnfocusable()
        Array.prototype.filter.call(elements || [], function(element) {
            return element.hasAttribute($336882a0c45ba3cd$var$TABINDEX_STATE);
        }).forEach(function(element) {
            var prior = element.getAttribute($336882a0c45ba3cd$var$TABINDEX_STATE);
            if (prior >= 0) element.setAttribute($336882a0c45ba3cd$var$TABINDEX, element.getAttribute($336882a0c45ba3cd$var$TABINDEX_STATE));
            else if (prior === 'none') element.removeAttribute($336882a0c45ba3cd$var$TABINDEX);
            element.removeAttribute($336882a0c45ba3cd$var$TABINDEX_STATE);
        });
    }
};
// Using ^ and $ to match the whole tagName, and not e.g. <meta> and <data>.
var $336882a0c45ba3cd$var$autoFocusingTags = /^(a|area|input|select|textarea|button|iframe)$/;
var $336882a0c45ba3cd$var$makeNodeUnfocusable = $336882a0c45ba3cd$export$f17a564c864b60a0 = function makeNodeUnfocusable(node) {
    // do not touch aria live containers so that announcements work
    if (!node.hasAttribute('aria-live')) {
        node.setAttribute('aria-hidden', true);
        // prevent children to receive focus
        var elements = node.getElementsByTagName('*');
        // first, save off the tabIndex of any element with one
        Array.prototype.filter.call(elements || [], function(element) {
            return element.getAttribute($336882a0c45ba3cd$var$TABINDEX) !== null;
        }).forEach(function(element) {
            // if TABINDEX_STATE already exists, it's holding the original value
            if (!element.getAttribute($336882a0c45ba3cd$var$TABINDEX_STATE)) element.setAttribute($336882a0c45ba3cd$var$TABINDEX_STATE, element.getAttribute($336882a0c45ba3cd$var$TABINDEX));
            element.setAttribute($336882a0c45ba3cd$var$TABINDEX, -1);
        });
        // then, if any element is inherently focusable and not handled above,
        // give it a tabIndex of -1 so it can't receive focus
        Array.prototype.filter.call(elements || [], function(element) {
            var currentTag = element.tagName.toLowerCase();
            return currentTag.match($336882a0c45ba3cd$var$autoFocusingTags) && element.focus && element.getAttribute($336882a0c45ba3cd$var$TABINDEX_STATE) === null;
        }).forEach(function(element) {
            element.setAttribute($336882a0c45ba3cd$var$TABINDEX_STATE, 'none');
            element.setAttribute($336882a0c45ba3cd$var$TABINDEX, -1);
        });
    }
};
var $336882a0c45ba3cd$var$_findVisibleParent = $336882a0c45ba3cd$export$4fe2c44731a76aa0 = function findVisibleParent(element) {
    if (element) // Get the closest ancestor element that is positioned.
    return element.offsetParent ? element : $336882a0c45ba3cd$var$_findVisibleParent(element.parentElement) || element;
    return undefined;
};
var $336882a0c45ba3cd$var$isNodeAfterScroll = $336882a0c45ba3cd$export$27af05f039e10378 = function isNodeAfterScroll(node, target) {
    var _node$getBoundingClie = node.getBoundingClientRect(), bottom = _node$getBoundingClie.bottom;
    // target will be the document from findScrollParent()
    var _ref = target.getBoundingClientRect ? target.getBoundingClientRect() : {
        height: 0,
        top: 0
    }, height = _ref.height, top = _ref.top;
    return bottom >= top + height;
};
var $336882a0c45ba3cd$var$isNodeBeforeScroll = $336882a0c45ba3cd$export$54c9800883215719 = function isNodeBeforeScroll(node, target) {
    var _node$getBoundingClie2 = node.getBoundingClientRect(), top = _node$getBoundingClie2.top;
    // target will be the document from findScrollParent()
    var _ref2 = target.getBoundingClientRect ? target.getBoundingClientRect() : {
        top: 0
    }, targetTop = _ref2.top;
    return top <= targetTop;
};
var $336882a0c45ba3cd$var$_findButtonParent = $336882a0c45ba3cd$export$37a8984127440e55 = function findButtonParent(element) {
    if (element && element.nodeName !== 'BUTTON' && element.nodeName !== 'A') return $336882a0c45ba3cd$var$_findButtonParent(element.parentElement);
    return element;
};


Object.keys($336882a0c45ba3cd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4113023f9e0bafa0$exports && $4113023f9e0bafa0$exports[key] === $336882a0c45ba3cd$exports[key]) return;
    $4113023f9e0bafa0$exports[key] = $336882a0c45ba3cd$exports[key];
});
var $f11a929500e32dbd$exports = {};

$parcel$export($f11a929500e32dbd$exports, "__esModule", function () { return $f11a929500e32dbd$export$1e511d4a378977f5; }, function (v) { return $f11a929500e32dbd$export$1e511d4a378977f5 = v; });
$parcel$export($f11a929500e32dbd$exports, "wedgeCommands", function () { return $f11a929500e32dbd$export$9928994028c6cb9b; }, function (v) { return $f11a929500e32dbd$export$9928994028c6cb9b = v; });
$parcel$export($f11a929500e32dbd$exports, "translateEndAngle", function () { return $f11a929500e32dbd$export$bd97579b57102dc8; }, function (v) { return $f11a929500e32dbd$export$bd97579b57102dc8 = v; });
$parcel$export($f11a929500e32dbd$exports, "polarToCartesian", function () { return $f11a929500e32dbd$export$5c9a959bb3fc7749; }, function (v) { return $f11a929500e32dbd$export$5c9a959bb3fc7749 = v; });
$parcel$export($f11a929500e32dbd$exports, "lineCommands", function () { return $f11a929500e32dbd$export$3bbb56266409c57; }, function (v) { return $f11a929500e32dbd$export$3bbb56266409c57 = v; });
$parcel$export($f11a929500e32dbd$exports, "calcAngle", function () { return $f11a929500e32dbd$export$11a7b5abbf8340a; }, function (v) { return $f11a929500e32dbd$export$11a7b5abbf8340a = v; });
$parcel$export($f11a929500e32dbd$exports, "baseUnit", function () { return $f11a929500e32dbd$export$4738d597a47e577d; }, function (v) { return $f11a929500e32dbd$export$4738d597a47e577d = v; });
$parcel$export($f11a929500e32dbd$exports, "arcCommands", function () { return $f11a929500e32dbd$export$42585d8f3d81ad44; }, function (v) { return $f11a929500e32dbd$export$42585d8f3d81ad44 = v; });
var $f11a929500e32dbd$export$1e511d4a378977f5;
var $f11a929500e32dbd$export$9928994028c6cb9b;
var $f11a929500e32dbd$export$bd97579b57102dc8;
var $f11a929500e32dbd$export$5c9a959bb3fc7749;
var $f11a929500e32dbd$export$3bbb56266409c57;
var $f11a929500e32dbd$export$11a7b5abbf8340a;
var $f11a929500e32dbd$export$4738d597a47e577d;
var $f11a929500e32dbd$export$42585d8f3d81ad44;
"use strict";
$f11a929500e32dbd$export$1e511d4a378977f5 = true;
$f11a929500e32dbd$export$9928994028c6cb9b = $f11a929500e32dbd$export$bd97579b57102dc8 = $f11a929500e32dbd$export$5c9a959bb3fc7749 = $f11a929500e32dbd$export$3bbb56266409c57 = $f11a929500e32dbd$export$11a7b5abbf8340a = $f11a929500e32dbd$export$4738d597a47e577d = $f11a929500e32dbd$export$42585d8f3d81ad44 = void 0;
var $f11a929500e32dbd$var$POST_DECIMAL_DIGITS = 10;
var $f11a929500e32dbd$var$baseUnit = $f11a929500e32dbd$export$4738d597a47e577d = 24;
var $f11a929500e32dbd$var$polarToCartesian = $f11a929500e32dbd$export$5c9a959bb3fc7749 = function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
    var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
    return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians)
    };
};
var $f11a929500e32dbd$var$intersection = function intersection(line1Point1, line1Point2, line2Point1, line2Point2) {
    var x1 = line1Point1.x, y1 = line1Point1.y;
    var x2 = line1Point2.x, y2 = line1Point2.y;
    var x3 = line2Point1.x, y3 = line2Point1.y;
    var x4 = line2Point2.x, y4 = line2Point2.y;
    // Calculate the denominator
    var denominator = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
    // Check if lines are parallel (denominator is 0)
    if (Math.abs(denominator) < 1e-10) return null; // Lines are parallel or coincident
    // Calculate the intersection point
    var t = ((x1 - x3) * (y3 - y4) - (y1 - y3) * (x3 - x4)) / denominator;
    var u = -((x1 - x2) * (y1 - y3) - (y1 - y2) * (x1 - x3)) / denominator;
    // Calculate intersection coordinates
    var intersectionX = x1 + t * (x2 - x1);
    var intersectionY = y1 + t * (y2 - y1);
    return {
        x: intersectionX,
        y: intersectionY,
        // Optional: check if intersection is within line segments
        withinSegment1: t >= 0 && t <= 1,
        withinSegment2: u >= 0 && u <= 1
    };
};
var $f11a929500e32dbd$var$lineCommands = $f11a929500e32dbd$export$3bbb56266409c57 = function lineCommands(centerX, centerY, radius, angle) {
    var start = $f11a929500e32dbd$var$polarToCartesian(centerX, centerY, radius, angle);
    var d = [
        'M',
        centerX.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS),
        centerY.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS),
        'L',
        start.x.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS),
        start.y.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS)
    ].join(' ');
    return d;
};
var $f11a929500e32dbd$var$arcCommands = $f11a929500e32dbd$export$42585d8f3d81ad44 = function arcCommands(centerX, centerY, radius, startAngle, endAngle) {
    // handle that we can't draw a complete circle
    var normalizedEndAngle = endAngle;
    /* 
   added endAngle - startAngle >= 360 
   for SemiCircle the endAngle will never be greater then startAngle 
   since it starts with a startAngle of 270.
  */ if (endAngle > startAngle && endAngle - startAngle >= 360) normalizedEndAngle = startAngle + 359.99;
    var start = $f11a929500e32dbd$var$polarToCartesian(centerX, centerY, radius, normalizedEndAngle);
    var end = $f11a929500e32dbd$var$polarToCartesian(centerX, centerY, radius, startAngle);
    var arcSweep = normalizedEndAngle - startAngle <= 180 ? '0' : '1';
    var d = [
        'M',
        start.x.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS),
        start.y.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS),
        'A',
        radius.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS),
        radius.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS),
        0,
        arcSweep,
        0,
        end.x.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS),
        end.y.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS)
    ].join(' ');
    return d;
};
var $f11a929500e32dbd$var$calcAngle = $f11a929500e32dbd$export$11a7b5abbf8340a = function calcAngle(radius, angle, midAngle, gap) {
    if (gap === 0) return angle;
    var gapAngleRadians = Math.asin(Math.abs(gap) / radius);
    var gapAngle = gapAngleRadians * 180 / Math.PI;
    return gap > 0 ? Math.min(angle + gapAngle, midAngle) : Math.max(angle - gapAngle, midAngle);
};
var $f11a929500e32dbd$var$gapPoints = function gapPoints(centerX, centerY, outerRadius, innerRadius, angle, midAngle, gap) {
    var outerAngle = $f11a929500e32dbd$var$calcAngle(outerRadius, angle, midAngle, gap);
    var outer = $f11a929500e32dbd$var$polarToCartesian(centerX, centerY, outerRadius, outerAngle);
    var inner;
    if (innerRadius > 0) {
        var innerAngle = $f11a929500e32dbd$var$calcAngle(innerRadius, angle, midAngle, gap);
        inner = $f11a929500e32dbd$var$polarToCartesian(centerX, centerY, innerRadius, innerAngle);
    } else inner = $f11a929500e32dbd$var$polarToCartesian(centerX, centerY, Math.abs(gap), gap < 0 ? angle - 90 : angle + 90);
    return {
        outer: outer,
        inner: inner
    };
};
var $f11a929500e32dbd$var$wedgeCommands = $f11a929500e32dbd$export$9928994028c6cb9b = function wedgeCommands(centerX, centerY, outerRadius, innerRadius, startAngle, endAngle, startGap, endGap, startRound, endRound, startRoundDirection) {
    if (startRoundDirection === void 0) startRoundDirection = 0;
    // handle that we can't draw a complete circle
    var normalizedEndAngle = endAngle;
    /* 
   added endAngle - startAngle >= 360 
   for SemiCircle the endAngle will never be greater then startAngle 
   since it starts with a startAngle of 270.
  */ if (endAngle > startAngle && endAngle - startAngle >= 359.99) normalizedEndAngle = startAngle + 359.99;
    // if we're rounded we need to ajust the start points to
    // account for a bigger cap radius
    // add a little bit extra to start to allow for larger rounded inset cap
    // The extra needed can be calculated by the Pythagorean theorem
    var thickness = outerRadius - innerRadius;
    var extraGap = startRound ? Math.sqrt(Math.pow(thickness / 2 + startGap / 4, 2) - Math.pow(thickness / 2, 2)) : 0;
    // define the angle at the center of the wedge. We can't let the gap
    // go past this angle.
    // calculate the angle span between start and end
    var angleSpan = (endAngle < startAngle ? endAngle + 360 : endAngle) - startAngle;
    var midAngle = startAngle + angleSpan / 2;
    var start = $f11a929500e32dbd$var$gapPoints(centerX, centerY, outerRadius, innerRadius, startAngle, midAngle < startAngle ? midAngle + 360 : midAngle, startGap + extraGap, startRound);
    var end = $f11a929500e32dbd$var$gapPoints(centerX, centerY, outerRadius, innerRadius, normalizedEndAngle, midAngle > endAngle ? midAngle - 360 : midAngle, endGap, endRound);
    var largeAngle = normalizedEndAngle - startAngle > 180;
    var arcSweep = largeAngle ? '1' : '0';
    var innerCapRadius = innerRadius;
    var innerArcSweep = arcSweep;
    var middle;
    if (innerRadius <= 0) {
        // we're doing a pie wedge
        innerArcSweep = arcSweep === '0' ? '1' : '0';
        if (largeAngle) // for a large pie wedge it has an inner corner rather
        // than a point. We need to round the inner corner
        innerCapRadius = startGap || endGap || 0;
        else // for a small pie wedge we'll make a point in the center
        middle = $f11a929500e32dbd$var$intersection(start.outer, start.inner, end.outer, end.inner);
    }
    var capRadius = (outerRadius - innerRadius) / 2;
    var startCapRadius = capRadius + (startRoundDirection === 0 ? startGap / 2 : 0);
    var startPoint = middle || start.inner;
    var endPoint = middle || end.inner;
    var startCap = startRound ? [
        'A',
        startCapRadius.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS),
        startCapRadius.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS),
        0,
        0,
        startRoundDirection,
        start.outer.x.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS),
        start.outer.y.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS)
    ] : [
        'L',
        start.outer.x.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS),
        start.outer.y.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS)
    ];
    var endCap = endRound ? [
        'A',
        capRadius.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS),
        capRadius.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS),
        0,
        0,
        1,
        endPoint.x.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS),
        endPoint.y.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS)
    ] : [
        'L',
        endPoint.x.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS),
        endPoint.y.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS)
    ];
    var d = [
        'M',
        startPoint.x.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS),
        startPoint.y.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS)
    ].concat(startCap, [
        'A',
        outerRadius.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS),
        outerRadius.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS),
        0,
        arcSweep,
        1,
        end.outer.x.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS),
        end.outer.y.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS)
    ], endCap);
    if (innerRadius > 0 || largeAngle) // for a donut or a large pie wedge, draw the inner arc
    d.push('A', innerCapRadius.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS), innerCapRadius.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS), 0, innerArcSweep, 0, start.inner.x.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS), start.inner.y.toFixed($f11a929500e32dbd$var$POST_DECIMAL_DIGITS), 'Z' // close the path
    );
    return d.join(' ');
};
/* TranslatedEngAngle will now take the value of the
startAngle + anglePer * value and mod by 360. This was added
to take account the startAngle not being 0. So no matter the
value it will be % 360 to get the correct angle. 
*/ var $f11a929500e32dbd$var$translateEndAngle = $f11a929500e32dbd$export$bd97579b57102dc8 = function translateEndAngle(startAngle, anglePer, value) {
    return Math.max(0, startAngle + anglePer * value) % 360;
};


Object.keys($f11a929500e32dbd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4113023f9e0bafa0$exports && $4113023f9e0bafa0$exports[key] === $f11a929500e32dbd$exports[key]) return;
    $4113023f9e0bafa0$exports[key] = $f11a929500e32dbd$exports[key];
});
var $f20b137c7db25109$exports = {};

$parcel$export($f20b137c7db25109$exports, "__esModule", function () { return $f20b137c7db25109$export$1e511d4a378977f5; }, function (v) { return $f20b137c7db25109$export$1e511d4a378977f5 = v; });
$parcel$export($f20b137c7db25109$exports, "useSizedIcon", function () { return $f20b137c7db25109$export$a123f939253731a8; }, function (v) { return $f20b137c7db25109$export$a123f939253731a8 = v; });
var $f20b137c7db25109$export$1e511d4a378977f5;
var $f20b137c7db25109$export$a123f939253731a8;
"use strict";
$f20b137c7db25109$export$1e511d4a378977f5 = true;
$f20b137c7db25109$export$a123f939253731a8 = void 0;

var $2xPiy = parcelRequire("2xPiy");
var $f20b137c7db25109$var$useSizedIcon = $f20b137c7db25109$export$a123f939253731a8 = function useSizedIcon(icon, size, theme) {
    var _theme$icon;
    return icon && theme != null && (_theme$icon = theme.icon) != null && _theme$icon.matchSize && !icon.props.size ? /*#__PURE__*/ (0, $2xPiy.cloneElement)(icon, {
        size: size
    }) : icon;
};


Object.keys($f20b137c7db25109$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4113023f9e0bafa0$exports && $4113023f9e0bafa0$exports[key] === $f20b137c7db25109$exports[key]) return;
    $4113023f9e0bafa0$exports[key] = $f20b137c7db25109$exports[key];
});
var $9a7099e779e83517$exports = {};

$parcel$export($9a7099e779e83517$exports, "__esModule", function () { return $9a7099e779e83517$export$1e511d4a378977f5; }, function (v) { return $9a7099e779e83517$export$1e511d4a378977f5 = v; });
$parcel$export($9a7099e779e83517$exports, "widthStyle", function () { return $9a7099e779e83517$export$c12f8e3e33f3bef7; }, function (v) { return $9a7099e779e83517$export$c12f8e3e33f3bef7 = v; });
$parcel$export($9a7099e779e83517$exports, "unfocusStyle", function () { return $9a7099e779e83517$export$525440aaa2c64805; }, function (v) { return $9a7099e779e83517$export$525440aaa2c64805 = v; });
$parcel$export($9a7099e779e83517$exports, "textAlignStyle", function () { return $9a7099e779e83517$export$4fc8e4871b69e1d6; }, function (v) { return $9a7099e779e83517$export$4fc8e4871b69e1d6 = v; });
$parcel$export($9a7099e779e83517$exports, "styledComponentsConfig", function () { return $9a7099e779e83517$export$373e75d802fd707; }, function (v) { return $9a7099e779e83517$export$373e75d802fd707 = v; });
$parcel$export($9a7099e779e83517$exports, "sizeStyle", function () { return $9a7099e779e83517$export$cb60038e9cf9f581; }, function (v) { return $9a7099e779e83517$export$cb60038e9cf9f581 = v; });
$parcel$export($9a7099e779e83517$exports, "roundStyle", function () { return $9a7099e779e83517$export$98483643daf52539; }, function (v) { return $9a7099e779e83517$export$98483643daf52539 = v; });
$parcel$export($9a7099e779e83517$exports, "plainInputStyle", function () { return $9a7099e779e83517$export$f9510e7ca63c26e5; }, function (v) { return $9a7099e779e83517$export$f9510e7ca63c26e5 = v; });
$parcel$export($9a7099e779e83517$exports, "overflowStyle", function () { return $9a7099e779e83517$export$5938e7adc3ab8d08; }, function (v) { return $9a7099e779e83517$export$5938e7adc3ab8d08 = v; });
$parcel$export($9a7099e779e83517$exports, "kindPartStyles", function () { return $9a7099e779e83517$export$73d7bd5e5b0271ce; }, function (v) { return $9a7099e779e83517$export$73d7bd5e5b0271ce = v; });
$parcel$export($9a7099e779e83517$exports, "inputStyle", function () { return $9a7099e779e83517$export$533edcdef9a0af13; }, function (v) { return $9a7099e779e83517$export$533edcdef9a0af13 = v; });
$parcel$export($9a7099e779e83517$exports, "inputPadForIcon", function () { return $9a7099e779e83517$export$cd595fd57f72dbc4; }, function (v) { return $9a7099e779e83517$export$cd595fd57f72dbc4 = v; });
$parcel$export($9a7099e779e83517$exports, "heightStyle", function () { return $9a7099e779e83517$export$9f8046d1e2885811; }, function (v) { return $9a7099e779e83517$export$9f8046d1e2885811 = v; });
$parcel$export($9a7099e779e83517$exports, "getInputPadBySide", function () { return $9a7099e779e83517$export$c98305b6d8dc560; }, function (v) { return $9a7099e779e83517$export$c98305b6d8dc560 = v; });
$parcel$export($9a7099e779e83517$exports, "genericStyles", function () { return $9a7099e779e83517$export$a157b298d219a801; }, function (v) { return $9a7099e779e83517$export$a157b298d219a801 = v; });
$parcel$export($9a7099e779e83517$exports, "focusStyle", function () { return $9a7099e779e83517$export$efbff472cb39d8b; }, function (v) { return $9a7099e779e83517$export$efbff472cb39d8b = v; });
$parcel$export($9a7099e779e83517$exports, "fillStyle", function () { return $9a7099e779e83517$export$7d12e60b29024244; }, function (v) { return $9a7099e779e83517$export$7d12e60b29024244 = v; });
$parcel$export($9a7099e779e83517$exports, "elevationStyle", function () { return $9a7099e779e83517$export$b4ff7c828301ce9f; }, function (v) { return $9a7099e779e83517$export$b4ff7c828301ce9f = v; });
$parcel$export($9a7099e779e83517$exports, "edgeStyle", function () { return $9a7099e779e83517$export$944a9710f9445eee; }, function (v) { return $9a7099e779e83517$export$944a9710f9445eee = v; });
$parcel$export($9a7099e779e83517$exports, "disabledStyle", function () { return $9a7099e779e83517$export$adf3fcef8e5e1347; }, function (v) { return $9a7099e779e83517$export$adf3fcef8e5e1347 = v; });
$parcel$export($9a7099e779e83517$exports, "controlBorderStyle", function () { return $9a7099e779e83517$export$717407de81592eca; }, function (v) { return $9a7099e779e83517$export$717407de81592eca = v; });
$parcel$export($9a7099e779e83517$exports, "baseStyle", function () { return $9a7099e779e83517$export$360b744af11007ac; }, function (v) { return $9a7099e779e83517$export$360b744af11007ac = v; });
$parcel$export($9a7099e779e83517$exports, "alignStyle", function () { return $9a7099e779e83517$export$f530b7ab00e4c68d; }, function (v) { return $9a7099e779e83517$export$f530b7ab00e4c68d = v; });
$parcel$export($9a7099e779e83517$exports, "alignContentStyle", function () { return $9a7099e779e83517$export$93b5fb4351939c1c; }, function (v) { return $9a7099e779e83517$export$93b5fb4351939c1c = v; });
var $9a7099e779e83517$export$1e511d4a378977f5;
var $9a7099e779e83517$export$c12f8e3e33f3bef7;
var $9a7099e779e83517$export$525440aaa2c64805;
var $9a7099e779e83517$export$4fc8e4871b69e1d6;
var $9a7099e779e83517$export$373e75d802fd707;
var $9a7099e779e83517$export$cb60038e9cf9f581;
var $9a7099e779e83517$export$98483643daf52539;
var $9a7099e779e83517$export$f9510e7ca63c26e5;
var $9a7099e779e83517$export$5938e7adc3ab8d08;
var $9a7099e779e83517$export$73d7bd5e5b0271ce;
var $9a7099e779e83517$export$533edcdef9a0af13;
var $9a7099e779e83517$export$cd595fd57f72dbc4;
var $9a7099e779e83517$export$9f8046d1e2885811;
var $9a7099e779e83517$export$c98305b6d8dc560;
var $9a7099e779e83517$export$a157b298d219a801;
var $9a7099e779e83517$export$efbff472cb39d8b;
var $9a7099e779e83517$export$7d12e60b29024244;
var $9a7099e779e83517$export$b4ff7c828301ce9f;
var $9a7099e779e83517$export$944a9710f9445eee;
var $9a7099e779e83517$export$adf3fcef8e5e1347;
var $9a7099e779e83517$export$717407de81592eca;
var $9a7099e779e83517$export$360b744af11007ac;
var $9a7099e779e83517$export$f530b7ab00e4c68d;
var $9a7099e779e83517$export$93b5fb4351939c1c;
"use strict";
$9a7099e779e83517$export$1e511d4a378977f5 = true;
$9a7099e779e83517$export$c12f8e3e33f3bef7 = $9a7099e779e83517$export$525440aaa2c64805 = $9a7099e779e83517$export$4fc8e4871b69e1d6 = $9a7099e779e83517$export$373e75d802fd707 = $9a7099e779e83517$export$cb60038e9cf9f581 = $9a7099e779e83517$export$98483643daf52539 = $9a7099e779e83517$export$f9510e7ca63c26e5 = $9a7099e779e83517$export$5938e7adc3ab8d08 = $9a7099e779e83517$export$73d7bd5e5b0271ce = $9a7099e779e83517$export$533edcdef9a0af13 = $9a7099e779e83517$export$cd595fd57f72dbc4 = $9a7099e779e83517$export$9f8046d1e2885811 = $9a7099e779e83517$export$c98305b6d8dc560 = $9a7099e779e83517$export$a157b298d219a801 = $9a7099e779e83517$export$efbff472cb39d8b = $9a7099e779e83517$export$7d12e60b29024244 = $9a7099e779e83517$export$b4ff7c828301ce9f = $9a7099e779e83517$export$944a9710f9445eee = $9a7099e779e83517$export$adf3fcef8e5e1347 = $9a7099e779e83517$export$717407de81592eca = $9a7099e779e83517$export$360b744af11007ac = $9a7099e779e83517$export$f530b7ab00e4c68d = $9a7099e779e83517$export$93b5fb4351939c1c = void 0;

var $iA1nz = parcelRequire("iA1nz");

var $9a7099e779e83517$var$_isPropValid = $9a7099e779e83517$var$_interopRequireDefault((parcelRequire("8Fliv")));


var $80783f9dd7b08ab9$exports = {};

$parcel$export($80783f9dd7b08ab9$exports, "__esModule", function () { return $80783f9dd7b08ab9$export$1e511d4a378977f5; }, function (v) { return $80783f9dd7b08ab9$export$1e511d4a378977f5 = v; });
$parcel$export($80783f9dd7b08ab9$exports, "supportsContainerQueries", function () { return $80783f9dd7b08ab9$export$6fa2a3092624a8f5; }, function (v) { return $80783f9dd7b08ab9$export$6fa2a3092624a8f5 = v; });
$parcel$export($80783f9dd7b08ab9$exports, "isSmall", function () { return $80783f9dd7b08ab9$export$813595e92b2e7a6f; }, function (v) { return $80783f9dd7b08ab9$export$813595e92b2e7a6f = v; });
$parcel$export($80783f9dd7b08ab9$exports, "getDeviceBreakpoint", function () { return $80783f9dd7b08ab9$export$4244a62ea87934e9; }, function (v) { return $80783f9dd7b08ab9$export$4244a62ea87934e9 = v; });
$parcel$export($80783f9dd7b08ab9$exports, "getBreakpointStyle", function () { return $80783f9dd7b08ab9$export$56780e7bbaff61f9; }, function (v) { return $80783f9dd7b08ab9$export$56780e7bbaff61f9 = v; });
$parcel$export($80783f9dd7b08ab9$exports, "getBreakpoint", function () { return $80783f9dd7b08ab9$export$1eb095b00b926404; }, function (v) { return $80783f9dd7b08ab9$export$1eb095b00b926404 = v; });
$parcel$export($80783f9dd7b08ab9$exports, "deviceResponsive", function () { return $80783f9dd7b08ab9$export$f207ad4bd0549009; }, function (v) { return $80783f9dd7b08ab9$export$f207ad4bd0549009 = v; });
var $80783f9dd7b08ab9$export$1e511d4a378977f5;
var $80783f9dd7b08ab9$export$6fa2a3092624a8f5;
var $80783f9dd7b08ab9$export$813595e92b2e7a6f;
var $80783f9dd7b08ab9$export$4244a62ea87934e9;
var $80783f9dd7b08ab9$export$56780e7bbaff61f9;
var $80783f9dd7b08ab9$export$1eb095b00b926404;
var $80783f9dd7b08ab9$export$f207ad4bd0549009;
"use strict";
$80783f9dd7b08ab9$export$1e511d4a378977f5 = true;
$80783f9dd7b08ab9$export$6fa2a3092624a8f5 = $80783f9dd7b08ab9$export$813595e92b2e7a6f = $80783f9dd7b08ab9$export$4244a62ea87934e9 = $80783f9dd7b08ab9$export$56780e7bbaff61f9 = $80783f9dd7b08ab9$export$1eb095b00b926404 = $80783f9dd7b08ab9$export$f207ad4bd0549009 = void 0;

var $80783f9dd7b08ab9$var$_styledComponents = $80783f9dd7b08ab9$var$_interopRequireDefault((parcelRequire("iA1nz")));
function $80783f9dd7b08ab9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $80783f9dd7b08ab9$var$getBreakpoint = $80783f9dd7b08ab9$export$1eb095b00b926404 = function getBreakpoint(viewportWidth, theme) {
    var sortedBreakpoints = Object.keys(theme.global.breakpoints).sort(function(a, b) {
        var first = theme.global.breakpoints[a];
        var second = theme.global.breakpoints[b];
        if (!first) return 1;
        if (!second) return -1;
        if (!first.value) return 1;
        if (!second.value) return -1;
        return first.value - second.value;
    });
    // the last breakpoint on the sorted array should have
    // no windowWidth boundaries
    var lastBreakpoint = sortedBreakpoints[sortedBreakpoints.length - 1];
    var result = sortedBreakpoints.find(function(name) {
        var breakpoint = theme.global.breakpoints[name];
        return !breakpoint.value || breakpoint.value >= viewportWidth ? name : false;
    });
    return result || lastBreakpoint;
};
var $80783f9dd7b08ab9$var$getDeviceBreakpoint = $80783f9dd7b08ab9$export$4244a62ea87934e9 = function getDeviceBreakpoint(type, theme) {
    return theme.global.deviceBreakpoints[type];
};
var $80783f9dd7b08ab9$var$getBreakpointStyle = $80783f9dd7b08ab9$export$56780e7bbaff61f9 = function getBreakpointStyle(theme, breakpointSize) {
    var breakpoint = breakpointSize && theme.global.breakpoints[breakpointSize] || {};
    if (!breakpoint.edgeSize) breakpoint.edgeSize = theme.global.edgeSize;
    if (!breakpoint.borderSize) breakpoint.borderSize = theme.global.borderSize;
    if (!breakpoint.radius) breakpoint.radius = theme.global.radius;
    if (!breakpoint.size) breakpoint.size = theme.global.size;
    return breakpoint;
};
// for checks that look for a small screen size, flag for xsmall
// as well since we use xsmall in the hpe theme
var $80783f9dd7b08ab9$var$isSmall = $80783f9dd7b08ab9$export$813595e92b2e7a6f = function isSmall(size) {
    return [
        'xsmall',
        'small'
    ].includes(size);
};
var $80783f9dd7b08ab9$var$deviceResponsive = $80783f9dd7b08ab9$export$f207ad4bd0549009 = function deviceResponsive(userAgent, theme) {
    // log('--deviceResponsive', userAgent, theme);
    /*
   * Regexes provided for mobile and tablet detection are meant to replace
   * a full-featured specific library due to contributing a considerable size
   * into the bundle.
   *
   * User agents found https://deviceatlas.com/blog/list-of-user-agent-strings
   */ if (userAgent) {
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobile))/i.test(userAgent)) return $80783f9dd7b08ab9$var$getDeviceBreakpoint('tablet', theme);
        if (/Mobile|iPhone|Android/.test(userAgent)) return $80783f9dd7b08ab9$var$getDeviceBreakpoint('phone', theme);
        return $80783f9dd7b08ab9$var$getDeviceBreakpoint('computer', theme);
    }
    return undefined;
};
// styled-components v6 and later do not have a withComponent
// method. We need v6 or later to support container queries.
var $80783f9dd7b08ab9$var$testComp = $80783f9dd7b08ab9$var$_styledComponents["default"].div.withConfig({
    displayName: "responsive__testComp",
    componentId: "sc-336m7y-0"
})([
    "display:flex;"
]);
var $80783f9dd7b08ab9$var$supportsContainerQueries = $80783f9dd7b08ab9$export$6fa2a3092624a8f5 = function supportsContainerQueries() {
    var isPreV6 = typeof $80783f9dd7b08ab9$var$testComp.withComponent === 'function';
    return !isPreV6;
};



function $9a7099e779e83517$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
// ensure only valid DOM attributes are forwarded onto DOM
var $9a7099e779e83517$var$styledComponentsConfig = $9a7099e779e83517$export$373e75d802fd707 = {
    shouldForwardProp: $9a7099e779e83517$var$_isPropValid["default"]
};
var $9a7099e779e83517$var$baseStyle = $9a7099e779e83517$export$360b744af11007ac = (0, $iA1nz.css)([
    "font-family:",
    ";font-size:",
    ";line-height:",
    ";font-weight:",
    ";",
    " ",
    " box-sizing:border-box;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;"
], function(props) {
    return props.theme.global.font.family;
}, function(props) {
    return props.theme.global.font.size;
}, function(props) {
    return props.theme.global.font.height;
}, function(props) {
    return props.theme.global.font.weight;
}, function(props) {
    return props.theme.global.font.variant && "\n    font-variant:" + props.theme.global.font.variant + ";\n  ";
}, function(props) {
    return !props.plain && (0, $cdcfbcf0f8cd48ba$export$e43a4f0de05cb7e9)(props.theme.baseBackground, props.theme);
});
var $9a7099e779e83517$var$controlBorderStyle = $9a7099e779e83517$export$717407de81592eca = (0, $iA1nz.css)([
    "border:",
    " solid ",
    ";border-radius:",
    ";"
], function(props) {
    return props.theme.global.control.border.width;
}, function(props) {
    return (0, $62e050f1cfc78056$export$4cde5df63f53f473)(props.theme.global.control.border.color || 'border', props.theme);
}, function(props) {
    return props.theme.global.control.border.radius;
});
var $9a7099e779e83517$var$edgeStyle = $9a7099e779e83517$export$944a9710f9445eee = function edgeStyle(kind, data, responsive, responsiveBreakpoint, theme) {
    var breakpoint = (0, $80783f9dd7b08ab9$export$56780e7bbaff61f9)(theme, responsiveBreakpoint);
    if (typeof data === 'string') {
        var value = theme.global.edgeSize[data] || data;
        var responsiveValue = responsive && breakpoint && breakpoint.edgeSize[data];
        return (0, $iA1nz.css)([
            "",
            ":",
            ";",
            ";"
        ], kind, value, responsiveValue ? (0, $d65b270127c3c07e$export$2180d12f0a299a89)(breakpoint, "\n        " + kind + ": " + responsiveValue + ";\n      ", responsive) : '');
    }
    var result = [];
    var horizontal = data.horizontal, vertical = data.vertical, top = data.top, bottom = data.bottom, left = data.left, right = data.right;
    // if horizontal and vertical are equal OR all sides are equal,
    // we can just return a single css value such as padding: 12px
    // instead of breaking out by sides.
    var horizontalVerticalEqual = horizontal && vertical && horizontal === vertical;
    var allSidesEqual = top && bottom && left && right && top === bottom === left === right;
    if (horizontalVerticalEqual || allSidesEqual) {
        // since the values will be the same between vertical & horizontal OR
        // left, right, top, & bottom, we can just choose one
        var allSidesValue = horizontalVerticalEqual ? horizontal : top;
        var allSidesResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[allSidesValue];
        return (0, $iA1nz.css)([
            "",
            ":",
            ";",
            ";"
        ], kind, theme.global.edgeSize[allSidesValue] || allSidesValue, allSidesResponsiveValue ? (0, $d65b270127c3c07e$export$2180d12f0a299a89)(breakpoint, "\n        " + kind + ": " + allSidesResponsiveValue + ";\n      ", responsive) : '');
    }
    if (horizontal) {
        var horizontalResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[horizontal];
        result.push((0, $iA1nz.css)([
            "",
            "-left:",
            ";",
            "-right:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[horizontal] || horizontal, kind, theme.global.edgeSize[horizontal] || horizontal, horizontalResponsiveValue ? (0, $d65b270127c3c07e$export$2180d12f0a299a89)(breakpoint, "\n          " + kind + "-left: " + horizontalResponsiveValue + ";\n          " + kind + "-right: " + horizontalResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (vertical) {
        var verticalResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[vertical];
        result.push((0, $iA1nz.css)([
            "",
            "-top:",
            ";",
            "-bottom:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[vertical] || vertical, kind, theme.global.edgeSize[vertical] || vertical, verticalResponsiveValue ? (0, $d65b270127c3c07e$export$2180d12f0a299a89)(breakpoint, "\n          " + kind + "-top: " + verticalResponsiveValue + ";\n          " + kind + "-bottom: " + verticalResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (top) {
        var topResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[top];
        result.push((0, $iA1nz.css)([
            "",
            "-top:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[top] || top, topResponsiveValue ? (0, $d65b270127c3c07e$export$2180d12f0a299a89)(breakpoint, "\n          " + kind + "-top: " + topResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (bottom) {
        var bottomResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[bottom];
        result.push((0, $iA1nz.css)([
            "",
            "-bottom:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[bottom] || bottom, bottomResponsiveValue ? (0, $d65b270127c3c07e$export$2180d12f0a299a89)(breakpoint, "\n          " + kind + "-bottom: " + bottomResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (left) {
        var leftResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[left];
        result.push((0, $iA1nz.css)([
            "",
            "-left:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[left] || left, leftResponsiveValue ? (0, $d65b270127c3c07e$export$2180d12f0a299a89)(breakpoint, "\n          " + kind + "-left: " + leftResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (right) {
        var rightResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[right];
        result.push((0, $iA1nz.css)([
            "",
            "-right:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[right] || right, rightResponsiveValue ? (0, $d65b270127c3c07e$export$2180d12f0a299a89)(breakpoint, "\n          " + kind + "-right: " + rightResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (data.start) {
        var startResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[data.start];
        result.push((0, $iA1nz.css)([
            "",
            "-inline-start:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[data.start] || data.start, startResponsiveValue ? (0, $d65b270127c3c07e$export$2180d12f0a299a89)(breakpoint, "\n          " + kind + "-inline-start: " + startResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (data.end) {
        var endResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[data.end];
        result.push((0, $iA1nz.css)([
            "",
            "-inline-end:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[data.end] || data.end, endResponsiveValue ? (0, $d65b270127c3c07e$export$2180d12f0a299a89)(breakpoint, "\n          " + kind + "-inline-end: " + endResponsiveValue + ";\n        ", responsive) : ''));
    }
    return result;
};
var $9a7099e779e83517$var$fillStyle = $9a7099e779e83517$export$7d12e60b29024244 = function fillStyle(fillProp) {
    if (fillProp === 'horizontal') return 'width: 100%;';
    if (fillProp === 'vertical') return 'height: 100%;';
    if (fillProp) return "\n      width: 100%;\n      height: 100%;\n    ";
    return undefined;
};
var $9a7099e779e83517$var$focusStyles = function focusStyles(props, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, forceOutline = _ref.forceOutline, justBorder = _ref.justBorder, insetFocus = _ref.inset;
    var generateFocusStyle = function generateFocusStyle(focus) {
        var compoundFocusStyle = '';
        if (!focus || forceOutline && !focus.outline) {
            var color = (0, $62e050f1cfc78056$export$4cde5df63f53f473)('focus', props.theme);
            if (color) return "outline: 2px solid " + color + ";";
            return ''; // native
        }
        if (focus.outline && (!focus.border || !justBorder)) {
            if (typeof focus.outline === 'object') {
                var _color = (0, $62e050f1cfc78056$export$4cde5df63f53f473)(focus.outline.color || 'focus', props.theme);
                var size = focus.outline.size || '2px';
                var offset = focus.outline.offset || '0px';
                var outlineStyle = "\n        outline-offset: " + offset + ";\n        outline: " + size + " solid " + _color + ";\n      ";
                compoundFocusStyle += outlineStyle;
                if (!focus.twoColor) return outlineStyle;
            } else {
                var _outlineStyle = "outline: " + focus.outline + ";";
                compoundFocusStyle += _outlineStyle;
                if (!focus.twoColor) return _outlineStyle;
            }
        }
        if (focus.shadow && (!focus.border || !justBorder)) {
            if (typeof focus.shadow === 'object') {
                var _color2 = (0, $62e050f1cfc78056$export$4cde5df63f53f473)(// If there is a focus.border.color, use that for shadow too.
                // This is for backwards compatibility in v2.
                focus.border && focus.border.color || focus.shadow.color || 'focus', props.theme);
                var _size = focus.shadow.size || '2px'; // backwards compatible default
                var blur = focus.shadow.blur || _size; // backwards compatible default
                var inset = focus.shadow.inset ? 'inset ' : '';
                var shadowStyle = "box-shadow: 0 0 " + blur + " " + _size + " " + _color2 + (inset ? " " + inset : '') + ";";
                compoundFocusStyle += shadowStyle;
                if (!focus.twoColor) return "\n        outline: none;\n      " + shadowStyle;
            } else {
                var _shadowStyle = "box-shadow: " + focus.shadow + ";";
                compoundFocusStyle += _shadowStyle;
                if (!focus.twoColor) return "outline: none; " + _shadowStyle;
            }
        }
        if (focus.border) {
            var _color3 = (0, $62e050f1cfc78056$export$4cde5df63f53f473)(focus.border.color || 'focus', props.theme);
            var borderStyle = "border-color: " + _color3 + ";";
            compoundFocusStyle += borderStyle;
            if (!focus.twoColor) return "outline: none; " + borderStyle;
        }
        if (focus.twoColor && compoundFocusStyle.length) return compoundFocusStyle;
        return ''; // defensive
    };
    if (insetFocus && props.theme.global.focus.inset) return generateFocusStyle(props.theme.global.focus.inset);
    return generateFocusStyle(props.theme.global.focus);
};
var $9a7099e779e83517$var$unfocusStyles = function unfocusStyles(props, _temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2, forceOutline = _ref2.forceOutline, justBorder = _ref2.justBorder;
    var focus = props.theme.global.focus;
    var compoundFocusStyle = '';
    if (!focus || forceOutline && !focus.outline) {
        var color = (0, $62e050f1cfc78056$export$4cde5df63f53f473)('focus', props.theme);
        if (color) return "outline: none;";
        return ''; // native
    }
    if (focus.outline && (!focus.border || !justBorder)) {
        if (typeof focus.outline === 'object') {
            var outlineStyle = "\n        outline-offset: 0px;\n        outline: none;\n      ";
            compoundFocusStyle += outlineStyle;
            if (!focus.twoColor) return "\n        outline-offset: 0px;\n        outline: none;\n      ";
        } else {
            var _outlineStyle2 = "outline: none;";
            compoundFocusStyle += _outlineStyle2;
            if (!focus.twoColor) return _outlineStyle2;
        }
    }
    if (focus.shadow && (!focus.border || !justBorder)) {
        if (typeof focus.shadow === 'object') {
            var shadowStyle = "\n        outline: none;\n        box-shadow: none;\n      ";
            compoundFocusStyle += shadowStyle;
            if (!focus.twoColor) return shadowStyle;
        } else {
            var _shadowStyle2 = "\n        outline: none;\n        box-shadow: none;\n      ";
            compoundFocusStyle += _shadowStyle2;
            if (!focus.twoColor) return _shadowStyle2;
        }
    }
    if (focus.border) {
        var borderStyle = "\n      outline: none;\n      border-color: none;\n    ";
        compoundFocusStyle += borderStyle;
        if (!focus.twoColor) return borderStyle;
    }
    if (focus.twoColor && compoundFocusStyle.length) return compoundFocusStyle;
    return ''; // defensive
};
// focus also supports clickable elements inside svg
var $9a7099e779e83517$var$focusStyle = $9a7099e779e83517$export$efbff472cb39d8b = function focusStyle(_temp3) {
    var _ref3 = _temp3 === void 0 ? {} : _temp3, forceOutline = _ref3.forceOutline, inset = _ref3.inset, justBorder = _ref3.justBorder, skipSvgChildren = _ref3.skipSvgChildren;
    return (0, $iA1nz.css)([
        "",
        " ",
        " ",
        ""
    ], function(props) {
        return !skipSvgChildren && "\n  > circle,\n  > ellipse,\n  > line,\n  > path,\n  > polygon,\n  > polyline,\n  > rect {\n    " + $9a7099e779e83517$var$focusStyles(props) + "\n  }";
    }, function(props) {
        return $9a7099e779e83517$var$focusStyles(props, {
            forceOutline: forceOutline,
            inset: inset,
            justBorder: justBorder
        });
    }, !forceOutline && "\n  ::-moz-focus-inner {\n    border: 0;\n  }\n  ");
};
// This is placed next to focusStyle for easy maintainability
// of code since changes to focusStyle should be reflected in
// unfocusStyle as well.
// this function can be used to reset focus styles which is
// applicable when turning the focus ring off when using the mouse
// see https://nelo.is/writing/styling-better-focus-states/
var $9a7099e779e83517$var$unfocusStyle = $9a7099e779e83517$export$525440aaa2c64805 = function unfocusStyle(_temp4) {
    var _ref4 = _temp4 === void 0 ? {} : _temp4, forceOutline = _ref4.forceOutline, justBorder = _ref4.justBorder, skipSvgChildren = _ref4.skipSvgChildren;
    return (0, $iA1nz.css)([
        "",
        " ",
        " ",
        ""
    ], function(props) {
        return !skipSvgChildren && "\n  > circle,\n  > ellipse,\n  > line,\n  > path,\n  > polygon,\n  > polyline,\n  > rect {\n    " + $9a7099e779e83517$var$unfocusStyles(props) + "\n  }";
    }, function(props) {
        return $9a7099e779e83517$var$unfocusStyles(props, {
            forceOutline: forceOutline,
            justBorder: justBorder
        });
    }, !forceOutline && "\n  ::-moz-focus-inner {\n    border: 0;\n  }\n  ");
};
// For backwards compatibility we need to add back the control border width.
// Based on how grommet was functioning prior to https://github.com/grommet/grommet/pull/3939,
// the padding was subtracting the border width from the theme value, but the
// placeholder was not. Because we're now placing the subtraction into the
// theme itself, we have to add back in the border width here.
// This is used for placeholder/icon in TextInput and MaskedInput.
var $9a7099e779e83517$var$adjustPad = function adjustPad(props, value) {
    return (0, $d65b270127c3c07e$export$333c2219d71d27ce)((props.theme.global.edgeSize[value] || value) + "px") + (0, $d65b270127c3c07e$export$333c2219d71d27ce)(props.theme.global.control.border.width + "px") + "px";
};
var $9a7099e779e83517$var$getInputPadBySide = $9a7099e779e83517$export$c98305b6d8dc560 = function getInputPadBySide(props, side) {
    if (typeof props.theme.global.input.padding !== 'object') {
        var _adjustedPad = $9a7099e779e83517$var$adjustPad(props, props.theme.global.input.padding);
        return _adjustedPad;
    }
    var orientation;
    if (side === 'left' || side === 'right') orientation = 'horizontal';
    else if (side === 'top' || side === 'bottom') orientation = 'vertical';
    else orientation = undefined;
    // if individual side isn't available, fallback to the
    // orientation if possible
    var pad = props.theme.global.input.padding[side] || props.theme.global.input.padding[orientation];
    var adjustedPad = $9a7099e779e83517$var$adjustPad(props, pad);
    return adjustedPad;
};
var $9a7099e779e83517$var$placeholderColor = (0, $iA1nz.css)([
    "color:",
    ";"
], function(props) {
    return (0, $62e050f1cfc78056$export$4cde5df63f53f473)(props.theme.global.colors.placeholder, props.theme);
});
var $9a7099e779e83517$var$placeholderStyle = (0, $iA1nz.css)([
    "&::-webkit-input-placeholder{",
    ";}&::-moz-placeholder{",
    ";}&:-ms-input-placeholder{",
    ";}"
], $9a7099e779e83517$var$placeholderColor, $9a7099e779e83517$var$placeholderColor, $9a7099e779e83517$var$placeholderColor);
var $9a7099e779e83517$var$inputSizeStyle = function inputSizeStyle(props) {
    var data = props.theme.text[props.size];
    if (!data) return (0, $iA1nz.css)([
        "font-size:",
        ";"
    ], props.size);
    return (0, $iA1nz.css)([
        "font-size:",
        ";line-height:",
        ";"
    ], data.size, data.height);
};
var $9a7099e779e83517$var$inputStyle = $9a7099e779e83517$export$533edcdef9a0af13 = (0, $iA1nz.css)([
    "box-sizing:border-box;",
    " font-family:inherit;border:none;-webkit-appearance:none;background:transparent;color:inherit;width:100%;",
    " ",
    " ",
    " margin:0;",
    " &:focus{",
    ";}",
    " ",
    " ::-webkit-search-decoration{-webkit-appearance:none;}&::-moz-focus-inner{border:none;outline:none;}&:-moz-placeholder,&::-moz-placeholder{opacity:1;}",
    ""
], function(props) {
    var _props$theme$text$pro;
    return "font-size: " + (props.theme.global.input.font.size ? ((_props$theme$text$pro = props.theme.text[props.theme.global.input.font.size]) == null ? void 0 : _props$theme$text$pro.size) || props.theme.global.input.font.size : 'inherit') + ";";
}, function(props) {
    return props.theme.global.input.font.height && "line-height: " + props.theme.global.input.font.height + ";";
}, function(props) {
    return props.theme.global.input.padding && typeof props.theme.global.input.padding !== 'object' ? // just the edgeStyle could remain. Currently, this is needed for
    // backwards compatibility since we are placing the calculation in
    // base.js
    "padding: " + ((0, $d65b270127c3c07e$export$333c2219d71d27ce)(props.theme.global.edgeSize[props.theme.global.input.padding] || props.theme.global.input.padding) - (0, $d65b270127c3c07e$export$333c2219d71d27ce)(props.theme.global.control.border.width)) + "px;" : $9a7099e779e83517$var$edgeStyle('padding', props.theme.global.input.padding, props.responsive, props.theme.box.responsiveBreakpoint, props.theme);
}, function(props) {
    return(// for backwards compatibility, check if props.theme.global.input.weight
    (props.theme.global.input.weight || props.theme.global.input.font.weight) && (0, $iA1nz.css)([
        "font-weight:",
        ";"
    ], props.theme.global.input.weight || props.theme.global.input.font.weight));
}, function(props) {
    return props.size && $9a7099e779e83517$var$inputSizeStyle(props);
}, function(props) {
    return (!props.plain || props.focusIndicator) && $9a7099e779e83517$var$focusStyle();
}, $9a7099e779e83517$var$controlBorderStyle, $9a7099e779e83517$var$placeholderStyle, function(props) {
    return props.theme.global.input.extend;
});
// Apply padding on input to create space for icon.
// When theme.icon.matchSize is true, the space for the
// icon should equal the icon dimension + 12px (edgeSize.medium)
// to ensure there is reasonable space between the icon and value or placeholder
var $9a7099e779e83517$var$inputPadForIcon = $9a7099e779e83517$export$cd595fd57f72dbc4 = (0, $iA1nz.css)([
    "",
    ""
], function(props) {
    var _props$theme, _props$theme$icon;
    var pad = (_props$theme = props.theme) != null && (_props$theme = _props$theme.icon) != null && _props$theme.matchSize ? (0, $d65b270127c3c07e$export$333c2219d71d27ce)((_props$theme$icon = props.theme.icon) == null || (_props$theme$icon = _props$theme$icon.size) == null ? void 0 : _props$theme$icon[(props == null ? void 0 : props.size) || 'medium']) + (0, $d65b270127c3c07e$export$333c2219d71d27ce)(props.theme.global.edgeSize.medium) + "px" : props.theme.global.edgeSize.large;
    return props.reverse ? "padding-right: " + pad + ";" : "padding-left: " + pad + ";";
});
var $9a7099e779e83517$var$overflowStyle = $9a7099e779e83517$export$5938e7adc3ab8d08 = function overflowStyle(overflowProp) {
    if (typeof overflowProp === 'string') return (0, $iA1nz.css)([
        "overflow:",
        ";"
    ], overflowProp);
    return (0, $iA1nz.css)([
        "",
        " ",
        ";"
    ], overflowProp.horizontal && "overflow-x: " + overflowProp.horizontal + ";", overflowProp.vertical && "overflow-y: " + overflowProp.vertical + ";");
};
var $9a7099e779e83517$var$ALIGN_SELF_MAP = {
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch',
    baseline: 'baseline'
};
var $9a7099e779e83517$var$genericStyles = $9a7099e779e83517$export$a157b298d219a801 = (0, $iA1nz.css)([
    "",
    " ",
    " ",
    ""
], function(props) {
    return props.alignSelf && "align-self: " + $9a7099e779e83517$var$ALIGN_SELF_MAP[props.alignSelf] + ";";
}, function(props) {
    return props.gridArea && "grid-area: " + props.gridArea + ";";
}, function(props) {
    return props.margin && props.theme.global && $9a7099e779e83517$var$edgeStyle('margin', props.margin, props.responsive, props.theme.global.edgeSize.responsiveBreakpoint, props.theme);
});
var $9a7099e779e83517$var$disabledStyle = $9a7099e779e83517$export$adf3fcef8e5e1347 = function disabledStyle(componentStyle) {
    return (0, $iA1nz.css)([
        "opacity:",
        ";cursor:default;"
    ], function(props) {
        return componentStyle || props.theme.global.control.disabled.opacity;
    });
};
var $9a7099e779e83517$var$sizeStyle = $9a7099e779e83517$export$cb60038e9cf9f581 = function sizeStyle(name, value, theme) {
    return (0, $iA1nz.css)([
        "",
        ":",
        ";"
    ], name, theme.global.size[value] || value);
};
var $9a7099e779e83517$var$plainInputStyle = $9a7099e779e83517$export$f9510e7ca63c26e5 = (0, $iA1nz.css)([
    "outline:none;border:none;"
]);
var $9a7099e779e83517$var$elevationStyle = $9a7099e779e83517$export$b4ff7c828301ce9f = function elevationStyle(elevation) {
    return (0, $iA1nz.css)([
        "box-shadow:",
        ";"
    ], function(props) {
        return props.theme.global.elevation[props.theme.dark ? 'dark' : 'light'][elevation];
    });
};
// CSS for this sub-object in the theme
var $9a7099e779e83517$var$kindPartStyles = $9a7099e779e83517$export$73d7bd5e5b0271ce = function kindPartStyles(obj, theme, colorValue) {
    var styles = [];
    if (obj.padding || obj.pad) {
        // button uses `padding` but other components use Grommet `pad`
        var pad = obj.padding || obj.pad;
        if (pad.vertical || pad.horizontal) styles.push("padding: " + (theme.global.edgeSize[pad.vertical] || pad.vertical || 0) + " " + (theme.global.edgeSize[pad.horizontal] || pad.horizontal || 0) + ";");
        else styles.push("padding: " + (theme.global.edgeSize[pad] || pad || 0) + ";");
    }
    if (obj.background) styles.push((0, $cdcfbcf0f8cd48ba$export$e43a4f0de05cb7e9)(colorValue || obj.background, theme, obj.color || (Object.prototype.hasOwnProperty.call(obj, 'color') && obj.color === undefined ? false : undefined)));
    else if (obj.color) styles.push("color: " + (0, $62e050f1cfc78056$export$4cde5df63f53f473)(obj.color, theme) + ";");
    if (obj.border) {
        if (obj.border.width) styles.push((0, $iA1nz.css)([
            "border-style:solid;border-width:",
            ";"
        ], obj.border.width));
        if (obj.border.color) styles.push((0, $iA1nz.css)([
            "border-color:",
            ";"
        ], (0, $62e050f1cfc78056$export$4cde5df63f53f473)(!obj.background && colorValue || obj.border.color || 'border', theme)));
        if (obj.border.radius) styles.push((0, $iA1nz.css)([
            "border-radius:",
            ";"
        ], obj.border.radius));
    } else if (obj.border === false) styles.push('border: none;');
    if (colorValue && !obj.border && !obj.background) styles.push("color: " + (0, $62e050f1cfc78056$export$4cde5df63f53f473)(colorValue, theme) + ";");
    if (obj.font) {
        if (obj.font.size) styles.push("font-size: " + (theme.text[obj.font.size].size || obj.font.size) + ";");
        if (obj.font.height) styles.push("line-height: " + obj.font.height + ";");
        if (obj.font.weight) styles.push("font-weight: " + obj.font.weight + ";");
    }
    if (obj.opacity) {
        var opacity = obj.opacity === true ? theme.global.opacity.medium : theme.global.opacity[obj.opacity] || obj.opacity;
        styles.push("opacity: " + opacity + ";");
    }
    if (obj.elevation) styles.push($9a7099e779e83517$var$elevationStyle(obj.elevation));
    if (obj.extend) styles.push(obj.extend);
    return styles;
};
var $9a7099e779e83517$var$ROUND_MAP = {
    full: '100%'
};
var $9a7099e779e83517$var$roundStyle = $9a7099e779e83517$export$98483643daf52539 = function roundStyle(data, responsive, theme) {
    var breakpoint = (0, $80783f9dd7b08ab9$export$56780e7bbaff61f9)(theme, theme.box.responsiveBreakpoint);
    // fallback to edgeSize for backwards compatibility
    var radius = theme.global.radius ? 'radius' : 'edgeSize';
    var styles = [];
    if (typeof data === 'object') {
        var _breakpoint$radius;
        var size = $9a7099e779e83517$var$ROUND_MAP[data.size] || theme.global[radius][data.size || 'medium'] || data.size;
        var responsiveSize = responsive && breakpoint && ((_breakpoint$radius = breakpoint[radius]) == null ? void 0 : _breakpoint$radius[data.size]) && (breakpoint[radius][data.size] || data.size);
        if (data.corner === 'top') {
            styles.push((0, $iA1nz.css)([
                "border-top-left-radius:",
                ";border-top-right-radius:",
                ";"
            ], size, size));
            if (responsiveSize) styles.push((0, $d65b270127c3c07e$export$2180d12f0a299a89)(breakpoint, "\n          border-top-left-radius: " + responsiveSize + ";\n          border-top-right-radius: " + responsiveSize + ";\n        ", responsive));
        } else if (data.corner === 'bottom') {
            styles.push((0, $iA1nz.css)([
                "border-bottom-left-radius:",
                ";border-bottom-right-radius:",
                ";"
            ], size, size));
            if (responsiveSize) styles.push((0, $d65b270127c3c07e$export$2180d12f0a299a89)(breakpoint, "\n          border-bottom-left-radius: " + responsiveSize + ";\n          border-bottom-right-radius: " + responsiveSize + ";\n        ", responsive));
        } else if (data.corner === 'left') {
            styles.push((0, $iA1nz.css)([
                "border-top-left-radius:",
                ";border-bottom-left-radius:",
                ";"
            ], size, size));
            if (responsiveSize) styles.push((0, $d65b270127c3c07e$export$2180d12f0a299a89)(breakpoint, "\n          border-top-left-radius: " + responsiveSize + ";\n          border-bottom-left-radius: " + responsiveSize + ";\n        ", responsive));
        } else if (data.corner === 'right') {
            styles.push((0, $iA1nz.css)([
                "border-top-right-radius:",
                ";border-bottom-right-radius:",
                ";"
            ], size, size));
            if (responsiveSize) styles.push((0, $d65b270127c3c07e$export$2180d12f0a299a89)(breakpoint, "\n          border-top-right-radius: " + responsiveSize + ";\n          border-bottom-right-radius: " + responsiveSize + ";\n        ", responsive));
        } else if (data.corner) {
            styles.push((0, $iA1nz.css)([
                "border-",
                "-radius:",
                ";"
            ], data.corner, size));
            if (responsiveSize) styles.push((0, $d65b270127c3c07e$export$2180d12f0a299a89)(breakpoint, "\n          border-" + data.corner + "-radius: " + responsiveSize + ";\n        ", responsive));
        } else {
            styles.push((0, $iA1nz.css)([
                "border-radius:",
                ";"
            ], size));
            if (responsiveSize) styles.push((0, $d65b270127c3c07e$export$2180d12f0a299a89)(breakpoint, "\n          border-radius: " + responsiveSize + ";\n        ", responsive));
        }
    } else {
        var _theme$global$radius, _breakpoint$radius2;
        var _size2 = data === true ? 'medium' : data;
        styles.push((0, $iA1nz.css)([
            "border-radius:",
            ";"
        ], $9a7099e779e83517$var$ROUND_MAP[_size2] || ((_theme$global$radius = theme.global[radius]) == null ? void 0 : _theme$global$radius[_size2]) || _size2));
        var _responsiveSize = responsive && breakpoint && ((_breakpoint$radius2 = breakpoint[radius]) == null ? void 0 : _breakpoint$radius2[_size2]);
        if (_responsiveSize) styles.push((0, $d65b270127c3c07e$export$2180d12f0a299a89)(breakpoint, "\n        border-radius: " + _responsiveSize + ";\n      ", responsive));
    }
    return styles;
};
var $9a7099e779e83517$var$TEXT_ALIGN_MAP = {
    center: 'center',
    end: 'right',
    justify: 'justify',
    start: 'left'
};
var $9a7099e779e83517$var$textAlignStyle = $9a7099e779e83517$export$4fc8e4871b69e1d6 = (0, $iA1nz.css)([
    "text-align:",
    ";"
], function(props) {
    return $9a7099e779e83517$var$TEXT_ALIGN_MAP[props.textAlign];
});
var $9a7099e779e83517$var$ALIGN_ITEMS_MAP = {
    baseline: 'baseline',
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch'
};
var $9a7099e779e83517$var$alignStyle = $9a7099e779e83517$export$f530b7ab00e4c68d = (0, $iA1nz.css)([
    "align-items:",
    ";"
], function(props) {
    var _ALIGN_ITEMS_MAP$prop;
    return (_ALIGN_ITEMS_MAP$prop = $9a7099e779e83517$var$ALIGN_ITEMS_MAP[props.align]) != null ? _ALIGN_ITEMS_MAP$prop : props.align;
});
var $9a7099e779e83517$var$ALIGN_CONTENT_MAP = {
    around: 'space-around',
    baseline: 'baseline',
    between: 'space-between',
    center: 'center',
    evenly: 'space-evenly',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch'
};
var $9a7099e779e83517$var$alignContentStyle = $9a7099e779e83517$export$93b5fb4351939c1c = (0, $iA1nz.css)([
    "align-content:",
    ";"
], function(props) {
    var _ALIGN_CONTENT_MAP$pr;
    return (_ALIGN_CONTENT_MAP$pr = $9a7099e779e83517$var$ALIGN_CONTENT_MAP[props.alignContent]) != null ? _ALIGN_CONTENT_MAP$pr : props.alignContent;
});
var $9a7099e779e83517$var$getSize = function getSize(theme, size) {
    return theme.global.size[size] || size;
};
var $9a7099e779e83517$var$widthObjectStyle = function widthObjectStyle(width, theme) {
    var result = [];
    if (width.max) result.push((0, $iA1nz.css)([
        "max-width:",
        ";"
    ], $9a7099e779e83517$var$getSize(theme, width.max)));
    if (width.min) result.push((0, $iA1nz.css)([
        "min-width:",
        ";"
    ], $9a7099e779e83517$var$getSize(theme, width.min)));
    if (width.width) result.push((0, $iA1nz.css)([
        "width:",
        ";"
    ], $9a7099e779e83517$var$getSize(theme, width.width)));
    return result;
};
var $9a7099e779e83517$var$widthStringStyle = function widthStringStyle(width, theme) {
    return (0, $iA1nz.css)([
        "width:",
        ";"
    ], $9a7099e779e83517$var$getSize(theme, width));
};
var $9a7099e779e83517$var$widthStyle = $9a7099e779e83517$export$c12f8e3e33f3bef7 = function widthStyle(width, theme) {
    return typeof width === 'object' ? $9a7099e779e83517$var$widthObjectStyle(width, theme) : $9a7099e779e83517$var$widthStringStyle(width, theme);
};
var $9a7099e779e83517$var$heightObjectStyle = function heightObjectStyle(height, theme) {
    var result = [];
    if (height.max) result.push((0, $iA1nz.css)([
        "max-height:",
        ";"
    ], $9a7099e779e83517$var$getSize(theme, height.max)));
    if (height.min) result.push((0, $iA1nz.css)([
        "min-height:",
        ";"
    ], $9a7099e779e83517$var$getSize(theme, height.min)));
    // backwards compatibile
    if (height.width) result.push((0, $iA1nz.css)([
        "height:",
        ";"
    ], $9a7099e779e83517$var$getSize(theme, height.height)));
    if (height.height) result.push((0, $iA1nz.css)([
        "height:",
        ";"
    ], $9a7099e779e83517$var$getSize(theme, height.height)));
    return result;
};
var $9a7099e779e83517$var$heightStringStyle = function heightStringStyle(height, theme) {
    return (0, $iA1nz.css)([
        "height:",
        ";"
    ], $9a7099e779e83517$var$getSize(theme, height));
};
var $9a7099e779e83517$var$heightStyle = $9a7099e779e83517$export$9f8046d1e2885811 = function heightStyle(height, theme) {
    return typeof height === 'object' ? $9a7099e779e83517$var$heightObjectStyle(height, theme) : $9a7099e779e83517$var$heightStringStyle(height, theme);
};


Object.keys($9a7099e779e83517$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4113023f9e0bafa0$exports && $4113023f9e0bafa0$exports[key] === $9a7099e779e83517$exports[key]) return;
    $4113023f9e0bafa0$exports[key] = $9a7099e779e83517$exports[key];
});
var $ebafa0e8c9355c24$exports = {};

$parcel$export($ebafa0e8c9355c24$exports, "__esModule", function () { return $ebafa0e8c9355c24$export$1e511d4a378977f5; }, function (v) { return $ebafa0e8c9355c24$export$1e511d4a378977f5 = v; });
$parcel$export($ebafa0e8c9355c24$exports, "removeUndefined", function () { return $ebafa0e8c9355c24$export$c499305a875a8ee9; }, function (v) { return $ebafa0e8c9355c24$export$c499305a875a8ee9 = v; });
$parcel$export($ebafa0e8c9355c24$exports, "isObject", function () { return $ebafa0e8c9355c24$export$a6cdc56e425d0d0a; }, function (v) { return $ebafa0e8c9355c24$export$a6cdc56e425d0d0a = v; });
$parcel$export($ebafa0e8c9355c24$exports, "deepMerge", function () { return $ebafa0e8c9355c24$export$6969335ea1e4e77c; }, function (v) { return $ebafa0e8c9355c24$export$6969335ea1e4e77c = v; });
$parcel$export($ebafa0e8c9355c24$exports, "deepFreeze", function () { return $ebafa0e8c9355c24$export$7e32b29e1cb162e1; }, function (v) { return $ebafa0e8c9355c24$export$7e32b29e1cb162e1 = v; });
var $ebafa0e8c9355c24$export$1e511d4a378977f5;
var $ebafa0e8c9355c24$export$c499305a875a8ee9;
var $ebafa0e8c9355c24$export$a6cdc56e425d0d0a;
var $ebafa0e8c9355c24$export$6969335ea1e4e77c;
var $ebafa0e8c9355c24$export$7e32b29e1cb162e1;
"use strict";
$ebafa0e8c9355c24$export$1e511d4a378977f5 = true;
$ebafa0e8c9355c24$export$c499305a875a8ee9 = $ebafa0e8c9355c24$export$a6cdc56e425d0d0a = $ebafa0e8c9355c24$export$6969335ea1e4e77c = $ebafa0e8c9355c24$export$7e32b29e1cb162e1 = void 0;
function $ebafa0e8c9355c24$var$_extends() {
    return $ebafa0e8c9355c24$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ebafa0e8c9355c24$var$_extends.apply(null, arguments);
}
var $ebafa0e8c9355c24$var$isObject = $ebafa0e8c9355c24$export$a6cdc56e425d0d0a = function isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
};
var $ebafa0e8c9355c24$var$deepFreeze = $ebafa0e8c9355c24$export$7e32b29e1cb162e1 = function deepFreeze(obj) {
    Object.keys(obj).forEach(function(key) {
        return key && $ebafa0e8c9355c24$var$isObject(obj[key]) && Object.freeze(obj[key]);
    });
    return Object.freeze(obj);
};
var $ebafa0e8c9355c24$var$_deepMerge = $ebafa0e8c9355c24$export$6969335ea1e4e77c = function deepMerge(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    // making sure to not change target (immutable)
    var output = $ebafa0e8c9355c24$var$_extends({}, target);
    sources.forEach(function(source) {
        if ($ebafa0e8c9355c24$var$isObject(source)) Object.keys(source).forEach(function(key) {
            if ($ebafa0e8c9355c24$var$isObject(source[key])) {
                if (!output[key]) output[key] = $ebafa0e8c9355c24$var$_extends({}, source[key]);
                else output[key] = $ebafa0e8c9355c24$var$_deepMerge(output[key], source[key]);
            } else output[key] = source[key];
        });
    });
    return output;
};
var $ebafa0e8c9355c24$var$removeUndefined = $ebafa0e8c9355c24$export$c499305a875a8ee9 = function removeUndefined(obj) {
    var result = {};
    Object.keys(obj).forEach(function(key) {
        if (obj[key] !== undefined) result[key] = obj[key];
    });
    return result;
};


Object.keys($ebafa0e8c9355c24$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4113023f9e0bafa0$exports && $4113023f9e0bafa0$exports[key] === $ebafa0e8c9355c24$exports[key]) return;
    $4113023f9e0bafa0$exports[key] = $ebafa0e8c9355c24$exports[key];
});
var $0608bbec2c14e586$exports = {};

$parcel$export($0608bbec2c14e586$exports, "__esModule", function () { return $0608bbec2c14e586$export$1e511d4a378977f5; }, function (v) { return $0608bbec2c14e586$export$1e511d4a378977f5 = v; });
$parcel$export($0608bbec2c14e586$exports, "usePagination", function () { return $0608bbec2c14e586$export$f80c710216eae131; }, function (v) { return $0608bbec2c14e586$export$f80c710216eae131 = v; });
$parcel$export($0608bbec2c14e586$exports, "normalizeShow", function () { return $0608bbec2c14e586$export$4bb2737d7e3380a3; }, function (v) { return $0608bbec2c14e586$export$4bb2737d7e3380a3 = v; });
var $0608bbec2c14e586$export$1e511d4a378977f5;
var $0608bbec2c14e586$export$f80c710216eae131;
var $0608bbec2c14e586$export$4bb2737d7e3380a3;
"use strict";
$0608bbec2c14e586$export$1e511d4a378977f5 = true;
$0608bbec2c14e586$export$f80c710216eae131 = $0608bbec2c14e586$export$4bb2737d7e3380a3 = void 0;

var $2xPiy = parcelRequire("2xPiy");
var $0608bbec2c14e586$var$_excluded = [
    "data",
    "page",
    "step"
];
function $0608bbec2c14e586$var$_extends() {
    return $0608bbec2c14e586$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0608bbec2c14e586$var$_extends.apply(null, arguments);
}
function $0608bbec2c14e586$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $0608bbec2c14e586$var$normalizeShow = $0608bbec2c14e586$export$4bb2737d7e3380a3 = function normalizeShow(showProp, step) {
    var page;
    // by default, show refers to the index of an item,
    // but if using pagination, show can take the form of { page: # },
    // where page refers to the page # to show
    if (typeof showProp === 'number') page = Math.ceil((showProp + 1) / step);
    else if (typeof showProp === 'object' && 'page' in showProp) page = showProp.page;
    return page;
};
var $0608bbec2c14e586$var$usePagination = $0608bbec2c14e586$export$f80c710216eae131 = function usePagination(_ref) {
    var data = _ref.data, page = _ref.page, step = _ref.step, rest = $0608bbec2c14e586$var$_objectWithoutPropertiesLoose(_ref, $0608bbec2c14e586$var$_excluded);
    var totalPages = data ? Math.ceil(data.length / step) : 0;
    var _useState = (0, $2xPiy.useState)(Math.min(page, totalPages) || 1), activePage = _useState[0], setActivePage = _useState[1];
    // ensure activePage is never lower than 1 to ensure that itemsBeginIndex
    // and itemsEndIndex aren't negative
    if (activePage > totalPages && (data == null ? void 0 : data.length) > 0) setActivePage(Math.max(totalPages, 1));
    var itemsBeginIndex = step * (activePage - 1);
    var itemsEndIndex = itemsBeginIndex + step;
    var currentItems = (0, $2xPiy.useMemo)(function() {
        if (Array.isArray(data)) return data.slice(itemsBeginIndex, itemsEndIndex);
        return [];
    }, [
        data,
        itemsBeginIndex,
        itemsEndIndex
    ]);
    var paginationProps = $0608bbec2c14e586$var$_extends({
        numberItems: data && data.length,
        onChange: function onChange(event) {
            return setActivePage(event.page);
        },
        page: activePage,
        step: step
    }, rest);
    return [
        currentItems,
        paginationProps
    ];
};


Object.keys($0608bbec2c14e586$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4113023f9e0bafa0$exports && $4113023f9e0bafa0$exports[key] === $0608bbec2c14e586$exports[key]) return;
    $4113023f9e0bafa0$exports[key] = $0608bbec2c14e586$exports[key];
});
var $0335b0b2857baecd$exports = {};

$parcel$export($0335b0b2857baecd$exports, "__esModule", function () { return $0335b0b2857baecd$export$1e511d4a378977f5; }, function (v) { return $0335b0b2857baecd$export$1e511d4a378977f5 = v; });
$parcel$export($0335b0b2857baecd$exports, "PortalContext", function () { return $0335b0b2857baecd$export$60d741e20e0aa309; }, function (v) { return $0335b0b2857baecd$export$60d741e20e0aa309 = v; });
var $0335b0b2857baecd$export$1e511d4a378977f5;
var $0335b0b2857baecd$export$60d741e20e0aa309;
"use strict";
$0335b0b2857baecd$export$1e511d4a378977f5 = true;
$0335b0b2857baecd$export$60d741e20e0aa309 = void 0;

var $0335b0b2857baecd$var$_react = $0335b0b2857baecd$var$_interopRequireDefault((parcelRequire("2xPiy")));
function $0335b0b2857baecd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $0335b0b2857baecd$var$PortalContext = $0335b0b2857baecd$export$60d741e20e0aa309 = /*#__PURE__*/ $0335b0b2857baecd$var$_react["default"].createContext([]);


Object.keys($0335b0b2857baecd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4113023f9e0bafa0$exports && $4113023f9e0bafa0$exports[key] === $0335b0b2857baecd$exports[key]) return;
    $4113023f9e0bafa0$exports[key] = $0335b0b2857baecd$exports[key];
});
var $18fb38d78d6dde51$exports = {};

$parcel$export($18fb38d78d6dde51$exports, "__esModule", function () { return $18fb38d78d6dde51$export$1e511d4a378977f5; }, function (v) { return $18fb38d78d6dde51$export$1e511d4a378977f5 = v; });
$parcel$export($18fb38d78d6dde51$exports, "readOnlyStyle", function () { return $18fb38d78d6dde51$export$28ff5f3fef0ffa78; }, function (v) { return $18fb38d78d6dde51$export$28ff5f3fef0ffa78 = v; });
var $18fb38d78d6dde51$export$1e511d4a378977f5;
var $18fb38d78d6dde51$export$28ff5f3fef0ffa78;
"use strict";
$18fb38d78d6dde51$export$1e511d4a378977f5 = true;
$18fb38d78d6dde51$export$28ff5f3fef0ffa78 = void 0;

var $iA1nz = parcelRequire("iA1nz");


var $18fb38d78d6dde51$var$readOnlyStyle = $18fb38d78d6dde51$export$28ff5f3fef0ffa78 = function readOnlyStyle(theme) {
    var _theme$global$input$r, _theme$global$input$r2, _theme$global$input$r3;
    var styles = [];
    if (theme != null && (_theme$global$input$r = theme.global.input.readOnly) != null && (_theme$global$input$r = _theme$global$input$r.border) != null && _theme$global$input$r.color) styles.push((0, $iA1nz.css)([
        "border-color:",
        ";"
    ], (0, $62e050f1cfc78056$export$4cde5df63f53f473)(theme.global.input.readOnly.border.color, theme)));
    if (theme != null && (_theme$global$input$r2 = theme.global.input.readOnly) != null && _theme$global$input$r2.background) styles.push((0, $cdcfbcf0f8cd48ba$export$e43a4f0de05cb7e9)((_theme$global$input$r3 = theme.global.input.readOnly) == null ? void 0 : _theme$global$input$r3.background, theme));
    return styles;
};


Object.keys($18fb38d78d6dde51$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4113023f9e0bafa0$exports && $4113023f9e0bafa0$exports[key] === $18fb38d78d6dde51$exports[key]) return;
    $4113023f9e0bafa0$exports[key] = $18fb38d78d6dde51$exports[key];
});
var $4c6ce388409ad0b3$exports = {};

$parcel$export($4c6ce388409ad0b3$exports, "__esModule", function () { return $4c6ce388409ad0b3$export$1e511d4a378977f5; }, function (v) { return $4c6ce388409ad0b3$export$1e511d4a378977f5 = v; });
$parcel$export($4c6ce388409ad0b3$exports, "useForwardedRef", function () { return $4c6ce388409ad0b3$export$61dc559f8a0b9bcf; }, function (v) { return $4c6ce388409ad0b3$export$61dc559f8a0b9bcf = v; });
var $4c6ce388409ad0b3$export$1e511d4a378977f5;
var $4c6ce388409ad0b3$export$61dc559f8a0b9bcf;
"use strict";
$4c6ce388409ad0b3$export$1e511d4a378977f5 = true;
$4c6ce388409ad0b3$export$61dc559f8a0b9bcf = void 0;

var $2xPiy = parcelRequire("2xPiy");
var $4c6ce388409ad0b3$var$useForwardedRef = $4c6ce388409ad0b3$export$61dc559f8a0b9bcf = function useForwardedRef(ref) {
    var innerRef = (0, $2xPiy.useRef)(null);
    (0, $2xPiy.useImperativeHandle)(ref, function() {
        return innerRef.current;
    }, [
        innerRef
    ]);
    return innerRef;
};


Object.keys($4c6ce388409ad0b3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4113023f9e0bafa0$exports && $4113023f9e0bafa0$exports[key] === $4c6ce388409ad0b3$exports[key]) return;
    $4113023f9e0bafa0$exports[key] = $4c6ce388409ad0b3$exports[key];
});

Object.keys($80783f9dd7b08ab9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4113023f9e0bafa0$exports && $4113023f9e0bafa0$exports[key] === $80783f9dd7b08ab9$exports[key]) return;
    $4113023f9e0bafa0$exports[key] = $80783f9dd7b08ab9$exports[key];
});
var $416b01f4d44e5520$exports = {};

$parcel$defineInteropFlag($416b01f4d44e5520$exports);

$parcel$export($416b01f4d44e5520$exports, "__esModule", function () { return $416b01f4d44e5520$export$1e511d4a378977f5; }, function (v) { return $416b01f4d44e5520$export$1e511d4a378977f5 = v; });
$parcel$export($416b01f4d44e5520$exports, "useKeyboard", function () { return $416b01f4d44e5520$export$8f71654801c2f7cd; }, function (v) { return $416b01f4d44e5520$export$8f71654801c2f7cd = v; });
$parcel$export($416b01f4d44e5520$exports, "default", function () { return $416b01f4d44e5520$export$2e2bcd8739ae039; }, function (v) { return $416b01f4d44e5520$export$2e2bcd8739ae039 = v; });
var $416b01f4d44e5520$export$1e511d4a378977f5;
var $416b01f4d44e5520$export$8f71654801c2f7cd;
var $416b01f4d44e5520$export$2e2bcd8739ae039;
"use strict";
$416b01f4d44e5520$export$1e511d4a378977f5 = true;
$416b01f4d44e5520$export$8f71654801c2f7cd = $416b01f4d44e5520$export$2e2bcd8739ae039 = void 0;

var $2xPiy = parcelRequire("2xPiy");
var $416b01f4d44e5520$var$useKeyboard = $416b01f4d44e5520$export$8f71654801c2f7cd = function useKeyboard() {
    var _useState = (0, $2xPiy.useState)(), usingKeyboard = _useState[0], setUsingKeyboard = _useState[1];
    (0, $2xPiy.useEffect)(function() {
        var onMouseDown = function onMouseDown() {
            return setUsingKeyboard(false);
        };
        var onKeyDown = function onKeyDown() {
            return setUsingKeyboard(true);
        };
        document.addEventListener('mousedown', onMouseDown);
        document.addEventListener('keydown', onKeyDown);
        return function() {
            document.removeEventListener('mousedown', onMouseDown);
            document.removeEventListener('keydown', onKeyDown);
        };
    }, []);
    return usingKeyboard;
};
var $416b01f4d44e5520$var$_default = $416b01f4d44e5520$export$2e2bcd8739ae039 = $416b01f4d44e5520$var$useKeyboard;


Object.keys($416b01f4d44e5520$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4113023f9e0bafa0$exports && $4113023f9e0bafa0$exports[key] === $416b01f4d44e5520$exports[key]) return;
    $4113023f9e0bafa0$exports[key] = $416b01f4d44e5520$exports[key];
});
var $63c7a354106f9631$exports = {};

$parcel$export($63c7a354106f9631$exports, "__esModule", function () { return $63c7a354106f9631$export$1e511d4a378977f5; }, function (v) { return $63c7a354106f9631$export$1e511d4a378977f5 = v; });
$parcel$export($63c7a354106f9631$exports, "useId", function () { return $63c7a354106f9631$export$f680877a34711e37; }, function (v) { return $63c7a354106f9631$export$f680877a34711e37 = v; });
var $63c7a354106f9631$export$1e511d4a378977f5;
var $63c7a354106f9631$export$f680877a34711e37;
"use strict";
$63c7a354106f9631$export$1e511d4a378977f5 = true;
$63c7a354106f9631$export$f680877a34711e37 = void 0;

var $63c7a354106f9631$var$_react = $63c7a354106f9631$var$_interopRequireWildcard((parcelRequire("2xPiy")));
var $63c7a354106f9631$var$_React$useId;
function $63c7a354106f9631$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($63c7a354106f9631$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $63c7a354106f9631$var$currentId = 0;
var $63c7a354106f9631$var$getId = function getId() {
    // eslint-disable-next-line no-plusplus
    var id = $63c7a354106f9631$var$currentId++;
    return ":r" + id.toString(32) + ":";
};
var $63c7a354106f9631$var$useIdGrommet = function useIdGrommet() {
    var _useState = (0, $63c7a354106f9631$var$_react.useState)($63c7a354106f9631$var$getId), id = _useState[0];
    return id;
};
// Polyfill React 18's useId for compatibility with React 16 and 17
var $63c7a354106f9631$var$useId = $63c7a354106f9631$export$f680877a34711e37 = ($63c7a354106f9631$var$_React$useId = $63c7a354106f9631$var$_react["default"].useId) != null ? $63c7a354106f9631$var$_React$useId : $63c7a354106f9631$var$useIdGrommet;


Object.keys($63c7a354106f9631$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4113023f9e0bafa0$exports && $4113023f9e0bafa0$exports[key] === $63c7a354106f9631$exports[key]) return;
    $4113023f9e0bafa0$exports[key] = $63c7a354106f9631$exports[key];
});


var $090ffb0ba78fff3f$exports = {};

$parcel$export($090ffb0ba78fff3f$exports, "__esModule", function () { return $090ffb0ba78fff3f$export$1e511d4a378977f5; }, function (v) { return $090ffb0ba78fff3f$export$1e511d4a378977f5 = v; });
$parcel$export($090ffb0ba78fff3f$exports, "Box", function () { return $090ffb0ba78fff3f$export$e71c4d32a2263218; }, function (v) { return $090ffb0ba78fff3f$export$e71c4d32a2263218 = v; });
var $090ffb0ba78fff3f$export$1e511d4a378977f5;
var $090ffb0ba78fff3f$export$e71c4d32a2263218;
"use strict";
$090ffb0ba78fff3f$export$1e511d4a378977f5 = true;
$090ffb0ba78fff3f$export$e71c4d32a2263218 = void 0;
var $3a5896a4feb1a7cd$export$1e511d4a378977f5;
var $3a5896a4feb1a7cd$export$e71c4d32a2263218;
"use strict";
$3a5896a4feb1a7cd$export$1e511d4a378977f5 = true;
$3a5896a4feb1a7cd$export$e71c4d32a2263218 = void 0;

var $3a5896a4feb1a7cd$var$_react = $3a5896a4feb1a7cd$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $iA1nz = parcelRequire("iA1nz");

var $0241778dbd7d3ddc$exports = {};

$parcel$export($0241778dbd7d3ddc$exports, "__esModule", function () { return $0241778dbd7d3ddc$export$1e511d4a378977f5; }, function (v) { return $0241778dbd7d3ddc$export$1e511d4a378977f5 = v; });
$parcel$export($0241778dbd7d3ddc$exports, "Keyboard", function () { return $0241778dbd7d3ddc$export$16e4d70cc375e707; }, function (v) { return $0241778dbd7d3ddc$export$16e4d70cc375e707 = v; });
var $0241778dbd7d3ddc$export$1e511d4a378977f5;
var $0241778dbd7d3ddc$export$16e4d70cc375e707;
"use strict";
$0241778dbd7d3ddc$export$1e511d4a378977f5 = true;
$0241778dbd7d3ddc$export$16e4d70cc375e707 = void 0;
var $c874633472f23f03$export$1e511d4a378977f5;
var $c874633472f23f03$export$16e4d70cc375e707;
"use strict";
$c874633472f23f03$export$1e511d4a378977f5 = true;
$c874633472f23f03$export$16e4d70cc375e707 = void 0;

var $2xPiy = parcelRequire("2xPiy");
var $8171800afcd564f7$export$1e511d4a378977f5;
var $8171800afcd564f7$export$52e12bf50c10ce6a;
"use strict";
$8171800afcd564f7$export$1e511d4a378977f5 = true;
$8171800afcd564f7$export$52e12bf50c10ce6a = void 0;

var $8171800afcd564f7$var$_propTypes = $8171800afcd564f7$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $8171800afcd564f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $8171800afcd564f7$var$PropType = {};
$8171800afcd564f7$var$PropType = {
    target: $8171800afcd564f7$var$_propTypes["default"].oneOf([
        'component',
        'document'
    ]),
    onBackspace: $8171800afcd564f7$var$_propTypes["default"].func,
    onComma: $8171800afcd564f7$var$_propTypes["default"].func,
    onDown: $8171800afcd564f7$var$_propTypes["default"].func,
    onEnter: $8171800afcd564f7$var$_propTypes["default"].func,
    onEsc: $8171800afcd564f7$var$_propTypes["default"].func,
    onKeyDown: $8171800afcd564f7$var$_propTypes["default"].func,
    onLeft: $8171800afcd564f7$var$_propTypes["default"].func,
    onRight: $8171800afcd564f7$var$_propTypes["default"].func,
    onShift: $8171800afcd564f7$var$_propTypes["default"].func,
    onSpace: $8171800afcd564f7$var$_propTypes["default"].func,
    onTab: $8171800afcd564f7$var$_propTypes["default"].func,
    onUp: $8171800afcd564f7$var$_propTypes["default"].func
};
var $8171800afcd564f7$var$KeyboardPropTypes = $8171800afcd564f7$export$52e12bf50c10ce6a = $8171800afcd564f7$var$PropType;


var $c874633472f23f03$var$_excluded = [
    "capture",
    "target",
    "children",
    "onKeyDown"
];
function $c874633472f23f03$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $c874633472f23f03$var$KEYS = {
    8: 'onBackspace',
    9: 'onTab',
    13: 'onEnter',
    27: 'onEsc',
    32: 'onSpace',
    37: 'onLeft',
    38: 'onUp',
    39: 'onRight',
    40: 'onDown',
    188: 'onComma',
    16: 'onShift'
};
var $c874633472f23f03$var$Keyboard = $c874633472f23f03$export$16e4d70cc375e707 = function Keyboard(_ref) {
    var capture = _ref.capture, target = _ref.target, children = _ref.children, onKeyDown = _ref.onKeyDown, restProps = $c874633472f23f03$var$_objectWithoutPropertiesLoose(_ref, $c874633472f23f03$var$_excluded);
    var onKeyDownHandler = (0, $2xPiy.useCallback)(function(event) {
        var key = event.keyCode ? event.keyCode : event.which;
        var callbackName = $c874633472f23f03$var$KEYS[key];
        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
        if (callbackName && restProps[callbackName]) restProps[callbackName].apply(restProps, [
            event
        ].concat(rest));
        if (onKeyDown) onKeyDown.apply(void 0, [
            event
        ].concat(rest));
    }, [
        onKeyDown,
        restProps
    ]);
    (0, $2xPiy.useEffect)(function() {
        if (target === 'document') document.addEventListener('keydown', onKeyDownHandler, capture);
        return function() {
            if (target === 'document') document.removeEventListener('keydown', onKeyDownHandler, capture);
        };
    }, [
        capture,
        onKeyDownHandler,
        target
    ]);
    return target === 'document' ? children : /*#__PURE__*/ (0, $2xPiy.cloneElement)($2xPiy.Children.only(children), {
        onKeyDown: onKeyDownHandler
    });
};
$c874633472f23f03$var$Keyboard.propTypes = $8171800afcd564f7$export$52e12bf50c10ce6a;


$0241778dbd7d3ddc$export$16e4d70cc375e707 = $c874633472f23f03$export$16e4d70cc375e707;


var $fb7cfe5df371ec76$export$1e511d4a378977f5;
var $fb7cfe5df371ec76$export$a800d5caa1dbbca6;
var $fb7cfe5df371ec76$export$d675f139b342d51a;
"use strict";
$fb7cfe5df371ec76$export$1e511d4a378977f5 = true;
$fb7cfe5df371ec76$export$a800d5caa1dbbca6 = $fb7cfe5df371ec76$export$d675f139b342d51a = void 0;

var $fb7cfe5df371ec76$var$_styledComponents = $fb7cfe5df371ec76$var$_interopRequireWildcard((parcelRequire("iA1nz")));

var $fb7cfe5df371ec76$var$_isPropValid = $fb7cfe5df371ec76$var$_interopRequireDefault((parcelRequire("8Fliv")));



var $fb7cfe5df371ec76$var$_FLEX_MAP;
function $fb7cfe5df371ec76$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $fb7cfe5df371ec76$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($fb7cfe5df371ec76$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $fb7cfe5df371ec76$var$_extends() {
    return $fb7cfe5df371ec76$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fb7cfe5df371ec76$var$_extends.apply(null, arguments);
}
var $fb7cfe5df371ec76$var$BASIS_MAP = {
    auto: 'auto',
    full: '100%',
    '1/2': '50%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    '1/3': '33.33%',
    '2/3': '66.66%'
};
var $fb7cfe5df371ec76$var$basisStyle = (0, $fb7cfe5df371ec76$var$_styledComponents.css)([
    "flex-basis:",
    ";"
], function(props) {
    return $fb7cfe5df371ec76$var$BASIS_MAP[props.basis] || props.theme.global.size[props.basis] || props.basis;
});
// min-width and min-height needed because of this
// https://stackoverflow.com/questions/36247140/why-doesnt-flex-item-shrink-past-content-size
// we assume we are in the context of a Box going the other direction
// TODO: revisit this
var $fb7cfe5df371ec76$var$directionStyle = function directionStyle(direction, responsive, theme) {
    var styles = [
        (0, $fb7cfe5df371ec76$var$_styledComponents.css)([
            "min-width:0;min-height:0;flex-direction:",
            ";"
        ], direction === 'row-responsive' ? 'row' : direction)
    ];
    if (direction === 'row-responsive' && theme.box.responsiveBreakpoint) {
        var breakpoint = (0, $4113023f9e0bafa0$exports.getBreakpointStyle)(theme, theme.box.responsiveBreakpoint);
        if (breakpoint) styles.push((0, $4113023f9e0bafa0$exports.breakpointStyle)(breakpoint, "\n        flex-direction: column;\n        flex-basis: auto;\n        justify-content: flex-start;\n        align-items: stretch;\n      ", responsive));
    }
    return styles;
};
var $fb7cfe5df371ec76$var$FLEX_MAP = ($fb7cfe5df371ec76$var$_FLEX_MAP = {}, $fb7cfe5df371ec76$var$_FLEX_MAP[true] = '1 1', $fb7cfe5df371ec76$var$_FLEX_MAP[false] = '0 0', $fb7cfe5df371ec76$var$_FLEX_MAP.grow = '1 0', $fb7cfe5df371ec76$var$_FLEX_MAP.shrink = '0 1', $fb7cfe5df371ec76$var$_FLEX_MAP);
var $fb7cfe5df371ec76$var$flexGrowShrinkProp = function flexGrowShrinkProp(flex) {
    if (typeof flex === 'boolean' || typeof flex === 'string') return $fb7cfe5df371ec76$var$FLEX_MAP[flex];
    return (flex.grow ? flex.grow : 0) + " " + (flex.shrink ? flex.shrink : 0);
};
var $fb7cfe5df371ec76$var$flexStyle = (0, $fb7cfe5df371ec76$var$_styledComponents.css)([
    "flex:",
    ";"
], function(props) {
    return "" + $fb7cfe5df371ec76$var$flexGrowShrinkProp(props.flex) + (props.flex !== true && !props.basis ? ' auto' : '');
});
var $fb7cfe5df371ec76$var$JUSTIFY_MAP = {
    around: 'space-around',
    between: 'space-between',
    center: 'center',
    end: 'flex-end',
    evenly: 'space-evenly',
    start: 'flex-start'
};
var $fb7cfe5df371ec76$var$justifyStyle = (0, $fb7cfe5df371ec76$var$_styledComponents.css)([
    "justify-content:",
    ";"
], function(props) {
    return $fb7cfe5df371ec76$var$JUSTIFY_MAP[props.justify];
});
var $fb7cfe5df371ec76$var$WRAP_MAP = {
    "true": 'wrap',
    reverse: 'wrap-reverse'
};
var $fb7cfe5df371ec76$var$wrapStyle = (0, $fb7cfe5df371ec76$var$_styledComponents.css)([
    "flex-wrap:",
    ";"
], function(props) {
    return $fb7cfe5df371ec76$var$WRAP_MAP[props.wrapProp];
});
var $fb7cfe5df371ec76$var$_animationItemStyle = function animationItemStyle(item, theme) {
    if (typeof item === 'string') return (0, $a0261dac70a40f19$export$1d0c30b40b07398)({
        type: item
    }, theme);
    if (Array.isArray(item)) return item.reduce(function(style, a, index) {
        return (0, $fb7cfe5df371ec76$var$_styledComponents.css)([
            "",
            "",
            " ",
            ""
        ], style, index > 0 ? ',' : '', $fb7cfe5df371ec76$var$_animationItemStyle(a, theme));
    }, '');
    if (typeof item === 'object') return (0, $a0261dac70a40f19$export$1d0c30b40b07398)(item, theme);
    return '';
};
var $fb7cfe5df371ec76$var$animationAncilaries = function animationAncilaries(animation) {
    if (animation.type === 'flipIn' || animation.type === 'flipOut') return 'perspective: 1000px; transform-style: preserve-3d;';
    return '';
};
var $fb7cfe5df371ec76$var$animationObjectInitialStyle = function animationObjectInitialStyle(animation) {
    var bounds = (0, $a0261dac70a40f19$export$106a9d8bc0bca92a)(animation.type, animation.size);
    if (bounds) return bounds[0] + " " + $fb7cfe5df371ec76$var$animationAncilaries(animation);
    return '';
};
var $fb7cfe5df371ec76$var$animationInitialStyle = function animationInitialStyle(item) {
    if (typeof item === 'string') return $fb7cfe5df371ec76$var$animationObjectInitialStyle({
        type: item
    });
    if (Array.isArray(item)) return item.map(function(a) {
        return typeof a === 'string' ? $fb7cfe5df371ec76$var$animationObjectInitialStyle({
            type: a
        }) : $fb7cfe5df371ec76$var$animationObjectInitialStyle(a);
    }).join('');
    if (typeof item === 'object') return $fb7cfe5df371ec76$var$animationObjectInitialStyle(item);
    return '';
};
var $fb7cfe5df371ec76$var$animationStyle = (0, $fb7cfe5df371ec76$var$_styledComponents.css)([
    "",
    ";"
], function(props) {
    return (0, $fb7cfe5df371ec76$var$_styledComponents.css)([
        "",
        " animation:",
        ";"
    ], $fb7cfe5df371ec76$var$animationInitialStyle(props.animation), $fb7cfe5df371ec76$var$_animationItemStyle(props.animation, props.theme));
});
var $fb7cfe5df371ec76$var$interactiveStyle = (0, $fb7cfe5df371ec76$var$_styledComponents.css)([
    "cursor:pointer;&:hover{",
    " ",
    "}"
], function(props) {
    var _props$kindProp;
    return ((_props$kindProp = props.kindProp) == null ? void 0 : _props$kindProp.hover) && (0, $4113023f9e0bafa0$exports.getHoverIndicatorStyle)(props.kindProp.hover, props.theme);
}, function(props) {
    return props.hoverIndicator && (0, $4113023f9e0bafa0$exports.getHoverIndicatorStyle)(props.hoverIndicator, props.theme);
});
var $fb7cfe5df371ec76$var$gapStyle = function gapStyle(directionProp, gap, responsive, wrap, theme) {
    var metric = theme.global.edgeSize[gap] || gap;
    var breakpoint = (0, $4113023f9e0bafa0$exports.getBreakpointStyle)(theme, theme.box.responsiveBreakpoint);
    var responsiveMetric = responsive && breakpoint && breakpoint.edgeSize[gap];
    var styles = [];
    if (typeof gap === 'object') {
        var responsiveColumnMetric = responsive && breakpoint && breakpoint.edgeSize[gap.column];
        var responsiveRowMetric = responsive && breakpoint && breakpoint.edgeSize[gap.row];
        if (gap.row !== undefined && gap.column !== undefined) {
            styles.push("gap: " + (theme.global.edgeSize[gap.row] || gap.row) + " " + (theme.global.edgeSize[gap.column] || gap.column) + ";");
            if (responsiveRowMetric || responsiveColumnMetric) styles.push((0, $4113023f9e0bafa0$exports.breakpointStyle)(breakpoint, "gap: " + (responsiveRowMetric || gap.row) + " " + (responsiveColumnMetric || gap.column) + ";", responsive));
        } else if (gap.row !== undefined) {
            styles.push("row-gap: " + (theme.global.edgeSize[gap.row] || gap.row) + ";");
            if (responsiveRowMetric) styles.push((0, $4113023f9e0bafa0$exports.breakpointStyle)(breakpoint, "row-gap: " + responsiveRowMetric + ";", responsive));
        } else if (gap.column !== undefined) {
            styles.push("column-gap: " + (theme.global.edgeSize[gap.column] || gap.column) + ";");
            if (responsiveColumnMetric) styles.push((0, $4113023f9e0bafa0$exports.breakpointStyle)(breakpoint, "column-gap: " + responsiveColumnMetric + ";", responsive));
        }
    } else if (directionProp === 'column' || directionProp === 'column-reverse') {
        styles.push("row-gap: " + metric + ";");
        if (responsiveMetric) styles.push((0, $4113023f9e0bafa0$exports.breakpointStyle)(breakpoint, "row-gap: " + responsiveMetric + ";", responsive));
    } else {
        styles.push("column-gap: " + metric + ";");
        if (wrap) styles.push("row-gap: " + metric + ";");
        if (responsiveMetric) {
            if (directionProp === 'row' || directionProp === 'row-reverse') styles.push((0, $4113023f9e0bafa0$exports.breakpointStyle)(breakpoint, "column-gap: " + responsiveMetric + ";", responsive));
            else if (directionProp === 'row-responsive') styles.push((0, $4113023f9e0bafa0$exports.breakpointStyle)(breakpoint, "row-gap: " + responsiveMetric + ";", responsive));
        }
    }
    return styles;
};
var $fb7cfe5df371ec76$var$responsiveContainerStyle = (0, $fb7cfe5df371ec76$var$_styledComponents.css)([
    "container-type:inline-size;"
]);
// NOTE: basis must be after flex! Otherwise, flex overrides basis
// After upgrading to react 19 the 'selected' prop is leaking through
// to the DOM, added a check to prevent this.
var $fb7cfe5df371ec76$var$StyledBox = $fb7cfe5df371ec76$export$d675f139b342d51a = $fb7cfe5df371ec76$var$_styledComponents["default"].div.withConfig({
    shouldForwardProp: function shouldForwardProp(prop) {
        return (0, $fb7cfe5df371ec76$var$_isPropValid["default"])(prop) && ![
            'selected'
        ].includes(prop);
    }
}).withConfig({
    displayName: "StyledBox",
    componentId: "sc-13pk1d4-0"
})([
    "display:flex;box-sizing:border-box;",
    ";",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return !props.basis && 'max-width: 100%;';
}, $4113023f9e0bafa0$exports.genericStyles, function(props) {
    return props.align && $4113023f9e0bafa0$exports.alignStyle;
}, function(props) {
    return props.alignContent && $4113023f9e0bafa0$exports.alignContentStyle;
}, function(props) {
    return props.background && (0, $4113023f9e0bafa0$exports.backgroundStyle)(props.background, props.theme);
}, function(props) {
    return props.border && (0, $4113023f9e0bafa0$exports.borderStyle)(props.border, props.responsive, props.theme);
}, function(props) {
    return props.directionProp && $fb7cfe5df371ec76$var$directionStyle(props.directionProp, props.responsive, props.theme);
}, function(props) {
    return props.heightProp && (0, $4113023f9e0bafa0$exports.heightStyle)(props.heightProp, props.theme);
}, function(props) {
    return props.widthProp && (0, $4113023f9e0bafa0$exports.widthStyle)(props.widthProp, props.theme);
}, function(props) {
    return props.flex !== undefined && $fb7cfe5df371ec76$var$flexStyle;
}, function(props) {
    return props.basis && $fb7cfe5df371ec76$var$basisStyle;
}, function(props) {
    return props.fillProp && (0, $4113023f9e0bafa0$exports.fillStyle)(props.fillProp);
}, function(props) {
    return props.justify && $fb7cfe5df371ec76$var$justifyStyle;
}, function(props) {
    return props.pad && (0, $4113023f9e0bafa0$exports.edgeStyle)('padding', props.pad, props.responsive, props.theme.box.responsiveBreakpoint, props.theme);
}, function(props) {
    return props.round && (0, $9a7099e779e83517$export$98483643daf52539)(props.round, props.responsive, props.theme);
}, function(props) {
    return props.wrapProp && $fb7cfe5df371ec76$var$wrapStyle;
}, function(props) {
    return props.overflowProp && (0, $4113023f9e0bafa0$exports.overflowStyle)(props.overflowProp);
}, function(props) {
    return props.elevationProp && (0, $4113023f9e0bafa0$exports.elevationStyle)(props.elevationProp);
}, function(props) {
    return props.gap && $fb7cfe5df371ec76$var$gapStyle(props.directionProp, props.gap, props.responsive, props.wrapProp, props.theme);
}, function(props) {
    return props.animation && $fb7cfe5df371ec76$var$animationStyle;
}, function(props) {
    return props.onClick && $fb7cfe5df371ec76$var$interactiveStyle;
}, function(props) {
    return props.onClick && props.focus && props.focusIndicator !== false && // only show focus styles when using keyboard navigation
    // but not with mouse
    (0, $fb7cfe5df371ec76$var$_styledComponents.css)([
        "",
        " &:focus:not(:focus-visible){",
        "}"
    ], (0, $4113023f9e0bafa0$exports.focusStyle)(), (0, $4113023f9e0bafa0$exports.unfocusStyle)());
}, function(props) {
    return props.theme.box && props.theme.box.extend;
}, function(props) {
    return props.kindProp && props.kindProp.extend;
}, function(props) {
    return props.responsiveContainer ? $fb7cfe5df371ec76$var$responsiveContainerStyle : '';
});
var $fb7cfe5df371ec76$var$gapGapStyle = function gapGapStyle(directionProp, gap, responsive, border, theme) {
    var metric = theme.global.edgeSize[gap] || gap;
    var breakpoint = (0, $4113023f9e0bafa0$exports.getBreakpointStyle)(theme, theme.box.responsiveBreakpoint);
    var responsiveMetric = responsive && breakpoint && breakpoint.edgeSize[gap];
    var styles = [];
    if (directionProp === 'column' || directionProp === 'column-reverse') {
        styles.push("height: " + metric + ";");
        if (responsiveMetric) styles.push((0, $4113023f9e0bafa0$exports.breakpointStyle)(breakpoint, "height: " + responsiveMetric + ";", responsive));
    } else {
        styles.push("width: " + metric + ";");
        if (responsiveMetric) {
            if (directionProp === 'row' || directionProp === 'row-reverse') styles.push((0, $4113023f9e0bafa0$exports.breakpointStyle)(breakpoint, "width: " + responsiveMetric + ";", responsive));
            else if (directionProp === 'row-responsive') styles.push((0, $4113023f9e0bafa0$exports.breakpointStyle)(breakpoint, "\n          width: auto;\n          height: " + responsiveMetric + ";\n        ", responsive));
        }
    }
    if (border === 'between' || border && border.side === 'between') {
        var borderSize = border.size || theme.box.border.offset;
        var borderMetric = theme.global.borderSize[borderSize] || borderSize;
        var borderOffset = (0, $4113023f9e0bafa0$exports.parseMetricToNum)(metric) / 2 - (0, $4113023f9e0bafa0$exports.parseMetricToNum)(borderMetric) / 2 + "px";
        var responsiveBorderMetric = responsive && breakpoint && (breakpoint.borderSize[borderSize] || borderSize);
        var responsiveBorderOffset = responsiveBorderMetric && (0, $4113023f9e0bafa0$exports.parseMetricToNum)(responsiveMetric || metric) / 2 - (0, $4113023f9e0bafa0$exports.parseMetricToNum)(responsiveBorderMetric) / 2 + "px";
        if (directionProp === 'column' || directionProp === 'column-reverse') {
            var adjustedBorder = typeof border === 'string' ? 'top' : $fb7cfe5df371ec76$var$_extends({}, border, {
                side: 'top'
            });
            styles.push((0, $fb7cfe5df371ec76$var$_styledComponents.css)([
                "position:relative;&:after{content:'';position:absolute;width:100%;top:",
                ";",
                "}"
            ], borderOffset, (0, $4113023f9e0bafa0$exports.borderStyle)(adjustedBorder, responsive, theme)));
            if (responsiveBorderOffset) styles.push((0, $4113023f9e0bafa0$exports.breakpointStyle)(breakpoint, "\n            &:after {\n              content: '';\n              top: " + responsiveBorderOffset + ";\n            }", responsive));
        } else {
            var _adjustedBorder = typeof border === 'string' ? 'left' : $fb7cfe5df371ec76$var$_extends({}, border, {
                side: 'left'
            });
            styles.push((0, $fb7cfe5df371ec76$var$_styledComponents.css)([
                "position:relative;&:after{content:'';position:absolute;height:100%;left:",
                ";",
                "}"
            ], borderOffset, (0, $4113023f9e0bafa0$exports.borderStyle)(_adjustedBorder, directionProp !== 'row-responsive' && responsive, theme)));
            if (responsiveBorderOffset) {
                if (directionProp === 'row' || directionProp === 'row-reverse') styles.push((0, $4113023f9e0bafa0$exports.breakpointStyle)(breakpoint, "\n              &:after {\n                content: '';\n                left: " + responsiveBorderOffset + ";\n              }", responsive));
                else if (directionProp === 'row-responsive') {
                    var adjustedBorder2 = typeof border === 'string' ? 'top' : $fb7cfe5df371ec76$var$_extends({}, border, {
                        side: 'top'
                    });
                    styles.push((0, $4113023f9e0bafa0$exports.breakpointStyle)(breakpoint, "\n              &:after {\n                content: '';\n                height: auto;\n                left: unset;\n                width: 100%;\n                top: " + responsiveBorderOffset + ";\n                border-left: none;\n                " + (0, $4113023f9e0bafa0$exports.responsiveBorderStyle)(adjustedBorder2, theme) + "\n              }", responsive));
                }
            }
        }
    }
    return styles;
};
var $fb7cfe5df371ec76$var$StyledBoxGap = $fb7cfe5df371ec76$export$a800d5caa1dbbca6 = $fb7cfe5df371ec76$var$_styledComponents["default"].div.withConfig($9a7099e779e83517$export$373e75d802fd707).withConfig({
    displayName: "StyledBox__StyledBoxGap",
    componentId: "sc-13pk1d4-1"
})([
    "flex:0 0 auto;align-self:stretch;",
    ";"
], function(props) {
    return props.gap && $fb7cfe5df371ec76$var$gapGapStyle(props.directionProp, props.gap, props.responsive, props.border, props.theme);
});


var $eee1df2c89b8d329$export$1e511d4a378977f5;
var $eee1df2c89b8d329$export$39ef5a49fe6b4917;
"use strict";
$eee1df2c89b8d329$export$1e511d4a378977f5 = true;
$eee1df2c89b8d329$export$39ef5a49fe6b4917 = void 0;

var $eee1df2c89b8d329$var$_propTypes = $eee1df2c89b8d329$var$_interopRequireDefault((parcelRequire("dyr1f")));
var $5897bd367fbd90c1$export$1e511d4a378977f5;
var $5897bd367fbd90c1$export$7d45d0e6b7abd5e2;
var $5897bd367fbd90c1$export$2f3082f340019e9a;
var $5897bd367fbd90c1$export$d3e0bc3700258305;
var $5897bd367fbd90c1$export$fcb8c87299e05542;
var $5897bd367fbd90c1$export$fe1f7946fa764688;
var $5897bd367fbd90c1$export$4be843ac40f484c6;
var $5897bd367fbd90c1$export$b91a2ef62736aae3;
var $5897bd367fbd90c1$export$7ece648387045365;
var $5897bd367fbd90c1$export$e4126213490fff97;
var $5897bd367fbd90c1$export$674efdc47ecf99e9;
var $5897bd367fbd90c1$export$ffe37ff34eeb9e21;
var $5897bd367fbd90c1$export$d9c9382fb5d26cc7;
var $5897bd367fbd90c1$export$fc4c368d97afb623;
var $5897bd367fbd90c1$export$f8a44c6979fe9fe5;
var $5897bd367fbd90c1$export$aa372966d47f02af;
var $5897bd367fbd90c1$export$6054792fa1afa765;
var $5897bd367fbd90c1$export$5dd51d61a30477bc;
var $5897bd367fbd90c1$export$eb55925152858bde;
var $5897bd367fbd90c1$export$5b49d53be3c37c69;
var $5897bd367fbd90c1$export$7d9f2aeb8f1f7c3f;
"use strict";
$5897bd367fbd90c1$export$1e511d4a378977f5 = true;
$5897bd367fbd90c1$export$7d45d0e6b7abd5e2 = $5897bd367fbd90c1$export$2f3082f340019e9a = $5897bd367fbd90c1$export$d3e0bc3700258305 = $5897bd367fbd90c1$export$fcb8c87299e05542 = $5897bd367fbd90c1$export$fe1f7946fa764688 = $5897bd367fbd90c1$export$4be843ac40f484c6 = $5897bd367fbd90c1$export$b91a2ef62736aae3 = $5897bd367fbd90c1$export$7ece648387045365 = $5897bd367fbd90c1$export$e4126213490fff97 = $5897bd367fbd90c1$export$674efdc47ecf99e9 = $5897bd367fbd90c1$export$ffe37ff34eeb9e21 = $5897bd367fbd90c1$export$d9c9382fb5d26cc7 = $5897bd367fbd90c1$export$fc4c368d97afb623 = $5897bd367fbd90c1$export$f8a44c6979fe9fe5 = $5897bd367fbd90c1$export$aa372966d47f02af = $5897bd367fbd90c1$export$6054792fa1afa765 = $5897bd367fbd90c1$export$5dd51d61a30477bc = $5897bd367fbd90c1$export$eb55925152858bde = $5897bd367fbd90c1$export$5b49d53be3c37c69 = $5897bd367fbd90c1$export$7d9f2aeb8f1f7c3f = void 0;

var $5897bd367fbd90c1$var$_propTypes = $5897bd367fbd90c1$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $5897bd367fbd90c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $5897bd367fbd90c1$var$a11yTitlePropType = $5897bd367fbd90c1$export$eb55925152858bde = $5897bd367fbd90c1$var$_propTypes["default"].string;
var $5897bd367fbd90c1$var$alignPropType = $5897bd367fbd90c1$export$5dd51d61a30477bc = $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
    $5897bd367fbd90c1$var$_propTypes["default"].oneOf([
        'baseline',
        'center',
        'end',
        'start',
        'stretch'
    ]),
    $5897bd367fbd90c1$var$_propTypes["default"].string
]);
var $5897bd367fbd90c1$var$ANIMATION_TYPE = $5897bd367fbd90c1$var$_propTypes["default"].oneOf([
    'fadeIn',
    'fadeOut',
    'jiggle',
    'pulse',
    'rotateLeft',
    'rotateRight',
    'slideUp',
    'slideDown',
    'slideLeft',
    'slideRight',
    'zoomIn',
    'zoomOut'
]);
var $5897bd367fbd90c1$var$ANIMATION_SHAPE = $5897bd367fbd90c1$var$_propTypes["default"].shape({
    type: $5897bd367fbd90c1$var$ANIMATION_TYPE,
    delay: $5897bd367fbd90c1$var$_propTypes["default"].number,
    duration: $5897bd367fbd90c1$var$_propTypes["default"].number,
    size: $5897bd367fbd90c1$var$_propTypes["default"].oneOf([
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ])
});
var $5897bd367fbd90c1$var$animationPropType = $5897bd367fbd90c1$export$6054792fa1afa765 = $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
    $5897bd367fbd90c1$var$ANIMATION_TYPE,
    $5897bd367fbd90c1$var$ANIMATION_SHAPE,
    $5897bd367fbd90c1$var$_propTypes["default"].arrayOf($5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
        $5897bd367fbd90c1$var$ANIMATION_TYPE,
        $5897bd367fbd90c1$var$ANIMATION_SHAPE
    ]))
]);
var $5897bd367fbd90c1$var$colorPropType = $5897bd367fbd90c1$export$fc4c368d97afb623 = $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
    $5897bd367fbd90c1$var$_propTypes["default"].string,
    $5897bd367fbd90c1$var$_propTypes["default"].shape({
        dark: $5897bd367fbd90c1$var$_propTypes["default"].string,
        light: $5897bd367fbd90c1$var$_propTypes["default"].string
    })
]);
var $5897bd367fbd90c1$var$backgroundPropType = $5897bd367fbd90c1$export$f8a44c6979fe9fe5 = $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
    $5897bd367fbd90c1$var$_propTypes["default"].string,
    $5897bd367fbd90c1$var$_propTypes["default"].shape({
        clip: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].oneOf([
                'text'
            ]),
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ]),
        color: $5897bd367fbd90c1$var$colorPropType,
        dark: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].bool,
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ]),
        image: $5897bd367fbd90c1$var$_propTypes["default"].string,
        position: $5897bd367fbd90c1$var$_propTypes["default"].string,
        opacity: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].string,
            $5897bd367fbd90c1$var$_propTypes["default"].bool,
            $5897bd367fbd90c1$var$_propTypes["default"].number,
            $5897bd367fbd90c1$var$_propTypes["default"].oneOf([
                'weak',
                'medium',
                'strong'
            ])
        ]),
        repeat: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].oneOf([
                'no-repeat',
                'repeat'
            ]),
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ]),
        rotate: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].number,
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ]),
        size: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].oneOf([
                'cover',
                'contain'
            ]),
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ]),
        light: $5897bd367fbd90c1$var$_propTypes["default"].string
    })
]);
var $5897bd367fbd90c1$var$backgroundDoc = $5897bd367fbd90c1$export$aa372966d47f02af = $5897bd367fbd90c1$var$backgroundPropType;
var $5897bd367fbd90c1$var$MARGIN_SIZES = $5897bd367fbd90c1$export$7d9f2aeb8f1f7c3f = [
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge'
];
var $5897bd367fbd90c1$var$marginProp = $5897bd367fbd90c1$export$7ece648387045365 = $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
    $5897bd367fbd90c1$var$_propTypes["default"].oneOf([
        'none'
    ].concat($5897bd367fbd90c1$var$MARGIN_SIZES)),
    $5897bd367fbd90c1$var$_propTypes["default"].shape({
        bottom: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].oneOf($5897bd367fbd90c1$var$MARGIN_SIZES),
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ]),
        end: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].oneOf($5897bd367fbd90c1$var$MARGIN_SIZES),
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ]),
        horizontal: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].oneOf($5897bd367fbd90c1$var$MARGIN_SIZES),
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ]),
        left: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].oneOf($5897bd367fbd90c1$var$MARGIN_SIZES),
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ]),
        right: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].oneOf($5897bd367fbd90c1$var$MARGIN_SIZES),
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ]),
        start: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].oneOf($5897bd367fbd90c1$var$MARGIN_SIZES),
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ]),
        top: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].oneOf($5897bd367fbd90c1$var$MARGIN_SIZES),
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ]),
        vertical: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].oneOf($5897bd367fbd90c1$var$MARGIN_SIZES),
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ])
    }),
    $5897bd367fbd90c1$var$_propTypes["default"].string
]);
var $5897bd367fbd90c1$var$PAD_SIZES = [
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge'
];
var $5897bd367fbd90c1$var$padPropType = $5897bd367fbd90c1$export$b91a2ef62736aae3 = $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
    $5897bd367fbd90c1$var$_propTypes["default"].oneOf([
        'none'
    ].concat($5897bd367fbd90c1$var$PAD_SIZES)),
    $5897bd367fbd90c1$var$_propTypes["default"].shape({
        bottom: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].oneOf($5897bd367fbd90c1$var$PAD_SIZES),
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ]),
        end: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].oneOf($5897bd367fbd90c1$var$PAD_SIZES),
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ]),
        horizontal: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].oneOf($5897bd367fbd90c1$var$PAD_SIZES),
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ]),
        left: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].oneOf($5897bd367fbd90c1$var$PAD_SIZES),
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ]),
        right: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].oneOf($5897bd367fbd90c1$var$PAD_SIZES),
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ]),
        start: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].oneOf($5897bd367fbd90c1$var$PAD_SIZES),
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ]),
        top: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].oneOf($5897bd367fbd90c1$var$PAD_SIZES),
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ]),
        vertical: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].oneOf($5897bd367fbd90c1$var$PAD_SIZES),
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ])
    }),
    $5897bd367fbd90c1$var$_propTypes["default"].string
]);
var $5897bd367fbd90c1$var$genericProps = $5897bd367fbd90c1$export$ffe37ff34eeb9e21 = {
    a11yTitle: $5897bd367fbd90c1$var$a11yTitlePropType,
    alignSelf: $5897bd367fbd90c1$var$_propTypes["default"].oneOf([
        'start',
        'center',
        'end',
        'stretch',
        'baseline'
    ]),
    gridArea: $5897bd367fbd90c1$var$_propTypes["default"].string,
    margin: $5897bd367fbd90c1$var$marginProp
};
var $5897bd367fbd90c1$var$elevationPropType = $5897bd367fbd90c1$export$d9c9382fb5d26cc7 = $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
    $5897bd367fbd90c1$var$_propTypes["default"].oneOf([
        'none',
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ]),
    $5897bd367fbd90c1$var$_propTypes["default"].string
]);
var $5897bd367fbd90c1$var$hoverIndicatorPropType = $5897bd367fbd90c1$export$e4126213490fff97 = $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
    $5897bd367fbd90c1$var$_propTypes["default"].bool,
    $5897bd367fbd90c1$var$_propTypes["default"].string,
    $5897bd367fbd90c1$var$_propTypes["default"].oneOf([
        'background'
    ]),
    $5897bd367fbd90c1$var$backgroundPropType,
    $5897bd367fbd90c1$var$_propTypes["default"].shape({
        background: $5897bd367fbd90c1$var$backgroundPropType,
        elevation: $5897bd367fbd90c1$var$elevationPropType
    })
]);
var $5897bd367fbd90c1$var$pointPropType = $5897bd367fbd90c1$export$fe1f7946fa764688 = $5897bd367fbd90c1$var$_propTypes["default"].oneOf([
    'circle',
    'diamond',
    'square',
    'star',
    'triangle',
    'triangleDown'
]);
var $5897bd367fbd90c1$var$patternPropType = $5897bd367fbd90c1$export$4be843ac40f484c6 = $5897bd367fbd90c1$var$_propTypes["default"].oneOf([
    'squares',
    'circles',
    'stripesHorizontal',
    'stripesVertical',
    'stripesDiagonalDown',
    'stripesDiagonalUp'
]);
var $5897bd367fbd90c1$var$roundPropType = $5897bd367fbd90c1$export$fcb8c87299e05542 = $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
    $5897bd367fbd90c1$var$_propTypes["default"].bool,
    $5897bd367fbd90c1$var$_propTypes["default"].oneOf([
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge',
        'full'
    ]),
    $5897bd367fbd90c1$var$_propTypes["default"].string,
    $5897bd367fbd90c1$var$_propTypes["default"].shape({
        corner: $5897bd367fbd90c1$var$_propTypes["default"].oneOf([
            'top',
            'left',
            'bottom',
            'right',
            'top-left',
            'top-right',
            'bottom-left',
            'bottom-right'
        ]),
        size: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].oneOf([
                'xsmall',
                'small',
                'medium',
                'large',
                'xlarge'
            ]),
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ])
    })
]);
var $5897bd367fbd90c1$var$skeletonColorsPropType = $5897bd367fbd90c1$export$d3e0bc3700258305 = $5897bd367fbd90c1$var$_propTypes["default"].shape({
    dark: $5897bd367fbd90c1$var$_propTypes["default"].arrayOf($5897bd367fbd90c1$var$_propTypes["default"].string),
    light: $5897bd367fbd90c1$var$_propTypes["default"].arrayOf($5897bd367fbd90c1$var$_propTypes["default"].string)
});
var $5897bd367fbd90c1$var$skeletonPropType = $5897bd367fbd90c1$export$2f3082f340019e9a = $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
    $5897bd367fbd90c1$var$_propTypes["default"].bool,
    $5897bd367fbd90c1$var$_propTypes["default"].shape({
        animation: $5897bd367fbd90c1$var$animationPropType,
        colors: $5897bd367fbd90c1$var$skeletonColorsPropType,
        depth: $5897bd367fbd90c1$var$_propTypes["default"].number,
        message: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$_propTypes["default"].string,
            $5897bd367fbd90c1$var$_propTypes["default"].shape({
                start: $5897bd367fbd90c1$var$_propTypes["default"].string,
                end: $5897bd367fbd90c1$var$_propTypes["default"].string
            })
        ])
    })
]);
var $5897bd367fbd90c1$var$dimSizeType = $5897bd367fbd90c1$var$_propTypes["default"].oneOf([
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge',
    'xxlarge'
]);
var $5897bd367fbd90c1$var$heightPropType = $5897bd367fbd90c1$export$674efdc47ecf99e9 = $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
    $5897bd367fbd90c1$var$dimSizeType,
    $5897bd367fbd90c1$var$_propTypes["default"].string,
    $5897bd367fbd90c1$var$_propTypes["default"].shape({
        height: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$dimSizeType,
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ]),
        min: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$dimSizeType,
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ]),
        max: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$dimSizeType,
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ])
    })
]);
var $5897bd367fbd90c1$var$widthPropType = $5897bd367fbd90c1$export$7d45d0e6b7abd5e2 = $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
    $5897bd367fbd90c1$var$dimSizeType,
    $5897bd367fbd90c1$var$_propTypes["default"].string,
    $5897bd367fbd90c1$var$_propTypes["default"].shape({
        width: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$dimSizeType,
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ]),
        min: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$dimSizeType,
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ]),
        max: $5897bd367fbd90c1$var$_propTypes["default"].oneOfType([
            $5897bd367fbd90c1$var$dimSizeType,
            $5897bd367fbd90c1$var$_propTypes["default"].string
        ])
    })
]);
var $5897bd367fbd90c1$var$OVERFLOW_VALUES = $5897bd367fbd90c1$export$5b49d53be3c37c69 = [
    'auto',
    'hidden',
    'scroll',
    'visible'
];


function $eee1df2c89b8d329$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $eee1df2c89b8d329$var$_extends() {
    return $eee1df2c89b8d329$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $eee1df2c89b8d329$var$_extends.apply(null, arguments);
}
var $eee1df2c89b8d329$var$OVERFLOW_VALUES = [
    'auto',
    'hidden',
    'scroll',
    'visible'
];
var $eee1df2c89b8d329$var$BORDER_SHAPE = $eee1df2c89b8d329$var$_propTypes["default"].shape({
    color: $eee1df2c89b8d329$var$_propTypes["default"].oneOfType([
        $eee1df2c89b8d329$var$_propTypes["default"].string,
        $eee1df2c89b8d329$var$_propTypes["default"].shape({
            dark: $eee1df2c89b8d329$var$_propTypes["default"].string,
            light: $eee1df2c89b8d329$var$_propTypes["default"].string
        })
    ]),
    side: $eee1df2c89b8d329$var$_propTypes["default"].oneOf([
        'top',
        'left',
        'bottom',
        'right',
        'start',
        'end',
        'horizontal',
        'vertical',
        'all',
        'between'
    ]),
    size: $eee1df2c89b8d329$var$_propTypes["default"].oneOfType([
        $eee1df2c89b8d329$var$_propTypes["default"].oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        $eee1df2c89b8d329$var$_propTypes["default"].string
    ]),
    style: $eee1df2c89b8d329$var$_propTypes["default"].oneOf([
        'solid',
        'dashed',
        'dotted',
        'double',
        'groove',
        'ridge',
        'inset',
        'outset',
        'hidden'
    ])
});
// if you update values here, make sure to update in Drop/doc too.
var $eee1df2c89b8d329$var$overflowPropType = $eee1df2c89b8d329$var$_propTypes["default"].oneOfType([
    $eee1df2c89b8d329$var$_propTypes["default"].oneOf($eee1df2c89b8d329$var$OVERFLOW_VALUES),
    $eee1df2c89b8d329$var$_propTypes["default"].shape({
        horizontal: $eee1df2c89b8d329$var$_propTypes["default"].oneOf($eee1df2c89b8d329$var$OVERFLOW_VALUES),
        vertical: $eee1df2c89b8d329$var$_propTypes["default"].oneOf($eee1df2c89b8d329$var$OVERFLOW_VALUES)
    }),
    $eee1df2c89b8d329$var$_propTypes["default"].string
]);
var $eee1df2c89b8d329$var$PropType = {};
$eee1df2c89b8d329$var$PropType = $eee1df2c89b8d329$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    align: $eee1df2c89b8d329$var$_propTypes["default"].oneOfType([
        $eee1df2c89b8d329$var$_propTypes["default"].oneOf([
            'baseline',
            'center',
            'end',
            'start',
            'stretch'
        ]),
        $eee1df2c89b8d329$var$_propTypes["default"].string
    ]),
    alignContent: $eee1df2c89b8d329$var$_propTypes["default"].oneOfType([
        $eee1df2c89b8d329$var$_propTypes["default"].oneOf([
            'around',
            'baseline',
            'between',
            'center',
            'evenly',
            'end',
            'start',
            'stretch'
        ]),
        $eee1df2c89b8d329$var$_propTypes["default"].string
    ]),
    animation: $5897bd367fbd90c1$export$6054792fa1afa765,
    background: $5897bd367fbd90c1$export$aa372966d47f02af,
    basis: $eee1df2c89b8d329$var$_propTypes["default"].oneOfType([
        $eee1df2c89b8d329$var$_propTypes["default"].oneOf([
            'xxsmall',
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            'xxlarge',
            'full',
            '1/2',
            '1/3',
            '2/3',
            '1/4',
            '2/4',
            '3/4',
            'auto'
        ]),
        $eee1df2c89b8d329$var$_propTypes["default"].string
    ]),
    border: $eee1df2c89b8d329$var$_propTypes["default"].oneOfType([
        $eee1df2c89b8d329$var$_propTypes["default"].bool,
        $eee1df2c89b8d329$var$_propTypes["default"].oneOf([
            'top',
            'left',
            'bottom',
            'right',
            'start',
            'end',
            'horizontal',
            'vertical',
            'all',
            'between'
        ]),
        $eee1df2c89b8d329$var$BORDER_SHAPE,
        $eee1df2c89b8d329$var$_propTypes["default"].arrayOf($eee1df2c89b8d329$var$BORDER_SHAPE)
    ]),
    cssGap: $eee1df2c89b8d329$var$_propTypes["default"].bool,
    direction: $eee1df2c89b8d329$var$_propTypes["default"].oneOf([
        'row',
        'column',
        'row-responsive',
        'row-reverse',
        'column-reverse'
    ]),
    elevation: $5897bd367fbd90c1$export$d9c9382fb5d26cc7,
    flex: $eee1df2c89b8d329$var$_propTypes["default"].oneOfType([
        $eee1df2c89b8d329$var$_propTypes["default"].oneOf([
            'grow',
            'shrink'
        ]),
        $eee1df2c89b8d329$var$_propTypes["default"].bool,
        $eee1df2c89b8d329$var$_propTypes["default"].shape({
            grow: $eee1df2c89b8d329$var$_propTypes["default"].number,
            shrink: $eee1df2c89b8d329$var$_propTypes["default"].number
        })
    ]),
    fill: $eee1df2c89b8d329$var$_propTypes["default"].oneOfType([
        $eee1df2c89b8d329$var$_propTypes["default"].oneOf([
            'horizontal',
            'vertical'
        ]),
        $eee1df2c89b8d329$var$_propTypes["default"].bool
    ]),
    focusIndicator: $eee1df2c89b8d329$var$_propTypes["default"].bool,
    gap: $eee1df2c89b8d329$var$_propTypes["default"].oneOfType([
        $eee1df2c89b8d329$var$_propTypes["default"].oneOf([
            'none',
            'xxsmall',
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        $eee1df2c89b8d329$var$_propTypes["default"].string,
        $eee1df2c89b8d329$var$_propTypes["default"].shape({
            row: $eee1df2c89b8d329$var$_propTypes["default"].string,
            column: $eee1df2c89b8d329$var$_propTypes["default"].string
        })
    ]),
    height: $5897bd367fbd90c1$export$674efdc47ecf99e9,
    hoverIndicator: $5897bd367fbd90c1$export$e4126213490fff97,
    justify: $eee1df2c89b8d329$var$_propTypes["default"].oneOf([
        'around',
        'between',
        'center',
        'end',
        'evenly',
        'start',
        'stretch'
    ]),
    onClick: $eee1df2c89b8d329$var$_propTypes["default"].func,
    overflow: $eee1df2c89b8d329$var$overflowPropType,
    pad: $5897bd367fbd90c1$export$b91a2ef62736aae3,
    responsive: $eee1df2c89b8d329$var$_propTypes["default"].oneOfType([
        $eee1df2c89b8d329$var$_propTypes["default"].bool,
        $eee1df2c89b8d329$var$_propTypes["default"].oneOf([
            'container'
        ])
    ]),
    round: $5897bd367fbd90c1$export$fcb8c87299e05542,
    skeleton: $5897bd367fbd90c1$export$2f3082f340019e9a,
    tag: $eee1df2c89b8d329$var$_propTypes["default"].oneOfType([
        $eee1df2c89b8d329$var$_propTypes["default"].string,
        $eee1df2c89b8d329$var$_propTypes["default"].func
    ]),
    as: $eee1df2c89b8d329$var$_propTypes["default"].oneOfType([
        $eee1df2c89b8d329$var$_propTypes["default"].string,
        $eee1df2c89b8d329$var$_propTypes["default"].func,
        $eee1df2c89b8d329$var$_propTypes["default"].elementType
    ]),
    width: $5897bd367fbd90c1$export$7d45d0e6b7abd5e2,
    wrap: $eee1df2c89b8d329$var$_propTypes["default"].oneOfType([
        $eee1df2c89b8d329$var$_propTypes["default"].bool,
        $eee1df2c89b8d329$var$_propTypes["default"].oneOf([
            'reverse'
        ])
    ])
});
var $eee1df2c89b8d329$var$BoxPropTypes = $eee1df2c89b8d329$export$39ef5a49fe6b4917 = $eee1df2c89b8d329$var$PropType;


var $ab65104eb6f9aa8a$exports = {};
"use strict";
$ab65104eb6f9aa8a$exports.__esModule = true;
var $ab65104eb6f9aa8a$var$_exportNames = {
    Skeleton: true
};
$ab65104eb6f9aa8a$exports.Skeleton = void 0;
var $e69128d7568b41c8$export$1e511d4a378977f5;
var $e69128d7568b41c8$export$8f31e4c4a37b8e9c;
"use strict";
$e69128d7568b41c8$export$1e511d4a378977f5 = true;
$e69128d7568b41c8$export$8f31e4c4a37b8e9c = void 0;

var $e69128d7568b41c8$var$_react = $e69128d7568b41c8$var$_interopRequireWildcard((parcelRequire("2xPiy")));
var $00dab9cdc7800161$export$1e511d4a378977f5;
var $00dab9cdc7800161$export$6c09f2c2b39894c;
"use strict";
$00dab9cdc7800161$export$1e511d4a378977f5 = true;
$00dab9cdc7800161$export$6c09f2c2b39894c = void 0;

var $00dab9cdc7800161$var$_propTypes = $00dab9cdc7800161$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $00dab9cdc7800161$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $00dab9cdc7800161$var$_extends() {
    return $00dab9cdc7800161$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $00dab9cdc7800161$var$_extends.apply(null, arguments);
}
var $00dab9cdc7800161$var$PropType = {};
$00dab9cdc7800161$var$PropType = $00dab9cdc7800161$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    as: $00dab9cdc7800161$var$_propTypes["default"].oneOfType([
        $00dab9cdc7800161$var$_propTypes["default"].string,
        $00dab9cdc7800161$var$_propTypes["default"].func,
        $00dab9cdc7800161$var$_propTypes["default"].element
    ]),
    colors: $5897bd367fbd90c1$export$d3e0bc3700258305,
    height: $5897bd367fbd90c1$export$674efdc47ecf99e9,
    pad: $5897bd367fbd90c1$export$b91a2ef62736aae3,
    round: $5897bd367fbd90c1$export$fcb8c87299e05542,
    width: $5897bd367fbd90c1$export$7d45d0e6b7abd5e2
});
var $00dab9cdc7800161$var$SkeletonPropTypes = $00dab9cdc7800161$export$6c09f2c2b39894c = $00dab9cdc7800161$var$PropType;


var $ac3ccf23d31b45d6$exports = {};

$parcel$export($ac3ccf23d31b45d6$exports, "__esModule", function () { return $ac3ccf23d31b45d6$export$1e511d4a378977f5; }, function (v) { return $ac3ccf23d31b45d6$export$1e511d4a378977f5 = v; });
$parcel$export($ac3ccf23d31b45d6$exports, "useSkeleton", function () { return $ac3ccf23d31b45d6$export$9489db5f14593d18; }, function (v) { return $ac3ccf23d31b45d6$export$9489db5f14593d18 = v; });
$parcel$export($ac3ccf23d31b45d6$exports, "SkeletonContext", function () { return $ac3ccf23d31b45d6$export$74e166679b1f49ee; }, function (v) { return $ac3ccf23d31b45d6$export$74e166679b1f49ee = v; });
var $ac3ccf23d31b45d6$export$1e511d4a378977f5;
var $ac3ccf23d31b45d6$export$9489db5f14593d18;
var $ac3ccf23d31b45d6$export$74e166679b1f49ee;
"use strict";
$ac3ccf23d31b45d6$export$1e511d4a378977f5 = true;
$ac3ccf23d31b45d6$export$9489db5f14593d18 = $ac3ccf23d31b45d6$export$74e166679b1f49ee = void 0;

var $ac3ccf23d31b45d6$var$_react = $ac3ccf23d31b45d6$var$_interopRequireWildcard((parcelRequire("2xPiy")));
function $ac3ccf23d31b45d6$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($ac3ccf23d31b45d6$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $ac3ccf23d31b45d6$var$SkeletonContext = $ac3ccf23d31b45d6$export$74e166679b1f49ee = /*#__PURE__*/ $ac3ccf23d31b45d6$var$_react["default"].createContext();
var $ac3ccf23d31b45d6$var$useSkeleton = $ac3ccf23d31b45d6$export$9489db5f14593d18 = function useSkeleton() {
    return (0, $ac3ccf23d31b45d6$var$_react.useContext)($ac3ccf23d31b45d6$var$SkeletonContext);
};


var $d39d1785a6a89a87$export$1e511d4a378977f5;
var $d39d1785a6a89a87$export$e4ecddc59e33f387;
"use strict";
$d39d1785a6a89a87$export$1e511d4a378977f5 = true;
$d39d1785a6a89a87$export$e4ecddc59e33f387 = void 0;

var $d39d1785a6a89a87$var$_styledComponents = $d39d1785a6a89a87$var$_interopRequireDefault((parcelRequire("iA1nz")));


function $d39d1785a6a89a87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
// Styling a div directly rather than just using
// a Box since Box itself will react to a SkeletonContext
// and we don't want that here.
var $d39d1785a6a89a87$var$StyledSkeleton = $d39d1785a6a89a87$export$e4ecddc59e33f387 = $d39d1785a6a89a87$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledSkeleton",
    componentId: "sc-1omqm6u-0"
})([
    "display:flex;box-sizing:border-box;",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], $4113023f9e0bafa0$exports.genericStyles, function(props) {
    return props.background && (0, $4113023f9e0bafa0$exports.backgroundStyle)(props.background, props.theme);
}, function(props) {
    var _props$theme$text;
    return (0, $4113023f9e0bafa0$exports.heightStyle)(props.heightProp || ((_props$theme$text = props.theme.text) == null || (_props$theme$text = _props$theme$text.medium) == null ? void 0 : _props$theme$text.height), props.theme);
}, function(props) {
    return (0, $4113023f9e0bafa0$exports.widthStyle)(props.widthProp || '100%', props.theme);
}, function(props) {
    return props.pad && (0, $4113023f9e0bafa0$exports.edgeStyle)('padding', props.pad, props.responsive, props.theme.box.responsiveBreakpoint, props.theme);
}, function(props) {
    return props.round && (0, $4113023f9e0bafa0$exports.roundStyle)(props.round, props.responsive, props.theme);
}, function(props) {
    var _props$theme;
    return (_props$theme = props.theme) == null || (_props$theme = _props$theme.skeleton) == null ? void 0 : _props$theme.extend;
}, function(props) {
    return props.responsiveSize && (0, $d65b270127c3c07e$export$2180d12f0a299a89)(props.responsiveSize.breakpoint, (0, $4113023f9e0bafa0$exports.heightStyle)(props.responsiveSize.height, props.theme), props.responsive);
});


var $c2bb495fd818831f$export$1e511d4a378977f5;
var $c2bb495fd818831f$export$b86e7a765e389e8f;
"use strict";
$c2bb495fd818831f$export$1e511d4a378977f5 = true;
$c2bb495fd818831f$export$b86e7a765e389e8f = void 0;

var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");
var $4e2055db6f77c198$export$1e511d4a378977f5;
var $4e2055db6f77c198$export$e8748c6a27b910dc;
var $4e2055db6f77c198$export$582fa4e2a9b13dde;
var $4e2055db6f77c198$export$9c21a3269931e1e6;
"use strict";
$4e2055db6f77c198$export$1e511d4a378977f5 = true;
$4e2055db6f77c198$export$e8748c6a27b910dc = $4e2055db6f77c198$export$582fa4e2a9b13dde = $4e2055db6f77c198$export$9c21a3269931e1e6 = void 0;

var $35181ae64da75991$export$1e511d4a378977f5;
var $35181ae64da75991$export$80d376111cc09ad7;
var $35181ae64da75991$export$e2253033e6e1df16;
"use strict";
$35181ae64da75991$export$1e511d4a378977f5 = true;
$35181ae64da75991$export$80d376111cc09ad7 = $35181ae64da75991$export$e2253033e6e1df16 = void 0;


























function $35181ae64da75991$var$_extends() {
    return $35181ae64da75991$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $35181ae64da75991$var$_extends.apply(null, arguments);
}
var $35181ae64da75991$var$brandColor = '#7D4CDB';
var $35181ae64da75991$var$accentColors = [
    '#6FFFB0',
    '#FD6FFF',
    '#81FCED',
    '#FFCA58'
];
var $35181ae64da75991$var$neutralColors = [
    '#00873D',
    '#3D138D',
    '#00739D',
    '#A2423D'
];
var $35181ae64da75991$var$statusColors = {
    critical: '#EB0000',
    error: '#B30000',
    warning: '#C27B00',
    ok: '#009E67',
    unknown: '#919191',
    disabled: '#CCCCCC'
};
var $35181ae64da75991$var$darkColors = [
    '#333333',
    '#555555',
    '#777777',
    '#999999',
    '#999999',
    '#999999'
];
var $35181ae64da75991$var$lightColors = [
    '#F8F8F8',
    '#F2F2F2',
    '#EDEDED',
    '#DADADA',
    '#DADADA',
    '#DADADA'
];
var $35181ae64da75991$var$focusColor = $35181ae64da75991$var$accentColors[0];
var $35181ae64da75991$var$colors = {
    active: 'rgba(221, 221, 221, 0.5)',
    'background-back': {
        dark: '#33333308',
        light: '#EDEDED'
    },
    'background-front': {
        dark: '#444444',
        light: '#FFFFFF'
    },
    'background-contrast': {
        light: '#33333310',
        dark: '#FFFFFF18'
    },
    'active-background': 'background-contrast',
    'active-text': 'text-strong',
    black: '#000000',
    border: {
        dark: 'rgba(255, 255, 255, 0.33)',
        light: 'rgba(0, 0, 0, 0.33)'
    },
    brand: $35181ae64da75991$var$brandColor,
    control: {
        dark: 'accent-1',
        light: 'brand'
    },
    focus: $35181ae64da75991$var$focusColor,
    'graph-0': 'accent-1',
    'graph-1': 'neutral-1',
    'graph-2': 'neutral-2',
    'graph-3': 'neutral-3',
    'graph-4': 'neutral-4',
    placeholder: '#AAAAAA',
    selected: 'brand',
    text: {
        dark: '#f8f8f8',
        light: '#444444'
    },
    'text-strong': {
        dark: '#FFFFFF',
        light: '#000000'
    },
    'text-weak': {
        dark: '#CCCCCC',
        light: '#555555'
    },
    'text-xweak': {
        dark: '#BBBBBB',
        light: '#666666'
    },
    icon: {
        dark: '#f8f8f8',
        light: '#666666'
    },
    'selected-background': 'brand',
    'selected-text': 'text-strong',
    white: '#FFFFFF'
};
var $35181ae64da75991$var$colorArray = function colorArray(array, prefix) {
    return array.forEach(function(color, index) {
        $35181ae64da75991$var$colors[prefix + "-" + (index + 1)] = color;
    });
};
$35181ae64da75991$var$colorArray($35181ae64da75991$var$accentColors, 'accent');
$35181ae64da75991$var$colorArray($35181ae64da75991$var$darkColors, 'dark');
$35181ae64da75991$var$colorArray($35181ae64da75991$var$lightColors, 'light');
$35181ae64da75991$var$colorArray($35181ae64da75991$var$neutralColors, 'neutral');
Object.keys($35181ae64da75991$var$statusColors).forEach(function(color) {
    $35181ae64da75991$var$colors["status-" + color] = $35181ae64da75991$var$statusColors[color];
});
var $35181ae64da75991$var$generate = $35181ae64da75991$export$80d376111cc09ad7 = function generate(baseSpacing, scale) {
    if (baseSpacing === void 0) baseSpacing = 24;
    if (scale === void 0) scale = 6;
    // 24
    var baseFontSize = baseSpacing * 0.75; // 18
    var fontScale = baseSpacing / scale; // 4
    var fontSizing = function fontSizing(factor) {
        return {
            size: baseFontSize + factor * fontScale + "px",
            height: baseSpacing + factor * fontScale + "px",
            // maxWidth chosen to be ~50 characters wide
            // see: https://ux.stackexchange.com/a/34125
            maxWidth: baseSpacing * (baseFontSize + factor * fontScale) + "px"
        };
    };
    var borderWidth = 2;
    var controlBorderWidth = 1;
    var result = (0, $ebafa0e8c9355c24$export$6969335ea1e4e77c)($07da00c9c00f6352$export$e2253033e6e1df16, {
        global: {
            active: {
                background: {
                    color: 'active',
                    opacity: 'medium'
                },
                color: {
                    dark: 'white',
                    light: 'black'
                }
            },
            animation: {
                duration: '1s',
                jiggle: {
                    duration: '0.1s'
                }
            },
            // backgrounds: undefined,
            borderSize: {
                xsmall: '1px',
                small: '2px',
                medium: baseSpacing / 6 + "px",
                // 4
                large: baseSpacing / 2 + "px",
                // 12
                xlarge: baseSpacing + "px" // 24
            },
            breakpoints: {
                small: {
                    value: baseSpacing * 32,
                    // 768
                    borderSize: {
                        xsmall: '1px',
                        small: '2px',
                        medium: baseSpacing / 6 + "px",
                        // 4
                        large: baseSpacing / 4 + "px",
                        // 6
                        xlarge: baseSpacing / 2 + "px" // 12
                    },
                    edgeSize: {
                        none: '0px',
                        hair: '1px',
                        // for Chart
                        xxsmall: '2px',
                        xsmall: baseSpacing / 8 + "px",
                        // 3
                        small: baseSpacing / 4 + "px",
                        // 6
                        medium: baseSpacing / 2 + "px",
                        // 12
                        large: baseSpacing + "px",
                        // 24
                        xlarge: baseSpacing * 2 + "px" // 48
                    },
                    // radius: {},
                    size: {
                        xxsmall: baseSpacing + "px",
                        // 24
                        xsmall: baseSpacing * 2 + "px",
                        // 48
                        small: baseSpacing * 4 + "px",
                        // 96
                        medium: baseSpacing * 8 + "px",
                        // 192
                        large: baseSpacing * 16 + "px",
                        // 384
                        xlarge: baseSpacing * 32 + "px",
                        // 768
                        full: '100%'
                    }
                },
                medium: {
                    value: baseSpacing * 64 // 1536
                },
                large: {} // anything above 'medium'
            },
            // Breakpoints used at Server Side Rendering for the initial rendering
            // These values correspond to the theme breakpoints
            deviceBreakpoints: {
                phone: 'small',
                tablet: 'medium',
                computer: 'large'
            },
            colors: $35181ae64da75991$var$colors,
            control: {
                border: {
                    width: controlBorderWidth + "px",
                    radius: '4px',
                    color: 'border'
                },
                disabled: {
                    opacity: 0.3
                }
            },
            // The time to wait after the user stopped typing, measured in ms.
            // A half second (500ms) debounce can be a helpful starting point.
            // You want to give the user time to fill out a field, but capture
            // their attention before they move on past it. 2 second (2000ms)
            // might be too long depending on how fast people type, and 200ms
            // would be an eye blink
            debounceDelay: 500,
            // deprecated: {
            //   backgrounds: [
            //     {
            //       name: string,
            //       message: string,
            //     },
            //   ],
            //   colors: [
            //     {
            //       name: string,
            //       message: string,
            //     },
            //   ],
            //   button: {
            //     kind: [
            //       {
            //         name: string,
            //         message: string,
            //       },
            //     ],
            //   },
            // },
            drop: {
                // intelligentMargin: undefined,
                background: {
                    dark: 'black',
                    light: 'white'
                },
                border: {
                    radius: '0px'
                },
                // margin: undefined
                shadowSize: 'small',
                // shadowSize is deprecated, use 'elevation'
                zIndex: '20'
            },
            edgeSize: {
                none: '0px',
                hair: '1px',
                // for Chart
                xxsmall: baseSpacing / 8 + "px",
                // 3
                xsmall: baseSpacing / 4 + "px",
                // 6
                small: baseSpacing / 2 + "px",
                // 12
                medium: baseSpacing + "px",
                // 24
                large: baseSpacing * 2 + "px",
                // 48
                xlarge: baseSpacing * 4 + "px",
                // 96
                responsiveBreakpoint: 'small'
            },
            elevation: {
                light: {
                    none: 'none',
                    xsmall: '0px 1px 2px rgba(0, 0, 0, 0.20)',
                    small: '0px 2px 4px rgba(0, 0, 0, 0.20)',
                    medium: '0px 4px 8px rgba(0, 0, 0, 0.20)',
                    large: '0px 8px 16px rgba(0, 0, 0, 0.20)',
                    xlarge: '0px 12px 24px rgba(0, 0, 0, 0.20)'
                },
                dark: {
                    none: 'none',
                    xsmall: '0px 2px 2px rgba(255, 255, 255, 0.40)',
                    small: '0px 4px 4px rgba(255, 255, 255, 0.40)',
                    medium: '0px 6px 8px rgba(255, 255, 255, 0.40)',
                    large: '0px 8px 16px rgba(255, 255, 255, 0.40)',
                    xlarge: '0px 12px 24px rgba(255, 255, 255, 0.40)'
                }
            },
            focus: {
                // shadow or outline are required for accessibility
                border: {
                    // remove to only have shadow
                    color: 'focus'
                },
                // outline: { color: undefined, size: undefined },
                shadow: {
                    color: 'focus',
                    size: '2px'
                },
                twoColor: undefined,
                inset: {
                    border: {
                        // remove to only have shadow
                        color: 'focus'
                    },
                    outline: {
                        color: 'focus',
                        size: '2px',
                        offset: '-2px'
                    },
                    shadow: undefined,
                    twoColor: undefined
                }
            },
            font: $35181ae64da75991$var$_extends({}, fontSizing(0)),
            hover: {
                background: {
                    color: 'active',
                    opacity: 'medium'
                },
                color: {
                    dark: 'white',
                    light: 'black'
                }
            },
            input: {
                padding: {
                    horizontal: (0, $d65b270127c3c07e$export$333c2219d71d27ce)(baseSpacing / 2 + "px") - (0, $d65b270127c3c07e$export$333c2219d71d27ce)(controlBorderWidth + "px") + "px",
                    vertical: (0, $d65b270127c3c07e$export$333c2219d71d27ce)(baseSpacing / 2 + "px") - (0, $d65b270127c3c07e$export$333c2219d71d27ce)(controlBorderWidth + "px") + "px"
                },
                font: {
                    // size: undefined,
                    // height: undefined,
                    weight: 600
                },
                // deprecate in v3
                // weight: undefined,
                readOnly: {
                }
            },
            opacity: {
                strong: 0.8,
                medium: 0.4,
                weak: 0.1
            },
            // radius: {},
            selected: {
                background: 'selected',
                color: 'white'
            },
            spacing: baseSpacing + "px",
            size: {
                xxsmall: baseSpacing * 2 + "px",
                // 48
                xsmall: baseSpacing * 4 + "px",
                // 96
                small: baseSpacing * 8 + "px",
                // 192
                medium: baseSpacing * 16 + "px",
                // 384
                large: baseSpacing * 32 + "px",
                // 768
                xlarge: baseSpacing * 48 + "px",
                // 1152
                xxlarge: baseSpacing * 64 + "px",
                // 1536
                full: '100%'
            }
        },
        // icon: {
        //   extend: undefined,
        //   matchSize: undefined,
        //   size: undefined,
        // },
        accordion: {
            icon: {
                container: {
                    pad: {
                        horizontal: 'small'
                    }
                }
            },
            label: {
                container: {
                    pad: {
                        horizontal: 'xsmall'
                    }
                }
            },
            panel: {
            },
            border: {
                side: 'bottom',
                color: 'border'
            },
            heading: {
                level: '4' // level ranges from 1-6
            },
            hover: {
                // background: undefined,
                color: {
                    dark: 'light-4',
                    light: 'dark-3'
                },
                // deprecated
                heading: {
                    color: {
                        dark: 'light-4',
                        light: 'dark-3'
                    }
                }
            },
            icons: {
                collapse: $ef56e12f46c6eb58$export$7dd0724a362def6d,
                expand: $08156255a6733056$export$cd1a8f5a55d5e9d3
            }
        },
        anchor: {
            color: {
                dark: 'accent-1',
                light: 'brand'
            },
            gap: 'small',
            hover: {
                textDecoration: 'underline'
            },
            // icon: {
            //   color: undefined
            // },
            iconOnly: {
                pad: 'small'
            },
            textDecoration: 'none',
            fontWeight: 600
        },
        avatar: {
            // extend: undefined,
            size: {
                xsmall: baseSpacing * 0.75 + "px",
                // 18px
                small: baseSpacing + "px",
                // 24px
                medium: baseSpacing * 2 + "px",
                // default 48px
                large: baseSpacing * 3 + "px",
                // 72px
                xlarge: baseSpacing * 4 + "px",
                // 96px
                '2xl': baseSpacing * 5 + "px",
                // 120px
                '3xl': baseSpacing * 6 + "px",
                // 144px
                '4xl': baseSpacing * 7 + "px",
                // 168px
                '5xl': baseSpacing * 8 + "px" // 192px
            },
            text: {
                size: {
                    xsmall: 'small',
                    // 14px
                    small: 'medium',
                    // 18px
                    medium: 'large',
                    // 22px
                    large: 'xlarge',
                    // 26px
                    xlarge: 'xxlarge',
                    // 34px
                    '2xl': '3xl',
                    // 42px
                    '3xl': '4xl',
                    // 54px
                    '4xl': '5xl',
                    // 70px
                    '5xl': '6xl' // 90px
                }
            }
        },
        box: {
            border: {
                offset: 'xsmall'
            },
            responsiveBreakpoint: 'small' // when we switch rows to columns
        },
        button: {
            intelligentPad: true,
            // background: undefined,
            badge: {
                // align: undefined,,
                container: {
                    background: 'brand'
                },
                size: {
                    medium: baseSpacing + "px" // 24px
                },
                text: {
                    size: {
                        medium: 'small' // 14px
                    }
                }
            },
            busy: {
                gap: 'small'
            },
            gap: 'small',
            size: {
                small: {
                    border: {
                        radius: baseSpacing * 0.75 + "px"
                    },
                    pad: {
                        vertical: baseSpacing / 4 - borderWidth + "px",
                        // 4px
                        horizontal: baseSpacing - borderWidth * 2 + "px" // 20px,
                    }
                },
                medium: {
                    border: {
                        radius: baseSpacing * 0.75 + "px" // 18px
                    },
                    pad: {
                        vertical: baseSpacing / 4 - borderWidth + "px",
                        // 4px
                        horizontal: baseSpacing - borderWidth + "px" // 22px
                    }
                },
                large: {
                    border: {
                        radius: baseSpacing + "px" // 24px
                    },
                    pad: {
                        vertical: baseSpacing / 4 + borderWidth + "px",
                        // 8px
                        horizontal: baseSpacing + borderWidth * 4 + "px" // 32px,
                    }
                }
            },
            border: {
                // color: { dark: undefined, light: undefined }
                width: borderWidth + "px",
                radius: baseSpacing * 0.75 + "px"
            },
            // color: { dark: undefined, light: undefined },
            // elevation: undefined,
            // default: {
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   direction: undefined,
            //   elevation: undefined,
            //   font: {
            //     size: undefined,
            //     weight: undefined,
            //   },
            //   icon: undefined,
            //   padding: {
            //     vertical: undefined,
            //     horizontal: undefined,
            //   },
            //   reverse: undefined,
            //   extend: undefined,
            // },
            // primary: {
            //   font: {
            //     size: undefined,
            //     weight: undefined,
            //   },
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   direction: undefined,
            //   elevation: undefined,
            //   icon: undefined,
            //   padding: {
            //     vertical: undefined,
            //     horizontal: undefined,
            //   },
            //   reverse: undefined,
            //   extend: undefined,
            // },
            // secondary: {
            //   font: {
            //     size: undefined,
            //     weight: undefined,
            //   },
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   direction: undefined,
            //   elevation: undefined,
            //   icon: undefined,
            //   padding: {
            //     vertical: undefined,
            //     horizontal: undefined,
            //   },
            //   reverse: undefined,
            //   extend: undefined,
            // },
            // option: {
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   direction: undefined,
            //   elevation: undefined,
            //   icon: undefined,
            //   padding: {
            //     vertical: undefined,
            //     horizontal: undefined,
            //   },
            //   reverse: undefined,
            //   extend: undefined,
            // },
            active: {
                background: 'active-background',
                //   border: undefined,
                color: 'active-text'
            },
            disabled: {
                //   background: undefined,
                //   border: undefined,
                //   color: undefined,
                opacity: 0.3
            },
            // hover: {
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   extend: undefined,
            //   default: {},
            //   primary: {},
            //   secondary: {},
            // },
            padding: {
                vertical: baseSpacing / 4 - borderWidth + "px",
                horizontal: baseSpacing - borderWidth + "px"
            },
            transition: {
                timing: 'ease-in-out',
                duration: 0.1,
                properties: [
                    'color',
                    'background-color',
                    'border-color',
                    'box-shadow'
                ]
            },
            skeleton: {
                width: {
                    min: '100px'
                }
            }
        },
        calendar: {
            day: {
                // adjacent: {
                //   color: undefined,
                // },
                hover: {
                    background: 'active-background'
                },
                selected: {
                    // background: undefined,
                    // color: undefined,
                    font: {
                        weight: 'bold'
                    }
                },
                inRange: {
                    // color: undefined,
                    font: {
                        weight: 'bold'
                    }
                }
            },
            // range: {
            //   background: undefined,
            // },
            // daySize must align with global.size
            small: {
                // day: {
                //   round: undefined,
                // },
                // range: {
                //   round: undefined,
                //   start: {
                //     round: undefined,
                //   },
                //   end: {
                //     round: undefined,
                //   },
                // },
                // title: {},
                fontSize: baseFontSize - fontScale + "px",
                title: {
                    container: {
                        pad: {
                            horizontal: 'xsmall'
                        }
                    }
                },
                lineHeight: 1.375,
                daySize: baseSpacing * 8 / 7 + "px",
                slideDuration: '0.2s'
            },
            medium: {
                // day: {
                //   round: undefined,
                // },
                // range: {
                //   round: undefined,
                //   start: {
                //     round: undefined,
                //   },
                //   end: {
                //     round: undefined,
                //   },
                // },
                // title: {},
                fontSize: baseFontSize + "px",
                title: {
                    container: {
                        pad: {
                            horizontal: 'small'
                        }
                    }
                },
                lineHeight: 1.45,
                daySize: baseSpacing * 16 / 7 + "px",
                slideDuration: '0.5s'
            },
            large: {
                // day: {
                //   round: undefined,
                // },
                // range: {
                //   round: undefined,
                //   start: {
                //     round: undefined,
                //   },
                //   end: {
                //     round: undefined,
                //   },
                // },
                // title: {},
                fontSize: baseFontSize + 3 * fontScale + "px",
                title: {
                    container: {
                        pad: {
                            horizontal: 'medium'
                        }
                    }
                },
                lineHeight: 1.11,
                daySize: baseSpacing * 32 / 7 + "px",
                slideDuration: '0.8s'
            },
            icons: {
                previous: $2ce319e09672cf9d$export$a499fb457891d86e,
                next: $395d1107a5183b93$export$b820fc49f2736e85,
                small: {
                    previous: $e416b67dbaf66fc1$export$a14ca6bc44f029a6,
                    next: $0736b9499c5aa664$export$a8d2f61b02c7b95f
                }
            },
            heading: {
                level: '4'
            } // level ranges from 1-6
        },
        card: {
            container: {
                round: 'small',
                elevation: 'small'
            },
            // hover: {
            //   container: {
            //     elevation: undefined,
            //   },
            // },
            header: {},
            body: {},
            footer: {}
        },
        cards: {
            container: {
                // any box props
                gap: 'xsmall'
            },
            grid: {
                columns: 'small',
                gap: 'medium'
            }
        },
        carousel: {
            icons: {
                current: $6a2802ef8f2bd5f5$export$8bc67ae85ef4b74f,
                next: $395d1107a5183b93$export$b820fc49f2736e85,
                previous: $2ce319e09672cf9d$export$a499fb457891d86e
            },
            animation: {
                duration: 1000
            },
            disabled: {
                icons: {
                }
            }
        },
        chart: {
            color: 'graph-0',
            height: 'small',
            thickness: 'medium',
            width: 'medium'
        },
        checkBox: {
            border: {
                color: {
                    dark: 'rgba(255, 255, 255, 0.5)',
                    light: 'rgba(0, 0, 0, 0.15)'
                },
                width: '2px'
            },
            check: {
                // extend: undefined,
                radius: '4px',
                thickness: '4px'
            },
            label: {
                align: 'center'
            },
            // color: { dark: undefined, light: undefined },
            // extend: undefined,
            gap: 'small',
            hover: {
                border: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    }
                }
            },
            icon: {
            },
            icons: {
            },
            // pad: undefined,
            size: baseSpacing + "px",
            toggle: {
                // background: undefined
                color: {
                    dark: '#d9d9d9',
                    light: '#d9d9d9'
                },
                knob: {
                },
                radius: baseSpacing + "px",
                size: baseSpacing * 2 + "px"
            }
        },
        checkBoxGroup: {
            container: {
                //   // any box props
                //   extend: undefined,
                gap: 'small'
            }
        },
        clock: {
            analog: {
                // extend: undefined,
                hour: {
                    color: {
                        dark: 'light-2',
                        light: 'dark-3'
                    },
                    width: baseSpacing / 3 + "px",
                    size: baseSpacing + "px",
                    shape: 'round'
                },
                minute: {
                    color: {
                        dark: 'light-4',
                        light: 'dark-3'
                    },
                    width: baseSpacing / 6 + "px",
                    size: Math.round(baseSpacing / 2) + "px",
                    shape: 'round'
                },
                second: {
                    color: {
                        dark: 'accent-1',
                        light: 'accent-1'
                    },
                    width: baseSpacing / 8 + "px",
                    size: Math.round(baseSpacing / 2.666) + "px",
                    shape: 'round'
                },
                size: {
                    xsmall: baseSpacing * 2 + "px",
                    small: baseSpacing * 3 + "px",
                    medium: baseSpacing * 4 + "px",
                    large: baseSpacing * 6 + "px",
                    xlarge: baseSpacing * 9 + "px",
                    xxlarge: baseSpacing * 12 + "px",
                    huge: baseSpacing * 12 + "px" // kept for backwards compatibility
                }
            },
            digital: {
                text: {
                    xsmall: {
                        size: baseFontSize - 2 * fontScale + "px",
                        height: 1.5
                    },
                    small: {
                        size: baseFontSize - fontScale + "px",
                        height: 1.43
                    },
                    medium: {
                        size: baseFontSize + "px",
                        height: 1.375
                    },
                    large: {
                        size: baseFontSize + fontScale + "px",
                        height: 1.167
                    },
                    xlarge: {
                        size: baseFontSize + 2 * fontScale + "px",
                        height: 1.1875
                    },
                    xxlarge: {
                        size: baseFontSize + 4 * fontScale + "px",
                        height: 1.125
                    }
                }
            }
        },
        collapsible: {
            minSpeed: 200,
            baseline: 500
        },
        data: {
            // button: {
            //   kind: undefined,
            // },
            drop: {
                pad: 'small'
            },
            toolbar: {
                gap: 'medium'
            }
        },
        dataChart: {
            // colors: [],
            gap: 'small',
            // granularity: {
            //   y: {},
            // },
            detail: {
                gap: 'xsmall',
                pad: 'small'
            },
            halfPad: {
                xlarge: 'large',
                large: 'medium',
                medium: 'small',
                small: 'xsmall',
                xsmall: 'xxsmall'
            },
            legend: {
                margin: {
                    top: 'small'
                },
                gap: 'small',
                item: {
                    gap: 'xsmall',
                    pad: {
                        horizontal: 'small',
                        vertical: 'xsmall'
                    }
                }
            },
            // orderedSizes: undefined,
            size: {
                height: 'small'
            },
            thickness: {
                veryDense: 'hair',
                dense: 'xsmall',
                heavy: 'small',
                moderate: 'medium',
                light: 'large',
                sparse: 'xlarge'
            },
            thicknessPad: {
                xlarge: 'large',
                large: 'medium',
                medium: 'small',
                small: 'xsmall',
                xsmall: 'xxsmall'
            }
        },
        dataFilter: {
            rangeSelector: {
                size: 'full',
                round: 'small'
            },
            selectMultiple: {
                dropHeight: 'medium'
            }
        },
        dataFilters: {
            // icons: {
            //   close: undefined,
            //   filter: undefined,
            // }
            footer: {
                actions: {
                    margin: {
                        top: 'medium'
                    },
                    gap: 'small'
                }
            },
            clearControl: {
                margin: {
                    start: 'small'
                }
            },
            pad: 'medium',
            width: {
                min: 'medium'
            }
        },
        dateInput: {
            button: {
                margin: 'small'
            },
            container: {
                round: 'xxsmall'
            },
            icon: {
                // calendar: undefined,
                size: 'medium'
            }
        },
        dataSearch: {
        },
        dataSort: {
        },
        dataSummary: {
            margin: {
                vertical: 'xsmall'
            },
            separator: {
                margin: {
                    horizontal: 'small'
                }
            }
        },
        dataTable: {
            // body: {
            //   extend: undefined,
            //   row: {
            //     extend: undefined,
            //   }
            //   selected: undefined,
            // },
            expand: {
                size: 'xxsmall'
            },
            pinned: {
                // body: {
                //    background: undefined,
                //    extend: undefined,
                // },
                header: {
                    background: {
                        opacity: 'strong'
                    }
                },
                footer: {
                    background: {
                        opacity: 'strong'
                    }
                }
            },
            container: {
                // any box props
                gap: 'xsmall'
            },
            groupHeader: {
            },
            groupEnd: {
                border: {
                    side: 'bottom',
                    size: 'xsmall'
                }
            },
            header: {
                // background: undefined,
                // border: undefined,
                // color: undefined,
                // extend: undefined,
                // font: {
                //   weight: undefined,
                //   size: undefined,
                // },
                gap: 'small',
                // hover: {
                //   background: undefined,
                // },
                // pad: undefined,
                units: {
                    color: 'text-xweak',
                    margin: {
                        left: 'xsmall'
                    },
                    alignSelf: 'end'
                }
            },
            icons: {
                ascending: $08156255a6733056$export$cd1a8f5a55d5e9d3,
                contract: $ef56e12f46c6eb58$export$7dd0724a362def6d,
                descending: $ef56e12f46c6eb58$export$7dd0724a362def6d,
                expand: $08156255a6733056$export$cd1a8f5a55d5e9d3
            },
            primary: {
                weight: 'bold'
            },
            resize: {
                border: {
                    color: 'border',
                    side: 'end'
                },
                // hover: {
                //   border: {
                //     color: undefined,
                //     side: undefined,
                //     size: undefined,
                //   },
                // },
                padding: {
                    vertical: 'xsmall'
                }
            },
            search: {
                pad: {
                    left: 'small'
                },
                text: {
                    pad: {
                        horizontal: 'small'
                    }
                }
            },
            sort: {
                gap: 'xsmall'
            }
        },
        dataTableColumns: {
            // icons: {
            //   control: undefined,
            //   pinned: undefined,
            //   search: undefined,
            // }
            tabs: {
                pad: 'small'
            },
            selectColumns: {
                pad: {
                    vertical: 'small'
                },
                gap: 'xsmall'
            },
            orderColumns: {
                pad: {
                    top: 'small'
                }
            }
        },
        diagram: {
            // extend: undefined,
            line: {
                color: 'graph-0'
            }
        },
        distribution: {
            gap: 'xsmall'
        },
        // drop: {
        //   extend: undefined,
        //   maxHeight: undefined,
        // },
        fileInput: {
            anchor: {
                margin: 'small'
            },
            // background: {},
            border: {
                // color: undefined,
                side: 'all',
                size: 'small',
                style: 'dashed'
            },
            dragOver: {
                border: {
                    color: 'control'
                }
            },
            hover: {
                border: {
                    color: 'brand'
                }
            },
            icons: {
                // error: undefined,
                remove: $da76b8daacd39c4f$export$fe20cfcdd41aa0ef
            },
            // pad: {},
            label: {
                gap: 'xsmall',
                margin: 'small'
            },
            message: {
                margin: 'small'
            }
        },
        footer: {
            gap: 'medium'
        },
        formField: {
            // [inputname]: {
            //  container: {
            //    extend: undefined,
            //   }
            // }
            border: {
                color: 'border',
                error: {
                    color: {
                        dark: 'white',
                        light: 'status-critical'
                    }
                },
                position: 'inner',
                side: 'bottom'
            },
            // checkBox: {
            //   pad: undefined,
            // },
            content: {
                // margin: undefined,
                pad: 'small'
            },
            disabled: {
                background: {
                    color: 'status-disabled',
                    opacity: 'medium'
                }
            },
            focus: {
                containerFocus: true
            },
            error: {
                color: 'status-critical',
                margin: {
                    vertical: 'xsmall',
                    horizontal: 'small'
                }
            },
            // extend: undefined,
            help: {
                color: 'dark-2',
                margin: {
                    start: 'small'
                }
            },
            info: {
                color: 'text-xweak',
                margin: {
                    vertical: 'xsmall',
                    horizontal: 'small'
                }
            },
            label: {
                margin: {
                    vertical: 'xsmall',
                    horizontal: 'small'
                }
            },
            margin: {
                bottom: 'small'
            },
            // round: undefined,
            survey: {
                label: {
                    margin: {
                        bottom: 'xsmall'
                    },
                    size: 'medium',
                    weight: 400
                }
            }
        },
        grommet: {
        },
        header: {
            sticky: {
                zIndex: '20'
            },
            gap: 'medium'
        },
        heading: {
            // color: undefined,
            font: {
            },
            level: {
                1: {
                    font: {
                    },
                    small: $35181ae64da75991$var$_extends({}, fontSizing(4)),
                    medium: $35181ae64da75991$var$_extends({}, fontSizing(8)),
                    large: $35181ae64da75991$var$_extends({}, fontSizing(16)),
                    xlarge: $35181ae64da75991$var$_extends({}, fontSizing(24))
                },
                2: {
                    font: {
                    },
                    small: $35181ae64da75991$var$_extends({}, fontSizing(2)),
                    medium: $35181ae64da75991$var$_extends({}, fontSizing(4)),
                    large: $35181ae64da75991$var$_extends({}, fontSizing(8)),
                    xlarge: $35181ae64da75991$var$_extends({}, fontSizing(12))
                },
                3: {
                    font: {
                    },
                    small: $35181ae64da75991$var$_extends({}, fontSizing(1)),
                    medium: $35181ae64da75991$var$_extends({}, fontSizing(2)),
                    large: $35181ae64da75991$var$_extends({}, fontSizing(4)),
                    xlarge: $35181ae64da75991$var$_extends({}, fontSizing(6))
                },
                4: {
                    font: {
                    },
                    small: $35181ae64da75991$var$_extends({}, fontSizing(0)),
                    medium: $35181ae64da75991$var$_extends({}, fontSizing(0)),
                    large: $35181ae64da75991$var$_extends({}, fontSizing(0)),
                    xlarge: $35181ae64da75991$var$_extends({}, fontSizing(0))
                },
                5: {
                    font: {
                    },
                    small: $35181ae64da75991$var$_extends({}, fontSizing(-0.5)),
                    medium: $35181ae64da75991$var$_extends({}, fontSizing(-0.5)),
                    large: $35181ae64da75991$var$_extends({}, fontSizing(-0.5)),
                    xlarge: $35181ae64da75991$var$_extends({}, fontSizing(-0.5))
                },
                6: {
                    font: {
                    },
                    small: $35181ae64da75991$var$_extends({}, fontSizing(-1)),
                    medium: $35181ae64da75991$var$_extends({}, fontSizing(-1)),
                    large: $35181ae64da75991$var$_extends({}, fontSizing(-1)),
                    xlarge: $35181ae64da75991$var$_extends({}, fontSizing(-1))
                }
            },
            responsiveBreakpoint: 'small',
            // when we scale the font size down
            weight: 600,
            skeleton: {
                width: {
                    min: '150px',
                    max: '200px'
                }
            }
        },
        layer: {
            background: {
                dark: 'black',
                light: 'white'
            },
            border: {
                radius: '4px'
            },
            container: {
                // elevation: undefined,
                zIndex: '20',
                height: {
                    min: 'xxsmall'
                }
            },
            // extend: undefined,
            overlay: {
                background: 'rgba(0, 0, 0, 0.5)'
            },
            responsiveBreakpoint: 'small',
            // when Layer takes over the full screen
            zIndex: '20'
        },
        list: {
            container: {
                // any box props
                gap: 'xsmall'
            },
            item: {
                // background: undefined,
                border: 'horizontal',
                disabled: {
                    color: 'status-disabled',
                    cursor: 'default'
                },
                gap: 'medium',
                pinned: {
                    background: 'background-contrast',
                    icon: {
                        size: 'medium',
                        pad: 'small'
                    }
                },
                pad: {
                    horizontal: 'medium',
                    vertical: 'small'
                }
            },
            primaryKey: {
                // any text props
                weight: 'bold'
            },
            icons: {
                down: $08156255a6733056$export$cd1a8f5a55d5e9d3,
                up: $ef56e12f46c6eb58$export$7dd0724a362def6d,
                pin: $5c441c37eb1f2356$export$5423378d28f4447c
            }
        },
        maskedInput: {
        },
        menu: {
            // background: undefined,
            // extend: undefined,
            // item: undefined,
            drop: {
                align: {
                    top: 'top',
                    left: 'left'
                }
            },
            // container: {
            //   // any box props
            // },
            group: {
                container: {
                    pad: {
                        vertical: 'xsmall'
                    }
                },
                separator: {
                    color: 'border',
                    size: 'xsmall',
                    pad: {
                        horizontal: 'small'
                    }
                }
            },
            icons: {
                down: $08156255a6733056$export$cd1a8f5a55d5e9d3
            }
        },
        meter: {
            background: {
                color: 'light-2',
                opacity: 'medium'
            },
            color: 'graph-0'
        },
        nameValueList: {
            gap: {
                column: 'large',
                row: 'small'
            },
            pair: {
                column: {
                    gap: {
                        column: 'large',
                        row: 'medium'
                    }
                }
            },
            name: {
                width: 'small'
            },
            value: {
                width: 'medium'
            }
        },
        nameValuePair: {
            column: {
                gap: 'xxsmall'
            },
            name: {
                // any text props
                color: 'text',
                weight: 'bold'
            },
            value: {
                // any text props
                color: 'text'
            }
        },
        nav: {
            gap: 'medium'
        },
        notification: {
            actions: {
                // any anchor props
                margin: {
                    right: 'xsmall'
                }
            },
            direction: 'column',
            container: {
                // any box props
                round: 'xsmall',
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                },
                background: {
                    color: 'background-front'
                }
            },
            gap: 'small',
            global: {
                direction: 'row',
                container: {
                    // any box props
                    round: 'none',
                    pad: {
                        horizontal: 'large',
                        vertical: 'xsmall'
                    }
                }
            },
            toast: {
                // direction: undefined,
                container: {
                    // any box props
                    elevation: 'medium',
                    width: 'medium'
                },
                layer: {
                    position: 'top',
                    margin: 'medium'
                },
                time: 8000
            },
            iconContainer: {
                // any box props
                pad: {
                    right: 'small'
                },
                flex: false
            },
            textContainer: {
                // any box props
                gap: 'medium'
            },
            title: {
                // any text props
                weight: 'bold'
            },
            message: {
                // any text props
                margin: 'none',
                // fill: undefined,
                text: {
                    margin: {
                        right: 'xsmall'
                    }
                }
            },
            close: {
                icon: $da76b8daacd39c4f$export$fe20cfcdd41aa0ef
            },
            critical: {
                icon: $845b68b8616c04e1$export$32f199c975b240fb,
                background: {
                    color: 'status-critical',
                    opacity: 'weak'
                },
                color: 'status-critical',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            warning: {
                icon: $b90cae8b1dd80e4e$export$ead8eef644cb6ffc,
                background: {
                    color: 'status-warning',
                    opacity: 'weak'
                },
                color: 'status-warning',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            normal: {
                icon: $e82314c0e829446b$export$a09254dff7a942de,
                background: {
                    color: 'status-ok',
                    opacity: 'weak'
                },
                color: 'status-ok',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            info: {
                icon: $8943ffd4a7fe1a81$export$7036cd8426a1245b,
                background: 'background-contrast',
                color: 'text-strong',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            unknown: {
                icon: $cf8d6a20ce9c71c6$export$525b879776bb0ada,
                background: {
                    color: 'status-unknown',
                    opacity: 'weak'
                },
                color: 'status-unknown',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            // deprecate "undefined" in v3
            // and if undefined, no icon
            undefined: {
                icon: $cf8d6a20ce9c71c6$export$525b879776bb0ada,
                // background: undefined,
                color: 'status-unknown'
            }
        },
        page: {
            wide: {
                alignSelf: 'center',
                width: {
                    min: 'medium',
                    max: 'xxlarge'
                },
                small: {
                    pad: {
                        horizontal: 'large'
                    }
                },
                medium: {
                    pad: {
                        horizontal: 'medium'
                    }
                },
                large: {
                    pad: {
                        horizontal: 'large'
                    }
                }
            },
            narrow: {
                alignSelf: 'center',
                width: {
                    min: 'medium',
                    max: 'large'
                },
                small: {
                    pad: {
                        horizontal: 'large'
                    }
                },
                medium: {
                    pad: {
                        horizontal: 'medium'
                    }
                },
                large: {
                    pad: {
                        horizontal: 'large'
                    }
                }
            },
            full: {
                alignSelf: 'start',
                width: {
                    min: 'medium',
                    max: '100%'
                },
                small: {
                    pad: {
                        horizontal: 'large'
                    }
                },
                medium: {
                    pad: {
                        horizontal: 'medium'
                    }
                },
                large: {
                    pad: {
                        horizontal: 'large'
                    }
                }
            }
        },
        pageHeader: {
            actions: {
                // any box props
                align: 'end'
            },
            pad: {
                top: 'large',
                bottom: 'medium'
            },
            parent: {
                // any box props
                align: 'start'
            },
            responsive: {
                actions: {
                    // any box props
                    align: 'start',
                    pad: {
                        top: 'small'
                    }
                },
                areas: [
                    [
                        'parent'
                    ],
                    [
                        'title'
                    ],
                    [
                        'subtitle'
                    ],
                    [
                        'actions'
                    ]
                ],
                breakpoints: [
                    'small'
                ],
                columns: [
                    'auto'
                ],
                rows: [
                    'auto'
                ]
            },
            subtitle: {
                // any paragraph props
                margin: 'none'
            },
            title: {
                // any heading props
                margin: 'none',
                fill: true
            },
            size: {
                small: {
                    pad: {
                        top: 'medium',
                        bottom: 'small'
                    },
                    subtitle: {
                        size: 'small'
                    },
                    title: {
                        size: 'small'
                    }
                },
                // medium: {
                //   // pad: undefined,
                //   // subtitle: {},
                //   // title: {},
                // },
                large: {
                    pad: {
                        top: 'xlarge',
                        bottom: 'large'
                    },
                    subtitle: {
                        size: 'large'
                    },
                    title: {
                        size: 'large'
                    }
                }
            },
            small: {
                areas: [
                    [
                        'parent',
                        'parent'
                    ],
                    [
                        'title',
                        'actions'
                    ],
                    [
                        'subtitle',
                        'actions'
                    ]
                ],
                columns: [
                    [
                        'small',
                        'flex'
                    ],
                    'auto'
                ],
                rows: [
                    'auto',
                    'auto',
                    'auto'
                ],
                gap: {
                    row: 'xsmall',
                    column: 'large'
                }
            },
            medium: {
                areas: [
                    [
                        'parent',
                        'parent'
                    ],
                    [
                        'title',
                        'actions'
                    ],
                    [
                        'subtitle',
                        'actions'
                    ]
                ],
                columns: [
                    [
                        'medium',
                        'flex'
                    ],
                    'auto'
                ],
                rows: [
                    'auto',
                    'auto',
                    'auto'
                ],
                gap: {
                    row: 'xsmall',
                    column: 'medium'
                }
            },
            large: {
                areas: [
                    [
                        'parent',
                        'parent'
                    ],
                    [
                        'title',
                        'actions'
                    ],
                    [
                        'subtitle',
                        'actions'
                    ]
                ],
                columns: [
                    [
                        'medium',
                        'flex'
                    ],
                    'auto'
                ],
                rows: [
                    'auto',
                    'auto',
                    'auto'
                ],
                gap: {
                    row: 'xsmall',
                    column: 'large'
                }
            }
        },
        pagination: {
            button: {
                active: {
                    background: {
                        color: 'active-background'
                    }
                },
                color: 'text-strong',
                hover: {
                    background: {
                        color: 'background-contrast'
                    },
                    color: undefined
                },
                size: {
                    small: {
                        border: {
                            radius: baseSpacing / 8 + "px",
                            // 3
                            width: '2px'
                        },
                        pad: {
                            vertical: "4px",
                            horizontal: "4px"
                        },
                        font: $35181ae64da75991$var$_extends({}, fontSizing(-1)),
                        height: baseSpacing * 1.25 + "px",
                        width: baseSpacing * 1.25 + "px"
                    },
                    medium: {
                        border: {
                            radius: baseSpacing / 6 + "px",
                            // 4
                            width: '2px'
                        },
                        pad: {
                            vertical: "4px",
                            horizontal: "4px"
                        },
                        font: $35181ae64da75991$var$_extends({}, fontSizing(0)),
                        height: baseSpacing * 1.5 + "px",
                        width: baseSpacing * 1.5 + "px"
                    },
                    large: {
                        border: {
                            radius: baseSpacing / 4 + "px",
                            // 6
                            width: '2px'
                        },
                        pad: {
                            vertical: "4px",
                            horizontal: "4px"
                        },
                        font: $35181ae64da75991$var$_extends({}, fontSizing(1)),
                        height: baseSpacing * 2 + "px",
                        width: baseSpacing * 2 + "px"
                    }
                }
            },
            container: {
                gap: {
                    column: 'xsmall',
                    row: 'small'
                }
            },
            controls: {
                align: 'center',
                direction: 'row',
                gap: 'xxsmall',
                margin: 'none',
                pad: 'none'
            },
            icons: {
                // color: undefined,
                next: $395d1107a5183b93$export$b820fc49f2736e85,
                previous: $2ce319e09672cf9d$export$a499fb457891d86e
            },
            step: {
                container: {
                    gap: 'xsmall'
                }
            }
        },
        paragraph: {
            font: {
            },
            small: $35181ae64da75991$var$_extends({}, fontSizing(-1)),
            medium: $35181ae64da75991$var$_extends({}, fontSizing(0)),
            large: $35181ae64da75991$var$_extends({}, fontSizing(1)),
            xlarge: $35181ae64da75991$var$_extends({}, fontSizing(2)),
            xxlarge: $35181ae64da75991$var$_extends({}, fontSizing(4)),
            skeleton: {
                gap: 'xsmall'
            }
        },
        thumbsRating: {
        },
        spinner: {
            container: {
                animation: 'rotateRight',
                color: 'brand',
                pad: 'small',
                round: 'full',
                size: 'small'
            },
            // icon: undefined
            responsive: true,
            size: {
                xsmall: baseSpacing * 0.75 + "px",
                small: baseSpacing + "px",
                // default 24
                medium: baseSpacing * 2 + "px",
                large: baseSpacing * 3 + "px",
                xlarge: baseSpacing * 4 + "px"
            }
        },
        radioButton: {
            border: {
                color: {
                    dark: 'rgba(255, 255, 255, 0.5)',
                    light: 'rgba(0, 0, 0, 0.15)'
                },
                width: '2px'
            },
            // background: {
            //   color: undefined,
            // },
            check: {
                radius: '100%'
            },
            // color: undefined,
            hover: {
                // background: {
                //   color: undefined,
                // },
                border: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    }
                }
            },
            icon: {
            },
            icons: {
            },
            gap: 'small',
            size: baseSpacing + "px",
            font: {
            },
            container: {
            }
        },
        radioButtonGroup: {
            // any box props
            container: {
                gap: 'small'
            }
        },
        rangeInput: {
            disabled: {
                opacity: 0.3
            },
            // extend: undefined
            track: {
                height: '4px',
                color: 'border'
            },
            thumb: {
            }
        },
        rangeSelector: {
            background: {
                invert: {
                    color: 'light-4'
                }
            },
            edge: {
            },
            label: {
                margin: {
                    horizontal: 'small'
                }
            }
        },
        select: {
            // background: undefined,
            clear: {
                container: {
                    pad: 'small',
                    background: 'background-contrast'
                },
                // any box props
                text: {
                    color: 'text-weak'
                } // any text props
            },
            container: {
            },
            control: {
            },
            // emptySearchMessage: {
            //   container: {}, // any box props
            //   text: {}, // any text props
            // },
            icons: {
                // color: { dark: undefined, light: undefined },
                margin: {
                    horizontal: 'small'
                },
                down: $08156255a6733056$export$cd1a8f5a55d5e9d3
            },
            // listbox: {
            //   extend: undefined,
            // },
            options: {
                container: {
                    align: 'start',
                    pad: 'small'
                },
                text: {
                    margin: 'none'
                }
            },
            search: {
                pad: 'xsmall'
            },
            // searchInput: undefined,
            step: 20
        },
        selectMultiple: {
            help: {
                container: {
                    pad: 'xsmall'
                }
            },
            maxInline: 5,
            // listbox: {
            //   extend: () => undefined,
            // },
            option: {
                pad: 'xsmall'
            },
            search: {
                pad: 'xsmall'
            },
            showMore: {
                pad: {
                    horizontal: 'small',
                    bottom: 'small',
                    top: 'xsmall'
                }
            },
            summary: {
                gap: 'small',
                height: {
                    min: 'xxsmall'
                },
                pad: 'xsmall',
                showSelectedInline: {
                    pad: {
                        left: 'xsmall',
                        vertical: 'xsmall'
                    }
                }
            }
        },
        sidebar: {
            gap: 'large',
            pad: 'small'
        },
        skeleton: {
            border: false,
            colors: {
                dark: [
                    'background',
                    'background-front'
                ],
                light: [
                    'background',
                    'background-back'
                ]
            }
        },
        skipLinks: {
            position: 'top',
            container: {
                elevation: 'large',
                round: 'small',
                pad: 'medium'
            },
            label: {
                margin: {
                    bottom: 'medium'
                },
                size: 'medium'
            }
        },
        starRating: {
        },
        tab: {
            active: {
                color: 'text'
            },
            // background: undefined,
            border: {
                side: 'bottom',
                size: 'small',
                color: {
                    dark: 'accent-1',
                    light: 'brand'
                },
                active: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    }
                },
                disabled: {
                },
                hover: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    }
                }
            },
            color: 'control',
            // disabled: {
            //   color: undefined,
            // },
            // extend: undefined,
            gap: 'small',
            hover: {
                // background: undefined,
                // extend: undefined,
                color: {
                    dark: 'white',
                    light: 'black'
                }
            },
            margin: {
                vertical: 'xxsmall',
                horizontal: 'small'
            },
            pad: {
                bottom: 'xsmall'
            }
        },
        tabs: {
            // background: undefined,
            // extend: undefined,
            // gap: undefined,
            header: {
                // alignSelf: undefined,
                // background: undefined,
                // border: {
                //   side: undefined,
                //   size: undefined,
                //   style: undefined,
                //   color: undefined,
                // },
                // extend: undefined,
                nextButton: {
                    // icon: undefined,
                    pad: {
                        horizontal: 'small',
                        vertical: 'xsmall'
                    }
                },
                previousButton: {
                    // icon: undefined,
                    pad: {
                        horizontal: 'small',
                        vertical: 'xsmall'
                    }
                }
            },
            panel: {
            },
            step: {
                small: 1,
                medium: 3,
                large: 3
            }
        },
        stepper: {
            indicator: {
                size: 'medium',
                // 'small' | 'medium' | 'large'
                border: {
                    width: '2px'
                }
            },
            label: {
                size: 'medium',
                substep: {
                    size: 'small'
                }
            },
            connector: {
                stroke: {
                    width: '2px'
                }
            },
            description: {
                size: 'small',
                color: 'text-weak'
            },
            helperText: {
                size: 'xsmall',
                color: 'text-weak'
            },
            // States: [component].[state].[element].[property]
            pending: {
                indicator: {
                    background: 'background-front',
                    color: 'text-strong',
                    border: 'text-xweak',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        background: 'background-front',
                        border: 'text-strong'
                    }
                },
                label: {
                    color: 'text'
                },
                connector: {
                    color: 'border'
                }
            },
            current: {
                indicator: {
                    icon: $e82314c0e829446b$export$a09254dff7a942de,
                    iconSize: 'medium',
                    background: 'brand',
                    color: 'white',
                    border: 'brand',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        color: 'white'
                    }
                },
                label: {
                    color: {
                        dark: 'text-strong',
                        light: 'brand'
                    }
                }
            },
            currentCompleted: {
                indicator: {
                    icon: $7aaaa7abc2375846$export$dec84e69d20720b4,
                    iconSize: 'medium',
                    background: 'brand',
                    color: 'white',
                    border: 'brand',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        color: 'white'
                    }
                },
                label: {
                    color: {
                        dark: 'text-strong',
                        light: 'brand'
                    }
                }
            },
            completed: {
                indicator: {
                    icon: $7aaaa7abc2375846$export$dec84e69d20720b4,
                    iconSize: 'medium',
                    background: 'background-front',
                    color: 'brand',
                    border: 'brand',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        background: 'background-front'
                    }
                },
                label: {
                    color: 'text-weak'
                },
                connector: {
                    color: 'brand'
                }
            },
            error: {
                indicator: {
                    icon: $845b68b8616c04e1$export$32f199c975b240fb,
                    background: 'background-front',
                    color: 'status-critical',
                    border: 'status-critical',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        background: 'background-front'
                    }
                },
                label: {
                    color: 'text'
                },
                connector: {
                    color: 'status-critical'
                },
                helperText: {
                    color: 'status-critical'
                }
            },
            currentError: {
                indicator: {
                    icon: $845b68b8616c04e1$export$32f199c975b240fb,
                    background: 'status-critical',
                    color: 'white',
                    border: 'status-critical',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        color: 'white'
                    }
                },
                label: {
                    color: 'status-critical'
                }
            },
            disabled: {
                indicator: {
                    background: 'background-contrast',
                    color: 'text-weak',
                    border: 'border',
                    substep: {
                        iconSize: 'small'
                    }
                },
                label: {
                    color: 'text-weak'
                },
                connector: {
                    color: 'border'
                }
            }
        },
        table: {
            caption: {
                margin: {
                    bottom: 'xxsmall'
                }
            },
            header: {
                align: 'start',
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                },
                border: 'bottom'
            },
            body: {
                align: 'start',
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                }
            },
            // row: {
            //   hover: {
            //     background: undefined,
            //     color: undefined,
            //   },
            // },
            footer: {
                align: 'start',
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                },
                border: 'top'
            }
        },
        tag: {
            // background: undefined,
            border: true,
            // hover: {
            //   background: undefined,
            //   border: undefined,
            // },
            round: 'large',
            // name: undefined,
            pad: {
                horizontal: 'small',
                vertical: 'xsmall'
            },
            remove: {
                margin: {
                    right: 'xsmall'
                }
            },
            separator: ' : ',
            size: {
                xsmall: {
                    pad: {
                        horizontal: baseSpacing / 3 + "px",
                        vertical: 'xxsmall'
                    },
                    icon: {
                        size: baseSpacing * 0.75 + "px"
                    }
                },
                small: {
                    pad: {
                        horizontal: baseSpacing * 0.4 + "px",
                        vertical: 'xxsmall'
                    },
                    icon: {
                        size: baseSpacing * 0.75 + "px"
                    }
                },
                large: {
                    pad: {
                        horizontal: baseSpacing / 3 * 2 + "px",
                        vertical: "xsmall"
                    },
                    icon: {
                        size: baseSpacing * 1.25 + "px"
                    }
                },
                xlarge: {
                    pad: {
                        horizontal: baseSpacing * 0.75 + "px",
                        vertical: 'xsmall'
                    },
                    icon: {
                        size: baseSpacing * 1.5 + "px"
                    }
                }
            },
            value: {
                weight: 600
            },
            icons: {
                remove: $da76b8daacd39c4f$export$fe20cfcdd41aa0ef
            }
        },
        text: {
            font: {
            },
            xsmall: $35181ae64da75991$var$_extends({}, fontSizing(-1.5)),
            small: $35181ae64da75991$var$_extends({}, fontSizing(-1)),
            medium: $35181ae64da75991$var$_extends({}, fontSizing(0)),
            // 18px
            large: $35181ae64da75991$var$_extends({}, fontSizing(1)),
            // 22px
            xlarge: $35181ae64da75991$var$_extends({}, fontSizing(2)),
            xxlarge: $35181ae64da75991$var$_extends({}, fontSizing(4)),
            '2xl': $35181ae64da75991$var$_extends({}, fontSizing(4)),
            '3xl': $35181ae64da75991$var$_extends({}, fontSizing(6)),
            '4xl': $35181ae64da75991$var$_extends({}, fontSizing(9)),
            '5xl': $35181ae64da75991$var$_extends({}, fontSizing(13)),
            '6xl': $35181ae64da75991$var$_extends({}, fontSizing(18)),
            skeleton: {
                width: {
                    width: '100px',
                    min: '100px'
                },
                margin: {
                    vertical: 'xsmall'
                },
                colors: {
                    dark: [
                        'border',
                        'border'
                    ],
                    light: [
                        'background-front',
                        'background-back'
                    ]
                }
            }
        },
        textArea: {
        },
        textInput: {
        },
        timeInput: {
            button: {
                margin: {
                    right: 'small'
                }
            },
            container: {
                round: 'xxsmall'
            },
            active: {
                background: 'active-background',
                pad: 'xxsmall',
                indicator: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    },
                    size: 'small'
                }
            },
            drop: {
                option: {
                    // background: undefined,
                    hover: {
                        background: 'active-background'
                    },
                    selected: {
                        background: 'selected',
                        color: 'white',
                        hover: {
                        }
                    }
                }
            },
            icon: {
            }
        },
        tip: {
            content: {
                // any Box props
                background: 'background-contrast',
                elevation: 'small',
                margin: 'xsmall',
                pad: {
                    vertical: 'xsmall',
                    horizontal: 'small'
                },
                round: 'small'
            },
            drop: {
                // any props for the drop
                align: {
                    top: 'bottom'
                },
                // most common use case is Header with Buttons
                background: 'none',
                elevation: 'none',
                margin: 'none'
            }
        },
        toggleGroup: {
            button: {
                // border: {
                //   radius: undefined,
                // }
                // iconOnly: {
                //   pad: undefined,
                // },
                // kind: undefined,
                pad: {
                    horizontal: '11px',
                    vertical: '11px'
                }
            },
            container: {
                round: 'xsmall',
                border: true
            },
            divider: {
                color: 'border'
            }
        },
        toolbar: {
            small: {
                gap: 'small'
            },
            gap: 'small'
        },
        video: {
            captions: {
                background: 'rgba(0, 0, 0, 0.7)'
            },
            // controls: { background: undefined },
            icons: {
                closedCaption: $173838d506ca9170$export$237eddafb41f13f6,
                configure: $1de8541bdd93d251$export$b52183d5cfb26dc9,
                fullScreen: $210911c17625cb22$export$49bd1dfb0ad29c40,
                pause: $e751bc12b719d8f4$export$59704c468e1a1527,
                play: $82c01c28d93e7046$export$480db61f4dcd7727,
                reduceVolume: $f6223518e88a1b05$export$679a525edce53a0a,
                volume: $230d45e2108d7875$export$dde279e52d625429,
                description: $2504912870405b96$export$c92b43e49fa6c65b
            },
            scrubber: {
                color: 'light-4',
                interval: 10,
                // track: { color: undefined }
                thickness: 'small'
            },
            time: {
                container: {
                    pad: {
                        horizontal: 'small'
                    }
                }
            }
        },
        worldMap: {
            color: 'light-3',
            continent: {
                active: '8px',
                base: '6px'
            },
            hover: {
                color: 'light-4'
            },
            place: {
                active: '20px',
                base: '8px'
            }
        }
    });
    return (0, $ebafa0e8c9355c24$export$7e32b29e1cb162e1)(result);
};
var $35181ae64da75991$var$base = $35181ae64da75991$export$e2253033e6e1df16 = $35181ae64da75991$var$generate(24);


var $4e2055db6f77c198$var$defaultProps = $4e2055db6f77c198$export$9c21a3269931e1e6 = {
    theme: $35181ae64da75991$export$e2253033e6e1df16
};
var $4e2055db6f77c198$var$extendDefaultTheme = $4e2055db6f77c198$export$582fa4e2a9b13dde = function extendDefaultTheme(theme) {
    $4e2055db6f77c198$var$defaultProps.theme = (0, $4113023f9e0bafa0$exports.deepMerge)($35181ae64da75991$export$e2253033e6e1df16, theme);
};
/*
  Pass `theme` for component which can be located outside of theme context.
  To be used as argument for `attrs` method from `styled-components`.
 */ var $4e2055db6f77c198$var$withTheme = $4e2055db6f77c198$export$e8748c6a27b910dc = function withTheme(props) {
    return {
        theme: (0, $4113023f9e0bafa0$exports.deepMerge)($4e2055db6f77c198$var$defaultProps.theme, props.theme)
    };
};


function $c2bb495fd818831f$var$_extends() {
    return $c2bb495fd818831f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c2bb495fd818831f$var$_extends.apply(null, arguments);
}
/*
  Hook that returns theme value along with a flag to determine if we are 
  outside of a theme context provider, if so pass the base theme.
  If used outside of `<Grommet>` wrapper, falls back to base theme.
*/ var $c2bb495fd818831f$var$useThemeValue = $c2bb495fd818831f$export$b86e7a765e389e8f = function useThemeValue() {
    var context = (0, $2xPiy.useContext)($iA1nz.ThemeContext);
    var theme = context || $4e2055db6f77c198$export$9c21a3269931e1e6.theme;
    return {
        theme: theme,
        passThemeFlag: $c2bb495fd818831f$var$_extends({}, context === undefined ? {
            theme: theme
        } : {})
    };
};


var $58f4f715ab4fa2c4$exports = {};
"use strict";
$58f4f715ab4fa2c4$exports.__esModule = true;
var $995522def9ecf485$exports = {};
"use strict";
$995522def9ecf485$exports.__esModule = true;
var $c2ea26ca265fb09f$exports = {};

$parcel$export($c2ea26ca265fb09f$exports, "__esModule", function () { return $c2ea26ca265fb09f$export$1e511d4a378977f5; }, function (v) { return $c2ea26ca265fb09f$export$1e511d4a378977f5 = v; });
$parcel$export($c2ea26ca265fb09f$exports, "useAnalytics", function () { return $c2ea26ca265fb09f$export$e955abb82869dc84; }, function (v) { return $c2ea26ca265fb09f$export$e955abb82869dc84 = v; });
$parcel$export($c2ea26ca265fb09f$exports, "AnalyticsProvider", function () { return $c2ea26ca265fb09f$export$1b581a2ec13e37f1; }, function (v) { return $c2ea26ca265fb09f$export$1b581a2ec13e37f1 = v; });
$parcel$export($c2ea26ca265fb09f$exports, "AnalyticsContext", function () { return $c2ea26ca265fb09f$export$83cd6c3eba7d8d9e; }, function (v) { return $c2ea26ca265fb09f$export$83cd6c3eba7d8d9e = v; });
var $c2ea26ca265fb09f$export$1e511d4a378977f5;
var $c2ea26ca265fb09f$export$e955abb82869dc84;
var $c2ea26ca265fb09f$export$1b581a2ec13e37f1;
var $c2ea26ca265fb09f$export$83cd6c3eba7d8d9e;
"use strict";
$c2ea26ca265fb09f$export$1e511d4a378977f5 = true;
$c2ea26ca265fb09f$export$e955abb82869dc84 = $c2ea26ca265fb09f$export$1b581a2ec13e37f1 = $c2ea26ca265fb09f$export$83cd6c3eba7d8d9e = void 0;

var $c2ea26ca265fb09f$var$_react = $c2ea26ca265fb09f$var$_interopRequireWildcard((parcelRequire("2xPiy")));
function $c2ea26ca265fb09f$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($c2ea26ca265fb09f$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $c2ea26ca265fb09f$var$AnalyticsContext = $c2ea26ca265fb09f$export$83cd6c3eba7d8d9e = /*#__PURE__*/ $c2ea26ca265fb09f$var$_react["default"].createContext(function() {});
var $c2ea26ca265fb09f$var$useAnalytics = $c2ea26ca265fb09f$export$e955abb82869dc84 = function useAnalytics() {
    return (0, $c2ea26ca265fb09f$var$_react.useContext)($c2ea26ca265fb09f$var$AnalyticsContext);
};
var $c2ea26ca265fb09f$var$AnalyticsProvider = $c2ea26ca265fb09f$export$1b581a2ec13e37f1 = function AnalyticsProvider(_ref) {
    var onAnalytics = _ref.onAnalytics, children = _ref.children;
    var lastUrlRef = (0, $c2ea26ca265fb09f$var$_react.useRef)();
    var sendAnalytics = (0, $c2ea26ca265fb09f$var$_react.useCallback)(function(data) {
        return onAnalytics && onAnalytics(data);
    }, [
        onAnalytics
    ]);
    (0, $c2ea26ca265fb09f$var$_react.useEffect)(function() {
        var observer;
        if (onAnalytics) {
            observer = new window.MutationObserver(function() {
                var _window;
                var url = (_window = window) == null || (_window = _window.location) == null ? void 0 : _window.href;
                var previousUrl = lastUrlRef.current;
                if (url !== previousUrl) {
                    lastUrlRef.current = url;
                    sendAnalytics({
                        type: 'pageView',
                        url: url,
                        previousUrl: previousUrl
                    });
                }
            });
            observer.observe(document, {
                subtree: true,
                childList: true
            });
        }
        return function() {
            var _observer;
            return (_observer = observer) == null ? void 0 : _observer.disconnect();
        };
    }, [
        sendAnalytics,
        onAnalytics
    ]);
    return /*#__PURE__*/ $c2ea26ca265fb09f$var$_react["default"].createElement($c2ea26ca265fb09f$var$AnalyticsContext.Provider, {
        value: sendAnalytics
    }, children);
};


Object.keys($c2ea26ca265fb09f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $995522def9ecf485$exports && $995522def9ecf485$exports[key] === $c2ea26ca265fb09f$exports[key]) return;
    $995522def9ecf485$exports[key] = $c2ea26ca265fb09f$exports[key];
});


Object.keys($995522def9ecf485$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $58f4f715ab4fa2c4$exports && $58f4f715ab4fa2c4$exports[key] === $995522def9ecf485$exports[key]) return;
    $58f4f715ab4fa2c4$exports[key] = $995522def9ecf485$exports[key];
});
var $cfbcb74d4f54e56b$exports = {};

$parcel$export($cfbcb74d4f54e56b$exports, "__esModule", function () { return $cfbcb74d4f54e56b$export$1e511d4a378977f5; }, function (v) { return $cfbcb74d4f54e56b$export$1e511d4a378977f5 = v; });
$parcel$export($cfbcb74d4f54e56b$exports, "AnnounceContext", function () { return $cfbcb74d4f54e56b$export$dcc8f4bff0d51f50; }, function (v) { return $cfbcb74d4f54e56b$export$dcc8f4bff0d51f50 = v; });
var $cfbcb74d4f54e56b$export$1e511d4a378977f5;
var $cfbcb74d4f54e56b$export$dcc8f4bff0d51f50;
"use strict";
$cfbcb74d4f54e56b$export$1e511d4a378977f5 = true;
$cfbcb74d4f54e56b$export$dcc8f4bff0d51f50 = void 0;
var $f3d02c0ed94e6438$export$1e511d4a378977f5;
var $f3d02c0ed94e6438$export$dcc8f4bff0d51f50;
"use strict";
$f3d02c0ed94e6438$export$1e511d4a378977f5 = true;
$f3d02c0ed94e6438$export$dcc8f4bff0d51f50 = void 0;

var $f3d02c0ed94e6438$var$_react = $f3d02c0ed94e6438$var$_interopRequireDefault((parcelRequire("2xPiy")));
var $f3ba19e4017ebfbf$export$1e511d4a378977f5;
var $f3ba19e4017ebfbf$export$33f2254b5dbf828a;
"use strict";
$f3ba19e4017ebfbf$export$1e511d4a378977f5 = true;
$f3ba19e4017ebfbf$export$33f2254b5dbf828a = void 0;

var $f3ba19e4017ebfbf$var$_propTypes = $f3ba19e4017ebfbf$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $f3ba19e4017ebfbf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $f3ba19e4017ebfbf$var$PropType = {};
$f3ba19e4017ebfbf$var$PropType = {
    children: $f3ba19e4017ebfbf$var$_propTypes["default"].func
};
var $f3ba19e4017ebfbf$var$AnnounceContextPropTypes = $f3ba19e4017ebfbf$export$33f2254b5dbf828a = $f3ba19e4017ebfbf$var$PropType;


function $f3d02c0ed94e6438$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $f3d02c0ed94e6438$var$DEFAULT_MODE = 'polite';
var $f3d02c0ed94e6438$var$invisibleChars = [
    "\u200B",
    "\uFEFF",
    "\u200C",
    "\u200D"
];
var $f3d02c0ed94e6438$var$createAnnouncer = function createAnnouncer() {
    var announcer = document.createElement('div');
    announcer.id = 'grommet-announcer';
    announcer.setAttribute('aria-live', $f3d02c0ed94e6438$var$DEFAULT_MODE);
    announcer.setAttribute('aria-atomic', 'true');
    announcer.style.left = '-100%';
    announcer.style.right = '100%';
    announcer.style.position = 'fixed';
    announcer.style['z-index'] = '-1';
    document.body.insertBefore(announcer, document.body.firstChild);
    return announcer;
};
var $f3d02c0ed94e6438$var$announceCounter = 0; // Counter to ensure unique announcements
var $f3d02c0ed94e6438$var$clearTimeoutId; // Variable to hold the timeout ID for clearing
var $f3d02c0ed94e6438$var$AnnounceContext = $f3d02c0ed94e6438$export$dcc8f4bff0d51f50 = /*#__PURE__*/ $f3d02c0ed94e6438$var$_react["default"].createContext(function(message, mode, timeout) {
    if (mode === void 0) mode = $f3d02c0ed94e6438$var$DEFAULT_MODE;
    if (timeout === void 0) timeout = 500;
    // we only create a new container if we don't have one already
    // we create a separate node so that grommet does not set aria-hidden to it
    var announcer = document.body.querySelector("#grommet-announcer[aria-live]") || $f3d02c0ed94e6438$var$createAnnouncer();
    announcer.setAttribute('aria-live', mode);
    // Clear any existing timeout before setting a new one
    if ($f3d02c0ed94e6438$var$clearTimeoutId) clearTimeout($f3d02c0ed94e6438$var$clearTimeoutId);
    if (mode === 'polite') // using setTimeout for polite mode pushes to next event loop tick,
    // giving time for the browser to process the change
    setTimeout(function() {
        var uniqueChar = $f3d02c0ed94e6438$var$invisibleChars[$f3d02c0ed94e6438$var$announceCounter % $f3d02c0ed94e6438$var$invisibleChars.length];
        $f3d02c0ed94e6438$var$announceCounter += 1; // Increment the counter for the next call
        // set the message with a unique invisible character to ensure
        // it is registered as different by screen readers
        announcer.textContent = "" + message + uniqueChar;
    }, 0);
    else announcer.textContent = message;
    // clear the message after the specified timeout
    $f3d02c0ed94e6438$var$clearTimeoutId = setTimeout(function() {
        announcer.textContent = '';
    }, timeout);
});
$f3d02c0ed94e6438$var$AnnounceContext.propTypes = $f3ba19e4017ebfbf$export$33f2254b5dbf828a;


$cfbcb74d4f54e56b$export$dcc8f4bff0d51f50 = $f3d02c0ed94e6438$export$dcc8f4bff0d51f50;


Object.keys($cfbcb74d4f54e56b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $58f4f715ab4fa2c4$exports && $58f4f715ab4fa2c4$exports[key] === $cfbcb74d4f54e56b$exports[key]) return;
    $58f4f715ab4fa2c4$exports[key] = $cfbcb74d4f54e56b$exports[key];
});
var $9055da357324b5ab$exports = {};

$parcel$export($9055da357324b5ab$exports, "__esModule", function () { return $9055da357324b5ab$export$1e511d4a378977f5; }, function (v) { return $9055da357324b5ab$export$1e511d4a378977f5 = v; });
$parcel$export($9055da357324b5ab$exports, "ContainerTargetContext", function () { return $9055da357324b5ab$export$64a849364cd772b4; }, function (v) { return $9055da357324b5ab$export$64a849364cd772b4 = v; });
var $9055da357324b5ab$export$1e511d4a378977f5;
var $9055da357324b5ab$export$64a849364cd772b4;
"use strict";
$9055da357324b5ab$export$1e511d4a378977f5 = true;
$9055da357324b5ab$export$64a849364cd772b4 = void 0;
var $733a7bd68337b13b$export$1e511d4a378977f5;
var $733a7bd68337b13b$export$64a849364cd772b4;
"use strict";
$733a7bd68337b13b$export$1e511d4a378977f5 = true;
$733a7bd68337b13b$export$64a849364cd772b4 = void 0;

var $733a7bd68337b13b$var$_react = $733a7bd68337b13b$var$_interopRequireDefault((parcelRequire("2xPiy")));
function $733a7bd68337b13b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $733a7bd68337b13b$var$ContainerTargetContext = $733a7bd68337b13b$export$64a849364cd772b4 = /*#__PURE__*/ $733a7bd68337b13b$var$_react["default"].createContext(typeof document === 'object' ? document.body : undefined);


$9055da357324b5ab$export$64a849364cd772b4 = $733a7bd68337b13b$export$64a849364cd772b4;


Object.keys($9055da357324b5ab$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $58f4f715ab4fa2c4$exports && $58f4f715ab4fa2c4$exports[key] === $9055da357324b5ab$exports[key]) return;
    $58f4f715ab4fa2c4$exports[key] = $9055da357324b5ab$exports[key];
});
var $932597a497e37de0$exports = {};

$parcel$export($932597a497e37de0$exports, "__esModule", function () { return $932597a497e37de0$export$1e511d4a378977f5; }, function (v) { return $932597a497e37de0$export$1e511d4a378977f5 = v; });
$parcel$export($932597a497e37de0$exports, "DataContext", function () { return $932597a497e37de0$export$58d75f9829cbe158; }, function (v) { return $932597a497e37de0$export$58d75f9829cbe158 = v; });
var $932597a497e37de0$export$1e511d4a378977f5;
var $932597a497e37de0$export$58d75f9829cbe158;
"use strict";
$932597a497e37de0$export$1e511d4a378977f5 = true;
$932597a497e37de0$export$58d75f9829cbe158 = void 0;

var $932597a497e37de0$var$_react = $932597a497e37de0$var$_interopRequireDefault((parcelRequire("2xPiy")));
function $932597a497e37de0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $932597a497e37de0$var$DataContext = $932597a497e37de0$export$58d75f9829cbe158 = /*#__PURE__*/ $932597a497e37de0$var$_react["default"].createContext({
    data: [],
    addToolbarKey: function addToolbarKey() {}
});


Object.keys($932597a497e37de0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $58f4f715ab4fa2c4$exports && $58f4f715ab4fa2c4$exports[key] === $932597a497e37de0$exports[key]) return;
    $58f4f715ab4fa2c4$exports[key] = $932597a497e37de0$exports[key];
});
var $afb62f3be48d73fe$exports = {};

$parcel$export($afb62f3be48d73fe$exports, "__esModule", function () { return $afb62f3be48d73fe$export$1e511d4a378977f5; }, function (v) { return $afb62f3be48d73fe$export$1e511d4a378977f5 = v; });
$parcel$export($afb62f3be48d73fe$exports, "ResponsiveContext", function () { return $afb62f3be48d73fe$export$51e389dae84ec233; }, function (v) { return $afb62f3be48d73fe$export$51e389dae84ec233 = v; });
var $afb62f3be48d73fe$export$1e511d4a378977f5;
var $afb62f3be48d73fe$export$51e389dae84ec233;
"use strict";
$afb62f3be48d73fe$export$1e511d4a378977f5 = true;
$afb62f3be48d73fe$export$51e389dae84ec233 = void 0;
var $c56f2a177f4158c5$export$1e511d4a378977f5;
var $c56f2a177f4158c5$export$51e389dae84ec233;
"use strict";
$c56f2a177f4158c5$export$1e511d4a378977f5 = true;
$c56f2a177f4158c5$export$51e389dae84ec233 = void 0;

var $c56f2a177f4158c5$var$_react = $c56f2a177f4158c5$var$_interopRequireDefault((parcelRequire("2xPiy")));
var $4f7b146d578301c9$export$1e511d4a378977f5;
var $4f7b146d578301c9$export$4c170dc5df56b17c;
"use strict";
$4f7b146d578301c9$export$1e511d4a378977f5 = true;
$4f7b146d578301c9$export$4c170dc5df56b17c = void 0;

var $4f7b146d578301c9$var$_propTypes = $4f7b146d578301c9$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $4f7b146d578301c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $4f7b146d578301c9$var$PropType = {};
$4f7b146d578301c9$var$PropType = {
    children: $4f7b146d578301c9$var$_propTypes["default"].func
};
var $4f7b146d578301c9$var$ResponsiveContextPropTypes = $4f7b146d578301c9$export$4c170dc5df56b17c = $4f7b146d578301c9$var$PropType;


function $c56f2a177f4158c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $c56f2a177f4158c5$var$ResponsiveContext = $c56f2a177f4158c5$export$51e389dae84ec233 = /*#__PURE__*/ $c56f2a177f4158c5$var$_react["default"].createContext(undefined);
$c56f2a177f4158c5$var$ResponsiveContext.propTypes = $4f7b146d578301c9$export$4c170dc5df56b17c;


$afb62f3be48d73fe$export$51e389dae84ec233 = $c56f2a177f4158c5$export$51e389dae84ec233;


Object.keys($afb62f3be48d73fe$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $58f4f715ab4fa2c4$exports && $58f4f715ab4fa2c4$exports[key] === $afb62f3be48d73fe$exports[key]) return;
    $58f4f715ab4fa2c4$exports[key] = $afb62f3be48d73fe$exports[key];
});
var $c2378bf528d9c599$exports = {};

$parcel$export($c2378bf528d9c599$exports, "__esModule", function () { return $c2378bf528d9c599$export$1e511d4a378977f5; }, function (v) { return $c2378bf528d9c599$export$1e511d4a378977f5 = v; });
$parcel$export($c2378bf528d9c599$exports, "ResponsiveContainerContext", function () { return $c2378bf528d9c599$export$505da1fc32900905; }, function (v) { return $c2378bf528d9c599$export$505da1fc32900905 = v; });
var $c2378bf528d9c599$export$1e511d4a378977f5;
var $c2378bf528d9c599$export$505da1fc32900905;
"use strict";
$c2378bf528d9c599$export$1e511d4a378977f5 = true;
$c2378bf528d9c599$export$505da1fc32900905 = void 0;

var $c2378bf528d9c599$var$_react = $c2378bf528d9c599$var$_interopRequireDefault((parcelRequire("2xPiy")));
function $c2378bf528d9c599$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $c2378bf528d9c599$var$ResponsiveContainerContext = $c2378bf528d9c599$export$505da1fc32900905 = /*#__PURE__*/ $c2378bf528d9c599$var$_react["default"].createContext(false);


Object.keys($c2378bf528d9c599$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $58f4f715ab4fa2c4$exports && $58f4f715ab4fa2c4$exports[key] === $c2378bf528d9c599$exports[key]) return;
    $58f4f715ab4fa2c4$exports[key] = $c2378bf528d9c599$exports[key];
});
var $f4322a4a0d63b89f$exports = {};

$parcel$export($f4322a4a0d63b89f$exports, "__esModule", function () { return $f4322a4a0d63b89f$export$1e511d4a378977f5; }, function (v) { return $f4322a4a0d63b89f$export$1e511d4a378977f5 = v; });
$parcel$export($f4322a4a0d63b89f$exports, "useRoots", function () { return $f4322a4a0d63b89f$export$79ef40724920756d; }, function (v) { return $f4322a4a0d63b89f$export$79ef40724920756d = v; });
$parcel$export($f4322a4a0d63b89f$exports, "RootsContext", function () { return $f4322a4a0d63b89f$export$1eeeeda725eeeda; }, function (v) { return $f4322a4a0d63b89f$export$1eeeeda725eeeda = v; });
var $f4322a4a0d63b89f$export$1e511d4a378977f5;
var $f4322a4a0d63b89f$export$79ef40724920756d;
var $f4322a4a0d63b89f$export$1eeeeda725eeeda;
"use strict";
$f4322a4a0d63b89f$export$1e511d4a378977f5 = true;
$f4322a4a0d63b89f$export$79ef40724920756d = $f4322a4a0d63b89f$export$1eeeeda725eeeda = void 0;

var $f4322a4a0d63b89f$var$_react = $f4322a4a0d63b89f$var$_interopRequireWildcard((parcelRequire("2xPiy")));
function $f4322a4a0d63b89f$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($f4322a4a0d63b89f$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
// When toggling aria-hidden values, we only want to affect elements
// in the DOM that come from Grommet, so we track those elements in this
// context value. We also only want `trapFocus` to apply to the most recently
// opened Drop/Layer. See FocusedContainer.js
var $f4322a4a0d63b89f$var$RootsContext = $f4322a4a0d63b89f$export$1eeeeda725eeeda = /*#__PURE__*/ $f4322a4a0d63b89f$var$_react["default"].createContext(undefined);
var $f4322a4a0d63b89f$var$useRoots = $f4322a4a0d63b89f$export$79ef40724920756d = function useRoots() {
    // If FocusedContainer is within Grommet React tree, there will be a value
    // from RootsContext. If not, set up a default value that can be passed
    // to drops that might open from within a drop.
    var defaultRoots = (0, $f4322a4a0d63b89f$var$_react.useRef)([]);
    var defaultValue = (0, $f4322a4a0d63b89f$var$_react.useMemo)(function() {
        return {
            roots: defaultRoots
        };
    }, []);
    var existingRoots = (0, $f4322a4a0d63b89f$var$_react.useContext)($f4322a4a0d63b89f$var$RootsContext);
    return {
        contextValue: existingRoots || defaultValue,
        hasRoots: (existingRoots == null ? void 0 : existingRoots.roots) !== undefined
    };
};


Object.keys($f4322a4a0d63b89f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $58f4f715ab4fa2c4$exports && $58f4f715ab4fa2c4$exports[key] === $f4322a4a0d63b89f$exports[key]) return;
    $58f4f715ab4fa2c4$exports[key] = $f4322a4a0d63b89f$exports[key];
});
var $9f2e7bf1c0db40a5$exports = {};

$parcel$export($9f2e7bf1c0db40a5$exports, "__esModule", function () { return $9f2e7bf1c0db40a5$export$1e511d4a378977f5; }, function (v) { return $9f2e7bf1c0db40a5$export$1e511d4a378977f5 = v; });
$parcel$export($9f2e7bf1c0db40a5$exports, "ThemeContext", function () { return $9f2e7bf1c0db40a5$export$2c657da244d00bd6; }, function (v) { return $9f2e7bf1c0db40a5$export$2c657da244d00bd6 = v; });
var $9f2e7bf1c0db40a5$export$1e511d4a378977f5;
var $9f2e7bf1c0db40a5$export$2c657da244d00bd6;
"use strict";
$9f2e7bf1c0db40a5$export$1e511d4a378977f5 = true;
$9f2e7bf1c0db40a5$export$2c657da244d00bd6 = void 0;
var $7d09fd5588b55eee$export$1e511d4a378977f5;
var $7d09fd5588b55eee$export$2c657da244d00bd6;
"use strict";
$7d09fd5588b55eee$export$1e511d4a378977f5 = true;

var $7d09fd5588b55eee$var$_react = $7d09fd5588b55eee$var$_interopRequireDefault((parcelRequire("2xPiy")));

var $7d09fd5588b55eee$var$_propTypes = $7d09fd5588b55eee$var$_interopRequireDefault((parcelRequire("dyr1f")));

var $iA1nz = parcelRequire("iA1nz");
$7d09fd5588b55eee$export$2c657da244d00bd6 = $iA1nz.ThemeContext;

var $d46293ffd7bba973$export$1e511d4a378977f5;
var $d46293ffd7bba973$export$b969a6543dfc7938;
"use strict";
$d46293ffd7bba973$export$1e511d4a378977f5 = true;
$d46293ffd7bba973$export$b969a6543dfc7938 = void 0;

var $d46293ffd7bba973$var$_propTypes = $d46293ffd7bba973$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $d46293ffd7bba973$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $d46293ffd7bba973$var$PropType = {};
$d46293ffd7bba973$var$PropType = {
    value: $d46293ffd7bba973$var$_propTypes["default"].shape({})
};
var $d46293ffd7bba973$var$ThemeContextPropTypes = $d46293ffd7bba973$export$b969a6543dfc7938 = $d46293ffd7bba973$var$PropType;


function $7d09fd5588b55eee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
$iA1nz.ThemeContext.Extend = function(_ref) {
    var children = _ref.children, value = _ref.value;
    return /*#__PURE__*/ $7d09fd5588b55eee$var$_react["default"].createElement($iA1nz.ThemeContext.Consumer, null, function(theme) {
        return /*#__PURE__*/ $7d09fd5588b55eee$var$_react["default"].createElement($iA1nz.ThemeContext.Provider, {
            value: (0, $4113023f9e0bafa0$exports.deepMerge)(theme, value)
        }, children);
    });
};
$iA1nz.ThemeContext.Extend.propTypes = {
    children: $7d09fd5588b55eee$var$_propTypes["default"].node.isRequired,
    value: $7d09fd5588b55eee$var$_propTypes["default"].shape({}).isRequired
};
$iA1nz.ThemeContext.propTypes = $d46293ffd7bba973$export$b969a6543dfc7938;


$9f2e7bf1c0db40a5$export$2c657da244d00bd6 = $7d09fd5588b55eee$export$2c657da244d00bd6;


Object.keys($9f2e7bf1c0db40a5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $58f4f715ab4fa2c4$exports && $58f4f715ab4fa2c4$exports[key] === $9f2e7bf1c0db40a5$exports[key]) return;
    $58f4f715ab4fa2c4$exports[key] = $9f2e7bf1c0db40a5$exports[key];
});


var $e69128d7568b41c8$var$_excluded = [
    "as",
    "colors",
    "width",
    "height",
    "responsive"
];
function $e69128d7568b41c8$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($e69128d7568b41c8$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $e69128d7568b41c8$var$_extends() {
    return $e69128d7568b41c8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e69128d7568b41c8$var$_extends.apply(null, arguments);
}
function $e69128d7568b41c8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $e69128d7568b41c8$var$Skeleton = $e69128d7568b41c8$export$8f31e4c4a37b8e9c = /*#__PURE__*/ (0, $e69128d7568b41c8$var$_react.forwardRef)(function(_ref, ref) {
    var _theme$skeleton;
    var as = _ref.as, colorsProp = _ref.colors, widthProp = _ref.width, heightProp = _ref.height, responsiveProp = _ref.responsive, rest = $e69128d7568b41c8$var$_objectWithoutPropertiesLoose(_ref, $e69128d7568b41c8$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var skeleton = (0, $ac3ccf23d31b45d6$export$9489db5f14593d18)();
    var depth = (skeleton == null ? void 0 : skeleton.depth) || 0;
    var responsiveContainer = (0, $e69128d7568b41c8$var$_react.useContext)($58f4f715ab4fa2c4$exports.ResponsiveContainerContext);
    var responsive = responsiveContainer && responsiveProp ? 'container' : responsiveProp;
    var colors = colorsProp || (theme == null || (_theme$skeleton = theme.skeleton) == null ? void 0 : _theme$skeleton.colors);
    var themeColors = colors[theme.dark ? 'dark' : 'light'];
    var background = themeColors[(depth + 1) % themeColors.length];
    return /*#__PURE__*/ $e69128d7568b41c8$var$_react["default"].createElement($d39d1785a6a89a87$export$e4ecddc59e33f387, $e69128d7568b41c8$var$_extends({
        "aria-hidden": "true",
        ref: ref,
        as: as,
        background: background,
        widthProp: widthProp,
        heightProp: heightProp,
        responsive: responsive
    }, passThemeFlag, rest));
});
$e69128d7568b41c8$var$Skeleton.displayName = 'Skeleton';
$e69128d7568b41c8$var$Skeleton.propTypes = $00dab9cdc7800161$export$6c09f2c2b39894c;


$ab65104eb6f9aa8a$exports.Skeleton = $e69128d7568b41c8$export$8f31e4c4a37b8e9c;

Object.keys($ac3ccf23d31b45d6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($ab65104eb6f9aa8a$var$_exportNames, key)) return;
    if (key in $ab65104eb6f9aa8a$exports && $ab65104eb6f9aa8a$exports[key] === $ac3ccf23d31b45d6$exports[key]) return;
    $ab65104eb6f9aa8a$exports[key] = $ac3ccf23d31b45d6$exports[key];
});



var $cddec80c12094a96$export$1e511d4a378977f5;
var $cddec80c12094a96$export$b709306b005c3ef;
"use strict";
$cddec80c12094a96$export$1e511d4a378977f5 = true;
$cddec80c12094a96$export$b709306b005c3ef = void 0;

var $cddec80c12094a96$var$_react = $cddec80c12094a96$var$_interopRequireDefault((parcelRequire("2xPiy")));
function $cddec80c12094a96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $cddec80c12094a96$var$OptionsContext = $cddec80c12094a96$export$b709306b005c3ef = /*#__PURE__*/ $cddec80c12094a96$var$_react["default"].createContext({});



var $02ce13bb5e48eddf$export$1e511d4a378977f5;
var $02ce13bb5e48eddf$export$cc532883f3610b88;
"use strict";
$02ce13bb5e48eddf$export$1e511d4a378977f5 = true;
$02ce13bb5e48eddf$export$cc532883f3610b88 = void 0;

var $02ce13bb5e48eddf$var$_react = $02ce13bb5e48eddf$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $02ce13bb5e48eddf$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($02ce13bb5e48eddf$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
// The value of ResponsiveContainerContext
// when we're within a responsive container
var $02ce13bb5e48eddf$var$responsiveContainerValue = true;
var $02ce13bb5e48eddf$var$ResponsiveContainerProvider = $02ce13bb5e48eddf$export$cc532883f3610b88 = function ResponsiveContainerProvider(_ref) {
    var container = _ref.container, theme = _ref.theme, children = _ref.children;
    var _useState = (0, $02ce13bb5e48eddf$var$_react.useState)(function() {
        var _theme$global;
        return (0, $80783f9dd7b08ab9$export$f207ad4bd0549009)(navigator.userAgent, theme) || (theme == null || (_theme$global = theme.global) == null ? void 0 : _theme$global.deviceBreakpoints.tablet);
    }), value = _useState[0], setValue = _useState[1];
    (0, $02ce13bb5e48eddf$var$_react.useEffect)(function() {
        if (!container) return undefined;
        // Track what breakpoint width of the container is at
        // and update the ResponsiveContext value accordingly.
        var resizeObserver;
        if (typeof window !== 'undefined' && window.ResizeObserver) {
            resizeObserver = new window.ResizeObserver(function(entries) {
                window.requestAnimationFrame(function() {
                    var _entries$;
                    if (!Array.isArray(entries) || !entries.length) return;
                    var size = (_entries$ = entries[0]) == null || (_entries$ = _entries$.borderBoxSize) == null || (_entries$ = _entries$[0]) == null ? void 0 : _entries$.inlineSize;
                    if (size) setValue((0, $80783f9dd7b08ab9$export$1eb095b00b926404)(size, theme));
                });
            });
            resizeObserver.observe(container);
        }
        // Initial size for ResponsiveContext in responsive container mode.
        // Also is a fallback for server side rendering
        var containerWidth = container.getBoundingClientRect().width;
        setValue((0, $80783f9dd7b08ab9$export$1eb095b00b926404)(containerWidth, theme));
        return function() {
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        container,
        theme
    ]);
    return /*#__PURE__*/ $02ce13bb5e48eddf$var$_react["default"].createElement($58f4f715ab4fa2c4$exports.ResponsiveContainerContext.Provider, {
        value: $02ce13bb5e48eddf$var$responsiveContainerValue
    }, /*#__PURE__*/ $02ce13bb5e48eddf$var$_react["default"].createElement($58f4f715ab4fa2c4$exports.ResponsiveContext.Provider, {
        value: value
    }, children));
};




var $3a5896a4feb1a7cd$var$_excluded = [
    "a11yTitle",
    "background",
    "border",
    "children",
    "cssGap",
    "direction",
    "elevation",
    "fill",
    "gap",
    "kind",
    "onBlur",
    "onClick",
    "onFocus",
    "overflow",
    "responsive",
    "tag",
    "as",
    "wrap",
    "width",
    "height",
    "tabIndex",
    "skeleton"
], $3a5896a4feb1a7cd$var$_excluded2 = [
    "colors",
    "size"
];
function $3a5896a4feb1a7cd$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($3a5896a4feb1a7cd$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $3a5896a4feb1a7cd$var$_extends() {
    return $3a5896a4feb1a7cd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3a5896a4feb1a7cd$var$_extends.apply(null, arguments);
}
function $3a5896a4feb1a7cd$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $3a5896a4feb1a7cd$var$Box = $3a5896a4feb1a7cd$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $3a5896a4feb1a7cd$var$_react.forwardRef)(function(_ref, refProp) {
    var _theme$global$depreca2;
    var a11yTitle = _ref.a11yTitle, backgroundProp = _ref.background, border = _ref.border, children = _ref.children, cssGap = _ref.cssGap, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? 'column' : _ref$direction, elevation = _ref.elevation, fill = _ref.fill, gap = _ref.gap, kind = _ref.kind, _onBlur = _ref.onBlur, onClick = _ref.onClick, _onFocus = _ref.onFocus, overflow = _ref.overflow, _ref$responsive = _ref.responsive, responsiveProp = _ref$responsive === void 0 ? true : _ref$responsive, tag = _ref.tag, as = _ref.as, wrap = _ref.wrap, width = _ref.width, height = _ref.height, tabIndex = _ref.tabIndex, skeletonProp = _ref.skeleton, rest = $3a5896a4feb1a7cd$var$_objectWithoutPropertiesLoose(_ref, $3a5896a4feb1a7cd$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    // boxOptions was created to preserve backwards compatibility but
    // should not be supported in v3
    var _useContext = (0, $3a5896a4feb1a7cd$var$_react.useContext)($cddec80c12094a96$export$b709306b005c3ef), boxOptions = _useContext.box;
    var skeleton = (0, $ab65104eb6f9aa8a$exports.useSkeleton)();
    var _useState = (0, $3a5896a4feb1a7cd$var$_react.useState)(undefined), containerElement = _useState[0], setContainerElement = _useState[1];
    var responsiveContainer = (0, $3a5896a4feb1a7cd$var$_react.useContext)($58f4f715ab4fa2c4$exports.ResponsiveContainerContext);
    var responsive = responsiveContainer && responsiveProp ? 'container' : responsiveProp;
    var background = backgroundProp;
    (0, $3a5896a4feb1a7cd$var$_react.useEffect)(function() {
        var _theme$global$depreca;
        if (backgroundProp && (_theme$global$depreca = theme.global.deprecated) != null && _theme$global$depreca.backgrounds) {
            var deprecatedBackground;
            if (typeof backgroundProp === 'string') deprecatedBackground = theme.global.deprecated.backgrounds.find(function(item) {
                return item.name === backgroundProp;
            });
            else if (typeof backgroundProp === 'object') deprecatedBackground = theme.global.deprecated.backgrounds.find(function(item) {
                return item.name === backgroundProp.image || item.name === backgroundProp.color;
            });
            if (deprecatedBackground) console.warn(deprecatedBackground.message || "The background " + deprecatedBackground.name + " is deprecated.");
        }
    }, [
        backgroundProp,
        (_theme$global$depreca2 = theme.global.deprecated) == null ? void 0 : _theme$global$depreca2.backgrounds
    ]);
    var announce = (0, $3a5896a4feb1a7cd$var$_react.useContext)($cfbcb74d4f54e56b$export$dcc8f4bff0d51f50);
    var containerRef = (0, $4113023f9e0bafa0$exports.useForwardedRef)(refProp);
    // Save the ref as a state if we're in a responsive container.
    // We only need it in the responsive container case and it
    // needs to be in a state to cause a re-render.
    (0, $3a5896a4feb1a7cd$var$_react.useEffect)(function() {
        if (responsiveProp === 'container' && containerRef.current) setContainerElement(containerRef.current);
    }, [
        containerRef,
        responsiveProp
    ]);
    (0, $3a5896a4feb1a7cd$var$_react.useEffect)(function() {
        if (typeof as === 'function') {
            if (refProp) console.warn('ref and as={function} are incompatible. The ref will not get set.');
            if (responsiveProp === 'container') console.warn(// eslint-disable-next-line max-len
            'responsive="container" and as={function} are incompatible. Use one or the other.');
        }
    }, [
        refProp,
        as,
        responsiveProp
    ]);
    (0, $3a5896a4feb1a7cd$var$_react.useEffect)(function() {
        var _skeletonProp$message;
        if (skeletonProp != null && (_skeletonProp$message = skeletonProp.message) != null && _skeletonProp$message.start) announce(skeletonProp.message.start);
        else if (typeof (skeletonProp == null ? void 0 : skeletonProp.message) === 'string') announce(skeletonProp.message);
        return function() {
            var _skeletonProp$message2;
            return (skeletonProp == null || (_skeletonProp$message2 = skeletonProp.message) == null ? void 0 : _skeletonProp$message2.end) && announce(skeletonProp.message.end);
        };
    }, [
        announce,
        skeletonProp
    ]);
    var focusable = (0, $3a5896a4feb1a7cd$var$_react.useMemo)(function() {
        return onClick && !(tabIndex < 0);
    }, [
        onClick,
        tabIndex
    ]);
    var _useState2 = (0, $3a5896a4feb1a7cd$var$_react.useState)(), focus = _useState2[0], setFocus = _useState2[1];
    var clickProps = (0, $3a5896a4feb1a7cd$var$_react.useMemo)(function() {
        if (focusable) return {
            onClick: onClick,
            onFocus: function onFocus(event) {
                setFocus(true);
                if (_onFocus) _onFocus(event);
            },
            onBlur: function onBlur(event) {
                setFocus(false);
                if (_onBlur) _onBlur(event);
            }
        };
        var result = {};
        if (_onBlur) result.onBlur = _onBlur;
        if (onClick) result.onClick = onClick;
        if (_onFocus) result.onFocus = _onFocus;
        return result;
    }, [
        focusable,
        onClick,
        _onFocus,
        _onBlur
    ]);
    var adjustedTabIndex = (0, $3a5896a4feb1a7cd$var$_react.useMemo)(function() {
        if (tabIndex !== undefined) return tabIndex;
        if (focusable) return 0;
        return undefined;
    }, [
        focusable,
        tabIndex
    ]);
    if ((border === 'between' || border && border.side === 'between' || Array.isArray(border) && border.find(function(b) {
        return b.side === 'between';
    })) && !gap) console.warn('Box must have a gap to use border between');
    var contents = children;
    if (gap && gap !== 'none' && (!(boxOptions != null && boxOptions.cssGap || cssGap || typeof gap === 'object') || // need this approach to show border between
    border === 'between' || (border == null ? void 0 : border.side) === 'between' || Array.isArray(border) && border.find(function(b) {
        return b.side === 'between';
    }))) {
        // if border is an array, we need to extract the border between object
        var styledBoxGapBorder = Array.isArray(border) ? border.find(function(b) {
            return b.side === 'between';
        }) : border;
        var boxAs = !as && tag ? tag : as;
        contents = [];
        var firstIndex;
        $3a5896a4feb1a7cd$var$_react.Children.forEach(children, function(child, index) {
            if (child) {
                if (firstIndex === undefined) firstIndex = index;
                else contents.push(/*#__PURE__*/ $3a5896a4feb1a7cd$var$_react["default"].createElement($fb7cfe5df371ec76$export$a800d5caa1dbbca6, $3a5896a4feb1a7cd$var$_extends({
                    key: "gap-" + index,
                    as: boxAs === 'span' ? boxAs : 'div',
                    gap: gap,
                    directionProp: direction,
                    responsive: responsive,
                    border: styledBoxGapBorder
                }, passThemeFlag)));
            }
            contents.push(child);
        });
    }
    var nextSkeleton = (0, $3a5896a4feb1a7cd$var$_react.useMemo)(function() {
        // Decide if we need to add a new SkeletonContext. We need one if:
        //   1. skeleton info was set in a property OR
        //   2. there already is a SkeletonContext but this box has a
        //      background or border. This means the box probably is more
        //      distinguishable from the area around it.
        // We keep track of a depth so we know how to alternate backgrounds.
        if (skeletonProp || (background || border) && skeleton) {
            var depth = skeleton ? skeleton.depth + 1 : 0;
            return $3a5896a4feb1a7cd$var$_extends({}, skeleton, {
                depth: depth
            }, typeof skeletonProp === 'object' ? skeletonProp : {});
        }
        return undefined;
    }, [
        background,
        border,
        skeleton,
        skeletonProp
    ]);
    var skeletonProps = {};
    if (nextSkeleton) {
        var _theme$skeleton = theme.skeleton, skeletonThemeColors = _theme$skeleton.colors, skeletonThemeSize = _theme$skeleton.size, skeletonThemeProps = $3a5896a4feb1a7cd$var$_objectWithoutPropertiesLoose(_theme$skeleton, $3a5896a4feb1a7cd$var$_excluded2);
        var skeletonColors = nextSkeleton.colors ? nextSkeleton.colors[theme.dark ? 'dark' : 'light'] : skeletonThemeColors == null ? void 0 : skeletonThemeColors[theme.dark ? 'dark' : 'light'];
        skeletonProps = $3a5896a4feb1a7cd$var$_extends({}, skeletonThemeProps);
        background = skeletonColors[nextSkeleton.depth % skeletonColors.length];
        if (skeletonProp != null && skeletonProp.animation) skeletonProps.animation = skeletonProp.animation;
        contents = /*#__PURE__*/ $3a5896a4feb1a7cd$var$_react["default"].createElement($ab65104eb6f9aa8a$exports.SkeletonContext.Provider, {
            value: nextSkeleton
        }, contents);
    }
    // construct a new theme object in case we have a background that wants
    // to change the background color context
    var nextTheme = (0, $3a5896a4feb1a7cd$var$_react.useMemo)(function() {
        var result;
        if (background || theme.darkChanged) {
            var dark = (0, $4113023f9e0bafa0$exports.backgroundIsDark)(background, theme);
            var darkChanged = dark !== undefined && dark !== theme.dark;
            if (darkChanged || theme.darkChanged) {
                result = $3a5896a4feb1a7cd$var$_extends({}, theme);
                result.dark = dark === undefined ? theme.dark : dark;
                result.background = background;
            } else if (background) {
                // This allows DataTable to intelligently set the background
                // of a pinned header or footer.
                result = $3a5896a4feb1a7cd$var$_extends({}, theme);
                result.background = background;
            }
        }
        return result || theme;
    }, [
        background,
        theme
    ]);
    // Only pass along the ref if the as prop is not a function.
    // The styled component will throw a warning if we try to pass
    // a ref when the as prop is a function. We do a console.warn
    // about this above in this case.
    var ref = typeof as === 'function' ? undefined : containerRef;
    var content = /*#__PURE__*/ $3a5896a4feb1a7cd$var$_react["default"].createElement($fb7cfe5df371ec76$export$d675f139b342d51a, $3a5896a4feb1a7cd$var$_extends({
        as: !as && tag ? tag : as,
        "aria-label": a11yTitle,
        background: background,
        border: border,
        ref: ref,
        directionProp: direction,
        elevationProp: elevation,
        fillProp: fill,
        focus: focus,
        gap: ((boxOptions == null ? void 0 : boxOptions.cssGap) || cssGap || typeof gap === 'object') && gap && gap !== 'none' && border !== 'between' && (border == null ? void 0 : border.side) !== 'between' && (!Array.isArray(border) || !border.find(function(b) {
            return b.side === 'between';
        })) && gap,
        kindProp: kind,
        overflowProp: overflow,
        wrapProp: wrap,
        widthProp: width,
        heightProp: height,
        responsive: responsive,
        responsiveContainer: responsiveProp === 'container',
        tabIndex: adjustedTabIndex
    }, clickProps, passThemeFlag, rest, skeletonProps), /*#__PURE__*/ $3a5896a4feb1a7cd$var$_react["default"].createElement($iA1nz.ThemeContext.Provider, {
        value: nextTheme
    }, contents));
    if (responsiveProp === 'container') {
        if ((0, $80783f9dd7b08ab9$export$6fa2a3092624a8f5)()) content = /*#__PURE__*/ $3a5896a4feb1a7cd$var$_react["default"].createElement($02ce13bb5e48eddf$export$cc532883f3610b88, {
            container: containerElement,
            theme: theme
        }, content);
        else console.warn('<Box responsive="container"> requires styled-components v6 or later');
    }
    if (onClick) content = /*#__PURE__*/ $3a5896a4feb1a7cd$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onEnter: onClick,
        onSpace: function onSpace(e) {
            e.preventDefault(); // prevent page scroll
            onClick(e);
        }
    }, content);
    return content;
});
$3a5896a4feb1a7cd$var$Box.displayName = 'Box';
$3a5896a4feb1a7cd$var$Box.propTypes = $eee1df2c89b8d329$export$39ef5a49fe6b4917;


$090ffb0ba78fff3f$export$e71c4d32a2263218 = $3a5896a4feb1a7cd$export$e71c4d32a2263218;


var $a3f8d0dc1702efe0$export$1e511d4a378977f5;
var $a3f8d0dc1702efe0$export$ec39d0bf2d6d1efb;
"use strict";
$a3f8d0dc1702efe0$export$1e511d4a378977f5 = true;
$a3f8d0dc1702efe0$export$ec39d0bf2d6d1efb = void 0;

var $a3f8d0dc1702efe0$var$_styledComponents = $a3f8d0dc1702efe0$var$_interopRequireWildcard((parcelRequire("iA1nz")));

function $a3f8d0dc1702efe0$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($a3f8d0dc1702efe0$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $a3f8d0dc1702efe0$var$disabledStyle = "\n  opacity: 0.3;\n  cursor: default;\n  text-decoration: none;\n";
var $a3f8d0dc1702efe0$var$sizeStyle = function sizeStyle(props) {
    if (props.size) {
        var size = props.size || 'medium';
        var data = props.theme.text[size];
        return (0, $a3f8d0dc1702efe0$var$_styledComponents.css)([
            "font-size:",
            ";line-height:",
            ";"
        ], data ? data.size : size, data ? data.height : 'normal');
    }
    return (0, $a3f8d0dc1702efe0$var$_styledComponents.css)([
        "font-size:inherit;line-height:inherit;"
    ]);
};
var $a3f8d0dc1702efe0$var$StyledAnchor = $a3f8d0dc1702efe0$export$ec39d0bf2d6d1efb = $a3f8d0dc1702efe0$var$_styledComponents["default"].a.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledAnchor",
    componentId: "sc-1rp7lwl-0"
})([
    "box-sizing:border-box;display:inline-flex;",
    " color:",
    ";",
    " text-decoration:",
    ";cursor:pointer;",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return $a3f8d0dc1702efe0$var$sizeStyle(props);
}, function(props) {
    var _props$theme$anchor;
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(props.colorProp || ((_props$theme$anchor = props.theme.anchor) == null || (_props$theme$anchor = _props$theme$anchor.size) == null || (_props$theme$anchor = _props$theme$anchor[props.size]) == null ? void 0 : _props$theme$anchor.color) || props.theme.anchor.color, props.theme);
}, function(props) {
    var _props$theme$anchor2, _props$theme$anchor3;
    return props.weight ? "font-weight: " + props.weight + ";" : (((_props$theme$anchor2 = props.theme.anchor) == null || (_props$theme$anchor2 = _props$theme$anchor2.size) == null || (_props$theme$anchor2 = _props$theme$anchor2[props.size]) == null ? void 0 : _props$theme$anchor2.fontWeight) || props.theme.anchor.fontWeight) && "font-weight: " + (((_props$theme$anchor3 = props.theme.anchor) == null || (_props$theme$anchor3 = _props$theme$anchor3.size) == null || (_props$theme$anchor3 = _props$theme$anchor3[props.size]) == null ? void 0 : _props$theme$anchor3.fontWeight) || props.theme.anchor.fontWeight) + ";";
}, function(props) {
    var _props$theme$anchor4;
    return props.hasIcon ? 'none' : ((_props$theme$anchor4 = props.theme.anchor) == null || (_props$theme$anchor4 = _props$theme$anchor4.size) == null || (_props$theme$anchor4 = _props$theme$anchor4[props.size]) == null ? void 0 : _props$theme$anchor4.textDecoration) || props.theme.anchor.textDecoration;
}, $4113023f9e0bafa0$exports.genericStyles, function(props) {
    return !props.disabled && props.theme.anchor.hover && (0, $a3f8d0dc1702efe0$var$_styledComponents.css)([
        "&:hover{",
        " ",
        " ",
        "}"
    ], props.theme.anchor.hover.textDecoration && "text-decoration: " + props.theme.anchor.hover.textDecoration + ";", props.theme.anchor.hover.fontWeight && "font-weight: " + props.theme.anchor.hover.fontWeight + ";", props.theme.anchor.hover.extend);
}, function(props) {
    return props.hasIcon && !props.hasLabel && (0, $4113023f9e0bafa0$exports.edgeStyle)('padding', props.theme.anchor.iconOnly.pad, false, props.theme.global.edgeSize.responsiveBreakpoint, props.theme);
}, function(props) {
    return props.disabled && $a3f8d0dc1702efe0$var$disabledStyle;
}, function(props) {
    return props.focus && (0, $4113023f9e0bafa0$exports.focusStyle)();
}, function(props) {
    return props.theme.anchor.extend;
});


var $f73163d0ec743d8c$export$1e511d4a378977f5;
var $f73163d0ec743d8c$export$503a586efc7a7ea1;
"use strict";
$f73163d0ec743d8c$export$1e511d4a378977f5 = true;
$f73163d0ec743d8c$export$503a586efc7a7ea1 = void 0;

var $f73163d0ec743d8c$var$_propTypes = $f73163d0ec743d8c$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $f73163d0ec743d8c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $f73163d0ec743d8c$var$_extends() {
    return $f73163d0ec743d8c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f73163d0ec743d8c$var$_extends.apply(null, arguments);
}
var $f73163d0ec743d8c$var$PropType = {};
$f73163d0ec743d8c$var$PropType = $f73163d0ec743d8c$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    a11yTitle: $f73163d0ec743d8c$var$_propTypes["default"].string,
    as: $f73163d0ec743d8c$var$_propTypes["default"].oneOfType([
        $f73163d0ec743d8c$var$_propTypes["default"].string,
        $f73163d0ec743d8c$var$_propTypes["default"].func,
        $f73163d0ec743d8c$var$_propTypes["default"].elementType
    ]),
    color: $5897bd367fbd90c1$export$fc4c368d97afb623,
    disabled: $f73163d0ec743d8c$var$_propTypes["default"].bool,
    gap: $f73163d0ec743d8c$var$_propTypes["default"].oneOfType([
        $f73163d0ec743d8c$var$_propTypes["default"].oneOf([
            'none',
            'xxsmall',
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        $f73163d0ec743d8c$var$_propTypes["default"].string
    ]),
    href: $f73163d0ec743d8c$var$_propTypes["default"].string,
    icon: $f73163d0ec743d8c$var$_propTypes["default"].element,
    label: $f73163d0ec743d8c$var$_propTypes["default"].node,
    onClick: $f73163d0ec743d8c$var$_propTypes["default"].func,
    reverse: $f73163d0ec743d8c$var$_propTypes["default"].bool,
    size: $f73163d0ec743d8c$var$_propTypes["default"].oneOfType([
        $f73163d0ec743d8c$var$_propTypes["default"].oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            'xxlarge'
        ]),
        $f73163d0ec743d8c$var$_propTypes["default"].string
    ]),
    weight: $f73163d0ec743d8c$var$_propTypes["default"].oneOfType([
        $f73163d0ec743d8c$var$_propTypes["default"].oneOf([
            'normal',
            'bold'
        ]),
        $f73163d0ec743d8c$var$_propTypes["default"].string,
        $f73163d0ec743d8c$var$_propTypes["default"].number
    ])
});
var $f73163d0ec743d8c$var$AnchorPropTypes = $f73163d0ec743d8c$export$503a586efc7a7ea1 = $f73163d0ec743d8c$var$PropType;



var $5eeccb5281d9dbdf$export$1e511d4a378977f5;
var $5eeccb5281d9dbdf$export$9afb8bc826b033ea;
"use strict";
$5eeccb5281d9dbdf$export$1e511d4a378977f5 = true;
$5eeccb5281d9dbdf$export$9afb8bc826b033ea = void 0;

var $5eeccb5281d9dbdf$var$_react = $5eeccb5281d9dbdf$var$_interopRequireDefault((parcelRequire("2xPiy")));
function $5eeccb5281d9dbdf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $5eeccb5281d9dbdf$var$TextContext = $5eeccb5281d9dbdf$export$9afb8bc826b033ea = /*#__PURE__*/ $5eeccb5281d9dbdf$var$_react["default"].createContext({});



var $484de1138b3f84d8$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "children",
    "color",
    "disabled",
    "gap",
    "href",
    "icon",
    "label",
    "onBlur",
    "onClick",
    "onFocus",
    "reverse",
    "size"
];
function $484de1138b3f84d8$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($484de1138b3f84d8$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $484de1138b3f84d8$var$_extends() {
    return $484de1138b3f84d8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $484de1138b3f84d8$var$_extends.apply(null, arguments);
}
function $484de1138b3f84d8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $484de1138b3f84d8$var$Anchor = $484de1138b3f84d8$export$b688253958b8dfe7 = /*#__PURE__*/ (0, $484de1138b3f84d8$var$_react.forwardRef)(function(_ref, ref) {
    var _theme$anchor3, _theme$anchor4;
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], children = _ref.children, color = _ref.color, disabled = _ref.disabled, gap = _ref.gap, href = _ref.href, icon = _ref.icon, label = _ref.label, _onBlur = _ref.onBlur, onClickProp = _ref.onClick, onFocus = _ref.onFocus, reverse = _ref.reverse, sizeProp = _ref.size, rest = $484de1138b3f84d8$var$_objectWithoutPropertiesLoose(_ref, $484de1138b3f84d8$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useState = (0, $484de1138b3f84d8$var$_react.useState)(), focus = _useState[0], setFocus = _useState[1];
    var _useContext = (0, $484de1138b3f84d8$var$_react.useContext)($5eeccb5281d9dbdf$export$9afb8bc826b033ea), size = _useContext.size;
    var sendAnalytics = (0, $995522def9ecf485$exports.useAnalytics)();
    var onClick = (0, $484de1138b3f84d8$var$_react.useCallback)(function(event) {
        sendAnalytics({
            type: 'anchorClick',
            element: (0, $4113023f9e0bafa0$exports.findButtonParent)(event.target),
            event: event,
            href: href,
            label: typeof label === 'string' ? label : undefined
        });
        if (onClickProp) onClickProp(event);
    }, [
        onClickProp,
        sendAnalytics,
        label,
        href
    ]);
    (0, $484de1138b3f84d8$var$_react.useEffect)(function() {
        if ((icon || label) && children) console.warn('Anchor should not have children if icon or label is provided');
    }, [
        children,
        icon,
        label
    ]);
    var coloredIcon = icon;
    if (icon && !icon.props.color) {
        var _theme$anchor, _theme$anchor2;
        coloredIcon = /*#__PURE__*/ (0, $484de1138b3f84d8$var$_react.cloneElement)(icon, {
            color: (0, $4113023f9e0bafa0$exports.normalizeColor)(color || ((_theme$anchor = theme.anchor) == null || (_theme$anchor = _theme$anchor.icon) == null ? void 0 : _theme$anchor.color) || ((_theme$anchor2 = theme.anchor) == null || (_theme$anchor2 = _theme$anchor2.size) == null || (_theme$anchor2 = _theme$anchor2[sizeProp || size]) == null ? void 0 : _theme$anchor2.color) || theme.anchor.color, theme)
        });
    }
    var anchorIcon = (0, $4113023f9e0bafa0$exports.useSizedIcon)(coloredIcon, sizeProp || size, theme);
    var first = reverse ? label : anchorIcon;
    var second = reverse ? anchorIcon : label;
    return /*#__PURE__*/ $484de1138b3f84d8$var$_react["default"].createElement($a3f8d0dc1702efe0$export$ec39d0bf2d6d1efb, $484de1138b3f84d8$var$_extends({}, rest, {
        ref: ref,
        "aria-label": ariaLabel || a11yTitle,
        colorProp: color,
        disabled: disabled,
        hasIcon: !!icon,
        focus: focus,
        hasLabel: label,
        reverse: reverse,
        href: !disabled ? href : undefined,
        onClick: !disabled ? onClick : undefined,
        onFocus: !disabled ? function(event) {
            setFocus(true);
            if (onFocus) onFocus(event);
        } : undefined,
        onBlur: function onBlur(event) {
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        size: sizeProp || size
    }, passThemeFlag), first && second ? /*#__PURE__*/ $484de1138b3f84d8$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        as: "span",
        direction: "row",
        align: "center",
        gap: gap || ((_theme$anchor3 = theme.anchor) == null || (_theme$anchor3 = _theme$anchor3.size) == null || (_theme$anchor3 = _theme$anchor3[sizeProp]) == null ? void 0 : _theme$anchor3.gap) || ((_theme$anchor4 = theme.anchor) == null ? void 0 : _theme$anchor4.gap),
        responsive: false
    }, first, second) : first || second || children);
});
$484de1138b3f84d8$var$Anchor.displayName = 'Anchor';
$484de1138b3f84d8$var$Anchor.propTypes = $f73163d0ec743d8c$export$503a586efc7a7ea1;


$e78646567f384248$export$b688253958b8dfe7 = $484de1138b3f84d8$export$b688253958b8dfe7;


const $0bcc8f6b5063c31e$export$67abef37aa2929b0 = (props)=>{
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e78646567f384248$export$b688253958b8dfe7), {
        as: (0, $79bcac94ca400be1$export$a6c7ac8248d6e38a),
        ...props
    });
};



parcelRequire("2xPiy");

const $7c6b91b494af203a$export$e71c4d32a2263218 = (props)=>{
    const { children: children, borderRadius: borderRadius, lineHeight: lineHeight, fontFamily: fontFamily, letterSpacing: letterSpacing, cursor: cursor, style: style, transitionDuration: transitionDuration, transitionProperty: transitionProperty, transitionTimingFunction: transitionTimingFunction, opacity: opacity, hidden: hidden, row: row, ...boxProps } = props;
    const customStyles = {};
    if (borderRadius) customStyles.borderRadius = borderRadius;
    if (lineHeight) customStyles.lineHeight = lineHeight;
    if (fontFamily) customStyles.fontFamily = fontFamily;
    if (letterSpacing) customStyles.letterSpacing = letterSpacing;
    if (cursor) customStyles.cursor = cursor;
    if (transitionDuration) customStyles.transitionDuration = transitionDuration;
    if (transitionProperty) customStyles.transitionProperty = transitionProperty;
    if (transitionTimingFunction) customStyles.transitionTimingFunction = transitionTimingFunction;
    if (opacity) customStyles.opacity = opacity;
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        style: {
            ...customStyles,
            ...style
        },
        hidden: hidden,
        direction: row ? 'row' : undefined,
        ...boxProps,
        children: children
    });
};



parcelRequire("2xPiy");

var $2xPiy = parcelRequire("2xPiy");


function $724dfb7ecf65a151$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $724dfb7ecf65a151$var$_extends() {
    return $724dfb7ecf65a151$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $724dfb7ecf65a151$var$_extends.apply(null, arguments);
}
var $724dfb7ecf65a151$export$60332b2344f7fe41 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var _theme$card$hover;
    var rest = $724dfb7ecf65a151$var$_extends({}, ($724dfb7ecf65a151$var$_objectDestructuringEmpty(_ref), _ref));
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), $724dfb7ecf65a151$var$_extends({
        overflow: "hidden",
        kind: $724dfb7ecf65a151$var$_extends({
            hover: (_theme$card$hover = theme.card.hover) == null ? void 0 : _theme$card$hover.container
        }, theme.card.container),
        ref: ref
    }, theme.card.container, rest));
});
$724dfb7ecf65a151$export$60332b2344f7fe41.displayName = 'Card';


const $d5c194f24ad1f021$export$60332b2344f7fe41 = (props)=>{
    const { children: children, borderRadius: borderRadius, fontFamily: fontFamily, style: style, ...cardProps } = props;
    const customStyles = {};
    if (borderRadius) customStyles.borderRadius = borderRadius;
    if (fontFamily) customStyles.fontFamily = fontFamily;
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $724dfb7ecf65a151$export$60332b2344f7fe41), {
        style: {
            ...customStyles,
            ...style
        },
        ...cardProps,
        children: children
    });
};



parcelRequire("2xPiy");


const $9e4283f3707f7e0b$export$851de33184ecdac4 = ({ children: children, ...props })=>{
    const { gap: gap = '1rem', saveButton: saveButton, pad: pad = '1.5rem', saveButtonPad: saveButtonPad = '1.5rem', width: width = '33%', innerBoxProps: innerBoxProps, ...boxProps } = props;
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $fdccc762800a972d$export$851de33184ecdac4), {
        gap: "none",
        ...boxProps,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                elevation: "small",
                pad: pad,
                gap: gap,
                ...innerBoxProps,
                children: children
            }),
            !!saveButton && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                pad: saveButtonPad,
                width: width,
                children: saveButton
            })
        ]
    });
};



parcelRequire("2xPiy");


var $2xPiy = parcelRequire("2xPiy");

var $2xPiy = parcelRequire("2xPiy");



var $74308ae79a3739df$var$_excluded = [
    "sticky"
];
function $74308ae79a3739df$var$_extends() {
    return $74308ae79a3739df$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $74308ae79a3739df$var$_extends.apply(null, arguments);
}
function $74308ae79a3739df$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $74308ae79a3739df$export$8b251419efc915eb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).forwardRef(function(_ref, ref) {
    var _theme$header2, _theme$header3;
    var sticky = _ref.sticky, rest = $74308ae79a3739df$var$_objectWithoutPropertiesLoose(_ref, $74308ae79a3739df$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var headerRef = (0, $3cecef11d3b9c451$export$61dc559f8a0b9bcf)(ref);
    (0, $2xPiy.useEffect)(function() {
        var scrollTop = 0;
        var updateScrollDir = function updateScrollDir() {
            // target is its scroll parent
            var target = (0, $83f2052c15a18307$export$6a1689aaa66d814c)(headerRef.current);
            var header = headerRef.current;
            if (target && sticky === 'scrollup') {
                var nextScrollTop = target === document ? window.pageYOffset : target.scrollTop;
                if (scrollTop - nextScrollTop <= 0) {
                    header.style.top = "-" + header.getBoundingClientRect().height + "px";
                    header.style.zIndex = '';
                } else if (scrollTop - nextScrollTop > 0) {
                    var _theme$header;
                    // ensure that header moves with the target
                    header.style.position = 'sticky';
                    header.style.top = '0px';
                    header.style.zIndex = "" + ((_theme$header = theme.header) == null || (_theme$header = _theme$header.sticky) == null ? void 0 : _theme$header.zIndex);
                    header.style.transition = 'top 0.6s';
                }
                scrollTop = nextScrollTop;
            }
        };
        if (sticky === 'scrollup') {
            updateScrollDir();
            window.addEventListener('resize', updateScrollDir);
            window.addEventListener('scroll', updateScrollDir, true);
        }
        return function() {
            if (sticky === 'scrollup') {
                window.removeEventListener('resize', updateScrollDir);
                window.removeEventListener('scroll', updateScrollDir, true);
            }
        };
    }, [
        headerRef,
        sticky,
        (_theme$header2 = theme.header) == null || (_theme$header2 = _theme$header2.sticky) == null ? void 0 : _theme$header2.zIndex
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), $74308ae79a3739df$var$_extends({
        align: "center",
        as: "header",
        direction: "row",
        flex: false,
        justify: "between",
        gap: (_theme$header3 = theme.header) == null ? void 0 : _theme$header3.gap,
        ref: headerRef
    }, rest));
});
$74308ae79a3739df$export$8b251419efc915eb.displayName = 'Header';



function $f557854f3abac6b7$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $f557854f3abac6b7$var$_extends() {
    return $f557854f3abac6b7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f557854f3abac6b7$var$_extends.apply(null, arguments);
}
var $f557854f3abac6b7$export$5665775b26e26c5d = function CardHeader(_ref) {
    var rest = $f557854f3abac6b7$var$_extends({}, ($f557854f3abac6b7$var$_objectDestructuringEmpty(_ref), _ref));
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $74308ae79a3739df$export$8b251419efc915eb), $f557854f3abac6b7$var$_extends({}, theme.card.header, rest));
};



const $9bd8d23e517716cc$export$5665775b26e26c5d = ({ children: children, ...props })=>{
    const { title: title, icon: icon, button: button, buttonNavigatePath: buttonNavigatePath, buttonTooltip: buttonTooltip, dataTour: dataTour, ...boxProps } = props;
    const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $f557854f3abac6b7$export$5665775b26e26c5d), {
        ...boxProps,
        children: [
            icon && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                height: "xxlarge",
                justify: "center",
                children: icon
            }),
            title && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                height: "xxlarge",
                justify: "center",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    size: "xlarge",
                    children: title
                })
            }),
            button && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                pad: "xsmall",
                icon: button,
                onClick: ()=>buttonNavigatePath && navigate(buttonNavigatePath),
                tip: buttonTooltip,
                "data-tour": dataTour
            }),
            children && title && icon && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                flex: "grow"
            }),
            children
        ]
    });
};



parcelRequire("2xPiy");

const $2e9b6825878d9ee2$export$c000c84d05eea37 = ({ children: children, title: title, border: border, subText: subText, ...textProps })=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        direction: "row",
        gap: "xsmall",
        border: border ? {
            color: 'transparent',
            size: 'small'
        } : undefined,
        pad: {
            vertical: '1rem'
        },
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                size: "small",
                color: "dark-1",
                toUpperCase: true,
                ...textProps,
                children: children ?? title
            }),
            subText && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                size: "xsmall",
                color: "dark-4",
                children: subText
            })
        ]
    });



parcelRequire("2xPiy");


const $3e3a21379031f1b0$export$3358b55665249725 = ({ value: value, setValue: setValue, boxProps: boxProps })=>{
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        direction: "row",
        border: {
            color: 'light-3',
            size: 'small'
        },
        round: "6px",
        pad: "xsmall",
        background: 'white',
        fontFamily: "Lato, sans-serif",
        justify: "center",
        align: "center",
        ...boxProps,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8c9c99ffe8765a99$export$c86715117507e8e5), {
            plain: true,
            value: value,
            onChange: (e)=>setValue(e.target.value),
            style: {
                padding: 0,
                margin: 0
            }
        })
    });
};



parcelRequire("2xPiy");

const $f42764fc1a81828a$export$d42fb77b9f0fb7ad = ({ children: children, value: value, unitName: unitName, icon: icon, boxProps: boxProps, ...textProps })=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        direction: "row",
        gap: "xsmall",
        align: "center",
        ...boxProps,
        children: [
            icon,
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                size: "medium",
                fontFamily: "Lato, sans-serif",
                ...textProps,
                children: children ?? value
            }),
            unitName && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                size: "small",
                fontFamily: "Lato, sans-serif",
                children: unitName
            })
        ]
    });



parcelRequire("2xPiy");

const $5770351c0fb34b29$export$b2bf131c9f9cce5d = ({ children: children, to: to, ...props })=>{
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
        to: to,
        target: "_blank",
        referrerPolicy: "no-referrer",
        textDecoration: "none",
        ...props,
        children: children
    });
};




var $2xPiy = parcelRequire("2xPiy");



var $2xPiy = parcelRequire("2xPiy");

function $a40a45464445f23e$var$_extends() {
    return $a40a45464445f23e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a40a45464445f23e$var$_extends.apply(null, arguments);
}
var $a40a45464445f23e$export$6ed0965c9443aaa6 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $a40a45464445f23e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Edit"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m14 4 6 6-6-6zm8.294 1.294c.39.39.387 1.025-.008 1.42L9 20l-7 2 2-7L17.286 1.714a1 1 0 0 1 1.42-.008l3.588 3.588zM3 19l2 2m2-4 8-8"
    }));
});
$a40a45464445f23e$export$6ed0965c9443aaa6.displayName = 'Edit';


var $2xPiy = parcelRequire("2xPiy");

function $eec4bc4b18205d01$var$_extends() {
    return $eec4bc4b18205d01$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $eec4bc4b18205d01$var$_extends.apply(null, arguments);
}
var $eec4bc4b18205d01$export$ec91da630f36d5ea = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $eec4bc4b18205d01$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Filter"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m3 6 7 7v8h4v-8l7-7V3H3z"
    }));
});
$eec4bc4b18205d01$export$ec91da630f36d5ea.displayName = 'Filter';



parcelRequire("2xPiy");


parcelRequire("2xPiy");

var $2xPiy = parcelRequire("2xPiy");



var $dyr1f = parcelRequire("dyr1f");
var $49cc6e7273d0338a$var$PropType = {};
$49cc6e7273d0338a$var$PropType = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    color: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            light: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        })
    ]),
    message: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            start: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            end: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        })
    ])
};
var $49cc6e7273d0338a$export$a41ccd36cbb5b95e = $49cc6e7273d0338a$var$PropType;



var $8bec6e2e7dc53c4a$var$_excluded = [
    "ref",
    "size"
], $8bec6e2e7dc53c4a$var$_excluded2 = [
    "children",
    "color",
    "size",
    "message"
], $8bec6e2e7dc53c4a$var$_excluded3 = [
    "size",
    "color",
    "border"
];
function $8bec6e2e7dc53c4a$var$_extends() {
    return $8bec6e2e7dc53c4a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8bec6e2e7dc53c4a$var$_extends.apply(null, arguments);
}
function $8bec6e2e7dc53c4a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $8bec6e2e7dc53c4a$var$BasicSpinner = function BasicSpinner(_ref) {
    var ref = _ref.ref, size = _ref.size, rest = $8bec6e2e7dc53c4a$var$_objectWithoutPropertiesLoose(_ref, $8bec6e2e7dc53c4a$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), $8bec6e2e7dc53c4a$var$_extends({
        flex: false,
        height: size,
        width: size,
        ref: ref,
        responsive: theme.spinner.responsive
    }, rest));
};
/**
 * If the user is calling <Spinner>…</Spinner> with children, it will take
 * precedence over theme styling. Yet, it will still inherit the
 * default animation and size of the spinner, and of course any additional
 * given props.
 *
 * If the user is providing an icon/svg via the theme.spinner.icon,
 * the Spinner will use it as a child and will include all its relevant
 * theme props (size/color/pad…) as well,
 * user will only need to type <Spinner />.
 * If the icon has its own animation, user can turn it off via the theme.
 *
 * If none of the above is provider, <Spinner /> will provide its default
 * border, size and friends, all configurable via theme or props.
 */ var $8bec6e2e7dc53c4a$export$7f7cbe89f1eacd2 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref2, ref) {
    var children = _ref2.children, colorProp = _ref2.color, size = _ref2.size, message = _ref2.message, rest = $8bec6e2e7dc53c4a$var$_objectWithoutPropertiesLoose(_ref2, $8bec6e2e7dc53c4a$var$_excluded2);
    var _useThemeValue2 = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue2.theme;
    var announce = (0, $2xPiy.useContext)((0, $c8f61343d2547c6a$export$dcc8f4bff0d51f50));
    (0, $2xPiy.useEffect)(function() {
        if (message != null && message.start) announce(message.start);
        else if (typeof message === 'string') announce(message);
        return function() {
            return (message == null ? void 0 : message.end) && announce(message.end);
        };
    }, [
        announce,
        message
    ]);
    // Avoid color and size leaking into the DOM
    var _theme$spinner$contai = theme.spinner.container, sizeThemeProp = _theme$spinner$contai.size, colorThemeProp = _theme$spinner$contai.color, borderThemeProp = _theme$spinner$contai.border, themeProps = $8bec6e2e7dc53c4a$var$_objectWithoutPropertiesLoose(_theme$spinner$contai, $8bec6e2e7dc53c4a$var$_excluded3);
    var normalizedSize = size || sizeThemeProp;
    var spinnerSize = theme.spinner.size[normalizedSize] || normalizedSize;
    var color = colorProp || colorThemeProp;
    var Icon = theme.spinner.icon;
    var defaultBorder = [
        {
            side: 'all',
            color: 'background-contrast',
            size: size
        },
        {
            side: 'top',
            color: color,
            size: size
        }
    ];
    var spinnerBorder = Array.isArray(borderThemeProp) ? borderThemeProp.map(function(borderSide) {
        return $8bec6e2e7dc53c4a$var$_extends({}, borderSide, {
            color: borderSide.side === 'all' ? borderSide.color || 'background-contrast' : color
        });
    }) : borderThemeProp;
    // children will take precedence over theme attributes
    if (children) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($8bec6e2e7dc53c4a$var$BasicSpinner, $8bec6e2e7dc53c4a$var$_extends({
        size: spinnerSize,
        ref: ref
    }, rest), children);
    // In case icon is provided by the theme
    if (Icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($8bec6e2e7dc53c4a$var$BasicSpinner, $8bec6e2e7dc53c4a$var$_extends({
        size: spinnerSize,
        ref: ref
    }, themeProps, rest), /*#__PURE__*/ (0, $2xPiy.isValidElement)(Icon) ? Icon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(Icon, {
        size: spinnerSize,
        color: color
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($8bec6e2e7dc53c4a$var$BasicSpinner, $8bec6e2e7dc53c4a$var$_extends({
        size: spinnerSize,
        ref: ref,
        border: typeof borderThemeProp === 'undefined' ? defaultBorder : spinnerBorder
    }, themeProps, rest));
});
$8bec6e2e7dc53c4a$export$7f7cbe89f1eacd2.displayName = 'Spinner';
$8bec6e2e7dc53c4a$export$7f7cbe89f1eacd2.propTypes = (0, $49cc6e7273d0338a$export$a41ccd36cbb5b95e);


const $edf5e45107627661$export$b08b517936747730 = (props)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        height: "100vh",
        fill: "horizontal",
        justify: "center",
        align: "center",
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8bec6e2e7dc53c4a$export$7f7cbe89f1eacd2), {
            size: props.size || 'medium',
            ...props
        })
    });


const $c0392a917902c1b9$var$preventAll = (e)=>{
    e.stopPropagation();
};
const $c0392a917902c1b9$export$361d78b5461c6788 = (_props)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        fill: true,
        background: {
            color: 'black',
            opacity: 'medium'
        },
        align: "center",
        justify: "center",
        style: {
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 100
        },
        onClick: $c0392a917902c1b9$var$preventAll,
        onMouseDown: $c0392a917902c1b9$var$preventAll,
        onMouseUp: $c0392a917902c1b9$var$preventAll,
        onTouchStart: $c0392a917902c1b9$var$preventAll,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {})
    });




const $ea2652f405b477a3$export$92a576f896a9bf72 = (props)=>{
    const { isFiltering: isFiltering, isLoading: isLoading, onSubmit: onSubmit, onClear: onClear, filters: filters, width: width, hasUnapplied: hasUnapplied = false, submitLabel: submitLabel, description: description, ...boxProps } = props;
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const [isApplyFocused, setIsApplyFocused] = (0, $2xPiy.useState)(false);
    const [isClearFocused, setIsClearFocused] = (0, $2xPiy.useState)(false);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        width: width || '20%',
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
            flex: "shrink",
            ...boxProps,
            style: {
                position: 'relative'
            },
            children: [
                isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c0392a917902c1b9$export$361d78b5461c6788), {}),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                    title: t('common:filters'),
                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $eec4bc4b18205d01$export$ec91da630f36d5ea), {
                        size: "24px",
                        color: "brand"
                    }),
                    children: hasUnapplied && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        justify: "center",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ceab9ef72b825454$export$c92c6401b52a9298), {
                            content: t('common:unsavedFilters'),
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $a40a45464445f23e$export$6ed0965c9443aaa6), {
                                size: "16px"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                    pad: "1.5rem",
                    gap: "medium",
                    children: [
                        description && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            size: "small",
                            color: "dark-3",
                            children: description
                        }),
                        filters.map((filter)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                gap: "xsmall",
                                ...boxProps,
                                children: [
                                    filter.type === 'input' && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        id: (0, $00658ccd6ec0135a$export$cc8b315fc368b20a)(filter.label),
                                        name: filter.label,
                                        label: filter.label,
                                        setValue: filter.setValue,
                                        onSubmit: onSubmit,
                                        value: filter.value,
                                        fontFamily: "Lato, sans-serif",
                                        hideOptionalText: true,
                                        disabled: filter.disabled
                                    }),
                                    (!filter.type || filter.type === 'select' || filter.type === 'multi-select') && !!filter.options && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                        id: (0, $00658ccd6ec0135a$export$cc8b315fc368b20a)(filter.label),
                                        name: filter.label,
                                        label: filter.label,
                                        placeholder: t('common:choose'),
                                        options: filter.options,
                                        multiple: filter.type === 'multi-select',
                                        value: filter.value,
                                        values: filter.values || [],
                                        setValue: filter.setValue,
                                        setValues: filter.setValues,
                                        onOpen: filter.onOpen,
                                        onClose: filter.onClose,
                                        onSearch: filter.onSearch,
                                        isLoadingOptions: filter.isLoadingOptions,
                                        emptySearchMessage: filter.emptySearchMessage,
                                        fontFamily: "Lato, sans-serif",
                                        hideOptionalText: true,
                                        disabled: filter.disabled
                                    }),
                                    filter.type === 'date' && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        name: filter.label,
                                        label: filter.label,
                                        fill: "horizontal",
                                        value: filter.value,
                                        setValue: filter.setValue,
                                        componentType: "date",
                                        dateBounds: filter.dateBounds,
                                        disabled: filter.disabled
                                    })
                                ]
                            }, filter.label)),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            direction: "row",
                            justify: "between",
                            gap: "xsmall",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    id: "apply_filters",
                                    justify: "center",
                                    align: "center",
                                    fill: "horizontal",
                                    background: isApplyFocused ? 'button-hover' : 'accent-1',
                                    elevation: isApplyFocused ? 'small' : undefined,
                                    pad: "0.75rem",
                                    borderRadius: "6px",
                                    onMouseOver: ()=>setIsApplyFocused(true),
                                    onMouseOut: ()=>setIsApplyFocused(false),
                                    onClick: ()=>onSubmit(),
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        color: "white",
                                        size: "1rem",
                                        weight: 500,
                                        children: !isFiltering ? submitLabel || t('common:apply') : t('common:applying')
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    id: "clear_filters",
                                    justify: "center",
                                    align: "center",
                                    fill: "horizontal",
                                    pad: "0.75rem",
                                    background: isClearFocused ? 'light-5' : 'light-4',
                                    elevation: isClearFocused ? 'small' : undefined,
                                    border: {
                                        color: 'light-2',
                                        size: '0.05rem'
                                    },
                                    borderRadius: "6px",
                                    onMouseOver: ()=>setIsClearFocused(true),
                                    onMouseOut: ()=>setIsClearFocused(false),
                                    onClick: ()=>onClear(),
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "1rem",
                                        weight: 500,
                                        children: t('common:clear')
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};




var $2xPiy = parcelRequire("2xPiy");




const $d5dc00f4222e17dc$export$c9824d87391788f3 = (props)=>{
    const { isFiltering: isFiltering, onSubmit: onSubmit, onClear: onClear, filters: filters, ...boxProps } = props;
    const [isApplyFocused, setIsApplyFocused] = (0, $2xPiy.useState)(false);
    const [isClearFocused, setIsClearFocused] = (0, $2xPiy.useState)(false);
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
        width: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(300),
        ...boxProps,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                pad: {
                    horizontal: 'medium',
                    vertical: 'small'
                },
                title: t('common:filters'),
                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $eec4bc4b18205d01$export$ec91da630f36d5ea), {
                    size: "24px",
                    color: "brand"
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                pad: "1.5rem",
                gap: "medium",
                children: [
                    filters.map((filter)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            gap: "xsmall",
                            ...boxProps,
                            children: [
                                filter.type === 'input' && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                    label: filter.label,
                                    setValue: filter.setValue,
                                    onSubmit: onSubmit,
                                    value: filter.value,
                                    fontFamily: "Lato, sans-serif",
                                    disabled: filter.disabled,
                                    hideOptionalText: true
                                }),
                                (!filter.type || filter.type === 'select') && !!filter.options && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                    label: filter.label,
                                    placeholder: t('common:choose'),
                                    options: filter.options,
                                    value: filter.value,
                                    setValue: filter.setValue,
                                    fontFamily: "Lato, sans-serif",
                                    disabled: filter.disabled,
                                    hideOptionalText: true
                                })
                            ]
                        }, filter.label)),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        direction: "row",
                        justify: "between",
                        gap: "xsmall",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                justify: "center",
                                fill: "horizontal",
                                background: isApplyFocused ? 'button-hover' : 'accent-1',
                                elevation: isApplyFocused ? 'small' : undefined,
                                pad: "0.75rem",
                                borderRadius: "6px",
                                onMouseOver: ()=>setIsApplyFocused(true),
                                onMouseOut: ()=>setIsApplyFocused(false),
                                onClick: ()=>onSubmit(),
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    alignSelf: "center",
                                    color: "white",
                                    size: "1rem",
                                    weight: 500,
                                    children: !isFiltering ? t('common:apply') : t('common:applying')
                                })
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                justify: "center",
                                fill: "horizontal",
                                pad: "0.75rem",
                                background: isClearFocused ? 'light-5' : 'light-4',
                                elevation: isClearFocused ? 'small' : undefined,
                                border: {
                                    color: 'light-2',
                                    size: '0.05rem'
                                },
                                borderRadius: "6px",
                                onMouseOver: ()=>setIsClearFocused(true),
                                onMouseOut: ()=>setIsClearFocused(false),
                                onClick: ()=>onClear(),
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    alignSelf: "center",
                                    size: "1rem",
                                    weight: 500,
                                    children: t('common:clear')
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



parcelRequire("2xPiy");

const $ed228084f3add613$export$aff4fc93593c3bcf = ({ children: children, pad: pad, gap: gap, background: background, ...boxProps })=>{
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        pad: pad || '1rem',
        gap: gap || '0.5rem',
        background: background || 'light-6',
        border: {
            size: 'small',
            color: 'light-5'
        },
        borderRadius: "6px",
        direction: "row",
        align: "center",
        fontFamily: "Lato, sans-serif",
        ...boxProps,
        children: children
    });
};






var $0af6249c6475ab9a$exports = {};
$0af6249c6475ab9a$exports = $parcel$resolve("i07th");




const $44eeea64131db5d9$export$ddd501dda1f62236 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(({ id: id = 'language-selector' })=>{
    const { i18n: i18n } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const { isFuseAdmin: isFuseAdmin } = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    if (isFuseAdmin) return null;
    const languageOptions = [
        {
            label: 'English',
            value: 'en',
            flagSrc: 'https://flagcdn.com/w80/us.png',
            flagSrcSet: 'https://flagcdn.com/w160/us.png 2x'
        },
        {
            label: "Fran\xe7ais",
            value: 'fc',
            flagSrc: (0, (/*@__PURE__*/$parcel$interopDefault($0af6249c6475ab9a$exports)))
        }
    ];
    const handleLanguageChange = (option)=>{
        i18n.changeLanguage(option.value);
    };
    const currentLanguage = languageOptions.find((option)=>option.value === i18n.language) || languageOptions[0];
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        style: {
            position: 'fixed',
            bottom: '24px',
            left: '24px',
            zIndex: 1000,
            borderRadius: '20%',
            width: '60px',
            height: '60px',
            justifyContent: 'center',
            backgroundColor: 'white',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
        },
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c9158ac1cba12f75$export$64fff40e709e8b2e), {
            id: id,
            plain: true,
            dropAlign: {
                bottom: 'top',
                left: 'left'
            },
            dropProps: {
                margin: {
                    bottom: 'medium'
                },
                round: '6px',
                overflow: 'hidden'
            },
            dropContent: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                background: "white",
                children: languageOptions.map((option)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        pad: "small",
                        hoverIndicator: true,
                        onClick: ()=>handleLanguageChange(option),
                        direction: "row",
                        align: "center",
                        gap: "small",
                        style: {
                            cursor: 'pointer'
                        },
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("img", {
                                src: option.flagSrc,
                                srcSet: option.flagSrcSet,
                                width: "20",
                                height: "15",
                                alt: option.label,
                                style: {
                                    borderRadius: '2px',
                                    objectFit: 'cover'
                                }
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: "small",
                                children: option.label
                            })
                        ]
                    }, option.value))
            }),
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                align: "center",
                justify: "center",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("img", {
                    src: currentLanguage.flagSrc,
                    srcSet: currentLanguage.flagSrcSet,
                    width: "32",
                    height: "24",
                    alt: currentLanguage.label,
                    style: {
                        borderRadius: '3px',
                        objectFit: 'cover'
                    }
                })
            })
        })
    });
});
var $44eeea64131db5d9$export$2e2bcd8739ae039 = $44eeea64131db5d9$export$ddd501dda1f62236;



parcelRequire("2xPiy");

const $6007641569af9929$export$17d680238e50603e = (props)=>{
    const { direction: direction = 'horizontal', size: size = '0.8px', color: color = 'light-5', margin: // margin = '0.5rem',
    margin = '1.5rem' } = props;
    const side = direction === 'vertical' ? 'right' : 'top';
    const marginSide = direction === 'vertical' ? 'horizontal' : 'vertical';
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        border: {
            side: side,
            size: size,
            color: color
        },
        margin: {
            [marginSide]: margin
        }
    });
};



parcelRequire("2xPiy");

const $2d2300e67aede872$export$a6c7ac8248d6e38a = (props)=>{
    const { children: children, fontFamily: fontFamily, textDecoration: textDecoration = 'none', style: style, ...routerLinkProps } = props;
    const customStyles = {};
    if (fontFamily) customStyles.fontFamily = fontFamily;
    if (textDecoration) customStyles.textDecoration = textDecoration;
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $79bcac94ca400be1$export$a6c7ac8248d6e38a), {
        style: {
            ...customStyles,
            ...style
        },
        ...routerLinkProps,
        children: children
    });
};





var $2xPiy = parcelRequire("2xPiy");


var $2xPiy = parcelRequire("2xPiy");


function $49bab0c28ee1a3c4$var$_extends() {
    return $49bab0c28ee1a3c4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $49bab0c28ee1a3c4$var$_extends.apply(null, arguments);
}
var $49bab0c28ee1a3c4$export$b820fc49f2736e85 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    var scaleProps = (0, $c043e17d1ada851a$export$56a2e46cd4a7c217)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $49bab0c28ee1a3c4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Next"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", $49bab0c28ee1a3c4$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m7 2 10 10L7 22"
    }, scaleProps)));
});
$49bab0c28ee1a3c4$export$b820fc49f2736e85.displayName = 'Next';


var $2xPiy = parcelRequire("2xPiy");


function $7f9dc5744e43cef4$var$_extends() {
    return $7f9dc5744e43cef4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7f9dc5744e43cef4$var$_extends.apply(null, arguments);
}
var $7f9dc5744e43cef4$export$a499fb457891d86e = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    var scaleProps = (0, $c043e17d1ada851a$export$56a2e46cd4a7c217)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $7f9dc5744e43cef4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Previous"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", $7f9dc5744e43cef4$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M17 2 7 12l10 10"
    }, scaleProps)));
});
$7f9dc5744e43cef4$export$a499fb457891d86e.displayName = 'Previous';






const $26f637f3d75d0420$export$54d79d35af45a337 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { reportingPeriods: reportingPeriods, selectedReportingPeriod: selectedReportingPeriod, setSelectedReportingPeriod: setSelectedReportingPeriod, nextPeriod: nextPeriod, previousPeriod: previousPeriod, isCanada: isCanada, id: id, name: name, showNav: showNav, error: error, fill: fill, ...selectProps } = props;
    /** State **/ const [options, setOptions] = (0, $2xPiy.useState)();
    /** Context **/ const tooltips = (0, $d597772cdbe12609$export$4713da6aa4410043)();
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        const periodOptions = (0, $00658ccd6ec0135a$export$b3ab20afa21fa2d4)(reportingPeriods).map((period)=>({
                label: (0, $00658ccd6ec0135a$export$f96ebb633255a704)(period.end_reporting_quarter, !!isCanada),
                value: period.id
            }));
        setOptions(periodOptions);
    }, [
        reportingPeriods,
        isCanada
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                direction: "row",
                gap: "small",
                children: [
                    showNav && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                        plain: true,
                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7f9dc5744e43cef4$export$a499fb457891d86e), {}),
                        onClick: ()=>{
                            if (previousPeriod) setSelectedReportingPeriod(previousPeriod);
                        },
                        disabled: !previousPeriod,
                        tip: tooltips.previousPeriod
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                        id: id,
                        name: id ? undefined : name || 'reporting_period',
                        label: selectProps.label || 'Reporting Period',
                        placeholder: selectProps.placeholder || 'Choose...',
                        value: selectedReportingPeriod?.id,
                        setValue: (value)=>{
                            const period = reportingPeriods?.find((p)=>p.id === value);
                            if (period) setSelectedReportingPeriod(period);
                        },
                        options: options ?? [],
                        disabled: selectProps.disabled,
                        required: selectProps.required,
                        fill: fill
                    }),
                    showNav && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                        plain: true,
                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $49bab0c28ee1a3c4$export$b820fc49f2736e85), {}),
                        onClick: ()=>{
                            if (nextPeriod) setSelectedReportingPeriod(nextPeriod);
                        },
                        disabled: !nextPeriod,
                        tip: tooltips.nextPeriod
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                row: true,
                gap: "small",
                margin: {
                    top: '0.5rem',
                    left: '0.75rem'
                },
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    color: "red",
                    size: "0.75rem",
                    children: error
                })
            })
        ]
    });
});



parcelRequire("2xPiy");

const $0c275a301c6c9ccc$export$34f176c4eb456ef9 = ({ children: children, ...boxProps })=>{
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        direction: "row",
        ...boxProps,
        children: children
    });
};




var $2xPiy = parcelRequire("2xPiy");


const $b012ec9a92c56d14$export$b2539bed5023c21c = (props)=>{
    const { titles: titles, activeTab: activeTab, setActiveTab: setActiveTab, dataTours: dataTours, ...boxProps } = props;
    const [hoverTab, setHoverTab] = (0, $2xPiy.useState)();
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        flex: "grow",
        direction: "row",
        gap: "0.25rem",
        background: "light",
        pad: {
            horizontal: 'medium',
            top: '2rem'
        },
        ...boxProps,
        children: titles.map((title, i)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                onClick: ()=>setActiveTab(i),
                onMouseOver: ()=>setHoverTab(i),
                onMouseOut: ()=>setHoverTab(undefined),
                style: {
                    cursor: activeTab === i ? 'default' : hoverTab === i ? 'pointer' : undefined
                },
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    pad: {
                        horizontal: '1.5rem',
                        vertical: '0.75rem'
                    },
                    border: {
                        color: activeTab === i || hoverTab === i ? 'light-2' : 'transparent',
                        size: 'small'
                    },
                    style: {
                        boxShadow: activeTab === i || hoverTab === i ? 'rgba(24, 100, 158, 0.2) 0px -24px 24px -24px inset' : '',
                        borderTopLeftRadius: '6px',
                        borderTopRightRadius: '6px',
                        borderBottom: '0px solid white'
                    },
                    transitionProperty: "color, box-shadow",
                    transitionDuration: "0.15s, 0.15s",
                    transitionTimingFunction: "ease, ease",
                    "data-tour": dataTours?.[i],
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        color: activeTab !== i ? 'accent-1' : undefined,
                        size: "1rem",
                        lineHeight: "1.5rem",
                        letterSpacing: "0.8px",
                        children: title.toUpperCase()
                    })
                })
            }, title))
    });
};



parcelRequire("2xPiy");

const $f59708bf363dcc09$export$3288d34c523a1192 = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        background: "light-4",
        pad: {
            horizontal: '0.5rem',
            vertical: '0.25rem'
        },
        border: {
            color: 'light-2',
            size: '0.8px'
        },
        borderRadius: "4px",
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
            fontFamily: "Lato, sans-serif",
            size: "0.75rem",
            children: children
        })
    });
};



parcelRequire("2xPiy");


const $7d936c80978f5831$export$5f1af8db9871e1d6 = (props)=>{
    const { children: children, lineHeight: lineHeight, fontFamily: fontFamily, letterSpacing: letterSpacing, toUpperCase: toUpperCase, convertToRems: convertToRems, size: size, style: style, transitionDuration: transitionDuration, transitionProperty: transitionProperty, transitionTimingFunction: transitionTimingFunction, ...textProps } = props;
    const remLineHeight = convertToRems && lineHeight ? (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(lineHeight) : undefined;
    const remLetterSpacing = convertToRems && letterSpacing ? (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(letterSpacing) : undefined;
    const remSize = convertToRems && size ? (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(size) : undefined;
    const customStyles = {};
    if (lineHeight) customStyles.lineHeight = remLineHeight ?? lineHeight;
    if (letterSpacing) customStyles.letterSpacing = remLetterSpacing ?? letterSpacing;
    if (fontFamily) customStyles.fontFamily = fontFamily;
    if (toUpperCase) customStyles.textTransform = 'uppercase';
    if (transitionDuration) customStyles.transitionDuration = transitionDuration;
    if (transitionProperty) customStyles.transitionProperty = transitionProperty;
    if (transitionTimingFunction) customStyles.transitionTimingFunction = transitionTimingFunction;
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), {
        style: {
            ...customStyles,
            ...style
        },
        size: remSize ?? size,
        ...textProps,
        children: children
    });
};





const $3680d7301df649fd$export$229cbb05167f08e5 = (props)=>{
    const { clients: clients, showFields: showFields, onMore: onMore, onSort: onSort, sortProperty: sortProperty, sortDirection: sortDirection, isCanada: isCanada = false } = props;
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** Computed **/ const defaultColumns = [
        {
            property: 'name',
            header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                title: t('common:clientName'),
                toUpperCase: true
            }),
            size: '60%',
            primary: true,
            render: (client)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    pad: {
                        vertical: '1rem'
                    },
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                        to: `/clients/${client.id}`,
                        fontFamily: "Lato, sans-serif",
                        textDecoration: "none",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                            color: "accent-1",
                            weight: 700,
                            children: client.name
                        })
                    })
                })
        },
        {
            property: 'start_date',
            header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                title: t('client:fuseStart'),
                toUpperCase: true
            }),
            render: (client)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                    children: (0, $00658ccd6ec0135a$export$25fe81f0e0c5bc4)(client.start_date, isCanada)
                })
        },
        {
            property: 'website',
            sortable: false,
            size: '15%',
            align: 'start',
            header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                title: "URL"
            }),
            render: (client)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    width: "22px",
                    height: "22px",
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                        to: client.website ?? '',
                        target: "_blank",
                        referrerPolicy: "no-referrer",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $1aed433c8cc8fc70$export$a6c7ac8248d6e38a), {
                            color: "dark-1",
                            size: "22px"
                        })
                    })
                })
        }
    ];
    const columns = showFields?.length ? defaultColumns.filter(({ property: property })=>showFields.includes(property)) : defaultColumns;
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
        id: "client_list_data_table",
        pad: {
            horizontal: '1.5rem'
        },
        step: 20,
        paginate: true,
        columns: columns,
        data: clients,
        onMore: onMore,
        sortable: true,
        sort: sortProperty && sortDirection ? {
            property: sortProperty,
            direction: sortDirection
        } : undefined,
        onSort: onSort ? (sort)=>onSort(sort.property, sort.direction) : undefined,
        background: [
            'light-6',
            'white'
        ],
        border: {
            color: 'light-2',
            side: 'bottom',
            size: 'small'
        }
    });
};



parcelRequire("2xPiy");


var $2xPiy = parcelRequire("2xPiy");

function $93663f13c4b467ae$var$_extends() {
    return $93663f13c4b467ae$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $93663f13c4b467ae$var$_extends.apply(null, arguments);
}
var $93663f13c4b467ae$export$d9b273488cd8ce6f = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $93663f13c4b467ae$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Menu"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 19h20M2 5h20M2 12h20"
    }));
});
$93663f13c4b467ae$export$d9b273488cd8ce6f.displayName = 'Menu';


var $2xPiy = parcelRequire("2xPiy");

function $546d71f0291023a6$var$_extends() {
    return $546d71f0291023a6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $546d71f0291023a6$var$_extends.apply(null, arguments);
}
var $546d71f0291023a6$export$f3a6aa388b70f149 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $546d71f0291023a6$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Organization"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M20 3v20H4V3h16zM8.042 9h2V7h-2v2zM14 9h2V7h-2v2zm-5.958 6h2v-2h-2v2zm2 8h4v-4h-4v4zM14 15h2v-2h-2v2zM2 3h20V1H2v2z"
    }));
});
$546d71f0291023a6$export$f3a6aa388b70f149.displayName = 'Organization';



parcelRequire("2xPiy");
const $ac6d619f145000c4$var$SvgFiletypeCsv = (props)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        className: "bi bi-filetype-csv",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM3.517 14.841a1.13 1.13 0 0 0 .401.823q.195.162.478.252.284.091.665.091.507 0 .859-.158.354-.158.539-.44.187-.284.187-.656 0-.336-.134-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.566-.21l-.621-.144a1 1 0 0 1-.404-.176.37.37 0 0 1-.144-.299q0-.234.185-.384.188-.152.512-.152.214 0 .37.068a.6.6 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.2-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.439 0-.776.15-.337.149-.527.421-.19.273-.19.639 0 .302.122.524.124.223.352.367.228.143.539.213l.618.144q.31.073.463.193a.39.39 0 0 1 .152.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.167.07-.413.07-.175 0-.32-.04a.8.8 0 0 1-.248-.115.58.58 0 0 1-.255-.384zM.806 13.693q0-.373.102-.633a.87.87 0 0 1 .302-.399.8.8 0 0 1 .475-.137q.225 0 .398.097a.7.7 0 0 1 .272.26.85.85 0 0 1 .12.381h.765v-.072a1.33 1.33 0 0 0-.466-.964 1.4 1.4 0 0 0-.489-.272 1.8 1.8 0 0 0-.606-.097q-.534 0-.911.223-.375.222-.572.632-.195.41-.196.979v.498q0 .568.193.976.197.407.572.626.375.217.914.217.439 0 .785-.164t.55-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.764a.8.8 0 0 1-.118.363.7.7 0 0 1-.272.25.9.9 0 0 1-.401.087.85.85 0 0 1-.478-.132.83.83 0 0 1-.299-.392 1.7 1.7 0 0 1-.102-.627zm8.239 2.238h-.953l-1.338-3.999h.917l.896 3.138h.038l.888-3.138h.879z"
        })
    });
var $ac6d619f145000c4$export$2e2bcd8739ae039 = $ac6d619f145000c4$var$SvgFiletypeCsv;



parcelRequire("2xPiy");
const $71b777ab3115472d$var$SvgFiletypeDoc = (props)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        className: "bi bi-filetype-doc",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zm-7.839 9.166v.522q0 .384-.117.641a.86.86 0 0 1-.322.387.9.9 0 0 1-.469.126.9.9 0 0 1-.471-.126.87.87 0 0 1-.32-.386 1.55 1.55 0 0 1-.117-.642v-.522q0-.386.117-.641a.87.87 0 0 1 .32-.387.87.87 0 0 1 .471-.129q.264 0 .469.13a.86.86 0 0 1 .322.386q.117.255.117.641m.803.519v-.513q0-.565-.205-.972a1.46 1.46 0 0 0-.589-.63q-.381-.22-.917-.22-.533 0-.92.22a1.44 1.44 0 0 0-.589.627q-.204.406-.205.975v.513q0 .563.205.973.205.406.59.627.386.216.92.216.535 0 .916-.216.383-.22.59-.627.204-.41.204-.973M0 11.926v4h1.459q.603 0 .999-.238a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.59-.68q-.395-.234-1.004-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082H.79V12.57Zm7.422.483a1.7 1.7 0 0 0-.103.633v.495q0 .369.103.627a.83.83 0 0 0 .298.393.85.85 0 0 0 .478.131.9.9 0 0 0 .401-.088.7.7 0 0 0 .273-.248.8.8 0 0 0 .117-.364h.765v.076a1.27 1.27 0 0 1-.226.674q-.205.29-.55.454a1.8 1.8 0 0 1-.786.164q-.54 0-.914-.216a1.42 1.42 0 0 1-.571-.627q-.194-.408-.194-.976v-.498q0-.568.197-.978.195-.411.571-.633.378-.223.911-.223.328 0 .607.097.28.093.489.272a1.33 1.33 0 0 1 .466.964v.073H9.78a.85.85 0 0 0-.12-.38.7.7 0 0 0-.273-.261.8.8 0 0 0-.398-.097.8.8 0 0 0-.475.138.87.87 0 0 0-.301.398"
        })
    });
var $71b777ab3115472d$export$2e2bcd8739ae039 = $71b777ab3115472d$var$SvgFiletypeDoc;



parcelRequire("2xPiy");
const $f7b07092b04f6732$var$SvgFiletypeDocx = (props)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        className: "bi bi-filetype-docx",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zm-6.839 9.688v-.522a1.5 1.5 0 0 0-.117-.641.86.86 0 0 0-.322-.387.86.86 0 0 0-.469-.129.87.87 0 0 0-.471.13.87.87 0 0 0-.32.386 1.5 1.5 0 0 0-.117.641v.522q0 .384.117.641a.87.87 0 0 0 .32.387.9.9 0 0 0 .471.126.9.9 0 0 0 .469-.126.86.86 0 0 0 .322-.386 1.55 1.55 0 0 0 .117-.642m.803-.516v.513q0 .563-.205.973a1.47 1.47 0 0 1-.589.627q-.381.216-.917.216a1.86 1.86 0 0 1-.92-.216 1.46 1.46 0 0 1-.589-.627 2.15 2.15 0 0 1-.205-.973v-.513q0-.569.205-.975.205-.411.59-.627.386-.22.92-.22.535 0 .916.22.383.219.59.63.204.406.204.972M1 15.925v-3.999h1.459q.609 0 1.005.235.396.233.589.68.196.445.196 1.074 0 .634-.196 1.084-.197.451-.595.689-.396.237-.999.237zm1.354-3.354H1.79v2.707h.563q.277 0 .483-.082a.8.8 0 0 0 .334-.252q.132-.17.196-.422a2.3 2.3 0 0 0 .068-.592q0-.45-.118-.753a.9.9 0 0 0-.354-.454q-.237-.152-.61-.152Zm6.756 1.116q0-.373.103-.633a.87.87 0 0 1 .301-.398.8.8 0 0 1 .475-.138q.225 0 .398.097a.7.7 0 0 1 .273.26.85.85 0 0 1 .12.381h.765v-.073a1.33 1.33 0 0 0-.466-.964 1.4 1.4 0 0 0-.49-.272 1.8 1.8 0 0 0-.606-.097q-.534 0-.911.223-.375.222-.571.633-.197.41-.197.978v.498q0 .568.194.976.195.406.571.627.375.216.914.216.44 0 .785-.164t.551-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.765a.8.8 0 0 1-.117.364.7.7 0 0 1-.273.248.9.9 0 0 1-.401.088.85.85 0 0 1-.478-.131.83.83 0 0 1-.298-.393 1.7 1.7 0 0 1-.103-.627zm5.092-1.76h.894l-1.275 2.006 1.254 1.992h-.908l-.85-1.415h-.035l-.852 1.415h-.862l1.24-2.015-1.228-1.984h.932l.832 1.439h.035z"
        })
    });
var $f7b07092b04f6732$export$2e2bcd8739ae039 = $f7b07092b04f6732$var$SvgFiletypeDocx;



parcelRequire("2xPiy");
const $34a908e70489f46f$var$SvgFiletypePdf = (props)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        className: "bi bi-filetype-pdf",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z"
        })
    });
var $34a908e70489f46f$export$2e2bcd8739ae039 = $34a908e70489f46f$var$SvgFiletypePdf;



parcelRequire("2xPiy");
const $24b8ecaefb555651$var$SvgFiletypeTxt = (props)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        className: "bi bi-filetype-txt",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M14 4.5V14a2 2 0 0 1-2 2h-2v-1h2a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.928 15.849v-3.337h1.136v-.662H0v.662h1.134v3.337zm4.689-3.999h-.894L4.9 13.289h-.035l-.832-1.439h-.932l1.228 1.983-1.24 2.016h.862l.853-1.415h.035l.85 1.415h.907l-1.253-1.992zm1.93.662v3.337h-.794v-3.337H6.619v-.662h3.064v.662H8.546Z"
        })
    });
var $24b8ecaefb555651$export$2e2bcd8739ae039 = $24b8ecaefb555651$var$SvgFiletypeTxt;



parcelRequire("2xPiy");
const $62d47c593e65bbe2$var$SvgFiletypeXls = (props)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        className: "bi bi-filetype-xls",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM6.472 15.29a1.2 1.2 0 0 1-.111-.449h.765a.58.58 0 0 0 .254.384q.106.073.25.114.143.041.319.041.246 0 .413-.07a.56.56 0 0 0 .255-.193.5.5 0 0 0 .085-.29.39.39 0 0 0-.153-.326q-.152-.12-.462-.193l-.619-.143a1.7 1.7 0 0 1-.539-.214 1 1 0 0 1-.351-.367 1.07 1.07 0 0 1-.123-.524q0-.366.19-.639.19-.272.527-.422.338-.15.777-.149.457 0 .78.152.324.153.5.41.18.255.2.566h-.75a.56.56 0 0 0-.12-.258.6.6 0 0 0-.247-.181.9.9 0 0 0-.369-.068q-.325 0-.513.152a.47.47 0 0 0-.184.384q0 .18.143.3a1 1 0 0 0 .405.175l.62.143q.326.075.566.211a1 1 0 0 1 .375.358q.135.222.135.56 0 .37-.188.656a1.2 1.2 0 0 1-.539.439q-.351.158-.858.158-.381 0-.665-.09a1.4 1.4 0 0 1-.478-.252 1.1 1.1 0 0 1-.29-.375m-2.945-3.358h-.893L1.81 13.37h-.036l-.832-1.438h-.93l1.227 1.983L0 15.931h.861l.853-1.415h.035l.85 1.415h.908L2.253 13.94zm2.727 3.325H4.557v-3.325h-.79v4h2.487z"
        })
    });
var $62d47c593e65bbe2$export$2e2bcd8739ae039 = $62d47c593e65bbe2$var$SvgFiletypeXls;



parcelRequire("2xPiy");
const $eb41741acb57eac1$var$SvgFiletypeXlsx = (props)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        className: "bi bi-filetype-xlsx",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM7.86 14.841a1.13 1.13 0 0 0 .401.823q.195.162.479.252.284.091.665.091.507 0 .858-.158.355-.158.54-.44a1.17 1.17 0 0 0 .187-.656q0-.336-.135-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.565-.21l-.621-.144a1 1 0 0 1-.405-.176.37.37 0 0 1-.143-.299q0-.234.184-.384.188-.152.513-.152.214 0 .37.068a.6.6 0 0 1 .245.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.199-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.44 0-.777.15-.336.149-.527.421-.19.273-.19.639 0 .302.123.524t.351.367q.229.143.54.213l.618.144q.31.073.462.193a.39.39 0 0 1 .153.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.168.07-.413.07-.176 0-.32-.04a.8.8 0 0 1-.249-.115.58.58 0 0 1-.255-.384zm-3.726-2.909h.893l-1.274 2.007 1.254 1.992h-.908l-.85-1.415h-.035l-.853 1.415H1.5l1.24-2.016-1.228-1.983h.931l.832 1.438h.036zm1.923 3.325h1.697v.674H5.266v-3.999h.791zm7.636-3.325h.893l-1.274 2.007 1.254 1.992h-.908l-.85-1.415h-.035l-.853 1.415h-.861l1.24-2.016-1.228-1.983h.931l.832 1.438h.036z"
        })
    });
var $eb41741acb57eac1$export$2e2bcd8739ae039 = $eb41741acb57eac1$var$SvgFiletypeXlsx;




const $4261960a4ecb3a3e$export$b46609774102e9b8 = (props)=>{
    const { clientFiles: clientFiles, metadata: metadata, currentPage: currentPage, setCurrentPage: setCurrentPage, showAddButton: showAddButton } = props;
    const renderEditButton = ()=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                borderRadius: "6px",
                direction: "row",
                justify: "center",
                pad: {
                    vertical: '0.5rem'
                },
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $93663f13c4b467ae$export$d9b273488cd8ce6f), {
                    size: "14px",
                    color: "accent-1"
                })
            })
        });
    const renderFileTypeIcon = (clientFile)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            alignSelf: "center",
            width: "20px",
            height: "20px",
            children: [
                clientFile.type === (0, $e325a86eb2295b0b$export$c5ae10d7c88c4d3e).CSV && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ac6d619f145000c4$export$2e2bcd8739ae039), {}),
                clientFile.type === (0, $e325a86eb2295b0b$export$c5ae10d7c88c4d3e).DOC && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $71b777ab3115472d$export$2e2bcd8739ae039), {}),
                clientFile.type === (0, $e325a86eb2295b0b$export$c5ae10d7c88c4d3e).DOCX && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f7b07092b04f6732$export$2e2bcd8739ae039), {}),
                clientFile.type === (0, $e325a86eb2295b0b$export$c5ae10d7c88c4d3e).PDF && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $34a908e70489f46f$export$2e2bcd8739ae039), {}),
                clientFile.type === (0, $e325a86eb2295b0b$export$c5ae10d7c88c4d3e).TXT && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $24b8ecaefb555651$export$2e2bcd8739ae039), {}),
                clientFile.type === (0, $e325a86eb2295b0b$export$c5ae10d7c88c4d3e).XLS && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d47c593e65bbe2$export$2e2bcd8739ae039), {}),
                clientFile.type === (0, $e325a86eb2295b0b$export$c5ae10d7c88c4d3e).XLSX && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $eb41741acb57eac1$export$2e2bcd8739ae039), {})
            ]
        });
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                title: "Documents List",
                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $546d71f0291023a6$export$f3a6aa388b70f149), {
                    size: "24px",
                    color: "brand"
                }),
                children: showAddButton && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $85ab7488c493b81c$export$6d88ebe453be59d7), {
                    label: "Add Record"
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $fdccc762800a972d$export$851de33184ecdac4), {
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        elevation: "small",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
                                columns: [
                                    {
                                        property: '',
                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            height: "1rem",
                                            margin: {
                                                vertical: '1rem'
                                            }
                                        }),
                                        render: renderEditButton
                                    },
                                    {
                                        property: 'name',
                                        primary: true,
                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                            children: "NAME"
                                        }),
                                        render: (clientFile)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                children: clientFile.name
                                            })
                                    },
                                    {
                                        property: 'type',
                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                            children: "TYPE"
                                        }),
                                        render: renderFileTypeIcon
                                    },
                                    {
                                        property: 'date',
                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                            children: "DATE"
                                        })
                                    },
                                    {
                                        property: 'size',
                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                            children: "SIZE"
                                        })
                                    },
                                    {
                                        property: 'category',
                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                            children: "CATEGORY"
                                        })
                                    }
                                ],
                                data: clientFiles,
                                background: [
                                    'light-6',
                                    'white'
                                ],
                                border: {
                                    color: 'light-2',
                                    side: 'bottom',
                                    size: '0.05rem'
                                }
                            }),
                            !clientFiles?.length && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                pad: {
                                    horizontal: '1.5rem',
                                    vertical: '2rem'
                                },
                                background: "light-6",
                                justify: "center",
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    alignSelf: "center",
                                    size: "medium",
                                    fontFamily: "Lato, sans-serif",
                                    children: "No documents found."
                                })
                            })
                        ]
                    }),
                    !!metadata && !!currentPage && !!setCurrentPage && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        pad: "1.5rem",
                        flex: "grow",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ffccbada2139938a$export$68f5e1453c188a82), {
                            alignSelf: "center",
                            size: "small",
                            page: currentPage,
                            step: metadata?.per_page,
                            numberItems: metadata?.total,
                            onChange: (e)=>setCurrentPage(e.page)
                        })
                    })
                ]
            })
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");







const $de52040ad2eb6f89$export$993f34602c1007f2 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    /* Props */ const { formValues: formValues, updateFormValue: updateFormValue, formErrors: formErrors, isCanada: isCanada, id: id, isUpdatePage: isUpdatePage, isRetired: isRetired, retirementReasonText: retirementReasonText, onSubmit: onSubmit } = props;
    /* Context */ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /* Computed */ const isMobile = (0, $18588a518ac6fdc7$export$2ac00d7098bf223)(screenSize);
    const reportingPeriodOptions = isCanada ? globalStore.reportingYearOptions : globalStore.reportingQuarterOptions;
    const firstPeriodLabel = isCanada ? formValues.first_active_reporting_quarter?.slice(0, 4) : (0, $00658ccd6ec0135a$export$6a2a5264dcc16b56)((0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(formValues.first_active_reporting_quarter).toDate());
    /* Render */ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
        id: id,
        title: t('common:generalInfo'),
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            direction: isMobile ? 'column' : 'row',
            gap: "1rem",
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    width: isMobile ? '100%' : '50%',
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            gap: "1rem",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                    name: "client_name",
                                    label: t('client:companyLegalName'),
                                    value: formValues.name,
                                    setValue: (value)=>updateFormValue('name', value),
                                    error: formErrors['name'],
                                    onSubmit: onSubmit,
                                    required: true,
                                    disabled: !userStore.isFuseAdmin
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                    name: "website",
                                    label: t('client:websiteURL'),
                                    value: formValues.website,
                                    setValue: (value)=>updateFormValue('website', value),
                                    error: formErrors['website'],
                                    onSubmit: onSubmit,
                                    disabled: !userStore.isFuseAdmin && (!userStore.isAdminUser || !userStore.isClientUser)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {}),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            flex: "grow",
                            height: "15rem",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                name: "comments",
                                label: t('common:comments'),
                                value: formValues.comments ?? '',
                                setValue: (value)=>updateFormValue('comments', value),
                                error: formErrors['comments'],
                                onSubmit: onSubmit,
                                placeholder: "",
                                centerLabel: false,
                                componentType: "textArea",
                                disabled: !userStore.isFuseAdmin && (!userStore.isAdminUser || !userStore.isClientUser)
                            })
                        })
                    ]
                }),
                isMobile ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                    margin: "0.5rem"
                }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                    direction: "vertical",
                    margin: "2rem"
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    width: isMobile ? '100%' : '50%',
                    children: [
                        isUpdatePage && userStore.isFuseAdmin && isRetired && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            gap: "1rem",
                            margin: {
                                bottom: '1.5rem'
                            },
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                name: "retirement_reason",
                                label: t('common:reasonForRetiring'),
                                value: retirementReasonText ?? '',
                                placeholder: "-",
                                setValue: ()=>{},
                                centerLabel: false,
                                componentType: "textArea",
                                disabled: true,
                                minHeight: "50%",
                                opacity: 1
                            })
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            gap: "1rem",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                direction: isMobile ? 'column' : 'row',
                                gap: "1rem",
                                children: [
                                    isUpdatePage ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        name: "first_active_reporting_quarter",
                                        label: t('common:firstReportingPeriod'),
                                        fill: "horizontal",
                                        value: firstPeriodLabel,
                                        setValue: ()=>{
                                        // blank method
                                        },
                                        disabled: true
                                    }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                        id: "first_active_reporting_quarter",
                                        name: "first_active_reporting_quarter",
                                        label: t('common:firstReportingPeriod'),
                                        placeholder: t('common:selectPeriod'),
                                        fill: "horizontal",
                                        value: formValues.first_active_reporting_quarter,
                                        setValue: (value)=>updateFormValue('first_active_reporting_quarter', value),
                                        error: formErrors['first_active_reporting_quarter'],
                                        options: reportingPeriodOptions,
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        name: "start_date",
                                        label: t('client:fuseStartDate'),
                                        fill: "horizontal",
                                        value: formValues.start_date,
                                        setValue: (value)=>updateFormValue('start_date', value),
                                        error: formErrors['start_date'],
                                        onSubmit: onSubmit,
                                        componentType: "date",
                                        required: !(isUpdatePage || !userStore.isFuseAdmin && (!userStore.isAdminUser || !userStore.isClientUser)),
                                        disabled: isUpdatePage || !userStore.isFuseAdmin && (!userStore.isAdminUser || !userStore.isClientUser),
                                        displayValue: (0, $00658ccd6ec0135a$export$25fe81f0e0c5bc4)(formValues.start_date, isCanada)
                                    }),
                                    isUpdatePage && !userStore.isExternalUser && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        name: "end_date",
                                        label: t('client:fuseEndDate'),
                                        fill: "horizontal",
                                        value: formValues.end_date,
                                        setValue: (value)=>updateFormValue('end_date', value),
                                        error: formErrors['end_date'],
                                        componentType: "date",
                                        disabled: true,
                                        displayValue: (0, $00658ccd6ec0135a$export$25fe81f0e0c5bc4)(formValues.end_date ?? '', isCanada)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {}),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            gap: "1rem",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                name: "business_id",
                                label: t('client:feinBusinessNumber'),
                                value: formValues.business_id,
                                setValue: (value)=>updateFormValue('business_id', value),
                                error: formErrors['business_id'],
                                onSubmit: onSubmit,
                                required: true,
                                disabled: !userStore.isFuseAdmin
                            })
                        })
                    ]
                })
            ]
        })
    });
});




var $2xPiy = parcelRequire("2xPiy");










var $86d06b4c1fd1e033$var$_client, $86d06b4c1fd1e033$var$_currentQuery, $86d06b4c1fd1e033$var$_currentQueryInitialState, $86d06b4c1fd1e033$var$_currentResult, $86d06b4c1fd1e033$var$_currentResultState, $86d06b4c1fd1e033$var$_currentResultOptions, $86d06b4c1fd1e033$var$_currentThenable, $86d06b4c1fd1e033$var$_selectError, $86d06b4c1fd1e033$var$_selectFn, $86d06b4c1fd1e033$var$_selectResult, $86d06b4c1fd1e033$var$_lastQueryWithDefinedData, $86d06b4c1fd1e033$var$_staleTimeoutId, $86d06b4c1fd1e033$var$_refetchIntervalId, $86d06b4c1fd1e033$var$_currentRefetchInterval, $86d06b4c1fd1e033$var$_trackedProps, $86d06b4c1fd1e033$var$_QueryObserver_instances, $86d06b4c1fd1e033$var$executeFetch_fn, $86d06b4c1fd1e033$var$updateStaleTimeout_fn, $86d06b4c1fd1e033$var$computeRefetchInterval_fn, $86d06b4c1fd1e033$var$updateRefetchInterval_fn, $86d06b4c1fd1e033$var$updateTimers_fn, $86d06b4c1fd1e033$var$clearStaleTimeout_fn, $86d06b4c1fd1e033$var$clearRefetchInterval_fn, $86d06b4c1fd1e033$var$updateQuery_fn, $86d06b4c1fd1e033$var$notify_fn;
var $86d06b4c1fd1e033$export$a06cf8c0066f0d4c = class extends (0, $9e2bfa130a0bbb51$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.options = options;
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $86d06b4c1fd1e033$var$_QueryObserver_instances);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $86d06b4c1fd1e033$var$_client);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $86d06b4c1fd1e033$var$_currentQuery);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $86d06b4c1fd1e033$var$_currentQueryInitialState);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $86d06b4c1fd1e033$var$_currentResult);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $86d06b4c1fd1e033$var$_currentResultState);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $86d06b4c1fd1e033$var$_currentResultOptions);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $86d06b4c1fd1e033$var$_currentThenable);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $86d06b4c1fd1e033$var$_selectError);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $86d06b4c1fd1e033$var$_selectFn);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $86d06b4c1fd1e033$var$_selectResult);
        // This property keeps track of the last query with defined data.
        // It will be used to pass the previous data and query to the placeholder function between renders.
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $86d06b4c1fd1e033$var$_lastQueryWithDefinedData);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $86d06b4c1fd1e033$var$_staleTimeoutId);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $86d06b4c1fd1e033$var$_refetchIntervalId);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $86d06b4c1fd1e033$var$_currentRefetchInterval);
        (0, $9e75c35ac10ca972$export$addf369becd23283)(this, $86d06b4c1fd1e033$var$_trackedProps, /* @__PURE__ */ new Set());
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $86d06b4c1fd1e033$var$_client, client);
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $86d06b4c1fd1e033$var$_selectError, null);
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $86d06b4c1fd1e033$var$_currentThenable, (0, $4e3c58cfd6cd9f22$export$d54630db02a12b72)());
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery).addObserver(this);
            if ($86d06b4c1fd1e033$var$shouldFetchOnMount((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery), this.options)) (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $86d06b4c1fd1e033$var$_QueryObserver_instances, $86d06b4c1fd1e033$var$executeFetch_fn).call(this);
            else this.updateResult();
            (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $86d06b4c1fd1e033$var$_QueryObserver_instances, $86d06b4c1fd1e033$var$updateTimers_fn).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $86d06b4c1fd1e033$var$shouldFetchOn((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $86d06b4c1fd1e033$var$shouldFetchOn((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $86d06b4c1fd1e033$var$_QueryObserver_instances, $86d06b4c1fd1e033$var$clearStaleTimeout_fn).call(this);
        (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $86d06b4c1fd1e033$var$_QueryObserver_instances, $86d06b4c1fd1e033$var$clearRefetchInterval_fn).call(this);
        (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery).removeObserver(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        const prevQuery = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery);
        this.options = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_client).defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $43eecd02f94428b5$export$8c88ee6f2357230d)(this.options.enabled, (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery)) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $86d06b4c1fd1e033$var$_QueryObserver_instances, $86d06b4c1fd1e033$var$updateQuery_fn).call(this);
        (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery).setOptions(this.options);
        if (prevOptions._defaulted && !(0, $43eecd02f94428b5$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery),
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $86d06b4c1fd1e033$var$shouldFetchOptionally((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery), prevQuery, this.options, prevOptions)) (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $86d06b4c1fd1e033$var$_QueryObserver_instances, $86d06b4c1fd1e033$var$executeFetch_fn).call(this);
        this.updateResult();
        if (mounted && ((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery) !== prevQuery || (0, $43eecd02f94428b5$export$8c88ee6f2357230d)(this.options.enabled, (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery)) !== (0, $43eecd02f94428b5$export$8c88ee6f2357230d)(prevOptions.enabled, (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery)) || (0, $43eecd02f94428b5$export$cb3145f011bda3ac)(this.options.staleTime, (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery)) !== (0, $43eecd02f94428b5$export$cb3145f011bda3ac)(prevOptions.staleTime, (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery)))) (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $86d06b4c1fd1e033$var$_QueryObserver_instances, $86d06b4c1fd1e033$var$updateStaleTimeout_fn).call(this);
        const nextRefetchInterval = (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $86d06b4c1fd1e033$var$_QueryObserver_instances, $86d06b4c1fd1e033$var$computeRefetchInterval_fn).call(this);
        if (mounted && ((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery) !== prevQuery || (0, $43eecd02f94428b5$export$8c88ee6f2357230d)(this.options.enabled, (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery)) !== (0, $43eecd02f94428b5$export$8c88ee6f2357230d)(prevOptions.enabled, (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery)) || nextRefetchInterval !== (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentRefetchInterval))) (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $86d06b4c1fd1e033$var$_QueryObserver_instances, $86d06b4c1fd1e033$var$updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_client).getQueryCache().build((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_client), options);
        const result = this.createResult(query, options);
        if ($86d06b4c1fd1e033$var$shouldAssignObserverCurrentProperties(this, result)) {
            (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $86d06b4c1fd1e033$var$_currentResult, result);
            (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $86d06b4c1fd1e033$var$_currentResultOptions, this.options);
            (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $86d06b4c1fd1e033$var$_currentResultState, (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentResult);
    }
    trackResult(result, onPropTracked) {
        return new Proxy(result, {
            get: (target, key)=>{
                this.trackProp(key);
                onPropTracked == null || onPropTracked(key);
                if (key === "promise") {
                    this.trackProp("data");
                    if (!this.options.experimental_prefetchInRender && (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentThenable).status === "pending") (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentThenable).reject(new Error("experimental_prefetchInRender feature flag is not enabled"));
                }
                return Reflect.get(target, key);
            }
        });
    }
    trackProp(key) {
        (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_trackedProps).add(key);
    }
    getCurrentQuery() {
        return (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery);
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_client).defaultQueryOptions(options);
        const query = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_client).getQueryCache().build((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_client), defaultedOptions);
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $86d06b4c1fd1e033$var$_QueryObserver_instances, $86d06b4c1fd1e033$var$executeFetch_fn).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentResult);
        });
    }
    createResult(query, options) {
        var _a;
        const prevQuery = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentResult);
        const prevResultState = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentResultState);
        const prevResultOptions = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQueryInitialState);
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $86d06b4c1fd1e033$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $86d06b4c1fd1e033$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $73e4f980fbd6b4b1$export$f3df9013f2b58bce)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        data = newState.data;
        let skipSelect = false;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
                placeholderData = prevResult.data;
                skipSelect = true;
            } else placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_a = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_lastQueryWithDefinedData)) == null ? void 0 : _a.state.data, (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_lastQueryWithDefinedData)) : options.placeholderData;
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $43eecd02f94428b5$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (options.select && data !== void 0 && !skipSelect) {
            if (prevResult && data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_selectFn)) data = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_selectResult);
            else try {
                (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $86d06b4c1fd1e033$var$_selectFn, options.select);
                data = options.select(data);
                data = (0, $43eecd02f94428b5$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $86d06b4c1fd1e033$var$_selectResult, data);
                (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $86d06b4c1fd1e033$var$_selectError, null);
            } catch (selectError) {
                (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $86d06b4c1fd1e033$var$_selectError, selectError);
            }
        }
        if ((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_selectError)) {
            error = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_selectError);
            data = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: query.isFetched(),
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $86d06b4c1fd1e033$var$isStale(query, options),
            refetch: this.refetch,
            promise: (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentThenable),
            isEnabled: (0, $43eecd02f94428b5$export$8c88ee6f2357230d)(options.enabled, query) !== false
        };
        const nextResult = result;
        if (this.options.experimental_prefetchInRender) {
            const hasResultData = nextResult.data !== void 0;
            const isErrorWithoutData = nextResult.status === "error" && !hasResultData;
            const finalizeThenableIfPossible = (thenable)=>{
                if (isErrorWithoutData) thenable.reject(nextResult.error);
                else if (hasResultData) thenable.resolve(nextResult.data);
            };
            const recreateThenable = ()=>{
                const pending = (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $86d06b4c1fd1e033$var$_currentThenable, nextResult.promise = (0, $4e3c58cfd6cd9f22$export$d54630db02a12b72)());
                finalizeThenableIfPossible(pending);
            };
            const prevThenable = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentThenable);
            switch(prevThenable.status){
                case "pending":
                    if (query.queryHash === prevQuery.queryHash) finalizeThenableIfPossible(prevThenable);
                    break;
                case "fulfilled":
                    if (isErrorWithoutData || nextResult.data !== prevThenable.value) recreateThenable();
                    break;
                case "rejected":
                    if (!isErrorWithoutData || nextResult.error !== prevThenable.reason) recreateThenable();
                    break;
            }
        }
        return nextResult;
    }
    updateResult() {
        const prevResult = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentResult);
        const nextResult = this.createResult((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery), this.options);
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $86d06b4c1fd1e033$var$_currentResultState, (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery).state);
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $86d06b4c1fd1e033$var$_currentResultOptions, this.options);
        if ((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentResultState).data !== void 0) (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $86d06b4c1fd1e033$var$_lastQueryWithDefinedData, (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery));
        if ((0, $43eecd02f94428b5$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $86d06b4c1fd1e033$var$_currentResult, nextResult);
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $86d06b4c1fd1e033$var$_QueryObserver_instances, $86d06b4c1fd1e033$var$notify_fn).call(this, {
            listeners: shouldNotifyListeners()
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $86d06b4c1fd1e033$var$_QueryObserver_instances, $86d06b4c1fd1e033$var$updateTimers_fn).call(this);
    }
};
$86d06b4c1fd1e033$var$_client = new WeakMap();
$86d06b4c1fd1e033$var$_currentQuery = new WeakMap();
$86d06b4c1fd1e033$var$_currentQueryInitialState = new WeakMap();
$86d06b4c1fd1e033$var$_currentResult = new WeakMap();
$86d06b4c1fd1e033$var$_currentResultState = new WeakMap();
$86d06b4c1fd1e033$var$_currentResultOptions = new WeakMap();
$86d06b4c1fd1e033$var$_currentThenable = new WeakMap();
$86d06b4c1fd1e033$var$_selectError = new WeakMap();
$86d06b4c1fd1e033$var$_selectFn = new WeakMap();
$86d06b4c1fd1e033$var$_selectResult = new WeakMap();
$86d06b4c1fd1e033$var$_lastQueryWithDefinedData = new WeakMap();
$86d06b4c1fd1e033$var$_staleTimeoutId = new WeakMap();
$86d06b4c1fd1e033$var$_refetchIntervalId = new WeakMap();
$86d06b4c1fd1e033$var$_currentRefetchInterval = new WeakMap();
$86d06b4c1fd1e033$var$_trackedProps = new WeakMap();
$86d06b4c1fd1e033$var$_QueryObserver_instances = new WeakSet();
$86d06b4c1fd1e033$var$executeFetch_fn = function(fetchOptions) {
    (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $86d06b4c1fd1e033$var$_QueryObserver_instances, $86d06b4c1fd1e033$var$updateQuery_fn).call(this);
    let promise = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $43eecd02f94428b5$export$8793edee2d425525));
    return promise;
};
$86d06b4c1fd1e033$var$updateStaleTimeout_fn = function() {
    (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $86d06b4c1fd1e033$var$_QueryObserver_instances, $86d06b4c1fd1e033$var$clearStaleTimeout_fn).call(this);
    const staleTime = (0, $43eecd02f94428b5$export$cb3145f011bda3ac)(this.options.staleTime, (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery));
    if ((0, $c0530cae3e8bcdd2$export$2d935f1a9c9d3f3e).isServer() || (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentResult).isStale || !(0, $43eecd02f94428b5$export$e539f754e934e270)(staleTime)) return;
    const time = (0, $43eecd02f94428b5$export$811b83d62bcf47f0)((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentResult).dataUpdatedAt, staleTime);
    const timeout = time + 1;
    (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $86d06b4c1fd1e033$var$_staleTimeoutId, (0, $102735a5227aa434$export$94a2700736e69372).setTimeout(()=>{
        if (!(0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentResult).isStale) this.updateResult();
    }, timeout));
};
$86d06b4c1fd1e033$var$computeRefetchInterval_fn = function() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery)) : this.options.refetchInterval) ?? false;
};
$86d06b4c1fd1e033$var$updateRefetchInterval_fn = function(nextInterval) {
    (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $86d06b4c1fd1e033$var$_QueryObserver_instances, $86d06b4c1fd1e033$var$clearRefetchInterval_fn).call(this);
    (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $86d06b4c1fd1e033$var$_currentRefetchInterval, nextInterval);
    if ((0, $c0530cae3e8bcdd2$export$2d935f1a9c9d3f3e).isServer() || (0, $43eecd02f94428b5$export$8c88ee6f2357230d)(this.options.enabled, (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery)) === false || !(0, $43eecd02f94428b5$export$e539f754e934e270)((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentRefetchInterval)) || (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentRefetchInterval) === 0) return;
    (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $86d06b4c1fd1e033$var$_refetchIntervalId, (0, $102735a5227aa434$export$94a2700736e69372).setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $f2135b4901caba4c$export$6bf54661be5b02cf).isFocused()) (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $86d06b4c1fd1e033$var$_QueryObserver_instances, $86d06b4c1fd1e033$var$executeFetch_fn).call(this);
    }, (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentRefetchInterval)));
};
$86d06b4c1fd1e033$var$updateTimers_fn = function() {
    (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $86d06b4c1fd1e033$var$_QueryObserver_instances, $86d06b4c1fd1e033$var$updateStaleTimeout_fn).call(this);
    (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $86d06b4c1fd1e033$var$_QueryObserver_instances, $86d06b4c1fd1e033$var$updateRefetchInterval_fn).call(this, (0, $9e75c35ac10ca972$export$fa92d15b718fce20)(this, $86d06b4c1fd1e033$var$_QueryObserver_instances, $86d06b4c1fd1e033$var$computeRefetchInterval_fn).call(this));
};
$86d06b4c1fd1e033$var$clearStaleTimeout_fn = function() {
    if ((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_staleTimeoutId)) {
        (0, $102735a5227aa434$export$94a2700736e69372).clearTimeout((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_staleTimeoutId));
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $86d06b4c1fd1e033$var$_staleTimeoutId, void 0);
    }
};
$86d06b4c1fd1e033$var$clearRefetchInterval_fn = function() {
    if ((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_refetchIntervalId)) {
        (0, $102735a5227aa434$export$94a2700736e69372).clearInterval((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_refetchIntervalId));
        (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $86d06b4c1fd1e033$var$_refetchIntervalId, void 0);
    }
};
$86d06b4c1fd1e033$var$updateQuery_fn = function() {
    const query = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_client).getQueryCache().build((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_client), this.options);
    if (query === (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery)) return;
    const prevQuery = (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery);
    (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $86d06b4c1fd1e033$var$_currentQuery, query);
    (0, $9e75c35ac10ca972$export$42432efe6614d3b4)(this, $86d06b4c1fd1e033$var$_currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery == null || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
};
$86d06b4c1fd1e033$var$notify_fn = function(notifyOptions) {
    (0, $c7defa80f1ead432$export$520687f44db6e1ab).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentResult));
        });
        (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_client).getQueryCache().notify({
            query: (0, $9e75c35ac10ca972$export$18a094aefa070634)(this, $86d06b4c1fd1e033$var$_currentQuery),
            type: "observerResultsUpdated"
        });
    });
};
function $86d06b4c1fd1e033$var$shouldLoadOnMount(query, options) {
    return (0, $43eecd02f94428b5$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function $86d06b4c1fd1e033$var$shouldFetchOnMount(query, options) {
    return $86d06b4c1fd1e033$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $86d06b4c1fd1e033$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $86d06b4c1fd1e033$var$shouldFetchOn(query, options, field) {
    if ((0, $43eecd02f94428b5$export$8c88ee6f2357230d)(options.enabled, query) !== false && (0, $43eecd02f94428b5$export$cb3145f011bda3ac)(options.staleTime, query) !== "static") {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $86d06b4c1fd1e033$var$isStale(query, options);
    }
    return false;
}
function $86d06b4c1fd1e033$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $43eecd02f94428b5$export$8c88ee6f2357230d)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $86d06b4c1fd1e033$var$isStale(query, options);
}
function $86d06b4c1fd1e033$var$isStale(query, options) {
    return (0, $43eecd02f94428b5$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.isStaleByTime((0, $43eecd02f94428b5$export$cb3145f011bda3ac)(options.staleTime, query));
}
function $86d06b4c1fd1e033$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $43eecd02f94428b5$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}



var $2xPiy = parcelRequire("2xPiy");



var $2xPiy = parcelRequire("2xPiy");

"use client";
function $17924bd9a2e5f64b$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $17924bd9a2e5f64b$var$QueryErrorResetBoundaryContext = $2xPiy.createContext($17924bd9a2e5f64b$var$createValue());
var $17924bd9a2e5f64b$export$50dfac555130cafd = ()=>$2xPiy.useContext($17924bd9a2e5f64b$var$QueryErrorResetBoundaryContext);
var $17924bd9a2e5f64b$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $2xPiy.useState(()=>$17924bd9a2e5f64b$var$createValue());
    return /* @__PURE__ */ (0, $cb4cc5db45d03478$exports.jsx)($17924bd9a2e5f64b$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};



var $2xPiy = parcelRequire("2xPiy");

"use client";
var $bbad5f606a3b0bba$export$ae8adb3de3d77633 = (options, errorResetBoundary, query)=>{
    const throwOnError = (query == null ? void 0 : query.state.error) && typeof options.throwOnError === "function" ? (0, $43eecd02f94428b5$export$2072f68e6c3507cf)(options.throwOnError, [
        query.state.error,
        query
    ]) : options.throwOnError;
    if (options.suspense || options.experimental_prefetchInRender || throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $bbad5f606a3b0bba$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $2xPiy.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $bbad5f606a3b0bba$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query, suspense: suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, $43eecd02f94428b5$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]));
};



var $2xPiy = parcelRequire("2xPiy");
"use client";
var $ad800f304adf5825$var$IsRestoringContext = $2xPiy.createContext(false);
var $ad800f304adf5825$export$4da0178d6b5f553 = ()=>$2xPiy.useContext($ad800f304adf5825$var$IsRestoringContext);
var $ad800f304adf5825$export$593807d4e94f9621 = $ad800f304adf5825$var$IsRestoringContext.Provider;


// src/suspense.ts
var $8b55b0fd4f886c8a$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
var $8b55b0fd4f886c8a$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        const MIN_SUSPENSE_TIME_MS = 1e3;
        const clamp = (value)=>value === "static" ? value : Math.max(value ?? MIN_SUSPENSE_TIME_MS, MIN_SUSPENSE_TIME_MS);
        const originalStaleTime = defaultedOptions.staleTime;
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>clamp(originalStaleTime(...args)) : clamp(originalStaleTime);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, MIN_SUSPENSE_TIME_MS);
    }
};
var $8b55b0fd4f886c8a$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $8b55b0fd4f886c8a$export$88d3586dfed64df9 = (defaultedOptions, result)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && result.isPending;
var $8b55b0fd4f886c8a$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });


"use client";
function $583fc52776fa51f6$export$fff0865807e996c5(options, Observer, queryClient) {
    var _a, _b, _c, _d;
    if (typeof options !== "object" || Array.isArray(options)) throw new Error('Bad argument type. Starting with v5, only the "Object" form is allowed when calling query related functions. Please use the error stack to find the culprit call. More info here: https://tanstack.com/query/latest/docs/react/guides/migrating-to-v5#supports-a-single-signature-one-object');
    const isRestoring = (0, $ad800f304adf5825$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $17924bd9a2e5f64b$export$50dfac555130cafd)();
    const client = (0, $bccbe1b43ff3d0cc$export$22e77b9572c4fded)(queryClient);
    const defaultedOptions = client.defaultQueryOptions(options);
    (_b = (_a = client.getDefaultOptions().queries) == null ? void 0 : _a._experimental_beforeQuery) == null || _b.call(_a, defaultedOptions);
    const query = client.getQueryCache().get(defaultedOptions.queryHash);
    if (!defaultedOptions.queryFn) console.error(`[${defaultedOptions.queryHash}]: No queryFn was passed as an option, and no default queryFn was found. The queryFn parameter is only optional when using a default queryFn. More info here: https://tanstack.com/query/latest/docs/framework/react/guides/default-query-function`);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $8b55b0fd4f886c8a$export$274d2a1db5a20c09)(defaultedOptions);
    (0, $bbad5f606a3b0bba$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary, query);
    (0, $bbad5f606a3b0bba$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const isNewCacheEntry = !client.getQueryCache().get(defaultedOptions.queryHash);
    const [observer] = $2xPiy.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && options.subscribed !== false;
    $2xPiy.useSyncExternalStore($2xPiy.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, $c7defa80f1ead432$export$520687f44db6e1ab).batchCalls(onStoreChange)) : (0, $43eecd02f94428b5$export$8793edee2d425525);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $2xPiy.useEffect(()=>{
        observer.setOptions(defaultedOptions);
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $8b55b0fd4f886c8a$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $8b55b0fd4f886c8a$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $bbad5f606a3b0bba$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: query,
        suspense: defaultedOptions.suspense
    })) throw result.error;
    (_d = (_c = client.getDefaultOptions().queries) == null ? void 0 : _c._experimental_afterQuery) == null || _d.call(_c, defaultedOptions, result);
    if (defaultedOptions.experimental_prefetchInRender && !(0, $c0530cae3e8bcdd2$export$2d935f1a9c9d3f3e).isServer() && (0, $8b55b0fd4f886c8a$export$e0a3f29513afe430)(result, isRestoring)) {
        const promise = isNewCacheEntry ? // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
        (0, $8b55b0fd4f886c8a$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary) : // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
        query == null ? void 0 : query.promise;
        promise == null || promise.catch((0, $43eecd02f94428b5$export$8793edee2d425525)).finally(()=>{
            observer.updateResult();
        });
    }
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $4130e158515cd100$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $583fc52776fa51f6$export$fff0865807e996c5)(options, (0, $86d06b4c1fd1e033$export$a06cf8c0066f0d4c), queryClient);
}








var $2xPiy = parcelRequire("2xPiy");


function $d73aac7e90cb996d$export$e4108de26414712f(config) {
    const { surfaceId: surfaceId, defaults: defaults, standalone: standalone = false } = config;
    const location = (0, $62d58f5c28b15c2e$export$45d76561a5302f2b)();
    const navigationType = (0, $62d58f5c28b15c2e$export$1b3f31771c5d07c)();
    const listRestoreStore = (0, $116967e0234c3770$export$7c25846276568136)();
    const restoreKey = `${location.pathname}::${surfaceId}`;
    const isPop = navigationType === 'POP';
    const restoredState = isPop ? listRestoreStore.getState(restoreKey) : undefined;
    const initialState = restoredState ? {
        ...defaults,
        ...restoredState
    } : defaults;
    const [state, setStateInternal] = (0, $2xPiy.useState)(initialState);
    const prevRestoreKeyRef = (0, $2xPiy.useRef)(restoreKey);
    const justRekeyedRef = (0, $2xPiy.useRef)(false);
    if (prevRestoreKeyRef.current !== restoreKey) {
        prevRestoreKeyRef.current = restoreKey;
        justRekeyedRef.current = true;
        const nextRestored = isPop ? listRestoreStore.getState(restoreKey) : undefined;
        setStateInternal(nextRestored ? {
            ...defaults,
            ...nextRestored
        } : defaults);
    }
    const isRestored = isPop && !!restoredState;
    (0, $2xPiy.useLayoutEffect)(()=>{
        if (isRestored && standalone) listRestoreStore.signalRestore(location.pathname);
    }, []);
    const hasPersistedRef = (0, $2xPiy.useRef)(false);
    const setState = (0, $2xPiy.useCallback)((updates)=>{
        setStateInternal((prev)=>{
            const next = {
                ...prev,
                ...updates
            };
            return next;
        });
    }, []);
    const resetToDefaults = (0, $2xPiy.useCallback)(()=>{
        listRestoreStore.clearState(restoreKey);
        setStateInternal(defaults);
    }, [
        listRestoreStore,
        restoreKey,
        defaults
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (isRestored && !hasPersistedRef.current) {
            hasPersistedRef.current = true;
            return;
        }
        if (justRekeyedRef.current) {
            justRekeyedRef.current = false;
            return;
        }
        hasPersistedRef.current = true;
        listRestoreStore.setState(restoreKey, state);
    }, [
        state,
        listRestoreStore,
        restoreKey
    ]);
    return {
        state: state,
        setState: setState,
        resetToDefaults: resetToDefaults,
        restoreKey: restoreKey,
        isRestored: isRestored
    };
}
function $d73aac7e90cb996d$export$b5b12661e3d1fa94(state, setDraft, select) {
    const setDraftRef = (0, $2xPiy.useRef)(setDraft);
    const selectRef = (0, $2xPiy.useRef)(select);
    setDraftRef.current = setDraft;
    selectRef.current = select;
    (0, $2xPiy.useEffect)(()=>{
        setDraftRef.current(selectRef.current(state));
    }, [
        state
    ]);
}



const $2542f3c44047daf5$var$CLIENT_LIST_DEFAULTS = {
    page: 1,
    search: '',
    is_active: 1,
    order_by: undefined,
    order_direction: undefined
};
const $2542f3c44047daf5$var$CLIENT_LIST_CLEARED = {
    ...$2542f3c44047daf5$var$CLIENT_LIST_DEFAULTS,
    is_active: 2
};
const $2542f3c44047daf5$export$fb3600cebe42014a = (props)=>{
    /* Props */ const { title: title, isLoading: propIsLoading, clients: propClients, fetchClients: propFetchClients, currentPage: propCurrentPage, setCurrentPage: propSetCurrentPage, metadata: propMetadata, showFilters: showFilters, showSearchInput: showSearchInput, showAddButton: showAddButton, hideHeader: hideHeader, surfaceId: surfaceId, standalone: standalone = false, mode: mode = 'query', ...boxProps } = props;
    const isPropControlled = mode === 'controlled';
    /* Context */ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const { handleApiError: handleApiError } = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /* Restorable state */ const restorableList = (0, $d73aac7e90cb996d$export$e4108de26414712f)({
        surfaceId: surfaceId || 'client-list',
        defaults: $2542f3c44047daf5$var$CLIENT_LIST_DEFAULTS,
        standalone: standalone
    });
    const queryState = restorableList.state;
    const setQueryState = restorableList.setState;
    /* Draft state */ const [draftSearch, setDraftSearch] = (0, $2xPiy.useState)(queryState.search);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [draftFilters, setDraftFilters] = (0, $2xPiy.useState)({
        is_active: queryState.is_active
    });
    /* Build the API request */ const request = (0, $2xPiy.useMemo)(()=>({
            page: queryState.page,
            name: queryState.search || undefined,
            is_active: queryState.is_active === 1 ? true : queryState.is_active === 0 ? false : undefined,
            order_by: queryState.order_by,
            order_direction: queryState.order_direction
        }), [
        queryState
    ]);
    /* React Query */ const { data: queryData, isLoading: queryIsLoading, isFetching: isFetching, error: queryError } = (0, $4130e158515cd100$export$dd0a697e1782aedd)({
        queryKey: [
            'clients',
            userStore.user?.id,
            request
        ],
        queryFn: ()=>(0, $5b927e2d9307efbc$export$15fb21390f08bb4c).list(request),
        enabled: !isPropControlled && !!userStore.user,
        placeholderData: (prev)=>prev
    });
    const queryClients = queryData?.data;
    const queryMetadata = queryData?.meta;
    /* Show toast on query error */ (0, $2xPiy.useEffect)(()=>{
        if (queryError && !isPropControlled) handleApiError(queryError, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listClients.error);
    }, [
        queryError
    ]);
    /* Resolved values */ const _clients = propClients ?? queryClients;
    const _metadata = propMetadata ?? queryMetadata;
    const _currentPage = propCurrentPage ?? queryState.page;
    const _isLoading = propIsLoading ?? (isPropControlled ? false : queryIsLoading || isFetching);
    const isRefetching = isFetching && !queryIsLoading;
    const hasClients = _clients;
    /* Methods */ const search = (0, $2xPiy.useCallback)((query)=>{
        setQueryState({
            search: query || '',
            page: 1
        });
    }, [
        setQueryState
    ]);
    const applyFilters = (0, $2xPiy.useCallback)(()=>{
        setQueryState({
            is_active: draftFilters.is_active,
            page: 1
        });
    }, [
        setQueryState,
        draftFilters
    ]);
    const clearFilters = (0, $2xPiy.useCallback)(()=>{
        setDraftFilters({
            is_active: $2542f3c44047daf5$var$CLIENT_LIST_CLEARED.is_active
        });
        setDraftSearch('');
        setQueryState($2542f3c44047daf5$var$CLIENT_LIST_CLEARED);
    }, [
        setQueryState
    ]);
    const handleSort = (0, $2xPiy.useCallback)((property, direction)=>{
        setQueryState({
            order_by: property,
            order_direction: direction,
            page: 1
        });
    }, [
        setQueryState
    ]);
    const handlePageChange = (0, $2xPiy.useCallback)((page)=>{
        if (isPropControlled) {
            propSetCurrentPage?.(page);
            propFetchClients?.(page);
        } else setQueryState({
            page: page
        });
    }, [
        isPropControlled,
        propSetCurrentPage,
        propFetchClients,
        setQueryState
    ]);
    /* Sync page from API response */ (0, $2xPiy.useEffect)(()=>{
        if (queryMetadata && !isPropControlled && queryMetadata.current_page !== queryState.page) setQueryState({
            page: queryMetadata.current_page
        });
    }, [
        queryMetadata?.current_page
    ]);
    /* Sync drafts when queryState changes */ (0, $d73aac7e90cb996d$export$b5b12661e3d1fa94)(queryState, setDraftSearch, (s)=>s.search);
    (0, $d73aac7e90cb996d$export$b5b12661e3d1fa94)(queryState, setDraftFilters, (s)=>({
            is_active: s.is_active
        }));
    /* Render */ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        direction: "row",
        gap: "medium",
        fill: "horizontal",
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
                ...boxProps,
                children: [
                    !hideHeader && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                        title: title || t('client:clientList'),
                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8997b562053e0858$export$481a7013a5a1a9ef), {}),
                        children: [
                            showSearchInput && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f7f71094d2af306c$export$55d7609a8f1eccd2), {
                                searchQuery: draftSearch,
                                setSearchQuery: setDraftSearch,
                                onSearch: search,
                                isSearching: isRefetching
                            }),
                            showAddButton && userStore.isFuseAdmin && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $85ab7488c493b81c$export$6d88ebe453be59d7), {
                                label: t('client:addClient'),
                                targetUrl: '/clients/create'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                        pad: "none",
                        gap: "none",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                elevation: "small",
                                children: [
                                    _isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}),
                                    !_isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $3680d7301df649fd$export$229cbb05167f08e5), {
                                        clients: _clients,
                                        onSort: handleSort,
                                        sortProperty: queryState.order_by,
                                        sortDirection: queryState.order_direction
                                    }),
                                    !hasClients?.length && !_isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        pad: {
                                            horizontal: '1.5rem',
                                            vertical: '2rem'
                                        },
                                        background: "light-6",
                                        justify: "center",
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                            alignSelf: "center",
                                            size: "medium",
                                            fontFamily: "Lato, sans-serif",
                                            children: "No clients found."
                                        })
                                    })
                                ]
                            }),
                            !!hasClients?.length && !!_metadata && !!_currentPage && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                pad: "1.5rem",
                                flex: "grow",
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ffccbada2139938a$export$68f5e1453c188a82), {
                                    alignSelf: "center",
                                    size: "small",
                                    page: _currentPage,
                                    step: _metadata?.per_page,
                                    numberItems: _metadata?.total,
                                    onChange: (e)=>handlePageChange(e.page)
                                })
                            })
                        ]
                    })
                ]
            }),
            showFilters && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ea2652f405b477a3$export$92a576f896a9bf72), {
                isFiltering: isRefetching,
                onSubmit: ()=>applyFilters(),
                onClear: ()=>clearFilters(),
                filters: [
                    {
                        label: t('client:clientStatus'),
                        value: draftFilters.is_active,
                        setValue: (value)=>setDraftFilters({
                                ...draftFilters,
                                is_active: value
                            }),
                        options: [
                            {
                                label: t('common:all'),
                                value: 2
                            },
                            {
                                label: t('common:active'),
                                value: 1
                            },
                            {
                                label: t('common:retired'),
                                value: 0
                            }
                        ]
                    }
                ]
            })
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");




const $d0c5483e267b078b$export$fefe20d940ef9f7d = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    /* Props */ const { formValues: formValues, updateFormValue: updateFormValue, formErrors: formErrors, id: id, onSubmit: onSubmit } = props;
    /* Context */ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /* Callbacks */ const renderRemittanceAddress = (0, $2xPiy.useCallback)(()=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
            id: id,
            title: t('client:remittanceAddress'),
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                    name: "remittance_address_line1",
                    label: t('common:address'),
                    value: formValues.remittance_address_line1,
                    setValue: (value)=>updateFormValue('remittance_address_line1', value),
                    error: formErrors['remittance_address_line1'],
                    onSubmit: onSubmit,
                    disabled: !userStore.isFuseAdmin && (!userStore.isAdminUser || !userStore.isClientUser)
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                    name: "remittance_address_line2",
                    label: t('common:addressContinued'),
                    value: formValues.remittance_address_line2 ?? '',
                    setValue: (value)=>updateFormValue('remittance_address_line2', value),
                    error: formErrors['remittance_address_line2'],
                    onSubmit: onSubmit,
                    centerLabel: userStore.isFuseAdmin || userStore.isAdminUser && userStore.isClientUser,
                    disabled: !userStore.isFuseAdmin && (!userStore.isAdminUser || !userStore.isClientUser)
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    direction: "row",
                    gap: "1rem",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                            name: "remittance_address_city",
                            label: t('common:city'),
                            value: formValues.remittance_address_city,
                            setValue: (value)=>updateFormValue('remittance_address_city', value),
                            error: formErrors['remittance_address_city'],
                            onSubmit: onSubmit,
                            disabled: !userStore.isFuseAdmin && (!userStore.isAdminUser || !userStore.isClientUser)
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                            name: "remittance_address_region_id",
                            label: t('common:stateProvince'),
                            value: formValues.remittance_address_region_id,
                            setValue: (value)=>updateFormValue('remittance_address_region_id', value),
                            options: globalStore.regions.map((region)=>({
                                    label: `${region.name} (${region.short_code})`,
                                    value: region.id
                                })),
                            error: formErrors['remittance_address_region_id'],
                            disabled: !userStore.isFuseAdmin && (!userStore.isAdminUser || !userStore.isClientUser)
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                            name: "remittance_address_post_code",
                            label: t('common:postalCode'),
                            value: formValues.remittance_address_post_code,
                            setValue: (value)=>updateFormValue('remittance_address_post_code', value),
                            error: formErrors['remittance_address_post_code'],
                            onSubmit: onSubmit,
                            disabled: !userStore.isFuseAdmin && (!userStore.isAdminUser || !userStore.isClientUser)
                        })
                    ]
                })
            ]
        }), [
        formValues,
        formErrors,
        userStore.isFuseAdmin,
        userStore.isAdminUser,
        userStore.isClientUser,
        globalStore.regions
    ]);
    const renderBankingInformation = (0, $2xPiy.useCallback)(()=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
            title: t('client:bankingInformation'),
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                gap: "1rem",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                        name: "bank_name",
                        label: t('client:bankName'),
                        placeholder: "",
                        value: formValues.bank_name ?? '',
                        setValue: (value)=>updateFormValue('bank_name', value),
                        error: formErrors['bank_name'],
                        onSubmit: onSubmit,
                        disabled: !userStore.isFuseAdmin && (!userStore.isAdminUser || !userStore.isClientUser)
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                        name: "bank_account_type_id",
                        label: t('client:bankAccountType'),
                        placeholder: "",
                        value: formValues.bank_account_type_id ?? NaN,
                        setValue: (value)=>updateFormValue('bank_account_type_id', value),
                        options: globalStore.bankAccountTypes.map((accountType)=>({
                                label: accountType.name,
                                value: accountType.id
                            })),
                        error: formErrors['bank_account_type_id'],
                        disabled: !userStore.isFuseAdmin && (!userStore.isAdminUser || !userStore.isClientUser)
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                        name: "routing_number",
                        label: t('client:bankRoutingNumber'),
                        placeholder: "",
                        value: formValues.routing_number ?? '',
                        setValue: (value)=>updateFormValue('routing_number', value),
                        error: formErrors['routing_number'],
                        onSubmit: onSubmit,
                        flex: "grow",
                        disabled: !userStore.isFuseAdmin && (!userStore.isAdminUser || !userStore.isClientUser),
                        componentType: "password"
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                        name: "account_number",
                        label: t('client:bankAccountNumber'),
                        placeholder: "",
                        value: formValues.account_number ?? '',
                        setValue: (value)=>updateFormValue('account_number', value),
                        error: formErrors['account_number'],
                        onSubmit: onSubmit,
                        flex: "grow",
                        disabled: !userStore.isFuseAdmin && (!userStore.isAdminUser || !userStore.isClientUser),
                        componentType: "password"
                    })
                ]
            })
        }), [
        formValues,
        formErrors,
        userStore.isFuseAdmin,
        userStore.isAdminUser,
        userStore.isClientUser,
        globalStore.bankAccountTypes
    ]);
    /* Render */ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
        title: t('client:remittanceInformation'),
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            margin: {
                bottom: '1rem'
            },
            gap: "1rem",
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                    name: "remittance_method_id",
                    label: t('common:remittanceMethod'),
                    value: formValues.remittance_method_id ?? null,
                    setValue: (value)=>updateFormValue('remittance_method_id', value),
                    options: [
                        {
                            label: '\u00A0',
                            value: null
                        },
                        ...globalStore.remittanceMethods.map((method)=>({
                                label: method.name,
                                value: method.id
                            }))
                    ],
                    error: formErrors['remittance_method_id'],
                    disabled: !userStore.isFuseAdmin && (!userStore.isAdminUser || !userStore.isClientUser)
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                    margin: "0.5rem"
                }),
                !formValues.remittance_method_id && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {}),
                formValues.remittance_method_id === 1 && renderBankingInformation(),
                formValues.remittance_method_id === 2 && renderRemittanceAddress()
            ]
        })
    });
});




var $2xPiy = parcelRequire("2xPiy");


var $2xPiy = parcelRequire("2xPiy");

function $a98c58baeeda52b5$var$_extends() {
    return $a98c58baeeda52b5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a98c58baeeda52b5$var$_extends.apply(null, arguments);
}
var $a98c58baeeda52b5$export$b5797ef40e68a059 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $a98c58baeeda52b5$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "AddCircle"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-4V6m-6 6h12"
    }));
});
$a98c58baeeda52b5$export$b5797ef40e68a059.displayName = 'AddCircle';


var $2xPiy = parcelRequire("2xPiy");

function $3e20861326453585$var$_extends() {
    return $3e20861326453585$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3e20861326453585$var$_extends.apply(null, arguments);
}
var $3e20861326453585$export$99442c433de1441d = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $3e20861326453585$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Trash"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4 5h16v18H4V5zM1 5h22M9 1h6v4H9V1zm0 0h6v4H9V1zm6 8v10M9 9v10"
    }));
});
$3e20861326453585$export$99442c433de1441d.displayName = 'Trash';








const $e51bffab3446bc0d$export$2c87cdb10b310a7c = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { countryId: countryId, id: id, commissions: commissions, setCommissions: setCommissions, formErrors: formErrors } = props;
    /** Context **/ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const tooltips = (0, $d597772cdbe12609$export$4713da6aa4410043)();
    /** Refs **/ const defaultFormValues = (0, $2xPiy.useRef)({
        program_id: NaN,
        is_percent_rate: false,
        rate: ''
    });
    /** State **/ const [, setIsLoadingPrograms] = (0, $2xPiy.useState)(false);
    const [programOptions, setProgramOptions] = (0, $2xPiy.useState)();
    const [selectedPrograms, setSelectedPrograms] = (0, $2xPiy.useState)([]);
    /** Computed **/ const isAddDisabled = programOptions && commissions.length === programOptions.length;
    /** Methods **/ /**
   * Update form data
   * @param key
   * @param value
   */ const updateFormValue = (key, index, value)=>{
        const updatedValues = commissions;
        updatedValues[index] ??= defaultFormValues.current;
        updatedValues[index][key] = value;
        setCommissions(updatedValues);
        formErrors[index] ??= {};
        if (formErrors[index][key]) formErrors[index][key] = '';
        if (key === 'program_id' && !!value && !Number.isNaN(value)) setSelectedPrograms(updatedValues.map((c)=>c.program_id));
    };
    /**
   * Handles adding a Commission to the list.
   */ const handleAddCommission = ()=>{
        const updatedValues = commissions;
        updatedValues.push({
            ...defaultFormValues.current
        });
        setCommissions(updatedValues);
    };
    /**
   * Handles removing the Commission at the given list index.
   */ const handleRemoveCommission = (index)=>{
        const updatedValues = commissions;
        updatedValues.splice(index, 1);
        setCommissions(updatedValues);
        setSelectedPrograms(updatedValues.map((c)=>c.program_id));
    };
    /**
   * Fetch Programs list
   */ const fetchPrograms = async (country_id)=>{
        if (!userStore.user) return;
        try {
            setIsLoadingPrograms(true);
            const programs = await (0, $06590284a0c4fd89$export$84ac2881c878ff18).list({
                country_id: country_id
            });
            let options = programs.map((program)=>({
                    label: program.name,
                    value: program.id
                }));
            if (commissions.length) {
                const existingProgramIds = commissions.map((v)=>v.program_id);
                options = options.filter(({ value: value })=>!existingProgramIds.includes(value));
            }
            setProgramOptions(options);
            setSelectedPrograms([]);
            if (!commissions.length) handleAddCommission();
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listPrograms.error);
        } finally{
            setIsLoadingPrograms(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (countryId && !Number.isNaN(countryId)) fetchPrograms(countryId);
    }, [
        countryId
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
        id: id,
        title: "Program Commissions",
        button: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
            plain: true,
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $a98c58baeeda52b5$export$b5797ef40e68a059), {
                size: "18px"
            }),
            onClick: ()=>handleAddCommission(),
            tip: tooltips.addCommission,
            disabled: !countryId || Number.isNaN(countryId) || isAddDisabled
        }),
        children: [
            commissions.map((commission, index)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    row: true,
                    gap: "1rem",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $73a306fd56291544$export$fa00aa2901190e49), {
                            name: "program_id",
                            label: "Program",
                            placeholder: "Choose...",
                            emptySearchMessage: 'Choose a country to see available Programs.',
                            value: commission.program_id,
                            setValue: (value)=>updateFormValue('program_id', index, value),
                            error: formErrors[index]?.['program_id'],
                            countryId: countryId,
                            required: true,
                            fill: "horizontal",
                            options: programOptions?.filter((o)=>!selectedPrograms.includes(o.value) || o.value === commission.program_id)
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                            id: "is_percent_rate",
                            label: "Commission Type",
                            value: commission.is_percent_rate ? 'Percentage' : 'Fixed',
                            setValue: (value)=>{
                                updateFormValue('is_percent_rate', index, value === 'Percentage');
                                updateFormValue('rate', index, '');
                            },
                            options: [
                                'Fixed',
                                'Percentage'
                            ],
                            error: formErrors[index]?.['is_percent_rate'],
                            required: true,
                            fill: "horizontal"
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $eabeffcc0be0175a$export$dec03dc0f3ef8025), {
                            id: "rate",
                            label: `Commission Rate${!commission.is_percent_rate ? ' ($/kWh)' : ''}`,
                            value: commission.rate,
                            setValue: (value)=>updateFormValue('rate', index, value),
                            error: formErrors[index]?.['rate'],
                            componentType: commission.is_percent_rate ? 'percent' : 'number',
                            isActiveLabel: true,
                            type: "number",
                            required: true,
                            fill: "horizontal"
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                            plain: true,
                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $3e20861326453585$export$99442c433de1441d), {
                                size: "18px",
                                color: "red"
                            }),
                            onClick: ()=>handleRemoveCommission(index),
                            tip: tooltips.removeCommission,
                            disabled: commissions.length === 1
                        })
                    ]
                })),
            (!countryId || Number.isNaN(countryId)) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                align: "center",
                justify: "center",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    size: "medium",
                    fontFamily: "Lato, sans-serif",
                    children: "To set Commissions, choose a country in the Country section above."
                })
            })
        ]
    });
});




var $2xPiy = parcelRequire("2xPiy");


var $2xPiy = parcelRequire("2xPiy");


var $iA1nz = parcelRequire("iA1nz");


var $1ff2200d31020b2f$var$disabledStyle = "\n  opacity: 0.5;\n  cursor: default;\n";
var $1ff2200d31020b2f$export$8acf1677a08924d7 = (0, $iA1nz.default).label.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledRadioButton__StyledRadioButtonContainer",
    componentId: "sc-g1f6ld-0"
})([
    "display:flex;flex-direction:row;align-items:center;user-select:none;width:fit-content;",
    " ",
    " &:hover input:not([disabled]) + div,&:hover input:not([disabled]) + span{border-color:",
    ";}&:hover{background-color:",
    ";}",
    " ",
    ";"
], function(props) {
    return props.disabled && $1ff2200d31020b2f$var$disabledStyle;
}, function(props) {
    return !props.disabled && 'cursor: pointer;';
}, function(props) {
    return (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.theme.radioButton.hover.border.color, props.theme);
}, function(props) {
    return (0, $11317b0e49e0d157$export$4cde5df63f53f473)(!props.disabled && props.theme.radioButton.hover && props.theme.radioButton.hover.background && props.theme.radioButton.hover.background.color, props.theme);
}, function(props) {
    return props.focus && !props.focusIndicator && "\n      input:not([disabled]) + div,\n      input:not([disabled]) + span {\n      border-color: " + (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.theme.radioButton.hover.border.color, props.theme) + ";\n    }\n    background-color: " + (0, $11317b0e49e0d157$export$4cde5df63f53f473)(!props.disabled && props.theme.radioButton.hover && props.theme.radioButton.hover.background && props.theme.radioButton.hover.background.color, props.theme) + ";\n    ";
}, function(props) {
    return props.theme.radioButton.container.extend;
});
var $1ff2200d31020b2f$export$e56967134e4288ed = (0, $iA1nz.default).input.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledRadioButton__StyledRadioButtonInput",
    componentId: "sc-g1f6ld-1"
})([
    "opacity:0;-moz-appearance:none;width:0;height:0;margin:0;",
    ";"
], function(props) {
    return !props.disabled && 'cursor: pointer;';
});
var $1ff2200d31020b2f$export$9785e57ddfe69aa = (0, $iA1nz.default).span.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledRadioButton__StyledRadioButtonLabel",
    componentId: "sc-g1f6ld-2"
})([
    "",
    ""
], function(props) {
    return props.theme.radioButton.font.weight && (0, $iA1nz.css)([
        "font-weight:",
        ";"
    ], props.theme.radioButton.font.weight);
});
var $1ff2200d31020b2f$export$be6e4fdf83e53746 = (0, $iA1nz.default).svg.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledRadioButton__StyledRadioButtonIcon",
    componentId: "sc-g1f6ld-3"
})([
    "box-sizing:border-box;width:",
    ";height:",
    ";fill:",
    ";transform:scale(1);",
    ";"
], function(props) {
    return props.theme.radioButton.icon.size || props.theme.radioButton.size;
}, function(props) {
    return props.theme.radioButton.icon.size || props.theme.radioButton.size;
}, function(props) {
    return (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.theme.radioButton.check.color || 'control', props.theme);
}, function(props) {
    return props.theme.radioButton.icon.extend;
});
var $1ff2200d31020b2f$export$634d9fc8954dd28a = (0, $iA1nz.default)((0, $18c0523379e5dd9d$export$e71c4d32a2263218)).withConfig({
    displayName: "StyledRadioButton__StyledRadioButtonBox",
    componentId: "sc-g1f6ld-4"
})([
    "background-color:",
    ";transform:scale(1);",
    ";",
    ";"
], function(props) {
    return props.backgroundColor;
}, function(props) {
    return props.focus && (0, $73ba8e2d301b823f$export$efbff472cb39d8b)();
}, function(props) {
    return props.theme.radioButton.check.extend;
});
var $1ff2200d31020b2f$export$561b697fc173df1f = (0, $iA1nz.default)((0, $18c0523379e5dd9d$export$e71c4d32a2263218)).withConfig({
    displayName: "StyledRadioButton",
    componentId: "sc-g1f6ld-5"
})([
    "",
    ";"
], function(props) {
    return props.theme.radioButton && props.theme.radioButton.extend;
});



var $dyr1f = parcelRequire("dyr1f");
var $210aa6094be60f17$var$PropType = {};
$210aa6094be60f17$var$PropType = {
    a11yTitle: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    checked: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func
};
var $210aa6094be60f17$export$9044c49f71780958 = $210aa6094be60f17$var$PropType;



var $e36c36a47b767f06$var$_excluded = [
    "a11yTitle",
    "checked",
    "children",
    "disabled",
    "focus",
    "focusIndicator",
    "id",
    "label",
    "name",
    "onChange"
];
function $e36c36a47b767f06$var$_extends() {
    return $e36c36a47b767f06$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e36c36a47b767f06$var$_extends.apply(null, arguments);
}
function $e36c36a47b767f06$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $e36c36a47b767f06$export$f4422ae58352e179 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var _theme$radioButton$ba;
    var a11yTitle = _ref.a11yTitle, checked = _ref.checked, children = _ref.children, disabled = _ref.disabled, focusProp = _ref.focus, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, id = _ref.id, label = _ref.label, name = _ref.name, onChange = _ref.onChange, rest = $e36c36a47b767f06$var$_objectWithoutPropertiesLoose(_ref, $e36c36a47b767f06$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useState = (0, $2xPiy.useState)(), hover = _useState[0], setHover = _useState[1];
    var _useState2 = (0, $2xPiy.useState)(focusProp), focus = _useState2[0], setFocus = _useState2[1];
    var usingKeyboard = (0, $fc2b59dcdb1fd3de$export$8f71654801c2f7cd)();
    var normalizedLabel = typeof label === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $1ff2200d31020b2f$export$9785e57ddfe69aa), passThemeFlag, label) : label;
    var Icon = theme.radioButton.icons.circle;
    var borderColor = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(theme.radioButton.border.color, theme);
    var backgroundColor = (0, $11317b0e49e0d157$export$4cde5df63f53f473)((_theme$radioButton$ba = theme.radioButton.background) == null ? void 0 : _theme$radioButton$ba.color, theme);
    if (checked) {
        var _theme$radioButton$ch;
        borderColor = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(theme.radioButton.color || 'control', theme);
        if ((_theme$radioButton$ch = theme.radioButton.check) != null && (_theme$radioButton$ch = _theme$radioButton$ch.background) != null && _theme$radioButton$ch.color) backgroundColor = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(theme.radioButton.check.background.color, theme);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $1ff2200d31020b2f$export$8acf1677a08924d7), $e36c36a47b767f06$var$_extends({}, (0, $cdf577e3272e3992$export$c499305a875a8ee9)({
        htmlFor: id,
        disabled: disabled
    }), {
        onClick: function onClick(event) {
            // prevents clicking on the label trigging the event twice
            // https://stackoverflow.com/questions/24501497/why-the-onclick-element-will-trigger-twice-for-label-element
            if (event.target.type !== 'radio') event.stopPropagation();
        },
        focus: focus,
        focusIndicator: focusIndicator,
        onFocus: function onFocus() {
            return setFocus(true);
        },
        onBlur: function onBlur() {
            return setFocus(false);
        },
        onMouseEnter: function onMouseEnter() {
            return setHover(true);
        },
        onMouseLeave: function onMouseLeave() {
            return setHover(false);
        }
    }, passThemeFlag), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $1ff2200d31020b2f$export$561b697fc173df1f), $e36c36a47b767f06$var$_extends({
        flex: false,
        margin: label ? {
            right: theme.radioButton.gap
        } : undefined
    }, passThemeFlag), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $1ff2200d31020b2f$export$e56967134e4288ed), $e36c36a47b767f06$var$_extends({
        "aria-label": a11yTitle
    }, rest, {
        ref: ref,
        type: "radio"
    }, (0, $cdf577e3272e3992$export$c499305a875a8ee9)({
        id: id,
        name: name,
        checked: checked,
        disabled: disabled,
        onChange: onChange
    }))), children ? children({
        checked: checked,
        focus: focus && focusIndicator,
        hover: hover
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $1ff2200d31020b2f$export$634d9fc8954dd28a), $e36c36a47b767f06$var$_extends({
        focus: focus && focusIndicator && usingKeyboard,
        align: "center",
        justify: "center",
        width: theme.radioButton.size,
        height: theme.radioButton.size,
        border: {
            size: theme.radioButton.border.width,
            color: borderColor
        },
        backgroundColor: backgroundColor,
        round: theme.radioButton.check.radius
    }, passThemeFlag), checked && (Icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(Icon, {
        theme: theme,
        as: (0, $1ff2200d31020b2f$export$be6e4fdf83e53746)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $1ff2200d31020b2f$export$be6e4fdf83e53746), $e36c36a47b767f06$var$_extends({
        viewBox: "0 0 24 24",
        preserveAspectRatio: "xMidYMid meet"
    }, passThemeFlag), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("circle", {
        cx: 12,
        cy: 12,
        r: 6
    }))))), normalizedLabel);
});
$e36c36a47b767f06$export$f4422ae58352e179.displayName = 'RadioButton';
$e36c36a47b767f06$export$f4422ae58352e179.propTypes = (0, $210aa6094be60f17$export$9044c49f71780958);









const $781bf4ccfee0e806$export$259abad983af717a = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const clientStore = (0, $116967e0234c3770$export$3b47afa599c78f61)();
    const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const [clientNames, setClientNames] = (0, $2xPiy.useState)([]);
    const [searchQuery, setSearchQuery] = (0, $2xPiy.useState)('');
    const [isLoadingNames, setIsLoadingNames] = (0, $2xPiy.useState)(false);
    const maxVisibleItems = (0, $2xPiy.useRef)(10);
    const selectedClientId = (0, $2xPiy.useMemo)(()=>{
        return !clientStore.selectedClientId && userStore.isInternalUser ? 0 : clientStore.selectedClientId;
    }, [
        userStore.isInternalUser,
        clientStore.selectedClientId
    ]);
    const clientOptions = (0, $2xPiy.useMemo)(()=>{
        const options = userStore.isInternalUser ? [
            clientStore.allClientsOption
        ] : [];
        const filtered = (0, $00658ccd6ec0135a$export$b5513415b3f92e76)(searchQuery, [
            ...options,
            ...clientNames.map(({ name: name, id: id })=>({
                    label: name,
                    value: id
                }))
        ]);
        return isLoadingNames ? [
            ...filtered,
            {
                label: '',
                value: -1
            }
        ] : filtered;
    }, [
        userStore.isInternalUser,
        clientNames,
        searchQuery,
        isLoadingNames
    ]);
    const hasFetchedNamesRef = (0, $2xPiy.useRef)(false);
    const isMountedRef = (0, $2xPiy.useRef)(true);
    (0, $2xPiy.useEffect)(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    const fetchClientNames = ()=>{
        hasFetchedNamesRef.current = true;
        setIsLoadingNames(true);
        (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).listClientNames().then((names)=>{
            if (isMountedRef.current) setClientNames(names);
        }).catch((err)=>{
            hasFetchedNamesRef.current = false;
            if (isMountedRef.current) globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listClients.error);
        }).finally(()=>{
            if (isMountedRef.current) setIsLoadingNames(false);
        });
    };
    (0, $2xPiy.useEffect)(()=>{
        if (!clientStore.selectedClientId) clientStore.setSelectedClientId(selectedClientId);
    }, [
        clientStore.selectedClientId
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (!selectedClientId || selectedClientId === 0) return;
        if (clientStore.selectedClient?.id === selectedClientId) return;
        let ignore = false;
        (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).get({
            id: selectedClientId
        }).then((client)=>{
            if (!ignore) clientStore.setSelectedClient(client);
        }).catch((err)=>globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).fetchClient.error));
        return ()=>{
            ignore = true;
        };
    }, [
        selectedClientId
    ]);
    const selectedClientName = (0, $2xPiy.useMemo)(()=>{
        if (selectedClientId === 0) return clientStore.allClientsOption.label;
        const fromList = clientNames.find((client)=>client.id === selectedClientId)?.name;
        if (fromList) return fromList;
        const cached = clientStore.selectedClient;
        if (cached && cached.id === selectedClientId) return cached.name;
        return undefined;
    }, [
        selectedClientId,
        clientNames,
        clientStore.selectedClient
    ]);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        justify: "center",
        animation: {
            type: 'slideLeft',
            duration: 500
        },
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b3fb5add06fccd6e$export$ef9b1a59e592288f), {
            name: "selected_client",
            plain: true,
            dropHeight: clientOptions.length < maxVisibleItems.current ? '100%' : (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(60 + 34.5 * maxVisibleItems.current),
            value: selectedClientId,
            labelKey: "label",
            valueKey: "value",
            dropProps: {
                width: '20rem',
                round: '6px',
                border: {
                    size: 'small',
                    color: 'light-5'
                }
            },
            valueLabel: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                alignSelf: "center",
                size: "1rem",
                children: selectedClientName
            }),
            dropAlign: {
                top: 'bottom',
                right: 'right'
            },
            onOpen: ()=>{
                if (!hasFetchedNamesRef.current) fetchClientNames();
            },
            onClose: ()=>setSearchQuery(''),
            defaultValue: selectedClientId,
            searchPlaceholder: "Filter by Company Name...",
            emptySearchMessage: (0, $d0d6382a5bdf6377$export$d8bd0967cb58683).clientNameSearchNoResult,
            options: clientOptions,
            onChange: ({ value: value })=>{
                if (value.value === -1) return;
                clientStore.setSelectedClientId(value.value);
                if (value.value === 0) navigate('/');
                else navigate(`/?view&client=${value.value}`, {
                    replace: true
                });
            },
            onSearch: setSearchQuery,
            children: (option)=>option.value === -1 ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    align: "center",
                    justify: "center",
                    pad: "small",
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8bec6e2e7dc53c4a$export$7f7cbe89f1eacd2), {})
                }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    direction: "row",
                    gap: "0.5rem",
                    pad: {
                        vertical: 'xsmall',
                        horizontal: 'small'
                    },
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e36c36a47b767f06$export$f4422ae58352e179), {
                            name: option.label,
                            checked: selectedClientId === option.value,
                            readOnly: true
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            size: "1rem",
                            color: "dark-2",
                            truncate: true,
                            lineHeight: "1.40625rem",
                            children: option.label
                        })
                    ]
                })
        })
    });
});




var $2xPiy = parcelRequire("2xPiy");







const $209e44abb3ffd31f$export$c57133fe35f19a3e = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { user: currentUser, isFuseAdmin: isFuseAdmin } = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const { handleApiError: handleApiError } = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const { id: id, name: name = 'selected_client', selectedClientId: selectedClientId, setSelectedClientId: setSelectedClientId, options: options, error: error, required: required, hideOptionalText: hideOptionalText, disabled: disabled, label: label, placeholder: placeholder, searchPlaceholder: searchPlaceholder = 'Filter by Company Name...', onSubmit: onSubmit, excludeClientIds: excludeClientIds, multiple: multiple, selectedClientIds: selectedClientIds, setSelectedClientIds: setSelectedClientIds, fill: fill } = props;
    const [fetchedOptions, setFetchedOptions] = (0, $2xPiy.useState)([]);
    (0, $2xPiy.useEffect)(()=>{
        if (options) return;
        fetchClientsList().catch((err)=>handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listClients.error));
    }, [
        options
    ]);
    const fetchClientsList = async ()=>{
        if (currentUser) {
            if (isFuseAdmin) {
                const data = await (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).listClientNames();
                const options = data.map((client)=>({
                        label: client.name,
                        value: client.id
                    }));
                setFetchedOptions(options);
            } else {
                const options = currentUser.clients.map((client)=>({
                        label: client.name,
                        value: client.id
                    }));
                setFetchedOptions(options);
            }
        }
    };
    const baseOptions = options ?? fetchedOptions;
    const filteredOptions = excludeClientIds ? baseOptions.filter((option)=>!excludeClientIds.includes(option.value)) : baseOptions;
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $168667f04da9206c$export$16e4d70cc375e707), {
        onEnter: onSubmit,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
            multiple: multiple,
            id: id,
            name: name,
            label: label ?? t('user:company'),
            value: selectedClientId,
            setValue: (id)=>setSelectedClientId?.(id),
            values: selectedClientIds ?? [],
            setValues: (values)=>setSelectedClientIds?.(values),
            options: filteredOptions,
            required: required,
            disabled: disabled,
            error: error,
            placeholder: placeholder,
            searchPlaceholder: searchPlaceholder,
            hideOptionalText: hideOptionalText,
            fill: fill
        })
    });
});




var $2xPiy = parcelRequire("2xPiy");




var $2xPiy = parcelRequire("2xPiy");

var $cX5wj = parcelRequire("cX5wj");



var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");








var $iA1nz = parcelRequire("iA1nz");

var $8Fliv = parcelRequire("8Fliv");

var $9aea1c389c35bf65$var$hiddenPositionStyle = (0, $iA1nz.css)([
    "left:-100%;right:100%;z-index:-1;position:fixed;"
]);
var $9aea1c389c35bf65$var$desktopLayerStyle = "\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n";
var $9aea1c389c35bf65$var$responsiveLayerStyle = "\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  min-height: 100vh;\n";
var $9aea1c389c35bf65$export$465e4e6abe6afeb6 = (0, $iA1nz.default).div.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledLayer",
    componentId: "sc-rmtehz-0"
})([
    "",
    " background:transparent;position:relative;z-index:",
    ";pointer-events:none;outline:none;",
    " ",
    ";"
], (0, $73ba8e2d301b823f$export$360b744af11007ac), function(props) {
    return props.theme.layer.zIndex;
}, function(props) {
    if (props.position === 'hidden') return $9aea1c389c35bf65$var$hiddenPositionStyle;
    var styles = [];
    styles.push($9aea1c389c35bf65$var$desktopLayerStyle);
    if (props.responsive && props.theme.layer.responsiveBreakpoint && !props.layerTarget) {
        var breakpoint = props.theme.global.breakpoints[props.theme.layer.responsiveBreakpoint];
        styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, $9aea1c389c35bf65$var$responsiveLayerStyle));
    }
    return styles;
}, function(props) {
    return props.theme.layer && props.theme.layer.extend;
});
var $9aea1c389c35bf65$export$47f426cc93e497b4 = (0, $iA1nz.default).div.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledLayer__StyledOverlay",
    componentId: "sc-rmtehz-1"
})([
    "position:absolute;",
    " top:0px;left:0px;right:0px;bottom:0px;",
    " ",
    " pointer-events:all;will-change:transform;"
], function(props) {
    if (props.responsive && props.theme.layer.responsiveBreakpoint) {
        var breakpoint = props.theme.global.breakpoints[props.theme.layer.responsiveBreakpoint];
        return (0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, 'position: relative;');
    }
    return '';
}, function(props) {
    return props.theme.layer.overlay.backdropFilter && "backdrop-filter: " + props.theme.layer.overlay.backdropFilter + ";";
}, function(props) {
    return !props.plain && props.theme.layer.overlay.background && (0, $0b4a347e23c22183$export$e43a4f0de05cb7e9)(props.theme.layer.overlay.background, props.theme);
});
var $9aea1c389c35bf65$var$getMargin = function getMargin(margin, theme, position) {
    var axis = position.indexOf('top') !== -1 || position.indexOf('bottom') !== -1 ? 'vertical' : 'horizontal';
    var marginValue = margin[position] || margin[axis] || margin;
    var marginApplied = theme.global.edgeSize[marginValue] || marginValue;
    var marginInTheme = !!theme.global.edgeSize[marginValue];
    return !marginInTheme && typeof marginValue !== 'string' ? 0 : (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(marginApplied);
};
var $9aea1c389c35bf65$var$getBounds = function getBounds(bounds, margin, theme, position) {
    if (position === void 0) position = undefined;
    if (position) return bounds[position] + $9aea1c389c35bf65$var$getMargin(margin, theme, position);
    return {
        bottom: bounds.bottom + $9aea1c389c35bf65$var$getMargin(margin, theme, 'bottom'),
        // 'bottom-left': getMargin(margin, theme, 'bottom-left'),
        // 'bottom-right': getMargin(margin, theme, 'bottom-right'),
        end: bounds.right + $9aea1c389c35bf65$var$getMargin(margin, theme, 'end'),
        left: bounds.left + $9aea1c389c35bf65$var$getMargin(margin, theme, 'left'),
        right: bounds.right + $9aea1c389c35bf65$var$getMargin(margin, theme, 'right'),
        start: bounds.left + $9aea1c389c35bf65$var$getMargin(margin, theme, 'start'),
        top: bounds.top + $9aea1c389c35bf65$var$getMargin(margin, theme, 'top')
    };
};
var $9aea1c389c35bf65$var$KEYFRAMES = {
    center: {
        vertical: (0, $iA1nz.keyframes)([
            "0%{transform:translateX(-50%) scale(0.8);}100%{transform:translateX(-50%) scale(1);}"
        ]),
        horizontal: (0, $iA1nz.keyframes)([
            "0%{transform:translateY(-50%) scale(0.8);}100%{transform:translateY(-50) scale(1);}"
        ]),
        "true": (0, $iA1nz.keyframes)([
            "0%{transform:scale(0.8);}100%{transform:scale(1);}"
        ]),
        "false": (0, $iA1nz.keyframes)([
            "0%{transform:translate(-50%,-50%) scale(0.8);}100%{transform:translate(-50%,-50%) scale(1);}"
        ])
    },
    top: {
        vertical: (0, $iA1nz.keyframes)([
            "0%{transform:translate(-50%,-100%);}100%{transform:translate(-50%,0);}"
        ]),
        horizontal: (0, $iA1nz.keyframes)([
            "0%{transform:translateY(-100%);}100%{transform:translateY(0);}"
        ]),
        "true": (0, $iA1nz.keyframes)([
            "0%{transform:translateY(-100%);}100%{transform:translateY(0);}"
        ]),
        "false": (0, $iA1nz.keyframes)([
            "0%{transform:translate(-50%,-100%);}100%{transform:translate(-50%,0);}"
        ])
    },
    bottom: {
        vertical: (0, $iA1nz.keyframes)([
            "0%{transform:translate(-50%,100%);}100%{transform:translate(-50%,0);}"
        ]),
        horizontal: (0, $iA1nz.keyframes)([
            "0%{transform:translateY(100%);}100%{transform:translateY(0);}"
        ]),
        "true": (0, $iA1nz.keyframes)([
            "0%{transform:translateY(100%);}100%{transform:translateY(0);}"
        ]),
        "false": (0, $iA1nz.keyframes)([
            "0%{transform:translate(-50%,100%);}100%{transform:translate(-50%,0);}"
        ])
    },
    left: {
        vertical: (0, $iA1nz.keyframes)([
            "0%{transform:translateX(-100%);}100%{transform:translateX(0);}"
        ]),
        horizontal: (0, $iA1nz.keyframes)([
            "0%{transform:translate(-100%,-50%);}100%{transform:translate(0,-50%);}"
        ]),
        "true": (0, $iA1nz.keyframes)([
            "0%{transform:translateX(-100%);}100%{transform:translateX(0);}"
        ]),
        "false": (0, $iA1nz.keyframes)([
            "0%{transform:translate(-100%,-50%);}100%{transform:translate(0,-50%);}"
        ])
    },
    right: {
        vertical: (0, $iA1nz.keyframes)([
            "0%{transform:translateX(100%);}100%{transform:translateX(0);}"
        ]),
        horizontal: (0, $iA1nz.keyframes)([
            "0%{transform:translate(100%,-50%);}100%{transform:translate(0,-50%);}"
        ]),
        "true": (0, $iA1nz.keyframes)([
            "0%{transform:translateX(100%);}100%{transform:translateX(0);}"
        ]),
        "false": (0, $iA1nz.keyframes)([
            "0%{transform:translate(100%,-50%);}100%{transform:translate(0,-50%);}"
        ])
    },
    start: {
        vertical: (0, $iA1nz.keyframes)([
            "0%{transform:translateX(-100%);}100%{transform:translateX(0);}"
        ]),
        horizontal: (0, $iA1nz.keyframes)([
            "0%{transform:translate(-100%,-50%);}100%{transform:translate(0,-50%);}"
        ]),
        "true": (0, $iA1nz.keyframes)([
            "0%{transform:translateX(-100%);}100%{transform:translateX(0);}"
        ]),
        "false": (0, $iA1nz.keyframes)([
            "0%{transform:translate(-100%,-50%);}100%{transform:translate(0,-50%);}"
        ])
    },
    end: {
        vertical: (0, $iA1nz.keyframes)([
            "0%{transform:translateX(100%);}100%{transform:translateX(0);}"
        ]),
        horizontal: (0, $iA1nz.keyframes)([
            "0%{transform:translate(100%,-50%);}100%{transform:translate(0,-50%);}"
        ]),
        "true": (0, $iA1nz.keyframes)([
            "0%{transform:translateX(100%);}100%{transform:translateX(0);}"
        ]),
        "false": (0, $iA1nz.keyframes)([
            "0%{transform:translate(100%,-50%);}100%{transform:translate(0,-50%);}"
        ])
    }
};
var $9aea1c389c35bf65$export$82f5c257a11c5515 = 200;
var $9aea1c389c35bf65$var$getAnimationStyle = function getAnimationStyle(props, position, full) {
    var animation = props.animation !== undefined ? props.animation : props.animate;
    if (animation === undefined) animation = 'slide';
    var keys;
    if (animation === 'slide' || animation === true) keys = $9aea1c389c35bf65$var$KEYFRAMES[position][full];
    else if (animation === 'fadeIn') keys = (0, $iA1nz.keyframes)([
        "0%{opacity:0}100%{opacity:1}"
    ]);
    return keys ? (0, $iA1nz.css)([
        "animation:",
        " ",
        "s ease-in-out forwards;"
    ], keys, $9aea1c389c35bf65$export$82f5c257a11c5515 / 1000.0) : '';
};
// POSITIONS combines 'position', 'full', and 'margin' properties, since
// they are all interdependent.
// Basically, non-full axes combine 50% position with -50% translation.
// full axes pin to the window edges offset by any margin.
// The keyframe animations are included as they are done via translations
// as well so they must take into account the non-animated positioning.
var $9aea1c389c35bf65$var$POSITIONS = {
    center: {
        vertical: function vertical(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;bottom:",
                "px;left:50%;transform:translateX(-50%);",
                ""
            ], bounds.top, bounds.bottom, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'center', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $iA1nz.css)([
                "left:",
                "px;right:",
                "px;top:50%;transform:translateY(-50%);",
                ""
            ], bounds.left, bounds.right, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'center', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'center', 'true');
            });
        },
        "false": function _false() {
            return (0, $iA1nz.css)([
                "top:50%;left:50%;transform:translate(-50%,-50%);",
                ""
            ], function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'center', 'false');
            });
        }
    },
    top: {
        vertical: function vertical(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;bottom:",
                "px;left:50%;transform:translate(-50%,0%);",
                ""
            ], bounds.top, bounds.bottom, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'top', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $iA1nz.css)([
                "left:",
                "px;right:",
                "px;top:",
                "px;transform:translateY(0);",
                ""
            ], bounds.left, bounds.right, bounds.top, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'top', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateY(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'top', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;left:50%;transform:translate(-50%,0);",
                ""
            ], bounds.top, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'top', 'false');
            });
        }
    },
    bottom: {
        vertical: function vertical(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;bottom:",
                "px;left:50%;transform:translate(-50%,0);",
                ""
            ], bounds.top, bounds.bottom, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'bottom', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $iA1nz.css)([
                "left:",
                "px;right:",
                "px;bottom:",
                "px;transform:translateY(0);",
                ""
            ], bounds.left, bounds.top, bounds.bottom, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'bottom', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateY(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'bottom', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $iA1nz.css)([
                "bottom:",
                "px;left:50%;transform:translate(-50%,0);",
                ""
            ], bounds.bottom, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'bottom', 'false');
            });
        }
    },
    left: {
        vertical: function vertical(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'left', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $iA1nz.css)([
                "left:",
                "px;right:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.left, bounds.right, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'left', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'left', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $iA1nz.css)([
                "left:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.left, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'left', 'false');
            });
        }
    },
    right: {
        vertical: function vertical(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;bottom:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.right, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'right', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $iA1nz.css)([
                "left:",
                "px;right:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.left, bounds.right, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'right', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'right', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $iA1nz.css)([
                "right:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.right, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'right', 'false');
            });
        }
    },
    start: {
        vertical: function vertical(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;bottom:",
                "px;inset-inline-start:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.start, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'start', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $iA1nz.css)([
                "inset-inline-start:",
                "px;inset-inline-end:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.start, bounds.end, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'start', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;bottom:",
                "px;inset-inline-start:",
                "px;inset-inline-end:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.start, bounds.end, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'start', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $iA1nz.css)([
                "inset-inline-start:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.start, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'start', 'false');
            });
        }
    },
    end: {
        vertical: function vertical(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;bottom:",
                "px;inset-inline-end:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.end, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'end', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $iA1nz.css)([
                "inset-inline-start:",
                "px;inset-inline-end:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.start, bounds.end, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'end', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;bottom:",
                "px;inset-inline-start:",
                "px;inset-inline-end:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.start, bounds.end, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'end', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $iA1nz.css)([
                "inset-inline-end:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.end, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'end', 'false');
            });
        }
    },
    'top-right': {
        vertical: function vertical(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;bottom:",
                "px;right:",
                "px;transform:translateX(0);",
                ";"
            ], bounds.top, bounds.bottom, bounds.right, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'top', 'true');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $iA1nz.css)([
                "left:",
                "px;right:",
                "px;top:0;transform:translateX(0);",
                ";"
            ], bounds.left, bounds.right, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'top', 'true');
            });
        },
        "true": function _true(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ";"
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'top', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;right:",
                "px;transform:translateY(0);",
                ";"
            ], bounds.top, bounds.right, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'top', 'true');
            });
        }
    },
    'top-left': {
        vertical: function vertical(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'top', 'true');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $iA1nz.css)([
                "left:",
                "px;right:",
                "px;top:0;transform:translateX(0);",
                ""
            ], bounds.left, bounds.right, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'top', 'true');
            });
        },
        "true": function _true(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'top', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;left:",
                "px;transform:translateY(0);",
                ""
            ], bounds.top, bounds.left, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'top', 'true');
            });
        }
    },
    'bottom-right': {
        vertical: function vertical(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;bottom:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.right, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'bottom', 'true');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $iA1nz.css)([
                "left:",
                "px;right:",
                "px;bottom:",
                "px;transform:translateY(0);",
                ""
            ], bounds.left, bounds.right, bounds.bottom, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'bottom', 'true');
            });
        },
        "true": function _true(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'bottom', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $iA1nz.css)([
                "bottom:",
                "px;right:",
                "px;transform:translateY(0);",
                ""
            ], bounds.bottom, bounds.right, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'bottom', 'true');
            });
        }
    },
    'bottom-left': {
        vertical: function vertical(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'bottom', 'true');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $iA1nz.css)([
                "left:",
                "px;right:",
                "px;bottom:",
                "px;transform:translateY(0);",
                ""
            ], bounds.left, bounds.right, bounds.bottom, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'bottom', 'true');
            });
        },
        "true": function _true(bounds) {
            return (0, $iA1nz.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'bottom', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $iA1nz.css)([
                "bottom:",
                "px;left:",
                "px;transform:translateY(0);",
                ""
            ], bounds.bottom, bounds.left, function(props) {
                return $9aea1c389c35bf65$var$getAnimationStyle(props, 'bottom', 'true');
            });
        }
    }
};
var $9aea1c389c35bf65$var$roundStyle = function roundStyle(data, theme, position, margin) {
    var styles = [];
    var size = data === true ? 'medium' : data;
    // fallback to edgeSize for backwards compatibility
    var round = theme.global[theme.global.radius ? 'radius' : 'edgeSize'][size] || size;
    // if user provides CSS string such as '50px 12px', apply that always
    var customCSS = round.split(' ').length > 1;
    if (margin === 'none' && !customCSS && theme.layer.border.intelligentRounding === true) {
        if (position === 'bottom') styles.push((0, $iA1nz.css)([
            "border-radius:",
            " ",
            " 0 0;"
        ], round, round));
        else if (position === 'bottom-left') styles.push((0, $iA1nz.css)([
            "border-radius:0 ",
            " 0 0;"
        ], round));
        else if (position === 'bottom-right') styles.push((0, $iA1nz.css)([
            "border-radius:",
            " 0 0 0;"
        ], round));
        else if (position === 'end') // only works on Firefox, what should be fallback?
        styles.push((0, $iA1nz.css)([
            "border-start-start-radius:",
            ";border-end-start-radius:",
            ";"
        ], round, round));
        else if (position === 'left') styles.push((0, $iA1nz.css)([
            "border-radius:0 ",
            " ",
            " 0;"
        ], round, round));
        else if (position === 'right') styles.push((0, $iA1nz.css)([
            "border-radius:",
            " 0 0 ",
            ";"
        ], round, round));
        else if (position === 'start') // only works on Firefox, what should be fallback?
        styles.push((0, $iA1nz.css)([
            "border-end-end-radius:",
            ";border-start-end-radius:",
            ";"
        ], round, round));
        else if (position === 'top') styles.push((0, $iA1nz.css)([
            "border-radius:0 0 ",
            " ",
            ";"
        ], round, round));
        else if (position === 'top-left') styles.push((0, $iA1nz.css)([
            "border-radius:0 0 ",
            " 0;"
        ], round));
        else if (position === 'top-right') styles.push((0, $iA1nz.css)([
            "border-radius:0 0 0 ",
            ";"
        ], round));
        else // position is center, apply uniform border-radius
        styles.push((0, $iA1nz.css)([
            "border-radius:",
            ";"
        ], round));
    } else // if there's a margin apply uniform border-radius, or if user has supplied
    // a complex CSS string such as "50px 20px" apply this
    styles.push((0, $iA1nz.css)([
        "border-radius:",
        ";"
    ], round));
    return styles;
};
var $9aea1c389c35bf65$var$bounds = {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
};
var $9aea1c389c35bf65$var$desktopContainerStyle = (0, $iA1nz.css)([
    "",
    " max-height:",
    ";max-width:",
    ";",
    ";",
    ";"
], function(props) {
    if (!props.modal && props.position === 'hidden') return $9aea1c389c35bf65$var$hiddenPositionStyle;
    return (0, $iA1nz.css)([
        "position:",
        ";"
    ], props.modal || props.layerTarget ? 'absolute' : 'fixed');
}, function(props) {
    return "calc(100% - " + $9aea1c389c35bf65$var$getBounds($9aea1c389c35bf65$var$bounds, props.margin, props.theme, 'top') + "px - " + $9aea1c389c35bf65$var$getBounds($9aea1c389c35bf65$var$bounds, props.margin, props.theme, 'bottom') + "px)";
}, function(props) {
    return "calc(100% - " + $9aea1c389c35bf65$var$getBounds($9aea1c389c35bf65$var$bounds, props.margin, props.theme, 'left') + "px - " + $9aea1c389c35bf65$var$getBounds($9aea1c389c35bf65$var$bounds, props.margin, props.theme, 'right') + "px)";
}, function(props) {
    return props.plain || props.full && props.margin === 'none' ? "border-radius: 0;" : $9aea1c389c35bf65$var$roundStyle(props.theme.layer.border.radius, props.theme, props.position, props.margin);
}, function(props) {
    return props.position !== 'hidden' && $9aea1c389c35bf65$var$POSITIONS[props.position][props.full]($9aea1c389c35bf65$var$getBounds($9aea1c389c35bf65$var$bounds, props.margin, props.theme), $9aea1c389c35bf65$var$bounds) || '';
});
var $9aea1c389c35bf65$var$responsiveContainerStyle = function responsiveContainerStyle(props) {
    return (0, $iA1nz.css)([
        "position:relative;max-height:none;max-width:none;border-radius:0;height:",
        ";width:",
        ";"
    ], !props.layerTarget ? '100vh' : '100%', !props.layerTarget ? '100vw' : '100%');
};
var $9aea1c389c35bf65$var$elevationStyle = (0, $iA1nz.css)([
    "box-shadow:",
    ";"
], function(props) {
    return props.theme.global.elevation[props.theme.dark ? 'dark' : 'light'][props.theme.layer.container.elevation];
});
var $9aea1c389c35bf65$export$1d41361302b577a1 = (0, $iA1nz.default).div.withConfig({
    shouldForwardProp: function shouldForwardProp(prop) {
        return (0, $8Fliv.default)(prop) && ![
            'elevation'
        ].includes(prop);
    }
}).withConfig({
    displayName: "StyledLayer__StyledContainer",
    componentId: "sc-rmtehz-2"
})([
    "",
    " display:flex;flex-direction:column;",
    " ",
    " outline:none;pointer-events:all;z-index:",
    ";",
    " ",
    " ",
    ";",
    ";"
], function(props) {
    return !props.modal ? (0, $73ba8e2d301b823f$export$360b744af11007ac) : '';
}, function(props) {
    return (0, $73ba8e2d301b823f$export$9f8046d1e2885811)(props.theme.layer.container.height, props.theme);
}, function(props) {
    return !props.plain && (props.background || props.theme.layer.background) && (0, $0b4a347e23c22183$export$e43a4f0de05cb7e9)(props.background || props.theme.layer.background, props.theme);
}, function(props) {
    return props.theme.layer.container.zIndex;
}, function(props) {
    return !props.plain && props.theme.layer.container.elevation && $9aea1c389c35bf65$var$elevationStyle;
}, $9aea1c389c35bf65$var$desktopContainerStyle, function(props) {
    if (props.responsive && props.theme.layer.responsiveBreakpoint) {
        var breakpoint = props.theme.global.breakpoints[props.theme.layer.responsiveBreakpoint];
        if (breakpoint) return (0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, $9aea1c389c35bf65$var$responsiveContainerStyle);
    }
    return '';
}, function(props) {
    return props.theme.layer.container && props.theme.layer.container.extend;
});



var $daf0d80fc2fd02dd$var$_excluded = [
    "background",
    "children",
    "full",
    "id",
    "margin",
    "modal",
    "onClickOutside",
    "onEsc",
    "plain",
    "position",
    "responsive",
    "target"
];
function $daf0d80fc2fd02dd$var$_extends() {
    return $daf0d80fc2fd02dd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $daf0d80fc2fd02dd$var$_extends.apply(null, arguments);
}
function $daf0d80fc2fd02dd$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// The FocusSpan ensures the LayerContainer has focus when
// it is opened for user to start tabbing inside it.
// It helps for escaping the LayerContainer using the keyboard.
// It is hidden visually but still part of the accessibility tree.
var $daf0d80fc2fd02dd$var$FocusSpan = (0, $iA1nz.default).span.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "LayerContainer__FocusSpan",
    componentId: "sc-1srj14c-0"
})([
    "width:0;height:0;overflow:hidden;position:absolute;clip-path:inset(50%);white-space:nowrap;border:0;&:focus{outline:none;}"
]);
var $daf0d80fc2fd02dd$export$802ffc1493ab0ff7 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var background = _ref.background, children = _ref.children, _ref$full = _ref.full, full = _ref$full === void 0 ? false : _ref$full, id = _ref.id, _ref$margin = _ref.margin, margin = _ref$margin === void 0 ? 'none' : _ref$margin, modal = _ref.modal, onClickOutside = _ref.onClickOutside, onEsc = _ref.onEsc, plain = _ref.plain, _ref$position = _ref.position, position = _ref$position === void 0 ? 'center' : _ref$position, _ref$responsive = _ref.responsive, responsive = _ref$responsive === void 0 ? true : _ref$responsive, layerTarget = _ref.target, rest = $daf0d80fc2fd02dd$var$_objectWithoutPropertiesLoose(_ref, $daf0d80fc2fd02dd$var$_excluded);
    var containerTarget = (0, $2xPiy.useContext)((0, $18ec84c72847fc8a$export$64a849364cd772b4));
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var size = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    // layerOptions was created to preserve backwards compatibility but
    // should not be supported in v3
    var _useContext = (0, $2xPiy.useContext)((0, $cc9e28c6770f7140$export$b709306b005c3ef)), layerOptions = _useContext.layer;
    var focusSpanRef = (0, $2xPiy.useRef)();
    var containerRef = (0, $2xPiy.useRef)();
    var layerRef = (0, $2xPiy.useRef)();
    var portalContext = (0, $2xPiy.useContext)((0, $fe63d32c9ed46844$export$60d741e20e0aa309));
    var portalId = (0, $2xPiy.useMemo)(function() {
        return portalContext.length;
    }, [
        portalContext
    ]);
    var nextPortalContext = (0, $2xPiy.useMemo)(function() {
        return [].concat(portalContext, [
            portalId
        ]);
    }, [
        portalContext,
        portalId
    ]);
    var sendAnalytics = (0, $5bd12fcfcb46b8f6$export$e955abb82869dc84)();
    (0, $2xPiy.useEffect)(function() {
        var start = new Date();
        var element = layerRef.current;
        var isHidden = position === 'hidden';
        if (!isHidden) sendAnalytics({
            type: 'layerOpen',
            element: element
        });
        return function() {
            if (!isHidden) sendAnalytics({
                type: 'layerClose',
                element: element,
                elapsed: new Date().getTime() - start.getTime()
            });
        };
    }, [
        sendAnalytics,
        layerRef,
        position
    ]);
    (0, $2xPiy.useEffect)(function() {
        if (position !== 'hidden') {
            var node = layerRef.current || containerRef.current || ref.current;
            if (node && node.scrollIntoView) node.scrollIntoView();
            // Once layer is open we make sure it has focus so that you
            // can start tabbing inside the layer. If the caller put focus
            // on an element already, we honor that. Otherwise, we put
            // the focus on the hidden span.
            var element = document.activeElement;
            while(element){
                if (element === containerRef.current) break;
                element = element.parentElement;
            }
            if (modal && !element && focusSpanRef.current) focusSpanRef.current.focus();
        }
    }, [
        modal,
        position,
        ref
    ]);
    (0, $2xPiy.useEffect)(function() {
        var onClickDocument = function onClickDocument(event) {
            // determine which portal id the target is in, if any
            var clickedPortalId = null;
            var node = event.composed && event.composedPath()[0] || event.target;
            while(clickedPortalId === null && node && node !== document && !(node instanceof ShadowRoot)){
                // check if user click occurred within the layer
                var attr = node.getAttribute('data-g-portal-id');
                if (attr !== null && attr !== '') clickedPortalId = parseInt(attr, 10);
                else node = node.parentNode;
            }
            if ((clickedPortalId === null || portalContext.indexOf(clickedPortalId) !== -1) && node !== null) // if the click occurred outside of the Layer portal, call
            // the user's onClickOutside function
            onClickOutside(event);
        };
        // if user provides an onClickOutside function, listen for mousedown event
        if (onClickOutside) document.addEventListener('mousedown', onClickDocument);
        if (layerTarget) {
            var updateBounds = function updateBounds() {
                var windowWidth = window.innerWidth;
                var windowHeight = window.innerHeight;
                var target = (0, $83f2052c15a18307$export$4fe2c44731a76aa0)(layerTarget);
                // affects StyledLayer
                var layer = layerRef.current;
                if (layer && target) {
                    // clear prior styling
                    layer.style.left = '';
                    layer.style.top = '';
                    layer.style.bottom = '';
                    layer.style.width = '';
                    // get bounds
                    var targetRect = target.getBoundingClientRect();
                    var layerRect = layer.getBoundingClientRect();
                    // ensure that layer moves with the target
                    layer.style.left = targetRect.left + "px";
                    layer.style.right = windowWidth - targetRect.right + "px";
                    layer.style.top = targetRect.top + "px";
                    layer.style.bottom = windowHeight - targetRect.bottom + "px";
                    layer.style.maxHeight = targetRect.height;
                    layer.style.maxWidth = Math.min(layerRect.width, windowWidth);
                }
            };
            updateBounds();
            window.addEventListener('resize', updateBounds);
            window.addEventListener('scroll', updateBounds, true);
            return function() {
                window.removeEventListener('resize', updateBounds);
                window.removeEventListener('scroll', updateBounds, true);
                if (onClickOutside) document.removeEventListener('mousedown', onClickDocument);
            };
        }
        return function() {
            if (onClickOutside) document.removeEventListener('mousedown', onClickDocument);
        };
    }, [
        containerTarget,
        layerTarget,
        onClickOutside,
        portalContext,
        portalId
    ]);
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $9aea1c389c35bf65$export$1d41361302b577a1), $daf0d80fc2fd02dd$var$_extends({
        ref: ref || containerRef,
        background: background,
        elevation: theme.layer.container.elevation,
        id: layerOptions && layerOptions.singleId ? id + "__container" : id,
        full: full,
        margin: margin,
        modal: modal
    }, passThemeFlag, rest, {
        position: position,
        plain: plain,
        responsive: responsive,
        layerTarget: layerTarget,
        dir: theme.dir,
        "data-g-portal-id": portalId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($daf0d80fc2fd02dd$var$FocusSpan, {
        ref: focusSpanRef,
        tabIndex: "-1"
    }), children);
    content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $9aea1c389c35bf65$export$465e4e6abe6afeb6), $daf0d80fc2fd02dd$var$_extends({
        ref: layerRef,
        id: id,
        plain: plain,
        position: position,
        responsive: responsive,
        layerTarget: layerTarget,
        tabIndex: "-1",
        dir: theme.dir
    }, passThemeFlag), modal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $9aea1c389c35bf65$export$47f426cc93e497b4), $daf0d80fc2fd02dd$var$_extends({
        plain: plain,
        responsive: responsive,
        onMouseDown: onClickOutside
    }, passThemeFlag)), content);
    if (onEsc) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $168667f04da9206c$export$16e4d70cc375e707), {
        onEsc: onEsc ? function(event) {
            // prevent further capturing or bubbling of event to other
            // child or parent elements
            event.stopPropagation();
            onEsc(event);
        } : undefined,
        target: modal === false ? 'document' : undefined
    }, content);
    var themeContextValue = (0, $2xPiy.useMemo)(function() {
        var dark = (0, $0b4a347e23c22183$export$d285dc898c6a4d11)(theme.layer.background, theme);
        return $daf0d80fc2fd02dd$var$_extends({}, theme, {
            dark: dark
        });
    }, [
        theme
    ]);
    if (theme.layer.background) {
        var dark = themeContextValue.dark;
        if (dark !== undefined && dark !== theme.dark) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $iA1nz.ThemeContext).Provider, {
            value: themeContextValue
        }, content);
    }
    content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $fe63d32c9ed46844$export$60d741e20e0aa309).Provider, {
        value: nextPortalContext
    }, content);
    var hitResponsiveBreakpoint = responsive && size === theme.layer.responsiveBreakpoint;
    // if layer is responsive and we've hit the breakpoint,
    // the layer will be filling the viewport, so we want to
    // restrict the scroll to the layer and not allow the
    // body to scroll
    if (modal || hitResponsiveBreakpoint) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $203385cade677f5b$export$b0cd6833c93fb94d), {
        hidden: position === 'hidden',
        restrictScroll: !layerTarget && (modal || hitResponsiveBreakpoint) ? true : undefined,
        trapFocus: true
    }, content);
    return content;
});





var $dyr1f = parcelRequire("dyr1f");

var $ae45c3d1290dc488$var$PAD_SIZES = [
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large'
];
var $ae45c3d1290dc488$var$PropType = {};
$ae45c3d1290dc488$var$PropType = {
    animate: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    animation: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'slide',
            'fadeIn',
            'none'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
    ]),
    background: (0, $ab32ce3df36aa105$export$aa372966d47f02af),
    full: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'vertical',
            'horizontal'
        ])
    ]),
    margin: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'none'
        ].concat($ae45c3d1290dc488$var$PAD_SIZES)),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            bottom: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ae45c3d1290dc488$var$PAD_SIZES),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            ]),
            end: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ae45c3d1290dc488$var$PAD_SIZES),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            ]),
            horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ae45c3d1290dc488$var$PAD_SIZES),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            ]),
            left: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ae45c3d1290dc488$var$PAD_SIZES),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            ]),
            right: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ae45c3d1290dc488$var$PAD_SIZES),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            ]),
            start: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ae45c3d1290dc488$var$PAD_SIZES),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            ]),
            top: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ae45c3d1290dc488$var$PAD_SIZES),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            ]),
            vertical: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($ae45c3d1290dc488$var$PAD_SIZES),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            ])
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    modal: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    onClickOutside: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onEsc: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    plain: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    position: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'bottom',
        'bottom-left',
        'bottom-right',
        'center',
        'end',
        'hidden',
        'left',
        'right',
        'start',
        'top',
        'top-left',
        'top-right'
    ]),
    responsive: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    target: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object
};
var $ae45c3d1290dc488$export$413e9102c6e92d1b = $ae45c3d1290dc488$var$PropType;


function $2a0d64d499f7ed44$var$_extends() {
    return $2a0d64d499f7ed44$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2a0d64d499f7ed44$var$_extends.apply(null, arguments);
}
var $2a0d64d499f7ed44$export$936d0764594b6eb3 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    var animate = props.animate, animation = props.animation, _props$modal = props.modal, modal = _props$modal === void 0 ? true : _props$modal, targetChildPosition = props.targetChildPosition;
    var _useState = (0, $2xPiy.useState)(), layerContainer = _useState[0], setLayerContainer = _useState[1];
    var containerTarget = (0, $2xPiy.useContext)((0, $18ec84c72847fc8a$export$64a849364cd772b4));
    var originalFocusedElementRef = (0, $2xPiy.useRef)(null);
    var focusWithinLayerRef = (0, $2xPiy.useRef)(false);
    (0, $2xPiy.useEffect)(function() {
        originalFocusedElementRef.current = document.activeElement;
    }, []);
    (0, $2xPiy.useEffect)(function() {
        var handleFocusIn = function handleFocusIn(event) {
            if (layerContainer != null && layerContainer.contains != null && layerContainer.contains(event.target)) focusWithinLayerRef.current = true;
        };
        var handleFocusOut = function handleFocusOut(event) {
            if (layerContainer != null && layerContainer.contains != null && layerContainer.contains(event.target) && !layerContainer.contains(event.relatedTarget)) focusWithinLayerRef.current = false;
        };
        document.addEventListener('focusin', handleFocusIn);
        document.addEventListener('focusout', handleFocusOut);
        return function() {
            document.removeEventListener('focusin', handleFocusIn);
            document.removeEventListener('focusout', handleFocusOut);
        };
    }, [
        layerContainer
    ]);
    (0, $2xPiy.useEffect)(function() {
        return setLayerContainer((0, $83f2052c15a18307$export$1cad4a11c7ad1375)(containerTarget, targetChildPosition));
    }, [
        containerTarget,
        targetChildPosition
    ]);
    // just a few things to clean up when the Layer is unmounted
    (0, $9462599f26e06396$export$e5c5a5f917a5871c)(function() {
        return function() {
            var originalFocusedElement = originalFocusedElementRef.current;
            if (originalFocusedElement) {
                // Restore focus if:
                // - modal layer (always restore), or
                // - non-modal layer that had focus when it closed
                var shouldRestoreFocus = modal || !modal && focusWithinLayerRef.current;
                if (shouldRestoreFocus && originalFocusedElement.focus) // wait for the fixed positioning to come back to normal
                // see layer styling for reference
                setTimeout(function() {
                    return originalFocusedElement.focus();
                }, 0);
                else if (originalFocusedElement.parentNode && originalFocusedElement.parentNode.focus) // required for IE11 and Edge
                originalFocusedElement.parentNode.focus();
            }
            if (layerContainer) {
                var activeAnimation = animation !== undefined ? animation : animate;
                if (activeAnimation !== false) {
                    // undefined uses 'slide' as the default
                    // animate out and remove later
                    var layerClone = layerContainer.cloneNode(true);
                    layerClone.id = 'layerClone';
                    containerTarget.appendChild(layerClone);
                    var clonedContainer = layerClone.querySelector('[class*="StyledLayer__StyledContainer"]');
                    if (clonedContainer && clonedContainer.style) clonedContainer.style.animationDirection = 'reverse';
                    setTimeout(function() {
                        // we add the id and query here so the unit tests work
                        var rootNode = containerTarget.getRootNode();
                        // Not all root nodes (ShadowRoot, DocumentFragment)
                        //  have getElementById.
                        if (rootNode && typeof rootNode.getElementById === 'function') {
                            var clone = rootNode.getElementById('layerClone');
                            if (clone) {
                                if (containerTarget.contains(clone)) containerTarget.removeChild(clone);
                                layerContainer.remove();
                            }
                        }
                    }, (0, $9aea1c389c35bf65$export$82f5c257a11c5515));
                } else if (containerTarget.contains(layerContainer)) containerTarget.removeChild(layerContainer);
            }
        };
    }, [
        animate,
        animation,
        containerTarget,
        layerContainer,
        modal
    ]);
    return layerContainer ? /*#__PURE__*/ (0, $cX5wj.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $daf0d80fc2fd02dd$export$802ffc1493ab0ff7), $2a0d64d499f7ed44$var$_extends({
        ref: ref
    }, props, {
        modal: modal
    })), layerContainer) : null;
});
$2a0d64d499f7ed44$export$936d0764594b6eb3.displayName = 'Layer';
$2a0d64d499f7ed44$export$936d0764594b6eb3.propTypes = (0, $ae45c3d1290dc488$export$413e9102c6e92d1b);



var $2xPiy = parcelRequire("2xPiy");


function $c1da19823027de53$var$_extends() {
    return $c1da19823027de53$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c1da19823027de53$var$_extends.apply(null, arguments);
}
var $c1da19823027de53$export$f39c2d165cd861fe = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    var scaleProps = (0, $c043e17d1ada851a$export$56a2e46cd4a7c217)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $c1da19823027de53$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Close"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", $c1da19823027de53$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m3 3 18 18M3 21 21 3"
    }, scaleProps)));
});
$c1da19823027de53$export$f39c2d165cd861fe.displayName = 'Close';


var $2xPiy = parcelRequire("2xPiy");

function $e23e190c1adfeb13$var$_extends() {
    return $e23e190c1adfeb13$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e23e190c1adfeb13$var$_extends.apply(null, arguments);
}
var $e23e190c1adfeb13$export$a2518b5310db22ab = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $e23e190c1adfeb13$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Status is warning"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m12 3 10 18H2L12 3zm0 6v6m0 1v2"
    }));
});
$e23e190c1adfeb13$export$a2518b5310db22ab.displayName = 'StatusWarning';





var $2xPiy = parcelRequire("2xPiy");







const $d3263c98ec06168d$export$90b89cb54a5768ce = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { value: value, setValue: setValue, clientId: clientId, fullClientLoad: fullClientLoad, reportingPeriodTypeId: reportingPeriodTypeId, firstActivePeriod: firstActivePeriod, programId: programId, id: id, name: name, label: label, disabled: disabled, placeholder: placeholder, ...selectProps } = props;
    /** Context **/ const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const clientStore = (0, $116967e0234c3770$export$3b47afa599c78f61)();
    /** State **/ const [isLoading, setIsLoading] = (0, $2xPiy.useState)(false);
    const [options, setOptions] = (0, $2xPiy.useState)();
    /** Methods **/ const fetchOptions = async (clientId, reportingPeriodTypeId, firstActivePeriod)=>{
        try {
            setIsLoading(true);
            /*
        Rules - Retirement (Last Reporting Period)

        1. Don't display any periods before the facility/equipment's first active period. 
        2. Don't display any finalized periods EXCEPT the most recent one. 
        3. Don't display anything before the locked period. 
      */ let reportingPeriods = (0, $00658ccd6ec0135a$export$b3ab20afa21fa2d4)(await clientStore.fetchClientReportingPeriods(clientId, reportingPeriodTypeId, true, false, programId, fullClientLoad));
            // Remove duplicates for full client load
            if (fullClientLoad) {
                const periodMap = new Map();
                for (const period of reportingPeriods){
                    const key = `${period.reporting_period_type_id}-${period.start_reporting_quarter}-${period.end_reporting_quarter}`;
                    const existing = periodMap.get(key);
                    if (existing) {
                        existing.is_finalized = existing.is_finalized || period.is_finalized;
                        existing.is_client_locked = existing.is_client_locked || period.is_client_locked;
                    } else periodMap.set(key, {
                        ...period
                    });
                }
                reportingPeriods = Array.from(periodMap.values());
            }
            let mostRecentFinalized;
            let mostRecentLocked;
            for (const p of reportingPeriods){
                if (p.is_finalized && !mostRecentFinalized) mostRecentFinalized = p;
                if (p.is_client_locked && !mostRecentLocked) mostRecentLocked = p;
                if (mostRecentFinalized && mostRecentLocked) break;
            }
            const options = reportingPeriods.filter((p)=>{
                const reportingPeriodDate = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(p.start_reporting_quarter);
                // Don't display any periods before the facility/equipment's first active period.
                if (reportingPeriodDate.isBefore(firstActivePeriod)) return false;
                // Don't display any finalized periods EXCEPT the most recent one.
                if (p.is_finalized && p.id !== mostRecentFinalized?.id) return false;
                // Don't display anything before the locked period.
                if (userStore.isExternalUser && mostRecentLocked && reportingPeriodDate.isBefore(mostRecentLocked.start_reporting_quarter)) return false;
                return true;
            }).map((p)=>({
                    label: (0, $00658ccd6ec0135a$export$f96ebb633255a704)(p.start_reporting_quarter, reportingPeriodTypeId === (0, $0badf5665deea2b2$export$a121e4a6c908fa8f).Yearly),
                    value: reportingPeriodTypeId === (0, $0badf5665deea2b2$export$a121e4a6c908fa8f).Yearly ? p.end_reporting_quarter : p.start_reporting_quarter
                }));
            setOptions((0, $00658ccd6ec0135a$export$ccc472524c48b71f)(options));
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listClientReportingPeriods.error);
        } finally{
            setIsLoading(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (clientId && reportingPeriodTypeId && firstActivePeriod && !options) fetchOptions(clientId, reportingPeriodTypeId, firstActivePeriod);
    }, [
        clientId,
        reportingPeriodTypeId,
        firstActivePeriod,
        options
    ]);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
        value: value,
        setValue: (value)=>setValue(value),
        options: options ?? [],
        name: id ? undefined : name || 'reporting_period_select',
        label: label ?? 'Reporting Period',
        placeholder: isLoading ? 'Loading...' : placeholder,
        disabled: isLoading || disabled,
        ...selectProps
    });
});








const $0a4cd5935f7bb50d$export$22a9bb52ea2aeb6d = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(({ client: client, setIsVisible: setIsVisible, setShouldRefresh: setShouldRefresh, isCanada: isCanada = false })=>{
    /** Stores **/ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** State **/ const [isRetiring, setIsRetiring] = (0, $2xPiy.useState)(false);
    const [isConfirmed1, setIsConfirmed1] = (0, $2xPiy.useState)(false);
    const [isConfirmed2, setIsConfirmed2] = (0, $2xPiy.useState)(false);
    const [formValues, setFormValues] = (0, $2xPiy.useState)({
        last_active_reporting_quarter: '',
        end_date: '',
        retirement_reason: ''
    });
    const [formErrors, setFormErrors] = (0, $2xPiy.useState)({});
    /** Computed **/ const canRetire = userStore.isFuseAdmin;
    const selectedPeriodLabel = (0, $00658ccd6ec0135a$export$f96ebb633255a704)(formValues.last_active_reporting_quarter ?? '', isCanada);
    const hasReason = !!formValues.retirement_reason.trim();
    /** Methods **/ const updateFormValue = (key, value)=>{
        setFormValues((prev)=>({
                ...prev,
                [key]: value
            }));
        if (formErrors[key]) setFormErrors((prev)=>({
                ...prev,
                [key]: ''
            }));
    };
    const retireClient = async ()=>{
        if (isRetiring) return;
        const formFields = {
            last_active_reporting_quarter: {
                label: t('client:lastReportingPeriod'),
                required: true
            },
            end_date: {
                label: t('client:fuseEndDate'),
                required: true
            },
            retirement_reason: {
                label: t('common:reasonForRetiring'),
                required: true
            }
        };
        const errors = (0, $084681c8221d0a24$export$5fafec8d1b047c0)(formFields, {
            ...formValues,
            retirement_reason: formValues.retirement_reason.trim()
        });
        if (errors) {
            setFormErrors(errors);
            return;
        }
        try {
            setIsRetiring(true);
            await (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).retire({
                id: client.id,
                last_active_reporting_quarter: formValues.last_active_reporting_quarter ?? '',
                end_date: formValues.end_date ?? '',
                retirement_reason: formValues.retirement_reason.trim()
            });
            setShouldRefresh(true);
            setIsVisible(false);
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).retireClient.success);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).retireClient.error);
        } finally{
            setIsRetiring(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (!canRetire) setIsVisible(false);
    }, [
        canRetire
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
        position: "center",
        onEsc: ()=>setIsVisible(false),
        onClickOutside: ()=>setIsVisible(false),
        responsive: false,
        style: {
            width: 'auto',
            maxWidth: 'min(95vw, 500px)',
            maxHeight: '95vh',
            overflow: 'auto',
            borderRadius: '8px'
        },
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $98b6153ed086d9bd$export$11154b700737b45e), {
            width: "100%",
            title: `${t('client:retire')} ${(0, $00658ccd6ec0135a$export$83ca57d51225263a)(client, (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Client)}`,
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d8fcb0015cca0f72$export$825a3c81a577bf46), {
                entityName: (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Client
            }),
            onSubmit: ()=>retireClient(),
            isLoading: isRetiring,
            hideRequiredText: true,
            saveButtonLabel: t('client:retireButton'),
            saveButtonLoadingLabel: t('client:retiringButton'),
            saveButtonDisabled: !isConfirmed1 || !isConfirmed2 || !hasReason,
            headerChildren: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                    pad: "none",
                    onClick: ()=>setIsVisible(false),
                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c1da19823027de53$export$f39c2d165cd861fe), {
                        size: "20px"
                    }),
                    tip: t('common:close')
                }, "close")
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                pad: {
                    horizontal: 'medium',
                    bottom: 'medium'
                },
                gap: "medium",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                        gap: "1rem",
                        direction: "row",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e23e190c1adfeb13$export$a2518b5310db22ab), {
                                size: "medium",
                                color: "status-warning"
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                children: [
                                    t('client:retireWarning'),
                                    " ",
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("b", {
                                        children: t('common:after')
                                    }),
                                    ' ',
                                    formValues.last_active_reporting_quarter ? selectedPeriodLabel : t('client:theLastReportingPeriod'),
                                    ' ',
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("b", {
                                        children: t('client:retireWarningEnd')
                                    })
                                ]
                            })
                        ]
                    }),
                    client.client_programs.length > 0 ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d3263c98ec06168d$export$90b89cb54a5768ce), {
                        id: "last_active_reporting_quarter",
                        label: t('client:lastReportingPeriod'),
                        placeholder: t('client:selectPeriod'),
                        value: formValues.last_active_reporting_quarter,
                        setValue: (value)=>updateFormValue('last_active_reporting_quarter', value),
                        clientId: client.id,
                        fullClientLoad: true,
                        reportingPeriodTypeId: client.reporting_period_type_id,
                        firstActivePeriod: client.first_active_reporting_quarter,
                        error: formErrors['last_active_reporting_quarter'],
                        required: true,
                        fill: "horizontal"
                    }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                        gap: "1rem",
                        direction: "row",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e23e190c1adfeb13$export$a2518b5310db22ab), {
                                size: "medium",
                                color: "status-warning"
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                children: t('client:noProgramMessage')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                        name: "end_date",
                        label: t('client:fuseEndDate'),
                        fill: "horizontal",
                        value: formValues.end_date,
                        setValue: (value)=>updateFormValue('end_date', value),
                        error: formErrors['end_date'],
                        componentType: "date",
                        dateBounds: formValues.last_active_reporting_quarter ? [
                            (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(formValues.last_active_reporting_quarter).format('YYYY-MM-DD'),
                            (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))().add(50, 'year').format('YYYY-MM-DD')
                        ] : undefined,
                        displayValue: (0, $00658ccd6ec0135a$export$25fe81f0e0c5bc4)(formValues.end_date ?? '', isCanada),
                        required: true
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                        name: "retirement_reason",
                        label: t('common:reasonForRetiring'),
                        fill: "horizontal",
                        value: formValues.retirement_reason,
                        setValue: (value)=>updateFormValue('retirement_reason', value),
                        error: formErrors['retirement_reason'],
                        componentType: "textArea",
                        rows: 3,
                        required: true
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        gap: "small",
                        children: [
                            formValues.last_active_reporting_quarter && formValues.end_date && hasReason && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                                gap: "1rem",
                                direction: "row",
                                align: "center",
                                background: {
                                    color: 'status-error',
                                    dark: true
                                },
                                pad: "medium",
                                round: "small",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                                        checked: isConfirmed1,
                                        onChange: ()=>setIsConfirmed1(!isConfirmed1),
                                        color: "white"
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        color: "white",
                                        children: t('client:retireConfirmation1')
                                    })
                                ]
                            }),
                            formValues.last_active_reporting_quarter && formValues.end_date && hasReason && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                                gap: "1rem",
                                direction: "row",
                                align: "center",
                                background: {
                                    color: 'status-error',
                                    dark: true
                                },
                                pad: "medium",
                                round: "small",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                                        checked: isConfirmed2,
                                        onChange: ()=>setIsConfirmed2(!isConfirmed2),
                                        color: "white"
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        color: "white",
                                        children: [
                                            t('client:retireConfirmation2Start'),
                                            " ",
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("b", {
                                                children: t('common:after')
                                            }),
                                            " ",
                                            selectedPeriodLabel,
                                            ' ',
                                            t('client:retireConfirmation2End')
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
});






var $2xPiy = parcelRequire("2xPiy");


var $2xPiy = parcelRequire("2xPiy");

var $dyr1f = parcelRequire("dyr1f");

function $aeab13eedea45727$var$_extends() {
    return $aeab13eedea45727$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $aeab13eedea45727$var$_extends.apply(null, arguments);
}
var $aeab13eedea45727$var$PropType = {};
$aeab13eedea45727$var$PropType = $aeab13eedea45727$var$_extends({}, (0, $ab32ce3df36aa105$export$ffe37ff34eeb9e21), {
    activeIndex: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number)
    ]),
    animate: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node,
    level: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
    onActive: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    multiple: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    messages: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        tabContents: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    })
});
var $aeab13eedea45727$export$2e471fbf97c80661 = $aeab13eedea45727$var$PropType;




var $2xPiy = parcelRequire("2xPiy");
var $97b849b107eeb84a$export$6bd5bb82c987ab74 = /*#__PURE__*/ (0, $2xPiy.createContext)({});


var $972a591c1e48136a$var$_excluded = [
    "activeIndex",
    "animate",
    "children",
    "level",
    "multiple",
    "onActive"
];
function $972a591c1e48136a$var$_extends() {
    return $972a591c1e48136a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $972a591c1e48136a$var$_extends.apply(null, arguments);
}
function $972a591c1e48136a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $972a591c1e48136a$var$activeAsArray = function activeAsArray(active) {
    return typeof active === 'number' ? [
        active
    ] : active;
};
var $972a591c1e48136a$export$a766cd26d0d69044 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var activeIndex = _ref.activeIndex, _ref$animate = _ref.animate, animate = _ref$animate === void 0 ? true : _ref$animate, children = _ref.children, level = _ref.level, multiple = _ref.multiple, onActive = _ref.onActive, rest = $972a591c1e48136a$var$_objectWithoutPropertiesLoose(_ref, $972a591c1e48136a$var$_excluded);
    var _useState = (0, $2xPiy.useState)([]), activeIndexes = _useState[0], setActiveIndexes = _useState[1];
    var _useState2 = (0, $2xPiy.useState)(), stateActiveIndex = _useState2[0], setStateActiveIndex = _useState2[1];
    // Derived state from props
    // https://reactjs.org/docs/hooks-faq.html#how-do-i-implement-getderivedstatefromprops
    var derivedActiveIndexes = $972a591c1e48136a$var$activeAsArray(activeIndex) || [];
    if ((typeof activeIndex !== 'undefined' || activeIndex !== stateActiveIndex) && derivedActiveIndexes.join() !== activeIndexes.join()) {
        setActiveIndexes(derivedActiveIndexes);
        setStateActiveIndex(activeIndex);
    }
    var getAccordionContext = (0, $2xPiy.useCallback)(function(index) {
        var _onPanelChange = function onPanelChange(nextIndex) {
            var nextActiveIndexes = [].concat(activeIndexes || []);
            var nextActiveIndex = nextActiveIndexes.indexOf(nextIndex);
            if (nextActiveIndex > -1) nextActiveIndexes.splice(nextActiveIndex, 1);
            else if (multiple) nextActiveIndexes.push(nextIndex);
            else nextActiveIndexes = [
                nextIndex
            ];
            setActiveIndexes(nextActiveIndexes);
            if (onActive) onActive(nextActiveIndexes);
        };
        return {
            active: activeIndexes.indexOf(index) > -1,
            animate: animate,
            level: level,
            onPanelChange: function onPanelChange() {
                return _onPanelChange(index);
            }
        };
    }, [
        activeIndexes,
        animate,
        level,
        multiple,
        onActive
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), $972a591c1e48136a$var$_extends({
        ref: ref
    }, rest), (0, $2xPiy.Children).toArray(children).filter(function(child) {
        return child;
    }).map(function(child, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $97b849b107eeb84a$export$6bd5bb82c987ab74).Provider, {
            // eslint-disable-next-line react/no-array-index-key
            key: index,
            value: getAccordionContext(index)
        }, child);
    }));
});
$972a591c1e48136a$export$a766cd26d0d69044.propTypes = (0, $aeab13eedea45727$export$2e471fbf97c80661);


var $2xPiy = parcelRequire("2xPiy");

var $2xPiy = parcelRequire("2xPiy");
var $6b7eb3480858eeaa$var$_React$useId;
var $6b7eb3480858eeaa$var$currentId = 0;
var $6b7eb3480858eeaa$var$getId = function getId() {
    // eslint-disable-next-line no-plusplus
    var id = $6b7eb3480858eeaa$var$currentId++;
    return ":r" + id.toString(32) + ":";
};
var $6b7eb3480858eeaa$var$useIdGrommet = function useIdGrommet() {
    var _useState = (0, $2xPiy.useState)($6b7eb3480858eeaa$var$getId), id = _useState[0];
    return id;
};
// Polyfill React 18's useId for compatibility with React 16 and 17
var $6b7eb3480858eeaa$export$f680877a34711e37 = ($6b7eb3480858eeaa$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).useId) != null ? $6b7eb3480858eeaa$var$_React$useId : $6b7eb3480858eeaa$var$useIdGrommet;





var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");




var $dyr1f = parcelRequire("dyr1f");
var $b0697cfc8b393228$var$PropType = {};
$b0697cfc8b393228$var$PropType = {
    open: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'horizontal',
        'vertical'
    ])
};
var $b0697cfc8b393228$export$2c6a2ea456400009 = $b0697cfc8b393228$var$PropType;



var $9dcd345e1cd244f1$var$AnimatedBox = (0, $iA1nz.default)((0, $18c0523379e5dd9d$export$e71c4d32a2263218)).withConfig({
    displayName: "Collapsible__AnimatedBox",
    componentId: "sc-15kniua-0"
})([
    "",
    ""
], function(props) {
    return props.shouldOpen ? "visibility: hidden;\n      position: absolute;\n      pointer-events: none;" : "transition: " + ("max-" + props.dimension + " " + props.speedProp + "ms, opacity " + props.speedProp + "ms") + ";\n      opacity: " + (props.open ? 1 : 0) + ";\n      overflow: " + (props.animate || !props.open ? 'hidden' : 'visible') + ";";
});
var $9dcd345e1cd244f1$export$6eb0f7ddcda6131f = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var children = _ref.children, direction = _ref.direction, openArg = _ref.open;
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useState = (0, $2xPiy.useState)(openArg), open = _useState[0], setOpen = _useState[1];
    var _useState2 = (0, $2xPiy.useState)(false), animate = _useState2[0], setAnimate = _useState2[1];
    var _useState3 = (0, $2xPiy.useState)(theme.collapsible.minSpeed), speed = _useState3[0], setSpeed = _useState3[1];
    var dimension = (0, $2xPiy.useMemo)(function() {
        return direction === 'horizontal' ? 'width' : 'height';
    }, [
        direction
    ]);
    var containerRef = (0, $3cecef11d3b9c451$export$61dc559f8a0b9bcf)(ref);
    var sizeRef = (0, $2xPiy.useRef)(0);
    var shouldOpen = !open && openArg;
    var shouldClose = open && !openArg;
    // when the caller changes openArg, trigger animation
    (0, $2xPiy.useEffect)(function() {
        if (openArg !== open) {
            setAnimate(true);
            setOpen(openArg);
        }
    }, [
        open,
        openArg
    ]);
    // prepare to open or close
    (0, $9462599f26e06396$export$e5c5a5f917a5871c)(function() {
        var container = containerRef.current;
        // skip this if animation is in progress
        if (!animate && shouldOpen) {
            var parentPrevPosition = container.parentNode.style.position;
            container.parentNode.style.position = 'relative';
            var _container$getBoundin = container.getBoundingClientRect(), size = _container$getBoundin[dimension];
            container.parentNode.style.position = parentPrevPosition;
            sizeRef.current = size;
        }
        if (shouldOpen) container.style["max-" + dimension] = 0;
        else if (shouldClose) {
            var _container$getBoundin2 = container.getBoundingClientRect(), _size = _container$getBoundin2[dimension];
            container.style["max-" + dimension] = _size + "px";
        }
    }, [
        shouldOpen,
        shouldClose,
        containerRef,
        dimension,
        animate
    ]);
    (0, $2xPiy.useEffect)(function() {
        if (shouldOpen || shouldClose) {
            var container = containerRef.current;
            var _theme$collapsible = theme.collapsible, minSpeed = _theme$collapsible.minSpeed, baseline = _theme$collapsible.baseline;
            var nextSpeed = Math.max(sizeRef.current / baseline * minSpeed, minSpeed);
            setSpeed(nextSpeed);
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    // Change the max to where we want to end up, the transition will
                    // animate to get there. We do this in an animation frame to
                    // give our starter setting a chance to fully render.
                    container.style["max-" + dimension] = shouldOpen ? sizeRef.current + "px" : 0;
                });
            });
        }
    }, [
        shouldOpen,
        shouldClose,
        containerRef,
        dimension,
        theme
    ]);
    (0, $2xPiy.useEffect)(function() {
        if (animate) {
            var container = containerRef.current;
            var timer = setTimeout(function() {
                setAnimate(false);
                container.removeAttribute('style');
            }, speed);
            return function() {
                return clearTimeout(timer);
            };
        }
        return undefined;
    // we need open here to cancel the timer and restart it
    }, [
        animate,
        containerRef,
        speed,
        open
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($9dcd345e1cd244f1$var$AnimatedBox, {
        "aria-hidden": !open,
        ref: containerRef,
        open: open,
        animate: animate,
        dimension: dimension,
        speedProp: speed,
        shouldOpen: !animate && shouldOpen
    }, shouldOpen || open || animate ? children : null);
});
$9dcd345e1cd244f1$export$6eb0f7ddcda6131f.displayName = 'Collapsible';
$9dcd345e1cd244f1$export$6eb0f7ddcda6131f.propTypes = (0, $b0697cfc8b393228$export$2c6a2ea456400009);



var $2xPiy = parcelRequire("2xPiy");


var $iA1nz = parcelRequire("iA1nz");

var $6b9b383459e65db7$var$sizeStyle = function sizeStyle(props) {
    // size is a combination of the level and size properties
    var size = props.size || 'medium';
    var headingTheme = props.theme.heading;
    var levelStyle = headingTheme.level[props.level];
    if (levelStyle) {
        var data = levelStyle[size];
        var styles = [
            (0, $iA1nz.css)([
                "font-size:",
                ";line-height:",
                ";max-width:",
                ";font-weight:",
                ";overflow-wrap:",
                ";"
            ], data ? data.size : size, data ? data.height : 'normal', props.fillProp && 'none' || data && data.maxWidth || levelStyle.medium.maxWidth, props.weight || levelStyle.font.weight || headingTheme.weight, props.overflowWrap)
        ];
        if (props.responsive && headingTheme.responsiveBreakpoint) {
            var breakpoint = props.theme.global.breakpoints[headingTheme.responsiveBreakpoint];
            if (breakpoint) {
                var responsiveData = headingTheme.level[props.level + 1] ? headingTheme.level[props.level + 1][size] : headingTheme.level[props.level][size];
                if (responsiveData) styles.push((0, $cdf517d38d72c2bc$export$2180d12f0a299a89)(breakpoint, "\n            font-size: " + responsiveData.size + ";\n            line-height: " + responsiveData.height + ";\n            max-width: " + (props.fillProp && 'none' || responsiveData.maxWidth) + ";\n          ", props.responsive));
            }
        }
        return styles;
    }
    console.warn("Heading level " + props.level + " is not defined in your theme.");
    return '';
};
var $6b9b383459e65db7$var$fontFamily = function fontFamily(props) {
    var _ref = props.theme.heading.level[props.level] || {}, font = _ref.font;
    if (font && font.family) return (0, $iA1nz.css)([
        "font-family:",
        ";"
    ], font.family);
    return props.theme.heading.font ? (0, $iA1nz.css)([
        "font-family:",
        ";"
    ], props.theme.heading.font.family) : '';
};
var $6b9b383459e65db7$var$truncateStyle = "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n";
var $6b9b383459e65db7$var$colorStyle = (0, $iA1nz.css)([
    "color:",
    ";"
], function(props) {
    return (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.colorProp || props.theme.heading.color, props.theme);
});
var $6b9b383459e65db7$export$8c1dfb3a3dfd5501 = (0, $iA1nz.default).h1.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledHeading",
    componentId: "sc-1rdh4aw-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], (0, $73ba8e2d301b823f$export$a157b298d219a801), function(props) {
    return $6b9b383459e65db7$var$fontFamily(props);
}, function(props) {
    return $6b9b383459e65db7$var$sizeStyle(props);
}, function(props) {
    return props.textAlign && (0, $73ba8e2d301b823f$export$4fc8e4871b69e1d6);
}, function(props) {
    return props.truncate && $6b9b383459e65db7$var$truncateStyle;
}, function(props) {
    return (props.colorProp || props.theme.heading.color) && $6b9b383459e65db7$var$colorStyle;
}, function(props) {
    return props.theme.heading && props.theme.heading.extend;
});



var $dyr1f = parcelRequire("dyr1f");

function $6096ca93f84cffa1$var$_extends() {
    return $6096ca93f84cffa1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6096ca93f84cffa1$var$_extends.apply(null, arguments);
}
var $6096ca93f84cffa1$var$PropType = {};
$6096ca93f84cffa1$var$PropType = $6096ca93f84cffa1$var$_extends({}, (0, $ab32ce3df36aa105$export$ffe37ff34eeb9e21), {
    color: (0, $ab32ce3df36aa105$export$fc4c368d97afb623),
    fill: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    level: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        1,
        2,
        3,
        4,
        5,
        6,
        '1',
        '2',
        '3',
        '4',
        '5',
        '6'
    ]),
    overflowWrap: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'normal',
            'break-word',
            'anywhere'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    responsive: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    textAlign: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'start',
        'center',
        'end',
        'justify'
    ]),
    truncate: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    weight: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'normal',
            'bold',
            'lighter',
            'bolder'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ])
});
var $6096ca93f84cffa1$export$c6750152f5d8efcb = $6096ca93f84cffa1$var$PropType;





var $2xPiy = parcelRequire("2xPiy");


function $4f870b5791fe65e9$var$_extends() {
    return $4f870b5791fe65e9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4f870b5791fe65e9$var$_extends.apply(null, arguments);
}
var $4f870b5791fe65e9$export$6db3fc939e78ca56 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var _theme$heading$level$;
    var as = _ref.as, _ref$level = _ref.level, level = _ref$level === void 0 ? 1 : _ref$level, _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, responsive = _ref.responsive;
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var height = ((_theme$heading$level$ = theme.heading.level[level]) == null || (_theme$heading$level$ = _theme$heading$level$[size]) == null ? void 0 : _theme$heading$level$.height) || size;
    var responsiveSize;
    if (responsive && theme.heading.responsiveBreakpoint) {
        var breakpoint = theme.global.breakpoints[theme.heading.responsiveBreakpoint];
        if (breakpoint) {
            var _theme$heading$level$2, _theme$heading$level$3;
            var responsiveHeight = theme.heading.level[level + 1] ? (_theme$heading$level$2 = theme.heading.level[level + 1][size]) == null ? void 0 : _theme$heading$level$2.height : (_theme$heading$level$3 = theme.heading.level[level][size]) == null ? void 0 : _theme$heading$level$3.height;
            responsiveSize = {
                breakpoint: breakpoint,
                height: responsiveHeight || height
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3c6eab35cbfc0e04$export$8f31e4c4a37b8e9c), $4f870b5791fe65e9$var$_extends({
        as: as,
        ref: ref,
        height: height,
        responsive: responsive,
        responsiveSize: responsiveSize
    }, theme.heading.skeleton));
});
$4f870b5791fe65e9$export$6db3fc939e78ca56.displayName = 'HeadingSkeleton';




var $e81502354812067e$var$_excluded = [
    "children",
    "color",
    "fill",
    "level",
    "overflowWrap",
    "responsive",
    "weight"
];
function $e81502354812067e$var$_extends() {
    return $e81502354812067e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e81502354812067e$var$_extends.apply(null, arguments);
}
function $e81502354812067e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $e81502354812067e$export$a8a3e93435678ff9 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref // munged to avoid styled-components putting it in the DOM
) {
    var children = _ref.children, color = _ref.color, fill = _ref.fill, _ref$level = _ref.level, level = _ref$level === void 0 ? 1 : _ref$level, overflowWrapProp = _ref.overflowWrap, _ref$responsive = _ref.responsive, responsiveProp = _ref$responsive === void 0 ? true : _ref$responsive, weight = _ref.weight, rest = $e81502354812067e$var$_objectWithoutPropertiesLoose(_ref, $e81502354812067e$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var headingRef = (0, $3cecef11d3b9c451$export$61dc559f8a0b9bcf)(ref);
    var _useState = (0, $2xPiy.useState)(overflowWrapProp || 'break-word'), overflowWrap = _useState[0], setOverflowWrap = _useState[1];
    var responsiveContainer = (0, $2xPiy.useContext)((0, $f328f122e8cc98b2$export$505da1fc32900905));
    var responsive = responsiveContainer && responsiveProp ? 'container' : responsiveProp;
    var skeleton = (0, $b03c62556e524549$export$9489db5f14593d18)();
    // handle overflowWrap of heading
    (0, $9462599f26e06396$export$e5c5a5f917a5871c)(function() {
        var updateOverflowWrap = function updateOverflowWrap() {
            var wrap;
            if (!overflowWrapProp && headingRef.current) {
                wrap = headingRef.current.scrollWidth > headingRef.current.offsetWidth ? 'anywhere' : 'break-word';
                setOverflowWrap(wrap);
            }
        };
        window.addEventListener('resize', updateOverflowWrap);
        updateOverflowWrap();
        return function() {
            return window.removeEventListener('resize', updateOverflowWrap);
        };
    }, [
        headingRef,
        overflowWrapProp
    ]);
    var content = children;
    if (skeleton) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $4f870b5791fe65e9$export$6db3fc939e78ca56), $e81502354812067e$var$_extends({
        level: level,
        fill: fill,
        responsive: responsive
    }, rest));
    return(/*#__PURE__*/ // enforce level to be a number
    (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $6b9b383459e65db7$export$8c1dfb3a3dfd5501), $e81502354812067e$var$_extends({
        as: "h" + level,
        colorProp: color,
        fillProp: fill,
        level: +level,
        overflowWrap: overflowWrap,
        responsive: responsive,
        weight: weight
    }, passThemeFlag, rest, {
        ref: headingRef
    }), content));
});
$e81502354812067e$export$a8a3e93435678ff9.displayName = 'Heading';
$e81502354812067e$export$a8a3e93435678ff9.propTypes = (0, $6096ca93f84cffa1$export$c6750152f5d8efcb);




var $dyr1f = parcelRequire("dyr1f");
var $bcf2c59dc7dff678$var$PropType = {};
$bcf2c59dc7dff678$var$PropType = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node
    ]),
    header: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node
};
var $bcf2c59dc7dff678$export$e0f57d1c561c3ce4 = $bcf2c59dc7dff678$var$PropType;



var $f178d3b6d5320b3a$var$_excluded = [
    "children",
    "header",
    "id",
    "label",
    "onClick",
    "onMouseOut",
    "onMouseOver",
    "onFocus",
    "onBlur"
];
function $f178d3b6d5320b3a$var$_extends() {
    return $f178d3b6d5320b3a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f178d3b6d5320b3a$var$_extends.apply(null, arguments);
}
function $f178d3b6d5320b3a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $f178d3b6d5320b3a$export$7cad6f17fd6e117b = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var _theme$accordion$labe, _theme$accordion$icon;
    var children = _ref.children, header = _ref.header, id = _ref.id, label = _ref.label, onClick = _ref.onClick, _onMouseOut = _ref.onMouseOut, _onMouseOver = _ref.onMouseOver, _onFocus = _ref.onFocus, _onBlur = _ref.onBlur, rest = $f178d3b6d5320b3a$var$_objectWithoutPropertiesLoose(_ref, $f178d3b6d5320b3a$var$_excluded);
    var panelButtonId = (0, $6b7eb3480858eeaa$export$f680877a34711e37)();
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useContext = (0, $2xPiy.useContext)((0, $97b849b107eeb84a$export$6bd5bb82c987ab74)), active = _useContext.active, animate = _useContext.animate, level = _useContext.level, onPanelChange = _useContext.onPanelChange;
    var _useState = (0, $2xPiy.useState)(undefined), hover = _useState[0], setHover = _useState[1];
    var _useState2 = (0, $2xPiy.useState)(), focus = _useState2[0], setFocus = _useState2[1];
    var iconColor = (0, $2xPiy.useMemo)(function() {
        return (0, $11317b0e49e0d157$export$4cde5df63f53f473)(theme.accordion.icons.color || 'control', theme);
    }, [
        theme
    ]);
    var AccordionIcon = (0, $2xPiy.useMemo)(function() {
        return active ? theme.accordion.icons.collapse : theme.accordion.icons.expand;
    }, [
        active,
        theme.accordion.icons
    ]);
    var defaultHoverColor = JSON.stringify({
        dark: 'light-4',
        light: 'dark-3'
    });
    // accordion.hover.color will be deprecated in v3.
    if (JSON.stringify(theme.accordion.hover.color) !== defaultHoverColor) console.warn("The theme style for accordion.hover.color is deprecated,\n        use accordion.hover.heading.color instead.");
    // accordion.hover.heading.color will trump accordion.hover.color in case
    // the user sets its value to be any other value than the
    // default value (defaultHoverColor).
    // accordion.hover.color will be deprecated in v3.
    var headingColor = theme.accordion.hover && JSON.stringify(theme.accordion.hover.heading.color) !== defaultHoverColor ? theme.accordion.hover.heading.color : theme.accordion.hover.color;
    var contentBorder = theme.accordion.border;
    var panelBorder = theme.accordion.panel.border;
    var abutMargin;
    if (panelBorder) // abutMargin 'bottom' is set to overlap adjacent border panels
    abutMargin = {
        bottom: "-" + (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(// in case border.size defined as a t-shirt size
        // or in case border size is a custom size i.e. '5px'
        theme.global.borderSize[panelBorder.size] || panelBorder.size || theme.global.borderSize.xsmall // '-1px'
        ) + "px"
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        ref: ref,
        flex: false,
        onClick: onClick,
        border: panelBorder,
        margin: abutMargin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
        id: panelButtonId,
        "aria-expanded": active,
        plain: theme.button["default"] ? true : undefined,
        onClick: onPanelChange,
        hoverIndicator: theme.accordion.hover.background,
        onMouseOver: function onMouseOver(event) {
            setHover(headingColor);
            if (_onMouseOver) _onMouseOver(event);
        },
        onMouseOut: function onMouseOut(event) {
            setHover(undefined);
            if (_onMouseOut) _onMouseOut(event);
        },
        onFocus: function onFocus(event) {
            setHover(headingColor);
            setFocus(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setHover(undefined);
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        style: focus ? {
            zIndex: 1
        } : undefined
    }, header || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), $f178d3b6d5320b3a$var$_extends({
        align: "center",
        direction: "row",
        justify: "between",
        id: id
    }, rest), typeof label === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        pad: (_theme$accordion$labe = theme.accordion.label) == null || (_theme$accordion$labe = _theme$accordion$labe.container) == null ? void 0 : _theme$accordion$labe.pad
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $e81502354812067e$export$a8a3e93435678ff9), {
        level: level || theme.accordion.heading && theme.accordion.heading.level || 4,
        margin: theme.accordion.heading && theme.accordion.heading.margin || undefined,
        color: hover
    }, label)) : label, AccordionIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        pad: (_theme$accordion$icon = theme.accordion.icon) == null || (_theme$accordion$icon = _theme$accordion$icon.container) == null ? void 0 : _theme$accordion$icon.pad,
        width: {
            min: 'fit-content'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(AccordionIcon, {
        color: iconColor
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        role: "region",
        border: contentBorder,
        "aria-labelledby": panelButtonId
    }, animate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $9dcd345e1cd244f1$export$6eb0f7ddcda6131f), {
        open: active
    }, children) : active && children));
});
$f178d3b6d5320b3a$export$7cad6f17fd6e117b.displayName = 'AccordionPanel';
$f178d3b6d5320b3a$export$7cad6f17fd6e117b.propTypes = (0, $bcf2c59dc7dff678$export$e0f57d1c561c3ce4);





var $2xPiy = parcelRequire("2xPiy");




const $13443f13855b5fd3$export$bf1fd9d74e401141 = ({ referralCommissions: initialReferralCommissions, isYearly: isYearly = false })=>{
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const [referralCommissions, setReferralCommissions] = (0, $2xPiy.useState)(initialReferralCommissions || []);
    (0, $2xPiy.useEffect)(()=>{
        if (initialReferralCommissions) setReferralCommissions(initialReferralCommissions);
    }, [
        initialReferralCommissions
    ]);
    return !referralCommissions ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
        pad: {
            horizontal: '1.5rem'
        },
        columns: [
            {
                property: 'referral_partner',
                primary: true,
                size: '35%',
                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                    children: t('commissions:referralPartner')
                }),
                render: (referralCommission)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        children: referralCommission.referral_partner?.name || "\u2014"
                    })
            },
            {
                property: 'percent_rate',
                size: '32%',
                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                    children: t('commissions:percentage')
                }),
                render: (referralCommission)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                        boxProps: {
                            pad: {
                                vertical: '1rem'
                            }
                        },
                        children: referralCommission.isEditing ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8c9c99ffe8765a99$export$c86715117507e8e5), {
                            type: "number",
                            value: referralCommission.editedPercentRate ?? referralCommission.percent_rate.toString(),
                            onChange: (e)=>{
                                const value = e.target.value;
                                if (value === '' || /^\d*\.?\d*$/.test(value)) setReferralCommissions((prev)=>prev.map((c)=>c.id === referralCommission.id ? {
                                            ...c,
                                            editedPercentRate: value
                                        } : c));
                            },
                            style: {
                                width: '80px'
                            }
                        }) : `${referralCommission.percent_rate}%`
                    })
            },
            {
                property: 'start_reporting_quarter',
                size: '16%',
                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                    children: t('commissions:effectiveStartDate')
                }),
                render: (referralCommission)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                        children: (0, $00658ccd6ec0135a$export$f96ebb633255a704)(referralCommission.start_reporting_quarter, isYearly)
                    })
            },
            {
                property: 'end_reporting_quarter',
                size: '16%',
                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                    children: t('commissions:effectiveEndDate')
                }),
                render: (referralCommission)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                        children: referralCommission.end_reporting_quarter === '2999-10-01' ? "\u2014" : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            children: (0, $00658ccd6ec0135a$export$f96ebb633255a704)(referralCommission.end_reporting_quarter, isYearly)
                        })
                    })
            }
        ],
        data: referralCommissions,
        background: [
            'light-6',
            'white'
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");




const $a31a3deed070de50$export$58dfb95cf1fbf160 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(({ onClose: onClose, onSubmit: onSubmit, isLoading: isLoading })=>{
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const [referralPartnerId, setReferralPartnerId] = (0, $2xPiy.useState)(null);
    const [percentRate, setPercentRate] = (0, $2xPiy.useState)('');
    const [isSubmitting, setIsSubmitting] = (0, $2xPiy.useState)(false);
    const [referralPartners, setReferralPartners] = (0, $2xPiy.useState)([]);
    const [isLoadingPartners, setIsLoadingPartners] = (0, $2xPiy.useState)(true);
    (0, $2xPiy.useEffect)(()=>{
        const loadReferralPartners = async ()=>{
            try {
                setIsLoadingPartners(true);
                await globalStore.fetchReferralPartners();
                setReferralPartners(globalStore.referralPartners || []);
            } catch (error) {
                console.error('Failed to load referral partners:', error);
            } finally{
                setIsLoadingPartners(false);
            }
        };
        loadReferralPartners();
    }, [
        globalStore
    ]);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (referralPartnerId === null) return;
        try {
            setIsSubmitting(true);
            await onSubmit(referralPartnerId, percentRate);
            onClose();
        } catch (error) {
            console.error('Error in onSubmit:', error);
        } finally{
            setIsSubmitting(false);
        }
    };
    const partnerOptions = referralPartners.map((partner)=>({
            label: partner.name,
            value: partner.id
        }));
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
        background: "transparent",
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
            width: "100%",
            style: {
                maxWidth: 480,
                minWidth: 320
            },
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                    title: "Add Referral Commission"
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                    pad: {
                        vertical: 'medium',
                        horizontal: 'large'
                    },
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("form", {
                        onSubmit: handleSubmit,
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            gap: "medium",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                    id: "referral_partner_id",
                                    name: "referral_partner_id",
                                    label: "Referral Partner",
                                    value: referralPartnerId,
                                    onChange: ({ value: value })=>setReferralPartnerId(Number(value)),
                                    options: partnerOptions,
                                    placeholder: "Select a referral partner",
                                    required: true,
                                    disabled: isLoading || isLoadingPartners
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $eabeffcc0be0175a$export$dec03dc0f3ef8025), {
                                    label: "Commission Rate (%)",
                                    value: percentRate,
                                    setValue: setPercentRate,
                                    componentType: "percent",
                                    placeholder: "0.00",
                                    required: true,
                                    disabled: isLoading || isSubmitting
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    direction: "row",
                                    justify: "end",
                                    gap: "small",
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                            label: "Cancel",
                                            onClick: onClose,
                                            disabled: isLoading || isSubmitting,
                                            style: {
                                                fontWeight: 'normal'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                            type: "submit",
                                            primary: true,
                                            label: isSubmitting ? 'Adding...' : 'Add Commission',
                                            disabled: referralPartnerId === null || !percentRate || isLoading || isSubmitting,
                                            style: {
                                                fontWeight: 'normal'
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
});




var $2xPiy = parcelRequire("2xPiy");




const $0f39389fcf976cc0$export$fd800575d5f4f75 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(({ onClose: onClose, onSubmit: onSubmit, isLoading: isLoading })=>{
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const [userId, setUserId] = (0, $2xPiy.useState)(null);
    const [percentRate, setPercentRate] = (0, $2xPiy.useState)('');
    const [isSubmitting, setIsSubmitting] = (0, $2xPiy.useState)(false);
    (0, $2xPiy.useEffect)(()=>{
        userStore.fetchUsers({
            is_internal: true
        });
    }, [
        userStore
    ]);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (userId === null) return;
        try {
            setIsSubmitting(true);
            await onSubmit(userId, percentRate);
            onClose();
        } catch (error) {
            console.error('Error in onSubmit:', error);
        } finally{
            setIsSubmitting(false);
        }
    };
    const userOptions = userStore.users.map((user)=>({
            label: user.name,
            value: user.id
        }));
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
        background: "transparent",
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
            width: "100%",
            style: {
                maxWidth: 480,
                minWidth: 320
            },
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                    title: "Add Sales Commission"
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                    pad: {
                        vertical: 'medium',
                        horizontal: 'large'
                    },
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("form", {
                        onSubmit: handleSubmit,
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            gap: "medium",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                    id: "user_id",
                                    name: "user_id",
                                    label: "Salesperson",
                                    value: userId,
                                    onChange: (e)=>setUserId(Number(e.value)),
                                    options: userOptions,
                                    placeholder: "Select a salesperson",
                                    required: true,
                                    disabled: isLoading
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $eabeffcc0be0175a$export$dec03dc0f3ef8025), {
                                    label: "Commission Rate (%)",
                                    value: percentRate,
                                    setValue: setPercentRate,
                                    componentType: "percent",
                                    placeholder: "0.00",
                                    required: true
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    direction: "row",
                                    justify: "end",
                                    gap: "small",
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                            label: "Cancel",
                                            onClick: onClose,
                                            disabled: isLoading || isSubmitting,
                                            style: {
                                                fontWeight: 'normal'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                            type: "submit",
                                            primary: true,
                                            label: isSubmitting ? 'Adding...' : 'Add Commission',
                                            disabled: userId === null || !percentRate || isLoading || isSubmitting,
                                            style: {
                                                fontWeight: 'normal'
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
});







const $ae84c926caf84bce$export$59a928bbf298277f = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { id: id, title: title, clientId: clientId, clientPrograms: clientProgramsProp, salesCommissions: salesCommissionsProp, referralCommissions: referralCommissionsProp } = props;
    /** Context **/ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const clientStore = (0, $116967e0234c3770$export$3b47afa599c78f61)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** State **/ const [clientPrograms, setClientPrograms] = (0, $2xPiy.useState)();
    const [salesCommissions, setSalesCommissions] = (0, $2xPiy.useState)();
    const [activeIndexes, setActiveIndexes] = (0, $2xPiy.useState)([
        0,
        1,
        2
    ]);
    const [isAddingSalesCommission, setIsAddingSalesCommission] = (0, $2xPiy.useState)(false);
    const [showAddSalesModal, setShowAddSalesModal] = (0, $2xPiy.useState)(false);
    const [isAddingReferralCommission, setIsAddingReferralCommission] = (0, $2xPiy.useState)(false);
    const [showAddReferralModal, setShowAddReferralModal] = (0, $2xPiy.useState)(false);
    const [referralCommissions, setReferralCommissions] = (0, $2xPiy.useState)([]);
    const [reportingPeriodTypeId, setReportingPeriodTypeId] = (0, $2xPiy.useState)(clientStore.selectedClient?.reporting_period_type_id);
    /** Computed **/ const isLoading = !clientPrograms || !salesCommissions;
    const isYearly = reportingPeriodTypeId === (0, $0badf5665deea2b2$export$a121e4a6c908fa8f).Yearly;
    /** Methods **/ const fetchCommissions = ()=>{
        if (!userStore.isInternalUser) return;
        if (clientProgramsProp && salesCommissionsProp && referralCommissionsProp) {
            setClientPrograms(clientProgramsProp);
            setSalesCommissions(salesCommissionsProp);
            setReferralCommissions(referralCommissionsProp);
            setReportingPeriodTypeId(clientStore.selectedClient?.reporting_period_type_id);
        } else if (clientId) (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).get({
            id: clientId
        }).then((client)=>{
            setClientPrograms(client.client_programs);
            setSalesCommissions(client.sales_commission_rates);
            setReportingPeriodTypeId(client.reporting_period_type_id);
        }).catch((err)=>globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).generic.error));
    };
    const handleAddSalesCommission = async (userId, percentRate)=>{
        if (!clientId || !clientStore.selectedClient) {
            console.error('No client or clientId available, cannot add commission');
            return;
        }
        try {
            setIsAddingSalesCommission(true);
            const startQuarter = clientStore.selectedClient.first_active_reporting_quarter;
            const requestData = {
                user_id: userId,
                percent_rate: parseFloat(percentRate),
                reporting_period_type_id: 1,
                start_reporting_quarter: startQuarter,
                end_reporting_quarter: null
            };
            await (0, $48810180e2a8cd58$export$98959fd4ac26ac2e).createSalesCommission({
                client_id: clientId,
                ...requestData
            });
            fetchCommissions();
        } catch (error) {
            console.error('Error adding sales commission:', error);
        } finally{
            setIsAddingSalesCommission(false);
        }
    };
    const handleAddReferralCommission = async (referralPartnerId, percentRate)=>{
        if (!clientId || !clientStore.selectedClient) {
            console.error('No client or clientId available, cannot add commission');
            return;
        }
        try {
            setIsAddingReferralCommission(true);
            const startQuarter = clientStore.selectedClient.first_active_reporting_quarter;
            const requestData = {
                client_id: clientId,
                referral_partner_id: referralPartnerId,
                percent_rate: parseFloat(percentRate),
                reporting_period_type_id: 1,
                start_reporting_quarter: startQuarter,
                end_reporting_quarter: null
            };
            await (0, $7d36359e85b6c632$export$f92f70e00c5fb03f).createReferralCommission(requestData);
            fetchCommissions();
        } catch (error) {
            console.error('Error adding referral commission:', error);
        } finally{
            setIsAddingReferralCommission(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (isLoading) fetchCommissions();
    }, [
        isLoading
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        id: id,
        direction: "row",
        gap: "medium",
        fill: "horizontal",
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                        title: title || 'Commission List',
                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $17a6c81a21a52d65$export$7794b6b29774c086), {})
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $fdccc762800a972d$export$851de33184ecdac4), {
                        pad: "none",
                        gap: "none",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            elevation: "small",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $972a591c1e48136a$export$a766cd26d0d69044), {
                                activeIndex: activeIndexes,
                                onActive: (activeIndexes)=>setActiveIndexes(activeIndexes),
                                multiple: true,
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f178d3b6d5320b3a$export$7cad6f17fd6e117b), {
                                        label: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            pad: "medium",
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "large",
                                                children: t('commissions:fuseCommissions')
                                            })
                                        }),
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e952f2d0a96461b9$export$ecaf5239346df5c3), {
                                            clientPrograms: clientPrograms,
                                            isYearly: isYearly
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f178d3b6d5320b3a$export$7cad6f17fd6e117b), {
                                        label: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            direction: "row",
                                            justify: "between",
                                            align: "center",
                                            pad: "medium",
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "large",
                                                children: t('commissions:salesCommissions')
                                            })
                                        }),
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c895a16235caaf48$export$320d418bc78de869), {
                                            salesCommissions: salesCommissions,
                                            isYearly: isYearly
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f178d3b6d5320b3a$export$7cad6f17fd6e117b), {
                                        label: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            direction: "row",
                                            justify: "between",
                                            align: "center",
                                            pad: "medium",
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "large",
                                                children: t('commissions:referralCommissions')
                                            })
                                        }),
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $13443f13855b5fd3$export$bf1fd9d74e401141), {
                                            referralCommissions: referralCommissions,
                                            isYearly: isYearly
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            showAddSalesModal && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $0f39389fcf976cc0$export$fd800575d5f4f75), {
                onClose: ()=>setShowAddSalesModal(false),
                onSubmit: handleAddSalesCommission,
                isLoading: isAddingSalesCommission
            }),
            showAddReferralModal && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $a31a3deed070de50$export$58dfb95cf1fbf160), {
                onClose: ()=>setShowAddReferralModal(false),
                onSubmit: handleAddReferralCommission,
                isLoading: isAddingReferralCommission
            })
        ]
    });
});



parcelRequire("2xPiy");




const $e952f2d0a96461b9$export$ecaf5239346df5c3 = ({ clientPrograms: clientPrograms, isYearly: isYearly = false })=>{
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    return !clientPrograms ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
        pad: {
            horizontal: '1.5rem'
        },
        columns: [
            {
                property: 'name',
                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                    children: t('common:program')
                }),
                primary: true,
                size: '35%',
                render: (clientProgram)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        children: clientProgram.program.name
                    })
            },
            {
                property: 'percent_rate',
                size: '16%',
                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                    children: t('commissions:percentage')
                }),
                render: (clientProgram)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                        boxProps: {
                            pad: {
                                vertical: '1rem'
                            }
                        },
                        children: clientProgram.percent_rate ? `${clientProgram.percent_rate}%` : "\u2014"
                    })
            },
            {
                property: 'fixed_kwh_rate',
                size: '16%',
                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                    children: t('commissions:fixedRate')
                }),
                render: (clientProgram)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                        boxProps: {
                            pad: {
                                vertical: '1rem'
                            }
                        },
                        children: clientProgram.fixed_kwh_rate ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            row: true,
                            gap: "xsmall",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    children: [
                                        "$",
                                        `${clientProgram.fixed_kwh_rate}`
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    children: "/ kWh"
                                })
                            ]
                        }) : "\u2014"
                    })
            },
            {
                property: 'start_reporting_quarter',
                size: '16%',
                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                    children: t('commissions:effectiveStartDate')
                }),
                render: (clientProgram)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                        children: (0, $00658ccd6ec0135a$export$f96ebb633255a704)(clientProgram.start_reporting_quarter, isYearly)
                    })
            },
            {
                property: 'end_reporting_quarter',
                size: '16%',
                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                    children: t('commissions:effectiveEndDate')
                }),
                render: (clientProgram)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                        children: clientProgram.end_reporting_quarter === '2999-10-01' ? "\u2014" : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            children: (0, $00658ccd6ec0135a$export$f96ebb633255a704)(clientProgram.end_reporting_quarter, isYearly)
                        })
                    })
            }
        ],
        data: clientPrograms,
        background: [
            'light-6',
            'white'
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");




const $c895a16235caaf48$export$320d418bc78de869 = ({ salesCommissions: initialSalesCommissions, isYearly: isYearly = false })=>{
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const [salesCommissions, setSalesCommissions] = (0, $2xPiy.useState)(initialSalesCommissions || []);
    (0, $2xPiy.useEffect)(()=>{
        if (initialSalesCommissions) setSalesCommissions(initialSalesCommissions);
    }, [
        initialSalesCommissions
    ]);
    return !salesCommissions ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
        pad: {
            horizontal: '1.5rem'
        },
        columns: [
            {
                property: 'name',
                primary: true,
                size: '35%',
                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                    children: t('common:name')
                }),
                render: (salesCommission)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                        to: `/users/${salesCommission.user.id}`,
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            weight: 500,
                            color: "accent-1",
                            children: salesCommission.user.name
                        })
                    })
            },
            {
                property: 'percent_rate',
                size: '32%',
                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                    children: t('commissions:percentage')
                }),
                render: (salesCommission)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                        boxProps: {
                            pad: {
                                vertical: '1rem'
                            }
                        },
                        children: salesCommission.isEditing ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8c9c99ffe8765a99$export$c86715117507e8e5), {
                            type: "number",
                            value: salesCommission.editedPercentRate !== undefined ? salesCommission.editedPercentRate : salesCommission.percent_rate.toString(),
                            onChange: (e)=>{
                                const value = e.target.value;
                                if (value === '' || /^\d*\.?\d*$/.test(value)) setSalesCommissions((prev)=>prev.map((c)=>c.id === salesCommission.id ? {
                                            ...c,
                                            editedPercentRate: value
                                        } : c));
                            },
                            style: {
                                width: '80px'
                            }
                        }) : `${salesCommission.percent_rate}%`
                    })
            },
            {
                property: 'start_reporting_quarter',
                size: '16%',
                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                    children: t('commissions:effectiveStartDate')
                }),
                render: (salesCommission)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                        children: (0, $00658ccd6ec0135a$export$f96ebb633255a704)(salesCommission.start_reporting_quarter, isYearly)
                    })
            },
            {
                property: 'end_reporting_quarter',
                size: '16%',
                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                    children: t('commissions:effectiveEndDate')
                }),
                render: (salesCommission)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                        children: salesCommission.end_reporting_quarter === '2999-10-01' ? "\u2014" : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            children: (0, $00658ccd6ec0135a$export$f96ebb633255a704)(salesCommission.end_reporting_quarter, isYearly)
                        })
                    })
            }
        ],
        data: salesCommissions,
        background: [
            'light-6',
            'white'
        ]
    });
};







var $2xPiy = parcelRequire("2xPiy");


var $2xPiy = parcelRequire("2xPiy");
const $6ce7268813681708$export$b8efcc4bff45e15b = 1;
function $6ce7268813681708$export$fb237fa819e17281(map) {
    return Object.freeze({
        __version: $6ce7268813681708$export$b8efcc4bff45e15b,
        map: map
    });
}
function $6ce7268813681708$export$9efaf186a2224858(source, extra) {
    return Object.freeze({
        ...source,
        ...extra
    });
}
const $6ce7268813681708$export$7de1b54b0142048f = (0, $2xPiy.createContext)(null);
function $6ce7268813681708$export$ea59151b8430a4e9() {
    const context = (0, $2xPiy.use)($6ce7268813681708$export$7de1b54b0142048f);
    if (context == null) throw new Error('No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>');
    return context;
}


var $49be9010cfb85667$exports = {};
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory($49be9010cfb85667$exports);
})($49be9010cfb85667$exports, function(exports1) {
    'use strict';
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!('_leaflet_id' in obj)) obj['_leaflet_id'] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, 'options')) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf('?') === -1 ? '?' : '&') + params.join('&');
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error('No value provided for variable ' + str);
            else if (typeof value === 'function') value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window['webkit' + name] || window['moz' + name] || window['ms' + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') || getPrefixed('CancelRequestAnimationFrame') || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== 'prototype' && i !== '__super__') NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === 'function' ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === 'undefined' || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === 'object') for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== 'string') console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== 'function') {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return 'Point(' + formatNum(this.x) + ', ' + formatNum(this.y) + ')';
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === 'object' && 'x' in x && 'y' in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === 'number' || 'x' in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === 'number' || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(',');
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return 'LatLng(' + formatNum(this.lat, precision) + ', ' + formatNum(this.lng, precision) + ')';
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== 'object') {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === 'object' && 'lat' in a) return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: 'EPSG:3857',
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: 'EPSG:900913'
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS('http://www.w3.org/2000/svg', name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = '', i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? 'z' : 'x' : '';
        }
        // SVG complains about empty path strings
        return str || 'M0 0';
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = 'ActiveXObject' in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains('webkit');
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains('android');
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains('android 2') || userAgentContains('android 3');
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains('chrome');
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains('safari');
    var phantom = userAgentContains('phantom');
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = 'OTransition' in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf('Win') === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && 'transition' in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = 'MozPerspective' in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = 'ontouchstart' in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener('testPassiveEventSupport', falseFn, opts);
            window.removeEventListener('testPassiveEventSupport', falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement('canvas').getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate('svg').createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement('div');
        div.innerHTML = '<svg/>';
        return (div.firstChild && div.firstChild.namespaceURI) === 'http://www.w3.org/2000/svg';
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement('div');
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = 'url(#default#VML)';
            return shape && typeof shape.adj === 'object';
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf('Mac') === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf('Linux') === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? 'MSPointerDown' : 'pointerdown';
    var POINTER_MOVE = Browser.msPointer ? 'MSPointerMove' : 'pointermove';
    var POINTER_UP = Browser.msPointer ? 'MSPointerUp' : 'pointerup';
    var POINTER_CANCEL = Browser.msPointer ? 'MSPointerCancel' : 'pointercancel';
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === 'touchstart') _addPointerDocListener();
        if (!handle[type]) {
            console.warn('wrong event specified:', type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn('wrong event specified:', type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse')) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = 'dblclick';
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener('dblclick', handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === 'mouse' || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener('click', simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener('dblclick', handlers.dblclick);
        obj.removeEventListener('click', handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        'transform',
        'webkitTransform',
        'OTransform',
        'MozTransform',
        'msTransform'
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        'webkitTransition',
        'transition',
        'OTransition',
        'MozTransition',
        'msTransition'
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === 'string' ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === 'auto') && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === 'auto' ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || '';
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + ' ' : '') + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ('opacity' in el.style) el.style.opacity = value;
        else if ('filter' in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = 'DXImageTransform.Microsoft.Alpha';
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + 'px';
            el.style.top = point.y + 'px';
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ('onselectstart' in document) {
        disableTextSelection = function() {
            on(window, 'selectstart', preventDefault);
        };
        enableTextSelection = function() {
            off(window, 'selectstart', preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            'userSelect',
            'WebkitUserSelect',
            'OUserSelect',
            'MozUserSelect',
            'msUserSelect'
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = 'none';
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, 'dragstart', preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, 'dragstart', preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = 'none';
        on(window, 'keydown', restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, 'keydown', restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === 'object') for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = '_leaflet_events';
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === 'object') for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout',
        wheel: !('onwheel' in window) && 'mousewheel'
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') handler = addDoubleTapListener(obj, handler);
        else if ('addEventListener' in obj) {
            if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' || type === 'mousewheel') obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === 'mouseenter' || type === 'mouseleave') {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent('on' + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? '_' + stamp(context) : '');
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') removeDoubleTapListener(obj, handler);
        else if ('removeEventListener' in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent('on' + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, 'wheel', stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, 'mousedown touchstart dblclick contextmenu', stopPropagation);
        el['_leaflet_disable_click'] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire('start');
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire('step');
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire('end');
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === 'number' ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error('Bounds are not valid.');
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire('moveend');
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    'step': this._onPanTransitionStep,
                    'end': this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire('movestart');
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, 'leaflet-pan-anim');
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire('move').fire('moveend');
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens('moveend', this._panInsideMaxBounds)) this.off('moveend', this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on('moveend', this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire('move');
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
                } else this.fire('moveend');
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire('resize', {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire('viewreset');
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!('geolocation' in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: 'Geolocation not supported.'
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? 'permission denied' : c === 2 ? 'position unavailable' : 'timeout');
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire('locationerror', {
                code: c,
                message: 'Geolocation error: ' + message + '.'
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === 'number') data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire('locationfound', data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off('moveend', this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error('Map container is being reused by another instance');
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire('unload');
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''), pane = create$1('div', className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === 'string' ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error('Map container not found.');
            else if (container._leaflet_id) throw new Error('Map container is already initialized.');
            on(container, 'scroll', this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, 'leaflet-container' + (Browser.touch ? ' leaflet-touch' : '') + (Browser.retina ? ' leaflet-retina' : '') + (Browser.ielt9 ? ' leaflet-oldie' : '') + (Browser.safari ? ' leaflet-safari' : '') + (this._fadeAnimated ? ' leaflet-fade-anim' : ''));
            var position = getStyle(container, 'position');
            if (position !== 'absolute' && position !== 'relative' && position !== 'fixed' && position !== 'sticky') container.style.position = 'relative';
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane('mapPane', this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane('tilePane');
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane('overlayPane');
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane('shadowPane');
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane('markerPane');
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane('tooltipPane');
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane('popupPane');
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, 'leaflet-zoom-hide');
                addClass(panes.shadowPane, 'leaflet-zoom-hide');
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire('viewprereset');
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire('viewreset');
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire('load');
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire('zoomstart');
            if (!noMoveStart) this.fire('movestart');
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire('zoom', data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire('move', data);
            } else if (data && data.pinch) this.fire('zoom', data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire('zoomend');
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire('moveend');
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error('Set map center and zoom first.');
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, 'resize', this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === 'mouseout' || type === 'mouseover', src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === 'click' || type === 'preclick') && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el['_leaflet_disable_click']) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el['_leaflet_disable_events'] || e.type === 'click' && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === 'mousedown') // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            'click',
            'dblclick',
            'mouseover',
            'mouseout',
            'contextmenu'
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === 'click') {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = 'preclick';
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === 'contextmenu') preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on('load', callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire('move');
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, 'leaflet-pan-anim');
            this.fire('moveend');
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
            this._panes.mapPane.appendChild(proxy);
            this.on('zoomanim', function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on('load moveend', this._animMoveEnd, this);
            this._on('unload', this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off('load moveend', this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, 'leaflet-zoom-anim');
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire('zoomanim', {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, 'leaflet-zoom-anim');
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire('zoom');
            delete this._tempFireZoomEvent;
            this.fire('move');
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: 'topright'
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, 'leaflet-control');
            if (pos.indexOf('bottom') !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on('unload', this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off('unload', this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = 'leaflet-', container = this._controlContainer = create$1('div', l + 'control-container', this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + ' ' + l + hSide;
                corners[vSide + hSide] = create$1('div', className, container);
            }
            createCorner('top', 'left');
            createCorner('top', 'right');
            createCorner('bottom', 'left');
            createCorner('bottom', 'right');
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: 'topright',
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on('add remove', this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off('add remove', this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off('add remove', this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, 'leaflet-control-layers-expanded');
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, 'leaflet-control-layers-scrollbar');
                this._section.style.height = acceptableHeight + 'px';
            } else removeClass(this._section, 'leaflet-control-layers-scrollbar');
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, 'leaflet-control-layers-expanded');
            return this;
        },
        _initLayout: function() {
            var className = 'leaflet-control-layers', container = this._container = create$1('div', className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute('aria-haspopup', true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1('section', className + '-list');
            if (collapsed) {
                this._map.on('click', this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1('a', className + '-toggle', container);
            link.href = '#';
            link.title = 'Layers';
            link.setAttribute('role', 'button');
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1('div', className + '-base', section);
            this._separator = create$1('div', className + '-separator', section);
            this._overlaysList = create$1('div', className + '-overlays', section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on('add remove', this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === 'add' ? 'overlayadd' : 'overlayremove' : e.type === 'add' ? 'baselayerchange' : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : '') + '/>';
            var radioFragment = document.createElement('div');
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement('label'), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement('input');
                input.type = 'checkbox';
                input.className = 'leaflet-control-layers-selector';
                input.defaultChecked = checked;
            } else input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, 'click', this._onInputClick, this);
            var name = document.createElement('span');
            name.innerHTML = ' ' + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement('span');
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, 'click', preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, 'click', preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: 'topleft',
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: 'Zoom in',
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: 'Zoom out'
        },
        onAdd: function(map) {
            var zoomName = 'leaflet-control-zoom', container = create$1('div', zoomName + ' leaflet-bar'), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + '-in', container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + '-out', container, this._zoomOut);
            this._updateDisabled();
            map.on('zoomend zoomlevelschange', this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off('zoomend zoomlevelschange', this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1('a', className, container);
            link.innerHTML = html;
            link.href = '#';
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute('role', 'button');
            link.setAttribute('aria-label', title);
            disableClickPropagation(link);
            on(link, 'click', stop);
            on(link, 'click', fn, this);
            on(link, 'click', this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = 'leaflet-disabled';
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute('aria-disabled', 'false');
            this._zoomOutButton.setAttribute('aria-disabled', 'false');
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute('aria-disabled', 'true');
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute('aria-disabled', 'true');
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: 'bottomleft',
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = 'leaflet-control-scale', container = create$1('div', className), options = this.options;
            this._addScales(options, className + '-line', container);
            map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1('div', className, container);
            if (options.imperial) this._iScale = create$1('div', className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + ' m' : meters / 1000 + ' km';
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: 'bottomright',
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + ' ' : '') + 'Leaflet</a>'
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1('div', 'leaflet-control-attribution');
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on('layeradd', this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off('layeradd', this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once('remove', function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(', '));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? 'touchstart mousedown' : 'mousedown';
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, 'leaflet-zoom-anim')) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire('down');
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === 'mousedown';
            on(document, mouseevent ? 'mousemove' : 'touchmove', this._onMove, this);
            on(document, mouseevent ? 'mouseup' : 'touchend touchcancel', this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire('dragstart');
                this._moved = true;
                addClass(document.body, 'leaflet-dragging');
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, 'leaflet-drag-target');
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire('predrag', e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire('drag', e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, 'leaflet-dragging');
            if (this._lastTarget) {
                removeClass(this._lastTarget, 'leaflet-drag-target');
                this._lastTarget = null;
            }
            off(document, 'mousemove touchmove', this._onMove, this);
            off(document, 'mouseup touchend touchcancel', this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire('dragend', {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined';
    }
    function _flat(latlngs) {
        console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: 'EPSG:3395',
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: 'EPSG:4326',
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: 'overlayPane',
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once('remove', function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire('add');
            map.fire('layeradd', {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error('The provided object is not a Layer.');
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire('layerremove', {
                    layer: layer
                });
                layer.fire('remove');
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire('zoomlevelschange');
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === 'number' ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke('setZIndex', zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire('layeradd', {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire('layerremove', {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke('setStyle', style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke('bringToFront');
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke('bringToBack');
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon('icon', oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon('shadow', oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === 'icon') throw new Error('iconUrl not set in Icon options (see the docs).');
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + 'Size'];
            if (typeof sizeOption === 'number') sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
            if (anchor) {
                img.style.marginLeft = -anchor.x + 'px';
                img.style.marginTop = -anchor.y + 'px';
            }
            if (size) {
                img.style.width = size.x + 'px';
                img.style.height = size.y + 'px';
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement('img');
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: 'marker-icon.png',
            iconRetinaUrl: 'marker-icon-2x.png',
            shadowUrl: 'marker-shadow.png',
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== 'string') IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1('div', 'leaflet-default-icon-path', document.body);
            var path = getStyle(el, 'background-image') || getStyle(el, 'backgroundImage'); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return '';
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, 'leaflet-marker-draggable');
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, 'leaflet-marker-draggable');
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire('movestart').fire('dragstart');
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire('move', e).fire('drag', e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire('moveend').fire('dragend', e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: '',
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: 'Marker',
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: 'markerPane',
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: 'shadowPane',
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on('zoomanim', this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off('zoomanim', this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === 'IMG') icon.alt = options.alt || '';
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = '0';
                icon.setAttribute('role', 'button');
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, 'focus', this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = '';
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, 'focus', this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, 'leaflet-interactive');
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: '#3388ff',
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: 'round',
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: 'round',
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: 'evenodd',
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, 'weight')) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === 'number') // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error('Circle radius cannot be NaN');
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === 'function') style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case 'Point':
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case 'MultiPoint':
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case 'LineString':
            case 'MultiLineString':
                latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case 'Polygon':
            case 'MultiPolygon':
                latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case 'GeometryCollection':
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: 'Feature',
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case 'FeatureCollection':
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error('Invalid GeoJSON object.');
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') return geojson;
        return {
            type: 'Feature',
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: 'Point',
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'LineString',
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'Polygon',
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: 'MultiPoint',
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === 'MultiPoint') return this.toMultiPoint(precision);
            var isGeometryCollection = type === 'GeometryCollection', jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === 'FeatureCollection') jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: 'GeometryCollection'
            });
            return {
                type: 'FeatureCollection',
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: '',
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: '',
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ''
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, 'leaflet-interactive');
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'IMG';
            var img = this._image = wasElementSupplied ? this._url : create$1('img');
            addClass(img, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(img, 'leaflet-zoom-animated');
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, 'load');
            img.onerror = bind(this._overlayOnError, this, 'error');
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + 'px';
            image.style.height = size.y + 'px';
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire('error');
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'VIDEO';
            var vid = this._image = wasElementSupplied ? this._url : create$1('video');
            addClass(vid, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(vid, 'leaflet-zoom-animated');
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, 'load');
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName('source');
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, 'objectFit')) vid.style['objectFit'] = 'fill';
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1('source');
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(el, 'leaflet-zoom-animated');
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: '',
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ''
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, 'leaflet-interactive');
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, 'leaflet-interactive');
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = 'hidden';
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = '';
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error('Unable to get source layer LatLng.');
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === 'function' ? this._content(this._source || this) : this._content;
            if (typeof content === 'string') node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire('contentupdate');
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + 'px';
            this._container.style.left = left + 'px';
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: 'popupPane',
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ''
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire('popupopen', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire('popupopen', {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on('preclick', stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire('popupclose', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire('popupclose', {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off('preclick', stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-popup', container = this._container = create$1('div', prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-animated');
            var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
            this._contentNode = create$1('div', prefix + '-content', wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, 'contextmenu', stopPropagation);
            this._tipContainer = create$1('div', prefix + '-tip-container', container);
            this._tip = create$1('div', prefix + '-tip', this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
                closeButton.setAttribute('role', 'button'); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute('aria-label', 'Close popup');
                closeButton.href = '#close';
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, 'click', function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = '';
            style.whiteSpace = 'nowrap';
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + 'px';
            style.whiteSpace = '';
            style.height = '';
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = 'leaflet-popup-scrolled';
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + 'px';
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire('autopanstart').panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: 'tooltipPane',
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: 'auto',
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire('tooltipopen', {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire('tooltipopen', {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire('tooltipclose', {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire('tooltipclose', {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-tooltip', className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            this._contentNode = this._container = create$1('div', className);
            this._container.setAttribute('role', 'tooltip');
            this._container.setAttribute('id', 'leaflet-tooltip-' + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === 'top') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === 'bottom') {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === 'center') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === 'right') {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === 'left') {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = 'right';
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = 'left';
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, 'leaflet-tooltip-right');
            removeClass(container, 'leaflet-tooltip-left');
            removeClass(container, 'leaflet-tooltip-top');
            removeClass(container, 'leaflet-tooltip-bottom');
            addClass(container, 'leaflet-tooltip-' + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? 'off' : 'on', events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) {
                on(el, 'focus', function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, 'blur', this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) el.setAttribute('aria-describedby', this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once('moveend', function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: 'leaflet-div-icon'
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === 'DIV' ? oldIcon : document.createElement('div'), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : '';
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + 'px ' + -bgPos.y + 'px';
            }
            this._setIconStyles(div, 'icon');
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: 'tilePane',
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: '',
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement('div');
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error('Attempted to load an infinite number of tiles');
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire('loading');
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ':' + coords.y + ':' + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(':'), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire('tileunload', {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, 'leaflet-tile');
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + 'px';
            tile.style.height = tileSize.y + 'px';
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire('tileloadstart', {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire('tileerror', {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, 'leaflet-tile-loaded');
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire('tileload', {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire('load');
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: 'abc',
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: '',
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === 'string') options.subdomains = options.subdomains.split('');
            this.on('tileunload', this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement('img');
            on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
            on(tile, 'error', bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === '') tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === 'string') tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = '';
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? '@2x' : '',
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data['y'] = invertedY;
                data['-y'] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute('src') !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire('tileabort', {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute('src', emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute('src') === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: 'WMS',
            request: 'GetMap',
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: '',
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: '',
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: 'image/jpeg',
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: '1.1.1'
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(','), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, 'leaflet-zoom-animated');
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on('update', this._updatePaths, this);
        },
        onRemove: function() {
            this.off('update', this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement('canvas');
            on(container, 'mousemove', this._onMouseMove, this);
            on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
            on(container, 'mouseout', this._handleMouseOut, this);
            container['_leaflet_disable_events'] = true;
            this._ctx = container.getContext('2d');
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + 'px';
            container.style.height = size.y + 'px';
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire('update');
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === 'string') {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || 'evenodd');
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === 'click' || e.type === 'preclick') || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, 'leaflet-interactive');
                this._fireEvent([
                    layer
                ], e, 'mouseout');
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, 'leaflet-interactive'); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, 'mouseover');
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
            return function(name) {
                return document.createElement('<lvml:' + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1('div', 'leaflet-vml-container');
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire('update');
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate('shape');
            addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
            container.coordsize = '1 1';
            layer._path = vmlCreate('path');
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate('stroke');
                container.appendChild(stroke);
                stroke.weight = options.weight + 'px';
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(' ') : options.dashArray.replace(/( *, *)/g, ' ');
                else stroke.dashStyle = '';
                stroke.endcap = options.lineCap.replace('butt', 'flat');
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate('fill');
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? 'M0 0' : 'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create('svg');
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute('pointer-events', 'none');
            this._rootGroup = create('g');
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute('width', size.x);
                container.setAttribute('height', size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute('viewBox', [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(' '));
            this.fire('update');
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create('path');
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, 'leaflet-interactive');
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute('stroke', options.color);
                path.setAttribute('stroke-opacity', options.opacity);
                path.setAttribute('stroke-width', options.weight);
                path.setAttribute('stroke-linecap', options.lineCap);
                path.setAttribute('stroke-linejoin', options.lineJoin);
                if (options.dashArray) path.setAttribute('stroke-dasharray', options.dashArray);
                else path.removeAttribute('stroke-dasharray');
                if (options.dashOffset) path.setAttribute('stroke-dashoffset', options.dashOffset);
                else path.removeAttribute('stroke-dashoffset');
            } else path.setAttribute('stroke', 'none');
            if (options.fill) {
                path.setAttribute('fill', options.fillColor || options.color);
                path.setAttribute('fill-opacity', options.fillOpacity);
                path.setAttribute('fill-rule', options.fillRule || 'evenodd');
            } else path.setAttribute('fill', 'none');
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
            // drawing a circle with two half-arcs
            var d = layer._empty() ? 'M0 0' : 'M' + (p.x - r) + ',' + p.y + arc + r * 2 + ',0 ' + arc + -r * 2 + ',0 ';
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute('d', path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === 'overlayPane' || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on('unload', this._destroy, this);
        },
        addHooks: function() {
            on(this._container, 'mousedown', this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, 'mousedown', this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1('div', 'leaflet-zoom-box', this._container);
                addClass(this._container, 'leaflet-crosshair');
                this._map.fire('boxzoomstart');
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + 'px';
            this._box.style.height = size.y + 'px';
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, 'leaflet-crosshair');
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire('boxzoomend', {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on('dblclick', this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off('dblclick', this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === 'center') map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on('predrag', this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on('predrag', this._onPreDragWrap, this);
                    map.on('zoomend', this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-grab');
            removeClass(this._map._container, 'leaflet-touch-drag');
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire('movestart').fire('dragstart');
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire('move', e).fire('drag', e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire('dragend', e);
            if (noInertia) map.fire('moveend');
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire('moveend');
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook('addHandler', 'dragging', Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = '0';
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire('focus');
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire('blur');
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, 'keydown', this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, 'keydown', this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook('addHandler', 'keyboard', Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'wheel', this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, 'wheel', this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === 'center') map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'touchstart', this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, 'touchstart', this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, 'touchend', preventDefault);
                on(document, 'touchend touchcancel', this._cancelClickPrevent);
                this._simulateEvent('contextmenu', first);
            }, this), tapHoldDelay);
            on(document, 'touchend touchcancel contextmenu', this._cancel, this);
            on(document, 'touchmove', this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, 'touchend', preventDefault);
            off(document, 'touchend touchcancel', cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, 'touchend touchcancel contextmenu', this._cancel, this);
            off(document, 'touchmove', this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook('addHandler', 'tapHold', TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, 'leaflet-touch-zoom');
            on(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-touch-zoom');
            off(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== 'center') this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, 'touchmove', this._onTouchMove, this);
            on(document, 'touchend touchcancel', this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === 'center') {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, 'touchmove', this._onTouchMove, this);
            off(document, 'touchend touchcancel', this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});



var $2xPiy = parcelRequire("2xPiy");
function $0e37ea606c782d6e$var$MapContainerComponent({ bounds: bounds, boundsOptions: boundsOptions, center: center, children: children, className: className, id: id, placeholder: placeholder, style: style, whenReady: whenReady, zoom: zoom, ...options }, forwardedRef) {
    const [props] = (0, $2xPiy.useState)({
        className: className,
        id: id,
        style: style
    });
    const [context, setContext] = (0, $2xPiy.useState)(null);
    const mapInstanceRef = (0, $2xPiy.useRef)(undefined);
    (0, $2xPiy.useImperativeHandle)(forwardedRef, ()=>context?.map ?? null, [
        context
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: ref callback
    const mapRef = (0, $2xPiy.useCallback)((node)=>{
        if (node !== null && !mapInstanceRef.current) {
            const map = new (0, $49be9010cfb85667$exports.Map)(node, options);
            mapInstanceRef.current = map;
            if (center != null && zoom != null) map.setView(center, zoom);
            else if (bounds != null) map.fitBounds(bounds, boundsOptions);
            if (whenReady != null) map.whenReady(whenReady);
            setContext((0, $6ce7268813681708$export$fb237fa819e17281)(map));
        }
    }, []);
    (0, $2xPiy.useEffect)(()=>{
        return ()=>{
            context?.map.remove();
        };
    }, [
        context
    ]);
    const contents = context ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $6ce7268813681708$export$7de1b54b0142048f), {
        value: context
    }, children) : placeholder ?? null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("div", {
        ...props,
        ref: mapRef
    }, contents);
}
const $0e37ea606c782d6e$export$23f3dfd47374502b = /*#__PURE__*/ (0, $2xPiy.forwardRef)($0e37ea606c782d6e$var$MapContainerComponent);


var $2xPiy = parcelRequire("2xPiy");
function $ef465f353ab38b7d$export$a080ff44e8067a44(instance, context, container) {
    return Object.freeze({
        instance: instance,
        context: context,
        container: container
    });
}
function $ef465f353ab38b7d$export$2e66ec8a7fb1892f(createElement, updateElement) {
    if (updateElement == null) return function useImmutableLeafletElement(props, context) {
        const elementRef = (0, $2xPiy.useRef)(undefined);
        if (!elementRef.current) elementRef.current = createElement(props, context);
        return elementRef;
    };
    return function useMutableLeafletElement(props, context) {
        const elementRef = (0, $2xPiy.useRef)(undefined);
        if (!elementRef.current) elementRef.current = createElement(props, context);
        const propsRef = (0, $2xPiy.useRef)(props);
        const { instance: instance } = elementRef.current;
        (0, $2xPiy.useEffect)(function updateElementProps() {
            if (propsRef.current !== props) {
                updateElement(instance, props, propsRef.current);
                propsRef.current = props;
            }
        }, [
            instance,
            props,
            updateElement
        ]);
        return elementRef;
    };
}


var $2xPiy = parcelRequire("2xPiy");

var $cX5wj = parcelRequire("cX5wj");

function $3ac8bd21acd3451b$export$96eac748c3f41e82(useElement) {
    function ContainerComponent(props, forwardedRef) {
        const { instance: instance, context: context } = useElement(props).current;
        (0, $2xPiy.useImperativeHandle)(forwardedRef, ()=>instance);
        const { children: children } = props;
        return children == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $6ce7268813681708$export$7de1b54b0142048f), {
            value: context
        }, children);
    }
    return /*#__PURE__*/ (0, $2xPiy.forwardRef)(ContainerComponent);
}
function $3ac8bd21acd3451b$export$bc37ddc24ed05446(useElement) {
    function OverlayComponent(props, forwardedRef) {
        const [isOpen, setOpen] = (0, $2xPiy.useState)(false);
        const { instance: instance } = useElement(props, setOpen).current;
        (0, $2xPiy.useImperativeHandle)(forwardedRef, ()=>instance);
        // biome-ignore lint/correctness/useExhaustiveDependencies: update overlay when children change
        (0, $2xPiy.useEffect)(function updateOverlay() {
            if (isOpen) instance.update();
        }, [
            instance,
            isOpen,
            props.children
        ]);
        // @ts-ignore _contentNode missing in type definition
        const contentNode = instance._contentNode;
        return contentNode ? /*#__PURE__*/ (0, $cX5wj.createPortal)(props.children, contentNode) : null;
    }
    return /*#__PURE__*/ (0, $2xPiy.forwardRef)(OverlayComponent);
}
function $3ac8bd21acd3451b$export$18af5c7a9e9b3664(useElement) {
    function LeafComponent(props, forwardedRef) {
        const { instance: instance } = useElement(props).current;
        (0, $2xPiy.useImperativeHandle)(forwardedRef, ()=>instance);
        return null;
    }
    return /*#__PURE__*/ (0, $2xPiy.forwardRef)(LeafComponent);
}



var $2xPiy = parcelRequire("2xPiy");

function $bc3ee1306d10c043$export$28d24ab3914549cd(useElement) {
    return function useLeafletControl(props) {
        const context = (0, $6ce7268813681708$export$ea59151b8430a4e9)();
        const elementRef = useElement(props, context);
        const { instance: instance } = elementRef.current;
        const positionRef = (0, $2xPiy.useRef)(props.position);
        const { position: position } = props;
        (0, $2xPiy.useEffect)(function addControl() {
            instance.addTo(context.map);
            return function removeControl() {
                instance.remove();
            };
        }, [
            context.map,
            instance
        ]);
        (0, $2xPiy.useEffect)(function updateControl() {
            if (position != null && position !== positionRef.current) {
                instance.setPosition(position);
                positionRef.current = position;
            }
        }, [
            instance,
            position
        ]);
        return elementRef;
    };
}



var $2xPiy = parcelRequire("2xPiy");
function $ae0c67ee36e8a591$export$46b870813daca3d4(map, attribution) {
    const attributionRef = (0, $2xPiy.useRef)(attribution);
    (0, $2xPiy.useEffect)(function updateAttribution() {
        if (attribution !== attributionRef.current && map.attributionControl != null) {
            if (attributionRef.current != null) map.attributionControl.removeAttribution(attributionRef.current);
            if (attribution != null) map.attributionControl.addAttribution(attribution);
        }
        attributionRef.current = attribution;
    }, [
        map,
        attribution
    ]);
}




var $2xPiy = parcelRequire("2xPiy");
function $b923568c1956c3a7$export$8ce912bc34d0dbea(element, eventHandlers) {
    const eventHandlersRef = (0, $2xPiy.useRef)(undefined);
    (0, $2xPiy.useEffect)(function addEventHandlers() {
        if (eventHandlers != null) element.instance.on(eventHandlers);
        eventHandlersRef.current = eventHandlers;
        return function removeEventHandlers() {
            if (eventHandlersRef.current != null) element.instance.off(eventHandlersRef.current);
            eventHandlersRef.current = null;
        };
    }, [
        element,
        eventHandlers
    ]);
}


function $650604282e2a958b$export$6ee5d263358f5c0e(props, context) {
    const pane = props.pane ?? context.pane;
    return pane ? {
        ...props,
        pane: pane
    } : props;
}


function $9161ed59d1ce6cfc$export$d5eca53b0accc0e0(useElement, useLifecycle) {
    return function useDivOverlay(props, setOpen) {
        const context = (0, $6ce7268813681708$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $650604282e2a958b$export$6ee5d263358f5c0e)(props, context), context);
        (0, $ae0c67ee36e8a591$export$46b870813daca3d4)(context.map, props.attribution);
        (0, $b923568c1956c3a7$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        useLifecycle(elementRef.current, context, props, setOpen);
        return elementRef;
    };
}




var $2xPiy = parcelRequire("2xPiy");




function $aa829355c2602134$export$cd00a227f8cfb2c2(element, context) {
    (0, $2xPiy.useEffect)(function addLayer() {
        const container = context.layerContainer ?? context.map;
        container.addLayer(element.instance);
        return function removeLayer() {
            context.layerContainer?.removeLayer(element.instance);
            context.map.removeLayer(element.instance);
        };
    }, [
        context,
        element
    ]);
}
function $aa829355c2602134$export$73f852c6a5abdefa(useElement) {
    return function useLayer(props) {
        const context = (0, $6ce7268813681708$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $650604282e2a958b$export$6ee5d263358f5c0e)(props, context), context);
        (0, $ae0c67ee36e8a591$export$46b870813daca3d4)(context.map, props.attribution);
        (0, $b923568c1956c3a7$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        $aa829355c2602134$export$cd00a227f8cfb2c2(elementRef.current, context);
        return elementRef;
    };
}



var $2xPiy = parcelRequire("2xPiy");




function $2b7a04f20f94f6dd$export$d0296329a1f118ca(element, props) {
    const optionsRef = (0, $2xPiy.useRef)(undefined);
    (0, $2xPiy.useEffect)(function updatePathOptions() {
        if (props.pathOptions !== optionsRef.current) {
            const options = props.pathOptions ?? {};
            element.instance.setStyle(options);
            optionsRef.current = options;
        }
    }, [
        element,
        props
    ]);
}
function $2b7a04f20f94f6dd$export$5fea2fe6048fc3db(useElement) {
    return function usePath(props) {
        const context = (0, $6ce7268813681708$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $650604282e2a958b$export$6ee5d263358f5c0e)(props, context), context);
        (0, $b923568c1956c3a7$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        (0, $aa829355c2602134$export$cd00a227f8cfb2c2)(elementRef.current, context);
        $2b7a04f20f94f6dd$export$d0296329a1f118ca(elementRef.current, props);
        return elementRef;
    };
}


function $2b5cff5fb52cca00$export$896a3ef451e396c4(createInstance) {
    function createElement(props, context) {
        return (0, $ef465f353ab38b7d$export$a080ff44e8067a44)(createInstance(props), context);
    }
    const useElement = (0, $ef465f353ab38b7d$export$2e66ec8a7fb1892f)(createElement);
    const useControl = (0, $bc3ee1306d10c043$export$28d24ab3914549cd)(useElement);
    return (0, $3ac8bd21acd3451b$export$18af5c7a9e9b3664)(useControl);
}
function $2b5cff5fb52cca00$export$8a4d5778bce4c3ac(createElement, updateElement) {
    const useElement = (0, $ef465f353ab38b7d$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const useLayer = (0, $aa829355c2602134$export$73f852c6a5abdefa)(useElement);
    return (0, $3ac8bd21acd3451b$export$96eac748c3f41e82)(useLayer);
}
function $2b5cff5fb52cca00$export$7d18e209be943d7d(createElement, useLifecycle) {
    const useElement = (0, $ef465f353ab38b7d$export$2e66ec8a7fb1892f)(createElement);
    const useOverlay = (0, $9161ed59d1ce6cfc$export$d5eca53b0accc0e0)(useElement, useLifecycle);
    return (0, $3ac8bd21acd3451b$export$bc37ddc24ed05446)(useOverlay);
}
function $2b5cff5fb52cca00$export$5e776dbe3c7d2790(createElement, updateElement) {
    const useElement = (0, $ef465f353ab38b7d$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const usePath = (0, $2b7a04f20f94f6dd$export$5fea2fe6048fc3db)(useElement);
    return (0, $3ac8bd21acd3451b$export$96eac748c3f41e82)(usePath);
}
function $2b5cff5fb52cca00$export$4f432c6de5c4ddb8(createElement, updateElement) {
    const useElement = (0, $ef465f353ab38b7d$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const useLayer = (0, $aa829355c2602134$export$73f852c6a5abdefa)(useElement);
    return (0, $3ac8bd21acd3451b$export$18af5c7a9e9b3664)(useLayer);
}



const $0cff41db924f5c11$export$e98856a975cab58e = (0, $2b5cff5fb52cca00$export$8a4d5778bce4c3ac)(function createMarker({ position: position, ...options }, ctx) {
    const marker = new (0, $49be9010cfb85667$exports.Marker)(position, options);
    return (0, $ef465f353ab38b7d$export$a080ff44e8067a44)(marker, (0, $6ce7268813681708$export$9efaf186a2224858)(ctx, {
        overlayContainer: marker
    }));
}, function updateMarker(marker, props, prevProps) {
    if (props.position !== prevProps.position) marker.setLatLng(props.position);
    if (props.icon != null && props.icon !== prevProps.icon) marker.setIcon(props.icon);
    if (props.zIndexOffset != null && props.zIndexOffset !== prevProps.zIndexOffset) marker.setZIndexOffset(props.zIndexOffset);
    if (props.opacity != null && props.opacity !== prevProps.opacity) marker.setOpacity(props.opacity);
    if (marker.dragging != null && props.draggable !== prevProps.draggable) {
        if (props.draggable === true) marker.dragging.enable();
        else marker.dragging.disable();
    }
});




var $2xPiy = parcelRequire("2xPiy");
const $b3b3e9e703d452b6$export$129a32eedafa97c5 = (0, $2b5cff5fb52cca00$export$7d18e209be943d7d)(function createPopup(props, context) {
    const popup = new (0, $49be9010cfb85667$exports.Popup)(props, context.overlayContainer);
    return (0, $ef465f353ab38b7d$export$a080ff44e8067a44)(popup, context);
}, function usePopupLifecycle(element, context, { position: position }, setOpen) {
    (0, $2xPiy.useEffect)(function addPopup() {
        const { instance: instance } = element;
        function onPopupOpen(event) {
            if (event.popup === instance) {
                instance.update();
                setOpen(true);
            }
        }
        function onPopupClose(event) {
            if (event.popup === instance) setOpen(false);
        }
        context.map.on({
            popupopen: onPopupOpen,
            popupclose: onPopupClose
        });
        if (context.overlayContainer == null) {
            // Attach to a Map
            if (position != null) instance.setLatLng(position);
            instance.openOn(context.map);
        } else // Attach to container component
        context.overlayContainer.bindPopup(instance);
        return function removePopup() {
            context.map.off({
                popupopen: onPopupOpen,
                popupclose: onPopupClose
            });
            context.overlayContainer?.unbindPopup();
            context.map.removeLayer(instance);
        };
    }, [
        element,
        context,
        setOpen,
        position
    ]);
});

function $61a34eb1a7d86a0a$export$b39104a5f1b9296f(layer, props, prevProps) {
    const { opacity: opacity, zIndex: zIndex } = props;
    if (opacity != null && opacity !== prevProps.opacity) layer.setOpacity(opacity);
    if (zIndex != null && zIndex !== prevProps.zIndex) layer.setZIndex(zIndex);
}



const $f6e8ce7c40b284d6$export$f52ee31d61d0b27b = (0, $2b5cff5fb52cca00$export$4f432c6de5c4ddb8)(function createTileLayer({ url: url, ...options }, context) {
    const layer = new (0, $49be9010cfb85667$exports.TileLayer)(url, (0, $650604282e2a958b$export$6ee5d263358f5c0e)(options, context));
    return (0, $ef465f353ab38b7d$export$a080ff44e8067a44)(layer, context);
}, function updateTileLayer(layer, props, prevProps) {
    (0, $61a34eb1a7d86a0a$export$b39104a5f1b9296f)(layer, props, prevProps);
    const { url: url } = props;
    if (url != null && url !== prevProps.url) layer.setUrl(url);
});




var $2xPiy = parcelRequire("2xPiy");

var $2xPiy = parcelRequire("2xPiy");


var $iA1nz = parcelRequire("iA1nz");

// fallback to edgeSize for backwards compatibility
var $16295f82d96039ab$var$roundStyle = (0, $iA1nz.css)([
    "border-radius:",
    ";"
], function(props) {
    return props.theme.global[props.theme.global.radius ? 'radius' : 'edgeSize'][props.round.size];
});
// overflow: hidden is needed for ie11
var $16295f82d96039ab$export$430a924eee89432c = (0, $iA1nz.default).svg.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledMeter",
    componentId: "sc-nsxarx-0"
})([
    "max-width:100%;overflow:hidden;",
    " ",
    " ",
    " path{transition:stroke 0.3s,stroke-width 0.3s;}",
    ";"
], function(props) {
    return props.reverse && (0, $iA1nz.css)([
        "transform:scale(-1,1);"
    ]);
}, (0, $73ba8e2d301b823f$export$a157b298d219a801), function(props) {
    return props.round && $16295f82d96039ab$var$roundStyle;
}, function(props) {
    return props.theme.meter && props.theme.meter.extend;
});



var $31fa3de1341227df$export$c6dfdb238d76e427 = function strokeProps(color, theme) {
    var result = {};
    if (color) {
        if (typeof color === 'object') {
            result.stroke = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(color.color, theme);
            if (color.opacity) result.strokeOpacity = "" + (color.opacity === true ? theme.global.opacity.medium : theme.global.opacity[color.opacity] || color.opacity);
        } else result.stroke = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(color, theme);
    }
    return result;
};
var $31fa3de1341227df$export$4ccf064591ccdacd = function fillProps(color, theme) {
    var result = {};
    if (color) {
        if (typeof color === 'object') {
            result.fill = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(color.color, theme);
            if (color.opacity) result.fillOpacity = "" + (color.opacity === true ? theme.global.opacity.medium : theme.global.opacity[color.opacity] || color.opacity);
        } else result.fill = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(color, theme);
    }
    return result;
};
var $31fa3de1341227df$var$neutralExp = /^neutral-\d+/;
var $31fa3de1341227df$export$f705f0fde43a55a = function defaultColor(index, theme, valuesLength) {
    if (index === valuesLength - 1 && theme.meter.color) return theme.meter.color;
    // We want the last value to have the first color
    var colorIndex = valuesLength - index - 1;
    if (theme.meter && theme.meter.colors) {
        var _colors = theme.meter.colors[theme.dark ? 'dark' : 'light'] || theme.meter.colors;
        return _colors[colorIndex % _colors.length];
    }
    var colors = Object.keys(theme.global.colors).filter(function(n) {
        return n.match(/^graph-[0-9]$/);
    });
    if (colors.length > 0) return colors[colorIndex % colors.length];
    // Deprecate using "neutral-*" color names. Remove eventually.
    var neutralColors = Object.keys(theme.global.colors).filter(function(k) {
        return $31fa3de1341227df$var$neutralExp.test(k);
    });
    return neutralColors[colorIndex % neutralColors.length];
};



var $d765544e8e0f6de5$var$_excluded = [
    "background",
    "max",
    "round",
    "size",
    "thickness",
    "direction",
    "values",
    "reverse"
], $d765544e8e0f6de5$var$_excluded2 = [
    "color",
    "highlight",
    "label",
    "onHover",
    "value"
];
function $d765544e8e0f6de5$var$_extends() {
    return $d765544e8e0f6de5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d765544e8e0f6de5$var$_extends.apply(null, arguments);
}
function $d765544e8e0f6de5$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $d765544e8e0f6de5$export$bbc6c6369b38e3d1 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    var _theme$meter$gap, _theme$meter;
    var _props$background = props.background, background = _props$background === void 0 ? 'light-1' : _props$background, max = props.max, round = props.round, size = props.size, thicknessProp = props.thickness, direction = props.direction, values = props.values, reverse = props.reverse, rest = $d765544e8e0f6de5$var$_objectWithoutPropertiesLoose(props, $d765544e8e0f6de5$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var length = size === 'full' ? 288 : (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(theme.global.size[size] || size);
    var thickness = (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(theme.global.edgeSize[thicknessProp] || thicknessProp);
    var gapTheme = (_theme$meter$gap = (_theme$meter = theme.meter) == null ? void 0 : _theme$meter.gap) != null ? _theme$meter$gap : 0;
    var gap = (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(theme.global.edgeSize[gapTheme] || gapTheme);
    // account for the round cap, if any
    var capRadius = round ? thickness / 2 : 0;
    var mid = thickness / 2;
    var someHighlight = (values || []).some(function(v) {
        return v.highlight;
    });
    var start = direction === 'horizontal' ? capRadius : length - capRadius;
    // Available space for the bar is the length of the meter minus an end cap
    // on each end, minus the gap between bars.
    var lengthAvailable = length - 2 * capRadius - gap * (values.length - 1);
    var paths = (values || []).reduce(function(acc, valueArg, index) {
        if (valueArg.value > 0) {
            var color = valueArg.color, highlight = valueArg.highlight, label = valueArg.label, onHover = valueArg.onHover, value = valueArg.value, pathRest = $d765544e8e0f6de5$var$_objectWithoutPropertiesLoose(valueArg, $d765544e8e0f6de5$var$_excluded2);
            var key = "p-" + index;
            var delta = value * lengthAvailable / max;
            // add a little bit extra to start to allow for larger rounded inset cap
            // The extra needed can be calculated by the Pythagorean theorem
            var extraGap = round && index !== 0 ? Math.sqrt(Math.pow(thickness / 2 + gap / 4, 2) - Math.pow(thickness / 2, 2)) : 0;
            var initialStart = direction === 'horizontal' ? start + extraGap : start - extraGap;
            // define the x,y points for the corners of the bar.
            var points = direction === 'horizontal' ? [
                initialStart + "," + thickness,
                initialStart + ",0",
                start + delta + ",0",
                start + delta + "," + thickness
            ] : [
                thickness + "," + initialStart,
                "0," + initialStart,
                "0," + (start - delta),
                thickness + "," + (start - delta)
            ];
            // if rounded, the starting cap is an arc. All but the first bar
            // will have a gap and a slightly larger radius
            var startRadius = index === 0 ? capRadius : capRadius + gap / 2;
            var startCap = round ? "A " + startRadius + "," + startRadius + " 0 0 " + (index === 0 ? 1 : 0) + " " + points[1] : "L " + points[1];
            var endCap = round ? "A " + capRadius + "," + capRadius + " 0 0 1 " + points[3] : "L " + points[3];
            var d = "M " + points[0] + " " + startCap + " L " + points[2] + " " + endCap + " Z";
            var colorName = color || (0, $31fa3de1341227df$export$f705f0fde43a55a)(index, theme, values ? values.length : 0);
            var hoverProps;
            if (onHover) hoverProps = {
                onMouseOver: function onMouseOver() {
                    return onHover(true);
                },
                onMouseLeave: function onMouseLeave() {
                    return onHover(false);
                }
            };
            var fill = (0, $31fa3de1341227df$export$4ccf064591ccdacd)(someHighlight && !highlight ? background : colorName, theme);
            acc.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", $d765544e8e0f6de5$var$_extends({
                key: key,
                d: d
            }, fill, {
                strokeWidth: 0,
                stroke: "none"
            }, hoverProps, pathRest)));
            if (direction === 'horizontal') start += delta + gap;
            else start -= delta + gap;
        }
        return acc;
    }, []).reverse(); // reverse so the caps look right
    var width;
    if (direction === 'horizontal') width = size === 'full' ? '100%' : length;
    else width = size === 'full' ? '100%' : thickness;
    var backgroundPath = direction === 'horizontal' ? "M " + capRadius + "," + mid + " L " + (length - capRadius) + "," + mid : "M " + mid + "," + capRadius + " L " + mid + "," + (length - capRadius);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $16295f82d96039ab$export$430a924eee89432c), $d765544e8e0f6de5$var$_extends({
        ref: ref,
        viewBox: direction === 'horizontal' ? "0 0 " + length + " " + thickness : "0 0 " + thickness + " " + length,
        preserveAspectRatio: "none",
        width: width,
        height: direction === 'horizontal' ? thickness : length,
        round: round ? {
            size: thicknessProp
        } : undefined
    }, passThemeFlag, rest, {
        reverse: reverse
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", $d765544e8e0f6de5$var$_extends({
        d: backgroundPath,
        fill: "none"
    }, (0, $31fa3de1341227df$export$c6dfdb238d76e427)(background, theme), {
        strokeWidth: thickness,
        strokeLinecap: round ? 'round' : 'square'
    })), paths);
});
$d765544e8e0f6de5$export$bbc6c6369b38e3d1.displayName = 'Bar';



var $2xPiy = parcelRequire("2xPiy");
var $931744413544a816$var$POST_DECIMAL_DIGITS = 10;
var $931744413544a816$export$4738d597a47e577d = 24;
var $931744413544a816$export$5c9a959bb3fc7749 = function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
    var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
    return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians)
    };
};
var $931744413544a816$var$intersection = function intersection(line1Point1, line1Point2, line2Point1, line2Point2) {
    var x1 = line1Point1.x, y1 = line1Point1.y;
    var x2 = line1Point2.x, y2 = line1Point2.y;
    var x3 = line2Point1.x, y3 = line2Point1.y;
    var x4 = line2Point2.x, y4 = line2Point2.y;
    // Calculate the denominator
    var denominator = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
    // Check if lines are parallel (denominator is 0)
    if (Math.abs(denominator) < 1e-10) return null; // Lines are parallel or coincident
    // Calculate the intersection point
    var t = ((x1 - x3) * (y3 - y4) - (y1 - y3) * (x3 - x4)) / denominator;
    var u = -((x1 - x2) * (y1 - y3) - (y1 - y2) * (x1 - x3)) / denominator;
    // Calculate intersection coordinates
    var intersectionX = x1 + t * (x2 - x1);
    var intersectionY = y1 + t * (y2 - y1);
    return {
        x: intersectionX,
        y: intersectionY,
        // Optional: check if intersection is within line segments
        withinSegment1: t >= 0 && t <= 1,
        withinSegment2: u >= 0 && u <= 1
    };
};
var $931744413544a816$export$3bbb56266409c57 = function lineCommands(centerX, centerY, radius, angle) {
    var start = $931744413544a816$export$5c9a959bb3fc7749(centerX, centerY, radius, angle);
    var d = [
        'M',
        centerX.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS),
        centerY.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS),
        'L',
        start.x.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS),
        start.y.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS)
    ].join(' ');
    return d;
};
var $931744413544a816$export$42585d8f3d81ad44 = function arcCommands(centerX, centerY, radius, startAngle, endAngle) {
    // handle that we can't draw a complete circle
    var normalizedEndAngle = endAngle;
    /* 
   added endAngle - startAngle >= 360 
   for SemiCircle the endAngle will never be greater then startAngle 
   since it starts with a startAngle of 270.
  */ if (endAngle > startAngle && endAngle - startAngle >= 360) normalizedEndAngle = startAngle + 359.99;
    var start = $931744413544a816$export$5c9a959bb3fc7749(centerX, centerY, radius, normalizedEndAngle);
    var end = $931744413544a816$export$5c9a959bb3fc7749(centerX, centerY, radius, startAngle);
    var arcSweep = normalizedEndAngle - startAngle <= 180 ? '0' : '1';
    var d = [
        'M',
        start.x.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS),
        start.y.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS),
        'A',
        radius.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS),
        radius.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS),
        0,
        arcSweep,
        0,
        end.x.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS),
        end.y.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS)
    ].join(' ');
    return d;
};
var $931744413544a816$export$11a7b5abbf8340a = function calcAngle(radius, angle, midAngle, gap) {
    if (gap === 0) return angle;
    var gapAngleRadians = Math.asin(Math.abs(gap) / radius);
    var gapAngle = gapAngleRadians * 180 / Math.PI;
    return gap > 0 ? Math.min(angle + gapAngle, midAngle) : Math.max(angle - gapAngle, midAngle);
};
var $931744413544a816$var$gapPoints = function gapPoints(centerX, centerY, outerRadius, innerRadius, angle, midAngle, gap) {
    var outerAngle = $931744413544a816$export$11a7b5abbf8340a(outerRadius, angle, midAngle, gap);
    var outer = $931744413544a816$export$5c9a959bb3fc7749(centerX, centerY, outerRadius, outerAngle);
    var inner;
    if (innerRadius > 0) {
        var innerAngle = $931744413544a816$export$11a7b5abbf8340a(innerRadius, angle, midAngle, gap);
        inner = $931744413544a816$export$5c9a959bb3fc7749(centerX, centerY, innerRadius, innerAngle);
    } else inner = $931744413544a816$export$5c9a959bb3fc7749(centerX, centerY, Math.abs(gap), gap < 0 ? angle - 90 : angle + 90);
    return {
        outer: outer,
        inner: inner
    };
};
var $931744413544a816$export$9928994028c6cb9b = function wedgeCommands(centerX, centerY, outerRadius, innerRadius, startAngle, endAngle, startGap, endGap, startRound, endRound, startRoundDirection) {
    if (startRoundDirection === void 0) startRoundDirection = 0;
    // handle that we can't draw a complete circle
    var normalizedEndAngle = endAngle;
    /* 
   added endAngle - startAngle >= 360 
   for SemiCircle the endAngle will never be greater then startAngle 
   since it starts with a startAngle of 270.
  */ if (endAngle > startAngle && endAngle - startAngle >= 359.99) normalizedEndAngle = startAngle + 359.99;
    // if we're rounded we need to ajust the start points to
    // account for a bigger cap radius
    // add a little bit extra to start to allow for larger rounded inset cap
    // The extra needed can be calculated by the Pythagorean theorem
    var thickness = outerRadius - innerRadius;
    var extraGap = startRound ? Math.sqrt(Math.pow(thickness / 2 + startGap / 4, 2) - Math.pow(thickness / 2, 2)) : 0;
    // define the angle at the center of the wedge. We can't let the gap
    // go past this angle.
    // calculate the angle span between start and end
    var angleSpan = (endAngle < startAngle ? endAngle + 360 : endAngle) - startAngle;
    var midAngle = startAngle + angleSpan / 2;
    var start = $931744413544a816$var$gapPoints(centerX, centerY, outerRadius, innerRadius, startAngle, midAngle < startAngle ? midAngle + 360 : midAngle, startGap + extraGap, startRound);
    var end = $931744413544a816$var$gapPoints(centerX, centerY, outerRadius, innerRadius, normalizedEndAngle, midAngle > endAngle ? midAngle - 360 : midAngle, endGap, endRound);
    var largeAngle = normalizedEndAngle - startAngle > 180;
    var arcSweep = largeAngle ? '1' : '0';
    var innerCapRadius = innerRadius;
    var innerArcSweep = arcSweep;
    var middle;
    if (innerRadius <= 0) {
        // we're doing a pie wedge
        innerArcSweep = arcSweep === '0' ? '1' : '0';
        if (largeAngle) // for a large pie wedge it has an inner corner rather
        // than a point. We need to round the inner corner
        innerCapRadius = startGap || endGap || 0;
        else // for a small pie wedge we'll make a point in the center
        middle = $931744413544a816$var$intersection(start.outer, start.inner, end.outer, end.inner);
    }
    var capRadius = (outerRadius - innerRadius) / 2;
    var startCapRadius = capRadius + (startRoundDirection === 0 ? startGap / 2 : 0);
    var startPoint = middle || start.inner;
    var endPoint = middle || end.inner;
    var startCap = startRound ? [
        'A',
        startCapRadius.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS),
        startCapRadius.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS),
        0,
        0,
        startRoundDirection,
        start.outer.x.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS),
        start.outer.y.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS)
    ] : [
        'L',
        start.outer.x.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS),
        start.outer.y.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS)
    ];
    var endCap = endRound ? [
        'A',
        capRadius.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS),
        capRadius.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS),
        0,
        0,
        1,
        endPoint.x.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS),
        endPoint.y.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS)
    ] : [
        'L',
        endPoint.x.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS),
        endPoint.y.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS)
    ];
    var d = [
        'M',
        startPoint.x.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS),
        startPoint.y.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS)
    ].concat(startCap, [
        'A',
        outerRadius.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS),
        outerRadius.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS),
        0,
        arcSweep,
        1,
        end.outer.x.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS),
        end.outer.y.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS)
    ], endCap);
    if (innerRadius > 0 || largeAngle) // for a donut or a large pie wedge, draw the inner arc
    d.push('A', innerCapRadius.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS), innerCapRadius.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS), 0, innerArcSweep, 0, start.inner.x.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS), start.inner.y.toFixed($931744413544a816$var$POST_DECIMAL_DIGITS), 'Z' // close the path
    );
    return d.join(' ');
};
var $931744413544a816$export$bd97579b57102dc8 = function translateEndAngle(startAngle, anglePer, value) {
    return Math.max(0, startAngle + anglePer * value) % 360;
};





var $a5a730a08cf803e7$var$_excluded = [
    "background",
    "max",
    "round",
    "size",
    "thickness",
    "type",
    "values"
], $a5a730a08cf803e7$var$_excluded2 = [
    "color",
    "highlight",
    "label",
    "onHover",
    "value"
];
function $a5a730a08cf803e7$var$_extends() {
    return $a5a730a08cf803e7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a5a730a08cf803e7$var$_extends.apply(null, arguments);
}
function $a5a730a08cf803e7$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $a5a730a08cf803e7$export$c89a927ffc67e6fa = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    var _theme$meter$gap, _theme$meter;
    var background = props.background, max = props.max, round = props.round, size = props.size, thickness = props.thickness, type = props.type, values = props.values, rest = $a5a730a08cf803e7$var$_objectWithoutPropertiesLoose(props, $a5a730a08cf803e7$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var width = size === 'full' ? 288 : (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(theme.global.size[size] || size);
    var strokeWidth = type === 'pie' ? width / 2 : Math.min(width / 2 - 8, (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(theme.global.edgeSize[thickness] || thickness));
    var centerX = width / 2;
    var centerY = width / 2;
    var radius = width / 2 - strokeWidth / 2;
    // truncate to avoid floating point arithmetic errors
    // see: https://github.com/grommet/grommet/issues/6190
    // Choose a scale factor at least 3 orders of magnitude above max
    var scalePower = Math.max(5, Math.ceil(Math.log10(max)) + 3);
    var scale = Math.pow(10, scalePower);
    var anglePer = Math.floor((type === 'semicircle' ? 180 : 360) / max * scale) / scale;
    var someHighlight = (values || []).some(function(v) {
        return v.highlight;
    });
    var gapTheme = (_theme$meter$gap = (_theme$meter = theme.meter) == null ? void 0 : _theme$meter.gap) != null ? _theme$meter$gap : '0';
    var gap = (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(theme.global.edgeSize[gapTheme] || gapTheme);
    var isSemi = type === 'semicircle';
    var isFull = values.reduce(function(total, currentValue) {
        return total + currentValue.value;
    }, 0) >= max;
    var startValue = 0;
    var startAngle = isSemi ? 270 : 0;
    var paths = [];
    (values || []).filter(function(v) {
        return v.value > 0;
    }).forEach(function(valueArg, index, _ref) {
        var length = _ref.length;
        var color = valueArg.color, highlight = valueArg.highlight, label = valueArg.label, onHover = valueArg.onHover, value = valueArg.value, pathRest = $a5a730a08cf803e7$var$_objectWithoutPropertiesLoose(valueArg, $a5a730a08cf803e7$var$_excluded2);
        var key = "p-" + index;
        var colorName = color || (0, $31fa3de1341227df$export$f705f0fde43a55a)(index, theme, values ? values.length : 0);
        var endAngle;
        if (startValue + value >= max) endAngle = isSemi ? 90 : 360;
        else endAngle = (0, $931744413544a816$export$bd97579b57102dc8)(startAngle, anglePer, value);
        var hoverProps;
        if (onHover) hoverProps = {
            onMouseOver: function onMouseOver() {
                return onHover(true);
            },
            onMouseLeave: function onMouseLeave() {
                return onHover(false);
            }
        };
        var stroke = (0, $31fa3de1341227df$export$c6dfdb238d76e427)(someHighlight && !highlight ? background : colorName, theme);
        var fill = (0, $31fa3de1341227df$export$4ccf064591ccdacd)(someHighlight && !highlight ? background : colorName, theme);
        var outerRadius = width / 2;
        var innerRadius = type === 'pie' ? 0 : width / 2 - strokeWidth;
        // We want a start gap if there's another segment before this one.
        // A circle's last segment can bump against the first segment if at max.
        var startGap = index === 0 && (isSemi || length === 1 || length > 1 && !isFull) ? 0 : gap / 2;
        // Similarly, we only need an end gap if there's a segment after this one.
        var endGap = index === length - 1 && (isSemi || length === 1) ? 0 : -gap / 2;
        var startRound = index === 0 && isSemi ? false : round;
        var d = (0, $931744413544a816$export$9928994028c6cb9b)(centerX, centerY, outerRadius, innerRadius, startAngle, endAngle, startGap, endGap, startRound, round, index === 0 ? 1 : 0);
        paths.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", $a5a730a08cf803e7$var$_extends({
            key: key,
            d: d
        }, fill, stroke, {
            strokeWidth: 0,
            strokeLinecap: "butt"
        }, hoverProps, pathRest)));
        startValue += value;
        startAngle = endAngle;
    });
    var track;
    if (type === 'semicircle') {
        var d1 = (0, $931744413544a816$export$42585d8f3d81ad44)(centerX, centerY, radius, 270, 90);
        track = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", $a5a730a08cf803e7$var$_extends({
            d: d1,
            strokeWidth: strokeWidth,
            fill: "none"
        }, (0, $31fa3de1341227df$export$c6dfdb238d76e427)(background, theme), {
            strokeLinecap: round ? 'round' : 'square'
        }));
    } else track = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("circle", $a5a730a08cf803e7$var$_extends({
        cx: centerX,
        cy: centerY,
        r: radius
    }, (0, $31fa3de1341227df$export$c6dfdb238d76e427)(background, theme), {
        strokeWidth: strokeWidth,
        strokeLinecap: round ? 'round' : 'square',
        fill: "none"
    }));
    var viewBoxHeight = type === 'semicircle' ? width / 2 : width;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $16295f82d96039ab$export$430a924eee89432c), $a5a730a08cf803e7$var$_extends({
        ref: ref,
        viewBox: "0 0 " + width + " " + viewBoxHeight,
        width: size === 'full' ? '100%' : width,
        height: size === 'full' ? '100%' : viewBoxHeight
    }, passThemeFlag, rest), track, paths);
});
$a5a730a08cf803e7$export$c89a927ffc67e6fa.displayName = 'Circle';



var $dyr1f = parcelRequire("dyr1f");

function $0c2d1dc825ae445b$var$_extends() {
    return $0c2d1dc825ae445b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0c2d1dc825ae445b$var$_extends.apply(null, arguments);
}
var $0c2d1dc825ae445b$var$PropType = {};
$0c2d1dc825ae445b$var$PropType = $0c2d1dc825ae445b$var$_extends({}, (0, $ab32ce3df36aa105$export$ffe37ff34eeb9e21), {
    background: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            color: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            opacity: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
                    'weak',
                    'medium',
                    'strong'
                ]),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
            ])
        })
    ]),
    color: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    max: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    messages: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        bar: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            singular: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            plural: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        }),
        circle: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            singular: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            plural: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        }),
        pie: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            singular: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            plural: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        }),
        semicirlce: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            singular: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            plural: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        })
    }),
    reverse: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    round: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            'full'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    thickness: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    type: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'bar',
        'circle',
        'pie',
        'semicircle'
    ]),
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'horizontal',
        'vertical'
    ]),
    value: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
    values: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        color: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        highlight: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string.isRequired,
        // for accessibility
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
        onHover: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number.isRequired
    }))
});
var $0c2d1dc825ae445b$export$1d51da36beba5791 = $0c2d1dc825ae445b$var$PropType;




var $71c166d579ee4cf3$var$_excluded = [
    "aria-label",
    "background",
    "color",
    "direction",
    "max",
    "messages",
    "size",
    "thickness",
    "type",
    "reverse",
    "value",
    "values"
];
function $71c166d579ee4cf3$var$_extends() {
    return $71c166d579ee4cf3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $71c166d579ee4cf3$var$_extends.apply(null, arguments);
}
function $71c166d579ee4cf3$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $71c166d579ee4cf3$export$62e3ae2a4090b879 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var _theme$meter, _messages$meter;
    var ariaLabel = _ref['aria-label'], backgroundProp = _ref.background, color = _ref.color, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? 'horizontal' : _ref$direction, maxProp = _ref.max, messages = _ref.messages, _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, _ref$thickness = _ref.thickness, thickness = _ref$thickness === void 0 ? 'medium' : _ref$thickness, _ref$type = _ref.type, type = _ref$type === void 0 ? 'bar' : _ref$type, reverseProp = _ref.reverse, value = _ref.value, valuesProp = _ref.values, rest = $71c166d579ee4cf3$var$_objectWithoutPropertiesLoose(_ref, $71c166d579ee4cf3$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useContext = (0, $2xPiy.useContext)((0, $f1ad7bf122eed3b0$export$b060d577040138d8)), format = _useContext.format;
    var background = backgroundProp || ((_theme$meter = theme.meter) == null ? void 0 : _theme$meter.background);
    // normalize values to an array of objects
    var values = (0, $2xPiy.useMemo)(function() {
        if (valuesProp) return valuesProp;
        if (value) return [
            {
                color: color,
                value: value
            }
        ];
        return [];
    }, [
        color,
        value,
        valuesProp
    ]);
    var reverse = direction === 'horizontal' && (theme.dir === 'rtl' || reverseProp) && !(theme.dir === 'rtl' && reverseProp);
    var max = (0, $2xPiy.useMemo)(function() {
        var maxValue = 100;
        if ((values == null ? void 0 : values.length) > 1) maxValue = values.reduce(function(total, currentValue) {
            return total + currentValue.value;
        }, 0);
        return maxProp || maxValue || 100;
    }, [
        maxProp,
        values
    ]);
    var messageId = (values == null ? void 0 : values.length) === 1 ? 'singular' : 'plural';
    var meterType = type || 'bar';
    var meterAriaLabel = ariaLabel || format({
        id: "meter." + meterType + "." + messageId,
        messages: messages == null || (_messages$meter = messages.meter) == null ? void 0 : _messages$meter[meterType],
        values: {
            meterValue: value || values.map(function(item) {
                var _item$value;
                return (_item$value = item.value) != null ? _item$value : 0;
            }).join(', ') || 0,
            type: type,
            max: max
        }
    });
    var content;
    if (type === 'bar') content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $d765544e8e0f6de5$export$bbc6c6369b38e3d1), $71c166d579ee4cf3$var$_extends({
        ref: ref,
        "aria-label": meterAriaLabel,
        max: max,
        values: values,
        size: size,
        thickness: thickness,
        background: background,
        direction: direction,
        reverse: reverse
    }, rest));
    else if (type === 'circle' || type === 'pie' || type === 'semicircle') content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $a5a730a08cf803e7$export$c89a927ffc67e6fa), $71c166d579ee4cf3$var$_extends({
        "aria-label": meterAriaLabel,
        ref: ref,
        max: max,
        values: values,
        size: size,
        thickness: thickness,
        type: type,
        background: background,
        reverse: reverse
    }, rest));
    return content;
});
$71c166d579ee4cf3$export$62e3ae2a4090b879.displayName = 'Meter';
$71c166d579ee4cf3$export$62e3ae2a4090b879.prototype = (0, $0c2d1dc825ae445b$export$1d51da36beba5791);



var $2xPiy = parcelRequire("2xPiy");


function $24b518a2732bce28$var$_extends() {
    return $24b518a2732bce28$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $24b518a2732bce28$var$_extends.apply(null, arguments);
}
var $24b518a2732bce28$export$4f481e0a96cfbed6 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    var scaleProps = (0, $c043e17d1ada851a$export$56a2e46cd4a7c217)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $24b518a2732bce28$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Checkmark"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", $24b518a2732bce28$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m2 14 7 6L22 4"
    }, scaleProps)));
});
$24b518a2732bce28$export$4f481e0a96cfbed6.displayName = 'Checkmark';








const $c1eda6c593a061fe$var$markerIcon = (0, (/*@__PURE__*/$parcel$interopDefault($49be9010cfb85667$exports))).divIcon({
    className: 'fuse-map-marker',
    html: `
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="36" viewBox="0 0 28 36">
      <defs>
        <filter id="fuse-marker-shadow" x="-30%" y="-10%" width="160%" height="140%">
          <feDropShadow dx="0" dy="2" stdDeviation="1.5" flood-opacity="0.3"/>
        </filter>
      </defs>
      <path filter="url(#fuse-marker-shadow)" fill="#EAAD47" stroke="#fff" stroke-width="2"
        d="M14 1C7.4 1 2 6.4 2 13c0 9 12 22 12 22s12-13 12-22c0-6.6-5.4-12-12-12z"/>
      <circle cx="14" cy="13" r="4" fill="#fff"/>
    </svg>
  `,
    iconSize: [
        28,
        36
    ],
    iconAnchor: [
        14,
        36
    ],
    popupAnchor: [
        0,
        -32
    ]
});
const $c1eda6c593a061fe$export$7734226e1720827f = (props)=>{
    /* Props */ const { height: height, ...cardProps } = props;
    /* Context */ const dashboardStore = (0, $116967e0234c3770$export$176f58333fc13682)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /* State */ const [isLoading, setIsLoading] = (0, $2xPiy.useState)(true);
    const [mapData, setMapData] = (0, $2xPiy.useState)([]);
    /* Memos */ const cardHeight = (0, $2xPiy.useRef)('52.125rem');
    const defaultMapCoords = (0, $2xPiy.useRef)([
        40.103,
        -122.217
    ]); // halfway between San Diego and Seattle
    const clientId = dashboardStore.dashboardData?.client_id;
    /* Effects */ (0, $2xPiy.useEffect)(()=>{
        if (!dashboardStore.dashboardData?.facilities) return;
        if (isLoading) {
            const chartData = dashboardStore.dashboardData.facilities.map((facility)=>({
                    id: facility.id,
                    name: facility.name,
                    address_1: `${facility.address.line1}${facility.address.line2 ? ` ${facility.address.line2}` : ''}`,
                    address_2: `${facility.address.city}, ${facility.address.region_short_code} ${facility.address.post_code}`,
                    coords: facility.address.latitude && facility.address.longitude ? [
                        facility.address.latitude,
                        facility.address.longitude
                    ] : undefined
                })).filter((d)=>!!d);
            setMapData(chartData);
            setIsLoading(false);
        }
    }, [
        isLoading,
        dashboardStore.dashboardData
    ]);
    /* Render */ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
        height: height || cardHeight.current,
        ...cardProps,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f557854f3abac6b7$export$5665775b26e26c5d), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), {
                    size: "xlarge",
                    children: t('dashboard:currentFacilityLocations')
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $fdccc762800a972d$export$851de33184ecdac4), {
                pad: "1.5rem",
                children: [
                    isLoading && dashboardStore.dashboardData?.facilities && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        height: "100vh",
                        fill: "horizontal",
                        justify: "center",
                        align: "center",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $1e7958766884f71d$export$694e0d28c7ffc90c), {
                            anchor: "center",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $71c166d579ee4cf3$export$62e3ae2a4090b879), {
                                    size: `${160}px`,
                                    value: dashboardStore.dashboardData.facilities.length * 10,
                                    type: "circle",
                                    color: "green"
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $24b518a2732bce28$export$4f481e0a96cfbed6), {
                                    size: `${80}px`,
                                    color: "green"
                                })
                            ]
                        })
                    }),
                    !isLoading && !!mapData && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $0e37ea606c782d6e$export$23f3dfd47374502b), {
                        center: mapData[0]?.coords ?? defaultMapCoords.current,
                        zoom: 5,
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f6e8ce7c40b284d6$export$f52ee31d61d0b27b), {
                                attribution: '\xa9 <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors \xa9 <a href="https://carto.com/attributions">CARTO</a>',
                                url: `https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=${(0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).maps.cartoBasemapsApiKey}`,
                                subdomains: "abcd",
                                maxZoom: 20
                            }),
                            mapData.map((f, i)=>{
                                return f.coords ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $0cff41db924f5c11$export$e98856a975cab58e), {
                                    position: f.coords,
                                    icon: $c1eda6c593a061fe$var$markerIcon,
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b3b3e9e703d452b6$export$129a32eedafa97c5), {
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            children: [
                                                f.name && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), {
                                                    margin: {
                                                        bottom: '0.5rem'
                                                    },
                                                    size: "1.25rem",
                                                    children: f.name
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $79bcac94ca400be1$export$a6c7ac8248d6e38a), {
                                                    to: `/clients/${clientId}/facilities/${f.id}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), {
                                                            size: "1rem",
                                                            style: {
                                                                display: 'block'
                                                            },
                                                            children: f.address_1
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), {
                                                            size: "1rem",
                                                            style: {
                                                                display: 'block'
                                                            },
                                                            children: f.address_2
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }, `${f.name}-${i}`) : undefined;
                            })
                        ]
                    })
                ]
            })
        ]
    });
};







var $2xPiy = parcelRequire("2xPiy");

function $ce7c3f634dc2ea76$var$_extends() {
    return $ce7c3f634dc2ea76$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ce7c3f634dc2ea76$var$_extends.apply(null, arguments);
}
var $ce7c3f634dc2ea76$export$c9915453de10000b = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $ce7c3f634dc2ea76$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Share"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M19 13v10H1V5h10m3-4h9v9m-13 4L23 1 10 14z"
    }));
});
$ce7c3f634dc2ea76$export$c9915453de10000b.displayName = 'Share';






const $0bcf9ecd3b8ca51b$export$f35abaf34fd2d2bf = (props)=>{
    /** Props **/ const { clientName: clientName, clientId: clientId, onExportPDF: onExportPDF, ...boxProps } = props;
    /** Stores **/ const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const tooltips = (0, $d597772cdbe12609$export$4713da6aa4410043)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $724dfb7ecf65a151$export$60332b2344f7fe41), {
        height: !userStore.isFacilityUser ? (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(80) : undefined,
        animation: !globalStore.didAnimateDashboard ? {
            type: 'slideDown',
            duration: 300,
            size: 'large'
        } : undefined,
        onAnimationEnd: ()=>globalStore.setDidAnimateDashboard(true),
        ...boxProps,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $fdccc762800a972d$export$851de33184ecdac4), {
            pad: {
                horizontal: '1.25rem',
                vertical: '1.25rem'
            },
            direction: "row",
            align: "center",
            justify: "between",
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    direction: "row",
                    align: "center",
                    children: [
                        !userStore.isFacilityUser && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    size: "1.75rem",
                                    weight: 400,
                                    children: clientName
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ce7c3f634dc2ea76$export$c9915453de10000b), {
                                        size: "16px"
                                    }),
                                    onClick: ()=>navigate(`/clients/${clientId}`),
                                    tip: tooltips.companyPageLink
                                })
                            ]
                        }),
                        userStore.isFacilityUser && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            justify: "center",
                            gap: "xxsmall",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    size: "1.75rem",
                                    weight: 400,
                                    children: t('dashboard:yourFacilities')
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    size: "1.1rem",
                                    fontFamily: "Lato, sans-serif",
                                    weight: 300,
                                    children: clientName
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                    id: "export-pdf-button",
                    label: t('dashboard:exportPDF'),
                    style: {
                        fontWeight: 400
                    },
                    onClick: onExportPDF
                })
            ]
        })
    });
};





const $39bb42c1b38b91d9$var$cardHeight = '8.44375rem';
const $39bb42c1b38b91d9$export$22cc6ea4392b37fa = (props)=>{
    /* Props */ const { title: title, value: value, subtitle: subtitle, description: description, icon: icon, height: height, width: width, isLoading: isLoading, showLoadingSpinner: showLoadingSpinner, ...cardProps } = props;
    /* Render */ return showLoadingSpinner && (isLoading ?? !value) ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
        height: height || $39bb42c1b38b91d9$var$cardHeight,
        width: width,
        ...cardProps,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $fdccc762800a972d$export$851de33184ecdac4), {
            direction: "row",
            pad: {
                horizontal: '1.5rem',
                vertical: '1.25rem'
            },
            justify: "between",
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    title: title,
                    alignSelf: "center",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            margin: {
                                bottom: '0.25rem'
                            },
                            direction: "row",
                            gap: "0.25rem",
                            style: {
                                alignItems: 'baseline'
                            },
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    size: "xxlarge",
                                    color: "accent-4",
                                    weight: 300,
                                    lineHeight: "2.5rem",
                                    letterSpacing: "-0.8px",
                                    children: value
                                }),
                                subtitle && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    size: "1.75rem",
                                    color: "accent-4",
                                    weight: 300,
                                    lineHeight: "1.75rem",
                                    children: subtitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            size: "large",
                            color: "dark-2",
                            children: title
                        }),
                        description && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            size: "medium",
                            weight: 300,
                            color: "dark-1",
                            children: description
                        })
                    ]
                }),
                icon && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    alignSelf: "center",
                    children: icon
                })
            ]
        })
    });
};




var $2xPiy = parcelRequire("2xPiy");
var $93d6258b67061950$exports = {};
"use strict";
Object.defineProperty($93d6258b67061950$exports, "__esModule", {
    value: !0
});
var $93d6258b67061950$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
    return typeof e;
} : function(e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
}, $93d6258b67061950$var$_extends = Object.assign || function(e) {
    for(var t = 1; t < arguments.length; t++){
        var r, n = arguments[t];
        for(r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
}, $93d6258b67061950$var$_createClass = function() {
    function n(e, t) {
        for(var r = 0; r < t.length; r++){
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
    }
    return function(e, t, r) {
        return t && n(e.prototype, t), r && n(e, r), e;
    };
}();
var $fffa43d1c55f0813$exports = {};
/*!
 * ApexCharts v3.44.1
 * (c) 2018-2023 ApexCharts
 * Released under the MIT License.
 */ "use strict";
function $fffa43d1c55f0813$var$t(t, e) {
    var i = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(t);
        e && (a = a.filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), i.push.apply(i, a);
    }
    return i;
}
function $fffa43d1c55f0813$var$e(e) {
    for(var i = 1; i < arguments.length; i++){
        var a = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $fffa43d1c55f0813$var$t(Object(a), !0).forEach(function(t) {
            $fffa43d1c55f0813$var$o(e, t, a[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : $fffa43d1c55f0813$var$t(Object(a)).forEach(function(t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
        });
    }
    return e;
}
function $fffa43d1c55f0813$var$i(t) {
    return $fffa43d1c55f0813$var$i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
        return typeof t;
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, $fffa43d1c55f0813$var$i(t);
}
function $fffa43d1c55f0813$var$a(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function $fffa43d1c55f0813$var$s(t, e) {
    for(var i = 0; i < e.length; i++){
        var a = e[i];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
}
function $fffa43d1c55f0813$var$r(t, e, i) {
    return e && $fffa43d1c55f0813$var$s(t.prototype, e), i && $fffa43d1c55f0813$var$s(t, i), t;
}
function $fffa43d1c55f0813$var$o(t, e, i) {
    return e in t ? Object.defineProperty(t, e, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[e] = i, t;
}
function $fffa43d1c55f0813$var$n(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), e && $fffa43d1c55f0813$var$h(t, e);
}
function $fffa43d1c55f0813$var$l(t) {
    return $fffa43d1c55f0813$var$l = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $fffa43d1c55f0813$var$l(t);
}
function $fffa43d1c55f0813$var$h(t, e) {
    return $fffa43d1c55f0813$var$h = Object.setPrototypeOf || function(t, e) {
        return t.__proto__ = e, t;
    }, $fffa43d1c55f0813$var$h(t, e);
}
function $fffa43d1c55f0813$var$c(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
}
function $fffa43d1c55f0813$var$d(t) {
    var e = function() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
        } catch (t) {
            return !1;
        }
    }();
    return function() {
        var i, a = $fffa43d1c55f0813$var$l(t);
        if (e) {
            var s = $fffa43d1c55f0813$var$l(this).constructor;
            i = Reflect.construct(a, arguments, s);
        } else i = a.apply(this, arguments);
        return function(t, e) {
            if (e && ("object" == typeof e || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return $fffa43d1c55f0813$var$c(t);
        }(this, i);
    };
}
function $fffa43d1c55f0813$var$g(t, e) {
    return function(t) {
        if (Array.isArray(t)) return t;
    }(t) || function(t, e) {
        var i = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
        if (null == i) return;
        var a, s, r = [], o = !0, n = !1;
        try {
            for(i = i.call(t); !(o = (a = i.next()).done) && (r.push(a.value), !e || r.length !== e); o = !0);
        } catch (t) {
            n = !0, s = t;
        } finally{
            try {
                o || null == i.return || i.return();
            } finally{
                if (n) throw s;
            }
        }
        return r;
    }(t, e) || $fffa43d1c55f0813$var$p(t, e) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $fffa43d1c55f0813$var$u(t) {
    return function(t) {
        if (Array.isArray(t)) return $fffa43d1c55f0813$var$f(t);
    }(t) || function(t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
    }(t) || $fffa43d1c55f0813$var$p(t) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $fffa43d1c55f0813$var$p(t, e) {
    if (t) {
        if ("string" == typeof t) return $fffa43d1c55f0813$var$f(t, e);
        var i = Object.prototype.toString.call(t).slice(8, -1);
        return "Object" === i && t.constructor && (i = t.constructor.name), "Map" === i || "Set" === i ? Array.from(t) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? $fffa43d1c55f0813$var$f(t, e) : void 0;
    }
}
function $fffa43d1c55f0813$var$f(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for(var i = 0, a = new Array(e); i < e; i++)a[i] = t[i];
    return a;
}
var $fffa43d1c55f0813$var$x = function() {
    function t() {
        $fffa43d1c55f0813$var$a(this, t);
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "shadeRGBColor",
            value: function(t, e) {
                var i = e.split(","), a = t < 0 ? 0 : 255, s = t < 0 ? -1 * t : t, r = parseInt(i[0].slice(4), 10), o = parseInt(i[1], 10), n = parseInt(i[2], 10);
                return "rgb(" + (Math.round((a - r) * s) + r) + "," + (Math.round((a - o) * s) + o) + "," + (Math.round((a - n) * s) + n) + ")";
            }
        },
        {
            key: "shadeHexColor",
            value: function(t, e) {
                var i = parseInt(e.slice(1), 16), a = t < 0 ? 0 : 255, s = t < 0 ? -1 * t : t, r = i >> 16, o = i >> 8 & 255, n = 255 & i;
                return "#" + (16777216 + 65536 * (Math.round((a - r) * s) + r) + 256 * (Math.round((a - o) * s) + o) + (Math.round((a - n) * s) + n)).toString(16).slice(1);
            }
        },
        {
            key: "shadeColor",
            value: function(e, i) {
                return t.isColorHex(i) ? this.shadeHexColor(e, i) : this.shadeRGBColor(e, i);
            }
        }
    ], [
        {
            key: "bind",
            value: function(t, e) {
                return function() {
                    return t.apply(e, arguments);
                };
            }
        },
        {
            key: "isObject",
            value: function(t) {
                return t && "object" === $fffa43d1c55f0813$var$i(t) && !Array.isArray(t) && null != t;
            }
        },
        {
            key: "is",
            value: function(t, e) {
                return Object.prototype.toString.call(e) === "[object " + t + "]";
            }
        },
        {
            key: "listToArray",
            value: function(t) {
                var e, i = [];
                for(e = 0; e < t.length; e++)i[e] = t[e];
                return i;
            }
        },
        {
            key: "extend",
            value: function(t, e) {
                var i = this;
                "function" != typeof Object.assign && (Object.assign = function(t) {
                    if (null == t) throw new TypeError("Cannot convert undefined or null to object");
                    for(var e = Object(t), i = 1; i < arguments.length; i++){
                        var a = arguments[i];
                        if (null != a) for(var s in a)a.hasOwnProperty(s) && (e[s] = a[s]);
                    }
                    return e;
                });
                var a = Object.assign({}, t);
                return this.isObject(t) && this.isObject(e) && Object.keys(e).forEach(function(s) {
                    i.isObject(e[s]) && s in t ? a[s] = i.extend(t[s], e[s]) : Object.assign(a, $fffa43d1c55f0813$var$o({}, s, e[s]));
                }), a;
            }
        },
        {
            key: "extendArray",
            value: function(e, i) {
                var a = [];
                return e.map(function(e) {
                    a.push(t.extend(i, e));
                }), e = a;
            }
        },
        {
            key: "monthMod",
            value: function(t) {
                return t % 12;
            }
        },
        {
            key: "clone",
            value: function(e) {
                if (t.is("Array", e)) {
                    for(var a = [], s = 0; s < e.length; s++)a[s] = this.clone(e[s]);
                    return a;
                }
                if (t.is("Null", e)) return null;
                if (t.is("Date", e)) return e;
                if ("object" === $fffa43d1c55f0813$var$i(e)) {
                    var r = {};
                    for(var o in e)e.hasOwnProperty(o) && (r[o] = this.clone(e[o]));
                    return r;
                }
                return e;
            }
        },
        {
            key: "log10",
            value: function(t) {
                return Math.log(t) / Math.LN10;
            }
        },
        {
            key: "roundToBase10",
            value: function(t) {
                return Math.pow(10, Math.floor(Math.log10(t)));
            }
        },
        {
            key: "roundToBase",
            value: function(t, e) {
                return Math.pow(e, Math.floor(Math.log(t) / Math.log(e)));
            }
        },
        {
            key: "parseNumber",
            value: function(t) {
                return null === t ? t : parseFloat(t);
            }
        },
        {
            key: "stripNumber",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2;
                return Number.isInteger(t) ? t : parseFloat(t.toPrecision(e));
            }
        },
        {
            key: "randomId",
            value: function() {
                return (Math.random() + 1).toString(36).substring(4);
            }
        },
        {
            key: "noExponents",
            value: function(t) {
                var e = String(t).split(/[eE]/);
                if (1 === e.length) return e[0];
                var i = "", a = t < 0 ? "-" : "", s = e[0].replace(".", ""), r = Number(e[1]) + 1;
                if (r < 0) {
                    for(i = a + "0."; r++;)i += "0";
                    return i + s.replace(/^-/, "");
                }
                for(r -= s.length; r--;)i += "0";
                return s + i;
            }
        },
        {
            key: "getDimensions",
            value: function(t) {
                var e = getComputedStyle(t, null), i = t.clientHeight, a = t.clientWidth;
                return i -= parseFloat(e.paddingTop) + parseFloat(e.paddingBottom), [
                    a -= parseFloat(e.paddingLeft) + parseFloat(e.paddingRight),
                    i
                ];
            }
        },
        {
            key: "getBoundingClientRect",
            value: function(t) {
                var e = t.getBoundingClientRect();
                return {
                    top: e.top,
                    right: e.right,
                    bottom: e.bottom,
                    left: e.left,
                    width: t.clientWidth,
                    height: t.clientHeight,
                    x: e.left,
                    y: e.top
                };
            }
        },
        {
            key: "getLargestStringFromArr",
            value: function(t) {
                return t.reduce(function(t, e) {
                    return Array.isArray(e) && (e = e.reduce(function(t, e) {
                        return t.length > e.length ? t : e;
                    })), t.length > e.length ? t : e;
                }, 0);
            }
        },
        {
            key: "hexToRgba",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "#999999", e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : .6;
                "#" !== t.substring(0, 1) && (t = "#999999");
                var i = t.replace("#", "");
                i = i.match(new RegExp("(.{" + i.length / 3 + "})", "g"));
                for(var a = 0; a < i.length; a++)i[a] = parseInt(1 === i[a].length ? i[a] + i[a] : i[a], 16);
                return void 0 !== e && i.push(e), "rgba(" + i.join(",") + ")";
            }
        },
        {
            key: "getOpacityFromRGBA",
            value: function(t) {
                return parseFloat(t.replace(/^.*,(.+)\)/, "$1"));
            }
        },
        {
            key: "rgb2hex",
            value: function(t) {
                return (t = t.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i)) && 4 === t.length ? "#" + ("0" + parseInt(t[1], 10).toString(16)).slice(-2) + ("0" + parseInt(t[2], 10).toString(16)).slice(-2) + ("0" + parseInt(t[3], 10).toString(16)).slice(-2) : "";
            }
        },
        {
            key: "isColorHex",
            value: function(t) {
                return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)|(^#[0-9A-F]{8}$)/i.test(t);
            }
        },
        {
            key: "getPolygonPos",
            value: function(t, e) {
                for(var i = [], a = 2 * Math.PI / e, s = 0; s < e; s++){
                    var r = {};
                    r.x = t * Math.sin(s * a), r.y = -t * Math.cos(s * a), i.push(r);
                }
                return i;
            }
        },
        {
            key: "polarToCartesian",
            value: function(t, e, i, a) {
                var s = (a - 90) * Math.PI / 180;
                return {
                    x: t + i * Math.cos(s),
                    y: e + i * Math.sin(s)
                };
            }
        },
        {
            key: "escapeString",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "x", i = t.toString().slice();
                return i = i.replace(/[` ~!@#$%^&*()|+\=?;:'",.<>{}[\]\\/]/gi, e);
            }
        },
        {
            key: "negToZero",
            value: function(t) {
                return t < 0 ? 0 : t;
            }
        },
        {
            key: "moveIndexInArray",
            value: function(t, e, i) {
                if (i >= t.length) for(var a = i - t.length + 1; a--;)t.push(void 0);
                return t.splice(i, 0, t.splice(e, 1)[0]), t;
            }
        },
        {
            key: "extractNumber",
            value: function(t) {
                return parseFloat(t.replace(/[^\d.]*/g, ""));
            }
        },
        {
            key: "findAncestor",
            value: function(t, e) {
                for(; (t = t.parentElement) && !t.classList.contains(e););
                return t;
            }
        },
        {
            key: "setELstyles",
            value: function(t, e) {
                for(var i in e)e.hasOwnProperty(i) && (t.style.key = e[i]);
            }
        },
        {
            key: "isNumber",
            value: function(t) {
                return !isNaN(t) && parseFloat(Number(t)) === t && !isNaN(parseInt(t, 10));
            }
        },
        {
            key: "isFloat",
            value: function(t) {
                return Number(t) === t && t % 1 != 0;
            }
        },
        {
            key: "isSafari",
            value: function() {
                return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            }
        },
        {
            key: "isFirefox",
            value: function() {
                return navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
            }
        },
        {
            key: "isIE11",
            value: function() {
                if (-1 !== window.navigator.userAgent.indexOf("MSIE") || window.navigator.appVersion.indexOf("Trident/") > -1) return !0;
            }
        },
        {
            key: "isIE",
            value: function() {
                var t = window.navigator.userAgent, e = t.indexOf("MSIE ");
                if (e > 0) return parseInt(t.substring(e + 5, t.indexOf(".", e)), 10);
                if (t.indexOf("Trident/") > 0) {
                    var i = t.indexOf("rv:");
                    return parseInt(t.substring(i + 3, t.indexOf(".", i)), 10);
                }
                var a = t.indexOf("Edge/");
                return a > 0 && parseInt(t.substring(a + 5, t.indexOf(".", a)), 10);
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$b = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w, this.setEasingFunctions();
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "setEasingFunctions",
            value: function() {
                var t;
                if (!this.w.globals.easing) {
                    switch(this.w.config.chart.animations.easing){
                        case "linear":
                            t = "-";
                            break;
                        case "easein":
                            t = "<";
                            break;
                        case "easeout":
                            t = ">";
                            break;
                        case "easeinout":
                        default:
                            t = "<>";
                            break;
                        case "swing":
                            t = function(t) {
                                var e = 1.70158;
                                return (t -= 1) * t * ((e + 1) * t + e) + 1;
                            };
                            break;
                        case "bounce":
                            t = function(t) {
                                return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
                            };
                            break;
                        case "elastic":
                            t = function(t) {
                                return t === !!t ? t : Math.pow(2, -10 * t) * Math.sin((t - .075) * (2 * Math.PI) / .3) + 1;
                            };
                    }
                    this.w.globals.easing = t;
                }
            }
        },
        {
            key: "animateLine",
            value: function(t, e, i, a) {
                t.attr(e).animate(a).attr(i);
            }
        },
        {
            key: "animateMarker",
            value: function(t, e, i, a, s, r) {
                e || (e = 0), t.attr({
                    r: e,
                    width: e,
                    height: e
                }).animate(a, s).attr({
                    r: i,
                    width: i.width,
                    height: i.height
                }).afterAll(function() {
                    r();
                });
            }
        },
        {
            key: "animateCircle",
            value: function(t, e, i, a, s) {
                t.attr({
                    r: e.r,
                    cx: e.cx,
                    cy: e.cy
                }).animate(a, s).attr({
                    r: i.r,
                    cx: i.cx,
                    cy: i.cy
                });
            }
        },
        {
            key: "animateRect",
            value: function(t, e, i, a, s) {
                t.attr(e).animate(a).attr(i).afterAll(function() {
                    return s();
                });
            }
        },
        {
            key: "animatePathsGradually",
            value: function(t) {
                var e = t.el, i = t.realIndex, a = t.j, s = t.fill, r = t.pathFrom, o = t.pathTo, n = t.speed, l = t.delay, h = this.w, c = 0;
                h.config.chart.animations.animateGradually.enabled && (c = h.config.chart.animations.animateGradually.delay), h.config.chart.animations.dynamicAnimation.enabled && h.globals.dataChanged && "bar" !== h.config.chart.type && (c = 0), this.morphSVG(e, i, a, "line" !== h.config.chart.type || h.globals.comboCharts ? s : "stroke", r, o, n, l * c);
            }
        },
        {
            key: "showDelayedElements",
            value: function() {
                this.w.globals.delayedElements.forEach(function(t) {
                    var e = t.el;
                    e.classList.remove("apexcharts-element-hidden"), e.classList.add("apexcharts-hidden-element-shown");
                });
            }
        },
        {
            key: "animationCompleted",
            value: function(t) {
                var e = this.w;
                e.globals.animationEnded || (e.globals.animationEnded = !0, this.showDelayedElements(), "function" == typeof e.config.chart.events.animationEnd && e.config.chart.events.animationEnd(this.ctx, {
                    el: t,
                    w: e
                }));
            }
        },
        {
            key: "morphSVG",
            value: function(t, e, i, a, s, r, o, n) {
                var l = this, h = this.w;
                s || (s = t.attr("pathFrom")), r || (r = t.attr("pathTo"));
                var c = function(t) {
                    return "radar" === h.config.chart.type && (o = 1), "M 0 ".concat(h.globals.gridHeight);
                };
                (!s || s.indexOf("undefined") > -1 || s.indexOf("NaN") > -1) && (s = c()), (!r || r.indexOf("undefined") > -1 || r.indexOf("NaN") > -1) && (r = c()), h.globals.shouldAnimate || (o = 1), t.plot(s).animate(1, h.globals.easing, n).plot(s).animate(o, h.globals.easing, n).plot(r).afterAll(function() {
                    $fffa43d1c55f0813$var$x.isNumber(i) ? i === h.globals.series[h.globals.maxValsInArrayIndex].length - 2 && h.globals.shouldAnimate && l.animationCompleted(t) : "none" !== a && h.globals.shouldAnimate && (!h.globals.comboCharts && e === h.globals.series.length - 1 || h.globals.comboCharts) && l.animationCompleted(t), l.showDelayedElements();
                });
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$v = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "getDefaultFilter",
            value: function(t, e) {
                var i = this.w;
                t.unfilter(!0), (new window.SVG.Filter).size("120%", "180%", "-5%", "-40%"), "none" !== i.config.states.normal.filter ? this.applyFilter(t, e, i.config.states.normal.filter.type, i.config.states.normal.filter.value) : i.config.chart.dropShadow.enabled && this.dropShadow(t, i.config.chart.dropShadow, e);
            }
        },
        {
            key: "addNormalFilter",
            value: function(t, e) {
                var i = this.w;
                i.config.chart.dropShadow.enabled && !t.node.classList.contains("apexcharts-marker") && this.dropShadow(t, i.config.chart.dropShadow, e);
            }
        },
        {
            key: "addLightenFilter",
            value: function(t, e, i) {
                var a = this, s = this.w, r = i.intensity;
                t.unfilter(!0);
                new window.SVG.Filter;
                t.filter(function(t) {
                    var i = s.config.chart.dropShadow;
                    (i.enabled ? a.addShadow(t, e, i) : t).componentTransfer({
                        rgb: {
                            type: "linear",
                            slope: 1.5,
                            intercept: r
                        }
                    });
                }), t.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(t.filterer.node);
            }
        },
        {
            key: "addDarkenFilter",
            value: function(t, e, i) {
                var a = this, s = this.w, r = i.intensity;
                t.unfilter(!0);
                new window.SVG.Filter;
                t.filter(function(t) {
                    var i = s.config.chart.dropShadow;
                    (i.enabled ? a.addShadow(t, e, i) : t).componentTransfer({
                        rgb: {
                            type: "linear",
                            slope: r
                        }
                    });
                }), t.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(t.filterer.node);
            }
        },
        {
            key: "applyFilter",
            value: function(t, e, i) {
                var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : .5;
                switch(i){
                    case "none":
                        this.addNormalFilter(t, e);
                        break;
                    case "lighten":
                        this.addLightenFilter(t, e, {
                            intensity: a
                        });
                        break;
                    case "darken":
                        this.addDarkenFilter(t, e, {
                            intensity: a
                        });
                }
            }
        },
        {
            key: "addShadow",
            value: function(t, e, i) {
                var a = i.blur, s = i.top, r = i.left, o = i.color, n = i.opacity, l = t.flood(Array.isArray(o) ? o[e] : o, n).composite(t.sourceAlpha, "in").offset(r, s).gaussianBlur(a).merge(t.source);
                return t.blend(t.source, l);
            }
        },
        {
            key: "dropShadow",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, a = e.top, s = e.left, r = e.blur, o = e.color, n = e.opacity, l = e.noUserSpaceOnUse, h = this.w;
                return t.unfilter(!0), $fffa43d1c55f0813$var$x.isIE() && "radialBar" === h.config.chart.type || (o = Array.isArray(o) ? o[i] : o, t.filter(function(t) {
                    var e = null;
                    e = $fffa43d1c55f0813$var$x.isSafari() || $fffa43d1c55f0813$var$x.isFirefox() || $fffa43d1c55f0813$var$x.isIE() ? t.flood(o, n).composite(t.sourceAlpha, "in").offset(s, a).gaussianBlur(r) : t.flood(o, n).composite(t.sourceAlpha, "in").offset(s, a).gaussianBlur(r).merge(t.source), t.blend(t.source, e);
                }), l || t.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(t.filterer.node)), t;
            }
        },
        {
            key: "setSelectionFilter",
            value: function(t, e, i) {
                var a = this.w;
                if (void 0 !== a.globals.selectedDataPoints[e] && a.globals.selectedDataPoints[e].indexOf(i) > -1) {
                    t.node.setAttribute("selected", !0);
                    var s = a.config.states.active.filter;
                    "none" !== s && this.applyFilter(t, e, s.type, s.value);
                }
            }
        },
        {
            key: "_scaleFilterSize",
            value: function(t) {
                !function(e) {
                    for(var i in e)e.hasOwnProperty(i) && t.setAttribute(i, e[i]);
                }({
                    width: "200%",
                    height: "200%",
                    x: "-50%",
                    y: "-50%"
                });
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$m = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "roundPathCorners",
            value: function(t, e) {
                function i(t, e, i) {
                    var s = e.x - t.x, r = e.y - t.y, o = Math.sqrt(s * s + r * r);
                    return a(t, e, Math.min(1, i / o));
                }
                function a(t, e, i) {
                    return {
                        x: t.x + (e.x - t.x) * i,
                        y: t.y + (e.y - t.y) * i
                    };
                }
                function s(t, e) {
                    t.length > 2 && (t[t.length - 2] = e.x, t[t.length - 1] = e.y);
                }
                function r(t) {
                    return {
                        x: parseFloat(t[t.length - 2]),
                        y: parseFloat(t[t.length - 1])
                    };
                }
                t.indexOf("NaN") > -1 && (t = "");
                var o = t.split(/[,\s]/).reduce(function(t, e) {
                    var i = e.match("([a-zA-Z])(.+)");
                    return i ? (t.push(i[1]), t.push(i[2])) : t.push(e), t;
                }, []).reduce(function(t, e) {
                    return parseFloat(e) == e && t.length ? t[t.length - 1].push(e) : t.push([
                        e
                    ]), t;
                }, []), n = [];
                if (o.length > 1) {
                    var l = r(o[0]), h = null;
                    "Z" == o[o.length - 1][0] && o[0].length > 2 && (h = [
                        "L",
                        l.x,
                        l.y
                    ], o[o.length - 1] = h), n.push(o[0]);
                    for(var c = 1; c < o.length; c++){
                        var d = n[n.length - 1], g = o[c], u = g == h ? o[1] : o[c + 1];
                        if (u && d && d.length > 2 && "L" == g[0] && u.length > 2 && "L" == u[0]) {
                            var p, f, x = r(d), b = r(g), v = r(u);
                            p = i(b, x, e), f = i(b, v, e), s(g, p), g.origPoint = b, n.push(g);
                            var m = a(p, b, .5), y = a(b, f, .5), w = [
                                "C",
                                m.x,
                                m.y,
                                y.x,
                                y.y,
                                f.x,
                                f.y
                            ];
                            w.origPoint = b, n.push(w);
                        } else n.push(g);
                    }
                    if (h) {
                        var k = r(n[n.length - 1]);
                        n.push([
                            "Z"
                        ]), s(n[0], k);
                    }
                } else n = o;
                return n.reduce(function(t, e) {
                    return t + e.join(" ") + " ";
                }, "");
            }
        },
        {
            key: "drawLine",
            value: function(t, e, i, a) {
                var s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "#a8a8a8", r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0, o = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : null, n = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : "butt";
                return this.w.globals.dom.Paper.line().attr({
                    x1: t,
                    y1: e,
                    x2: i,
                    y2: a,
                    stroke: s,
                    "stroke-dasharray": r,
                    "stroke-width": o,
                    "stroke-linecap": n
                });
            }
        },
        {
            key: "drawRect",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : "#fefefe", o = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 1, n = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : null, l = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : null, h = arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : 0, c = this.w.globals.dom.Paper.rect();
                return c.attr({
                    x: t,
                    y: e,
                    width: i > 0 ? i : 0,
                    height: a > 0 ? a : 0,
                    rx: s,
                    ry: s,
                    opacity: o,
                    "stroke-width": null !== n ? n : 0,
                    stroke: null !== l ? l : "none",
                    "stroke-dasharray": h
                }), c.node.setAttribute("fill", r), c;
            }
        },
        {
            key: "drawPolygon",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "#e1e1e1", i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "none";
                return this.w.globals.dom.Paper.polygon(t).attr({
                    fill: a,
                    stroke: e,
                    "stroke-width": i
                });
            }
        },
        {
            key: "drawCircle",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                t < 0 && (t = 0);
                var i = this.w.globals.dom.Paper.circle(2 * t);
                return null !== e && i.attr(e), i;
            }
        },
        {
            key: "drawPath",
            value: function(t) {
                var e = t.d, i = void 0 === e ? "" : e, a = t.stroke, s = void 0 === a ? "#a8a8a8" : a, r = t.strokeWidth, o = void 0 === r ? 1 : r, n = t.fill, l = t.fillOpacity, h = void 0 === l ? 1 : l, c = t.strokeOpacity, d = void 0 === c ? 1 : c, g = t.classes, u = t.strokeLinecap, p = void 0 === u ? null : u, f = t.strokeDashArray, x = void 0 === f ? 0 : f, b = this.w;
                return null === p && (p = b.config.stroke.lineCap), (i.indexOf("undefined") > -1 || i.indexOf("NaN") > -1) && (i = "M 0 ".concat(b.globals.gridHeight)), b.globals.dom.Paper.path(i).attr({
                    fill: n,
                    "fill-opacity": h,
                    stroke: s,
                    "stroke-opacity": d,
                    "stroke-linecap": p,
                    "stroke-width": o,
                    "stroke-dasharray": x,
                    class: g
                });
            }
        },
        {
            key: "group",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, e = this.w.globals.dom.Paper.group();
                return null !== t && e.attr(t), e;
            }
        },
        {
            key: "move",
            value: function(t, e) {
                var i = [
                    "M",
                    t,
                    e
                ].join(" ");
                return i;
            }
        },
        {
            key: "line",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = null;
                return null === i ? a = [
                    " L",
                    t,
                    e
                ].join(" ") : "H" === i ? a = [
                    " H",
                    t
                ].join(" ") : "V" === i && (a = [
                    " V",
                    e
                ].join(" ")), a;
            }
        },
        {
            key: "curve",
            value: function(t, e, i, a, s, r) {
                var o = [
                    "C",
                    t,
                    e,
                    i,
                    a,
                    s,
                    r
                ].join(" ");
                return o;
            }
        },
        {
            key: "quadraticCurve",
            value: function(t, e, i, a) {
                return [
                    "Q",
                    t,
                    e,
                    i,
                    a
                ].join(" ");
            }
        },
        {
            key: "arc",
            value: function(t, e, i, a, s, r, o) {
                var n = "A";
                arguments.length > 7 && void 0 !== arguments[7] && arguments[7] && (n = "a");
                var l = [
                    n,
                    t,
                    e,
                    i,
                    a,
                    s,
                    r,
                    o
                ].join(" ");
                return l;
            }
        },
        {
            key: "renderPaths",
            value: function(t) {
                var i, a = t.j, s = t.realIndex, r = t.pathFrom, o = t.pathTo, n = t.stroke, l = t.strokeWidth, h = t.strokeLinecap, c = t.fill, d = t.animationDelay, g = t.initialSpeed, u = t.dataChangeSpeed, p = t.className, f = t.shouldClipToGrid, x = void 0 === f || f, m = t.bindEventsOnPaths, y = void 0 === m || m, w = t.drawShadow, k = void 0 === w || w, A = this.w, S = new $fffa43d1c55f0813$var$v(this.ctx), C = new $fffa43d1c55f0813$var$b(this.ctx), L = this.w.config.chart.animations.enabled, P = L && this.w.config.chart.animations.dynamicAnimation.enabled, I = !!(L && !A.globals.resized || P && A.globals.dataChanged && A.globals.shouldAnimate);
                I ? i = r : (i = o, A.globals.animationEnded = !0);
                var T = A.config.stroke.dashArray, M = 0;
                M = Array.isArray(T) ? T[s] : A.config.stroke.dashArray;
                var z = this.drawPath({
                    d: i,
                    stroke: n,
                    strokeWidth: l,
                    fill: c,
                    fillOpacity: 1,
                    classes: p,
                    strokeLinecap: h,
                    strokeDashArray: M
                });
                if (z.attr("index", s), x && z.attr({
                    "clip-path": "url(#gridRectMask".concat(A.globals.cuid, ")")
                }), "none" !== A.config.states.normal.filter.type) S.getDefaultFilter(z, s);
                else if (A.config.chart.dropShadow.enabled && k && (!A.config.chart.dropShadow.enabledOnSeries || A.config.chart.dropShadow.enabledOnSeries && -1 !== A.config.chart.dropShadow.enabledOnSeries.indexOf(s))) {
                    var X = A.config.chart.dropShadow;
                    S.dropShadow(z, X, s);
                }
                y && (z.node.addEventListener("mouseenter", this.pathMouseEnter.bind(this, z)), z.node.addEventListener("mouseleave", this.pathMouseLeave.bind(this, z)), z.node.addEventListener("mousedown", this.pathMouseDown.bind(this, z))), z.attr({
                    pathTo: o,
                    pathFrom: r
                });
                var E = {
                    el: z,
                    j: a,
                    realIndex: s,
                    pathFrom: r,
                    pathTo: o,
                    fill: c,
                    strokeWidth: l,
                    delay: d
                };
                return !L || A.globals.resized || A.globals.dataChanged ? !A.globals.resized && A.globals.dataChanged || C.showDelayedElements() : C.animatePathsGradually($fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, E), {}, {
                    speed: g
                })), A.globals.dataChanged && P && I && C.animatePathsGradually($fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, E), {}, {
                    speed: u
                })), z;
            }
        },
        {
            key: "drawPattern",
            value: function(t, e, i) {
                var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "#a8a8a8", s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0;
                return this.w.globals.dom.Paper.pattern(e, i, function(r) {
                    "horizontalLines" === t ? r.line(0, 0, i, 0).stroke({
                        color: a,
                        width: s + 1
                    }) : "verticalLines" === t ? r.line(0, 0, 0, e).stroke({
                        color: a,
                        width: s + 1
                    }) : "slantedLines" === t ? r.line(0, 0, e, i).stroke({
                        color: a,
                        width: s
                    }) : "squares" === t ? r.rect(e, i).fill("none").stroke({
                        color: a,
                        width: s
                    }) : "circles" === t && r.circle(e).fill("none").stroke({
                        color: a,
                        width: s
                    });
                });
            }
        },
        {
            key: "drawGradient",
            value: function(t, e, i, a, s) {
                var r, o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null, n = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : null, l = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : null, h = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : 0, c = this.w;
                e.length < 9 && 0 === e.indexOf("#") && (e = $fffa43d1c55f0813$var$x.hexToRgba(e, a)), i.length < 9 && 0 === i.indexOf("#") && (i = $fffa43d1c55f0813$var$x.hexToRgba(i, s));
                var d = 0, g = 1, u = 1, p = null;
                null !== n && (d = void 0 !== n[0] ? n[0] / 100 : 0, g = void 0 !== n[1] ? n[1] / 100 : 1, u = void 0 !== n[2] ? n[2] / 100 : 1, p = void 0 !== n[3] ? n[3] / 100 : null);
                var f = !("donut" !== c.config.chart.type && "pie" !== c.config.chart.type && "polarArea" !== c.config.chart.type && "bubble" !== c.config.chart.type);
                if (r = null === l || 0 === l.length ? c.globals.dom.Paper.gradient(f ? "radial" : "linear", function(t) {
                    t.at(d, e, a), t.at(g, i, s), t.at(u, i, s), null !== p && t.at(p, e, a);
                }) : c.globals.dom.Paper.gradient(f ? "radial" : "linear", function(t) {
                    (Array.isArray(l[h]) ? l[h] : l).forEach(function(e) {
                        t.at(e.offset / 100, e.color, e.opacity);
                    });
                }), f) {
                    var b = c.globals.gridWidth / 2, v = c.globals.gridHeight / 2;
                    "bubble" !== c.config.chart.type ? r.attr({
                        gradientUnits: "userSpaceOnUse",
                        cx: b,
                        cy: v,
                        r: o
                    }) : r.attr({
                        cx: .5,
                        cy: .5,
                        r: .8,
                        fx: .2,
                        fy: .2
                    });
                } else "vertical" === t ? r.from(0, 0).to(0, 1) : "diagonal" === t ? r.from(0, 0).to(1, 1) : "horizontal" === t ? r.from(0, 1).to(1, 1) : "diagonal2" === t && r.from(1, 0).to(0, 1);
                return r;
            }
        },
        {
            key: "getTextBasedOnMaxWidth",
            value: function(t) {
                var e = t.text, i = t.maxWidth, a = t.fontSize, s = t.fontFamily, r = this.getTextRects(e, a, s), o = r.width / e.length, n = Math.floor(i / o);
                return i < r.width ? e.slice(0, n - 3) + "..." : e;
            }
        },
        {
            key: "drawText",
            value: function(t) {
                var i = this, a = t.x, s = t.y, r = t.text, o = t.textAnchor, n = t.fontSize, l = t.fontFamily, h = t.fontWeight, c = t.foreColor, d = t.opacity, g = t.maxWidth, u = t.cssClass, p = void 0 === u ? "" : u, f = t.isPlainText, x = void 0 === f || f, b = t.dominantBaseline, v = void 0 === b ? "auto" : b, m = this.w;
                void 0 === r && (r = "");
                var y = r;
                o || (o = "start"), c && c.length || (c = m.config.chart.foreColor), l = l || m.config.chart.fontFamily, h = h || "regular";
                var w, k = {
                    maxWidth: g,
                    fontSize: n = n || "11px",
                    fontFamily: l
                };
                return Array.isArray(r) ? w = m.globals.dom.Paper.text(function(t) {
                    for(var a = 0; a < r.length; a++)y = r[a], g && (y = i.getTextBasedOnMaxWidth($fffa43d1c55f0813$var$e({
                        text: r[a]
                    }, k))), 0 === a ? t.tspan(y) : t.tspan(y).newLine();
                }) : (g && (y = this.getTextBasedOnMaxWidth($fffa43d1c55f0813$var$e({
                    text: r
                }, k))), w = x ? m.globals.dom.Paper.plain(r) : m.globals.dom.Paper.text(function(t) {
                    return t.tspan(y);
                })), w.attr({
                    x: a,
                    y: s,
                    "text-anchor": o,
                    "dominant-baseline": v,
                    "font-size": n,
                    "font-family": l,
                    "font-weight": h,
                    fill: c,
                    class: "apexcharts-text " + p
                }), w.node.style.fontFamily = l, w.node.style.opacity = d, w;
            }
        },
        {
            key: "drawMarker",
            value: function(t, e, i) {
                t = t || 0;
                var a = i.pSize || 0, s = null;
                if ("square" === i.shape || "rect" === i.shape) {
                    var r = void 0 === i.pRadius ? a / 2 : i.pRadius;
                    null !== e && a || (a = 0, r = 0);
                    var o = 1.2 * a + r, n = this.drawRect(o, o, o, o, r);
                    n.attr({
                        x: t - o / 2,
                        y: e - o / 2,
                        cx: t,
                        cy: e,
                        class: i.class ? i.class : "",
                        fill: i.pointFillColor,
                        "fill-opacity": i.pointFillOpacity ? i.pointFillOpacity : 1,
                        stroke: i.pointStrokeColor,
                        "stroke-width": i.pointStrokeWidth ? i.pointStrokeWidth : 0,
                        "stroke-opacity": i.pointStrokeOpacity ? i.pointStrokeOpacity : 1
                    }), s = n;
                } else "circle" !== i.shape && i.shape || ($fffa43d1c55f0813$var$x.isNumber(e) || (a = 0, e = 0), s = this.drawCircle(a, {
                    cx: t,
                    cy: e,
                    class: i.class ? i.class : "",
                    stroke: i.pointStrokeColor,
                    fill: i.pointFillColor,
                    "fill-opacity": i.pointFillOpacity ? i.pointFillOpacity : 1,
                    "stroke-width": i.pointStrokeWidth ? i.pointStrokeWidth : 0,
                    "stroke-opacity": i.pointStrokeOpacity ? i.pointStrokeOpacity : 1
                }));
                return s;
            }
        },
        {
            key: "pathMouseEnter",
            value: function(t, e) {
                var i = this.w, a = new $fffa43d1c55f0813$var$v(this.ctx), s = parseInt(t.node.getAttribute("index"), 10), r = parseInt(t.node.getAttribute("j"), 10);
                if ("function" == typeof i.config.chart.events.dataPointMouseEnter && i.config.chart.events.dataPointMouseEnter(e, this.ctx, {
                    seriesIndex: s,
                    dataPointIndex: r,
                    w: i
                }), this.ctx.events.fireEvent("dataPointMouseEnter", [
                    e,
                    this.ctx,
                    {
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }
                ]), ("none" === i.config.states.active.filter.type || "true" !== t.node.getAttribute("selected")) && "none" !== i.config.states.hover.filter.type && !i.globals.isTouchDevice) {
                    var o = i.config.states.hover.filter;
                    a.applyFilter(t, s, o.type, o.value);
                }
            }
        },
        {
            key: "pathMouseLeave",
            value: function(t, e) {
                var i = this.w, a = new $fffa43d1c55f0813$var$v(this.ctx), s = parseInt(t.node.getAttribute("index"), 10), r = parseInt(t.node.getAttribute("j"), 10);
                "function" == typeof i.config.chart.events.dataPointMouseLeave && i.config.chart.events.dataPointMouseLeave(e, this.ctx, {
                    seriesIndex: s,
                    dataPointIndex: r,
                    w: i
                }), this.ctx.events.fireEvent("dataPointMouseLeave", [
                    e,
                    this.ctx,
                    {
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }
                ]), "none" !== i.config.states.active.filter.type && "true" === t.node.getAttribute("selected") || "none" !== i.config.states.hover.filter.type && a.getDefaultFilter(t, s);
            }
        },
        {
            key: "pathMouseDown",
            value: function(t, e) {
                var i = this.w, a = new $fffa43d1c55f0813$var$v(this.ctx), s = parseInt(t.node.getAttribute("index"), 10), r = parseInt(t.node.getAttribute("j"), 10), o = "false";
                if ("true" === t.node.getAttribute("selected")) {
                    if (t.node.setAttribute("selected", "false"), i.globals.selectedDataPoints[s].indexOf(r) > -1) {
                        var n = i.globals.selectedDataPoints[s].indexOf(r);
                        i.globals.selectedDataPoints[s].splice(n, 1);
                    }
                } else {
                    if (!i.config.states.active.allowMultipleDataPointsSelection && i.globals.selectedDataPoints.length > 0) {
                        i.globals.selectedDataPoints = [];
                        var l = i.globals.dom.Paper.select(".apexcharts-series path").members, h = i.globals.dom.Paper.select(".apexcharts-series circle, .apexcharts-series rect").members, c = function(t) {
                            Array.prototype.forEach.call(t, function(t) {
                                t.node.setAttribute("selected", "false"), a.getDefaultFilter(t, s);
                            });
                        };
                        c(l), c(h);
                    }
                    t.node.setAttribute("selected", "true"), o = "true", void 0 === i.globals.selectedDataPoints[s] && (i.globals.selectedDataPoints[s] = []), i.globals.selectedDataPoints[s].push(r);
                }
                if ("true" === o) {
                    var d = i.config.states.active.filter;
                    if ("none" !== d) a.applyFilter(t, s, d.type, d.value);
                    else if ("none" !== i.config.states.hover.filter && !i.globals.isTouchDevice) {
                        var g = i.config.states.hover.filter;
                        a.applyFilter(t, s, g.type, g.value);
                    }
                } else if ("none" !== i.config.states.active.filter.type) {
                    if ("none" === i.config.states.hover.filter.type || i.globals.isTouchDevice) a.getDefaultFilter(t, s);
                    else {
                        g = i.config.states.hover.filter;
                        a.applyFilter(t, s, g.type, g.value);
                    }
                }
                "function" == typeof i.config.chart.events.dataPointSelection && i.config.chart.events.dataPointSelection(e, this.ctx, {
                    selectedDataPoints: i.globals.selectedDataPoints,
                    seriesIndex: s,
                    dataPointIndex: r,
                    w: i
                }), e && this.ctx.events.fireEvent("dataPointSelection", [
                    e,
                    this.ctx,
                    {
                        selectedDataPoints: i.globals.selectedDataPoints,
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }
                ]);
            }
        },
        {
            key: "rotateAroundCenter",
            value: function(t) {
                var e = {};
                return t && "function" == typeof t.getBBox && (e = t.getBBox()), {
                    x: e.x + e.width / 2,
                    y: e.y + e.height / 2
                };
            }
        },
        {
            key: "getTextRects",
            value: function(t, e, i, a) {
                var s = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4], r = this.w, o = this.drawText({
                    x: -200,
                    y: -200,
                    text: t,
                    textAnchor: "start",
                    fontSize: e,
                    fontFamily: i,
                    foreColor: "#fff",
                    opacity: 0
                });
                a && o.attr("transform", a), r.globals.dom.Paper.add(o);
                var n = o.bbox();
                return s || (n = o.node.getBoundingClientRect()), o.remove(), {
                    width: n.width,
                    height: n.height
                };
            }
        },
        {
            key: "placeTextWithEllipsis",
            value: function(t, e, i) {
                if ("function" == typeof t.getComputedTextLength && (t.textContent = e, e.length > 0 && t.getComputedTextLength() >= i / 1.1)) {
                    for(var a = e.length - 3; a > 0; a -= 3)if (t.getSubStringLength(0, a) <= i / 1.1) return void (t.textContent = e.substring(0, a) + "...");
                    t.textContent = ".";
                }
            }
        }
    ], [
        {
            key: "setAttrs",
            value: function(t, e) {
                for(var i in e)e.hasOwnProperty(i) && t.setAttribute(i, e[i]);
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$y = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "getStackedSeriesTotals",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], e = this.w, i = [];
                if (0 === e.globals.series.length) return i;
                for(var a = 0; a < e.globals.series[e.globals.maxValsInArrayIndex].length; a++){
                    for(var s = 0, r = 0; r < e.globals.series.length; r++)void 0 !== e.globals.series[r][a] && -1 === t.indexOf(r) && (s += e.globals.series[r][a]);
                    i.push(s);
                }
                return i;
            }
        },
        {
            key: "getSeriesTotalByIndex",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                return null === t ? this.w.config.series.reduce(function(t, e) {
                    return t + e;
                }, 0) : this.w.globals.series[t].reduce(function(t, e) {
                    return t + e;
                }, 0);
            }
        },
        {
            key: "getStackedSeriesTotalsByGroups",
            value: function() {
                var t = this, e = this.w, i = [];
                return e.globals.seriesGroups.forEach(function(a) {
                    var s = [];
                    e.config.series.forEach(function(t, e) {
                        a.indexOf(t.name) > -1 && s.push(e);
                    });
                    var r = e.globals.series.map(function(t, e) {
                        return -1 === s.indexOf(e) ? e : -1;
                    }).filter(function(t) {
                        return -1 !== t;
                    });
                    i.push(t.getStackedSeriesTotals(r));
                }), i;
            }
        },
        {
            key: "isSeriesNull",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                return 0 === (null === t ? this.w.config.series.filter(function(t) {
                    return null !== t;
                }) : this.w.config.series[t].data.filter(function(t) {
                    return null !== t;
                })).length;
            }
        },
        {
            key: "seriesHaveSameValues",
            value: function(t) {
                return this.w.globals.series[t].every(function(t, e, i) {
                    return t === i[0];
                });
            }
        },
        {
            key: "getCategoryLabels",
            value: function(t) {
                var e = this.w, i = t.slice();
                return e.config.xaxis.convertedCatToNumeric && (i = t.map(function(t, i) {
                    return e.config.xaxis.labels.formatter(t - e.globals.minX + 1);
                })), i;
            }
        },
        {
            key: "getLargestSeries",
            value: function() {
                var t = this.w;
                t.globals.maxValsInArrayIndex = t.globals.series.map(function(t) {
                    return t.length;
                }).indexOf(Math.max.apply(Math, t.globals.series.map(function(t) {
                    return t.length;
                })));
            }
        },
        {
            key: "getLargestMarkerSize",
            value: function() {
                var t = this.w, e = 0;
                return t.globals.markers.size.forEach(function(t) {
                    e = Math.max(e, t);
                }), t.config.markers.discrete && t.config.markers.discrete.length && t.config.markers.discrete.forEach(function(t) {
                    e = Math.max(e, t.size);
                }), e > 0 && (e += t.config.markers.hover.sizeOffset + 1), t.globals.markers.largestSize = e, e;
            }
        },
        {
            key: "getSeriesTotals",
            value: function() {
                var t = this.w;
                t.globals.seriesTotals = t.globals.series.map(function(t, e) {
                    var i = 0;
                    if (Array.isArray(t)) for(var a = 0; a < t.length; a++)i += t[a];
                    else i += t;
                    return i;
                });
            }
        },
        {
            key: "getSeriesTotalsXRange",
            value: function(t, e) {
                var i = this.w;
                return i.globals.series.map(function(a, s) {
                    for(var r = 0, o = 0; o < a.length; o++)i.globals.seriesX[s][o] > t && i.globals.seriesX[s][o] < e && (r += a[o]);
                    return r;
                });
            }
        },
        {
            key: "getPercentSeries",
            value: function() {
                var t = this.w;
                t.globals.seriesPercent = t.globals.series.map(function(e, i) {
                    var a = [];
                    if (Array.isArray(e)) for(var s = 0; s < e.length; s++){
                        var r = t.globals.stackedSeriesTotals[s], o = 0;
                        r && (o = 100 * e[s] / r), a.push(o);
                    }
                    else {
                        var n = 100 * e / t.globals.seriesTotals.reduce(function(t, e) {
                            return t + e;
                        }, 0);
                        a.push(n);
                    }
                    return a;
                });
            }
        },
        {
            key: "getCalculatedRatios",
            value: function() {
                var t, e, i, a, s = this.w.globals, r = [], o = 0, n = [], l = .1, h = 0;
                if (s.yRange = [], s.isMultipleYAxis) for(var c = 0; c < s.minYArr.length; c++)s.yRange.push(Math.abs(s.minYArr[c] - s.maxYArr[c])), n.push(0);
                else s.yRange.push(Math.abs(s.minY - s.maxY));
                s.xRange = Math.abs(s.maxX - s.minX), s.zRange = Math.abs(s.maxZ - s.minZ);
                for(var d = 0; d < s.yRange.length; d++)r.push(s.yRange[d] / s.gridHeight);
                if (e = s.xRange / s.gridWidth, i = Math.abs(s.initialMaxX - s.initialMinX) / s.gridWidth, t = s.yRange / s.gridWidth, a = s.xRange / s.gridHeight, (o = s.zRange / s.gridHeight * 16) || (o = 1), s.minY !== Number.MIN_VALUE && 0 !== Math.abs(s.minY) && (s.hasNegs = !0), s.isMultipleYAxis) {
                    n = [];
                    for(var g = 0; g < r.length; g++)n.push(-s.minYArr[g] / r[g]);
                } else n.push(-s.minY / r[0]), s.minY !== Number.MIN_VALUE && 0 !== Math.abs(s.minY) && (l = -s.minY / t, h = s.minX / e);
                return {
                    yRatio: r,
                    invertedYRatio: t,
                    zRatio: o,
                    xRatio: e,
                    initialXRatio: i,
                    invertedXRatio: a,
                    baseLineInvertedY: l,
                    baseLineY: n,
                    baseLineX: h
                };
            }
        },
        {
            key: "getLogSeries",
            value: function(t) {
                var e = this, i = this.w;
                return i.globals.seriesLog = t.map(function(t, a) {
                    return i.config.yaxis[a] && i.config.yaxis[a].logarithmic ? t.map(function(t) {
                        return null === t ? null : e.getLogVal(i.config.yaxis[a].logBase, t, a);
                    }) : t;
                }), i.globals.invalidLogScale ? t : i.globals.seriesLog;
            }
        },
        {
            key: "getBaseLog",
            value: function(t, e) {
                return Math.log(e) / Math.log(t);
            }
        },
        {
            key: "getLogVal",
            value: function(t, e, i) {
                if (0 === e) return 0;
                var a = this.w, s = 0 === a.globals.minYArr[i] ? -1 : this.getBaseLog(t, a.globals.minYArr[i]), r = (0 === a.globals.maxYArr[i] ? 0 : this.getBaseLog(t, a.globals.maxYArr[i])) - s;
                return e < 1 ? e / r : (this.getBaseLog(t, e) - s) / r;
            }
        },
        {
            key: "getLogYRatios",
            value: function(t) {
                var e = this, i = this.w, a = this.w.globals;
                return a.yLogRatio = t.slice(), a.logYRange = a.yRange.map(function(t, s) {
                    if (i.config.yaxis[s] && e.w.config.yaxis[s].logarithmic) {
                        var r, o = -Number.MAX_VALUE, n = Number.MIN_VALUE;
                        return a.seriesLog.forEach(function(t, e) {
                            t.forEach(function(t) {
                                i.config.yaxis[e] && i.config.yaxis[e].logarithmic && (o = Math.max(t, o), n = Math.min(t, n));
                            });
                        }), r = Math.pow(a.yRange[s], Math.abs(n - o) / a.yRange[s]), a.yLogRatio[s] = r / a.gridHeight, r;
                    }
                }), a.invalidLogScale ? t.slice() : a.yLogRatio;
            }
        }
    ], [
        {
            key: "checkComboSeries",
            value: function(t) {
                var e = !1, i = 0, a = 0;
                return t.length && void 0 !== t[0].type && t.forEach(function(t) {
                    "bar" !== t.type && "column" !== t.type && "candlestick" !== t.type && "boxPlot" !== t.type || i++, void 0 !== t.type && a++;
                }), a > 0 && (e = !0), {
                    comboBarCount: i,
                    comboCharts: e
                };
            }
        },
        {
            key: "extendArrayProps",
            value: function(t, e, i) {
                return e.yaxis && (e = t.extendYAxis(e, i)), e.annotations && (e.annotations.yaxis && (e = t.extendYAxisAnnotations(e)), e.annotations.xaxis && (e = t.extendXAxisAnnotations(e)), e.annotations.points && (e = t.extendPointAnnotations(e))), e;
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$w = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.w = e.w, this.annoCtx = e;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "setOrientations",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, i = this.w;
                if ("vertical" === t.label.orientation) {
                    var a = null !== e ? e : 0, s = i.globals.dom.baseEl.querySelector(".apexcharts-xaxis-annotations .apexcharts-xaxis-annotation-label[rel='".concat(a, "']"));
                    if (null !== s) {
                        var r = s.getBoundingClientRect();
                        s.setAttribute("x", parseFloat(s.getAttribute("x")) - r.height + 4), "top" === t.label.position ? s.setAttribute("y", parseFloat(s.getAttribute("y")) + r.width) : s.setAttribute("y", parseFloat(s.getAttribute("y")) - r.width);
                        var o = this.annoCtx.graphics.rotateAroundCenter(s), n = o.x, l = o.y;
                        s.setAttribute("transform", "rotate(-90 ".concat(n, " ").concat(l, ")"));
                    }
                }
            }
        },
        {
            key: "addBackgroundToAnno",
            value: function(t, e) {
                var i = this.w;
                if (!t || void 0 === e.label.text || void 0 !== e.label.text && !String(e.label.text).trim()) return null;
                var a = i.globals.dom.baseEl.querySelector(".apexcharts-grid").getBoundingClientRect(), s = t.getBoundingClientRect(), r = e.label.style.padding.left, o = e.label.style.padding.right, n = e.label.style.padding.top, l = e.label.style.padding.bottom;
                "vertical" === e.label.orientation && (n = e.label.style.padding.left, l = e.label.style.padding.right, r = e.label.style.padding.top, o = e.label.style.padding.bottom);
                var h = s.left - a.left - r, c = s.top - a.top - n, d = this.annoCtx.graphics.drawRect(h - i.globals.barPadForNumericAxis, c, s.width + r + o, s.height + n + l, e.label.borderRadius, e.label.style.background, 1, e.label.borderWidth, e.label.borderColor, 0);
                return e.id && d.node.classList.add(e.id), d;
            }
        },
        {
            key: "annotationsBackground",
            value: function() {
                var t = this, e = this.w, i = function(i, a, s) {
                    var r = e.globals.dom.baseEl.querySelector(".apexcharts-".concat(s, "-annotations .apexcharts-").concat(s, "-annotation-label[rel='").concat(a, "']"));
                    if (r) {
                        var o = r.parentNode, n = t.addBackgroundToAnno(r, i);
                        n && (o.insertBefore(n.node, r), i.label.mouseEnter && n.node.addEventListener("mouseenter", i.label.mouseEnter.bind(t, i)), i.label.mouseLeave && n.node.addEventListener("mouseleave", i.label.mouseLeave.bind(t, i)), i.label.click && n.node.addEventListener("click", i.label.click.bind(t, i)));
                    }
                };
                e.config.annotations.xaxis.map(function(t, e) {
                    i(t, e, "xaxis");
                }), e.config.annotations.yaxis.map(function(t, e) {
                    i(t, e, "yaxis");
                }), e.config.annotations.points.map(function(t, e) {
                    i(t, e, "point");
                });
            }
        },
        {
            key: "getY1Y2",
            value: function(t, e) {
                var i, a = "y1" === t ? e.y : e.y2, s = this.w;
                if (this.annoCtx.invertAxis) {
                    var r = s.globals.labels.indexOf(a);
                    s.config.xaxis.convertedCatToNumeric && (r = s.globals.categoryLabels.indexOf(a));
                    var o = s.globals.dom.baseEl.querySelector(".apexcharts-yaxis-texts-g text:nth-child(" + (r + 1) + ")");
                    o && (i = parseFloat(o.getAttribute("y")));
                } else {
                    var n;
                    if (s.config.yaxis[e.yAxisIndex].logarithmic) n = (a = new $fffa43d1c55f0813$var$y(this.annoCtx.ctx).getLogVal(a, e.yAxisIndex)) / s.globals.yLogRatio[e.yAxisIndex];
                    else n = (a - s.globals.minYArr[e.yAxisIndex]) / (s.globals.yRange[e.yAxisIndex] / s.globals.gridHeight);
                    i = s.globals.gridHeight - n, !e.marker || void 0 !== e.y && null !== e.y || (i = 0), s.config.yaxis[e.yAxisIndex] && s.config.yaxis[e.yAxisIndex].reversed && (i = n);
                }
                return "string" == typeof a && a.indexOf("px") > -1 && (i = parseFloat(a)), i;
            }
        },
        {
            key: "getX1X2",
            value: function(t, e) {
                var i = this.w, a = this.annoCtx.invertAxis ? i.globals.minY : i.globals.minX, s = this.annoCtx.invertAxis ? i.globals.maxY : i.globals.maxX, r = this.annoCtx.invertAxis ? i.globals.yRange[0] : i.globals.xRange, o = (e.x - a) / (r / i.globals.gridWidth);
                this.annoCtx.inversedReversedAxis && (o = (s - e.x) / (r / i.globals.gridWidth)), "category" !== i.config.xaxis.type && !i.config.xaxis.convertedCatToNumeric || this.annoCtx.invertAxis || i.globals.dataFormatXNumeric || (o = this.getStringX(e.x));
                var n = (e.x2 - a) / (r / i.globals.gridWidth);
                return this.annoCtx.inversedReversedAxis && (n = (s - e.x2) / (r / i.globals.gridWidth)), "category" !== i.config.xaxis.type && !i.config.xaxis.convertedCatToNumeric || this.annoCtx.invertAxis || i.globals.dataFormatXNumeric || (n = this.getStringX(e.x2)), void 0 !== e.x && null !== e.x || !e.marker || (o = i.globals.gridWidth), "x1" === t && "string" == typeof e.x && e.x.indexOf("px") > -1 && (o = parseFloat(e.x)), "x2" === t && "string" == typeof e.x2 && e.x2.indexOf("px") > -1 && (n = parseFloat(e.x2)), "x1" === t ? o : n;
            }
        },
        {
            key: "getStringX",
            value: function(t) {
                var e = this.w, i = t;
                e.config.xaxis.convertedCatToNumeric && e.globals.categoryLabels.length && (t = e.globals.categoryLabels.indexOf(t) + 1);
                var a = e.globals.labels.indexOf(t), s = e.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g text:nth-child(" + (a + 1) + ")");
                return s && (i = parseFloat(s.getAttribute("x"))), i;
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$k = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.w = e.w, this.annoCtx = e, this.invertAxis = this.annoCtx.invertAxis, this.helpers = new $fffa43d1c55f0813$var$w(this.annoCtx);
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "addXaxisAnnotation",
            value: function(t, e, i) {
                var a, s = this.w, r = this.helpers.getX1X2("x1", t), o = t.label.text, n = t.strokeDashArray;
                if ($fffa43d1c55f0813$var$x.isNumber(r)) {
                    if (null === t.x2 || void 0 === t.x2) {
                        var l = this.annoCtx.graphics.drawLine(r + t.offsetX, 0 + t.offsetY, r + t.offsetX, s.globals.gridHeight + t.offsetY, t.borderColor, n, t.borderWidth);
                        e.appendChild(l.node), t.id && l.node.classList.add(t.id);
                    } else {
                        if ((a = this.helpers.getX1X2("x2", t)) < r) {
                            var h = r;
                            r = a, a = h;
                        }
                        var c = this.annoCtx.graphics.drawRect(r + t.offsetX, 0 + t.offsetY, a - r, s.globals.gridHeight + t.offsetY, 0, t.fillColor, t.opacity, 1, t.borderColor, n);
                        c.node.classList.add("apexcharts-annotation-rect"), c.attr("clip-path", "url(#gridRectMask".concat(s.globals.cuid, ")")), e.appendChild(c.node), t.id && c.node.classList.add(t.id);
                    }
                    var d = this.annoCtx.graphics.getTextRects(o, parseFloat(t.label.style.fontSize)), g = "top" === t.label.position ? 4 : "center" === t.label.position ? s.globals.gridHeight / 2 + ("vertical" === t.label.orientation ? d.width / 2 : 0) : s.globals.gridHeight, u = this.annoCtx.graphics.drawText({
                        x: r + t.label.offsetX,
                        y: g + t.label.offsetY - ("vertical" === t.label.orientation ? "top" === t.label.position ? d.width / 2 - 12 : -d.width / 2 : 0),
                        text: o,
                        textAnchor: t.label.textAnchor,
                        fontSize: t.label.style.fontSize,
                        fontFamily: t.label.style.fontFamily,
                        fontWeight: t.label.style.fontWeight,
                        foreColor: t.label.style.color,
                        cssClass: "apexcharts-xaxis-annotation-label ".concat(t.label.style.cssClass, " ").concat(t.id ? t.id : "")
                    });
                    u.attr({
                        rel: i
                    }), e.appendChild(u.node), this.annoCtx.helpers.setOrientations(t, i);
                }
            }
        },
        {
            key: "drawXAxisAnnotations",
            value: function() {
                var t = this, e = this.w, i = this.annoCtx.graphics.group({
                    class: "apexcharts-xaxis-annotations"
                });
                return e.config.annotations.xaxis.map(function(e, a) {
                    t.addXaxisAnnotation(e, i.node, a);
                }), i;
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$A = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.w = e.w, this.annoCtx = e, this.helpers = new $fffa43d1c55f0813$var$w(this.annoCtx);
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "addYaxisAnnotation",
            value: function(t, e, i) {
                var a, s = this.w, r = t.strokeDashArray, o = this.helpers.getY1Y2("y1", t), n = t.label.text;
                if (null === t.y2 || void 0 === t.y2) {
                    var l = this.annoCtx.graphics.drawLine(0 + t.offsetX, o + t.offsetY, this._getYAxisAnnotationWidth(t), o + t.offsetY, t.borderColor, r, t.borderWidth);
                    e.appendChild(l.node), t.id && l.node.classList.add(t.id);
                } else {
                    if ((a = this.helpers.getY1Y2("y2", t)) > o) {
                        var h = o;
                        o = a, a = h;
                    }
                    var c = this.annoCtx.graphics.drawRect(0 + t.offsetX, a + t.offsetY, this._getYAxisAnnotationWidth(t), o - a, 0, t.fillColor, t.opacity, 1, t.borderColor, r);
                    c.node.classList.add("apexcharts-annotation-rect"), c.attr("clip-path", "url(#gridRectMask".concat(s.globals.cuid, ")")), e.appendChild(c.node), t.id && c.node.classList.add(t.id);
                }
                var d = "right" === t.label.position ? s.globals.gridWidth : "center" === t.label.position ? s.globals.gridWidth / 2 : 0, g = this.annoCtx.graphics.drawText({
                    x: d + t.label.offsetX,
                    y: (null != a ? a : o) + t.label.offsetY - 3,
                    text: n,
                    textAnchor: t.label.textAnchor,
                    fontSize: t.label.style.fontSize,
                    fontFamily: t.label.style.fontFamily,
                    fontWeight: t.label.style.fontWeight,
                    foreColor: t.label.style.color,
                    cssClass: "apexcharts-yaxis-annotation-label ".concat(t.label.style.cssClass, " ").concat(t.id ? t.id : "")
                });
                g.attr({
                    rel: i
                }), e.appendChild(g.node);
            }
        },
        {
            key: "_getYAxisAnnotationWidth",
            value: function(t) {
                var e = this.w;
                e.globals.gridWidth;
                return (t.width.indexOf("%") > -1 ? e.globals.gridWidth * parseInt(t.width, 10) / 100 : parseInt(t.width, 10)) + t.offsetX;
            }
        },
        {
            key: "drawYAxisAnnotations",
            value: function() {
                var t = this, e = this.w, i = this.annoCtx.graphics.group({
                    class: "apexcharts-yaxis-annotations"
                });
                return e.config.annotations.yaxis.map(function(e, a) {
                    t.addYaxisAnnotation(e, i.node, a);
                }), i;
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$S = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.w = e.w, this.annoCtx = e, this.helpers = new $fffa43d1c55f0813$var$w(this.annoCtx);
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "addPointAnnotation",
            value: function(t, e, i) {
                this.w;
                var a = this.helpers.getX1X2("x1", t), s = this.helpers.getY1Y2("y1", t);
                if ($fffa43d1c55f0813$var$x.isNumber(a)) {
                    var r = {
                        pSize: t.marker.size,
                        pointStrokeWidth: t.marker.strokeWidth,
                        pointFillColor: t.marker.fillColor,
                        pointStrokeColor: t.marker.strokeColor,
                        shape: t.marker.shape,
                        pRadius: t.marker.radius,
                        class: "apexcharts-point-annotation-marker ".concat(t.marker.cssClass, " ").concat(t.id ? t.id : "")
                    }, o = this.annoCtx.graphics.drawMarker(a + t.marker.offsetX, s + t.marker.offsetY, r);
                    e.appendChild(o.node);
                    var n = t.label.text ? t.label.text : "", l = this.annoCtx.graphics.drawText({
                        x: a + t.label.offsetX,
                        y: s + t.label.offsetY - t.marker.size - parseFloat(t.label.style.fontSize) / 1.6,
                        text: n,
                        textAnchor: t.label.textAnchor,
                        fontSize: t.label.style.fontSize,
                        fontFamily: t.label.style.fontFamily,
                        fontWeight: t.label.style.fontWeight,
                        foreColor: t.label.style.color,
                        cssClass: "apexcharts-point-annotation-label ".concat(t.label.style.cssClass, " ").concat(t.id ? t.id : "")
                    });
                    if (l.attr({
                        rel: i
                    }), e.appendChild(l.node), t.customSVG.SVG) {
                        var h = this.annoCtx.graphics.group({
                            class: "apexcharts-point-annotations-custom-svg " + t.customSVG.cssClass
                        });
                        h.attr({
                            transform: "translate(".concat(a + t.customSVG.offsetX, ", ").concat(s + t.customSVG.offsetY, ")")
                        }), h.node.innerHTML = t.customSVG.SVG, e.appendChild(h.node);
                    }
                    if (t.image.path) {
                        var c = t.image.width ? t.image.width : 20, d = t.image.height ? t.image.height : 20;
                        o = this.annoCtx.addImage({
                            x: a + t.image.offsetX - c / 2,
                            y: s + t.image.offsetY - d / 2,
                            width: c,
                            height: d,
                            path: t.image.path,
                            appendTo: ".apexcharts-point-annotations"
                        });
                    }
                    t.mouseEnter && o.node.addEventListener("mouseenter", t.mouseEnter.bind(this, t)), t.mouseLeave && o.node.addEventListener("mouseleave", t.mouseLeave.bind(this, t)), t.click && o.node.addEventListener("click", t.click.bind(this, t));
                }
            }
        },
        {
            key: "drawPointAnnotations",
            value: function() {
                var t = this, e = this.w, i = this.annoCtx.graphics.group({
                    class: "apexcharts-point-annotations"
                });
                return e.config.annotations.points.map(function(e, a) {
                    t.addPointAnnotation(e, i.node, a);
                }), i;
            }
        }
    ]), t;
}();
var $fffa43d1c55f0813$var$C = {
    name: "en",
    options: {
        months: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        shortMonths: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        days: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        shortDays: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        toolbar: {
            exportToSVG: "Download SVG",
            exportToPNG: "Download PNG",
            exportToCSV: "Download CSV",
            menu: "Menu",
            selection: "Selection",
            selectionZoom: "Selection Zoom",
            zoomIn: "Zoom In",
            zoomOut: "Zoom Out",
            pan: "Panning",
            reset: "Reset Zoom"
        }
    }
}, $fffa43d1c55f0813$var$L = function() {
    function t() {
        $fffa43d1c55f0813$var$a(this, t), this.yAxis = {
            show: !0,
            showAlways: !1,
            showForNullSeries: !0,
            seriesName: void 0,
            opposite: !1,
            reversed: !1,
            logarithmic: !1,
            logBase: 10,
            tickAmount: void 0,
            forceNiceScale: !1,
            max: void 0,
            min: void 0,
            floating: !1,
            decimalsInFloat: void 0,
            labels: {
                show: !0,
                minWidth: 0,
                maxWidth: 160,
                offsetX: 0,
                offsetY: 0,
                align: void 0,
                rotate: 0,
                padding: 20,
                style: {
                    colors: [],
                    fontSize: "11px",
                    fontWeight: 400,
                    fontFamily: void 0,
                    cssClass: ""
                },
                formatter: void 0
            },
            axisBorder: {
                show: !1,
                color: "#e0e0e0",
                width: 1,
                offsetX: 0,
                offsetY: 0
            },
            axisTicks: {
                show: !1,
                color: "#e0e0e0",
                width: 6,
                offsetX: 0,
                offsetY: 0
            },
            title: {
                text: void 0,
                rotate: -90,
                offsetY: 0,
                offsetX: 0,
                style: {
                    color: void 0,
                    fontSize: "11px",
                    fontWeight: 900,
                    fontFamily: void 0,
                    cssClass: ""
                }
            },
            tooltip: {
                enabled: !1,
                offsetX: 0
            },
            crosshairs: {
                show: !0,
                position: "front",
                stroke: {
                    color: "#b6b6b6",
                    width: 1,
                    dashArray: 0
                }
            }
        }, this.pointAnnotation = {
            id: void 0,
            x: 0,
            y: null,
            yAxisIndex: 0,
            seriesIndex: 0,
            mouseEnter: void 0,
            mouseLeave: void 0,
            click: void 0,
            marker: {
                size: 4,
                fillColor: "#fff",
                strokeWidth: 2,
                strokeColor: "#333",
                shape: "circle",
                offsetX: 0,
                offsetY: 0,
                radius: 2,
                cssClass: ""
            },
            label: {
                borderColor: "#c2c2c2",
                borderWidth: 1,
                borderRadius: 2,
                text: void 0,
                textAnchor: "middle",
                offsetX: 0,
                offsetY: 0,
                mouseEnter: void 0,
                mouseLeave: void 0,
                click: void 0,
                style: {
                    background: "#fff",
                    color: void 0,
                    fontSize: "11px",
                    fontFamily: void 0,
                    fontWeight: 400,
                    cssClass: "",
                    padding: {
                        left: 5,
                        right: 5,
                        top: 2,
                        bottom: 2
                    }
                }
            },
            customSVG: {
                SVG: void 0,
                cssClass: void 0,
                offsetX: 0,
                offsetY: 0
            },
            image: {
                path: void 0,
                width: 20,
                height: 20,
                offsetX: 0,
                offsetY: 0
            }
        }, this.yAxisAnnotation = {
            id: void 0,
            y: 0,
            y2: null,
            strokeDashArray: 1,
            fillColor: "#c2c2c2",
            borderColor: "#c2c2c2",
            borderWidth: 1,
            opacity: .3,
            offsetX: 0,
            offsetY: 0,
            width: "100%",
            yAxisIndex: 0,
            label: {
                borderColor: "#c2c2c2",
                borderWidth: 1,
                borderRadius: 2,
                text: void 0,
                textAnchor: "end",
                position: "right",
                offsetX: 0,
                offsetY: -3,
                mouseEnter: void 0,
                mouseLeave: void 0,
                click: void 0,
                style: {
                    background: "#fff",
                    color: void 0,
                    fontSize: "11px",
                    fontFamily: void 0,
                    fontWeight: 400,
                    cssClass: "",
                    padding: {
                        left: 5,
                        right: 5,
                        top: 2,
                        bottom: 2
                    }
                }
            }
        }, this.xAxisAnnotation = {
            id: void 0,
            x: 0,
            x2: null,
            strokeDashArray: 1,
            fillColor: "#c2c2c2",
            borderColor: "#c2c2c2",
            borderWidth: 1,
            opacity: .3,
            offsetX: 0,
            offsetY: 0,
            label: {
                borderColor: "#c2c2c2",
                borderWidth: 1,
                borderRadius: 2,
                text: void 0,
                textAnchor: "middle",
                orientation: "vertical",
                position: "top",
                offsetX: 0,
                offsetY: 0,
                mouseEnter: void 0,
                mouseLeave: void 0,
                click: void 0,
                style: {
                    background: "#fff",
                    color: void 0,
                    fontSize: "11px",
                    fontFamily: void 0,
                    fontWeight: 400,
                    cssClass: "",
                    padding: {
                        left: 5,
                        right: 5,
                        top: 2,
                        bottom: 2
                    }
                }
            }
        }, this.text = {
            x: 0,
            y: 0,
            text: "",
            textAnchor: "start",
            foreColor: void 0,
            fontSize: "13px",
            fontFamily: void 0,
            fontWeight: 400,
            appendTo: ".apexcharts-annotations",
            backgroundColor: "transparent",
            borderColor: "#c2c2c2",
            borderRadius: 0,
            borderWidth: 0,
            paddingLeft: 4,
            paddingRight: 4,
            paddingTop: 2,
            paddingBottom: 2
        };
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "init",
            value: function() {
                return {
                    annotations: {
                        yaxis: [
                            this.yAxisAnnotation
                        ],
                        xaxis: [
                            this.xAxisAnnotation
                        ],
                        points: [
                            this.pointAnnotation
                        ],
                        texts: [],
                        images: [],
                        shapes: []
                    },
                    chart: {
                        animations: {
                            enabled: !0,
                            easing: "easeinout",
                            speed: 800,
                            animateGradually: {
                                delay: 150,
                                enabled: !0
                            },
                            dynamicAnimation: {
                                enabled: !0,
                                speed: 350
                            }
                        },
                        background: "transparent",
                        locales: [
                            $fffa43d1c55f0813$var$C
                        ],
                        defaultLocale: "en",
                        dropShadow: {
                            enabled: !1,
                            enabledOnSeries: void 0,
                            top: 2,
                            left: 2,
                            blur: 4,
                            color: "#000",
                            opacity: .35
                        },
                        events: {
                            animationEnd: void 0,
                            beforeMount: void 0,
                            mounted: void 0,
                            updated: void 0,
                            click: void 0,
                            mouseMove: void 0,
                            mouseLeave: void 0,
                            xAxisLabelClick: void 0,
                            legendClick: void 0,
                            markerClick: void 0,
                            selection: void 0,
                            dataPointSelection: void 0,
                            dataPointMouseEnter: void 0,
                            dataPointMouseLeave: void 0,
                            beforeZoom: void 0,
                            beforeResetZoom: void 0,
                            zoomed: void 0,
                            scrolled: void 0,
                            brushScrolled: void 0
                        },
                        foreColor: "#373d3f",
                        fontFamily: "Helvetica, Arial, sans-serif",
                        height: "auto",
                        parentHeightOffset: 15,
                        redrawOnParentResize: !0,
                        redrawOnWindowResize: !0,
                        id: void 0,
                        group: void 0,
                        nonce: void 0,
                        offsetX: 0,
                        offsetY: 0,
                        selection: {
                            enabled: !1,
                            type: "x",
                            fill: {
                                color: "#24292e",
                                opacity: .1
                            },
                            stroke: {
                                width: 1,
                                color: "#24292e",
                                opacity: .4,
                                dashArray: 3
                            },
                            xaxis: {
                                min: void 0,
                                max: void 0
                            },
                            yaxis: {
                                min: void 0,
                                max: void 0
                            }
                        },
                        sparkline: {
                            enabled: !1
                        },
                        brush: {
                            enabled: !1,
                            autoScaleYaxis: !0,
                            target: void 0,
                            targets: void 0
                        },
                        stacked: !1,
                        stackOnlyBar: !0,
                        stackType: "normal",
                        toolbar: {
                            show: !0,
                            offsetX: 0,
                            offsetY: 0,
                            tools: {
                                download: !0,
                                selection: !0,
                                zoom: !0,
                                zoomin: !0,
                                zoomout: !0,
                                pan: !0,
                                reset: !0,
                                customIcons: []
                            },
                            export: {
                                csv: {
                                    filename: void 0,
                                    columnDelimiter: ",",
                                    headerCategory: "category",
                                    headerValue: "value",
                                    dateFormatter: function(t) {
                                        return new Date(t).toDateString();
                                    }
                                },
                                png: {
                                    filename: void 0
                                },
                                svg: {
                                    filename: void 0
                                }
                            },
                            autoSelected: "zoom"
                        },
                        type: "line",
                        width: "100%",
                        zoom: {
                            enabled: !0,
                            type: "x",
                            autoScaleYaxis: !1,
                            zoomedArea: {
                                fill: {
                                    color: "#90CAF9",
                                    opacity: .4
                                },
                                stroke: {
                                    color: "#0D47A1",
                                    opacity: .4,
                                    width: 1
                                }
                            }
                        }
                    },
                    plotOptions: {
                        area: {
                            fillTo: "origin"
                        },
                        bar: {
                            horizontal: !1,
                            columnWidth: "70%",
                            barHeight: "70%",
                            distributed: !1,
                            borderRadius: 0,
                            borderRadiusApplication: "around",
                            borderRadiusWhenStacked: "last",
                            rangeBarOverlap: !0,
                            rangeBarGroupRows: !1,
                            hideZeroBarsWhenGrouped: !1,
                            isDumbbell: !1,
                            dumbbellColors: void 0,
                            isFunnel: !1,
                            isFunnel3d: !0,
                            colors: {
                                ranges: [],
                                backgroundBarColors: [],
                                backgroundBarOpacity: 1,
                                backgroundBarRadius: 0
                            },
                            dataLabels: {
                                position: "top",
                                maxItems: 100,
                                hideOverflowingLabels: !0,
                                orientation: "horizontal",
                                total: {
                                    enabled: !1,
                                    formatter: void 0,
                                    offsetX: 0,
                                    offsetY: 0,
                                    style: {
                                        color: "#373d3f",
                                        fontSize: "12px",
                                        fontFamily: void 0,
                                        fontWeight: 600
                                    }
                                }
                            }
                        },
                        bubble: {
                            zScaling: !0,
                            minBubbleRadius: void 0,
                            maxBubbleRadius: void 0
                        },
                        candlestick: {
                            colors: {
                                upward: "#00B746",
                                downward: "#EF403C"
                            },
                            wick: {
                                useFillColor: !0
                            }
                        },
                        boxPlot: {
                            colors: {
                                upper: "#00E396",
                                lower: "#008FFB"
                            }
                        },
                        heatmap: {
                            radius: 2,
                            enableShades: !0,
                            shadeIntensity: .5,
                            reverseNegativeShade: !1,
                            distributed: !1,
                            useFillColorAsStroke: !1,
                            colorScale: {
                                inverse: !1,
                                ranges: [],
                                min: void 0,
                                max: void 0
                            }
                        },
                        treemap: {
                            enableShades: !0,
                            shadeIntensity: .5,
                            distributed: !1,
                            reverseNegativeShade: !1,
                            useFillColorAsStroke: !1,
                            dataLabels: {
                                format: "scale"
                            },
                            colorScale: {
                                inverse: !1,
                                ranges: [],
                                min: void 0,
                                max: void 0
                            }
                        },
                        radialBar: {
                            inverseOrder: !1,
                            startAngle: 0,
                            endAngle: 360,
                            offsetX: 0,
                            offsetY: 0,
                            hollow: {
                                margin: 5,
                                size: "50%",
                                background: "transparent",
                                image: void 0,
                                imageWidth: 150,
                                imageHeight: 150,
                                imageOffsetX: 0,
                                imageOffsetY: 0,
                                imageClipped: !0,
                                position: "front",
                                dropShadow: {
                                    enabled: !1,
                                    top: 0,
                                    left: 0,
                                    blur: 3,
                                    color: "#000",
                                    opacity: .5
                                }
                            },
                            track: {
                                show: !0,
                                startAngle: void 0,
                                endAngle: void 0,
                                background: "#f2f2f2",
                                strokeWidth: "97%",
                                opacity: 1,
                                margin: 5,
                                dropShadow: {
                                    enabled: !1,
                                    top: 0,
                                    left: 0,
                                    blur: 3,
                                    color: "#000",
                                    opacity: .5
                                }
                            },
                            dataLabels: {
                                show: !0,
                                name: {
                                    show: !0,
                                    fontSize: "16px",
                                    fontFamily: void 0,
                                    fontWeight: 600,
                                    color: void 0,
                                    offsetY: 0,
                                    formatter: function(t) {
                                        return t;
                                    }
                                },
                                value: {
                                    show: !0,
                                    fontSize: "14px",
                                    fontFamily: void 0,
                                    fontWeight: 400,
                                    color: void 0,
                                    offsetY: 16,
                                    formatter: function(t) {
                                        return t + "%";
                                    }
                                },
                                total: {
                                    show: !1,
                                    label: "Total",
                                    fontSize: "16px",
                                    fontWeight: 600,
                                    fontFamily: void 0,
                                    color: void 0,
                                    formatter: function(t) {
                                        return t.globals.seriesTotals.reduce(function(t, e) {
                                            return t + e;
                                        }, 0) / t.globals.series.length + "%";
                                    }
                                }
                            },
                            barLabels: {
                                enabled: !1,
                                margin: 5,
                                useSeriesColors: !0,
                                fontFamily: void 0,
                                fontWeight: 600,
                                fontSize: "16px",
                                formatter: function(t) {
                                    return t;
                                },
                                onClick: void 0
                            }
                        },
                        pie: {
                            customScale: 1,
                            offsetX: 0,
                            offsetY: 0,
                            startAngle: 0,
                            endAngle: 360,
                            expandOnClick: !0,
                            dataLabels: {
                                offset: 0,
                                minAngleToShowLabel: 10
                            },
                            donut: {
                                size: "65%",
                                background: "transparent",
                                labels: {
                                    show: !1,
                                    name: {
                                        show: !0,
                                        fontSize: "16px",
                                        fontFamily: void 0,
                                        fontWeight: 600,
                                        color: void 0,
                                        offsetY: -10,
                                        formatter: function(t) {
                                            return t;
                                        }
                                    },
                                    value: {
                                        show: !0,
                                        fontSize: "20px",
                                        fontFamily: void 0,
                                        fontWeight: 400,
                                        color: void 0,
                                        offsetY: 10,
                                        formatter: function(t) {
                                            return t;
                                        }
                                    },
                                    total: {
                                        show: !1,
                                        showAlways: !1,
                                        label: "Total",
                                        fontSize: "16px",
                                        fontWeight: 400,
                                        fontFamily: void 0,
                                        color: void 0,
                                        formatter: function(t) {
                                            return t.globals.seriesTotals.reduce(function(t, e) {
                                                return t + e;
                                            }, 0);
                                        }
                                    }
                                }
                            }
                        },
                        polarArea: {
                            rings: {
                                strokeWidth: 1,
                                strokeColor: "#e8e8e8"
                            },
                            spokes: {
                                strokeWidth: 1,
                                connectorColors: "#e8e8e8"
                            }
                        },
                        radar: {
                            size: void 0,
                            offsetX: 0,
                            offsetY: 0,
                            polygons: {
                                strokeWidth: 1,
                                strokeColors: "#e8e8e8",
                                connectorColors: "#e8e8e8",
                                fill: {
                                    colors: void 0
                                }
                            }
                        }
                    },
                    colors: void 0,
                    dataLabels: {
                        enabled: !0,
                        enabledOnSeries: void 0,
                        formatter: function(t) {
                            return null !== t ? t : "";
                        },
                        textAnchor: "middle",
                        distributed: !1,
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            fontSize: "12px",
                            fontFamily: void 0,
                            fontWeight: 600,
                            colors: void 0
                        },
                        background: {
                            enabled: !0,
                            foreColor: "#fff",
                            borderRadius: 2,
                            padding: 4,
                            opacity: .9,
                            borderWidth: 1,
                            borderColor: "#fff",
                            dropShadow: {
                                enabled: !1,
                                top: 1,
                                left: 1,
                                blur: 1,
                                color: "#000",
                                opacity: .45
                            }
                        },
                        dropShadow: {
                            enabled: !1,
                            top: 1,
                            left: 1,
                            blur: 1,
                            color: "#000",
                            opacity: .45
                        }
                    },
                    fill: {
                        type: "solid",
                        colors: void 0,
                        opacity: .85,
                        gradient: {
                            shade: "dark",
                            type: "horizontal",
                            shadeIntensity: .5,
                            gradientToColors: void 0,
                            inverseColors: !0,
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [
                                0,
                                50,
                                100
                            ],
                            colorStops: []
                        },
                        image: {
                            src: [],
                            width: void 0,
                            height: void 0
                        },
                        pattern: {
                            style: "squares",
                            width: 6,
                            height: 6,
                            strokeWidth: 2
                        }
                    },
                    forecastDataPoints: {
                        count: 0,
                        fillOpacity: .5,
                        strokeWidth: void 0,
                        dashArray: 4
                    },
                    grid: {
                        show: !0,
                        borderColor: "#e0e0e0",
                        strokeDashArray: 0,
                        position: "back",
                        xaxis: {
                            lines: {
                                show: !1
                            }
                        },
                        yaxis: {
                            lines: {
                                show: !0
                            }
                        },
                        row: {
                            colors: void 0,
                            opacity: .5
                        },
                        column: {
                            colors: void 0,
                            opacity: .5
                        },
                        padding: {
                            top: 0,
                            right: 10,
                            bottom: 0,
                            left: 12
                        }
                    },
                    labels: [],
                    legend: {
                        show: !0,
                        showForSingleSeries: !1,
                        showForNullSeries: !0,
                        showForZeroSeries: !0,
                        floating: !1,
                        position: "bottom",
                        horizontalAlign: "center",
                        inverseOrder: !1,
                        fontSize: "12px",
                        fontFamily: void 0,
                        fontWeight: 400,
                        width: void 0,
                        height: void 0,
                        formatter: void 0,
                        tooltipHoverFormatter: void 0,
                        offsetX: -20,
                        offsetY: 4,
                        customLegendItems: [],
                        labels: {
                            colors: void 0,
                            useSeriesColors: !1
                        },
                        markers: {
                            width: 12,
                            height: 12,
                            strokeWidth: 0,
                            fillColors: void 0,
                            strokeColor: "#fff",
                            radius: 12,
                            customHTML: void 0,
                            offsetX: 0,
                            offsetY: 0,
                            onClick: void 0
                        },
                        itemMargin: {
                            horizontal: 5,
                            vertical: 2
                        },
                        onItemClick: {
                            toggleDataSeries: !0
                        },
                        onItemHover: {
                            highlightDataSeries: !0
                        }
                    },
                    markers: {
                        discrete: [],
                        size: 0,
                        colors: void 0,
                        strokeColors: "#fff",
                        strokeWidth: 2,
                        strokeOpacity: .9,
                        strokeDashArray: 0,
                        fillOpacity: 1,
                        shape: "circle",
                        width: 8,
                        height: 8,
                        radius: 2,
                        offsetX: 0,
                        offsetY: 0,
                        onClick: void 0,
                        onDblClick: void 0,
                        showNullDataPoints: !0,
                        hover: {
                            size: void 0,
                            sizeOffset: 3
                        }
                    },
                    noData: {
                        text: void 0,
                        align: "center",
                        verticalAlign: "middle",
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            color: void 0,
                            fontSize: "14px",
                            fontFamily: void 0
                        }
                    },
                    responsive: [],
                    series: void 0,
                    states: {
                        normal: {
                            filter: {
                                type: "none",
                                value: 0
                            }
                        },
                        hover: {
                            filter: {
                                type: "lighten",
                                value: .1
                            }
                        },
                        active: {
                            allowMultipleDataPointsSelection: !1,
                            filter: {
                                type: "darken",
                                value: .5
                            }
                        }
                    },
                    title: {
                        text: void 0,
                        align: "left",
                        margin: 5,
                        offsetX: 0,
                        offsetY: 0,
                        floating: !1,
                        style: {
                            fontSize: "14px",
                            fontWeight: 900,
                            fontFamily: void 0,
                            color: void 0
                        }
                    },
                    subtitle: {
                        text: void 0,
                        align: "left",
                        margin: 5,
                        offsetX: 0,
                        offsetY: 30,
                        floating: !1,
                        style: {
                            fontSize: "12px",
                            fontWeight: 400,
                            fontFamily: void 0,
                            color: void 0
                        }
                    },
                    stroke: {
                        show: !0,
                        curve: "smooth",
                        lineCap: "butt",
                        width: 2,
                        colors: void 0,
                        dashArray: 0,
                        fill: {
                            type: "solid",
                            colors: void 0,
                            opacity: .85,
                            gradient: {
                                shade: "dark",
                                type: "horizontal",
                                shadeIntensity: .5,
                                gradientToColors: void 0,
                                inverseColors: !0,
                                opacityFrom: 1,
                                opacityTo: 1,
                                stops: [
                                    0,
                                    50,
                                    100
                                ],
                                colorStops: []
                            }
                        }
                    },
                    tooltip: {
                        enabled: !0,
                        enabledOnSeries: void 0,
                        shared: !0,
                        hideEmptySeries: !0,
                        followCursor: !1,
                        intersect: !1,
                        inverseOrder: !1,
                        custom: void 0,
                        fillSeriesColor: !1,
                        theme: "light",
                        cssClass: "",
                        style: {
                            fontSize: "12px",
                            fontFamily: void 0
                        },
                        onDatasetHover: {
                            highlightDataSeries: !1
                        },
                        x: {
                            show: !0,
                            format: "dd MMM",
                            formatter: void 0
                        },
                        y: {
                            formatter: void 0,
                            title: {
                                formatter: function(t) {
                                    return t ? t + ": " : "";
                                }
                            }
                        },
                        z: {
                            formatter: void 0,
                            title: "Size: "
                        },
                        marker: {
                            show: !0,
                            fillColors: void 0
                        },
                        items: {
                            display: "flex"
                        },
                        fixed: {
                            enabled: !1,
                            position: "topRight",
                            offsetX: 0,
                            offsetY: 0
                        }
                    },
                    xaxis: {
                        type: "category",
                        categories: [],
                        convertedCatToNumeric: !1,
                        offsetX: 0,
                        offsetY: 0,
                        overwriteCategories: void 0,
                        labels: {
                            show: !0,
                            rotate: -45,
                            rotateAlways: !1,
                            hideOverlappingLabels: !0,
                            trim: !1,
                            minHeight: void 0,
                            maxHeight: 120,
                            showDuplicates: !0,
                            style: {
                                colors: [],
                                fontSize: "12px",
                                fontWeight: 400,
                                fontFamily: void 0,
                                cssClass: ""
                            },
                            offsetX: 0,
                            offsetY: 0,
                            format: void 0,
                            formatter: void 0,
                            datetimeUTC: !0,
                            datetimeFormatter: {
                                year: "yyyy",
                                month: "MMM 'yy",
                                day: "dd MMM",
                                hour: "HH:mm",
                                minute: "HH:mm:ss",
                                second: "HH:mm:ss"
                            }
                        },
                        group: {
                            groups: [],
                            style: {
                                colors: [],
                                fontSize: "12px",
                                fontWeight: 400,
                                fontFamily: void 0,
                                cssClass: ""
                            }
                        },
                        axisBorder: {
                            show: !0,
                            color: "#e0e0e0",
                            width: "100%",
                            height: 1,
                            offsetX: 0,
                            offsetY: 0
                        },
                        axisTicks: {
                            show: !0,
                            color: "#e0e0e0",
                            height: 6,
                            offsetX: 0,
                            offsetY: 0
                        },
                        tickAmount: void 0,
                        tickPlacement: "on",
                        min: void 0,
                        max: void 0,
                        range: void 0,
                        floating: !1,
                        decimalsInFloat: void 0,
                        position: "bottom",
                        title: {
                            text: void 0,
                            offsetX: 0,
                            offsetY: 0,
                            style: {
                                color: void 0,
                                fontSize: "12px",
                                fontWeight: 900,
                                fontFamily: void 0,
                                cssClass: ""
                            }
                        },
                        crosshairs: {
                            show: !0,
                            width: 1,
                            position: "back",
                            opacity: .9,
                            stroke: {
                                color: "#b6b6b6",
                                width: 1,
                                dashArray: 3
                            },
                            fill: {
                                type: "solid",
                                color: "#B1B9C4",
                                gradient: {
                                    colorFrom: "#D8E3F0",
                                    colorTo: "#BED1E6",
                                    stops: [
                                        0,
                                        100
                                    ],
                                    opacityFrom: .4,
                                    opacityTo: .5
                                }
                            },
                            dropShadow: {
                                enabled: !1,
                                left: 0,
                                top: 0,
                                blur: 1,
                                opacity: .4
                            }
                        },
                        tooltip: {
                            enabled: !0,
                            offsetY: 0,
                            formatter: void 0,
                            style: {
                                fontSize: "12px",
                                fontFamily: void 0
                            }
                        }
                    },
                    yaxis: this.yAxis,
                    theme: {
                        mode: "light",
                        palette: "palette1",
                        monochrome: {
                            enabled: !1,
                            color: "#008FFB",
                            shadeTo: "light",
                            shadeIntensity: .65
                        }
                    }
                };
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$P = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w, this.graphics = new $fffa43d1c55f0813$var$m(this.ctx), this.w.globals.isBarHorizontal && (this.invertAxis = !0), this.helpers = new $fffa43d1c55f0813$var$w(this), this.xAxisAnnotations = new $fffa43d1c55f0813$var$k(this), this.yAxisAnnotations = new $fffa43d1c55f0813$var$A(this), this.pointsAnnotations = new $fffa43d1c55f0813$var$S(this), this.w.globals.isBarHorizontal && this.w.config.yaxis[0].reversed && (this.inversedReversedAxis = !0), this.xDivision = this.w.globals.gridWidth / this.w.globals.dataPoints;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "drawAxesAnnotations",
            value: function() {
                var t = this.w;
                if (t.globals.axisCharts) {
                    for(var e = this.yAxisAnnotations.drawYAxisAnnotations(), i = this.xAxisAnnotations.drawXAxisAnnotations(), a = this.pointsAnnotations.drawPointAnnotations(), s = t.config.chart.animations.enabled, r = [
                        e,
                        i,
                        a
                    ], o = [
                        i.node,
                        e.node,
                        a.node
                    ], n = 0; n < 3; n++)t.globals.dom.elGraphical.add(r[n]), !s || t.globals.resized || t.globals.dataChanged || "scatter" !== t.config.chart.type && "bubble" !== t.config.chart.type && t.globals.dataPoints > 1 && o[n].classList.add("apexcharts-element-hidden"), t.globals.delayedElements.push({
                        el: o[n],
                        index: 0
                    });
                    this.helpers.annotationsBackground();
                }
            }
        },
        {
            key: "drawImageAnnos",
            value: function() {
                var t = this;
                this.w.config.annotations.images.map(function(e, i) {
                    t.addImage(e, i);
                });
            }
        },
        {
            key: "drawTextAnnos",
            value: function() {
                var t = this;
                this.w.config.annotations.texts.map(function(e, i) {
                    t.addText(e, i);
                });
            }
        },
        {
            key: "addXaxisAnnotation",
            value: function(t, e, i) {
                this.xAxisAnnotations.addXaxisAnnotation(t, e, i);
            }
        },
        {
            key: "addYaxisAnnotation",
            value: function(t, e, i) {
                this.yAxisAnnotations.addYaxisAnnotation(t, e, i);
            }
        },
        {
            key: "addPointAnnotation",
            value: function(t, e, i) {
                this.pointsAnnotations.addPointAnnotation(t, e, i);
            }
        },
        {
            key: "addText",
            value: function(t, e) {
                var i = t.x, a = t.y, s = t.text, r = t.textAnchor, o = t.foreColor, n = t.fontSize, l = t.fontFamily, h = t.fontWeight, c = t.cssClass, d = t.backgroundColor, g = t.borderWidth, u = t.strokeDashArray, p = t.borderRadius, f = t.borderColor, x = t.appendTo, b = void 0 === x ? ".apexcharts-svg" : x, v = t.paddingLeft, m = void 0 === v ? 4 : v, y = t.paddingRight, w = void 0 === y ? 4 : y, k = t.paddingBottom, A = void 0 === k ? 2 : k, S = t.paddingTop, C = void 0 === S ? 2 : S, L = this.w, P = this.graphics.drawText({
                    x: i,
                    y: a,
                    text: s,
                    textAnchor: r || "start",
                    fontSize: n || "12px",
                    fontWeight: h || "regular",
                    fontFamily: l || L.config.chart.fontFamily,
                    foreColor: o || L.config.chart.foreColor,
                    cssClass: c
                }), I = L.globals.dom.baseEl.querySelector(b);
                I && I.appendChild(P.node);
                var T = P.bbox();
                if (s) {
                    var M = this.graphics.drawRect(T.x - m, T.y - C, T.width + m + w, T.height + A + C, p, d || "transparent", 1, g, f, u);
                    I.insertBefore(M.node, P.node);
                }
            }
        },
        {
            key: "addImage",
            value: function(t, e) {
                var i = this.w, a = t.path, s = t.x, r = void 0 === s ? 0 : s, o = t.y, n = void 0 === o ? 0 : o, l = t.width, h = void 0 === l ? 20 : l, c = t.height, d = void 0 === c ? 20 : c, g = t.appendTo, u = void 0 === g ? ".apexcharts-svg" : g, p = i.globals.dom.Paper.image(a);
                p.size(h, d).move(r, n);
                var f = i.globals.dom.baseEl.querySelector(u);
                return f && f.appendChild(p.node), p;
            }
        },
        {
            key: "addXaxisAnnotationExternal",
            value: function(t, e, i) {
                return this.addAnnotationExternal({
                    params: t,
                    pushToMemory: e,
                    context: i,
                    type: "xaxis",
                    contextMethod: i.addXaxisAnnotation
                }), i;
            }
        },
        {
            key: "addYaxisAnnotationExternal",
            value: function(t, e, i) {
                return this.addAnnotationExternal({
                    params: t,
                    pushToMemory: e,
                    context: i,
                    type: "yaxis",
                    contextMethod: i.addYaxisAnnotation
                }), i;
            }
        },
        {
            key: "addPointAnnotationExternal",
            value: function(t, e, i) {
                return void 0 === this.invertAxis && (this.invertAxis = i.w.globals.isBarHorizontal), this.addAnnotationExternal({
                    params: t,
                    pushToMemory: e,
                    context: i,
                    type: "point",
                    contextMethod: i.addPointAnnotation
                }), i;
            }
        },
        {
            key: "addAnnotationExternal",
            value: function(t) {
                var e = t.params, i = t.pushToMemory, a = t.context, s = t.type, r = t.contextMethod, o = a, n = o.w, l = n.globals.dom.baseEl.querySelector(".apexcharts-".concat(s, "-annotations")), h = l.childNodes.length + 1, c = new $fffa43d1c55f0813$var$L, d = Object.assign({}, "xaxis" === s ? c.xAxisAnnotation : "yaxis" === s ? c.yAxisAnnotation : c.pointAnnotation), g = $fffa43d1c55f0813$var$x.extend(d, e);
                switch(s){
                    case "xaxis":
                        this.addXaxisAnnotation(g, l, h);
                        break;
                    case "yaxis":
                        this.addYaxisAnnotation(g, l, h);
                        break;
                    case "point":
                        this.addPointAnnotation(g, l, h);
                }
                var u = n.globals.dom.baseEl.querySelector(".apexcharts-".concat(s, "-annotations .apexcharts-").concat(s, "-annotation-label[rel='").concat(h, "']")), p = this.helpers.addBackgroundToAnno(u, g);
                return p && l.insertBefore(p.node, u), i && n.globals.memory.methodsToExec.push({
                    context: o,
                    id: g.id ? g.id : $fffa43d1c55f0813$var$x.randomId(),
                    method: r,
                    label: "addAnnotation",
                    params: e
                }), a;
            }
        },
        {
            key: "clearAnnotations",
            value: function(t) {
                var e = t.w, i = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-annotations, .apexcharts-xaxis-annotations, .apexcharts-point-annotations");
                e.globals.memory.methodsToExec.map(function(t, i) {
                    "addText" !== t.label && "addAnnotation" !== t.label || e.globals.memory.methodsToExec.splice(i, 1);
                }), i = $fffa43d1c55f0813$var$x.listToArray(i), Array.prototype.forEach.call(i, function(t) {
                    for(; t.firstChild;)t.removeChild(t.firstChild);
                });
            }
        },
        {
            key: "removeAnnotation",
            value: function(t, e) {
                var i = t.w, a = i.globals.dom.baseEl.querySelectorAll(".".concat(e));
                a && (i.globals.memory.methodsToExec.map(function(t, a) {
                    t.id === e && i.globals.memory.methodsToExec.splice(a, 1);
                }), Array.prototype.forEach.call(a, function(t) {
                    t.parentElement.removeChild(t);
                }));
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$I = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w, this.months31 = [
            1,
            3,
            5,
            7,
            8,
            10,
            12
        ], this.months30 = [
            2,
            4,
            6,
            9,
            11
        ], this.daysCntOfYear = [
            0,
            31,
            59,
            90,
            120,
            151,
            181,
            212,
            243,
            273,
            304,
            334
        ];
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "isValidDate",
            value: function(t) {
                return "number" != typeof t && !isNaN(this.parseDate(t));
            }
        },
        {
            key: "getTimeStamp",
            value: function(t) {
                return Date.parse(t) ? this.w.config.xaxis.labels.datetimeUTC ? new Date(new Date(t).toISOString().substr(0, 25)).getTime() : new Date(t).getTime() : t;
            }
        },
        {
            key: "getDate",
            value: function(t) {
                return this.w.config.xaxis.labels.datetimeUTC ? new Date(new Date(t).toUTCString()) : new Date(t);
            }
        },
        {
            key: "parseDate",
            value: function(t) {
                var e = Date.parse(t);
                if (!isNaN(e)) return this.getTimeStamp(t);
                var i = Date.parse(t.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
                return i = this.getTimeStamp(i);
            }
        },
        {
            key: "parseDateWithTimezone",
            value: function(t) {
                return Date.parse(t.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
            }
        },
        {
            key: "formatDate",
            value: function(t, e) {
                var i = this.w.globals.locale, a = this.w.config.xaxis.labels.datetimeUTC, s = [
                    "\0"
                ].concat($fffa43d1c55f0813$var$u(i.months)), r = [
                    "\x01"
                ].concat($fffa43d1c55f0813$var$u(i.shortMonths)), o = [
                    "\x02"
                ].concat($fffa43d1c55f0813$var$u(i.days)), n = [
                    "\x03"
                ].concat($fffa43d1c55f0813$var$u(i.shortDays));
                function l(t, e) {
                    var i = t + "";
                    for(e = e || 2; i.length < e;)i = "0" + i;
                    return i;
                }
                var h = a ? t.getUTCFullYear() : t.getFullYear();
                e = (e = (e = e.replace(/(^|[^\\])yyyy+/g, "$1" + h)).replace(/(^|[^\\])yy/g, "$1" + h.toString().substr(2, 2))).replace(/(^|[^\\])y/g, "$1" + h);
                var c = (a ? t.getUTCMonth() : t.getMonth()) + 1;
                e = (e = (e = (e = e.replace(/(^|[^\\])MMMM+/g, "$1" + s[0])).replace(/(^|[^\\])MMM/g, "$1" + r[0])).replace(/(^|[^\\])MM/g, "$1" + l(c))).replace(/(^|[^\\])M/g, "$1" + c);
                var d = a ? t.getUTCDate() : t.getDate();
                e = (e = (e = (e = e.replace(/(^|[^\\])dddd+/g, "$1" + o[0])).replace(/(^|[^\\])ddd/g, "$1" + n[0])).replace(/(^|[^\\])dd/g, "$1" + l(d))).replace(/(^|[^\\])d/g, "$1" + d);
                var g = a ? t.getUTCHours() : t.getHours(), p = g > 12 ? g - 12 : 0 === g ? 12 : g;
                e = (e = (e = (e = e.replace(/(^|[^\\])HH+/g, "$1" + l(g))).replace(/(^|[^\\])H/g, "$1" + g)).replace(/(^|[^\\])hh+/g, "$1" + l(p))).replace(/(^|[^\\])h/g, "$1" + p);
                var f = a ? t.getUTCMinutes() : t.getMinutes();
                e = (e = e.replace(/(^|[^\\])mm+/g, "$1" + l(f))).replace(/(^|[^\\])m/g, "$1" + f);
                var x = a ? t.getUTCSeconds() : t.getSeconds();
                e = (e = e.replace(/(^|[^\\])ss+/g, "$1" + l(x))).replace(/(^|[^\\])s/g, "$1" + x);
                var b = a ? t.getUTCMilliseconds() : t.getMilliseconds();
                e = e.replace(/(^|[^\\])fff+/g, "$1" + l(b, 3)), b = Math.round(b / 10), e = e.replace(/(^|[^\\])ff/g, "$1" + l(b)), b = Math.round(b / 10);
                var v = g < 12 ? "AM" : "PM";
                e = (e = (e = e.replace(/(^|[^\\])f/g, "$1" + b)).replace(/(^|[^\\])TT+/g, "$1" + v)).replace(/(^|[^\\])T/g, "$1" + v.charAt(0));
                var m = v.toLowerCase();
                e = (e = e.replace(/(^|[^\\])tt+/g, "$1" + m)).replace(/(^|[^\\])t/g, "$1" + m.charAt(0));
                var y = -t.getTimezoneOffset(), w = a || !y ? "Z" : y > 0 ? "+" : "-";
                if (!a) {
                    var k = (y = Math.abs(y)) % 60;
                    w += l(Math.floor(y / 60)) + ":" + l(k);
                }
                e = e.replace(/(^|[^\\])K/g, "$1" + w);
                var A = (a ? t.getUTCDay() : t.getDay()) + 1;
                return e = (e = (e = (e = (e = e.replace(new RegExp(o[0], "g"), o[A])).replace(new RegExp(n[0], "g"), n[A])).replace(new RegExp(s[0], "g"), s[c])).replace(new RegExp(r[0], "g"), r[c])).replace(/\\(.)/g, "$1");
            }
        },
        {
            key: "getTimeUnitsfromTimestamp",
            value: function(t, e, i) {
                var a = this.w;
                void 0 !== a.config.xaxis.min && (t = a.config.xaxis.min), void 0 !== a.config.xaxis.max && (e = a.config.xaxis.max);
                var s = this.getDate(t), r = this.getDate(e), o = this.formatDate(s, "yyyy MM dd HH mm ss fff").split(" "), n = this.formatDate(r, "yyyy MM dd HH mm ss fff").split(" ");
                return {
                    minMillisecond: parseInt(o[6], 10),
                    maxMillisecond: parseInt(n[6], 10),
                    minSecond: parseInt(o[5], 10),
                    maxSecond: parseInt(n[5], 10),
                    minMinute: parseInt(o[4], 10),
                    maxMinute: parseInt(n[4], 10),
                    minHour: parseInt(o[3], 10),
                    maxHour: parseInt(n[3], 10),
                    minDate: parseInt(o[2], 10),
                    maxDate: parseInt(n[2], 10),
                    minMonth: parseInt(o[1], 10) - 1,
                    maxMonth: parseInt(n[1], 10) - 1,
                    minYear: parseInt(o[0], 10),
                    maxYear: parseInt(n[0], 10)
                };
            }
        },
        {
            key: "isLeapYear",
            value: function(t) {
                return t % 4 == 0 && t % 100 != 0 || t % 400 == 0;
            }
        },
        {
            key: "calculcateLastDaysOfMonth",
            value: function(t, e, i) {
                return this.determineDaysOfMonths(t, e) - i;
            }
        },
        {
            key: "determineDaysOfYear",
            value: function(t) {
                var e = 365;
                return this.isLeapYear(t) && (e = 366), e;
            }
        },
        {
            key: "determineRemainingDaysOfYear",
            value: function(t, e, i) {
                var a = this.daysCntOfYear[e] + i;
                return e > 1 && this.isLeapYear() && a++, a;
            }
        },
        {
            key: "determineDaysOfMonths",
            value: function(t, e) {
                var i = 30;
                switch(t = $fffa43d1c55f0813$var$x.monthMod(t), !0){
                    case this.months30.indexOf(t) > -1:
                        2 === t && (i = this.isLeapYear(e) ? 29 : 28);
                        break;
                    case this.months31.indexOf(t) > -1:
                    default:
                        i = 31;
                }
                return i;
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$T = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w, this.tooltipKeyFormat = "dd MMM";
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "xLabelFormat",
            value: function(t, e, i, a) {
                var s = this.w;
                if ("datetime" === s.config.xaxis.type && void 0 === s.config.xaxis.labels.formatter && void 0 === s.config.tooltip.x.formatter) {
                    var r = new $fffa43d1c55f0813$var$I(this.ctx);
                    return r.formatDate(r.getDate(e), s.config.tooltip.x.format);
                }
                return t(e, i, a);
            }
        },
        {
            key: "defaultGeneralFormatter",
            value: function(t) {
                return Array.isArray(t) ? t.map(function(t) {
                    return t;
                }) : t;
            }
        },
        {
            key: "defaultYFormatter",
            value: function(t, e, i) {
                var a = this.w;
                return $fffa43d1c55f0813$var$x.isNumber(t) && (t = 0 !== a.globals.yValueDecimal ? t.toFixed(void 0 !== e.decimalsInFloat ? e.decimalsInFloat : a.globals.yValueDecimal) : a.globals.maxYArr[i] - a.globals.minYArr[i] < 5 ? t.toFixed(1) : t.toFixed(0)), t;
            }
        },
        {
            key: "setLabelFormatters",
            value: function() {
                var t = this, e = this.w;
                return e.globals.xaxisTooltipFormatter = function(e) {
                    return t.defaultGeneralFormatter(e);
                }, e.globals.ttKeyFormatter = function(e) {
                    return t.defaultGeneralFormatter(e);
                }, e.globals.ttZFormatter = function(t) {
                    return t;
                }, e.globals.legendFormatter = function(e) {
                    return t.defaultGeneralFormatter(e);
                }, void 0 !== e.config.xaxis.labels.formatter ? e.globals.xLabelFormatter = e.config.xaxis.labels.formatter : e.globals.xLabelFormatter = function(t) {
                    if ($fffa43d1c55f0813$var$x.isNumber(t)) {
                        if (!e.config.xaxis.convertedCatToNumeric && "numeric" === e.config.xaxis.type) {
                            if ($fffa43d1c55f0813$var$x.isNumber(e.config.xaxis.decimalsInFloat)) return t.toFixed(e.config.xaxis.decimalsInFloat);
                            var i = e.globals.maxX - e.globals.minX;
                            return i > 0 && i < 100 ? t.toFixed(1) : t.toFixed(0);
                        }
                        if (e.globals.isBarHorizontal) {
                            if (e.globals.maxY - e.globals.minYArr < 4) return t.toFixed(1);
                        }
                        return t.toFixed(0);
                    }
                    return t;
                }, "function" == typeof e.config.tooltip.x.formatter ? e.globals.ttKeyFormatter = e.config.tooltip.x.formatter : e.globals.ttKeyFormatter = e.globals.xLabelFormatter, "function" == typeof e.config.xaxis.tooltip.formatter && (e.globals.xaxisTooltipFormatter = e.config.xaxis.tooltip.formatter), (Array.isArray(e.config.tooltip.y) || void 0 !== e.config.tooltip.y.formatter) && (e.globals.ttVal = e.config.tooltip.y), void 0 !== e.config.tooltip.z.formatter && (e.globals.ttZFormatter = e.config.tooltip.z.formatter), void 0 !== e.config.legend.formatter && (e.globals.legendFormatter = e.config.legend.formatter), e.config.yaxis.forEach(function(i, a) {
                    void 0 !== i.labels.formatter ? e.globals.yLabelFormatters[a] = i.labels.formatter : e.globals.yLabelFormatters[a] = function(s) {
                        return e.globals.xyCharts ? Array.isArray(s) ? s.map(function(e) {
                            return t.defaultYFormatter(e, i, a);
                        }) : t.defaultYFormatter(s, i, a) : s;
                    };
                }), e.globals;
            }
        },
        {
            key: "heatmapLabelFormatters",
            value: function() {
                var t = this.w;
                if ("heatmap" === t.config.chart.type) {
                    t.globals.yAxisScale[0].result = t.globals.seriesNames.slice();
                    var e = t.globals.seriesNames.reduce(function(t, e) {
                        return t.length > e.length ? t : e;
                    }, 0);
                    t.globals.yAxisScale[0].niceMax = e, t.globals.yAxisScale[0].niceMin = e;
                }
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$M = function(t) {
    var e, i = t.isTimeline, a = t.ctx, s = t.seriesIndex, r = t.dataPointIndex, o = t.y1, n = t.y2, l = t.w, h = l.globals.seriesRangeStart[s][r], c = l.globals.seriesRangeEnd[s][r], d = l.globals.labels[r], g = l.config.series[s].name ? l.config.series[s].name : "", u = l.globals.ttKeyFormatter, p = l.config.tooltip.y.title.formatter, f = {
        w: l,
        seriesIndex: s,
        dataPointIndex: r,
        start: h,
        end: c
    };
    ("function" == typeof p && (g = p(g, f)), null !== (e = l.config.series[s].data[r]) && void 0 !== e && e.x && (d = l.config.series[s].data[r].x), i) || "datetime" === l.config.xaxis.type && (d = new $fffa43d1c55f0813$var$T(a).xLabelFormat(l.globals.ttKeyFormatter, d, d, {
        i: void 0,
        dateFormatter: new $fffa43d1c55f0813$var$I(a).formatDate,
        w: l
    }));
    "function" == typeof u && (d = u(d, f)), Number.isFinite(o) && Number.isFinite(n) && (h = o, c = n);
    var x = "", b = "", v = l.globals.colors[s];
    if (void 0 === l.config.tooltip.x.formatter) {
        if ("datetime" === l.config.xaxis.type) {
            var m = new $fffa43d1c55f0813$var$I(a);
            x = m.formatDate(m.getDate(h), l.config.tooltip.x.format), b = m.formatDate(m.getDate(c), l.config.tooltip.x.format);
        } else x = h, b = c;
    } else x = l.config.tooltip.x.formatter(h), b = l.config.tooltip.x.formatter(c);
    return {
        start: h,
        end: c,
        startVal: x,
        endVal: b,
        ylabel: d,
        color: v,
        seriesName: g
    };
}, $fffa43d1c55f0813$var$z = function(t) {
    var e = t.color, i = t.seriesName, a = t.ylabel, s = t.start, r = t.end, o = t.seriesIndex, n = t.dataPointIndex, l = t.ctx.tooltip.tooltipLabels.getFormatters(o);
    s = l.yLbFormatter(s), r = l.yLbFormatter(r);
    var h = l.yLbFormatter(t.w.globals.series[o][n]), c = '<span class="value start-value">\n  '.concat(s, '\n  </span> <span class="separator">-</span> <span class="value end-value">\n  ').concat(r, "\n  </span>");
    return '<div class="apexcharts-tooltip-rangebar"><div> <span class="series-name" style="color: ' + e + '">' + (i || "") + '</span></div><div> <span class="category">' + a + ": </span> " + (t.w.globals.comboCharts ? "rangeArea" === t.w.config.series[o].type || "rangeBar" === t.w.config.series[o].type ? c : "<span>".concat(h, "</span>") : c) + " </div></div>";
}, $fffa43d1c55f0813$var$X = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.opts = e;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "hideYAxis",
            value: function() {
                this.opts.yaxis[0].show = !1, this.opts.yaxis[0].title.text = "", this.opts.yaxis[0].axisBorder.show = !1, this.opts.yaxis[0].axisTicks.show = !1, this.opts.yaxis[0].floating = !0;
            }
        },
        {
            key: "line",
            value: function() {
                return {
                    chart: {
                        animations: {
                            easing: "swing"
                        }
                    },
                    dataLabels: {
                        enabled: !1
                    },
                    stroke: {
                        width: 5,
                        curve: "straight"
                    },
                    markers: {
                        size: 0,
                        hover: {
                            sizeOffset: 6
                        }
                    },
                    xaxis: {
                        crosshairs: {
                            width: 1
                        }
                    }
                };
            }
        },
        {
            key: "sparkline",
            value: function(t) {
                this.hideYAxis();
                return $fffa43d1c55f0813$var$x.extend(t, {
                    grid: {
                        show: !1,
                        padding: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                    },
                    legend: {
                        show: !1
                    },
                    xaxis: {
                        labels: {
                            show: !1
                        },
                        tooltip: {
                            enabled: !1
                        },
                        axisBorder: {
                            show: !1
                        },
                        axisTicks: {
                            show: !1
                        }
                    },
                    chart: {
                        toolbar: {
                            show: !1
                        },
                        zoom: {
                            enabled: !1
                        }
                    },
                    dataLabels: {
                        enabled: !1
                    }
                });
            }
        },
        {
            key: "bar",
            value: function() {
                return {
                    chart: {
                        stacked: !1,
                        animations: {
                            easing: "swing"
                        }
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                position: "center"
                            }
                        }
                    },
                    dataLabels: {
                        style: {
                            colors: [
                                "#fff"
                            ]
                        },
                        background: {
                            enabled: !1
                        }
                    },
                    stroke: {
                        width: 0,
                        lineCap: "round"
                    },
                    fill: {
                        opacity: .85
                    },
                    legend: {
                        markers: {
                            shape: "square",
                            radius: 2,
                            size: 8
                        }
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0
                    },
                    xaxis: {
                        tooltip: {
                            enabled: !1
                        },
                        tickPlacement: "between",
                        crosshairs: {
                            width: "barWidth",
                            position: "back",
                            fill: {
                                type: "gradient"
                            },
                            dropShadow: {
                                enabled: !1
                            },
                            stroke: {
                                width: 0
                            }
                        }
                    }
                };
            }
        },
        {
            key: "funnel",
            value: function() {
                return this.hideYAxis(), $fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, this.bar()), {}, {
                    chart: {
                        animations: {
                            easing: "linear",
                            speed: 800,
                            animateGradually: {
                                enabled: !1
                            }
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: !0,
                            borderRadiusApplication: "around",
                            borderRadius: 0,
                            dataLabels: {
                                position: "center"
                            }
                        }
                    },
                    grid: {
                        show: !1,
                        padding: {
                            left: 0,
                            right: 0
                        }
                    },
                    xaxis: {
                        labels: {
                            show: !1
                        },
                        tooltip: {
                            enabled: !1
                        },
                        axisBorder: {
                            show: !1
                        },
                        axisTicks: {
                            show: !1
                        }
                    }
                });
            }
        },
        {
            key: "candlestick",
            value: function() {
                var t = this;
                return {
                    stroke: {
                        width: 1,
                        colors: [
                            "#333"
                        ]
                    },
                    fill: {
                        opacity: 1
                    },
                    dataLabels: {
                        enabled: !1
                    },
                    tooltip: {
                        shared: !0,
                        custom: function(e) {
                            var i = e.seriesIndex, a = e.dataPointIndex, s = e.w;
                            return t._getBoxTooltip(s, i, a, [
                                "Open",
                                "High",
                                "",
                                "Low",
                                "Close"
                            ], "candlestick");
                        }
                    },
                    states: {
                        active: {
                            filter: {
                                type: "none"
                            }
                        }
                    },
                    xaxis: {
                        crosshairs: {
                            width: 1
                        }
                    }
                };
            }
        },
        {
            key: "boxPlot",
            value: function() {
                var t = this;
                return {
                    chart: {
                        animations: {
                            dynamicAnimation: {
                                enabled: !1
                            }
                        }
                    },
                    stroke: {
                        width: 1,
                        colors: [
                            "#24292e"
                        ]
                    },
                    dataLabels: {
                        enabled: !1
                    },
                    tooltip: {
                        shared: !0,
                        custom: function(e) {
                            var i = e.seriesIndex, a = e.dataPointIndex, s = e.w;
                            return t._getBoxTooltip(s, i, a, [
                                "Minimum",
                                "Q1",
                                "Median",
                                "Q3",
                                "Maximum"
                            ], "boxPlot");
                        }
                    },
                    markers: {
                        size: 5,
                        strokeWidth: 1,
                        strokeColors: "#111"
                    },
                    xaxis: {
                        crosshairs: {
                            width: 1
                        }
                    }
                };
            }
        },
        {
            key: "rangeBar",
            value: function() {
                return {
                    chart: {
                        animations: {
                            animateGradually: !1
                        }
                    },
                    stroke: {
                        width: 0,
                        lineCap: "square"
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 0,
                            dataLabels: {
                                position: "center"
                            }
                        }
                    },
                    dataLabels: {
                        enabled: !1,
                        formatter: function(t, e) {
                            e.ctx;
                            var i = e.seriesIndex, a = e.dataPointIndex, s = e.w, r = function() {
                                var t = s.globals.seriesRangeStart[i][a];
                                return s.globals.seriesRangeEnd[i][a] - t;
                            };
                            return s.globals.comboCharts ? "rangeBar" === s.config.series[i].type || "rangeArea" === s.config.series[i].type ? r() : t : r();
                        },
                        background: {
                            enabled: !1
                        },
                        style: {
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    markers: {
                        size: 10
                    },
                    tooltip: {
                        shared: !1,
                        followCursor: !0,
                        custom: function(t) {
                            return t.w.config.plotOptions && t.w.config.plotOptions.bar && t.w.config.plotOptions.bar.horizontal ? function(t) {
                                var i = $fffa43d1c55f0813$var$M($fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, t), {}, {
                                    isTimeline: !0
                                })), a = i.color, s = i.seriesName, r = i.ylabel, o = i.startVal, n = i.endVal;
                                return $fffa43d1c55f0813$var$z($fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, t), {}, {
                                    color: a,
                                    seriesName: s,
                                    ylabel: r,
                                    start: o,
                                    end: n
                                }));
                            }(t) : function(t) {
                                var i = $fffa43d1c55f0813$var$M(t), a = i.color, s = i.seriesName, r = i.ylabel, o = i.start, n = i.end;
                                return $fffa43d1c55f0813$var$z($fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, t), {}, {
                                    color: a,
                                    seriesName: s,
                                    ylabel: r,
                                    start: o,
                                    end: n
                                }));
                            }(t);
                        }
                    },
                    xaxis: {
                        tickPlacement: "between",
                        tooltip: {
                            enabled: !1
                        },
                        crosshairs: {
                            stroke: {
                                width: 0
                            }
                        }
                    }
                };
            }
        },
        {
            key: "dumbbell",
            value: function(t) {
                var e, i;
                return null !== (e = t.plotOptions.bar) && void 0 !== e && e.barHeight || (t.plotOptions.bar.barHeight = 2), null !== (i = t.plotOptions.bar) && void 0 !== i && i.columnWidth || (t.plotOptions.bar.columnWidth = 2), t;
            }
        },
        {
            key: "area",
            value: function() {
                return {
                    stroke: {
                        width: 4,
                        fill: {
                            type: "solid",
                            gradient: {
                                inverseColors: !1,
                                shade: "light",
                                type: "vertical",
                                opacityFrom: .65,
                                opacityTo: .5,
                                stops: [
                                    0,
                                    100,
                                    100
                                ]
                            }
                        }
                    },
                    fill: {
                        type: "gradient",
                        gradient: {
                            inverseColors: !1,
                            shade: "light",
                            type: "vertical",
                            opacityFrom: .65,
                            opacityTo: .5,
                            stops: [
                                0,
                                100,
                                100
                            ]
                        }
                    },
                    markers: {
                        size: 0,
                        hover: {
                            sizeOffset: 6
                        }
                    },
                    tooltip: {
                        followCursor: !1
                    }
                };
            }
        },
        {
            key: "rangeArea",
            value: function() {
                return {
                    stroke: {
                        curve: "straight",
                        width: 0
                    },
                    fill: {
                        type: "solid",
                        opacity: .6
                    },
                    markers: {
                        size: 0
                    },
                    states: {
                        hover: {
                            filter: {
                                type: "none"
                            }
                        },
                        active: {
                            filter: {
                                type: "none"
                            }
                        }
                    },
                    tooltip: {
                        intersect: !1,
                        shared: !0,
                        followCursor: !0,
                        custom: function(t) {
                            return function(t) {
                                var i = $fffa43d1c55f0813$var$M(t), a = i.color, s = i.seriesName, r = i.ylabel, o = i.start, n = i.end;
                                return $fffa43d1c55f0813$var$z($fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, t), {}, {
                                    color: a,
                                    seriesName: s,
                                    ylabel: r,
                                    start: o,
                                    end: n
                                }));
                            }(t);
                        }
                    }
                };
            }
        },
        {
            key: "brush",
            value: function(t) {
                return $fffa43d1c55f0813$var$x.extend(t, {
                    chart: {
                        toolbar: {
                            autoSelected: "selection",
                            show: !1
                        },
                        zoom: {
                            enabled: !1
                        }
                    },
                    dataLabels: {
                        enabled: !1
                    },
                    stroke: {
                        width: 1
                    },
                    tooltip: {
                        enabled: !1
                    },
                    xaxis: {
                        tooltip: {
                            enabled: !1
                        }
                    }
                });
            }
        },
        {
            key: "stacked100",
            value: function(t) {
                t.dataLabels = t.dataLabels || {}, t.dataLabels.formatter = t.dataLabels.formatter || void 0;
                var e = t.dataLabels.formatter;
                return t.yaxis.forEach(function(e, i) {
                    t.yaxis[i].min = 0, t.yaxis[i].max = 100;
                }), "bar" === t.chart.type && (t.dataLabels.formatter = e || function(t) {
                    return "number" == typeof t && t ? t.toFixed(0) + "%" : t;
                }), t;
            }
        },
        {
            key: "stackedBars",
            value: function() {
                var t = this.bar();
                return $fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, t), {}, {
                    plotOptions: $fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, t.plotOptions), {}, {
                        bar: $fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, t.plotOptions.bar), {}, {
                            borderRadiusApplication: "end",
                            borderRadiusWhenStacked: "last"
                        })
                    })
                });
            }
        },
        {
            key: "convertCatToNumeric",
            value: function(t) {
                return t.xaxis.convertedCatToNumeric = !0, t;
            }
        },
        {
            key: "convertCatToNumericXaxis",
            value: function(t, e, i) {
                t.xaxis.type = "numeric", t.xaxis.labels = t.xaxis.labels || {}, t.xaxis.labels.formatter = t.xaxis.labels.formatter || function(t) {
                    return $fffa43d1c55f0813$var$x.isNumber(t) ? Math.floor(t) : t;
                };
                var a = t.xaxis.labels.formatter, s = t.xaxis.categories && t.xaxis.categories.length ? t.xaxis.categories : t.labels;
                return i && i.length && (s = i.map(function(t) {
                    return Array.isArray(t) ? t : String(t);
                })), s && s.length && (t.xaxis.labels.formatter = function(t) {
                    return $fffa43d1c55f0813$var$x.isNumber(t) ? a(s[Math.floor(t) - 1]) : a(t);
                }), t.xaxis.categories = [], t.labels = [], t.xaxis.tickAmount = t.xaxis.tickAmount || "dataPoints", t;
            }
        },
        {
            key: "bubble",
            value: function() {
                return {
                    dataLabels: {
                        style: {
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0
                    },
                    xaxis: {
                        crosshairs: {
                            width: 0
                        }
                    },
                    fill: {
                        type: "solid",
                        gradient: {
                            shade: "light",
                            inverse: !0,
                            shadeIntensity: .55,
                            opacityFrom: .4,
                            opacityTo: .8
                        }
                    }
                };
            }
        },
        {
            key: "scatter",
            value: function() {
                return {
                    dataLabels: {
                        enabled: !1
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0
                    },
                    markers: {
                        size: 6,
                        strokeWidth: 1,
                        hover: {
                            sizeOffset: 2
                        }
                    }
                };
            }
        },
        {
            key: "heatmap",
            value: function() {
                return {
                    chart: {
                        stacked: !1
                    },
                    fill: {
                        opacity: 1
                    },
                    dataLabels: {
                        style: {
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    stroke: {
                        colors: [
                            "#fff"
                        ]
                    },
                    tooltip: {
                        followCursor: !0,
                        marker: {
                            show: !1
                        },
                        x: {
                            show: !1
                        }
                    },
                    legend: {
                        position: "top",
                        markers: {
                            shape: "square",
                            size: 10,
                            offsetY: 2
                        }
                    },
                    grid: {
                        padding: {
                            right: 20
                        }
                    }
                };
            }
        },
        {
            key: "treemap",
            value: function() {
                return {
                    chart: {
                        zoom: {
                            enabled: !1
                        }
                    },
                    dataLabels: {
                        style: {
                            fontSize: 14,
                            fontWeight: 600,
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    stroke: {
                        show: !0,
                        width: 2,
                        colors: [
                            "#fff"
                        ]
                    },
                    legend: {
                        show: !1
                    },
                    fill: {
                        gradient: {
                            stops: [
                                0,
                                100
                            ]
                        }
                    },
                    tooltip: {
                        followCursor: !0,
                        x: {
                            show: !1
                        }
                    },
                    grid: {
                        padding: {
                            left: 0,
                            right: 0
                        }
                    },
                    xaxis: {
                        crosshairs: {
                            show: !1
                        },
                        tooltip: {
                            enabled: !1
                        }
                    }
                };
            }
        },
        {
            key: "pie",
            value: function() {
                return {
                    chart: {
                        toolbar: {
                            show: !1
                        }
                    },
                    plotOptions: {
                        pie: {
                            donut: {
                                labels: {
                                    show: !1
                                }
                            }
                        }
                    },
                    dataLabels: {
                        formatter: function(t) {
                            return t.toFixed(1) + "%";
                        },
                        style: {
                            colors: [
                                "#fff"
                            ]
                        },
                        background: {
                            enabled: !1
                        },
                        dropShadow: {
                            enabled: !0
                        }
                    },
                    stroke: {
                        colors: [
                            "#fff"
                        ]
                    },
                    fill: {
                        opacity: 1,
                        gradient: {
                            shade: "light",
                            stops: [
                                0,
                                100
                            ]
                        }
                    },
                    tooltip: {
                        theme: "dark",
                        fillSeriesColor: !0
                    },
                    legend: {
                        position: "right"
                    }
                };
            }
        },
        {
            key: "donut",
            value: function() {
                return {
                    chart: {
                        toolbar: {
                            show: !1
                        }
                    },
                    dataLabels: {
                        formatter: function(t) {
                            return t.toFixed(1) + "%";
                        },
                        style: {
                            colors: [
                                "#fff"
                            ]
                        },
                        background: {
                            enabled: !1
                        },
                        dropShadow: {
                            enabled: !0
                        }
                    },
                    stroke: {
                        colors: [
                            "#fff"
                        ]
                    },
                    fill: {
                        opacity: 1,
                        gradient: {
                            shade: "light",
                            shadeIntensity: .35,
                            stops: [
                                80,
                                100
                            ],
                            opacityFrom: 1,
                            opacityTo: 1
                        }
                    },
                    tooltip: {
                        theme: "dark",
                        fillSeriesColor: !0
                    },
                    legend: {
                        position: "right"
                    }
                };
            }
        },
        {
            key: "polarArea",
            value: function() {
                return this.opts.yaxis[0].tickAmount = this.opts.yaxis[0].tickAmount ? this.opts.yaxis[0].tickAmount : 6, {
                    chart: {
                        toolbar: {
                            show: !1
                        }
                    },
                    dataLabels: {
                        formatter: function(t) {
                            return t.toFixed(1) + "%";
                        },
                        enabled: !1
                    },
                    stroke: {
                        show: !0,
                        width: 2
                    },
                    fill: {
                        opacity: .7
                    },
                    tooltip: {
                        theme: "dark",
                        fillSeriesColor: !0
                    },
                    legend: {
                        position: "right"
                    }
                };
            }
        },
        {
            key: "radar",
            value: function() {
                return this.opts.yaxis[0].labels.offsetY = this.opts.yaxis[0].labels.offsetY ? this.opts.yaxis[0].labels.offsetY : 6, {
                    dataLabels: {
                        enabled: !1,
                        style: {
                            fontSize: "11px"
                        }
                    },
                    stroke: {
                        width: 2
                    },
                    markers: {
                        size: 3,
                        strokeWidth: 1,
                        strokeOpacity: 1
                    },
                    fill: {
                        opacity: .2
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0,
                        followCursor: !0
                    },
                    grid: {
                        show: !1
                    },
                    xaxis: {
                        labels: {
                            formatter: function(t) {
                                return t;
                            },
                            style: {
                                colors: [
                                    "#a8a8a8"
                                ],
                                fontSize: "11px"
                            }
                        },
                        tooltip: {
                            enabled: !1
                        },
                        crosshairs: {
                            show: !1
                        }
                    }
                };
            }
        },
        {
            key: "radialBar",
            value: function() {
                return {
                    chart: {
                        animations: {
                            dynamicAnimation: {
                                enabled: !0,
                                speed: 800
                            }
                        },
                        toolbar: {
                            show: !1
                        }
                    },
                    fill: {
                        gradient: {
                            shade: "dark",
                            shadeIntensity: .4,
                            inverseColors: !1,
                            type: "diagonal2",
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [
                                70,
                                98,
                                100
                            ]
                        }
                    },
                    legend: {
                        show: !1,
                        position: "right"
                    },
                    tooltip: {
                        enabled: !1,
                        fillSeriesColor: !0
                    }
                };
            }
        },
        {
            key: "_getBoxTooltip",
            value: function(t, e, i, a, s) {
                var r = t.globals.seriesCandleO[e][i], o = t.globals.seriesCandleH[e][i], n = t.globals.seriesCandleM[e][i], l = t.globals.seriesCandleL[e][i], h = t.globals.seriesCandleC[e][i];
                return t.config.series[e].type && t.config.series[e].type !== s ? '<div class="apexcharts-custom-tooltip">\n          '.concat(t.config.series[e].name ? t.config.series[e].name : "series-" + (e + 1), ": <strong>").concat(t.globals.series[e][i], "</strong>\n        </div>") : '<div class="apexcharts-tooltip-box apexcharts-tooltip-'.concat(t.config.chart.type, '">') + "<div>".concat(a[0], ': <span class="value">') + r + "</span></div>" + "<div>".concat(a[1], ': <span class="value">') + o + "</span></div>" + (n ? "<div>".concat(a[2], ': <span class="value">') + n + "</span></div>" : "") + "<div>".concat(a[3], ': <span class="value">') + l + "</span></div>" + "<div>".concat(a[4], ': <span class="value">') + h + "</span></div></div>";
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$E = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.opts = e;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "init",
            value: function(t) {
                var e = t.responsiveOverride, a = this.opts, s = new $fffa43d1c55f0813$var$L, r = new $fffa43d1c55f0813$var$X(a);
                this.chartType = a.chart.type, a = this.extendYAxis(a), a = this.extendAnnotations(a);
                var o = s.init(), n = {};
                if (a && "object" === $fffa43d1c55f0813$var$i(a)) {
                    var l, h, c, d, g, u, p, f, b, v, m = {};
                    m = -1 !== [
                        "line",
                        "area",
                        "bar",
                        "candlestick",
                        "boxPlot",
                        "rangeBar",
                        "rangeArea",
                        "bubble",
                        "scatter",
                        "heatmap",
                        "treemap",
                        "pie",
                        "polarArea",
                        "donut",
                        "radar",
                        "radialBar"
                    ].indexOf(a.chart.type) ? r[a.chart.type]() : r.line(), null !== (l = a.plotOptions) && void 0 !== l && null !== (h = l.bar) && void 0 !== h && h.isFunnel && (m = r.funnel()), a.chart.stacked && "bar" === a.chart.type && (m = r.stackedBars()), null !== (c = a.chart.brush) && void 0 !== c && c.enabled && (m = r.brush(m)), a.chart.stacked && "100%" === a.chart.stackType && (a = r.stacked100(a)), null !== (d = a.plotOptions) && void 0 !== d && null !== (g = d.bar) && void 0 !== g && g.isDumbbell && (a = r.dumbbell(a)), "monotoneCubic" === (null === (u = a) || void 0 === u || null === (p = u.stroke) || void 0 === p ? void 0 : p.curve) && (a.stroke.curve = "smooth"), this.checkForDarkTheme(window.Apex), this.checkForDarkTheme(a), a.xaxis = a.xaxis || window.Apex.xaxis || {}, e || (a.xaxis.convertedCatToNumeric = !1), (null !== (f = (a = this.checkForCatToNumericXAxis(this.chartType, m, a)).chart.sparkline) && void 0 !== f && f.enabled || null !== (b = window.Apex.chart) && void 0 !== b && null !== (v = b.sparkline) && void 0 !== v && v.enabled) && (m = r.sparkline(m)), n = $fffa43d1c55f0813$var$x.extend(o, m);
                }
                var y = $fffa43d1c55f0813$var$x.extend(n, window.Apex);
                return o = $fffa43d1c55f0813$var$x.extend(y, a), o = this.handleUserInputErrors(o);
            }
        },
        {
            key: "checkForCatToNumericXAxis",
            value: function(t, e, i) {
                var a, s, r = new $fffa43d1c55f0813$var$X(i), o = ("bar" === t || "boxPlot" === t) && (null === (a = i.plotOptions) || void 0 === a || null === (s = a.bar) || void 0 === s ? void 0 : s.horizontal), n = "pie" === t || "polarArea" === t || "donut" === t || "radar" === t || "radialBar" === t || "heatmap" === t, l = "datetime" !== i.xaxis.type && "numeric" !== i.xaxis.type, h = i.xaxis.tickPlacement ? i.xaxis.tickPlacement : e.xaxis && e.xaxis.tickPlacement;
                return o || n || !l || "between" === h || (i = r.convertCatToNumeric(i)), i;
            }
        },
        {
            key: "extendYAxis",
            value: function(t, e) {
                var i = new $fffa43d1c55f0813$var$L;
                (void 0 === t.yaxis || !t.yaxis || Array.isArray(t.yaxis) && 0 === t.yaxis.length) && (t.yaxis = {}), t.yaxis.constructor !== Array && window.Apex.yaxis && window.Apex.yaxis.constructor !== Array && (t.yaxis = $fffa43d1c55f0813$var$x.extend(t.yaxis, window.Apex.yaxis)), t.yaxis.constructor !== Array ? t.yaxis = [
                    $fffa43d1c55f0813$var$x.extend(i.yAxis, t.yaxis)
                ] : t.yaxis = $fffa43d1c55f0813$var$x.extendArray(t.yaxis, i.yAxis);
                var a = !1;
                t.yaxis.forEach(function(t) {
                    t.logarithmic && (a = !0);
                });
                var s = t.series;
                return e && !s && (s = e.config.series), a && s.length !== t.yaxis.length && s.length && (t.yaxis = s.map(function(e, a) {
                    if (e.name || (s[a].name = "series-".concat(a + 1)), t.yaxis[a]) return t.yaxis[a].seriesName = s[a].name, t.yaxis[a];
                    var r = $fffa43d1c55f0813$var$x.extend(i.yAxis, t.yaxis[0]);
                    return r.show = !1, r;
                })), a && s.length > 1 && s.length !== t.yaxis.length && console.warn("A multi-series logarithmic chart should have equal number of series and y-axes"), t;
            }
        },
        {
            key: "extendAnnotations",
            value: function(t) {
                return void 0 === t.annotations && (t.annotations = {}, t.annotations.yaxis = [], t.annotations.xaxis = [], t.annotations.points = []), t = this.extendYAxisAnnotations(t), t = this.extendXAxisAnnotations(t), t = this.extendPointAnnotations(t);
            }
        },
        {
            key: "extendYAxisAnnotations",
            value: function(t) {
                var e = new $fffa43d1c55f0813$var$L;
                return t.annotations.yaxis = $fffa43d1c55f0813$var$x.extendArray(void 0 !== t.annotations.yaxis ? t.annotations.yaxis : [], e.yAxisAnnotation), t;
            }
        },
        {
            key: "extendXAxisAnnotations",
            value: function(t) {
                var e = new $fffa43d1c55f0813$var$L;
                return t.annotations.xaxis = $fffa43d1c55f0813$var$x.extendArray(void 0 !== t.annotations.xaxis ? t.annotations.xaxis : [], e.xAxisAnnotation), t;
            }
        },
        {
            key: "extendPointAnnotations",
            value: function(t) {
                var e = new $fffa43d1c55f0813$var$L;
                return t.annotations.points = $fffa43d1c55f0813$var$x.extendArray(void 0 !== t.annotations.points ? t.annotations.points : [], e.pointAnnotation), t;
            }
        },
        {
            key: "checkForDarkTheme",
            value: function(t) {
                t.theme && "dark" === t.theme.mode && (t.tooltip || (t.tooltip = {}), "light" !== t.tooltip.theme && (t.tooltip.theme = "dark"), t.chart.foreColor || (t.chart.foreColor = "#f6f7f8"), t.chart.background || (t.chart.background = "#424242"), t.theme.palette || (t.theme.palette = "palette4"));
            }
        },
        {
            key: "handleUserInputErrors",
            value: function(t) {
                var e = t;
                if (e.tooltip.shared && e.tooltip.intersect) throw new Error("tooltip.shared cannot be enabled when tooltip.intersect is true. Turn off any other option by setting it to false.");
                if ("bar" === e.chart.type && e.plotOptions.bar.horizontal) {
                    if (e.yaxis.length > 1) throw new Error("Multiple Y Axis for bars are not supported. Switch to column chart by setting plotOptions.bar.horizontal=false");
                    e.yaxis[0].reversed && (e.yaxis[0].opposite = !0), e.xaxis.tooltip.enabled = !1, e.yaxis[0].tooltip.enabled = !1, e.chart.zoom.enabled = !1;
                }
                return "bar" !== e.chart.type && "rangeBar" !== e.chart.type || e.tooltip.shared && "barWidth" === e.xaxis.crosshairs.width && e.series.length > 1 && (e.xaxis.crosshairs.width = "tickWidth"), "candlestick" !== e.chart.type && "boxPlot" !== e.chart.type || e.yaxis[0].reversed && (console.warn("Reversed y-axis in ".concat(e.chart.type, " chart is not supported.")), e.yaxis[0].reversed = !1), e;
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$Y = function() {
    function t() {
        $fffa43d1c55f0813$var$a(this, t);
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "initGlobalVars",
            value: function(t) {
                t.series = [], t.seriesCandleO = [], t.seriesCandleH = [], t.seriesCandleM = [], t.seriesCandleL = [], t.seriesCandleC = [], t.seriesRangeStart = [], t.seriesRangeEnd = [], t.seriesRange = [], t.seriesPercent = [], t.seriesGoals = [], t.seriesX = [], t.seriesZ = [], t.seriesNames = [], t.seriesTotals = [], t.seriesLog = [], t.seriesColors = [], t.stackedSeriesTotals = [], t.seriesXvalues = [], t.seriesYvalues = [], t.labels = [], t.hasXaxisGroups = !1, t.groups = [], t.hasSeriesGroups = !1, t.seriesGroups = [], t.categoryLabels = [], t.timescaleLabels = [], t.noLabelsProvided = !1, t.resizeTimer = null, t.selectionResizeTimer = null, t.delayedElements = [], t.pointsArray = [], t.dataLabelsRects = [], t.isXNumeric = !1, t.skipLastTimelinelabel = !1, t.skipFirstTimelinelabel = !1, t.isDataXYZ = !1, t.isMultiLineX = !1, t.isMultipleYAxis = !1, t.maxY = -Number.MAX_VALUE, t.minY = Number.MIN_VALUE, t.minYArr = [], t.maxYArr = [], t.maxX = -Number.MAX_VALUE, t.minX = Number.MAX_VALUE, t.initialMaxX = -Number.MAX_VALUE, t.initialMinX = Number.MAX_VALUE, t.maxDate = 0, t.minDate = Number.MAX_VALUE, t.minZ = Number.MAX_VALUE, t.maxZ = -Number.MAX_VALUE, t.minXDiff = Number.MAX_VALUE, t.yAxisScale = [], t.xAxisScale = null, t.xAxisTicksPositions = [], t.yLabelsCoords = [], t.yTitleCoords = [], t.barPadForNumericAxis = 0, t.padHorizontal = 0, t.xRange = 0, t.yRange = [], t.zRange = 0, t.dataPoints = 0, t.xTickAmount = 0;
            }
        },
        {
            key: "globalVars",
            value: function(t) {
                return {
                    chartID: null,
                    cuid: null,
                    events: {
                        beforeMount: [],
                        mounted: [],
                        updated: [],
                        clicked: [],
                        selection: [],
                        dataPointSelection: [],
                        zoomed: [],
                        scrolled: []
                    },
                    colors: [],
                    clientX: null,
                    clientY: null,
                    fill: {
                        colors: []
                    },
                    stroke: {
                        colors: []
                    },
                    dataLabels: {
                        style: {
                            colors: []
                        }
                    },
                    radarPolygons: {
                        fill: {
                            colors: []
                        }
                    },
                    markers: {
                        colors: [],
                        size: t.markers.size,
                        largestSize: 0
                    },
                    animationEnded: !1,
                    isTouchDevice: "ontouchstart" in window || navigator.msMaxTouchPoints,
                    isDirty: !1,
                    isExecCalled: !1,
                    initialConfig: null,
                    initialSeries: [],
                    lastXAxis: [],
                    lastYAxis: [],
                    columnSeries: null,
                    labels: [],
                    timescaleLabels: [],
                    noLabelsProvided: !1,
                    allSeriesCollapsed: !1,
                    collapsedSeries: [],
                    collapsedSeriesIndices: [],
                    ancillaryCollapsedSeries: [],
                    ancillaryCollapsedSeriesIndices: [],
                    risingSeries: [],
                    dataFormatXNumeric: !1,
                    capturedSeriesIndex: -1,
                    capturedDataPointIndex: -1,
                    selectedDataPoints: [],
                    goldenPadding: 35,
                    invalidLogScale: !1,
                    ignoreYAxisIndexes: [],
                    yAxisSameScaleIndices: [],
                    maxValsInArrayIndex: 0,
                    radialSize: 0,
                    selection: void 0,
                    zoomEnabled: "zoom" === t.chart.toolbar.autoSelected && t.chart.toolbar.tools.zoom && t.chart.zoom.enabled,
                    panEnabled: "pan" === t.chart.toolbar.autoSelected && t.chart.toolbar.tools.pan,
                    selectionEnabled: "selection" === t.chart.toolbar.autoSelected && t.chart.toolbar.tools.selection,
                    yaxis: null,
                    mousedown: !1,
                    lastClientPosition: {},
                    visibleXRange: void 0,
                    yValueDecimal: 0,
                    total: 0,
                    SVGNS: "http://www.w3.org/2000/svg",
                    svgWidth: 0,
                    svgHeight: 0,
                    noData: !1,
                    locale: {},
                    dom: {},
                    memory: {
                        methodsToExec: []
                    },
                    shouldAnimate: !0,
                    skipLastTimelinelabel: !1,
                    skipFirstTimelinelabel: !1,
                    delayedElements: [],
                    axisCharts: !0,
                    isDataXYZ: !1,
                    resized: !1,
                    resizeTimer: null,
                    comboCharts: !1,
                    dataChanged: !1,
                    previousPaths: [],
                    allSeriesHasEqualX: !0,
                    pointsArray: [],
                    dataLabelsRects: [],
                    lastDrawnDataLabelsIndexes: [],
                    hasNullValues: !1,
                    easing: null,
                    zoomed: !1,
                    gridWidth: 0,
                    gridHeight: 0,
                    rotateXLabels: !1,
                    defaultLabels: !1,
                    xLabelFormatter: void 0,
                    yLabelFormatters: [],
                    xaxisTooltipFormatter: void 0,
                    ttKeyFormatter: void 0,
                    ttVal: void 0,
                    ttZFormatter: void 0,
                    LINE_HEIGHT_RATIO: 1.618,
                    xAxisLabelsHeight: 0,
                    xAxisGroupLabelsHeight: 0,
                    xAxisLabelsWidth: 0,
                    yAxisLabelsWidth: 0,
                    scaleX: 1,
                    scaleY: 1,
                    translateX: 0,
                    translateY: 0,
                    translateYAxisX: [],
                    yAxisWidths: [],
                    translateXAxisY: 0,
                    translateXAxisX: 0,
                    tooltip: null
                };
            }
        },
        {
            key: "init",
            value: function(t) {
                var e = this.globalVars(t);
                return this.initGlobalVars(e), e.initialConfig = $fffa43d1c55f0813$var$x.extend({}, t), e.initialSeries = $fffa43d1c55f0813$var$x.clone(t.series), e.lastXAxis = $fffa43d1c55f0813$var$x.clone(e.initialConfig.xaxis), e.lastYAxis = $fffa43d1c55f0813$var$x.clone(e.initialConfig.yaxis), e;
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$F = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.opts = e;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "init",
            value: function() {
                var t = new $fffa43d1c55f0813$var$E(this.opts).init({
                    responsiveOverride: !1
                });
                return {
                    config: t,
                    globals: (new $fffa43d1c55f0813$var$Y).init(t)
                };
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$R = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w, this.opts = null, this.seriesIndex = 0;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "clippedImgArea",
            value: function(t) {
                var e = this.w, i = e.config, a = parseInt(e.globals.gridWidth, 10), s = parseInt(e.globals.gridHeight, 10), r = a > s ? a : s, o = t.image, n = 0, l = 0;
                void 0 === t.width && void 0 === t.height ? void 0 !== i.fill.image.width && void 0 !== i.fill.image.height ? (n = i.fill.image.width + 1, l = i.fill.image.height) : (n = r + 1, l = r) : (n = t.width, l = t.height);
                var h = document.createElementNS(e.globals.SVGNS, "pattern");
                $fffa43d1c55f0813$var$m.setAttrs(h, {
                    id: t.patternID,
                    patternUnits: t.patternUnits ? t.patternUnits : "userSpaceOnUse",
                    width: n + "px",
                    height: l + "px"
                });
                var c = document.createElementNS(e.globals.SVGNS, "image");
                h.appendChild(c), c.setAttributeNS(window.SVG.xlink, "href", o), $fffa43d1c55f0813$var$m.setAttrs(c, {
                    x: 0,
                    y: 0,
                    preserveAspectRatio: "none",
                    width: n + "px",
                    height: l + "px"
                }), c.style.opacity = t.opacity, e.globals.dom.elDefs.node.appendChild(h);
            }
        },
        {
            key: "getSeriesIndex",
            value: function(t) {
                var e = this.w, i = e.config.chart.type;
                return ("bar" === i || "rangeBar" === i) && e.config.plotOptions.bar.distributed || "heatmap" === i || "treemap" === i ? this.seriesIndex = t.seriesNumber : this.seriesIndex = t.seriesNumber % e.globals.series.length, this.seriesIndex;
            }
        },
        {
            key: "fillPath",
            value: function(t) {
                var e = this.w;
                this.opts = t;
                var i, a, s, r = this.w.config;
                this.seriesIndex = this.getSeriesIndex(t);
                var o = this.getFillColors()[this.seriesIndex];
                void 0 !== e.globals.seriesColors[this.seriesIndex] && (o = e.globals.seriesColors[this.seriesIndex]), "function" == typeof o && (o = o({
                    seriesIndex: this.seriesIndex,
                    dataPointIndex: t.dataPointIndex,
                    value: t.value,
                    w: e
                }));
                var n = t.fillType ? t.fillType : this.getFillType(this.seriesIndex), l = Array.isArray(r.fill.opacity) ? r.fill.opacity[this.seriesIndex] : r.fill.opacity;
                t.color && (o = t.color), o || (o = "#fff", console.warn("undefined color - ApexCharts"));
                var h = o;
                if (-1 === o.indexOf("rgb") ? o.length < 9 && (h = $fffa43d1c55f0813$var$x.hexToRgba(o, l)) : o.indexOf("rgba") > -1 && (l = $fffa43d1c55f0813$var$x.getOpacityFromRGBA(o)), t.opacity && (l = t.opacity), "pattern" === n && (a = this.handlePatternFill({
                    fillConfig: t.fillConfig,
                    patternFill: a,
                    fillColor: o,
                    fillOpacity: l,
                    defaultColor: h
                })), "gradient" === n && (s = this.handleGradientFill({
                    fillConfig: t.fillConfig,
                    fillColor: o,
                    fillOpacity: l,
                    i: this.seriesIndex
                })), "image" === n) {
                    var c = r.fill.image.src, d = t.patternID ? t.patternID : "";
                    this.clippedImgArea({
                        opacity: l,
                        image: Array.isArray(c) ? t.seriesNumber < c.length ? c[t.seriesNumber] : c[0] : c,
                        width: t.width ? t.width : void 0,
                        height: t.height ? t.height : void 0,
                        patternUnits: t.patternUnits,
                        patternID: "pattern".concat(e.globals.cuid).concat(t.seriesNumber + 1).concat(d)
                    }), i = "url(#pattern".concat(e.globals.cuid).concat(t.seriesNumber + 1).concat(d, ")");
                } else i = "gradient" === n ? s : "pattern" === n ? a : h;
                return t.solid && (i = h), i;
            }
        },
        {
            key: "getFillType",
            value: function(t) {
                var e = this.w;
                return Array.isArray(e.config.fill.type) ? e.config.fill.type[t] : e.config.fill.type;
            }
        },
        {
            key: "getFillColors",
            value: function() {
                var t = this.w, e = t.config, i = this.opts, a = [];
                return t.globals.comboCharts ? "line" === t.config.series[this.seriesIndex].type ? Array.isArray(t.globals.stroke.colors) ? a = t.globals.stroke.colors : a.push(t.globals.stroke.colors) : Array.isArray(t.globals.fill.colors) ? a = t.globals.fill.colors : a.push(t.globals.fill.colors) : "line" === e.chart.type ? Array.isArray(t.globals.stroke.colors) ? a = t.globals.stroke.colors : a.push(t.globals.stroke.colors) : Array.isArray(t.globals.fill.colors) ? a = t.globals.fill.colors : a.push(t.globals.fill.colors), void 0 !== i.fillColors && (a = [], Array.isArray(i.fillColors) ? a = i.fillColors.slice() : a.push(i.fillColors)), a;
            }
        },
        {
            key: "handlePatternFill",
            value: function(t) {
                var e = t.fillConfig, i = t.patternFill, a = t.fillColor, s = t.fillOpacity, r = t.defaultColor, o = this.w.config.fill;
                e && (o = e);
                var n = this.opts, l = new $fffa43d1c55f0813$var$m(this.ctx), h = Array.isArray(o.pattern.strokeWidth) ? o.pattern.strokeWidth[this.seriesIndex] : o.pattern.strokeWidth, c = a;
                Array.isArray(o.pattern.style) ? i = void 0 !== o.pattern.style[n.seriesNumber] ? l.drawPattern(o.pattern.style[n.seriesNumber], o.pattern.width, o.pattern.height, c, h, s) : r : i = l.drawPattern(o.pattern.style, o.pattern.width, o.pattern.height, c, h, s);
                return i;
            }
        },
        {
            key: "handleGradientFill",
            value: function(t) {
                var i = t.fillColor, a = t.fillOpacity, s = t.fillConfig, r = t.i, o = this.w.config.fill;
                s && (o = $fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, o), s));
                var n, l = this.opts, h = new $fffa43d1c55f0813$var$m(this.ctx), c = new $fffa43d1c55f0813$var$x, d = o.gradient.type, g = i, u = void 0 === o.gradient.opacityFrom ? a : Array.isArray(o.gradient.opacityFrom) ? o.gradient.opacityFrom[r] : o.gradient.opacityFrom;
                g.indexOf("rgba") > -1 && (u = $fffa43d1c55f0813$var$x.getOpacityFromRGBA(g));
                var p = void 0 === o.gradient.opacityTo ? a : Array.isArray(o.gradient.opacityTo) ? o.gradient.opacityTo[r] : o.gradient.opacityTo;
                if (void 0 === o.gradient.gradientToColors || 0 === o.gradient.gradientToColors.length) n = "dark" === o.gradient.shade ? c.shadeColor(-1 * parseFloat(o.gradient.shadeIntensity), i.indexOf("rgb") > -1 ? $fffa43d1c55f0813$var$x.rgb2hex(i) : i) : c.shadeColor(parseFloat(o.gradient.shadeIntensity), i.indexOf("rgb") > -1 ? $fffa43d1c55f0813$var$x.rgb2hex(i) : i);
                else if (o.gradient.gradientToColors[l.seriesNumber]) {
                    var f = o.gradient.gradientToColors[l.seriesNumber];
                    n = f, f.indexOf("rgba") > -1 && (p = $fffa43d1c55f0813$var$x.getOpacityFromRGBA(f));
                } else n = i;
                if (o.gradient.gradientFrom && (g = o.gradient.gradientFrom), o.gradient.gradientTo && (n = o.gradient.gradientTo), o.gradient.inverseColors) {
                    var b = g;
                    g = n, n = b;
                }
                return g.indexOf("rgb") > -1 && (g = $fffa43d1c55f0813$var$x.rgb2hex(g)), n.indexOf("rgb") > -1 && (n = $fffa43d1c55f0813$var$x.rgb2hex(n)), h.drawGradient(d, g, n, u, p, l.size, o.gradient.stops, o.gradient.colorStops, r);
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$H = function() {
    function t(e, i) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "setGlobalMarkerSize",
            value: function() {
                var t = this.w;
                if (t.globals.markers.size = Array.isArray(t.config.markers.size) ? t.config.markers.size : [
                    t.config.markers.size
                ], t.globals.markers.size.length > 0) {
                    if (t.globals.markers.size.length < t.globals.series.length + 1) for(var e = 0; e <= t.globals.series.length; e++)void 0 === t.globals.markers.size[e] && t.globals.markers.size.push(t.globals.markers.size[0]);
                } else t.globals.markers.size = t.config.series.map(function(e) {
                    return t.config.markers.size;
                });
            }
        },
        {
            key: "plotChartMarkers",
            value: function(t, e, i, a) {
                var s, r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4], o = this.w, n = e, l = t, h = null, c = new $fffa43d1c55f0813$var$m(this.ctx), d = o.config.markers.discrete && o.config.markers.discrete.length;
                if ((o.globals.markers.size[e] > 0 || r || d) && (h = c.group({
                    class: r || d ? "" : "apexcharts-series-markers"
                })).attr("clip-path", "url(#gridRectMarkerMask".concat(o.globals.cuid, ")")), Array.isArray(l.x)) for(var g = 0; g < l.x.length; g++){
                    var u = i;
                    1 === i && 0 === g && (u = 0), 1 === i && 1 === g && (u = 1);
                    var p = "apexcharts-marker";
                    if ("line" !== o.config.chart.type && "area" !== o.config.chart.type || o.globals.comboCharts || o.config.tooltip.intersect || (p += " no-pointer-events"), (Array.isArray(o.config.markers.size) ? o.globals.markers.size[e] > 0 : o.config.markers.size > 0) || r || d) {
                        $fffa43d1c55f0813$var$x.isNumber(l.y[g]) ? p += " w".concat($fffa43d1c55f0813$var$x.randomId()) : p = "apexcharts-nullpoint";
                        var f = this.getMarkerConfig({
                            cssClass: p,
                            seriesIndex: e,
                            dataPointIndex: u
                        });
                        o.config.series[n].data[u] && (o.config.series[n].data[u].fillColor && (f.pointFillColor = o.config.series[n].data[u].fillColor), o.config.series[n].data[u].strokeColor && (f.pointStrokeColor = o.config.series[n].data[u].strokeColor)), a && (f.pSize = a), (l.x[g] < 0 || l.x[g] > o.globals.gridWidth || l.y[g] < -o.globals.markers.largestSize || l.y[g] > o.globals.gridHeight + o.globals.markers.largestSize) && (f.pSize = 0), (s = c.drawMarker(l.x[g], l.y[g], f)).attr("rel", u), s.attr("j", u), s.attr("index", e), s.node.setAttribute("default-marker-size", f.pSize), new $fffa43d1c55f0813$var$v(this.ctx).setSelectionFilter(s, e, u), this.addEvents(s), h && h.add(s);
                    } else void 0 === o.globals.pointsArray[e] && (o.globals.pointsArray[e] = []), o.globals.pointsArray[e].push([
                        l.x[g],
                        l.y[g]
                    ]);
                }
                return h;
            }
        },
        {
            key: "getMarkerConfig",
            value: function(t) {
                var e = t.cssClass, i = t.seriesIndex, a = t.dataPointIndex, s = void 0 === a ? null : a, r = t.finishRadius, o = void 0 === r ? null : r, n = this.w, l = this.getMarkerStyle(i), h = n.globals.markers.size[i], c = n.config.markers;
                return null !== s && c.discrete.length && c.discrete.map(function(t) {
                    t.seriesIndex === i && t.dataPointIndex === s && (l.pointStrokeColor = t.strokeColor, l.pointFillColor = t.fillColor, h = t.size, l.pointShape = t.shape);
                }), {
                    pSize: null === o ? h : o,
                    pRadius: c.radius,
                    width: Array.isArray(c.width) ? c.width[i] : c.width,
                    height: Array.isArray(c.height) ? c.height[i] : c.height,
                    pointStrokeWidth: Array.isArray(c.strokeWidth) ? c.strokeWidth[i] : c.strokeWidth,
                    pointStrokeColor: l.pointStrokeColor,
                    pointFillColor: l.pointFillColor,
                    shape: l.pointShape || (Array.isArray(c.shape) ? c.shape[i] : c.shape),
                    class: e,
                    pointStrokeOpacity: Array.isArray(c.strokeOpacity) ? c.strokeOpacity[i] : c.strokeOpacity,
                    pointStrokeDashArray: Array.isArray(c.strokeDashArray) ? c.strokeDashArray[i] : c.strokeDashArray,
                    pointFillOpacity: Array.isArray(c.fillOpacity) ? c.fillOpacity[i] : c.fillOpacity,
                    seriesIndex: i
                };
            }
        },
        {
            key: "addEvents",
            value: function(t) {
                var e = this.w, i = new $fffa43d1c55f0813$var$m(this.ctx);
                t.node.addEventListener("mouseenter", i.pathMouseEnter.bind(this.ctx, t)), t.node.addEventListener("mouseleave", i.pathMouseLeave.bind(this.ctx, t)), t.node.addEventListener("mousedown", i.pathMouseDown.bind(this.ctx, t)), t.node.addEventListener("click", e.config.markers.onClick), t.node.addEventListener("dblclick", e.config.markers.onDblClick), t.node.addEventListener("touchstart", i.pathMouseDown.bind(this.ctx, t), {
                    passive: !0
                });
            }
        },
        {
            key: "getMarkerStyle",
            value: function(t) {
                var e = this.w, i = e.globals.markers.colors, a = e.config.markers.strokeColor || e.config.markers.strokeColors;
                return {
                    pointStrokeColor: Array.isArray(a) ? a[t] : a,
                    pointFillColor: Array.isArray(i) ? i[t] : i
                };
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$D = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "draw",
            value: function(t, e, i) {
                var a = this.w, s = new $fffa43d1c55f0813$var$m(this.ctx), r = i.realIndex, o = i.pointsPos, n = i.zRatio, l = i.elParent, h = s.group({
                    class: "apexcharts-series-markers apexcharts-series-".concat(a.config.chart.type)
                });
                if (h.attr("clip-path", "url(#gridRectMarkerMask".concat(a.globals.cuid, ")")), Array.isArray(o.x)) for(var c = 0; c < o.x.length; c++){
                    var d = e + 1, g = !0;
                    0 === e && 0 === c && (d = 0), 0 === e && 1 === c && (d = 1);
                    var u = 0, p = a.globals.markers.size[r];
                    if (n !== 1 / 0) {
                        var f = a.config.plotOptions.bubble;
                        p = a.globals.seriesZ[r][d], f.zScaling && (p /= n), f.minBubbleRadius && p < f.minBubbleRadius && (p = f.minBubbleRadius), f.maxBubbleRadius && p > f.maxBubbleRadius && (p = f.maxBubbleRadius);
                    }
                    a.config.chart.animations.enabled || (u = p);
                    var x = o.x[c], b = o.y[c];
                    if (u = u || 0, null !== b && void 0 !== a.globals.series[r][d] || (g = !1), g) {
                        var v = this.drawPoint(x, b, u, p, r, d, e);
                        h.add(v);
                    }
                    l.add(h);
                }
            }
        },
        {
            key: "drawPoint",
            value: function(t, e, i, a, s, r, o) {
                var n = this.w, l = s, h = new $fffa43d1c55f0813$var$b(this.ctx), c = new $fffa43d1c55f0813$var$v(this.ctx), d = new $fffa43d1c55f0813$var$R(this.ctx), g = new $fffa43d1c55f0813$var$H(this.ctx), u = new $fffa43d1c55f0813$var$m(this.ctx), p = g.getMarkerConfig({
                    cssClass: "apexcharts-marker",
                    seriesIndex: l,
                    dataPointIndex: r,
                    finishRadius: "bubble" === n.config.chart.type || n.globals.comboCharts && n.config.series[s] && "bubble" === n.config.series[s].type ? a : null
                });
                a = p.pSize;
                var f, x = d.fillPath({
                    seriesNumber: s,
                    dataPointIndex: r,
                    color: p.pointFillColor,
                    patternUnits: "objectBoundingBox",
                    value: n.globals.series[s][o]
                });
                if ("circle" === p.shape ? f = u.drawCircle(i) : "square" !== p.shape && "rect" !== p.shape || (f = u.drawRect(0, 0, p.width - p.pointStrokeWidth / 2, p.height - p.pointStrokeWidth / 2, p.pRadius)), n.config.series[l].data[r] && n.config.series[l].data[r].fillColor && (x = n.config.series[l].data[r].fillColor), f.attr({
                    x: t - p.width / 2 - p.pointStrokeWidth / 2,
                    y: e - p.height / 2 - p.pointStrokeWidth / 2,
                    cx: t,
                    cy: e,
                    fill: x,
                    "fill-opacity": p.pointFillOpacity,
                    stroke: p.pointStrokeColor,
                    r: a,
                    "stroke-width": p.pointStrokeWidth,
                    "stroke-dasharray": p.pointStrokeDashArray,
                    "stroke-opacity": p.pointStrokeOpacity
                }), n.config.chart.dropShadow.enabled) {
                    var y = n.config.chart.dropShadow;
                    c.dropShadow(f, y, s);
                }
                if (!this.initialAnim || n.globals.dataChanged || n.globals.resized) n.globals.animationEnded = !0;
                else {
                    var w = n.config.chart.animations.speed;
                    h.animateMarker(f, 0, "circle" === p.shape ? a : {
                        width: p.width,
                        height: p.height
                    }, w, n.globals.easing, function() {
                        window.setTimeout(function() {
                            h.animationCompleted(f);
                        }, 100);
                    });
                }
                if (n.globals.dataChanged && "circle" === p.shape) {
                    if (this.dynamicAnim) {
                        var k, A, S, C, L = n.config.chart.animations.dynamicAnimation.speed;
                        null != (C = n.globals.previousPaths[s] && n.globals.previousPaths[s][o]) && (k = C.x, A = C.y, S = void 0 !== C.r ? C.r : a);
                        for(var P = 0; P < n.globals.collapsedSeries.length; P++)n.globals.collapsedSeries[P].index === s && (L = 1, a = 0);
                        0 === t && 0 === e && (a = 0), h.animateCircle(f, {
                            cx: k,
                            cy: A,
                            r: S
                        }, {
                            cx: t,
                            cy: e,
                            r: a
                        }, L, n.globals.easing);
                    } else f.attr({
                        r: a
                    });
                }
                return f.attr({
                    rel: r,
                    j: r,
                    index: s,
                    "default-marker-size": a
                }), c.setSelectionFilter(f, s, r), g.addEvents(f), f.node.classList.add("apexcharts-marker"), f;
            }
        },
        {
            key: "centerTextInBubble",
            value: function(t) {
                var e = this.w;
                return {
                    y: t += parseInt(e.config.dataLabels.style.fontSize, 10) / 4
                };
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$O = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "dataLabelsCorrection",
            value: function(t, e, i, a, s, r, o) {
                var n = this.w, l = !1, h = new $fffa43d1c55f0813$var$m(this.ctx).getTextRects(i, o), c = h.width, d = h.height;
                e < 0 && (e = 0), e > n.globals.gridHeight + d && (e = n.globals.gridHeight + d / 2), void 0 === n.globals.dataLabelsRects[a] && (n.globals.dataLabelsRects[a] = []), n.globals.dataLabelsRects[a].push({
                    x: t,
                    y: e,
                    width: c,
                    height: d
                });
                var g = n.globals.dataLabelsRects[a].length - 2, u = void 0 !== n.globals.lastDrawnDataLabelsIndexes[a] ? n.globals.lastDrawnDataLabelsIndexes[a][n.globals.lastDrawnDataLabelsIndexes[a].length - 1] : 0;
                if (void 0 !== n.globals.dataLabelsRects[a][g]) {
                    var p = n.globals.dataLabelsRects[a][u];
                    (t > p.x + p.width || e > p.y + p.height || e + d < p.y || t + c < p.x) && (l = !0);
                }
                return (0 === s || r) && (l = !0), {
                    x: t,
                    y: e,
                    textRects: h,
                    drawnextLabel: l
                };
            }
        },
        {
            key: "drawDataLabel",
            value: function(t) {
                var e = this, i = t.type, a = t.pos, s = t.i, r = t.j, o = t.isRangeStart, n = t.strokeWidth, l = void 0 === n ? 2 : n, h = this.w, c = new $fffa43d1c55f0813$var$m(this.ctx), d = h.config.dataLabels, g = 0, u = 0, p = r, f = null;
                if (!d.enabled || !Array.isArray(a.x)) return f;
                f = c.group({
                    class: "apexcharts-data-labels"
                });
                for(var x = 0; x < a.x.length; x++)if (g = a.x[x] + d.offsetX, u = a.y[x] + d.offsetY + l, !isNaN(g)) {
                    1 === r && 0 === x && (p = 0), 1 === r && 1 === x && (p = 1);
                    var b = h.globals.series[s][p];
                    "rangeArea" === i && (b = o ? h.globals.seriesRangeStart[s][p] : h.globals.seriesRangeEnd[s][p]);
                    var v = "", y = function(t) {
                        return h.config.dataLabels.formatter(t, {
                            ctx: e.ctx,
                            seriesIndex: s,
                            dataPointIndex: p,
                            w: h
                        });
                    };
                    if ("bubble" === h.config.chart.type) v = y(b = h.globals.seriesZ[s][p]), u = a.y[x], u = new $fffa43d1c55f0813$var$D(this.ctx).centerTextInBubble(u, s, p).y;
                    else void 0 !== b && (v = y(b));
                    this.plotDataLabelsText({
                        x: g,
                        y: u,
                        text: v,
                        i: s,
                        j: p,
                        parent: f,
                        offsetCorrection: !0,
                        dataLabelsConfig: h.config.dataLabels
                    });
                }
                return f;
            }
        },
        {
            key: "plotDataLabelsText",
            value: function(t) {
                var e = this.w, i = new $fffa43d1c55f0813$var$m(this.ctx), a = t.x, s = t.y, r = t.i, o = t.j, n = t.text, l = t.textAnchor, h = t.fontSize, c = t.parent, d = t.dataLabelsConfig, g = t.color, u = t.alwaysDrawDataLabel, p = t.offsetCorrection;
                if (!(Array.isArray(e.config.dataLabels.enabledOnSeries) && e.config.dataLabels.enabledOnSeries.indexOf(r) < 0)) {
                    var f = {
                        x: a,
                        y: s,
                        drawnextLabel: !0,
                        textRects: null
                    };
                    p && (f = this.dataLabelsCorrection(a, s, n, r, o, u, parseInt(d.style.fontSize, 10))), e.globals.zoomed || (a = f.x, s = f.y), f.textRects && (a < -20 - f.textRects.width || a > e.globals.gridWidth + f.textRects.width + 30) && (n = "");
                    var x = e.globals.dataLabels.style.colors[r];
                    (("bar" === e.config.chart.type || "rangeBar" === e.config.chart.type) && e.config.plotOptions.bar.distributed || e.config.dataLabels.distributed) && (x = e.globals.dataLabels.style.colors[o]), "function" == typeof x && (x = x({
                        series: e.globals.series,
                        seriesIndex: r,
                        dataPointIndex: o,
                        w: e
                    })), g && (x = g);
                    var b = d.offsetX, y = d.offsetY;
                    if ("bar" !== e.config.chart.type && "rangeBar" !== e.config.chart.type || (b = 0, y = 0), f.drawnextLabel) {
                        var w = i.drawText({
                            width: 100,
                            height: parseInt(d.style.fontSize, 10),
                            x: a + b,
                            y: s + y,
                            foreColor: x,
                            textAnchor: l || d.textAnchor,
                            text: n,
                            fontSize: h || d.style.fontSize,
                            fontFamily: d.style.fontFamily,
                            fontWeight: d.style.fontWeight || "normal"
                        });
                        if (w.attr({
                            class: "apexcharts-datalabel",
                            cx: a,
                            cy: s
                        }), d.dropShadow.enabled) {
                            var k = d.dropShadow;
                            new $fffa43d1c55f0813$var$v(this.ctx).dropShadow(w, k);
                        }
                        c.add(w), void 0 === e.globals.lastDrawnDataLabelsIndexes[r] && (e.globals.lastDrawnDataLabelsIndexes[r] = []), e.globals.lastDrawnDataLabelsIndexes[r].push(o);
                    }
                }
            }
        },
        {
            key: "addBackgroundToDataLabel",
            value: function(t, e) {
                var i = this.w, a = i.config.dataLabels.background, s = a.padding, r = a.padding / 2, o = e.width, n = e.height, l = new $fffa43d1c55f0813$var$m(this.ctx).drawRect(e.x - s, e.y - r / 2, o + 2 * s, n + r, a.borderRadius, "transparent" === i.config.chart.background ? "#fff" : i.config.chart.background, a.opacity, a.borderWidth, a.borderColor);
                a.dropShadow.enabled && new $fffa43d1c55f0813$var$v(this.ctx).dropShadow(l, a.dropShadow);
                return l;
            }
        },
        {
            key: "dataLabelsBackground",
            value: function() {
                var t = this.w;
                if ("bubble" !== t.config.chart.type) for(var e = t.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels text"), i = 0; i < e.length; i++){
                    var a = e[i], s = a.getBBox(), r = null;
                    if (s.width && s.height && (r = this.addBackgroundToDataLabel(a, s)), r) {
                        a.parentNode.insertBefore(r.node, a);
                        var o = a.getAttribute("fill");
                        t.config.chart.animations.enabled && !t.globals.resized && !t.globals.dataChanged ? r.animate().attr({
                            fill: o
                        }) : r.attr({
                            fill: o
                        }), a.setAttribute("fill", t.config.dataLabels.background.foreColor);
                    }
                }
            }
        },
        {
            key: "bringForward",
            value: function() {
                for(var t = this.w, e = t.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels"), i = t.globals.dom.baseEl.querySelector(".apexcharts-plot-series:last-child"), a = 0; a < e.length; a++)i && i.insertBefore(e[a], i.nextSibling);
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$N = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w, this.legendInactiveClass = "legend-mouseover-inactive";
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "getAllSeriesEls",
            value: function() {
                return this.w.globals.dom.baseEl.getElementsByClassName("apexcharts-series");
            }
        },
        {
            key: "getSeriesByName",
            value: function(t) {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner .apexcharts-series[seriesName='".concat($fffa43d1c55f0813$var$x.escapeString(t), "']"));
            }
        },
        {
            key: "isSeriesHidden",
            value: function(t) {
                var e = this.getSeriesByName(t), i = parseInt(e.getAttribute("data:realIndex"), 10);
                return {
                    isHidden: e.classList.contains("apexcharts-series-collapsed"),
                    realIndex: i
                };
            }
        },
        {
            key: "addCollapsedClassToSeries",
            value: function(t, e) {
                var i = this.w;
                function a(i) {
                    for(var a = 0; a < i.length; a++)i[a].index === e && t.node.classList.add("apexcharts-series-collapsed");
                }
                a(i.globals.collapsedSeries), a(i.globals.ancillaryCollapsedSeries);
            }
        },
        {
            key: "toggleSeries",
            value: function(t) {
                var e = this.isSeriesHidden(t);
                return this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex, e.isHidden), e.isHidden;
            }
        },
        {
            key: "showSeries",
            value: function(t) {
                var e = this.isSeriesHidden(t);
                e.isHidden && this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex, !0);
            }
        },
        {
            key: "hideSeries",
            value: function(t) {
                var e = this.isSeriesHidden(t);
                e.isHidden || this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex, !1);
            }
        },
        {
            key: "resetSeries",
            value: function() {
                var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], a = this.w, s = $fffa43d1c55f0813$var$x.clone(a.globals.initialSeries);
                a.globals.previousPaths = [], i ? (a.globals.collapsedSeries = [], a.globals.ancillaryCollapsedSeries = [], a.globals.collapsedSeriesIndices = [], a.globals.ancillaryCollapsedSeriesIndices = []) : s = this.emptyCollapsedSeries(s), a.config.series = s, t && (e && (a.globals.zoomed = !1, this.ctx.updateHelpers.revertDefaultAxisMinMax()), this.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled));
            }
        },
        {
            key: "emptyCollapsedSeries",
            value: function(t) {
                for(var e = this.w, i = 0; i < t.length; i++)e.globals.collapsedSeriesIndices.indexOf(i) > -1 && (t[i].data = []);
                return t;
            }
        },
        {
            key: "toggleSeriesOnHover",
            value: function(t, e) {
                var i = this.w;
                e || (e = t.target);
                var a = i.globals.dom.baseEl.querySelectorAll(".apexcharts-series, .apexcharts-datalabels");
                if ("mousemove" === t.type) {
                    var s = parseInt(e.getAttribute("rel"), 10) - 1, r = null, o = null;
                    i.globals.axisCharts || "radialBar" === i.config.chart.type ? i.globals.axisCharts ? (r = i.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(s, "']")), o = i.globals.dom.baseEl.querySelector(".apexcharts-datalabels[data\\:realIndex='".concat(s, "']"))) : r = i.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(s + 1, "']")) : r = i.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(s + 1, "'] path"));
                    for(var n = 0; n < a.length; n++)a[n].classList.add(this.legendInactiveClass);
                    null !== r && (i.globals.axisCharts || r.parentNode.classList.remove(this.legendInactiveClass), r.classList.remove(this.legendInactiveClass), null !== o && o.classList.remove(this.legendInactiveClass));
                } else if ("mouseout" === t.type) for(var l = 0; l < a.length; l++)a[l].classList.remove(this.legendInactiveClass);
            }
        },
        {
            key: "highlightRangeInSeries",
            value: function(t, e) {
                var i = this, a = this.w, s = a.globals.dom.baseEl.getElementsByClassName("apexcharts-heatmap-rect"), r = function(t) {
                    for(var e = 0; e < s.length; e++)s[e].classList[t](i.legendInactiveClass);
                };
                if ("mousemove" === t.type) {
                    var o = parseInt(e.getAttribute("rel"), 10) - 1;
                    r("add"), function(t) {
                        for(var e = 0; e < s.length; e++){
                            var a = parseInt(s[e].getAttribute("val"), 10);
                            a >= t.from && a <= t.to && s[e].classList.remove(i.legendInactiveClass);
                        }
                    }(a.config.plotOptions.heatmap.colorScale.ranges[o]);
                } else "mouseout" === t.type && r("remove");
            }
        },
        {
            key: "getActiveConfigSeriesIndex",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "asc", e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], i = this.w, a = 0;
                if (i.config.series.length > 1) {
                    for(var s = i.config.series.map(function(t, a) {
                        return t.data && t.data.length > 0 && -1 === i.globals.collapsedSeriesIndices.indexOf(a) && (!i.globals.comboCharts || 0 === e.length || e.length && e.indexOf(i.config.series[a].type) > -1) ? a : -1;
                    }), r = "asc" === t ? 0 : s.length - 1; "asc" === t ? r < s.length : r >= 0; "asc" === t ? r++ : r--)if (-1 !== s[r]) {
                        a = s[r];
                        break;
                    }
                }
                return a;
            }
        },
        {
            key: "getBarSeriesIndices",
            value: function() {
                return this.w.globals.comboCharts ? this.w.config.series.map(function(t, e) {
                    return "bar" === t.type || "column" === t.type ? e : -1;
                }).filter(function(t) {
                    return -1 !== t;
                }) : this.w.config.series.map(function(t, e) {
                    return e;
                });
            }
        },
        {
            key: "getPreviousPaths",
            value: function() {
                var t = this.w;
                function e(e, i, a) {
                    for(var s = e[i].childNodes, r = {
                        type: a,
                        paths: [],
                        realIndex: e[i].getAttribute("data:realIndex")
                    }, o = 0; o < s.length; o++)if (s[o].hasAttribute("pathTo")) {
                        var n = s[o].getAttribute("pathTo");
                        r.paths.push({
                            d: n
                        });
                    }
                    t.globals.previousPaths.push(r);
                }
                t.globals.previousPaths = [];
                [
                    "line",
                    "area",
                    "bar",
                    "rangebar",
                    "rangeArea",
                    "candlestick",
                    "radar"
                ].forEach(function(i) {
                    for(var a, s = (a = i, t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(a, "-series .apexcharts-series"))), r = 0; r < s.length; r++)e(s, r, i);
                }), this.handlePrevBubbleScatterPaths("bubble"), this.handlePrevBubbleScatterPaths("scatter");
                var i = t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t.config.chart.type, " .apexcharts-series"));
                if (i.length > 0) for(var a = function(e) {
                    for(var i = t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t.config.chart.type, " .apexcharts-series[data\\:realIndex='").concat(e, "'] rect")), a = [], s = function(t) {
                        var e = function(e) {
                            return i[t].getAttribute(e);
                        }, s = {
                            x: parseFloat(e("x")),
                            y: parseFloat(e("y")),
                            width: parseFloat(e("width")),
                            height: parseFloat(e("height"))
                        };
                        a.push({
                            rect: s,
                            color: i[t].getAttribute("color")
                        });
                    }, r = 0; r < i.length; r++)s(r);
                    t.globals.previousPaths.push(a);
                }, s = 0; s < i.length; s++)a(s);
                t.globals.axisCharts || (t.globals.previousPaths = t.globals.series);
            }
        },
        {
            key: "handlePrevBubbleScatterPaths",
            value: function(t) {
                var e = this.w, i = e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t, "-series .apexcharts-series"));
                if (i.length > 0) for(var a = 0; a < i.length; a++){
                    for(var s = e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t, "-series .apexcharts-series[data\\:realIndex='").concat(a, "'] circle")), r = [], o = 0; o < s.length; o++)r.push({
                        x: s[o].getAttribute("cx"),
                        y: s[o].getAttribute("cy"),
                        r: s[o].getAttribute("r")
                    });
                    e.globals.previousPaths.push(r);
                }
            }
        },
        {
            key: "clearPreviousPaths",
            value: function() {
                var t = this.w;
                t.globals.previousPaths = [], t.globals.allSeriesCollapsed = !1;
            }
        },
        {
            key: "handleNoData",
            value: function() {
                var t = this.w, e = t.config.noData, i = new $fffa43d1c55f0813$var$m(this.ctx), a = t.globals.svgWidth / 2, s = t.globals.svgHeight / 2, r = "middle";
                if (t.globals.noData = !0, t.globals.animationEnded = !0, "left" === e.align ? (a = 10, r = "start") : "right" === e.align && (a = t.globals.svgWidth - 10, r = "end"), "top" === e.verticalAlign ? s = 50 : "bottom" === e.verticalAlign && (s = t.globals.svgHeight - 50), a += e.offsetX, s = s + parseInt(e.style.fontSize, 10) + 2 + e.offsetY, void 0 !== e.text && "" !== e.text) {
                    var o = i.drawText({
                        x: a,
                        y: s,
                        text: e.text,
                        textAnchor: r,
                        fontSize: e.style.fontSize,
                        fontFamily: e.style.fontFamily,
                        foreColor: e.style.color,
                        opacity: 1,
                        class: "apexcharts-text-nodata"
                    });
                    t.globals.dom.Paper.add(o);
                }
            }
        },
        {
            key: "setNullSeriesToZeroValues",
            value: function(t) {
                for(var e = this.w, i = 0; i < t.length; i++)if (0 === t[i].length) for(var a = 0; a < t[e.globals.maxValsInArrayIndex].length; a++)t[i].push(0);
                return t;
            }
        },
        {
            key: "hasAllSeriesEqualX",
            value: function() {
                for(var t = !0, e = this.w, i = this.filteredSeriesX(), a = 0; a < i.length - 1; a++)if (i[a][0] !== i[a + 1][0]) {
                    t = !1;
                    break;
                }
                return e.globals.allSeriesHasEqualX = t, t;
            }
        },
        {
            key: "filteredSeriesX",
            value: function() {
                var t = this.w.globals.seriesX.map(function(t) {
                    return t.length > 0 ? t : [];
                });
                return t;
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$W = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w, this.twoDSeries = [], this.threeDSeries = [], this.twoDSeriesX = [], this.seriesGoals = [], this.coreUtils = new $fffa43d1c55f0813$var$y(this.ctx);
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "isMultiFormat",
            value: function() {
                return this.isFormatXY() || this.isFormat2DArray();
            }
        },
        {
            key: "isFormatXY",
            value: function() {
                var t = this.w.config.series.slice(), e = new $fffa43d1c55f0813$var$N(this.ctx);
                if (this.activeSeriesIndex = e.getActiveConfigSeriesIndex(), void 0 !== t[this.activeSeriesIndex].data && t[this.activeSeriesIndex].data.length > 0 && null !== t[this.activeSeriesIndex].data[0] && void 0 !== t[this.activeSeriesIndex].data[0].x && null !== t[this.activeSeriesIndex].data[0]) return !0;
            }
        },
        {
            key: "isFormat2DArray",
            value: function() {
                var t = this.w.config.series.slice(), e = new $fffa43d1c55f0813$var$N(this.ctx);
                if (this.activeSeriesIndex = e.getActiveConfigSeriesIndex(), void 0 !== t[this.activeSeriesIndex].data && t[this.activeSeriesIndex].data.length > 0 && void 0 !== t[this.activeSeriesIndex].data[0] && null !== t[this.activeSeriesIndex].data[0] && t[this.activeSeriesIndex].data[0].constructor === Array) return !0;
            }
        },
        {
            key: "handleFormat2DArray",
            value: function(t, e) {
                for(var i = this.w.config, a = this.w.globals, s = "boxPlot" === i.chart.type || "boxPlot" === i.series[e].type, r = 0; r < t[e].data.length; r++)if (void 0 !== t[e].data[r][1] && (Array.isArray(t[e].data[r][1]) && 4 === t[e].data[r][1].length && !s ? this.twoDSeries.push($fffa43d1c55f0813$var$x.parseNumber(t[e].data[r][1][3])) : t[e].data[r].length >= 5 ? this.twoDSeries.push($fffa43d1c55f0813$var$x.parseNumber(t[e].data[r][4])) : this.twoDSeries.push($fffa43d1c55f0813$var$x.parseNumber(t[e].data[r][1])), a.dataFormatXNumeric = !0), "datetime" === i.xaxis.type) {
                    var o = new Date(t[e].data[r][0]);
                    o = new Date(o).getTime(), this.twoDSeriesX.push(o);
                } else this.twoDSeriesX.push(t[e].data[r][0]);
                for(var n = 0; n < t[e].data.length; n++)void 0 !== t[e].data[n][2] && (this.threeDSeries.push(t[e].data[n][2]), a.isDataXYZ = !0);
            }
        },
        {
            key: "handleFormatXY",
            value: function(t, e) {
                var i = this.w.config, a = this.w.globals, s = new $fffa43d1c55f0813$var$I(this.ctx), r = e;
                a.collapsedSeriesIndices.indexOf(e) > -1 && (r = this.activeSeriesIndex);
                for(var o = 0; o < t[e].data.length; o++)void 0 !== t[e].data[o].y && (Array.isArray(t[e].data[o].y) ? this.twoDSeries.push($fffa43d1c55f0813$var$x.parseNumber(t[e].data[o].y[t[e].data[o].y.length - 1])) : this.twoDSeries.push($fffa43d1c55f0813$var$x.parseNumber(t[e].data[o].y))), void 0 !== t[e].data[o].goals && Array.isArray(t[e].data[o].goals) ? (void 0 === this.seriesGoals[e] && (this.seriesGoals[e] = []), this.seriesGoals[e].push(t[e].data[o].goals)) : (void 0 === this.seriesGoals[e] && (this.seriesGoals[e] = []), this.seriesGoals[e].push(null));
                for(var n = 0; n < t[r].data.length; n++){
                    var l = "string" == typeof t[r].data[n].x, h = Array.isArray(t[r].data[n].x), c = !h && !!s.isValidDate(t[r].data[n].x);
                    if (l || c) {
                        if (l || i.xaxis.convertedCatToNumeric) {
                            var d = a.isBarHorizontal && a.isRangeData;
                            "datetime" !== i.xaxis.type || d ? (this.fallbackToCategory = !0, this.twoDSeriesX.push(t[r].data[n].x), isNaN(t[r].data[n].x) || "category" === this.w.config.xaxis.type || "string" == typeof t[r].data[n].x || (a.isXNumeric = !0)) : this.twoDSeriesX.push(s.parseDate(t[r].data[n].x));
                        } else "datetime" === i.xaxis.type ? this.twoDSeriesX.push(s.parseDate(t[r].data[n].x.toString())) : (a.dataFormatXNumeric = !0, a.isXNumeric = !0, this.twoDSeriesX.push(parseFloat(t[r].data[n].x)));
                    } else h ? (this.fallbackToCategory = !0, this.twoDSeriesX.push(t[r].data[n].x)) : (a.isXNumeric = !0, a.dataFormatXNumeric = !0, this.twoDSeriesX.push(t[r].data[n].x));
                }
                if (t[e].data[0] && void 0 !== t[e].data[0].z) {
                    for(var g = 0; g < t[e].data.length; g++)this.threeDSeries.push(t[e].data[g].z);
                    a.isDataXYZ = !0;
                }
            }
        },
        {
            key: "handleRangeData",
            value: function(t, e) {
                var i = this.w.globals, a = {};
                return this.isFormat2DArray() ? a = this.handleRangeDataFormat("array", t, e) : this.isFormatXY() && (a = this.handleRangeDataFormat("xy", t, e)), i.seriesRangeStart.push(a.start), i.seriesRangeEnd.push(a.end), i.seriesRange.push(a.rangeUniques), i.seriesRange.forEach(function(t, e) {
                    t && t.forEach(function(t, e) {
                        t.y.forEach(function(e, i) {
                            for(var a = 0; a < t.y.length; a++)if (i !== a) {
                                var s = e.y1, r = e.y2, o = t.y[a].y1;
                                s <= t.y[a].y2 && o <= r && (t.overlaps.indexOf(e.rangeName) < 0 && t.overlaps.push(e.rangeName), t.overlaps.indexOf(t.y[a].rangeName) < 0 && t.overlaps.push(t.y[a].rangeName));
                            }
                        });
                    });
                }), a;
            }
        },
        {
            key: "handleCandleStickBoxData",
            value: function(t, e) {
                var i = this.w.globals, a = {};
                return this.isFormat2DArray() ? a = this.handleCandleStickBoxDataFormat("array", t, e) : this.isFormatXY() && (a = this.handleCandleStickBoxDataFormat("xy", t, e)), i.seriesCandleO[e] = a.o, i.seriesCandleH[e] = a.h, i.seriesCandleM[e] = a.m, i.seriesCandleL[e] = a.l, i.seriesCandleC[e] = a.c, a;
            }
        },
        {
            key: "handleRangeDataFormat",
            value: function(t, e, i) {
                var a = [], s = [], r = e[i].data.filter(function(t, e, i) {
                    return e === i.findIndex(function(e) {
                        return e.x === t.x;
                    });
                }).map(function(t, e) {
                    return {
                        x: t.x,
                        overlaps: [],
                        y: []
                    };
                });
                if ("array" === t) for(var o = 0; o < e[i].data.length; o++)Array.isArray(e[i].data[o]) ? (a.push(e[i].data[o][1][0]), s.push(e[i].data[o][1][1])) : (a.push(e[i].data[o]), s.push(e[i].data[o]));
                else if ("xy" === t) for(var n = function(t) {
                    var o = Array.isArray(e[i].data[t].y), n = $fffa43d1c55f0813$var$x.randomId(), l = e[i].data[t].x, h = {
                        y1: o ? e[i].data[t].y[0] : e[i].data[t].y,
                        y2: o ? e[i].data[t].y[1] : e[i].data[t].y,
                        rangeName: n
                    };
                    e[i].data[t].rangeName = n;
                    var c = r.findIndex(function(t) {
                        return t.x === l;
                    });
                    r[c].y.push(h), a.push(h.y1), s.push(h.y2);
                }, l = 0; l < e[i].data.length; l++)n(l);
                return {
                    start: a,
                    end: s,
                    rangeUniques: r
                };
            }
        },
        {
            key: "handleCandleStickBoxDataFormat",
            value: function(t, e, i) {
                var a = this.w, s = "boxPlot" === a.config.chart.type || "boxPlot" === a.config.series[i].type, r = [], o = [], n = [], l = [], h = [];
                if ("array" === t) {
                    if (s && 6 === e[i].data[0].length || !s && 5 === e[i].data[0].length) for(var c = 0; c < e[i].data.length; c++)r.push(e[i].data[c][1]), o.push(e[i].data[c][2]), s ? (n.push(e[i].data[c][3]), l.push(e[i].data[c][4]), h.push(e[i].data[c][5])) : (l.push(e[i].data[c][3]), h.push(e[i].data[c][4]));
                    else for(var d = 0; d < e[i].data.length; d++)Array.isArray(e[i].data[d][1]) && (r.push(e[i].data[d][1][0]), o.push(e[i].data[d][1][1]), s ? (n.push(e[i].data[d][1][2]), l.push(e[i].data[d][1][3]), h.push(e[i].data[d][1][4])) : (l.push(e[i].data[d][1][2]), h.push(e[i].data[d][1][3])));
                } else if ("xy" === t) for(var g = 0; g < e[i].data.length; g++)Array.isArray(e[i].data[g].y) && (r.push(e[i].data[g].y[0]), o.push(e[i].data[g].y[1]), s ? (n.push(e[i].data[g].y[2]), l.push(e[i].data[g].y[3]), h.push(e[i].data[g].y[4])) : (l.push(e[i].data[g].y[2]), h.push(e[i].data[g].y[3])));
                return {
                    o: r,
                    h: o,
                    m: n,
                    l: l,
                    c: h
                };
            }
        },
        {
            key: "parseDataAxisCharts",
            value: function(t) {
                var e, i = this, a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.ctx, s = this.w.config, r = this.w.globals, o = new $fffa43d1c55f0813$var$I(a), n = s.labels.length > 0 ? s.labels.slice() : s.xaxis.categories.slice();
                if (r.isRangeBar = "rangeBar" === s.chart.type && r.isBarHorizontal, r.hasXaxisGroups = "category" === s.xaxis.type && s.xaxis.group.groups.length > 0, r.hasXaxisGroups && (r.groups = s.xaxis.group.groups), r.hasSeriesGroups = null === (e = t[0]) || void 0 === e ? void 0 : e.group, r.hasSeriesGroups) {
                    var l = [], h = $fffa43d1c55f0813$var$u(new Set(t.map(function(t) {
                        return t.group;
                    })));
                    t.forEach(function(t, e) {
                        var i = h.indexOf(t.group);
                        l[i] || (l[i] = []), l[i].push(t.name);
                    }), r.seriesGroups = l;
                }
                for(var c = function() {
                    for(var t = 0; t < n.length; t++)if ("string" == typeof n[t]) {
                        if (!o.isValidDate(n[t])) throw new Error("You have provided invalid Date format. Please provide a valid JavaScript Date");
                        i.twoDSeriesX.push(o.parseDate(n[t]));
                    } else i.twoDSeriesX.push(n[t]);
                }, d = 0; d < t.length; d++){
                    if (this.twoDSeries = [], this.twoDSeriesX = [], this.threeDSeries = [], void 0 === t[d].data) return void console.error("It is a possibility that you may have not included 'data' property in series.");
                    if ("rangeBar" !== s.chart.type && "rangeArea" !== s.chart.type && "rangeBar" !== t[d].type && "rangeArea" !== t[d].type || (r.isRangeData = !0, r.isComboCharts ? "rangeBar" !== t[d].type && "rangeArea" !== t[d].type || this.handleRangeData(t, d) : "rangeBar" !== s.chart.type && "rangeArea" !== s.chart.type || this.handleRangeData(t, d)), this.isMultiFormat()) this.isFormat2DArray() ? this.handleFormat2DArray(t, d) : this.isFormatXY() && this.handleFormatXY(t, d), "candlestick" !== s.chart.type && "candlestick" !== t[d].type && "boxPlot" !== s.chart.type && "boxPlot" !== t[d].type || this.handleCandleStickBoxData(t, d), r.series.push(this.twoDSeries), r.labels.push(this.twoDSeriesX), r.seriesX.push(this.twoDSeriesX), r.seriesGoals = this.seriesGoals, d !== this.activeSeriesIndex || this.fallbackToCategory || (r.isXNumeric = !0);
                    else {
                        "datetime" === s.xaxis.type ? (r.isXNumeric = !0, c(), r.seriesX.push(this.twoDSeriesX)) : "numeric" === s.xaxis.type && (r.isXNumeric = !0, n.length > 0 && (this.twoDSeriesX = n, r.seriesX.push(this.twoDSeriesX))), r.labels.push(this.twoDSeriesX);
                        var g = t[d].data.map(function(t) {
                            return $fffa43d1c55f0813$var$x.parseNumber(t);
                        });
                        r.series.push(g);
                    }
                    r.seriesZ.push(this.threeDSeries), void 0 !== t[d].name ? r.seriesNames.push(t[d].name) : r.seriesNames.push("series-" + parseInt(d + 1, 10)), void 0 !== t[d].color ? r.seriesColors.push(t[d].color) : r.seriesColors.push(void 0);
                }
                return this.w;
            }
        },
        {
            key: "parseDataNonAxisCharts",
            value: function(t) {
                var e = this.w.globals, i = this.w.config;
                e.series = t.slice(), e.seriesNames = i.labels.slice();
                for(var a = 0; a < e.series.length; a++)void 0 === e.seriesNames[a] && e.seriesNames.push("series-" + (a + 1));
                return this.w;
            }
        },
        {
            key: "handleExternalLabelsData",
            value: function(t) {
                var e = this.w.config, i = this.w.globals;
                if (e.xaxis.categories.length > 0) i.labels = e.xaxis.categories;
                else if (e.labels.length > 0) i.labels = e.labels.slice();
                else if (this.fallbackToCategory) {
                    if (i.labels = i.labels[0], i.seriesRange.length && (i.seriesRange.map(function(t) {
                        t.forEach(function(t) {
                            i.labels.indexOf(t.x) < 0 && t.x && i.labels.push(t.x);
                        });
                    }), i.labels = Array.from(new Set(i.labels.map(JSON.stringify)), JSON.parse)), e.xaxis.convertedCatToNumeric) new $fffa43d1c55f0813$var$X(e).convertCatToNumericXaxis(e, this.ctx, i.seriesX[0]), this._generateExternalLabels(t);
                } else this._generateExternalLabels(t);
            }
        },
        {
            key: "_generateExternalLabels",
            value: function(t) {
                var e = this.w.globals, i = this.w.config, a = [];
                if (e.axisCharts) {
                    if (e.series.length > 0) {
                        if (this.isFormatXY()) for(var s = i.series.map(function(t, e) {
                            return t.data.filter(function(t, e, i) {
                                return i.findIndex(function(e) {
                                    return e.x === t.x;
                                }) === e;
                            });
                        }), r = s.reduce(function(t, e, i, a) {
                            return a[t].length > e.length ? t : i;
                        }, 0), o = 0; o < s[r].length; o++)a.push(o + 1);
                        else for(var n = 0; n < e.series[e.maxValsInArrayIndex].length; n++)a.push(n + 1);
                    }
                    e.seriesX = [];
                    for(var l = 0; l < t.length; l++)e.seriesX.push(a);
                    this.w.globals.isBarHorizontal || (e.isXNumeric = !0);
                }
                if (0 === a.length) {
                    a = e.axisCharts ? [] : e.series.map(function(t, e) {
                        return e + 1;
                    });
                    for(var h = 0; h < t.length; h++)e.seriesX.push(a);
                }
                e.labels = a, i.xaxis.convertedCatToNumeric && (e.categoryLabels = a.map(function(t) {
                    return i.xaxis.labels.formatter(t);
                })), e.noLabelsProvided = !0;
            }
        },
        {
            key: "parseData",
            value: function(t) {
                var e = this.w, i = e.config, a = e.globals;
                if (this.excludeCollapsedSeriesInYAxis(), this.fallbackToCategory = !1, this.ctx.core.resetGlobals(), this.ctx.core.isMultipleY(), a.axisCharts ? (this.parseDataAxisCharts(t), this.coreUtils.getLargestSeries()) : this.parseDataNonAxisCharts(t), i.chart.stacked) {
                    var s = new $fffa43d1c55f0813$var$N(this.ctx);
                    a.series = s.setNullSeriesToZeroValues(a.series);
                }
                this.coreUtils.getSeriesTotals(), a.axisCharts && (a.stackedSeriesTotals = this.coreUtils.getStackedSeriesTotals(), a.stackedSeriesTotalsByGroups = this.coreUtils.getStackedSeriesTotalsByGroups()), this.coreUtils.getPercentSeries(), a.dataFormatXNumeric || a.isXNumeric && ("numeric" !== i.xaxis.type || 0 !== i.labels.length || 0 !== i.xaxis.categories.length) || this.handleExternalLabelsData(t);
                for(var r = this.coreUtils.getCategoryLabels(a.labels), o = 0; o < r.length; o++)if (Array.isArray(r[o])) {
                    a.isMultiLineX = !0;
                    break;
                }
            }
        },
        {
            key: "excludeCollapsedSeriesInYAxis",
            value: function() {
                var t = this, e = this.w;
                e.globals.ignoreYAxisIndexes = e.globals.collapsedSeries.map(function(i, a) {
                    if (t.w.globals.isMultipleYAxis && !e.config.chart.stacked) return i.index;
                });
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$B = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "getLabel",
            value: function(t, e, i, a) {
                var s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : [], r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : "12px", o = !(arguments.length > 6 && void 0 !== arguments[6]) || arguments[6], n = this.w, l = void 0 === t[a] ? "" : t[a], h = l, c = n.globals.xLabelFormatter, d = n.config.xaxis.labels.formatter, g = !1, u = new $fffa43d1c55f0813$var$T(this.ctx), p = l;
                o && (h = u.xLabelFormat(c, l, p, {
                    i: a,
                    dateFormatter: new $fffa43d1c55f0813$var$I(this.ctx).formatDate,
                    w: n
                }), void 0 !== d && (h = d(l, t[a], {
                    i: a,
                    dateFormatter: new $fffa43d1c55f0813$var$I(this.ctx).formatDate,
                    w: n
                })));
                var f, x;
                e.length > 0 ? (f = e[a].unit, x = null, e.forEach(function(t) {
                    "month" === t.unit ? x = "year" : "day" === t.unit ? x = "month" : "hour" === t.unit ? x = "day" : "minute" === t.unit && (x = "hour");
                }), g = x === f, i = e[a].position, h = e[a].value) : "datetime" === n.config.xaxis.type && void 0 === d && (h = ""), void 0 === h && (h = ""), h = Array.isArray(h) ? h : h.toString();
                var b = new $fffa43d1c55f0813$var$m(this.ctx), v = {};
                v = n.globals.rotateXLabels && o ? b.getTextRects(h, parseInt(r, 10), null, "rotate(".concat(n.config.xaxis.labels.rotate, " 0 0)"), !1) : b.getTextRects(h, parseInt(r, 10));
                var y = !n.config.xaxis.labels.showDuplicates && this.ctx.timeScale;
                return !Array.isArray(h) && (0 === h.indexOf("NaN") || 0 === h.toLowerCase().indexOf("invalid") || h.toLowerCase().indexOf("infinity") >= 0 || s.indexOf(h) >= 0 && y) && (h = ""), {
                    x: i,
                    text: h,
                    textRect: v,
                    isBold: g
                };
            }
        },
        {
            key: "checkLabelBasedOnTickamount",
            value: function(t, e, i) {
                var a = this.w, s = a.config.xaxis.tickAmount;
                return "dataPoints" === s && (s = Math.round(a.globals.gridWidth / 120)), s > i || t % Math.round(i / (s + 1)) == 0 || (e.text = ""), e;
            }
        },
        {
            key: "checkForOverflowingLabels",
            value: function(t, e, i, a, s) {
                var r = this.w;
                if (0 === t && r.globals.skipFirstTimelinelabel && (e.text = ""), t === i - 1 && r.globals.skipLastTimelinelabel && (e.text = ""), r.config.xaxis.labels.hideOverlappingLabels && a.length > 0) {
                    var o = s[s.length - 1];
                    e.x < o.textRect.width / (r.globals.rotateXLabels ? Math.abs(r.config.xaxis.labels.rotate) / 12 : 1.01) + o.x && (e.text = "");
                }
                return e;
            }
        },
        {
            key: "checkForReversedLabels",
            value: function(t, e) {
                var i = this.w;
                return i.config.yaxis[t] && i.config.yaxis[t].reversed && e.reverse(), e;
            }
        },
        {
            key: "isYAxisHidden",
            value: function(t) {
                var e = this.w, i = new $fffa43d1c55f0813$var$y(this.ctx);
                return !e.config.yaxis[t].show || !e.config.yaxis[t].showForNullSeries && i.isSeriesNull(t) && -1 === e.globals.collapsedSeriesIndices.indexOf(t);
            }
        },
        {
            key: "getYAxisForeColor",
            value: function(t, e) {
                var i = this.w;
                return Array.isArray(t) && i.globals.yAxisScale[e] && this.ctx.theme.pushExtraColors(t, i.globals.yAxisScale[e].result.length, !1), t;
            }
        },
        {
            key: "drawYAxisTicks",
            value: function(t, e, i, a, s, r, o) {
                var n = this.w, l = new $fffa43d1c55f0813$var$m(this.ctx), h = n.globals.translateY;
                if (a.show && e > 0) {
                    !0 === n.config.yaxis[s].opposite && (t += a.width);
                    for(var c = e; c >= 0; c--){
                        var d = h + e / 10 + n.config.yaxis[s].labels.offsetY - 1;
                        n.globals.isBarHorizontal && (d = r * c), "heatmap" === n.config.chart.type && (d += r / 2);
                        var g = l.drawLine(t + i.offsetX - a.width + a.offsetX, d + a.offsetY, t + i.offsetX + a.offsetX, d + a.offsetY, a.color);
                        o.add(g), h += r;
                    }
                }
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$G = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "scaleSvgNode",
            value: function(t, e) {
                var i = parseFloat(t.getAttributeNS(null, "width")), a = parseFloat(t.getAttributeNS(null, "height"));
                t.setAttributeNS(null, "width", i * e), t.setAttributeNS(null, "height", a * e), t.setAttributeNS(null, "viewBox", "0 0 " + i + " " + a);
            }
        },
        {
            key: "fixSvgStringForIe11",
            value: function(t) {
                if (!$fffa43d1c55f0813$var$x.isIE11()) return t.replace(/&nbsp;/g, "&#160;");
                var e = 0, i = t.replace(/xmlns="http:\/\/www.w3.org\/2000\/svg"/g, function(t) {
                    return 2 === ++e ? 'xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.dev"' : t;
                });
                return i = (i = i.replace(/xmlns:NS\d+=""/g, "")).replace(/NS\d+:(\w+:\w+=")/g, "$1");
            }
        },
        {
            key: "getSvgString",
            value: function(t) {
                null == t && (t = 1);
                var e = this.w.globals.dom.Paper.svg();
                if (1 !== t) {
                    var i = this.w.globals.dom.Paper.node.cloneNode(!0);
                    this.scaleSvgNode(i, t), e = (new XMLSerializer).serializeToString(i);
                }
                return this.fixSvgStringForIe11(e);
            }
        },
        {
            key: "cleanup",
            value: function() {
                var t = this.w, e = t.globals.dom.baseEl.getElementsByClassName("apexcharts-xcrosshairs"), i = t.globals.dom.baseEl.getElementsByClassName("apexcharts-ycrosshairs"), a = t.globals.dom.baseEl.querySelectorAll(".apexcharts-zoom-rect, .apexcharts-selection-rect");
                Array.prototype.forEach.call(a, function(t) {
                    t.setAttribute("width", 0);
                }), e && e[0] && (e[0].setAttribute("x", -500), e[0].setAttribute("x1", -500), e[0].setAttribute("x2", -500)), i && i[0] && (i[0].setAttribute("y", -100), i[0].setAttribute("y1", -100), i[0].setAttribute("y2", -100));
            }
        },
        {
            key: "svgUrl",
            value: function() {
                this.cleanup();
                var t = this.getSvgString(), e = new Blob([
                    t
                ], {
                    type: "image/svg+xml;charset=utf-8"
                });
                return URL.createObjectURL(e);
            }
        },
        {
            key: "dataURI",
            value: function(t) {
                var e = this;
                return new Promise(function(i) {
                    var a = e.w, s = t ? t.scale || t.width / a.globals.svgWidth : 1;
                    e.cleanup();
                    var r = document.createElement("canvas");
                    r.width = a.globals.svgWidth * s, r.height = parseInt(a.globals.dom.elWrap.style.height, 10) * s;
                    var o = "transparent" === a.config.chart.background ? "#fff" : a.config.chart.background, n = r.getContext("2d");
                    n.fillStyle = o, n.fillRect(0, 0, r.width * s, r.height * s);
                    var l = e.getSvgString(s);
                    if (window.canvg && $fffa43d1c55f0813$var$x.isIE11()) {
                        var h = window.canvg.Canvg.fromString(n, l, {
                            ignoreClear: !0,
                            ignoreDimensions: !0
                        });
                        h.start();
                        var c = r.msToBlob();
                        h.stop(), i({
                            blob: c
                        });
                    } else {
                        var d = "data:image/svg+xml," + encodeURIComponent(l), g = new Image;
                        g.crossOrigin = "anonymous", g.onload = function() {
                            if (n.drawImage(g, 0, 0), r.msToBlob) {
                                var t = r.msToBlob();
                                i({
                                    blob: t
                                });
                            } else {
                                var e = r.toDataURL("image/png");
                                i({
                                    imgURI: e
                                });
                            }
                        }, g.src = d;
                    }
                });
            }
        },
        {
            key: "exportToSVG",
            value: function() {
                this.triggerDownload(this.svgUrl(), this.w.config.chart.toolbar.export.svg.filename, ".svg");
            }
        },
        {
            key: "exportToPng",
            value: function() {
                var t = this;
                this.dataURI().then(function(e) {
                    var i = e.imgURI, a = e.blob;
                    a ? navigator.msSaveOrOpenBlob(a, t.w.globals.chartID + ".png") : t.triggerDownload(i, t.w.config.chart.toolbar.export.png.filename, ".png");
                });
            }
        },
        {
            key: "exportToCSV",
            value: function(t) {
                var e = this, i = t.series, a = t.fileName, s = t.columnDelimiter, r = void 0 === s ? "," : s, o = t.lineDelimiter, n = void 0 === o ? "\n" : o, l = this.w;
                i || (i = l.config.series);
                var h, c, d = [], g = [], p = "", f = l.globals.series.map(function(t, e) {
                    return -1 === l.globals.collapsedSeriesIndices.indexOf(e) ? t : [];
                }), b = function(t) {
                    return "datetime" === l.config.xaxis.type && String(t).length >= 10;
                }, v = Math.max.apply(Math, $fffa43d1c55f0813$var$u(i.map(function(t) {
                    return t.data ? t.data.length : 0;
                }))), m = new $fffa43d1c55f0813$var$W(this.ctx), y = new $fffa43d1c55f0813$var$B(this.ctx), w = function(t) {
                    var i = "";
                    if (l.globals.axisCharts) {
                        if ("category" === l.config.xaxis.type || l.config.xaxis.convertedCatToNumeric) {
                            if (l.globals.isBarHorizontal) {
                                var a = l.globals.yLabelFormatters[0], s = new $fffa43d1c55f0813$var$N(e.ctx).getActiveConfigSeriesIndex();
                                i = a(l.globals.labels[t], {
                                    seriesIndex: s,
                                    dataPointIndex: t,
                                    w: l
                                });
                            } else i = y.getLabel(l.globals.labels, l.globals.timescaleLabels, 0, t).text;
                        }
                        "datetime" === l.config.xaxis.type && (l.config.xaxis.categories.length ? i = l.config.xaxis.categories[t] : l.config.labels.length && (i = l.config.labels[t]));
                    } else i = l.config.labels[t];
                    return Array.isArray(i) && (i = i.join(" ")), $fffa43d1c55f0813$var$x.isNumber(i) ? i : i.split(r).join("");
                }, k = function(t, e) {
                    if (d.length && 0 === e && g.push(d.join(r)), t.data) {
                        t.data = t.data.length && t.data || $fffa43d1c55f0813$var$u(Array(v)).map(function() {
                            return "";
                        });
                        for(var a = 0; a < t.data.length; a++){
                            d = [];
                            var s = w(a);
                            if (s || (m.isFormatXY() ? s = i[e].data[a].x : m.isFormat2DArray() && (s = i[e].data[a] ? i[e].data[a][0] : "")), 0 === e) {
                                d.push(b(s) ? l.config.chart.toolbar.export.csv.dateFormatter(s) : $fffa43d1c55f0813$var$x.isNumber(s) ? s : s.split(r).join(""));
                                for(var o = 0; o < l.globals.series.length; o++){
                                    var n;
                                    if (m.isFormatXY()) d.push(null === (n = i[o].data[a]) || void 0 === n ? void 0 : n.y);
                                    else d.push(f[o][a]);
                                }
                            }
                            ("candlestick" === l.config.chart.type || t.type && "candlestick" === t.type) && (d.pop(), d.push(l.globals.seriesCandleO[e][a]), d.push(l.globals.seriesCandleH[e][a]), d.push(l.globals.seriesCandleL[e][a]), d.push(l.globals.seriesCandleC[e][a])), ("boxPlot" === l.config.chart.type || t.type && "boxPlot" === t.type) && (d.pop(), d.push(l.globals.seriesCandleO[e][a]), d.push(l.globals.seriesCandleH[e][a]), d.push(l.globals.seriesCandleM[e][a]), d.push(l.globals.seriesCandleL[e][a]), d.push(l.globals.seriesCandleC[e][a])), "rangeBar" === l.config.chart.type && (d.pop(), d.push(l.globals.seriesRangeStart[e][a]), d.push(l.globals.seriesRangeEnd[e][a])), d.length && g.push(d.join(r));
                        }
                    }
                };
                d.push(l.config.chart.toolbar.export.csv.headerCategory), "boxPlot" === l.config.chart.type ? (d.push("minimum"), d.push("q1"), d.push("median"), d.push("q3"), d.push("maximum")) : "candlestick" === l.config.chart.type ? (d.push("open"), d.push("high"), d.push("low"), d.push("close")) : "rangeBar" === l.config.chart.type ? (d.push("minimum"), d.push("maximum")) : i.map(function(t, e) {
                    var i = (t.name ? t.name : "series-".concat(e)) + "";
                    l.globals.axisCharts && d.push(i.split(r).join("") ? i.split(r).join("") : "series-".concat(e));
                }), l.globals.axisCharts || (d.push(l.config.chart.toolbar.export.csv.headerValue), g.push(d.join(r))), l.globals.allSeriesHasEqualX || !l.globals.axisCharts || "datetime" !== l.config.xaxis.type || l.config.xaxis.categories.length || l.config.labels.length ? i.map(function(t, e) {
                    l.globals.axisCharts ? k(t, e) : ((d = []).push(l.globals.labels[e].split(r).join("")), d.push(f[e]), g.push(d.join(r)));
                }) : (h = new Set, c = {}, i.forEach(function(t, e) {
                    null == t || t.data.forEach(function(t) {
                        var a, s;
                        if (m.isFormatXY()) a = t.x, s = t.y;
                        else {
                            if (!m.isFormat2DArray()) return;
                            a = t[0], s = t[1];
                        }
                        c[a] || (c[a] = Array(i.length).fill("")), c[a][e] = s, h.add(a);
                    });
                }), d.length && g.push(d.join(r)), Array.from(h).sort().forEach(function(t) {
                    g.push([
                        b(t) ? l.config.chart.toolbar.export.csv.dateFormatter(t) : $fffa43d1c55f0813$var$x.isNumber(t) ? t : t.split(r).join(""),
                        c[t].join(r)
                    ]);
                })), p += g.join(n), this.triggerDownload("data:text/csv; charset=utf-8," + encodeURIComponent("\ufeff" + p), a || l.config.chart.toolbar.export.csv.filename, ".csv");
            }
        },
        {
            key: "triggerDownload",
            value: function(t, e, i) {
                var a = document.createElement("a");
                a.href = t, a.download = (e || this.w.globals.chartID) + i, document.body.appendChild(a), a.click(), document.body.removeChild(a);
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$V = function() {
    function t(e, i) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.elgrid = i, this.w = e.w;
        var s = this.w;
        this.axesUtils = new $fffa43d1c55f0813$var$B(e), this.xaxisLabels = s.globals.labels.slice(), s.globals.timescaleLabels.length > 0 && !s.globals.isBarHorizontal && (this.xaxisLabels = s.globals.timescaleLabels.slice()), s.config.xaxis.overwriteCategories && (this.xaxisLabels = s.config.xaxis.overwriteCategories), this.drawnLabels = [], this.drawnLabelsRects = [], "top" === s.config.xaxis.position ? this.offY = 0 : this.offY = s.globals.gridHeight + 1, this.offY = this.offY + s.config.xaxis.axisBorder.offsetY, this.isCategoryBarHorizontal = "bar" === s.config.chart.type && s.config.plotOptions.bar.horizontal, this.xaxisFontSize = s.config.xaxis.labels.style.fontSize, this.xaxisFontFamily = s.config.xaxis.labels.style.fontFamily, this.xaxisForeColors = s.config.xaxis.labels.style.colors, this.xaxisBorderWidth = s.config.xaxis.axisBorder.width, this.isCategoryBarHorizontal && (this.xaxisBorderWidth = s.config.yaxis[0].axisBorder.width.toString()), this.xaxisBorderWidth.indexOf("%") > -1 ? this.xaxisBorderWidth = s.globals.gridWidth * parseInt(this.xaxisBorderWidth, 10) / 100 : this.xaxisBorderWidth = parseInt(this.xaxisBorderWidth, 10), this.xaxisBorderHeight = s.config.xaxis.axisBorder.height, this.yaxis = s.config.yaxis[0];
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "drawXaxis",
            value: function() {
                var t = this.w, e = new $fffa43d1c55f0813$var$m(this.ctx), i = e.group({
                    class: "apexcharts-xaxis",
                    transform: "translate(".concat(t.config.xaxis.offsetX, ", ").concat(t.config.xaxis.offsetY, ")")
                }), a = e.group({
                    class: "apexcharts-xaxis-texts-g",
                    transform: "translate(".concat(t.globals.translateXAxisX, ", ").concat(t.globals.translateXAxisY, ")")
                });
                i.add(a);
                for(var s = [], r = 0; r < this.xaxisLabels.length; r++)s.push(this.xaxisLabels[r]);
                if (this.drawXAxisLabelAndGroup(!0, e, a, s, t.globals.isXNumeric, function(t, e) {
                    return e;
                }), t.globals.hasXaxisGroups) {
                    var o = t.globals.groups;
                    s = [];
                    for(var n = 0; n < o.length; n++)s.push(o[n].title);
                    var l = {};
                    t.config.xaxis.group.style && (l.xaxisFontSize = t.config.xaxis.group.style.fontSize, l.xaxisFontFamily = t.config.xaxis.group.style.fontFamily, l.xaxisForeColors = t.config.xaxis.group.style.colors, l.fontWeight = t.config.xaxis.group.style.fontWeight, l.cssClass = t.config.xaxis.group.style.cssClass), this.drawXAxisLabelAndGroup(!1, e, a, s, !1, function(t, e) {
                        return o[t].cols * e;
                    }, l);
                }
                if (void 0 !== t.config.xaxis.title.text) {
                    var h = e.group({
                        class: "apexcharts-xaxis-title"
                    }), c = e.drawText({
                        x: t.globals.gridWidth / 2 + t.config.xaxis.title.offsetX,
                        y: this.offY + parseFloat(this.xaxisFontSize) + ("bottom" === t.config.xaxis.position ? t.globals.xAxisLabelsHeight : -t.globals.xAxisLabelsHeight - 10) + t.config.xaxis.title.offsetY,
                        text: t.config.xaxis.title.text,
                        textAnchor: "middle",
                        fontSize: t.config.xaxis.title.style.fontSize,
                        fontFamily: t.config.xaxis.title.style.fontFamily,
                        fontWeight: t.config.xaxis.title.style.fontWeight,
                        foreColor: t.config.xaxis.title.style.color,
                        cssClass: "apexcharts-xaxis-title-text " + t.config.xaxis.title.style.cssClass
                    });
                    h.add(c), i.add(h);
                }
                if (t.config.xaxis.axisBorder.show) {
                    var d = t.globals.barPadForNumericAxis, g = e.drawLine(t.globals.padHorizontal + t.config.xaxis.axisBorder.offsetX - d, this.offY, this.xaxisBorderWidth + d, this.offY, t.config.xaxis.axisBorder.color, 0, this.xaxisBorderHeight);
                    this.elgrid && this.elgrid.elGridBorders && t.config.grid.show ? this.elgrid.elGridBorders.add(g) : i.add(g);
                }
                return i;
            }
        },
        {
            key: "drawXAxisLabelAndGroup",
            value: function(t, e, i, a, s, r) {
                var o, n = this, l = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : {}, h = [], c = [], d = this.w, g = l.xaxisFontSize || this.xaxisFontSize, u = l.xaxisFontFamily || this.xaxisFontFamily, p = l.xaxisForeColors || this.xaxisForeColors, f = l.fontWeight || d.config.xaxis.labels.style.fontWeight, x = l.cssClass || d.config.xaxis.labels.style.cssClass, b = d.globals.padHorizontal, v = a.length, m = "category" === d.config.xaxis.type ? d.globals.dataPoints : v;
                if (0 === m && v > m && (m = v), s) {
                    var y = m > 1 ? m - 1 : m;
                    o = d.globals.gridWidth / Math.min(y, v - 1), b = b + r(0, o) / 2 + d.config.xaxis.labels.offsetX;
                } else o = d.globals.gridWidth / m, b = b + r(0, o) + d.config.xaxis.labels.offsetX;
                for(var w = function(s) {
                    var l = b - r(s, o) / 2 + d.config.xaxis.labels.offsetX;
                    0 === s && 1 === v && o / 2 === b && 1 === m && (l = d.globals.gridWidth / 2);
                    var y = n.axesUtils.getLabel(a, d.globals.timescaleLabels, l, s, h, g, t), w = 28;
                    d.globals.rotateXLabels && t && (w = 22), d.config.xaxis.title.text && "top" === d.config.xaxis.position && (w += parseFloat(d.config.xaxis.title.style.fontSize) + 2), t || (w = w + parseFloat(g) + (d.globals.xAxisLabelsHeight - d.globals.xAxisGroupLabelsHeight) + (d.globals.rotateXLabels ? 10 : 0)), y = void 0 !== d.config.xaxis.tickAmount && "dataPoints" !== d.config.xaxis.tickAmount && "datetime" !== d.config.xaxis.type ? n.axesUtils.checkLabelBasedOnTickamount(s, y, v) : n.axesUtils.checkForOverflowingLabels(s, y, v, h, c);
                    if (d.config.xaxis.labels.show) {
                        var k = e.drawText({
                            x: y.x,
                            y: n.offY + d.config.xaxis.labels.offsetY + w - ("top" === d.config.xaxis.position ? d.globals.xAxisHeight + d.config.xaxis.axisTicks.height - 2 : 0),
                            text: y.text,
                            textAnchor: "middle",
                            fontWeight: y.isBold ? 600 : f,
                            fontSize: g,
                            fontFamily: u,
                            foreColor: Array.isArray(p) ? t && d.config.xaxis.convertedCatToNumeric ? p[d.globals.minX + s - 1] : p[s] : p,
                            isPlainText: !1,
                            cssClass: (t ? "apexcharts-xaxis-label " : "apexcharts-xaxis-group-label ") + x
                        });
                        if (i.add(k), k.on("click", function(t) {
                            if ("function" == typeof d.config.chart.events.xAxisLabelClick) {
                                var e = Object.assign({}, d, {
                                    labelIndex: s
                                });
                                d.config.chart.events.xAxisLabelClick(t, n.ctx, e);
                            }
                        }), t) {
                            var A = document.createElementNS(d.globals.SVGNS, "title");
                            A.textContent = Array.isArray(y.text) ? y.text.join(" ") : y.text, k.node.appendChild(A), "" !== y.text && (h.push(y.text), c.push(y));
                        }
                    }
                    s < v - 1 && (b += r(s + 1, o));
                }, k = 0; k <= v - 1; k++)w(k);
            }
        },
        {
            key: "drawXaxisInversed",
            value: function(t) {
                var e, i, a = this, s = this.w, r = new $fffa43d1c55f0813$var$m(this.ctx), o = s.config.yaxis[0].opposite ? s.globals.translateYAxisX[t] : 0, n = r.group({
                    class: "apexcharts-yaxis apexcharts-xaxis-inversed",
                    rel: t
                }), l = r.group({
                    class: "apexcharts-yaxis-texts-g apexcharts-xaxis-inversed-texts-g",
                    transform: "translate(" + o + ", 0)"
                });
                n.add(l);
                var h = [];
                if (s.config.yaxis[t].show) for(var c = 0; c < this.xaxisLabels.length; c++)h.push(this.xaxisLabels[c]);
                e = s.globals.gridHeight / h.length, i = -e / 2.2;
                var d = s.globals.yLabelFormatters[0], g = s.config.yaxis[0].labels;
                if (g.show) for(var u = function(o) {
                    var n = void 0 === h[o] ? "" : h[o];
                    n = d(n, {
                        seriesIndex: t,
                        dataPointIndex: o,
                        w: s
                    });
                    var c = a.axesUtils.getYAxisForeColor(g.style.colors, t), u = 0;
                    Array.isArray(n) && (u = n.length / 2 * parseInt(g.style.fontSize, 10));
                    var p = g.offsetX - 15, f = "end";
                    a.yaxis.opposite && (f = "start"), "left" === s.config.yaxis[0].labels.align ? (p = g.offsetX, f = "start") : "center" === s.config.yaxis[0].labels.align ? (p = g.offsetX, f = "middle") : "right" === s.config.yaxis[0].labels.align && (f = "end");
                    var x = r.drawText({
                        x: p,
                        y: i + e + g.offsetY - u,
                        text: n,
                        textAnchor: f,
                        foreColor: Array.isArray(c) ? c[o] : c,
                        fontSize: g.style.fontSize,
                        fontFamily: g.style.fontFamily,
                        fontWeight: g.style.fontWeight,
                        isPlainText: !1,
                        cssClass: "apexcharts-yaxis-label " + g.style.cssClass,
                        maxWidth: g.maxWidth
                    });
                    l.add(x), x.on("click", function(t) {
                        if ("function" == typeof s.config.chart.events.xAxisLabelClick) {
                            var e = Object.assign({}, s, {
                                labelIndex: o
                            });
                            s.config.chart.events.xAxisLabelClick(t, a.ctx, e);
                        }
                    });
                    var b = document.createElementNS(s.globals.SVGNS, "title");
                    if (b.textContent = Array.isArray(n) ? n.join(" ") : n, x.node.appendChild(b), 0 !== s.config.yaxis[t].labels.rotate) {
                        var v = r.rotateAroundCenter(x.node);
                        x.node.setAttribute("transform", "rotate(".concat(s.config.yaxis[t].labels.rotate, " 0 ").concat(v.y, ")"));
                    }
                    i += e;
                }, p = 0; p <= h.length - 1; p++)u(p);
                if (void 0 !== s.config.yaxis[0].title.text) {
                    var f = r.group({
                        class: "apexcharts-yaxis-title apexcharts-xaxis-title-inversed",
                        transform: "translate(" + o + ", 0)"
                    }), x = r.drawText({
                        x: s.config.yaxis[0].title.offsetX,
                        y: s.globals.gridHeight / 2 + s.config.yaxis[0].title.offsetY,
                        text: s.config.yaxis[0].title.text,
                        textAnchor: "middle",
                        foreColor: s.config.yaxis[0].title.style.color,
                        fontSize: s.config.yaxis[0].title.style.fontSize,
                        fontWeight: s.config.yaxis[0].title.style.fontWeight,
                        fontFamily: s.config.yaxis[0].title.style.fontFamily,
                        cssClass: "apexcharts-yaxis-title-text " + s.config.yaxis[0].title.style.cssClass
                    });
                    f.add(x), n.add(f);
                }
                var b = 0;
                this.isCategoryBarHorizontal && s.config.yaxis[0].opposite && (b = s.globals.gridWidth);
                var v = s.config.xaxis.axisBorder;
                if (v.show) {
                    var y = r.drawLine(s.globals.padHorizontal + v.offsetX + b, 1 + v.offsetY, s.globals.padHorizontal + v.offsetX + b, s.globals.gridHeight + v.offsetY, v.color, 0);
                    this.elgrid && this.elgrid.elGridBorders && s.config.grid.show ? this.elgrid.elGridBorders.add(y) : n.add(y);
                }
                return s.config.yaxis[0].axisTicks.show && this.axesUtils.drawYAxisTicks(b, h.length, s.config.yaxis[0].axisBorder, s.config.yaxis[0].axisTicks, 0, e, n), n;
            }
        },
        {
            key: "drawXaxisTicks",
            value: function(t, e, i) {
                var a = this.w, s = t;
                if (!(t < 0 || t - 2 > a.globals.gridWidth)) {
                    var r = this.offY + a.config.xaxis.axisTicks.offsetY;
                    if (e = e + r + a.config.xaxis.axisTicks.height, "top" === a.config.xaxis.position && (e = r - a.config.xaxis.axisTicks.height), a.config.xaxis.axisTicks.show) {
                        var o = new $fffa43d1c55f0813$var$m(this.ctx).drawLine(t + a.config.xaxis.axisTicks.offsetX, r + a.config.xaxis.offsetY, s + a.config.xaxis.axisTicks.offsetX, e + a.config.xaxis.offsetY, a.config.xaxis.axisTicks.color);
                        i.add(o), o.node.classList.add("apexcharts-xaxis-tick");
                    }
                }
            }
        },
        {
            key: "getXAxisTicksPositions",
            value: function() {
                var t = this.w, e = [], i = this.xaxisLabels.length, a = t.globals.padHorizontal;
                if (t.globals.timescaleLabels.length > 0) for(var s = 0; s < i; s++)a = this.xaxisLabels[s].position, e.push(a);
                else for(var r = i, o = 0; o < r; o++){
                    var n = r;
                    t.globals.isXNumeric && "bar" !== t.config.chart.type && (n -= 1), a += t.globals.gridWidth / n, e.push(a);
                }
                return e;
            }
        },
        {
            key: "xAxisLabelCorrections",
            value: function() {
                var t = this.w, e = new $fffa43d1c55f0813$var$m(this.ctx), i = t.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g"), a = t.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-texts-g text:not(.apexcharts-xaxis-group-label)"), s = t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-inversed text"), r = t.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-inversed-texts-g text tspan");
                if (t.globals.rotateXLabels || t.config.xaxis.labels.rotateAlways) for(var o = 0; o < a.length; o++){
                    var n = e.rotateAroundCenter(a[o]);
                    n.y = n.y - 1, n.x = n.x + 1, a[o].setAttribute("transform", "rotate(".concat(t.config.xaxis.labels.rotate, " ").concat(n.x, " ").concat(n.y, ")")), a[o].setAttribute("text-anchor", "end");
                    i.setAttribute("transform", "translate(0, ".concat(-10, ")"));
                    var l = a[o].childNodes;
                    t.config.xaxis.labels.trim && Array.prototype.forEach.call(l, function(i) {
                        e.placeTextWithEllipsis(i, i.textContent, t.globals.xAxisLabelsHeight - ("bottom" === t.config.legend.position ? 20 : 10));
                    });
                }
                else !function() {
                    for(var i = t.globals.gridWidth / (t.globals.labels.length + 1), s = 0; s < a.length; s++){
                        var r = a[s].childNodes;
                        t.config.xaxis.labels.trim && "datetime" !== t.config.xaxis.type && Array.prototype.forEach.call(r, function(t) {
                            e.placeTextWithEllipsis(t, t.textContent, i);
                        });
                    }
                }();
                if (s.length > 0) {
                    var h = s[s.length - 1].getBBox(), c = s[0].getBBox();
                    h.x < -20 && s[s.length - 1].parentNode.removeChild(s[s.length - 1]), c.x + c.width > t.globals.gridWidth && !t.globals.isBarHorizontal && s[0].parentNode.removeChild(s[0]);
                    for(var d = 0; d < r.length; d++)e.placeTextWithEllipsis(r[d], r[d].textContent, t.config.yaxis[0].labels.maxWidth - (t.config.yaxis[0].title.text ? 2 * parseFloat(t.config.yaxis[0].title.style.fontSize) : 0) - 15);
                }
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$j = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w;
        var i = this.w;
        this.xaxisLabels = i.globals.labels.slice(), this.axesUtils = new $fffa43d1c55f0813$var$B(e), this.isRangeBar = i.globals.seriesRange.length && i.globals.isBarHorizontal, i.globals.timescaleLabels.length > 0 && (this.xaxisLabels = i.globals.timescaleLabels.slice());
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "drawGridArea",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, e = this.w, i = new $fffa43d1c55f0813$var$m(this.ctx);
                null === t && (t = i.group({
                    class: "apexcharts-grid"
                }));
                var a = i.drawLine(e.globals.padHorizontal, 1, e.globals.padHorizontal, e.globals.gridHeight, "transparent"), s = i.drawLine(e.globals.padHorizontal, e.globals.gridHeight, e.globals.gridWidth, e.globals.gridHeight, "transparent");
                return t.add(s), t.add(a), t;
            }
        },
        {
            key: "drawGrid",
            value: function() {
                var t = null;
                return this.w.globals.axisCharts && (t = this.renderGrid(), this.drawGridArea(t.el)), t;
            }
        },
        {
            key: "createGridMask",
            value: function() {
                var t = this.w, e = t.globals, i = new $fffa43d1c55f0813$var$m(this.ctx), a = Array.isArray(t.config.stroke.width) ? 0 : t.config.stroke.width;
                if (Array.isArray(t.config.stroke.width)) {
                    var s = 0;
                    t.config.stroke.width.forEach(function(t) {
                        s = Math.max(s, t);
                    }), a = s;
                }
                e.dom.elGridRectMask = document.createElementNS(e.SVGNS, "clipPath"), e.dom.elGridRectMask.setAttribute("id", "gridRectMask".concat(e.cuid)), e.dom.elGridRectMarkerMask = document.createElementNS(e.SVGNS, "clipPath"), e.dom.elGridRectMarkerMask.setAttribute("id", "gridRectMarkerMask".concat(e.cuid)), e.dom.elForecastMask = document.createElementNS(e.SVGNS, "clipPath"), e.dom.elForecastMask.setAttribute("id", "forecastMask".concat(e.cuid)), e.dom.elNonForecastMask = document.createElementNS(e.SVGNS, "clipPath"), e.dom.elNonForecastMask.setAttribute("id", "nonForecastMask".concat(e.cuid));
                var r = t.config.chart.type, o = 0, n = 0;
                ("bar" === r || "rangeBar" === r || "candlestick" === r || "boxPlot" === r || t.globals.comboBarCount > 0) && t.globals.isXNumeric && !t.globals.isBarHorizontal && (o = t.config.grid.padding.left, n = t.config.grid.padding.right, e.barPadForNumericAxis > o && (o = e.barPadForNumericAxis, n = e.barPadForNumericAxis)), e.dom.elGridRect = i.drawRect(-a - o - 2, 2 * -a - 2, e.gridWidth + a + n + o + 4, e.gridHeight + 4 * a + 4, 0, "#fff");
                var l = t.globals.markers.largestSize + 1;
                e.dom.elGridRectMarker = i.drawRect(2 * -l, 2 * -l, e.gridWidth + 4 * l, e.gridHeight + 4 * l, 0, "#fff"), e.dom.elGridRectMask.appendChild(e.dom.elGridRect.node), e.dom.elGridRectMarkerMask.appendChild(e.dom.elGridRectMarker.node);
                var h = e.dom.baseEl.querySelector("defs");
                h.appendChild(e.dom.elGridRectMask), h.appendChild(e.dom.elForecastMask), h.appendChild(e.dom.elNonForecastMask), h.appendChild(e.dom.elGridRectMarkerMask);
            }
        },
        {
            key: "_drawGridLines",
            value: function(t) {
                var e = t.i, i = t.x1, a = t.y1, s = t.x2, r = t.y2, o = t.xCount, n = t.parent, l = this.w;
                if (!(0 === e && l.globals.skipFirstTimelinelabel || e === o - 1 && l.globals.skipLastTimelinelabel && !l.config.xaxis.labels.formatter || "radar" === l.config.chart.type)) {
                    l.config.grid.xaxis.lines.show && this._drawGridLine({
                        i: e,
                        x1: i,
                        y1: a,
                        x2: s,
                        y2: r,
                        xCount: o,
                        parent: n
                    });
                    var h = 0;
                    if (l.globals.hasXaxisGroups && "between" === l.config.xaxis.tickPlacement) {
                        var c = l.globals.groups;
                        if (c) {
                            for(var d = 0, g = 0; d < e && g < c.length; g++)d += c[g].cols;
                            d === e && (h = .6 * l.globals.xAxisLabelsHeight);
                        }
                    }
                    new $fffa43d1c55f0813$var$V(this.ctx).drawXaxisTicks(i, h, l.globals.dom.elGraphical);
                }
            }
        },
        {
            key: "_drawGridLine",
            value: function(t) {
                var e = t.i, i = t.x1, a = t.y1, s = t.x2, r = t.y2, o = t.xCount, n = t.parent, l = this.w, h = !1, c = n.node.classList.contains("apexcharts-gridlines-horizontal"), d = l.config.grid.strokeDashArray, g = l.globals.barPadForNumericAxis;
                (0 === a && 0 === r || 0 === i && 0 === s) && (h = !0), a === l.globals.gridHeight && r === l.globals.gridHeight && (h = !0), !l.globals.isBarHorizontal || 0 !== e && e !== o - 1 || (h = !0);
                var u = new $fffa43d1c55f0813$var$m(this).drawLine(i - (c ? g : 0), a, s + (c ? g : 0), r, l.config.grid.borderColor, d);
                u.node.classList.add("apexcharts-gridline"), h && l.config.grid.show ? this.elGridBorders.add(u) : n.add(u);
            }
        },
        {
            key: "_drawGridBandRect",
            value: function(t) {
                var e = t.c, i = t.x1, a = t.y1, s = t.x2, r = t.y2, o = t.type, n = this.w, l = new $fffa43d1c55f0813$var$m(this.ctx), h = n.globals.barPadForNumericAxis;
                if ("column" !== o || "datetime" !== n.config.xaxis.type) {
                    var c = n.config.grid[o].colors[e], d = l.drawRect(i - ("row" === o ? h : 0), a, s + ("row" === o ? 2 * h : 0), r, 0, c, n.config.grid[o].opacity);
                    this.elg.add(d), d.attr("clip-path", "url(#gridRectMask".concat(n.globals.cuid, ")")), d.node.classList.add("apexcharts-grid-".concat(o));
                }
            }
        },
        {
            key: "_drawXYLines",
            value: function(t) {
                var e = this, i = t.xCount, a = t.tickAmount, s = this.w;
                if (s.config.grid.xaxis.lines.show || s.config.xaxis.axisTicks.show) {
                    var r, o = s.globals.padHorizontal, n = s.globals.gridHeight;
                    s.globals.timescaleLabels.length ? function(t) {
                        for(var a = t.xC, s = t.x1, r = t.y1, o = t.x2, n = t.y2, l = 0; l < a; l++)s = e.xaxisLabels[l].position, o = e.xaxisLabels[l].position, e._drawGridLines({
                            i: l,
                            x1: s,
                            y1: r,
                            x2: o,
                            y2: n,
                            xCount: i,
                            parent: e.elgridLinesV
                        });
                    }({
                        xC: i,
                        x1: o,
                        y1: 0,
                        x2: r,
                        y2: n
                    }) : (s.globals.isXNumeric && (i = s.globals.xAxisScale.result.length), function(t) {
                        for(var a = t.xC, r = t.x1, o = t.y1, n = t.x2, l = t.y2, h = 0; h < a + (s.globals.isXNumeric ? 0 : 1); h++)0 === h && 1 === a && 1 === s.globals.dataPoints && (n = r = s.globals.gridWidth / 2), e._drawGridLines({
                            i: h,
                            x1: r,
                            y1: o,
                            x2: n,
                            y2: l,
                            xCount: i,
                            parent: e.elgridLinesV
                        }), n = r += s.globals.gridWidth / (s.globals.isXNumeric ? a - 1 : a);
                    }({
                        xC: i,
                        x1: o,
                        y1: 0,
                        x2: r,
                        y2: n
                    }));
                }
                if (s.config.grid.yaxis.lines.show) {
                    var l = 0, h = 0, c = s.globals.gridWidth, d = a + 1;
                    this.isRangeBar && (d = s.globals.labels.length);
                    for(var g = 0; g < d + (this.isRangeBar ? 1 : 0); g++)this._drawGridLine({
                        i: g,
                        xCount: d + (this.isRangeBar ? 1 : 0),
                        x1: 0,
                        y1: l,
                        x2: c,
                        y2: h,
                        parent: this.elgridLinesH
                    }), h = l += s.globals.gridHeight / (this.isRangeBar ? d : a);
                }
            }
        },
        {
            key: "_drawInvertedXYLines",
            value: function(t) {
                var e = t.xCount, i = this.w;
                if (i.config.grid.xaxis.lines.show || i.config.xaxis.axisTicks.show) for(var a, s = i.globals.padHorizontal, r = i.globals.gridHeight, o = 0; o < e + 1; o++)i.config.grid.xaxis.lines.show && this._drawGridLine({
                    i: o,
                    xCount: e + 1,
                    x1: s,
                    y1: 0,
                    x2: a,
                    y2: r,
                    parent: this.elgridLinesV
                }), new $fffa43d1c55f0813$var$V(this.ctx).drawXaxisTicks(s, 0, i.globals.dom.elGraphical), a = s = s + i.globals.gridWidth / e + .3;
                if (i.config.grid.yaxis.lines.show) for(var n = 0, l = 0, h = i.globals.gridWidth, c = 0; c < i.globals.dataPoints + 1; c++)this._drawGridLine({
                    i: c,
                    xCount: i.globals.dataPoints + 1,
                    x1: 0,
                    y1: n,
                    x2: h,
                    y2: l,
                    parent: this.elgridLinesH
                }), l = n += i.globals.gridHeight / i.globals.dataPoints;
            }
        },
        {
            key: "renderGrid",
            value: function() {
                var t = this.w, e = new $fffa43d1c55f0813$var$m(this.ctx);
                this.elg = e.group({
                    class: "apexcharts-grid"
                }), this.elgridLinesH = e.group({
                    class: "apexcharts-gridlines-horizontal"
                }), this.elgridLinesV = e.group({
                    class: "apexcharts-gridlines-vertical"
                }), this.elGridBorders = e.group({
                    class: "apexcharts-grid-borders"
                }), this.elg.add(this.elgridLinesH), this.elg.add(this.elgridLinesV), t.config.grid.show || (this.elgridLinesV.hide(), this.elgridLinesH.hide(), this.elGridBorders.hide());
                for(var i, a = t.globals.yAxisScale.length ? t.globals.yAxisScale[0].result.length - 1 : 5, s = 0; s < t.globals.series.length && (void 0 !== t.globals.yAxisScale[s] && (a = t.globals.yAxisScale[s].result.length - 1), !(a > 2)); s++);
                return !t.globals.isBarHorizontal || this.isRangeBar ? (i = this.xaxisLabels.length, this.isRangeBar && (i--, a = t.globals.labels.length, t.config.xaxis.tickAmount && t.config.xaxis.labels.formatter && (i = t.config.xaxis.tickAmount)), this._drawXYLines({
                    xCount: i,
                    tickAmount: a
                })) : (i = a, a = t.globals.xTickAmount, this._drawInvertedXYLines({
                    xCount: i,
                    tickAmount: a
                })), this.drawGridBands(i, a), {
                    el: this.elg,
                    elGridBorders: this.elGridBorders,
                    xAxisTickWidth: t.globals.gridWidth / i
                };
            }
        },
        {
            key: "drawGridBands",
            value: function(t, e) {
                var i = this.w;
                if (void 0 !== i.config.grid.row.colors && i.config.grid.row.colors.length > 0) for(var a = 0, s = i.globals.gridHeight / e, r = i.globals.gridWidth, o = 0, n = 0; o < e; o++, n++)n >= i.config.grid.row.colors.length && (n = 0), this._drawGridBandRect({
                    c: n,
                    x1: 0,
                    y1: a,
                    x2: r,
                    y2: s,
                    type: "row"
                }), a += i.globals.gridHeight / e;
                if (void 0 !== i.config.grid.column.colors && i.config.grid.column.colors.length > 0) for(var l = i.globals.isBarHorizontal || "on" !== i.config.xaxis.tickPlacement || "category" !== i.config.xaxis.type && !i.config.xaxis.convertedCatToNumeric ? t : t - 1, h = i.globals.padHorizontal, c = i.globals.padHorizontal + i.globals.gridWidth / l, d = i.globals.gridHeight, g = 0, u = 0; g < t; g++, u++)u >= i.config.grid.column.colors.length && (u = 0), this._drawGridBandRect({
                    c: u,
                    x1: h,
                    y1: 0,
                    x2: c,
                    y2: d,
                    type: "column"
                }), h += i.globals.gridWidth / l;
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$_ = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "niceScale",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 10, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, s = arguments.length > 4 ? arguments[4] : void 0, r = this.w, o = Math.abs(e - t);
                if ("dataPoints" === (i = this._adjustTicksForSmallRange(i, a, o)) && (i = r.globals.dataPoints - 1), t === Number.MIN_VALUE && 0 === e || !$fffa43d1c55f0813$var$x.isNumber(t) && !$fffa43d1c55f0813$var$x.isNumber(e) || t === Number.MIN_VALUE && e === -Number.MAX_VALUE) return t = 0, e = i, this.linearScale(t, e, i);
                t > e ? (console.warn("axis.min cannot be greater than axis.max"), e = t + .1) : t === e && (t = 0 === t ? 0 : t - .5, e = 0 === e ? 2 : e + .5);
                var n = [];
                o < 1 && s && ("candlestick" === r.config.chart.type || "candlestick" === r.config.series[a].type || "boxPlot" === r.config.chart.type || "boxPlot" === r.config.series[a].type || r.globals.isRangeData) && (e *= 1.01);
                var l = i + 1;
                l < 2 ? l = 2 : l > 2 && (l -= 2);
                var h = o / l, c = Math.floor($fffa43d1c55f0813$var$x.log10(h)), d = Math.pow(10, c), g = Math.round(h / d);
                g < 1 && (g = 1);
                var u = g * d, p = u * Math.floor(t / u), f = u * Math.ceil(e / u), b = p;
                if (s && o > 2) {
                    for(; n.push($fffa43d1c55f0813$var$x.stripNumber(b, 7)), !((b += u) > f););
                    return {
                        result: n,
                        niceMin: n[0],
                        niceMax: n[n.length - 1]
                    };
                }
                var v = t;
                (n = []).push($fffa43d1c55f0813$var$x.stripNumber(v, 7));
                for(var m = Math.abs(e - t) / i, y = 0; y <= i; y++)v += m, n.push(v);
                return n[n.length - 2] >= e && n.pop(), {
                    result: n,
                    niceMin: n[0],
                    niceMax: n[n.length - 1]
                };
            }
        },
        {
            key: "linearScale",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 10, a = arguments.length > 3 ? arguments[3] : void 0, s = Math.abs(e - t);
                "dataPoints" === (i = this._adjustTicksForSmallRange(i, a, s)) && (i = this.w.globals.dataPoints - 1);
                var r = s / i;
                i === Number.MAX_VALUE && (i = 10, r = 1);
                for(var o = [], n = t; i >= 0;)o.push(n), n += r, i -= 1;
                return {
                    result: o,
                    niceMin: o[0],
                    niceMax: o[o.length - 1]
                };
            }
        },
        {
            key: "logarithmicScaleNice",
            value: function(t, e, i) {
                e <= 0 && (e = Math.max(t, i)), t <= 0 && (t = Math.min(e, i));
                for(var a = [], s = Math.ceil(Math.log(e) / Math.log(i) + 1), r = Math.floor(Math.log(t) / Math.log(i)); r < s; r++)a.push(Math.pow(i, r));
                return {
                    result: a,
                    niceMin: a[0],
                    niceMax: a[a.length - 1]
                };
            }
        },
        {
            key: "logarithmicScale",
            value: function(t, e, i) {
                e <= 0 && (e = Math.max(t, i)), t <= 0 && (t = Math.min(e, i));
                for(var a = [], s = Math.log(e) / Math.log(i), r = Math.log(t) / Math.log(i), o = s - r, n = Math.round(o), l = o / n, h = 0, c = r; h < n; h++, c += l)a.push(Math.pow(i, c));
                return a.push(Math.pow(i, s)), {
                    result: a,
                    niceMin: t,
                    niceMax: e
                };
            }
        },
        {
            key: "_adjustTicksForSmallRange",
            value: function(t, e, i) {
                var a = t;
                if (void 0 !== e && this.w.config.yaxis[e].labels.formatter && void 0 === this.w.config.yaxis[e].tickAmount) {
                    var s = Number(this.w.config.yaxis[e].labels.formatter(1));
                    $fffa43d1c55f0813$var$x.isNumber(s) && 0 === this.w.globals.yValueDecimal && (a = Math.ceil(i));
                }
                return a < t ? a : t;
            }
        },
        {
            key: "setYScaleForIndex",
            value: function(t, e, i) {
                var a = this.w.globals, s = this.w.config, r = a.isBarHorizontal ? s.xaxis : s.yaxis[t];
                void 0 === a.yAxisScale[t] && (a.yAxisScale[t] = []);
                var o = Math.abs(i - e);
                if (r.logarithmic && o <= 5 && (a.invalidLogScale = !0), r.logarithmic && o > 5) a.allSeriesCollapsed = !1, a.yAxisScale[t] = this.logarithmicScale(e, i, r.logBase), a.yAxisScale[t] = r.forceNiceScale ? this.logarithmicScaleNice(e, i, r.logBase) : this.logarithmicScale(e, i, r.logBase);
                else if (i !== -Number.MAX_VALUE && $fffa43d1c55f0813$var$x.isNumber(i)) {
                    if (a.allSeriesCollapsed = !1, void 0 === r.min && void 0 === r.max || r.forceNiceScale) {
                        var n = void 0 === s.yaxis[t].max && void 0 === s.yaxis[t].min || s.yaxis[t].forceNiceScale;
                        a.yAxisScale[t] = this.niceScale(e, i, r.tickAmount ? r.tickAmount : o < 5 && o > 1 ? o + 1 : 5, t, n);
                    } else a.yAxisScale[t] = this.linearScale(e, i, r.tickAmount, t);
                } else a.yAxisScale[t] = this.linearScale(0, 5, 5);
            }
        },
        {
            key: "setXScale",
            value: function(t, e) {
                var i = this.w, a = i.globals, s = i.config.xaxis, r = Math.abs(e - t);
                return e !== -Number.MAX_VALUE && $fffa43d1c55f0813$var$x.isNumber(e) ? a.xAxisScale = this.linearScale(t, e, s.tickAmount ? s.tickAmount : r < 5 && r > 1 ? r + 1 : 5, 0) : a.xAxisScale = this.linearScale(0, 5, 5), a.xAxisScale;
            }
        },
        {
            key: "setMultipleYScales",
            value: function() {
                var t = this, e = this.w.globals, i = this.w.config, a = e.minYArr.concat([]), s = e.maxYArr.concat([]), r = [];
                i.yaxis.forEach(function(e, o) {
                    var n = o;
                    i.series.forEach(function(t, i) {
                        t.name === e.seriesName && (n = i, o !== i ? r.push({
                            index: i,
                            similarIndex: o,
                            alreadyExists: !0
                        }) : r.push({
                            index: i
                        }));
                    });
                    var l = a[n], h = s[n];
                    t.setYScaleForIndex(o, l, h);
                }), this.sameScaleInMultipleAxes(a, s, r);
            }
        },
        {
            key: "sameScaleInMultipleAxes",
            value: function(t, e, i) {
                var a = this, s = this.w.config, r = this.w.globals, o = [];
                i.forEach(function(t) {
                    t.alreadyExists && (void 0 === o[t.index] && (o[t.index] = []), o[t.index].push(t.index), o[t.index].push(t.similarIndex));
                }), r.yAxisSameScaleIndices = o, o.forEach(function(t, e) {
                    o.forEach(function(i, a) {
                        var s, r;
                        e !== a && (s = t, r = i, s.filter(function(t) {
                            return -1 !== r.indexOf(t);
                        })).length > 0 && (o[e] = o[e].concat(o[a]));
                    });
                });
                var n = o.map(function(t) {
                    return t.filter(function(e, i) {
                        return t.indexOf(e) === i;
                    });
                }).map(function(t) {
                    return t.sort();
                });
                o = o.filter(function(t) {
                    return !!t;
                });
                var l = n.slice(), h = l.map(function(t) {
                    return JSON.stringify(t);
                });
                l = l.filter(function(t, e) {
                    return h.indexOf(JSON.stringify(t)) === e;
                });
                var c = [], d = [];
                t.forEach(function(t, i) {
                    l.forEach(function(a, s) {
                        a.indexOf(i) > -1 && (void 0 === c[s] && (c[s] = [], d[s] = []), c[s].push({
                            key: i,
                            value: t
                        }), d[s].push({
                            key: i,
                            value: e[i]
                        }));
                    });
                });
                var g = Array.apply(null, Array(l.length)).map(Number.prototype.valueOf, Number.MIN_VALUE), u = Array.apply(null, Array(l.length)).map(Number.prototype.valueOf, -Number.MAX_VALUE);
                c.forEach(function(t, e) {
                    t.forEach(function(t, i) {
                        g[e] = Math.min(t.value, g[e]);
                    });
                }), d.forEach(function(t, e) {
                    t.forEach(function(t, i) {
                        u[e] = Math.max(t.value, u[e]);
                    });
                }), t.forEach(function(t, e) {
                    d.forEach(function(t, i) {
                        var o = g[i], n = u[i];
                        s.chart.stacked && (n = 0, t.forEach(function(t, e) {
                            t.value !== -Number.MAX_VALUE && (n += t.value), o !== Number.MIN_VALUE && (o += c[i][e].value);
                        })), t.forEach(function(i, l) {
                            t[l].key === e && (void 0 !== s.yaxis[e].min && (o = "function" == typeof s.yaxis[e].min ? s.yaxis[e].min(r.minY) : s.yaxis[e].min), void 0 !== s.yaxis[e].max && (n = "function" == typeof s.yaxis[e].max ? s.yaxis[e].max(r.maxY) : s.yaxis[e].max), a.setYScaleForIndex(e, o, n));
                        });
                    });
                });
            }
        },
        {
            key: "autoScaleY",
            value: function(t, e, i) {
                t || (t = this);
                var a = t.w;
                if (a.globals.isMultipleYAxis || a.globals.collapsedSeries.length) return console.warn("autoScaleYaxis not supported in a multi-yaxis chart."), e;
                var s = a.globals.seriesX[0], r = a.config.chart.stacked;
                return e.forEach(function(t, o) {
                    for(var n = 0, l = 0; l < s.length; l++)if (s[l] >= i.xaxis.min) {
                        n = l;
                        break;
                    }
                    var h, c, d = a.globals.minYArr[o], g = a.globals.maxYArr[o], u = a.globals.stackedSeriesTotals;
                    a.globals.series.forEach(function(o, l) {
                        var p = o[n];
                        r ? (p = u[n], h = c = p, u.forEach(function(t, e) {
                            s[e] <= i.xaxis.max && s[e] >= i.xaxis.min && (t > c && null !== t && (c = t), o[e] < h && null !== o[e] && (h = o[e]));
                        })) : (h = c = p, o.forEach(function(t, e) {
                            if (s[e] <= i.xaxis.max && s[e] >= i.xaxis.min) {
                                var r = t, o = t;
                                a.globals.series.forEach(function(i, a) {
                                    null !== t && (r = Math.min(i[e], r), o = Math.max(i[e], o));
                                }), o > c && null !== o && (c = o), r < h && null !== r && (h = r);
                            }
                        })), void 0 === h && void 0 === c && (h = d, c = g), c *= c < 0 ? .9 : 1.1, 0 === (h *= h < 0 ? 1.1 : .9) && 0 === c && (h = -1, c = 1), c < 0 && c < g && (c = g), h < 0 && h > d && (h = d), e.length > 1 ? (e[l].min = void 0 === t.min ? h : t.min, e[l].max = void 0 === t.max ? c : t.max) : (e[0].min = void 0 === t.min ? h : t.min, e[0].max = void 0 === t.max ? c : t.max);
                    });
                }), e;
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$U = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w, this.scales = new $fffa43d1c55f0813$var$_(e);
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "init",
            value: function() {
                this.setYRange(), this.setXRange(), this.setZRange();
            }
        },
        {
            key: "getMinYMaxY",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Number.MAX_VALUE, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : -Number.MAX_VALUE, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null, s = this.w.config, r = this.w.globals, o = -Number.MAX_VALUE, n = Number.MIN_VALUE;
                null === a && (a = t + 1);
                var l = r.series, h = l, c = l;
                "candlestick" === s.chart.type ? (h = r.seriesCandleL, c = r.seriesCandleH) : "boxPlot" === s.chart.type ? (h = r.seriesCandleO, c = r.seriesCandleC) : r.isRangeData && (h = r.seriesRangeStart, c = r.seriesRangeEnd);
                for(var d = t; d < a; d++){
                    r.dataPoints = Math.max(r.dataPoints, l[d].length), r.categoryLabels.length && (r.dataPoints = r.categoryLabels.filter(function(t) {
                        return void 0 !== t;
                    }).length), r.labels.length && "datetime" !== s.xaxis.type && 0 !== r.series.reduce(function(t, e) {
                        return t + e.length;
                    }, 0) && (r.dataPoints = Math.max(r.dataPoints, r.labels.length));
                    for(var g = 0; g < r.series[d].length; g++){
                        var u = l[d][g];
                        null !== u && $fffa43d1c55f0813$var$x.isNumber(u) ? (void 0 !== c[d][g] && (o = Math.max(o, c[d][g]), e = Math.min(e, c[d][g])), void 0 !== h[d][g] && (e = Math.min(e, h[d][g]), i = Math.max(i, h[d][g])), "candlestick" !== this.w.config.chart.type && "boxPlot" !== this.w.config.chart.type && "rangeArea" === this.w.config.chart.type && "rangeBar" === this.w.config.chart.type || ("candlestick" !== this.w.config.chart.type && "boxPlot" !== this.w.config.chart.type || void 0 !== r.seriesCandleC[d][g] && (o = Math.max(o, r.seriesCandleO[d][g]), o = Math.max(o, r.seriesCandleH[d][g]), o = Math.max(o, r.seriesCandleL[d][g]), o = Math.max(o, r.seriesCandleC[d][g]), "boxPlot" === this.w.config.chart.type && (o = Math.max(o, r.seriesCandleM[d][g]))), !s.series[d].type || "candlestick" === s.series[d].type && "boxPlot" === s.series[d].type && "rangeArea" === s.series[d].type && "rangeBar" === s.series[d].type || (o = Math.max(o, r.series[d][g]), e = Math.min(e, r.series[d][g])), i = o), r.seriesGoals[d] && r.seriesGoals[d][g] && Array.isArray(r.seriesGoals[d][g]) && r.seriesGoals[d][g].forEach(function(t) {
                            n !== Number.MIN_VALUE && (n = Math.min(n, t.value), e = n), o = Math.max(o, t.value), i = o;
                        }), $fffa43d1c55f0813$var$x.isFloat(u) && (u = $fffa43d1c55f0813$var$x.noExponents(u), r.yValueDecimal = Math.max(r.yValueDecimal, u.toString().split(".")[1].length)), n > h[d][g] && h[d][g] < 0 && (n = h[d][g])) : r.hasNullValues = !0;
                    }
                }
                return "rangeBar" === s.chart.type && r.seriesRangeStart.length && r.isBarHorizontal && (n = e), "bar" === s.chart.type && (n < 0 && o < 0 && (o = 0), n === Number.MIN_VALUE && (n = 0)), {
                    minY: n,
                    maxY: o,
                    lowestY: e,
                    highestY: i
                };
            }
        },
        {
            key: "setYRange",
            value: function() {
                var t = this.w.globals, e = this.w.config;
                t.maxY = -Number.MAX_VALUE, t.minY = Number.MIN_VALUE;
                var i = Number.MAX_VALUE;
                if (t.isMultipleYAxis) for(var a = 0; a < t.series.length; a++){
                    var s = this.getMinYMaxY(a, i, null, a + 1);
                    t.minYArr.push(s.minY), t.maxYArr.push(s.maxY), i = s.lowestY;
                }
                var r = this.getMinYMaxY(0, i, null, t.series.length);
                if (t.minY = r.minY, t.maxY = r.maxY, i = r.lowestY, e.chart.stacked && this._setStackedMinMax(), ("line" === e.chart.type || "area" === e.chart.type || "candlestick" === e.chart.type || "boxPlot" === e.chart.type || "rangeBar" === e.chart.type && !t.isBarHorizontal) && t.minY === Number.MIN_VALUE && i !== -Number.MAX_VALUE && i !== t.maxY) {
                    var o = t.maxY - i;
                    (i >= 0 && i <= 10 || void 0 !== e.yaxis[0].min || void 0 !== e.yaxis[0].max) && (o = 0), t.minY = i - 5 * o / 100, i > 0 && t.minY < 0 && (t.minY = 0), t.maxY = t.maxY + 5 * o / 100;
                }
                if (e.yaxis.forEach(function(e, i) {
                    void 0 !== e.max && ("number" == typeof e.max ? t.maxYArr[i] = e.max : "function" == typeof e.max && (t.maxYArr[i] = e.max(t.isMultipleYAxis ? t.maxYArr[i] : t.maxY)), t.maxY = t.maxYArr[i]), void 0 !== e.min && ("number" == typeof e.min ? t.minYArr[i] = e.min : "function" == typeof e.min && (t.minYArr[i] = e.min(t.isMultipleYAxis ? t.minYArr[i] === Number.MIN_VALUE ? 0 : t.minYArr[i] : t.minY)), t.minY = t.minYArr[i]);
                }), t.isBarHorizontal) [
                    "min",
                    "max"
                ].forEach(function(i) {
                    void 0 !== e.xaxis[i] && "number" == typeof e.xaxis[i] && ("min" === i ? t.minY = e.xaxis[i] : t.maxY = e.xaxis[i]);
                });
                return t.isMultipleYAxis ? (this.scales.setMultipleYScales(), t.minY = i, t.yAxisScale.forEach(function(e, i) {
                    t.minYArr[i] = e.niceMin, t.maxYArr[i] = e.niceMax;
                })) : (this.scales.setYScaleForIndex(0, t.minY, t.maxY), t.minY = t.yAxisScale[0].niceMin, t.maxY = t.yAxisScale[0].niceMax, t.minYArr[0] = t.yAxisScale[0].niceMin, t.maxYArr[0] = t.yAxisScale[0].niceMax), {
                    minY: t.minY,
                    maxY: t.maxY,
                    minYArr: t.minYArr,
                    maxYArr: t.maxYArr,
                    yAxisScale: t.yAxisScale
                };
            }
        },
        {
            key: "setXRange",
            value: function() {
                var t = this.w.globals, e = this.w.config, i = "numeric" === e.xaxis.type || "datetime" === e.xaxis.type || "category" === e.xaxis.type && !t.noLabelsProvided || t.noLabelsProvided || t.isXNumeric;
                if (t.isXNumeric && function() {
                    for(var e = 0; e < t.series.length; e++)if (t.labels[e]) for(var i = 0; i < t.labels[e].length; i++)null !== t.labels[e][i] && $fffa43d1c55f0813$var$x.isNumber(t.labels[e][i]) && (t.maxX = Math.max(t.maxX, t.labels[e][i]), t.initialMaxX = Math.max(t.maxX, t.labels[e][i]), t.minX = Math.min(t.minX, t.labels[e][i]), t.initialMinX = Math.min(t.minX, t.labels[e][i]));
                }(), t.noLabelsProvided && 0 === e.xaxis.categories.length && (t.maxX = t.labels[t.labels.length - 1], t.initialMaxX = t.labels[t.labels.length - 1], t.minX = 1, t.initialMinX = 1), t.isXNumeric || t.noLabelsProvided || t.dataFormatXNumeric) {
                    var a;
                    if (void 0 === e.xaxis.tickAmount ? (a = Math.round(t.svgWidth / 150), "numeric" === e.xaxis.type && t.dataPoints < 30 && (a = t.dataPoints - 1), a > t.dataPoints && 0 !== t.dataPoints && (a = t.dataPoints - 1)) : "dataPoints" === e.xaxis.tickAmount ? (t.series.length > 1 && (a = t.series[t.maxValsInArrayIndex].length - 1), t.isXNumeric && (a = t.maxX - t.minX - 1)) : a = e.xaxis.tickAmount, t.xTickAmount = a, void 0 !== e.xaxis.max && "number" == typeof e.xaxis.max && (t.maxX = e.xaxis.max), void 0 !== e.xaxis.min && "number" == typeof e.xaxis.min && (t.minX = e.xaxis.min), void 0 !== e.xaxis.range && (t.minX = t.maxX - e.xaxis.range), t.minX !== Number.MAX_VALUE && t.maxX !== -Number.MAX_VALUE) {
                        if (e.xaxis.convertedCatToNumeric && !t.dataFormatXNumeric) {
                            for(var s = [], r = t.minX - 1; r < t.maxX; r++)s.push(r + 1);
                            t.xAxisScale = {
                                result: s,
                                niceMin: s[0],
                                niceMax: s[s.length - 1]
                            };
                        } else t.xAxisScale = this.scales.setXScale(t.minX, t.maxX);
                    } else t.xAxisScale = this.scales.linearScale(0, a, a), t.noLabelsProvided && t.labels.length > 0 && (t.xAxisScale = this.scales.linearScale(1, t.labels.length, a - 1), t.seriesX = t.labels.slice());
                    i && (t.labels = t.xAxisScale.result.slice());
                }
                return t.isBarHorizontal && t.labels.length && (t.xTickAmount = t.labels.length), this._handleSingleDataPoint(), this._getMinXDiff(), {
                    minX: t.minX,
                    maxX: t.maxX
                };
            }
        },
        {
            key: "setZRange",
            value: function() {
                var t = this.w.globals;
                if (t.isDataXYZ) {
                    for(var e = 0; e < t.series.length; e++)if (void 0 !== t.seriesZ[e]) for(var i = 0; i < t.seriesZ[e].length; i++)null !== t.seriesZ[e][i] && $fffa43d1c55f0813$var$x.isNumber(t.seriesZ[e][i]) && (t.maxZ = Math.max(t.maxZ, t.seriesZ[e][i]), t.minZ = Math.min(t.minZ, t.seriesZ[e][i]));
                }
            }
        },
        {
            key: "_handleSingleDataPoint",
            value: function() {
                var t = this.w.globals, e = this.w.config;
                if (t.minX === t.maxX) {
                    var i = new $fffa43d1c55f0813$var$I(this.ctx);
                    if ("datetime" === e.xaxis.type) {
                        var a = i.getDate(t.minX);
                        e.xaxis.labels.datetimeUTC ? a.setUTCDate(a.getUTCDate() - 2) : a.setDate(a.getDate() - 2), t.minX = new Date(a).getTime();
                        var s = i.getDate(t.maxX);
                        e.xaxis.labels.datetimeUTC ? s.setUTCDate(s.getUTCDate() + 2) : s.setDate(s.getDate() + 2), t.maxX = new Date(s).getTime();
                    } else ("numeric" === e.xaxis.type || "category" === e.xaxis.type && !t.noLabelsProvided) && (t.minX = t.minX - 2, t.initialMinX = t.minX, t.maxX = t.maxX + 2, t.initialMaxX = t.maxX);
                }
            }
        },
        {
            key: "_getMinXDiff",
            value: function() {
                var t = this.w.globals;
                t.isXNumeric && t.seriesX.forEach(function(e, i) {
                    1 === e.length && e.push(t.seriesX[t.maxValsInArrayIndex][t.seriesX[t.maxValsInArrayIndex].length - 1]);
                    var a = e.slice();
                    a.sort(function(t, e) {
                        return t - e;
                    }), a.forEach(function(e, i) {
                        if (i > 0) {
                            var s = e - a[i - 1];
                            s > 0 && (t.minXDiff = Math.min(s, t.minXDiff));
                        }
                    }), 1 !== t.dataPoints && t.minXDiff !== Number.MAX_VALUE || (t.minXDiff = .5);
                });
            }
        },
        {
            key: "_setStackedMinMax",
            value: function() {
                var t = this, e = this.w.globals;
                if (e.series.length) {
                    var i = e.seriesGroups;
                    i.length || (i = [
                        this.w.config.series.map(function(t) {
                            return t.name;
                        })
                    ]);
                    var a = {}, s = {};
                    i.forEach(function(i) {
                        a[i] = [], s[i] = [], t.w.config.series.map(function(t, e) {
                            return i.indexOf(t.name) > -1 ? e : null;
                        }).filter(function(t) {
                            return null !== t;
                        }).forEach(function(r) {
                            for(var o = 0; o < e.series[e.maxValsInArrayIndex].length; o++){
                                var n, l;
                                void 0 === a[i][o] && (a[i][o] = 0, s[i][o] = 0), (!t.w.config.chart.stackOnlyBar || "bar" === (null === (n = e.series) || void 0 === n || null === (l = n[r]) || void 0 === l ? void 0 : l.type) || "bar" === t.w.config.chart.type) && null !== e.series[r][o] && $fffa43d1c55f0813$var$x.isNumber(e.series[r][o]) && (e.series[r][o] > 0 ? a[i][o] += parseFloat(e.series[r][o]) + 1e-4 : s[i][o] += parseFloat(e.series[r][o]));
                            }
                        });
                    }), Object.entries(a).forEach(function(t) {
                        var i = $fffa43d1c55f0813$var$g(t, 1)[0];
                        a[i].forEach(function(t, r) {
                            e.maxY = Math.max(e.maxY, a[i][r]), e.minY = Math.min(e.minY, s[i][r]);
                        });
                    });
                }
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$q = function() {
    function t(e, i) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.elgrid = i, this.w = e.w;
        var s = this.w;
        this.xaxisFontSize = s.config.xaxis.labels.style.fontSize, this.axisFontFamily = s.config.xaxis.labels.style.fontFamily, this.xaxisForeColors = s.config.xaxis.labels.style.colors, this.isCategoryBarHorizontal = "bar" === s.config.chart.type && s.config.plotOptions.bar.horizontal, this.xAxisoffX = 0, "bottom" === s.config.xaxis.position && (this.xAxisoffX = s.globals.gridHeight), this.drawnLabels = [], this.axesUtils = new $fffa43d1c55f0813$var$B(e);
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "drawYaxis",
            value: function(t) {
                var e = this, i = this.w, a = new $fffa43d1c55f0813$var$m(this.ctx), s = i.config.yaxis[t].labels.style, r = s.fontSize, o = s.fontFamily, n = s.fontWeight, l = a.group({
                    class: "apexcharts-yaxis",
                    rel: t,
                    transform: "translate(" + i.globals.translateYAxisX[t] + ", 0)"
                });
                if (this.axesUtils.isYAxisHidden(t)) return l;
                var h = a.group({
                    class: "apexcharts-yaxis-texts-g"
                });
                l.add(h);
                var c = i.globals.yAxisScale[t].result.length - 1, d = i.globals.gridHeight / c, g = i.globals.translateY, u = i.globals.yLabelFormatters[t], p = i.globals.yAxisScale[t].result.slice();
                p = this.axesUtils.checkForReversedLabels(t, p);
                var f = "";
                if (i.config.yaxis[t].labels.show) for(var x = function(l) {
                    var x = p[l];
                    x = u(x, l, i);
                    var b = i.config.yaxis[t].labels.padding;
                    i.config.yaxis[t].opposite && 0 !== i.config.yaxis.length && (b *= -1);
                    var v = "end";
                    i.config.yaxis[t].opposite && (v = "start"), "left" === i.config.yaxis[t].labels.align ? v = "start" : "center" === i.config.yaxis[t].labels.align ? v = "middle" : "right" === i.config.yaxis[t].labels.align && (v = "end");
                    var m = e.axesUtils.getYAxisForeColor(s.colors, t), y = i.config.yaxis[t].labels.offsetY;
                    "heatmap" === i.config.chart.type && (y -= (i.globals.gridHeight / i.globals.series.length - 1) / 2);
                    var w = a.drawText({
                        x: b,
                        y: g + c / 10 + y + 1,
                        text: x,
                        textAnchor: v,
                        fontSize: r,
                        fontFamily: o,
                        fontWeight: n,
                        maxWidth: i.config.yaxis[t].labels.maxWidth,
                        foreColor: Array.isArray(m) ? m[l] : m,
                        isPlainText: !1,
                        cssClass: "apexcharts-yaxis-label " + s.cssClass
                    });
                    l === c && (f = w), h.add(w);
                    var k = document.createElementNS(i.globals.SVGNS, "title");
                    if (k.textContent = Array.isArray(x) ? x.join(" ") : x, w.node.appendChild(k), 0 !== i.config.yaxis[t].labels.rotate) {
                        var A = a.rotateAroundCenter(f.node), S = a.rotateAroundCenter(w.node);
                        w.node.setAttribute("transform", "rotate(".concat(i.config.yaxis[t].labels.rotate, " ").concat(A.x, " ").concat(S.y, ")"));
                    }
                    g += d;
                }, b = c; b >= 0; b--)x(b);
                if (void 0 !== i.config.yaxis[t].title.text) {
                    var v = a.group({
                        class: "apexcharts-yaxis-title"
                    }), y = 0;
                    i.config.yaxis[t].opposite && (y = i.globals.translateYAxisX[t]);
                    var w = a.drawText({
                        x: y,
                        y: i.globals.gridHeight / 2 + i.globals.translateY + i.config.yaxis[t].title.offsetY,
                        text: i.config.yaxis[t].title.text,
                        textAnchor: "end",
                        foreColor: i.config.yaxis[t].title.style.color,
                        fontSize: i.config.yaxis[t].title.style.fontSize,
                        fontWeight: i.config.yaxis[t].title.style.fontWeight,
                        fontFamily: i.config.yaxis[t].title.style.fontFamily,
                        cssClass: "apexcharts-yaxis-title-text " + i.config.yaxis[t].title.style.cssClass
                    });
                    v.add(w), l.add(v);
                }
                var k = i.config.yaxis[t].axisBorder, A = 31 + k.offsetX;
                if (i.config.yaxis[t].opposite && (A = -31 - k.offsetX), k.show) {
                    var S = a.drawLine(A, i.globals.translateY + k.offsetY - 2, A, i.globals.gridHeight + i.globals.translateY + k.offsetY + 2, k.color, 0, k.width);
                    l.add(S);
                }
                return i.config.yaxis[t].axisTicks.show && this.axesUtils.drawYAxisTicks(A, c, k, i.config.yaxis[t].axisTicks, t, d, l), l;
            }
        },
        {
            key: "drawYaxisInversed",
            value: function(t) {
                var e = this.w, i = new $fffa43d1c55f0813$var$m(this.ctx), a = i.group({
                    class: "apexcharts-xaxis apexcharts-yaxis-inversed"
                }), s = i.group({
                    class: "apexcharts-xaxis-texts-g",
                    transform: "translate(".concat(e.globals.translateXAxisX, ", ").concat(e.globals.translateXAxisY, ")")
                });
                a.add(s);
                var r = e.globals.yAxisScale[t].result.length - 1, o = e.globals.gridWidth / r + .1, n = o + e.config.xaxis.labels.offsetX, l = e.globals.xLabelFormatter, h = e.globals.yAxisScale[t].result.slice(), c = e.globals.timescaleLabels;
                c.length > 0 && (this.xaxisLabels = c.slice(), r = (h = c.slice()).length), h = this.axesUtils.checkForReversedLabels(t, h);
                var d = c.length;
                if (e.config.xaxis.labels.show) for(var g = d ? 0 : r; d ? g < d : g >= 0; d ? g++ : g--){
                    var u = h[g];
                    u = l(u, g, e);
                    var p = e.globals.gridWidth + e.globals.padHorizontal - (n - o + e.config.xaxis.labels.offsetX);
                    if (c.length) {
                        var f = this.axesUtils.getLabel(h, c, p, g, this.drawnLabels, this.xaxisFontSize);
                        p = f.x, u = f.text, this.drawnLabels.push(f.text), 0 === g && e.globals.skipFirstTimelinelabel && (u = ""), g === h.length - 1 && e.globals.skipLastTimelinelabel && (u = "");
                    }
                    var x = i.drawText({
                        x: p,
                        y: this.xAxisoffX + e.config.xaxis.labels.offsetY + 30 - ("top" === e.config.xaxis.position ? e.globals.xAxisHeight + e.config.xaxis.axisTicks.height - 2 : 0),
                        text: u,
                        textAnchor: "middle",
                        foreColor: Array.isArray(this.xaxisForeColors) ? this.xaxisForeColors[t] : this.xaxisForeColors,
                        fontSize: this.xaxisFontSize,
                        fontFamily: this.xaxisFontFamily,
                        fontWeight: e.config.xaxis.labels.style.fontWeight,
                        isPlainText: !1,
                        cssClass: "apexcharts-xaxis-label " + e.config.xaxis.labels.style.cssClass
                    });
                    s.add(x), x.tspan(u);
                    var b = document.createElementNS(e.globals.SVGNS, "title");
                    b.textContent = u, x.node.appendChild(b), n += o;
                }
                return this.inversedYAxisTitleText(a), this.inversedYAxisBorder(a), a;
            }
        },
        {
            key: "inversedYAxisBorder",
            value: function(t) {
                var e = this.w, i = new $fffa43d1c55f0813$var$m(this.ctx), a = e.config.xaxis.axisBorder;
                if (a.show) {
                    var s = 0;
                    "bar" === e.config.chart.type && e.globals.isXNumeric && (s -= 15);
                    var r = i.drawLine(e.globals.padHorizontal + s + a.offsetX, this.xAxisoffX, e.globals.gridWidth, this.xAxisoffX, a.color, 0, a.height);
                    this.elgrid && this.elgrid.elGridBorders && e.config.grid.show ? this.elgrid.elGridBorders.add(r) : t.add(r);
                }
            }
        },
        {
            key: "inversedYAxisTitleText",
            value: function(t) {
                var e = this.w, i = new $fffa43d1c55f0813$var$m(this.ctx);
                if (void 0 !== e.config.xaxis.title.text) {
                    var a = i.group({
                        class: "apexcharts-xaxis-title apexcharts-yaxis-title-inversed"
                    }), s = i.drawText({
                        x: e.globals.gridWidth / 2 + e.config.xaxis.title.offsetX,
                        y: this.xAxisoffX + parseFloat(this.xaxisFontSize) + parseFloat(e.config.xaxis.title.style.fontSize) + e.config.xaxis.title.offsetY + 20,
                        text: e.config.xaxis.title.text,
                        textAnchor: "middle",
                        fontSize: e.config.xaxis.title.style.fontSize,
                        fontFamily: e.config.xaxis.title.style.fontFamily,
                        fontWeight: e.config.xaxis.title.style.fontWeight,
                        foreColor: e.config.xaxis.title.style.color,
                        cssClass: "apexcharts-xaxis-title-text " + e.config.xaxis.title.style.cssClass
                    });
                    a.add(s), t.add(a);
                }
            }
        },
        {
            key: "yAxisTitleRotate",
            value: function(t, e) {
                var i = this.w, a = new $fffa43d1c55f0813$var$m(this.ctx), s = {
                    width: 0,
                    height: 0
                }, r = {
                    width: 0,
                    height: 0
                }, o = i.globals.dom.baseEl.querySelector(" .apexcharts-yaxis[rel='".concat(t, "'] .apexcharts-yaxis-texts-g"));
                null !== o && (s = o.getBoundingClientRect());
                var n = i.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(t, "'] .apexcharts-yaxis-title text"));
                if (null !== n && (r = n.getBoundingClientRect()), null !== n) {
                    var l = this.xPaddingForYAxisTitle(t, s, r, e);
                    n.setAttribute("x", l.xPos - (e ? 10 : 0));
                }
                if (null !== n) {
                    var h = a.rotateAroundCenter(n);
                    n.setAttribute("transform", "rotate(".concat(e ? -1 * i.config.yaxis[t].title.rotate : i.config.yaxis[t].title.rotate, " ").concat(h.x, " ").concat(h.y, ")"));
                }
            }
        },
        {
            key: "xPaddingForYAxisTitle",
            value: function(t, e, i, a) {
                var s = this.w, r = 0, o = 0, n = 10;
                return void 0 === s.config.yaxis[t].title.text || t < 0 ? {
                    xPos: o,
                    padd: 0
                } : (a ? (o = e.width + s.config.yaxis[t].title.offsetX + i.width / 2 + n / 2, 0 === (r += 1) && (o -= n / 2)) : (o = -1 * e.width + s.config.yaxis[t].title.offsetX + n / 2 + i.width / 2, s.globals.isBarHorizontal && (n = 25, o = -1 * e.width - s.config.yaxis[t].title.offsetX - n)), {
                    xPos: o,
                    padd: n
                });
            }
        },
        {
            key: "setYAxisXPosition",
            value: function(t, e) {
                var i = this.w, a = 0, s = 0, r = 18, o = 1;
                i.config.yaxis.length > 1 && (this.multipleYs = !0), i.config.yaxis.map(function(n, l) {
                    var h = i.globals.ignoreYAxisIndexes.indexOf(l) > -1 || !n.show || n.floating || 0 === t[l].width, c = t[l].width + e[l].width;
                    n.opposite ? i.globals.isBarHorizontal ? (s = i.globals.gridWidth + i.globals.translateX - 1, i.globals.translateYAxisX[l] = s - n.labels.offsetX) : (s = i.globals.gridWidth + i.globals.translateX + o, h || (o = o + c + 20), i.globals.translateYAxisX[l] = s - n.labels.offsetX + 20) : (a = i.globals.translateX - r, h || (r = r + c + 20), i.globals.translateYAxisX[l] = a + n.labels.offsetX);
                });
            }
        },
        {
            key: "setYAxisTextAlignments",
            value: function() {
                var t = this.w, e = t.globals.dom.baseEl.getElementsByClassName("apexcharts-yaxis");
                (e = $fffa43d1c55f0813$var$x.listToArray(e)).forEach(function(e, i) {
                    var a = t.config.yaxis[i];
                    if (a && !a.floating && void 0 !== a.labels.align) {
                        var s = t.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(i, "'] .apexcharts-yaxis-texts-g")), r = t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis[rel='".concat(i, "'] .apexcharts-yaxis-label"));
                        r = $fffa43d1c55f0813$var$x.listToArray(r);
                        var o = s.getBoundingClientRect();
                        "left" === a.labels.align ? (r.forEach(function(t, e) {
                            t.setAttribute("text-anchor", "start");
                        }), a.opposite || s.setAttribute("transform", "translate(-".concat(o.width, ", 0)"))) : "center" === a.labels.align ? (r.forEach(function(t, e) {
                            t.setAttribute("text-anchor", "middle");
                        }), s.setAttribute("transform", "translate(".concat(o.width / 2 * (a.opposite ? 1 : -1), ", 0)"))) : "right" === a.labels.align && (r.forEach(function(t, e) {
                            t.setAttribute("text-anchor", "end");
                        }), a.opposite && s.setAttribute("transform", "translate(".concat(o.width, ", 0)")));
                    }
                });
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$Z = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w, this.documentEvent = $fffa43d1c55f0813$var$x.bind(this.documentEvent, this);
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "addEventListener",
            value: function(t, e) {
                var i = this.w;
                i.globals.events.hasOwnProperty(t) ? i.globals.events[t].push(e) : i.globals.events[t] = [
                    e
                ];
            }
        },
        {
            key: "removeEventListener",
            value: function(t, e) {
                var i = this.w;
                if (i.globals.events.hasOwnProperty(t)) {
                    var a = i.globals.events[t].indexOf(e);
                    -1 !== a && i.globals.events[t].splice(a, 1);
                }
            }
        },
        {
            key: "fireEvent",
            value: function(t, e) {
                var i = this.w;
                if (i.globals.events.hasOwnProperty(t)) {
                    e && e.length || (e = []);
                    for(var a = i.globals.events[t], s = a.length, r = 0; r < s; r++)a[r].apply(null, e);
                }
            }
        },
        {
            key: "setupEventHandlers",
            value: function() {
                var t = this, e = this.w, i = this.ctx, a = e.globals.dom.baseEl.querySelector(e.globals.chartClass);
                this.ctx.eventList.forEach(function(t) {
                    a.addEventListener(t, function(t) {
                        var a = Object.assign({}, e, {
                            seriesIndex: e.globals.capturedSeriesIndex,
                            dataPointIndex: e.globals.capturedDataPointIndex
                        });
                        "mousemove" === t.type || "touchmove" === t.type ? "function" == typeof e.config.chart.events.mouseMove && e.config.chart.events.mouseMove(t, i, a) : "mouseleave" === t.type || "touchleave" === t.type ? "function" == typeof e.config.chart.events.mouseLeave && e.config.chart.events.mouseLeave(t, i, a) : ("mouseup" === t.type && 1 === t.which || "touchend" === t.type) && ("function" == typeof e.config.chart.events.click && e.config.chart.events.click(t, i, a), i.ctx.events.fireEvent("click", [
                            t,
                            i,
                            a
                        ]));
                    }, {
                        capture: !1,
                        passive: !0
                    });
                }), this.ctx.eventList.forEach(function(i) {
                    e.globals.dom.baseEl.addEventListener(i, t.documentEvent, {
                        passive: !0
                    });
                }), this.ctx.core.setupBrushHandler();
            }
        },
        {
            key: "documentEvent",
            value: function(t) {
                var e = this.w, i = t.target.className;
                if ("click" === t.type) {
                    var a = e.globals.dom.baseEl.querySelector(".apexcharts-menu");
                    a && a.classList.contains("apexcharts-menu-open") && "apexcharts-menu-icon" !== i && a.classList.remove("apexcharts-menu-open");
                }
                e.globals.clientX = "touchmove" === t.type ? t.touches[0].clientX : t.clientX, e.globals.clientY = "touchmove" === t.type ? t.touches[0].clientY : t.clientY;
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$$ = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "setCurrentLocaleValues",
            value: function(t) {
                var e = this.w.config.chart.locales;
                window.Apex.chart && window.Apex.chart.locales && window.Apex.chart.locales.length > 0 && (e = this.w.config.chart.locales.concat(window.Apex.chart.locales));
                var i = e.filter(function(e) {
                    return e.name === t;
                })[0];
                if (!i) throw new Error("Wrong locale name provided. Please make sure you set the correct locale name in options");
                var a = $fffa43d1c55f0813$var$x.extend($fffa43d1c55f0813$var$C, i);
                this.w.globals.locale = a.options;
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$J = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "drawAxis",
            value: function(t, e) {
                var i, a, s = this, r = this.w.globals, o = this.w.config, n = new $fffa43d1c55f0813$var$V(this.ctx, e), l = new $fffa43d1c55f0813$var$q(this.ctx, e);
                r.axisCharts && "radar" !== t && (r.isBarHorizontal ? (a = l.drawYaxisInversed(0), i = n.drawXaxisInversed(0), r.dom.elGraphical.add(i), r.dom.elGraphical.add(a)) : (i = n.drawXaxis(), r.dom.elGraphical.add(i), o.yaxis.map(function(t, e) {
                    if (-1 === r.ignoreYAxisIndexes.indexOf(e) && (a = l.drawYaxis(e), r.dom.Paper.add(a), "back" === s.w.config.grid.position)) {
                        var i = r.dom.Paper.children()[1];
                        i.remove(), r.dom.Paper.add(i);
                    }
                })));
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$Q = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "drawXCrosshairs",
            value: function() {
                var t = this.w, e = new $fffa43d1c55f0813$var$m(this.ctx), i = new $fffa43d1c55f0813$var$v(this.ctx), a = t.config.xaxis.crosshairs.fill.gradient, s = t.config.xaxis.crosshairs.dropShadow, r = t.config.xaxis.crosshairs.fill.type, o = a.colorFrom, n = a.colorTo, l = a.opacityFrom, h = a.opacityTo, c = a.stops, d = s.enabled, g = s.left, u = s.top, p = s.blur, f = s.color, b = s.opacity, y = t.config.xaxis.crosshairs.fill.color;
                if (t.config.xaxis.crosshairs.show) {
                    "gradient" === r && (y = e.drawGradient("vertical", o, n, l, h, null, c, null));
                    var w = e.drawRect();
                    1 === t.config.xaxis.crosshairs.width && (w = e.drawLine());
                    var k = t.globals.gridHeight;
                    (!$fffa43d1c55f0813$var$x.isNumber(k) || k < 0) && (k = 0);
                    var A = t.config.xaxis.crosshairs.width;
                    (!$fffa43d1c55f0813$var$x.isNumber(A) || A < 0) && (A = 0), w.attr({
                        class: "apexcharts-xcrosshairs",
                        x: 0,
                        y: 0,
                        y2: k,
                        width: A,
                        height: k,
                        fill: y,
                        filter: "none",
                        "fill-opacity": t.config.xaxis.crosshairs.opacity,
                        stroke: t.config.xaxis.crosshairs.stroke.color,
                        "stroke-width": t.config.xaxis.crosshairs.stroke.width,
                        "stroke-dasharray": t.config.xaxis.crosshairs.stroke.dashArray
                    }), d && (w = i.dropShadow(w, {
                        left: g,
                        top: u,
                        blur: p,
                        color: f,
                        opacity: b
                    })), t.globals.dom.elGraphical.add(w);
                }
            }
        },
        {
            key: "drawYCrosshairs",
            value: function() {
                var t = this.w, e = new $fffa43d1c55f0813$var$m(this.ctx), i = t.config.yaxis[0].crosshairs, a = t.globals.barPadForNumericAxis;
                if (t.config.yaxis[0].crosshairs.show) {
                    var s = e.drawLine(-a, 0, t.globals.gridWidth + a, 0, i.stroke.color, i.stroke.dashArray, i.stroke.width);
                    s.attr({
                        class: "apexcharts-ycrosshairs"
                    }), t.globals.dom.elGraphical.add(s);
                }
                var r = e.drawLine(-a, 0, t.globals.gridWidth + a, 0, i.stroke.color, 0, 0);
                r.attr({
                    class: "apexcharts-ycrosshairs-hidden"
                }), t.globals.dom.elGraphical.add(r);
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$K = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "checkResponsiveConfig",
            value: function(t) {
                var e = this, i = this.w, a = i.config;
                if (0 !== a.responsive.length) {
                    var s = a.responsive.slice();
                    s.sort(function(t, e) {
                        return t.breakpoint > e.breakpoint ? 1 : e.breakpoint > t.breakpoint ? -1 : 0;
                    }).reverse();
                    var r = new $fffa43d1c55f0813$var$E({}), o = function() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, a = s[0].breakpoint, o = window.innerWidth > 0 ? window.innerWidth : screen.width;
                        if (o > a) {
                            var n = $fffa43d1c55f0813$var$y.extendArrayProps(r, i.globals.initialConfig, i);
                            t = $fffa43d1c55f0813$var$x.extend(n, t), t = $fffa43d1c55f0813$var$x.extend(i.config, t), e.overrideResponsiveOptions(t);
                        } else for(var l = 0; l < s.length; l++)o < s[l].breakpoint && (t = $fffa43d1c55f0813$var$y.extendArrayProps(r, s[l].options, i), t = $fffa43d1c55f0813$var$x.extend(i.config, t), e.overrideResponsiveOptions(t));
                    };
                    if (t) {
                        var n = $fffa43d1c55f0813$var$y.extendArrayProps(r, t, i);
                        n = $fffa43d1c55f0813$var$x.extend(i.config, n), o(n = $fffa43d1c55f0813$var$x.extend(n, t));
                    } else o({});
                }
            }
        },
        {
            key: "overrideResponsiveOptions",
            value: function(t) {
                var e = new $fffa43d1c55f0813$var$E(t).init({
                    responsiveOverride: !0
                });
                this.w.config = e;
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$tt = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.colors = [], this.w = e.w;
        var i = this.w;
        this.isColorFn = !1, this.isHeatmapDistributed = "treemap" === i.config.chart.type && i.config.plotOptions.treemap.distributed || "heatmap" === i.config.chart.type && i.config.plotOptions.heatmap.distributed, this.isBarDistributed = i.config.plotOptions.bar.distributed && ("bar" === i.config.chart.type || "rangeBar" === i.config.chart.type);
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "init",
            value: function() {
                this.setDefaultColors();
            }
        },
        {
            key: "setDefaultColors",
            value: function() {
                var t, e = this, i = this.w, a = new $fffa43d1c55f0813$var$x;
                if (i.globals.dom.elWrap.classList.add("apexcharts-theme-".concat(i.config.theme.mode)), void 0 === i.config.colors || 0 === (null === (t = i.config.colors) || void 0 === t ? void 0 : t.length) ? i.globals.colors = this.predefined() : (i.globals.colors = i.config.colors, Array.isArray(i.config.colors) && i.config.colors.length > 0 && "function" == typeof i.config.colors[0] && (i.globals.colors = i.config.series.map(function(t, a) {
                    var s = i.config.colors[a];
                    return s || (s = i.config.colors[0]), "function" == typeof s ? (e.isColorFn = !0, s({
                        value: i.globals.axisCharts ? i.globals.series[a][0] ? i.globals.series[a][0] : 0 : i.globals.series[a],
                        seriesIndex: a,
                        dataPointIndex: a,
                        w: i
                    })) : s;
                }))), i.globals.seriesColors.map(function(t, e) {
                    t && (i.globals.colors[e] = t);
                }), i.config.theme.monochrome.enabled) {
                    var s = [], r = i.globals.series.length;
                    (this.isBarDistributed || this.isHeatmapDistributed) && (r = i.globals.series[0].length * i.globals.series.length);
                    for(var o = i.config.theme.monochrome.color, n = 1 / (r / i.config.theme.monochrome.shadeIntensity), l = i.config.theme.monochrome.shadeTo, h = 0, c = 0; c < r; c++){
                        var d = void 0;
                        "dark" === l ? (d = a.shadeColor(-1 * h, o), h += n) : (d = a.shadeColor(h, o), h += n), s.push(d);
                    }
                    i.globals.colors = s.slice();
                }
                var g = i.globals.colors.slice();
                this.pushExtraColors(i.globals.colors);
                [
                    "fill",
                    "stroke"
                ].forEach(function(t) {
                    void 0 === i.config[t].colors ? i.globals[t].colors = e.isColorFn ? i.config.colors : g : i.globals[t].colors = i.config[t].colors.slice(), e.pushExtraColors(i.globals[t].colors);
                }), void 0 === i.config.dataLabels.style.colors ? i.globals.dataLabels.style.colors = g : i.globals.dataLabels.style.colors = i.config.dataLabels.style.colors.slice(), this.pushExtraColors(i.globals.dataLabels.style.colors, 50), void 0 === i.config.plotOptions.radar.polygons.fill.colors ? i.globals.radarPolygons.fill.colors = [
                    "dark" === i.config.theme.mode ? "#424242" : "none"
                ] : i.globals.radarPolygons.fill.colors = i.config.plotOptions.radar.polygons.fill.colors.slice(), this.pushExtraColors(i.globals.radarPolygons.fill.colors, 20), void 0 === i.config.markers.colors ? i.globals.markers.colors = g : i.globals.markers.colors = i.config.markers.colors.slice(), this.pushExtraColors(i.globals.markers.colors);
            }
        },
        {
            key: "pushExtraColors",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = this.w, s = e || a.globals.series.length;
                if (null === i && (i = this.isBarDistributed || this.isHeatmapDistributed || "heatmap" === a.config.chart.type && a.config.plotOptions.heatmap.colorScale.inverse), i && a.globals.series.length && (s = a.globals.series[a.globals.maxValsInArrayIndex].length * a.globals.series.length), t.length < s) for(var r = s - t.length, o = 0; o < r; o++)t.push(t[o]);
            }
        },
        {
            key: "updateThemeOptions",
            value: function(t) {
                t.chart = t.chart || {}, t.tooltip = t.tooltip || {};
                var e = t.theme.mode || "light", i = t.theme.palette ? t.theme.palette : "dark" === e ? "palette4" : "palette1", a = t.chart.foreColor ? t.chart.foreColor : "dark" === e ? "#f6f7f8" : "#373d3f";
                return t.tooltip.theme = e, t.chart.foreColor = a, t.theme.palette = i, t;
            }
        },
        {
            key: "predefined",
            value: function() {
                switch(this.w.config.theme.palette){
                    case "palette1":
                    default:
                        this.colors = [
                            "#008FFB",
                            "#00E396",
                            "#FEB019",
                            "#FF4560",
                            "#775DD0"
                        ];
                        break;
                    case "palette2":
                        this.colors = [
                            "#3f51b5",
                            "#03a9f4",
                            "#4caf50",
                            "#f9ce1d",
                            "#FF9800"
                        ];
                        break;
                    case "palette3":
                        this.colors = [
                            "#33b2df",
                            "#546E7A",
                            "#d4526e",
                            "#13d8aa",
                            "#A5978B"
                        ];
                        break;
                    case "palette4":
                        this.colors = [
                            "#4ecdc4",
                            "#c7f464",
                            "#81D4FA",
                            "#fd6a6a",
                            "#546E7A"
                        ];
                        break;
                    case "palette5":
                        this.colors = [
                            "#2b908f",
                            "#f9a3a4",
                            "#90ee7e",
                            "#fa4443",
                            "#69d2e7"
                        ];
                        break;
                    case "palette6":
                        this.colors = [
                            "#449DD1",
                            "#F86624",
                            "#EA3546",
                            "#662E9B",
                            "#C5D86D"
                        ];
                        break;
                    case "palette7":
                        this.colors = [
                            "#D7263D",
                            "#1B998B",
                            "#2E294E",
                            "#F46036",
                            "#E2C044"
                        ];
                        break;
                    case "palette8":
                        this.colors = [
                            "#662E9B",
                            "#F86624",
                            "#F9C80E",
                            "#EA3546",
                            "#43BCCD"
                        ];
                        break;
                    case "palette9":
                        this.colors = [
                            "#5C4742",
                            "#A5978B",
                            "#8D5B4C",
                            "#5A2A27",
                            "#C4BBAF"
                        ];
                        break;
                    case "palette10":
                        this.colors = [
                            "#A300D6",
                            "#7D02EB",
                            "#5653FE",
                            "#2983FF",
                            "#00B1F2"
                        ];
                }
                return this.colors;
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$et = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "draw",
            value: function() {
                this.drawTitleSubtitle("title"), this.drawTitleSubtitle("subtitle");
            }
        },
        {
            key: "drawTitleSubtitle",
            value: function(t) {
                var e = this.w, i = "title" === t ? e.config.title : e.config.subtitle, a = e.globals.svgWidth / 2, s = i.offsetY, r = "middle";
                if ("left" === i.align ? (a = 10, r = "start") : "right" === i.align && (a = e.globals.svgWidth - 10, r = "end"), a += i.offsetX, s = s + parseInt(i.style.fontSize, 10) + i.margin / 2, void 0 !== i.text) {
                    var o = new $fffa43d1c55f0813$var$m(this.ctx).drawText({
                        x: a,
                        y: s,
                        text: i.text,
                        textAnchor: r,
                        fontSize: i.style.fontSize,
                        fontFamily: i.style.fontFamily,
                        fontWeight: i.style.fontWeight,
                        foreColor: i.style.color,
                        opacity: 1
                    });
                    o.node.setAttribute("class", "apexcharts-".concat(t, "-text")), e.globals.dom.Paper.add(o);
                }
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$it = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.w = e.w, this.dCtx = e;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "getTitleSubtitleCoords",
            value: function(t) {
                var e = this.w, i = 0, a = 0, s = "title" === t ? e.config.title.floating : e.config.subtitle.floating, r = e.globals.dom.baseEl.querySelector(".apexcharts-".concat(t, "-text"));
                if (null !== r && !s) {
                    var o = r.getBoundingClientRect();
                    i = o.width, a = e.globals.axisCharts ? o.height + 5 : o.height;
                }
                return {
                    width: i,
                    height: a
                };
            }
        },
        {
            key: "getLegendsRect",
            value: function() {
                var t = this.w, e = t.globals.dom.elLegendWrap;
                t.config.legend.height || "top" !== t.config.legend.position && "bottom" !== t.config.legend.position || (e.style.maxHeight = t.globals.svgHeight / 2 + "px");
                var i = Object.assign({}, $fffa43d1c55f0813$var$x.getBoundingClientRect(e));
                return null !== e && !t.config.legend.floating && t.config.legend.show ? this.dCtx.lgRect = {
                    x: i.x,
                    y: i.y,
                    height: i.height,
                    width: 0 === i.height ? 0 : i.width
                } : this.dCtx.lgRect = {
                    x: 0,
                    y: 0,
                    height: 0,
                    width: 0
                }, "left" !== t.config.legend.position && "right" !== t.config.legend.position || 1.5 * this.dCtx.lgRect.width > t.globals.svgWidth && (this.dCtx.lgRect.width = t.globals.svgWidth / 1.5), this.dCtx.lgRect;
            }
        },
        {
            key: "getLargestStringFromMultiArr",
            value: function(t, e) {
                var i = t;
                if (this.w.globals.isMultiLineX) {
                    var a = e.map(function(t, e) {
                        return Array.isArray(t) ? t.length : 1;
                    }), s = Math.max.apply(Math, $fffa43d1c55f0813$var$u(a));
                    i = e[a.indexOf(s)];
                }
                return i;
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$at = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.w = e.w, this.dCtx = e;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "getxAxisLabelsCoords",
            value: function() {
                var t, e = this.w, i = e.globals.labels.slice();
                if (e.config.xaxis.convertedCatToNumeric && 0 === i.length && (i = e.globals.categoryLabels), e.globals.timescaleLabels.length > 0) {
                    var a = this.getxAxisTimeScaleLabelsCoords();
                    t = {
                        width: a.width,
                        height: a.height
                    }, e.globals.rotateXLabels = !1;
                } else {
                    this.dCtx.lgWidthForSideLegends = "left" !== e.config.legend.position && "right" !== e.config.legend.position || e.config.legend.floating ? 0 : this.dCtx.lgRect.width;
                    var s = e.globals.xLabelFormatter, r = $fffa43d1c55f0813$var$x.getLargestStringFromArr(i), o = this.dCtx.dimHelpers.getLargestStringFromMultiArr(r, i);
                    e.globals.isBarHorizontal && (o = r = e.globals.yAxisScale[0].result.reduce(function(t, e) {
                        return t.length > e.length ? t : e;
                    }, 0));
                    var n = new $fffa43d1c55f0813$var$T(this.dCtx.ctx), l = r;
                    r = n.xLabelFormat(s, r, l, {
                        i: void 0,
                        dateFormatter: new $fffa43d1c55f0813$var$I(this.dCtx.ctx).formatDate,
                        w: e
                    }), o = n.xLabelFormat(s, o, l, {
                        i: void 0,
                        dateFormatter: new $fffa43d1c55f0813$var$I(this.dCtx.ctx).formatDate,
                        w: e
                    }), (e.config.xaxis.convertedCatToNumeric && void 0 === r || "" === String(r).trim()) && (o = r = "1");
                    var h = new $fffa43d1c55f0813$var$m(this.dCtx.ctx), c = h.getTextRects(r, e.config.xaxis.labels.style.fontSize), d = c;
                    if (r !== o && (d = h.getTextRects(o, e.config.xaxis.labels.style.fontSize)), (t = {
                        width: c.width >= d.width ? c.width : d.width,
                        height: c.height >= d.height ? c.height : d.height
                    }).width * i.length > e.globals.svgWidth - this.dCtx.lgWidthForSideLegends - this.dCtx.yAxisWidth - this.dCtx.gridPad.left - this.dCtx.gridPad.right && 0 !== e.config.xaxis.labels.rotate || e.config.xaxis.labels.rotateAlways) {
                        if (!e.globals.isBarHorizontal) {
                            e.globals.rotateXLabels = !0;
                            var g = function(t) {
                                return h.getTextRects(t, e.config.xaxis.labels.style.fontSize, e.config.xaxis.labels.style.fontFamily, "rotate(".concat(e.config.xaxis.labels.rotate, " 0 0)"), !1);
                            };
                            c = g(r), r !== o && (d = g(o)), t.height = (c.height > d.height ? c.height : d.height) / 1.5, t.width = c.width > d.width ? c.width : d.width;
                        }
                    } else e.globals.rotateXLabels = !1;
                }
                return e.config.xaxis.labels.show || (t = {
                    width: 0,
                    height: 0
                }), {
                    width: t.width,
                    height: t.height
                };
            }
        },
        {
            key: "getxAxisGroupLabelsCoords",
            value: function() {
                var t, e = this.w;
                if (!e.globals.hasXaxisGroups) return {
                    width: 0,
                    height: 0
                };
                var i, a = (null === (t = e.config.xaxis.group.style) || void 0 === t ? void 0 : t.fontSize) || e.config.xaxis.labels.style.fontSize, s = e.globals.groups.map(function(t) {
                    return t.title;
                }), r = $fffa43d1c55f0813$var$x.getLargestStringFromArr(s), o = this.dCtx.dimHelpers.getLargestStringFromMultiArr(r, s), n = new $fffa43d1c55f0813$var$m(this.dCtx.ctx), l = n.getTextRects(r, a), h = l;
                return r !== o && (h = n.getTextRects(o, a)), i = {
                    width: l.width >= h.width ? l.width : h.width,
                    height: l.height >= h.height ? l.height : h.height
                }, e.config.xaxis.labels.show || (i = {
                    width: 0,
                    height: 0
                }), {
                    width: i.width,
                    height: i.height
                };
            }
        },
        {
            key: "getxAxisTitleCoords",
            value: function() {
                var t = this.w, e = 0, i = 0;
                if (void 0 !== t.config.xaxis.title.text) {
                    var a = new $fffa43d1c55f0813$var$m(this.dCtx.ctx).getTextRects(t.config.xaxis.title.text, t.config.xaxis.title.style.fontSize);
                    e = a.width, i = a.height;
                }
                return {
                    width: e,
                    height: i
                };
            }
        },
        {
            key: "getxAxisTimeScaleLabelsCoords",
            value: function() {
                var t, e = this.w;
                this.dCtx.timescaleLabels = e.globals.timescaleLabels.slice();
                var i = this.dCtx.timescaleLabels.map(function(t) {
                    return t.value;
                }), a = i.reduce(function(t, e) {
                    return void 0 === t ? (console.error("You have possibly supplied invalid Date format. Please supply a valid JavaScript Date"), 0) : t.length > e.length ? t : e;
                }, 0);
                return 1.05 * (t = new $fffa43d1c55f0813$var$m(this.dCtx.ctx).getTextRects(a, e.config.xaxis.labels.style.fontSize)).width * i.length > e.globals.gridWidth && 0 !== e.config.xaxis.labels.rotate && (e.globals.overlappingXLabels = !0), t;
            }
        },
        {
            key: "additionalPaddingXLabels",
            value: function(t) {
                var e = this, i = this.w, a = i.globals, s = i.config, r = s.xaxis.type, o = t.width;
                a.skipLastTimelinelabel = !1, a.skipFirstTimelinelabel = !1;
                var n = i.config.yaxis[0].opposite && i.globals.isBarHorizontal, l = function(t, n) {
                    s.yaxis.length > 1 && function(t) {
                        return -1 !== a.collapsedSeriesIndices.indexOf(t);
                    }(n) || function(t) {
                        if (e.dCtx.timescaleLabels && e.dCtx.timescaleLabels.length) {
                            var n = e.dCtx.timescaleLabels[0], l = e.dCtx.timescaleLabels[e.dCtx.timescaleLabels.length - 1].position + o / 1.75 - e.dCtx.yAxisWidthRight, h = n.position - o / 1.75 + e.dCtx.yAxisWidthLeft, c = "right" === i.config.legend.position && e.dCtx.lgRect.width > 0 ? e.dCtx.lgRect.width : 0;
                            l > a.svgWidth - a.translateX - c && (a.skipLastTimelinelabel = !0), h < -(t.show && !t.floating || "bar" !== s.chart.type && "candlestick" !== s.chart.type && "rangeBar" !== s.chart.type && "boxPlot" !== s.chart.type ? 10 : o / 1.75) && (a.skipFirstTimelinelabel = !0);
                        } else "datetime" === r ? e.dCtx.gridPad.right < o && !a.rotateXLabels && (a.skipLastTimelinelabel = !0) : "datetime" !== r && e.dCtx.gridPad.right < o / 2 - e.dCtx.yAxisWidthRight && !a.rotateXLabels && !i.config.xaxis.labels.trim && ("between" !== i.config.xaxis.tickPlacement || i.globals.isBarHorizontal) && (e.dCtx.xPadRight = o / 2 + 1);
                    }(t);
                };
                s.yaxis.forEach(function(t, i) {
                    n ? (e.dCtx.gridPad.left < o && (e.dCtx.xPadLeft = o / 2 + 1), e.dCtx.xPadRight = o / 2 + 1) : l(t, i);
                });
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$st = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.w = e.w, this.dCtx = e;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "getyAxisLabelsCoords",
            value: function() {
                var t = this, e = this.w, i = [], a = 10, s = new $fffa43d1c55f0813$var$B(this.dCtx.ctx);
                return e.config.yaxis.map(function(r, o) {
                    var n = {
                        seriesIndex: o,
                        dataPointIndex: -1,
                        w: e
                    }, l = e.globals.yAxisScale[o], h = 0;
                    if (!s.isYAxisHidden(o) && r.labels.show && void 0 !== r.labels.minWidth && (h = r.labels.minWidth), !s.isYAxisHidden(o) && r.labels.show && l.result.length) {
                        var c = e.globals.yLabelFormatters[o], d = l.niceMin === Number.MIN_VALUE ? 0 : l.niceMin, g = l.result.reduce(function(t, e) {
                            var i, a;
                            return (null === (i = String(c(t, n))) || void 0 === i ? void 0 : i.length) > (null === (a = String(c(e, n))) || void 0 === a ? void 0 : a.length) ? t : e;
                        }, d), u = g = c(g, n);
                        if (void 0 !== g && 0 !== g.length || (g = l.niceMax), e.globals.isBarHorizontal) {
                            a = 0;
                            var p = e.globals.labels.slice();
                            g = $fffa43d1c55f0813$var$x.getLargestStringFromArr(p), g = c(g, {
                                seriesIndex: o,
                                dataPointIndex: -1,
                                w: e
                            }), u = t.dCtx.dimHelpers.getLargestStringFromMultiArr(g, p);
                        }
                        var f = new $fffa43d1c55f0813$var$m(t.dCtx.ctx), b = "rotate(".concat(r.labels.rotate, " 0 0)"), v = f.getTextRects(g, r.labels.style.fontSize, r.labels.style.fontFamily, b, !1), y = v;
                        g !== u && (y = f.getTextRects(u, r.labels.style.fontSize, r.labels.style.fontFamily, b, !1)), i.push({
                            width: (h > y.width || h > v.width ? h : y.width > v.width ? y.width : v.width) + a,
                            height: y.height > v.height ? y.height : v.height
                        });
                    } else i.push({
                        width: 0,
                        height: 0
                    });
                }), i;
            }
        },
        {
            key: "getyAxisTitleCoords",
            value: function() {
                var t = this, e = this.w, i = [];
                return e.config.yaxis.map(function(e, a) {
                    if (e.show && void 0 !== e.title.text) {
                        var s = new $fffa43d1c55f0813$var$m(t.dCtx.ctx), r = "rotate(".concat(e.title.rotate, " 0 0)"), o = s.getTextRects(e.title.text, e.title.style.fontSize, e.title.style.fontFamily, r, !1);
                        i.push({
                            width: o.width,
                            height: o.height
                        });
                    } else i.push({
                        width: 0,
                        height: 0
                    });
                }), i;
            }
        },
        {
            key: "getTotalYAxisWidth",
            value: function() {
                var t = this.w, e = 0, i = 0, a = 0, s = t.globals.yAxisScale.length > 1 ? 10 : 0, r = new $fffa43d1c55f0813$var$B(this.dCtx.ctx), o = function(o, n) {
                    var l = t.config.yaxis[n].floating, h = 0;
                    o.width > 0 && !l ? (h = o.width + s, function(e) {
                        return t.globals.ignoreYAxisIndexes.indexOf(e) > -1;
                    }(n) && (h = h - o.width - s)) : h = l || r.isYAxisHidden(n) ? 0 : 5, t.config.yaxis[n].opposite ? a += h : i += h, e += h;
                };
                return t.globals.yLabelsCoords.map(function(t, e) {
                    o(t, e);
                }), t.globals.yTitleCoords.map(function(t, e) {
                    o(t, e);
                }), t.globals.isBarHorizontal && !t.config.yaxis[0].floating && (e = t.globals.yLabelsCoords[0].width + t.globals.yTitleCoords[0].width + 15), this.dCtx.yAxisWidthLeft = i, this.dCtx.yAxisWidthRight = a, e;
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$rt = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.w = e.w, this.dCtx = e;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "gridPadForColumnsInNumericAxis",
            value: function(t) {
                var e = this.w;
                if (e.globals.noData || e.globals.allSeriesCollapsed) return 0;
                var i = function(t) {
                    return "bar" === t || "rangeBar" === t || "candlestick" === t || "boxPlot" === t;
                }, a = e.config.chart.type, s = 0, r = i(a) ? e.config.series.length : 1;
                if (e.globals.comboBarCount > 0 && (r = e.globals.comboBarCount), e.globals.collapsedSeries.forEach(function(t) {
                    i(t.type) && (r -= 1);
                }), e.config.chart.stacked && (r = 1), (i(a) || e.globals.comboBarCount > 0) && e.globals.isXNumeric && !e.globals.isBarHorizontal && r > 0) {
                    var o, n, l = Math.abs(e.globals.initialMaxX - e.globals.initialMinX);
                    l <= 3 && (l = e.globals.dataPoints), o = l / t, e.globals.minXDiff && e.globals.minXDiff / o > 0 && (n = e.globals.minXDiff / o), n > t / 2 && (n /= 2), (s = n / r * parseInt(e.config.plotOptions.bar.columnWidth, 10) / 100) < 1 && (s = 1), s = s / (r > 1 ? 1 : 1.5) + 5, e.globals.barPadForNumericAxis = s;
                }
                return s;
            }
        },
        {
            key: "gridPadFortitleSubtitle",
            value: function() {
                var t = this, e = this.w, i = e.globals, a = this.dCtx.isSparkline || !e.globals.axisCharts ? 0 : 10;
                [
                    "title",
                    "subtitle"
                ].forEach(function(i) {
                    void 0 !== e.config[i].text ? a += e.config[i].margin : a += t.dCtx.isSparkline || !e.globals.axisCharts ? 0 : 5;
                }), !e.config.legend.show || "bottom" !== e.config.legend.position || e.config.legend.floating || e.globals.axisCharts || (a += 10);
                var s = this.dCtx.dimHelpers.getTitleSubtitleCoords("title"), r = this.dCtx.dimHelpers.getTitleSubtitleCoords("subtitle");
                i.gridHeight = i.gridHeight - s.height - r.height - a, i.translateY = i.translateY + s.height + r.height + a;
            }
        },
        {
            key: "setGridXPosForDualYAxis",
            value: function(t, e) {
                var i = this.w, a = new $fffa43d1c55f0813$var$B(this.dCtx.ctx);
                i.config.yaxis.map(function(s, r) {
                    -1 !== i.globals.ignoreYAxisIndexes.indexOf(r) || s.floating || a.isYAxisHidden(r) || (s.opposite && (i.globals.translateX = i.globals.translateX - (e[r].width + t[r].width) - parseInt(i.config.yaxis[r].labels.style.fontSize, 10) / 1.2 - 12), i.globals.translateX < 2 && (i.globals.translateX = 2));
                });
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$ot = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w, this.lgRect = {}, this.yAxisWidth = 0, this.yAxisWidthLeft = 0, this.yAxisWidthRight = 0, this.xAxisHeight = 0, this.isSparkline = this.w.config.chart.sparkline.enabled, this.dimHelpers = new $fffa43d1c55f0813$var$it(this), this.dimYAxis = new $fffa43d1c55f0813$var$st(this), this.dimXAxis = new $fffa43d1c55f0813$var$at(this), this.dimGrid = new $fffa43d1c55f0813$var$rt(this), this.lgWidthForSideLegends = 0, this.gridPad = this.w.config.grid.padding, this.xPadRight = 0, this.xPadLeft = 0;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "plotCoords",
            value: function() {
                var t = this, e = this.w, i = e.globals;
                this.lgRect = this.dimHelpers.getLegendsRect(), this.isSparkline && ((e.config.markers.discrete.length > 0 || e.config.markers.size > 0) && Object.entries(this.gridPad).forEach(function(e) {
                    var i = $fffa43d1c55f0813$var$g(e, 2), a = i[0], s = i[1];
                    t.gridPad[a] = Math.max(s, t.w.globals.markers.largestSize / 1.5);
                }), this.gridPad.top = Math.max(e.config.stroke.width / 2, this.gridPad.top), this.gridPad.bottom = Math.max(e.config.stroke.width / 2, this.gridPad.bottom)), i.axisCharts ? this.setDimensionsForAxisCharts() : this.setDimensionsForNonAxisCharts(), this.dimGrid.gridPadFortitleSubtitle(), i.gridHeight = i.gridHeight - this.gridPad.top - this.gridPad.bottom, i.gridWidth = i.gridWidth - this.gridPad.left - this.gridPad.right - this.xPadRight - this.xPadLeft;
                var a = this.dimGrid.gridPadForColumnsInNumericAxis(i.gridWidth);
                i.gridWidth = i.gridWidth - 2 * a, i.translateX = i.translateX + this.gridPad.left + this.xPadLeft + (a > 0 ? a + 4 : 0), i.translateY = i.translateY + this.gridPad.top;
            }
        },
        {
            key: "setDimensionsForAxisCharts",
            value: function() {
                var t = this, e = this.w, i = e.globals, a = this.dimYAxis.getyAxisLabelsCoords(), s = this.dimYAxis.getyAxisTitleCoords();
                e.globals.yLabelsCoords = [], e.globals.yTitleCoords = [], e.config.yaxis.map(function(t, i) {
                    e.globals.yLabelsCoords.push({
                        width: a[i].width,
                        index: i
                    }), e.globals.yTitleCoords.push({
                        width: s[i].width,
                        index: i
                    });
                }), this.yAxisWidth = this.dimYAxis.getTotalYAxisWidth();
                var r = this.dimXAxis.getxAxisLabelsCoords(), o = this.dimXAxis.getxAxisGroupLabelsCoords(), n = this.dimXAxis.getxAxisTitleCoords();
                this.conditionalChecksForAxisCoords(r, n, o), i.translateXAxisY = e.globals.rotateXLabels ? this.xAxisHeight / 8 : -4, i.translateXAxisX = e.globals.rotateXLabels && e.globals.isXNumeric && e.config.xaxis.labels.rotate <= -45 ? -this.xAxisWidth / 4 : 0, e.globals.isBarHorizontal && (i.rotateXLabels = !1, i.translateXAxisY = parseInt(e.config.xaxis.labels.style.fontSize, 10) / 1.5 * -1), i.translateXAxisY = i.translateXAxisY + e.config.xaxis.labels.offsetY, i.translateXAxisX = i.translateXAxisX + e.config.xaxis.labels.offsetX;
                var l = this.yAxisWidth, h = this.xAxisHeight;
                i.xAxisLabelsHeight = this.xAxisHeight - n.height, i.xAxisGroupLabelsHeight = i.xAxisLabelsHeight - r.height, i.xAxisLabelsWidth = this.xAxisWidth, i.xAxisHeight = this.xAxisHeight;
                var c = 10;
                ("radar" === e.config.chart.type || this.isSparkline) && (l = 0, h = i.goldenPadding), this.isSparkline && (this.lgRect = {
                    height: 0,
                    width: 0
                }), (this.isSparkline || "treemap" === e.config.chart.type) && (l = 0, h = 0, c = 0), this.isSparkline || this.dimXAxis.additionalPaddingXLabels(r);
                var d = function() {
                    i.translateX = l, i.gridHeight = i.svgHeight - t.lgRect.height - h - (t.isSparkline || "treemap" === e.config.chart.type ? 0 : e.globals.rotateXLabels ? 10 : 15), i.gridWidth = i.svgWidth - l;
                };
                switch("top" === e.config.xaxis.position && (c = i.xAxisHeight - e.config.xaxis.axisTicks.height - 5), e.config.legend.position){
                    case "bottom":
                        i.translateY = c, d();
                        break;
                    case "top":
                        i.translateY = this.lgRect.height + c, d();
                        break;
                    case "left":
                        i.translateY = c, i.translateX = this.lgRect.width + l, i.gridHeight = i.svgHeight - h - 12, i.gridWidth = i.svgWidth - this.lgRect.width - l;
                        break;
                    case "right":
                        i.translateY = c, i.translateX = l, i.gridHeight = i.svgHeight - h - 12, i.gridWidth = i.svgWidth - this.lgRect.width - l - 5;
                        break;
                    default:
                        throw new Error("Legend position not supported");
                }
                this.dimGrid.setGridXPosForDualYAxis(s, a), new $fffa43d1c55f0813$var$q(this.ctx).setYAxisXPosition(a, s);
            }
        },
        {
            key: "setDimensionsForNonAxisCharts",
            value: function() {
                var t = this.w, e = t.globals, i = t.config, a = 0;
                t.config.legend.show && !t.config.legend.floating && (a = 20);
                var s = "pie" === i.chart.type || "polarArea" === i.chart.type || "donut" === i.chart.type ? "pie" : "radialBar", r = i.plotOptions[s].offsetY, o = i.plotOptions[s].offsetX;
                if (!i.legend.show || i.legend.floating) return e.gridHeight = e.svgHeight - i.grid.padding.left + i.grid.padding.right, e.gridWidth = e.gridHeight, e.translateY = r, void (e.translateX = o + (e.svgWidth - e.gridWidth) / 2);
                switch(i.legend.position){
                    case "bottom":
                        e.gridHeight = e.svgHeight - this.lgRect.height - e.goldenPadding, e.gridWidth = e.svgWidth, e.translateY = r - 10, e.translateX = o + (e.svgWidth - e.gridWidth) / 2;
                        break;
                    case "top":
                        e.gridHeight = e.svgHeight - this.lgRect.height - e.goldenPadding, e.gridWidth = e.svgWidth, e.translateY = this.lgRect.height + r + 10, e.translateX = o + (e.svgWidth - e.gridWidth) / 2;
                        break;
                    case "left":
                        e.gridWidth = e.svgWidth - this.lgRect.width - a, e.gridHeight = "auto" !== i.chart.height ? e.svgHeight : e.gridWidth, e.translateY = r, e.translateX = o + this.lgRect.width + a;
                        break;
                    case "right":
                        e.gridWidth = e.svgWidth - this.lgRect.width - a - 5, e.gridHeight = "auto" !== i.chart.height ? e.svgHeight : e.gridWidth, e.translateY = r, e.translateX = o + 10;
                        break;
                    default:
                        throw new Error("Legend position not supported");
                }
            }
        },
        {
            key: "conditionalChecksForAxisCoords",
            value: function(t, e, i) {
                var a = this.w, s = a.globals.hasXaxisGroups ? 2 : 1, r = i.height + t.height + e.height, o = a.globals.isMultiLineX ? 1.2 : a.globals.LINE_HEIGHT_RATIO, n = a.globals.rotateXLabels ? 22 : 10, l = a.globals.rotateXLabels && "bottom" === a.config.legend.position ? 10 : 0;
                this.xAxisHeight = r * o + s * n + l, this.xAxisWidth = t.width, this.xAxisHeight - e.height > a.config.xaxis.labels.maxHeight && (this.xAxisHeight = a.config.xaxis.labels.maxHeight), a.config.xaxis.labels.minHeight && this.xAxisHeight < a.config.xaxis.labels.minHeight && (this.xAxisHeight = a.config.xaxis.labels.minHeight), a.config.xaxis.floating && (this.xAxisHeight = 0);
                var h = 0, c = 0;
                a.config.yaxis.forEach(function(t) {
                    h += t.labels.minWidth, c += t.labels.maxWidth;
                }), this.yAxisWidth < h && (this.yAxisWidth = h), this.yAxisWidth > c && (this.yAxisWidth = c);
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$nt = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.w = e.w, this.lgCtx = e;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "getLegendStyles",
            value: function() {
                var t, e, i, a = document.createElement("style");
                a.setAttribute("type", "text/css");
                var s = (null === (t = this.lgCtx.ctx) || void 0 === t || null === (e = t.opts) || void 0 === e || null === (i = e.chart) || void 0 === i ? void 0 : i.nonce) || this.w.config.chart.nonce;
                s && a.setAttribute("nonce", s);
                var r = document.createTextNode("\t\n    \t\n      .apexcharts-legend {\t\n        display: flex;\t\n        overflow: auto;\t\n        padding: 0 10px;\t\n      }\t\n      .apexcharts-legend.apx-legend-position-bottom, .apexcharts-legend.apx-legend-position-top {\t\n        flex-wrap: wrap\t\n      }\t\n      .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {\t\n        flex-direction: column;\t\n        bottom: 0;\t\n      }\t\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-left, .apexcharts-legend.apx-legend-position-top.apexcharts-align-left, .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {\t\n        justify-content: flex-start;\t\n      }\t\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-center, .apexcharts-legend.apx-legend-position-top.apexcharts-align-center {\t\n        justify-content: center;  \t\n      }\t\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-right, .apexcharts-legend.apx-legend-position-top.apexcharts-align-right {\t\n        justify-content: flex-end;\t\n      }\t\n      .apexcharts-legend-series {\t\n        cursor: pointer;\t\n        line-height: normal;\t\n      }\t\n      .apexcharts-legend.apx-legend-position-bottom .apexcharts-legend-series, .apexcharts-legend.apx-legend-position-top .apexcharts-legend-series{\t\n        display: flex;\t\n        align-items: center;\t\n      }\t\n      .apexcharts-legend-text {\t\n        position: relative;\t\n        font-size: 14px;\t\n      }\t\n      .apexcharts-legend-text *, .apexcharts-legend-marker * {\t\n        pointer-events: none;\t\n      }\t\n      .apexcharts-legend-marker {\t\n        position: relative;\t\n        display: inline-block;\t\n        cursor: pointer;\t\n        margin-right: 3px;\t\n        border-style: solid;\n      }\t\n      \t\n      .apexcharts-legend.apexcharts-align-right .apexcharts-legend-series, .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series{\t\n        display: inline-block;\t\n      }\t\n      .apexcharts-legend-series.apexcharts-no-click {\t\n        cursor: auto;\t\n      }\t\n      .apexcharts-legend .apexcharts-hidden-zero-series, .apexcharts-legend .apexcharts-hidden-null-series {\t\n        display: none !important;\t\n      }\t\n      .apexcharts-inactive-legend {\t\n        opacity: 0.45;\t\n      }");
                return a.appendChild(r), a;
            }
        },
        {
            key: "getLegendBBox",
            value: function() {
                var t = this.w.globals.dom.baseEl.querySelector(".apexcharts-legend").getBoundingClientRect(), e = t.width;
                return {
                    clwh: t.height,
                    clww: e
                };
            }
        },
        {
            key: "appendToForeignObject",
            value: function() {
                this.w.globals.dom.elLegendForeign.appendChild(this.getLegendStyles());
            }
        },
        {
            key: "toggleDataSeries",
            value: function(t, e) {
                var i = this, a = this.w;
                if (a.globals.axisCharts || "radialBar" === a.config.chart.type) {
                    a.globals.resized = !0;
                    var s = null, r = null;
                    if (a.globals.risingSeries = [], a.globals.axisCharts ? (s = a.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(t, "']")), r = parseInt(s.getAttribute("data:realIndex"), 10)) : (s = a.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(t + 1, "']")), r = parseInt(s.getAttribute("rel"), 10) - 1), e) [
                        {
                            cs: a.globals.collapsedSeries,
                            csi: a.globals.collapsedSeriesIndices
                        },
                        {
                            cs: a.globals.ancillaryCollapsedSeries,
                            csi: a.globals.ancillaryCollapsedSeriesIndices
                        }
                    ].forEach(function(t) {
                        i.riseCollapsedSeries(t.cs, t.csi, r);
                    });
                    else this.hideSeries({
                        seriesEl: s,
                        realIndex: r
                    });
                } else {
                    var o = a.globals.dom.Paper.select(" .apexcharts-series[rel='".concat(t + 1, "'] path")), n = a.config.chart.type;
                    if ("pie" === n || "polarArea" === n || "donut" === n) {
                        var l = a.config.plotOptions.pie.donut.labels;
                        new $fffa43d1c55f0813$var$m(this.lgCtx.ctx).pathMouseDown(o.members[0], null), this.lgCtx.ctx.pie.printDataLabelsInner(o.members[0].node, l);
                    }
                    o.fire("click");
                }
            }
        },
        {
            key: "hideSeries",
            value: function(t) {
                var e = t.seriesEl, i = t.realIndex, a = this.w, s = $fffa43d1c55f0813$var$x.clone(a.config.series);
                if (a.globals.axisCharts) {
                    var r = !1;
                    if (a.config.yaxis[i] && a.config.yaxis[i].show && a.config.yaxis[i].showAlways && (r = !0, a.globals.ancillaryCollapsedSeriesIndices.indexOf(i) < 0 && (a.globals.ancillaryCollapsedSeries.push({
                        index: i,
                        data: s[i].data.slice(),
                        type: e.parentNode.className.baseVal.split("-")[1]
                    }), a.globals.ancillaryCollapsedSeriesIndices.push(i))), !r) {
                        a.globals.collapsedSeries.push({
                            index: i,
                            data: s[i].data.slice(),
                            type: e.parentNode.className.baseVal.split("-")[1]
                        }), a.globals.collapsedSeriesIndices.push(i);
                        var o = a.globals.risingSeries.indexOf(i);
                        a.globals.risingSeries.splice(o, 1);
                    }
                } else a.globals.collapsedSeries.push({
                    index: i,
                    data: s[i]
                }), a.globals.collapsedSeriesIndices.push(i);
                for(var n = e.childNodes, l = 0; l < n.length; l++)n[l].classList.contains("apexcharts-series-markers-wrap") && (n[l].classList.contains("apexcharts-hide") ? n[l].classList.remove("apexcharts-hide") : n[l].classList.add("apexcharts-hide"));
                a.globals.allSeriesCollapsed = a.globals.collapsedSeries.length === a.config.series.length, s = this._getSeriesBasedOnCollapsedState(s), this.lgCtx.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled);
            }
        },
        {
            key: "riseCollapsedSeries",
            value: function(t, e, i) {
                var a = this.w, s = $fffa43d1c55f0813$var$x.clone(a.config.series);
                if (t.length > 0) {
                    for(var r = 0; r < t.length; r++)t[r].index === i && (a.globals.axisCharts ? (s[i].data = t[r].data.slice(), t.splice(r, 1), e.splice(r, 1), a.globals.risingSeries.push(i)) : (s[i] = t[r].data, t.splice(r, 1), e.splice(r, 1), a.globals.risingSeries.push(i)));
                    s = this._getSeriesBasedOnCollapsedState(s), this.lgCtx.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled);
                }
            }
        },
        {
            key: "_getSeriesBasedOnCollapsedState",
            value: function(t) {
                var e = this.w;
                return e.globals.axisCharts ? t.forEach(function(i, a) {
                    e.globals.collapsedSeriesIndices.indexOf(a) > -1 && (t[a].data = []);
                }) : t.forEach(function(i, a) {
                    e.globals.collapsedSeriesIndices.indexOf(a) > -1 && (t[a] = 0);
                }), t;
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$lt = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w, this.onLegendClick = this.onLegendClick.bind(this), this.onLegendHovered = this.onLegendHovered.bind(this), this.isBarsDistributed = "bar" === this.w.config.chart.type && this.w.config.plotOptions.bar.distributed && 1 === this.w.config.series.length, this.legendHelpers = new $fffa43d1c55f0813$var$nt(this);
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "init",
            value: function() {
                var t = this.w, e = t.globals, i = t.config;
                if ((i.legend.showForSingleSeries && 1 === e.series.length || this.isBarsDistributed || e.series.length > 1 || !e.axisCharts) && i.legend.show) {
                    for(; e.dom.elLegendWrap.firstChild;)e.dom.elLegendWrap.removeChild(e.dom.elLegendWrap.firstChild);
                    this.drawLegends(), $fffa43d1c55f0813$var$x.isIE11() ? document.getElementsByTagName("head")[0].appendChild(this.legendHelpers.getLegendStyles()) : this.legendHelpers.appendToForeignObject(), "bottom" === i.legend.position || "top" === i.legend.position ? this.legendAlignHorizontal() : "right" !== i.legend.position && "left" !== i.legend.position || this.legendAlignVertical();
                }
            }
        },
        {
            key: "drawLegends",
            value: function() {
                var t = this, e = this.w, i = e.config.legend.fontFamily, a = e.globals.seriesNames, s = e.globals.colors.slice();
                if ("heatmap" === e.config.chart.type) {
                    var r = e.config.plotOptions.heatmap.colorScale.ranges;
                    a = r.map(function(t) {
                        return t.name ? t.name : t.from + " - " + t.to;
                    }), s = r.map(function(t) {
                        return t.color;
                    });
                } else this.isBarsDistributed && (a = e.globals.labels.slice());
                e.config.legend.customLegendItems.length && (a = e.config.legend.customLegendItems);
                for(var o = e.globals.legendFormatter, n = e.config.legend.inverseOrder, l = n ? a.length - 1 : 0; n ? l >= 0 : l <= a.length - 1; n ? l-- : l++){
                    var h, c = o(a[l], {
                        seriesIndex: l,
                        w: e
                    }), d = !1, g = !1;
                    if (e.globals.collapsedSeries.length > 0) for(var u = 0; u < e.globals.collapsedSeries.length; u++)e.globals.collapsedSeries[u].index === l && (d = !0);
                    if (e.globals.ancillaryCollapsedSeriesIndices.length > 0) for(var p = 0; p < e.globals.ancillaryCollapsedSeriesIndices.length; p++)e.globals.ancillaryCollapsedSeriesIndices[p] === l && (g = !0);
                    var f = document.createElement("span");
                    f.classList.add("apexcharts-legend-marker");
                    var b = e.config.legend.markers.offsetX, v = e.config.legend.markers.offsetY, w = e.config.legend.markers.height, k = e.config.legend.markers.width, A = e.config.legend.markers.strokeWidth, S = e.config.legend.markers.strokeColor, C = e.config.legend.markers.radius, L = f.style;
                    L.background = s[l], L.color = s[l], L.setProperty("background", s[l], "important"), e.config.legend.markers.fillColors && e.config.legend.markers.fillColors[l] && (L.background = e.config.legend.markers.fillColors[l]), void 0 !== e.globals.seriesColors[l] && (L.background = e.globals.seriesColors[l], L.color = e.globals.seriesColors[l]), L.height = Array.isArray(w) ? parseFloat(w[l]) + "px" : parseFloat(w) + "px", L.width = Array.isArray(k) ? parseFloat(k[l]) + "px" : parseFloat(k) + "px", L.left = (Array.isArray(b) ? parseFloat(b[l]) : parseFloat(b)) + "px", L.top = (Array.isArray(v) ? parseFloat(v[l]) : parseFloat(v)) + "px", L.borderWidth = Array.isArray(A) ? A[l] : A, L.borderColor = Array.isArray(S) ? S[l] : S, L.borderRadius = Array.isArray(C) ? parseFloat(C[l]) + "px" : parseFloat(C) + "px", e.config.legend.markers.customHTML && (Array.isArray(e.config.legend.markers.customHTML) ? e.config.legend.markers.customHTML[l] && (f.innerHTML = e.config.legend.markers.customHTML[l]()) : f.innerHTML = e.config.legend.markers.customHTML()), $fffa43d1c55f0813$var$m.setAttrs(f, {
                        rel: l + 1,
                        "data:collapsed": d || g
                    }), (d || g) && f.classList.add("apexcharts-inactive-legend");
                    var P = document.createElement("div"), I = document.createElement("span");
                    I.classList.add("apexcharts-legend-text"), I.innerHTML = Array.isArray(c) ? c.join(" ") : c;
                    var T = e.config.legend.labels.useSeriesColors ? e.globals.colors[l] : Array.isArray(e.config.legend.labels.colors) ? null === (h = e.config.legend.labels.colors) || void 0 === h ? void 0 : h[l] : e.config.legend.labels.colors;
                    T || (T = e.config.chart.foreColor), I.style.color = T, I.style.fontSize = parseFloat(e.config.legend.fontSize) + "px", I.style.fontWeight = e.config.legend.fontWeight, I.style.fontFamily = i || e.config.chart.fontFamily, $fffa43d1c55f0813$var$m.setAttrs(I, {
                        rel: l + 1,
                        i: l,
                        "data:default-text": encodeURIComponent(c),
                        "data:collapsed": d || g
                    }), P.appendChild(f), P.appendChild(I);
                    var M = new $fffa43d1c55f0813$var$y(this.ctx);
                    if (!e.config.legend.showForZeroSeries) 0 === M.getSeriesTotalByIndex(l) && M.seriesHaveSameValues(l) && !M.isSeriesNull(l) && -1 === e.globals.collapsedSeriesIndices.indexOf(l) && -1 === e.globals.ancillaryCollapsedSeriesIndices.indexOf(l) && P.classList.add("apexcharts-hidden-zero-series");
                    e.config.legend.showForNullSeries || M.isSeriesNull(l) && -1 === e.globals.collapsedSeriesIndices.indexOf(l) && -1 === e.globals.ancillaryCollapsedSeriesIndices.indexOf(l) && P.classList.add("apexcharts-hidden-null-series"), e.globals.dom.elLegendWrap.appendChild(P), e.globals.dom.elLegendWrap.classList.add("apexcharts-align-".concat(e.config.legend.horizontalAlign)), e.globals.dom.elLegendWrap.classList.add("apx-legend-position-" + e.config.legend.position), P.classList.add("apexcharts-legend-series"), P.style.margin = "".concat(e.config.legend.itemMargin.vertical, "px ").concat(e.config.legend.itemMargin.horizontal, "px"), e.globals.dom.elLegendWrap.style.width = e.config.legend.width ? e.config.legend.width + "px" : "", e.globals.dom.elLegendWrap.style.height = e.config.legend.height ? e.config.legend.height + "px" : "", $fffa43d1c55f0813$var$m.setAttrs(P, {
                        rel: l + 1,
                        seriesName: $fffa43d1c55f0813$var$x.escapeString(a[l]),
                        "data:collapsed": d || g
                    }), (d || g) && P.classList.add("apexcharts-inactive-legend"), e.config.legend.onItemClick.toggleDataSeries || P.classList.add("apexcharts-no-click");
                }
                e.globals.dom.elWrap.addEventListener("click", t.onLegendClick, !0), e.config.legend.onItemHover.highlightDataSeries && 0 === e.config.legend.customLegendItems.length && (e.globals.dom.elWrap.addEventListener("mousemove", t.onLegendHovered, !0), e.globals.dom.elWrap.addEventListener("mouseout", t.onLegendHovered, !0));
            }
        },
        {
            key: "setLegendWrapXY",
            value: function(t, e) {
                var i = this.w, a = i.globals.dom.elLegendWrap, s = a.getBoundingClientRect(), r = 0, o = 0;
                if ("bottom" === i.config.legend.position) o += i.globals.svgHeight - s.height / 2;
                else if ("top" === i.config.legend.position) {
                    var n = new $fffa43d1c55f0813$var$ot(this.ctx), l = n.dimHelpers.getTitleSubtitleCoords("title").height, h = n.dimHelpers.getTitleSubtitleCoords("subtitle").height;
                    o = o + (l > 0 ? l - 10 : 0) + (h > 0 ? h - 10 : 0);
                }
                a.style.position = "absolute", r = r + t + i.config.legend.offsetX, o = o + e + i.config.legend.offsetY, a.style.left = r + "px", a.style.top = o + "px", "bottom" === i.config.legend.position ? (a.style.top = "auto", a.style.bottom = 5 - i.config.legend.offsetY + "px") : "right" === i.config.legend.position && (a.style.left = "auto", a.style.right = 25 + i.config.legend.offsetX + "px");
                [
                    "width",
                    "height"
                ].forEach(function(t) {
                    a.style[t] && (a.style[t] = parseInt(i.config.legend[t], 10) + "px");
                });
            }
        },
        {
            key: "legendAlignHorizontal",
            value: function() {
                var t = this.w;
                t.globals.dom.elLegendWrap.style.right = 0;
                var e = this.legendHelpers.getLegendBBox(), i = new $fffa43d1c55f0813$var$ot(this.ctx), a = i.dimHelpers.getTitleSubtitleCoords("title"), s = i.dimHelpers.getTitleSubtitleCoords("subtitle"), r = 0;
                "bottom" === t.config.legend.position ? r = -e.clwh / 1.8 : "top" === t.config.legend.position && (r = a.height + s.height + t.config.title.margin + t.config.subtitle.margin - 10), this.setLegendWrapXY(20, r);
            }
        },
        {
            key: "legendAlignVertical",
            value: function() {
                var t = this.w, e = this.legendHelpers.getLegendBBox(), i = 0;
                "left" === t.config.legend.position && (i = 20), "right" === t.config.legend.position && (i = t.globals.svgWidth - e.clww - 10), this.setLegendWrapXY(i, 20);
            }
        },
        {
            key: "onLegendHovered",
            value: function(t) {
                var e = this.w, i = t.target.classList.contains("apexcharts-legend-series") || t.target.classList.contains("apexcharts-legend-text") || t.target.classList.contains("apexcharts-legend-marker");
                if ("heatmap" === e.config.chart.type || this.isBarsDistributed) {
                    if (i) {
                        var a = parseInt(t.target.getAttribute("rel"), 10) - 1;
                        this.ctx.events.fireEvent("legendHover", [
                            this.ctx,
                            a,
                            this.w
                        ]), new $fffa43d1c55f0813$var$N(this.ctx).highlightRangeInSeries(t, t.target);
                    }
                } else !t.target.classList.contains("apexcharts-inactive-legend") && i && new $fffa43d1c55f0813$var$N(this.ctx).toggleSeriesOnHover(t, t.target);
            }
        },
        {
            key: "onLegendClick",
            value: function(t) {
                var e = this.w;
                if (!e.config.legend.customLegendItems.length && (t.target.classList.contains("apexcharts-legend-series") || t.target.classList.contains("apexcharts-legend-text") || t.target.classList.contains("apexcharts-legend-marker"))) {
                    var i = parseInt(t.target.getAttribute("rel"), 10) - 1, a = "true" === t.target.getAttribute("data:collapsed"), s = this.w.config.chart.events.legendClick;
                    "function" == typeof s && s(this.ctx, i, this.w), this.ctx.events.fireEvent("legendClick", [
                        this.ctx,
                        i,
                        this.w
                    ]);
                    var r = this.w.config.legend.markers.onClick;
                    "function" == typeof r && t.target.classList.contains("apexcharts-legend-marker") && (r(this.ctx, i, this.w), this.ctx.events.fireEvent("legendMarkerClick", [
                        this.ctx,
                        i,
                        this.w
                    ])), "treemap" !== e.config.chart.type && "heatmap" !== e.config.chart.type && !this.isBarsDistributed && e.config.legend.onItemClick.toggleDataSeries && this.legendHelpers.toggleDataSeries(i, a);
                }
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$ht = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w;
        var i = this.w;
        this.ev = this.w.config.chart.events, this.selectedClass = "apexcharts-selected", this.localeValues = this.w.globals.locale.toolbar, this.minX = i.globals.minX, this.maxX = i.globals.maxX;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "createToolbar",
            value: function() {
                var t = this, e = this.w, i = function() {
                    return document.createElement("div");
                }, a = i();
                if (a.setAttribute("class", "apexcharts-toolbar"), a.style.top = e.config.chart.toolbar.offsetY + "px", a.style.right = 3 - e.config.chart.toolbar.offsetX + "px", e.globals.dom.elWrap.appendChild(a), this.elZoom = i(), this.elZoomIn = i(), this.elZoomOut = i(), this.elPan = i(), this.elSelection = i(), this.elZoomReset = i(), this.elMenuIcon = i(), this.elMenu = i(), this.elCustomIcons = [], this.t = e.config.chart.toolbar.tools, Array.isArray(this.t.customIcons)) for(var s = 0; s < this.t.customIcons.length; s++)this.elCustomIcons.push(i());
                var r = [], o = function(i, a, s) {
                    var o = i.toLowerCase();
                    t.t[o] && e.config.chart.zoom.enabled && r.push({
                        el: a,
                        icon: "string" == typeof t.t[o] ? t.t[o] : s,
                        title: t.localeValues[i],
                        class: "apexcharts-".concat(o, "-icon")
                    });
                };
                o("zoomIn", this.elZoomIn, '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>\n</svg>\n'), o("zoomOut", this.elZoomOut, '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>\n</svg>\n');
                var n = function(i) {
                    t.t[i] && e.config.chart[i].enabled && r.push({
                        el: "zoom" === i ? t.elZoom : t.elSelection,
                        icon: "string" == typeof t.t[i] ? t.t[i] : "zoom" === i ? '<svg xmlns="http://www.w3.org/2000/svg" fill="#000000" height="24" viewBox="0 0 24 24" width="24">\n    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>\n    <path d="M0 0h24v24H0V0z" fill="none"/>\n    <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"/>\n</svg>' : '<svg fill="#6E8192" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2z"/>\n</svg>',
                        title: t.localeValues["zoom" === i ? "selectionZoom" : "selection"],
                        class: e.globals.isTouchDevice ? "apexcharts-element-hidden" : "apexcharts-".concat(i, "-icon")
                    });
                };
                n("zoom"), n("selection"), this.t.pan && e.config.chart.zoom.enabled && r.push({
                    el: this.elPan,
                    icon: "string" == typeof this.t.pan ? this.t.pan : '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="24" viewBox="0 0 24 24" width="24">\n    <defs>\n        <path d="M0 0h24v24H0z" id="a"/>\n    </defs>\n    <clipPath id="b">\n        <use overflow="visible" xlink:href="#a"/>\n    </clipPath>\n    <path clip-path="url(#b)" d="M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z"/>\n</svg>',
                    title: this.localeValues.pan,
                    class: e.globals.isTouchDevice ? "apexcharts-element-hidden" : "apexcharts-pan-icon"
                }), o("reset", this.elZoomReset, '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'), this.t.download && r.push({
                    el: this.elMenuIcon,
                    icon: "string" == typeof this.t.download ? this.t.download : '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>',
                    title: this.localeValues.menu,
                    class: "apexcharts-menu-icon"
                });
                for(var l = 0; l < this.elCustomIcons.length; l++)r.push({
                    el: this.elCustomIcons[l],
                    icon: this.t.customIcons[l].icon,
                    title: this.t.customIcons[l].title,
                    index: this.t.customIcons[l].index,
                    class: "apexcharts-toolbar-custom-icon " + this.t.customIcons[l].class
                });
                r.forEach(function(t, e) {
                    t.index && $fffa43d1c55f0813$var$x.moveIndexInArray(r, e, t.index);
                });
                for(var h = 0; h < r.length; h++)$fffa43d1c55f0813$var$m.setAttrs(r[h].el, {
                    class: r[h].class,
                    title: r[h].title
                }), r[h].el.innerHTML = r[h].icon, a.appendChild(r[h].el);
                this._createHamburgerMenu(a), e.globals.zoomEnabled ? this.elZoom.classList.add(this.selectedClass) : e.globals.panEnabled ? this.elPan.classList.add(this.selectedClass) : e.globals.selectionEnabled && this.elSelection.classList.add(this.selectedClass), this.addToolbarEventListeners();
            }
        },
        {
            key: "_createHamburgerMenu",
            value: function(t) {
                this.elMenuItems = [], t.appendChild(this.elMenu), $fffa43d1c55f0813$var$m.setAttrs(this.elMenu, {
                    class: "apexcharts-menu"
                });
                var e = [
                    {
                        name: "exportSVG",
                        title: this.localeValues.exportToSVG
                    },
                    {
                        name: "exportPNG",
                        title: this.localeValues.exportToPNG
                    },
                    {
                        name: "exportCSV",
                        title: this.localeValues.exportToCSV
                    }
                ];
                this.w.globals.allSeriesHasEqualX || this.w.globals.axisCharts && "datetime" === this.w.config.xaxis.type && !this.w.config.xaxis.categories.length && !this.w.config.labels.length || e.splice(2, 1);
                for(var i = 0; i < e.length; i++)this.elMenuItems.push(document.createElement("div")), this.elMenuItems[i].innerHTML = e[i].title, $fffa43d1c55f0813$var$m.setAttrs(this.elMenuItems[i], {
                    class: "apexcharts-menu-item ".concat(e[i].name),
                    title: e[i].title
                }), this.elMenu.appendChild(this.elMenuItems[i]);
            }
        },
        {
            key: "addToolbarEventListeners",
            value: function() {
                var t = this;
                this.elZoomReset.addEventListener("click", this.handleZoomReset.bind(this)), this.elSelection.addEventListener("click", this.toggleZoomSelection.bind(this, "selection")), this.elZoom.addEventListener("click", this.toggleZoomSelection.bind(this, "zoom")), this.elZoomIn.addEventListener("click", this.handleZoomIn.bind(this)), this.elZoomOut.addEventListener("click", this.handleZoomOut.bind(this)), this.elPan.addEventListener("click", this.togglePanning.bind(this)), this.elMenuIcon.addEventListener("click", this.toggleMenu.bind(this)), this.elMenuItems.forEach(function(e) {
                    e.classList.contains("exportSVG") ? e.addEventListener("click", t.handleDownload.bind(t, "svg")) : e.classList.contains("exportPNG") ? e.addEventListener("click", t.handleDownload.bind(t, "png")) : e.classList.contains("exportCSV") && e.addEventListener("click", t.handleDownload.bind(t, "csv"));
                });
                for(var e = 0; e < this.t.customIcons.length; e++)this.elCustomIcons[e].addEventListener("click", this.t.customIcons[e].click.bind(this, this.ctx, this.ctx.w));
            }
        },
        {
            key: "toggleZoomSelection",
            value: function(t) {
                this.ctx.getSyncedCharts().forEach(function(e) {
                    e.ctx.toolbar.toggleOtherControls();
                    var i = "selection" === t ? e.ctx.toolbar.elSelection : e.ctx.toolbar.elZoom, a = "selection" === t ? "selectionEnabled" : "zoomEnabled";
                    e.w.globals[a] = !e.w.globals[a], i.classList.contains(e.ctx.toolbar.selectedClass) ? i.classList.remove(e.ctx.toolbar.selectedClass) : i.classList.add(e.ctx.toolbar.selectedClass);
                });
            }
        },
        {
            key: "getToolbarIconsReference",
            value: function() {
                var t = this.w;
                this.elZoom || (this.elZoom = t.globals.dom.baseEl.querySelector(".apexcharts-zoom-icon")), this.elPan || (this.elPan = t.globals.dom.baseEl.querySelector(".apexcharts-pan-icon")), this.elSelection || (this.elSelection = t.globals.dom.baseEl.querySelector(".apexcharts-selection-icon"));
            }
        },
        {
            key: "enableZoomPanFromToolbar",
            value: function(t) {
                this.toggleOtherControls(), "pan" === t ? this.w.globals.panEnabled = !0 : this.w.globals.zoomEnabled = !0;
                var e = "pan" === t ? this.elPan : this.elZoom, i = "pan" === t ? this.elZoom : this.elPan;
                e && e.classList.add(this.selectedClass), i && i.classList.remove(this.selectedClass);
            }
        },
        {
            key: "togglePanning",
            value: function() {
                this.ctx.getSyncedCharts().forEach(function(t) {
                    t.ctx.toolbar.toggleOtherControls(), t.w.globals.panEnabled = !t.w.globals.panEnabled, t.ctx.toolbar.elPan.classList.contains(t.ctx.toolbar.selectedClass) ? t.ctx.toolbar.elPan.classList.remove(t.ctx.toolbar.selectedClass) : t.ctx.toolbar.elPan.classList.add(t.ctx.toolbar.selectedClass);
                });
            }
        },
        {
            key: "toggleOtherControls",
            value: function() {
                var t = this, e = this.w;
                e.globals.panEnabled = !1, e.globals.zoomEnabled = !1, e.globals.selectionEnabled = !1, this.getToolbarIconsReference(), [
                    this.elPan,
                    this.elSelection,
                    this.elZoom
                ].forEach(function(e) {
                    e && e.classList.remove(t.selectedClass);
                });
            }
        },
        {
            key: "handleZoomIn",
            value: function() {
                var t = this.w;
                t.globals.isRangeBar && (this.minX = t.globals.minY, this.maxX = t.globals.maxY);
                var e = (this.minX + this.maxX) / 2, i = (this.minX + e) / 2, a = (this.maxX + e) / 2, s = this._getNewMinXMaxX(i, a);
                t.globals.disableZoomIn || this.zoomUpdateOptions(s.minX, s.maxX);
            }
        },
        {
            key: "handleZoomOut",
            value: function() {
                var t = this.w;
                if (t.globals.isRangeBar && (this.minX = t.globals.minY, this.maxX = t.globals.maxY), !("datetime" === t.config.xaxis.type && new Date(this.minX).getUTCFullYear() < 1e3)) {
                    var e = (this.minX + this.maxX) / 2, i = this.minX - (e - this.minX), a = this.maxX - (e - this.maxX), s = this._getNewMinXMaxX(i, a);
                    t.globals.disableZoomOut || this.zoomUpdateOptions(s.minX, s.maxX);
                }
            }
        },
        {
            key: "_getNewMinXMaxX",
            value: function(t, e) {
                var i = this.w.config.xaxis.convertedCatToNumeric;
                return {
                    minX: i ? Math.floor(t) : t,
                    maxX: i ? Math.floor(e) : e
                };
            }
        },
        {
            key: "zoomUpdateOptions",
            value: function(t, e) {
                var i = this.w;
                if (void 0 !== t || void 0 !== e) {
                    if (!(i.config.xaxis.convertedCatToNumeric && (t < 1 && (t = 1, e = i.globals.dataPoints), e - t < 2))) {
                        var a = {
                            min: t,
                            max: e
                        }, s = this.getBeforeZoomRange(a);
                        s && (a = s.xaxis);
                        var r = {
                            xaxis: a
                        }, o = $fffa43d1c55f0813$var$x.clone(i.globals.initialConfig.yaxis);
                        if (i.config.chart.zoom.autoScaleYaxis) o = new $fffa43d1c55f0813$var$_(this.ctx).autoScaleY(this.ctx, o, {
                            xaxis: a
                        });
                        i.config.chart.group || (r.yaxis = o), this.w.globals.zoomed = !0, this.ctx.updateHelpers._updateOptions(r, !1, this.w.config.chart.animations.dynamicAnimation.enabled), this.zoomCallback(a, o);
                    }
                } else this.handleZoomReset();
            }
        },
        {
            key: "zoomCallback",
            value: function(t, e) {
                "function" == typeof this.ev.zoomed && this.ev.zoomed(this.ctx, {
                    xaxis: t,
                    yaxis: e
                });
            }
        },
        {
            key: "getBeforeZoomRange",
            value: function(t, e) {
                var i = null;
                return "function" == typeof this.ev.beforeZoom && (i = this.ev.beforeZoom(this, {
                    xaxis: t,
                    yaxis: e
                })), i;
            }
        },
        {
            key: "toggleMenu",
            value: function() {
                var t = this;
                window.setTimeout(function() {
                    t.elMenu.classList.contains("apexcharts-menu-open") ? t.elMenu.classList.remove("apexcharts-menu-open") : t.elMenu.classList.add("apexcharts-menu-open");
                }, 0);
            }
        },
        {
            key: "handleDownload",
            value: function(t) {
                var e = this.w, i = new $fffa43d1c55f0813$var$G(this.ctx);
                switch(t){
                    case "svg":
                        i.exportToSVG(this.ctx);
                        break;
                    case "png":
                        i.exportToPng(this.ctx);
                        break;
                    case "csv":
                        i.exportToCSV({
                            series: e.config.series,
                            columnDelimiter: e.config.chart.toolbar.export.csv.columnDelimiter
                        });
                }
            }
        },
        {
            key: "handleZoomReset",
            value: function(t) {
                this.ctx.getSyncedCharts().forEach(function(t) {
                    var e = t.w;
                    if (e.globals.lastXAxis.min = e.globals.initialConfig.xaxis.min, e.globals.lastXAxis.max = e.globals.initialConfig.xaxis.max, t.updateHelpers.revertDefaultAxisMinMax(), "function" == typeof e.config.chart.events.beforeResetZoom) {
                        var i = e.config.chart.events.beforeResetZoom(t, e);
                        i && t.updateHelpers.revertDefaultAxisMinMax(i);
                    }
                    "function" == typeof e.config.chart.events.zoomed && t.ctx.toolbar.zoomCallback({
                        min: e.config.xaxis.min,
                        max: e.config.xaxis.max
                    }), e.globals.zoomed = !1;
                    var a = t.ctx.series.emptyCollapsedSeries($fffa43d1c55f0813$var$x.clone(e.globals.initialSeries));
                    t.updateHelpers._updateSeries(a, e.config.chart.animations.dynamicAnimation.enabled);
                });
            }
        },
        {
            key: "destroy",
            value: function() {
                this.elZoom = null, this.elZoomIn = null, this.elZoomOut = null, this.elPan = null, this.elSelection = null, this.elZoomReset = null, this.elMenuIcon = null;
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$ct = function(t) {
    $fffa43d1c55f0813$var$n(i, $fffa43d1c55f0813$var$ht);
    var e = $fffa43d1c55f0813$var$d(i);
    function i(t) {
        var s;
        return $fffa43d1c55f0813$var$a(this, i), (s = e.call(this, t)).ctx = t, s.w = t.w, s.dragged = !1, s.graphics = new $fffa43d1c55f0813$var$m(s.ctx), s.eventList = [
            "mousedown",
            "mouseleave",
            "mousemove",
            "touchstart",
            "touchmove",
            "mouseup",
            "touchend"
        ], s.clientX = 0, s.clientY = 0, s.startX = 0, s.endX = 0, s.dragX = 0, s.startY = 0, s.endY = 0, s.dragY = 0, s.moveDirection = "none", s;
    }
    return $fffa43d1c55f0813$var$r(i, [
        {
            key: "init",
            value: function(t) {
                var e = this, i = t.xyRatios, a = this.w, s = this;
                this.xyRatios = i, this.zoomRect = this.graphics.drawRect(0, 0, 0, 0), this.selectionRect = this.graphics.drawRect(0, 0, 0, 0), this.gridRect = a.globals.dom.baseEl.querySelector(".apexcharts-grid"), this.zoomRect.node.classList.add("apexcharts-zoom-rect"), this.selectionRect.node.classList.add("apexcharts-selection-rect"), a.globals.dom.elGraphical.add(this.zoomRect), a.globals.dom.elGraphical.add(this.selectionRect), "x" === a.config.chart.selection.type ? this.slDraggableRect = this.selectionRect.draggable({
                    minX: 0,
                    minY: 0,
                    maxX: a.globals.gridWidth,
                    maxY: a.globals.gridHeight
                }).on("dragmove", this.selectionDragging.bind(this, "dragging")) : "y" === a.config.chart.selection.type ? this.slDraggableRect = this.selectionRect.draggable({
                    minX: 0,
                    maxX: a.globals.gridWidth
                }).on("dragmove", this.selectionDragging.bind(this, "dragging")) : this.slDraggableRect = this.selectionRect.draggable().on("dragmove", this.selectionDragging.bind(this, "dragging")), this.preselectedSelection(), this.hoverArea = a.globals.dom.baseEl.querySelector("".concat(a.globals.chartClass, " .apexcharts-svg")), this.hoverArea.classList.add("apexcharts-zoomable"), this.eventList.forEach(function(t) {
                    e.hoverArea.addEventListener(t, s.svgMouseEvents.bind(s, i), {
                        capture: !1,
                        passive: !0
                    });
                });
            }
        },
        {
            key: "destroy",
            value: function() {
                this.slDraggableRect && (this.slDraggableRect.draggable(!1), this.slDraggableRect.off(), this.selectionRect.off()), this.selectionRect = null, this.zoomRect = null, this.gridRect = null;
            }
        },
        {
            key: "svgMouseEvents",
            value: function(t, e) {
                var i = this.w, a = this, s = this.ctx.toolbar, r = i.globals.zoomEnabled ? i.config.chart.zoom.type : i.config.chart.selection.type, o = i.config.chart.toolbar.autoSelected;
                if (e.shiftKey ? (this.shiftWasPressed = !0, s.enableZoomPanFromToolbar("pan" === o ? "zoom" : "pan")) : this.shiftWasPressed && (s.enableZoomPanFromToolbar(o), this.shiftWasPressed = !1), e.target) {
                    var n, l = e.target.classList;
                    if (e.target.parentNode && null !== e.target.parentNode && (n = e.target.parentNode.classList), !(l.contains("apexcharts-selection-rect") || l.contains("apexcharts-legend-marker") || l.contains("apexcharts-legend-text") || n && n.contains("apexcharts-toolbar"))) {
                        if (a.clientX = "touchmove" === e.type || "touchstart" === e.type ? e.touches[0].clientX : "touchend" === e.type ? e.changedTouches[0].clientX : e.clientX, a.clientY = "touchmove" === e.type || "touchstart" === e.type ? e.touches[0].clientY : "touchend" === e.type ? e.changedTouches[0].clientY : e.clientY, "mousedown" === e.type && 1 === e.which) {
                            var h = a.gridRect.getBoundingClientRect();
                            a.startX = a.clientX - h.left, a.startY = a.clientY - h.top, a.dragged = !1, a.w.globals.mousedown = !0;
                        }
                        if (("mousemove" === e.type && 1 === e.which || "touchmove" === e.type) && (a.dragged = !0, i.globals.panEnabled ? (i.globals.selection = null, a.w.globals.mousedown && a.panDragging({
                            context: a,
                            zoomtype: r,
                            xyRatios: t
                        })) : (a.w.globals.mousedown && i.globals.zoomEnabled || a.w.globals.mousedown && i.globals.selectionEnabled) && (a.selection = a.selectionDrawing({
                            context: a,
                            zoomtype: r
                        }))), "mouseup" === e.type || "touchend" === e.type || "mouseleave" === e.type) {
                            var c = a.gridRect.getBoundingClientRect();
                            a.w.globals.mousedown && (a.endX = a.clientX - c.left, a.endY = a.clientY - c.top, a.dragX = Math.abs(a.endX - a.startX), a.dragY = Math.abs(a.endY - a.startY), (i.globals.zoomEnabled || i.globals.selectionEnabled) && a.selectionDrawn({
                                context: a,
                                zoomtype: r
                            }), i.globals.panEnabled && i.config.xaxis.convertedCatToNumeric && a.delayedPanScrolled()), i.globals.zoomEnabled && a.hideSelectionRect(this.selectionRect), a.dragged = !1, a.w.globals.mousedown = !1;
                        }
                        this.makeSelectionRectDraggable();
                    }
                }
            }
        },
        {
            key: "makeSelectionRectDraggable",
            value: function() {
                var t = this.w;
                if (this.selectionRect) {
                    var e = this.selectionRect.node.getBoundingClientRect();
                    e.width > 0 && e.height > 0 && this.slDraggableRect.selectize({
                        points: "l, r",
                        pointSize: 8,
                        pointType: "rect"
                    }).resize({
                        constraint: {
                            minX: 0,
                            minY: 0,
                            maxX: t.globals.gridWidth,
                            maxY: t.globals.gridHeight
                        }
                    }).on("resizing", this.selectionDragging.bind(this, "resizing"));
                }
            }
        },
        {
            key: "preselectedSelection",
            value: function() {
                var t = this.w, e = this.xyRatios;
                if (!t.globals.zoomEnabled) {
                    if (void 0 !== t.globals.selection && null !== t.globals.selection) this.drawSelectionRect(t.globals.selection);
                    else if (void 0 !== t.config.chart.selection.xaxis.min && void 0 !== t.config.chart.selection.xaxis.max) {
                        var i = (t.config.chart.selection.xaxis.min - t.globals.minX) / e.xRatio, a = t.globals.gridWidth - (t.globals.maxX - t.config.chart.selection.xaxis.max) / e.xRatio - i;
                        t.globals.isRangeBar && (i = (t.config.chart.selection.xaxis.min - t.globals.yAxisScale[0].niceMin) / e.invertedYRatio, a = (t.config.chart.selection.xaxis.max - t.config.chart.selection.xaxis.min) / e.invertedYRatio);
                        var s = {
                            x: i,
                            y: 0,
                            width: a,
                            height: t.globals.gridHeight,
                            translateX: 0,
                            translateY: 0,
                            selectionEnabled: !0
                        };
                        this.drawSelectionRect(s), this.makeSelectionRectDraggable(), "function" == typeof t.config.chart.events.selection && t.config.chart.events.selection(this.ctx, {
                            xaxis: {
                                min: t.config.chart.selection.xaxis.min,
                                max: t.config.chart.selection.xaxis.max
                            },
                            yaxis: {}
                        });
                    }
                }
            }
        },
        {
            key: "drawSelectionRect",
            value: function(t) {
                var e = t.x, i = t.y, a = t.width, s = t.height, r = t.translateX, o = void 0 === r ? 0 : r, n = t.translateY, l = void 0 === n ? 0 : n, h = this.w, c = this.zoomRect, d = this.selectionRect;
                if (this.dragged || null !== h.globals.selection) {
                    var g = {
                        transform: "translate(" + o + ", " + l + ")"
                    };
                    h.globals.zoomEnabled && this.dragged && (a < 0 && (a = 1), c.attr({
                        x: e,
                        y: i,
                        width: a,
                        height: s,
                        fill: h.config.chart.zoom.zoomedArea.fill.color,
                        "fill-opacity": h.config.chart.zoom.zoomedArea.fill.opacity,
                        stroke: h.config.chart.zoom.zoomedArea.stroke.color,
                        "stroke-width": h.config.chart.zoom.zoomedArea.stroke.width,
                        "stroke-opacity": h.config.chart.zoom.zoomedArea.stroke.opacity
                    }), $fffa43d1c55f0813$var$m.setAttrs(c.node, g)), h.globals.selectionEnabled && (d.attr({
                        x: e,
                        y: i,
                        width: a > 0 ? a : 0,
                        height: s > 0 ? s : 0,
                        fill: h.config.chart.selection.fill.color,
                        "fill-opacity": h.config.chart.selection.fill.opacity,
                        stroke: h.config.chart.selection.stroke.color,
                        "stroke-width": h.config.chart.selection.stroke.width,
                        "stroke-dasharray": h.config.chart.selection.stroke.dashArray,
                        "stroke-opacity": h.config.chart.selection.stroke.opacity
                    }), $fffa43d1c55f0813$var$m.setAttrs(d.node, g));
                }
            }
        },
        {
            key: "hideSelectionRect",
            value: function(t) {
                t && t.attr({
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                });
            }
        },
        {
            key: "selectionDrawing",
            value: function(t) {
                var e = t.context, i = t.zoomtype, a = this.w, s = e, r = this.gridRect.getBoundingClientRect(), o = s.startX - 1, n = s.startY, l = !1, h = !1, c = s.clientX - r.left - o, d = s.clientY - r.top - n, g = {};
                return Math.abs(c + o) > a.globals.gridWidth ? c = a.globals.gridWidth - o : s.clientX - r.left < 0 && (c = o), o > s.clientX - r.left && (l = !0, c = Math.abs(c)), n > s.clientY - r.top && (h = !0, d = Math.abs(d)), g = "x" === i ? {
                    x: l ? o - c : o,
                    y: 0,
                    width: c,
                    height: a.globals.gridHeight
                } : "y" === i ? {
                    x: 0,
                    y: h ? n - d : n,
                    width: a.globals.gridWidth,
                    height: d
                } : {
                    x: l ? o - c : o,
                    y: h ? n - d : n,
                    width: c,
                    height: d
                }, s.drawSelectionRect(g), s.selectionDragging("resizing"), g;
            }
        },
        {
            key: "selectionDragging",
            value: function(t, e) {
                var i = this, a = this.w, s = this.xyRatios, r = this.selectionRect, o = 0;
                "resizing" === t && (o = 30);
                var n = function(t) {
                    return parseFloat(r.node.getAttribute(t));
                }, l = {
                    x: n("x"),
                    y: n("y"),
                    width: n("width"),
                    height: n("height")
                };
                a.globals.selection = l, "function" == typeof a.config.chart.events.selection && a.globals.selectionEnabled && (clearTimeout(this.w.globals.selectionResizeTimer), this.w.globals.selectionResizeTimer = window.setTimeout(function() {
                    var t, e, o, n, l = i.gridRect.getBoundingClientRect(), h = r.node.getBoundingClientRect();
                    a.globals.isRangeBar ? (t = a.globals.yAxisScale[0].niceMin + (h.left - l.left) * s.invertedYRatio, e = a.globals.yAxisScale[0].niceMin + (h.right - l.left) * s.invertedYRatio, o = 0, n = 1) : (t = a.globals.xAxisScale.niceMin + (h.left - l.left) * s.xRatio, e = a.globals.xAxisScale.niceMin + (h.right - l.left) * s.xRatio, o = a.globals.yAxisScale[0].niceMin + (l.bottom - h.bottom) * s.yRatio[0], n = a.globals.yAxisScale[0].niceMax - (h.top - l.top) * s.yRatio[0]);
                    var c = {
                        xaxis: {
                            min: t,
                            max: e
                        },
                        yaxis: {
                            min: o,
                            max: n
                        }
                    };
                    a.config.chart.events.selection(i.ctx, c), a.config.chart.brush.enabled && void 0 !== a.config.chart.events.brushScrolled && a.config.chart.events.brushScrolled(i.ctx, c);
                }, o));
            }
        },
        {
            key: "selectionDrawn",
            value: function(t) {
                var e = t.context, i = t.zoomtype, a = this.w, s = e, r = this.xyRatios, o = this.ctx.toolbar;
                if (s.startX > s.endX) {
                    var n = s.startX;
                    s.startX = s.endX, s.endX = n;
                }
                if (s.startY > s.endY) {
                    var l = s.startY;
                    s.startY = s.endY, s.endY = l;
                }
                var h = void 0, c = void 0;
                a.globals.isRangeBar ? (h = a.globals.yAxisScale[0].niceMin + s.startX * r.invertedYRatio, c = a.globals.yAxisScale[0].niceMin + s.endX * r.invertedYRatio) : (h = a.globals.xAxisScale.niceMin + s.startX * r.xRatio, c = a.globals.xAxisScale.niceMin + s.endX * r.xRatio);
                var d = [], g = [];
                if (a.config.yaxis.forEach(function(t, e) {
                    d.push(a.globals.yAxisScale[e].niceMax - r.yRatio[e] * s.startY), g.push(a.globals.yAxisScale[e].niceMax - r.yRatio[e] * s.endY);
                }), s.dragged && (s.dragX > 10 || s.dragY > 10) && h !== c) {
                    if (a.globals.zoomEnabled) {
                        var u = $fffa43d1c55f0813$var$x.clone(a.globals.initialConfig.yaxis), p = $fffa43d1c55f0813$var$x.clone(a.globals.initialConfig.xaxis);
                        if (a.globals.zoomed = !0, a.config.xaxis.convertedCatToNumeric && (h = Math.floor(h), c = Math.floor(c), h < 1 && (h = 1, c = a.globals.dataPoints), c - h < 2 && (c = h + 1)), "xy" !== i && "x" !== i || (p = {
                            min: h,
                            max: c
                        }), "xy" !== i && "y" !== i || u.forEach(function(t, e) {
                            u[e].min = g[e], u[e].max = d[e];
                        }), a.config.chart.zoom.autoScaleYaxis) {
                            var f = new $fffa43d1c55f0813$var$_(s.ctx);
                            u = f.autoScaleY(s.ctx, u, {
                                xaxis: p
                            });
                        }
                        if (o) {
                            var b = o.getBeforeZoomRange(p, u);
                            b && (p = b.xaxis ? b.xaxis : p, u = b.yaxis ? b.yaxis : u);
                        }
                        var v = {
                            xaxis: p
                        };
                        a.config.chart.group || (v.yaxis = u), s.ctx.updateHelpers._updateOptions(v, !1, s.w.config.chart.animations.dynamicAnimation.enabled), "function" == typeof a.config.chart.events.zoomed && o.zoomCallback(p, u);
                    } else if (a.globals.selectionEnabled) {
                        var m, y = null;
                        m = {
                            min: h,
                            max: c
                        }, "xy" !== i && "y" !== i || (y = $fffa43d1c55f0813$var$x.clone(a.config.yaxis)).forEach(function(t, e) {
                            y[e].min = g[e], y[e].max = d[e];
                        }), a.globals.selection = s.selection, "function" == typeof a.config.chart.events.selection && a.config.chart.events.selection(s.ctx, {
                            xaxis: m,
                            yaxis: y
                        });
                    }
                }
            }
        },
        {
            key: "panDragging",
            value: function(t) {
                var e = t.context, i = this.w, a = e;
                if (void 0 !== i.globals.lastClientPosition.x) {
                    var s = i.globals.lastClientPosition.x - a.clientX, r = i.globals.lastClientPosition.y - a.clientY;
                    Math.abs(s) > Math.abs(r) && s > 0 ? this.moveDirection = "left" : Math.abs(s) > Math.abs(r) && s < 0 ? this.moveDirection = "right" : Math.abs(r) > Math.abs(s) && r > 0 ? this.moveDirection = "up" : Math.abs(r) > Math.abs(s) && r < 0 && (this.moveDirection = "down");
                }
                i.globals.lastClientPosition = {
                    x: a.clientX,
                    y: a.clientY
                };
                var o = i.globals.isRangeBar ? i.globals.minY : i.globals.minX, n = i.globals.isRangeBar ? i.globals.maxY : i.globals.maxX;
                i.config.xaxis.convertedCatToNumeric || a.panScrolled(o, n);
            }
        },
        {
            key: "delayedPanScrolled",
            value: function() {
                var t = this.w, e = t.globals.minX, i = t.globals.maxX, a = (t.globals.maxX - t.globals.minX) / 2;
                "left" === this.moveDirection ? (e = t.globals.minX + a, i = t.globals.maxX + a) : "right" === this.moveDirection && (e = t.globals.minX - a, i = t.globals.maxX - a), e = Math.floor(e), i = Math.floor(i), this.updateScrolledChart({
                    xaxis: {
                        min: e,
                        max: i
                    }
                }, e, i);
            }
        },
        {
            key: "panScrolled",
            value: function(t, e) {
                var i = this.w, a = this.xyRatios, s = $fffa43d1c55f0813$var$x.clone(i.globals.initialConfig.yaxis), r = a.xRatio, o = i.globals.minX, n = i.globals.maxX;
                i.globals.isRangeBar && (r = a.invertedYRatio, o = i.globals.minY, n = i.globals.maxY), "left" === this.moveDirection ? (t = o + i.globals.gridWidth / 15 * r, e = n + i.globals.gridWidth / 15 * r) : "right" === this.moveDirection && (t = o - i.globals.gridWidth / 15 * r, e = n - i.globals.gridWidth / 15 * r), i.globals.isRangeBar || (t < i.globals.initialMinX || e > i.globals.initialMaxX) && (t = o, e = n);
                var l = {
                    min: t,
                    max: e
                };
                i.config.chart.zoom.autoScaleYaxis && (s = new $fffa43d1c55f0813$var$_(this.ctx).autoScaleY(this.ctx, s, {
                    xaxis: l
                }));
                var h = {
                    xaxis: {
                        min: t,
                        max: e
                    }
                };
                i.config.chart.group || (h.yaxis = s), this.updateScrolledChart(h, t, e);
            }
        },
        {
            key: "updateScrolledChart",
            value: function(t, e, i) {
                var a = this.w;
                this.ctx.updateHelpers._updateOptions(t, !1, !1), "function" == typeof a.config.chart.events.scrolled && a.config.chart.events.scrolled(this.ctx, {
                    xaxis: {
                        min: e,
                        max: i
                    }
                });
            }
        }
    ]), i;
}(), $fffa43d1c55f0813$var$dt = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.w = e.w, this.ttCtx = e, this.ctx = e.ctx;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "getNearestValues",
            value: function(t) {
                var e = t.hoverArea, i = t.elGrid, a = t.clientX, s = t.clientY, r = this.w, o = i.getBoundingClientRect(), n = o.width, l = o.height, h = n / (r.globals.dataPoints - 1), c = l / r.globals.dataPoints, d = this.hasBars();
                !r.globals.comboCharts && !d || r.config.xaxis.convertedCatToNumeric || (h = n / r.globals.dataPoints);
                var g = a - o.left - r.globals.barPadForNumericAxis, u = s - o.top;
                g < 0 || u < 0 || g > n || u > l ? (e.classList.remove("hovering-zoom"), e.classList.remove("hovering-pan")) : r.globals.zoomEnabled ? (e.classList.remove("hovering-pan"), e.classList.add("hovering-zoom")) : r.globals.panEnabled && (e.classList.remove("hovering-zoom"), e.classList.add("hovering-pan"));
                var p = Math.round(g / h), f = Math.floor(u / c);
                d && !r.config.xaxis.convertedCatToNumeric && (p = Math.ceil(g / h), p -= 1);
                var b = null, v = null, m = r.globals.seriesXvalues.map(function(t) {
                    return t.filter(function(t) {
                        return $fffa43d1c55f0813$var$x.isNumber(t);
                    });
                }), y = r.globals.seriesYvalues.map(function(t) {
                    return t.filter(function(t) {
                        return $fffa43d1c55f0813$var$x.isNumber(t);
                    });
                });
                if (r.globals.isXNumeric) {
                    var w = this.ttCtx.getElGrid().getBoundingClientRect(), k = g * (w.width / n), A = u * (w.height / l);
                    b = (v = this.closestInMultiArray(k, A, m, y)).index, p = v.j, null !== b && (m = r.globals.seriesXvalues[b], p = (v = this.closestInArray(k, m)).index);
                }
                return r.globals.capturedSeriesIndex = null === b ? -1 : b, (!p || p < 1) && (p = 0), r.globals.isBarHorizontal ? r.globals.capturedDataPointIndex = f : r.globals.capturedDataPointIndex = p, {
                    capturedSeries: b,
                    j: r.globals.isBarHorizontal ? f : p,
                    hoverX: g,
                    hoverY: u
                };
            }
        },
        {
            key: "closestInMultiArray",
            value: function(t, e, i, a) {
                var s = this.w, r = 0, o = null, n = -1;
                s.globals.series.length > 1 ? r = this.getFirstActiveXArray(i) : o = 0;
                var l = i[r][0], h = Math.abs(t - l);
                if (i.forEach(function(e) {
                    e.forEach(function(e, i) {
                        var a = Math.abs(t - e);
                        a <= h && (h = a, n = i);
                    });
                }), -1 !== n) {
                    var c = a[r][n], d = Math.abs(e - c);
                    o = r, a.forEach(function(t, i) {
                        var a = Math.abs(e - t[n]);
                        a <= d && (d = a, o = i);
                    });
                }
                return {
                    index: o,
                    j: n
                };
            }
        },
        {
            key: "getFirstActiveXArray",
            value: function(t) {
                for(var e = this.w, i = 0, a = t.map(function(t, e) {
                    return t.length > 0 ? e : -1;
                }), s = 0; s < a.length; s++)if (-1 !== a[s] && -1 === e.globals.collapsedSeriesIndices.indexOf(s) && -1 === e.globals.ancillaryCollapsedSeriesIndices.indexOf(s)) {
                    i = a[s];
                    break;
                }
                return i;
            }
        },
        {
            key: "closestInArray",
            value: function(t, e) {
                for(var i = e[0], a = null, s = Math.abs(t - i), r = 0; r < e.length; r++){
                    var o = Math.abs(t - e[r]);
                    o < s && (s = o, a = r);
                }
                return {
                    index: a
                };
            }
        },
        {
            key: "isXoverlap",
            value: function(t) {
                var e = [], i = this.w.globals.seriesX.filter(function(t) {
                    return void 0 !== t[0];
                });
                if (i.length > 0) for(var a = 0; a < i.length - 1; a++)void 0 !== i[a][t] && void 0 !== i[a + 1][t] && i[a][t] !== i[a + 1][t] && e.push("unEqual");
                return 0 === e.length;
            }
        },
        {
            key: "isInitialSeriesSameLen",
            value: function() {
                for(var t = !0, e = this.w.globals.initialSeries, i = 0; i < e.length - 1; i++)if (e[i].data.length !== e[i + 1].data.length) {
                    t = !1;
                    break;
                }
                return t;
            }
        },
        {
            key: "getBarsHeight",
            value: function(t) {
                return $fffa43d1c55f0813$var$u(t).reduce(function(t, e) {
                    return t + e.getBBox().height;
                }, 0);
            }
        },
        {
            key: "getElMarkers",
            value: function(t) {
                return "number" == typeof t ? this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series[data\\:realIndex='".concat(t, "'] .apexcharts-series-markers-wrap > *")) : this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers-wrap > *");
            }
        },
        {
            key: "getAllMarkers",
            value: function() {
                var t = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers-wrap");
                (t = $fffa43d1c55f0813$var$u(t)).sort(function(t, e) {
                    var i = Number(t.getAttribute("data:realIndex")), a = Number(e.getAttribute("data:realIndex"));
                    return a < i ? 1 : a > i ? -1 : 0;
                });
                var e = [];
                return t.forEach(function(t) {
                    e.push(t.querySelector(".apexcharts-marker"));
                }), e;
            }
        },
        {
            key: "hasMarkers",
            value: function(t) {
                return this.getElMarkers(t).length > 0;
            }
        },
        {
            key: "getElBars",
            value: function() {
                return this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-bar-series,  .apexcharts-candlestick-series, .apexcharts-boxPlot-series, .apexcharts-rangebar-series");
            }
        },
        {
            key: "hasBars",
            value: function() {
                return this.getElBars().length > 0;
            }
        },
        {
            key: "getHoverMarkerSize",
            value: function(t) {
                var e = this.w, i = e.config.markers.hover.size;
                return void 0 === i && (i = e.globals.markers.size[t] + e.config.markers.hover.sizeOffset), i;
            }
        },
        {
            key: "toggleAllTooltipSeriesGroups",
            value: function(t) {
                var e = this.w, i = this.ttCtx;
                0 === i.allTooltipSeriesGroups.length && (i.allTooltipSeriesGroups = e.globals.dom.baseEl.querySelectorAll(".apexcharts-tooltip-series-group"));
                for(var a = i.allTooltipSeriesGroups, s = 0; s < a.length; s++)"enable" === t ? (a[s].classList.add("apexcharts-active"), a[s].style.display = e.config.tooltip.items.display) : (a[s].classList.remove("apexcharts-active"), a[s].style.display = "none");
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$gt = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.w = e.w, this.ctx = e.ctx, this.ttCtx = e, this.tooltipUtil = new $fffa43d1c55f0813$var$dt(e);
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "drawSeriesTexts",
            value: function(t) {
                var e = t.shared, i = void 0 === e || e, a = t.ttItems, s = t.i, r = void 0 === s ? 0 : s, o = t.j, n = void 0 === o ? null : o, l = t.y1, h = t.y2, c = t.e, d = this.w;
                void 0 !== d.config.tooltip.custom ? this.handleCustomTooltip({
                    i: r,
                    j: n,
                    y1: l,
                    y2: h,
                    w: d
                }) : this.toggleActiveInactiveSeries(i);
                var g = this.getValuesToPrint({
                    i: r,
                    j: n
                });
                this.printLabels({
                    i: r,
                    j: n,
                    values: g,
                    ttItems: a,
                    shared: i,
                    e: c
                });
                var u = this.ttCtx.getElTooltip();
                this.ttCtx.tooltipRect.ttWidth = u.getBoundingClientRect().width, this.ttCtx.tooltipRect.ttHeight = u.getBoundingClientRect().height;
            }
        },
        {
            key: "printLabels",
            value: function(t) {
                var i, a = this, s = t.i, r = t.j, o = t.values, n = t.ttItems, l = t.shared, h = t.e, c = this.w, d = [], g = function(t) {
                    return c.globals.seriesGoals[t] && c.globals.seriesGoals[t][r] && Array.isArray(c.globals.seriesGoals[t][r]);
                }, u = o.xVal, p = o.zVal, f = o.xAxisTTVal, x = "", b = c.globals.colors[s];
                null !== r && c.config.plotOptions.bar.distributed && (b = c.globals.colors[r]);
                for(var v = function(t, o) {
                    var v = a.getFormatters(s);
                    x = a.getSeriesName({
                        fn: v.yLbTitleFormatter,
                        index: s,
                        seriesIndex: s,
                        j: r
                    }), "treemap" === c.config.chart.type && (x = v.yLbTitleFormatter(String(c.config.series[s].data[r].x), {
                        series: c.globals.series,
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: c
                    }));
                    var m = c.config.tooltip.inverseOrder ? o : t;
                    if (c.globals.axisCharts) {
                        var y = function(t) {
                            var e, i, a, s;
                            return c.globals.isRangeData ? v.yLbFormatter(null === (e = c.globals.seriesRangeStart) || void 0 === e || null === (i = e[t]) || void 0 === i ? void 0 : i[r], {
                                series: c.globals.seriesRangeStart,
                                seriesIndex: t,
                                dataPointIndex: r,
                                w: c
                            }) + " - " + v.yLbFormatter(null === (a = c.globals.seriesRangeEnd) || void 0 === a || null === (s = a[t]) || void 0 === s ? void 0 : s[r], {
                                series: c.globals.seriesRangeEnd,
                                seriesIndex: t,
                                dataPointIndex: r,
                                w: c
                            }) : v.yLbFormatter(c.globals.series[t][r], {
                                series: c.globals.series,
                                seriesIndex: t,
                                dataPointIndex: r,
                                w: c
                            });
                        };
                        if (l) v = a.getFormatters(m), x = a.getSeriesName({
                            fn: v.yLbTitleFormatter,
                            index: m,
                            seriesIndex: s,
                            j: r
                        }), b = c.globals.colors[m], i = y(m), g(m) && (d = c.globals.seriesGoals[m][r].map(function(t) {
                            return {
                                attrs: t,
                                val: v.yLbFormatter(t.value, {
                                    seriesIndex: m,
                                    dataPointIndex: r,
                                    w: c
                                })
                            };
                        }));
                        else {
                            var w, k = null == h || null === (w = h.target) || void 0 === w ? void 0 : w.getAttribute("fill");
                            k && (b = -1 !== k.indexOf("url") ? document.querySelector(k.substr(4).slice(0, -1)).childNodes[0].getAttribute("stroke") : k), i = y(s), g(s) && Array.isArray(c.globals.seriesGoals[s][r]) && (d = c.globals.seriesGoals[s][r].map(function(t) {
                                return {
                                    attrs: t,
                                    val: v.yLbFormatter(t.value, {
                                        seriesIndex: s,
                                        dataPointIndex: r,
                                        w: c
                                    })
                                };
                            }));
                        }
                    }
                    null === r && (i = v.yLbFormatter(c.globals.series[s], $fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, c), {}, {
                        seriesIndex: s,
                        dataPointIndex: s
                    }))), a.DOMHandling({
                        i: s,
                        t: m,
                        j: r,
                        ttItems: n,
                        values: {
                            val: i,
                            goalVals: d,
                            xVal: u,
                            xAxisTTVal: f,
                            zVal: p
                        },
                        seriesName: x,
                        shared: l,
                        pColor: b
                    });
                }, m = 0, y = c.globals.series.length - 1; m < c.globals.series.length; m++, y--)v(m, y);
            }
        },
        {
            key: "getFormatters",
            value: function(t) {
                var e, i = this.w, a = i.globals.yLabelFormatters[t];
                return void 0 !== i.globals.ttVal ? Array.isArray(i.globals.ttVal) ? (a = i.globals.ttVal[t] && i.globals.ttVal[t].formatter, e = i.globals.ttVal[t] && i.globals.ttVal[t].title && i.globals.ttVal[t].title.formatter) : (a = i.globals.ttVal.formatter, "function" == typeof i.globals.ttVal.title.formatter && (e = i.globals.ttVal.title.formatter)) : e = i.config.tooltip.y.title.formatter, "function" != typeof a && (a = i.globals.yLabelFormatters[0] ? i.globals.yLabelFormatters[0] : function(t) {
                    return t;
                }), "function" != typeof e && (e = function(t) {
                    return t;
                }), {
                    yLbFormatter: a,
                    yLbTitleFormatter: e
                };
            }
        },
        {
            key: "getSeriesName",
            value: function(t) {
                var e = t.fn, i = t.index, a = t.seriesIndex, s = t.j, r = this.w;
                return e(String(r.globals.seriesNames[i]), {
                    series: r.globals.series,
                    seriesIndex: a,
                    dataPointIndex: s,
                    w: r
                });
            }
        },
        {
            key: "DOMHandling",
            value: function(t) {
                t.i;
                var e = t.t, i = t.j, a = t.ttItems, s = t.values, r = t.seriesName, o = t.shared, n = t.pColor, l = this.w, h = this.ttCtx, c = s.val, d = s.goalVals, g = s.xVal, u = s.xAxisTTVal, p = s.zVal, f = null;
                f = a[e].children, l.config.tooltip.fillSeriesColor && (a[e].style.backgroundColor = n, f[0].style.display = "none"), h.showTooltipTitle && (null === h.tooltipTitle && (h.tooltipTitle = l.globals.dom.baseEl.querySelector(".apexcharts-tooltip-title")), h.tooltipTitle.innerHTML = g), h.isXAxisTooltipEnabled && (h.xaxisTooltipText.innerHTML = "" !== u ? u : g);
                var x = a[e].querySelector(".apexcharts-tooltip-text-y-label");
                x && (x.innerHTML = r || "");
                var b = a[e].querySelector(".apexcharts-tooltip-text-y-value");
                b && (b.innerHTML = void 0 !== c ? c : ""), f[0] && f[0].classList.contains("apexcharts-tooltip-marker") && (l.config.tooltip.marker.fillColors && Array.isArray(l.config.tooltip.marker.fillColors) && (n = l.config.tooltip.marker.fillColors[e]), f[0].style.backgroundColor = n), l.config.tooltip.marker.show || (f[0].style.display = "none");
                var v = a[e].querySelector(".apexcharts-tooltip-text-goals-label"), m = a[e].querySelector(".apexcharts-tooltip-text-goals-value");
                if (d.length && l.globals.seriesGoals[e]) {
                    var y = function() {
                        var t = "<div >", e = "<div>";
                        d.forEach(function(i, a) {
                            t += ' <div style="display: flex"><span class="apexcharts-tooltip-marker" style="background-color: '.concat(i.attrs.strokeColor, '; height: 3px; border-radius: 0; top: 5px;"></span> ').concat(i.attrs.name, "</div>"), e += "<div>".concat(i.val, "</div>");
                        }), v.innerHTML = t + "</div>", m.innerHTML = e + "</div>";
                    };
                    o ? l.globals.seriesGoals[e][i] && Array.isArray(l.globals.seriesGoals[e][i]) ? y() : (v.innerHTML = "", m.innerHTML = "") : y();
                } else v.innerHTML = "", m.innerHTML = "";
                null !== p && (a[e].querySelector(".apexcharts-tooltip-text-z-label").innerHTML = l.config.tooltip.z.title, a[e].querySelector(".apexcharts-tooltip-text-z-value").innerHTML = void 0 !== p ? p : "");
                if (o && f[0]) {
                    if (l.config.tooltip.hideEmptySeries) {
                        var w = a[e].querySelector(".apexcharts-tooltip-marker"), k = a[e].querySelector(".apexcharts-tooltip-text");
                        0 == parseFloat(c) ? (w.style.display = "none", k.style.display = "none") : (w.style.display = "block", k.style.display = "block");
                    }
                    null == c || l.globals.ancillaryCollapsedSeriesIndices.indexOf(e) > -1 || l.globals.collapsedSeriesIndices.indexOf(e) > -1 ? f[0].parentNode.style.display = "none" : f[0].parentNode.style.display = l.config.tooltip.items.display;
                }
            }
        },
        {
            key: "toggleActiveInactiveSeries",
            value: function(t) {
                var e = this.w;
                if (t) this.tooltipUtil.toggleAllTooltipSeriesGroups("enable");
                else {
                    this.tooltipUtil.toggleAllTooltipSeriesGroups("disable");
                    var i = e.globals.dom.baseEl.querySelector(".apexcharts-tooltip-series-group");
                    i && (i.classList.add("apexcharts-active"), i.style.display = e.config.tooltip.items.display);
                }
            }
        },
        {
            key: "getValuesToPrint",
            value: function(t) {
                var e = t.i, i = t.j, a = this.w, s = this.ctx.series.filteredSeriesX(), r = "", o = "", n = null, l = null, h = {
                    series: a.globals.series,
                    seriesIndex: e,
                    dataPointIndex: i,
                    w: a
                }, c = a.globals.ttZFormatter;
                null === i ? l = a.globals.series[e] : a.globals.isXNumeric && "treemap" !== a.config.chart.type ? (r = s[e][i], 0 === s[e].length && (r = s[this.tooltipUtil.getFirstActiveXArray(s)][i])) : r = void 0 !== a.globals.labels[i] ? a.globals.labels[i] : "";
                var d = r;
                a.globals.isXNumeric && "datetime" === a.config.xaxis.type ? r = new $fffa43d1c55f0813$var$T(this.ctx).xLabelFormat(a.globals.ttKeyFormatter, d, d, {
                    i: void 0,
                    dateFormatter: new $fffa43d1c55f0813$var$I(this.ctx).formatDate,
                    w: this.w
                }) : r = a.globals.isBarHorizontal ? a.globals.yLabelFormatters[0](d, h) : a.globals.xLabelFormatter(d, h);
                return void 0 !== a.config.tooltip.x.formatter && (r = a.globals.ttKeyFormatter(d, h)), a.globals.seriesZ.length > 0 && a.globals.seriesZ[e].length > 0 && (n = c(a.globals.seriesZ[e][i], a)), o = "function" == typeof a.config.xaxis.tooltip.formatter ? a.globals.xaxisTooltipFormatter(d, h) : r, {
                    val: Array.isArray(l) ? l.join(" ") : l,
                    xVal: Array.isArray(r) ? r.join(" ") : r,
                    xAxisTTVal: Array.isArray(o) ? o.join(" ") : o,
                    zVal: n
                };
            }
        },
        {
            key: "handleCustomTooltip",
            value: function(t) {
                var e = t.i, i = t.j, a = t.y1, s = t.y2, r = t.w, o = this.ttCtx.getElTooltip(), n = r.config.tooltip.custom;
                Array.isArray(n) && n[e] && (n = n[e]), o.innerHTML = n({
                    ctx: this.ctx,
                    series: r.globals.series,
                    seriesIndex: e,
                    dataPointIndex: i,
                    y1: a,
                    y2: s,
                    w: r
                });
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$ut = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ttCtx = e, this.ctx = e.ctx, this.w = e.w;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "moveXCrosshairs",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, i = this.ttCtx, a = this.w, s = i.getElXCrosshairs(), r = t - i.xcrosshairsWidth / 2, o = a.globals.labels.slice().length;
                if (null !== e && (r = a.globals.gridWidth / o * e), null === s || a.globals.isBarHorizontal || (s.setAttribute("x", r), s.setAttribute("x1", r), s.setAttribute("x2", r), s.setAttribute("y2", a.globals.gridHeight), s.classList.add("apexcharts-active")), r < 0 && (r = 0), r > a.globals.gridWidth && (r = a.globals.gridWidth), i.isXAxisTooltipEnabled) {
                    var n = r;
                    "tickWidth" !== a.config.xaxis.crosshairs.width && "barWidth" !== a.config.xaxis.crosshairs.width || (n = r + i.xcrosshairsWidth / 2), this.moveXAxisTooltip(n);
                }
            }
        },
        {
            key: "moveYCrosshairs",
            value: function(t) {
                var e = this.ttCtx;
                null !== e.ycrosshairs && $fffa43d1c55f0813$var$m.setAttrs(e.ycrosshairs, {
                    y1: t,
                    y2: t
                }), null !== e.ycrosshairsHidden && $fffa43d1c55f0813$var$m.setAttrs(e.ycrosshairsHidden, {
                    y1: t,
                    y2: t
                });
            }
        },
        {
            key: "moveXAxisTooltip",
            value: function(t) {
                var e = this.w, i = this.ttCtx;
                if (null !== i.xaxisTooltip && 0 !== i.xcrosshairsWidth) {
                    i.xaxisTooltip.classList.add("apexcharts-active");
                    var a = i.xaxisOffY + e.config.xaxis.tooltip.offsetY + e.globals.translateY + 1 + e.config.xaxis.offsetY;
                    if (t -= i.xaxisTooltip.getBoundingClientRect().width / 2, !isNaN(t)) {
                        t += e.globals.translateX;
                        var s;
                        s = new $fffa43d1c55f0813$var$m(this.ctx).getTextRects(i.xaxisTooltipText.innerHTML), i.xaxisTooltipText.style.minWidth = s.width + "px", i.xaxisTooltip.style.left = t + "px", i.xaxisTooltip.style.top = a + "px";
                    }
                }
            }
        },
        {
            key: "moveYAxisTooltip",
            value: function(t) {
                var e = this.w, i = this.ttCtx;
                null === i.yaxisTTEls && (i.yaxisTTEls = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));
                var a = parseInt(i.ycrosshairsHidden.getAttribute("y1"), 10), s = e.globals.translateY + a, r = i.yaxisTTEls[t].getBoundingClientRect().height, o = e.globals.translateYAxisX[t] - 2;
                e.config.yaxis[t].opposite && (o -= 26), s -= r / 2, -1 === e.globals.ignoreYAxisIndexes.indexOf(t) ? (i.yaxisTTEls[t].classList.add("apexcharts-active"), i.yaxisTTEls[t].style.top = s + "px", i.yaxisTTEls[t].style.left = o + e.config.yaxis[t].tooltip.offsetX + "px") : i.yaxisTTEls[t].classList.remove("apexcharts-active");
            }
        },
        {
            key: "moveTooltip",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = this.w, s = this.ttCtx, r = s.getElTooltip(), o = s.tooltipRect, n = null !== i ? parseFloat(i) : 1, l = parseFloat(t) + n + 5, h = parseFloat(e) + n / 2;
                if (l > a.globals.gridWidth / 2 && (l = l - o.ttWidth - n - 10), l > a.globals.gridWidth - o.ttWidth - 10 && (l = a.globals.gridWidth - o.ttWidth), l < -20 && (l = -20), a.config.tooltip.followCursor) {
                    var c = s.getElGrid().getBoundingClientRect();
                    (l = s.e.clientX - c.left) > a.globals.gridWidth / 2 && (l -= s.tooltipRect.ttWidth), (h = s.e.clientY + a.globals.translateY - c.top) > a.globals.gridHeight / 2 && (h -= s.tooltipRect.ttHeight);
                } else a.globals.isBarHorizontal || o.ttHeight / 2 + h > a.globals.gridHeight && (h = a.globals.gridHeight - o.ttHeight + a.globals.translateY);
                isNaN(l) || (l += a.globals.translateX, r.style.left = l + "px", r.style.top = h + "px");
            }
        },
        {
            key: "moveMarkers",
            value: function(t, e) {
                var i = this.w, a = this.ttCtx;
                if (i.globals.markers.size[t] > 0) for(var s = i.globals.dom.baseEl.querySelectorAll(" .apexcharts-series[data\\:realIndex='".concat(t, "'] .apexcharts-marker")), r = 0; r < s.length; r++)parseInt(s[r].getAttribute("rel"), 10) === e && (a.marker.resetPointsSize(), a.marker.enlargeCurrentPoint(e, s[r]));
                else a.marker.resetPointsSize(), this.moveDynamicPointOnHover(e, t);
            }
        },
        {
            key: "moveDynamicPointOnHover",
            value: function(t, e) {
                var i, a, s = this.w, r = this.ttCtx, o = s.globals.pointsArray, n = r.tooltipUtil.getHoverMarkerSize(e), l = s.config.series[e].type;
                if (!l || "column" !== l && "candlestick" !== l && "boxPlot" !== l) {
                    i = o[e][t][0], a = o[e][t][1] ? o[e][t][1] : 0;
                    var h = s.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(e, "'] .apexcharts-series-markers circle"));
                    h && a < s.globals.gridHeight && a > 0 && (h.setAttribute("r", n), h.setAttribute("cx", i), h.setAttribute("cy", a)), this.moveXCrosshairs(i), r.fixedTooltip || this.moveTooltip(i, a, n);
                }
            }
        },
        {
            key: "moveDynamicPointsOnHover",
            value: function(t) {
                var e, i = this.ttCtx, a = i.w, s = 0, r = 0, o = a.globals.pointsArray;
                e = new $fffa43d1c55f0813$var$N(this.ctx).getActiveConfigSeriesIndex("asc", [
                    "line",
                    "area",
                    "scatter",
                    "bubble"
                ]);
                var n = i.tooltipUtil.getHoverMarkerSize(e);
                o[e] && (s = o[e][t][0], r = o[e][t][1]);
                var l = i.tooltipUtil.getAllMarkers();
                if (null !== l) for(var h = 0; h < a.globals.series.length; h++){
                    var c = o[h];
                    if (a.globals.comboCharts && void 0 === c && l.splice(h, 0, null), c && c.length) {
                        var d = o[h][t][1], g = void 0;
                        if (l[h].setAttribute("cx", s), "rangeArea" === a.config.chart.type && !a.globals.comboCharts) {
                            var u = t + a.globals.series[h].length;
                            g = o[h][u][1], d -= Math.abs(d - g) / 2;
                        }
                        null !== d && !isNaN(d) && d < a.globals.gridHeight + n && d + n > 0 ? (l[h] && l[h].setAttribute("r", n), l[h] && l[h].setAttribute("cy", d)) : l[h] && l[h].setAttribute("r", 0);
                    }
                }
                this.moveXCrosshairs(s), i.fixedTooltip || this.moveTooltip(s, r || a.globals.gridHeight, n);
            }
        },
        {
            key: "moveStickyTooltipOverBars",
            value: function(t, e) {
                var i = this.w, a = this.ttCtx, s = i.globals.columnSeries ? i.globals.columnSeries.length : i.globals.series.length, r = s >= 2 && s % 2 == 0 ? Math.floor(s / 2) : Math.floor(s / 2) + 1;
                i.globals.isBarHorizontal && (r = new $fffa43d1c55f0813$var$N(this.ctx).getActiveConfigSeriesIndex("desc") + 1);
                var o = i.globals.dom.baseEl.querySelector(".apexcharts-bar-series .apexcharts-series[rel='".concat(r, "'] path[j='").concat(t, "'], .apexcharts-candlestick-series .apexcharts-series[rel='").concat(r, "'] path[j='").concat(t, "'], .apexcharts-boxPlot-series .apexcharts-series[rel='").concat(r, "'] path[j='").concat(t, "'], .apexcharts-rangebar-series .apexcharts-series[rel='").concat(r, "'] path[j='").concat(t, "']"));
                o || "number" != typeof e || (o = i.globals.dom.baseEl.querySelector(".apexcharts-bar-series .apexcharts-series[data\\:realIndex='".concat(e, "'] path[j='").concat(t, "'],\n        .apexcharts-candlestick-series .apexcharts-series[data\\:realIndex='").concat(e, "'] path[j='").concat(t, "'],\n        .apexcharts-boxPlot-series .apexcharts-series[data\\:realIndex='").concat(e, "'] path[j='").concat(t, "'],\n        .apexcharts-rangebar-series .apexcharts-series[data\\:realIndex='").concat(e, "'] path[j='").concat(t, "']")));
                var n = o ? parseFloat(o.getAttribute("cx")) : 0, l = o ? parseFloat(o.getAttribute("cy")) : 0, h = o ? parseFloat(o.getAttribute("barWidth")) : 0, c = a.getElGrid().getBoundingClientRect(), d = o && (o.classList.contains("apexcharts-candlestick-area") || o.classList.contains("apexcharts-boxPlot-area"));
                i.globals.isXNumeric ? (o && !d && (n -= s % 2 != 0 ? h / 2 : 0), o && d && i.globals.comboCharts && (n -= h / 2)) : i.globals.isBarHorizontal || (n = a.xAxisTicksPositions[t - 1] + a.dataPointsDividedWidth / 2, isNaN(n) && (n = a.xAxisTicksPositions[t] - a.dataPointsDividedWidth / 2)), i.globals.isBarHorizontal ? l -= a.tooltipRect.ttHeight : i.config.tooltip.followCursor ? l = a.e.clientY - c.top - a.tooltipRect.ttHeight / 2 : l + a.tooltipRect.ttHeight + 15 > i.globals.gridHeight && (l = i.globals.gridHeight), i.globals.isBarHorizontal || this.moveXCrosshairs(n), a.fixedTooltip || this.moveTooltip(n, l || i.globals.gridHeight);
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$pt = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.w = e.w, this.ttCtx = e, this.ctx = e.ctx, this.tooltipPosition = new $fffa43d1c55f0813$var$ut(e);
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "drawDynamicPoints",
            value: function() {
                var t = this.w, e = new $fffa43d1c55f0813$var$m(this.ctx), i = new $fffa43d1c55f0813$var$H(this.ctx), a = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series");
                a = $fffa43d1c55f0813$var$u(a), t.config.chart.stacked && a.sort(function(t, e) {
                    return parseFloat(t.getAttribute("data:realIndex")) - parseFloat(e.getAttribute("data:realIndex"));
                });
                for(var s = 0; s < a.length; s++){
                    var r = a[s].querySelector(".apexcharts-series-markers-wrap");
                    if (null !== r) {
                        var o = void 0, n = "apexcharts-marker w".concat((Math.random() + 1).toString(36).substring(4));
                        "line" !== t.config.chart.type && "area" !== t.config.chart.type || t.globals.comboCharts || t.config.tooltip.intersect || (n += " no-pointer-events");
                        var l = i.getMarkerConfig({
                            cssClass: n,
                            seriesIndex: Number(r.getAttribute("data:realIndex"))
                        });
                        (o = e.drawMarker(0, 0, l)).node.setAttribute("default-marker-size", 0);
                        var h = document.createElementNS(t.globals.SVGNS, "g");
                        h.classList.add("apexcharts-series-markers"), h.appendChild(o.node), r.appendChild(h);
                    }
                }
            }
        },
        {
            key: "enlargeCurrentPoint",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null, s = this.w;
                "bubble" !== s.config.chart.type && this.newPointSize(t, e);
                var r = e.getAttribute("cx"), o = e.getAttribute("cy");
                if (null !== i && null !== a && (r = i, o = a), this.tooltipPosition.moveXCrosshairs(r), !this.fixedTooltip) {
                    if ("radar" === s.config.chart.type) {
                        var n = this.ttCtx.getElGrid().getBoundingClientRect();
                        r = this.ttCtx.e.clientX - n.left;
                    }
                    this.tooltipPosition.moveTooltip(r, o, s.config.markers.hover.size);
                }
            }
        },
        {
            key: "enlargePoints",
            value: function(t) {
                for(var e = this.w, i = this, a = this.ttCtx, s = t, r = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"), o = e.config.markers.hover.size, n = 0; n < r.length; n++){
                    var l = r[n].getAttribute("rel"), h = r[n].getAttribute("index");
                    if (void 0 === o && (o = e.globals.markers.size[h] + e.config.markers.hover.sizeOffset), s === parseInt(l, 10)) {
                        i.newPointSize(s, r[n]);
                        var c = r[n].getAttribute("cx"), d = r[n].getAttribute("cy");
                        i.tooltipPosition.moveXCrosshairs(c), a.fixedTooltip || i.tooltipPosition.moveTooltip(c, d, o);
                    } else i.oldPointSize(r[n]);
                }
            }
        },
        {
            key: "newPointSize",
            value: function(t, e) {
                var i = this.w, a = i.config.markers.hover.size, s = 0 === t ? e.parentNode.firstChild : e.parentNode.lastChild;
                if ("0" !== s.getAttribute("default-marker-size")) {
                    var r = parseInt(s.getAttribute("index"), 10);
                    void 0 === a && (a = i.globals.markers.size[r] + i.config.markers.hover.sizeOffset), a < 0 && (a = 0), s.setAttribute("r", a);
                }
            }
        },
        {
            key: "oldPointSize",
            value: function(t) {
                var e = parseFloat(t.getAttribute("default-marker-size"));
                t.setAttribute("r", e);
            }
        },
        {
            key: "resetPointsSize",
            value: function() {
                for(var t = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"), e = 0; e < t.length; e++){
                    var i = parseFloat(t[e].getAttribute("default-marker-size"));
                    $fffa43d1c55f0813$var$x.isNumber(i) && i >= 0 ? t[e].setAttribute("r", i) : t[e].setAttribute("r", 0);
                }
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$ft = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.w = e.w;
        var i = this.w;
        this.ttCtx = e, this.isVerticalGroupedRangeBar = !i.globals.isBarHorizontal && "rangeBar" === i.config.chart.type && i.config.plotOptions.bar.rangeBarGroupRows;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "getAttr",
            value: function(t, e) {
                return parseFloat(t.target.getAttribute(e));
            }
        },
        {
            key: "handleHeatTreeTooltip",
            value: function(t) {
                var e = t.e, i = t.opt, a = t.x, s = t.y, r = t.type, o = this.ttCtx, n = this.w;
                if (e.target.classList.contains("apexcharts-".concat(r, "-rect"))) {
                    var l = this.getAttr(e, "i"), h = this.getAttr(e, "j"), c = this.getAttr(e, "cx"), d = this.getAttr(e, "cy"), g = this.getAttr(e, "width"), u = this.getAttr(e, "height");
                    if (o.tooltipLabels.drawSeriesTexts({
                        ttItems: i.ttItems,
                        i: l,
                        j: h,
                        shared: !1,
                        e: e
                    }), n.globals.capturedSeriesIndex = l, n.globals.capturedDataPointIndex = h, a = c + o.tooltipRect.ttWidth / 2 + g, s = d + o.tooltipRect.ttHeight / 2 - u / 2, o.tooltipPosition.moveXCrosshairs(c + g / 2), a > n.globals.gridWidth / 2 && (a = c - o.tooltipRect.ttWidth / 2 + g), o.w.config.tooltip.followCursor) {
                        var p = n.globals.dom.elWrap.getBoundingClientRect();
                        a = n.globals.clientX - p.left - (a > n.globals.gridWidth / 2 ? o.tooltipRect.ttWidth : 0), s = n.globals.clientY - p.top - (s > n.globals.gridHeight / 2 ? o.tooltipRect.ttHeight : 0);
                    }
                }
                return {
                    x: a,
                    y: s
                };
            }
        },
        {
            key: "handleMarkerTooltip",
            value: function(t) {
                var e, i, a = t.e, s = t.opt, r = t.x, o = t.y, n = this.w, l = this.ttCtx;
                if (a.target.classList.contains("apexcharts-marker")) {
                    var h = parseInt(s.paths.getAttribute("cx"), 10), c = parseInt(s.paths.getAttribute("cy"), 10), d = parseFloat(s.paths.getAttribute("val"));
                    if (i = parseInt(s.paths.getAttribute("rel"), 10), e = parseInt(s.paths.parentNode.parentNode.parentNode.getAttribute("rel"), 10) - 1, l.intersect) {
                        var g = $fffa43d1c55f0813$var$x.findAncestor(s.paths, "apexcharts-series");
                        g && (e = parseInt(g.getAttribute("data:realIndex"), 10));
                    }
                    if (l.tooltipLabels.drawSeriesTexts({
                        ttItems: s.ttItems,
                        i: e,
                        j: i,
                        shared: !l.showOnIntersect && n.config.tooltip.shared,
                        e: a
                    }), "mouseup" === a.type && l.markerClick(a, e, i), n.globals.capturedSeriesIndex = e, n.globals.capturedDataPointIndex = i, r = h, o = c + n.globals.translateY - 1.4 * l.tooltipRect.ttHeight, l.w.config.tooltip.followCursor) {
                        var u = l.getElGrid().getBoundingClientRect();
                        o = l.e.clientY + n.globals.translateY - u.top;
                    }
                    d < 0 && (o = c), l.marker.enlargeCurrentPoint(i, s.paths, r, o);
                }
                return {
                    x: r,
                    y: o
                };
            }
        },
        {
            key: "handleBarTooltip",
            value: function(t) {
                var e, i, a = t.e, s = t.opt, r = this.w, o = this.ttCtx, n = o.getElTooltip(), l = 0, h = 0, c = 0, d = this.getBarTooltipXY({
                    e: a,
                    opt: s
                });
                e = d.i;
                var g = d.barHeight, u = d.j;
                r.globals.capturedSeriesIndex = e, r.globals.capturedDataPointIndex = u, r.globals.isBarHorizontal && o.tooltipUtil.hasBars() || !r.config.tooltip.shared ? (h = d.x, c = d.y, i = Array.isArray(r.config.stroke.width) ? r.config.stroke.width[e] : r.config.stroke.width, l = h) : r.globals.comboCharts || r.config.tooltip.shared || (l /= 2), isNaN(c) && (c = r.globals.svgHeight - o.tooltipRect.ttHeight);
                var p = parseInt(s.paths.parentNode.getAttribute("data:realIndex"), 10), f = r.globals.isMultipleYAxis ? r.config.yaxis[p] && r.config.yaxis[p].reversed : r.config.yaxis[0].reversed;
                if (h + o.tooltipRect.ttWidth > r.globals.gridWidth && !f ? h -= o.tooltipRect.ttWidth : h < 0 && (h = 0), o.w.config.tooltip.followCursor) {
                    var x = o.getElGrid().getBoundingClientRect();
                    c = o.e.clientY - x.top;
                }
                null === o.tooltip && (o.tooltip = r.globals.dom.baseEl.querySelector(".apexcharts-tooltip")), r.config.tooltip.shared || (r.globals.comboBarCount > 0 ? o.tooltipPosition.moveXCrosshairs(l + i / 2) : o.tooltipPosition.moveXCrosshairs(l)), !o.fixedTooltip && (!r.config.tooltip.shared || r.globals.isBarHorizontal && o.tooltipUtil.hasBars()) && (f && (h -= o.tooltipRect.ttWidth) < 0 && (h = 0), !f || r.globals.isBarHorizontal && o.tooltipUtil.hasBars() || (c = c + g - 2 * (r.globals.series[e][u] < 0 ? g : 0)), c = c + r.globals.translateY - o.tooltipRect.ttHeight / 2, n.style.left = h + r.globals.translateX + "px", n.style.top = c + "px");
            }
        },
        {
            key: "getBarTooltipXY",
            value: function(t) {
                var e = this, i = t.e, a = t.opt, s = this.w, r = null, o = this.ttCtx, n = 0, l = 0, h = 0, c = 0, d = 0, g = i.target.classList;
                if (g.contains("apexcharts-bar-area") || g.contains("apexcharts-candlestick-area") || g.contains("apexcharts-boxPlot-area") || g.contains("apexcharts-rangebar-area")) {
                    var u = i.target, p = u.getBoundingClientRect(), f = a.elGrid.getBoundingClientRect(), x = p.height;
                    d = p.height;
                    var b = p.width, v = parseInt(u.getAttribute("cx"), 10), m = parseInt(u.getAttribute("cy"), 10);
                    c = parseFloat(u.getAttribute("barWidth"));
                    var y = "touchmove" === i.type ? i.touches[0].clientX : i.clientX;
                    r = parseInt(u.getAttribute("j"), 10), n = parseInt(u.parentNode.getAttribute("rel"), 10) - 1;
                    var w = u.getAttribute("data-range-y1"), k = u.getAttribute("data-range-y2");
                    s.globals.comboCharts && (n = parseInt(u.parentNode.getAttribute("data:realIndex"), 10));
                    var A = function(t) {
                        return s.globals.isXNumeric ? v - b / 2 : e.isVerticalGroupedRangeBar ? v + b / 2 : v - o.dataPointsDividedWidth + b / 2;
                    }, S = function() {
                        return m - o.dataPointsDividedHeight + x / 2 - o.tooltipRect.ttHeight / 2;
                    };
                    o.tooltipLabels.drawSeriesTexts({
                        ttItems: a.ttItems,
                        i: n,
                        j: r,
                        y1: w ? parseInt(w, 10) : null,
                        y2: k ? parseInt(k, 10) : null,
                        shared: !o.showOnIntersect && s.config.tooltip.shared,
                        e: i
                    }), s.config.tooltip.followCursor ? s.globals.isBarHorizontal ? (l = y - f.left + 15, h = S()) : (l = A(), h = i.clientY - f.top - o.tooltipRect.ttHeight / 2 - 15) : s.globals.isBarHorizontal ? ((l = v) < o.xyRatios.baseLineInvertedY && (l = v - o.tooltipRect.ttWidth), h = S()) : (l = A(), h = m);
                }
                return {
                    x: l,
                    y: h,
                    barHeight: d,
                    barWidth: c,
                    i: n,
                    j: r
                };
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$xt = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.w = e.w, this.ttCtx = e;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "drawXaxisTooltip",
            value: function() {
                var t = this.w, e = this.ttCtx, i = "bottom" === t.config.xaxis.position;
                e.xaxisOffY = i ? t.globals.gridHeight + 1 : -t.globals.xAxisHeight - t.config.xaxis.axisTicks.height + 3;
                var a = i ? "apexcharts-xaxistooltip apexcharts-xaxistooltip-bottom" : "apexcharts-xaxistooltip apexcharts-xaxistooltip-top", s = t.globals.dom.elWrap;
                e.isXAxisTooltipEnabled && null === t.globals.dom.baseEl.querySelector(".apexcharts-xaxistooltip") && (e.xaxisTooltip = document.createElement("div"), e.xaxisTooltip.setAttribute("class", a + " apexcharts-theme-" + t.config.tooltip.theme), s.appendChild(e.xaxisTooltip), e.xaxisTooltipText = document.createElement("div"), e.xaxisTooltipText.classList.add("apexcharts-xaxistooltip-text"), e.xaxisTooltipText.style.fontFamily = t.config.xaxis.tooltip.style.fontFamily || t.config.chart.fontFamily, e.xaxisTooltipText.style.fontSize = t.config.xaxis.tooltip.style.fontSize, e.xaxisTooltip.appendChild(e.xaxisTooltipText));
            }
        },
        {
            key: "drawYaxisTooltip",
            value: function() {
                for(var t = this.w, e = this.ttCtx, i = function(i) {
                    var a = t.config.yaxis[i].opposite || t.config.yaxis[i].crosshairs.opposite;
                    e.yaxisOffX = a ? t.globals.gridWidth + 1 : 1;
                    var s = "apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(i, a ? " apexcharts-yaxistooltip-right" : " apexcharts-yaxistooltip-left");
                    t.globals.yAxisSameScaleIndices.map(function(e, a) {
                        e.map(function(e, a) {
                            a === i && (s += t.config.yaxis[a].show ? " " : " apexcharts-yaxistooltip-hidden");
                        });
                    });
                    var r = t.globals.dom.elWrap;
                    null === t.globals.dom.baseEl.querySelector(".apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(i)) && (e.yaxisTooltip = document.createElement("div"), e.yaxisTooltip.setAttribute("class", s + " apexcharts-theme-" + t.config.tooltip.theme), r.appendChild(e.yaxisTooltip), 0 === i && (e.yaxisTooltipText = []), e.yaxisTooltipText[i] = document.createElement("div"), e.yaxisTooltipText[i].classList.add("apexcharts-yaxistooltip-text"), e.yaxisTooltip.appendChild(e.yaxisTooltipText[i]));
                }, a = 0; a < t.config.yaxis.length; a++)i(a);
            }
        },
        {
            key: "setXCrosshairWidth",
            value: function() {
                var t = this.w, e = this.ttCtx, i = e.getElXCrosshairs();
                if (e.xcrosshairsWidth = parseInt(t.config.xaxis.crosshairs.width, 10), t.globals.comboCharts) {
                    var a = t.globals.dom.baseEl.querySelector(".apexcharts-bar-area");
                    if (null !== a && "barWidth" === t.config.xaxis.crosshairs.width) {
                        var s = parseFloat(a.getAttribute("barWidth"));
                        e.xcrosshairsWidth = s;
                    } else if ("tickWidth" === t.config.xaxis.crosshairs.width) {
                        var r = t.globals.labels.length;
                        e.xcrosshairsWidth = t.globals.gridWidth / r;
                    }
                } else if ("tickWidth" === t.config.xaxis.crosshairs.width) {
                    var o = t.globals.labels.length;
                    e.xcrosshairsWidth = t.globals.gridWidth / o;
                } else if ("barWidth" === t.config.xaxis.crosshairs.width) {
                    var n = t.globals.dom.baseEl.querySelector(".apexcharts-bar-area");
                    if (null !== n) {
                        var l = parseFloat(n.getAttribute("barWidth"));
                        e.xcrosshairsWidth = l;
                    } else e.xcrosshairsWidth = 1;
                }
                t.globals.isBarHorizontal && (e.xcrosshairsWidth = 0), null !== i && e.xcrosshairsWidth > 0 && i.setAttribute("width", e.xcrosshairsWidth);
            }
        },
        {
            key: "handleYCrosshair",
            value: function() {
                var t = this.w, e = this.ttCtx;
                e.ycrosshairs = t.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs"), e.ycrosshairsHidden = t.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs-hidden");
            }
        },
        {
            key: "drawYaxisTooltipText",
            value: function(t, e, i) {
                var a = this.ttCtx, s = this.w, r = s.globals.yLabelFormatters[t];
                if (a.yaxisTooltips[t]) {
                    var o = a.getElGrid().getBoundingClientRect(), n = (e - o.top) * i.yRatio[t], l = s.globals.maxYArr[t] - s.globals.minYArr[t], h = s.globals.minYArr[t] + (l - n);
                    a.tooltipPosition.moveYCrosshairs(e - o.top), a.yaxisTooltipText[t].innerHTML = r(h), a.tooltipPosition.moveYAxisTooltip(t);
                }
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$bt = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w;
        var i = this.w;
        this.tConfig = i.config.tooltip, this.tooltipUtil = new $fffa43d1c55f0813$var$dt(this), this.tooltipLabels = new $fffa43d1c55f0813$var$gt(this), this.tooltipPosition = new $fffa43d1c55f0813$var$ut(this), this.marker = new $fffa43d1c55f0813$var$pt(this), this.intersect = new $fffa43d1c55f0813$var$ft(this), this.axesTooltip = new $fffa43d1c55f0813$var$xt(this), this.showOnIntersect = this.tConfig.intersect, this.showTooltipTitle = this.tConfig.x.show, this.fixedTooltip = this.tConfig.fixed.enabled, this.xaxisTooltip = null, this.yaxisTTEls = null, this.isBarShared = !i.globals.isBarHorizontal && this.tConfig.shared, this.lastHoverTime = Date.now();
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "getElTooltip",
            value: function(t) {
                return t || (t = this), t.w.globals.dom.baseEl ? t.w.globals.dom.baseEl.querySelector(".apexcharts-tooltip") : null;
            }
        },
        {
            key: "getElXCrosshairs",
            value: function() {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-xcrosshairs");
            }
        },
        {
            key: "getElGrid",
            value: function() {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-grid");
            }
        },
        {
            key: "drawTooltip",
            value: function(t) {
                var e = this.w;
                this.xyRatios = t, this.isXAxisTooltipEnabled = e.config.xaxis.tooltip.enabled && e.globals.axisCharts, this.yaxisTooltips = e.config.yaxis.map(function(t, i) {
                    return !!(t.show && t.tooltip.enabled && e.globals.axisCharts);
                }), this.allTooltipSeriesGroups = [], e.globals.axisCharts || (this.showTooltipTitle = !1);
                var i = document.createElement("div");
                if (i.classList.add("apexcharts-tooltip"), e.config.tooltip.cssClass && i.classList.add(e.config.tooltip.cssClass), i.classList.add("apexcharts-theme-".concat(this.tConfig.theme)), e.globals.dom.elWrap.appendChild(i), e.globals.axisCharts) {
                    this.axesTooltip.drawXaxisTooltip(), this.axesTooltip.drawYaxisTooltip(), this.axesTooltip.setXCrosshairWidth(), this.axesTooltip.handleYCrosshair();
                    var a = new $fffa43d1c55f0813$var$V(this.ctx);
                    this.xAxisTicksPositions = a.getXAxisTicksPositions();
                }
                if (!e.globals.comboCharts && !this.tConfig.intersect && "rangeBar" !== e.config.chart.type || this.tConfig.shared || (this.showOnIntersect = !0), 0 !== e.config.markers.size && 0 !== e.globals.markers.largestSize || this.marker.drawDynamicPoints(this), e.globals.collapsedSeries.length !== e.globals.series.length) {
                    this.dataPointsDividedHeight = e.globals.gridHeight / e.globals.dataPoints, this.dataPointsDividedWidth = e.globals.gridWidth / e.globals.dataPoints, this.showTooltipTitle && (this.tooltipTitle = document.createElement("div"), this.tooltipTitle.classList.add("apexcharts-tooltip-title"), this.tooltipTitle.style.fontFamily = this.tConfig.style.fontFamily || e.config.chart.fontFamily, this.tooltipTitle.style.fontSize = this.tConfig.style.fontSize, i.appendChild(this.tooltipTitle));
                    var s = e.globals.series.length;
                    (e.globals.xyCharts || e.globals.comboCharts) && this.tConfig.shared && (s = this.showOnIntersect ? 1 : e.globals.series.length), this.legendLabels = e.globals.dom.baseEl.querySelectorAll(".apexcharts-legend-text"), this.ttItems = this.createTTElements(s), this.addSVGEvents();
                }
            }
        },
        {
            key: "createTTElements",
            value: function(t) {
                for(var e = this, i = this.w, a = [], s = this.getElTooltip(), r = function(r) {
                    var o = document.createElement("div");
                    o.classList.add("apexcharts-tooltip-series-group"), o.style.order = i.config.tooltip.inverseOrder ? t - r : r + 1, e.tConfig.shared && e.tConfig.enabledOnSeries && Array.isArray(e.tConfig.enabledOnSeries) && e.tConfig.enabledOnSeries.indexOf(r) < 0 && o.classList.add("apexcharts-tooltip-series-group-hidden");
                    var n = document.createElement("span");
                    n.classList.add("apexcharts-tooltip-marker"), n.style.backgroundColor = i.globals.colors[r], o.appendChild(n);
                    var l = document.createElement("div");
                    l.classList.add("apexcharts-tooltip-text"), l.style.fontFamily = e.tConfig.style.fontFamily || i.config.chart.fontFamily, l.style.fontSize = e.tConfig.style.fontSize, [
                        "y",
                        "goals",
                        "z"
                    ].forEach(function(t) {
                        var e = document.createElement("div");
                        e.classList.add("apexcharts-tooltip-".concat(t, "-group"));
                        var i = document.createElement("span");
                        i.classList.add("apexcharts-tooltip-text-".concat(t, "-label")), e.appendChild(i);
                        var a = document.createElement("span");
                        a.classList.add("apexcharts-tooltip-text-".concat(t, "-value")), e.appendChild(a), l.appendChild(e);
                    }), o.appendChild(l), s.appendChild(o), a.push(o);
                }, o = 0; o < t; o++)r(o);
                return a;
            }
        },
        {
            key: "addSVGEvents",
            value: function() {
                var t = this.w, e = t.config.chart.type, i = this.getElTooltip(), a = !("bar" !== e && "candlestick" !== e && "boxPlot" !== e && "rangeBar" !== e), s = "area" === e || "line" === e || "scatter" === e || "bubble" === e || "radar" === e, r = t.globals.dom.Paper.node, o = this.getElGrid();
                o && (this.seriesBound = o.getBoundingClientRect());
                var n, l = [], h = [], c = {
                    hoverArea: r,
                    elGrid: o,
                    tooltipEl: i,
                    tooltipY: l,
                    tooltipX: h,
                    ttItems: this.ttItems
                };
                if (t.globals.axisCharts && (s ? n = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series[data\\:longestSeries='true'] .apexcharts-marker") : a ? n = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-bar-area, .apexcharts-series .apexcharts-candlestick-area, .apexcharts-series .apexcharts-boxPlot-area, .apexcharts-series .apexcharts-rangebar-area") : "heatmap" !== e && "treemap" !== e || (n = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-heatmap, .apexcharts-series .apexcharts-treemap")), n && n.length)) for(var d = 0; d < n.length; d++)l.push(n[d].getAttribute("cy")), h.push(n[d].getAttribute("cx"));
                if (t.globals.xyCharts && !this.showOnIntersect || t.globals.comboCharts && !this.showOnIntersect || a && this.tooltipUtil.hasBars() && this.tConfig.shared) this.addPathsEventListeners([
                    r
                ], c);
                else if (a && !t.globals.comboCharts || s && this.showOnIntersect) this.addDatapointEventsListeners(c);
                else if (!t.globals.axisCharts || "heatmap" === e || "treemap" === e) {
                    var g = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series");
                    this.addPathsEventListeners(g, c);
                }
                if (this.showOnIntersect) {
                    var u = t.globals.dom.baseEl.querySelectorAll(".apexcharts-line-series .apexcharts-marker, .apexcharts-area-series .apexcharts-marker");
                    u.length > 0 && this.addPathsEventListeners(u, c), this.tooltipUtil.hasBars() && !this.tConfig.shared && this.addDatapointEventsListeners(c);
                }
            }
        },
        {
            key: "drawFixedTooltipRect",
            value: function() {
                var t = this.w, e = this.getElTooltip(), i = e.getBoundingClientRect(), a = i.width + 10, s = i.height + 10, r = this.tConfig.fixed.offsetX, o = this.tConfig.fixed.offsetY, n = this.tConfig.fixed.position.toLowerCase();
                return n.indexOf("right") > -1 && (r = r + t.globals.svgWidth - a + 10), n.indexOf("bottom") > -1 && (o = o + t.globals.svgHeight - s - 10), e.style.left = r + "px", e.style.top = o + "px", {
                    x: r,
                    y: o,
                    ttWidth: a,
                    ttHeight: s
                };
            }
        },
        {
            key: "addDatapointEventsListeners",
            value: function(t) {
                var e = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers .apexcharts-marker, .apexcharts-bar-area, .apexcharts-candlestick-area, .apexcharts-boxPlot-area, .apexcharts-rangebar-area");
                this.addPathsEventListeners(e, t);
            }
        },
        {
            key: "addPathsEventListeners",
            value: function(t, e) {
                for(var i = this, a = function(a) {
                    var s = {
                        paths: t[a],
                        tooltipEl: e.tooltipEl,
                        tooltipY: e.tooltipY,
                        tooltipX: e.tooltipX,
                        elGrid: e.elGrid,
                        hoverArea: e.hoverArea,
                        ttItems: e.ttItems
                    };
                    [
                        "mousemove",
                        "mouseup",
                        "touchmove",
                        "mouseout",
                        "touchend"
                    ].map(function(e) {
                        return t[a].addEventListener(e, i.onSeriesHover.bind(i, s), {
                            capture: !1,
                            passive: !0
                        });
                    });
                }, s = 0; s < t.length; s++)a(s);
            }
        },
        {
            key: "onSeriesHover",
            value: function(t, e) {
                var i = this, a = Date.now() - this.lastHoverTime;
                a >= 100 ? this.seriesHover(t, e) : (clearTimeout(this.seriesHoverTimeout), this.seriesHoverTimeout = setTimeout(function() {
                    i.seriesHover(t, e);
                }, 100 - a));
            }
        },
        {
            key: "seriesHover",
            value: function(t, e) {
                var i = this;
                this.lastHoverTime = Date.now();
                var a = [], s = this.w;
                s.config.chart.group && (a = this.ctx.getGroupedCharts()), s.globals.axisCharts && (s.globals.minX === -1 / 0 && s.globals.maxX === 1 / 0 || 0 === s.globals.dataPoints) || (a.length ? a.forEach(function(a) {
                    var s = i.getElTooltip(a), r = {
                        paths: t.paths,
                        tooltipEl: s,
                        tooltipY: t.tooltipY,
                        tooltipX: t.tooltipX,
                        elGrid: t.elGrid,
                        hoverArea: t.hoverArea,
                        ttItems: a.w.globals.tooltip.ttItems
                    };
                    a.w.globals.minX === i.w.globals.minX && a.w.globals.maxX === i.w.globals.maxX && a.w.globals.tooltip.seriesHoverByContext({
                        chartCtx: a,
                        ttCtx: a.w.globals.tooltip,
                        opt: r,
                        e: e
                    });
                }) : this.seriesHoverByContext({
                    chartCtx: this.ctx,
                    ttCtx: this.w.globals.tooltip,
                    opt: t,
                    e: e
                }));
            }
        },
        {
            key: "seriesHoverByContext",
            value: function(t) {
                var e = t.chartCtx, i = t.ttCtx, a = t.opt, s = t.e, r = e.w, o = this.getElTooltip();
                if (o) {
                    if (i.tooltipRect = {
                        x: 0,
                        y: 0,
                        ttWidth: o.getBoundingClientRect().width,
                        ttHeight: o.getBoundingClientRect().height
                    }, i.e = s, i.tooltipUtil.hasBars() && !r.globals.comboCharts && !i.isBarShared) {
                        if (this.tConfig.onDatasetHover.highlightDataSeries) new $fffa43d1c55f0813$var$N(e).toggleSeriesOnHover(s, s.target.parentNode);
                    }
                    i.fixedTooltip && i.drawFixedTooltipRect(), r.globals.axisCharts ? i.axisChartsTooltips({
                        e: s,
                        opt: a,
                        tooltipRect: i.tooltipRect
                    }) : i.nonAxisChartsTooltips({
                        e: s,
                        opt: a,
                        tooltipRect: i.tooltipRect
                    });
                }
            }
        },
        {
            key: "axisChartsTooltips",
            value: function(t) {
                var e, i, a = t.e, s = t.opt, r = this.w, o = s.elGrid.getBoundingClientRect(), n = "touchmove" === a.type ? a.touches[0].clientX : a.clientX, l = "touchmove" === a.type ? a.touches[0].clientY : a.clientY;
                if (this.clientY = l, this.clientX = n, r.globals.capturedSeriesIndex = -1, r.globals.capturedDataPointIndex = -1, l < o.top || l > o.top + o.height) this.handleMouseOut(s);
                else {
                    if (Array.isArray(this.tConfig.enabledOnSeries) && !r.config.tooltip.shared) {
                        var h = parseInt(s.paths.getAttribute("index"), 10);
                        if (this.tConfig.enabledOnSeries.indexOf(h) < 0) return void this.handleMouseOut(s);
                    }
                    var c = this.getElTooltip(), d = this.getElXCrosshairs(), g = r.globals.xyCharts || "bar" === r.config.chart.type && !r.globals.isBarHorizontal && this.tooltipUtil.hasBars() && this.tConfig.shared || r.globals.comboCharts && this.tooltipUtil.hasBars();
                    if ("mousemove" === a.type || "touchmove" === a.type || "mouseup" === a.type) {
                        if (r.globals.collapsedSeries.length + r.globals.ancillaryCollapsedSeries.length === r.globals.series.length) return;
                        null !== d && d.classList.add("apexcharts-active");
                        var u = this.yaxisTooltips.filter(function(t) {
                            return !0 === t;
                        });
                        if (null !== this.ycrosshairs && u.length && this.ycrosshairs.classList.add("apexcharts-active"), g && !this.showOnIntersect) this.handleStickyTooltip(a, n, l, s);
                        else if ("heatmap" === r.config.chart.type || "treemap" === r.config.chart.type) {
                            var p = this.intersect.handleHeatTreeTooltip({
                                e: a,
                                opt: s,
                                x: e,
                                y: i,
                                type: r.config.chart.type
                            });
                            e = p.x, i = p.y, c.style.left = e + "px", c.style.top = i + "px";
                        } else this.tooltipUtil.hasBars() && this.intersect.handleBarTooltip({
                            e: a,
                            opt: s
                        }), this.tooltipUtil.hasMarkers() && this.intersect.handleMarkerTooltip({
                            e: a,
                            opt: s,
                            x: e,
                            y: i
                        });
                        if (this.yaxisTooltips.length) for(var f = 0; f < r.config.yaxis.length; f++)this.axesTooltip.drawYaxisTooltipText(f, l, this.xyRatios);
                        s.tooltipEl.classList.add("apexcharts-active");
                    } else "mouseout" !== a.type && "touchend" !== a.type || this.handleMouseOut(s);
                }
            }
        },
        {
            key: "nonAxisChartsTooltips",
            value: function(t) {
                var e = t.e, i = t.opt, a = t.tooltipRect, s = this.w, r = i.paths.getAttribute("rel"), o = this.getElTooltip(), n = s.globals.dom.elWrap.getBoundingClientRect();
                if ("mousemove" === e.type || "touchmove" === e.type) {
                    o.classList.add("apexcharts-active"), this.tooltipLabels.drawSeriesTexts({
                        ttItems: i.ttItems,
                        i: parseInt(r, 10) - 1,
                        shared: !1
                    });
                    var l = s.globals.clientX - n.left - a.ttWidth / 2, h = s.globals.clientY - n.top - a.ttHeight - 10;
                    if (o.style.left = l + "px", o.style.top = h + "px", s.config.legend.tooltipHoverFormatter) {
                        var c = r - 1, d = (0, s.config.legend.tooltipHoverFormatter)(this.legendLabels[c].getAttribute("data:default-text"), {
                            seriesIndex: c,
                            dataPointIndex: c,
                            w: s
                        });
                        this.legendLabels[c].innerHTML = d;
                    }
                } else "mouseout" !== e.type && "touchend" !== e.type || (o.classList.remove("apexcharts-active"), s.config.legend.tooltipHoverFormatter && this.legendLabels.forEach(function(t) {
                    var e = t.getAttribute("data:default-text");
                    t.innerHTML = decodeURIComponent(e);
                }));
            }
        },
        {
            key: "handleStickyTooltip",
            value: function(t, e, i, a) {
                var s = this.w, r = this.tooltipUtil.getNearestValues({
                    context: this,
                    hoverArea: a.hoverArea,
                    elGrid: a.elGrid,
                    clientX: e,
                    clientY: i
                }), o = r.j, n = r.capturedSeries;
                s.globals.collapsedSeriesIndices.includes(n) && (n = null);
                var l = a.elGrid.getBoundingClientRect();
                if (r.hoverX < 0 || r.hoverX > l.width) this.handleMouseOut(a);
                else if (null !== n) this.handleStickyCapturedSeries(t, n, a, o);
                else if (this.tooltipUtil.isXoverlap(o) || s.globals.isBarHorizontal) {
                    var h = s.globals.series.findIndex(function(t, e) {
                        return !s.globals.collapsedSeriesIndices.includes(e);
                    });
                    this.create(t, this, h, o, a.ttItems);
                }
            }
        },
        {
            key: "handleStickyCapturedSeries",
            value: function(t, e, i, a) {
                var s = this.w;
                if (!this.tConfig.shared && null === s.globals.series[e][a]) return void this.handleMouseOut(i);
                if (void 0 !== s.globals.series[e][a]) this.tConfig.shared && this.tooltipUtil.isXoverlap(a) && this.tooltipUtil.isInitialSeriesSameLen() ? this.create(t, this, e, a, i.ttItems) : this.create(t, this, e, a, i.ttItems, !1);
                else if (this.tooltipUtil.isXoverlap(a)) {
                    var r = s.globals.series.findIndex(function(t, e) {
                        return !s.globals.collapsedSeriesIndices.includes(e);
                    });
                    this.create(t, this, r, a, i.ttItems);
                }
            }
        },
        {
            key: "deactivateHoverFilter",
            value: function() {
                for(var t = this.w, e = new $fffa43d1c55f0813$var$m(this.ctx), i = t.globals.dom.Paper.select(".apexcharts-bar-area"), a = 0; a < i.length; a++)e.pathMouseLeave(i[a]);
            }
        },
        {
            key: "handleMouseOut",
            value: function(t) {
                var e = this.w, i = this.getElXCrosshairs();
                if (t.tooltipEl.classList.remove("apexcharts-active"), this.deactivateHoverFilter(), "bubble" !== e.config.chart.type && this.marker.resetPointsSize(), null !== i && i.classList.remove("apexcharts-active"), null !== this.ycrosshairs && this.ycrosshairs.classList.remove("apexcharts-active"), this.isXAxisTooltipEnabled && this.xaxisTooltip.classList.remove("apexcharts-active"), this.yaxisTooltips.length) {
                    null === this.yaxisTTEls && (this.yaxisTTEls = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));
                    for(var a = 0; a < this.yaxisTTEls.length; a++)this.yaxisTTEls[a].classList.remove("apexcharts-active");
                }
                e.config.legend.tooltipHoverFormatter && this.legendLabels.forEach(function(t) {
                    var e = t.getAttribute("data:default-text");
                    t.innerHTML = decodeURIComponent(e);
                });
            }
        },
        {
            key: "markerClick",
            value: function(t, e, i) {
                var a = this.w;
                "function" == typeof a.config.chart.events.markerClick && a.config.chart.events.markerClick(t, this.ctx, {
                    seriesIndex: e,
                    dataPointIndex: i,
                    w: a
                }), this.ctx.events.fireEvent("markerClick", [
                    t,
                    this.ctx,
                    {
                        seriesIndex: e,
                        dataPointIndex: i,
                        w: a
                    }
                ]);
            }
        },
        {
            key: "create",
            value: function(t, i, a, s, r) {
                var o, n, l, h, c, d, g, u, p, f, x, b, v, y, w, k, A = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null, S = this.w, C = i;
                "mouseup" === t.type && this.markerClick(t, a, s), null === A && (A = this.tConfig.shared);
                var L = this.tooltipUtil.hasMarkers(a), P = this.tooltipUtil.getElBars();
                if (S.config.legend.tooltipHoverFormatter) {
                    var I = S.config.legend.tooltipHoverFormatter, T = Array.from(this.legendLabels);
                    T.forEach(function(t) {
                        var e = t.getAttribute("data:default-text");
                        t.innerHTML = decodeURIComponent(e);
                    });
                    for(var M = 0; M < T.length; M++){
                        var z = T[M], X = parseInt(z.getAttribute("i"), 10), E = decodeURIComponent(z.getAttribute("data:default-text")), Y = I(E, {
                            seriesIndex: A ? X : a,
                            dataPointIndex: s,
                            w: S
                        });
                        if (A) z.innerHTML = S.globals.collapsedSeriesIndices.indexOf(X) < 0 ? Y : E;
                        else if (z.innerHTML = X === a ? Y : E, a === X) break;
                    }
                }
                var F = $fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({
                    ttItems: r,
                    i: a,
                    j: s
                }, void 0 !== (null === (o = S.globals.seriesRange) || void 0 === o || null === (n = o[a]) || void 0 === n || null === (l = n[s]) || void 0 === l || null === (h = l.y[0]) || void 0 === h ? void 0 : h.y1) && {
                    y1: null === (c = S.globals.seriesRange) || void 0 === c || null === (d = c[a]) || void 0 === d || null === (g = d[s]) || void 0 === g || null === (u = g.y[0]) || void 0 === u ? void 0 : u.y1
                }), void 0 !== (null === (p = S.globals.seriesRange) || void 0 === p || null === (f = p[a]) || void 0 === f || null === (x = f[s]) || void 0 === x || null === (b = x.y[0]) || void 0 === b ? void 0 : b.y2) && {
                    y2: null === (v = S.globals.seriesRange) || void 0 === v || null === (y = v[a]) || void 0 === y || null === (w = y[s]) || void 0 === w || null === (k = w.y[0]) || void 0 === k ? void 0 : k.y2
                });
                if (A) {
                    if (C.tooltipLabels.drawSeriesTexts($fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, F), {}, {
                        shared: !this.showOnIntersect && this.tConfig.shared
                    })), L) S.globals.markers.largestSize > 0 ? C.marker.enlargePoints(s) : C.tooltipPosition.moveDynamicPointsOnHover(s);
                    else if (this.tooltipUtil.hasBars() && (this.barSeriesHeight = this.tooltipUtil.getBarsHeight(P), this.barSeriesHeight > 0)) {
                        var R = new $fffa43d1c55f0813$var$m(this.ctx), H = S.globals.dom.Paper.select(".apexcharts-bar-area[j='".concat(s, "']"));
                        this.deactivateHoverFilter(), this.tooltipPosition.moveStickyTooltipOverBars(s, a);
                        for(var D = 0; D < H.length; D++)R.pathMouseEnter(H[D]);
                    }
                } else C.tooltipLabels.drawSeriesTexts($fffa43d1c55f0813$var$e({
                    shared: !1
                }, F)), this.tooltipUtil.hasBars() && C.tooltipPosition.moveStickyTooltipOverBars(s, a), L && C.tooltipPosition.moveMarkers(a, s);
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$vt = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.w = e.w, this.barCtx = e, this.totalFormatter = this.w.config.plotOptions.bar.dataLabels.total.formatter, this.totalFormatter || (this.totalFormatter = this.w.config.dataLabels.formatter);
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "handleBarDataLabels",
            value: function(t) {
                var e = t.x, i = t.y, a = t.y1, s = t.y2, r = t.i, o = t.j, n = t.realIndex, l = t.groupIndex, h = t.series, c = t.barHeight, d = t.barWidth, g = t.barXPosition, u = t.barYPosition, p = t.visibleSeries, f = t.renderedPath, x = this.w, b = new $fffa43d1c55f0813$var$m(this.barCtx.ctx), v = Array.isArray(this.barCtx.strokeWidth) ? this.barCtx.strokeWidth[n] : this.barCtx.strokeWidth, y = e + parseFloat(d * p), w = i + parseFloat(c * p);
                x.globals.isXNumeric && !x.globals.isBarHorizontal && (y = e + parseFloat(d * (p + 1)), w = i + parseFloat(c * (p + 1)) - v);
                var k, A = null, S = e, C = i, L = {}, P = x.config.dataLabels, I = this.barCtx.barOptions.dataLabels, T = this.barCtx.barOptions.dataLabels.total;
                void 0 !== u && this.barCtx.isRangeBar && (w = u, C = u), void 0 !== g && this.barCtx.isVerticalGroupedRangeBar && (y = g, S = g);
                var M = P.offsetX, z = P.offsetY, X = {
                    width: 0,
                    height: 0
                };
                if (x.config.dataLabels.enabled) {
                    var E = this.barCtx.series[r][o];
                    X = b.getTextRects(x.globals.yLabelFormatters[0](E), parseFloat(P.style.fontSize));
                }
                var Y = {
                    x: e,
                    y: i,
                    i: r,
                    j: o,
                    realIndex: n,
                    groupIndex: l || -1,
                    renderedPath: f,
                    bcx: y,
                    bcy: w,
                    barHeight: c,
                    barWidth: d,
                    textRects: X,
                    strokeWidth: v,
                    dataLabelsX: S,
                    dataLabelsY: C,
                    dataLabelsConfig: P,
                    barDataLabelsConfig: I,
                    barTotalDataLabelsConfig: T,
                    offX: M,
                    offY: z
                };
                return L = this.barCtx.isHorizontal ? this.calculateBarsDataLabelsPosition(Y) : this.calculateColumnsDataLabelsPosition(Y), f.attr({
                    cy: L.bcy,
                    cx: L.bcx,
                    j: o,
                    val: h[r][o],
                    barHeight: c,
                    barWidth: d
                }), k = this.drawCalculatedDataLabels({
                    x: L.dataLabelsX,
                    y: L.dataLabelsY,
                    val: this.barCtx.isRangeBar ? [
                        a,
                        s
                    ] : h[r][o],
                    i: n,
                    j: o,
                    barWidth: d,
                    barHeight: c,
                    textRects: X,
                    dataLabelsConfig: P
                }), x.config.chart.stacked && T.enabled && (A = this.drawTotalDataLabels({
                    x: L.totalDataLabelsX,
                    y: L.totalDataLabelsY,
                    barWidth: d,
                    barHeight: c,
                    realIndex: n,
                    textAnchor: L.totalDataLabelsAnchor,
                    val: this.getStackedTotalDataLabel({
                        realIndex: n,
                        j: o
                    }),
                    dataLabelsConfig: P,
                    barTotalDataLabelsConfig: T
                })), {
                    dataLabels: k,
                    totalDataLabels: A
                };
            }
        },
        {
            key: "getStackedTotalDataLabel",
            value: function(t) {
                var i = t.realIndex, a = t.j, s = this.w, r = this.barCtx.stackedSeriesTotals[a];
                return this.totalFormatter && (r = this.totalFormatter(r, $fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, s), {}, {
                    seriesIndex: i,
                    dataPointIndex: a,
                    w: s
                }))), r;
            }
        },
        {
            key: "calculateColumnsDataLabelsPosition",
            value: function(t) {
                var e, i, a = this.w, s = t.i, r = t.j, o = t.realIndex, n = t.groupIndex, l = t.y, h = t.bcx, c = t.barWidth, d = t.barHeight, g = t.textRects, u = t.dataLabelsX, p = t.dataLabelsY, f = t.dataLabelsConfig, x = t.barDataLabelsConfig, b = t.barTotalDataLabelsConfig, v = t.strokeWidth, y = t.offX, w = t.offY;
                d = Math.abs(d);
                var k = "vertical" === a.config.plotOptions.bar.dataLabels.orientation, A = this.barCtx.barHelpers.getZeroValueEncounters({
                    i: s,
                    j: r
                }).zeroEncounters;
                h = h - v / 2 + (-1 !== n ? n * c : 0);
                var S = a.globals.gridWidth / a.globals.dataPoints;
                if (this.barCtx.isVerticalGroupedRangeBar ? u += c / 2 : (u = a.globals.isXNumeric ? h - c / 2 + y : h - S + c / 2 + y, A > 0 && a.config.plotOptions.bar.hideZeroBarsWhenGrouped && (u -= c * A)), k) u = u + g.height / 2 - v / 2 - 2;
                var C = this.barCtx.series[s][r] < 0, L = l;
                switch(this.barCtx.isReversed && (L = l - d + (C ? 2 * d : 0), l -= d), x.position){
                    case "center":
                        p = k ? C ? L - d / 2 + w : L + d / 2 - w : C ? L - d / 2 + g.height / 2 + w : L + d / 2 + g.height / 2 - w;
                        break;
                    case "bottom":
                        p = k ? C ? L - d + w : L + d - w : C ? L - d + g.height + v + w : L + d - g.height / 2 + v - w;
                        break;
                    case "top":
                        p = k ? C ? L + w : L - w : C ? L - g.height / 2 - w : L + g.height + w;
                }
                if (this.barCtx.lastActiveBarSerieIndex === o && b.enabled) {
                    var P = new $fffa43d1c55f0813$var$m(this.barCtx.ctx).getTextRects(this.getStackedTotalDataLabel({
                        realIndex: o,
                        j: r
                    }), f.fontSize);
                    e = C ? L - P.height / 2 - w - b.offsetY + 18 : L + P.height + w + b.offsetY - 18, i = u + b.offsetX;
                }
                return a.config.chart.stacked || (p < 0 ? p = 0 + v : p + g.height / 3 > a.globals.gridHeight && (p = a.globals.gridHeight - v)), {
                    bcx: h,
                    bcy: l,
                    dataLabelsX: u,
                    dataLabelsY: p,
                    totalDataLabelsX: i,
                    totalDataLabelsY: e,
                    totalDataLabelsAnchor: "middle"
                };
            }
        },
        {
            key: "calculateBarsDataLabelsPosition",
            value: function(t) {
                var e = this.w, i = t.x, a = t.i, s = t.j, r = t.realIndex, o = t.groupIndex, n = t.bcy, l = t.barHeight, h = t.barWidth, c = t.textRects, d = t.dataLabelsX, g = t.strokeWidth, u = t.dataLabelsConfig, p = t.barDataLabelsConfig, f = t.barTotalDataLabelsConfig, x = t.offX, b = t.offY, v = e.globals.gridHeight / e.globals.dataPoints;
                h = Math.abs(h);
                var y, w, k = (n += -1 !== o ? o * l : 0) - (this.barCtx.isRangeBar ? 0 : v) + l / 2 + c.height / 2 + b - 3, A = "start", S = this.barCtx.series[a][s] < 0, C = i;
                switch(this.barCtx.isReversed && (C = i + h - (S ? 2 * h : 0), i = e.globals.gridWidth - h), p.position){
                    case "center":
                        d = S ? C + h / 2 - x : Math.max(c.width / 2, C - h / 2) + x;
                        break;
                    case "bottom":
                        d = S ? C + h - g - Math.round(c.width / 2) - x : C - h + g + Math.round(c.width / 2) + x;
                        break;
                    case "top":
                        d = S ? C - g + Math.round(c.width / 2) - x : C - g - Math.round(c.width / 2) + x;
                }
                if (this.barCtx.lastActiveBarSerieIndex === r && f.enabled) {
                    var L = new $fffa43d1c55f0813$var$m(this.barCtx.ctx).getTextRects(this.getStackedTotalDataLabel({
                        realIndex: r,
                        j: s
                    }), u.fontSize);
                    S ? (y = C - g + Math.round(L.width / 2) - x - f.offsetX - 15, A = "end") : y = C - g - Math.round(L.width / 2) + x + f.offsetX + 15, w = k + f.offsetY;
                }
                return e.config.chart.stacked || (d < 0 ? d = d + c.width + g : d + c.width / 2 > e.globals.gridWidth && (d = e.globals.gridWidth - c.width - g)), {
                    bcx: i,
                    bcy: n,
                    dataLabelsX: d,
                    dataLabelsY: k,
                    totalDataLabelsX: y,
                    totalDataLabelsY: w,
                    totalDataLabelsAnchor: A
                };
            }
        },
        {
            key: "drawCalculatedDataLabels",
            value: function(t) {
                var i = t.x, a = t.y, s = t.val, r = t.i, o = t.j, n = t.textRects, l = t.barHeight, h = t.barWidth, c = t.dataLabelsConfig, d = this.w, g = "rotate(0)";
                "vertical" === d.config.plotOptions.bar.dataLabels.orientation && (g = "rotate(-90, ".concat(i, ", ").concat(a, ")"));
                var u = new $fffa43d1c55f0813$var$O(this.barCtx.ctx), p = new $fffa43d1c55f0813$var$m(this.barCtx.ctx), f = c.formatter, x = null, b = d.globals.collapsedSeriesIndices.indexOf(r) > -1;
                if (c.enabled && !b) {
                    x = p.group({
                        class: "apexcharts-data-labels",
                        transform: g
                    });
                    var v = "";
                    void 0 !== s && (v = f(s, $fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, d), {}, {
                        seriesIndex: r,
                        dataPointIndex: o,
                        w: d
                    }))), !s && d.config.plotOptions.bar.hideZeroBarsWhenGrouped && (v = "");
                    var y = d.globals.series[r][o] < 0, w = d.config.plotOptions.bar.dataLabels.position;
                    if ("vertical" === d.config.plotOptions.bar.dataLabels.orientation && ("top" === w && (c.textAnchor = y ? "end" : "start"), "center" === w && (c.textAnchor = "middle"), "bottom" === w && (c.textAnchor = y ? "end" : "start")), this.barCtx.isRangeBar && this.barCtx.barOptions.dataLabels.hideOverflowingLabels) h < p.getTextRects(v, parseFloat(c.style.fontSize)).width && (v = "");
                    d.config.chart.stacked && this.barCtx.barOptions.dataLabels.hideOverflowingLabels && (this.barCtx.isHorizontal ? n.width / 1.6 > Math.abs(h) && (v = "") : n.height / 1.6 > Math.abs(l) && (v = ""));
                    var k = $fffa43d1c55f0813$var$e({}, c);
                    this.barCtx.isHorizontal && s < 0 && ("start" === c.textAnchor ? k.textAnchor = "end" : "end" === c.textAnchor && (k.textAnchor = "start")), u.plotDataLabelsText({
                        x: i,
                        y: a,
                        text: v,
                        i: r,
                        j: o,
                        parent: x,
                        dataLabelsConfig: k,
                        alwaysDrawDataLabel: !0,
                        offsetCorrection: !0
                    });
                }
                return x;
            }
        },
        {
            key: "drawTotalDataLabels",
            value: function(t) {
                var e, i = t.x, a = t.y, s = t.val, r = t.barWidth, o = t.barHeight, n = t.realIndex, l = t.textAnchor, h = t.barTotalDataLabelsConfig, c = this.w, d = new $fffa43d1c55f0813$var$m(this.barCtx.ctx);
                return h.enabled && void 0 !== i && void 0 !== a && this.barCtx.lastActiveBarSerieIndex === n && (e = d.drawText({
                    x: i - (!c.globals.isBarHorizontal && c.globals.seriesGroups.length ? r / c.globals.seriesGroups.length : 0),
                    y: a - (c.globals.isBarHorizontal && c.globals.seriesGroups.length ? o / c.globals.seriesGroups.length : 0),
                    foreColor: h.style.color,
                    text: s,
                    textAnchor: l,
                    fontFamily: h.style.fontFamily,
                    fontSize: h.style.fontSize,
                    fontWeight: h.style.fontWeight
                })), e;
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$mt = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.w = e.w, this.barCtx = e;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "initVariables",
            value: function(t) {
                var e = this.w;
                this.barCtx.series = t, this.barCtx.totalItems = 0, this.barCtx.seriesLen = 0, this.barCtx.visibleI = -1, this.barCtx.visibleItems = 1;
                for(var i = 0; i < t.length; i++)if (t[i].length > 0 && (this.barCtx.seriesLen = this.barCtx.seriesLen + 1, this.barCtx.totalItems += t[i].length), e.globals.isXNumeric) for(var a = 0; a < t[i].length; a++)e.globals.seriesX[i][a] > e.globals.minX && e.globals.seriesX[i][a] < e.globals.maxX && this.barCtx.visibleItems++;
                else this.barCtx.visibleItems = e.globals.dataPoints;
                0 === this.barCtx.seriesLen && (this.barCtx.seriesLen = 1), this.barCtx.zeroSerieses = [], e.globals.comboCharts || this.checkZeroSeries({
                    series: t
                });
            }
        },
        {
            key: "initialPositions",
            value: function() {
                var t, e, i, a, s, r, o, n, l = this.w, h = l.globals.dataPoints;
                this.barCtx.isRangeBar && (h = l.globals.labels.length);
                var c = this.barCtx.seriesLen;
                if (l.config.plotOptions.bar.rangeBarGroupRows && (c = 1), this.barCtx.isHorizontal) s = (i = l.globals.gridHeight / h) / c, l.globals.isXNumeric && (s = (i = l.globals.gridHeight / this.barCtx.totalItems) / this.barCtx.seriesLen), s = s * parseInt(this.barCtx.barOptions.barHeight, 10) / 100, -1 === String(this.barCtx.barOptions.barHeight).indexOf("%") && (s = parseInt(this.barCtx.barOptions.barHeight, 10)), n = this.barCtx.baseLineInvertedY + l.globals.padHorizontal + (this.barCtx.isReversed ? l.globals.gridWidth : 0) - (this.barCtx.isReversed ? 2 * this.barCtx.baseLineInvertedY : 0), this.barCtx.isFunnel && (n = l.globals.gridWidth / 2), e = (i - s * this.barCtx.seriesLen) / 2;
                else {
                    if (a = l.globals.gridWidth / this.barCtx.visibleItems, l.config.xaxis.convertedCatToNumeric && (a = l.globals.gridWidth / l.globals.dataPoints), r = a / c * parseInt(this.barCtx.barOptions.columnWidth, 10) / 100, l.globals.isXNumeric) {
                        var d = this.barCtx.xRatio;
                        l.config.xaxis.convertedCatToNumeric && (d = this.barCtx.initialXRatio), l.globals.minXDiff && .5 !== l.globals.minXDiff && l.globals.minXDiff / d > 0 && (a = l.globals.minXDiff / d), (r = a / c * parseInt(this.barCtx.barOptions.columnWidth, 10) / 100) < 1 && (r = 1);
                    }
                    -1 === String(this.barCtx.barOptions.columnWidth).indexOf("%") && (r = parseInt(this.barCtx.barOptions.columnWidth, 10)), o = l.globals.gridHeight - this.barCtx.baseLineY[this.barCtx.yaxisIndex] - (this.barCtx.isReversed ? l.globals.gridHeight : 0) + (this.barCtx.isReversed ? 2 * this.barCtx.baseLineY[this.barCtx.yaxisIndex] : 0), t = l.globals.padHorizontal + (a - r * this.barCtx.seriesLen) / 2;
                }
                return {
                    x: t,
                    y: e,
                    yDivision: i,
                    xDivision: a,
                    barHeight: s,
                    barWidth: r,
                    zeroH: o,
                    zeroW: n
                };
            }
        },
        {
            key: "initializeStackedPrevVars",
            value: function(t) {
                var e = t.w;
                e.globals.hasSeriesGroups ? e.globals.seriesGroups.forEach(function(e) {
                    t[e] || (t[e] = {}), t[e].prevY = [], t[e].prevX = [], t[e].prevYF = [], t[e].prevXF = [], t[e].prevYVal = [], t[e].prevXVal = [];
                }) : (t.prevY = [], t.prevX = [], t.prevYF = [], t.prevXF = [], t.prevYVal = [], t.prevXVal = []);
            }
        },
        {
            key: "initializeStackedXYVars",
            value: function(t) {
                var e = t.w;
                e.globals.hasSeriesGroups ? e.globals.seriesGroups.forEach(function(e) {
                    t[e] || (t[e] = {}), t[e].xArrj = [], t[e].xArrjF = [], t[e].xArrjVal = [], t[e].yArrj = [], t[e].yArrjF = [], t[e].yArrjVal = [];
                }) : (t.xArrj = [], t.xArrjF = [], t.xArrjVal = [], t.yArrj = [], t.yArrjF = [], t.yArrjVal = []);
            }
        },
        {
            key: "getPathFillColor",
            value: function(t, e, i, a) {
                var s, r, o, n, l = this.w, h = new $fffa43d1c55f0813$var$R(this.barCtx.ctx), c = null, d = this.barCtx.barOptions.distributed ? i : e;
                this.barCtx.barOptions.colors.ranges.length > 0 && this.barCtx.barOptions.colors.ranges.map(function(a) {
                    t[e][i] >= a.from && t[e][i] <= a.to && (c = a.color);
                });
                return l.config.series[e].data[i] && l.config.series[e].data[i].fillColor && (c = l.config.series[e].data[i].fillColor), h.fillPath({
                    seriesNumber: this.barCtx.barOptions.distributed ? d : a,
                    dataPointIndex: i,
                    color: c,
                    value: t[e][i],
                    fillConfig: null === (s = l.config.series[e].data[i]) || void 0 === s ? void 0 : s.fill,
                    fillType: null !== (r = l.config.series[e].data[i]) && void 0 !== r && null !== (o = r.fill) && void 0 !== o && o.type ? null === (n = l.config.series[e].data[i]) || void 0 === n ? void 0 : n.fill.type : Array.isArray(l.config.fill.type) ? l.config.fill.type[e] : l.config.fill.type
                });
            }
        },
        {
            key: "getStrokeWidth",
            value: function(t, e, i) {
                var a = 0, s = this.w;
                return this.barCtx.series[t][e] ? this.barCtx.isNullValue = !1 : this.barCtx.isNullValue = !0, s.config.stroke.show && (this.barCtx.isNullValue || (a = Array.isArray(this.barCtx.strokeWidth) ? this.barCtx.strokeWidth[i] : this.barCtx.strokeWidth)), a;
            }
        },
        {
            key: "shouldApplyRadius",
            value: function(t) {
                var e = this.w, i = !1;
                return e.config.plotOptions.bar.borderRadius > 0 && (e.config.chart.stacked && "last" === e.config.plotOptions.bar.borderRadiusWhenStacked ? this.barCtx.lastActiveBarSerieIndex === t && (i = !0) : i = !0), i;
            }
        },
        {
            key: "barBackground",
            value: function(t) {
                var e = t.j, i = t.i, a = t.x1, s = t.x2, r = t.y1, o = t.y2, n = t.elSeries, l = this.w, h = new $fffa43d1c55f0813$var$m(this.barCtx.ctx), c = new $fffa43d1c55f0813$var$N(this.barCtx.ctx).getActiveConfigSeriesIndex();
                if (this.barCtx.barOptions.colors.backgroundBarColors.length > 0 && c === i) {
                    e >= this.barCtx.barOptions.colors.backgroundBarColors.length && (e %= this.barCtx.barOptions.colors.backgroundBarColors.length);
                    var d = this.barCtx.barOptions.colors.backgroundBarColors[e], g = h.drawRect(void 0 !== a ? a : 0, void 0 !== r ? r : 0, void 0 !== s ? s : l.globals.gridWidth, void 0 !== o ? o : l.globals.gridHeight, this.barCtx.barOptions.colors.backgroundBarRadius, d, this.barCtx.barOptions.colors.backgroundBarOpacity);
                    n.add(g), g.node.classList.add("apexcharts-backgroundBar");
                }
            }
        },
        {
            key: "getColumnPaths",
            value: function(t) {
                var e, i = t.barWidth, a = t.barXPosition, s = t.y1, r = t.y2, o = t.strokeWidth, n = t.seriesGroup, l = t.realIndex, h = t.i, c = t.j, d = t.w, g = new $fffa43d1c55f0813$var$m(this.barCtx.ctx);
                (o = Array.isArray(o) ? o[l] : o) || (o = 0);
                var u = i, p = a;
                null !== (e = d.config.series[l].data[c]) && void 0 !== e && e.columnWidthOffset && (p = a - d.config.series[l].data[c].columnWidthOffset / 2, u = i + d.config.series[l].data[c].columnWidthOffset);
                var f = p, x = p + u;
                s += .001, r += .001;
                var b = g.move(f, s), v = g.move(f, s), y = g.line(x - o, s);
                if (d.globals.previousPaths.length > 0 && (v = this.barCtx.getPreviousPath(l, c, !1)), b = b + g.line(f, r) + g.line(x - o, r) + g.line(x - o, s) + ("around" === d.config.plotOptions.bar.borderRadiusApplication ? " Z" : " z"), v = v + g.line(f, s) + y + y + y + y + y + g.line(f, s) + ("around" === d.config.plotOptions.bar.borderRadiusApplication ? " Z" : " z"), this.shouldApplyRadius(l) && (b = g.roundPathCorners(b, d.config.plotOptions.bar.borderRadius)), d.config.chart.stacked) {
                    var w = this.barCtx;
                    d.globals.hasSeriesGroups && n && (w = this.barCtx[n]), w.yArrj.push(r), w.yArrjF.push(Math.abs(s - r)), w.yArrjVal.push(this.barCtx.series[h][c]);
                }
                return {
                    pathTo: b,
                    pathFrom: v
                };
            }
        },
        {
            key: "getBarpaths",
            value: function(t) {
                var e, i = t.barYPosition, a = t.barHeight, s = t.x1, r = t.x2, o = t.strokeWidth, n = t.seriesGroup, l = t.realIndex, h = t.i, c = t.j, d = t.w, g = new $fffa43d1c55f0813$var$m(this.barCtx.ctx);
                (o = Array.isArray(o) ? o[l] : o) || (o = 0);
                var u = i, p = a;
                null !== (e = d.config.series[l].data[c]) && void 0 !== e && e.barHeightOffset && (u = i - d.config.series[l].data[c].barHeightOffset / 2, p = a + d.config.series[l].data[c].barHeightOffset);
                var f = u, x = u + p;
                s += .001, r += .001;
                var b = g.move(s, f), v = g.move(s, f);
                d.globals.previousPaths.length > 0 && (v = this.barCtx.getPreviousPath(l, c, !1));
                var y = g.line(s, x - o);
                if (b = b + g.line(r, f) + g.line(r, x - o) + y + ("around" === d.config.plotOptions.bar.borderRadiusApplication ? " Z" : " z"), v = v + g.line(s, f) + y + y + y + y + y + g.line(s, f) + ("around" === d.config.plotOptions.bar.borderRadiusApplication ? " Z" : " z"), this.shouldApplyRadius(l) && (b = g.roundPathCorners(b, d.config.plotOptions.bar.borderRadius)), d.config.chart.stacked) {
                    var w = this.barCtx;
                    d.globals.hasSeriesGroups && n && (w = this.barCtx[n]), w.xArrj.push(r), w.xArrjF.push(Math.abs(s - r)), w.xArrjVal.push(this.barCtx.series[h][c]);
                }
                return {
                    pathTo: b,
                    pathFrom: v
                };
            }
        },
        {
            key: "checkZeroSeries",
            value: function(t) {
                for(var e = t.series, i = this.w, a = 0; a < e.length; a++){
                    for(var s = 0, r = 0; r < e[i.globals.maxValsInArrayIndex].length; r++)s += e[a][r];
                    0 === s && this.barCtx.zeroSerieses.push(a);
                }
            }
        },
        {
            key: "getXForValue",
            value: function(t, e) {
                var i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2] ? e : null;
                return null != t && (i = e + t / this.barCtx.invertedYRatio - 2 * (this.barCtx.isReversed ? t / this.barCtx.invertedYRatio : 0)), i;
            }
        },
        {
            key: "getYForValue",
            value: function(t, e) {
                var i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2] ? e : null;
                return null != t && (i = e - t / this.barCtx.yRatio[this.barCtx.yaxisIndex] + 2 * (this.barCtx.isReversed ? t / this.barCtx.yRatio[this.barCtx.yaxisIndex] : 0)), i;
            }
        },
        {
            key: "getGoalValues",
            value: function(t, i, a, s, r) {
                var n = this, l = this.w, h = [], c = function(e, s) {
                    var r;
                    h.push(($fffa43d1c55f0813$var$o(r = {}, t, "x" === t ? n.getXForValue(e, i, !1) : n.getYForValue(e, a, !1)), $fffa43d1c55f0813$var$o(r, "attrs", s), r));
                };
                if (l.globals.seriesGoals[s] && l.globals.seriesGoals[s][r] && Array.isArray(l.globals.seriesGoals[s][r]) && l.globals.seriesGoals[s][r].forEach(function(t) {
                    c(t.value, t);
                }), this.barCtx.barOptions.isDumbbell && l.globals.seriesRange.length) {
                    var d = this.barCtx.barOptions.dumbbellColors ? this.barCtx.barOptions.dumbbellColors : l.globals.colors, g = {
                        strokeHeight: "x" === t ? 0 : l.globals.markers.size[s],
                        strokeWidth: "x" === t ? l.globals.markers.size[s] : 0,
                        strokeDashArray: 0,
                        strokeLineCap: "round",
                        strokeColor: Array.isArray(d[s]) ? d[s][0] : d[s]
                    };
                    c(l.globals.seriesRangeStart[s][r], g), c(l.globals.seriesRangeEnd[s][r], $fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, g), {}, {
                        strokeColor: Array.isArray(d[s]) ? d[s][1] : d[s]
                    }));
                }
                return h;
            }
        },
        {
            key: "drawGoalLine",
            value: function(t) {
                var e = t.barXPosition, i = t.barYPosition, a = t.goalX, s = t.goalY, r = t.barWidth, o = t.barHeight, n = new $fffa43d1c55f0813$var$m(this.barCtx.ctx), l = n.group({
                    className: "apexcharts-bar-goals-groups"
                });
                l.node.classList.add("apexcharts-element-hidden"), this.barCtx.w.globals.delayedElements.push({
                    el: l.node
                }), l.attr("clip-path", "url(#gridRectMarkerMask".concat(this.barCtx.w.globals.cuid, ")"));
                var h = null;
                return this.barCtx.isHorizontal ? Array.isArray(a) && a.forEach(function(t) {
                    var e = void 0 !== t.attrs.strokeHeight ? t.attrs.strokeHeight : o / 2, a = i + e + o / 2;
                    h = n.drawLine(t.x, a - 2 * e, t.x, a, t.attrs.strokeColor ? t.attrs.strokeColor : void 0, t.attrs.strokeDashArray, t.attrs.strokeWidth ? t.attrs.strokeWidth : 2, t.attrs.strokeLineCap), l.add(h);
                }) : Array.isArray(s) && s.forEach(function(t) {
                    var i = void 0 !== t.attrs.strokeWidth ? t.attrs.strokeWidth : r / 2, a = e + i + r / 2;
                    h = n.drawLine(a - 2 * i, t.y, a, t.y, t.attrs.strokeColor ? t.attrs.strokeColor : void 0, t.attrs.strokeDashArray, t.attrs.strokeHeight ? t.attrs.strokeHeight : 2, t.attrs.strokeLineCap), l.add(h);
                }), l;
            }
        },
        {
            key: "drawBarShadow",
            value: function(t) {
                var e = t.prevPaths, i = t.currPaths, a = t.color, s = this.w, r = e.x, o = e.x1, n = e.barYPosition, l = i.x, h = i.x1, c = i.barYPosition, d = n + i.barHeight, g = new $fffa43d1c55f0813$var$m(this.barCtx.ctx), u = new $fffa43d1c55f0813$var$x, p = g.move(o, d) + g.line(r, d) + g.line(l, c) + g.line(h, c) + g.line(o, d) + ("around" === s.config.plotOptions.bar.borderRadiusApplication ? " Z" : " z");
                return g.drawPath({
                    d: p,
                    fill: u.shadeColor(.5, $fffa43d1c55f0813$var$x.rgb2hex(a)),
                    stroke: "none",
                    strokeWidth: 0,
                    fillOpacity: 1,
                    classes: "apexcharts-bar-shadows"
                });
            }
        },
        {
            key: "getZeroValueEncounters",
            value: function(t) {
                var e = t.i, i = t.j, a = this.w, s = 0, r = 0;
                return a.globals.seriesPercent.forEach(function(t, a) {
                    t[i] && s++, a < e && 0 === t[i] && r++;
                }), {
                    nonZeroColumns: s,
                    zeroEncounters: r
                };
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$yt = function() {
    function t(e, i) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w;
        var s = this.w;
        this.barOptions = s.config.plotOptions.bar, this.isHorizontal = this.barOptions.horizontal, this.strokeWidth = s.config.stroke.width, this.isNullValue = !1, this.isRangeBar = s.globals.seriesRange.length && this.isHorizontal, this.isVerticalGroupedRangeBar = !s.globals.isBarHorizontal && s.globals.seriesRange.length && s.config.plotOptions.bar.rangeBarGroupRows, this.isFunnel = this.barOptions.isFunnel, this.xyRatios = i, null !== this.xyRatios && (this.xRatio = i.xRatio, this.initialXRatio = i.initialXRatio, this.yRatio = i.yRatio, this.invertedXRatio = i.invertedXRatio, this.invertedYRatio = i.invertedYRatio, this.baseLineY = i.baseLineY, this.baseLineInvertedY = i.baseLineInvertedY), this.yaxisIndex = 0, this.seriesLen = 0, this.pathArr = [];
        var r = new $fffa43d1c55f0813$var$N(this.ctx);
        this.lastActiveBarSerieIndex = r.getActiveConfigSeriesIndex("desc", [
            "bar",
            "column"
        ]);
        var o = r.getBarSeriesIndices(), n = new $fffa43d1c55f0813$var$y(this.ctx);
        this.stackedSeriesTotals = n.getStackedSeriesTotals(this.w.config.series.map(function(t, e) {
            return -1 === o.indexOf(e) ? e : -1;
        }).filter(function(t) {
            return -1 !== t;
        })), this.barHelpers = new $fffa43d1c55f0813$var$mt(this);
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "draw",
            value: function(t, i) {
                var a = this.w, s = new $fffa43d1c55f0813$var$m(this.ctx), r = new $fffa43d1c55f0813$var$y(this.ctx, a);
                t = r.getLogSeries(t), this.series = t, this.yRatio = r.getLogYRatios(this.yRatio), this.barHelpers.initVariables(t);
                var o = s.group({
                    class: "apexcharts-bar-series apexcharts-plot-series"
                });
                a.config.dataLabels.enabled && this.totalItems > this.barOptions.dataLabels.maxItems && console.warn("WARNING: DataLabels are enabled but there are too many to display. This may cause performance issue when rendering - ApexCharts");
                for(var n = 0, l = 0; n < t.length; n++, l++){
                    var h, c, d, g, u = void 0, p = void 0, f = [], b = [], v = a.globals.comboCharts ? i[n] : n, w = s.group({
                        class: "apexcharts-series",
                        rel: n + 1,
                        seriesName: $fffa43d1c55f0813$var$x.escapeString(a.globals.seriesNames[v]),
                        "data:realIndex": v
                    });
                    this.ctx.series.addCollapsedClassToSeries(w, v), t[n].length > 0 && (this.visibleI = this.visibleI + 1);
                    var k = 0, A = 0;
                    this.yRatio.length > 1 && (this.yaxisIndex = v), this.isReversed = a.config.yaxis[this.yaxisIndex] && a.config.yaxis[this.yaxisIndex].reversed;
                    var S = this.barHelpers.initialPositions();
                    p = S.y, k = S.barHeight, c = S.yDivision, g = S.zeroW, u = S.x, A = S.barWidth, h = S.xDivision, d = S.zeroH, this.horizontal || b.push(u + A / 2);
                    var C = s.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": v
                    });
                    a.globals.delayedElements.push({
                        el: C.node
                    }), C.node.classList.add("apexcharts-element-hidden");
                    var L = s.group({
                        class: "apexcharts-bar-goals-markers"
                    }), P = s.group({
                        class: "apexcharts-bar-shadows"
                    });
                    a.globals.delayedElements.push({
                        el: P.node
                    }), P.node.classList.add("apexcharts-element-hidden");
                    for(var I = 0; I < a.globals.dataPoints; I++){
                        var T = this.barHelpers.getStrokeWidth(n, I, v), M = null, z = {
                            indexes: {
                                i: n,
                                j: I,
                                realIndex: v,
                                bc: l
                            },
                            x: u,
                            y: p,
                            strokeWidth: T,
                            elSeries: w
                        };
                        this.isHorizontal ? (M = this.drawBarPaths($fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, z), {}, {
                            barHeight: k,
                            zeroW: g,
                            yDivision: c
                        })), A = this.series[n][I] / this.invertedYRatio) : (M = this.drawColumnPaths($fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, z), {}, {
                            xDivision: h,
                            barWidth: A,
                            zeroH: d
                        })), k = this.series[n][I] / this.yRatio[this.yaxisIndex]);
                        var X = this.barHelpers.getPathFillColor(t, n, I, v);
                        if (this.isFunnel && this.barOptions.isFunnel3d && this.pathArr.length && I > 0) {
                            var E = this.barHelpers.drawBarShadow({
                                color: "string" == typeof X && -1 === (null == X ? void 0 : X.indexOf("url")) ? X : $fffa43d1c55f0813$var$x.hexToRgba(a.globals.colors[n]),
                                prevPaths: this.pathArr[this.pathArr.length - 1],
                                currPaths: M
                            });
                            E && P.add(E);
                        }
                        this.pathArr.push(M);
                        var Y = this.barHelpers.drawGoalLine({
                            barXPosition: M.barXPosition,
                            barYPosition: M.barYPosition,
                            goalX: M.goalX,
                            goalY: M.goalY,
                            barHeight: k,
                            barWidth: A
                        });
                        Y && L.add(Y), p = M.y, u = M.x, I > 0 && b.push(u + A / 2), f.push(p), this.renderSeries({
                            realIndex: v,
                            pathFill: X,
                            j: I,
                            i: n,
                            pathFrom: M.pathFrom,
                            pathTo: M.pathTo,
                            strokeWidth: T,
                            elSeries: w,
                            x: u,
                            y: p,
                            series: t,
                            barHeight: M.barHeight ? M.barHeight : k,
                            barWidth: M.barWidth ? M.barWidth : A,
                            elDataLabelsWrap: C,
                            elGoalsMarkers: L,
                            elBarShadows: P,
                            visibleSeries: this.visibleI,
                            type: "bar"
                        });
                    }
                    a.globals.seriesXvalues[v] = b, a.globals.seriesYvalues[v] = f, o.add(w);
                }
                return o;
            }
        },
        {
            key: "renderSeries",
            value: function(t) {
                var e = t.realIndex, i = t.pathFill, a = t.lineFill, s = t.j, r = t.i, o = t.groupIndex, n = t.pathFrom, l = t.pathTo, h = t.strokeWidth, c = t.elSeries, d = t.x, g = t.y, u = t.y1, p = t.y2, f = t.series, x = t.barHeight, b = t.barWidth, y = t.barXPosition, w = t.barYPosition, k = t.elDataLabelsWrap, A = t.elGoalsMarkers, S = t.elBarShadows, C = t.visibleSeries, L = t.type, P = this.w, I = new $fffa43d1c55f0813$var$m(this.ctx);
                a || (a = this.barOptions.distributed ? P.globals.stroke.colors[s] : P.globals.stroke.colors[e]), P.config.series[r].data[s] && P.config.series[r].data[s].strokeColor && (a = P.config.series[r].data[s].strokeColor), this.isNullValue && (i = "none");
                var T = s / P.config.chart.animations.animateGradually.delay * (P.config.chart.animations.speed / P.globals.dataPoints) / 2.4, M = I.renderPaths({
                    i: r,
                    j: s,
                    realIndex: e,
                    pathFrom: n,
                    pathTo: l,
                    stroke: a,
                    strokeWidth: h,
                    strokeLineCap: P.config.stroke.lineCap,
                    fill: i,
                    animationDelay: T,
                    initialSpeed: P.config.chart.animations.speed,
                    dataChangeSpeed: P.config.chart.animations.dynamicAnimation.speed,
                    className: "apexcharts-".concat(L, "-area")
                });
                M.attr("clip-path", "url(#gridRectMask".concat(P.globals.cuid, ")"));
                var z = P.config.forecastDataPoints;
                z.count > 0 && s >= P.globals.dataPoints - z.count && (M.node.setAttribute("stroke-dasharray", z.dashArray), M.node.setAttribute("stroke-width", z.strokeWidth), M.node.setAttribute("fill-opacity", z.fillOpacity)), void 0 !== u && void 0 !== p && (M.attr("data-range-y1", u), M.attr("data-range-y2", p)), new $fffa43d1c55f0813$var$v(this.ctx).setSelectionFilter(M, e, s), c.add(M);
                var X = new $fffa43d1c55f0813$var$vt(this).handleBarDataLabels({
                    x: d,
                    y: g,
                    y1: u,
                    y2: p,
                    i: r,
                    j: s,
                    series: f,
                    realIndex: e,
                    groupIndex: o,
                    barHeight: x,
                    barWidth: b,
                    barXPosition: y,
                    barYPosition: w,
                    renderedPath: M,
                    visibleSeries: C
                });
                return null !== X.dataLabels && k.add(X.dataLabels), X.totalDataLabels && k.add(X.totalDataLabels), c.add(k), A && c.add(A), S && c.add(S), c;
            }
        },
        {
            key: "drawBarPaths",
            value: function(t) {
                var e, i = t.indexes, a = t.barHeight, s = t.strokeWidth, r = t.zeroW, o = t.x, n = t.y, l = t.yDivision, h = t.elSeries, c = this.w, d = i.i, g = i.j;
                if (c.globals.isXNumeric) e = (n = (c.globals.seriesX[d][g] - c.globals.minX) / this.invertedXRatio - a) + a * this.visibleI;
                else if (c.config.plotOptions.bar.hideZeroBarsWhenGrouped) {
                    var u = 0, p = 0;
                    c.globals.seriesPercent.forEach(function(t, e) {
                        t[g] && u++, e < d && 0 === t[g] && p++;
                    }), u > 0 && (a = this.seriesLen * a / u), e = n + a * this.visibleI, e -= a * p;
                } else e = n + a * this.visibleI;
                this.isFunnel && (r -= (this.barHelpers.getXForValue(this.series[d][g], r) - r) / 2), o = this.barHelpers.getXForValue(this.series[d][g], r);
                var f = this.barHelpers.getBarpaths({
                    barYPosition: e,
                    barHeight: a,
                    x1: r,
                    x2: o,
                    strokeWidth: s,
                    series: this.series,
                    realIndex: i.realIndex,
                    i: d,
                    j: g,
                    w: c
                });
                return c.globals.isXNumeric || (n += l), this.barHelpers.barBackground({
                    j: g,
                    i: d,
                    y1: e - a * this.visibleI,
                    y2: a * this.seriesLen,
                    elSeries: h
                }), {
                    pathTo: f.pathTo,
                    pathFrom: f.pathFrom,
                    x1: r,
                    x: o,
                    y: n,
                    goalX: this.barHelpers.getGoalValues("x", r, null, d, g),
                    barYPosition: e,
                    barHeight: a
                };
            }
        },
        {
            key: "drawColumnPaths",
            value: function(t) {
                var e, i = t.indexes, a = t.x, s = t.y, r = t.xDivision, o = t.barWidth, n = t.zeroH, l = t.strokeWidth, h = t.elSeries, c = this.w, d = i.realIndex, g = i.i, u = i.j, p = i.bc;
                if (c.globals.isXNumeric) {
                    var f = this.getBarXForNumericXAxis({
                        x: a,
                        j: u,
                        realIndex: d,
                        barWidth: o
                    });
                    a = f.x, e = f.barXPosition;
                } else if (c.config.plotOptions.bar.hideZeroBarsWhenGrouped) {
                    var x = this.barHelpers.getZeroValueEncounters({
                        i: g,
                        j: u
                    }), b = x.nonZeroColumns, v = x.zeroEncounters;
                    b > 0 && (o = this.seriesLen * o / b), e = a + o * this.visibleI, e -= o * v;
                } else e = a + o * this.visibleI;
                s = this.barHelpers.getYForValue(this.series[g][u], n);
                var m = this.barHelpers.getColumnPaths({
                    barXPosition: e,
                    barWidth: o,
                    y1: n,
                    y2: s,
                    strokeWidth: l,
                    series: this.series,
                    realIndex: i.realIndex,
                    i: g,
                    j: u,
                    w: c
                });
                return c.globals.isXNumeric || (a += r), this.barHelpers.barBackground({
                    bc: p,
                    j: u,
                    i: g,
                    x1: e - l / 2 - o * this.visibleI,
                    x2: o * this.seriesLen + l / 2,
                    elSeries: h
                }), {
                    pathTo: m.pathTo,
                    pathFrom: m.pathFrom,
                    x: a,
                    y: s,
                    goalY: this.barHelpers.getGoalValues("y", null, n, g, u),
                    barXPosition: e,
                    barWidth: o
                };
            }
        },
        {
            key: "getBarXForNumericXAxis",
            value: function(t) {
                var e = t.x, i = t.barWidth, a = t.realIndex, s = t.j, r = this.w, o = a;
                return r.globals.seriesX[a].length || (o = r.globals.maxValsInArrayIndex), r.globals.seriesX[o][s] && (e = (r.globals.seriesX[o][s] - r.globals.minX) / this.xRatio - i * this.seriesLen / 2), {
                    barXPosition: e + i * this.visibleI,
                    x: e
                };
            }
        },
        {
            key: "getPreviousPath",
            value: function(t, e) {
                for(var i, a = this.w, s = 0; s < a.globals.previousPaths.length; s++){
                    var r = a.globals.previousPaths[s];
                    r.paths && r.paths.length > 0 && parseInt(r.realIndex, 10) === parseInt(t, 10) && void 0 !== a.globals.previousPaths[s].paths[e] && (i = a.globals.previousPaths[s].paths[e].d);
                }
                return i;
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$wt = function(t) {
    $fffa43d1c55f0813$var$n(s, $fffa43d1c55f0813$var$yt);
    var i = $fffa43d1c55f0813$var$d(s);
    function s() {
        return $fffa43d1c55f0813$var$a(this, s), i.apply(this, arguments);
    }
    return $fffa43d1c55f0813$var$r(s, [
        {
            key: "draw",
            value: function(t, i) {
                var a = this, s = this.w;
                this.graphics = new $fffa43d1c55f0813$var$m(this.ctx), this.bar = new $fffa43d1c55f0813$var$yt(this.ctx, this.xyRatios);
                var r = new $fffa43d1c55f0813$var$y(this.ctx, s);
                t = r.getLogSeries(t), this.yRatio = r.getLogYRatios(this.yRatio), this.barHelpers.initVariables(t), "100%" === s.config.chart.stackType && (t = s.globals.seriesPercent.slice()), this.series = t, this.barHelpers.initializeStackedPrevVars(this);
                for(var o = this.graphics.group({
                    class: "apexcharts-bar-series apexcharts-plot-series"
                }), n = 0, l = 0, h = function(r, h) {
                    var c = void 0, d = void 0, g = void 0, u = void 0, p = -1;
                    a.groupCtx = a, s.globals.seriesGroups.forEach(function(t, e) {
                        t.indexOf(s.config.series[r].name) > -1 && (p = e);
                    }), -1 !== p && (a.groupCtx = a[s.globals.seriesGroups[p]]);
                    var f = [], b = [], v = s.globals.comboCharts ? i[r] : r;
                    a.yRatio.length > 1 && (a.yaxisIndex = v), a.isReversed = s.config.yaxis[a.yaxisIndex] && s.config.yaxis[a.yaxisIndex].reversed;
                    var m = a.graphics.group({
                        class: "apexcharts-series",
                        seriesName: $fffa43d1c55f0813$var$x.escapeString(s.globals.seriesNames[v]),
                        rel: r + 1,
                        "data:realIndex": v
                    });
                    a.ctx.series.addCollapsedClassToSeries(m, v);
                    var y = a.graphics.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": v
                    }), w = a.graphics.group({
                        class: "apexcharts-bar-goals-markers"
                    }), k = 0, A = 0, S = a.initialPositions(n, l, c, d, g, u);
                    l = S.y, k = S.barHeight, d = S.yDivision, u = S.zeroW, n = S.x, A = S.barWidth, c = S.xDivision, g = S.zeroH, a.barHelpers.initializeStackedXYVars(a), 1 === a.groupCtx.prevY.length && a.groupCtx.prevY[0].every(function(t) {
                        return isNaN(t);
                    }) && (a.groupCtx.prevY[0] = a.groupCtx.prevY[0].map(function(t) {
                        return g;
                    }), a.groupCtx.prevYF[0] = a.groupCtx.prevYF[0].map(function(t) {
                        return 0;
                    }));
                    for(var C = 0; C < s.globals.dataPoints; C++){
                        var L = a.barHelpers.getStrokeWidth(r, C, v), P = {
                            indexes: {
                                i: r,
                                j: C,
                                realIndex: v,
                                bc: h
                            },
                            strokeWidth: L,
                            x: n,
                            y: l,
                            elSeries: m,
                            groupIndex: p,
                            seriesGroup: s.globals.seriesGroups[p]
                        }, I = null;
                        a.isHorizontal ? (I = a.drawStackedBarPaths($fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, P), {}, {
                            zeroW: u,
                            barHeight: k,
                            yDivision: d
                        })), A = a.series[r][C] / a.invertedYRatio) : (I = a.drawStackedColumnPaths($fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, P), {}, {
                            xDivision: c,
                            barWidth: A,
                            zeroH: g
                        })), k = a.series[r][C] / a.yRatio[a.yaxisIndex]);
                        var T = a.barHelpers.drawGoalLine({
                            barXPosition: I.barXPosition,
                            barYPosition: I.barYPosition,
                            goalX: I.goalX,
                            goalY: I.goalY,
                            barHeight: k,
                            barWidth: A
                        });
                        T && w.add(T), l = I.y, n = I.x, f.push(n), b.push(l);
                        var M = a.barHelpers.getPathFillColor(t, r, C, v);
                        m = a.renderSeries({
                            realIndex: v,
                            pathFill: M,
                            j: C,
                            i: r,
                            groupIndex: p,
                            pathFrom: I.pathFrom,
                            pathTo: I.pathTo,
                            strokeWidth: L,
                            elSeries: m,
                            x: n,
                            y: l,
                            series: t,
                            barHeight: k,
                            barWidth: A,
                            elDataLabelsWrap: y,
                            elGoalsMarkers: w,
                            type: "bar",
                            visibleSeries: 0
                        });
                    }
                    s.globals.seriesXvalues[v] = f, s.globals.seriesYvalues[v] = b, a.groupCtx.prevY.push(a.groupCtx.yArrj), a.groupCtx.prevYF.push(a.groupCtx.yArrjF), a.groupCtx.prevYVal.push(a.groupCtx.yArrjVal), a.groupCtx.prevX.push(a.groupCtx.xArrj), a.groupCtx.prevXF.push(a.groupCtx.xArrjF), a.groupCtx.prevXVal.push(a.groupCtx.xArrjVal), o.add(m);
                }, c = 0, d = 0; c < t.length; c++, d++)h(c, d);
                return o;
            }
        },
        {
            key: "initialPositions",
            value: function(t, e, i, a, s, r) {
                var o, n, l, h, c = this.w;
                return this.isHorizontal ? (l = (l = a = c.globals.gridHeight / c.globals.dataPoints) * parseInt(c.config.plotOptions.bar.barHeight, 10) / 100, -1 === String(c.config.plotOptions.bar.barHeight).indexOf("%") && (l = parseInt(c.config.plotOptions.bar.barHeight, 10)), r = this.baseLineInvertedY + c.globals.padHorizontal + (this.isReversed ? c.globals.gridWidth : 0) - (this.isReversed ? 2 * this.baseLineInvertedY : 0), e = (a - l) / 2) : (h = i = c.globals.gridWidth / c.globals.dataPoints, h = c.globals.isXNumeric && c.globals.dataPoints > 1 ? (i = c.globals.minXDiff / this.xRatio) * parseInt(this.barOptions.columnWidth, 10) / 100 : h * parseInt(c.config.plotOptions.bar.columnWidth, 10) / 100, -1 === String(c.config.plotOptions.bar.columnWidth).indexOf("%") && (h = parseInt(c.config.plotOptions.bar.columnWidth, 10)), s = c.globals.gridHeight - this.baseLineY[this.yaxisIndex] - (this.isReversed ? c.globals.gridHeight : 0) + (this.isReversed ? 2 * this.baseLineY[this.yaxisIndex] : 0), t = c.globals.padHorizontal + (i - h) / 2), {
                    x: t,
                    y: e,
                    yDivision: a,
                    xDivision: i,
                    barHeight: null !== (o = c.globals.seriesGroups) && void 0 !== o && o.length ? l / c.globals.seriesGroups.length : l,
                    barWidth: null !== (n = c.globals.seriesGroups) && void 0 !== n && n.length ? h / c.globals.seriesGroups.length : h,
                    zeroH: s,
                    zeroW: r
                };
            }
        },
        {
            key: "drawStackedBarPaths",
            value: function(t) {
                for(var e, i = t.indexes, a = t.barHeight, s = t.strokeWidth, r = t.zeroW, o = t.x, n = t.y, l = t.groupIndex, h = t.seriesGroup, c = t.yDivision, d = t.elSeries, g = this.w, u = n + (-1 !== l ? l * a : 0), p = i.i, f = i.j, x = 0, b = 0; b < this.groupCtx.prevXF.length; b++)x += this.groupCtx.prevXF[b][f];
                var v = p;
                if (h && (v = h.indexOf(g.config.series[p].name)), v > 0) {
                    var m = r;
                    this.groupCtx.prevXVal[v - 1][f] < 0 ? m = this.series[p][f] >= 0 ? this.groupCtx.prevX[v - 1][f] + x - 2 * (this.isReversed ? x : 0) : this.groupCtx.prevX[v - 1][f] : this.groupCtx.prevXVal[v - 1][f] >= 0 && (m = this.series[p][f] >= 0 ? this.groupCtx.prevX[v - 1][f] : this.groupCtx.prevX[v - 1][f] - x + 2 * (this.isReversed ? x : 0)), e = m;
                } else e = r;
                o = null === this.series[p][f] ? e : e + this.series[p][f] / this.invertedYRatio - 2 * (this.isReversed ? this.series[p][f] / this.invertedYRatio : 0);
                var y = this.barHelpers.getBarpaths({
                    barYPosition: u,
                    barHeight: a,
                    x1: e,
                    x2: o,
                    strokeWidth: s,
                    series: this.series,
                    realIndex: i.realIndex,
                    seriesGroup: h,
                    i: p,
                    j: f,
                    w: g
                });
                return this.barHelpers.barBackground({
                    j: f,
                    i: p,
                    y1: u,
                    y2: a,
                    elSeries: d
                }), n += c, {
                    pathTo: y.pathTo,
                    pathFrom: y.pathFrom,
                    goalX: this.barHelpers.getGoalValues("x", r, null, p, f),
                    barYPosition: u,
                    x: o,
                    y: n
                };
            }
        },
        {
            key: "drawStackedColumnPaths",
            value: function(t) {
                var e = t.indexes, i = t.x, a = t.y, s = t.xDivision, r = t.barWidth, o = t.zeroH, n = t.groupIndex, l = t.seriesGroup, h = t.elSeries, c = this.w, d = e.i, g = e.j, u = e.bc;
                if (c.globals.isXNumeric) {
                    var p = c.globals.seriesX[d][g];
                    p || (p = 0), i = (p - c.globals.minX) / this.xRatio - r / 2, c.globals.seriesGroups.length && (i = (p - c.globals.minX) / this.xRatio - r / 2 * c.globals.seriesGroups.length);
                }
                for(var f, x = i + (-1 !== n ? n * r : 0), b = 0, v = 0; v < this.groupCtx.prevYF.length; v++)b += isNaN(this.groupCtx.prevYF[v][g]) ? 0 : this.groupCtx.prevYF[v][g];
                var m = d;
                if (l && (m = l.indexOf(c.config.series[d].name)), m > 0 && !c.globals.isXNumeric || m > 0 && c.globals.isXNumeric && c.globals.seriesX[d - 1][g] === c.globals.seriesX[d][g]) {
                    var y, w, k, A = Math.min(this.yRatio.length + 1, d + 1);
                    if (void 0 !== this.groupCtx.prevY[m - 1] && this.groupCtx.prevY[m - 1].length) for(var S = 1; S < A; S++){
                        var C;
                        if (!isNaN(null === (C = this.groupCtx.prevY[m - S]) || void 0 === C ? void 0 : C[g])) {
                            k = this.groupCtx.prevY[m - S][g];
                            break;
                        }
                    }
                    for(var L = 1; L < A; L++){
                        var P, I;
                        if ((null === (P = this.groupCtx.prevYVal[m - L]) || void 0 === P ? void 0 : P[g]) < 0) {
                            w = this.series[d][g] >= 0 ? k - b + 2 * (this.isReversed ? b : 0) : k;
                            break;
                        }
                        if ((null === (I = this.groupCtx.prevYVal[m - L]) || void 0 === I ? void 0 : I[g]) >= 0) {
                            w = this.series[d][g] >= 0 ? k : k + b - 2 * (this.isReversed ? b : 0);
                            break;
                        }
                    }
                    void 0 === w && (w = c.globals.gridHeight), f = null !== (y = this.groupCtx.prevYF[0]) && void 0 !== y && y.every(function(t) {
                        return 0 === t;
                    }) && this.groupCtx.prevYF.slice(1, m).every(function(t) {
                        return t.every(function(t) {
                            return isNaN(t);
                        });
                    }) ? o : w;
                } else f = o;
                a = this.series[d][g] ? f - this.series[d][g] / this.yRatio[this.yaxisIndex] + 2 * (this.isReversed ? this.series[d][g] / this.yRatio[this.yaxisIndex] : 0) : f;
                var T = this.barHelpers.getColumnPaths({
                    barXPosition: x,
                    barWidth: r,
                    y1: f,
                    y2: a,
                    yRatio: this.yRatio[this.yaxisIndex],
                    strokeWidth: this.strokeWidth,
                    series: this.series,
                    seriesGroup: l,
                    realIndex: e.realIndex,
                    i: d,
                    j: g,
                    w: c
                });
                return this.barHelpers.barBackground({
                    bc: u,
                    j: g,
                    i: d,
                    x1: x,
                    x2: r,
                    elSeries: h
                }), i += s, {
                    pathTo: T.pathTo,
                    pathFrom: T.pathFrom,
                    goalY: this.barHelpers.getGoalValues("y", null, o, d, g),
                    barXPosition: x,
                    x: c.globals.isXNumeric ? i - s : i,
                    y: a
                };
            }
        }
    ]), s;
}(), $fffa43d1c55f0813$var$kt = function(t) {
    $fffa43d1c55f0813$var$n(s, $fffa43d1c55f0813$var$yt);
    var i = $fffa43d1c55f0813$var$d(s);
    function s() {
        return $fffa43d1c55f0813$var$a(this, s), i.apply(this, arguments);
    }
    return $fffa43d1c55f0813$var$r(s, [
        {
            key: "draw",
            value: function(t, i, a) {
                var s = this, r = this.w, o = new $fffa43d1c55f0813$var$m(this.ctx), n = r.globals.comboCharts ? i : r.config.chart.type, l = new $fffa43d1c55f0813$var$R(this.ctx);
                this.candlestickOptions = this.w.config.plotOptions.candlestick, this.boxOptions = this.w.config.plotOptions.boxPlot, this.isHorizontal = r.config.plotOptions.bar.horizontal;
                var h = new $fffa43d1c55f0813$var$y(this.ctx, r);
                t = h.getLogSeries(t), this.series = t, this.yRatio = h.getLogYRatios(this.yRatio), this.barHelpers.initVariables(t);
                for(var c = o.group({
                    class: "apexcharts-".concat(n, "-series apexcharts-plot-series")
                }), d = function(i) {
                    s.isBoxPlot = "boxPlot" === r.config.chart.type || "boxPlot" === r.config.series[i].type;
                    var n, h, d, g, u = void 0, p = void 0, f = [], b = [], v = r.globals.comboCharts ? a[i] : i, m = o.group({
                        class: "apexcharts-series",
                        seriesName: $fffa43d1c55f0813$var$x.escapeString(r.globals.seriesNames[v]),
                        rel: i + 1,
                        "data:realIndex": v
                    });
                    s.ctx.series.addCollapsedClassToSeries(m, v), t[i].length > 0 && (s.visibleI = s.visibleI + 1);
                    var y, w;
                    s.yRatio.length > 1 && (s.yaxisIndex = v);
                    var k = s.barHelpers.initialPositions();
                    p = k.y, y = k.barHeight, h = k.yDivision, g = k.zeroW, u = k.x, w = k.barWidth, n = k.xDivision, d = k.zeroH, b.push(u + w / 2);
                    for(var A = o.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": v
                    }), S = function(a) {
                        var o = s.barHelpers.getStrokeWidth(i, a, v), c = null, x = {
                            indexes: {
                                i: i,
                                j: a,
                                realIndex: v
                            },
                            x: u,
                            y: p,
                            strokeWidth: o,
                            elSeries: m
                        };
                        c = s.isHorizontal ? s.drawHorizontalBoxPaths($fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, x), {}, {
                            yDivision: h,
                            barHeight: y,
                            zeroW: g
                        })) : s.drawVerticalBoxPaths($fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, x), {}, {
                            xDivision: n,
                            barWidth: w,
                            zeroH: d
                        })), p = c.y, u = c.x, a > 0 && b.push(u + w / 2), f.push(p), c.pathTo.forEach(function(e, n) {
                            var h = !s.isBoxPlot && s.candlestickOptions.wick.useFillColor ? c.color[n] : r.globals.stroke.colors[i], d = l.fillPath({
                                seriesNumber: v,
                                dataPointIndex: a,
                                color: c.color[n],
                                value: t[i][a]
                            });
                            s.renderSeries({
                                realIndex: v,
                                pathFill: d,
                                lineFill: h,
                                j: a,
                                i: i,
                                pathFrom: c.pathFrom,
                                pathTo: e,
                                strokeWidth: o,
                                elSeries: m,
                                x: u,
                                y: p,
                                series: t,
                                barHeight: y,
                                barWidth: w,
                                elDataLabelsWrap: A,
                                visibleSeries: s.visibleI,
                                type: r.config.chart.type
                            });
                        });
                    }, C = 0; C < r.globals.dataPoints; C++)S(C);
                    r.globals.seriesXvalues[v] = b, r.globals.seriesYvalues[v] = f, c.add(m);
                }, g = 0; g < t.length; g++)d(g);
                return c;
            }
        },
        {
            key: "drawVerticalBoxPaths",
            value: function(t) {
                var e = t.indexes, i = t.x;
                t.y;
                var a = t.xDivision, s = t.barWidth, r = t.zeroH, o = t.strokeWidth, n = this.w, l = new $fffa43d1c55f0813$var$m(this.ctx), h = e.i, c = e.j, d = !0, g = n.config.plotOptions.candlestick.colors.upward, u = n.config.plotOptions.candlestick.colors.downward, p = "";
                this.isBoxPlot && (p = [
                    this.boxOptions.colors.lower,
                    this.boxOptions.colors.upper
                ]);
                var f = this.yRatio[this.yaxisIndex], x = e.realIndex, b = this.getOHLCValue(x, c), v = r, y = r;
                b.o > b.c && (d = !1);
                var w = Math.min(b.o, b.c), k = Math.max(b.o, b.c), A = b.m;
                n.globals.isXNumeric && (i = (n.globals.seriesX[x][c] - n.globals.minX) / this.xRatio - s / 2);
                var S = i + s * this.visibleI;
                void 0 === this.series[h][c] || null === this.series[h][c] ? (w = r, k = r) : (w = r - w / f, k = r - k / f, v = r - b.h / f, y = r - b.l / f, A = r - b.m / f);
                var C = l.move(S, r), L = l.move(S + s / 2, w);
                return n.globals.previousPaths.length > 0 && (L = this.getPreviousPath(x, c, !0)), C = this.isBoxPlot ? [
                    l.move(S, w) + l.line(S + s / 2, w) + l.line(S + s / 2, v) + l.line(S + s / 4, v) + l.line(S + s - s / 4, v) + l.line(S + s / 2, v) + l.line(S + s / 2, w) + l.line(S + s, w) + l.line(S + s, A) + l.line(S, A) + l.line(S, w + o / 2),
                    l.move(S, A) + l.line(S + s, A) + l.line(S + s, k) + l.line(S + s / 2, k) + l.line(S + s / 2, y) + l.line(S + s - s / 4, y) + l.line(S + s / 4, y) + l.line(S + s / 2, y) + l.line(S + s / 2, k) + l.line(S, k) + l.line(S, A) + "z"
                ] : [
                    l.move(S, k) + l.line(S + s / 2, k) + l.line(S + s / 2, v) + l.line(S + s / 2, k) + l.line(S + s, k) + l.line(S + s, w) + l.line(S + s / 2, w) + l.line(S + s / 2, y) + l.line(S + s / 2, w) + l.line(S, w) + l.line(S, k - o / 2)
                ], L += l.move(S, w), n.globals.isXNumeric || (i += a), {
                    pathTo: C,
                    pathFrom: L,
                    x: i,
                    y: k,
                    barXPosition: S,
                    color: this.isBoxPlot ? p : d ? [
                        g
                    ] : [
                        u
                    ]
                };
            }
        },
        {
            key: "drawHorizontalBoxPaths",
            value: function(t) {
                var e = t.indexes;
                t.x;
                var i = t.y, a = t.yDivision, s = t.barHeight, r = t.zeroW, o = t.strokeWidth, n = this.w, l = new $fffa43d1c55f0813$var$m(this.ctx), h = e.i, c = e.j, d = this.boxOptions.colors.lower;
                this.isBoxPlot && (d = [
                    this.boxOptions.colors.lower,
                    this.boxOptions.colors.upper
                ]);
                var g = this.invertedYRatio, u = e.realIndex, p = this.getOHLCValue(u, c), f = r, x = r, b = Math.min(p.o, p.c), v = Math.max(p.o, p.c), y = p.m;
                n.globals.isXNumeric && (i = (n.globals.seriesX[u][c] - n.globals.minX) / this.invertedXRatio - s / 2);
                var w = i + s * this.visibleI;
                void 0 === this.series[h][c] || null === this.series[h][c] ? (b = r, v = r) : (b = r + b / g, v = r + v / g, f = r + p.h / g, x = r + p.l / g, y = r + p.m / g);
                var k = l.move(r, w), A = l.move(b, w + s / 2);
                return n.globals.previousPaths.length > 0 && (A = this.getPreviousPath(u, c, !0)), k = [
                    l.move(b, w) + l.line(b, w + s / 2) + l.line(f, w + s / 2) + l.line(f, w + s / 2 - s / 4) + l.line(f, w + s / 2 + s / 4) + l.line(f, w + s / 2) + l.line(b, w + s / 2) + l.line(b, w + s) + l.line(y, w + s) + l.line(y, w) + l.line(b + o / 2, w),
                    l.move(y, w) + l.line(y, w + s) + l.line(v, w + s) + l.line(v, w + s / 2) + l.line(x, w + s / 2) + l.line(x, w + s - s / 4) + l.line(x, w + s / 4) + l.line(x, w + s / 2) + l.line(v, w + s / 2) + l.line(v, w) + l.line(y, w) + "z"
                ], A += l.move(b, w), n.globals.isXNumeric || (i += a), {
                    pathTo: k,
                    pathFrom: A,
                    x: v,
                    y: i,
                    barYPosition: w,
                    color: d
                };
            }
        },
        {
            key: "getOHLCValue",
            value: function(t, e) {
                var i = this.w;
                return {
                    o: this.isBoxPlot ? i.globals.seriesCandleH[t][e] : i.globals.seriesCandleO[t][e],
                    h: this.isBoxPlot ? i.globals.seriesCandleO[t][e] : i.globals.seriesCandleH[t][e],
                    m: i.globals.seriesCandleM[t][e],
                    l: this.isBoxPlot ? i.globals.seriesCandleC[t][e] : i.globals.seriesCandleL[t][e],
                    c: this.isBoxPlot ? i.globals.seriesCandleL[t][e] : i.globals.seriesCandleC[t][e]
                };
            }
        }
    ]), s;
}(), $fffa43d1c55f0813$var$At = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "checkColorRange",
            value: function() {
                var t = this.w, e = !1, i = t.config.plotOptions[t.config.chart.type];
                return i.colorScale.ranges.length > 0 && i.colorScale.ranges.map(function(t, i) {
                    t.from <= 0 && (e = !0);
                }), e;
            }
        },
        {
            key: "getShadeColor",
            value: function(t, e, i, a) {
                var s = this.w, r = 1, o = s.config.plotOptions[t].shadeIntensity, n = this.determineColor(t, e, i);
                s.globals.hasNegs || a ? r = s.config.plotOptions[t].reverseNegativeShade ? n.percent < 0 ? n.percent / 100 * (1.25 * o) : (1 - n.percent / 100) * (1.25 * o) : n.percent <= 0 ? 1 - (1 + n.percent / 100) * o : (1 - n.percent / 100) * o : (r = 1 - n.percent / 100, "treemap" === t && (r = (1 - n.percent / 100) * (1.25 * o)));
                var l = n.color, h = new $fffa43d1c55f0813$var$x;
                return s.config.plotOptions[t].enableShades && (l = "dark" === this.w.config.theme.mode ? $fffa43d1c55f0813$var$x.hexToRgba(h.shadeColor(-1 * r, n.color), s.config.fill.opacity) : $fffa43d1c55f0813$var$x.hexToRgba(h.shadeColor(r, n.color), s.config.fill.opacity)), {
                    color: l,
                    colorProps: n
                };
            }
        },
        {
            key: "determineColor",
            value: function(t, e, i) {
                var a = this.w, s = a.globals.series[e][i], r = a.config.plotOptions[t], o = r.colorScale.inverse ? i : e;
                r.distributed && "treemap" === a.config.chart.type && (o = i);
                var n = a.globals.colors[o], l = null, h = Math.min.apply(Math, $fffa43d1c55f0813$var$u(a.globals.series[e])), c = Math.max.apply(Math, $fffa43d1c55f0813$var$u(a.globals.series[e]));
                r.distributed || "heatmap" !== t || (h = a.globals.minY, c = a.globals.maxY), void 0 !== r.colorScale.min && (h = r.colorScale.min < a.globals.minY ? r.colorScale.min : a.globals.minY, c = r.colorScale.max > a.globals.maxY ? r.colorScale.max : a.globals.maxY);
                var d = Math.abs(c) + Math.abs(h), g = 100 * s / (0 === d ? d - 1e-6 : d);
                r.colorScale.ranges.length > 0 && r.colorScale.ranges.map(function(t, e) {
                    if (s >= t.from && s <= t.to) {
                        n = t.color, l = t.foreColor ? t.foreColor : null, h = t.from, c = t.to;
                        var i = Math.abs(c) + Math.abs(h);
                        g = 100 * s / (0 === i ? i - 1e-6 : i);
                    }
                });
                return {
                    color: n,
                    foreColor: l,
                    percent: g
                };
            }
        },
        {
            key: "calculateDataLabels",
            value: function(t) {
                var e = t.text, i = t.x, a = t.y, s = t.i, r = t.j, o = t.colorProps, n = t.fontSize, l = this.w.config.dataLabels, h = new $fffa43d1c55f0813$var$m(this.ctx), c = new $fffa43d1c55f0813$var$O(this.ctx), d = null;
                if (l.enabled) {
                    d = h.group({
                        class: "apexcharts-data-labels"
                    });
                    var g = l.offsetX, u = l.offsetY, p = i + g, f = a + parseFloat(l.style.fontSize) / 3 + u;
                    c.plotDataLabelsText({
                        x: p,
                        y: f,
                        text: e,
                        i: s,
                        j: r,
                        color: o.foreColor,
                        parent: d,
                        fontSize: n,
                        dataLabelsConfig: l
                    });
                }
                return d;
            }
        },
        {
            key: "addListeners",
            value: function(t) {
                var e = new $fffa43d1c55f0813$var$m(this.ctx);
                t.node.addEventListener("mouseenter", e.pathMouseEnter.bind(this, t)), t.node.addEventListener("mouseleave", e.pathMouseLeave.bind(this, t)), t.node.addEventListener("mousedown", e.pathMouseDown.bind(this, t));
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$St = function() {
    function t(e, i) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w, this.xRatio = i.xRatio, this.yRatio = i.yRatio, this.dynamicAnim = this.w.config.chart.animations.dynamicAnimation, this.helpers = new $fffa43d1c55f0813$var$At(e), this.rectRadius = this.w.config.plotOptions.heatmap.radius, this.strokeWidth = this.w.config.stroke.show ? this.w.config.stroke.width : 0;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "draw",
            value: function(t) {
                var e = this.w, i = new $fffa43d1c55f0813$var$m(this.ctx), a = i.group({
                    class: "apexcharts-heatmap"
                });
                a.attr("clip-path", "url(#gridRectMask".concat(e.globals.cuid, ")"));
                var s = e.globals.gridWidth / e.globals.dataPoints, r = e.globals.gridHeight / e.globals.series.length, o = 0, n = !1;
                this.negRange = this.helpers.checkColorRange();
                var l = t.slice();
                e.config.yaxis[0].reversed && (n = !0, l.reverse());
                for(var h = n ? 0 : l.length - 1; n ? h < l.length : h >= 0; n ? h++ : h--){
                    var c = i.group({
                        class: "apexcharts-series apexcharts-heatmap-series",
                        seriesName: $fffa43d1c55f0813$var$x.escapeString(e.globals.seriesNames[h]),
                        rel: h + 1,
                        "data:realIndex": h
                    });
                    if (this.ctx.series.addCollapsedClassToSeries(c, h), e.config.chart.dropShadow.enabled) {
                        var d = e.config.chart.dropShadow;
                        new $fffa43d1c55f0813$var$v(this.ctx).dropShadow(c, d, h);
                    }
                    for(var g = 0, u = e.config.plotOptions.heatmap.shadeIntensity, p = 0; p < l[h].length; p++){
                        var f = this.helpers.getShadeColor(e.config.chart.type, h, p, this.negRange), b = f.color, y = f.colorProps;
                        if ("image" === e.config.fill.type) b = new $fffa43d1c55f0813$var$R(this.ctx).fillPath({
                            seriesNumber: h,
                            dataPointIndex: p,
                            opacity: e.globals.hasNegs ? y.percent < 0 ? 1 - (1 + y.percent / 100) : u + y.percent / 100 : y.percent / 100,
                            patternID: $fffa43d1c55f0813$var$x.randomId(),
                            width: e.config.fill.image.width ? e.config.fill.image.width : s,
                            height: e.config.fill.image.height ? e.config.fill.image.height : r
                        });
                        var w = this.rectRadius, k = i.drawRect(g, o, s, r, w);
                        if (k.attr({
                            cx: g,
                            cy: o
                        }), k.node.classList.add("apexcharts-heatmap-rect"), c.add(k), k.attr({
                            fill: b,
                            i: h,
                            index: h,
                            j: p,
                            val: t[h][p],
                            "stroke-width": this.strokeWidth,
                            stroke: e.config.plotOptions.heatmap.useFillColorAsStroke ? b : e.globals.stroke.colors[0],
                            color: b
                        }), this.helpers.addListeners(k), e.config.chart.animations.enabled && !e.globals.dataChanged) {
                            var A = 1;
                            e.globals.resized || (A = e.config.chart.animations.speed), this.animateHeatMap(k, g, o, s, r, A);
                        }
                        if (e.globals.dataChanged) {
                            var S = 1;
                            if (this.dynamicAnim.enabled && e.globals.shouldAnimate) {
                                S = this.dynamicAnim.speed;
                                var C = e.globals.previousPaths[h] && e.globals.previousPaths[h][p] && e.globals.previousPaths[h][p].color;
                                C || (C = "rgba(255, 255, 255, 0)"), this.animateHeatColor(k, $fffa43d1c55f0813$var$x.isColorHex(C) ? C : $fffa43d1c55f0813$var$x.rgb2hex(C), $fffa43d1c55f0813$var$x.isColorHex(b) ? b : $fffa43d1c55f0813$var$x.rgb2hex(b), S);
                            }
                        }
                        var L = (0, e.config.dataLabels.formatter)(e.globals.series[h][p], {
                            value: e.globals.series[h][p],
                            seriesIndex: h,
                            dataPointIndex: p,
                            w: e
                        }), P = this.helpers.calculateDataLabels({
                            text: L,
                            x: g + s / 2,
                            y: o + r / 2,
                            i: h,
                            j: p,
                            colorProps: y,
                            series: l
                        });
                        null !== P && c.add(P), g += s;
                    }
                    o += r, a.add(c);
                }
                var I = e.globals.yAxisScale[0].result.slice();
                return e.config.yaxis[0].reversed ? I.unshift("") : I.push(""), e.globals.yAxisScale[0].result = I, a;
            }
        },
        {
            key: "animateHeatMap",
            value: function(t, e, i, a, s, r) {
                var o = new $fffa43d1c55f0813$var$b(this.ctx);
                o.animateRect(t, {
                    x: e + a / 2,
                    y: i + s / 2,
                    width: 0,
                    height: 0
                }, {
                    x: e,
                    y: i,
                    width: a,
                    height: s
                }, r, function() {
                    o.animationCompleted(t);
                });
            }
        },
        {
            key: "animateHeatColor",
            value: function(t, e, i, a) {
                t.attr({
                    fill: e
                }).animate(a).attr({
                    fill: i
                });
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$Ct = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "drawYAxisTexts",
            value: function(t, e, i, a) {
                var s = this.w, r = s.config.yaxis[0], o = s.globals.yLabelFormatters[0];
                return new $fffa43d1c55f0813$var$m(this.ctx).drawText({
                    x: t + r.labels.offsetX,
                    y: e + r.labels.offsetY,
                    text: o(a, i),
                    textAnchor: "middle",
                    fontSize: r.labels.style.fontSize,
                    fontFamily: r.labels.style.fontFamily,
                    foreColor: Array.isArray(r.labels.style.colors) ? r.labels.style.colors[i] : r.labels.style.colors
                });
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$Lt = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w;
        var i = this.w;
        this.chartType = this.w.config.chart.type, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled, this.animBeginArr = [
            0
        ], this.animDur = 0, this.donutDataLabels = this.w.config.plotOptions.pie.donut.labels, this.lineColorArr = void 0 !== i.globals.stroke.colors ? i.globals.stroke.colors : i.globals.colors, this.defaultSize = Math.min(i.globals.gridWidth, i.globals.gridHeight), this.centerY = this.defaultSize / 2, this.centerX = i.globals.gridWidth / 2, "radialBar" === i.config.chart.type ? this.fullAngle = 360 : this.fullAngle = Math.abs(i.config.plotOptions.pie.endAngle - i.config.plotOptions.pie.startAngle), this.initialAngle = i.config.plotOptions.pie.startAngle % this.fullAngle, i.globals.radialSize = this.defaultSize / 2.05 - i.config.stroke.width - (i.config.chart.sparkline.enabled ? 0 : i.config.chart.dropShadow.blur), this.donutSize = i.globals.radialSize * parseInt(i.config.plotOptions.pie.donut.size, 10) / 100, this.maxY = 0, this.sliceLabels = [], this.sliceSizes = [], this.prevSectorAngleArr = [];
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "draw",
            value: function(t) {
                var e = this, i = this.w, a = new $fffa43d1c55f0813$var$m(this.ctx);
                if (this.ret = a.group({
                    class: "apexcharts-pie"
                }), i.globals.noData) return this.ret;
                for(var s = 0, r = 0; r < t.length; r++)s += $fffa43d1c55f0813$var$x.negToZero(t[r]);
                var o = [], n = a.group();
                0 === s && (s = 1e-5), t.forEach(function(t) {
                    e.maxY = Math.max(e.maxY, t);
                }), i.config.yaxis[0].max && (this.maxY = i.config.yaxis[0].max), "back" === i.config.grid.position && "polarArea" === this.chartType && this.drawPolarElements(this.ret);
                for(var l = 0; l < t.length; l++){
                    var h = this.fullAngle * $fffa43d1c55f0813$var$x.negToZero(t[l]) / s;
                    o.push(h), "polarArea" === this.chartType ? (o[l] = this.fullAngle / t.length, this.sliceSizes.push(i.globals.radialSize * t[l] / this.maxY)) : this.sliceSizes.push(i.globals.radialSize);
                }
                if (i.globals.dataChanged) {
                    for(var c, d = 0, g = 0; g < i.globals.previousPaths.length; g++)d += $fffa43d1c55f0813$var$x.negToZero(i.globals.previousPaths[g]);
                    for(var u = 0; u < i.globals.previousPaths.length; u++)c = this.fullAngle * $fffa43d1c55f0813$var$x.negToZero(i.globals.previousPaths[u]) / d, this.prevSectorAngleArr.push(c);
                }
                this.donutSize < 0 && (this.donutSize = 0);
                var p = i.config.plotOptions.pie.customScale, f = i.globals.gridWidth / 2, b = i.globals.gridHeight / 2, v = f - i.globals.gridWidth / 2 * p, y = b - i.globals.gridHeight / 2 * p;
                if ("donut" === this.chartType) {
                    var w = a.drawCircle(this.donutSize);
                    w.attr({
                        cx: this.centerX,
                        cy: this.centerY,
                        fill: i.config.plotOptions.pie.donut.background ? i.config.plotOptions.pie.donut.background : "transparent"
                    }), n.add(w);
                }
                var k = this.drawArcs(o, t);
                if (this.sliceLabels.forEach(function(t) {
                    k.add(t);
                }), n.attr({
                    transform: "translate(".concat(v, ", ").concat(y, ") scale(").concat(p, ")")
                }), n.add(k), this.ret.add(n), this.donutDataLabels.show) {
                    var A = this.renderInnerDataLabels(this.donutDataLabels, {
                        hollowSize: this.donutSize,
                        centerX: this.centerX,
                        centerY: this.centerY,
                        opacity: this.donutDataLabels.show,
                        translateX: v,
                        translateY: y
                    });
                    this.ret.add(A);
                }
                return "front" === i.config.grid.position && "polarArea" === this.chartType && this.drawPolarElements(this.ret), this.ret;
            }
        },
        {
            key: "drawArcs",
            value: function(t, e) {
                var i = this.w, a = new $fffa43d1c55f0813$var$v(this.ctx), s = new $fffa43d1c55f0813$var$m(this.ctx), r = new $fffa43d1c55f0813$var$R(this.ctx), o = s.group({
                    class: "apexcharts-slices"
                }), n = this.initialAngle, l = this.initialAngle, h = this.initialAngle, c = this.initialAngle;
                this.strokeWidth = i.config.stroke.show ? i.config.stroke.width : 0;
                for(var d = 0; d < t.length; d++){
                    var g = s.group({
                        class: "apexcharts-series apexcharts-pie-series",
                        seriesName: $fffa43d1c55f0813$var$x.escapeString(i.globals.seriesNames[d]),
                        rel: d + 1,
                        "data:realIndex": d
                    });
                    o.add(g), l = c, h = (n = h) + t[d], c = l + this.prevSectorAngleArr[d];
                    var u = h < n ? this.fullAngle + h - n : h - n, p = r.fillPath({
                        seriesNumber: d,
                        size: this.sliceSizes[d],
                        value: e[d]
                    }), f = this.getChangedPath(l, c), b = s.drawPath({
                        d: f,
                        stroke: Array.isArray(this.lineColorArr) ? this.lineColorArr[d] : this.lineColorArr,
                        strokeWidth: 0,
                        fill: p,
                        fillOpacity: i.config.fill.opacity,
                        classes: "apexcharts-pie-area apexcharts-".concat(this.chartType.toLowerCase(), "-slice-").concat(d)
                    });
                    if (b.attr({
                        index: 0,
                        j: d
                    }), a.setSelectionFilter(b, 0, d), i.config.chart.dropShadow.enabled) {
                        var y = i.config.chart.dropShadow;
                        a.dropShadow(b, y, d);
                    }
                    this.addListeners(b, this.donutDataLabels), $fffa43d1c55f0813$var$m.setAttrs(b.node, {
                        "data:angle": u,
                        "data:startAngle": n,
                        "data:strokeWidth": this.strokeWidth,
                        "data:value": e[d]
                    });
                    var w = {
                        x: 0,
                        y: 0
                    };
                    "pie" === this.chartType || "polarArea" === this.chartType ? w = $fffa43d1c55f0813$var$x.polarToCartesian(this.centerX, this.centerY, i.globals.radialSize / 1.25 + i.config.plotOptions.pie.dataLabels.offset, (n + u / 2) % this.fullAngle) : "donut" === this.chartType && (w = $fffa43d1c55f0813$var$x.polarToCartesian(this.centerX, this.centerY, (i.globals.radialSize + this.donutSize) / 2 + i.config.plotOptions.pie.dataLabels.offset, (n + u / 2) % this.fullAngle)), g.add(b);
                    var k = 0;
                    if (!this.initialAnim || i.globals.resized || i.globals.dataChanged ? this.animBeginArr.push(0) : (0 === (k = u / this.fullAngle * i.config.chart.animations.speed) && (k = 1), this.animDur = k + this.animDur, this.animBeginArr.push(this.animDur)), this.dynamicAnim && i.globals.dataChanged ? this.animatePaths(b, {
                        size: this.sliceSizes[d],
                        endAngle: h,
                        startAngle: n,
                        prevStartAngle: l,
                        prevEndAngle: c,
                        animateStartingPos: !0,
                        i: d,
                        animBeginArr: this.animBeginArr,
                        shouldSetPrevPaths: !0,
                        dur: i.config.chart.animations.dynamicAnimation.speed
                    }) : this.animatePaths(b, {
                        size: this.sliceSizes[d],
                        endAngle: h,
                        startAngle: n,
                        i: d,
                        totalItems: t.length - 1,
                        animBeginArr: this.animBeginArr,
                        dur: k
                    }), i.config.plotOptions.pie.expandOnClick && "polarArea" !== this.chartType && b.click(this.pieClicked.bind(this, d)), void 0 !== i.globals.selectedDataPoints[0] && i.globals.selectedDataPoints[0].indexOf(d) > -1 && this.pieClicked(d), i.config.dataLabels.enabled) {
                        var A = w.x, S = w.y, C = 100 * u / this.fullAngle + "%";
                        if (0 !== u && i.config.plotOptions.pie.dataLabels.minAngleToShowLabel < t[d]) {
                            var L = i.config.dataLabels.formatter;
                            void 0 !== L && (C = L(i.globals.seriesPercent[d][0], {
                                seriesIndex: d,
                                w: i
                            }));
                            var P = i.globals.dataLabels.style.colors[d], I = s.group({
                                class: "apexcharts-datalabels"
                            }), T = s.drawText({
                                x: A,
                                y: S,
                                text: C,
                                textAnchor: "middle",
                                fontSize: i.config.dataLabels.style.fontSize,
                                fontFamily: i.config.dataLabels.style.fontFamily,
                                fontWeight: i.config.dataLabels.style.fontWeight,
                                foreColor: P
                            });
                            if (I.add(T), i.config.dataLabels.dropShadow.enabled) {
                                var M = i.config.dataLabels.dropShadow;
                                a.dropShadow(T, M);
                            }
                            T.node.classList.add("apexcharts-pie-label"), i.config.chart.animations.animate && !1 === i.globals.resized && (T.node.classList.add("apexcharts-pie-label-delay"), T.node.style.animationDelay = i.config.chart.animations.speed / 940 + "s"), this.sliceLabels.push(I);
                        }
                    }
                }
                return o;
            }
        },
        {
            key: "addListeners",
            value: function(t, e) {
                var i = new $fffa43d1c55f0813$var$m(this.ctx);
                t.node.addEventListener("mouseenter", i.pathMouseEnter.bind(this, t)), t.node.addEventListener("mouseleave", i.pathMouseLeave.bind(this, t)), t.node.addEventListener("mouseleave", this.revertDataLabelsInner.bind(this, t.node, e)), t.node.addEventListener("mousedown", i.pathMouseDown.bind(this, t)), this.donutDataLabels.total.showAlways || (t.node.addEventListener("mouseenter", this.printDataLabelsInner.bind(this, t.node, e)), t.node.addEventListener("mousedown", this.printDataLabelsInner.bind(this, t.node, e)));
            }
        },
        {
            key: "animatePaths",
            value: function(t, e) {
                var i = this.w, a = e.endAngle < e.startAngle ? this.fullAngle + e.endAngle - e.startAngle : e.endAngle - e.startAngle, s = a, r = e.startAngle, o = e.startAngle;
                void 0 !== e.prevStartAngle && void 0 !== e.prevEndAngle && (r = e.prevEndAngle, s = e.prevEndAngle < e.prevStartAngle ? this.fullAngle + e.prevEndAngle - e.prevStartAngle : e.prevEndAngle - e.prevStartAngle), e.i === i.config.series.length - 1 && (a + o > this.fullAngle ? e.endAngle = e.endAngle - (a + o) : a + o < this.fullAngle && (e.endAngle = e.endAngle + (this.fullAngle - (a + o)))), a === this.fullAngle && (a = this.fullAngle - .01), this.animateArc(t, r, o, a, s, e);
            }
        },
        {
            key: "animateArc",
            value: function(t, e, i, a, s, r) {
                var o, n = this, l = this.w, h = new $fffa43d1c55f0813$var$b(this.ctx), c = r.size;
                (isNaN(e) || isNaN(s)) && (e = i, s = a, r.dur = 0);
                var d = a, g = i, u = e < i ? this.fullAngle + e - i : e - i;
                l.globals.dataChanged && r.shouldSetPrevPaths && r.prevEndAngle && (o = n.getPiePath({
                    me: n,
                    startAngle: r.prevStartAngle,
                    angle: r.prevEndAngle < r.prevStartAngle ? this.fullAngle + r.prevEndAngle - r.prevStartAngle : r.prevEndAngle - r.prevStartAngle,
                    size: c
                }), t.attr({
                    d: o
                })), 0 !== r.dur ? t.animate(r.dur, l.globals.easing, r.animBeginArr[r.i]).afterAll(function() {
                    "pie" !== n.chartType && "donut" !== n.chartType && "polarArea" !== n.chartType || this.animate(l.config.chart.animations.dynamicAnimation.speed).attr({
                        "stroke-width": n.strokeWidth
                    }), r.i === l.config.series.length - 1 && h.animationCompleted(t);
                }).during(function(l) {
                    d = u + (a - u) * l, r.animateStartingPos && (d = s + (a - s) * l, g = e - s + (i - (e - s)) * l), o = n.getPiePath({
                        me: n,
                        startAngle: g,
                        angle: d,
                        size: c
                    }), t.node.setAttribute("data:pathOrig", o), t.attr({
                        d: o
                    });
                }) : (o = n.getPiePath({
                    me: n,
                    startAngle: g,
                    angle: a,
                    size: c
                }), r.isTrack || (l.globals.animationEnded = !0), t.node.setAttribute("data:pathOrig", o), t.attr({
                    d: o,
                    "stroke-width": n.strokeWidth
                }));
            }
        },
        {
            key: "pieClicked",
            value: function(t) {
                var e, i = this.w, a = this, s = a.sliceSizes[t] + (i.config.plotOptions.pie.expandOnClick ? 4 : 0), r = i.globals.dom.Paper.select(".apexcharts-".concat(a.chartType.toLowerCase(), "-slice-").concat(t)).members[0];
                if ("true" !== r.attr("data:pieClicked")) {
                    var o = i.globals.dom.baseEl.getElementsByClassName("apexcharts-pie-area");
                    Array.prototype.forEach.call(o, function(t) {
                        t.setAttribute("data:pieClicked", "false");
                        var e = t.getAttribute("data:pathOrig");
                        e && t.setAttribute("d", e);
                    }), r.attr("data:pieClicked", "true");
                    var n = parseInt(r.attr("data:startAngle"), 10), l = parseInt(r.attr("data:angle"), 10);
                    e = a.getPiePath({
                        me: a,
                        startAngle: n,
                        angle: l,
                        size: s
                    }), 360 !== l && r.plot(e);
                } else {
                    r.attr({
                        "data:pieClicked": "false"
                    }), this.revertDataLabelsInner(r.node, this.donutDataLabels);
                    var h = r.attr("data:pathOrig");
                    r.attr({
                        d: h
                    });
                }
            }
        },
        {
            key: "getChangedPath",
            value: function(t, e) {
                var i = "";
                return this.dynamicAnim && this.w.globals.dataChanged && (i = this.getPiePath({
                    me: this,
                    startAngle: t,
                    angle: e - t,
                    size: this.size
                })), i;
            }
        },
        {
            key: "getPiePath",
            value: function(t) {
                var e, i = t.me, a = t.startAngle, s = t.angle, r = t.size, o = new $fffa43d1c55f0813$var$m(this.ctx), n = a, l = Math.PI * (n - 90) / 180, h = s + a;
                Math.ceil(h) >= this.fullAngle + this.w.config.plotOptions.pie.startAngle % this.fullAngle && (h = this.fullAngle + this.w.config.plotOptions.pie.startAngle % this.fullAngle - .01), Math.ceil(h) > this.fullAngle && (h -= this.fullAngle);
                var c = Math.PI * (h - 90) / 180, d = i.centerX + r * Math.cos(l), g = i.centerY + r * Math.sin(l), u = i.centerX + r * Math.cos(c), p = i.centerY + r * Math.sin(c), f = $fffa43d1c55f0813$var$x.polarToCartesian(i.centerX, i.centerY, i.donutSize, h), b = $fffa43d1c55f0813$var$x.polarToCartesian(i.centerX, i.centerY, i.donutSize, n), v = s > 180 ? 1 : 0, y = [
                    "M",
                    d,
                    g,
                    "A",
                    r,
                    r,
                    0,
                    v,
                    1,
                    u,
                    p
                ];
                return e = "donut" === i.chartType ? [].concat(y, [
                    "L",
                    f.x,
                    f.y,
                    "A",
                    i.donutSize,
                    i.donutSize,
                    0,
                    v,
                    0,
                    b.x,
                    b.y,
                    "L",
                    d,
                    g,
                    "z"
                ]).join(" ") : "pie" === i.chartType || "polarArea" === i.chartType ? [].concat(y, [
                    "L",
                    i.centerX,
                    i.centerY,
                    "L",
                    d,
                    g
                ]).join(" ") : [].concat(y).join(" "), o.roundPathCorners(e, 2 * this.strokeWidth);
            }
        },
        {
            key: "drawPolarElements",
            value: function(t) {
                var e = this.w, i = new $fffa43d1c55f0813$var$_(this.ctx), a = new $fffa43d1c55f0813$var$m(this.ctx), s = new $fffa43d1c55f0813$var$Ct(this.ctx), r = a.group(), o = a.group(), n = i.niceScale(0, Math.ceil(this.maxY), e.config.yaxis[0].tickAmount, 0, !0), l = n.result.reverse(), h = n.result.length;
                this.maxY = n.niceMax;
                for(var c = e.globals.radialSize, d = c / (h - 1), g = 0; g < h - 1; g++){
                    var u = a.drawCircle(c);
                    if (u.attr({
                        cx: this.centerX,
                        cy: this.centerY,
                        fill: "none",
                        "stroke-width": e.config.plotOptions.polarArea.rings.strokeWidth,
                        stroke: e.config.plotOptions.polarArea.rings.strokeColor
                    }), e.config.yaxis[0].show) {
                        var p = s.drawYAxisTexts(this.centerX, this.centerY - c + parseInt(e.config.yaxis[0].labels.style.fontSize, 10) / 2, g, l[g]);
                        o.add(p);
                    }
                    r.add(u), c -= d;
                }
                this.drawSpokes(t), t.add(r), t.add(o);
            }
        },
        {
            key: "renderInnerDataLabels",
            value: function(t, e) {
                var i = this.w, a = new $fffa43d1c55f0813$var$m(this.ctx), s = a.group({
                    class: "apexcharts-datalabels-group",
                    transform: "translate(".concat(e.translateX ? e.translateX : 0, ", ").concat(e.translateY ? e.translateY : 0, ") scale(").concat(i.config.plotOptions.pie.customScale, ")")
                }), r = t.total.show;
                s.node.style.opacity = e.opacity;
                var o, n, l = e.centerX, h = e.centerY;
                o = void 0 === t.name.color ? i.globals.colors[0] : t.name.color;
                var c = t.name.fontSize, d = t.name.fontFamily, g = t.name.fontWeight;
                n = void 0 === t.value.color ? i.config.chart.foreColor : t.value.color;
                var u = t.value.formatter, p = "", f = "";
                if (r ? (o = t.total.color, c = t.total.fontSize, d = t.total.fontFamily, g = t.total.fontWeight, f = t.total.label, p = t.total.formatter(i)) : 1 === i.globals.series.length && (p = u(i.globals.series[0], i), f = i.globals.seriesNames[0]), f && (f = t.name.formatter(f, t.total.show, i)), t.name.show) {
                    var x = a.drawText({
                        x: l,
                        y: h + parseFloat(t.name.offsetY),
                        text: f,
                        textAnchor: "middle",
                        foreColor: o,
                        fontSize: c,
                        fontWeight: g,
                        fontFamily: d
                    });
                    x.node.classList.add("apexcharts-datalabel-label"), s.add(x);
                }
                if (t.value.show) {
                    var b = t.name.show ? parseFloat(t.value.offsetY) + 16 : t.value.offsetY, v = a.drawText({
                        x: l,
                        y: h + b,
                        text: p,
                        textAnchor: "middle",
                        foreColor: n,
                        fontWeight: t.value.fontWeight,
                        fontSize: t.value.fontSize,
                        fontFamily: t.value.fontFamily
                    });
                    v.node.classList.add("apexcharts-datalabel-value"), s.add(v);
                }
                return s;
            }
        },
        {
            key: "printInnerLabels",
            value: function(t, e, i, a) {
                var s, r = this.w;
                a ? s = void 0 === t.name.color ? r.globals.colors[parseInt(a.parentNode.getAttribute("rel"), 10) - 1] : t.name.color : r.globals.series.length > 1 && t.total.show && (s = t.total.color);
                var o = r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-label"), n = r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-value");
                i = (0, t.value.formatter)(i, r), a || "function" != typeof t.total.formatter || (i = t.total.formatter(r));
                var l = e === t.total.label;
                e = t.name.formatter(e, l, r), null !== o && (o.textContent = e), null !== n && (n.textContent = i), null !== o && (o.style.fill = s);
            }
        },
        {
            key: "printDataLabelsInner",
            value: function(t, e) {
                var i = this.w, a = t.getAttribute("data:value"), s = i.globals.seriesNames[parseInt(t.parentNode.getAttribute("rel"), 10) - 1];
                i.globals.series.length > 1 && this.printInnerLabels(e, s, a, t);
                var r = i.globals.dom.baseEl.querySelector(".apexcharts-datalabels-group");
                null !== r && (r.style.opacity = 1);
            }
        },
        {
            key: "drawSpokes",
            value: function(t) {
                var e = this, i = this.w, a = new $fffa43d1c55f0813$var$m(this.ctx), s = i.config.plotOptions.polarArea.spokes;
                if (0 !== s.strokeWidth) {
                    for(var r = [], o = 360 / i.globals.series.length, n = 0; n < i.globals.series.length; n++)r.push($fffa43d1c55f0813$var$x.polarToCartesian(this.centerX, this.centerY, i.globals.radialSize, i.config.plotOptions.pie.startAngle + o * n));
                    r.forEach(function(i, r) {
                        var o = a.drawLine(i.x, i.y, e.centerX, e.centerY, Array.isArray(s.connectorColors) ? s.connectorColors[r] : s.connectorColors);
                        t.add(o);
                    });
                }
            }
        },
        {
            key: "revertDataLabelsInner",
            value: function(t, e, i) {
                var a = this, s = this.w, r = s.globals.dom.baseEl.querySelector(".apexcharts-datalabels-group"), o = !1, n = s.globals.dom.baseEl.getElementsByClassName("apexcharts-pie-area"), l = function(t) {
                    var i = t.makeSliceOut, s = t.printLabel;
                    Array.prototype.forEach.call(n, function(t) {
                        "true" === t.getAttribute("data:pieClicked") && (i && (o = !0), s && a.printDataLabelsInner(t, e));
                    });
                };
                if (l({
                    makeSliceOut: !0,
                    printLabel: !1
                }), e.total.show && s.globals.series.length > 1) o && !e.total.showAlways ? l({
                    makeSliceOut: !1,
                    printLabel: !0
                }) : this.printInnerLabels(e, e.total.label, e.total.formatter(s));
                else if (l({
                    makeSliceOut: !1,
                    printLabel: !0
                }), !o) {
                    if (s.globals.selectedDataPoints.length && s.globals.series.length > 1) {
                        if (s.globals.selectedDataPoints[0].length > 0) {
                            var h = s.globals.selectedDataPoints[0], c = s.globals.dom.baseEl.querySelector(".apexcharts-".concat(this.chartType.toLowerCase(), "-slice-").concat(h));
                            this.printDataLabelsInner(c, e);
                        } else r && s.globals.selectedDataPoints.length && 0 === s.globals.selectedDataPoints[0].length && (r.style.opacity = 0);
                    } else r && s.globals.series.length > 1 && (r.style.opacity = 0);
                }
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$Pt = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w, this.chartType = this.w.config.chart.type, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled, this.animDur = 0;
        var i = this.w;
        this.graphics = new $fffa43d1c55f0813$var$m(this.ctx), this.lineColorArr = void 0 !== i.globals.stroke.colors ? i.globals.stroke.colors : i.globals.colors, this.defaultSize = i.globals.svgHeight < i.globals.svgWidth ? i.globals.gridHeight + 1.5 * i.globals.goldenPadding : i.globals.gridWidth, this.isLog = i.config.yaxis[0].logarithmic, this.coreUtils = new $fffa43d1c55f0813$var$y(this.ctx), this.maxValue = this.isLog ? this.coreUtils.getLogVal(i.globals.maxY, 0) : i.globals.maxY, this.minValue = this.isLog ? this.coreUtils.getLogVal(this.w.globals.minY, 0) : i.globals.minY, this.polygons = i.config.plotOptions.radar.polygons, this.strokeWidth = i.config.stroke.show ? i.config.stroke.width : 0, this.size = this.defaultSize / 2.1 - this.strokeWidth - i.config.chart.dropShadow.blur, i.config.xaxis.labels.show && (this.size = this.size - i.globals.xAxisLabelsWidth / 1.75), void 0 !== i.config.plotOptions.radar.size && (this.size = i.config.plotOptions.radar.size), this.dataRadiusOfPercent = [], this.dataRadius = [], this.angleArr = [], this.yaxisLabelsTextsPos = [];
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "draw",
            value: function(t) {
                var i = this, a = this.w, s = new $fffa43d1c55f0813$var$R(this.ctx), r = [], o = new $fffa43d1c55f0813$var$O(this.ctx);
                t.length && (this.dataPointsLen = t[a.globals.maxValsInArrayIndex].length), this.disAngle = 2 * Math.PI / this.dataPointsLen;
                var n = a.globals.gridWidth / 2, l = a.globals.gridHeight / 2, h = n + a.config.plotOptions.radar.offsetX, c = l + a.config.plotOptions.radar.offsetY, d = this.graphics.group({
                    class: "apexcharts-radar-series apexcharts-plot-series",
                    transform: "translate(".concat(h || 0, ", ").concat(c || 0, ")")
                }), g = [], u = null, p = null;
                if (this.yaxisLabels = this.graphics.group({
                    class: "apexcharts-yaxis"
                }), t.forEach(function(t, n) {
                    var l = t.length === a.globals.dataPoints, h = i.graphics.group().attr({
                        class: "apexcharts-series",
                        "data:longestSeries": l,
                        seriesName: $fffa43d1c55f0813$var$x.escapeString(a.globals.seriesNames[n]),
                        rel: n + 1,
                        "data:realIndex": n
                    });
                    i.dataRadiusOfPercent[n] = [], i.dataRadius[n] = [], i.angleArr[n] = [], t.forEach(function(t, e) {
                        var a = Math.abs(i.maxValue - i.minValue);
                        t += Math.abs(i.minValue), i.isLog && (t = i.coreUtils.getLogVal(t, 0)), i.dataRadiusOfPercent[n][e] = t / a, i.dataRadius[n][e] = i.dataRadiusOfPercent[n][e] * i.size, i.angleArr[n][e] = e * i.disAngle;
                    }), g = i.getDataPointsPos(i.dataRadius[n], i.angleArr[n]);
                    var c = i.createPaths(g, {
                        x: 0,
                        y: 0
                    });
                    u = i.graphics.group({
                        class: "apexcharts-series-markers-wrap apexcharts-element-hidden"
                    }), p = i.graphics.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": n
                    }), a.globals.delayedElements.push({
                        el: u.node,
                        index: n
                    });
                    var d = {
                        i: n,
                        realIndex: n,
                        animationDelay: n,
                        initialSpeed: a.config.chart.animations.speed,
                        dataChangeSpeed: a.config.chart.animations.dynamicAnimation.speed,
                        className: "apexcharts-radar",
                        shouldClipToGrid: !1,
                        bindEventsOnPaths: !1,
                        stroke: a.globals.stroke.colors[n],
                        strokeLineCap: a.config.stroke.lineCap
                    }, f = null;
                    a.globals.previousPaths.length > 0 && (f = i.getPreviousPath(n));
                    for(var b = 0; b < c.linePathsTo.length; b++){
                        var m = i.graphics.renderPaths($fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, d), {}, {
                            pathFrom: null === f ? c.linePathsFrom[b] : f,
                            pathTo: c.linePathsTo[b],
                            strokeWidth: Array.isArray(i.strokeWidth) ? i.strokeWidth[n] : i.strokeWidth,
                            fill: "none",
                            drawShadow: !1
                        }));
                        h.add(m);
                        var y = s.fillPath({
                            seriesNumber: n
                        }), w = i.graphics.renderPaths($fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, d), {}, {
                            pathFrom: null === f ? c.areaPathsFrom[b] : f,
                            pathTo: c.areaPathsTo[b],
                            strokeWidth: 0,
                            fill: y,
                            drawShadow: !1
                        }));
                        if (a.config.chart.dropShadow.enabled) {
                            var k = new $fffa43d1c55f0813$var$v(i.ctx), A = a.config.chart.dropShadow;
                            k.dropShadow(w, Object.assign({}, A, {
                                noUserSpaceOnUse: !0
                            }), n);
                        }
                        h.add(w);
                    }
                    t.forEach(function(t, s) {
                        var r = new $fffa43d1c55f0813$var$H(i.ctx).getMarkerConfig({
                            cssClass: "apexcharts-marker",
                            seriesIndex: n,
                            dataPointIndex: s
                        }), l = i.graphics.drawMarker(g[s].x, g[s].y, r);
                        l.attr("rel", s), l.attr("j", s), l.attr("index", n), l.node.setAttribute("default-marker-size", r.pSize);
                        var c = i.graphics.group({
                            class: "apexcharts-series-markers"
                        });
                        c && c.add(l), u.add(c), h.add(u);
                        var d = a.config.dataLabels;
                        if (d.enabled) {
                            var f = d.formatter(a.globals.series[n][s], {
                                seriesIndex: n,
                                dataPointIndex: s,
                                w: a
                            });
                            o.plotDataLabelsText({
                                x: g[s].x,
                                y: g[s].y,
                                text: f,
                                textAnchor: "middle",
                                i: n,
                                j: n,
                                parent: p,
                                offsetCorrection: !1,
                                dataLabelsConfig: $fffa43d1c55f0813$var$e({}, d)
                            });
                        }
                        h.add(p);
                    }), r.push(h);
                }), this.drawPolygons({
                    parent: d
                }), a.config.xaxis.labels.show) {
                    var f = this.drawXAxisTexts();
                    d.add(f);
                }
                return r.forEach(function(t) {
                    d.add(t);
                }), d.add(this.yaxisLabels), d;
            }
        },
        {
            key: "drawPolygons",
            value: function(t) {
                for(var e = this, i = this.w, a = t.parent, s = new $fffa43d1c55f0813$var$Ct(this.ctx), r = i.globals.yAxisScale[0].result.reverse(), o = r.length, n = [], l = this.size / (o - 1), h = 0; h < o; h++)n[h] = l * h;
                n.reverse();
                var c = [], d = [];
                n.forEach(function(t, i) {
                    var a = $fffa43d1c55f0813$var$x.getPolygonPos(t, e.dataPointsLen), s = "";
                    a.forEach(function(t, a) {
                        if (0 === i) {
                            var r = e.graphics.drawLine(t.x, t.y, 0, 0, Array.isArray(e.polygons.connectorColors) ? e.polygons.connectorColors[a] : e.polygons.connectorColors);
                            d.push(r);
                        }
                        0 === a && e.yaxisLabelsTextsPos.push({
                            x: t.x,
                            y: t.y
                        }), s += t.x + "," + t.y + " ";
                    }), c.push(s);
                }), c.forEach(function(t, s) {
                    var r = e.polygons.strokeColors, o = e.polygons.strokeWidth, n = e.graphics.drawPolygon(t, Array.isArray(r) ? r[s] : r, Array.isArray(o) ? o[s] : o, i.globals.radarPolygons.fill.colors[s]);
                    a.add(n);
                }), d.forEach(function(t) {
                    a.add(t);
                }), i.config.yaxis[0].show && this.yaxisLabelsTextsPos.forEach(function(t, i) {
                    var a = s.drawYAxisTexts(t.x, t.y, i, r[i]);
                    e.yaxisLabels.add(a);
                });
            }
        },
        {
            key: "drawXAxisTexts",
            value: function() {
                var t = this, i = this.w, a = i.config.xaxis.labels, s = this.graphics.group({
                    class: "apexcharts-xaxis"
                }), r = $fffa43d1c55f0813$var$x.getPolygonPos(this.size, this.dataPointsLen);
                return i.globals.labels.forEach(function(o, n) {
                    var l = i.config.xaxis.labels.formatter, h = new $fffa43d1c55f0813$var$O(t.ctx);
                    if (r[n]) {
                        var c = t.getTextPos(r[n], t.size), d = l(o, {
                            seriesIndex: -1,
                            dataPointIndex: n,
                            w: i
                        });
                        h.plotDataLabelsText({
                            x: c.newX,
                            y: c.newY,
                            text: d,
                            textAnchor: c.textAnchor,
                            i: n,
                            j: n,
                            parent: s,
                            color: Array.isArray(a.style.colors) && a.style.colors[n] ? a.style.colors[n] : "#a8a8a8",
                            dataLabelsConfig: $fffa43d1c55f0813$var$e({
                                textAnchor: c.textAnchor,
                                dropShadow: {
                                    enabled: !1
                                }
                            }, a),
                            offsetCorrection: !1
                        });
                    }
                }), s;
            }
        },
        {
            key: "createPaths",
            value: function(t, e) {
                var i = this, a = [], s = [], r = [], o = [];
                if (t.length) {
                    s = [
                        this.graphics.move(e.x, e.y)
                    ], o = [
                        this.graphics.move(e.x, e.y)
                    ];
                    var n = this.graphics.move(t[0].x, t[0].y), l = this.graphics.move(t[0].x, t[0].y);
                    t.forEach(function(e, a) {
                        n += i.graphics.line(e.x, e.y), l += i.graphics.line(e.x, e.y), a === t.length - 1 && (n += "Z", l += "Z");
                    }), a.push(n), r.push(l);
                }
                return {
                    linePathsFrom: s,
                    linePathsTo: a,
                    areaPathsFrom: o,
                    areaPathsTo: r
                };
            }
        },
        {
            key: "getTextPos",
            value: function(t, e) {
                var i = "middle", a = t.x, s = t.y;
                return Math.abs(t.x) >= 10 ? t.x > 0 ? (i = "start", a += 10) : t.x < 0 && (i = "end", a -= 10) : i = "middle", Math.abs(t.y) >= e - 10 && (t.y < 0 ? s -= 10 : t.y > 0 && (s += 10)), {
                    textAnchor: i,
                    newX: a,
                    newY: s
                };
            }
        },
        {
            key: "getPreviousPath",
            value: function(t) {
                for(var e = this.w, i = null, a = 0; a < e.globals.previousPaths.length; a++){
                    var s = e.globals.previousPaths[a];
                    s.paths.length > 0 && parseInt(s.realIndex, 10) === parseInt(t, 10) && void 0 !== e.globals.previousPaths[a].paths[0] && (i = e.globals.previousPaths[a].paths[0].d);
                }
                return i;
            }
        },
        {
            key: "getDataPointsPos",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.dataPointsLen;
                t = t || [], e = e || [];
                for(var a = [], s = 0; s < i; s++){
                    var r = {};
                    r.x = t[s] * Math.sin(e[s]), r.y = -t[s] * Math.cos(e[s]), a.push(r);
                }
                return a;
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$It = function(t) {
    $fffa43d1c55f0813$var$n(i, $fffa43d1c55f0813$var$Lt);
    var e = $fffa43d1c55f0813$var$d(i);
    function i(t) {
        var s;
        $fffa43d1c55f0813$var$a(this, i), (s = e.call(this, t)).ctx = t, s.w = t.w, s.animBeginArr = [
            0
        ], s.animDur = 0;
        var r = s.w;
        return s.startAngle = r.config.plotOptions.radialBar.startAngle, s.endAngle = r.config.plotOptions.radialBar.endAngle, s.totalAngle = Math.abs(r.config.plotOptions.radialBar.endAngle - r.config.plotOptions.radialBar.startAngle), s.trackStartAngle = r.config.plotOptions.radialBar.track.startAngle, s.trackEndAngle = r.config.plotOptions.radialBar.track.endAngle, s.barLabels = s.w.config.plotOptions.radialBar.barLabels, s.donutDataLabels = s.w.config.plotOptions.radialBar.dataLabels, s.radialDataLabels = s.donutDataLabels, s.trackStartAngle || (s.trackStartAngle = s.startAngle), s.trackEndAngle || (s.trackEndAngle = s.endAngle), 360 === s.endAngle && (s.endAngle = 359.99), s.margin = parseInt(r.config.plotOptions.radialBar.track.margin, 10), s.onBarLabelClick = s.onBarLabelClick.bind($fffa43d1c55f0813$var$c(s)), s;
    }
    return $fffa43d1c55f0813$var$r(i, [
        {
            key: "draw",
            value: function(t) {
                var e = this.w, i = new $fffa43d1c55f0813$var$m(this.ctx), a = i.group({
                    class: "apexcharts-radialbar"
                });
                if (e.globals.noData) return a;
                var s = i.group(), r = this.defaultSize / 2, o = e.globals.gridWidth / 2, n = this.defaultSize / 2.05;
                e.config.chart.sparkline.enabled || (n = n - e.config.stroke.width - e.config.chart.dropShadow.blur);
                var l = e.globals.fill.colors;
                if (e.config.plotOptions.radialBar.track.show) {
                    var h = this.drawTracks({
                        size: n,
                        centerX: o,
                        centerY: r,
                        colorArr: l,
                        series: t
                    });
                    s.add(h);
                }
                var c = this.drawArcs({
                    size: n,
                    centerX: o,
                    centerY: r,
                    colorArr: l,
                    series: t
                }), d = 360;
                e.config.plotOptions.radialBar.startAngle < 0 && (d = this.totalAngle);
                var g = (360 - d) / 360;
                if (e.globals.radialSize = n - n * g, this.radialDataLabels.value.show) {
                    var u = Math.max(this.radialDataLabels.value.offsetY, this.radialDataLabels.name.offsetY);
                    e.globals.radialSize += u * g;
                }
                return s.add(c.g), "front" === e.config.plotOptions.radialBar.hollow.position && (c.g.add(c.elHollow), c.dataLabels && c.g.add(c.dataLabels)), a.add(s), a;
            }
        },
        {
            key: "drawTracks",
            value: function(t) {
                var e = this.w, i = new $fffa43d1c55f0813$var$m(this.ctx), a = i.group({
                    class: "apexcharts-tracks"
                }), s = new $fffa43d1c55f0813$var$v(this.ctx), r = new $fffa43d1c55f0813$var$R(this.ctx), o = this.getStrokeWidth(t);
                t.size = t.size - o / 2;
                for(var n = 0; n < t.series.length; n++){
                    var l = i.group({
                        class: "apexcharts-radialbar-track apexcharts-track"
                    });
                    a.add(l), l.attr({
                        rel: n + 1
                    }), t.size = t.size - o - this.margin;
                    var h = e.config.plotOptions.radialBar.track, c = r.fillPath({
                        seriesNumber: 0,
                        size: t.size,
                        fillColors: Array.isArray(h.background) ? h.background[n] : h.background,
                        solid: !0
                    }), d = this.trackStartAngle, g = this.trackEndAngle;
                    Math.abs(g) + Math.abs(d) >= 360 && (g = 360 - Math.abs(this.startAngle) - .1);
                    var u = i.drawPath({
                        d: "",
                        stroke: c,
                        strokeWidth: o * parseInt(h.strokeWidth, 10) / 100,
                        fill: "none",
                        strokeOpacity: h.opacity,
                        classes: "apexcharts-radialbar-area"
                    });
                    if (h.dropShadow.enabled) {
                        var p = h.dropShadow;
                        s.dropShadow(u, p);
                    }
                    l.add(u), u.attr("id", "apexcharts-radialbarTrack-" + n), this.animatePaths(u, {
                        centerX: t.centerX,
                        centerY: t.centerY,
                        endAngle: g,
                        startAngle: d,
                        size: t.size,
                        i: n,
                        totalItems: 2,
                        animBeginArr: 0,
                        dur: 0,
                        isTrack: !0,
                        easing: e.globals.easing
                    });
                }
                return a;
            }
        },
        {
            key: "drawArcs",
            value: function(t) {
                var e = this.w, i = new $fffa43d1c55f0813$var$m(this.ctx), a = new $fffa43d1c55f0813$var$R(this.ctx), s = new $fffa43d1c55f0813$var$v(this.ctx), r = i.group(), o = this.getStrokeWidth(t);
                t.size = t.size - o / 2;
                var n = e.config.plotOptions.radialBar.hollow.background, l = t.size - o * t.series.length - this.margin * t.series.length - o * parseInt(e.config.plotOptions.radialBar.track.strokeWidth, 10) / 100 / 2, h = l - e.config.plotOptions.radialBar.hollow.margin;
                void 0 !== e.config.plotOptions.radialBar.hollow.image && (n = this.drawHollowImage(t, r, l, n));
                var c = this.drawHollow({
                    size: h,
                    centerX: t.centerX,
                    centerY: t.centerY,
                    fill: n || "transparent"
                });
                if (e.config.plotOptions.radialBar.hollow.dropShadow.enabled) {
                    var d = e.config.plotOptions.radialBar.hollow.dropShadow;
                    s.dropShadow(c, d);
                }
                var g = 1;
                !this.radialDataLabels.total.show && e.globals.series.length > 1 && (g = 0);
                var u = null;
                this.radialDataLabels.show && (u = this.renderInnerDataLabels(this.radialDataLabels, {
                    hollowSize: l,
                    centerX: t.centerX,
                    centerY: t.centerY,
                    opacity: g
                })), "back" === e.config.plotOptions.radialBar.hollow.position && (r.add(c), u && r.add(u));
                var p = !1;
                e.config.plotOptions.radialBar.inverseOrder && (p = !0);
                for(var f = p ? t.series.length - 1 : 0; p ? f >= 0 : f < t.series.length; p ? f-- : f++){
                    var b = i.group({
                        class: "apexcharts-series apexcharts-radial-series",
                        seriesName: $fffa43d1c55f0813$var$x.escapeString(e.globals.seriesNames[f])
                    });
                    r.add(b), b.attr({
                        rel: f + 1,
                        "data:realIndex": f
                    }), this.ctx.series.addCollapsedClassToSeries(b, f), t.size = t.size - o - this.margin;
                    var y = a.fillPath({
                        seriesNumber: f,
                        size: t.size,
                        value: t.series[f]
                    }), w = this.startAngle, k = void 0, A = $fffa43d1c55f0813$var$x.negToZero(t.series[f] > 100 ? 100 : t.series[f]) / 100, S = Math.round(this.totalAngle * A) + this.startAngle, C = void 0;
                    e.globals.dataChanged && (k = this.startAngle, C = Math.round(this.totalAngle * $fffa43d1c55f0813$var$x.negToZero(e.globals.previousPaths[f]) / 100) + k), Math.abs(S) + Math.abs(w) >= 360 && (S -= .01), Math.abs(C) + Math.abs(k) >= 360 && (C -= .01);
                    var L = S - w, P = Array.isArray(e.config.stroke.dashArray) ? e.config.stroke.dashArray[f] : e.config.stroke.dashArray, I = i.drawPath({
                        d: "",
                        stroke: y,
                        strokeWidth: o,
                        fill: "none",
                        fillOpacity: e.config.fill.opacity,
                        classes: "apexcharts-radialbar-area apexcharts-radialbar-slice-" + f,
                        strokeDashArray: P
                    });
                    if ($fffa43d1c55f0813$var$m.setAttrs(I.node, {
                        "data:angle": L,
                        "data:value": t.series[f]
                    }), e.config.chart.dropShadow.enabled) {
                        var T = e.config.chart.dropShadow;
                        s.dropShadow(I, T, f);
                    }
                    if (s.setSelectionFilter(I, 0, f), this.addListeners(I, this.radialDataLabels), b.add(I), I.attr({
                        index: 0,
                        j: f
                    }), this.barLabels.enabled) {
                        var M = $fffa43d1c55f0813$var$x.polarToCartesian(t.centerX, t.centerY, t.size, w), z = this.barLabels.formatter(e.globals.seriesNames[f], {
                            seriesIndex: f,
                            w: e
                        }), X = [
                            "apexcharts-radialbar-label"
                        ];
                        this.barLabels.onClick || X.push("apexcharts-no-click");
                        var E = this.barLabels.useSeriesColors ? e.globals.colors[f] : e.config.chart.foreColor;
                        E || (E = e.config.chart.foreColor);
                        var Y = M.x - this.barLabels.margin, F = M.y, H = i.drawText({
                            x: Y,
                            y: F,
                            text: z,
                            textAnchor: "end",
                            dominantBaseline: "middle",
                            fontFamily: this.barLabels.fontFamily,
                            fontWeight: this.barLabels.fontWeight,
                            fontSize: this.barLabels.fontSize,
                            foreColor: E,
                            cssClass: X.join(" ")
                        });
                        H.on("click", this.onBarLabelClick), H.attr({
                            rel: f + 1
                        }), 0 !== w && H.attr({
                            "transform-origin": "".concat(Y, " ").concat(F),
                            transform: "rotate(".concat(w, " 0 0)")
                        }), b.add(H);
                    }
                    var D = 0;
                    !this.initialAnim || e.globals.resized || e.globals.dataChanged || (D = e.config.chart.animations.speed), e.globals.dataChanged && (D = e.config.chart.animations.dynamicAnimation.speed), this.animDur = D / (1.2 * t.series.length) + this.animDur, this.animBeginArr.push(this.animDur), this.animatePaths(I, {
                        centerX: t.centerX,
                        centerY: t.centerY,
                        endAngle: S,
                        startAngle: w,
                        prevEndAngle: C,
                        prevStartAngle: k,
                        size: t.size,
                        i: f,
                        totalItems: 2,
                        animBeginArr: this.animBeginArr,
                        dur: D,
                        shouldSetPrevPaths: !0,
                        easing: e.globals.easing
                    });
                }
                return {
                    g: r,
                    elHollow: c,
                    dataLabels: u
                };
            }
        },
        {
            key: "drawHollow",
            value: function(t) {
                var e = new $fffa43d1c55f0813$var$m(this.ctx).drawCircle(2 * t.size);
                return e.attr({
                    class: "apexcharts-radialbar-hollow",
                    cx: t.centerX,
                    cy: t.centerY,
                    r: t.size,
                    fill: t.fill
                }), e;
            }
        },
        {
            key: "drawHollowImage",
            value: function(t, e, i, a) {
                var s = this.w, r = new $fffa43d1c55f0813$var$R(this.ctx), o = $fffa43d1c55f0813$var$x.randomId(), n = s.config.plotOptions.radialBar.hollow.image;
                if (s.config.plotOptions.radialBar.hollow.imageClipped) r.clippedImgArea({
                    width: i,
                    height: i,
                    image: n,
                    patternID: "pattern".concat(s.globals.cuid).concat(o)
                }), a = "url(#pattern".concat(s.globals.cuid).concat(o, ")");
                else {
                    var l = s.config.plotOptions.radialBar.hollow.imageWidth, h = s.config.plotOptions.radialBar.hollow.imageHeight;
                    if (void 0 === l && void 0 === h) {
                        var c = s.globals.dom.Paper.image(n).loaded(function(e) {
                            this.move(t.centerX - e.width / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetX, t.centerY - e.height / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetY);
                        });
                        e.add(c);
                    } else {
                        var d = s.globals.dom.Paper.image(n).loaded(function(e) {
                            this.move(t.centerX - l / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetX, t.centerY - h / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetY), this.size(l, h);
                        });
                        e.add(d);
                    }
                }
                return a;
            }
        },
        {
            key: "getStrokeWidth",
            value: function(t) {
                var e = this.w;
                return t.size * (100 - parseInt(e.config.plotOptions.radialBar.hollow.size, 10)) / 100 / (t.series.length + 1) - this.margin;
            }
        },
        {
            key: "onBarLabelClick",
            value: function(t) {
                var e = parseInt(t.target.getAttribute("rel"), 10) - 1, i = this.barLabels.onClick, a = this.w;
                i && i(a.globals.seriesNames[e], {
                    w: a,
                    seriesIndex: e
                });
            }
        }
    ]), i;
}(), $fffa43d1c55f0813$var$Tt = function(t) {
    $fffa43d1c55f0813$var$n(s, $fffa43d1c55f0813$var$yt);
    var i = $fffa43d1c55f0813$var$d(s);
    function s() {
        return $fffa43d1c55f0813$var$a(this, s), i.apply(this, arguments);
    }
    return $fffa43d1c55f0813$var$r(s, [
        {
            key: "draw",
            value: function(t, i) {
                var a = this.w, s = new $fffa43d1c55f0813$var$m(this.ctx);
                this.rangeBarOptions = this.w.config.plotOptions.rangeBar, this.series = t, this.seriesRangeStart = a.globals.seriesRangeStart, this.seriesRangeEnd = a.globals.seriesRangeEnd, this.barHelpers.initVariables(t);
                for(var r = s.group({
                    class: "apexcharts-rangebar-series apexcharts-plot-series"
                }), n = 0; n < t.length; n++){
                    var l, h, c, d, g = void 0, u = void 0, p = a.globals.comboCharts ? i[n] : n, f = s.group({
                        class: "apexcharts-series",
                        seriesName: $fffa43d1c55f0813$var$x.escapeString(a.globals.seriesNames[p]),
                        rel: n + 1,
                        "data:realIndex": p
                    });
                    this.ctx.series.addCollapsedClassToSeries(f, p), t[n].length > 0 && (this.visibleI = this.visibleI + 1);
                    var b = 0, v = 0;
                    this.yRatio.length > 1 && (this.yaxisIndex = p);
                    var y = this.barHelpers.initialPositions();
                    u = y.y, d = y.zeroW, g = y.x, v = y.barWidth, b = y.barHeight, l = y.xDivision, h = y.yDivision, c = y.zeroH;
                    for(var w = s.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": p
                    }), k = s.group({
                        class: "apexcharts-rangebar-goals-markers"
                    }), A = 0; A < a.globals.dataPoints; A++){
                        var S, C = this.barHelpers.getStrokeWidth(n, A, p), L = this.seriesRangeStart[n][A], P = this.seriesRangeEnd[n][A], I = null, T = null, M = null, z = {
                            x: g,
                            y: u,
                            strokeWidth: C,
                            elSeries: f
                        }, X = this.seriesLen;
                        if (a.config.plotOptions.bar.rangeBarGroupRows && (X = 1), void 0 === a.config.series[n].data[A]) break;
                        if (this.isHorizontal) {
                            M = u + b * this.visibleI;
                            var E = (h - b * X) / 2;
                            if (a.config.series[n].data[A].x) {
                                var Y = this.detectOverlappingBars({
                                    i: n,
                                    j: A,
                                    barYPosition: M,
                                    srty: E,
                                    barHeight: b,
                                    yDivision: h,
                                    initPositions: y
                                });
                                b = Y.barHeight, M = Y.barYPosition;
                            }
                            v = (I = this.drawRangeBarPaths($fffa43d1c55f0813$var$e({
                                indexes: {
                                    i: n,
                                    j: A,
                                    realIndex: p
                                },
                                barHeight: b,
                                barYPosition: M,
                                zeroW: d,
                                yDivision: h,
                                y1: L,
                                y2: P
                            }, z))).barWidth;
                        } else {
                            a.globals.isXNumeric && (g = (a.globals.seriesX[n][A] - a.globals.minX) / this.xRatio - v / 2), T = g + v * this.visibleI;
                            var F = (l - v * X) / 2;
                            if (a.config.series[n].data[A].x) {
                                var R = this.detectOverlappingBars({
                                    i: n,
                                    j: A,
                                    barXPosition: T,
                                    srtx: F,
                                    barWidth: v,
                                    xDivision: l,
                                    initPositions: y
                                });
                                v = R.barWidth, T = R.barXPosition;
                            }
                            b = (I = this.drawRangeColumnPaths($fffa43d1c55f0813$var$e({
                                indexes: {
                                    i: n,
                                    j: A,
                                    realIndex: p
                                },
                                barWidth: v,
                                barXPosition: T,
                                zeroH: c,
                                xDivision: l
                            }, z))).barHeight;
                        }
                        var H = this.barHelpers.drawGoalLine({
                            barXPosition: I.barXPosition,
                            barYPosition: M,
                            goalX: I.goalX,
                            goalY: I.goalY,
                            barHeight: b,
                            barWidth: v
                        });
                        H && k.add(H), u = I.y, g = I.x;
                        var D = this.barHelpers.getPathFillColor(t, n, A, p), O = a.globals.stroke.colors[p];
                        this.renderSeries(($fffa43d1c55f0813$var$o(S = {
                            realIndex: p,
                            pathFill: D,
                            lineFill: O,
                            j: A,
                            i: n,
                            x: g,
                            y: u,
                            y1: L,
                            y2: P,
                            pathFrom: I.pathFrom,
                            pathTo: I.pathTo,
                            strokeWidth: C,
                            elSeries: f,
                            series: t,
                            barHeight: b,
                            barWidth: v,
                            barXPosition: T,
                            barYPosition: M
                        }, "barWidth", v), $fffa43d1c55f0813$var$o(S, "elDataLabelsWrap", w), $fffa43d1c55f0813$var$o(S, "elGoalsMarkers", k), $fffa43d1c55f0813$var$o(S, "visibleSeries", this.visibleI), $fffa43d1c55f0813$var$o(S, "type", "rangebar"), S));
                    }
                    r.add(f);
                }
                return r;
            }
        },
        {
            key: "detectOverlappingBars",
            value: function(t) {
                var e = t.i, i = t.j, a = t.barYPosition, s = t.barXPosition, r = t.srty, o = t.srtx, n = t.barHeight, l = t.barWidth, h = t.yDivision, c = t.xDivision, d = t.initPositions, g = this.w, u = [], p = g.config.series[e].data[i].rangeName, f = g.config.series[e].data[i].x, x = Array.isArray(f) ? f.join(" ") : f, b = g.globals.labels.map(function(t) {
                    return Array.isArray(t) ? t.join(" ") : t;
                }).indexOf(x), v = g.globals.seriesRange[e].findIndex(function(t) {
                    return t.x === x && t.overlaps.length > 0;
                });
                return this.isHorizontal ? (a = g.config.plotOptions.bar.rangeBarGroupRows ? r + h * b : r + n * this.visibleI + h * b, v > -1 && !g.config.plotOptions.bar.rangeBarOverlap && (u = g.globals.seriesRange[e][v].overlaps).indexOf(p) > -1 && (a = (n = d.barHeight / u.length) * this.visibleI + h * (100 - parseInt(this.barOptions.barHeight, 10)) / 100 / 2 + n * (this.visibleI + u.indexOf(p)) + h * b)) : (b > -1 && (s = g.config.plotOptions.bar.rangeBarGroupRows ? o + c * b : o + l * this.visibleI + c * b), v > -1 && !g.config.plotOptions.bar.rangeBarOverlap && (u = g.globals.seriesRange[e][v].overlaps).indexOf(p) > -1 && (s = (l = d.barWidth / u.length) * this.visibleI + c * (100 - parseInt(this.barOptions.barWidth, 10)) / 100 / 2 + l * (this.visibleI + u.indexOf(p)) + c * b)), {
                    barYPosition: a,
                    barXPosition: s,
                    barHeight: n,
                    barWidth: l
                };
            }
        },
        {
            key: "drawRangeColumnPaths",
            value: function(t) {
                var e = t.indexes, i = t.x, a = t.xDivision, s = t.barWidth, r = t.barXPosition, o = t.zeroH, n = this.w, l = e.i, h = e.j, c = this.yRatio[this.yaxisIndex], d = e.realIndex, g = this.getRangeValue(d, h), u = Math.min(g.start, g.end), p = Math.max(g.start, g.end);
                void 0 === this.series[l][h] || null === this.series[l][h] ? u = o : (u = o - u / c, p = o - p / c);
                var f = Math.abs(p - u), x = this.barHelpers.getColumnPaths({
                    barXPosition: r,
                    barWidth: s,
                    y1: u,
                    y2: p,
                    strokeWidth: this.strokeWidth,
                    series: this.seriesRangeEnd,
                    realIndex: e.realIndex,
                    i: d,
                    j: h,
                    w: n
                });
                if (n.globals.isXNumeric) {
                    var b = this.getBarXForNumericXAxis({
                        x: i,
                        j: h,
                        realIndex: d,
                        barWidth: s
                    });
                    i = b.x, r = b.barXPosition;
                } else i += a;
                return {
                    pathTo: x.pathTo,
                    pathFrom: x.pathFrom,
                    barHeight: f,
                    x: i,
                    y: p,
                    goalY: this.barHelpers.getGoalValues("y", null, o, l, h),
                    barXPosition: r
                };
            }
        },
        {
            key: "drawRangeBarPaths",
            value: function(t) {
                var e = t.indexes, i = t.y, a = t.y1, s = t.y2, r = t.yDivision, o = t.barHeight, n = t.barYPosition, l = t.zeroW, h = this.w, c = l + a / this.invertedYRatio, d = l + s / this.invertedYRatio, g = Math.abs(d - c), u = this.barHelpers.getBarpaths({
                    barYPosition: n,
                    barHeight: o,
                    x1: c,
                    x2: d,
                    strokeWidth: this.strokeWidth,
                    series: this.seriesRangeEnd,
                    i: e.realIndex,
                    realIndex: e.realIndex,
                    j: e.j,
                    w: h
                });
                return h.globals.isXNumeric || (i += r), {
                    pathTo: u.pathTo,
                    pathFrom: u.pathFrom,
                    barWidth: g,
                    x: d,
                    goalX: this.barHelpers.getGoalValues("x", l, null, e.realIndex, e.j),
                    y: i
                };
            }
        },
        {
            key: "getRangeValue",
            value: function(t, e) {
                var i = this.w;
                return {
                    start: i.globals.seriesRangeStart[t][e],
                    end: i.globals.seriesRangeEnd[t][e]
                };
            }
        }
    ]), s;
}(), $fffa43d1c55f0813$var$Mt = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.w = e.w, this.lineCtx = e;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "sameValueSeriesFix",
            value: function(t, e) {
                var i = this.w;
                if (("gradient" === i.config.fill.type || "gradient" === i.config.fill.type[t]) && new $fffa43d1c55f0813$var$y(this.lineCtx.ctx, i).seriesHaveSameValues(t)) {
                    var a = e[t].slice();
                    a[a.length - 1] = a[a.length - 1] + 1e-6, e[t] = a;
                }
                return e;
            }
        },
        {
            key: "calculatePoints",
            value: function(t) {
                var e = t.series, i = t.realIndex, a = t.x, s = t.y, r = t.i, o = t.j, n = t.prevY, l = this.w, h = [], c = [];
                if (0 === o) {
                    var d = this.lineCtx.categoryAxisCorrection + l.config.markers.offsetX;
                    l.globals.isXNumeric && (d = (l.globals.seriesX[i][0] - l.globals.minX) / this.lineCtx.xRatio + l.config.markers.offsetX), h.push(d), c.push($fffa43d1c55f0813$var$x.isNumber(e[r][0]) ? n + l.config.markers.offsetY : null), h.push(a + l.config.markers.offsetX), c.push($fffa43d1c55f0813$var$x.isNumber(e[r][o + 1]) ? s + l.config.markers.offsetY : null);
                } else h.push(a + l.config.markers.offsetX), c.push($fffa43d1c55f0813$var$x.isNumber(e[r][o + 1]) ? s + l.config.markers.offsetY : null);
                return {
                    x: h,
                    y: c
                };
            }
        },
        {
            key: "checkPreviousPaths",
            value: function(t) {
                for(var e = t.pathFromLine, i = t.pathFromArea, a = t.realIndex, s = this.w, r = 0; r < s.globals.previousPaths.length; r++){
                    var o = s.globals.previousPaths[r];
                    ("line" === o.type || "area" === o.type) && o.paths.length > 0 && parseInt(o.realIndex, 10) === parseInt(a, 10) && ("line" === o.type ? (this.lineCtx.appendPathFrom = !1, e = s.globals.previousPaths[r].paths[0].d) : "area" === o.type && (this.lineCtx.appendPathFrom = !1, i = s.globals.previousPaths[r].paths[0].d, s.config.stroke.show && s.globals.previousPaths[r].paths[1] && (e = s.globals.previousPaths[r].paths[1].d)));
                }
                return {
                    pathFromLine: e,
                    pathFromArea: i
                };
            }
        },
        {
            key: "determineFirstPrevY",
            value: function(t) {
                var e, i, a = t.i, s = t.series, r = t.prevY, o = t.lineYPosition, n = this.w, l = n.config.chart.stacked && (!n.config.chart.stackOnlyBar || "bar" === (null == s || null === (e = s[a]) || void 0 === e ? void 0 : e.type));
                if (void 0 !== (null === (i = s[a]) || void 0 === i ? void 0 : i[0])) r = (o = l && a > 0 ? this.lineCtx.prevSeriesY[a - 1][0] : this.lineCtx.zeroY) - s[a][0] / this.lineCtx.yRatio[this.lineCtx.yaxisIndex] + 2 * (this.lineCtx.isReversed ? s[a][0] / this.lineCtx.yRatio[this.lineCtx.yaxisIndex] : 0);
                else if (l && a > 0 && void 0 === s[a][0]) {
                    for(var h = a - 1; h >= 0; h--)if (null !== s[h][0] && void 0 !== s[h][0]) {
                        r = o = this.lineCtx.prevSeriesY[h][0];
                        break;
                    }
                }
                return {
                    prevY: r,
                    lineYPosition: o
                };
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$zt = function(t) {
    for(var e, i, a, s, r = function(t) {
        for(var e = [], i = t[0], a = t[1], s = e[0] = $fffa43d1c55f0813$var$Yt(i, a), r = 1, o = t.length - 1; r < o; r++)i = a, a = t[r + 1], e[r] = .5 * (s + (s = $fffa43d1c55f0813$var$Yt(i, a)));
        return e[r] = s, e;
    }(t), o = t.length - 1, n = [], l = 0; l < o; l++)a = $fffa43d1c55f0813$var$Yt(t[l], t[l + 1]), Math.abs(a) < 1e-6 ? r[l] = r[l + 1] = 0 : (s = (e = r[l] / a) * e + (i = r[l + 1] / a) * i) > 9 && (s = 3 * a / Math.sqrt(s), r[l] = s * e, r[l + 1] = s * i);
    for(var h = 0; h <= o; h++)s = (t[Math.min(o, h + 1)][0] - t[Math.max(0, h - 1)][0]) / (6 * (1 + r[h] * r[h])), n.push([
        s || 0,
        r[h] * s || 0
    ]);
    return n;
}, $fffa43d1c55f0813$var$Xt = function(t, e) {
    for(var i = "", a = 0; a < t.length; a++){
        var s = t[a], r = t[a - 1], o = s.length, n = null == r ? void 0 : r.length;
        a > 1 && Math.abs(s[o - 2] - r[n - 2]) < e / 25 ? i += "L".concat(s[2], ", ").concat(s[3]) : o > 4 ? (i += "C".concat(s[0], ", ").concat(s[1]), i += ", ".concat(s[2], ", ").concat(s[3]), i += ", ".concat(s[4], ", ").concat(s[5])) : o > 2 && (i += "S".concat(s[0], ", ").concat(s[1]), i += ", ".concat(s[2], ", ").concat(s[3]));
    }
    return i;
}, $fffa43d1c55f0813$var$Et = function(t) {
    var e = $fffa43d1c55f0813$var$zt(t), i = t[1], a = t[0], s = [], r = e[1], o = e[0];
    s.push(a, [
        a[0] + o[0],
        a[1] + o[1],
        i[0] - r[0],
        i[1] - r[1],
        i[0],
        i[1]
    ]);
    for(var n = 2, l = e.length; n < l; n++){
        var h = t[n], c = e[n];
        s.push([
            h[0] - c[0],
            h[1] - c[1],
            h[0],
            h[1]
        ]);
    }
    return s;
};
function $fffa43d1c55f0813$var$Yt(t, e) {
    return (e[1] - t[1]) / (e[0] - t[0]);
}
var $fffa43d1c55f0813$var$Ft = function() {
    function t(e, i, s) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w, this.xyRatios = i, this.pointsChart = !("bubble" !== this.w.config.chart.type && "scatter" !== this.w.config.chart.type) || s, this.scatter = new $fffa43d1c55f0813$var$D(this.ctx), this.noNegatives = this.w.globals.minX === Number.MAX_VALUE, this.lineHelpers = new $fffa43d1c55f0813$var$Mt(this), this.markers = new $fffa43d1c55f0813$var$H(this.ctx), this.prevSeriesY = [], this.categoryAxisCorrection = 0, this.yaxisIndex = 0;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "draw",
            value: function(t, i, a, s) {
                var r, o = this.w, n = new $fffa43d1c55f0813$var$m(this.ctx), l = o.globals.comboCharts ? i : o.config.chart.type, h = n.group({
                    class: "apexcharts-".concat(l, "-series apexcharts-plot-series")
                }), c = new $fffa43d1c55f0813$var$y(this.ctx, o);
                this.yRatio = this.xyRatios.yRatio, this.zRatio = this.xyRatios.zRatio, this.xRatio = this.xyRatios.xRatio, this.baseLineY = this.xyRatios.baseLineY, t = c.getLogSeries(t), this.yRatio = c.getLogYRatios(this.yRatio);
                for(var d = [], g = 0; g < t.length; g++){
                    t = this.lineHelpers.sameValueSeriesFix(g, t);
                    var u = o.globals.comboCharts ? a[g] : g;
                    this._initSerieVariables(t, g, u);
                    var p = [], f = [], x = [], b = o.globals.padHorizontal + this.categoryAxisCorrection;
                    this.ctx.series.addCollapsedClassToSeries(this.elSeries, u), o.globals.isXNumeric && o.globals.seriesX.length > 0 && (b = (o.globals.seriesX[u][0] - o.globals.minX) / this.xRatio), x.push(b);
                    var v = b, w = this.zeroY, k = this.zeroY;
                    w = this.lineHelpers.determineFirstPrevY({
                        i: g,
                        series: t,
                        prevY: w,
                        lineYPosition: 0
                    }).prevY, "smooth" === o.config.stroke.curve && null === t[g][0] ? p.push(null) : p.push(w);
                    "rangeArea" === l && (k = this.lineHelpers.determineFirstPrevY({
                        i: g,
                        series: s,
                        prevY: k,
                        lineYPosition: 0
                    }).prevY, f.push(k));
                    var A = {
                        type: l,
                        series: t,
                        realIndex: u,
                        i: g,
                        x: b,
                        y: 1,
                        pathsFrom: this._calculatePathsFrom({
                            type: l,
                            series: t,
                            i: g,
                            realIndex: u,
                            prevX: v,
                            prevY: w,
                            prevY2: k
                        }),
                        linePaths: [],
                        areaPaths: [],
                        seriesIndex: a,
                        lineYPosition: 0,
                        xArrj: x,
                        yArrj: p,
                        y2Arrj: f,
                        seriesRangeEnd: s
                    }, S = this._iterateOverDataPoints($fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, A), {}, {
                        iterations: "rangeArea" === l ? t[g].length - 1 : void 0,
                        isRangeStart: !0
                    }));
                    if ("rangeArea" === l) {
                        var C = this._calculatePathsFrom({
                            series: s,
                            i: g,
                            realIndex: u,
                            prevX: v,
                            prevY: k
                        }), L = this._iterateOverDataPoints($fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, A), {}, {
                            series: s,
                            pathsFrom: C,
                            iterations: s[g].length - 1,
                            isRangeStart: !1
                        }));
                        S.linePaths[0] = L.linePath + S.linePath, S.pathFromLine = L.pathFromLine + S.pathFromLine;
                    }
                    this._handlePaths({
                        type: l,
                        realIndex: u,
                        i: g,
                        paths: S
                    }), this.elSeries.add(this.elPointsMain), this.elSeries.add(this.elDataLabelsWrap), d.push(this.elSeries);
                }
                if (void 0 !== (null === (r = o.config.series[0]) || void 0 === r ? void 0 : r.zIndex) && d.sort(function(t, e) {
                    return Number(t.node.getAttribute("zIndex")) - Number(e.node.getAttribute("zIndex"));
                }), o.config.chart.stacked) for(var P = d.length; P > 0; P--)h.add(d[P - 1]);
                else for(var I = 0; I < d.length; I++)h.add(d[I]);
                return h;
            }
        },
        {
            key: "_initSerieVariables",
            value: function(t, e, i) {
                var a = this.w, s = new $fffa43d1c55f0813$var$m(this.ctx);
                this.xDivision = a.globals.gridWidth / (a.globals.dataPoints - ("on" === a.config.xaxis.tickPlacement ? 1 : 0)), this.strokeWidth = Array.isArray(a.config.stroke.width) ? a.config.stroke.width[i] : a.config.stroke.width, this.yRatio.length > 1 && (this.yaxisIndex = i), this.isReversed = a.config.yaxis[this.yaxisIndex] && a.config.yaxis[this.yaxisIndex].reversed, this.zeroY = a.globals.gridHeight - this.baseLineY[this.yaxisIndex] - (this.isReversed ? a.globals.gridHeight : 0) + (this.isReversed ? 2 * this.baseLineY[this.yaxisIndex] : 0), this.areaBottomY = this.zeroY, (this.zeroY > a.globals.gridHeight || "end" === a.config.plotOptions.area.fillTo) && (this.areaBottomY = a.globals.gridHeight), this.categoryAxisCorrection = this.xDivision / 2, this.elSeries = s.group({
                    class: "apexcharts-series",
                    zIndex: void 0 !== a.config.series[i].zIndex ? a.config.series[i].zIndex : i,
                    seriesName: $fffa43d1c55f0813$var$x.escapeString(a.globals.seriesNames[i])
                }), this.elPointsMain = s.group({
                    class: "apexcharts-series-markers-wrap",
                    "data:realIndex": i
                }), this.elDataLabelsWrap = s.group({
                    class: "apexcharts-datalabels",
                    "data:realIndex": i
                });
                var r = t[e].length === a.globals.dataPoints;
                this.elSeries.attr({
                    "data:longestSeries": r,
                    rel: e + 1,
                    "data:realIndex": i
                }), this.appendPathFrom = !0;
            }
        },
        {
            key: "_calculatePathsFrom",
            value: function(t) {
                var e, i, a, s, r = t.type, o = t.series, n = t.i, l = t.realIndex, h = t.prevX, c = t.prevY, d = t.prevY2, g = this.w, u = new $fffa43d1c55f0813$var$m(this.ctx);
                if (null === o[n][0]) {
                    for(var p = 0; p < o[n].length; p++)if (null !== o[n][p]) {
                        h = this.xDivision * p, c = this.zeroY - o[n][p] / this.yRatio[this.yaxisIndex], e = u.move(h, c), i = u.move(h, this.areaBottomY);
                        break;
                    }
                } else e = u.move(h, c), "rangeArea" === r && (e = u.move(h, d) + u.line(h, c)), i = u.move(h, this.areaBottomY) + u.line(h, c);
                if (a = u.move(-1, this.zeroY) + u.line(-1, this.zeroY), s = u.move(-1, this.zeroY) + u.line(-1, this.zeroY), g.globals.previousPaths.length > 0) {
                    var f = this.lineHelpers.checkPreviousPaths({
                        pathFromLine: a,
                        pathFromArea: s,
                        realIndex: l
                    });
                    a = f.pathFromLine, s = f.pathFromArea;
                }
                return {
                    prevX: h,
                    prevY: c,
                    linePath: e,
                    areaPath: i,
                    pathFromLine: a,
                    pathFromArea: s
                };
            }
        },
        {
            key: "_handlePaths",
            value: function(t) {
                var i = t.type, a = t.realIndex, s = t.i, r = t.paths, o = this.w, n = new $fffa43d1c55f0813$var$m(this.ctx), l = new $fffa43d1c55f0813$var$R(this.ctx);
                this.prevSeriesY.push(r.yArrj), o.globals.seriesXvalues[a] = r.xArrj, o.globals.seriesYvalues[a] = r.yArrj;
                var h = o.config.forecastDataPoints;
                if (h.count > 0 && "rangeArea" !== i) {
                    var c = o.globals.seriesXvalues[a][o.globals.seriesXvalues[a].length - h.count - 1], d = n.drawRect(c, 0, o.globals.gridWidth, o.globals.gridHeight, 0);
                    o.globals.dom.elForecastMask.appendChild(d.node);
                    var g = n.drawRect(0, 0, c, o.globals.gridHeight, 0);
                    o.globals.dom.elNonForecastMask.appendChild(g.node);
                }
                this.pointsChart || o.globals.delayedElements.push({
                    el: this.elPointsMain.node,
                    index: a
                });
                var u = {
                    i: s,
                    realIndex: a,
                    animationDelay: s,
                    initialSpeed: o.config.chart.animations.speed,
                    dataChangeSpeed: o.config.chart.animations.dynamicAnimation.speed,
                    className: "apexcharts-".concat(i)
                };
                if ("area" === i) for(var p = l.fillPath({
                    seriesNumber: a
                }), f = 0; f < r.areaPaths.length; f++){
                    var x = n.renderPaths($fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, u), {}, {
                        pathFrom: r.pathFromArea,
                        pathTo: r.areaPaths[f],
                        stroke: "none",
                        strokeWidth: 0,
                        strokeLineCap: null,
                        fill: p
                    }));
                    this.elSeries.add(x);
                }
                if (o.config.stroke.show && !this.pointsChart) {
                    var b = null;
                    if ("line" === i) b = l.fillPath({
                        seriesNumber: a,
                        i: s
                    });
                    else if ("solid" === o.config.stroke.fill.type) b = o.globals.stroke.colors[a];
                    else {
                        var v = o.config.fill;
                        o.config.fill = o.config.stroke.fill, b = l.fillPath({
                            seriesNumber: a,
                            i: s
                        }), o.config.fill = v;
                    }
                    for(var y = 0; y < r.linePaths.length; y++){
                        var w = b;
                        "rangeArea" === i && (w = l.fillPath({
                            seriesNumber: a
                        }));
                        var k = $fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, u), {}, {
                            pathFrom: r.pathFromLine,
                            pathTo: r.linePaths[y],
                            stroke: b,
                            strokeWidth: this.strokeWidth,
                            strokeLineCap: o.config.stroke.lineCap,
                            fill: "rangeArea" === i ? w : "none"
                        }), A = n.renderPaths(k);
                        if (this.elSeries.add(A), A.attr("fill-rule", "evenodd"), h.count > 0 && "rangeArea" !== i) {
                            var S = n.renderPaths(k);
                            S.node.setAttribute("stroke-dasharray", h.dashArray), h.strokeWidth && S.node.setAttribute("stroke-width", h.strokeWidth), this.elSeries.add(S), S.attr("clip-path", "url(#forecastMask".concat(o.globals.cuid, ")")), A.attr("clip-path", "url(#nonForecastMask".concat(o.globals.cuid, ")"));
                        }
                    }
                }
            }
        },
        {
            key: "_iterateOverDataPoints",
            value: function(t) {
                var e, i = this, a = t.type, s = t.series, r = t.iterations, o = t.realIndex, n = t.i, l = t.x, h = t.y, c = t.pathsFrom, d = t.linePaths, g = t.areaPaths, u = t.seriesIndex, p = t.lineYPosition, f = t.xArrj, b = t.yArrj, v = t.y2Arrj, y = t.isRangeStart, w = t.seriesRangeEnd, k = this.w, A = new $fffa43d1c55f0813$var$m(this.ctx), S = this.yRatio, C = c.prevY, L = c.linePath, P = c.areaPath, I = c.pathFromLine, T = c.pathFromArea, M = $fffa43d1c55f0813$var$x.isNumber(k.globals.minYArr[o]) ? k.globals.minYArr[o] : k.globals.minY;
                r || (r = k.globals.dataPoints > 1 ? k.globals.dataPoints - 1 : k.globals.dataPoints);
                for(var z = function(t, e) {
                    return e - t / S[i.yaxisIndex] + 2 * (i.isReversed ? t / S[i.yaxisIndex] : 0);
                }, X = h, E = k.config.chart.stacked && (!this.w.config.chart.stackOnlyBar || "bar" === (null === (e = this.w.config.series[o]) || void 0 === e ? void 0 : e.type)), Y = 0; Y < r; Y++){
                    var F = void 0 === s[n][Y + 1] || null === s[n][Y + 1];
                    if (k.globals.isXNumeric) {
                        var R = k.globals.seriesX[o][Y + 1];
                        void 0 === k.globals.seriesX[o][Y + 1] && (R = k.globals.seriesX[o][r - 1]), l = (R - k.globals.minX) / this.xRatio;
                    } else l += this.xDivision;
                    if (E) {
                        if (n > 0 && k.globals.collapsedSeries.length < k.config.series.length - 1) p = this.prevSeriesY[function(t) {
                            for(var e = t, i = 0; i < k.globals.series.length; i++)if (k.globals.collapsedSeriesIndices.indexOf(t) > -1) {
                                e--;
                                break;
                            }
                            return e >= 0 ? e : 0;
                        }(n - 1)][Y + 1];
                        else p = this.zeroY;
                    } else p = this.zeroY;
                    F ? h = z(M, p) : (h = z(s[n][Y + 1], p), "rangeArea" === a && (X = z(w[n][Y + 1], p))), f.push(l), F && "smooth" === k.config.stroke.curve ? b.push(null) : b.push(h), v.push(X);
                    var H = this.lineHelpers.calculatePoints({
                        series: s,
                        x: l,
                        y: h,
                        realIndex: o,
                        i: n,
                        j: Y,
                        prevY: C
                    }), D = this._createPaths({
                        type: a,
                        series: s,
                        i: n,
                        realIndex: o,
                        j: Y,
                        x: l,
                        y: h,
                        y2: X,
                        xArrj: f,
                        yArrj: b,
                        y2Arrj: v,
                        linePath: L,
                        areaPath: P,
                        linePaths: d,
                        areaPaths: g,
                        seriesIndex: u,
                        isRangeStart: y
                    });
                    g = D.areaPaths, d = D.linePaths, P = D.areaPath, L = D.linePath, !this.appendPathFrom || "smooth" === k.config.stroke.curve && "rangeArea" === a || (I += A.line(l, this.zeroY), T += A.line(l, this.zeroY)), this.handleNullDataPoints(s, H, n, Y, o), this._handleMarkersAndLabels({
                        type: a,
                        pointsPos: H,
                        i: n,
                        j: Y,
                        realIndex: o,
                        isRangeStart: y
                    });
                }
                return {
                    yArrj: b,
                    xArrj: f,
                    pathFromArea: T,
                    areaPaths: g,
                    pathFromLine: I,
                    linePaths: d,
                    linePath: L,
                    areaPath: P
                };
            }
        },
        {
            key: "_handleMarkersAndLabels",
            value: function(t) {
                var e = t.type, i = t.pointsPos, a = t.isRangeStart, s = t.i, r = t.j, o = t.realIndex, n = this.w, l = new $fffa43d1c55f0813$var$O(this.ctx);
                if (this.pointsChart) this.scatter.draw(this.elSeries, r, {
                    realIndex: o,
                    pointsPos: i,
                    zRatio: this.zRatio,
                    elParent: this.elPointsMain
                });
                else {
                    n.globals.series[s].length > 1 && this.elPointsMain.node.classList.add("apexcharts-element-hidden");
                    var h = this.markers.plotChartMarkers(i, o, r + 1);
                    null !== h && this.elPointsMain.add(h);
                }
                var c = l.drawDataLabel({
                    type: e,
                    isRangeStart: a,
                    pos: i,
                    i: o,
                    j: r + 1
                });
                null !== c && this.elDataLabelsWrap.add(c);
            }
        },
        {
            key: "_createPaths",
            value: function(t) {
                var e = t.type, i = t.series, a = t.i, s = t.realIndex, r = t.j, o = t.x, n = t.y, l = t.xArrj, h = t.yArrj, c = t.y2, d = t.y2Arrj, g = t.linePath, u = t.areaPath, p = t.linePaths, f = t.areaPaths, x = t.seriesIndex, b = t.isRangeStart, v = this.w, y = new $fffa43d1c55f0813$var$m(this.ctx), w = v.config.stroke.curve, k = this.areaBottomY;
                if (Array.isArray(v.config.stroke.curve) && (w = Array.isArray(x) ? v.config.stroke.curve[x[a]] : v.config.stroke.curve[a]), "rangeArea" === e && (v.globals.hasNullValues || v.config.forecastDataPoints.count > 0) && "smooth" === w && (w = "straight"), "smooth" === w) {
                    var A = "rangeArea" === e ? l.length === v.globals.dataPoints : r === i[a].length - 2, S = l.map(function(t, e) {
                        return [
                            l[e],
                            h[e]
                        ];
                    }).filter(function(t) {
                        return null !== t[1];
                    });
                    if (A && S.length > 1) {
                        var C = $fffa43d1c55f0813$var$Et(S);
                        if (g += $fffa43d1c55f0813$var$Xt(C, v.globals.gridWidth), null === i[a][0] ? u = g : u += $fffa43d1c55f0813$var$Xt(C, v.globals.gridWidth), "rangeArea" === e && b) {
                            g += y.line(l[l.length - 1], d[d.length - 1]);
                            var L = l.slice().reverse(), P = d.slice().reverse(), I = L.map(function(t, e) {
                                return [
                                    L[e],
                                    P[e]
                                ];
                            }), T = $fffa43d1c55f0813$var$Et(I);
                            u = g += $fffa43d1c55f0813$var$Xt(T, v.globals.gridWidth);
                        } else u += y.line(S[S.length - 1][0], k) + y.line(S[0][0], k) + y.move(S[0][0], S[0][1]) + "z";
                        p.push(g), f.push(u);
                    }
                } else {
                    if (null === i[a][r + 1]) {
                        g += y.move(o, n);
                        var M = v.globals.isXNumeric ? (v.globals.seriesX[s][r] - v.globals.minX) / this.xRatio : o - this.xDivision;
                        u = u + y.line(M, k) + y.move(o, n) + "z";
                    }
                    null === i[a][r] && (g += y.move(o, n), u += y.move(o, k)), "stepline" === w ? (g = g + y.line(o, null, "H") + y.line(null, n, "V"), u = u + y.line(o, null, "H") + y.line(null, n, "V")) : "straight" === w && (g += y.line(o, n), u += y.line(o, n)), r === i[a].length - 2 && (u = u + y.line(o, k) + y.move(o, n) + "z", "rangeArea" === e && b ? g = g + y.line(o, c) + y.move(o, c) + "z" : (p.push(g), f.push(u)));
                }
                return {
                    linePaths: p,
                    areaPaths: f,
                    linePath: g,
                    areaPath: u
                };
            }
        },
        {
            key: "handleNullDataPoints",
            value: function(t, e, i, a, s) {
                var r = this.w;
                if (null === t[i][a] && r.config.markers.showNullDataPoints || 1 === t[i].length) {
                    var o = this.markers.plotChartMarkers(e, s, a + 1, this.strokeWidth - r.config.markers.strokeWidth / 2, !0);
                    null !== o && this.elPointsMain.add(o);
                }
            }
        }
    ]), t;
}();
window.TreemapSquared = {}, window.TreemapSquared.generate = function() {
    function t(e, i, a, s) {
        this.xoffset = e, this.yoffset = i, this.height = s, this.width = a, this.shortestEdge = function() {
            return Math.min(this.height, this.width);
        }, this.getCoordinates = function(t) {
            var e, i = [], a = this.xoffset, s = this.yoffset, o = r(t) / this.height, n = r(t) / this.width;
            if (this.width >= this.height) for(e = 0; e < t.length; e++)i.push([
                a,
                s,
                a + o,
                s + t[e] / o
            ]), s += t[e] / o;
            else for(e = 0; e < t.length; e++)i.push([
                a,
                s,
                a + t[e] / n,
                s + n
            ]), a += t[e] / n;
            return i;
        }, this.cutArea = function(e) {
            var i;
            if (this.width >= this.height) {
                var a = e / this.height, s = this.width - a;
                i = new t(this.xoffset + a, this.yoffset, s, this.height);
            } else {
                var r = e / this.width, o = this.height - r;
                i = new t(this.xoffset, this.yoffset + r, this.width, o);
            }
            return i;
        };
    }
    function e(e, a, s, o, n) {
        o = void 0 === o ? 0 : o, n = void 0 === n ? 0 : n;
        var l = i(function(t, e) {
            var i, a = [], s = e / r(t);
            for(i = 0; i < t.length; i++)a[i] = t[i] * s;
            return a;
        }(e, a * s), [], new t(o, n, a, s), []);
        return function(t) {
            var e, i, a = [];
            for(e = 0; e < t.length; e++)for(i = 0; i < t[e].length; i++)a.push(t[e][i]);
            return a;
        }(l);
    }
    function i(t, e, s, o) {
        var n, l, h;
        if (0 !== t.length) return n = s.shortestEdge(), function(t, e, i) {
            var s;
            if (0 === t.length) return !0;
            (s = t.slice()).push(e);
            var r = a(t, i), o = a(s, i);
            return r >= o;
        }(e, l = t[0], n) ? (e.push(l), i(t.slice(1), e, s, o)) : (h = s.cutArea(r(e), o), o.push(s.getCoordinates(e)), i(t, [], h, o)), o;
        o.push(s.getCoordinates(e));
    }
    function a(t, e) {
        var i = Math.min.apply(Math, t), a = Math.max.apply(Math, t), s = r(t);
        return Math.max(Math.pow(e, 2) * a / Math.pow(s, 2), Math.pow(s, 2) / (Math.pow(e, 2) * i));
    }
    function s(t) {
        return t && t.constructor === Array;
    }
    function r(t) {
        var e, i = 0;
        for(e = 0; e < t.length; e++)i += t[e];
        return i;
    }
    function o(t) {
        var e, i = 0;
        if (s(t[0])) for(e = 0; e < t.length; e++)i += o(t[e]);
        else i = r(t);
        return i;
    }
    return function t(i, a, r, n, l) {
        n = void 0 === n ? 0 : n, l = void 0 === l ? 0 : l;
        var h, c, d = [], g = [];
        if (s(i[0])) {
            for(c = 0; c < i.length; c++)d[c] = o(i[c]);
            for(h = e(d, a, r, n, l), c = 0; c < i.length; c++)g.push(t(i[c], h[c][2] - h[c][0], h[c][3] - h[c][1], h[c][0], h[c][1]));
        } else g = e(i, a, r, n, l);
        return g;
    };
}();
var $fffa43d1c55f0813$var$Rt, $fffa43d1c55f0813$var$Ht, $fffa43d1c55f0813$var$Dt = function() {
    function t(e, i) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w, this.strokeWidth = this.w.config.stroke.width, this.helpers = new $fffa43d1c55f0813$var$At(e), this.dynamicAnim = this.w.config.chart.animations.dynamicAnimation, this.labels = [];
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "draw",
            value: function(t) {
                var e = this, i = this.w, a = new $fffa43d1c55f0813$var$m(this.ctx), s = new $fffa43d1c55f0813$var$R(this.ctx), r = a.group({
                    class: "apexcharts-treemap"
                });
                if (i.globals.noData) return r;
                var o = [];
                return t.forEach(function(t) {
                    var e = t.map(function(t) {
                        return Math.abs(t);
                    });
                    o.push(e);
                }), this.negRange = this.helpers.checkColorRange(), i.config.series.forEach(function(t, i) {
                    t.data.forEach(function(t) {
                        Array.isArray(e.labels[i]) || (e.labels[i] = []), e.labels[i].push(t.x);
                    });
                }), window.TreemapSquared.generate(o, i.globals.gridWidth, i.globals.gridHeight).forEach(function(o, n) {
                    var l = a.group({
                        class: "apexcharts-series apexcharts-treemap-series",
                        seriesName: $fffa43d1c55f0813$var$x.escapeString(i.globals.seriesNames[n]),
                        rel: n + 1,
                        "data:realIndex": n
                    });
                    if (i.config.chart.dropShadow.enabled) {
                        var h = i.config.chart.dropShadow;
                        new $fffa43d1c55f0813$var$v(e.ctx).dropShadow(r, h, n);
                    }
                    var c = a.group({
                        class: "apexcharts-data-labels"
                    });
                    o.forEach(function(r, o) {
                        var h = r[0], c = r[1], d = r[2], g = r[3], u = a.drawRect(h, c, d - h, g - c, 0, "#fff", 1, e.strokeWidth, i.config.plotOptions.treemap.useFillColorAsStroke ? f : i.globals.stroke.colors[n]);
                        u.attr({
                            cx: h,
                            cy: c,
                            index: n,
                            i: n,
                            j: o,
                            width: d - h,
                            height: g - c
                        });
                        var p = e.helpers.getShadeColor(i.config.chart.type, n, o, e.negRange), f = p.color;
                        void 0 !== i.config.series[n].data[o] && i.config.series[n].data[o].fillColor && (f = i.config.series[n].data[o].fillColor);
                        var x = s.fillPath({
                            color: f,
                            seriesNumber: n,
                            dataPointIndex: o
                        });
                        u.node.classList.add("apexcharts-treemap-rect"), u.attr({
                            fill: x
                        }), e.helpers.addListeners(u);
                        var b = {
                            x: h + (d - h) / 2,
                            y: c + (g - c) / 2,
                            width: 0,
                            height: 0
                        }, v = {
                            x: h,
                            y: c,
                            width: d - h,
                            height: g - c
                        };
                        if (i.config.chart.animations.enabled && !i.globals.dataChanged) {
                            var m = 1;
                            i.globals.resized || (m = i.config.chart.animations.speed), e.animateTreemap(u, b, v, m);
                        }
                        if (i.globals.dataChanged) {
                            var y = 1;
                            e.dynamicAnim.enabled && i.globals.shouldAnimate && (y = e.dynamicAnim.speed, i.globals.previousPaths[n] && i.globals.previousPaths[n][o] && i.globals.previousPaths[n][o].rect && (b = i.globals.previousPaths[n][o].rect), e.animateTreemap(u, b, v, y));
                        }
                        var w = e.getFontSize(r), k = i.config.dataLabels.formatter(e.labels[n][o], {
                            value: i.globals.series[n][o],
                            seriesIndex: n,
                            dataPointIndex: o,
                            w: i
                        });
                        "truncate" === i.config.plotOptions.treemap.dataLabels.format && (w = parseInt(i.config.dataLabels.style.fontSize, 10), k = e.truncateLabels(k, w, h, c, d, g));
                        var A = e.helpers.calculateDataLabels({
                            text: k,
                            x: (h + d) / 2,
                            y: (c + g) / 2 + e.strokeWidth / 2 + w / 3,
                            i: n,
                            j: o,
                            colorProps: p,
                            fontSize: w,
                            series: t
                        });
                        i.config.dataLabels.enabled && A && e.rotateToFitLabel(A, w, k, h, c, d, g), l.add(u), null !== A && l.add(A);
                    }), l.add(c), r.add(l);
                }), r;
            }
        },
        {
            key: "getFontSize",
            value: function(t) {
                var e = this.w;
                var i, a, s, r, o = function t(e) {
                    var i, a = 0;
                    if (Array.isArray(e[0])) for(i = 0; i < e.length; i++)a += t(e[i]);
                    else for(i = 0; i < e.length; i++)a += e[i].length;
                    return a;
                }(this.labels) / function t(e) {
                    var i, a = 0;
                    if (Array.isArray(e[0])) for(i = 0; i < e.length; i++)a += t(e[i]);
                    else for(i = 0; i < e.length; i++)a += 1;
                    return a;
                }(this.labels);
                return i = t[2] - t[0], a = t[3] - t[1], s = i * a, r = Math.pow(s, .5), Math.min(r / o, parseInt(e.config.dataLabels.style.fontSize, 10));
            }
        },
        {
            key: "rotateToFitLabel",
            value: function(t, e, i, a, s, r, o) {
                var n = new $fffa43d1c55f0813$var$m(this.ctx), l = n.getTextRects(i, e);
                if (l.width + this.w.config.stroke.width + 5 > r - a && l.width <= o - s) {
                    var h = n.rotateAroundCenter(t.node);
                    t.node.setAttribute("transform", "rotate(-90 ".concat(h.x, " ").concat(h.y, ") translate(").concat(l.height / 3, ")"));
                }
            }
        },
        {
            key: "truncateLabels",
            value: function(t, e, i, a, s, r) {
                var o = new $fffa43d1c55f0813$var$m(this.ctx), n = o.getTextRects(t, e).width + this.w.config.stroke.width + 5 > s - i && r - a > s - i ? r - a : s - i, l = o.getTextBasedOnMaxWidth({
                    text: t,
                    maxWidth: n,
                    fontSize: e
                });
                return t.length !== l.length && n / e < 5 ? "" : l;
            }
        },
        {
            key: "animateTreemap",
            value: function(t, e, i, a) {
                var s = new $fffa43d1c55f0813$var$b(this.ctx);
                s.animateRect(t, {
                    x: e.x,
                    y: e.y,
                    width: e.width,
                    height: e.height
                }, {
                    x: i.x,
                    y: i.y,
                    width: i.width,
                    height: i.height
                }, a, function() {
                    s.animationCompleted(t);
                });
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$Ot = 86400, $fffa43d1c55f0813$var$Nt = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w, this.timeScaleArray = [], this.utc = this.w.config.xaxis.labels.datetimeUTC;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "calculateTimeScaleTicks",
            value: function(t, i) {
                var a = this, s = this.w;
                if (s.globals.allSeriesCollapsed) return s.globals.labels = [], s.globals.timescaleLabels = [], [];
                var r = new $fffa43d1c55f0813$var$I(this.ctx), o = (i - t) / 864e5;
                this.determineInterval(o), s.globals.disableZoomIn = !1, s.globals.disableZoomOut = !1, o < .00011574074074074075 ? s.globals.disableZoomIn = !0 : o > 5e4 && (s.globals.disableZoomOut = !0);
                var n = r.getTimeUnitsfromTimestamp(t, i, this.utc), l = s.globals.gridWidth / o, h = l / 24, c = h / 60, d = c / 60, g = Math.floor(24 * o), u = Math.floor(1440 * o), p = Math.floor(o * $fffa43d1c55f0813$var$Ot), f = Math.floor(o), x = Math.floor(o / 30), b = Math.floor(o / 365), v = {
                    minMillisecond: n.minMillisecond,
                    minSecond: n.minSecond,
                    minMinute: n.minMinute,
                    minHour: n.minHour,
                    minDate: n.minDate,
                    minMonth: n.minMonth,
                    minYear: n.minYear
                }, m = {
                    firstVal: v,
                    currentMillisecond: v.minMillisecond,
                    currentSecond: v.minSecond,
                    currentMinute: v.minMinute,
                    currentHour: v.minHour,
                    currentMonthDate: v.minDate,
                    currentDate: v.minDate,
                    currentMonth: v.minMonth,
                    currentYear: v.minYear,
                    daysWidthOnXAxis: l,
                    hoursWidthOnXAxis: h,
                    minutesWidthOnXAxis: c,
                    secondsWidthOnXAxis: d,
                    numberOfSeconds: p,
                    numberOfMinutes: u,
                    numberOfHours: g,
                    numberOfDays: f,
                    numberOfMonths: x,
                    numberOfYears: b
                };
                switch(this.tickInterval){
                    case "years":
                        this.generateYearScale(m);
                        break;
                    case "months":
                    case "half_year":
                        this.generateMonthScale(m);
                        break;
                    case "months_days":
                    case "months_fortnight":
                    case "days":
                    case "week_days":
                        this.generateDayScale(m);
                        break;
                    case "hours":
                        this.generateHourScale(m);
                        break;
                    case "minutes_fives":
                    case "minutes":
                        this.generateMinuteScale(m);
                        break;
                    case "seconds_tens":
                    case "seconds_fives":
                    case "seconds":
                        this.generateSecondScale(m);
                }
                var y = this.timeScaleArray.map(function(t) {
                    var i = {
                        position: t.position,
                        unit: t.unit,
                        year: t.year,
                        day: t.day ? t.day : 1,
                        hour: t.hour ? t.hour : 0,
                        month: t.month + 1
                    };
                    return "month" === t.unit ? $fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, i), {}, {
                        day: 1,
                        value: t.value + 1
                    }) : "day" === t.unit || "hour" === t.unit ? $fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, i), {}, {
                        value: t.value
                    }) : "minute" === t.unit ? $fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, i), {}, {
                        value: t.value,
                        minute: t.value
                    }) : "second" === t.unit ? $fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, i), {}, {
                        value: t.value,
                        minute: t.minute,
                        second: t.second
                    }) : t;
                });
                return y.filter(function(t) {
                    var e = 1, i = Math.ceil(s.globals.gridWidth / 120), r = t.value;
                    void 0 !== s.config.xaxis.tickAmount && (i = s.config.xaxis.tickAmount), y.length > i && (e = Math.floor(y.length / i));
                    var o = !1, n = !1;
                    switch(a.tickInterval){
                        case "years":
                            "year" === t.unit && (o = !0);
                            break;
                        case "half_year":
                            e = 7, "year" === t.unit && (o = !0);
                            break;
                        case "months":
                            e = 1, "year" === t.unit && (o = !0);
                            break;
                        case "months_fortnight":
                            e = 15, "year" !== t.unit && "month" !== t.unit || (o = !0), 30 === r && (n = !0);
                            break;
                        case "months_days":
                            e = 10, "month" === t.unit && (o = !0), 30 === r && (n = !0);
                            break;
                        case "week_days":
                            e = 8, "month" === t.unit && (o = !0);
                            break;
                        case "days":
                            e = 1, "month" === t.unit && (o = !0);
                            break;
                        case "hours":
                            "day" === t.unit && (o = !0);
                            break;
                        case "minutes_fives":
                        case "seconds_fives":
                            r % 5 != 0 && (n = !0);
                            break;
                        case "seconds_tens":
                            r % 10 != 0 && (n = !0);
                    }
                    if ("hours" === a.tickInterval || "minutes_fives" === a.tickInterval || "seconds_tens" === a.tickInterval || "seconds_fives" === a.tickInterval) {
                        if (!n) return !0;
                    } else if ((r % e == 0 || o) && !n) return !0;
                });
            }
        },
        {
            key: "recalcDimensionsBasedOnFormat",
            value: function(t, e) {
                var i = this.w, a = this.formatDates(t), s = this.removeOverlappingTS(a);
                i.globals.timescaleLabels = s.slice(), new $fffa43d1c55f0813$var$ot(this.ctx).plotCoords();
            }
        },
        {
            key: "determineInterval",
            value: function(t) {
                var e = 24 * t, i = 60 * e;
                switch(!0){
                    case t / 365 > 5:
                        this.tickInterval = "years";
                        break;
                    case t > 800:
                        this.tickInterval = "half_year";
                        break;
                    case t > 180:
                        this.tickInterval = "months";
                        break;
                    case t > 90:
                        this.tickInterval = "months_fortnight";
                        break;
                    case t > 60:
                        this.tickInterval = "months_days";
                        break;
                    case t > 30:
                        this.tickInterval = "week_days";
                        break;
                    case t > 2:
                        this.tickInterval = "days";
                        break;
                    case e > 2.4:
                        this.tickInterval = "hours";
                        break;
                    case i > 15:
                        this.tickInterval = "minutes_fives";
                        break;
                    case i > 5:
                        this.tickInterval = "minutes";
                        break;
                    case i > 1:
                        this.tickInterval = "seconds_tens";
                        break;
                    case 60 * i > 20:
                        this.tickInterval = "seconds_fives";
                        break;
                    default:
                        this.tickInterval = "seconds";
                }
            }
        },
        {
            key: "generateYearScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentMonth, a = t.currentYear, s = t.daysWidthOnXAxis, r = t.numberOfYears, o = e.minYear, n = 0, l = new $fffa43d1c55f0813$var$I(this.ctx), h = "year";
                if (e.minDate > 1 || e.minMonth > 0) {
                    var c = l.determineRemainingDaysOfYear(e.minYear, e.minMonth, e.minDate);
                    n = (l.determineDaysOfYear(e.minYear) - c + 1) * s, o = e.minYear + 1, this.timeScaleArray.push({
                        position: n,
                        value: o,
                        unit: h,
                        year: o,
                        month: $fffa43d1c55f0813$var$x.monthMod(i + 1)
                    });
                } else 1 === e.minDate && 0 === e.minMonth && this.timeScaleArray.push({
                    position: n,
                    value: o,
                    unit: h,
                    year: a,
                    month: $fffa43d1c55f0813$var$x.monthMod(i + 1)
                });
                for(var d = o, g = n, u = 0; u < r; u++)d++, g = l.determineDaysOfYear(d - 1) * s + g, this.timeScaleArray.push({
                    position: g,
                    value: d,
                    unit: h,
                    year: d,
                    month: 1
                });
            }
        },
        {
            key: "generateMonthScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentMonthDate, a = t.currentMonth, s = t.currentYear, r = t.daysWidthOnXAxis, o = t.numberOfMonths, n = a, l = 0, h = new $fffa43d1c55f0813$var$I(this.ctx), c = "month", d = 0;
                if (e.minDate > 1) {
                    l = (h.determineDaysOfMonths(a + 1, e.minYear) - i + 1) * r, n = $fffa43d1c55f0813$var$x.monthMod(a + 1);
                    var g = s + d, u = $fffa43d1c55f0813$var$x.monthMod(n), p = n;
                    0 === n && (c = "year", p = g, u = 1, g += d += 1), this.timeScaleArray.push({
                        position: l,
                        value: p,
                        unit: c,
                        year: g,
                        month: u
                    });
                } else this.timeScaleArray.push({
                    position: l,
                    value: n,
                    unit: c,
                    year: s,
                    month: $fffa43d1c55f0813$var$x.monthMod(a)
                });
                for(var f = n + 1, b = l, v = 0, m = 1; v < o; v++, m++){
                    0 === (f = $fffa43d1c55f0813$var$x.monthMod(f)) ? (c = "year", d += 1) : c = "month";
                    var y = this._getYear(s, f, d);
                    b = h.determineDaysOfMonths(f, y) * r + b;
                    var w = 0 === f ? y : f;
                    this.timeScaleArray.push({
                        position: b,
                        value: w,
                        unit: c,
                        year: y,
                        month: 0 === f ? 1 : f
                    }), f++;
                }
            }
        },
        {
            key: "generateDayScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentMonth, a = t.currentYear, s = t.hoursWidthOnXAxis, r = t.numberOfDays, o = new $fffa43d1c55f0813$var$I(this.ctx), n = "day", l = e.minDate + 1, h = l, c = function(t, e, i) {
                    return t > o.determineDaysOfMonths(e + 1, i) ? (h = 1, n = "month", g = e += 1, e) : e;
                }, d = (24 - e.minHour) * s, g = l, u = c(h, i, a);
                0 === e.minHour && 1 === e.minDate ? (d = 0, g = $fffa43d1c55f0813$var$x.monthMod(e.minMonth), n = "month", h = e.minDate) : 1 !== e.minDate && 0 === e.minHour && 0 === e.minMinute && (d = 0, l = e.minDate, g = l, u = c(h = l, i, a)), this.timeScaleArray.push({
                    position: d,
                    value: g,
                    unit: n,
                    year: this._getYear(a, u, 0),
                    month: $fffa43d1c55f0813$var$x.monthMod(u),
                    day: h
                });
                for(var p = d, f = 0; f < r; f++){
                    n = "day", u = c(h += 1, u, this._getYear(a, u, 0));
                    var b = this._getYear(a, u, 0);
                    p = 24 * s + p;
                    var v = 1 === h ? $fffa43d1c55f0813$var$x.monthMod(u) : h;
                    this.timeScaleArray.push({
                        position: p,
                        value: v,
                        unit: n,
                        year: b,
                        month: $fffa43d1c55f0813$var$x.monthMod(u),
                        day: v
                    });
                }
            }
        },
        {
            key: "generateHourScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentDate, a = t.currentMonth, s = t.currentYear, r = t.minutesWidthOnXAxis, o = t.numberOfHours, n = new $fffa43d1c55f0813$var$I(this.ctx), l = "hour", h = function(t, e) {
                    return t > n.determineDaysOfMonths(e + 1, s) && (f = 1, e += 1), {
                        month: e,
                        date: f
                    };
                }, c = function(t, e) {
                    return t > n.determineDaysOfMonths(e + 1, s) ? e += 1 : e;
                }, d = 60 - (e.minMinute + e.minSecond / 60), g = d * r, u = e.minHour + 1, p = u;
                60 === d && (g = 0, p = (u = e.minHour) + 1);
                var f = i;
                p >= 24 && (p = 0, f += 1, l = "day");
                var b = h(f, a).month;
                b = c(f, b), this.timeScaleArray.push({
                    position: g,
                    value: u,
                    unit: l,
                    day: f,
                    hour: p,
                    year: s,
                    month: $fffa43d1c55f0813$var$x.monthMod(b)
                }), p++;
                for(var v = g, m = 0; m < o; m++){
                    if (l = "hour", p >= 24) p = 0, l = "day", b = h(f += 1, b).month, b = c(f, b);
                    var y = this._getYear(s, b, 0);
                    v = 60 * r + v;
                    var w = 0 === p ? f : p;
                    this.timeScaleArray.push({
                        position: v,
                        value: w,
                        unit: l,
                        hour: p,
                        day: f,
                        year: y,
                        month: $fffa43d1c55f0813$var$x.monthMod(b)
                    }), p++;
                }
            }
        },
        {
            key: "generateMinuteScale",
            value: function(t) {
                for(var e = t.currentMillisecond, i = t.currentSecond, a = t.currentMinute, s = t.currentHour, r = t.currentDate, o = t.currentMonth, n = t.currentYear, l = t.minutesWidthOnXAxis, h = t.secondsWidthOnXAxis, c = t.numberOfMinutes, d = a + 1, g = r, u = o, p = n, f = s, b = (60 - i - e / 1e3) * h, v = 0; v < c; v++)d >= 60 && (d = 0, 24 === (f += 1) && (f = 0)), this.timeScaleArray.push({
                    position: b,
                    value: d,
                    unit: "minute",
                    hour: f,
                    minute: d,
                    day: g,
                    year: this._getYear(p, u, 0),
                    month: $fffa43d1c55f0813$var$x.monthMod(u)
                }), b += l, d++;
            }
        },
        {
            key: "generateSecondScale",
            value: function(t) {
                for(var e = t.currentMillisecond, i = t.currentSecond, a = t.currentMinute, s = t.currentHour, r = t.currentDate, o = t.currentMonth, n = t.currentYear, l = t.secondsWidthOnXAxis, h = t.numberOfSeconds, c = i + 1, d = a, g = r, u = o, p = n, f = s, b = (1e3 - e) / 1e3 * l, v = 0; v < h; v++)c >= 60 && (c = 0, ++d >= 60 && (d = 0, 24 === ++f && (f = 0))), this.timeScaleArray.push({
                    position: b,
                    value: c,
                    unit: "second",
                    hour: f,
                    minute: d,
                    second: c,
                    day: g,
                    year: this._getYear(p, u, 0),
                    month: $fffa43d1c55f0813$var$x.monthMod(u)
                }), b += l, c++;
            }
        },
        {
            key: "createRawDateString",
            value: function(t, e) {
                var i = t.year;
                return 0 === t.month && (t.month = 1), i += "-" + ("0" + t.month.toString()).slice(-2), "day" === t.unit ? i += "day" === t.unit ? "-" + ("0" + e).slice(-2) : "-01" : i += "-" + ("0" + (t.day ? t.day : "1")).slice(-2), "hour" === t.unit ? i += "hour" === t.unit ? "T" + ("0" + e).slice(-2) : "T00" : i += "T" + ("0" + (t.hour ? t.hour : "0")).slice(-2), "minute" === t.unit ? i += ":" + ("0" + e).slice(-2) : i += ":" + (t.minute ? ("0" + t.minute).slice(-2) : "00"), "second" === t.unit ? i += ":" + ("0" + e).slice(-2) : i += ":00", this.utc && (i += ".000Z"), i;
            }
        },
        {
            key: "formatDates",
            value: function(t) {
                var e = this, i = this.w;
                return t.map(function(t) {
                    var a = t.value.toString(), s = new $fffa43d1c55f0813$var$I(e.ctx), r = e.createRawDateString(t, a), o = s.getDate(s.parseDate(r));
                    if (e.utc || (o = s.getDate(s.parseDateWithTimezone(r))), void 0 === i.config.xaxis.labels.format) {
                        var n = "dd MMM", l = i.config.xaxis.labels.datetimeFormatter;
                        "year" === t.unit && (n = l.year), "month" === t.unit && (n = l.month), "day" === t.unit && (n = l.day), "hour" === t.unit && (n = l.hour), "minute" === t.unit && (n = l.minute), "second" === t.unit && (n = l.second), a = s.formatDate(o, n);
                    } else a = s.formatDate(o, i.config.xaxis.labels.format);
                    return {
                        dateString: r,
                        position: t.position,
                        value: a,
                        unit: t.unit,
                        year: t.year,
                        month: t.month
                    };
                });
            }
        },
        {
            key: "removeOverlappingTS",
            value: function(t) {
                var e, i = this, a = new $fffa43d1c55f0813$var$m(this.ctx), s = !1;
                t.length > 0 && t[0].value && t.every(function(e) {
                    return e.value.length === t[0].value.length;
                }) && (s = !0, e = a.getTextRects(t[0].value).width);
                var r = 0, o = t.map(function(o, n) {
                    if (n > 0 && i.w.config.xaxis.labels.hideOverlappingLabels) {
                        var l = s ? e : a.getTextRects(t[r].value).width, h = t[r].position;
                        return o.position > h + l + 10 ? (r = n, o) : null;
                    }
                    return o;
                });
                return o = o.filter(function(t) {
                    return null !== t;
                });
            }
        },
        {
            key: "_getYear",
            value: function(t, e, i) {
                return t + Math.floor(e / 12) + i;
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$Wt = function() {
    function t(e, i) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = i, this.w = i.w, this.el = e;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "setupElements",
            value: function() {
                var t = this.w.globals, e = this.w.config, i = e.chart.type;
                t.axisCharts = [
                    "line",
                    "area",
                    "bar",
                    "rangeBar",
                    "rangeArea",
                    "candlestick",
                    "boxPlot",
                    "scatter",
                    "bubble",
                    "radar",
                    "heatmap",
                    "treemap"
                ].indexOf(i) > -1, t.xyCharts = [
                    "line",
                    "area",
                    "bar",
                    "rangeBar",
                    "rangeArea",
                    "candlestick",
                    "boxPlot",
                    "scatter",
                    "bubble"
                ].indexOf(i) > -1, t.isBarHorizontal = ("bar" === e.chart.type || "rangeBar" === e.chart.type || "boxPlot" === e.chart.type) && e.plotOptions.bar.horizontal, t.chartClass = ".apexcharts" + t.chartID, t.dom.baseEl = this.el, t.dom.elWrap = document.createElement("div"), $fffa43d1c55f0813$var$m.setAttrs(t.dom.elWrap, {
                    id: t.chartClass.substring(1),
                    class: "apexcharts-canvas " + t.chartClass.substring(1)
                }), this.el.appendChild(t.dom.elWrap), t.dom.Paper = new window.SVG.Doc(t.dom.elWrap), t.dom.Paper.attr({
                    class: "apexcharts-svg",
                    "xmlns:data": "ApexChartsNS",
                    transform: "translate(".concat(e.chart.offsetX, ", ").concat(e.chart.offsetY, ")")
                }), t.dom.Paper.node.style.background = "dark" !== e.theme.mode || e.chart.background ? e.chart.background : "rgba(0, 0, 0, 0.8)", this.setSVGDimensions(), t.dom.elLegendForeign = document.createElementNS(t.SVGNS, "foreignObject"), $fffa43d1c55f0813$var$m.setAttrs(t.dom.elLegendForeign, {
                    x: 0,
                    y: 0,
                    width: t.svgWidth,
                    height: t.svgHeight
                }), t.dom.elLegendWrap = document.createElement("div"), t.dom.elLegendWrap.classList.add("apexcharts-legend"), t.dom.elLegendWrap.setAttribute("xmlns", "http://www.w3.org/1999/xhtml"), t.dom.elLegendForeign.appendChild(t.dom.elLegendWrap), t.dom.Paper.node.appendChild(t.dom.elLegendForeign), t.dom.elGraphical = t.dom.Paper.group().attr({
                    class: "apexcharts-inner apexcharts-graphical"
                }), t.dom.elDefs = t.dom.Paper.defs(), t.dom.Paper.add(t.dom.elGraphical), t.dom.elGraphical.add(t.dom.elDefs);
            }
        },
        {
            key: "plotChartType",
            value: function(t, e) {
                var i = this.w, a = i.config, s = i.globals, r = {
                    series: [],
                    i: []
                }, o = {
                    series: [],
                    i: []
                }, n = {
                    series: [],
                    i: []
                }, l = {
                    series: [],
                    i: []
                }, h = {
                    series: [],
                    i: []
                }, c = {
                    series: [],
                    i: []
                }, d = {
                    series: [],
                    i: []
                }, g = {
                    series: [],
                    i: []
                }, u = {
                    series: [],
                    seriesRangeEnd: [],
                    i: []
                };
                s.series.map(function(e, p) {
                    var f = 0;
                    void 0 !== t[p].type ? ("column" === t[p].type || "bar" === t[p].type ? (s.series.length > 1 && a.plotOptions.bar.horizontal && console.warn("Horizontal bars are not supported in a mixed/combo chart. Please turn off `plotOptions.bar.horizontal`"), h.series.push(e), h.i.push(p), f++, i.globals.columnSeries = h.series) : "area" === t[p].type ? (o.series.push(e), o.i.push(p), f++) : "line" === t[p].type ? (r.series.push(e), r.i.push(p), f++) : "scatter" === t[p].type ? (n.series.push(e), n.i.push(p)) : "bubble" === t[p].type ? (l.series.push(e), l.i.push(p), f++) : "candlestick" === t[p].type ? (c.series.push(e), c.i.push(p), f++) : "boxPlot" === t[p].type ? (d.series.push(e), d.i.push(p), f++) : "rangeBar" === t[p].type ? (g.series.push(e), g.i.push(p), f++) : "rangeArea" === t[p].type ? (u.series.push(s.seriesRangeStart[p]), u.seriesRangeEnd.push(s.seriesRangeEnd[p]), u.i.push(p), f++) : console.warn("You have specified an unrecognized chart type. Available types for this property are line/area/column/bar/scatter/bubble/candlestick/boxPlot/rangeBar/rangeArea"), f > 1 && (s.comboCharts = !0)) : (r.series.push(e), r.i.push(p));
                });
                var p = new $fffa43d1c55f0813$var$Ft(this.ctx, e), f = new $fffa43d1c55f0813$var$kt(this.ctx, e);
                this.ctx.pie = new $fffa43d1c55f0813$var$Lt(this.ctx);
                var x = new $fffa43d1c55f0813$var$It(this.ctx);
                this.ctx.rangeBar = new $fffa43d1c55f0813$var$Tt(this.ctx, e);
                var b = new $fffa43d1c55f0813$var$Pt(this.ctx), v = [];
                if (s.comboCharts) {
                    if (o.series.length > 0 && v.push(p.draw(o.series, "area", o.i)), h.series.length > 0) {
                        if (i.config.chart.stacked) {
                            var m = new $fffa43d1c55f0813$var$wt(this.ctx, e);
                            v.push(m.draw(h.series, h.i));
                        } else this.ctx.bar = new $fffa43d1c55f0813$var$yt(this.ctx, e), v.push(this.ctx.bar.draw(h.series, h.i));
                    }
                    if (u.series.length > 0 && v.push(p.draw(u.series, "rangeArea", u.i, u.seriesRangeEnd)), r.series.length > 0 && v.push(p.draw(r.series, "line", r.i)), c.series.length > 0 && v.push(f.draw(c.series, "candlestick", c.i)), d.series.length > 0 && v.push(f.draw(d.series, "boxPlot", d.i)), g.series.length > 0 && v.push(this.ctx.rangeBar.draw(g.series, g.i)), n.series.length > 0) {
                        var y = new $fffa43d1c55f0813$var$Ft(this.ctx, e, !0);
                        v.push(y.draw(n.series, "scatter", n.i));
                    }
                    if (l.series.length > 0) {
                        var w = new $fffa43d1c55f0813$var$Ft(this.ctx, e, !0);
                        v.push(w.draw(l.series, "bubble", l.i));
                    }
                } else switch(a.chart.type){
                    case "line":
                        v = p.draw(s.series, "line");
                        break;
                    case "area":
                        v = p.draw(s.series, "area");
                        break;
                    case "bar":
                        if (a.chart.stacked) v = new $fffa43d1c55f0813$var$wt(this.ctx, e).draw(s.series);
                        else this.ctx.bar = new $fffa43d1c55f0813$var$yt(this.ctx, e), v = this.ctx.bar.draw(s.series);
                        break;
                    case "candlestick":
                        v = new $fffa43d1c55f0813$var$kt(this.ctx, e).draw(s.series, "candlestick");
                        break;
                    case "boxPlot":
                        v = new $fffa43d1c55f0813$var$kt(this.ctx, e).draw(s.series, a.chart.type);
                        break;
                    case "rangeBar":
                        v = this.ctx.rangeBar.draw(s.series);
                        break;
                    case "rangeArea":
                        v = p.draw(s.seriesRangeStart, "rangeArea", void 0, s.seriesRangeEnd);
                        break;
                    case "heatmap":
                        v = new $fffa43d1c55f0813$var$St(this.ctx, e).draw(s.series);
                        break;
                    case "treemap":
                        v = new $fffa43d1c55f0813$var$Dt(this.ctx, e).draw(s.series);
                        break;
                    case "pie":
                    case "donut":
                    case "polarArea":
                        v = this.ctx.pie.draw(s.series);
                        break;
                    case "radialBar":
                        v = x.draw(s.series);
                        break;
                    case "radar":
                        v = b.draw(s.series);
                        break;
                    default:
                        v = p.draw(s.series);
                }
                return v;
            }
        },
        {
            key: "setSVGDimensions",
            value: function() {
                var t = this.w.globals, e = this.w.config;
                t.svgWidth = e.chart.width, t.svgHeight = e.chart.height;
                var i = $fffa43d1c55f0813$var$x.getDimensions(this.el), a = e.chart.width.toString().split(/[0-9]+/g).pop();
                "%" === a ? $fffa43d1c55f0813$var$x.isNumber(i[0]) && (0 === i[0].width && (i = $fffa43d1c55f0813$var$x.getDimensions(this.el.parentNode)), t.svgWidth = i[0] * parseInt(e.chart.width, 10) / 100) : "px" !== a && "" !== a || (t.svgWidth = parseInt(e.chart.width, 10));
                var s = e.chart.height.toString().split(/[0-9]+/g).pop();
                if ("auto" !== t.svgHeight && "" !== t.svgHeight) {
                    if ("%" === s) {
                        var r = $fffa43d1c55f0813$var$x.getDimensions(this.el.parentNode);
                        t.svgHeight = r[1] * parseInt(e.chart.height, 10) / 100;
                    } else t.svgHeight = parseInt(e.chart.height, 10);
                } else t.axisCharts ? t.svgHeight = t.svgWidth / 1.61 : t.svgHeight = t.svgWidth / 1.2;
                if (t.svgWidth < 0 && (t.svgWidth = 0), t.svgHeight < 0 && (t.svgHeight = 0), $fffa43d1c55f0813$var$m.setAttrs(t.dom.Paper.node, {
                    width: t.svgWidth,
                    height: t.svgHeight
                }), "%" !== s) {
                    var o = e.chart.sparkline.enabled ? 0 : t.axisCharts ? e.chart.parentHeightOffset : 0;
                    t.dom.Paper.node.parentNode.parentNode.style.minHeight = t.svgHeight + o + "px";
                }
                t.dom.elWrap.style.width = t.svgWidth + "px", t.dom.elWrap.style.height = t.svgHeight + "px";
            }
        },
        {
            key: "shiftGraphPosition",
            value: function() {
                var t = this.w.globals, e = t.translateY, i = {
                    transform: "translate(" + t.translateX + ", " + e + ")"
                };
                $fffa43d1c55f0813$var$m.setAttrs(t.dom.elGraphical.node, i);
            }
        },
        {
            key: "resizeNonAxisCharts",
            value: function() {
                var t = this.w, e = t.globals, i = 0, a = t.config.chart.sparkline.enabled ? 1 : 15;
                a += t.config.grid.padding.bottom, "top" !== t.config.legend.position && "bottom" !== t.config.legend.position || !t.config.legend.show || t.config.legend.floating || (i = new $fffa43d1c55f0813$var$lt(this.ctx).legendHelpers.getLegendBBox().clwh + 10);
                var s = t.globals.dom.baseEl.querySelector(".apexcharts-radialbar, .apexcharts-pie"), r = 2.05 * t.globals.radialSize;
                if (s && !t.config.chart.sparkline.enabled && 0 !== t.config.plotOptions.radialBar.startAngle) {
                    var o = $fffa43d1c55f0813$var$x.getBoundingClientRect(s);
                    r = o.bottom;
                    var n = o.bottom - o.top;
                    r = Math.max(2.05 * t.globals.radialSize, n);
                }
                var l = r + e.translateY + i + a;
                e.dom.elLegendForeign && e.dom.elLegendForeign.setAttribute("height", l), t.config.chart.height && String(t.config.chart.height).indexOf("%") > 0 || (e.dom.elWrap.style.height = l + "px", $fffa43d1c55f0813$var$m.setAttrs(e.dom.Paper.node, {
                    height: l
                }), e.dom.Paper.node.parentNode.parentNode.style.minHeight = l + "px");
            }
        },
        {
            key: "coreCalculations",
            value: function() {
                new $fffa43d1c55f0813$var$U(this.ctx).init();
            }
        },
        {
            key: "resetGlobals",
            value: function() {
                var t = this, e = function() {
                    return t.w.config.series.map(function(t) {
                        return [];
                    });
                }, i = new $fffa43d1c55f0813$var$Y, a = this.w.globals;
                i.initGlobalVars(a), a.seriesXvalues = e(), a.seriesYvalues = e();
            }
        },
        {
            key: "isMultipleY",
            value: function() {
                if (this.w.config.yaxis.constructor === Array && this.w.config.yaxis.length > 1) return this.w.globals.isMultipleYAxis = !0, !0;
            }
        },
        {
            key: "xySettings",
            value: function() {
                var t = null, e = this.w;
                if (e.globals.axisCharts) {
                    if ("back" === e.config.xaxis.crosshairs.position) new $fffa43d1c55f0813$var$Q(this.ctx).drawXCrosshairs();
                    if ("back" === e.config.yaxis[0].crosshairs.position) new $fffa43d1c55f0813$var$Q(this.ctx).drawYCrosshairs();
                    if ("datetime" === e.config.xaxis.type && void 0 === e.config.xaxis.labels.formatter) {
                        this.ctx.timeScale = new $fffa43d1c55f0813$var$Nt(this.ctx);
                        var i = [];
                        isFinite(e.globals.minX) && isFinite(e.globals.maxX) && !e.globals.isBarHorizontal ? i = this.ctx.timeScale.calculateTimeScaleTicks(e.globals.minX, e.globals.maxX) : e.globals.isBarHorizontal && (i = this.ctx.timeScale.calculateTimeScaleTicks(e.globals.minY, e.globals.maxY)), this.ctx.timeScale.recalcDimensionsBasedOnFormat(i);
                    }
                    t = new $fffa43d1c55f0813$var$y(this.ctx).getCalculatedRatios();
                }
                return t;
            }
        },
        {
            key: "updateSourceChart",
            value: function(t) {
                this.ctx.w.globals.selection = void 0, this.ctx.updateHelpers._updateOptions({
                    chart: {
                        selection: {
                            xaxis: {
                                min: t.w.globals.minX,
                                max: t.w.globals.maxX
                            }
                        }
                    }
                }, !1, !1);
            }
        },
        {
            key: "setupBrushHandler",
            value: function() {
                var t = this, i = this.w;
                if (i.config.chart.brush.enabled && "function" != typeof i.config.chart.events.selection) {
                    var a = Array.isArray(i.config.chart.brush.targets) || [
                        i.config.chart.brush.target
                    ];
                    a.forEach(function(e) {
                        var i = ApexCharts.getChartByID(e);
                        i.w.globals.brushSource = t.ctx, "function" != typeof i.w.config.chart.events.zoomed && (i.w.config.chart.events.zoomed = function() {
                            t.updateSourceChart(i);
                        }), "function" != typeof i.w.config.chart.events.scrolled && (i.w.config.chart.events.scrolled = function() {
                            t.updateSourceChart(i);
                        });
                    }), i.config.chart.events.selection = function(t, s) {
                        a.forEach(function(t) {
                            var a = ApexCharts.getChartByID(t), r = $fffa43d1c55f0813$var$x.clone(i.config.yaxis);
                            if (i.config.chart.brush.autoScaleYaxis && 1 === a.w.globals.series.length) {
                                var o = new $fffa43d1c55f0813$var$_(a);
                                r = o.autoScaleY(a, r, s);
                            }
                            var n = a.w.config.yaxis.reduce(function(t, i, s) {
                                return [].concat($fffa43d1c55f0813$var$u(t), [
                                    $fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, a.w.config.yaxis[s]), {}, {
                                        min: r[0].min,
                                        max: r[0].max
                                    })
                                ]);
                            }, []);
                            a.ctx.updateHelpers._updateOptions({
                                xaxis: {
                                    min: s.xaxis.min,
                                    max: s.xaxis.max
                                },
                                yaxis: n
                            }, !1, !1, !1, !1);
                        });
                    };
                }
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$Bt = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "_updateOptions",
            value: function(t) {
                var e = this, a = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], s = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3], o = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
                return new Promise(function(n) {
                    var l = [
                        e.ctx
                    ];
                    r && (l = e.ctx.getSyncedCharts()), e.ctx.w.globals.isExecCalled && (l = [
                        e.ctx
                    ], e.ctx.w.globals.isExecCalled = !1), l.forEach(function(r, h) {
                        var c = r.w;
                        if (c.globals.shouldAnimate = s, a || (c.globals.resized = !0, c.globals.dataChanged = !0, s && r.series.getPreviousPaths()), t && "object" === $fffa43d1c55f0813$var$i(t) && (r.config = new $fffa43d1c55f0813$var$E(t), t = $fffa43d1c55f0813$var$y.extendArrayProps(r.config, t, c), r.w.globals.chartID !== e.ctx.w.globals.chartID && delete t.series, c.config = $fffa43d1c55f0813$var$x.extend(c.config, t), o && (c.globals.lastXAxis = t.xaxis ? $fffa43d1c55f0813$var$x.clone(t.xaxis) : [], c.globals.lastYAxis = t.yaxis ? $fffa43d1c55f0813$var$x.clone(t.yaxis) : [], c.globals.initialConfig = $fffa43d1c55f0813$var$x.extend({}, c.config), c.globals.initialSeries = $fffa43d1c55f0813$var$x.clone(c.config.series), t.series))) {
                            for(var d = 0; d < c.globals.collapsedSeriesIndices.length; d++){
                                var g = c.config.series[c.globals.collapsedSeriesIndices[d]];
                                c.globals.collapsedSeries[d].data = c.globals.axisCharts ? g.data.slice() : g;
                            }
                            for(var u = 0; u < c.globals.ancillaryCollapsedSeriesIndices.length; u++){
                                var p = c.config.series[c.globals.ancillaryCollapsedSeriesIndices[u]];
                                c.globals.ancillaryCollapsedSeries[u].data = c.globals.axisCharts ? p.data.slice() : p;
                            }
                            r.series.emptyCollapsedSeries(c.config.series);
                        }
                        return r.update(t).then(function() {
                            h === l.length - 1 && n(r);
                        });
                    });
                });
            }
        },
        {
            key: "_updateSeries",
            value: function(t, e) {
                var i = this, a = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                return new Promise(function(s) {
                    var r, o = i.w;
                    return o.globals.shouldAnimate = e, o.globals.dataChanged = !0, e && i.ctx.series.getPreviousPaths(), o.globals.axisCharts ? (0 === (r = t.map(function(t, e) {
                        return i._extendSeries(t, e);
                    })).length && (r = [
                        {
                            data: []
                        }
                    ]), o.config.series = r) : o.config.series = t.slice(), a && (o.globals.initialConfig.series = $fffa43d1c55f0813$var$x.clone(o.config.series), o.globals.initialSeries = $fffa43d1c55f0813$var$x.clone(o.config.series)), i.ctx.update().then(function() {
                        s(i.ctx);
                    });
                });
            }
        },
        {
            key: "_extendSeries",
            value: function(t, i) {
                var a = this.w, s = a.config.series[i];
                return $fffa43d1c55f0813$var$e($fffa43d1c55f0813$var$e({}, a.config.series[i]), {}, {
                    name: t.name ? t.name : null == s ? void 0 : s.name,
                    color: t.color ? t.color : null == s ? void 0 : s.color,
                    type: t.type ? t.type : null == s ? void 0 : s.type,
                    group: t.group ? t.group : null == s ? void 0 : s.group,
                    data: t.data ? t.data : null == s ? void 0 : s.data,
                    zIndex: void 0 !== t.zIndex ? t.zIndex : i
                });
            }
        },
        {
            key: "toggleDataPointSelection",
            value: function(t, e) {
                var i = this.w, a = null, s = ".apexcharts-series[data\\:realIndex='".concat(t, "']");
                return i.globals.axisCharts ? a = i.globals.dom.Paper.select("".concat(s, " path[j='").concat(e, "'], ").concat(s, " circle[j='").concat(e, "'], ").concat(s, " rect[j='").concat(e, "']")).members[0] : void 0 === e && (a = i.globals.dom.Paper.select("".concat(s, " path[j='").concat(t, "']")).members[0], "pie" !== i.config.chart.type && "polarArea" !== i.config.chart.type && "donut" !== i.config.chart.type || this.ctx.pie.pieClicked(t)), a ? (new $fffa43d1c55f0813$var$m(this.ctx).pathMouseDown(a, null), a.node ? a.node : null) : (console.warn("toggleDataPointSelection: Element not found"), null);
            }
        },
        {
            key: "forceXAxisUpdate",
            value: function(t) {
                var e = this.w;
                if ([
                    "min",
                    "max"
                ].forEach(function(i) {
                    void 0 !== t.xaxis[i] && (e.config.xaxis[i] = t.xaxis[i], e.globals.lastXAxis[i] = t.xaxis[i]);
                }), t.xaxis.categories && t.xaxis.categories.length && (e.config.xaxis.categories = t.xaxis.categories), e.config.xaxis.convertedCatToNumeric) {
                    var i = new $fffa43d1c55f0813$var$X(t);
                    t = i.convertCatToNumericXaxis(t, this.ctx);
                }
                return t;
            }
        },
        {
            key: "forceYAxisUpdate",
            value: function(t) {
                return t.chart && t.chart.stacked && "100%" === t.chart.stackType && (Array.isArray(t.yaxis) ? t.yaxis.forEach(function(e, i) {
                    t.yaxis[i].min = 0, t.yaxis[i].max = 100;
                }) : (t.yaxis.min = 0, t.yaxis.max = 100)), t;
            }
        },
        {
            key: "revertDefaultAxisMinMax",
            value: function(t) {
                var e = this, i = this.w, a = i.globals.lastXAxis, s = i.globals.lastYAxis;
                t && t.xaxis && (a = t.xaxis), t && t.yaxis && (s = t.yaxis), i.config.xaxis.min = a.min, i.config.xaxis.max = a.max;
                var r = function(t) {
                    void 0 !== s[t] && (i.config.yaxis[t].min = s[t].min, i.config.yaxis[t].max = s[t].max);
                };
                i.config.yaxis.map(function(t, a) {
                    i.globals.zoomed || void 0 !== s[a] ? r(a) : void 0 !== e.ctx.opts.yaxis[a] && (t.min = e.ctx.opts.yaxis[a].min, t.max = e.ctx.opts.yaxis[a].max);
                });
            }
        }
    ]), t;
}();
$fffa43d1c55f0813$var$Rt = "undefined" != typeof window ? window : void 0, $fffa43d1c55f0813$var$Ht = function(t, e) {
    var a = (void 0 !== this ? this : t).SVG = function(t) {
        if (a.supported) return t = new a.Doc(t), a.parser.draw || a.prepare(), t;
    };
    if (a.ns = "http://www.w3.org/2000/svg", a.xmlns = "http://www.w3.org/2000/xmlns/", a.xlink = "http://www.w3.org/1999/xlink", a.svgjs = "http://svgjs.dev", a.supported = !0, !a.supported) return !1;
    a.did = 1e3, a.eid = function(t) {
        return "Svgjs" + d(t) + a.did++;
    }, a.create = function(t) {
        var i = e.createElementNS(this.ns, t);
        return i.setAttribute("id", this.eid(t)), i;
    }, a.extend = function() {
        var t, e;
        e = (t = [].slice.call(arguments)).pop();
        for(var i = t.length - 1; i >= 0; i--)if (t[i]) for(var s in e)t[i].prototype[s] = e[s];
        a.Set && a.Set.inherit && a.Set.inherit();
    }, a.invent = function(t) {
        var e = "function" == typeof t.create ? t.create : function() {
            this.constructor.call(this, a.create(t.create));
        };
        return t.inherit && (e.prototype = new t.inherit), t.extend && a.extend(e, t.extend), t.construct && a.extend(t.parent || a.Container, t.construct), e;
    }, a.adopt = function(e) {
        var i;
        return e ? e.instance ? e.instance : ((i = "svg" == e.nodeName ? e.parentNode instanceof t.SVGElement ? new a.Nested : new a.Doc : "linearGradient" == e.nodeName ? new a.Gradient("linear") : "radialGradient" == e.nodeName ? new a.Gradient("radial") : a[d(e.nodeName)] ? new a[d(e.nodeName)] : new a.Element(e)).type = e.nodeName, i.node = e, e.instance = i, i instanceof a.Doc && i.namespace().defs(), i.setData(JSON.parse(e.getAttribute("svgjs:data")) || {}), i) : null;
    }, a.prepare = function() {
        var t = e.getElementsByTagName("body")[0], i = (t ? new a.Doc(t) : a.adopt(e.documentElement).nested()).size(2, 0);
        a.parser = {
            body: t || e.documentElement,
            draw: i.style("opacity:0;position:absolute;left:-100%;top:-100%;overflow:hidden").node,
            poly: i.polyline().node,
            path: i.path().node,
            native: a.create("svg")
        };
    }, a.parser = {
        native: a.create("svg")
    }, e.addEventListener("DOMContentLoaded", function() {
        a.parser.draw || a.prepare();
    }, !1), a.regex = {
        numberAndUnit: /^([+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?)([a-z%]*)$/i,
        hex: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
        rgb: /rgb\((\d+),(\d+),(\d+)\)/,
        reference: /#([a-z0-9\-_]+)/i,
        transforms: /\)\s*,?\s*/,
        whitespace: /\s/g,
        isHex: /^#[a-f0-9]{3,6}$/i,
        isRgb: /^rgb\(/,
        isCss: /[^:]+:[^;]+;?/,
        isBlank: /^(\s+)?$/,
        isNumber: /^[+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
        isPercent: /^-?[\d\.]+%$/,
        isImage: /\.(jpg|jpeg|png|gif|svg)(\?[^=]+.*)?/i,
        delimiter: /[\s,]+/,
        hyphen: /([^e])\-/gi,
        pathLetters: /[MLHVCSQTAZ]/gi,
        isPathLetter: /[MLHVCSQTAZ]/i,
        numbersWithDots: /((\d?\.\d+(?:e[+-]?\d+)?)((?:\.\d+(?:e[+-]?\d+)?)+))+/gi,
        dots: /\./g
    }, a.utils = {
        map: function(t, e) {
            for(var i = t.length, a = [], s = 0; s < i; s++)a.push(e(t[s]));
            return a;
        },
        filter: function(t, e) {
            for(var i = t.length, a = [], s = 0; s < i; s++)e(t[s]) && a.push(t[s]);
            return a;
        },
        filterSVGElements: function(e) {
            return this.filter(e, function(e) {
                return e instanceof t.SVGElement;
            });
        }
    }, a.defaults = {
        attrs: {
            "fill-opacity": 1,
            "stroke-opacity": 1,
            "stroke-width": 0,
            "stroke-linejoin": "miter",
            "stroke-linecap": "butt",
            fill: "#000000",
            stroke: "#000000",
            opacity: 1,
            x: 0,
            y: 0,
            cx: 0,
            cy: 0,
            width: 0,
            height: 0,
            r: 0,
            rx: 0,
            ry: 0,
            offset: 0,
            "stop-opacity": 1,
            "stop-color": "#000000",
            "font-size": 16,
            "font-family": "Helvetica, Arial, sans-serif",
            "text-anchor": "start"
        }
    }, a.Color = function(t) {
        var e, s;
        this.r = 0, this.g = 0, this.b = 0, t && ("string" == typeof t ? a.regex.isRgb.test(t) ? (e = a.regex.rgb.exec(t.replace(a.regex.whitespace, "")), this.r = parseInt(e[1]), this.g = parseInt(e[2]), this.b = parseInt(e[3])) : a.regex.isHex.test(t) && (e = a.regex.hex.exec(4 == (s = t).length ? [
            "#",
            s.substring(1, 2),
            s.substring(1, 2),
            s.substring(2, 3),
            s.substring(2, 3),
            s.substring(3, 4),
            s.substring(3, 4)
        ].join("") : s), this.r = parseInt(e[1], 16), this.g = parseInt(e[2], 16), this.b = parseInt(e[3], 16)) : "object" === $fffa43d1c55f0813$var$i(t) && (this.r = t.r, this.g = t.g, this.b = t.b));
    }, a.extend(a.Color, {
        toString: function() {
            return this.toHex();
        },
        toHex: function() {
            return "#" + g(this.r) + g(this.g) + g(this.b);
        },
        toRgb: function() {
            return "rgb(" + [
                this.r,
                this.g,
                this.b
            ].join() + ")";
        },
        brightness: function() {
            return this.r / 255 * .3 + this.g / 255 * .59 + this.b / 255 * .11;
        },
        morph: function(t) {
            return this.destination = new a.Color(t), this;
        },
        at: function(t) {
            return this.destination ? (t = t < 0 ? 0 : t > 1 ? 1 : t, new a.Color({
                r: ~~(this.r + (this.destination.r - this.r) * t),
                g: ~~(this.g + (this.destination.g - this.g) * t),
                b: ~~(this.b + (this.destination.b - this.b) * t)
            })) : this;
        }
    }), a.Color.test = function(t) {
        return t += "", a.regex.isHex.test(t) || a.regex.isRgb.test(t);
    }, a.Color.isRgb = function(t) {
        return t && "number" == typeof t.r && "number" == typeof t.g && "number" == typeof t.b;
    }, a.Color.isColor = function(t) {
        return a.Color.isRgb(t) || a.Color.test(t);
    }, a.Array = function(t, e) {
        0 == (t = (t || []).valueOf()).length && e && (t = e.valueOf()), this.value = this.parse(t);
    }, a.extend(a.Array, {
        toString: function() {
            return this.value.join(" ");
        },
        valueOf: function() {
            return this.value;
        },
        parse: function(t) {
            return t = t.valueOf(), Array.isArray(t) ? t : this.split(t);
        }
    }), a.PointArray = function(t, e) {
        a.Array.call(this, t, e || [
            [
                0,
                0
            ]
        ]);
    }, a.PointArray.prototype = new a.Array, a.PointArray.prototype.constructor = a.PointArray;
    for(var s = {
        M: function(t, e, i) {
            return e.x = i.x = t[0], e.y = i.y = t[1], [
                "M",
                e.x,
                e.y
            ];
        },
        L: function(t, e) {
            return e.x = t[0], e.y = t[1], [
                "L",
                t[0],
                t[1]
            ];
        },
        H: function(t, e) {
            return e.x = t[0], [
                "H",
                t[0]
            ];
        },
        V: function(t, e) {
            return e.y = t[0], [
                "V",
                t[0]
            ];
        },
        C: function(t, e) {
            return e.x = t[4], e.y = t[5], [
                "C",
                t[0],
                t[1],
                t[2],
                t[3],
                t[4],
                t[5]
            ];
        },
        Q: function(t, e) {
            return e.x = t[2], e.y = t[3], [
                "Q",
                t[0],
                t[1],
                t[2],
                t[3]
            ];
        },
        S: function(t, e) {
            return e.x = t[2], e.y = t[3], [
                "S",
                t[0],
                t[1],
                t[2],
                t[3]
            ];
        },
        Z: function(t, e, i) {
            return e.x = i.x, e.y = i.y, [
                "Z"
            ];
        }
    }, r = "mlhvqtcsaz".split(""), o = 0, n = r.length; o < n; ++o)s[r[o]] = function(t) {
        return function(e, i, a) {
            if ("H" == t) e[0] = e[0] + i.x;
            else if ("V" == t) e[0] = e[0] + i.y;
            else if ("A" == t) e[5] = e[5] + i.x, e[6] = e[6] + i.y;
            else for(var r = 0, o = e.length; r < o; ++r)e[r] = e[r] + (r % 2 ? i.y : i.x);
            if (s && "function" == typeof s[t]) return s[t](e, i, a);
        };
    }(r[o].toUpperCase());
    a.PathArray = function(t, e) {
        a.Array.call(this, t, e || [
            [
                "M",
                0,
                0
            ]
        ]);
    }, a.PathArray.prototype = new a.Array, a.PathArray.prototype.constructor = a.PathArray, a.extend(a.PathArray, {
        toString: function() {
            return function(t) {
                for(var e = 0, i = t.length, a = ""; e < i; e++)a += t[e][0], null != t[e][1] && (a += t[e][1], null != t[e][2] && (a += " ", a += t[e][2], null != t[e][3] && (a += " ", a += t[e][3], a += " ", a += t[e][4], null != t[e][5] && (a += " ", a += t[e][5], a += " ", a += t[e][6], null != t[e][7] && (a += " ", a += t[e][7])))));
                return a + " ";
            }(this.value);
        },
        move: function(t, e) {
            var i = this.bbox();
            return i.x, i.y, this;
        },
        at: function(t) {
            if (!this.destination) return this;
            for(var e = this.value, i = this.destination.value, s = [], r = new a.PathArray, o = 0, n = e.length; o < n; o++){
                s[o] = [
                    e[o][0]
                ];
                for(var l = 1, h = e[o].length; l < h; l++)s[o][l] = e[o][l] + (i[o][l] - e[o][l]) * t;
                "A" === s[o][0] && (s[o][4] = +(0 != s[o][4]), s[o][5] = +(0 != s[o][5]));
            }
            return r.value = s, r;
        },
        parse: function(t) {
            if (t instanceof a.PathArray) return t.valueOf();
            var e, i = {
                M: 2,
                L: 2,
                H: 1,
                V: 1,
                C: 6,
                S: 4,
                Q: 4,
                T: 2,
                A: 7,
                Z: 0
            };
            t = "string" == typeof t ? t.replace(a.regex.numbersWithDots, h).replace(a.regex.pathLetters, " $& ").replace(a.regex.hyphen, "$1 -").trim().split(a.regex.delimiter) : t.reduce(function(t, e) {
                return [].concat.call(t, e);
            }, []);
            var r = [], o = new a.Point, n = new a.Point, l = 0, c = t.length;
            do a.regex.isPathLetter.test(t[l]) ? (e = t[l], ++l) : "M" == e ? e = "L" : "m" == e && (e = "l"), r.push(s[e].call(null, t.slice(l, l += i[e.toUpperCase()]).map(parseFloat), o, n));
            while (c > l);
            return r;
        },
        bbox: function() {
            return a.parser.draw || a.prepare(), a.parser.path.setAttribute("d", this.toString()), a.parser.path.getBBox();
        }
    }), a.Number = a.invent({
        create: function(t, e) {
            this.value = 0, this.unit = e || "", "number" == typeof t ? this.value = isNaN(t) ? 0 : isFinite(t) ? t : t < 0 ? -340000000000000000000000000000000000000 : 34e37 : "string" == typeof t ? (e = t.match(a.regex.numberAndUnit)) && (this.value = parseFloat(e[1]), "%" == e[5] ? this.value /= 100 : "s" == e[5] && (this.value *= 1e3), this.unit = e[5]) : t instanceof a.Number && (this.value = t.valueOf(), this.unit = t.unit);
        },
        extend: {
            toString: function() {
                return ("%" == this.unit ? ~~(1e8 * this.value) / 1e6 : "s" == this.unit ? this.value / 1e3 : this.value) + this.unit;
            },
            toJSON: function() {
                return this.toString();
            },
            valueOf: function() {
                return this.value;
            },
            plus: function(t) {
                return t = new a.Number(t), new a.Number(this + t, this.unit || t.unit);
            },
            minus: function(t) {
                return t = new a.Number(t), new a.Number(this - t, this.unit || t.unit);
            },
            times: function(t) {
                return t = new a.Number(t), new a.Number(this * t, this.unit || t.unit);
            },
            divide: function(t) {
                return t = new a.Number(t), new a.Number(this / t, this.unit || t.unit);
            },
            to: function(t) {
                var e = new a.Number(this);
                return "string" == typeof t && (e.unit = t), e;
            },
            morph: function(t) {
                return this.destination = new a.Number(t), t.relative && (this.destination.value += this.value), this;
            },
            at: function(t) {
                return this.destination ? new a.Number(this.destination).minus(this).times(t).plus(this) : this;
            }
        }
    }), a.Element = a.invent({
        create: function(t) {
            this._stroke = a.defaults.attrs.stroke, this._event = null, this.dom = {}, (this.node = t) && (this.type = t.nodeName, this.node.instance = this, this._stroke = t.getAttribute("stroke") || this._stroke);
        },
        extend: {
            x: function(t) {
                return this.attr("x", t);
            },
            y: function(t) {
                return this.attr("y", t);
            },
            cx: function(t) {
                return null == t ? this.x() + this.width() / 2 : this.x(t - this.width() / 2);
            },
            cy: function(t) {
                return null == t ? this.y() + this.height() / 2 : this.y(t - this.height() / 2);
            },
            move: function(t, e) {
                return this.x(t).y(e);
            },
            center: function(t, e) {
                return this.cx(t).cy(e);
            },
            width: function(t) {
                return this.attr("width", t);
            },
            height: function(t) {
                return this.attr("height", t);
            },
            size: function(t, e) {
                var i = u(this, t, e);
                return this.width(new a.Number(i.width)).height(new a.Number(i.height));
            },
            clone: function(t) {
                this.writeDataToDom();
                var e = x(this.node.cloneNode(!0));
                return t ? t.add(e) : this.after(e), e;
            },
            remove: function() {
                return this.parent() && this.parent().removeElement(this), this;
            },
            replace: function(t) {
                return this.after(t).remove(), t;
            },
            addTo: function(t) {
                return t.put(this);
            },
            putIn: function(t) {
                return t.add(this);
            },
            id: function(t) {
                return this.attr("id", t);
            },
            show: function() {
                return this.style("display", "");
            },
            hide: function() {
                return this.style("display", "none");
            },
            visible: function() {
                return "none" != this.style("display");
            },
            toString: function() {
                return this.attr("id");
            },
            classes: function() {
                var t = this.attr("class");
                return null == t ? [] : t.trim().split(a.regex.delimiter);
            },
            hasClass: function(t) {
                return -1 != this.classes().indexOf(t);
            },
            addClass: function(t) {
                if (!this.hasClass(t)) {
                    var e = this.classes();
                    e.push(t), this.attr("class", e.join(" "));
                }
                return this;
            },
            removeClass: function(t) {
                return this.hasClass(t) && this.attr("class", this.classes().filter(function(e) {
                    return e != t;
                }).join(" ")), this;
            },
            toggleClass: function(t) {
                return this.hasClass(t) ? this.removeClass(t) : this.addClass(t);
            },
            reference: function(t) {
                return a.get(this.attr(t));
            },
            parent: function(e) {
                var i = this;
                if (!i.node.parentNode) return null;
                if (i = a.adopt(i.node.parentNode), !e) return i;
                for(; i && i.node instanceof t.SVGElement;){
                    if ("string" == typeof e ? i.matches(e) : i instanceof e) return i;
                    if (!i.node.parentNode || "#document" == i.node.parentNode.nodeName) return null;
                    i = a.adopt(i.node.parentNode);
                }
            },
            doc: function() {
                return this instanceof a.Doc ? this : this.parent(a.Doc);
            },
            parents: function(t) {
                var e = [], i = this;
                do {
                    if (!(i = i.parent(t)) || !i.node) break;
                    e.push(i);
                }while (i.parent);
                return e;
            },
            matches: function(t) {
                return function(t, e) {
                    return (t.matches || t.matchesSelector || t.msMatchesSelector || t.mozMatchesSelector || t.webkitMatchesSelector || t.oMatchesSelector).call(t, e);
                }(this.node, t);
            },
            native: function() {
                return this.node;
            },
            svg: function(t) {
                var i = e.createElement("svg");
                if (!(t && this instanceof a.Parent)) return i.appendChild(t = e.createElement("svg")), this.writeDataToDom(), t.appendChild(this.node.cloneNode(!0)), i.innerHTML.replace(/^<svg>/, "").replace(/<\/svg>$/, "");
                i.innerHTML = "<svg>" + t.replace(/\n/, "").replace(/<([\w:-]+)([^<]+?)\/>/g, "<$1$2></$1>") + "</svg>";
                for(var s = 0, r = i.firstChild.childNodes.length; s < r; s++)this.node.appendChild(i.firstChild.firstChild);
                return this;
            },
            writeDataToDom: function() {
                return (this.each || this.lines) && (this.each ? this : this.lines()).each(function() {
                    this.writeDataToDom();
                }), this.node.removeAttribute("svgjs:data"), Object.keys(this.dom).length && this.node.setAttribute("svgjs:data", JSON.stringify(this.dom)), this;
            },
            setData: function(t) {
                return this.dom = t, this;
            },
            is: function(t) {
                return function(t, e) {
                    return t instanceof e;
                }(this, t);
            }
        }
    }), a.easing = {
        "-": function(t) {
            return t;
        },
        "<>": function(t) {
            return -Math.cos(t * Math.PI) / 2 + .5;
        },
        ">": function(t) {
            return Math.sin(t * Math.PI / 2);
        },
        "<": function(t) {
            return 1 - Math.cos(t * Math.PI / 2);
        }
    }, a.morph = function(t) {
        return function(e, i) {
            return new a.MorphObj(e, i).at(t);
        };
    }, a.Situation = a.invent({
        create: function(t) {
            this.init = !1, this.reversed = !1, this.reversing = !1, this.duration = new a.Number(t.duration).valueOf(), this.delay = new a.Number(t.delay).valueOf(), this.start = +new Date + this.delay, this.finish = this.start + this.duration, this.ease = t.ease, this.loop = 0, this.loops = !1, this.animations = {}, this.attrs = {}, this.styles = {}, this.transforms = [], this.once = {};
        }
    }), a.FX = a.invent({
        create: function(t) {
            this._target = t, this.situations = [], this.active = !1, this.situation = null, this.paused = !1, this.lastPos = 0, this.pos = 0, this.absPos = 0, this._speed = 1;
        },
        extend: {
            animate: function(t, e, s) {
                "object" === $fffa43d1c55f0813$var$i(t) && (e = t.ease, s = t.delay, t = t.duration);
                var r = new a.Situation({
                    duration: t || 1e3,
                    delay: s || 0,
                    ease: a.easing[e || "-"] || e
                });
                return this.queue(r), this;
            },
            target: function(t) {
                return t && t instanceof a.Element ? (this._target = t, this) : this._target;
            },
            timeToAbsPos: function(t) {
                return (t - this.situation.start) / (this.situation.duration / this._speed);
            },
            absPosToTime: function(t) {
                return this.situation.duration / this._speed * t + this.situation.start;
            },
            startAnimFrame: function() {
                this.stopAnimFrame(), this.animationFrame = t.requestAnimationFrame((function() {
                    this.step();
                }).bind(this));
            },
            stopAnimFrame: function() {
                t.cancelAnimationFrame(this.animationFrame);
            },
            start: function() {
                return !this.active && this.situation && (this.active = !0, this.startCurrent()), this;
            },
            startCurrent: function() {
                return this.situation.start = +new Date + this.situation.delay / this._speed, this.situation.finish = this.situation.start + this.situation.duration / this._speed, this.initAnimations().step();
            },
            queue: function(t) {
                return ("function" == typeof t || t instanceof a.Situation) && this.situations.push(t), this.situation || (this.situation = this.situations.shift()), this;
            },
            dequeue: function() {
                return this.stop(), this.situation = this.situations.shift(), this.situation && (this.situation instanceof a.Situation ? this.start() : this.situation.call(this)), this;
            },
            initAnimations: function() {
                var t, e = this.situation;
                if (e.init) return this;
                for(var i in e.animations){
                    t = this.target()[i](), Array.isArray(t) || (t = [
                        t
                    ]), Array.isArray(e.animations[i]) || (e.animations[i] = [
                        e.animations[i]
                    ]);
                    for(var s = t.length; s--;)e.animations[i][s] instanceof a.Number && (t[s] = new a.Number(t[s])), e.animations[i][s] = t[s].morph(e.animations[i][s]);
                }
                for(var i in e.attrs)e.attrs[i] = new a.MorphObj(this.target().attr(i), e.attrs[i]);
                for(var i in e.styles)e.styles[i] = new a.MorphObj(this.target().style(i), e.styles[i]);
                return e.initialTransformation = this.target().matrixify(), e.init = !0, this;
            },
            clearQueue: function() {
                return this.situations = [], this;
            },
            clearCurrent: function() {
                return this.situation = null, this;
            },
            stop: function(t, e) {
                var i = this.active;
                return this.active = !1, e && this.clearQueue(), t && this.situation && (!i && this.startCurrent(), this.atEnd()), this.stopAnimFrame(), this.clearCurrent();
            },
            after: function(t) {
                var e = this.last();
                return this.target().on("finished.fx", function i(a) {
                    a.detail.situation == e && (t.call(this, e), this.off("finished.fx", i));
                }), this._callStart();
            },
            during: function(t) {
                var e = this.last(), i = function(i) {
                    i.detail.situation == e && t.call(this, i.detail.pos, a.morph(i.detail.pos), i.detail.eased, e);
                };
                return this.target().off("during.fx", i).on("during.fx", i), this.after(function() {
                    this.off("during.fx", i);
                }), this._callStart();
            },
            afterAll: function(t) {
                var e = function e(i) {
                    t.call(this), this.off("allfinished.fx", e);
                };
                return this.target().off("allfinished.fx", e).on("allfinished.fx", e), this._callStart();
            },
            last: function() {
                return this.situations.length ? this.situations[this.situations.length - 1] : this.situation;
            },
            add: function(t, e, i) {
                return this.last()[i || "animations"][t] = e, this._callStart();
            },
            step: function(t) {
                var e, i, a;
                t || (this.absPos = this.timeToAbsPos(+new Date)), !1 !== this.situation.loops ? (e = Math.max(this.absPos, 0), i = Math.floor(e), !0 === this.situation.loops || i < this.situation.loops ? (this.pos = e - i, a = this.situation.loop, this.situation.loop = i) : (this.absPos = this.situation.loops, this.pos = 1, a = this.situation.loop - 1, this.situation.loop = this.situation.loops), this.situation.reversing && (this.situation.reversed = this.situation.reversed != Boolean((this.situation.loop - a) % 2))) : (this.absPos = Math.min(this.absPos, 1), this.pos = this.absPos), this.pos < 0 && (this.pos = 0), this.situation.reversed && (this.pos = 1 - this.pos);
                var s = this.situation.ease(this.pos);
                for(var r in this.situation.once)r > this.lastPos && r <= s && (this.situation.once[r].call(this.target(), this.pos, s), delete this.situation.once[r]);
                return this.active && this.target().fire("during", {
                    pos: this.pos,
                    eased: s,
                    fx: this,
                    situation: this.situation
                }), this.situation ? (this.eachAt(), 1 == this.pos && !this.situation.reversed || this.situation.reversed && 0 == this.pos ? (this.stopAnimFrame(), this.target().fire("finished", {
                    fx: this,
                    situation: this.situation
                }), this.situations.length || (this.target().fire("allfinished"), this.situations.length || (this.target().off(".fx"), this.active = !1)), this.active ? this.dequeue() : this.clearCurrent()) : !this.paused && this.active && this.startAnimFrame(), this.lastPos = s, this) : this;
            },
            eachAt: function() {
                var t, e = this, i = this.target(), s = this.situation;
                for(var r in s.animations)t = [].concat(s.animations[r]).map(function(t) {
                    return "string" != typeof t && t.at ? t.at(s.ease(e.pos), e.pos) : t;
                }), i[r].apply(i, t);
                for(var r in s.attrs)t = [
                    r
                ].concat(s.attrs[r]).map(function(t) {
                    return "string" != typeof t && t.at ? t.at(s.ease(e.pos), e.pos) : t;
                }), i.attr.apply(i, t);
                for(var r in s.styles)t = [
                    r
                ].concat(s.styles[r]).map(function(t) {
                    return "string" != typeof t && t.at ? t.at(s.ease(e.pos), e.pos) : t;
                }), i.style.apply(i, t);
                if (s.transforms.length) {
                    t = s.initialTransformation, r = 0;
                    for(var o = s.transforms.length; r < o; r++){
                        var n = s.transforms[r];
                        n instanceof a.Matrix ? t = n.relative ? t.multiply((new a.Matrix).morph(n).at(s.ease(this.pos))) : t.morph(n).at(s.ease(this.pos)) : (n.relative || n.undo(t.extract()), t = t.multiply(n.at(s.ease(this.pos))));
                    }
                    i.matrix(t);
                }
                return this;
            },
            once: function(t, e, i) {
                var a = this.last();
                return i || (t = a.ease(t)), a.once[t] = e, this;
            },
            _callStart: function() {
                return setTimeout((function() {
                    this.start();
                }).bind(this), 0), this;
            }
        },
        parent: a.Element,
        construct: {
            animate: function(t, e, i) {
                return (this.fx || (this.fx = new a.FX(this))).animate(t, e, i);
            },
            delay: function(t) {
                return (this.fx || (this.fx = new a.FX(this))).delay(t);
            },
            stop: function(t, e) {
                return this.fx && this.fx.stop(t, e), this;
            },
            finish: function() {
                return this.fx && this.fx.finish(), this;
            }
        }
    }), a.MorphObj = a.invent({
        create: function(t, e) {
            return a.Color.isColor(e) ? new a.Color(t).morph(e) : a.regex.delimiter.test(t) ? a.regex.pathLetters.test(t) ? new a.PathArray(t).morph(e) : new a.Array(t).morph(e) : a.regex.numberAndUnit.test(e) ? new a.Number(t).morph(e) : (this.value = t, void (this.destination = e));
        },
        extend: {
            at: function(t, e) {
                return e < 1 ? this.value : this.destination;
            },
            valueOf: function() {
                return this.value;
            }
        }
    }), a.extend(a.FX, {
        attr: function(t, e, a) {
            if ("object" === $fffa43d1c55f0813$var$i(t)) for(var s in t)this.attr(s, t[s]);
            else this.add(t, e, "attrs");
            return this;
        },
        plot: function(t, e, i, a) {
            return 4 == arguments.length ? this.plot([
                t,
                e,
                i,
                a
            ]) : this.add("plot", new (this.target()).morphArray(t));
        }
    }), a.Box = a.invent({
        create: function(t, e, s, r) {
            if (!("object" !== $fffa43d1c55f0813$var$i(t) || t instanceof a.Element)) return a.Box.call(this, null != t.left ? t.left : t.x, null != t.top ? t.top : t.y, t.width, t.height);
            var o;
            4 == arguments.length && (this.x = t, this.y = e, this.width = s, this.height = r), null == (o = this).x && (o.x = 0, o.y = 0, o.width = 0, o.height = 0), o.w = o.width, o.h = o.height, o.x2 = o.x + o.width, o.y2 = o.y + o.height, o.cx = o.x + o.width / 2, o.cy = o.y + o.height / 2;
        }
    }), a.BBox = a.invent({
        create: function(t) {
            if (a.Box.apply(this, [].slice.call(arguments)), t instanceof a.Element) {
                var i;
                try {
                    if (!e.documentElement.contains) {
                        for(var s = t.node; s.parentNode;)s = s.parentNode;
                        if (s != e) throw new Error("Element not in the dom");
                    }
                    i = t.node.getBBox();
                } catch (e) {
                    if (t instanceof a.Shape) {
                        a.parser.draw || a.prepare();
                        var r = t.clone(a.parser.draw.instance).show();
                        r && r.node && "function" == typeof r.node.getBBox && (i = r.node.getBBox()), r && "function" == typeof r.remove && r.remove();
                    } else i = {
                        x: t.node.clientLeft,
                        y: t.node.clientTop,
                        width: t.node.clientWidth,
                        height: t.node.clientHeight
                    };
                }
                a.Box.call(this, i);
            }
        },
        inherit: a.Box,
        parent: a.Element,
        construct: {
            bbox: function() {
                return new a.BBox(this);
            }
        }
    }), a.BBox.prototype.constructor = a.BBox, a.Matrix = a.invent({
        create: function(t) {
            var e = f([
                1,
                0,
                0,
                1,
                0,
                0
            ]);
            t = null === t ? e : t instanceof a.Element ? t.matrixify() : "string" == typeof t ? f(t.split(a.regex.delimiter).map(parseFloat)) : 6 == arguments.length ? f([].slice.call(arguments)) : Array.isArray(t) ? f(t) : t && "object" === $fffa43d1c55f0813$var$i(t) ? t : e;
            for(var s = v.length - 1; s >= 0; --s)this[v[s]] = null != t[v[s]] ? t[v[s]] : e[v[s]];
        },
        extend: {
            extract: function() {
                var t = p(this, 0, 1);
                p(this, 1, 0);
                var e = 180 / Math.PI * Math.atan2(t.y, t.x) - 90;
                return {
                    x: this.e,
                    y: this.f,
                    transformedX: (this.e * Math.cos(e * Math.PI / 180) + this.f * Math.sin(e * Math.PI / 180)) / Math.sqrt(this.a * this.a + this.b * this.b),
                    transformedY: (this.f * Math.cos(e * Math.PI / 180) + this.e * Math.sin(-e * Math.PI / 180)) / Math.sqrt(this.c * this.c + this.d * this.d),
                    rotation: e,
                    a: this.a,
                    b: this.b,
                    c: this.c,
                    d: this.d,
                    e: this.e,
                    f: this.f,
                    matrix: new a.Matrix(this)
                };
            },
            clone: function() {
                return new a.Matrix(this);
            },
            morph: function(t) {
                return this.destination = new a.Matrix(t), this;
            },
            multiply: function(t) {
                return new a.Matrix(this.native().multiply((function(t) {
                    return t instanceof a.Matrix || (t = new a.Matrix(t)), t;
                })(t).native()));
            },
            inverse: function() {
                return new a.Matrix(this.native().inverse());
            },
            translate: function(t, e) {
                return new a.Matrix(this.native().translate(t || 0, e || 0));
            },
            native: function() {
                for(var t = a.parser.native.createSVGMatrix(), e = v.length - 1; e >= 0; e--)t[v[e]] = this[v[e]];
                return t;
            },
            toString: function() {
                return "matrix(" + b(this.a) + "," + b(this.b) + "," + b(this.c) + "," + b(this.d) + "," + b(this.e) + "," + b(this.f) + ")";
            }
        },
        parent: a.Element,
        construct: {
            ctm: function() {
                return new a.Matrix(this.node.getCTM());
            },
            screenCTM: function() {
                if (this instanceof a.Nested) {
                    var t = this.rect(1, 1), e = t.node.getScreenCTM();
                    return t.remove(), new a.Matrix(e);
                }
                return new a.Matrix(this.node.getScreenCTM());
            }
        }
    }), a.Point = a.invent({
        create: function(t, e) {
            var a;
            a = Array.isArray(t) ? {
                x: t[0],
                y: t[1]
            } : "object" === $fffa43d1c55f0813$var$i(t) ? {
                x: t.x,
                y: t.y
            } : null != t ? {
                x: t,
                y: null != e ? e : t
            } : {
                x: 0,
                y: 0
            }, this.x = a.x, this.y = a.y;
        },
        extend: {
            clone: function() {
                return new a.Point(this);
            },
            morph: function(t, e) {
                return this.destination = new a.Point(t, e), this;
            }
        }
    }), a.extend(a.Element, {
        point: function(t, e) {
            return new a.Point(t, e).transform(this.screenCTM().inverse());
        }
    }), a.extend(a.Element, {
        attr: function(t, e, s) {
            if (null == t) {
                for(t = {}, s = (e = this.node.attributes).length - 1; s >= 0; s--)t[e[s].nodeName] = a.regex.isNumber.test(e[s].nodeValue) ? parseFloat(e[s].nodeValue) : e[s].nodeValue;
                return t;
            }
            if ("object" === $fffa43d1c55f0813$var$i(t)) for(var r in t)this.attr(r, t[r]);
            else if (null === e) this.node.removeAttribute(t);
            else {
                if (null == e) return null == (e = this.node.getAttribute(t)) ? a.defaults.attrs[t] : a.regex.isNumber.test(e) ? parseFloat(e) : e;
                "stroke-width" == t ? this.attr("stroke", parseFloat(e) > 0 ? this._stroke : null) : "stroke" == t && (this._stroke = e), "fill" != t && "stroke" != t || (a.regex.isImage.test(e) && (e = this.doc().defs().image(e, 0, 0)), e instanceof a.Image && (e = this.doc().defs().pattern(0, 0, function() {
                    this.add(e);
                }))), "number" == typeof e ? e = new a.Number(e) : a.Color.isColor(e) ? e = new a.Color(e) : Array.isArray(e) && (e = new a.Array(e)), "leading" == t ? this.leading && this.leading(e) : "string" == typeof s ? this.node.setAttributeNS(s, t, e.toString()) : this.node.setAttribute(t, e.toString()), !this.rebuild || "font-size" != t && "x" != t || this.rebuild(t, e);
            }
            return this;
        }
    }), a.extend(a.Element, {
        transform: function(t, e) {
            var s;
            return "object" !== $fffa43d1c55f0813$var$i(t) ? (s = new a.Matrix(this).extract(), "string" == typeof t ? s[t] : s) : (s = new a.Matrix(this), e = !!e || !!t.relative, null != t.a && (s = e ? s.multiply(new a.Matrix(t)) : new a.Matrix(t)), this.attr("transform", s));
        }
    }), a.extend(a.Element, {
        untransform: function() {
            return this.attr("transform", null);
        },
        matrixify: function() {
            return (this.attr("transform") || "").split(a.regex.transforms).slice(0, -1).map(function(t) {
                var e = t.trim().split("(");
                return [
                    e[0],
                    e[1].split(a.regex.delimiter).map(function(t) {
                        return parseFloat(t);
                    })
                ];
            }).reduce(function(t, e) {
                return "matrix" == e[0] ? t.multiply(f(e[1])) : t[e[0]].apply(t, e[1]);
            }, new a.Matrix);
        },
        toParent: function(t) {
            if (this == t) return this;
            var e = this.screenCTM(), i = t.screenCTM().inverse();
            return this.addTo(t).untransform().transform(i.multiply(e)), this;
        },
        toDoc: function() {
            return this.toParent(this.doc());
        }
    }), a.Transformation = a.invent({
        create: function(t, e) {
            if (arguments.length > 1 && "boolean" != typeof e) return this.constructor.call(this, [].slice.call(arguments));
            if (Array.isArray(t)) for(var a = 0, s = this.arguments.length; a < s; ++a)this[this.arguments[a]] = t[a];
            else if (t && "object" === $fffa43d1c55f0813$var$i(t)) for(a = 0, s = this.arguments.length; a < s; ++a)this[this.arguments[a]] = t[this.arguments[a]];
            this.inversed = !1, !0 === e && (this.inversed = !0);
        }
    }), a.Translate = a.invent({
        parent: a.Matrix,
        inherit: a.Transformation,
        create: function(t, e) {
            this.constructor.apply(this, [].slice.call(arguments));
        },
        extend: {
            arguments: [
                "transformedX",
                "transformedY"
            ],
            method: "translate"
        }
    }), a.extend(a.Element, {
        style: function(t, e) {
            if (0 == arguments.length) return this.node.style.cssText || "";
            if (arguments.length < 2) {
                if ("object" === $fffa43d1c55f0813$var$i(t)) for(var s in t)this.style(s, t[s]);
                else {
                    if (!a.regex.isCss.test(t)) return this.node.style[c(t)];
                    for(t = t.split(/\s*;\s*/).filter(function(t) {
                        return !!t;
                    }).map(function(t) {
                        return t.split(/\s*:\s*/);
                    }); e = t.pop();)this.style(e[0], e[1]);
                }
            } else this.node.style[c(t)] = null === e || a.regex.isBlank.test(e) ? "" : e;
            return this;
        }
    }), a.Parent = a.invent({
        create: function(t) {
            this.constructor.call(this, t);
        },
        inherit: a.Element,
        extend: {
            children: function() {
                return a.utils.map(a.utils.filterSVGElements(this.node.childNodes), function(t) {
                    return a.adopt(t);
                });
            },
            add: function(t, e) {
                return null == e ? this.node.appendChild(t.node) : t.node != this.node.childNodes[e] && this.node.insertBefore(t.node, this.node.childNodes[e]), this;
            },
            put: function(t, e) {
                return this.add(t, e), t;
            },
            has: function(t) {
                return this.index(t) >= 0;
            },
            index: function(t) {
                return [].slice.call(this.node.childNodes).indexOf(t.node);
            },
            get: function(t) {
                return a.adopt(this.node.childNodes[t]);
            },
            first: function() {
                return this.get(0);
            },
            last: function() {
                return this.get(this.node.childNodes.length - 1);
            },
            each: function(t, e) {
                for(var i = this.children(), s = 0, r = i.length; s < r; s++)i[s] instanceof a.Element && t.apply(i[s], [
                    s,
                    i
                ]), e && i[s] instanceof a.Container && i[s].each(t, e);
                return this;
            },
            removeElement: function(t) {
                return this.node.removeChild(t.node), this;
            },
            clear: function() {
                for(; this.node.hasChildNodes();)this.node.removeChild(this.node.lastChild);
                return delete this._defs, this;
            },
            defs: function() {
                return this.doc().defs();
            }
        }
    }), a.extend(a.Parent, {
        ungroup: function(t, e) {
            return 0 === e || this instanceof a.Defs || this.node == a.parser.draw || (t = t || (this instanceof a.Doc ? this : this.parent(a.Parent)), e = e || 1 / 0, this.each(function() {
                return this instanceof a.Defs ? this : this instanceof a.Parent ? this.ungroup(t, e - 1) : this.toParent(t);
            }), this.node.firstChild || this.remove()), this;
        },
        flatten: function(t, e) {
            return this.ungroup(t, e);
        }
    }), a.Container = a.invent({
        create: function(t) {
            this.constructor.call(this, t);
        },
        inherit: a.Parent
    }), a.ViewBox = a.invent({
        parent: a.Container,
        construct: {}
    }), [
        "click",
        "dblclick",
        "mousedown",
        "mouseup",
        "mouseover",
        "mouseout",
        "mousemove",
        "touchstart",
        "touchmove",
        "touchleave",
        "touchend",
        "touchcancel"
    ].forEach(function(t) {
        a.Element.prototype[t] = function(e) {
            return a.on(this.node, t, e), this;
        };
    }), a.listeners = [], a.handlerMap = [], a.listenerId = 0, a.on = function(t, e, i, s, r) {
        var o = i.bind(s || t.instance || t), n = (a.handlerMap.indexOf(t) + 1 || a.handlerMap.push(t)) - 1, l = e.split(".")[0], h = e.split(".")[1] || "*";
        a.listeners[n] = a.listeners[n] || {}, a.listeners[n][l] = a.listeners[n][l] || {}, a.listeners[n][l][h] = a.listeners[n][l][h] || {}, i._svgjsListenerId || (i._svgjsListenerId = ++a.listenerId), a.listeners[n][l][h][i._svgjsListenerId] = o, t.addEventListener(l, o, r || {
            passive: !0
        });
    }, a.off = function(t, e, i) {
        var s = a.handlerMap.indexOf(t), r = e && e.split(".")[0], o = e && e.split(".")[1], n = "";
        if (-1 != s) {
            if (i) {
                if ("function" == typeof i && (i = i._svgjsListenerId), !i) return;
                a.listeners[s][r] && a.listeners[s][r][o || "*"] && (t.removeEventListener(r, a.listeners[s][r][o || "*"][i], !1), delete a.listeners[s][r][o || "*"][i]);
            } else if (o && r) {
                if (a.listeners[s][r] && a.listeners[s][r][o]) {
                    for(var l in a.listeners[s][r][o])a.off(t, [
                        r,
                        o
                    ].join("."), l);
                    delete a.listeners[s][r][o];
                }
            } else if (o) for(var h in a.listeners[s])for(var n in a.listeners[s][h])o === n && a.off(t, [
                h,
                o
            ].join("."));
            else if (r) {
                if (a.listeners[s][r]) {
                    for(var n in a.listeners[s][r])a.off(t, [
                        r,
                        n
                    ].join("."));
                    delete a.listeners[s][r];
                }
            } else {
                for(var h in a.listeners[s])a.off(t, h);
                delete a.listeners[s], delete a.handlerMap[s];
            }
        }
    }, a.extend(a.Element, {
        on: function(t, e, i, s) {
            return a.on(this.node, t, e, i, s), this;
        },
        off: function(t, e) {
            return a.off(this.node, t, e), this;
        },
        fire: function(e, i) {
            return e instanceof t.Event ? this.node.dispatchEvent(e) : this.node.dispatchEvent(e = new a.CustomEvent(e, {
                detail: i,
                cancelable: !0
            })), this._event = e, this;
        },
        event: function() {
            return this._event;
        }
    }), a.Defs = a.invent({
        create: "defs",
        inherit: a.Container
    }), a.G = a.invent({
        create: "g",
        inherit: a.Container,
        extend: {
            x: function(t) {
                return null == t ? this.transform("x") : this.transform({
                    x: t - this.x()
                }, !0);
            }
        },
        construct: {
            group: function() {
                return this.put(new a.G);
            }
        }
    }), a.Doc = a.invent({
        create: function(t) {
            t && ("svg" == (t = "string" == typeof t ? e.getElementById(t) : t).nodeName ? this.constructor.call(this, t) : (this.constructor.call(this, a.create("svg")), t.appendChild(this.node), this.size("100%", "100%")), this.namespace().defs());
        },
        inherit: a.Container,
        extend: {
            namespace: function() {
                return this.attr({
                    xmlns: a.ns,
                    version: "1.1"
                }).attr("xmlns:xlink", a.xlink, a.xmlns).attr("xmlns:svgjs", a.svgjs, a.xmlns);
            },
            defs: function() {
                var t;
                return this._defs || ((t = this.node.getElementsByTagName("defs")[0]) ? this._defs = a.adopt(t) : this._defs = new a.Defs, this.node.appendChild(this._defs.node)), this._defs;
            },
            parent: function() {
                return this.node.parentNode && "#document" != this.node.parentNode.nodeName ? this.node.parentNode : null;
            },
            remove: function() {
                return this.parent() && this.parent().removeChild(this.node), this;
            },
            clear: function() {
                for(; this.node.hasChildNodes();)this.node.removeChild(this.node.lastChild);
                return delete this._defs, a.parser.draw && !a.parser.draw.parentNode && this.node.appendChild(a.parser.draw), this;
            },
            clone: function(t) {
                this.writeDataToDom();
                var e = this.node, i = x(e.cloneNode(!0));
                return t ? (t.node || t).appendChild(i.node) : e.parentNode.insertBefore(i.node, e.nextSibling), i;
            }
        }
    }), a.extend(a.Element, {}), a.Gradient = a.invent({
        create: function(t) {
            this.constructor.call(this, a.create(t + "Gradient")), this.type = t;
        },
        inherit: a.Container,
        extend: {
            at: function(t, e, i) {
                return this.put(new a.Stop).update(t, e, i);
            },
            update: function(t) {
                return this.clear(), "function" == typeof t && t.call(this, this), this;
            },
            fill: function() {
                return "url(#" + this.id() + ")";
            },
            toString: function() {
                return this.fill();
            },
            attr: function(t, e, i) {
                return "transform" == t && (t = "gradientTransform"), a.Container.prototype.attr.call(this, t, e, i);
            }
        },
        construct: {
            gradient: function(t, e) {
                return this.defs().gradient(t, e);
            }
        }
    }), a.extend(a.Gradient, a.FX, {
        from: function(t, e) {
            return "radial" == (this._target || this).type ? this.attr({
                fx: new a.Number(t),
                fy: new a.Number(e)
            }) : this.attr({
                x1: new a.Number(t),
                y1: new a.Number(e)
            });
        },
        to: function(t, e) {
            return "radial" == (this._target || this).type ? this.attr({
                cx: new a.Number(t),
                cy: new a.Number(e)
            }) : this.attr({
                x2: new a.Number(t),
                y2: new a.Number(e)
            });
        }
    }), a.extend(a.Defs, {
        gradient: function(t, e) {
            return this.put(new a.Gradient(t)).update(e);
        }
    }), a.Stop = a.invent({
        create: "stop",
        inherit: a.Element,
        extend: {
            update: function(t) {
                return ("number" == typeof t || t instanceof a.Number) && (t = {
                    offset: arguments[0],
                    color: arguments[1],
                    opacity: arguments[2]
                }), null != t.opacity && this.attr("stop-opacity", t.opacity), null != t.color && this.attr("stop-color", t.color), null != t.offset && this.attr("offset", new a.Number(t.offset)), this;
            }
        }
    }), a.Pattern = a.invent({
        create: "pattern",
        inherit: a.Container,
        extend: {
            fill: function() {
                return "url(#" + this.id() + ")";
            },
            update: function(t) {
                return this.clear(), "function" == typeof t && t.call(this, this), this;
            },
            toString: function() {
                return this.fill();
            },
            attr: function(t, e, i) {
                return "transform" == t && (t = "patternTransform"), a.Container.prototype.attr.call(this, t, e, i);
            }
        },
        construct: {
            pattern: function(t, e, i) {
                return this.defs().pattern(t, e, i);
            }
        }
    }), a.extend(a.Defs, {
        pattern: function(t, e, i) {
            return this.put(new a.Pattern).update(i).attr({
                x: 0,
                y: 0,
                width: t,
                height: e,
                patternUnits: "userSpaceOnUse"
            });
        }
    }), a.Shape = a.invent({
        create: function(t) {
            this.constructor.call(this, t);
        },
        inherit: a.Element
    }), a.Symbol = a.invent({
        create: "symbol",
        inherit: a.Container,
        construct: {
            symbol: function() {
                return this.put(new a.Symbol);
            }
        }
    }), a.Use = a.invent({
        create: "use",
        inherit: a.Shape,
        extend: {
            element: function(t, e) {
                return this.attr("href", (e || "") + "#" + t, a.xlink);
            }
        },
        construct: {
            use: function(t, e) {
                return this.put(new a.Use).element(t, e);
            }
        }
    }), a.Rect = a.invent({
        create: "rect",
        inherit: a.Shape,
        construct: {
            rect: function(t, e) {
                return this.put(new a.Rect).size(t, e);
            }
        }
    }), a.Circle = a.invent({
        create: "circle",
        inherit: a.Shape,
        construct: {
            circle: function(t) {
                return this.put(new a.Circle).rx(new a.Number(t).divide(2)).move(0, 0);
            }
        }
    }), a.extend(a.Circle, a.FX, {
        rx: function(t) {
            return this.attr("r", t);
        },
        ry: function(t) {
            return this.rx(t);
        }
    }), a.Ellipse = a.invent({
        create: "ellipse",
        inherit: a.Shape,
        construct: {
            ellipse: function(t, e) {
                return this.put(new a.Ellipse).size(t, e).move(0, 0);
            }
        }
    }), a.extend(a.Ellipse, a.Rect, a.FX, {
        rx: function(t) {
            return this.attr("rx", t);
        },
        ry: function(t) {
            return this.attr("ry", t);
        }
    }), a.extend(a.Circle, a.Ellipse, {
        x: function(t) {
            return null == t ? this.cx() - this.rx() : this.cx(t + this.rx());
        },
        y: function(t) {
            return null == t ? this.cy() - this.ry() : this.cy(t + this.ry());
        },
        cx: function(t) {
            return null == t ? this.attr("cx") : this.attr("cx", t);
        },
        cy: function(t) {
            return null == t ? this.attr("cy") : this.attr("cy", t);
        },
        width: function(t) {
            return null == t ? 2 * this.rx() : this.rx(new a.Number(t).divide(2));
        },
        height: function(t) {
            return null == t ? 2 * this.ry() : this.ry(new a.Number(t).divide(2));
        },
        size: function(t, e) {
            var i = u(this, t, e);
            return this.rx(new a.Number(i.width).divide(2)).ry(new a.Number(i.height).divide(2));
        }
    }), a.Line = a.invent({
        create: "line",
        inherit: a.Shape,
        extend: {
            array: function() {
                return new a.PointArray([
                    [
                        this.attr("x1"),
                        this.attr("y1")
                    ],
                    [
                        this.attr("x2"),
                        this.attr("y2")
                    ]
                ]);
            },
            plot: function(t, e, i, s) {
                return null == t ? this.array() : (t = void 0 !== e ? {
                    x1: t,
                    y1: e,
                    x2: i,
                    y2: s
                } : new a.PointArray(t).toLine(), this.attr(t));
            },
            move: function(t, e) {
                return this.attr(this.array().move(t, e).toLine());
            },
            size: function(t, e) {
                var i = u(this, t, e);
                return this.attr(this.array().size(i.width, i.height).toLine());
            }
        },
        construct: {
            line: function(t, e, i, s) {
                return a.Line.prototype.plot.apply(this.put(new a.Line), null != t ? [
                    t,
                    e,
                    i,
                    s
                ] : [
                    0,
                    0,
                    0,
                    0
                ]);
            }
        }
    }), a.Polyline = a.invent({
        create: "polyline",
        inherit: a.Shape,
        construct: {
            polyline: function(t) {
                return this.put(new a.Polyline).plot(t || new a.PointArray);
            }
        }
    }), a.Polygon = a.invent({
        create: "polygon",
        inherit: a.Shape,
        construct: {
            polygon: function(t) {
                return this.put(new a.Polygon).plot(t || new a.PointArray);
            }
        }
    }), a.extend(a.Polyline, a.Polygon, {
        array: function() {
            return this._array || (this._array = new a.PointArray(this.attr("points")));
        },
        plot: function(t) {
            return null == t ? this.array() : this.clear().attr("points", "string" == typeof t ? t : this._array = new a.PointArray(t));
        },
        clear: function() {
            return delete this._array, this;
        },
        move: function(t, e) {
            return this.attr("points", this.array().move(t, e));
        },
        size: function(t, e) {
            var i = u(this, t, e);
            return this.attr("points", this.array().size(i.width, i.height));
        }
    }), a.extend(a.Line, a.Polyline, a.Polygon, {
        morphArray: a.PointArray,
        x: function(t) {
            return null == t ? this.bbox().x : this.move(t, this.bbox().y);
        },
        y: function(t) {
            return null == t ? this.bbox().y : this.move(this.bbox().x, t);
        },
        width: function(t) {
            var e = this.bbox();
            return null == t ? e.width : this.size(t, e.height);
        },
        height: function(t) {
            var e = this.bbox();
            return null == t ? e.height : this.size(e.width, t);
        }
    }), a.Path = a.invent({
        create: "path",
        inherit: a.Shape,
        extend: {
            morphArray: a.PathArray,
            array: function() {
                return this._array || (this._array = new a.PathArray(this.attr("d")));
            },
            plot: function(t) {
                return null == t ? this.array() : this.clear().attr("d", "string" == typeof t ? t : this._array = new a.PathArray(t));
            },
            clear: function() {
                return delete this._array, this;
            }
        },
        construct: {
            path: function(t) {
                return this.put(new a.Path).plot(t || new a.PathArray);
            }
        }
    }), a.Image = a.invent({
        create: "image",
        inherit: a.Shape,
        extend: {
            load: function(e) {
                if (!e) return this;
                var i = this, s = new t.Image;
                return a.on(s, "load", function() {
                    a.off(s);
                    var t = i.parent(a.Pattern);
                    null !== t && (0 == i.width() && 0 == i.height() && i.size(s.width, s.height), t && 0 == t.width() && 0 == t.height() && t.size(i.width(), i.height()), "function" == typeof i._loaded && i._loaded.call(i, {
                        width: s.width,
                        height: s.height,
                        ratio: s.width / s.height,
                        url: e
                    }));
                }), a.on(s, "error", function(t) {
                    a.off(s), "function" == typeof i._error && i._error.call(i, t);
                }), this.attr("href", s.src = this.src = e, a.xlink);
            },
            loaded: function(t) {
                return this._loaded = t, this;
            },
            error: function(t) {
                return this._error = t, this;
            }
        },
        construct: {
            image: function(t, e, i) {
                return this.put(new a.Image).load(t).size(e || 0, i || e || 0);
            }
        }
    }), a.Text = a.invent({
        create: function() {
            this.constructor.call(this, a.create("text")), this.dom.leading = new a.Number(1.3), this._rebuild = !0, this._build = !1, this.attr("font-family", a.defaults.attrs["font-family"]);
        },
        inherit: a.Shape,
        extend: {
            x: function(t) {
                return null == t ? this.attr("x") : this.attr("x", t);
            },
            text: function(t) {
                if (void 0 === t) {
                    t = "";
                    for(var e = this.node.childNodes, i = 0, s = e.length; i < s; ++i)0 != i && 3 != e[i].nodeType && 1 == a.adopt(e[i]).dom.newLined && (t += "\n"), t += e[i].textContent;
                    return t;
                }
                if (this.clear().build(!0), "function" == typeof t) t.call(this, this);
                else {
                    i = 0;
                    for(var r = (t = t.split("\n")).length; i < r; i++)this.tspan(t[i]).newLine();
                }
                return this.build(!1).rebuild();
            },
            size: function(t) {
                return this.attr("font-size", t).rebuild();
            },
            leading: function(t) {
                return null == t ? this.dom.leading : (this.dom.leading = new a.Number(t), this.rebuild());
            },
            lines: function() {
                var t = (this.textPath && this.textPath() || this).node, e = a.utils.map(a.utils.filterSVGElements(t.childNodes), function(t) {
                    return a.adopt(t);
                });
                return new a.Set(e);
            },
            rebuild: function(t) {
                if ("boolean" == typeof t && (this._rebuild = t), this._rebuild) {
                    var e = this, i = 0, s = this.dom.leading * new a.Number(this.attr("font-size"));
                    this.lines().each(function() {
                        this.dom.newLined && (e.textPath() || this.attr("x", e.attr("x")), "\n" == this.text() ? i += s : (this.attr("dy", s + i), i = 0));
                    }), this.fire("rebuild");
                }
                return this;
            },
            build: function(t) {
                return this._build = !!t, this;
            },
            setData: function(t) {
                return this.dom = t, this.dom.leading = new a.Number(t.leading || 1.3), this;
            }
        },
        construct: {
            text: function(t) {
                return this.put(new a.Text).text(t);
            },
            plain: function(t) {
                return this.put(new a.Text).plain(t);
            }
        }
    }), a.Tspan = a.invent({
        create: "tspan",
        inherit: a.Shape,
        extend: {
            text: function(t) {
                return null == t ? this.node.textContent + (this.dom.newLined ? "\n" : "") : ("function" == typeof t ? t.call(this, this) : this.plain(t), this);
            },
            dx: function(t) {
                return this.attr("dx", t);
            },
            dy: function(t) {
                return this.attr("dy", t);
            },
            newLine: function() {
                var t = this.parent(a.Text);
                return this.dom.newLined = !0, this.dy(t.dom.leading * t.attr("font-size")).attr("x", t.x());
            }
        }
    }), a.extend(a.Text, a.Tspan, {
        plain: function(t) {
            return !1 === this._build && this.clear(), this.node.appendChild(e.createTextNode(t)), this;
        },
        tspan: function(t) {
            var e = (this.textPath && this.textPath() || this).node, i = new a.Tspan;
            return !1 === this._build && this.clear(), e.appendChild(i.node), i.text(t);
        },
        clear: function() {
            for(var t = (this.textPath && this.textPath() || this).node; t.hasChildNodes();)t.removeChild(t.lastChild);
            return this;
        },
        length: function() {
            return this.node.getComputedTextLength();
        }
    }), a.TextPath = a.invent({
        create: "textPath",
        inherit: a.Parent,
        parent: a.Text,
        construct: {
            morphArray: a.PathArray,
            array: function() {
                var t = this.track();
                return t ? t.array() : null;
            },
            plot: function(t) {
                var e = this.track(), i = null;
                return e && (i = e.plot(t)), null == t ? i : this;
            },
            track: function() {
                var t = this.textPath();
                if (t) return t.reference("href");
            },
            textPath: function() {
                if (this.node.firstChild && "textPath" == this.node.firstChild.nodeName) return a.adopt(this.node.firstChild);
            }
        }
    }), a.Nested = a.invent({
        create: function() {
            this.constructor.call(this, a.create("svg")), this.style("overflow", "visible");
        },
        inherit: a.Container,
        construct: {
            nested: function() {
                return this.put(new a.Nested);
            }
        }
    });
    var l = {
        stroke: [
            "color",
            "width",
            "opacity",
            "linecap",
            "linejoin",
            "miterlimit",
            "dasharray",
            "dashoffset"
        ],
        fill: [
            "color",
            "opacity",
            "rule"
        ],
        prefix: function(t, e) {
            return "color" == e ? t : t + "-" + e;
        }
    };
    function h(t, e, i, s) {
        return i + s.replace(a.regex.dots, " .");
    }
    function c(t) {
        return t.toLowerCase().replace(/-(.)/g, function(t, e) {
            return e.toUpperCase();
        });
    }
    function d(t) {
        return t.charAt(0).toUpperCase() + t.slice(1);
    }
    function g(t) {
        var e = t.toString(16);
        return 1 == e.length ? "0" + e : e;
    }
    function u(t, e, i) {
        if (null == e || null == i) {
            var a = t.bbox();
            null == e ? e = a.width / a.height * i : null == i && (i = a.height / a.width * e);
        }
        return {
            width: e,
            height: i
        };
    }
    function p(t, e, i) {
        return {
            x: e * t.a + i * t.c + 0,
            y: e * t.b + i * t.d + 0
        };
    }
    function f(t) {
        return {
            a: t[0],
            b: t[1],
            c: t[2],
            d: t[3],
            e: t[4],
            f: t[5]
        };
    }
    function x(e) {
        for(var i = e.childNodes.length - 1; i >= 0; i--)e.childNodes[i] instanceof t.SVGElement && x(e.childNodes[i]);
        return a.adopt(e).id(a.eid(e.nodeName));
    }
    function b(t) {
        return Math.abs(t) > 1e-37 ? t : 0;
    }
    [
        "fill",
        "stroke"
    ].forEach(function(t) {
        var e = {};
        e[t] = function(e) {
            if (void 0 === e) return this;
            if ("string" == typeof e || a.Color.isRgb(e) || e && "function" == typeof e.fill) this.attr(t, e);
            else for(var i = l[t].length - 1; i >= 0; i--)null != e[l[t][i]] && this.attr(l.prefix(t, l[t][i]), e[l[t][i]]);
            return this;
        }, a.extend(a.Element, a.FX, e);
    }), a.extend(a.Element, a.FX, {
        translate: function(t, e) {
            return this.transform({
                x: t,
                y: e
            });
        },
        matrix: function(t) {
            return this.attr("transform", new a.Matrix(6 == arguments.length ? [].slice.call(arguments) : t));
        },
        opacity: function(t) {
            return this.attr("opacity", t);
        },
        dx: function(t) {
            return this.x(new a.Number(t).plus(this instanceof a.FX ? 0 : this.x()), !0);
        },
        dy: function(t) {
            return this.y(new a.Number(t).plus(this instanceof a.FX ? 0 : this.y()), !0);
        }
    }), a.extend(a.Path, {
        length: function() {
            return this.node.getTotalLength();
        },
        pointAt: function(t) {
            return this.node.getPointAtLength(t);
        }
    }), a.Set = a.invent({
        create: function(t) {
            Array.isArray(t) ? this.members = t : this.clear();
        },
        extend: {
            add: function() {
                for(var t = [].slice.call(arguments), e = 0, i = t.length; e < i; e++)this.members.push(t[e]);
                return this;
            },
            remove: function(t) {
                var e = this.index(t);
                return e > -1 && this.members.splice(e, 1), this;
            },
            each: function(t) {
                for(var e = 0, i = this.members.length; e < i; e++)t.apply(this.members[e], [
                    e,
                    this.members
                ]);
                return this;
            },
            clear: function() {
                return this.members = [], this;
            },
            length: function() {
                return this.members.length;
            },
            has: function(t) {
                return this.index(t) >= 0;
            },
            index: function(t) {
                return this.members.indexOf(t);
            },
            get: function(t) {
                return this.members[t];
            },
            first: function() {
                return this.get(0);
            },
            last: function() {
                return this.get(this.members.length - 1);
            },
            valueOf: function() {
                return this.members;
            }
        },
        construct: {
            set: function(t) {
                return new a.Set(t);
            }
        }
    }), a.FX.Set = a.invent({
        create: function(t) {
            this.set = t;
        }
    }), a.Set.inherit = function() {
        var t = [];
        for(var e in a.Shape.prototype)"function" == typeof a.Shape.prototype[e] && "function" != typeof a.Set.prototype[e] && t.push(e);
        for(var e in t.forEach(function(t) {
            a.Set.prototype[t] = function() {
                for(var e = 0, i = this.members.length; e < i; e++)this.members[e] && "function" == typeof this.members[e][t] && this.members[e][t].apply(this.members[e], arguments);
                return "animate" == t ? this.fx || (this.fx = new a.FX.Set(this)) : this;
            };
        }), t = [], a.FX.prototype)"function" == typeof a.FX.prototype[e] && "function" != typeof a.FX.Set.prototype[e] && t.push(e);
        t.forEach(function(t) {
            a.FX.Set.prototype[t] = function() {
                for(var e = 0, i = this.set.members.length; e < i; e++)this.set.members[e].fx[t].apply(this.set.members[e].fx, arguments);
                return this;
            };
        });
    }, a.extend(a.Element, {}), a.extend(a.Element, {
        remember: function(t, e) {
            if ("object" === $fffa43d1c55f0813$var$i(arguments[0])) for(var a in t)this.remember(a, t[a]);
            else {
                if (1 == arguments.length) return this.memory()[t];
                this.memory()[t] = e;
            }
            return this;
        },
        forget: function() {
            if (0 == arguments.length) this._memory = {};
            else for(var t = arguments.length - 1; t >= 0; t--)delete this.memory()[arguments[t]];
            return this;
        },
        memory: function() {
            return this._memory || (this._memory = {});
        }
    }), a.get = function(t) {
        var i = e.getElementById(function(t) {
            var e = (t || "").toString().match(a.regex.reference);
            if (e) return e[1];
        }(t) || t);
        return a.adopt(i);
    }, a.select = function(t, i) {
        return new a.Set(a.utils.map((i || e).querySelectorAll(t), function(t) {
            return a.adopt(t);
        }));
    }, a.extend(a.Parent, {
        select: function(t) {
            return a.select(t, this.node);
        }
    });
    var v = "abcdef".split("");
    if ("function" != typeof t.CustomEvent) {
        var m = function(t, i) {
            i = i || {
                bubbles: !1,
                cancelable: !1,
                detail: void 0
            };
            var a = e.createEvent("CustomEvent");
            return a.initCustomEvent(t, i.bubbles, i.cancelable, i.detail), a;
        };
        m.prototype = t.Event.prototype, a.CustomEvent = m;
    } else a.CustomEvent = t.CustomEvent;
    return a;
}, "function" == typeof define && define.amd ? define(function() {
    return $fffa43d1c55f0813$var$Ht($fffa43d1c55f0813$var$Rt, $fffa43d1c55f0813$var$Rt.document);
}) : "object" === $fffa43d1c55f0813$var$i($fffa43d1c55f0813$exports) && true ? $fffa43d1c55f0813$exports = $fffa43d1c55f0813$var$Rt.document ? $fffa43d1c55f0813$var$Ht($fffa43d1c55f0813$var$Rt, $fffa43d1c55f0813$var$Rt.document) : function(t) {
    return $fffa43d1c55f0813$var$Ht(t, t.document);
} : $fffa43d1c55f0813$var$Rt.SVG = $fffa43d1c55f0813$var$Ht($fffa43d1c55f0813$var$Rt, $fffa43d1c55f0813$var$Rt.document), /*! svg.filter.js - v2.0.2 - 2016-02-24
* https://github.com/wout/svg.filter.js
* Copyright (c) 2016 Wout Fierens; Licensed MIT */ (function() {
    SVG.Filter = SVG.invent({
        create: "filter",
        inherit: SVG.Parent,
        extend: {
            source: "SourceGraphic",
            sourceAlpha: "SourceAlpha",
            background: "BackgroundImage",
            backgroundAlpha: "BackgroundAlpha",
            fill: "FillPaint",
            stroke: "StrokePaint",
            autoSetIn: !0,
            put: function(t, e) {
                return this.add(t, e), !t.attr("in") && this.autoSetIn && t.attr("in", this.source), t.attr("result") || t.attr("result", t), t;
            },
            blend: function(t, e, i) {
                return this.put(new SVG.BlendEffect(t, e, i));
            },
            colorMatrix: function(t, e) {
                return this.put(new SVG.ColorMatrixEffect(t, e));
            },
            convolveMatrix: function(t) {
                return this.put(new SVG.ConvolveMatrixEffect(t));
            },
            componentTransfer: function(t) {
                return this.put(new SVG.ComponentTransferEffect(t));
            },
            composite: function(t, e, i) {
                return this.put(new SVG.CompositeEffect(t, e, i));
            },
            flood: function(t, e) {
                return this.put(new SVG.FloodEffect(t, e));
            },
            offset: function(t, e) {
                return this.put(new SVG.OffsetEffect(t, e));
            },
            image: function(t) {
                return this.put(new SVG.ImageEffect(t));
            },
            merge: function() {
                var t = [
                    void 0
                ];
                for(var e in arguments)t.push(arguments[e]);
                return this.put(new (SVG.MergeEffect.bind.apply(SVG.MergeEffect, t)));
            },
            gaussianBlur: function(t, e) {
                return this.put(new SVG.GaussianBlurEffect(t, e));
            },
            morphology: function(t, e) {
                return this.put(new SVG.MorphologyEffect(t, e));
            },
            diffuseLighting: function(t, e, i) {
                return this.put(new SVG.DiffuseLightingEffect(t, e, i));
            },
            displacementMap: function(t, e, i, a, s) {
                return this.put(new SVG.DisplacementMapEffect(t, e, i, a, s));
            },
            specularLighting: function(t, e, i, a) {
                return this.put(new SVG.SpecularLightingEffect(t, e, i, a));
            },
            tile: function() {
                return this.put(new SVG.TileEffect);
            },
            turbulence: function(t, e, i, a, s) {
                return this.put(new SVG.TurbulenceEffect(t, e, i, a, s));
            },
            toString: function() {
                return "url(#" + this.attr("id") + ")";
            }
        }
    }), SVG.extend(SVG.Defs, {
        filter: function(t) {
            var e = this.put(new SVG.Filter);
            return "function" == typeof t && t.call(e, e), e;
        }
    }), SVG.extend(SVG.Container, {
        filter: function(t) {
            return this.defs().filter(t);
        }
    }), SVG.extend(SVG.Element, SVG.G, SVG.Nested, {
        filter: function(t) {
            return this.filterer = t instanceof SVG.Element ? t : this.doc().filter(t), this.doc() && this.filterer.doc() !== this.doc() && this.doc().defs().add(this.filterer), this.attr("filter", this.filterer), this.filterer;
        },
        unfilter: function(t) {
            return this.filterer && !0 === t && this.filterer.remove(), delete this.filterer, this.attr("filter", null);
        }
    }), SVG.Effect = SVG.invent({
        create: function() {
            this.constructor.call(this);
        },
        inherit: SVG.Element,
        extend: {
            in: function(t) {
                return null == t ? this.parent() && this.parent().select('[result="' + this.attr("in") + '"]').get(0) || this.attr("in") : this.attr("in", t);
            },
            result: function(t) {
                return null == t ? this.attr("result") : this.attr("result", t);
            },
            toString: function() {
                return this.result();
            }
        }
    }), SVG.ParentEffect = SVG.invent({
        create: function() {
            this.constructor.call(this);
        },
        inherit: SVG.Parent,
        extend: {
            in: function(t) {
                return null == t ? this.parent() && this.parent().select('[result="' + this.attr("in") + '"]').get(0) || this.attr("in") : this.attr("in", t);
            },
            result: function(t) {
                return null == t ? this.attr("result") : this.attr("result", t);
            },
            toString: function() {
                return this.result();
            }
        }
    });
    var t = {
        blend: function(t, e) {
            return this.parent() && this.parent().blend(this, t, e);
        },
        colorMatrix: function(t, e) {
            return this.parent() && this.parent().colorMatrix(t, e).in(this);
        },
        convolveMatrix: function(t) {
            return this.parent() && this.parent().convolveMatrix(t).in(this);
        },
        componentTransfer: function(t) {
            return this.parent() && this.parent().componentTransfer(t).in(this);
        },
        composite: function(t, e) {
            return this.parent() && this.parent().composite(this, t, e);
        },
        flood: function(t, e) {
            return this.parent() && this.parent().flood(t, e);
        },
        offset: function(t, e) {
            return this.parent() && this.parent().offset(t, e).in(this);
        },
        image: function(t) {
            return this.parent() && this.parent().image(t);
        },
        merge: function() {
            return this.parent() && this.parent().merge.apply(this.parent(), [
                this
            ].concat(arguments));
        },
        gaussianBlur: function(t, e) {
            return this.parent() && this.parent().gaussianBlur(t, e).in(this);
        },
        morphology: function(t, e) {
            return this.parent() && this.parent().morphology(t, e).in(this);
        },
        diffuseLighting: function(t, e, i) {
            return this.parent() && this.parent().diffuseLighting(t, e, i).in(this);
        },
        displacementMap: function(t, e, i, a) {
            return this.parent() && this.parent().displacementMap(this, t, e, i, a);
        },
        specularLighting: function(t, e, i, a) {
            return this.parent() && this.parent().specularLighting(t, e, i, a).in(this);
        },
        tile: function() {
            return this.parent() && this.parent().tile().in(this);
        },
        turbulence: function(t, e, i, a, s) {
            return this.parent() && this.parent().turbulence(t, e, i, a, s).in(this);
        }
    };
    SVG.extend(SVG.Effect, t), SVG.extend(SVG.ParentEffect, t), SVG.ChildEffect = SVG.invent({
        create: function() {
            this.constructor.call(this);
        },
        inherit: SVG.Element,
        extend: {
            in: function(t) {
                this.attr("in", t);
            }
        }
    });
    var e = {
        blend: function(t, e, i) {
            this.attr({
                in: t,
                in2: e,
                mode: i || "normal"
            });
        },
        colorMatrix: function(t, e) {
            "matrix" == t && (e = s(e)), this.attr({
                type: t,
                values: void 0 === e ? null : e
            });
        },
        convolveMatrix: function(t) {
            t = s(t), this.attr({
                order: Math.sqrt(t.split(" ").length),
                kernelMatrix: t
            });
        },
        composite: function(t, e, i) {
            this.attr({
                in: t,
                in2: e,
                operator: i
            });
        },
        flood: function(t, e) {
            this.attr("flood-color", t), null != e && this.attr("flood-opacity", e);
        },
        offset: function(t, e) {
            this.attr({
                dx: t,
                dy: e
            });
        },
        image: function(t) {
            this.attr("href", t, SVG.xlink);
        },
        displacementMap: function(t, e, i, a, s) {
            this.attr({
                in: t,
                in2: e,
                scale: i,
                xChannelSelector: a,
                yChannelSelector: s
            });
        },
        gaussianBlur: function(t, e) {
            null != t || null != e ? this.attr("stdDeviation", function(t) {
                if (!Array.isArray(t)) return t;
                for(var e = 0, i = t.length, a = []; e < i; e++)a.push(t[e]);
                return a.join(" ");
            }(Array.prototype.slice.call(arguments))) : this.attr("stdDeviation", "0 0");
        },
        morphology: function(t, e) {
            this.attr({
                operator: t,
                radius: e
            });
        },
        tile: function() {},
        turbulence: function(t, e, i, a, s) {
            this.attr({
                numOctaves: e,
                seed: i,
                stitchTiles: a,
                baseFrequency: t,
                type: s
            });
        }
    }, i = {
        merge: function() {
            var t;
            if (arguments[0] instanceof SVG.Set) {
                var e = this;
                arguments[0].each(function(t) {
                    this instanceof SVG.MergeNode ? e.put(this) : (this instanceof SVG.Effect || this instanceof SVG.ParentEffect) && e.put(new SVG.MergeNode(this));
                });
            } else {
                t = Array.isArray(arguments[0]) ? arguments[0] : arguments;
                for(var i = 0; i < t.length; i++)t[i] instanceof SVG.MergeNode ? this.put(t[i]) : this.put(new SVG.MergeNode(t[i]));
            }
        },
        componentTransfer: function(t) {
            if (this.rgb = new SVG.Set, [
                "r",
                "g",
                "b",
                "a"
            ].forEach((function(t) {
                this[t] = new SVG["Func" + t.toUpperCase()]("identity"), this.rgb.add(this[t]), this.node.appendChild(this[t].node);
            }).bind(this)), t) for(var e in t.rgb && ([
                "r",
                "g",
                "b"
            ].forEach((function(e) {
                this[e].attr(t.rgb);
            }).bind(this)), delete t.rgb), t)this[e].attr(t[e]);
        },
        diffuseLighting: function(t, e, i) {
            this.attr({
                surfaceScale: t,
                diffuseConstant: e,
                kernelUnitLength: i
            });
        },
        specularLighting: function(t, e, i, a) {
            this.attr({
                surfaceScale: t,
                diffuseConstant: e,
                specularExponent: i,
                kernelUnitLength: a
            });
        }
    }, a = {
        distantLight: function(t, e) {
            this.attr({
                azimuth: t,
                elevation: e
            });
        },
        pointLight: function(t, e, i) {
            this.attr({
                x: t,
                y: e,
                z: i
            });
        },
        spotLight: function(t, e, i, a, s, r) {
            this.attr({
                x: t,
                y: e,
                z: i,
                pointsAtX: a,
                pointsAtY: s,
                pointsAtZ: r
            });
        },
        mergeNode: function(t) {
            this.attr("in", t);
        }
    };
    function s(t) {
        return Array.isArray(t) && (t = new SVG.Array(t)), t.toString().replace(/^\s+/, "").replace(/\s+$/, "").replace(/\s+/g, " ");
    }
    function r() {
        var t = function() {};
        for(var e in "function" == typeof arguments[arguments.length - 1] && (t = arguments[arguments.length - 1], Array.prototype.splice.call(arguments, arguments.length - 1, 1)), arguments)for(var i in arguments[e])t(arguments[e][i], i, arguments[e]);
    }
    [
        "r",
        "g",
        "b",
        "a"
    ].forEach(function(t) {
        a["Func" + t.toUpperCase()] = function(t) {
            switch(this.attr("type", t), t){
                case "table":
                    this.attr("tableValues", arguments[1]);
                    break;
                case "linear":
                    this.attr("slope", arguments[1]), this.attr("intercept", arguments[2]);
                    break;
                case "gamma":
                    this.attr("amplitude", arguments[1]), this.attr("exponent", arguments[2]), this.attr("offset", arguments[2]);
            }
        };
    }), r(e, function(t, e) {
        var i = e.charAt(0).toUpperCase() + e.slice(1);
        SVG[i + "Effect"] = SVG.invent({
            create: function() {
                this.constructor.call(this, SVG.create("fe" + i)), t.apply(this, arguments), this.result(this.attr("id") + "Out");
            },
            inherit: SVG.Effect,
            extend: {}
        });
    }), r(i, function(t, e) {
        var i = e.charAt(0).toUpperCase() + e.slice(1);
        SVG[i + "Effect"] = SVG.invent({
            create: function() {
                this.constructor.call(this, SVG.create("fe" + i)), t.apply(this, arguments), this.result(this.attr("id") + "Out");
            },
            inherit: SVG.ParentEffect,
            extend: {}
        });
    }), r(a, function(t, e) {
        var i = e.charAt(0).toUpperCase() + e.slice(1);
        SVG[i] = SVG.invent({
            create: function() {
                this.constructor.call(this, SVG.create("fe" + i)), t.apply(this, arguments);
            },
            inherit: SVG.ChildEffect,
            extend: {}
        });
    }), SVG.extend(SVG.MergeEffect, {
        in: function(t) {
            return t instanceof SVG.MergeNode ? this.add(t, 0) : this.add(new SVG.MergeNode(t), 0), this;
        }
    }), SVG.extend(SVG.CompositeEffect, SVG.BlendEffect, SVG.DisplacementMapEffect, {
        in2: function(t) {
            return null == t ? this.parent() && this.parent().select('[result="' + this.attr("in2") + '"]').get(0) || this.attr("in2") : this.attr("in2", t);
        }
    }), SVG.filter = {
        sepiatone: [
            .343,
            .669,
            .119,
            0,
            0,
            .249,
            .626,
            .13,
            0,
            0,
            .172,
            .334,
            .111,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ]
    };
}).call(void 0), function() {
    function t(t, s, r, o, n, l, h) {
        for(var c = t.slice(s, r || h), d = o.slice(n, l || h), g = 0, u = {
            pos: [
                0,
                0
            ],
            start: [
                0,
                0
            ]
        }, p = {
            pos: [
                0,
                0
            ],
            start: [
                0,
                0
            ]
        };;){
            if (c[g] = e.call(u, c[g]), d[g] = e.call(p, d[g]), c[g][0] != d[g][0] || "M" == c[g][0] || "A" == c[g][0] && (c[g][4] != d[g][4] || c[g][5] != d[g][5]) ? (Array.prototype.splice.apply(c, [
                g,
                1
            ].concat(a.call(u, c[g]))), Array.prototype.splice.apply(d, [
                g,
                1
            ].concat(a.call(p, d[g])))) : (c[g] = i.call(u, c[g]), d[g] = i.call(p, d[g])), ++g == c.length && g == d.length) break;
            g == c.length && c.push([
                "C",
                u.pos[0],
                u.pos[1],
                u.pos[0],
                u.pos[1],
                u.pos[0],
                u.pos[1]
            ]), g == d.length && d.push([
                "C",
                p.pos[0],
                p.pos[1],
                p.pos[0],
                p.pos[1],
                p.pos[0],
                p.pos[1]
            ]);
        }
        return {
            start: c,
            dest: d
        };
    }
    function e(t) {
        switch(t[0]){
            case "z":
            case "Z":
                t[0] = "L", t[1] = this.start[0], t[2] = this.start[1];
                break;
            case "H":
                t[0] = "L", t[2] = this.pos[1];
                break;
            case "V":
                t[0] = "L", t[2] = t[1], t[1] = this.pos[0];
                break;
            case "T":
                t[0] = "Q", t[3] = t[1], t[4] = t[2], t[1] = this.reflection[1], t[2] = this.reflection[0];
                break;
            case "S":
                t[0] = "C", t[6] = t[4], t[5] = t[3], t[4] = t[2], t[3] = t[1], t[2] = this.reflection[1], t[1] = this.reflection[0];
        }
        return t;
    }
    function i(t) {
        var e = t.length;
        return this.pos = [
            t[e - 2],
            t[e - 1]
        ], -1 != "SCQT".indexOf(t[0]) && (this.reflection = [
            2 * this.pos[0] - t[e - 4],
            2 * this.pos[1] - t[e - 3]
        ]), t;
    }
    function a(t) {
        var e = [
            t
        ];
        switch(t[0]){
            case "M":
                return this.pos = this.start = [
                    t[1],
                    t[2]
                ], e;
            case "L":
                t[5] = t[3] = t[1], t[6] = t[4] = t[2], t[1] = this.pos[0], t[2] = this.pos[1];
                break;
            case "Q":
                t[6] = t[4], t[5] = t[3], t[4] = 1 * t[4] / 3 + 2 * t[2] / 3, t[3] = 1 * t[3] / 3 + 2 * t[1] / 3, t[2] = 1 * this.pos[1] / 3 + 2 * t[2] / 3, t[1] = 1 * this.pos[0] / 3 + 2 * t[1] / 3;
                break;
            case "A":
                e = function(t, e) {
                    var i, a, s, r, o, n, l, h, c, d, g, u, p, f, x, b, v, m, y, w, k, A, S, C, L, P, I = Math.abs(e[1]), T = Math.abs(e[2]), M = e[3] % 360, z = e[4], X = e[5], E = e[6], Y = e[7], F = new SVG.Point(t), R = new SVG.Point(E, Y), H = [];
                    if (0 === I || 0 === T || F.x === R.x && F.y === R.y) return [
                        [
                            "C",
                            F.x,
                            F.y,
                            R.x,
                            R.y,
                            R.x,
                            R.y
                        ]
                    ];
                    i = new SVG.Point((F.x - R.x) / 2, (F.y - R.y) / 2).transform((new SVG.Matrix).rotate(M)), (a = i.x * i.x / (I * I) + i.y * i.y / (T * T)) > 1 && (I *= a = Math.sqrt(a), T *= a);
                    s = (new SVG.Matrix).rotate(M).scale(1 / I, 1 / T).rotate(-M), F = F.transform(s), R = R.transform(s), r = [
                        R.x - F.x,
                        R.y - F.y
                    ], n = r[0] * r[0] + r[1] * r[1], o = Math.sqrt(n), r[0] /= o, r[1] /= o, l = n < 4 ? Math.sqrt(1 - n / 4) : 0, z === X && (l *= -1);
                    h = new SVG.Point((R.x + F.x) / 2 + l * -r[1], (R.y + F.y) / 2 + l * r[0]), c = new SVG.Point(F.x - h.x, F.y - h.y), d = new SVG.Point(R.x - h.x, R.y - h.y), g = Math.acos(c.x / Math.sqrt(c.x * c.x + c.y * c.y)), c.y < 0 && (g *= -1);
                    u = Math.acos(d.x / Math.sqrt(d.x * d.x + d.y * d.y)), d.y < 0 && (u *= -1);
                    X && g > u && (u += 2 * Math.PI);
                    !X && g < u && (u -= 2 * Math.PI);
                    for(f = Math.ceil(2 * Math.abs(g - u) / Math.PI), b = [], v = g, p = (u - g) / f, x = 4 * Math.tan(p / 4) / 3, k = 0; k <= f; k++)y = Math.cos(v), m = Math.sin(v), w = new SVG.Point(h.x + y, h.y + m), b[k] = [
                        new SVG.Point(w.x + x * m, w.y - x * y),
                        w,
                        new SVG.Point(w.x - x * m, w.y + x * y)
                    ], v += p;
                    for(b[0][0] = b[0][1].clone(), b[b.length - 1][2] = b[b.length - 1][1].clone(), s = (new SVG.Matrix).rotate(M).scale(I, T).rotate(-M), k = 0, A = b.length; k < A; k++)b[k][0] = b[k][0].transform(s), b[k][1] = b[k][1].transform(s), b[k][2] = b[k][2].transform(s);
                    for(k = 1, A = b.length; k < A; k++)S = (w = b[k - 1][2]).x, C = w.y, L = (w = b[k][0]).x, P = w.y, E = (w = b[k][1]).x, Y = w.y, H.push([
                        "C",
                        S,
                        C,
                        L,
                        P,
                        E,
                        Y
                    ]);
                    return H;
                }(this.pos, t), t = e[0];
        }
        return t[0] = "C", this.pos = [
            t[5],
            t[6]
        ], this.reflection = [
            2 * t[5] - t[3],
            2 * t[6] - t[4]
        ], e;
    }
    function s(t, e) {
        if (!1 === e) return !1;
        for(var i = e, a = t.length; i < a; ++i)if ("M" == t[i][0]) return i;
        return !1;
    }
    SVG.extend(SVG.PathArray, {
        morph: function(e) {
            for(var i = this.value, a = this.parse(e), r = 0, o = 0, n = !1, l = !1; !1 !== r || !1 !== o;){
                var h;
                n = s(i, !1 !== r && r + 1), l = s(a, !1 !== o && o + 1), !1 === r && (r = 0 == (h = new SVG.PathArray(c.start).bbox()).height || 0 == h.width ? i.push(i[0]) - 1 : i.push([
                    "M",
                    h.x + h.width / 2,
                    h.y + h.height / 2
                ]) - 1), !1 === o && (o = 0 == (h = new SVG.PathArray(c.dest).bbox()).height || 0 == h.width ? a.push(a[0]) - 1 : a.push([
                    "M",
                    h.x + h.width / 2,
                    h.y + h.height / 2
                ]) - 1);
                var c = t(i, r, n, a, o, l);
                i = i.slice(0, r).concat(c.start, !1 === n ? [] : i.slice(n)), a = a.slice(0, o).concat(c.dest, !1 === l ? [] : a.slice(l)), r = !1 !== n && r + c.start.length, o = !1 !== l && o + c.dest.length;
            }
            return this.value = i, this.destination = new SVG.PathArray, this.destination.value = a, this;
        }
    });
}(), /*! svg.draggable.js - v2.2.2 - 2019-01-08
* https://github.com/svgdotjs/svg.draggable.js
* Copyright (c) 2019 Wout Fierens; Licensed MIT */ (function() {
    function t(t) {
        t.remember("_draggable", this), this.el = t;
    }
    t.prototype.init = function(t, e) {
        var i = this;
        this.constraint = t, this.value = e, this.el.on("mousedown.drag", function(t) {
            i.start(t);
        }), this.el.on("touchstart.drag", function(t) {
            i.start(t);
        });
    }, t.prototype.transformPoint = function(t, e) {
        var i = (t = t || window.event).changedTouches && t.changedTouches[0] || t;
        return this.p.x = i.clientX - (e || 0), this.p.y = i.clientY, this.p.matrixTransform(this.m);
    }, t.prototype.getBBox = function() {
        var t = this.el.bbox();
        return this.el instanceof SVG.Nested && (t = this.el.rbox()), (this.el instanceof SVG.G || this.el instanceof SVG.Use || this.el instanceof SVG.Nested) && (t.x = this.el.x(), t.y = this.el.y()), t;
    }, t.prototype.start = function(t) {
        if ("click" != t.type && "mousedown" != t.type && "mousemove" != t.type || 1 == (t.which || t.buttons)) {
            var e = this;
            if (this.el.fire("beforedrag", {
                event: t,
                handler: this
            }), !this.el.event().defaultPrevented) {
                t.preventDefault(), t.stopPropagation(), this.parent = this.parent || this.el.parent(SVG.Nested) || this.el.parent(SVG.Doc), this.p = this.parent.node.createSVGPoint(), this.m = this.el.node.getScreenCTM().inverse();
                var i, a = this.getBBox();
                if (this.el instanceof SVG.Text) switch(i = this.el.node.getComputedTextLength(), this.el.attr("text-anchor")){
                    case "middle":
                        i /= 2;
                        break;
                    case "start":
                        i = 0;
                }
                this.startPoints = {
                    point: this.transformPoint(t, i),
                    box: a,
                    transform: this.el.transform()
                }, SVG.on(window, "mousemove.drag", function(t) {
                    e.drag(t);
                }), SVG.on(window, "touchmove.drag", function(t) {
                    e.drag(t);
                }), SVG.on(window, "mouseup.drag", function(t) {
                    e.end(t);
                }), SVG.on(window, "touchend.drag", function(t) {
                    e.end(t);
                }), this.el.fire("dragstart", {
                    event: t,
                    p: this.startPoints.point,
                    m: this.m,
                    handler: this
                });
            }
        }
    }, t.prototype.drag = function(t) {
        var e = this.getBBox(), i = this.transformPoint(t), a = this.startPoints.box.x + i.x - this.startPoints.point.x, s = this.startPoints.box.y + i.y - this.startPoints.point.y, r = this.constraint, o = i.x - this.startPoints.point.x, n = i.y - this.startPoints.point.y;
        if (this.el.fire("dragmove", {
            event: t,
            p: i,
            m: this.m,
            handler: this
        }), this.el.event().defaultPrevented) return i;
        if ("function" == typeof r) {
            var l = r.call(this.el, a, s, this.m);
            "boolean" == typeof l && (l = {
                x: l,
                y: l
            }), !0 === l.x ? this.el.x(a) : !1 !== l.x && this.el.x(l.x), !0 === l.y ? this.el.y(s) : !1 !== l.y && this.el.y(l.y);
        } else "object" == typeof r && (null != r.minX && a < r.minX ? o = (a = r.minX) - this.startPoints.box.x : null != r.maxX && a > r.maxX - e.width && (o = (a = r.maxX - e.width) - this.startPoints.box.x), null != r.minY && s < r.minY ? n = (s = r.minY) - this.startPoints.box.y : null != r.maxY && s > r.maxY - e.height && (n = (s = r.maxY - e.height) - this.startPoints.box.y), null != r.snapToGrid && (a -= a % r.snapToGrid, s -= s % r.snapToGrid, o -= o % r.snapToGrid, n -= n % r.snapToGrid), this.el instanceof SVG.G ? this.el.matrix(this.startPoints.transform).transform({
            x: o,
            y: n
        }, !0) : this.el.move(a, s));
        return i;
    }, t.prototype.end = function(t) {
        var e = this.drag(t);
        this.el.fire("dragend", {
            event: t,
            p: e,
            m: this.m,
            handler: this
        }), SVG.off(window, "mousemove.drag"), SVG.off(window, "touchmove.drag"), SVG.off(window, "mouseup.drag"), SVG.off(window, "touchend.drag");
    }, SVG.extend(SVG.Element, {
        draggable: function(e, i) {
            "function" != typeof e && "object" != typeof e || (i = e, e = !0);
            var a = this.remember("_draggable") || new t(this);
            return (e = void 0 === e || e) ? a.init(i || {}, e) : (this.off("mousedown.drag"), this.off("touchstart.drag")), this;
        }
    });
}).call(void 0), function() {
    function t(t) {
        this.el = t, t.remember("_selectHandler", this), this.pointSelection = {
            isSelected: !1
        }, this.rectSelection = {
            isSelected: !1
        }, this.pointsList = {
            lt: [
                0,
                0
            ],
            rt: [
                "width",
                0
            ],
            rb: [
                "width",
                "height"
            ],
            lb: [
                0,
                "height"
            ],
            t: [
                "width",
                0
            ],
            r: [
                "width",
                "height"
            ],
            b: [
                "width",
                "height"
            ],
            l: [
                0,
                "height"
            ]
        }, this.pointCoord = function(t, e, i) {
            var a = "string" != typeof t ? t : e[t];
            return i ? a / 2 : a;
        }, this.pointCoords = function(t, e) {
            var i = this.pointsList[t];
            return {
                x: this.pointCoord(i[0], e, "t" === t || "b" === t),
                y: this.pointCoord(i[1], e, "r" === t || "l" === t)
            };
        };
    }
    t.prototype.init = function(t, e) {
        var i = this.el.bbox();
        this.options = {};
        var a = this.el.selectize.defaults.points;
        for(var s in this.el.selectize.defaults)this.options[s] = this.el.selectize.defaults[s], void 0 !== e[s] && (this.options[s] = e[s]);
        var r = [
            "points",
            "pointsExclude"
        ];
        for(var s in r){
            var o = this.options[r[s]];
            "string" == typeof o ? o = o.length > 0 ? o.split(/\s*,\s*/i) : [] : "boolean" == typeof o && "points" === r[s] && (o = o ? a : []), this.options[r[s]] = o;
        }
        this.options.points = [
            a,
            this.options.points
        ].reduce(function(t, e) {
            return t.filter(function(t) {
                return e.indexOf(t) > -1;
            });
        }), this.options.points = [
            this.options.points,
            this.options.pointsExclude
        ].reduce(function(t, e) {
            return t.filter(function(t) {
                return e.indexOf(t) < 0;
            });
        }), this.parent = this.el.parent(), this.nested = this.nested || this.parent.group(), this.nested.matrix(new SVG.Matrix(this.el).translate(i.x, i.y)), this.options.deepSelect && -1 !== [
            "line",
            "polyline",
            "polygon"
        ].indexOf(this.el.type) ? this.selectPoints(t) : this.selectRect(t), this.observe(), this.cleanup();
    }, t.prototype.selectPoints = function(t) {
        return this.pointSelection.isSelected = t, this.pointSelection.set || (this.pointSelection.set = this.parent.set(), this.drawPoints()), this;
    }, t.prototype.getPointArray = function() {
        var t = this.el.bbox();
        return this.el.array().valueOf().map(function(e) {
            return [
                e[0] - t.x,
                e[1] - t.y
            ];
        });
    }, t.prototype.drawPoints = function() {
        for(var t = this, e = this.getPointArray(), i = 0, a = e.length; i < a; ++i){
            var s = function(e) {
                return function(i) {
                    (i = i || window.event).preventDefault ? i.preventDefault() : i.returnValue = !1, i.stopPropagation();
                    var a = i.pageX || i.touches[0].pageX, s = i.pageY || i.touches[0].pageY;
                    t.el.fire("point", {
                        x: a,
                        y: s,
                        i: e,
                        event: i
                    });
                };
            }(i), r = this.drawPoint(e[i][0], e[i][1]).addClass(this.options.classPoints).addClass(this.options.classPoints + "_point").on("touchstart", s).on("mousedown", s);
            this.pointSelection.set.add(r);
        }
    }, t.prototype.drawPoint = function(t, e) {
        var i = this.options.pointType;
        switch(i){
            case "circle":
                return this.drawCircle(t, e);
            case "rect":
                return this.drawRect(t, e);
            default:
                if ("function" == typeof i) return i.call(this, t, e);
                throw new Error("Unknown " + i + " point type!");
        }
    }, t.prototype.drawCircle = function(t, e) {
        return this.nested.circle(this.options.pointSize).center(t, e);
    }, t.prototype.drawRect = function(t, e) {
        return this.nested.rect(this.options.pointSize, this.options.pointSize).center(t, e);
    }, t.prototype.updatePointSelection = function() {
        var t = this.getPointArray();
        this.pointSelection.set.each(function(e) {
            this.cx() === t[e][0] && this.cy() === t[e][1] || this.center(t[e][0], t[e][1]);
        });
    }, t.prototype.updateRectSelection = function() {
        var t = this, e = this.el.bbox();
        if (this.rectSelection.set.get(0).attr({
            width: e.width,
            height: e.height
        }), this.options.points.length && this.options.points.map(function(i, a) {
            var s = t.pointCoords(i, e);
            t.rectSelection.set.get(a + 1).center(s.x, s.y);
        }), this.options.rotationPoint) {
            var i = this.rectSelection.set.length();
            this.rectSelection.set.get(i - 1).center(e.width / 2, 20);
        }
    }, t.prototype.selectRect = function(t) {
        var e = this, i = this.el.bbox();
        function a(t) {
            return function(i) {
                (i = i || window.event).preventDefault ? i.preventDefault() : i.returnValue = !1, i.stopPropagation();
                var a = i.pageX || i.touches[0].pageX, s = i.pageY || i.touches[0].pageY;
                e.el.fire(t, {
                    x: a,
                    y: s,
                    event: i
                });
            };
        }
        if (this.rectSelection.isSelected = t, this.rectSelection.set = this.rectSelection.set || this.parent.set(), this.rectSelection.set.get(0) || this.rectSelection.set.add(this.nested.rect(i.width, i.height).addClass(this.options.classRect)), this.options.points.length && this.rectSelection.set.length() < 2) this.options.points.map(function(t, s) {
            var r = e.pointCoords(t, i), o = e.drawPoint(r.x, r.y).attr("class", e.options.classPoints + "_" + t).on("mousedown", a(t)).on("touchstart", a(t));
            e.rectSelection.set.add(o);
        }), this.rectSelection.set.each(function() {
            this.addClass(e.options.classPoints);
        });
        if (this.options.rotationPoint && (this.options.points && !this.rectSelection.set.get(9) || !this.options.points && !this.rectSelection.set.get(1))) {
            var s = function(t) {
                (t = t || window.event).preventDefault ? t.preventDefault() : t.returnValue = !1, t.stopPropagation();
                var i = t.pageX || t.touches[0].pageX, a = t.pageY || t.touches[0].pageY;
                e.el.fire("rot", {
                    x: i,
                    y: a,
                    event: t
                });
            }, r = this.drawPoint(i.width / 2, 20).attr("class", this.options.classPoints + "_rot").on("touchstart", s).on("mousedown", s);
            this.rectSelection.set.add(r);
        }
    }, t.prototype.handler = function() {
        var t = this.el.bbox();
        this.nested.matrix(new SVG.Matrix(this.el).translate(t.x, t.y)), this.rectSelection.isSelected && this.updateRectSelection(), this.pointSelection.isSelected && this.updatePointSelection();
    }, t.prototype.observe = function() {
        var t = this;
        if (MutationObserver) {
            if (this.rectSelection.isSelected || this.pointSelection.isSelected) this.observerInst = this.observerInst || new MutationObserver(function() {
                t.handler();
            }), this.observerInst.observe(this.el.node, {
                attributes: !0
            });
            else try {
                this.observerInst.disconnect(), delete this.observerInst;
            } catch (t) {}
        } else this.el.off("DOMAttrModified.select"), (this.rectSelection.isSelected || this.pointSelection.isSelected) && this.el.on("DOMAttrModified.select", function() {
            t.handler();
        });
    }, t.prototype.cleanup = function() {
        !this.rectSelection.isSelected && this.rectSelection.set && (this.rectSelection.set.each(function() {
            this.remove();
        }), this.rectSelection.set.clear(), delete this.rectSelection.set), !this.pointSelection.isSelected && this.pointSelection.set && (this.pointSelection.set.each(function() {
            this.remove();
        }), this.pointSelection.set.clear(), delete this.pointSelection.set), this.pointSelection.isSelected || this.rectSelection.isSelected || (this.nested.remove(), delete this.nested);
    }, SVG.extend(SVG.Element, {
        selectize: function(e, i) {
            return "object" == typeof e && (i = e, e = !0), (this.remember("_selectHandler") || new t(this)).init(void 0 === e || e, i || {}), this;
        }
    }), SVG.Element.prototype.selectize.defaults = {
        points: [
            "lt",
            "rt",
            "rb",
            "lb",
            "t",
            "r",
            "b",
            "l"
        ],
        pointsExclude: [],
        classRect: "svg_select_boundingRect",
        classPoints: "svg_select_points",
        pointSize: 7,
        rotationPoint: !0,
        deepSelect: !1,
        pointType: "circle"
    };
}(), function() {
    (function() {
        function t(t) {
            t.remember("_resizeHandler", this), this.el = t, this.parameters = {}, this.lastUpdateCall = null, this.p = t.doc().node.createSVGPoint();
        }
        t.prototype.transformPoint = function(t, e, i) {
            return this.p.x = t - (this.offset.x - window.pageXOffset), this.p.y = e - (this.offset.y - window.pageYOffset), this.p.matrixTransform(i || this.m);
        }, t.prototype._extractPosition = function(t) {
            return {
                x: null != t.clientX ? t.clientX : t.touches[0].clientX,
                y: null != t.clientY ? t.clientY : t.touches[0].clientY
            };
        }, t.prototype.init = function(t) {
            var e = this;
            if (this.stop(), "stop" !== t) {
                for(var i in this.options = {}, this.el.resize.defaults)this.options[i] = this.el.resize.defaults[i], void 0 !== t[i] && (this.options[i] = t[i]);
                this.el.on("lt.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("rt.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("rb.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("lb.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("t.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("r.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("b.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("l.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("rot.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("point.resize", function(t) {
                    e.resize(t || window.event);
                }), this.update();
            }
        }, t.prototype.stop = function() {
            return this.el.off("lt.resize"), this.el.off("rt.resize"), this.el.off("rb.resize"), this.el.off("lb.resize"), this.el.off("t.resize"), this.el.off("r.resize"), this.el.off("b.resize"), this.el.off("l.resize"), this.el.off("rot.resize"), this.el.off("point.resize"), this;
        }, t.prototype.resize = function(t) {
            var e = this;
            this.m = this.el.node.getScreenCTM().inverse(), this.offset = {
                x: window.pageXOffset,
                y: window.pageYOffset
            };
            var i = this._extractPosition(t.detail.event);
            if (this.parameters = {
                type: this.el.type,
                p: this.transformPoint(i.x, i.y),
                x: t.detail.x,
                y: t.detail.y,
                box: this.el.bbox(),
                rotation: this.el.transform().rotation
            }, "text" === this.el.type && (this.parameters.fontSize = this.el.attr()["font-size"]), void 0 !== t.detail.i) {
                var a = this.el.array().valueOf();
                this.parameters.i = t.detail.i, this.parameters.pointCoords = [
                    a[t.detail.i][0],
                    a[t.detail.i][1]
                ];
            }
            switch(t.type){
                case "lt":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e);
                        if (this.parameters.box.width - i[0] > 0 && this.parameters.box.height - i[1] > 0) {
                            if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x + i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize - i[0]);
                            i = this.checkAspectRatio(i), this.el.move(this.parameters.box.x + i[0], this.parameters.box.y + i[1]).size(this.parameters.box.width - i[0], this.parameters.box.height - i[1]);
                        }
                    };
                    break;
                case "rt":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 2);
                        if (this.parameters.box.width + i[0] > 0 && this.parameters.box.height - i[1] > 0) {
                            if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x - i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize + i[0]);
                            i = this.checkAspectRatio(i, !0), this.el.move(this.parameters.box.x, this.parameters.box.y + i[1]).size(this.parameters.box.width + i[0], this.parameters.box.height - i[1]);
                        }
                    };
                    break;
                case "rb":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 0);
                        if (this.parameters.box.width + i[0] > 0 && this.parameters.box.height + i[1] > 0) {
                            if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x - i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize + i[0]);
                            i = this.checkAspectRatio(i), this.el.move(this.parameters.box.x, this.parameters.box.y).size(this.parameters.box.width + i[0], this.parameters.box.height + i[1]);
                        }
                    };
                    break;
                case "lb":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 1);
                        if (this.parameters.box.width - i[0] > 0 && this.parameters.box.height + i[1] > 0) {
                            if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x + i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize - i[0]);
                            i = this.checkAspectRatio(i, !0), this.el.move(this.parameters.box.x + i[0], this.parameters.box.y).size(this.parameters.box.width - i[0], this.parameters.box.height + i[1]);
                        }
                    };
                    break;
                case "t":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 2);
                        if (this.parameters.box.height - i[1] > 0) {
                            if ("text" === this.parameters.type) return;
                            this.el.move(this.parameters.box.x, this.parameters.box.y + i[1]).height(this.parameters.box.height - i[1]);
                        }
                    };
                    break;
                case "r":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 0);
                        if (this.parameters.box.width + i[0] > 0) {
                            if ("text" === this.parameters.type) return;
                            this.el.move(this.parameters.box.x, this.parameters.box.y).width(this.parameters.box.width + i[0]);
                        }
                    };
                    break;
                case "b":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 0);
                        if (this.parameters.box.height + i[1] > 0) {
                            if ("text" === this.parameters.type) return;
                            this.el.move(this.parameters.box.x, this.parameters.box.y).height(this.parameters.box.height + i[1]);
                        }
                    };
                    break;
                case "l":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 1);
                        if (this.parameters.box.width - i[0] > 0) {
                            if ("text" === this.parameters.type) return;
                            this.el.move(this.parameters.box.x + i[0], this.parameters.box.y).width(this.parameters.box.width - i[0]);
                        }
                    };
                    break;
                case "rot":
                    this.calc = function(t, e) {
                        var i = t + this.parameters.p.x, a = e + this.parameters.p.y, s = Math.atan2(this.parameters.p.y - this.parameters.box.y - this.parameters.box.height / 2, this.parameters.p.x - this.parameters.box.x - this.parameters.box.width / 2), r = Math.atan2(a - this.parameters.box.y - this.parameters.box.height / 2, i - this.parameters.box.x - this.parameters.box.width / 2), o = this.parameters.rotation + 180 * (r - s) / Math.PI + this.options.snapToAngle / 2;
                        this.el.center(this.parameters.box.cx, this.parameters.box.cy).rotate(o - o % this.options.snapToAngle, this.parameters.box.cx, this.parameters.box.cy);
                    };
                    break;
                case "point":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, this.parameters.pointCoords[0], this.parameters.pointCoords[1]), a = this.el.array().valueOf();
                        a[this.parameters.i][0] = this.parameters.pointCoords[0] + i[0], a[this.parameters.i][1] = this.parameters.pointCoords[1] + i[1], this.el.plot(a);
                    };
            }
            this.el.fire("resizestart", {
                dx: this.parameters.x,
                dy: this.parameters.y,
                event: t
            }), SVG.on(window, "touchmove.resize", function(t) {
                e.update(t || window.event);
            }), SVG.on(window, "touchend.resize", function() {
                e.done();
            }), SVG.on(window, "mousemove.resize", function(t) {
                e.update(t || window.event);
            }), SVG.on(window, "mouseup.resize", function() {
                e.done();
            });
        }, t.prototype.update = function(t) {
            if (t) {
                var e = this._extractPosition(t), i = this.transformPoint(e.x, e.y), a = i.x - this.parameters.p.x, s = i.y - this.parameters.p.y;
                this.lastUpdateCall = [
                    a,
                    s
                ], this.calc(a, s), this.el.fire("resizing", {
                    dx: a,
                    dy: s,
                    event: t
                });
            } else this.lastUpdateCall && this.calc(this.lastUpdateCall[0], this.lastUpdateCall[1]);
        }, t.prototype.done = function() {
            this.lastUpdateCall = null, SVG.off(window, "mousemove.resize"), SVG.off(window, "mouseup.resize"), SVG.off(window, "touchmove.resize"), SVG.off(window, "touchend.resize"), this.el.fire("resizedone");
        }, t.prototype.snapToGrid = function(t, e, i, a) {
            var s;
            return void 0 !== a ? s = [
                (i + t) % this.options.snapToGrid,
                (a + e) % this.options.snapToGrid
            ] : (i = null == i ? 3 : i, s = [
                (this.parameters.box.x + t + (1 & i ? 0 : this.parameters.box.width)) % this.options.snapToGrid,
                (this.parameters.box.y + e + (2 & i ? 0 : this.parameters.box.height)) % this.options.snapToGrid
            ]), t < 0 && (s[0] -= this.options.snapToGrid), e < 0 && (s[1] -= this.options.snapToGrid), t -= Math.abs(s[0]) < this.options.snapToGrid / 2 ? s[0] : s[0] - (t < 0 ? -this.options.snapToGrid : this.options.snapToGrid), e -= Math.abs(s[1]) < this.options.snapToGrid / 2 ? s[1] : s[1] - (e < 0 ? -this.options.snapToGrid : this.options.snapToGrid), this.constraintToBox(t, e, i, a);
        }, t.prototype.constraintToBox = function(t, e, i, a) {
            var s, r, o = this.options.constraint || {};
            return void 0 !== a ? (s = i, r = a) : (s = this.parameters.box.x + (1 & i ? 0 : this.parameters.box.width), r = this.parameters.box.y + (2 & i ? 0 : this.parameters.box.height)), void 0 !== o.minX && s + t < o.minX && (t = o.minX - s), void 0 !== o.maxX && s + t > o.maxX && (t = o.maxX - s), void 0 !== o.minY && r + e < o.minY && (e = o.minY - r), void 0 !== o.maxY && r + e > o.maxY && (e = o.maxY - r), [
                t,
                e
            ];
        }, t.prototype.checkAspectRatio = function(t, e) {
            if (!this.options.saveAspectRatio) return t;
            var i = t.slice(), a = this.parameters.box.width / this.parameters.box.height, s = this.parameters.box.width + t[0], r = this.parameters.box.height - t[1], o = s / r;
            return o < a ? (i[1] = s / a - this.parameters.box.height, e && (i[1] = -i[1])) : o > a && (i[0] = this.parameters.box.width - r * a, e && (i[0] = -i[0])), i;
        }, SVG.extend(SVG.Element, {
            resize: function(e) {
                return (this.remember("_resizeHandler") || new t(this)).init(e || {}), this;
            }
        }), SVG.Element.prototype.resize.defaults = {
            snapToAngle: .1,
            snapToGrid: 1,
            constraint: {},
            saveAspectRatio: !1
        };
    }).call(this);
}(), void 0 === window.Apex && (window.Apex = {});
var $fffa43d1c55f0813$var$Gt = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "initModules",
            value: function() {
                this.ctx.publicMethods = [
                    "updateOptions",
                    "updateSeries",
                    "appendData",
                    "appendSeries",
                    "isSeriesHidden",
                    "toggleSeries",
                    "showSeries",
                    "hideSeries",
                    "setLocale",
                    "resetSeries",
                    "zoomX",
                    "toggleDataPointSelection",
                    "dataURI",
                    "exportToCSV",
                    "addXaxisAnnotation",
                    "addYaxisAnnotation",
                    "addPointAnnotation",
                    "clearAnnotations",
                    "removeAnnotation",
                    "paper",
                    "destroy"
                ], this.ctx.eventList = [
                    "click",
                    "mousedown",
                    "mousemove",
                    "mouseleave",
                    "touchstart",
                    "touchmove",
                    "touchleave",
                    "mouseup",
                    "touchend"
                ], this.ctx.animations = new $fffa43d1c55f0813$var$b(this.ctx), this.ctx.axes = new $fffa43d1c55f0813$var$J(this.ctx), this.ctx.core = new $fffa43d1c55f0813$var$Wt(this.ctx.el, this.ctx), this.ctx.config = new $fffa43d1c55f0813$var$E({}), this.ctx.data = new $fffa43d1c55f0813$var$W(this.ctx), this.ctx.grid = new $fffa43d1c55f0813$var$j(this.ctx), this.ctx.graphics = new $fffa43d1c55f0813$var$m(this.ctx), this.ctx.coreUtils = new $fffa43d1c55f0813$var$y(this.ctx), this.ctx.crosshairs = new $fffa43d1c55f0813$var$Q(this.ctx), this.ctx.events = new $fffa43d1c55f0813$var$Z(this.ctx), this.ctx.exports = new $fffa43d1c55f0813$var$G(this.ctx), this.ctx.localization = new $fffa43d1c55f0813$var$$(this.ctx), this.ctx.options = new $fffa43d1c55f0813$var$L, this.ctx.responsive = new $fffa43d1c55f0813$var$K(this.ctx), this.ctx.series = new $fffa43d1c55f0813$var$N(this.ctx), this.ctx.theme = new $fffa43d1c55f0813$var$tt(this.ctx), this.ctx.formatters = new $fffa43d1c55f0813$var$T(this.ctx), this.ctx.titleSubtitle = new $fffa43d1c55f0813$var$et(this.ctx), this.ctx.legend = new $fffa43d1c55f0813$var$lt(this.ctx), this.ctx.toolbar = new $fffa43d1c55f0813$var$ht(this.ctx), this.ctx.tooltip = new $fffa43d1c55f0813$var$bt(this.ctx), this.ctx.dimensions = new $fffa43d1c55f0813$var$ot(this.ctx), this.ctx.updateHelpers = new $fffa43d1c55f0813$var$Bt(this.ctx), this.ctx.zoomPanSelection = new $fffa43d1c55f0813$var$ct(this.ctx), this.ctx.w.globals.tooltip = new $fffa43d1c55f0813$var$bt(this.ctx);
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$Vt = function() {
    function t(e) {
        $fffa43d1c55f0813$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "clear",
            value: function(t) {
                var e = t.isUpdating;
                this.ctx.zoomPanSelection && this.ctx.zoomPanSelection.destroy(), this.ctx.toolbar && this.ctx.toolbar.destroy(), this.ctx.animations = null, this.ctx.axes = null, this.ctx.annotations = null, this.ctx.core = null, this.ctx.data = null, this.ctx.grid = null, this.ctx.series = null, this.ctx.responsive = null, this.ctx.theme = null, this.ctx.formatters = null, this.ctx.titleSubtitle = null, this.ctx.legend = null, this.ctx.dimensions = null, this.ctx.options = null, this.ctx.crosshairs = null, this.ctx.zoomPanSelection = null, this.ctx.updateHelpers = null, this.ctx.toolbar = null, this.ctx.localization = null, this.ctx.w.globals.tooltip = null, this.clearDomElements({
                    isUpdating: e
                });
            }
        },
        {
            key: "killSVG",
            value: function(t) {
                t.each(function(t, e) {
                    this.removeClass("*"), this.off(), this.stop();
                }, !0), t.ungroup(), t.clear();
            }
        },
        {
            key: "clearDomElements",
            value: function(t) {
                var e = this, i = t.isUpdating, a = this.w.globals.dom.Paper.node;
                a.parentNode && a.parentNode.parentNode && !i && (a.parentNode.parentNode.style.minHeight = "unset");
                var s = this.w.globals.dom.baseEl;
                s && this.ctx.eventList.forEach(function(t) {
                    s.removeEventListener(t, e.ctx.events.documentEvent);
                });
                var r = this.w.globals.dom;
                if (null !== this.ctx.el) for(; this.ctx.el.firstChild;)this.ctx.el.removeChild(this.ctx.el.firstChild);
                this.killSVG(r.Paper), r.Paper.remove(), r.elWrap = null, r.elGraphical = null, r.elLegendWrap = null, r.elLegendForeign = null, r.baseEl = null, r.elGridRect = null, r.elGridRectMask = null, r.elGridRectMarkerMask = null, r.elForecastMask = null, r.elNonForecastMask = null, r.elDefs = null;
            }
        }
    ]), t;
}(), $fffa43d1c55f0813$var$jt = new WeakMap;
var $fffa43d1c55f0813$var$_t = function() {
    function t(e, i) {
        $fffa43d1c55f0813$var$a(this, t), this.opts = i, this.ctx = this, this.w = new $fffa43d1c55f0813$var$F(i).init(), this.el = e, this.w.globals.cuid = $fffa43d1c55f0813$var$x.randomId(), this.w.globals.chartID = this.w.config.chart.id ? $fffa43d1c55f0813$var$x.escapeString(this.w.config.chart.id) : this.w.globals.cuid, new $fffa43d1c55f0813$var$Gt(this).initModules(), this.create = $fffa43d1c55f0813$var$x.bind(this.create, this), this.windowResizeHandler = this._windowResizeHandler.bind(this), this.parentResizeHandler = this._parentResizeCallback.bind(this);
    }
    return $fffa43d1c55f0813$var$r(t, [
        {
            key: "render",
            value: function() {
                var t = this;
                return new Promise(function(e, i) {
                    if (null !== t.el) {
                        void 0 === Apex._chartInstances && (Apex._chartInstances = []), t.w.config.chart.id && Apex._chartInstances.push({
                            id: t.w.globals.chartID,
                            group: t.w.config.chart.group,
                            chart: t
                        }), t.setLocale(t.w.config.chart.defaultLocale);
                        var a = t.w.config.chart.events.beforeMount;
                        if ("function" == typeof a && a(t, t.w), t.events.fireEvent("beforeMount", [
                            t,
                            t.w
                        ]), window.addEventListener("resize", t.windowResizeHandler), function(t, e) {
                            var i = !1;
                            if (t.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
                                var a = t.getBoundingClientRect();
                                "none" !== t.style.display && 0 !== a.width || (i = !0);
                            }
                            var s = new ResizeObserver(function(a) {
                                i && e.call(t, a), i = !0;
                            });
                            t.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? Array.from(t.children).forEach(function(t) {
                                return s.observe(t);
                            }) : s.observe(t), $fffa43d1c55f0813$var$jt.set(e, s);
                        }(t.el.parentNode, t.parentResizeHandler), !t.css) {
                            var s = t.el.getRootNode && t.el.getRootNode(), r = $fffa43d1c55f0813$var$x.is("ShadowRoot", s), o = t.el.ownerDocument, n = o.getElementById("apexcharts-css");
                            if (r || !n) {
                                var l;
                                t.css = document.createElement("style"), t.css.id = "apexcharts-css", t.css.textContent = '@keyframes opaque {\n  0% {\n      opacity: 0\n  }\n\n  to {\n      opacity: 1\n  }\n}\n\n@keyframes resizeanim {\n  0%,to {\n      opacity: 0\n  }\n}\n\n.apexcharts-canvas {\n  position: relative;\n  user-select: none\n}\n\n.apexcharts-canvas ::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 6px\n}\n\n.apexcharts-canvas ::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background-color: rgba(0,0,0,.5);\n  box-shadow: 0 0 1px rgba(255,255,255,.5);\n  -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5)\n}\n\n.apexcharts-inner {\n  position: relative\n}\n\n.apexcharts-text tspan {\n  font-family: inherit\n}\n\n.legend-mouseover-inactive {\n  transition: .15s ease all;\n  opacity: .2\n}\n\n.apexcharts-legend-text {\n  padding-left: 15px;\n  margin-left: -15px;\n}\n\n.apexcharts-series-collapsed {\n  opacity: 0\n}\n\n.apexcharts-tooltip {\n  border-radius: 5px;\n  box-shadow: 2px 2px 6px -4px #999;\n  cursor: default;\n  font-size: 14px;\n  left: 62px;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 20px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  white-space: nowrap;\n  z-index: 12;\n  transition: .15s ease all\n}\n\n.apexcharts-tooltip.apexcharts-active {\n  opacity: 1;\n  transition: .15s ease all\n}\n\n.apexcharts-tooltip.apexcharts-theme-light {\n  border: 1px solid #e3e3e3;\n  background: rgba(255,255,255,.96)\n}\n\n.apexcharts-tooltip.apexcharts-theme-dark {\n  color: #fff;\n  background: rgba(30,30,30,.8)\n}\n\n.apexcharts-tooltip * {\n  font-family: inherit\n}\n\n.apexcharts-tooltip-title {\n  padding: 6px;\n  font-size: 15px;\n  margin-bottom: 4px\n}\n\n.apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {\n  background: #eceff1;\n  border-bottom: 1px solid #ddd\n}\n\n.apexcharts-tooltip.apexcharts-theme-dark .apexcharts-tooltip-title {\n  background: rgba(0,0,0,.7);\n  border-bottom: 1px solid #333\n}\n\n.apexcharts-tooltip-text-goals-value,.apexcharts-tooltip-text-y-value,.apexcharts-tooltip-text-z-value {\n  display: inline-block;\n  margin-left: 5px;\n  font-weight: 600\n}\n\n.apexcharts-tooltip-text-goals-label:empty,.apexcharts-tooltip-text-goals-value:empty,.apexcharts-tooltip-text-y-label:empty,.apexcharts-tooltip-text-y-value:empty,.apexcharts-tooltip-text-z-value:empty,.apexcharts-tooltip-title:empty {\n  display: none\n}\n\n.apexcharts-tooltip-text-goals-label,.apexcharts-tooltip-text-goals-value {\n  padding: 6px 0 5px\n}\n\n.apexcharts-tooltip-goals-group,.apexcharts-tooltip-text-goals-label,.apexcharts-tooltip-text-goals-value {\n  display: flex\n}\n\n.apexcharts-tooltip-text-goals-label:not(:empty),.apexcharts-tooltip-text-goals-value:not(:empty) {\n  margin-top: -6px\n}\n\n.apexcharts-tooltip-marker {\n  width: 12px;\n  height: 12px;\n  position: relative;\n  top: 0;\n  margin-right: 10px;\n  border-radius: 50%\n}\n\n.apexcharts-tooltip-series-group {\n  padding: 0 10px;\n  display: none;\n  text-align: left;\n  justify-content: left;\n  align-items: center\n}\n\n.apexcharts-tooltip-series-group.apexcharts-active .apexcharts-tooltip-marker {\n  opacity: 1\n}\n\n.apexcharts-tooltip-series-group.apexcharts-active,.apexcharts-tooltip-series-group:last-child {\n  padding-bottom: 4px\n}\n\n.apexcharts-tooltip-series-group-hidden {\n  opacity: 0;\n  height: 0;\n  line-height: 0;\n  padding: 0!important\n}\n\n.apexcharts-tooltip-y-group {\n  padding: 6px 0 5px\n}\n\n.apexcharts-custom-tooltip,.apexcharts-tooltip-box {\n  padding: 4px 8px\n}\n\n.apexcharts-tooltip-boxPlot {\n  display: flex;\n  flex-direction: column-reverse\n}\n\n.apexcharts-tooltip-box>div {\n  margin: 4px 0\n}\n\n.apexcharts-tooltip-box span.value {\n  font-weight: 700\n}\n\n.apexcharts-tooltip-rangebar {\n  padding: 5px 8px\n}\n\n.apexcharts-tooltip-rangebar .category {\n  font-weight: 600;\n  color: #777\n}\n\n.apexcharts-tooltip-rangebar .series-name {\n  font-weight: 700;\n  display: block;\n  margin-bottom: 5px\n}\n\n.apexcharts-xaxistooltip,.apexcharts-yaxistooltip {\n  opacity: 0;\n  pointer-events: none;\n  color: #373d3f;\n  font-size: 13px;\n  text-align: center;\n  border-radius: 2px;\n  position: absolute;\n  z-index: 10;\n  background: #eceff1;\n  border: 1px solid #90a4ae\n}\n\n.apexcharts-xaxistooltip {\n  padding: 9px 10px;\n  transition: .15s ease all\n}\n\n.apexcharts-xaxistooltip.apexcharts-theme-dark {\n  background: rgba(0,0,0,.7);\n  border: 1px solid rgba(0,0,0,.5);\n  color: #fff\n}\n\n.apexcharts-xaxistooltip:after,.apexcharts-xaxistooltip:before {\n  left: 50%;\n  border: solid transparent;\n  content: " ";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none\n}\n\n.apexcharts-xaxistooltip:after {\n  border-color: transparent;\n  border-width: 6px;\n  margin-left: -6px\n}\n\n.apexcharts-xaxistooltip:before {\n  border-color: transparent;\n  border-width: 7px;\n  margin-left: -7px\n}\n\n.apexcharts-xaxistooltip-bottom:after,.apexcharts-xaxistooltip-bottom:before {\n  bottom: 100%\n}\n\n.apexcharts-xaxistooltip-top:after,.apexcharts-xaxistooltip-top:before {\n  top: 100%\n}\n\n.apexcharts-xaxistooltip-bottom:after {\n  border-bottom-color: #eceff1\n}\n\n.apexcharts-xaxistooltip-bottom:before {\n  border-bottom-color: #90a4ae\n}\n\n.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:after,.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:before {\n  border-bottom-color: rgba(0,0,0,.5)\n}\n\n.apexcharts-xaxistooltip-top:after {\n  border-top-color: #eceff1\n}\n\n.apexcharts-xaxistooltip-top:before {\n  border-top-color: #90a4ae\n}\n\n.apexcharts-xaxistooltip-top.apexcharts-theme-dark:after,.apexcharts-xaxistooltip-top.apexcharts-theme-dark:before {\n  border-top-color: rgba(0,0,0,.5)\n}\n\n.apexcharts-xaxistooltip.apexcharts-active {\n  opacity: 1;\n  transition: .15s ease all\n}\n\n.apexcharts-yaxistooltip {\n  padding: 4px 10px\n}\n\n.apexcharts-yaxistooltip.apexcharts-theme-dark {\n  background: rgba(0,0,0,.7);\n  border: 1px solid rgba(0,0,0,.5);\n  color: #fff\n}\n\n.apexcharts-yaxistooltip:after,.apexcharts-yaxistooltip:before {\n  top: 50%;\n  border: solid transparent;\n  content: " ";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none\n}\n\n.apexcharts-yaxistooltip:after {\n  border-color: transparent;\n  border-width: 6px;\n  margin-top: -6px\n}\n\n.apexcharts-yaxistooltip:before {\n  border-color: transparent;\n  border-width: 7px;\n  margin-top: -7px\n}\n\n.apexcharts-yaxistooltip-left:after,.apexcharts-yaxistooltip-left:before {\n  left: 100%\n}\n\n.apexcharts-yaxistooltip-right:after,.apexcharts-yaxistooltip-right:before {\n  right: 100%\n}\n\n.apexcharts-yaxistooltip-left:after {\n  border-left-color: #eceff1\n}\n\n.apexcharts-yaxistooltip-left:before {\n  border-left-color: #90a4ae\n}\n\n.apexcharts-yaxistooltip-left.apexcharts-theme-dark:after,.apexcharts-yaxistooltip-left.apexcharts-theme-dark:before {\n  border-left-color: rgba(0,0,0,.5)\n}\n\n.apexcharts-yaxistooltip-right:after {\n  border-right-color: #eceff1\n}\n\n.apexcharts-yaxistooltip-right:before {\n  border-right-color: #90a4ae\n}\n\n.apexcharts-yaxistooltip-right.apexcharts-theme-dark:after,.apexcharts-yaxistooltip-right.apexcharts-theme-dark:before {\n  border-right-color: rgba(0,0,0,.5)\n}\n\n.apexcharts-yaxistooltip.apexcharts-active {\n  opacity: 1\n}\n\n.apexcharts-yaxistooltip-hidden {\n  display: none\n}\n\n.apexcharts-xcrosshairs,.apexcharts-ycrosshairs {\n  pointer-events: none;\n  opacity: 0;\n  transition: .15s ease all\n}\n\n.apexcharts-xcrosshairs.apexcharts-active,.apexcharts-ycrosshairs.apexcharts-active {\n  opacity: 1;\n  transition: .15s ease all\n}\n\n.apexcharts-ycrosshairs-hidden {\n  opacity: 0\n}\n\n.apexcharts-selection-rect {\n  cursor: move\n}\n\n.svg_select_boundingRect,.svg_select_points_rot {\n  pointer-events: none;\n  opacity: 0;\n  visibility: hidden\n}\n\n.apexcharts-selection-rect+g .svg_select_boundingRect,.apexcharts-selection-rect+g .svg_select_points_rot {\n  opacity: 0;\n  visibility: hidden\n}\n\n.apexcharts-selection-rect+g .svg_select_points_l,.apexcharts-selection-rect+g .svg_select_points_r {\n  cursor: ew-resize;\n  opacity: 1;\n  visibility: visible\n}\n\n.svg_select_points {\n  fill: #efefef;\n  stroke: #333;\n  rx: 2\n}\n\n.apexcharts-svg.apexcharts-zoomable.hovering-zoom {\n  cursor: crosshair\n}\n\n.apexcharts-svg.apexcharts-zoomable.hovering-pan {\n  cursor: move\n}\n\n.apexcharts-menu-icon,.apexcharts-pan-icon,.apexcharts-reset-icon,.apexcharts-selection-icon,.apexcharts-toolbar-custom-icon,.apexcharts-zoom-icon,.apexcharts-zoomin-icon,.apexcharts-zoomout-icon {\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n  line-height: 24px;\n  color: #6e8192;\n  text-align: center\n}\n\n.apexcharts-menu-icon svg,.apexcharts-reset-icon svg,.apexcharts-zoom-icon svg,.apexcharts-zoomin-icon svg,.apexcharts-zoomout-icon svg {\n  fill: #6e8192\n}\n\n.apexcharts-selection-icon svg {\n  fill: #444;\n  transform: scale(.76)\n}\n\n.apexcharts-theme-dark .apexcharts-menu-icon svg,.apexcharts-theme-dark .apexcharts-pan-icon svg,.apexcharts-theme-dark .apexcharts-reset-icon svg,.apexcharts-theme-dark .apexcharts-selection-icon svg,.apexcharts-theme-dark .apexcharts-toolbar-custom-icon svg,.apexcharts-theme-dark .apexcharts-zoom-icon svg,.apexcharts-theme-dark .apexcharts-zoomin-icon svg,.apexcharts-theme-dark .apexcharts-zoomout-icon svg {\n  fill: #f3f4f5\n}\n\n.apexcharts-canvas .apexcharts-reset-zoom-icon.apexcharts-selected svg,.apexcharts-canvas .apexcharts-selection-icon.apexcharts-selected svg,.apexcharts-canvas .apexcharts-zoom-icon.apexcharts-selected svg {\n  fill: #008ffb\n}\n\n.apexcharts-theme-light .apexcharts-menu-icon:hover svg,.apexcharts-theme-light .apexcharts-reset-icon:hover svg,.apexcharts-theme-light .apexcharts-selection-icon:not(.apexcharts-selected):hover svg,.apexcharts-theme-light .apexcharts-zoom-icon:not(.apexcharts-selected):hover svg,.apexcharts-theme-light .apexcharts-zoomin-icon:hover svg,.apexcharts-theme-light .apexcharts-zoomout-icon:hover svg {\n  fill: #333\n}\n\n.apexcharts-menu-icon,.apexcharts-selection-icon {\n  position: relative\n}\n\n.apexcharts-reset-icon {\n  margin-left: 5px\n}\n\n.apexcharts-menu-icon,.apexcharts-reset-icon,.apexcharts-zoom-icon {\n  transform: scale(.85)\n}\n\n.apexcharts-zoomin-icon,.apexcharts-zoomout-icon {\n  transform: scale(.7)\n}\n\n.apexcharts-zoomout-icon {\n  margin-right: 3px\n}\n\n.apexcharts-pan-icon {\n  transform: scale(.62);\n  position: relative;\n  left: 1px;\n  top: 0\n}\n\n.apexcharts-pan-icon svg {\n  fill: #fff;\n  stroke: #6e8192;\n  stroke-width: 2\n}\n\n.apexcharts-pan-icon.apexcharts-selected svg {\n  stroke: #008ffb\n}\n\n.apexcharts-pan-icon:not(.apexcharts-selected):hover svg {\n  stroke: #333\n}\n\n.apexcharts-toolbar {\n  position: absolute;\n  z-index: 11;\n  max-width: 176px;\n  text-align: right;\n  border-radius: 3px;\n  padding: 0 6px 2px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center\n}\n\n.apexcharts-menu {\n  background: #fff;\n  position: absolute;\n  top: 100%;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 3px;\n  right: 10px;\n  opacity: 0;\n  min-width: 110px;\n  transition: .15s ease all;\n  pointer-events: none\n}\n\n.apexcharts-menu.apexcharts-menu-open {\n  opacity: 1;\n  pointer-events: all;\n  transition: .15s ease all\n}\n\n.apexcharts-menu-item {\n  padding: 6px 7px;\n  font-size: 12px;\n  cursor: pointer\n}\n\n.apexcharts-theme-light .apexcharts-menu-item:hover {\n  background: #eee\n}\n\n.apexcharts-theme-dark .apexcharts-menu {\n  background: rgba(0,0,0,.7);\n  color: #fff\n}\n\n@media screen and (min-width:768px) {\n  .apexcharts-canvas:hover .apexcharts-toolbar {\n      opacity: 1\n  }\n}\n\n.apexcharts-canvas .apexcharts-element-hidden,.apexcharts-datalabel.apexcharts-element-hidden,.apexcharts-hide .apexcharts-series-points {\n  opacity: 0\n}\n\n.apexcharts-hidden-element-shown {\n  opacity: 1;\n  transition: 0.25s ease all;\n}\n.apexcharts-datalabel,.apexcharts-datalabel-label,.apexcharts-datalabel-value,.apexcharts-datalabels,.apexcharts-pie-label {\n  cursor: default;\n  pointer-events: none\n}\n\n.apexcharts-pie-label-delay {\n  opacity: 0;\n  animation-name: opaque;\n  animation-duration: .3s;\n  animation-fill-mode: forwards;\n  animation-timing-function: ease\n}\n\n.apexcharts-radialbar-label {\n  cursor: pointer;\n}\n\n.apexcharts-annotation-rect,.apexcharts-area-series .apexcharts-area,.apexcharts-area-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,.apexcharts-gridline,.apexcharts-line,.apexcharts-line-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,.apexcharts-point-annotation-label,.apexcharts-radar-series path,.apexcharts-radar-series polygon,.apexcharts-toolbar svg,.apexcharts-tooltip .apexcharts-marker,.apexcharts-xaxis-annotation-label,.apexcharts-yaxis-annotation-label,.apexcharts-zoom-rect {\n  pointer-events: none\n}\n\n.apexcharts-marker {\n  transition: .15s ease all\n}\n\n.resize-triggers {\n  animation: 1ms resizeanim;\n  visibility: hidden;\n  opacity: 0;\n  height: 100%;\n  width: 100%;\n  overflow: hidden\n}\n\n.contract-trigger:before,.resize-triggers,.resize-triggers>div {\n  content: " ";\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0\n}\n\n.resize-triggers>div {\n  height: 100%;\n  width: 100%;\n  background: #eee;\n  overflow: auto\n}\n\n.contract-trigger:before {\n  overflow: hidden;\n  width: 200%;\n  height: 200%\n}\n\n.apexcharts-bar-goals-markers{\n  pointer-events: none\n}\n\n.apexcharts-bar-shadows{\n  pointer-events: none\n}\n\n.apexcharts-rangebar-goals-markers{\n  pointer-events: none\n}';
                                var h = (null === (l = t.opts.chart) || void 0 === l ? void 0 : l.nonce) || t.w.config.chart.nonce;
                                h && t.css.setAttribute("nonce", h), r ? s.prepend(t.css) : o.head.appendChild(t.css);
                            }
                        }
                        var c = t.create(t.w.config.series, {});
                        if (!c) return e(t);
                        t.mount(c).then(function() {
                            "function" == typeof t.w.config.chart.events.mounted && t.w.config.chart.events.mounted(t, t.w), t.events.fireEvent("mounted", [
                                t,
                                t.w
                            ]), e(c);
                        }).catch(function(t) {
                            i(t);
                        });
                    } else i(new Error("Element not found"));
                });
            }
        },
        {
            key: "create",
            value: function(t, e) {
                var i = this.w;
                new $fffa43d1c55f0813$var$Gt(this).initModules();
                var a = this.w.globals;
                (a.noData = !1, a.animationEnded = !1, this.responsive.checkResponsiveConfig(e), i.config.xaxis.convertedCatToNumeric) && new $fffa43d1c55f0813$var$X(i.config).convertCatToNumericXaxis(i.config, this.ctx);
                if (null === this.el) return a.animationEnded = !0, null;
                if (this.core.setupElements(), "treemap" === i.config.chart.type && (i.config.grid.show = !1, i.config.yaxis[0].show = !1), 0 === a.svgWidth) return a.animationEnded = !0, null;
                var s = $fffa43d1c55f0813$var$y.checkComboSeries(t);
                a.comboCharts = s.comboCharts, a.comboBarCount = s.comboBarCount;
                var r = t.every(function(t) {
                    return t.data && 0 === t.data.length;
                });
                (0 === t.length || r) && this.series.handleNoData(), this.events.setupEventHandlers(), this.data.parseData(t), this.theme.init(), new $fffa43d1c55f0813$var$H(this).setGlobalMarkerSize(), this.formatters.setLabelFormatters(), this.titleSubtitle.draw(), a.noData && a.collapsedSeries.length !== a.series.length && !i.config.legend.showForSingleSeries || this.legend.init(), this.series.hasAllSeriesEqualX(), a.axisCharts && (this.core.coreCalculations(), "category" !== i.config.xaxis.type && this.formatters.setLabelFormatters(), this.ctx.toolbar.minX = i.globals.minX, this.ctx.toolbar.maxX = i.globals.maxX), this.formatters.heatmapLabelFormatters(), new $fffa43d1c55f0813$var$y(this).getLargestMarkerSize(), this.dimensions.plotCoords();
                var o = this.core.xySettings();
                this.grid.createGridMask();
                var n = this.core.plotChartType(t, o), l = new $fffa43d1c55f0813$var$O(this);
                return l.bringForward(), i.config.dataLabels.background.enabled && l.dataLabelsBackground(), this.core.shiftGraphPosition(), {
                    elGraph: n,
                    xyRatios: o,
                    dimensions: {
                        plot: {
                            left: i.globals.translateX,
                            top: i.globals.translateY,
                            width: i.globals.gridWidth,
                            height: i.globals.gridHeight
                        }
                    }
                };
            }
        },
        {
            key: "mount",
            value: function() {
                var t = this, e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, i = this, a = i.w;
                return new Promise(function(s, r) {
                    if (null === i.el) return r(new Error("Not enough data to display or target element not found"));
                    (null === e || a.globals.allSeriesCollapsed) && i.series.handleNoData(), i.grid = new $fffa43d1c55f0813$var$j(i);
                    var o, n, l = i.grid.drawGrid();
                    (i.annotations = new $fffa43d1c55f0813$var$P(i), i.annotations.drawImageAnnos(), i.annotations.drawTextAnnos(), "back" === a.config.grid.position) && (l && a.globals.dom.elGraphical.add(l.el), null != l && null !== (o = l.elGridBorders) && void 0 !== o && o.node && a.globals.dom.elGraphical.add(l.elGridBorders));
                    if (Array.isArray(e.elGraph)) for(var h = 0; h < e.elGraph.length; h++)a.globals.dom.elGraphical.add(e.elGraph[h]);
                    else a.globals.dom.elGraphical.add(e.elGraph);
                    "front" === a.config.grid.position && (l && a.globals.dom.elGraphical.add(l.el), null != l && null !== (n = l.elGridBorders) && void 0 !== n && n.node && a.globals.dom.elGraphical.add(l.elGridBorders));
                    "front" === a.config.xaxis.crosshairs.position && i.crosshairs.drawXCrosshairs(), "front" === a.config.yaxis[0].crosshairs.position && i.crosshairs.drawYCrosshairs(), "treemap" !== a.config.chart.type && i.axes.drawAxis(a.config.chart.type, l);
                    var c = new $fffa43d1c55f0813$var$V(t.ctx, l), d = new $fffa43d1c55f0813$var$q(t.ctx, l);
                    if (null !== l && (c.xAxisLabelCorrections(l.xAxisTickWidth), d.setYAxisTextAlignments(), a.config.yaxis.map(function(t, e) {
                        -1 === a.globals.ignoreYAxisIndexes.indexOf(e) && d.yAxisTitleRotate(e, t.opposite);
                    })), i.annotations.drawAxesAnnotations(), !a.globals.noData) {
                        if (a.config.tooltip.enabled && !a.globals.noData && i.w.globals.tooltip.drawTooltip(e.xyRatios), a.globals.axisCharts && (a.globals.isXNumeric || a.config.xaxis.convertedCatToNumeric || a.globals.isRangeBar)) (a.config.chart.zoom.enabled || a.config.chart.selection && a.config.chart.selection.enabled || a.config.chart.pan && a.config.chart.pan.enabled) && i.zoomPanSelection.init({
                            xyRatios: e.xyRatios
                        });
                        else {
                            var g = a.config.chart.toolbar.tools;
                            [
                                "zoom",
                                "zoomin",
                                "zoomout",
                                "selection",
                                "pan",
                                "reset"
                            ].forEach(function(t) {
                                g[t] = !1;
                            });
                        }
                        a.config.chart.toolbar.show && !a.globals.allSeriesCollapsed && i.toolbar.createToolbar();
                    }
                    a.globals.memory.methodsToExec.length > 0 && a.globals.memory.methodsToExec.forEach(function(t) {
                        t.method(t.params, !1, t.context);
                    }), a.globals.axisCharts || a.globals.noData || i.core.resizeNonAxisCharts(), s(i);
                });
            }
        },
        {
            key: "destroy",
            value: function() {
                var t, e;
                window.removeEventListener("resize", this.windowResizeHandler), this.el.parentNode, t = this.parentResizeHandler, (e = $fffa43d1c55f0813$var$jt.get(t)) && (e.disconnect(), $fffa43d1c55f0813$var$jt.delete(t));
                var i = this.w.config.chart.id;
                i && Apex._chartInstances.forEach(function(t, e) {
                    t.id === $fffa43d1c55f0813$var$x.escapeString(i) && Apex._chartInstances.splice(e, 1);
                }), new $fffa43d1c55f0813$var$Vt(this.ctx).clear({
                    isUpdating: !1
                });
            }
        },
        {
            key: "updateOptions",
            value: function(t) {
                var e = this, i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], a = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], s = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3], r = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4], o = this.w;
                return o.globals.selection = void 0, t.series && (this.series.resetSeries(!1, !0, !1), t.series.length && t.series[0].data && (t.series = t.series.map(function(t, i) {
                    return e.updateHelpers._extendSeries(t, i);
                })), this.updateHelpers.revertDefaultAxisMinMax()), t.xaxis && (t = this.updateHelpers.forceXAxisUpdate(t)), t.yaxis && (t = this.updateHelpers.forceYAxisUpdate(t)), o.globals.collapsedSeriesIndices.length > 0 && this.series.clearPreviousPaths(), t.theme && (t = this.theme.updateThemeOptions(t)), this.updateHelpers._updateOptions(t, i, a, s, r);
            }
        },
        {
            key: "updateSeries",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                return this.series.resetSeries(!1), this.updateHelpers.revertDefaultAxisMinMax(), this.updateHelpers._updateSeries(t, e, i);
            }
        },
        {
            key: "appendSeries",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], a = this.w.config.series.slice();
                return a.push(t), this.series.resetSeries(!1), this.updateHelpers.revertDefaultAxisMinMax(), this.updateHelpers._updateSeries(a, e, i);
            }
        },
        {
            key: "appendData",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = this;
                i.w.globals.dataChanged = !0, i.series.getPreviousPaths();
                for(var a = i.w.config.series.slice(), s = 0; s < a.length; s++)if (null !== t[s] && void 0 !== t[s]) for(var r = 0; r < t[s].data.length; r++)a[s].data.push(t[s].data[r]);
                return i.w.config.series = a, e && (i.w.globals.initialSeries = $fffa43d1c55f0813$var$x.clone(i.w.config.series)), this.update();
            }
        },
        {
            key: "update",
            value: function(t) {
                var e = this;
                return new Promise(function(i, a) {
                    new $fffa43d1c55f0813$var$Vt(e.ctx).clear({
                        isUpdating: !0
                    });
                    var s = e.create(e.w.config.series, t);
                    if (!s) return i(e);
                    e.mount(s).then(function() {
                        "function" == typeof e.w.config.chart.events.updated && e.w.config.chart.events.updated(e, e.w), e.events.fireEvent("updated", [
                            e,
                            e.w
                        ]), e.w.globals.isDirty = !0, i(e);
                    }).catch(function(t) {
                        a(t);
                    });
                });
            }
        },
        {
            key: "getSyncedCharts",
            value: function() {
                var t = this.getGroupedCharts(), e = [
                    this
                ];
                return t.length && (e = [], t.forEach(function(t) {
                    e.push(t);
                })), e;
            }
        },
        {
            key: "getGroupedCharts",
            value: function() {
                var t = this;
                return Apex._chartInstances.filter(function(t) {
                    if (t.group) return !0;
                }).map(function(e) {
                    return t.w.config.chart.group === e.group ? e.chart : t;
                });
            }
        },
        {
            key: "toggleSeries",
            value: function(t) {
                return this.series.toggleSeries(t);
            }
        },
        {
            key: "highlightSeriesOnLegendHover",
            value: function(t, e) {
                return this.series.toggleSeriesOnHover(t, e);
            }
        },
        {
            key: "showSeries",
            value: function(t) {
                this.series.showSeries(t);
            }
        },
        {
            key: "hideSeries",
            value: function(t) {
                this.series.hideSeries(t);
            }
        },
        {
            key: "isSeriesHidden",
            value: function(t) {
                this.series.isSeriesHidden(t);
            }
        },
        {
            key: "resetSeries",
            value: function() {
                var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                this.series.resetSeries(t, e);
            }
        },
        {
            key: "addEventListener",
            value: function(t, e) {
                this.events.addEventListener(t, e);
            }
        },
        {
            key: "removeEventListener",
            value: function(t, e) {
                this.events.removeEventListener(t, e);
            }
        },
        {
            key: "addXaxisAnnotation",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, a = this;
                i && (a = i), a.annotations.addXaxisAnnotationExternal(t, e, a);
            }
        },
        {
            key: "addYaxisAnnotation",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, a = this;
                i && (a = i), a.annotations.addYaxisAnnotationExternal(t, e, a);
            }
        },
        {
            key: "addPointAnnotation",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, a = this;
                i && (a = i), a.annotations.addPointAnnotationExternal(t, e, a);
            }
        },
        {
            key: "clearAnnotations",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, e = this;
                t && (e = t), e.annotations.clearAnnotations(e);
            }
        },
        {
            key: "removeAnnotation",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0, i = this;
                e && (i = e), i.annotations.removeAnnotation(i, t);
            }
        },
        {
            key: "getChartArea",
            value: function() {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner");
            }
        },
        {
            key: "getSeriesTotalXRange",
            value: function(t, e) {
                return this.coreUtils.getSeriesTotalsXRange(t, e);
            }
        },
        {
            key: "getHighestValueInSeries",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                return new $fffa43d1c55f0813$var$U(this.ctx).getMinYMaxY(t).highestY;
            }
        },
        {
            key: "getLowestValueInSeries",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                return new $fffa43d1c55f0813$var$U(this.ctx).getMinYMaxY(t).lowestY;
            }
        },
        {
            key: "getSeriesTotal",
            value: function() {
                return this.w.globals.seriesTotals;
            }
        },
        {
            key: "toggleDataPointSelection",
            value: function(t, e) {
                return this.updateHelpers.toggleDataPointSelection(t, e);
            }
        },
        {
            key: "zoomX",
            value: function(t, e) {
                this.ctx.toolbar.zoomUpdateOptions(t, e);
            }
        },
        {
            key: "setLocale",
            value: function(t) {
                this.localization.setCurrentLocaleValues(t);
            }
        },
        {
            key: "dataURI",
            value: function(t) {
                return new $fffa43d1c55f0813$var$G(this.ctx).dataURI(t);
            }
        },
        {
            key: "exportToCSV",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return new $fffa43d1c55f0813$var$G(this.ctx).exportToCSV(t);
            }
        },
        {
            key: "paper",
            value: function() {
                return this.w.globals.dom.Paper;
            }
        },
        {
            key: "_parentResizeCallback",
            value: function() {
                this.w.globals.animationEnded && this.w.config.chart.redrawOnParentResize && this._windowResize();
            }
        },
        {
            key: "_windowResize",
            value: function() {
                var t = this;
                clearTimeout(this.w.globals.resizeTimer), this.w.globals.resizeTimer = window.setTimeout(function() {
                    t.w.globals.resized = !0, t.w.globals.dataChanged = !1, t.ctx.update();
                }, 150);
            }
        },
        {
            key: "_windowResizeHandler",
            value: function() {
                var t = this.w.config.chart.redrawOnWindowResize;
                "function" == typeof t && (t = t()), t && this._windowResize();
            }
        }
    ], [
        {
            key: "getChartByID",
            value: function(t) {
                var e = $fffa43d1c55f0813$var$x.escapeString(t);
                if (Apex._chartInstances) {
                    var i = Apex._chartInstances.filter(function(t) {
                        return t.id === e;
                    })[0];
                    return i && i.chart;
                }
            }
        },
        {
            key: "initOnLoad",
            value: function() {
                for(var e = document.querySelectorAll("[data-apexcharts]"), i = 0; i < e.length; i++)new t(e[i], JSON.parse(e[i].getAttribute("data-options"))).render();
            }
        },
        {
            key: "exec",
            value: function(t, e) {
                var i = this.getChartByID(t);
                if (i) {
                    i.w.globals.isExecCalled = !0;
                    var a = null;
                    if (-1 !== i.publicMethods.indexOf(e)) {
                        for(var s = arguments.length, r = new Array(s > 2 ? s - 2 : 0), o = 2; o < s; o++)r[o - 2] = arguments[o];
                        a = i[e].apply(i, r);
                    }
                    return a;
                }
            }
        },
        {
            key: "merge",
            value: function(t, e) {
                return $fffa43d1c55f0813$var$x.extend(t, e);
            }
        }
    ]), t;
}();
$fffa43d1c55f0813$exports = $fffa43d1c55f0813$var$_t;


var $93d6258b67061950$var$_apexcharts2 = $93d6258b67061950$var$_interopRequireDefault($fffa43d1c55f0813$exports);

var $2xPiy = parcelRequire("2xPiy");
var $93d6258b67061950$var$_react2 = $93d6258b67061950$var$_interopRequireDefault($2xPiy);

var $dyr1f = parcelRequire("dyr1f");
var $93d6258b67061950$var$_propTypes2 = $93d6258b67061950$var$_interopRequireDefault($dyr1f);
function $93d6258b67061950$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $93d6258b67061950$var$_defineProperty(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = r, e;
}
function $93d6258b67061950$var$_objectWithoutProperties(e, t) {
    var r, n = {};
    for(r in e)0 <= t.indexOf(r) || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
    return n;
}
function $93d6258b67061950$var$_classCallCheck(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function $93d6258b67061950$var$_possibleConstructorReturn(e, t) {
    if (e) return !t || "object" != typeof t && "function" != typeof t ? e : t;
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
}
function $93d6258b67061950$var$_inherits(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
        constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
        }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
window.ApexCharts = $93d6258b67061950$var$_apexcharts2.default;
var $93d6258b67061950$var$Charts = function() {
    function r(e) {
        $93d6258b67061950$var$_classCallCheck(this, r);
        var t = $93d6258b67061950$var$_possibleConstructorReturn(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this, e));
        return $93d6258b67061950$var$_react2.default.createRef ? t.chartRef = $93d6258b67061950$var$_react2.default.createRef() : t.setRef = function(e) {
            return t.chartRef = e;
        }, t.chart = null, t;
    }
    return $93d6258b67061950$var$_inherits(r, $2xPiy.Component), $93d6258b67061950$var$_createClass(r, [
        {
            key: "render",
            value: function() {
                var e = $93d6258b67061950$var$_objectWithoutProperties(this.props, []);
                return $93d6258b67061950$var$_react2.default.createElement("div", $93d6258b67061950$var$_extends({
                    ref: $93d6258b67061950$var$_react2.default.createRef ? this.chartRef : this.setRef
                }, e));
            }
        },
        {
            key: "componentDidMount",
            value: function() {
                var e = $93d6258b67061950$var$_react2.default.createRef ? this.chartRef.current : this.chartRef;
                this.chart = new $93d6258b67061950$var$_apexcharts2.default(e, this.getConfig()), this.chart.render();
            }
        },
        {
            key: "getConfig",
            value: function() {
                var e = this.props, t = e.type, r = e.height, n = e.width, o = e.series, e = e.options;
                return this.extend(e, {
                    chart: {
                        type: t,
                        height: r,
                        width: n
                    },
                    series: o
                });
            }
        },
        {
            key: "isObject",
            value: function(e) {
                return e && "object" === (void 0 === e ? "undefined" : $93d6258b67061950$var$_typeof(e)) && !Array.isArray(e) && null != e;
            }
        },
        {
            key: "extend",
            value: function(t, r) {
                var n = this, o = ("function" != typeof Object.assign && (Object.assign = function(e) {
                    if (null == e) throw new TypeError("Cannot convert undefined or null to object");
                    for(var t = Object(e), r = 1; r < arguments.length; r++){
                        var n = arguments[r];
                        if (null != n) for(var o in n)n.hasOwnProperty(o) && (t[o] = n[o]);
                    }
                    return t;
                }), Object.assign({}, t));
                return this.isObject(t) && this.isObject(r) && Object.keys(r).forEach(function(e) {
                    n.isObject(r[e]) && e in t ? o[e] = n.extend(t[e], r[e]) : Object.assign(o, $93d6258b67061950$var$_defineProperty({}, e, r[e]));
                }), o;
            }
        },
        {
            key: "componentDidUpdate",
            value: function(e) {
                if (!this.chart) return null;
                var t = this.props, r = t.options, n = t.series, o = t.height, t = t.width, i = JSON.stringify(e.options), a = JSON.stringify(e.series), r = JSON.stringify(r), s = JSON.stringify(n);
                i === r && a === s && o === e.height && t === e.width || (a !== s && i === r && o === e.height && t === e.width ? this.chart.updateSeries(n) : this.chart.updateOptions(this.getConfig()));
            }
        },
        {
            key: "componentWillUnmount",
            value: function() {
                this.chart && "function" == typeof this.chart.destroy && this.chart.destroy();
            }
        }
    ]), r;
}();
($93d6258b67061950$exports.default = $93d6258b67061950$var$Charts).propTypes = {
    type: $93d6258b67061950$var$_propTypes2.default.string.isRequired,
    width: $93d6258b67061950$var$_propTypes2.default.oneOfType([
        $93d6258b67061950$var$_propTypes2.default.string,
        $93d6258b67061950$var$_propTypes2.default.number
    ]),
    height: $93d6258b67061950$var$_propTypes2.default.oneOfType([
        $93d6258b67061950$var$_propTypes2.default.string,
        $93d6258b67061950$var$_propTypes2.default.number
    ]),
    series: $93d6258b67061950$var$_propTypes2.default.array.isRequired,
    options: $93d6258b67061950$var$_propTypes2.default.object.isRequired
}, $93d6258b67061950$var$Charts.defaultProps = {
    type: "line",
    width: "100%",
    height: "auto"
};







var $2xPiy = parcelRequire("2xPiy");

function $1721736c3a136fd2$var$_extends() {
    return $1721736c3a136fd2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1721736c3a136fd2$var$_extends.apply(null, arguments);
}
var $1721736c3a136fd2$export$c22d792887f3cb87 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $1721736c3a136fd2$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CaretDownFill"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        d: "M18 9H6l6 6 6-6z",
        fill: "#000"
    }));
});
$1721736c3a136fd2$export$c22d792887f3cb87.displayName = 'CaretDownFill';


var $2xPiy = parcelRequire("2xPiy");

function $5ac95831a9324798$var$_extends() {
    return $5ac95831a9324798$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5ac95831a9324798$var$_extends.apply(null, arguments);
}
var $5ac95831a9324798$export$cb86d8fdcb9f94b5 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $5ac95831a9324798$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CaretUpFill"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        d: "M6 15h12l-6-6-6 6z",
        fill: "#000"
    }));
});
$5ac95831a9324798$export$cb86d8fdcb9f94b5.displayName = 'CaretUpFill';


var $2xPiy = parcelRequire("2xPiy");

function $2ab90fad418fe2af$var$_extends() {
    return $2ab90fad418fe2af$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2ab90fad418fe2af$var$_extends.apply(null, arguments);
}
var $2ab90fad418fe2af$export$2f4a3096121829b3 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $2ab90fad418fe2af$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Status is okay"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM7 12l4 3 5-7"
    }));
});
$2ab90fad418fe2af$export$2f4a3096121829b3.displayName = 'StatusGood';


var $45e3c754f67e1b77$export$1e511d4a378977f5;
var $45e3c754f67e1b77$export$b2f72e3c920710c0;
var $45e3c754f67e1b77$export$9d812a0de4eabbe3;
var $45e3c754f67e1b77$export$80d376111cc09ad7;
var $45e3c754f67e1b77$export$55ce6f3a06c59543;
var $45e3c754f67e1b77$export$e2253033e6e1df16;
"use strict";
$45e3c754f67e1b77$export$1e511d4a378977f5 = true;
$45e3c754f67e1b77$export$b2f72e3c920710c0 = $45e3c754f67e1b77$export$9d812a0de4eabbe3 = $45e3c754f67e1b77$export$80d376111cc09ad7 = $45e3c754f67e1b77$export$55ce6f3a06c59543 = $45e3c754f67e1b77$export$e2253033e6e1df16 = void 0;

$45e3c754f67e1b77$export$e2253033e6e1df16 = $35181ae64da75991$export$e2253033e6e1df16;
$45e3c754f67e1b77$export$80d376111cc09ad7 = $35181ae64da75991$export$80d376111cc09ad7;
var $12ea83166b26d412$export$1e511d4a378977f5;
var $12ea83166b26d412$export$9d812a0de4eabbe3;
"use strict";
$12ea83166b26d412$export$1e511d4a378977f5 = true;
$12ea83166b26d412$export$9d812a0de4eabbe3 = void 0;

var $iA1nz = parcelRequire("iA1nz");

var $12ea83166b26d412$var$grommet = $12ea83166b26d412$export$9d812a0de4eabbe3 = (0, $ebafa0e8c9355c24$export$7e32b29e1cb162e1)({
    global: {
        colors: {
            background: {
                light: '#ffffff',
                dark: '#000000'
            }
        },
        backgrounds: {
            stack: {
                color: 'light-1',
                image: "url(https://v2.grommet.io/img/stak-hurrah.svg)"
            },
            'gradient-purple-blue': {
                color: 'neutral-3',
                image: "linear-gradient(\n          #3D138D 0%, /* neutral-2 */\n          #00739D 100% /* neutral-3 */\n        );",
                rotate: 145
            },
            'gradient-purple-gold': {
                color: 'neutral-2',
                image: "linear-gradient(\n          #3D138D 0%, /* neutral-2 */\n          #EB0F79 75%,\n          #FFCA58 100% /* accent-4 */\n        );"
            }
        },
        font: {
            family: "-apple-system,\n         BlinkMacSystemFont, \n         \"Segoe UI\", \n         Roboto, \n         Oxygen, \n         Ubuntu, \n         Cantarell, \n         \"Fira Sans\", \n         \"Droid Sans\",  \n         \"Helvetica Neue\", \n         Arial, sans-serif,  \n         \"Apple Color Emoji\", \n         \"Segoe UI Emoji\", \n         \"Segoe UI Symbol\""
        }
    },
    button: {
        extend: (0, $iA1nz.css)([
            "",
            ""
        ], function(props) {
            return !props.plain && 'font-weight: bold;';
        })
    }
});


$45e3c754f67e1b77$export$9d812a0de4eabbe3 = $12ea83166b26d412$export$9d812a0de4eabbe3;
var $86188474bfff4abd$export$1e511d4a378977f5;
var $86188474bfff4abd$export$55ce6f3a06c59543;
"use strict";
$86188474bfff4abd$export$1e511d4a378977f5 = true;
$86188474bfff4abd$export$55ce6f3a06c59543 = void 0;

var $iA1nz = parcelRequire("iA1nz");


var $86188474bfff4abd$var$accentColors = [
    '#FD6FFF',
    '#60EB9F',
    '#60EBE1',
    '#FFCA58'
];
var $86188474bfff4abd$var$neutralColors = [
    '#EB6060',
    '#01C781',
    '#6095EB',
    '#FFB200'
];
var $86188474bfff4abd$var$statusColors = {
    critical: '#FF3333',
    error: '#FF3333',
    warning: '#F7E464',
    ok: '#7DD892',
    unknown: '#a8a8a8',
    disabled: '#a8a8a8'
};
var $86188474bfff4abd$var$backgroundColor = '#111111';
var $86188474bfff4abd$var$colors = {
    active: 'rgba(102, 102, 102, 0.5)',
    background: $86188474bfff4abd$var$backgroundColor,
    black: '#000000',
    brand: '#FD6FFF',
    control: {
        dark: '#FFCA58',
        light: '#403216'
    },
    focus: '#FFCA58',
    icon: {
        dark: '#f8f8f8',
        light: '#666666'
    },
    placeholder: '#AAAAAA',
    text: {
        dark: '#eeeeee',
        light: '#444444'
    },
    white: '#FFFFFF'
};
var $86188474bfff4abd$var$colorArray = function colorArray(array, prefix) {
    return array.forEach(function(color, index) {
        $86188474bfff4abd$var$colors[prefix + "-" + (index + 1)] = color;
    });
};
$86188474bfff4abd$var$colorArray($86188474bfff4abd$var$accentColors, 'accent');
$86188474bfff4abd$var$colorArray($86188474bfff4abd$var$neutralColors, 'neutral');
Object.keys($86188474bfff4abd$var$statusColors).forEach(function(color) {
    $86188474bfff4abd$var$colors["status-" + color] = $86188474bfff4abd$var$statusColors[color];
});
var $86188474bfff4abd$var$dark = $86188474bfff4abd$export$55ce6f3a06c59543 = (0, $ebafa0e8c9355c24$export$7e32b29e1cb162e1)({
    global: {
        colors: $86188474bfff4abd$var$colors,
        drop: {
            background: '#333333'
        },
        focus: {
            border: {
                color: (0, $iA1nz.css)([
                    "",
                    ";"
                ], function(props) {
                    return (0, $62e050f1cfc78056$export$4cde5df63f53f473)('focus', props.theme);
                }),
                width: '2px'
            }
        },
        font: {
            family: 'Arial'
        },
        input: {
            weight: 700
        }
    },
    anchor: {
        color: 'control'
    },
    layer: {
        background: $86188474bfff4abd$var$backgroundColor,
        overlay: {
            background: 'rgba(48, 48, 48, 0.5)'
        }
    }
});


$45e3c754f67e1b77$export$55ce6f3a06c59543 = $86188474bfff4abd$export$55ce6f3a06c59543;
var $fc9864a4270df07d$export$1e511d4a378977f5;
var $fc9864a4270df07d$export$b2f72e3c920710c0;
"use strict";
$fc9864a4270df07d$export$1e511d4a378977f5 = true;
$fc9864a4270df07d$export$b2f72e3c920710c0 = void 0;

var $iA1nz = parcelRequire("iA1nz");

var $fc9864a4270df07d$var$hacktoberfest2022 = $fc9864a4270df07d$export$b2f72e3c920710c0 = (0, $ebafa0e8c9355c24$export$7e32b29e1cb162e1)({
    defaultMode: 'dark',
    global: {
        colors: {
            background: '#160F1D',
            'background-back': '#000000',
            'background-front': '#160F1D',
            'text-strong': '#FFFFFF',
            text: '#E4E1E6',
            'text-weak': '#76717A',
            grey: '#AFACB2',
            lime: '#C6FC60',
            pink: '#D856A7',
            purple: '#7C7EF4',
            teal: '#73DAFB',
            yellow: '#EDD063',
            darkPurple: '#291E40',
            active: 'purple',
            focus: '#233670',
            brand: 'lime',
            control: 'teal',
            'graph-0': 'yellow',
            'graph-1': 'purple',
            'graph-2': 'teal',
            'graph-3': 'pink',
            'graph-4': 'lime',
            // clear unused colors
            icon: undefined,
            'accent-1': undefined,
            'accent-2': undefined,
            'accent-3': undefined,
            'accent-4': undefined,
            'neutral-1': undefined,
            'neutral-2': undefined,
            'neutral-3': undefined,
            'neutral-4': undefined,
            'neutral-5': undefined,
            'light-1': undefined,
            'light-2': undefined,
            'light-3': undefined,
            'light-4': undefined,
            'light-5': undefined,
            'light-6': undefined,
            'dark-1': undefined,
            'dark-2': undefined,
            'dark-3': undefined,
            'dark-4': undefined,
            'dark-5': undefined,
            'dark-6': undefined
        },
        backgrounds: {
            'gradient-purple-teal': {
                image: "linear-gradient(\n          #7C7EF4 0%,\n          #73DAFB 100%\n        );"
            },
            'gradient-teal-purple': {
                image: "linear-gradient(\n          #73DAFB 0%,\n          #7C7EF4 100%\n        );"
            },
            'gradient-yellow-teal-purple': {
                image: "linear-gradient(\n          #EDD063 0%,\n          #73DAFB 50%,\n          #7C7EF4 100%\n        );",
                rotate: 90
            },
            'gradient-yellow-teal': {
                image: "linear-gradient(\n          #EDD063 0%,\n          #73DAFB 100%\n        );",
                rotate: 90
            }
        },
        focus: {
            shadow: {
                color: 'focus',
                size: '3px'
            }
        },
        font: {
            family: '"JetBrains Mono", monospace',
            face: "/* latin */\n@font-face {\n  font-family: 'JetBrains Mono';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/jetbrainsmono/v13/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8yKxTOlOTk6OThhvA.woff) format('woff');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}"
        }
    },
    grommet: {
        extend: (0, $iA1nz.css)([
            "text-transform:uppercase;"
        ])
    },
    anchor: {
        color: 'text',
        hover: {
            color: 'text-strong'
        }
    },
    button: {
        border: {
            width: '0px',
            radius: '0px'
        },
        padding: {
            horizontal: '20px',
            vertical: '10px'
        },
        color: 'text-strong',
        size: {
            small: {
                pad: {
                    horizontal: '16px',
                    vertical: '8px'
                }
            },
            medium: {
                pad: {
                    horizontal: '20px',
                    vertical: '10px'
                }
            }
        },
        "default": {
            color: 'text-strong'
        },
        primary: {
            border: false,
            background: 'gradient-yellow-teal-purple',
            color: 'text'
        },
        hover: {
            border: false
        },
        extend: (0, $iA1nz.css)([
            "clip-path:polygon( 12px 0px,100% 0px,100% 72%,calc(100% - 12px) 100%,0px 100%,0px 12px );text-transform:uppercase;&:focus{clip-path:none;}"
        ])
    },
    heading: {
        extend: (0, $iA1nz.css)([
            "text-shadow:rgba(255,215,77,0.6) -1px -1px 6px,rgba(124,127,255,0.6) 1px 1px 6px;"
        ])
    }
});


$45e3c754f67e1b77$export$b2f72e3c920710c0 = $fc9864a4270df07d$export$b2f72e3c920710c0;



const $edb3b666553e0b8a$var$customTheme = {
    global: {
        colors: {
            brand: 'rgb(234, 173, 71)',
            'brand-dark': 'rgb(224, 158, 71)',
            control: 'accent-1',
            'accent-1': 'rgb(49, 99, 153)',
            'accent-2': 'rgb(52, 54, 72)',
            'accent-3': 'rgb(77, 152, 235)',
            'accent-4': 'rgb(24, 100, 158)',
            'accent-5': 'rgb(170, 34, 92)',
            'accent-6': 'rgb(65, 110, 144)',
            'accent-7': 'rgb(0, 110, 49)',
            text: 'rgb(33, 37, 41)',
            'light-1': 'rgb(170, 178, 188)',
            'light-2': 'rgb(201, 208, 216)',
            'light-3': 'rgb(108, 117, 125)',
            'light-4': 'rgb(234, 236, 239)',
            'light-5': 'rgb(210, 216, 223)',
            'light-6': 'rgb(244, 246, 248)',
            'dark-1': 'rgb(81, 94, 107)',
            'dark-2': 'rgb(41, 38, 56)',
            'dark-3': 'rgb(33, 37, 41)',
            'dark-4': 'rgb(66, 73, 90)',
            'button-hover': 'rgb(42, 86, 134)'
        },
        focus: {
            outline: {
                size: '0',
                // size: '1px',
                color: 'accent-1'
            }
        },
        animation: {
            duration: '500'
        },
        font: {
            family: 'Roboto Condensed, sans-serif'
        },
        backgrounds: {
            light: 'linear-gradient(rgb(253, 253, 254) 0%, rgb(241, 243, 246) 300px, rgb(241, 243, 246) 100%)'
        },
        breakpoints: {
            small: {
                value: 1000
            }
        },
        input: {
            font: {
                weight: 400,
                size: '14px'
            }
        },
        borderSize: {
            small: '0.8px'
        },
        size: {
            xxsmall: '0.5rem',
            xsmall: '0.75rem',
            small: '0.875rem',
            medium: '1rem',
            large: '1.5rem',
            xlarge: '2rem',
            xxlarge: '2.5rem'
        },
        control: {
            border: {
                color: 'light-2',
                radius: '6px',
                width: '0.8px'
            }
        }
    },
    accordion: {
        border: {
            color: 'light-2',
            side: 'horizontal',
            size: 'small'
        }
    },
    tip: {
        content: {
            background: 'white'
        }
    },
    text: {
        xsmall: {
            size: '11px',
            height: '1rem'
        },
        small: {
            size: '13px',
            height: '1.125rem'
        },
        medium: {
            size: '14px',
            height: '1.125rem'
        },
        large: {
            size: '20px',
            height: '1.5rem'
        },
        xlarge: {
            size: '24px',
            height: '1.75rem'
        },
        xxlarge: {
            size: '32px',
            height: '2.5rem'
        }
    },
    formField: {
        border: {
            color: 'light-5',
            size: 'small',
            side: 'all'
        },
        round: '6px',
        content: {
            pad: {
                horizontal: '0.75rem',
                vertical: '0.5rem'
            }
        },
        label: {
            size: 'small',
            color: 'accent-1'
        },
        focus: {
            border: {
                color: 'accent-1'
            }
        },
        disabled: {
            background: 'light-6',
            border: {
                color: 'light-6'
            },
            label: {
                color: 'light-3'
            }
        },
        error: {
            border: {
                color: 'red',
                size: 'small',
                side: 'all'
            }
        }
    },
    textArea: {
        disabled: 1
    },
    textInput: {
        disabled: {
            opacity: 1
        }
    },
    maskedInput: {
        disabled: {
            opacity: 1
        }
    },
    spinner: {
        container: {
            animation: {
                type: 'rotateRight',
                duration: 600
            }
        }
    },
    button: {
        border: {
            radius: '6px',
            color: 'light-2',
            width: '0.05rem'
        },
        padding: {
            horizontal: '0.75rem',
            vertical: '0.75rem'
        },
        primary: {
            background: 'accent-1',
            color: 'white'
        }
    },
    card: {
        container: {
            flex: 'grow',
            background: 'white',
            border: {
                color: 'light-2',
                size: 'small'
            },
            round: '6px',
            elevation: 'xsmall'
        },
        header: {
            border: {
                color: 'light-2',
                side: 'bottom',
                size: 'small'
            },
            pad: '1.5rem',
            gap: '0.5rem',
            direction: 'row',
            justify: 'start'
        },
        body: {
            gap: '1rem'
        }
    },
    checkBox: {
        border: {
            color: {
                light: 'light-5',
                dark: 'white'
            },
            width: '1px'
        },
        hover: {
            border: {
                color: {
                    light: 'dark-1',
                    dark: 'light-5'
                }
            }
        },
        check: {
            radius: '6px'
        },
        color: {
            light: 'dark-1',
            dark: 'white'
        }
    },
    select: {
        options: {
            container: {
                style: {
                    lineHeight: '24px'
                },
                pad: '0.75rem'
            }
        },
        icons: {
            down: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $1721736c3a136fd2$export$c22d792887f3cb87), {}),
            up: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $5ac95831a9324798$export$cb86d8fdcb9f94b5), {})
        }
    },
    radioButton: {
        size: '1rem',
        icons: {
            circle: (0, $2ab90fad418fe2af$export$2f4a3096121829b3)
        }
    }
};
var $edb3b666553e0b8a$export$2e2bcd8739ae039 = (0, $4113023f9e0bafa0$exports.deepMerge)((0, $45e3c754f67e1b77$export$9d812a0de4eabbe3), $edb3b666553e0b8a$var$customTheme);


const $d5bd1c1beb7b51b0$var$themeColors = (0, $edb3b666553e0b8a$export$2e2bcd8739ae039).global?.colors ?? {};
const $d5bd1c1beb7b51b0$var$cardHeight = '40.875rem';
const $d5bd1c1beb7b51b0$var$colors = [
    '#eba14d',
    $d5bd1c1beb7b51b0$var$themeColors['accent-3'],
    $d5bd1c1beb7b51b0$var$themeColors['accent-5'],
    '#4de6eb'
];
const $d5bd1c1beb7b51b0$var$SCALE_FACTORS = {
    'Electric Forklift': 1.5,
    eTRU: 8,
    'Fixed Guideway, Light Rail': 6,
    'Heavy-Duty On-Road EV': 3.5,
    eCHE: 15,
    'Light-Duty On-Road EV': 2.5
};
const $d5bd1c1beb7b51b0$var$DEFAULT_SCALE_FACTOR_RANGE = {
    min: 5,
    max: 10,
    multiplier: 0.8
};
const $d5bd1c1beb7b51b0$var$getChartOptions = (reportingPeriodLabel)=>({
        chart: {
            type: 'line',
            fontFamily: 'Roboto Condensed, sans-serif',
            foreColor: $d5bd1c1beb7b51b0$var$themeColors['dark-3'],
            animations: {
                enabled: true,
                speed: 500,
                animateGradually: {
                    enabled: false
                },
                dynamicAnimation: {
                    speed: 300
                }
            },
            toolbar: {
                show: false
            },
            zoom: {
                enabled: false
            }
        },
        stroke: {
            width: [
                2.5
            ],
            curve: 'smooth'
        },
        dataLabels: {
            enabled: true,
            enabledOnSeries: [
                0
            ],
            style: {
                fontSize: '11px',
                fontWeight: 600
            },
            background: {
                borderColor: $d5bd1c1beb7b51b0$var$themeColors.brand,
                borderRadius: 10,
                padding: 5
            }
        },
        markers: {
            size: 0,
            hover: {
                size: 6
            }
        },
        colors: $d5bd1c1beb7b51b0$var$colors,
        fill: {
            type: 'solid'
        },
        grid: {
            borderColor: '#EAECEF',
            strokeDashArray: 4,
            xaxis: {
                lines: {
                    show: false
                }
            },
            padding: {
                left: 10,
                right: 10
            }
        },
        xaxis: {
            type: 'category',
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false
            },
            title: {
                text: reportingPeriodLabel,
                style: {
                    fontWeight: 400,
                    fontSize: '20px',
                    color: $d5bd1c1beb7b51b0$var$themeColors['dark-3']
                },
                offsetY: -10
            },
            labels: {
                rotate: -90,
                rotateAlways: true,
                offsetX: -1,
                style: {
                    fontWeight: 500
                }
            }
        },
        yaxis: {
            show: false
        },
        tooltip: {
            theme: 'light',
            y: {
                formatter: (val)=>val?.toString().split('.')[0] ?? ''
            },
            style: {
                fontSize: '13px'
            }
        },
        legend: {
            showForSingleSeries: true,
            fontSize: '16px',
            markers: {
                radius: 12
            }
        }
    });
const $d5bd1c1beb7b51b0$export$5f6a353c197b2d41 = (props)=>{
    /**
   * Props
   */ const { data: data, height: height, ...cardProps } = props;
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const { chartData: chartData, chartLabels: chartLabels, categoryStrokes: categoryStrokes, chartYAxes: chartYAxes } = (0, $2xPiy.useMemo)(()=>{
        const periods = [];
        const categories = {
            Facilities: []
        };
        const categoryMaxValues = {};
        const equipmentCategories = [];
        data.reporting_periods.forEach((period)=>{
            period.equipment.forEach((equipment)=>{
                if (!equipmentCategories.includes(equipment.category)) {
                    equipmentCategories.push(equipment.category);
                    categories[equipment.category] = [];
                }
            });
        });
        data.reporting_periods.forEach((period)=>{
            periods.push(period.reporting_period);
            categories['Facilities'].push(period.num_facilities);
            categoryMaxValues['Facilities'] = Math.max(categoryMaxValues['Facilities'] ?? 0, period.num_facilities);
            equipmentCategories.forEach((categoryName)=>{
                const equipment = period.equipment.find((equipment)=>equipment.category === categoryName);
                categories[categoryName].push(equipment?.amount ?? null);
                if (equipment) categoryMaxValues[categoryName] = Math.max(categoryMaxValues[categoryName] ?? 0, equipment.amount);
            });
        });
        const series = [];
        const categoryYAxes = [];
        const strokes = [];
        series.push({
            name: 'Facilities',
            type: 'line',
            data: categories['Facilities']
        });
        const highestEquipmentValue = equipmentCategories.length ? Math.max(...equipmentCategories.map((cat)=>categoryMaxValues[cat])) : 0;
        const facilitiesMax = categoryMaxValues['Facilities'];
        const facilitiesYAxis = {
            seriesName: 'Facilities',
            show: false,
            ...facilitiesMax > 0 ? {
                max: facilitiesMax * 1.15
            } : {}
        };
        equipmentCategories.forEach((categoryName)=>{
            strokes.push(0);
            series.push({
                name: categoryName,
                type: 'column',
                data: categories[categoryName]
            });
            const categoryMax = categoryMaxValues[categoryName];
            const scaleFactor = $d5bd1c1beb7b51b0$var$SCALE_FACTORS[categoryName] ?? (categoryMax > 0 ? Math.min($d5bd1c1beb7b51b0$var$DEFAULT_SCALE_FACTOR_RANGE.max, Math.max($d5bd1c1beb7b51b0$var$DEFAULT_SCALE_FACTOR_RANGE.min, highestEquipmentValue / categoryMax * $d5bd1c1beb7b51b0$var$DEFAULT_SCALE_FACTOR_RANGE.multiplier)) : $d5bd1c1beb7b51b0$var$DEFAULT_SCALE_FACTOR_RANGE.min);
            categoryYAxes.push({
                seriesName: categoryName,
                show: false,
                ...categoryMax > 0 ? {
                    max: categoryMax * scaleFactor
                } : {}
            });
        });
        return {
            chartData: series,
            chartLabels: periods,
            chartYAxes: [
                facilitiesYAxis,
                ...categoryYAxes
            ],
            categoryStrokes: strokes
        };
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
        flex: "grow",
        height: height || $d5bd1c1beb7b51b0$var$cardHeight,
        ...cardProps,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f557854f3abac6b7$export$5665775b26e26c5d), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    size: "xlarge",
                    children: t('dashboard:cumulativeEnrollmentTrends')
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $fdccc762800a972d$export$851de33184ecdac4), {
                pad: {
                    horizontal: 'medium',
                    bottom: '2rem'
                },
                children: !chartLabels || !categoryStrokes || !chartYAxes || !chartData ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    width: "100%",
                    flex: "grow",
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($93d6258b67061950$exports))), {
                        options: {
                            ...$d5bd1c1beb7b51b0$var$getChartOptions(t('common:reportingPeriod')),
                            labels: chartLabels,
                            yaxis: chartYAxes,
                            stroke: {
                                width: [
                                    4,
                                    ...categoryStrokes
                                ]
                            },
                            plotOptions: {
                                bar: {
                                    columnWidth: '65%',
                                    borderRadius: 2,
                                    borderRadiusApplication: 'end',
                                    dataLabels: {
                                        maxItems: 1000
                                    }
                                }
                            }
                        },
                        series: chartData,
                        type: "line",
                        width: "100%",
                        height: "100%"
                    })
                })
            })
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");








const $696adc961bb18b9f$export$3eb8726488fe45ba = (props)=>{
    /**
   * Props
   */ const { data: data, height: height, ...boxProps } = props;
    const [facilitiesData, setFacilitiesData] = (0, $2xPiy.useState)({});
    const [seriesData, setSeriesData] = (0, $2xPiy.useState)([]);
    const [orderedFacilityIds, setOrderedFacilityIds] = (0, $2xPiy.useState)([]);
    const chartLabels = Object.keys(facilitiesData);
    const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    /* Context */ const dashboardStore = (0, $116967e0234c3770$export$176f58333fc13682)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /* Refs */ const clientId = dashboardStore.dashboardData?.client_id;
    const themeColors = (0, $2xPiy.useRef)((0, $edb3b666553e0b8a$export$2e2bcd8739ae039).global?.colors ?? {});
    const cardHeight = (0, $2xPiy.useRef)('31.5rem');
    const chartColors = (0, $2xPiy.useRef)([
        themeColors.current['accent-3'],
        themeColors.current['accent-5'],
        themeColors.current['brand']
    ]);
    const chartOptions = (0, $2xPiy.useRef)({
        chart: {
            type: 'bar',
            stacked: true,
            fontFamily: 'Roboto Condensed, sans-serif',
            foreColor: themeColors.current['dark-3'],
            animations: {
                enabled: true,
                speed: 500,
                animateGradually: {
                    enabled: false
                },
                dynamicAnimation: {
                    speed: 300
                }
            },
            toolbar: {
                show: false
            },
            zoom: {
                enabled: false
            }
        },
        plotOptions: {
            bar: {
                horizontal: true,
                borderRadius: 6,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last'
            }
        },
        dataLabels: {
            enabled: true
        },
        stroke: {
            show: false
        },
        colors: chartColors.current,
        grid: {
            borderColor: '#EAECEF',
            strokeDashArray: 4,
            xaxis: {
                lines: {
                    show: true
                }
            },
            yaxis: {
                lines: {
                    show: false
                }
            },
            padding: {
                left: 10,
                right: 10
            }
        },
        xaxis: {
            position: 'top',
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false
            },
            labels: {
                style: {
                    fontWeight: 500
                }
            }
        },
        yaxis: {
            title: {
                text: undefined
            },
            labels: {
                style: {
                    fontWeight: 500,
                    fontSize: '12px'
                },
                maxWidth: 200
            }
        },
        tooltip: {
            theme: 'light',
            style: {
                fontSize: '13px'
            }
        },
        legend: {
            showForSingleSeries: true,
            showForZeroSeries: false,
            fontSize: '16px',
            position: 'bottom',
            markers: {
                radius: 12
            },
            itemMargin: {
                horizontal: 8,
                vertical: 4
            }
        }
    });
    /* Effects */ (0, $2xPiy.useEffect)(()=>{
        const facilities = {};
        if (!data || !data.facilities) return;
        const dataFacilities = [
            ...data.facilities
        ].sort((a, b)=>b.equipment.map((e)=>e.amount).reduce((total, amount)=>total + amount, 0) - a.equipment.map((e)=>e.amount).reduce((total, amount)=>total + amount, 0)).slice(0, 10);
        const newOrderedFacilityIds = [];
        for (const facility of dataFacilities){
            if (!facility.id) continue;
            const facilityAddress = `${(0, $00658ccd6ec0135a$export$6cc1800f355fe600)(facility.address.line1)}, ${facility.address.city}, ${facility.address.region_short_code} ${facility.address.post_code}`;
            facilities[facilityAddress] = {};
            newOrderedFacilityIds.push(facility.id);
            facility.equipment.forEach((equipment)=>{
                facilities[facilityAddress][equipment.category] = equipment.amount;
            });
        }
        setFacilitiesData(facilities);
        chartOptions.current = {
            ...chartOptions.current,
            chart: {
                ...chartOptions.current.chart,
                events: {
                    dataPointSelection: (_, __, config)=>{
                        navigate(`/clients/${clientId}/facilities/${newOrderedFacilityIds[config.dataPointIndex]}`);
                    }
                }
            }
        };
        const seriesData = [];
        for(const facilityName in facilities)for(const categoryName in facilities[facilityName]){
            const existingIndex = seriesData.findIndex((s)=>s.name === categoryName);
            if (existingIndex > -1) {
                const existingData = seriesData[existingIndex].data;
                existingData.push(facilities[facilityName][categoryName]);
                seriesData[existingIndex].data = existingData;
            } else {
                const newData = {
                    name: categoryName,
                    data: [
                        facilities[facilityName][categoryName]
                    ]
                };
                seriesData.push(newData);
            }
        }
        setSeriesData(seriesData.filter((datum)=>!!datum.data.reduce((total, amount)=>total += amount)));
        setOrderedFacilityIds(newOrderedFacilityIds);
    }, [
        data?.facilities,
        clientId,
        navigate
    ]);
    /* Render */ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
        flex: "grow",
        height: height || cardHeight.current,
        ...boxProps,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f557854f3abac6b7$export$5665775b26e26c5d), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), {
                    size: "xlarge",
                    children: t('dashboard:equipmentTypeByFacility')
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $fdccc762800a972d$export$851de33184ecdac4), {
                pad: {
                    horizontal: 'medium',
                    bottom: '2rem'
                },
                children: !seriesData || !chartLabels ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                    width: "100%",
                    flex: "grow",
                    direction: "row",
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        flex: "grow",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($93d6258b67061950$exports))), {
                            options: {
                                ...chartOptions.current,
                                chart: {
                                    ...chartOptions.current.chart,
                                    events: {
                                        xAxisLabelClick: (_event, _chartContext, { labelIndex: labelIndex })=>{
                                            if (clientId && orderedFacilityIds[labelIndex]) navigate(`/clients/${clientId}/facilities/${orderedFacilityIds[labelIndex]}`);
                                        },
                                        dataPointSelection: (_event, _chartContext, { dataPointIndex: dataPointIndex })=>{
                                            if (clientId && orderedFacilityIds[dataPointIndex]) navigate(`/clients/${clientId}/facilities/${orderedFacilityIds[dataPointIndex]}`);
                                        }
                                    }
                                },
                                xaxis: {
                                    ...chartOptions.current.xaxis,
                                    categories: chartLabels
                                }
                            },
                            series: seriesData,
                            type: "bar",
                            width: "100%",
                            height: "100%"
                        })
                    })
                })
            })
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");





const $e6edef7c6c6bd381$export$b5c0e79205a9b186 = (props)=>{
    /* Props */ const { data: data, hideHeader: hideHeader, height: height, ...cardProps } = props;
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const seriesData = (0, $2xPiy.useMemo)(()=>{
        const sortedCategories = data.percent_revenue_per_equipment_category.sort((a, b)=>a.category.toLowerCase() > b.category.toLowerCase() ? 1 : -1);
        const seriesData = {};
        sortedCategories.forEach(({ category: category, percentage: percentage })=>{
            seriesData[category] = parseFloat(percentage.toString());
        });
        return seriesData;
    }, [
        data
    ]);
    const chartData = (0, $2xPiy.useMemo)(()=>Object.values(seriesData), [
        seriesData
    ]);
    const chartLabels = (0, $2xPiy.useMemo)(()=>Object.keys(seriesData), [
        seriesData
    ]);
    /* Refs */ const themeColors = (0, $2xPiy.useRef)((0, $edb3b666553e0b8a$export$2e2bcd8739ae039).global?.colors ?? {});
    const cardHeight = (0, $2xPiy.useRef)('32.5rem');
    const chartColors = (0, $2xPiy.useRef)([
        themeColors.current['brand'],
        themeColors.current['accent-5'],
        themeColors.current['accent-7'],
        themeColors.current['accent-3'],
        themeColors.current['accent-2'],
        themeColors.current['accent-1'],
        themeColors.current['accent-4'],
        themeColors.current['accent-6']
    ]);
    const chartOptions = (0, $2xPiy.useRef)({
        chart: {
            type: 'donut',
            fontFamily: 'Roboto Condensed, sans-serif',
            foreColor: themeColors.current['dark-3'],
            animations: {
                enabled: true,
                speed: 500,
                animateGradually: {
                    enabled: false
                },
                dynamicAnimation: {
                    speed: 300
                }
            },
            toolbar: {
                show: false
            },
            zoom: {
                enabled: false
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            show: true,
            width: 2,
            colors: [
                '#fff'
            ]
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '75%',
                    labels: {
                        show: true,
                        name: {
                            show: true,
                            fontSize: '14px',
                            fontWeight: 500
                        },
                        value: {
                            show: true,
                            fontSize: '24px',
                            fontWeight: 600,
                            formatter: (val)=>`${val}%`
                        }
                    }
                }
            }
        },
        tooltip: {
            enabled: false
        },
        colors: chartColors.current,
        legend: {
            fontSize: '16px',
            position: 'bottom',
            markers: {
                radius: 12
            },
            itemMargin: {
                horizontal: 8,
                vertical: 4
            }
        }
    });
    /* Render */ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $724dfb7ecf65a151$export$60332b2344f7fe41), {
        height: height || cardHeight.current,
        ...cardProps,
        children: [
            !hideHeader && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f557854f3abac6b7$export$5665775b26e26c5d), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    size: "xlarge",
                    children: t('dashboard:percentRevenueByEquipmenttype')
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $fdccc762800a972d$export$851de33184ecdac4), {
                pad: "none",
                gap: "none",
                children: !chartData || !chartLabels ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    alignSelf: "center",
                    pad: "1.5rem",
                    fill: true,
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($93d6258b67061950$exports))), {
                        options: {
                            ...chartOptions.current,
                            labels: chartLabels
                        },
                        series: chartData,
                        type: "donut",
                        width: "100%",
                        height: "100%"
                    })
                })
            })
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");





const $1cd4ac24d8653a5d$export$db95aab8af762a3 = (props)=>{
    /* Props */ const { data: data, hideHeader: hideHeader, height: height, ...cardProps } = props;
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /* Memos */ const seriesData = (0, $2xPiy.useMemo)(()=>{
        const sortedCategories = data.percent_revenue_per_program.sort((a, b)=>a.program.toLowerCase() > b.program.toLowerCase() ? 1 : -1);
        const seriesData = {};
        sortedCategories.forEach(({ program: program, percentage: percentage })=>{
            seriesData[program] = parseFloat(percentage.toString());
        });
        return seriesData;
    }, [
        data
    ]);
    const chartData = (0, $2xPiy.useMemo)(()=>Object.values(seriesData), [
        seriesData
    ]);
    const chartLabels = (0, $2xPiy.useMemo)(()=>Object.keys(seriesData), [
        seriesData
    ]);
    /* Refs */ const themeColors = (0, $2xPiy.useRef)((0, $edb3b666553e0b8a$export$2e2bcd8739ae039).global?.colors ?? {});
    const cardHeight = (0, $2xPiy.useRef)('32.5rem');
    const chartColors = (0, $2xPiy.useRef)([
        themeColors.current['accent-3'],
        themeColors.current['accent-5'],
        themeColors.current['brand'],
        themeColors.current['accent-1'],
        themeColors.current['accent-4'],
        themeColors.current['accent-7'],
        themeColors.current['accent-6'],
        themeColors.current['accent-2']
    ]);
    const chartOptions = (0, $2xPiy.useRef)({
        chart: {
            type: 'donut',
            fontFamily: 'Roboto Condensed, sans-serif',
            foreColor: themeColors.current['dark-3'],
            animations: {
                enabled: true,
                speed: 500,
                animateGradually: {
                    enabled: false
                },
                dynamicAnimation: {
                    speed: 300
                }
            },
            toolbar: {
                show: false
            },
            zoom: {
                enabled: false
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            show: true,
            width: 2,
            colors: [
                '#fff'
            ]
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '75%',
                    labels: {
                        show: true,
                        name: {
                            show: true,
                            fontSize: '14px',
                            fontWeight: 500
                        },
                        value: {
                            show: true,
                            fontSize: '24px',
                            fontWeight: 600,
                            formatter: (val)=>`${val}%`
                        }
                    }
                }
            }
        },
        tooltip: {
            enabled: false
        },
        colors: chartColors.current,
        legend: {
            fontSize: '16px',
            position: 'bottom',
            markers: {
                radius: 12
            },
            itemMargin: {
                horizontal: 8,
                vertical: 4
            }
        }
    });
    /* Render */ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $724dfb7ecf65a151$export$60332b2344f7fe41), {
        height: height || cardHeight.current,
        ...cardProps,
        children: [
            !hideHeader && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f557854f3abac6b7$export$5665775b26e26c5d), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    size: "xlarge",
                    children: t('dashboard:percentRevenueByProgram')
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $fdccc762800a972d$export$851de33184ecdac4), {
                pad: "none",
                gap: "none",
                children: !chartData || !chartLabels ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    alignSelf: "center",
                    pad: "1.5rem",
                    fill: true,
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($93d6258b67061950$exports))), {
                        options: {
                            ...chartOptions.current,
                            labels: chartLabels
                        },
                        series: chartData,
                        type: "donut",
                        width: "100%",
                        height: "100%"
                    })
                })
            })
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");






const $fd4665cc6c98489d$export$27ae23542b46daac = (props)=>{
    const { data: data, height: height, ...cardProps } = props;
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** Settings **/ const themeColors = (0, $2xPiy.useRef)((0, $edb3b666553e0b8a$export$2e2bcd8739ae039).global?.colors);
    const cardHeight = (0, $2xPiy.useRef)('40.875rem');
    const chartColors = (0, $2xPiy.useRef)([
        themeColors.current?.['accent-3'],
        themeColors.current?.['accent-5'],
        themeColors.current?.['brand'],
        themeColors.current?.['accent-4']
    ]);
    const chartOptions = (0, $2xPiy.useRef)({
        chart: {
            type: 'line',
            fontFamily: 'Roboto Condensed, sans-serif',
            foreColor: themeColors.current?.['dark-3'],
            animations: {
                enabled: true,
                speed: 500,
                animateGradually: {
                    enabled: false
                },
                dynamicAnimation: {
                    speed: 300
                }
            },
            toolbar: {
                show: false
            },
            zoom: {
                enabled: false
            }
        },
        stroke: {
            width: [
                0,
                2.5
            ],
            curve: 'smooth'
        },
        dataLabels: {
            enabled: false
        },
        markers: {
            size: 0,
            colors: [
                '#fff'
            ],
            strokeColors: chartColors.current.slice(0, 3),
            strokeWidth: 2,
            hover: {
                size: 6
            }
        },
        colors: chartColors.current,
        grid: {
            borderColor: '#EAECEF',
            strokeDashArray: 4,
            xaxis: {
                lines: {
                    show: false
                }
            },
            padding: {
                left: 10,
                right: 10
            }
        },
        xaxis: {
            type: 'category',
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false
            },
            labels: {
                rotate: -90,
                rotateAlways: true,
                offsetX: -1,
                style: {
                    fontWeight: 500
                }
            }
        },
        plotOptions: {
            bar: {
                hideZeroBarsWhenGrouped: true,
                borderRadius: 6,
                borderRadiusApplication: 'end',
                columnWidth: '55%'
            }
        },
        tooltip: {
            theme: 'light',
            y: {
                formatter: (val)=>val ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(val, true, true) : "\u2014"
            },
            style: {
                fontSize: '13px'
            }
        },
        legend: {
            showForSingleSeries: true,
            fontSize: '16px',
            markers: {
                radius: 12
            },
            formatter: (legendName)=>legendName === 'Incentive Revenue' ? legendName : `${legendName} Price / Credit ($)`
        }
    });
    const dataSeries = (0, $2xPiy.useMemo)(()=>{
        const dataSeries = {};
        const programs = {};
        data.reporting_periods.forEach((period)=>{
            period.programs.forEach((program)=>{
                programs[program.name] ??= program;
            });
        });
        data.reporting_periods.forEach((period)=>{
            if (!dataSeries['Incentive Revenue']) dataSeries['Incentive Revenue'] = [];
            const revenueFloat = parseFloat(period.incentive_revenue);
            dataSeries['Incentive Revenue'].push(revenueFloat);
            Object.keys(programs).forEach((programName)=>{
                const program = period.programs.find((program)=>program.name.toLowerCase() === programName.toLowerCase());
                dataSeries[programName] ??= [];
                dataSeries[programName].push(program ? parseFloat(program.price_per_credit) || null : null);
            });
        });
        return dataSeries;
    }, [
        data
    ]);
    const chartData = dataSeries ? Object.keys(dataSeries).map((seriesName)=>({
            name: seriesName,
            type: seriesName === 'Incentive Revenue' ? 'column' : 'line',
            data: dataSeries[seriesName]
        })) : undefined;
    const categoryStrokes = dataSeries ? Object.keys(dataSeries).filter((seriesName)=>seriesName !== 'Incentive Revenue').map(()=>3) : undefined;
    const chartLabels = data?.reporting_periods.map(({ reporting_period: reporting_period })=>reporting_period);
    const chartYAxes = (0, $2xPiy.useMemo)(()=>{
        if (!dataSeries) return;
        let minRevenue = 0;
        let maxRevenue = 0;
        let minCreditPrice = 0;
        let maxCreditPrice = 0;
        const dataSeriesKeys = Object.keys(dataSeries);
        dataSeriesKeys.forEach((programName)=>{
            dataSeries[programName].forEach((amount)=>{
                if (!amount) return;
                const isRevenue = programName.toLowerCase() === 'Incentive Revenue'.toLowerCase();
                if (isRevenue) {
                    if (amount > maxRevenue) maxRevenue = amount;
                    else if (amount < minRevenue) minRevenue = amount;
                } else {
                    if (amount > maxCreditPrice) maxCreditPrice = amount;
                    else if (amount < minCreditPrice) minCreditPrice = amount;
                }
            });
        });
        const revenueYAxis = {
            seriesName: 'Incentive Revenue',
            show: false,
            min: minRevenue ? -(maxRevenue * 1.25) : 0,
            max: maxRevenue * 1.25
        };
        const programYAxes = dataSeriesKeys.map((programName)=>({
                seriesName: programName,
                show: false,
                max: maxCreditPrice * 1.25
            }));
        return [
            revenueYAxis,
            ...programYAxes
        ];
    }, [
        dataSeries
    ]);
    /** Computed **/ const isLoading = !(chartLabels && categoryStrokes && chartYAxes && chartData);
    const chartTitle = t('dashboard:periodIncentiveRevenue');
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $724dfb7ecf65a151$export$60332b2344f7fe41), {
        flex: "grow",
        height: height || cardHeight.current,
        ...cardProps,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f557854f3abac6b7$export$5665775b26e26c5d), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    size: "xlarge",
                    children: chartTitle
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $fdccc762800a972d$export$851de33184ecdac4), {
                pad: {
                    horizontal: 'medium',
                    bottom: '2rem'
                },
                children: [
                    isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}),
                    !isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        width: "100%",
                        flex: "grow",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($93d6258b67061950$exports))), {
                            options: {
                                ...chartOptions.current,
                                labels: chartLabels,
                                yaxis: chartYAxes,
                                stroke: {
                                    width: [
                                        0,
                                        ...categoryStrokes
                                    ]
                                },
                                xaxis: {
                                    ...chartOptions.current.xaxis,
                                    title: {
                                        text: t('common:reportingPeriod'),
                                        style: {
                                            fontWeight: 400,
                                            fontSize: '20px',
                                            color: themeColors.current?.['dark-3']
                                        },
                                        offsetY: -10
                                    }
                                }
                            },
                            series: chartData,
                            width: "100%",
                            height: "100%"
                        })
                    })
                ]
            })
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");



const $46a185d5f0c5c26e$export$5f86e2a9a667774f = (props)=>{
    const { data: data, height: height, ...cardProps } = props;
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const [activeTab, setActiveTab] = (0, $2xPiy.useState)(0);
    const [focusedTab, setFocusedTab] = (0, $2xPiy.useState)('');
    // const cardHeight = useRef('30rem');
    /* Render */ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $724dfb7ecf65a151$export$60332b2344f7fe41), {
        height: height,
        ...cardProps,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f557854f3abac6b7$export$5665775b26e26c5d), {
                style: {
                    borderBottom: 'none'
                },
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    size: "xlarge",
                    children: t('dashboard:revenueBreakdown')
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $fdccc762800a972d$export$851de33184ecdac4), {
                pad: "none",
                gap: "none",
                children: [
                    !data && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}),
                    data && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                pad: {
                                    horizontal: '1.5rem'
                                },
                                justify: "end",
                                border: {
                                    side: 'bottom',
                                    color: 'light-5',
                                    size: 'small'
                                },
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b012ec9a92c56d14$export$b2539bed5023c21c), {
                                    titles: [
                                        t('dashboard:byEquipmentType'),
                                        t('dashboard:byProgram')
                                    ],
                                    activeTab: activeTab,
                                    focusedTab: focusedTab,
                                    setActiveTab: setActiveTab,
                                    setFocusedTab: setFocusedTab,
                                    flex: "shrink",
                                    pad: "none",
                                    background: "none"
                                })
                            }),
                            activeTab === 0 && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e6edef7c6c6bd381$export$b5c0e79205a9b186), {
                                data: data,
                                hideHeader: true,
                                round: "none",
                                border: undefined
                            }),
                            activeTab === 1 && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $1cd4ac24d8653a5d$export$db95aab8af762a3), {
                                data: data,
                                hideHeader: true,
                                round: "none",
                                border: undefined
                            })
                        ]
                    })
                ]
            })
        ]
    });
};






var $2xPiy = parcelRequire("2xPiy");










const $48980c91a59d1811$var$maxItemsAtOnce = 6;
const $48980c91a59d1811$var$headerHeight = 60;
const $48980c91a59d1811$var$itemHeight = 57.6;
const $48980c91a59d1811$var$gapSize = 16;
const $48980c91a59d1811$export$87d8bfca539b26c = (props)=>{
    /* Props */ const { clientId: clientId, facilityId: facilityId, isVisible: isVisible = true, setIsVisible: setIsVisible, ...boxProps } = props;
    /* Context */ const { handleApiError: handleApiError } = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const tooltips = (0, $d597772cdbe12609$export$4713da6aa4410043)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /* State */ const [hoverCategory, setHoverCategory] = (0, $2xPiy.useState)('');
    const [categories, setCategories] = (0, $2xPiy.useState)();
    const [programId, setProgramId] = (0, $2xPiy.useState)();
    /* Computed */ const isLoading = !categories || !programId;
    /* Effects */ (0, $2xPiy.useEffect)(()=>{
        if (programId && !categories) (0, $d17911beca13351e$export$63e6e4d9a672e282).listEquipmentCategories({
            program_id: programId
        }).then((categories)=>{
            setCategories(categories);
        }).catch((err)=>handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).generic.error));
    }, [
        programId,
        categories
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (isLoading && facilityId) (0, $2f95a0926656d8e2$export$c270777027a9c841).get({
            id: facilityId
        }).then((facility)=>{
            setProgramId(facility.program?.id);
        }).catch((err)=>handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).generic.error));
    }, [
        isLoading
    ]);
    /* Render */ const renderCategoryButton = (category)=>{
        const isHover = hoverCategory === category;
        return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
            plain: true,
            onClick: ()=>navigate(`/clients/${clientId}/equipment/create?category=${category}&facility_id=${facilityId}`),
            onMouseOver: ()=>setHoverCategory(category),
            onMouseOut: ()=>setHoverCategory(''),
            fill: "horizontal",
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                direction: "row",
                justify: "between",
                elevation: "xsmall",
                pad: "0.75rem",
                border: {
                    color: isHover ? 'white' : 'light-2',
                    size: '0.8px'
                },
                borderRadius: "4px",
                background: isHover ? 'accent-1' : 'white',
                transitionDuration: "0.3s",
                transitionProperty: "background",
                transitionTimingFunction: "ease",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        gap: "0.5rem",
                        alignSelf: "center",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            color: isHover ? 'white' : undefined,
                            transitionDuration: "0.3s",
                            transitionProperty: "color",
                            transitionTimingFunction: "ease",
                            children: category
                        })
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d23b039134f2e17$export$6d179221523bd367), {
                        color: isHover ? 'white' : undefined,
                        style: {
                            transitionDuration: '0.3s',
                            transitionProperty: 'color',
                            transitionTimingFunction: 'ease'
                        }
                    })
                ]
            })
        }, category);
    };
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
        position: "center",
        onEsc: ()=>setIsVisible(false),
        onClickOutside: ()=>setIsVisible(false),
        responsive: false,
        style: {
            width: 'auto',
            maxWidth: 'min(95vw, 500px)',
            maxHeight: '95vh',
            overflow: 'auto',
            borderRadius: '8px'
        },
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
            height: {
                min: 'auto'
            },
            width: "100%",
            style: {
                maxHeight: `min(95vh, ${(0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)($48980c91a59d1811$var$headerHeight + $48980c91a59d1811$var$gapSize * ($48980c91a59d1811$var$maxItemsAtOnce + 2) + $48980c91a59d1811$var$itemHeight * $48980c91a59d1811$var$maxItemsAtOnce)})`
            },
            ...boxProps,
            children: [
                isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}),
                !isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                    pad: {
                        horizontal: '1.5rem',
                        vertical: '1rem'
                    },
                    title: t('equipment:whatAreYouChargingOrPowering'),
                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $805d36e3aa560182$export$4f47cef615b0c343), {}),
                    border: {
                        side: 'bottom',
                        size: '3px',
                        color: 'brand'
                    },
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                        pad: "none",
                        onClick: ()=>setIsVisible(false),
                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c1da19823027de53$export$f39c2d165cd861fe), {
                            size: "18px"
                        }),
                        tip: tooltips.close
                    }, "close")
                }),
                !isLoading && categories && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                    pad: "none",
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        overflow: "scroll",
                        gap: "1rem",
                        pad: "1rem",
                        children: categories.map((category)=>renderCategoryButton(category.name))
                    })
                })
            ]
        })
    });
};




var $2xPiy = parcelRequire("2xPiy");












const $a839c87108bdeb6e$export$ef8bfc7c63f40c52 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(({ equipment: equipment, setIsVisible: setIsVisible })=>{
    /** Context **/ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const tooltips = (0, $d597772cdbe12609$export$4713da6aa4410043)();
    /** State **/ const [isDeleting, setIsDeleting] = (0, $2xPiy.useState)(false);
    /** Computed **/ const isLoading = !equipment;
    const canDelete = userStore.isFuseAdmin;
    /** Methods **/ const deleteEquipment = async ()=>{
        if (isDeleting) return;
        try {
            setIsDeleting(true);
            await (0, $64087c41a5036744$export$f3cdcae448e94402).delete({
                equipment_ids: [
                    equipment.id
                ]
            });
            setIsVisible(false);
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).deleteEquipment.success);
            navigate(`/clients/${equipment.client_id}/facilities/${equipment.facility_id}/equipment`);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).deleteEquipment.error);
        } finally{
            setIsDeleting(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (!canDelete) setIsVisible(false);
    }, [
        canDelete
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
        position: "center",
        onEsc: ()=>setIsVisible(false),
        onClickOutside: ()=>setIsVisible(false),
        responsive: false,
        style: {
            width: 'auto',
            maxWidth: 'min(95vw, 500px)',
            maxHeight: '95vh',
            overflow: 'auto',
            borderRadius: '8px'
        },
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $98b6153ed086d9bd$export$11154b700737b45e), {
            width: "100%",
            title: `Delete ${(0, $00658ccd6ec0135a$export$83ca57d51225263a)(equipment, (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Equipment)}`,
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d8fcb0015cca0f72$export$825a3c81a577bf46), {
                entityName: (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Equipment
            }),
            onSubmit: ()=>deleteEquipment(),
            isLoading: isLoading || isDeleting,
            hideRequiredText: true,
            saveButtonLabel: "DELETE",
            saveButtonLoadingLabel: "DELETING...",
            headerChildren: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                    pad: "none",
                    onClick: ()=>setIsVisible(false),
                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c1da19823027de53$export$f39c2d165cd861fe), {
                        size: "20px"
                    }),
                    tip: tooltips.close
                }, "close")
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                pad: {
                    horizontal: 'medium',
                    bottom: 'medium'
                },
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                    gap: "1rem",
                    direction: "row",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e23e190c1adfeb13$export$a2518b5310db22ab), {
                            size: "medium",
                            color: "status-warning"
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            children: "Are you sure you want to delete this Equipment?"
                        })
                    ]
                })
            })
        })
    });
});




var $2xPiy = parcelRequire("2xPiy");




var $2xPiy = parcelRequire("2xPiy");

function $b480de5bf3618c14$var$_extends() {
    return $b480de5bf3618c14$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b480de5bf3618c14$var$_extends.apply(null, arguments);
}
var $b480de5bf3618c14$export$fe82a520fc33e5f4 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $b480de5bf3618c14$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Dashboard"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm3-6a3 3 0 0 0-6 0M5 5l2 2m5 0v6m0-10v2m7 7h2M3 12h2m12-5 2-2M3 17h18"
    }));
});
$b480de5bf3618c14$export$fe82a520fc33e5f4.displayName = 'Dashboard';


var $2xPiy = parcelRequire("2xPiy");

function $f97d8419a136e9e9$var$_extends() {
    return $f97d8419a136e9e9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f97d8419a136e9e9$var$_extends.apply(null, arguments);
}
var $f97d8419a136e9e9$export$6d128738bddfaa67 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $f97d8419a136e9e9$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "SettingsOption"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 9V0m3 12h9M0 12h9m3 12v-9m0 6a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM3.5 8.5 1 7.5m19.5 8 2.5 1M3 3l2.5 2.5M3 3l2.5 2.5M18 18l2.5 2.5m0-17.5L18 5.5M5.5 18 3 20.5m9-5.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm8.5-6.5 2.5-1m-7.5-4 1-2.5m-1 19.5 1 2.5m-8-2.5-1 2.5m-4-7.5-2.5 1m7.5-13L7.5 1"
    }));
});
$f97d8419a136e9e9$export$6d128738bddfaa67.displayName = 'SettingsOption';




parcelRequire("2xPiy");



var $2xPiy = parcelRequire("2xPiy");


function $06bd06341dc4840c$var$_extends() {
    return $06bd06341dc4840c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $06bd06341dc4840c$var$_extends.apply(null, arguments);
}
var $06bd06341dc4840c$export$4b85d3515bd863a5 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    var scaleProps = (0, $c043e17d1ada851a$export$56a2e46cd4a7c217)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $06bd06341dc4840c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Search"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", $06bd06341dc4840c$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m15 15 7 7-7-7zm-5.5 2a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15z"
    }, scaleProps)));
});
$06bd06341dc4840c$export$4b85d3515bd863a5.displayName = 'Search';



const $f7f71094d2af306c$export$55d7609a8f1eccd2 = (props)=>{
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const { searchQuery: searchQuery, setSearchQuery: setSearchQuery, onSearch: onSearch, searchField: searchField, setSearchField: setSearchField, isSearching: isSearching, showIcon: showIcon = true, placeholder: placeholder, ...boxProps } = props;
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        height: "xxlarge",
        direction: "row",
        border: {
            color: 'light-5',
            size: '0.8px'
        },
        round: "6px",
        ...boxProps,
        children: [
            searchField && setSearchField && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                border: {
                    side: 'right',
                    color: 'light-5',
                    size: '0.8px'
                },
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b3fb5add06fccd6e$export$ef9b1a59e592288f), {
                    id: "search_field",
                    name: "search_field",
                    plain: true,
                    value: searchField,
                    onChange: (e)=>setSearchField(e.target.value ?? ''),
                    options: [
                        'Name',
                        'Address'
                    ]
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                justify: "center",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $168667f04da9206c$export$16e4d70cc375e707), {
                    onEnter: ()=>onSearch(searchQuery),
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8c9c99ffe8765a99$export$c86715117507e8e5), {
                        id: "search_query",
                        name: "search_query",
                        plain: true,
                        style: {
                            fontFamily: 'Lato, sans-serif'
                        },
                        placeholder: placeholder || (searchField ? `Search by ${searchField.toLowerCase()}` : t('common:enterName')),
                        value: searchQuery,
                        onChange: (e)=>setSearchQuery(e.target.value),
                        onSubmit: ()=>onSearch(searchQuery)
                    })
                })
            }),
            showIcon && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                id: "search_button",
                type: "submit",
                onClick: ()=>onSearch(searchQuery),
                disabled: isSearching,
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    height: "100%",
                    justify: "center",
                    background: "light-6",
                    alignSelf: "center",
                    border: {
                        side: 'left',
                        color: 'light-5',
                        size: '0.8px'
                    },
                    pad: {
                        horizontal: '0.75rem'
                    },
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $06bd06341dc4840c$export$4b85d3515bd863a5), {
                        size: "18px"
                    })
                })
            })
        ]
    });
};










const $e7d90faf51ccfde9$export$8d64ad56b7344b16 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(({ facility: facility, isVisible: isVisible, setIsVisible: setIsVisible, setShouldRefresh: setShouldRefresh, isCanada: isCanada = false })=>{
    /** Context **/ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const tooltips = (0, $d597772cdbe12609$export$4713da6aa4410043)();
    /** State **/ const [isLoading, setIsLoading] = (0, $2xPiy.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $2xPiy.useState)(false);
    const [isSelectingAll, setIsSelectingAll] = (0, $2xPiy.useState)(false);
    const [equipmentList, setEquipmentList] = (0, $2xPiy.useState)([]);
    const [selectedEquipmentIds, setSelectedEquipmentIds] = (0, $2xPiy.useState)([]);
    const [isConfirmed, setIsConfirmed] = (0, $2xPiy.useState)(false);
    const [currentPage, setCurrentPage] = (0, $2xPiy.useState)(1);
    const [limit] = (0, $2xPiy.useState)(20);
    const [metadata, setMetadata] = (0, $2xPiy.useState)();
    const [searchQuery, setSearchQuery] = (0, $2xPiy.useState)('');
    const [committedSearchQuery, setCommittedSearchQuery] = (0, $2xPiy.useState)('');
    const [isSearching, setIsSearching] = (0, $2xPiy.useState)(false);
    /** Computed **/ const canDelete = userStore.isFuseAdmin;
    const currentUsagePeriod = equipmentList?.[0]?.current_reporting_period_equipment_usage?.start_reporting_quarter;
    const selectedEquipmentIdSet = new Set(selectedEquipmentIds);
    const selectedOnPageCount = equipmentList.filter((eq)=>selectedEquipmentIdSet.has(eq.id)).length;
    const isPageSelected = !!equipmentList.length && selectedOnPageCount === equipmentList.length;
    const isPagePartiallySelected = selectedOnPageCount > 0 && selectedOnPageCount < equipmentList.length;
    const hasSelection = !!selectedEquipmentIds.length;
    /** Methods **/ const search = (query)=>{
        setSearchQuery(query);
        setCommittedSearchQuery(query);
        setIsSearching(query !== committedSearchQuery);
        setCurrentPage(1);
    };
    const loadEquipment = async (page = 1, serialNumber)=>{
        try {
            setIsLoading(true);
            const { data: data, meta: meta } = await (0, $64087c41a5036744$export$f3cdcae448e94402).list({
                facility_id: facility.id,
                is_active: true,
                is_finalized: false,
                page: page,
                limit: limit,
                ...serialNumber ? {
                    serial_number: serialNumber
                } : {}
            });
            setEquipmentList(data);
            setMetadata(meta);
            setCurrentPage(meta?.current_page ?? page);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listEquipment.error);
        } finally{
            setIsLoading(false);
            setIsSearching(false);
        }
    };
    const deleteEquipment = async ()=>{
        if (isDeleting || !selectedEquipmentIds.length) return;
        try {
            setIsDeleting(true);
            await (0, $64087c41a5036744$export$f3cdcae448e94402).delete({
                equipment_ids: selectedEquipmentIds
            });
            setShouldRefresh(true);
            setIsVisible(false);
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).deleteEquipment.success);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).deleteEquipment.error);
        } finally{
            setIsDeleting(false);
        }
    };
    const toggleSelection = (equipmentId)=>{
        setSelectedEquipmentIds((prev)=>prev.includes(equipmentId) ? prev.filter((id)=>id !== equipmentId) : [
                ...prev,
                equipmentId
            ]);
    };
    const toggleSelectPage = (checked)=>{
        const pageIds = equipmentList.map((eq)=>eq.id);
        const pageIdSet = new Set(pageIds);
        setSelectedEquipmentIds((prev)=>{
            const offPageIds = prev.filter((id)=>!pageIdSet.has(id));
            return checked ? [
                ...offPageIds,
                ...pageIds
            ] : offPageIds;
        });
    };
    const selectAll = async ()=>{
        if (isSelectingAll || !metadata?.total) return;
        try {
            setIsSelectingAll(true);
            const { data: data } = await (0, $64087c41a5036744$export$f3cdcae448e94402).list({
                facility_id: facility.id,
                is_active: true,
                is_finalized: false,
                page: 1,
                limit: metadata.total,
                ...committedSearchQuery ? {
                    serial_number: committedSearchQuery
                } : {}
            });
            setSelectedEquipmentIds((prev)=>Array.from(new Set([
                    ...prev,
                    ...data.map((eq)=>eq.id)
                ])));
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listEquipment.error);
        } finally{
            setIsSelectingAll(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (isVisible) {
            setSelectedEquipmentIds([]);
            setIsConfirmed(false);
            setCurrentPage(1);
            setSearchQuery('');
            setCommittedSearchQuery('');
        }
    }, [
        isVisible,
        facility.id
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (!canDelete && isVisible) setIsVisible(false);
    }, [
        canDelete,
        isVisible
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (isVisible && currentPage) loadEquipment(currentPage, committedSearchQuery || undefined);
    }, [
        isVisible,
        currentPage,
        committedSearchQuery
    ]);
    /** Render **/ const renderDataTable = ()=>{
        return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            elevation: "small",
            round: "xsmall",
            overflow: "hidden",
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                },
                primaryKey: "id",
                columns: [
                    {
                        property: 'select',
                        size: '3%',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                            checked: isPageSelected,
                            indeterminate: isPagePartiallySelected,
                            onChange: (e)=>toggleSelectPage(e.target.checked)
                        }),
                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                                checked: selectedEquipmentIdSet.has(equipment.id),
                                onChange: ()=>toggleSelection(equipment.id)
                            })
                    },
                    {
                        property: 'id',
                        size: '3%',
                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                pad: {
                                    vertical: 'small'
                                },
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                                    to: `/clients/${equipment.client_id}/equipment/${equipment.id}`,
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                        direction: "row",
                                        round: "6px",
                                        justify: "center",
                                        align: "center",
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ceab9ef72b825454$export$c92c6401b52a9298), {
                                            content: tooltips.viewEquipmentDetails,
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f97d8419a136e9e9$export$6d128738bddfaa67), {
                                                size: "16px",
                                                color: "accent-1"
                                            })
                                        })
                                    })
                                })
                            })
                    },
                    {
                        property: 'equipment_type.name',
                        size: '17%',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('equipment:chargingType')
                        }),
                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: equipment.equipment_type.name
                            })
                    },
                    {
                        property: 'is_active',
                        align: 'center',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('common:status')
                        }),
                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: equipment.is_active ? (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Active : (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Retired
                            })
                    },
                    {
                        property: 'is_metered',
                        size: '8%',
                        align: 'center',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('equipment:meter')
                        }),
                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                direction: "row",
                                children: equipment.is_metered && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b480de5bf3618c14$export$fe82a520fc33e5f4), {
                                    size: "20px"
                                }) || '-'
                            })
                    },
                    {
                        property: 'serial_number',
                        size: '13%',
                        align: 'center',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('equipment:serialVin')
                        }),
                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: equipment.serial_number?.length >= 22 ? `${equipment.serial_number?.slice(0, 4)}...${equipment.serial_number?.slice(-4)}` : equipment.serial_number || '-'
                            })
                    },
                    {
                        property: 'manufacturer',
                        size: '12%',
                        align: 'center',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('equipment:manufacturer')
                        }),
                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: equipment.manufacturer || '-'
                            })
                    },
                    {
                        property: 'model_year',
                        size: '11%',
                        align: 'center',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('equipment:modelYear')
                        }),
                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: equipment.model_year || '-'
                            })
                    },
                    {
                        property: 'model_number',
                        size: '13%',
                        align: 'center',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('equipment:modelNumber')
                        }),
                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: equipment.model_number || '-'
                            })
                    },
                    {
                        property: 'unit_number',
                        size: '11%',
                        align: 'center',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('equipment:unitNo')
                        }),
                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: equipment.unit_number || '-'
                            })
                    },
                    {
                        property: 'total_kwh',
                        size: '12%',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "small",
                                        children: t('common:totalKwh')
                                    }),
                                    currentUsagePeriod && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "small",
                                        children: [
                                            "(",
                                            (0, $00658ccd6ec0135a$export$f96ebb633255a704)(currentUsagePeriod, isCanada),
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        }),
                        render: (equipment)=>equipment.current_reporting_period_equipment_usage?.total_kwh ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: (0, $00658ccd6ec0135a$export$f5dd818bff069720)(equipment.current_reporting_period_equipment_usage.total_kwh, true, false, false, 4),
                                unitName: "kWh"
                            }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: "-"
                            })
                    }
                ],
                data: equipmentList,
                sortable: true,
                background: [
                    'light-6',
                    'white'
                ],
                border: {
                    color: 'light-2',
                    side: 'bottom',
                    size: 'small'
                }
            })
        });
    };
    return isVisible ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
        position: "center",
        onEsc: ()=>setIsVisible(false),
        onClickOutside: ()=>setIsVisible(false),
        responsive: false,
        style: {
            width: '95%',
            maxWidth: '1400px',
            maxHeight: '95vh',
            overflow: 'auto',
            borderRadius: '8px'
        },
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $98b6153ed086d9bd$export$11154b700737b45e), {
            width: "100%",
            title: t('equipment:deleteEquipment'),
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d8fcb0015cca0f72$export$825a3c81a577bf46), {
                entityName: (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Equipment
            }),
            onSubmit: ()=>deleteEquipment(),
            isLoading: isLoading || isDeleting,
            hideRequiredText: true,
            saveButtonLabel: "DELETE",
            saveButtonLoadingLabel: "DELETING...",
            saveButtonDisabled: !isConfirmed || !selectedEquipmentIds.length,
            headerChildren: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                    pad: "none",
                    onClick: ()=>setIsVisible(false),
                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c1da19823027de53$export$f39c2d165cd861fe), {
                        size: "20px"
                    }),
                    tip: t('common:close')
                }, "close")
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                pad: {
                    horizontal: 'medium',
                    bottom: 'medium'
                },
                gap: "medium",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                        gap: "1rem",
                        direction: "row",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e23e190c1adfeb13$export$a2518b5310db22ab), {
                                size: "medium",
                                color: "status-warning"
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                children: t('equipment:deleteWarning', 'Warning: This action will permanently delete the selected equipment. This action cannot be undone.')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        direction: "row",
                        align: "end",
                        justify: "between",
                        children: [
                            hasSelection && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                                gap: "1rem",
                                direction: "row",
                                align: "center",
                                background: {
                                    color: 'status-error',
                                    dark: true
                                },
                                pad: "medium",
                                round: "small",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                                        checked: isConfirmed,
                                        onChange: ()=>setIsConfirmed(!isConfirmed),
                                        color: "white"
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        color: "white",
                                        children: t('equipment:deleteMultipleConfirmation', {
                                            count: selectedEquipmentIds.length
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                direction: "row",
                                align: "center",
                                gap: "small",
                                margin: {
                                    left: 'auto'
                                },
                                children: [
                                    hasSelection && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "small",
                                        children: t('common:selectedCount', {
                                            count: selectedEquipmentIds.length
                                        })
                                    }),
                                    (hasSelection || !!metadata?.total) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $85ab7488c493b81c$export$6d88ebe453be59d7), {
                                        label: hasSelection ? t('common:clearAll') : `${t('common:selectAll')} (${metadata?.total})`,
                                        onClick: ()=>{
                                            setIsConfirmed(false);
                                            if (hasSelection) setSelectedEquipmentIds([]);
                                            else selectAll();
                                        },
                                        disabled: isSelectingAll || isLoading || isSearching
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f7f71094d2af306c$export$55d7609a8f1eccd2), {
                                        searchQuery: searchQuery,
                                        placeholder: t('equipment:searchBySerial'),
                                        setSearchQuery: setSearchQuery,
                                        onSearch: search,
                                        isSearching: isSearching
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        gap: "small",
                        children: isLoading ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            pad: {
                                vertical: 'medium'
                            },
                            height: "10vh",
                            fill: "horizontal",
                            justify: "center",
                            align: "center",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8bec6e2e7dc53c4a$export$7f7cbe89f1eacd2), {
                                size: "medium"
                            })
                        }) : equipmentList.length ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
                            children: [
                                renderDataTable(),
                                metadata && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    pad: {
                                        top: 'medium'
                                    },
                                    justify: "center",
                                    align: "center",
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ffccbada2139938a$export$68f5e1453c188a82), {
                                        alignSelf: "center",
                                        size: "small",
                                        page: currentPage,
                                        step: metadata.per_page,
                                        numberItems: metadata.total,
                                        onChange: (e)=>setCurrentPage(e.page)
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            pad: {
                                horizontal: 'small',
                                vertical: 'medium'
                            },
                            background: "light-6",
                            align: "center",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: "medium",
                                fontFamily: "Lato, sans-serif",
                                children: t('equipment:noEquipmentFound', 'No equipment found.')
                            })
                        })
                    })
                ]
            })
        })
    }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cb4cc5db45d03478$exports.Fragment), {});
});




var $2xPiy = parcelRequire("2xPiy");




var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");








var $dyr1f = parcelRequire("dyr1f");

function $9de00d0723a30a2b$var$_extends() {
    return $9de00d0723a30a2b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9de00d0723a30a2b$var$_extends.apply(null, arguments);
}
var $9de00d0723a30a2b$var$VERTICAL_ALIGN_OPTIONS = [
    'top',
    'bottom'
];
var $9de00d0723a30a2b$var$HORIZONTAL_ALIGN_OPTIONS = [
    'right',
    'left'
];
var $9de00d0723a30a2b$var$PropType = {};
$9de00d0723a30a2b$var$PropType = $9de00d0723a30a2b$var$_extends({}, (0, $ab32ce3df36aa105$export$ffe37ff34eeb9e21), {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node
    ]),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    dropAlign: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        top: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($9de00d0723a30a2b$var$VERTICAL_ALIGN_OPTIONS),
        bottom: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($9de00d0723a30a2b$var$VERTICAL_ALIGN_OPTIONS),
        left: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($9de00d0723a30a2b$var$HORIZONTAL_ALIGN_OPTIONS),
        right: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($9de00d0723a30a2b$var$HORIZONTAL_ALIGN_OPTIONS)
    }),
    dropBackground: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            color: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            opacity: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
                    'weak',
                    'medium',
                    'strong'
                ])
            ])
        })
    ]),
    dropTarget: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object,
    dropProps: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object,
    justifyContent: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'start',
        'center',
        'end',
        'between',
        'around',
        'stretch'
    ]),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node
    ]),
    items: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object))
    ]),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node
    ]),
    messages: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        closeMenu: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        openMenu: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    }),
    open: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ])
});
var $9de00d0723a30a2b$export$debf9a822325d3f0 = $9de00d0723a30a2b$var$PropType;



var $41d136aeffe9860f$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "children",
    "disabled",
    "dropAlign",
    "dropBackground",
    "dropProps",
    "dropTarget",
    "justifyContent",
    "icon",
    "items",
    "label",
    "messages",
    "onKeyDown",
    "open",
    "plain",
    "size"
], $41d136aeffe9860f$var$_excluded2 = [
    "align"
];
function $41d136aeffe9860f$var$_extends() {
    return $41d136aeffe9860f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $41d136aeffe9860f$var$_extends.apply(null, arguments);
}
function $41d136aeffe9860f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $41d136aeffe9860f$var$ContainerBox = (0, $iA1nz.default)((0, $18c0523379e5dd9d$export$e71c4d32a2263218)).withConfig({
    displayName: "Menu__ContainerBox",
    componentId: "sc-17fcys9-0"
})([
    "max-height:inherit;@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){width:100%;}&:focus{outline:none;}",
    ";"
], function(props) {
    return props.theme.menu.extend;
});
/* Notes on keyboard interactivity (based on W3) // For details reference: https://www.w3.org/TR/wai-aria-practices/#menu

To open menu when menu button is focused:
- Space/Enter/Up arrow/Down arrow will open menu

To navigate within menu:
- Up/down arrow keys can be used and will loop through options
(keeping focus within the Menu)
- Tab can be used, but once the last menu item is reached, Tab will close the
Menu and continue through page content.

To close the menu:
- Tabbing beyond the first or last menu item.
- Esc will close the menu
- Select a menu item

To make a selection:
- Enter key is pressed.
- Space is pressed.
*/ var $41d136aeffe9860f$var$defaultItems = [];
var $41d136aeffe9860f$export$d9b273488cd8ce6f = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    var _theme$menu$disabled;
    var a11yTitle = props.a11yTitle, ariaLabel = props['aria-label'], children = props.children, disabled = props.disabled, dropAlign = props.dropAlign, dropBackground = props.dropBackground, dropProps = props.dropProps, dropTarget = props.dropTarget, _props$justifyContent = props.justifyContent, justifyContent = _props$justifyContent === void 0 ? 'start' : _props$justifyContent, icon = props.icon, _props$items = props.items, items = _props$items === void 0 ? $41d136aeffe9860f$var$defaultItems : _props$items, label = props.label, messages = props.messages, onKeyDown = props.onKeyDown, open = props.open, plain = props.plain, size = props.size, rest = $41d136aeffe9860f$var$_objectWithoutPropertiesLoose(props, $41d136aeffe9860f$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useContext = (0, $2xPiy.useContext)((0, $f1ad7bf122eed3b0$export$b060d577040138d8)), format = _useContext.format;
    var iconColor = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(theme.menu.icons.color || 'control', theme);
    var iconDisabledColor = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(((_theme$menu$disabled = theme.menu.disabled) == null || (_theme$menu$disabled = _theme$menu$disabled.icons) == null ? void 0 : _theme$menu$disabled.color) || theme.menu.icons.color || 'control', theme);
    // need to destructure the align otherwise it will get passed through
    // to DropButton and override prop values
    var _theme$menu$drop = theme.menu.drop, themeDropAlign = _theme$menu$drop.align, themeDropProps = $41d136aeffe9860f$var$_objectWithoutPropertiesLoose(_theme$menu$drop, $41d136aeffe9860f$var$_excluded2);
    var a11y = ariaLabel || a11yTitle;
    // total number of menu items
    var itemCount = (0, $2xPiy.useMemo)(function() {
        var count = 0;
        if (items && Array.isArray(items[0])) items.forEach(function(group) {
            count += group.length;
        });
        else count = items.length;
        return count;
    }, [
        items
    ]);
    var align = dropProps && dropProps.align || dropAlign || themeDropAlign;
    var controlButtonIndex = (0, $2xPiy.useMemo)(function() {
        if (align.top === 'top') return -1;
        if (align.bottom === 'bottom') return itemCount;
        return undefined;
    }, [
        align,
        itemCount
    ]);
    // Keeps track of whether menu options should be mirrored
    // when there's not enough space below DropButton. This state
    // is modified on /Drop/DropContainer.js.
    var _useState = (0, $2xPiy.useState)(), alignControlMirror = _useState[0], setAlignControlMirror = _useState[1];
    var initialAlignTop = alignControlMirror === align.top;
    var dropContainerRef = (0, $2xPiy.useRef)();
    var buttonRefs = (0, $2xPiy.useRef)([]);
    var constants = (0, $2xPiy.useMemo)(function() {
        return {
            none: 'none',
            tab: 9,
            // Menu control button included on top of menu items
            controlTop: align.top === 'top' || undefined,
            // Menu control button included on the bottom of menu items
            controlBottom: align.bottom === 'bottom' || undefined,
            controlButtonIndex: controlButtonIndex
        };
    }, [
        align,
        controlButtonIndex
    ]);
    var _useState2 = (0, $2xPiy.useState)(constants.none), activeItemIndex = _useState2[0], setActiveItemIndex = _useState2[1];
    var _useState3 = (0, $2xPiy.useState)(open || false), isOpen = _useState3[0], setOpen = _useState3[1];
    var MenuIcon = isOpen && theme.menu.icons.up ? theme.menu.icons.up : theme.menu.icons.down;
    var onDropClose = (0, $2xPiy.useCallback)(function() {
        setActiveItemIndex(constants.none);
        setOpen(false);
    }, [
        constants.none
    ]);
    var onDropOpen = (0, $2xPiy.useCallback)(function() {
        setOpen(true);
    }, []);
    (0, $2xPiy.useEffect)(function() {
        // need to wait for Drop to be ready
        var timer = setTimeout(function() {
            if (isOpen) {
                var optionsNode = dropContainerRef.current;
                if (optionsNode) optionsNode.focus();
            }
        }, 100);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        isOpen
    ]);
    var onSelectMenuItem = function onSelectMenuItem(event) {
        if (isOpen) {
            if (activeItemIndex >= 0) {
                event.preventDefault();
                event.stopPropagation();
                buttonRefs.current[activeItemIndex].click();
            }
        } else onDropOpen();
    };
    var isTab = function isTab(event) {
        return event.keyCode === constants.tab || event.which === constants.tab;
    };
    var onNextMenuItem = function onNextMenuItem(event) {
        event.preventDefault();
        if (!isOpen) onDropOpen();
        else if (isTab(event) && (!constants.controlBottom && activeItemIndex === itemCount - 1 || constants.controlBottom && activeItemIndex === controlButtonIndex)) // User has reached end of the menu, this tab will close
        // the menu drop because there are no more "next items" to access
        onDropClose();
        else {
            var index;
            if (// This checks if the user has reached the end of the menu.
            // In the case the the menu control button is located at the
            // bottom of the menu, it checks if the user has reached the button.
            // Otherwise, it checks if the user is at the last menu item.
            constants.controlBottom && activeItemIndex === controlButtonIndex || !constants.controlBottom && activeItemIndex === itemCount - 1 || activeItemIndex === constants.none) // place focus on the first menu item
            index = 0;
            else index = activeItemIndex + 1;
            setActiveItemIndex(index);
            if (buttonRefs.current[index]) buttonRefs.current[index].focus();
        }
    };
    var onPreviousMenuItem = function onPreviousMenuItem(event) {
        event.preventDefault();
        if (!isOpen) onDropOpen();
        else if (isTab(event) && (constants.controlTop && activeItemIndex === controlButtonIndex || !constants.controlTop && activeItemIndex - 1 < 0)) // User has reached beginning of the menu, this tab will close
        // the menu drop because there are no more "previous items" to access
        onDropClose();
        else {
            var index;
            if (activeItemIndex === 'none') index = itemCount - 1;
            else if (activeItemIndex - 1 < 0) {
                if (constants.controlTop && activeItemIndex - 1 === controlButtonIndex) index = itemCount;
                else index = itemCount - 1;
            } else index = activeItemIndex - 1;
            setActiveItemIndex(index);
            if (buttonRefs.current[index]) buttonRefs.current[index].focus();
        }
    };
    var menuIcon = icon !== false ? icon !== true && icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(MenuIcon, {
        color: disabled ? iconDisabledColor : iconColor,
        size: size
    }) : null;
    var buttonProps = {
        plain: plain,
        size: size
    };
    var content;
    if (children) content = children;
    else if (!theme.button["default"]) /*
    Not adding a theme object now because this code path
    is not used in the HPE theme, but we may add theme
    support here in the future.
    */ content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        direction: "row",
        justify: justifyContent,
        align: "center",
        pad: "small",
        gap: label && icon !== false ? 'small' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), {
        size: size
    }, label), menuIcon);
    else {
        // when a theme has theme.button.default, keep content as
        // undefined so we can rely on Button label & icon props
        buttonProps = {
            icon: menuIcon,
            label: label,
            plain: plain,
            reverse: true,
            size: size
        };
        content = undefined;
    }
    var controlMirror = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        flex: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), $41d136aeffe9860f$var$_extends({
        ref: function ref(r) {
            // make it accessible at the end of all menu items
            buttonRefs.current[itemCount] = r;
        },
        a11yTitle: a11y || format({
            id: 'menu.closeMenu',
            messages: messages
        }),
        active: activeItemIndex === controlButtonIndex,
        focusIndicator: false,
        hoverIndicator: "background",
        onClick: onDropClose,
        onFocus: function onFocus() {
            return setActiveItemIndex(controlButtonIndex);
        },
        tabIndex: activeItemIndex === constants.none ? '-1' : undefined
    }, theme.menu.item, buttonProps), typeof content === 'function' ? function() {
        return content($41d136aeffe9860f$var$_extends({}, props, {
            drop: true
        }));
    } : content));
    var menuItem = function menuItem(item, index) {
        var _theme$menu$item, _theme$menu$item2, _theme$menu$item3, _theme$menu$item4;
        // Determine whether the label is done as a child or
        // as an option Button kind property.
        var child = !theme.button.option ? /*#__PURE__*/ /*
    Not adding a theme object now because this code path
    is not used in the HPE theme, but we may add theme
    support here in the future.
    */ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            align: ((_theme$menu$item = theme.menu.item) == null ? void 0 : _theme$menu$item.align) || 'start',
            pad: "small",
            direction: "row",
            gap: item.gap || ((_theme$menu$item2 = theme.menu.item) == null ? void 0 : _theme$menu$item2.gap),
            justify: item.justify || ((_theme$menu$item3 = theme.menu.item) == null ? void 0 : _theme$menu$item3.justify)
        }, item.reverse && item.label, item.icon, !item.reverse && item.label) : undefined;
        // if we have a child, turn on plain, and hoverIndicator
        return(/*#__PURE__*/ // lint isn't flagging this but we shouldn't use index as a key
        // see no-array-index-key lint rule
        (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            key: index,
            flex: false,
            role: "none"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), $41d136aeffe9860f$var$_extends({
            ref: function ref(r) {
                buttonRefs.current[index] = r;
            },
            role: "menuitem",
            onFocus: function onFocus() {
                setActiveItemIndex(index);
            },
            active: activeItemIndex === index,
            focusIndicator: false,
            plain: !child ? undefined : true,
            align: "start",
            kind: !child ? 'option' : undefined,
            hoverIndicator: !child ? undefined : 'background'
        }, theme.menu.item, {
            justify: item.justify || ((_theme$menu$item4 = theme.menu.item) == null ? void 0 : _theme$menu$item4.justify)
        }, !child ? item : $41d136aeffe9860f$var$_extends({}, item, {
            gap: undefined,
            icon: undefined,
            label: undefined,
            reverse: undefined
        }), {
            onClick: function onClick() {
                if (item.onClick) item.onClick.apply(item, arguments);
                if (item.close !== false) onDropClose();
            }
        }), child)));
    };
    var menuContent;
    var grouped = itemCount && Array.isArray(items[0]);
    if (grouped) {
        var index = 0;
        menuContent = items.map(function(group, groupIndex) {
            var _theme$menu$group, _theme$menu$group2, _theme$menu$group3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                key: groupIndex,
                flex: false
            }, groupIndex > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                pad: theme.menu.group.separator.pad
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                border: {
                    side: 'top',
                    color: (_theme$menu$group = theme.menu.group) == null || (_theme$menu$group = _theme$menu$group.separator) == null ? void 0 : _theme$menu$group.color,
                    size: (_theme$menu$group2 = theme.menu.group) == null || (_theme$menu$group2 = _theme$menu$group2.separator) == null ? void 0 : _theme$menu$group2.size
                }
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), $41d136aeffe9860f$var$_extends({}, theme.menu.container, (_theme$menu$group3 = theme.menu.group) == null ? void 0 : _theme$menu$group3.container), group.map(function(item) {
                // item index needs to be its index in the entire menu as if
                // it were a flat array
                var currentIndex = index;
                index += 1;
                return menuItem(item, currentIndex);
            })));
        });
    } else menuContent = items.map(function(item, index) {
        return menuItem(item, index);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $168667f04da9206c$export$16e4d70cc375e707), {
        onDown: onDropOpen,
        onUp: onDropOpen,
        onSpace: onSelectMenuItem,
        onEsc: onDropClose,
        onTab: onDropClose,
        onKeyDown: onKeyDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $c9158ac1cba12f75$export$64fff40e709e8b2e), $41d136aeffe9860f$var$_extends({
        ref: ref
    }, rest, buttonProps, {
        a11yTitle: a11y || format({
            id: 'menu.openMenu',
            messages: messages
        }),
        "aria-haspopup": "menu",
        "aria-expanded": isOpen,
        onAlign: setAlignControlMirror,
        disabled: disabled,
        dropAlign: align,
        dropTarget: dropTarget,
        dropProps: dropProps || themeDropProps,
        open: isOpen,
        onOpen: onDropOpen,
        onClose: onDropClose,
        dropContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $168667f04da9206c$export$16e4d70cc375e707), {
            onTab: function onTab(event) {
                return event.shiftKey ? onPreviousMenuItem(event) : onNextMenuItem(event);
            },
            onDown: onNextMenuItem,
            onUp: onPreviousMenuItem,
            onEnter: onSelectMenuItem
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($41d136aeffe9860f$var$ContainerBox, $41d136aeffe9860f$var$_extends({
            ref: dropContainerRef,
            tabIndex: -1,
            background: dropBackground || theme.menu.background
        }, passThemeFlag), alignControlMirror === 'top' && align.bottom !== 'top' && align.top !== 'bottom' ? controlMirror : undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), $41d136aeffe9860f$var$_extends({
            overflow: "auto",
            role: "menu",
            a11yTitle: a11y
        }, !grouped ? theme.menu.container : {}), menuContent), !initialAlignTop && // don't show controlMirror if caller is using
        // align.bottom === 'top'
        alignControlMirror === 'bottom' && align.bottom !== 'top' && align.top !== 'bottom' ? controlMirror : undefined))
    }), content));
});
$41d136aeffe9860f$export$d9b273488cd8ce6f.displayName = 'Menu';
$41d136aeffe9860f$export$d9b273488cd8ce6f.propTypes = (0, $9de00d0723a30a2b$export$debf9a822325d3f0);











const $5c08d54bb3238b41$var$EQUIPMENT_LIST_DEFAULTS = {
    page: 1,
    search: '',
    is_active: 'true',
    is_metered: undefined
};
const $5c08d54bb3238b41$var$EQUIPMENT_LIST_CLEARED = {
    ...$5c08d54bb3238b41$var$EQUIPMENT_LIST_DEFAULTS,
    is_active: '',
    is_metered: undefined
};
const $5c08d54bb3238b41$export$ff2589847bbc6a39 = (props)=>{
    const { title: title, clientId: clientId, facilityId: facilityId, isCanada: isCanada, showAddButton: showAddButton, showShareButton: showShareButton, showFilters: showFilters, showSearchInput: showSearchInput, isLoading: propIsLoading, equipment: propEquipment, fetchEquipment: propFetchEquipment, currentPage: propCurrentPage, setCurrentPage: propSetCurrentPage, metadata: propMetadata, hideHeader: hideHeader, surfaceId: surfaceId, standalone: standalone = false, mode: mode = 'query', ...boxProps } = props;
    const isPropControlled = mode === 'controlled';
    /** Context **/ const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const facilityStore = (0, $116967e0234c3770$export$1fa40d59fe105eba)();
    const tooltips = (0, $d597772cdbe12609$export$4713da6aa4410043)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** Restorable state **/ const restorableList = (0, $d73aac7e90cb996d$export$e4108de26414712f)({
        surfaceId: surfaceId || 'equipment-list',
        defaults: $5c08d54bb3238b41$var$EQUIPMENT_LIST_DEFAULTS,
        standalone: standalone
    });
    const queryState = restorableList.state;
    const setQueryState = restorableList.setState;
    /** Draft state **/ const [draftSearch, setDraftSearch] = (0, $2xPiy.useState)(queryState.search);
    const [draftFilters, setDraftFilters] = (0, $2xPiy.useState)({
        is_active: queryState.is_active,
        is_metered: queryState.is_metered
    });
    /** Modal state **/ const [showEquipmentModal, setShowEquipmentModal] = (0, $2xPiy.useState)(false);
    const [showEditUnmetered, setShowEditUnmetered] = (0, $2xPiy.useState)(false);
    const [showEditMetered, setShowEditMetered] = (0, $2xPiy.useState)(false);
    const [showRetireMultipleModal, setShowRetireMultipleModal] = (0, $2xPiy.useState)(false);
    const [showDeleteMultipleModal, setShowDeleteMultipleModal] = (0, $2xPiy.useState)(false);
    /** Permission state **/ const [userCanRetire, setUserCanRetire] = (0, $2xPiy.useState)(false);
    const [userCanDelete, setUserCanDelete] = (0, $2xPiy.useState)(false);
    const [hasMeteredEquipment, setHasMeteredEquipment] = (0, $2xPiy.useState)(false);
    /** UI state **/ const [isFiltersMenuOpen, setIsFiltersMenuOpen] = (0, $2xPiy.useState)(false);
    const [isFiltersMenuHovered, setIsFiltersMenuHovered] = (0, $2xPiy.useState)(false);
    const [isMenuOpen] = (0, $2xPiy.useState)(false);
    const [isMenuHovered, setIsMenuHovered] = (0, $2xPiy.useState)(false);
    const request = (0, $2xPiy.useMemo)(()=>({
            facility_id: facilityId,
            page: queryState.page,
            limit: 20,
            serial_number: queryState.search || undefined,
            is_active: queryState.is_active === 'true' ? true : queryState.is_active === 'false' ? false : undefined,
            is_metered: queryState.is_metered === 'true' ? true : queryState.is_metered === 'false' ? false : undefined
        }), [
        queryState,
        facilityId
    ]);
    /** React Query **/ const { data: queryData, isLoading: queryIsLoading, isFetching: isFetching, error: queryError, refetch: refetch } = (0, $4130e158515cd100$export$dd0a697e1782aedd)({
        queryKey: [
            'equipment',
            userStore.user?.id,
            request
        ],
        queryFn: ()=>(0, $64087c41a5036744$export$f3cdcae448e94402).list(request),
        enabled: !isPropControlled && !!userStore.user,
        placeholderData: (prev)=>prev
    });
    const queryEquipment = queryData?.data;
    const queryMetadata = queryData?.meta;
    /** Show toast on query error **/ (0, $2xPiy.useEffect)(()=>{
        if (queryError && !isPropControlled) globalStore.handleApiError(queryError, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listEquipment.error);
    }, [
        queryError
    ]);
    /** Fetch facility metadata **/ (0, $2xPiy.useEffect)(()=>{
        if (isPropControlled || !facilityId || Number.isNaN(facilityId)) return;
        facilityStore.fetchFacility(facilityId);
    }, [
        facilityId,
        isPropControlled
    ]);
    /** Check equipment counts for menu permissions **/ (0, $2xPiy.useEffect)(()=>{
        if (isPropControlled || !facilityId || Number.isNaN(facilityId)) return;
        let cancelled = false;
        const setIfCurrent = (setter)=>(value)=>{
                if (!cancelled) setter(value);
            };
        const hasMatches = (filter)=>(0, $64087c41a5036744$export$f3cdcae448e94402).list({
                facility_id: facilityId,
                limit: 1,
                page: 1,
                ...filter
            }).then((equipmentList)=>(equipmentList.meta?.total ?? 0) > 0).catch(()=>false);
        const hasRetireAccess = userStore.isFuseAdmin || (userStore.isClientAdmin || userStore.isFacilityAdmin) && (userStore.user?.facilities.some((f)=>f.id === facilityId) ?? false);
        if (hasRetireAccess) hasMatches({
            is_active: true
        }).then(setIfCurrent(setUserCanRetire));
        else setUserCanRetire(false);
        if (userStore.isFuseAdmin) hasMatches({
            is_active: true,
            is_finalized: false
        }).then(setIfCurrent(setUserCanDelete));
        else setUserCanDelete(false);
        hasMatches({
            is_metered: true
        }).then(setIfCurrent(setHasMeteredEquipment));
        return ()=>{
            cancelled = true;
        };
    }, [
        facilityId,
        isPropControlled,
        userStore.isFuseAdmin,
        userStore.isClientAdmin,
        userStore.isFacilityAdmin
    ]);
    /** Resolved values **/ const _equipment = propEquipment ?? queryEquipment;
    const _metadata = propMetadata ?? queryMetadata;
    const _currentPage = propCurrentPage ?? queryState.page;
    const _isLoading = propIsLoading ?? (isPropControlled ? false : queryIsLoading || isFetching);
    const isRefetching = isFetching && !queryIsLoading;
    const hasEquipment = !!_equipment?.length;
    const noResultsMessage = (0, $2xPiy.useMemo)(()=>{
        const activeMessage = queryState.is_active === 'true' ? 'active' : queryState.is_active === 'false' ? 'inactive' : '';
        const meteredMessage = queryState.is_metered === 'true' ? 'metered' : queryState.is_metered === 'false' ? 'non-metered' : '';
        return `No ${activeMessage} ${meteredMessage} equipment found.`;
    }, [
        queryState.is_active,
        queryState.is_metered
    ]);
    /** Methods **/ const search = (0, $2xPiy.useCallback)((query)=>{
        setQueryState({
            search: query || '',
            page: 1
        });
    }, [
        setQueryState
    ]);
    const applyFilters = (0, $2xPiy.useCallback)(()=>{
        setQueryState({
            is_active: draftFilters.is_active,
            is_metered: draftFilters.is_metered,
            page: 1
        });
        setIsFiltersMenuOpen(false);
    }, [
        setQueryState,
        draftFilters
    ]);
    const clearFilters = (0, $2xPiy.useCallback)(()=>{
        setDraftFilters({
            is_active: $5c08d54bb3238b41$var$EQUIPMENT_LIST_CLEARED.is_active,
            is_metered: $5c08d54bb3238b41$var$EQUIPMENT_LIST_CLEARED.is_metered
        });
        setDraftSearch('');
        setQueryState($5c08d54bb3238b41$var$EQUIPMENT_LIST_CLEARED);
        setIsFiltersMenuOpen(false);
    }, [
        setQueryState
    ]);
    const handlePageChange = (0, $2xPiy.useCallback)((page)=>{
        if (isPropControlled) {
            propSetCurrentPage?.(page);
            propFetchEquipment?.(page);
        } else setQueryState({
            page: page
        });
    }, [
        isPropControlled,
        propSetCurrentPage,
        propFetchEquipment,
        setQueryState
    ]);
    /** shouldRefresh handler */ const handleShouldRefresh = (0, $2xPiy.useCallback)(async ()=>{
        await refetch();
    }, [
        refetch
    ]);
    /** Sync page from API response **/ (0, $2xPiy.useEffect)(()=>{
        if (queryMetadata && !isPropControlled && queryMetadata.current_page !== queryState.page) setQueryState({
            page: queryMetadata.current_page
        });
    }, [
        queryMetadata?.current_page
    ]);
    /** Sync drafts when queryState changes **/ (0, $d73aac7e90cb996d$export$b5b12661e3d1fa94)(queryState, setDraftSearch, (s)=>s.search);
    (0, $d73aac7e90cb996d$export$b5b12661e3d1fa94)(queryState, setDraftFilters, (s)=>({
            is_active: s.is_active,
            is_metered: s.is_metered
        }));
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        fill: "horizontal",
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                row: true,
                gap: "medium",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
                        ...boxProps,
                        children: [
                            !hideHeader && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                                title: title || t('equipment:equipmentList'),
                                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $321042383c42af9d$export$ee6a9ec6ae3156df), {
                                    size: "24"
                                }),
                                ...showShareButton && {
                                    button: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ce7c3f634dc2ea76$export$c9915453de10000b), {
                                        size: "17px"
                                    }),
                                    buttonNavigatePath: `/clients/${clientId}/facilities/${facilityId}/equipment`,
                                    buttonTooltip: (0, $d597772cdbe12609$export$4713da6aa4410043)().equipmentPageLink
                                },
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    direction: "row",
                                    gap: "small",
                                    children: [
                                        showSearchInput && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            "data-tour": "equipment-search",
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f7f71094d2af306c$export$55d7609a8f1eccd2), {
                                                searchQuery: draftSearch,
                                                placeholder: t('equipment:searchBySerial'),
                                                setSearchQuery: setDraftSearch,
                                                onSearch: search,
                                                isSearching: isRefetching
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c9158ac1cba12f75$export$64fff40e709e8b2e), {
                                            plain: true,
                                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $eec4bc4b18205d01$export$ec91da630f36d5ea), {
                                                color: isFiltersMenuHovered || isFiltersMenuOpen ? 'brand' : undefined
                                            }),
                                            open: isFiltersMenuOpen,
                                            onOpen: ()=>setIsFiltersMenuOpen(true),
                                            onClose: ()=>setIsFiltersMenuOpen(false),
                                            onMouseOver: ()=>setIsFiltersMenuHovered(true),
                                            onMouseOut: ()=>setIsFiltersMenuHovered(false),
                                            tip: tooltips.filterEquipment,
                                            dropAlign: {
                                                right: 'right',
                                                top: 'bottom'
                                            },
                                            dropContent: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d5dc00f4222e17dc$export$c9824d87391788f3), {
                                                isFiltering: isRefetching,
                                                onSubmit: ()=>applyFilters(),
                                                onClear: ()=>clearFilters(),
                                                filters: [
                                                    {
                                                        label: t('equipment:activityStatus'),
                                                        value: draftFilters.is_active ?? '',
                                                        setValue: (value)=>setDraftFilters({
                                                                ...draftFilters,
                                                                is_active: value || undefined
                                                            }),
                                                        options: [
                                                            {
                                                                label: t('common:all'),
                                                                value: ''
                                                            },
                                                            {
                                                                label: t('common:active'),
                                                                value: 'true'
                                                            },
                                                            {
                                                                label: t('common:retired'),
                                                                value: 'false'
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        label: t('equipment:meterType'),
                                                        value: draftFilters.is_metered ?? '',
                                                        setValue: (value)=>setDraftFilters({
                                                                ...draftFilters,
                                                                is_metered: value || undefined
                                                            }),
                                                        options: [
                                                            {
                                                                label: t('common:all'),
                                                                value: ''
                                                            },
                                                            {
                                                                label: t('equipment:metered'),
                                                                value: 'true'
                                                            },
                                                            {
                                                                label: t('equipment:unmetered'),
                                                                value: 'false'
                                                            }
                                                        ]
                                                    }
                                                ]
                                            })
                                        }),
                                        facilityStore.facility?.is_active && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            "data-tour": "equipment-actions-button",
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $41d136aeffe9860f$export$d9b273488cd8ce6f), {
                                                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $93663f13c4b467ae$export$d9b273488cd8ce6f), {
                                                    color: isMenuHovered || isMenuOpen ? 'brand' : undefined
                                                }),
                                                onMouseOver: ()=>setIsMenuHovered(true),
                                                onMouseOut: ()=>setIsMenuHovered(false),
                                                tip: tooltips.equipmentActions,
                                                dropAlign: {
                                                    top: 'bottom',
                                                    right: 'right'
                                                },
                                                items: [
                                                    {
                                                        label: t('equipment:editMetered'),
                                                        onClick: ()=>hasMeteredEquipment && setShowEditMetered(true),
                                                        disabled: !hasMeteredEquipment
                                                    },
                                                    {
                                                        label: t('equipment:editUnmetered'),
                                                        onClick: ()=>!isCanada && setShowEditUnmetered(true),
                                                        disabled: isCanada
                                                    },
                                                    {
                                                        label: t('equipment:addEquipment'),
                                                        onClick: ()=>facilityId ? setShowEquipmentModal(true) : navigate(`/clients/${clientId}/equipment/create`),
                                                        'data-tour': 'add-equipment-button'
                                                    },
                                                    {
                                                        label: t('equipment:retireEquipment'),
                                                        onClick: ()=>userCanRetire && setShowRetireMultipleModal(true),
                                                        disabled: !userCanRetire
                                                    },
                                                    {
                                                        label: t('equipment:deleteEquipment'),
                                                        onClick: ()=>userCanDelete && setShowDeleteMultipleModal(true),
                                                        disabled: !userCanDelete
                                                    }
                                                ].filter((item)=>item.label !== t('equipment:addEquipment') || showAddButton).filter((item)=>item.label !== t('equipment:deleteEquipment') || userCanDelete).filter((item)=>item.label !== t('equipment:retireEquipment') || userCanRetire).filter((item)=>item.label !== t('equipment:editMetered') || hasMeteredEquipment).filter((item)=>item.label !== t('equipment:editUnmetered') || !isCanada)
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                                pad: "none",
                                gap: "none",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        elevation: "small",
                                        children: [
                                            _isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}),
                                            !_isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
                                                id: "equipment_list_data_table",
                                                pad: {
                                                    horizontal: '1.5rem'
                                                },
                                                columns: [
                                                    {
                                                        property: 'id',
                                                        primary: true,
                                                        size: '4%',
                                                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                pad: {
                                                                    vertical: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(23)
                                                                },
                                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                                                                    to: `/clients/${equipment.client_id}/equipment/${equipment.id}`,
                                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                        row: true,
                                                                        borderRadius: "6px",
                                                                        justify: "center",
                                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ceab9ef72b825454$export$c92c6401b52a9298), {
                                                                            content: tooltips.viewEquipmentDetails,
                                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f97d8419a136e9e9$export$6d128738bddfaa67), {
                                                                                size: "16px",
                                                                                color: "accent-1"
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                    },
                                                    {
                                                        property: 'equipment_type.name',
                                                        size: '17%',
                                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            title: t('equipment:chargingType')
                                                        }),
                                                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                value: equipment.equipment_type.name
                                                            })
                                                    },
                                                    {
                                                        property: 'is_active',
                                                        align: 'center',
                                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            title: t('common:status')
                                                        }),
                                                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                value: equipment.is_active ? (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Active : (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Retired
                                                            })
                                                    },
                                                    {
                                                        property: 'is_metered',
                                                        size: '8%',
                                                        align: 'center',
                                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            title: t('equipment:meter')
                                                        }),
                                                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                row: true,
                                                                children: equipment.is_metered && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b480de5bf3618c14$export$fe82a520fc33e5f4), {
                                                                    size: "20px"
                                                                }) || '-'
                                                            })
                                                    },
                                                    {
                                                        property: 'serial_number',
                                                        size: '13%',
                                                        align: 'center',
                                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            title: t('equipment:serialVin')
                                                        }),
                                                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                value: equipment.serial_number || '-'
                                                            })
                                                    },
                                                    {
                                                        property: 'manufacturer',
                                                        size: '12%',
                                                        align: 'center',
                                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            title: t('equipment:manufacturer')
                                                        }),
                                                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                value: equipment.manufacturer || '-'
                                                            })
                                                    },
                                                    {
                                                        property: 'model_year',
                                                        size: '11%',
                                                        align: 'center',
                                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            title: t('equipment:modelYear')
                                                        }),
                                                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                value: equipment.model_year || '-'
                                                            })
                                                    },
                                                    {
                                                        property: 'model_number',
                                                        size: '13%',
                                                        align: 'center',
                                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            title: t('equipment:modelNumber')
                                                        }),
                                                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                value: equipment.model_number || '-'
                                                            })
                                                    },
                                                    {
                                                        property: 'unit_number',
                                                        size: '11%',
                                                        align: 'center',
                                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            title: t('equipment:unitNo')
                                                        }),
                                                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                value: equipment.unit_number || '-'
                                                            })
                                                    },
                                                    {
                                                        property: 'total_kwh',
                                                        size: '12%',
                                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                align: "center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                        size: "small",
                                                                        children: t('common:totalKwh')
                                                                    }),
                                                                    _equipment?.[0]?.current_reporting_period_equipment_usage?.start_reporting_quarter && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                        size: "small",
                                                                        children: [
                                                                            "(",
                                                                            (0, $00658ccd6ec0135a$export$f96ebb633255a704)(_equipment[0].current_reporting_period_equipment_usage.start_reporting_quarter, !!isCanada),
                                                                            ")"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        render: (equipment)=>equipment.current_reporting_period_equipment_usage?.total_kwh ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                value: (0, $00658ccd6ec0135a$export$f5dd818bff069720)(equipment.current_reporting_period_equipment_usage.total_kwh, true, false, false, 4),
                                                                unitName: "kWh"
                                                            }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                value: "-"
                                                            })
                                                    }
                                                ],
                                                data: _equipment,
                                                sortable: true,
                                                background: [
                                                    'light-6',
                                                    'white'
                                                ],
                                                border: {
                                                    color: 'light-2',
                                                    side: 'bottom',
                                                    size: 'small'
                                                }
                                            }),
                                            !hasEquipment && !_isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                pad: {
                                                    horizontal: '1.5rem',
                                                    vertical: '2rem'
                                                },
                                                background: "light-6",
                                                justify: "center",
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    alignSelf: "center",
                                                    size: "medium",
                                                    fontFamily: "Lato, sans-serif",
                                                    children: noResultsMessage
                                                })
                                            })
                                        ]
                                    }),
                                    hasEquipment && !!_metadata && !!_currentPage && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        pad: "1.5rem",
                                        flex: "grow",
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ffccbada2139938a$export$68f5e1453c188a82), {
                                            alignSelf: "center",
                                            size: "small",
                                            page: _currentPage,
                                            step: _metadata?.per_page,
                                            numberItems: _metadata?.total,
                                            onChange: (e)=>handlePageChange(e.page)
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    showFilters && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ea2652f405b477a3$export$92a576f896a9bf72), {
                        isFiltering: isRefetching,
                        onSubmit: ()=>applyFilters(),
                        onClear: ()=>clearFilters(),
                        filters: []
                    })
                ]
            }),
            !!clientId && !!facilityId && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $48980c91a59d1811$export$87d8bfca539b26c), {
                clientId: clientId,
                facilityId: facilityId,
                isVisible: showEquipmentModal,
                setIsVisible: setShowEquipmentModal
            }),
            showEditUnmetered && !!clientId && !!facilityStore.facility && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $75095e19a0ae4c0f$export$61ef7bc6604b920), {
                facility: facilityStore.facility,
                isVisible: showEditUnmetered,
                setIsVisible: setShowEditUnmetered,
                refreshData: handleShouldRefresh
            }),
            showEditMetered && !!facilityStore.facility && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6c29c45a0502563a$export$b4f27205065e2049), {
                facility: facilityStore.facility,
                isVisible: showEditMetered,
                setIsVisible: setShowEditMetered,
                setShouldRefresh: (_shouldRefresh)=>{
                    if (_shouldRefresh) refetch();
                }
            }),
            showRetireMultipleModal && !!facilityStore.facility && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $88bb8675ed4cb473$export$6db348ae70e65be5), {
                facility: facilityStore.facility,
                isVisible: showRetireMultipleModal,
                setIsVisible: setShowRetireMultipleModal,
                setShouldRefresh: (_shouldRefresh)=>{
                    if (_shouldRefresh) refetch();
                },
                isCanada: isCanada
            }),
            showDeleteMultipleModal && !!facilityStore.facility && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e7d90faf51ccfde9$export$8d64ad56b7344b16), {
                facility: facilityStore.facility,
                isVisible: showDeleteMultipleModal,
                setIsVisible: setShowDeleteMultipleModal,
                setShouldRefresh: (_shouldRefresh)=>{
                    if (_shouldRefresh) refetch();
                },
                isCanada: isCanada
            })
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");













const $72045821182f72ef$export$9f86c65c7386fe24 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { equipment: equipment, dataTour: dataTour } = props;
    /** Context **/ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const equipmentUsageStore = (0, $116967e0234c3770$export$f93886ff234de9d1)();
    const equipmentStore = (0, $116967e0234c3770$export$728bc2cead7f2c5a)();
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** Refs **/ const defaultFormValues = (0, $2xPiy.useRef)(equipment.is_metered ? {
        fuel_pathway_id: undefined,
        is_book_and_claim_applied: null,
        total_kwh: null,
        percent_uptime: '95',
        max_site_deliverability_kw: ''
    } : {
        fuel_pathway_id: undefined,
        is_book_and_claim_applied: null,
        is_paused: false,
        battery_capacity_rating_ah: '',
        voltage: '',
        charge_cycles_per_shift: '0',
        shifts_per_day: '0',
        work_days_per_quarter: '0',
        percent_charger_efficiency_rating: '0',
        percent_charge_return_factor: '0',
        percent_depth_of_discharge: '0',
        percent_uptime: '95',
        max_site_deliverability_kw: ''
    });
    /** State **/ const [isFetchingUsages, setIsFetchingUsages] = (0, $2xPiy.useState)(true);
    const [isFetchingPeriods, setIsFetchingPeriods] = (0, $2xPiy.useState)(true);
    const [isFetchingPathways, setIsFetchingPathways] = (0, $2xPiy.useState)(true);
    const [isUpdatingCurrent, setIsUpdatingCurrent] = (0, $2xPiy.useState)(false);
    const [reportingPeriods, setReportingPeriods] = (0, $2xPiy.useState)();
    const [selectedReportingPeriod, setSelectedReportingPeriod] = (0, $2xPiy.useState)();
    const [oldWorkDaysValue, setOldWorkDaysValue] = (0, $2xPiy.useState)();
    const [currentUsage, setCurrentUsage] = (0, $2xPiy.useState)();
    const [formValues, setFormValues] = (0, $2xPiy.useState)(defaultFormValues.current);
    const [formErrors, setFormErrors] = (0, $2xPiy.useState)({});
    /** Computed **/ const isMobile = (0, $18588a518ac6fdc7$export$2ac00d7098bf223)(screenSize);
    const isLoading = isFetchingPeriods || isFetchingUsages || isFetchingPathways;
    const selectedIndex = reportingPeriods?.findIndex((p)=>p.id === selectedReportingPeriod?.id) ?? -1;
    const previousPeriod = selectedIndex > -1 ? reportingPeriods?.[selectedIndex + 1] : undefined;
    const nextPeriod = selectedIndex > -1 ? reportingPeriods?.[selectedIndex - 1] : undefined;
    const isMetered = equipment.is_metered;
    const isCanada = equipment?.reporting_period_type_id === (0, $0badf5665deea2b2$export$a121e4a6c908fa8f).Yearly;
    const isQ2_2025 = selectedReportingPeriod?.start_reporting_quarter === '2025-04-01';
    const showFciFields = (0, $acc57f855dc3e03c$export$e8efcaf51aaf349d)(equipmentStore.formValues.equipment_category_id ?? equipment?.equipment_type?.equipment_category?.id);
    const isEditable = userStore.isExternalUser && isQ2_2025 ? false : (0, $2e4d07611f552ce8$export$9d2757a220e824d7)(userStore.isExternalUser, currentUsage);
    const disabledMessage = currentUsage ? userStore.isExternalUser && (selectedReportingPeriod?.is_client_locked || isQ2_2025) ? t('equipment:periodHasBeenLockedAndCannotBeEdited') : t('equipment:periodHasBeenFinalizedAndCanNoLongerBeEdited') : '';
    /** Methods **/ /**
   * Fetch Reporting Periods
   */ const fetchReportingPeriods = async (equipment)=>{
        try {
            setIsFetchingPeriods(true);
            const request = {
                client_id: equipment.client_id,
                program_id: equipment.program_id,
                limit: 1000,
                reporting_period_type_id: equipment.reporting_period_type_id,
                start_reporting_quarter: equipment.first_active_reporting_quarter
            };
            if (equipment.last_active_reporting_quarter) request.end_reporting_quarter = equipment.last_active_reporting_quarter;
            const { data: data } = await (0, $37f79218b8708603$export$225d8bcca10eefa2).list(request);
            const periodData = data.reverse().sort((a, b)=>a.start_reporting_quarter > b.start_reporting_quarter ? -1 : a.start_reporting_quarter === b.start_reporting_quarter ? 0 : 1);
            setReportingPeriods(periodData);
            if (periodData[0]) setSelectedReportingPeriod(periodData[0]);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listClientReportingPeriods.error);
        } finally{
            setIsFetchingPeriods(false);
        }
    };
    /**
   * Fetches page data.
   * @param equipment
   * @param reportingPeriod
   */ const fetchPageData = async (equipment, reportingPeriod)=>{
        try {
            setIsFetchingUsages(true);
            setIsFetchingPathways(true);
            const equipmentUsages = await equipmentUsageStore.listEquipmentUsages({
                equipment_id: equipment.id,
                client_program_reporting_period_id: reportingPeriod.id
            });
            const usage = equipmentUsages?.find((u)=>u.start_reporting_quarter === reportingPeriod.start_reporting_quarter && u.end_reporting_quarter === reportingPeriod.end_reporting_quarter);
            setCurrentUsage(usage);
            if (usage) {
                const updatedFormValues = isMetered ? {
                    is_book_and_claim_applied: usage.is_book_and_claim_applied !== undefined ? usage.is_book_and_claim_applied : defaultFormValues.current.is_book_and_claim_applied,
                    fuel_pathway_id: usage.fuel_pathway_id,
                    total_kwh: usage.total_kwh ?? null,
                    percent_uptime: usage.percent_uptime !== undefined ? usage.percent_uptime : defaultFormValues.current.percent_uptime,
                    max_site_deliverability_kw: usage.max_site_deliverability_kw ?? defaultFormValues.current.max_site_deliverability_kw
                } : {
                    is_book_and_claim_applied: usage.is_book_and_claim_applied !== undefined ? usage.is_book_and_claim_applied : defaultFormValues.current.is_book_and_claim_applied,
                    percent_uptime: usage.percent_uptime !== undefined ? usage.percent_uptime : defaultFormValues.current.percent_uptime,
                    max_site_deliverability_kw: usage.max_site_deliverability_kw?.toString() ?? defaultFormValues.current.max_site_deliverability_kw,
                    is_paused: usage.is_paused,
                    fuel_pathway_id: usage.fuel_pathway_id,
                    battery_capacity_rating_ah: usage.battery_capacity_rating_ah?.toString() ?? '',
                    voltage: usage.voltage?.toString() ?? '',
                    charge_cycles_per_shift: usage.charge_cycles_per_shift ?? '',
                    shifts_per_day: usage.shifts_per_day ?? '',
                    work_days_per_quarter: usage.is_paused ? '0' : usage.work_days_per_quarter ?? '0',
                    percent_charger_efficiency_rating: usage.percent_charger_efficiency_rating?.toString() ?? '',
                    percent_charge_return_factor: usage.percent_charge_return_factor?.toString() ?? '',
                    percent_depth_of_discharge: usage.percent_depth_of_discharge?.toString() ?? ''
                };
                setFormValues({
                    ...formValues,
                    ...updatedFormValues
                });
                if (equipment.facility?.program_id && equipment.facility?.address_region_id) await equipmentUsageStore.fetchFuelPathways(equipment.facility.program_id, equipment.facility.address_region_id, usage.start_reporting_quarter, usage.end_reporting_quarter);
            }
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listEquipmentUsages.error);
        } finally{
            setIsFetchingUsages(false);
            setIsFetchingPathways(false);
        }
    };
    /**
   * Filter Fuel Pathways by name. Used by the Fuel Pathways dropdown search box.
   * @param nameFilter
   */ const searchPathways = (nameFilter)=>{
        if (nameFilter === '') equipmentUsageStore.setFuelPathwayOptions(equipmentUsageStore.defaultFuelPathwayOptions);
        else {
            const filteredPathways = (0, $00658ccd6ec0135a$export$b5513415b3f92e76)(nameFilter, equipmentUsageStore.defaultFuelPathwayOptions);
            equipmentUsageStore.setFuelPathwayOptions(filteredPathways);
        }
    };
    /**
   * Validate a single field value
   * @param key
   * @param value
   * @param isMetered
   */ const validateFieldValue = (key, value, isMetered)=>{
        const validationRules = isMetered ? [
            {
                field: 'total_kwh',
                min: 0,
                max: undefined,
                displayName: 'Total kWh'
            },
            {
                field: 'percent_uptime',
                min: 0,
                max: undefined,
                displayName: 'Uptime'
            },
            {
                field: 'max_site_deliverability_kw',
                min: 0,
                max: undefined,
                displayName: 'Max Site Deliverability (kW)'
            }
        ] : [
            {
                field: 'battery_capacity_rating_ah',
                min: 0.001,
                max: undefined,
                displayName: 'Battery Capacity'
            },
            {
                field: 'voltage',
                min: 0.001,
                max: undefined,
                displayName: 'Voltage'
            },
            {
                field: 'charge_cycles_per_shift',
                min: 0,
                max: 9.99,
                displayName: 'Charge Cycles/Shift'
            },
            {
                field: 'shifts_per_day',
                min: 0,
                max: 9.99,
                displayName: 'Shifts/Day'
            },
            {
                field: 'work_days_per_quarter',
                min: 0,
                max: undefined,
                displayName: 'Work Days/Quarter'
            },
            {
                field: 'percent_charger_efficiency_rating',
                min: 0,
                max: undefined,
                displayName: 'Charger Efficiency'
            },
            {
                field: 'percent_charge_return_factor',
                min: 0,
                max: undefined,
                displayName: 'Charge Return Factor'
            },
            {
                field: 'percent_depth_of_discharge',
                min: 0,
                max: undefined,
                displayName: 'Depth of Discharge'
            },
            {
                field: 'percent_uptime',
                min: 0,
                max: undefined,
                displayName: 'Uptime'
            },
            {
                field: 'max_site_deliverability_kw',
                min: 0,
                max: undefined,
                displayName: 'Max Site Deliverability (kW)'
            }
        ];
        const rule = validationRules.find((r)=>r.field === key);
        if (!rule) return '';
        if (value === null || value === '') return '';
        const numValue = parseFloat(value.toString());
        if (isNaN(numValue)) return '';
        if (numValue < rule.min || rule.min > 0 && numValue === 0) return `${rule.displayName} must be ${rule.min === 0 ? '0 or greater' : `greater than ${rule.min}`}`;
        else if (rule.max !== undefined && numValue > rule.max) return `${rule.displayName} must be less than or equal to ${rule.max}`;
        return '';
    };
    /**
   * Update form data
   * @param key
   * @param value
   */ const updateFormValue = (key, value)=>{
        const processedValue = key === 'total_kwh' && value === '' ? null : value;
        const updatedFormValues = {
            ...formValues,
            [key]: processedValue
        };
        setFormValues(updatedFormValues);
        const error = validateFieldValue(key, processedValue, isMetered);
        setFormErrors({
            ...formErrors,
            [key]: error
        });
    };
    /**
   * Form validation for equipment usage
   * @param formValues
   * @param isMetered
   */ const validateFormValues = (formValues, isMetered)=>{
        const errors = {};
        const validationRules = isMetered ? [
            {
                field: 'total_kwh',
                min: 0,
                max: undefined,
                displayName: 'Total kWh'
            },
            {
                field: 'max_site_deliverability_kw',
                min: 0,
                max: undefined,
                displayName: 'Max Site Deliverability (kW)'
            },
            ...showFciFields ? [
                {
                    field: 'percent_uptime',
                    min: 0,
                    max: undefined,
                    displayName: 'Uptime'
                }
            ] : []
        ] : [
            {
                field: 'battery_capacity_rating_ah',
                min: 0.001,
                max: undefined,
                displayName: 'Battery Capacity'
            },
            {
                field: 'voltage',
                min: 0.001,
                max: undefined,
                displayName: 'Voltage'
            },
            {
                field: 'charge_cycles_per_shift',
                min: 0,
                max: 9.99,
                displayName: 'Charge Cycles/Shift'
            },
            {
                field: 'shifts_per_day',
                min: 0,
                max: 9.99,
                displayName: 'Shifts/Day'
            },
            {
                field: 'work_days_per_quarter',
                min: 0,
                max: undefined,
                displayName: 'Work Days/Quarter'
            },
            {
                field: 'percent_charger_efficiency_rating',
                min: 0,
                max: undefined,
                displayName: 'Charger Efficiency'
            },
            {
                field: 'percent_charge_return_factor',
                min: 0,
                max: undefined,
                displayName: 'Charge Return Factor'
            },
            {
                field: 'percent_depth_of_discharge',
                min: 0,
                max: undefined,
                displayName: 'Depth of Discharge'
            },
            {
                field: 'max_site_deliverability_kw',
                min: 0,
                max: undefined,
                displayName: 'Max Site Deliverability (kW)'
            },
            ...showFciFields ? [
                {
                    field: 'percent_uptime',
                    min: 0,
                    max: undefined,
                    displayName: 'Uptime'
                }
            ] : []
        ];
        validationRules.forEach(({ field: field, min: min, max: max, displayName: displayName })=>{
            const value = formValues[field];
            if (field === 'percent_uptime' && showFciFields && (value === null || value === '')) {
                errors[field] = 'Uptime is required';
                return;
            }
            if (value === null || value === '') return;
            const numValue = parseFloat(value);
            if (isNaN(numValue) || numValue < min || min > 0 && numValue === 0) errors[field] = `${displayName} must be ${min === 0 ? '0 or greater' : `greater than ${min}`}`;
            else if (max !== undefined && numValue > max) errors[field] = `${displayName} must be less than or equal to ${max}`;
        });
        return errors;
    };
    /**
   * Update Equipment Usage
   */ const updateEquipmentUsage = async (equipmentUsageId, formValues)=>{
        try {
            const errors = validateFormValues(formValues, isMetered);
            if (Object.keys(errors).length > 0) {
                setFormErrors(errors);
                (0, $05d5739209a21833$export$b410431fab84fa58).error(Object.values(errors)[0]);
                return;
            }
            setIsUpdatingCurrent(true);
            if (isMetered) {
                /* Update Metered */ const values = formValues;
                const newUsage = {
                    equipment_usage_id: equipmentUsageId,
                    fuel_pathway_id: typeof values.fuel_pathway_id === 'number' ? values.fuel_pathway_id : null,
                    is_book_and_claim_applied: values.is_book_and_claim_applied,
                    total_kwh: values.total_kwh ? parseFloat(values.total_kwh) : null,
                    percent_uptime: values.percent_uptime ? parseInt(values.percent_uptime) : null,
                    max_site_deliverability_kw: values.max_site_deliverability_kw ? parseInt(values.max_site_deliverability_kw) : null
                };
                await equipmentUsageStore.updateMeteredEquipmentUsage(newUsage);
            } else {
                /* Update Unmetered */ const values = formValues;
                const newUsage = {
                    equipment_usage_id: equipmentUsageId,
                    fuel_pathway_id: typeof values.fuel_pathway_id === 'number' ? values.fuel_pathway_id : null,
                    is_book_and_claim_applied: values.is_book_and_claim_applied,
                    percent_uptime: values.percent_uptime ? parseInt(values.percent_uptime) : null,
                    max_site_deliverability_kw: values.max_site_deliverability_kw ? parseInt(values.max_site_deliverability_kw) : null,
                    is_paused: values.is_paused,
                    battery_capacity_rating_ah: parseFloat(values.battery_capacity_rating_ah?.toString() ?? '0'),
                    voltage: parseFloat(values.voltage?.toString() ?? '0'),
                    charge_cycles_per_shift: values.charge_cycles_per_shift ? parseFloat(parseFloat(values.charge_cycles_per_shift).toFixed(2)) : 0,
                    shifts_per_day: values.shifts_per_day ? parseFloat(parseFloat(values.shifts_per_day).toFixed(2)) : 0,
                    work_days_per_quarter: values.is_paused ? 0 : values.work_days_per_quarter ? parseFloat(parseFloat(values.work_days_per_quarter).toFixed(2)) : 0,
                    percent_charger_efficiency_rating: values.percent_charger_efficiency_rating ? parseInt(values.percent_charger_efficiency_rating) : 0,
                    percent_charge_return_factor: values.percent_charge_return_factor ? parseInt(values.percent_charge_return_factor) : 0,
                    percent_depth_of_discharge: values.percent_depth_of_discharge ? parseInt(values.percent_depth_of_discharge) : 0
                };
                await equipmentUsageStore.updateUnmeteredEquipmentUsage(newUsage);
            }
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updateEquipmentUsage.success);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updateEquipmentUsage.error);
        } finally{
            setIsUpdatingCurrent(false);
        }
    };
    const handleCheckBox = (isChecked)=>{
        if (isChecked) setOldWorkDaysValue(formValues.work_days_per_quarter);
        updateFormValue('is_paused', isChecked);
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (equipment?.client_id && !reportingPeriods) fetchReportingPeriods(equipment);
    }, [
        equipment?.client_id,
        reportingPeriods
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (equipment && selectedReportingPeriod) fetchPageData(equipment, selectedReportingPeriod);
    }, [
        equipment,
        selectedReportingPeriod
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (!isMetered) {
            if (formValues.is_paused) updateFormValue('work_days_per_quarter', 0);
            else if (oldWorkDaysValue !== undefined) updateFormValue('work_days_per_quarter', oldWorkDaysValue);
        }
    }, [
        isMetered,
        formValues.is_paused,
        oldWorkDaysValue
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
        "data-tour": dataTour,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                title: t('equipment:equipmentUsage'),
                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $805d36e3aa560182$export$4f47cef615b0c343), {}),
                children: currentUsage && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $85ab7488c493b81c$export$6d88ebe453be59d7), {
                    background: "accent-1",
                    color: "white",
                    style: {
                        opacity: isLoading || isUpdatingCurrent || !isEditable ? 0.5 : 1
                    },
                    label: t('equipment:saveUsage'),
                    tip: `${t('equipment:saveChangesTo')} ${(0, $00658ccd6ec0135a$export$f96ebb633255a704)(currentUsage.start_reporting_quarter, isCanada)}`,
                    disabled: isLoading || isUpdatingCurrent || !isEditable,
                    onClick: ()=>updateEquipmentUsage(currentUsage.id, formValues)
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                gap: !isLoading && !currentUsage ? 'none' : '1.5rem',
                pad: !isLoading && !currentUsage ? 'none' : undefined,
                children: [
                    isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        pad: {
                            vertical: 'medium'
                        },
                        height: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(277),
                        fill: "horizontal",
                        justify: "center",
                        align: "center",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8bec6e2e7dc53c4a$export$7f7cbe89f1eacd2), {
                            size: "medium"
                        })
                    }),
                    !isLoading && equipment && reportingPeriods && selectedReportingPeriod && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        row: true,
                        justify: "between",
                        align: "center",
                        pad: !isLoading && !currentUsage ? 'medium' : undefined,
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                gap: "xsmall",
                                justify: "center",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        row: true,
                                        gap: "xsmall",
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "xlarge",
                                                weight: 500,
                                                children: t('equipment:viewing')
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "xlarge",
                                                weight: 500,
                                                color: "accent-1",
                                                children: selectedReportingPeriod && (0, $00658ccd6ec0135a$export$f96ebb633255a704)(selectedReportingPeriod.start_reporting_quarter, isCanada)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                            size: "medium",
                                            weight: 300,
                                            children: [
                                                (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(selectedReportingPeriod?.start_reporting_quarter).format('MMMM DD, YYYY'),
                                                " -",
                                                ' ',
                                                (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(selectedReportingPeriod?.start_reporting_quarter).add(2, 'months').endOf('month').format('MMMM DD, YYYY')
                                            ]
                                        })
                                    })
                                ]
                            }),
                            !isEditable && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                justify: "center",
                                align: "center",
                                pad: "1rem",
                                gap: "xsmall",
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    fontFamily: "Lato, sans-serif",
                                    children: disabledMessage
                                })
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $26f637f3d75d0420$export$54d79d35af45a337), {
                                reportingPeriods: reportingPeriods,
                                setSelectedReportingPeriod: setSelectedReportingPeriod,
                                selectedReportingPeriod: selectedReportingPeriod,
                                previousPeriod: previousPeriod,
                                nextPeriod: nextPeriod,
                                isCanada: isCanada,
                                showNav: true
                            })
                        ]
                    }),
                    !isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        gap: "xsmall",
                        children: [
                            currentUsage && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                gap: "medium",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            direction: isMobile ? 'column' : 'row',
                                            gap: "medium",
                                            children: [
                                                !isMetered && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                                                    id: "is_paused",
                                                    name: "is_paused",
                                                    label: t('equipment:pausedForSeasonality'),
                                                    checked: formValues.is_paused,
                                                    onChange: (e)=>handleCheckBox(e.target.checked),
                                                    disabled: !isEditable
                                                }),
                                                userStore.isInternalUser && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                    id: "fuel_pathway_id",
                                                    label: t('equipment:fuelPathwayCode'),
                                                    placeholder: !isFetchingPathways ? t('common:choose') : t('common:loading'),
                                                    value: !isFetchingPathways ? formValues.fuel_pathway_id : '',
                                                    setValue: (value)=>updateFormValue('fuel_pathway_id', value),
                                                    options: [
                                                        {
                                                            label: '\u00A0',
                                                            value: null
                                                        },
                                                        ...equipmentUsageStore.fuelPathwayOptions
                                                    ],
                                                    error: formErrors['fuel_pathway_id'],
                                                    onSearch: searchPathways,
                                                    searchPlaceholder: t('equipment:filterByCode'),
                                                    emptySearchMessage: (0, $d0d6382a5bdf6377$export$d8bd0967cb58683).fuelPathwayNameSearchNoResult,
                                                    fill: "horizontal",
                                                    disabled: !userStore.isAdminUser || !isEditable || isFetchingPathways
                                                }),
                                                userStore.isInternalUser && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                    id: "is_book_and_claim_applied",
                                                    label: t('equipment:bookAndClaim'),
                                                    value: formValues.is_book_and_claim_applied === null || formValues.is_book_and_claim_applied === undefined ? null : formValues.is_book_and_claim_applied ? 'Applied' : 'Not Applied',
                                                    setValue: (value)=>updateFormValue('is_book_and_claim_applied', value === 'Applied' ? true : value === 'Not Applied' ? false : value === null ? null : value),
                                                    options: [
                                                        {
                                                            label: '\u00A0',
                                                            value: null
                                                        },
                                                        {
                                                            label: t('equipment:applied'),
                                                            value: 'Applied'
                                                        },
                                                        {
                                                            label: t('equipment:notApplied'),
                                                            value: 'Not Applied'
                                                        }
                                                    ],
                                                    error: formErrors['is_book_and_claim_applied'],
                                                    disabled: !isEditable,
                                                    fill: "horizontal"
                                                }),
                                                !isMetered && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    id: "battery_capacity_rating_ah",
                                                    label: t('equipment:batteryCapacityAh'),
                                                    value: formValues.battery_capacity_rating_ah,
                                                    setValue: (value)=>updateFormValue('battery_capacity_rating_ah', value),
                                                    onSubmit: ()=>updateEquipmentUsage(currentUsage.id, formValues),
                                                    fill: "horizontal",
                                                    type: "number",
                                                    disabled: !isEditable,
                                                    required: true,
                                                    hideOptionalText: true
                                                }),
                                                !isMetered && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    id: "voltage",
                                                    label: t('equipment:voltage'),
                                                    value: formValues.voltage,
                                                    setValue: (value)=>updateFormValue('voltage', value),
                                                    onSubmit: ()=>updateEquipmentUsage(currentUsage.id, formValues),
                                                    fill: "horizontal",
                                                    type: "number",
                                                    disabled: !isEditable,
                                                    required: true,
                                                    hideOptionalText: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62a54a62048a38c2$export$c87604745e124f91), {
                                        formValues: formValues,
                                        updateFormValue: updateFormValue,
                                        formErrors: formErrors,
                                        tableCells: isMetered ? [
                                            {
                                                label: t('common:totalKwh'),
                                                valueKey: 'total_kwh',
                                                isEditable: isEditable,
                                                formatNumber: !isEditable,
                                                unit: !isEditable ? 'kwh' : undefined
                                            },
                                            ...showFciFields ? [
                                                {
                                                    label: t('equipment:percentUptime'),
                                                    valueKey: 'percent_uptime',
                                                    isEditable: isEditable,
                                                    unit: 'percent'
                                                },
                                                {
                                                    label: t('equipment:maxSiteDeliverabilityKw'),
                                                    valueKey: 'max_site_deliverability_kw',
                                                    isEditable: isEditable
                                                }
                                            ] : []
                                        ] : [
                                            {
                                                label: t('equipment:chargeCyclesShift'),
                                                valueKey: 'charge_cycles_per_shift',
                                                isEditable: isEditable
                                            },
                                            {
                                                label: t('equipment:shiftsDay'),
                                                valueKey: 'shifts_per_day',
                                                isEditable: isEditable
                                            },
                                            {
                                                label: t('equipment:workDaysQuarter'),
                                                valueKey: 'work_days_per_quarter',
                                                isEditable: isEditable && !formValues.is_paused
                                            },
                                            {
                                                label: t('equipment:chargerEfficiencyRating'),
                                                valueKey: 'percent_charger_efficiency_rating',
                                                isEditable: isEditable,
                                                unit: 'percent',
                                                inputMode: 'numeric'
                                            },
                                            {
                                                label: t('equipment:chargeReturnFactor'),
                                                valueKey: 'percent_charge_return_factor',
                                                isEditable: isEditable,
                                                unit: 'percent',
                                                inputMode: 'numeric'
                                            },
                                            {
                                                label: t('equipment:depthOfDischarge'),
                                                valueKey: 'percent_depth_of_discharge',
                                                isEditable: isEditable,
                                                unit: 'percent',
                                                inputMode: 'numeric'
                                            },
                                            ...showFciFields ? [
                                                {
                                                    label: t('equipment:percentUptime'),
                                                    valueKey: 'percent_uptime',
                                                    isEditable: isEditable,
                                                    required: true,
                                                    unit: 'percent'
                                                },
                                                {
                                                    label: t('equipment:maxSiteDeliverabilityKw'),
                                                    valueKey: 'max_site_deliverability_kw',
                                                    isEditable: isEditable
                                                }
                                            ] : []
                                        ],
                                        cellWidth: "100%",
                                        equipment: equipment,
                                        equipmentUsages: [
                                            currentUsage
                                        ],
                                        isCanada: isCanada
                                    })
                                ]
                            }),
                            !currentUsage && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                pad: {
                                    horizontal: '1.5rem',
                                    vertical: '2rem'
                                },
                                background: "light-6",
                                justify: "center",
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    alignSelf: "center",
                                    size: "medium",
                                    fontFamily: "Lato, sans-serif",
                                    children: t('equipment:noUsageDataFound')
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});




var $2xPiy = parcelRequire("2xPiy");












const $e44f10ba4a112641$export$de2fdb1e021e43cc = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(({ equipment: equipment, setIsVisible: setIsVisible, setShouldRefresh: setShouldRefresh, isCanada: isCanada = false })=>{
    /** Context **/ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** State **/ const [isRetiring, setIsRetiring] = (0, $2xPiy.useState)(false);
    const [isConfirmed, setIsConfirmed] = (0, $2xPiy.useState)(false);
    const [reasonId, setReasonId] = (0, $2xPiy.useState)();
    const [reasonText, setReasonText] = (0, $2xPiy.useState)('');
    const [isOther, setIsOther] = (0, $2xPiy.useState)(false);
    const [formValues, setFormValues] = (0, $2xPiy.useState)({
        last_active_reporting_quarter: ''
    });
    const [formErrors, setFormErrors] = (0, $2xPiy.useState)({});
    /** Computed **/ const canRetire = userStore.isClientAdmin || userStore.isFacilityAdmin ? !!userStore.user?.facilities.find((f)=>f.id === equipment.facility_id) : userStore.isFuseAdmin;
    const selectedPeriodLabel = (0, $00658ccd6ec0135a$export$f96ebb633255a704)(formValues.last_active_reporting_quarter ?? '', isCanada);
    const hasReason = !!reasonId && (!isOther || !!reasonText.trim());
    /** Methods **/ const updateFormValue = (key, value)=>{
        setFormValues((prev)=>({
                ...prev,
                [key]: value
            }));
        if (formErrors[key]) setFormErrors((prev)=>({
                ...prev,
                [key]: ''
            }));
    };
    const retireEquipment = async ()=>{
        if (isRetiring) return;
        const formFields = {
            last_active_reporting_quarter: {
                label: t('common:lastReportingPeriod'),
                required: true
            },
            retirement_reason_id: {
                label: t('common:reasonForRetiring'),
                required: true
            },
            ...isOther && {
                retirement_reason_other: {
                    label: t('common:otherReasonDescription'),
                    required: true
                }
            }
        };
        const errors = (0, $084681c8221d0a24$export$5fafec8d1b047c0)(formFields, {
            last_active_reporting_quarter: formValues.last_active_reporting_quarter,
            retirement_reason_id: reasonId,
            retirement_reason_other: reasonText.trim()
        });
        if (errors) {
            setFormErrors(errors);
            return;
        }
        try {
            setIsRetiring(true);
            await (0, $64087c41a5036744$export$f3cdcae448e94402).retire({
                equipment_ids: [
                    equipment.id
                ],
                last_active_reporting_quarter: formValues.last_active_reporting_quarter ?? '',
                retirement_reason_id: reasonId,
                retirement_reason_other: isOther ? reasonText.trim() : null
            });
            setShouldRefresh(true);
            setIsVisible(false);
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).retireEquipment.success);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).retireEquipment.error);
        } finally{
            setIsRetiring(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (!canRetire) setIsVisible(false);
    }, [
        canRetire
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
        position: "center",
        onEsc: ()=>setIsVisible(false),
        onClickOutside: ()=>setIsVisible(false),
        responsive: false,
        style: {
            width: 'auto',
            maxWidth: 'min(95vw, 500px)',
            maxHeight: '95vh',
            overflow: 'auto',
            borderRadius: '8px'
        },
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $98b6153ed086d9bd$export$11154b700737b45e), {
            width: "100%",
            title: `${t('common:retire')} ${(0, $00658ccd6ec0135a$export$83ca57d51225263a)(equipment, (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Equipment)}`,
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d8fcb0015cca0f72$export$825a3c81a577bf46), {
                entityName: (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Equipment
            }),
            onSubmit: ()=>retireEquipment(),
            isLoading: isRetiring,
            hideRequiredText: true,
            saveButtonLabel: t('common:retireButton'),
            saveButtonLoadingLabel: t('common:retiringButton'),
            saveButtonDisabled: !isConfirmed || !hasReason || !formValues.last_active_reporting_quarter,
            headerChildren: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                    pad: "none",
                    onClick: ()=>setIsVisible(false),
                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c1da19823027de53$export$f39c2d165cd861fe), {
                        size: "20px"
                    }),
                    tip: t('common:close')
                }, "close")
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                pad: {
                    horizontal: 'medium',
                    bottom: 'medium'
                },
                gap: "medium",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                        gap: "1rem",
                        direction: "row",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e23e190c1adfeb13$export$a2518b5310db22ab), {
                                size: "medium",
                                color: "status-warning"
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                children: [
                                    t('equipment:retireWarning'),
                                    " ",
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("b", {
                                        children: t('common:after')
                                    }),
                                    ' ',
                                    formValues.last_active_reporting_quarter ? selectedPeriodLabel : t('common:theLastReportingPeriod'),
                                    "."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d3263c98ec06168d$export$90b89cb54a5768ce), {
                        id: "last_active_reporting_quarter",
                        label: t('common:lastReportingPeriod'),
                        placeholder: t('common:selectPeriod'),
                        value: formValues.last_active_reporting_quarter,
                        setValue: (value)=>updateFormValue('last_active_reporting_quarter', value),
                        clientId: equipment.client_id,
                        programId: equipment.program_id,
                        reportingPeriodTypeId: equipment.reporting_period_type_id,
                        firstActivePeriod: equipment.first_active_reporting_quarter,
                        error: formErrors['last_active_reporting_quarter'],
                        required: true,
                        fill: "horizontal"
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $95684e66166a88c8$export$516f52107d98083f), {
                        entityType: "equipment",
                        reasonId: reasonId,
                        setReasonId: setReasonId,
                        reasonText: reasonText,
                        setReasonText: setReasonText,
                        setIsOther: setIsOther,
                        reasonError: formErrors['retirement_reason_id'],
                        textError: formErrors['retirement_reason_other']
                    }),
                    formValues.last_active_reporting_quarter && hasReason && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                        gap: "1rem",
                        direction: "row",
                        align: "center",
                        background: {
                            color: 'status-error',
                            dark: true
                        },
                        pad: "medium",
                        round: "small",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                                checked: isConfirmed,
                                onChange: ()=>setIsConfirmed(!isConfirmed),
                                color: "white"
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                color: "white",
                                children: t('equipment:retireConfirmation', {
                                    period: selectedPeriodLabel
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
});




var $2xPiy = parcelRequire("2xPiy");















const $88bb8675ed4cb473$export$6db348ae70e65be5 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(({ facility: facility, isVisible: isVisible, setIsVisible: setIsVisible, setShouldRefresh: setShouldRefresh, isCanada: isCanada = false })=>{
    /** Context **/ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const tooltips = (0, $d597772cdbe12609$export$4713da6aa4410043)();
    /** State **/ const [isLoading, setIsLoading] = (0, $2xPiy.useState)(false);
    const [isRetiring, setIsRetiring] = (0, $2xPiy.useState)(false);
    const [isSelectingAll, setIsSelectingAll] = (0, $2xPiy.useState)(false);
    const [equipmentList, setEquipmentList] = (0, $2xPiy.useState)([]);
    const [selectedEquipmentIds, setSelectedEquipmentIds] = (0, $2xPiy.useState)([]);
    const [lastActivePeriod, setLastActivePeriod] = (0, $2xPiy.useState)('');
    const [reasonId, setReasonId] = (0, $2xPiy.useState)();
    const [reasonText, setReasonText] = (0, $2xPiy.useState)('');
    const [isOther, setIsOther] = (0, $2xPiy.useState)(false);
    const [isConfirmed, setIsConfirmed] = (0, $2xPiy.useState)(false);
    const [currentPage, setCurrentPage] = (0, $2xPiy.useState)(1);
    const [limit] = (0, $2xPiy.useState)(20);
    const [metadata, setMetadata] = (0, $2xPiy.useState)();
    const [earliestFirstActive, setEarliestFirstActive] = (0, $2xPiy.useState)();
    const [searchQuery, setSearchQuery] = (0, $2xPiy.useState)('');
    const [committedSearchQuery, setCommittedSearchQuery] = (0, $2xPiy.useState)('');
    const [isSearching, setIsSearching] = (0, $2xPiy.useState)(false);
    const selectAllRequestIdRef = (0, $2xPiy.useRef)(0);
    /** Computed **/ const canRetire = userStore.isClientAdmin || userStore.isFacilityAdmin ? !!userStore.user?.facilities.find((f)=>f.id === facility.id) : userStore.isFuseAdmin;
    const selectedPeriodLabel = lastActivePeriod ? (0, $00658ccd6ec0135a$export$f96ebb633255a704)(lastActivePeriod, isCanada) : t('common:theLastReportingPeriod');
    const hasReason = !!reasonId && (!isOther || !!reasonText.trim());
    const selectedEquipmentIdSet = new Set(selectedEquipmentIds);
    const selectedOnPageCount = equipmentList.filter((eq)=>selectedEquipmentIdSet.has(eq.id)).length;
    const isPageSelected = !!equipmentList.length && selectedOnPageCount === equipmentList.length;
    const isPagePartiallySelected = selectedOnPageCount > 0 && selectedOnPageCount < equipmentList.length;
    const hasSelection = !!selectedEquipmentIds.length;
    /** Methods **/ const search = (query)=>{
        setSearchQuery(query);
        setCommittedSearchQuery(query);
        setIsSearching(query !== committedSearchQuery);
        setCurrentPage(1);
    };
    const handlePeriodChange = (period)=>{
        selectAllRequestIdRef.current += 1;
        setSelectedEquipmentIds([]);
        setIsConfirmed(false);
        setCurrentPage(1);
        setLastActivePeriod(period);
    };
    const loadEquipment = async (page = 1, serialNumber)=>{
        try {
            setIsLoading(true);
            const { data: data, meta: meta, earliest_first_active_reporting_quarter: earliest_first_active_reporting_quarter } = await (0, $64087c41a5036744$export$f3cdcae448e94402).list({
                facility_id: facility.id,
                page: page,
                limit: limit,
                is_active: true,
                ...lastActivePeriod ? {
                    active_by_reporting_quarter: lastActivePeriod
                } : {},
                ...serialNumber ? {
                    serial_number: serialNumber
                } : {}
            });
            setEquipmentList(data);
            setMetadata(meta);
            setCurrentPage(meta?.current_page ?? page);
            setEarliestFirstActive(earliest_first_active_reporting_quarter ?? undefined);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listEquipment.error);
        } finally{
            setIsLoading(false);
            setIsSearching(false);
        }
    };
    const retireEquipment = async ()=>{
        if (isRetiring || !selectedEquipmentIds.length || !lastActivePeriod || !reasonId || isOther && !reasonText.trim()) return;
        try {
            setIsRetiring(true);
            await (0, $64087c41a5036744$export$f3cdcae448e94402).retire({
                equipment_ids: selectedEquipmentIds,
                last_active_reporting_quarter: lastActivePeriod,
                retirement_reason_id: reasonId,
                retirement_reason_other: isOther ? reasonText.trim() : null
            });
            setShouldRefresh(true);
            setIsVisible(false);
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).retireEquipment.success);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).retireEquipment.error);
        } finally{
            setIsRetiring(false);
        }
    };
    const toggleSelection = (equipmentId)=>{
        setSelectedEquipmentIds((prev)=>prev.includes(equipmentId) ? prev.filter((id)=>id !== equipmentId) : [
                ...prev,
                equipmentId
            ]);
    };
    const toggleSelectPage = (checked)=>{
        const pageIds = equipmentList.map((eq)=>eq.id);
        const pageIdSet = new Set(pageIds);
        setSelectedEquipmentIds((prev)=>{
            const offPageIds = prev.filter((id)=>!pageIdSet.has(id));
            return checked ? [
                ...offPageIds,
                ...pageIds
            ] : offPageIds;
        });
    };
    const selectAll = async ()=>{
        if (isSelectingAll || !metadata?.total) return;
        selectAllRequestIdRef.current += 1;
        const requestId = selectAllRequestIdRef.current;
        try {
            setIsSelectingAll(true);
            const { data: data } = await (0, $64087c41a5036744$export$f3cdcae448e94402).list({
                facility_id: facility.id,
                page: 1,
                limit: metadata.total,
                is_active: true,
                ...lastActivePeriod ? {
                    active_by_reporting_quarter: lastActivePeriod
                } : {},
                ...committedSearchQuery ? {
                    serial_number: committedSearchQuery
                } : {}
            });
            if (requestId !== selectAllRequestIdRef.current) return;
            setSelectedEquipmentIds((prev)=>Array.from(new Set([
                    ...prev,
                    ...data.map((eq)=>eq.id)
                ])));
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listEquipment.error);
        } finally{
            setIsSelectingAll(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (isVisible) {
            setLastActivePeriod('');
            setReasonId(undefined);
            setReasonText('');
            setIsOther(false);
            setSelectedEquipmentIds([]);
            setIsConfirmed(false);
            setCurrentPage(1);
            setSearchQuery('');
            setCommittedSearchQuery('');
        }
    }, [
        isVisible,
        facility.id
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (!canRetire && isVisible) setIsVisible(false);
    }, [
        canRetire,
        isVisible
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (isVisible && currentPage) loadEquipment(currentPage, committedSearchQuery || undefined);
    }, [
        isVisible,
        currentPage,
        committedSearchQuery,
        lastActivePeriod
    ]);
    /** Render **/ const renderDataTable = ()=>{
        const currentUsagePeriod = equipmentList?.[0]?.current_reporting_period_equipment_usage?.start_reporting_quarter;
        return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            elevation: "small",
            round: "xsmall",
            overflow: "hidden",
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                },
                primaryKey: "id",
                columns: [
                    {
                        property: 'select',
                        size: '3%',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                            checked: isPageSelected,
                            indeterminate: isPagePartiallySelected,
                            onChange: (e)=>toggleSelectPage(e.target.checked)
                        }),
                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                                checked: selectedEquipmentIdSet.has(equipment.id),
                                onChange: ()=>toggleSelection(equipment.id)
                            })
                    },
                    {
                        property: 'id',
                        size: '3%',
                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                pad: {
                                    vertical: 'small'
                                },
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                                    to: `/clients/${equipment.client_id}/equipment/${equipment.id}`,
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                        direction: "row",
                                        round: "6px",
                                        justify: "center",
                                        align: "center",
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ceab9ef72b825454$export$c92c6401b52a9298), {
                                            content: tooltips.viewEquipmentDetails,
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f97d8419a136e9e9$export$6d128738bddfaa67), {
                                                size: "16px",
                                                color: "accent-1"
                                            })
                                        })
                                    })
                                })
                            })
                    },
                    {
                        property: 'equipment_type.name',
                        size: '17%',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('equipment:chargingType')
                        }),
                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: equipment.equipment_type.name
                            })
                    },
                    {
                        property: 'is_active',
                        align: 'center',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('common:status')
                        }),
                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: equipment.is_active ? (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Active : (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Retired
                            })
                    },
                    {
                        property: 'is_metered',
                        size: '8%',
                        align: 'center',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('equipment:meter')
                        }),
                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                direction: "row",
                                children: equipment.is_metered && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b480de5bf3618c14$export$fe82a520fc33e5f4), {
                                    size: "20px"
                                }) || '-'
                            })
                    },
                    {
                        property: 'serial_number',
                        size: '13%',
                        align: 'center',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('equipment:serialVin')
                        }),
                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: equipment.serial_number?.length >= 22 ? `${equipment.serial_number?.slice(0, 4)}...${equipment.serial_number?.slice(-4)}` : equipment.serial_number || '-'
                            })
                    },
                    {
                        property: 'manufacturer',
                        size: '12%',
                        align: 'center',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('equipment:manufacturer')
                        }),
                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: equipment.manufacturer || '-'
                            })
                    },
                    {
                        property: 'model_year',
                        size: '11%',
                        align: 'center',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('equipment:modelYear')
                        }),
                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: equipment.model_year || '-'
                            })
                    },
                    {
                        property: 'model_number',
                        size: '13%',
                        align: 'center',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('equipment:modelNumber')
                        }),
                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: equipment.model_number || '-'
                            })
                    },
                    {
                        property: 'unit_number',
                        size: '11%',
                        align: 'center',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('equipment:unitNo')
                        }),
                        render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: equipment.unit_number || '-'
                            })
                    },
                    {
                        property: 'total_kwh',
                        size: '12%',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "small",
                                        children: t('common:totalKwh')
                                    }),
                                    currentUsagePeriod && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "small",
                                        children: [
                                            "(",
                                            (0, $00658ccd6ec0135a$export$f96ebb633255a704)(currentUsagePeriod, isCanada),
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        }),
                        render: (equipment)=>equipment.current_reporting_period_equipment_usage?.total_kwh ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: (0, $00658ccd6ec0135a$export$f5dd818bff069720)(equipment.current_reporting_period_equipment_usage.total_kwh, true, false, false, 4),
                                unitName: "kWh"
                            }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: "-"
                            })
                    }
                ],
                data: equipmentList,
                sortable: true,
                background: [
                    'light-6',
                    'white'
                ],
                border: {
                    color: 'light-2',
                    side: 'bottom',
                    size: 'small'
                }
            })
        });
    };
    return isVisible ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
        position: "center",
        onEsc: ()=>setIsVisible(false),
        onClickOutside: ()=>setIsVisible(false),
        responsive: false,
        style: {
            width: '95%',
            maxWidth: '1400px',
            maxHeight: '95vh',
            overflow: 'auto',
            borderRadius: '8px'
        },
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $98b6153ed086d9bd$export$11154b700737b45e), {
            width: "100%",
            title: t('equipment:retireEquipment'),
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d8fcb0015cca0f72$export$825a3c81a577bf46), {
                entityName: (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Equipment
            }),
            onSubmit: ()=>retireEquipment(),
            isLoading: isLoading || isRetiring,
            hideRequiredText: true,
            saveButtonLabel: t('common:retireButton'),
            saveButtonLoadingLabel: t('common:retiringButton'),
            saveButtonDisabled: !isConfirmed || !selectedEquipmentIds.length || !lastActivePeriod || !hasReason,
            headerChildren: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                    pad: "none",
                    onClick: ()=>setIsVisible(false),
                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c1da19823027de53$export$f39c2d165cd861fe), {
                        size: "20px"
                    }),
                    tip: t('common:close')
                }, "close")
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                pad: {
                    horizontal: 'medium',
                    bottom: 'medium'
                },
                gap: "medium",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                        gap: "1rem",
                        direction: "row",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e23e190c1adfeb13$export$a2518b5310db22ab), {
                                size: "medium",
                                color: "status-warning"
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                children: [
                                    t('equipment:retireWarning'),
                                    " ",
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("b", {
                                        children: t('common:after')
                                    }),
                                    " ",
                                    selectedPeriodLabel,
                                    "."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        direction: "row",
                        align: "end",
                        justify: "between",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                direction: "row",
                                align: "end",
                                gap: "small",
                                width: "40%",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d3263c98ec06168d$export$90b89cb54a5768ce), {
                                        id: "last_active_reporting_quarter",
                                        label: t('common:lastReportingPeriod'),
                                        placeholder: isLoading ? t('common:loading') : t('common:selectPeriod'),
                                        value: lastActivePeriod,
                                        setValue: (value)=>handlePeriodChange(value),
                                        clientId: facility.client_id,
                                        programId: facility.program_id,
                                        reportingPeriodTypeId: facility.reporting_period_type_id,
                                        firstActivePeriod: earliestFirstActive,
                                        required: true,
                                        width: '60%'
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $95684e66166a88c8$export$516f52107d98083f), {
                                        entityType: "equipment",
                                        showTextField: false,
                                        fill: "horizontal",
                                        reasonId: reasonId,
                                        setReasonId: setReasonId,
                                        setReasonText: setReasonText,
                                        setIsOther: setIsOther
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                direction: "row",
                                align: "center",
                                gap: "small",
                                children: [
                                    hasSelection && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "small",
                                        children: t('common:selectedCount', {
                                            count: selectedEquipmentIds.length
                                        })
                                    }),
                                    (hasSelection || !!metadata?.total) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $85ab7488c493b81c$export$6d88ebe453be59d7), {
                                        label: hasSelection ? t('common:clearAll') : `${t('common:selectAll')} (${metadata?.total})`,
                                        onClick: ()=>{
                                            setIsConfirmed(false);
                                            if (hasSelection) setSelectedEquipmentIds([]);
                                            else selectAll();
                                        },
                                        disabled: isSelectingAll || isLoading || isSearching
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f7f71094d2af306c$export$55d7609a8f1eccd2), {
                                        searchQuery: searchQuery,
                                        placeholder: t('equipment:searchBySerial'),
                                        setSearchQuery: setSearchQuery,
                                        onSearch: search,
                                        isSearching: isSearching
                                    })
                                ]
                            })
                        ]
                    }),
                    isOther && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $95684e66166a88c8$export$3109f1de68cd7ecc), {
                        value: reasonText,
                        setValue: setReasonText
                    }),
                    lastActivePeriod && hasReason && hasSelection && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                        gap: "1rem",
                        direction: "row",
                        align: "center",
                        background: {
                            color: 'status-error',
                            dark: true
                        },
                        pad: "medium",
                        round: "small",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                                checked: isConfirmed,
                                onChange: ()=>setIsConfirmed(!isConfirmed),
                                color: "white"
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                color: "white",
                                children: t('equipment:retireMultipleConfirmation', {
                                    count: selectedEquipmentIds.length,
                                    period: (0, $00658ccd6ec0135a$export$f96ebb633255a704)(lastActivePeriod, isCanada)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        gap: "small",
                        children: isLoading ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            pad: {
                                vertical: 'medium'
                            },
                            height: "10vh",
                            fill: "horizontal",
                            justify: "center",
                            align: "center",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8bec6e2e7dc53c4a$export$7f7cbe89f1eacd2), {
                                size: "medium"
                            })
                        }) : equipmentList.length ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
                            children: [
                                renderDataTable(),
                                !!metadata && metadata.total > limit && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    pad: {
                                        top: 'medium'
                                    },
                                    justify: "center",
                                    align: "center",
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ffccbada2139938a$export$68f5e1453c188a82), {
                                        alignSelf: "center",
                                        size: "small",
                                        page: currentPage,
                                        step: metadata.per_page,
                                        numberItems: metadata.total,
                                        onChange: (e)=>setCurrentPage(e.page)
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            pad: {
                                horizontal: 'small',
                                vertical: 'medium'
                            },
                            background: "light-6",
                            align: "center",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: "medium",
                                fontFamily: "Lato, sans-serif",
                                children: t('equipment:noEquipmentFound', 'No active equipment found.')
                            })
                        })
                    })
                ]
            })
        })
    }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cb4cc5db45d03478$exports.Fragment), {});
});




var $2xPiy = parcelRequire("2xPiy");












const $6c29c45a0502563a$export$b4f27205065e2049 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { facility: facility, isVisible: isVisible, setIsVisible: setIsVisible, setShouldRefresh: setShouldRefresh } = props;
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** Stores **/ const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const equipmentStore = (0, $116967e0234c3770$export$728bc2cead7f2c5a)();
    const equipmentUsageStore = (0, $116967e0234c3770$export$f93886ff234de9d1)();
    /** State **/ const [isFetchingUsages, setIsFetchingUsages] = (0, $2xPiy.useState)(true);
    const [isFetchingPeriods, setIsFetchingPeriods] = (0, $2xPiy.useState)(true);
    const [isUpdating, setIsUpdating] = (0, $2xPiy.useState)(false);
    const [allMeteredKwhValue, setAllMeteredKwhValue] = (0, $2xPiy.useState)('');
    const [reportingPeriods, setReportingPeriods] = (0, $2xPiy.useState)();
    const [selectedReportingPeriod, setSelectedReportingPeriod] = (0, $2xPiy.useState)();
    const [currentPage, setCurrentPage] = (0, $2xPiy.useState)(1);
    const [tableData, setTableData] = (0, $2xPiy.useState)();
    const [formValues, setFormValues] = (0, $2xPiy.useState)({});
    const [initialFormValues, setInitialFormValues] = (0, $2xPiy.useState)({});
    const pageLimit = 20;
    /** Computed **/ const isLoading = isFetchingPeriods || isFetchingUsages;
    const hasReportingPeriods = !isLoading && !!reportingPeriods?.length;
    const hasData = !isLoading && !!tableData?.length;
    const hasChanges = Object.keys(formValues).some((key)=>formValues[key] !== initialFormValues[key]);
    const isCanada = facility.reporting_period_type_id === (0, $0badf5665deea2b2$export$a121e4a6c908fa8f).Yearly;
    const selectedIndex = reportingPeriods?.findIndex((p)=>p.id === selectedReportingPeriod?.id) ?? -1;
    const previousPeriod = selectedIndex > -1 ? reportingPeriods?.[selectedIndex + 1] : undefined;
    const nextPeriod = selectedIndex > -1 ? reportingPeriods?.[selectedIndex - 1] : undefined;
    const totalRows = tableData?.length ?? 0;
    const paginatedData = tableData?.slice((currentPage - 1) * pageLimit, currentPage * pageLimit);
    /** Methods **/ const getIsEditable = (period)=>{
        if (!period) return false;
        const isQ2_2025 = period.start_reporting_quarter === '2025-04-01';
        if (userStore.isExternalUser) return !period.is_finalized && !period.is_client_locked && !isQ2_2025;
        else return !period.is_finalized;
    };
    /**
   * Set kWh Value
   */ const setValue = (usageId, newValue)=>{
        setFormValues({
            ...formValues,
            [usageId.toString()]: newValue ?? ''
        });
    };
    const formatKwh = (value)=>{
        const cleaned = value.replace(/[^0-9.]/g, '');
        const parts = cleaned.split('.');
        return parts.length > 2 ? `${parts[0]}.${parts.slice(1).join('')}` : cleaned;
    };
    /**
   * Set All kWh Values
   */ const setAllValues = (newValue)=>{
        const value = newValue ?? '';
        const newKwhValues = {
            ...formValues
        };
        for(const usageId in newKwhValues)newKwhValues[usageId.toString()] = value;
        setFormValues(newKwhValues);
        setAllMeteredKwhValue(value);
    };
    /**
   * Fetch Reporting Periods
   */ const fetchReportingPeriods = async (facility)=>{
        if (!facility.client_id || !facility.program_id) return;
        try {
            setIsFetchingPeriods(true);
            const { data: data } = await (0, $37f79218b8708603$export$225d8bcca10eefa2).list({
                client_id: facility.client_id,
                program_id: facility.program_id,
                limit: 1000,
                is_finalized: 0,
                reporting_period_type_id: facility.reporting_period_type_id
            });
            const periodData = data.reverse();
            setReportingPeriods(periodData);
            if (periodData.length) setSelectedReportingPeriod(periodData[0]);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listClientReportingPeriods.error);
        } finally{
            setIsFetchingPeriods(false);
        }
    };
    /**
   * Fetch EquipmentUsage Data
   */ const fetchEquipmentUsages = async (facilityId, selectedReportingPeriodId, previousPeriod)=>{
        try {
            setIsFetchingUsages(true);
            const promises = [
                equipmentUsageStore.listEquipmentUsagesByFacility({
                    facility_id: facilityId,
                    client_program_reporting_period_id: selectedReportingPeriodId,
                    is_metered: true
                })
            ];
            if (previousPeriod) promises.push(equipmentUsageStore.listEquipmentUsagesByFacility({
                facility_id: facilityId,
                client_program_reporting_period_id: previousPeriod.id,
                is_metered: true
            }));
            const [selectedUsages, previousUsages] = await Promise.all(promises);
            if (selectedUsages) await populateTableData(selectedUsages, previousUsages);
            else console.warn('No selected usages found');
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listClientReportingPeriods.error);
        } finally{
            setIsFetchingUsages(false);
        }
    };
    /**
   * Populates Table kWh Data
   */ const populateTableData = async (reportingQuarterUsages, previousReportingPeriodUsages)=>{
        const dataRows = [];
        const formValues = {};
        for (const equipmentUsage of reportingQuarterUsages){
            formValues[equipmentUsage.id] = equipmentUsage.total_kwh ?? '';
            const equipmentType = (equipmentStore.equipmentCategories || await equipmentStore.fetchEquipmentCategories() || []).flatMap((category)=>({
                    name: category.name,
                    equipment_types: category.equipment_types?.filter((type)=>type.id === equipmentUsage.equipment?.equipment_type_id)
                })).find((category)=>!!category.equipment_types?.length);
            const dataRow = {
                facilityId: equipmentUsage.equipment?.facility_id ?? '-',
                equipmentId: equipmentUsage.equipment?.id ?? '-',
                clientId: equipmentUsage.equipment?.client_id ?? '-',
                equipmentType: equipmentType?.equipment_types?.[0],
                serialNumber: equipmentUsage.equipment?.serial_number ?? '',
                manufacturer: equipmentUsage.equipment?.manufacturer ?? '',
                modelYear: equipmentUsage.equipment?.model_year ?? '',
                modelNumber: equipmentUsage.equipment?.model_number ?? '',
                unitNumber: equipmentUsage.equipment?.unit_number ?? '',
                currentUsageId: equipmentUsage.id
            };
            const previousUsage = previousReportingPeriodUsages?.find((usage)=>usage.equipment.id === equipmentUsage.equipment.id);
            if (previousUsage) {
                dataRow.previousUsageId = previousUsage.id;
                dataRow.previousMeteredKwh = previousUsage.total_kwh ?? undefined;
            }
            dataRows.push(dataRow);
        }
        setTableData(dataRows);
        setFormValues(formValues);
        setInitialFormValues({
            ...formValues
        });
        setAllMeteredKwhValue('');
        setCurrentPage(1);
    };
    /**
   * Update Metered Equipment
   */ const updateEquipment = async ()=>{
        if (!facility || !selectedReportingPeriod) return;
        try {
            setIsUpdating(true);
            const equipmentUsages = Object.keys(formValues).map((usageId)=>{
                const totalKwh = parseFloat(formatKwh(formValues[usageId]));
                return {
                    equipment_usage_id: parseInt(usageId),
                    total_kwh: Number.isFinite(totalKwh) ? totalKwh : null,
                    percent_uptime: null,
                    max_site_deliverability_kw: null
                };
            });
            const updateRequest = {
                facility_id: facility.id,
                client_program_reporting_period_id: selectedReportingPeriod.id,
                equipment_usages: equipmentUsages
            };
            await equipmentUsageStore.updateMultipleMeteredEquipmentUsages(updateRequest);
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updateMultipleMeteredEquipment.success);
            setShouldRefresh(true);
            setIsVisible(false);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updateMultipleMeteredEquipment.error);
        } finally{
            setIsUpdating(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (facility.client_id) fetchReportingPeriods(facility);
    }, [
        facility.client_id
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (facility && selectedReportingPeriod) fetchEquipmentUsages(facility.id, selectedReportingPeriod.id, previousPeriod);
    }, [
        facility.id,
        selectedReportingPeriod?.id,
        previousPeriod?.id
    ]);
    /** Render **/ const renderToolbar = (reportingPeriods)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            row: true,
            justify: "between",
            align: "center",
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    gap: "xsmall",
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            row: true,
                            gap: "xsmall",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    size: "xlarge",
                                    weight: 500,
                                    children: [
                                        getIsEditable(selectedReportingPeriod) ? 'Editing' : 'Viewing',
                                        " Period:"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    size: "xlarge",
                                    weight: 500,
                                    color: "accent-1",
                                    children: selectedReportingPeriod && (0, $00658ccd6ec0135a$export$f96ebb633255a704)(selectedReportingPeriod.start_reporting_quarter, isCanada)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: "medium",
                                weight: 300,
                                children: [
                                    (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(selectedReportingPeriod?.start_reporting_quarter).format('MMMM DD, YYYY'),
                                    " -",
                                    ' ',
                                    (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(selectedReportingPeriod?.start_reporting_quarter).add(2, 'months').endOf('month').format('MMMM DD, YYYY')
                                ]
                            })
                        })
                    ]
                }),
                !getIsEditable(selectedReportingPeriod) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    justify: "center",
                    align: "center",
                    pad: "1rem",
                    gap: "xsmall",
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        fontFamily: "Lato, sans-serif",
                        children: selectedReportingPeriod?.is_client_locked || selectedReportingPeriod?.start_reporting_quarter === '2025-04-01' ? 'This period has been locked and cannot be edited.' : 'This period has been finalized and can no longer be edited.'
                    })
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $26f637f3d75d0420$export$54d79d35af45a337), {
                    reportingPeriods: reportingPeriods,
                    setSelectedReportingPeriod: setSelectedReportingPeriod,
                    selectedReportingPeriod: selectedReportingPeriod,
                    previousPeriod: previousPeriod,
                    nextPeriod: nextPeriod,
                    isCanada: isCanada,
                    showNav: true
                })
            ]
        });
    const renderEquipmentTable = ()=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            elevation: "small",
            round: "xsmall",
            overflow: "hidden",
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                },
                primaryKey: "currentUsageId",
                columns: [
                    {
                        property: 'equipmentId',
                        size: '5%',
                        sortable: false,
                        render: (row)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                pad: {
                                    vertical: 'small'
                                },
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                                    to: `/clients/${row.clientId}/equipment/${row.equipmentId}`,
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        direction: "row",
                                        round: "6px",
                                        justify: "center",
                                        align: "center",
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ceab9ef72b825454$export$c92c6401b52a9298), {
                                            content: `${t('equipment:viewEquipmentId')} ${row.equipmentId}`,
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f97d8419a136e9e9$export$6d128738bddfaa67), {
                                                size: "16px",
                                                color: "accent-1"
                                            })
                                        })
                                    })
                                })
                            })
                    },
                    {
                        property: 'equipmentType.name',
                        size: '16%',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('equipment:chargingType')
                        }),
                        render: (row)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: row.equipmentType?.name || '-'
                            })
                    },
                    {
                        property: 'serialNumber',
                        size: '13%',
                        align: 'center',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('equipment:serialVin')
                        }),
                        render: (row)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: row.serialNumber?.length >= 22 ? `${row.serialNumber.slice(0, 4)}...${row.serialNumber.slice(-4)}` : row.serialNumber || '-'
                            })
                    },
                    {
                        property: 'manufacturer',
                        size: '12%',
                        align: 'center',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('equipment:manufacturer')
                        }),
                        render: (row)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: row.manufacturer || '-'
                            })
                    },
                    {
                        property: 'modelYear',
                        size: '10%',
                        align: 'center',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('equipment:modelYear')
                        }),
                        render: (row)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: row.modelYear || '-'
                            })
                    },
                    {
                        property: 'modelNumber',
                        size: '12%',
                        align: 'center',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('equipment:modelNumber')
                        }),
                        render: (row)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: row.modelNumber || '-'
                            })
                    },
                    {
                        property: 'unitNumber',
                        size: '10%',
                        align: 'center',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('equipment:unitNo')
                        }),
                        render: (row)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: row.unitNumber || '-'
                            })
                    },
                    {
                        property: 'previousMeteredKwh',
                        size: '11%',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "small",
                                        children: t('equipment:meteredKwh')
                                    }),
                                    previousPeriod?.start_reporting_quarter && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "small",
                                        children: [
                                            "(",
                                            (0, $00658ccd6ec0135a$export$f96ebb633255a704)(previousPeriod.start_reporting_quarter, isCanada),
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        }),
                        render: (row)=>row.previousMeteredKwh ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: (0, $00658ccd6ec0135a$export$f5dd818bff069720)(row.previousMeteredKwh, true),
                                unitName: "kWh"
                            }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: "-"
                            })
                    },
                    {
                        property: 'currentMeteredKwh',
                        size: '11%',
                        sortable: false,
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "small",
                                        children: t('equipment:meteredKwh')
                                    }),
                                    selectedReportingPeriod?.start_reporting_quarter && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "small",
                                        children: [
                                            "(",
                                            (0, $00658ccd6ec0135a$export$f96ebb633255a704)(selectedReportingPeriod.start_reporting_quarter, isCanada),
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        }),
                        render: (row)=>getIsEditable(selectedReportingPeriod) ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                direction: "row",
                                gap: "xsmall",
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $3e3a21379031f1b0$export$3358b55665249725), {
                                        value: formValues[row.currentUsageId.toString()] ?? '',
                                        setValue: (value)=>setValue(row.currentUsageId, formatKwh(value.toString()))
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "small",
                                        children: "kWh"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: (0, $00658ccd6ec0135a$export$f5dd818bff069720)(formValues[row.currentUsageId.toString()], true),
                                unitName: "kWh"
                            })
                    }
                ],
                data: paginatedData,
                sortable: true,
                background: [
                    'light-6',
                    'white'
                ],
                border: {
                    color: 'light-2',
                    side: 'bottom',
                    size: 'small'
                }
            })
        });
    const renderBulkEditField = ()=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
            direction: "row",
            justify: "between",
            align: "center",
            gap: "medium",
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    direction: "row",
                    gap: "small",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7dacb42a28be9c15$export$7036cd8426a1245b), {
                            size: "medium",
                            color: "accent-1"
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            gap: "xxsmall",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    weight: 700,
                                    children: [
                                        t('equipment:bulkEditAllKwh'),
                                        selectedReportingPeriod?.start_reporting_quarter && ` (${(0, $00658ccd6ec0135a$export$f96ebb633255a704)(selectedReportingPeriod.start_reporting_quarter, isCanada)})`
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    size: "small",
                                    color: "dark-4",
                                    children: t('equipment:bulkEditAllKwhHelp')
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    direction: "row",
                    gap: "xsmall",
                    align: "center",
                    width: "20%",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8c9c99ffe8765a99$export$c86715117507e8e5), {
                            name: "all_metered_kwh_value",
                            value: allMeteredKwhValue,
                            type: "number",
                            onChange: (e)=>setAllValues(e.target.value),
                            style: {
                                background: 'white',
                                paddingTop: '8px',
                                paddingBottom: '8px'
                            },
                            className: "hide-input-arrows",
                            disabled: !getIsEditable(selectedReportingPeriod)
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            size: "small",
                            children: "kWh"
                        })
                    ]
                })
            ]
        });
    const renderDataTable = ()=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            gap: "medium",
            children: [
                getIsEditable(selectedReportingPeriod) && renderBulkEditField(),
                renderEquipmentTable(),
                totalRows > pageLimit && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    justify: "center",
                    align: "center",
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ffccbada2139938a$export$68f5e1453c188a82), {
                        alignSelf: "center",
                        size: "small",
                        page: currentPage,
                        step: pageLimit,
                        numberItems: totalRows,
                        onChange: (e)=>setCurrentPage(e.page)
                    })
                })
            ]
        });
    return isVisible ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
        position: "center",
        onClickOutside: ()=>setIsVisible(false),
        onEsc: ()=>setIsVisible(false),
        responsive: false,
        style: {
            width: '90%',
            maxWidth: '1400px',
            maxHeight: '90vh',
            overflow: 'auto'
        },
        margin: "none",
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $98b6153ed086d9bd$export$11154b700737b45e), {
            width: "100%",
            title: t('equipment:updateMeteredEquipmentUsage'),
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $805d36e3aa560182$export$4f47cef615b0c343), {}),
            onSubmit: ()=>updateEquipment(),
            isLoading: isUpdating,
            hideRequiredText: true,
            hideSaveButton: !hasReportingPeriods || !getIsEditable(selectedReportingPeriod),
            saveButtonLabel: t('common:saveChanges'),
            saveButtonLoadingLabel: t('common:savingChanges'),
            saveButtonDisabled: !hasData || !hasChanges,
            headerChildren: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                    pad: "none",
                    onClick: ()=>setIsVisible(false),
                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c1da19823027de53$export$f39c2d165cd861fe), {
                        size: "20px"
                    }),
                    tip: t('common:close')
                }, "close")
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                gap: "medium",
                children: [
                    hasReportingPeriods && renderToolbar(reportingPeriods),
                    isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        pad: {
                            vertical: 'medium'
                        },
                        height: "10vh",
                        fill: "horizontal",
                        justify: "center",
                        align: "center",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8bec6e2e7dc53c4a$export$7f7cbe89f1eacd2), {
                            size: "medium"
                        })
                    }),
                    !isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cb4cc5db45d03478$exports.Fragment), {
                        children: hasData ? renderDataTable() : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            pad: {
                                vertical: '2rem'
                            },
                            background: "light-6",
                            align: "center",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: "medium",
                                fontFamily: "Lato, sans-serif",
                                children: hasReportingPeriods ? t('equipment:noMeteredEquipmentUsageDataFound') : t('equipment:noUsageDataFound')
                            })
                        })
                    })
                ]
            })
        })
    }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cb4cc5db45d03478$exports.Fragment), {});
});




var $2xPiy = parcelRequire("2xPiy");



var $2xPiy = parcelRequire("2xPiy");





var $dyr1f = parcelRequire("dyr1f");
var $41ee3468c03c6a7e$var$PropType = {};
$41ee3468c03c6a7e$var$PropType = {
    errors: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({}),
    infos: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({}),
    kind: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    messages: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        invalid: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        required: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    }),
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onReset: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onValidate: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    validate: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'blur',
        'submit',
        'change'
    ]),
    value: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({})
};
var $41ee3468c03c6a7e$export$87387e52a99daa8 = $41ee3468c03c6a7e$var$PropType;


var $04d59a1221f4208a$var$_excluded = [
    "children",
    "errors",
    "infos",
    "messages",
    "kind",
    "onChange",
    "onReset",
    "onSubmit",
    "onValidate",
    "validate",
    "value"
];
function $04d59a1221f4208a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $04d59a1221f4208a$var$_extends() {
    return $04d59a1221f4208a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $04d59a1221f4208a$var$_extends.apply(null, arguments);
}
var $04d59a1221f4208a$var$defaultValue = {};
var $04d59a1221f4208a$var$defaultTouched = {};
var $04d59a1221f4208a$var$defaultValidationResults = {
    errors: {},
    infos: {}
};
var $04d59a1221f4208a$var$defaultThreshold = 0.5;
var $04d59a1221f4208a$var$stringToArray = function stringToArray(string) {
    var match = string == null ? void 0 : string.match(/^(.+)\[([0-9]+)\]\.(.*)$/);
    if (match) {
        var arrayName = match[1], indexOfArray = match[2], arrayObjName = match[3];
        return {
            indexOfArray: indexOfArray,
            arrayName: arrayName,
            arrayObjName: arrayObjName
        };
    }
    return undefined;
};
var $04d59a1221f4208a$var$_getValueAt = function getValueAt(valueObject, pathArg) {
    if (valueObject === undefined) return undefined;
    var path = Array.isArray(pathArg) ? pathArg : pathArg.split('.');
    if (path.length === 1) return valueObject[path];
    return $04d59a1221f4208a$var$_getValueAt(valueObject[path.shift()], path);
};
var $04d59a1221f4208a$var$_setValueAt = function setValueAt(valueObject, pathArg, value) {
    var object = valueObject;
    var path = Array.isArray(pathArg) ? pathArg : pathArg.split('.');
    if (path.length === 1) object[path] = value;
    else {
        var key = path.shift();
        if (!object[key]) object[key] = {};
        $04d59a1221f4208a$var$_setValueAt(object[key], path, value);
    }
};
var $04d59a1221f4208a$var$getFieldValue = function getFieldValue(name, value) {
    var isArrayField = $04d59a1221f4208a$var$stringToArray(name);
    if (isArrayField) {
        var _value$arrayName;
        var indexOfArray = isArrayField.indexOfArray, arrayName = isArrayField.arrayName, arrayObjName = isArrayField.arrayObjName;
        var obj = (_value$arrayName = value[arrayName]) == null ? void 0 : _value$arrayName[indexOfArray];
        return arrayObjName ? obj == null ? void 0 : obj[arrayObjName] : obj;
    }
    return $04d59a1221f4208a$var$_getValueAt(value, name);
};
var $04d59a1221f4208a$var$setFieldValue = function setFieldValue(name, componentValue, prevValue) {
    var nextValue = $04d59a1221f4208a$var$_extends({}, prevValue);
    var isArrayField = $04d59a1221f4208a$var$stringToArray(name);
    if (isArrayField) {
        var indexOfArray = isArrayField.indexOfArray, arrayName = isArrayField.arrayName, arrayObjName = isArrayField.arrayObjName;
        if (!nextValue[arrayName]) nextValue[arrayName] = [];
        if (arrayObjName) {
            var _nextValue$arrayName$;
            if (!nextValue[arrayName][indexOfArray]) nextValue[arrayName][indexOfArray] = (_nextValue$arrayName$ = {}, _nextValue$arrayName$[arrayObjName] = componentValue, _nextValue$arrayName$);
            nextValue[arrayName][indexOfArray][arrayObjName] = componentValue;
        } else nextValue[arrayName][indexOfArray] = componentValue;
    } else $04d59a1221f4208a$var$_setValueAt(nextValue, name, componentValue);
    return nextValue;
};
var $04d59a1221f4208a$var$validateCharacterCount = function validateCharacterCount(format, rule, value) {
    var max = rule.max, threshold = rule.threshold;
    var getMessage = function getMessage() {
        var charactersRemaining = function charactersRemaining(plural) {
            return {
                id: "formField.maxCharacters.remaining." + (plural ? 'plural' : 'singular'),
                values: {
                    number: max - value.length
                }
            };
        };
        var charactersOverLimit = function charactersOverLimit(plural) {
            return {
                id: "formField.maxCharacters.overLimit." + (plural ? 'plural' : 'singular'),
                values: {
                    number: value.length - max
                }
            };
        };
        if (max - value.length >= 0) return format(charactersRemaining(max - value.length > 1));
        return format(charactersOverLimit(value.length - max > 1));
    };
    return value.length / max > (threshold != null ? threshold : $04d59a1221f4208a$var$defaultThreshold) ? {
        status: max - value.length >= 0 ? 'info' : 'error',
        message: getMessage()
    } : undefined;
};
// Apply validation rule to field value and send correct messaging.
var $04d59a1221f4208a$var$validate = function validate(rule, fieldValue, formValue, format, messages) {
    var result;
    if (typeof rule === 'function') result = rule(fieldValue, formValue);
    else if (rule.regexp) {
        if (!rule.regexp.test(fieldValue)) {
            result = rule.message || format({
                id: 'form.invalid',
                messages: messages
            });
            if (rule.status) result = {
                message: result,
                status: rule.status
            };
        }
    } else if (rule.max) result = $04d59a1221f4208a$var$validateCharacterCount(format, rule, fieldValue);
    return result;
};
// Validates particular key in formValue
var $04d59a1221f4208a$var$validateName = function validateName(validationRules, required) {
    return function(name, formValue, format, messages) {
        var fieldValue = $04d59a1221f4208a$var$getFieldValue(name, formValue);
        var validationResult;
        if (required && // false is for CheckBox
        (fieldValue === undefined || fieldValue === '' || fieldValue === false || Array.isArray(fieldValue) && !fieldValue.length)) validationResult = format({
            id: 'form.required',
            messages: messages
        });
        else if (validationRules) {
            if (Array.isArray(validationRules)) validationRules.some(function(rule) {
                validationResult = $04d59a1221f4208a$var$validate(rule, fieldValue, formValue, format, messages);
                return !!validationResult;
            });
            else validationResult = $04d59a1221f4208a$var$validate(validationRules, fieldValue, formValue, format, messages);
        }
        return validationResult;
    };
};
// Validates all keys in formValue
var $04d59a1221f4208a$var$validateForm = function validateForm(validationRules, formValue, format, messages, omitValid) {
    var nextErrors = {};
    var nextInfos = {};
    validationRules.forEach(function(_ref) {
        var name = _ref[0], _ref$ = _ref[1], field = _ref$.field, input = _ref$.input, validateOn = _ref$.validateOn;
        if (!omitValid) {
            nextErrors[name] = undefined;
            nextInfos[name] = undefined;
        }
        if (!validateOn) return;
        var result;
        if (input) // input() a validation function supplied through useFormInput()
        result = input(name, formValue, format, messages);
        if (field && !result) // field() a validation function supplied through useFormField()
        result = field(name, formValue, format, messages);
        // typeof error === 'object' is implied for both cases of error with
        // a status message and for an error object that is a react node
        if (typeof result === 'object') {
            if (result.status === 'info') nextInfos[name] = result.message;
            else nextErrors[name] = result.message || result; // could be a node
        } else if (typeof result === 'string') nextErrors[name] = result;
    });
    return [
        nextErrors,
        nextInfos
    ];
};
var $04d59a1221f4208a$var$isInstantValidate = function isInstantValidate(validateOn) {
    return [
        'blur',
        'change'
    ].includes(validateOn);
};
var $04d59a1221f4208a$export$a7fed597f4b8afd8 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref2, ref) {
    var children = _ref2.children, _ref2$errors = _ref2.errors, errorsProp = _ref2$errors === void 0 ? $04d59a1221f4208a$var$defaultValidationResults.errors : _ref2$errors, _ref2$infos = _ref2.infos, infosProp = _ref2$infos === void 0 ? $04d59a1221f4208a$var$defaultValidationResults.infos : _ref2$infos, messages = _ref2.messages, kind = _ref2.kind, onChange = _ref2.onChange, _onReset = _ref2.onReset, _onSubmit = _ref2.onSubmit, onValidate = _ref2.onValidate, _ref2$validate = _ref2.validate, validateOnProp = _ref2$validate === void 0 ? 'submit' : _ref2$validate, valueProp = _ref2.value, rest = $04d59a1221f4208a$var$_objectWithoutPropertiesLoose(_ref2, $04d59a1221f4208a$var$_excluded);
    var formRef = (0, $3cecef11d3b9c451$export$61dc559f8a0b9bcf)(ref);
    var _useContext = (0, $2xPiy.useContext)((0, $f1ad7bf122eed3b0$export$b060d577040138d8)), format = _useContext.format;
    var _useState = (0, $2xPiy.useState)(valueProp || $04d59a1221f4208a$var$defaultValue), valueState = _useState[0], setValueState = _useState[1];
    var value = (0, $2xPiy.useMemo)(function() {
        return valueProp || valueState;
    }, [
        valueProp,
        valueState
    ]);
    var _useState2 = (0, $2xPiy.useState)($04d59a1221f4208a$var$defaultTouched), touched = _useState2[0], setTouched = _useState2[1];
    var _useState3 = (0, $2xPiy.useState)(validateOnProp), validateOn = _useState3[0], setValidateOn = _useState3[1];
    var _useState4 = (0, $2xPiy.useState)({
        errors: errorsProp,
        infos: infosProp
    }), validationResults = _useState4[0], setValidationResults = _useState4[1];
    // maintain a copy of validationResults in a ref for useEffects
    // which can't depend on validationResults directly without
    // causing infinite renders.
    var validationResultsRef = (0, $2xPiy.useRef)({});
    // Simulated onMount state. Consider Form to be mounted once it has
    // accounted for values originating from controlled inputs (available
    // at second rendering).
    var _useState5 = (0, $2xPiy.useState)('unmounted'), mounted = _useState5[0], setMounted = _useState5[1];
    (0, $2xPiy.useEffect)(function() {
        if (!mounted) setMounted('mounting');
        else if (mounted === 'mounting') setMounted('mounted');
    }, [
        mounted
    ]);
    // `pendingValidation` is the name of the FormField awaiting validation.
    var _useState6 = (0, $2xPiy.useState)(undefined), pendingValidation = _useState6[0], setPendingValidation = _useState6[1];
    var validationRulesRef = (0, $2xPiy.useRef)({});
    var requiredFields = (0, $2xPiy.useRef)([]);
    var analyticsRef = (0, $2xPiy.useRef)({
        start: new Date(),
        errors: {}
    });
    var sendAnalytics = (0, $5bd12fcfcb46b8f6$export$e955abb82869dc84)();
    var buildValid = (0, $2xPiy.useCallback)(function(nextErrors) {
        var valid = false;
        valid = requiredFields.current.filter(function(n) {
            return Object.keys(validationRulesRef.current).includes(n);
        }).every(function(field) {
            return value[field] && (value[field] !== '' || value[field] !== false);
        });
        if (Object.keys(nextErrors).length > 0) valid = false;
        return valid;
    }, [
        value
    ]);
    // Only keep validation results for current form fields. In the case of a
    // dynamic form, a field possessing an error may have been removed from the
    // form; need to clean up any previous related validation results.
    var filterRemovedFields = function filterRemovedFields(prevValidations) {
        var nextValidations = prevValidations;
        return Object.keys(nextValidations).filter(function(n) {
            return !validationRulesRef.current[n] || nextValidations[n] === undefined;
        }).forEach(function(n) {
            return delete nextValidations[n];
        });
    };
    var updateAnalytics = function updateAnalytics() {
        var _validationResultsRef;
        var errorFields = Object.keys((_validationResultsRef = validationResultsRef.current) == null ? void 0 : _validationResultsRef.errors);
        var errorCounts = analyticsRef.current.errors;
        if (errorFields.length > 0) errorFields.forEach(function(key) {
            errorCounts[key] = (errorCounts[key] || 0) + 1;
        });
    };
    var applyValidationRules = (0, $2xPiy.useCallback)(function(validationRules) {
        var _validateForm = $04d59a1221f4208a$var$validateForm(validationRules, value, format, messages), validatedErrors = _validateForm[0], validatedInfos = _validateForm[1];
        setValidationResults(function(prevValidationResults) {
            // Keep any previous errors and infos for untouched keys,
            // these may have come from a Submit.
            var nextErrors = $04d59a1221f4208a$var$_extends({}, prevValidationResults.errors, validatedErrors);
            var nextInfos = $04d59a1221f4208a$var$_extends({}, prevValidationResults.infos, validatedInfos);
            // Remove previous errors and infos for keys no longer in the
            // form, these may have been fields removed from a dynamic form.
            filterRemovedFields(nextErrors);
            filterRemovedFields(nextInfos);
            var nextValidationResults = {
                errors: nextErrors,
                infos: nextInfos
            };
            if (onValidate) onValidate($04d59a1221f4208a$var$_extends({}, nextValidationResults, {
                valid: buildValid(nextErrors)
            }));
            validationResultsRef.current = nextValidationResults;
            updateAnalytics();
            return nextValidationResults;
        });
    }, [
        buildValid,
        format,
        messages,
        onValidate,
        value
    ]);
    // Validate all fields holding values onMount if set to
    // validate when blur or change.
    (0, $2xPiy.useEffect)(function() {
        var validationRules = Object.entries(validationRulesRef.current);
        // Use simulated onMount state to account for values provided by
        // controlled inputs.
        if (mounted !== 'mounted' && ($04d59a1221f4208a$var$isInstantValidate(validateOn) || validationRules.some(function(_ref3) {
            var v = _ref3[1];
            return $04d59a1221f4208a$var$isInstantValidate(v.validateOn);
        })) && Object.keys(value).length > 0 && Object.keys(touched).length === 0) applyValidationRules(validationRules.filter(function(_ref4) {
            var n = _ref4[0], v = _ref4[1];
            return $04d59a1221f4208a$var$getFieldValue(n, value) && v.validateOn;
        })// Exlude empty arrays which may be initial values in
        // an input such as DateInput.
        .filter(function(_ref5) {
            var n = _ref5[0];
            return !(Array.isArray($04d59a1221f4208a$var$getFieldValue(n, value)) && $04d59a1221f4208a$var$getFieldValue(n, value).length === 0);
        }));
    }, [
        applyValidationRules,
        mounted,
        touched,
        validateOn,
        value
    ]);
    // Run validation against fields with pendingValidations from onBlur
    // and/or onChange.
    (0, $2xPiy.useEffect)(function() {
        var validationRules = Object.entries(validationRulesRef.current);
        var timer = setTimeout(function() {
            if (pendingValidation && ($04d59a1221f4208a$var$isInstantValidate(validateOn) || validationRules.some(function(_ref6) {
                var v = _ref6[1];
                return $04d59a1221f4208a$var$isInstantValidate(v.validateOn);
            }))) {
                applyValidationRules(validationRules.filter(function(_ref7) {
                    var n = _ref7[0], v = _ref7[1];
                    return (touched[n] || pendingValidation.includes(n)) && v.validateOn;
                }));
                setPendingValidation(undefined);
            }
        // Complete any potential click events before running onBlur validation.
        // Otherwise, click events like reset, etc. may not be registered. For a
        // detailed scenario/discussion, see: https://github.com/grommet/grommet/issues/4863
        // Values empirically tested; 120 was selected because it is the largest
        // Chrome: 100, Safari: 120, Firefox: 80
        }, 120);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        applyValidationRules,
        pendingValidation,
        touched,
        validateOn
    ]);
    // Re-run validation rules for all fields with prior errors.
    // if validate=blur this helps re-validate if there are errors
    // as the user fixes them (basically act like validate=change for that)
    (0, $2xPiy.useEffect)(function() {
        var _validationResultsRef2;
        var validationRules = Object.entries(validationRulesRef.current);
        if ((_validationResultsRef2 = validationResultsRef.current) != null && _validationResultsRef2.errors && Object.keys(validationResultsRef.current.errors).length > 0) applyValidationRules(validationRules.filter(function(_ref8) {
            var n = _ref8[0];
            return touched[n] && validationResultsRef.current.errors[n];
        }));
    }, [
        applyValidationRules,
        touched
    ]);
    (0, $2xPiy.useEffect)(function() {
        var element = formRef.current;
        analyticsRef.current = {
            start: new Date(),
            errors: {}
        };
        sendAnalytics({
            type: 'formOpen',
            element: element
        });
        return function() {
            if (!analyticsRef.current.submitted) sendAnalytics({
                type: 'formClose',
                element: element,
                errors: analyticsRef.current.errors,
                elapsed: new Date().getTime() - analyticsRef.current.start.getTime()
            });
        };
    }, [
        sendAnalytics,
        formRef
    ]);
    // There are three basic patterns of handling form input value state:
    //
    // 1 - form controlled
    //
    // In this model, the caller sets `value` and `onChange` properties
    // on the Form component to supply the values used by the input fields.
    // In useFormContext(), componentValue would be undefined and formValue
    // is be set to whatever the form state has. Whenever the form state
    // changes, we update the contextValue so the input component will use
    // that. When the input component changes, we will call update() to
    // update the form state.
    //
    // 2 - input controlled
    //
    // In this model, the caller sets `value` and `onChange` properties
    // on the input components, like TextInput, to supply the value for it.
    // In useFormContext(), componentValue is this value and we ensure to
    // update the form state, via update(), and set the contextValue from
    // the componentValue. When the input component changes, we will
    // call update() to update the form state.
    //
    // 3 - uncontrolled
    //
    // In this model, the caller doesn't set a `value` or `onChange` property
    // at either the form or input component levels.
    // In useFormContext(), componentValue is undefined and valueProp is
    // undefined and nothing much happens here. That is, unless the
    // calling component needs to know the state in order to work, such
    // as CheckBox or Select. In this case, those components supply
    // an initialValue, which will trigger updating the contextValue so
    // they can have access to it.
    //
    var formContextValue = (0, $2xPiy.useMemo)(function() {
        var useFormInput = function useFormInput(_ref9) {
            var name = _ref9.name, componentValue = _ref9.value, initialValue = _ref9.initialValue, validateArg = _ref9.validate;
            var _useState7 = (0, $2xPiy.useState)(initialValue), inputValue = _useState7[0], setInputValue = _useState7[1];
            var formValue = name ? $04d59a1221f4208a$var$getFieldValue(name, value) : undefined;
            // for dynamic forms, we need to track when an input has been added to
            // the form value. if the input is unmounted, we will delete its
            // key/value from the form value.
            var keyCreated = (0, $2xPiy.useRef)(false);
            // This effect is for pattern #2, where the controlled input
            // component is driving the value via componentValue.
            (0, $2xPiy.useEffect)(function() {
                if (name && // we have somewhere to put this
                componentValue !== undefined && // input driving
                (Array.isArray(componentValue) && Array.isArray(formValue) ? componentValue.toString() !== formValue.toString() : componentValue !== formValue // don't already have it
                )) setValueState(function(prevValue) {
                    return $04d59a1221f4208a$var$setFieldValue(name, componentValue, prevValue);
                });
            }, [
                componentValue,
                formValue,
                name
            ]);
            // on unmount, if the form is uncontrolled, remove the key/value
            // from the form value
            (0, $2xPiy.useEffect)(function() {
                return function() {
                    if (keyCreated.current) {
                        keyCreated.current = false;
                        setValueState(function(prevValue) {
                            var nextValue = $04d59a1221f4208a$var$_extends({}, prevValue);
                            var isArrayField = $04d59a1221f4208a$var$stringToArray(name);
                            if (isArrayField) {
                                var arrayName = isArrayField.arrayName;
                                delete nextValue[arrayName];
                            } else delete nextValue[name];
                            return nextValue;
                        });
                    }
                };
            }, // eslint-disable-next-line react-hooks/exhaustive-deps
            [] // only run onmount and unmount
            );
            // Create validation rules for fields
            (0, $2xPiy.useEffect)(function() {
                if (validateArg) {
                    if (!validationRulesRef.current[name]) validationRulesRef.current[name] = {};
                    validationRulesRef.current[name].input = $04d59a1221f4208a$var$validateName(validateArg);
                    return function() {
                        return delete validationRulesRef.current[name].input;
                    };
                }
                return undefined;
            }, [
                validateArg,
                name
            ]);
            var useValue;
            if (componentValue !== undefined) // input component drives, pattern #2
            useValue = componentValue;
            else if (valueProp && name && formValue !== undefined) // form drives, pattern #1
            useValue = formValue;
            else if (formValue === undefined && name) // form has reset, so reset input value as well
            useValue = initialValue;
            else useValue = inputValue;
            return [
                useValue,
                function(nextComponentValue) {
                    if (name) {
                        // we have somewhere to put this
                        var nextTouched = $04d59a1221f4208a$var$_extends({}, touched);
                        nextTouched[name] = true;
                        if (!touched[name]) // don't update if not needed
                        setTouched(nextTouched);
                        // if nextValue doesn't have a key for name, this must be
                        // uncontrolled form. we will flag this field was added so
                        // we know to remove its value from the form if it is dynamically
                        // removed
                        if (!(name in value)) keyCreated.current = true;
                        var nextValue = $04d59a1221f4208a$var$setFieldValue(name, nextComponentValue, value);
                        setValueState(nextValue);
                        if (onChange) onChange(nextValue, {
                            touched: nextTouched
                        });
                    }
                    if (initialValue !== undefined) setInputValue(nextComponentValue);
                }
            ];
        };
        var useFormField = function useFormField(_ref0) {
            var errorArg = _ref0.error, infoArg = _ref0.info, name = _ref0.name, required = _ref0.required, disabled = _ref0.disabled, validateArg = _ref0.validate, validateOnArg = _ref0.validateOn;
            var error = disabled ? undefined : errorArg || validationResults.errors[name];
            var info = infoArg || validationResults.infos[name];
            (0, $2xPiy.useEffect)(function() {
                setValidateOn(function(prevValues) {
                    var _extends2;
                    if (typeof prevValues === 'string') {
                        var _ref1;
                        return _ref1 = {}, _ref1[name] = validateOnArg || validateOnProp, _ref1;
                    }
                    return $04d59a1221f4208a$var$_extends({}, prevValues, (_extends2 = {}, _extends2[name] = validateOnArg || validateOnProp, _extends2));
                });
            }, [
                validateOnArg,
                name
            ]);
            // Create validation rules for field
            (0, $2xPiy.useEffect)(function() {
                var index = requiredFields.current.indexOf(name);
                if (required) {
                    if (index === -1) requiredFields.current.push(name);
                } else if (index !== -1) requiredFields.current.splice(index, 1);
                if (validateArg || required) {
                    if (!validationRulesRef.current[name]) validationRulesRef.current[name] = {};
                    validationRulesRef.current[name].field = $04d59a1221f4208a$var$validateName(validateArg, required);
                    // priority is given to validateOn prop on formField, if it is
                    // undefined, then we will use the validate prop value of Form.
                    // The reason we don't want to add validateOn = "submit" here is
                    // because we don't want to trigger validation of "submit" field
                    // when the user is typing in the instant (blur, change)
                    // validation fields.
                    if (validateOnArg && validateOnArg !== 'submit') validationRulesRef.current[name].validateOn = validateOnArg;
                    else if (!validateOnArg && validateOnProp !== 'submit') validationRulesRef.current[name].validateOn = validateOnProp;
                    return function() {
                        delete validationRulesRef.current[name].field;
                        delete validationRulesRef.current[name].validateOn;
                        var requiredFieldIndex = requiredFields.current.indexOf(name);
                        if (requiredFieldIndex !== -1) requiredFields.current.splice(requiredFieldIndex, 1);
                    };
                }
                return undefined;
            }, [
                error,
                name,
                required,
                validateArg,
                disabled,
                validateOnArg
            ]);
            return {
                error: error,
                info: info,
                inForm: true,
                onBlur: validateOnArg === 'blur' || validateOn[name] === 'blur' ? function() {
                    return setPendingValidation(pendingValidation ? [].concat(pendingValidation, [
                        name
                    ]) : [
                        name
                    ]);
                } : undefined,
                onChange: validateOnArg === 'change' || validateOn[name] === 'change' ? function() {
                    return setPendingValidation(pendingValidation ? [].concat(pendingValidation, [
                        name
                    ]) : [
                        name
                    ]);
                } : undefined
            };
        };
        return {
            useFormField: useFormField,
            useFormInput: useFormInput,
            kind: kind
        };
    }, [
        onChange,
        kind,
        pendingValidation,
        touched,
        validateOn,
        validationResults.errors,
        validationResults.infos,
        value,
        valueProp,
        validateOnProp
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("form", $04d59a1221f4208a$var$_extends({
        ref: formRef
    }, rest, {
        onReset: function onReset(event) {
            sendAnalytics({
                type: 'formReset',
                element: formRef.current,
                data: event,
                errors: analyticsRef.current.errors,
                elapsed: new Date().getTime() - analyticsRef.current.start.getTime()
            });
            setPendingValidation(undefined);
            if (!valueProp) {
                setValueState($04d59a1221f4208a$var$defaultValue);
                if (onChange) onChange($04d59a1221f4208a$var$defaultValue, {
                    touched: $04d59a1221f4208a$var$defaultTouched
                });
            }
            setTouched($04d59a1221f4208a$var$defaultTouched);
            setValidationResults($04d59a1221f4208a$var$defaultValidationResults);
            analyticsRef.current = {
                start: new Date(),
                errors: {}
            };
            if (_onReset) {
                event.persist(); // extract from React's synthetic event pool
                var adjustedEvent = event;
                adjustedEvent.value = $04d59a1221f4208a$var$defaultValue;
                _onReset(adjustedEvent);
            }
        },
        onSubmit: function onSubmit(event) {
            // Don't submit the form via browser form action. We don't want it
            // if the validation fails. And, we assume a javascript action handler
            // otherwise.
            event.preventDefault();
            // Prevent any "outer" forms from performing `onSubmit`.
            // Nesting forms is not recommended in HTML. However, with React
            // portals, if the portal (such as Grommet's Layer) contains a form
            // and is nested within another form in the React tree, the event
            // bubbles up to the "outer" form even though in the DOM the portal
            // doesn't render as child of the "outer" form.
            // https://legacy.reactjs.org/docs/portals.html#event-bubbling-through-portals
            if (formRef.current && (event.target === formRef.current || event.target.form === formRef.current)) {
                setPendingValidation(undefined);
                // adding validateOn: "submit" prop to the undefined validateOn
                // fields as we want to trigger "submit" validation once form
                // is submitted
                var newValidationRulesRef = Object.keys(validationRulesRef.current).reduce(function(acc, key) {
                    acc[key] = validationRulesRef.current[key];
                    if (!acc[key].validateOn) acc[key] = $04d59a1221f4208a$var$_extends({}, validationRulesRef.current[key], {
                        validateOn: 'submit'
                    });
                    return acc;
                }, {});
                var _validateForm2 = $04d59a1221f4208a$var$validateForm(Object.entries(newValidationRulesRef), value, format, messages, true), nextErrors = _validateForm2[0], nextInfos = _validateForm2[1];
                setValidationResults(function() {
                    var nextValidationResults = {
                        errors: nextErrors,
                        infos: nextInfos,
                        // Show form's validity when clicking on Submit
                        valid: buildValid(nextErrors)
                    };
                    if (onValidate) onValidate(nextValidationResults);
                    validationResultsRef.current = nextValidationResults;
                    updateAnalytics();
                    return nextValidationResults;
                });
                if (Object.keys(nextErrors).length === 0 && _onSubmit) {
                    event.persist(); // extract from React's synthetic event pool
                    var adjustedEvent = event;
                    adjustedEvent.value = value;
                    adjustedEvent.touched = touched;
                    _onSubmit(adjustedEvent);
                    sendAnalytics({
                        type: 'formSubmit',
                        element: formRef.current,
                        data: adjustedEvent,
                        errors: analyticsRef.current.errors,
                        elapsed: new Date().getTime() - analyticsRef.current.start.getTime()
                    });
                    analyticsRef.current.errors = {};
                    analyticsRef.current.submitted = true;
                }
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $55ac84ad3d20c8d4$export$c24727297075ec6a).Provider, {
        value: formContextValue
    }, children));
});
$04d59a1221f4208a$export$a7fed597f4b8afd8.displayName = 'Form';
$04d59a1221f4208a$export$a7fed597f4b8afd8.propTypes = (0, $41ee3468c03c6a7e$export$87387e52a99daa8);



var $2xPiy = parcelRequire("2xPiy");

function $eabd1d040ee4804f$var$_extends() {
    return $eabd1d040ee4804f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $eabd1d040ee4804f$var$_extends.apply(null, arguments);
}
var $eabd1d040ee4804f$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $eabd1d040ee4804f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "List"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: "2",
        d: "M9 6h12M9 12h12M9 18h8M4 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
    }));
});
$eabd1d040ee4804f$export$54c2e3dc7acea9f5.displayName = 'List';








const $75095e19a0ae4c0f$export$61ef7bc6604b920 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { facility: facility, isVisible: isVisible, setIsVisible: setIsVisible, refreshData: refreshData, ...boxProps } = props;
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** Stores **/ const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const clientStore = (0, $116967e0234c3770$export$3b47afa599c78f61)();
    const equipmentUsageStore = (0, $116967e0234c3770$export$f93886ff234de9d1)();
    /** Defaults **/ const defaultFormValues = (0, $2xPiy.useRef)({
        client_program_reporting_period_id: NaN,
        shifts_per_day: NaN,
        charge_cycles_per_shift: NaN,
        work_days_per_quarter: NaN,
        percent_charger_efficiency_rating: NaN,
        percent_charge_return_factor: NaN,
        percent_depth_of_discharge: NaN
    });
    /** State **/ const [isUpdating, setIsUpdating] = (0, $2xPiy.useState)(false);
    const [selectedReportingPeriod, setSelectedReportingPeriod] = (0, $2xPiy.useState)();
    const [formValues, setFormValues] = (0, $2xPiy.useState)(defaultFormValues.current);
    const [formErrors, setFormErrors] = (0, $2xPiy.useState)({});
    /** Computed **/ const hasValues = !!formValues.charge_cycles_per_shift || !!formValues.percent_charge_return_factor || !!formValues.percent_charger_efficiency_rating || !!formValues.percent_depth_of_discharge || !!formValues.shifts_per_day || !!formValues.work_days_per_quarter;
    const isCanada = facility?.reporting_period_type_id === (0, $0badf5665deea2b2$export$a121e4a6c908fa8f).Yearly;
    const selectedIndex = clientStore.reportingPeriods?.findIndex((p)=>p.id === selectedReportingPeriod?.id) ?? -1;
    const previousPeriod = selectedIndex > -1 ? clientStore.reportingPeriods?.[selectedIndex + 1] : undefined;
    const nextPeriod = selectedIndex > -1 ? clientStore.reportingPeriods?.[selectedIndex - 1] : undefined;
    /** Methods **/ const getIsEditable = (period)=>{
        if (!period) return false;
        const isQ2_2025 = period.start_reporting_quarter === '2025-04-01';
        if (userStore.isExternalUser) return !period.is_finalized && !period.is_client_locked && !isQ2_2025;
        else return !period.is_finalized;
    };
    /**
   * Set Values
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const updateValue = (key, value)=>{
        if (key === 'charge_cycles_per_shift' && value > 9.99) setFormErrors({
            ...formErrors,
            charge_cycles_per_shift: 'Value cannot exceed 9.99'
        });
        else if (key === 'shifts_per_day' && value > 9.99) setFormErrors({
            ...formErrors,
            shifts_per_day: 'Value cannot exceed 9.99'
        });
        else if (key === 'work_days_per_quarter' && value > 92) setFormErrors({
            ...formErrors,
            work_days_per_quarter: 'Value cannot exceed 92 days'
        });
        (0, $2e4d07611f552ce8$export$c729434f4f29c53)(key, value, formValues, setFormValues, formErrors, setFormErrors);
    };
    /**
   * Updates multiple unmetered Equipment
   */ const updateMultipleUnmetered = async ()=>{
        if (!facility.id || !selectedReportingPeriod) return;
        const errors = (0, $084681c8221d0a24$export$5fafec8d1b047c0)({
            charge_cycles_per_shift: {
                label: 'Charge Cycles / Shift',
                required: true,
                max: 9.99,
                nonZero: true
            },
            shifts_per_day: {
                label: 'Shifts / Day',
                required: true,
                max: 9.99,
                nonZero: true
            },
            work_days_per_quarter: {
                label: 'Work Days / Quarter',
                required: true,
                max: 92,
                nonZero: true
            },
            percent_charger_efficiency_rating: {
                label: 'Charger Efficiency Rating',
                required: true
            },
            percent_charge_return_factor: {
                label: 'Charge Return Factor',
                required: true
            },
            percent_depth_of_discharge: {
                label: 'Depth of Discharge',
                required: true
            }
        }, formValues);
        if (errors) {
            setFormErrors(errors);
            return;
        }
        try {
            setIsUpdating(true);
            const updatedDetails = {
                facility_id: facility.id,
                client_program_reporting_period_id: selectedReportingPeriod.id,
                percent_charger_efficiency_rating: formValues.percent_charger_efficiency_rating,
                percent_charge_return_factor: formValues.percent_charge_return_factor,
                percent_depth_of_discharge: formValues.percent_depth_of_discharge,
                charge_cycles_per_shift: formValues.charge_cycles_per_shift,
                shifts_per_day: formValues.shifts_per_day,
                work_days_per_quarter: formValues.work_days_per_quarter
            };
            await equipmentUsageStore.updateMultipleUnmeteredEquipmentUsages(updatedDetails);
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updateNonMeteredEquipment.success);
            setIsVisible(false);
            await refreshData();
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updateNonMeteredEquipment.error);
        } finally{
            setIsUpdating(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (isVisible && facility.client_id && facility.program_id) clientStore.fetchClientReportingPeriods(facility.client_id, facility.reporting_period_type_id, undefined, undefined, facility.program_id).then((periods)=>setSelectedReportingPeriod(periods?.[0]));
    }, [
        isVisible,
        facility.client_id,
        facility.reporting_period_type_id,
        facility.program_id,
        clientStore
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (!isVisible) {
            setFormValues(defaultFormValues.current);
            setFormErrors({});
        }
    }, [
        isVisible
    ]);
    /** Render **/ return isVisible ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
        onEsc: ()=>setIsVisible(false),
        onClickOutside: ()=>setIsVisible(false),
        background: "transparent",
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            fill: "horizontal",
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                direction: "row",
                gap: "medium",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
                    ...boxProps,
                    children: facility?.client_id && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                                title: t('equipment:operationDetails'),
                                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $eabd1d040ee4804f$export$54c2e3dc7acea9f5), {
                                    size: "24px",
                                    color: "brand"
                                }),
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    direction: "row",
                                    gap: "1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $26f637f3d75d0420$export$54d79d35af45a337), {
                                            reportingPeriods: clientStore.reportingPeriods ?? [],
                                            setSelectedReportingPeriod: setSelectedReportingPeriod,
                                            selectedReportingPeriod: selectedReportingPeriod,
                                            previousPeriod: previousPeriod,
                                            nextPeriod: nextPeriod,
                                            isCanada: isCanada,
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                            alignSelf: "center",
                                            pad: "0.5rem",
                                            onClick: ()=>setIsVisible(false),
                                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c1da19823027de53$export$f39c2d165cd861fe), {
                                                size: "20px"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $04d59a1221f4208a$export$a7fed597f4b8afd8), {
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                                    saveButton: getIsEditable(selectedReportingPeriod) ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7ac54c23a62de8c7$export$4ecda0163efe6d1d), {
                                        type: "submit",
                                        isLoading: isUpdating,
                                        disabled: !hasValues,
                                        label: t('common:saveChanges'),
                                        onClick: ()=>updateMultipleUnmetered()
                                    }) : undefined,
                                    gap: "medium",
                                    children: [
                                        !getIsEditable(selectedReportingPeriod) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            width: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(712.5),
                                            height: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(140),
                                            justify: "center",
                                            align: "center",
                                            pad: "1rem",
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                fontFamily: "Lato, sans-serif",
                                                children: selectedReportingPeriod?.is_client_locked || selectedReportingPeriod?.start_reporting_quarter === '2025-04-01' ? `${t('equipment:periodHasBeenLockedAndCannotBeEdited')}` : `${t('equipment:periodHasBeenFinalizedAndCanNoLongerBeEdited')}`
                                            })
                                        }),
                                        getIsEditable(selectedReportingPeriod) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            gap: "medium",
                                            width: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(712.5),
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                    direction: "row",
                                                    gap: "small",
                                                    justify: "between",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                            flex: "grow",
                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                                label: t('equipment:chargingCyclesShift'),
                                                                type: "number",
                                                                value: formValues.charge_cycles_per_shift || '',
                                                                setValue: (value)=>updateValue('charge_cycles_per_shift', value),
                                                                name: "charge_cycles_per_shift",
                                                                error: formErrors['charge_cycles_per_shift'],
                                                                required: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                            flex: "grow",
                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                                label: t('equipment:shiftsDay'),
                                                                type: "number",
                                                                value: formValues.shifts_per_day || '',
                                                                setValue: (value)=>updateValue('shifts_per_day', value),
                                                                name: "shifts_per_day",
                                                                error: formErrors['shifts_per_day'],
                                                                required: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                            flex: "grow",
                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                                label: t('equipment:workDaysQuarter'),
                                                                type: "number",
                                                                value: formValues.work_days_per_quarter || '',
                                                                setValue: (value)=>updateValue('work_days_per_quarter', value),
                                                                name: "work_days_per_quarter",
                                                                error: formErrors['work_days_per_quarter'],
                                                                required: true
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                    direction: "row",
                                                    gap: "small",
                                                    justify: "between",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                            flex: "grow",
                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                                label: t('equipment:chargerEfficiencyRating'),
                                                                componentType: "percent",
                                                                value: formValues.percent_charger_efficiency_rating || '',
                                                                setValue: (value)=>updateValue('percent_charger_efficiency_rating', value),
                                                                name: "percent_charger_efficiency_rating",
                                                                error: formErrors['percent_charger_efficiency_rating'],
                                                                required: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                            flex: "grow",
                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                                label: t('equipment:chargeReturnFactor'),
                                                                componentType: "percent",
                                                                value: formValues.percent_charge_return_factor || '',
                                                                setValue: (value)=>updateValue('percent_charge_return_factor', value),
                                                                name: "percent_charge_return_factor",
                                                                error: formErrors['percent_charge_return_factor'],
                                                                required: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                            flex: "grow",
                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                                label: t('equipment:depthOfDischarge'),
                                                                componentType: "percent",
                                                                value: formValues.percent_depth_of_discharge || '',
                                                                setValue: (value)=>updateValue('percent_depth_of_discharge', value),
                                                                name: "percent_depth_of_discharge",
                                                                error: formErrors['percent_depth_of_discharge'],
                                                                required: true
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        })
    }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cb4cc5db45d03478$exports.Fragment), {});
});



parcelRequire("2xPiy");





const $62a54a62048a38c2$export$c87604745e124f91 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { equipmentUsages: equipmentUsages, tableCells: tableCells, cellWidth: cellWidth, equipment: equipment, formValues: formValues, updateFormValue: updateFormValue, formErrors: formErrors, quarterColumnWidth: quarterColumnWidth = 8, showQuarterColumn: showQuarterColumn = false, isCanada: isCanada = false } = props;
    const columnCount = tableCells.length || 1;
    const leftoverWidth = 100 - (showQuarterColumn ? quarterColumnWidth ?? 0 : 0);
    const width = cellWidth ?? (showQuarterColumn && quarterColumnWidth ? `${leftoverWidth / columnCount}%` : `${100 / columnCount}%`);
    const getRowBackground = (rowIndex)=>rowIndex % 2 ? 'white' : 'light-6';
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        border: {
            side: 'all',
            size: '0.4px',
            color: 'light-2'
        },
        row: true,
        wrap: true,
        fill: "vertical",
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                direction: "column",
                flex: false,
                height: '100%',
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $3eef26db3a873d75$export$a50edf83e83f547d), {
                        label: "",
                        width: "3rem",
                        minWidth: "3rem"
                    }),
                    equipmentUsages.map((equipmentUsage, rowIndex)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            width: "3rem",
                            style: {
                                minWidth: '3rem'
                            },
                            justify: "center",
                            align: "center",
                            border: {
                                side: 'all',
                                size: '0.4px',
                                color: 'light-2'
                            },
                            pad: {
                                vertical: 'xsmall',
                                horizontal: 'xsmall'
                            },
                            background: getRowBackground(rowIndex),
                            height: '6rem',
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                                to: `/clients/${equipment?.client_id}/equipment/${equipment?.id}/usages/${equipmentUsage.id}`,
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    align: "center",
                                    justify: "center",
                                    style: {
                                        height: '3rem',
                                        position: 'relative'
                                    },
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ceab9ef72b825454$export$c92c6401b52a9298), {
                                        content: `View ${(0, $00658ccd6ec0135a$export$f96ebb633255a704)(equipmentUsage.start_reporting_quarter, isCanada)} Usage Details`,
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f97d8419a136e9e9$export$6d128738bddfaa67), {
                                            size: "20px",
                                            color: "accent-1"
                                        })
                                    })
                                })
                            })
                        }, equipmentUsage.id ?? rowIndex))
                ]
            }),
            showQuarterColumn && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                direction: "column",
                flex: false,
                width: `${quarterColumnWidth}%`,
                height: '100%',
                style: {
                    minWidth: '3rem'
                },
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $3eef26db3a873d75$export$a50edf83e83f547d), {
                        label: "Period",
                        width: `${quarterColumnWidth}%`
                    }),
                    equipmentUsages.map((equipmentUsage, rowIndex)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            width: "100%",
                            align: "center",
                            border: {
                                side: 'all',
                                size: '0.4px',
                                color: 'light-2'
                            },
                            pad: {
                                vertical: 'xsmall',
                                horizontal: 'xsmall'
                            },
                            background: getRowBackground(rowIndex),
                            style: {
                                height: '3rem'
                            },
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                toUpperCase: true,
                                weight: 500,
                                children: (0, $00658ccd6ec0135a$export$f96ebb633255a704)(equipmentUsage.start_reporting_quarter, isCanada)
                            })
                        }, `${equipmentUsage.id ?? rowIndex}-period`))
                ]
            }),
            tableCells.map((cellData, columnIndex)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    direction: "column",
                    width: typeof width === 'number' ? width.toString() : width,
                    flex: true,
                    fill: true,
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $3eef26db3a873d75$export$a50edf83e83f547d), {
                            label: cellData.label,
                            width: width,
                            required: cellData.required ? true : undefined
                        }),
                        equipmentUsages.map((equipmentUsage, rowIndex)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $4c6109cf9a14d5e7$export$af0dbca8b89be5c5), {
                                index: columnIndex,
                                width: typeof width === 'number' ? width.toString() : width,
                                isEditable: cellData.isEditable,
                                valueKey: cellData.valueKey,
                                formValues: formValues,
                                updateFormValue: updateFormValue,
                                formErrors: formErrors,
                                unit: cellData.unit,
                                inputMode: cellData.isEditable ? cellData.inputMode : undefined,
                                formatNumber: cellData.formatNumber,
                                background: getRowBackground(rowIndex)
                            }, `${cellData.valueKey ?? columnIndex}-${equipmentUsage.id ?? rowIndex}`))
                    ]
                }, cellData.valueKey ?? cellData.label ?? columnIndex))
        ]
    });
});



parcelRequire("2xPiy");




const $4c6109cf9a14d5e7$export$af0dbca8b89be5c5 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { index: index, width: width, isEditable: isEditable, valueKey: valueKey, formValues: formValues, updateFormValue: updateFormValue, formErrors: formErrors, inputType: inputType = 'number', inputMode: inputMode = 'decimal', unit: unit, formatNumber: formatNumber, background: background } = props;
    const value = valueKey && (typeof formValues?.[valueKey] === 'string' || typeof formValues?.[valueKey] === 'number') ? formValues[valueKey] : '-';
    const canEdit = isEditable && !!valueKey && !!formValues && !!updateFormValue;
    const error = valueKey ? formErrors?.[valueKey] : undefined;
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        width: typeof width === 'number' ? width.toString() : width,
        align: "center",
        justify: "start",
        border: {
            side: 'all',
            size: '0.4px',
            color: 'light-2'
        },
        pad: {
            top: '26px',
            horizontal: '17px'
        },
        gap: "xsmall",
        direction: "column",
        background: background,
        style: {
            minHeight: '96px',
            position: 'relative'
        },
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                row: true,
                gap: "xsmall",
                align: "center",
                justify: "center",
                width: "100%",
                flex: false,
                children: [
                    !canEdit && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        height: "2.25rem",
                        justify: "center",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            toUpperCase: true,
                            children: formatNumber ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(value, true) || '-' : value
                        })
                    }),
                    canEdit && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        flex: "grow",
                        align: "center",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8c9c99ffe8765a99$export$c86715117507e8e5), {
                            id: valueKey,
                            name: valueKey,
                            value: formValues[valueKey] ?? '',
                            type: inputType,
                            inputMode: inputMode,
                            textAlign: "center",
                            onChange: (e)=>valueKey ? updateFormValue(valueKey, e.target.value) : undefined,
                            className: "hide-input-arrows",
                            height: "2.25rem",
                            style: {
                                background: !canEdit ? 'light-2' : 'white',
                                paddingTop: '8px',
                                paddingBottom: '8px',
                                borderColor: error ? 'red' : undefined
                            }
                        })
                    }),
                    unit && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        children: [
                            unit === 'percent' && '%',
                            unit === 'kwh' && 'kWh'
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                width: "100%",
                flex: false,
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    size: "0.7rem",
                    color: "status-error",
                    style: {
                        textAlign: 'center',
                        lineHeight: '1',
                        display: 'block'
                    },
                    children: error
                })
            })
        ]
    }, index);
});



parcelRequire("2xPiy");


const $3eef26db3a873d75$export$a50edf83e83f547d = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { label: label, width: width, minWidth: minWidth, style: style, required: required } = props;
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        width: typeof width === 'number' ? `${width}px` : width,
        minWidth: minWidth ? typeof minWidth === 'number' ? `${minWidth}px` : minWidth : undefined,
        align: "center",
        justify: "center",
        border: {
            side: 'all',
            size: '0.4px',
            color: 'light-2'
        },
        pad: "small",
        flex: false,
        style: {
            height: '100px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...style
        },
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
            size: "small",
            weight: 300,
            toUpperCase: true,
            textAlign: "center",
            style: {
                maxHeight: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            },
            children: [
                label,
                required === true && ' *'
            ]
        })
    });
});



parcelRequire("2xPiy");



const $d9744627da6af181$export$707f5522c6543027 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(({ ...props })=>{
    const { equipmentUsage: equipmentUsage, tableCells: tableCells, cellWidth: cellWidth, rowIndex: rowIndex, quarterColumnWidth: quarterColumnWidth, isCanada: isCanada = false, showQuarterColumn: showQuarterColumn = false, formValues: formValues, updateFormValue: updateFormValue, formErrors: formErrors } = props;
    const leftoverWidth = 100 - (quarterColumnWidth ?? 0);
    const width = cellWidth ?? (showQuarterColumn && quarterColumnWidth ? `${leftoverWidth / 6}%` : `${100 / 6}%`);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        row: true,
        background: rowIndex && rowIndex % 2 ? 'white' : 'light-6',
        children: [
            showQuarterColumn && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                width: `${quarterColumnWidth}%`,
                align: "center",
                border: {
                    side: 'all',
                    size: '0.4px',
                    color: 'light-2'
                },
                pad: "small",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    toUpperCase: true,
                    weight: 500,
                    children: (0, $00658ccd6ec0135a$export$f96ebb633255a704)(equipmentUsage.start_reporting_quarter, isCanada)
                })
            }),
            tableCells.map((cellData, cellIndex)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $4c6109cf9a14d5e7$export$af0dbca8b89be5c5), {
                    index: cellIndex,
                    width: width,
                    isEditable: cellData.isEditable,
                    valueKey: cellData.valueKey,
                    formValues: formValues,
                    updateFormValue: updateFormValue,
                    formErrors: formErrors,
                    unit: cellData.unit,
                    inputMode: cellData.isEditable ? cellData.inputMode : undefined,
                    formatNumber: cellData.formatNumber
                }, cellIndex))
        ]
    }, rowIndex);
});








var $2xPiy = parcelRequire("2xPiy");


var $2xPiy = parcelRequire("2xPiy");

function $11571e85aa9685ed$var$_extends() {
    return $11571e85aa9685ed$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $11571e85aa9685ed$var$_extends.apply(null, arguments);
}
var $11571e85aa9685ed$export$5a89edf87f611fb5 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $11571e85aa9685ed$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CircleAlert"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        stroke: "#000",
        strokeWidth: "2",
        fill: "none",
        d: "M12 14V6m0 12v-2m0-14C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z"
    }));
});
$11571e85aa9685ed$export$5a89edf87f611fb5.displayName = 'CircleAlert';





var $2xPiy = parcelRequire("2xPiy");

function $d48fc541d96cd8f0$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $d48fc541d96cd8f0$var$_extends() {
    return $d48fc541d96cd8f0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d48fc541d96cd8f0$var$_extends.apply(null, arguments);
}
var $d48fc541d96cd8f0$export$861edd1ccea2f746 = function Main(_ref) {
    var rest = $d48fc541d96cd8f0$var$_extends({}, ($d48fc541d96cd8f0$var$_objectDestructuringEmpty(_ref), _ref));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), $d48fc541d96cd8f0$var$_extends({
        as: "main",
        fill: "vertical",
        flex: "grow",
        overflow: "auto"
    }, rest));
};



const $f068601a66842d6c$export$c1faa9c8f42906a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        style: {
            minHeight: '100vh'
        },
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c3e91fa8212c6d4c$export$50d7b5e01df871ca), {}),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d48fc541d96cd8f0$export$861edd1ccea2f746), {
                background: "light",
                children: [
                    children,
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $605617a28ba64070$export$3210cca7a959581e), {})
                    })
                ]
            })
        ]
    });
};





const $63b81b7a12b117de$export$92b5a78288d46b08 = ()=>{
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const isMobile = (0, $18588a518ac6fdc7$export$2ac00d7098bf223)(screenSize);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f068601a66842d6c$export$c1faa9c8f42906a), {
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            flex: "grow",
            justify: "center",
            align: "center",
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
                flex: "shrink",
                width: !isMobile ? '35%' : '80%',
                margin: {
                    bottom: 'xlarge'
                },
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                        title: "Unauthorized",
                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $11571e85aa9685ed$export$5a89edf87f611fb5), {
                            color: "brand"
                        })
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            pad: {
                                vertical: 'xsmall'
                            },
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                fontFamily: "Lato, sans-serif",
                                children: "You don't have access to this page."
                            })
                        })
                    })
                ]
            })
        })
    });
};




/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $1f46b14b25973594$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $2135a815867df812$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $2135a815867df812$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $2135a815867df812$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    const finalIntegrations = $2135a815867df812$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = finalIntegrations.findIndex((integration)=>integration.name === 'Debug');
    if (debugIndex > -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $2135a815867df812$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $2135a815867df812$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $2135a815867df812$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $2135a815867df812$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($2135a815867df812$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $2135a815867df812$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $2135a815867df812$export$2d8f5188773bcddd(integration) {
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $2135a815867df812$export$2323046b9414659f(fn) {
    return fn;
}




const $d668e2a4b0475ef5$var$STACKTRACE_FRAME_LIMIT = 50;
const $d668e2a4b0475ef5$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $d668e2a4b0475ef5$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $d668e2a4b0475ef5$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $d668e2a4b0475ef5$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $d668e2a4b0475ef5$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($d668e2a4b0475ef5$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $d668e2a4b0475ef5$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $d668e2a4b0475ef5$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $d668e2a4b0475ef5$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $d668e2a4b0475ef5$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $d668e2a4b0475ef5$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($d668e2a4b0475ef5$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($d668e2a4b0475ef5$var$STRIP_FRAME_REGEXP.test($d668e2a4b0475ef5$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($d668e2a4b0475ef5$var$STRIP_FRAME_REGEXP.test($d668e2a4b0475ef5$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $d668e2a4b0475ef5$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $d668e2a4b0475ef5$var$getLastStackFrame(localStack).filename,
            function: frame.function || $d668e2a4b0475ef5$export$27c7e15d453fc0ac
        }));
}
function $d668e2a4b0475ef5$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $d668e2a4b0475ef5$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $d668e2a4b0475ef5$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $d668e2a4b0475ef5$var$defaultFunctionName;
        return fn.name || $d668e2a4b0475ef5$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $d668e2a4b0475ef5$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $d668e2a4b0475ef5$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}


const $e4abaab4bcbee8b0$var$INTEGRATION_NAME = 'Dedupe';
const $e4abaab4bcbee8b0$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $e4abaab4bcbee8b0$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($e4abaab4bcbee8b0$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $e4abaab4bcbee8b0$export$6d39aa44cd0c7567 = (0, $2135a815867df812$export$2323046b9414659f)($e4abaab4bcbee8b0$var$_dedupeIntegration);
/** only exported for tests. */ function $e4abaab4bcbee8b0$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($e4abaab4bcbee8b0$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($e4abaab4bcbee8b0$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $e4abaab4bcbee8b0$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$e4abaab4bcbee8b0$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$e4abaab4bcbee8b0$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $e4abaab4bcbee8b0$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $e4abaab4bcbee8b0$var$_getExceptionFromEvent(previousEvent);
    const currentException = $e4abaab4bcbee8b0$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$e4abaab4bcbee8b0$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$e4abaab4bcbee8b0$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $e4abaab4bcbee8b0$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $d668e2a4b0475ef5$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $d668e2a4b0475ef5$export$91d8ca51bd9f6a47)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $e4abaab4bcbee8b0$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $e4abaab4bcbee8b0$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}




let $e196c1893a780844$var$originalFunctionToString;
const $e196c1893a780844$var$INTEGRATION_NAME = 'FunctionToString';
const $e196c1893a780844$var$SETUP_CLIENTS = new WeakMap();
const $e196c1893a780844$var$_functionToStringIntegration = ()=>{
    return {
        name: $e196c1893a780844$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $e196c1893a780844$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $9d45b9df9881c412$export$e6cc1e135e2092e5)(this);
                    const context = $e196c1893a780844$var$SETUP_CLIENTS.has((0, $a383148e3fcc828a$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $e196c1893a780844$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $e196c1893a780844$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $e196c1893a780844$export$7918117e9202e4fb = (0, $2135a815867df812$export$2323046b9414659f)($e196c1893a780844$var$_functionToStringIntegration);



/** Regular expression used to parse a Dsn. */ const $86d9ae5b2fb1b398$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $86d9ae5b2fb1b398$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $86d9ae5b2fb1b398$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $86d9ae5b2fb1b398$export$b892860177f70a30(str) {
    const match = $86d9ae5b2fb1b398$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $2c5c4ba32bebd8b3$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $86d9ae5b2fb1b398$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $86d9ae5b2fb1b398$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $86d9ae5b2fb1b398$var$validateDsn(dsn) {
    if (!(0, $398ec29dacbd7df2$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$86d9ae5b2fb1b398$var$isValidProtocol(protocol)) {
        (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $86d9ae5b2fb1b398$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $86d9ae5b2fb1b398$export$b892860177f70a30(from) : $86d9ae5b2fb1b398$var$dsnFromComponents(from);
    if (!components || !$86d9ae5b2fb1b398$var$validateDsn(components)) return undefined;
    return components;
}


const $bcd1105623a7bc13$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $bcd1105623a7bc13$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $bcd1105623a7bc13$var$_getIngestEndpoint(dsn) {
    return `${$bcd1105623a7bc13$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $bcd1105623a7bc13$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $bcd1105623a7bc13$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $bcd1105623a7bc13$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$bcd1105623a7bc13$var$_getIngestEndpoint(dsn)}?${$bcd1105623a7bc13$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $bcd1105623a7bc13$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $86d9ae5b2fb1b398$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$bcd1105623a7bc13$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $86d9ae5b2fb1b398$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}






// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $ab1dff1b301a8161$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    "undefined is not an object (evaluating 'a.L')",
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
    /^Java exception was raised during method invocation$/
];
/** Options for the InboundFilters integration */ const $ab1dff1b301a8161$var$INTEGRATION_NAME = 'InboundFilters';
const $ab1dff1b301a8161$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $ab1dff1b301a8161$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $ab1dff1b301a8161$var$_mergeOptions(options, clientOptions);
            return $ab1dff1b301a8161$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $ab1dff1b301a8161$export$cb3c5c2ceb9818ba = (0, $2135a815867df812$export$2323046b9414659f)($ab1dff1b301a8161$var$_inboundFiltersIntegration);
function $ab1dff1b301a8161$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $ab1dff1b301a8161$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $ab1dff1b301a8161$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $ab1dff1b301a8161$var$_isSentryError(event)) {
        (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $3340a52637a7f113$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($ab1dff1b301a8161$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $3340a52637a7f113$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($ab1dff1b301a8161$var$_isUselessError(event)) {
        (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $3340a52637a7f113$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($ab1dff1b301a8161$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $3340a52637a7f113$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($ab1dff1b301a8161$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $3340a52637a7f113$export$4157119e2b157127)(event)}.\nUrl: ${$ab1dff1b301a8161$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$ab1dff1b301a8161$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $3340a52637a7f113$export$4157119e2b157127)(event)}.\nUrl: ${$ab1dff1b301a8161$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $ab1dff1b301a8161$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $ab1dff1b301a8161$var$_getPossibleEventMessages(event).some((message)=>(0, $b846d2d7ea7b5879$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $ab1dff1b301a8161$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $b846d2d7ea7b5879$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $ab1dff1b301a8161$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $ab1dff1b301a8161$var$_getEventFilterUrl(event);
    return !url ? false : (0, $b846d2d7ea7b5879$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $ab1dff1b301a8161$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $ab1dff1b301a8161$var$_getEventFilterUrl(event);
    return !url ? true : (0, $b846d2d7ea7b5879$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $ab1dff1b301a8161$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    return possibleMessages;
}
function $ab1dff1b301a8161$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $ab1dff1b301a8161$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $ab1dff1b301a8161$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $ab1dff1b301a8161$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $3340a52637a7f113$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $ab1dff1b301a8161$var$_isUselessError(event) {
    if (event.type) // event is not an error
    return false;
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception || !event.exception.values || event.exception.values.length === 0) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $e116253dcd9c0933$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $1f46b14b25973594$export$16a28057038b10ef) (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $2c5c4ba32bebd8b3$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $a383148e3fcc828a$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $e116253dcd9c0933$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $e116253dcd9c0933$export$ecb76f41d43c0e43(client) {
    (0, $a383148e3fcc828a$export$c7be4b0125a10cba)().setClient(client);
}

const $4d8dcfea76790756$export$849dbeeeda01ae98 = 'production';
















/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $c133b3629f3b6130$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($c133b3629f3b6130$var$States || ($c133b3629f3b6130$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $c133b3629f3b6130$export$1fda8aa4d135f8aa(value) {
    return new $c133b3629f3b6130$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $c133b3629f3b6130$export$78e43115b553f358(reason) {
    return new $c133b3629f3b6130$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $c133b3629f3b6130$export$6f292d4960313241 {
    constructor(executor){
        $c133b3629f3b6130$export$6f292d4960313241.prototype.__init.call(this);
        $c133b3629f3b6130$export$6f292d4960313241.prototype.__init2.call(this);
        $c133b3629f3b6130$export$6f292d4960313241.prototype.__init3.call(this);
        $c133b3629f3b6130$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $c133b3629f3b6130$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $c133b3629f3b6130$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $c133b3629f3b6130$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($c133b3629f3b6130$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($c133b3629f3b6130$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $c133b3629f3b6130$var$States.PENDING) return;
            if ((0, $5d145fc2c94d286e$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $c133b3629f3b6130$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $c133b3629f3b6130$var$States.RESOLVED) handler[1](this._value);
                if (this._state === $c133b3629f3b6130$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}


/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $0b0ab73e00c1f09e$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $c133b3629f3b6130$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $1f46b14b25973594$export$16a28057038b10ef) && processor.id && result === null && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $5d145fc2c94d286e$export$f5b060c2914b97c8)(result)) result.then((final)=>$0b0ab73e00c1f09e$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $0b0ab73e00c1f09e$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}




let $eec9e4fac93d12af$var$parsedStackResults;
let $eec9e4fac93d12af$var$lastKeysCount;
let $eec9e4fac93d12af$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $eec9e4fac93d12af$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($eec9e4fac93d12af$var$cachedFilenameDebugIds && debugIdKeys.length === $eec9e4fac93d12af$var$lastKeysCount) return $eec9e4fac93d12af$var$cachedFilenameDebugIds;
    $eec9e4fac93d12af$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $eec9e4fac93d12af$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$eec9e4fac93d12af$var$parsedStackResults) $eec9e4fac93d12af$var$parsedStackResults = {};
        const result = $eec9e4fac93d12af$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame && stackFrame.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $eec9e4fac93d12af$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $eec9e4fac93d12af$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $eec9e4fac93d12af$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $eec9e4fac93d12af$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}




/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 *
 * @deprecated This function is deprecated and will be removed in the next major version.
 */ // TODO(v9): Move this function into normalize() directly
function $58a5b7e16cc782b6$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}




/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $90e1e394273ecc0b$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $90e1e394273ecc0b$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $90e1e394273ecc0b$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $90e1e394273ecc0b$export$a3295358bff77e(object, depth);
    if ($90e1e394273ecc0b$var$jsonSize(normalized) > maxSize) return $90e1e394273ecc0b$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $90e1e394273ecc0b$var$visit(key, value, depth = Infinity, maxProperties = Infinity, // eslint-disable-next-line deprecation/deprecation
memo = (0, $58a5b7e16cc782b6$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $90e1e394273ecc0b$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $90e1e394273ecc0b$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $9d45b9df9881c412$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $90e1e394273ecc0b$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $90e1e394273ecc0b$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $5d145fc2c94d286e$export$7916fad0ebc23f48)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $5d145fc2c94d286e$export$bc2894c7158efbac)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $d668e2a4b0475ef5$export$aad197c7121a6651)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $90e1e394273ecc0b$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $90e1e394273ecc0b$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $90e1e394273ecc0b$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $90e1e394273ecc0b$var$jsonSize(value) {
    return $90e1e394273ecc0b$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $90e1e394273ecc0b$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}






/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $01d0eacec09c488a$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $01d0eacec09c488a$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $01d0eacec09c488a$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $01d0eacec09c488a$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $01d0eacec09c488a$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $01d0eacec09c488a$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $01d0eacec09c488a$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $01d0eacec09c488a$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $01d0eacec09c488a$export$1efec95406bbe327 = 'sentry.profile_id';
const $01d0eacec09c488a$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $01d0eacec09c488a$export$b016f89ac1066ec = 'cache.hit';
const $01d0eacec09c488a$export$3110e4c3f4386399 = 'cache.key';
const $01d0eacec09c488a$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $01d0eacec09c488a$export$be7a251980e7e946 = 'http.request.method';
const $01d0eacec09c488a$export$25dfd73e0e32c6e1 = 'url.full';





/**
 * @deprecated Use a `"baggage"` string directly
 */ const $38bce5d11c2da882$export$9ca9946bd449ac06 = 'baggage';
const $38bce5d11c2da882$export$6e69537d67fa20f = 'sentry-';
const $38bce5d11c2da882$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $38bce5d11c2da882$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $38bce5d11c2da882$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $38bce5d11c2da882$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($38bce5d11c2da882$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($38bce5d11c2da882$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $38bce5d11c2da882$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$38bce5d11c2da882$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $38bce5d11c2da882$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $38bce5d11c2da882$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $5d145fc2c94d286e$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $38bce5d11c2da882$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $38bce5d11c2da882$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $38bce5d11c2da882$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $38bce5d11c2da882$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $38bce5d11c2da882$export$bdd844ddb2def819) {
            (0, $398ec29dacbd7df2$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}




// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $e47ffb9996454191$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    const options = maybeOptions || client && client.getOptions();
    // eslint-disable-next-line deprecation/deprecation
    return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}






/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ const $265629da06370fb9$var$METRICS_SPAN_FIELD = '_sentryMetrics';
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $265629da06370fb9$export$2e7205e45c58797d(span) {
    const storage = span[$265629da06370fb9$var$METRICS_SPAN_FIELD];
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        const arr = output[exportKey] || (output[exportKey] = []);
        arr.push((0, $9d45b9df9881c412$export$d25f2688db1bb433)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on a span.
 */ function $265629da06370fb9$export$102c7b059b14a4a(span, metricType, sanitizedName, value, unit, tags, bucketKey) {
    const existingStorage = span[$265629da06370fb9$var$METRICS_SPAN_FIELD];
    const storage = existingStorage || (span[$265629da06370fb9$var$METRICS_SPAN_FIELD] = new Map());
    const exportKey = `${metricType}:${sanitizedName}@${unit}`;
    const bucketItem = storage.get(bucketKey);
    if (bucketItem) {
        const [, summary] = bucketItem;
        storage.set(bucketKey, [
            exportKey,
            {
                min: Math.min(summary.min, value),
                max: Math.max(summary.max, value),
                count: summary.count += 1,
                sum: summary.sum += value,
                tags: summary.tags
            }
        ]);
    } else storage.set(bucketKey, [
        exportKey,
        {
            min: value,
            max: value,
            count: 1,
            sum: value,
            tags: tags
        }
    ]);
}



const $18260bff12274275$export$136e25984ba4a383 = 0;
const $18260bff12274275$export$58f7963109c806fc = 1;
const $18260bff12274275$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $18260bff12274275$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $18260bff12274275$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $18260bff12274275$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $18260bff12274275$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $18260bff12274275$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $18260bff12274275$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $18260bff12274275$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $18260bff12274275$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $18260bff12274275$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $18260bff12274275$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $18260bff12274275$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $18260bff12274275$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $18260bff12274275$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $18260bff12274275$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $18260bff12274275$export$f966a0446ece71e,
        message: 'unknown_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $18260bff12274275$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $18260bff12274275$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}








// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $9be700175edbb9b7$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $9be700175edbb9b7$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($9be700175edbb9b7$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $9be700175edbb9b7$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $9be700175edbb9b7$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $38bce5d11c2da882$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData || !traceparentData.traceId) return {
        traceId: (0, $3135b6e87c14d175$export$dc6d7ea554bcce10)(),
        spanId: (0, $3135b6e87c14d175$export$295213bc4d0c54ad)()
    };
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    const virtualSpanId = (0, $3135b6e87c14d175$export$295213bc4d0c54ad)();
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        spanId: virtualSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $9be700175edbb9b7$export$f35d907436da45cf(traceId = (0, $3135b6e87c14d175$export$dc6d7ea554bcce10)(), spanId = (0, $3135b6e87c14d175$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}



// These are aligned with OpenTelemetry trace flags
const $e228aefa610f8d34$export$208d5b368507fb8b = 0x0;
const $e228aefa610f8d34$export$eb571cd9b5d98de8 = 0x1;
// todo(v9): Remove this once we've stopped dropping spans via `beforeSendSpan`
let $e228aefa610f8d34$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $e228aefa610f8d34$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin } = $e228aefa610f8d34$export$92d8c23565496537(span);
    return (0, $9d45b9df9881c412$export$d25f2688db1bb433)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin
    });
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $e228aefa610f8d34$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $e228aefa610f8d34$export$92d8c23565496537(span).parent_span_id;
    const span_id = isRemote ? (0, $3135b6e87c14d175$export$295213bc4d0c54ad)() : spanId;
    return (0, $9d45b9df9881c412$export$d25f2688db1bb433)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $e228aefa610f8d34$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $e228aefa610f8d34$export$5caecac1caaf3a71(span);
    return (0, $9be700175edbb9b7$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $e228aefa610f8d34$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $e228aefa610f8d34$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $e228aefa610f8d34$var$ensureTimestampInSeconds(input.getTime());
    return (0, $958146d03402aa5e$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $e228aefa610f8d34$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $e228aefa610f8d34$export$92d8c23565496537(span) {
    if ($e228aefa610f8d34$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    try {
        const { spanId: span_id, traceId: trace_id } = span.spanContext();
        // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
        if ($e228aefa610f8d34$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
            const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status } = span;
            return (0, $9d45b9df9881c412$export$d25f2688db1bb433)({
                span_id: span_id,
                trace_id: trace_id,
                data: attributes,
                description: name,
                parent_span_id: parentSpanId,
                start_timestamp: $e228aefa610f8d34$export$3f7581298f56c6d7(startTime),
                // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
                timestamp: $e228aefa610f8d34$export$3f7581298f56c6d7(endTime) || undefined,
                status: $e228aefa610f8d34$export$e238a77ea3a8cd66(status),
                op: attributes[0, $01d0eacec09c488a$export$1a413bd9a88fdb09],
                origin: attributes[0, $01d0eacec09c488a$export$cca8dd30f57f805e],
                _metrics_summary: (0, $265629da06370fb9$export$2e7205e45c58797d)(span)
            });
        }
        // Finally, at least we have `spanContext()`....
        return {
            span_id: span_id,
            trace_id: trace_id
        };
    } catch (e) {
        return {};
    }
}
function $e228aefa610f8d34$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $e228aefa610f8d34$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $e228aefa610f8d34$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $e228aefa610f8d34$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $e228aefa610f8d34$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $18260bff12274275$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $18260bff12274275$export$58f7963109c806fc)) return 'ok';
    return status.message || 'unknown_error';
}
const $e228aefa610f8d34$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $e228aefa610f8d34$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $e228aefa610f8d34$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$e228aefa610f8d34$var$ROOT_SPAN_FIELD] || span;
    (0, $9d45b9df9881c412$export$e73679ffaf56810e)(childSpan, $e228aefa610f8d34$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$e228aefa610f8d34$var$CHILD_SPANS_FIELD]) span[$e228aefa610f8d34$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $9d45b9df9881c412$export$e73679ffaf56810e)(span, $e228aefa610f8d34$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $e228aefa610f8d34$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$e228aefa610f8d34$var$CHILD_SPANS_FIELD]) span[$e228aefa610f8d34$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $e228aefa610f8d34$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($e228aefa610f8d34$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$e228aefa610f8d34$var$CHILD_SPANS_FIELD] ? Array.from(span[$e228aefa610f8d34$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $e228aefa610f8d34$export$c4c6a79b1260ca1b(span) {
    return span[$e228aefa610f8d34$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $e228aefa610f8d34$export$1be426a8e585c83e() {
    const carrier = (0, $2efcafe7a288277a$export$19eade501500c6c1)();
    const acs = (0, $c744881b70afcb3e$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $ee9e4ca60d4b7ed9$export$91f063ebb8eff307)((0, $a383148e3fcc828a$export$c7be4b0125a10cba)());
}
/**
 * Updates the metric summary on the currently active span
 */ function $e228aefa610f8d34$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = $e228aefa610f8d34$export$1be426a8e585c83e();
    if (span) (0, $265629da06370fb9$export$102c7b059b14a4a)(span, metricType, sanitizedName, value, unit, tags, bucketKey);
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 *
 * todo(v9): Remove this once we've stopped dropping spans via `beforeSendSpan`.
 */ function $e228aefa610f8d34$export$d11691ff45a3e535() {
    if (!$e228aefa610f8d34$var$hasShownSpanDropWarning) {
        (0, $2c5c4ba32bebd8b3$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Deprecation warning: Returning null from `beforeSendSpan` will be disallowed from SDK version 9.0.0 onwards. The callback will only support mutating spans. To drop certain spans, configure the respective integrations directly.');
        });
        $e228aefa610f8d34$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $e228aefa610f8d34$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $01d0eacec09c488a$export$d7a7d984b0791405)]: 'custom',
        [(0, $01d0eacec09c488a$export$165ce9a229f6f050)]: name
    });
}


/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $1dfeb99fdc06c052$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $1dfeb99fdc06c052$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $9d45b9df9881c412$export$e73679ffaf56810e)(spanWithMaybeDsc, $1dfeb99fdc06c052$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $1dfeb99fdc06c052$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = (0, $9d45b9df9881c412$export$d25f2688db1bb433)({
        environment: options.environment || (0, $4d8dcfea76790756$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $1dfeb99fdc06c052$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $1dfeb99fdc06c052$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $1dfeb99fdc06c052$export$a117f995597e25df(span) {
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $e228aefa610f8d34$export$c4c6a79b1260ca1b)(span);
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$1dfeb99fdc06c052$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return frozenDsc;
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceState = rootSpan.spanContext().traceState;
    const traceStateDsc = traceState && traceState.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $38bce5d11c2da882$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return dscOnTraceState;
    // Else, we generate it from the span
    const dsc = $1dfeb99fdc06c052$export$366bad00d6815eed(span.spanContext().traceId, client);
    const jsonSpan = (0, $e228aefa610f8d34$export$92d8c23565496537)(rootSpan);
    const attributes = jsonSpan.data || {};
    const maybeSampleRate = attributes[0, $01d0eacec09c488a$export$ccfe0a40627cc34b];
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = attributes[0, $01d0eacec09c488a$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = jsonSpan.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasTracingEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $e47ffb9996454191$export$5008da00b1b6dee6)()) dsc.sampled = String((0, $e228aefa610f8d34$export$5caecac1caaf3a71)(rootSpan));
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $1dfeb99fdc06c052$export$95cf936fdacaff7b(span) {
    const dsc = $1dfeb99fdc06c052$export$a117f995597e25df(span);
    return (0, $38bce5d11c2da882$export$56766feef403f365)(dsc);
}





/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $ce201004b88de0c4$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $ce201004b88de0c4$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $ce201004b88de0c4$var$applySpanToEvent(event, span);
    $ce201004b88de0c4$var$applyFingerprintToEvent(event, fingerprint);
    $ce201004b88de0c4$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $ce201004b88de0c4$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $ce201004b88de0c4$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $ce201004b88de0c4$export$b1a120a2871faa46(data, 'extra', extra);
    $ce201004b88de0c4$export$b1a120a2871faa46(data, 'tags', tags);
    $ce201004b88de0c4$export$b1a120a2871faa46(data, 'user', user);
    $ce201004b88de0c4$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $2ca8d67afb83b542$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $ce201004b88de0c4$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $2ca8d67afb83b542$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
function $ce201004b88de0c4$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    const cleanedExtra = (0, $9d45b9df9881c412$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $9d45b9df9881c412$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $9d45b9df9881c412$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $9d45b9df9881c412$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $ce201004b88de0c4$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $ce201004b88de0c4$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $ce201004b88de0c4$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $e228aefa610f8d34$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $1dfeb99fdc06c052$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $e228aefa610f8d34$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $e228aefa610f8d34$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $ce201004b88de0c4$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $1708e90023694d2b$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $3340a52637a7f113$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $958146d03402aa5e$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $1708e90023694d2b$export$d7e04067a6fbc882(prepared, options);
    $1708e90023694d2b$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $1708e90023694d2b$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $1708e90023694d2b$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $3340a52637a7f113$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $a383148e3fcc828a$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $ce201004b88de0c4$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $ce201004b88de0c4$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $ce201004b88de0c4$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $0b0ab73e00c1f09e$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $1708e90023694d2b$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $1708e90023694d2b$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $1708e90023694d2b$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $4d8dcfea76790756$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    if (event.message) event.message = (0, $b846d2d7ea7b5879$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $b846d2d7ea7b5879$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $b846d2d7ea7b5879$export$6a506b36fdea397d)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $1708e90023694d2b$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $eec9e4fac93d12af$export$e069fee9c632ed00)(stackParser);
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (filenameDebugIdMap && frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $1708e90023694d2b$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $1708e90023694d2b$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $1708e90023694d2b$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $90e1e394273ecc0b$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $90e1e394273ecc0b$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $90e1e394273ecc0b$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $90e1e394273ecc0b$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $90e1e394273ecc0b$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $90e1e394273ecc0b$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts && event.contexts.flags && normalized.contexts) normalized.contexts.flags = (0, $90e1e394273ecc0b$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $1708e90023694d2b$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $29c58ba512e41a0d$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $1708e90023694d2b$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($1708e90023694d2b$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($1708e90023694d2b$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $1708e90023694d2b$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $29c58ba512e41a0d$export$775b6bb06e53a214) || typeof hint === 'function';
}
const $1708e90023694d2b$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $1708e90023694d2b$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$1708e90023694d2b$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $4af1b4aa86e906d6$export$f5282963edea4a68(exception, hint) {
    return (0, $a383148e3fcc828a$export$c7be4b0125a10cba)().captureException(exception, (0, $1708e90023694d2b$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $4af1b4aa86e906d6$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $a383148e3fcc828a$export$c7be4b0125a10cba)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $4af1b4aa86e906d6$export$1462b974fdcf6ba2(event, hint) {
    return (0, $a383148e3fcc828a$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $4af1b4aa86e906d6$export$2f04de43fe27971a(name, context) {
    (0, $a383148e3fcc828a$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $4af1b4aa86e906d6$export$bb4922da0dd51b92(extras) {
    (0, $a383148e3fcc828a$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $4af1b4aa86e906d6$export$8e8e7789d42ed61d(key, extra) {
    (0, $a383148e3fcc828a$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $4af1b4aa86e906d6$export$74a8fb34822092e6(tags) {
    (0, $a383148e3fcc828a$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $4af1b4aa86e906d6$export$a37d07ee78eb4569(key, value) {
    (0, $a383148e3fcc828a$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $4af1b4aa86e906d6$export$8b6bb3dd62a01be2(user) {
    (0, $a383148e3fcc828a$export$68f3af03034c9e90)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $4af1b4aa86e906d6$export$5d4e9fd7fac8e617() {
    return (0, $a383148e3fcc828a$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $4af1b4aa86e906d6$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $a383148e3fcc828a$export$c7be4b0125a10cba)();
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    if (!client) (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $3340a52637a7f113$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $4af1b4aa86e906d6$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $4af1b4aa86e906d6$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $958146d03402aa5e$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $4af1b4aa86e906d6$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $958146d03402aa5e$export$ee52dced521e3e18)() - now
        });
    }
    return (0, $a383148e3fcc828a$export$9a4fed82c350c2bd)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $5d145fc2c94d286e$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn('ok');
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        else finishCheckIn('ok');
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $4af1b4aa86e906d6$export$4909b86c8034bf73(timeout) {
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $4af1b4aa86e906d6$export$8360e631d277ea4d(timeout) {
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $4af1b4aa86e906d6$export$3f95c6f800b78024() {
    return !!(0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $4af1b4aa86e906d6$export$3b029eb57ac4d562() {
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    return !!client && client.getOptions().enabled !== false && !!client.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $4af1b4aa86e906d6$export$9aac0b9f77928fbf(callback) {
    (0, $a383148e3fcc828a$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $4af1b4aa86e906d6$export$c0d84948cecf78d8(context) {
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $a383148e3fcc828a$export$68f3af03034c9e90)();
    const currentScope = (0, $a383148e3fcc828a$export$c7be4b0125a10cba)();
    const { release: release, environment: environment = (0, $4d8dcfea76790756$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $72eac955b1607be8$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $72eac955b1607be8$export$531818e825e774db)(currentSession, {
        status: 'exited'
    });
    $4af1b4aa86e906d6$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $4af1b4aa86e906d6$export$17a5be43989a0bc1() {
    const isolationScope = (0, $a383148e3fcc828a$export$68f3af03034c9e90)();
    const currentScope = (0, $a383148e3fcc828a$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $72eac955b1607be8$export$56521d9ba90f62ee)(session);
    $4af1b4aa86e906d6$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $4af1b4aa86e906d6$var$_sendSessionUpdate() {
    const isolationScope = (0, $a383148e3fcc828a$export$68f3af03034c9e90)();
    const currentScope = (0, $a383148e3fcc828a$export$c7be4b0125a10cba)();
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $4af1b4aa86e906d6$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $4af1b4aa86e906d6$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $4af1b4aa86e906d6$var$_sendSessionUpdate();
}




const $e2ea69fdb18f915a$var$WINDOW = (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $e2ea69fdb18f915a$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $e2ea69fdb18f915a$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $e2ea69fdb18f915a$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $e2ea69fdb18f915a$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $e2ea69fdb18f915a$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $e2ea69fdb18f915a$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $e2ea69fdb18f915a$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$e2ea69fdb18f915a$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($e2ea69fdb18f915a$export$d5f608b368e73f38($e2ea69fdb18f915a$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $e2ea69fdb18f915a$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $e2ea69fdb18f915a$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $398ec29dacbd7df2$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $e2ea69fdb18f915a$export$531055a6c684a70a() {
    return 'ReportingObserver' in $e2ea69fdb18f915a$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $e2ea69fdb18f915a$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$e2ea69fdb18f915a$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}



/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $5c75d591cd944930$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $4c4488a883ef31f7$export$31499a9cd224b78c)
            })),
        version: (0, $4c4488a883ef31f7$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}










/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $1420d5a25389549d$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $1420d5a25389549d$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $1420d5a25389549d$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $1420d5a25389549d$export$604a45d95a155e2b(envelope, types) {
    return $1420d5a25389549d$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $1420d5a25389549d$var$encodeUTF8(input) {
    return (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1).__SENTRY__ && (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1).__SENTRY__.encodePolyfill ? (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1).__SENTRY__.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $1420d5a25389549d$var$decodeUTF8(input) {
    return (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1).__SENTRY__ && (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1).__SENTRY__.decodePolyfill ? (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1).__SENTRY__.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $1420d5a25389549d$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $1420d5a25389549d$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $1420d5a25389549d$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $90e1e394273ecc0b$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $1420d5a25389549d$var$concatBuffers(parts);
}
function $1420d5a25389549d$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $1420d5a25389549d$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $1420d5a25389549d$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($1420d5a25389549d$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $1420d5a25389549d$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $1420d5a25389549d$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $1420d5a25389549d$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        (0, $9d45b9df9881c412$export$d25f2688db1bb433)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $1420d5a25389549d$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    statsd: 'metric_bucket',
    raw_security: 'security'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $1420d5a25389549d$export$b11169581eeaf237(type) {
    return $1420d5a25389549d$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $1420d5a25389549d$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $1420d5a25389549d$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $86d9ae5b2fb1b398$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $9d45b9df9881c412$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $b5349cc77e272d5a$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $b5349cc77e272d5a$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $1420d5a25389549d$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $86d9ae5b2fb1b398$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $1420d5a25389549d$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $b5349cc77e272d5a$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $1420d5a25389549d$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $b5349cc77e272d5a$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $1420d5a25389549d$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $1420d5a25389549d$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $b5349cc77e272d5a$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $1dfeb99fdc06c052$export$a117f995597e25df)(spans[0]);
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $86d9ae5b2fb1b398$export$44d472fbb931a776)(dsn)
        }
    };
    const beforeSendSpan = client && client.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = beforeSendSpan((0, $e228aefa610f8d34$export$92d8c23565496537)(span));
        if (!spanJson) (0, $e228aefa610f8d34$export$d11691ff45a3e535)();
        return spanJson;
    } : (span)=>(0, $e228aefa610f8d34$export$92d8c23565496537)(span);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $1420d5a25389549d$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $1420d5a25389549d$export$f93f7f385160c44e)(headers, items);
}







/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $30420f7833b76bb2$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $958146d03402aa5e$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $1420d5a25389549d$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}




/** An error emitted by Sentry SDKs and related utilities. */ class $17fa27a1b7630bbb$export$5949942ba2a7c0e2 extends Error {
    constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.logLevel = logLevel;
    }
}








/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $783dda70189181e4$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) {
        (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return undefined;
    }
    return rate;
}




const $d99066aee5064637$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $d99066aee5064637$export$4f22f74eddb7716a {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $86d9ae5b2fb1b398$export$128827c3562ec0cb)(options.dsn);
        else (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $bcd1105623a7bc13$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        // TODO(v9): Remove this deprecation warning
        const tracingOptions = [
            'enableTracing',
            'tracesSampleRate',
            'tracesSampler'
        ];
        const undefinedOption = tracingOptions.find((option)=>option in options && options[option] == undefined);
        if (undefinedOption) (0, $2c5c4ba32bebd8b3$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn(`[Sentry] Deprecation warning: \`${undefinedOption}\` is set to undefined, which leads to tracing being enabled. In v9, a value of \`undefined\` will result in tracing being disabled.`);
        });
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint, scope) {
        const eventId = (0, $3340a52637a7f113$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((0, $3340a52637a7f113$export$6de4ffac6a2f1098)(exception)) {
            (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log($d99066aee5064637$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $3340a52637a7f113$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $5d145fc2c94d286e$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $5d145fc2c94d286e$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $3340a52637a7f113$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $3340a52637a7f113$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log($d99066aee5064637$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === 'string')) (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn('Discarded session because of missing or non-string release');
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $72eac955b1607be8$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit('flush');
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $c133b3629f3b6130$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit('close');
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $2135a815867df812$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $2135a815867df812$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $b5349cc77e272d5a$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $1420d5a25389549d$export$d650323442802f6f)(env, (0, $1420d5a25389549d$export$d8fc80952cc31fa4)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $b5349cc77e272d5a$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === 'number' ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * @inheritdoc
   */ sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).error('Error while sending envelope:', reason);
            return reason;
        });
        (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).error('Transport disabled');
        return (0, $c133b3629f3b6130$export$1fda8aa4d135f8aa)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $2135a815867df812$export$51abed9797baa598)(this, integrations);
        (0, $2135a815867df812$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $72eac955b1607be8$export$531818e825e774db)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $c133b3629f3b6130$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope = (0, $a383148e3fcc828a$export$c7be4b0125a10cba)(), isolationScope = (0, $a383148e3fcc828a$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $1708e90023694d2b$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            evt.contexts = {
                trace: (0, $a383148e3fcc828a$export$1e83db7ee4876dc4)(currentScope),
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $1dfeb99fdc06c052$export$89ef1736f08c6b2b)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $1f46b14b25973594$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                if (reason instanceof (0, $17fa27a1b7630bbb$export$5949942ba2a7c0e2) && reason.logLevel === 'log') (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log(reason.message);
                else (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $d99066aee5064637$var$isTransactionEvent(event);
        const isError = $d99066aee5064637$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $783dda70189181e4$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error', event);
            return (0, $c133b3629f3b6130$export$78e43115b553f358)(new (0, $17fa27a1b7630bbb$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, currentScope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory, event);
                throw new (0, $17fa27a1b7630bbb$export$5949942ba2a7c0e2)('An event processor returned `null`, will not send event.', 'log');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $d99066aee5064637$var$processBeforeSend(this, options, prepared, hint);
            return $d99066aee5064637$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw new (0, $17fa27a1b7630bbb$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
            }
            const session = currentScope && currentScope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $17fa27a1b7630bbb$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $17fa27a1b7630bbb$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log('Sending outcomes:', outcomes);
        const envelope = (0, $30420f7833b76bb2$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $86d9ae5b2fb1b398$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $d99066aee5064637$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $5d145fc2c94d286e$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $5d145fc2c94d286e$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $17fa27a1b7630bbb$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $17fa27a1b7630bbb$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $5d145fc2c94d286e$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $17fa27a1b7630bbb$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $d99066aee5064637$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    if ($d99066aee5064637$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($d99066aee5064637$var$isTransactionEvent(event)) {
        if (event.spans && beforeSendSpan) {
            const processedSpans = [];
            for (const span of event.spans){
                const processedSpan = beforeSendSpan(span);
                if (processedSpan) processedSpans.push(processedSpan);
                else {
                    (0, $e228aefa610f8d34$export$d11691ff45a3e535)();
                    client.recordDroppedEvent('before_send', 'span');
                }
            }
            event.spans = processedSpans;
        }
        if (beforeSendTransaction) {
            if (event.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = event.spans.length;
                event.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(event, hint);
        }
    }
    return event;
}
function $d99066aee5064637$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $d99066aee5064637$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}


var $cjt0R = parcelRequire("cjt0R");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $aea8a197a12f0967$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/**
 * This function creates an exception from a JavaScript Error
 */ function $3ae121be400e36eb$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $3ae121be400e36eb$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $3ae121be400e36eb$export$2e9ae379995d99e3(ex),
        value: $3ae121be400e36eb$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $3ae121be400e36eb$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $3ae121be400e36eb$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $90e1e394273ecc0b$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $3ae121be400e36eb$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $5d145fc2c94d286e$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $3ae121be400e36eb$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $3ae121be400e36eb$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $3ae121be400e36eb$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $3ae121be400e36eb$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $3ae121be400e36eb$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $3ae121be400e36eb$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $3ae121be400e36eb$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $3ae121be400e36eb$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $3ae121be400e36eb$var$getSkipFirstStackStringLines(ex) {
    if (ex && $3ae121be400e36eb$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $3ae121be400e36eb$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $3ae121be400e36eb$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $3ae121be400e36eb$export$2e9ae379995d99e3(ex) {
    const name = ex && ex.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $3ae121be400e36eb$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $3ae121be400e36eb$export$86005d1b62804363(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
    if ($3ae121be400e36eb$var$isWebAssemblyException(ex) && Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $3ae121be400e36eb$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $3ae121be400e36eb$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $3340a52637a7f113$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $c133b3629f3b6130$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $3ae121be400e36eb$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $3ae121be400e36eb$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $c133b3629f3b6130$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $3ae121be400e36eb$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $5d145fc2c94d286e$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $3ae121be400e36eb$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $5d145fc2c94d286e$export$ef9e2056653f0c8e)(exception) || (0, $5d145fc2c94d286e$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $3ae121be400e36eb$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $5d145fc2c94d286e$export$ef9e2056653f0c8e)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $3ae121be400e36eb$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $3340a52637a7f113$export$f26508487bf83ee7)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $5d145fc2c94d286e$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $3ae121be400e36eb$var$eventFromError(stackParser, exception);
    if ((0, $5d145fc2c94d286e$export$53b83ca8eaab0383)(exception) || (0, $5d145fc2c94d286e$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $3ae121be400e36eb$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $3340a52637a7f113$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $3ae121be400e36eb$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $3340a52637a7f113$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $3340a52637a7f113$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $3ae121be400e36eb$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $3ae121be400e36eb$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $3340a52637a7f113$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
    }
    if ((0, $5d145fc2c94d286e$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $3ae121be400e36eb$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $9d45b9df9881c412$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $5d145fc2c94d286e$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $5d145fc2c94d286e$export$9671ea99bd126ace)(exception)) {
        const className = $3ae121be400e36eb$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $3ae121be400e36eb$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $3ae121be400e36eb$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}



const $df1f7a182305cd2c$export$56d8a8a25bd48b81 = (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1);
let $df1f7a182305cd2c$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $df1f7a182305cd2c$export$b79738ab10c590b2() {
    return $df1f7a182305cd2c$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $df1f7a182305cd2c$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $df1f7a182305cd2c$var$ignoreOnError++;
    setTimeout(()=>{
        $df1f7a182305cd2c$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $df1f7a182305cd2c$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $9d45b9df9881c412$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$df1f7a182305cd2c$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $df1f7a182305cd2c$export$1265a142ff5ba165();
            (0, $a383148e3fcc828a$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $3340a52637a7f113$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $3340a52637a7f113$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $4af1b4aa86e906d6$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (e2) {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $9d45b9df9881c412$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $9d45b9df9881c412$export$e73679ffaf56810e)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch (e3) {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}



/**
 * Creates an envelope from a user feedback.
 */ function $0c8d6c2ad654ca7e$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $86d9ae5b2fb1b398$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $0c8d6c2ad654ca7e$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $1420d5a25389549d$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $0c8d6c2ad654ca7e$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/core Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $d948ee557d0ac687$export$1df9218a526d318d extends (0, $d99066aee5064637$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = {
            // We default this to true, as it is the safer scenario
            parentSpanIsAlwaysRootSpan: true,
            ...options
        };
        const sdkSource = (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $cjt0R.getSDKSource)();
        (0, $5c75d591cd944930$export$b9f95b027256052c)(opts, 'browser', [
            'browser'
        ], sdkSource);
        super(opts);
        if (opts.sendClientReports && (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).document) (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $3ae121be400e36eb$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $3ae121be400e36eb$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   *
   * @deprecated Use `captureFeedback` instead.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $aea8a197a12f0967$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $0c8d6c2ad654ca7e$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
}







// We keep the handlers globally
const $9feabaa2f4bd5016$var$handlers = {};
const $9feabaa2f4bd5016$var$instrumented = {};
/** Add a handler function. */ function $9feabaa2f4bd5016$export$a4e09611e30da72e(type, handler) {
    $9feabaa2f4bd5016$var$handlers[type] = $9feabaa2f4bd5016$var$handlers[type] || [];
    $9feabaa2f4bd5016$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $9feabaa2f4bd5016$export$b17eab759a1cb5fe() {
    Object.keys($9feabaa2f4bd5016$var$handlers).forEach((key)=>{
        $9feabaa2f4bd5016$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $9feabaa2f4bd5016$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$9feabaa2f4bd5016$var$instrumented[type]) {
        $9feabaa2f4bd5016$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $398ec29dacbd7df2$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $9feabaa2f4bd5016$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $9feabaa2f4bd5016$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $398ec29dacbd7df2$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $d668e2a4b0475ef5$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}



const $085c565c0b56f1a9$export$56d8a8a25bd48b81 = (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1);


const $cd9614bbd73b83f8$var$DEBOUNCE_DURATION = 1000;
let $cd9614bbd73b83f8$var$debounceTimerID;
let $cd9614bbd73b83f8$var$lastCapturedEventType;
let $cd9614bbd73b83f8$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $cd9614bbd73b83f8$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $9feabaa2f4bd5016$export$a4e09611e30da72e)(type, handler);
    (0, $9feabaa2f4bd5016$export$e18d6c5462c01368)(type, $cd9614bbd73b83f8$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $cd9614bbd73b83f8$export$3014bbf0af0e1d4a() {
    if (!(0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $9feabaa2f4bd5016$export$b18c893e424d3127).bind(null, 'dom');
    const globalDOMEventHandler = $cd9614bbd73b83f8$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        const globalObject = (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81);
        const targetObj = globalObject[target];
        const proto = targetObj && targetObj.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $9d45b9df9881c412$export$9563e054e6f787fb)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $cd9614bbd73b83f8$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $9d45b9df9881c412$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $cd9614bbd73b83f8$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $cd9614bbd73b83f8$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $cd9614bbd73b83f8$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $cd9614bbd73b83f8$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $cd9614bbd73b83f8$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $cd9614bbd73b83f8$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($cd9614bbd73b83f8$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $9d45b9df9881c412$export$e73679ffaf56810e)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $9d45b9df9881c412$export$e73679ffaf56810e)(target, '_sentryId', (0, $3340a52637a7f113$export$19f53698e68b2496)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$cd9614bbd73b83f8$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $cd9614bbd73b83f8$var$lastCapturedEventType = event.type;
            $cd9614bbd73b83f8$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($cd9614bbd73b83f8$var$debounceTimerID);
        $cd9614bbd73b83f8$var$debounceTimerID = (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).setTimeout(()=>{
            $cd9614bbd73b83f8$var$lastCapturedEventTargetId = undefined;
            $cd9614bbd73b83f8$var$lastCapturedEventType = undefined;
        }, $cd9614bbd73b83f8$var$DEBOUNCE_DURATION);
    };
}
function $cd9614bbd73b83f8$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}


// Based on https://github.com/angular/angular.js/pull/13945/files
// The MIT License
const $f884cc827c4c39b4$var$WINDOW = (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $f884cc827c4c39b4$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    // TODO(v9): Remove this custom check, it is pretty old and likely not needed anymore
    const chromeVar = $f884cc827c4c39b4$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    const hasHistoryApi = 'history' in $f884cc827c4c39b4$var$WINDOW && !!$f884cc827c4c39b4$var$WINDOW.history.pushState && !!$f884cc827c4c39b4$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



let $66c7820cfb83137d$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $66c7820cfb83137d$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $9feabaa2f4bd5016$export$a4e09611e30da72e)(type, handler);
    (0, $9feabaa2f4bd5016$export$e18d6c5462c01368)(type, $66c7820cfb83137d$var$instrumentHistory);
}
function $66c7820cfb83137d$var$instrumentHistory() {
    if (!(0, $f884cc827c4c39b4$export$67fc34576016d6ec)()) return;
    const oldOnPopState = (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).onpopstate;
    (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).onpopstate = function(...args) {
        const to = (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $66c7820cfb83137d$var$lastHref;
        $66c7820cfb83137d$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $9feabaa2f4bd5016$export$b18c893e424d3127)('history', handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $66c7820cfb83137d$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $66c7820cfb83137d$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $9feabaa2f4bd5016$export$b18c893e424d3127)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $9d45b9df9881c412$export$9563e054e6f787fb)((0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).history, 'pushState', historyReplacementFunction);
    (0, $9d45b9df9881c412$export$9563e054e6f787fb)((0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).history, 'replaceState', historyReplacementFunction);
}



const $3bd585063dd5b110$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $3bd585063dd5b110$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $9feabaa2f4bd5016$export$a4e09611e30da72e)(type, handler);
    (0, $9feabaa2f4bd5016$export$e18d6c5462c01368)(type, $3bd585063dd5b110$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $3bd585063dd5b110$export$c67d533bf77cbf54() {
    if (!(0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $958146d03402aa5e$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $5d145fc2c94d286e$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $3bd585063dd5b110$var$parseUrl(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$3bd585063dd5b110$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$3bd585063dd5b110$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $958146d03402aa5e$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $9feabaa2f4bd5016$export$b18c893e424d3127)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$3bd585063dd5b110$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $5d145fc2c94d286e$export$844ec244b1367d54)(header) && (0, $5d145fc2c94d286e$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$3bd585063dd5b110$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $958146d03402aa5e$export$ee52dced521e3e18)() * 1000,
                xhr: sendThisArg
            };
            (0, $9feabaa2f4bd5016$export$b18c893e424d3127)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $3bd585063dd5b110$var$parseUrl(url) {
    if ((0, $5d145fc2c94d286e$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}





/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $39b2704e5c5568a5$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $39b2704e5c5568a5$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $a383148e3fcc828a$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $39b2704e5c5568a5$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $958146d03402aa5e$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $2c5c4ba32bebd8b3$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $afb77ab1bc09358d$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $9feabaa2f4bd5016$export$a4e09611e30da72e)(type, handler);
    (0, $9feabaa2f4bd5016$export$e18d6c5462c01368)(type, $afb77ab1bc09358d$var$instrumentConsole);
}
function $afb77ab1bc09358d$var$instrumentConsole() {
    if (!('console' in (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1))) return;
    (0, $2c5c4ba32bebd8b3$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1).console)) return;
        (0, $9d45b9df9881c412$export$9563e054e6f787fb)((0, $af8853bd97d114cc$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $2c5c4ba32bebd8b3$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $9feabaa2f4bd5016$export$b18c893e424d3127)('console', handlerData);
                const log = (0, $2c5c4ba32bebd8b3$export$77c4ce905194557b)[level];
                log && log.apply((0, $af8853bd97d114cc$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}







/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $58ddee4fc1fd3ed5$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $9feabaa2f4bd5016$export$a4e09611e30da72e)(type, handler);
    (0, $9feabaa2f4bd5016$export$e18d6c5462c01368)(type, ()=>$58ddee4fc1fd3ed5$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $58ddee4fc1fd3ed5$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $9feabaa2f4bd5016$export$a4e09611e30da72e)(type, handler);
    (0, $9feabaa2f4bd5016$export$e18d6c5462c01368)(type, ()=>$58ddee4fc1fd3ed5$var$instrumentFetch($58ddee4fc1fd3ed5$var$streamHandler));
}
function $58ddee4fc1fd3ed5$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $e2ea69fdb18f915a$export$c82d238e23c40b21)()) return;
    (0, $9d45b9df9881c412$export$9563e054e6f787fb)((0, $af8853bd97d114cc$export$f1a6cdb1459e81d1), 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $58ddee4fc1fd3ed5$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $958146d03402aa5e$export$ee52dced521e3e18)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $9feabaa2f4bd5016$export$b18c893e424d3127)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $af8853bd97d114cc$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $9feabaa2f4bd5016$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $958146d03402aa5e$export$ee52dced521e3e18)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $9feabaa2f4bd5016$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $958146d03402aa5e$export$ee52dced521e3e18)() * 1000,
                    error: error
                });
                if ((0, $5d145fc2c94d286e$export$e6127cc7fe7395c3)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $9d45b9df9881c412$export$e73679ffaf56810e)(error, 'framesToPop', 1);
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $58ddee4fc1fd3ed5$var$resolveResponse(res, onFinishedResolving) {
    if (res && res.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $58ddee4fc1fd3ed5$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch (e) {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $58ddee4fc1fd3ed5$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $9feabaa2f4bd5016$export$b18c893e424d3127)('fetch-body-resolved', {
            endTimestamp: (0, $958146d03402aa5e$export$ee52dced521e3e18)() * 1000,
            response: response
        });
    });
}
function $58ddee4fc1fd3ed5$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $58ddee4fc1fd3ed5$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($58ddee4fc1fd3ed5$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $58ddee4fc1fd3ed5$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $58ddee4fc1fd3ed5$var$getUrlFromResource(url),
            method: $58ddee4fc1fd3ed5$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $58ddee4fc1fd3ed5$var$getUrlFromResource(arg),
        method: $58ddee4fc1fd3ed5$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}

/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $3eb85910cfdbc4c4$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}

/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $4584eb8e6be08f57$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $4584eb8e6be08f57$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 *
 * @deprecated This function will be removed in the next major version.
 */ // TODO(v9): Hoist this function into the places where we use it. (as it stands only react router v6 instrumentation)
function $4584eb8e6be08f57$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $4584eb8e6be08f57$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

/**
 * @deprecated This variable has been deprecated and will be removed in the next major version.
 */ const $6c101982fbcae8ee$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $6c101982fbcae8ee$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $90aee76cd1400c4e$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $90aee76cd1400c4e$var$INTEGRATION_NAME = 'Breadcrumbs';
const $90aee76cd1400c4e$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $90aee76cd1400c4e$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $afb77ab1bc09358d$export$1d6e0d073f9e6723)($90aee76cd1400c4e$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $cd9614bbd73b83f8$export$5aeffd3db2cf9df7)($90aee76cd1400c4e$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $3bd585063dd5b110$export$26ace48dd54c9aea)($90aee76cd1400c4e$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $58ddee4fc1fd3ed5$export$f75d3c772c923df0)($90aee76cd1400c4e$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $66c7820cfb83137d$export$3f18c56c58114e75)($90aee76cd1400c4e$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $90aee76cd1400c4e$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $90aee76cd1400c4e$export$c079d904b326663a = (0, $2135a815867df812$export$2323046b9414659f)($90aee76cd1400c4e$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $90aee76cd1400c4e$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $a383148e3fcc828a$export$6bb76d6eba7e258c)() !== client) return;
        (0, $39b2704e5c5568a5$export$efda9a273d7a036d)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $3340a52637a7f113$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $90aee76cd1400c4e$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $a383148e3fcc828a$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $90aee76cd1400c4e$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $aea8a197a12f0967$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$90aee76cd1400c4e$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$90aee76cd1400c4e$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $90aee76cd1400c4e$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $90aee76cd1400c4e$var$_isEvent(event) ? event.target : event;
            target = (0, $efa6e113a375d8ac$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $efa6e113a375d8ac$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $39b2704e5c5568a5$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $90aee76cd1400c4e$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $a383148e3fcc828a$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $6c101982fbcae8ee$export$d771ef054122c30a)(handlerData.level),
            message: (0, $b846d2d7ea7b5879$export$465e9d514283d4fd)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $b846d2d7ea7b5879$export$465e9d514283d4fd)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $39b2704e5c5568a5$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $90aee76cd1400c4e$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $a383148e3fcc828a$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $3bd585063dd5b110$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const level = (0, $3eb85910cfdbc4c4$export$b8cfcc4175694bcc)(status_code);
        (0, $39b2704e5c5568a5$export$efda9a273d7a036d)({
            category: 'xhr',
            data: data,
            type: 'http',
            level: level
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $90aee76cd1400c4e$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $a383148e3fcc828a$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $39b2704e5c5568a5$export$efda9a273d7a036d)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const level = (0, $3eb85910cfdbc4c4$export$b8cfcc4175694bcc)(data.status_code);
            (0, $39b2704e5c5568a5$export$efda9a273d7a036d)({
                category: 'fetch',
                data: data,
                type: 'http',
                level: level
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $90aee76cd1400c4e$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $a383148e3fcc828a$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $4584eb8e6be08f57$export$7a5253c0f62e0150)((0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $4584eb8e6be08f57$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $4584eb8e6be08f57$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $39b2704e5c5568a5$export$efda9a273d7a036d)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $90aee76cd1400c4e$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $5c2a3ef08526d650$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $5c2a3ef08526d650$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $5c2a3ef08526d650$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $5c2a3ef08526d650$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $9d45b9df9881c412$export$9563e054e6f787fb)((0, $df1f7a182305cd2c$export$56d8a8a25bd48b81), 'setTimeout', $5c2a3ef08526d650$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $9d45b9df9881c412$export$9563e054e6f787fb)((0, $df1f7a182305cd2c$export$56d8a8a25bd48b81), 'setInterval', $5c2a3ef08526d650$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $9d45b9df9881c412$export$9563e054e6f787fb)((0, $df1f7a182305cd2c$export$56d8a8a25bd48b81), 'requestAnimationFrame', $5c2a3ef08526d650$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81)) (0, $9d45b9df9881c412$export$9563e054e6f787fb)(XMLHttpRequest.prototype, 'send', $5c2a3ef08526d650$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $5c2a3ef08526d650$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($5c2a3ef08526d650$var$_wrapEventTarget);
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $5c2a3ef08526d650$export$59bfe9f1c76150e = (0, $2135a815867df812$export$2323046b9414659f)($5c2a3ef08526d650$var$_browserApiErrorsIntegration);
function $5c2a3ef08526d650$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $df1f7a182305cd2c$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $d668e2a4b0475ef5$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
function $5c2a3ef08526d650$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $df1f7a182305cd2c$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $d668e2a4b0475ef5$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $5c2a3ef08526d650$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $9d45b9df9881c412$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $d668e2a4b0475ef5$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $9d45b9df9881c412$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $d668e2a4b0475ef5$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $df1f7a182305cd2c$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $5c2a3ef08526d650$var$_wrapEventTarget(target) {
    const globalObject = (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81);
    const targetObj = globalObject[target];
    const proto = targetObj && targetObj.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $9d45b9df9881c412$export$9563e054e6f787fb)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($5c2a3ef08526d650$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $df1f7a182305cd2c$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $d668e2a4b0475ef5$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (e2) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                (0, $df1f7a182305cd2c$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $d668e2a4b0475ef5$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $9d45b9df9881c412$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $5c2a3ef08526d650$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}






/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $5405b8912357f47d$export$1baa7880e357371c = (0, $2135a815867df812$export$2323046b9414659f)(()=>{
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).document === 'undefined') {
                (0, $aea8a197a12f0967$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $4af1b4aa86e906d6$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $4af1b4aa86e906d6$export$667e7b4d445d566b)();
            // We want to create a session for every navigation as well
            (0, $66c7820cfb83137d$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $4af1b4aa86e906d6$export$c0d84948cecf78d8)({
                        ignoreDuration: true
                    });
                    (0, $4af1b4aa86e906d6$export$667e7b4d445d566b)();
                }
            });
        }
    };
});




let $8f992e0826d111dd$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $8f992e0826d111dd$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $9feabaa2f4bd5016$export$a4e09611e30da72e)(type, handler);
    (0, $9feabaa2f4bd5016$export$e18d6c5462c01368)(type, $8f992e0826d111dd$var$instrumentError);
}
function $8f992e0826d111dd$var$instrumentError() {
    $8f992e0826d111dd$var$_oldOnErrorHandler = (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $9feabaa2f4bd5016$export$b18c893e424d3127)('error', handlerData);
        if ($8f992e0826d111dd$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $8f992e0826d111dd$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $545c8ea05bc34624$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $545c8ea05bc34624$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $9feabaa2f4bd5016$export$a4e09611e30da72e)(type, handler);
    (0, $9feabaa2f4bd5016$export$e18d6c5462c01368)(type, $545c8ea05bc34624$var$instrumentUnhandledRejection);
}
function $545c8ea05bc34624$var$instrumentUnhandledRejection() {
    $545c8ea05bc34624$var$_oldOnUnhandledRejectionHandler = (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $9feabaa2f4bd5016$export$b18c893e424d3127)('unhandledrejection', handlerData);
        if ($545c8ea05bc34624$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $545c8ea05bc34624$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





const $9bcac279f53ffd52$var$INTEGRATION_NAME = 'GlobalHandlers';
const $9bcac279f53ffd52$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $9bcac279f53ffd52$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $9bcac279f53ffd52$var$_installGlobalOnErrorHandler(client);
                $9bcac279f53ffd52$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $9bcac279f53ffd52$var$_installGlobalOnUnhandledRejectionHandler(client);
                $9bcac279f53ffd52$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $9bcac279f53ffd52$export$66acc70e8cf2b71a = (0, $2135a815867df812$export$2323046b9414659f)($9bcac279f53ffd52$var$_globalHandlersIntegration);
function $9bcac279f53ffd52$var$_installGlobalOnErrorHandler(client) {
    (0, $8f992e0826d111dd$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $9bcac279f53ffd52$var$getOptions();
        if ((0, $a383148e3fcc828a$export$6bb76d6eba7e258c)() !== client || (0, $df1f7a182305cd2c$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $9bcac279f53ffd52$var$_enhanceEventWithInitialFrame((0, $3ae121be400e36eb$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $4af1b4aa86e906d6$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $9bcac279f53ffd52$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $545c8ea05bc34624$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $9bcac279f53ffd52$var$getOptions();
        if ((0, $a383148e3fcc828a$export$6bb76d6eba7e258c)() !== client || (0, $df1f7a182305cd2c$export$b79738ab10c590b2)()) return;
        const error = $9bcac279f53ffd52$var$_getUnhandledRejectionError(e);
        const event = (0, $5d145fc2c94d286e$export$c3825b437cbdea5c)(error) ? $9bcac279f53ffd52$var$_eventFromRejectionWithPrimitive(error) : (0, $3ae121be400e36eb$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $4af1b4aa86e906d6$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $9bcac279f53ffd52$var$_getUnhandledRejectionError(error) {
    if ((0, $5d145fc2c94d286e$export$c3825b437cbdea5c)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $9bcac279f53ffd52$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $9bcac279f53ffd52$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = (0, $5d145fc2c94d286e$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $efa6e113a375d8ac$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $d668e2a4b0475ef5$export$27c7e15d453fc0ac),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $9bcac279f53ffd52$var$globalHandlerLog(type) {
    (0, $aea8a197a12f0967$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $9bcac279f53ffd52$var$getOptions() {
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $c891f2b5d0b4d526$export$1378794447170364 = (0, $2135a815867df812$export$2323046b9414659f)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).navigator && !(0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).location && !(0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).location && (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
});




/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $38cf13c3c0bfff8e$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $5d145fc2c94d286e$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $38cf13c3c0bfff8e$var$truncateAggregateExceptions($38cf13c3c0bfff8e$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $38cf13c3c0bfff8e$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $5d145fc2c94d286e$export$49034edbe6b62415)(error[key], Error)) {
        $38cf13c3c0bfff8e$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $38cf13c3c0bfff8e$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $38cf13c3c0bfff8e$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $5d145fc2c94d286e$export$49034edbe6b62415)(childError, Error)) {
            $38cf13c3c0bfff8e$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $38cf13c3c0bfff8e$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $38cf13c3c0bfff8e$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $38cf13c3c0bfff8e$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $38cf13c3c0bfff8e$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $38cf13c3c0bfff8e$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $b846d2d7ea7b5879$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $a598fccd205f1408$var$DEFAULT_KEY = 'cause';
const $a598fccd205f1408$var$DEFAULT_LIMIT = 5;
const $a598fccd205f1408$var$INTEGRATION_NAME = 'LinkedErrors';
const $a598fccd205f1408$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $a598fccd205f1408$var$DEFAULT_LIMIT;
    const key = options.key || $a598fccd205f1408$var$DEFAULT_KEY;
    return {
        name: $a598fccd205f1408$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $38cf13c3c0bfff8e$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $3ae121be400e36eb$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $a598fccd205f1408$export$ebabb00eb7f3a395 = (0, $2135a815867df812$export$2323046b9414659f)($a598fccd205f1408$var$_linkedErrorsIntegration);



// This was originally forked from https://github.com/csnover/TraceKit, and was largely
// re - written as part of raven - js.
//
// This code was later copied to the JavaScript mono - repo and further modified and
// refactored over the years.
const $eb8f39a71acf0a4f$var$OPERA10_PRIORITY = 10;
const $eb8f39a71acf0a4f$var$OPERA11_PRIORITY = 20;
const $eb8f39a71acf0a4f$var$CHROME_PRIORITY = 30;
const $eb8f39a71acf0a4f$var$WINJS_PRIORITY = 40;
const $eb8f39a71acf0a4f$var$GECKO_PRIORITY = 50;
function $eb8f39a71acf0a4f$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $d668e2a4b0475ef5$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $eb8f39a71acf0a4f$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $eb8f39a71acf0a4f$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $eb8f39a71acf0a4f$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $eb8f39a71acf0a4f$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $eb8f39a71acf0a4f$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $eb8f39a71acf0a4f$var$createFrame(filename, (0, $d668e2a4b0475ef5$export$27c7e15d453fc0ac), +line, +col);
    }
    const parts = $eb8f39a71acf0a4f$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $eb8f39a71acf0a4f$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $eb8f39a71acf0a4f$var$extractSafariExtensionDetails(parts[1] || (0, $d668e2a4b0475ef5$export$27c7e15d453fc0ac), parts[2]);
        return $eb8f39a71acf0a4f$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $eb8f39a71acf0a4f$export$263a749fff749872 = [
    $eb8f39a71acf0a4f$var$CHROME_PRIORITY,
    $eb8f39a71acf0a4f$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $eb8f39a71acf0a4f$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $eb8f39a71acf0a4f$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $eb8f39a71acf0a4f$var$gecko = (line)=>{
    const parts = $eb8f39a71acf0a4f$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $eb8f39a71acf0a4f$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $d668e2a4b0475ef5$export$27c7e15d453fc0ac);
        [func, filename] = $eb8f39a71acf0a4f$var$extractSafariExtensionDetails(func, filename);
        return $eb8f39a71acf0a4f$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $eb8f39a71acf0a4f$export$cdba47a5dd2804d = [
    $eb8f39a71acf0a4f$var$GECKO_PRIORITY,
    $eb8f39a71acf0a4f$var$gecko
];
const $eb8f39a71acf0a4f$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $eb8f39a71acf0a4f$var$winjs = (line)=>{
    const parts = $eb8f39a71acf0a4f$var$winjsRegex.exec(line);
    return parts ? $eb8f39a71acf0a4f$var$createFrame(parts[2], parts[1] || (0, $d668e2a4b0475ef5$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $eb8f39a71acf0a4f$export$179460296da408e8 = [
    $eb8f39a71acf0a4f$var$WINJS_PRIORITY,
    $eb8f39a71acf0a4f$var$winjs
];
const $eb8f39a71acf0a4f$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $eb8f39a71acf0a4f$var$opera10 = (line)=>{
    const parts = $eb8f39a71acf0a4f$var$opera10Regex.exec(line);
    return parts ? $eb8f39a71acf0a4f$var$createFrame(parts[2], parts[3] || (0, $d668e2a4b0475ef5$export$27c7e15d453fc0ac), +parts[1]) : undefined;
};
const $eb8f39a71acf0a4f$export$f892b52c880ffc7a = [
    $eb8f39a71acf0a4f$var$OPERA10_PRIORITY,
    $eb8f39a71acf0a4f$var$opera10
];
const $eb8f39a71acf0a4f$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $eb8f39a71acf0a4f$var$opera11 = (line)=>{
    const parts = $eb8f39a71acf0a4f$var$opera11Regex.exec(line);
    return parts ? $eb8f39a71acf0a4f$var$createFrame(parts[5], parts[3] || parts[4] || (0, $d668e2a4b0475ef5$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : undefined;
};
const $eb8f39a71acf0a4f$export$af11af13f09fb0dc = [
    $eb8f39a71acf0a4f$var$OPERA11_PRIORITY,
    $eb8f39a71acf0a4f$var$opera11
];
const $eb8f39a71acf0a4f$export$7197c0fe6554c079 = [
    $eb8f39a71acf0a4f$export$263a749fff749872,
    $eb8f39a71acf0a4f$export$cdba47a5dd2804d
];
const $eb8f39a71acf0a4f$export$2b2b997d81bf3907 = (0, $d668e2a4b0475ef5$export$a5739666fb2d03d4)(...$eb8f39a71acf0a4f$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $eb8f39a71acf0a4f$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $d668e2a4b0475ef5$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $5ce69a8e194cc380$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $d180a652670457c1$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $d180a652670457c1$export$e464f4a514ac28a8(name) {
    const cached = $d180a652670457c1$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $e2ea69fdb18f915a$export$d5f608b368e73f38)(impl)) return $d180a652670457c1$var$cachedImplementations[name] = impl.bind((0, $085c565c0b56f1a9$export$56d8a8a25bd48b81));
    const document = (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $5ce69a8e194cc380$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $d180a652670457c1$var$cachedImplementations[name] = impl.bind((0, $085c565c0b56f1a9$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $d180a652670457c1$export$8aa36702e8c8978(name) {
    $d180a652670457c1$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $d180a652670457c1$export$e7aa7bc5c1b3cfb3(...rest) {
    return $d180a652670457c1$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $d180a652670457c1$export$831dc9f2ab0a617b(...rest) {
    return $d180a652670457c1$export$e464f4a514ac28a8('setTimeout')(...rest);
}








/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $9d74d4c3327fc4eb$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $c133b3629f3b6130$export$78e43115b553f358)(new (0, $17fa27a1b7630bbb$export$5949942ba2a7c0e2)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $c133b3629f3b6130$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $c133b3629f3b6130$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $08e9c02052b869f6$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $08e9c02052b869f6$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $08e9c02052b869f6$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $08e9c02052b869f6$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $08e9c02052b869f6$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $08e9c02052b869f6$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $08e9c02052b869f6$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers && headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $08e9c02052b869f6$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



const $c7572eef4ca16199$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $c7572eef4ca16199$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $9d74d4c3327fc4eb$export$85a4f67f852183e6)(options.bufferSize || $c7572eef4ca16199$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $1420d5a25389549d$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $1420d5a25389549d$export$b11169581eeaf237)(type);
            if ((0, $08e9c02052b869f6$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $c7572eef4ca16199$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $c133b3629f3b6130$export$1fda8aa4d135f8aa)({});
        const filteredEnvelope = (0, $1420d5a25389549d$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $1420d5a25389549d$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $c7572eef4ca16199$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $1420d5a25389549d$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $1420d5a25389549d$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $08e9c02052b869f6$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $17fa27a1b7630bbb$export$5949942ba2a7c0e2)) {
                (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $c133b3629f3b6130$export$1fda8aa4d135f8aa)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
function $c7572eef4ca16199$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $9d258c4e029a0465$export$b2311068c46d7cc8(options, nativeFetch = (0, $d180a652670457c1$export$e464f4a514ac28a8)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $d180a652670457c1$export$8aa36702e8c8978)('fetch');
            return (0, $c133b3629f3b6130$export$78e43115b553f358)('No fetch implementation available');
        }
        try {
            // TODO: This may need a `suppressTracing` call in the future when we switch the browser SDK to OTEL
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $d180a652670457c1$export$8aa36702e8c8978)('fetch');
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $c133b3629f3b6130$export$78e43115b553f358)(e);
        }
    }
    return (0, $c7572eef4ca16199$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** Get the default integrations for the browser SDK. */ function $79a61d28a18d7e3e$export$5783b2920b1d62b9(options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ const integrations = [
        (0, $ab1dff1b301a8161$export$cb3c5c2ceb9818ba)(),
        (0, $e196c1893a780844$export$7918117e9202e4fb)(),
        (0, $5c2a3ef08526d650$export$59bfe9f1c76150e)(),
        (0, $90aee76cd1400c4e$export$c079d904b326663a)(),
        (0, $9bcac279f53ffd52$export$66acc70e8cf2b71a)(),
        (0, $a598fccd205f1408$export$ebabb00eb7f3a395)(),
        (0, $e4abaab4bcbee8b0$export$6d39aa44cd0c7567)(),
        (0, $c891f2b5d0b4d526$export$1378794447170364)()
    ];
    // eslint-disable-next-line deprecation/deprecation
    if (options.autoSessionTracking !== false) integrations.push((0, $5405b8912357f47d$export$1baa7880e357371c)());
    return integrations;
}
function $79a61d28a18d7e3e$var$applyDefaultOptions(optionsArg = {}) {
    const defaultOptions = {
        defaultIntegrations: $79a61d28a18d7e3e$export$5783b2920b1d62b9(optionsArg),
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).SENTRY_RELEASE.id // This supports the variable that sentry-webpack-plugin injects
         ? (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).SENTRY_RELEASE.id : undefined,
        autoSessionTracking: true,
        sendClientReports: true
    };
    // TODO: Instead of dropping just `defaultIntegrations`, we should simply
    // call `dropUndefinedKeys` on the entire `optionsArg`.
    // However, for this to work we need to adjust the `hasTracingEnabled()` logic
    // first as it differentiates between `undefined` and the key not being in the object.
    if (optionsArg.defaultIntegrations == null) delete optionsArg.defaultIntegrations;
    return {
        ...defaultOptions,
        ...optionsArg
    };
}
function $79a61d28a18d7e3e$var$shouldShowBrowserExtensionError() {
    const windowWithMaybeExtension = typeof (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).window !== 'undefined' && (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81);
    if (!windowWithMaybeExtension) // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const extensionKey = windowWithMaybeExtension.chrome ? 'chrome' : 'browser';
    const extensionObject = windowWithMaybeExtension[extensionKey];
    const runtimeId = extensionObject && extensionObject.runtime && extensionObject.runtime.id;
    const href = (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).location && (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).location.href || '';
    const extensionProtocols = [
        'chrome-extension:',
        'moz-extension:',
        'ms-browser-extension:',
        'safari-web-extension:'
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = !!runtimeId && (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81) === (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}//`));
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    const isNWjs = typeof windowWithMaybeExtension.nw !== 'undefined';
    return !!runtimeId && !isDedicatedExtensionPage && !isNWjs;
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $79a61d28a18d7e3e$export$2cd8252107eb640b(browserOptions = {}) {
    const options = $79a61d28a18d7e3e$var$applyDefaultOptions(browserOptions);
    if (!options.skipBrowserExtensionCheck && $79a61d28a18d7e3e$var$shouldShowBrowserExtensionError()) {
        (0, $2c5c4ba32bebd8b3$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return;
    }
    if (0, $aea8a197a12f0967$export$16a28057038b10ef) {
        if (!(0, $e2ea69fdb18f915a$export$edf3cb81fd7d2a3e)()) (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn('No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.');
    }
    const clientOptions = {
        ...options,
        stackParser: (0, $d668e2a4b0475ef5$export$1d5cf88b347146d4)(options.stackParser || (0, $eb8f39a71acf0a4f$export$2b2b997d81bf3907)),
        integrations: (0, $2135a815867df812$export$68bc4c01ab8ae766)(options),
        transport: options.transport || (0, $9d258c4e029a0465$export$b2311068c46d7cc8)
    };
    return (0, $e116253dcd9c0933$export$5333c3f1c58d9bc1)((0, $d948ee557d0ac687$export$1df9218a526d318d), clientOptions);
}
/**
 * All properties the report dialog supports
 */ /**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $79a61d28a18d7e3e$export$3a8fd680da42627b(options = {}) {
    // doesn't work without a document (React Native)
    if (!(0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).document) {
        (0, $aea8a197a12f0967$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).error('Global document not defined in showReportDialog call');
        return;
    }
    const scope = (0, $a383148e3fcc828a$export$c7be4b0125a10cba)();
    const client = scope.getClient();
    const dsn = client && client.getDsn();
    if (!dsn) {
        (0, $aea8a197a12f0967$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) {
        const eventId = (0, $4af1b4aa86e906d6$export$5d4e9fd7fac8e617)();
        if (eventId) options.eventId = eventId;
    }
    const script = (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $bcd1105623a7bc13$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).document.head || (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $aea8a197a12f0967$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).error('Not injecting report dialog. No injection point found in HTML');
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $79a61d28a18d7e3e$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $79a61d28a18d7e3e$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Captures user feedback and sends it to Sentry.
 *
 * @deprecated Use `captureFeedback` instead.
 */ function $79a61d28a18d7e3e$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    if (client) // eslint-disable-next-line deprecation/deprecation
    client.captureUserFeedback(feedback);
}




var $liOrM = parcelRequire("liOrM");

var $2xPiy = parcelRequire("2xPiy");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $9552556577956458$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;





var $2xPiy = parcelRequire("2xPiy");
/**
 * See if React major version is 17+ by parsing version string.
 */ function $be2536f819d22ee0$export$a87138b73900f5b(reactVersion) {
    const reactMajor = reactVersion.match(/^([^.]+)/);
    return reactMajor !== null && parseInt(reactMajor[0]) >= 17;
}
/**
 * Recurse through `error.cause` chain to set cause on an error.
 */ function $be2536f819d22ee0$export$bc95048bc211a673(error, cause) {
    const seenErrors = new WeakSet();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.add(error);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * Captures an error that was thrown by a React ErrorBoundary or React root.
 *
 * @param error The error to capture.
 * @param errorInfo The errorInfo provided by React.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $be2536f819d22ee0$export$270be4195468cda9(// eslint-disable-next-line @typescript-eslint/no-explicit-any
error, { componentStack: componentStack }, hint) {
    // If on React version >= 17, create stack trace from componentStack param and links
    // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
    // Linking errors requires the `LinkedErrors` integration be enabled.
    // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
    //
    // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
    // with non-error objects. This is why we need to check if the error is an error-like object.
    // See: https://github.com/getsentry/sentry-javascript/issues/6167
    if ($be2536f819d22ee0$export$a87138b73900f5b((0, $2xPiy.version)) && (0, $5d145fc2c94d286e$export$e6127cc7fe7395c3)(error) && componentStack) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
        errorBoundaryError.stack = componentStack;
        // Using the `LinkedErrors` integration to link the errors together.
        $be2536f819d22ee0$export$bc95048bc211a673(error, errorBoundaryError);
    }
    return (0, $4af1b4aa86e906d6$export$f5282963edea4a68)(error, {
        ...hint,
        captureContext: {
            contexts: {
                react: {
                    componentStack: componentStack
                }
            }
        }
    });
}
/**
 * Creates an error handler that can be used with the `onCaughtError`, `onUncaughtError`,
 * and `onRecoverableError` options in `createRoot` and `hydrateRoot` React DOM methods.
 *
 * @param callback An optional callback that will be called after the error is captured.
 * Use this to add custom handling for errors.
 *
 * @example
 *
 * ```JavaScript
 * const root = createRoot(container, {
 *  onCaughtError: Sentry.reactErrorHandler(),
 *  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
 *    console.warn('Caught error', error, errorInfo.componentStack);
 *  });
 * });
 * ```
 */ function $be2536f819d22ee0$export$1e6f045b27b3cfb1(// eslint-disable-next-line @typescript-eslint/no-explicit-any
callback) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error, errorInfo)=>{
        const eventId = $be2536f819d22ee0$export$270be4195468cda9(error, errorInfo);
        if (callback) callback(error, errorInfo, eventId);
    };
}


const $8ff4b3643a1893c6$export$6ef4c0367e27f2d5 = 'unknown';
const $8ff4b3643a1893c6$var$INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
/**
 * A ErrorBoundary component that logs errors to Sentry.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ class $8ff4b3643a1893c6$export$e926676385687eaf extends $2xPiy.Component {
    constructor(props){
        super(props);
        $8ff4b3643a1893c6$export$e926676385687eaf.prototype.__init.call(this);
        this.state = $8ff4b3643a1893c6$var$INITIAL_STATE;
        this._openFallbackReportDialog = true;
        const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
        if (client && props.showDialog) {
            this._openFallbackReportDialog = false;
            this._cleanupHook = client.on('afterSendEvent', (event)=>{
                if (!event.type && this._lastEventId && event.event_id === this._lastEventId) (0, $79a61d28a18d7e3e$export$3a8fd680da42627b)({
                    ...props.dialogOptions,
                    eventId: this._lastEventId
                });
            });
        }
    }
    componentDidCatch(error, errorInfo) {
        const { componentStack: componentStack } = errorInfo;
        // TODO(v9): Remove this check and type `componentStack` to be React.ErrorInfo['componentStack'].
        const passedInComponentStack = componentStack == null ? undefined : componentStack;
        const { beforeCapture: beforeCapture, onError: onError, showDialog: showDialog, dialogOptions: dialogOptions } = this.props;
        (0, $a383148e3fcc828a$export$ec58d9285c204497)((scope)=>{
            if (beforeCapture) beforeCapture(scope, error, passedInComponentStack);
            const handled = this.props.handled != null ? this.props.handled : !!this.props.fallback;
            const eventId = (0, $be2536f819d22ee0$export$270be4195468cda9)(error, errorInfo, {
                mechanism: {
                    handled: handled
                }
            });
            if (onError) onError(error, passedInComponentStack, eventId);
            if (showDialog) {
                this._lastEventId = eventId;
                if (this._openFallbackReportDialog) (0, $79a61d28a18d7e3e$export$3a8fd680da42627b)({
                    ...dialogOptions,
                    eventId: eventId
                });
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            this.setState({
                error: error,
                componentStack: componentStack,
                eventId: eventId
            });
        });
    }
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentWillUnmount() {
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) onUnmount(error, componentStack, eventId);
        if (this._cleanupHook) {
            this._cleanupHook();
            this._cleanupHook = undefined;
        }
    }
    __init() {
        this.resetErrorBoundary = ()=>{
            const { onReset: onReset } = this.props;
            const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
            if (onReset) onReset(error, componentStack, eventId);
            this.setState($8ff4b3643a1893c6$var$INITIAL_STATE);
        };
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const state = this.state;
        if (state.error) {
            let element = undefined;
            if (typeof fallback === 'function') element = $2xPiy.createElement(fallback, {
                error: state.error,
                componentStack: state.componentStack,
                resetError: this.resetErrorBoundary,
                eventId: state.eventId
            });
            else element = fallback;
            if ($2xPiy.isValidElement(element)) return element;
            if (fallback) (0, $9552556577956458$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn('fallback did not produce a valid ReactElement');
            // Fail gracefully if no fallback provided or is not valid
            return null;
        }
        if (typeof children === 'function') return children();
        return children;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8ff4b3643a1893c6$export$f0c7a449e0cfaec7(WrappedComponent, errorBoundaryOptions) {
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || $8ff4b3643a1893c6$export$6ef4c0367e27f2d5;
    const Wrapped = (props)=>$2xPiy.createElement($8ff4b3643a1893c6$export$e926676385687eaf, {
            ...errorBoundaryOptions
        }, $2xPiy.createElement(WrappedComponent, {
            ...props
        }));
    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, (/*@__PURE__*/$parcel$interopDefault($liOrM)))(Wrapped, WrappedComponent);
    return Wrapped;
}




const $0a3e98ef9be0c428$export$b735bbab4dd866a3 = ({ children: children })=>{
    const handleError = (error, stack)=>{
        if ((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).nodeEnv === 'development') console.error('Caught error at root error boundary: %O\nStack trace: %O', error, stack);
    };
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)($8ff4b3643a1893c6$export$e926676385687eaf, {
        fallback: ({ error: error, resetError: resetError })=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $90147163f7f48009$export$605ff0acdbe5bc43), {
                error: error,
                resetErrorBoundary: resetError
            }),
        onError: (error, componentStack)=>handleError(error, componentStack),
        children: children
    });
};




var $2xPiy = parcelRequire("2xPiy");





const $90147163f7f48009$export$605ff0acdbe5bc43 = ()=>{
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const isMobile = screenSize === 'small' || screenSize === 'medium';
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f068601a66842d6c$export$c1faa9c8f42906a), {
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            flex: "grow",
            justify: "center",
            align: "center",
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
                flex: "shrink",
                width: !isMobile ? '35%' : '80%',
                margin: {
                    bottom: 'xlarge'
                },
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                        title: "Error",
                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $11571e85aa9685ed$export$5a89edf87f611fb5), {
                            color: "brand"
                        })
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            pad: {
                                vertical: 'xsmall'
                            },
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                fontFamily: "Lato, sans-serif",
                                children: (0, $d0d6382a5bdf6377$export$d8bd0967cb58683).default
                            })
                        })
                    })
                ]
            })
        })
    });
};






var $2xPiy = parcelRequire("2xPiy");












const $0f2d97cc23e8df8d$export$1e40880dc1d4b90b = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { facility: facility, setIsVisible: setIsVisible } = props;
    /** Stores **/ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const tooltips = (0, $d597772cdbe12609$export$4713da6aa4410043)();
    /** State **/ const [isDeleting, setIsDeleting] = (0, $2xPiy.useState)(false);
    /** Computed **/ const isLoading = !facility;
    const canDelete = userStore.isFuseAdmin;
    /** Methods **/ const deleteFacility = async ()=>{
        if (isDeleting) return;
        try {
            setIsDeleting(true);
            await (0, $2f95a0926656d8e2$export$c270777027a9c841).delete({
                facility_ids: [
                    facility.id
                ]
            });
            setIsVisible(false);
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).deleteFacility.success);
            navigate(`/clients/${facility.client_id}/facilities`);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).deleteFacility.error);
        } finally{
            setIsDeleting(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (!canDelete) setIsVisible(false);
    }, [
        canDelete
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
        position: "center",
        onEsc: ()=>setIsVisible(false),
        onClickOutside: ()=>setIsVisible(false),
        responsive: false,
        style: {
            width: 'auto',
            maxWidth: 'min(95vw, 500px)',
            maxHeight: '95vh',
            overflow: 'auto',
            borderRadius: '8px'
        },
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $98b6153ed086d9bd$export$11154b700737b45e), {
            width: "100%",
            title: `Delete ${(0, $00658ccd6ec0135a$export$83ca57d51225263a)(facility, (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Facility)}`,
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d8fcb0015cca0f72$export$825a3c81a577bf46), {
                entityName: (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Facility
            }),
            onSubmit: ()=>deleteFacility(),
            isLoading: isLoading || isDeleting,
            hideRequiredText: true,
            saveButtonLabel: "DELETE",
            saveButtonLoadingLabel: "DELETING...",
            headerChildren: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                    pad: "none",
                    onClick: ()=>setIsVisible(false),
                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c1da19823027de53$export$f39c2d165cd861fe), {
                        size: "20px"
                    }),
                    tip: tooltips.close
                }, "close")
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                pad: {
                    horizontal: 'medium',
                    bottom: 'medium'
                },
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                    gap: "1rem",
                    direction: "row",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e23e190c1adfeb13$export$a2518b5310db22ab), {
                            size: "medium",
                            color: "status-warning"
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            children: "Are you sure you want to delete this Facility?"
                        })
                    ]
                })
            })
        })
    });
});




var $2xPiy = parcelRequire("2xPiy");












const $1a8d77482fbc9530$export$4b0785a4c770a9d8 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(({ clientId: clientId, isVisible: isVisible, setIsVisible: setIsVisible, setShouldRefresh: setShouldRefresh })=>{
    /** Context **/ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** State **/ const [isLoading, setIsLoading] = (0, $2xPiy.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $2xPiy.useState)(false);
    const [isSelectingAll, setIsSelectingAll] = (0, $2xPiy.useState)(false);
    const [facilitiesList, setFacilitiesList] = (0, $2xPiy.useState)([]);
    const [selectedFacilityIds, setSelectedFacilityIds] = (0, $2xPiy.useState)([]);
    const [isConfirmed, setIsConfirmed] = (0, $2xPiy.useState)(false);
    const [currentPage, setCurrentPage] = (0, $2xPiy.useState)(1);
    const [limit] = (0, $2xPiy.useState)(20);
    const [metadata, setMetadata] = (0, $2xPiy.useState)();
    const [searchQuery, setSearchQuery] = (0, $2xPiy.useState)('');
    const [committedSearchQuery, setCommittedSearchQuery] = (0, $2xPiy.useState)('');
    const [isSearching, setIsSearching] = (0, $2xPiy.useState)(false);
    /** Computed **/ const canDelete = userStore.isFuseAdmin;
    const selectedFacilityIdSet = new Set(selectedFacilityIds);
    const selectedOnPageCount = facilitiesList.filter((facility)=>selectedFacilityIdSet.has(facility.id)).length;
    const isPageSelected = !!facilitiesList.length && selectedOnPageCount === facilitiesList.length;
    const isPagePartiallySelected = selectedOnPageCount > 0 && selectedOnPageCount < facilitiesList.length;
    const hasSelection = !!selectedFacilityIds.length;
    /** Methods **/ const search = (query)=>{
        setSearchQuery(query);
        setCommittedSearchQuery(query);
        setIsSearching(query !== committedSearchQuery);
        setCurrentPage(1);
    };
    const loadFacilities = async (page = 1, address)=>{
        try {
            setIsLoading(true);
            const { data: data, meta: meta } = await (0, $2f95a0926656d8e2$export$c270777027a9c841).list({
                client_id: clientId,
                is_active: true,
                is_finalized: false,
                page: page,
                limit: limit,
                ...address ? {
                    address_line1: address
                } : {}
            });
            setFacilitiesList(data);
            setMetadata(meta);
            setCurrentPage(meta?.current_page ?? page);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listFacilities.error);
        } finally{
            setIsLoading(false);
            setIsSearching(false);
        }
    };
    const deleteFacilities = async ()=>{
        if (isDeleting || !selectedFacilityIds.length) return;
        try {
            setIsDeleting(true);
            await (0, $2f95a0926656d8e2$export$c270777027a9c841).delete({
                facility_ids: selectedFacilityIds
            });
            setShouldRefresh(true);
            setIsVisible(false);
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).deleteFacility.success);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).deleteFacility.error);
        } finally{
            setIsDeleting(false);
        }
    };
    const toggleSelection = (facilityId)=>{
        setSelectedFacilityIds((prev)=>prev.includes(facilityId) ? prev.filter((id)=>id !== facilityId) : [
                ...prev,
                facilityId
            ]);
    };
    const toggleSelectPage = (checked)=>{
        const pageIds = facilitiesList.map((facility)=>facility.id);
        const pageIdSet = new Set(pageIds);
        setSelectedFacilityIds((prev)=>{
            const offPageIds = prev.filter((id)=>!pageIdSet.has(id));
            return checked ? [
                ...offPageIds,
                ...pageIds
            ] : offPageIds;
        });
    };
    const selectAll = async ()=>{
        if (isSelectingAll || !metadata?.total) return;
        try {
            setIsSelectingAll(true);
            const { data: data } = await (0, $2f95a0926656d8e2$export$c270777027a9c841).list({
                client_id: clientId,
                is_active: true,
                is_finalized: false,
                page: 1,
                limit: metadata.total,
                ...committedSearchQuery ? {
                    address_line1: committedSearchQuery
                } : {}
            });
            setSelectedFacilityIds((prev)=>Array.from(new Set([
                    ...prev,
                    ...data.map((facility)=>facility.id)
                ])));
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listFacilities.error);
        } finally{
            setIsSelectingAll(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (isVisible) {
            setSelectedFacilityIds([]);
            setIsConfirmed(false);
            setCurrentPage(1);
            setSearchQuery('');
            setCommittedSearchQuery('');
        }
    }, [
        isVisible,
        clientId
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (!canDelete && isVisible) setIsVisible(false);
    }, [
        canDelete,
        isVisible
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (isVisible && currentPage) loadFacilities(currentPage, committedSearchQuery || undefined);
    }, [
        isVisible,
        currentPage,
        committedSearchQuery
    ]);
    /** Render **/ const renderDataTable = ()=>{
        return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            elevation: "small",
            round: "xsmall",
            overflow: "hidden",
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                },
                primaryKey: "id",
                columns: [
                    {
                        property: 'select',
                        size: '6%',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                            checked: isPageSelected,
                            indeterminate: isPagePartiallySelected,
                            onChange: (e)=>toggleSelectPage(e.target.checked)
                        }),
                        render: (facility)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                                checked: selectedFacilityIdSet.has(facility.id),
                                onChange: ()=>toggleSelection(facility.id)
                            })
                    },
                    {
                        property: 'address_line1',
                        size: '30%',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('common:address')
                        }),
                        render: (facility)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                pad: {
                                    vertical: 'small'
                                },
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                                    to: `/clients/${clientId}/facilities/${facility.id}`,
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "medium",
                                                weight: 700,
                                                color: "accent-1",
                                                fontFamily: "Lato, sans-serif",
                                                children: facility.address_line1
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "small",
                                                color: "accent-1",
                                                fontFamily: "Lato, sans-serif",
                                                children: [
                                                    facility.address_city,
                                                    ",",
                                                    ' ',
                                                    (facility.address_region ?? globalStore.getRegionById(facility.address_region_id))?.short_code,
                                                    ' ',
                                                    facility.address_post_code
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                    },
                    {
                        property: 'is_active',
                        align: 'center',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('common:status')
                        }),
                        render: (facility)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: facility.is_active ? (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Active : (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Retired
                            })
                    },
                    {
                        property: 'program.name',
                        size: '15%',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('common:program')
                        }),
                        render: (facility)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: facility.program?.name || '-'
                            })
                    },
                    {
                        property: 'utility.name',
                        size: '25%',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('facility:utility')
                        }),
                        render: (facility)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: facility.utility?.name || '-'
                            })
                    }
                ],
                data: facilitiesList,
                sortable: true,
                background: [
                    'light-6',
                    'white'
                ],
                border: {
                    color: 'light-2',
                    side: 'bottom',
                    size: 'small'
                }
            })
        });
    };
    return isVisible ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
        position: "center",
        onEsc: ()=>setIsVisible(false),
        onClickOutside: ()=>setIsVisible(false),
        responsive: false,
        style: {
            width: '95%',
            maxWidth: '1400px',
            maxHeight: '95vh',
            overflow: 'auto',
            borderRadius: '8px'
        },
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $98b6153ed086d9bd$export$11154b700737b45e), {
            width: "100%",
            title: t('facility:deleteFacilities'),
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d8fcb0015cca0f72$export$825a3c81a577bf46), {
                entityName: (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Facility
            }),
            onSubmit: ()=>deleteFacilities(),
            isLoading: isLoading || isDeleting,
            hideRequiredText: true,
            saveButtonLabel: "DELETE",
            saveButtonLoadingLabel: "DELETING...",
            saveButtonDisabled: !isConfirmed || !selectedFacilityIds.length,
            headerChildren: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                    pad: "none",
                    onClick: ()=>setIsVisible(false),
                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c1da19823027de53$export$f39c2d165cd861fe), {
                        size: "20px"
                    }),
                    tip: t('common:close')
                }, "close")
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                pad: {
                    horizontal: 'medium',
                    bottom: 'medium'
                },
                gap: "medium",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                        gap: "1rem",
                        direction: "row",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e23e190c1adfeb13$export$a2518b5310db22ab), {
                                size: "medium",
                                color: "status-warning"
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                children: t('facility:deleteWarning', 'Warning: This action will permanently delete the selected facilities. This action cannot be undone.')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        direction: "row",
                        align: "end",
                        justify: "between",
                        children: [
                            hasSelection && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                                gap: "1rem",
                                direction: "row",
                                align: "center",
                                background: {
                                    color: 'status-error',
                                    dark: true
                                },
                                pad: "medium",
                                round: "small",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                                        checked: isConfirmed,
                                        onChange: ()=>setIsConfirmed(!isConfirmed),
                                        color: "white"
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        color: "white",
                                        children: t('facility:deleteMultipleConfirmation', {
                                            count: selectedFacilityIds.length
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                direction: "row",
                                align: "center",
                                gap: "small",
                                margin: {
                                    left: 'auto'
                                },
                                children: [
                                    hasSelection && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "small",
                                        children: t('common:selectedCount', {
                                            count: selectedFacilityIds.length
                                        })
                                    }),
                                    (hasSelection || !!metadata?.total) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $85ab7488c493b81c$export$6d88ebe453be59d7), {
                                        label: hasSelection ? t('common:clearAll') : `${t('common:selectAll')} (${metadata?.total})`,
                                        onClick: ()=>{
                                            setIsConfirmed(false);
                                            if (hasSelection) setSelectedFacilityIds([]);
                                            else selectAll();
                                        },
                                        disabled: isSelectingAll || isLoading || isSearching
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f7f71094d2af306c$export$55d7609a8f1eccd2), {
                                        searchQuery: searchQuery,
                                        placeholder: t('facility:searchByAddress', 'Search by Address'),
                                        setSearchQuery: setSearchQuery,
                                        onSearch: search,
                                        isSearching: isSearching
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        gap: "small",
                        children: isLoading ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            pad: {
                                vertical: 'medium'
                            },
                            height: "10vh",
                            fill: "horizontal",
                            justify: "center",
                            align: "center",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8bec6e2e7dc53c4a$export$7f7cbe89f1eacd2), {
                                size: "medium"
                            })
                        }) : facilitiesList.length ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
                            children: [
                                renderDataTable(),
                                !!metadata && metadata.total > limit && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    pad: {
                                        top: 'medium'
                                    },
                                    justify: "center",
                                    align: "center",
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ffccbada2139938a$export$68f5e1453c188a82), {
                                        alignSelf: "center",
                                        size: "small",
                                        page: currentPage,
                                        step: metadata.per_page,
                                        numberItems: metadata.total,
                                        onChange: (e)=>setCurrentPage(e.page)
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            pad: {
                                horizontal: 'small',
                                vertical: 'medium'
                            },
                            background: "light-6",
                            align: "center",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: "medium",
                                fontFamily: "Lato, sans-serif",
                                children: t('facility:noFacilitiesFound', 'No non-finalized facilities found.')
                            })
                        })
                    })
                ]
            })
        })
    }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cb4cc5db45d03478$exports.Fragment), {});
});




var $2xPiy = parcelRequire("2xPiy");













const $93b56b8d4d0da6dd$var$FACILITY_LIST_DEFAULTS = {
    page: 1,
    search: '',
    is_active: 'true',
    program_id: undefined,
    utility_id: undefined,
    address_region_id: undefined
};
const $93b56b8d4d0da6dd$var$FACILITY_LIST_CLEARED = {
    ...$93b56b8d4d0da6dd$var$FACILITY_LIST_DEFAULTS,
    is_active: ''
};
const $93b56b8d4d0da6dd$export$9f76c3e28857a02f = (props)=>{
    const { clientId: clientId, id: id, title: title, showFilters: showFilters, showSearchInput: showSearchInput, showAddButton: showAddButton, showShareButton: showShareButton, isLoading: propIsLoading, facilities: propFacilities, fetchFacilities: propFetchFacilities, currentPage: propCurrentPage, setCurrentPage: propSetCurrentPage, metadata: propMetadata, hideHeader: hideHeader, boxProps: boxProps, dataTour: dataTour, surfaceId: surfaceId, standalone: standalone = false, mode: mode = 'query' } = props;
    const isPropControlled = mode === 'controlled';
    /** Context **/ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const queryClient = (0, $bccbe1b43ff3d0cc$export$22e77b9572c4fded)();
    const tooltips = (0, $d597772cdbe12609$export$4713da6aa4410043)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    /** Restorable state **/ const restorableList = (0, $d73aac7e90cb996d$export$e4108de26414712f)({
        surfaceId: surfaceId || 'facility-list',
        defaults: $93b56b8d4d0da6dd$var$FACILITY_LIST_DEFAULTS,
        standalone: standalone
    });
    const queryState = restorableList.state;
    const setQueryState = restorableList.setState;
    /** Draft state **/ const [draftSearch, setDraftSearch] = (0, $2xPiy.useState)(queryState.search);
    const [draftIsActive, setDraftIsActive] = (0, $2xPiy.useState)(queryState.is_active);
    const [draftFilters, setDraftFilters] = (0, $2xPiy.useState)({
        program_id: queryState.program_id,
        utility_id: queryState.utility_id,
        address_region_id: queryState.address_region_id
    });
    /** Modal state **/ const [showRetireMultipleModal, setShowRetireMultipleModal] = (0, $2xPiy.useState)(false);
    const [showDeleteMultipleModal, setShowDeleteMultipleModal] = (0, $2xPiy.useState)(false);
    const [userCanRetire, setUserCanRetire] = (0, $2xPiy.useState)(false);
    const [userCanDelete, setUserCanDelete] = (0, $2xPiy.useState)(false);
    const [isMenuOpen] = (0, $2xPiy.useState)(false);
    const [isMenuHovered, setIsMenuHovered] = (0, $2xPiy.useState)(false);
    const [isFiltersMenuOpen, setIsFiltersMenuOpen] = (0, $2xPiy.useState)(false);
    const [isFiltersMenuHovered, setIsFiltersMenuHovered] = (0, $2xPiy.useState)(false);
    /** Computed **/ const isMobile = (0, $18588a518ac6fdc7$export$2ac00d7098bf223)(screenSize);
    const request = (0, $2xPiy.useMemo)(()=>({
            client_id: clientId,
            page: queryState.page,
            address_line1: queryState.search || undefined,
            is_active: queryState.is_active === 'true' ? true : queryState.is_active === 'false' ? false : undefined,
            program_id: queryState.program_id,
            utility_id: queryState.utility_id,
            address_region_id: queryState.address_region_id ? String(queryState.address_region_id) : undefined
        }), [
        queryState,
        clientId
    ]);
    /** React Query **/ const { data: queryData, isLoading: queryIsLoading, isFetching: isFetching, error: queryError, refetch: refetch } = (0, $4130e158515cd100$export$dd0a697e1782aedd)({
        queryKey: [
            'facilities',
            userStore.user?.id,
            request
        ],
        queryFn: ()=>(0, $2f95a0926656d8e2$export$c270777027a9c841).list(request),
        enabled: !isPropControlled && !!userStore.user && !!clientId && !Number.isNaN(clientId),
        placeholderData: (prev)=>prev
    });
    const queryFacilities = queryData?.data;
    const queryMetadata = queryData?.meta;
    /** Toast on query error **/ (0, $2xPiy.useEffect)(()=>{
        if (queryError && !isPropControlled) globalStore.handleApiError(queryError, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listFacilities.error);
    }, [
        queryError
    ]);
    /** Check facilities for retire (active) and delete (unfinalized) permissions **/ (0, $2xPiy.useEffect)(()=>{
        if (isPropControlled || !clientId || Number.isNaN(clientId)) return;
        if (!userStore.isFuseAdmin) {
            setUserCanRetire(false);
            setUserCanDelete(false);
            return;
        }
        let cancelled = false;
        const setIfCurrent = (setter)=>(value)=>{
                if (!cancelled) setter(value);
            };
        const hasMatches = (filter)=>(0, $2f95a0926656d8e2$export$c270777027a9c841).list({
                client_id: clientId,
                limit: 1,
                page: 1,
                ...filter
            }).then((facilityList)=>(facilityList.meta?.total ?? 0) > 0).catch(()=>false);
        hasMatches({
            is_active: true
        }).then(setIfCurrent(setUserCanRetire));
        hasMatches({
            is_active: true,
            is_finalized: false
        }).then(setIfCurrent(setUserCanDelete));
        return ()=>{
            cancelled = true;
        };
    }, [
        clientId,
        isPropControlled,
        userStore.isFuseAdmin
    ]);
    /** Resolved values **/ const _facilities = propFacilities ?? queryFacilities;
    const _metadata = propMetadata ?? queryMetadata;
    const _currentPage = propCurrentPage ?? queryState.page;
    const _isLoading = propIsLoading ?? (isPropControlled ? false : queryIsLoading || isFetching);
    const isRefetching = isFetching && !queryIsLoading;
    const hasFacilities = !!_facilities?.length;
    const lastQuery = queryState.search;
    /** Methods **/ const search = (0, $2xPiy.useCallback)((query)=>{
        setQueryState({
            search: query || '',
            page: 1
        });
    }, [
        setQueryState
    ]);
    const applyFilters = (0, $2xPiy.useCallback)(()=>{
        setQueryState({
            is_active: draftIsActive,
            program_id: draftFilters.program_id,
            utility_id: draftFilters.utility_id,
            address_region_id: draftFilters.address_region_id,
            page: 1
        });
        setIsFiltersMenuOpen(false);
    }, [
        setQueryState,
        draftIsActive,
        draftFilters
    ]);
    const clearFilters = (0, $2xPiy.useCallback)(()=>{
        setDraftIsActive($93b56b8d4d0da6dd$var$FACILITY_LIST_CLEARED.is_active);
        setDraftFilters({
            program_id: $93b56b8d4d0da6dd$var$FACILITY_LIST_CLEARED.program_id,
            utility_id: $93b56b8d4d0da6dd$var$FACILITY_LIST_CLEARED.utility_id,
            address_region_id: $93b56b8d4d0da6dd$var$FACILITY_LIST_CLEARED.address_region_id
        });
        setDraftSearch('');
        setQueryState($93b56b8d4d0da6dd$var$FACILITY_LIST_CLEARED);
        setIsFiltersMenuOpen(false);
    }, [
        setQueryState
    ]);
    const handlePageChange = (0, $2xPiy.useCallback)((page)=>{
        if (isPropControlled) {
            propSetCurrentPage?.(page);
            propFetchFacilities?.(page);
        } else setQueryState({
            page: page
        });
    }, [
        isPropControlled,
        propSetCurrentPage,
        propFetchFacilities,
        setQueryState
    ]);
    /** shouldRefresh callback for modals **/ const setShouldRefresh = (0, $2xPiy.useCallback)((value)=>{
        if (value) {
            refetch();
            queryClient.invalidateQueries({
                queryKey: [
                    'equipment'
                ]
            });
        }
    }, [
        refetch,
        queryClient
    ]);
    /** Sync page from API response **/ (0, $2xPiy.useEffect)(()=>{
        if (queryMetadata && !isPropControlled && queryMetadata.current_page !== queryState.page) setQueryState({
            page: queryMetadata.current_page
        });
    }, [
        queryMetadata?.current_page
    ]);
    /** Sync drafts when queryState changes **/ (0, $d73aac7e90cb996d$export$b5b12661e3d1fa94)(queryState, setDraftSearch, (s)=>s.search);
    (0, $d73aac7e90cb996d$export$b5b12661e3d1fa94)(queryState, setDraftIsActive, (s)=>s.is_active);
    (0, $d73aac7e90cb996d$export$b5b12661e3d1fa94)(queryState, setDraftFilters, (s)=>({
            program_id: s.program_id,
            utility_id: s.utility_id,
            address_region_id: s.address_region_id
        }));
    /** Render **/ const renderFleetOverview = (facility)=>{
        if (!facility.num_equipment_per_category.length) return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                children: "-"
            })
        });
        let hasItem = false;
        const overview = /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            direction: isMobile ? 'column' : 'row',
            wrap: true,
            gap: isMobile ? '3px' : '6px',
            margin: {
                vertical: isMobile ? (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(12) : undefined
            },
            children: facility.num_equipment_per_category.map(({ category_name: category_name, num_equipment: num_equipment })=>{
                if (!category_name || !num_equipment) return;
                hasItem = true;
                return category_name && num_equipment ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    direction: "row",
                    margin: {
                        vertical: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(3)
                    },
                    border: {
                        side: 'all',
                        size: 'small',
                        color: 'light-2'
                    },
                    background: "white",
                    gap: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(12),
                    pad: {
                        vertical: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(4),
                        left: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(10),
                        right: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(6)
                    },
                    style: {
                        boxShadow: 'rgba(0, 0, 0, 0.2) 0 10px 10px -10px'
                    },
                    round: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(4),
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            justify: "center",
                            flex: isMobile ? true : undefined,
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(12),
                                lineHeight: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(12),
                                children: category_name
                            })
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            align: "center",
                            justify: "center",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                style: {
                                    minWidth: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(28)
                                },
                                pad: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(2.8),
                                round: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(4),
                                align: "center",
                                justify: "center",
                                background: "accent-1",
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    color: "white",
                                    weight: 500,
                                    size: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(12),
                                    lineHeight: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(12),
                                    children: num_equipment
                                })
                            })
                        })
                    ]
                }, category_name) : undefined;
            })
        });
        return hasItem ? overview : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                children: "-"
            })
        });
    };
    const facilityMenuItems = [
        {
            label: t('facility:addFacility'),
            onClick: ()=>navigate(`/clients/${clientId}/facilities/create`)
        },
        {
            label: t('facility:retireFacilities'),
            onClick: ()=>userCanRetire && setShowRetireMultipleModal(true),
            disabled: !userCanRetire
        },
        {
            label: t('facility:deleteFacilities'),
            onClick: ()=>userCanDelete && setShowDeleteMultipleModal(true),
            disabled: !userCanDelete
        }
    ].filter((item)=>item.label !== t('facility:addFacility') || showAddButton).filter((item)=>item.label !== t('facility:deleteFacilities') || userCanDelete).filter((item)=>item.label !== t('facility:retireFacilities') || userCanRetire);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        id: id,
        direction: "row",
        gap: "medium",
        fill: "horizontal",
        "data-tour": dataTour,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
                ...boxProps,
                children: [
                    !hideHeader && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                        title: title || t('facility:facilityList'),
                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $a71df00a6fead254$export$cb4af564eb490bac), {}),
                        ...showShareButton && {
                            button: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ce7c3f634dc2ea76$export$c9915453de10000b), {
                                size: "16px"
                            }),
                            buttonNavigatePath: `/clients/${clientId}/facilities`,
                            buttonTooltip: (0, $d597772cdbe12609$export$4713da6aa4410043)().facilityPageLink
                        },
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            direction: "row",
                            gap: "small",
                            children: [
                                showSearchInput && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f7f71094d2af306c$export$55d7609a8f1eccd2), {
                                    searchQuery: draftSearch,
                                    placeholder: t('facility:searchByAddress'),
                                    setSearchQuery: setDraftSearch,
                                    onSearch: search,
                                    isSearching: isRefetching,
                                    "data-tour": "facility-search"
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c9158ac1cba12f75$export$64fff40e709e8b2e), {
                                    plain: true,
                                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $eec4bc4b18205d01$export$ec91da630f36d5ea), {
                                        color: isFiltersMenuHovered || isFiltersMenuOpen ? 'brand' : undefined
                                    }),
                                    open: isFiltersMenuOpen,
                                    onOpen: ()=>setIsFiltersMenuOpen(true),
                                    onClose: ()=>setIsFiltersMenuOpen(false),
                                    onMouseOver: ()=>setIsFiltersMenuHovered(true),
                                    onMouseOut: ()=>setIsFiltersMenuHovered(false),
                                    tip: tooltips.filterFacilities,
                                    dropAlign: {
                                        right: 'right',
                                        top: 'bottom'
                                    },
                                    dropContent: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d5dc00f4222e17dc$export$c9824d87391788f3), {
                                        isFiltering: isRefetching,
                                        onSubmit: ()=>applyFilters(),
                                        onClear: ()=>clearFilters(),
                                        filters: [
                                            {
                                                label: t('facility:activityStatus'),
                                                value: draftIsActive ?? '',
                                                setValue: (value)=>setDraftIsActive(value || undefined),
                                                options: [
                                                    {
                                                        label: t('common:all'),
                                                        value: ''
                                                    },
                                                    {
                                                        label: t('common:active'),
                                                        value: 'true'
                                                    },
                                                    {
                                                        label: t('common:retired'),
                                                        value: 'false'
                                                    }
                                                ]
                                            }
                                        ]
                                    })
                                }),
                                userStore.isFuseAdmin ? facilityMenuItems.length > 0 && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $41d136aeffe9860f$export$d9b273488cd8ce6f), {
                                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $93663f13c4b467ae$export$d9b273488cd8ce6f), {
                                            color: isMenuHovered || isMenuOpen ? 'brand' : undefined
                                        }),
                                        onMouseOver: ()=>setIsMenuHovered(true),
                                        onMouseOut: ()=>setIsMenuHovered(false),
                                        tip: t('facility:facilityActions'),
                                        dropAlign: {
                                            top: 'bottom',
                                            right: 'right'
                                        },
                                        items: facilityMenuItems
                                    })
                                }) : showAddButton && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $85ab7488c493b81c$export$6d88ebe453be59d7), {
                                    label: t('facility:addFacility'),
                                    targetUrl: `/clients/${clientId}/facilities/create`
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                        pad: "none",
                        gap: "none",
                        children: [
                            _isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}),
                            !_isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                elevation: "small",
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
                                    id: "facility_list_data_table",
                                    pad: {
                                        horizontal: '1.5rem'
                                    },
                                    columns: [
                                        {
                                            property: 'id',
                                            primary: true,
                                            size: '24%',
                                            header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                title: t('common:address')
                                            }),
                                            render: (facility)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                    pad: {
                                                        vertical: '1rem'
                                                    },
                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                                                        to: `/clients/${!!clientId && !Number.isNaN(clientId) ? clientId : facility.client_id ?? ''}/facilities/${facility.id}`,
                                                        textDecoration: "none",
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                    size: "medium",
                                                                    weight: 700,
                                                                    color: "accent-1",
                                                                    fontFamily: "Lato, sans-serif",
                                                                    lineHeight: "1.25rem",
                                                                    children: facility.address_line1
                                                                }),
                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                    size: "small",
                                                                    color: "accent-1",
                                                                    fontFamily: "Lato, sans-serif",
                                                                    lineHeight: "1rem",
                                                                    children: [
                                                                        facility.address_city,
                                                                        ",",
                                                                        ' ',
                                                                        (facility.address_region ?? globalStore.getRegionById(facility.address_region_id))?.short_code,
                                                                        ' ',
                                                                        facility.address_post_code
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                        },
                                        {
                                            property: 'is_active',
                                            header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                title: t('common:status')
                                            }),
                                            render: (facility)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                    value: facility.is_active ? (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Active : (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Retired
                                                })
                                        },
                                        {
                                            property: 'program.name',
                                            size: '10%',
                                            header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                title: t('common:program')
                                            }),
                                            render: (facility)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    size: "medium",
                                                    fontFamily: "Lato, sans-serif",
                                                    children: facility.program?.name
                                                })
                                        },
                                        {
                                            property: 'utility.name',
                                            size: '28%',
                                            header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                title: t('facility:utility')
                                            }),
                                            render: (facility)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    size: "medium",
                                                    fontFamily: "Lato, sans-serif",
                                                    children: facility.utility?.name
                                                })
                                        },
                                        {
                                            property: 'fleet_overview',
                                            size: '36%',
                                            sortable: false,
                                            header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                title: t('facility:assetOverview')
                                            }),
                                            align: 'start',
                                            render: (facility)=>renderFleetOverview(facility)
                                        }
                                    ],
                                    data: _facilities,
                                    sortable: true,
                                    background: [
                                        'light-6',
                                        'white'
                                    ],
                                    border: {
                                        color: 'light-2',
                                        side: 'bottom',
                                        size: 'small'
                                    }
                                })
                            }),
                            !hasFacilities && !_isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                pad: {
                                    horizontal: '1.5rem',
                                    vertical: '2rem'
                                },
                                background: "light-6",
                                justify: "center",
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    alignSelf: "center",
                                    size: "medium",
                                    fontFamily: "Lato, sans-serif",
                                    children: [
                                        "No facilities found",
                                        lastQuery ? ` with the name "${lastQuery}"` : '',
                                        "."
                                    ]
                                })
                            }),
                            !!_metadata && !!_currentPage && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                pad: "1.5rem",
                                flex: "grow",
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ffccbada2139938a$export$68f5e1453c188a82), {
                                    alignSelf: "center",
                                    size: "small",
                                    page: _currentPage,
                                    step: _metadata?.per_page,
                                    numberItems: _metadata?.total,
                                    onChange: (e)=>handlePageChange(e.page)
                                })
                            })
                        ]
                    })
                ]
            }),
            showFilters && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ea2652f405b477a3$export$92a576f896a9bf72), {
                isFiltering: isRefetching,
                onSubmit: ()=>applyFilters(),
                onClear: ()=>clearFilters(),
                filters: [
                    {
                        label: 'Program',
                        value: draftFilters.program_id ?? NaN,
                        setValue: (value)=>setDraftFilters({
                                ...draftFilters,
                                program_id: value
                            }),
                        options: []
                    },
                    {
                        label: 'Utility',
                        value: draftFilters.utility_id ?? NaN,
                        setValue: (value)=>setDraftFilters({
                                ...draftFilters,
                                utility_id: value
                            }),
                        options: []
                    },
                    {
                        label: 'State/Region',
                        value: draftFilters.address_region_id ?? NaN,
                        setValue: (value)=>setDraftFilters({
                                ...draftFilters,
                                address_region_id: value
                            }),
                        options: globalStore.regions.filter((region)=>!!region.short_code).map((region)=>({
                                label: region.short_code ?? '',
                                value: region.id
                            }))
                    }
                ]
            }),
            showRetireMultipleModal && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7cc07084df16eaeb$export$20f9a0e50e4a11c6), {
                clientId: clientId,
                isVisible: showRetireMultipleModal,
                setIsVisible: setShowRetireMultipleModal,
                setShouldRefresh: setShouldRefresh,
                isCanada: false
            }),
            showDeleteMultipleModal && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $1a8d77482fbc9530$export$4b0785a4c770a9d8), {
                clientId: clientId,
                isVisible: showDeleteMultipleModal,
                setIsVisible: setShowDeleteMultipleModal,
                setShouldRefresh: setShouldRefresh
            })
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");












const $02d290c95d3f695d$export$3640d7be9c00e62d = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(({ facility: facility, setIsVisible: setIsVisible, setShouldRefresh: setShouldRefresh, isCanada: isCanada = false })=>{
    /** Stores **/ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** State **/ const [isRetiring, setIsRetiring] = (0, $2xPiy.useState)(false);
    const [isConfirmed1, setIsConfirmed1] = (0, $2xPiy.useState)(false);
    const [isConfirmed2, setIsConfirmed2] = (0, $2xPiy.useState)(false);
    const [reasonId, setReasonId] = (0, $2xPiy.useState)();
    const [reasonText, setReasonText] = (0, $2xPiy.useState)('');
    const [isOther, setIsOther] = (0, $2xPiy.useState)(false);
    const [formValues, setFormValues] = (0, $2xPiy.useState)({
        last_active_reporting_quarter: ''
    });
    const [formErrors, setFormErrors] = (0, $2xPiy.useState)({});
    /** Computed **/ const canRetire = userStore.isFuseAdmin;
    const selectedPeriodLabel = (0, $00658ccd6ec0135a$export$f96ebb633255a704)(formValues.last_active_reporting_quarter ?? '', isCanada);
    const hasReason = !!reasonId && (!isOther || !!reasonText.trim());
    /** Methods **/ const updateFormValue = (key, value)=>{
        setFormValues((prev)=>({
                ...prev,
                [key]: value
            }));
        if (formErrors[key]) setFormErrors((prev)=>({
                ...prev,
                [key]: ''
            }));
    };
    const retireFacility = async ()=>{
        if (isRetiring) return;
        const formFields = {
            last_active_reporting_quarter: {
                label: t('common:lastReportingPeriod'),
                required: true
            },
            retirement_reason_id: {
                label: t('common:reasonForRetiring'),
                required: true
            },
            ...isOther && {
                retirement_reason_other: {
                    label: t('common:otherReasonDescription'),
                    required: true
                }
            }
        };
        const errors = (0, $084681c8221d0a24$export$5fafec8d1b047c0)(formFields, {
            last_active_reporting_quarter: formValues.last_active_reporting_quarter,
            retirement_reason_id: reasonId,
            retirement_reason_other: reasonText.trim()
        });
        if (errors) {
            setFormErrors(errors);
            return;
        }
        try {
            setIsRetiring(true);
            await (0, $2f95a0926656d8e2$export$c270777027a9c841).retire({
                facility_ids: [
                    facility.id
                ],
                last_active_reporting_quarter: formValues.last_active_reporting_quarter ?? '',
                retirement_reason_id: reasonId,
                retirement_reason_other: isOther ? reasonText.trim() : null
            });
            setShouldRefresh(true);
            setIsVisible(false);
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).retireFacility.success);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).retireFacility.error);
        } finally{
            setIsRetiring(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (!canRetire) setIsVisible(false);
    }, [
        canRetire
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
        position: "center",
        onEsc: ()=>setIsVisible(false),
        onClickOutside: ()=>setIsVisible(false),
        responsive: false,
        style: {
            width: 'auto',
            maxWidth: 'min(95vw, 500px)',
            maxHeight: '95vh',
            overflow: 'auto',
            borderRadius: '8px'
        },
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $98b6153ed086d9bd$export$11154b700737b45e), {
            width: "100%",
            title: `${t('common:retire')} ${(0, $00658ccd6ec0135a$export$83ca57d51225263a)(facility, (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Facility)}`,
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d8fcb0015cca0f72$export$825a3c81a577bf46), {
                entityName: (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Facility
            }),
            onSubmit: ()=>retireFacility(),
            isLoading: isRetiring,
            hideRequiredText: true,
            saveButtonLabel: t('common:retireButton'),
            saveButtonLoadingLabel: t('common:retiringButton'),
            saveButtonDisabled: !isConfirmed1 || !isConfirmed2 || !hasReason,
            headerChildren: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                    pad: "none",
                    onClick: ()=>setIsVisible(false),
                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c1da19823027de53$export$f39c2d165cd861fe), {
                        size: "20px"
                    }),
                    tip: t('common:close')
                }, "close")
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                pad: {
                    horizontal: 'medium',
                    bottom: 'medium'
                },
                gap: "medium",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                        gap: "1rem",
                        direction: "row",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e23e190c1adfeb13$export$a2518b5310db22ab), {
                                size: "medium",
                                color: "status-warning"
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                children: [
                                    t('facility:retireWarning'),
                                    " ",
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("b", {
                                        children: t('common:after')
                                    }),
                                    ' ',
                                    formValues.last_active_reporting_quarter ? selectedPeriodLabel : t('common:theLastReportingPeriod'),
                                    ' ',
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("b", {
                                        children: t('facility:retireWarningEnd')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d3263c98ec06168d$export$90b89cb54a5768ce), {
                        id: "last_active_reporting_quarter",
                        label: t('common:lastReportingPeriod'),
                        placeholder: t('common:selectPeriod'),
                        value: formValues.last_active_reporting_quarter,
                        setValue: (value)=>updateFormValue('last_active_reporting_quarter', value),
                        clientId: facility.client_id,
                        programId: facility.program_id,
                        reportingPeriodTypeId: facility.reporting_period_type_id,
                        firstActivePeriod: facility.first_active_reporting_quarter,
                        error: formErrors['last_active_reporting_quarter'],
                        required: true,
                        fill: "horizontal"
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $95684e66166a88c8$export$516f52107d98083f), {
                        entityType: "facility",
                        reasonId: reasonId,
                        setReasonId: setReasonId,
                        reasonText: reasonText,
                        setReasonText: setReasonText,
                        setIsOther: setIsOther,
                        reasonError: formErrors['retirement_reason_id'],
                        textError: formErrors['retirement_reason_other']
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        gap: "small",
                        children: [
                            formValues.last_active_reporting_quarter && hasReason && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                                gap: "1rem",
                                direction: "row",
                                align: "center",
                                background: {
                                    color: 'status-error',
                                    dark: true
                                },
                                pad: "medium",
                                round: "small",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                                        checked: isConfirmed1,
                                        onChange: ()=>setIsConfirmed1(!isConfirmed1),
                                        color: "white"
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        color: "white",
                                        children: t('facility:retireConfirmation1')
                                    })
                                ]
                            }),
                            formValues.last_active_reporting_quarter && hasReason && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                                gap: "1rem",
                                direction: "row",
                                align: "center",
                                background: {
                                    color: 'status-error',
                                    dark: true
                                },
                                pad: "medium",
                                round: "small",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                                        checked: isConfirmed2,
                                        onChange: ()=>setIsConfirmed2(!isConfirmed2),
                                        color: "white"
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        color: "white",
                                        children: [
                                            t('facility:retireConfirmation2Start'),
                                            " ",
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("b", {
                                                children: t('common:after')
                                            }),
                                            " ",
                                            selectedPeriodLabel,
                                            ' ',
                                            t('facility:retireConfirmation2End')
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
});




var $2xPiy = parcelRequire("2xPiy");














const $7cc07084df16eaeb$export$20f9a0e50e4a11c6 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(({ clientId: clientId, isVisible: isVisible, setIsVisible: setIsVisible, setShouldRefresh: setShouldRefresh, isCanada: isCanada = false })=>{
    /** Context **/ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** State **/ const [isLoading, setIsLoading] = (0, $2xPiy.useState)(false);
    const [isRetiring, setIsRetiring] = (0, $2xPiy.useState)(false);
    const [isSelectingAll, setIsSelectingAll] = (0, $2xPiy.useState)(false);
    const [facilitiesList, setFacilitiesList] = (0, $2xPiy.useState)([]);
    const [selectedFacilityIds, setSelectedFacilityIds] = (0, $2xPiy.useState)([]);
    const [lastActivePeriod, setLastActivePeriod] = (0, $2xPiy.useState)('');
    const [reasonId, setReasonId] = (0, $2xPiy.useState)();
    const [reasonText, setReasonText] = (0, $2xPiy.useState)('');
    const [isOther, setIsOther] = (0, $2xPiy.useState)(false);
    const [isConfirmed1, setIsConfirmed1] = (0, $2xPiy.useState)(false);
    const [isConfirmed2, setIsConfirmed2] = (0, $2xPiy.useState)(false);
    const [currentPage, setCurrentPage] = (0, $2xPiy.useState)(1);
    const [limit] = (0, $2xPiy.useState)(20);
    const [metadata, setMetadata] = (0, $2xPiy.useState)();
    const [earliestFirstActive, setEarliestFirstActive] = (0, $2xPiy.useState)();
    const [searchQuery, setSearchQuery] = (0, $2xPiy.useState)('');
    const [committedSearchQuery, setCommittedSearchQuery] = (0, $2xPiy.useState)('');
    const [isSearching, setIsSearching] = (0, $2xPiy.useState)(false);
    const selectAllRequestIdRef = (0, $2xPiy.useRef)(0);
    /** Computed **/ const canRetire = userStore.isFuseAdmin;
    const selectedPeriodLabel = lastActivePeriod ? (0, $00658ccd6ec0135a$export$f96ebb633255a704)(lastActivePeriod, isCanada) : t('common:theLastReportingPeriod');
    const hasReason = !!reasonId && (!isOther || !!reasonText.trim());
    const selectedFacilityIdSet = new Set(selectedFacilityIds);
    const selectedOnPageCount = facilitiesList.filter((facility)=>selectedFacilityIdSet.has(facility.id)).length;
    const isPageSelected = !!facilitiesList.length && selectedOnPageCount === facilitiesList.length;
    const isPagePartiallySelected = selectedOnPageCount > 0 && selectedOnPageCount < facilitiesList.length;
    const hasSelection = !!selectedFacilityIds.length;
    /** Methods **/ const search = (query)=>{
        setSearchQuery(query);
        setCommittedSearchQuery(query);
        setIsSearching(query !== committedSearchQuery);
        setCurrentPage(1);
    };
    const handlePeriodChange = (period)=>{
        selectAllRequestIdRef.current += 1;
        setSelectedFacilityIds([]);
        setIsConfirmed1(false);
        setIsConfirmed2(false);
        setCurrentPage(1);
        setLastActivePeriod(period);
    };
    const loadFacilities = async (page = 1, address)=>{
        try {
            setIsLoading(true);
            const { data: data, meta: meta, earliest_first_active_reporting_quarter: earliest_first_active_reporting_quarter } = await (0, $2f95a0926656d8e2$export$c270777027a9c841).list({
                client_id: clientId,
                is_active: true,
                page: page,
                limit: limit,
                ...lastActivePeriod ? {
                    active_by_reporting_quarter: lastActivePeriod
                } : {},
                ...address ? {
                    address_line1: address
                } : {}
            });
            setFacilitiesList(data);
            setMetadata(meta);
            setCurrentPage(meta?.current_page ?? page);
            setEarliestFirstActive(earliest_first_active_reporting_quarter ?? undefined);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listFacilities.error);
        } finally{
            setIsLoading(false);
            setIsSearching(false);
        }
    };
    const retireFacilities = async ()=>{
        if (isRetiring || !selectedFacilityIds.length || !lastActivePeriod || !reasonId || isOther && !reasonText.trim()) return;
        try {
            setIsRetiring(true);
            await (0, $2f95a0926656d8e2$export$c270777027a9c841).retire({
                facility_ids: selectedFacilityIds,
                last_active_reporting_quarter: lastActivePeriod,
                retirement_reason_id: reasonId,
                retirement_reason_other: isOther ? reasonText.trim() : null
            });
            setShouldRefresh(true);
            setIsVisible(false);
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).retireFacility.success);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).retireFacility.error);
        } finally{
            setIsRetiring(false);
        }
    };
    const toggleSelection = (facilityId)=>{
        setSelectedFacilityIds((prev)=>prev.includes(facilityId) ? prev.filter((id)=>id !== facilityId) : [
                ...prev,
                facilityId
            ]);
    };
    const toggleSelectPage = (checked)=>{
        const pageIds = facilitiesList.map((facility)=>facility.id);
        const pageIdSet = new Set(pageIds);
        setSelectedFacilityIds((prev)=>{
            const offPageIds = prev.filter((id)=>!pageIdSet.has(id));
            return checked ? [
                ...offPageIds,
                ...pageIds
            ] : offPageIds;
        });
    };
    const selectAll = async ()=>{
        if (isSelectingAll || !metadata?.total) return;
        selectAllRequestIdRef.current += 1;
        const requestId = selectAllRequestIdRef.current;
        try {
            setIsSelectingAll(true);
            const { data: data } = await (0, $2f95a0926656d8e2$export$c270777027a9c841).list({
                client_id: clientId,
                is_active: true,
                page: 1,
                limit: metadata.total,
                ...lastActivePeriod ? {
                    active_by_reporting_quarter: lastActivePeriod
                } : {},
                ...committedSearchQuery ? {
                    address_line1: committedSearchQuery
                } : {}
            });
            if (requestId !== selectAllRequestIdRef.current) return;
            setSelectedFacilityIds((prev)=>Array.from(new Set([
                    ...prev,
                    ...data.map((facility)=>facility.id)
                ])));
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listFacilities.error);
        } finally{
            setIsSelectingAll(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (isVisible) {
            setLastActivePeriod('');
            setReasonId(undefined);
            setReasonText('');
            setIsOther(false);
            setSelectedFacilityIds([]);
            setIsConfirmed1(false);
            setIsConfirmed2(false);
            setCurrentPage(1);
            setSearchQuery('');
            setCommittedSearchQuery('');
        }
    }, [
        isVisible,
        clientId
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (!canRetire && isVisible) setIsVisible(false);
    }, [
        canRetire,
        isVisible
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (isVisible && currentPage) loadFacilities(currentPage, committedSearchQuery || undefined);
    }, [
        isVisible,
        currentPage,
        committedSearchQuery,
        lastActivePeriod
    ]);
    /** Render **/ const renderDataTable = ()=>{
        return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            elevation: "small",
            round: "xsmall",
            overflow: "hidden",
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                },
                primaryKey: "id",
                columns: [
                    {
                        property: 'select',
                        size: '6%',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                            checked: isPageSelected,
                            indeterminate: isPagePartiallySelected,
                            onChange: (e)=>toggleSelectPage(e.target.checked)
                        }),
                        render: (facility)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                                checked: selectedFacilityIdSet.has(facility.id),
                                onChange: ()=>toggleSelection(facility.id)
                            })
                    },
                    {
                        property: 'address_line1',
                        size: '30%',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('common:address')
                        }),
                        render: (facility)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                pad: {
                                    vertical: 'small'
                                },
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                                    to: `/clients/${clientId}/facilities/${facility.id}`,
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "medium",
                                                weight: 700,
                                                color: "accent-1",
                                                fontFamily: "Lato, sans-serif",
                                                children: facility.address_line1
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "small",
                                                color: "accent-1",
                                                fontFamily: "Lato, sans-serif",
                                                children: [
                                                    facility.address_city,
                                                    ",",
                                                    ' ',
                                                    (facility.address_region ?? globalStore.getRegionById(facility.address_region_id))?.short_code,
                                                    ' ',
                                                    facility.address_post_code
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                    },
                    {
                        property: 'is_active',
                        align: 'center',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('common:status')
                        }),
                        render: (facility)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: facility.is_active ? (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Active : (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Retired
                            })
                    },
                    {
                        property: 'program.name',
                        size: '15%',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('common:program')
                        }),
                        render: (facility)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: facility.program?.name || '-'
                            })
                    },
                    {
                        property: 'utility.name',
                        size: '25%',
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                            title: t('facility:utility')
                        }),
                        render: (facility)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                value: facility.utility?.name || '-'
                            })
                    }
                ],
                data: facilitiesList,
                sortable: true,
                background: [
                    'light-6',
                    'white'
                ],
                border: {
                    color: 'light-2',
                    side: 'bottom',
                    size: 'small'
                }
            })
        });
    };
    return isVisible ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
        position: "center",
        onEsc: ()=>setIsVisible(false),
        onClickOutside: ()=>setIsVisible(false),
        responsive: false,
        style: {
            width: '95%',
            maxWidth: '1400px',
            maxHeight: '95vh',
            overflow: 'auto',
            borderRadius: '8px'
        },
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $98b6153ed086d9bd$export$11154b700737b45e), {
            width: "100%",
            title: t('facility:retireFacilities'),
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d8fcb0015cca0f72$export$825a3c81a577bf46), {
                entityName: (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Facility
            }),
            onSubmit: ()=>retireFacilities(),
            isLoading: isLoading || isRetiring,
            hideRequiredText: true,
            saveButtonLabel: t('common:retireButton'),
            saveButtonLoadingLabel: t('common:retiringButton'),
            saveButtonDisabled: !isConfirmed1 || !isConfirmed2 || !selectedFacilityIds.length || !lastActivePeriod || !hasReason,
            headerChildren: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                    pad: "none",
                    onClick: ()=>setIsVisible(false),
                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c1da19823027de53$export$f39c2d165cd861fe), {
                        size: "20px"
                    }),
                    tip: t('common:close')
                }, "close")
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                pad: {
                    horizontal: 'medium',
                    bottom: 'medium'
                },
                gap: "medium",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                        gap: "1rem",
                        direction: "row",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e23e190c1adfeb13$export$a2518b5310db22ab), {
                                size: "medium",
                                color: "status-warning"
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                children: [
                                    t('facility:retireWarning'),
                                    " ",
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("b", {
                                        children: t('common:after')
                                    }),
                                    " ",
                                    selectedPeriodLabel,
                                    ' ',
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("b", {
                                        children: t('facility:retireWarningEnd')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        direction: "row",
                        align: "end",
                        justify: "between",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                direction: "row",
                                align: "end",
                                gap: "small",
                                width: "40%",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d3263c98ec06168d$export$90b89cb54a5768ce), {
                                        id: "last_active_reporting_quarter",
                                        label: t('common:lastReportingPeriod'),
                                        placeholder: isLoading ? t('common:loading') : t('common:selectPeriod'),
                                        value: lastActivePeriod,
                                        setValue: (value)=>handlePeriodChange(value),
                                        clientId: clientId,
                                        programId: facilitiesList[0]?.program_id,
                                        reportingPeriodTypeId: facilitiesList[0]?.reporting_period_type_id,
                                        firstActivePeriod: earliestFirstActive,
                                        required: true,
                                        width: '60%'
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $95684e66166a88c8$export$516f52107d98083f), {
                                        entityType: "facility",
                                        showTextField: false,
                                        fill: "horizontal",
                                        reasonId: reasonId,
                                        setReasonId: setReasonId,
                                        setReasonText: setReasonText,
                                        setIsOther: setIsOther
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                direction: "row",
                                align: "center",
                                gap: "small",
                                children: [
                                    hasSelection && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "small",
                                        children: t('common:selectedCount', {
                                            count: selectedFacilityIds.length
                                        })
                                    }),
                                    (hasSelection || !!metadata?.total) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $85ab7488c493b81c$export$6d88ebe453be59d7), {
                                        label: hasSelection ? t('common:clearAll') : `${t('common:selectAll')} (${metadata?.total})`,
                                        onClick: ()=>{
                                            setIsConfirmed1(false);
                                            setIsConfirmed2(false);
                                            if (hasSelection) setSelectedFacilityIds([]);
                                            else selectAll();
                                        },
                                        disabled: isSelectingAll || isLoading || isSearching
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f7f71094d2af306c$export$55d7609a8f1eccd2), {
                                        searchQuery: searchQuery,
                                        placeholder: t('facility:searchByAddress', 'Search by Address'),
                                        setSearchQuery: setSearchQuery,
                                        onSearch: search,
                                        isSearching: isSearching
                                    })
                                ]
                            })
                        ]
                    }),
                    isOther && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $95684e66166a88c8$export$3109f1de68cd7ecc), {
                        value: reasonText,
                        setValue: setReasonText
                    }),
                    lastActivePeriod && hasReason && hasSelection && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        gap: "small",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                                gap: "1rem",
                                direction: "row",
                                align: "center",
                                background: {
                                    color: 'status-error',
                                    dark: true
                                },
                                pad: "medium",
                                round: "small",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                                        checked: isConfirmed1,
                                        onChange: ()=>setIsConfirmed1(!isConfirmed1),
                                        color: "white"
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        color: "white",
                                        children: t('facility:retireMultipleConfirmation', {
                                            count: selectedFacilityIds.length
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                                gap: "1rem",
                                direction: "row",
                                align: "center",
                                background: {
                                    color: 'status-error',
                                    dark: true
                                },
                                pad: "medium",
                                round: "small",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                                        checked: isConfirmed2,
                                        onChange: ()=>setIsConfirmed2(!isConfirmed2),
                                        color: "white"
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        color: "white",
                                        children: [
                                            t('facility:retireConfirmation2Start'),
                                            " ",
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("b", {
                                                children: t('common:after')
                                            }),
                                            " ",
                                            selectedPeriodLabel,
                                            ' ',
                                            t('facility:retireConfirmation2End')
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        gap: "small",
                        children: isLoading ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            pad: {
                                vertical: 'medium'
                            },
                            height: "10vh",
                            fill: "horizontal",
                            justify: "center",
                            align: "center",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8bec6e2e7dc53c4a$export$7f7cbe89f1eacd2), {
                                size: "medium"
                            })
                        }) : facilitiesList.length ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
                            children: [
                                renderDataTable(),
                                !!metadata && metadata.total > limit && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    pad: {
                                        top: 'medium'
                                    },
                                    justify: "center",
                                    align: "center",
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ffccbada2139938a$export$68f5e1453c188a82), {
                                        alignSelf: "center",
                                        size: "small",
                                        page: currentPage,
                                        step: metadata.per_page,
                                        numberItems: metadata.total,
                                        onChange: (e)=>setCurrentPage(e.page)
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            pad: {
                                horizontal: 'small',
                                vertical: 'medium'
                            },
                            background: "light-6",
                            align: "center",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: "medium",
                                fontFamily: "Lato, sans-serif",
                                children: t('facility:noActiveFacilitiesFound', 'No active facilities found.')
                            })
                        })
                    })
                ]
            })
        })
    }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cb4cc5db45d03478$exports.Fragment), {});
});






var $2xPiy = parcelRequire("2xPiy");







const $9623ddb5e8e2f680$export$c48527d0fea494d = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { value: value, setValue: setValue, clientId: clientId, reportingPeriodTypeId: reportingPeriodTypeId, firstActivePeriod: firstActivePeriod, id: id, name: name, label: label, disabled: disabled, placeholder: placeholder, programId: programId, ...selectProps } = props;
    /** Context **/ const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const clientStore = (0, $116967e0234c3770$export$3b47afa599c78f61)();
    /** State **/ const [options, setOptions] = (0, $2xPiy.useState)();
    /** Computed **/ const isLoading = !options;
    /** Methods **/ const fetchOptions = async (clientId, reportingPeriodTypeId, firstActivePeriod)=>{
        try {
            /*
        Rules - First Reporting Period

        1. Reporting periods should only be the client's unfinalized reporting periods
        2. Do not allow client users to add facilities/equipment with a locked first reporting period
      */ const reportingPeriods = await clientStore.fetchClientReportingPeriods(clientId, reportingPeriodTypeId, false, userStore.isExternalUser, programId);
            const isUSProgram = programId === 1 || programId === 2 || programId === 3;
            const options = reportingPeriods.filter((p)=>!(0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(p.start_reporting_quarter).isBefore(firstActivePeriod)).filter((p)=>{
                if (userStore.isFuseAdmin) return true;
                if (isUSProgram) {
                    const periodDate = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(p.start_reporting_quarter);
                    const isQ2_2025 = periodDate.year() === 2025 && periodDate.month() >= 3 && periodDate.month() <= 5;
                    return !isQ2_2025;
                }
                return true;
            }).map((p)=>({
                    label: (0, $00658ccd6ec0135a$export$f96ebb633255a704)(p.start_reporting_quarter, reportingPeriodTypeId === (0, $0badf5665deea2b2$export$a121e4a6c908fa8f).Yearly),
                    value: p.start_reporting_quarter
                }));
            setOptions((0, $00658ccd6ec0135a$export$ccc472524c48b71f)(options));
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listClientReportingPeriods.error);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (clientId && reportingPeriodTypeId && firstActivePeriod && programId) {
            setOptions(undefined);
            fetchOptions(clientId, reportingPeriodTypeId, firstActivePeriod);
        } else if (options) setOptions(undefined);
    }, [
        clientId,
        reportingPeriodTypeId,
        firstActivePeriod,
        programId
    ]);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
        value: value,
        setValue: (value)=>setValue(value),
        options: options ?? [],
        name: id ? undefined : name || 'reporting_period_select',
        label: label ?? 'Reporting Period',
        placeholder: !programId ? 'Select Program First...' : isLoading ? 'Loading...' : placeholder,
        disabled: isLoading || disabled,
        ...selectProps
    });
});




var $2xPiy = parcelRequire("2xPiy");




let $d3e44ef4a726de02$var$googleMapsScriptLoaded = false;
let $d3e44ef4a726de02$var$googleMapsScriptLoading = false;
const $d3e44ef4a726de02$var$loadCallbacks = [];
function $d3e44ef4a726de02$var$loadGoogleMapsScript() {
    return new Promise((resolve)=>{
        if ($d3e44ef4a726de02$var$googleMapsScriptLoaded) {
            resolve(true);
            return;
        }
        $d3e44ef4a726de02$var$loadCallbacks.push(resolve);
        if ($d3e44ef4a726de02$var$googleMapsScriptLoading) return;
        $d3e44ef4a726de02$var$googleMapsScriptLoading = true;
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${(0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).maps.googleMapsApiKey}&libraries=places&loading=async&callback=__googleMapsCallback`;
        script.async = true;
        script.defer = true;
        window.__googleMapsCallback = ()=>{
            $d3e44ef4a726de02$var$googleMapsScriptLoaded = true;
            $d3e44ef4a726de02$var$loadCallbacks.forEach((cb)=>cb(true));
            $d3e44ef4a726de02$var$loadCallbacks.length = 0;
            delete window.__googleMapsCallback;
        };
        script.onerror = ()=>{
            $d3e44ef4a726de02$var$googleMapsScriptLoading = false;
            delete window.__googleMapsCallback;
            script.remove();
            const pending = $d3e44ef4a726de02$var$loadCallbacks.splice(0);
            pending.forEach((cb)=>cb(false));
        };
        document.head.appendChild(script);
    });
}
async function $d3e44ef4a726de02$var$fetchPredictions(input) {
    try {
        const AutocompleteSuggestion = google.maps.places.AutocompleteSuggestion;
        const { suggestions: suggestions } = await AutocompleteSuggestion.fetchAutocompleteSuggestions({
            input: input,
            includedPrimaryTypes: [
                'street_address',
                'subpremise',
                'premise'
            ],
            includedRegionCodes: [
                'us',
                'ca'
            ]
        });
        return (suggestions || []).map((s)=>({
                placePrediction: s.placePrediction,
                description: s.placePrediction.text.text
            }));
    } catch  {
        return [];
    }
}
function $d3e44ef4a726de02$var$getComponentText(component, preferShort = false) {
    if (preferShort) return component.shortText ?? component.short_name ?? component.longText ?? component.long_name ?? '';
    return component.longText ?? component.long_name ?? component.shortText ?? component.short_name ?? '';
}
function $d3e44ef4a726de02$var$parseAddressComponents(components) {
    let streetNumber = '';
    let route = '';
    let city = '';
    let stateShortCode = '';
    let postCode = '';
    let subpremise = '';
    for (const component of components){
        const types = component.types;
        if (types.includes('street_number')) streetNumber = $d3e44ef4a726de02$var$getComponentText(component);
        else if (types.includes('route')) route = $d3e44ef4a726de02$var$getComponentText(component);
        else if (types.includes('subpremise')) subpremise = $d3e44ef4a726de02$var$getComponentText(component);
        else if (types.includes('locality')) city = $d3e44ef4a726de02$var$getComponentText(component);
        else if (types.includes('sublocality_level_1') && !city) city = $d3e44ef4a726de02$var$getComponentText(component);
        else if (types.includes('administrative_area_level_1')) stateShortCode = $d3e44ef4a726de02$var$getComponentText(component, true);
        else if (types.includes('postal_code')) postCode = $d3e44ef4a726de02$var$getComponentText(component);
    }
    return {
        line1: streetNumber ? `${streetNumber} ${route}` : route,
        line2: subpremise ? `#${subpremise}` : '',
        city: city,
        stateShortCode: stateShortCode,
        postCode: postCode
    };
}
async function $d3e44ef4a726de02$var$getPlaceDetails(placePrediction) {
    try {
        const place = placePrediction.toPlace();
        await place.fetchFields({
            fields: [
                'addressComponents'
            ]
        });
        if (!place.addressComponents) return null;
        return $d3e44ef4a726de02$var$parseAddressComponents(place.addressComponents);
    } catch  {
        return null;
    }
}
const $d3e44ef4a726de02$export$db97b1df0d4d83fb = (props)=>{
    const { label: label, value: value, setValue: setValue, onPlaceSelected: onPlaceSelected, name: name, placeholder: placeholder, error: error, required: required, disabled: disabled, onSubmit: onSubmit, ...boxProps } = props;
    const [isFocused, setIsFocused] = (0, $2xPiy.useState)(false);
    const [predictions, setPredictions] = (0, $2xPiy.useState)([]);
    const [showDropdown, setShowDropdown] = (0, $2xPiy.useState)(false);
    const [apiReady, setApiReady] = (0, $2xPiy.useState)($d3e44ef4a726de02$var$googleMapsScriptLoaded);
    const debounceRef = (0, $2xPiy.useRef)(undefined);
    const containerRef = (0, $2xPiy.useRef)(null);
    const skipFetchRef = (0, $2xPiy.useRef)(false);
    const isActiveLabel = value !== '' || isFocused || disabled || !!placeholder;
    (0, $2xPiy.useEffect)(()=>{
        if (disabled || !(0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).maps.googleMapsApiKey) return;
        $d3e44ef4a726de02$var$loadGoogleMapsScript().then((success)=>setApiReady(success));
    }, [
        disabled
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (!apiReady || skipFetchRef.current || !isFocused) {
            skipFetchRef.current = false;
            return;
        }
        if (!value || value.length < 3) {
            setPredictions([]);
            setShowDropdown(false);
            return;
        }
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(async ()=>{
            const results = await $d3e44ef4a726de02$var$fetchPredictions(value);
            setPredictions(results);
            setShowDropdown(results.length > 0);
        }, 300);
        return ()=>{
            if (debounceRef.current) clearTimeout(debounceRef.current);
        };
    }, [
        value,
        apiReady,
        isFocused
    ]);
    (0, $2xPiy.useEffect)(()=>{
        const handleClickOutside = (e)=>{
            if (containerRef.current && !containerRef.current.contains(e.target)) setShowDropdown(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    const handleSelect = (0, $2xPiy.useCallback)(async (prediction)=>{
        setShowDropdown(false);
        setPredictions([]);
        const result = await $d3e44ef4a726de02$var$getPlaceDetails(prediction.placePrediction);
        if (result) {
            skipFetchRef.current = true;
            setValue(result.line1);
            onPlaceSelected?.(result);
        }
    }, [
        setValue,
        onPlaceSelected
    ]);
    const borderColor = error ? 'red' : isFocused ? 'accent-1' : 'light-5';
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("div", {
        ref: containerRef,
        style: {
            position: 'relative'
        },
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            ...boxProps,
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    border: disabled ? undefined : {
                        color: borderColor,
                        size: 'small'
                    },
                    background: disabled ? 'light-6' : undefined,
                    round: "6px",
                    height: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(58),
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        round: "6px",
                        direction: "row",
                        fill: "vertical",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $1e7958766884f71d$export$694e0d28c7ffc90c), {
                            anchor: isActiveLabel ? 'top-left' : 'left',
                            guidingChild: "last",
                            fill: "vertical",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    pad: {
                                        top: isActiveLabel ? 'xsmall' : undefined,
                                        left: 'small'
                                    },
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: isActiveLabel ? 'small' : 'medium',
                                        color: isActiveLabel ? 'accent-1' : undefined,
                                        children: [
                                            label,
                                            required && '*'
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $168667f04da9206c$export$16e4d70cc375e707), {
                                    onEnter: onSubmit,
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8c9c99ffe8765a99$export$c86715117507e8e5), {
                                        id: name,
                                        name: name,
                                        value: value,
                                        placeholder: placeholder,
                                        onChange: (e)=>setValue(e.target.value),
                                        required: required,
                                        disabled: disabled,
                                        onFocus: ()=>{
                                            setIsFocused(true);
                                            if (predictions.length > 0) setShowDropdown(true);
                                        },
                                        onBlur: ()=>setIsFocused(false),
                                        autoComplete: "off",
                                        plain: true,
                                        style: {
                                            fontFamily: 'Lato, sans-serif',
                                            height: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(58),
                                            paddingTop: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(26),
                                            paddingBottom: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(10)
                                        },
                                        className: "hide-input-arrows"
                                    })
                                })
                            ]
                        })
                    })
                }),
                showDropdown && predictions.length > 0 && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    background: "white",
                    elevation: "medium",
                    round: "6px",
                    style: {
                        position: 'absolute',
                        top: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(62),
                        left: 0,
                        right: 0,
                        zIndex: 10000,
                        maxHeight: '240px',
                        overflowY: 'auto'
                    },
                    children: predictions.map((prediction)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            pad: {
                                horizontal: 'small',
                                vertical: 'xsmall'
                            },
                            hoverIndicator: "light-2",
                            onClick: ()=>handleSelect(prediction),
                            style: {
                                cursor: 'pointer'
                            },
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: "small",
                                style: {
                                    fontFamily: 'Lato, sans-serif'
                                },
                                children: prediction.description
                            })
                        }, prediction.placePrediction.placeId))
                }),
                error && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    margin: {
                        top: '0.5rem',
                        left: '0.75rem'
                    },
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        color: "red",
                        size: "0.75rem",
                        children: error
                    })
                })
            ]
        })
    });
};




var $2xPiy = parcelRequire("2xPiy");

var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");
var $5958f18f8d688d50$exports = {};

$parcel$export($5958f18f8d688d50$exports, "__esModule", function () { return $5958f18f8d688d50$export$1e511d4a378977f5; }, function (v) { return $5958f18f8d688d50$export$1e511d4a378977f5 = v; });
$parcel$export($5958f18f8d688d50$exports, "Calendar", function () { return $5958f18f8d688d50$export$e1aef45b828286de; }, function (v) { return $5958f18f8d688d50$export$e1aef45b828286de = v; });
var $5958f18f8d688d50$export$1e511d4a378977f5;
var $5958f18f8d688d50$export$e1aef45b828286de;
"use strict";
$5958f18f8d688d50$export$1e511d4a378977f5 = true;
$5958f18f8d688d50$export$e1aef45b828286de = void 0;

var $5958f18f8d688d50$var$_react = $5958f18f8d688d50$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5958f18f8d688d50$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5958f18f8d688d50$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5958f18f8d688d50$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5958f18f8d688d50$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5958f18f8d688d50$var$_extends() {
    return $5958f18f8d688d50$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5958f18f8d688d50$var$_extends.apply(null, arguments);
}
var $5958f18f8d688d50$var$Calendar = $5958f18f8d688d50$export$e1aef45b828286de = /*#__PURE__*/ (0, $5958f18f8d688d50$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5958f18f8d688d50$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5958f18f8d688d50$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Calendar"
    }, props), /*#__PURE__*/ $5958f18f8d688d50$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 5h20v17H2V5zm16 0V1M6 5V1m-4 9h20"
    }));
});
$5958f18f8d688d50$var$Calendar.displayName = 'Calendar';







var $2xPiy = parcelRequire("2xPiy");









var $dyr1f = parcelRequire("dyr1f");

function $ba59fffdaf612893$var$_extends() {
    return $ba59fffdaf612893$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ba59fffdaf612893$var$_extends.apply(null, arguments);
}
var $ba59fffdaf612893$var$PropType = {};
$ba59fffdaf612893$var$PropType = $ba59fffdaf612893$var$_extends({}, (0, $ab32ce3df36aa105$export$ffe37ff34eeb9e21), {
    activeDate: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'start',
        'end'
    ]),
    animate: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    bounds: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    date: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string)
        ]))
    ]),
    dates: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string)
    ])),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string)
    ])),
    daysOfWeek: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    fill: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    firstDayOfWeek: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        0,
        1
    ]),
    header: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    level: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        1,
        2,
        3,
        4,
        5,
        6,
        '1',
        '2',
        '3',
        '4',
        '5',
        '6'
    ]),
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    messages: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        previous: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        next: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    }),
    onReference: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    range: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'array'
        ])
    ]),
    reference: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    responsive: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    showAdjacentDays: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'trim'
        ])
    ]),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'small',
            'medium',
            'large'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ])
});
var $ba59fffdaf612893$export$91040927b1d7b4d1 = $ba59fffdaf612893$var$PropType;



var $iA1nz = parcelRequire("iA1nz");



var $3257a779ba750b21$var$responsiveSizeStyle = function responsiveSizeStyle(props) {
    var breakpoint = props.theme.global.size[props.sizeProp];
    return (0, $cdf517d38d72c2bc$export$2180d12f0a299a89)({
        value: breakpoint
    }, "\n    width: 100vw;\n    max-width: " + breakpoint + ";\n  ", true);
};
var $3257a779ba750b21$var$sizeStyle = function sizeStyle(props) {
    var data = props.theme.calendar[props.sizeProp];
    var width = props.fillContainer ? '100%' : props.theme.global.size[props.sizeProp];
    return (0, $iA1nz.css)([
        "font-size:",
        ";line-height:",
        ";width:",
        ";",
        ""
    ], data.fontSize, data.lineHeight, width, function(p) {
        return p.fillContainer && 'height: 100%;';
    });
};
var $3257a779ba750b21$export$2185b0041ed383 = (0, $iA1nz.default).div.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledCalendar",
    componentId: "sc-1y4xhmp-0"
})([
    "",
    " ",
    " ",
    " ",
    ""
], (0, $73ba8e2d301b823f$export$a157b298d219a801), function(props) {
    return $3257a779ba750b21$var$sizeStyle(props);
}, function(props) {
    return props.responsive && $3257a779ba750b21$var$responsiveSizeStyle(props);
}, function(props) {
    return props.theme.calendar && props.theme.calendar.extend;
});
var $3257a779ba750b21$var$weeksContainerSizeStyle = function weeksContainerSizeStyle(props) {
    var height = props.fillContainer ? '100%' : (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(props.theme.calendar[props.sizeProp].daySize) * 6 + "px";
    return "\n    height: " + height + ";\n\n  ";
};
var $3257a779ba750b21$var$weeksContainerResponsiveSizeStyle = function weeksContainerResponsiveSizeStyle(props) {
    var breakpoint = props.theme.global.size[props.sizeProp];
    // set aspect-ratio to 7 days by 6 weeks
    return (0, $cdf517d38d72c2bc$export$2180d12f0a299a89)({
        value: breakpoint
    }, "\n    height: auto;\n    aspect-ratio: 7/6;\n    ", true);
};
var $3257a779ba750b21$export$cc9ae1676f4ee80a = (0, $iA1nz.default).div.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledCalendar__StyledWeeksContainer",
    componentId: "sc-1y4xhmp-1"
})([
    "overflow:hidden;",
    " ",
    " ",
    ";"
], function(props) {
    return $3257a779ba750b21$var$weeksContainerSizeStyle(props);
}, function(props) {
    return props.responsive && $3257a779ba750b21$var$weeksContainerResponsiveSizeStyle(props);
}, function(props) {
    return props.focus && !props.plain && (0, $73ba8e2d301b823f$export$efbff472cb39d8b)();
});
var $3257a779ba750b21$var$slideStyle = function slideStyle(props) {
    var _props$slide = props.slide, direction = _props$slide.direction, weeks = _props$slide.weeks, sizeProp = props.sizeProp, theme = props.theme;
    var _theme$calendar$sizeP = theme.calendar[sizeProp], daySize = _theme$calendar$sizeP.daySize, slideDuration = _theme$calendar$sizeP.slideDuration;
    var amount = (0, $cdf517d38d72c2bc$export$333c2219d71d27ce)(daySize) * weeks;
    var translateYFrom = direction === 'down' ? "-" + amount + "px" : '0';
    var translateYTo = direction === 'up' ? "-" + amount + "px" : '0';
    var slideTransition = (0, $iA1nz.css)([
        "0%{transform:translateY(",
        ");}100%{transform:translateY(",
        ");}"
    ], translateYFrom, translateYTo);
    return (0, $iA1nz.css)([
        "animation:",
        " ",
        " forwards;"
    ], (0, $iA1nz.keyframes)([
        "",
        ""
    ], slideTransition), slideDuration);
};
var $3257a779ba750b21$var$weeksSizeStyle = function weeksSizeStyle() {
    return (0, $iA1nz.css)([
        "display:flex;flex-direction:column;height:100%;"
    ]);
};
// fallback to medium if no size-specific styles
var $3257a779ba750b21$var$rangeRoundStyle = function rangeRoundStyle(props) {
    var _props$theme$calendar5, _props$theme$calendar6;
    var themeObj;
    if (props.isSelected) {
        var _props$theme$calendar, _props$theme$calendar2, _props$theme$calendar3, _props$theme$calendar4;
        var rangeStart = ((_props$theme$calendar = props.theme.calendar) == null || (_props$theme$calendar = _props$theme$calendar[props.sizeProp]) == null || (_props$theme$calendar = _props$theme$calendar.range) == null || (_props$theme$calendar = _props$theme$calendar.start) == null ? void 0 : _props$theme$calendar.round) || ((_props$theme$calendar2 = props.theme.calendar) == null || (_props$theme$calendar2 = _props$theme$calendar2.medium) == null || (_props$theme$calendar2 = _props$theme$calendar2.range) == null || (_props$theme$calendar2 = _props$theme$calendar2.start) == null ? void 0 : _props$theme$calendar2.round);
        var rangeEnd = ((_props$theme$calendar3 = props.theme.calendar) == null || (_props$theme$calendar3 = _props$theme$calendar3[props.sizeProp]) == null || (_props$theme$calendar3 = _props$theme$calendar3.range) == null || (_props$theme$calendar3 = _props$theme$calendar3.end) == null ? void 0 : _props$theme$calendar3.round) || ((_props$theme$calendar4 = props.theme.calendar) == null || (_props$theme$calendar4 = _props$theme$calendar4.medium) == null || (_props$theme$calendar4 = _props$theme$calendar4.range) == null || (_props$theme$calendar4 = _props$theme$calendar4.end) == null ? void 0 : _props$theme$calendar4.round);
        if (props.rangePosition === 'start' && rangeStart) themeObj = rangeStart;
        else if (props.rangePosition === 'end' && rangeEnd) themeObj = rangeEnd;
    } else themeObj = ((_props$theme$calendar5 = props.theme.calendar) == null || (_props$theme$calendar5 = _props$theme$calendar5[props.sizeProp]) == null || (_props$theme$calendar5 = _props$theme$calendar5.range) == null ? void 0 : _props$theme$calendar5.round) || ((_props$theme$calendar6 = props.theme.calendar) == null || (_props$theme$calendar6 = _props$theme$calendar6.medium) == null || (_props$theme$calendar6 = _props$theme$calendar6.range) == null ? void 0 : _props$theme$calendar6.round);
    return themeObj && [
        (0, $73ba8e2d301b823f$export$98483643daf52539)(themeObj, props.responsive, props.theme)
    ];
};
var $3257a779ba750b21$export$3d055278a61c3939 = (0, $iA1nz.default).div.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledCalendar__StyledWeeks",
    componentId: "sc-1y4xhmp-2"
})([
    "position:relative;",
    " ",
    ";"
], function(props) {
    return props.fillContainer && $3257a779ba750b21$var$weeksSizeStyle();
}, function(props) {
    return props.slide && $3257a779ba750b21$var$slideStyle(props);
});
var $3257a779ba750b21$export$5db4823d38c0569f = (0, $iA1nz.default).div.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledCalendar__StyledWeek",
    componentId: "sc-1y4xhmp-3"
})([
    "display:flex;justify-content:space-between;",
    ""
], function(props) {
    return props.fillContainer && 'flex: 1;';
});
var $3257a779ba750b21$var$responsiveDayContainerStyle = function responsiveDayContainerStyle(props) {
    var breakpoint = props.theme.global.size[props.sizeProp];
    return (0, $cdf517d38d72c2bc$export$2180d12f0a299a89)({
        value: breakpoint
    }, "\n    width: 14.3%;\n  ", true);
};
// The width of 14.3% is derived from dividing 100/7. We want the
// widths of 7 days to equally fill 100% of the row.
var $3257a779ba750b21$export$ffce625ce693a981 = (0, $iA1nz.default).div.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledCalendar__StyledDayContainer",
    componentId: "sc-1y4xhmp-4"
})([
    "flex:0 1 auto;",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return props.fillContainer && 'width: 14.3%;';
}, function(props) {
    var _props$theme$calendar7;
    return (props.inRange || props.isSelected && props.rangePosition) && ((_props$theme$calendar7 = props.theme.calendar) == null || (_props$theme$calendar7 = _props$theme$calendar7.range) == null ? void 0 : _props$theme$calendar7.background) && (0, $0b4a347e23c22183$export$e43a4f0de05cb7e9)(props.theme.calendar.range.background, props.theme);
}, function(props) {
    return $3257a779ba750b21$var$rangeRoundStyle(props);
}, function(props) {
    return props.responsive && $3257a779ba750b21$var$responsiveDayContainerStyle(props);
});
var $3257a779ba750b21$var$responsiveDayButtonStyle = function responsiveDayButtonStyle(props) {
    var breakpoint = props.theme.global.size[props.sizeProp];
    return (0, $cdf517d38d72c2bc$export$2180d12f0a299a89)({
        value: breakpoint
    }, "\n    width: 100%;\n  ", true);
};
// when caller opts in to day hover styling, apply all state styles
// on CalendarDay instead of active state on CalendarDayButton
// position relative and z-index are added to prevent the focus
// indicator from getting cut off
var $3257a779ba750b21$export$2be68822f46d2c34 = (0, $iA1nz.default)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1)).withConfig({
    displayName: "StyledCalendar__StyledDayButton",
    componentId: "sc-1y4xhmp-5"
})([
    "&:focus{position:relative;z-index:1;}",
    " ",
    ""
], function(props) {
    return props.disabledProp && (0, $73ba8e2d301b823f$export$adf3fcef8e5e1347)(props.theme.button.disabled.opacity);
}, function(props) {
    return props.responsive && $3257a779ba750b21$var$responsiveDayButtonStyle(props);
});
var $3257a779ba750b21$var$daySizeStyle = function daySizeStyle(props) {
    var data = props.theme.calendar[props.sizeProp];
    return (0, $iA1nz.css)([
        "width:",
        ";height:",
        ";"
    ], props.fillContainer ? '100%' : data.daySize, props.fillContainer ? '100%' : data.daySize);
};
var $3257a779ba750b21$var$responsiveDaySizeStyle = function responsiveDaySizeStyle(props) {
    var breakpoint = props.theme.global.size[props.sizeProp];
    var data = props.theme.calendar[props.sizeProp];
    return (0, $cdf517d38d72c2bc$export$2180d12f0a299a89)({
        value: breakpoint
    }, "\n      width: 100%;\n      max-width: " + data.daySize + ";\n      height: auto;\n      aspect-ratio: 1;\n    ", true);
};
var $3257a779ba750b21$var$dayStyle = function dayStyle(props) {
    var backgroundObj;
    var colorObj;
    if (props.isSelected) {
        var _props$theme$calendar8, _props$theme$calendar9;
        backgroundObj = ((_props$theme$calendar8 = props.theme.calendar.day) == null || (_props$theme$calendar8 = _props$theme$calendar8.selected) == null ? void 0 : _props$theme$calendar8.background) || 'control';
        colorObj = (_props$theme$calendar9 = props.theme.calendar.day) == null || (_props$theme$calendar9 = _props$theme$calendar9.selected) == null ? void 0 : _props$theme$calendar9.color;
    } else if (props.inRange) {
        var _props$theme$calendar0, _props$theme$calendar1, _props$theme$calendar10, _props$theme$calendar11;
        // for backwards compatability, only apply this if caller hasn't specified
        // range specific rounding
        // if they have, background will be applied to StyledDayContainer
        backgroundObj = !((_props$theme$calendar0 = props.theme.calendar) != null && (_props$theme$calendar0 = _props$theme$calendar0[props.sizeProp]) != null && (_props$theme$calendar0 = _props$theme$calendar0.range) != null && _props$theme$calendar0.round) && !((_props$theme$calendar1 = props.theme.calendar) != null && (_props$theme$calendar1 = _props$theme$calendar1.medium.range) != null && _props$theme$calendar1.round) && (((_props$theme$calendar10 = props.theme.calendar.day) == null || (_props$theme$calendar10 = _props$theme$calendar10.inRange) == null ? void 0 : _props$theme$calendar10.background) || {
            color: 'control',
            opacity: 'weak'
        });
        colorObj = (_props$theme$calendar11 = props.theme.calendar.day) == null || (_props$theme$calendar11 = _props$theme$calendar11.inRange) == null ? void 0 : _props$theme$calendar11.color;
    } else {
        var _props$theme$calendar12, _props$theme$calendar13;
        backgroundObj = (_props$theme$calendar12 = props.theme.calendar.day) == null ? void 0 : _props$theme$calendar12.background;
        colorObj = (_props$theme$calendar13 = props.theme.calendar.day) == null ? void 0 : _props$theme$calendar13.color;
    }
    if (colorObj && !backgroundObj) return "color: " + (0, $11317b0e49e0d157$export$4cde5df63f53f473)(colorObj, props.theme) + ";";
    return (0, $0b4a347e23c22183$export$e43a4f0de05cb7e9)(backgroundObj, props.theme, colorObj);
};
var $3257a779ba750b21$var$dayHoverStyle = function dayHoverStyle(props) {
    var backgroundObj;
    var colorObj;
    if (props.isSelected) {
        var _props$theme$calendar14, _props$theme$calendar15;
        backgroundObj = (_props$theme$calendar14 = props.theme.calendar.day) == null || (_props$theme$calendar14 = _props$theme$calendar14.selected) == null || (_props$theme$calendar14 = _props$theme$calendar14.hover) == null ? void 0 : _props$theme$calendar14.background;
        colorObj = (_props$theme$calendar15 = props.theme.calendar.day) == null || (_props$theme$calendar15 = _props$theme$calendar15.selected) == null || (_props$theme$calendar15 = _props$theme$calendar15.hover) == null ? void 0 : _props$theme$calendar15.color;
    } else if (props.inRange) {
        var _props$theme$calendar16, _props$theme$calendar17;
        backgroundObj = (_props$theme$calendar16 = props.theme.calendar.day) == null || (_props$theme$calendar16 = _props$theme$calendar16.inRange) == null || (_props$theme$calendar16 = _props$theme$calendar16.hover) == null ? void 0 : _props$theme$calendar16.background;
        colorObj = (_props$theme$calendar17 = props.theme.calendar.day) == null || (_props$theme$calendar17 = _props$theme$calendar17.inRange) == null || (_props$theme$calendar17 = _props$theme$calendar17.hover) == null ? void 0 : _props$theme$calendar17.color;
    } else {
        var _props$theme$calendar18, _props$theme$calendar19;
        backgroundObj = (_props$theme$calendar18 = props.theme.calendar.day) == null || (_props$theme$calendar18 = _props$theme$calendar18.hover) == null ? void 0 : _props$theme$calendar18.background;
        colorObj = (_props$theme$calendar19 = props.theme.calendar.day) == null || (_props$theme$calendar19 = _props$theme$calendar19.hover) == null ? void 0 : _props$theme$calendar19.color;
    }
    if (colorObj && !backgroundObj) return "color: " + (0, $11317b0e49e0d157$export$4cde5df63f53f473)(colorObj, props.theme) + ";";
    return (0, $0b4a347e23c22183$export$e43a4f0de05cb7e9)(backgroundObj, props.theme, colorObj);
};
var $3257a779ba750b21$var$dayFontStyle = function dayFontStyle(props) {
    var fontWeight;
    if (props.isSelected) {
        var _props$theme$calendar20;
        fontWeight = (_props$theme$calendar20 = props.theme.calendar.day) == null || (_props$theme$calendar20 = _props$theme$calendar20.selected) == null || (_props$theme$calendar20 = _props$theme$calendar20.font) == null ? void 0 : _props$theme$calendar20.weight;
    } else if (props.inRange) {
        var _props$theme$calendar21;
        fontWeight = (_props$theme$calendar21 = props.theme.calendar.day) == null || (_props$theme$calendar21 = _props$theme$calendar21.inRange) == null || (_props$theme$calendar21 = _props$theme$calendar21.font) == null ? void 0 : _props$theme$calendar21.weight;
    }
    return fontWeight && "font-weight: " + fontWeight + ";";
};
var $3257a779ba750b21$export$4fe9184bd47dbe20 = (0, $iA1nz.default).div.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledCalendar__StyledDay",
    componentId: "sc-1y4xhmp-6"
})([
    "display:flex;justify-content:center;align-items:center;color:",
    ";",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], function(props) {
    var _props$theme$calendar22;
    return (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.otherMonth ? ((_props$theme$calendar22 = props.theme.calendar) == null || (_props$theme$calendar22 = _props$theme$calendar22.day) == null || (_props$theme$calendar22 = _props$theme$calendar22.adjacent) == null ? void 0 : _props$theme$calendar22.color) || 'text-xweak' : 'text-strong', props.theme);
}, function(props) {
    return $3257a779ba750b21$var$daySizeStyle(props);
}, function(props) {
    return props.responsive && $3257a779ba750b21$var$responsiveDaySizeStyle(props);
}, function(props) {
    return $3257a779ba750b21$var$dayStyle(props);
}, function(props) {
    return $3257a779ba750b21$var$dayFontStyle(props);
}, function(props) {
    var _props$theme$calendar23, _props$theme$calendar24;
    // fallback to medium if no size-specific styles
    var round = ((_props$theme$calendar23 = props.theme.calendar) == null || (_props$theme$calendar23 = _props$theme$calendar23[props.sizeProp]) == null || (_props$theme$calendar23 = _props$theme$calendar23.day) == null ? void 0 : _props$theme$calendar23.round) || ((_props$theme$calendar24 = props.theme.calendar) == null || (_props$theme$calendar24 = _props$theme$calendar24.medium) == null || (_props$theme$calendar24 = _props$theme$calendar24.day) == null ? void 0 : _props$theme$calendar24.round);
    return round && (0, $73ba8e2d301b823f$export$98483643daf52539)(round, props.responsive, props.theme);
}, function(props) {
    return props.hover && !props.disabledProp && $3257a779ba750b21$var$dayHoverStyle(props);
}, function(props) {
    return(// when theme uses kind Buttons, since we use children for Button,
    // we have to special case how we handle disabled days here
    props.disabledProp && props.theme.button["default"] && (0, $73ba8e2d301b823f$export$73d7bd5e5b0271ce)(props.theme.button.disabled, props.theme));
}, function(props) {
    return props.theme.calendar && props.theme.calendar.day && props.theme.calendar.day.extend;
});


// Utility functions for the Calendar.
// Just what's needed to avoid having to include a dependency like momentjs.
var $123971ce5b8991ad$var$DAY_MILLISECONDS = 86400000;
var $123971ce5b8991ad$export$dd412b56f1e4d8aa = function addDays(date, days) {
    var result = new Date(date.getTime() + $123971ce5b8991ad$var$DAY_MILLISECONDS * days);
    // Deal with crossing the daylight savings time boundary,
    // where adding a day's worth when the time is midnight results in
    // being a day off.
    var hourDelta = result.getHours() - date.getHours();
    // At this point, hourDelta is typically 0 (normal day),
    // +23 (November daylight saving), or -23 (March Daylight saving)
    // depending on which side of the switch we are on.
    // Convert so that hourDelta is either +1 or -1.
    if (hourDelta === 23) hourDelta -= 24;
    else if (hourDelta === -23) hourDelta += 24;
    result.setHours(result.getHours() - hourDelta);
    return result;
};
var $123971ce5b8991ad$export$8f6ba218ec818063 = function subtractDays(date, days) {
    return $123971ce5b8991ad$export$dd412b56f1e4d8aa(date, -days);
};
var $123971ce5b8991ad$export$17c93e242b2d3a22 = function addMonths(date, months) {
    var result = new Date(date);
    var years = Math.floor((date.getMonth() + months) / 12);
    result.setFullYear(date.getFullYear() + years);
    var targetMonth = (date.getMonth() + months) % 12;
    result.setMonth(targetMonth < 0 ? 12 + targetMonth : targetMonth);
    return result;
};
var $123971ce5b8991ad$export$cde1cfadc1403459 = function subtractMonths(date, months) {
    return $123971ce5b8991ad$export$17c93e242b2d3a22(date, -months);
};
var $123971ce5b8991ad$export$a5a3b454ada2268e = function startOfMonth(date) {
    var result = new Date(date);
    result.setDate(1);
    return result;
};
var $123971ce5b8991ad$export$a2258d9c4118825c = function endOfMonth(date) {
    var result = $123971ce5b8991ad$export$17c93e242b2d3a22(date, 1);
    result.setDate(0);
    return result;
};
var $123971ce5b8991ad$export$803c6c0e435ba32b = function sameDay(date1, date2) {
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
};
var $123971ce5b8991ad$export$b43b14f05e74d2a6 = function sameDayOrAfter(date1, date2) {
    return date1.getFullYear() > date2.getFullYear() || date1.getFullYear() === date2.getFullYear() && (date1.getMonth() > date2.getMonth() || date1.getMonth() === date2.getMonth() && date1.getDate() >= date2.getDate());
};
var $123971ce5b8991ad$export$fc01259e21cb1793 = function sameDayOrBefore(date1, date2) {
    return date1.getFullYear() < date2.getFullYear() || date1.getFullYear() === date2.getFullYear() && (date1.getMonth() < date2.getMonth() || date1.getMonth() === date2.getMonth() && date1.getDate() <= date2.getDate());
};
var $123971ce5b8991ad$export$564c235164ed6ce8 = function daysApart(date1, date2) {
    return Math.floor((date1.getTime() - date2.getTime()) / $123971ce5b8991ad$var$DAY_MILLISECONDS);
};
var $123971ce5b8991ad$export$5e6ff6e7b7b4e53b = function betweenDates(date, dates) {
    var result;
    if (dates) {
        var _ref = Array.isArray(dates) ? dates.map(function(d) {
            return d ? new Date(d) : undefined;
        }) : [
            dates,
            undefined
        ], from = _ref[0], to = _ref[1];
        if (from && $123971ce5b8991ad$export$803c6c0e435ba32b(date, from) || to && $123971ce5b8991ad$export$803c6c0e435ba32b(date, to)) result = 2;
        else if (from && $123971ce5b8991ad$export$b43b14f05e74d2a6(date, from) && to && $123971ce5b8991ad$export$fc01259e21cb1793(date, to)) result = 1;
    } else result = 1;
    return result;
};
var $123971ce5b8991ad$export$b4a32babffa865e6 = function getRangePosition(date, dates) {
    var rangePosition;
    if (dates) {
        var _ref2 = Array.isArray(dates) ? dates.map(function(d) {
            return d ? new Date(d) : undefined;
        }) : [
            dates,
            undefined
        ], from = _ref2[0], to = _ref2[1];
        if (from && $123971ce5b8991ad$export$803c6c0e435ba32b(date, from)) rangePosition = 'start';
        else if (to && $123971ce5b8991ad$export$803c6c0e435ba32b(date, to)) rangePosition = 'end';
    }
    return rangePosition;
};
var $123971ce5b8991ad$export$509e5b8f8eb27f5c = function withinDates(date, dates) {
    var result;
    var rangePosition;
    if (dates) {
        if (Array.isArray(dates)) dates.some(function(d) {
            if (d instanceof Date) {
                if ($123971ce5b8991ad$export$803c6c0e435ba32b(date, d)) result = 2;
            } else {
                result = $123971ce5b8991ad$export$5e6ff6e7b7b4e53b(date, d);
                rangePosition = $123971ce5b8991ad$export$b4a32babffa865e6(date, d);
            }
            return result;
        });
        else if ($123971ce5b8991ad$export$803c6c0e435ba32b(date, dates)) result = 2;
    }
    return [
        result,
        rangePosition
    ];
};
var $123971ce5b8991ad$export$440bcced20c33405 = function handleOffset(date) {
    var normalizedDate = new Date(date);
    var offset = normalizedDate.getTimezoneOffset();
    var hour = normalizedDate.getHours();
    // add back offset
    normalizedDate.setHours(hour, offset < 0 ? -offset : offset);
    return normalizedDate;
};


var $97dce9bdc58ca202$export$c739ab4d3d4926aa = function setHoursWithOffset(date) {
    var newDate = new Date(date);
    if ((date == null ? void 0 : date.indexOf('T')) === -1) {
        var offset = newDate.getTimezoneOffset();
        var hour = newDate.getHours();
        newDate.setHours(hour, offset < 0 ? -offset : offset);
    }
    return newDate;
};



var $f1631bb79f7b96e6$var$_excluded = [
    "activeDate",
    "animate",
    "bounds",
    "children",
    "date",
    "dates",
    "daysOfWeek",
    "disabled",
    "initialFocus",
    "fill",
    "firstDayOfWeek",
    "header",
    "level",
    "locale",
    "messages",
    "onReference",
    "onSelect",
    "range",
    "reference",
    "responsive",
    "showAdjacentDays",
    "size",
    "timestamp"
], $f1631bb79f7b96e6$var$_excluded2 = [
    "container"
];
function $f1631bb79f7b96e6$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $f1631bb79f7b96e6$var$_extends() {
    return $f1631bb79f7b96e6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f1631bb79f7b96e6$var$_extends.apply(null, arguments);
}
var $f1631bb79f7b96e6$var$getLocaleString = function getLocaleString(value, locale) {
    return value == null ? void 0 : value.toLocaleDateString(locale, {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    });
};
var $f1631bb79f7b96e6$var$currentlySelectedString = function currentlySelectedString(value, locale) {
    var selected;
    if (value instanceof Date) selected = "Currently selected " + $f1631bb79f7b96e6$var$getLocaleString(value, locale) + ";";
    else if (value != null && value.length) selected = "Currently selected " + value.map(function(item) {
        var dates;
        if (!Array.isArray(item)) dates = "" + $f1631bb79f7b96e6$var$getLocaleString(item, locale);
        else {
            var start = item[0] !== undefined ? $f1631bb79f7b96e6$var$getLocaleString(item[0], locale) : 'none';
            var end = item[1] !== undefined ? $f1631bb79f7b96e6$var$getLocaleString(item[1], locale) : 'none';
            dates = start + " through " + end;
        }
        return dates;
    });
    else selected = 'No date selected';
    return selected;
};
// calendar value may be a single date, multiple dates, a range of dates
// supplied as ISOstrings.
var $f1631bb79f7b96e6$var$_normalizeInput = function normalizeInput(dateValue) {
    var result;
    if (dateValue instanceof Date) result = dateValue;
    else if (typeof dateValue === 'string' && dateValue.length) result = (0, $97dce9bdc58ca202$export$c739ab4d3d4926aa)(dateValue);
    else if (Array.isArray(dateValue)) result = dateValue.map(function(d) {
        return $f1631bb79f7b96e6$var$_normalizeInput(d);
    });
    return result;
};
var $f1631bb79f7b96e6$var$_normalizeOutput = function normalizeOutput(dateValue, outputFormat) {
    var result;
    var normalize = function normalize(value) {
        var normalizedValue = value.toISOString();
        if (normalizedValue && outputFormat === 'no timezone') {
            var _handleOffset$toISOSt = (0, $123971ce5b8991ad$export$440bcced20c33405)(normalizedValue).toISOString().split('T');
            normalizedValue = _handleOffset$toISOSt[0];
        }
        return normalizedValue;
    };
    if (dateValue instanceof Date) result = normalize(dateValue);
    else if (typeof dateValue === 'undefined') result = undefined;
    else result = dateValue.map(function(d) {
        return $f1631bb79f7b96e6$var$_normalizeOutput(d, outputFormat);
    });
    return result;
};
// format value to [[]] for internal functions
var $f1631bb79f7b96e6$var$normalizeRange = function normalizeRange(value, activeDate) {
    var range = value;
    if (range instanceof Date) range = activeDate === 'start' ? [
        [
            undefined,
            range
        ]
    ] : [
        [
            range,
            undefined
        ]
    ];
    else if (Array.isArray(range) && !Array.isArray(range[0])) range = [
        range
    ];
    return range;
};
var $f1631bb79f7b96e6$var$getReference = function getReference(reference, onReference, value, activeDate) {
    var nextReference;
    if (reference && onReference) // controlled component, so use the reference provided
    nextReference = reference;
    else if (value) {
        if (Array.isArray(value)) {
            if (value[0] instanceof Date) {
                // if we just selected an end date, active date will be 'start'
                // and we should set the reference to the end date
                if (activeDate === 'start' && value[1] instanceof Date) nextReference = value[1];
                else nextReference = value[0];
            } else if (Array.isArray(value[0])) {
                // if we just selected an end date, active date will be 'start'
                // and we should set the reference to the end date
                if (activeDate === 'start' && value[0][1]) // eslint-disable-next-line prefer-destructuring
                nextReference = value[0][1];
                else nextReference = value[0][0] ? value[0][0] : value[0][1];
            } else {
                nextReference = new Date();
                nextReference.setHours(0, 0, 0, 0);
            }
        } else nextReference = value;
    } else if (reference) nextReference = reference;
    else {
        nextReference = new Date();
        nextReference.setHours(0, 0, 0, 0);
    }
    return nextReference;
};
var $f1631bb79f7b96e6$var$buildDisplayBounds = function buildDisplayBounds(reference, firstDayOfWeek) {
    var start = new Date(reference);
    start.setDate(1); // first of month
    // In case Sunday is the first day of the month, and the user asked for Monday
    // to be the first day of the week, then we need to include Sunday and six
    // days prior.
    start = start.getDay() === 0 && firstDayOfWeek === 1 ? start = (0, $123971ce5b8991ad$export$8f6ba218ec818063)(start, 6) : // beginning of week
    start = (0, $123971ce5b8991ad$export$8f6ba218ec818063)(start, start.getDay() - firstDayOfWeek);
    var end = (0, $123971ce5b8991ad$export$dd412b56f1e4d8aa)(start, 42); // 5 weeks to end of week
    return [
        start,
        end
    ];
};
var $f1631bb79f7b96e6$var$monthBounds = function monthBounds(reference) {
    var start = new Date(reference);
    start.setDate(1); // first of month
    var end = (0, $123971ce5b8991ad$export$a2258d9c4118825c)(start);
    return [
        start,
        end
    ];
};
var $f1631bb79f7b96e6$var$disabledCalendarPreviousMonthButton = function disabledCalendarPreviousMonthButton(date, reference, bounds) {
    if (!bounds) return false;
    var lastBound = new Date(bounds[1]);
    return !(0, $123971ce5b8991ad$export$fc01259e21cb1793)(lastBound, reference) && !(0, $123971ce5b8991ad$export$5e6ff6e7b7b4e53b)(date, bounds);
};
var $f1631bb79f7b96e6$var$disabledCalendarNextMonthButton = function disabledCalendarNextMonthButton(date, reference, bounds) {
    if (!bounds) return false;
    var firstBound = new Date(bounds[0]);
    return !(0, $123971ce5b8991ad$export$b43b14f05e74d2a6)(firstBound, reference) && !(0, $123971ce5b8991ad$export$5e6ff6e7b7b4e53b)(date, bounds);
};
var $f1631bb79f7b96e6$export$c0c99f9031a45b3 = function getOutputFormat(dates) {
    if (typeof dates === 'string' && (dates == null ? void 0 : dates.indexOf('T')) === -1) return 'no timezone';
    if (Array.isArray(dates)) return $f1631bb79f7b96e6$export$c0c99f9031a45b3(dates[0]);
    return 'date timezone';
};
var $f1631bb79f7b96e6$var$millisecondsPerYear = 31557600000;
var $f1631bb79f7b96e6$var$CalendarDay = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var activeProp = _ref.activeProp, children = _ref.children, day = _ref.day, disabledProp = _ref.disabledProp, fill = _ref.fill, size = _ref.size, isInRange = _ref.isInRange, isSelected = _ref.isSelected, otherMonth = _ref.otherMonth, rangePosition = _ref.rangePosition, _ref$buttonProps = _ref.buttonProps, buttonProps = _ref$buttonProps === void 0 ? {} : _ref$buttonProps, responsive = _ref.responsive;
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3257a779ba750b21$export$ffce625ce693a981), {
        role: "gridcell",
        "aria-selected": isSelected,
        inRange: isInRange,
        isSelected: isSelected,
        rangePosition: rangePosition,
        sizeProp: size,
        fillContainer: fill,
        responsive: responsive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3257a779ba750b21$export$2be68822f46d2c34), $f1631bb79f7b96e6$var$_extends({
        "aria-disabled": disabledProp,
        disabledProp: disabledProp,
        fill: fill,
        plain: true,
        tabIndex: (activeProp == null ? void 0 : activeProp.getTime()) === (day == null ? void 0 : day.getTime()) ? 0 : -1,
        responsive: responsive
    }, buttonProps, {
        ref: (activeProp == null ? void 0 : activeProp.getTime()) === (day == null ? void 0 : day.getTime()) ? ref : undefined
    }), function(_ref2) {
        var hover = _ref2.hover;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3257a779ba750b21$export$4fe9184bd47dbe20), $f1631bb79f7b96e6$var$_extends({
            disabledProp: disabledProp,
            hover: hover,
            inRange: isInRange,
            isSelected: isSelected,
            otherMonth: otherMonth,
            sizeProp: size,
            fillContainer: fill,
            responsive: responsive
        }, passThemeFlag), children);
    }));
});
var $f1631bb79f7b96e6$var$CalendarCustomDay = function CalendarCustomDay(_ref3) {
    var ariaSelected = _ref3['aria-selected'], children = _ref3.children, fill = _ref3.fill, size = _ref3.size, buttonProps = _ref3.buttonProps, responsive = _ref3.responsive;
    if (!buttonProps) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3257a779ba750b21$export$ffce625ce693a981), {
        "aria-selected": ariaSelected,
        role: "gridcell",
        sizeProp: size,
        fillContainer: fill,
        responsive: responsive
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3257a779ba750b21$export$ffce625ce693a981), {
        "aria-selected": ariaSelected,
        role: "gridcell",
        sizeProp: size,
        fillContainer: fill,
        responsive: responsive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3257a779ba750b21$export$2be68822f46d2c34), $f1631bb79f7b96e6$var$_extends({
        fill: fill,
        responsive: responsive
    }, buttonProps), children));
};
var $f1631bb79f7b96e6$export$e1aef45b828286de = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref4, ref) {
    var activeDateProp = _ref4.activeDate, _ref4$animate = _ref4.animate, animate = _ref4$animate === void 0 ? true : _ref4$animate, boundsProp = _ref4.bounds, children = _ref4.children, dateProp = _ref4.date, datesProp = _ref4.dates, daysOfWeek = _ref4.daysOfWeek, disabled = _ref4.disabled, initialFocus = _ref4.initialFocus, fill = _ref4.fill, _ref4$firstDayOfWeek = _ref4.firstDayOfWeek, firstDayOfWeek = _ref4$firstDayOfWeek === void 0 ? 0 : _ref4$firstDayOfWeek, header = _ref4.header, level = _ref4.level, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? 'en-US' : _ref4$locale, messages = _ref4.messages, onReference = _ref4.onReference, onSelect = _ref4.onSelect, range = _ref4.range, referenceProp = _ref4.reference, _ref4$responsive = _ref4.responsive, responsiveProp = _ref4$responsive === void 0 ? true : _ref4$responsive, _ref4$showAdjacentDay = _ref4.showAdjacentDays, showAdjacentDays = _ref4$showAdjacentDay === void 0 ? true : _ref4$showAdjacentDay, _ref4$size = _ref4.size, size = _ref4$size === void 0 ? 'medium' : _ref4$size, timestampProp = _ref4.timestamp, rest = $f1631bb79f7b96e6$var$_objectWithoutPropertiesLoose(_ref4, $f1631bb79f7b96e6$var$_excluded);
    var _useThemeValue2 = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue2.theme, passThemeFlag = _useThemeValue2.passThemeFlag;
    var announce = (0, $2xPiy.useContext)((0, $c8f61343d2547c6a$export$dcc8f4bff0d51f50));
    var _useContext = (0, $2xPiy.useContext)((0, $f1ad7bf122eed3b0$export$b060d577040138d8)), format = _useContext.format;
    // If fill is true the responsive behavior isn't needed.
    var responsive = responsiveProp && !fill;
    // set activeDate when caller changes it, allows us to change
    // it internally too
    var _useState = (0, $2xPiy.useState)(dateProp && typeof dateProp === 'string' && range ? 'end' : 'start'), activeDate = _useState[0], setActiveDate = _useState[1];
    (0, $2xPiy.useEffect)(function() {
        if (activeDateProp) setActiveDate(activeDateProp);
    }, [
        activeDateProp
    ]);
    var _useState2 = (0, $2xPiy.useState)($f1631bb79f7b96e6$var$_normalizeInput(dateProp || datesProp)), value = _useState2[0], setValue = _useState2[1];
    (0, $2xPiy.useEffect)(function() {
        var val = dateProp || datesProp;
        setValue($f1631bb79f7b96e6$var$_normalizeInput(val));
    }, [
        dateProp,
        datesProp
    ]);
    var _useState3 = (0, $2xPiy.useState)($f1631bb79f7b96e6$var$getReference($f1631bb79f7b96e6$var$_normalizeInput(referenceProp), onReference, value, activeDate)), reference = _useState3[0], setReference = _useState3[1];
    (0, $2xPiy.useEffect)(function() {
        setReference($f1631bb79f7b96e6$var$getReference($f1631bb79f7b96e6$var$_normalizeInput(referenceProp), onReference, value, activeDate));
    }, [
        referenceProp,
        onReference,
        value,
        activeDate
    ]);
    var _useState4 = (0, $2xPiy.useState)($f1631bb79f7b96e6$export$c0c99f9031a45b3(dateProp || datesProp)), outputFormat = _useState4[0], setOutputFormat = _useState4[1];
    (0, $2xPiy.useEffect)(function() {
        setOutputFormat($f1631bb79f7b96e6$export$c0c99f9031a45b3(dateProp || datesProp));
    }, [
        dateProp,
        datesProp
    ]);
    // normalize bounds
    var _useState5 = (0, $2xPiy.useState)(boundsProp), bounds = _useState5[0], setBounds = _useState5[1];
    (0, $2xPiy.useEffect)(function() {
        if (boundsProp) setBounds(boundsProp);
        else setBounds(undefined);
    }, [
        boundsProp
    ]);
    // calculate the bounds we display based on the reference
    var _useState6 = (0, $2xPiy.useState)($f1631bb79f7b96e6$var$buildDisplayBounds(reference, firstDayOfWeek)), displayBounds = _useState6[0], setDisplayBounds = _useState6[1];
    var _useState7 = (0, $2xPiy.useState)(), targetDisplayBounds = _useState7[0], setTargetDisplayBounds = _useState7[1];
    var _useState8 = (0, $2xPiy.useState)(), slide = _useState8[0], setSlide = _useState8[1];
    var _useState9 = (0, $2xPiy.useState)(), animating = _useState9[0], setAnimating = _useState9[1];
    // When the reference changes, we need to update the displayBounds.
    // This is easy when we aren't animating. If we are animating,
    // we temporarily increase the displayBounds to be the union of the old
    // and new ones and set slide to drive the animation. We keep track
    // of where we are heading via targetDisplayBounds. When the animation
    // finishes, we prune displayBounds down to where we are headed and
    // clear the slide and targetDisplayBounds.
    (0, $2xPiy.useEffect)(function() {
        var nextDisplayBounds = $f1631bb79f7b96e6$var$buildDisplayBounds(reference, firstDayOfWeek);
        // Checks if the difference between the current and next DisplayBounds is
        // greater than a year. If that's the case, calendar should update without
        // animation.
        if (nextDisplayBounds[0].getTime() !== displayBounds[0].getTime() && nextDisplayBounds[1].getTime() !== displayBounds[1].getTime()) {
            var diffBoundsAboveYear = false;
            if (nextDisplayBounds[0].getTime() < displayBounds[0].getTime()) {
                if (displayBounds[0].getTime() - nextDisplayBounds[0].getTime() > $f1631bb79f7b96e6$var$millisecondsPerYear) diffBoundsAboveYear = true;
            } else if (nextDisplayBounds[1].getTime() > displayBounds[1].getTime()) {
                if (nextDisplayBounds[1].getTime() - displayBounds[1].getTime() > $f1631bb79f7b96e6$var$millisecondsPerYear) diffBoundsAboveYear = true;
            }
            if (!animate || diffBoundsAboveYear) setDisplayBounds(nextDisplayBounds);
            else setTargetDisplayBounds(nextDisplayBounds);
        }
    }, [
        animate,
        firstDayOfWeek,
        reference,
        displayBounds
    ]);
    (0, $2xPiy.useEffect)(function() {
        // if the reference timezone has changed (e.g., controlled component),
        // both ends of the displayBounds should inherit that new timestamp
        if (targetDisplayBounds) {
            if (targetDisplayBounds[0].getTime() < displayBounds[0].getTime() || targetDisplayBounds[1].getTime() > displayBounds[1].getTime()) setDisplayBounds([
                targetDisplayBounds[0],
                targetDisplayBounds[1]
            ]);
            if (targetDisplayBounds[0].getTime() < displayBounds[0].getTime()) // only animate if the duration is within a year
            {
                if (displayBounds[0].getTime() - targetDisplayBounds[0].getTime() < $f1631bb79f7b96e6$var$millisecondsPerYear && (0, $123971ce5b8991ad$export$564c235164ed6ce8)(displayBounds[0], targetDisplayBounds[0])) {
                    setSlide({
                        direction: 'down',
                        weeks: (0, $123971ce5b8991ad$export$564c235164ed6ce8)(displayBounds[0], targetDisplayBounds[0]) / 7
                    });
                    setAnimating(true);
                }
            } else if (targetDisplayBounds[1].getTime() > displayBounds[1].getTime()) {
                if (targetDisplayBounds[1].getTime() - displayBounds[1].getTime() < $f1631bb79f7b96e6$var$millisecondsPerYear && (0, $123971ce5b8991ad$export$564c235164ed6ce8)(targetDisplayBounds[1], displayBounds[1])) {
                    setSlide({
                        direction: 'up',
                        weeks: (0, $123971ce5b8991ad$export$564c235164ed6ce8)(targetDisplayBounds[1], displayBounds[1]) / 7
                    });
                    setAnimating(true);
                }
            }
            return undefined;
        }
        setSlide(undefined);
        return undefined;
    }, [
        animating,
        displayBounds,
        targetDisplayBounds
    ]);
    // Last step in updating the displayBounds. Allows for pruning
    // displayBounds and cleaning up states to occur after animation.
    (0, $2xPiy.useEffect)(function() {
        if (animating && targetDisplayBounds) {
            // Wait for animation to finish before cleaning up.
            var timer = setTimeout(function() {
                setDisplayBounds(targetDisplayBounds);
                setTargetDisplayBounds(undefined);
                setSlide(undefined);
                setAnimating(false);
            }, 400 // Empirically determined.
            );
            return function() {
                return clearTimeout(timer);
            };
        }
        return undefined;
    }, [
        animating,
        targetDisplayBounds
    ]);
    // We have to deal with reference being the end of a month with more
    // days than the month we are changing to. So, we always set reference
    // to the first of the month before changing the month.
    var previousMonth = (0, $2xPiy.useMemo)(function() {
        return (0, $123971ce5b8991ad$export$a2258d9c4118825c)((0, $123971ce5b8991ad$export$cde1cfadc1403459)((0, $123971ce5b8991ad$export$a5a3b454ada2268e)(reference), 1));
    }, [
        reference
    ]);
    var nextMonth = (0, $2xPiy.useMemo)(function() {
        return (0, $123971ce5b8991ad$export$a5a3b454ada2268e)((0, $123971ce5b8991ad$export$17c93e242b2d3a22)((0, $123971ce5b8991ad$export$a5a3b454ada2268e)(reference), 1));
    }, [
        reference
    ]);
    var initialFocusDate = showAdjacentDays ? new Date(displayBounds[0]) : (0, $123971ce5b8991ad$export$a5a3b454ada2268e)(reference);
    var _useState0 = (0, $2xPiy.useState)(), focus = _useState0[0], setFocus = _useState0[1];
    var _useState1 = (0, $2xPiy.useState)(initialFocusDate), active = _useState1[0], setActive = _useState1[1];
    var focusableDateRef = (0, $2xPiy.useRef)(undefined);
    (0, $2xPiy.useEffect)(function() {
        if (focusableDateRef != null && focusableDateRef.current && initialFocus === 'days') focusableDateRef.current.focus();
    }, [
        initialFocus,
        focusableDateRef
    ]);
    var handleReference = (0, $2xPiy.useCallback)(function(nextReference) {
        setReference(nextReference);
        if (onReference) onReference(nextReference.toISOString());
    }, [
        onReference
    ]);
    var changeReference = (0, $2xPiy.useCallback)(function(nextReference) {
        if ((0, $123971ce5b8991ad$export$5e6ff6e7b7b4e53b)(nextReference, bounds)) handleReference(nextReference);
    }, [
        handleReference,
        bounds
    ]);
    var changeCalendarMonth = function changeCalendarMonth(messageId, newMonth) {
        handleReference(newMonth);
        var referenceStartOfMonth = (0, $123971ce5b8991ad$export$a5a3b454ada2268e)(reference);
        var firstOfMonth = new Date(newMonth.getFullYear(), newMonth.getMonth(), 1, referenceStartOfMonth.getHours(), referenceStartOfMonth.getMinutes(), referenceStartOfMonth.getSeconds());
        setActive(firstOfMonth);
        announce(format({
            id: messageId,
            messages: messages,
            values: {
                date: newMonth.toLocaleDateString(locale, {
                    month: 'long',
                    year: 'numeric'
                })
            }
        }));
    };
    var handleRange = (0, $2xPiy.useCallback)(function(selectedDate) {
        var _priorRange$, _priorRange$2;
        var result;
        var nextActiveDate = activeDate;
        var priorRange = $f1631bb79f7b96e6$var$normalizeRange(value, activeDate);
        // deselect when date clicked was the start/end of the range
        if (selectedDate.getTime() === (priorRange == null || (_priorRange$ = priorRange[0]) == null || (_priorRange$ = _priorRange$[0]) == null ? void 0 : _priorRange$.getTime())) {
            result = [
                [
                    undefined,
                    priorRange[0][1]
                ]
            ];
            nextActiveDate = 'start';
        } else if (selectedDate.getTime() === (priorRange == null || (_priorRange$2 = priorRange[0]) == null || (_priorRange$2 = _priorRange$2[1]) == null ? void 0 : _priorRange$2.getTime())) {
            result = [
                [
                    priorRange[0][0],
                    undefined
                ]
            ];
            nextActiveDate = 'end';
        } else if (activeDate === 'start') {
            if (!priorRange) result = [
                [
                    selectedDate,
                    undefined
                ]
            ];
            else if (!priorRange[0][1]) result = [
                [
                    selectedDate,
                    priorRange[0][1]
                ]
            ];
            else if (selectedDate.getTime() < priorRange[0][1].getTime()) result = [
                [
                    selectedDate,
                    priorRange[0][1]
                ]
            ];
            else if (selectedDate.getTime() > priorRange[0][1].getTime()) result = [
                [
                    selectedDate,
                    undefined
                ]
            ];
            nextActiveDate = 'end';
        } else if (!priorRange) {
            result = [
                [
                    undefined,
                    selectedDate
                ]
            ];
            nextActiveDate = 'start';
        } else if (selectedDate.getTime() < priorRange[0][0].getTime()) {
            result = [
                [
                    selectedDate,
                    undefined
                ]
            ];
            nextActiveDate = 'end';
        } else if (selectedDate.getTime() > priorRange[0][0].getTime()) {
            result = [
                [
                    priorRange[0][0],
                    selectedDate
                ]
            ];
            nextActiveDate = 'start';
        }
        // If no dates selected, always return undefined; else format
        // result according to specified range value.
        if (result[0].includes(undefined)) {
            if (range === 'array') result = !result[0][0] && !result[0][1] ? undefined : result;
            else result = result[0].find(function(d) {
                return d !== undefined;
            });
        }
        setActiveDate(nextActiveDate);
        setValue(result);
        return [
            result,
            nextActiveDate
        ];
    }, [
        activeDate,
        value,
        range
    ]);
    var selectDate = (0, $2xPiy.useCallback)(function(selectedDate) {
        // If no onSelect prop is provided, the calendar should be read-only
        if (!onSelect) return;
        var nextValue;
        var nextActiveDate;
        var details = {};
        if (range || Array.isArray(value == null ? void 0 : value[0])) {
            var _handleRange = handleRange(selectedDate);
            nextValue = _handleRange[0];
            nextActiveDate = _handleRange[1];
            details.activeDate = nextActiveDate;
        } else nextValue = selectedDate;
        if (onSelect) {
            nextValue = $f1631bb79f7b96e6$var$_normalizeOutput(nextValue, outputFormat);
            onSelect(nextValue, details);
        }
    }, [
        handleRange,
        onSelect,
        outputFormat,
        range,
        value
    ]);
    var onClick = function onClick(selectedDate) {
        selectDate(selectedDate);
        announce("Selected " + $f1631bb79f7b96e6$var$getLocaleString(selectedDate, locale), 'assertive');
        setActive(selectedDate);
    };
    var renderCalendarHeader = function renderCalendarHeader() {
        var _theme$calendar$size;
        var PreviousIcon = size === 'small' ? theme.calendar.icons.small.previous : theme.calendar.icons.previous;
        var NextIcon = size === 'small' ? theme.calendar.icons.small.next : theme.calendar.icons.next;
        var monthAndYear = reference.toLocaleDateString(locale, {
            month: 'long',
            year: 'numeric'
        });
        // theme.calendar.heading.level should be removed in v3 of grommet
        // theme.calendar[size].title should be used instead
        var headingLevel;
        if (level !== undefined) headingLevel = level;
        else if (size === 'small') headingLevel = theme.calendar.heading && theme.calendar.heading.level || 4;
        else headingLevel = (theme.calendar.heading && theme.calendar.heading.level || 4) - 1;
        var _ref5 = ((_theme$calendar$size = theme.calendar[size]) == null ? void 0 : _theme$calendar$size.title) || undefined, containerTheme = _ref5.container, textTheme = $f1631bb79f7b96e6$var$_objectWithoutPropertiesLoose(_ref5, $f1631bb79f7b96e6$var$_excluded2);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            direction: "row",
            justify: "between",
            align: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $74308ae79a3739df$export$8b251419efc915eb), {
            flex: true,
            pad: containerTheme.pad
        }, Object.keys(textTheme).length !== 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), textTheme, monthAndYear) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $e81502354812067e$export$a8a3e93435678ff9), {
            level: headingLevel,
            size: size,
            margin: "none",
            overflowWrap: "normal"
        }, monthAndYear)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            flex: false,
            direction: "row",
            align: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
            a11yTitle: format({
                id: 'calendar.previous',
                messages: messages,
                values: {
                    date: previousMonth.toLocaleDateString(locale, {
                        month: 'long',
                        year: 'numeric'
                    })
                }
            }),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(PreviousIcon, {
                size: size !== 'small' ? size : undefined
            }),
            disabled: $f1631bb79f7b96e6$var$disabledCalendarPreviousMonthButton(previousMonth, reference, bounds),
            onClick: function onClick() {
                return changeCalendarMonth('calendar.previousMove', previousMonth);
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
            a11yTitle: format({
                id: 'calendar.next',
                messages: messages,
                values: {
                    date: nextMonth.toLocaleDateString(locale, {
                        month: 'long',
                        year: 'numeric'
                    })
                }
            }),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(NextIcon, {
                size: size !== 'small' ? size : undefined
            }),
            disabled: $f1631bb79f7b96e6$var$disabledCalendarNextMonthButton(nextMonth, reference, bounds),
            onClick: function onClick() {
                return changeCalendarMonth('calendar.nextMove', nextMonth);
            }
        })));
    };
    var renderDaysOfWeek = function renderDaysOfWeek() {
        var day = new Date(displayBounds[0]);
        var days = [];
        while(days.length < 7){
            days.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3257a779ba750b21$export$ffce625ce693a981), {
                role: "gridcell",
                key: days.length,
                sizeProp: size,
                fillContainer: fill,
                responsive: responsive
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3257a779ba750b21$export$4fe9184bd47dbe20), {
                sizeProp: size,
                fillContainer: fill,
                responsive: responsive
            }, day.toLocaleDateString(locale, {
                weekday: 'narrow'
            }))));
            day = (0, $123971ce5b8991ad$export$dd412b56f1e4d8aa)(day, 1);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3257a779ba750b21$export$5db4823d38c0569f), {
            role: "row"
        }, days);
    };
    var weeks = [];
    var day = new Date(displayBounds[0]);
    var days;
    var firstDayInMonth;
    var blankWeek = false;
    var _loop = function _loop() {
        if (day.getDay() === firstDayOfWeek) {
            if (days) weeks.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3257a779ba750b21$export$5db4823d38c0569f), {
                role: "row",
                key: day.getTime(),
                fillContainer: fill
            }, days));
            days = [];
        }
        var otherMonth = day.getMonth() !== reference.getMonth();
        if (!showAdjacentDays && otherMonth) {
            days.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3257a779ba750b21$export$ffce625ce693a981), {
                key: day.getTime(),
                sizeProp: size,
                fillContainer: fill,
                responsive: responsive
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3257a779ba750b21$export$4fe9184bd47dbe20), {
                sizeProp: size,
                fillContainer: fill,
                responsive: responsive
            })));
            if (weeks.length === 5 && /* If the length days array is less than the current getDate()
      we know that all days in the array are from the next month. */ days.length < day.getDate()) blankWeek = true;
        } else if (/* Do not show adjacent days in 6th row if all days
    fall in the next month */ showAdjacentDays === 'trim' && otherMonth && weeks.length === 5 && /* If the length days array is less than the current getDate()
    we know that all days in the array are from the next month. */ days.length < day.getDate()) {
            blankWeek = true;
            days.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3257a779ba750b21$export$ffce625ce693a981), {
                key: day.getTime(),
                sizeProp: size,
                fillContainer: fill,
                responsive: responsive
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3257a779ba750b21$export$4fe9184bd47dbe20), {
                sizeProp: size,
                fillContainer: fill,
                responsive: responsive
            })));
        } else {
            var dateObject = day;
            // this.dayRefs[dateObject] = React.createRef();
            var selected = false;
            var inRange = false;
            var rangePosition;
            var _withinDates = (0, $123971ce5b8991ad$export$509e5b8f8eb27f5c)(day, range ? $f1631bb79f7b96e6$var$normalizeRange(value, activeDate) : value), selectedState = _withinDates[0];
            if (selectedState === 2) {
                selected = true;
                var _withinDates2 = (0, $123971ce5b8991ad$export$509e5b8f8eb27f5c)(day, range ? $f1631bb79f7b96e6$var$normalizeRange(value, activeDate) : value);
                rangePosition = _withinDates2[1];
            } else if (selectedState === 1) inRange = true;
            var dayDisabled = !!((0, $123971ce5b8991ad$export$509e5b8f8eb27f5c)(day, $f1631bb79f7b96e6$var$_normalizeInput(disabled))[0] || bounds && !(0, $123971ce5b8991ad$export$5e6ff6e7b7b4e53b)(day, $f1631bb79f7b96e6$var$_normalizeInput(bounds)));
            if (!firstDayInMonth && !dayDisabled && day.getMonth() === reference.getMonth()) firstDayInMonth = dateObject;
            if (!children) days.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($f1631bb79f7b96e6$var$CalendarDay, {
                activeProp: active,
                day: day,
                key: day.getTime(),
                disabledProp: dayDisabled,
                buttonProps: {
                    a11yTitle: day.toDateString(),
                    onClick: !dayDisabled && !!onSelect ? function() {
                        return onClick(dateObject);
                    } : function() {}
                },
                isInRange: inRange,
                isSelected: selected,
                otherMonth: day.getMonth() !== reference.getMonth(),
                rangePosition: rangePosition,
                size: size,
                fill: fill,
                ref: focusableDateRef,
                responsive: responsive
            }, day.getDate()));
            else days.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($f1631bb79f7b96e6$var$CalendarCustomDay, {
                key: day.getTime(),
                "aria-selected": selected,
                buttonProps: $f1631bb79f7b96e6$var$_extends({
                    a11yTitle: day.toDateString()
                }, onSelect ? {
                    active: active && active.getTime() === day.getTime(),
                    disabled: dayDisabled,
                    onClick: dayDisabled ? function() {} : function() {
                        return onClick(dateObject);
                    }
                } : {}),
                size: size,
                fill: fill,
                responsive: responsive
            }, children({
                date: day,
                day: day.getDate(),
                isInRange: inRange,
                isSelected: selected
            })));
        }
        day = (0, $123971ce5b8991ad$export$dd412b56f1e4d8aa)(day, 1);
    };
    while(day.getTime() < displayBounds[1].getTime())_loop();
    weeks.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3257a779ba750b21$export$5db4823d38c0569f), {
        role: !blankWeek ? 'row' : undefined,
        key: day.getTime(),
        fillContainer: fill
    }, days));
    // track if we need to focus when element becomes available
    var _useState10 = (0, $2xPiy.useState)(false), needsFocus = _useState10[0], setNeedsFocus = _useState10[1];
    // while the calendar contains focus, and is not animating, set
    // the focus to the active date
    // Focus management effect
    (0, $2xPiy.useEffect)(function() {
        if (!animating && active && focus) setNeedsFocus(true);
    }, [
        animating,
        active,
        focus
    ]);
    (0, $2xPiy.useEffect)(function() {
        if (needsFocus && focusableDateRef != null && focusableDateRef.current) {
            focusableDateRef.current.focus();
            setNeedsFocus(false); // Reset flag after focus
        }
    }, [
        active,
        reference,
        displayBounds,
        needsFocus,
        focusableDateRef
    ]);
    (0, $2xPiy.useEffect)(function() {
        if (bounds && active) {
            var normalizedBounds = $f1631bb79f7b96e6$var$_normalizeInput(bounds);
            if (!(0, $123971ce5b8991ad$export$5e6ff6e7b7b4e53b)(active, normalizedBounds)) {
                var diff1 = Math.abs(active.getTime() - normalizedBounds[0].getTime());
                var diff2 = Math.abs(active.getTime() - normalizedBounds[1].getTime());
                var closerDate = diff1 < diff2 ? 0 : 1;
                setActive(normalizedBounds[closerDate]);
            }
        }
    }, [
        active,
        bounds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3257a779ba750b21$export$2185b0041ed383), $f1631bb79f7b96e6$var$_extends({
        ref: ref,
        sizeProp: size,
        fillContainer: fill,
        responsive: responsive
    }, passThemeFlag, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        fill: fill
    }, header ? header({
        date: reference,
        locale: locale,
        onPreviousMonth: function onPreviousMonth() {
            changeReference(previousMonth);
            setActive(previousMonth);
            announce(format({
                id: 'calendar.previous',
                messages: messages,
                values: {
                    date: previousMonth.toLocaleDateString(locale, {
                        month: 'long',
                        year: 'numeric'
                    })
                }
            }));
        },
        onNextMonth: function onNextMonth() {
            changeReference(nextMonth);
            setActive(nextMonth);
            announce(format({
                id: 'calendar.next',
                messages: messages,
                values: {
                    date: nextMonth.toLocaleDateString(locale, {
                        month: 'long',
                        year: 'numeric'
                    })
                }
            }));
        },
        previousInBound: (0, $123971ce5b8991ad$export$5e6ff6e7b7b4e53b)(previousMonth, bounds),
        nextInBound: (0, $123971ce5b8991ad$export$5e6ff6e7b7b4e53b)(nextMonth, bounds)
    }) : renderCalendarHeader(previousMonth, nextMonth), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        fill: true,
        role: "grid"
    }, daysOfWeek && renderDaysOfWeek(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $168667f04da9206c$export$16e4d70cc375e707), {
        onUp: function onUp(event) {
            var nextActive = (0, $123971ce5b8991ad$export$dd412b56f1e4d8aa)(active, -7);
            event.preventDefault();
            event.stopPropagation(); // so the page doesn't scroll
            if (!!(0, $123971ce5b8991ad$export$5e6ff6e7b7b4e53b)(nextActive, $f1631bb79f7b96e6$var$_normalizeInput(bounds)) || !bounds) {
                setActive(nextActive);
                if (!(0, $123971ce5b8991ad$export$5e6ff6e7b7b4e53b)(nextActive, displayBounds) || !showAdjacentDays && !(0, $123971ce5b8991ad$export$5e6ff6e7b7b4e53b)(nextActive, $f1631bb79f7b96e6$var$monthBounds(reference))) changeReference(nextActive);
            }
        },
        onDown: function onDown(event) {
            var nextActive = (0, $123971ce5b8991ad$export$dd412b56f1e4d8aa)(active, 7);
            event.preventDefault();
            event.stopPropagation(); // so the page doesn't scroll
            if (!!(0, $123971ce5b8991ad$export$5e6ff6e7b7b4e53b)(nextActive, $f1631bb79f7b96e6$var$_normalizeInput(bounds)) || !bounds) {
                setActive(nextActive);
                if (!(0, $123971ce5b8991ad$export$5e6ff6e7b7b4e53b)(nextActive, displayBounds) || !showAdjacentDays && !(0, $123971ce5b8991ad$export$5e6ff6e7b7b4e53b)(nextActive, $f1631bb79f7b96e6$var$monthBounds(reference))) changeReference(nextActive);
            }
        },
        onLeft: function onLeft() {
            var nextActive = (0, $123971ce5b8991ad$export$dd412b56f1e4d8aa)(active, -1);
            if (!!(0, $123971ce5b8991ad$export$5e6ff6e7b7b4e53b)(nextActive, $f1631bb79f7b96e6$var$_normalizeInput(bounds)) || !bounds) {
                setActive(nextActive);
                if (!(0, $123971ce5b8991ad$export$5e6ff6e7b7b4e53b)(nextActive, displayBounds) || !showAdjacentDays && !(0, $123971ce5b8991ad$export$5e6ff6e7b7b4e53b)(nextActive, $f1631bb79f7b96e6$var$monthBounds(reference))) changeReference(nextActive);
            }
        },
        onRight: function onRight() {
            var nextActive = (0, $123971ce5b8991ad$export$dd412b56f1e4d8aa)(active, 1);
            if (!!(0, $123971ce5b8991ad$export$5e6ff6e7b7b4e53b)(nextActive, $f1631bb79f7b96e6$var$_normalizeInput(bounds)) || !bounds) {
                setActive(nextActive);
                if (!(0, $123971ce5b8991ad$export$5e6ff6e7b7b4e53b)(nextActive, displayBounds) || !showAdjacentDays && !(0, $123971ce5b8991ad$export$5e6ff6e7b7b4e53b)(nextActive, $f1631bb79f7b96e6$var$monthBounds(reference))) changeReference(nextActive);
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3257a779ba750b21$export$cc9ae1676f4ee80a), $f1631bb79f7b96e6$var$_extends({
        role: "rowgroup",
        "aria-label": reference.toLocaleDateString(locale, {
            month: 'long',
            year: 'numeric'
        }) + "; " + $f1631bb79f7b96e6$var$currentlySelectedString(value, locale),
        sizeProp: size,
        fillContainer: fill,
        responsive: responsive,
        onFocus: function onFocus() {
            setFocus(true);
        },
        onBlur: function onBlur() {
            setFocus(false);
        }
    }, passThemeFlag), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3257a779ba750b21$export$3d055278a61c3939), $f1631bb79f7b96e6$var$_extends({
        slide: slide,
        sizeProp: size,
        fillContainer: fill
    }, passThemeFlag), weeks))))));
});
$f1631bb79f7b96e6$export$e1aef45b828286de.displayName = 'Calendar';
$f1631bb79f7b96e6$export$e1aef45b828286de.propTypes = (0, $ba59fffdaf612893$export$91040927b1d7b4d1);







var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");







var $iA1nz = parcelRequire("iA1nz");


var $8969445decf5d10b$export$3b982a63cbad39fd = (0, $iA1nz.default).input.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledMaskedInput",
    componentId: "sc-99vkfa-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    " ",
    ";"
], (0, $73ba8e2d301b823f$export$533edcdef9a0af13), function(props) {
    return props.plain && (0, $73ba8e2d301b823f$export$f9510e7ca63c26e5);
}, function(props) {
    return props.icon && (0, $73ba8e2d301b823f$export$cd595fd57f72dbc4);
}, function(props) {
    return props.disabled && (0, $73ba8e2d301b823f$export$adf3fcef8e5e1347)(props.theme.maskedInput.disabled && props.theme.maskedInput.disabled.opacity);
}, function(props) {
    return props.textAlign && (0, $73ba8e2d301b823f$export$4fc8e4871b69e1d6);
}, function(props) {
    return props.theme.maskedInput && props.theme.maskedInput.extend;
});
var $8969445decf5d10b$export$a3c8b952c846e4b1 = (0, $iA1nz.default).div.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledMaskedInput__StyledMaskedInputContainer",
    componentId: "sc-99vkfa-1"
})([
    "position:relative;width:100%;",
    ";"
], function(props) {
    return props.theme.maskedInput && props.theme.maskedInput.container && props.theme.maskedInput.container.extend;
});
var $8969445decf5d10b$export$7c8f159da0dc916 = (0, $iA1nz.default).div.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledMaskedInput__StyledIcon",
    componentId: "sc-99vkfa-2"
})([
    "position:absolute;display:flex;justify:center;top:50%;transform:translateY(-50%);pointer-events:none;",
    ""
], function(props) {
    return props.reverse ? "right: " + (0, $73ba8e2d301b823f$export$c98305b6d8dc560)(props, 'right') + ";" : "left: " + (0, $73ba8e2d301b823f$export$c98305b6d8dc560)(props, 'left') + ";";
});



var $dyr1f = parcelRequire("dyr1f");
var $9a8c666add11e139$var$PropType = {};
$9a8c666add11e139$var$PropType = {
    a11yTitle: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    dropHeight: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    dropProps: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).element,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    focusIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    mask: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        length: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number)
        ]),
        fixed: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        options: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number
        ])),
        restrictToOptions: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        regexp: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({}) // RegExp
    })),
    reverse: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            'xxlarge',
            '2xl',
            '3xl',
            '4xl',
            '5xl',
            '6xl'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    textAlign: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'start',
        'center',
        'end'
    ]),
    value: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number
    ])
};
var $9a8c666add11e139$export$2bbcb24fb0cd855c = $9a8c666add11e139$var$PropType;



var $d76f119224a6c3c6$var$_excluded = [
    "a11yTitle",
    "dropHeight",
    "dropProps",
    "focus",
    "focusIndicator",
    "icon",
    "id",
    "mask",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onKeyDown",
    "placeholder",
    "plain",
    "reverse",
    "textAlign",
    "value"
];
function $d76f119224a6c3c6$var$_extends() {
    return $d76f119224a6c3c6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d76f119224a6c3c6$var$_extends.apply(null, arguments);
}
function $d76f119224a6c3c6$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $d76f119224a6c3c6$var$parseValue = function parseValue(mask, value) {
    // break the value up into mask parts
    var valueParts = []; // { part, beginIndex, endIndex }
    var valueIndex = 0;
    var maskIndex = 0;
    while(value !== undefined && valueIndex < value.length && maskIndex < mask.length){
        var item = mask[maskIndex];
        var found = void 0;
        if (item.fixed) {
            var length = item.fixed.length;
            // grab however much of value (starting at valueIndex) matches
            // item.fixed. If none matches it and there is more in value
            // add in the fixed item.
            var matching = 0;
            while(matching < length && value[valueIndex + matching] === item.fixed[matching])matching += 1;
            if (matching > 0) {
                var part = value.slice(valueIndex, valueIndex + matching);
                if (valueIndex + matching < value.length) // matched part of the fixed portion but there's more stuff
                // after it. Go ahead and fill in the entire fixed chunk
                part = item.fixed;
                valueParts.push({
                    part: part,
                    beginIndex: valueIndex,
                    endIndex: valueIndex + matching - 1
                });
                valueIndex += matching;
            } else valueParts.push({
                part: item.fixed,
                beginIndex: valueIndex,
                endIndex: valueIndex + length - 1
            });
            maskIndex += 1;
            found = true;
        } else if (item.options && item.restrictToOptions !== false) // reverse assuming larger is later
        found = item.options.slice(0).reverse()// eslint-disable-next-line no-loop-func
        .some(function(option) {
            var length = option.length;
            var part = value.slice(valueIndex, valueIndex + length);
            if (part === option) {
                valueParts.push({
                    part: part,
                    beginIndex: valueIndex,
                    endIndex: valueIndex + length - 1
                });
                valueIndex += length;
                maskIndex += 1;
                return true;
            }
            return false;
        });
        if (!found) {
            if (item.regexp) {
                var minLength = Array.isArray(item.length) && item.length[0] || item.length || 1;
                var maxLength = Array.isArray(item.length) && item.length[1] || item.length || value.length - valueIndex;
                var _length = maxLength;
                while(!found && _length >= minLength){
                    var _part = value.slice(valueIndex, valueIndex + _length);
                    if (item.regexp.test(_part)) {
                        valueParts.push({
                            part: _part,
                            beginIndex: valueIndex,
                            endIndex: valueIndex + _length - 1
                        });
                        valueIndex += _length;
                        maskIndex += 1;
                        found = true;
                    }
                    _length -= 1;
                }
                if (!found) valueIndex = value.length;
            } else {
                var _length2 = Array.isArray(item.length) ? item.length[1] : item.length || value.length - valueIndex;
                var _part2 = value.slice(valueIndex, valueIndex + _length2);
                valueParts.push({
                    part: _part2,
                    beginIndex: valueIndex,
                    endIndex: valueIndex + _length2 - 1
                });
                valueIndex += _length2;
                maskIndex += 1;
            }
        }
    }
    return valueParts;
};
var $d76f119224a6c3c6$var$defaultMask = [
    {
        regexp: /[^]*/
    }
];
var $d76f119224a6c3c6$var$ContainerBox = (0, $iA1nz.default)((0, $18c0523379e5dd9d$export$e71c4d32a2263218)).withConfig({
    displayName: "MaskedInput__ContainerBox",
    componentId: "sc-af8hzu-0"
})([
    "",
    ";"
], function(props) {
    return props.dropHeight ? (0, $73ba8e2d301b823f$export$cb60038e9cf9f581)('max-height', props.dropHeight, props.theme) : 'max-height: inherit;';
});
var $d76f119224a6c3c6$var$dropAlign = {
    top: 'bottom',
    left: 'left'
};
var $d76f119224a6c3c6$export$dec03dc0f3ef8025 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, dropHeight = _ref.dropHeight, dropProps = _ref.dropProps, focusProp = _ref.focus, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, icon = _ref.icon, id = _ref.id, _ref$mask = _ref.mask, mask = _ref$mask === void 0 ? $d76f119224a6c3c6$var$defaultMask : _ref$mask, name = _ref.name, _onBlur = _ref.onBlur, onChange = _ref.onChange, _onFocus = _ref.onFocus, onKeyDown = _ref.onKeyDown, placeholder = _ref.placeholder, plain = _ref.plain, reverse = _ref.reverse, textAlign = _ref.textAlign, valueProp = _ref.value, rest = $d76f119224a6c3c6$var$_objectWithoutPropertiesLoose(_ref, $d76f119224a6c3c6$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var formContext = (0, $2xPiy.useContext)((0, $55ac84ad3d20c8d4$export$c24727297075ec6a));
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp,
        initialValue: ''
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    var valueParts = (0, $2xPiy.useMemo)(function() {
        return $d76f119224a6c3c6$var$parseValue(mask, value);
    }, [
        mask,
        value
    ]);
    var inputRef = (0, $3cecef11d3b9c451$export$61dc559f8a0b9bcf)(ref);
    var dropRef = (0, $2xPiy.useRef)();
    // Caller's ref, if provided
    var _useState = (0, $2xPiy.useState)(), dropPropsTarget = _useState[0], setDropPropsTarget = _useState[1];
    (0, $2xPiy.useEffect)(function() {
        var nextDropPropsTarget;
        // If caller provided a ref, set to 'pending' until ref.current is defined
        if (dropProps && 'target' in dropProps) {
            nextDropPropsTarget = dropProps.target || 'pending';
            setDropPropsTarget(nextDropPropsTarget);
        }
    }, [
        dropProps
    ]);
    var _useState2 = (0, $2xPiy.useState)(focusProp), focus = _useState2[0], setFocus = _useState2[1];
    var _useState3 = (0, $2xPiy.useState)(), activeMaskIndex = _useState3[0], setActiveMaskIndex = _useState3[1];
    var _useState4 = (0, $2xPiy.useState)(), activeOptionIndex = _useState4[0], setActiveOptionIndex = _useState4[1];
    var _useState5 = (0, $2xPiy.useState)(), showDrop = _useState5[0], setShowDrop = _useState5[1];
    (0, $2xPiy.useEffect)(function() {
        if (focus) {
            var timer = setTimeout(function() {
                // determine which mask element the caret is at
                var caretIndex = inputRef.current.selectionStart;
                var maskIndex;
                valueParts.some(function(part, index) {
                    if (part.beginIndex <= caretIndex && part.endIndex >= caretIndex) {
                        maskIndex = index;
                        return true;
                    }
                    return false;
                });
                if (maskIndex === undefined && valueParts.length < mask.length) maskIndex = valueParts.length; // first unused one
                if (maskIndex && mask[maskIndex].fixed) maskIndex -= 1; // fixed mask parts are never "active"
                if (maskIndex !== activeMaskIndex) {
                    setActiveMaskIndex(maskIndex);
                    setActiveOptionIndex(-1);
                    setShowDrop(maskIndex >= 0 && mask[maskIndex].options && true);
                }
            }, 10); // 10ms empirically chosen
            return function() {
                return clearTimeout(timer);
            };
        }
        return undefined;
    }, [
        activeMaskIndex,
        focus,
        inputRef,
        mask,
        valueParts
    ]);
    var setInputValue = (0, $2xPiy.useCallback)(function(nextValue) {
        // Calling set value function directly on input because React library
        // overrides setter `event.target.value =` and loses original event
        // target fidelity.
        // https://stackoverflow.com/a/46012210 &&
        // https://github.com/grommet/grommet/pull/3171#discussion_r296415239
        var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
        nativeInputValueSetter.call(inputRef.current, nextValue);
        var event = new Event('input', {
            bubbles: true
        });
        inputRef.current.dispatchEvent(event);
    }, [
        inputRef
    ]);
    var _useState6 = (0, $2xPiy.useState)(), mouseMovedSinceLastKey = _useState6[0], setMouseMovedSinceLastKey = _useState6[1];
    // This could be due to a paste or as the user is typing.
    var onChangeInput = (0, $2xPiy.useCallback)(function(event) {
        var eventValue = event.target.value;
        // Align with the mask.
        var nextValueParts = $d76f119224a6c3c6$var$parseValue(mask, eventValue);
        var nextValue = nextValueParts.map(function(part) {
            return part.part;
        }).join('');
        if (nextValue !== eventValue) {
            // The mask adjusted the next value. If something was added,
            // the value must be valid. Change the actual input value
            // to correspond.
            // This will re-trigger this callback with the next value.
            if (nextValue.length > eventValue.length) setInputValue(nextValue);
            else if (value && eventValue.length < value.length) {
                // If the user is removing characters, preserve what the
                // user is working on.
                setValue(eventValue);
                if (onChange) onChange(event);
            } else // If the user is adding invalid characters, don't allow it.
            // Revert to the prior value.
            setInputValue(value);
        } else if (value !== nextValue) {
            setValue(nextValue);
            if (onChange) onChange(event);
        }
    }, [
        mask,
        onChange,
        setInputValue,
        setValue,
        value
    ]);
    var onOption = (0, $2xPiy.useCallback)(function(option) {
        return function() {
            var nextValueParts = [].concat(valueParts);
            nextValueParts[activeMaskIndex] = {
                part: option
            };
            // add any fixed parts that follow
            var index = activeMaskIndex + 1;
            while(index < mask.length && !nextValueParts[index] && mask[index].fixed){
                nextValueParts[index] = {
                    part: mask[index].fixed
                };
                index += 1;
            }
            var nextValue = nextValueParts.map(function(part) {
                return part.part;
            }).join('');
            setInputValue(nextValue);
            // restore focus to input
            inputRef.current.focus();
        };
    }, [
        activeMaskIndex,
        inputRef,
        mask,
        setInputValue,
        valueParts
    ]);
    var onNextOption = (0, $2xPiy.useCallback)(function(event) {
        var item = mask[activeMaskIndex];
        if (item && item.options) {
            event.preventDefault();
            var index = Math.min(activeOptionIndex + 1, item.options.length - 1);
            setMouseMovedSinceLastKey(false);
            setActiveOptionIndex(index);
        }
    }, [
        activeMaskIndex,
        activeOptionIndex,
        mask
    ]);
    var onPreviousOption = (0, $2xPiy.useCallback)(function(event) {
        if (activeMaskIndex >= 0 && mask[activeMaskIndex].options) {
            event.preventDefault();
            var index = Math.max(activeOptionIndex - 1, 0);
            setMouseMovedSinceLastKey(false);
            setActiveOptionIndex(index);
        }
    }, [
        activeMaskIndex,
        activeOptionIndex,
        mask
    ]);
    var onSelectOption = (0, $2xPiy.useCallback)(function(event) {
        if (activeMaskIndex >= 0 && activeOptionIndex >= 0) {
            event.preventDefault();
            var option = mask[activeMaskIndex].options[activeOptionIndex];
            onOption(option)();
        }
    }, [
        activeMaskIndex,
        activeOptionIndex,
        mask,
        onOption
    ]);
    var onEsc = (0, $2xPiy.useCallback)(function(event) {
        if (showDrop) {
            // we have to stop both synthetic events and native events
            // drop and layer should not close by pressing esc on this input
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();
            setShowDrop(false);
        }
    }, [
        showDrop
    ]);
    var onHideDrop = (0, $2xPiy.useCallback)(function() {
        return setShowDrop(false);
    }, []);
    var renderPlaceholder = function renderPlaceholder() {
        return mask.map(function(item) {
            return item.placeholder || item.fixed;
        }).join('');
    };
    var maskedInputIcon = (0, $0a9f81b63fff2436$export$a123f939253731a8)(icon, rest.size, theme);
    /*
  If the masked input has a list of options, add the WAI-ARIA 1.2
  combobox role and states.
  */ var comboboxProps = {};
    var activeOptionID;
    var options = (0, $2xPiy.useMemo)(function() {
        var _mask$find, _mask$activeMaskIndex;
        var res;
        if (!activeMaskIndex) // ensures that comboboxProps gets set on input initially
        res = (_mask$find = mask.find(function(item) {
            var _item$options;
            return (item == null || (_item$options = item.options) == null ? void 0 : _item$options.length) > 0;
        })) == null ? void 0 : _mask$find.options;
        else res = (_mask$activeMaskIndex = mask[activeMaskIndex]) == null ? void 0 : _mask$activeMaskIndex.options;
        return res;
    }, [
        mask,
        activeMaskIndex
    ]);
    if (id && (options == null ? void 0 : options.length) > 0) {
        if (showDrop && options) activeOptionID = "listbox-option-" + activeOptionIndex + "__" + id;
        comboboxProps = {
            'aria-activedescendant': activeOptionID,
            'aria-autocomplete': 'list',
            'aria-expanded': showDrop ? 'true' : 'false',
            'aria-controls': showDrop ? "listbox__" + id : undefined,
            role: 'combobox'
        };
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $8969445decf5d10b$export$a3c8b952c846e4b1), $d76f119224a6c3c6$var$_extends({
        plain: plain,
        onMouseMove: function onMouseMove() {
            return setMouseMovedSinceLastKey(true);
        }
    }, passThemeFlag), maskedInputIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $8969445decf5d10b$export$7c8f159da0dc916), {
        reverse: reverse,
        theme: theme
    }, maskedInputIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $168667f04da9206c$export$16e4d70cc375e707), {
        onEsc: onEsc,
        onTab: showDrop ? function() {
            return setShowDrop(false);
        } : undefined,
        onLeft: undefined,
        onRight: undefined,
        onUp: onPreviousOption,
        onDown: showDrop ? onNextOption : function() {
            return setShowDrop(true);
        },
        onEnter: onSelectOption,
        onKeyDown: onKeyDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $8969445decf5d10b$export$3b982a63cbad39fd), $d76f119224a6c3c6$var$_extends({
        ref: inputRef,
        "aria-label": a11yTitle,
        id: id,
        name: name,
        autoComplete: "off",
        focusIndicator: focusIndicator,
        plain: plain,
        placeholder: placeholder || renderPlaceholder(),
        icon: icon,
        reverse: reverse,
        focus: focus,
        textAlign: textAlign
    }, comboboxProps, rest, {
        value: value,
        theme: theme,
        onFocus: function onFocus(event) {
            setFocus(true);
            setShowDrop(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            // This will be called when the user clicks on a suggestion,
            // check for that and don't remove the drop in that case.
            // Drop will already have removed itself if the user has focused
            // outside of the Drop.
            if (!dropRef.current) setShowDrop(false);
            if (_onBlur) _onBlur(event);
        },
        onChange: onChangeInput
    }))), showDrop && mask[activeMaskIndex] && mask[activeMaskIndex].options && // If caller has specified dropProps.target, ensure target is defined
    dropPropsTarget !== 'pending' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $9f4217ea4a25a271$export$aaa698cd7aa517d6), $d76f119224a6c3c6$var$_extends({
        id: id ? "masked-input-drop__" + id : undefined,
        align: $d76f119224a6c3c6$var$dropAlign,
        responsive: false,
        target: inputRef.current,
        onClickOutside: onHideDrop,
        onEsc: onHideDrop,
        trapFocus: false
    }, dropProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($d76f119224a6c3c6$var$ContainerBox, $d76f119224a6c3c6$var$_extends({
        ref: dropRef,
        overflow: "auto",
        id: id ? "listbox__" + id : undefined,
        role: "listbox",
        dropHeight: dropHeight,
        onMouseOver: function onMouseOver() {
            return setMouseMovedSinceLastKey(true);
        }
    }, passThemeFlag), mask[activeMaskIndex].options.map(function(option, index) {
        // Determine whether the label is done as a child or
        // as an option Button kind property.
        var child = !theme.button.option ? /*#__PURE__*/ // Not adding a theme object now because this code path
        // is not used in the HPE theme, but we may add theme
        // support here in the future.
        (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            pad: {
                horizontal: 'small',
                vertical: 'xsmall'
            }
        }, option) : undefined;
        // if we have a child, turn on plain, and hoverIndicator
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            key: option,
            flex: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
            id: id ? "listbox-option-" + index + "__" + id : undefined,
            tabIndex: "-1",
            onClick: onOption(option),
            onMouseOver: function onMouseOver() {
                return setActiveOptionIndex(index);
            },
            onFocus: function onFocus() {},
            active: index === activeOptionIndex,
            plain: !child ? undefined : true,
            align: "start",
            kind: !child ? 'option' : undefined,
            hoverIndicator: !child ? undefined : 'background',
            label: !child ? option : undefined,
            keyboard: !mouseMovedSinceLastKey
        }, child));
    }))));
});
$d76f119224a6c3c6$export$dec03dc0f3ef8025.displayName = 'MaskedInput';
$d76f119224a6c3c6$export$dec03dc0f3ef8025.propTypes = (0, $9a8c666add11e139$export$2bbcb24fb0cd855c);






function $15c82f927d04446f$var$_construct(t, e, r) {
    if ($15c82f927d04446f$var$_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $15c82f927d04446f$var$_setPrototypeOf(p, r.prototype), p;
}
function $15c82f927d04446f$var$_setPrototypeOf(t, e) {
    return $15c82f927d04446f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $15c82f927d04446f$var$_setPrototypeOf(t, e);
}
function $15c82f927d04446f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($15c82f927d04446f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $15c82f927d04446f$var$_extends() {
    return $15c82f927d04446f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $15c82f927d04446f$var$_extends.apply(null, arguments);
}
var $15c82f927d04446f$export$42f432bed9bbfa4a = function formatToSchema(format) {
    if (!format) return undefined;
    var result = [];
    var i = 0;
    var part;
    while(i < format.length){
        if (!part || part[0] !== format[i]) {
            if (part) result.push(part);
            part = format[i];
        } else part += format[i];
        i += 1;
    }
    if (part) result.push(part);
    return result;
};
var $15c82f927d04446f$var$masks = {
    m: {
        length: [
            1,
            2
        ],
        regexp: /^[1-9]$|^1[0-2]$/
    },
    mm: {
        length: [
            1,
            2
        ],
        regexp: /^[0-1]$|^0[1-9]$|^1[0-2]$/
    },
    d: {
        length: [
            1,
            2
        ],
        regexp: /^[1-9]$|^[1-2][0-9]$|^3[0-1]$/
    },
    dd: {
        length: [
            1,
            2
        ],
        regexp: /^[0-3]$|^0[1-9]$|^[1-2][0-9]$|^3[0-1]$/
    },
    yy: {
        length: [
            1,
            2
        ],
        regexp: /^[0-9]{1,2}$/
    },
    yyyy: {
        length: [
            1,
            4
        ],
        regexp: /^[0-9]{1,4}$/
    }
};
var $15c82f927d04446f$export$9235b47e9363044 = function schemaToMask(schema) {
    if (!schema) return undefined;
    return schema.map(function(part) {
        var lower = part.toLowerCase();
        var _char = lower[0];
        if (_char === 'm' || _char === 'd' || _char === 'y') return $15c82f927d04446f$var$_extends({
            placeholder: part
        }, $15c82f927d04446f$var$masks[lower]);
        return {
            fixed: part
        };
    });
};
var $15c82f927d04446f$export$a1f20cd55d4f0f56 = function valueToText(value, schema) {
    var text = '';
    // when user initializes dates as empty array, we want to still
    // show the placeholder text
    if (!value || Array.isArray(value) && !value.length) return text;
    var dates = (Array.isArray(value) ? value : [
        value
    ]).map(function(v) {
        return (0, $97dce9bdc58ca202$export$c739ab4d3d4926aa)(v);
    });
    var dateIndex = 0;
    var parts = {};
    schema.every(function(part) {
        var _char2 = part[0].toLowerCase();
        // advance dateIndex if we already have this part
        while(dateIndex < dates.length && (Number.isNaN(dates[dateIndex].date) || (_char2 === 'm' || _char2 === 'd' || _char2 === 'y') && parts[part])){
            dateIndex += 1;
            parts = {};
        }
        var date = dates[dateIndex];
        if (date && part === 'm') {
            text += date.getMonth() + 1;
            parts[part] = true;
        } else if (date && part === 'mm') {
            text += ("0" + (date.getMonth() + 1)).slice(-2);
            parts[part] = true;
        } else if (date && part === 'd') {
            text += date.getDate();
            parts[part] = true;
        } else if (date && part === 'dd') {
            text += ("0" + date.getDate()).slice(-2);
            parts[part] = true;
        } else if (date && part === 'yy') {
            text += date.getFullYear().toString().slice(-2);
            parts[part] = true;
        } else if (date && part === 'yyyy') {
            text += date.getFullYear();
            parts[part] = true;
        } else if (!date && (part[0] === 'm' || part[0] === 'd' || part[0] === 'y')) return false;
        else text += part;
        return true;
    });
    return text;
};
var $15c82f927d04446f$var$charCodeZero = '0'.charCodeAt(0);
var $15c82f927d04446f$var$charCodeNine = '9'.charCodeAt(0);
var $15c82f927d04446f$var$pullDigits = function pullDigits(text, index) {
    var end = index;
    while(text.charCodeAt(end) >= $15c82f927d04446f$var$charCodeZero && text.charCodeAt(end) <= $15c82f927d04446f$var$charCodeNine)end += 1;
    return text.slice(index, end);
};
var $15c82f927d04446f$export$51e58a02740fe411 = function validateBounds(dateBounds, selectedDate) {
    if (!dateBounds || !selectedDate) return true;
    var _dateBounds$map = dateBounds.map(function(date) {
        return (0, $97dce9bdc58ca202$export$c739ab4d3d4926aa)(date).toISOString();
    }), startDate = _dateBounds$map[0], endDate = _dateBounds$map[1];
    var isoSelectedDates = (Array.isArray(selectedDate) ? selectedDate : [
        selectedDate
    ]).map(function(date) {
        return (0, $97dce9bdc58ca202$export$c739ab4d3d4926aa)(date).toISOString();
    });
    var validSelection = isoSelectedDates.every(function(isoSelectedDate) {
        return !endDate && startDate === isoSelectedDate || isoSelectedDate >= startDate && isoSelectedDate <= endDate;
    });
    return validSelection;
};
var $15c82f927d04446f$export$60c3f5dffac76ccb = function textToValue(text, schema, range, reference, outputFormat) {
    if (!text) return range ? [] : undefined;
    var result;
    var addDate = function addDate(parts) {
        var leapYear = parts.y % 4 === 0 && parts.y % 100 !== 0 || parts.y % 400 === 0;
        // Do a little sanity checking on the parts first.
        // If not valid, leave as is.
        if (!parts.m || !parts.d || !parts.y || parts.y.length < 4 || parts.m.length > 2 || parts.d.length > 2 || parts.m > 12 || parts.d > 31 || (parts.m === "02" || parts.m === "2") && parts.d > (leapYear ? 29 : 28)) return parts;
        // use time info from reference date
        var time = reference ? [
            reference.getHours(),
            reference.getMinutes(),
            reference.getSeconds(),
            reference.getMilliseconds()
        ] : null;
        var date = $15c82f927d04446f$var$_construct(Date, [
            parts.y,
            parts.m - 1,
            parts.d
        ].concat(time)).toISOString();
        if (date && outputFormat === 'no timezone') {
            var _handleOffset$toISOSt = (0, $123971ce5b8991ad$export$440bcced20c33405)(date).toISOString().split('T');
            date = _handleOffset$toISOSt[0];
        }
        if (!range) {
            if (!result) result = date;
        } else {
            if (!result) result = [];
            result.push(date);
        }
        // we've consumed these parts, return an empty object in case we need
        // to start building up another one for a range
        return {};
    };
    var parts = {};
    var index = 0;
    schema.forEach(function(part) {
        if (index < text.length) {
            var lower = part.toLowerCase();
            var _char3 = lower[0];
            if (parts[_char3] !== undefined) parts = addDate(parts);
            if (_char3 === 'm') {
                parts.m = $15c82f927d04446f$var$pullDigits(text, index);
                index += parts.m.length;
            } else if (_char3 === 'd') {
                var _parts;
                parts.d = $15c82f927d04446f$var$pullDigits(text, index);
                // when format is something like yyyy/mm/dd,
                // '0' as incomplete day can cause date to be
                // prematurely calculated.
                // ex: 2022/01/0 would reutrn 2021/12/31 in addDate()
                if (parts.d === '0') delete parts.d;
                index += ((_parts = parts) == null || (_parts = _parts.d) == null ? void 0 : _parts.length) || 0;
            } else if (_char3 === 'y') {
                parts.y = $15c82f927d04446f$var$pullDigits(text, index);
                index += parts.y.length;
                if (lower === 'yy' && parts.y.length === 2) // convert to full year, pivot at 69 based on POSIX strptime()
                parts.y = "" + (parts.y < 69 ? 20 : 19) + parts.y;
            } else if (text.slice(index, index + part.length) === part) index += part.length;
            else {
                // syntax error
                index = text.length;
                result = undefined;
            }
        }
    });
    parts = addDate(parts);
    if (!result) return range ? [] : undefined;
    return result;
};
var $15c82f927d04446f$export$45491dafa4524293 = function valuesAreEqual(value1, value2) {
    return Array.isArray(value1) && Array.isArray(value2) && value1.every(function(d1, i) {
        return d1 === value2[i];
    }) || value1 === value2;
};



var $dyr1f = parcelRequire("dyr1f");
var $28a68cdaedd06d10$var$PropType = {};
$28a68cdaedd06d10$var$PropType = {
    buttonProps: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({}),
    calendarProps: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({}),
    defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string)
    ]),
    dropProps: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({}),
    format: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).element,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    inline: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    reverse: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    readOnlyCopy: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({}),
    name: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string)
    ]),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            'xxlarge',
            '2xl',
            '3xl',
            '4xl',
            '5xl',
            '6xl'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ])
};
var $28a68cdaedd06d10$export$22313ae4df6bbc32 = $28a68cdaedd06d10$var$PropType;





var $f8b1322d821ac28a$var$_excluded = [
    "buttonProps",
    "calendarProps",
    "defaultValue",
    "disabled",
    "dropProps",
    "format",
    "id",
    "icon",
    "inline",
    "inputProps",
    "name",
    "onChange",
    "onFocus",
    "plain",
    "readOnly",
    "readOnlyCopy",
    "reverse",
    "value",
    "messages"
], $f8b1322d821ac28a$var$_excluded2 = [
    "icon"
];
function $f8b1322d821ac28a$var$_extends() {
    return $f8b1322d821ac28a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f8b1322d821ac28a$var$_extends.apply(null, arguments);
}
function $f8b1322d821ac28a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $f8b1322d821ac28a$var$StyledDateInputContainer = (0, $iA1nz.default)((0, $18c0523379e5dd9d$export$e71c4d32a2263218)).withConfig({
    // to not pass props on dom through Box
    shouldForwardProp: function shouldForwardProp(prop) {
        return prop !== 'disabled';
    }
}).withConfig({
    displayName: "DateInput__StyledDateInputContainer",
    componentId: "sc-1jfta23-0"
})([
    "",
    " ",
    "}"
], function(props) {
    return props.disabled && (0, $73ba8e2d301b823f$export$adf3fcef8e5e1347)();
}, function(props) {
    return props.readOnlyProp && (0, $546d8bf2981e1998$export$28ff5f3fef0ffa78)(props.theme);
});
var $f8b1322d821ac28a$var$getReference = function getReference(value) {
    var adjustedDate;
    var res;
    if (typeof value === 'string') res = value;
    else if (Array.isArray(value) && Array.isArray(value[0])) res = value[0].find(function(date) {
        return date;
    });
    else if (Array.isArray(value) && value.length) res = value[0];
    if (res) adjustedDate = (0, $97dce9bdc58ca202$export$c739ab4d3d4926aa)(res);
    return adjustedDate;
};
var $f8b1322d821ac28a$export$7edc06cf1783b30f = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, refArg) {
    var _theme$icon, _theme$dateInput$icon, _theme$dateInput$icon2, _theme$dateInput$butt, _theme$dateInput$butt2;
    var buttonProps = _ref.buttonProps, calendarProps = _ref.calendarProps, defaultValue = _ref.defaultValue, disabled = _ref.disabled, dropProps = _ref.dropProps, format = _ref.format, id = _ref.id, icon = _ref.icon, _ref$inline = _ref.inline, inline = _ref$inline === void 0 ? false : _ref$inline, inputProps = _ref.inputProps, name = _ref.name, _onChange = _ref.onChange, _onFocus = _ref.onFocus, plain = _ref.plain, readOnlyProp = _ref.readOnly, readOnlyCopy = _ref.readOnlyCopy, _ref$reverse = _ref.reverse, reverseProp = _ref$reverse === void 0 ? false : _ref$reverse, valueArg = _ref.value, messages = _ref.messages, rest = $f8b1322d821ac28a$var$_objectWithoutPropertiesLoose(_ref, $f8b1322d821ac28a$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var announce = (0, $2xPiy.useContext)((0, $c8f61343d2547c6a$export$dcc8f4bff0d51f50));
    var _useContext = (0, $2xPiy.useContext)((0, $f1ad7bf122eed3b0$export$b060d577040138d8)), formatMessage = _useContext.format;
    var iconSize = ((_theme$icon = theme.icon) == null ? void 0 : _theme$icon.matchSize) && rest.size || ((_theme$dateInput$icon = theme.dateInput.icon) == null ? void 0 : _theme$dateInput$icon.size);
    var _useContext2 = (0, $2xPiy.useContext)((0, $55ac84ad3d20c8d4$export$c24727297075ec6a)), useFormInput = _useContext2.useFormInput;
    var ref = (0, $3cecef11d3b9c451$export$61dc559f8a0b9bcf)(refArg);
    var containerRef = (0, $2xPiy.useRef)();
    var readOnly = readOnlyProp || readOnlyCopy;
    var bounds = calendarProps == null ? void 0 : calendarProps.bounds;
    var validateBoundsForForm = (0, $2xPiy.useCallback)(function(fieldValue) {
        if (!bounds || !fieldValue) return undefined;
        var isValid = (0, $15c82f927d04446f$export$51e58a02740fe411)(bounds, fieldValue);
        if (!isValid) {
            var _bounds$map = bounds.map(function(date) {
                return (0, $97dce9bdc58ca202$export$c739ab4d3d4926aa)(date).toISOString();
            }), startBound = _bounds$map[0], endBound = _bounds$map[1];
            if (startBound && endBound) return formatMessage({
                id: 'dateInput.outOfBounds',
                messages: messages,
                values: {
                    start: new Date(startBound).toLocaleDateString(),
                    end: new Date(endBound).toLocaleDateString()
                }
            });
        }
        return undefined;
    }, [
        bounds,
        formatMessage,
        messages
    ]);
    var _useFormInput = useFormInput({
        name: name,
        value: valueArg,
        initialValue: defaultValue,
        validate: bounds ? validateBoundsForForm : undefined
    }), value = _useFormInput[0], setValue = _useFormInput[1];
    var usingKeyboard = (0, $fc2b59dcdb1fd3de$export$8f71654801c2f7cd)();
    var CalendarIcon = ((_theme$dateInput$icon2 = theme.dateInput.icon) == null ? void 0 : _theme$dateInput$icon2.calendar) || (0, $5958f18f8d688d50$export$e1aef45b828286de);
    var _useState = (0, $2xPiy.useState)(true), withinBounds = _useState[0], setWithinBounds = _useState[1];
    var _useState2 = (0, $2xPiy.useState)((0, $f1631bb79f7b96e6$export$c0c99f9031a45b3)(value)), outputFormat = _useState2[0], setOutputFormat = _useState2[1];
    (0, $2xPiy.useEffect)(function() {
        setOutputFormat(function(previousFormat) {
            var nextFormat = (0, $f1631bb79f7b96e6$export$c0c99f9031a45b3)(value);
            // when user types, date could become something like 07//2020
            // and value becomes undefined. don't lose the format from the
            // previous valid date
            return previousFormat !== nextFormat ? previousFormat : nextFormat;
        });
    }, [
        value
    ]);
    (0, $2xPiy.useEffect)(function() {
        if (value === undefined || bounds === undefined) setWithinBounds(true);
        else {
            var validNextValue = (0, $15c82f927d04446f$export$51e58a02740fe411)(bounds, value);
            setWithinBounds(validNextValue);
        }
    }, [
        value,
        bounds
    ]);
    // keep track of timestamp from original date(s)
    var _useState3 = (0, $2xPiy.useState)($f8b1322d821ac28a$var$getReference(value)), reference = _useState3[0], setReference = _useState3[1];
    // do we expect multiple dates?
    var range = Array.isArray(value) || format && format.includes('-');
    // parse format and build a formal schema we can use elsewhere
    var schema = (0, $2xPiy.useMemo)(function() {
        return (0, $15c82f927d04446f$export$42f432bed9bbfa4a)(format);
    }, [
        format
    ]);
    // mask is only used when a format is provided
    var mask = (0, $2xPiy.useMemo)(function() {
        return (0, $15c82f927d04446f$export$9235b47e9363044)(schema);
    }, [
        schema
    ]);
    // textValue is only used when a format is provided
    var _useState4 = (0, $2xPiy.useState)(schema ? (0, $15c82f927d04446f$export$a1f20cd55d4f0f56)(value, schema) : undefined), textValue = _useState4[0], setTextValue = _useState4[1];
    var readOnlyCopyValidation = formatMessage({
        id: 'input.readOnlyCopy.validation',
        messages: messages
    });
    var readOnlyCopyPrompt = formatMessage({
        id: 'input.readOnlyCopy.prompt',
        messages: messages
    });
    var _useState5 = (0, $2xPiy.useState)(readOnlyCopyPrompt), tip = _useState5[0], setTip = _useState5[1];
    // Setting the icon through `inputProps` is deprecated.
    // The `icon` prop should be used instead.
    var _ref2 = inputProps || {}, MaskedInputIcon = _ref2.icon, restOfInputProps = $f8b1322d821ac28a$var$_objectWithoutPropertiesLoose(_ref2, $f8b1322d821ac28a$var$_excluded2);
    if (MaskedInputIcon) console.warn("Customizing the DateInput icon through inputProps is deprecated.\nUse the icon prop instead.");
    var reverse = reverseProp || restOfInputProps.reverse;
    var calendarDropdownAlign = {
        top: 'bottom',
        left: 'left'
    };
    // We need to distinguish between the caller changing a Form value
    // and the user typing a date that he isn't finished with yet.
    // To handle this, we see if we have a value and the text value
    // associated with it doesn't align to it, then we update the text value.
    // We compare using textToValue to avoid "06/01/2021" not
    // matching "06/1/2021".
    (0, $2xPiy.useEffect)(function() {
        if (schema && value !== undefined) {
            var nextTextValue = (0, $15c82f927d04446f$export$a1f20cd55d4f0f56)(value, schema);
            if (!(0, $15c82f927d04446f$export$45491dafa4524293)((0, $15c82f927d04446f$export$60c3f5dffac76ccb)(textValue, schema, range, reference), (0, $15c82f927d04446f$export$60c3f5dffac76ccb)(nextTextValue, schema, range, reference)) || textValue === '' && nextTextValue !== '') setTextValue(nextTextValue);
        }
    }, [
        range,
        schema,
        textValue,
        reference,
        value
    ]);
    // textValue of MaskedInput is controlled.
    // for uncontrolled forms, ensure the reset event
    // resets the textValue
    (0, $2xPiy.useEffect)(function() {
        var _ref$current;
        var form = ref == null || (_ref$current = ref.current) == null ? void 0 : _ref$current.form;
        var handleFormReset = function handleFormReset(e) {
            if (schema && ref.current && e.target.contains(ref.current)) setTextValue('');
        };
        // place the listener on the form directly. if listener is on window,
        // the event could get blocked if caller has e.stopPropagation(), etc. in
        // their form onReset
        form == null || form.addEventListener('reset', handleFormReset);
        return function() {
            return form == null ? void 0 : form.removeEventListener('reset', handleFormReset);
        };
    }, [
        schema,
        ref
    ]);
    // when format and not inline, whether to show the Calendar in a Drop
    var _useState6 = (0, $2xPiy.useState)(), open = _useState6[0], setOpen = _useState6[1];
    var openCalendar = (0, $2xPiy.useCallback)(function() {
        setOpen(true);
        announce(formatMessage({
            id: 'dateInput.enterCalendar',
            messages: messages
        }));
    }, [
        announce,
        formatMessage,
        messages
    ]);
    var closeCalendar = (0, $2xPiy.useCallback)(function() {
        if (usingKeyboard && !inline && ref != null && ref.current) setTimeout(function() {
            var _ref$current2;
            ref == null || (_ref$current2 = ref.current) == null || _ref$current2.focus();
        }, 0);
        setOpen(false);
        announce(formatMessage({
            id: 'dateInput.exitCalendar',
            messages: messages
        }));
    }, [
        announce,
        formatMessage,
        messages,
        usingKeyboard,
        ref,
        inline
    ]);
    var dates = (0, $2xPiy.useMemo)(function() {
        return range && value != null && value.length ? [
            value
        ] : undefined;
    }, [
        range,
        value
    ]);
    var calendar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $f1631bb79f7b96e6$export$e1aef45b828286de), $f8b1322d821ac28a$var$_extends({
        ref: inline ? ref : undefined,
        id: inline && !format ? id : undefined,
        range: range,
        date: range ? undefined : value,
        dates: dates,
        initialFocus: open ? 'days' : undefined,
        onSelect: disabled ? undefined : function(nextValue) {
            var normalizedValue;
            if (range && Array.isArray(nextValue)) normalizedValue = nextValue[0];
            else if (range && nextValue) normalizedValue = [
                nextValue,
                nextValue
            ];
            else normalizedValue = nextValue;
            if (schema) setTextValue((0, $15c82f927d04446f$export$a1f20cd55d4f0f56)(normalizedValue, schema));
            setValue(normalizedValue);
            setReference($f8b1322d821ac28a$var$getReference(nextValue));
            if (_onChange) _onChange({
                value: normalizedValue
            });
            if (open && !range) closeCalendar();
        }
    }, calendarProps));
    var formContextValue = (0, $2xPiy.useMemo)(function() {
        return {
            useFormInput: function useFormInput(_ref3) {
                var valueProp = _ref3.value;
                return [
                    valueProp,
                    function() {}
                ];
            }
        };
    }, []);
    if (!format) {
        // When no format is specified, we don't give the user a way to type
        if (inline) return calendar;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $c9158ac1cba12f75$export$64fff40e709e8b2e), $f8b1322d821ac28a$var$_extends({
            ref: ref,
            id: id,
            dropProps: $f8b1322d821ac28a$var$_extends({
                align: calendarDropdownAlign
            }, dropProps),
            dropContent: calendar,
            icon: icon || MaskedInputIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(CalendarIcon, {
                size: iconSize
            })
        }, buttonProps));
    }
    var onClickCopy = function onClickCopy() {
        navigator.clipboard.writeText(textValue);
        announce(readOnlyCopyValidation, 'assertive');
        setTip(readOnlyCopyValidation);
    };
    var onBlurCopy = function onBlurCopy() {
        if (tip === readOnlyCopyValidation) setTip(readOnlyCopyPrompt);
    };
    var DateInputButton = readOnlyCopy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $313d8d7c610a335e$export$4f2558dd25106ae2), {
        disabled: disabled,
        onBlurCopy: onBlurCopy,
        onClickCopy: onClickCopy,
        readOnlyCopyPrompt: readOnlyCopyPrompt,
        tip: tip,
        value: value
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
        onClick: open ? closeCalendar : openCalendar,
        disabled: disabled,
        plain: true,
        icon: icon || MaskedInputIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(CalendarIcon, {
            size: iconSize
        }),
        margin: reverse ? {
            left: (_theme$dateInput$butt = theme.dateInput.button) == null ? void 0 : _theme$dateInput$butt.margin
        } : {
            right: (_theme$dateInput$butt2 = theme.dateInput.button) == null ? void 0 : _theme$dateInput$butt2.margin
        }
    });
    var input = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $55ac84ad3d20c8d4$export$c24727297075ec6a).Provider, {
        key: "input",
        value: formContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $168667f04da9206c$export$16e4d70cc375e707), {
        onEsc: open ? function() {
            return closeCalendar();
        } : undefined,
        onSpace: function onSpace(event) {
            if (!readOnlyCopy) {
                event.preventDefault();
                if (!readOnly) openCalendar();
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($f8b1322d821ac28a$var$StyledDateInputContainer, $f8b1322d821ac28a$var$_extends({
        ref: containerRef,
        border: !plain,
        round: theme.dateInput.container.round,
        direction: "row",
        disabled: disabled,
        readOnlyProp: readOnly,
        fill: true
    }, passThemeFlag), reverse && (!readOnly || readOnlyCopy) && DateInputButton, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $d76f119224a6c3c6$export$dec03dc0f3ef8025), $f8b1322d821ac28a$var$_extends({
        "aria-invalid": bounds && !withinBounds ? true : undefined,
        readOnly: readOnly,
        ref: ref,
        id: id,
        name: name,
        reverse: true,
        disabled: disabled,
        mask: mask,
        plain: true
    }, restOfInputProps, rest, {
        value: textValue,
        onChange: function onChange(event) {
            var nextTextValue = event.target.value;
            setTextValue(nextTextValue);
            var nextValue = (0, $15c82f927d04446f$export$60c3f5dffac76ccb)(nextTextValue, schema, range, reference, outputFormat);
            var validNextValue = (0, $15c82f927d04446f$export$51e58a02740fe411)(bounds, nextValue);
            setWithinBounds(validNextValue);
            if (nextValue !== undefined) setReference($f8b1322d821ac28a$var$getReference(nextValue));
            // update value even when undefined
            setValue(nextValue);
            if (_onChange) {
                event.persist(); // extract from React synthetic event pool
                var adjustedEvent = event;
                adjustedEvent.value = nextValue;
                _onChange(adjustedEvent);
            }
        },
        onFocus: function onFocus(event) {
            if (!readOnly) announce(formatMessage({
                id: 'dateInput.openCalendar',
                messages: messages
            }));
            if (_onFocus) _onFocus(event);
        }
    })), !reverse && (!readOnly || readOnlyCopy) && DateInputButton)));
    if (inline) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), null, input, calendar);
    if (open && !readOnly) return [
        input,
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $9f4217ea4a25a271$export$aaa698cd7aa517d6), $f8b1322d821ac28a$var$_extends({
            key: "drop",
            id: id ? id + "__drop" : undefined,
            target: containerRef.current,
            align: $f8b1322d821ac28a$var$_extends({}, calendarDropdownAlign, dropProps),
            onEsc: closeCalendar,
            onClickOutside: function onClickOutside(_ref4) {
                var target = _ref4.target;
                if (target !== containerRef.current && !containerRef.current.contains(target)) closeCalendar();
            }
        }, dropProps), calendar)
    ];
    return input;
});
$f8b1322d821ac28a$export$7edc06cf1783b30f.displayName = 'DateInput';
$f8b1322d821ac28a$export$7edc06cf1783b30f.propTypes = (0, $28a68cdaedd06d10$export$22313ae4df6bbc32);



var $2xPiy = parcelRequire("2xPiy");

function $52cab84bc22908ed$var$_extends() {
    return $52cab84bc22908ed$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $52cab84bc22908ed$var$_extends.apply(null, arguments);
}
var $52cab84bc22908ed$export$e1aef45b828286de = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $52cab84bc22908ed$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Calendar"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 5h20v17H2V5zm16 0V1M6 5V1m-4 9h20"
    }));
});
$52cab84bc22908ed$export$e1aef45b828286de.displayName = 'Calendar';



const $80552002da1e12b3$export$7edc06cf1783b30f = (props)=>{
    const { label: label, value: value, setValue: setValue, error: error, required: required, hideRequiredMarker: hideRequiredMarker, disabled: disabled, onSubmit: onSubmit, ...boxProps } = props;
    const formatDate = (date)=>{
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const todayString = formatDate(new Date());
    const effectiveValue = value || todayString;
    (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).useEffect(()=>{
        if (!value) setValue(todayString);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        ...boxProps,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                border: disabled ? undefined : {
                    color: error ? 'red' : 'light-5',
                    size: '0.8px'
                },
                background: disabled ? 'light-6' : undefined,
                borderRadius: "6px",
                pad: {
                    horizontal: '0.75rem',
                    vertical: '0.5rem'
                },
                direction: "row",
                justify: "between",
                height: "58px",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        alignSelf: "center",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: "0.875rem",
                                color: disabled ? 'light-3' : 'accent-1',
                                children: [
                                    label,
                                    required && !hideRequiredMarker && '*'
                                ]
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $168667f04da9206c$export$16e4d70cc375e707), {
                                onEnter: onSubmit,
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d76f119224a6c3c6$export$dec03dc0f3ef8025), {
                                    value: effectiveValue,
                                    onChange: (e)=>setValue(e.target.value),
                                    mask: [
                                        {
                                            length: 4,
                                            regexp: /^[1-2]$|^19$|^20$|^19[0-9]$|^20[0-9]$|^19[0-9][0-9]$|^20[0-9][0-9]$/,
                                            placeholder: 'yyyy'
                                        },
                                        {
                                            fixed: '-'
                                        },
                                        {
                                            length: [
                                                1,
                                                2
                                            ],
                                            regexp: /^1[0,1-2]$|^0?[1-9]$|^0$/,
                                            placeholder: 'mm'
                                        },
                                        {
                                            fixed: '-'
                                        },
                                        {
                                            length: [
                                                1,
                                                2
                                            ],
                                            regexp: /^[1-2][0-9]$|^3[0-1]$|^0?[1-9]$|^0$/,
                                            placeholder: 'dd'
                                        }
                                    ],
                                    plain: true,
                                    style: {
                                        fontSize: '0.875rem',
                                        fontFamily: 'Lato, sans-serif',
                                        fontWeight: 400,
                                        padding: 0
                                    },
                                    required: required,
                                    disabled: disabled
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        alignSelf: "center",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f8b1322d821ac28a$export$7edc06cf1783b30f), {
                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $52cab84bc22908ed$export$e1aef45b828286de), {
                                size: "20px",
                                color: "text"
                            }),
                            value: effectiveValue,
                            format: "yyyy-mm-dd",
                            onChange: ({ value: value })=>setValue(typeof value === 'string' ? value : value[0]),
                            calendarProps: {
                                style: {
                                    fontFamily: 'Lato, sans-serif',
                                    borderRadius: '6px'
                                },
                                margin: {
                                    bottom: '0.5rem'
                                },
                                fill: true,
                                color: 'white'
                            }
                        })
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                row: true,
                gap: "small",
                margin: {
                    top: '0.5rem',
                    left: '0.75rem'
                },
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    color: "red",
                    size: "0.75rem",
                    children: error
                })
            })
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");


var $2xPiy = parcelRequire("2xPiy");



var $iA1nz = parcelRequire("iA1nz");

var $63d92ee5353c8e56$var$plainStyle = (0, $iA1nz.css)([
    "outline:none;border:none;width:100%;-webkit-appearance:none;"
]);
var $63d92ee5353c8e56$var$resizeStyle = function resizeStyle(resize) {
    if (resize === 'horizontal') return 'resize: horizontal;';
    if (resize === 'vertical') return 'resize: vertical;';
    if (resize) return 'resize: both;';
    return 'resize: none;';
};
var $63d92ee5353c8e56$export$e93364aaaa97e46f = (0, $iA1nz.default).textarea.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledTextArea",
    componentId: "sc-17i3mwp-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    " ",
    ";max-width:100%;"
], (0, $73ba8e2d301b823f$export$533edcdef9a0af13), function(props) {
    return props.resize !== undefined && $63d92ee5353c8e56$var$resizeStyle(props.resize);
}, function(props) {
    return props.fillArg && 'height: 100%;';
}, function(props) {
    return props.plain && $63d92ee5353c8e56$var$plainStyle;
}, function(props) {
    return props.disabled && (0, $73ba8e2d301b823f$export$adf3fcef8e5e1347)(props.theme.textArea.disabled && props.theme.textArea.disabled.opacity);
}, function(props) {
    return props.theme.textArea && props.theme.textArea.extend;
});



var $dyr1f = parcelRequire("dyr1f");
var $11581769fb067db4$var$PropType = {};
$11581769fb067db4$var$PropType = {
    a11yTitle: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    fill: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    focusIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    plain: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    resize: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'vertical',
            'horizontal'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
    ]),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            'xxlarge',
            '2xl',
            '3xl',
            '4xl',
            '5xl',
            '6xl'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ])
};
var $11581769fb067db4$export$84f313a0fe939ad2 = $11581769fb067db4$var$PropType;



var $f281159a7d882928$var$_excluded = [
    "a11yTitle",
    "fill",
    "focusIndicator",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onKeyDown",
    "value"
];
function $f281159a7d882928$var$_extends() {
    return $f281159a7d882928$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f281159a7d882928$var$_extends.apply(null, arguments);
}
function $f281159a7d882928$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $f281159a7d882928$export$f5c9f3c2c4054eec = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, fill = _ref.fill, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, name = _ref.name, _onBlur = _ref.onBlur, _onChange = _ref.onChange, _onFocus = _ref.onFocus, onKeyDown = _ref.onKeyDown, valueProp = _ref.value, rest = $f281159a7d882928$var$_objectWithoutPropertiesLoose(_ref, $f281159a7d882928$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var formContext = (0, $2xPiy.useContext)((0, $55ac84ad3d20c8d4$export$c24727297075ec6a));
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    var _useState = (0, $2xPiy.useState)(), focus = _useState[0], setFocus = _useState[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $168667f04da9206c$export$16e4d70cc375e707), {
        onEsc: function onEsc(event) {
            // we have to stop both synthetic events and native events
            // drop and layer should not close by pressing esc on this input
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();
        },
        onKeyDown: onKeyDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $63d92ee5353c8e56$export$e93364aaaa97e46f), $f281159a7d882928$var$_extends({
        "aria-label": a11yTitle,
        ref: ref,
        name: name,
        fillArg: fill,
        focus: focus,
        value: value,
        focusIndicator: focusIndicator
    }, passThemeFlag, rest, {
        onFocus: function onFocus(event) {
            setFocus(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        onChange: function onChange(event) {
            setValue(event.target.value);
            if (_onChange) _onChange(event);
        }
    })));
});
$f281159a7d882928$export$f5c9f3c2c4054eec.displayName = 'TextArea';
$f281159a7d882928$export$f5c9f3c2c4054eec.propTypes = (0, $11581769fb067db4$export$84f313a0fe939ad2);



var $2xPiy = parcelRequire("2xPiy");

function $c7bce65ed51d571e$var$_extends() {
    return $c7bce65ed51d571e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c7bce65ed51d571e$var$_extends.apply(null, arguments);
}
var $c7bce65ed51d571e$export$a8d2f61b02c7b95f = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $c7bce65ed51d571e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormNext"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m9 6 6 6-6 6"
    }));
});
$c7bce65ed51d571e$export$a8d2f61b02c7b95f.displayName = 'FormNext';


var $2xPiy = parcelRequire("2xPiy");

function $c992d2c91441866d$var$_extends() {
    return $c992d2c91441866d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c992d2c91441866d$var$_extends.apply(null, arguments);
}
var $c992d2c91441866d$export$a14ca6bc44f029a6 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $c992d2c91441866d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormPrevious"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m15 6-6 6 6 6"
    }));
});
$c992d2c91441866d$export$a14ca6bc44f029a6.displayName = 'FormPrevious';


var $2xPiy = parcelRequire("2xPiy");

function $17615e8310fedcd7$var$_extends() {
    return $17615e8310fedcd7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $17615e8310fedcd7$var$_extends.apply(null, arguments);
}
var $17615e8310fedcd7$export$bed28288a051538 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $17615e8310fedcd7$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Hide"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 17c-2.727 0-6-2.778-6-5s3.273-5 6-5 6 2.778 6 5-3.273 5-6 5zm-1-5a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm9-7L4 19"
    }));
});
$17615e8310fedcd7$export$bed28288a051538.displayName = 'Hide';


var $2xPiy = parcelRequire("2xPiy");

function $4acda1c651d988fd$var$_extends() {
    return $4acda1c651d988fd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4acda1c651d988fd$var$_extends.apply(null, arguments);
}
var $4acda1c651d988fd$export$27a5bd065ad55220 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $4acda1c651d988fd$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "View"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 21c-5 0-11-5-11-9s6-9 11-9 11 5 11 9-6 9-11 9zm0-14a5 5 0 1 0 0 10 5 5 0 0 0 0-10z"
    }));
});
$4acda1c651d988fd$export$27a5bd065ad55220.displayName = 'View';




const $b86c1b08804a61b5$export$f5b8910cec6cf069 = (props)=>{
    const { label: label, value: value = Number.isNaN(props.value) ? '' : props.value, setValue: setValue, id: id, name: name, error: error, placeholder: placeholder, type: type, required: required, minLength: minLength, maxLength: maxLength, rows: rows, fuseAdminOnly: fuseAdminOnly, opacity: opacity, hideRequiredMarker: hideRequiredMarker, centerLabel: centerLabel = true, disabled: disabled, disabledBackground: disabledBackground, autoComplete: autoComplete, componentType: componentType, onSubmit: onSubmit, dateBounds: dateBounds, ...boxProps } = props;
    const [showPassword, setShowPassword] = (0, $2xPiy.useState)(false);
    const [isButtonFocused, setIsButtonFocused] = (0, $2xPiy.useState)(false);
    const [isCalendarOpen, setIsCalendarOpen] = (0, $2xPiy.useState)(false);
    const [isFocused, setIsFocused] = (0, $2xPiy.useState)(false);
    const isActiveLabel = (0, $2xPiy.useMemo)(()=>value !== undefined && value !== null && value !== '' || isFocused || !centerLabel || placeholder || disabled, [
        value,
        isFocused,
        centerLabel,
        placeholder,
        disabled
    ]);
    const onChange = (e)=>{
        if (e.target.value) {
            if (minLength) {
                if (typeof e.target.value === 'number' && e.target.value.toString().length < minLength) return;
                else if (typeof e.target.value === 'string' && e.target.value.length < minLength) return;
            }
            if (maxLength) {
                if (typeof e.target.value === 'number' && e.target.value.toString().length > maxLength) return;
                else if (typeof e.target.value === 'string' && e.target.value.length > maxLength) return;
            }
        }
        setValue?.(e.target.value);
    };
    const renderInput = ()=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8c9c99ffe8765a99$export$c86715117507e8e5), {
            id: id,
            name: name || id,
            placeholder: placeholder,
            minLength: minLength,
            maxLength: maxLength,
            type: type,
            value: value,
            onChange: onChange,
            required: required,
            disabled: disabled,
            autoComplete: autoComplete,
            onFocus: ()=>setIsFocused(true),
            onBlur: ()=>setIsFocused(false),
            plain: true,
            style: {
                fontFamily: 'Lato, sans-serif',
                height: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(58),
                paddingTop: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(26),
                paddingBottom: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(10)
            },
            className: "hide-input-arrows"
        });
    const renderPercentInput = ()=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8c9c99ffe8765a99$export$c86715117507e8e5), {
            id: id,
            name: name || id,
            placeholder: placeholder,
            minLength: minLength,
            maxLength: maxLength,
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                size: "20px",
                color: "dark-1",
                weight: 700,
                style: {
                    fontFamily: 'Lato, sans-serif'
                },
                children: "%"
            }),
            reverse: true,
            type: "number",
            className: "percent-input hide-input-arrows",
            value: value,
            onChange: (e)=>setValue?.(e.target.value),
            required: required,
            disabled: disabled,
            autoComplete: autoComplete,
            onFocus: ()=>setIsFocused(true),
            onBlur: ()=>setIsFocused(false),
            plain: true,
            style: {
                fontFamily: 'Lato, sans-serif',
                height: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(58),
                paddingTop: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(26),
                paddingBottom: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(10)
            }
        });
    const renderDateInput = ()=>{
        const months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];
        const currentYear = new Date().getFullYear();
        const startYear = 2020;
        const yearRange = currentYear - startYear + 1;
        const years = Array.from({
            length: yearRange
        }, (_, i)=>(startYear + i).toString());
        const [displayDateValue, setDisplayDateValue] = (0, $2xPiy.useState)(value ? (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(value).format('MM/DD/YYYY') : '');
        const [minDate, maxDate] = dateBounds ?? [];
        const isOutOfBounds = (date, unit)=>!!minDate && date.isBefore(minDate, unit) || !!maxDate && date.isAfter(maxDate, unit);
        const lockToBounds = (date)=>{
            if (minDate && date.isBefore(minDate, 'day')) return (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(minDate).format('YYYY-MM-DD');
            if (maxDate && date.isAfter(maxDate, 'day')) return (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(maxDate).format('YYYY-MM-DD');
            return date.format('YYYY-MM-DD');
        };
        const effectiveValue = lockToBounds(value ? (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(value) : (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))());
        const disabledYears = years.filter((year)=>isOutOfBounds((0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))().year(parseInt(year)), 'year'));
        (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).useEffect(()=>{
            if (value) setDisplayDateValue((0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(value).format('MM/DD/YYYY'));
            else setDisplayDateValue('');
        }, [
            value
        ]);
        return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            direction: "row",
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d76f119224a6c3c6$export$dec03dc0f3ef8025), {
                    id: id,
                    name: name || id,
                    value: displayDateValue,
                    onChange: (e)=>{
                        const inputValue = e.target.value;
                        setDisplayDateValue(inputValue);
                        if (!inputValue) {
                            setValue?.('');
                            return;
                        }
                        if (inputValue.length === 10) {
                            const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
                            if (dateRegex.test(inputValue)) {
                                const date = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(inputValue, 'MM/DD/YYYY');
                                if (date.isValid()) setValue?.(date.format('YYYY-MM-DD'));
                            }
                        }
                    },
                    placeholder: placeholder,
                    mask: isActiveLabel ? [
                        {
                            length: [
                                1,
                                2
                            ],
                            regexp: /^1[0-2]$|^0?[1-9]$|^0$/,
                            placeholder: 'mm'
                        },
                        {
                            fixed: '/'
                        },
                        {
                            length: [
                                1,
                                2
                            ],
                            regexp: /^[1-2][0-9]$|^3[0-1]$|^0?[1-9]$|^0$/,
                            placeholder: 'dd'
                        },
                        {
                            fixed: '/'
                        },
                        {
                            length: 4,
                            regexp: /^[1-2]$|^19$|^20$|^19[0-9]$|^20[0-9]$|^19[0-9][0-9]$|^20[0-9][0-9]$/,
                            placeholder: 'yyyy'
                        }
                    ] : undefined,
                    onFocus: ()=>setIsFocused(true),
                    onBlur: (e)=>{
                        setIsFocused(false);
                        const inputValue = e.target.value;
                        if (inputValue && inputValue.length === 10) {
                            const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
                            if (dateRegex.test(inputValue)) {
                                const date = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(inputValue, 'MM/DD/YYYY');
                                if (date.isValid()) {
                                    setValue?.(date.format('YYYY-MM-DD'));
                                    setDisplayDateValue(date.format('MM/DD/YYYY'));
                                } else setDisplayDateValue(value ? (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(value).format('MM/DD/YYYY') : '');
                            } else setDisplayDateValue(value ? (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(value).format('MM/DD/YYYY') : '');
                        } else if (inputValue && inputValue.length < 10) setDisplayDateValue(value ? (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(value).format('MM/DD/YYYY') : '');
                    },
                    reverse: true,
                    plain: true,
                    style: {
                        fontFamily: 'Lato, sans-serif',
                        height: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(58),
                        paddingTop: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(26),
                        paddingBottom: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(10)
                    },
                    className: "hide-input-arrows",
                    required: required,
                    disabled: disabled
                }),
                !disabled && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    alignSelf: "center",
                    margin: {
                        right: '18px'
                    },
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f8b1322d821ac28a$export$7edc06cf1783b30f), {
                        id: id,
                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $52cab84bc22908ed$export$e1aef45b828286de), {
                            size: "20px",
                            color: isButtonFocused ? 'accent-1' : 'text'
                        }),
                        value: effectiveValue,
                        onChange: ({ value: value })=>{
                            setValue?.((0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(typeof value === 'string' ? value : value[0]).format('YYYY-MM-DD'));
                            setIsCalendarOpen(false);
                        },
                        buttonProps: {
                            open: isCalendarOpen,
                            onOpen: ()=>setIsCalendarOpen(true),
                            onClose: ()=>setIsCalendarOpen(false)
                        },
                        calendarProps: {
                            bounds: dateBounds,
                            daysOfWeek: true,
                            showAdjacentDays: 'trim',
                            size: 'medium',
                            header: ({ date: date, onPreviousMonth: onPreviousMonth, onNextMonth: onNextMonth, previousInBound: previousInBound, nextInBound: nextInBound })=>{
                                const current = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(date);
                                const currentMonth = months[current.month()];
                                const currentYearValue = String(current.year());
                                const disabledMonths = months.filter((_, index)=>isOutOfBounds(current.month(index), 'month'));
                                return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    direction: "row",
                                    pad: {
                                        horizontal: 'small',
                                        vertical: 'xsmall'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c992d2c91441866d$export$a14ca6bc44f029a6), {
                                                size: "24px"
                                            }),
                                            onClick: onPreviousMonth,
                                            disabled: !previousInBound,
                                            plain: true
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            direction: "row",
                                            gap: "xsmall",
                                            align: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                    width: "200px",
                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b3fb5add06fccd6e$export$ef9b1a59e592288f), {
                                                        options: months,
                                                        value: currentMonth,
                                                        disabled: disabledMonths,
                                                        onChange: ({ option: option })=>setValue?.(lockToBounds(current.month(months.indexOf(option)))),
                                                        style: {
                                                            fontFamily: 'Lato, sans-serif',
                                                            fontWeight: 600,
                                                            fontSize: '18px'
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                    width: "200px",
                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b3fb5add06fccd6e$export$ef9b1a59e592288f), {
                                                        options: years,
                                                        value: currentYearValue,
                                                        disabled: disabledYears,
                                                        onChange: ({ option: option })=>setValue?.(lockToBounds(current.year(parseInt(option)))),
                                                        style: {
                                                            fontFamily: 'Lato, sans-serif',
                                                            fontWeight: 600,
                                                            fontSize: '18px'
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c7bce65ed51d571e$export$a8d2f61b02c7b95f), {
                                                size: "24px"
                                            }),
                                            onClick: onNextMonth,
                                            disabled: !nextInBound,
                                            plain: true
                                        })
                                    ]
                                });
                            },
                            style: {
                                fontFamily: 'Lato, sans-serif',
                                paddingBottom: '6px'
                            },
                            fill: true
                        },
                        dropProps: {
                            align: {
                                top: 'bottom',
                                right: 'right'
                            }
                        },
                        disabled: disabled,
                        onFocus: ()=>setIsButtonFocused(true),
                        onBlur: ()=>setIsButtonFocused(false)
                    })
                })
            ]
        });
    };
    const renderTextArea = ()=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f281159a7d882928$export$f5c9f3c2c4054eec), {
            id: id,
            name: name || id,
            placeholder: placeholder,
            minLength: minLength,
            maxLength: maxLength,
            rows: rows,
            value: typeof value === 'number' ? value?.toString() : value,
            onChange: (e)=>setValue?.(e.target.value),
            required: required,
            disabled: disabled,
            onFocus: ()=>setIsFocused(true),
            onBlur: ()=>setIsFocused(false),
            resize: false,
            fill: true,
            plain: true,
            style: {
                fontFamily: 'Lato, sans-serif',
                paddingTop: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(26),
                paddingBottom: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(10),
                minHeight: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(50),
                ...opacity !== undefined ? {
                    opacity: opacity
                } : {},
                fieldSizing: 'content'
            }
        });
    const renderPasswordInput = ()=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8c9c99ffe8765a99$export$c86715117507e8e5), {
            id: id,
            name: name || id,
            focusIndicator: false,
            placeholder: placeholder,
            minLength: minLength || 10,
            maxLength: maxLength,
            type: showPassword ? 'text' : 'password',
            value: value,
            onChange: (e)=>setValue?.(e.target.value),
            required: required,
            reverse: true,
            disabled: disabled,
            onFocus: ()=>setIsFocused(true),
            onBlur: ()=>setIsFocused(false),
            plain: true,
            style: {
                fontFamily: 'Lato, sans-serif',
                height: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(58),
                paddingTop: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(26),
                paddingBottom: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(10)
            }
        });
    const renderInputComponent = ()=>{
        switch(componentType){
            case 'date':
                return renderDateInput();
            case 'percent':
                return renderPercentInput();
            case 'percentage':
                return renderPercentInput();
            case 'password':
                return renderPasswordInput();
            case 'textArea':
                return renderTextArea();
            default:
                return renderInput();
        }
    };
    const borderColor = error ? 'red' : isFocused ? 'accent-1' : 'light-5';
    //const buttonBorderColor = isButtonFocused ? 'accent-1' : 'transparent';
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        flex: componentType === 'textArea' ? 'grow' : undefined,
        ...boxProps,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                border: disabled ? undefined : {
                    color: borderColor,
                    size: 'small'
                },
                background: disabled ? disabledBackground || 'light-6' : undefined,
                round: "6px",
                height: componentType === 'textArea' ? {
                    min: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(58)
                } : (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(58),
                flex: componentType === 'textArea' ? 'grow' : undefined,
                basis: componentType === 'textArea' ? 'auto' : undefined,
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    round: "6px",
                    direction: "row",
                    fill: "vertical",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $1e7958766884f71d$export$694e0d28c7ffc90c), {
                            anchor: isActiveLabel ? 'top-left' : 'left',
                            guidingChild: "last",
                            fill: true,
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    pad: {
                                        top: isActiveLabel ? 'xsmall' : undefined,
                                        left: 'small'
                                    },
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: isActiveLabel ? 'small' : 'medium',
                                        color: isActiveLabel ? 'accent-1' : undefined,
                                        children: [
                                            label,
                                            required && !hideRequiredMarker && '*'
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $168667f04da9206c$export$16e4d70cc375e707), {
                                    onEnter: onSubmit,
                                    children: renderInputComponent()
                                })
                            ]
                        }),
                        componentType === 'password' && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                            icon: showPassword ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $4acda1c651d988fd$export$27a5bd065ad55220), {
                                size: "medium",
                                color: isButtonFocused ? 'brand' : undefined
                            }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $17615e8310fedcd7$export$bed28288a051538), {
                                size: "medium",
                                color: isButtonFocused ? 'brand' : undefined
                            }),
                            onClick: ()=>setShowPassword(!showPassword),
                            onFocus: ()=>setIsButtonFocused(true),
                            onBlur: ()=>setIsButtonFocused(false),
                            onMouseOver: ()=>setIsButtonFocused(true),
                            onMouseOut: ()=>setIsButtonFocused(false)
                        })
                    ]
                })
            }),
            (error || fuseAdminOnly) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                row: true,
                gap: "small",
                margin: {
                    top: '0.5rem',
                    left: '0.75rem'
                },
                children: [
                    error && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        color: "red",
                        size: "0.75rem",
                        children: error
                    }),
                    error && fuseAdminOnly && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                        direction: "vertical",
                        margin: "0"
                    }),
                    fuseAdminOnly && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        color: "dark-1",
                        size: "0.75rem",
                        children: "FuSE ADMINS ONLY"
                    })
                ]
            })
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");



const $eabeffcc0be0175a$export$dec03dc0f3ef8025 = (props)=>{
    const { label: label, value: value = Number.isNaN(props.value) ? '' : props.value, setValue: setValue, id: id, name: name, error: error, placeholder: placeholder, required: required, minLength: minLength, maxLength: maxLength, hideIcon: hideIcon, hideRequiredMarker: hideRequiredMarker, centerLabel: centerLabel = true, disabled: disabled, disabledBackground: disabledBackground, autoComplete: autoComplete, componentType: componentType, onSubmit: onSubmit, isActiveLabel: _isActiveLabel, ...boxProps } = props;
    const [isFocused, setIsFocused] = (0, $2xPiy.useState)(false);
    const isActiveLabel = _isActiveLabel ?? (value !== undefined && value !== null && value !== '' || isFocused || !centerLabel || placeholder || disabled);
    const numberRegex = /^[0-9]*$/g;
    const renderNumberInput = (afterDecimal = 4)=>{
        const stringValue = value === undefined || value === null ? '' : String(value);
        const handleNumberChange = (e)=>{
            let raw = e.target.value;
            if (raw.startsWith('0.')) raw = raw.slice(2);
            const digits = raw.replace(/[^0-9]/g, '').slice(0, afterDecimal);
            setValue(digits ? `0.${digits}` : '');
        };
        return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8c9c99ffe8765a99$export$c86715117507e8e5), {
            id: id,
            name: name || id,
            placeholder: placeholder || '0.',
            inputMode: "decimal",
            value: stringValue,
            onChange: handleNumberChange,
            required: required,
            disabled: disabled,
            autoComplete: autoComplete,
            onFocus: ()=>setIsFocused(true),
            onBlur: ()=>setIsFocused(false),
            icon: !hideIcon ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                size: "20px",
                color: "dark-1",
                weight: 700,
                style: {
                    fontFamily: 'Lato, sans-serif'
                },
                children: "$"
            }) : undefined,
            reverse: true,
            plain: true,
            style: {
                fontFamily: 'Lato, sans-serif',
                height: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(58),
                paddingTop: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(26),
                paddingBottom: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(10)
            },
            className: "hide-input-arrows"
        });
    };
    const renderPercentInput = (beforeDecimal = 2, afterDecimal = 2)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d76f119224a6c3c6$export$dec03dc0f3ef8025), {
            id: id,
            name: name || id,
            placeholder: placeholder,
            minLength: minLength,
            maxLength: maxLength,
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                size: "20px",
                color: "dark-1",
                weight: 700,
                style: {
                    fontFamily: 'Lato, sans-serif'
                },
                children: "%"
            }),
            reverse: true,
            className: "percent-input hide-input-arrows",
            value: value,
            onChange: (e)=>setValue(e.target.value),
            required: required,
            disabled: disabled,
            autoComplete: autoComplete,
            onFocus: ()=>setIsFocused(true),
            onBlur: ()=>setIsFocused(false),
            plain: true,
            mask: [
                {
                    length: [
                        1,
                        beforeDecimal + 1
                    ],
                    regexp: numberRegex
                },
                {
                    fixed: '.'
                },
                {
                    length: [
                        1,
                        afterDecimal + 1
                    ],
                    regexp: numberRegex
                }
            ],
            style: {
                fontFamily: 'Lato, sans-serif',
                height: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(58),
                paddingTop: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(26),
                paddingBottom: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(10)
            }
        });
    const renderInputComponent = ()=>{
        switch(componentType){
            case 'number':
                return renderNumberInput();
            case 'percent':
                return renderPercentInput();
            case 'percentage':
                return renderPercentInput();
            default:
                return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cb4cc5db45d03478$exports.Fragment), {});
        }
    };
    const borderColor = error ? 'red' : isFocused ? 'accent-1' : 'light-5';
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        ...boxProps,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                border: disabled ? undefined : {
                    color: borderColor,
                    size: 'small'
                },
                background: disabled ? disabledBackground || 'light-6' : undefined,
                round: "6px",
                height: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(58),
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    round: "6px",
                    direction: "row",
                    fill: "vertical",
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $1e7958766884f71d$export$694e0d28c7ffc90c), {
                        anchor: isActiveLabel ? 'top-left' : 'left',
                        guidingChild: "last",
                        fill: "vertical",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                pad: {
                                    top: isActiveLabel ? 'xsmall' : undefined,
                                    left: 'small'
                                },
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    size: isActiveLabel ? 'small' : 'medium',
                                    color: isActiveLabel ? 'accent-1' : undefined,
                                    children: [
                                        label,
                                        required && !hideRequiredMarker && '*'
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $168667f04da9206c$export$16e4d70cc375e707), {
                                onEnter: onSubmit,
                                children: renderInputComponent()
                            })
                        ]
                    })
                })
            }),
            error && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                row: true,
                gap: "small",
                margin: {
                    top: '0.5rem',
                    left: '0.75rem'
                },
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    color: "red",
                    size: "0.75rem",
                    children: error
                })
            })
        ]
    });
};






var $2xPiy = parcelRequire("2xPiy");





const $73a306fd56291544$export$fa00aa2901190e49 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { value: value, setValue: setValue, multiple: multiple, selectedProgramIds: selectedProgramIds, setSelectedProgramIds: setSelectedProgramIds, programs: programs, error: error, required: required, fill: fill, width: width, hideOptionalText: hideOptionalText, hideLabel: hideLabel, emptySearchMessage: emptySearchMessage, searchPlaceholder: searchPlaceholder, label: label, placeholder: placeholder, countryId: countryId, id: id, name: name, disabled: disabled, onSubmit: onSubmit, filterOutOptions: filterOutOptions, options: options, hideSelectAll: hideSelectAll } = props;
    /** Stores **/ const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    /** State **/ const [isLoadingPrograms, setIsLoadingPrograms] = (0, $2xPiy.useState)(true);
    const [programsList, setProgramsList] = (0, $2xPiy.useState)([]);
    const [defaultSelectOptions, setDefaultSelectOptions] = (0, $2xPiy.useState)([]);
    const [selectOptions, setSelectOptions] = (0, $2xPiy.useState)([]);
    /** Methods **/ const fetchProgramsList = async (country_id)=>{
        if (!userStore.user) return;
        try {
            setIsLoadingPrograms(true);
            const programsList = programs || await (0, $06590284a0c4fd89$export$84ac2881c878ff18).list({
                country_id: country_id
            });
            setProgramsList(programsList);
            let options = programsList.map((program)=>({
                    label: program.name,
                    value: program.id
                }));
            if (filterOutOptions) options = options.filter(({ value: value })=>!filterOutOptions.includes(value));
            setSelectOptions(options);
            setDefaultSelectOptions(options);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listPrograms.error);
        } finally{
            setIsLoadingPrograms(false);
        }
    };
    const filterPrograms = (query)=>{
        if (query === '') setSelectOptions(defaultSelectOptions);
        const exp = new RegExp(query.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
        const filteredOptions = defaultSelectOptions.filter(({ label: label })=>exp.test(label));
        setSelectOptions(filteredOptions);
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (isLoadingPrograms) {
            if (!programsList.length) {
                if (programs) {
                    setProgramsList(programs);
                    const options = programs.map((program)=>({
                            label: program.name,
                            value: program.id
                        }));
                    setSelectOptions(options);
                    setDefaultSelectOptions(options);
                } else if (countryId) fetchProgramsList(countryId);
            } else setIsLoadingPrograms(false);
        }
    }, [
        programs,
        programsList,
        countryId,
        isLoadingPrograms,
        value
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (countryId) {
            if (multiple) setSelectedProgramIds?.([]);
            else setValue?.(NaN);
            fetchProgramsList(countryId);
        }
    }, [
        countryId
    ]);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
        multiple: multiple,
        id: id,
        name: id ? undefined : name || 'selected_program',
        label: label ?? 'Program',
        placeholder: placeholder,
        hideLabel: hideLabel,
        options: options ?? selectOptions,
        onOpen: ()=>filterPrograms(''),
        value: !isLoadingPrograms ? value : '',
        values: selectedProgramIds ?? [],
        fill: fill,
        width: width,
        setValue: (value)=>setValue?.(value),
        setValues: (values)=>setSelectedProgramIds?.(values),
        error: error,
        required: required,
        disabled: disabled,
        onSearch: selectOptions.length > 1 ? (query)=>filterPrograms(query) : undefined,
        emptySearchMessage: emptySearchMessage,
        searchPlaceholder: searchPlaceholder,
        onSubmit: onSubmit,
        hideOptionalText: hideOptionalText,
        hideSelectAll: hideSelectAll
    });
});




var $2xPiy = parcelRequire("2xPiy");







const $d95e777f7234893c$export$c591cf9e3b4f9db3 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { value: value, setValue: setValue, client: client, options: options, hideFinalized: hideFinalized, hideLocked: hideLocked, id: id, name: name, label: label, ...selectProps } = props;
    /** Context **/ const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const clientStore = (0, $116967e0234c3770$export$3b47afa599c78f61)();
    /** State **/ const [, setIsLoading] = (0, $2xPiy.useState)(false);
    const [reportingPeriodOptions, setReportingPeriodOptions] = (0, $2xPiy.useState)();
    /** Methods **/ const fetchOptions = async ()=>{
        if (options) {
            setReportingPeriodOptions(options);
            return;
        } else if (!client) {
            console.warn('Client must be provided to ReportingPeriodSelect when options prop is undefined');
            return;
        }
        try {
            setIsLoading(true);
            const reportingPeriods = await clientStore.fetchClientReportingPeriods(client.id, client.reporting_period_type_id, !hideFinalized, hideLocked);
            /*
        RULES
  
        - Create/Update (First Reporting Period)
          - Reporting periods should only be the client's unfinalized reporting periods
          - Do not allow client users to add facilities/equipment with a locked first reporting period
        - Retire (Last Reporting Period)
          - Don't display any periods before the facility/equipment's first active period. Obvious because you can't retire it before it existed.
          - Don't display any finalized periods EXCEPT the most recent one. They can choose the most recent finalized period because that could have been the last period the equipment was used in.
          - Don't display anything before the locked period. They can still retire in the locked period because that will only affect the period AFTER .
        */ setReportingPeriodOptions((0, $00658ccd6ec0135a$export$ccc472524c48b71f)(reportingPeriods.filter((p)=>!(0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(p.start_reporting_quarter).isBefore(client.first_active_reporting_quarter)).map((p)=>({
                    label: (0, $00658ccd6ec0135a$export$f96ebb633255a704)(p.start_reporting_quarter, client.reporting_period_type_id === (0, $0badf5665deea2b2$export$a121e4a6c908fa8f).Yearly),
                    value: p.start_reporting_quarter
                }))));
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listClientReportingPeriods.error);
        } finally{
            setIsLoading(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (!reportingPeriodOptions) fetchOptions();
    }, [
        reportingPeriodOptions
    ]);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
        value: value,
        setValue: (value)=>setValue(value),
        options: reportingPeriodOptions ?? [],
        name: id ? undefined : name || 'reporting_period_select',
        label: label ?? 'Reporting Period',
        ...selectProps
    });
});




var $2xPiy = parcelRequire("2xPiy");






const $95684e66166a88c8$var$MAX_REASON_TEXT_LENGTH = 500;
const $95684e66166a88c8$export$3109f1de68cd7ecc = ({ value: value, setValue: setValue, error: error })=>{
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
        id: "retirement_reason_other",
        label: t('common:otherReasonDescription'),
        value: value,
        setValue: setValue,
        error: error,
        componentType: "textArea",
        maxLength: $95684e66166a88c8$var$MAX_REASON_TEXT_LENGTH,
        rows: 1,
        required: true,
        fill: "horizontal",
        centerLabel: false,
        placeholder: ""
    });
};
const $95684e66166a88c8$export$516f52107d98083f = (props)=>{
    const { entityType: entityType, reasonId: reasonId, setReasonId: setReasonId, reasonText: reasonText = '', setReasonText: setReasonText, setIsOther: setIsOther, reasonError: reasonError, textError: textError, disabled: disabled, showTextField: showTextField = true, fill: fill, ...selectProps } = props;
    /** Context **/ const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** State **/ const [reasons, setReasons] = (0, $2xPiy.useState)();
    /** Methods **/ const fetchReasons = async ()=>{
        try {
            const data = await (0, $1840877422ff944e$export$12a0075dc4fe634f).list(entityType === 'equipment' ? {
                visible_to_equipment: true
            } : {
                visible_to_facilities: true
            });
            setReasons(data);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).generic.error);
        }
    };
    const isOtherReason = (id)=>(reasons ?? []).find((reason)=>reason.id === id)?.name === (0, $47b7f1ecedcfeb5f$export$3ac33485b394649b);
    const handleReasonChange = (value)=>{
        setReasonId(value);
        const isOther = isOtherReason(value);
        setIsOther?.(isOther);
        if (!isOther) setReasonText('');
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        fetchReasons();
    }, [
        entityType
    ]);
    /** Render **/ const options = (reasons ?? []).map((reason)=>({
            label: reason.name,
            value: reason.id
        }));
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        gap: "small",
        fill: fill,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                id: "retirement_reason_id",
                label: t('common:reasonForRetiring'),
                placeholder: reasons ? t('common:selectReason') : t('common:loading'),
                value: reasonId,
                setValue: handleReasonChange,
                options: options,
                error: reasonError,
                disabled: disabled || !reasons,
                required: true,
                fill: "horizontal",
                ...selectProps
            }),
            showTextField && isOtherReason(reasonId) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)($95684e66166a88c8$export$3109f1de68cd7ecc, {
                value: reasonText,
                setValue: setReasonText,
                error: textError
            })
        ]
    });
};





var $2xPiy = parcelRequire("2xPiy");

var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");






var $2xPiy = parcelRequire("2xPiy");






var $a51b175812b7eddf$export$65ae1fa19d91e9b3 = function SelectMultipleValue(_ref) {
    var _theme$selectMultiple2, _theme$selectMultiple3;
    var allOptions = _ref.allOptions, children = _ref.children, disabled = _ref.disabled, disabledKey = _ref.disabledKey, dropButtonRef = _ref.dropButtonRef, labelKey = _ref.labelKey, messages = _ref.messages, onRequestOpen = _ref.onRequestOpen, onSelectChange = _ref.onSelectChange, theme = _ref.theme, value = _ref.value, valueKey = _ref.valueKey;
    var _useState = (0, $2xPiy.useState)(false), showA11yDiv = _useState[0], setShowA11yDiv = _useState[1];
    var _useContext = (0, $2xPiy.useContext)((0, $f1ad7bf122eed3b0$export$b060d577040138d8)), format = _useContext.format;
    var isDisabled = (0, $f3173fa86fa0c94f$export$c763bb7a184a0f11)(disabled, disabledKey, allOptions, valueKey || labelKey);
    var visibleValue = (0, $2xPiy.useCallback)(function(i) {
        var optionValue = valueKey && valueKey.reduce ? (0, $f3173fa86fa0c94f$export$f9e47df77939ed56)(i, valueKey) : i;
        var optionSelected = (0, $f3173fa86fa0c94f$export$22012a5c726bef55)(value, optionValue, valueKey || labelKey);
        var indexOptions = (0, $f3173fa86fa0c94f$export$2921b90f3ed1b63a)(allOptions, i, valueKey || labelKey);
        var optionLabel = (0, $f3173fa86fa0c94f$export$dac6ace3020563ca)(indexOptions, allOptions, labelKey || valueKey);
        var optionDisabled = isDisabled(indexOptions);
        var valueIndex = (0, $f3173fa86fa0c94f$export$2921b90f3ed1b63a)(value, optionValue, valueKey || labelKey);
        if (valueIndex < theme.selectMultiple.maxInline) {
            var _theme$selectMultiple;
            var child;
            if (children) child = children(i, indexOptions, allOptions, {
                active: false,
                disabled: optionDisabled,
                selected: true
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $72edb32352a5dc2f$export$11a8a1ea41bf55d8), {
                role: "option",
                a11yTitle: format({
                    id: optionSelected ? 'selectMultiple.optionSelected' : 'selectMultiple.optionNotSelected',
                    messages: messages,
                    values: {
                        optionLabel: optionLabel
                    }
                }),
                "aria-setsize": value.length,
                "aria-posinset": valueIndex + 1,
                "aria-selected": optionSelected,
                "aria-disabled": optionDisabled,
                plain: true,
                hoverIndicator: !optionDisabled,
                fill: "horizontal",
                tabIndex: "0",
                onClick: function onClick(event) {
                    if (!optionDisabled) {
                        var intermediate = [].concat(value);
                        if ((0, $f3173fa86fa0c94f$export$22012a5c726bef55)(intermediate, optionValue, valueKey || labelKey)) {
                            onSelectChange(event, {
                                option: optionValue,
                                value: intermediate.filter(function(v) {
                                    return typeof v === 'object' ? (0, $f3173fa86fa0c94f$export$f9e47df77939ed56)(v, valueKey || labelKey) !== (0, $f3173fa86fa0c94f$export$f9e47df77939ed56)(optionValue, valueKey || labelKey) : v !== optionValue;
                                })
                            });
                            if (valueIndex !== intermediate.length - 1) setTimeout(function() {
                                var nextFocus = document.getElementById("selected-" + intermediate[valueIndex + 1]);
                                if (nextFocus) nextFocus.focus();
                                var result = intermediate[valueIndex + 1];
                                setShowA11yDiv("Unselected " + optionLabel + ". \n                        Focus moved to " + (0, $f3173fa86fa0c94f$export$dac6ace3020563ca)((0, $f3173fa86fa0c94f$export$2921b90f3ed1b63a)(allOptions, result, valueKey || labelKey), allOptions, labelKey || valueKey));
                            }, 200); // Timeout needed to allow screen reader
                            else if (intermediate.length !== 1) setTimeout(function() {
                                var nextFocus = document.getElementById("selected-" + intermediate[valueIndex - 1]);
                                if (nextFocus) nextFocus.focus();
                                var result = intermediate[valueIndex - 1];
                                setShowA11yDiv("Unselected " + optionLabel + ". Focus moved to \n                          " + (0, $f3173fa86fa0c94f$export$dac6ace3020563ca)((0, $f3173fa86fa0c94f$export$2921b90f3ed1b63a)(allOptions, result, valueKey || labelKey), allOptions, labelKey || valueKey));
                            }, 200); // Timeout needed to allow screen reader
                            else if (dropButtonRef.current) dropButtonRef.current.focus();
                        }
                    }
                },
                key: optionLabel,
                id: "selected-" + optionValue
            }, child || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                disabled: optionDisabled,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                    alignSelf: "center",
                    align: "start"
                }, optionLabel),
                key: optionLabel,
                pad: (_theme$selectMultiple = theme.selectMultiple) == null || (_theme$selectMultiple = _theme$selectMultiple.option) == null ? void 0 : _theme$selectMultiple.pad,
                tabIndex: "-1",
                checked: optionSelected,
                inert: (0, $f3173fa86fa0c94f$export$6f8d7bb3dad10aa1),
                containerProps: {
                    // in Firefox when we have inert set, the checkbox
                    // click event gets swallowed by the checkbox.
                    // We need the click event to go the the button
                    // around the checkbox so we use pointerEvents =
                    // none. For code clarity we decided an inline
                    // style made sense here.
                    style: {
                        pointerEvents: 'none'
                    }
                }
            }));
        }
        return undefined;
    }, [
        allOptions,
        children,
        dropButtonRef,
        format,
        isDisabled,
        labelKey,
        messages,
        onSelectChange,
        theme.selectMultiple.maxInline,
        (_theme$selectMultiple2 = theme.selectMultiple) == null || (_theme$selectMultiple2 = _theme$selectMultiple2.option) == null ? void 0 : _theme$selectMultiple2.pad,
        value,
        valueKey
    ]);
    // After announcing set showA11yDiv to undefined so it won't
    // be read out again
    (0, $2xPiy.useEffect)(function() {
        if (showA11yDiv !== undefined) setTimeout(function() {
            setShowA11yDiv(undefined);
        }, 1000);
    }, [
        showA11yDiv
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        width: "100%",
        role: "listbox",
        "aria-multiselectable": true,
        a11yTitle: format({
            id: 'selectMultiple.selectedOptions',
            messages: messages
        })
    }, value && allOptions.filter(function(i) {
        return (0, $f3173fa86fa0c94f$export$22012a5c726bef55)(value, valueKey && valueKey.reduce ? (0, $f3173fa86fa0c94f$export$f9e47df77939ed56)(i, valueKey) : i, valueKey || labelKey);
    }).map(function(i) {
        return visibleValue(i);
    }), showA11yDiv && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        height: "0px",
        width: "0px",
        overflow: "hidden",
        "aria-live": "assertive",
        role: "alert"
    }, showA11yDiv)), value && value.length > theme.selectMultiple.maxInline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        pad: (_theme$selectMultiple3 = theme.selectMultiple) == null || (_theme$selectMultiple3 = _theme$selectMultiple3.showMore) == null ? void 0 : _theme$selectMultiple3.pad,
        alignSelf: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
        onClick: onRequestOpen,
        size: "small",
        label: format({
            id: 'selectMultiple.showMore',
            messages: messages,
            values: {
                remaining: value.length - theme.selectMultiple.maxInline
            }
        })
    })));
};



var $2xPiy = parcelRequire("2xPiy");










var $2xPiy = parcelRequire("2xPiy");






var $e231e68c0f6c852d$export$4d281ebdf277250c = function SelectionSummary(_ref) {
    var _theme$selectMultiple, _theme$selectMultiple2, _theme$selectMultiple3, _theme$selectMultiple4;
    var allOptions = _ref.allOptions, clearRef = _ref.clearRef, disabled = _ref.disabled, disabledKey = _ref.disabledKey, isSelected = _ref.isSelected, labelKey = _ref.labelKey, limit = _ref.limit, messages = _ref.messages, onChange = _ref.onChange, onMore = _ref.onMore, options = _ref.options, search = _ref.search, setActiveIndex = _ref.setActiveIndex, showSelectedInline = _ref.showSelectedInline, value = _ref.value, valueKey = _ref.valueKey;
    var _useContext = (0, $2xPiy.useContext)((0, $f1ad7bf122eed3b0$export$b060d577040138d8)), format = _useContext.format;
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var isDisabled = (0, $f3173fa86fa0c94f$export$c763bb7a184a0f11)(disabled, disabledKey, options, valueKey || labelKey);
    var selectedValuesDisabled = (0, $2xPiy.useCallback)(function() {
        var disabledSelected = 0;
        if (value) {
            for(var i = 0; i < allOptions.length; i += 1)if ((0, $f3173fa86fa0c94f$export$22012a5c726bef55)(value, (0, $f3173fa86fa0c94f$export$40be908210c5a79c)(i, options, valueKey || labelKey), valueKey || labelKey) && isDisabled(i)) disabledSelected += 1;
            if (value.length === disabledSelected) return true;
        }
        return false;
    }, [
        value,
        allOptions,
        options,
        valueKey,
        labelKey,
        isDisabled
    ]);
    var selectedInSearch = (0, $2xPiy.useCallback)(function() {
        return options == null ? void 0 : options.filter(function(option) {
            return (0, $f3173fa86fa0c94f$export$22012a5c726bef55)(value, option, valueKey || labelKey);
        });
    }, [
        options,
        value,
        valueKey,
        labelKey
    ]);
    var showSelectAll = !!((value == null ? void 0 : value.length) === 0 || selectedValuesDisabled() || !value || selectedInSearch().length === 0);
    var messageId = (value == null ? void 0 : value.length) === 0 || onMore || !value || search !== '' && search !== undefined ? 'selectMultiple.selected' : 'selectMultiple.selectedOfTotal';
    var summaryText = format({
        id: messageId,
        messages: messages,
        values: {
            selected: (value == null ? void 0 : value.length) || 0,
            total: options.length
        }
    });
    var summaryButtonClick = function summaryButtonClick(event) {
        if (onChange) {
            var nextSelected = options.filter(function(i, index) {
                return showSelectAll ? !isDisabled(index) || isSelected(index) : isDisabled(index) && isSelected(index);
            });
            if (search !== '' && search !== undefined && value) {
                if (showSelectAll) nextSelected = nextSelected.concat(value);
                else value.forEach(function(item) {
                    if (!(0, $f3173fa86fa0c94f$export$22012a5c726bef55)(options, item, valueKey || labelKey)) nextSelected.push(item);
                });
            }
            var nextValue = nextSelected.map(function(i) {
                return valueKey && valueKey.reduce ? (0, $f3173fa86fa0c94f$export$f9e47df77939ed56)(i, valueKey) : i;
            });
            onChange(event, {
                option: options,
                value: nextValue,
                selected: nextSelected
            });
        }
        if (limit && !showSelectAll) setActiveIndex(0);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        pad: showSelectedInline ? (_theme$selectMultiple = theme.selectMultiple) == null || (_theme$selectMultiple = _theme$selectMultiple.summary) == null || (_theme$selectMultiple = _theme$selectMultiple.showSelectedInline) == null ? void 0 : _theme$selectMultiple.pad : (_theme$selectMultiple2 = theme.selectMultiple) == null || (_theme$selectMultiple2 = _theme$selectMultiple2.summary) == null ? void 0 : _theme$selectMultiple2.pad,
        direction: "row",
        justify: "between",
        gap: (_theme$selectMultiple3 = theme.selectMultiple) == null || (_theme$selectMultiple3 = _theme$selectMultiple3.summary) == null ? void 0 : _theme$selectMultiple3.gap,
        fill: "horizontal",
        flex: showSelectedInline,
        align: "center",
        height: (_theme$selectMultiple4 = theme.selectMultiple) == null || (_theme$selectMultiple4 = _theme$selectMultiple4.summary) == null ? void 0 : _theme$selectMultiple4.height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), {
        size: "small"
    }, summaryText), (options.length && (!limit || !(!value || (value == null ? void 0 : value.length) === 0 && selectedValuesDisabled()))) > 0 && (!onMore || onMore && (value == null ? void 0 : value.length) !== 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
        a11yTitle: showSelectAll ? format({
            id: 'selectMultiple.selectAllA11y',
            messages: messages,
            values: {
                total: options.length
            }
        }) : format({
            id: 'selectMultiple.clearAllA11y',
            messages: messages,
            values: {
                selected: (value == null ? void 0 : value.length) || 0
            }
        }),
        label: format({
            id: showSelectAll ? 'selectMultiple.selectAll' : 'selectMultiple.clearAll',
            messages: messages
        }),
        onClick: function onClick(event) {
            return summaryButtonClick(event);
        },
        onFocus: function onFocus() {
            return setActiveIndex(-1);
        },
        ref: clearRef
    }));
};







function $1c97903eeb8589f7$var$_extends() {
    return $1c97903eeb8589f7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1c97903eeb8589f7$var$_extends.apply(null, arguments);
}
var $1c97903eeb8589f7$export$2dd06c00b4faaa63 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var _theme$select$icons, _theme$selectMultiple2;
    var allOptions = _ref.allOptions, _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children, disabledProp = _ref.disabled, disabledKey = _ref.disabledKey, dropHeight = _ref.dropHeight, _ref$emptySearchMessa = _ref.emptySearchMessage, emptySearchMessage = _ref$emptySearchMessa === void 0 ? 'No matches found' : _ref$emptySearchMessa, help = _ref.help, icon = _ref.icon, id = _ref.id, labelKey = _ref.labelKey, limit = _ref.limit, messages = _ref.messages, onChange = _ref.onChange, onClose = _ref.onClose, onKeyDown = _ref.onKeyDown, onMore = _ref.onMore, onSearch = _ref.onSearch, optionIndexesInValue = _ref.optionIndexesInValue, options = _ref.options, _ref$replace = _ref.replace, replace = _ref$replace === void 0 ? true : _ref$replace, searchPlaceholder = _ref.searchPlaceholder, search = _ref.search, setSearch = _ref.setSearch, usingKeyboard = _ref.usingKeyboard, _ref$value = _ref.value, value = _ref$value === void 0 ? [] : _ref$value, valueKey = _ref.valueKey, showSelectedInline = _ref.showSelectedInline;
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    // the currently active option based on keyboard navigation
    // or mouse hover, -1 means no active option
    var _useState = (0, $2xPiy.useState)(-1), activeIndex = _useState[0], setActiveIndex = _useState[1];
    var _useState2 = (0, $2xPiy.useState)(usingKeyboard), keyboardNavigation = _useState2[0], setKeyboardNavigation = _useState2[1];
    var _useContext = (0, $2xPiy.useContext)((0, $f1ad7bf122eed3b0$export$b060d577040138d8)), format = _useContext.format;
    var searchRef = (0, $2xPiy.useRef)();
    var optionsRef = (0, $2xPiy.useRef)();
    var _useState3 = (0, $2xPiy.useState)(disabledProp), disabled = _useState3[0], setDisabled = _useState3[1];
    // the node of the currently active option, as activeIndex changes
    // this is updated too and the useEffect below ensures the
    // active option remains in keyboard focus since we're
    // following roving tab index pattern
    var activeRef = (0, $2xPiy.useRef)();
    var _useState4 = (0, $2xPiy.useState)(), showA11yLimit = _useState4[0], setShowA11yLimit = _useState4[1];
    var clearRef = (0, $2xPiy.useRef)();
    var isDisabled = (0, $f3173fa86fa0c94f$export$c763bb7a184a0f11)(disabled, disabledKey, options, valueKey || labelKey);
    var searchIcon = ((_theme$select$icons = theme.select.icons) == null ? void 0 : _theme$select$icons.search) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $ac084058cd06093e$export$4b85d3515bd863a5), {
        "aria-hidden": true
    });
    // for keyboard/screenreader, keep the active option in focus
    (0, $2xPiy.useEffect)(function() {
        var _activeRef$current;
        if (activeIndex) (_activeRef$current = activeRef.current) == null || _activeRef$current.focus();
    }, [
        activeIndex
    ]);
    // set initial focus
    (0, $2xPiy.useEffect)(function() {
        // need to wait for Drop to be ready
        var timer = setTimeout(function() {
            var clearButton = clearRef.current;
            if (clearButton && clearButton.focus) (0, $83f2052c15a18307$export$99137e580254b26a)(clearButton);
            else if (searchRef && searchRef.current) {
                var searchInput = searchRef.current;
                if (searchInput && searchInput.focus) (0, $83f2052c15a18307$export$99137e580254b26a)(searchInput);
            } else if (activeRef.current) (0, $83f2052c15a18307$export$99137e580254b26a)(activeRef.current);
            else if (optionsRef.current) setActiveIndex(0);
        }, 100); // Drop should be open after 100ms
        return function() {
            return clearTimeout(timer);
        };
    }, []);
    (0, $2xPiy.useEffect)(function() {
        var optionsNode = optionsRef.current;
        if (optionsNode != null && optionsNode.children) {
            var optionNode = optionsNode.children[activeIndex];
            if (optionNode) optionNode.focus();
        }
    }, [
        activeIndex
    ]);
    var isSelected = (0, $2xPiy.useCallback)(function(index) {
        var result;
        var optionVal = (0, $f3173fa86fa0c94f$export$40be908210c5a79c)(index, options, valueKey || labelKey);
        if (value) {
            if (value.length === 0) result = false;
            else if (typeof value[0] !== 'object') result = value.indexOf(optionVal) !== -1;
            else if (valueKey) result = value.some(function(valueItem) {
                var valueValue = typeof valueKey === 'function' ? valueKey(valueItem) : valueItem[valueKey];
                return valueValue === optionVal;
            });
        }
        return result;
    }, [
        value,
        valueKey,
        options,
        labelKey
    ]);
    var selectOption = (0, $2xPiy.useCallback)(function(index) {
        return function(event) {
            if (onChange) {
                var nextOptionIndexesInValue = optionIndexesInValue.slice(0);
                var allOptionsIndex = (0, $f3173fa86fa0c94f$export$2921b90f3ed1b63a)(allOptions, options[index], valueKey || labelKey);
                var valueIndex = optionIndexesInValue.indexOf(allOptionsIndex);
                if (valueIndex === -1 && (!limit || (value == null ? void 0 : value.length) < limit)) nextOptionIndexesInValue.push(allOptionsIndex);
                else nextOptionIndexesInValue.splice(valueIndex, 1);
                var nextValue = nextOptionIndexesInValue.map(function(i) {
                    return valueKey && valueKey.reduce ? (0, $f3173fa86fa0c94f$export$f9e47df77939ed56)(allOptions[i], valueKey) : allOptions[i];
                });
                var nextSelected = nextOptionIndexesInValue;
                onChange(event, {
                    option: options[index],
                    value: nextValue,
                    selected: nextSelected
                });
            }
        };
    }, [
        labelKey,
        limit,
        onChange,
        optionIndexesInValue,
        options,
        allOptions,
        valueKey,
        value
    ]);
    var onNextOption = (0, $2xPiy.useCallback)(function(event) {
        event.preventDefault();
        var nextActiveIndex = activeIndex + 1;
        // checking activeIndex > -1 ensures arrow keys don't
        // move focus when select all/clear all button or search input
        // are focused
        if (nextActiveIndex !== (options == null ? void 0 : options.length) && activeIndex > -1) {
            setActiveIndex(nextActiveIndex);
            setKeyboardNavigation(true);
        }
    }, [
        activeIndex,
        options
    ]);
    var onPreviousOption = (0, $2xPiy.useCallback)(function(event) {
        event.preventDefault();
        var nextActiveIndex = activeIndex - 1;
        // checking activeIndex > -1 ensures arrow keys don't
        // move focus when select all/clear all button or search input
        // are focused
        if (activeIndex > -1) {
            setActiveIndex(Math.max(nextActiveIndex, 0));
            setKeyboardNavigation(true);
        }
    }, [
        activeIndex
    ]);
    var onKeyDownOption = (0, $2xPiy.useCallback)(function(event) {
        if (!onSearch) {
            var nextActiveIndex = options.findIndex(function(e) {
                var label;
                if (typeof e === 'object') label = e.label || (0, $f3173fa86fa0c94f$export$f9e47df77939ed56)(e, labelKey);
                else label = e;
                return typeof label === 'string' && label.charAt(0).toLowerCase() === event.key.toLowerCase();
            });
            if (nextActiveIndex >= 0) {
                event.preventDefault();
                setActiveIndex(nextActiveIndex);
                setKeyboardNavigation(true);
            }
        }
        if (onKeyDown) onKeyDown(event);
    }, [
        onKeyDown,
        options,
        onSearch,
        labelKey
    ]);
    var onActiveOption = (0, $2xPiy.useCallback)(function(index) {
        return function() {
            if (!keyboardNavigation) setActiveIndex(index);
        };
    }, [
        keyboardNavigation
    ]);
    var onSelectOption = (0, $2xPiy.useCallback)(function(event) {
        if (!isDisabled(activeIndex) && activeIndex >= 0 && activeIndex < (options == null ? void 0 : options.length)) {
            event.preventDefault(); // prevent submitting forms
            selectOption(activeIndex)(event);
        }
    }, [
        activeIndex,
        selectOption,
        options,
        isDisabled
    ]);
    var customSearchInput = theme.select.searchInput;
    var SelectTextInput = customSearchInput || (0, $8c9c99ffe8765a99$export$c86715117507e8e5);
    var selectOptionsStyle = theme.select.options ? $1c97903eeb8589f7$var$_extends({}, theme.select.options.box, theme.select.options.container) : {};
    // handle when limit is reached
    (0, $2xPiy.useEffect)(function() {
        var originallyDisabled = function originallyDisabled(index) {
            var option = allOptions[index];
            var result;
            if (disabledKey) result = (0, $f3173fa86fa0c94f$export$f9e47df77939ed56)(option, disabledKey);
            else if (Array.isArray(disabledProp)) {
                if (typeof disabledProp[0] === 'number') result = disabledProp.indexOf(index) !== -1;
                else result = (0, $f3173fa86fa0c94f$export$2921b90f3ed1b63a)(disabledProp, (0, $f3173fa86fa0c94f$export$40be908210c5a79c)(index, options, valueKey || labelKey), valueKey || labelKey) !== -1;
            }
            return result;
        };
        if (value && limit) {
            if (value.length === limit) {
                var newDisabled = [].concat(disabledProp);
                // disable everything that is not selected
                for(var i = 0; i < (options == null ? void 0 : options.length); i += 1)if (!isSelected(i) && !originallyDisabled(i)) newDisabled.push(options[i]);
                if (usingKeyboard) setShowA11yLimit('Selected. Maximum selection limit reached.');
                setDisabled(newDisabled);
            } else {
                if (usingKeyboard) setShowA11yLimit(undefined);
                setDisabled(disabledProp);
            }
        }
    }, [
        isSelected,
        value,
        limit,
        disabledProp,
        allOptions,
        disabledKey,
        labelKey,
        options,
        usingKeyboard,
        valueKey
    ]);
    // reset showA11yLimit after announcement is read
    (0, $2xPiy.useEffect)(function() {
        if (showA11yLimit !== undefined) setTimeout(function() {
            setShowA11yLimit(undefined);
        }, 2000); // value chosen based on length of a11yLimit message
    }, [
        showA11yLimit
    ]);
    var summaryContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $e231e68c0f6c852d$export$4d281ebdf277250c), {
        allOptions: allOptions,
        clearRef: clearRef,
        disabled: disabled,
        disabledKey: disabledKey,
        isSelected: isSelected,
        labelKey: labelKey,
        limit: limit,
        messages: messages,
        onChange: onChange,
        onMore: onMore,
        options: options,
        search: search,
        setActiveIndex: setActiveIndex,
        showSelectedInline: showSelectedInline,
        value: value,
        valueKey: valueKey
    });
    var helpContent;
    if (help) {
        var _theme$selectMultiple;
        if (typeof help === 'string') helpContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            flex: false,
            pad: (_theme$selectMultiple = theme.selectMultiple) == null || (_theme$selectMultiple = _theme$selectMultiple.help) == null || (_theme$selectMultiple = _theme$selectMultiple.container) == null ? void 0 : _theme$selectMultiple.pad
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), {
            size: "small"
        }, help));
        else helpContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            flex: false
        }, help);
    }
    if (showSelectedInline) summaryContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        direction: "row",
        justify: "between",
        flex: false
    }, summaryContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
        fill: "vertical",
        onClick: onClose,
        a11yTitle: "Close Select"
    }, icon)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $168667f04da9206c$export$16e4d70cc375e707), {
        onEnter: onSelectOption,
        onSpace: onSelectOption,
        onUp: onPreviousOption,
        onDown: onNextOption,
        onKeyDown: onKeyDownOption,
        onEsc: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $72edb32352a5dc2f$export$1d41361302b577a1), {
        ref: ref,
        id: id ? id + "__select-drop" : undefined,
        dropHeight: dropHeight,
        a11yTitle: format({
            id: 'selectMultiple.selectDrop',
            messages: messages
        })
    }, summaryContent, onSearch && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        pad: !customSearchInput ? (_theme$selectMultiple2 = theme.selectMultiple) == null || (_theme$selectMultiple2 = _theme$selectMultiple2.search) == null ? void 0 : _theme$selectMultiple2.pad : undefined,
        flex: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $168667f04da9206c$export$16e4d70cc375e707), {
        onEnter: function onEnter(event) {
            onNextOption(event);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(SelectTextInput, {
        a11yTitle: format({
            id: 'selectMultiple.search',
            messages: messages
        }),
        focusIndicator: !customSearchInput,
        size: "small",
        ref: searchRef,
        type: "search",
        value: search || '',
        placeholder: searchPlaceholder,
        onChange: function onChange(event) {
            var nextSearch = event.target.value;
            setSearch(nextSearch);
            setActiveIndex(-1);
            onSearch(nextSearch);
        },
        onFocus: function onFocus() {
            return setActiveIndex(-1);
        },
        icon: searchIcon
    }))), helpContent, (options == null ? void 0 : options.length) > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $72edb32352a5dc2f$export$1a780bb4ae54ddec), {
        "aria-label": format({
            id: 'selectMultiple.optionsA11y',
            messages: messages
        }),
        role: "listbox",
        tabIndex: "-1",
        ref: optionsRef,
        "aria-multiselectable": true,
        onMouseMove: function onMouseMove() {
            return setKeyboardNavigation(false);
        },
        selectMultiple: true // internal prop
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $26613b622f673475$export$c5295390d6167a3e), {
        items: options,
        step: theme.select.step,
        onMore: onMore,
        replace: replace,
        show: activeIndex !== -1 ? activeIndex : undefined
    }, function(option, index, optionRef) {
        var optionDisabled = isDisabled(index);
        var optionSelected = value ? (0, $f3173fa86fa0c94f$export$22012a5c726bef55)(value, valueKey && valueKey.reduce ? (0, $f3173fa86fa0c94f$export$f9e47df77939ed56)(option, valueKey) : option, valueKey || labelKey) : false;
        var optionActive = activeIndex === index;
        var optionLabel = (0, $f3173fa86fa0c94f$export$dac6ace3020563ca)(index, options, labelKey || valueKey);
        // Determine whether the label is done as a child or
        // as an option Button kind property.
        var child;
        var textComponent = false;
        if (children) {
            child = children(option, index, options, {
                active: optionActive,
                disabled: optionDisabled,
                selected: optionSelected
            });
            if (typeof child === 'string' || child.props && child.props.children && typeof child.props.children === 'string') textComponent = true;
        } else {
            var _theme$selectMultiple3;
            child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                    alignSelf: "center",
                    width: "100%",
                    align: "start"
                }, optionLabel),
                pad: (_theme$selectMultiple3 = theme.selectMultiple) == null || (_theme$selectMultiple3 = _theme$selectMultiple3.option) == null ? void 0 : _theme$selectMultiple3.pad,
                tabIndex: "-1",
                checked: optionSelected,
                disabled: optionDisabled,
                inert: (0, $f3173fa86fa0c94f$export$6f8d7bb3dad10aa1),
                containerProps: {
                    // in Firefox when we have inert set, the checkbox
                    // click event gets swallowed by the checkbox.
                    // We need the click event to go the the button
                    // around the checkbox so we use pointerEvents =
                    // none. For code clarity we decided an inline
                    // style made sense here.
                    style: {
                        pointerEvents: 'none'
                    }
                }
            });
        }
        if (!children && search) {
            var searchText = search.toLowerCase();
            if (typeof optionLabel === 'string' && optionLabel.toLowerCase().indexOf(searchText) >= 0) {
                var _theme$selectMultiple4;
                // code to bold search term in matching options
                var boldIndex = optionLabel.toLowerCase().indexOf(searchText);
                var childBeginning = optionLabel.substring(0, boldIndex);
                var childBold = optionLabel.substring(boldIndex, boldIndex + searchText.length);
                childBold = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("b", null, childBold);
                var childEnd = optionLabel.substring(boldIndex + searchText.length);
                child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        alignSelf: "center",
                        width: "100%",
                        align: "start",
                        direction: "row"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), null, childBeginning, childBold, childEnd)),
                    pad: (_theme$selectMultiple4 = theme.selectMultiple) == null || (_theme$selectMultiple4 = _theme$selectMultiple4.option) == null ? void 0 : _theme$selectMultiple4.pad,
                    tabIndex: "-1",
                    checked: optionSelected,
                    disabled: optionDisabled,
                    inert: (0, $f3173fa86fa0c94f$export$6f8d7bb3dad10aa1),
                    containerProps: {
                        // in Firefox when we have inert set, the checkbox
                        // click event gets swallowed by the checkbox.
                        // We need the click event to go the the button
                        // around the checkbox so we use pointerEvents =
                        // none. For code clarity we decided an inline
                        // style made sense here.
                        style: {
                            pointerEvents: 'none'
                        }
                    }
                });
            }
        }
        // if we have a child, turn on plain, and hoverIndicator
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $72edb32352a5dc2f$export$11a8a1ea41bf55d8), {
            a11yTitle: format({
                id: optionSelected ? 'selectMultiple.optionSelected' : 'selectMultiple.optionNotSelected',
                messages: messages,
                values: {
                    optionLabel: optionLabel
                }
            }),
            key: index,
            ref: function ref(node) {
                // eslint-disable-next-line no-param-reassign
                if (optionRef) optionRef.current = node;
                if (optionActive) activeRef.current = node;
            },
            tabIndex: optionSelected || activeIndex === index || // when nothing is selected and entering listbox
            // first option should be focused
            value.length === 0 && activeIndex === -1 && index === 0 ? '0' : '-1',
            role: "option",
            id: "option" + index,
            "aria-setsize": options.length,
            "aria-posinset": index + 1,
            "aria-selected": optionSelected,
            focusIndicator: usingKeyboard,
            "aria-disabled": optionDisabled || undefined,
            plain: !child ? undefined : true,
            align: "start",
            kind: !child ? 'option' : undefined,
            active: optionActive,
            selected: optionSelected,
            onMouseOver: !optionDisabled ? onActiveOption(index) : undefined,
            onClick: !optionDisabled ? selectOption(index) : undefined,
            onFocus: function onFocus() {
                return setActiveIndex(index);
            },
            textComponent: textComponent
        }, child);
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $8c72eb2f36aa176e$export$e87a5b03dc8a6193), {
        emptySearchMessage: emptySearchMessage,
        selectOptionsStyle: selectOptionsStyle,
        theme: theme
    }), usingKeyboard && showA11yLimit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        height: "0px",
        width: "0px",
        overflow: "hidden",
        "aria-live": "assertive",
        role: "alert"
    }, showA11yLimit)));
});







var $dyr1f = parcelRequire("dyr1f");

function $35f8e57c28fe8470$var$_extends() {
    return $35f8e57c28fe8470$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $35f8e57c28fe8470$var$_extends.apply(null, arguments);
}
var $35f8e57c28fe8470$var$PropType = {};
$35f8e57c28fe8470$var$PropType = $35f8e57c28fe8470$var$_extends({}, (0, $5f8300a4b3c3eeae$export$257cf46788f4f52b), {
    defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number
    ])),
    help: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node,
    limit: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
    messages: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        clearAll: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        clearAllA11y: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        // "multiple" kept for backwards compatibility,
        // but summarizedValue should be used instead
        multiple: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        open: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        optionNotSelected: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        optionSelected: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        optionsA11y: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        selectAll: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        selectAllA11y: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        selectDrop: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        selected: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        selectedOfTotal: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        selectedOptions: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        showMore: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        summarizedValue: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    }),
    showSelectedInline: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    sortSelectedOnClose: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number
    ]))
});
var $35f8e57c28fe8470$export$81241bedce0a1d47 = $35f8e57c28fe8470$var$PropType;



var $8333ace9bbd5fe81$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "aria-labelledby",
    "alignSelf",
    "children",
    "defaultValue",
    "disabled",
    "disabledKey",
    "dropAlign",
    "dropHeight",
    "dropProps",
    "dropTarget",
    "emptySearchMessage",
    "focusIndicator",
    "gridArea",
    "help",
    "id",
    "icon",
    "labelKey",
    "limit",
    "margin",
    "messages",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onClose",
    "onFocus",
    "onKeyDown",
    "onMore",
    "onOpen",
    "onSearch",
    "open",
    "options",
    "placeholder",
    "plain",
    "replace",
    "searchPlaceholder",
    "size",
    "sortSelectedOnClose",
    "value",
    "valueKey",
    "valueLabel",
    "showSelectedInline",
    "width"
];
function $8333ace9bbd5fe81$var$_extends() {
    return $8333ace9bbd5fe81$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8333ace9bbd5fe81$var$_extends.apply(null, arguments);
}
function $8333ace9bbd5fe81$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $8333ace9bbd5fe81$var$StyledSelectBox = (0, $iA1nz.default)((0, $18c0523379e5dd9d$export$e71c4d32a2263218)).withConfig({
    displayName: "SelectMultiple__StyledSelectBox",
    componentId: "sc-18zwyth-0"
})([
    "",
    ";",
    ";",
    ";"
], function(props) {
    return !props.plainSelect && (0, $73ba8e2d301b823f$export$717407de81592eca);
}, function(props) {
    var _props$theme$select;
    return (_props$theme$select = props.theme.select) == null || (_props$theme$select = _props$theme$select.control) == null ? void 0 : _props$theme$select.extend;
}, function(props) {
    var _props$theme$select$c;
    return props.open && ((_props$theme$select$c = props.theme.select.control) == null ? void 0 : _props$theme$select$c.open);
});
var $8333ace9bbd5fe81$export$12a18ac91a0d2aeb = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], ariaLabelledByProp = _ref['aria-labelledby'], alignSelf = _ref.alignSelf, children = _ref.children, defaultValue = _ref.defaultValue, disabled = _ref.disabled, disabledKey = _ref.disabledKey, dropAlignProp = _ref.dropAlign, dropHeight = _ref.dropHeight, dropProps = _ref.dropProps, dropTarget = _ref.dropTarget, emptySearchMessage = _ref.emptySearchMessage, focusIndicator = _ref.focusIndicator, gridArea = _ref.gridArea, help = _ref.help, id = _ref.id, icon = _ref.icon, labelKey = _ref.labelKey, limit = _ref.limit, margin = _ref.margin, messages = _ref.messages, name = _ref.name, onBlur = _ref.onBlur, onChange = _ref.onChange, onClick = _ref.onClick, onClose = _ref.onClose, onFocus = _ref.onFocus, onKeyDown = _ref.onKeyDown, onMore = _ref.onMore, onOpen = _ref.onOpen, onSearch = _ref.onSearch, openProp = _ref.open, optionsProp = _ref.options, placeholder = _ref.placeholder, plain = _ref.plain, replace = _ref.replace, searchPlaceholder = _ref.searchPlaceholder, size = _ref.size, _ref$sortSelectedOnCl = _ref.sortSelectedOnClose, sortSelectedOnClose = _ref$sortSelectedOnCl === void 0 ? true : _ref$sortSelectedOnCl, valueProp = _ref.value, valueKey = _ref.valueKey, valueLabel = _ref.valueLabel, _ref$showSelectedInli = _ref.showSelectedInline, showSelectedInline = _ref$showSelectedInli === void 0 ? false : _ref$showSelectedInli, width = _ref.width, rest = $8333ace9bbd5fe81$var$_objectWithoutPropertiesLoose(_ref, $8333ace9bbd5fe81$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var inputRef = (0, $2xPiy.useRef)();
    var formContext = (0, $2xPiy.useContext)((0, $55ac84ad3d20c8d4$export$c24727297075ec6a));
    var _useContext = (0, $2xPiy.useContext)((0, $f1ad7bf122eed3b0$export$b060d577040138d8)), format = _useContext.format;
    var selectBoxRef = (0, $2xPiy.useRef)();
    var dropButtonRef = (0, $3cecef11d3b9c451$export$61dc559f8a0b9bcf)(ref);
    var usingKeyboard = (0, $fc2b59dcdb1fd3de$export$8f71654801c2f7cd)();
    var formFieldData = formContext == null ? void 0 : formContext.useFormField({});
    var dropAlign = (0, $2xPiy.useMemo)(function() {
        return dropAlignProp || (showSelectedInline ? {
            top: 'top',
            right: 'right',
            left: 'left'
        } : {
            top: 'bottom',
            left: 'left'
        });
    }, [
        dropAlignProp,
        showSelectedInline
    ]);
    // value is used for what we receive in valueProp and the basis for
    // what we send with onChange
    // When 'valueKey' sets 'reduce', the value(s) here should match
    // what the 'valueKey' would return for the corresponding
    // selected option object.
    // Otherwise, the value(s) should match the selected options.
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp,
        initialValue: defaultValue || ''
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    var _useState = (0, $2xPiy.useState)(), ariaLabelledBy = _useState[0], setAriaLabelledBy = _useState[1];
    (0, $2xPiy.useEffect)(function() {
        if (formFieldData != null && formFieldData.inForm && id && !ariaLabel && !placeholder) {
            var labelElement = document.getElementById("grommet-" + id + "__input__label");
            if (labelElement) setAriaLabelledBy("grommet-" + id + "__input__label " + id);
        }
    }, [
        formFieldData == null ? void 0 : formFieldData.inForm,
        id,
        ariaLabel,
        placeholder
    ]);
    // normalizedValue is the value mapped with any valueKey applied
    // When the options array contains objects, this property indicates how
    // to retrieve the value of each option.
    // If a string is provided, it is used as the key to retrieve a
    // property of an option object.
    // If a function is provided, it is called with the option and should
    // return the value.
    // If reduce is true, this value will be used for the 'value'
    // delivered via 'onChange'.
    var normalizedValue = (0, $2xPiy.useMemo)(function() {
        return (0, $f3173fa86fa0c94f$export$49df40d5c24cf7e3)(value, valueKey);
    }, [
        value,
        valueKey
    ]);
    // search input value
    var _useState2 = (0, $2xPiy.useState)(), search = _useState2[0], setSearch = _useState2[1];
    // All select option indices and values
    var _useState3 = (0, $2xPiy.useState)(optionsProp), allOptions = _useState3[0], setAllOptions = _useState3[1];
    var _useState4 = (0, $2xPiy.useState)(), orderedOptions = _useState4[0], setOrderedOptions = _useState4[1];
    // Track changes to options property, except when options are being
    // updated due to search activity. Allows option's initial index value
    // to be referenced when filtered by search.
    (0, $2xPiy.useEffect)(function() {
        if (!search) setAllOptions(optionsProp);
    }, [
        optionsProp,
        search
    ]);
    (0, $2xPiy.useEffect)(function() {
        if (search && optionsProp && optionsProp.length > 0) {
            var additionalOptions = [].concat(allOptions);
            optionsProp.forEach(function(i) {
                return !additionalOptions.some(function(j) {
                    return typeof i === 'object' ? (0, $f3173fa86fa0c94f$export$f9e47df77939ed56)(i, valueKey) === (0, $f3173fa86fa0c94f$export$f9e47df77939ed56)(j, valueKey) : i === j;
                }) && additionalOptions.push(i);
            });
            if (allOptions.length !== additionalOptions.length) setAllOptions(additionalOptions);
        }
    }, [
        allOptions,
        optionsProp,
        search,
        valueKey
    ]);
    (0, $2xPiy.useEffect)(function() {
        if (sortSelectedOnClose) setOrderedOptions(optionsProp);
    }, [
        optionsProp,
        sortSelectedOnClose
    ]);
    // the option indexes present in the value
    var optionIndexesInValue = (0, $2xPiy.useMemo)(function() {
        var result = [];
        if (!Array.isArray(normalizedValue)) return result;
        normalizedValue.forEach(function(v) {
            var index = allOptions.map(function(option) {
                return (0, $f3173fa86fa0c94f$export$f9e47df77939ed56)(option, valueKey);
            }).indexOf(v);
            if (index !== -1) result.push(index);
        });
        return result;
    }, [
        allOptions,
        valueKey,
        normalizedValue
    ]);
    var _useState5 = (0, $2xPiy.useState)(openProp), open = _useState5[0], setOpen = _useState5[1];
    (0, $2xPiy.useEffect)(function() {
        return setOpen(openProp);
    }, [
        openProp
    ]);
    var onRequestOpen = (0, $2xPiy.useCallback)(function() {
        if (open) return;
        setOpen(true);
        if (onOpen) onOpen();
    }, [
        onOpen,
        open
    ]);
    // On drop close if sortSelectedOnClose is true, sort options so that
    // selected options appear first, followed by unselected options.
    (0, $2xPiy.useEffect)(function() {
        if (sortSelectedOnClose && value && !open) {
            var selectedOptions = optionsProp.filter(function(option) {
                return (0, $f3173fa86fa0c94f$export$22012a5c726bef55)(value, valueKey && valueKey.reduce ? (0, $f3173fa86fa0c94f$export$f9e47df77939ed56)(option, valueKey) : option, valueKey || labelKey);
            });
            var unselectedOptions = optionsProp.filter(function(i) {
                return !(0, $f3173fa86fa0c94f$export$22012a5c726bef55)(selectedOptions, i, valueKey || labelKey);
            });
            var nextOrderedOptions = selectedOptions.concat(unselectedOptions);
            setOrderedOptions(nextOrderedOptions);
        }
    }, [
        labelKey,
        open,
        sortSelectedOnClose,
        optionsProp,
        value,
        valueKey
    ]);
    var onRequestClose = (0, $2xPiy.useCallback)(function() {
        setOpen(false);
        if (onClose) onClose();
        setSearch();
    }, [
        onClose
    ]);
    var triggerChangeEvent = (0, $2xPiy.useCallback)(function(nextValue) {
        return (0, $f3173fa86fa0c94f$export$922aead9cd650d86)(inputRef, nextValue);
    }, []);
    var onSelectChange = (0, $2xPiy.useCallback)(function(event, _ref2) {
        var option = _ref2.option, nextValue = _ref2.value;
        // nextValue must not be of type object to set value directly on the
        // input. if it is an object, then the user has not provided necessary
        // props to reduce object option
        if (typeof nextValue !== 'object' && nextValue !== event.target.value && inputRef.current) // select registers changing option as a click event or keydown.
        // when in a form, we need to programatically trigger a change
        // event in order for the change event to be registered upstream
        // necessary for change validation in form
        triggerChangeEvent(nextValue);
        setValue(nextValue);
        if (onChange) {
            event.persist();
            var adjustedEvent;
            // support for native event used by Preact
            if (event instanceof Event) {
                adjustedEvent = new event.constructor(event.type, event);
                Object.defineProperties(adjustedEvent, {
                    target: {
                        value: inputRef.current
                    },
                    value: {
                        value: nextValue
                    },
                    option: {
                        value: option
                    }
                });
            } else {
                adjustedEvent = event;
                adjustedEvent.target = inputRef.current;
                adjustedEvent.value = nextValue;
                adjustedEvent.option = option;
            }
            onChange(adjustedEvent);
        }
    }, [
        onChange,
        setValue,
        triggerChangeEvent
    ]);
    var SelectIcon = (0, $f3173fa86fa0c94f$export$ea6782b1ec892245)(icon, theme, open);
    // element to show, trumps inputValue
    var selectValue = (0, $2xPiy.useMemo)(function() {
        var result;
        if (valueLabel) result = value && valueLabel instanceof Function ? valueLabel(value) : valueLabel;
        else if ((value == null ? void 0 : value.length) > 0 && showSelectedInline) result = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $a51b175812b7eddf$export$65ae1fa19d91e9b3), {
            allOptions: allOptions,
            disabled: disabled,
            disabledKey: disabledKey,
            dropButtonRef: dropButtonRef,
            labelKey: labelKey,
            messages: messages,
            onRequestOpen: onRequestOpen,
            onSelectChange: onSelectChange,
            theme: theme,
            value: value,
            valueKey: valueKey
        }, children);
        return result;
    }, [
        allOptions,
        children,
        disabled,
        disabledKey,
        dropButtonRef,
        labelKey,
        messages,
        onRequestOpen,
        onSelectChange,
        showSelectedInline,
        theme,
        value,
        valueKey,
        valueLabel
    ]);
    var displayLabelKey = (0, $2xPiy.useMemo)(function() {
        return (0, $f3173fa86fa0c94f$export$7e4915d842d2c2e)(labelKey, allOptions, optionIndexesInValue, selectValue);
    }, [
        labelKey,
        allOptions,
        optionIndexesInValue,
        selectValue
    ]);
    // text to show
    // When the options array contains objects, this property indicates how
    // to retrieve the value of each option.
    // If a string is provided, it is used as the key to retrieve a
    // property of an option object.
    // If a function is provided, it is called with the option and should
    // return the value.
    // If reduce is true, this value will be used for the 'value'
    // delivered via 'onChange'.
    var inputValue = (0, $2xPiy.useMemo)(function() {
        if (!selectValue) {
            if (optionIndexesInValue.length === 0) return '';
            if (optionIndexesInValue.length === 1) return (0, $f3173fa86fa0c94f$export$f9e47df77939ed56)(allOptions[optionIndexesInValue[0]], labelKey);
            // keeping messages.multiple for backwards compatibility
            if (messages != null && messages.multiple && !messages.summarizedValue) return format({
                id: 'select.multiple',
                messages: messages
            });
            return format({
                id: 'selectMultiple.summarizedValue',
                messages: messages,
                values: {
                    selected: optionIndexesInValue.length,
                    total: allOptions.length
                }
            });
        }
        return undefined;
    }, [
        selectValue,
        optionIndexesInValue,
        allOptions,
        labelKey,
        format,
        messages
    ]);
    var iconColor = (0, $f3173fa86fa0c94f$export$bb417e0702eb86b5)(theme);
    var displaySelectIcon = SelectIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        alignSelf: "center",
        margin: theme.select.icons.margin,
        width: {
            min: 'auto'
        }
    }, /*#__PURE__*/ (0, $2xPiy.isValidElement)(SelectIcon) ? SelectIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(SelectIcon, {
        color: iconColor,
        size: size
    }));
    var dropContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $1c97903eeb8589f7$export$2dd06c00b4faaa63), {
        allOptions: allOptions,
        disabled: disabled,
        disabledKey: disabledKey,
        dropHeight: dropHeight,
        emptySearchMessage: emptySearchMessage,
        help: help,
        icon: displaySelectIcon,
        id: id,
        labelKey: labelKey,
        limit: limit,
        messages: messages,
        onChange: onSelectChange,
        onClose: onRequestClose,
        onKeyDown: onKeyDown,
        onMore: onMore,
        onSearch: onSearch,
        options: orderedOptions || optionsProp,
        optionIndexesInValue: optionIndexesInValue,
        replace: replace,
        searchPlaceholder: searchPlaceholder,
        search: search,
        setSearch: setSearch,
        usingKeyboard: usingKeyboard,
        value: value,
        valueKey: valueKey,
        showSelectedInline: showSelectedInline
    }, children);
    var dropButtonProps = {
        ref: dropButtonRef,
        a11yTitle: (ariaLabel || a11yTitle || placeholder || format({
            id: 'selectMultiple.open',
            messages: messages
        })) + ". " + format({
            id: 'selectMultiple.selected',
            values: {
                selected: (value == null ? void 0 : value.length) || 0,
                total: allOptions.length
            }
        }),
        'aria-expanded': Boolean(open),
        'aria-haspopup': 'listbox',
        id: id,
        disabled: disabled === true || undefined,
        open: open,
        focusIndicator: focusIndicator,
        onFocus: onFocus,
        onBlur: onBlur,
        gridArea: gridArea,
        margin: margin,
        onOpen: onRequestOpen,
        onClose: onRequestClose,
        onClick: onClick,
        plainSelect: plain,
        plain: plain,
        // Button should be plain
        dropProps: dropProps,
        dropContent: dropContent,
        theme: theme
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $168667f04da9206c$export$16e4d70cc375e707), {
        onDown: onRequestOpen,
        onUp: onRequestOpen
    }, showSelectedInline ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement($8333ace9bbd5fe81$var$StyledSelectBox, $8333ace9bbd5fe81$var$_extends({
        disabled: disabled === true || undefined,
        alignSelf: alignSelf,
        direction: "row",
        alignContent: "start",
        background: theme.select.background,
        ref: selectBoxRef,
        flex: false,
        plainSelect: plain,
        width: width
    }, passThemeFlag), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        width: "100%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $c9158ac1cba12f75$export$64fff40e709e8b2e), $8333ace9bbd5fe81$var$_extends({
        fill: "horizontal",
        alignSelf: "start"
    }, dropButtonProps, {
        dropAlign: dropAlign,
        dropTarget: dropTarget || selectBoxRef.current
    }), selectValue || displayLabelKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        direction: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $72edb32352a5dc2f$export$b34b5c37a9633c78), $8333ace9bbd5fe81$var$_extends({
        a11yTitle: ariaLabel || a11yTitle,
        defaultCursor: disabled === true || undefined,
        focusIndicator: false,
        id: id ? (0, $f3173fa86fa0c94f$export$abfa4f6a3fb2b741)(id) : undefined,
        inert: (0, $f3173fa86fa0c94f$export$6f8d7bb3dad10aa1),
        name: name,
        width: "100%"
    }, rest, {
        tabIndex: "-1",
        type: "text",
        placeholder: !value || (value == null ? void 0 : value.length) === 0 ? placeholder || selectValue || displayLabelKey : format({
            id: onMore ? 'selectMultiple.selected' : 'selectMultiple.selectedOfTotal',
            messages: messages,
            values: $8333ace9bbd5fe81$var$_extends({
                selected: (value == null ? void 0 : value.length) || 0
            }, !onMore ? {
                total: allOptions.length
            } : {})
        }),
        plain: true,
        readOnly: true,
        value: "",
        theme: theme
    })), displaySelectIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $72edb32352a5dc2f$export$7196851310a3d0bf), {
        type: "text",
        name: name,
        id: id ? (0, $f3173fa86fa0c94f$export$abfa4f6a3fb2b741)(id) : undefined,
        inert: (0, $f3173fa86fa0c94f$export$6f8d7bb3dad10aa1),
        value: inputValue,
        ref: inputRef,
        readOnly: true
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        direction: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $7b0983d1c6b6547c$export$2307ecc6c2fea308), $8333ace9bbd5fe81$var$_extends({
        a11yTitle: ariaLabel || a11yTitle,
        disabled: disabled,
        id: id,
        inert: (0, $f3173fa86fa0c94f$export$6f8d7bb3dad10aa1),
        name: name,
        ref: inputRef,
        placeholder: placeholder || 'Select',
        value: inputValue,
        size: size,
        theme: theme
    }, rest)), displaySelectIcon)), !open && (value == null ? void 0 : value.length) > 0 && (selectValue || displayLabelKey))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $72edb32352a5dc2f$export$923536af422910c8), $8333ace9bbd5fe81$var$_extends({}, dropButtonProps, {
        dropAlign: dropAlign,
        dropTarget: dropTarget,
        alignSelf: alignSelf,
        tabIndex: "0",
        "aria-labelledby": ariaLabelledByProp || ariaLabelledBy
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        align: "center",
        direction: "row",
        justify: "between",
        background: theme.select.background
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        direction: "row",
        flex: true,
        basis: "auto"
    }, selectValue || displayLabelKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).Fragment, null, selectValue || displayLabelKey, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $72edb32352a5dc2f$export$7196851310a3d0bf), {
        type: "text",
        name: name,
        id: id ? (0, $f3173fa86fa0c94f$export$abfa4f6a3fb2b741)(id) : undefined,
        inert: (0, $f3173fa86fa0c94f$export$6f8d7bb3dad10aa1),
        value: inputValue,
        ref: inputRef,
        readOnly: true
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $7b0983d1c6b6547c$export$2307ecc6c2fea308), $8333ace9bbd5fe81$var$_extends({
        a11yTitle: ariaLabel || a11yTitle,
        disabled: disabled,
        id: id,
        inert: (0, $f3173fa86fa0c94f$export$6f8d7bb3dad10aa1),
        name: name,
        ref: inputRef,
        placeholder: placeholder,
        value: inputValue,
        size: size,
        theme: theme
    }, rest))), displaySelectIcon))));
});
$8333ace9bbd5fe81$export$12a18ac91a0d2aeb.displayName = 'SelectMultiple';
$8333ace9bbd5fe81$export$12a18ac91a0d2aeb.propTypes = (0, $35f8e57c28fe8470$export$81241bedce0a1d47);





const $cc59cdc159c0357e$export$ef9b1a59e592288f = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { label: label, value: value, setValue: setValue, error: error, id: id, name: name, onChange: onChange, onSubmit: onSubmit, placeholder: placeholder, required: required, fuseAdminOnly: fuseAdminOnly, hideOptionalText: hideOptionalText, hideRequiredMarker: hideRequiredMarker, hideLabel: hideLabel, disabled: disabled, onOpen: onOpen, onClose: onClose, onMore: onMore, onSearch: onSearch, options: options, multiple: multiple, isLoadingOptions: isLoadingOptions, clear: clear, hideSelectAll: hideSelectAll, values: values, setValues: setValues, searchPlaceholder: searchPlaceholder = 'Search...', emptySearchMessage: emptySearchMessage = 'No matches found.', labelGap: labelGap, ...boxProps } = props;
    const [isFocused, setIsFocused] = (0, $2xPiy.useState)(false);
    const [filteredOptions, setFilteredOptions] = (0, $2xPiy.useState)([]);
    const shouldShowSearch = onSearch ? true : options.length > 5;
    const isLoading = !!isLoadingOptions;
    (0, $2xPiy.useEffect)(()=>{
        setFilteredOptions(options);
    }, [
        options
    ]);
    const handleClose = ()=>{
        setFilteredOptions(options);
        if (onClose) onClose();
    };
    const blockWhileLoading = (event)=>{
        if (isLoading) {
            event.stopPropagation();
            event.preventDefault();
        }
    };
    const handleSearch = (query)=>{
        if (query === '') {
            setFilteredOptions(options);
            return;
        }
        const exp = new RegExp(query.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
        const filtered = options.filter((option)=>{
            if (typeof option === 'string') return exp.test(option);
            else return exp.test(option.label);
        });
        setFilteredOptions(filtered);
    };
    const selectIcon = isLoading ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8bec6e2e7dc53c4a$export$7f7cbe89f1eacd2), {
        size: "xsmall"
    }) : undefined;
    let disabledValue;
    if (disabled) {
        const option = options.find((o)=>{
            if (typeof o === 'object') return o.value === value;
            else return o === value;
        });
        if (typeof option === 'object') disabledValue = option.label;
    }
    const renderSelect = ()=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b3fb5add06fccd6e$export$ef9b1a59e592288f), {
            id: id,
            name: name || id,
            placeholder: placeholder || 'Choose...',
            labelKey: "label",
            valueKey: {
                key: 'value',
                reduce: true
            },
            value: value ?? undefined,
            onChange: onChange ? onChange : ({ value: nextValue })=>setValue ? setValue(nextValue) : undefined,
            plain: true,
            style: {
                fontFamily: 'Lato, sans-serif',
                height: !hideLabel ? (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(58) : undefined,
                paddingTop: !hideLabel ? (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(26) : undefined,
                paddingBottom: !hideLabel ? (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(10) : undefined
            },
            onFocus: ()=>setIsFocused(true),
            onBlur: ()=>setIsFocused(false),
            onMore: onMore,
            onOpen: onOpen,
            onClose: handleClose,
            onSearch: shouldShowSearch ? onSearch || handleSearch : undefined,
            clear: clear ? {
                label: 'Clear Selection'
            } : undefined,
            options: filteredOptions,
            required: required,
            disabled: disabled,
            icon: selectIcon,
            searchPlaceholder: searchPlaceholder,
            emptySearchMessage: emptySearchMessage,
            dropHeight: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(300)
        });
    const isTotallyDisabled = typeof disabled === 'boolean' ? disabled : disabled?.length === filteredOptions.length;
    const renderSelectMultiple = ()=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8333ace9bbd5fe81$export$12a18ac91a0d2aeb), {
            id: id,
            name: name || id,
            placeholder: placeholder || 'Choose...',
            labelKey: "label",
            valueKey: {
                key: 'value',
                reduce: true
            },
            value: values,
            onChange: ({ value: nextValues })=>setValues ? setValues(nextValues) : undefined,
            plain: true,
            style: {
                fontFamily: 'Lato, sans-serif',
                height: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(58),
                paddingTop: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(26),
                paddingBottom: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(10)
            },
            onFocus: ()=>setIsFocused(true),
            onBlur: ()=>setIsFocused(false),
            onMore: onMore,
            onOpen: onOpen,
            onClose: handleClose,
            onSearch: shouldShowSearch ? onSearch || handleSearch : undefined,
            options: filteredOptions,
            limit: hideSelectAll ? options.length : undefined,
            required: required,
            disabled: disabled,
            icon: selectIcon,
            searchPlaceholder: searchPlaceholder,
            emptySearchMessage: emptySearchMessage,
            dropHeight: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(300)
        });
    const renderSelectComponent = ()=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            onClickCapture: blockWhileLoading,
            onKeyDownCapture: blockWhileLoading,
            "aria-busy": isLoading || undefined,
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $168667f04da9206c$export$16e4d70cc375e707), {
                onEnter: onSubmit,
                children: multiple ? renderSelectMultiple() : renderSelect()
            })
        });
    const borderColor = error ? 'red' : isFocused ? 'accent-1' : 'light-5';
    return !!disabled && !multiple ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        ...boxProps,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
            id: id,
            name: name || id,
            label: label,
            value: disabledValue ?? value ?? '',
            placeholder: placeholder,
            required: required,
            hideOptionalText: hideOptionalText,
            disabled: true
        })
    }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        ...boxProps,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                border: isTotallyDisabled ? undefined : {
                    color: borderColor,
                    size: 'small'
                },
                background: isTotallyDisabled ? 'light-6' : undefined,
                borderRadius: "6px",
                children: !hideLabel ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $1e7958766884f71d$export$694e0d28c7ffc90c), {
                    anchor: "top-left",
                    guidingChild: "last",
                    fill: "vertical",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            pad: {
                                top: 'xsmall',
                                left: 'small'
                            },
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: "small",
                                color: isTotallyDisabled ? 'light-3' : 'accent-1',
                                children: [
                                    label,
                                    required && !hideRequiredMarker && '*'
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            pad: {
                                top: labelGap ? 'xsmall' : undefined
                            },
                            children: renderSelectComponent()
                        })
                    ]
                }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    children: renderSelectComponent()
                })
            }),
            (error || fuseAdminOnly) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                row: true,
                gap: "small",
                margin: {
                    top: '0.5rem',
                    left: '0.75rem'
                },
                children: [
                    error && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        color: "red",
                        size: "0.75rem",
                        children: error
                    }),
                    error && fuseAdminOnly && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                        direction: "vertical",
                        margin: "0"
                    }),
                    fuseAdminOnly && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        color: "dark-1",
                        size: "0.75rem",
                        children: "FuSE ADMINS ONLY"
                    })
                ]
            })
        ]
    });
});



parcelRequire("2xPiy");


const $7fc367c9592dce2b$export$12a18ac91a0d2aeb = (props)=>{
    const { label: label, values: values, setValues: setValues, error: error, id: id, placeholder: placeholder, required: required, hideOptionalText: hideOptionalText, disabled: disabled, options: options, ...boxProps } = props;
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        ...boxProps,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                border: disabled ? undefined : {
                    color: error ? 'red' : 'light-5',
                    size: '0.8px'
                },
                background: disabled ? 'light-6' : undefined,
                borderRadius: "6px",
                pad: {
                    horizontal: '0.75rem',
                    vertical: '0.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        size: "small",
                        color: disabled ? 'light-3' : 'accent-1',
                        lineHeight: "0.875rem",
                        children: label
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8333ace9bbd5fe81$export$12a18ac91a0d2aeb), {
                        id: id || `${label.toLowerCase()}-input`,
                        placeholder: placeholder || 'Choose...',
                        required: required,
                        plain: true,
                        labelKey: "label",
                        valueKey: {
                            key: 'value',
                            reduce: true
                        },
                        value: values,
                        style: {
                            fontSize: '0.875rem',
                            fontFamily: 'Lato, sans-serif',
                            fontWeight: 400,
                            padding: 0
                        },
                        options: options,
                        onChange: ({ value: nextValues })=>setValues(nextValues),
                        disabled: disabled
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                margin: {
                    top: '0.5rem'
                },
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    color: "red",
                    size: "0.75rem",
                    children: error
                })
            }),
            !required && !hideOptionalText && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                margin: {
                    top: '0.5rem'
                },
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    color: "dark-1",
                    size: "0.75rem",
                    children: "OPTIONAL"
                })
            })
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");





const $cdb622057b5638fa$export$df14e2f55b34badd = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { utilities: utilities, value: value, setValue: setValue, error: error, required: required, fill: fill, width: width, hideOptionalText: hideOptionalText, hideLabel: hideLabel, emptySearchMessage: emptySearchMessage, searchPlaceholder: searchPlaceholder, label: label, placeholder: placeholder, regionId: regionId, id: id, name: name, disabled: disabled, onSubmit: onSubmit } = props;
    /** Stores **/ const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    /** State **/ const [isLoadingUtilities, setIsLoadingUtilities] = (0, $2xPiy.useState)(true);
    const [utilitiesList, setUtilitiesList] = (0, $2xPiy.useState)([]);
    const [defaultSelectOptions, setDefaultSelectOptions] = (0, $2xPiy.useState)([]);
    const [selectOptions, setSelectOptions] = (0, $2xPiy.useState)([]);
    /** Methods **/ const fetchUtilitiesList = async (region_id)=>{
        if (!userStore.user) return;
        try {
            setIsLoadingUtilities(true);
            const utilities = await (0, $554ab5093ad5ab37$export$6d7a392c12f13470).listUtilities({
                region_id: region_id
            });
            setUtilitiesList(utilities);
            const options = utilities.map((utility)=>({
                    label: utility.name,
                    value: utility.id
                }));
            setSelectOptions(options);
            setDefaultSelectOptions(options);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listFacilities.error);
        } finally{
            setIsLoadingUtilities(false);
        }
    };
    const filterUtilities = (query)=>{
        if (query === '') setSelectOptions(defaultSelectOptions);
        const exp = new RegExp(query.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
        const filteredOptions = defaultSelectOptions.filter(({ label: label })=>exp.test(label));
        setSelectOptions(filteredOptions);
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (isLoadingUtilities) {
            if (!utilitiesList.length) {
                if (utilities) {
                    setUtilitiesList(utilities);
                    const options = utilities.map((utility)=>({
                            label: utility.name,
                            value: utility.id
                        }));
                    setSelectOptions(options);
                    setDefaultSelectOptions(options);
                } else if (regionId) fetchUtilitiesList(regionId);
            } else setIsLoadingUtilities(false);
        }
    }, [
        utilities,
        utilitiesList,
        regionId,
        isLoadingUtilities,
        value
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (regionId) fetchUtilitiesList(regionId);
    }, [
        regionId
    ]);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
        id: id,
        name: id ? undefined : name || 'selected_utility',
        label: label ?? 'Utility',
        placeholder: placeholder,
        hideLabel: hideLabel,
        options: selectOptions,
        onOpen: ()=>filterUtilities(''),
        value: !isLoadingUtilities ? value : '',
        fill: fill,
        width: width,
        setValue: setValue,
        error: error,
        required: required,
        disabled: disabled,
        onSearch: (query)=>filterUtilities(query),
        emptySearchMessage: emptySearchMessage,
        searchPlaceholder: searchPlaceholder,
        onSubmit: onSubmit,
        hideOptionalText: hideOptionalText
    });
});





parcelRequire("2xPiy");
const $b693aeeca29ae7b2$var$SvgFuseLogo = (props)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "1 0 197 60",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("path", {
                fill: "#231f20",
                fillRule: "evenodd",
                d: "M103.8 20.6v-6.2H80.1v31.1H87v-12h14.8v-6.2H87v-6.7zm94 25v-6.1h-16.9V33h14.7v-6.1h-14.7v-6.3h16.7v-6.1h-23.4v31.1zm-32.5-9.2c0-1.5-.2-2.6-.6-3.6s-1.1-1.8-1.9-2.6c-.8-.7-1.9-1.4-3.1-1.9s-2.6-1-4.2-1.4q-1.95-.6-3.3-.9c-.9-.3-1.6-.5-2.1-.8s-.9-.6-1-1-.3-.8-.3-1.3v-.1c0-.8.3-1.4 1-1.9s1.7-.8 3-.8 2.7.3 4 .8 2.7 1.3 4.1 2.2l3.5-5.1c-1.6-1.3-3.4-2.2-5.3-2.9s-4-1-6.3-1c-1.6 0-3.1.2-4.4.7-1.3.4-2.5 1.1-3.4 1.9s-1.7 1.8-2.2 3c-.5 1.1-.8 2.4-.8 3.8v.1c0 1.5.2 2.8.7 3.9.5 1 1.2 1.9 2.1 2.6s2 1.3 3.2 1.8c1.3.5 2.7.9 4.3 1.3 1.3.3 2.4.6 3.2.9s1.5.6 1.9.9c.5.3.8.6.9 1 .2.3.2.7.2 1.2V37c0 .9-.4 1.6-1.2 2.2-.8.5-1.9.8-3.3.8-1.8 0-3.4-.3-4.9-1s-2.9-1.6-4.4-2.8l-4 4.8c1.9 1.7 3.9 2.9 6.2 3.8s4.6 1.2 7 1.2c1.7 0 3.2-.2 4.6-.6s2.6-1 3.6-1.9c1-.8 1.8-1.8 2.3-3s.9-2.6.9-4.1m-32.2 9.2V21.7h-6.7V35c0 1.6-.4 2.8-1.1 3.6-.8.8-1.8 1.2-3.1 1.2s-2.3-.4-3-1.2-1.1-2-1.1-3.6V21.7h-6.8v15.4c0 2.8.7 4.9 2.1 6.5s3.4 2.3 6 2.3c.9 0 1.6-.1 2.3-.3s1.3-.5 1.9-.8q.9-.6 1.5-1.2c.5-.5.9-1 1.3-1.5v3.4z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("path", {
                fill: "#f6a43b",
                fillRule: "evenodd",
                d: "M13.1 10.7h36.5c2.3 0 4.1 1.9 4.1 4.1s-1.8 4.1-4.1 4.1H18.5c-5.4 0-9.9 3.4-11.6 8.2-.5 1.3-.7 2.7-.7 4.1v16.4c0 1.4.2 2.8.7 4.1 1.7 4.8 6.3 8.2 11.6 8.2s9.9-3.4 11.6-8.2c.5-1.3.7-2.7.7-4.1v-4.1h9.8c1.2 1.6 3.1 2.5 5.1 2.5 3.6 0 6.6-2.9 6.6-6.6 0-3.6-2.9-6.6-6.6-6.6-2.1 0-3.9 1-5.1 2.5h-18v12.3c0 2.3-1.9 4.1-4.1 4.1s-4.1-1.8-4.1-4.1V31.2c0-2.3 1.9-4.1 4.1-4.1h31.1c6.8 0 12.3-5.5 12.3-12.3S56.4 2.5 49.6 2.5H13.1C11.8.9 9.9 0 7.9 0 4.3 0 1.4 3 1.4 6.6s2.9 6.6 6.6 6.6c2 0 3.9-1 5.1-2.5",
                clipRule: "evenodd"
            })
        ]
    });
var $b693aeeca29ae7b2$export$2e2bcd8739ae039 = $b693aeeca29ae7b2$var$SvgFuseLogo;




var $2xPiy = parcelRequire("2xPiy");


function $b354176c7fc1b147$var$_extends() {
    return $b354176c7fc1b147$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b354176c7fc1b147$var$_extends.apply(null, arguments);
}
var $b354176c7fc1b147$export$d0265b2c425512d6 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    var scaleProps = (0, $c043e17d1ada851a$export$56a2e46cd4a7c217)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $b354176c7fc1b147$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Add"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", $b354176c7fc1b147$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22V2M2 12h20"
    }, scaleProps)));
});
$b354176c7fc1b147$export$d0265b2c425512d6.displayName = 'Add';


var $2xPiy = parcelRequire("2xPiy");

function $b45db5d49fa6fcc6$var$_extends() {
    return $b45db5d49fa6fcc6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b45db5d49fa6fcc6$var$_extends.apply(null, arguments);
}
var $b45db5d49fa6fcc6$export$489a84f048b0ef8 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $b45db5d49fa6fcc6$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Update"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1.75 16.002C3.353 20.098 7.338 23 12 23c6.075 0 11-4.925 11-11m-.75-4.002C20.649 3.901 16.663 1 12 1 5.925 1 1 5.925 1 12m8 4H1v8M23 0v8h-8"
    }));
});
$b45db5d49fa6fcc6$export$489a84f048b0ef8.displayName = 'Update';




const $f3cc7d38ce51a564$export$9f4a842c4554f9c9 = ({ auditLogEventTypeName: auditLogEventTypeName, ...iconProps })=>{
    switch(auditLogEventTypeName){
        case (0, $0badf5665deea2b2$export$f4dd91be846acd3a).Create:
            return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b354176c7fc1b147$export$d0265b2c425512d6), {
                ...iconProps
            });
        case (0, $0badf5665deea2b2$export$f4dd91be846acd3a).Update:
            return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b45db5d49fa6fcc6$export$489a84f048b0ef8), {
                ...iconProps
            });
        case (0, $0badf5665deea2b2$export$f4dd91be846acd3a).Delete:
            return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $3e20861326453585$export$99442c433de1441d), {
                ...iconProps
            });
        default:
            return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $796804e8c8878bbf$export$8e3d391089488a08), {
                ...iconProps
            });
    }
};




var $2xPiy = parcelRequire("2xPiy");

function $2e3799991ff4454d$var$_extends() {
    return $2e3799991ff4454d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2e3799991ff4454d$var$_extends.apply(null, arguments);
}
var $2e3799991ff4454d$export$aa31b211d2f4c3af = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $2e3799991ff4454d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Notes"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M3 1v22h13l5-5V1H3zm3 16h5m-5-4h12M6 9h10M3 5h18m0 12h-6v6"
    }));
});
$2e3799991ff4454d$export$aa31b211d2f4c3af.displayName = 'Notes';


const $796804e8c8878bbf$export$8e3d391089488a08 = (props)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e3799991ff4454d$export$aa31b211d2f4c3af), {
        size: "24px",
        color: "brand",
        ...props
    });




const $8997b562053e0858$export$481a7013a5a1a9ef = (props)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $546d71f0291023a6$export$f3a6aa388b70f149), {
        size: "24px",
        color: "brand",
        ...props
    });




const $17a6c81a21a52d65$export$7794b6b29774c086 = ({ size: size = '24px', color: color = 'brand' })=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        width: size,
        align: "center",
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
            size: size,
            color: color,
            weight: 700,
            fontFamily: "Lato, sans-serif",
            children: "%"
        })
    });


/**
 * via https://mui.com/material-ui/material-icons/?query=vehicle&selected=ElectricCar
 */ 
parcelRequire("2xPiy");
const $c655726bed55211f$export$67a10e40c6cae5b = ({ size: size = '24', color: color = '#EAAD47' })=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        enableBackground: "new 0 0 24 24",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("g", {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("rect", {
                    fill: "none",
                    height: size,
                    width: size
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("path", {
                        fill: color,
                        d: "M18.92,2.01C18.72,1.42,18.16,1,17.5,1h-11C5.84,1,5.29,1.42,5.08,2.01L3,8v8c0,0.55,0.45,1,1,1h1c0.55,0,1-0.45,1-1v-1h12 v1c0,0.55,0.45,1,1,1h1c0.55,0,1-0.45,1-1V8L18.92,2.01z M6.5,12C5.67,12,5,11.33,5,10.5S5.67,9,6.5,9S8,9.67,8,10.5 S7.33,12,6.5,12z M17.5,12c-0.83,0-1.5-0.67-1.5-1.5S16.67,9,17.5,9S19,9.67,19,10.5S18.33,12,17.5,12z M5,7l1.5-4.5h11L19,7H5z"
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("polygon", {
                        fill: color,
                        points: "7,20 11,20 11,18 17,21 13,21 13,23"
                    })
                ]
            })
        ]
    });



parcelRequire("2xPiy");

parcelRequire("2xPiy");
const $da0a958b64c0ffce$var$SvgEvStation = (props)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 38,
        fill: "current",
        className: "bi bi-ev-station",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("path", {
                d: "M3.5 2a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5zm2.131 10.46H4.14v-.893h1.403v-.505H4.14v-.855h1.49v-.54H3.485V13h2.146zm1.316.54h.794l1.106-3.333h-.733l-.74 2.615h-.031l-.747-2.615h-.764z"
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("path", {
                d: "M3 0a2 2 0 0 0-2 2v13H.5a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1H11v-4a1 1 0 0 1 1 1v.5a1.5 1.5 0 0 0 3 0V4a.5.5 0 0 0-.146-.354l-.5-.5a.5.5 0 0 0-.707 0l-.5.5A.5.5 0 0 0 13 4v3c0 .71.38 1.096.636 1.357l.007.008c.253.258.357.377.357.635v3.5a.5.5 0 1 1-1 0V12a2 2 0 0 0-2-2V2a2 2 0 0 0-2-2zm7 2v13H2V2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1"
            })
        ]
    });
var $da0a958b64c0ffce$export$2e2bcd8739ae039 = $da0a958b64c0ffce$var$SvgEvStation;




const $2d23b039134f2e17$export$6d179221523bd367 = ({ color: color = (0, $edb3b666553e0b8a$export$2e2bcd8739ae039).global?.colors?.['light-1']?.toString() || 'rgb(170, 178, 188)', width: width = '30px', height: height = '32px', ...props })=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        ...props,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $da0a958b64c0ffce$export$2e2bcd8739ae039), {
            fill: color,
            width: width,
            height: height
        })
    });




const $a44c7c31fa61dfd1$var$colors = (0, $edb3b666553e0b8a$export$2e2bcd8739ae039).global?.colors ?? {};
const $a44c7c31fa61dfd1$export$8401c541f45c4691 = ({ fill: fill, ...props })=>{
    const fillColor = (()=>{
        if (fill && typeof fill === 'string') {
            const color = $a44c7c31fa61dfd1$var$colors[fill];
            if (typeof color === 'object' && color !== null) return color.dark || color.light || fill;
            return color;
        }
        return fill;
    })();
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)("svg", {
        height: "22px",
        viewBox: "0 0 22 22",
        width: "22px",
        fill: fillColor,
        ...props,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("path", {
                d: "M21,11c0-4.97-4.03-9-9-9s-9,4.03-9,9c0,3.92,2.51,7.24,6,8.48V22h2v-2.06c0.33,0.04,0.66,0.06,1,0.06s0.67-0.02,1-0.06 V22h2v-2.52C18.49,18.24,21,14.92,21,11z M12,18c-3.86,0-7-3.14-7-7s3.14-7,7-7s7,3.14,7,7S15.86,18,12,18z"
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("rect", {
                height: "2",
                width: "8",
                x: "8",
                y: "7"
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("polygon", {
                points: "12.75,10 9.75,13 11,14.25 9.75,15.5 11.25,17 14.25,14 13,12.75 14.25,11.5"
            })
        ]
    });
};





const $d8fcb0015cca0f72$export$825a3c81a577bf46 = ({ entityName: entityName, ...iconProps })=>{
    switch(entityName){
        case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Client:
            return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8997b562053e0858$export$481a7013a5a1a9ef), {
                ...iconProps
            });
        case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).ClientFile:
            return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $796804e8c8878bbf$export$8e3d391089488a08), {
                ...iconProps
            });
        case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Facility:
            return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $a71df00a6fead254$export$cb4af564eb490bac), {
                ...iconProps
            });
        case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Equipment:
            return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $321042383c42af9d$export$ee6a9ec6ae3156df), {
                ...iconProps
            });
        case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).EquipmentUsage:
            return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $805d36e3aa560182$export$4f47cef615b0c343), {
                ...iconProps
            });
        case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).User:
            return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $5c7d4261f00c095c$export$4202723ba73439f5), {
                ...iconProps
            });
        default:
            return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $796804e8c8878bbf$export$8e3d391089488a08), {
                ...iconProps
            });
    }
};



parcelRequire("2xPiy");

var $2xPiy = parcelRequire("2xPiy");

function $4c7d348bb823ced4$var$_extends() {
    return $4c7d348bb823ced4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4c7d348bb823ced4$var$_extends.apply(null, arguments);
}
var $4c7d348bb823ced4$export$ffec088e0621637 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $4c7d348bb823ced4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Deliver"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M3 18H1V3h13v14m0 1H9m-3 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm11 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM14 8h5l4 5v5h-3"
    }));
});
$4c7d348bb823ced4$export$ffec088e0621637.displayName = 'Deliver';


const $321042383c42af9d$export$ee6a9ec6ae3156df = ({ size: size = '24', color: color = '#EAAD47', ...iconProps })=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $4c7d348bb823ced4$export$ffec088e0621637), {
        size: size,
        color: color,
        ...iconProps
    });


/**
 * via https://mui.com/material-ui/material-icons/?query=electrical&selected=ElectricalServices
 */ 
parcelRequire("2xPiy");
const $805d36e3aa560182$export$4f47cef615b0c343 = ({ size: size = '24', color: color = '#EAAD47' })=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        enableBackground: "new 0 0 24 24",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("g", {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("rect", {
                    fill: "none",
                    height: size,
                    width: size
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("g", {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("path", {
                    fill: color,
                    d: "M14.69,2.21L4.33,11.49c-0.64,0.58-0.28,1.65,0.58,1.73L13,14l-4.85,6.76c-0.22,0.31-0.19,0.74,0.08,1.01h0 c0.3,0.3,0.77,0.31,1.08,0.02l10.36-9.28c0.64-0.58,0.28-1.65-0.58-1.73L11,10l4.85-6.76c0.22-0.31,0.19-0.74-0.08-1.01l0,0 C15.47,1.93,15,1.92,14.69,2.21z"
                })
            })
        ]
    });




var $2xPiy = parcelRequire("2xPiy");

function $7b610fc5bf7a8b9a$var$_extends() {
    return $7b610fc5bf7a8b9a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7b610fc5bf7a8b9a$var$_extends.apply(null, arguments);
}
var $7b610fc5bf7a8b9a$export$b94310965bed44e6 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $7b610fc5bf7a8b9a$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Home"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m1 11 11-9 11 9m-8 12v-8H9v8m-5 0V9m16 14V9"
    }));
});
$7b610fc5bf7a8b9a$export$b94310965bed44e6.displayName = 'Home';


const $a71df00a6fead254$export$cb4af564eb490bac = (props)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7b610fc5bf7a8b9a$export$b94310965bed44e6), {
        size: "24px",
        color: "brand",
        ...props
    });


/**
 * via SVG Repo, www.svgrepo.com
 */ 
parcelRequire("2xPiy");
const $40a6ae513e2fbd43$export$d3a6321932430fa3 = ({ size: size = '24', color: color = '#EAAD47' })=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: size,
        width: size,
        viewBox: "0 0 512 512",
        enableBackground: "new 0 0 512 512",
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("path", {
            fill: color,
            d: "m496,400h-112v-352c0-8.836-7.164-16-16-16s-16,7.164-16,16v256h-36.465l-45.769-137.305c-10.906-32.71-41.406-54.695-75.89-54.695h-81.875c-8.836,0-16,7.164-16,16v144h-79.999c-8.836,0-16,7.164-16,16v128c0,8.836 7.165,16 16,16h16c0,26.469 21.531,48 48,48 26.469,0 48-21.531 48-48h66.272c7.156,27.523 31.995,48 61.727,48 35.289,0 64-28.711 64-64v-16h32v16c0,8.836 7.165,16 16,16h128c8.836,0 16-7.164 16-16 0-8.836-7.164-16-16-16zm-256.594-223.179l42.394,127.179h-52.948l-37.781-25.184c-4.004-34.429-29.072-62.37-63.072-69.198v-65.618h65.876c20.687,0 38.992,13.188 45.531,32.821zm-111.407,66.129c14,4.832 24.219,15.496 29.052,29.051h-29.052v-29.051zm-47.999,205.05c-8.82,0-16-7.18-16-16 0-8.82 7.18-16 16-16s16,7.18 16,16c0,8.821-7.18,16-16,16zm35.515-48c-8.792-9.75-21.385-16-35.516-16-14.131,0-26.724,6.25-35.516,16h-12.484v-96h139.157l43.977,29.313c2.633,1.75 5.719,2.688 8.875,2.688h63.991v24.902c-9-5.512-20.292-8.902-32-8.902-29.732,0-54.571,20.477-61.727,48h-78.757zm140.485,47.999c-17.648,0-32-14.352-32-32 0-17.648 14.352-32 32-32 17.648,0 32,14.352 32,32 0,17.649-14.352,32-32,32zm63.999-80v-32h32v32h-32z"
        })
    });




const $72a0e64c3a374612$export$230671d7ba50d3c8 = (props)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $eabd1d040ee4804f$export$54c2e3dc7acea9f5), {
        size: "24px",
        color: "brand",
        ...props
    });


/**
 * via https://mui.com/material-ui/material-icons/?query=vehicle&selected=LocalShipping
 */ 
parcelRequire("2xPiy");
const $6d412379aa03c100$export$8f6d4065384cdcf5 = ({ size: size = '24', color: color = '#EAAD47' })=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("path", {
                fill: color,
                d: "M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
            })
        ]
    });




var $2xPiy = parcelRequire("2xPiy");

function $0157675666c7298e$var$_extends() {
    return $0157675666c7298e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0157675666c7298e$var$_extends.apply(null, arguments);
}
var $0157675666c7298e$export$1b5fea8128845fdf = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $0157675666c7298e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentText"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M6 16h10H6zm0-4h12H6zm0-4h5-5zm8-7v7h7M3 23V1h12l6 6v16H3z"
    }));
});
$0157675666c7298e$export$1b5fea8128845fdf.displayName = 'DocumentText';


const $eb42ea7ffec9b630$export$b1da2ec504d39093 = (props)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $0157675666c7298e$export$1b5fea8128845fdf), {
        size: "24px",
        color: "brand",
        ...props
    });




var $2xPiy = parcelRequire("2xPiy");

function $f9d24484a1354f14$var$_extends() {
    return $f9d24484a1354f14$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f9d24484a1354f14$var$_extends.apply(null, arguments);
}
var $f9d24484a1354f14$export$1f44aaf2ec115b54 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $f9d24484a1354f14$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "User"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8 24v-5m8 5v-5M3 24v-5c0-4.97 4.03-8 9-8s9 3.03 9 8v5m-9-13a5 5 0 1 0 0-10 5 5 0 0 0 0 10z"
    }));
});
$f9d24484a1354f14$export$1f44aaf2ec115b54.displayName = 'User';


const $5c7d4261f00c095c$export$4202723ba73439f5 = (props)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f9d24484a1354f14$export$1f44aaf2ec115b54), {
        size: "24px",
        color: "brand",
        ...props
    });




var $2xPiy = parcelRequire("2xPiy");

function $77ee8bc744382cac$var$_extends() {
    return $77ee8bc744382cac$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $77ee8bc744382cac$var$_extends.apply(null, arguments);
}
var $77ee8bc744382cac$export$eb2fcfdbd7ba97d4 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $77ee8bc744382cac$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Group"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm-6 9v-3a6 6 0 1 1 12 0v3M13 5c.404-1.664 2.015-3 4-3 2.172 0 3.98 1.79 4 4-.02 2.21-1.828 4-4 4h-1 1c3.288 0 6 2.686 6 6v2M11 5c-.404-1.664-2.015-3-4-3-2.172 0-3.98 1.79-4 4 .02 2.21 1.828 4 4 4h1-1c-3.288 0-6 2.686-6 6v2"
    }));
});
$77ee8bc744382cac$export$eb2fcfdbd7ba97d4.displayName = 'Group';


const $8f895d620f459036$export$4e04c809deb7a605 = (props)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $77ee8bc744382cac$export$eb2fcfdbd7ba97d4), {
        size: "24px",
        color: "brand",
        ...props
    });





parcelRequire("2xPiy");





const $6645b887919d682a$export$6a279c7792150a9a = (props)=>{
    /* Props */ const { setIsVisible: setIsVisible } = props;
    /* Context */ const tooltips = (0, $d597772cdbe12609$export$4713da6aa4410043)();
    /* Render */ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
        onEsc: ()=>setIsVisible(false),
        onClickOutside: ()=>setIsVisible(false),
        background: "transparent",
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
            width: "30rem",
            pad: "none",
            margin: "none",
            style: {
                overflow: 'hidden'
            },
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                    direction: "row",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $11571e85aa9685ed$export$5a89edf87f611fb5), {}),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            size: "large",
                            children: "Inactive User"
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            flex: "grow"
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                            pad: "none",
                            onClick: ()=>setIsVisible(false),
                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c1da19823027de53$export$f39c2d165cd861fe), {
                                size: "18px"
                            }),
                            tip: tooltips.close
                        }, "close")
                    ]
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $fdccc762800a972d$export$851de33184ecdac4), {
                    pad: {
                        vertical: '2rem',
                        horizontal: 'medium'
                    },
                    direction: "row",
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        size: "1.1rem",
                        lineHeight: "medium",
                        fontFamily: "Lato, sans-serif",
                        children: [
                            "Contact",
                            ' ',
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $79bcac94ca400be1$export$a6c7ac8248d6e38a), {
                                style: {
                                    textDecoration: 'none'
                                },
                                to: "mailto:support@usefuse.com",
                                children: "support@usefuse.com"
                            }),
                            ' ',
                            "to activate your account."
                        ]
                    })
                })
            ]
        })
    });
};




var $2xPiy = parcelRequire("2xPiy");



const $e7dd63b10d4904e9$export$988959db72b892c3 = (props)=>{
    const { previousPages: previousPages, currentPageName: currentPageName, ...boxProps } = props;
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const isMobile = (0, $18588a518ac6fdc7$export$2ac00d7098bf223)(screenSize);
    //const [focusedItem, setFocusedItem] = useState<string>('');
    const textSize = (0, $2xPiy.useRef)('small');
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        pad: {
            horizontal: isMobile ? '3.75rem' : '8rem',
            vertical: '1rem'
        },
        border: {
            side: 'bottom',
            size: 'small',
            color: 'light-2'
        },
        ...boxProps,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            direction: "row",
            gap: "xsmall",
            children: [
                previousPages.map(({ name: name, link: link, color: color, size: size, weight: weight }, i)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        direction: "row",
                        gap: "xsmall",
                        height: "large",
                        children: [
                            link ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                                to: link,
                                textDecoration: "none",
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: size || textSize.current,
                                        color: color || 'dark-1',
                                        weight: weight,
                                        letterSpacing: "0.6px",
                                        children: name.toUpperCase()
                                    })
                                })
                            }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: size || textSize.current,
                                color: color || 'dark-1',
                                weight: weight,
                                letterSpacing: "0.6px",
                                children: name.toUpperCase()
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: textSize.current,
                                color: "light-2",
                                children: "/"
                            })
                        ]
                    }, `${name}-${i}`)),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    size: textSize.current,
                    color: "dark-1",
                    letterSpacing: "0.6px",
                    children: currentPageName.toUpperCase()
                })
            ]
        })
    });
};




var $2xPiy = parcelRequire("2xPiy");




const $605617a28ba64070$export$3210cca7a959581e = (props)=>{
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const isMobile = screenSize === 'small' || screenSize === 'xsmall';
    const { flex: flex, height: height, ...boxProps } = props;
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        as: "footer",
        height: isMobile ? 'auto' : height ?? (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(110),
        direction: isMobile ? 'column' : 'row',
        flex: flex ?? 'grow',
        background: "transparent",
        justify: isMobile ? undefined : 'between',
        align: isMobile ? 'center' : undefined,
        gap: isMobile ? '1rem' : undefined,
        pad: {
            vertical: '2rem',
            horizontal: '8rem'
        },
        border: {
            color: 'light-2',
            side: 'top',
            size: 'small'
        },
        ...boxProps,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                align: isMobile ? 'center' : undefined,
                gap: "1rem",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), {
                        size: "0.875rem",
                        color: "dark-2",
                        children: [
                            "\xa9 ",
                            new Date().getFullYear(),
                            " FuSE. All Rights Reserved."
                        ]
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        direction: "row",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            alignSelf: "center",
                            height: "0.8125rem",
                            justify: "center",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $5770351c0fb34b29$export$b2bf131c9f9cce5d), {
                                to: (0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).urls.privacyPolicyUrl,
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), {
                                    size: "0.8125rem",
                                    color: "accent-4",
                                    children: "Privacy Policy"
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                margin: isMobile ? {
                    top: 'small'
                } : '',
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $5770351c0fb34b29$export$b2bf131c9f9cce5d), {
                    to: (0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).urls.fuseWebsiteUrl,
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b693aeeca29ae7b2$export$2e2bcd8739ae039), {
                        height: "40px"
                    })
                })
            })
        ]
    });
};



parcelRequire("2xPiy");



const $98b6153ed086d9bd$export$11154b700737b45e = (props)=>{
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const { children: children, isLoading: isLoading, title: title, icon: icon, onSubmit: onSubmit, fill: fill, hideSaveButton: hideSaveButton, saveButtonLabel: saveButtonLabel, saveButtonLoadingLabel: saveButtonLoadingLabel, saveButtonProps: saveButtonProps, saveButtonDisabled: saveButtonDisabled, headerChildren: headerChildren, header: header, hideRequiredText: hideRequiredText, saveButton: saveButton, ...boxProps } = props;
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        flex: fill ? undefined : 'grow',
        fill: fill,
        ...boxProps,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
            flex: "shrink",
            children: [
                header ?? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                    title: title,
                    icon: icon,
                    children: headerChildren
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                    gap: "1.5rem",
                    saveButton: saveButton ?? (!hideSaveButton && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7ac54c23a62de8c7$export$4ecda0163efe6d1d), {
                        type: "submit",
                        label: saveButtonLabel ?? '',
                        loadingLabel: saveButtonLoadingLabel ?? '',
                        isLoading: isLoading,
                        onClick: onSubmit,
                        disabled: saveButtonDisabled,
                        ...saveButtonProps
                    })),
                    children: [
                        children,
                        !hideRequiredText && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            size: "14px",
                            fontFamily: "Lato, sans-serif",
                            children: t('common:requiredField')
                        })
                    ]
                })
            ]
        })
    });
};



parcelRequire("2xPiy");

const $ac0830614d9d3eb7$export$d306034f499f617e = (props)=>{
    const { children: children, title: title, subtitle: subtitle, row: row, button: button, ...boxProps } = props;
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        gap: "1rem",
        ...boxProps,
        children: [
            (title || button) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                row: true,
                align: "center",
                gap: "xsmall",
                children: [
                    !!title && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        color: "dark-1",
                        size: "large",
                        weight: 300,
                        children: title
                    }),
                    button
                ]
            }),
            subtitle && (typeof subtitle === 'string' ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                size: "medium",
                fontFamily: "Lato, sans-serif",
                children: subtitle
            }) : subtitle),
            row ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                direction: "row",
                gap: "1rem",
                children: children
            }) : children
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");



var $2xPiy = parcelRequire("2xPiy");



var $2xPiy = parcelRequire("2xPiy");

var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");

var $509008dbd8ab367a$var$FIT_MAP = {
    cover: 'cover',
    contain: 'contain'
};
var $509008dbd8ab367a$var$fitStyle = (0, $iA1nz.css)([
    "flex:1 1;overflow:hidden;object-fit:",
    ";"
], function(props) {
    return $509008dbd8ab367a$var$FIT_MAP[props.fit];
});
var $509008dbd8ab367a$export$7722b1870d9eec03 = (0, $iA1nz.default).img.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledImage",
    componentId: "sc-ey4zx9-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    ""
], (0, $73ba8e2d301b823f$export$a157b298d219a801), function(props) {
    return props.fit && $509008dbd8ab367a$var$fitStyle;
}, function(props) {
    return props.fillProp && (0, $73ba8e2d301b823f$export$7d12e60b29024244)(props.fillProp);
}, function(props) {
    return props.theme.image && props.theme.image.extend;
}, function(props) {
    return props.opacityProp && "opacity: " + (props.opacityProp === true ? props.theme.global.opacity.medium : props.theme.global.opacity[props.opacityProp] || props.opacityProp) + ";\n  ";
});



var $dyr1f = parcelRequire("dyr1f");

function $d498db4f9d79415b$var$_extends() {
    return $d498db4f9d79415b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d498db4f9d79415b$var$_extends.apply(null, arguments);
}
var $d498db4f9d79415b$var$PropType = {};
$d498db4f9d79415b$var$PropType = $d498db4f9d79415b$var$_extends({}, (0, $ab32ce3df36aa105$export$ffe37ff34eeb9e21), {
    fill: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'horizontal',
            'vertical'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
    ]),
    fit: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'cover',
        'contain'
    ]),
    fallback: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    opacity: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'weak',
            'medium',
            'strong'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
    ])
});
var $d498db4f9d79415b$export$c3be8f1cc0265a9c = $d498db4f9d79415b$var$PropType;



var $6d8734f4817eb59e$var$_excluded = [
    "a11yTitle",
    "fallback",
    "onError",
    "onLoad",
    "opacity",
    "fill",
    "src"
];
function $6d8734f4817eb59e$var$_extends() {
    return $6d8734f4817eb59e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6d8734f4817eb59e$var$_extends.apply(null, arguments);
}
function $6d8734f4817eb59e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $6d8734f4817eb59e$export$3e431a229df88919 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, fallback = _ref.fallback, onError = _ref.onError, onLoad = _ref.onLoad, opacity = _ref.opacity, fill = _ref.fill, src = _ref.src, rest = $6d8734f4817eb59e$var$_objectWithoutPropertiesLoose(_ref, $6d8734f4817eb59e$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var _useState = (0, $2xPiy.useState)(false), isFallbackInUse = _useState[0], setFallbackInUse = _useState[1];
    var handleError = function handleError(event) {
        if (onError) onError(event);
        if (!isFallbackInUse && fallback && fallback !== '') {
            // eslint-disable-next-line no-param-reassign
            event.target.src = fallback;
            setFallbackInUse(true);
        }
    };
    var handleOnLoad = function handleOnLoad(event) {
        if (onLoad) onLoad(event);
        setFallbackInUse(false);
    };
    var extraProps = {
        onError: (onError || fallback) && handleError,
        onLoad: handleOnLoad
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $509008dbd8ab367a$export$7722b1870d9eec03), $6d8734f4817eb59e$var$_extends({
        "aria-label": a11yTitle
    }, passThemeFlag, rest, extraProps, {
        ref: ref,
        opacityProp: opacity,
        fillProp: fill,
        src: src === undefined ? '' : src
    }));
});
$6d8734f4817eb59e$export$3e431a229df88919.displayName = 'Image';
$6d8734f4817eb59e$export$3e431a229df88919.propTypes = (0, $d498db4f9d79415b$export$c3be8f1cc0265a9c);



var $iA1nz = parcelRequire("iA1nz");


var $2beeea5d713179af$export$347ff640deb5f69a = (0, $iA1nz.default)((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6)).withConfig({
    displayName: "StyledAvatar__StyledAvatarText",
    componentId: "sc-1suyamb-0"
})([
    "",
    " ",
    ""
], function(props) {
    return props.theme.avatar && props.theme.avatar.text && props.theme.avatar.text.fontWeight && "font-weight: " + props.theme.avatar.text.fontWeight + ";";
}, function(props) {
    return props.theme.avatar.text && props.theme.avatar.text.extend;
});
var $2beeea5d713179af$export$f9c8934f7fa064f8 = (0, $iA1nz.default)((0, $18c0523379e5dd9d$export$e71c4d32a2263218)).withConfig({
    displayName: "StyledAvatar",
    componentId: "sc-1suyamb-1"
})([
    "",
    ""
], function(props) {
    return props.theme.avatar && props.theme.avatar.extend;
});



var $dyr1f = parcelRequire("dyr1f");
var $7547e906aae269b6$var$PropType = {};
$7547e906aae269b6$var$PropType = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            '2xl',
            '3xl',
            '4xl',
            '5xl'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    src: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    imageProps: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).object
};
var $7547e906aae269b6$export$d8bb67314afc20d6 = $7547e906aae269b6$var$PropType;



var $cc7832ace6bae342$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "align",
    "children",
    "height",
    "imageProps",
    "justify",
    "round",
    "size",
    "src",
    "width"
];
function $cc7832ace6bae342$var$_extends() {
    return $cc7832ace6bae342$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cc7832ace6bae342$var$_extends.apply(null, arguments);
}
function $cc7832ace6bae342$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $cc7832ace6bae342$export$e2255cf6045e8d47 = function Avatar(_ref) {
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], _ref$align = _ref.align, align = _ref$align === void 0 ? 'center' : _ref$align, children = _ref.children, height = _ref.height, imageProps = _ref.imageProps, _ref$justify = _ref.justify, justify = _ref$justify === void 0 ? 'center' : _ref$justify, _ref$round = _ref.round, round = _ref$round === void 0 ? 'full' : _ref$round, _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, src = _ref.src, width = _ref.width, rest = $cc7832ace6bae342$var$_objectWithoutPropertiesLoose(_ref, $cc7832ace6bae342$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var avatarSize = theme.avatar.size[size] || size;
    var avatarTextSize = theme.avatar.text.size[size] || 'large';
    var avatarProps = (0, $2xPiy.useMemo)(function() {
        return {
            align: align,
            height: avatarSize,
            justify: justify,
            overflow: 'hidden',
            round: round,
            width: avatarSize
        };
    }, [
        align,
        avatarSize,
        justify,
        round
    ]);
    var AvatarChildren = (0, $2xPiy.useCallback)(function() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $2beeea5d713179af$export$f9c8934f7fa064f8), $cc7832ace6bae342$var$_extends({}, avatarProps, rest), children);
    }, [
        avatarProps,
        children,
        rest
    ]);
    if (height || width) console.warn('Avatar should use `size` instead of `height` or `width` props');
    var content;
    if (typeof children === 'string') content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $2beeea5d713179af$export$347ff640deb5f69a), $cc7832ace6bae342$var$_extends({
        alignSelf: "center",
        size: avatarTextSize
    }, passThemeFlag), children);
    else if (typeof src === 'string') content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $6d8734f4817eb59e$export$3e431a229df88919), $cc7832ace6bae342$var$_extends({
        role: "presentation",
        fit: "contain",
        src: src
    }, imageProps));
    if (typeof children === 'string' || typeof src === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $2beeea5d713179af$export$f9c8934f7fa064f8), $cc7832ace6bae342$var$_extends({
        role: typeof src === 'string' ? 'figure' : undefined,
        a11yTitle: a11yTitle || ariaLabel
    }, avatarProps, passThemeFlag, rest), content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(AvatarChildren, null);
};
$cc7832ace6bae342$export$e2255cf6045e8d47.propTypes = (0, $7547e906aae269b6$export$d8bb67314afc20d6);







const $c61d91bfa75be0a1$export$53f1cd6809577fc5 = (props)=>{
    /** Props **/ const { title: title, titleBar: titleBar, showLinkButton: showLinkButton, linkButtonUrl: linkButtonUrl, linkButtonSize: linkButtonSize, showAddButton: showAddButton, addButtonLabel: addButtonLabel, addButtonUrl: addButtonUrl, addButtonIcon: addButtonIcon, showMenuButton: showMenuButton, menuButtonItems: menuButtonItems, isUserPage: isUserPage, isClientPage: isClientPage, clientId: clientId, onAddButton: onAddButton, dataTour: dataTour, children: children, ...boxProps } = props;
    /** Context */ const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const clientStore = (0, $116967e0234c3770$export$3b47afa599c78f61)();
    const tooltips = (0, $d597772cdbe12609$export$4713da6aa4410043)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** State */ const [isButtonFocused, setIsButtonFocused] = (0, $2xPiy.useState)(false);
    /** Render */ if (isUserPage) return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        direction: "row",
        gap: "small",
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                alignSelf: "center",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc7832ace6bae342$export$e2255cf6045e8d47), {
                    background: "light-3",
                    size: "80px",
                    hoverIndicator: {
                        elevation: 'small'
                    },
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        size: "xxlarge",
                        color: "white",
                        children: (0, $00658ccd6ec0135a$export$de9bdbce6502b027)(title)
                    })
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                alignSelf: "center",
                gap: "0.25rem",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    size: "xxlarge",
                    children: title
                })
            })
        ]
    });
    else return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        direction: "row",
        margin: {
            bottom: '2rem'
        },
        gap: "1rem",
        align: "center",
        ...boxProps,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                direction: "row",
                gap: "medium",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        size: "xxlarge",
                        children: title
                    }),
                    titleBar,
                    showLinkButton && !!linkButtonUrl && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ce7c3f634dc2ea76$export$c9915453de10000b), {
                            size: linkButtonSize || '16px'
                        }),
                        onClick: ()=>navigate(linkButtonUrl),
                        tip: tooltips.equipmentPageLink
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                flex: "grow"
            }),
            showMenuButton && !!menuButtonItems && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $41d136aeffe9860f$export$d9b273488cd8ce6f), {
                dropAlign: {
                    right: 'right',
                    top: 'bottom'
                },
                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    pad: "0.7rem",
                    round: true,
                    border: {
                        size: 'small',
                        color: 'light-2'
                    },
                    elevation: "small",
                    background: "white",
                    align: "center",
                    justify: "center",
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $93663f13c4b467ae$export$d9b273488cd8ce6f), {
                        size: "22px"
                    })
                }),
                items: menuButtonItems
            }),
            showAddButton && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                alignSelf: "end",
                background: isButtonFocused ? 'button-hover' : 'accent-1',
                elevation: isButtonFocused ? 'small' : undefined,
                direction: "row",
                pad: "0.75rem",
                gap: "xsmall",
                borderRadius: "6px",
                onMouseOver: ()=>setIsButtonFocused(true),
                onMouseOut: ()=>setIsButtonFocused(false),
                onClick: ()=>{
                    if (onAddButton) onAddButton();
                    else if (addButtonUrl) navigate(addButtonUrl);
                },
                "data-tour": dataTour,
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        alignSelf: "center",
                        children: addButtonIcon ?? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b354176c7fc1b147$export$d0265b2c425512d6), {
                            size: "16px"
                        })
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        alignSelf: "center",
                        color: "white",
                        size: "medium",
                        weight: 500,
                        toUpperCase: true,
                        children: addButtonLabel || 'ADD'
                    })
                ]
            }),
            isClientPage && clientId && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $85ab7488c493b81c$export$6d88ebe453be59d7), {
                background: "accent-1",
                color: "white",
                label: t('common:viewDashboard'),
                onClick: ()=>{
                    clientStore.setSelectedClientId(clientId);
                    navigate(`/?client=${clientId}`);
                }
            }),
            children
        ]
    });
};





const $3d99c6153124a6ba$export$7234abc5d81adb58 = (props)=>{
    const { children: children, isLoading: isLoading, breadcrumbNav: breadcrumbNav, userInfoBar: userInfoBar, hideMenuButton: hideMenuButton, menuButtonItems: menuButtonItems, title: title, titleBar: titleBar, titleLinkUrl: titleLinkUrl, titleLinkIconSize: titleLinkIconSize, isUserPage: isUserPage, isClientPage: isClientPage, isDetailPage: isDetailPage, clientId: clientId } = props;
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const isMobile = (0, $18588a518ac6fdc7$export$2ac00d7098bf223)(screenSize);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $f068601a66842d6c$export$c1faa9c8f42906a), {
        children: [
            isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}),
            !isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
                children: [
                    breadcrumbNav,
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        flex: "grow",
                        pad: {
                            horizontal: isMobile ? '3.75rem' : '8rem',
                            vertical: isMobile ? '2.25rem' : '3rem'
                        },
                        children: [
                            !!title && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c61d91bfa75be0a1$export$53f1cd6809577fc5), {
                                title: title,
                                titleBar: titleBar,
                                isUserPage: isUserPage,
                                isClientPage: isClientPage,
                                clientId: clientId,
                                showLinkButton: !!titleLinkUrl,
                                linkButtonUrl: titleLinkUrl,
                                linkButtonSize: titleLinkIconSize,
                                showMenuButton: !hideMenuButton,
                                menuButtonItems: menuButtonItems
                            }),
                            userInfoBar,
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                direction: isMobile || isDetailPage ? 'column' : 'row',
                                gap: "1rem",
                                children: children
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");




var $2xPiy = parcelRequire("2xPiy");

function $64b43dde096e82d9$var$_extends() {
    return $64b43dde096e82d9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $64b43dde096e82d9$var$_extends.apply(null, arguments);
}
var $64b43dde096e82d9$export$59596d9b033ace49 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $64b43dde096e82d9$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CircleQuestion"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-7v-1c0-1 0-1.5 1-2s2-1 2-2.5c0-1-1-2.5-3-2.5s-3 1.264-3 3m3 6v2"
    }));
});
$64b43dde096e82d9$export$59596d9b033ace49.displayName = 'CircleQuestion';


var $2xPiy = parcelRequire("2xPiy");

function $48dbea6a6b8a2aea$var$_extends() {
    return $48dbea6a6b8a2aea$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $48dbea6a6b8a2aea$var$_extends.apply(null, arguments);
}
var $48dbea6a6b8a2aea$export$f93ec6528f706bfe = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $48dbea6a6b8a2aea$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Refresh"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M20 8c-1.403-2.96-4.463-5-8-5a9 9 0 1 0 0 18 9 9 0 0 0 9-9m0-9v6h-6"
    }));
});
$48dbea6a6b8a2aea$export$f93ec6528f706bfe.displayName = 'Refresh';










const $4f524dd59a699d69$var$e = [
    `pointerdown`,
    `mousedown`,
    `pointerup`,
    `mouseup`,
    `click`
], $4f524dd59a699d69$var$t = new WeakMap;
function $4f524dd59a699d69$var$n(n, i, a) {
    $4f524dd59a699d69$var$r(n);
    let o = (e)=>{
        let t = e.target;
        n.contains(t) && ((!a || a(t)) && (e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation()), e.type === `click` && i?.(e));
    };
    for (let t of $4f524dd59a699d69$var$e)document.addEventListener(t, o, !0);
    $4f524dd59a699d69$var$t.set(n, o);
}
function $4f524dd59a699d69$var$r(n) {
    let r = $4f524dd59a699d69$var$t.get(n);
    if (r) {
        for (let t of $4f524dd59a699d69$var$e)document.removeEventListener(t, r, !0);
        $4f524dd59a699d69$var$t.delete(n);
    }
}
function $4f524dd59a699d69$var$i(e, t) {
    let n = e.wrapper.getBoundingClientRect();
    return {
        width: n.width + t,
        height: n.height + t,
        realWidth: n.width,
        realHeight: n.height
    };
}
function $4f524dd59a699d69$var$a(e, t) {
    let { elementDimensions: n, popoverDimensions: r, popoverPadding: i, popoverArrowDimensions: a } = t;
    return e === `start` ? Math.max(Math.min(n.top - i, window.innerHeight - r.realHeight - a.width), a.width) : e === `end` ? Math.max(Math.min(n.top - r?.realHeight + n.height + i, window.innerHeight - r?.realHeight - a.width), a.width) : e === `center` ? Math.max(Math.min(n.top + n.height / 2 - r?.realHeight / 2, window.innerHeight - r?.realHeight - a.width), a.width) : 0;
}
function $4f524dd59a699d69$var$o(e, t) {
    let { elementDimensions: n, popoverDimensions: r, popoverPadding: i, popoverArrowDimensions: a } = t;
    return e === `start` ? Math.max(Math.min(n.left - i, window.innerWidth - r.realWidth - a.width), a.width) : e === `end` ? Math.max(Math.min(n.left - r?.realWidth + n.width + i, window.innerWidth - r?.realWidth - a.width), a.width) : e === `center` ? Math.max(Math.min(n.left + n.width / 2 - r?.realWidth / 2, window.innerWidth - r?.realWidth - a.width), a.width) : 0;
}
function $4f524dd59a699d69$var$s(e, t, n) {
    let { align: r, side: s } = n, c = n.centered ? `over` : s, l = n.padding, u = $4f524dd59a699d69$var$i(e, n.offset), f = e.arrow.getBoundingClientRect(), p = t.getBoundingClientRect(), m = p.top - u.height, h = m >= 0, g = window.innerHeight - (p.bottom + u.height), _ = g >= 0, v = p.left - u.width, y = v >= 0, b = window.innerWidth - (p.right + u.width), x = b >= 0, S = !h && !_ && !y && !x, C = c;
    if (c === `top` && h ? x = y = _ = !1 : c === `bottom` && _ ? x = y = h = !1 : c === `left` && y ? x = h = _ = !1 : c === `right` && x && (y = h = _ = !1), c === `over`) {
        let t = window.innerWidth / 2 - u.realWidth / 2, n = window.innerHeight / 2 - u.realHeight / 2;
        e.wrapper.style.left = `${t}px`, e.wrapper.style.right = `auto`, e.wrapper.style.top = `${n}px`, e.wrapper.style.bottom = `auto`;
    } else if (S) {
        let t = window.innerWidth / 2 - u?.realWidth / 2;
        e.wrapper.style.left = `${t}px`, e.wrapper.style.right = `auto`, e.wrapper.style.bottom = `10px`, e.wrapper.style.top = `auto`;
    } else if (y) {
        let t = Math.min(v, window.innerWidth - u?.realWidth - f.width), n = $4f524dd59a699d69$var$a(r, {
            elementDimensions: p,
            popoverDimensions: u,
            popoverPadding: l,
            popoverArrowDimensions: f
        });
        e.wrapper.style.left = `${t}px`, e.wrapper.style.top = `${n}px`, e.wrapper.style.bottom = `auto`, e.wrapper.style.right = `auto`, C = `left`;
    } else if (x) {
        let t = Math.min(b, window.innerWidth - u?.realWidth - f.width), n = $4f524dd59a699d69$var$a(r, {
            elementDimensions: p,
            popoverDimensions: u,
            popoverPadding: l,
            popoverArrowDimensions: f
        });
        e.wrapper.style.right = `${t}px`, e.wrapper.style.top = `${n}px`, e.wrapper.style.bottom = `auto`, e.wrapper.style.left = `auto`, C = `right`;
    } else if (h) {
        let t = Math.min(m, window.innerHeight - u.realHeight - f.width), n = $4f524dd59a699d69$var$o(r, {
            elementDimensions: p,
            popoverDimensions: u,
            popoverPadding: l,
            popoverArrowDimensions: f
        });
        e.wrapper.style.top = `${t}px`, e.wrapper.style.left = `${n}px`, e.wrapper.style.bottom = `auto`, e.wrapper.style.right = `auto`, C = `top`;
    } else if (_) {
        let t = Math.min(g, window.innerHeight - u?.realHeight - f.width), n = $4f524dd59a699d69$var$o(r, {
            elementDimensions: p,
            popoverDimensions: u,
            popoverPadding: l,
            popoverArrowDimensions: f
        });
        e.wrapper.style.left = `${n}px`, e.wrapper.style.bottom = `${t}px`, e.wrapper.style.top = `auto`, e.wrapper.style.right = `auto`, C = `bottom`;
    }
    $4f524dd59a699d69$var$d(e, S ? `over` : C, r, t), [
        ...e.wrapper.classList
    ].filter((e)=>e.startsWith(`driver-popover-side-`) || e.startsWith(`driver-popover-align-`)).forEach((t)=>e.wrapper.classList.remove(t)), e.wrapper.classList.add(`driver-popover-side-${C}`), e.wrapper.classList.add(`driver-popover-align-${r}`);
}
function $4f524dd59a699d69$var$c(e, t, n, r, i, a = 10) {
    let o = r - n;
    return e <= n && t >= r ? i === `start` ? 15 + a / 2 : i === `end` ? o - 15 - a / 2 : o / 2 : (Math.min(Math.max(e, n), r) + Math.min(Math.max(t, n), r)) / 2 - n;
}
function $4f524dd59a699d69$var$l(e, t, n = 10) {
    let r = t - 15 - n;
    if (r < 15) return Math.max(0, (t - n) / 2);
    let i = e - n / 2;
    return Math.min(Math.max(i, 15), r);
}
function $4f524dd59a699d69$var$u(e, t, n) {
    return e === `left` || e === `right` ? t.bottom > n.top && t.top < n.bottom ? e : t.bottom <= n.top ? `bottom` : `top` : t.right > n.left && t.left < n.right ? e : t.right <= n.left ? `right` : `left`;
}
function $4f524dd59a699d69$var$d(e, t, n, r) {
    let i = e.arrow;
    if (i.className = `driver-popover-arrow`, i.style.top = ``, i.style.right = ``, i.style.bottom = ``, i.style.left = ``, t === `over`) {
        i.classList.add(`driver-popover-arrow-none`);
        return;
    }
    let a = r.getBoundingClientRect(), o = e.wrapper.getBoundingClientRect(), s = $4f524dd59a699d69$var$u(t, a, o);
    i.classList.add(`driver-popover-arrow-side-${s}`);
    let d = i.getBoundingClientRect().width || 10;
    if (s === `left` || s === `right`) {
        let e = $4f524dd59a699d69$var$c(a.top, a.bottom, o.top, o.bottom, n, d);
        i.style.top = `${$4f524dd59a699d69$var$l(e, o.height, d)}px`;
    } else {
        let e = $4f524dd59a699d69$var$c(a.left, a.right, o.left, o.right, n, d);
        i.style.left = `${$4f524dd59a699d69$var$l(e, o.width, d)}px`;
    }
}
function $4f524dd59a699d69$var$f(e) {
    return typeof e == `function` ? e() : typeof e == `string` ? document.querySelector(e) : e;
}
function $4f524dd59a699d69$var$p(e) {
    let t = window.getComputedStyle(e);
    return [
        t.overflow,
        t.overflowX,
        t.overflowY
    ].some((e)=>e === `auto` || e === `scroll`);
}
function $4f524dd59a699d69$var$m(e, t, n, r) {
    return (e /= r / 2) < 1 ? n / 2 * e * e + t : -n / 2 * (--e * (e - 2) - 1) + t;
}
function $4f524dd59a699d69$var$h(e) {
    let t = `a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])`;
    return e.flatMap((e)=>{
        let n = e.matches(t), r = Array.from(e.querySelectorAll(t));
        return [
            ...n ? [
                e
            ] : [],
            ...r
        ];
    }).filter((e)=>getComputedStyle(e).pointerEvents !== `none` && $4f524dd59a699d69$var$y(e));
}
function $4f524dd59a699d69$var$g(e, t) {
    if (!e || $4f524dd59a699d69$var$v(e)) return;
    let n = e.offsetHeight > window.innerHeight;
    e.scrollIntoView({
        behavior: !t || $4f524dd59a699d69$var$_(e) ? `auto` : `smooth`,
        inline: `center`,
        block: n ? `start` : `center`
    });
}
function $4f524dd59a699d69$var$_(e) {
    if (!e || !e.parentElement) return;
    let t = e.parentElement;
    return t.scrollHeight > t.clientHeight;
}
function $4f524dd59a699d69$var$v(e) {
    let t = e.getBoundingClientRect();
    return t.top >= 0 && t.left >= 0 && t.bottom <= (window.innerHeight || document.documentElement.clientHeight) && t.right <= (window.innerWidth || document.documentElement.clientWidth);
}
function $4f524dd59a699d69$var$y(e) {
    return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
}
function $4f524dd59a699d69$var$b(e) {
    e && (e.wrapper.style.display = `none`);
}
function $4f524dd59a699d69$var$x(e, t) {
    let r = $4f524dd59a699d69$var$C();
    document.body.appendChild(r.wrapper);
    let { title: i, description: a, showButtons: o, disableButtons: c, showProgress: l, nextBtnText: u, prevBtnText: d, progressText: f } = t;
    r.nextButton.innerHTML = u, r.previousButton.innerHTML = d, r.progress.innerHTML = f, t.doneButton && r.nextButton.classList.add(`driver-popover-done-btn`), i ? (r.title.innerHTML = i, r.title.style.display = `block`) : r.title.style.display = `none`, a ? (r.description.innerHTML = a, r.description.style.display = `block`) : r.description.style.display = `none`;
    let p = o.includes(`next`) || o.includes(`previous`) || l;
    r.closeButton.style.display = o.includes(`close`) ? `block` : `none`, p ? (r.footer.style.display = `flex`, r.progress.style.display = l ? `block` : `none`, r.nextButton.style.display = o.includes(`next`) ? `block` : `none`, r.previousButton.style.display = o.includes(`previous`) ? `block` : `none`) : r.footer.style.display = `none`, c.includes(`next`) && (r.nextButton.disabled = !0, r.nextButton.classList.add(`driver-popover-btn-disabled`)), c.includes(`previous`) && (r.previousButton.disabled = !0, r.previousButton.classList.add(`driver-popover-btn-disabled`)), c.includes(`close`) && (r.closeButton.disabled = !0, r.closeButton.classList.add(`driver-popover-btn-disabled`));
    let m = r.wrapper;
    m.style.display = `block`, m.style.left = ``, m.style.top = ``, m.style.bottom = ``, m.style.right = ``, m.id = `driver-popover-content`, m.setAttribute(`role`, `dialog`), m.setAttribute(`aria-labelledby`, `driver-popover-title`), m.setAttribute(`aria-describedby`, `driver-popover-description`);
    let _ = r.arrow;
    _.className = `driver-popover-arrow`, m.className = `driver-popover ${t.popoverClass || ``}`.trim(), $4f524dd59a699d69$var$n(r.wrapper, (e)=>{
        let n = e.target;
        if (n.closest(`.driver-popover-next-btn`)) return t.onNextClick?.();
        if (n.closest(`.driver-popover-prev-btn`)) return t.onPrevClick?.();
        if (n.closest(`.driver-popover-close-btn`)) return t.onCloseClick?.();
    }, (e)=>r.description.contains(e) || r.title.contains(e) ? !1 : !!e.closest(`.driver-popover-prev-btn, .driver-popover-next-btn, .driver-popover-close-btn`)), t.onRender?.(r), $4f524dd59a699d69$var$s(r, e, t.position), $4f524dd59a699d69$var$S(r, e, t.position), $4f524dd59a699d69$var$g(m, t.smoothScroll);
    let v = $4f524dd59a699d69$var$h([
        m,
        e
    ]);
    return v.length > 0 && v[0].focus(), r;
}
function $4f524dd59a699d69$var$S(e, t, n) {
    e.wrapper.querySelectorAll(`img`).forEach((r)=>{
        if (r.complete) return;
        let i = ()=>$4f524dd59a699d69$var$s(e, t, n);
        r.addEventListener(`load`, i, {
            once: !0
        }), r.addEventListener(`error`, i, {
            once: !0
        });
    });
}
function $4f524dd59a699d69$var$C() {
    let e = document.createElement(`div`);
    e.classList.add(`driver-popover`);
    let t = document.createElement(`div`);
    t.classList.add(`driver-popover-arrow`);
    let n = document.createElement(`header`);
    n.id = `driver-popover-title`, n.classList.add(`driver-popover-title`), n.style.display = `none`, n.innerText = `Popover Title`;
    let r = document.createElement(`div`);
    r.id = `driver-popover-description`, r.classList.add(`driver-popover-description`), r.style.display = `none`, r.innerText = `Popover description is here`;
    let i = document.createElement(`button`);
    i.type = `button`, i.classList.add(`driver-popover-close-btn`), i.setAttribute(`aria-label`, `Close`), i.innerHTML = `&times;`;
    let a = document.createElement(`footer`);
    a.classList.add(`driver-popover-footer`);
    let o = document.createElement(`span`);
    o.classList.add(`driver-popover-progress-text`), o.innerText = ``;
    let s = document.createElement(`span`);
    s.classList.add(`driver-popover-navigation-btns`);
    let c = document.createElement(`button`);
    c.type = `button`, c.classList.add(`driver-popover-prev-btn`, `driver-popover-footer-btn`), c.innerHTML = `Previous`;
    let l = document.createElement(`button`);
    return l.type = `button`, l.classList.add(`driver-popover-next-btn`, `driver-popover-footer-btn`), l.innerHTML = `Next`, s.appendChild(c), s.appendChild(l), a.appendChild(o), a.appendChild(s), e.appendChild(i), e.appendChild(t), e.appendChild(n), e.appendChild(r), e.appendChild(a), {
        wrapper: e,
        arrow: t,
        title: n,
        description: r,
        footer: a,
        previousButton: c,
        nextButton: l,
        closeButton: i,
        footerButtons: s,
        progress: o
    };
}
function $4f524dd59a699d69$var$w(e) {
    e && ($4f524dd59a699d69$var$r(e.wrapper), e.wrapper.parentElement?.removeChild(e.wrapper));
}
function $4f524dd59a699d69$var$T(e, t) {
    let n = window.innerWidth, r = window.innerHeight, i = t.padding, a = t.radius, o = e.width + i * 2, s = e.height + i * 2, c = Math.min(a, o / 2, s / 2), l = Math.floor(Math.max(c, 0)), u = e.x - i + l, d = e.y - i, f = o - l * 2, p = s - l * 2;
    return `M${n},0L0,0L0,${r}L${n},${r}L${n},0Z
    M${u},${d} h${f} a${l},${l} 0 0 1 ${l},${l} v${p} a${l},${l} 0 0 1 -${l},${l} h-${f} a${l},${l} 0 0 1 -${l},-${l} v-${p} a${l},${l} 0 0 1 ${l},-${l} z`;
}
function $4f524dd59a699d69$var$E(e, t, n, r, i) {
    let a = e.getState(`__activeStagePosition`), o = a || r.getBoundingClientRect(), s = i.getBoundingClientRect();
    a = {
        x: $4f524dd59a699d69$var$m(t, o.x, s.x - o.x, n),
        y: $4f524dd59a699d69$var$m(t, o.y, s.y - o.y, n),
        width: $4f524dd59a699d69$var$m(t, o.width, s.width - o.width, n),
        height: $4f524dd59a699d69$var$m(t, o.height, s.height - o.height, n)
    }, $4f524dd59a699d69$var$A(e, a), e.setState(`__activeStagePosition`, a);
}
function $4f524dd59a699d69$var$D(e, t) {
    if (!t) return;
    let n = t.getBoundingClientRect(), r = {
        x: n.x,
        y: n.y,
        width: n.width,
        height: n.height
    };
    e.setState(`__activeStagePosition`, r), $4f524dd59a699d69$var$A(e, r);
}
function $4f524dd59a699d69$var$O(e) {
    let t = e.getState(`__activeStagePosition`), n = e.getState(`__overlaySvg`);
    if (!t) return;
    if (!n) {
        console.warn(`No stage svg found.`);
        return;
    }
    let r = window.innerWidth, i = window.innerHeight;
    n.setAttribute(`viewBox`, `0 0 ${r} ${i}`);
}
function $4f524dd59a699d69$var$k(e, t) {
    let r = $4f524dd59a699d69$var$M(e, t);
    document.body.appendChild(r), $4f524dd59a699d69$var$n(r, (t)=>{
        t.target.tagName === `path` && e.emit(`overlayClick`);
    }), e.setState(`__overlaySvg`, r);
}
function $4f524dd59a699d69$var$A(e, t) {
    let n = e.getState(`__overlaySvg`);
    if (!n) {
        $4f524dd59a699d69$var$k(e, t);
        return;
    }
    let r = n.firstElementChild;
    if (r?.tagName !== `path`) throw Error(`no path element found in stage svg`);
    r.setAttribute(`d`, $4f524dd59a699d69$var$T(t, $4f524dd59a699d69$var$j(e)));
}
function $4f524dd59a699d69$var$j(e) {
    return {
        padding: e.getConfig(`stagePadding`) || 0,
        radius: e.getConfig(`stageRadius`) || 0
    };
}
function $4f524dd59a699d69$var$M(e, t) {
    let n = window.innerWidth, r = window.innerHeight, i = document.createElementNS(`http://www.w3.org/2000/svg`, `svg`);
    i.classList.add(`driver-overlay`, `driver-overlay-animated`), i.setAttribute(`viewBox`, `0 0 ${n} ${r}`), i.setAttribute(`xmlSpace`, `preserve`), i.setAttribute(`xmlnsXlink`, `http://www.w3.org/1999/xlink`), i.setAttribute(`version`, `1.1`), i.setAttribute(`preserveAspectRatio`, `xMinYMin slice`), i.style.fillRule = `evenodd`, i.style.clipRule = `evenodd`, i.style.strokeLinejoin = `round`, i.style.strokeMiterlimit = `2`, i.style.zIndex = `10000`, i.style.position = `fixed`, i.style.top = `0`, i.style.left = `0`, i.style.width = `100%`, i.style.height = `100%`;
    let a = document.createElementNS(`http://www.w3.org/2000/svg`, `path`);
    return a.setAttribute(`d`, $4f524dd59a699d69$var$T(t, $4f524dd59a699d69$var$j(e))), a.style.fill = e.getConfig(`overlayColor`) || `rgb(0,0,0)`, a.style.opacity = `${e.getConfig(`overlayOpacity`)}`, a.style.pointerEvents = `auto`, a.style.cursor = `auto`, i.appendChild(a), i;
}
function $4f524dd59a699d69$var$N(e) {
    let t = e.getState(`__overlaySvg`);
    t && ($4f524dd59a699d69$var$r(t), t.remove());
}
const $4f524dd59a699d69$var$P = `{{current}} of {{total}}`;
function $4f524dd59a699d69$var$F(e, t) {
    return !(t.skipMissingElement ?? e.getConfig(`skipMissingElement`)) || !t.element ? !1 : !$4f524dd59a699d69$var$f(t.element);
}
function $4f524dd59a699d69$var$I(e, t, n) {
    let r = e.getConfig(`steps`) || [];
    for(let i = t; i >= 0 && i < r.length; i += n)if (!$4f524dd59a699d69$var$F(e, r[i])) return i;
}
function $4f524dd59a699d69$var$L(e, t) {
    let n = e.getState(`activeIndex`), r = n !== void 0 && $4f524dd59a699d69$var$I(e, n + 1, 1) === void 0, i = t?.popover?.onDoneClick || e.getConfig(`onDoneClick`);
    return r && i ? i : t?.popover?.onNextClick || e.getConfig(`onNextClick`);
}
function $4f524dd59a699d69$var$R(e, t) {
    return t?.popover?.onPrevClick || e.getConfig(`onPrevClick`);
}
function $4f524dd59a699d69$var$z(e, t) {
    return t?.popover?.onCloseClick || e.getConfig(`onCloseClick`);
}
function $4f524dd59a699d69$var$B(e, t, n) {
    let r = e.getConfig(`steps`) || [], i = r[t], a = i.popover || {}, o = $4f524dd59a699d69$var$I(e, t + 1, 1) !== void 0, s = $4f524dd59a699d69$var$I(e, t - 1, -1) !== void 0, c = a.doneBtnText || e.getConfig(`doneBtnText`) || `Done`, l = e.getConfig(`allowClose`), u = a.showProgress === void 0 ? e.getConfig(`showProgress`) : a.showProgress, d = (a.progressText || e.getConfig(`progressText`) || $4f524dd59a699d69$var$P).replace(`{{current}}`, `${t + 1}`).replace(`{{total}}`, `${r.length}`), f = a.showButtons || e.getConfig(`showButtons`), p = [
        `next`,
        `previous`,
        ...l ? [
            `close`
        ] : []
    ].filter((e)=>!f?.length || f.includes(e)), m = a.onNextClick || e.getConfig(`onNextClick`), h = a.onPrevClick || e.getConfig(`onPrevClick`), g = a.onCloseClick || e.getConfig(`onCloseClick`);
    return {
        ...i,
        popover: {
            showButtons: p,
            nextBtnText: o ? void 0 : c,
            disableButtons: [
                ...s ? [] : [
                    `previous`
                ]
            ],
            showProgress: u,
            onNextClick: m || n.onNextClick,
            onPrevClick: h || n.onPrevClick,
            onCloseClick: g || n.onCloseClick,
            ...a,
            progressText: d
        }
    };
}
function $4f524dd59a699d69$var$V(e, t, n) {
    let r = e.getConfig(`stagePadding`) || 0;
    return {
        side: n.popover?.side || `bottom`,
        align: n.popover?.align || `start`,
        offset: r + (e.getConfig(`popoverOffset`) || 0),
        padding: r,
        centered: t.id === `driver-dummy-element`
    };
}
function $4f524dd59a699d69$var$H(e, t, n) {
    let r = n.popover || {}, i = e.getState(`activeIndex`), a = i !== void 0 && $4f524dd59a699d69$var$I(e, i + 1, 1) === void 0;
    return {
        title: r.title,
        description: r.description,
        showButtons: r.showButtons || e.getConfig(`showButtons`),
        disableButtons: r.disableButtons || e.getConfig(`disableButtons`) || [],
        showProgress: r.showProgress || e.getConfig(`showProgress`) || !1,
        progressText: r.progressText ?? (e.getConfig(`progressText`) || $4f524dd59a699d69$var$P),
        nextBtnText: r.nextBtnText ?? (e.getConfig(`nextBtnText`) || `Next`),
        prevBtnText: r.prevBtnText ?? (e.getConfig(`prevBtnText`) || `Previous`),
        doneButton: a,
        popoverClass: r.popoverClass || e.getConfig(`popoverClass`) || ``,
        smoothScroll: e.getConfig(`smoothScroll`),
        onNextClick: ()=>{
            let r = $4f524dd59a699d69$var$L(e, n);
            return r ? r(t, n, e.getHookOpts()) : e.emit(`nextClick`);
        },
        onPrevClick: ()=>{
            let r = $4f524dd59a699d69$var$R(e, n);
            return r ? r(t, n, e.getHookOpts()) : e.emit(`prevClick`);
        },
        onCloseClick: ()=>{
            let r = $4f524dd59a699d69$var$z(e, n);
            return r ? r(t, n, e.getHookOpts()) : e.emit(`closeClick`);
        },
        onRender: (t)=>{
            e.setState(`popover`, t), (r.onPopoverRender || e.getConfig(`onPopoverRender`))?.(t, e.getHookOpts());
        },
        position: $4f524dd59a699d69$var$V(e, t, n)
    };
}
function $4f524dd59a699d69$var$U(e, t, n) {
    $4f524dd59a699d69$var$w(e.getState(`popover`)), $4f524dd59a699d69$var$x(t, $4f524dd59a699d69$var$H(e, t, n));
}
function $4f524dd59a699d69$var$W(e, t, n) {
    let r = e.getState(`popover`);
    r && $4f524dd59a699d69$var$s(r, t, $4f524dd59a699d69$var$V(e, t, n));
}
function $4f524dd59a699d69$var$G() {
    let e = document.getElementById(`driver-dummy-element`);
    if (e) return e;
    let t = document.createElement(`div`);
    return t.id = `driver-dummy-element`, t.style.width = `0`, t.style.height = `0`, t.style.pointerEvents = `none`, t.style.opacity = `0`, t.style.position = `fixed`, t.style.top = `50%`, t.style.left = `50%`, document.body.appendChild(t), t;
}
function $4f524dd59a699d69$var$K(e, t) {
    let n = $4f524dd59a699d69$var$f(t.element);
    n || (n = $4f524dd59a699d69$var$G()), $4f524dd59a699d69$var$J(e, n, t);
}
function $4f524dd59a699d69$var$q(e) {
    let t = e.getState(`__activeElement`), n = e.getState(`__activeStep`);
    t && ($4f524dd59a699d69$var$D(e, t), $4f524dd59a699d69$var$O(e), $4f524dd59a699d69$var$W(e, t, n));
}
function $4f524dd59a699d69$var$J(e, t, n) {
    let r = e.getConfig(`duration`) || 400, i = Date.now(), a = e.getState(`__activeStep`), o = e.getState(`__activeElement`) || t, s = !o || o === t, c = t.id === `driver-dummy-element`, l = o.id === `driver-dummy-element`, u = e.getConfig(`animate`), d = n.onHighlightStarted || e.getConfig(`onHighlightStarted`), f = n?.onHighlighted || e.getConfig(`onHighlighted`), m = a?.onDeselected || e.getConfig(`onDeselected`), h = e.getHookOpts();
    !s && m && m(l ? void 0 : o, a, h), d && d(c ? void 0 : t, n, h);
    let _ = !s && u, v = !1;
    $4f524dd59a699d69$var$b(e.getState(`popover`)), e.setState(`previousStep`, a), e.setState(`previousElement`, o), e.setState(`activeStep`, n), e.setState(`activeElement`, t);
    let y = ()=>{
        if (e.getState(`__transitionCallback`) !== y) return;
        let s = Date.now() - i, l = r - s <= r / 2;
        n.popover && l && !v && _ && ($4f524dd59a699d69$var$U(e, t, n), v = !0), e.getConfig(`animate`) && s < r ? $4f524dd59a699d69$var$E(e, s, r, o, t) : ($4f524dd59a699d69$var$D(e, t), f && f(c ? void 0 : t, n, e.getHookOpts()), e.setState(`__transitionCallback`, void 0), e.setState(`__previousStep`, a), e.setState(`__previousElement`, o), e.setState(`__activeStep`, n), e.setState(`__activeElement`, t)), window.requestAnimationFrame(y);
    };
    e.setState(`__transitionCallback`, y), window.requestAnimationFrame(y), $4f524dd59a699d69$var$g(t, e.getConfig(`smoothScroll`)), !_ && n.popover && $4f524dd59a699d69$var$U(e, t, n), document.querySelectorAll(`.driver-active-element-parent`).forEach((e)=>{
        e.classList.remove(`driver-active-element-parent`, `driver-active-element-parent-no-scroll`);
    }), o.classList.remove(`driver-active-element`, `driver-no-interaction`), o.removeAttribute(`aria-haspopup`), o.removeAttribute(`aria-expanded`), o.removeAttribute(`aria-controls`), (n.disableActiveInteraction ?? e.getConfig(`disableActiveInteraction`)) && t.classList.add(`driver-no-interaction`);
    let x = t.parentElement;
    x && x !== document.body && (x.classList.add(`driver-active-element-parent`), $4f524dd59a699d69$var$p(x) && x.classList.add(`driver-active-element-parent-no-scroll`)), t.classList.add(`driver-active-element`), t.setAttribute(`aria-haspopup`, `dialog`), t.setAttribute(`aria-expanded`, `true`), t.setAttribute(`aria-controls`, `driver-popover-content`);
}
function $4f524dd59a699d69$var$Y() {
    document.getElementById(`driver-dummy-element`)?.remove(), document.querySelectorAll(`.driver-active-element`).forEach((e)=>{
        let t = e.parentElement;
        t && t !== document.body && t.classList.remove(`driver-active-element-parent`, `driver-active-element-parent-no-scroll`), e.classList.remove(`driver-active-element`, `driver-no-interaction`), e.removeAttribute(`aria-haspopup`), e.removeAttribute(`aria-expanded`), e.removeAttribute(`aria-controls`);
    });
}
function $4f524dd59a699d69$var$X(e) {
    let t = e.getState(`__resizeTimeout`);
    t && window.cancelAnimationFrame(t), e.setState(`__resizeTimeout`, window.requestAnimationFrame(()=>$4f524dd59a699d69$var$q(e)));
}
function $4f524dd59a699d69$var$Z(e, t) {
    if (!e.getState(`isInitialized`) || !(t.key === `Tab` || t.keyCode === 9)) return;
    let n = e.getState(`__activeElement`), r = e.getState(`popover`)?.wrapper, i = $4f524dd59a699d69$var$h([
        ...r ? [
            r
        ] : [],
        ...n ? [
            n
        ] : []
    ]), a = i[0], o = i[i.length - 1];
    t.preventDefault(), t.shiftKey ? (i[i.indexOf(document.activeElement) - 1] || o)?.focus() : (i[i.indexOf(document.activeElement) + 1] || a)?.focus();
}
function $4f524dd59a699d69$var$Q(e, t) {
    (e.getConfig(`allowKeyboardControl`) ?? !0) && (t.key === `Escape` ? e.emit(`escapePress`) : t.key === `ArrowRight` ? e.emit(`arrowRightPress`) : t.key === `ArrowLeft` && e.emit(`arrowLeftPress`));
}
function $4f524dd59a699d69$var$$(e, t) {
    let n = e.getState(`__activeElement`), r = t.target;
    !n || !r || !n.contains(r) || e.emit(`activeElementClick`);
}
function $4f524dd59a699d69$var$ee(e) {
    let t = (t)=>$4f524dd59a699d69$var$Q(e, t), n = (t)=>$4f524dd59a699d69$var$Z(e, t), r = ()=>$4f524dd59a699d69$var$X(e), i = ()=>$4f524dd59a699d69$var$X(e), a = (t)=>$4f524dd59a699d69$var$$(e, t);
    e.setState(`__events`, {
        onKeyup: t,
        onKeydown: n,
        onResize: r,
        onScroll: i,
        onClick: a
    }), window.addEventListener(`keyup`, t, !1), window.addEventListener(`keydown`, n, !1), window.addEventListener(`resize`, r), window.addEventListener(`scroll`, i), document.addEventListener(`click`, a, !1);
}
function $4f524dd59a699d69$var$te(e) {
    let t = e.getState(`__events`);
    t && (window.removeEventListener(`keyup`, t.onKeyup), window.removeEventListener(`keydown`, t.onKeydown), window.removeEventListener(`resize`, t.onResize), window.removeEventListener(`scroll`, t.onScroll), document.removeEventListener(`click`, t.onClick, !1));
}
function $4f524dd59a699d69$var$ne() {
    let e = {};
    function t(t1 = {}) {
        e = {
            animate: !0,
            duration: 400,
            allowClose: !0,
            allowScroll: !0,
            overlayClickBehavior: `close`,
            overlayOpacity: .7,
            smoothScroll: !1,
            disableActiveInteraction: !1,
            advanceOnClick: !1,
            skipMissingElement: !1,
            waitForElement: 0,
            showProgress: !1,
            stagePadding: 10,
            stageRadius: 5,
            popoverOffset: 10,
            showButtons: [
                `next`,
                `previous`,
                `close`
            ],
            disableButtons: [],
            overlayColor: `#000`,
            ...t1
        };
    }
    return t(), {
        getConfig: (t)=>t ? e[t] : e,
        configure: t
    };
}
function $4f524dd59a699d69$var$re() {
    let e = {}, t = (t)=>t ? e[t] : e, n = (t, n)=>{
        e[t] = n;
    };
    function r() {
        e = {};
    }
    return {
        getState: t,
        setState: n,
        resetState: r
    };
}
function $4f524dd59a699d69$var$ie() {
    let e = {};
    function t(t, n) {
        e[t] = n;
    }
    function n(t) {
        e[t]?.();
    }
    function r() {
        e = {};
    }
    return {
        listen: t,
        emit: n,
        reset: r
    };
}
function $4f524dd59a699d69$var$ae(e = {}) {
    let t = $4f524dd59a699d69$var$ne();
    t.configure(e);
    let n = $4f524dd59a699d69$var$re(), r = $4f524dd59a699d69$var$ie(), i;
    return {
        getConfig: t.getConfig,
        setConfig: t.configure,
        getState: n.getState,
        setState: n.setState,
        resetState: n.resetState,
        listen: r.listen,
        emit: r.emit,
        resetEmitter: r.reset,
        getDriver: ()=>i,
        setDriver: (e)=>{
            i = e;
        },
        getHookOpts: (e)=>{
            let r = e || n.getState();
            return {
                config: t.getConfig(),
                state: r,
                driver: i,
                index: r.activeIndex
            };
        }
    };
}
function $4f524dd59a699d69$export$7a292f067638ecd6(e = {}) {
    let t = $4f524dd59a699d69$var$ae(e);
    function n() {
        t.getConfig(`allowClose`) && h();
    }
    function r() {
        let e = t.getConfig(`overlayClickBehavior`);
        if (t.getConfig(`allowClose`) && e === `close`) {
            h();
            return;
        }
        if (typeof e == `function`) {
            let n = t.getState(`__activeStep`);
            e(t.getState(`__activeElement`), n, t.getHookOpts());
            return;
        }
        if (e === `nextStep`) {
            let e = t.getState(`activeStep`), n = t.getState(`activeElement`), r = $4f524dd59a699d69$var$L(t, e);
            if (r) {
                r(n, e, t.getHookOpts());
                return;
            }
            i();
        }
    }
    function i() {
        let e = t.getState(`activeIndex`), n = t.getConfig(`steps`) || [];
        if (e === void 0) return;
        let r = e + 1;
        n[r] ? m(r) : h();
    }
    function a() {
        let e = t.getState(`activeIndex`), n = t.getConfig(`steps`) || [];
        if (e === void 0) return;
        let r = e - 1;
        n[r] ? m(r) : h();
    }
    function o(e) {
        (t.getConfig(`steps`) || [])[e] ? m(e) : h();
    }
    function s() {
        if (t.getState(`__transitionCallback`)) return;
        let e = t.getState(`__activeStep`);
        if (!e || !(e.advanceOnClick ?? t.getConfig(`advanceOnClick`))) return;
        let n = t.getState(`__activeElement`), r = $4f524dd59a699d69$var$L(t, e);
        if (r) {
            r(n, e, t.getHookOpts());
            return;
        }
        i();
    }
    function c() {
        if (t.getState(`__transitionCallback`)) return;
        let e = t.getState(`activeIndex`), n = t.getState(`__activeStep`), r = t.getState(`__activeElement`);
        if (e === void 0 || n === void 0 || !(t.getConfig(`steps`) || [])[e - 1]) return;
        let i = $4f524dd59a699d69$var$R(t, n);
        if (i) return i(r, n, t.getHookOpts());
        a();
    }
    function l() {
        if (t.getState(`__transitionCallback`)) return;
        let e = t.getState(`activeIndex`), n = t.getState(`__activeStep`), r = t.getState(`__activeElement`);
        if (e === void 0 || n === void 0) return;
        let a = $4f524dd59a699d69$var$L(t, n);
        if (a) return a(r, n, t.getHookOpts());
        i();
    }
    function u() {
        t.getState(`isInitialized`) || (t.setState(`isInitialized`, !0), document.body.classList.add(`driver-active`, t.getConfig(`animate`) ? `driver-fade` : `driver-simple`), t.getConfig(`allowScroll`) || document.body.classList.add(`driver-no-scroll`), document.body.style.setProperty(`--driver-animation-duration`, `${t.getConfig(`duration`) || 400}ms`), $4f524dd59a699d69$var$ee(t), t.listen(`overlayClick`, r), t.listen(`activeElementClick`, s), t.listen(`escapePress`, n), t.listen(`closeClick`, n), t.listen(`arrowLeftPress`, c), t.listen(`arrowRightPress`, l));
    }
    function d() {
        let e = t.getState(`__pendingWaitCancel`);
        e && (t.setState(`__pendingWaitCancel`, void 0), e());
    }
    function p(e, n, r) {
        let i = ()=>{
            a.disconnect(), window.clearTimeout(o), t.setState(`__pendingWaitCancel`, void 0), r();
        }, a = new MutationObserver(()=>{
            $4f524dd59a699d69$var$f(e.element) && i();
        }), o = window.setTimeout(i, n);
        t.setState(`__pendingWaitCancel`, ()=>{
            a.disconnect(), window.clearTimeout(o);
        }), a.observe(document.documentElement, {
            childList: !0,
            subtree: !0,
            attributes: !0
        });
    }
    function m(e = 0, n = !1) {
        d();
        let r = t.getConfig(`steps`);
        if (!r) {
            console.error(`No steps to drive through`), h();
            return;
        }
        if (!r[e]) {
            h();
            return;
        }
        let i = r[e], a = i.waitForElement ?? t.getConfig(`waitForElement`) ?? 0;
        if (!n && a > 0 && i.element && !$4f524dd59a699d69$var$f(i.element)) {
            p(i, a, ()=>m(e, !0));
            return;
        }
        if ($4f524dd59a699d69$var$F(t, i)) {
            let n = t.getState(`activeIndex`), i = typeof n == `number` && e < n ? -1 : 1;
            r[e + i] ? m(e + i) : i === 1 && h();
            return;
        }
        t.setState(`__activeOnDestroyed`, document.activeElement), t.setState(`activeIndex`, e);
        let o = r[e + 1];
        $4f524dd59a699d69$var$K(t, $4f524dd59a699d69$var$B(t, e, {
            onNextClick: ()=>{
                o ? m(e + 1) : h();
            },
            onPrevClick: ()=>{
                m(e - 1);
            },
            onCloseClick: ()=>{
                h();
            }
        }));
    }
    function h(e = !0) {
        let n = t.getState(`__activeElement`), r = t.getState(`__activeStep`), i = t.getState(`__activeOnDestroyed`), a = t.getConfig(`onDestroyStarted`);
        if (e && a) {
            a(!n || n?.id === `driver-dummy-element` ? void 0 : n, r, t.getHookOpts());
            return;
        }
        let o = r?.onDeselected || t.getConfig(`onDeselected`), s = t.getConfig(`onDestroyed`);
        document.body.classList.remove(`driver-active`, `driver-fade`, `driver-simple`, `driver-no-scroll`), document.body.style.removeProperty(`--driver-animation-duration`), d(), $4f524dd59a699d69$var$te(t), $4f524dd59a699d69$var$w(t.getState(`popover`)), $4f524dd59a699d69$var$Y(), $4f524dd59a699d69$var$N(t), t.resetEmitter();
        let c = t.getState();
        if (t.resetState(), n && r) {
            let e = n.id === `driver-dummy-element`;
            o && o(e ? void 0 : n, r, t.getHookOpts(c)), s && s(e ? void 0 : n, r, t.getHookOpts(c));
        }
        i && i.focus();
    }
    let g = {
        isActive: ()=>t.getState(`isInitialized`) || !1,
        refresh: ()=>$4f524dd59a699d69$var$X(t),
        drive: (e = 0)=>{
            u(), m(e);
        },
        setConfig: t.setConfig,
        setSteps: (e)=>{
            d(), t.resetState(), t.setConfig({
                ...t.getConfig(),
                steps: e
            });
        },
        getConfig: t.getConfig,
        getState: t.getState,
        getActiveIndex: ()=>t.getState(`activeIndex`),
        isFirstStep: ()=>{
            let e = t.getState(`activeIndex`);
            return e !== void 0 && $4f524dd59a699d69$var$I(t, e - 1, -1) === void 0;
        },
        isLastStep: ()=>{
            let e = t.getState(`activeIndex`);
            return e !== void 0 && $4f524dd59a699d69$var$I(t, e + 1, 1) === void 0;
        },
        getActiveStep: ()=>t.getState(`activeStep`),
        getActiveElement: ()=>t.getState(`activeElement`),
        getPreviousElement: ()=>t.getState(`previousElement`),
        getPreviousStep: ()=>t.getState(`previousStep`),
        getNextStep: ()=>{
            let e = t.getConfig(`steps`) || [], n = t.getState(`activeIndex`);
            if (n === void 0) return;
            let r = $4f524dd59a699d69$var$I(t, n + 1, 1);
            return r === void 0 ? void 0 : e[r];
        },
        moveNext: i,
        movePrevious: a,
        moveTo: o,
        hasNextStep: ()=>{
            let e = t.getState(`activeIndex`);
            return e !== void 0 && $4f524dd59a699d69$var$I(t, e + 1, 1) !== void 0;
        },
        hasPreviousStep: ()=>{
            let e = t.getState(`activeIndex`);
            return e !== void 0 && $4f524dd59a699d69$var$I(t, e - 1, -1) !== void 0;
        },
        highlight: (e)=>{
            u(), $4f524dd59a699d69$var$K(t, {
                ...e,
                popover: e.popover ? {
                    showButtons: [],
                    showProgress: !1,
                    progressText: ``,
                    ...e.popover
                } : void 0
            });
        },
        destroy: ()=>{
            h(!1);
        }
    };
    return t.setDriver(g), g;
}



const $3d0c747b3f894c98$export$76e2b24a18280c32 = {
    showProgress: true,
    showButtons: [
        'next',
        'previous',
        'close'
    ],
    progressText: '{{current}} of {{total}}',
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'fuse-tour-popover',
    animate: true,
    overlayColor: 'rgba(0, 0, 0, 0.5)',
    smoothScroll: true,
    allowClose: true
};
const $3d0c747b3f894c98$export$a491843cc088839f = (steps, config)=>{
    return (0, $4f524dd59a699d69$export$7a292f067638ecd6)({
        ...$3d0c747b3f894c98$export$76e2b24a18280c32,
        ...config,
        steps: steps
    });
};
const $3d0c747b3f894c98$export$71960fd1648de88d = [
    {
        element: '[data-tour="dashboard-header"]',
        popover: {
            title: 'Welcome to FUSE Dashboard',
            description: 'This is your main dashboard where you can view key metrics and navigate to different sections.',
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: '[data-tour="nav-dashboard"]',
        popover: {
            title: 'Dashboard Navigation',
            description: 'Return to the dashboard at any time by clicking here.',
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: '[data-tour="nav-company"]',
        popover: {
            title: 'Company Section',
            description: 'Access your company details, facilities, documents, stripe details, and statements.',
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: '[data-tour="nav-facilities"]',
        popover: {
            title: 'Facilities Section',
            description: 'View and manage all facilities and their associated equipment.',
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: '[data-tour="nav-users"]',
        popover: {
            title: 'Users Section',
            description: 'Manage user accounts and permissions for your organization.',
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: '[data-tour="nav-statements"]',
        popover: {
            title: 'Statements Section',
            description: 'View financial statements and credit history.',
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: '[data-tour="search-bar"]',
        popover: {
            title: 'Global Search',
            description: 'Quickly find clients, facilities, or equipment using the search bar.',
            side: 'bottom',
            align: 'center'
        }
    },
    {
        element: '[data-tour="support-page-button"]',
        popover: {
            title: 'View Support Page',
            description: 'Access the FUSE support page for additional page help, FAQs, and troubleshooting questions.',
            side: 'bottom',
            align: 'center'
        }
    },
    {
        element: '[data-tour="tour-reset-button"]',
        popover: {
            title: 'Restart Tour',
            description: 'Click here anytime to restart the tour for the current page if you need a refresher.',
            side: 'bottom',
            align: 'center'
        }
    },
    {
        element: '[data-tour="user-settings"]',
        popover: {
            title: 'User Settings',
            description: 'Access profile details and securely sign out.',
            side: 'bottom',
            align: 'start'
        }
    }
];
const $3d0c747b3f894c98$export$e5e01ff4ae0af8aa = [
    {
        element: '[data-tour="facilities-list"]',
        popover: {
            title: 'Facilities Overview',
            description: 'View all your facility locations here. Each facility can have multiple pieces of equipment enrolled in clean fuel programs.',
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: '[data-tour="add-facility-button"]',
        popover: {
            title: 'Add New Facility',
            description: 'Click here to add a new facility location to your account.',
            side: 'left',
            align: 'start'
        }
    },
    {
        element: '[data-tour="facility-search"]',
        popover: {
            title: 'Search Facilities',
            description: 'Quickly find a specific facility by address.',
            side: 'bottom',
            align: 'start'
        }
    }
];
const $3d0c747b3f894c98$export$f825ccf1ead67c47 = [
    {
        element: '[data-tour="facility-info"]',
        popover: {
            title: 'Facility Information',
            description: 'View and update facility details including name, address, and FSE utility.',
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: '[data-tour="facility-equipment-list"]',
        popover: {
            title: 'Equipment at This Facility',
            description: 'View all equipment registered at this facility. Click on any equipment to see details or update usage data.',
            side: 'top',
            align: 'start'
        }
    },
    {
        element: '[data-tour="equipment-actions-button"]',
        popover: {
            title: 'Equipment Actions',
            description: 'Click this menu to access equipment management options including add, edit, retire, and delete equipment.',
            side: 'bottom',
            align: 'start'
        }
    }
];
const $3d0c747b3f894c98$export$7c37f8ecad7b78ca = [
    {
        element: '[data-tour="equipment-list"]',
        popover: {
            title: 'Equipment Overview',
            description: 'View all equipment under your facility. Each facility can have multiple pieces of equipment enrolled in clean fuel programs.',
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: '[data-tour="add-equipment-button"]',
        popover: {
            title: 'Add New Equipment',
            description: 'Click here to add a new piece of equipment to this facility.',
            side: 'left',
            align: 'start'
        }
    },
    {
        element: '[data-tour="equipment-search"]',
        popover: {
            title: 'Search Equipment',
            description: 'Quickly find specific equipment by serial or VIN number.',
            side: 'bottom',
            align: 'start'
        }
    }
];
const $3d0c747b3f894c98$export$647caee5d32955ba = [
    {
        element: '[data-tour="equipment-info"]',
        popover: {
            title: 'Equipment Information',
            description: 'View equipment specifications including make, model, serial number, and registration details.',
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: '#equipment-usage-data',
        popover: {
            title: 'Quarterly Usage Data',
            description: 'Enter kWh consumption data for each reporting quarter. This data is used to calculate your clean fuel credits.',
            side: 'top',
            align: 'start'
        }
    }
];
const $3d0c747b3f894c98$export$869d9546d6e0f9ad = [
    {
        element: '[data-tour="users-list"]',
        popover: {
            title: 'User Management',
            description: "View and manage all users who have access to your organization's FUSE account.",
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: '[data-tour="add-user-button"]',
        popover: {
            title: 'Add New User',
            description: 'Invite new team members to access FUSE. You can assign different permission levels.',
            side: 'left',
            align: 'start'
        }
    },
    {
        element: '[data-tour="user-search"]',
        popover: {
            title: 'Search Users',
            description: 'Quickly find specific users by name, email, or other criteria.',
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: '[data-tour="user-filters"]',
        popover: {
            title: 'User Filters',
            description: 'Filter users by role (Admin, User, Facility User) or status (Active, Inactive) to narrow down the list.',
            side: 'bottom',
            align: 'start'
        }
    }
];
const $3d0c747b3f894c98$export$c55ca0fafd817c94 = [
    {
        element: '[data-tour="company-info"]',
        popover: {
            title: 'Company Information',
            description: "View and update your organization's corporate information including legal name, FEIN/Business number, and status.",
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: '[data-tour="contacts-tab"]',
        popover: {
            title: 'Contacts Tab',
            description: 'Click here to manage contact information for key personnel and administrators.',
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: '[data-tour="documents-tab"]',
        popover: {
            title: 'Documents Tab',
            description: 'Click here to upload and manage important documents related to your company and programs.',
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: '[data-tour="stripe-tab"]',
        popover: {
            title: 'Stripe Details Tab',
            description: 'Click here to manage banking and payment details for receiving incentive payments.',
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: '[data-tour="corporate-info"]',
        popover: {
            title: 'Corporate Details',
            description: "View and update your organization's corporate address information",
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: '#facility_list',
        popover: {
            title: 'Facilities Overview',
            description: 'View all facility locations associated with this company. Click to manage individual facilities.',
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: '[data-tour="statements-list"]',
        popover: {
            title: 'Statements History',
            description: 'View quarterly incentive statements showing credits generated and incentives.',
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: '[data-tour="users-list"]',
        popover: {
            title: 'User Management',
            description: 'Manage user accounts and permissions for accessing this company information.',
            side: 'bottom',
            align: 'start'
        }
    }
];
const $3d0c747b3f894c98$export$5ae791509b33d09b = [
    {
        element: '[data-tour="statements-list"]',
        popover: {
            title: 'Incentive Statements',
            description: 'View all your quarterly incentive statements showing credits generated and incentives.',
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: '[data-tour="statement-details"]',
        popover: {
            title: 'Statement Details',
            description: 'Click on a statement to view detailed breakdown of credits, rates, and payment information.',
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: '[data-tour="individual-statement"]',
        popover: {
            title: 'Individual Statement',
            description: 'Click to view the summary statement with breakdown of credits and incentives of enrolled programs with the option to download pdf.',
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: '[data-tour="detailed-statement"]',
        popover: {
            title: 'Detailed Statement',
            description: 'Click to view the detailed statement with breakdown of credits and incentives of enrolled programs with the option to download pdf.',
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: '[data-tour="view-individual-programs"]',
        popover: {
            title: 'View Individual Programs',
            description: 'Click to expand and view statements for each individual program within this reporting period.',
            side: 'bottom',
            align: 'start'
        }
    }
];
const $3d0c747b3f894c98$export$b91f7e6a749a57bf = (tourName)=>{
    let steps = [];
    switch(tourName){
        case 'dashboard':
            steps = $3d0c747b3f894c98$export$71960fd1648de88d;
            break;
        case 'facilities-list':
            steps = $3d0c747b3f894c98$export$e5e01ff4ae0af8aa;
            break;
        case 'facility-details':
            steps = $3d0c747b3f894c98$export$f825ccf1ead67c47;
            break;
        case 'equipment-list':
            steps = $3d0c747b3f894c98$export$7c37f8ecad7b78ca;
            break;
        case 'equipment-details':
            steps = $3d0c747b3f894c98$export$647caee5d32955ba;
            break;
        case 'users':
            steps = $3d0c747b3f894c98$export$869d9546d6e0f9ad;
            break;
        case 'company':
            steps = $3d0c747b3f894c98$export$c55ca0fafd817c94;
            break;
        case 'statements':
            steps = $3d0c747b3f894c98$export$5ae791509b33d09b;
            break;
    }
    const tour = $3d0c747b3f894c98$export$a491843cc088839f(steps);
    tour.drive();
};
const $3d0c747b3f894c98$export$77062b4cb4095a52 = (tourName)=>{
    return localStorage.getItem(`tour_completed_${tourName}`) === 'true';
};
const $3d0c747b3f894c98$export$23395c972863dbd3 = (tourName)=>{
    localStorage.setItem(`tour_completed_${tourName}`, 'true');
};
const $3d0c747b3f894c98$export$1edc71d0f1beb631 = (tourName)=>{
    localStorage.removeItem(`tour_completed_${tourName}`);
};
const $3d0c747b3f894c98$export$8186df7617e1c8db = ()=>{
    const keys = Object.keys(localStorage).filter((key)=>key.startsWith('tour_completed_'));
    keys.forEach((key)=>localStorage.removeItem(key));
};
const $3d0c747b3f894c98$export$39462dac4b1c91cd = (pathname, clientId)=>{
    if (pathname === '/') return 'dashboard-tour';
    if (pathname.includes('/facilities') && pathname.includes('/equipment') && !pathname.includes('/create')) return 'equipment-list-tour';
    if (pathname.includes('/equipment/') && !pathname.includes('/create')) return 'equipment-details-tour';
    if (pathname.includes(`/clients/${clientId}/facilities/`) && !pathname.includes('/create')) return 'facility-details-tour';
    if (pathname.includes('/facilities') && !pathname.includes('/create')) return 'facilities-list-tour';
    if (pathname.includes(`/clients/${clientId}/users`)) return 'users-tour';
    if (pathname.includes(`/clients/${clientId}/statements`)) return 'statements-tour';
    if (pathname.includes(`/clients/${clientId}`) && !pathname.includes('/facilities') && !pathname.includes('/users')) return 'company-tour';
    return null;
};


const $c3e91fa8212c6d4c$export$50d7b5e01df871ca = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const clientStore = (0, $116967e0234c3770$export$3b47afa599c78f61)();
    const modelAuditLogStore = (0, $116967e0234c3770$export$88b0cc0fc4818e39)();
    const location = (0, $62d58f5c28b15c2e$export$45d76561a5302f2b)();
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const isMobile = (0, $2xPiy.useMemo)(()=>screenSize === 'small', [
        screenSize
    ]);
    const tooltips = (0, $d597772cdbe12609$export$4713da6aa4410043)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const [hoverItem, setHoverItem] = (0, $2xPiy.useState)();
    const clientId = userStore.isExternalUser ? clientStore.activeClientId : clientStore.selectedClientId;
    (0, $2xPiy.useEffect)(()=>{
        modelAuditLogStore.fetchModelAuditLogs({
            action_taken_by: (0, $0badf5665deea2b2$export$61d688781044f006).ExternalUser,
            model_audit_log_state_id: (0, $0badf5665deea2b2$export$b60056a547589254).Unresolved
        }).catch((err)=>globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).fetchAuditLog.error));
    }, [
        location
    ]);
    const selectedItem = (0, $2xPiy.useMemo)(()=>{
        if (location.pathname.includes(`/clients/${clientId}/facilities`)) return 'Facilities';
        else if (location.pathname.includes(`/clients/${clientId}/users`)) return 'Users';
        else if (location.pathname.includes(`/clients/${clientId}/statements`)) return 'Statements';
        else if (location.pathname.includes(`/clients/${clientId}`)) return 'Company';
        else if (location.pathname.includes('/clients')) return 'Clients';
        else if (location.pathname.includes('/users')) return 'Users';
        else if (location.pathname.includes('/api-data-old')) return 'API Data [Old]';
        else if (location.pathname.includes('/api-data')) return 'API Data [New]';
        else if (location.pathname.includes('/fuse-admin')) return 'FuSE Admin';
        else if (location.pathname === '/') return t('navigation:dashboard');
    }, [
        location.pathname,
        clientId,
        t
    ]);
    const renderLinkItem = (0, $2xPiy.useCallback)((url, label, leftBorderSize)=>{
        const isSelected = selectedItem === label;
        const isHover = hoverItem === label;
        const dataTourAttr = `nav-${label.toLowerCase().replace(/\s+/g, '-')}`;
        return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            // animation={{ type: 'fadeIn', duration: 300 }}
            direction: "row",
            border: {
                side: 'left',
                size: leftBorderSize || '0.75px',
                color: 'light-4'
            },
            width: {
                min: isMobile ? '90px' : '115px'
            },
            justify: "center",
            align: "center",
            style: {
                boxShadow: isSelected || isHover ? 'rgba(24, 100, 158, 0.3) 0px -24px 24px -24px inset' : ''
            },
            transitionProperty: "color, box-shadow",
            transitionDuration: "0.15s, 0.15s",
            transitionTimingFunction: "ease, ease",
            onMouseOver: ()=>setHoverItem(label),
            onMouseOut: ()=>setHoverItem(undefined),
            "data-tour": dataTourAttr,
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                to: url,
                style: {
                    display: 'flex',
                    flex: 1,
                    alignSelf: 'stretch',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: isMobile ? '1rem 0.5rem' : '1rem 0.875rem'
                },
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    transitionProperty: "padding-bottom",
                    transitionDuration: "0.15s",
                    transitionTimingFunction: "ease",
                    pad: {
                        bottom: isHover ? '3px' : undefined
                    },
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        size: isMobile ? label === 'FuSE Admin' || label === 'API Data' ? (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(14) : (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(16) : (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(18),
                        lineHeight: isMobile ? (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(16) : (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(18),
                        weight: 300,
                        color: !isSelected || isHover ? 'accent-2' : 'accent-1',
                        style: {
                            whiteSpace: label === 'FuSE Admin' || label === 'API Data' ? 'nowrap' : 'normal'
                        },
                        children: label
                    })
                })
            })
        }, label);
    }, [
        selectedItem,
        hoverItem,
        setHoverItem,
        isMobile
    ]);
    const linkItems = (0, $2xPiy.useMemo)(()=>[
            // Internal users
            {
                shouldShow: userStore.isInternalUser,
                url: '/',
                label: t('navigation:dashboard')
            },
            {
                shouldShow: userStore.isInternalUser,
                url: '/clients',
                label: t('navigation:clients')
            },
            {
                shouldShow: userStore.isInternalUser,
                url: '/users',
                label: t('navigation:users')
            },
            {
                shouldShow: userStore.isFuseAdmin,
                url: '/api-data',
                label: t('navigation:apiData') + ' [New]'
            },
            {
                shouldShow: userStore.isFuseAdmin,
                url: '/api-data-old',
                label: t('navigation:apiData') + ' [Old]'
            },
            {
                shouldShow: userStore.isInternalUser,
                url: '/fuse-admin/importer',
                label: t('navigation:fuseAdmin')
            },
            // External users
            {
                shouldShow: userStore.isExternalUser,
                url: '/',
                label: t('navigation:dashboard')
            },
            {
                shouldShow: userStore.isClientUser && !!clientId,
                url: `/clients/${clientId}`,
                label: t('navigation:company')
            },
            {
                shouldShow: userStore.isExternalUser && !!clientId,
                url: `/clients/${clientId}/facilities`,
                label: t('navigation:facilities')
            },
            {
                shouldShow: userStore.isClientAdmin && !!clientId,
                url: `/clients/${clientId}/users`,
                label: t('navigation:users')
            },
            {
                shouldShow: userStore.isClientUser && !!clientId,
                url: `/clients/${clientId}/statements`,
                label: t('navigation:statements')
            }
        ], [
        userStore.isInternalUser,
        userStore.isFuseAdmin,
        userStore.isExternalUser,
        userStore.isClientAdmin,
        userStore.isClientUser,
        clientId,
        t
    ]);
    const currentTourName = (0, $2xPiy.useMemo)(()=>{
        return (0, $3d0c747b3f894c98$export$39462dac4b1c91cd)(location.pathname, clientId);
    }, [
        location.pathname,
        clientId
    ]);
    const handleResetTour = ()=>{
        if (currentTourName) {
            (0, $3d0c747b3f894c98$export$1edc71d0f1beb631)(currentTourName);
            const tourNameWithoutSuffix = currentTourName.replace('-tour', '');
            (0, $3d0c747b3f894c98$export$b91f7e6a749a57bf)(tourNameWithoutSuffix);
        }
    };
    const TourResetButton = ()=>{
        if (!currentTourName || userStore.isFuseAdmin) return null;
        return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            width: "20px",
            height: "20px",
            alignSelf: "center",
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                plain: true,
                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $48dbea6a6b8a2aea$export$f93ec6528f706bfe), {
                    size: "20"
                }),
                onClick: handleResetTour,
                tip: t('common:restartPageTour'),
                "data-tour": "tour-reset-button"
            })
        });
    };
    const HelpButton = ()=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            width: "20px",
            height: "20px",
            alignSelf: "center",
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                to: (0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).urls.fuseSupportUrl,
                target: "_blank",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                    plain: true,
                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $64b43dde096e82d9$export$59596d9b033ace49), {
                        size: "20"
                    }),
                    tip: tooltips.support,
                    "data-tour": "support-page-button"
                })
            })
        });
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $74308ae79a3739df$export$8b251419efc915eb), {
        gridArea: props.gridArea,
        direction: "row",
        animation: !globalStore.didAnimateHeader ? {
            type: 'slideDown',
            duration: 300,
            size: 'large'
        } : undefined,
        onAnimationEnd: ()=>globalStore.setDidAnimateHeader(true),
        children: userStore.user && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $2f0cb182ea7bd57a$export$39140c7d8b0ba7b3), {
            animation: !globalStore.didAnimateHeader ? {
                type: 'fadeIn',
                duration: 300
            } : undefined,
            direction: "row",
            background: "white",
            flex: "grow",
            pad: {
                horizontal: isMobile ? '1rem' : '7.2rem'
            },
            border: {
                color: 'brand',
                side: 'bottom',
                size: '4px'
            },
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    direction: "row",
                    align: "center",
                    gap: "small",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $0bcc8f6b5063c31e$export$67abef37aa2929b0), {
                            to: "/",
                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b693aeeca29ae7b2$export$2e2bcd8739ae039), {
                                height: "40px"
                            }),
                            alignSelf: "center"
                        }),
                        screenSize !== 'small' && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            color: "red",
                            weight: "bold",
                            size: "large",
                            children: "DEV"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    direction: "row",
                    border: {
                        side: 'right',
                        size: '0.75px',
                        color: 'light-4'
                    },
                    style: {
                        overflowX: isMobile ? 'auto' : 'visible'
                    },
                    children: linkItems.filter(({ shouldShow: shouldShow })=>shouldShow).map(({ url: url, label: label })=>renderLinkItem(url, label))
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    flex: "grow"
                }),
                location.pathname === '/' && !userStore.isClientUser && !userStore.isFacilityUser && !isMobile && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $781bf4ccfee0e806$export$259abad983af717a), {}),
                location.pathname !== '/search' && !isMobile && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $bc9dd8577744cff7$export$e33d60b8f4099ae), {}),
                userStore.isFuseAdmin && !isMobile && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $a36a48817db21e66$export$669ab06444c0abf), {}),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)(HelpButton, {}),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)(TourResetButton, {}),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6c87f11e3936feb6$export$3dff63dd9b497d3e), {
                    margin: {
                        right: isMobile ? '0.5rem' : '0.875rem'
                    }
                })
            ]
        })
    });
});




var $2xPiy = parcelRequire("2xPiy");




const $9057517707360bf5$export$9b7824917a0c851e = (props)=>{
    const { children: children, isLoading: isLoading, breadcrumbNav: breadcrumbNav, pageHeader: pageHeader, userInfoBar: userInfoBar, title: title, isUserPage: isUserPage } = props;
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const isMobile = (0, $2xPiy.useMemo)(()=>screenSize === 'small' || screenSize === 'xsmall', [
        screenSize
    ]);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $f068601a66842d6c$export$c1faa9c8f42906a), {
        children: [
            isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}),
            !isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
                children: [
                    breadcrumbNav,
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        flex: "grow",
                        pad: {
                            horizontal: isMobile ? '3.75rem' : '8rem',
                            vertical: isMobile ? '2.25rem' : '3rem'
                        },
                        children: [
                            pageHeader ?? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c61d91bfa75be0a1$export$53f1cd6809577fc5), {
                                title: title,
                                isUserPage: isUserPage
                            }),
                            userInfoBar,
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                direction: isMobile ? 'column' : 'row',
                                gap: "medium",
                                children: children
                            })
                        ]
                    })
                ]
            })
        ]
    });
};







var $2xPiy = parcelRequire("2xPiy");



var $2xPiy = parcelRequire("2xPiy");


function $b733993b9aac9c83$var$_extends() {
    return $b733993b9aac9c83$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b733993b9aac9c83$var$_extends.apply(null, arguments);
}
var $b733993b9aac9c83$export$18f0836c03a64fbe = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    var scaleProps = (0, $c043e17d1ada851a$export$56a2e46cd4a7c217)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $b733993b9aac9c83$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "LinkNext"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", $b733993b9aac9c83$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 12h20m-9-9 9 9-9 9"
    }, scaleProps)));
});
$b733993b9aac9c83$export$18f0836c03a64fbe.displayName = 'LinkNext';


var $2xPiy = parcelRequire("2xPiy");

function $3cf30b18191e4322$var$_extends() {
    return $3cf30b18191e4322$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3cf30b18191e4322$var$_extends.apply(null, arguments);
}
var $3cf30b18191e4322$export$14834abbfce3b8cd = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $3cf30b18191e4322$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Notification"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4 19V9a8 8 0 0 1 16 0v10M1 19h22m-8 0v1a3 3 0 1 1-6 0v-1"
    }));
});
$3cf30b18191e4322$export$14834abbfce3b8cd.displayName = 'Notification';








const $a36a48817db21e66$export$669ab06444c0abf = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { ...boxProps } = props;
    const modelAuditLogStore = (0, $116967e0234c3770$export$88b0cc0fc4818e39)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const maxLogs = (0, $2xPiy.useRef)(10);
    const tooltips = (0, $d597772cdbe12609$export$4713da6aa4410043)();
    const [dropIsOpen, setDropIsOpen] = (0, $2xPiy.useState)(false);
    const renderIcon = ()=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $1e7958766884f71d$export$694e0d28c7ffc90c), {
            anchor: "top-right",
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    align: "center",
                    justify: "center",
                    width: "24px",
                    height: "28px",
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $3cf30b18191e4322$export$14834abbfce3b8cd), {
                        size: "20px"
                    })
                }),
                !dropIsOpen && !!modelAuditLogStore.modelAuditLogs?.length && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    background: "red",
                    width: "12px",
                    height: "12px",
                    align: "center",
                    justify: "center",
                    round: true
                })
            ]
        });
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        justify: "center",
        ...boxProps,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c9158ac1cba12f75$export$64fff40e709e8b2e), {
                plain: true,
                tip: tooltips.logNotifications,
                icon: renderIcon(),
                open: dropIsOpen,
                reverse: true,
                onOpen: ()=>{
                    setDropIsOpen(true);
                    modelAuditLogStore.fetchModelAuditLogs({
                        action_taken_by: (0, $0badf5665deea2b2$export$61d688781044f006).ExternalUser,
                        model_audit_log_state_id: (0, $0badf5665deea2b2$export$b60056a547589254).Unresolved
                    });
                },
                onClose: ()=>{
                    setDropIsOpen(false);
                    modelAuditLogStore.reset();
                },
                dropAlign: {
                    top: 'bottom',
                    right: 'right'
                },
                dropContent: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    flex: "grow",
                    width: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(475),
                    border: {
                        size: 'small',
                        color: 'light-2'
                    },
                    height: !modelAuditLogStore.modelAuditLogs || modelAuditLogStore.isLoading ? '10rem' : undefined,
                    children: [
                        (!modelAuditLogStore.modelAuditLogs || modelAuditLogStore.isLoading) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}),
                        !!modelAuditLogStore.modelAuditLogs && !modelAuditLogStore.isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    row: true,
                                    pad: {
                                        horizontal: 'small',
                                        vertical: '18px'
                                    },
                                    gap: "xsmall",
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $796804e8c8878bbf$export$8e3d391089488a08), {
                                            size: "18px"
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                            size: "18px",
                                            children: t('navigation:unresolvedLogs')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    border: {
                                        side: 'horizontal',
                                        color: 'brand',
                                        size: '2px'
                                    },
                                    transitionProperty: "height",
                                    transitionDuration: "0.3s",
                                    transitionTimingFunction: "ease",
                                    children: [
                                        !!modelAuditLogStore.modelAuditLogs.length && modelAuditLogStore.modelAuditLogs.slice(0, maxLogs.current).map((modelAuditLog, i)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                                                to: `/change-logs/${modelAuditLog.id}`,
                                                onClick: ()=>setDropIsOpen(false),
                                                color: "accent-1",
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                    row: true,
                                                    align: "center",
                                                    gap: "xsmall",
                                                    pad: "small",
                                                    background: i % 2 ? 'white' : 'light-6',
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d8fcb0015cca0f72$export$825a3c81a577bf46), {
                                                            size: "16",
                                                            color: "text",
                                                            entityName: modelAuditLog.model_name
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                            row: true,
                                                            gap: "4px",
                                                            align: "center",
                                                            children: [
                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                        truncate: true,
                                                                        color: "accent-1",
                                                                        children: (0, $00658ccd6ec0135a$export$83ca57d51225263a)(modelAuditLog.model, modelAuditLog.model_name)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                    flex: "grow",
                                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                        children: [
                                                                            "was ",
                                                                            modelAuditLog.model_audit_log_event_type.name.toLowerCase(),
                                                                            "d by",
                                                                            ' ',
                                                                            modelAuditLog.user.name
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }, i)),
                                        !modelAuditLogStore.modelAuditLogs.length && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            pad: {
                                                vertical: 'medium'
                                            },
                                            background: "light-6",
                                            justify: "center",
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                alignSelf: "center",
                                                size: "medium",
                                                fontFamily: "Lato, sans-serif",
                                                children: t('navigation:noUnresolvedChangeLogs')
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    pad: "small",
                                    align: "center",
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                                        to: '/change-logs',
                                        onClick: ()=>setDropIsOpen(false),
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $85ab7488c493b81c$export$6d88ebe453be59d7), {
                                            border: {
                                                size: '0'
                                            },
                                            label: t('navigation:viewAllChangeLogs'),
                                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b733993b9aac9c83$export$18f0836c03a64fbe), {
                                                size: "14px"
                                            }),
                                            reverse: true
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
});




var $2xPiy = parcelRequire("2xPiy");














const $372c0dd4210c0f1d$var$AUDIT_LOG_DEFAULTS = {
    page: 1,
    action_taken_by: (0, $0badf5665deea2b2$export$61d688781044f006).ExternalUser,
    model_audit_log_state_id: (0, $0badf5665deea2b2$export$b60056a547589254).Unresolved,
    model_name: undefined,
    model_id: undefined,
    user_id: undefined
};
const $372c0dd4210c0f1d$var$AUDIT_LOG_CLEARED = {
    ...$372c0dd4210c0f1d$var$AUDIT_LOG_DEFAULTS
};
const $372c0dd4210c0f1d$export$9b4fb0669564c0d5 = (props)=>{
    /* Props */ const { title: title = 'Logs List', hideHeader: hideHeader, surfaceId: surfaceId, ...boxProps } = props;
    /* Context */ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const queryClient = (0, $bccbe1b43ff3d0cc$export$22e77b9572c4fded)();
    const tooltips = (0, $d597772cdbe12609$export$4713da6aa4410043)();
    /* Restorable state */ const restorableList = (0, $d73aac7e90cb996d$export$e4108de26414712f)({
        surfaceId: surfaceId || 'audit-log-list',
        defaults: $372c0dd4210c0f1d$var$AUDIT_LOG_DEFAULTS,
        standalone: true
    });
    const queryState = restorableList.state;
    const setQueryState = restorableList.setState;
    /* Draft state */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [draftFilters, setDraftFilters] = (0, $2xPiy.useState)({
        action_taken_by: queryState.action_taken_by ?? '',
        model_audit_log_state_id: queryState.model_audit_log_state_id ?? 0,
        model_name: queryState.model_name ?? ''
    });
    const [isUpdating, setIsUpdating] = (0, $2xPiy.useState)(false);
    const [isFiltersMenuOpen, setIsFiltersMenuOpen] = (0, $2xPiy.useState)(false);
    const [isFiltersMenuHovered, setIsFiltersMenuHovered] = (0, $2xPiy.useState)(false);
    const [selectedRows, setSelectedRows] = (0, $2xPiy.useState)({});
    const [allRowsSelected, setAllRowsSelected] = (0, $2xPiy.useState)(false);
    const [expandedRows, setExpandedRows] = (0, $2xPiy.useState)({});
    /* Build the API request */ const request = (0, $2xPiy.useMemo)(()=>({
            page: queryState.page,
            limit: 20,
            action_taken_by: queryState.action_taken_by || undefined,
            model_audit_log_state_id: queryState.model_audit_log_state_id || undefined,
            model_name: queryState.model_name || undefined,
            model_id: queryState.model_id || undefined,
            user_id: queryState.user_id || undefined
        }), [
        queryState
    ]);
    /* React Query */ const { data: queryData, isLoading: queryIsLoading, isFetching: isFetching, error: queryError } = (0, $4130e158515cd100$export$dd0a697e1782aedd)({
        queryKey: [
            'model-audit-logs',
            userStore.user?.id,
            request
        ],
        queryFn: async ()=>{
            const response = await (0, $05bcb43788f04b5c$export$ef093b57d2fc4c08).list(request);
            return {
                meta: response.meta,
                data: response.data.filter((log)=>Object.values((0, $1132a1d774d1082e$export$8fde3cbed0ae03c0)).includes(log.model_name))
            };
        },
        enabled: !!userStore.user,
        placeholderData: (prev)=>prev
    });
    const modelAuditLogs = queryData?.data;
    const metadata = queryData?.meta;
    /* Show toast on query error */ (0, $2xPiy.useEffect)(()=>{
        if (queryError) globalStore.handleApiError(queryError, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listAuditLogs.error);
    }, [
        queryError
    ]);
    /* Computed */ const _isLoading = queryIsLoading || isFetching;
    const isRefetching = isFetching && !queryIsLoading;
    const hasModelAuditLogs = !!modelAuditLogs?.length;
    const hasSelectedRows = !!Object.values(selectedRows).find((row)=>!!row);
    const draftActionTakenBy = draftFilters.action_taken_by || $372c0dd4210c0f1d$var$AUDIT_LOG_DEFAULTS.action_taken_by;
    const statusFilterOptions = (0, $2xPiy.useMemo)(()=>{
        const options = [
            {
                label: 'All',
                value: 0
            }
        ];
        if (draftActionTakenBy !== (0, $0badf5665deea2b2$export$61d688781044f006).System && draftActionTakenBy !== (0, $0badf5665deea2b2$export$61d688781044f006).InternalUser) {
            options.push({
                label: 'Unresolved',
                value: 1
            });
            options.push({
                label: 'Resolved',
                value: 2
            });
        }
        return options;
    }, [
        draftActionTakenBy
    ]);
    /* Methods */ const getModelLabel = (log)=>{
        const isDelete = log.model_audit_log_event_type.name === (0, $0badf5665deea2b2$export$f4dd91be846acd3a).Delete;
        const isCreate = log.model_audit_log_event_type.name === (0, $0badf5665deea2b2$export$f4dd91be846acd3a).Create;
        let modelData = log.model;
        if (!modelData && isDelete && log.old_data) modelData = log.old_data;
        else if (!modelData && isCreate && log.new_data) modelData = log.new_data;
        if (!modelData) return '';
        let model = {};
        if ((isDelete || isCreate) && !log.model) Object.keys(modelData).forEach((key)=>{
            const val = modelData[key];
            model[(0, $00658ccd6ec0135a$export$7a79460e9abc6302)(key)] = val;
        });
        else model = modelData;
        switch(log.model_name){
            case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Client:
                return String(model.name ?? '');
            case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).ClientFile:
                return String(model.name ?? '');
            case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Facility:
                return String(model.address_line1 ?? '');
            case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Equipment:
                return `${model.manufacturer ?? ''}: ${model.serial_number ?? ''}`;
            case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).EquipmentUsage:
                return 'Equipment Usage';
            case (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).User:
                return String(model.name ?? '');
            default:
                return '';
        }
    };
    const applyFilters = (0, $2xPiy.useCallback)(()=>{
        const committed = {
            action_taken_by: draftFilters.action_taken_by || undefined,
            model_name: draftFilters.model_name || undefined,
            page: 1
        };
        if (draftFilters.action_taken_by === (0, $0badf5665deea2b2$export$61d688781044f006).System || draftFilters.action_taken_by === (0, $0badf5665deea2b2$export$61d688781044f006).InternalUser) {
            committed.model_audit_log_state_id = undefined;
            setDraftFilters((prev)=>({
                    ...prev,
                    model_audit_log_state_id: 0
                }));
        } else committed.model_audit_log_state_id = draftFilters.model_audit_log_state_id || undefined;
        setQueryState(committed);
        setIsFiltersMenuOpen(false);
    }, [
        setQueryState,
        draftFilters
    ]);
    const clearFilters = (0, $2xPiy.useCallback)(()=>{
        setDraftFilters({
            action_taken_by: $372c0dd4210c0f1d$var$AUDIT_LOG_CLEARED.action_taken_by,
            model_audit_log_state_id: $372c0dd4210c0f1d$var$AUDIT_LOG_CLEARED.model_audit_log_state_id,
            model_name: $372c0dd4210c0f1d$var$AUDIT_LOG_CLEARED.model_name
        });
        setQueryState($372c0dd4210c0f1d$var$AUDIT_LOG_CLEARED);
        setIsFiltersMenuOpen(false);
    }, [
        setQueryState
    ]);
    const handlePageChange = (0, $2xPiy.useCallback)((page)=>{
        setQueryState({
            page: page
        });
    }, [
        setQueryState
    ]);
    const resolveSelectedRows = (0, $2xPiy.useCallback)(async ()=>{
        try {
            setIsUpdating(true);
            const promises = Object.keys(selectedRows).filter((logId)=>!!selectedRows[parseInt(logId)]).map((logId)=>(0, $05bcb43788f04b5c$export$ef093b57d2fc4c08).updateState({
                    model_audit_log_id: parseInt(logId),
                    model_audit_log_state_id: (0, $0badf5665deea2b2$export$b60056a547589254).Resolved
                }));
            await Promise.all(promises);
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).resolveAuditLogs.success);
            setAllRowsSelected(false);
            setSelectedRows({});
            queryClient.invalidateQueries({
                queryKey: [
                    'model-audit-logs'
                ]
            });
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).resolveAuditLogs.error);
        } finally{
            setIsUpdating(false);
        }
    }, [
        selectedRows,
        queryClient,
        globalStore
    ]);
    /* Effects */ const handleSelectAll = (0, $2xPiy.useCallback)((selectAll)=>{
        setAllRowsSelected(selectAll);
        if (selectAll) setSelectedRows((prev)=>{
            const next = {
                ...prev
            };
            modelAuditLogs?.forEach((log)=>next[log.id] = true);
            return next;
        });
        else setSelectedRows({});
    }, [
        modelAuditLogs
    ]);
    (0, $2xPiy.useEffect)(()=>{
        setAllRowsSelected(false);
        setSelectedRows({});
    }, [
        queryState.page,
        queryState.action_taken_by,
        queryState.model_audit_log_state_id,
        queryState.model_name
    ]);
    /* Sync page from API response */ (0, $2xPiy.useEffect)(()=>{
        if (metadata && metadata.current_page !== queryState.page) setQueryState({
            page: metadata.current_page
        });
    }, [
        metadata?.current_page
    ]);
    /* Sync drafts when queryState changes */ (0, $d73aac7e90cb996d$export$b5b12661e3d1fa94)(queryState, setDraftFilters, (s)=>({
            action_taken_by: s.action_taken_by ?? '',
            model_audit_log_state_id: s.model_audit_log_state_id ?? 0,
            model_name: s.model_name ?? ''
        }));
    /* Render helpers */ const renderClientColumn = (log)=>{
        const isDelete = log.model_audit_log_event_type.name === (0, $0badf5665deea2b2$export$f4dd91be846acd3a).Delete;
        const isCreate = log.model_audit_log_event_type.name === (0, $0badf5665deea2b2$export$f4dd91be846acd3a).Create;
        const modelData = log.model ?? {};
        const client = log.model_name === (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).User ? modelData.clients?.[0] : log.model_name === (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).ClientFile ? modelData?.client : modelData?.client;
        let clientIdFromData;
        if (isDelete && !log.model && log.old_data) {
            const oldData = log.old_data;
            if (oldData.clientId) clientIdFromData = oldData.clientId;
            else if (oldData.client_id) clientIdFromData = oldData.client_id;
        }
        if (isCreate && !log.model && log.new_data) {
            const newData = log.new_data;
            if (newData.clientId) clientIdFromData = newData.clientId;
            else if (newData.client_id) clientIdFromData = newData.client_id;
        }
        return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            overflow: {
                horizontal: 'hidden'
            },
            children: [
                client && (!isDelete ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                    to: `/clients/${client.id}`,
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        fontFamily: "Lato, sans-serif",
                        color: "accent-1",
                        children: client.name
                    })
                }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    fontFamily: "Lato, sans-serif",
                    color: "accent-1",
                    children: client.name
                })),
                !client && clientIdFromData && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                    to: `/clients/${clientIdFromData}`,
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        fontFamily: "Lato, sans-serif",
                        color: "accent-1",
                        children: [
                            "Client ID: ",
                            clientIdFromData
                        ]
                    })
                }),
                !client && !clientIdFromData && "\u2014"
            ]
        });
    };
    const renderModelNameColumn = (log)=>{
        const isEquipmentUsage = log.model_name === (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).EquipmentUsage;
        const hasModel = !!log.model;
        const modelLabel = getModelLabel(log) || '';
        const isRecognizedModel = Object.values((0, $1132a1d774d1082e$export$8fde3cbed0ae03c0)).includes(log.model_name);
        return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d8fcb0015cca0f72$export$825a3c81a577bf46), {
                entityName: log.model_name,
                size: "18",
                color: "accent-1"
            }),
            boxProps: {
                direction: 'row',
                align: 'center',
                gap: 'xsmall',
                overflow: {
                    horizontal: 'hidden'
                }
            },
            children: hasModel && !isEquipmentUsage ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                to: (0, $00658ccd6ec0135a$export$d9d91b4addd2e9b8)(log.model, log.model_name),
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    fontFamily: "Lato, sans-serif",
                    color: "accent-1",
                    style: {
                        wordBreak: 'break-word',
                        whiteSpace: 'normal'
                    },
                    children: modelLabel
                })
            }) : isEquipmentUsage ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                fontFamily: "Lato, sans-serif",
                style: {
                    wordBreak: 'break-word',
                    whiteSpace: 'normal'
                },
                children: "Equipment Usage"
            }) : !isRecognizedModel ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                fontFamily: "Lato, sans-serif",
                color: "dark-4",
                style: {
                    wordBreak: 'break-word',
                    whiteSpace: 'normal'
                },
                children: log.model_name
            }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                fontFamily: "Lato, sans-serif",
                color: "dark-4",
                style: {
                    wordBreak: 'break-word',
                    whiteSpace: 'normal',
                    fontStyle: 'italic'
                },
                children: modelLabel
            })
        });
    };
    const getChangedField = (oldData, newData)=>{
        const changes = [];
        const allKeys = new Set([
            ...Object.keys(oldData || {}),
            ...Object.keys(newData || {})
        ]);
        allKeys.forEach((key)=>{
            const oldValue = oldData?.[key];
            const newValue = newData?.[key];
            if (JSON.stringify(oldValue) !== JSON.stringify(newValue)) changes.push({
                field: key,
                oldValue: oldValue,
                newValue: newValue
            });
        });
        return changes;
    };
    const formatField = (field)=>{
        return field.split('_').map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    };
    const formatValue = (value)=>{
        if (value === null || value === undefined) return 'null';
        if (typeof value === 'boolean') return value ? 'true' : 'false';
        if (typeof value === 'object') return JSON.stringify(value, null, 2);
        return String(value);
    };
    const renderExpandedRow = (log)=>{
        const changes = log.old_data && log.new_data ? getChangedField(log.old_data, log.new_data) : [];
        const hasChanges = changes.length > 0;
        const isDelete = log.model_audit_log_event_type.name === (0, $0badf5665deea2b2$export$f4dd91be846acd3a).Delete;
        const isCreate = log.model_audit_log_event_type.name === (0, $0badf5665deea2b2$export$f4dd91be846acd3a).Create;
        const dataToDisplay = isDelete ? log.old_data : isCreate ? log.new_data : null;
        const dataFields = dataToDisplay ? Object.keys(dataToDisplay).map((key)=>({
                field: key,
                value: dataToDisplay[key]
            })) : [];
        return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            pad: {
                horizontal: 'large',
                vertical: 'medium'
            },
            background: "light-4",
            border: {
                side: 'bottom',
                color: 'light-4'
            },
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                direction: "row",
                gap: "large",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        flex: "grow",
                        gap: "small",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                weight: "bold",
                                size: "small",
                                color: "dark-3",
                                children: "REQUEST DETAILS"
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                gap: "xsmall",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        direction: "row",
                                        gap: "small",
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "small",
                                                weight: "bold",
                                                fontFamily: "Lato, sans-serif",
                                                children: "Method:"
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "small",
                                                fontFamily: "Lato, sans-serif",
                                                children: log.request_method
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        direction: "row",
                                        gap: "small",
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "small",
                                                weight: "bold",
                                                fontFamily: "Lato, sans-serif",
                                                children: "URL:"
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "small",
                                                fontFamily: "Lato, sans-serif",
                                                wordBreak: "break-all",
                                                children: log.request_url
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        direction: "row",
                                        gap: "small",
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "small",
                                                weight: "bold",
                                                fontFamily: "Lato, sans-serif",
                                                children: "IP:"
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "small",
                                                fontFamily: "Lato, sans-serif",
                                                children: log.request_ip
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    hasChanges && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        flex: "grow",
                        gap: "small",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                weight: "bold",
                                size: "small",
                                color: "dark-3",
                                children: "CHANGES MADE"
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                background: "white",
                                pad: "small",
                                round: "xsmall",
                                border: {
                                    color: 'light-3'
                                },
                                overflow: "auto",
                                style: {
                                    maxHeight: '300px'
                                },
                                children: changes.map((change, index)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        direction: "row",
                                        gap: "small",
                                        pad: "small",
                                        border: {
                                            side: 'bottom',
                                            color: 'light-3'
                                        },
                                        style: {
                                            borderBottom: index === changes.length - 1 ? 'none' : undefined
                                        },
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                width: "300px",
                                                flex: "shrink",
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    size: "small",
                                                    weight: "bold",
                                                    fontFamily: "Lato, sans-serif",
                                                    children: formatField(change.field)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                flex: "grow",
                                                direction: "row",
                                                gap: "small",
                                                align: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                        flex: true,
                                                        basis: "1/2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                size: "xsmall",
                                                                weight: "bold",
                                                                fontFamily: "Lato, sans-serif",
                                                                color: "dark-4",
                                                                children: "Old Value:"
                                                            }),
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                size: "xsmall",
                                                                fontFamily: "monospace",
                                                                style: {
                                                                    whiteSpace: 'pre-wrap',
                                                                    wordBreak: 'break-word'
                                                                },
                                                                children: formatValue(change.oldValue)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                        flex: true,
                                                        basis: "1/2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                size: "xsmall",
                                                                weight: "bold",
                                                                fontFamily: "Lato, sans-serif",
                                                                color: "dark-4",
                                                                children: "New Value:"
                                                            }),
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                size: "xsmall",
                                                                fontFamily: "monospace",
                                                                style: {
                                                                    whiteSpace: 'pre-wrap',
                                                                    wordBreak: 'break-word'
                                                                },
                                                                children: formatValue(change.newValue)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index))
                            })
                        ]
                    }),
                    !hasChanges && (isDelete || isCreate) && dataFields.length > 0 && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        flex: "grow",
                        gap: "small",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                weight: "bold",
                                size: "small",
                                color: "dark-3",
                                children: isDelete ? 'DELETED DATA' : 'CREATED DATA'
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                background: "white",
                                pad: "small",
                                round: "xsmall",
                                border: {
                                    color: 'light-3'
                                },
                                overflow: "auto",
                                style: {
                                    maxHeight: '300px'
                                },
                                children: dataFields.map((item, index)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        direction: "row",
                                        gap: "small",
                                        pad: "small",
                                        border: {
                                            side: 'bottom',
                                            color: 'light-3'
                                        },
                                        style: {
                                            borderBottom: index === dataFields.length - 1 ? 'none' : undefined
                                        },
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                width: "300px",
                                                flex: "shrink",
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    size: "small",
                                                    weight: "bold",
                                                    fontFamily: "Lato, sans-serif",
                                                    children: formatField(item.field)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                flex: "grow",
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    size: "xsmall",
                                                    fontFamily: "monospace",
                                                    style: {
                                                        whiteSpace: 'pre-wrap',
                                                        wordBreak: 'break-word'
                                                    },
                                                    children: formatValue(item.value)
                                                })
                                            })
                                        ]
                                    }, index))
                            })
                        ]
                    }),
                    log.resolved_by_user && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        flex: "shrink",
                        gap: "small",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                weight: "bold",
                                size: "small",
                                color: "dark-3",
                                children: "RESOLVED BY"
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                gap: "xsmall",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "small",
                                        fontFamily: "Lato, sans-serif",
                                        children: log.resolved_by_user.name
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "xsmall",
                                        fontFamily: "Lato, sans-serif",
                                        color: "dark-4",
                                        children: log.resolved_by_user.email
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        fill: "horizontal",
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            direction: "row",
            gap: "medium",
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
                ...boxProps,
                flex: true,
                children: [
                    !hideHeader && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                        title: title || 'Change Log List',
                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $796804e8c8878bbf$export$8e3d391089488a08), {}),
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            direction: "row",
                            gap: "medium",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $85ab7488c493b81c$export$6d88ebe453be59d7), {
                                    label: "Resolve Selected Logs",
                                    onClick: ()=>resolveSelectedRows(),
                                    disabled: !hasSelectedRows
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c9158ac1cba12f75$export$64fff40e709e8b2e), {
                                    plain: true,
                                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $eec4bc4b18205d01$export$ec91da630f36d5ea), {
                                        color: isFiltersMenuHovered || isFiltersMenuOpen ? 'brand' : undefined
                                    }),
                                    open: isFiltersMenuOpen,
                                    onOpen: ()=>setIsFiltersMenuOpen(true),
                                    onClose: ()=>setIsFiltersMenuOpen(false),
                                    onMouseOver: ()=>setIsFiltersMenuHovered(true),
                                    onMouseOut: ()=>setIsFiltersMenuHovered(false),
                                    tip: tooltips.filterLogs,
                                    dropAlign: {
                                        right: 'right',
                                        top: 'bottom'
                                    },
                                    dropContent: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d5dc00f4222e17dc$export$c9824d87391788f3), {
                                        isFiltering: isRefetching,
                                        onSubmit: ()=>applyFilters(),
                                        onClear: ()=>clearFilters(),
                                        filters: [
                                            {
                                                label: 'Status',
                                                value: draftFilters.model_audit_log_state_id,
                                                setValue: (value)=>setDraftFilters({
                                                        ...draftFilters,
                                                        model_audit_log_state_id: value
                                                    }),
                                                options: statusFilterOptions,
                                                disabled: draftFilters.action_taken_by === (0, $0badf5665deea2b2$export$61d688781044f006).System || draftFilters.action_taken_by === (0, $0badf5665deea2b2$export$61d688781044f006).InternalUser
                                            },
                                            {
                                                label: 'Model Type',
                                                value: draftFilters.model_name,
                                                setValue: (value)=>{
                                                    setDraftFilters({
                                                        ...draftFilters,
                                                        model_name: value
                                                    });
                                                },
                                                options: [
                                                    {
                                                        label: 'All',
                                                        value: ''
                                                    },
                                                    {
                                                        label: 'Client',
                                                        value: (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Client
                                                    },
                                                    {
                                                        label: 'Client File',
                                                        value: (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).ClientFile
                                                    },
                                                    {
                                                        label: 'Facility',
                                                        value: (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Facility
                                                    },
                                                    {
                                                        label: 'Equipment',
                                                        value: (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Equipment
                                                    },
                                                    {
                                                        label: 'Equipment Usage',
                                                        value: (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).EquipmentUsage
                                                    }
                                                ]
                                            },
                                            {
                                                label: 'Action Taken By',
                                                value: draftFilters.action_taken_by,
                                                setValue: (value)=>setDraftFilters({
                                                        ...draftFilters,
                                                        action_taken_by: value,
                                                        model_audit_log_state_id: value !== (0, $0badf5665deea2b2$export$61d688781044f006).ExternalUser ? 0 : draftFilters.model_audit_log_state_id === 0 ? (0, $0badf5665deea2b2$export$b60056a547589254).Unresolved : draftFilters.model_audit_log_state_id
                                                    }),
                                                options: [
                                                    {
                                                        label: 'All',
                                                        value: ''
                                                    },
                                                    {
                                                        label: 'System',
                                                        value: (0, $0badf5665deea2b2$export$61d688781044f006).System
                                                    },
                                                    {
                                                        label: 'Internal User',
                                                        value: (0, $0badf5665deea2b2$export$61d688781044f006).InternalUser
                                                    },
                                                    {
                                                        label: 'External User',
                                                        value: (0, $0badf5665deea2b2$export$61d688781044f006).ExternalUser
                                                    }
                                                ]
                                            }
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                        pad: "none",
                        gap: "none",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                elevation: "small",
                                overflow: {
                                    horizontal: 'auto'
                                },
                                children: [
                                    (_isLoading || isUpdating) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}),
                                    !_isLoading && !isUpdating && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        style: {
                                            minWidth: '900px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                direction: "row",
                                                pad: {
                                                    horizontal: '1rem',
                                                    vertical: 'xsmall'
                                                },
                                                background: "white",
                                                border: {
                                                    side: 'bottom',
                                                    color: 'light-4'
                                                },
                                                gap: "12px",
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                        width: "7%",
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                                                                name: "all_rows_selected",
                                                                checked: allRowsSelected,
                                                                onChange: ()=>handleSelectAll(!allRowsSelected)
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                        width: "7%",
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            title: "EVENT"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                        width: "19%",
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            title: "CLIENT"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                        width: "25%",
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            title: "MODEL NAME"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                        width: "20%",
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            title: "USER"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                        width: "12%",
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            title: "DATE"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                        width: "10%",
                                                        direction: "row",
                                                        align: "center",
                                                        gap: "xsmall",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                                title: "STATUS"
                                                            }),
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ceab9ef72b825454$export$c92c6401b52a9298), {
                                                                content: tooltips.logStatus,
                                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7dacb42a28be9c15$export$7036cd8426a1245b), {
                                                                    size: "14px"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            modelAuditLogs?.map((log, index)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                            direction: "row",
                                                            pad: {
                                                                horizontal: '1rem'
                                                            },
                                                            background: index % 2 === 0 ? 'light-6' : 'white',
                                                            border: {
                                                                side: 'bottom',
                                                                color: 'light-2',
                                                                size: 'small'
                                                            },
                                                            gap: "12px",
                                                            children: [
                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                    width: "7%",
                                                                    direction: "row",
                                                                    gap: "medium",
                                                                    pad: {
                                                                        vertical: '1.25rem'
                                                                    },
                                                                    style: {
                                                                        alignItems: 'center'
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                                                                            name: log.id?.toString(),
                                                                            checked: !!selectedRows[log.id],
                                                                            onChange: ()=>{
                                                                                setSelectedRows({
                                                                                    ...selectedRows,
                                                                                    [log.id]: !selectedRows[log.id]
                                                                                });
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                                                                            to: `/change-logs/${log.id}`,
                                                                            color: "accent-1",
                                                                            style: {
                                                                                display: 'flex'
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ceab9ef72b825454$export$c92c6401b52a9298), {
                                                                                content: tooltips.viewLogDetails,
                                                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f97d8419a136e9e9$export$6d128738bddfaa67), {
                                                                                    size: "18px",
                                                                                    color: "accent-1"
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                    width: "7%",
                                                                    pad: {
                                                                        vertical: '1.25rem'
                                                                    },
                                                                    justify: "center",
                                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                        onClick: ()=>{
                                                                            setExpandedRows({
                                                                                ...expandedRows,
                                                                                [log.id]: !expandedRows[log.id]
                                                                            });
                                                                        },
                                                                        style: {
                                                                            cursor: 'pointer',
                                                                            color: 'accent-1'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                            value: log.model_audit_log_event_type.name,
                                                                            color: "accent-1",
                                                                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f3cc7d38ce51a564$export$9f4a842c4554f9c9), {
                                                                                auditLogEventTypeName: log.model_audit_log_event_type.name,
                                                                                size: "14px"
                                                                            })
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                    width: "19%",
                                                                    pad: {
                                                                        vertical: '1.25rem'
                                                                    },
                                                                    justify: "center",
                                                                    children: renderClientColumn(log)
                                                                }),
                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                    width: "25%",
                                                                    pad: {
                                                                        vertical: '1.25rem'
                                                                    },
                                                                    justify: "center",
                                                                    overflow: {
                                                                        horizontal: 'hidden'
                                                                    },
                                                                    children: renderModelNameColumn(log)
                                                                }),
                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                    width: "20%",
                                                                    pad: {
                                                                        vertical: '1.25rem'
                                                                    },
                                                                    justify: "center",
                                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                        children: log.user ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                                                                                    to: `/users/${log.user?.id}`,
                                                                                    textDecoration: "none",
                                                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                                        color: "accent-1",
                                                                                        size: "medium",
                                                                                        weight: 700,
                                                                                        fontFamily: "Lato, sans-serif",
                                                                                        lineHeight: "1rem",
                                                                                        children: log.user?.name
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                                    size: "small",
                                                                                    fontFamily: "Lato, sans-serif",
                                                                                    lineHeight: "1.25rem",
                                                                                    wordBreak: "break-all",
                                                                                    children: log.user?.email
                                                                                }),
                                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                                    size: "small",
                                                                                    fontFamily: "Lato, sans-serif",
                                                                                    lineHeight: "1rem",
                                                                                    children: log.user?.phone
                                                                                })
                                                                            ]
                                                                        }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                            children: "\u2014"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                    width: "12%",
                                                                    pad: {
                                                                        vertical: '1.25rem'
                                                                    },
                                                                    justify: "center",
                                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                        value: (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(log.created_at).format('MM/DD/YYYY')
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                    width: "10%",
                                                                    pad: {
                                                                        vertical: '1.25rem'
                                                                    },
                                                                    justify: "center",
                                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                        value: log.model_audit_log_state_id === null ? "\u2014" : log.model_audit_log_state_id === (0, $0badf5665deea2b2$export$b60056a547589254).Resolved ? 'Resolved' : 'Unresolved',
                                                                        icon: log.model_audit_log_state_id === null ? undefined : log.model_audit_log_state_id === (0, $0badf5665deea2b2$export$b60056a547589254).Resolved ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $24b518a2732bce28$export$4f481e0a96cfbed6), {
                                                                            size: "16px"
                                                                        }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $11571e85aa9685ed$export$5a89edf87f611fb5), {
                                                                            size: "16px"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9dcd345e1cd244f1$export$6eb0f7ddcda6131f), {
                                                            open: expandedRows[log.id],
                                                            children: renderExpandedRow(log)
                                                        })
                                                    ]
                                                }, log.id))
                                        ]
                                    }),
                                    !hasModelAuditLogs && !_isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        pad: {
                                            horizontal: '1.5rem',
                                            vertical: '2rem'
                                        },
                                        background: "light-6",
                                        justify: "center",
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                            alignSelf: "center",
                                            size: "medium",
                                            fontFamily: "Lato, sans-serif",
                                            children: "No audit logs found."
                                        })
                                    })
                                ]
                            }),
                            hasModelAuditLogs && !!metadata && !!queryState.page && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                pad: "1.5rem",
                                flex: "grow",
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ffccbada2139938a$export$68f5e1453c188a82), {
                                    alignSelf: "center",
                                    size: "small",
                                    page: queryState.page,
                                    step: metadata.per_page,
                                    numberItems: metadata.total,
                                    onChange: ({ page: page })=>handlePageChange(page)
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};






var $2xPiy = parcelRequire("2xPiy");






const $d82a1fe0d9d455d5$export$8ef2ed426dede42d = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(({ children: children, ...props })=>{
    const { allowedRoles: allowedRoles, redirectUrl: redirectUrl, isUserRoute: isUserRoute } = props;
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const location = (0, $62d58f5c28b15c2e$export$45d76561a5302f2b)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const params = (0, $62d58f5c28b15c2e$export$99eaa27ddbbb95ef)();
    const [isLoading, setIsLoading] = (0, $2xPiy.useState)(true);
    const [isValid, setIsValid] = (0, $2xPiy.useState)(true);
    const [isUnauthorized, setIsUnauthorized] = (0, $2xPiy.useState)(false);
    const handler = (()=>{
        if ((isUnauthorized || !isValid) && redirectUrl) return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$444b3ab0cb9aec40), {
            to: redirectUrl,
            replace: true
        });
        if (isUnauthorized) return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $63b81b7a12b117de$export$92b5a78288d46b08), {});
        else if (!isValid) {
            globalStore.setPreviousPath(`${location.pathname}${location.search}${location.hash}`);
            return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$444b3ab0cb9aec40), {
                to: "/login",
                state: {
                    from: location
                },
                replace: true
            });
        }
    })();
    (0, $2xPiy.useEffect)(()=>{
        setIsLoading(true);
        setIsValid(false);
        setIsUnauthorized(false);
        if (!userStore.token) {
            setIsValid(false);
            userStore.logout();
            (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).sessionExpired.success);
            globalStore.setPreviousPath(`${location.pathname}${location.search}${location.hash}`);
        } else {
            const isSameUser = userStore.user && params.id && userStore.user.id === parseInt(params.id);
            const isAllowed = userStore.user && allowedRoles?.includes(userStore.user.role.id);
            const clientIdParam = params.client_id !== undefined ? parseInt(params.client_id) : undefined;
            const hasClientAccess = clientIdParam === undefined || !userStore.isExternalUser || !Number.isNaN(clientIdParam) && !!userStore.user?.clients?.some((client)=>client.id === clientIdParam);
            if (!hasClientAccess) setIsUnauthorized(true);
            else if (isUserRoute && (isSameUser || isAllowed)) setIsValid(true);
            else if (!!allowedRoles?.length && !isAllowed) setIsUnauthorized(true);
            else setIsValid(true);
            setIsLoading(false);
        }
    }, [
        userStore.token,
        userStore.user,
        location.pathname,
        params.id,
        params.client_id
    ]);
    return handler ?? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cb4cc5db45d03478$exports.Fragment), {
        children: !isLoading && isValid && children
    });
});




var $2xPiy = parcelRequire("2xPiy");






const $6a215f3aac1f0b29$export$309483df120b4850 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { maxItems: maxItems = 10, showResultsLink: showResultsLink } = props;
    const searchStore = (0, $116967e0234c3770$export$8992e2c9f8b2a805)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const clientStore = (0, $116967e0234c3770$export$3b47afa599c78f61)();
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const getClientColumns = ()=>{
        const columns = [
            {
                property: 'name',
                primary: true,
                size: '100%',
                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                    margin: "none",
                    children: "NAME"
                }),
                render: (client)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                            to: `/clients/${client.id}`,
                            textDecoration: "none",
                            children: client.name
                        })
                    })
            }
        ];
        return columns;
    };
    const getFacilityColumns = (searchField, clientOptions)=>{
        const columns = [];
        const getFacilityUrl = (facility)=>`/clients/${facility.client_id}/facilities/${facility.id}`;
        columns.push({
            property: 'id',
            primary: true,
            header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                margin: "none",
                children: "ADDRESS"
            }),
            render: (facility)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    pad: {
                        vertical: 'xsmall'
                    },
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                        to: getFacilityUrl(facility),
                        textDecoration: "none",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    size: "medium",
                                    weight: 700,
                                    color: "accent-1",
                                    fontFamily: "Lato, sans-serif",
                                    lineHeight: "1.25rem",
                                    children: facility.address_line1
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    size: "small",
                                    color: "accent-1",
                                    fontFamily: "Lato, sans-serif",
                                    lineHeight: "1rem",
                                    children: [
                                        facility.address_city,
                                        ",",
                                        ' ',
                                        (facility.address_region ?? globalStore.getRegionById(facility.address_region_id))?.short_code,
                                        ' ',
                                        facility.address_post_code
                                    ]
                                })
                            ]
                        })
                    })
                })
        });
        switch(searchField.toLowerCase()){
            case 'name':
                columns.push({
                    property: 'name',
                    header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                        margin: "none",
                        children: "NAME"
                    }),
                    render: (facility)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                                to: getFacilityUrl(facility),
                                textDecoration: "none",
                                children: facility.name
                            })
                        })
                });
                break;
            case 'utility':
                columns.push({
                    property: 'utility_id',
                    header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                        margin: "none",
                        children: "UTILITY"
                    }),
                    render: (facility)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                            children: facility.utility.name
                        })
                });
                break;
            default:
                break;
        }
        columns.push({
            property: 'client.name',
            header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                margin: "none",
                children: "CLIENT"
            }),
            render: (facility)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                    children: !userStore.isFacilityAdmin ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                        to: `/clients/${facility.client_id}`,
                        children: clientOptions.find((option)=>option.value === facility.client_id)?.label
                    }) : clientOptions.find((option)=>option.value === facility.client_id)?.label
                })
        });
        columns.push({
            property: 'is_active',
            header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                margin: "none",
                children: "STATUS"
            }),
            render: (facility)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                    children: facility.is_active ? (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Active : (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Retired
                })
        });
        columns.push({
            property: 'program_id',
            header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                margin: "none",
                children: "PROGRAM"
            }),
            render: (facility)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                    children: facility.program?.name
                })
        });
        return columns;
    };
    const getEquipmentColumns = (searchField, clientOptions)=>{
        const getEquipmentUrl = (equipment)=>`/clients/${equipment.client_id}/equipment/${equipment.id}`;
        const columns = [
            {
                property: 'serial_number',
                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                    margin: "none",
                    children: "SERIAL NUMBER"
                }),
                render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                            to: getEquipmentUrl(equipment),
                            children: equipment.serial_number
                        })
                    })
            },
            {
                property: 'client.name',
                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                    margin: "none",
                    children: "CLIENT"
                }),
                render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                        children: !userStore.isFacilityAdmin ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                            to: `/clients/${equipment.client_id}`,
                            children: clientOptions.find((option)=>option.value === equipment.client_id)?.label
                        }) : clientOptions.find((option)=>option.value === equipment.client_id)?.label
                    })
            },
            {
                property: 'manufacturer',
                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                    margin: "none",
                    children: "MANUFACTURER"
                }),
                render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                            to: getEquipmentUrl(equipment),
                            children: equipment.manufacturer
                        })
                    })
            },
            {
                property: 'equipment_type_id',
                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                    margin: "none",
                    children: "EQUIPMENT TYPE"
                }),
                render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                        children: equipment.equipment_type.name
                    })
            },
            {
                property: 'is_active',
                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                    margin: "none",
                    children: "STATUS"
                }),
                render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                        children: equipment.is_active ? (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Active : (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Retired
                    })
            },
            {
                property: 'program_id',
                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                    margin: "none",
                    children: "PROGRAM"
                }),
                render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                        children: equipment.program?.name
                    })
            }
        ];
        switch(searchField){
            case 'model_year':
                columns.push({
                    property: 'model_year',
                    header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                        margin: "none",
                        children: "MODEL YEAR"
                    }),
                    render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                            children: equipment.model_year
                        })
                });
                break;
            case 'model_number':
                columns.push({
                    property: 'model_number',
                    header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                        margin: "none",
                        children: "MODEL NUMBER"
                    }),
                    render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                            children: equipment.model_number
                        })
                });
                break;
            case 'fse_id':
                columns.push({
                    property: 'fse_id',
                    header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                        margin: "none",
                        children: "FSE ID"
                    }),
                    render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                            children: equipment.fse_id
                        })
                });
                break;
            case 'fse_ru':
                columns.push({
                    property: 'fse_ru',
                    header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                        margin: "none",
                        children: "FSE RU"
                    }),
                    render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                            children: equipment.fse_ru
                        })
                });
                break;
            case 'is_metered':
                columns.push({
                    property: 'is_metered',
                    header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                        margin: "none",
                        children: "METERED"
                    }),
                    render: (equipment)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                            children: equipment.is_metered ? 'Yes' : 'No'
                        })
                });
                break;
            default:
                break;
        }
        return columns;
    };
    const getUserColumns = ()=>{
        const getUserUrl = (user)=>`/users/${user.id}`;
        const columns = [
            {
                property: 'name',
                width: '50%',
                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                    margin: "none",
                    children: "NAME"
                }),
                render: (user)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                        boxProps: {
                            pad: {
                                vertical: 'xsmall'
                            }
                        },
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                            to: getUserUrl(user),
                            textDecoration: "none",
                            children: user.name
                        })
                    })
            },
            {
                property: 'email',
                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                    margin: "none",
                    children: "EMAIL"
                }),
                render: (user)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                        children: user.email
                    })
            },
            {
                property: 'role_id',
                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                    margin: "none",
                    children: "ROLE"
                }),
                render: (user)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                        children: globalStore.roles?.find((role)=>role.id === user.role_id)?.name
                    })
            }
        ];
        return columns;
    };
    const searchResultColumns = (0, $2xPiy.useMemo)(()=>{
        if (!searchStore.searchEntity || !searchStore.searchField || !clientStore.clientOptions) return [];
        if (searchStore.searchEntity === (0, $0badf5665deea2b2$export$dd8643a5f2fdbfa5).Clients) return getClientColumns();
        else if (searchStore.searchEntity === (0, $0badf5665deea2b2$export$dd8643a5f2fdbfa5).Facilities) return getFacilityColumns(searchStore.searchField, clientStore.clientOptions);
        else if (searchStore.searchEntity === (0, $0badf5665deea2b2$export$dd8643a5f2fdbfa5).Equipment) return getEquipmentColumns(searchStore.searchField, clientStore.clientOptions);
        else if (searchStore.searchEntity === (0, $0badf5665deea2b2$export$dd8643a5f2fdbfa5).Users) return getUserColumns();
    }, [
        searchStore.searchEntity,
        searchStore.searchField,
        clientStore.clientOptions
    ]);
    const topResults = (0, $2xPiy.useMemo)(()=>searchStore.results?.slice(0, maxItems), [
        searchStore.results
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (!clientStore.clientOptions) clientStore.fetchClientOptions();
    }, [
        clientStore.clientOptions
    ]);
    return !!searchStore.results && !!searchStore.resultsMetadata && !!clientStore.clientOptions ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $889e19f37a594124$export$f45fe4e6e757ea91), {})
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                border: {
                    side: searchStore.resultsMetadata.total < maxItems ? 'top' : 'horizontal',
                    color: 'brand',
                    size: '2px'
                },
                transitionProperty: "height",
                transitionDuration: "0.3s",
                transitionTimingFunction: "ease",
                children: [
                    !!searchStore.results.length && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
                        data: topResults,
                        columns: searchResultColumns,
                        background: [
                            'light-6',
                            'white'
                        ],
                        border: {
                            color: 'light-2',
                            side: 'bottom',
                            size: 'small'
                        }
                    }),
                    !searchStore.results.length && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        pad: {
                            vertical: 'medium'
                        },
                        background: "light-6",
                        justify: "center",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            alignSelf: "center",
                            size: "medium",
                            fontFamily: "Lato, sans-serif",
                            children: "No results found."
                        })
                    })
                ]
            }),
            showResultsLink && searchStore.resultsMetadata.total > maxItems && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                pad: "small",
                align: "center",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                    to: '/search',
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $85ab7488c493b81c$export$6d88ebe453be59d7), {
                        border: {
                            size: '0'
                        },
                        label: "View all results",
                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b733993b9aac9c83$export$18f0836c03a64fbe), {
                            size: "14px"
                        }),
                        reverse: true
                    })
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cb4cc5db45d03478$exports.Fragment), {});
});



parcelRequire("2xPiy");






const $bc9dd8577744cff7$export$e33d60b8f4099ae = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { ...boxProps } = props;
    const { searchEntity: searchEntity, searchField: searchField, reset: reset } = (0, $116967e0234c3770$export$8992e2c9f8b2a805)();
    const tooltips = (0, $d597772cdbe12609$export$4713da6aa4410043)();
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        justify: "center",
        ...boxProps,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c9158ac1cba12f75$export$64fff40e709e8b2e), {
                plain: true,
                tip: tooltips.adminSearch,
                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $06bd06341dc4840c$export$4b85d3515bd863a5), {
                    size: "20px"
                }),
                reverse: true,
                "data-tour": "search-bar",
                onOpen: ()=>{
                    reset();
                },
                dropAlign: {
                    top: 'bottom',
                    right: 'right'
                },
                dropContent: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    flex: "grow",
                    width: "55rem",
                    border: {
                        color: 'light-5'
                    },
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            pad: "small",
                            gap: "small",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    direction: "row",
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $3007114f05a3417c$export$c36d5511411110dc), {}),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d8886d3505a9a12f$export$201222d15f223f41), {})
                                    ]
                                }),
                                !!searchEntity && !!searchField && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ee22287e9c411205$export$4be43b7638517ea8), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6a215f3aac1f0b29$export$309483df120b4850), {
                            showResultsLink: true
                        })
                    ]
                })
            })
        })
    });
});




var $2xPiy = parcelRequire("2xPiy");





const $3007114f05a3417c$export$c36d5511411110dc = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { labelSize: labelSize, labelWeight: labelWeight, ...boxProps } = props;
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const searchStore = (0, $116967e0234c3770$export$8992e2c9f8b2a805)();
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const entityOptions = (0, $2xPiy.useMemo)(()=>{
        const entities = [
            t('navigation:facilities'),
            t('navigation:equipment')
        ];
        if (userStore.isInternalUser) entities.unshift(t('navigation:clients'));
        if (!userStore.isFacilityAdmin) entities.push(t('navigation:users'));
        return entities.filter((entity)=>entity.toLowerCase().includes(searchStore.entityFilter.toLowerCase()));
    }, [
        searchStore.entityFilter,
        userStore.isInternalUser,
        userStore.isFacilityAdmin,
        t
    ]);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        direction: "row",
        fill: "horizontal",
        ...boxProps,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                align: "center",
                justify: "center",
                width: "20%",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    toUpperCase: true,
                    size: labelSize || 'small',
                    weight: labelWeight || 300,
                    children: t('common:find')
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                justify: "center",
                fontFamily: "Lato, sans-serif",
                width: "80%",
                border: {
                    color: searchStore.isEntityFocused ? 'accent-1' : 'light-5'
                },
                round: "6px",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b3fb5add06fccd6e$export$ef9b1a59e592288f), {
                    plain: true,
                    name: "search_entity",
                    dropAlign: {
                        top: 'bottom',
                        right: 'right'
                    },
                    value: searchStore.searchEntity,
                    placeholder: t('common:choose'),
                    focusIndicator: true,
                    options: entityOptions,
                    searchPlaceholder: t('common:findFieldByName'),
                    onFocus: ()=>searchStore.setIsEntityFocused(true),
                    onBlur: ()=>searchStore.setIsEntityFocused(false),
                    onClose: ()=>searchStore.setEntityFilter(''),
                    onSearch: (filter)=>searchStore.setEntityFilter(filter),
                    onChange: ({ value: value })=>searchStore.setSearchEntity(value)
                })
            })
        ]
    });
});




var $2xPiy = parcelRequire("2xPiy");






const $d8886d3505a9a12f$export$201222d15f223f41 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { labelSize: labelSize, labelWeight: labelWeight, ...boxProps } = props;
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const searchStore = (0, $116967e0234c3770$export$8992e2c9f8b2a805)();
    const fieldOptions = (0, $2xPiy.useMemo)(()=>{
        return searchStore.searchEntity ? (0, $00658ccd6ec0135a$export$55326c15f59f164f)(searchStore.fieldFilter, searchStore.fields[searchStore.searchEntity].map((f)=>f.label)) : [];
    }, [
        searchStore.searchEntity,
        searchStore.fieldFilter,
        searchStore.fields
    ]);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        direction: "row",
        fill: "horizontal",
        ...boxProps,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                align: "center",
                justify: "center",
                width: "20%",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    toUpperCase: true,
                    size: labelSize || 'small',
                    weight: labelWeight || 300,
                    children: t('common:by')
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                justify: "center",
                fontFamily: "Lato, sans-serif",
                width: "80%",
                border: {
                    color: searchStore.isFieldFocused ? 'accent-1' : 'light-5'
                },
                round: "6px",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b3fb5add06fccd6e$export$ef9b1a59e592288f), {
                    plain: true,
                    name: "search_field",
                    dropAlign: {
                        top: 'bottom',
                        right: 'right'
                    },
                    value: searchStore.searchField,
                    placeholder: t('common:choose'),
                    disabled: !searchStore.searchEntity,
                    options: fieldOptions,
                    searchPlaceholder: t('common:findFieldByName'),
                    onFocus: ()=>searchStore.setIsFieldFocused(true),
                    onBlur: ()=>searchStore.setIsFieldFocused(false),
                    onClose: ()=>searchStore.setFieldFilter(''),
                    onSearch: (filter)=>searchStore.setFieldFilter(filter),
                    onChange: ({ value: value })=>searchStore.setSearchField(value)
                })
            })
        ]
    });
});




var $2xPiy = parcelRequire("2xPiy");


var $2xPiy = parcelRequire("2xPiy");

function $bd900446703ba3c4$var$_extends() {
    return $bd900446703ba3c4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bd900446703ba3c4$var$_extends.apply(null, arguments);
}
var $bd900446703ba3c4$export$e4563dc022bb8e8d = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $bd900446703ba3c4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "InProgress"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 1h22M10 4.5h4V6c0 1-2 2-2 2s-2-1-2-2V4.5zM5 1v5c0 3 5 3.235 5 6s-5 3-5 6v5M19 1v5c0 3-5 3.235-5 6s5 3 5 6v5M1 23h22M8 21c0-2 4-4 4-4s4 2 4 4v2H8v-2z"
    }));
});
$bd900446703ba3c4$export$e4563dc022bb8e8d.displayName = 'InProgress';









const $ee22287e9c411205$export$4be43b7638517ea8 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { ...boxProps } = props;
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const searchStore = (0, $116967e0234c3770$export$8992e2c9f8b2a805)();
    const { handleApiError: handleApiError, roles: roles } = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const [isButtonSelected, setIsButtonSelected] = (0, $2xPiy.useState)(false);
    const [, setIsLoadingOptions] = (0, $2xPiy.useState)(false);
    const [defaultOptions, setDefaultOptions] = (0, $2xPiy.useState)([]);
    const [options, setOptions] = (0, $2xPiy.useState)([]);
    const searchFieldOption = (0, $2xPiy.useMemo)(()=>searchStore.searchEntity ? searchStore.fields[searchStore.searchEntity]?.find((f)=>f.label === searchStore.searchField) : undefined, [
        searchStore.searchEntity,
        searchStore.fields,
        searchStore.searchField
    ]);
    const isUtility = (0, $2xPiy.useMemo)(()=>searchFieldOption?.value.toLowerCase() === 'utility_id', [
        searchFieldOption
    ]);
    const isProgram = (0, $2xPiy.useMemo)(()=>searchFieldOption?.value.toLowerCase() === 'program_id', [
        searchFieldOption
    ]);
    const isEquipmentType = (0, $2xPiy.useMemo)(()=>searchFieldOption?.value.toLowerCase() === 'equipment_type_id', [
        searchFieldOption
    ]);
    const isFuelPathway = (0, $2xPiy.useMemo)(()=>searchFieldOption?.value.toLowerCase() === 'fuel_pathway_id', [
        searchFieldOption
    ]);
    const isFSERegistrationStatus = (0, $2xPiy.useMemo)(()=>searchFieldOption?.value.toLowerCase() === 'fse_registration_status_id', [
        searchStore.searchField
    ]);
    const isRole = (0, $2xPiy.useMemo)(()=>searchFieldOption?.value.toLowerCase() === 'role_id', [
        searchFieldOption
    ]);
    const isActiveStatus = (0, $2xPiy.useMemo)(()=>searchFieldOption?.value.toLowerCase() === 'is_active', [
        searchFieldOption
    ]);
    const isMeteredStatus = (0, $2xPiy.useMemo)(()=>searchFieldOption?.value.toLowerCase() === 'is_metered', [
        searchFieldOption
    ]);
    const isSelectField = (0, $2xPiy.useMemo)(()=>isUtility || isProgram || isEquipmentType || isFuelPathway || isFSERegistrationStatus || isRole || isActiveStatus || isMeteredStatus, [
        isUtility,
        isProgram,
        isEquipmentType,
        isFuelPathway,
        isFSERegistrationStatus,
        isRole,
        isActiveStatus,
        isMeteredStatus
    ]);
    const isDisabled = (0, $2xPiy.useMemo)(()=>!searchStore.searchQuery && !searchStore.searchOption?.value, [
        searchStore.searchQuery,
        searchStore.searchOption?.value
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (searchStore.searchOption?.value) searchStore.search();
    }, [
        searchStore.searchOption?.value
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (searchFieldOption) fetchOptions();
    }, [
        searchFieldOption
    ]);
    const fetchOptions = async ()=>{
        setIsLoadingOptions(true);
        try {
            let options = [];
            if (isUtility) options = (await (0, $554ab5093ad5ab37$export$6d7a392c12f13470).listUtilities({})).map((result)=>({
                    label: result.name,
                    value: result.id
                }));
            else if (isProgram) options = (await (0, $06590284a0c4fd89$export$84ac2881c878ff18).list()).map((result)=>({
                    label: result.name,
                    value: result.id
                }));
            else if (isEquipmentType) options = (await (0, $d17911beca13351e$export$63e6e4d9a672e282).listEquipmentCategories()).flatMap((category)=>category.equipment_types?.map((type)=>({
                        label: `${category.program?.name} - ${type.name} (${category.name})`,
                        value: type.id
                    })) ?? []);
            else if (isFuelPathway) options = (await (0, $b0af269f4f630763$export$40b243bf31bf9421).list()).map((result)=>({
                    label: result.code,
                    value: result.id
                }));
            else if (isFSERegistrationStatus) options = (await (0, $d6dddabef9527262$export$47f5a8b2675bf9f0).listFSERegistrationStatuses()).map((result)=>({
                    label: result.name,
                    value: result.id
                }));
            else if (isRole) {
                options = roles?.map((result)=>({
                        label: result.name,
                        value: result.id
                    })) ?? [];
                if (userStore.isExternalUser) options = options.filter((role)=>(0, $a65473e9746b33bb$export$39d571c105d2314f).includes(role.value));
            } else if (isActiveStatus) options = [
                {
                    label: (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Active,
                    value: (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Active
                },
                {
                    label: (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Inactive,
                    value: (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Inactive
                }
            ];
            else if (isMeteredStatus) options = [
                {
                    label: (0, $0badf5665deea2b2$export$3e3dc826e36eaf2b).Metered,
                    value: (0, $0badf5665deea2b2$export$3e3dc826e36eaf2b).Metered
                },
                {
                    label: (0, $0badf5665deea2b2$export$3e3dc826e36eaf2b).Unmetered,
                    value: (0, $0badf5665deea2b2$export$3e3dc826e36eaf2b).Unmetered
                }
            ];
            setOptions(options);
            setDefaultOptions(options);
        } catch (err) {
            handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listFacilities.error);
        } finally{
            setIsLoadingOptions(false);
        }
    };
    const filterOptions = (filter)=>{
        if (filter === '') setOptions(defaultOptions);
        const exp = new RegExp(filter.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
        const filteredOptions = defaultOptions.filter(({ label: label })=>exp.test(label));
        setOptions(filteredOptions);
    };
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        ...boxProps,
        direction: "row",
        gap: "xsmall",
        children: [
            isSelectField && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                direction: "row",
                animation: {
                    type: 'slideDown',
                    duration: 300,
                    size: 'large'
                },
                border: {
                    color: searchStore.isQueryFocused ? 'accent-1' : 'light-5'
                },
                flex: "grow",
                round: "6px",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    fill: "horizontal",
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b3fb5add06fccd6e$export$ef9b1a59e592288f), {
                        plain: true,
                        name: "search_option",
                        dropAlign: {
                            top: 'bottom',
                            right: 'right'
                        },
                        value: searchStore.searchOption,
                        options: options,
                        placeholder: `Choose ${searchStore.searchField}...`,
                        searchPlaceholder: !isActiveStatus && !isMeteredStatus ? `Find ${searchStore.searchEntity} by name...` : undefined,
                        labelKey: "label",
                        valueKey: {
                            key: 'value'
                        },
                        onFocus: ()=>searchStore.setIsQueryFocused(true),
                        onBlur: ()=>searchStore.setIsQueryFocused(false),
                        onClose: ()=>filterOptions(''),
                        onSearch: !isActiveStatus && !isMeteredStatus ? filterOptions : undefined,
                        onChange: ({ value: value })=>searchStore.setSearchOption(value)
                    })
                })
            }),
            !isSelectField && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                direction: "row",
                animation: {
                    type: 'slideDown',
                    duration: 300,
                    size: 'large'
                },
                border: {
                    color: searchStore.isQueryFocused ? 'accent-1' : 'light-5'
                },
                round: "6px",
                flex: "grow",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $168667f04da9206c$export$16e4d70cc375e707), {
                    onEnter: ()=>searchStore.search(),
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8c9c99ffe8765a99$export$c86715117507e8e5), {
                        plain: true,
                        name: "search_input",
                        style: {
                            fontFamily: 'Lato, sans-serif',
                            borderTopLeftRadius: '6px',
                            borderBottomLeftRadius: '6px',
                            borderTopRightRadius: '0',
                            borderBottomRightRadius: '0'
                        },
                        placeholder: `Enter ${searchStore.searchField?.toLowerCase()}...`,
                        value: searchStore.searchQuery,
                        reverse: true,
                        onFocus: ()=>searchStore.setIsQueryFocused(true),
                        onBlur: ()=>searchStore.setIsQueryFocused(false),
                        onChange: (e)=>searchStore.setSearchQuery(e.target.value)
                    })
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                plain: true,
                disabled: isDisabled,
                onClick: ()=>searchStore.search(),
                onMouseEnter: ()=>setIsButtonSelected(true),
                onMouseLeave: ()=>setIsButtonSelected(false),
                onFocus: ()=>setIsButtonSelected(true),
                onBlur: ()=>setIsButtonSelected(false),
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    pad: "small",
                    align: "center",
                    justify: "center",
                    round: "6px",
                    background: !searchStore.isSearching && !isDisabled && isButtonSelected ? 'accent-1' : 'white',
                    color: !searchStore.isSearching && !isDisabled && isButtonSelected ? 'white' : 'text',
                    transitionProperty: "color background",
                    transitionDuration: "0.2s 0.2s",
                    transitionTimingFunction: "ease ease",
                    children: !searchStore.isSearching ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $06bd06341dc4840c$export$4b85d3515bd863a5), {
                        size: "18px"
                    }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        animation: {
                            type: 'rotateRight',
                            size: 'xsmall',
                            duration: 1000
                        },
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $bd900446703ba3c4$export$e4563dc022bb8e8d), {
                            size: "18px"
                        })
                    })
                })
            })
        ]
    });
});




var $2xPiy = parcelRequire("2xPiy");






const $889e19f37a594124$export$f45fe4e6e757ea91 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { maxItems: maxItems = 10, textSize: textSize = 'small', ...boxProps } = props;
    const tooltips = (0, $d597772cdbe12609$export$4713da6aa4410043)();
    const searchStore = (0, $116967e0234c3770$export$8992e2c9f8b2a805)();
    const totalText = (0, $2xPiy.useMemo)(()=>{
        if (!searchStore.resultsMetadata) return;
        return searchStore.resultsMetadata.total ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
            size: textSize,
            children: [
                "Found ",
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("b", {
                    children: (0, $00658ccd6ec0135a$export$f5dd818bff069720)(searchStore.resultsMetadata.total, true)
                }),
                " result",
                searchStore.resultsMetadata.total > 1 ? 's' : ''
            ]
        }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cb4cc5db45d03478$exports.Fragment), {});
    }, [
        searchStore.resultsMetadata,
        maxItems,
        textSize
    ]);
    return !!searchStore.results && !!searchStore.resultsMetadata ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        animation: {
            type: 'slideDown',
            duration: 300,
            size: 'large'
        },
        direction: "row",
        pad: {
            horizontal: 'small',
            bottom: 'small'
        },
        justify: "between",
        align: "center",
        ...boxProps,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                children: totalText
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                direction: "row",
                gap: "xsmall",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                        plain: true,
                        onClick: ()=>searchStore.clear(),
                        tip: tooltips.clearSearch,
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            pad: {
                                horizontal: 'xsmall'
                            },
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: textSize,
                                color: "accent-1",
                                children: "Clear"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                        direction: "vertical",
                        margin: "none",
                        color: "text"
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                        plain: true,
                        onClick: ()=>searchStore.reset(),
                        tip: tooltips.resetSearch,
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            pad: {
                                horizontal: 'xsmall'
                            },
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: textSize,
                                color: "accent-1",
                                children: "Reset"
                            })
                        })
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cb4cc5db45d03478$exports.Fragment), {});
});





var $2xPiy = parcelRequire("2xPiy");





const $b7bc42650fa26391$var$CHECK_INTERVAL_MS = 30000;
const $b7bc42650fa26391$var$AUTH_PATHS = [
    '/login',
    '/logout',
    '/reset-password',
    '/verify-email'
];
const $b7bc42650fa26391$var$isAuthPath = (path)=>$b7bc42650fa26391$var$AUTH_PATHS.some((p)=>path === p || path.startsWith(`${p}/`));
const $b7bc42650fa26391$export$415798a788f40554 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    (0, $2xPiy.useEffect)(()=>{
        const expireSession = ()=>{
            if (!userStore.isLoggedIn || $b7bc42650fa26391$var$isAuthPath(window.location.pathname)) return;
            globalStore.setPreviousPath(`${window.location.pathname}${window.location.search}${window.location.hash}`);
            navigate('/logout', {
                state: {
                    reason: (0, $9c41c53e999a77b0$export$c37e141db7d79f56)
                }
            });
        };
        (0, $c5482855026ef46a$export$df74a7f975458b43)(expireSession);
        (0, $c5482855026ef46a$export$28821114e1994a07)(()=>{
            if (userStore.isLoggedIn) (0, $9c41c53e999a77b0$export$41c56a5e2126fc6e)();
        });
        const check = ()=>{
            if (!userStore.isLoggedIn) return;
            if (!(0, $9c41c53e999a77b0$export$70d175fe2fbaa383)()) {
                expireSession();
                return;
            }
            if ((0, $9c41c53e999a77b0$export$599cd8c85ed06f71)() === undefined) (0, $9c41c53e999a77b0$export$41c56a5e2126fc6e)();
            else if ((0, $9c41c53e999a77b0$export$6d174f73f8547532)()) expireSession();
        };
        const onVisibilityChange = ()=>{
            if (document.visibilityState === 'visible') check();
        };
        check();
        const interval = setInterval(check, $b7bc42650fa26391$var$CHECK_INTERVAL_MS);
        document.addEventListener('visibilitychange', onVisibilityChange);
        window.addEventListener('focus', check);
        return ()=>{
            (0, $c5482855026ef46a$export$df74a7f975458b43)(undefined);
            (0, $c5482855026ef46a$export$28821114e1994a07)(undefined);
            clearInterval(interval);
            document.removeEventListener('visibilitychange', onVisibilityChange);
            window.removeEventListener('focus', check);
        };
    }, []);
    return null;
});



parcelRequire("2xPiy");





const $4f34f15711532ac0$export$c5dc331420891764 = ({ countryId: countryId })=>{
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const isCanada = countryId === (0, $0badf5665deea2b2$export$b77c37614753bffb).Canada;
    const calculationKeys = [
        {
            key: t('statements:credits'),
            definition: t('statements:creditsDefinition')
        },
        {
            key: t('statements:creditPrice'),
            definition: t('statements:creditPriceDefinition')
        },
        isCanada ? {
            key: t('statements:taxesOnCreditSale'),
            definition: t('statements:taxesOnCreditSaleDefinition')
        } : {
            key: t('statements:recCost'),
            definition: t('statements:recCostDefinition')
        },
        isCanada ? {
            key: t('statements:taxesOnServices'),
            definition: t('statements:taxesOnServicesDefinition')
        } : {
            key: t('statements:brokerCost'),
            definition: t('statements:brokerCostDefinition')
        },
        isCanada ? {
            key: t('statements:fuseServiceFee'),
            definition: t('statements:caFuseServiceFeeDefinition')
        } : {
            key: t('statements:fuseServiceFee'),
            definition: t('statements:fuseServiceFeeDefinition')
        },
        {
            key: t('statements:costRecoup'),
            definition: t('statements:costRecoupDefinition')
        },
        {
            key: t('statements:netIncentive'),
            definition: t('statements:netIncentiveDefinition')
        }
    ];
    // Cells
    const border = {
        side: 'all',
        color: 'text'
    };
    const headerVerticalPad = (0, $00658ccd6ec0135a$export$ed800035e096ef02)('10px');
    const itemVerticalPad = (0, $00658ccd6ec0135a$export$ed800035e096ef02)('8px');
    const itemHorizontalPad = (0, $00658ccd6ec0135a$export$ed800035e096ef02)('6px');
    // Text
    const lineHeight = (0, $00658ccd6ec0135a$export$ed800035e096ef02)('14px');
    const headerSize = (0, $00658ccd6ec0135a$export$ed800035e096ef02)('11px');
    const descriptionSize = (0, $00658ccd6ec0135a$export$ed800035e096ef02)('10px');
    const getBackground = (rowIndex)=>rowIndex % 2 ? 'white' : 'light-6';
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        fill: "horizontal",
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $db5bdbb5ed7980e0$export$54ec01a60f47d33d), {
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9a8cd9b190c1a99e$export$f850895b287ef28e), {
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $551c43fc27d858fa$export$b05581f4e764e162), {
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ab315163778b3d77$export$1e4baea7053fc0e3), {
                                scope: "col",
                                size: "20%",
                                align: "center",
                                justify: "center",
                                border: border,
                                pad: {
                                    vertical: headerVerticalPad
                                },
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    size: headerSize,
                                    lineHeight: lineHeight,
                                    weight: 700,
                                    children: t('statements:calculationKey')
                                })
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ab315163778b3d77$export$1e4baea7053fc0e3), {
                                scope: "col",
                                size: "80%",
                                align: "center",
                                justify: "center",
                                border: border,
                                pad: {
                                    vertical: headerVerticalPad
                                },
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    size: headerSize,
                                    lineHeight: lineHeight,
                                    weight: 700,
                                    children: t('statements:definition')
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $5d12037769f7acde$export$76ccd210b9029917), {
                    children: calculationKeys.map(({ key: key, definition: definition }, i)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $551c43fc27d858fa$export$b05581f4e764e162), {
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ab315163778b3d77$export$1e4baea7053fc0e3), {
                                    scope: "row",
                                    size: "20%",
                                    align: "center",
                                    justify: "center",
                                    border: border,
                                    pad: {
                                        vertical: itemVerticalPad,
                                        horizontal: itemHorizontalPad
                                    },
                                    background: getBackground(i),
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: descriptionSize,
                                        lineHeight: lineHeight,
                                        weight: 700,
                                        children: key
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ab315163778b3d77$export$1e4baea7053fc0e3), {
                                    scope: "row",
                                    size: "80%",
                                    justify: "center",
                                    border: border,
                                    background: getBackground(i),
                                    pad: {
                                        vertical: itemVerticalPad,
                                        horizontal: itemHorizontalPad
                                    },
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                            size: descriptionSize,
                                            lineHeight: lineHeight,
                                            children: definition
                                        })
                                    })
                                })
                            ]
                        }, key))
                })
            ]
        })
    });
};




var $2xPiy = parcelRequire("2xPiy");






const $78e0d7df04d75fa4$export$2a8f4302f71576bb = (props)=>{
    /* PROPS */ const { incentiveStatement: response, isSummary: isSummary, countryId: countryId, ...boxProps } = props;
    /* CONTEXT */ const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const isMobile = (0, $18588a518ac6fdc7$export$2ac00d7098bf223)(screenSize);
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const tableHeaders = (0, $2xPiy.useMemo)(()=>[
            t('common:program'),
            t('common:totalKwh'),
            t('statements:credits'),
            t('statements:creditPrice'),
            t('statements:totalValue'),
            t('statements:recCost'),
            t('statements:brokerCost'),
            t('statements:fuseServiceFee'),
            t('statements:netIncentive')
        ], [
        t
    ]);
    const canadianHeaders = (0, $2xPiy.useMemo)(()=>[
            t('common:program'),
            t('common:totalKwh'),
            t('statements:credits'),
            t('statements:creditPrice'),
            t('statements:totalValue'),
            t('statements:taxesOnCreditSale'),
            t('statements:taxesOnServices'),
            t('statements:fuseServiceFee'),
            t('statements:netIncentive')
        ], [
        t
    ]);
    // Cells
    const getBackground = (rowIndex)=>rowIndex % 2 ? 'white' : 'light-6';
    const verticalPad = (0, $00658ccd6ec0135a$export$ed800035e096ef02)('4px');
    const horizontalPad = (0, $00658ccd6ec0135a$export$ed800035e096ef02)('4px');
    const cellBorder = {
        size: '0'
    };
    const totalsCellBorder = {
        side: 'top',
        size: 'xsmall',
        color: 'text'
    };
    const horizontalMargin = (0, $00658ccd6ec0135a$export$ed800035e096ef02)('18px');
    const facilityIndent = (0, $00658ccd6ec0135a$export$ed800035e096ef02)('12px');
    const categoryIndent = (0, $00658ccd6ec0135a$export$ed800035e096ef02)('24px');
    const nameCellSizePct = 25;
    const currencyCellSizePct = 9;
    // Text
    const lineHeight = (0, $00658ccd6ec0135a$export$ed800035e096ef02)('18px');
    const headerSize = (0, $00658ccd6ec0135a$export$ed800035e096ef02)('11px');
    const programValueSize = (0, $00658ccd6ec0135a$export$ed800035e096ef02)('10px');
    const facilityValueSize = (0, $00658ccd6ec0135a$export$ed800035e096ef02)('10px');
    const categoryValueSize = (0, $00658ccd6ec0135a$export$ed800035e096ef02)('10px');
    const totalsSize = (0, $00658ccd6ec0135a$export$ed800035e096ef02)('11px');
    const grandTotalSize = (0, $00658ccd6ec0135a$export$ed800035e096ef02)('13px');
    const maxHeaderWidth = (0, $00658ccd6ec0135a$export$ed800035e096ef02)('102px');
    /* Memos */ const normalized = (0, $2xPiy.useMemo)(()=>(0, $049b0cfdd8ac4942$export$e0c1ba76f119f8b1)(response), [
        response
    ]);
    const renderHeaders = (headers)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $551c43fc27d858fa$export$b05581f4e764e162), {
            children: headers.map((header, i)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ab315163778b3d77$export$1e4baea7053fc0e3), {
                    scope: "col",
                    border: cellBorder,
                    size: !isMobile && i > 0 ? `${currencyCellSizePct}%` : `${nameCellSizePct}%`,
                    pad: {
                        bottom: verticalPad,
                        left: !i ? horizontalPad : undefined,
                        right: i === tableHeaders.length - 1 ? horizontalPad : horizontalMargin
                    },
                    verticalAlign: "top",
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        direction: "row",
                        justify: i > 0 ? 'end' : 'start',
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            size: headerSize,
                            lineHeight: lineHeight,
                            weight: 700,
                            textAlign: "end",
                            style: {
                                maxWidth: maxHeaderWidth
                            },
                            children: header
                        })
                    })
                }, header))
        });
    const isCanada = countryId === (0, $0badf5665deea2b2$export$b77c37614753bffb).Canada;
    const renderDataLine = (data, rowIndex)=>{
        const { programData: programData, facilityData: facilityData, categoryData: categoryData, totalsData: totalsData } = data;
        if (!facilityData && !totalsData && !programData && !categoryData) return;
        const textSize = programData ? programValueSize : facilityData ? facilityValueSize : categoryData ? categoryValueSize : totalsSize;
        const border = totalsData ? totalsCellBorder : cellBorder;
        const textWeight = programData && !isSummary || totalsData ? 700 : undefined;
        const values = {};
        values.title = programData ? programData.name : facilityData ? facilityData.address : categoryData ? categoryData.name : t('statements:totals');
        const credits = programData?.credits ?? facilityData?.credits ?? categoryData?.credits ?? totalsData?.credits ?? '0';
        values.credits = !Number.isNaN(parseFloat(credits)) ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(credits, true, false, false, 2) : '-';
        const credit_price = programData?.credit_price ?? facilityData?.credit_price ?? categoryData?.credit_price ?? '';
        values.credit_price = !Number.isNaN(parseFloat(credit_price)) ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(credit_price, true, false, false, 2) : '-';
        const total_value = programData?.total_value ?? facilityData?.total_value ?? categoryData?.total_value ?? totalsData?.total_value ?? '0';
        values.total_value = !Number.isNaN(parseFloat(total_value)) ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(total_value, true, false, false, 2) : '-';
        const rec_cost = programData?.rec_cost ?? facilityData?.rec_cost ?? categoryData?.rec_cost ?? totalsData?.rec_cost ?? '0';
        values.rec_cost = !Number.isNaN(parseFloat(rec_cost)) ? `(${(0, $00658ccd6ec0135a$export$f5dd818bff069720)(rec_cost, true, false, false, 2)})` : '-';
        const taxes_on_credit_sale = programData?.taxes_on_credit_sale ?? facilityData?.taxes_on_credit_sale ?? categoryData?.taxes_on_credit_sale ?? totalsData?.taxes_on_credit_sale ?? '0';
        values.taxes_on_credit_sale = !Number.isNaN(parseFloat(taxes_on_credit_sale)) ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(taxes_on_credit_sale, true, false, false, 2) : '-';
        const broker_cost = programData?.broker_cost ?? facilityData?.broker_cost ?? categoryData?.broker_cost ?? totalsData?.broker_cost ?? '0';
        values.broker_cost = !Number.isNaN(parseFloat(broker_cost)) ? `(${(0, $00658ccd6ec0135a$export$f5dd818bff069720)(broker_cost, true, false, false, 2)})` : '-';
        const taxes_on_services = programData?.taxes_on_services ?? facilityData?.taxes_on_services ?? categoryData?.taxes_on_services ?? totalsData?.taxes_on_services ?? '0';
        values.taxes_on_services = !Number.isNaN(parseFloat(taxes_on_services)) ? `(${(0, $00658ccd6ec0135a$export$f5dd818bff069720)(taxes_on_services, true, false, false, 2)})` : '-';
        const fuse_service_fee = programData?.fuse_service_fee ?? facilityData?.fuse_service_fee ?? categoryData?.fuse_service_fee ?? totalsData?.fuse_service_fee ?? '0';
        values.fuse_service_fee = !Number.isNaN(parseFloat(fuse_service_fee)) ? `(${(0, $00658ccd6ec0135a$export$f5dd818bff069720)(fuse_service_fee, true, false, false, 2)})` : '-';
        const total_kwh = programData?.total_kwh ?? facilityData?.total_kwh ?? categoryData?.total_kwh ?? totalsData?.total_kwh ?? 0;
        const total_kwh_str = String(total_kwh);
        values.total_kwh = !Number.isNaN(parseInt(total_kwh_str)) ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(total_kwh_str, true, false, false, 0) || '0' : '-';
        const net_incentive = programData?.net_incentive ?? facilityData?.net_incentive ?? categoryData?.net_incentive ?? totalsData?.net_incentive ?? '0';
        values.net_incentive = !Number.isNaN(parseFloat(net_incentive)) ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(net_incentive, true, false, false, 2) : '-';
        return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $551c43fc27d858fa$export$b05581f4e764e162), {
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ab315163778b3d77$export$1e4baea7053fc0e3), {
                    scope: "row",
                    border: border,
                    size: `${nameCellSizePct}%`,
                    pad: {
                        vertical: verticalPad,
                        right: horizontalMargin,
                        left: categoryData ? categoryIndent : facilityData ? facilityIndent : horizontalPad
                    },
                    background: rowIndex !== undefined ? getBackground(rowIndex) : undefined,
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            size: textSize,
                            lineHeight: lineHeight,
                            weight: programData || totalsData ? 700 : undefined,
                            color: categoryData ? 'dark-4' : undefined,
                            children: values.title
                        })
                    })
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ab315163778b3d77$export$1e4baea7053fc0e3), {
                    scope: "row",
                    border: border,
                    size: `${currencyCellSizePct}%`,
                    pad: {
                        vertical: verticalPad,
                        right: horizontalMargin
                    },
                    background: rowIndex !== undefined ? getBackground(rowIndex) : undefined,
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        direction: "row",
                        justify: "end",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            size: textSize,
                            lineHeight: lineHeight,
                            weight: textWeight,
                            children: values.total_kwh
                        })
                    })
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ab315163778b3d77$export$1e4baea7053fc0e3), {
                    scope: "row",
                    border: border,
                    size: `${currencyCellSizePct}%`,
                    pad: {
                        vertical: verticalPad,
                        right: horizontalMargin
                    },
                    background: rowIndex !== undefined ? getBackground(rowIndex) : undefined,
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        direction: "row",
                        justify: "end",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            size: textSize,
                            lineHeight: lineHeight,
                            weight: textWeight,
                            children: values.credits
                        })
                    })
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ab315163778b3d77$export$1e4baea7053fc0e3), {
                    scope: "row",
                    border: border,
                    size: `${currencyCellSizePct}%`,
                    align: totalsData ? 'center' : undefined,
                    pad: {
                        vertical: verticalPad,
                        right: horizontalMargin
                    },
                    background: rowIndex !== undefined ? getBackground(rowIndex) : undefined,
                    children: [
                        values.credit_price === '-' && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            direction: "row",
                            justify: "end",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: textSize,
                                lineHeight: lineHeight,
                                weight: textWeight,
                                children: "N/A"
                            })
                        }),
                        values.credit_price !== '-' && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            direction: "row",
                            justify: "between",
                            gap: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('3px'),
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    size: textSize,
                                    lineHeight: lineHeight,
                                    weight: textWeight,
                                    children: "$"
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    size: textSize,
                                    lineHeight: lineHeight,
                                    weight: textWeight,
                                    children: values.credit_price
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ab315163778b3d77$export$1e4baea7053fc0e3), {
                    scope: "row",
                    border: border,
                    size: `${currencyCellSizePct}%`,
                    pad: {
                        vertical: verticalPad,
                        right: horizontalMargin
                    },
                    background: rowIndex !== undefined ? getBackground(rowIndex) : undefined,
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        direction: "row",
                        justify: "between",
                        gap: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('3px'),
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: textSize,
                                lineHeight: lineHeight,
                                weight: textWeight,
                                children: "$"
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: textSize,
                                lineHeight: lineHeight,
                                weight: textWeight,
                                children: values.total_value
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ab315163778b3d77$export$1e4baea7053fc0e3), {
                    scope: "row",
                    border: border,
                    size: `${currencyCellSizePct}%`,
                    pad: {
                        vertical: verticalPad,
                        right: horizontalMargin
                    },
                    background: rowIndex !== undefined ? getBackground(rowIndex) : undefined,
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        direction: "row",
                        justify: "between",
                        gap: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('3px'),
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: textSize,
                                lineHeight: lineHeight,
                                weight: textWeight,
                                children: "$"
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: textSize,
                                lineHeight: lineHeight,
                                weight: textWeight,
                                children: isCanada ? values.taxes_on_credit_sale : values.rec_cost
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ab315163778b3d77$export$1e4baea7053fc0e3), {
                    scope: "row",
                    border: border,
                    size: `${currencyCellSizePct}%`,
                    pad: {
                        vertical: verticalPad,
                        right: horizontalMargin
                    },
                    background: rowIndex !== undefined ? getBackground(rowIndex) : undefined,
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        direction: "row",
                        justify: "between",
                        gap: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('3px'),
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: textSize,
                                lineHeight: lineHeight,
                                weight: textWeight,
                                children: "$"
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: textSize,
                                lineHeight: lineHeight,
                                weight: textWeight,
                                children: isCanada ? values.taxes_on_services : values.broker_cost
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ab315163778b3d77$export$1e4baea7053fc0e3), {
                    scope: "row",
                    border: border,
                    size: `${currencyCellSizePct}%`,
                    pad: {
                        vertical: verticalPad,
                        right: horizontalMargin
                    },
                    background: rowIndex !== undefined ? getBackground(rowIndex) : undefined,
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        direction: "row",
                        justify: "between",
                        gap: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('3px'),
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: textSize,
                                lineHeight: lineHeight,
                                weight: textWeight,
                                children: "$"
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: textSize,
                                lineHeight: lineHeight,
                                weight: textWeight,
                                children: values.fuse_service_fee
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ab315163778b3d77$export$1e4baea7053fc0e3), {
                    scope: "row",
                    border: border,
                    size: `${currencyCellSizePct}%`,
                    pad: {
                        vertical: verticalPad,
                        right: horizontalPad
                    },
                    background: rowIndex !== undefined ? getBackground(rowIndex) : undefined,
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        direction: "row",
                        justify: "between",
                        gap: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('3px'),
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: textSize,
                                lineHeight: lineHeight,
                                weight: textWeight,
                                children: "$"
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: textSize,
                                lineHeight: lineHeight,
                                weight: textWeight,
                                children: values.net_incentive
                            })
                        ]
                    })
                })
            ]
        }, rowIndex);
    };
    const renderGrandTotal = (totals)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $db5bdbb5ed7980e0$export$54ec01a60f47d33d), {
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $5d12037769f7acde$export$76ccd210b9029917), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $551c43fc27d858fa$export$b05581f4e764e162), {
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ab315163778b3d77$export$1e4baea7053fc0e3), {
                            scope: "row",
                            size: `${100 - currencyCellSizePct}%`,
                            pad: {
                                vertical: verticalPad,
                                right: horizontalMargin
                            },
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                align: "end",
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    size: grandTotalSize,
                                    lineHeight: lineHeight,
                                    color: "brand",
                                    weight: 700,
                                    children: t('statements:grandTotal')
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ab315163778b3d77$export$1e4baea7053fc0e3), {
                            scope: "row",
                            size: `${currencyCellSizePct}%`,
                            pad: {
                                vertical: verticalPad,
                                right: horizontalPad
                            },
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                direction: "row",
                                justify: "between",
                                gap: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('3px'),
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: grandTotalSize,
                                        lineHeight: lineHeight,
                                        color: "brand",
                                        weight: 700,
                                        children: "$"
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: grandTotalSize,
                                        lineHeight: lineHeight,
                                        color: "brand",
                                        weight: 700,
                                        children: (0, $00658ccd6ec0135a$export$f5dd818bff069720)(totals.net_incentive, true, false, false, 2)
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        });
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        fill: "horizontal",
        ...boxProps,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $db5bdbb5ed7980e0$export$54ec01a60f47d33d), {
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9a8cd9b190c1a99e$export$f850895b287ef28e), {
                        children: renderHeaders(isCanada ? canadianHeaders : tableHeaders)
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $5d12037769f7acde$export$76ccd210b9029917), {
                        children: [
                            (()=>{
                                let rowCounter = 0;
                                return normalized.programs.map((program)=>[
                                        renderDataLine({
                                            programData: program
                                        }, rowCounter++),
                                        !isSummary && program.facilities?.map((facility)=>{
                                            const facilityRow = renderDataLine({
                                                facilityData: facility
                                            }, rowCounter++);
                                            const categoryRows = facility.equipment_categories?.map((category)=>renderDataLine({
                                                    categoryData: category
                                                }, rowCounter++)) || [];
                                            return [
                                                facilityRow,
                                                ...categoryRows
                                            ];
                                        })
                                    ]);
                            })(),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $551c43fc27d858fa$export$b05581f4e764e162), {
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ab315163778b3d77$export$1e4baea7053fc0e3), {
                                    pad: {
                                        vertical: verticalPad
                                    },
                                    height: programValueSize
                                })
                            }),
                            renderDataLine({
                                totalsData: normalized.totals
                            })
                        ]
                    })
                ]
            }),
            renderGrandTotal(normalized.totals)
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");


const $ff16ac31d7c036ca$export$ac4f8729c50d29aa = (props)=>{
    const { ...boxProps } = props;
    const fuseInfo = (0, $2xPiy.useRef)({
        address_line1: '801 K Street',
        address_line2: 'Suite 2700',
        address_city: 'Sacramento',
        address_region_short_code: 'CA',
        address_post_code: '95814',
        phone: '(833) 937-6262',
        websiteLabel: 'usefuse.com'
    });
    const textProps = (0, $2xPiy.useRef)({
        size: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('11px'),
        lineHeight: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('16px')
    });
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        gap: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('4px'),
        ...boxProps,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                margin: {
                    bottom: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('4px')
                },
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b693aeeca29ae7b2$export$2e2bcd8739ae039), {
                    width: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('120px')
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                margin: {
                    bottom: '0'
                },
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        ...textProps.current,
                        children: [
                            fuseInfo.current.address_line1,
                            ", ",
                            fuseInfo.current.address_line2
                        ]
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        ...textProps.current,
                        children: [
                            fuseInfo.current.address_city,
                            ", ",
                            fuseInfo.current.address_region_short_code,
                            ' ',
                            fuseInfo.current.address_post_code
                        ]
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        ...textProps.current,
                        children: fuseInfo.current.phone
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                ...textProps.current,
                weight: 700,
                style: {
                    textDecoration: 'underline'
                },
                children: fuseInfo.current.websiteLabel
            })
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");




const $c18f805a5ac844fb$export$da9a2709d1cb1ab4 = (props)=>{
    const { incentiveStatement: incentiveStatement, ...boxProps } = props;
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const normalized = (0, $049b0cfdd8ac4942$export$e0c1ba76f119f8b1)(incentiveStatement);
    const lineHeight = (0, $2xPiy.useRef)((0, $00658ccd6ec0135a$export$ed800035e096ef02)('24px'));
    const labelSize = (0, $2xPiy.useRef)((0, $00658ccd6ec0135a$export$ed800035e096ef02)('14px'));
    const valueSize = (0, $2xPiy.useRef)((0, $00658ccd6ec0135a$export$ed800035e096ef02)('12px'));
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        direction: "row",
        justify: "between",
        ...boxProps,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            direction: "row",
            width: "50%",
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    width: "50%",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            size: labelSize.current,
                            lineHeight: lineHeight.current,
                            weight: 700,
                            children: t('common:clientName')
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            size: valueSize.current,
                            lineHeight: lineHeight.current,
                            wordBreak: "break-word",
                            children: normalized.client_name
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            size: labelSize.current,
                            lineHeight: lineHeight.current,
                            weight: 700,
                            children: t('common:reportingPeriod')
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            size: valueSize.current,
                            lineHeight: lineHeight.current,
                            wordBreak: "break-word",
                            children: normalized.reporting_period
                        })
                    ]
                })
            ]
        })
    });
};






const $2a19f59ee0120218$export$25895b921b7e775b = (props)=>{
    const { ...boxProps } = props;
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        width: "50%",
        pad: {
            right: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('6px')
        },
        ...boxProps,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
            size: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('11px'),
            children: t('statements:incentiveStatementNotice')
        })
    });
};






var $2xPiy = parcelRequire("2xPiy");




var $2xPiy = parcelRequire("2xPiy");

function $aa240f1efb63cecd$var$_extends() {
    return $aa240f1efb63cecd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $aa240f1efb63cecd$var$_extends.apply(null, arguments);
}
var $aa240f1efb63cecd$export$cd1a8f5a55d5e9d3 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $aa240f1efb63cecd$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormDown"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m18 9-6 6-6-6"
    }));
});
$aa240f1efb63cecd$export$cd1a8f5a55d5e9d3.displayName = 'FormDown';


var $2xPiy = parcelRequire("2xPiy");

function $0e0bb398288390ad$var$_extends() {
    return $0e0bb398288390ad$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0e0bb398288390ad$var$_extends.apply(null, arguments);
}
var $0e0bb398288390ad$export$531cef85654f2406 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $0e0bb398288390ad$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Print"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M6 19H1V7h22v12h-5M3 16h18M6 16v7h12v-7m0-9V1H6v6m11 5h2v-1h-2v1z"
    }));
});
$0e0bb398288390ad$export$531cef85654f2406.displayName = 'Print';








const $659efb5a52c8fd59$export$c2a262540e4917c2 = (props)=>{
    /** Props **/ const { clientId: clientId, title: title, id: id } = props;
    /** Context **/ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** State **/ const [isLoading, setIsLoading] = (0, $2xPiy.useState)(true);
    const [currentPage, setCurrentPage] = (0, $2xPiy.useState)(1);
    const [expandedPeriods, setExpandedPeriods] = (0, $2xPiy.useState)(new Set());
    const [reportingPeriods, setReportingPeriods] = (0, $2xPiy.useState)();
    const [metadata, setIncentiveStatementsMetadata] = (0, $2xPiy.useState)();
    const [programs, setPrograms] = (0, $2xPiy.useState)(new Map());
    const [request] = (0, $2xPiy.useState)({
        client_id: clientId,
        limit: 5
    });
    /** Computed **/ const hasReportingPeriods = !!reportingPeriods?.length;
    const togglePeriodExpansion = (periodId)=>{
        setExpandedPeriods((prev)=>{
            const newSet = new Set(prev);
            if (newSet.has(periodId)) newSet.delete(periodId);
            else newSet.add(periodId);
            return newSet;
        });
    };
    /** Methods **/ const fetchPrograms = async ()=>{
        try {
            const programsList = await (0, $06590284a0c4fd89$export$84ac2881c878ff18).list();
            const programsMap = new Map();
            programsList.forEach((program)=>{
                programsMap.set(program.id, program);
            });
            setPrograms(programsMap);
        } catch (err) {
            console.error('Failed to fetch programs:', err);
        }
    };
    const fetchReportingPeriods = async (page)=>{
        if (!clientId || !userStore.user) return;
        try {
            const { meta: meta, data: data } = await (0, $56a7168c8945bbf5$export$c90fd1a7cde0dffa).listIncentiveStatementReportingPeriods({
                ...request,
                page: page || request.page
            });
            setReportingPeriods(data);
            setIncentiveStatementsMetadata(meta);
            setCurrentPage(meta.current_page);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listIncentiveStatements.error);
        } finally{
            setIsLoading(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        fetchPrograms();
    }, []);
    (0, $2xPiy.useEffect)(()=>{
        if (!reportingPeriods) fetchReportingPeriods(currentPage);
    }, [
        reportingPeriods,
        currentPage
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (!isLoading && metadata && currentPage !== metadata.current_page) {
            setIsLoading(true);
            fetchReportingPeriods(currentPage);
        }
    }, [
        isLoading,
        metadata,
        currentPage
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        id: id,
        direction: "row",
        gap: "medium",
        fill: "horizontal",
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                    title: title || t('statements:statementList'),
                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $0157675666c7298e$export$1b5fea8128845fdf), {
                        size: "24px",
                        color: "brand"
                    })
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                    pad: "none",
                    gap: "none",
                    children: [
                        isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}),
                        !isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            children: reportingPeriods?.map((reportingPeriod)=>{
                                const isExpanded = expandedPeriods.has(reportingPeriod.id);
                                const hasSingleProgram = reportingPeriod.incentive_statements.length === 1;
                                const tableData = [
                                    {
                                        isCombined: true
                                    }
                                ];
                                tableData.push({
                                    isToggle: true,
                                    reportingPeriodId: reportingPeriod.id
                                });
                                if (isExpanded) tableData.push(...reportingPeriod.incentive_statements);
                                return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            pad: {
                                                horizontal: 'medium',
                                                vertical: 'small'
                                            },
                                            background: "light-5",
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "large",
                                                children: (0, $00658ccd6ec0135a$export$f96ebb633255a704)((0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(reportingPeriod.end_reporting_quarter).format('YYYY-MM-DD'), reportingPeriod.reporting_period_type_id === (0, $0badf5665deea2b2$export$a121e4a6c908fa8f).Yearly)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
                                            pad: {
                                                horizontal: '1.5rem'
                                            },
                                            columns: [
                                                {
                                                    property: 'program.name',
                                                    size: '30%',
                                                    header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                        title: t('common:program')
                                                    }),
                                                    render: (row)=>{
                                                        if ('isCombined' in row) return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                            margin: {
                                                                vertical: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)('14px')
                                                            },
                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                size: "medium",
                                                                fontFamily: "Lato, sans-serif",
                                                                children: t('statements:allPrograms')
                                                            })
                                                        });
                                                        if ('isToggle' in row) return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                            direction: "row",
                                                            gap: "xsmall",
                                                            align: "center",
                                                            margin: {
                                                                vertical: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)('14px')
                                                            },
                                                            onClick: ()=>togglePeriodExpansion(reportingPeriod.id),
                                                            style: {
                                                                cursor: 'pointer'
                                                            },
                                                            "data-tour": "view-individual-programs",
                                                            children: [
                                                                isExpanded ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $aa240f1efb63cecd$export$cd1a8f5a55d5e9d3), {
                                                                    size: "small"
                                                                }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c7bce65ed51d571e$export$a8d2f61b02c7b95f), {
                                                                    size: "small"
                                                                }),
                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                    size: "small",
                                                                    style: {
                                                                        textDecoration: 'none'
                                                                    },
                                                                    children: isExpanded ? hasSingleProgram ? t('statements:hideIndividualProgram') : t('statements:hideIndividualPrograms') : hasSingleProgram ? t('statements:viewIndividualProgram') : t('statements:viewIndividualPrograms')
                                                                })
                                                            ]
                                                        });
                                                        const program = programs.get(row.program_id);
                                                        return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                            margin: {
                                                                vertical: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)('14px')
                                                            },
                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                size: "medium",
                                                                fontFamily: "Lato, sans-serif",
                                                                children: program?.name || row.program?.name || ''
                                                            })
                                                        });
                                                    }
                                                },
                                                {
                                                    property: 'summary',
                                                    sortable: false,
                                                    size: '35%',
                                                    header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                        title: t('statements:individualStatement')
                                                    }),
                                                    render: (row)=>{
                                                        if ('isToggle' in row) return null;
                                                        if ('isCombined' in row) return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $5770351c0fb34b29$export$b2bf131c9f9cce5d), {
                                                            to: `/clients/${clientId}/statements/reporting-period/${reportingPeriod.id}`,
                                                            "data-tour": "individual-statement",
                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                direction: "row",
                                                                gap: "xsmall",
                                                                align: "center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $0e0bb398288390ad$export$531cef85654f2406), {
                                                                        size: "22px"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                        fontFamily: "Lato, sans-serif",
                                                                        children: t('statements:summary')
                                                                    })
                                                                ]
                                                            })
                                                        });
                                                        return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $5770351c0fb34b29$export$b2bf131c9f9cce5d), {
                                                            to: `/clients/${clientId}/statements/incentive/${row.id}`,
                                                            "data-tour": "individual-statement",
                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                direction: "row",
                                                                gap: "xsmall",
                                                                align: "center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $0e0bb398288390ad$export$531cef85654f2406), {
                                                                        size: "22px"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                        fontFamily: "Lato, sans-serif",
                                                                        children: t('statements:summary')
                                                                    })
                                                                ]
                                                            })
                                                        });
                                                    }
                                                },
                                                {
                                                    property: 'details',
                                                    sortable: false,
                                                    size: '35%',
                                                    header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                        title: t('statements:detailedStatement')
                                                    }),
                                                    render: (row)=>{
                                                        if ('isToggle' in row) return null;
                                                        if ('isCombined' in row) return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                            margin: {
                                                                vertical: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)('14px')
                                                            },
                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $5770351c0fb34b29$export$b2bf131c9f9cce5d), {
                                                                to: `/clients/${clientId}/statements/reporting-period/${reportingPeriod.id}/details`,
                                                                "data-tour": "detailed-statement",
                                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                    direction: "row",
                                                                    gap: "xsmall",
                                                                    align: "center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $0e0bb398288390ad$export$531cef85654f2406), {
                                                                            size: "22px"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                            fontFamily: "Lato, sans-serif",
                                                                            children: t('statements:details')
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        });
                                                        return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                            margin: {
                                                                vertical: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)('14px')
                                                            },
                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $5770351c0fb34b29$export$b2bf131c9f9cce5d), {
                                                                to: `/clients/${clientId}/statements/incentive/${row.id}/details`,
                                                                "data-tour": "detailed-statement",
                                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                    direction: "row",
                                                                    gap: "xsmall",
                                                                    align: "center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $0e0bb398288390ad$export$531cef85654f2406), {
                                                                            size: "22px"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                            fontFamily: "Lato, sans-serif",
                                                                            children: t('statements:details')
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        });
                                                    }
                                                }
                                            ],
                                            data: tableData,
                                            background: [
                                                'white',
                                                'light-6'
                                            ]
                                        })
                                    ]
                                }, reportingPeriod.id);
                            })
                        }),
                        !hasReportingPeriods && !isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            pad: {
                                horizontal: '1.5rem',
                                vertical: '2rem'
                            },
                            background: "light-6",
                            justify: "center",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                alignSelf: "center",
                                size: "medium",
                                fontFamily: "Lato, sans-serif",
                                children: t('statements:noStatementsFound')
                            })
                        }),
                        !!metadata && !!currentPage && !!setCurrentPage && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            pad: "1.5rem",
                            flex: "grow",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ffccbada2139938a$export$68f5e1453c188a82), {
                                alignSelf: "center",
                                size: "small",
                                page: currentPage,
                                step: metadata?.per_page,
                                numberItems: metadata?.total,
                                onChange: (e)=>setCurrentPage(e.page)
                            })
                        })
                    ]
                })
            ]
        })
    });
};






var $2xPiy = parcelRequire("2xPiy");

var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");

var $f0a365c46768ce0a$var$fillStyle = function fillStyle(fill) {
    if (!fill) return fill;
    if (fill === 'horizontal') return 'width: 100%;';
    if (fill === 'vertical') return 'height: 100%;';
    return "\n      width: 100%;\n      height: 100%;\n    ";
};
var $f0a365c46768ce0a$var$JUSTIFY_MAP = {
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch'
};
var $f0a365c46768ce0a$var$justifyStyle = (0, $iA1nz.css)([
    "justify-items:",
    ";"
], function(props) {
    return $f0a365c46768ce0a$var$JUSTIFY_MAP[props.justify];
});
var $f0a365c46768ce0a$var$JUSTIFY_CONTENT_MAP = {
    around: 'space-around',
    between: 'space-between',
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch'
};
var $f0a365c46768ce0a$var$justifyContentStyle = (0, $iA1nz.css)([
    "justify-content:",
    ";"
], function(props) {
    return $f0a365c46768ce0a$var$JUSTIFY_CONTENT_MAP[props.justifyContent];
});
var $f0a365c46768ce0a$var$gapSizes = function gapSizes(props) {
    var result = [];
    if (typeof props.gap === 'string') {
        var size = props.theme.global.edgeSize[props.gap] || props.gap;
        result[0] = size;
        result[1] = size;
    } else if (props.gap) {
        if (props.gap.row) result[0] = props.theme.global.edgeSize[props.gap.row] || props.gap.row;
        if (props.gap.column) result[1] = props.theme.global.edgeSize[props.gap.column] || props.gap.column;
    }
    return result;
};
var $f0a365c46768ce0a$var$gapStyle = function gapStyle(props) {
    var sizes = $f0a365c46768ce0a$var$gapSizes(props);
    if (sizes[0] !== undefined && sizes[1] !== undefined) return "grid-gap: " + sizes[0] + " " + sizes[1] + ";";
    if (sizes[0] !== undefined) return "grid-row-gap: " + sizes[0] + ";";
    if (sizes[1] !== undefined) return "grid-column-gap: " + sizes[1] + ";";
    return '';
};
var $f0a365c46768ce0a$var$SIZE_MAP = {
    flex: '1fr',
    full: '100%',
    '1/2': '50%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    '1/3': '33.33%',
    '2/3': '66.66%'
};
var $f0a365c46768ce0a$var$normalizeSize = function normalizeSize(size, props) {
    return $f0a365c46768ce0a$var$SIZE_MAP[size] || props.theme.global.size[size] || size;
};
var $f0a365c46768ce0a$var$getRepeatCount = function getRepeatCount(count) {
    return typeof count === 'number' ? count : "auto-" + (count || 'fit');
};
var $f0a365c46768ce0a$var$getRepeatSize = function getRepeatSize(size, props) {
    if (size === 'flex') return '1fr';
    var gaps = $f0a365c46768ce0a$var$gapSizes(props);
    var min;
    var max;
    var minFill;
    if (Array.isArray(size)) {
        var _size$ = size[0], minSize = _size$ === void 0 ? 'auto' : _size$, _size$2 = size[1], maxSize = _size$2 === void 0 ? 'auto' : _size$2;
        min = $f0a365c46768ce0a$var$normalizeSize(minSize, props);
        if (min.search(/px/) !== -1) minFill = true;
        max = $f0a365c46768ce0a$var$normalizeSize(maxSize, props);
        if (gaps[1] !== undefined) {
            // account for the column gap when using fractional sizes, e.g. 1/3
            if (minSize.indexOf('/') !== -1) min = "calc(" + min + " - (" + gaps[1] + " * (1 - " + minSize + ")))";
            if (maxSize.indexOf('/') !== -1) max = "calc(" + max + " - (" + gaps[1] + " * (1 - " + maxSize + ")))";
        }
    } else {
        min = $f0a365c46768ce0a$var$normalizeSize(size, props);
        if (min.search(/px/) !== -1) minFill = true;
        max = '1fr';
        if (gaps[1] !== undefined) // account for column gap with fractional sizes, e.g. 1/3
        {
            if (size.indexOf('/') !== -1) min = "calc(" + min + " - (" + gaps[1] + " * (1 - " + size + ")))";
        }
    }
    if (minFill) // ensure we never go beyond the container width,
    // for mobile/narrow situations
    min = "min(" + min + ", 100%)";
    return "minmax(" + min + ", " + max + ")";
};
var $f0a365c46768ce0a$var$columnsStyle = function columnsStyle(props) {
    if (Array.isArray(props.columns)) return (0, $iA1nz.css)([
        "grid-template-columns:",
        ";"
    ], props.columns.map(function(s) {
        if (Array.isArray(s)) return "minmax(" + $f0a365c46768ce0a$var$normalizeSize(s[0], props) + ", " + $f0a365c46768ce0a$var$normalizeSize(s[1], props) + ")";
        return $f0a365c46768ce0a$var$normalizeSize(s, props);
    }).join(' '));
    if (typeof props.columns === 'object') return (0, $iA1nz.css)([
        "grid-template-columns:repeat( ",
        ",",
        " );"
    ], $f0a365c46768ce0a$var$getRepeatCount(props.columns.count), $f0a365c46768ce0a$var$getRepeatSize(props.columns.size, props));
    return (0, $iA1nz.css)([
        "grid-template-columns:repeat( auto-fill,",
        " );"
    ], $f0a365c46768ce0a$var$getRepeatSize(props.columns, props));
};
var $f0a365c46768ce0a$var$rowsStyle = function rowsStyle(props) {
    if (Array.isArray(props.rowsProp)) return (0, $iA1nz.css)([
        "grid-template-rows:",
        ";"
    ], props.rowsProp.map(function(s) {
        if (Array.isArray(s)) return "minmax(" + $f0a365c46768ce0a$var$normalizeSize(s[0], props) + ", " + $f0a365c46768ce0a$var$normalizeSize(s[1], props) + ")";
        return $f0a365c46768ce0a$var$normalizeSize(s, props);
    }).join(' '));
    return (0, $iA1nz.css)([
        "grid-auto-rows:",
        ";"
    ], props.theme.global.size[props.rowsProp]);
};
var $f0a365c46768ce0a$var$areasStyle = function areasStyle(props) {
    // translate areas objects into grid-template-areas syntax
    if (!Array.isArray(props.rowsProp) || !Array.isArray(props.columns)) console.warn('Grid `areas` requires `rows` and `columns` to be arrays.');
    if (Array.isArray(props.areas) && props.areas.every(function(area) {
        return Array.isArray(area);
    })) return "grid-template-areas: " + props.areas.map(function(area) {
        return "\"" + area.join(' ') + "\"";
    }).join(' ') + ";";
    var cells = props.rowsProp.map(function() {
        return props.columns.map(function() {
            return '.';
        });
    });
    props.areas.forEach(function(area) {
        for(var row = area.start[1]; row <= area.end[1]; row += 1)for(var column = area.start[0]; column <= area.end[0]; column += 1)cells[row][column] = area.name;
    });
    return "grid-template-areas: " + cells.map(function(r) {
        return "\"" + r.join(' ') + "\"";
    }).join(' ') + ";";
};
var $f0a365c46768ce0a$export$ba6ff269176936c2 = (0, $iA1nz.default).div.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledGrid",
    componentId: "sc-1wofa1l-0"
})([
    "display:grid;box-sizing:border-box;",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], (0, $73ba8e2d301b823f$export$a157b298d219a801), function(props) {
    return props.border && (0, $1d37a3883a1c6277$export$4d0a7f76ad443516)(props.border, props.responsive, props.theme);
}, function(props) {
    return $f0a365c46768ce0a$var$fillStyle(props.fillContainer);
}, function(props) {
    return props.align && (0, $73ba8e2d301b823f$export$f530b7ab00e4c68d);
}, function(props) {
    return props.alignContent && (0, $73ba8e2d301b823f$export$93b5fb4351939c1c);
}, function(props) {
    return props.areas && $f0a365c46768ce0a$var$areasStyle(props);
}, function(props) {
    return props.columns && $f0a365c46768ce0a$var$columnsStyle(props);
}, function(props) {
    return props.gap && $f0a365c46768ce0a$var$gapStyle(props);
}, function(props) {
    return props.justify && $f0a365c46768ce0a$var$justifyStyle;
}, function(props) {
    return props.justifyContent && $f0a365c46768ce0a$var$justifyContentStyle;
}, function(props) {
    return props.pad && (0, $73ba8e2d301b823f$export$944a9710f9445eee)('padding', props.pad, props.responsive, props.theme.global.edgeSize.responsiveBreakpoint, props.theme);
}, function(props) {
    return props.rowsProp && $f0a365c46768ce0a$var$rowsStyle(props);
}, function(props) {
    return props.heightProp && (0, $73ba8e2d301b823f$export$9f8046d1e2885811)(props.heightProp, props.theme);
}, function(props) {
    return props.widthProp && (0, $73ba8e2d301b823f$export$c12f8e3e33f3bef7)(props.widthProp, props.theme);
}, function(props) {
    return props.theme.grid && props.theme.grid.extend;
});



var $dyr1f = parcelRequire("dyr1f");

function $d90412459d89d679$var$_extends() {
    return $d90412459d89d679$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d90412459d89d679$var$_extends.apply(null, arguments);
}
var $d90412459d89d679$var$fixedSizes = [
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge'
];
var $d90412459d89d679$var$sizes = [
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge',
    'full',
    '1/2',
    '1/3',
    '2/3',
    '1/4',
    '2/4',
    '3/4',
    'flex',
    'auto'
];
var $d90412459d89d679$var$edgeSizes = [
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge',
    'none'
];
var $d90412459d89d679$var$BORDER_SHAPE = (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
    color: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            light: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        })
    ]),
    side: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'top',
        'left',
        'bottom',
        'right',
        'start',
        'end',
        'horizontal',
        'vertical',
        'all',
        'between'
    ]),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    style: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'solid',
        'dashed',
        'dotted',
        'double',
        'groove',
        'ridge',
        'inset',
        'outset',
        'hidden'
    ])
});
var $d90412459d89d679$var$PropType = {};
$d90412459d89d679$var$PropType = $d90412459d89d679$var$_extends({}, (0, $ab32ce3df36aa105$export$ffe37ff34eeb9e21), {
    align: (0, $ab32ce3df36aa105$export$5dd51d61a30477bc),
    alignContent: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'around',
            'baseline',
            'between',
            'center',
            'evenly',
            'end',
            'start',
            'stretch'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    areas: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            name: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
            start: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number),
            end: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number)
        })),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string))
    ]),
    border: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'top',
            'left',
            'bottom',
            'right',
            'start',
            'end',
            'horizontal',
            'vertical',
            'all'
        ]),
        $d90412459d89d679$var$BORDER_SHAPE,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf($d90412459d89d679$var$BORDER_SHAPE)
    ]),
    columns: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($d90412459d89d679$var$sizes),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            ])),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($d90412459d89d679$var$sizes),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($d90412459d89d679$var$sizes),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            count: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
                    'fit',
                    'fill'
                ]),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number
            ]),
            size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($d90412459d89d679$var$sizes),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($d90412459d89d679$var$sizes),
                    (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
                ])),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            ])
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    fill: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'horizontal',
            'vertical'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
    ]),
    gap: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($d90412459d89d679$var$edgeSizes),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
            row: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($d90412459d89d679$var$edgeSizes),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            ]),
            column: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($d90412459d89d679$var$edgeSizes),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            ])
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    height: (0, $ab32ce3df36aa105$export$674efdc47ecf99e9),
    justify: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'start',
        'center',
        'end',
        'stretch'
    ]),
    justifyContent: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'start',
        'center',
        'end',
        'between',
        'around',
        'stretch'
    ]),
    pad: (0, $ab32ce3df36aa105$export$b91a2ef62736aae3),
    responsive: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    rows: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($d90412459d89d679$var$sizes),
                (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
            ])),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($d90412459d89d679$var$sizes),
            (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf($d90412459d89d679$var$fixedSizes),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    tag: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func
    ]),
    as: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func
    ]),
    width: (0, $ab32ce3df36aa105$export$7d45d0e6b7abd5e2)
});
var $d90412459d89d679$export$c3a9d48c57d48e6e = $d90412459d89d679$var$PropType;




var $225251299c21678a$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "border",
    "fill",
    "height",
    "responsive",
    "rows",
    "tag",
    "as",
    "width"
];
function $225251299c21678a$var$_extends() {
    return $225251299c21678a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $225251299c21678a$var$_extends.apply(null, arguments);
}
function $225251299c21678a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $225251299c21678a$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    var a11yTitle = props.a11yTitle, ariaLabel = props['aria-label'], border = props.border, fill = props.fill, height = props.height, _props$responsive = props.responsive, responsiveProp = _props$responsive === void 0 ? true : _props$responsive, rows = props.rows, tag = props.tag, as = props.as, width = props.width, rest = $225251299c21678a$var$_objectWithoutPropertiesLoose(props, $225251299c21678a$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var responsiveContainer = (0, $2xPiy.useContext)((0, $f328f122e8cc98b2$export$505da1fc32900905));
    var responsive = responsiveContainer && responsiveProp ? 'container' : responsiveProp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $f0a365c46768ce0a$export$ba6ff269176936c2), $225251299c21678a$var$_extends({
        ref: ref,
        "aria-label": ariaLabel || a11yTitle,
        as: !as && tag ? tag : as,
        border: border,
        fillContainer: fill,
        heightProp: height,
        responsive: responsive,
        rowsProp: rows,
        widthProp: width
    }, passThemeFlag, rest));
});
$225251299c21678a$export$ef2184bd89960b14.displayName = 'Grid';
$225251299c21678a$export$ef2184bd89960b14.propTypes = (0, $d90412459d89d679$export$c3a9d48c57d48e6e);
// Defualting to true to support existing code that relies on
// grid.available to create a fallback option
$225251299c21678a$export$ef2184bd89960b14.available = true;





const $f2ed542b0753eadc$export$85c5a83f4045b2d2 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(({ children: children })=>{
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const clientStore = (0, $116967e0234c3770$export$3b47afa599c78f61)();
    const [modalIsVisible, setModalIsVisible] = (0, $2xPiy.useState)(false);
    const isLoading = !userStore.user || !clientStore.activeClientId;
    (0, $2xPiy.useEffect)(()=>{
        if (userStore.user && userStore.isExternalUser && !clientStore.activeClientId) {
            if (userStore.user.clients.length === 1) clientStore.setActiveClientId(userStore.user.clients[0].id);
            else setModalIsVisible(true);
        }
    }, [
        userStore.user,
        userStore.isExternalUser,
        clientStore.activeClientId
    ]);
    return userStore.isInternalUser ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cb4cc5db45d03478$exports.Fragment), {
        children: children
    }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
        children: [
            !isLoading && children,
            userStore.user && modalIsVisible && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
                full: true,
                animate: false,
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $225251299c21678a$export$ef2184bd89960b14), {
                    height: "100vh",
                    rows: [
                        'flex'
                    ],
                    columns: [
                        'auto'
                    ],
                    areas: [
                        {
                            name: 'main',
                            start: [
                                0,
                                0
                            ],
                            end: [
                                0,
                                0
                            ]
                        }
                    ],
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d48fc541d96cd8f0$export$861edd1ccea2f746), {
                        gridArea: "main",
                        background: "light",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            justify: "center",
                            align: "center",
                            flex: "grow",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $0d5d171277c7fe9b$export$3e19e9f19f11a807), {
                                user: userStore.user,
                                setIsVisible: setModalIsVisible,
                                canBeClosed: false
                            })
                        })
                    })
                })
            })
        ]
    });
});




var $2xPiy = parcelRequire("2xPiy");



const $9f4eedc32616d701$export$ccfabc72f6726f7e = (props)=>{
    const { contacts: contacts = [], isUpdatePage: isUpdatePage, isCorporate: isCorporate, isRemittance: isRemittance, isFacility: isFacility } = props;
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** State **/ const [selectedContactId, setSelectedContactId] = (0, $2xPiy.useState)();
    /** Computed **/ const isClient = isCorporate || isRemittance;
    const entityName = isClient ? 'Client' : isFacility ? 'Facility' : undefined;
    const selectedContact = contacts.find((contact)=>contact.id === selectedContactId) ?? contacts[0];
    const formatPhoneNumber = (value)=>{
        const digitsOnly = value.replace(/[^\d]/g, '');
        if (!digitsOnly) return '';
        if (digitsOnly.length >= 10) return `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6, 10)}`;
        return value;
    };
    (0, $2xPiy.useEffect)(()=>{
        if (!!contacts?.length && !selectedContactId) setSelectedContactId(contacts[0]?.id);
    }, [
        contacts,
        selectedContactId
    ]);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        gap: "1rem",
        fill: "horizontal",
        children: [
            !isUpdatePage && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                pad: "1rem",
                gap: "0.5rem",
                background: "light-6",
                border: {
                    size: 'small',
                    color: 'light-5'
                },
                borderRadius: "6px",
                fontFamily: "Lato, sans-serif",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        size: "large",
                        children: t('contacts:pointsOfContact')
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        size: "medium",
                        children: t('contacts:pointsOfContactDescription', {
                            entityType: entityName
                        })
                    })
                ]
            }),
            isUpdatePage && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                gap: "1rem",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        gap: "small",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                color: "dark-1",
                                size: "large",
                                weight: 300,
                                children: t('contacts:pointsOfContact')
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    fontFamily: "Lato, sans-serif",
                                    children: t('contacts:pointsOfContactDescriptionClient', {
                                        entityType: entityName
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                        id: "contact_name",
                        label: t('contacts:contact'),
                        placeholder: t('contacts:choose'),
                        value: selectedContactId,
                        setValue: (value)=>setSelectedContactId(value),
                        options: contacts.map((user)=>({
                                label: user.name,
                                value: user.id
                            })),
                        hideOptionalText: true
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        height: "8rem",
                        children: selectedContact && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            gap: "1rem",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                    plain: true,
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        id: "contact_role_name",
                                        label: t('contacts:contactRole'),
                                        value: selectedContact.role.name,
                                        placeholder: "",
                                        setValue: ()=>{},
                                        hideOptionalText: true,
                                        disabled: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                    plain: true,
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        id: "contact_email",
                                        label: t('contacts:contactEmail'),
                                        value: selectedContact.email,
                                        placeholder: "",
                                        setValue: ()=>{},
                                        hideOptionalText: true,
                                        disabled: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                    plain: true,
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        id: "contact_phone",
                                        label: t('contacts:contactPhone'),
                                        value: selectedContact.phone ? formatPhoneNumber(selectedContact.phone) : '',
                                        placeholder: "",
                                        setValue: ()=>{},
                                        hideOptionalText: true,
                                        width: "1/3",
                                        disabled: true
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");



const $8c584e3e17a0dda3$export$78c2aadc68a82149 = (props)=>{
    const { id: id, contacts: contacts = [], isUpdatePage: isUpdatePage, isCorporate: isCorporate, isRemittance: isRemittance, isFacility: isFacility } = props;
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const [selectedContactId, setSelectedContactId] = (0, $2xPiy.useState)();
    // const contacts = useMemo(() => (users ?? []).filter((user) => user.role.id === RoleTypes.ClientAdmin), [users]);
    const entityName = (0, $2xPiy.useMemo)(()=>isCorporate || isRemittance ? t('contacts:client') : isFacility ? t('common:facility') : undefined, [
        isCorporate,
        isRemittance,
        isFacility,
        t
    ]);
    const contactTypeName = (0, $2xPiy.useMemo)(()=>isCorporate ? t('contacts:corporateContacts') : isRemittance ? t('contacts:remittanceContacts') : isFacility ? t('contacts:facilityContacts') : undefined, [
        isCorporate,
        isRemittance,
        isFacility,
        t
    ]);
    const selectedContact = (0, $2xPiy.useMemo)(()=>contacts.find((contact)=>contact.id === selectedContactId) ?? contacts[0], [
        contacts,
        selectedContactId
    ]);
    const formatPhoneNumber = (value)=>{
        const digitsOnly = value.replace(/[^\d]/g, '');
        if (!digitsOnly) return '';
        if (digitsOnly.length >= 10) return `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6, 10)}`;
        return value;
    };
    (0, $2xPiy.useEffect)(()=>{
        if (!!contacts?.length && !selectedContactId) setSelectedContactId(contacts[0]?.id);
    }, [
        contacts,
        selectedContactId
    ]);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        gap: "1rem",
        fill: "horizontal",
        children: [
            !isUpdatePage && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                id: id,
                pad: "1rem",
                gap: "0.5rem",
                background: "light-6",
                border: {
                    size: 'small',
                    color: 'light-5'
                },
                borderRadius: "6px",
                fontFamily: "Lato, sans-serif",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        size: "large",
                        children: t('contacts:pointsOfContact')
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        size: "medium",
                        children: t('contacts:pointsOfContactDescription', {
                            entityType: entityName
                        })
                    })
                ]
            }),
            isUpdatePage && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                id: id,
                gap: "1rem",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        color: "dark-1",
                        size: "large",
                        weight: 300,
                        children: contactTypeName
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                        name: "contact_name",
                        label: t('contacts:contactName'),
                        placeholder: t('contacts:choose'),
                        value: selectedContactId,
                        setValue: (value)=>setSelectedContactId(value),
                        options: contacts.map((user)=>({
                                label: user.name,
                                value: user.id
                            })),
                        hideOptionalText: true
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        height: "8rem",
                        children: selectedContact && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            gap: "1rem",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                    plain: true,
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        name: "contact_email",
                                        label: t('contacts:contactEmail'),
                                        value: selectedContact.email,
                                        placeholder: "",
                                        // eslint-disable-next-line @typescript-eslint/no-empty-function
                                        setValue: ()=>{},
                                        hideOptionalText: true,
                                        disabled: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                    name: "contact_phone",
                                    label: t('contacts:contactPhone'),
                                    value: selectedContact.phone ? formatPhoneNumber(selectedContact.phone) : '',
                                    placeholder: "",
                                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                                    setValue: ()=>{},
                                    hideOptionalText: true,
                                    flex: "grow",
                                    disabled: true
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");



const $6aebb29a9b81e178$export$cd98175b99428c21 = (props)=>{
    const { isEmailVerified: isEmailVerified, userCanEdit: userCanEdit, setIsEmailVerified: setIsEmailVerified, required: required, onSubmit: onSubmit } = props;
    const [isFocused, setIsFocused] = (0, $2xPiy.useState)(false);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        border: {
            side: 'bottom',
            size: 'small',
            color: isFocused ? 'accent-1' : 'transparent'
        },
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $168667f04da9206c$export$16e4d70cc375e707), {
            onEnter: onSubmit,
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b3fb5add06fccd6e$export$ef9b1a59e592288f), {
                id: "email-verification-input",
                required: required,
                plain: true,
                onFocus: ()=>setIsFocused(true),
                onBlur: ()=>setIsFocused(false),
                value: isEmailVerified ? (0, $6db26f7304b7efb4$export$b664f3cc034a10ef).Verified : (0, $6db26f7304b7efb4$export$b664f3cc034a10ef).Unverified,
                options: [
                    (0, $6db26f7304b7efb4$export$b664f3cc034a10ef).Verified,
                    (0, $6db26f7304b7efb4$export$b664f3cc034a10ef).Unverified
                ],
                style: {
                    fontSize: '1rem',
                    fontFamily: 'Lato, sans-serif',
                    fontWeight: 400
                },
                disabled: !userCanEdit,
                onChange: ({ value: nextStatus })=>setIsEmailVerified(nextStatus === (0, $6db26f7304b7efb4$export$b664f3cc034a10ef).Verified ? true : false),
                valueLabel: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                    direction: "row",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            alignSelf: "center",
                            children: isEmailVerified ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2ab90fad418fe2af$export$2f4a3096121829b3), {
                                color: "green",
                                size: "16px"
                            }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $11571e85aa9685ed$export$5a89edf87f611fb5), {
                                size: "16px"
                            })
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), {
                            alignSelf: "center",
                            margin: {
                                left: '0.25rem'
                            },
                            size: "1rem",
                            style: {
                                fontFamily: 'Lato, sans-serif'
                            },
                            children: isEmailVerified ? (0, $6db26f7304b7efb4$export$b664f3cc034a10ef).Verified : (0, $6db26f7304b7efb4$export$b664f3cc034a10ef).Unverified
                        })
                    ]
                })
            })
        })
    });
};




var $2xPiy = parcelRequire("2xPiy");







const $c7da1bfa2f532a8b$export$99620e8a9a901b92 = (props)=>{
    const { isFuseAdmin: isFuseAdmin } = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const { user: user, isActive: isActive, userCanEdit: userCanEdit, setIsActive: setIsActive, ...boxProps } = props;
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const isMobile = screenSize === 'small' || screenSize === 'xsmall';
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        id: "info-bar",
        direction: isMobile ? 'column' : 'row',
        justify: "between",
        gap: "medium",
        margin: {
            vertical: '2rem'
        },
        pad: {
            vertical: '1rem'
        },
        border: {
            color: 'light-2',
            side: 'horizontal',
            size: 'small'
        },
        ...boxProps,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                justify: "center",
                gap: "xsmall",
                width: isMobile ? undefined : '25%',
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        color: "dark-4",
                        size: "medium",
                        children: t('common:status')
                    }),
                    isFuseAdmin ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7241dfec093c9db2$export$f62d1f3aa0d3cc5b), {
                        isActive: isActive,
                        setIsActive: setIsActive,
                        userCanEdit: userCanEdit
                    }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                alignSelf: "center",
                                children: isActive ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2ab90fad418fe2af$export$2f4a3096121829b3), {
                                    color: "green",
                                    size: "16px"
                                }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $11571e85aa9685ed$export$5a89edf87f611fb5), {
                                    size: "16px"
                                })
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                alignSelf: "center",
                                margin: {
                                    left: '0.25rem'
                                },
                                size: "medium",
                                fontFamily: "Lato, sans-serif",
                                children: isActive ? (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Active : (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Inactive
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                width: "10%"
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                justify: "center",
                gap: "xsmall",
                flex: "grow",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        color: "dark-4",
                        size: "medium",
                        children: t('user:lastLogin')
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        direction: "row",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            alignSelf: "center",
                            size: "medium",
                            fontFamily: "Lato, sans-serif",
                            children: user.last_login_at ? (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(user.last_login_at).format('MM/DD/YYYY @ h:mm A') : 'Never'
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                justify: "center",
                gap: "xsmall",
                flex: "grow",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        color: "dark-4",
                        size: "medium",
                        children: t('user:created')
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        direction: "row",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            alignSelf: "center",
                            size: "medium",
                            fontFamily: "Lato, sans-serif",
                            children: user.created_at ? (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(user.created_at).format('MM/DD/YYYY @ h:mm A') : 'Unknown'
                        })
                    })
                ]
            })
        ]
    });
};







const $171ae2f1cc3ea623$export$a19fd53949b39f24 = (props)=>{
    const { user: user, clientId: clientId, hideAvatar: hideAvatar, ...boxProps } = props;
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const usersPath = clientId && userStore.isExternalUser ? `/clients/${clientId}/users` : '/users';
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        direction: "row",
        gap: "small",
        pad: {
            vertical: '1rem'
        },
        ...boxProps,
        children: [
            !hideAvatar && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                alignSelf: "center",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc7832ace6bae342$export$e2255cf6045e8d47), {
                    background: "light-3",
                    size: "3rem",
                    hoverIndicator: {
                        elevation: 'small'
                    },
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        size: "medium",
                        color: "white",
                        children: (0, $00658ccd6ec0135a$export$de9bdbce6502b027)(user.name)
                    })
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                alignSelf: "center",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                        to: `${usersPath}/${user.id}`,
                        textDecoration: "none",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            color: "accent-1",
                            size: "medium",
                            weight: 700,
                            fontFamily: "Lato, sans-serif",
                            lineHeight: "1rem",
                            children: user.name
                        })
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        size: "small",
                        fontFamily: "Lato, sans-serif",
                        lineHeight: "1.25rem",
                        children: user.email
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        size: "small",
                        fontFamily: "Lato, sans-serif",
                        lineHeight: "1.25rem",
                        children: user.phone
                    })
                ]
            })
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");













const $b8d120ccf98e8417$var$USER_LIST_DEFAULTS = {
    page: 1,
    search: '',
    role_id: 0,
    is_active: 2
};
// Original defaults already represent "all" for every filter, so CLEARED === DEFAULTS
const $b8d120ccf98e8417$var$USER_LIST_CLEARED = {
    ...$b8d120ccf98e8417$var$USER_LIST_DEFAULTS
};
const $b8d120ccf98e8417$export$21b6143e6c635cfa = (props)=>{
    /* Props */ const { id: id, title: title, clientId: clientId, isClientPage: isClientPage, showAddButton: showAddButton, showFilters: showFilters, showSearchInput: showSearchInput, isLoading: propIsLoading, users: propUsers, fetchUsers: propFetchUsers, metadata: propMetadata, currentPage: propCurrentPage, setCurrentPage: propSetCurrentPage, hideHeader: hideHeader, boxProps: boxProps, surfaceId: surfaceId, standalone: standalone = false, mode: mode = 'query' } = props;
    const isPropControlled = mode === 'controlled';
    /* Context */ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /* Restorable state */ const restorableList = (0, $d73aac7e90cb996d$export$e4108de26414712f)({
        surfaceId: surfaceId || 'user-list',
        defaults: $b8d120ccf98e8417$var$USER_LIST_DEFAULTS,
        standalone: standalone
    });
    const queryState = restorableList.state;
    const setQueryState = restorableList.setState;
    /* Draft state */ const [draftSearch, setDraftSearch] = (0, $2xPiy.useState)(queryState.search);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [draftFilters, setDraftFilters] = (0, $2xPiy.useState)({
        role_id: queryState.role_id,
        is_active: queryState.is_active
    });
    /* Memos */ const filteredRoleOptions = (0, $2xPiy.useMemo)(()=>(!userStore.isInternalUser ? globalStore.roles.filter((role)=>(0, $a65473e9746b33bb$export$39d571c105d2314f).includes(role.id)) : globalStore.roles).map((role)=>({
                label: role.name,
                value: role.id
            })), [
        globalStore.roles,
        userStore.isInternalUser
    ]);
    /* Build the API request */ const request = (0, $2xPiy.useMemo)(()=>({
            page: queryState.page,
            name: queryState.search || undefined,
            role_id: queryState.role_id || undefined,
            is_active: queryState.is_active === 1 ? true : queryState.is_active === 0 ? false : undefined
        }), [
        queryState
    ]);
    /* React Query */ const { data: queryData, isLoading: queryIsLoading, isFetching: isFetching, error: queryError } = (0, $4130e158515cd100$export$dd0a697e1782aedd)({
        queryKey: [
            'users',
            userStore.user?.id,
            clientId,
            request
        ],
        queryFn: ()=>clientId ? (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).listClientUsers({
                ...request,
                id: clientId
            }) : (0, $1f30379e064ebff4$export$a81c579a392aa9d2).list(request),
        enabled: !isPropControlled && !!userStore.user,
        placeholderData: (prev)=>prev
    });
    const queryUsers = queryData?.data;
    const queryMetadata = queryData?.meta;
    /* Show toast on query error */ (0, $2xPiy.useEffect)(()=>{
        if (queryError && !isPropControlled) globalStore.handleApiError(queryError, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listUsers.error);
    }, [
        queryError
    ]);
    /* Resolved values */ const _users = propUsers ?? queryUsers;
    const _metadata = propMetadata ?? queryMetadata;
    const _currentPage = propCurrentPage ?? queryState.page;
    const _isLoading = propIsLoading ?? (isPropControlled ? false : queryIsLoading || isFetching);
    const isRefetching = isFetching && !queryIsLoading;
    const hasUsers = (0, $2xPiy.useMemo)(()=>!!_users?.length, [
        _users
    ]);
    /* Methods */ const search = (0, $2xPiy.useCallback)((query)=>{
        setQueryState({
            search: query || '',
            page: 1
        });
    }, [
        setQueryState
    ]);
    const applyFilters = (0, $2xPiy.useCallback)(()=>{
        setQueryState({
            role_id: draftFilters.role_id,
            is_active: draftFilters.is_active,
            page: 1
        });
    }, [
        setQueryState,
        draftFilters
    ]);
    const clearFilters = (0, $2xPiy.useCallback)(()=>{
        setDraftFilters({
            role_id: $b8d120ccf98e8417$var$USER_LIST_CLEARED.role_id,
            is_active: $b8d120ccf98e8417$var$USER_LIST_CLEARED.is_active
        });
        setDraftSearch('');
        setQueryState($b8d120ccf98e8417$var$USER_LIST_CLEARED);
    }, [
        setQueryState
    ]);
    const handlePageChange = (0, $2xPiy.useCallback)((page)=>{
        if (isPropControlled) {
            propSetCurrentPage?.(page);
            propFetchUsers?.(page);
        } else setQueryState({
            page: page
        });
    }, [
        isPropControlled,
        propSetCurrentPage,
        propFetchUsers,
        setQueryState
    ]);
    /* Sync page from API response */ (0, $2xPiy.useEffect)(()=>{
        if (queryMetadata && !isPropControlled && queryMetadata.current_page !== queryState.page) setQueryState({
            page: queryMetadata.current_page
        });
    }, [
        queryMetadata?.current_page
    ]);
    /* Sync drafts when queryState changes */ (0, $d73aac7e90cb996d$export$b5b12661e3d1fa94)(queryState, setDraftSearch, (s)=>s.search);
    (0, $d73aac7e90cb996d$export$b5b12661e3d1fa94)(queryState, setDraftFilters, (s)=>({
            role_id: s.role_id,
            is_active: s.is_active
        }));
    /* Render */ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        id: id,
        direction: "row",
        gap: "medium",
        fill: "horizontal",
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
                ...boxProps,
                children: [
                    !hideHeader && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                        title: title || t('user:userList'),
                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $77ee8bc744382cac$export$eb2fcfdbd7ba97d4), {
                            size: "24px",
                            color: "brand"
                        }),
                        children: [
                            showSearchInput && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f7f71094d2af306c$export$55d7609a8f1eccd2), {
                                searchQuery: draftSearch,
                                setSearchQuery: setDraftSearch,
                                onSearch: search,
                                isSearching: isRefetching,
                                "data-tour": "user-search"
                            }),
                            showAddButton && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $85ab7488c493b81c$export$6d88ebe453be59d7), {
                                label: t('user:addUser'),
                                targetUrl: `/users/create${clientId ? `?client_id=${clientId}` : ''}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                        pad: "none",
                        gap: "none",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                elevation: "small",
                                children: [
                                    _isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}),
                                    !_isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
                                        pad: {
                                            horizontal: '1.5rem'
                                        },
                                        columns: [
                                            {
                                                property: 'id',
                                                primary: true,
                                                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                    children: t('user:user')
                                                }),
                                                render: (user)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $171ae2f1cc3ea623$export$a19fd53949b39f24), {
                                                        user: user,
                                                        clientId: clientId
                                                    })
                                            },
                                            {
                                                property: isClientPage ? 'last_login_at' : 'clients',
                                                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                    children: isClientPage ? t('user:lastLogin') : t('user:company')
                                                }),
                                                render: (user)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                        boxProps: {
                                                            align: 'center',
                                                            height: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(92)
                                                        },
                                                        children: isClientPage ? user.last_login_at ? (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(user.last_login_at).format('MM/DD/YYYY @ hh:mm A') : 'Never' : user.clients && user.clients.length > 0 ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                            width: "250px",
                                                            overflow: "hidden",
                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                truncate: true,
                                                                children: user.clients.map((client)=>client.name).join(', ')
                                                            })
                                                        }) : '-'
                                                    })
                                            },
                                            {
                                                property: 'role.name',
                                                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                    children: t('user:userRole')
                                                }),
                                                align: 'start',
                                                render: (user)=>user.role ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                        background: "light-4",
                                                        pad: {
                                                            horizontal: '0.5rem',
                                                            vertical: '0.25rem'
                                                        },
                                                        borderRadius: "6px",
                                                        border: {
                                                            color: 'light-2',
                                                            size: 'small'
                                                        },
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            size: "xsmall",
                                                            weight: 700,
                                                            fontFamily: "Lato, sans-serif",
                                                            children: user.role?.name.split(' ').join(' - ')
                                                        })
                                                    }) : undefined
                                            },
                                            {
                                                property: 'active',
                                                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                    children: t('common:status')
                                                }),
                                                render: (user)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                            direction: "row",
                                                            gap: "xsmall",
                                                            children: [
                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                    alignSelf: "center",
                                                                    children: user.is_active ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2ab90fad418fe2af$export$2f4a3096121829b3), {
                                                                        color: "green",
                                                                        size: "16px"
                                                                    }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $11571e85aa9685ed$export$5a89edf87f611fb5), {
                                                                        size: "16px"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                    alignSelf: "center",
                                                                    size: "medium",
                                                                    fontFamily: "Lato, sans-serif",
                                                                    children: user.is_active ? (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Active : (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Inactive
                                                                })
                                                            ]
                                                        })
                                                    })
                                            }
                                        ],
                                        data: _users,
                                        background: [
                                            'light-6',
                                            'white'
                                        ],
                                        border: {
                                            color: 'light-2',
                                            side: 'bottom',
                                            size: 'small'
                                        }
                                    }),
                                    !hasUsers && !_isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        pad: {
                                            horizontal: '1.5rem',
                                            vertical: '2rem'
                                        },
                                        background: "light-6",
                                        justify: "center",
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                            alignSelf: "center",
                                            size: "medium",
                                            fontFamily: "Lato, sans-serif",
                                            children: t('user:noUsersFound')
                                        })
                                    })
                                ]
                            }),
                            !!_metadata && !!_currentPage && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                pad: "1.5rem",
                                flex: "grow",
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ffccbada2139938a$export$68f5e1453c188a82), {
                                    alignSelf: "center",
                                    size: "small",
                                    page: _currentPage,
                                    step: _metadata?.per_page,
                                    numberItems: _metadata?.total,
                                    onChange: (e)=>handlePageChange(e.page)
                                })
                            })
                        ]
                    })
                ]
            }),
            showFilters && filteredRoleOptions && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ea2652f405b477a3$export$92a576f896a9bf72), {
                isFiltering: isRefetching,
                onSubmit: ()=>applyFilters(),
                onClear: ()=>clearFilters(),
                "data-tour": "user-filters",
                filters: [
                    {
                        label: t('user:userRole'),
                        value: draftFilters.role_id,
                        setValue: (value)=>setDraftFilters({
                                ...draftFilters,
                                role_id: value
                            }),
                        options: [
                            {
                                label: t('common:all'),
                                value: 0
                            },
                            ...filteredRoleOptions
                        ]
                    },
                    {
                        label: t('user:userStatus'),
                        value: draftFilters.is_active,
                        setValue: (value)=>setDraftFilters({
                                ...draftFilters,
                                is_active: value
                            }),
                        options: [
                            {
                                label: t('common:all'),
                                value: 2
                            },
                            {
                                label: t('common:active'),
                                value: 1
                            },
                            {
                                label: t('user:inactive'),
                                value: 0
                            }
                        ]
                    }
                ]
            })
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");




var $2xPiy = parcelRequire("2xPiy");

function $c46e603b24b26e65$var$_extends() {
    return $c46e603b24b26e65$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c46e603b24b26e65$var$_extends.apply(null, arguments);
}
var $c46e603b24b26e65$export$cad1a703886b4e3a = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $c46e603b24b26e65$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Logout"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#231F20",
        strokeWidth: "2",
        d: "M13 9V2H1v20h12v-7m9-3H5m12-5 5 5-5 5"
    }));
});
$c46e603b24b26e65$export$cad1a703886b4e3a.displayName = 'Logout';






const $6c87f11e3936feb6$export$3dff63dd9b497d3e = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const clientStore = (0, $116967e0234c3770$export$3b47afa599c78f61)();
    const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const [menuIsOpen, setMenuIsOpen] = (0, $2xPiy.useState)(false);
    const isMultiClientUser = userStore.user && userStore.isExternalUser && (userStore.user.clients.length ?? 0) > 1;
    const handleEditProfile = ()=>{
        if (userStore.user) {
            setMenuIsOpen(false);
            navigate(`/users/${userStore.user.id}`);
        }
    };
    const handleChangeCompany = ()=>{
        clientStore.setActiveClientId(undefined);
        setMenuIsOpen(false);
    };
    const renderSignedInAs = (userName)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            pad: "small",
            border: {
                side: 'bottom',
                size: '0.05rem',
                color: 'light-2'
            },
            fontFamily: "Lato, sans-serif",
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    size: "0.875rem",
                    color: "light-3",
                    children: t('navigation:signedInAs')
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    size: "1rem",
                    color: "dark-2",
                    weight: 700,
                    lineHeight: "1.5rem",
                    children: userName
                })
            ]
        });
    const renderMenuButton = (label, onClick, icon)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            hoverIndicator: {
                background: 'light-4'
            },
            gap: "xsmall",
            pad: {
                horizontal: 'small',
                vertical: 'small'
            },
            flex: "grow",
            direction: "row",
            color: "dark-2",
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    alignSelf: "center",
                    children: icon
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    alignSelf: "center",
                    size: "1rem",
                    toUpperCase: true,
                    children: label
                })
            ]
        });
    const renderMenu = (user)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            justify: "center",
            ...props,
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c9158ac1cba12f75$export$64fff40e709e8b2e), {
                label: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    direction: "row",
                    justify: "center",
                    pad: "xsmall",
                    gap: "xsmall",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc7832ace6bae342$export$e2255cf6045e8d47), {
                            background: "accent-1",
                            size: "40px",
                            hoverIndicator: {
                                elevation: 'small'
                            },
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: "1.275rem",
                                color: "white",
                                children: (0, $00658ccd6ec0135a$export$de9bdbce6502b027)(user.name)
                            })
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            justify: "center",
                            children: menuIsOpen ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $5ac95831a9324798$export$cb86d8fdcb9f94b5), {}) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $1721736c3a136fd2$export$c22d792887f3cb87), {})
                        })
                    ]
                }),
                open: menuIsOpen,
                onOpen: ()=>setMenuIsOpen(true),
                onClose: ()=>setMenuIsOpen(false),
                plain: true,
                "data-tour": "user-settings",
                dropProps: {
                    align: {
                        top: 'bottom',
                        right: 'right'
                    }
                },
                dropContent: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    width: "15rem",
                    flex: "grow",
                    border: {
                        size: '0.05rem',
                        color: 'light-2'
                    },
                    children: [
                        renderSignedInAs(user.name),
                        isMultiClientUser && renderMenuButton('Set Active Company', handleChangeCompany, /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $546d71f0291023a6$export$f3a6aa388b70f149), {
                            size: "16px"
                        })),
                        renderMenuButton(t('navigation:editProfile'), handleEditProfile, /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f97d8419a136e9e9$export$6d128738bddfaa67), {
                            size: "16px"
                        })),
                        renderMenuButton(t('navigation:logout'), ()=>navigate('/logout'), /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c46e603b24b26e65$export$cad1a703886b4e3a), {
                            size: "16px"
                        }))
                    ]
                })
            })
        });
    return userStore.user ? renderMenu(userStore.user) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cb4cc5db45d03478$exports.Fragment), {});
});




var $2xPiy = parcelRequire("2xPiy");




const $7241dfec093c9db2$export$f62d1f3aa0d3cc5b = (props)=>{
    const { isActive: isActive, userCanEdit: userCanEdit, setIsActive: setIsActive, required: required, onSubmit: onSubmit } = props;
    const [isFocused, setIsFocused] = (0, $2xPiy.useState)(false);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        border: {
            side: 'bottom',
            size: 'small',
            color: isFocused ? 'accent-1' : 'transparent'
        },
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $168667f04da9206c$export$16e4d70cc375e707), {
            onEnter: onSubmit,
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b3fb5add06fccd6e$export$ef9b1a59e592288f), {
                id: "user-status-select",
                required: required,
                plain: true,
                onFocus: ()=>setIsFocused(true),
                onBlur: ()=>setIsFocused(false),
                value: isActive ? (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Active : (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Inactive,
                options: [
                    (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Active,
                    (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Inactive
                ],
                style: {
                    fontSize: '1rem',
                    fontFamily: 'Lato, sans-serif',
                    fontWeight: 400
                },
                disabled: !userCanEdit,
                onChange: ({ value: nextStatus })=>setIsActive(nextStatus === (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Active ? true : false),
                valueLabel: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                    direction: "row",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            alignSelf: "center",
                            children: isActive ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2ab90fad418fe2af$export$2f4a3096121829b3), {
                                color: "green",
                                size: "16px"
                            }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $11571e85aa9685ed$export$5a89edf87f611fb5), {
                                size: "16px"
                            })
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            alignSelf: "center",
                            margin: {
                                left: '0.25rem'
                            },
                            size: "1rem",
                            fontFamily: "Lato, sans-serif",
                            children: isActive ? (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Active : (0, $0badf5665deea2b2$export$3f6d0f4ada384a91).Inactive
                        })
                    ]
                })
            })
        })
    });
};




var $2xPiy = parcelRequire("2xPiy");







const $8879b7aaa1ca402a$export$48631ae2357a6160 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    const { user: currentUser, isFuseAdmin: isFuseAdmin, selectedUser: selectedUser, selectedUserId: selectedUserId, setSelectedUser: setSelectedUser } = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const { handleApiError: handleApiError } = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const [menuIsOpen, setMenuIsOpen] = (0, $2xPiy.useState)(false);
    const [selectedIndex, setSelectedIndex] = (0, $2xPiy.useState)(0);
    const [isLoadingUsers, setIsLoadingUsers] = (0, $2xPiy.useState)(true);
    const [usersList, setUsersList] = (0, $2xPiy.useState)();
    const [metadata, setMetadata] = (0, $2xPiy.useState)();
    const [currentPage, setCurrentPage] = (0, $2xPiy.useState)(1);
    (0, $2xPiy.useEffect)(()=>{
        if (isLoadingUsers) {
            if (!usersList) fetchUsersList();
            else {
                if (!selectedUser && usersList.length) setSelectedUser(usersList[0]);
                setIsLoadingUsers(false);
            }
        }
    }, [
        usersList,
        isLoadingUsers,
        selectedUser
    ]);
    const nextPage = ()=>{
        if (metadata && currentPage + 1 > metadata.last_page) return;
        fetchUsersList(currentPage + 1);
    };
    const fetchUsersList = (page)=>{
        if (!currentUser) return;
        if (isFuseAdmin) (0, $1f30379e064ebff4$export$a81c579a392aa9d2).list({
            page: page
        }).then(({ data: data, meta: meta })=>{
            setUsersList([
                ...usersList ?? [],
                ...data
            ]);
            setMetadata(meta);
            setCurrentPage(meta.current_page);
        }).catch((err)=>handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listUsers.error));
        else {
            setUsersList([
                currentUser
            ]);
            setCurrentPage(1);
        }
    };
    const openMenu = ()=>setMenuIsOpen(true);
    const closeMenu = ()=>setMenuIsOpen(false);
    const selectUser = (user, index)=>{
        setSelectedUser(user);
        setSelectedIndex(index);
        closeMenu();
    };
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c9158ac1cba12f75$export$64fff40e709e8b2e), {
        label: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            direction: "row",
            justify: "center",
            pad: "xsmall",
            gap: "xsmall",
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    alignSelf: "center",
                    size: "1rem",
                    weight: 500,
                    children: selectedUser?.name
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                    justify: "center",
                    children: menuIsOpen ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $5ac95831a9324798$export$cb86d8fdcb9f94b5), {}) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $1721736c3a136fd2$export$c22d792887f3cb87), {})
                })
            ]
        }),
        open: menuIsOpen,
        onOpen: openMenu,
        onClose: closeMenu,
        plain: true,
        dropProps: {
            align: {
                top: 'bottom',
                right: 'right'
            }
        },
        dropContent: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            border: {
                size: '0.05rem',
                color: 'light-2'
            },
            height: (usersList ? usersList.length <= 7 : false) ? '100%' : '241px',
            overflow: (usersList ? usersList.length <= 7 : false) ? 'default' : 'auto',
            children: !isLoadingUsers && !!usersList && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $26613b622f673475$export$c5295390d6167a3e), {
                show: selectedIndex,
                step: 20,
                onMore: nextPage,
                items: usersList,
                children: (user, i)=>{
                    const isSelected = selectedUserId === user.id;
                    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                        hoverIndicator: "light-4",
                        onClick: ()=>selectUser(user, i),
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            direction: "row",
                            gap: "7px",
                            pad: {
                                vertical: 'xsmall',
                                horizontal: 'small'
                            },
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e36c36a47b767f06$export$f4422ae58352e179), {
                                    name: user.name,
                                    checked: isSelected,
                                    readOnly: true
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    size: "1rem",
                                    color: "dark-2",
                                    truncate: true,
                                    lineHeight: "1.40625rem",
                                    children: user.name
                                })
                            ]
                        })
                    }, `user-list-index-${i}`);
                }
            })
        })
    });
});




var $2xPiy = parcelRequire("2xPiy");





const $98f6fb2bc6644a7b$export$a66ad6b97f33cef3 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { user: user } = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const { handleApiError: handleApiError } = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const { users: users, value: value, setValue: setValue, required: required, hideOptionalText: hideOptionalText, disabled: disabled } = props;
    const [isLoadingUsers, setIsLoadingUsers] = (0, $2xPiy.useState)(true);
    const [usersList, setUsersList] = (0, $2xPiy.useState)([]);
    const [selectOptions, setSelectOptions] = (0, $2xPiy.useState)([]);
    const [usersMetadata, setUsersMetadata] = (0, $2xPiy.useState)();
    const [currentPage, setCurrentPage] = (0, $2xPiy.useState)(1);
    (0, $2xPiy.useEffect)(()=>{
        if (isLoadingUsers) {
            if (!usersList.length) {
                if (users) {
                    setUsersList(users);
                    setSelectOptions(users.map((user)=>({
                            label: user.name,
                            value: user.id
                        })));
                    setIsLoadingUsers(false);
                } else fetchUsersList().catch((err)=>handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listUsers.error)).finally(()=>setIsLoadingUsers(false));
            } else setIsLoadingUsers(false);
        }
    }, [
        usersList,
        isLoadingUsers,
        value
    ]);
    const fetchUsersList = async (page)=>{
        if (user) {
            const { data: data, meta: meta } = await (0, $1f30379e064ebff4$export$a81c579a392aa9d2).list({
                page: page
            });
            const options = data.map((user)=>({
                    label: user.name,
                    value: user.id
                }));
            setUsersList([
                ...usersList ?? [],
                ...data
            ]);
            setSelectOptions([
                ...selectOptions,
                ...options
            ]);
            setUsersMetadata(meta);
            setCurrentPage(meta.current_page);
        }
    };
    const handleOnMore = ()=>{
        if (usersMetadata && currentPage + 1 > usersMetadata.last_page) return;
        fetchUsersList(currentPage + 1);
    };
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
        label: "Users",
        value: value,
        setValue: (id)=>setValue(id),
        onMore: handleOnMore,
        options: selectOptions,
        required: required,
        disabled: disabled,
        hideOptionalText: hideOptionalText
    });
});






var $2xPiy = parcelRequire("2xPiy");



var $2xPiy = parcelRequire("2xPiy");

function $f16983307411ac60$var$_extends() {
    return $f16983307411ac60$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f16983307411ac60$var$_extends.apply(null, arguments);
}
var $f16983307411ac60$export$be11e187edb4cb0c = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $f16983307411ac60$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Save"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M3 2v19h18V3h-9v11m-4-3 4 4 4-4"
    }));
});
$f16983307411ac60$export$be11e187edb4cb0c.displayName = 'Save';


var $2xPiy = parcelRequire("2xPiy");

function $91e0caa7b2d289da$var$_extends() {
    return $91e0caa7b2d289da$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $91e0caa7b2d289da$var$_extends.apply(null, arguments);
}
var $91e0caa7b2d289da$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $91e0caa7b2d289da$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Table"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8 5v18m8-18v18M1 11h22M1 5h22M1 17h22M1 1h22v22H1V1z"
    }));
});
$91e0caa7b2d289da$export$54ec01a60f47d33d.displayName = 'Table';




var $2xPiy = parcelRequire("2xPiy");



var $3321243da0932e1e$exports = {};
"use strict";
$3321243da0932e1e$exports.__esModule = true;
var $2ef7a3fe1531457a$exports = {};

$parcel$export($2ef7a3fe1531457a$exports, "__esModule", function () { return $2ef7a3fe1531457a$export$1e511d4a378977f5; }, function (v) { return $2ef7a3fe1531457a$export$1e511d4a378977f5 = v; });
$parcel$export($2ef7a3fe1531457a$exports, "Accordion", function () { return $2ef7a3fe1531457a$export$a766cd26d0d69044; }, function (v) { return $2ef7a3fe1531457a$export$a766cd26d0d69044 = v; });
var $2ef7a3fe1531457a$export$1e511d4a378977f5;
var $2ef7a3fe1531457a$export$a766cd26d0d69044;
"use strict";
$2ef7a3fe1531457a$export$1e511d4a378977f5 = true;
$2ef7a3fe1531457a$export$a766cd26d0d69044 = void 0;
var $7bbf8f812abe43e9$export$1e511d4a378977f5;
var $7bbf8f812abe43e9$export$a766cd26d0d69044;
"use strict";
$7bbf8f812abe43e9$export$1e511d4a378977f5 = true;
$7bbf8f812abe43e9$export$a766cd26d0d69044 = void 0;

var $7bbf8f812abe43e9$var$_react = $7bbf8f812abe43e9$var$_interopRequireWildcard((parcelRequire("2xPiy")));
var $da133a25baccbe1d$export$1e511d4a378977f5;
var $da133a25baccbe1d$export$2e471fbf97c80661;
"use strict";
$da133a25baccbe1d$export$1e511d4a378977f5 = true;
$da133a25baccbe1d$export$2e471fbf97c80661 = void 0;

var $da133a25baccbe1d$var$_propTypes = $da133a25baccbe1d$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $da133a25baccbe1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $da133a25baccbe1d$var$_extends() {
    return $da133a25baccbe1d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $da133a25baccbe1d$var$_extends.apply(null, arguments);
}
var $da133a25baccbe1d$var$PropType = {};
$da133a25baccbe1d$var$PropType = $da133a25baccbe1d$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    activeIndex: $da133a25baccbe1d$var$_propTypes["default"].oneOfType([
        $da133a25baccbe1d$var$_propTypes["default"].number,
        $da133a25baccbe1d$var$_propTypes["default"].arrayOf($da133a25baccbe1d$var$_propTypes["default"].number)
    ]),
    animate: $da133a25baccbe1d$var$_propTypes["default"].bool,
    children: $da133a25baccbe1d$var$_propTypes["default"].node,
    level: $da133a25baccbe1d$var$_propTypes["default"].number,
    onActive: $da133a25baccbe1d$var$_propTypes["default"].func,
    multiple: $da133a25baccbe1d$var$_propTypes["default"].bool,
    messages: $da133a25baccbe1d$var$_propTypes["default"].shape({
        tabContents: $da133a25baccbe1d$var$_propTypes["default"].string
    })
});
var $da133a25baccbe1d$var$AccordionPropTypes = $da133a25baccbe1d$export$2e471fbf97c80661 = $da133a25baccbe1d$var$PropType;



var $f09a9f2430934c2c$export$1e511d4a378977f5;
var $f09a9f2430934c2c$export$6bd5bb82c987ab74;
"use strict";
$f09a9f2430934c2c$export$1e511d4a378977f5 = true;
$f09a9f2430934c2c$export$6bd5bb82c987ab74 = void 0;

var $2xPiy = parcelRequire("2xPiy");
var $f09a9f2430934c2c$var$AccordionContext = $f09a9f2430934c2c$export$6bd5bb82c987ab74 = /*#__PURE__*/ (0, $2xPiy.createContext)({});


var $7bbf8f812abe43e9$var$_excluded = [
    "activeIndex",
    "animate",
    "children",
    "level",
    "multiple",
    "onActive"
];
function $7bbf8f812abe43e9$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($7bbf8f812abe43e9$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $7bbf8f812abe43e9$var$_extends() {
    return $7bbf8f812abe43e9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7bbf8f812abe43e9$var$_extends.apply(null, arguments);
}
function $7bbf8f812abe43e9$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $7bbf8f812abe43e9$var$activeAsArray = function activeAsArray(active) {
    return typeof active === 'number' ? [
        active
    ] : active;
};
var $7bbf8f812abe43e9$var$Accordion = $7bbf8f812abe43e9$export$a766cd26d0d69044 = /*#__PURE__*/ (0, $7bbf8f812abe43e9$var$_react.forwardRef)(function(_ref, ref) {
    var activeIndex = _ref.activeIndex, _ref$animate = _ref.animate, animate = _ref$animate === void 0 ? true : _ref$animate, children = _ref.children, level = _ref.level, multiple = _ref.multiple, onActive = _ref.onActive, rest = $7bbf8f812abe43e9$var$_objectWithoutPropertiesLoose(_ref, $7bbf8f812abe43e9$var$_excluded);
    var _useState = (0, $7bbf8f812abe43e9$var$_react.useState)([]), activeIndexes = _useState[0], setActiveIndexes = _useState[1];
    var _useState2 = (0, $7bbf8f812abe43e9$var$_react.useState)(), stateActiveIndex = _useState2[0], setStateActiveIndex = _useState2[1];
    // Derived state from props
    // https://reactjs.org/docs/hooks-faq.html#how-do-i-implement-getderivedstatefromprops
    var derivedActiveIndexes = $7bbf8f812abe43e9$var$activeAsArray(activeIndex) || [];
    if ((typeof activeIndex !== 'undefined' || activeIndex !== stateActiveIndex) && derivedActiveIndexes.join() !== activeIndexes.join()) {
        setActiveIndexes(derivedActiveIndexes);
        setStateActiveIndex(activeIndex);
    }
    var getAccordionContext = (0, $7bbf8f812abe43e9$var$_react.useCallback)(function(index) {
        var _onPanelChange = function onPanelChange(nextIndex) {
            var nextActiveIndexes = [].concat(activeIndexes || []);
            var nextActiveIndex = nextActiveIndexes.indexOf(nextIndex);
            if (nextActiveIndex > -1) nextActiveIndexes.splice(nextActiveIndex, 1);
            else if (multiple) nextActiveIndexes.push(nextIndex);
            else nextActiveIndexes = [
                nextIndex
            ];
            setActiveIndexes(nextActiveIndexes);
            if (onActive) onActive(nextActiveIndexes);
        };
        return {
            active: activeIndexes.indexOf(index) > -1,
            animate: animate,
            level: level,
            onPanelChange: function onPanelChange() {
                return _onPanelChange(index);
            }
        };
    }, [
        activeIndexes,
        animate,
        level,
        multiple,
        onActive
    ]);
    return /*#__PURE__*/ $7bbf8f812abe43e9$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $7bbf8f812abe43e9$var$_extends({
        ref: ref
    }, rest), $7bbf8f812abe43e9$var$_react.Children.toArray(children).filter(function(child) {
        return child;
    }).map(function(child, index) {
        return /*#__PURE__*/ $7bbf8f812abe43e9$var$_react["default"].createElement($f09a9f2430934c2c$export$6bd5bb82c987ab74.Provider, {
            // eslint-disable-next-line react/no-array-index-key
            key: index,
            value: getAccordionContext(index)
        }, child);
    }));
});
$7bbf8f812abe43e9$var$Accordion.propTypes = $da133a25baccbe1d$export$2e471fbf97c80661;


$2ef7a3fe1531457a$export$a766cd26d0d69044 = $7bbf8f812abe43e9$export$a766cd26d0d69044;


Object.keys($2ef7a3fe1531457a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $2ef7a3fe1531457a$exports[key]) return;
    $3321243da0932e1e$exports[key] = $2ef7a3fe1531457a$exports[key];
});
var $0b17fa67fb14e31e$exports = {};

$parcel$export($0b17fa67fb14e31e$exports, "__esModule", function () { return $0b17fa67fb14e31e$export$1e511d4a378977f5; }, function (v) { return $0b17fa67fb14e31e$export$1e511d4a378977f5 = v; });
$parcel$export($0b17fa67fb14e31e$exports, "AccordionPanel", function () { return $0b17fa67fb14e31e$export$7cad6f17fd6e117b; }, function (v) { return $0b17fa67fb14e31e$export$7cad6f17fd6e117b = v; });
var $0b17fa67fb14e31e$export$1e511d4a378977f5;
var $0b17fa67fb14e31e$export$7cad6f17fd6e117b;
"use strict";
$0b17fa67fb14e31e$export$1e511d4a378977f5 = true;
$0b17fa67fb14e31e$export$7cad6f17fd6e117b = void 0;
var $dc13f7a9b9569734$export$1e511d4a378977f5;
var $dc13f7a9b9569734$export$7cad6f17fd6e117b;
"use strict";
$dc13f7a9b9569734$export$1e511d4a378977f5 = true;
$dc13f7a9b9569734$export$7cad6f17fd6e117b = void 0;

var $dc13f7a9b9569734$var$_react = $dc13f7a9b9569734$var$_interopRequireWildcard((parcelRequire("2xPiy")));


var $fb68f765668b25d0$exports = {};

$parcel$export($fb68f765668b25d0$exports, "__esModule", function () { return $fb68f765668b25d0$export$1e511d4a378977f5; }, function (v) { return $fb68f765668b25d0$export$1e511d4a378977f5 = v; });
$parcel$export($fb68f765668b25d0$exports, "Button", function () { return $fb68f765668b25d0$export$353f5b6fc5456de1; }, function (v) { return $fb68f765668b25d0$export$353f5b6fc5456de1 = v; });
var $fb68f765668b25d0$export$1e511d4a378977f5;
var $fb68f765668b25d0$export$353f5b6fc5456de1;
"use strict";
$fb68f765668b25d0$export$1e511d4a378977f5 = true;
$fb68f765668b25d0$export$353f5b6fc5456de1 = void 0;
var $2449fa876f4654de$export$1e511d4a378977f5;
var $2449fa876f4654de$export$353f5b6fc5456de1;
"use strict";
$2449fa876f4654de$export$1e511d4a378977f5 = true;
$2449fa876f4654de$export$353f5b6fc5456de1 = void 0;

var $2449fa876f4654de$var$_react = $2449fa876f4654de$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $2449fa876f4654de$var$_styledComponents = $2449fa876f4654de$var$_interopRequireDefault((parcelRequire("iA1nz")));

var $5c5e21b37c7cd707$export$1e511d4a378977f5;
var $5c5e21b37c7cd707$export$932f054f6b4bba8d;
"use strict";
$5c5e21b37c7cd707$export$1e511d4a378977f5 = true;
$5c5e21b37c7cd707$export$932f054f6b4bba8d = void 0;

var $5c5e21b37c7cd707$var$_propTypes = $5c5e21b37c7cd707$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $5c5e21b37c7cd707$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $5c5e21b37c7cd707$var$_extends() {
    return $5c5e21b37c7cd707$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5c5e21b37c7cd707$var$_extends.apply(null, arguments);
}
var $5c5e21b37c7cd707$var$PropType = {};
$5c5e21b37c7cd707$var$PropType = $5c5e21b37c7cd707$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    children: $5c5e21b37c7cd707$var$_propTypes["default"].oneOfType([
        $5c5e21b37c7cd707$var$_propTypes["default"].func,
        $5c5e21b37c7cd707$var$_propTypes["default"].object,
        $5c5e21b37c7cd707$var$_propTypes["default"].node
    ]),
    active: $5c5e21b37c7cd707$var$_propTypes["default"].bool,
    as: $5c5e21b37c7cd707$var$_propTypes["default"].oneOfType([
        $5c5e21b37c7cd707$var$_propTypes["default"].string,
        $5c5e21b37c7cd707$var$_propTypes["default"].func,
        $5c5e21b37c7cd707$var$_propTypes["default"].elementType
    ]),
    badge: $5c5e21b37c7cd707$var$_propTypes["default"].oneOfType([
        $5c5e21b37c7cd707$var$_propTypes["default"].bool,
        $5c5e21b37c7cd707$var$_propTypes["default"].element,
        $5c5e21b37c7cd707$var$_propTypes["default"].number,
        $5c5e21b37c7cd707$var$_propTypes["default"].shape({
            background: $5897bd367fbd90c1$export$f8a44c6979fe9fe5,
            max: $5c5e21b37c7cd707$var$_propTypes["default"].number,
            value: $5c5e21b37c7cd707$var$_propTypes["default"].oneOfType([
                $5c5e21b37c7cd707$var$_propTypes["default"].bool,
                $5c5e21b37c7cd707$var$_propTypes["default"].number
            ])
        })
    ]),
    busy: $5c5e21b37c7cd707$var$_propTypes["default"].bool,
    color: $5897bd367fbd90c1$export$fc4c368d97afb623,
    disabled: $5c5e21b37c7cd707$var$_propTypes["default"].bool,
    fill: $5c5e21b37c7cd707$var$_propTypes["default"].oneOfType([
        $5c5e21b37c7cd707$var$_propTypes["default"].oneOf([
            'horizontal',
            'vertical'
        ]),
        $5c5e21b37c7cd707$var$_propTypes["default"].bool
    ]),
    focusIndicator: $5c5e21b37c7cd707$var$_propTypes["default"].oneOfType([
        $5c5e21b37c7cd707$var$_propTypes["default"].bool,
        $5c5e21b37c7cd707$var$_propTypes["default"].oneOf([
            'inset'
        ])
    ]),
    gap: $5c5e21b37c7cd707$var$_propTypes["default"].oneOfType([
        $5c5e21b37c7cd707$var$_propTypes["default"].oneOf([
            'none',
            'xxsmall',
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        $5c5e21b37c7cd707$var$_propTypes["default"].string
    ]),
    hoverIndicator: $5897bd367fbd90c1$export$e4126213490fff97,
    href: $5c5e21b37c7cd707$var$_propTypes["default"].string,
    icon: $5c5e21b37c7cd707$var$_propTypes["default"].element,
    justify: $5c5e21b37c7cd707$var$_propTypes["default"].oneOf([
        'around',
        'between',
        'center',
        'end',
        'evenly',
        'start',
        'stretch'
    ]),
    label: $5c5e21b37c7cd707$var$_propTypes["default"].node,
    messages: $5c5e21b37c7cd707$var$_propTypes["default"].shape({
        busy: $5c5e21b37c7cd707$var$_propTypes["default"].string,
        success: $5c5e21b37c7cd707$var$_propTypes["default"].string
    }),
    onClick: $5c5e21b37c7cd707$var$_propTypes["default"].func,
    pad: $5897bd367fbd90c1$export$b91a2ef62736aae3,
    plain: $5c5e21b37c7cd707$var$_propTypes["default"].bool,
    primary: $5c5e21b37c7cd707$var$_propTypes["default"].bool,
    reverse: $5c5e21b37c7cd707$var$_propTypes["default"].bool,
    secondary: $5c5e21b37c7cd707$var$_propTypes["default"].bool,
    size: $5c5e21b37c7cd707$var$_propTypes["default"].oneOfType([
        $5c5e21b37c7cd707$var$_propTypes["default"].oneOf([
            'small',
            'medium',
            'large'
        ]),
        $5c5e21b37c7cd707$var$_propTypes["default"].string
    ]),
    success: $5c5e21b37c7cd707$var$_propTypes["default"].bool,
    target: $5c5e21b37c7cd707$var$_propTypes["default"].oneOfType([
        $5c5e21b37c7cd707$var$_propTypes["default"].oneOf([
            '_self',
            '_blank',
            '_parent',
            '_top'
        ]),
        $5c5e21b37c7cd707$var$_propTypes["default"].string
    ]),
    tip: $5c5e21b37c7cd707$var$_propTypes["default"].oneOfType([
        $5c5e21b37c7cd707$var$_propTypes["default"].shape({
            content: $5c5e21b37c7cd707$var$_propTypes["default"].oneOfType([
                $5c5e21b37c7cd707$var$_propTypes["default"].node,
                $5c5e21b37c7cd707$var$_propTypes["default"].string
            ]),
            dropProps: $5c5e21b37c7cd707$var$_propTypes["default"].shape({}),
            plain: $5c5e21b37c7cd707$var$_propTypes["default"].bool
        }),
        $5c5e21b37c7cd707$var$_propTypes["default"].string
    ]),
    type: $5c5e21b37c7cd707$var$_propTypes["default"].oneOf([
        'button',
        'reset',
        'submit'
    ])
});
var $5c5e21b37c7cd707$var$ButtonPropTypes = $5c5e21b37c7cd707$export$932f054f6b4bba8d = $5c5e21b37c7cd707$var$PropType;



var $3b30be80b148b2c8$export$1e511d4a378977f5;
var $3b30be80b148b2c8$export$d9468344d3651243;
var $3b30be80b148b2c8$export$b060d577040138d8;
"use strict";
$3b30be80b148b2c8$export$1e511d4a378977f5 = true;
$3b30be80b148b2c8$export$d9468344d3651243 = $3b30be80b148b2c8$export$b060d577040138d8 = void 0;
var $f6efb4fb59334234$export$1e511d4a378977f5;
var $f6efb4fb59334234$export$d9468344d3651243;
var $f6efb4fb59334234$export$b060d577040138d8;
"use strict";
$f6efb4fb59334234$export$1e511d4a378977f5 = true;
$f6efb4fb59334234$export$d9468344d3651243 = $f6efb4fb59334234$export$b060d577040138d8 = void 0;

var $f6efb4fb59334234$var$_react = $f6efb4fb59334234$var$_interopRequireDefault((parcelRequire("2xPiy")));

var $f6efb4fb59334234$var$_default = $f6efb4fb59334234$var$_interopRequireDefault((parcelRequire("3YqNT")));
function $f6efb4fb59334234$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
// options:
//   id: message id
//   messages: (optional) an object of message overrides
//   values: (optional) currently unused but in the future
//     will be an object with substitution values for
//     positional variables in the message text.
//   defaultMessage: (optional) default message to use if
//     the message isn't found elsewhere.
var $f6efb4fb59334234$var$_format = $f6efb4fb59334234$export$d9468344d3651243 = function format(options, messages) {
    var _options$id;
    // Message id's are hierarchical. For the component-specific
    // message objects passed as options.messages, just use the last
    // component in the id for backwards compatibility.
    //
    // For overall messages passed to grommet, use the hierarchical
    // id. For that messages object, the messages are in an object
    // hierarchy by component, similar to how the theme works.
    //
    // Applications that typically keep their messages in flat
    // objects with a single key string per message can override
    // this format function to get the grommet messages from
    // their bundles that way and don't need to pass the messages
    // themselves in this property, just the format function.
    var idParts = ((_options$id = options.id) == null ? void 0 : _options$id.split('.')) || [];
    // eslint-disable-next-line no-unsafe-optional-chaining
    var baseId = idParts[(idParts == null ? void 0 : idParts.length) - 1];
    var messageObj = messages;
    idParts.forEach(function(idPart) {
        if (typeof messageObj === 'object') messageObj = messageObj[idPart];
    });
    var message = (options.messages ? options.messages[baseId] : undefined) || messageObj || options.defaultMessage;
    var values = options.values;
    var newMessage = message;
    var tokens = message == null ? void 0 : message.match(/\{(.+?)\}/g);
    tokens == null || tokens.forEach(function(token) {
        var names = token.substr(1, token.length - 2);
        var value = values[names];
        newMessage = newMessage.replace(token, value);
    });
    return values ? newMessage : message;
};
var $f6efb4fb59334234$var$defaultValue = {
    messages: $f6efb4fb59334234$var$_default["default"],
    format: function format(options) {
        return $f6efb4fb59334234$var$_format(options, $f6efb4fb59334234$var$_default["default"]);
    }
};
var $f6efb4fb59334234$var$MessageContext = $f6efb4fb59334234$export$b060d577040138d8 = /*#__PURE__*/ $f6efb4fb59334234$var$_react["default"].createContext($f6efb4fb59334234$var$defaultValue);


$3b30be80b148b2c8$export$d9468344d3651243 = $f6efb4fb59334234$export$d9468344d3651243;
$3b30be80b148b2c8$export$b060d577040138d8 = $f6efb4fb59334234$export$b060d577040138d8;




var $7946e73be6fde87a$exports = {};

$parcel$export($7946e73be6fde87a$exports, "__esModule", function () { return $7946e73be6fde87a$export$1e511d4a378977f5; }, function (v) { return $7946e73be6fde87a$export$1e511d4a378977f5 = v; });
$parcel$export($7946e73be6fde87a$exports, "Tip", function () { return $7946e73be6fde87a$export$c92c6401b52a9298; }, function (v) { return $7946e73be6fde87a$export$c92c6401b52a9298 = v; });
var $7946e73be6fde87a$export$1e511d4a378977f5;
var $7946e73be6fde87a$export$c92c6401b52a9298;
"use strict";
$7946e73be6fde87a$export$1e511d4a378977f5 = true;
$7946e73be6fde87a$export$c92c6401b52a9298 = void 0;
var $7f82531467bce456$export$1e511d4a378977f5;
var $7f82531467bce456$export$c92c6401b52a9298;
"use strict";
$7f82531467bce456$export$1e511d4a378977f5 = true;
$7f82531467bce456$export$c92c6401b52a9298 = void 0;

var $7f82531467bce456$var$_react = $7f82531467bce456$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $9097252a6690f3a9$exports = {};

$parcel$export($9097252a6690f3a9$exports, "__esModule", function () { return $9097252a6690f3a9$export$1e511d4a378977f5; }, function (v) { return $9097252a6690f3a9$export$1e511d4a378977f5 = v; });
$parcel$export($9097252a6690f3a9$exports, "Drop", function () { return $9097252a6690f3a9$export$aaa698cd7aa517d6; }, function (v) { return $9097252a6690f3a9$export$aaa698cd7aa517d6 = v; });
var $9097252a6690f3a9$export$1e511d4a378977f5;
var $9097252a6690f3a9$export$aaa698cd7aa517d6;
"use strict";
$9097252a6690f3a9$export$1e511d4a378977f5 = true;
$9097252a6690f3a9$export$aaa698cd7aa517d6 = void 0;
var $6a7412d1389f6c64$export$1e511d4a378977f5;
var $6a7412d1389f6c64$export$aaa698cd7aa517d6;
"use strict";
$6a7412d1389f6c64$export$1e511d4a378977f5 = true;
$6a7412d1389f6c64$export$aaa698cd7aa517d6 = void 0;

var $6a7412d1389f6c64$var$_react = $6a7412d1389f6c64$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $cX5wj = parcelRequire("cX5wj");

var $b7ccb885e3be2f19$export$1e511d4a378977f5;
var $b7ccb885e3be2f19$export$aabdb120602c28c3;
"use strict";
$b7ccb885e3be2f19$export$1e511d4a378977f5 = true;
$b7ccb885e3be2f19$export$aabdb120602c28c3 = void 0;

var $b7ccb885e3be2f19$var$_react = $b7ccb885e3be2f19$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $iA1nz = parcelRequire("iA1nz");

var $5b4f0795c5f45c3e$export$1e511d4a378977f5;
var $5b4f0795c5f45c3e$export$b0cd6833c93fb94d;
"use strict";
$5b4f0795c5f45c3e$export$1e511d4a378977f5 = true;
$5b4f0795c5f45c3e$export$b0cd6833c93fb94d = void 0;

var $5b4f0795c5f45c3e$var$_react = $5b4f0795c5f45c3e$var$_interopRequireWildcard((parcelRequire("2xPiy")));


var $5b4f0795c5f45c3e$var$_excluded = [
    "hidden",
    "restrictScroll",
    "children",
    "trapFocus"
];
function $5b4f0795c5f45c3e$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($5b4f0795c5f45c3e$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $5b4f0795c5f45c3e$var$_extends() {
    return $5b4f0795c5f45c3e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5b4f0795c5f45c3e$var$_extends.apply(null, arguments);
}
function $5b4f0795c5f45c3e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $5b4f0795c5f45c3e$var$isFocusable = function isFocusable(element) {
    if ((element == null ? void 0 : element.tabIndex) < 0 || element != null && element.disabled) return false;
    switch(element == null ? void 0 : element.nodeName){
        case 'A':
            return !!element.href && element.rel !== 'ignore';
        case 'INPUT':
            return element.type !== 'hidden';
        case 'BUTTON':
        case 'SELECT':
        case 'TEXTAREA':
            return true;
        case 'DIV':
            return element.tabIndex >= 0;
        default:
            return false;
    }
};
var $5b4f0795c5f45c3e$var$FocusedContainer = $5b4f0795c5f45c3e$export$b0cd6833c93fb94d = function FocusedContainer(_ref) {
    var _ref$hidden = _ref.hidden, hidden = _ref$hidden === void 0 ? false : _ref$hidden, _ref$restrictScroll = _ref.restrictScroll, restrictScroll = _ref$restrictScroll === void 0 ? false : _ref$restrictScroll, children = _ref.children, trapFocus = _ref.trapFocus, rest = $5b4f0795c5f45c3e$var$_objectWithoutPropertiesLoose(_ref, $5b4f0795c5f45c3e$var$_excluded);
    var _useState = (0, $5b4f0795c5f45c3e$var$_react.useState)(''), bodyOverflowStyle = _useState[0], setBodyOverflowStyle = _useState[1];
    var ref = (0, $5b4f0795c5f45c3e$var$_react.useRef)(null);
    var preNodeRef = (0, $5b4f0795c5f45c3e$var$_react.useRef)(null);
    var postNodeRef = (0, $5b4f0795c5f45c3e$var$_react.useRef)(null);
    var _useRoots = (0, $f4322a4a0d63b89f$export$79ef40724920756d)(), contextValue = _useRoots.contextValue, hasRoots = _useRoots.hasRoots;
    var contextRoots = contextValue.roots;
    // When attemptFocus moves focus around to find the focusable element,
    // set this to true so handleTrapFocus doesn't focus the element.
    var ignoreUtilFocusRef = (0, $5b4f0795c5f45c3e$var$_react.useRef)(false);
    var lastFocusRef = (0, $5b4f0795c5f45c3e$var$_react.useRef)(null);
    (0, $5b4f0795c5f45c3e$var$_react.useEffect)(function() {
        var container = ref.current;
        var roots = contextRoots.current;
        var attemptFocus = function attemptFocus(element) {
            // Check if the element is focusable; if not, return false
            if (!$5b4f0795c5f45c3e$var$isFocusable(element)) return false;
            ignoreUtilFocusRef.current = true;
            try {
                element.focus();
            } catch (_unused) {
            // continue regardless of error
            }
            ignoreUtilFocusRef.current = false;
            // Return true if the element is currently the active element or has focus
            return document.activeElement === element;
        };
        var _focusFirstDescendant = function focusFirstDescendant(element) {
            // Iterate through all child nodes of the provided element
            for(var i = 0; i < element.childNodes.length; i += 1){
                var child = element.childNodes[i];
                if (attemptFocus(child) || _focusFirstDescendant(child)) return true;
            }
            // If no focusable child or descendant was found, return false
            return false;
        };
        var _focusLastDescendant = function focusLastDescendant(element) {
            for(var i = element.childNodes.length - 1; i >= 0; i -= 1){
                var child = element.childNodes[i];
                if (attemptFocus(child) || _focusLastDescendant(child)) return true;
            }
            return false;
        };
        var handleTrapFocus = function handleTrapFocus(e) {
            if (!hidden && trapFocus && ignoreUtilFocusRef.current === false && container && // only perform focus if this is the most recently opened drop
            roots[roots.length - 1] === container) {
                if (container.contains(e.target)) lastFocusRef.current = e.target;
                else {
                    _focusFirstDescendant(container);
                    if (lastFocusRef.current === document.activeElement) _focusLastDescendant(container);
                    lastFocusRef.current = document.activeElement;
                }
            }
        };
        // add container to the global roots
        if (container) roots.push(container);
        // Create and insert focusable nodes to help track when focus
        // has left this container but without letting focus be noticeably
        // placed on anything outside the container
        if (!hidden && trapFocus) {
            var preDiv = document.createElement('div');
            var postDiv = document.createElement('div');
            var commonStyles = {
                position: 'absolute',
                height: '1px',
                left: '0',
                right: '0'
            };
            Object.assign(preDiv.style, $5b4f0795c5f45c3e$var$_extends({}, commonStyles, {
                top: '0'
            }));
            Object.assign(postDiv.style, $5b4f0795c5f45c3e$var$_extends({}, commonStyles, {
                bottom: '0'
            }));
            preNodeRef.current = container.parentNode.insertBefore(preDiv, container);
            postNodeRef.current = container.parentNode.insertBefore(postDiv, container.nextSibling);
            preNodeRef.current.tabIndex = 0;
            postNodeRef.current.tabIndex = 0;
        }
        document.addEventListener('focus', handleTrapFocus, true);
        return function() {
            var _preNodeRef$current, _postNodeRef$current;
            // remove from global roots array
            if (roots.includes(container)) roots.splice(roots.indexOf(container), 1);
            document.removeEventListener('focus', handleTrapFocus, true);
            if (roots != null && roots[roots.length - 1]) (0, $4113023f9e0bafa0$exports.makeNodeFocusable)(roots[roots.length - 1]);
            preNodeRef == null || (_preNodeRef$current = preNodeRef.current) == null || _preNodeRef$current.remove();
            postNodeRef == null || (_postNodeRef$current = postNodeRef.current) == null || _postNodeRef$current.remove();
        };
    }, [
        hidden,
        contextRoots,
        trapFocus
    ]);
    (0, $5b4f0795c5f45c3e$var$_react.useEffect)(function() {
        if (bodyOverflowStyle !== 'hidden' && !hidden && restrictScroll && trapFocus) {
            setBodyOverflowStyle(document.body.style.overflow);
            document.body.style.overflow = 'hidden';
        }
        return function() {
            if (bodyOverflowStyle !== 'hidden' && !hidden && restrictScroll && trapFocus) document.body.style.overflow = bodyOverflowStyle;
        };
    }, [
        bodyOverflowStyle,
        hidden,
        trapFocus,
        restrictScroll
    ]);
    (0, $5b4f0795c5f45c3e$var$_react.useEffect)(function() {
        var roots = contextRoots.current;
        var timer = setTimeout(function() {
            if (!hidden && trapFocus) // make every root before this one unfocusable
            roots == null || roots.forEach(function(root, index) {
                if (index < roots.length - 1) (0, $4113023f9e0bafa0$exports.makeNodeUnfocusable)(root);
            });
        }, 0);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        hidden,
        contextRoots,
        trapFocus
    ]);
    var focusedContainer = /*#__PURE__*/ $5b4f0795c5f45c3e$var$_react["default"].createElement("div", $5b4f0795c5f45c3e$var$_extends({
        ref: ref,
        "aria-hidden": hidden
    }, rest), children);
    if (hasRoots) return focusedContainer;
    return(/*#__PURE__*/ // for cases outside of Grommet React tree, manage trapFocus when
    // Drop/Layer opens another Drop/Layer
    $5b4f0795c5f45c3e$var$_react["default"].createElement($f4322a4a0d63b89f$export$1eeeeda725eeeda.Provider, {
        value: contextValue
    }, focusedContainer));
};




var $a125b24653bac357$export$1e511d4a378977f5;
var $a125b24653bac357$export$b726e6b8eaa2acc7;
"use strict";
$a125b24653bac357$export$1e511d4a378977f5 = true;
$a125b24653bac357$export$b726e6b8eaa2acc7 = void 0;

var $a125b24653bac357$var$_styledComponents = $a125b24653bac357$var$_interopRequireWildcard((parcelRequire("iA1nz")));



function $a125b24653bac357$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($a125b24653bac357$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $a125b24653bac357$var$getTransformOriginStyle(align) {
    var vertical = 'top';
    if (align.bottom) vertical = 'bottom';
    var horizontal = 'left';
    if (align.right) horizontal = 'right';
    return vertical + " " + horizontal;
}
var $a125b24653bac357$var$dropKeyFrames = (0, $a125b24653bac357$var$_styledComponents.keyframes)([
    "0%{opacity:0.5;transform:scale(0.8);}100%{opacity:1;transform:scale(1);}"
]);
// The desired margin may be adjusted depending on drops alignment
var $a125b24653bac357$var$marginStyle = function marginStyle(theme, align, data, responsive, marginProp) {
    // NOTE: If marginProp is passed, it overrides the alignment-aware
    //  margin logic and uses the provided value instead.
    var margin = theme.global.edgeSize[data] || data;
    var adjustedMargin = {};
    // if user provides CSS string such as '50px 12px', apply that always
    var customCSS = typeof margin === 'string' && margin.split(' ').length > 1;
    if (theme.global.drop.intelligentMargin === true && !customCSS && typeof margin === 'string') {
        if (align.top === 'bottom') adjustedMargin.top = margin;
        else if (align.bottom === 'top') adjustedMargin.bottom = margin;
        if (align.right === 'left') adjustedMargin.left = "-" + margin;
        else if (align.left === 'right') adjustedMargin.left = margin;
        if (!Object.keys(adjustedMargin)) adjustedMargin = 'none';
    } else return (0, $9a7099e779e83517$export$944a9710f9445eee)('margin', marginProp || theme.global.drop.margin, responsive, theme.global.edgeSize.responsiveBreakpoint, theme);
    return (0, $9a7099e779e83517$export$944a9710f9445eee)('margin', marginProp || adjustedMargin, responsive, theme.global.edgeSize.responsiveBreakpoint, theme);
};
var $a125b24653bac357$var$StyledDrop = $a125b24653bac357$export$b726e6b8eaa2acc7 = (0, $a125b24653bac357$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "StyledDrop",
    componentId: "sc-16s5rx8-0"
})([
    "",
    " ",
    " position:fixed;z-index:",
    ";outline:none;",
    " ",
    " opacity:0;transform-origin:",
    ";animation:",
    " 0.1s forwards;animation-delay:0.01s;@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){display:flex;align-items:stretch;}",
    ""
], $9a7099e779e83517$export$360b744af11007ac, function(props) {
    return !props.plain && (props.round && (0, $9a7099e779e83517$export$98483643daf52539)(props.round, props.responsive || true, props.theme) || "border-radius: " + props.theme.global.drop.border.radius + ";");
}, function(props) {
    return props.theme.global.drop.zIndex;
}, function(props) {
    return !props.plain && (0, $cdcfbcf0f8cd48ba$export$e43a4f0de05cb7e9)(props.background || props.theme.global.drop.background, props.theme);
}, function(props) {
    return !props.plain && (props.margin || props.theme.global.drop.margin) && props.theme.global && $a125b24653bac357$var$marginStyle(props.theme, props.alignProp, props.theme.global.drop.margin, props.responsive, props.margin);
}, function(props) {
    return $a125b24653bac357$var$getTransformOriginStyle(props.alignProp);
}, $a125b24653bac357$var$dropKeyFrames, function(props) {
    return props.theme.global.drop && props.theme.global.drop.extend;
});




var $b7ccb885e3be2f19$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "align",
    "background",
    "onAlign",
    "children",
    "dropTarget",
    "elevation",
    "onClickOutside",
    "onEsc",
    "onKeyDown",
    "overflow",
    "plain",
    "responsive",
    "restrictFocus",
    "stretch",
    "trapFocus"
];
function $b7ccb885e3be2f19$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($b7ccb885e3be2f19$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $b7ccb885e3be2f19$var$_extends() {
    return $b7ccb885e3be2f19$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b7ccb885e3be2f19$var$_extends.apply(null, arguments);
}
function $b7ccb885e3be2f19$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// using react synthetic event to be able to stop propagation that
// would otherwise close the layer on ESC.
var $b7ccb885e3be2f19$var$preventLayerClose = function preventLayerClose(event) {
    var key = event.keyCode ? event.keyCode : event.which;
    if (key === 27) event.stopPropagation();
};
// Gets the closest ancestor positioned element
var $b7ccb885e3be2f19$var$getParentNode = function getParentNode(element) {
    var _element$offsetParent;
    return (_element$offsetParent = element.offsetParent) != null ? _element$offsetParent : element.parentNode;
};
// return the containing block
var $b7ccb885e3be2f19$var$getContainingBlock = function getContainingBlock(element) {
    var currentNode = $b7ccb885e3be2f19$var$getParentNode(element);
    while(currentNode instanceof window.HTMLElement && ![
        'html',
        'body'
    ].includes(currentNode.nodeName.toLowerCase())){
        var _currentNode;
        var css = window.getComputedStyle(currentNode);
        // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if ((css.transform ? css.transform !== 'none' : false) || (css.perspective ? css.perspective !== 'none' : false) || (css.backdropFilter ? css.backdropFilter !== 'none' : false) || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].includes(css.willChange) || css.willChange === 'filter' || (css.filter ? css.filter !== 'none' : false)) return currentNode;
        currentNode = (_currentNode = currentNode) == null ? void 0 : _currentNode.parentNode;
    }
    return null;
};
var $b7ccb885e3be2f19$var$defaultAlign = {
    top: 'top',
    left: 'left'
};
var $b7ccb885e3be2f19$var$DropContainer = $b7ccb885e3be2f19$export$aabdb120602c28c3 = /*#__PURE__*/ (0, $b7ccb885e3be2f19$var$_react.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], _ref$align = _ref.align, align = _ref$align === void 0 ? $b7ccb885e3be2f19$var$defaultAlign : _ref$align, background = _ref.background, onAlign = _ref.onAlign, children = _ref.children, dropTarget = _ref.dropTarget, elevation = _ref.elevation, onClickOutside = _ref.onClickOutside, onEsc = _ref.onEsc, onKeyDown = _ref.onKeyDown, _ref$overflow = _ref.overflow, overflow = _ref$overflow === void 0 ? 'auto' : _ref$overflow, plain = _ref.plain, _ref$responsive = _ref.responsive, responsive = _ref$responsive === void 0 ? true : _ref$responsive, restrictFocus = _ref.restrictFocus, _ref$stretch = _ref.stretch, stretch = _ref$stretch === void 0 ? 'width' : _ref$stretch, trapFocus = _ref.trapFocus, rest = $b7ccb885e3be2f19$var$_objectWithoutPropertiesLoose(_ref, $b7ccb885e3be2f19$var$_excluded);
    var containerTarget = (0, $b7ccb885e3be2f19$var$_react.useContext)($9055da357324b5ab$export$64a849364cd772b4);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    // dropOptions was created to preserve backwards compatibility
    var _useContext = (0, $b7ccb885e3be2f19$var$_react.useContext)($cddec80c12094a96$export$b709306b005c3ef), dropOptions = _useContext.drop;
    var portalContext = (0, $b7ccb885e3be2f19$var$_react.useContext)($4113023f9e0bafa0$exports.PortalContext);
    var portalId = (0, $b7ccb885e3be2f19$var$_react.useMemo)(function() {
        return portalContext.length;
    }, [
        portalContext
    ]);
    var nextPortalContext = (0, $b7ccb885e3be2f19$var$_react.useMemo)(function() {
        return [].concat(portalContext, [
            portalId
        ]);
    }, [
        portalContext,
        portalId
    ]);
    var dropRef = (0, $4113023f9e0bafa0$exports.useForwardedRef)(ref);
    (0, $b7ccb885e3be2f19$var$_react.useEffect)(function() {
        var onClickDocument = function onClickDocument(event) {
            // determine which portal id the target is in, if any
            var clickedPortalId = null;
            var node = event.composed && event.composedPath()[0] || event.target;
            while(clickedPortalId === null && node && node !== document && !(node instanceof ShadowRoot)){
                var attr = node.getAttribute('data-g-portal-id');
                if (attr !== null) clickedPortalId = parseInt(attr, 10);
                node = node.parentNode;
            }
            // Check if the click happened within the dropTarget
            var clickInsideDropTarget = (dropTarget == null ? void 0 : dropTarget.current) && dropTarget.current.contains(event.target) || dropTarget && typeof dropTarget.contains === 'function' && dropTarget.contains(event.target);
            if (!clickInsideDropTarget && clickedPortalId === null || portalContext.indexOf(clickedPortalId) !== -1) onClickOutside(event);
        };
        if (onClickOutside) document.addEventListener('mousedown', onClickDocument);
        return function() {
            if (onClickOutside) document.removeEventListener('mousedown', onClickDocument);
        };
    }, [
        onClickOutside,
        containerTarget,
        portalContext,
        dropTarget
    ]);
    (0, $b7ccb885e3be2f19$var$_react.useEffect)(function() {
        var target = (dropTarget == null ? void 0 : dropTarget.current) || dropTarget;
        var notifyAlign = function notifyAlign() {
            var _dropRef$current;
            var styleCurrent = dropRef == null || (_dropRef$current = dropRef.current) == null ? void 0 : _dropRef$current.style;
            var alignControl = (styleCurrent == null ? void 0 : styleCurrent.top) !== '' ? 'top' : 'bottom';
            onAlign(alignControl);
        };
        // We try to preserve the maxHeight as changing it causes any scroll
        // position to be lost. We set the maxHeight on mount and if the window
        // is resized.
        var place = function place(preserveHeight) {
            var windowWidth = window.innerWidth;
            var windowHeight = window.innerHeight;
            var container = dropRef.current;
            if (container && target) {
                var _containingBlockRect$, _containingBlockRect, _containingBlockRect$2, _containingBlockRect2, _containingBlockRect$3, _containingBlockRect3, _containingBlock$scro, _containingBlock2, _containingBlock$scro2, _containingBlock3;
                // clear prior styling
                container.style.left = '';
                container.style.top = '';
                container.style.bottom = '';
                container.style.width = '';
                if (!preserveHeight) container.style.maxHeight = '';
                // get bounds
                var targetRect = target.getBoundingClientRect();
                var containerRect = container.getBoundingClientRect();
                // determine width
                var width;
                if (stretch) width = Math.min(stretch === 'align' ? Math.min(targetRect.width, containerRect.width) : Math.max(targetRect.width, containerRect.width), windowWidth);
                else width = Math.min(containerRect.width, windowWidth);
                // set left position
                var left;
                if (align.left) {
                    if (align.left === 'left') left = targetRect.left;
                    else if (align.left === 'right') left = targetRect.left + targetRect.width;
                } else if (align.right) {
                    if (align.right === 'left') left = targetRect.left - width;
                    else if (align.right === 'right') left = targetRect.left + targetRect.width - width;
                } else left = targetRect.left + targetRect.width / 2 - width / 2;
                if (left + width > windowWidth) left -= left + width - windowWidth;
                else if (left < 0) left = 0;
                // set top or bottom position
                var top;
                var bottom;
                var maxHeight = containerRect.height;
                /* If responsive is true and the Drop doesn't have enough room
          to be fully visible and there is more room in the other
          direction, change the Drop to display above/below. If neither
          direction has enough room for the full Drop, prefer the side
          with more available space rather than clamping to the side
          originally requested. */ if (responsive && // drop is above target
                align.bottom === 'top' && // drop is overflowing above window
                targetRect.top - containerRect.height <= 0 && // there is room to display the drop below the target
                targetRect.bottom + containerRect.height < windowHeight) {
                    // top of drop is aligned to bottom of target
                    top = targetRect.bottom;
                    maxHeight = top;
                } else if (responsive && // top of drop is aligned to top of target
                align.top === 'top' && // drop is overflowing below window
                targetRect.top + containerRect.height >= windowHeight && // height of the drop is larger than the target.
                targetRect.top + containerRect.height > targetRect.bottom && // there is room to display the drop above the target
                targetRect.bottom - containerRect.height > 0) {
                    // bottom of drop is aligned to bottom of target
                    bottom = targetRect.bottom;
                    maxHeight = top;
                } else if (responsive && // top of drop is aligned to bottom of target
                align.top === 'bottom' && // drop is overflowing below window
                targetRect.bottom + containerRect.height >= windowHeight && // there is room to display the drop above the target
                targetRect.top - containerRect.height > 0) {
                    // bottom of drop is aligned to top of target
                    bottom = targetRect.top;
                    maxHeight = bottom;
                } else if (responsive && // bottom of drop is aligned to bottom of target
                align.bottom === 'bottom' && // drop is overflowing above window
                targetRect.bottom - containerRect.height <= 0 && // height of the drop is larger than the target.
                targetRect.bottom - containerRect.height > targetRect.top && // there is room to display the drop below the target
                targetRect.top + containerRect.height > 0) {
                    // top of drop is aligned to top of target
                    top = targetRect.top;
                    maxHeight = bottom;
                } else if (responsive && // top of drop is aligned to bottom of target (open below)
                align.top === 'bottom' && // drop is overflowing below window
                targetRect.bottom + containerRect.height >= windowHeight && // the flip anchor (target's top) is on-screen — otherwise
                // flipping pins the drop's bottom off-screen
                targetRect.top > 0 && // there is more room above the target than below it — neither
                // side fits the full drop, so prefer the larger side rather
                // than clamping to the smaller requested side.
                targetRect.top > windowHeight - targetRect.bottom) {
                    // bottom of drop is aligned to top of target
                    bottom = targetRect.top;
                    maxHeight = bottom;
                } else if (responsive && // top of drop is aligned to top of target (open below)
                align.top === 'top' && // drop is overflowing below window
                targetRect.top + containerRect.height >= windowHeight && // height of the drop is larger than the target — otherwise the
                // drop already fits inside the target's vertical span and a
                // flip would pin its bottom to a potentially off-screen
                // target.bottom (mirrors the safety in branch #2 above).
                targetRect.top + containerRect.height > targetRect.bottom && // there is more room above the target than below it
                targetRect.bottom > windowHeight - targetRect.top) {
                    // bottom of drop is aligned to bottom of target
                    bottom = targetRect.bottom;
                    maxHeight = bottom;
                } else if (responsive && // bottom of drop is aligned to top of target (open above)
                align.bottom === 'top' && // drop is overflowing above window
                targetRect.top - containerRect.height <= 0 && // the flip anchor (target's bottom) is on-screen
                targetRect.bottom < windowHeight && // there is more room below the target than above it
                windowHeight - targetRect.bottom > targetRect.top) {
                    // top of drop is aligned to bottom of target
                    top = targetRect.bottom;
                    maxHeight = windowHeight - top;
                } else if (responsive && // bottom of drop is aligned to bottom of target (open above)
                align.bottom === 'bottom' && // drop is overflowing above window
                targetRect.bottom - containerRect.height <= 0 && // height of the drop is larger than the target (mirrors the
                // safety in branch #4 above)
                targetRect.bottom - containerRect.height < targetRect.top && // there is more room below the target than above it
                windowHeight - targetRect.top > targetRect.bottom) {
                    // top of drop is aligned to top of target
                    top = targetRect.top;
                    maxHeight = windowHeight - top;
                } else if (align.top === 'top') {
                    top = targetRect.top;
                    maxHeight = windowHeight - top;
                } else if (align.top === 'bottom') {
                    top = targetRect.bottom;
                    maxHeight = windowHeight - top;
                } else if (align.bottom === 'top') {
                    bottom = targetRect.top;
                    maxHeight = bottom;
                } else if (align.bottom === 'bottom') {
                    bottom = targetRect.bottom;
                    maxHeight = bottom;
                } else top = targetRect.top + targetRect.height / 2 - containerRect.height / 2;
                var containingBlock;
                var containingBlockRect;
                // dropOptions was created to preserve backwards compatibility
                if (dropOptions != null && dropOptions.checkContainingBlock) {
                    var _containingBlock;
                    // return the containing block for absolute elements or `null`
                    // for fixed elements
                    containingBlock = $b7ccb885e3be2f19$var$getContainingBlock(container);
                    containingBlockRect = (_containingBlock = containingBlock) == null ? void 0 : _containingBlock.getBoundingClientRect();
                }
                // compute viewport offsets
                var viewportOffsetLeft = (_containingBlockRect$ = (_containingBlockRect = containingBlockRect) == null ? void 0 : _containingBlockRect.left) != null ? _containingBlockRect$ : 0;
                var viewportOffsetTop = (_containingBlockRect$2 = (_containingBlockRect2 = containingBlockRect) == null ? void 0 : _containingBlockRect2.top) != null ? _containingBlockRect$2 : 0;
                var viewportOffsetBottom = (_containingBlockRect$3 = (_containingBlockRect3 = containingBlockRect) == null ? void 0 : _containingBlockRect3.bottom) != null ? _containingBlockRect$3 : windowHeight;
                var containerOffsetLeft = (_containingBlock$scro = (_containingBlock2 = containingBlock) == null ? void 0 : _containingBlock2.scrollLeft) != null ? _containingBlock$scro : 0;
                var containerOffsetTop = (_containingBlock$scro2 = (_containingBlock3 = containingBlock) == null ? void 0 : _containingBlock3.scrollTop) != null ? _containingBlock$scro2 : 0;
                container.style.left = left - viewportOffsetLeft + containerOffsetLeft + "px";
                if (stretch) // offset width by 0.1 to avoid a bug in ie11 that
                // unnecessarily wraps the text if width is the same
                // NOTE: turned off for now
                container.style.width = width + 0.1 + "px";
                // the (position:absolute + scrollTop)
                // is presenting issues with desktop scroll flickering
                if (top !== '') container.style.top = top - viewportOffsetTop + containerOffsetTop + "px";
                if (bottom !== '') container.style.bottom = viewportOffsetBottom - bottom - containerOffsetTop + "px";
                if (!preserveHeight) {
                    if (theme.drop && theme.drop.maxHeight) maxHeight = Math.min(maxHeight, (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.drop.maxHeight));
                    container.style.maxHeight = maxHeight + "px";
                }
            }
            if (onAlign) notifyAlign();
        };
        var scrollParents;
        var addScrollListeners = function addScrollListeners() {
            scrollParents = (0, $4113023f9e0bafa0$exports.findScrollParents)(target);
            scrollParents.forEach(function(scrollParent) {
                return scrollParent.addEventListener('scroll', place);
            });
        };
        var removeScrollListeners = function removeScrollListeners() {
            scrollParents.forEach(function(scrollParent) {
                return scrollParent.removeEventListener('scroll', place);
            });
            scrollParents = [];
        };
        var onResize = function onResize() {
            removeScrollListeners();
            addScrollListeners();
            place(false);
        };
        addScrollListeners();
        window.addEventListener('resize', onResize);
        place(false);
        return function() {
            removeScrollListeners();
            window.removeEventListener('resize', onResize);
        };
    }, [
        align,
        containerTarget,
        onAlign,
        dropTarget,
        portalContext,
        portalId,
        responsive,
        restrictFocus,
        stretch,
        theme.drop,
        dropRef,
        dropOptions
    ]);
    // Once drop is open the focus will be put on the drop container
    // if restrictFocus is true. If the caller put focus
    // on an element already, we honor that. Otherwise, we put
    // the focus on the drop container.
    (0, $b7ccb885e3be2f19$var$_react.useEffect)(function() {
        if (restrictFocus) {
            var dropContainer = dropRef.current;
            if (dropContainer) {
                if (!dropContainer.contains(document.activeElement)) dropContainer.focus();
            }
        }
    }, [
        dropRef,
        restrictFocus
    ]);
    var content = /*#__PURE__*/ $b7ccb885e3be2f19$var$_react["default"].createElement($a125b24653bac357$export$b726e6b8eaa2acc7, $b7ccb885e3be2f19$var$_extends({
        "aria-label": a11yTitle || ariaLabel,
        ref: dropRef,
        background: background,
        plain: plain,
        elevation: !plain ? elevation || theme.global.drop.elevation || theme.global.drop.shadowSize || // backward compatibility
        'small' : undefined,
        tabIndex: "-1",
        alignProp: align,
        overflow: overflow,
        "data-g-portal-id": portalId
    }, passThemeFlag, rest), children);
    var themeContextValue = (0, $b7ccb885e3be2f19$var$_react.useMemo)(function() {
        var dark;
        if (background || theme.global.drop.background) dark = (0, $4113023f9e0bafa0$exports.backgroundIsDark)(background || theme.global.drop.background, theme);
        return $b7ccb885e3be2f19$var$_extends({}, theme, {
            dark: dark
        });
    }, [
        background,
        theme
    ]);
    var dark = themeContextValue.dark;
    if (dark !== undefined && dark !== theme.dark) content = /*#__PURE__*/ $b7ccb885e3be2f19$var$_react["default"].createElement($iA1nz.ThemeContext.Provider, {
        value: themeContextValue
    }, content);
    return /*#__PURE__*/ $b7ccb885e3be2f19$var$_react["default"].createElement($4113023f9e0bafa0$exports.PortalContext.Provider, {
        value: nextPortalContext
    }, /*#__PURE__*/ $b7ccb885e3be2f19$var$_react["default"].createElement($5b4f0795c5f45c3e$export$b0cd6833c93fb94d, {
        onKeyDown: onEsc && $b7ccb885e3be2f19$var$preventLayerClose,
        trapFocus: trapFocus
    }, /*#__PURE__*/ $b7ccb885e3be2f19$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        capture: true,
        onEsc: onEsc ? function(event) {
            event.stopPropagation();
            onEsc(event);
        } : undefined,
        onKeyDown: onKeyDown,
        target: "document"
    }, content)));
});



var $1c3689ed9fe825cd$export$1e511d4a378977f5;
var $1c3689ed9fe825cd$export$9863f458227ea225;
"use strict";
$1c3689ed9fe825cd$export$1e511d4a378977f5 = true;
$1c3689ed9fe825cd$export$9863f458227ea225 = void 0;

var $1c3689ed9fe825cd$var$_propTypes = $1c3689ed9fe825cd$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $1c3689ed9fe825cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
// if you update values here, make sure to update in Box too.
var $1c3689ed9fe825cd$var$dropOverflowPropTypes = $1c3689ed9fe825cd$var$_propTypes["default"].oneOfType([
    $1c3689ed9fe825cd$var$_propTypes["default"].oneOf($5897bd367fbd90c1$export$5b49d53be3c37c69),
    $1c3689ed9fe825cd$var$_propTypes["default"].shape({
        horizontal: $1c3689ed9fe825cd$var$_propTypes["default"].oneOf($5897bd367fbd90c1$export$5b49d53be3c37c69),
        vertical: $1c3689ed9fe825cd$var$_propTypes["default"].oneOf($5897bd367fbd90c1$export$5b49d53be3c37c69)
    }),
    $1c3689ed9fe825cd$var$_propTypes["default"].string
]);
var $1c3689ed9fe825cd$var$PropType = {};
$1c3689ed9fe825cd$var$PropType = {
    align: $1c3689ed9fe825cd$var$_propTypes["default"].shape({
        top: $1c3689ed9fe825cd$var$_propTypes["default"].oneOf([
            'top',
            'bottom'
        ]),
        bottom: $1c3689ed9fe825cd$var$_propTypes["default"].oneOf([
            'top',
            'bottom'
        ]),
        right: $1c3689ed9fe825cd$var$_propTypes["default"].oneOf([
            'left',
            'right'
        ]),
        left: $1c3689ed9fe825cd$var$_propTypes["default"].oneOf([
            'left',
            'right'
        ])
    }),
    background: $5897bd367fbd90c1$export$aa372966d47f02af,
    elevation: $1c3689ed9fe825cd$var$_propTypes["default"].oneOfType([
        $1c3689ed9fe825cd$var$_propTypes["default"].oneOf([
            'none',
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        $1c3689ed9fe825cd$var$_propTypes["default"].string
    ]),
    inline: $1c3689ed9fe825cd$var$_propTypes["default"].bool,
    margin: $5897bd367fbd90c1$export$7ece648387045365,
    onClickOutside: $1c3689ed9fe825cd$var$_propTypes["default"].func,
    onEsc: $1c3689ed9fe825cd$var$_propTypes["default"].func,
    overflow: $1c3689ed9fe825cd$var$dropOverflowPropTypes,
    plain: $1c3689ed9fe825cd$var$_propTypes["default"].bool,
    responsive: $1c3689ed9fe825cd$var$_propTypes["default"].bool,
    restrictFocus: $1c3689ed9fe825cd$var$_propTypes["default"].bool,
    round: $5897bd367fbd90c1$export$fcb8c87299e05542,
    stretch: $1c3689ed9fe825cd$var$_propTypes["default"].oneOfType([
        $1c3689ed9fe825cd$var$_propTypes["default"].bool,
        $1c3689ed9fe825cd$var$_propTypes["default"].oneOf([
            'align'
        ])
    ]),
    target: $1c3689ed9fe825cd$var$_propTypes["default"].object.isRequired,
    trapFocus: $1c3689ed9fe825cd$var$_propTypes["default"].bool
};
var $1c3689ed9fe825cd$var$DropPropTypes = $1c3689ed9fe825cd$export$9863f458227ea225 = $1c3689ed9fe825cd$var$PropType;



var $6a7412d1389f6c64$var$_excluded = [
    "inline",
    "restrictFocus",
    "target",
    "trapFocus"
];
function $6a7412d1389f6c64$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($6a7412d1389f6c64$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $6a7412d1389f6c64$var$_extends() {
    return $6a7412d1389f6c64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6a7412d1389f6c64$var$_extends.apply(null, arguments);
}
function $6a7412d1389f6c64$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $6a7412d1389f6c64$var$Drop = $6a7412d1389f6c64$export$aaa698cd7aa517d6 = /*#__PURE__*/ (0, $6a7412d1389f6c64$var$_react.forwardRef)(function(_ref, ref) {
    var inline = _ref.inline, restrictFocus = _ref.restrictFocus, dropTarget = _ref.target, _ref$trapFocus = _ref.trapFocus, trapFocus = _ref$trapFocus === void 0 ? true : _ref$trapFocus, rest = $6a7412d1389f6c64$var$_objectWithoutPropertiesLoose(_ref, $6a7412d1389f6c64$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useState = (0, $6a7412d1389f6c64$var$_react.useState)(), originalFocusedElement = _useState[0], setOriginalFocusedElement = _useState[1];
    (0, $6a7412d1389f6c64$var$_react.useEffect)(function() {
        return setOriginalFocusedElement(document.activeElement);
    }, []);
    var _useState2 = (0, $6a7412d1389f6c64$var$_react.useState)(), dropContainer = _useState2[0], setDropContainer = _useState2[1];
    var containerTarget = (0, $6a7412d1389f6c64$var$_react.useContext)($9055da357324b5ab$export$64a849364cd772b4);
    var containerChildNodesLength = (0, $6a7412d1389f6c64$var$_react.useRef)(null);
    (0, $6a7412d1389f6c64$var$_react.useEffect)(function() {
        // we need this condition to prevent getNewContainer to run multiple times
        // in the event that the component gets created, destroyed, and recreated.
        // see https://reactjs.org/docs/strict-mode.html#ensuring-reusable-state
        if (!(containerChildNodesLength != null && containerChildNodesLength.current)) {
            containerChildNodesLength.current = containerTarget.childNodes.length;
            setDropContainer(!inline ? (0, $4113023f9e0bafa0$exports.getNewContainer)(containerTarget) : undefined);
        }
    }, [
        containerTarget,
        inline
    ]);
    // just a few things to clean up when the Drop is unmounted
    (0, $6a7412d1389f6c64$var$_react.useEffect)(function() {
        return function() {
            if (restrictFocus && originalFocusedElement) {
                if (originalFocusedElement.focus) (0, $4113023f9e0bafa0$exports.setFocusWithoutScroll)(originalFocusedElement);
                else if (originalFocusedElement.parentNode && originalFocusedElement.parentNode.focus) // required for IE11 and Edge
                (0, $4113023f9e0bafa0$exports.setFocusWithoutScroll)(originalFocusedElement.parentNode);
            }
            if (dropContainer) containerTarget.removeChild(dropContainer);
        };
    }, [
        containerTarget,
        dropContainer,
        originalFocusedElement,
        restrictFocus
    ]);
    var content = /*#__PURE__*/ $6a7412d1389f6c64$var$_react["default"].createElement($b7ccb885e3be2f19$export$aabdb120602c28c3, $6a7412d1389f6c64$var$_extends({
        ref: ref,
        dir: theme && theme.dir,
        dropTarget: dropTarget,
        restrictFocus: restrictFocus,
        trapFocus: trapFocus
    }, rest));
    if (inline) return content;
    if (dropContainer) return /*#__PURE__*/ (0, $cX5wj.createPortal)(content, dropContainer);
    return null;
});
$6a7412d1389f6c64$var$Drop.displayName = 'Drop';
$6a7412d1389f6c64$var$Drop.propTypes = $1c3689ed9fe825cd$export$9863f458227ea225;


$9097252a6690f3a9$export$aaa698cd7aa517d6 = $6a7412d1389f6c64$export$aaa698cd7aa517d6;




var $a8fb2a9e8870536e$export$1e511d4a378977f5;
var $a8fb2a9e8870536e$export$475ce0081ee75899;
"use strict";
$a8fb2a9e8870536e$export$1e511d4a378977f5 = true;
$a8fb2a9e8870536e$export$475ce0081ee75899 = void 0;

var $a8fb2a9e8870536e$var$_propTypes = $a8fb2a9e8870536e$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $a8fb2a9e8870536e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $a8fb2a9e8870536e$var$PropType = {};
$a8fb2a9e8870536e$var$PropType = {
    content: $a8fb2a9e8870536e$var$_propTypes["default"].node,
    dropProps: $a8fb2a9e8870536e$var$_propTypes["default"].object,
    plain: $a8fb2a9e8870536e$var$_propTypes["default"].bool,
    defaultVisible: $a8fb2a9e8870536e$var$_propTypes["default"].bool
};
var $a8fb2a9e8870536e$var$TipPropTypes = $a8fb2a9e8870536e$export$475ce0081ee75899 = $a8fb2a9e8870536e$var$PropType;



function $7f82531467bce456$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($7f82531467bce456$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $7f82531467bce456$var$_extends() {
    return $7f82531467bce456$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7f82531467bce456$var$_extends.apply(null, arguments);
}
/*
 * This function getReactNodeRef is adapted from
 * [Material UI] (https://github.com/mui/material-ui)
 * Licensed under the MIT License (c) 2024 aarongarciah
 * The function has been modified from its original version.
 */ var $7f82531467bce456$var$getReactNodeRef = function getReactNodeRef(element) {
    if (!element || !/*#__PURE__*/ $7f82531467bce456$var$_react["default"].isValidElement(element)) return null;
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to
    // children in older versions
    return ({}).propertyIsEnumerable.call(element.props, 'ref') ? element.props.ref : element.ref;
};
var $7f82531467bce456$var$Tip = $7f82531467bce456$export$c92c6401b52a9298 = /*#__PURE__*/ (0, $7f82531467bce456$var$_react.forwardRef)(function(_ref, tipRef) {
    var children = _ref.children, content = _ref.content, _ref$defaultVisible = _ref.defaultVisible, defaultVisible = _ref$defaultVisible === void 0 ? false : _ref$defaultVisible, dropProps = _ref.dropProps, plain = _ref.plain;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useState = (0, $7f82531467bce456$var$_react.useState)(false), over = _useState[0], setOver = _useState[1];
    var _useState2 = (0, $7f82531467bce456$var$_react.useState)(false), tooltipOver = _useState2[0], setTooltipOver = _useState2[1];
    var usingKeyboard = (0, $4113023f9e0bafa0$exports.useKeyboard)();
    var componentRef = (0, $4113023f9e0bafa0$exports.useForwardedRef)(tipRef);
    // Three use case for children
    // 1. Tip has a single child + it is a React Element => Great!
    // 2. Tip has a single child +  not React Element =>
    // span will wrap the child so we can use ref and events.
    // 3. Tip has more than one child => Abort, display Children.only error
    var child = $7f82531467bce456$var$_react.Children.count(children) <= 1 && !/*#__PURE__*/ $7f82531467bce456$var$_react["default"].isValidElement(children) && /*#__PURE__*/ $7f82531467bce456$var$_react["default"].createElement("span", null, children) || $7f82531467bce456$var$_react.Children.only(children);
    var clonedChild = /*#__PURE__*/ (0, $7f82531467bce456$var$_react.cloneElement)(child, {
        onMouseEnter: function onMouseEnter(event) {
            var _child$props;
            setOver(true);
            if ((_child$props = child.props) != null && _child$props.onMouseEnter) child.props.onMouseEnter(event);
        },
        onMouseLeave: function onMouseLeave(event) {
            var _child$props2;
            setOver(false);
            if ((_child$props2 = child.props) != null && _child$props2.onMouseLeave) child.props.onMouseLeave(event);
        },
        onFocus: function onFocus(event) {
            var _child$props3;
            if (usingKeyboard) setOver(true);
            if ((_child$props3 = child.props) != null && _child$props3.onFocus) child.props.onFocus(event);
        },
        onBlur: function onBlur(event) {
            var _child$props4;
            if (usingKeyboard) setOver(false);
            if ((_child$props4 = child.props) != null && _child$props4.onBlur) child.props.onBlur(event);
        },
        key: 'tip-child',
        ref: function ref(node) {
            // https://github.com/facebook/react/issues/8873#issuecomment-287873307
            if (typeof componentRef === 'function') componentRef(node);
            else if (componentRef) componentRef.current = node;
            // Call the original ref, if any
            var callerRef = $7f82531467bce456$var$getReactNodeRef(child);
            if (typeof callerRef === 'function') callerRef(node);
            else if (callerRef) callerRef.current = node;
        }
    });
    (0, $7f82531467bce456$var$_react.useEffect)(function() {
        setOver(defaultVisible);
    }, [
        defaultVisible
    ]);
    return [
        clonedChild,
        (over || tooltipOver) && /*#__PURE__*/ $7f82531467bce456$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
            key: "tip-keyboard",
            onEsc: function onEsc() {
                setOver(false);
                setTooltipOver(false);
            }
        }, /*#__PURE__*/ $7f82531467bce456$var$_react["default"].createElement($9097252a6690f3a9$export$aaa698cd7aa517d6, $7f82531467bce456$var$_extends({
            target: componentRef.current,
            trapFocus: false,
            key: "tip-drop"
        }, theme.tip.drop, dropProps, {
            onMouseEnter: function onMouseEnter() {
                return setTooltipOver(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setTooltipOver(false);
            }
        }), plain ? content : /*#__PURE__*/ $7f82531467bce456$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, theme.tip.content, content)))
    ];
});
$7f82531467bce456$var$Tip.displayName = 'Tip';
$7f82531467bce456$var$Tip.propTypes = $a8fb2a9e8870536e$export$475ce0081ee75899;


$7946e73be6fde87a$export$c92c6401b52a9298 = $7f82531467bce456$export$c92c6401b52a9298;


var $8d3bd995936cfd81$export$1e511d4a378977f5;
var $8d3bd995936cfd81$export$37acb3580601e69a;
"use strict";
$8d3bd995936cfd81$export$1e511d4a378977f5 = true;
$8d3bd995936cfd81$export$37acb3580601e69a = void 0;

var $8d3bd995936cfd81$var$_react = $8d3bd995936cfd81$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $8d3bd995936cfd81$var$_styledComponents = $8d3bd995936cfd81$var$_interopRequireDefault((parcelRequire("iA1nz")));

var $6a5275ec792307a1$export$1e511d4a378977f5;
var $6a5275ec792307a1$export$e5c5a5f917a5871c;
var $6a5275ec792307a1$export$2e2bcd8739ae039;
"use strict";
$6a5275ec792307a1$export$1e511d4a378977f5 = true;
$6a5275ec792307a1$export$e5c5a5f917a5871c = $6a5275ec792307a1$export$2e2bcd8739ae039 = void 0;

var $2xPiy = parcelRequire("2xPiy");
/* eslint-disable no-restricted-imports */ /**
 * A substitute for React's useLayoutEffect, which does not generate warnings on
 * SSR. It is named useLayoutEffect so that all eslint rules applying to the
 * original useLayoutEffect would also apply to it.
 * This solution was suggested by Alex Reardon.
 * @see https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a
 * @see https://github.com/grommet/grommet/issues/4765
 */ var $6a5275ec792307a1$var$useLayoutEffect = $6a5275ec792307a1$export$e5c5a5f917a5871c = typeof window !== 'undefined' ? $2xPiy.useLayoutEffect : $2xPiy.useEffect;
var $6a5275ec792307a1$var$_default = $6a5275ec792307a1$export$2e2bcd8739ae039 = $6a5275ec792307a1$var$useLayoutEffect;



var $8c60273918bcf71f$exports = {};

$parcel$export($8c60273918bcf71f$exports, "__esModule", function () { return $8c60273918bcf71f$export$1e511d4a378977f5; }, function (v) { return $8c60273918bcf71f$export$1e511d4a378977f5 = v; });
$parcel$export($8c60273918bcf71f$exports, "Stack", function () { return $8c60273918bcf71f$export$694e0d28c7ffc90c; }, function (v) { return $8c60273918bcf71f$export$694e0d28c7ffc90c = v; });
var $8c60273918bcf71f$export$1e511d4a378977f5;
var $8c60273918bcf71f$export$694e0d28c7ffc90c;
"use strict";
$8c60273918bcf71f$export$1e511d4a378977f5 = true;
$8c60273918bcf71f$export$694e0d28c7ffc90c = void 0;
var $6bf62d63c2cc8b3a$export$1e511d4a378977f5;
var $6bf62d63c2cc8b3a$export$694e0d28c7ffc90c;
"use strict";
$6bf62d63c2cc8b3a$export$1e511d4a378977f5 = true;
$6bf62d63c2cc8b3a$export$694e0d28c7ffc90c = void 0;

var $6bf62d63c2cc8b3a$var$_react = $6bf62d63c2cc8b3a$var$_interopRequireWildcard((parcelRequire("2xPiy")));
var $798bf802fedde553$export$1e511d4a378977f5;
var $798bf802fedde553$export$5946a5a83aaaa916;
var $798bf802fedde553$export$8a7fb03b17c12e52;
"use strict";
$798bf802fedde553$export$1e511d4a378977f5 = true;
$798bf802fedde553$export$5946a5a83aaaa916 = $798bf802fedde553$export$8a7fb03b17c12e52 = void 0;

var $798bf802fedde553$var$_styledComponents = $798bf802fedde553$var$_interopRequireWildcard((parcelRequire("iA1nz")));

function $798bf802fedde553$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($798bf802fedde553$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $798bf802fedde553$var$fillStyle = (0, $798bf802fedde553$var$_styledComponents.css)([
    "",
    " ",
    " flex-grow:1;display:flex;"
], function(props) {
    return props.fillContainer === true || props.fillContainer === 'horizontal' ? "\n        width: 100%;\n        max-width: none;\n      " : '';
}, function(props) {
    return props.fillContainer === true || props.fillContainer === 'vertical' ? 'height: 100%;' : '';
});
var $798bf802fedde553$var$StyledStack = $798bf802fedde553$export$8a7fb03b17c12e52 = $798bf802fedde553$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledStack",
    componentId: "sc-ajspsk-0"
})([
    "position:relative;",
    " ",
    " ",
    ""
], $4113023f9e0bafa0$exports.genericStyles, function(props) {
    return props.fillContainer && $798bf802fedde553$var$fillStyle;
}, function(props) {
    return props.theme.stack && props.theme.stack.extend;
});
var $798bf802fedde553$var$styleMap = {
    fill: "\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n  ",
    center: "\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  ",
    left: "\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n  ",
    right: "\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n  ",
    top: "\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n  ",
    bottom: "\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n  ",
    'top-left': "\n    top: 0;\n    left: 0;\n  ",
    'bottom-left': "\n    bottom: 0;\n    left: 0;\n  ",
    'top-right': "\n    top: 0;\n    right: 0;\n  ",
    'bottom-right': "\n    bottom: 0;\n    right: 0;\n  "
};
var $798bf802fedde553$var$StyledStackLayer = $798bf802fedde553$export$5946a5a83aaaa916 = $798bf802fedde553$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledStack__StyledStackLayer",
    componentId: "sc-ajspsk-1"
})([
    "position:",
    ";",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return props.guiding ? 'relative' : 'absolute';
}, function(props) {
    return props.guiding && 'display: block;';
}, function(props) {
    return !props.guiding && $798bf802fedde553$var$styleMap[props.anchor || 'fill'] + ";";
}, function(props) {
    return props.fillContainer && "\n    width: 100%;\n    height: 100%;\n  ";
}, function(props) {
    return !props.interactive && "pointer-events: none;";
});


var $7e46d051fd89407e$export$1e511d4a378977f5;
var $7e46d051fd89407e$export$ae929f3c1850d7bc;
"use strict";
$7e46d051fd89407e$export$1e511d4a378977f5 = true;
$7e46d051fd89407e$export$ae929f3c1850d7bc = void 0;

var $7e46d051fd89407e$var$_propTypes = $7e46d051fd89407e$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $7e46d051fd89407e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $7e46d051fd89407e$var$_extends() {
    return $7e46d051fd89407e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7e46d051fd89407e$var$_extends.apply(null, arguments);
}
var $7e46d051fd89407e$var$PropType = {};
$7e46d051fd89407e$var$PropType = $7e46d051fd89407e$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    anchor: $7e46d051fd89407e$var$_propTypes["default"].oneOf([
        'center',
        'left',
        'right',
        'top',
        'bottom',
        'top-left',
        'bottom-left',
        'top-right',
        'bottom-right'
    ]),
    fill: $7e46d051fd89407e$var$_propTypes["default"].oneOfType([
        $7e46d051fd89407e$var$_propTypes["default"].oneOf([
            'horizontal',
            'vertical'
        ]),
        $7e46d051fd89407e$var$_propTypes["default"].bool
    ]),
    guidingChild: $7e46d051fd89407e$var$_propTypes["default"].oneOfType([
        $7e46d051fd89407e$var$_propTypes["default"].number,
        $7e46d051fd89407e$var$_propTypes["default"].oneOf([
            'first',
            'last'
        ])
    ]),
    interactiveChild: $7e46d051fd89407e$var$_propTypes["default"].oneOfType([
        $7e46d051fd89407e$var$_propTypes["default"].number,
        $7e46d051fd89407e$var$_propTypes["default"].oneOf([
            'first',
            'last'
        ])
    ])
});
var $7e46d051fd89407e$var$StackPropTypes = $7e46d051fd89407e$export$ae929f3c1850d7bc = $7e46d051fd89407e$var$PropType;



var $6bf62d63c2cc8b3a$var$_excluded = [
    "anchor",
    "children",
    "fill",
    "guidingChild",
    "interactiveChild"
];
function $6bf62d63c2cc8b3a$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($6bf62d63c2cc8b3a$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $6bf62d63c2cc8b3a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $6bf62d63c2cc8b3a$var$_extends() {
    return $6bf62d63c2cc8b3a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6bf62d63c2cc8b3a$var$_extends.apply(null, arguments);
}
var $6bf62d63c2cc8b3a$var$buildStyledChildren = function buildStyledChildren(_ref) {
    var anchor = _ref.anchor, fill = _ref.fill, guidingIndex = _ref.guidingIndex, interactiveChild = _ref.interactiveChild, interactiveIndex = _ref.interactiveIndex;
    return function(child, index) {
        var interactive = interactiveChild === undefined || interactiveIndex === index;
        var isGuidingIndex = index === guidingIndex;
        var props = isGuidingIndex ? {
            guiding: true,
            fillContainer: fill
        } : {
            anchor: anchor
        };
        return /*#__PURE__*/ $6bf62d63c2cc8b3a$var$_react["default"].createElement($798bf802fedde553$export$5946a5a83aaaa916, $6bf62d63c2cc8b3a$var$_extends({
            key: index,
            interactive: interactive
        }, props), child);
    };
};
var $6bf62d63c2cc8b3a$var$Stack = $6bf62d63c2cc8b3a$export$694e0d28c7ffc90c = /*#__PURE__*/ (0, $6bf62d63c2cc8b3a$var$_react.forwardRef)(function(_ref2, ref) {
    var anchor = _ref2.anchor, children = _ref2.children, fill = _ref2.fill, guidingChild = _ref2.guidingChild, interactiveChild = _ref2.interactiveChild, rest = $6bf62d63c2cc8b3a$var$_objectWithoutPropertiesLoose(_ref2, $6bf62d63c2cc8b3a$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var prunedChildren = $6bf62d63c2cc8b3a$var$_react.Children.toArray(children).filter(function(c) {
        return c;
    });
    var toChildIndex = function toChildIndex(child) {
        var index = child;
        if (index === 'first' || !index) index = 0;
        else if (index === 'last') index = prunedChildren.length - 1;
        return index;
    };
    var guidingIndex = toChildIndex(guidingChild);
    var interactiveIndex = interactiveChild && toChildIndex(interactiveChild);
    var styledChildren = prunedChildren.map($6bf62d63c2cc8b3a$var$buildStyledChildren({
        anchor: anchor,
        fill: fill,
        guidingIndex: guidingIndex,
        interactiveChild: interactiveChild,
        interactiveIndex: interactiveIndex
    }));
    return /*#__PURE__*/ $6bf62d63c2cc8b3a$var$_react["default"].createElement($798bf802fedde553$export$8a7fb03b17c12e52, $6bf62d63c2cc8b3a$var$_extends({
        ref: ref,
        fillContainer: fill
    }, passThemeFlag, rest), styledChildren);
});
$6bf62d63c2cc8b3a$var$Stack.displayName = 'Stack';
$6bf62d63c2cc8b3a$var$Stack.propTypes = $7e46d051fd89407e$export$ae929f3c1850d7bc;


$8c60273918bcf71f$export$694e0d28c7ffc90c = $6bf62d63c2cc8b3a$export$694e0d28c7ffc90c;


var $2f0b7ad0e7a4866d$exports = {};

$parcel$export($2f0b7ad0e7a4866d$exports, "__esModule", function () { return $2f0b7ad0e7a4866d$export$1e511d4a378977f5; }, function (v) { return $2f0b7ad0e7a4866d$export$1e511d4a378977f5 = v; });
$parcel$export($2f0b7ad0e7a4866d$exports, "Text", function () { return $2f0b7ad0e7a4866d$export$5f1af8db9871e1d6; }, function (v) { return $2f0b7ad0e7a4866d$export$5f1af8db9871e1d6 = v; });
var $2f0b7ad0e7a4866d$export$1e511d4a378977f5;
var $2f0b7ad0e7a4866d$export$5f1af8db9871e1d6;
"use strict";
$2f0b7ad0e7a4866d$export$1e511d4a378977f5 = true;
$2f0b7ad0e7a4866d$export$5f1af8db9871e1d6 = void 0;
var $5bf8ddcbc5d2dd3a$export$1e511d4a378977f5;
var $5bf8ddcbc5d2dd3a$export$5f1af8db9871e1d6;
"use strict";
$5bf8ddcbc5d2dd3a$export$1e511d4a378977f5 = true;
$5bf8ddcbc5d2dd3a$export$5f1af8db9871e1d6 = void 0;

var $5bf8ddcbc5d2dd3a$var$_react = $5bf8ddcbc5d2dd3a$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $177e150e26cebaa1$export$1e511d4a378977f5;
var $177e150e26cebaa1$export$31ea92f3997410dd;
"use strict";
$177e150e26cebaa1$export$1e511d4a378977f5 = true;
$177e150e26cebaa1$export$31ea92f3997410dd = void 0;

var $177e150e26cebaa1$var$_styledComponents = $177e150e26cebaa1$var$_interopRequireWildcard((parcelRequire("iA1nz")));

function $177e150e26cebaa1$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($177e150e26cebaa1$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $177e150e26cebaa1$var$sizeStyle = function sizeStyle(props) {
    var size = props.size || 'medium';
    var data = props.theme.text[size];
    if (data) return (0, $177e150e26cebaa1$var$_styledComponents.css)([
        "font-size:",
        ";line-height:",
        ";"
    ], data.size, data.height);
    return (0, $177e150e26cebaa1$var$_styledComponents.css)([
        "font-size:",
        ";line-height:normal;"
    ], size);
};
var $177e150e26cebaa1$var$truncateStyle = "\n  white-space: nowrap;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n";
var $177e150e26cebaa1$var$colorStyle = (0, $177e150e26cebaa1$var$_styledComponents.css)([
    "color:",
    ";"
], function(props) {
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(props.colorProp, props.theme);
});
var $177e150e26cebaa1$var$weightStyle = (0, $177e150e26cebaa1$var$_styledComponents.css)([
    "font-weight:",
    ";"
], function(props) {
    return props.weight;
});
var $177e150e26cebaa1$var$wordBreakStyle = (0, $177e150e26cebaa1$var$_styledComponents.css)([
    "word-break:",
    ";"
], function(props) {
    return props.wordBreak;
});
var $177e150e26cebaa1$var$fontFamily = (0, $177e150e26cebaa1$var$_styledComponents.css)([
    "font-family:",
    ";"
], function(props) {
    return props.theme.text.font.family;
});
var $177e150e26cebaa1$var$StyledText = $177e150e26cebaa1$export$31ea92f3997410dd = (0, $177e150e26cebaa1$var$_styledComponents["default"])('span').withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledText",
    componentId: "sc-1sadyjn-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], $4113023f9e0bafa0$exports.genericStyles, function(props) {
    return $177e150e26cebaa1$var$sizeStyle(props);
}, function(props) {
    return props.textAlign && $4113023f9e0bafa0$exports.textAlignStyle;
}, function(props) {
    return props.truncate && $177e150e26cebaa1$var$truncateStyle;
}, function(props) {
    return props.colorProp && $177e150e26cebaa1$var$colorStyle;
}, function(props) {
    return props.weight && $177e150e26cebaa1$var$weightStyle;
}, function(props) {
    return props.wordBreak && $177e150e26cebaa1$var$wordBreakStyle;
}, function(props) {
    return props.theme.text.font && props.theme.text.font.family && $177e150e26cebaa1$var$fontFamily;
}, function(props) {
    return props.theme.text && props.theme.text.extend;
});




var $26a92da470d0556d$export$1e511d4a378977f5;
var $26a92da470d0556d$export$da9fd56aa591dacf;
"use strict";
$26a92da470d0556d$export$1e511d4a378977f5 = true;
$26a92da470d0556d$export$da9fd56aa591dacf = void 0;

var $26a92da470d0556d$var$_propTypes = $26a92da470d0556d$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $26a92da470d0556d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $26a92da470d0556d$var$_extends() {
    return $26a92da470d0556d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $26a92da470d0556d$var$_extends.apply(null, arguments);
}
var $26a92da470d0556d$var$PropType = {};
$26a92da470d0556d$var$PropType = $26a92da470d0556d$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    color: $5897bd367fbd90c1$export$fc4c368d97afb623,
    margin: $26a92da470d0556d$var$_propTypes["default"].oneOfType([
        $26a92da470d0556d$var$_propTypes["default"].oneOf([
            'none'
        ].concat($5897bd367fbd90c1$export$7d9f2aeb8f1f7c3f)),
        $26a92da470d0556d$var$_propTypes["default"].shape({
            bottom: $26a92da470d0556d$var$_propTypes["default"].oneOfType([
                $26a92da470d0556d$var$_propTypes["default"].oneOf($5897bd367fbd90c1$export$7d9f2aeb8f1f7c3f),
                $26a92da470d0556d$var$_propTypes["default"].string
            ]),
            end: $26a92da470d0556d$var$_propTypes["default"].oneOfType([
                $26a92da470d0556d$var$_propTypes["default"].oneOf($5897bd367fbd90c1$export$7d9f2aeb8f1f7c3f),
                $26a92da470d0556d$var$_propTypes["default"].string
            ]),
            horizontal: $26a92da470d0556d$var$_propTypes["default"].oneOfType([
                $26a92da470d0556d$var$_propTypes["default"].oneOf($5897bd367fbd90c1$export$7d9f2aeb8f1f7c3f),
                $26a92da470d0556d$var$_propTypes["default"].string
            ]),
            left: $26a92da470d0556d$var$_propTypes["default"].oneOfType([
                $26a92da470d0556d$var$_propTypes["default"].oneOf($5897bd367fbd90c1$export$7d9f2aeb8f1f7c3f),
                $26a92da470d0556d$var$_propTypes["default"].string
            ]),
            right: $26a92da470d0556d$var$_propTypes["default"].oneOfType([
                $26a92da470d0556d$var$_propTypes["default"].oneOf($5897bd367fbd90c1$export$7d9f2aeb8f1f7c3f),
                $26a92da470d0556d$var$_propTypes["default"].string
            ]),
            start: $26a92da470d0556d$var$_propTypes["default"].oneOfType([
                $26a92da470d0556d$var$_propTypes["default"].oneOf($5897bd367fbd90c1$export$7d9f2aeb8f1f7c3f),
                $26a92da470d0556d$var$_propTypes["default"].string
            ]),
            top: $26a92da470d0556d$var$_propTypes["default"].oneOfType([
                $26a92da470d0556d$var$_propTypes["default"].oneOf($5897bd367fbd90c1$export$7d9f2aeb8f1f7c3f),
                $26a92da470d0556d$var$_propTypes["default"].string
            ]),
            vertical: $26a92da470d0556d$var$_propTypes["default"].oneOfType([
                $26a92da470d0556d$var$_propTypes["default"].oneOf($5897bd367fbd90c1$export$7d9f2aeb8f1f7c3f),
                $26a92da470d0556d$var$_propTypes["default"].string
            ])
        }),
        $26a92da470d0556d$var$_propTypes["default"].string
    ]),
    size: $26a92da470d0556d$var$_propTypes["default"].oneOfType([
        $26a92da470d0556d$var$_propTypes["default"].oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            'xxlarge',
            '2xl',
            '3xl',
            '4xl',
            '5xl',
            '6xl'
        ]),
        $26a92da470d0556d$var$_propTypes["default"].string
    ]),
    skeleton: $5897bd367fbd90c1$export$2f3082f340019e9a,
    tag: $26a92da470d0556d$var$_propTypes["default"].oneOfType([
        $26a92da470d0556d$var$_propTypes["default"].string,
        $26a92da470d0556d$var$_propTypes["default"].func
    ]),
    as: $26a92da470d0556d$var$_propTypes["default"].oneOfType([
        $26a92da470d0556d$var$_propTypes["default"].string,
        $26a92da470d0556d$var$_propTypes["default"].func,
        $26a92da470d0556d$var$_propTypes["default"].element
    ]),
    textAlign: $26a92da470d0556d$var$_propTypes["default"].oneOf([
        'start',
        'center',
        'end',
        'justify'
    ]),
    tip: $26a92da470d0556d$var$_propTypes["default"].oneOfType([
        $26a92da470d0556d$var$_propTypes["default"].shape({
            content: $26a92da470d0556d$var$_propTypes["default"].oneOfType([
                $26a92da470d0556d$var$_propTypes["default"].node,
                $26a92da470d0556d$var$_propTypes["default"].string
            ]),
            dropProps: $26a92da470d0556d$var$_propTypes["default"].shape({}),
            plain: $26a92da470d0556d$var$_propTypes["default"].bool
        }),
        $26a92da470d0556d$var$_propTypes["default"].string
    ]),
    truncate: $26a92da470d0556d$var$_propTypes["default"].oneOfType([
        $26a92da470d0556d$var$_propTypes["default"].bool,
        $26a92da470d0556d$var$_propTypes["default"].oneOf([
            'tip'
        ])
    ]),
    weight: $26a92da470d0556d$var$_propTypes["default"].oneOfType([
        $26a92da470d0556d$var$_propTypes["default"].oneOf([
            'normal',
            'bold',
            'bolder',
            'lighter'
        ]),
        $26a92da470d0556d$var$_propTypes["default"].number
    ]),
    wordBreak: $26a92da470d0556d$var$_propTypes["default"].oneOf([
        'normal',
        'break-all',
        'keep-all',
        'break-word'
    ])
});
var $26a92da470d0556d$var$TextPropTypes = $26a92da470d0556d$export$da9fd56aa591dacf = $26a92da470d0556d$var$PropType;



var $efc756dca20d1785$export$1e511d4a378977f5;
var $efc756dca20d1785$export$8334ddaea41520f1;
"use strict";
$efc756dca20d1785$export$1e511d4a378977f5 = true;
$efc756dca20d1785$export$8334ddaea41520f1 = void 0;

var $efc756dca20d1785$var$_react = $efc756dca20d1785$var$_interopRequireWildcard((parcelRequire("2xPiy")));


var $efc756dca20d1785$var$_excluded = [
    "as",
    "size"
];
function $efc756dca20d1785$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($efc756dca20d1785$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $efc756dca20d1785$var$_extends() {
    return $efc756dca20d1785$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $efc756dca20d1785$var$_extends.apply(null, arguments);
}
function $efc756dca20d1785$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $efc756dca20d1785$var$TextSkeleton = $efc756dca20d1785$export$8334ddaea41520f1 = /*#__PURE__*/ (0, $efc756dca20d1785$var$_react.forwardRef)(function(_ref, ref) {
    var as = _ref.as, sizeProp = _ref.size, rest = $efc756dca20d1785$var$_objectWithoutPropertiesLoose(_ref, $efc756dca20d1785$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var size = sizeProp || 'medium';
    var data = theme.text[size];
    var height = data ? data.size : sizeProp;
    return /*#__PURE__*/ $efc756dca20d1785$var$_react["default"].createElement($ab65104eb6f9aa8a$exports.Skeleton, $efc756dca20d1785$var$_extends({
        ref: ref,
        as: as,
        height: height
    }, theme.text.skeleton, rest));
});
$efc756dca20d1785$var$TextSkeleton.displayName = 'TextSkeleton';




var $5bf8ddcbc5d2dd3a$var$_excluded = [
    "children",
    "color",
    "tag",
    "as",
    "tip",
    "a11yTitle",
    "truncate",
    "size",
    "skeleton",
    "level"
];
function $5bf8ddcbc5d2dd3a$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($5bf8ddcbc5d2dd3a$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $5bf8ddcbc5d2dd3a$var$_extends() {
    return $5bf8ddcbc5d2dd3a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5bf8ddcbc5d2dd3a$var$_extends.apply(null, arguments);
}
function $5bf8ddcbc5d2dd3a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $5bf8ddcbc5d2dd3a$var$Text = $5bf8ddcbc5d2dd3a$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $5bf8ddcbc5d2dd3a$var$_react.forwardRef)(function(_ref, ref) {
    var children = _ref.children, color = _ref.color, tag = _ref.tag, as = _ref.as, tipProp = _ref.tip, _ref$a11yTitle = _ref.a11yTitle, a11yTitle = _ref$a11yTitle === void 0 ? typeof tipProp === 'string' && tipProp || (tipProp == null ? void 0 : tipProp.content) || undefined : _ref$a11yTitle, truncate = _ref.truncate, size = _ref.size, skeletonProp = _ref.skeleton, _ref$level = _ref.level, level = _ref$level === void 0 ? 1 : _ref$level, rest = $5bf8ddcbc5d2dd3a$var$_objectWithoutPropertiesLoose(_ref, $5bf8ddcbc5d2dd3a$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var textRef = (0, $4113023f9e0bafa0$exports.useForwardedRef)(ref);
    var _useState = (0, $5bf8ddcbc5d2dd3a$var$_react.useState)(false), textTruncated = _useState[0], setTextTruncated = _useState[1];
    var textContextValue = (0, $5bf8ddcbc5d2dd3a$var$_react.useMemo)(function() {
        return {
            size: size
        };
    }, [
        size
    ]);
    var skeleton = (0, $ab65104eb6f9aa8a$exports.useSkeleton)();
    (0, $6a5275ec792307a1$export$e5c5a5f917a5871c)(function() {
        var updateTip = function updateTip() {
            setTextTruncated(false);
            if (truncate === 'tip' && textRef.current && textRef.current.scrollWidth > textRef.current.offsetWidth) setTextTruncated(true);
        };
        window.addEventListener('resize', updateTip);
        window.addEventListener('pagechange', updateTip);
        updateTip();
        return function() {
            window.removeEventListener('resize', updateTip);
            window.removeEventListener('pagechange', updateTip);
        };
    }, [
        textRef,
        truncate
    ]);
    if (skeleton) return /*#__PURE__*/ $5bf8ddcbc5d2dd3a$var$_react["default"].createElement($efc756dca20d1785$export$8334ddaea41520f1, $5bf8ddcbc5d2dd3a$var$_extends({
        ref: ref,
        as: as,
        level: level,
        size: size
    }, skeletonProp, rest));
    var styledTextResult = /*#__PURE__*/ $5bf8ddcbc5d2dd3a$var$_react["default"].createElement($177e150e26cebaa1$export$31ea92f3997410dd, $5bf8ddcbc5d2dd3a$var$_extends({
        as: !as && tag ? tag : as,
        colorProp: color,
        "aria-label": a11yTitle,
        level: level,
        truncate: truncate,
        size: size
    }, passThemeFlag, rest, {
        ref: textRef
    }), children !== undefined ? /*#__PURE__*/ $5bf8ddcbc5d2dd3a$var$_react["default"].createElement($5eeccb5281d9dbdf$export$9afb8bc826b033ea.Provider, {
        value: textContextValue
    }, children) : undefined);
    var tipProps = tipProp && typeof tipProp === 'object' ? tipProp : {};
    if (tipProp || textTruncated) {
        // place the text content in a tip if truncate === 'tip'
        // and the text has been truncated
        if (textTruncated) return /*#__PURE__*/ $5bf8ddcbc5d2dd3a$var$_react["default"].createElement($7946e73be6fde87a$export$c92c6401b52a9298, $5bf8ddcbc5d2dd3a$var$_extends({
            content: children
        }, tipProps), styledTextResult);
        // place the text content in a tip if truncate !== 'tip'
        // it displays even if the text has not truncated
        if (truncate !== 'tip') return /*#__PURE__*/ $5bf8ddcbc5d2dd3a$var$_react["default"].createElement($7946e73be6fde87a$export$c92c6401b52a9298, tipProps, styledTextResult);
    }
    return styledTextResult;
});
$5bf8ddcbc5d2dd3a$var$Text.displayName = 'Text';
$5bf8ddcbc5d2dd3a$var$Text.propTypes = $26a92da470d0556d$export$da9fd56aa591dacf;


$2f0b7ad0e7a4866d$export$5f1af8db9871e1d6 = $5bf8ddcbc5d2dd3a$export$5f1af8db9871e1d6;



function $8d3bd995936cfd81$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $8d3bd995936cfd81$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($8d3bd995936cfd81$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $8d3bd995936cfd81$var$_extends() {
    return $8d3bd995936cfd81$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8d3bd995936cfd81$var$_extends.apply(null, arguments);
}
var $8d3bd995936cfd81$var$StyledBadgeContainer = (0, $8d3bd995936cfd81$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "Badge__StyledBadgeContainer",
    componentId: "sc-1es4ws1-0"
})([
    "",
    ""
], function(props) {
    return props.theme.button.badge.container.extend;
});
var $8d3bd995936cfd81$var$Badge = $8d3bd995936cfd81$export$37acb3580601e69a = function Badge(_ref) {
    var children = _ref.children, content = _ref.content;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var containerRef = (0, $8d3bd995936cfd81$var$_react.useRef)();
    var contentRef = (0, $8d3bd995936cfd81$var$_react.useRef)();
    var stackRef = (0, $8d3bd995936cfd81$var$_react.useRef)();
    var defaultBadgeDimension = typeof content === 'boolean' || content && content.value && typeof content.value === 'boolean' ? // after experimenting with various values
    (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.button.badge.size.medium) / 2 + "px" : theme.button.badge.size.medium;
    // scale badge to fit its contents, leaving space horizontally
    // that is proportional to vertical space
    (0, $6a5275ec792307a1$export$e5c5a5f917a5871c)(function() {
        // when window resizes and hits a responsive breakpoint, width of the badge
        // can change (because pad is responsive, etc.). we want to recalculate
        // width since badge offset is reliant on its dimensions.
        var onResize = function onResize() {
            if (containerRef != null && containerRef.current) {
                containerRef.current.style.minHeight = '';
                containerRef.current.style.minWidth = '';
                if (contentRef != null && contentRef.current) {
                    if (typeof content === 'number' || typeof content === 'object' && content.value) {
                        containerRef.current.style.minHeight = defaultBadgeDimension;
                        containerRef.current.style.minWidth = defaultBadgeDimension;
                        var _contentRef$current$g = contentRef.current.getBoundingClientRect(), contentHeight = _contentRef$current$g.height, contentWidth = _contentRef$current$g.width;
                        // only adjust the width if contentHeight > 0
                        // jest returns 0 for all getBoundingClientRect values,
                        // so this ensures snapshots are closer to correct values
                        if (contentHeight) {
                            // height of content includes extra space around font from
                            // line-height. account for this extra space with 2.5 multiplier
                            // to add proportional horizontal space
                            var height = defaultBadgeDimension;
                            var width = defaultBadgeDimension;
                            var verticalSpace = ((0, $4113023f9e0bafa0$exports.parseMetricToNum)(height) - contentHeight) * 2.5;
                            containerRef.current.style.minHeight = height;
                            containerRef.current.style.minWidth = Math.max((0, $4113023f9e0bafa0$exports.parseMetricToNum)(width), Math.ceil(contentWidth + verticalSpace)) + "px";
                        }
                    } else {
                        // caller has provided custom JSX
                        containerRef.current.style.minHeight = contentRef.current.getBoundingClientRect().width;
                        containerRef.current.style.minWidth = contentRef.current.getBoundingClientRect().height;
                    }
                } else {
                    containerRef.current.style.minHeight = defaultBadgeDimension;
                    containerRef.current.style.minWidth = defaultBadgeDimension;
                }
            }
        };
        window.addEventListener('resize', onResize);
        onResize();
        return function() {
            window.removeEventListener('resize', onResize);
        };
    }, [
        content,
        defaultBadgeDimension
    ]);
    // offset the badge so it overlaps content
    (0, $6a5275ec792307a1$export$e5c5a5f917a5871c)(function() {
        if (stackRef != null && stackRef.current) {
            // when badge has content, offset should be 50%.
            // when badge is empty, offset by a smaller amount to keep the badge
            // closer to the content. this value was chosen as a reasonable default
            // after testing with various grommet icons.
            var offset = typeof content === 'boolean' || content && content.value === true ? '25%' : '50%';
            // second child of Stack is the div that receives absolute positioning
            // and contains our badge content
            stackRef.current.children[1].style.top = 0;
            stackRef.current.children[1].style.right = 0;
            // eslint-disable-next-line max-len
            stackRef.current.children[1].style.transform = "translate(" + offset + ", -" + offset + ")";
            stackRef.current.children[1].style.transformOrigin = '100% 0%';
        }
    }, [
        content
    ]);
    var value;
    if (typeof content === 'number') value = content;
    else if (typeof content === 'object') value = content.value;
    var badge;
    if (typeof value === 'number' || typeof value === 'boolean' || typeof content === 'boolean') {
        if (typeof value === 'number') {
            var max = content.max || 9;
            badge = /*#__PURE__*/ $8d3bd995936cfd81$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, {
                color: "text-strong",
                size: theme.button.badge.text.size.medium,
                weight: "normal",
                ref: contentRef
            }, value > max ? max + "+" : value);
        }
        badge = /*#__PURE__*/ $8d3bd995936cfd81$var$_react["default"].createElement($8d3bd995936cfd81$var$StyledBadgeContainer, $8d3bd995936cfd81$var$_extends({
            ref: containerRef,
            align: "center",
            background: content.background || theme.button.badge.container.background,
            flex: false,
            justify: "center",
            round: true,
            pad: !(typeof value === 'boolean' || typeof content === 'boolean') ? theme.button.badge.container.pad : undefined
        }, passThemeFlag), badge);
    // caller has provided their own JSX and we will just render that
    } else badge = /*#__PURE__*/ $8d3bd995936cfd81$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        ref: contentRef
    }, content);
    return /*#__PURE__*/ $8d3bd995936cfd81$var$_react["default"].createElement($8c60273918bcf71f$export$694e0d28c7ffc90c, {
        ref: stackRef,
        anchor: "top-right"
    }, children, badge);
};


var $b4ed02cd88b378ae$export$1e511d4a378977f5;
var $b4ed02cd88b378ae$export$2d5d2ba3c7c8c40b;
"use strict";
$b4ed02cd88b378ae$export$1e511d4a378977f5 = true;
$b4ed02cd88b378ae$export$2d5d2ba3c7c8c40b = void 0;

var $b4ed02cd88b378ae$var$_styledComponents = $b4ed02cd88b378ae$var$_interopRequireWildcard((parcelRequire("iA1nz")));


function $b4ed02cd88b378ae$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($b4ed02cd88b378ae$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $b4ed02cd88b378ae$var$radiusStyle = function radiusStyle(props) {
    // border.radius shouldn't impact an only-icon rendering.
    var isIconOnly = props.hasIcon && !props.hasLabel;
    var size = props.sizeProp;
    if (!isIconOnly && size && props.theme.button.size && props.theme.button.size[size]) return props.theme.button.size[size].border.radius;
    return props.theme.button.border.radius;
};
var $b4ed02cd88b378ae$var$fontStyle = function fontStyle(props) {
    var size = props.sizeProp || 'medium';
    var data = props.theme.text[size];
    return (0, $b4ed02cd88b378ae$var$_styledComponents.css)([
        "font-size:",
        ";line-height:",
        ";"
    ], data.size, data.height);
};
var $b4ed02cd88b378ae$var$padStyle = function padStyle(props) {
    var size = props.sizeProp;
    if (size && props.theme.button.size && props.theme.button.size[size]) return (0, $b4ed02cd88b378ae$var$_styledComponents.css)([
        "",
        " ",
        ""
    ], props.theme.button.size[size].pad.vertical, props.theme.button.size[size].pad.horizontal);
    return (0, $b4ed02cd88b378ae$var$_styledComponents.css)([
        "",
        " ",
        ""
    ], props.theme.button.padding.vertical, props.theme.button.padding.horizontal);
};
var $b4ed02cd88b378ae$var$basicStyle = function basicStyle(props) {
    return (0, $b4ed02cd88b378ae$var$_styledComponents.css)([
        "border:",
        " solid ",
        ";border-radius:",
        ";",
        " color:",
        ";padding:",
        ";",
        ""
    ], props.theme.button.border.width, (0, $4113023f9e0bafa0$exports.normalizeColor)(props.colorValue || props.theme.button.border.color || 'control', props.theme), $b4ed02cd88b378ae$var$radiusStyle(props), props.theme.button.elevation && (0, $9a7099e779e83517$export$b4ff7c828301ce9f)(props.theme.button.elevation), (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.button.color || 'text', props.theme), $b4ed02cd88b378ae$var$padStyle(props), $b4ed02cd88b378ae$var$fontStyle(props));
};
var $b4ed02cd88b378ae$var$primaryStyle = function primaryStyle(props) {
    var _props$theme$button$p, _props$theme$button$p2;
    return (0, $b4ed02cd88b378ae$var$_styledComponents.css)([
        "",
        " border-radius:",
        ";",
        " ",
        ""
    ], (0, $4113023f9e0bafa0$exports.backgroundStyle)((0, $4113023f9e0bafa0$exports.normalizeColor)(props.colorValue || props.theme.button.primary && props.theme.button.primary.color || 'control', props.theme), props.theme, props.theme.button.color), $b4ed02cd88b378ae$var$radiusStyle(props), ((_props$theme$button$p = props.theme.button.primary) == null ? void 0 : _props$theme$button$p.elevation) && (0, $9a7099e779e83517$export$b4ff7c828301ce9f)((_props$theme$button$p2 = props.theme.button.primary) == null ? void 0 : _props$theme$button$p2.elevation), props.theme.button.primary && props.theme.button.primary.extend);
};
function $b4ed02cd88b378ae$var$getHoverColor(props) {
    if (props.colorValue) return (0, $4113023f9e0bafa0$exports.normalizeColor)(props.colorValue, props.theme);
    if (props.active && props.primary && props.theme.button.primary && props.theme.button.primary.active && props.theme.button.primary.active.border && props.theme.button.primary.active.border.color) return (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.button.primary.active.border.color, props.theme);
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.button.border.color || 'control', props.theme);
}
var $b4ed02cd88b378ae$var$hoverStyle = (0, $b4ed02cd88b378ae$var$_styledComponents.css)([
    "&:hover{",
    " ",
    ";}"
], function(props) {
    return props.hoverIndicator && (0, $4113023f9e0bafa0$exports.getHoverIndicatorStyle)(props.hoverIndicator, props.theme);
}, function(props) {
    return !props.plain && (0, $b4ed02cd88b378ae$var$_styledComponents.css)([
        "box-shadow:0px 0px 0px 2px ",
        ";"
    ], $b4ed02cd88b378ae$var$getHoverColor(props));
});
var $b4ed02cd88b378ae$var$fillStyle = function fillStyle(fillContainer) {
    if (fillContainer === 'horizontal') return 'width: 100%;';
    if (fillContainer === 'vertical') return 'height: 100%;';
    if (fillContainer) return "\n      width: 100%;\n      height: 100%;\n      max-width: none;\n      flex: 1 0 auto;\n    ";
    return undefined;
};
var $b4ed02cd88b378ae$var$plainStyle = function plainStyle(props) {
    return (0, $b4ed02cd88b378ae$var$_styledComponents.css)([
        "color:",
        ";outline:none;border:none;padding:0;text-align:inherit;"
    ], (0, $4113023f9e0bafa0$exports.normalizeColor)(props.colorValue || 'inherit', props.theme));
};
var $b4ed02cd88b378ae$var$activeButtonStyle = function activeButtonStyle(props) {
    return (0, $b4ed02cd88b378ae$var$_styledComponents.css)([
        "",
        " ",
        " ",
        ""
    ], $4113023f9e0bafa0$exports.activeStyle, props.primary && props.theme.button.primary && props.theme.button.primary.active && props.theme.button.primary.active.border && props.theme.button.primary.active.border.color && "border: " + props.theme.button.border.width + " solid\n    " + (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.button.primary.active.border.color, props.theme) + ";\n    ", props.primary && props.theme.button.primary && props.theme.button.primary.active && props.theme.button.primary.active.extend);
};
var $b4ed02cd88b378ae$var$disabledButtonStyle = function disabledButtonStyle(props) {
    return (0, $b4ed02cd88b378ae$var$_styledComponents.css)([
        "",
        " ",
        " ",
        " ",
        ""
    ], (0, $4113023f9e0bafa0$exports.disabledStyle)(props.theme.button.disabled.opacity), !props.plain && props.theme.button.disabled.border && props.theme.button.disabled.border.color && "border: " + props.theme.button.border.width + " solid\n    " + (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.button.disabled.border.color, props.theme) + ";", props.theme.button.disabled.color && // if primary button, apply disabled color to background. otherwise,
    // apply disabled color to the label
    (props.primary ? (0, $4113023f9e0bafa0$exports.backgroundStyle)((0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.button.disabled.color, props.theme), props.theme, props.theme.button.color) : "color: " + (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.button.disabled.color, props.theme) + ";"), props.theme.button.disabled && props.theme.button.disabled.extend);
};
// Deprecate props.theme.button.disabled.opacity in V3
var $b4ed02cd88b378ae$var$StyledButton = $b4ed02cd88b378ae$export$2d5d2ba3c7c8c40b = $b4ed02cd88b378ae$var$_styledComponents["default"].button.withConfig($9a7099e779e83517$export$373e75d802fd707).withConfig({
    displayName: "StyledButton",
    componentId: "sc-323bzc-0"
})([
    "display:inline-block;box-sizing:border-box;cursor:pointer;font:inherit;text-decoration:none;margin:0;background:transparent;overflow:visible;text-transform:none;",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " &:focus{",
    "}&:focus:not(:focus-visible){",
    "}",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], $4113023f9e0bafa0$exports.genericStyles, function(props) {
    return props.plain && $b4ed02cd88b378ae$var$plainStyle(props);
}, function(props) {
    return !props.plain && $b4ed02cd88b378ae$var$basicStyle(props);
}, function(props) {
    return props.primary && $b4ed02cd88b378ae$var$primaryStyle(props);
}, function(props) {
    return !props.disabled && !props.selected && !props.focus && !props.busy && !props.success && $b4ed02cd88b378ae$var$hoverStyle;
}, function(props) {
    return !props.disabled && props.active && $b4ed02cd88b378ae$var$activeButtonStyle(props);
}, function(props) {
    return props.disabled && props.theme.button && props.theme.button.disabled && $b4ed02cd88b378ae$var$disabledButtonStyle(props);
}, function(props) {
    return (!props.plain || props.focusIndicator) && (0, $4113023f9e0bafa0$exports.focusStyle)({
        inset: props.focusIndicator === 'inset'
    });
}, (0, $4113023f9e0bafa0$exports.unfocusStyle)(), function(props) {
    return !props.plain && props.theme.button.transition && "\n    transition-property: " + props.theme.button.transition.properties.join(',') + ";\n    transition-duration: " + props.theme.button.transition.duration + "s;\n    transition-timing-function: " + props.theme.button.transition.timing + ";\n  ";
}, function(props) {
    return props.fillContainer && $b4ed02cd88b378ae$var$fillStyle(props.fillContainer);
}, function(props) {
    return props.hasIcon && !props.hasLabel && "\n    line-height: 0;\n  ";
}, function(props) {
    return props.pad === true && props.hasIcon && !props.hasLabel && "\n    padding: " + props.theme.global.edgeSize.small + ";\n  ";
}, function(props) {
    return !props.plain && props.pad && (0, $4113023f9e0bafa0$exports.edgeStyle)('padding', props.pad, false, undefined, props.theme);
}, function(props) {
    return props.theme.button && props.theme.button.extend;
}, function(props) {
    return (props.busy || props.success) && "\n    cursor: default;\n  ";
});


var $592deb967468e376$export$1e511d4a378977f5;
var $592deb967468e376$export$64e6768d853ca4b8;
"use strict";
$592deb967468e376$export$1e511d4a378977f5 = true;
$592deb967468e376$export$64e6768d853ca4b8 = void 0;

var $592deb967468e376$var$_styledComponents = $592deb967468e376$var$_interopRequireWildcard((parcelRequire("iA1nz")));

var $592deb967468e376$var$_isPropValid = $592deb967468e376$var$_interopRequireDefault((parcelRequire("8Fliv")));

function $592deb967468e376$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $592deb967468e376$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($592deb967468e376$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $592deb967468e376$var$radiusStyle = function radiusStyle(props) {
    var size = props.sizeProp;
    // caller has specified a themeObj to use for styling
    // relevant for cases like pagination which looks to theme.pagination.button
    var themeObj = typeof props.kind === 'object' ? props.kind : props.theme.button;
    if (size && themeObj.size && themeObj.size[size]) return (0, $592deb967468e376$var$_styledComponents.css)([
        "border-radius:",
        ";"
    ], themeObj.size[size].border.radius);
    if (themeObj.border && themeObj.border.radius) return (0, $592deb967468e376$var$_styledComponents.css)([
        "border-radius:",
        ";"
    ], themeObj.border.radius);
    return '';
};
var $592deb967468e376$var$fontStyle = function fontStyle(props) {
    var size = props.sizeProp || 'medium';
    var data = props.theme.text[size];
    return (0, $592deb967468e376$var$_styledComponents.css)([
        "font-size:",
        ";line-height:",
        ";"
    ], data.size, props.hasIcon && !props.hasLabel ? 0 : data.height);
};
var $592deb967468e376$var$padFromTheme = function padFromTheme(size, theme, themeObj, kind, iconOnly) {
    var _themeObj$size, _themeObj$size3;
    if (size === void 0) size = 'medium';
    if (size && iconOnly && themeObj != null && (_themeObj$size = themeObj.size) != null && (_themeObj$size = _themeObj$size[size]) != null && (_themeObj$size = _themeObj$size.iconOnly) != null && _themeObj$size.pad) {
        var _themeObj$size2;
        var pad = themeObj == null || (_themeObj$size2 = themeObj.size) == null || (_themeObj$size2 = _themeObj$size2[size]) == null || (_themeObj$size2 = _themeObj$size2.iconOnly) == null ? void 0 : _themeObj$size2.pad;
        return {
            vertical: typeof pad === 'string' ? pad : pad.vertical,
            horizontal: typeof pad === 'string' ? pad : pad.horizontal
        };
    }
    if (size && themeObj != null && (_themeObj$size3 = themeObj.size) != null && (_themeObj$size3 = _themeObj$size3[size]) != null && (_themeObj$size3 = _themeObj$size3[kind]) != null && _themeObj$size3.pad) return themeObj.size[size][kind].pad;
    if (size && themeObj.size && themeObj.size[size] && themeObj.size[size].pad) return {
        vertical: themeObj.size[size].pad.vertical,
        horizontal: themeObj.size[size].pad.horizontal
    };
    if (theme.button.padding) return {
        vertical: theme.global.edgeSize[theme.button.padding.vertical] || theme.button.padding.vertical,
        horizontal: theme.global.edgeSize[theme.button.padding.horizontal] || theme.button.padding.horizontal
    };
    return undefined;
};
var $592deb967468e376$var$padStyle = function padStyle(_ref) {
    var hasIcon = _ref.hasIcon, hasLabel = _ref.hasLabel, size = _ref.sizeProp, theme = _ref.theme, kind = _ref.kind;
    // caller has specified a themeObj to use for styling
    // relevant for cases like pagination which looks to theme.pagination.button
    var themeObj = typeof kind === 'object' ? kind : theme.button;
    var iconOnly = hasIcon && !hasLabel;
    var pad = $592deb967468e376$var$padFromTheme(size, theme, themeObj, kind, iconOnly);
    return pad ? (0, $592deb967468e376$var$_styledComponents.css)([
        "padding:",
        " ",
        ";"
    ], pad.vertical, pad.horizontal) : '';
};
var $592deb967468e376$var$basicStyle = function basicStyle(props) {
    return (0, $592deb967468e376$var$_styledComponents.css)([
        "border:none;",
        ";",
        " ",
        " ",
        ""
    ], $592deb967468e376$var$radiusStyle(props), $592deb967468e376$var$padStyle(props), $592deb967468e376$var$fontStyle(props), props.icon && "\n    > svg {\n      display: flex;\n      align-self: center;\n      vertical-align: middle;\n    }\n  ");
};
var $592deb967468e376$var$getPath = function getPath(theme, path) {
    var obj;
    if (path) {
        obj = theme;
        var parts = path.split('.');
        while(obj && parts.length)obj = obj[parts.shift()];
    }
    return obj;
};
var $592deb967468e376$var$adjustPadStyle = function adjustPadStyle(pad, width, theme) {
    var _theme$button;
    var intelligentPad = theme == null || (_theme$button = theme.button) == null ? void 0 : _theme$button.intelligentPad;
    if (intelligentPad === true) {
        var offset = (0, $4113023f9e0bafa0$exports.parseMetricToNum)(width);
        return (0, $592deb967468e376$var$_styledComponents.css)([
            "padding:",
            "px ",
            "px;"
        ], Math.max((0, $4113023f9e0bafa0$exports.parseMetricToNum)(pad.vertical) - offset, 0), Math.max((0, $4113023f9e0bafa0$exports.parseMetricToNum)(pad.horizontal) - offset, 0));
    }
    // If intelligentPad is false return padding without adjustment
    return (0, $592deb967468e376$var$_styledComponents.css)([
        "padding:",
        " ",
        ";"
    ], pad.vertical, pad.horizontal);
};
// build up CSS from basic to specific based on the supplied sub-object paths
var $592deb967468e376$var$kindStyle = function kindStyle(_ref2) {
    var busy = _ref2.busy, colorValue = _ref2.colorValue, hasIcon = _ref2.hasIcon, hasLabel = _ref2.hasLabel, kind = _ref2.kind, size = _ref2.sizeProp, success = _ref2.success, themePaths = _ref2.themePaths, theme = _ref2.theme;
    var styles = [];
    // caller has specified a themeObj to use for styling
    // relevant for cases like pagination which looks to theme.pagination.button
    var themeObj = typeof kind === 'object' ? kind : theme.button;
    var iconOnly = hasIcon && !hasLabel;
    var pad = $592deb967468e376$var$padFromTheme(size, theme, themeObj, kind, iconOnly);
    themePaths.base.forEach(function(themePath) {
        var obj = $592deb967468e376$var$getPath(themeObj, themePath);
        if (obj) {
            styles.push((0, $4113023f9e0bafa0$exports.kindPartStyles)(obj, theme, colorValue));
            if (obj.border && obj.border.width && pad && !obj.padding) // Adjust padding from the button.size or just top button.padding
            // to deal with the kind's border width. But don't override any
            // padding in the kind itself for backward compatibility
            styles.push($592deb967468e376$var$adjustPadStyle(pad, obj.border.width, theme));
        }
    });
    // do the styling from the root of the object if caller passes one
    if (!themePaths.base.length && typeof kind === 'object') {
        var obj = kind;
        if (obj) {
            styles.push((0, $4113023f9e0bafa0$exports.kindPartStyles)(obj, theme, colorValue));
            if (obj.border && obj.border.width && pad && !obj.padding) // Adjust padding from the button.size or just top button.padding
            // to deal with the kind's border width. But don't override any
            // padding in the kind itself for backward compatibility
            styles.push($592deb967468e376$var$adjustPadStyle(pad, obj.border.width, theme));
        }
    }
    themePaths.hover.forEach(function(themePath) {
        var obj = $592deb967468e376$var$getPath(themeObj, themePath);
        if (obj) {
            var partStyles = (0, $4113023f9e0bafa0$exports.kindPartStyles)(obj, theme);
            var adjPadStyles = '';
            if (obj.border && obj.border.width && pad && !obj.padding) // Adjust padding from the button.size or just top button.padding
            // to deal with the hover's border width. But don't override any
            // padding in the hover or hover.kind itself for backward compatibility
            adjPadStyles = $592deb967468e376$var$adjustPadStyle(pad, obj.border.width, theme);
            if (partStyles.length > 0 && !busy && !success) styles.push((0, $592deb967468e376$var$_styledComponents.css)([
                "&:hover{",
                " ",
                "}"
            ], partStyles, adjPadStyles));
        }
    });
    return styles;
};
var $592deb967468e376$var$hoverIndicatorStyle = function hoverIndicatorStyle(_ref3) {
    var hoverIndicator = _ref3.hoverIndicator, theme = _ref3.theme;
    var themishObj = {};
    if (hoverIndicator === true || hoverIndicator === 'background') themishObj.background = theme.global.hover.background;
    else if (hoverIndicator.color || hoverIndicator.background) {
        if (hoverIndicator.background) themishObj.background = hoverIndicator.background;
        if (hoverIndicator.color) themishObj.color = hoverIndicator.color;
    } else themishObj.background = hoverIndicator;
    var styles = (0, $4113023f9e0bafa0$exports.kindPartStyles)(themishObj, theme);
    if (styles.length > 0) return (0, $592deb967468e376$var$_styledComponents.css)([
        "&:hover{",
        "}"
    ], styles);
    return '';
};
var $592deb967468e376$var$fillStyle = function fillStyle(fillContainer) {
    if (fillContainer === 'horizontal') return 'width: 100%;';
    if (fillContainer === 'vertical') return 'height: 100%;';
    if (fillContainer) return "\n      width: 100%;\n      height: 100%;\n      max-width: none;\n      flex: 1 0 auto;\n    ";
    return undefined;
};
var $592deb967468e376$var$plainStyle = function plainStyle(props) {
    return (0, $592deb967468e376$var$_styledComponents.css)([
        "outline:none;border:none;padding:0;text-align:inherit;color:inherit;",
        " ",
        ""
    ], props.icon && "\n    > svg {\n      display: flex;\n      align-self: center;\n      vertical-align: middle;\n    }\n  ", props.hasIcon && !props.hasLabel && "line-height: 0;");
};
var $592deb967468e376$var$StyledButtonKind = $592deb967468e376$export$64e6768d853ca4b8 = $592deb967468e376$var$_styledComponents["default"].button.withConfig({
    shouldForwardProp: function shouldForwardProp(prop) {
        return (0, $592deb967468e376$var$_isPropValid["default"])(prop) && ![
            'kind'
        ].includes(prop);
    }
}).withConfig({
    displayName: "StyledButtonKind",
    componentId: "sc-1vhfpnt-0"
})([
    "display:inline-block;box-sizing:border-box;cursor:pointer;font:inherit;text-decoration:none;margin:0;background:transparent;overflow:visible;text-transform:none;",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " &:focus{",
    "}&:focus:not(:focus-visible){",
    "}",
    " ",
    " ",
    " ",
    ""
], $4113023f9e0bafa0$exports.genericStyles, function(props) {
    return props.plain && $592deb967468e376$var$plainStyle(props);
}, function(props) {
    return !props.disabled && props.active && $4113023f9e0bafa0$exports.activeStyle;
}, function(props) {
    return !props.plain && $592deb967468e376$var$basicStyle(props);
}, function(props) {
    return !props.plain && $592deb967468e376$var$kindStyle(props);
}, function(props) {
    return !props.plain && props.pad && (0, $4113023f9e0bafa0$exports.edgeStyle)('padding', props.pad, false, undefined, props.theme);
}, function(props) {
    return !props.plain && props.align && "\n    text-align: " + props.align + ";\n    ";
}, function(props) {
    return !props.disabled && props.hoverIndicator && !props.busy && !props.success && $592deb967468e376$var$hoverIndicatorStyle(props);
}, function(props) {
    return props.disabled && (0, $4113023f9e0bafa0$exports.disabledStyle)(props.theme.button.disabled.opacity);
}, function(props) {
    return (!props.plain || props.focusIndicator) && (0, $4113023f9e0bafa0$exports.focusStyle)({
        inset: props.focusIndicator === 'inset'
    });
}, (0, $4113023f9e0bafa0$exports.unfocusStyle)(), function(props) {
    return !props.plain && props.theme.button.transition && "\n    transition-property: " + props.theme.button.transition.properties.join(',') + ";\n    transition-duration: " + props.theme.button.transition.duration + "s;\n    transition-timing-function: " + props.theme.button.transition.timing + ";\n  ";
}, function(props) {
    return props.fillContainer && $592deb967468e376$var$fillStyle(props.fillContainer);
}, function(props) {
    return props.theme.button && props.theme.button.extend;
}, function(props) {
    return (props.busy || props.success) && "\n    cursor: default;\n  ";
});




var $321c380efcde3e06$export$1e511d4a378977f5;
var $321c380efcde3e06$export$8bc5e3952d9f3838;
var $321c380efcde3e06$export$b9551c1d2e56e841;
var $321c380efcde3e06$export$ac1e1252ed898bd3;
"use strict";
$321c380efcde3e06$export$1e511d4a378977f5 = true;
$321c380efcde3e06$export$8bc5e3952d9f3838 = $321c380efcde3e06$export$b9551c1d2e56e841 = $321c380efcde3e06$export$ac1e1252ed898bd3 = void 0;

var $321c380efcde3e06$var$_react = $321c380efcde3e06$var$_interopRequireDefault((parcelRequire("2xPiy")));

var $321c380efcde3e06$var$_styledComponents = $321c380efcde3e06$var$_interopRequireWildcard((parcelRequire("iA1nz")));




function $321c380efcde3e06$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($321c380efcde3e06$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $321c380efcde3e06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $321c380efcde3e06$var$bounceDelay = (0, $321c380efcde3e06$var$_styledComponents.keyframes)([
    "0%,80%,100%{transform:scale(0.4);}40%{transform:scale(0.8);}"
]);
var $321c380efcde3e06$var$bounceDelayRule = (0, $321c380efcde3e06$var$_styledComponents.css)([
    "animation:",
    " 1.4s infinite ease-in-out both;"
], $321c380efcde3e06$var$bounceDelay);
var $321c380efcde3e06$var$Dot = (0, $321c380efcde3e06$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "BusyAnimation__Dot",
    componentId: "sc-feuivs-0"
})([
    "background-color:currentColor;width:8px;height:8px;border-radius:100%;display:inline-block;",
    " ",
    ""
], $321c380efcde3e06$var$bounceDelayRule, function(props) {
    return props.delay && "animation-delay: " + props.delay + ";";
});
var $321c380efcde3e06$var$EllipsisAnimation = $321c380efcde3e06$export$ac1e1252ed898bd3 = function EllipsisAnimation() {
    var _theme$button;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ $321c380efcde3e06$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        style: {
            position: 'absolute'
        },
        fill: true,
        alignContent: "center",
        justify: "center"
    }, /*#__PURE__*/ $321c380efcde3e06$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        alignSelf: "center",
        direction: "row",
        gap: (_theme$button = theme.button) == null || (_theme$button = _theme$button.busy) == null ? void 0 : _theme$button.gap
    }, /*#__PURE__*/ $321c380efcde3e06$var$_react["default"].createElement($321c380efcde3e06$var$Dot, {
        delay: "-0.32s"
    }), /*#__PURE__*/ $321c380efcde3e06$var$_react["default"].createElement($321c380efcde3e06$var$Dot, {
        delay: "-0.16s"
    }), /*#__PURE__*/ $321c380efcde3e06$var$_react["default"].createElement($321c380efcde3e06$var$Dot, null)));
};
var $321c380efcde3e06$var$grow = (0, $321c380efcde3e06$var$_styledComponents.keyframes)([
    "0%{opacity:0;transform:scale(.3);}20%{opacity:1;transform:scale(1.15);}30%{transform:scale(.9);}45%{transform:scale(1.05);}55%{transform:scale(1);}100%{transform:scale(1);}"
]);
var $321c380efcde3e06$var$GrowCheckmark = $321c380efcde3e06$export$b9551c1d2e56e841 = (0, $321c380efcde3e06$var$_styledComponents["default"])($efa3551e30470d99$export$4f481e0a96cfbed6).withConfig({
    displayName: "BusyAnimation__GrowCheckmark",
    componentId: "sc-feuivs-1"
})([
    "position:absolute;align-self:center;animation:",
    " 0.9s ease-in-out;"
], $321c380efcde3e06$var$grow);
var $321c380efcde3e06$var$StyledBusyContents = $321c380efcde3e06$export$8bc5e3952d9f3838 = $321c380efcde3e06$var$_styledComponents["default"].div.withConfig($9a7099e779e83517$export$373e75d802fd707).withConfig({
    displayName: "BusyAnimation__StyledBusyContents",
    componentId: "sc-feuivs-2"
})([
    "opacity:",
    ";}"
], function(props) {
    return props.animating ? 0 : 1;
});



var $2449fa876f4654de$var$_excluded = [
    "active",
    "align",
    "aria-label",
    "badge",
    "busy",
    "color",
    "children",
    "disabled",
    "icon",
    "focusIndicator",
    "gap",
    "fill",
    "href",
    "justify",
    "kind",
    "label",
    "messages",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseOut",
    "onMouseOver",
    "pad",
    "plain",
    "primary",
    "reverse",
    "secondary",
    "selected",
    "size",
    "success",
    "tip",
    "type",
    "a11yTitle",
    "as"
];
function $2449fa876f4654de$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $2449fa876f4654de$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($2449fa876f4654de$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $2449fa876f4654de$var$_extends() {
    return $2449fa876f4654de$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2449fa876f4654de$var$_extends.apply(null, arguments);
}
function $2449fa876f4654de$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $2449fa876f4654de$var$RelativeBox = (0, $2449fa876f4654de$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "Button__RelativeBox",
    componentId: "sc-zuqsuw-0"
})([
    "position:relative;"
]);
// We have two Styled* components to separate
// the newer default|primary|secondary approach,
// which we use the term "kind" to refer to,
// from the previous approach. Hopefully, when we get to grommet v3,
// we can drop the old way and just use kind.
//
// In the kind approach, we rely on the basic structure of the theme
// being repeated. For example: button.default, button.active,
// button.active.default all refer to a similar object containing
// { background, border, color, padding }.
// This allows us to use the same code to evaluate color and generate CSS.
// We just need to build up CSS, since selectors override previous ones.
// See StyledButtonKind.kindStyles() for this.
// And we build down to determine icon color, once we have a color from
// the latest applicable state, we can stop. See Button.getIconColor() for this.
// backgroundAndTextColor() is used in both cases to ensure we are determining
// color in the same way, so the icon and label align.
// only when default is in the theme
// Used to get the color for the icon to match what StyledButtonKind
// and backgroundStyle() will do for the label.
// The paths are ordered from basic to specific. Go through them
// specific to base until we find one that has a color and use that.
var $2449fa876f4654de$var$getIconColor = function getIconColor(paths, theme, colorProp, kind) {
    if (paths === void 0) paths = [];
    var result = [];
    var index = paths.length - 1;
    // caller has specified a themeObj to use for styling
    // relevant for cases like pagination which looks to theme.pagination.button
    if (typeof kind === 'object') index = 0;
    // stop when we have a color or no more paths
    while(index >= 0 && !result[1]){
        var baseObj = typeof kind === 'object' && kind || theme.button;
        var obj = baseObj;
        // find sub-object under the button theme that corresponds with this path
        // for example: 'active.primary'
        if (paths[index]) {
            var parts = paths[index].split('.');
            while(obj && parts.length)obj = obj[parts.shift()];
        }
        if (obj) {
            var _obj;
            // use passed in color for background if the theme has a background color
            var background = colorProp && obj.background && obj.background.color ? colorProp : obj.background;
            // if theme object explicitly sets the color to undefined, pass false
            // to indicate that the theme doesn't want any text color
            var objColor = obj.color || (Object.prototype.hasOwnProperty.call(obj, 'color') && obj.color === undefined ? false : undefined);
            var color = void 0;
            if ((_obj = obj) != null && (_obj = _obj.icon) != null && (_obj = _obj.props) != null && _obj.color) color = obj.icon.props.color;
            else if (paths[index + 1]) {
                var _obj2;
                var _parts = paths[index + 1].split('.');
                while(baseObj && _parts.length)obj = baseObj[_parts.shift()];
                if ((_obj2 = obj) != null && (_obj2 = _obj2.icon) != null && (_obj2 = _obj2.props) != null && _obj2.color) color = obj.icon.props.color;
            }
            // use passed in color for text if the theme doesn't have
            // background or border color
            if (!color) color = colorProp && (!obj.background || !obj.background.color) && (!obj.border || !obj.border.color) ? colorProp : objColor;
            result = (0, $4113023f9e0bafa0$exports.backgroundAndTextColors)(background, color, theme);
        }
        index -= 1;
    }
    return result[1] || undefined;
};
// get the icon for the current button state
var $2449fa876f4654de$var$getKindIcon = function getKindIcon(paths, theme, kind) {
    if (paths === void 0) paths = [];
    var result;
    var index = paths.length - 1;
    // caller has specified a themeObj to use for styling
    // relevant for cases like pagination which looks to theme.pagination.button
    if (typeof kind === 'object') index = 0;
    // stop when we have a color or no more paths
    while(index >= 0 && !result){
        var _obj3;
        var obj = typeof kind === 'object' && kind || theme.button;
        // find sub-object under the button theme that corresponds with this path
        // for example: 'active.primary'
        if (paths[index]) {
            var parts = paths[index].split('.');
            while(obj && parts.length)obj = obj[parts.shift()];
        }
        if ((_obj3 = obj) != null && _obj3.icon) result = obj.icon;
        index -= 1;
    }
    return result || undefined;
};
var $2449fa876f4654de$var$getPropertyColor = function getPropertyColor(property, paths, theme, kind, primary) {
    if (paths === void 0) paths = [];
    var result;
    if (kind) {
        var obj = typeof kind === 'object' && kind || theme.button;
        // index 0 is default state
        if (paths[0]) {
            var parts = paths[0].split('.');
            while(obj && parts.length)obj = obj[parts.shift()];
        }
        if (obj) result = obj[property] || obj[property] && obj[property].color;
    } else if (primary && theme && theme.button && theme.button.primary) result = theme.button.primary[property] || theme.button.primary[property] && theme.button.primary[property].color;
    else result = theme && theme.button && theme.button[property] || theme && theme.button && theme.button[property] && theme.button[property].color;
    return result;
};
var $2449fa876f4654de$var$Button = $2449fa876f4654de$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $2449fa876f4654de$var$_react.forwardRef)(function(_ref, ref) {
    var _theme$global$depreca2, _theme$button$kind, _theme$button2;
    var active = _ref.active, _ref$align = _ref.align, align = _ref$align === void 0 ? 'center' : _ref$align, ariaLabel = _ref['aria-label'], badgeProp = _ref.badge, busy = _ref.busy, color = _ref.color, children = _ref.children, disabled = _ref.disabled, icon = _ref.icon, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, gap = _ref.gap, fill = _ref.fill, href = _ref.href, justify = _ref.justify, kindArg = _ref.kind, label = _ref.label, messages = _ref.messages, _onBlur = _ref.onBlur, onClickProp = _ref.onClick, _onFocus = _ref.onFocus, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, pad = _ref.pad, plain = _ref.plain, primary = _ref.primary, reverseProp = _ref.reverse, secondary = _ref.secondary, selected = _ref.selected, sizeProp = _ref.size, success = _ref.success, tip = _ref.tip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$a11yTitle = _ref.a11yTitle, a11yTitle = _ref$a11yTitle === void 0 ? typeof tip === 'string' ? tip : undefined : _ref$a11yTitle, as = _ref.as, rest = $2449fa876f4654de$var$_objectWithoutPropertiesLoose(_ref, $2449fa876f4654de$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useContext = (0, $2449fa876f4654de$var$_react.useContext)($cddec80c12094a96$export$b709306b005c3ef), buttonOptions = _useContext.button;
    var _useState = (0, $2449fa876f4654de$var$_react.useState)(), focus = _useState[0], setFocus = _useState[1];
    var _useState2 = (0, $2449fa876f4654de$var$_react.useState)(false), hover = _useState2[0], setHover = _useState2[1];
    var announce = (0, $2449fa876f4654de$var$_react.useContext)($cfbcb74d4f54e56b$export$dcc8f4bff0d51f50);
    var _useContext2 = (0, $2449fa876f4654de$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext2.format;
    if (busy && success) console.warn('Button cannot have both busy and success set to true.');
    (0, $2449fa876f4654de$var$_react.useEffect)(function() {
        if (busy) announce(format({
            id: 'button.busy',
            messages: messages
        }));
        else if (success) announce(format({
            id: 'button.success',
            messages: messages
        }));
    }, [
        announce,
        busy,
        format,
        messages,
        success
    ]);
    if ((icon || label) && children) console.warn('Button should not have children if icon or label is provided');
    (0, $2449fa876f4654de$var$_react.useEffect)(function() {
        var _theme$global$depreca;
        if ((_theme$global$depreca = theme.global.deprecated) != null && (_theme$global$depreca = _theme$global$depreca.button) != null && _theme$global$depreca.kind && kindArg) {
            var deprecatedKind = theme.global.deprecated.button.kind.find(function(item) {
                return item.name === kindArg;
            });
            if (deprecatedKind) console.warn(deprecatedKind.message || kindArg + " is deprecated.");
        }
    }, [
        kindArg,
        (_theme$global$depreca2 = theme.global.deprecated) == null || (_theme$global$depreca2 = _theme$global$depreca2.button) == null ? void 0 : _theme$global$depreca2.kind
    ]);
    var skeleton = (0, $ab65104eb6f9aa8a$exports.useSkeleton)();
    var sendAnalytics = (0, $995522def9ecf485$exports.useAnalytics)();
    var onClick = (0, $2449fa876f4654de$var$_react.useCallback)(function(event) {
        sendAnalytics({
            type: 'buttonClick',
            element: (0, $4113023f9e0bafa0$exports.findButtonParent)(event.target),
            event: event,
            href: href,
            label: typeof label === 'string' ? label : undefined
        });
        if (onClickProp) onClickProp(event);
    }, [
        onClickProp,
        sendAnalytics,
        href,
        label
    ]);
    // kindArg is object if we are referencing a theme object
    // outside of theme.button
    var kindObj = (0, $2449fa876f4654de$var$_react.useMemo)(function() {
        return typeof kindArg === 'object';
    }, [
        kindArg
    ]);
    // if the theme has button.default, what kind of Button is this
    var kind = (0, $2449fa876f4654de$var$_react.useMemo)(function() {
        if (theme.button["default"] || kindObj) {
            if (kindArg) return kindArg;
            if (primary) return 'primary';
            if (secondary) return 'secondary';
            return 'default';
        }
        return undefined; // pre-default, no kind
    }, [
        kindArg,
        kindObj,
        primary,
        secondary,
        theme
    ]);
    // for backwards compatibility, no-kind button theme did not
    // default to size "medium" on buttons with no size prop
    var size = sizeProp || kind && 'medium' || undefined;
    // When we have a kind and are not plain, themePaths stores the relative
    // paths within the theme for the current kind and state of the button.
    // These paths are used with getIconColor() above and kindStyle() within
    // StyledButtonKind.
    var themePaths = (0, $2449fa876f4654de$var$_react.useMemo)(function() {
        if (!kind || plain) return undefined;
        var result = {
            base: [],
            hover: []
        };
        if (!kindObj) result.base.push(kind);
        if (selected) {
            result.base.push('selected');
            if (!kindObj) result.base.push("selected." + kind);
        }
        if (disabled) {
            result.base.push('disabled');
            if (!kindObj) result.base.push("disabled." + kind);
        } else {
            if (active) {
                result.base.push('active');
                if (!kindObj) result.base.push("active." + kind);
            }
            result.hover.push('hover');
            if (!kindObj) result.hover.push("hover." + kind);
            if (active) {
                result.hover.push("hover.active");
                if (!kindObj) result.hover.push("hover.active." + kind);
            }
        }
        return result;
    }, [
        active,
        disabled,
        kind,
        kindObj,
        plain,
        selected
    ]);
    // only used when theme does not have button.default
    var isDarkBackground = function isDarkBackground() {
        var backgroundColor = (0, $4113023f9e0bafa0$exports.normalizeBackground)((0, $4113023f9e0bafa0$exports.normalizeColor)(color || theme.button.primary && theme.button.primary.color || theme.global.colors.control || 'brand', theme), theme);
        return (0, $4113023f9e0bafa0$exports.colorIsDark)(backgroundColor, theme);
    };
    var onMouseOverButton = function onMouseOverButton(event) {
        setHover(true);
        if (onMouseOver) onMouseOver(event);
    };
    var onMouseOutButton = function onMouseOutButton(event) {
        setHover(false);
        if (onMouseOut) onMouseOut(event);
    };
    var kindIcon = hover && $2449fa876f4654de$var$getKindIcon(themePaths == null ? void 0 : themePaths.hover, theme, kind) || $2449fa876f4654de$var$getKindIcon(themePaths == null ? void 0 : themePaths.base, theme, kind);
    var buttonIcon = icon || kindIcon;
    // only change color if user did not specify the color themselves...
    if (icon && !icon.props.color) {
        if (kind) {
            if (!plain) {
                // match what the label will use
                var iconColor = hover && $2449fa876f4654de$var$getIconColor(themePaths.hover, theme) || $2449fa876f4654de$var$getIconColor(themePaths.base, theme, color, kind);
                if (iconColor) buttonIcon = /*#__PURE__*/ (0, $2449fa876f4654de$var$_react.cloneElement)(icon, {
                    color: iconColor
                });
            }
        } else if (primary) buttonIcon = /*#__PURE__*/ (0, $2449fa876f4654de$var$_react.cloneElement)(icon, {
            color: theme.global.colors.text[isDarkBackground() ? 'dark' : 'light']
        });
    } else if (kindIcon && !plain) {
        var _iconColor = hover && $2449fa876f4654de$var$getIconColor(themePaths.hover, theme) || $2449fa876f4654de$var$getIconColor(themePaths.base, theme, color, kind);
        if (_iconColor) buttonIcon = /*#__PURE__*/ (0, $2449fa876f4654de$var$_react.cloneElement)(kindIcon, {
            color: _iconColor
        });
    }
    buttonIcon = (0, $4113023f9e0bafa0$exports.useSizedIcon)(buttonIcon, size, theme);
    if (skeleton) {
        var _theme$text, _theme$button$size;
        return /*#__PURE__*/ $2449fa876f4654de$var$_react["default"].createElement($ab65104eb6f9aa8a$exports.Skeleton, $2449fa876f4654de$var$_extends({
            ref: ref,
            height: ((_theme$text = theme.text[size || 'medium']) == null ? void 0 : _theme$text.height) || size,
            a11yTitle: a11yTitle
        }, rest, (_theme$button$size = theme.button.size) == null ? void 0 : _theme$button$size[size || 'medium'], theme.button.skeleton));
    }
    var reverse = reverseProp != null ? reverseProp : (_theme$button$kind = theme.button[kind]) == null ? void 0 : _theme$button$kind.reverse;
    var domTag = !as && href ? 'a' : as;
    var first = reverse ? label : buttonIcon;
    var second = reverse ? buttonIcon : label;
    var contents;
    if (first && second) {
        var _theme$button;
        contents = /*#__PURE__*/ $2449fa876f4654de$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            direction: ((_theme$button = theme.button) == null || (_theme$button = _theme$button[kind]) == null ? void 0 : _theme$button.direction) || 'row',
            align: "center",
            justify: justify || (align === 'center' ? 'center' : 'between'),
            gap: gap || theme.button.gap,
            responsive: false
        }, first, second);
    } else if (typeof children === 'function') contents = children({
        active: active,
        disabled: disabled,
        hover: hover,
        focus: focus
    });
    else contents = first || second || children;
    var background = $2449fa876f4654de$var$getPropertyColor('background', themePaths && themePaths.base, theme, kind, primary);
    var border = $2449fa876f4654de$var$getPropertyColor('border', themePaths && themePaths.base, theme, kind, primary);
    // set the badge relative to the button content
    // when the button doesn't have background or border
    // (!kind && icon && !label) is necessary because for old button logic,
    // if button has icon but not label, it will be considered "plain",
    // so no border or background will be applied
    var innerBadge = ((_theme$button2 = theme.button) == null || (_theme$button2 = _theme$button2.badge) == null ? void 0 : _theme$button2.align) !== 'container' && (!background && !border || !kind && icon && !label);
    if (badgeProp && innerBadge) contents = /*#__PURE__*/ $2449fa876f4654de$var$_react["default"].createElement($8d3bd995936cfd81$export$37acb3580601e69a, {
        content: badgeProp
    }, contents);
    if (busy || success) {
        var _theme$button3;
        // match what the label will use
        var animationColor;
        if (kind) {
            if (!plain) animationColor = hover && $2449fa876f4654de$var$getIconColor(themePaths.hover, theme) || $2449fa876f4654de$var$getIconColor(themePaths.base, theme, color, kind);
        } else if (primary) animationColor = theme.global.colors.text[isDarkBackground() ? 'dark' : 'light'];
        contents = /*#__PURE__*/ // position relative is necessary to have the animation
        // display over the button content
        $2449fa876f4654de$var$_react["default"].createElement($2449fa876f4654de$var$RelativeBox, {
            flex: false
        }, busy && /*#__PURE__*/ $2449fa876f4654de$var$_react["default"].createElement($321c380efcde3e06$export$ac1e1252ed898bd3, null), success && /*#__PURE__*/ $2449fa876f4654de$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            style: {
                position: 'absolute'
            },
            fill: true,
            alignContent: "center",
            justify: "center"
        }, /*#__PURE__*/ $2449fa876f4654de$var$_react["default"].createElement($321c380efcde3e06$export$b9551c1d2e56e841, {
            color: animationColor,
            "aria-hidden": true,
            as: (_theme$button3 = theme.button) == null || (_theme$button3 = _theme$button3.busy) == null || (_theme$button3 = _theme$button3.icons) == null ? void 0 : _theme$button3.success
        })), /*#__PURE__*/ $2449fa876f4654de$var$_react["default"].createElement($321c380efcde3e06$export$8bc5e3952d9f3838, {
            animating: busy || success
        }, contents));
    }
    var styledButtonResult;
    if (kind) styledButtonResult = /*#__PURE__*/ $2449fa876f4654de$var$_react["default"].createElement($592deb967468e376$export$64e6768d853ca4b8, $2449fa876f4654de$var$_extends({}, rest, {
        as: domTag,
        ref: ref,
        active: active,
        align: align,
        "aria-label": ariaLabel || a11yTitle,
        busy: busy,
        badge: badgeProp,
        colorValue: color,
        disabled: disabled,
        hasIcon: !!icon,
        gap: gap,
        hasLabel: !!label,
        icon: icon,
        fillContainer: fill,
        focus: focus,
        focusIndicator: focusIndicator,
        href: href,
        kind: kind,
        themePaths: themePaths,
        onClick: !busy && !success ? onClick : undefined,
        onFocus: function onFocus(event) {
            setFocus(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        onMouseOver: onMouseOverButton,
        onMouseOut: onMouseOutButton,
        pad: pad,
        plain: plain || (buttonOptions == null ? void 0 : buttonOptions.childrenPlain) !== false && $2449fa876f4654de$var$_react.Children.count(children) > 0,
        primary: primary,
        selected: selected,
        sizeProp: size,
        success: success,
        type: !href ? type : undefined
    }, passThemeFlag), contents);
    else styledButtonResult = /*#__PURE__*/ $2449fa876f4654de$var$_react["default"].createElement($b4ed02cd88b378ae$export$2d5d2ba3c7c8c40b, $2449fa876f4654de$var$_extends({}, rest, {
        as: domTag,
        ref: ref,
        "aria-label": ariaLabel || a11yTitle,
        busy: busy,
        colorValue: color,
        active: active,
        selected: selected,
        disabled: disabled,
        hasIcon: !!icon,
        gap: gap,
        hasLabel: !!label,
        fillContainer: fill,
        focus: focus,
        focusIndicator: focusIndicator,
        href: href,
        kind: kind,
        themePaths: themePaths,
        onClick: !busy && !success ? onClick : undefined,
        onFocus: function onFocus(event) {
            setFocus(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        onMouseOver: onMouseOverButton,
        onMouseOut: onMouseOutButton,
        pad: pad || !plain,
        plain: typeof plain !== 'undefined' ? plain : (buttonOptions == null ? void 0 : buttonOptions.childrenPlain) !== false && $2449fa876f4654de$var$_react.Children.count(children) > 0 || icon && !label,
        primary: primary,
        sizeProp: size,
        success: success,
        type: !href ? type : undefined
    }, passThemeFlag), contents);
    if (tip) {
        if (typeof tip === 'string') styledButtonResult = /*#__PURE__*/ $2449fa876f4654de$var$_react["default"].createElement($7946e73be6fde87a$export$c92c6401b52a9298, {
            content: tip
        }, styledButtonResult);
        else styledButtonResult = /*#__PURE__*/ $2449fa876f4654de$var$_react["default"].createElement($7946e73be6fde87a$export$c92c6401b52a9298, tip, styledButtonResult);
    }
    // if button has background or border, place badge relative
    // to outer edge of button
    if (badgeProp && !innerBadge) styledButtonResult = /*#__PURE__*/ $2449fa876f4654de$var$_react["default"].createElement($8d3bd995936cfd81$export$37acb3580601e69a, {
        content: badgeProp
    }, styledButtonResult);
    return styledButtonResult;
});
$2449fa876f4654de$var$Button.displayName = 'Button';
$2449fa876f4654de$var$Button.propTypes = $5c5e21b37c7cd707$export$932f054f6b4bba8d;


$fb68f765668b25d0$export$353f5b6fc5456de1 = $2449fa876f4654de$export$353f5b6fc5456de1;


var $6978a6eff11602a9$exports = {};

$parcel$export($6978a6eff11602a9$exports, "__esModule", function () { return $6978a6eff11602a9$export$1e511d4a378977f5; }, function (v) { return $6978a6eff11602a9$export$1e511d4a378977f5 = v; });
$parcel$export($6978a6eff11602a9$exports, "Collapsible", function () { return $6978a6eff11602a9$export$6eb0f7ddcda6131f; }, function (v) { return $6978a6eff11602a9$export$6eb0f7ddcda6131f = v; });
var $6978a6eff11602a9$export$1e511d4a378977f5;
var $6978a6eff11602a9$export$6eb0f7ddcda6131f;
"use strict";
$6978a6eff11602a9$export$1e511d4a378977f5 = true;
$6978a6eff11602a9$export$6eb0f7ddcda6131f = void 0;
var $ee1ba0da75180c1c$export$1e511d4a378977f5;
var $ee1ba0da75180c1c$export$6eb0f7ddcda6131f;
"use strict";
$ee1ba0da75180c1c$export$1e511d4a378977f5 = true;
$ee1ba0da75180c1c$export$6eb0f7ddcda6131f = void 0;

var $ee1ba0da75180c1c$var$_react = $ee1ba0da75180c1c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $ee1ba0da75180c1c$var$_styledComponents = $ee1ba0da75180c1c$var$_interopRequireDefault((parcelRequire("iA1nz")));



var $b6ecb42f1f593fb3$export$1e511d4a378977f5;
var $b6ecb42f1f593fb3$export$2c6a2ea456400009;
"use strict";
$b6ecb42f1f593fb3$export$1e511d4a378977f5 = true;
$b6ecb42f1f593fb3$export$2c6a2ea456400009 = void 0;

var $b6ecb42f1f593fb3$var$_propTypes = $b6ecb42f1f593fb3$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $b6ecb42f1f593fb3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $b6ecb42f1f593fb3$var$PropType = {};
$b6ecb42f1f593fb3$var$PropType = {
    open: $b6ecb42f1f593fb3$var$_propTypes["default"].bool,
    direction: $b6ecb42f1f593fb3$var$_propTypes["default"].oneOf([
        'horizontal',
        'vertical'
    ])
};
var $b6ecb42f1f593fb3$var$CollapsiblePropTypes = $b6ecb42f1f593fb3$export$2c6a2ea456400009 = $b6ecb42f1f593fb3$var$PropType;



function $ee1ba0da75180c1c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $ee1ba0da75180c1c$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($ee1ba0da75180c1c$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $ee1ba0da75180c1c$var$AnimatedBox = (0, $ee1ba0da75180c1c$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "Collapsible__AnimatedBox",
    componentId: "sc-15kniua-0"
})([
    "",
    ""
], function(props) {
    return props.shouldOpen ? "visibility: hidden;\n      position: absolute;\n      pointer-events: none;" : "transition: " + ("max-" + props.dimension + " " + props.speedProp + "ms, opacity " + props.speedProp + "ms") + ";\n      opacity: " + (props.open ? 1 : 0) + ";\n      overflow: " + (props.animate || !props.open ? 'hidden' : 'visible') + ";";
});
var $ee1ba0da75180c1c$var$Collapsible = $ee1ba0da75180c1c$export$6eb0f7ddcda6131f = /*#__PURE__*/ (0, $ee1ba0da75180c1c$var$_react.forwardRef)(function(_ref, ref) {
    var children = _ref.children, direction = _ref.direction, openArg = _ref.open;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useState = (0, $ee1ba0da75180c1c$var$_react.useState)(openArg), open = _useState[0], setOpen = _useState[1];
    var _useState2 = (0, $ee1ba0da75180c1c$var$_react.useState)(false), animate = _useState2[0], setAnimate = _useState2[1];
    var _useState3 = (0, $ee1ba0da75180c1c$var$_react.useState)(theme.collapsible.minSpeed), speed = _useState3[0], setSpeed = _useState3[1];
    var dimension = (0, $ee1ba0da75180c1c$var$_react.useMemo)(function() {
        return direction === 'horizontal' ? 'width' : 'height';
    }, [
        direction
    ]);
    var containerRef = (0, $4113023f9e0bafa0$exports.useForwardedRef)(ref);
    var sizeRef = (0, $ee1ba0da75180c1c$var$_react.useRef)(0);
    var shouldOpen = !open && openArg;
    var shouldClose = open && !openArg;
    // when the caller changes openArg, trigger animation
    (0, $ee1ba0da75180c1c$var$_react.useEffect)(function() {
        if (openArg !== open) {
            setAnimate(true);
            setOpen(openArg);
        }
    }, [
        open,
        openArg
    ]);
    // prepare to open or close
    (0, $6a5275ec792307a1$export$e5c5a5f917a5871c)(function() {
        var container = containerRef.current;
        // skip this if animation is in progress
        if (!animate && shouldOpen) {
            var parentPrevPosition = container.parentNode.style.position;
            container.parentNode.style.position = 'relative';
            var _container$getBoundin = container.getBoundingClientRect(), size = _container$getBoundin[dimension];
            container.parentNode.style.position = parentPrevPosition;
            sizeRef.current = size;
        }
        if (shouldOpen) container.style["max-" + dimension] = 0;
        else if (shouldClose) {
            var _container$getBoundin2 = container.getBoundingClientRect(), _size = _container$getBoundin2[dimension];
            container.style["max-" + dimension] = _size + "px";
        }
    }, [
        shouldOpen,
        shouldClose,
        containerRef,
        dimension,
        animate
    ]);
    (0, $ee1ba0da75180c1c$var$_react.useEffect)(function() {
        if (shouldOpen || shouldClose) {
            var container = containerRef.current;
            var _theme$collapsible = theme.collapsible, minSpeed = _theme$collapsible.minSpeed, baseline = _theme$collapsible.baseline;
            var nextSpeed = Math.max(sizeRef.current / baseline * minSpeed, minSpeed);
            setSpeed(nextSpeed);
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    // Change the max to where we want to end up, the transition will
                    // animate to get there. We do this in an animation frame to
                    // give our starter setting a chance to fully render.
                    container.style["max-" + dimension] = shouldOpen ? sizeRef.current + "px" : 0;
                });
            });
        }
    }, [
        shouldOpen,
        shouldClose,
        containerRef,
        dimension,
        theme
    ]);
    (0, $ee1ba0da75180c1c$var$_react.useEffect)(function() {
        if (animate) {
            var container = containerRef.current;
            var timer = setTimeout(function() {
                setAnimate(false);
                container.removeAttribute('style');
            }, speed);
            return function() {
                return clearTimeout(timer);
            };
        }
        return undefined;
    // we need open here to cancel the timer and restart it
    }, [
        animate,
        containerRef,
        speed,
        open
    ]);
    return /*#__PURE__*/ $ee1ba0da75180c1c$var$_react["default"].createElement($ee1ba0da75180c1c$var$AnimatedBox, {
        "aria-hidden": !open,
        ref: containerRef,
        open: open,
        animate: animate,
        dimension: dimension,
        speedProp: speed,
        shouldOpen: !animate && shouldOpen
    }, shouldOpen || open || animate ? children : null);
});
$ee1ba0da75180c1c$var$Collapsible.displayName = 'Collapsible';
$ee1ba0da75180c1c$var$Collapsible.propTypes = $b6ecb42f1f593fb3$export$2c6a2ea456400009;


$6978a6eff11602a9$export$6eb0f7ddcda6131f = $ee1ba0da75180c1c$export$6eb0f7ddcda6131f;


var $2d67f2629ee502eb$exports = {};

$parcel$export($2d67f2629ee502eb$exports, "__esModule", function () { return $2d67f2629ee502eb$export$1e511d4a378977f5; }, function (v) { return $2d67f2629ee502eb$export$1e511d4a378977f5 = v; });
$parcel$export($2d67f2629ee502eb$exports, "Heading", function () { return $2d67f2629ee502eb$export$a8a3e93435678ff9; }, function (v) { return $2d67f2629ee502eb$export$a8a3e93435678ff9 = v; });
var $2d67f2629ee502eb$export$1e511d4a378977f5;
var $2d67f2629ee502eb$export$a8a3e93435678ff9;
"use strict";
$2d67f2629ee502eb$export$1e511d4a378977f5 = true;
$2d67f2629ee502eb$export$a8a3e93435678ff9 = void 0;
var $1c76f0fc20519fad$export$1e511d4a378977f5;
var $1c76f0fc20519fad$export$a8a3e93435678ff9;
"use strict";
$1c76f0fc20519fad$export$1e511d4a378977f5 = true;
$1c76f0fc20519fad$export$a8a3e93435678ff9 = void 0;

var $1c76f0fc20519fad$var$_react = $1c76f0fc20519fad$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $cfca6947a32aa844$export$1e511d4a378977f5;
var $cfca6947a32aa844$export$8c1dfb3a3dfd5501;
"use strict";
$cfca6947a32aa844$export$1e511d4a378977f5 = true;
$cfca6947a32aa844$export$8c1dfb3a3dfd5501 = void 0;

var $cfca6947a32aa844$var$_styledComponents = $cfca6947a32aa844$var$_interopRequireWildcard((parcelRequire("iA1nz")));

function $cfca6947a32aa844$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($cfca6947a32aa844$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $cfca6947a32aa844$var$sizeStyle = function sizeStyle(props) {
    // size is a combination of the level and size properties
    var size = props.size || 'medium';
    var headingTheme = props.theme.heading;
    var levelStyle = headingTheme.level[props.level];
    if (levelStyle) {
        var data = levelStyle[size];
        var styles = [
            (0, $cfca6947a32aa844$var$_styledComponents.css)([
                "font-size:",
                ";line-height:",
                ";max-width:",
                ";font-weight:",
                ";overflow-wrap:",
                ";"
            ], data ? data.size : size, data ? data.height : 'normal', props.fillProp && 'none' || data && data.maxWidth || levelStyle.medium.maxWidth, props.weight || levelStyle.font.weight || headingTheme.weight, props.overflowWrap)
        ];
        if (props.responsive && headingTheme.responsiveBreakpoint) {
            var breakpoint = props.theme.global.breakpoints[headingTheme.responsiveBreakpoint];
            if (breakpoint) {
                var responsiveData = headingTheme.level[props.level + 1] ? headingTheme.level[props.level + 1][size] : headingTheme.level[props.level][size];
                if (responsiveData) styles.push((0, $4113023f9e0bafa0$exports.breakpointStyle)(breakpoint, "\n            font-size: " + responsiveData.size + ";\n            line-height: " + responsiveData.height + ";\n            max-width: " + (props.fillProp && 'none' || responsiveData.maxWidth) + ";\n          ", props.responsive));
            }
        }
        return styles;
    }
    console.warn("Heading level " + props.level + " is not defined in your theme.");
    return '';
};
var $cfca6947a32aa844$var$fontFamily = function fontFamily(props) {
    var _ref = props.theme.heading.level[props.level] || {}, font = _ref.font;
    if (font && font.family) return (0, $cfca6947a32aa844$var$_styledComponents.css)([
        "font-family:",
        ";"
    ], font.family);
    return props.theme.heading.font ? (0, $cfca6947a32aa844$var$_styledComponents.css)([
        "font-family:",
        ";"
    ], props.theme.heading.font.family) : '';
};
var $cfca6947a32aa844$var$truncateStyle = "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n";
var $cfca6947a32aa844$var$colorStyle = (0, $cfca6947a32aa844$var$_styledComponents.css)([
    "color:",
    ";"
], function(props) {
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(props.colorProp || props.theme.heading.color, props.theme);
});
var $cfca6947a32aa844$var$StyledHeading = $cfca6947a32aa844$export$8c1dfb3a3dfd5501 = $cfca6947a32aa844$var$_styledComponents["default"].h1.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledHeading",
    componentId: "sc-1rdh4aw-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], $4113023f9e0bafa0$exports.genericStyles, function(props) {
    return $cfca6947a32aa844$var$fontFamily(props);
}, function(props) {
    return $cfca6947a32aa844$var$sizeStyle(props);
}, function(props) {
    return props.textAlign && $4113023f9e0bafa0$exports.textAlignStyle;
}, function(props) {
    return props.truncate && $cfca6947a32aa844$var$truncateStyle;
}, function(props) {
    return (props.colorProp || props.theme.heading.color) && $cfca6947a32aa844$var$colorStyle;
}, function(props) {
    return props.theme.heading && props.theme.heading.extend;
});


var $604104a14f61c1ef$export$1e511d4a378977f5;
var $604104a14f61c1ef$export$c6750152f5d8efcb;
"use strict";
$604104a14f61c1ef$export$1e511d4a378977f5 = true;
$604104a14f61c1ef$export$c6750152f5d8efcb = void 0;

var $604104a14f61c1ef$var$_propTypes = $604104a14f61c1ef$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $604104a14f61c1ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $604104a14f61c1ef$var$_extends() {
    return $604104a14f61c1ef$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $604104a14f61c1ef$var$_extends.apply(null, arguments);
}
var $604104a14f61c1ef$var$PropType = {};
$604104a14f61c1ef$var$PropType = $604104a14f61c1ef$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    color: $5897bd367fbd90c1$export$fc4c368d97afb623,
    fill: $604104a14f61c1ef$var$_propTypes["default"].bool,
    level: $604104a14f61c1ef$var$_propTypes["default"].oneOf([
        1,
        2,
        3,
        4,
        5,
        6,
        '1',
        '2',
        '3',
        '4',
        '5',
        '6'
    ]),
    overflowWrap: $604104a14f61c1ef$var$_propTypes["default"].oneOfType([
        $604104a14f61c1ef$var$_propTypes["default"].oneOf([
            'normal',
            'break-word',
            'anywhere'
        ]),
        $604104a14f61c1ef$var$_propTypes["default"].string
    ]),
    responsive: $604104a14f61c1ef$var$_propTypes["default"].bool,
    size: $604104a14f61c1ef$var$_propTypes["default"].oneOfType([
        $604104a14f61c1ef$var$_propTypes["default"].oneOf([
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        $604104a14f61c1ef$var$_propTypes["default"].string
    ]),
    textAlign: $604104a14f61c1ef$var$_propTypes["default"].oneOf([
        'start',
        'center',
        'end',
        'justify'
    ]),
    truncate: $604104a14f61c1ef$var$_propTypes["default"].bool,
    weight: $604104a14f61c1ef$var$_propTypes["default"].oneOfType([
        $604104a14f61c1ef$var$_propTypes["default"].oneOf([
            'normal',
            'bold',
            'lighter',
            'bolder'
        ]),
        $604104a14f61c1ef$var$_propTypes["default"].number,
        $604104a14f61c1ef$var$_propTypes["default"].string
    ])
});
var $604104a14f61c1ef$var$HeadingPropTypes = $604104a14f61c1ef$export$c6750152f5d8efcb = $604104a14f61c1ef$var$PropType;




var $e6e4fd5c14c58da8$export$1e511d4a378977f5;
var $e6e4fd5c14c58da8$export$6db3fc939e78ca56;
"use strict";
$e6e4fd5c14c58da8$export$1e511d4a378977f5 = true;
$e6e4fd5c14c58da8$export$6db3fc939e78ca56 = void 0;

var $e6e4fd5c14c58da8$var$_react = $e6e4fd5c14c58da8$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $e6e4fd5c14c58da8$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($e6e4fd5c14c58da8$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $e6e4fd5c14c58da8$var$_extends() {
    return $e6e4fd5c14c58da8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e6e4fd5c14c58da8$var$_extends.apply(null, arguments);
}
var $e6e4fd5c14c58da8$var$HeadingSkeleton = $e6e4fd5c14c58da8$export$6db3fc939e78ca56 = /*#__PURE__*/ (0, $e6e4fd5c14c58da8$var$_react.forwardRef)(function(_ref, ref) {
    var _theme$heading$level$;
    var as = _ref.as, _ref$level = _ref.level, level = _ref$level === void 0 ? 1 : _ref$level, _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, responsive = _ref.responsive;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var height = ((_theme$heading$level$ = theme.heading.level[level]) == null || (_theme$heading$level$ = _theme$heading$level$[size]) == null ? void 0 : _theme$heading$level$.height) || size;
    var responsiveSize;
    if (responsive && theme.heading.responsiveBreakpoint) {
        var breakpoint = theme.global.breakpoints[theme.heading.responsiveBreakpoint];
        if (breakpoint) {
            var _theme$heading$level$2, _theme$heading$level$3;
            var responsiveHeight = theme.heading.level[level + 1] ? (_theme$heading$level$2 = theme.heading.level[level + 1][size]) == null ? void 0 : _theme$heading$level$2.height : (_theme$heading$level$3 = theme.heading.level[level][size]) == null ? void 0 : _theme$heading$level$3.height;
            responsiveSize = {
                breakpoint: breakpoint,
                height: responsiveHeight || height
            };
        }
    }
    return /*#__PURE__*/ $e6e4fd5c14c58da8$var$_react["default"].createElement($ab65104eb6f9aa8a$exports.Skeleton, $e6e4fd5c14c58da8$var$_extends({
        as: as,
        ref: ref,
        height: height,
        responsive: responsive,
        responsiveSize: responsiveSize
    }, theme.heading.skeleton));
});
$e6e4fd5c14c58da8$var$HeadingSkeleton.displayName = 'HeadingSkeleton';




var $1c76f0fc20519fad$var$_excluded = [
    "children",
    "color",
    "fill",
    "level",
    "overflowWrap",
    "responsive",
    "weight"
];
function $1c76f0fc20519fad$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($1c76f0fc20519fad$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $1c76f0fc20519fad$var$_extends() {
    return $1c76f0fc20519fad$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1c76f0fc20519fad$var$_extends.apply(null, arguments);
}
function $1c76f0fc20519fad$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $1c76f0fc20519fad$var$Heading = $1c76f0fc20519fad$export$a8a3e93435678ff9 = /*#__PURE__*/ (0, $1c76f0fc20519fad$var$_react.forwardRef)(function(_ref, ref // munged to avoid styled-components putting it in the DOM
) {
    var children = _ref.children, color = _ref.color, fill = _ref.fill, _ref$level = _ref.level, level = _ref$level === void 0 ? 1 : _ref$level, overflowWrapProp = _ref.overflowWrap, _ref$responsive = _ref.responsive, responsiveProp = _ref$responsive === void 0 ? true : _ref$responsive, weight = _ref.weight, rest = $1c76f0fc20519fad$var$_objectWithoutPropertiesLoose(_ref, $1c76f0fc20519fad$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var headingRef = (0, $4113023f9e0bafa0$exports.useForwardedRef)(ref);
    var _useState = (0, $1c76f0fc20519fad$var$_react.useState)(overflowWrapProp || 'break-word'), overflowWrap = _useState[0], setOverflowWrap = _useState[1];
    var responsiveContainer = (0, $1c76f0fc20519fad$var$_react.useContext)($58f4f715ab4fa2c4$exports.ResponsiveContainerContext);
    var responsive = responsiveContainer && responsiveProp ? 'container' : responsiveProp;
    var skeleton = (0, $ab65104eb6f9aa8a$exports.useSkeleton)();
    // handle overflowWrap of heading
    (0, $6a5275ec792307a1$export$e5c5a5f917a5871c)(function() {
        var updateOverflowWrap = function updateOverflowWrap() {
            var wrap;
            if (!overflowWrapProp && headingRef.current) {
                wrap = headingRef.current.scrollWidth > headingRef.current.offsetWidth ? 'anywhere' : 'break-word';
                setOverflowWrap(wrap);
            }
        };
        window.addEventListener('resize', updateOverflowWrap);
        updateOverflowWrap();
        return function() {
            return window.removeEventListener('resize', updateOverflowWrap);
        };
    }, [
        headingRef,
        overflowWrapProp
    ]);
    var content = children;
    if (skeleton) content = /*#__PURE__*/ $1c76f0fc20519fad$var$_react["default"].createElement($e6e4fd5c14c58da8$export$6db3fc939e78ca56, $1c76f0fc20519fad$var$_extends({
        level: level,
        fill: fill,
        responsive: responsive
    }, rest));
    return(/*#__PURE__*/ // enforce level to be a number
    $1c76f0fc20519fad$var$_react["default"].createElement($cfca6947a32aa844$export$8c1dfb3a3dfd5501, $1c76f0fc20519fad$var$_extends({
        as: "h" + level,
        colorProp: color,
        fillProp: fill,
        level: +level,
        overflowWrap: overflowWrap,
        responsive: responsive,
        weight: weight
    }, passThemeFlag, rest, {
        ref: headingRef
    }), content));
});
$1c76f0fc20519fad$var$Heading.displayName = 'Heading';
$1c76f0fc20519fad$var$Heading.propTypes = $604104a14f61c1ef$export$c6750152f5d8efcb;


$2d67f2629ee502eb$export$a8a3e93435678ff9 = $1c76f0fc20519fad$export$a8a3e93435678ff9;



var $295f66ff4a73c659$export$1e511d4a378977f5;
var $295f66ff4a73c659$export$e0f57d1c561c3ce4;
"use strict";
$295f66ff4a73c659$export$1e511d4a378977f5 = true;
$295f66ff4a73c659$export$e0f57d1c561c3ce4 = void 0;

var $295f66ff4a73c659$var$_propTypes = $295f66ff4a73c659$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $295f66ff4a73c659$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $295f66ff4a73c659$var$PropType = {};
$295f66ff4a73c659$var$PropType = {
    label: $295f66ff4a73c659$var$_propTypes["default"].oneOfType([
        $295f66ff4a73c659$var$_propTypes["default"].string,
        $295f66ff4a73c659$var$_propTypes["default"].node
    ]),
    header: $295f66ff4a73c659$var$_propTypes["default"].node
};
var $295f66ff4a73c659$var$AccordionPanelPropTypes = $295f66ff4a73c659$export$e0f57d1c561c3ce4 = $295f66ff4a73c659$var$PropType;



var $dc13f7a9b9569734$var$_excluded = [
    "children",
    "header",
    "id",
    "label",
    "onClick",
    "onMouseOut",
    "onMouseOver",
    "onFocus",
    "onBlur"
];
function $dc13f7a9b9569734$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($dc13f7a9b9569734$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $dc13f7a9b9569734$var$_extends() {
    return $dc13f7a9b9569734$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $dc13f7a9b9569734$var$_extends.apply(null, arguments);
}
function $dc13f7a9b9569734$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $dc13f7a9b9569734$var$AccordionPanel = $dc13f7a9b9569734$export$7cad6f17fd6e117b = /*#__PURE__*/ (0, $dc13f7a9b9569734$var$_react.forwardRef)(function(_ref, ref) {
    var _theme$accordion$labe, _theme$accordion$icon;
    var children = _ref.children, header = _ref.header, id = _ref.id, label = _ref.label, onClick = _ref.onClick, _onMouseOut = _ref.onMouseOut, _onMouseOver = _ref.onMouseOver, _onFocus = _ref.onFocus, _onBlur = _ref.onBlur, rest = $dc13f7a9b9569734$var$_objectWithoutPropertiesLoose(_ref, $dc13f7a9b9569734$var$_excluded);
    var panelButtonId = (0, $4113023f9e0bafa0$exports.useId)();
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useContext = (0, $dc13f7a9b9569734$var$_react.useContext)($f09a9f2430934c2c$export$6bd5bb82c987ab74), active = _useContext.active, animate = _useContext.animate, level = _useContext.level, onPanelChange = _useContext.onPanelChange;
    var _useState = (0, $dc13f7a9b9569734$var$_react.useState)(undefined), hover = _useState[0], setHover = _useState[1];
    var _useState2 = (0, $dc13f7a9b9569734$var$_react.useState)(), focus = _useState2[0], setFocus = _useState2[1];
    var iconColor = (0, $dc13f7a9b9569734$var$_react.useMemo)(function() {
        return (0, $4113023f9e0bafa0$exports.normalizeColor)(theme.accordion.icons.color || 'control', theme);
    }, [
        theme
    ]);
    var AccordionIcon = (0, $dc13f7a9b9569734$var$_react.useMemo)(function() {
        return active ? theme.accordion.icons.collapse : theme.accordion.icons.expand;
    }, [
        active,
        theme.accordion.icons
    ]);
    var defaultHoverColor = JSON.stringify({
        dark: 'light-4',
        light: 'dark-3'
    });
    // accordion.hover.color will be deprecated in v3.
    if (JSON.stringify(theme.accordion.hover.color) !== defaultHoverColor) console.warn("The theme style for accordion.hover.color is deprecated,\n        use accordion.hover.heading.color instead.");
    // accordion.hover.heading.color will trump accordion.hover.color in case
    // the user sets its value to be any other value than the
    // default value (defaultHoverColor).
    // accordion.hover.color will be deprecated in v3.
    var headingColor = theme.accordion.hover && JSON.stringify(theme.accordion.hover.heading.color) !== defaultHoverColor ? theme.accordion.hover.heading.color : theme.accordion.hover.color;
    var contentBorder = theme.accordion.border;
    var panelBorder = theme.accordion.panel.border;
    var abutMargin;
    if (panelBorder) // abutMargin 'bottom' is set to overlap adjacent border panels
    abutMargin = {
        bottom: "-" + (0, $4113023f9e0bafa0$exports.parseMetricToNum)(// in case border.size defined as a t-shirt size
        // or in case border size is a custom size i.e. '5px'
        theme.global.borderSize[panelBorder.size] || panelBorder.size || theme.global.borderSize.xsmall // '-1px'
        ) + "px"
    };
    return /*#__PURE__*/ $dc13f7a9b9569734$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        ref: ref,
        flex: false,
        onClick: onClick,
        border: panelBorder,
        margin: abutMargin
    }, /*#__PURE__*/ $dc13f7a9b9569734$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
        id: panelButtonId,
        "aria-expanded": active,
        plain: theme.button["default"] ? true : undefined,
        onClick: onPanelChange,
        hoverIndicator: theme.accordion.hover.background,
        onMouseOver: function onMouseOver(event) {
            setHover(headingColor);
            if (_onMouseOver) _onMouseOver(event);
        },
        onMouseOut: function onMouseOut(event) {
            setHover(undefined);
            if (_onMouseOut) _onMouseOut(event);
        },
        onFocus: function onFocus(event) {
            setHover(headingColor);
            setFocus(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setHover(undefined);
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        style: focus ? {
            zIndex: 1
        } : undefined
    }, header || /*#__PURE__*/ $dc13f7a9b9569734$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $dc13f7a9b9569734$var$_extends({
        align: "center",
        direction: "row",
        justify: "between",
        id: id
    }, rest), typeof label === 'string' ? /*#__PURE__*/ $dc13f7a9b9569734$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        pad: (_theme$accordion$labe = theme.accordion.label) == null || (_theme$accordion$labe = _theme$accordion$labe.container) == null ? void 0 : _theme$accordion$labe.pad
    }, /*#__PURE__*/ $dc13f7a9b9569734$var$_react["default"].createElement($2d67f2629ee502eb$export$a8a3e93435678ff9, {
        level: level || theme.accordion.heading && theme.accordion.heading.level || 4,
        margin: theme.accordion.heading && theme.accordion.heading.margin || undefined,
        color: hover
    }, label)) : label, AccordionIcon && /*#__PURE__*/ $dc13f7a9b9569734$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        pad: (_theme$accordion$icon = theme.accordion.icon) == null || (_theme$accordion$icon = _theme$accordion$icon.container) == null ? void 0 : _theme$accordion$icon.pad,
        width: {
            min: 'fit-content'
        }
    }, /*#__PURE__*/ $dc13f7a9b9569734$var$_react["default"].createElement(AccordionIcon, {
        color: iconColor
    })))), /*#__PURE__*/ $dc13f7a9b9569734$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        role: "region",
        border: contentBorder,
        "aria-labelledby": panelButtonId
    }, animate ? /*#__PURE__*/ $dc13f7a9b9569734$var$_react["default"].createElement($6978a6eff11602a9$export$6eb0f7ddcda6131f, {
        open: active
    }, children) : active && children));
});
$dc13f7a9b9569734$var$AccordionPanel.displayName = 'AccordionPanel';
$dc13f7a9b9569734$var$AccordionPanel.propTypes = $295f66ff4a73c659$export$e0f57d1c561c3ce4;


$0b17fa67fb14e31e$export$7cad6f17fd6e117b = $dc13f7a9b9569734$export$7cad6f17fd6e117b;


Object.keys($0b17fa67fb14e31e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $0b17fa67fb14e31e$exports[key]) return;
    $3321243da0932e1e$exports[key] = $0b17fa67fb14e31e$exports[key];
});

Object.keys($e78646567f384248$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $e78646567f384248$exports[key]) return;
    $3321243da0932e1e$exports[key] = $e78646567f384248$exports[key];
});
var $e3804c57ef89ff56$exports = {};

$parcel$export($e3804c57ef89ff56$exports, "__esModule", function () { return $e3804c57ef89ff56$export$1e511d4a378977f5; }, function (v) { return $e3804c57ef89ff56$export$1e511d4a378977f5 = v; });
$parcel$export($e3804c57ef89ff56$exports, "Avatar", function () { return $e3804c57ef89ff56$export$e2255cf6045e8d47; }, function (v) { return $e3804c57ef89ff56$export$e2255cf6045e8d47 = v; });
var $e3804c57ef89ff56$export$1e511d4a378977f5;
var $e3804c57ef89ff56$export$e2255cf6045e8d47;
"use strict";
$e3804c57ef89ff56$export$1e511d4a378977f5 = true;
$e3804c57ef89ff56$export$e2255cf6045e8d47 = void 0;
var $6610fb960d6c6bec$export$1e511d4a378977f5;
var $6610fb960d6c6bec$export$e2255cf6045e8d47;
"use strict";
$6610fb960d6c6bec$export$1e511d4a378977f5 = true;
$6610fb960d6c6bec$export$e2255cf6045e8d47 = void 0;

var $6610fb960d6c6bec$var$_react = $6610fb960d6c6bec$var$_interopRequireWildcard((parcelRequire("2xPiy")));
var $ef77062b4b63719c$exports = {};

$parcel$export($ef77062b4b63719c$exports, "__esModule", function () { return $ef77062b4b63719c$export$1e511d4a378977f5; }, function (v) { return $ef77062b4b63719c$export$1e511d4a378977f5 = v; });
$parcel$export($ef77062b4b63719c$exports, "Image", function () { return $ef77062b4b63719c$export$3e431a229df88919; }, function (v) { return $ef77062b4b63719c$export$3e431a229df88919 = v; });
var $ef77062b4b63719c$export$1e511d4a378977f5;
var $ef77062b4b63719c$export$3e431a229df88919;
"use strict";
$ef77062b4b63719c$export$1e511d4a378977f5 = true;
$ef77062b4b63719c$export$3e431a229df88919 = void 0;
var $98886605fda458bc$export$1e511d4a378977f5;
var $98886605fda458bc$export$3e431a229df88919;
"use strict";
$98886605fda458bc$export$1e511d4a378977f5 = true;
$98886605fda458bc$export$3e431a229df88919 = void 0;

var $98886605fda458bc$var$_react = $98886605fda458bc$var$_interopRequireWildcard((parcelRequire("2xPiy")));
var $30a88bfba171f3c7$export$1e511d4a378977f5;
var $30a88bfba171f3c7$export$7722b1870d9eec03;
"use strict";
$30a88bfba171f3c7$export$1e511d4a378977f5 = true;
$30a88bfba171f3c7$export$7722b1870d9eec03 = void 0;

var $30a88bfba171f3c7$var$_styledComponents = $30a88bfba171f3c7$var$_interopRequireWildcard((parcelRequire("iA1nz")));

function $30a88bfba171f3c7$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($30a88bfba171f3c7$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $30a88bfba171f3c7$var$FIT_MAP = {
    cover: 'cover',
    contain: 'contain'
};
var $30a88bfba171f3c7$var$fitStyle = (0, $30a88bfba171f3c7$var$_styledComponents.css)([
    "flex:1 1;overflow:hidden;object-fit:",
    ";"
], function(props) {
    return $30a88bfba171f3c7$var$FIT_MAP[props.fit];
});
var $30a88bfba171f3c7$var$StyledImage = $30a88bfba171f3c7$export$7722b1870d9eec03 = $30a88bfba171f3c7$var$_styledComponents["default"].img.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledImage",
    componentId: "sc-ey4zx9-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    ""
], $4113023f9e0bafa0$exports.genericStyles, function(props) {
    return props.fit && $30a88bfba171f3c7$var$fitStyle;
}, function(props) {
    return props.fillProp && (0, $4113023f9e0bafa0$exports.fillStyle)(props.fillProp);
}, function(props) {
    return props.theme.image && props.theme.image.extend;
}, function(props) {
    return props.opacityProp && "opacity: " + (props.opacityProp === true ? props.theme.global.opacity.medium : props.theme.global.opacity[props.opacityProp] || props.opacityProp) + ";\n  ";
});


var $668ba18ec33d11b6$export$1e511d4a378977f5;
var $668ba18ec33d11b6$export$c3be8f1cc0265a9c;
"use strict";
$668ba18ec33d11b6$export$1e511d4a378977f5 = true;
$668ba18ec33d11b6$export$c3be8f1cc0265a9c = void 0;

var $668ba18ec33d11b6$var$_propTypes = $668ba18ec33d11b6$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $668ba18ec33d11b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $668ba18ec33d11b6$var$_extends() {
    return $668ba18ec33d11b6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $668ba18ec33d11b6$var$_extends.apply(null, arguments);
}
var $668ba18ec33d11b6$var$PropType = {};
$668ba18ec33d11b6$var$PropType = $668ba18ec33d11b6$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    fill: $668ba18ec33d11b6$var$_propTypes["default"].oneOfType([
        $668ba18ec33d11b6$var$_propTypes["default"].oneOf([
            'horizontal',
            'vertical'
        ]),
        $668ba18ec33d11b6$var$_propTypes["default"].bool
    ]),
    fit: $668ba18ec33d11b6$var$_propTypes["default"].oneOf([
        'cover',
        'contain'
    ]),
    fallback: $668ba18ec33d11b6$var$_propTypes["default"].string,
    opacity: $668ba18ec33d11b6$var$_propTypes["default"].oneOfType([
        $668ba18ec33d11b6$var$_propTypes["default"].oneOf([
            'weak',
            'medium',
            'strong'
        ]),
        $668ba18ec33d11b6$var$_propTypes["default"].string,
        $668ba18ec33d11b6$var$_propTypes["default"].bool
    ])
});
var $668ba18ec33d11b6$var$ImagePropTypes = $668ba18ec33d11b6$export$c3be8f1cc0265a9c = $668ba18ec33d11b6$var$PropType;



var $98886605fda458bc$var$_excluded = [
    "a11yTitle",
    "fallback",
    "onError",
    "onLoad",
    "opacity",
    "fill",
    "src"
];
function $98886605fda458bc$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($98886605fda458bc$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $98886605fda458bc$var$_extends() {
    return $98886605fda458bc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $98886605fda458bc$var$_extends.apply(null, arguments);
}
function $98886605fda458bc$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $98886605fda458bc$var$Image = $98886605fda458bc$export$3e431a229df88919 = /*#__PURE__*/ (0, $98886605fda458bc$var$_react.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, fallback = _ref.fallback, onError = _ref.onError, onLoad = _ref.onLoad, opacity = _ref.opacity, fill = _ref.fill, src = _ref.src, rest = $98886605fda458bc$var$_objectWithoutPropertiesLoose(_ref, $98886605fda458bc$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var _useState = (0, $98886605fda458bc$var$_react.useState)(false), isFallbackInUse = _useState[0], setFallbackInUse = _useState[1];
    var handleError = function handleError(event) {
        if (onError) onError(event);
        if (!isFallbackInUse && fallback && fallback !== '') {
            // eslint-disable-next-line no-param-reassign
            event.target.src = fallback;
            setFallbackInUse(true);
        }
    };
    var handleOnLoad = function handleOnLoad(event) {
        if (onLoad) onLoad(event);
        setFallbackInUse(false);
    };
    var extraProps = {
        onError: (onError || fallback) && handleError,
        onLoad: handleOnLoad
    };
    return /*#__PURE__*/ $98886605fda458bc$var$_react["default"].createElement($30a88bfba171f3c7$export$7722b1870d9eec03, $98886605fda458bc$var$_extends({
        "aria-label": a11yTitle
    }, passThemeFlag, rest, extraProps, {
        ref: ref,
        opacityProp: opacity,
        fillProp: fill,
        src: src === undefined ? '' : src
    }));
});
$98886605fda458bc$var$Image.displayName = 'Image';
$98886605fda458bc$var$Image.propTypes = $668ba18ec33d11b6$export$c3be8f1cc0265a9c;


$ef77062b4b63719c$export$3e431a229df88919 = $98886605fda458bc$export$3e431a229df88919;


var $d5e2d79df9e054eb$export$1e511d4a378977f5;
var $d5e2d79df9e054eb$export$347ff640deb5f69a;
var $d5e2d79df9e054eb$export$f9c8934f7fa064f8;
"use strict";
$d5e2d79df9e054eb$export$1e511d4a378977f5 = true;
$d5e2d79df9e054eb$export$347ff640deb5f69a = $d5e2d79df9e054eb$export$f9c8934f7fa064f8 = void 0;

var $d5e2d79df9e054eb$var$_styledComponents = $d5e2d79df9e054eb$var$_interopRequireDefault((parcelRequire("iA1nz")));


function $d5e2d79df9e054eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $d5e2d79df9e054eb$var$StyledAvatarText = $d5e2d79df9e054eb$export$347ff640deb5f69a = (0, $d5e2d79df9e054eb$var$_styledComponents["default"])($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6).withConfig({
    displayName: "StyledAvatar__StyledAvatarText",
    componentId: "sc-1suyamb-0"
})([
    "",
    " ",
    ""
], function(props) {
    return props.theme.avatar && props.theme.avatar.text && props.theme.avatar.text.fontWeight && "font-weight: " + props.theme.avatar.text.fontWeight + ";";
}, function(props) {
    return props.theme.avatar.text && props.theme.avatar.text.extend;
});
var $d5e2d79df9e054eb$var$StyledAvatar = $d5e2d79df9e054eb$export$f9c8934f7fa064f8 = (0, $d5e2d79df9e054eb$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "StyledAvatar",
    componentId: "sc-1suyamb-1"
})([
    "",
    ""
], function(props) {
    return props.theme.avatar && props.theme.avatar.extend;
});


var $a584d7055fd43d88$export$1e511d4a378977f5;
var $a584d7055fd43d88$export$d8bb67314afc20d6;
"use strict";
$a584d7055fd43d88$export$1e511d4a378977f5 = true;
$a584d7055fd43d88$export$d8bb67314afc20d6 = void 0;

var $a584d7055fd43d88$var$_propTypes = $a584d7055fd43d88$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $a584d7055fd43d88$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $a584d7055fd43d88$var$PropType = {};
$a584d7055fd43d88$var$PropType = {
    size: $a584d7055fd43d88$var$_propTypes["default"].oneOfType([
        $a584d7055fd43d88$var$_propTypes["default"].oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            '2xl',
            '3xl',
            '4xl',
            '5xl'
        ]),
        $a584d7055fd43d88$var$_propTypes["default"].string
    ]),
    src: $a584d7055fd43d88$var$_propTypes["default"].string,
    imageProps: $a584d7055fd43d88$var$_propTypes["default"].object
};
var $a584d7055fd43d88$var$AvatarPropTypes = $a584d7055fd43d88$export$d8bb67314afc20d6 = $a584d7055fd43d88$var$PropType;



var $6610fb960d6c6bec$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "align",
    "children",
    "height",
    "imageProps",
    "justify",
    "round",
    "size",
    "src",
    "width"
];
function $6610fb960d6c6bec$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($6610fb960d6c6bec$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $6610fb960d6c6bec$var$_extends() {
    return $6610fb960d6c6bec$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6610fb960d6c6bec$var$_extends.apply(null, arguments);
}
function $6610fb960d6c6bec$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $6610fb960d6c6bec$var$Avatar = $6610fb960d6c6bec$export$e2255cf6045e8d47 = function Avatar(_ref) {
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], _ref$align = _ref.align, align = _ref$align === void 0 ? 'center' : _ref$align, children = _ref.children, height = _ref.height, imageProps = _ref.imageProps, _ref$justify = _ref.justify, justify = _ref$justify === void 0 ? 'center' : _ref$justify, _ref$round = _ref.round, round = _ref$round === void 0 ? 'full' : _ref$round, _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, src = _ref.src, width = _ref.width, rest = $6610fb960d6c6bec$var$_objectWithoutPropertiesLoose(_ref, $6610fb960d6c6bec$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var avatarSize = theme.avatar.size[size] || size;
    var avatarTextSize = theme.avatar.text.size[size] || 'large';
    var avatarProps = (0, $6610fb960d6c6bec$var$_react.useMemo)(function() {
        return {
            align: align,
            height: avatarSize,
            justify: justify,
            overflow: 'hidden',
            round: round,
            width: avatarSize
        };
    }, [
        align,
        avatarSize,
        justify,
        round
    ]);
    var AvatarChildren = (0, $6610fb960d6c6bec$var$_react.useCallback)(function() {
        return /*#__PURE__*/ $6610fb960d6c6bec$var$_react["default"].createElement($d5e2d79df9e054eb$export$f9c8934f7fa064f8, $6610fb960d6c6bec$var$_extends({}, avatarProps, rest), children);
    }, [
        avatarProps,
        children,
        rest
    ]);
    if (height || width) console.warn('Avatar should use `size` instead of `height` or `width` props');
    var content;
    if (typeof children === 'string') content = /*#__PURE__*/ $6610fb960d6c6bec$var$_react["default"].createElement($d5e2d79df9e054eb$export$347ff640deb5f69a, $6610fb960d6c6bec$var$_extends({
        alignSelf: "center",
        size: avatarTextSize
    }, passThemeFlag), children);
    else if (typeof src === 'string') content = /*#__PURE__*/ $6610fb960d6c6bec$var$_react["default"].createElement($ef77062b4b63719c$export$3e431a229df88919, $6610fb960d6c6bec$var$_extends({
        role: "presentation",
        fit: "contain",
        src: src
    }, imageProps));
    if (typeof children === 'string' || typeof src === 'string') return /*#__PURE__*/ $6610fb960d6c6bec$var$_react["default"].createElement($d5e2d79df9e054eb$export$f9c8934f7fa064f8, $6610fb960d6c6bec$var$_extends({
        role: typeof src === 'string' ? 'figure' : undefined,
        a11yTitle: a11yTitle || ariaLabel
    }, avatarProps, passThemeFlag, rest), content);
    return /*#__PURE__*/ $6610fb960d6c6bec$var$_react["default"].createElement(AvatarChildren, null);
};
$6610fb960d6c6bec$var$Avatar.propTypes = $a584d7055fd43d88$export$d8bb67314afc20d6;


$e3804c57ef89ff56$export$e2255cf6045e8d47 = $6610fb960d6c6bec$export$e2255cf6045e8d47;


Object.keys($e3804c57ef89ff56$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $e3804c57ef89ff56$exports[key]) return;
    $3321243da0932e1e$exports[key] = $e3804c57ef89ff56$exports[key];
});

Object.keys($090ffb0ba78fff3f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $090ffb0ba78fff3f$exports[key]) return;
    $3321243da0932e1e$exports[key] = $090ffb0ba78fff3f$exports[key];
});

Object.keys($fb68f765668b25d0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $fb68f765668b25d0$exports[key]) return;
    $3321243da0932e1e$exports[key] = $fb68f765668b25d0$exports[key];
});
var $754c60248b2cdc9f$exports = {};

$parcel$export($754c60248b2cdc9f$exports, "__esModule", function () { return $754c60248b2cdc9f$export$1e511d4a378977f5; }, function (v) { return $754c60248b2cdc9f$export$1e511d4a378977f5 = v; });
$parcel$export($754c60248b2cdc9f$exports, "Calendar", function () { return $754c60248b2cdc9f$export$e1aef45b828286de; }, function (v) { return $754c60248b2cdc9f$export$e1aef45b828286de = v; });
var $754c60248b2cdc9f$export$1e511d4a378977f5;
var $754c60248b2cdc9f$export$e1aef45b828286de;
"use strict";
$754c60248b2cdc9f$export$1e511d4a378977f5 = true;
$754c60248b2cdc9f$export$e1aef45b828286de = void 0;
var $fcf2886c26d1d13d$export$1e511d4a378977f5;
var $fcf2886c26d1d13d$export$c0c99f9031a45b3;
var $fcf2886c26d1d13d$export$e1aef45b828286de;
"use strict";
$fcf2886c26d1d13d$export$1e511d4a378977f5 = true;
$fcf2886c26d1d13d$export$c0c99f9031a45b3 = $fcf2886c26d1d13d$export$e1aef45b828286de = void 0;

var $fcf2886c26d1d13d$var$_react = $fcf2886c26d1d13d$var$_interopRequireWildcard((parcelRequire("2xPiy")));




var $30d6151480c557a9$exports = {};

$parcel$export($30d6151480c557a9$exports, "__esModule", function () { return $30d6151480c557a9$export$1e511d4a378977f5; }, function (v) { return $30d6151480c557a9$export$1e511d4a378977f5 = v; });
$parcel$export($30d6151480c557a9$exports, "Header", function () { return $30d6151480c557a9$export$8b251419efc915eb; }, function (v) { return $30d6151480c557a9$export$8b251419efc915eb = v; });
var $30d6151480c557a9$export$1e511d4a378977f5;
var $30d6151480c557a9$export$8b251419efc915eb;
"use strict";
$30d6151480c557a9$export$1e511d4a378977f5 = true;
$30d6151480c557a9$export$8b251419efc915eb = void 0;
var $892e3009928fe596$export$1e511d4a378977f5;
var $892e3009928fe596$export$8b251419efc915eb;
"use strict";
$892e3009928fe596$export$1e511d4a378977f5 = true;
$892e3009928fe596$export$8b251419efc915eb = void 0;

var $892e3009928fe596$var$_react = $892e3009928fe596$var$_interopRequireWildcard((parcelRequire("2xPiy")));



var $892e3009928fe596$var$_excluded = [
    "sticky"
];
function $892e3009928fe596$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($892e3009928fe596$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $892e3009928fe596$var$_extends() {
    return $892e3009928fe596$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $892e3009928fe596$var$_extends.apply(null, arguments);
}
function $892e3009928fe596$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $892e3009928fe596$var$Header = $892e3009928fe596$export$8b251419efc915eb = /*#__PURE__*/ $892e3009928fe596$var$_react["default"].forwardRef(function(_ref, ref) {
    var _theme$header2, _theme$header3;
    var sticky = _ref.sticky, rest = $892e3009928fe596$var$_objectWithoutPropertiesLoose(_ref, $892e3009928fe596$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var headerRef = (0, $4113023f9e0bafa0$exports.useForwardedRef)(ref);
    (0, $892e3009928fe596$var$_react.useEffect)(function() {
        var scrollTop = 0;
        var updateScrollDir = function updateScrollDir() {
            // target is its scroll parent
            var target = (0, $4113023f9e0bafa0$exports.findScrollParent)(headerRef.current);
            var header = headerRef.current;
            if (target && sticky === 'scrollup') {
                var nextScrollTop = target === document ? window.pageYOffset : target.scrollTop;
                if (scrollTop - nextScrollTop <= 0) {
                    header.style.top = "-" + header.getBoundingClientRect().height + "px";
                    header.style.zIndex = '';
                } else if (scrollTop - nextScrollTop > 0) {
                    var _theme$header;
                    // ensure that header moves with the target
                    header.style.position = 'sticky';
                    header.style.top = '0px';
                    header.style.zIndex = "" + ((_theme$header = theme.header) == null || (_theme$header = _theme$header.sticky) == null ? void 0 : _theme$header.zIndex);
                    header.style.transition = 'top 0.6s';
                }
                scrollTop = nextScrollTop;
            }
        };
        if (sticky === 'scrollup') {
            updateScrollDir();
            window.addEventListener('resize', updateScrollDir);
            window.addEventListener('scroll', updateScrollDir, true);
        }
        return function() {
            if (sticky === 'scrollup') {
                window.removeEventListener('resize', updateScrollDir);
                window.removeEventListener('scroll', updateScrollDir, true);
            }
        };
    }, [
        headerRef,
        sticky,
        (_theme$header2 = theme.header) == null || (_theme$header2 = _theme$header2.sticky) == null ? void 0 : _theme$header2.zIndex
    ]);
    return /*#__PURE__*/ $892e3009928fe596$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $892e3009928fe596$var$_extends({
        align: "center",
        as: "header",
        direction: "row",
        flex: false,
        justify: "between",
        gap: (_theme$header3 = theme.header) == null ? void 0 : _theme$header3.gap,
        ref: headerRef
    }, rest));
});
$892e3009928fe596$var$Header.displayName = 'Header';


$30d6151480c557a9$export$8b251419efc915eb = $892e3009928fe596$export$8b251419efc915eb;





var $851c863e2b1f5fef$export$1e511d4a378977f5;
var $851c863e2b1f5fef$export$91040927b1d7b4d1;
"use strict";
$851c863e2b1f5fef$export$1e511d4a378977f5 = true;
$851c863e2b1f5fef$export$91040927b1d7b4d1 = void 0;

var $851c863e2b1f5fef$var$_propTypes = $851c863e2b1f5fef$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $851c863e2b1f5fef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $851c863e2b1f5fef$var$_extends() {
    return $851c863e2b1f5fef$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $851c863e2b1f5fef$var$_extends.apply(null, arguments);
}
var $851c863e2b1f5fef$var$PropType = {};
$851c863e2b1f5fef$var$PropType = $851c863e2b1f5fef$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    activeDate: $851c863e2b1f5fef$var$_propTypes["default"].oneOf([
        'start',
        'end'
    ]),
    animate: $851c863e2b1f5fef$var$_propTypes["default"].bool,
    bounds: $851c863e2b1f5fef$var$_propTypes["default"].arrayOf($851c863e2b1f5fef$var$_propTypes["default"].string),
    children: $851c863e2b1f5fef$var$_propTypes["default"].func,
    date: $851c863e2b1f5fef$var$_propTypes["default"].oneOfType([
        $851c863e2b1f5fef$var$_propTypes["default"].string,
        $851c863e2b1f5fef$var$_propTypes["default"].arrayOf($851c863e2b1f5fef$var$_propTypes["default"].oneOfType([
            $851c863e2b1f5fef$var$_propTypes["default"].string,
            $851c863e2b1f5fef$var$_propTypes["default"].arrayOf($851c863e2b1f5fef$var$_propTypes["default"].string)
        ]))
    ]),
    dates: $851c863e2b1f5fef$var$_propTypes["default"].arrayOf($851c863e2b1f5fef$var$_propTypes["default"].oneOfType([
        $851c863e2b1f5fef$var$_propTypes["default"].string,
        $851c863e2b1f5fef$var$_propTypes["default"].arrayOf($851c863e2b1f5fef$var$_propTypes["default"].string)
    ])),
    disabled: $851c863e2b1f5fef$var$_propTypes["default"].arrayOf($851c863e2b1f5fef$var$_propTypes["default"].oneOfType([
        $851c863e2b1f5fef$var$_propTypes["default"].string,
        $851c863e2b1f5fef$var$_propTypes["default"].arrayOf($851c863e2b1f5fef$var$_propTypes["default"].string)
    ])),
    daysOfWeek: $851c863e2b1f5fef$var$_propTypes["default"].bool,
    fill: $851c863e2b1f5fef$var$_propTypes["default"].bool,
    firstDayOfWeek: $851c863e2b1f5fef$var$_propTypes["default"].oneOf([
        0,
        1
    ]),
    header: $851c863e2b1f5fef$var$_propTypes["default"].func,
    level: $851c863e2b1f5fef$var$_propTypes["default"].oneOf([
        1,
        2,
        3,
        4,
        5,
        6,
        '1',
        '2',
        '3',
        '4',
        '5',
        '6'
    ]),
    locale: $851c863e2b1f5fef$var$_propTypes["default"].string,
    messages: $851c863e2b1f5fef$var$_propTypes["default"].shape({
        previous: $851c863e2b1f5fef$var$_propTypes["default"].string,
        next: $851c863e2b1f5fef$var$_propTypes["default"].string
    }),
    onReference: $851c863e2b1f5fef$var$_propTypes["default"].func,
    onSelect: $851c863e2b1f5fef$var$_propTypes["default"].func,
    range: $851c863e2b1f5fef$var$_propTypes["default"].oneOfType([
        $851c863e2b1f5fef$var$_propTypes["default"].bool,
        $851c863e2b1f5fef$var$_propTypes["default"].oneOf([
            'array'
        ])
    ]),
    reference: $851c863e2b1f5fef$var$_propTypes["default"].string,
    responsive: $851c863e2b1f5fef$var$_propTypes["default"].bool,
    showAdjacentDays: $851c863e2b1f5fef$var$_propTypes["default"].oneOfType([
        $851c863e2b1f5fef$var$_propTypes["default"].bool,
        $851c863e2b1f5fef$var$_propTypes["default"].oneOf([
            'trim'
        ])
    ]),
    size: $851c863e2b1f5fef$var$_propTypes["default"].oneOfType([
        $851c863e2b1f5fef$var$_propTypes["default"].oneOf([
            'small',
            'medium',
            'large'
        ]),
        $851c863e2b1f5fef$var$_propTypes["default"].string
    ])
});
var $851c863e2b1f5fef$var$CalendarPropTypes = $851c863e2b1f5fef$export$91040927b1d7b4d1 = $851c863e2b1f5fef$var$PropType;


var $c2bf620672af0d10$export$1e511d4a378977f5;
var $c2bf620672af0d10$export$cc9ae1676f4ee80a;
var $c2bf620672af0d10$export$3d055278a61c3939;
var $c2bf620672af0d10$export$5db4823d38c0569f;
var $c2bf620672af0d10$export$ffce625ce693a981;
var $c2bf620672af0d10$export$2be68822f46d2c34;
var $c2bf620672af0d10$export$4fe9184bd47dbe20;
var $c2bf620672af0d10$export$2185b0041ed383;
"use strict";
$c2bf620672af0d10$export$1e511d4a378977f5 = true;
$c2bf620672af0d10$export$cc9ae1676f4ee80a = $c2bf620672af0d10$export$3d055278a61c3939 = $c2bf620672af0d10$export$5db4823d38c0569f = $c2bf620672af0d10$export$ffce625ce693a981 = $c2bf620672af0d10$export$2be68822f46d2c34 = $c2bf620672af0d10$export$4fe9184bd47dbe20 = $c2bf620672af0d10$export$2185b0041ed383 = void 0;

var $c2bf620672af0d10$var$_styledComponents = $c2bf620672af0d10$var$_interopRequireWildcard((parcelRequire("iA1nz")));



function $c2bf620672af0d10$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($c2bf620672af0d10$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $c2bf620672af0d10$var$responsiveSizeStyle = function responsiveSizeStyle(props) {
    var breakpoint = props.theme.global.size[props.sizeProp];
    return (0, $d65b270127c3c07e$export$2180d12f0a299a89)({
        value: breakpoint
    }, "\n    width: 100vw;\n    max-width: " + breakpoint + ";\n  ", true);
};
var $c2bf620672af0d10$var$sizeStyle = function sizeStyle(props) {
    var data = props.theme.calendar[props.sizeProp];
    var width = props.fillContainer ? '100%' : props.theme.global.size[props.sizeProp];
    return (0, $c2bf620672af0d10$var$_styledComponents.css)([
        "font-size:",
        ";line-height:",
        ";width:",
        ";",
        ""
    ], data.fontSize, data.lineHeight, width, function(p) {
        return p.fillContainer && 'height: 100%;';
    });
};
var $c2bf620672af0d10$var$StyledCalendar = $c2bf620672af0d10$export$2185b0041ed383 = $c2bf620672af0d10$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledCalendar",
    componentId: "sc-1y4xhmp-0"
})([
    "",
    " ",
    " ",
    " ",
    ""
], $4113023f9e0bafa0$exports.genericStyles, function(props) {
    return $c2bf620672af0d10$var$sizeStyle(props);
}, function(props) {
    return props.responsive && $c2bf620672af0d10$var$responsiveSizeStyle(props);
}, function(props) {
    return props.theme.calendar && props.theme.calendar.extend;
});
var $c2bf620672af0d10$var$weeksContainerSizeStyle = function weeksContainerSizeStyle(props) {
    var height = props.fillContainer ? '100%' : (0, $4113023f9e0bafa0$exports.parseMetricToNum)(props.theme.calendar[props.sizeProp].daySize) * 6 + "px";
    return "\n    height: " + height + ";\n\n  ";
};
var $c2bf620672af0d10$var$weeksContainerResponsiveSizeStyle = function weeksContainerResponsiveSizeStyle(props) {
    var breakpoint = props.theme.global.size[props.sizeProp];
    // set aspect-ratio to 7 days by 6 weeks
    return (0, $d65b270127c3c07e$export$2180d12f0a299a89)({
        value: breakpoint
    }, "\n    height: auto;\n    aspect-ratio: 7/6;\n    ", true);
};
var $c2bf620672af0d10$var$StyledWeeksContainer = $c2bf620672af0d10$export$cc9ae1676f4ee80a = $c2bf620672af0d10$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledCalendar__StyledWeeksContainer",
    componentId: "sc-1y4xhmp-1"
})([
    "overflow:hidden;",
    " ",
    " ",
    ";"
], function(props) {
    return $c2bf620672af0d10$var$weeksContainerSizeStyle(props);
}, function(props) {
    return props.responsive && $c2bf620672af0d10$var$weeksContainerResponsiveSizeStyle(props);
}, function(props) {
    return props.focus && !props.plain && (0, $4113023f9e0bafa0$exports.focusStyle)();
});
var $c2bf620672af0d10$var$slideStyle = function slideStyle(props) {
    var _props$slide = props.slide, direction = _props$slide.direction, weeks = _props$slide.weeks, sizeProp = props.sizeProp, theme = props.theme;
    var _theme$calendar$sizeP = theme.calendar[sizeProp], daySize = _theme$calendar$sizeP.daySize, slideDuration = _theme$calendar$sizeP.slideDuration;
    var amount = (0, $4113023f9e0bafa0$exports.parseMetricToNum)(daySize) * weeks;
    var translateYFrom = direction === 'down' ? "-" + amount + "px" : '0';
    var translateYTo = direction === 'up' ? "-" + amount + "px" : '0';
    var slideTransition = (0, $c2bf620672af0d10$var$_styledComponents.css)([
        "0%{transform:translateY(",
        ");}100%{transform:translateY(",
        ");}"
    ], translateYFrom, translateYTo);
    return (0, $c2bf620672af0d10$var$_styledComponents.css)([
        "animation:",
        " ",
        " forwards;"
    ], (0, $c2bf620672af0d10$var$_styledComponents.keyframes)([
        "",
        ""
    ], slideTransition), slideDuration);
};
var $c2bf620672af0d10$var$weeksSizeStyle = function weeksSizeStyle() {
    return (0, $c2bf620672af0d10$var$_styledComponents.css)([
        "display:flex;flex-direction:column;height:100%;"
    ]);
};
// fallback to medium if no size-specific styles
var $c2bf620672af0d10$var$rangeRoundStyle = function rangeRoundStyle(props) {
    var _props$theme$calendar5, _props$theme$calendar6;
    var themeObj;
    if (props.isSelected) {
        var _props$theme$calendar, _props$theme$calendar2, _props$theme$calendar3, _props$theme$calendar4;
        var rangeStart = ((_props$theme$calendar = props.theme.calendar) == null || (_props$theme$calendar = _props$theme$calendar[props.sizeProp]) == null || (_props$theme$calendar = _props$theme$calendar.range) == null || (_props$theme$calendar = _props$theme$calendar.start) == null ? void 0 : _props$theme$calendar.round) || ((_props$theme$calendar2 = props.theme.calendar) == null || (_props$theme$calendar2 = _props$theme$calendar2.medium) == null || (_props$theme$calendar2 = _props$theme$calendar2.range) == null || (_props$theme$calendar2 = _props$theme$calendar2.start) == null ? void 0 : _props$theme$calendar2.round);
        var rangeEnd = ((_props$theme$calendar3 = props.theme.calendar) == null || (_props$theme$calendar3 = _props$theme$calendar3[props.sizeProp]) == null || (_props$theme$calendar3 = _props$theme$calendar3.range) == null || (_props$theme$calendar3 = _props$theme$calendar3.end) == null ? void 0 : _props$theme$calendar3.round) || ((_props$theme$calendar4 = props.theme.calendar) == null || (_props$theme$calendar4 = _props$theme$calendar4.medium) == null || (_props$theme$calendar4 = _props$theme$calendar4.range) == null || (_props$theme$calendar4 = _props$theme$calendar4.end) == null ? void 0 : _props$theme$calendar4.round);
        if (props.rangePosition === 'start' && rangeStart) themeObj = rangeStart;
        else if (props.rangePosition === 'end' && rangeEnd) themeObj = rangeEnd;
    } else themeObj = ((_props$theme$calendar5 = props.theme.calendar) == null || (_props$theme$calendar5 = _props$theme$calendar5[props.sizeProp]) == null || (_props$theme$calendar5 = _props$theme$calendar5.range) == null ? void 0 : _props$theme$calendar5.round) || ((_props$theme$calendar6 = props.theme.calendar) == null || (_props$theme$calendar6 = _props$theme$calendar6.medium) == null || (_props$theme$calendar6 = _props$theme$calendar6.range) == null ? void 0 : _props$theme$calendar6.round);
    return themeObj && [
        (0, $4113023f9e0bafa0$exports.roundStyle)(themeObj, props.responsive, props.theme)
    ];
};
var $c2bf620672af0d10$var$StyledWeeks = $c2bf620672af0d10$export$3d055278a61c3939 = $c2bf620672af0d10$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledCalendar__StyledWeeks",
    componentId: "sc-1y4xhmp-2"
})([
    "position:relative;",
    " ",
    ";"
], function(props) {
    return props.fillContainer && $c2bf620672af0d10$var$weeksSizeStyle();
}, function(props) {
    return props.slide && $c2bf620672af0d10$var$slideStyle(props);
});
var $c2bf620672af0d10$var$StyledWeek = $c2bf620672af0d10$export$5db4823d38c0569f = $c2bf620672af0d10$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledCalendar__StyledWeek",
    componentId: "sc-1y4xhmp-3"
})([
    "display:flex;justify-content:space-between;",
    ""
], function(props) {
    return props.fillContainer && 'flex: 1;';
});
var $c2bf620672af0d10$var$responsiveDayContainerStyle = function responsiveDayContainerStyle(props) {
    var breakpoint = props.theme.global.size[props.sizeProp];
    return (0, $d65b270127c3c07e$export$2180d12f0a299a89)({
        value: breakpoint
    }, "\n    width: 14.3%;\n  ", true);
};
// The width of 14.3% is derived from dividing 100/7. We want the
// widths of 7 days to equally fill 100% of the row.
var $c2bf620672af0d10$var$StyledDayContainer = $c2bf620672af0d10$export$ffce625ce693a981 = $c2bf620672af0d10$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledCalendar__StyledDayContainer",
    componentId: "sc-1y4xhmp-4"
})([
    "flex:0 1 auto;",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return props.fillContainer && 'width: 14.3%;';
}, function(props) {
    var _props$theme$calendar7;
    return (props.inRange || props.isSelected && props.rangePosition) && ((_props$theme$calendar7 = props.theme.calendar) == null || (_props$theme$calendar7 = _props$theme$calendar7.range) == null ? void 0 : _props$theme$calendar7.background) && (0, $4113023f9e0bafa0$exports.backgroundStyle)(props.theme.calendar.range.background, props.theme);
}, function(props) {
    return $c2bf620672af0d10$var$rangeRoundStyle(props);
}, function(props) {
    return props.responsive && $c2bf620672af0d10$var$responsiveDayContainerStyle(props);
});
var $c2bf620672af0d10$var$responsiveDayButtonStyle = function responsiveDayButtonStyle(props) {
    var breakpoint = props.theme.global.size[props.sizeProp];
    return (0, $d65b270127c3c07e$export$2180d12f0a299a89)({
        value: breakpoint
    }, "\n    width: 100%;\n  ", true);
};
// when caller opts in to day hover styling, apply all state styles
// on CalendarDay instead of active state on CalendarDayButton
// position relative and z-index are added to prevent the focus
// indicator from getting cut off
var $c2bf620672af0d10$var$StyledDayButton = $c2bf620672af0d10$export$2be68822f46d2c34 = (0, $c2bf620672af0d10$var$_styledComponents["default"])($fb68f765668b25d0$export$353f5b6fc5456de1).withConfig({
    displayName: "StyledCalendar__StyledDayButton",
    componentId: "sc-1y4xhmp-5"
})([
    "&:focus{position:relative;z-index:1;}",
    " ",
    ""
], function(props) {
    return props.disabledProp && (0, $4113023f9e0bafa0$exports.disabledStyle)(props.theme.button.disabled.opacity);
}, function(props) {
    return props.responsive && $c2bf620672af0d10$var$responsiveDayButtonStyle(props);
});
var $c2bf620672af0d10$var$daySizeStyle = function daySizeStyle(props) {
    var data = props.theme.calendar[props.sizeProp];
    return (0, $c2bf620672af0d10$var$_styledComponents.css)([
        "width:",
        ";height:",
        ";"
    ], props.fillContainer ? '100%' : data.daySize, props.fillContainer ? '100%' : data.daySize);
};
var $c2bf620672af0d10$var$responsiveDaySizeStyle = function responsiveDaySizeStyle(props) {
    var breakpoint = props.theme.global.size[props.sizeProp];
    var data = props.theme.calendar[props.sizeProp];
    return (0, $d65b270127c3c07e$export$2180d12f0a299a89)({
        value: breakpoint
    }, "\n      width: 100%;\n      max-width: " + data.daySize + ";\n      height: auto;\n      aspect-ratio: 1;\n    ", true);
};
var $c2bf620672af0d10$var$dayStyle = function dayStyle(props) {
    var backgroundObj;
    var colorObj;
    if (props.isSelected) {
        var _props$theme$calendar8, _props$theme$calendar9;
        backgroundObj = ((_props$theme$calendar8 = props.theme.calendar.day) == null || (_props$theme$calendar8 = _props$theme$calendar8.selected) == null ? void 0 : _props$theme$calendar8.background) || 'control';
        colorObj = (_props$theme$calendar9 = props.theme.calendar.day) == null || (_props$theme$calendar9 = _props$theme$calendar9.selected) == null ? void 0 : _props$theme$calendar9.color;
    } else if (props.inRange) {
        var _props$theme$calendar0, _props$theme$calendar1, _props$theme$calendar10, _props$theme$calendar11;
        // for backwards compatability, only apply this if caller hasn't specified
        // range specific rounding
        // if they have, background will be applied to StyledDayContainer
        backgroundObj = !((_props$theme$calendar0 = props.theme.calendar) != null && (_props$theme$calendar0 = _props$theme$calendar0[props.sizeProp]) != null && (_props$theme$calendar0 = _props$theme$calendar0.range) != null && _props$theme$calendar0.round) && !((_props$theme$calendar1 = props.theme.calendar) != null && (_props$theme$calendar1 = _props$theme$calendar1.medium.range) != null && _props$theme$calendar1.round) && (((_props$theme$calendar10 = props.theme.calendar.day) == null || (_props$theme$calendar10 = _props$theme$calendar10.inRange) == null ? void 0 : _props$theme$calendar10.background) || {
            color: 'control',
            opacity: 'weak'
        });
        colorObj = (_props$theme$calendar11 = props.theme.calendar.day) == null || (_props$theme$calendar11 = _props$theme$calendar11.inRange) == null ? void 0 : _props$theme$calendar11.color;
    } else {
        var _props$theme$calendar12, _props$theme$calendar13;
        backgroundObj = (_props$theme$calendar12 = props.theme.calendar.day) == null ? void 0 : _props$theme$calendar12.background;
        colorObj = (_props$theme$calendar13 = props.theme.calendar.day) == null ? void 0 : _props$theme$calendar13.color;
    }
    if (colorObj && !backgroundObj) return "color: " + (0, $4113023f9e0bafa0$exports.normalizeColor)(colorObj, props.theme) + ";";
    return (0, $4113023f9e0bafa0$exports.backgroundStyle)(backgroundObj, props.theme, colorObj);
};
var $c2bf620672af0d10$var$dayHoverStyle = function dayHoverStyle(props) {
    var backgroundObj;
    var colorObj;
    if (props.isSelected) {
        var _props$theme$calendar14, _props$theme$calendar15;
        backgroundObj = (_props$theme$calendar14 = props.theme.calendar.day) == null || (_props$theme$calendar14 = _props$theme$calendar14.selected) == null || (_props$theme$calendar14 = _props$theme$calendar14.hover) == null ? void 0 : _props$theme$calendar14.background;
        colorObj = (_props$theme$calendar15 = props.theme.calendar.day) == null || (_props$theme$calendar15 = _props$theme$calendar15.selected) == null || (_props$theme$calendar15 = _props$theme$calendar15.hover) == null ? void 0 : _props$theme$calendar15.color;
    } else if (props.inRange) {
        var _props$theme$calendar16, _props$theme$calendar17;
        backgroundObj = (_props$theme$calendar16 = props.theme.calendar.day) == null || (_props$theme$calendar16 = _props$theme$calendar16.inRange) == null || (_props$theme$calendar16 = _props$theme$calendar16.hover) == null ? void 0 : _props$theme$calendar16.background;
        colorObj = (_props$theme$calendar17 = props.theme.calendar.day) == null || (_props$theme$calendar17 = _props$theme$calendar17.inRange) == null || (_props$theme$calendar17 = _props$theme$calendar17.hover) == null ? void 0 : _props$theme$calendar17.color;
    } else {
        var _props$theme$calendar18, _props$theme$calendar19;
        backgroundObj = (_props$theme$calendar18 = props.theme.calendar.day) == null || (_props$theme$calendar18 = _props$theme$calendar18.hover) == null ? void 0 : _props$theme$calendar18.background;
        colorObj = (_props$theme$calendar19 = props.theme.calendar.day) == null || (_props$theme$calendar19 = _props$theme$calendar19.hover) == null ? void 0 : _props$theme$calendar19.color;
    }
    if (colorObj && !backgroundObj) return "color: " + (0, $4113023f9e0bafa0$exports.normalizeColor)(colorObj, props.theme) + ";";
    return (0, $4113023f9e0bafa0$exports.backgroundStyle)(backgroundObj, props.theme, colorObj);
};
var $c2bf620672af0d10$var$dayFontStyle = function dayFontStyle(props) {
    var fontWeight;
    if (props.isSelected) {
        var _props$theme$calendar20;
        fontWeight = (_props$theme$calendar20 = props.theme.calendar.day) == null || (_props$theme$calendar20 = _props$theme$calendar20.selected) == null || (_props$theme$calendar20 = _props$theme$calendar20.font) == null ? void 0 : _props$theme$calendar20.weight;
    } else if (props.inRange) {
        var _props$theme$calendar21;
        fontWeight = (_props$theme$calendar21 = props.theme.calendar.day) == null || (_props$theme$calendar21 = _props$theme$calendar21.inRange) == null || (_props$theme$calendar21 = _props$theme$calendar21.font) == null ? void 0 : _props$theme$calendar21.weight;
    }
    return fontWeight && "font-weight: " + fontWeight + ";";
};
var $c2bf620672af0d10$var$StyledDay = $c2bf620672af0d10$export$4fe9184bd47dbe20 = $c2bf620672af0d10$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledCalendar__StyledDay",
    componentId: "sc-1y4xhmp-6"
})([
    "display:flex;justify-content:center;align-items:center;color:",
    ";",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], function(props) {
    var _props$theme$calendar22;
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(props.otherMonth ? ((_props$theme$calendar22 = props.theme.calendar) == null || (_props$theme$calendar22 = _props$theme$calendar22.day) == null || (_props$theme$calendar22 = _props$theme$calendar22.adjacent) == null ? void 0 : _props$theme$calendar22.color) || 'text-xweak' : 'text-strong', props.theme);
}, function(props) {
    return $c2bf620672af0d10$var$daySizeStyle(props);
}, function(props) {
    return props.responsive && $c2bf620672af0d10$var$responsiveDaySizeStyle(props);
}, function(props) {
    return $c2bf620672af0d10$var$dayStyle(props);
}, function(props) {
    return $c2bf620672af0d10$var$dayFontStyle(props);
}, function(props) {
    var _props$theme$calendar23, _props$theme$calendar24;
    // fallback to medium if no size-specific styles
    var round = ((_props$theme$calendar23 = props.theme.calendar) == null || (_props$theme$calendar23 = _props$theme$calendar23[props.sizeProp]) == null || (_props$theme$calendar23 = _props$theme$calendar23.day) == null ? void 0 : _props$theme$calendar23.round) || ((_props$theme$calendar24 = props.theme.calendar) == null || (_props$theme$calendar24 = _props$theme$calendar24.medium) == null || (_props$theme$calendar24 = _props$theme$calendar24.day) == null ? void 0 : _props$theme$calendar24.round);
    return round && (0, $4113023f9e0bafa0$exports.roundStyle)(round, props.responsive, props.theme);
}, function(props) {
    return props.hover && !props.disabledProp && $c2bf620672af0d10$var$dayHoverStyle(props);
}, function(props) {
    return(// when theme uses kind Buttons, since we use children for Button,
    // we have to special case how we handle disabled days here
    props.disabledProp && props.theme.button["default"] && (0, $4113023f9e0bafa0$exports.kindPartStyles)(props.theme.button.disabled, props.theme));
}, function(props) {
    return props.theme.calendar && props.theme.calendar.day && props.theme.calendar.day.extend;
});


var $6dca34d168a0b7e8$export$1e511d4a378977f5;
var $6dca34d168a0b7e8$export$509e5b8f8eb27f5c;
var $6dca34d168a0b7e8$export$cde1cfadc1403459;
var $6dca34d168a0b7e8$export$8f6ba218ec818063;
var $6dca34d168a0b7e8$export$a5a3b454ada2268e;
var $6dca34d168a0b7e8$export$fc01259e21cb1793;
var $6dca34d168a0b7e8$export$b43b14f05e74d2a6;
var $6dca34d168a0b7e8$export$803c6c0e435ba32b;
var $6dca34d168a0b7e8$export$440bcced20c33405;
var $6dca34d168a0b7e8$export$b4a32babffa865e6;
var $6dca34d168a0b7e8$export$a2258d9c4118825c;
var $6dca34d168a0b7e8$export$564c235164ed6ce8;
var $6dca34d168a0b7e8$export$5e6ff6e7b7b4e53b;
var $6dca34d168a0b7e8$export$17c93e242b2d3a22;
var $6dca34d168a0b7e8$export$dd412b56f1e4d8aa;
"use strict";
$6dca34d168a0b7e8$export$1e511d4a378977f5 = true;
$6dca34d168a0b7e8$export$509e5b8f8eb27f5c = $6dca34d168a0b7e8$export$cde1cfadc1403459 = $6dca34d168a0b7e8$export$8f6ba218ec818063 = $6dca34d168a0b7e8$export$a5a3b454ada2268e = $6dca34d168a0b7e8$export$fc01259e21cb1793 = $6dca34d168a0b7e8$export$b43b14f05e74d2a6 = $6dca34d168a0b7e8$export$803c6c0e435ba32b = $6dca34d168a0b7e8$export$440bcced20c33405 = $6dca34d168a0b7e8$export$b4a32babffa865e6 = $6dca34d168a0b7e8$export$a2258d9c4118825c = $6dca34d168a0b7e8$export$564c235164ed6ce8 = $6dca34d168a0b7e8$export$5e6ff6e7b7b4e53b = $6dca34d168a0b7e8$export$17c93e242b2d3a22 = $6dca34d168a0b7e8$export$dd412b56f1e4d8aa = void 0;
// Utility functions for the Calendar.
// Just what's needed to avoid having to include a dependency like momentjs.
var $6dca34d168a0b7e8$var$DAY_MILLISECONDS = 86400000;
var $6dca34d168a0b7e8$var$addDays = $6dca34d168a0b7e8$export$dd412b56f1e4d8aa = function addDays(date, days) {
    var result = new Date(date.getTime() + $6dca34d168a0b7e8$var$DAY_MILLISECONDS * days);
    // Deal with crossing the daylight savings time boundary,
    // where adding a day's worth when the time is midnight results in
    // being a day off.
    var hourDelta = result.getHours() - date.getHours();
    // At this point, hourDelta is typically 0 (normal day),
    // +23 (November daylight saving), or -23 (March Daylight saving)
    // depending on which side of the switch we are on.
    // Convert so that hourDelta is either +1 or -1.
    if (hourDelta === 23) hourDelta -= 24;
    else if (hourDelta === -23) hourDelta += 24;
    result.setHours(result.getHours() - hourDelta);
    return result;
};
var $6dca34d168a0b7e8$var$subtractDays = $6dca34d168a0b7e8$export$8f6ba218ec818063 = function subtractDays(date, days) {
    return $6dca34d168a0b7e8$var$addDays(date, -days);
};
var $6dca34d168a0b7e8$var$addMonths = $6dca34d168a0b7e8$export$17c93e242b2d3a22 = function addMonths(date, months) {
    var result = new Date(date);
    var years = Math.floor((date.getMonth() + months) / 12);
    result.setFullYear(date.getFullYear() + years);
    var targetMonth = (date.getMonth() + months) % 12;
    result.setMonth(targetMonth < 0 ? 12 + targetMonth : targetMonth);
    return result;
};
var $6dca34d168a0b7e8$var$subtractMonths = $6dca34d168a0b7e8$export$cde1cfadc1403459 = function subtractMonths(date, months) {
    return $6dca34d168a0b7e8$var$addMonths(date, -months);
};
var $6dca34d168a0b7e8$var$startOfMonth = $6dca34d168a0b7e8$export$a5a3b454ada2268e = function startOfMonth(date) {
    var result = new Date(date);
    result.setDate(1);
    return result;
};
var $6dca34d168a0b7e8$var$endOfMonth = $6dca34d168a0b7e8$export$a2258d9c4118825c = function endOfMonth(date) {
    var result = $6dca34d168a0b7e8$var$addMonths(date, 1);
    result.setDate(0);
    return result;
};
var $6dca34d168a0b7e8$var$sameDay = $6dca34d168a0b7e8$export$803c6c0e435ba32b = function sameDay(date1, date2) {
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
};
var $6dca34d168a0b7e8$var$sameDayOrAfter = $6dca34d168a0b7e8$export$b43b14f05e74d2a6 = function sameDayOrAfter(date1, date2) {
    return date1.getFullYear() > date2.getFullYear() || date1.getFullYear() === date2.getFullYear() && (date1.getMonth() > date2.getMonth() || date1.getMonth() === date2.getMonth() && date1.getDate() >= date2.getDate());
};
var $6dca34d168a0b7e8$var$sameDayOrBefore = $6dca34d168a0b7e8$export$fc01259e21cb1793 = function sameDayOrBefore(date1, date2) {
    return date1.getFullYear() < date2.getFullYear() || date1.getFullYear() === date2.getFullYear() && (date1.getMonth() < date2.getMonth() || date1.getMonth() === date2.getMonth() && date1.getDate() <= date2.getDate());
};
var $6dca34d168a0b7e8$var$daysApart = $6dca34d168a0b7e8$export$564c235164ed6ce8 = function daysApart(date1, date2) {
    return Math.floor((date1.getTime() - date2.getTime()) / $6dca34d168a0b7e8$var$DAY_MILLISECONDS);
};
// betweenDates takes an array of two elements and checks if the
// supplied date lies between them, inclusive.
// returns 2 if exact match to one end, 1 if between, undefined otherwise
var $6dca34d168a0b7e8$var$betweenDates = $6dca34d168a0b7e8$export$5e6ff6e7b7b4e53b = function betweenDates(date, dates) {
    var result;
    if (dates) {
        var _ref = Array.isArray(dates) ? dates.map(function(d) {
            return d ? new Date(d) : undefined;
        }) : [
            dates,
            undefined
        ], from = _ref[0], to = _ref[1];
        if (from && $6dca34d168a0b7e8$var$sameDay(date, from) || to && $6dca34d168a0b7e8$var$sameDay(date, to)) result = 2;
        else if (from && $6dca34d168a0b7e8$var$sameDayOrAfter(date, from) && to && $6dca34d168a0b7e8$var$sameDayOrBefore(date, to)) result = 1;
    } else result = 1;
    return result;
};
var $6dca34d168a0b7e8$var$getRangePosition = $6dca34d168a0b7e8$export$b4a32babffa865e6 = function getRangePosition(date, dates) {
    var rangePosition;
    if (dates) {
        var _ref2 = Array.isArray(dates) ? dates.map(function(d) {
            return d ? new Date(d) : undefined;
        }) : [
            dates,
            undefined
        ], from = _ref2[0], to = _ref2[1];
        if (from && $6dca34d168a0b7e8$var$sameDay(date, from)) rangePosition = 'start';
        else if (to && $6dca34d168a0b7e8$var$sameDay(date, to)) rangePosition = 'end';
    }
    return rangePosition;
};
// withinDates takes an array of string dates or 2 element arrays and
// checks whether the supplied date matches any string or is between
// any dates in arrays.
// returns 2 if exact match, 1 if between, undefined otherwise
var $6dca34d168a0b7e8$var$withinDates = $6dca34d168a0b7e8$export$509e5b8f8eb27f5c = function withinDates(date, dates) {
    var result;
    var rangePosition;
    if (dates) {
        if (Array.isArray(dates)) dates.some(function(d) {
            if (d instanceof Date) {
                if ($6dca34d168a0b7e8$var$sameDay(date, d)) result = 2;
            } else {
                result = $6dca34d168a0b7e8$var$betweenDates(date, d);
                rangePosition = $6dca34d168a0b7e8$var$getRangePosition(date, d);
            }
            return result;
        });
        else if ($6dca34d168a0b7e8$var$sameDay(date, dates)) result = 2;
    }
    return [
        result,
        rangePosition
    ];
};
var $6dca34d168a0b7e8$var$handleOffset = $6dca34d168a0b7e8$export$440bcced20c33405 = function handleOffset(date) {
    var normalizedDate = new Date(date);
    var offset = normalizedDate.getTimezoneOffset();
    var hour = normalizedDate.getHours();
    // add back offset
    normalizedDate.setHours(hour, offset < 0 ? -offset : offset);
    return normalizedDate;
};




var $fcf2886c26d1d13d$var$_excluded = [
    "activeDate",
    "animate",
    "bounds",
    "children",
    "date",
    "dates",
    "daysOfWeek",
    "disabled",
    "initialFocus",
    "fill",
    "firstDayOfWeek",
    "header",
    "level",
    "locale",
    "messages",
    "onReference",
    "onSelect",
    "range",
    "reference",
    "responsive",
    "showAdjacentDays",
    "size",
    "timestamp"
], $fcf2886c26d1d13d$var$_excluded2 = [
    "container"
];
function $fcf2886c26d1d13d$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($fcf2886c26d1d13d$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $fcf2886c26d1d13d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $fcf2886c26d1d13d$var$_extends() {
    return $fcf2886c26d1d13d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fcf2886c26d1d13d$var$_extends.apply(null, arguments);
}
var $fcf2886c26d1d13d$var$getLocaleString = function getLocaleString(value, locale) {
    return value == null ? void 0 : value.toLocaleDateString(locale, {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    });
};
var $fcf2886c26d1d13d$var$currentlySelectedString = function currentlySelectedString(value, locale) {
    var selected;
    if (value instanceof Date) selected = "Currently selected " + $fcf2886c26d1d13d$var$getLocaleString(value, locale) + ";";
    else if (value != null && value.length) selected = "Currently selected " + value.map(function(item) {
        var dates;
        if (!Array.isArray(item)) dates = "" + $fcf2886c26d1d13d$var$getLocaleString(item, locale);
        else {
            var start = item[0] !== undefined ? $fcf2886c26d1d13d$var$getLocaleString(item[0], locale) : 'none';
            var end = item[1] !== undefined ? $fcf2886c26d1d13d$var$getLocaleString(item[1], locale) : 'none';
            dates = start + " through " + end;
        }
        return dates;
    });
    else selected = 'No date selected';
    return selected;
};
// calendar value may be a single date, multiple dates, a range of dates
// supplied as ISOstrings.
var $fcf2886c26d1d13d$var$_normalizeInput = function normalizeInput(dateValue) {
    var result;
    if (dateValue instanceof Date) result = dateValue;
    else if (typeof dateValue === 'string' && dateValue.length) result = (0, $7f85f6d695ff3bb5$export$c739ab4d3d4926aa)(dateValue);
    else if (Array.isArray(dateValue)) result = dateValue.map(function(d) {
        return $fcf2886c26d1d13d$var$_normalizeInput(d);
    });
    return result;
};
var $fcf2886c26d1d13d$var$_normalizeOutput = function normalizeOutput(dateValue, outputFormat) {
    var result;
    var normalize = function normalize(value) {
        var normalizedValue = value.toISOString();
        if (normalizedValue && outputFormat === 'no timezone') {
            var _handleOffset$toISOSt = (0, $6dca34d168a0b7e8$export$440bcced20c33405)(normalizedValue).toISOString().split('T');
            normalizedValue = _handleOffset$toISOSt[0];
        }
        return normalizedValue;
    };
    if (dateValue instanceof Date) result = normalize(dateValue);
    else if (typeof dateValue === 'undefined') result = undefined;
    else result = dateValue.map(function(d) {
        return $fcf2886c26d1d13d$var$_normalizeOutput(d, outputFormat);
    });
    return result;
};
// format value to [[]] for internal functions
var $fcf2886c26d1d13d$var$normalizeRange = function normalizeRange(value, activeDate) {
    var range = value;
    if (range instanceof Date) range = activeDate === 'start' ? [
        [
            undefined,
            range
        ]
    ] : [
        [
            range,
            undefined
        ]
    ];
    else if (Array.isArray(range) && !Array.isArray(range[0])) range = [
        range
    ];
    return range;
};
var $fcf2886c26d1d13d$var$getReference = function getReference(reference, onReference, value, activeDate) {
    var nextReference;
    if (reference && onReference) // controlled component, so use the reference provided
    nextReference = reference;
    else if (value) {
        if (Array.isArray(value)) {
            if (value[0] instanceof Date) {
                // if we just selected an end date, active date will be 'start'
                // and we should set the reference to the end date
                if (activeDate === 'start' && value[1] instanceof Date) nextReference = value[1];
                else nextReference = value[0];
            } else if (Array.isArray(value[0])) {
                // if we just selected an end date, active date will be 'start'
                // and we should set the reference to the end date
                if (activeDate === 'start' && value[0][1]) // eslint-disable-next-line prefer-destructuring
                nextReference = value[0][1];
                else nextReference = value[0][0] ? value[0][0] : value[0][1];
            } else {
                nextReference = new Date();
                nextReference.setHours(0, 0, 0, 0);
            }
        } else nextReference = value;
    } else if (reference) nextReference = reference;
    else {
        nextReference = new Date();
        nextReference.setHours(0, 0, 0, 0);
    }
    return nextReference;
};
var $fcf2886c26d1d13d$var$buildDisplayBounds = function buildDisplayBounds(reference, firstDayOfWeek) {
    var start = new Date(reference);
    start.setDate(1); // first of month
    // In case Sunday is the first day of the month, and the user asked for Monday
    // to be the first day of the week, then we need to include Sunday and six
    // days prior.
    start = start.getDay() === 0 && firstDayOfWeek === 1 ? start = (0, $6dca34d168a0b7e8$export$8f6ba218ec818063)(start, 6) : // beginning of week
    start = (0, $6dca34d168a0b7e8$export$8f6ba218ec818063)(start, start.getDay() - firstDayOfWeek);
    var end = (0, $6dca34d168a0b7e8$export$dd412b56f1e4d8aa)(start, 42); // 5 weeks to end of week
    return [
        start,
        end
    ];
};
var $fcf2886c26d1d13d$var$monthBounds = function monthBounds(reference) {
    var start = new Date(reference);
    start.setDate(1); // first of month
    var end = (0, $6dca34d168a0b7e8$export$a2258d9c4118825c)(start);
    return [
        start,
        end
    ];
};
var $fcf2886c26d1d13d$var$disabledCalendarPreviousMonthButton = function disabledCalendarPreviousMonthButton(date, reference, bounds) {
    if (!bounds) return false;
    var lastBound = new Date(bounds[1]);
    return !(0, $6dca34d168a0b7e8$export$fc01259e21cb1793)(lastBound, reference) && !(0, $6dca34d168a0b7e8$export$5e6ff6e7b7b4e53b)(date, bounds);
};
var $fcf2886c26d1d13d$var$disabledCalendarNextMonthButton = function disabledCalendarNextMonthButton(date, reference, bounds) {
    if (!bounds) return false;
    var firstBound = new Date(bounds[0]);
    return !(0, $6dca34d168a0b7e8$export$b43b14f05e74d2a6)(firstBound, reference) && !(0, $6dca34d168a0b7e8$export$5e6ff6e7b7b4e53b)(date, bounds);
};
var $fcf2886c26d1d13d$var$_getOutputFormat = $fcf2886c26d1d13d$export$c0c99f9031a45b3 = function getOutputFormat(dates) {
    if (typeof dates === 'string' && (dates == null ? void 0 : dates.indexOf('T')) === -1) return 'no timezone';
    if (Array.isArray(dates)) return $fcf2886c26d1d13d$var$_getOutputFormat(dates[0]);
    return 'date timezone';
};
var $fcf2886c26d1d13d$var$millisecondsPerYear = 31557600000;
var $fcf2886c26d1d13d$var$CalendarDay = /*#__PURE__*/ (0, $fcf2886c26d1d13d$var$_react.forwardRef)(function(_ref, ref) {
    var activeProp = _ref.activeProp, children = _ref.children, day = _ref.day, disabledProp = _ref.disabledProp, fill = _ref.fill, size = _ref.size, isInRange = _ref.isInRange, isSelected = _ref.isSelected, otherMonth = _ref.otherMonth, rangePosition = _ref.rangePosition, _ref$buttonProps = _ref.buttonProps, buttonProps = _ref$buttonProps === void 0 ? {} : _ref$buttonProps, responsive = _ref.responsive;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    return /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($c2bf620672af0d10$export$ffce625ce693a981, {
        role: "gridcell",
        "aria-selected": isSelected,
        inRange: isInRange,
        isSelected: isSelected,
        rangePosition: rangePosition,
        sizeProp: size,
        fillContainer: fill,
        responsive: responsive
    }, /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($c2bf620672af0d10$export$2be68822f46d2c34, $fcf2886c26d1d13d$var$_extends({
        "aria-disabled": disabledProp,
        disabledProp: disabledProp,
        fill: fill,
        plain: true,
        tabIndex: (activeProp == null ? void 0 : activeProp.getTime()) === (day == null ? void 0 : day.getTime()) ? 0 : -1,
        responsive: responsive
    }, buttonProps, {
        ref: (activeProp == null ? void 0 : activeProp.getTime()) === (day == null ? void 0 : day.getTime()) ? ref : undefined
    }), function(_ref2) {
        var hover = _ref2.hover;
        return /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($c2bf620672af0d10$export$4fe9184bd47dbe20, $fcf2886c26d1d13d$var$_extends({
            disabledProp: disabledProp,
            hover: hover,
            inRange: isInRange,
            isSelected: isSelected,
            otherMonth: otherMonth,
            sizeProp: size,
            fillContainer: fill,
            responsive: responsive
        }, passThemeFlag), children);
    }));
});
var $fcf2886c26d1d13d$var$CalendarCustomDay = function CalendarCustomDay(_ref3) {
    var ariaSelected = _ref3['aria-selected'], children = _ref3.children, fill = _ref3.fill, size = _ref3.size, buttonProps = _ref3.buttonProps, responsive = _ref3.responsive;
    if (!buttonProps) return /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($c2bf620672af0d10$export$ffce625ce693a981, {
        "aria-selected": ariaSelected,
        role: "gridcell",
        sizeProp: size,
        fillContainer: fill,
        responsive: responsive
    }, children);
    return /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($c2bf620672af0d10$export$ffce625ce693a981, {
        "aria-selected": ariaSelected,
        role: "gridcell",
        sizeProp: size,
        fillContainer: fill,
        responsive: responsive
    }, /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($c2bf620672af0d10$export$2be68822f46d2c34, $fcf2886c26d1d13d$var$_extends({
        fill: fill,
        responsive: responsive
    }, buttonProps), children));
};
var $fcf2886c26d1d13d$var$Calendar = $fcf2886c26d1d13d$export$e1aef45b828286de = /*#__PURE__*/ (0, $fcf2886c26d1d13d$var$_react.forwardRef)(function(_ref4, ref) {
    var activeDateProp = _ref4.activeDate, _ref4$animate = _ref4.animate, animate = _ref4$animate === void 0 ? true : _ref4$animate, boundsProp = _ref4.bounds, children = _ref4.children, dateProp = _ref4.date, datesProp = _ref4.dates, daysOfWeek = _ref4.daysOfWeek, disabled = _ref4.disabled, initialFocus = _ref4.initialFocus, fill = _ref4.fill, _ref4$firstDayOfWeek = _ref4.firstDayOfWeek, firstDayOfWeek = _ref4$firstDayOfWeek === void 0 ? 0 : _ref4$firstDayOfWeek, header = _ref4.header, level = _ref4.level, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? 'en-US' : _ref4$locale, messages = _ref4.messages, onReference = _ref4.onReference, onSelect = _ref4.onSelect, range = _ref4.range, referenceProp = _ref4.reference, _ref4$responsive = _ref4.responsive, responsiveProp = _ref4$responsive === void 0 ? true : _ref4$responsive, _ref4$showAdjacentDay = _ref4.showAdjacentDays, showAdjacentDays = _ref4$showAdjacentDay === void 0 ? true : _ref4$showAdjacentDay, _ref4$size = _ref4.size, size = _ref4$size === void 0 ? 'medium' : _ref4$size, timestampProp = _ref4.timestamp, rest = $fcf2886c26d1d13d$var$_objectWithoutPropertiesLoose(_ref4, $fcf2886c26d1d13d$var$_excluded);
    var _useThemeValue2 = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue2.theme, passThemeFlag = _useThemeValue2.passThemeFlag;
    var announce = (0, $fcf2886c26d1d13d$var$_react.useContext)($cfbcb74d4f54e56b$export$dcc8f4bff0d51f50);
    var _useContext = (0, $fcf2886c26d1d13d$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    // If fill is true the responsive behavior isn't needed.
    var responsive = responsiveProp && !fill;
    // set activeDate when caller changes it, allows us to change
    // it internally too
    var _useState = (0, $fcf2886c26d1d13d$var$_react.useState)(dateProp && typeof dateProp === 'string' && range ? 'end' : 'start'), activeDate = _useState[0], setActiveDate = _useState[1];
    (0, $fcf2886c26d1d13d$var$_react.useEffect)(function() {
        if (activeDateProp) setActiveDate(activeDateProp);
    }, [
        activeDateProp
    ]);
    var _useState2 = (0, $fcf2886c26d1d13d$var$_react.useState)($fcf2886c26d1d13d$var$_normalizeInput(dateProp || datesProp)), value = _useState2[0], setValue = _useState2[1];
    (0, $fcf2886c26d1d13d$var$_react.useEffect)(function() {
        var val = dateProp || datesProp;
        setValue($fcf2886c26d1d13d$var$_normalizeInput(val));
    }, [
        dateProp,
        datesProp
    ]);
    var _useState3 = (0, $fcf2886c26d1d13d$var$_react.useState)($fcf2886c26d1d13d$var$getReference($fcf2886c26d1d13d$var$_normalizeInput(referenceProp), onReference, value, activeDate)), reference = _useState3[0], setReference = _useState3[1];
    (0, $fcf2886c26d1d13d$var$_react.useEffect)(function() {
        setReference($fcf2886c26d1d13d$var$getReference($fcf2886c26d1d13d$var$_normalizeInput(referenceProp), onReference, value, activeDate));
    }, [
        referenceProp,
        onReference,
        value,
        activeDate
    ]);
    var _useState4 = (0, $fcf2886c26d1d13d$var$_react.useState)($fcf2886c26d1d13d$var$_getOutputFormat(dateProp || datesProp)), outputFormat = _useState4[0], setOutputFormat = _useState4[1];
    (0, $fcf2886c26d1d13d$var$_react.useEffect)(function() {
        setOutputFormat($fcf2886c26d1d13d$var$_getOutputFormat(dateProp || datesProp));
    }, [
        dateProp,
        datesProp
    ]);
    // normalize bounds
    var _useState5 = (0, $fcf2886c26d1d13d$var$_react.useState)(boundsProp), bounds = _useState5[0], setBounds = _useState5[1];
    (0, $fcf2886c26d1d13d$var$_react.useEffect)(function() {
        if (boundsProp) setBounds(boundsProp);
        else setBounds(undefined);
    }, [
        boundsProp
    ]);
    // calculate the bounds we display based on the reference
    var _useState6 = (0, $fcf2886c26d1d13d$var$_react.useState)($fcf2886c26d1d13d$var$buildDisplayBounds(reference, firstDayOfWeek)), displayBounds = _useState6[0], setDisplayBounds = _useState6[1];
    var _useState7 = (0, $fcf2886c26d1d13d$var$_react.useState)(), targetDisplayBounds = _useState7[0], setTargetDisplayBounds = _useState7[1];
    var _useState8 = (0, $fcf2886c26d1d13d$var$_react.useState)(), slide = _useState8[0], setSlide = _useState8[1];
    var _useState9 = (0, $fcf2886c26d1d13d$var$_react.useState)(), animating = _useState9[0], setAnimating = _useState9[1];
    // When the reference changes, we need to update the displayBounds.
    // This is easy when we aren't animating. If we are animating,
    // we temporarily increase the displayBounds to be the union of the old
    // and new ones and set slide to drive the animation. We keep track
    // of where we are heading via targetDisplayBounds. When the animation
    // finishes, we prune displayBounds down to where we are headed and
    // clear the slide and targetDisplayBounds.
    (0, $fcf2886c26d1d13d$var$_react.useEffect)(function() {
        var nextDisplayBounds = $fcf2886c26d1d13d$var$buildDisplayBounds(reference, firstDayOfWeek);
        // Checks if the difference between the current and next DisplayBounds is
        // greater than a year. If that's the case, calendar should update without
        // animation.
        if (nextDisplayBounds[0].getTime() !== displayBounds[0].getTime() && nextDisplayBounds[1].getTime() !== displayBounds[1].getTime()) {
            var diffBoundsAboveYear = false;
            if (nextDisplayBounds[0].getTime() < displayBounds[0].getTime()) {
                if (displayBounds[0].getTime() - nextDisplayBounds[0].getTime() > $fcf2886c26d1d13d$var$millisecondsPerYear) diffBoundsAboveYear = true;
            } else if (nextDisplayBounds[1].getTime() > displayBounds[1].getTime()) {
                if (nextDisplayBounds[1].getTime() - displayBounds[1].getTime() > $fcf2886c26d1d13d$var$millisecondsPerYear) diffBoundsAboveYear = true;
            }
            if (!animate || diffBoundsAboveYear) setDisplayBounds(nextDisplayBounds);
            else setTargetDisplayBounds(nextDisplayBounds);
        }
    }, [
        animate,
        firstDayOfWeek,
        reference,
        displayBounds
    ]);
    (0, $fcf2886c26d1d13d$var$_react.useEffect)(function() {
        // if the reference timezone has changed (e.g., controlled component),
        // both ends of the displayBounds should inherit that new timestamp
        if (targetDisplayBounds) {
            if (targetDisplayBounds[0].getTime() < displayBounds[0].getTime() || targetDisplayBounds[1].getTime() > displayBounds[1].getTime()) setDisplayBounds([
                targetDisplayBounds[0],
                targetDisplayBounds[1]
            ]);
            if (targetDisplayBounds[0].getTime() < displayBounds[0].getTime()) // only animate if the duration is within a year
            {
                if (displayBounds[0].getTime() - targetDisplayBounds[0].getTime() < $fcf2886c26d1d13d$var$millisecondsPerYear && (0, $6dca34d168a0b7e8$export$564c235164ed6ce8)(displayBounds[0], targetDisplayBounds[0])) {
                    setSlide({
                        direction: 'down',
                        weeks: (0, $6dca34d168a0b7e8$export$564c235164ed6ce8)(displayBounds[0], targetDisplayBounds[0]) / 7
                    });
                    setAnimating(true);
                }
            } else if (targetDisplayBounds[1].getTime() > displayBounds[1].getTime()) {
                if (targetDisplayBounds[1].getTime() - displayBounds[1].getTime() < $fcf2886c26d1d13d$var$millisecondsPerYear && (0, $6dca34d168a0b7e8$export$564c235164ed6ce8)(targetDisplayBounds[1], displayBounds[1])) {
                    setSlide({
                        direction: 'up',
                        weeks: (0, $6dca34d168a0b7e8$export$564c235164ed6ce8)(targetDisplayBounds[1], displayBounds[1]) / 7
                    });
                    setAnimating(true);
                }
            }
            return undefined;
        }
        setSlide(undefined);
        return undefined;
    }, [
        animating,
        displayBounds,
        targetDisplayBounds
    ]);
    // Last step in updating the displayBounds. Allows for pruning
    // displayBounds and cleaning up states to occur after animation.
    (0, $fcf2886c26d1d13d$var$_react.useEffect)(function() {
        if (animating && targetDisplayBounds) {
            // Wait for animation to finish before cleaning up.
            var timer = setTimeout(function() {
                setDisplayBounds(targetDisplayBounds);
                setTargetDisplayBounds(undefined);
                setSlide(undefined);
                setAnimating(false);
            }, 400 // Empirically determined.
            );
            return function() {
                return clearTimeout(timer);
            };
        }
        return undefined;
    }, [
        animating,
        targetDisplayBounds
    ]);
    // We have to deal with reference being the end of a month with more
    // days than the month we are changing to. So, we always set reference
    // to the first of the month before changing the month.
    var previousMonth = (0, $fcf2886c26d1d13d$var$_react.useMemo)(function() {
        return (0, $6dca34d168a0b7e8$export$a2258d9c4118825c)((0, $6dca34d168a0b7e8$export$cde1cfadc1403459)((0, $6dca34d168a0b7e8$export$a5a3b454ada2268e)(reference), 1));
    }, [
        reference
    ]);
    var nextMonth = (0, $fcf2886c26d1d13d$var$_react.useMemo)(function() {
        return (0, $6dca34d168a0b7e8$export$a5a3b454ada2268e)((0, $6dca34d168a0b7e8$export$17c93e242b2d3a22)((0, $6dca34d168a0b7e8$export$a5a3b454ada2268e)(reference), 1));
    }, [
        reference
    ]);
    var initialFocusDate = showAdjacentDays ? new Date(displayBounds[0]) : (0, $6dca34d168a0b7e8$export$a5a3b454ada2268e)(reference);
    var _useState0 = (0, $fcf2886c26d1d13d$var$_react.useState)(), focus = _useState0[0], setFocus = _useState0[1];
    var _useState1 = (0, $fcf2886c26d1d13d$var$_react.useState)(initialFocusDate), active = _useState1[0], setActive = _useState1[1];
    var focusableDateRef = (0, $fcf2886c26d1d13d$var$_react.useRef)(undefined);
    (0, $fcf2886c26d1d13d$var$_react.useEffect)(function() {
        if (focusableDateRef != null && focusableDateRef.current && initialFocus === 'days') focusableDateRef.current.focus();
    }, [
        initialFocus,
        focusableDateRef
    ]);
    var handleReference = (0, $fcf2886c26d1d13d$var$_react.useCallback)(function(nextReference) {
        setReference(nextReference);
        if (onReference) onReference(nextReference.toISOString());
    }, [
        onReference
    ]);
    var changeReference = (0, $fcf2886c26d1d13d$var$_react.useCallback)(function(nextReference) {
        if ((0, $6dca34d168a0b7e8$export$5e6ff6e7b7b4e53b)(nextReference, bounds)) handleReference(nextReference);
    }, [
        handleReference,
        bounds
    ]);
    var changeCalendarMonth = function changeCalendarMonth(messageId, newMonth) {
        handleReference(newMonth);
        var referenceStartOfMonth = (0, $6dca34d168a0b7e8$export$a5a3b454ada2268e)(reference);
        var firstOfMonth = new Date(newMonth.getFullYear(), newMonth.getMonth(), 1, referenceStartOfMonth.getHours(), referenceStartOfMonth.getMinutes(), referenceStartOfMonth.getSeconds());
        setActive(firstOfMonth);
        announce(format({
            id: messageId,
            messages: messages,
            values: {
                date: newMonth.toLocaleDateString(locale, {
                    month: 'long',
                    year: 'numeric'
                })
            }
        }));
    };
    var handleRange = (0, $fcf2886c26d1d13d$var$_react.useCallback)(function(selectedDate) {
        var _priorRange$, _priorRange$2;
        var result;
        var nextActiveDate = activeDate;
        var priorRange = $fcf2886c26d1d13d$var$normalizeRange(value, activeDate);
        // deselect when date clicked was the start/end of the range
        if (selectedDate.getTime() === (priorRange == null || (_priorRange$ = priorRange[0]) == null || (_priorRange$ = _priorRange$[0]) == null ? void 0 : _priorRange$.getTime())) {
            result = [
                [
                    undefined,
                    priorRange[0][1]
                ]
            ];
            nextActiveDate = 'start';
        } else if (selectedDate.getTime() === (priorRange == null || (_priorRange$2 = priorRange[0]) == null || (_priorRange$2 = _priorRange$2[1]) == null ? void 0 : _priorRange$2.getTime())) {
            result = [
                [
                    priorRange[0][0],
                    undefined
                ]
            ];
            nextActiveDate = 'end';
        } else if (activeDate === 'start') {
            if (!priorRange) result = [
                [
                    selectedDate,
                    undefined
                ]
            ];
            else if (!priorRange[0][1]) result = [
                [
                    selectedDate,
                    priorRange[0][1]
                ]
            ];
            else if (selectedDate.getTime() < priorRange[0][1].getTime()) result = [
                [
                    selectedDate,
                    priorRange[0][1]
                ]
            ];
            else if (selectedDate.getTime() > priorRange[0][1].getTime()) result = [
                [
                    selectedDate,
                    undefined
                ]
            ];
            nextActiveDate = 'end';
        } else if (!priorRange) {
            result = [
                [
                    undefined,
                    selectedDate
                ]
            ];
            nextActiveDate = 'start';
        } else if (selectedDate.getTime() < priorRange[0][0].getTime()) {
            result = [
                [
                    selectedDate,
                    undefined
                ]
            ];
            nextActiveDate = 'end';
        } else if (selectedDate.getTime() > priorRange[0][0].getTime()) {
            result = [
                [
                    priorRange[0][0],
                    selectedDate
                ]
            ];
            nextActiveDate = 'start';
        }
        // If no dates selected, always return undefined; else format
        // result according to specified range value.
        if (result[0].includes(undefined)) {
            if (range === 'array') result = !result[0][0] && !result[0][1] ? undefined : result;
            else result = result[0].find(function(d) {
                return d !== undefined;
            });
        }
        setActiveDate(nextActiveDate);
        setValue(result);
        return [
            result,
            nextActiveDate
        ];
    }, [
        activeDate,
        value,
        range
    ]);
    var selectDate = (0, $fcf2886c26d1d13d$var$_react.useCallback)(function(selectedDate) {
        // If no onSelect prop is provided, the calendar should be read-only
        if (!onSelect) return;
        var nextValue;
        var nextActiveDate;
        var details = {};
        if (range || Array.isArray(value == null ? void 0 : value[0])) {
            var _handleRange = handleRange(selectedDate);
            nextValue = _handleRange[0];
            nextActiveDate = _handleRange[1];
            details.activeDate = nextActiveDate;
        } else nextValue = selectedDate;
        if (onSelect) {
            nextValue = $fcf2886c26d1d13d$var$_normalizeOutput(nextValue, outputFormat);
            onSelect(nextValue, details);
        }
    }, [
        handleRange,
        onSelect,
        outputFormat,
        range,
        value
    ]);
    var onClick = function onClick(selectedDate) {
        selectDate(selectedDate);
        announce("Selected " + $fcf2886c26d1d13d$var$getLocaleString(selectedDate, locale), 'assertive');
        setActive(selectedDate);
    };
    var renderCalendarHeader = function renderCalendarHeader() {
        var _theme$calendar$size;
        var PreviousIcon = size === 'small' ? theme.calendar.icons.small.previous : theme.calendar.icons.previous;
        var NextIcon = size === 'small' ? theme.calendar.icons.small.next : theme.calendar.icons.next;
        var monthAndYear = reference.toLocaleDateString(locale, {
            month: 'long',
            year: 'numeric'
        });
        // theme.calendar.heading.level should be removed in v3 of grommet
        // theme.calendar[size].title should be used instead
        var headingLevel;
        if (level !== undefined) headingLevel = level;
        else if (size === 'small') headingLevel = theme.calendar.heading && theme.calendar.heading.level || 4;
        else headingLevel = (theme.calendar.heading && theme.calendar.heading.level || 4) - 1;
        var _ref5 = ((_theme$calendar$size = theme.calendar[size]) == null ? void 0 : _theme$calendar$size.title) || undefined, containerTheme = _ref5.container, textTheme = $fcf2886c26d1d13d$var$_objectWithoutPropertiesLoose(_ref5, $fcf2886c26d1d13d$var$_excluded2);
        return /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            direction: "row",
            justify: "between",
            align: "center"
        }, /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($30d6151480c557a9$export$8b251419efc915eb, {
            flex: true,
            pad: containerTheme.pad
        }, Object.keys(textTheme).length !== 0 ? /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, textTheme, monthAndYear) : /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($2d67f2629ee502eb$export$a8a3e93435678ff9, {
            level: headingLevel,
            size: size,
            margin: "none",
            overflowWrap: "normal"
        }, monthAndYear)), /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            flex: false,
            direction: "row",
            align: "center"
        }, /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
            a11yTitle: format({
                id: 'calendar.previous',
                messages: messages,
                values: {
                    date: previousMonth.toLocaleDateString(locale, {
                        month: 'long',
                        year: 'numeric'
                    })
                }
            }),
            icon: /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement(PreviousIcon, {
                size: size !== 'small' ? size : undefined
            }),
            disabled: $fcf2886c26d1d13d$var$disabledCalendarPreviousMonthButton(previousMonth, reference, bounds),
            onClick: function onClick() {
                return changeCalendarMonth('calendar.previousMove', previousMonth);
            }
        }), /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
            a11yTitle: format({
                id: 'calendar.next',
                messages: messages,
                values: {
                    date: nextMonth.toLocaleDateString(locale, {
                        month: 'long',
                        year: 'numeric'
                    })
                }
            }),
            icon: /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement(NextIcon, {
                size: size !== 'small' ? size : undefined
            }),
            disabled: $fcf2886c26d1d13d$var$disabledCalendarNextMonthButton(nextMonth, reference, bounds),
            onClick: function onClick() {
                return changeCalendarMonth('calendar.nextMove', nextMonth);
            }
        })));
    };
    var renderDaysOfWeek = function renderDaysOfWeek() {
        var day = new Date(displayBounds[0]);
        var days = [];
        while(days.length < 7){
            days.push(/*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($c2bf620672af0d10$export$ffce625ce693a981, {
                role: "gridcell",
                key: days.length,
                sizeProp: size,
                fillContainer: fill,
                responsive: responsive
            }, /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($c2bf620672af0d10$export$4fe9184bd47dbe20, {
                sizeProp: size,
                fillContainer: fill,
                responsive: responsive
            }, day.toLocaleDateString(locale, {
                weekday: 'narrow'
            }))));
            day = (0, $6dca34d168a0b7e8$export$dd412b56f1e4d8aa)(day, 1);
        }
        return /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($c2bf620672af0d10$export$5db4823d38c0569f, {
            role: "row"
        }, days);
    };
    var weeks = [];
    var day = new Date(displayBounds[0]);
    var days;
    var firstDayInMonth;
    var blankWeek = false;
    var _loop = function _loop() {
        if (day.getDay() === firstDayOfWeek) {
            if (days) weeks.push(/*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($c2bf620672af0d10$export$5db4823d38c0569f, {
                role: "row",
                key: day.getTime(),
                fillContainer: fill
            }, days));
            days = [];
        }
        var otherMonth = day.getMonth() !== reference.getMonth();
        if (!showAdjacentDays && otherMonth) {
            days.push(/*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($c2bf620672af0d10$export$ffce625ce693a981, {
                key: day.getTime(),
                sizeProp: size,
                fillContainer: fill,
                responsive: responsive
            }, /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($c2bf620672af0d10$export$4fe9184bd47dbe20, {
                sizeProp: size,
                fillContainer: fill,
                responsive: responsive
            })));
            if (weeks.length === 5 && /* If the length days array is less than the current getDate()
      we know that all days in the array are from the next month. */ days.length < day.getDate()) blankWeek = true;
        } else if (/* Do not show adjacent days in 6th row if all days
    fall in the next month */ showAdjacentDays === 'trim' && otherMonth && weeks.length === 5 && /* If the length days array is less than the current getDate()
    we know that all days in the array are from the next month. */ days.length < day.getDate()) {
            blankWeek = true;
            days.push(/*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($c2bf620672af0d10$export$ffce625ce693a981, {
                key: day.getTime(),
                sizeProp: size,
                fillContainer: fill,
                responsive: responsive
            }, /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($c2bf620672af0d10$export$4fe9184bd47dbe20, {
                sizeProp: size,
                fillContainer: fill,
                responsive: responsive
            })));
        } else {
            var dateObject = day;
            // this.dayRefs[dateObject] = React.createRef();
            var selected = false;
            var inRange = false;
            var rangePosition;
            var _withinDates = (0, $6dca34d168a0b7e8$export$509e5b8f8eb27f5c)(day, range ? $fcf2886c26d1d13d$var$normalizeRange(value, activeDate) : value), selectedState = _withinDates[0];
            if (selectedState === 2) {
                selected = true;
                var _withinDates2 = (0, $6dca34d168a0b7e8$export$509e5b8f8eb27f5c)(day, range ? $fcf2886c26d1d13d$var$normalizeRange(value, activeDate) : value);
                rangePosition = _withinDates2[1];
            } else if (selectedState === 1) inRange = true;
            var dayDisabled = !!((0, $6dca34d168a0b7e8$export$509e5b8f8eb27f5c)(day, $fcf2886c26d1d13d$var$_normalizeInput(disabled))[0] || bounds && !(0, $6dca34d168a0b7e8$export$5e6ff6e7b7b4e53b)(day, $fcf2886c26d1d13d$var$_normalizeInput(bounds)));
            if (!firstDayInMonth && !dayDisabled && day.getMonth() === reference.getMonth()) firstDayInMonth = dateObject;
            if (!children) days.push(/*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($fcf2886c26d1d13d$var$CalendarDay, {
                activeProp: active,
                day: day,
                key: day.getTime(),
                disabledProp: dayDisabled,
                buttonProps: {
                    a11yTitle: day.toDateString(),
                    onClick: !dayDisabled && !!onSelect ? function() {
                        return onClick(dateObject);
                    } : function() {}
                },
                isInRange: inRange,
                isSelected: selected,
                otherMonth: day.getMonth() !== reference.getMonth(),
                rangePosition: rangePosition,
                size: size,
                fill: fill,
                ref: focusableDateRef,
                responsive: responsive
            }, day.getDate()));
            else days.push(/*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($fcf2886c26d1d13d$var$CalendarCustomDay, {
                key: day.getTime(),
                "aria-selected": selected,
                buttonProps: $fcf2886c26d1d13d$var$_extends({
                    a11yTitle: day.toDateString()
                }, onSelect ? {
                    active: active && active.getTime() === day.getTime(),
                    disabled: dayDisabled,
                    onClick: dayDisabled ? function() {} : function() {
                        return onClick(dateObject);
                    }
                } : {}),
                size: size,
                fill: fill,
                responsive: responsive
            }, children({
                date: day,
                day: day.getDate(),
                isInRange: inRange,
                isSelected: selected
            })));
        }
        day = (0, $6dca34d168a0b7e8$export$dd412b56f1e4d8aa)(day, 1);
    };
    while(day.getTime() < displayBounds[1].getTime())_loop();
    weeks.push(/*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($c2bf620672af0d10$export$5db4823d38c0569f, {
        role: !blankWeek ? 'row' : undefined,
        key: day.getTime(),
        fillContainer: fill
    }, days));
    // track if we need to focus when element becomes available
    var _useState10 = (0, $fcf2886c26d1d13d$var$_react.useState)(false), needsFocus = _useState10[0], setNeedsFocus = _useState10[1];
    // while the calendar contains focus, and is not animating, set
    // the focus to the active date
    // Focus management effect
    (0, $fcf2886c26d1d13d$var$_react.useEffect)(function() {
        if (!animating && active && focus) setNeedsFocus(true);
    }, [
        animating,
        active,
        focus
    ]);
    (0, $fcf2886c26d1d13d$var$_react.useEffect)(function() {
        if (needsFocus && focusableDateRef != null && focusableDateRef.current) {
            focusableDateRef.current.focus();
            setNeedsFocus(false); // Reset flag after focus
        }
    }, [
        active,
        reference,
        displayBounds,
        needsFocus,
        focusableDateRef
    ]);
    (0, $fcf2886c26d1d13d$var$_react.useEffect)(function() {
        if (bounds && active) {
            var normalizedBounds = $fcf2886c26d1d13d$var$_normalizeInput(bounds);
            if (!(0, $6dca34d168a0b7e8$export$5e6ff6e7b7b4e53b)(active, normalizedBounds)) {
                var diff1 = Math.abs(active.getTime() - normalizedBounds[0].getTime());
                var diff2 = Math.abs(active.getTime() - normalizedBounds[1].getTime());
                var closerDate = diff1 < diff2 ? 0 : 1;
                setActive(normalizedBounds[closerDate]);
            }
        }
    }, [
        active,
        bounds
    ]);
    return /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($c2bf620672af0d10$export$2185b0041ed383, $fcf2886c26d1d13d$var$_extends({
        ref: ref,
        sizeProp: size,
        fillContainer: fill,
        responsive: responsive
    }, passThemeFlag, rest), /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        fill: fill
    }, header ? header({
        date: reference,
        locale: locale,
        onPreviousMonth: function onPreviousMonth() {
            changeReference(previousMonth);
            setActive(previousMonth);
            announce(format({
                id: 'calendar.previous',
                messages: messages,
                values: {
                    date: previousMonth.toLocaleDateString(locale, {
                        month: 'long',
                        year: 'numeric'
                    })
                }
            }));
        },
        onNextMonth: function onNextMonth() {
            changeReference(nextMonth);
            setActive(nextMonth);
            announce(format({
                id: 'calendar.next',
                messages: messages,
                values: {
                    date: nextMonth.toLocaleDateString(locale, {
                        month: 'long',
                        year: 'numeric'
                    })
                }
            }));
        },
        previousInBound: (0, $6dca34d168a0b7e8$export$5e6ff6e7b7b4e53b)(previousMonth, bounds),
        nextInBound: (0, $6dca34d168a0b7e8$export$5e6ff6e7b7b4e53b)(nextMonth, bounds)
    }) : renderCalendarHeader(previousMonth, nextMonth), /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        fill: true,
        role: "grid"
    }, daysOfWeek && renderDaysOfWeek(), /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onUp: function onUp(event) {
            var nextActive = (0, $6dca34d168a0b7e8$export$dd412b56f1e4d8aa)(active, -7);
            event.preventDefault();
            event.stopPropagation(); // so the page doesn't scroll
            if (!!(0, $6dca34d168a0b7e8$export$5e6ff6e7b7b4e53b)(nextActive, $fcf2886c26d1d13d$var$_normalizeInput(bounds)) || !bounds) {
                setActive(nextActive);
                if (!(0, $6dca34d168a0b7e8$export$5e6ff6e7b7b4e53b)(nextActive, displayBounds) || !showAdjacentDays && !(0, $6dca34d168a0b7e8$export$5e6ff6e7b7b4e53b)(nextActive, $fcf2886c26d1d13d$var$monthBounds(reference))) changeReference(nextActive);
            }
        },
        onDown: function onDown(event) {
            var nextActive = (0, $6dca34d168a0b7e8$export$dd412b56f1e4d8aa)(active, 7);
            event.preventDefault();
            event.stopPropagation(); // so the page doesn't scroll
            if (!!(0, $6dca34d168a0b7e8$export$5e6ff6e7b7b4e53b)(nextActive, $fcf2886c26d1d13d$var$_normalizeInput(bounds)) || !bounds) {
                setActive(nextActive);
                if (!(0, $6dca34d168a0b7e8$export$5e6ff6e7b7b4e53b)(nextActive, displayBounds) || !showAdjacentDays && !(0, $6dca34d168a0b7e8$export$5e6ff6e7b7b4e53b)(nextActive, $fcf2886c26d1d13d$var$monthBounds(reference))) changeReference(nextActive);
            }
        },
        onLeft: function onLeft() {
            var nextActive = (0, $6dca34d168a0b7e8$export$dd412b56f1e4d8aa)(active, -1);
            if (!!(0, $6dca34d168a0b7e8$export$5e6ff6e7b7b4e53b)(nextActive, $fcf2886c26d1d13d$var$_normalizeInput(bounds)) || !bounds) {
                setActive(nextActive);
                if (!(0, $6dca34d168a0b7e8$export$5e6ff6e7b7b4e53b)(nextActive, displayBounds) || !showAdjacentDays && !(0, $6dca34d168a0b7e8$export$5e6ff6e7b7b4e53b)(nextActive, $fcf2886c26d1d13d$var$monthBounds(reference))) changeReference(nextActive);
            }
        },
        onRight: function onRight() {
            var nextActive = (0, $6dca34d168a0b7e8$export$dd412b56f1e4d8aa)(active, 1);
            if (!!(0, $6dca34d168a0b7e8$export$5e6ff6e7b7b4e53b)(nextActive, $fcf2886c26d1d13d$var$_normalizeInput(bounds)) || !bounds) {
                setActive(nextActive);
                if (!(0, $6dca34d168a0b7e8$export$5e6ff6e7b7b4e53b)(nextActive, displayBounds) || !showAdjacentDays && !(0, $6dca34d168a0b7e8$export$5e6ff6e7b7b4e53b)(nextActive, $fcf2886c26d1d13d$var$monthBounds(reference))) changeReference(nextActive);
            }
        }
    }, /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($c2bf620672af0d10$export$cc9ae1676f4ee80a, $fcf2886c26d1d13d$var$_extends({
        role: "rowgroup",
        "aria-label": reference.toLocaleDateString(locale, {
            month: 'long',
            year: 'numeric'
        }) + "; " + $fcf2886c26d1d13d$var$currentlySelectedString(value, locale),
        sizeProp: size,
        fillContainer: fill,
        responsive: responsive,
        onFocus: function onFocus() {
            setFocus(true);
        },
        onBlur: function onBlur() {
            setFocus(false);
        }
    }, passThemeFlag), /*#__PURE__*/ $fcf2886c26d1d13d$var$_react["default"].createElement($c2bf620672af0d10$export$3d055278a61c3939, $fcf2886c26d1d13d$var$_extends({
        slide: slide,
        sizeProp: size,
        fillContainer: fill
    }, passThemeFlag), weeks))))));
});
$fcf2886c26d1d13d$var$Calendar.displayName = 'Calendar';
$fcf2886c26d1d13d$var$Calendar.propTypes = $851c863e2b1f5fef$export$91040927b1d7b4d1;


$754c60248b2cdc9f$export$e1aef45b828286de = $fcf2886c26d1d13d$export$e1aef45b828286de;


Object.keys($754c60248b2cdc9f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $754c60248b2cdc9f$exports[key]) return;
    $3321243da0932e1e$exports[key] = $754c60248b2cdc9f$exports[key];
});
var $5b055e3351599a71$exports = {};

$parcel$export($5b055e3351599a71$exports, "__esModule", function () { return $5b055e3351599a71$export$1e511d4a378977f5; }, function (v) { return $5b055e3351599a71$export$1e511d4a378977f5 = v; });
$parcel$export($5b055e3351599a71$exports, "Card", function () { return $5b055e3351599a71$export$60332b2344f7fe41; }, function (v) { return $5b055e3351599a71$export$60332b2344f7fe41 = v; });
var $5b055e3351599a71$export$1e511d4a378977f5;
var $5b055e3351599a71$export$60332b2344f7fe41;
"use strict";
$5b055e3351599a71$export$1e511d4a378977f5 = true;
$5b055e3351599a71$export$60332b2344f7fe41 = void 0;
var $fc9e840d1826457d$export$1e511d4a378977f5;
var $fc9e840d1826457d$export$60332b2344f7fe41;
"use strict";
$fc9e840d1826457d$export$1e511d4a378977f5 = true;
$fc9e840d1826457d$export$60332b2344f7fe41 = void 0;

var $fc9e840d1826457d$var$_react = $fc9e840d1826457d$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $fc9e840d1826457d$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($fc9e840d1826457d$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $fc9e840d1826457d$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $fc9e840d1826457d$var$_extends() {
    return $fc9e840d1826457d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fc9e840d1826457d$var$_extends.apply(null, arguments);
}
var $fc9e840d1826457d$var$Card = $fc9e840d1826457d$export$60332b2344f7fe41 = /*#__PURE__*/ (0, $fc9e840d1826457d$var$_react.forwardRef)(function(_ref, ref) {
    var _theme$card$hover;
    var rest = $fc9e840d1826457d$var$_extends({}, ($fc9e840d1826457d$var$_objectDestructuringEmpty(_ref), _ref));
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ $fc9e840d1826457d$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $fc9e840d1826457d$var$_extends({
        overflow: "hidden",
        kind: $fc9e840d1826457d$var$_extends({
            hover: (_theme$card$hover = theme.card.hover) == null ? void 0 : _theme$card$hover.container
        }, theme.card.container),
        ref: ref
    }, theme.card.container, rest));
});
$fc9e840d1826457d$var$Card.displayName = 'Card';


$5b055e3351599a71$export$60332b2344f7fe41 = $fc9e840d1826457d$export$60332b2344f7fe41;


Object.keys($5b055e3351599a71$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $5b055e3351599a71$exports[key]) return;
    $3321243da0932e1e$exports[key] = $5b055e3351599a71$exports[key];
});
var $a78b478a7bdcd33d$exports = {};

$parcel$export($a78b478a7bdcd33d$exports, "__esModule", function () { return $a78b478a7bdcd33d$export$1e511d4a378977f5; }, function (v) { return $a78b478a7bdcd33d$export$1e511d4a378977f5 = v; });
$parcel$export($a78b478a7bdcd33d$exports, "CardBody", function () { return $a78b478a7bdcd33d$export$851de33184ecdac4; }, function (v) { return $a78b478a7bdcd33d$export$851de33184ecdac4 = v; });
var $a78b478a7bdcd33d$export$1e511d4a378977f5;
var $a78b478a7bdcd33d$export$851de33184ecdac4;
"use strict";
$a78b478a7bdcd33d$export$1e511d4a378977f5 = true;
$a78b478a7bdcd33d$export$851de33184ecdac4 = void 0;
var $b417372729720fe0$export$1e511d4a378977f5;
var $b417372729720fe0$export$851de33184ecdac4;
"use strict";
$b417372729720fe0$export$1e511d4a378977f5 = true;
$b417372729720fe0$export$851de33184ecdac4 = void 0;

var $b417372729720fe0$var$_react = $b417372729720fe0$var$_interopRequireDefault((parcelRequire("2xPiy")));


function $b417372729720fe0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $b417372729720fe0$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $b417372729720fe0$var$_extends() {
    return $b417372729720fe0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b417372729720fe0$var$_extends.apply(null, arguments);
}
var $b417372729720fe0$var$CardBody = $b417372729720fe0$export$851de33184ecdac4 = function CardBody(_ref) {
    var rest = $b417372729720fe0$var$_extends({}, ($b417372729720fe0$var$_objectDestructuringEmpty(_ref), _ref));
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ $b417372729720fe0$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $b417372729720fe0$var$_extends({
        flex: true
    }, theme.card.body, rest));
};


$a78b478a7bdcd33d$export$851de33184ecdac4 = $b417372729720fe0$export$851de33184ecdac4;


Object.keys($a78b478a7bdcd33d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $a78b478a7bdcd33d$exports[key]) return;
    $3321243da0932e1e$exports[key] = $a78b478a7bdcd33d$exports[key];
});
var $d3dcf1986033410c$exports = {};

$parcel$export($d3dcf1986033410c$exports, "__esModule", function () { return $d3dcf1986033410c$export$1e511d4a378977f5; }, function (v) { return $d3dcf1986033410c$export$1e511d4a378977f5 = v; });
$parcel$export($d3dcf1986033410c$exports, "CardFooter", function () { return $d3dcf1986033410c$export$e9897d434e0741ee; }, function (v) { return $d3dcf1986033410c$export$e9897d434e0741ee = v; });
var $d3dcf1986033410c$export$1e511d4a378977f5;
var $d3dcf1986033410c$export$e9897d434e0741ee;
"use strict";
$d3dcf1986033410c$export$1e511d4a378977f5 = true;
$d3dcf1986033410c$export$e9897d434e0741ee = void 0;
var $8958185e2698f017$export$1e511d4a378977f5;
var $8958185e2698f017$export$e9897d434e0741ee;
"use strict";
$8958185e2698f017$export$1e511d4a378977f5 = true;
$8958185e2698f017$export$e9897d434e0741ee = void 0;

var $8958185e2698f017$var$_react = $8958185e2698f017$var$_interopRequireDefault((parcelRequire("2xPiy")));
var $267fa7db763dabfc$exports = {};

$parcel$export($267fa7db763dabfc$exports, "__esModule", function () { return $267fa7db763dabfc$export$1e511d4a378977f5; }, function (v) { return $267fa7db763dabfc$export$1e511d4a378977f5 = v; });
$parcel$export($267fa7db763dabfc$exports, "Footer", function () { return $267fa7db763dabfc$export$a06f1c675e846f6f; }, function (v) { return $267fa7db763dabfc$export$a06f1c675e846f6f = v; });
var $267fa7db763dabfc$export$1e511d4a378977f5;
var $267fa7db763dabfc$export$a06f1c675e846f6f;
"use strict";
$267fa7db763dabfc$export$1e511d4a378977f5 = true;
$267fa7db763dabfc$export$a06f1c675e846f6f = void 0;
var $8254917b3ffe8187$export$1e511d4a378977f5;
var $8254917b3ffe8187$export$a06f1c675e846f6f;
"use strict";
$8254917b3ffe8187$export$1e511d4a378977f5 = true;
$8254917b3ffe8187$export$a06f1c675e846f6f = void 0;

var $8254917b3ffe8187$var$_react = $8254917b3ffe8187$var$_interopRequireDefault((parcelRequire("2xPiy")));


function $8254917b3ffe8187$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $8254917b3ffe8187$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $8254917b3ffe8187$var$_extends() {
    return $8254917b3ffe8187$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8254917b3ffe8187$var$_extends.apply(null, arguments);
}
var $8254917b3ffe8187$var$Footer = $8254917b3ffe8187$export$a06f1c675e846f6f = function Footer(_ref) {
    var _theme$footer;
    var rest = $8254917b3ffe8187$var$_extends({}, ($8254917b3ffe8187$var$_objectDestructuringEmpty(_ref), _ref));
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ $8254917b3ffe8187$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $8254917b3ffe8187$var$_extends({
        as: "footer",
        align: "center",
        direction: "row",
        flex: false,
        gap: (_theme$footer = theme.footer) == null ? void 0 : _theme$footer.gap,
        justify: "between"
    }, rest));
};


$267fa7db763dabfc$export$a06f1c675e846f6f = $8254917b3ffe8187$export$a06f1c675e846f6f;



function $8958185e2698f017$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $8958185e2698f017$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $8958185e2698f017$var$_extends() {
    return $8958185e2698f017$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8958185e2698f017$var$_extends.apply(null, arguments);
}
// Needs to have a CardBody or a flex container when Card uses a fixed height.
var $8958185e2698f017$var$CardFooter = $8958185e2698f017$export$e9897d434e0741ee = function CardFooter(_ref) {
    var rest = $8958185e2698f017$var$_extends({}, ($8958185e2698f017$var$_objectDestructuringEmpty(_ref), _ref));
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ $8958185e2698f017$var$_react["default"].createElement($267fa7db763dabfc$export$a06f1c675e846f6f, $8958185e2698f017$var$_extends({}, theme.card.footer, rest));
};


$d3dcf1986033410c$export$e9897d434e0741ee = $8958185e2698f017$export$e9897d434e0741ee;


Object.keys($d3dcf1986033410c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $d3dcf1986033410c$exports[key]) return;
    $3321243da0932e1e$exports[key] = $d3dcf1986033410c$exports[key];
});
var $43086b5678cb1ee1$exports = {};

$parcel$export($43086b5678cb1ee1$exports, "__esModule", function () { return $43086b5678cb1ee1$export$1e511d4a378977f5; }, function (v) { return $43086b5678cb1ee1$export$1e511d4a378977f5 = v; });
$parcel$export($43086b5678cb1ee1$exports, "CardHeader", function () { return $43086b5678cb1ee1$export$5665775b26e26c5d; }, function (v) { return $43086b5678cb1ee1$export$5665775b26e26c5d = v; });
var $43086b5678cb1ee1$export$1e511d4a378977f5;
var $43086b5678cb1ee1$export$5665775b26e26c5d;
"use strict";
$43086b5678cb1ee1$export$1e511d4a378977f5 = true;
$43086b5678cb1ee1$export$5665775b26e26c5d = void 0;
var $08f6e3155436f4c0$export$1e511d4a378977f5;
var $08f6e3155436f4c0$export$5665775b26e26c5d;
"use strict";
$08f6e3155436f4c0$export$1e511d4a378977f5 = true;
$08f6e3155436f4c0$export$5665775b26e26c5d = void 0;

var $08f6e3155436f4c0$var$_react = $08f6e3155436f4c0$var$_interopRequireDefault((parcelRequire("2xPiy")));


function $08f6e3155436f4c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $08f6e3155436f4c0$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $08f6e3155436f4c0$var$_extends() {
    return $08f6e3155436f4c0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $08f6e3155436f4c0$var$_extends.apply(null, arguments);
}
var $08f6e3155436f4c0$var$CardHeader = $08f6e3155436f4c0$export$5665775b26e26c5d = function CardHeader(_ref) {
    var rest = $08f6e3155436f4c0$var$_extends({}, ($08f6e3155436f4c0$var$_objectDestructuringEmpty(_ref), _ref));
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ $08f6e3155436f4c0$var$_react["default"].createElement($30d6151480c557a9$export$8b251419efc915eb, $08f6e3155436f4c0$var$_extends({}, theme.card.header, rest));
};


$43086b5678cb1ee1$export$5665775b26e26c5d = $08f6e3155436f4c0$export$5665775b26e26c5d;


Object.keys($43086b5678cb1ee1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $43086b5678cb1ee1$exports[key]) return;
    $3321243da0932e1e$exports[key] = $43086b5678cb1ee1$exports[key];
});
var $d0861f5d89d312dc$exports = {};

$parcel$export($d0861f5d89d312dc$exports, "__esModule", function () { return $d0861f5d89d312dc$export$1e511d4a378977f5; }, function (v) { return $d0861f5d89d312dc$export$1e511d4a378977f5 = v; });
$parcel$export($d0861f5d89d312dc$exports, "Cards", function () { return $d0861f5d89d312dc$export$c8d38e0dcc0f5a1; }, function (v) { return $d0861f5d89d312dc$export$c8d38e0dcc0f5a1 = v; });
var $d0861f5d89d312dc$export$1e511d4a378977f5;
var $d0861f5d89d312dc$export$c8d38e0dcc0f5a1;
"use strict";
$d0861f5d89d312dc$export$1e511d4a378977f5 = true;
$d0861f5d89d312dc$export$c8d38e0dcc0f5a1 = void 0;
var $da9cbcb70d6a9c25$export$1e511d4a378977f5;
var $da9cbcb70d6a9c25$export$c8d38e0dcc0f5a1;
"use strict";
$da9cbcb70d6a9c25$export$1e511d4a378977f5 = true;
$da9cbcb70d6a9c25$export$c8d38e0dcc0f5a1 = void 0;

var $da9cbcb70d6a9c25$var$_react = $da9cbcb70d6a9c25$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $da9cbcb70d6a9c25$var$_styledComponents = $da9cbcb70d6a9c25$var$_interopRequireDefault((parcelRequire("iA1nz")));






var $f75e849c2101cc4f$exports = {};

$parcel$export($f75e849c2101cc4f$exports, "__esModule", function () { return $f75e849c2101cc4f$export$1e511d4a378977f5; }, function (v) { return $f75e849c2101cc4f$export$1e511d4a378977f5 = v; });
$parcel$export($f75e849c2101cc4f$exports, "Grid", function () { return $f75e849c2101cc4f$export$ef2184bd89960b14; }, function (v) { return $f75e849c2101cc4f$export$ef2184bd89960b14 = v; });
var $f75e849c2101cc4f$export$1e511d4a378977f5;
var $f75e849c2101cc4f$export$ef2184bd89960b14;
"use strict";
$f75e849c2101cc4f$export$1e511d4a378977f5 = true;
$f75e849c2101cc4f$export$ef2184bd89960b14 = void 0;
var $a73e015701900499$export$1e511d4a378977f5;
var $a73e015701900499$export$ef2184bd89960b14;
"use strict";
$a73e015701900499$export$1e511d4a378977f5 = true;
$a73e015701900499$export$ef2184bd89960b14 = void 0;

var $a73e015701900499$var$_react = $a73e015701900499$var$_interopRequireWildcard((parcelRequire("2xPiy")));
var $91a567fa8a853110$export$1e511d4a378977f5;
var $91a567fa8a853110$export$ba6ff269176936c2;
"use strict";
$91a567fa8a853110$export$1e511d4a378977f5 = true;
$91a567fa8a853110$export$ba6ff269176936c2 = void 0;

var $91a567fa8a853110$var$_styledComponents = $91a567fa8a853110$var$_interopRequireWildcard((parcelRequire("iA1nz")));

function $91a567fa8a853110$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($91a567fa8a853110$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $91a567fa8a853110$var$fillStyle = function fillStyle(fill) {
    if (!fill) return fill;
    if (fill === 'horizontal') return 'width: 100%;';
    if (fill === 'vertical') return 'height: 100%;';
    return "\n      width: 100%;\n      height: 100%;\n    ";
};
var $91a567fa8a853110$var$JUSTIFY_MAP = {
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch'
};
var $91a567fa8a853110$var$justifyStyle = (0, $91a567fa8a853110$var$_styledComponents.css)([
    "justify-items:",
    ";"
], function(props) {
    return $91a567fa8a853110$var$JUSTIFY_MAP[props.justify];
});
var $91a567fa8a853110$var$JUSTIFY_CONTENT_MAP = {
    around: 'space-around',
    between: 'space-between',
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch'
};
var $91a567fa8a853110$var$justifyContentStyle = (0, $91a567fa8a853110$var$_styledComponents.css)([
    "justify-content:",
    ";"
], function(props) {
    return $91a567fa8a853110$var$JUSTIFY_CONTENT_MAP[props.justifyContent];
});
var $91a567fa8a853110$var$gapSizes = function gapSizes(props) {
    var result = [];
    if (typeof props.gap === 'string') {
        var size = props.theme.global.edgeSize[props.gap] || props.gap;
        result[0] = size;
        result[1] = size;
    } else if (props.gap) {
        if (props.gap.row) result[0] = props.theme.global.edgeSize[props.gap.row] || props.gap.row;
        if (props.gap.column) result[1] = props.theme.global.edgeSize[props.gap.column] || props.gap.column;
    }
    return result;
};
var $91a567fa8a853110$var$gapStyle = function gapStyle(props) {
    var sizes = $91a567fa8a853110$var$gapSizes(props);
    if (sizes[0] !== undefined && sizes[1] !== undefined) return "grid-gap: " + sizes[0] + " " + sizes[1] + ";";
    if (sizes[0] !== undefined) return "grid-row-gap: " + sizes[0] + ";";
    if (sizes[1] !== undefined) return "grid-column-gap: " + sizes[1] + ";";
    return '';
};
var $91a567fa8a853110$var$SIZE_MAP = {
    flex: '1fr',
    full: '100%',
    '1/2': '50%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    '1/3': '33.33%',
    '2/3': '66.66%'
};
var $91a567fa8a853110$var$normalizeSize = function normalizeSize(size, props) {
    return $91a567fa8a853110$var$SIZE_MAP[size] || props.theme.global.size[size] || size;
};
var $91a567fa8a853110$var$getRepeatCount = function getRepeatCount(count) {
    return typeof count === 'number' ? count : "auto-" + (count || 'fit');
};
var $91a567fa8a853110$var$getRepeatSize = function getRepeatSize(size, props) {
    if (size === 'flex') return '1fr';
    var gaps = $91a567fa8a853110$var$gapSizes(props);
    var min;
    var max;
    var minFill;
    if (Array.isArray(size)) {
        var _size$ = size[0], minSize = _size$ === void 0 ? 'auto' : _size$, _size$2 = size[1], maxSize = _size$2 === void 0 ? 'auto' : _size$2;
        min = $91a567fa8a853110$var$normalizeSize(minSize, props);
        if (min.search(/px/) !== -1) minFill = true;
        max = $91a567fa8a853110$var$normalizeSize(maxSize, props);
        if (gaps[1] !== undefined) {
            // account for the column gap when using fractional sizes, e.g. 1/3
            if (minSize.indexOf('/') !== -1) min = "calc(" + min + " - (" + gaps[1] + " * (1 - " + minSize + ")))";
            if (maxSize.indexOf('/') !== -1) max = "calc(" + max + " - (" + gaps[1] + " * (1 - " + maxSize + ")))";
        }
    } else {
        min = $91a567fa8a853110$var$normalizeSize(size, props);
        if (min.search(/px/) !== -1) minFill = true;
        max = '1fr';
        if (gaps[1] !== undefined) // account for column gap with fractional sizes, e.g. 1/3
        {
            if (size.indexOf('/') !== -1) min = "calc(" + min + " - (" + gaps[1] + " * (1 - " + size + ")))";
        }
    }
    if (minFill) // ensure we never go beyond the container width,
    // for mobile/narrow situations
    min = "min(" + min + ", 100%)";
    return "minmax(" + min + ", " + max + ")";
};
var $91a567fa8a853110$var$columnsStyle = function columnsStyle(props) {
    if (Array.isArray(props.columns)) return (0, $91a567fa8a853110$var$_styledComponents.css)([
        "grid-template-columns:",
        ";"
    ], props.columns.map(function(s) {
        if (Array.isArray(s)) return "minmax(" + $91a567fa8a853110$var$normalizeSize(s[0], props) + ", " + $91a567fa8a853110$var$normalizeSize(s[1], props) + ")";
        return $91a567fa8a853110$var$normalizeSize(s, props);
    }).join(' '));
    if (typeof props.columns === 'object') return (0, $91a567fa8a853110$var$_styledComponents.css)([
        "grid-template-columns:repeat( ",
        ",",
        " );"
    ], $91a567fa8a853110$var$getRepeatCount(props.columns.count), $91a567fa8a853110$var$getRepeatSize(props.columns.size, props));
    return (0, $91a567fa8a853110$var$_styledComponents.css)([
        "grid-template-columns:repeat( auto-fill,",
        " );"
    ], $91a567fa8a853110$var$getRepeatSize(props.columns, props));
};
var $91a567fa8a853110$var$rowsStyle = function rowsStyle(props) {
    if (Array.isArray(props.rowsProp)) return (0, $91a567fa8a853110$var$_styledComponents.css)([
        "grid-template-rows:",
        ";"
    ], props.rowsProp.map(function(s) {
        if (Array.isArray(s)) return "minmax(" + $91a567fa8a853110$var$normalizeSize(s[0], props) + ", " + $91a567fa8a853110$var$normalizeSize(s[1], props) + ")";
        return $91a567fa8a853110$var$normalizeSize(s, props);
    }).join(' '));
    return (0, $91a567fa8a853110$var$_styledComponents.css)([
        "grid-auto-rows:",
        ";"
    ], props.theme.global.size[props.rowsProp]);
};
var $91a567fa8a853110$var$areasStyle = function areasStyle(props) {
    // translate areas objects into grid-template-areas syntax
    if (!Array.isArray(props.rowsProp) || !Array.isArray(props.columns)) console.warn('Grid `areas` requires `rows` and `columns` to be arrays.');
    if (Array.isArray(props.areas) && props.areas.every(function(area) {
        return Array.isArray(area);
    })) return "grid-template-areas: " + props.areas.map(function(area) {
        return "\"" + area.join(' ') + "\"";
    }).join(' ') + ";";
    var cells = props.rowsProp.map(function() {
        return props.columns.map(function() {
            return '.';
        });
    });
    props.areas.forEach(function(area) {
        for(var row = area.start[1]; row <= area.end[1]; row += 1)for(var column = area.start[0]; column <= area.end[0]; column += 1)cells[row][column] = area.name;
    });
    return "grid-template-areas: " + cells.map(function(r) {
        return "\"" + r.join(' ') + "\"";
    }).join(' ') + ";";
};
var $91a567fa8a853110$var$StyledGrid = $91a567fa8a853110$export$ba6ff269176936c2 = $91a567fa8a853110$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledGrid",
    componentId: "sc-1wofa1l-0"
})([
    "display:grid;box-sizing:border-box;",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], $4113023f9e0bafa0$exports.genericStyles, function(props) {
    return props.border && (0, $4113023f9e0bafa0$exports.borderStyle)(props.border, props.responsive, props.theme);
}, function(props) {
    return $91a567fa8a853110$var$fillStyle(props.fillContainer);
}, function(props) {
    return props.align && $4113023f9e0bafa0$exports.alignStyle;
}, function(props) {
    return props.alignContent && $4113023f9e0bafa0$exports.alignContentStyle;
}, function(props) {
    return props.areas && $91a567fa8a853110$var$areasStyle(props);
}, function(props) {
    return props.columns && $91a567fa8a853110$var$columnsStyle(props);
}, function(props) {
    return props.gap && $91a567fa8a853110$var$gapStyle(props);
}, function(props) {
    return props.justify && $91a567fa8a853110$var$justifyStyle;
}, function(props) {
    return props.justifyContent && $91a567fa8a853110$var$justifyContentStyle;
}, function(props) {
    return props.pad && (0, $4113023f9e0bafa0$exports.edgeStyle)('padding', props.pad, props.responsive, props.theme.global.edgeSize.responsiveBreakpoint, props.theme);
}, function(props) {
    return props.rowsProp && $91a567fa8a853110$var$rowsStyle(props);
}, function(props) {
    return props.heightProp && (0, $4113023f9e0bafa0$exports.heightStyle)(props.heightProp, props.theme);
}, function(props) {
    return props.widthProp && (0, $4113023f9e0bafa0$exports.widthStyle)(props.widthProp, props.theme);
}, function(props) {
    return props.theme.grid && props.theme.grid.extend;
});


var $81262464ad843e70$export$1e511d4a378977f5;
var $81262464ad843e70$export$c3a9d48c57d48e6e;
"use strict";
$81262464ad843e70$export$1e511d4a378977f5 = true;
$81262464ad843e70$export$c3a9d48c57d48e6e = void 0;

var $81262464ad843e70$var$_propTypes = $81262464ad843e70$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $81262464ad843e70$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $81262464ad843e70$var$_extends() {
    return $81262464ad843e70$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $81262464ad843e70$var$_extends.apply(null, arguments);
}
var $81262464ad843e70$var$fixedSizes = [
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge'
];
var $81262464ad843e70$var$sizes = [
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge',
    'full',
    '1/2',
    '1/3',
    '2/3',
    '1/4',
    '2/4',
    '3/4',
    'flex',
    'auto'
];
var $81262464ad843e70$var$edgeSizes = [
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge',
    'none'
];
var $81262464ad843e70$var$BORDER_SHAPE = $81262464ad843e70$var$_propTypes["default"].shape({
    color: $81262464ad843e70$var$_propTypes["default"].oneOfType([
        $81262464ad843e70$var$_propTypes["default"].string,
        $81262464ad843e70$var$_propTypes["default"].shape({
            dark: $81262464ad843e70$var$_propTypes["default"].string,
            light: $81262464ad843e70$var$_propTypes["default"].string
        })
    ]),
    side: $81262464ad843e70$var$_propTypes["default"].oneOf([
        'top',
        'left',
        'bottom',
        'right',
        'start',
        'end',
        'horizontal',
        'vertical',
        'all',
        'between'
    ]),
    size: $81262464ad843e70$var$_propTypes["default"].oneOfType([
        $81262464ad843e70$var$_propTypes["default"].oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        $81262464ad843e70$var$_propTypes["default"].string
    ]),
    style: $81262464ad843e70$var$_propTypes["default"].oneOf([
        'solid',
        'dashed',
        'dotted',
        'double',
        'groove',
        'ridge',
        'inset',
        'outset',
        'hidden'
    ])
});
var $81262464ad843e70$var$PropType = {};
$81262464ad843e70$var$PropType = $81262464ad843e70$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    align: $5897bd367fbd90c1$export$5dd51d61a30477bc,
    alignContent: $81262464ad843e70$var$_propTypes["default"].oneOfType([
        $81262464ad843e70$var$_propTypes["default"].oneOf([
            'around',
            'baseline',
            'between',
            'center',
            'evenly',
            'end',
            'start',
            'stretch'
        ]),
        $81262464ad843e70$var$_propTypes["default"].string
    ]),
    areas: $81262464ad843e70$var$_propTypes["default"].oneOfType([
        $81262464ad843e70$var$_propTypes["default"].arrayOf($81262464ad843e70$var$_propTypes["default"].shape({
            name: $81262464ad843e70$var$_propTypes["default"].string,
            start: $81262464ad843e70$var$_propTypes["default"].arrayOf($81262464ad843e70$var$_propTypes["default"].number),
            end: $81262464ad843e70$var$_propTypes["default"].arrayOf($81262464ad843e70$var$_propTypes["default"].number)
        })),
        $81262464ad843e70$var$_propTypes["default"].arrayOf($81262464ad843e70$var$_propTypes["default"].arrayOf($81262464ad843e70$var$_propTypes["default"].string))
    ]),
    border: $81262464ad843e70$var$_propTypes["default"].oneOfType([
        $81262464ad843e70$var$_propTypes["default"].bool,
        $81262464ad843e70$var$_propTypes["default"].oneOf([
            'top',
            'left',
            'bottom',
            'right',
            'start',
            'end',
            'horizontal',
            'vertical',
            'all'
        ]),
        $81262464ad843e70$var$BORDER_SHAPE,
        $81262464ad843e70$var$_propTypes["default"].arrayOf($81262464ad843e70$var$BORDER_SHAPE)
    ]),
    columns: $81262464ad843e70$var$_propTypes["default"].oneOfType([
        $81262464ad843e70$var$_propTypes["default"].arrayOf($81262464ad843e70$var$_propTypes["default"].oneOfType([
            $81262464ad843e70$var$_propTypes["default"].arrayOf($81262464ad843e70$var$_propTypes["default"].oneOfType([
                $81262464ad843e70$var$_propTypes["default"].oneOf($81262464ad843e70$var$sizes),
                $81262464ad843e70$var$_propTypes["default"].string
            ])),
            $81262464ad843e70$var$_propTypes["default"].oneOf($81262464ad843e70$var$sizes),
            $81262464ad843e70$var$_propTypes["default"].string
        ])),
        $81262464ad843e70$var$_propTypes["default"].oneOf($81262464ad843e70$var$sizes),
        $81262464ad843e70$var$_propTypes["default"].shape({
            count: $81262464ad843e70$var$_propTypes["default"].oneOfType([
                $81262464ad843e70$var$_propTypes["default"].oneOf([
                    'fit',
                    'fill'
                ]),
                $81262464ad843e70$var$_propTypes["default"].number
            ]),
            size: $81262464ad843e70$var$_propTypes["default"].oneOfType([
                $81262464ad843e70$var$_propTypes["default"].oneOf($81262464ad843e70$var$sizes),
                $81262464ad843e70$var$_propTypes["default"].arrayOf($81262464ad843e70$var$_propTypes["default"].oneOfType([
                    $81262464ad843e70$var$_propTypes["default"].oneOf($81262464ad843e70$var$sizes),
                    $81262464ad843e70$var$_propTypes["default"].string
                ])),
                $81262464ad843e70$var$_propTypes["default"].string
            ])
        }),
        $81262464ad843e70$var$_propTypes["default"].string
    ]),
    fill: $81262464ad843e70$var$_propTypes["default"].oneOfType([
        $81262464ad843e70$var$_propTypes["default"].oneOf([
            'horizontal',
            'vertical'
        ]),
        $81262464ad843e70$var$_propTypes["default"].bool
    ]),
    gap: $81262464ad843e70$var$_propTypes["default"].oneOfType([
        $81262464ad843e70$var$_propTypes["default"].oneOf($81262464ad843e70$var$edgeSizes),
        $81262464ad843e70$var$_propTypes["default"].shape({
            row: $81262464ad843e70$var$_propTypes["default"].oneOfType([
                $81262464ad843e70$var$_propTypes["default"].oneOf($81262464ad843e70$var$edgeSizes),
                $81262464ad843e70$var$_propTypes["default"].string
            ]),
            column: $81262464ad843e70$var$_propTypes["default"].oneOfType([
                $81262464ad843e70$var$_propTypes["default"].oneOf($81262464ad843e70$var$edgeSizes),
                $81262464ad843e70$var$_propTypes["default"].string
            ])
        }),
        $81262464ad843e70$var$_propTypes["default"].string
    ]),
    height: $5897bd367fbd90c1$export$674efdc47ecf99e9,
    justify: $81262464ad843e70$var$_propTypes["default"].oneOf([
        'start',
        'center',
        'end',
        'stretch'
    ]),
    justifyContent: $81262464ad843e70$var$_propTypes["default"].oneOf([
        'start',
        'center',
        'end',
        'between',
        'around',
        'stretch'
    ]),
    pad: $5897bd367fbd90c1$export$b91a2ef62736aae3,
    responsive: $81262464ad843e70$var$_propTypes["default"].bool,
    rows: $81262464ad843e70$var$_propTypes["default"].oneOfType([
        $81262464ad843e70$var$_propTypes["default"].arrayOf($81262464ad843e70$var$_propTypes["default"].oneOfType([
            $81262464ad843e70$var$_propTypes["default"].arrayOf($81262464ad843e70$var$_propTypes["default"].oneOfType([
                $81262464ad843e70$var$_propTypes["default"].oneOf($81262464ad843e70$var$sizes),
                $81262464ad843e70$var$_propTypes["default"].string
            ])),
            $81262464ad843e70$var$_propTypes["default"].oneOf($81262464ad843e70$var$sizes),
            $81262464ad843e70$var$_propTypes["default"].string
        ])),
        $81262464ad843e70$var$_propTypes["default"].oneOf($81262464ad843e70$var$fixedSizes),
        $81262464ad843e70$var$_propTypes["default"].string
    ]),
    tag: $81262464ad843e70$var$_propTypes["default"].oneOfType([
        $81262464ad843e70$var$_propTypes["default"].string,
        $81262464ad843e70$var$_propTypes["default"].func
    ]),
    as: $81262464ad843e70$var$_propTypes["default"].oneOfType([
        $81262464ad843e70$var$_propTypes["default"].string,
        $81262464ad843e70$var$_propTypes["default"].func
    ]),
    width: $5897bd367fbd90c1$export$7d45d0e6b7abd5e2
});
var $81262464ad843e70$var$GridPropTypes = $81262464ad843e70$export$c3a9d48c57d48e6e = $81262464ad843e70$var$PropType;




var $a73e015701900499$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "border",
    "fill",
    "height",
    "responsive",
    "rows",
    "tag",
    "as",
    "width"
];
function $a73e015701900499$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($a73e015701900499$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $a73e015701900499$var$_extends() {
    return $a73e015701900499$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a73e015701900499$var$_extends.apply(null, arguments);
}
function $a73e015701900499$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $a73e015701900499$var$Grid = $a73e015701900499$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $a73e015701900499$var$_react.forwardRef)(function(props, ref) {
    var a11yTitle = props.a11yTitle, ariaLabel = props['aria-label'], border = props.border, fill = props.fill, height = props.height, _props$responsive = props.responsive, responsiveProp = _props$responsive === void 0 ? true : _props$responsive, rows = props.rows, tag = props.tag, as = props.as, width = props.width, rest = $a73e015701900499$var$_objectWithoutPropertiesLoose(props, $a73e015701900499$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var responsiveContainer = (0, $a73e015701900499$var$_react.useContext)($58f4f715ab4fa2c4$exports.ResponsiveContainerContext);
    var responsive = responsiveContainer && responsiveProp ? 'container' : responsiveProp;
    return /*#__PURE__*/ $a73e015701900499$var$_react["default"].createElement($91a567fa8a853110$export$ba6ff269176936c2, $a73e015701900499$var$_extends({
        ref: ref,
        "aria-label": ariaLabel || a11yTitle,
        as: !as && tag ? tag : as,
        border: border,
        fillContainer: fill,
        heightProp: height,
        responsive: responsive,
        rowsProp: rows,
        widthProp: width
    }, passThemeFlag, rest));
});
$a73e015701900499$var$Grid.displayName = 'Grid';
$a73e015701900499$var$Grid.propTypes = $81262464ad843e70$export$c3a9d48c57d48e6e;
// Defualting to true to support existing code that relies on
// grid.available to create a fallback option
$a73e015701900499$var$Grid.available = true;


$f75e849c2101cc4f$export$ef2184bd89960b14 = $a73e015701900499$export$ef2184bd89960b14;


var $41010700ddcbac64$exports = {};

$parcel$export($41010700ddcbac64$exports, "__esModule", function () { return $41010700ddcbac64$export$1e511d4a378977f5; }, function (v) { return $41010700ddcbac64$export$1e511d4a378977f5 = v; });
$parcel$export($41010700ddcbac64$exports, "InfiniteScroll", function () { return $41010700ddcbac64$export$c5295390d6167a3e; }, function (v) { return $41010700ddcbac64$export$c5295390d6167a3e = v; });
var $41010700ddcbac64$export$1e511d4a378977f5;
var $41010700ddcbac64$export$c5295390d6167a3e;
"use strict";
$41010700ddcbac64$export$1e511d4a378977f5 = true;
$41010700ddcbac64$export$c5295390d6167a3e = void 0;
var $b19f89b4068f9aff$export$1e511d4a378977f5;
var $b19f89b4068f9aff$export$c5295390d6167a3e;
"use strict";
$b19f89b4068f9aff$export$1e511d4a378977f5 = true;
$b19f89b4068f9aff$export$c5295390d6167a3e = void 0;

var $b19f89b4068f9aff$var$_react = $b19f89b4068f9aff$var$_interopRequireWildcard((parcelRequire("2xPiy")));



var $b401dc823cf33fc0$export$1e511d4a378977f5;
var $b401dc823cf33fc0$export$2cd935ea72beacbd;
"use strict";
$b401dc823cf33fc0$export$1e511d4a378977f5 = true;
$b401dc823cf33fc0$export$2cd935ea72beacbd = void 0;

var $b401dc823cf33fc0$var$_propTypes = $b401dc823cf33fc0$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $b401dc823cf33fc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $b401dc823cf33fc0$var$PropType = {};
$b401dc823cf33fc0$var$PropType = {
    children: $b401dc823cf33fc0$var$_propTypes["default"].func,
    items: $b401dc823cf33fc0$var$_propTypes["default"].arrayOf($b401dc823cf33fc0$var$_propTypes["default"].any),
    onMore: $b401dc823cf33fc0$var$_propTypes["default"].func,
    renderMarker: $b401dc823cf33fc0$var$_propTypes["default"].func,
    replace: $b401dc823cf33fc0$var$_propTypes["default"].bool,
    show: $b401dc823cf33fc0$var$_propTypes["default"].number,
    step: $b401dc823cf33fc0$var$_propTypes["default"].number
};
var $b401dc823cf33fc0$var$InfiniteScrollPropTypes = $b401dc823cf33fc0$export$2cd935ea72beacbd = $b401dc823cf33fc0$var$PropType;


function $b19f89b4068f9aff$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($b19f89b4068f9aff$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $b19f89b4068f9aff$var$_readOnlyError(r) {
    throw new TypeError('"' + r + '" is read-only');
}
var $b19f89b4068f9aff$var$calculateLastPageBound = function calculateLastPageBound(show, step) {
    return show ? Math.floor((show + step) / step) - 1 : 0;
};
var $b19f89b4068f9aff$var$InfiniteScroll = $b19f89b4068f9aff$export$c5295390d6167a3e = function InfiniteScroll(_ref) {
    var children = _ref.children, _ref$items = _ref.items, items = _ref$items === void 0 ? [] : _ref$items, onMore = _ref.onMore, renderMarker = _ref.renderMarker, replace = _ref.replace, show = _ref.show, _ref$step = _ref.step, step = _ref$step === void 0 ? 50 : _ref$step;
    // item index to be made visible initially
    var _useState = (0, $b19f89b4068f9aff$var$_react.useState)(), scrollShow = _useState[0], setScrollShow = _useState[1];
    // the last page we have items for
    var lastPage = (0, $b19f89b4068f9aff$var$_react.useMemo)(function() {
        return Math.max(0, Math.ceil(items.length / step) - 1);
    }, [
        items.length,
        step
    ]);
    // the pages we are rendering
    var _useState2 = (0, $b19f89b4068f9aff$var$_react.useState)([
        0,
        $b19f89b4068f9aff$var$calculateLastPageBound(show, step)
    ]), renderPageBounds = _useState2[0], setRenderPageBounds = _useState2[1];
    // the heights of the pages, approximated after we render the first page
    // and then updated for pages that have rendered
    var _useState3 = (0, $b19f89b4068f9aff$var$_react.useState)([]), pageHeights = _useState3[0], setPageHeights = _useState3[1];
    // what we're waiting for onMore to give us
    var _useState4 = (0, $b19f89b4068f9aff$var$_react.useState)(0), pendingLength = _useState4[0], setPendingLength = _useState4[1];
    var aboveMarkerRef = (0, $b19f89b4068f9aff$var$_react.useRef)(); // only when replacing
    var belowMarkerRef = (0, $b19f89b4068f9aff$var$_react.useRef)();
    // scroll and resize handling
    (0, $b19f89b4068f9aff$var$_react.useEffect)(function() {
        var scrollParents;
        var evaluate = function evaluate() {
            if (!scrollParents) return;
            var scrollParent = scrollParents[0];
            // Determine the scroll position of the scroll container
            var top;
            var height;
            if (scrollParent === document) {
                top = document.documentElement.scrollTop || document.body.scrollTop;
                height = window.innerHeight;
            } else {
                top = scrollParent.scrollTop;
                var rect = scrollParent.getBoundingClientRect();
                height = rect.height;
            }
            var offset = height / 4; // so we pre-load when the user scrolls slowly
            // Use the pageHeights to determine what pages we should render based
            // on the current scroll window.
            var nextBeginPage = 0;
            var index = 0;
            var pagesHeight = pageHeights[index] || 0;
            while(pageHeights[index + 1] && pagesHeight < top - offset){
                index += 1;
                nextBeginPage += 1;
                pagesHeight += pageHeights[index];
            }
            var nextEndPage = nextBeginPage;
            while(pageHeights[index] !== undefined && pagesHeight < top + height + offset){
                index += 1;
                nextEndPage += 1;
                // when we haven't rendered the nextEndPage and we aren't replacing,
                // we might not have a height for it yet
                pagesHeight += pageHeights[index] || 0;
            }
            if (!replace) {
                // when not replacing, never shrink bounds
                nextBeginPage = 0;
                nextEndPage = Math.max(renderPageBounds[1], nextEndPage);
            }
            if (show) {
                // ensure we try to render any show page
                var showPage = $b19f89b4068f9aff$var$calculateLastPageBound(show, step);
                nextBeginPage = Math.min(showPage, nextBeginPage);
                nextEndPage = Math.max(showPage, nextEndPage);
            }
            if (nextBeginPage !== renderPageBounds[0] || nextEndPage !== renderPageBounds[1]) setRenderPageBounds([
                nextBeginPage,
                nextEndPage
            ]);
        };
        var timer;
        var debounce = function debounce() {
            clearTimeout(timer);
            timer = setTimeout(evaluate, 10);
        };
        // might not be there yet or might have already rendered everything
        if (belowMarkerRef.current) {
            scrollParents = (0, $4113023f9e0bafa0$exports.findScrollParents)(belowMarkerRef.current);
            scrollParents.forEach(function(sp) {
                return sp.addEventListener('scroll', debounce);
            });
        }
        window.addEventListener('resize', debounce);
        evaluate();
        return function() {
            if (scrollParents) scrollParents.forEach(function(sp) {
                return sp.removeEventListener('scroll', debounce);
            });
            window.removeEventListener('resize', debounce);
            clearTimeout(timer);
        };
    }, [
        pageHeights,
        renderPageBounds,
        replace,
        show,
        step
    ]);
    // check if we need to ask for more
    (0, $b19f89b4068f9aff$var$_react.useEffect)(function() {
        if (onMore && renderPageBounds[1] === lastPage && items.length >= pendingLength && items.length > 0) {
            // remember we've asked for more, so we don't keep asking if it takes
            // a while
            setPendingLength(items.length + 1);
            onMore();
        }
    }, [
        items.length,
        lastPage,
        onMore,
        pendingLength,
        renderPageBounds,
        step
    ]);
    (0, $b19f89b4068f9aff$var$_react.useEffect)(function() {
        if (items.length === 0 && lastPage === 0 && pendingLength !== 0) {
            setPageHeights([]);
            setPendingLength(0);
            setRenderPageBounds([
                0,
                $b19f89b4068f9aff$var$calculateLastPageBound(show, step)
            ]);
        }
    }, [
        lastPage,
        pendingLength,
        show,
        step,
        items.length
    ]);
    // scroll to any 'show'
    (0, $6a5275ec792307a1$export$e5c5a5f917a5871c)(function() {
        // ride out any animation delays, 100ms empirically measured
        var timer = setTimeout(function() {
            if (show && belowMarkerRef.current && show !== scrollShow) {
                // calculate show index based on beginPage
                var showIndex = show - renderPageBounds[0] * step + (renderPageBounds[0] ? 1 : 0);
                var showNode = belowMarkerRef.current.parentNode.children.item(showIndex);
                if (showNode) {
                    var scrollParent = (0, $4113023f9e0bafa0$exports.findScrollParent)(showNode);
                    if ((0, $4113023f9e0bafa0$exports.isNodeBeforeScroll)(showNode, scrollParent)) showNode.scrollIntoView(true);
                    else if ((0, $4113023f9e0bafa0$exports.isNodeAfterScroll)(showNode, scrollParent)) showNode.scrollIntoView(false);
                    // clean up after having shown
                    setScrollShow(show);
                }
            }
        }, 100);
        return function() {
            return clearTimeout(timer);
        };
    // Omitting scrollShow as a dependency due to concern that setScrollShow
    // is being called within the timer. If left included, re-renders and other
    // dependency values could change in an unpredictable manner during timer
    // and potentially result in an infinite loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        renderPageBounds,
        show,
        step
    ]);
    // calculate and keep track of page heights
    (0, $6a5275ec792307a1$export$e5c5a5f917a5871c)(function() {
        // if don't have a belowMarker, we must have rendered everything already
        if (!belowMarkerRef.current) return;
        // calculate page heights for rendered pages
        var rendered = belowMarkerRef.current.parentNode.children;
        // ensure we've rendered the state we have
        // above? + items in rendered pages + below === rendered DOM elements length
        if ((aboveMarkerRef.current ? 1 : 0) + (renderPageBounds[1] - renderPageBounds[0] + 1) * step + 1 === rendered.length) {
            var nextPageHeights;
            // step through each page
            var i = renderPageBounds[0];
            var lastBottom;
            while(i <= renderPageBounds[1]){
                var topIndex = (aboveMarkerRef.current ? 1 : 0) + (i - renderPageBounds[0]) * step;
                var bottomIndex = Math.min(topIndex + step - 1, rendered.length - 1);
                // we use lastBottom for top to ensure grid layouts work
                var top = lastBottom !== undefined ? lastBottom : rendered.item(topIndex).getBoundingClientRect().top;
                var _rendered$item$getBou = rendered.item(bottomIndex).getBoundingClientRect(), bottom = _rendered$item$getBou.bottom;
                var height = bottom - top;
                if (bottom && (!pageHeights || pageHeights[i] !== height)) {
                    if (!nextPageHeights) nextPageHeights = [].concat(pageHeights || []);
                    nextPageHeights[i] = height;
                }
                lastBottom = bottom;
                i += 1;
            }
            // estimate page heights for pages we haven't rendered yet
            while(replace && i <= lastPage){
                if (!pageHeights[i] && pageHeights[i] !== pageHeights[0]) {
                    if (!nextPageHeights) nextPageHeights = [].concat(pageHeights || []);
                    // set to first page height
                    var _nextPageHeights = nextPageHeights;
                    nextPageHeights[i] = _nextPageHeights[0];
                }
                i += 1;
            }
            if (nextPageHeights) setPageHeights(nextPageHeights);
        }
    }, [
        lastPage,
        pageHeights,
        renderPageBounds,
        replace,
        step
    ]);
    // calculate the height above the first rendered page using the pageHeights
    var aboveHeight = (0, $b19f89b4068f9aff$var$_react.useMemo)(function() {
        if (!replace) return 0;
        var height = 0;
        var i = 0;
        while(i < renderPageBounds[0]){
            height += pageHeights[i] || 0;
            i += 1;
        }
        return height;
    }, [
        pageHeights,
        renderPageBounds,
        replace
    ]);
    // calculate the height below the last rendered page using the pageHeights
    var belowHeight = (0, $b19f89b4068f9aff$var$_react.useMemo)(function() {
        if (!replace) return 0;
        var height = 0;
        var i = renderPageBounds[1] + 1;
        while(i <= lastPage){
            height += pageHeights[i] || 0;
            i += 1;
        }
        return height;
    }, [
        lastPage,
        pageHeights,
        renderPageBounds,
        replace
    ]);
    var firstIndex = renderPageBounds[0] * step;
    var lastIndex = Math.min((renderPageBounds[1] + 1) * step, items.length) - 1;
    var result = [];
    if (aboveHeight) {
        var marker = /*#__PURE__*/ $b19f89b4068f9aff$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            key: "above",
            ref: aboveMarkerRef,
            flex: false,
            height: aboveHeight + "px"
        });
        if (renderMarker) // need to give it a key
        marker = /*#__PURE__*/ $b19f89b4068f9aff$var$_react["default"].cloneElement(renderMarker(marker), {
            key: 'above'
        });
        result.push(marker);
    }
    items.slice(firstIndex, lastIndex + 1).forEach(function(item, index) {
        var itemsIndex = firstIndex + index;
        var child = children(item, itemsIndex);
        result.push(child);
    });
    if (replace || renderPageBounds[1] < lastPage || onMore) {
        var _marker = /*#__PURE__*/ $b19f89b4068f9aff$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            key: "below",
            ref: !renderMarker && belowMarkerRef || undefined,
            flex: false,
            height: (belowHeight || 0) + "px"
        });
        if (renderMarker) {
            // need to give it a key
            var renderedMarker = renderMarker(_marker);
            _marker = /*#__PURE__*/ $b19f89b4068f9aff$var$_react["default"].cloneElement(renderedMarker, {
                key: 'below',
                // We need to make sure our belowMarkerRef is tied to a component
                // that has the same parent as the items being rendered. This is so
                // we can use belowMarkerRef.current.parentNode.children to
                // get a reference to the items in the DOM for calculating pageHeights.
                //
                // Since the caller might have included a ref in what their
                // renderMarker returns, we have to take care of both refs.
                // https://github.com/facebook/react/issues/8873#issuecomment-489579878
                ref: function ref(node) {
                    // Keep your own reference
                    belowMarkerRef.current = node;
                    // Call the original ref, if any
                    var ref = renderedMarker.ref;
                    if (typeof ref === 'function') ref(node);
                    else if (ref !== null) ref.current = node;
                }
            });
        }
        result.push(_marker);
    }
    return result;
};
$b19f89b4068f9aff$var$InfiniteScroll.propTypes = $b401dc823cf33fc0$export$2cd935ea72beacbd;


$41010700ddcbac64$export$c5295390d6167a3e = $b19f89b4068f9aff$export$c5295390d6167a3e;



var $98274833e85ef953$exports = {};

$parcel$export($98274833e85ef953$exports, "__esModule", function () { return $98274833e85ef953$export$1e511d4a378977f5; }, function (v) { return $98274833e85ef953$export$1e511d4a378977f5 = v; });
$parcel$export($98274833e85ef953$exports, "Pagination", function () { return $98274833e85ef953$export$68f5e1453c188a82; }, function (v) { return $98274833e85ef953$export$68f5e1453c188a82 = v; });
var $98274833e85ef953$export$1e511d4a378977f5;
var $98274833e85ef953$export$68f5e1453c188a82;
"use strict";
$98274833e85ef953$export$1e511d4a378977f5 = true;
$98274833e85ef953$export$68f5e1453c188a82 = void 0;
var $671cd2c50019ac20$export$1e511d4a378977f5;
var $671cd2c50019ac20$export$68f5e1453c188a82;
"use strict";
$671cd2c50019ac20$export$1e511d4a378977f5 = true;
$671cd2c50019ac20$export$68f5e1453c188a82 = void 0;

var $671cd2c50019ac20$var$_react = $671cd2c50019ac20$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $671cd2c50019ac20$var$_styledComponents = $671cd2c50019ac20$var$_interopRequireDefault((parcelRequire("iA1nz")));


var $30abe96e60597f25$exports = {};

$parcel$export($30abe96e60597f25$exports, "__esModule", function () { return $30abe96e60597f25$export$1e511d4a378977f5; }, function (v) { return $30abe96e60597f25$export$1e511d4a378977f5 = v; });
$parcel$export($30abe96e60597f25$exports, "Nav", function () { return $30abe96e60597f25$export$39140c7d8b0ba7b3; }, function (v) { return $30abe96e60597f25$export$39140c7d8b0ba7b3 = v; });
var $30abe96e60597f25$export$1e511d4a378977f5;
var $30abe96e60597f25$export$39140c7d8b0ba7b3;
"use strict";
$30abe96e60597f25$export$1e511d4a378977f5 = true;
$30abe96e60597f25$export$39140c7d8b0ba7b3 = void 0;
var $ab06c6a0f86d696a$export$1e511d4a378977f5;
var $ab06c6a0f86d696a$export$39140c7d8b0ba7b3;
"use strict";
$ab06c6a0f86d696a$export$1e511d4a378977f5 = true;
$ab06c6a0f86d696a$export$39140c7d8b0ba7b3 = void 0;

var $ab06c6a0f86d696a$var$_react = $ab06c6a0f86d696a$var$_interopRequireDefault((parcelRequire("2xPiy")));


function $ab06c6a0f86d696a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $ab06c6a0f86d696a$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $ab06c6a0f86d696a$var$_extends() {
    return $ab06c6a0f86d696a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ab06c6a0f86d696a$var$_extends.apply(null, arguments);
}
var $ab06c6a0f86d696a$var$Nav = $ab06c6a0f86d696a$export$39140c7d8b0ba7b3 = function Nav(_ref) {
    var _theme$nav;
    var rest = $ab06c6a0f86d696a$var$_extends({}, ($ab06c6a0f86d696a$var$_objectDestructuringEmpty(_ref), _ref));
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ $ab06c6a0f86d696a$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $ab06c6a0f86d696a$var$_extends({
        as: "nav",
        flex: false,
        gap: (_theme$nav = theme.nav) == null ? void 0 : _theme$nav.gap
    }, rest));
};


$30abe96e60597f25$export$39140c7d8b0ba7b3 = $ab06c6a0f86d696a$export$39140c7d8b0ba7b3;


var $1eaa94637897e2e8$export$1e511d4a378977f5;
var $1eaa94637897e2e8$export$4109320283c508e;
"use strict";
$1eaa94637897e2e8$export$1e511d4a378977f5 = true;
$1eaa94637897e2e8$export$4109320283c508e = void 0;

var $1eaa94637897e2e8$var$_react = $1eaa94637897e2e8$var$_interopRequireDefault((parcelRequire("2xPiy")));
var $4da987b200638fa8$export$1e511d4a378977f5;
var $4da987b200638fa8$export$6d7013b439c96bfa;
var $4da987b200638fa8$export$84e27f887f319440;
var $4da987b200638fa8$export$1d41361302b577a1;
"use strict";
$4da987b200638fa8$export$1e511d4a378977f5 = true;
$4da987b200638fa8$export$6d7013b439c96bfa = $4da987b200638fa8$export$84e27f887f319440 = $4da987b200638fa8$export$1d41361302b577a1 = void 0;

var $4da987b200638fa8$var$_styledComponents = $4da987b200638fa8$var$_interopRequireDefault((parcelRequire("iA1nz")));



function $4da987b200638fa8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $4da987b200638fa8$var$sizeStyle = function sizeStyle(props) {
    var style = props.theme.pagination.button && props.theme.pagination.button.size && props.theme.pagination.button.size[props.size || 'medium'];
    return style ? {
        content: {
            fontSize: style.font && style.font.size,
            // fix for safari, apply line-height 0 on next/previous
            // icon-only buttons
            lineHeight: style.font && props.hasLabel ? style.font.height : 0
        },
        container: {
            height: style.height,
            minWidth: style.width
        }
    } : '';
};
var $4da987b200638fa8$var$StyledPaginationButton = $4da987b200638fa8$export$84e27f887f319440 = (0, $4da987b200638fa8$var$_styledComponents["default"])($fb68f765668b25d0$export$353f5b6fc5456de1).withConfig({
    displayName: "StyledPageControl__StyledPaginationButton",
    componentId: "sc-1vlfaez-0"
})([
    "> svg{margin:0 auto;}",
    ";"
], function(props) {
    return $4da987b200638fa8$var$sizeStyle(props).content;
});
var $4da987b200638fa8$var$StyledContainer = $4da987b200638fa8$export$1d41361302b577a1 = $4da987b200638fa8$var$_styledComponents["default"].div.withConfig($9a7099e779e83517$export$373e75d802fd707).withConfig({
    displayName: "StyledPageControl__StyledContainer",
    componentId: "sc-1vlfaez-1"
})([
    "display:flex;align-items:center;justify-content:center;max-width:100%;",
    ";",
    ";"
], function(props) {
    return $4da987b200638fa8$var$sizeStyle(props).container;
}, function(props) {
    return props.theme.pagination.control && props.theme.pagination.control.extend;
});
var $4da987b200638fa8$var$StyledSeparator = $4da987b200638fa8$export$6d7013b439c96bfa = (0, $4da987b200638fa8$var$_styledComponents["default"])($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6).withConfig({
    displayName: "StyledPageControl__StyledSeparator",
    componentId: "sc-1vlfaez-2"
})([
    "font-weight:bold;",
    ";",
    ";"
], function(props) {
    return "font-size: " + ($4da987b200638fa8$var$sizeStyle(props).content && $4da987b200638fa8$var$sizeStyle(props).content.fontSize);
}, function(props) {
    return "line-height: " + ($4da987b200638fa8$var$sizeStyle(props).content && $4da987b200638fa8$var$sizeStyle(props).content.lineHeight);
});



var $1eaa94637897e2e8$var$_excluded = [
    "control",
    "separator",
    "size"
];
function $1eaa94637897e2e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $1eaa94637897e2e8$var$_extends() {
    return $1eaa94637897e2e8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1eaa94637897e2e8$var$_extends.apply(null, arguments);
}
function $1eaa94637897e2e8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $1eaa94637897e2e8$var$PageControl = $1eaa94637897e2e8$export$4109320283c508e = function PageControl(_ref) {
    var control = _ref.control, separator = _ref.separator, sizeProp = _ref.size, rest = $1eaa94637897e2e8$var$_objectWithoutPropertiesLoose(_ref, $1eaa94637897e2e8$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var size = sizeProp || 'medium';
    return /*#__PURE__*/ $1eaa94637897e2e8$var$_react["default"].createElement($4da987b200638fa8$export$1d41361302b577a1, $1eaa94637897e2e8$var$_extends({
        as: "li",
        size: size
    }, passThemeFlag), separator ? /*#__PURE__*/ $1eaa94637897e2e8$var$_react["default"].createElement($4da987b200638fa8$export$6d7013b439c96bfa, $1eaa94637897e2e8$var$_extends({
        size: size
    }, passThemeFlag), "\u2026") : /*#__PURE__*/ $1eaa94637897e2e8$var$_react["default"].createElement($4da987b200638fa8$export$84e27f887f319440, $1eaa94637897e2e8$var$_extends({
        a11yTitle: "Go to page " + control,
        fill: true,
        kind: theme.pagination.button,
        label: control,
        size: size
    }, passThemeFlag, rest)));
};


var $943aca04a5ebc26c$export$1e511d4a378977f5;
var $943aca04a5ebc26c$export$5035dc52aa18dae0;
"use strict";
$943aca04a5ebc26c$export$1e511d4a378977f5 = true;
$943aca04a5ebc26c$export$5035dc52aa18dae0 = void 0;

var $943aca04a5ebc26c$var$_react = $943aca04a5ebc26c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $c692f0029c94fbb2$exports = {};

$parcel$export($c692f0029c94fbb2$exports, "__esModule", function () { return $c692f0029c94fbb2$export$1e511d4a378977f5; }, function (v) { return $c692f0029c94fbb2$export$1e511d4a378977f5 = v; });
$parcel$export($c692f0029c94fbb2$exports, "Select", function () { return $c692f0029c94fbb2$export$ef9b1a59e592288f; }, function (v) { return $c692f0029c94fbb2$export$ef9b1a59e592288f = v; });
var $c692f0029c94fbb2$export$1e511d4a378977f5;
var $c692f0029c94fbb2$export$ef9b1a59e592288f;
"use strict";
$c692f0029c94fbb2$export$1e511d4a378977f5 = true;
$c692f0029c94fbb2$export$ef9b1a59e592288f = void 0;
var $fee1c086737bcc76$export$1e511d4a378977f5;
var $fee1c086737bcc76$export$ef9b1a59e592288f;
"use strict";
$fee1c086737bcc76$export$1e511d4a378977f5 = true;
$fee1c086737bcc76$export$ef9b1a59e592288f = void 0;

var $fee1c086737bcc76$var$_react = $fee1c086737bcc76$var$_interopRequireWildcard((parcelRequire("2xPiy")));



var $5c9c2e034f522b3e$export$1e511d4a378977f5;
var $5c9c2e034f522b3e$export$c24727297075ec6a;
"use strict";
$5c9c2e034f522b3e$export$1e511d4a378977f5 = true;
$5c9c2e034f522b3e$export$c24727297075ec6a = void 0;

var $5c9c2e034f522b3e$var$_react = $5c9c2e034f522b3e$var$_interopRequireWildcard((parcelRequire("2xPiy")));
function $5c9c2e034f522b3e$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($5c9c2e034f522b3e$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
// When not a descendant of a Form, FormContext still provides a basic
// useFormInput. It doesn't do anything for components like TextInput.
// But, it does store the value for components like CheckBox or Select
// where the grommet component needs to know the value in order to
// render custom visuals.
var $5c9c2e034f522b3e$var$useFormInput = function useFormInput(_ref) {
    var valueProp = _ref.value, initialValue = _ref.initialValue;
    var _useState = (0, $5c9c2e034f522b3e$var$_react.useState)(valueProp !== undefined ? valueProp : initialValue), value = _useState[0], setValue = _useState[1];
    // Returns an array [value and function to set the value]
    return [
        valueProp !== undefined ? valueProp : value,
        function(nextValue) {
            if (initialValue !== undefined) setValue(nextValue);
        }
    ];
};
var $5c9c2e034f522b3e$var$useFormField = function useFormField(_ref2) {
    var error = _ref2.error, info = _ref2.info, disabled = _ref2.disabled;
    return {
        error: error,
        info: info,
        disabled: disabled
    };
};
var $5c9c2e034f522b3e$var$FormContext = $5c9c2e034f522b3e$export$c24727297075ec6a = /*#__PURE__*/ $5c9c2e034f522b3e$var$_react["default"].createContext({
    useFormField: $5c9c2e034f522b3e$var$useFormField,
    useFormInput: $5c9c2e034f522b3e$var$useFormInput
});


var $07138d450b6c9297$export$1e511d4a378977f5;
var $07138d450b6c9297$export$446eebadefe1123b;
"use strict";
$07138d450b6c9297$export$1e511d4a378977f5 = true;
$07138d450b6c9297$export$446eebadefe1123b = void 0;

var $07138d450b6c9297$var$_react = $07138d450b6c9297$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $07138d450b6c9297$var$_styledComponents = $07138d450b6c9297$var$_interopRequireDefault((parcelRequire("iA1nz")));








var $99c7a15bc083da62$exports = {};

$parcel$export($99c7a15bc083da62$exports, "__esModule", function () { return $99c7a15bc083da62$export$1e511d4a378977f5; }, function (v) { return $99c7a15bc083da62$export$1e511d4a378977f5 = v; });
$parcel$export($99c7a15bc083da62$exports, "TextInput", function () { return $99c7a15bc083da62$export$c86715117507e8e5; }, function (v) { return $99c7a15bc083da62$export$c86715117507e8e5 = v; });
var $99c7a15bc083da62$export$1e511d4a378977f5;
var $99c7a15bc083da62$export$c86715117507e8e5;
"use strict";
$99c7a15bc083da62$export$1e511d4a378977f5 = true;
$99c7a15bc083da62$export$c86715117507e8e5 = void 0;
var $de8b1a269eb27769$export$1e511d4a378977f5;
var $de8b1a269eb27769$export$c86715117507e8e5;
"use strict";
$de8b1a269eb27769$export$1e511d4a378977f5 = true;
$de8b1a269eb27769$export$c86715117507e8e5 = void 0;

var $de8b1a269eb27769$var$_react = $de8b1a269eb27769$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $de8b1a269eb27769$var$_styledComponents = $de8b1a269eb27769$var$_interopRequireDefault((parcelRequire("iA1nz")));








var $b781946845414bc7$export$1e511d4a378977f5;
var $b781946845414bc7$export$4aa9d16f7efe0fb6;
var $b781946845414bc7$export$46d060c4400937ed;
var $b781946845414bc7$export$2f5b00b01ab6676b;
var $b781946845414bc7$export$333ccef64da8eec4;
var $b781946845414bc7$export$7c8f159da0dc916;
"use strict";
$b781946845414bc7$export$1e511d4a378977f5 = true;
$b781946845414bc7$export$4aa9d16f7efe0fb6 = $b781946845414bc7$export$46d060c4400937ed = $b781946845414bc7$export$2f5b00b01ab6676b = $b781946845414bc7$export$333ccef64da8eec4 = $b781946845414bc7$export$7c8f159da0dc916 = void 0;

var $b781946845414bc7$var$_styledComponents = $b781946845414bc7$var$_interopRequireWildcard((parcelRequire("iA1nz")));



function $b781946845414bc7$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($b781946845414bc7$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $b781946845414bc7$var$getPlainStyle = function getPlainStyle(plain) {
    if (plain === 'full') return (0, $b781946845414bc7$var$_styledComponents.css)([
        "",
        " padding:0;"
    ], $4113023f9e0bafa0$exports.plainInputStyle);
    return plain && $4113023f9e0bafa0$exports.plainInputStyle;
};
var $b781946845414bc7$var$StyledTextInput = $b781946845414bc7$export$46d060c4400937ed = $b781946845414bc7$var$_styledComponents["default"].input.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledTextInput",
    componentId: "sc-1x30a0s-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ";"
], $4113023f9e0bafa0$exports.inputStyle, function(props) {
    return props.readOnlyCopy ? "padding-" + (props.reverse ? 'left' : 'right') + ": 0px;" : '';
}, function(props) {
    return props.readOnly && "border: none;";
}, function(props) {
    return $b781946845414bc7$var$getPlainStyle(props.plain);
}, function(props) {
    return props.icon && $9a7099e779e83517$export$cd595fd57f72dbc4;
}, function(props) {
    return props.disabled && (0, $4113023f9e0bafa0$exports.disabledStyle)(props.theme.textInput.disabled && props.theme.textInput.disabled.opacity);
}, function(props) {
    return props.textAlign && $4113023f9e0bafa0$exports.textAlignStyle;
}, function(props) {
    return props.widthProp && !props.readOnly && (0, $4113023f9e0bafa0$exports.widthStyle)(props.widthProp, props.theme);
}, function(props) {
    return props.theme.textInput && props.theme.textInput.extend;
});
var $b781946845414bc7$var$StyledTextInputContainer = $b781946845414bc7$export$4aa9d16f7efe0fb6 = $b781946845414bc7$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledTextInput__StyledTextInputContainer",
    componentId: "sc-1x30a0s-1"
})([
    "position:relative;width:100%;",
    " ",
    ";",
    ";",
    " ",
    ";"
], function(props) {
    return props.widthProp && props.readOnlyProp && (0, $4113023f9e0bafa0$exports.widthStyle)(props.widthProp, props.theme);
}, function(props) {
    return props.readOnlyProp && !props.plain && $4113023f9e0bafa0$exports.controlBorderStyle;
}, function(props) {
    return props.readOnlyCopy && "\n    box-sizing: border-box;\n    flex-direction: row;\n    display: flex;\n  ";
}, function(props) {
    return props.readOnlyProp && !props.plain && (0, $18fb38d78d6dde51$export$28ff5f3fef0ffa78)(props.theme);
}, function(props) {
    return props.theme.textInput && props.theme.textInput.container && props.theme.textInput.container.extend;
});
var $b781946845414bc7$var$StyledPlaceholder = $b781946845414bc7$export$333ccef64da8eec4 = $b781946845414bc7$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledTextInput__StyledPlaceholder",
    componentId: "sc-1x30a0s-2"
})([
    "position:absolute;left:",
    "px;top:50%;transform:translateY(-50%);display:flex;justify-content:center;pointer-events:none;",
    ";"
], function(props) {
    return (0, $4113023f9e0bafa0$exports.parseMetricToNum)((0, $4113023f9e0bafa0$exports.getInputPadBySide)(props, 'left')) - (0, $4113023f9e0bafa0$exports.parseMetricToNum)(props.theme.global.control.border.width);
}, function(props) {
    return props.theme.textInput && props.theme.textInput.placeholder && props.theme.textInput.placeholder.extend;
});
var $b781946845414bc7$var$StyledIcon = $b781946845414bc7$export$7c8f159da0dc916 = $b781946845414bc7$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledTextInput__StyledIcon",
    componentId: "sc-1x30a0s-3"
})([
    "position:absolute;display:flex;justify:center;top:50%;transform:translateY(-50%);pointer-events:none;",
    ""
], function(props) {
    return props.reverse ? "right: " + (0, $4113023f9e0bafa0$exports.getInputPadBySide)(props, 'right') + ";" : "left: " + (0, $4113023f9e0bafa0$exports.getInputPadBySide)(props, 'left') + ";";
});
var $b781946845414bc7$var$StyledSuggestions = $b781946845414bc7$export$2f5b00b01ab6676b = $b781946845414bc7$var$_styledComponents["default"].ol.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledTextInput__StyledSuggestions",
    componentId: "sc-1x30a0s-4"
})([
    "border-top-left-radius:0;border-top-right-radius:0;margin:0;padding:0;list-style-type:none;",
    ";"
], function(props) {
    return props.theme.textInput && props.theme.textInput.suggestions && props.theme.textInput.suggestions.extend;
});



var $e5cb9c1bbfccf4eb$export$1e511d4a378977f5;
var $e5cb9c1bbfccf4eb$export$2cabbaef9a75cbd2;
"use strict";
$e5cb9c1bbfccf4eb$export$1e511d4a378977f5 = true;
$e5cb9c1bbfccf4eb$export$2cabbaef9a75cbd2 = void 0;

var $e5cb9c1bbfccf4eb$var$_propTypes = $e5cb9c1bbfccf4eb$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $e5cb9c1bbfccf4eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $e5cb9c1bbfccf4eb$var$PropType = {};
$e5cb9c1bbfccf4eb$var$PropType = {
    a11yTitle: $e5cb9c1bbfccf4eb$var$_propTypes["default"].string,
    defaultSuggestion: $e5cb9c1bbfccf4eb$var$_propTypes["default"].number,
    dropAlign: $e5cb9c1bbfccf4eb$var$_propTypes["default"].shape({
        top: $e5cb9c1bbfccf4eb$var$_propTypes["default"].oneOf([
            'top',
            'bottom'
        ]),
        bottom: $e5cb9c1bbfccf4eb$var$_propTypes["default"].oneOf([
            'top',
            'bottom'
        ]),
        right: $e5cb9c1bbfccf4eb$var$_propTypes["default"].oneOf([
            'left',
            'right'
        ]),
        left: $e5cb9c1bbfccf4eb$var$_propTypes["default"].oneOf([
            'left',
            'right'
        ])
    }),
    dropHeight: $e5cb9c1bbfccf4eb$var$_propTypes["default"].oneOfType([
        $e5cb9c1bbfccf4eb$var$_propTypes["default"].oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        $e5cb9c1bbfccf4eb$var$_propTypes["default"].string
    ]),
    dropTarget: $e5cb9c1bbfccf4eb$var$_propTypes["default"].object,
    dropProps: $e5cb9c1bbfccf4eb$var$_propTypes["default"].object,
    icon: $e5cb9c1bbfccf4eb$var$_propTypes["default"].element,
    id: $e5cb9c1bbfccf4eb$var$_propTypes["default"].string,
    focusIndicator: $e5cb9c1bbfccf4eb$var$_propTypes["default"].bool,
    messages: $e5cb9c1bbfccf4eb$var$_propTypes["default"].shape({
        enterSelect: $e5cb9c1bbfccf4eb$var$_propTypes["default"].string,
        suggestionsCount: $e5cb9c1bbfccf4eb$var$_propTypes["default"].string,
        suggestionsExist: $e5cb9c1bbfccf4eb$var$_propTypes["default"].string,
        suggestionIsOpen: $e5cb9c1bbfccf4eb$var$_propTypes["default"].string
    }),
    name: $e5cb9c1bbfccf4eb$var$_propTypes["default"].string,
    onChange: $e5cb9c1bbfccf4eb$var$_propTypes["default"].func,
    onSelect: $e5cb9c1bbfccf4eb$var$_propTypes["default"].func,
    onSuggestionSelect: $e5cb9c1bbfccf4eb$var$_propTypes["default"].func,
    onSuggestionsOpen: $e5cb9c1bbfccf4eb$var$_propTypes["default"].func,
    onSuggestionsClose: $e5cb9c1bbfccf4eb$var$_propTypes["default"].func,
    placeholder: $e5cb9c1bbfccf4eb$var$_propTypes["default"].node,
    plain: $e5cb9c1bbfccf4eb$var$_propTypes["default"].oneOfType([
        $e5cb9c1bbfccf4eb$var$_propTypes["default"].bool,
        $e5cb9c1bbfccf4eb$var$_propTypes["default"].oneOf([
            'full'
        ])
    ]),
    readOnlyCopy: $e5cb9c1bbfccf4eb$var$_propTypes["default"].bool,
    reverse: $e5cb9c1bbfccf4eb$var$_propTypes["default"].bool,
    size: $e5cb9c1bbfccf4eb$var$_propTypes["default"].oneOfType([
        $e5cb9c1bbfccf4eb$var$_propTypes["default"].oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            'xxlarge',
            '2xl',
            '3xl',
            '4xl',
            '5xl',
            '6xl'
        ]),
        $e5cb9c1bbfccf4eb$var$_propTypes["default"].string
    ]),
    suggestions: $e5cb9c1bbfccf4eb$var$_propTypes["default"].arrayOf($e5cb9c1bbfccf4eb$var$_propTypes["default"].oneOfType([
        $e5cb9c1bbfccf4eb$var$_propTypes["default"].shape({
            label: $e5cb9c1bbfccf4eb$var$_propTypes["default"].node,
            // eslint-disable-next-line
            value: $e5cb9c1bbfccf4eb$var$_propTypes["default"].any // this is intentional any
        }),
        $e5cb9c1bbfccf4eb$var$_propTypes["default"].string
    ])),
    textAlign: $e5cb9c1bbfccf4eb$var$_propTypes["default"].oneOf([
        'start',
        'center',
        'end'
    ]),
    value: $e5cb9c1bbfccf4eb$var$_propTypes["default"].oneOfType([
        $e5cb9c1bbfccf4eb$var$_propTypes["default"].string,
        $e5cb9c1bbfccf4eb$var$_propTypes["default"].number
    ]),
    width: $5897bd367fbd90c1$export$7d45d0e6b7abd5e2
};
var $e5cb9c1bbfccf4eb$var$TextInputPropTypes = $e5cb9c1bbfccf4eb$export$2cabbaef9a75cbd2 = $e5cb9c1bbfccf4eb$var$PropType;


var $10cb694a8e7833c1$export$1e511d4a378977f5;
var $10cb694a8e7833c1$export$4f2558dd25106ae2;
"use strict";
$10cb694a8e7833c1$export$1e511d4a378977f5 = true;
$10cb694a8e7833c1$export$4f2558dd25106ae2 = void 0;

var $10cb694a8e7833c1$var$_react = $10cb694a8e7833c1$var$_interopRequireDefault((parcelRequire("2xPiy")));

var $10cb694a8e7833c1$var$_styledComponents = $10cb694a8e7833c1$var$_interopRequireDefault((parcelRequire("iA1nz")));





function $10cb694a8e7833c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $10cb694a8e7833c1$var$_extends() {
    return $10cb694a8e7833c1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $10cb694a8e7833c1$var$_extends.apply(null, arguments);
}
// to overcome `plain` styling due to (icon && !label) condition
// in buttons without theme.button.default, apply the padding here
var $10cb694a8e7833c1$var$StyledButton = (0, $10cb694a8e7833c1$var$_styledComponents["default"])($fb68f765668b25d0$export$353f5b6fc5456de1).withConfig({
    displayName: "CopyButton__StyledButton",
    componentId: "sc-1bp1m18-0"
})([
    "border-radius:",
    ";",
    ""
], function(props) {
    return props.theme.global.control.border.radius;
}, function(props) {
    return !props.theme.button["default"] ? (0, $9a7099e779e83517$export$944a9710f9445eee)('padding', props.pad, false, undefined, props.theme) : '';
});
var $10cb694a8e7833c1$var$CopyButton = $10cb694a8e7833c1$export$4f2558dd25106ae2 = function CopyButton(_ref) {
    var _theme$textInput, _theme$global$input$p, _theme$global$input$p2, _theme$global$input$p3;
    var disabled = _ref.disabled, onClickCopy = _ref.onClickCopy, onBlurCopy = _ref.onBlurCopy, readOnlyCopyPrompt = _ref.readOnlyCopyPrompt, tip = _ref.tip, value = _ref.value;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var CopyIcon = ((_theme$textInput = theme.textInput) == null || (_theme$textInput = _theme$textInput.icons) == null ? void 0 : _theme$textInput.copy) || $cf62a042166a0000$export$92ce62e1201c4fc0;
    return /*#__PURE__*/ $10cb694a8e7833c1$var$_react["default"].createElement($7946e73be6fde87a$export$c92c6401b52a9298, {
        dropProps: {
            align: {
                bottom: 'top'
            }
        },
        content: tip
    }, /*#__PURE__*/ $10cb694a8e7833c1$var$_react["default"].createElement($10cb694a8e7833c1$var$StyledButton, $10cb694a8e7833c1$var$_extends({
        disabled: disabled,
        onClick: onClickCopy,
        icon: /*#__PURE__*/ $10cb694a8e7833c1$var$_react["default"].createElement(CopyIcon, null),
        pad: {
            horizontal: (_theme$global$input$p = theme.global.input.padding) == null ? void 0 : _theme$global$input$p.horizontal,
            left: (_theme$global$input$p2 = theme.global.input.padding) == null ? void 0 : _theme$global$input$p2.left,
            right: (_theme$global$input$p3 = theme.global.input.padding) == null ? void 0 : _theme$global$input$p3.right,
            // only apply horizontal padding since button will
            // fill height of input
            top: '0',
            bottom: '0'
        },
        onBlur: onBlurCopy,
        onMouseOut: onBlurCopy,
        "aria-label": readOnlyCopyPrompt + " " + value
    }, passThemeFlag)));
};



var $de8b1a269eb27769$var$_excluded = [
    "a11yTitle",
    "defaultSuggestion",
    "defaultValue",
    "disabled",
    "dropAlign",
    "dropHeight",
    "dropTarget",
    "dropProps",
    "focusIndicator",
    "icon",
    "id",
    "messages",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onKeyDown",
    "onSelect",
    "onSuggestionSelect",
    "onSuggestionsClose",
    "onSuggestionsOpen",
    "placeholder",
    "plain",
    "readOnly",
    "readOnlyCopy",
    "reverse",
    "suggestions",
    "textAlign",
    "value",
    "width"
];
function $de8b1a269eb27769$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $de8b1a269eb27769$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($de8b1a269eb27769$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $de8b1a269eb27769$var$_extends() {
    return $de8b1a269eb27769$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $de8b1a269eb27769$var$_extends.apply(null, arguments);
}
function $de8b1a269eb27769$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $de8b1a269eb27769$var$renderLabel = function renderLabel(suggestion) {
    if (suggestion && typeof suggestion === 'object') return suggestion.label || suggestion.value;
    return suggestion;
};
var $de8b1a269eb27769$var$stringLabel = function stringLabel(suggestion) {
    if (suggestion && typeof suggestion === 'object') {
        if (suggestion.label && typeof suggestion.label === 'string') return suggestion.label;
        return suggestion.value;
    }
    return suggestion;
};
var $de8b1a269eb27769$var$ContainerBox = (0, $de8b1a269eb27769$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "TextInput__ContainerBox",
    componentId: "sc-1ai0c08-0"
})([
    "",
    ";@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){width:100%;}"
], function(props) {
    return props.dropHeight ? (0, $4113023f9e0bafa0$exports.sizeStyle)('max-height', props.dropHeight, props.theme) : 'max-height: inherit;';
});
var $de8b1a269eb27769$var$defaultDropAlign = {
    top: 'bottom',
    left: 'left'
};
var $de8b1a269eb27769$var$TextInput = $de8b1a269eb27769$export$c86715117507e8e5 = /*#__PURE__*/ (0, $de8b1a269eb27769$var$_react.forwardRef)(function(_ref, ref) {
    var _inputRef$current, _inputRef$current2;
    var a11yTitle = _ref.a11yTitle, defaultSuggestion = _ref.defaultSuggestion, defaultValue = _ref.defaultValue, disabled = _ref.disabled, _ref$dropAlign = _ref.dropAlign, dropAlign = _ref$dropAlign === void 0 ? $de8b1a269eb27769$var$defaultDropAlign : _ref$dropAlign, dropHeight = _ref.dropHeight, dropTarget = _ref.dropTarget, dropProps = _ref.dropProps, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, icon = _ref.icon, id = _ref.id, messages = _ref.messages, name = _ref.name, _onBlur = _ref.onBlur, onChange = _ref.onChange, _onFocus = _ref.onFocus, onKeyDown = _ref.onKeyDown, onSelect = _ref.onSelect, onSuggestionSelect = _ref.onSuggestionSelect, onSuggestionsClose = _ref.onSuggestionsClose, onSuggestionsOpen = _ref.onSuggestionsOpen, placeholder = _ref.placeholder, plain = _ref.plain, readOnlyProp = _ref.readOnly, readOnlyCopy = _ref.readOnlyCopy, reverse = _ref.reverse, suggestions = _ref.suggestions, textAlign = _ref.textAlign, valueProp = _ref.value, widthProp = _ref.width, rest = $de8b1a269eb27769$var$_objectWithoutPropertiesLoose(_ref, $de8b1a269eb27769$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useContext = (0, $de8b1a269eb27769$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var announce = (0, $de8b1a269eb27769$var$_react.useContext)($58f4f715ab4fa2c4$exports.AnnounceContext);
    var formContext = (0, $de8b1a269eb27769$var$_react.useContext)($5c9c2e034f522b3e$export$c24727297075ec6a);
    var inputRef = (0, $4113023f9e0bafa0$exports.useForwardedRef)(ref);
    var dropRef = (0, $de8b1a269eb27769$var$_react.useRef)();
    var suggestionsRef = (0, $de8b1a269eb27769$var$_react.useRef)();
    var readOnly = readOnlyProp || readOnlyCopy;
    // if this is a readOnly property, don't set a name with the form context
    // this allows Select to control the form context for the name.
    var _formContext$useFormI = formContext.useFormInput({
        name: readOnly ? undefined : name,
        value: valueProp
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    var _useState = (0, $de8b1a269eb27769$var$_react.useState)(), focus = _useState[0], setFocus = _useState[1];
    var _useState2 = (0, $de8b1a269eb27769$var$_react.useState)(false), showDrop = _useState2[0], setShowDrop = _useState2[1];
    var handleSuggestionSelect = (0, $de8b1a269eb27769$var$_react.useMemo)(function() {
        return onSelect && !onSuggestionSelect ? onSelect : onSuggestionSelect;
    }, [
        onSelect,
        onSuggestionSelect
    ]);
    var handleTextSelect = (0, $de8b1a269eb27769$var$_react.useMemo)(function() {
        return onSelect && onSuggestionSelect ? onSelect : undefined;
    }, [
        onSelect,
        onSuggestionSelect
    ]);
    var _useState3 = (0, $de8b1a269eb27769$var$_react.useState)(), suggestionsAtClose = _useState3[0], setSuggestionsAtClose = _useState3[1];
    var readOnlyCopyValidation = format({
        id: 'input.readOnlyCopy.validation',
        messages: messages
    });
    var readOnlyCopyPrompt = format({
        id: 'input.readOnlyCopy.prompt',
        messages: messages
    });
    var _useState4 = (0, $de8b1a269eb27769$var$_react.useState)(readOnlyCopyPrompt), tip = _useState4[0], setTip = _useState4[1];
    var onClickCopy = function onClickCopy() {
        navigator.clipboard.writeText(value);
        announce(readOnlyCopyValidation, 'assertive');
        setTip(readOnlyCopyValidation);
    };
    var onBlurCopy = function onBlurCopy() {
        if (tip === readOnlyCopyValidation) setTip(readOnlyCopyPrompt);
    };
    var openDrop = (0, $de8b1a269eb27769$var$_react.useCallback)(function() {
        setShowDrop(true);
        announce(format({
            id: 'textInput.suggestionIsOpen',
            messages: messages
        }));
        announce(suggestions.length + " " + format({
            id: 'textInput.suggestionsCount',
            messages: messages
        }));
        if (onSuggestionsOpen) onSuggestionsOpen();
    }, [
        announce,
        messages,
        format,
        onSuggestionsOpen,
        suggestions
    ]);
    var closeDrop = (0, $de8b1a269eb27769$var$_react.useCallback)(function() {
        setSuggestionsAtClose(suggestions); // must be before closing drop
        setShowDrop(false);
        if (onSuggestionsClose) onSuggestionsClose();
    }, [
        onSuggestionsClose,
        suggestions
    ]);
    var clickOutside = (0, $de8b1a269eb27769$var$_react.useCallback)(function(event) {
        if (event.target !== inputRef.current) closeDrop();
    }, [
        inputRef,
        closeDrop
    ]);
    // Handle scenarios where we have focus, the drop isn't showing,
    // and the suggestions change. We don't want to open the drop if
    // the drop has been closed by onEsc and the suggestions haven't
    // changed. So, we remember the suggestions we are showing when
    // the drop was closed and only re-open it when the suggestions
    // subsequently change.
    (0, $de8b1a269eb27769$var$_react.useEffect)(function() {
        if (focus && !showDrop && suggestions && suggestions.length && (!suggestionsAtClose || suggestionsAtClose.length !== suggestions.length)) openDrop();
    }, [
        focus,
        openDrop,
        showDrop,
        suggestions,
        suggestionsAtClose
    ]);
    // if we have no suggestions, close drop if it's open
    (0, $de8b1a269eb27769$var$_react.useEffect)(function() {
        if (showDrop && (!suggestions || !suggestions.length)) closeDrop();
    }, [
        closeDrop,
        showDrop,
        suggestions
    ]);
    var valueSuggestionIndex = (0, $de8b1a269eb27769$var$_react.useMemo)(function() {
        return suggestions ? suggestions.map(function(suggestion) {
            return typeof suggestion === 'object' ? suggestion.value : suggestion;
        }).indexOf(value) : -1;
    }, [
        suggestions,
        value
    ]);
    // choose the best suggestion, either the explicit default or the one
    // that matches the current value
    var resetSuggestionIndex = (0, $de8b1a269eb27769$var$_react.useMemo)(function() {
        if (valueSuggestionIndex === -1 && typeof defaultSuggestion === 'number') return defaultSuggestion;
        return valueSuggestionIndex;
    }, [
        defaultSuggestion,
        valueSuggestionIndex
    ]);
    // activeSuggestionIndex unifies mouse and keyboard interaction of
    // the suggestions
    var _useState5 = (0, $de8b1a269eb27769$var$_react.useState)(resetSuggestionIndex), activeSuggestionIndex = _useState5[0], setActiveSuggestionIndex = _useState5[1];
    // Only update active suggestion index when the mouse actually moves,
    // not when suggestions are moving under the mouse.
    var _useState6 = (0, $de8b1a269eb27769$var$_react.useState)(), mouseMovedSinceLastKey = _useState6[0], setMouseMovedSinceLastKey = _useState6[1];
    // set activeSuggestionIndex when value changes
    (0, $de8b1a269eb27769$var$_react.useEffect)(function() {
        return setActiveSuggestionIndex(valueSuggestionIndex);
    }, [
        valueSuggestionIndex
    ]);
    // reset activeSuggestionIndex when the drop is closed
    (0, $de8b1a269eb27769$var$_react.useEffect)(function() {
        if (!showDrop) setActiveSuggestionIndex(resetSuggestionIndex);
    }, [
        resetSuggestionIndex,
        showDrop
    ]);
    // announce active suggestion
    (0, $de8b1a269eb27769$var$_react.useEffect)(function() {
        if (activeSuggestionIndex >= 0) {
            var label = $de8b1a269eb27769$var$stringLabel(suggestions[activeSuggestionIndex]);
            announce(label + " " + format({
                id: 'textInput.enterSelect',
                messages: messages
            }));
        }
    }, [
        activeSuggestionIndex,
        announce,
        messages,
        format,
        suggestions
    ]);
    // make sure activeSuggestion is visible in scroll
    (0, $de8b1a269eb27769$var$_react.useEffect)(function() {
        var timer = setTimeout(function() {
            var list = suggestionsRef.current;
            if (showDrop && activeSuggestionIndex !== -1 && list) {
                var container = list.parentNode;
                var item = list.children[activeSuggestionIndex];
                if (container.scrollTo) {
                    if ((0, $4113023f9e0bafa0$exports.isNodeAfterScroll)(item, container)) container.scrollTo(0, item.offsetTop - (container.getBoundingClientRect().height - item.getBoundingClientRect().height));
                    else if ((0, $4113023f9e0bafa0$exports.isNodeBeforeScroll)(item, container)) container.scrollTo(0, item.offsetTop);
                }
            }
        }, 50); // delay to allow Drop to animate in
        return function() {
            return clearTimeout(timer);
        };
    }, [
        activeSuggestionIndex,
        showDrop
    ]);
    (0, $de8b1a269eb27769$var$_react.useEffect)(function() {
        if (readOnly && inputRef != null && inputRef.current && inputRef.current.scrollLeft > 0) inputRef.current.scrollLeft = 0;
    }, [
        readOnly,
        inputRef,
        inputRef == null || (_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.scrollLeft
    ]);
    var setValueFromSuggestion = function setValueFromSuggestion(event, suggestion) {
        // if we stole the focus in the drop, perhaps by interacting with
        // a suggestion button or the scrollbar, give it back
        inputRef.current.focus();
        inputRef.current.value = suggestion; // needed for uncontrolled cases
        closeDrop();
        if (handleSuggestionSelect) {
            if (event.persist) event.persist();
            var adjustedEvent = event;
            adjustedEvent.suggestion = suggestion;
            handleSuggestionSelect(adjustedEvent);
        }
        setValue(suggestion);
    };
    var onNextSuggestion = (0, $de8b1a269eb27769$var$_react.useCallback)(function(event) {
        event.preventDefault();
        var nextActiveIndex = Math.min(activeSuggestionIndex + 1, suggestions.length - 1);
        setActiveSuggestionIndex(nextActiveIndex);
        setMouseMovedSinceLastKey(false);
    }, [
        activeSuggestionIndex,
        suggestions
    ]);
    var onPreviousSuggestion = (0, $de8b1a269eb27769$var$_react.useCallback)(function(event) {
        event.preventDefault();
        var nextActiveIndex = Math.max(activeSuggestionIndex - 1, 0);
        setActiveSuggestionIndex(nextActiveIndex);
        setMouseMovedSinceLastKey(false);
    }, [
        activeSuggestionIndex
    ]);
    // account for input value in both controlled and uncontrolled scenarios
    var hasValue = value || ((_inputRef$current2 = inputRef.current) == null ? void 0 : _inputRef$current2.value);
    var showStyledPlaceholder = (0, $de8b1a269eb27769$var$_react.useMemo)(function() {
        return placeholder && typeof placeholder !== 'string' && !hasValue;
    }, [
        hasValue,
        placeholder
    ]);
    var drop;
    var extraProps = {
        onSelect: handleTextSelect
    };
    if (showDrop) drop = /*#__PURE__*/ $de8b1a269eb27769$var$_react["default"].createElement($9097252a6690f3a9$export$aaa698cd7aa517d6, $de8b1a269eb27769$var$_extends({
        ref: dropRef,
        id: id ? "text-input-drop__" + id : undefined,
        align: dropAlign,
        responsive: false,
        target: dropTarget || inputRef.current,
        onClickOutside: clickOutside,
        onEsc: closeDrop,
        trapFocus: false
    }, dropProps), /*#__PURE__*/ $de8b1a269eb27769$var$_react["default"].createElement($de8b1a269eb27769$var$ContainerBox, $de8b1a269eb27769$var$_extends({
        id: id ? "listbox__" + id : undefined,
        role: "listbox",
        overflow: "auto",
        dropHeight: dropHeight,
        onMouseMove: function onMouseMove() {
            return setMouseMovedSinceLastKey(true);
        }
    }, passThemeFlag), /*#__PURE__*/ $de8b1a269eb27769$var$_react["default"].createElement($b781946845414bc7$export$2f5b00b01ab6676b, $de8b1a269eb27769$var$_extends({
        ref: suggestionsRef
    }, passThemeFlag), /*#__PURE__*/ $de8b1a269eb27769$var$_react["default"].createElement($41010700ddcbac64$export$c5295390d6167a3e, {
        items: suggestions,
        step: theme.select.step,
        show: activeSuggestionIndex !== -1 ? activeSuggestionIndex : undefined
    }, function(suggestion, index, itemRef) {
        var active = activeSuggestionIndex === index;
        var selected = suggestion === value;
        // Determine whether the label is done as a child or
        // as an option Button kind property.
        var renderedLabel = $de8b1a269eb27769$var$renderLabel(suggestion);
        var child;
        if (typeof renderedLabel !== 'string') // must be an element rendered by suggestions.label
        child = renderedLabel;
        else if (!theme.button.option) // don't have theme support, need to layout here
        /*
        Not adding a theme object now because this code path
        is not used in the HPE theme, but we may add theme
        support here in the future.
        */ child = /*#__PURE__*/ $de8b1a269eb27769$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            align: "start",
            pad: "small"
        }, renderedLabel);
        // if we have a child, turn on plain
        return /*#__PURE__*/ $de8b1a269eb27769$var$_react["default"].createElement("li", {
            key: $de8b1a269eb27769$var$stringLabel(suggestion) + "-" + index,
            ref: itemRef
        }, /*#__PURE__*/ $de8b1a269eb27769$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
            id: id ? "listbox-option-" + index + "__" + id : undefined,
            role: "option",
            "aria-selected": selected ? 'true' : 'false',
            active: active,
            fill: "horizontal",
            plain: !child ? undefined : true,
            align: "start",
            kind: !child ? 'option' : undefined,
            label: !child ? renderedLabel : undefined,
            onClick: function onClick(event) {
                return setValueFromSuggestion(event, suggestion);
            },
            onMouseMove: mouseMovedSinceLastKey && activeSuggestionIndex !== index ? function() {
                return setActiveSuggestionIndex(index);
            } : undefined,
            keyboard: !mouseMovedSinceLastKey
        }, child));
    }))));
    var keyboardProps = {
        onKeyDown: onKeyDown
    };
    if (showDrop) {
        keyboardProps.onEnter = function(event) {
            // prevent submitting forms via Enter when the drop is open
            event.preventDefault();
            if (activeSuggestionIndex >= 0) setValueFromSuggestion(event, suggestions[activeSuggestionIndex]);
            else closeDrop();
        };
        if (activeSuggestionIndex > 0) keyboardProps.onUp = onPreviousSuggestion;
        if (activeSuggestionIndex < suggestions.length - 1) keyboardProps.onDown = onNextSuggestion;
        keyboardProps.onTab = closeDrop;
    } else if (suggestions && suggestions.length > 0) keyboardProps.onDown = openDrop;
    /*
  If the text input has a list of suggestions, add the WAI-ARIA 1.2
  combobox role and states.
  */ var comboboxProps = {};
    var activeOptionID;
    if (id && (suggestions == null ? void 0 : suggestions.length) > -1) {
        if (showDrop && activeSuggestionIndex > -1) activeOptionID = "listbox-option-" + activeSuggestionIndex + "__" + id;
        comboboxProps = {
            'aria-activedescendant': activeOptionID,
            'aria-autocomplete': 'list',
            'aria-expanded': showDrop ? 'true' : 'false',
            'aria-controls': showDrop ? "listbox__" + id : undefined,
            role: 'combobox'
        };
    }
    // For the Keyboard target below, if we have focus,
    // either on the input element or within the drop,
    // then we set the target to the document,
    // otherwise we only listen to onDown on the input element itself,
    // primarily for tests.
    var textInputIcon = (0, $4113023f9e0bafa0$exports.useSizedIcon)(icon, rest.size, theme);
    var ReadOnlyCopyButton = /*#__PURE__*/ $de8b1a269eb27769$var$_react["default"].createElement($10cb694a8e7833c1$export$4f2558dd25106ae2, {
        disabled: disabled,
        onBlurCopy: onBlurCopy,
        onClickCopy: onClickCopy,
        readOnlyCopyPrompt: readOnlyCopyPrompt,
        tip: tip,
        value: value
    });
    return /*#__PURE__*/ $de8b1a269eb27769$var$_react["default"].createElement($b781946845414bc7$export$4aa9d16f7efe0fb6, $de8b1a269eb27769$var$_extends({
        readOnlyProp: readOnly // readOnlyProp to avoid passing to DOM
        ,
        readOnlyCopy: readOnlyCopy,
        plain: plain,
        border: !plain,
        widthProp: widthProp,
        onMouseMove: function onMouseMove() {
            return setMouseMovedSinceLastKey(true);
        }
    }, passThemeFlag), reverse && readOnlyCopy && ReadOnlyCopyButton, showStyledPlaceholder && /*#__PURE__*/ $de8b1a269eb27769$var$_react["default"].createElement($b781946845414bc7$export$333ccef64da8eec4, passThemeFlag, placeholder), textInputIcon && !readOnlyCopy && /*#__PURE__*/ $de8b1a269eb27769$var$_react["default"].createElement($b781946845414bc7$export$7c8f159da0dc916, {
        reverse: reverse,
        theme: theme
    }, textInputIcon), /*#__PURE__*/ $de8b1a269eb27769$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, $de8b1a269eb27769$var$_extends({
        target: focus ? 'document' : undefined
    }, keyboardProps), /*#__PURE__*/ $de8b1a269eb27769$var$_react["default"].createElement($b781946845414bc7$export$46d060c4400937ed, $de8b1a269eb27769$var$_extends({
        "aria-label": a11yTitle,
        ref: inputRef,
        id: id,
        name: name,
        autoComplete: "off",
        disabled: disabled,
        plain: plain,
        placeholder: typeof placeholder === 'string' ? placeholder : undefined,
        icon: !readOnlyCopy && icon,
        reverse: reverse,
        focus: focus,
        focusIndicator: focusIndicator,
        textAlign: textAlign,
        widthProp: widthProp
    }, passThemeFlag, rest, extraProps, comboboxProps, {
        defaultValue: $de8b1a269eb27769$var$renderLabel(defaultValue),
        value: $de8b1a269eb27769$var$renderLabel(value),
        readOnly: readOnly,
        readOnlyCopy: readOnlyCopy,
        onFocus: function onFocus(event) {
            // Don't do anything if we are acting like we already have
            // focus. This can happen when this input loses focus temporarily
            // to our drop, see onBlur() handler below.
            if (!focus) {
                setFocus(true);
                if (suggestions && suggestions.length > 0) {
                    announce(format({
                        id: 'textInput.suggestionsExist',
                        messages: messages
                    }));
                    openDrop();
                }
                if (_onFocus) _onFocus(event);
            }
        },
        onBlur: function onBlur(event) {
            // Only treat it as a blur if the element receiving focus
            // isn't in our drop. The relatedTarget will be our drop
            // when the user clicks on a suggestion or interacts with the
            // scrollbar in the drop.
            if (!event.relatedTarget || event.relatedTarget !== dropRef.current) {
                setFocus(false);
                if (_onBlur) _onBlur(event);
            }
        },
        onChange: readOnly ? undefined : function(event) {
            // when TextInput is not contained in a Form, no re-render
            // will come from this onChange and remove the placeholder
            // so we need to update state to ensure the styled
            // placeholder only appears when there is no value
            if (suggestions && focus && !showDrop) openDrop();
            setValue(event.target.value);
            setActiveSuggestionIndex(resetSuggestionIndex);
            if (onChange) onChange(event);
        }
    }))), !reverse && readOnlyCopy && ReadOnlyCopyButton, !readOnly && drop);
});
$de8b1a269eb27769$var$TextInput.displayName = 'TextInput';
$de8b1a269eb27769$var$TextInput.propTypes = $e5cb9c1bbfccf4eb$export$2cabbaef9a75cbd2;


$99c7a15bc083da62$export$c86715117507e8e5 = $de8b1a269eb27769$export$c86715117507e8e5;


var $c0f2e05c3c6f54d3$export$1e511d4a378977f5;
var $c0f2e05c3c6f54d3$export$923536af422910c8;
var $c0f2e05c3c6f54d3$export$1d41361302b577a1;
var $c0f2e05c3c6f54d3$export$b34b5c37a9633c78;
var $c0f2e05c3c6f54d3$export$11a8a1ea41bf55d8;
var $c0f2e05c3c6f54d3$export$1a780bb4ae54ddec;
var $c0f2e05c3c6f54d3$export$7196851310a3d0bf;
"use strict";
$c0f2e05c3c6f54d3$export$1e511d4a378977f5 = true;
$c0f2e05c3c6f54d3$export$923536af422910c8 = $c0f2e05c3c6f54d3$export$1d41361302b577a1 = $c0f2e05c3c6f54d3$export$b34b5c37a9633c78 = $c0f2e05c3c6f54d3$export$11a8a1ea41bf55d8 = $c0f2e05c3c6f54d3$export$1a780bb4ae54ddec = $c0f2e05c3c6f54d3$export$7196851310a3d0bf = void 0;

var $c0f2e05c3c6f54d3$var$_styledComponents = $c0f2e05c3c6f54d3$var$_interopRequireDefault((parcelRequire("iA1nz")));


var $d7e2a556593dc38b$exports = {};

$parcel$export($d7e2a556593dc38b$exports, "__esModule", function () { return $d7e2a556593dc38b$export$1e511d4a378977f5; }, function (v) { return $d7e2a556593dc38b$export$1e511d4a378977f5 = v; });
$parcel$export($d7e2a556593dc38b$exports, "DropButton", function () { return $d7e2a556593dc38b$export$64fff40e709e8b2e; }, function (v) { return $d7e2a556593dc38b$export$64fff40e709e8b2e = v; });
var $d7e2a556593dc38b$export$1e511d4a378977f5;
var $d7e2a556593dc38b$export$64fff40e709e8b2e;
"use strict";
$d7e2a556593dc38b$export$1e511d4a378977f5 = true;
$d7e2a556593dc38b$export$64fff40e709e8b2e = void 0;
var $8a6f31f656bb2499$export$1e511d4a378977f5;
var $8a6f31f656bb2499$export$64fff40e709e8b2e;
"use strict";
$8a6f31f656bb2499$export$1e511d4a378977f5 = true;
$8a6f31f656bb2499$export$64fff40e709e8b2e = void 0;

var $8a6f31f656bb2499$var$_react = $8a6f31f656bb2499$var$_interopRequireWildcard((parcelRequire("2xPiy")));



var $02dbbe574ae49729$export$1e511d4a378977f5;
var $02dbbe574ae49729$export$4962ab15dba8ac7;
"use strict";
$02dbbe574ae49729$export$1e511d4a378977f5 = true;
$02dbbe574ae49729$export$4962ab15dba8ac7 = void 0;

var $02dbbe574ae49729$var$_propTypes = $02dbbe574ae49729$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $02dbbe574ae49729$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $02dbbe574ae49729$var$_extends() {
    return $02dbbe574ae49729$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $02dbbe574ae49729$var$_extends.apply(null, arguments);
}
var $02dbbe574ae49729$var$PropType = {};
$02dbbe574ae49729$var$PropType = $02dbbe574ae49729$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    disabled: $02dbbe574ae49729$var$_propTypes["default"].bool,
    dropAlign: $02dbbe574ae49729$var$_propTypes["default"].shape({
        top: $02dbbe574ae49729$var$_propTypes["default"].oneOf([
            'top',
            'bottom'
        ]),
        bottom: $02dbbe574ae49729$var$_propTypes["default"].oneOf([
            'top',
            'bottom'
        ]),
        right: $02dbbe574ae49729$var$_propTypes["default"].oneOf([
            'left',
            'right'
        ]),
        left: $02dbbe574ae49729$var$_propTypes["default"].oneOf([
            'left',
            'right'
        ])
    }),
    dropContent: $02dbbe574ae49729$var$_propTypes["default"].element.isRequired,
    dropTarget: $02dbbe574ae49729$var$_propTypes["default"].object,
    dropProps: $02dbbe574ae49729$var$_propTypes["default"].object,
    onClose: $02dbbe574ae49729$var$_propTypes["default"].func,
    onOpen: $02dbbe574ae49729$var$_propTypes["default"].func,
    open: $02dbbe574ae49729$var$_propTypes["default"].bool
});
var $02dbbe574ae49729$var$DropButtonPropTypes = $02dbbe574ae49729$export$4962ab15dba8ac7 = $02dbbe574ae49729$var$PropType;


var $8a6f31f656bb2499$var$_excluded = [
    "a11yTitle",
    "onAlign",
    "disabled",
    "dropAlign",
    "dropProps",
    "dropContent",
    "dropTarget",
    "id",
    "open",
    "onClick",
    "onClose",
    "onOpen"
];
function $8a6f31f656bb2499$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($8a6f31f656bb2499$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $8a6f31f656bb2499$var$_extends() {
    return $8a6f31f656bb2499$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8a6f31f656bb2499$var$_extends.apply(null, arguments);
}
function $8a6f31f656bb2499$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $8a6f31f656bb2499$var$defaultDropAlign = {
    top: 'top',
    left: 'left'
};
var $8a6f31f656bb2499$var$DropButton = $8a6f31f656bb2499$export$64fff40e709e8b2e = /*#__PURE__*/ (0, $8a6f31f656bb2499$var$_react.forwardRef)(function(_ref, ref) {
    var _ref$a11yTitle = _ref.a11yTitle, a11yTitle = _ref$a11yTitle === void 0 ? 'Open Drop' : _ref$a11yTitle, onAlign = _ref.onAlign, disabled = _ref.disabled, _ref$dropAlign = _ref.dropAlign, dropAlign = _ref$dropAlign === void 0 ? $8a6f31f656bb2499$var$defaultDropAlign : _ref$dropAlign, dropProps = _ref.dropProps, dropContent = _ref.dropContent, dropTarget = _ref.dropTarget, id = _ref.id, open = _ref.open, onClick = _ref.onClick, onClose = _ref.onClose, onOpen = _ref.onOpen, rest = $8a6f31f656bb2499$var$_objectWithoutPropertiesLoose(_ref, $8a6f31f656bb2499$var$_excluded);
    var buttonRef = (0, $4113023f9e0bafa0$exports.useForwardedRef)(ref);
    var _useState = (0, $8a6f31f656bb2499$var$_react.useState)(), show = _useState[0], setShow = _useState[1];
    (0, $8a6f31f656bb2499$var$_react.useEffect)(function() {
        if (open !== undefined && open !== show) setShow(open);
    }, [
        open,
        show
    ]);
    var onDropClose = (0, $8a6f31f656bb2499$var$_react.useCallback)(function(event) {
        // if the user has clicked on our Button, don't do anything here,
        // handle that in onClickInternal() below.
        var node = event.composed && event.composedPath()[0] || event.target;
        while(node && node !== document && !(node instanceof ShadowRoot) && node !== buttonRef.current)node = node.parentNode;
        if (node !== buttonRef.current) {
            // don't change internal state if caller is driving
            if (open === undefined) setShow(false);
            if (onClose) onClose(event);
        }
    }, [
        buttonRef,
        onClose,
        open
    ]);
    var onClickInternal = (0, $8a6f31f656bb2499$var$_react.useCallback)(function(event) {
        if (!show) {
            setShow(true);
            if (onOpen) onOpen(event);
        } else {
            setShow(false);
            if (onClose) onClose(event);
        }
        if (onClick) onClick(event);
    }, [
        onClick,
        onClose,
        onOpen,
        show
    ]);
    return /*#__PURE__*/ $8a6f31f656bb2499$var$_react["default"].createElement($8a6f31f656bb2499$var$_react["default"].Fragment, null, /*#__PURE__*/ $8a6f31f656bb2499$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, $8a6f31f656bb2499$var$_extends({
        id: id,
        ref: buttonRef,
        a11yTitle: a11yTitle,
        disabled: disabled
    }, rest, {
        onClick: onClickInternal
    })), show && buttonRef.current && /*#__PURE__*/ $8a6f31f656bb2499$var$_react["default"].createElement($9097252a6690f3a9$export$aaa698cd7aa517d6, $8a6f31f656bb2499$var$_extends({
        id: id ? id + "__drop" : undefined,
        onAlign: onAlign,
        restrictFocus: true,
        align: dropAlign,
        target: dropTarget || buttonRef,
        onClickOutside: onDropClose,
        onEsc: onDropClose
    }, dropProps), dropContent));
});
$8a6f31f656bb2499$var$DropButton.displayName = 'DropButton';
$8a6f31f656bb2499$var$DropButton.propTypes = $02dbbe574ae49729$export$4962ab15dba8ac7;


$d7e2a556593dc38b$export$64fff40e709e8b2e = $8a6f31f656bb2499$export$64fff40e709e8b2e;




function $c0f2e05c3c6f54d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $c0f2e05c3c6f54d3$var$StyledContainer = $c0f2e05c3c6f54d3$export$1d41361302b577a1 = (0, $c0f2e05c3c6f54d3$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "StyledSelect__StyledContainer",
    componentId: "sc-znp66n-0"
})([
    "@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){width:100%;}",
    ";",
    ";"
], function(props) {
    return props.dropHeight ? (0, $4113023f9e0bafa0$exports.sizeStyle)('max-height', props.dropHeight, props.theme) : 'max-height: inherit;';
}, function(props) {
    return props.theme.select.container && props.theme.select.container.extend;
});
// position relative is so scroll can be managed correctly
var $c0f2e05c3c6f54d3$var$OptionsContainer = $c0f2e05c3c6f54d3$export$1a780bb4ae54ddec = $c0f2e05c3c6f54d3$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledSelect__OptionsContainer",
    componentId: "sc-znp66n-1"
})([
    "position:relative;scroll-behavior:smooth;overflow:auto;outline:none;",
    ";"
], function(props) {
    if (props.selectMultiple) return props.theme.selectMultiple.listbox && props.theme.selectMultiple.listbox.extend;
    return props.theme.select.listbox && props.theme.select.listbox.extend;
});
var $c0f2e05c3c6f54d3$var$HiddenInput = $c0f2e05c3c6f54d3$export$7196851310a3d0bf = $c0f2e05c3c6f54d3$var$_styledComponents["default"].input.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledSelect__HiddenInput",
    componentId: "sc-znp66n-2"
})([
    "display:none;"
]);
var $c0f2e05c3c6f54d3$var$SelectOption = $c0f2e05c3c6f54d3$export$11a8a1ea41bf55d8 = (0, $c0f2e05c3c6f54d3$var$_styledComponents["default"])($fb68f765668b25d0$export$353f5b6fc5456de1).withConfig({
    displayName: "StyledSelect__SelectOption",
    componentId: "sc-znp66n-3"
})([
    "",
    " ",
    " &:focus{",
    "}display:block;width:100%;",
    ";"
], function(props) {
    return props.selected && props.textComponent && $4113023f9e0bafa0$exports.selectedStyle;
}, function(props) {
    return props.active && (0, $4113023f9e0bafa0$exports.getHoverIndicatorStyle)(!props.children && !props.theme.select.options ? undefined : 'background', props.theme);
}, function(props) {
    return props.active && (0, $4113023f9e0bafa0$exports.getHoverIndicatorStyle)(!props.children && !props.theme.select.options ? undefined : 'background', props.theme);
}, function(props) {
    return props["aria-disabled"] && "cursor: default";
});
var $c0f2e05c3c6f54d3$var$SelectTextInput = $c0f2e05c3c6f54d3$export$b34b5c37a9633c78 = (0, $c0f2e05c3c6f54d3$var$_styledComponents["default"])($99c7a15bc083da62$export$c86715117507e8e5).withConfig({
    displayName: "StyledSelect__SelectTextInput",
    componentId: "sc-znp66n-4"
})([
    "cursor:",
    ";"
], function(props) {
    return props.defaultCursor ? 'default' : 'pointer';
});
var $c0f2e05c3c6f54d3$var$StyledSelectDropButton = $c0f2e05c3c6f54d3$export$923536af422910c8 = (0, $c0f2e05c3c6f54d3$var$_styledComponents["default"])($d7e2a556593dc38b$export$64fff40e709e8b2e).withConfig({
    displayName: "StyledSelect__StyledSelectDropButton",
    componentId: "sc-znp66n-5"
})([
    "",
    ";",
    ";",
    ";"
], function(props) {
    return !props.plainSelect && $4113023f9e0bafa0$exports.controlBorderStyle;
}, function(props) {
    var _props$theme$select;
    return (_props$theme$select = props.theme.select) == null || (_props$theme$select = _props$theme$select.control) == null ? void 0 : _props$theme$select.extend;
}, function(props) {
    var _props$theme$select2;
    return props.open && ((_props$theme$select2 = props.theme.select) == null || (_props$theme$select2 = _props$theme$select2.control) == null ? void 0 : _props$theme$select2.open);
});


var $a1aed72b35405d54$export$1e511d4a378977f5;
var $a1aed72b35405d54$export$c763bb7a184a0f11;
var $a1aed72b35405d54$export$abfa4f6a3fb2b741;
var $a1aed72b35405d54$export$6f8d7bb3dad10aa1;
var $a1aed72b35405d54$export$ea6782b1ec892245;
var $a1aed72b35405d54$export$40be908210c5a79c;
var $a1aed72b35405d54$export$dac6ace3020563ca;
var $a1aed72b35405d54$export$2921b90f3ed1b63a;
var $a1aed72b35405d54$export$49df40d5c24cf7e3;
var $a1aed72b35405d54$export$bb417e0702eb86b5;
var $a1aed72b35405d54$export$7e4915d842d2c2e;
var $a1aed72b35405d54$export$fe7dc70cd4404dea;
var $a1aed72b35405d54$export$922aead9cd650d86;
var $a1aed72b35405d54$export$22012a5c726bef55;
var $a1aed72b35405d54$export$f9e47df77939ed56;
"use strict";
$a1aed72b35405d54$export$1e511d4a378977f5 = true;
$a1aed72b35405d54$export$c763bb7a184a0f11 = $a1aed72b35405d54$export$abfa4f6a3fb2b741 = $a1aed72b35405d54$export$6f8d7bb3dad10aa1 = $a1aed72b35405d54$export$ea6782b1ec892245 = $a1aed72b35405d54$export$40be908210c5a79c = $a1aed72b35405d54$export$dac6ace3020563ca = $a1aed72b35405d54$export$2921b90f3ed1b63a = $a1aed72b35405d54$export$49df40d5c24cf7e3 = $a1aed72b35405d54$export$bb417e0702eb86b5 = $a1aed72b35405d54$export$7e4915d842d2c2e = $a1aed72b35405d54$export$fe7dc70cd4404dea = $a1aed72b35405d54$export$922aead9cd650d86 = $a1aed72b35405d54$export$22012a5c726bef55 = $a1aed72b35405d54$export$f9e47df77939ed56 = void 0;

var $a1aed72b35405d54$var$_react = $a1aed72b35405d54$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a1aed72b35405d54$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($a1aed72b35405d54$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $a1aed72b35405d54$var$_applyKey = $a1aed72b35405d54$export$f9e47df77939ed56 = function applyKey(option, key) {
    if (/*#__PURE__*/ (0, $a1aed72b35405d54$var$_react.isValidElement)(option)) return option;
    if (option === undefined || option === null) return undefined;
    if (typeof key === 'object') return $a1aed72b35405d54$var$_applyKey(option, key.key);
    if (typeof key === 'function') return key(option);
    if (key !== undefined && typeof option === 'object') return option[key];
    if (typeof option === 'object' && Object.keys(option).length > 0) return option[Object.keys(option)[0]];
    return option;
};
var $a1aed72b35405d54$var$getOptionLabel = $a1aed72b35405d54$export$dac6ace3020563ca = function getOptionLabel(index, options, labelKey) {
    return $a1aed72b35405d54$var$_applyKey(options[index], labelKey);
};
var $a1aed72b35405d54$var$getOptionValue = $a1aed72b35405d54$export$40be908210c5a79c = function getOptionValue(index, options, valueKey) {
    return $a1aed72b35405d54$var$_applyKey(options[index], valueKey);
};
var $a1aed72b35405d54$var$getOptionIndex = $a1aed72b35405d54$export$2921b90f3ed1b63a = function getOptionIndex(options, i, valueKey) {
    if (options) {
        if (typeof i === 'object') return options.findIndex(function(x) {
            return $a1aed72b35405d54$var$_applyKey(x, valueKey) === $a1aed72b35405d54$var$_applyKey(i, valueKey);
        });
        return options.indexOf(i);
    }
    return undefined;
};
var $a1aed72b35405d54$var$arrayIncludes = $a1aed72b35405d54$export$22012a5c726bef55 = function arrayIncludes(arr, i, valueKey) {
    if (arr) {
        if (typeof i === 'object') return arr.some(function(x) {
            return $a1aed72b35405d54$var$_applyKey(x, valueKey) === $a1aed72b35405d54$var$_applyKey(i, valueKey);
        });
        return arr.includes(i);
    }
    return undefined;
};
var $a1aed72b35405d54$var$useDisabled = $a1aed72b35405d54$export$c763bb7a184a0f11 = function useDisabled(disabled, disabledKey, options, valueKey) {
    return (0, $a1aed72b35405d54$var$_react.useCallback)(function(index) {
        var option = options[index];
        var result;
        if (disabledKey) result = $a1aed72b35405d54$var$_applyKey(option, disabledKey);
        else if (Array.isArray(disabled)) {
            if (typeof disabled[0] === 'number') result = disabled.indexOf(index) !== -1;
            else {
                var optionVal = $a1aed72b35405d54$var$getOptionValue(index, options, valueKey);
                result = $a1aed72b35405d54$var$getOptionIndex(disabled, options[index], valueKey) !== -1 || $a1aed72b35405d54$var$getOptionIndex(disabled, optionVal, valueKey) !== -1;
            }
        }
        return result;
    }, [
        disabled,
        disabledKey,
        options,
        valueKey
    ]);
};
var $a1aed72b35405d54$var$getNormalizedValue = $a1aed72b35405d54$export$49df40d5c24cf7e3 = function getNormalizedValue(value, valueKey) {
    if (Array.isArray(value)) return value.map(function(v) {
        return valueKey && valueKey.reduce ? v : $a1aed72b35405d54$var$_applyKey(v, valueKey);
    });
    return valueKey && valueKey.reduce ? value : $a1aed72b35405d54$var$_applyKey(value, valueKey);
};
var $a1aed72b35405d54$var$changeEvent = $a1aed72b35405d54$export$922aead9cd650d86 = function changeEvent(inputRef, nextValue) {
    // Calling set value function directly on input because React library
    // overrides setter `event.target.value =` and loses original event
    // target fidelity.
    // https://stackoverflow.com/a/46012210
    var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    nativeInputValueSetter.call(inputRef.current, nextValue);
    var event = new Event('input', {
        bubbles: true
    });
    inputRef.current.dispatchEvent(event);
};
var $a1aed72b35405d54$var$getSelectIcon = $a1aed72b35405d54$export$ea6782b1ec892245 = function getSelectIcon(icon, theme, open) {
    var SelectIcon;
    switch(icon){
        case false:
            break;
        case true:
        case undefined:
            SelectIcon = open && theme.select.icons.up ? theme.select.icons.up : theme.select.icons.down;
            break;
        default:
            SelectIcon = icon;
    }
    return SelectIcon;
};
// if labelKey is a function and valueLabel is not defined
// we should use the labelKey function to display the
// selected value
var $a1aed72b35405d54$var$getDisplayLabelKey = $a1aed72b35405d54$export$7e4915d842d2c2e = function getDisplayLabelKey(labelKey, allOptions, optionIndexesInValue, selectValue) {
    var optionLabelKey = $a1aed72b35405d54$var$_applyKey(allOptions[optionIndexesInValue[0]], labelKey);
    if (!selectValue && optionIndexesInValue.length === 1 && typeof optionLabelKey === 'object') return optionLabelKey;
    return undefined;
};
var $a1aed72b35405d54$var$getIconColor = $a1aed72b35405d54$export$bb417e0702eb86b5 = function getIconColor(theme) {
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(theme.select.icons.color || 'control', theme);
};
var $a1aed72b35405d54$var$_formatValueForA11y = $a1aed72b35405d54$export$fe7dc70cd4404dea = function formatValueForA11y(value, labelKey) {
    if (typeof value === 'string') return value;
    if (/*#__PURE__*/ (0, $a1aed72b35405d54$var$_react.isValidElement)(value)) return value.toString();
    if (Array.isArray(value)) return value.map(function(item) {
        return $a1aed72b35405d54$var$_formatValueForA11y(item, labelKey);
    }).join(', ');
    return $a1aed72b35405d54$var$_applyKey(value, labelKey);
};
// In react 18 and below the inert attribute is not supported
// so we use an empty string instead of true. In react 19 and above
// inert is supported so we should use true. The use function is
// used to determine the react version because it is only available
// in react 19 and above.
var $a1aed72b35405d54$var$inertTrueValue = $a1aed72b35405d54$export$6f8d7bb3dad10aa1 = $a1aed72b35405d54$var$_react["default"].use ? true : '';
// Grommet manipulates the provided id by appending "__input" for
// the id places on the DOM input. In order to properly associate
// form label htmlFor with select input, we handle appending this
// to htmlFor for internal components like DataSort and DataFilter.
// Caller is responsible for appending this on their Select or
// SelectMultiple instances.
var $a1aed72b35405d54$var$selectInputId = $a1aed72b35405d54$export$abfa4f6a3fb2b741 = function selectInputId(id) {
    return id + "__input";
};


var $f95174500a869a04$export$1e511d4a378977f5;
var $f95174500a869a04$export$e87a5b03dc8a6193;
"use strict";
$f95174500a869a04$export$1e511d4a378977f5 = true;
$f95174500a869a04$export$e87a5b03dc8a6193 = void 0;

var $f95174500a869a04$var$_react = $f95174500a869a04$var$_interopRequireDefault((parcelRequire("2xPiy")));


function $f95174500a869a04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $f95174500a869a04$var$_extends() {
    return $f95174500a869a04$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f95174500a869a04$var$_extends.apply(null, arguments);
}
var $f95174500a869a04$var$EmptySearchOption = $f95174500a869a04$export$e87a5b03dc8a6193 = function EmptySearchOption(_ref) {
    var _theme$select, _theme$select2, _theme$select3;
    var emptySearchMessage = _ref.emptySearchMessage, selectOptionsStyle = _ref.selectOptionsStyle, theme = _ref.theme;
    return /*#__PURE__*/ $f95174500a869a04$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, (theme == null || (_theme$select = theme.select) == null || (_theme$select = _theme$select.emptySearchMessage) == null ? void 0 : _theme$select.container) || selectOptionsStyle, /*#__PURE__*/ $f95174500a869a04$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, $f95174500a869a04$var$_extends({
        "aria-live": "polite",
        role: "alert"
    }, (theme == null || (_theme$select2 = theme.select) == null || (_theme$select2 = _theme$select2.emptySearchMessage) == null ? void 0 : _theme$select2.text) || ((_theme$select3 = theme.select) == null || (_theme$select3 = _theme$select3.options) == null ? void 0 : _theme$select3.text)), emptySearchMessage));
};



var $07138d450b6c9297$var$_excluded = [
    "clear",
    "onClear",
    "name",
    "theme"
];
function $07138d450b6c9297$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $07138d450b6c9297$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($07138d450b6c9297$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $07138d450b6c9297$var$_extends() {
    return $07138d450b6c9297$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $07138d450b6c9297$var$_extends.apply(null, arguments);
}
function $07138d450b6c9297$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// ensure ClearButton receives visual indication of keyboard
var $07138d450b6c9297$var$StyledButton = (0, $07138d450b6c9297$var$_styledComponents["default"])($fb68f765668b25d0$export$353f5b6fc5456de1).withConfig({
    displayName: "SelectContainer__StyledButton",
    componentId: "sc-1wi0ul8-0"
})([
    "&:focus{",
    "}"
], function(props) {
    return (0, $4113023f9e0bafa0$exports.getHoverIndicatorStyle)('background', props.theme);
});
var $07138d450b6c9297$var$ClearButton = /*#__PURE__*/ (0, $07138d450b6c9297$var$_react.forwardRef)(function(_ref, ref) {
    var _theme$select$clear, _theme$select$clear2, _theme$select$clear3;
    var clear = _ref.clear, onClear = _ref.onClear, name = _ref.name, theme = _ref.theme, rest = $07138d450b6c9297$var$_objectWithoutPropertiesLoose(_ref, $07138d450b6c9297$var$_excluded);
    var label = clear.label, position = clear.position;
    var align = position !== 'bottom' ? 'start' : 'center';
    var buttonLabel = label || "Clear " + (name || 'selection');
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var buttonKind = (_theme$select$clear = theme.select.clear) == null ? void 0 : _theme$select$clear.button;
    var containerProps = ((_theme$select$clear2 = theme.select.clear) == null ? void 0 : _theme$select$clear2.container) || {};
    var textProps = ((_theme$select$clear3 = theme.select.clear) == null ? void 0 : _theme$select$clear3.text) || {};
    var buttonProps = $07138d450b6c9297$var$_extends({
        a11yTitle: buttonLabel + ". Or, press " + (position === 'bottom' ? 'shift tab' : 'down arrow') + " to move to select options",
        align: align,
        fill: 'horizontal',
        onClick: onClear,
        ref: ref
    }, passThemeFlag, rest);
    if (buttonKind) // new structure when `theme.select.clear.button` is defined
    return /*#__PURE__*/ $07138d450b6c9297$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $07138d450b6c9297$var$_extends({
        flex: "grow"
    }, containerProps), /*#__PURE__*/ $07138d450b6c9297$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, $07138d450b6c9297$var$_extends({
        kind: buttonKind,
        label: textProps ? /*#__PURE__*/ $07138d450b6c9297$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, textProps, buttonLabel) : buttonLabel
    }, buttonProps)));
    // default structure when `theme.select.clear.button` is not defined
    return /*#__PURE__*/ $07138d450b6c9297$var$_react["default"].createElement($07138d450b6c9297$var$StyledButton, $07138d450b6c9297$var$_extends({
        focusIndicator: false,
        plain: true
    }, buttonProps), function(_ref2) {
        var _theme$select$clear4;
        var hover = _ref2.hover;
        var boxProps = $07138d450b6c9297$var$_extends({}, theme.select.clear.container);
        delete boxProps.hover; // avoid passing hover object to Box
        return /*#__PURE__*/ $07138d450b6c9297$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $07138d450b6c9297$var$_extends({}, boxProps, hover ? (_theme$select$clear4 = theme.select.clear) == null || (_theme$select$clear4 = _theme$select$clear4.container) == null ? void 0 : _theme$select$clear4.hover : {}, {
            align: align
        }), /*#__PURE__*/ $07138d450b6c9297$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, theme.select.clear.text, buttonLabel));
    });
});
var $07138d450b6c9297$var$SelectContainer = $07138d450b6c9297$export$446eebadefe1123b = /*#__PURE__*/ (0, $07138d450b6c9297$var$_react.forwardRef)(function(_ref3, ref) {
    var _theme$select$icons, _theme$select;
    var clear = _ref3.clear, _ref3$children = _ref3.children, children = _ref3$children === void 0 ? null : _ref3$children, disabled = _ref3.disabled, disabledKey = _ref3.disabledKey, dropHeight = _ref3.dropHeight, _ref3$emptySearchMess = _ref3.emptySearchMessage, emptySearchMessage = _ref3$emptySearchMess === void 0 ? 'No matches found' : _ref3$emptySearchMess, id = _ref3.id, labelKey = _ref3.labelKey, messages = _ref3.messages, multiple = _ref3.multiple, name = _ref3.name, onChange = _ref3.onChange, onKeyDown = _ref3.onKeyDown, onMore = _ref3.onMore, onSearch = _ref3.onSearch, optionIndexesInValue = _ref3.optionIndexesInValue, options = _ref3.options, allOptions = _ref3.allOptions, searchPlaceholder = _ref3.searchPlaceholder, search = _ref3.search, setSearch = _ref3.setSearch, selected = _ref3.selected, usingKeyboard = _ref3.usingKeyboard, _ref3$value = _ref3.value, value = _ref3$value === void 0 ? '' : _ref3$value, valueKey = _ref3.valueKey, _ref3$replace = _ref3.replace, replace = _ref3$replace === void 0 ? true : _ref3$replace;
    var _useThemeValue2 = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue2.theme, passThemeFlag = _useThemeValue2.passThemeFlag;
    var shouldShowClearButton = (0, $07138d450b6c9297$var$_react.useCallback)(function(position) {
        var hasValue = Boolean(multiple && value ? value.length : value);
        var showAtPosition = position === 'bottom' ? (clear == null ? void 0 : clear.position) === 'bottom' : (clear == null ? void 0 : clear.position) !== 'bottom';
        return clear && hasValue && showAtPosition;
    }, [
        clear,
        multiple,
        value
    ]);
    var isDisabled = (0, $a1aed72b35405d54$export$c763bb7a184a0f11)(disabled, disabledKey, options, valueKey || labelKey);
    var _useState = (0, $07138d450b6c9297$var$_react.useState)(usingKeyboard && !shouldShowClearButton('top') && !onSearch ? 0 : -1), activeIndex = _useState[0], setActiveIndex = _useState[1];
    var _useState2 = (0, $07138d450b6c9297$var$_react.useState)(usingKeyboard), keyboardNavigation = _useState2[0], setKeyboardNavigation = _useState2[1];
    var searchRef = (0, $07138d450b6c9297$var$_react.useRef)();
    var optionsRef = (0, $07138d450b6c9297$var$_react.useRef)();
    var clearRef = (0, $07138d450b6c9297$var$_react.useRef)();
    var activeRef = (0, $07138d450b6c9297$var$_react.useRef)();
    var _useContext = (0, $07138d450b6c9297$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var searchIcon = ((_theme$select$icons = theme.select.icons) == null ? void 0 : _theme$select$icons.search) || /*#__PURE__*/ $07138d450b6c9297$var$_react["default"].createElement($ac084058cd06093e$export$4b85d3515bd863a5, {
        "aria-hidden": true
    });
    // for keyboard/screenreader, keep the active option in focus
    (0, $07138d450b6c9297$var$_react.useEffect)(function() {
        var _activeRef$current;
        if (activeIndex >= 0) (_activeRef$current = activeRef.current) == null || _activeRef$current.focus();
    }, [
        activeIndex
    ]);
    // set initial focus
    (0, $07138d450b6c9297$var$_react.useEffect)(function() {
        // need to wait for Drop to be ready
        var timer = setTimeout(function() {
            var optionsNode = optionsRef.current;
            var clearButton = clearRef.current;
            if (onSearch) {
                var searchInput = searchRef.current;
                if (searchInput && searchInput.focus && !activeRef.current) (0, $4113023f9e0bafa0$exports.setFocusWithoutScroll)(searchInput);
            } else if (clear && clearButton && clearButton.focus && clear.position !== 'bottom') (0, $4113023f9e0bafa0$exports.setFocusWithoutScroll)(clearButton);
            else if (usingKeyboard && activeRef.current) (0, $4113023f9e0bafa0$exports.setFocusWithoutScroll)(activeRef.current);
            else if (optionsNode) (0, $4113023f9e0bafa0$exports.setFocusWithoutScroll)(optionsNode);
        }, 100);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        onSearch,
        usingKeyboard,
        clear
    ]);
    var isSelected = (0, $07138d450b6c9297$var$_react.useCallback)(function(index) {
        var result;
        if (selected) // deprecated in favor of value
        result = selected.indexOf(index) !== -1;
        else {
            var optionVal = (0, $a1aed72b35405d54$export$40be908210c5a79c)(index, options, valueKey);
            if (Array.isArray(value)) {
                if (value.length === 0) result = false;
                else if (typeof value[0] !== 'object') result = value.indexOf(optionVal) !== -1;
                else if (valueKey) result = value.some(function(valueItem) {
                    var valueValue = typeof valueKey === 'function' ? valueKey(valueItem) : valueItem[valueKey] || valueItem[valueKey.key];
                    return valueValue === optionVal;
                });
            } else if (valueKey && value !== null && typeof value === 'object') {
                var valueValue = typeof valueKey === 'function' ? valueKey(value) : value[valueKey];
                result = valueValue === optionVal;
            } else result = value === optionVal;
        }
        return result;
    }, [
        selected,
        value,
        valueKey,
        options
    ]);
    var selectOption = (0, $07138d450b6c9297$var$_react.useCallback)(function(index) {
        return function(event) {
            if (onChange) {
                var nextValue;
                var nextSelected;
                if (multiple) {
                    var nextOptionIndexesInValue = optionIndexesInValue.slice(0);
                    var allOptionsIndex = allOptions.indexOf(options[index]);
                    var valueIndex = optionIndexesInValue.indexOf(allOptionsIndex);
                    if (valueIndex === -1) nextOptionIndexesInValue.push(allOptionsIndex);
                    else nextOptionIndexesInValue.splice(valueIndex, 1);
                    nextValue = nextOptionIndexesInValue.map(function(i) {
                        return valueKey && valueKey.reduce ? (0, $a1aed72b35405d54$export$f9e47df77939ed56)(allOptions[i], valueKey) : allOptions[i];
                    });
                    nextSelected = nextOptionIndexesInValue;
                } else {
                    nextValue = valueKey && valueKey.reduce ? (0, $a1aed72b35405d54$export$f9e47df77939ed56)(options[index], valueKey) : options[index];
                    nextSelected = index;
                }
                onChange(event, {
                    option: options[index],
                    value: nextValue,
                    selected: nextSelected
                });
            }
        };
    }, [
        multiple,
        onChange,
        optionIndexesInValue,
        options,
        allOptions,
        valueKey
    ]);
    var onClear = (0, $07138d450b6c9297$var$_react.useCallback)(function(event) {
        onChange(event, {
            option: undefined,
            value: '',
            selected: ''
        });
    }, [
        onChange
    ]);
    var onNextOption = (0, $07138d450b6c9297$var$_react.useCallback)(function(event) {
        event.preventDefault();
        var nextActiveIndex = activeIndex + 1;
        while(nextActiveIndex < options.length && isDisabled(nextActiveIndex))nextActiveIndex += 1;
        if (nextActiveIndex !== options.length) {
            setActiveIndex(nextActiveIndex);
            setKeyboardNavigation(true);
        }
    }, [
        activeIndex,
        options,
        isDisabled
    ]);
    var onPreviousOption = (0, $07138d450b6c9297$var$_react.useCallback)(function(event) {
        event.preventDefault();
        var nextActiveIndex = activeIndex - 1;
        if (nextActiveIndex === -1) {
            var searchInput = searchRef.current;
            var clearButton = clearRef.current;
            if (clearButton && clearButton.focus && shouldShowClearButton('top')) {
                setActiveIndex(nextActiveIndex);
                (0, $4113023f9e0bafa0$exports.setFocusWithoutScroll)(clearButton);
            } else if (searchInput && searchInput.focus) {
                setActiveIndex(nextActiveIndex);
                (0, $4113023f9e0bafa0$exports.setFocusWithoutScroll)(searchInput);
            }
        }
        while(nextActiveIndex >= 0 && isDisabled(nextActiveIndex))nextActiveIndex -= 1;
        if (nextActiveIndex >= 0) {
            setActiveIndex(nextActiveIndex);
            setKeyboardNavigation(true);
        }
    }, [
        activeIndex,
        isDisabled,
        shouldShowClearButton
    ]);
    var onKeyDownOption = (0, $07138d450b6c9297$var$_react.useCallback)(function(event) {
        if (!onSearch) {
            var nextActiveIndex = options.findIndex(function(e, index) {
                var label;
                if (typeof e === 'object') label = e.label || (0, $a1aed72b35405d54$export$f9e47df77939ed56)(e, labelKey);
                else label = e;
                return typeof label === 'string' && label.charAt(0).toLowerCase() === event.key.toLowerCase() && !isDisabled(index);
            });
            if (nextActiveIndex >= 0) {
                event.preventDefault();
                setActiveIndex(nextActiveIndex);
                setKeyboardNavigation(true);
            }
        }
        if (onKeyDown) onKeyDown(event);
    }, [
        isDisabled,
        labelKey,
        onKeyDown,
        options,
        onSearch
    ]);
    var onActiveOption = (0, $07138d450b6c9297$var$_react.useCallback)(function(index) {
        return function() {
            if (!keyboardNavigation) setActiveIndex(index);
        };
    }, [
        keyboardNavigation
    ]);
    var onSelectOption = (0, $07138d450b6c9297$var$_react.useCallback)(function(event) {
        if ((shouldShowClearButton('bottom') || shouldShowClearButton('top')) && (0, $4113023f9e0bafa0$exports.containsFocus)(clearRef.current)) onChange(event, {
            option: undefined,
            value: '',
            selected: ''
        });
        else if (activeIndex >= 0 && activeIndex < options.length) {
            event.preventDefault(); // prevent submitting forms
            selectOption(activeIndex)(event);
        }
    }, [
        activeIndex,
        selectOption,
        options,
        onChange,
        shouldShowClearButton
    ]);
    var customSearchInput = theme.select.searchInput;
    var SelectTextInput = customSearchInput || $99c7a15bc083da62$export$c86715117507e8e5;
    var selectOptionsStyle = theme.select.options ? $07138d450b6c9297$var$_extends({}, theme.select.options.box, theme.select.options.container) : {};
    return /*#__PURE__*/ $07138d450b6c9297$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onEnter: onSelectOption,
        onSpace: onSelectOption,
        onUp: onPreviousOption,
        onDown: onNextOption,
        onKeyDown: onKeyDownOption
    }, /*#__PURE__*/ $07138d450b6c9297$var$_react["default"].createElement($c0f2e05c3c6f54d3$export$1d41361302b577a1, $07138d450b6c9297$var$_extends({
        ref: ref,
        id: id ? id + "__select-drop" : undefined,
        dropHeight: dropHeight
    }, passThemeFlag), onSearch && /*#__PURE__*/ $07138d450b6c9297$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        pad: !customSearchInput ? (_theme$select = theme.select) == null || (_theme$select = _theme$select.search) == null ? void 0 : _theme$select.pad : undefined,
        flex: false
    }, /*#__PURE__*/ $07138d450b6c9297$var$_react["default"].createElement(SelectTextInput, {
        "aria-label": format({
            id: 'select.searchA11y',
            messages: messages
        }),
        focusIndicator: !customSearchInput,
        size: "small",
        ref: searchRef,
        type: "search",
        value: search || '',
        placeholder: searchPlaceholder,
        onChange: function onChange(event) {
            var nextSearch = event.target.value;
            setSearch(nextSearch);
            setActiveIndex(-1);
            onSearch(nextSearch);
        },
        onFocus: function onFocus() {
            return setActiveIndex(-1);
        },
        icon: searchIcon
    })), shouldShowClearButton('top') && /*#__PURE__*/ $07138d450b6c9297$var$_react["default"].createElement($07138d450b6c9297$var$ClearButton, {
        ref: clearRef,
        clear: clear,
        name: name,
        onClear: onClear,
        onFocus: function onFocus() {
            return setActiveIndex(-1);
        },
        onMouseOver: function onMouseOver() {
            return setActiveIndex(-1);
        },
        theme: theme
    }), options.length > 0 ? /*#__PURE__*/ $07138d450b6c9297$var$_react["default"].createElement($c0f2e05c3c6f54d3$export$1a780bb4ae54ddec, {
        "aria-label": format({
            id: 'select.optionsA11y',
            messages: messages
        }),
        role: "listbox",
        tabIndex: "-1",
        ref: optionsRef,
        "aria-multiselectable": multiple,
        onMouseMove: function onMouseMove() {
            return setKeyboardNavigation(false);
        }
    }, /*#__PURE__*/ $07138d450b6c9297$var$_react["default"].createElement($41010700ddcbac64$export$c5295390d6167a3e, {
        items: options,
        step: theme.select.step,
        onMore: onMore,
        replace: replace,
        show: activeIndex !== -1 ? activeIndex : undefined
    }, function(option, index, optionRef) {
        var optionDisabled = isDisabled(index);
        var optionSelected = isSelected(index);
        var optionActive = activeIndex === index;
        // Determine whether the label is done as a child or
        // as an option Button kind property.
        var child;
        var textComponent = false;
        if (children) {
            child = children(option, index, options, {
                active: optionActive,
                disabled: optionDisabled,
                selected: optionSelected
            });
            if (typeof child === 'string' || child.props && child.props.children && typeof child.props.children === 'string') textComponent = true;
        } else if (theme.select.options) {
            child = /*#__PURE__*/ $07138d450b6c9297$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, selectOptionsStyle, /*#__PURE__*/ $07138d450b6c9297$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, theme.select.options.text, (0, $a1aed72b35405d54$export$dac6ace3020563ca)(index, options, labelKey)));
            textComponent = true;
        }
        // if we have a child, turn on plain, and hoverIndicator
        return /*#__PURE__*/ $07138d450b6c9297$var$_react["default"].createElement($c0f2e05c3c6f54d3$export$11a8a1ea41bf55d8, $07138d450b6c9297$var$_extends({
            key: index,
            ref: function ref(node) {
                // eslint-disable-next-line no-param-reassign
                if (optionRef) optionRef.current = node;
                if (optionActive) activeRef.current = node;
            },
            tabIndex: optionSelected || activeIndex === index || // when nothing is selected and entering listbox
            // first option should be focused
            (!value || Array.isArray(value) && value.length === 0) && activeIndex === -1 && index === 0 ? '0' : '-1',
            role: "option",
            "aria-setsize": options.length,
            "aria-posinset": index + 1,
            "aria-selected": optionSelected,
            "aria-disabled": optionDisabled || undefined,
            plain: !child ? undefined : true,
            align: "start",
            kind: !child ? 'option' : undefined,
            label: !child ? (0, $a1aed72b35405d54$export$dac6ace3020563ca)(index, options, labelKey || valueKey) : undefined,
            disabled: optionDisabled || undefined,
            active: optionActive,
            selected: optionSelected,
            onFocus: function onFocus() {
                return setActiveIndex(index);
            },
            onMouseOver: !optionDisabled ? onActiveOption(index) : undefined,
            onMouseOut: !optionDisabled ? onActiveOption(-1) : undefined,
            onClick: !optionDisabled ? selectOption(index) : undefined,
            textComponent: textComponent
        }, passThemeFlag), child);
    })) : /*#__PURE__*/ $07138d450b6c9297$var$_react["default"].createElement($f95174500a869a04$export$e87a5b03dc8a6193, {
        emptySearchMessage: emptySearchMessage,
        selectOptionsStyle: selectOptionsStyle,
        theme: theme
    }), shouldShowClearButton('bottom') && /*#__PURE__*/ $07138d450b6c9297$var$_react["default"].createElement($07138d450b6c9297$var$ClearButton, {
        ref: clearRef,
        clear: clear,
        name: name,
        onClear: onClear,
        onFocus: function onFocus() {
            return setActiveIndex(-1);
        },
        onMouseOver: function onMouseOver() {
            return setActiveIndex(-1);
        },
        theme: theme
    })));
});




var $2f5972626e30691d$export$1e511d4a378977f5;
var $2f5972626e30691d$export$2307ecc6c2fea308;
"use strict";
$2f5972626e30691d$export$1e511d4a378977f5 = true;
$2f5972626e30691d$export$2307ecc6c2fea308 = void 0;

var $2f5972626e30691d$var$_react = $2f5972626e30691d$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $2f5972626e30691d$var$_excluded = [
    "disabled",
    "id"
];
function $2f5972626e30691d$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($2f5972626e30691d$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $2f5972626e30691d$var$_extends() {
    return $2f5972626e30691d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2f5972626e30691d$var$_extends.apply(null, arguments);
}
function $2f5972626e30691d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $2f5972626e30691d$var$DefaultSelectTextInput = $2f5972626e30691d$export$2307ecc6c2fea308 = /*#__PURE__*/ (0, $2f5972626e30691d$var$_react.forwardRef)(function(_ref, ref) {
    var disabled = _ref.disabled, id = _ref.id, rest = $2f5972626e30691d$var$_objectWithoutPropertiesLoose(_ref, $2f5972626e30691d$var$_excluded);
    return /*#__PURE__*/ $2f5972626e30691d$var$_react["default"].createElement($c0f2e05c3c6f54d3$export$b34b5c37a9633c78, $2f5972626e30691d$var$_extends({
        defaultCursor: disabled === true || undefined,
        focusIndicator: false,
        id: id ? id + "__input" : undefined,
        ref: ref
    }, rest, {
        tabIndex: "-1",
        type: "text",
        plain: true,
        readOnly: true
    }));
});



var $b3898c3050a12e8b$export$1e511d4a378977f5;
var $b3898c3050a12e8b$export$257cf46788f4f52b;
var $b3898c3050a12e8b$export$e340aafd6bd05c16;
"use strict";
$b3898c3050a12e8b$export$1e511d4a378977f5 = true;
$b3898c3050a12e8b$export$257cf46788f4f52b = $b3898c3050a12e8b$export$e340aafd6bd05c16 = void 0;

var $b3898c3050a12e8b$var$_propTypes = $b3898c3050a12e8b$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $b3898c3050a12e8b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $b3898c3050a12e8b$var$_extends() {
    return $b3898c3050a12e8b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b3898c3050a12e8b$var$_extends.apply(null, arguments);
}
var $b3898c3050a12e8b$var$genericSelectProps = $b3898c3050a12e8b$export$257cf46788f4f52b = $b3898c3050a12e8b$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    children: $b3898c3050a12e8b$var$_propTypes["default"].func,
    disabled: $b3898c3050a12e8b$var$_propTypes["default"].oneOfType([
        $b3898c3050a12e8b$var$_propTypes["default"].bool,
        $b3898c3050a12e8b$var$_propTypes["default"].arrayOf($b3898c3050a12e8b$var$_propTypes["default"].oneOfType([
            $b3898c3050a12e8b$var$_propTypes["default"].number,
            $b3898c3050a12e8b$var$_propTypes["default"].string,
            $b3898c3050a12e8b$var$_propTypes["default"].object
        ]))
    ]),
    disabledKey: $b3898c3050a12e8b$var$_propTypes["default"].oneOfType([
        $b3898c3050a12e8b$var$_propTypes["default"].string,
        $b3898c3050a12e8b$var$_propTypes["default"].func
    ]),
    dropAlign: $b3898c3050a12e8b$var$_propTypes["default"].shape({
        top: $b3898c3050a12e8b$var$_propTypes["default"].oneOf([
            'top',
            'bottom'
        ]),
        bottom: $b3898c3050a12e8b$var$_propTypes["default"].oneOf([
            'top',
            'bottom'
        ]),
        right: $b3898c3050a12e8b$var$_propTypes["default"].oneOf([
            'left',
            'right'
        ]),
        left: $b3898c3050a12e8b$var$_propTypes["default"].oneOf([
            'left',
            'right'
        ])
    }),
    dropHeight: $b3898c3050a12e8b$var$_propTypes["default"].oneOfType([
        $b3898c3050a12e8b$var$_propTypes["default"].oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        $b3898c3050a12e8b$var$_propTypes["default"].string
    ]),
    dropTarget: $b3898c3050a12e8b$var$_propTypes["default"].object,
    dropProps: $b3898c3050a12e8b$var$_propTypes["default"].object,
    emptySearchMessage: $b3898c3050a12e8b$var$_propTypes["default"].oneOfType([
        $b3898c3050a12e8b$var$_propTypes["default"].string,
        $b3898c3050a12e8b$var$_propTypes["default"].node
    ]),
    focusIndicator: $b3898c3050a12e8b$var$_propTypes["default"].bool,
    icon: $b3898c3050a12e8b$var$_propTypes["default"].oneOfType([
        $b3898c3050a12e8b$var$_propTypes["default"].bool,
        $b3898c3050a12e8b$var$_propTypes["default"].func,
        $b3898c3050a12e8b$var$_propTypes["default"].node,
        $b3898c3050a12e8b$var$_propTypes["default"].elementType
    ]),
    labelKey: $b3898c3050a12e8b$var$_propTypes["default"].oneOfType([
        $b3898c3050a12e8b$var$_propTypes["default"].string,
        $b3898c3050a12e8b$var$_propTypes["default"].func
    ]),
    messages: $b3898c3050a12e8b$var$_propTypes["default"].shape({
        optionsA11y: $b3898c3050a12e8b$var$_propTypes["default"].string,
        multiple: $b3898c3050a12e8b$var$_propTypes["default"].string,
        searchA11y: $b3898c3050a12e8b$var$_propTypes["default"].string,
        selected: $b3898c3050a12e8b$var$_propTypes["default"].string
    }),
    name: $b3898c3050a12e8b$var$_propTypes["default"].string,
    onChange: $b3898c3050a12e8b$var$_propTypes["default"].func,
    onClose: $b3898c3050a12e8b$var$_propTypes["default"].func,
    onOpen: $b3898c3050a12e8b$var$_propTypes["default"].func,
    onSearch: $b3898c3050a12e8b$var$_propTypes["default"].func,
    onMore: $b3898c3050a12e8b$var$_propTypes["default"].func,
    options: $b3898c3050a12e8b$var$_propTypes["default"].arrayOf($b3898c3050a12e8b$var$_propTypes["default"].oneOfType([
        $b3898c3050a12e8b$var$_propTypes["default"].string,
        $b3898c3050a12e8b$var$_propTypes["default"].number,
        $b3898c3050a12e8b$var$_propTypes["default"].bool,
        $b3898c3050a12e8b$var$_propTypes["default"].element,
        $b3898c3050a12e8b$var$_propTypes["default"].object
    ])).isRequired,
    open: $b3898c3050a12e8b$var$_propTypes["default"].bool,
    placeholder: $b3898c3050a12e8b$var$_propTypes["default"].oneOfType([
        $b3898c3050a12e8b$var$_propTypes["default"].string,
        $b3898c3050a12e8b$var$_propTypes["default"].element,
        $b3898c3050a12e8b$var$_propTypes["default"].node
    ]),
    plain: $b3898c3050a12e8b$var$_propTypes["default"].bool,
    replace: $b3898c3050a12e8b$var$_propTypes["default"].bool,
    searchPlaceholder: $b3898c3050a12e8b$var$_propTypes["default"].oneOfType([
        $b3898c3050a12e8b$var$_propTypes["default"].string,
        $b3898c3050a12e8b$var$_propTypes["default"].element,
        $b3898c3050a12e8b$var$_propTypes["default"].node
    ]),
    size: $b3898c3050a12e8b$var$_propTypes["default"].oneOfType([
        $b3898c3050a12e8b$var$_propTypes["default"].oneOf([
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        $b3898c3050a12e8b$var$_propTypes["default"].string
    ]),
    valueLabel: $b3898c3050a12e8b$var$_propTypes["default"].oneOfType([
        $b3898c3050a12e8b$var$_propTypes["default"].node,
        $b3898c3050a12e8b$var$_propTypes["default"].func
    ]),
    valueKey: $b3898c3050a12e8b$var$_propTypes["default"].oneOfType([
        $b3898c3050a12e8b$var$_propTypes["default"].string,
        $b3898c3050a12e8b$var$_propTypes["default"].func,
        $b3898c3050a12e8b$var$_propTypes["default"].shape({
            key: $b3898c3050a12e8b$var$_propTypes["default"].string,
            reduce: $b3898c3050a12e8b$var$_propTypes["default"].bool
        })
    ])
});
var $b3898c3050a12e8b$var$PropType = {};
$b3898c3050a12e8b$var$PropType = $b3898c3050a12e8b$var$_extends({}, $b3898c3050a12e8b$var$genericSelectProps, {
    clear: $b3898c3050a12e8b$var$_propTypes["default"].oneOfType([
        $b3898c3050a12e8b$var$_propTypes["default"].bool,
        $b3898c3050a12e8b$var$_propTypes["default"].shape({
            position: $b3898c3050a12e8b$var$_propTypes["default"].oneOf([
                'top',
                'bottom'
            ]),
            label: $b3898c3050a12e8b$var$_propTypes["default"].string
        })
    ]),
    closeOnChange: $b3898c3050a12e8b$var$_propTypes["default"].bool,
    defaultValue: $b3898c3050a12e8b$var$_propTypes["default"].oneOfType([
        $b3898c3050a12e8b$var$_propTypes["default"].string,
        $b3898c3050a12e8b$var$_propTypes["default"].object,
        $b3898c3050a12e8b$var$_propTypes["default"].number,
        $b3898c3050a12e8b$var$_propTypes["default"].arrayOf($b3898c3050a12e8b$var$_propTypes["default"].oneOfType([
            $b3898c3050a12e8b$var$_propTypes["default"].string,
            $b3898c3050a12e8b$var$_propTypes["default"].object,
            $b3898c3050a12e8b$var$_propTypes["default"].number
        ]))
    ]),
    multiple: $b3898c3050a12e8b$var$_propTypes["default"].bool,
    selected: $b3898c3050a12e8b$var$_propTypes["default"].oneOfType([
        $b3898c3050a12e8b$var$_propTypes["default"].number,
        $b3898c3050a12e8b$var$_propTypes["default"].arrayOf($b3898c3050a12e8b$var$_propTypes["default"].number)
    ]),
    value: $b3898c3050a12e8b$var$_propTypes["default"].oneOfType([
        $b3898c3050a12e8b$var$_propTypes["default"].string,
        $b3898c3050a12e8b$var$_propTypes["default"].element,
        // deprecated, use valueLabel
        $b3898c3050a12e8b$var$_propTypes["default"].object,
        $b3898c3050a12e8b$var$_propTypes["default"].number,
        $b3898c3050a12e8b$var$_propTypes["default"].arrayOf($b3898c3050a12e8b$var$_propTypes["default"].oneOfType([
            $b3898c3050a12e8b$var$_propTypes["default"].string,
            $b3898c3050a12e8b$var$_propTypes["default"].object,
            $b3898c3050a12e8b$var$_propTypes["default"].number
        ]))
    ])
});
var $b3898c3050a12e8b$var$SelectPropTypes = $b3898c3050a12e8b$export$e340aafd6bd05c16 = $b3898c3050a12e8b$var$PropType;



var $fee1c086737bcc76$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "aria-labelledby",
    "alignSelf",
    "children",
    "clear",
    "closeOnChange",
    "defaultValue",
    "disabled",
    "disabledKey",
    "dropAlign",
    "dropHeight",
    "dropProps",
    "dropTarget",
    "emptySearchMessage",
    "focusIndicator",
    "gridArea",
    "id",
    "icon",
    "labelKey",
    "margin",
    "messages",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onClose",
    "onFocus",
    "onKeyDown",
    "onMore",
    "onOpen",
    "onSearch",
    "open",
    "options",
    "placeholder",
    "plain",
    "replace",
    "searchPlaceholder",
    "selected",
    "size",
    "value",
    "valueKey",
    "valueLabel"
];
function $fee1c086737bcc76$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($fee1c086737bcc76$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $fee1c086737bcc76$var$_extends() {
    return $fee1c086737bcc76$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fee1c086737bcc76$var$_extends.apply(null, arguments);
}
function $fee1c086737bcc76$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $fee1c086737bcc76$var$defaultDropAlign = {
    top: 'bottom',
    left: 'left'
};
var $fee1c086737bcc76$var$Select = $fee1c086737bcc76$export$ef9b1a59e592288f = /*#__PURE__*/ (0, $fee1c086737bcc76$var$_react.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], ariaLabelledByProp = _ref['aria-labelledby'], alignSelf = _ref.alignSelf, children = _ref.children, _ref$clear = _ref.clear, clear = _ref$clear === void 0 ? false : _ref$clear, _ref$closeOnChange = _ref.closeOnChange, closeOnChange = _ref$closeOnChange === void 0 ? true : _ref$closeOnChange, defaultValue = _ref.defaultValue, disabled = _ref.disabled, disabledKey = _ref.disabledKey, _ref$dropAlign = _ref.dropAlign, dropAlign = _ref$dropAlign === void 0 ? $fee1c086737bcc76$var$defaultDropAlign : _ref$dropAlign, dropHeight = _ref.dropHeight, dropProps = _ref.dropProps, dropTarget = _ref.dropTarget, emptySearchMessage = _ref.emptySearchMessage, focusIndicator = _ref.focusIndicator, gridArea = _ref.gridArea, id = _ref.id, icon = _ref.icon, labelKeyProp = _ref.labelKey, margin = _ref.margin, messages = _ref.messages, multiple = _ref.multiple, name = _ref.name, onBlur = _ref.onBlur, onChange = _ref.onChange, onClick = _ref.onClick, onClose = _ref.onClose, onFocus = _ref.onFocus, onKeyDown = _ref.onKeyDown, onMore = _ref.onMore, onOpen = _ref.onOpen, onSearch = _ref.onSearch, propOpen = _ref.open, optionsProp = _ref.options, placeholder = _ref.placeholder, plain = _ref.plain, replace = _ref.replace, searchPlaceholder = _ref.searchPlaceholder, selected = _ref.selected, size = _ref.size, valueProp = _ref.value, valueKeyProp = _ref.valueKey, valueLabel = _ref.valueLabel, rest = $fee1c086737bcc76$var$_objectWithoutPropertiesLoose(_ref, $fee1c086737bcc76$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var inputRef = (0, $fee1c086737bcc76$var$_react.useRef)();
    var formContext = (0, $fee1c086737bcc76$var$_react.useContext)($5c9c2e034f522b3e$export$c24727297075ec6a);
    var _useContext = (0, $fee1c086737bcc76$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    // For greater resilience, use labelKey if valueKey isn't provided and
    // vice versa. https://github.com/grommet/grommet/pull/6299
    var valueKey = valueKeyProp || labelKeyProp;
    var labelKey = labelKeyProp || valueKeyProp;
    var formFieldData = formContext == null ? void 0 : formContext.useFormField({});
    // Determine if the Select is opened with the keyboard. If so,
    // focus should be set on the first option when the drop opens
    // see set initial focus code in SelectContainer.js
    var usingKeyboard = (0, $4113023f9e0bafa0$exports.useKeyboard)();
    // value is used for what we receive in valueProp and the basis for
    // what we send with onChange
    // When 'valueKey' sets 'reduce', the value(s) here should match
    // what the 'valueKey' would return for the corresponding
    // selected option object.
    // Otherwise, the value(s) should match the selected options.
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp,
        initialValue: defaultValue || ''
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    // normalizedValue is the value mapped with any valueKey applied
    // When the options array contains objects, this property indicates how
    // to retrieve the value of each option.
    // If a string is provided, it is used as the key to retrieve a
    // property of an option object.
    // If a function is provided, it is called with the option and should
    // return the value.
    // If reduce is true, this value will be used for the 'value'
    // delivered via 'onChange'.
    var normalizedValue = (0, $fee1c086737bcc76$var$_react.useMemo)(function() {
        return (0, $a1aed72b35405d54$export$49df40d5c24cf7e3)(value, valueKey);
    }, [
        value,
        valueKey
    ]);
    // search input value
    var _useState = (0, $fee1c086737bcc76$var$_react.useState)(), search = _useState[0], setSearch = _useState[1];
    // All select option indices and values
    var _useState2 = (0, $fee1c086737bcc76$var$_react.useState)(optionsProp), allOptions = _useState2[0], setAllOptions = _useState2[1];
    // Track changes to options property, except when options are being
    // updated due to search activity. Allows option's initial index value
    // to be referenced when filtered by search.
    (0, $fee1c086737bcc76$var$_react.useEffect)(function() {
        if (!search) setAllOptions(optionsProp);
    }, [
        optionsProp,
        search
    ]);
    // the option indexes present in the value
    var optionIndexesInValue = (0, $fee1c086737bcc76$var$_react.useMemo)(function() {
        var result = [];
        if (selected !== undefined) {
            if (Array.isArray(selected)) {
                var validSelections = selected.filter(function(i) {
                    return i in allOptions;
                });
                result.push.apply(result, validSelections);
            } else if (selected in allOptions) result.push(selected);
        } else if (Array.isArray(normalizedValue)) normalizedValue.forEach(function(v) {
            var index = allOptions.map(function(option) {
                return (0, $a1aed72b35405d54$export$f9e47df77939ed56)(option, valueKey);
            }).indexOf(v);
            if (index !== -1) result.push(index);
        });
        else {
            var index = allOptions.map(function(option) {
                return (0, $a1aed72b35405d54$export$f9e47df77939ed56)(option, valueKey);
            }).indexOf(normalizedValue);
            if (index !== -1) result.push(index);
        }
        return result;
    }, [
        allOptions,
        selected,
        valueKey,
        normalizedValue
    ]);
    var _useState3 = (0, $fee1c086737bcc76$var$_react.useState)(propOpen), open = _useState3[0], setOpen = _useState3[1];
    (0, $fee1c086737bcc76$var$_react.useEffect)(function() {
        return setOpen(propOpen);
    }, [
        propOpen
    ]);
    var onRequestOpen = (0, $fee1c086737bcc76$var$_react.useCallback)(function() {
        if (open) return;
        setOpen(true);
        if (onOpen) onOpen();
    }, [
        onOpen,
        open
    ]);
    var onRequestClose = (0, $fee1c086737bcc76$var$_react.useCallback)(function() {
        setOpen(false);
        if (onClose) onClose();
        setSearch();
    }, [
        onClose
    ]);
    var triggerChangeEvent = (0, $fee1c086737bcc76$var$_react.useCallback)(function(nextValue) {
        return (0, $a1aed72b35405d54$export$922aead9cd650d86)(inputRef, nextValue);
    }, []);
    var onSelectChange = (0, $fee1c086737bcc76$var$_react.useCallback)(function(event, _ref2) {
        var option = _ref2.option, nextValue = _ref2.value, nextSelected = _ref2.selected;
        if (closeOnChange) onRequestClose();
        // nextValue must not be of type object to set value directly on the
        // input. if it is an object, then the user has not provided necessary
        // props to reduce object option
        if ((typeof nextValue !== 'object' || multiple) && nextValue !== event.target.value && inputRef.current) // select registers changing option as a click event or keydown.
        // when in a form, we need to programatically trigger a change
        // event in order for the change event to be registered upstream
        // necessary for change validation in form
        triggerChangeEvent(nextValue);
        setValue(nextValue);
        if (onChange) {
            event.persist();
            var adjustedEvent;
            // support for native event used by Preact
            if (event instanceof Event) {
                adjustedEvent = new event.constructor(event.type, event);
                Object.defineProperties(adjustedEvent, {
                    target: {
                        value: inputRef.current
                    },
                    value: {
                        value: nextValue
                    },
                    option: {
                        value: option
                    },
                    selected: {
                        value: nextSelected
                    }
                });
            } else {
                adjustedEvent = event;
                adjustedEvent.target = inputRef.current;
                adjustedEvent.value = nextValue;
                adjustedEvent.option = option;
                adjustedEvent.selected = nextSelected;
            }
            onChange(adjustedEvent);
        }
    }, [
        closeOnChange,
        multiple,
        onChange,
        onRequestClose,
        setValue,
        triggerChangeEvent
    ]);
    var SelectIcon = (0, $a1aed72b35405d54$export$ea6782b1ec892245)(icon, theme, open);
    // element to show, trumps inputValue
    var selectValue = (0, $fee1c086737bcc76$var$_react.useMemo)(function() {
        if (valueLabel instanceof Function) {
            if (value || value === 0 || value === false) return valueLabel(value);
        } else if (valueLabel) return valueLabel;
        else if (/*#__PURE__*/ $fee1c086737bcc76$var$_react["default"].isValidElement(value)) return value; // deprecated
        return undefined;
    }, [
        value,
        valueLabel
    ]);
    var displayLabelKey = (0, $fee1c086737bcc76$var$_react.useMemo)(function() {
        return (0, $a1aed72b35405d54$export$7e4915d842d2c2e)(labelKey, allOptions, optionIndexesInValue, selectValue);
    }, [
        labelKey,
        allOptions,
        optionIndexesInValue,
        selectValue
    ]);
    // text to show
    // When the options array contains objects, this property indicates how
    // to retrieve the value of each option.
    // If a string is provided, it is used as the key to retrieve a
    // property of an option object.
    // If a function is provided, it is called with the option and should
    // return the value.
    // If reduce is true, this value will be used for the 'value'
    // delivered via 'onChange'.
    var inputValue = (0, $fee1c086737bcc76$var$_react.useMemo)(function() {
        if (!selectValue) {
            if (optionIndexesInValue.length === 0) return '';
            if (optionIndexesInValue.length === 1) return (0, $a1aed72b35405d54$export$f9e47df77939ed56)(allOptions[optionIndexesInValue[0]], labelKey);
            return format({
                id: 'select.multiple',
                messages: messages
            });
        }
        return undefined;
    }, [
        labelKey,
        messages,
        format,
        optionIndexesInValue,
        allOptions,
        selectValue
    ]);
    var iconColor = (0, $a1aed72b35405d54$export$bb417e0702eb86b5)(theme);
    var _useState4 = (0, $fee1c086737bcc76$var$_react.useState)(), ariaLabelledBy = _useState4[0], setAriaLabelledBy = _useState4[1];
    (0, $fee1c086737bcc76$var$_react.useEffect)(function() {
        if (formFieldData != null && formFieldData.inForm && id && !ariaLabel && !placeholder && typeof document !== 'undefined') {
            var labelElement = document.getElementById("grommet-" + id + "__input__label");
            if (labelElement) setAriaLabelledBy("grommet-" + id + "__input__label " + id);
        }
    }, [
        formFieldData == null ? void 0 : formFieldData.inForm,
        id,
        ariaLabel,
        placeholder
    ]);
    return /*#__PURE__*/ $fee1c086737bcc76$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onDown: onRequestOpen,
        onUp: onRequestOpen
    }, /*#__PURE__*/ $fee1c086737bcc76$var$_react["default"].createElement($c0f2e05c3c6f54d3$export$923536af422910c8, {
        ref: ref,
        a11yTitle: "" + (ariaLabel || a11yTitle || placeholder || 'Open Drop') + (value ? format({
            id: 'select.selected',
            messages: messages,
            values: {
                currentSelectedValue: (0, $a1aed72b35405d54$export$fe7dc70cd4404dea)(value, labelKey)
            }
        }) : ''),
        "aria-expanded": Boolean(open),
        "aria-labelledby": ariaLabelledByProp || ariaLabelledBy,
        "aria-haspopup": "listbox",
        id: id,
        disabled: disabled === true || undefined,
        dropAlign: dropAlign,
        dropTarget: dropTarget,
        open: open,
        alignSelf: alignSelf,
        focusIndicator: plain ? focusIndicator : true,
        onFocus: onFocus,
        onBlur: onBlur,
        gridArea: gridArea,
        margin: margin,
        onOpen: onRequestOpen,
        onClose: onRequestClose,
        onClick: onClick,
        dropContent: /*#__PURE__*/ $fee1c086737bcc76$var$_react["default"].createElement($07138d450b6c9297$export$446eebadefe1123b, {
            clear: clear,
            disabled: disabled,
            disabledKey: disabledKey,
            dropHeight: dropHeight,
            emptySearchMessage: emptySearchMessage,
            id: id,
            labelKey: labelKey,
            messages: messages,
            multiple: multiple,
            name: name,
            onChange: onSelectChange,
            onKeyDown: onKeyDown,
            onMore: onMore,
            onSearch: onSearch,
            options: optionsProp,
            allOptions: allOptions,
            optionIndexesInValue: optionIndexesInValue,
            replace: replace,
            searchPlaceholder: searchPlaceholder,
            search: search,
            setSearch: setSearch,
            selected: selected,
            usingKeyboard: usingKeyboard,
            value: value,
            valueKey: valueKey
        }, children),
        plainSelect: plain,
        plain: true // Button should be plain
        ,
        dropProps: dropProps,
        theme: theme
    }, /*#__PURE__*/ $fee1c086737bcc76$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        align: "center",
        direction: "row",
        justify: "between",
        background: theme.select.background
    }, /*#__PURE__*/ $fee1c086737bcc76$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        direction: "row",
        flex: true,
        basis: "auto"
    }, selectValue || displayLabelKey ? /*#__PURE__*/ $fee1c086737bcc76$var$_react["default"].createElement($fee1c086737bcc76$var$_react["default"].Fragment, null, selectValue || displayLabelKey, /*#__PURE__*/ $fee1c086737bcc76$var$_react["default"].createElement($c0f2e05c3c6f54d3$export$7196851310a3d0bf, {
        type: "text",
        name: name,
        id: id ? (0, $a1aed72b35405d54$export$abfa4f6a3fb2b741)(id) : undefined,
        inert: $a1aed72b35405d54$export$6f8d7bb3dad10aa1,
        value: inputValue,
        ref: inputRef,
        readOnly: true
    })) : /*#__PURE__*/ $fee1c086737bcc76$var$_react["default"].createElement($2f5972626e30691d$export$2307ecc6c2fea308, $fee1c086737bcc76$var$_extends({
        a11yTitle: (ariaLabel || a11yTitle) && "" + (ariaLabel || a11yTitle) + (value && typeof value === 'string' ? ", " + value : ''),
        disabled: disabled,
        id: id,
        inert: $a1aed72b35405d54$export$6f8d7bb3dad10aa1,
        name: name,
        ref: inputRef,
        placeholder: placeholder,
        value: inputValue,
        size: size,
        theme: theme
    }, rest))), SelectIcon && /*#__PURE__*/ $fee1c086737bcc76$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        margin: theme.select.icons.margin,
        flex: false,
        style: {
            minWidth: 'auto'
        }
    }, /*#__PURE__*/ (0, $fee1c086737bcc76$var$_react.isValidElement)(SelectIcon) ? SelectIcon : /*#__PURE__*/ $fee1c086737bcc76$var$_react["default"].createElement(SelectIcon, {
        color: iconColor,
        size: size
    })))));
});
$fee1c086737bcc76$var$Select.displayName = 'Select';
$fee1c086737bcc76$var$Select.propTypes = $b3898c3050a12e8b$export$e340aafd6bd05c16;


$c692f0029c94fbb2$export$ef9b1a59e592288f = $fee1c086737bcc76$export$ef9b1a59e592288f;





var $943aca04a5ebc26c$var$_excluded = [
    "messages",
    "onChange",
    "options",
    "step"
];
function $943aca04a5ebc26c$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($943aca04a5ebc26c$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $943aca04a5ebc26c$var$_extends() {
    return $943aca04a5ebc26c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $943aca04a5ebc26c$var$_extends.apply(null, arguments);
}
function $943aca04a5ebc26c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $943aca04a5ebc26c$var$PaginationStep = $943aca04a5ebc26c$export$5035dc52aa18dae0 = function PaginationStep(_ref) {
    var _theme$pagination;
    var messages = _ref.messages, onChange = _ref.onChange, _ref$options = _ref.options, options = _ref$options === void 0 ? [
        10,
        25,
        50,
        100
    ] : _ref$options, step = _ref.step, rest = $943aca04a5ebc26c$var$_objectWithoutPropertiesLoose(_ref, $943aca04a5ebc26c$var$_excluded);
    var _useContext = (0, $943aca04a5ebc26c$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), formatMessage = _useContext.format;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ $943aca04a5ebc26c$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $943aca04a5ebc26c$var$_extends({
        direction: "row",
        align: "center",
        gap: (_theme$pagination = theme.pagination) == null || (_theme$pagination = _theme$pagination.step) == null || (_theme$pagination = _theme$pagination.container) == null ? void 0 : _theme$pagination.gap
    }, rest), /*#__PURE__*/ $943aca04a5ebc26c$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, null, formatMessage({
        id: 'pagination.stepLabel',
        messages: messages
    })), /*#__PURE__*/ $943aca04a5ebc26c$var$_react["default"].createElement($c692f0029c94fbb2$export$ef9b1a59e592288f, {
        options: options,
        value: step,
        "aria-label": formatMessage({
            id: 'pagination.stepLabel',
            messages: messages
        }),
        valueLabel: /*#__PURE__*/ $943aca04a5ebc26c$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $943aca04a5ebc26c$var$_extends({}, theme.global.input, {
            pad: theme.global.input.padding
        }), /*#__PURE__*/ $943aca04a5ebc26c$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, theme.global.input.font, step)),
        onChange: onChange
    }));
};


var $eb4afb22fb12c00d$export$1e511d4a378977f5;
var $eb4afb22fb12c00d$export$94528e113b92ad1e;
"use strict";
$eb4afb22fb12c00d$export$1e511d4a378977f5 = true;
$eb4afb22fb12c00d$export$94528e113b92ad1e = void 0;

var $eb4afb22fb12c00d$var$_react = $eb4afb22fb12c00d$var$_interopRequireWildcard((parcelRequire("2xPiy")));



var $eb4afb22fb12c00d$var$_excluded = [
    "messages",
    "numberItems",
    "page",
    "step"
];
function $eb4afb22fb12c00d$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($eb4afb22fb12c00d$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $eb4afb22fb12c00d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $eb4afb22fb12c00d$var$PaginationSummary = $eb4afb22fb12c00d$export$94528e113b92ad1e = function PaginationSummary(_ref) {
    var messages = _ref.messages, numberItems = _ref.numberItems, page = _ref.page, step = _ref.step, rest = $eb4afb22fb12c00d$var$_objectWithoutPropertiesLoose(_ref, $eb4afb22fb12c00d$var$_excluded);
    var _useContext = (0, $eb4afb22fb12c00d$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), formatMessage = _useContext.format;
    return /*#__PURE__*/ $eb4afb22fb12c00d$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, rest, /*#__PURE__*/ $eb4afb22fb12c00d$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, null, numberItems > 0 ? formatMessage({
        id: 'pagination.summary',
        messages: messages,
        values: {
            start: "" + ((page - 1) * step + 1),
            end: "" + Math.min(page * step, numberItems),
            total: numberItems
        }
    }) : formatMessage({
        id: 'pagination.summaryNoItems',
        messages: messages
    })));
};


var $66ba7b6defa33233$export$1e511d4a378977f5;
var $66ba7b6defa33233$export$c8661a4aa71cec2a;
"use strict";
$66ba7b6defa33233$export$1e511d4a378977f5 = true;
$66ba7b6defa33233$export$c8661a4aa71cec2a = void 0;

var $66ba7b6defa33233$var$_propTypes = $66ba7b6defa33233$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $66ba7b6defa33233$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $66ba7b6defa33233$var$_extends() {
    return $66ba7b6defa33233$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $66ba7b6defa33233$var$_extends.apply(null, arguments);
}
var $66ba7b6defa33233$var$PropType = {};
$66ba7b6defa33233$var$PropType = $66ba7b6defa33233$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    numberEdgePages: $66ba7b6defa33233$var$_propTypes["default"].number,
    numberItems: $66ba7b6defa33233$var$_propTypes["default"].number,
    numberMiddlePages: $66ba7b6defa33233$var$_propTypes["default"].number,
    onChange: $66ba7b6defa33233$var$_propTypes["default"].func,
    page: $66ba7b6defa33233$var$_propTypes["default"].number,
    size: $66ba7b6defa33233$var$_propTypes["default"].oneOf([
        'small',
        'medium',
        'large'
    ]),
    step: $66ba7b6defa33233$var$_propTypes["default"].number,
    stepOptions: $66ba7b6defa33233$var$_propTypes["default"].oneOfType([
        $66ba7b6defa33233$var$_propTypes["default"].bool,
        $66ba7b6defa33233$var$_propTypes["default"].arrayOf($66ba7b6defa33233$var$_propTypes["default"].oneOfType([
            $66ba7b6defa33233$var$_propTypes["default"].string,
            $66ba7b6defa33233$var$_propTypes["default"].number,
            $66ba7b6defa33233$var$_propTypes["default"].bool,
            $66ba7b6defa33233$var$_propTypes["default"].element,
            $66ba7b6defa33233$var$_propTypes["default"].object
        ]))
    ]),
    summary: $66ba7b6defa33233$var$_propTypes["default"].bool,
    messages: $66ba7b6defa33233$var$_propTypes["default"].shape({
        stepLabel: $66ba7b6defa33233$var$_propTypes["default"].string,
        summary: $66ba7b6defa33233$var$_propTypes["default"].string,
        summaryNoItems: $66ba7b6defa33233$var$PropType.string
    })
});
var $66ba7b6defa33233$var$PaginationPropTypes = $66ba7b6defa33233$export$c8661a4aa71cec2a = $66ba7b6defa33233$var$PropType;



var $671cd2c50019ac20$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "numberItems",
    "numberEdgePages",
    "numberMiddlePages",
    "onChange",
    "messages",
    "page",
    "size",
    "step",
    "stepOptions",
    "summary"
];
function $671cd2c50019ac20$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $671cd2c50019ac20$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($671cd2c50019ac20$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $671cd2c50019ac20$var$_extends() {
    return $671cd2c50019ac20$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $671cd2c50019ac20$var$_extends.apply(null, arguments);
}
function $671cd2c50019ac20$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $671cd2c50019ac20$var$StyledPaginationContainer = (0, $671cd2c50019ac20$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "Pagination__StyledPaginationContainer",
    componentId: "sc-rnlw6m-0"
})([
    "",
    ""
], function(props) {
    return props.theme.pagination.container && props.theme.pagination.container.extend;
});
var $671cd2c50019ac20$var$getPageIndices = function getPageIndices(begin, end) {
    var indices = [];
    for(var i = begin; i <= end; i += 1)indices.push(i);
    return indices;
};
var $671cd2c50019ac20$var$Pagination = $671cd2c50019ac20$export$68f5e1453c188a82 = /*#__PURE__*/ (0, $671cd2c50019ac20$var$_react.forwardRef)(function(_ref, ref) {
    var _ref2, _theme$pagination$con;
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], numberItems = _ref.numberItems, _ref$numberEdgePages = _ref.numberEdgePages, numberEdgePages = _ref$numberEdgePages === void 0 ? 1 : _ref$numberEdgePages, _ref$numberMiddlePage = _ref.numberMiddlePages, numberMiddlePagesProp = _ref$numberMiddlePage === void 0 ? 3 : _ref$numberMiddlePage, onChange = _ref.onChange, messages = _ref.messages, pageProp = _ref.page, size = _ref.size, stepProp = _ref.step, stepOptions = _ref.stepOptions, summary = _ref.summary, rest = $671cd2c50019ac20$var$_objectWithoutPropertiesLoose(_ref, $671cd2c50019ac20$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useContext = (0, $671cd2c50019ac20$var$_react.useContext)($932597a497e37de0$export$58d75f9829cbe158), onView = _useContext.onView, filteredTotal = _useContext.filteredTotal, view = _useContext.view;
    var _useState = (0, $671cd2c50019ac20$var$_react.useState)(stepProp || (view == null ? void 0 : view.step) || 10), step = _useState[0], setStep = _useState[1];
    var total = (_ref2 = numberItems != null ? numberItems : filteredTotal) != null ? _ref2 : 0;
    var page = pageProp || (view == null ? void 0 : view.page) || 1;
    /* Calculate total number pages */ var totalPages = Math.ceil(total / step);
    var _useState2 = (0, $671cd2c50019ac20$var$_react.useState)(Math.min(page, totalPages) || 1), activePage = _useState2[0], setActivePage = _useState2[1];
    (0, $671cd2c50019ac20$var$_react.useEffect)(function() {
        if (stepProp) setStep(stepProp);
    }, [
        stepProp
    ]);
    (0, $671cd2c50019ac20$var$_react.useEffect)(function() {
        setActivePage(page);
        var pageEvent = new Event('pagechange');
        window.dispatchEvent(pageEvent);
    }, [
        page
    ]);
    (0, $671cd2c50019ac20$var$_react.useEffect)(function() {
        // if we are getting the step or page from outside the view,
        // update the Data's view in case it needs to filter.
        if (onView && ((view == null ? void 0 : view.step) !== step || (view == null ? void 0 : view.page) !== page)) onView($671cd2c50019ac20$var$_extends({}, view, {
            page: page,
            step: step
        }));
    }, [
        onView,
        page,
        step,
        view
    ]);
    /* Define page indices to display */ var beginPages = $671cd2c50019ac20$var$getPageIndices(1, Math.min(numberEdgePages, totalPages));
    var endPages = $671cd2c50019ac20$var$getPageIndices(Math.max(totalPages - numberEdgePages + 1, numberEdgePages + 1), totalPages);
    var numberMiddlePages;
    if (numberMiddlePagesProp < 1) {
        numberMiddlePages = 1;
        console.warn("Property \"numberMiddlePages\" should not be < 1. One middle page button will be shown. Set \"numberMiddlePages\" >= 1 to remove this warning.");
    } else numberMiddlePages = numberMiddlePagesProp;
    var startingMiddlePages;
    // odd
    if (numberMiddlePages % 2) startingMiddlePages = Math.min(activePage - Math.floor(numberMiddlePages / 2), totalPages - numberEdgePages - numberMiddlePages);
    else startingMiddlePages = Math.min(activePage - Math.floor(numberMiddlePages / 2) + 1, totalPages - numberEdgePages - numberMiddlePages);
    var middlePagesBegin = Math.max(startingMiddlePages, numberEdgePages + 2);
    var middlePagesEnd = Math.min(Math.max(activePage + Math.floor(numberMiddlePages / 2), numberEdgePages + numberMiddlePages + 1), endPages.length > 0 ? endPages[0] - 2 : totalPages - 1);
    var middlePages = $671cd2c50019ac20$var$getPageIndices(middlePagesBegin, middlePagesEnd);
    var beginFlex = [];
    if (middlePagesBegin > numberEdgePages + 2) beginFlex = [
        'more-prev'
    ];
    else if (numberEdgePages + 1 < totalPages - numberEdgePages) beginFlex = [
        numberEdgePages + 1
    ];
    var endFlex = [];
    if (middlePagesEnd < totalPages - numberEdgePages - 1) endFlex = [
        'more-next'
    ];
    else if (totalPages - numberEdgePages > numberEdgePages) endFlex = [
        totalPages - numberEdgePages
    ];
    var getItemIndices = function getItemIndices(nextPage) {
        var startIndex = step * (nextPage - 1);
        var endIndex = startIndex + step;
        return {
            startIndex: startIndex,
            endIndex: endIndex
        };
    };
    var handleClick = function handleClick(event, nextPage) {
        setActivePage(nextPage);
        if (onView) onView($671cd2c50019ac20$var$_extends({}, view, {
            page: nextPage
        }));
        if (onChange) {
            event.persist();
            var adjustedEvent = event;
            adjustedEvent.page = nextPage;
            // for controlled use cases, provide user with info on
            // what range of indices should be displayed given the active page
            var _getItemIndices = getItemIndices(nextPage), startIndex = _getItemIndices.startIndex, endIndex = _getItemIndices.endIndex;
            adjustedEvent.startIndex = startIndex;
            adjustedEvent.endIndex = endIndex;
            onChange(adjustedEvent);
        }
    };
    var NextIcon = theme.pagination.icons.next;
    var PreviousIcon = theme.pagination.icons.previous;
    var iconColor = theme.pagination.icons.color;
    var navProps = {
        next: {
            // https://a11y-style-guide.com/style-guide/section-navigation.html#kssref-navigation-pagination
            'aria-disabled': activePage === totalPages ? 'true' : undefined,
            disabled: activePage === totalPages || !total,
            icon: /*#__PURE__*/ $671cd2c50019ac20$var$_react["default"].createElement(NextIcon, {
                color: iconColor
            }),
            onClick: function onClick(event) {
                var nextPage = activePage + 1;
                handleClick(event, nextPage);
            },
            label: undefined
        },
        previous: {
            'aria-disabled': activePage === 1 ? 'true' : undefined,
            disabled: activePage === 1 || !total,
            icon: /*#__PURE__*/ $671cd2c50019ac20$var$_react["default"].createElement(PreviousIcon, {
                color: iconColor
            }),
            onClick: function onClick(event) {
                var previousPage = activePage - 1;
                handleClick(event, previousPage);
            },
            label: undefined
        }
    };
    var controls = [
        'previous'
    ].concat(beginPages, beginFlex, middlePages, endFlex, endPages, [
        'next'
    ]);
    /* Set props for each page index. Each page index should display a
   * clickable index, control, or placeholder (e.g. ellipsis) indicating
   * more pages are available.
   */ controls = controls.map(function(control) {
        return $671cd2c50019ac20$var$_extends({
            active: control === activePage,
            a11yTitle: typeof control === 'number' ? "Go to page " + control : "Go to " + control + " page",
            // https://a11y-style-guide.com/style-guide/section-navigation.html#kssref-navigation-pagination
            // https://www.w3.org/TR/wai-aria-1.1/#aria-current
            'aria-current': control === activePage ? 'page' : undefined,
            control: control,
            onClick: function onClick(event) {
                handleClick(event, control);
            },
            separator: control === 'more-prev' || control === 'more-next'
        }, navProps[control]);
    });
    var paginationControls = /*#__PURE__*/ $671cd2c50019ac20$var$_react["default"].createElement($30abe96e60597f25$export$39140c7d8b0ba7b3, {
        a11yTitle: ariaLabel || a11yTitle || 'Pagination Navigation',
        ref: ref
    }, /*#__PURE__*/ $671cd2c50019ac20$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $671cd2c50019ac20$var$_extends({
        as: "ul"
    }, theme.pagination.controls, {
        cssGap: true
    }), controls.map(function(control, index) {
        return(/*#__PURE__*/ /* Using index as key (as opposed to a unique id) seems to
       * help React prioritize rendering the updated controls as
       * desired. Whereas, using a unique id resulted in rendering
       * the active control with an undesired lag. */ // eslint-disable-next-line react/no-array-index-key
        $671cd2c50019ac20$var$_react["default"].createElement($1eaa94637897e2e8$export$4109320283c508e, $671cd2c50019ac20$var$_extends({
            key: index,
            size: size
        }, control)));
    })));
    // for backwards compatibility
    if (!summary && !stepOptions) return /*#__PURE__*/ $671cd2c50019ac20$var$_react["default"].createElement($671cd2c50019ac20$var$StyledPaginationContainer, $671cd2c50019ac20$var$_extends({
        flex: false
    }, $671cd2c50019ac20$var$_extends({}, theme.pagination.container, {
        gap: undefined
    }), passThemeFlag, rest), paginationControls);
    return /*#__PURE__*/ $671cd2c50019ac20$var$_react["default"].createElement($671cd2c50019ac20$var$StyledPaginationContainer, $671cd2c50019ac20$var$_extends({
        direction: "row",
        align: "center",
        wrap: true,
        flex: false
    }, theme.pagination.container, passThemeFlag, rest), /*#__PURE__*/ $671cd2c50019ac20$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        flex: "grow"
    }, summary && /*#__PURE__*/ $671cd2c50019ac20$var$_react["default"].createElement($eb4afb22fb12c00d$export$94528e113b92ad1e, {
        messages: messages,
        page: activePage,
        step: step,
        numberItems: total
    })), /*#__PURE__*/ $671cd2c50019ac20$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        align: "center",
        direction: "row",
        gap: (_theme$pagination$con = theme.pagination.container) == null ? void 0 : _theme$pagination$con.gap,
        wrap: true
    }, stepOptions && /*#__PURE__*/ $671cd2c50019ac20$var$_react["default"].createElement($943aca04a5ebc26c$export$5035dc52aa18dae0, {
        messages: messages,
        options: Array.isArray(stepOptions) ? stepOptions : undefined,
        step: step,
        onChange: function onChange(_ref3) {
            var value = _ref3.value;
            return setStep(value);
        }
    }), paginationControls));
});
$671cd2c50019ac20$var$Pagination.displayName = 'Pagination';
$671cd2c50019ac20$var$Pagination.propTypes = $66ba7b6defa33233$export$c8661a4aa71cec2a;


$98274833e85ef953$export$68f5e1453c188a82 = $671cd2c50019ac20$export$68f5e1453c188a82;



var $012479f6f88ed1e1$export$1e511d4a378977f5;
var $012479f6f88ed1e1$export$f2981dfb09f1c1b5;
"use strict";
$012479f6f88ed1e1$export$1e511d4a378977f5 = true;
$012479f6f88ed1e1$export$f2981dfb09f1c1b5 = void 0;

var $012479f6f88ed1e1$var$_propTypes = $012479f6f88ed1e1$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $012479f6f88ed1e1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $012479f6f88ed1e1$var$_extends() {
    return $012479f6f88ed1e1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $012479f6f88ed1e1$var$_extends.apply(null, arguments);
}
var $012479f6f88ed1e1$var$PropType = {};
$012479f6f88ed1e1$var$PropType = $012479f6f88ed1e1$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    as: $012479f6f88ed1e1$var$_propTypes["default"].string,
    data: $012479f6f88ed1e1$var$_propTypes["default"].arrayOf($012479f6f88ed1e1$var$_propTypes["default"].oneOfType([
        $012479f6f88ed1e1$var$_propTypes["default"].string,
        $012479f6f88ed1e1$var$_propTypes["default"].shape({})
    ])),
    children: $012479f6f88ed1e1$var$_propTypes["default"].func,
    onMore: $012479f6f88ed1e1$var$_propTypes["default"].func,
    onOrder: $012479f6f88ed1e1$var$_propTypes["default"].func,
    paginate: $012479f6f88ed1e1$var$_propTypes["default"].oneOfType([
        $012479f6f88ed1e1$var$_propTypes["default"].bool,
        $012479f6f88ed1e1$var$_propTypes["default"].object
    ]),
    show: $012479f6f88ed1e1$var$_propTypes["default"].oneOfType([
        $012479f6f88ed1e1$var$_propTypes["default"].number,
        $012479f6f88ed1e1$var$_propTypes["default"].shape({
            page: $012479f6f88ed1e1$var$_propTypes["default"].number
        })
    ]),
    sizeKey: $012479f6f88ed1e1$var$_propTypes["default"].string,
    step: $012479f6f88ed1e1$var$_propTypes["default"].number
});
var $012479f6f88ed1e1$var$CardsPropTypes = $012479f6f88ed1e1$export$f2981dfb09f1c1b5 = $012479f6f88ed1e1$var$PropType;



var $9f234e4048ace84e$export$1e511d4a378977f5;
var $9f234e4048ace84e$export$2509dc96fc7de990;
"use strict";
$9f234e4048ace84e$export$1e511d4a378977f5 = true;
$9f234e4048ace84e$export$2509dc96fc7de990 = void 0;

var $9f234e4048ace84e$var$_styledComponents = $9f234e4048ace84e$var$_interopRequireDefault((parcelRequire("iA1nz")));

function $9f234e4048ace84e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $9f234e4048ace84e$var$_extends() {
    return $9f234e4048ace84e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9f234e4048ace84e$var$_extends.apply(null, arguments);
}
var $9f234e4048ace84e$var$sizeStyles = function sizeStyles(size) {
    return size && typeof size === 'object' ? "\n      " + (size != null && size.columns ? "grid-column: span " + size.columns + ";" : '') + "\n      " + (size != null && size.rows ? "grid-row: span " + size.rows + ";" : '') + "\n    " : '';
};
// display: grid makes the single child fill the wrapper (stretch in both axes)
var $9f234e4048ace84e$var$StyledCellContainer = $9f234e4048ace84e$export$2509dc96fc7de990 = $9f234e4048ace84e$var$_styledComponents["default"].div.withConfig($9f234e4048ace84e$var$_extends({}, $4113023f9e0bafa0$exports.styledComponentsConfig, {
    // 'size' passes isPropValid (valid for input/select), filter it to
    // prevent the object value from reaching the DOM as an attribute.
    shouldForwardProp: function shouldForwardProp(prop) {
        return prop !== 'size' && $4113023f9e0bafa0$exports.styledComponentsConfig.shouldForwardProp(prop);
    }
})).withConfig({
    displayName: "StyledCellContainer",
    componentId: "sc-183y88f-0"
})([
    "display:grid;",
    " ",
    " ",
    " &:focus{",
    "}&:focus:not(:focus-visible){",
    "}"
], function(props) {
    return props.size ? $9f234e4048ace84e$var$sizeStyles(props.size) : undefined;
}, function(props) {
    return props.draggable ? 'cursor: move;' : undefined;
}, function(props) {
    return props.round && (0, $4113023f9e0bafa0$exports.roundStyle)(props.round, props.responsive, props.theme);
}, (0, $4113023f9e0bafa0$exports.focusStyle)(), (0, $4113023f9e0bafa0$exports.unfocusStyle)());


var $da9cbcb70d6a9c25$var$_excluded = [
    "as",
    "children",
    "data",
    "margin",
    "onMore",
    "pad",
    "paginate",
    "show",
    "size",
    "step",
    "sizeKey",
    "onOrder"
], $da9cbcb70d6a9c25$var$_excluded2 = [
    "keyboard"
];
function $da9cbcb70d6a9c25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $da9cbcb70d6a9c25$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($da9cbcb70d6a9c25$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $da9cbcb70d6a9c25$var$_extends() {
    return $da9cbcb70d6a9c25$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $da9cbcb70d6a9c25$var$_extends.apply(null, arguments);
}
function $da9cbcb70d6a9c25$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $da9cbcb70d6a9c25$var$emptyData = [];
var $da9cbcb70d6a9c25$var$HiddenText = $da9cbcb70d6a9c25$var$_styledComponents["default"].span.withConfig({
    displayName: "Cards__HiddenText",
    componentId: "sc-1f9ilr5-0"
})([
    "position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;"
]);
var $da9cbcb70d6a9c25$var$indexForItem = function indexForItem(data, item) {
    var index = data.indexOf(item);
    if (index === -1) // If the item isn't in the data, try to find it by id. This allows for
    // reordering to work when the items provided to Cards are different objects
    // than those in the data array, as long as they share an id.
    return data.findIndex(function(d) {
        return d.id === item.id;
    });
    return index;
};
var $da9cbcb70d6a9c25$var$reorder = function reorder(array, source, target) {
    var result = array.slice(0);
    var tmp = result[source];
    if (source < target) for(var i = source; i < target; i += 1)result[i] = result[i + 1];
    else for(var _i = source; _i > target; _i -= 1)result[_i] = result[_i - 1];
    result[target] = tmp;
    return result;
};
var $da9cbcb70d6a9c25$var$Cards = $da9cbcb70d6a9c25$export$c8d38e0dcc0f5a1 = /*#__PURE__*/ $da9cbcb70d6a9c25$var$_react["default"].forwardRef(function(_ref, ref) {
    var _ref$as = _ref.as, as = _ref$as === void 0 ? 'ul' : _ref$as, children = _ref.children, dataProp = _ref.data, margin = _ref.margin, onMore = _ref.onMore, pad = _ref.pad, paginate = _ref.paginate, showProp = _ref.show, size = _ref.size, _ref$step = _ref.step, step = _ref$step === void 0 ? paginate ? 50 : undefined : _ref$step, sizeKey = _ref.sizeKey, onOrder = _ref.onOrder, rest = $da9cbcb70d6a9c25$var$_objectWithoutPropertiesLoose(_ref, $da9cbcb70d6a9c25$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var announce = (0, $da9cbcb70d6a9c25$var$_react.useContext)($cfbcb74d4f54e56b$export$dcc8f4bff0d51f50);
    var _useContext = (0, $da9cbcb70d6a9c25$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var _useContext2 = (0, $da9cbcb70d6a9c25$var$_react.useContext)($932597a497e37de0$export$58d75f9829cbe158), contextData = _useContext2.data, unfilteredData = _useContext2.unfilteredData;
    var data = dataProp || contextData || $da9cbcb70d6a9c25$var$emptyData;
    var unfiltered = unfilteredData || data;
    var _usePagination = (0, $4113023f9e0bafa0$exports.usePagination)($da9cbcb70d6a9c25$var$_extends({
        data: data,
        page: (0, $4113023f9e0bafa0$exports.normalizeShow)(showProp, step),
        step: step
    }, paginate)), items = _usePagination[0], paginationProps = _usePagination[1];
    var Container = paginate ? $090ffb0ba78fff3f$export$e71c4d32a2263218 : $da9cbcb70d6a9c25$var$_react.Fragment;
    var containerProps = paginate ? $da9cbcb70d6a9c25$var$_extends({}, theme.cards.container, {
        pad: pad,
        margin: margin
    }) : undefined;
    var _useState = (0, $da9cbcb70d6a9c25$var$_react.useState)(), dragging = _useState[0], setDragging = _useState[1];
    var _useState2 = (0, $da9cbcb70d6a9c25$var$_react.useState)(), orderedData = _useState2[0], setOrderedData = _useState2[1];
    var _useState3 = (0, $da9cbcb70d6a9c25$var$_react.useState)(), unfilteredOrder = _useState3[0], setUnfilteredOrder = _useState3[1];
    var hintId = (0, $4113023f9e0bafa0$exports.useId)();
    var currentItems = orderedData || (!paginate ? data : items);
    var renderItem = function renderItem(item, index) {
        var move = function move(count) {
            var newIndex = Math.max(0, Math.min(index + count, currentItems.length - 1));
            onOrder($da9cbcb70d6a9c25$var$reorder(unfiltered, $da9cbcb70d6a9c25$var$indexForItem(unfiltered, item), $da9cbcb70d6a9c25$var$indexForItem(unfiltered, currentItems[newIndex])));
            announce(format({
                id: 'cards.moved',
                values: {
                    source: newIndex + 1,
                    target: currentItems.length
                }
            }));
        };
        var onOrderProps = onOrder ? {
            tabIndex: 0,
            'aria-roledescription': format({
                id: 'cards.description'
            }),
            'aria-describedby': hintId,
            draggable: true,
            onDragStart: function onDragStart(event) {
                event.dataTransfer.setData('text/plain', '');
                // allowed per
                // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API#define_the_drag_effect
                // eslint-disable-next-line no-param-reassign
                event.dataTransfer.effectAllowed = 'move';
                setDragging(index);
            },
            onDragEnd: function onDragEnd() {
                setDragging(undefined);
                setOrderedData(undefined);
                setUnfilteredOrder(undefined);
            },
            onDragEnter: function onDragEnter(event) {
                if (dragging !== undefined && dragging !== index) {
                    // Ignore synthetic re-fires caused by entering
                    // a child of this element
                    if (event.currentTarget.contains(event.relatedTarget)) return;
                    // eslint-disable-next-line no-param-reassign
                    event.dataTransfer.dropEffect = 'move';
                    setUnfilteredOrder($da9cbcb70d6a9c25$var$reorder(unfiltered, $da9cbcb70d6a9c25$var$indexForItem(unfiltered, currentItems[dragging]), $da9cbcb70d6a9c25$var$indexForItem(unfiltered, item)));
                    setOrderedData($da9cbcb70d6a9c25$var$reorder(currentItems, dragging, index));
                    setDragging(index);
                }
            },
            onDragOver: function onDragOver(event) {
                if (dragging !== undefined) // preventDefault is required to allow the drop to occur
                event.preventDefault();
            },
            onDrop: function onDrop() {
                if (unfilteredOrder) onOrder(unfilteredOrder);
            },
            keyboard: {
                onUp: function onUp(event) {
                    event.preventDefault();
                    move(-1);
                },
                onDown: function onDown(event) {
                    event.preventDefault();
                    move(1);
                },
                onLeft: function onLeft(event) {
                    event.preventDefault();
                    move(-1);
                },
                onRight: function onRight(event) {
                    event.preventDefault();
                    move(1);
                }
            }
        } : {};
        var keyboard = onOrderProps.keyboard, wrapperProps = $da9cbcb70d6a9c25$var$_objectWithoutPropertiesLoose(onOrderProps, $da9cbcb70d6a9c25$var$_excluded2);
        var content;
        if (children) content = children(item, index);
        else {
            var _ref2, _ref3;
            content = /*#__PURE__*/ $da9cbcb70d6a9c25$var$_react["default"].createElement($5b055e3351599a71$export$60332b2344f7fe41, {
                key: item.id || index.toString(),
                as: !(onOrder || sizeKey) && as === 'ul' ? 'li' : undefined
            }, /*#__PURE__*/ $da9cbcb70d6a9c25$var$_react["default"].createElement($a78b478a7bdcd33d$export$851de33184ecdac4, null, (_ref2 = (_ref3 = typeof item === 'string' && item) != null ? _ref3 : typeof item === 'object' && Object.values(item)[0]) != null ? _ref2 : index));
        }
        // If the items are orderable or sized by a property, wrap them in a
        // StyledCellContainer to apply the drag and drop handlers and/or
        // size styles
        if (onOrder || sizeKey) {
            var round = theme.card.container.round;
            content = /*#__PURE__*/ $da9cbcb70d6a9c25$var$_react["default"].createElement($9f234e4048ace84e$export$2509dc96fc7de990, $da9cbcb70d6a9c25$var$_extends({
                key: "_container_" + ((item == null ? void 0 : item.id) || index),
                as: as === 'ul' ? 'li' : undefined
            }, wrapperProps, {
                size: sizeKey ? item[sizeKey] : undefined,
                round: round
            }), content);
        }
        // Keyboard is only applied if onOrder is provided
        return keyboard ? /*#__PURE__*/ $da9cbcb70d6a9c25$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, $da9cbcb70d6a9c25$var$_extends({
            key: "_keyboard_" + ((item == null ? void 0 : item.id) || index)
        }, keyboard), content) : content;
    };
    return /*#__PURE__*/ $da9cbcb70d6a9c25$var$_react["default"].createElement(Container, containerProps, onOrder && /*#__PURE__*/ $da9cbcb70d6a9c25$var$_react["default"].createElement($da9cbcb70d6a9c25$var$HiddenText, {
        id: hintId
    }, format({
        id: 'cards.reorderHint'
    })), /*#__PURE__*/ $da9cbcb70d6a9c25$var$_react["default"].createElement($f75e849c2101cc4f$export$ef2184bd89960b14, $da9cbcb70d6a9c25$var$_extends({
        ref: ref,
        as: as,
        gap: theme.cards.grid.gap,
        columns: size || theme.cards.grid.columns,
        margin: !paginate && margin || 'none',
        pad: !paginate && pad || 'none'
    }, rest), /*#__PURE__*/ $da9cbcb70d6a9c25$var$_react["default"].createElement($41010700ddcbac64$export$c5295390d6167a3e, {
        items: currentItems,
        onMore: onMore,
        show: !paginate ? showProp : undefined,
        step: step,
        renderMarker: function renderMarker(marker) {
            return /*#__PURE__*/ $da9cbcb70d6a9c25$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
                as: "li",
                flex: false
            }, marker);
        }
    }, function(item, index) {
        return renderItem(item, index);
    })), paginate && data.length > step && items && items.length ? /*#__PURE__*/ $da9cbcb70d6a9c25$var$_react["default"].createElement($98274833e85ef953$export$68f5e1453c188a82, $da9cbcb70d6a9c25$var$_extends({
        alignSelf: "end"
    }, paginationProps)) : null);
});
$da9cbcb70d6a9c25$var$Cards.displayName = 'Cards';
$da9cbcb70d6a9c25$var$Cards.propTypes = $012479f6f88ed1e1$export$f2981dfb09f1c1b5;


$d0861f5d89d312dc$export$c8d38e0dcc0f5a1 = $da9cbcb70d6a9c25$export$c8d38e0dcc0f5a1;


Object.keys($d0861f5d89d312dc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $d0861f5d89d312dc$exports[key]) return;
    $3321243da0932e1e$exports[key] = $d0861f5d89d312dc$exports[key];
});
var $b9c1cc376265c38e$exports = {};

$parcel$export($b9c1cc376265c38e$exports, "__esModule", function () { return $b9c1cc376265c38e$export$1e511d4a378977f5; }, function (v) { return $b9c1cc376265c38e$export$1e511d4a378977f5 = v; });
$parcel$export($b9c1cc376265c38e$exports, "Carousel", function () { return $b9c1cc376265c38e$export$144901db2ea8e967; }, function (v) { return $b9c1cc376265c38e$export$144901db2ea8e967 = v; });
var $b9c1cc376265c38e$export$1e511d4a378977f5;
var $b9c1cc376265c38e$export$144901db2ea8e967;
"use strict";
$b9c1cc376265c38e$export$1e511d4a378977f5 = true;
$b9c1cc376265c38e$export$144901db2ea8e967 = void 0;
var $1468c6296519704e$export$1e511d4a378977f5;
var $1468c6296519704e$export$144901db2ea8e967;
"use strict";
$1468c6296519704e$export$1e511d4a378977f5 = true;
$1468c6296519704e$export$144901db2ea8e967 = void 0;

var $1468c6296519704e$var$_react = $1468c6296519704e$var$_interopRequireWildcard((parcelRequire("2xPiy")));





var $3507974cae200b70$export$1e511d4a378977f5;
var $3507974cae200b70$export$5c7b7f0e517b89f8;
var $3507974cae200b70$export$115e625c3f67bf98;
var $3507974cae200b70$export$be541686e428c2a6;
"use strict";
$3507974cae200b70$export$1e511d4a378977f5 = true;
$3507974cae200b70$export$5c7b7f0e517b89f8 = $3507974cae200b70$export$115e625c3f67bf98 = $3507974cae200b70$export$be541686e428c2a6 = void 0;

var $3507974cae200b70$var$_styledComponents = $3507974cae200b70$var$_interopRequireWildcard((parcelRequire("iA1nz")));

function $3507974cae200b70$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($3507974cae200b70$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $3507974cae200b70$var$StyledCarouselContainer = $3507974cae200b70$export$115e625c3f67bf98 = (0, $3507974cae200b70$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "StyledCarousel__StyledCarouselContainer",
    componentId: "sc-c2hjel-0"
})([
    "position:relative;overflow:hidden;"
]);
var $3507974cae200b70$var$animationKeyframes = {
    // Slide Right = Previous or Backward
    slideRightPrevious: (0, $3507974cae200b70$var$_styledComponents.keyframes)([
        "0%{transform:translateX(0%)}100%{transform:translateX(100%)}"
    ]),
    slideRightCurrent: (0, $3507974cae200b70$var$_styledComponents.keyframes)([
        "0%{transform:translateX(-100%)}100%{transform:translateX(0%)}"
    ]),
    // Slide Left = Next or Forward
    slideLeftPrevious: (0, $3507974cae200b70$var$_styledComponents.keyframes)([
        "0%{transform:translateX(0%)}100%{transform:translateX(-100%)}"
    ]),
    slideLeftCurrent: (0, $3507974cae200b70$var$_styledComponents.keyframes)([
        "0%{transform:translateX(100%)}100%{transform:translateX(0%)}"
    ])
};
var $3507974cae200b70$var$StyledCarouselChild = $3507974cae200b70$export$be541686e428c2a6 = (0, $3507974cae200b70$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "StyledCarousel__StyledCarouselChild",
    componentId: "sc-c2hjel-1"
})([
    "visibility:",
    ";position:",
    ";width:100%;height:100%;overflow:hidden;",
    ";animation-fill-mode:both;"
], function(props) {
    return props.visibilityProp;
}, function(props) {
    return props.positionProp;
}, function(props) {
    return props.animationType ? (0, $3507974cae200b70$var$_styledComponents.css)([
        "animation:",
        " ",
        "s ease-in-out;"
    ], $3507974cae200b70$var$animationKeyframes[props.animationType], props.animationDuration / 1000) : "";
});
var $3507974cae200b70$var$StyledControl = $3507974cae200b70$export$5c7b7f0e517b89f8 = (0, $3507974cae200b70$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "StyledCarousel__StyledControl",
    componentId: "sc-c2hjel-2"
})([
    "position:absolute;z-index:1;",
    " align-items:center;justify-content:center;"
], function(props) {
    return props.offsetProp + ": 0;";
});


var $2a42595435b6316a$export$1e511d4a378977f5;
var $2a42595435b6316a$export$b27165ff157668ed;
"use strict";
$2a42595435b6316a$export$1e511d4a378977f5 = true;
$2a42595435b6316a$export$b27165ff157668ed = void 0;

var $2a42595435b6316a$var$_react = $2a42595435b6316a$var$_interopRequireWildcard((parcelRequire("2xPiy")));
var $688718ff0cd866bd$export$1e511d4a378977f5;
var $688718ff0cd866bd$export$4a1671f1b9579d0f;
var $688718ff0cd866bd$export$311ded8387e5ce78;
"use strict";
$688718ff0cd866bd$export$1e511d4a378977f5 = true;
$688718ff0cd866bd$export$4a1671f1b9579d0f = $688718ff0cd866bd$export$311ded8387e5ce78 = void 0;

var $688718ff0cd866bd$var$_propTypes = $688718ff0cd866bd$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $688718ff0cd866bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $688718ff0cd866bd$var$_extends() {
    return $688718ff0cd866bd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $688718ff0cd866bd$var$_extends.apply(null, arguments);
}
var $688718ff0cd866bd$var$CarouselPropType;
$688718ff0cd866bd$var$CarouselPropType = $688718ff0cd866bd$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    activeChild: $688718ff0cd866bd$var$_propTypes["default"].number,
    initialChild: $688718ff0cd866bd$var$_propTypes["default"].number,
    fill: $688718ff0cd866bd$var$_propTypes["default"].bool,
    wrap: $688718ff0cd866bd$var$_propTypes["default"].bool,
    controls: $688718ff0cd866bd$var$_propTypes["default"].oneOfType([
        $688718ff0cd866bd$var$_propTypes["default"].oneOf([
            'arrows',
            'selectors'
        ]),
        $688718ff0cd866bd$var$_propTypes["default"].bool
    ]),
    onChild: $688718ff0cd866bd$var$_propTypes["default"].func,
    width: $5897bd367fbd90c1$export$7d45d0e6b7abd5e2,
    height: $5897bd367fbd90c1$export$674efdc47ecf99e9,
    play: $688718ff0cd866bd$var$_propTypes["default"].number
});
var $688718ff0cd866bd$var$CarouselPropTypes = $688718ff0cd866bd$export$4a1671f1b9579d0f = $688718ff0cd866bd$var$CarouselPropType;
var $688718ff0cd866bd$var$CarouselChildPropType;
$688718ff0cd866bd$var$CarouselChildPropType = {
    animationDuration: $688718ff0cd866bd$var$_propTypes["default"].number.isRequired,
    fill: $688718ff0cd866bd$var$_propTypes["default"].bool,
    index: $688718ff0cd866bd$var$_propTypes["default"].number.isRequired,
    activeIndex: $688718ff0cd866bd$var$_propTypes["default"].number.isRequired,
    priorActiveIndex: $688718ff0cd866bd$var$_propTypes["default"].number,
    direction: $688718ff0cd866bd$var$_propTypes["default"].oneOf([
        'left',
        'right'
    ])
};
var $688718ff0cd866bd$var$CarouselChildPropTypes = $688718ff0cd866bd$export$311ded8387e5ce78 = $688718ff0cd866bd$var$CarouselChildPropType;




function $2a42595435b6316a$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($2a42595435b6316a$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $2a42595435b6316a$var$CarouselChild = $2a42595435b6316a$export$b27165ff157668ed = function CarouselChild(_ref) {
    var animationDuration = _ref.animationDuration, _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? false : _ref$fill, index = _ref.index, activeIndex = _ref.activeIndex, priorActiveIndex = _ref.priorActiveIndex, direction = _ref.direction, children = _ref.children;
    var _useState = (0, $2a42595435b6316a$var$_react.useState)(undefined), animation = _useState[0], setAnimation = _useState[1];
    var _useState2 = (0, $2a42595435b6316a$var$_react.useState)(index === activeIndex ? 'visible' : 'hidden'), visibility = _useState2[0], setVisibility = _useState2[1];
    (0, $2a42595435b6316a$var$_react.useEffect)(function() {
        var timer;
        if (index === activeIndex) {
            if (priorActiveIndex !== undefined) /**
         * This check will only be false onMount of the component. It ensures
         * the initial active slide of the Carousel renders with no animation.
         */ setAnimation(direction === 'left' ? 'slideLeftCurrent' : 'slideRightCurrent');
            setVisibility('visible');
        } else if (index === priorActiveIndex) {
            setAnimation(direction === 'left' ? 'slideLeftPrevious' : 'slideRightPrevious');
            timer = setTimeout(function() {
                return setVisibility('hidden');
            }, animationDuration);
        }
        return function() {
            return clearTimeout(timer);
        };
    }, [
        activeIndex,
        priorActiveIndex,
        index,
        direction,
        animationDuration
    ]);
    var position = index === 0 ? 'relative' : 'absolute';
    return /*#__PURE__*/ $2a42595435b6316a$var$_react["default"].createElement($3507974cae200b70$export$be541686e428c2a6, {
        fill: fill,
        visibilityProp: visibility,
        positionProp: position,
        animationType: animation,
        animationDuration: animationDuration
    }, /*#__PURE__*/ $2a42595435b6316a$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        fill: fill
    }, children));
};
$2a42595435b6316a$var$CarouselChild.propTypes = $688718ff0cd866bd$export$311ded8387e5ce78;




var $1468c6296519704e$var$_excluded = [
    "activeChild",
    "initialChild",
    "onChild",
    "play",
    "children",
    "controls",
    "height",
    "fill",
    "width",
    "onFocus",
    "onBlur",
    "wrap"
];
function $1468c6296519704e$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($1468c6296519704e$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $1468c6296519704e$var$_extends() {
    return $1468c6296519704e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1468c6296519704e$var$_extends.apply(null, arguments);
}
function $1468c6296519704e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $1468c6296519704e$var$Carousel = $1468c6296519704e$export$144901db2ea8e967 = function Carousel(_ref) {
    var activeChild = _ref.activeChild, _ref$initialChild = _ref.initialChild, initialChild = _ref$initialChild === void 0 ? 0 : _ref$initialChild, onChild = _ref.onChild, play = _ref.play, children = _ref.children, _ref$controls = _ref.controls, controls = _ref$controls === void 0 ? true : _ref$controls, height = _ref.height, fill = _ref.fill, width = _ref.width, onFocus = _ref.onFocus, onBlur = _ref.onBlur, wrap = _ref.wrap, rest = $1468c6296519704e$var$_objectWithoutPropertiesLoose(_ref, $1468c6296519704e$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useContext = (0, $1468c6296519704e$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var timerRef = (0, $1468c6296519704e$var$_react.useRef)();
    var animationDuration = (0, $1468c6296519704e$var$_react.useMemo)(function() {
        return play && play < theme.carousel.animation.duration ? play : theme.carousel.animation.duration;
    }, [
        play,
        theme.carousel.animation.duration
    ]);
    var _useState = (0, $1468c6296519704e$var$_react.useState)({
        activeIndex: activeChild !== undefined ? activeChild : initialChild
    }), indexes = _useState[0], setIndexes = _useState[1];
    var _useState2 = (0, $1468c6296519704e$var$_react.useState)(activeChild), activeChildState = _useState2[0], setActiveChildState = _useState2[1];
    var _useState3 = (0, $1468c6296519704e$var$_react.useState)(), direction = _useState3[0], setDirection = _useState3[1];
    var _useState4 = (0, $1468c6296519704e$var$_react.useState)(false), inTransition = _useState4[0], setInTransition = _useState4[1];
    var activeIndex = indexes.activeIndex, priorActiveIndex = indexes.priorActiveIndex;
    var lastIndex = $1468c6296519704e$var$_react.Children.count(children) - 1;
    var onChildChange = (0, $1468c6296519704e$var$_react.useCallback)(function(index) {
        if (onChild) onChild(index);
    }, [
        onChild
    ]);
    var onRight = (0, $1468c6296519704e$var$_react.useCallback)(function() {
        if (inTransition) return;
        clearInterval(timerRef.current);
        var nextActiveIndex = activeIndex < lastIndex ? activeIndex + 1 : 0;
        setIndexes({
            activeIndex: nextActiveIndex,
            priorActiveIndex: activeIndex
        });
        setInTransition(true);
        setDirection('left');
        onChildChange(nextActiveIndex);
    }, [
        activeIndex,
        inTransition,
        lastIndex,
        onChildChange
    ]);
    var onLeft = (0, $1468c6296519704e$var$_react.useCallback)(function() {
        if (inTransition) return;
        clearInterval(timerRef.current);
        var nextActiveIndex = activeIndex === 0 ? lastIndex : activeIndex - 1;
        setIndexes({
            activeIndex: nextActiveIndex,
            priorActiveIndex: activeIndex
        });
        setInTransition(true);
        setDirection('right');
        onChildChange(nextActiveIndex);
    }, [
        activeIndex,
        inTransition,
        lastIndex,
        onChildChange
    ]);
    var onSelect = (0, $1468c6296519704e$var$_react.useCallback)(function(index) {
        return function() {
            if (!inTransition && activeIndex !== index) {
                clearInterval(timerRef.current);
                setIndexes({
                    activeIndex: index,
                    priorActiveIndex: activeIndex
                });
                setInTransition(true);
                setDirection(index > activeIndex ? 'left' : 'right');
                onChildChange(index);
            }
        };
    }, [
        activeIndex,
        inTransition,
        onChildChange
    ]);
    var onControlledNavigation = (0, $1468c6296519704e$var$_react.useCallback)(function() {
        if (inTransition || activeChild === activeChildState || activeChild === activeIndex || activeChild === undefined || activeChild < 0 || activeChild > lastIndex) return;
        setDirection(activeChild > activeIndex ? 'left' : 'right');
        setInTransition(true);
        setIndexes({
            activeIndex: activeChild,
            priorActiveIndex: activeIndex
        });
        setActiveChildState(activeChild);
        onChildChange(activeChild);
    }, [
        activeChild,
        activeChildState,
        activeIndex,
        inTransition,
        lastIndex,
        onChildChange
    ]);
    /**
   * Delays the transitions between Carousel slides. This is needed to
   * avoid users "spamming" the controls which results in jarring animations
   * and a bad user experience.
   */ (0, $1468c6296519704e$var$_react.useEffect)(function() {
        var transitionTimer;
        if (inTransition) transitionTimer = setTimeout(function() {
            setInTransition(false);
        }, animationDuration);
        return function() {
            return clearTimeout(transitionTimer);
        };
    }, [
        inTransition,
        setInTransition,
        animationDuration
    ]);
    // Handles auto-playing Carousel slides
    (0, $1468c6296519704e$var$_react.useEffect)(function() {
        // stop playing if wrap is explicitly false and we're at the end
        if (play && (wrap !== false || activeIndex < lastIndex)) {
            var timer = setInterval(function() {
                var nextActiveIndex = activeIndex < lastIndex ? activeIndex + 1 : 0;
                setIndexes({
                    activeIndex: nextActiveIndex,
                    priorActiveIndex: activeIndex
                });
                setInTransition(true);
                setDirection('left');
                onChildChange(nextActiveIndex);
            }, play);
            timerRef.current = timer;
            return function() {
                clearTimeout(timer);
            };
        }
        return function() {};
    }, [
        activeIndex,
        play,
        children,
        lastIndex,
        onChildChange,
        wrap
    ]);
    // Allow Carousel slides to be controlled outside the component
    (0, $1468c6296519704e$var$_react.useEffect)(function() {
        onControlledNavigation(activeIndex, activeChild, activeChildState, inTransition);
    }, [
        onControlledNavigation,
        activeIndex,
        activeChild,
        activeChildState,
        inTransition
    ]);
    var showArrows = controls && controls !== 'selectors';
    var showSelectors = controls && controls !== 'arrows';
    var CurrentIcon = theme.carousel.icons.current;
    var iconColor = (0, $4113023f9e0bafa0$exports.normalizeColor)(theme.carousel.icons.color || 'control', theme);
    var selectors = [];
    var wrappedChildren = $1468c6296519704e$var$_react.Children.map(children, function(child, index) {
        selectors.push(/*#__PURE__*/ $1468c6296519704e$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
            a11yTitle: format({
                id: 'carousel.jump',
                values: {
                    slide: index + 1
                }
            }),
            key: index,
            icon: /*#__PURE__*/ $1468c6296519704e$var$_react["default"].createElement(CurrentIcon, {
                color: activeIndex === index ? iconColor : undefined
            }),
            onClick: onSelect(index)
        }));
        return /*#__PURE__*/ $1468c6296519704e$var$_react["default"].createElement($2a42595435b6316a$export$b27165ff157668ed, {
            animationDuration: animationDuration,
            fill: fill || !!height || !!width,
            index: index,
            activeIndex: activeIndex,
            priorActiveIndex: priorActiveIndex,
            direction: direction
        }, child);
    });
    var NextIcon = theme.carousel.icons.next;
    var PreviousIcon = theme.carousel.icons.previous;
    var nextIconDisabled = !wrap && activeIndex >= lastIndex;
    var previousIconDisabled = !wrap && activeIndex <= 0;
    return /*#__PURE__*/ $1468c6296519704e$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onLeft: onLeft,
        onRight: onRight
    }, /*#__PURE__*/ $1468c6296519704e$var$_react["default"].createElement($3507974cae200b70$export$115e625c3f67bf98, $1468c6296519704e$var$_extends({
        fill: fill,
        height: height,
        width: width
    }, rest), showArrows && /*#__PURE__*/ $1468c6296519704e$var$_react["default"].createElement($3507974cae200b70$export$5c7b7f0e517b89f8, {
        offsetProp: "left",
        fill: "vertical"
    }, /*#__PURE__*/ $1468c6296519704e$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
        fill: "vertical",
        icon: /*#__PURE__*/ $1468c6296519704e$var$_react["default"].createElement(PreviousIcon, {
            color: (0, $4113023f9e0bafa0$exports.normalizeColor)(previousIconDisabled ? theme.carousel.disabled.icons.color : theme.carousel.icons.color, theme)
        }),
        a11yTitle: format({
            id: 'carousel.previous',
            values: {
                slide: activeIndex
            }
        }),
        plain: true,
        disabled: previousIconDisabled,
        onClick: onLeft,
        hoverIndicator: true
    })), wrappedChildren, showSelectors && /*#__PURE__*/ $1468c6296519704e$var$_react["default"].createElement($3507974cae200b70$export$5c7b7f0e517b89f8, {
        offsetProp: "bottom",
        fill: "horizontal"
    }, /*#__PURE__*/ $1468c6296519704e$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        justify: "end",
        fill: !showArrows && 'horizontal'
    }, /*#__PURE__*/ $1468c6296519704e$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        direction: "row",
        justify: "center"
    }, selectors))), showArrows && /*#__PURE__*/ $1468c6296519704e$var$_react["default"].createElement($3507974cae200b70$export$5c7b7f0e517b89f8, {
        offsetProp: "right",
        fill: "vertical"
    }, /*#__PURE__*/ $1468c6296519704e$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
        fill: "vertical",
        icon: /*#__PURE__*/ $1468c6296519704e$var$_react["default"].createElement(NextIcon, {
            color: (0, $4113023f9e0bafa0$exports.normalizeColor)(nextIconDisabled ? theme.carousel.disabled.icons.color : theme.carousel.icons.color, theme)
        }),
        a11yTitle: format({
            id: 'carousel.next',
            values: {
                slide: activeIndex + 2
            }
        }),
        plain: true,
        disabled: nextIconDisabled,
        onClick: onRight,
        hoverIndicator: true
    }))));
};
$1468c6296519704e$var$Carousel.displayName = 'Carousel';
$1468c6296519704e$var$Carousel.propTypes = $688718ff0cd866bd$export$4a1671f1b9579d0f;


$b9c1cc376265c38e$export$144901db2ea8e967 = $1468c6296519704e$export$144901db2ea8e967;


Object.keys($b9c1cc376265c38e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $b9c1cc376265c38e$exports[key]) return;
    $3321243da0932e1e$exports[key] = $b9c1cc376265c38e$exports[key];
});
var $d26ee9a4af4863b0$exports = {};

$parcel$export($d26ee9a4af4863b0$exports, "__esModule", function () { return $d26ee9a4af4863b0$export$1e511d4a378977f5; }, function (v) { return $d26ee9a4af4863b0$export$1e511d4a378977f5 = v; });
$parcel$export($d26ee9a4af4863b0$exports, "CheckBoxGroup", function () { return $d26ee9a4af4863b0$export$b6a68782c21a95ce; }, function (v) { return $d26ee9a4af4863b0$export$b6a68782c21a95ce = v; });
var $d26ee9a4af4863b0$export$1e511d4a378977f5;
var $d26ee9a4af4863b0$export$b6a68782c21a95ce;
"use strict";
$d26ee9a4af4863b0$export$1e511d4a378977f5 = true;
$d26ee9a4af4863b0$export$b6a68782c21a95ce = void 0;
var $6817aac1e2951c1d$export$1e511d4a378977f5;
var $6817aac1e2951c1d$export$b6a68782c21a95ce;
"use strict";
$6817aac1e2951c1d$export$1e511d4a378977f5 = true;
$6817aac1e2951c1d$export$b6a68782c21a95ce = void 0;

var $6817aac1e2951c1d$var$_react = $6817aac1e2951c1d$var$_interopRequireWildcard((parcelRequire("2xPiy")));
var $c15af89705eeb537$exports = {};

$parcel$export($c15af89705eeb537$exports, "__esModule", function () { return $c15af89705eeb537$export$1e511d4a378977f5; }, function (v) { return $c15af89705eeb537$export$1e511d4a378977f5 = v; });
$parcel$export($c15af89705eeb537$exports, "CheckBox", function () { return $c15af89705eeb537$export$ea5f704b89d806f6; }, function (v) { return $c15af89705eeb537$export$ea5f704b89d806f6 = v; });
var $c15af89705eeb537$export$1e511d4a378977f5;
var $c15af89705eeb537$export$ea5f704b89d806f6;
"use strict";
$c15af89705eeb537$export$1e511d4a378977f5 = true;
$c15af89705eeb537$export$ea5f704b89d806f6 = void 0;
var $572978a416f7ed0c$export$1e511d4a378977f5;
var $572978a416f7ed0c$export$ea5f704b89d806f6;
"use strict";
$572978a416f7ed0c$export$1e511d4a378977f5 = true;
$572978a416f7ed0c$export$ea5f704b89d806f6 = void 0;

var $572978a416f7ed0c$var$_react = $572978a416f7ed0c$var$_interopRequireWildcard((parcelRequire("2xPiy")));


var $2ae99504cff3abea$export$1e511d4a378977f5;
var $2ae99504cff3abea$export$7aa8af94cfcf92cd;
"use strict";
$2ae99504cff3abea$export$1e511d4a378977f5 = true;
$2ae99504cff3abea$export$7aa8af94cfcf92cd = void 0;

var $2ae99504cff3abea$var$_propTypes = $2ae99504cff3abea$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $2ae99504cff3abea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $2ae99504cff3abea$var$PropType = {};
$2ae99504cff3abea$var$PropType = {
    a11yTitle: $2ae99504cff3abea$var$_propTypes["default"].string,
    checked: $2ae99504cff3abea$var$_propTypes["default"].bool,
    disabled: $2ae99504cff3abea$var$_propTypes["default"].bool,
    fill: $2ae99504cff3abea$var$_propTypes["default"].bool,
    id: $2ae99504cff3abea$var$_propTypes["default"].string,
    label: $2ae99504cff3abea$var$_propTypes["default"].node,
    name: $2ae99504cff3abea$var$_propTypes["default"].string,
    onChange: $2ae99504cff3abea$var$_propTypes["default"].func,
    pad: $5897bd367fbd90c1$export$b91a2ef62736aae3,
    reverse: $2ae99504cff3abea$var$_propTypes["default"].bool,
    toggle: $2ae99504cff3abea$var$_propTypes["default"].bool,
    indeterminate: $2ae99504cff3abea$var$_propTypes["default"].bool
};
var $2ae99504cff3abea$var$CheckBoxPropTypes = $2ae99504cff3abea$export$7aa8af94cfcf92cd = $2ae99504cff3abea$var$PropType;


var $402df3dc3eceec07$export$1e511d4a378977f5;
var $402df3dc3eceec07$export$3bdb76e4c33903d5;
var $402df3dc3eceec07$export$848dcdc388a1c52f;
var $402df3dc3eceec07$export$cfaa8b267e569e86;
var $402df3dc3eceec07$export$59aa90b6aef14a9a;
var $402df3dc3eceec07$export$644eb5002e1279aa;
var $402df3dc3eceec07$export$85d649873caec356;
var $402df3dc3eceec07$export$150f188f805089fa;
"use strict";
$402df3dc3eceec07$export$1e511d4a378977f5 = true;
$402df3dc3eceec07$export$3bdb76e4c33903d5 = $402df3dc3eceec07$export$848dcdc388a1c52f = $402df3dc3eceec07$export$cfaa8b267e569e86 = $402df3dc3eceec07$export$59aa90b6aef14a9a = $402df3dc3eceec07$export$644eb5002e1279aa = $402df3dc3eceec07$export$85d649873caec356 = $402df3dc3eceec07$export$150f188f805089fa = void 0;

var $402df3dc3eceec07$var$_styledComponents = $402df3dc3eceec07$var$_interopRequireWildcard((parcelRequire("iA1nz")));


function $402df3dc3eceec07$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($402df3dc3eceec07$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
// Note: since `fillStyle` is only used in one place, `justify-content` was
// added to it to simplify its logic. If this is ever reused somewhere else,
// consider the need of separating those once again.
var $402df3dc3eceec07$var$fillStyle = function fillStyle() {
    return "\n      width: auto;\n      height: 100%;\n      max-width: none;\n      flex: 1 0 auto;\n      justify-content: space-between;\n    ";
};
var $402df3dc3eceec07$var$disabledStyle = "\n  opacity: 0.5;\n  cursor: default;\n";
var $402df3dc3eceec07$var$hoverStyle = (0, $402df3dc3eceec07$var$_styledComponents.css)([
    "&:hover input:not([disabled]) + div,&:hover input:not([disabled]) + span{border-color:",
    ";",
    "}&:hover{background-color:",
    ";}"
], function(props) {
    var _props$theme$checkBox;
    return (0, $4113023f9e0bafa0$exports.normalizeColor)((_props$theme$checkBox = props.theme.checkBox.hover) == null || (_props$theme$checkBox = _props$theme$checkBox.border) == null ? void 0 : _props$theme$checkBox.color, props.theme);
}, function(props) {
    var _props$theme$checkBox2;
    return (_props$theme$checkBox2 = props.theme.checkBox.hover) == null ? void 0 : _props$theme$checkBox2.extend;
}, function(props) {
    var _props$theme$checkBox3;
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(!props.disabled && ((_props$theme$checkBox3 = props.theme.checkBox.hover) == null || (_props$theme$checkBox3 = _props$theme$checkBox3.background) == null ? void 0 : _props$theme$checkBox3.color), props.theme);
});
var $402df3dc3eceec07$var$StyledCheckBoxIcon = $402df3dc3eceec07$export$59aa90b6aef14a9a = $402df3dc3eceec07$var$_styledComponents["default"].svg.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxIcon",
    componentId: "sc-1dbk5ju-0"
})([
    "box-sizing:border-box;stroke-width:",
    ";stroke:",
    ";width:",
    ";height:",
    ";",
    ";"
], function(props) {
    return props.theme.checkBox.check.thickness;
}, function(props) {
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.checkBox.color || 'control', props.theme);
}, function(props) {
    return props.theme.checkBox.icon.size || props.theme.checkBox.size;
}, function(props) {
    return props.theme.checkBox.icon.size || props.theme.checkBox.size;
}, function(props) {
    return props.theme.checkBox.icon.extend;
});
var $402df3dc3eceec07$var$StyledCheckBoxContainer = $402df3dc3eceec07$export$644eb5002e1279aa = $402df3dc3eceec07$var$_styledComponents["default"].label.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxContainer",
    componentId: "sc-1dbk5ju-1"
})([
    "display:flex;flex-direction:row;align-items:",
    ";user-select:none;-webkit-user-select:none;",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return typeof props.labelProp === 'string' ? props.theme.checkBox.label.align : undefined;
}, function(props) {
    return props.fillProp ? $402df3dc3eceec07$var$fillStyle() : 'width: fit-content;';
}, function(props) {
    return (props.pad || props.theme.checkBox.pad) && (0, $4113023f9e0bafa0$exports.edgeStyle)('padding', props.pad || props.theme.checkBox.pad, props.responsive, props.theme.box.responsiveBreakpoint, props.theme);
}, function(props) {
    return props.disabled && $402df3dc3eceec07$var$disabledStyle;
}, function(props) {
    return !props.disabled && 'cursor: pointer;';
}, $402df3dc3eceec07$var$hoverStyle, function(props) {
    var _props$theme$checkBox4, _props$theme$checkBox5;
    return props.focus && !props.focusIndicator && "\n    input:not([disabled]) + div,\n    input:not([disabled]) + span {\n      border-color: " + (0, $4113023f9e0bafa0$exports.normalizeColor)((_props$theme$checkBox4 = props.theme.checkBox.hover) == null || (_props$theme$checkBox4 = _props$theme$checkBox4.border) == null ? void 0 : _props$theme$checkBox4.color, props.theme) + ";\n    }\n\n    background-color: " + (0, $4113023f9e0bafa0$exports.normalizeColor)(!props.disabled && ((_props$theme$checkBox5 = props.theme.checkBox.hover) == null || (_props$theme$checkBox5 = _props$theme$checkBox5.background) == null ? void 0 : _props$theme$checkBox5.color), props.theme) + ";";
}, function(props) {
    return props.theme.checkBox.extend;
});
var $402df3dc3eceec07$var$StyledCheckBoxInput = $402df3dc3eceec07$export$cfaa8b267e569e86 = $402df3dc3eceec07$var$_styledComponents["default"].input.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxInput",
    componentId: "sc-1dbk5ju-2"
})([
    "opacity:0;-moz-appearance:none;width:0;height:0;margin:0;",
    " &:checked + span > span{",
    ":calc( ",
    " - ",
    " );background:",
    ";}"
], function(props) {
    return !props.disabled && 'cursor: pointer;';
}, function(props) {
    return !props.theme.dir ? 'left' : 'right';
}, function(props) {
    return props.theme.checkBox.toggle.size;
}, function(props) {
    return props.theme.checkBox.size;
}, function(props) {
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.checkBox.color || 'control', props.theme);
});
var $402df3dc3eceec07$var$StyledCheckBoxBox = $402df3dc3eceec07$export$85d649873caec356 = (0, $402df3dc3eceec07$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxBox",
    componentId: "sc-1dbk5ju-3"
})([
    "",
    ";",
    ";"
], function(props) {
    return props.focus && props.focusIndicator && (0, $4113023f9e0bafa0$exports.focusStyle)();
}, function(props) {
    return props.theme.checkBox.check.extend;
});
var $402df3dc3eceec07$var$StyledCheckBoxToggle = $402df3dc3eceec07$export$3bdb76e4c33903d5 = $402df3dc3eceec07$var$_styledComponents["default"].span.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxToggle",
    componentId: "sc-1dbk5ju-4"
})([
    "box-sizing:border-box;vertical-align:middle;display:inline-block;width:",
    ";height:",
    ";border:",
    " solid;border-color:",
    ";border-radius:",
    ";background-color:",
    ";",
    ";",
    ";"
], function(props) {
    return props.theme.checkBox.toggle.size;
}, function(props) {
    return props.theme.checkBox.size;
}, function(props) {
    return props.theme.checkBox.border.width;
}, function(props) {
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.checkBox.border.color, props.theme);
}, function(props) {
    return props.theme.checkBox.toggle.radius;
}, function(props) {
    return props.theme.checkBox.toggle.background ? (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.checkBox.toggle.background, props.theme) : 'transparent';
}, function(props) {
    return props.focus && props.focusIndicator && (0, $4113023f9e0bafa0$exports.focusStyle)();
}, function(props) {
    return props.theme.checkBox.toggle.extend;
});
var $402df3dc3eceec07$var$StyledCheckBoxKnob = $402df3dc3eceec07$export$848dcdc388a1c52f = $402df3dc3eceec07$var$_styledComponents["default"].span.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxKnob",
    componentId: "sc-1dbk5ju-5"
})([
    "box-sizing:border-box;position:relative;display:inherit;top:-",
    ";",
    ":-",
    ";transition:all 0.3s;width:",
    ";height:",
    ";background:",
    ";border-radius:",
    ";",
    ";"
], function(props) {
    return props.theme.checkBox.border.width;
}, function(props) {
    return !props.theme.dir ? 'left' : 'right';
}, function(props) {
    return props.theme.checkBox.border.width;
}, function(props) {
    return props.theme.checkBox.size;
}, function(props) {
    return props.theme.checkBox.size;
}, function(props) {
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.checkBox.toggle.color, props.theme);
}, function(props) {
    return props.theme.checkBox.toggle.radius;
}, function(props) {
    return props.theme.checkBox.toggle.knob.extend;
});
var $402df3dc3eceec07$var$StyledCheckBox = $402df3dc3eceec07$export$150f188f805089fa = (0, $402df3dc3eceec07$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "StyledCheckBox",
    componentId: "sc-1dbk5ju-6"
})([
    "flex-shrink:0;"
]);




var $572978a416f7ed0c$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "checked",
    "children",
    "containerProps",
    "defaultChecked",
    "disabled",
    "fill",
    "focus",
    "focusIndicator",
    "id",
    "label",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseOut",
    "onMouseOver",
    "pad",
    "reverse",
    "toggle",
    "indeterminate"
];
function $572978a416f7ed0c$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($572978a416f7ed0c$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $572978a416f7ed0c$var$_extends() {
    return $572978a416f7ed0c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $572978a416f7ed0c$var$_extends.apply(null, arguments);
}
function $572978a416f7ed0c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $572978a416f7ed0c$var$stopLabelClick = function stopLabelClick(event) {
    // prevents clicking on the label trigging the event twice
    // https://stackoverflow.com/questions/24501497/why-the-onclick-element-will-trigger-twice-for-label-element
    if (event.target.type !== 'checkbox') event.stopPropagation();
};
var $572978a416f7ed0c$var$CheckBox = $572978a416f7ed0c$export$ea5f704b89d806f6 = /*#__PURE__*/ (0, $572978a416f7ed0c$var$_react.forwardRef)(function(_ref, ref) {
    var _ref2;
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], checkedProp = _ref.checked, children = _ref.children, containerProps = _ref.containerProps, _ref$defaultChecked = _ref.defaultChecked, defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked, disabled = _ref.disabled, fill = _ref.fill, focusProp = _ref.focus, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, id = _ref.id, label = _ref.label, name = _ref.name, _onBlur = _ref.onBlur, _onChange = _ref.onChange, _onFocus = _ref.onFocus, _onMouseEnter = _ref.onMouseEnter, _onMouseLeave = _ref.onMouseLeave, _onMouseOut = _ref.onMouseOut, _onMouseOver = _ref.onMouseOver, pad = _ref.pad, reverse = _ref.reverse, toggle = _ref.toggle, indeterminate = _ref.indeterminate, rest = $572978a416f7ed0c$var$_objectWithoutPropertiesLoose(_ref, $572978a416f7ed0c$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var formContext = (0, $572978a416f7ed0c$var$_react.useContext)($5c9c2e034f522b3e$export$c24727297075ec6a);
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: checkedProp,
        initialValue: defaultChecked
    }), checked = _formContext$useFormI[0], setChecked = _formContext$useFormI[1];
    var _useState = (0, $572978a416f7ed0c$var$_react.useState)(focusProp), focus = _useState[0], setFocus = _useState[1];
    (0, $572978a416f7ed0c$var$_react.useEffect)(function() {
        // don't allow checkbox to have focus when disabled
        if (disabled && focusProp) setFocus(false);
        else setFocus(focusProp);
    }, [
        disabled,
        focusProp
    ]);
    (0, $572978a416f7ed0c$var$_react.useEffect)(function() {
        if (checkedProp && indeterminate) console.warn('Checkbox cannot be "checked" and "indeterminate" at the same time.');
        if (toggle && indeterminate) console.warn('Checkbox of type toggle does not have "indeterminate" state.');
    }, [
        checkedProp,
        toggle,
        indeterminate
    ]);
    var themeableProps = {
        checked: checked,
        disabled: disabled,
        focus: focus,
        // when contained in a FormField, focusIndicator = false,
        // so that the FormField has focus style. However, we still
        // need to visually indicate when a CheckBox is active.
        // If focus = true but focusIndicator = false,
        // we will apply the hover treament.
        focusIndicator: focusIndicator,
        reverse: reverse,
        toggle: toggle,
        indeterminate: indeterminate
    };
    var hidden;
    if (disabled && checked) hidden = /*#__PURE__*/ $572978a416f7ed0c$var$_react["default"].createElement("input", {
        name: name,
        type: "hidden",
        value: "true"
    });
    var _theme$checkBox$icons = theme.checkBox.icons, CheckedIcon = _theme$checkBox$icons.checked, IndeterminateIcon = _theme$checkBox$icons.indeterminate;
    var borderColor = (0, $4113023f9e0bafa0$exports.normalizeColor)(theme.checkBox.border.color, theme);
    if (checked) borderColor = (0, $4113023f9e0bafa0$exports.normalizeColor)(theme.checkBox.color || 'control', theme);
    var visual = toggle ? /*#__PURE__*/ $572978a416f7ed0c$var$_react["default"].createElement($402df3dc3eceec07$export$3bdb76e4c33903d5, $572978a416f7ed0c$var$_extends({}, passThemeFlag, themeableProps), /*#__PURE__*/ $572978a416f7ed0c$var$_react["default"].createElement($402df3dc3eceec07$export$848dcdc388a1c52f, $572978a416f7ed0c$var$_extends({}, passThemeFlag, themeableProps))) : /*#__PURE__*/ $572978a416f7ed0c$var$_react["default"].createElement($402df3dc3eceec07$export$85d649873caec356, $572978a416f7ed0c$var$_extends({
        align: "center",
        justify: "center",
        width: theme.checkBox.size,
        height: theme.checkBox.size,
        border: {
            size: theme.checkBox.border.width,
            color: borderColor
        },
        round: theme.checkBox.check.radius
    }, passThemeFlag, themeableProps), !indeterminate && checked && (CheckedIcon ? /*#__PURE__*/ $572978a416f7ed0c$var$_react["default"].createElement(CheckedIcon, {
        theme: theme,
        as: $402df3dc3eceec07$export$59aa90b6aef14a9a
    }) : /*#__PURE__*/ $572978a416f7ed0c$var$_react["default"].createElement($402df3dc3eceec07$export$59aa90b6aef14a9a, $572978a416f7ed0c$var$_extends({
        theme: theme,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "xMidYMid meet"
    }, themeableProps), /*#__PURE__*/ $572978a416f7ed0c$var$_react["default"].createElement("path", {
        fill: "none",
        d: "M6,11.3 L10.3,16 L18,6.2"
    }))), !checked && indeterminate && (IndeterminateIcon ? /*#__PURE__*/ $572978a416f7ed0c$var$_react["default"].createElement(IndeterminateIcon, {
        theme: theme,
        as: $402df3dc3eceec07$export$59aa90b6aef14a9a
    }) : /*#__PURE__*/ $572978a416f7ed0c$var$_react["default"].createElement($402df3dc3eceec07$export$59aa90b6aef14a9a, $572978a416f7ed0c$var$_extends({
        theme: theme,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "xMidYMid meet"
    }, themeableProps), /*#__PURE__*/ $572978a416f7ed0c$var$_react["default"].createElement("path", {
        fill: "none",
        d: "M6,12 L18,12"
    }))));
    var side = !reverse !== !theme.dir ? 'left' : 'right';
    var checkBoxNode = /*#__PURE__*/ $572978a416f7ed0c$var$_react["default"].createElement($402df3dc3eceec07$export$150f188f805089fa, $572978a416f7ed0c$var$_extends({
        align: "center",
        justify: "center",
        margin: label && (_ref2 = {}, _ref2[side] = theme.checkBox.gap, _ref2)
    }, themeableProps), /*#__PURE__*/ $572978a416f7ed0c$var$_react["default"].createElement($402df3dc3eceec07$export$cfaa8b267e569e86, $572978a416f7ed0c$var$_extends({
        "aria-label": ariaLabel || a11yTitle
    }, passThemeFlag, rest, {
        ref: ref,
        type: "checkbox"
    }, (0, $ebafa0e8c9355c24$export$c499305a875a8ee9)({
        id: id,
        name: name,
        checked: checked,
        disabled: disabled
    }), themeableProps, {
        onFocus: function onFocus(event) {
            setFocus(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        onChange: function onChange(event) {
            setChecked(event.target.checked);
            if (_onChange) _onChange(event);
        }
    })), children ? children({
        checked: checked,
        indeterminate: indeterminate
    }) : visual, hidden);
    var normalizedLabel = typeof label === 'string' ? /*#__PURE__*/ $572978a416f7ed0c$var$_react["default"].createElement("span", null, label) : label;
    var first = reverse ? normalizedLabel : checkBoxNode;
    var second = reverse ? checkBoxNode : normalizedLabel;
    return /*#__PURE__*/ $572978a416f7ed0c$var$_react["default"].createElement($402df3dc3eceec07$export$644eb5002e1279aa, $572978a416f7ed0c$var$_extends({
        fillProp: fill,
        reverse: reverse
    }, (0, $ebafa0e8c9355c24$export$c499305a875a8ee9)({
        htmlFor: id,
        disabled: disabled
    }), {
        checked: checked,
        labelProp: label,
        onClick: $572978a416f7ed0c$var$stopLabelClick,
        pad: pad,
        onMouseEnter: function onMouseEnter(event) {
            return _onMouseEnter == null ? void 0 : _onMouseEnter(event);
        },
        onMouseOver: function onMouseOver(event) {
            return _onMouseOver == null ? void 0 : _onMouseOver(event);
        },
        onMouseLeave: function onMouseLeave(event) {
            return _onMouseLeave == null ? void 0 : _onMouseLeave(event);
        },
        onMouseOut: function onMouseOut(event) {
            return _onMouseOut == null ? void 0 : _onMouseOut(event);
        }
    }, passThemeFlag, themeableProps, containerProps), first, second);
});
$572978a416f7ed0c$var$CheckBox.displayName = 'CheckBox';
$572978a416f7ed0c$var$CheckBox.propTypes = $2ae99504cff3abea$export$7aa8af94cfcf92cd;


$c15af89705eeb537$export$ea5f704b89d806f6 = $572978a416f7ed0c$export$ea5f704b89d806f6;



var $e018103171c318a4$export$1e511d4a378977f5;
var $e018103171c318a4$export$16c1e3500516c0d8;
"use strict";
$e018103171c318a4$export$1e511d4a378977f5 = true;
$e018103171c318a4$export$16c1e3500516c0d8 = void 0;

var $e018103171c318a4$var$_styledComponents = $e018103171c318a4$var$_interopRequireDefault((parcelRequire("iA1nz")));

function $e018103171c318a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $e018103171c318a4$var$StyledCheckBoxGroup = $e018103171c318a4$export$16c1e3500516c0d8 = (0, $e018103171c318a4$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "StyledCheckBoxGroup",
    componentId: "sc-2nhc5d-0"
})([
    "",
    ""
], function(props) {
    return props.theme.checkBoxGroup && props.theme.checkBoxGroup.container && props.theme.checkBoxGroup.container.extend;
});


var $aaf6d7ec653b7665$export$1e511d4a378977f5;
var $aaf6d7ec653b7665$export$7b69d769ba440e56;
"use strict";
$aaf6d7ec653b7665$export$1e511d4a378977f5 = true;
$aaf6d7ec653b7665$export$7b69d769ba440e56 = void 0;

var $aaf6d7ec653b7665$var$_propTypes = $aaf6d7ec653b7665$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $aaf6d7ec653b7665$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $aaf6d7ec653b7665$var$PropType = {};
$aaf6d7ec653b7665$var$PropType = {
    value: $aaf6d7ec653b7665$var$_propTypes["default"].arrayOf($aaf6d7ec653b7665$var$_propTypes["default"].oneOfType([
        $aaf6d7ec653b7665$var$_propTypes["default"].number,
        $aaf6d7ec653b7665$var$_propTypes["default"].string
    ])),
    defaultValue: $aaf6d7ec653b7665$var$_propTypes["default"].arrayOf($aaf6d7ec653b7665$var$_propTypes["default"].oneOfType([
        $aaf6d7ec653b7665$var$_propTypes["default"].string,
        $aaf6d7ec653b7665$var$_propTypes["default"].number
    ])),
    disabled: $aaf6d7ec653b7665$var$_propTypes["default"].bool,
    labelKey: $aaf6d7ec653b7665$var$_propTypes["default"].string,
    name: $aaf6d7ec653b7665$var$_propTypes["default"].string,
    onChange: $aaf6d7ec653b7665$var$_propTypes["default"].func,
    options: $aaf6d7ec653b7665$var$_propTypes["default"].oneOfType([
        $aaf6d7ec653b7665$var$_propTypes["default"].arrayOf($aaf6d7ec653b7665$var$_propTypes["default"].string),
        $aaf6d7ec653b7665$var$_propTypes["default"].arrayOf($aaf6d7ec653b7665$var$_propTypes["default"].shape({}))
    ]),
    valueKey: $aaf6d7ec653b7665$var$_propTypes["default"].string
};
var $aaf6d7ec653b7665$var$CheckBoxGroupPropTypes = $aaf6d7ec653b7665$export$7b69d769ba440e56 = $aaf6d7ec653b7665$var$PropType;



var $6817aac1e2951c1d$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "children",
    "defaultValue",
    "value",
    "disabled",
    "focusIndicator",
    "gap",
    "id",
    "labelKey",
    "valueKey",
    "onChange",
    "options",
    "name"
], $6817aac1e2951c1d$var$_excluded2 = [
    "value"
];
function $6817aac1e2951c1d$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($6817aac1e2951c1d$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $6817aac1e2951c1d$var$_extends() {
    return $6817aac1e2951c1d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6817aac1e2951c1d$var$_extends.apply(null, arguments);
}
function $6817aac1e2951c1d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $6817aac1e2951c1d$var$CheckBoxGroup = $6817aac1e2951c1d$export$b6a68782c21a95ce = /*#__PURE__*/ (0, $6817aac1e2951c1d$var$_react.forwardRef)(function(_ref, ref) {
    var _formContext$useFormF, _theme$checkBoxGroup;
    var ariaLabelProp = _ref['aria-label'], ariaLabelledByProp = _ref['aria-labelledby'], children = _ref.children, defaultValue = _ref.defaultValue, valueProp = _ref.value, disabledProp = _ref.disabled, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, gap = _ref.gap, id = _ref.id, labelKey = _ref.labelKey, valueKey = _ref.valueKey, onChange = _ref.onChange, optionsProp = _ref.options, name = _ref.name, rest = $6817aac1e2951c1d$var$_objectWithoutPropertiesLoose(_ref, $6817aac1e2951c1d$var$_excluded);
    var formContext = (0, $6817aac1e2951c1d$var$_react.useContext)($5c9c2e034f522b3e$export$c24727297075ec6a);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    // In case option is a string, normalize it to be an object
    var options = optionsProp.map(function(option) {
        return typeof option === 'string' ? {
            disabled: disabledProp,
            value: option,
            label: option
        } : option;
    });
    // 'value' is an array of checked valueKeys
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp,
        initialValue: defaultValue || []
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    // Logic is necessary to maintain a proper data structure for Form logic
    var onCheckBoxChange = function onCheckBoxChange(event, optionValue, option) {
        // deep copy of value
        var nextValue = JSON.parse(JSON.stringify(value)) || [];
        var optionIndex = nextValue.indexOf(optionValue);
        // If the value option isn't in the array, add it.
        // Otherwise, remove it.
        if (optionIndex < 0) nextValue.push(optionValue);
        else nextValue.splice(optionIndex, 1);
        setValue(nextValue);
        // Similar functionality to Select onChange()
        if (onChange) {
            event.persist(); // extract from React synthetic event pool
            var adjustedEvent = event;
            adjustedEvent.value = nextValue;
            adjustedEvent.option = option;
            onChange(adjustedEvent);
        }
    };
    var ariaLabelledBy;
    if (formContext != null && (_formContext$useFormF = formContext.useFormField({})) != null && _formContext$useFormF.inForm && id && !ariaLabelProp) ariaLabelledBy = "grommet-" + id + "__label";
    return /*#__PURE__*/ $6817aac1e2951c1d$var$_react["default"].createElement($e018103171c318a4$export$16c1e3500516c0d8, $6817aac1e2951c1d$var$_extends({
        ref: ref,
        "aria-label": ariaLabelProp,
        "aria-labelledby": ariaLabelledByProp || ariaLabelledBy,
        role: "group"
    }, theme.checkBoxGroup.container, {
        gap: gap || ((_theme$checkBoxGroup = theme.checkBoxGroup) == null || (_theme$checkBoxGroup = _theme$checkBoxGroup.container) == null ? void 0 : _theme$checkBoxGroup.gap),
        id: id
    }, passThemeFlag, rest), options.map(function(option, index) {
        var optionValue = option.value;
        var label = labelKey ? option[labelKey] : option.label;
        var valueOption = valueKey ? option[valueKey] : optionValue;
        var checked = value.indexOf(valueOption) >= 0;
        var disabled = disabledProp || option.disabled;
        var key = label + "-" + valueOption;
        if (option.checked) console.warn("'checked' prop of an individual CheckBox shouldn't be used in a CheckBoxGroup component. Use the CheckBoxGroup 'value' prop instead.");
        // value shouldn't propagate the input field and the onChange option
        var omit = option.value, optionRest = $6817aac1e2951c1d$var$_objectWithoutPropertiesLoose(option, $6817aac1e2951c1d$var$_excluded2);
        var optionProps = $6817aac1e2951c1d$var$_extends({}, optionRest, {
            label: label,
            disabled: disabled
        });
        return /*#__PURE__*/ $6817aac1e2951c1d$var$_react["default"].createElement($c15af89705eeb537$export$ea5f704b89d806f6, $6817aac1e2951c1d$var$_extends({
            key: key
        }, optionProps, {
            disabled: disabled,
            checked: checked,
            focusIndicator: focusIndicator,
            label: label,
            onChange: function onChange(event) {
                return onCheckBoxChange(event, valueOption, optionProps);
            }
        }), children ? function(state) {
            return children(options[index], state);
        } : null);
    }));
});
$6817aac1e2951c1d$var$CheckBoxGroup.displayName = 'CheckBoxGroup';
$6817aac1e2951c1d$var$CheckBoxGroup.propTypes = $aaf6d7ec653b7665$export$7b69d769ba440e56;


$d26ee9a4af4863b0$export$b6a68782c21a95ce = $6817aac1e2951c1d$export$b6a68782c21a95ce;


Object.keys($d26ee9a4af4863b0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $d26ee9a4af4863b0$exports[key]) return;
    $3321243da0932e1e$exports[key] = $d26ee9a4af4863b0$exports[key];
});
var $f6c8c05e7d725926$exports = {};

$parcel$export($f6c8c05e7d725926$exports, "__esModule", function () { return $f6c8c05e7d725926$export$1e511d4a378977f5; }, function (v) { return $f6c8c05e7d725926$export$1e511d4a378977f5 = v; });
$parcel$export($f6c8c05e7d725926$exports, "round", function () { return $f6c8c05e7d725926$export$2077e0241d6afd3c; }, function (v) { return $f6c8c05e7d725926$export$2077e0241d6afd3c = v; });
$parcel$export($f6c8c05e7d725926$exports, "calcs", function () { return $f6c8c05e7d725926$export$f210a4934359ec3b; }, function (v) { return $f6c8c05e7d725926$export$f210a4934359ec3b = v; });
$parcel$export($f6c8c05e7d725926$exports, "calcBounds", function () { return $f6c8c05e7d725926$export$de5d4336bd2f6d1d; }, function (v) { return $f6c8c05e7d725926$export$de5d4336bd2f6d1d = v; });
$parcel$export($f6c8c05e7d725926$exports, "Chart", function () { return $f6c8c05e7d725926$export$acaa6426d77a227e; }, function (v) { return $f6c8c05e7d725926$export$acaa6426d77a227e = v; });
var $f6c8c05e7d725926$export$1e511d4a378977f5;
var $f6c8c05e7d725926$export$2077e0241d6afd3c;
var $f6c8c05e7d725926$export$f210a4934359ec3b;
var $f6c8c05e7d725926$export$de5d4336bd2f6d1d;
var $f6c8c05e7d725926$export$acaa6426d77a227e;
"use strict";
$f6c8c05e7d725926$export$1e511d4a378977f5 = true;
$f6c8c05e7d725926$export$2077e0241d6afd3c = $f6c8c05e7d725926$export$f210a4934359ec3b = $f6c8c05e7d725926$export$de5d4336bd2f6d1d = $f6c8c05e7d725926$export$acaa6426d77a227e = void 0;
var $0ca1ee83594b9234$export$1e511d4a378977f5;
var $0ca1ee83594b9234$export$acaa6426d77a227e;
"use strict";
$0ca1ee83594b9234$export$1e511d4a378977f5 = true;
$0ca1ee83594b9234$export$acaa6426d77a227e = void 0;

var $0ca1ee83594b9234$var$_react = $0ca1ee83594b9234$var$_interopRequireWildcard((parcelRequire("2xPiy")));


var $0261c638c9cffc45$export$1e511d4a378977f5;
var $0261c638c9cffc45$export$8809c6727dc0976b;
"use strict";
$0261c638c9cffc45$export$1e511d4a378977f5 = true;
$0261c638c9cffc45$export$8809c6727dc0976b = void 0;

var $0261c638c9cffc45$var$_styledComponents = $0261c638c9cffc45$var$_interopRequireWildcard((parcelRequire("iA1nz")));

function $0261c638c9cffc45$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($0261c638c9cffc45$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $0261c638c9cffc45$var$animateStyle = function animateStyle(_ref) {
    var theme = _ref.theme, typeProp = _ref.typeProp;
    var animateBounds;
    if (typeProp === 'line') // 200% allows the line to be squiggly
    animateBounds = [
        'stroke-dashoffset: 200%;',
        'stroke-dashoffset: 0%;'
    ];
    else if (typeProp === 'point') animateBounds = [
        'opacity: 0;',
        'opacity: 1;'
    ];
    else animateBounds = [
        'transform: scaleY(0);',
        'transform: scaleY(1);'
    ];
    return (0, $0261c638c9cffc45$var$_styledComponents.css)([
        "",
        " animation:",
        " ",
        " forwards;",
        ""
    ], typeProp === 'line' && 'stroke-dasharray: 200%;', (0, $0261c638c9cffc45$var$_styledComponents.keyframes)([
        "from{",
        "}to{",
        "}"
    ], animateBounds[0], animateBounds[1]), theme.global.animation.duration, (typeProp === 'bar' || typeProp === 'area') && 'transform-origin: center bottom 0;');
};
var $0261c638c9cffc45$var$StyledChart = $0261c638c9cffc45$export$8809c6727dc0976b = $0261c638c9cffc45$var$_styledComponents["default"].svg.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledChart",
    componentId: "sc-1nae0gf-0"
})([
    "display:block;max-width:100%;overflow:visible;",
    " ",
    " ",
    ";"
], $4113023f9e0bafa0$exports.genericStyles, function(props) {
    return props.animate && $0261c638c9cffc45$var$animateStyle(props);
}, function(props) {
    return props.theme.chart && props.theme.chart.extend;
});


var $83d745eec3f15823$export$1e511d4a378977f5;
var $83d745eec3f15823$export$6a3a240ee501e276;
var $83d745eec3f15823$export$6e207fa74e4b4899;
var $83d745eec3f15823$export$d120e998a826f71d;
var $83d745eec3f15823$export$c81e3dc883dc7c5b;
var $83d745eec3f15823$export$966f3352140ed90c;
"use strict";
$83d745eec3f15823$export$1e511d4a378977f5 = true;
$83d745eec3f15823$export$6a3a240ee501e276 = $83d745eec3f15823$export$6e207fa74e4b4899 = $83d745eec3f15823$export$d120e998a826f71d = $83d745eec3f15823$export$c81e3dc883dc7c5b = $83d745eec3f15823$export$966f3352140ed90c = void 0;
var $83d745eec3f15823$var$normalizeValues = $83d745eec3f15823$export$6a3a240ee501e276 = function normalizeValues(values) {
    return (values || []).map(function(value, index) {
        if (value === undefined) return {
            value: [
                index,
                undefined
            ]
        };
        if (Array.isArray(value)) return {
            value: value
        };
        if (typeof value === 'object') return value;
        return {
            value: [
                index,
                value
            ]
        };
    });
};
var $83d745eec3f15823$var$calcMinMax = $83d745eec3f15823$export$d120e998a826f71d = function calcMinMax(values, direction) {
    var _ref, _ref2, _ref3, _ref4;
    if (values === void 0) values = [];
    // We default to 0 minimum as that's typically what's wanted.
    // If callers want a narrower band, they can pass bounds explicitly.
    var min0 = (_ref = direction && 0) != null ? _ref : undefined;
    var max0 = (_ref2 = direction && 1) != null ? _ref2 : undefined;
    var min1 = (_ref3 = direction && 0) != null ? _ref3 : undefined;
    var max1 = (_ref4 = direction && 1) != null ? _ref4 : undefined;
    values.forEach(function(value) {
        var _value$value = value.value, val0 = _value$value[0], val1 = _value$value[1], val2 = _value$value[2];
        if (val0 !== undefined) {
            min0 = min0 === undefined ? val0 : Math.min(min0, val0);
            max0 = max0 === undefined ? val0 : Math.max(max0, val0);
        }
        if (val1 !== undefined) {
            min1 = min1 === undefined ? val1 : Math.min(min1, val1);
            max1 = max1 === undefined ? val1 : Math.max(max1, val1);
        }
        if (val2 !== undefined) {
            min1 = min1 === undefined ? val2 : Math.min(min1, val2);
            max1 = max1 === undefined ? val2 : Math.max(max1, val2);
        }
    });
    // when max === min, offset them so we can show something
    if (max0 === min0) {
        if (max0 > 0) min0 = max0 - 1;
        else max0 = min0 + 1;
    }
    if (max1 === min1) {
        if (max1 > 0) min1 = max1 - 1;
        else max1 = min1 + 1;
    }
    return direction === 'horizontal' ? {
        x: {
            min: min1,
            max: max1
        },
        y: {
            min: min0,
            max: max0
        }
    } : {
        x: {
            min: min0,
            max: max0
        },
        y: {
            min: min1,
            max: max1
        }
    };
};
var $83d745eec3f15823$var$normalizeBounds = $83d745eec3f15823$export$6e207fa74e4b4899 = function normalizeBounds(boundsProp, values, direction) {
    var result;
    if (Array.isArray(boundsProp)) result = {
        x: {
            min: boundsProp[0][0],
            max: boundsProp[0][1]
        },
        y: {
            min: boundsProp[1][0],
            max: boundsProp[1][1]
        }
    };
    else if (typeof boundsProp === 'object') result = boundsProp;
    else result = $83d745eec3f15823$var$calcMinMax(values, direction);
    return result;
};
var $83d745eec3f15823$var$areNormalizedValuesEquals = $83d745eec3f15823$export$c81e3dc883dc7c5b = function areNormalizedValuesEquals(valuesX, valuesY) {
    console.warn("This function will be removed in the upcoming releases.\nPlease get in touch with us if you have concerns.");
    if (!valuesX || !valuesY) return false;
    if (valuesX.length !== valuesY.length) return false;
    if (valuesX.length === 0) return true;
    if (!valuesX[0].value || !valuesY[0].value) return false;
    return valuesX.every(function(_, i) {
        return valuesX[i].value.every(function(value, index) {
            return value === valuesY[i].value[index];
        });
    });
};
var $83d745eec3f15823$var$areNormalizedBoundsEquals = $83d745eec3f15823$export$966f3352140ed90c = function areNormalizedBoundsEquals(boundsX, boundsY) {
    console.warn("This function will be removed in the upcoming releases.\nPlease get in touch with us if you have concerns.");
    if (!boundsX || !boundsY) return false;
    if (boundsX.length !== boundsY.length || !(boundsX.length > 0)) return false;
    return boundsX.every(function(_, i) {
        return boundsX[i].every(function(value, index) {
            return value === boundsY[i][index];
        });
    });
};


var $af8ece92f217fcd1$export$1e511d4a378977f5;
var $af8ece92f217fcd1$export$a45818ccd4fd946d;
"use strict";
$af8ece92f217fcd1$export$1e511d4a378977f5 = true;
$af8ece92f217fcd1$export$a45818ccd4fd946d = void 0;

var $af8ece92f217fcd1$var$_propTypes = $af8ece92f217fcd1$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $af8ece92f217fcd1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $af8ece92f217fcd1$var$_extends() {
    return $af8ece92f217fcd1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $af8ece92f217fcd1$var$_extends.apply(null, arguments);
}
var $af8ece92f217fcd1$var$thicknessType = $af8ece92f217fcd1$var$_propTypes["default"].oneOfType([
    $af8ece92f217fcd1$var$_propTypes["default"].oneOf([
        'hair',
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge',
        'none'
    ]),
    $af8ece92f217fcd1$var$_propTypes["default"].string,
    $af8ece92f217fcd1$var$_propTypes["default"].number
]);
var $af8ece92f217fcd1$var$PropType = {};
$af8ece92f217fcd1$var$PropType = $af8ece92f217fcd1$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    animate: $af8ece92f217fcd1$var$_propTypes["default"].bool,
    bounds: $af8ece92f217fcd1$var$_propTypes["default"].oneOfType([
        $af8ece92f217fcd1$var$_propTypes["default"].shape({
            x: $af8ece92f217fcd1$var$_propTypes["default"].shape({
                min: $af8ece92f217fcd1$var$_propTypes["default"].number,
                max: $af8ece92f217fcd1$var$_propTypes["default"].number
            }),
            y: $af8ece92f217fcd1$var$_propTypes["default"].shape({
                min: $af8ece92f217fcd1$var$_propTypes["default"].number,
                max: $af8ece92f217fcd1$var$_propTypes["default"].number
            })
        }),
        $af8ece92f217fcd1$var$_propTypes["default"].arrayOf($af8ece92f217fcd1$var$_propTypes["default"].arrayOf($af8ece92f217fcd1$var$_propTypes["default"].number))
    ]),
    color: $af8ece92f217fcd1$var$_propTypes["default"].oneOfType([
        $5897bd367fbd90c1$export$fc4c368d97afb623,
        $af8ece92f217fcd1$var$_propTypes["default"].shape({
            color: $5897bd367fbd90c1$export$fc4c368d97afb623,
            // deprecated, use top level 'opacity'
            opacity: $af8ece92f217fcd1$var$_propTypes["default"].oneOfType([
                $af8ece92f217fcd1$var$_propTypes["default"].oneOf([
                    'weak',
                    'medium',
                    'strong'
                ]),
                $af8ece92f217fcd1$var$_propTypes["default"].bool
            ])
        }),
        $af8ece92f217fcd1$var$_propTypes["default"].arrayOf($af8ece92f217fcd1$var$_propTypes["default"].shape({
            color: $5897bd367fbd90c1$export$fc4c368d97afb623,
            value: $af8ece92f217fcd1$var$_propTypes["default"].number
        }))
    ]),
    id: $af8ece92f217fcd1$var$_propTypes["default"].string,
    dash: $af8ece92f217fcd1$var$_propTypes["default"].bool,
    direction: $af8ece92f217fcd1$var$_propTypes["default"].oneOf([
        'horizontal',
        'vertical'
    ]),
    gap: $af8ece92f217fcd1$var$_propTypes["default"].oneOfType([
        $af8ece92f217fcd1$var$_propTypes["default"].oneOf([
            'none',
            'xxsmall',
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        $af8ece92f217fcd1$var$_propTypes["default"].string
    ]),
    onClick: $af8ece92f217fcd1$var$_propTypes["default"].func,
    onHover: $af8ece92f217fcd1$var$_propTypes["default"].func,
    opacity: $af8ece92f217fcd1$var$_propTypes["default"].oneOfType([
        $af8ece92f217fcd1$var$_propTypes["default"].oneOf([
            'weak',
            'medium',
            'strong'
        ]),
        $af8ece92f217fcd1$var$_propTypes["default"].bool
    ]),
    overflow: $af8ece92f217fcd1$var$_propTypes["default"].bool,
    pad: $5897bd367fbd90c1$export$b91a2ef62736aae3,
    pattern: $5897bd367fbd90c1$export$4be843ac40f484c6,
    point: $5897bd367fbd90c1$export$fe1f7946fa764688,
    round: $af8ece92f217fcd1$var$_propTypes["default"].bool,
    size: $af8ece92f217fcd1$var$_propTypes["default"].oneOfType([
        $af8ece92f217fcd1$var$_propTypes["default"].oneOf([
            'xxsmall',
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            'fill',
            'full'
        ]),
        $af8ece92f217fcd1$var$_propTypes["default"].shape({
            height: $af8ece92f217fcd1$var$_propTypes["default"].oneOfType([
                $af8ece92f217fcd1$var$_propTypes["default"].oneOf([
                    'xxsmall',
                    'xsmall',
                    'small',
                    'medium',
                    'large',
                    'xlarge',
                    'fill',
                    'full'
                ]),
                $af8ece92f217fcd1$var$_propTypes["default"].string
            ]),
            width: $af8ece92f217fcd1$var$_propTypes["default"].oneOfType([
                $af8ece92f217fcd1$var$_propTypes["default"].oneOf([
                    'xxsmall',
                    'xsmall',
                    'small',
                    'medium',
                    'large',
                    'xlarge',
                    'fill',
                    'full',
                    'auto'
                ]),
                $af8ece92f217fcd1$var$_propTypes["default"].string
            ])
        }),
        $af8ece92f217fcd1$var$_propTypes["default"].string
    ]),
    thickness: $af8ece92f217fcd1$var$thicknessType,
    type: $af8ece92f217fcd1$var$_propTypes["default"].oneOf([
        'bar',
        'line',
        'area',
        'point'
    ]),
    values: $af8ece92f217fcd1$var$_propTypes["default"].arrayOf($af8ece92f217fcd1$var$_propTypes["default"].oneOfType([
        $af8ece92f217fcd1$var$_propTypes["default"].number,
        $af8ece92f217fcd1$var$_propTypes["default"].arrayOf($af8ece92f217fcd1$var$_propTypes["default"].number),
        $af8ece92f217fcd1$var$_propTypes["default"].shape({
            color: $5897bd367fbd90c1$export$fc4c368d97afb623,
            label: $af8ece92f217fcd1$var$_propTypes["default"].string,
            // for accessibility of bars and points
            onClick: $af8ece92f217fcd1$var$_propTypes["default"].func,
            onHover: $af8ece92f217fcd1$var$_propTypes["default"].func,
            opacity: $af8ece92f217fcd1$var$_propTypes["default"].oneOfType([
                $af8ece92f217fcd1$var$_propTypes["default"].string,
                $af8ece92f217fcd1$var$_propTypes["default"].number,
                $af8ece92f217fcd1$var$_propTypes["default"].bool
            ]),
            thickness: $af8ece92f217fcd1$var$thicknessType,
            value: $af8ece92f217fcd1$var$_propTypes["default"].oneOfType([
                $af8ece92f217fcd1$var$_propTypes["default"].number,
                $af8ece92f217fcd1$var$_propTypes["default"].arrayOf($af8ece92f217fcd1$var$_propTypes["default"].number)
            ])
        })
    ]))
});
var $af8ece92f217fcd1$var$ChartPropTypes = $af8ece92f217fcd1$export$a45818ccd4fd946d = $af8ece92f217fcd1$var$PropType;



var $0ca1ee83594b9234$var$_excluded = [
    "a11yTitle",
    "bounds",
    "color",
    "dash",
    "direction",
    "gap",
    "id",
    "onClick",
    "onHover",
    "opacity",
    "overflow",
    "pad",
    "pattern",
    "point",
    "round",
    "size",
    "thickness",
    "type",
    "values"
], $0ca1ee83594b9234$var$_excluded2 = [
    "color",
    "label",
    "onHover",
    "opacity",
    "thickness",
    "value"
], $0ca1ee83594b9234$var$_excluded3 = [
    "color",
    "label",
    "onHover",
    "opacity",
    "thickness",
    "value"
];
function $0ca1ee83594b9234$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($0ca1ee83594b9234$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $0ca1ee83594b9234$var$_extends() {
    return $0ca1ee83594b9234$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0ca1ee83594b9234$var$_extends.apply(null, arguments);
}
function $0ca1ee83594b9234$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $0ca1ee83594b9234$var$gradientMaskColor = '#ffffff';
// use constants so re-renders don't re-trigger effects
var $0ca1ee83594b9234$var$defaultValues = [];
var $0ca1ee83594b9234$var$Chart = $0ca1ee83594b9234$export$acaa6426d77a227e = /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].forwardRef(function(_ref, ref) {
    var _theme$chart, _theme$chart4, _theme$chart5;
    var a11yTitle = _ref.a11yTitle, boundsProp = _ref.bounds, color = _ref.color, dash = _ref.dash, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? 'vertical' : _ref$direction, gap = _ref.gap, id = _ref.id, onClick = _ref.onClick, onHover = _ref.onHover, opacityProp = _ref.opacity, _ref$overflow = _ref.overflow, overflow = _ref$overflow === void 0 ? false : _ref$overflow, pad = _ref.pad, pattern = _ref.pattern, point = _ref.point, round = _ref.round, sizeProp = _ref.size, thickness = _ref.thickness, _ref$type = _ref.type, type = _ref$type === void 0 ? 'bar' : _ref$type, _ref$values = _ref.values, valuesProp = _ref$values === void 0 ? $0ca1ee83594b9234$var$defaultValues : _ref$values, rest = $0ca1ee83594b9234$var$_objectWithoutPropertiesLoose(_ref, $0ca1ee83594b9234$var$_excluded);
    var containerRef = (0, $4113023f9e0bafa0$exports.useForwardedRef)(ref);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var thicknessValue = thickness || ((_theme$chart = theme.chart) == null ? void 0 : _theme$chart.thickness);
    var values = (0, $0ca1ee83594b9234$var$_react.useMemo)(function() {
        return (0, $83d745eec3f15823$export$6a3a240ee501e276)(valuesProp);
    }, [
        valuesProp
    ]);
    var horizontal = (0, $0ca1ee83594b9234$var$_react.useMemo)(function() {
        return direction === 'horizontal';
    }, [
        direction
    ]);
    // bounds is { x: { min, max }, y: { min, max } }
    var bounds = (0, $0ca1ee83594b9234$var$_react.useMemo)(function() {
        return (0, $83d745eec3f15823$export$6e207fa74e4b4899)(boundsProp, values, direction);
    }, [
        direction,
        boundsProp,
        values
    ]);
    var strokeWidth = (0, $0ca1ee83594b9234$var$_react.useMemo)(function() {
        return (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.edgeSize[thicknessValue] || thicknessValue);
    }, [
        theme.global.edgeSize,
        thicknessValue
    ]);
    // inset is { top, left, bottom, right }
    var inset = (0, $0ca1ee83594b9234$var$_react.useMemo)(function() {
        var result = {
            top: 0,
            left: 0,
            bottom: 0,
            right: 0
        };
        if (pad) {
            if (pad.horizontal) {
                var padSize = (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.edgeSize[pad.horizontal] || pad.horizontal);
                result.left = padSize;
                result.right = padSize;
            }
            if (pad.vertical) {
                var _padSize = (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.edgeSize[pad.vertical] || pad.vertical);
                result.top = _padSize;
                result.bottom = _padSize;
            }
            if (pad.start) result.left = (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.edgeSize[pad.start] || pad.start);
            if (pad.end) result.right = (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.edgeSize[pad.end] || pad.end);
            if (typeof pad === 'string') {
                var _padSize2 = (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.edgeSize[pad]);
                result.top = _padSize2;
                result.left = _padSize2;
                result.bottom = _padSize2;
                result.right = _padSize2;
            }
        }
        return result;
    }, [
        pad,
        theme.global.edgeSize
    ]);
    var strokeDasharray = (0, $0ca1ee83594b9234$var$_react.useMemo)(function() {
        if (dash) {
            if (round) return strokeWidth + " " + strokeWidth * 1.5;
            return strokeWidth * 2 + " " + strokeWidth / 2;
        }
        return undefined;
    }, [
        dash,
        round,
        strokeWidth
    ]);
    // potentially dynamic sizing
    var _useState = (0, $0ca1ee83594b9234$var$_react.useState)([
        0,
        0
    ]), containerSize = _useState[0], setContainerSize = _useState[1];
    var needContainerSize = (0, $0ca1ee83594b9234$var$_react.useMemo)(function() {
        return sizeProp && (sizeProp === 'full' || sizeProp === 'fill' || sizeProp.height === 'full' || sizeProp.height === 'fill' || sizeProp.width === 'full' || sizeProp.width === 'fill');
    }, [
        sizeProp
    ]);
    // size is { width, height }
    var size = (0, $0ca1ee83594b9234$var$_react.useMemo)(function() {
        var _theme$chart2, _theme$chart3;
        var defaultSize = {
            height: (_theme$chart2 = theme.chart) == null ? void 0 : _theme$chart2.height,
            width: (_theme$chart3 = theme.chart) == null ? void 0 : _theme$chart3.width
        };
        var gapWidth = gap ? (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.edgeSize[gap] || gap) : strokeWidth;
        // autoSize is how wide or tall we'd pefer based on the number of values
        var autoSize = strokeWidth * values.length + (values.length - 1) * gapWidth;
        var sizeWidth = typeof sizeProp === 'string' ? sizeProp : (sizeProp == null ? void 0 : sizeProp.width) || horizontal && defaultSize.height || defaultSize.width;
        var width;
        if (sizeWidth === 'full' || sizeWidth === 'fill') width = containerSize[0];
        else if (sizeWidth === 'auto') width = autoSize;
        else width = (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.size[sizeWidth] || sizeWidth);
        var sizeHeight = typeof sizeProp === 'string' ? sizeProp : (sizeProp == null ? void 0 : sizeProp.height) || horizontal && defaultSize.width || defaultSize.height;
        var height;
        if (sizeHeight === 'full' || sizeHeight === 'fill') height = containerSize[1];
        else if (sizeHeight === 'auto') height = autoSize;
        else height = (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.size[sizeHeight] || sizeHeight);
        return {
            width: width,
            height: height
        };
    }, [
        containerSize,
        gap,
        horizontal,
        sizeProp,
        strokeWidth,
        theme.global.edgeSize,
        theme.global.size,
        (_theme$chart4 = theme.chart) == null ? void 0 : _theme$chart4.height,
        (_theme$chart5 = theme.chart) == null ? void 0 : _theme$chart5.width,
        values
    ]);
    // scale is { x, y }
    var scale = (0, $0ca1ee83594b9234$var$_react.useMemo)(function() {
        return {
            x: (size.width - (inset.left + inset.right)) / (bounds.x.max - bounds.x.min),
            y: (size.height - (inset.top + inset.bottom)) / (bounds.y.max - bounds.y.min)
        };
    }, [
        bounds,
        inset,
        size
    ]);
    var viewBoxBounds = (0, $0ca1ee83594b9234$var$_react.useMemo)(function() {
        if (overflow) return [
            0,
            0,
            size.width,
            size.height
        ];
        return [
            -(strokeWidth / 2),
            -(strokeWidth / 2),
            size.width + strokeWidth,
            size.height + strokeWidth
        ];
    }, [
        overflow,
        size,
        strokeWidth
    ]);
    // set container size when we get ref or when size changes
    (0, $6a5275ec792307a1$export$e5c5a5f917a5871c)(function() {
        if (containerRef.current && needContainerSize) {
            var containerNode = containerRef.current;
            if (containerNode) {
                var parentNode = containerNode.parentNode;
                if (parentNode) {
                    var rect = parentNode.getBoundingClientRect();
                    if (rect.width !== containerSize[0] || rect.height !== containerSize[1]) setContainerSize([
                        rect.width,
                        rect.height
                    ]);
                }
            }
        }
    }, [
        containerRef,
        containerSize,
        needContainerSize
    ]);
    // container size, if needed
    (0, $0ca1ee83594b9234$var$_react.useEffect)(function() {
        var onResize = function onResize() {
            var parentNode = containerRef.current.parentNode;
            var rect = parentNode.getBoundingClientRect();
            setContainerSize([
                rect.width,
                rect.height
            ]);
        };
        if (needContainerSize) {
            window.addEventListener('resize', onResize);
            return function() {
                return window.removeEventListener('resize', onResize);
            };
        }
        return undefined;
    }, [
        containerRef,
        needContainerSize
    ]);
    // rendering helpers, to make rendering code easier to understand
    var valueCoords = function valueCoords(x, y) {
        return horizontal ? [
            y,
            x
        ] : [
            x,
            y
        ];
    };
    // Converts values to drawing coordinates.
    // Takes into account the bounds, any inset, and the scale.
    var valueToCoordinate = function valueToCoordinate(xValue, yValue) {
        var y = (yValue - bounds.y.min) * scale.y + inset.top;
        return [
            (xValue - bounds.x.min) * scale.x + inset.left,
            // horizontal grows y top down, vertical grows y bottom up
            horizontal ? y : size.height - y
        ];
    };
    var useGradient = color && Array.isArray(color);
    var patternId;
    function getOpacity(valueOpacity) {
        return valueOpacity && theme.global.opacity[valueOpacity] || // eslint-disable-next-line no-nested-ternary
        (valueOpacity === true ? theme.global.opacity.medium : valueOpacity === false ? undefined : valueOpacity);
    }
    var renderBars = function renderBars() {
        return (values || []).filter(function(_ref2) {
            var value = _ref2.value;
            return value[1] !== undefined;
        }).map(function(valueArg, index) {
            var valueColor = valueArg.color, label = valueArg.label, valueOnHover = valueArg.onHover, valueOpacity = valueArg.opacity, valueThickness = valueArg.thickness, value = valueArg.value, valueRest = $0ca1ee83594b9234$var$_objectWithoutPropertiesLoose(valueArg, $0ca1ee83594b9234$var$_excluded2);
            var key = "p-" + index;
            // Math.min/max are to handle negative values
            var _valueCoords = valueCoords(value[0], value.length === 2 ? Math.min(Math.max(0, horizontal ? bounds.x.min : bounds.y.min), value[1]) : Math.min(value[1], value[2])), startX = _valueCoords[0], startY = _valueCoords[1];
            var _valueCoords2 = valueCoords(value[0], value.length === 2 ? Math.max(Math.min(0, horizontal ? bounds.x.max : bounds.y.max), value[1]) : Math.max(value[1], value[2])), endX = _valueCoords2[0], endY = _valueCoords2[1];
            var d = "M " + valueToCoordinate(startX, startY).join(',') + (" L " + valueToCoordinate(endX, endY).join(','));
            var hoverProps;
            if (valueOnHover) hoverProps = {
                onMouseOver: function onMouseOver() {
                    return valueOnHover(true);
                },
                onMouseLeave: function onMouseLeave() {
                    return valueOnHover(false);
                }
            };
            var clickProps;
            if (onClick) clickProps = {
                onClick: onClick
            };
            return /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("g", {
                key: key,
                fill: "none",
                stroke: valueColor ? (0, $4113023f9e0bafa0$exports.normalizeColor)(valueColor, theme) : undefined,
                strokeWidth: valueThickness ? (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.edgeSize[valueThickness] || valueThickness) : undefined,
                opacity: getOpacity(valueOpacity)
            }, /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("title", null, label), /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("path", $0ca1ee83594b9234$var$_extends({
                d: d
            }, hoverProps, clickProps, valueRest, {
                strokeDasharray: strokeDasharray
            })));
        });
    };
    var renderLine = function renderLine() {
        var d = '';
        var d2 = '';
        (values || []).filter(function(_ref3) {
            var value = _ref3.value;
            return value[1] !== undefined;
        }).forEach(function(_ref4) {
            var value = _ref4.value;
            var _valueCoords3 = valueCoords(value[0], value[1]), x = _valueCoords3[0], y = _valueCoords3[1];
            d += (d ? ' L' : 'M') + " " + valueToCoordinate(x, y).join(',');
            if (value[2] !== undefined) {
                var _valueCoords4 = valueCoords(value[0], value[2]), x2 = _valueCoords4[0], y2 = _valueCoords4[1];
                d2 += (d2 ? ' L' : 'M') + " " + valueToCoordinate(x2, y2).join(',');
            }
        });
        var hoverProps;
        if (onHover) hoverProps = {
            onMouseOver: function onMouseOver() {
                return onHover(true);
            },
            onMouseLeave: function onMouseLeave() {
                return onHover(false);
            }
        };
        var clickProps;
        if (onClick) clickProps = {
            onClick: onClick
        };
        return /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("g", {
            fill: "none"
        }, /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("path", $0ca1ee83594b9234$var$_extends({
            d: d
        }, hoverProps, clickProps, {
            strokeDasharray: strokeDasharray
        })), d2 && /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("path", $0ca1ee83594b9234$var$_extends({
            d: d2
        }, hoverProps, clickProps, {
            strokeDasharray: strokeDasharray
        })));
    };
    var renderArea = function renderArea() {
        var d = '';
        (values || []).filter(function(_ref5) {
            var value = _ref5.value;
            return value[1] !== undefined;
        }).forEach(function(_ref6, index) {
            var value = _ref6.value;
            var _valueCoords5 = valueCoords(value[0], // when a range, second value is on top
            value[value.length === 2 ? 1 : 2]), x = _valueCoords5[0], y = _valueCoords5[1];
            d += (!index ? 'M' : ' L') + " " + valueToCoordinate(x, y).join(',');
        });
        (values || []).filter(function(_ref7) {
            var value = _ref7.value;
            return value[1] !== undefined;
        }).reverse().forEach(function(_ref8) {
            var value = _ref8.value;
            var _valueCoords6 = valueCoords(value[0], // Math.max() is to account for value[1] being negative
            value.length === 2 ? Math.max(0, horizontal ? bounds.x.min : bounds.y.min) : value[1]), x = _valueCoords6[0], y = _valueCoords6[1];
            d += " L " + valueToCoordinate(x, y).join(',');
        });
        if (d.length > 0) d += ' Z';
        var hoverProps;
        if (onHover) hoverProps = {
            onMouseOver: function onMouseOver() {
                return onHover(true);
            },
            onMouseLeave: function onMouseLeave() {
                return onHover(false);
            }
        };
        var clickProps;
        if (onClick) clickProps = {
            onClick: onClick
        };
        patternId = pattern && pattern + "-" + id + "-pattern";
        return /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("g", null, /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("path", $0ca1ee83594b9234$var$_extends({
            d: d,
            fill: patternId ? "url(#" + patternId + ")" : undefined
        }, hoverProps, clickProps)));
    };
    var renderPoints = function renderPoints() {
        return (values || []).filter(function(_ref9) {
            var value = _ref9.value;
            return value[1] !== undefined;
        }).map(function(valueArg, index) {
            var valueColor = valueArg.color, label = valueArg.label, valueOnHover = valueArg.onHover, valueOpacity = valueArg.opacity, valueThickness = valueArg.thickness, value = valueArg.value, valueRest = $0ca1ee83594b9234$var$_objectWithoutPropertiesLoose(valueArg, $0ca1ee83594b9234$var$_excluded3);
            var key = "p-" + index;
            var hoverProps;
            if (valueOnHover) hoverProps = {
                onMouseOver: function onMouseOver() {
                    return valueOnHover(true);
                },
                onMouseLeave: function onMouseLeave() {
                    return valueOnHover(false);
                }
            };
            var clickProps;
            if (onClick) clickProps = {
                onClick: onClick
            };
            var width = valueThickness ? (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.edgeSize[valueThickness] || valueThickness) : strokeWidth;
            var renderPoint = function renderPoint(valueX, valueY) {
                var props = $0ca1ee83594b9234$var$_extends({}, hoverProps, clickProps, valueRest);
                var _valueCoords7 = valueCoords(valueX, valueY), x = _valueCoords7[0], y = _valueCoords7[1];
                var _valueToCoordinate = valueToCoordinate(x, y), cx = _valueToCoordinate[0], cy = _valueToCoordinate[1];
                var off = width / 2;
                if (point === 'circle' || !point && round) return /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("circle", $0ca1ee83594b9234$var$_extends({
                    cx: cx,
                    cy: cy,
                    r: off
                }, props));
                var d;
                if (point === 'diamond') d = "M " + cx + " " + (cy - off) + " L " + (cx + off) + " " + cy + " L " + cx + " " + (cy + off) + " L " + (cx - off) + " " + cy + " Z";
                else if (point === 'star') {
                    var off1 = off / 3;
                    var off2 = off1 * 2;
                    d = "M " + cx + " " + (cy - off) + " L " + (cx - off2) + " " + (cy + off) + " L " + (cx + off) + " " + (cy - off1) + " L " + (cx - off) + " " + (cy - off1) + " L " + (cx + off2) + " " + (cy + off) + " Z";
                } else if (point === 'triangle') d = "M " + cx + " " + (cy - off) + " L " + (cx + off) + " " + (cy + off) + " L " + (cx - off) + " " + (cy + off) + " Z";
                else if (point === 'triangleDown') d = "M " + (cx - off) + " " + (cy - off) + " L " + (cx + off) + " " + (cy - off) + " L " + cx + " " + (cy + off) + " Z";
                else d = "M " + (cx - off) + " " + (cy - off) + " L " + (cx + off) + " " + (cy - off) + " L " + (cx + off) + " " + (cy + off) + " L " + (cx - off) + " " + (cy + off) + " Z";
                return /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("path", {
                    d: d
                });
            };
            return /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("g", {
                key: key,
                stroke: "none",
                fill: valueColor ? (0, $4113023f9e0bafa0$exports.normalizeColor)(valueColor, theme) : undefined,
                opacity: getOpacity(valueOpacity)
            }, /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("title", null, label), renderPoint(value[0], value[1]), value[2] !== undefined && renderPoint(value[0], value[2]));
        });
    };
    var contents;
    if (type === 'bar') contents = renderBars();
    else if (type === 'line') contents = renderLine();
    else if (type === 'area') contents = renderArea();
    else if (type === 'point') contents = renderPoints();
    var viewBox = viewBoxBounds.join(' ');
    var colorName;
    if (!useGradient) {
        if (color && color.color) colorName = color.color;
        else if (color) colorName = color;
        else if (theme.chart && theme.chart.color) colorName = theme.chart.color;
    }
    var opacity;
    if (opacityProp === true) opacity = theme.global.opacity.medium;
    else if (opacityProp) opacity = theme.global.opacity[opacityProp] ? theme.global.opacity[opacityProp] : opacityProp;
    else if (color && color.opacity) opacity = theme.global.opacity[color.opacity] ? theme.global.opacity[color.opacity] : color.opacity;
    else opacity = undefined;
    var stroke;
    if (type !== 'point') {
        if (useGradient) stroke = $0ca1ee83594b9234$var$gradientMaskColor;
        else stroke = (0, $4113023f9e0bafa0$exports.normalizeColor)(colorName, theme);
    } else stroke = 'none';
    var fill;
    if (type === 'point' || type === 'area') {
        if (useGradient) fill = $0ca1ee83594b9234$var$gradientMaskColor;
        else fill = (0, $4113023f9e0bafa0$exports.normalizeColor)(colorName, theme);
    } else fill = 'none';
    var drawing = /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("g", {
        stroke: stroke,
        strokeWidth: type !== 'point' && (type !== 'area' || !pattern) ? strokeWidth : undefined,
        fill: fill,
        strokeLinecap: round ? 'round' : 'butt',
        strokeLinejoin: round ? 'round' : 'miter',
        opacity: opacity
    }, contents);
    var defs = [];
    var gradientRect;
    if (useGradient && (horizontal && size.width || size.height)) {
        var uniqueGradientId = color.map(function(element) {
            return element.color;
        }).join('-');
        var gradientId = uniqueGradientId + "-" + id + "-gradient";
        var maskId = uniqueGradientId + "-" + id + "-mask";
        defs.push(/*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("linearGradient", {
            key: "gradientId",
            id: gradientId,
            x1: 0,
            y1: 0,
            x2: horizontal ? 1 : 0,
            y2: horizontal ? 0 : 1
        }, color.slice(0).sort(function(c1, c2) {
            return horizontal ? c1.value - c2.value : c2.value - c1.value;
        }).map(function(_ref0) {
            var value = _ref0.value, gradientColor = _ref0.color;
            return /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("stop", {
                key: value,
                offset: horizontal ? (value - bounds.x.min) * scale.x / size.width : (size.height - (value - bounds.y.min) * scale.y) / size.height,
                stopColor: (0, $4113023f9e0bafa0$exports.normalizeColor)(gradientColor, theme)
            });
        })));
        defs.push(/*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("mask", {
            key: "mask",
            id: maskId
        }, drawing));
        gradientRect = /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("rect", {
            x: viewBoxBounds[0],
            y: viewBoxBounds[1],
            width: viewBoxBounds[2],
            height: viewBoxBounds[3],
            fill: "url(#" + gradientId + ")",
            mask: "url(#" + maskId + ")"
        });
    } else if (patternId) {
        var content;
        var diagonal = pattern.match(/Diagonal/);
        var unit = diagonal ? strokeWidth * Math.sqrt(2) : strokeWidth;
        var half = unit / 2;
        var _double = unit * 2;
        var pColor = (0, $4113023f9e0bafa0$exports.normalizeColor)(colorName, theme);
        if (pattern === 'squares') content = /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("rect", {
            x: half,
            y: half,
            width: unit,
            height: unit,
            fill: pColor
        });
        else if (pattern === 'circles') content = /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("circle", {
            cx: unit,
            cy: unit,
            r: half,
            fill: pColor
        });
        else if (pattern === 'stripesHorizontal') content = /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("path", {
            d: "M 0 " + unit + " L " + _double + " " + unit,
            stroke: pColor,
            strokeWidth: strokeWidth
        });
        else if (pattern === 'stripesVertical') content = /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("path", {
            d: "M " + unit + " 0 L " + unit + " " + _double,
            stroke: pColor,
            strokeWidth: strokeWidth
        });
        else if (pattern === 'stripesDiagonalDown') content = /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("path", {
            d: "M " + half + " " + -half + " L " + (_double + half) + " " + (_double - half) + "\n              M " + -half + " " + half + " L " + (_double - half) + " " + (_double + half),
            stroke: pColor,
            strokeWidth: strokeWidth
        });
        else if (pattern === 'stripesDiagonalUp') content = /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("path", {
            d: "M " + -half + " " + (_double - half) + " L " + (_double - half) + " " + -half + "\n              M " + half + " " + (_double + half) + " L " + (_double + half) + " " + half,
            stroke: pColor,
            strokeWidth: strokeWidth
        });
        defs.push(/*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("pattern", {
            key: patternId,
            id: patternId,
            width: _double,
            height: _double,
            patternUnits: "userSpaceOnUse"
        }, content));
    }
    return /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement($0261c638c9cffc45$export$8809c6727dc0976b, $0ca1ee83594b9234$var$_extends({
        ref: containerRef,
        id: id,
        "aria-label": a11yTitle,
        viewBox: viewBox,
        preserveAspectRatio: "none",
        width: size === 'full' ? '100%' : size.width,
        height: size === 'full' ? '100%' : size.height,
        typeProp: type // prevent adding to DOM
    }, passThemeFlag, rest), defs.length && /*#__PURE__*/ $0ca1ee83594b9234$var$_react["default"].createElement("defs", null, defs), useGradient ? gradientRect : drawing);
});
$0ca1ee83594b9234$var$Chart.displayName = 'Chart';
$0ca1ee83594b9234$var$Chart.propTypes = $af8ece92f217fcd1$export$a45818ccd4fd946d;


$f6c8c05e7d725926$export$acaa6426d77a227e = $0ca1ee83594b9234$export$acaa6426d77a227e;
var $4ced132a60f807fe$export$1e511d4a378977f5;
var $4ced132a60f807fe$export$2077e0241d6afd3c;
var $4ced132a60f807fe$export$f210a4934359ec3b;
var $4ced132a60f807fe$export$de5d4336bd2f6d1d;
"use strict";
$4ced132a60f807fe$export$1e511d4a378977f5 = true;
$4ced132a60f807fe$export$2077e0241d6afd3c = $4ced132a60f807fe$export$f210a4934359ec3b = $4ced132a60f807fe$export$de5d4336bd2f6d1d = void 0;

var $4ced132a60f807fe$var$round = $4ced132a60f807fe$export$2077e0241d6afd3c = function round(value, decimals) {
    return Number(Math.round(value + "e" + decimals) + "e-" + decimals);
};
// Normalize coarseness to an object.
// Backwards compatible has no coarseness for x-axis.
var $4ced132a60f807fe$var$normalizeCoarseness = function normalizeCoarseness(coarseness, direction) {
    var result;
    if (Array.isArray(coarseness)) result = {
        x: coarseness[0],
        y: coarseness[1]
    };
    else if (typeof coarseness === 'object') result = coarseness;
    else if (coarseness) result = {
        x: undefined,
        y: coarseness
    };
    else result = direction === 'horizontal' ? {
        x: 5,
        y: undefined
    } : {
        x: undefined,
        y: 5
    };
    return result;
};
var $4ced132a60f807fe$var$normalizeSteps = function normalizeSteps(steps) {
    var result;
    if (Array.isArray(steps)) result = {
        x: steps[0],
        y: steps[1]
    };
    else if (typeof steps === 'object') result = steps;
    else result = {
        x: 1,
        y: 1
    };
    return result;
};
var $4ced132a60f807fe$var$alignMax = function alignMax(value, interval) {
    if (value > 0) return value - value % interval + interval;
    if (value < 0) return value + value % interval;
    return value;
};
var $4ced132a60f807fe$var$alignMin = function alignMin(value, interval) {
    if (value > 0) return value - value % interval;
    if (value < 0) return value - value % interval - interval;
    return value;
};
var $4ced132a60f807fe$var$adjustToShowZero = function adjustToShowZero(minArg, maxArg, steps) {
    var min = minArg;
    var max = maxArg;
    if (min < 0 && max > 0 && Math.abs(min) !== Math.abs(max)) {
        // Adjust min and max when crossing 0 to ensure 0 will be shown on
        // the axis based on the number of steps.
        if (steps === 1) {
            var largest = Math.max(Math.abs(min), Math.abs(max));
            min = -largest;
            max = largest;
        } else {
            var stepInterval = (max - min) / steps;
            var minSteps = min / stepInterval;
            var maxSteps = max / stepInterval;
            if (Math.abs(minSteps) < Math.abs(maxSteps)) {
                // more above than below
                stepInterval = max / Math.floor(maxSteps);
                max = stepInterval * Math.floor(maxSteps);
                min = stepInterval * Math.floor(minSteps);
            } else {
                // more below than above
                stepInterval = Math.abs(min / Math.ceil(minSteps));
                min = stepInterval * Math.ceil(minSteps);
                max = stepInterval * Math.ceil(maxSteps);
            }
        }
    }
    return [
        min,
        max
    ];
};
var $4ced132a60f807fe$var$calcBounds = $4ced132a60f807fe$export$de5d4336bd2f6d1d = function calcBounds(valuesArg, options) {
    if (options === void 0) options = {};
    // coarseness influences the rounding of the bounds, the smaller the
    // number, the more the bounds will be rounded. e.g. 111 -> 110 -> 100.
    var _normalizeCoarseness = $4ced132a60f807fe$var$normalizeCoarseness(options.coarseness, options.direction), coarseX = _normalizeCoarseness.x, coarseY = _normalizeCoarseness.y;
    // the number of steps is one less than the number of labels
    var _normalizeSteps = $4ced132a60f807fe$var$normalizeSteps(options.steps), stepsX = _normalizeSteps.x, stepsY = _normalizeSteps.y;
    var values = (0, $83d745eec3f15823$export$6a3a240ee501e276)(valuesArg || []);
    var result;
    if (values.length) {
        // min and max values
        var _calcMinMax = (0, $83d745eec3f15823$export$d120e998a826f71d)(values, options.direction), _calcMinMax$x = _calcMinMax.x, minX = _calcMinMax$x.min, maxX = _calcMinMax$x.max, _calcMinMax$y = _calcMinMax.y, minY = _calcMinMax$y.min, maxY = _calcMinMax$y.max;
        // Calculate some reasonable bounds based on the max and min values.
        // This is so values like 87342.12 don't end up being displayed as the
        // graph axis labels.
        if (coarseX) {
            var deltaX = maxX - minX;
            var intervalX = Number.parseFloat((deltaX / coarseX).toPrecision(1));
            minX = $4ced132a60f807fe$var$alignMin(minX, intervalX);
            maxX = $4ced132a60f807fe$var$alignMax(maxX, intervalX);
        }
        if (coarseY) {
            var deltaY = maxY - minY;
            var intervalY = Number.parseFloat((deltaY / coarseY).toPrecision(1));
            minY = $4ced132a60f807fe$var$alignMin(minY, intervalY);
            maxY = $4ced132a60f807fe$var$alignMax(maxY, intervalY);
        }
        if (options.direction === 'horizontal') {
            var _adjustToShowZero = $4ced132a60f807fe$var$adjustToShowZero(minX, maxX, stepsX);
            minX = _adjustToShowZero[0];
            maxX = _adjustToShowZero[1];
        } else {
            var _adjustToShowZero2 = $4ced132a60f807fe$var$adjustToShowZero(minY, maxY, stepsY);
            minY = _adjustToShowZero2[0];
            maxY = _adjustToShowZero2[1];
        }
        // if options.direction is present, the results are delivered in { x, y }
        // object structure. If options.direction is not present, the results are
        // delivered in [x, y] array structure, for backwards compatibility
        result = options.direction ? {
            x: {
                min: minX,
                max: maxX
            },
            y: {
                min: minY,
                max: maxY
            }
        } : [
            [
                minX,
                maxX
            ],
            [
                minY,
                maxY
            ]
        ];
    } else result = options.direction ? {
        x: {},
        y: {}
    } : [
        [],
        []
    ];
    return result;
};
// if options.direction is present, the results are delivered in { x, y }
// object structure. If options.direction is not present, the results are
// delivered in [x, y] array structure, for backwards compatibility
var $4ced132a60f807fe$var$calcs = $4ced132a60f807fe$export$f210a4934359ec3b = function calcs(values, options) {
    var _theme$dataChart, _theme$dataChart2, _theme$dataChart3, _theme$dataChart4, _theme$dataChart5;
    if (values === void 0) values = [];
    if (options === void 0) options = {};
    var theme = options.theme || {};
    var horizontal = options.direction === 'horizontal';
    // the number of steps is one less than the number of labels
    var _normalizeSteps2 = $4ced132a60f807fe$var$normalizeSteps(options.steps), stepsX = _normalizeSteps2.x, stepsY = _normalizeSteps2.y;
    // bounds is { x: { min, max }, y: { min, max } } when options.direction is
    // present and [[min, max], [min, max]] if not, for backwards compatibility
    var bounds = options.bounds || $4ced132a60f807fe$var$calcBounds(values, options);
    if (options.min !== undefined) {
        if (options.direction) {
            if (horizontal) bounds.x.min = options.min;
            else bounds.y.min = options.min;
        } else bounds[1][0] = options.min;
    }
    if (options.max !== undefined) {
        if (options.direction) {
            if (horizontal) bounds.y.max = options.max;
            else bounds.x.max = options.max;
        } else bounds[1][1] = options.max;
    }
    var _ref = options.direction ? bounds : {
        x: {
            min: bounds[0][0],
            max: bounds[0][1]
        },
        y: {
            min: bounds[1][0],
            max: bounds[1][1]
        }
    }, _ref$x = _ref.x, minX = _ref$x.min, maxX = _ref$x.max, _ref$y = _ref.y, minY = _ref$y.min, maxY = _ref$y.max;
    var width = $4ced132a60f807fe$var$round(maxX - minX, 2);
    var height = $4ced132a60f807fe$var$round(maxY - minY, 2);
    var dimensions = options.direction ? {
        width: width,
        height: height
    } : [
        width,
        height
    ];
    // Calculate x and y axis values across the specfied number of steps.
    var yAxis = [];
    var y = maxY;
    // To deal with javascript math limitations, round the step with 4 decimal
    // places and then push the values with 2 decimal places
    var yStepInterval = $4ced132a60f807fe$var$round(height / stepsY, 4);
    while($4ced132a60f807fe$var$round(y, 2) >= minY){
        yAxis.push($4ced132a60f807fe$var$round(y, 2));
        y -= yStepInterval;
    }
    if (horizontal) yAxis.reverse();
    var xAxis = [];
    var x = minX;
    var xStepInterval = $4ced132a60f807fe$var$round(width / stepsX, 4);
    while($4ced132a60f807fe$var$round(x, 2) <= maxX){
        xAxis.push($4ced132a60f807fe$var$round(x, 2));
        x += xStepInterval;
    }
    var thicknessPad = {
        xlarge: ((_theme$dataChart = theme.dataChart) == null || (_theme$dataChart = _theme$dataChart.thicknessPad) == null ? void 0 : _theme$dataChart.xlarge) || 'large',
        large: ((_theme$dataChart2 = theme.dataChart) == null || (_theme$dataChart2 = _theme$dataChart2.thicknessPad) == null ? void 0 : _theme$dataChart2.large) || 'medium',
        medium: ((_theme$dataChart3 = theme.dataChart) == null || (_theme$dataChart3 = _theme$dataChart3.thicknessPad) == null ? void 0 : _theme$dataChart3.medium) || 'small',
        small: ((_theme$dataChart4 = theme.dataChart) == null || (_theme$dataChart4 = _theme$dataChart4.thicknessPad) == null ? void 0 : _theme$dataChart4.small) || 'xsmall',
        xsmall: ((_theme$dataChart5 = theme.dataChart) == null || (_theme$dataChart5 = _theme$dataChart5.thicknessPad) == null ? void 0 : _theme$dataChart5.xsmall) || 'xxsmall'
    };
    var _options = options, thickness = _options.thickness;
    if (!thickness) {
        // Set bar thickness based on number of values being rendered.
        // Someday, it would be better to include the actual rendered size.
        // These values were emirically determined, trying to balance visibility
        // and overlap across resolutions.
        if (values.length < 5) {
            var _theme$dataChart6;
            thickness = ((_theme$dataChart6 = theme.dataChart) == null || (_theme$dataChart6 = _theme$dataChart6.thickness) == null ? void 0 : _theme$dataChart6.sparse) || 'xlarge';
        } else if (values.length < 11) {
            var _theme$dataChart7;
            thickness = ((_theme$dataChart7 = theme.dataChart) == null || (_theme$dataChart7 = _theme$dataChart7.thickness) == null ? void 0 : _theme$dataChart7.light) || 'large';
        } else if (values.length < 21) {
            var _theme$dataChart8;
            thickness = ((_theme$dataChart8 = theme.dataChart) == null || (_theme$dataChart8 = _theme$dataChart8.thickness) == null ? void 0 : _theme$dataChart8.moderate) || 'medium';
        } else if (values.length < 61) {
            var _theme$dataChart9;
            thickness = ((_theme$dataChart9 = theme.dataChart) == null || (_theme$dataChart9 = _theme$dataChart9.thickness) == null ? void 0 : _theme$dataChart9.heavy) || 'small';
        } else if (values.length < 121) {
            var _theme$dataChart0;
            thickness = ((_theme$dataChart0 = theme.dataChart) == null || (_theme$dataChart0 = _theme$dataChart0.thickness) == null ? void 0 : _theme$dataChart0.dense) || 'xsmall';
        } else {
            var _theme$dataChart1;
            thickness = ((_theme$dataChart1 = theme.dataChart) == null || (_theme$dataChart1 = _theme$dataChart1.thickness) == null ? void 0 : _theme$dataChart1.veryDense) || 'hair';
        }
    }
    var pad = thicknessPad[thickness];
    return {
        axis: options.direction ? {
            x: xAxis,
            y: yAxis
        } : [
            xAxis,
            yAxis
        ],
        bounds: bounds,
        dimensions: dimensions,
        pad: pad,
        thickness: thickness
    };
};


$f6c8c05e7d725926$export$de5d4336bd2f6d1d = $4ced132a60f807fe$export$de5d4336bd2f6d1d;
$f6c8c05e7d725926$export$f210a4934359ec3b = $4ced132a60f807fe$export$f210a4934359ec3b;
$f6c8c05e7d725926$export$2077e0241d6afd3c = $4ced132a60f807fe$export$2077e0241d6afd3c;


Object.keys($f6c8c05e7d725926$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $f6c8c05e7d725926$exports[key]) return;
    $3321243da0932e1e$exports[key] = $f6c8c05e7d725926$exports[key];
});

Object.keys($c15af89705eeb537$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $c15af89705eeb537$exports[key]) return;
    $3321243da0932e1e$exports[key] = $c15af89705eeb537$exports[key];
});
var $db2ca7111e4ea3dd$exports = {};

$parcel$export($db2ca7111e4ea3dd$exports, "__esModule", function () { return $db2ca7111e4ea3dd$export$1e511d4a378977f5; }, function (v) { return $db2ca7111e4ea3dd$export$1e511d4a378977f5 = v; });
$parcel$export($db2ca7111e4ea3dd$exports, "Clock", function () { return $db2ca7111e4ea3dd$export$9735c82c4bae3302; }, function (v) { return $db2ca7111e4ea3dd$export$9735c82c4bae3302 = v; });
var $db2ca7111e4ea3dd$export$1e511d4a378977f5;
var $db2ca7111e4ea3dd$export$9735c82c4bae3302;
"use strict";
$db2ca7111e4ea3dd$export$1e511d4a378977f5 = true;
$db2ca7111e4ea3dd$export$9735c82c4bae3302 = void 0;
var $9b51af4eaaf40643$export$1e511d4a378977f5;
var $9b51af4eaaf40643$export$9735c82c4bae3302;
"use strict";
$9b51af4eaaf40643$export$1e511d4a378977f5 = true;
$9b51af4eaaf40643$export$9735c82c4bae3302 = void 0;

var $9b51af4eaaf40643$var$_react = $9b51af4eaaf40643$var$_interopRequireWildcard((parcelRequire("2xPiy")));
var $47e4439bafb1fe48$export$1e511d4a378977f5;
var $47e4439bafb1fe48$export$e4942f925b959595;
"use strict";
$47e4439bafb1fe48$export$1e511d4a378977f5 = true;
$47e4439bafb1fe48$export$e4942f925b959595 = void 0;

var $47e4439bafb1fe48$var$_react = $47e4439bafb1fe48$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $085ab10282756fce$export$1e511d4a378977f5;
var $085ab10282756fce$export$1c4c6736efe94e05;
var $085ab10282756fce$export$c4ef7b8e65ff349;
var $085ab10282756fce$export$374360fd7041c894;
var $085ab10282756fce$export$53ad85ca611e5ca0;
var $085ab10282756fce$export$3e34a191ce3a5aa;
var $085ab10282756fce$export$62187e24705e4453;
var $085ab10282756fce$export$8a4090086704219a;
"use strict";
$085ab10282756fce$export$1e511d4a378977f5 = true;
$085ab10282756fce$export$1c4c6736efe94e05 = $085ab10282756fce$export$c4ef7b8e65ff349 = $085ab10282756fce$export$374360fd7041c894 = $085ab10282756fce$export$53ad85ca611e5ca0 = $085ab10282756fce$export$3e34a191ce3a5aa = $085ab10282756fce$export$62187e24705e4453 = $085ab10282756fce$export$8a4090086704219a = void 0;

var $085ab10282756fce$var$_styledComponents = $085ab10282756fce$var$_interopRequireWildcard((parcelRequire("iA1nz")));

function $085ab10282756fce$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($085ab10282756fce$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $085ab10282756fce$var$StyledHour = $085ab10282756fce$export$374360fd7041c894 = $085ab10282756fce$var$_styledComponents["default"].line.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledClock__StyledHour",
    componentId: "sc-y4xw8s-0"
})([
    "stroke-width:",
    ";stroke:",
    ";transition:stroke 1s ease-out;"
], function(props) {
    return props.theme.clock.analog.hour.width;
}, function(props) {
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.clock.analog.hour.color, props.theme);
});
var $085ab10282756fce$var$StyledMinute = $085ab10282756fce$export$c4ef7b8e65ff349 = $085ab10282756fce$var$_styledComponents["default"].line.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledClock__StyledMinute",
    componentId: "sc-y4xw8s-1"
})([
    "stroke-width:",
    ";stroke:",
    ";transition:stroke 1s ease-out;"
], function(props) {
    return props.theme.clock.analog.minute.width;
}, function(props) {
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.clock.analog.minute.color, props.theme);
});
var $085ab10282756fce$var$StyledSecond = $085ab10282756fce$export$1c4c6736efe94e05 = $085ab10282756fce$var$_styledComponents["default"].line.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledClock__StyledSecond",
    componentId: "sc-y4xw8s-2"
})([
    "stroke-width:",
    ";stroke:",
    ";transition:stroke 1s ease-out;"
], function(props) {
    return props.theme.clock.analog.second.width;
}, function(props) {
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.clock.analog.second.color, props.theme);
});
var $085ab10282756fce$var$StyledAnalog = $085ab10282756fce$export$8a4090086704219a = $085ab10282756fce$var$_styledComponents["default"].svg.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledClock__StyledAnalog",
    componentId: "sc-y4xw8s-3"
})([
    "width:",
    ";height:",
    ";",
    " ",
    ";"
], function(props) {
    return props.theme.clock.analog.size[props.size];
}, function(props) {
    return props.theme.clock.analog.size[props.size];
}, $4113023f9e0bafa0$exports.genericStyles, function(props) {
    return props.theme.clock.analog && props.theme.clock.analog.extend;
});
var $085ab10282756fce$var$sizeStyle = function sizeStyle(props) {
    // size is a combination of the size and height properties
    var size = props.size || 'medium';
    var data = props.theme.clock.digital.text[size] || {};
    return (0, $085ab10282756fce$var$_styledComponents.css)([
        "font-size:",
        ";line-height:",
        ";"
    ], data.size || props.theme.clock.digital.text.medium.size, data.height || props.theme.clock.digital.text.medium.height);
};
var $085ab10282756fce$var$StyledDigitalDigit = $085ab10282756fce$export$62187e24705e4453 = $085ab10282756fce$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledClock__StyledDigitalDigit",
    componentId: "sc-y4xw8s-4"
})([
    "position:relative;width:0.8em;text-align:center;overflow:hidden;",
    ";"
], function(props) {
    return $085ab10282756fce$var$sizeStyle(props);
});
var $085ab10282756fce$var$previousUp = (0, $085ab10282756fce$var$_styledComponents.keyframes)([
    "0%{transform:translateY(0);}100%{transform:translateY(-100%);}"
]);
var $085ab10282756fce$var$previousDown = (0, $085ab10282756fce$var$_styledComponents.keyframes)([
    "0%{transform:translateY(0);}100%{transform:translateY(100%);}"
]);
var $085ab10282756fce$var$StyledDigitalPrevious = $085ab10282756fce$export$53ad85ca611e5ca0 = $085ab10282756fce$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledClock__StyledDigitalPrevious",
    componentId: "sc-y4xw8s-5"
})([
    "position:absolute;top:0;left:0;width:0.8em;text-align:center;animation:",
    " 0.5s forwards;"
], function(props) {
    return props.direction === 'down' ? $085ab10282756fce$var$previousDown : $085ab10282756fce$var$previousUp;
});
var $085ab10282756fce$var$nextUp = (0, $085ab10282756fce$var$_styledComponents.keyframes)([
    "0%{transform:translateY(100%);}100%{transform:translateY(0);}"
]);
var $085ab10282756fce$var$nextDown = (0, $085ab10282756fce$var$_styledComponents.keyframes)([
    "0%{transform:translateY(-100%);}100%{transform:translateY(0);}"
]);
var $085ab10282756fce$var$StyledDigitalNext = $085ab10282756fce$export$3e34a191ce3a5aa = $085ab10282756fce$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledClock__StyledDigitalNext",
    componentId: "sc-y4xw8s-6"
})([
    "position:absolute;top:0;left:0;width:0.8em;text-align:center;animation:",
    " 0.5s forwards;"
], function(props) {
    return props.direction === 'down' ? $085ab10282756fce$var$nextDown : $085ab10282756fce$var$nextUp;
});



var $47e4439bafb1fe48$var$_excluded = [
    "elements",
    "precision"
];
function $47e4439bafb1fe48$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($47e4439bafb1fe48$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $47e4439bafb1fe48$var$_extends() {
    return $47e4439bafb1fe48$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $47e4439bafb1fe48$var$_extends.apply(null, arguments);
}
function $47e4439bafb1fe48$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// this will serve both minutes and hours (360 / 6)
var $47e4439bafb1fe48$var$ANGLE_UNIT = 6;
// 360 / 12
var $47e4439bafb1fe48$var$HOUR_ANGLE_UNIT = 30;
var $47e4439bafb1fe48$var$getClockDimensions = function getClockDimensions(theme) {
    return {
        size: (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.clock.analog.size.medium),
        secondSize: (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.clock.analog.second.size),
        minuteSize: (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.clock.analog.minute.size),
        hourSize: (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.clock.analog.hour.size)
    };
};
var $47e4439bafb1fe48$var$getClockState = function getClockState(_ref) {
    var hours = _ref.hours, minutes = _ref.minutes, seconds = _ref.seconds;
    var hour12 = hours > 12 ? hours - 12 : hours;
    var minuteAngle = minutes * $47e4439bafb1fe48$var$ANGLE_UNIT;
    return {
        // offset hour angle by half of the minute angle so that it gets closer
        // to the next hour
        hourAngle: hour12 * $47e4439bafb1fe48$var$HOUR_ANGLE_UNIT + minutes / 2,
        minuteAngle: minuteAngle,
        secondAngle: seconds * $47e4439bafb1fe48$var$ANGLE_UNIT
    };
};
var $47e4439bafb1fe48$var$Analog = $47e4439bafb1fe48$export$e4942f925b959595 = /*#__PURE__*/ (0, $47e4439bafb1fe48$var$_react.forwardRef)(function(_ref2, ref) {
    var elements = _ref2.elements, precision = _ref2.precision, rest = $47e4439bafb1fe48$var$_objectWithoutPropertiesLoose(_ref2, $47e4439bafb1fe48$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useMemo = (0, $47e4439bafb1fe48$var$_react.useMemo)(function() {
        return $47e4439bafb1fe48$var$getClockState(elements);
    }, [
        elements
    ]), hourAngle = _useMemo.hourAngle, minuteAngle = _useMemo.minuteAngle, secondAngle = _useMemo.secondAngle;
    var _useMemo2 = (0, $47e4439bafb1fe48$var$_react.useMemo)(function() {
        return $47e4439bafb1fe48$var$getClockDimensions(theme);
    }, [
        theme
    ]), size = _useMemo2.size, secondSize = _useMemo2.secondSize, minuteSize = _useMemo2.minuteSize, hourSize = _useMemo2.hourSize;
    var halfSize = size / 2;
    var secondHand;
    if (precision === 'seconds') secondHand = /*#__PURE__*/ $47e4439bafb1fe48$var$_react["default"].createElement($085ab10282756fce$export$1c4c6736efe94e05, $47e4439bafb1fe48$var$_extends({
        x1: halfSize,
        y1: halfSize,
        x2: halfSize,
        y2: secondSize,
        stroke: "#000000",
        strokeLinecap: theme.clock.analog.second.shape,
        style: {
            transform: "rotate(" + secondAngle + "deg)",
            transformOrigin: halfSize + "px " + halfSize + "px"
        }
    }, passThemeFlag));
    var minuteHand;
    if (precision === 'seconds' || precision === 'minutes') minuteHand = /*#__PURE__*/ $47e4439bafb1fe48$var$_react["default"].createElement($085ab10282756fce$export$c4ef7b8e65ff349, $47e4439bafb1fe48$var$_extends({
        x1: halfSize,
        y1: halfSize,
        x2: halfSize,
        y2: minuteSize,
        stroke: "#000000",
        strokeLinecap: theme.clock.analog.minute.shape,
        style: {
            transform: "rotate(" + minuteAngle + "deg)",
            transformOrigin: halfSize + "px " + halfSize + "px"
        }
    }, passThemeFlag));
    return /*#__PURE__*/ $47e4439bafb1fe48$var$_react["default"].createElement($085ab10282756fce$export$8a4090086704219a, $47e4439bafb1fe48$var$_extends({
        ref: ref,
        version: "1.1",
        width: size,
        height: size,
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 " + size + " " + size
    }, passThemeFlag, rest), secondHand, minuteHand, /*#__PURE__*/ $47e4439bafb1fe48$var$_react["default"].createElement($085ab10282756fce$export$374360fd7041c894, $47e4439bafb1fe48$var$_extends({
        x1: halfSize,
        y1: halfSize,
        x2: halfSize,
        y2: hourSize,
        stroke: "#000000",
        strokeLinecap: theme.clock.analog.hour.shape,
        style: {
            transform: "rotate(" + hourAngle + "deg)",
            transformOrigin: halfSize + "px " + halfSize + "px"
        }
    }, passThemeFlag)));
});
$47e4439bafb1fe48$var$Analog.displayName = 'Analog';


var $d39c82e020605b11$export$1e511d4a378977f5;
var $d39c82e020605b11$export$3b7073cedb37804a;
"use strict";
$d39c82e020605b11$export$1e511d4a378977f5 = true;
$d39c82e020605b11$export$3b7073cedb37804a = void 0;

var $d39c82e020605b11$var$_react = $d39c82e020605b11$var$_interopRequireWildcard((parcelRequire("2xPiy")));



var $d39c82e020605b11$var$_excluded = [
    "elements",
    "precision",
    "run",
    "size"
];
function $d39c82e020605b11$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($d39c82e020605b11$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $d39c82e020605b11$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $d39c82e020605b11$var$_extends() {
    return $d39c82e020605b11$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d39c82e020605b11$var$_extends.apply(null, arguments);
}
var $d39c82e020605b11$var$Digit = function Digit(_ref) {
    var number = _ref.number, run = _ref.run, size = _ref.size;
    var _useState = (0, $d39c82e020605b11$var$_react.useState)(number), previous = _useState[0], setPrevious = _useState[1];
    var _useState2 = (0, $d39c82e020605b11$var$_react.useState)(), changing = _useState2[0], setChanging = _useState2[1];
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    (0, $d39c82e020605b11$var$_react.useEffect)(function() {
        if (number !== previous) {
            setChanging(true);
            var timer = setTimeout(function() {
                setPrevious(number);
                setChanging(false);
            }, 900);
            return function() {
                return clearTimeout(timer);
            };
        }
        return undefined;
    }, [
        number,
        previous
    ]);
    if (changing) {
        var direction = run === 'backward' ? 'down' : 'up';
        return /*#__PURE__*/ $d39c82e020605b11$var$_react["default"].createElement($085ab10282756fce$export$62187e24705e4453, $d39c82e020605b11$var$_extends({}, passThemeFlag, {
            size: size
        }), /*#__PURE__*/ $d39c82e020605b11$var$_react["default"].createElement($085ab10282756fce$export$53ad85ca611e5ca0, {
            direction: direction
        }, Math.floor(previous)), /*#__PURE__*/ $d39c82e020605b11$var$_react["default"].createElement($085ab10282756fce$export$3e34a191ce3a5aa, {
            direction: direction
        }, Math.floor(number)));
    }
    return /*#__PURE__*/ $d39c82e020605b11$var$_react["default"].createElement($085ab10282756fce$export$62187e24705e4453, $d39c82e020605b11$var$_extends({
        size: size
    }, passThemeFlag), Math.floor(number));
};
var $d39c82e020605b11$var$Element = function Element(_ref2) {
    var number = _ref2.number, run = _ref2.run, sep = _ref2.sep, size = _ref2.size;
    var _useThemeValue2 = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue2.passThemeFlag;
    var tens = Math.floor(number / 10);
    var ones = number % 10;
    var result = [
        /*#__PURE__*/ $d39c82e020605b11$var$_react["default"].createElement($d39c82e020605b11$var$Digit, {
            key: "tens",
            run: run,
            size: size,
            number: tens
        }),
        /*#__PURE__*/ $d39c82e020605b11$var$_react["default"].createElement($d39c82e020605b11$var$Digit, {
            key: "ones",
            run: run,
            size: size,
            number: ones
        })
    ];
    if (sep) result.unshift(/*#__PURE__*/ $d39c82e020605b11$var$_react["default"].createElement($085ab10282756fce$export$62187e24705e4453, $d39c82e020605b11$var$_extends({
        key: "sep",
        size: size
    }, passThemeFlag), ":"));
    return result;
};
var $d39c82e020605b11$var$Digital = $d39c82e020605b11$export$3b7073cedb37804a = /*#__PURE__*/ (0, $d39c82e020605b11$var$_react.forwardRef)(function(props, ref) {
    var elements = props.elements, precision = props.precision, run = props.run, size = props.size, rest = $d39c82e020605b11$var$_objectWithoutPropertiesLoose(props, $d39c82e020605b11$var$_excluded);
    var seconds;
    if (precision === 'seconds') seconds = /*#__PURE__*/ $d39c82e020605b11$var$_react["default"].createElement($d39c82e020605b11$var$Element, {
        number: elements.seconds,
        run: run,
        size: size,
        sep: true
    });
    var minutes;
    if (precision === 'minutes' || precision === 'seconds') minutes = /*#__PURE__*/ $d39c82e020605b11$var$_react["default"].createElement($d39c82e020605b11$var$Element, {
        number: elements.minutes,
        run: run,
        size: size,
        sep: true
    });
    return /*#__PURE__*/ $d39c82e020605b11$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $d39c82e020605b11$var$_extends({
        ref: ref,
        direction: "row"
    }, rest), /*#__PURE__*/ $d39c82e020605b11$var$_react["default"].createElement($d39c82e020605b11$var$Element, {
        number: elements.hours12 || elements.hours,
        run: run,
        size: size
    }), minutes, seconds);
});


var $e1c8d778f8e303d4$export$1e511d4a378977f5;
var $e1c8d778f8e303d4$export$4366c5666bf7409d;
"use strict";
$e1c8d778f8e303d4$export$1e511d4a378977f5 = true;
$e1c8d778f8e303d4$export$4366c5666bf7409d = void 0;

var $e1c8d778f8e303d4$var$_propTypes = $e1c8d778f8e303d4$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $e1c8d778f8e303d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $e1c8d778f8e303d4$var$_extends() {
    return $e1c8d778f8e303d4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e1c8d778f8e303d4$var$_extends.apply(null, arguments);
}
var $e1c8d778f8e303d4$var$PropType = {};
$e1c8d778f8e303d4$var$PropType = $e1c8d778f8e303d4$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    hourLimit: $e1c8d778f8e303d4$var$_propTypes["default"].oneOf([
        12,
        24,
        '12',
        '24'
    ]),
    onChange: $e1c8d778f8e303d4$var$_propTypes["default"].func,
    precision: $e1c8d778f8e303d4$var$_propTypes["default"].oneOf([
        'hours',
        'minutes',
        'seconds'
    ]),
    run: $e1c8d778f8e303d4$var$_propTypes["default"].oneOfType([
        $e1c8d778f8e303d4$var$_propTypes["default"].bool,
        $e1c8d778f8e303d4$var$_propTypes["default"].oneOf([
            'backward',
            'forward'
        ])
    ]),
    size: $e1c8d778f8e303d4$var$_propTypes["default"].oneOfType([
        $e1c8d778f8e303d4$var$_propTypes["default"].oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            'xxlarge'
        ]),
        $e1c8d778f8e303d4$var$_propTypes["default"].string
    ]),
    time: $e1c8d778f8e303d4$var$_propTypes["default"].string,
    type: $e1c8d778f8e303d4$var$_propTypes["default"].oneOf([
        'analog',
        'digital'
    ])
});
var $e1c8d778f8e303d4$var$ClockPropTypes = $e1c8d778f8e303d4$export$4366c5666bf7409d = $e1c8d778f8e303d4$var$PropType;


var $9b51af4eaaf40643$var$_excluded = [
    "hourLimit",
    "onChange",
    "precision",
    "run",
    "size",
    "time",
    "type"
];
function $9b51af4eaaf40643$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($9b51af4eaaf40643$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $9b51af4eaaf40643$var$_extends() {
    return $9b51af4eaaf40643$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9b51af4eaaf40643$var$_extends.apply(null, arguments);
}
function $9b51af4eaaf40643$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $9b51af4eaaf40643$var$TIME_REGEXP = /T([0-9]{2}):([0-9]{2})(?::([0-9.,]{2,}))?/;
var $9b51af4eaaf40643$var$DURATION_REGEXP = /^(-|\+)?P.*T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?$/;
var $9b51af4eaaf40643$var$parseTime = function parseTime(time, hourLimit) {
    var result = {};
    if (time) {
        var match = $9b51af4eaaf40643$var$DURATION_REGEXP.exec(time);
        if (match) {
            result.hours = parseFloat(match[2]) || 0;
            if (hourLimit === 12) result.hours12 = result.hours > 12 ? result.hours - 12 : result.hours;
            result.minutes = parseFloat(match[3]) || 0;
            result.seconds = parseFloat(match[4]) || 0;
            result.duration = true;
        } else {
            match = $9b51af4eaaf40643$var$TIME_REGEXP.exec(time);
            if (match) {
                result.hours = parseFloat(match[1]);
                if (hourLimit === 12) result.hours12 = result.hours > 12 ? result.hours - 12 : result.hours;
                result.minutes = parseFloat(match[2]) || 0;
                result.seconds = parseFloat(match[3]) || 0;
            } else console.error("Grommet Clock cannot parse '" + time + "'");
        }
    } else {
        var date = new Date();
        result.hours = date.getHours();
        result.minutes = date.getMinutes();
        result.seconds = date.getSeconds();
    }
    return result;
};
var $9b51af4eaaf40643$var$Clock = $9b51af4eaaf40643$export$9735c82c4bae3302 = /*#__PURE__*/ (0, $9b51af4eaaf40643$var$_react.forwardRef)(function(_ref, ref) {
    var _ref$hourLimit = _ref.hourLimit, hourLimit = _ref$hourLimit === void 0 ? 24 : _ref$hourLimit, onChange = _ref.onChange, _ref$precision = _ref.precision, precision = _ref$precision === void 0 ? 'seconds' : _ref$precision, _ref$run = _ref.run, run = _ref$run === void 0 ? 'forward' : _ref$run, _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, time = _ref.time, _ref$type = _ref.type, type = _ref$type === void 0 ? 'analog' : _ref$type, rest = $9b51af4eaaf40643$var$_objectWithoutPropertiesLoose(_ref, $9b51af4eaaf40643$var$_excluded);
    var _useState = (0, $9b51af4eaaf40643$var$_react.useState)($9b51af4eaaf40643$var$parseTime(time, hourLimit)), elements = _useState[0], setElements = _useState[1];
    (0, $9b51af4eaaf40643$var$_react.useEffect)(function() {
        return setElements($9b51af4eaaf40643$var$parseTime(time, hourLimit));
    }, [
        hourLimit,
        time
    ]);
    (0, $9b51af4eaaf40643$var$_react.useEffect)(function() {
        var atDurationEnd = run === 'backward' && elements.duration && !elements.hours && !elements.minutes && !elements.seconds;
        if (run && !atDurationEnd) {
            // set the interval time based on the precision
            var interval = 1000;
            var increment = 'seconds';
            if (precision !== 'seconds' && elements.seconds === 0) {
                interval *= 60;
                increment = 'minutes';
                if (precision !== 'minutes' && elements.minutes === 0) {
                    interval *= 60;
                    increment = 'hours';
                }
            }
            var timer = setInterval(function() {
                var nextElements = $9b51af4eaaf40643$var$_extends({}, elements);
                // adjust time based on precision
                if (increment === 'seconds') {
                    if (run === 'backward') nextElements.seconds -= 1;
                    else nextElements.seconds += 1;
                } else if (increment === 'minutes') {
                    if (run === 'backward') nextElements.minutes -= 1;
                    else nextElements.minutes += 1;
                } else if (increment === 'hours') {
                    if (run === 'backward') nextElements.hours -= 1;
                    else nextElements.hours += 1;
                }
                // deal with overflows
                if (nextElements.seconds >= 60) {
                    nextElements.minutes += Math.floor(nextElements.seconds / 60);
                    nextElements.seconds = 0;
                } else if (nextElements.seconds < 0) {
                    nextElements.minutes += Math.floor(nextElements.seconds / 60);
                    nextElements.seconds = 59;
                }
                if (nextElements.minutes >= 60) {
                    nextElements.hours += Math.floor(nextElements.minutes / 60);
                    nextElements.minutes = 0;
                } else if (nextElements.minutes < 0) {
                    nextElements.hours += Math.floor(nextElements.minutes / 60);
                    nextElements.minutes = 59;
                }
                if (nextElements.hours >= 24 || nextElements.hours < 0) nextElements.hours = 0;
                if (hourLimit === 12) nextElements.hours12 = nextElements.hours > 12 ? nextElements.hours - 12 : nextElements.hours;
                setElements(nextElements);
                if (onChange) {
                    var e = nextElements;
                    if (e.duration) onChange("P" + e.hours + "H" + e.minutes + "M" + e.seconds + "S");
                    else onChange("T" + e.hours + ":" + e.minutes + ":" + e.seconds);
                }
            }, interval);
            return function() {
                return clearInterval(timer);
            };
        }
        return undefined;
    }, [
        elements,
        hourLimit,
        onChange,
        precision,
        run
    ]);
    var content;
    if (type === 'analog') content = /*#__PURE__*/ $9b51af4eaaf40643$var$_react["default"].createElement($47e4439bafb1fe48$export$e4942f925b959595, $9b51af4eaaf40643$var$_extends({
        ref: ref,
        elements: elements,
        precision: precision,
        size: size
    }, rest));
    else if (type === 'digital') content = /*#__PURE__*/ $9b51af4eaaf40643$var$_react["default"].createElement($d39c82e020605b11$export$3b7073cedb37804a, $9b51af4eaaf40643$var$_extends({
        ref: ref,
        elements: elements,
        precision: precision,
        run: run,
        size: size
    }, rest));
    return content;
});
$9b51af4eaaf40643$var$Clock.displayName = 'Clock';
$9b51af4eaaf40643$var$Clock.propTypes = $e1c8d778f8e303d4$export$4366c5666bf7409d;


$db2ca7111e4ea3dd$export$9735c82c4bae3302 = $9b51af4eaaf40643$export$9735c82c4bae3302;


Object.keys($db2ca7111e4ea3dd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $db2ca7111e4ea3dd$exports[key]) return;
    $3321243da0932e1e$exports[key] = $db2ca7111e4ea3dd$exports[key];
});

Object.keys($6978a6eff11602a9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $6978a6eff11602a9$exports[key]) return;
    $3321243da0932e1e$exports[key] = $6978a6eff11602a9$exports[key];
});
var $3ad925e2d12764e5$exports = {};

$parcel$export($3ad925e2d12764e5$exports, "__esModule", function () { return $3ad925e2d12764e5$export$1e511d4a378977f5; }, function (v) { return $3ad925e2d12764e5$export$1e511d4a378977f5 = v; });
$parcel$export($3ad925e2d12764e5$exports, "formSortKey", function () { return $3ad925e2d12764e5$export$5d400b63d4a1c541; }, function (v) { return $3ad925e2d12764e5$export$5d400b63d4a1c541 = v; });
$parcel$export($3ad925e2d12764e5$exports, "formSearchKey", function () { return $3ad925e2d12764e5$export$af663afbf59caa0b; }, function (v) { return $3ad925e2d12764e5$export$af663afbf59caa0b = v; });
$parcel$export($3ad925e2d12764e5$exports, "formRangeKey", function () { return $3ad925e2d12764e5$export$58cb1cd3f7c80c90; }, function (v) { return $3ad925e2d12764e5$export$58cb1cd3f7c80c90 = v; });
$parcel$export($3ad925e2d12764e5$exports, "formColumnsKey", function () { return $3ad925e2d12764e5$export$6c37302973078e01; }, function (v) { return $3ad925e2d12764e5$export$6c37302973078e01 = v; });
$parcel$export($3ad925e2d12764e5$exports, "DataForm", function () { return $3ad925e2d12764e5$export$dcf38ffba6c01577; }, function (v) { return $3ad925e2d12764e5$export$dcf38ffba6c01577 = v; });
$parcel$export($3ad925e2d12764e5$exports, "Data", function () { return $3ad925e2d12764e5$export$2d0294657ab35f1b; }, function (v) { return $3ad925e2d12764e5$export$2d0294657ab35f1b = v; });
var $3ad925e2d12764e5$export$1e511d4a378977f5;
var $3ad925e2d12764e5$export$5d400b63d4a1c541;
var $3ad925e2d12764e5$export$af663afbf59caa0b;
var $3ad925e2d12764e5$export$58cb1cd3f7c80c90;
var $3ad925e2d12764e5$export$6c37302973078e01;
var $3ad925e2d12764e5$export$dcf38ffba6c01577;
var $3ad925e2d12764e5$export$2d0294657ab35f1b;
"use strict";
$3ad925e2d12764e5$export$1e511d4a378977f5 = true;
$3ad925e2d12764e5$export$5d400b63d4a1c541 = $3ad925e2d12764e5$export$af663afbf59caa0b = $3ad925e2d12764e5$export$58cb1cd3f7c80c90 = $3ad925e2d12764e5$export$6c37302973078e01 = $3ad925e2d12764e5$export$dcf38ffba6c01577 = $3ad925e2d12764e5$export$2d0294657ab35f1b = void 0;
var $c3eaf414750edd8e$export$1e511d4a378977f5;
var $c3eaf414750edd8e$export$2d0294657ab35f1b;
"use strict";
$c3eaf414750edd8e$export$1e511d4a378977f5 = true;
$c3eaf414750edd8e$export$2d0294657ab35f1b = void 0;

var $c3eaf414750edd8e$var$_react = $c3eaf414750edd8e$var$_interopRequireWildcard((parcelRequire("2xPiy")));


var $3ee1846956b4e555$exports = {};

$parcel$export($3ee1846956b4e555$exports, "__esModule", function () { return $3ee1846956b4e555$export$1e511d4a378977f5; }, function (v) { return $3ee1846956b4e555$export$1e511d4a378977f5 = v; });
$parcel$export($3ee1846956b4e555$exports, "DataFilters", function () { return $3ee1846956b4e555$export$32443de3cfb88b3c; }, function (v) { return $3ee1846956b4e555$export$32443de3cfb88b3c = v; });
var $3ee1846956b4e555$export$1e511d4a378977f5;
var $3ee1846956b4e555$export$32443de3cfb88b3c;
"use strict";
$3ee1846956b4e555$export$1e511d4a378977f5 = true;
$3ee1846956b4e555$export$32443de3cfb88b3c = void 0;
var $ce0209180cc90fd1$export$1e511d4a378977f5;
var $ce0209180cc90fd1$export$32443de3cfb88b3c;
"use strict";
$ce0209180cc90fd1$export$1e511d4a378977f5 = true;
$ce0209180cc90fd1$export$32443de3cfb88b3c = void 0;

var $ce0209180cc90fd1$var$_react = $ce0209180cc90fd1$var$_interopRequireWildcard((parcelRequire("2xPiy")));
var $77fad0572c6e1b7e$exports = {};

$parcel$export($77fad0572c6e1b7e$exports, "__esModule", function () { return $77fad0572c6e1b7e$export$1e511d4a378977f5; }, function (v) { return $77fad0572c6e1b7e$export$1e511d4a378977f5 = v; });
$parcel$export($77fad0572c6e1b7e$exports, "Filter", function () { return $77fad0572c6e1b7e$export$ec91da630f36d5ea; }, function (v) { return $77fad0572c6e1b7e$export$ec91da630f36d5ea = v; });
var $77fad0572c6e1b7e$export$1e511d4a378977f5;
var $77fad0572c6e1b7e$export$ec91da630f36d5ea;
"use strict";
$77fad0572c6e1b7e$export$1e511d4a378977f5 = true;
$77fad0572c6e1b7e$export$ec91da630f36d5ea = void 0;

var $77fad0572c6e1b7e$var$_react = $77fad0572c6e1b7e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $77fad0572c6e1b7e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($77fad0572c6e1b7e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $77fad0572c6e1b7e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $77fad0572c6e1b7e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $77fad0572c6e1b7e$var$_extends() {
    return $77fad0572c6e1b7e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $77fad0572c6e1b7e$var$_extends.apply(null, arguments);
}
var $77fad0572c6e1b7e$var$Filter = $77fad0572c6e1b7e$export$ec91da630f36d5ea = /*#__PURE__*/ (0, $77fad0572c6e1b7e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $77fad0572c6e1b7e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $77fad0572c6e1b7e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Filter"
    }, props), /*#__PURE__*/ $77fad0572c6e1b7e$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m3 6 7 7v8h4v-8l7-7V3H3z"
    }));
});
$77fad0572c6e1b7e$var$Filter.displayName = 'Filter';


var $465d22e15ca8d0c4$exports = {};

$parcel$export($465d22e15ca8d0c4$exports, "__esModule", function () { return $465d22e15ca8d0c4$export$1e511d4a378977f5; }, function (v) { return $465d22e15ca8d0c4$export$1e511d4a378977f5 = v; });
$parcel$export($465d22e15ca8d0c4$exports, "Close", function () { return $465d22e15ca8d0c4$export$f39c2d165cd861fe; }, function (v) { return $465d22e15ca8d0c4$export$f39c2d165cd861fe = v; });
var $465d22e15ca8d0c4$export$1e511d4a378977f5;
var $465d22e15ca8d0c4$export$f39c2d165cd861fe;
"use strict";
$465d22e15ca8d0c4$export$1e511d4a378977f5 = true;
$465d22e15ca8d0c4$export$f39c2d165cd861fe = void 0;

var $465d22e15ca8d0c4$var$_react = $465d22e15ca8d0c4$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $465d22e15ca8d0c4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($465d22e15ca8d0c4$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $465d22e15ca8d0c4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $465d22e15ca8d0c4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $465d22e15ca8d0c4$var$_extends() {
    return $465d22e15ca8d0c4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $465d22e15ca8d0c4$var$_extends.apply(null, arguments);
}
var $465d22e15ca8d0c4$var$Close = $465d22e15ca8d0c4$export$f39c2d165cd861fe = /*#__PURE__*/ (0, $465d22e15ca8d0c4$var$_react.forwardRef)(function(props, ref) {
    var scaleProps = (0, $1b754218be0a6592$export$56a2e46cd4a7c217)(props);
    return /*#__PURE__*/ $465d22e15ca8d0c4$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $465d22e15ca8d0c4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Close"
    }, props), /*#__PURE__*/ $465d22e15ca8d0c4$var$_react["default"].createElement("path", $465d22e15ca8d0c4$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m3 3 18 18M3 21 21 3"
    }, scaleProps)));
});
$465d22e15ca8d0c4$var$Close.displayName = 'Close';




var $70cc0737328cfe1c$exports = {};

$parcel$export($70cc0737328cfe1c$exports, "__esModule", function () { return $70cc0737328cfe1c$export$1e511d4a378977f5; }, function (v) { return $70cc0737328cfe1c$export$1e511d4a378977f5 = v; });
$parcel$export($70cc0737328cfe1c$exports, "DataClearFilters", function () { return $70cc0737328cfe1c$export$1129e998938c6510; }, function (v) { return $70cc0737328cfe1c$export$1129e998938c6510 = v; });
var $70cc0737328cfe1c$export$1e511d4a378977f5;
var $70cc0737328cfe1c$export$1129e998938c6510;
"use strict";
$70cc0737328cfe1c$export$1e511d4a378977f5 = true;
$70cc0737328cfe1c$export$1129e998938c6510 = void 0;
var $ed75f970d0e611a7$export$1e511d4a378977f5;
var $ed75f970d0e611a7$export$1129e998938c6510;
"use strict";
$ed75f970d0e611a7$export$1e511d4a378977f5 = true;
$ed75f970d0e611a7$export$1129e998938c6510 = void 0;

var $ed75f970d0e611a7$var$_react = $ed75f970d0e611a7$var$_interopRequireWildcard((parcelRequire("2xPiy")));
var $8929f48502f48eae$export$1e511d4a378977f5;
var $8929f48502f48eae$export$6671b4010eef64fb;
"use strict";
$8929f48502f48eae$export$1e511d4a378977f5 = true;
$8929f48502f48eae$export$6671b4010eef64fb = void 0;

var $8929f48502f48eae$var$DataClearFiltersPropTypes = $8929f48502f48eae$export$6671b4010eef64fb = $5c5e21b37c7cd707$export$932f054f6b4bba8d;






var $ed75f970d0e611a7$var$_excluded = [
    "onClick"
];
function $ed75f970d0e611a7$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($ed75f970d0e611a7$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $ed75f970d0e611a7$var$_extends() {
    return $ed75f970d0e611a7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ed75f970d0e611a7$var$_extends.apply(null, arguments);
}
function $ed75f970d0e611a7$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $ed75f970d0e611a7$var$DataClearFilters = $ed75f970d0e611a7$export$1129e998938c6510 = /*#__PURE__*/ (0, $ed75f970d0e611a7$var$_react.forwardRef)(function(_ref, ref) {
    var _theme$data$button;
    var _onClick = _ref.onClick, rest = $ed75f970d0e611a7$var$_objectWithoutPropertiesLoose(_ref, $ed75f970d0e611a7$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useContext = (0, $ed75f970d0e611a7$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var _useContext2 = (0, $ed75f970d0e611a7$var$_react.useContext)($932597a497e37de0$export$58d75f9829cbe158), clearFilters = _useContext2.clearFilters, messages = _useContext2.messages;
    return /*#__PURE__*/ $ed75f970d0e611a7$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, $ed75f970d0e611a7$var$_extends({
        ref: ref,
        kind: (_theme$data$button = theme.data.button) == null ? void 0 : _theme$data$button.kind,
        label: format({
            id: 'dataFilters.clear',
            messages: messages == null ? void 0 : messages.dataFilters
        }),
        onClick: function onClick(event) {
            clearFilters();
            if (_onClick) _onClick(event);
        }
    }, rest));
});
$ed75f970d0e611a7$var$DataClearFilters.displayName = 'DataClearFilters';
$ed75f970d0e611a7$var$DataClearFilters.propTypes = $8929f48502f48eae$export$6671b4010eef64fb;


$70cc0737328cfe1c$export$1129e998938c6510 = $ed75f970d0e611a7$export$1129e998938c6510;


var $b001492d8dcf4f6c$exports = {};

$parcel$export($b001492d8dcf4f6c$exports, "__esModule", function () { return $b001492d8dcf4f6c$export$1e511d4a378977f5; }, function (v) { return $b001492d8dcf4f6c$export$1e511d4a378977f5 = v; });
$parcel$export($b001492d8dcf4f6c$exports, "DataFilter", function () { return $b001492d8dcf4f6c$export$bf2cd9c1afd10b96; }, function (v) { return $b001492d8dcf4f6c$export$bf2cd9c1afd10b96 = v; });
var $b001492d8dcf4f6c$export$1e511d4a378977f5;
var $b001492d8dcf4f6c$export$bf2cd9c1afd10b96;
"use strict";
$b001492d8dcf4f6c$export$1e511d4a378977f5 = true;
$b001492d8dcf4f6c$export$bf2cd9c1afd10b96 = void 0;
var $8481a9fe404a179c$export$1e511d4a378977f5;
var $8481a9fe404a179c$export$bf2cd9c1afd10b96;
"use strict";
$8481a9fe404a179c$export$1e511d4a378977f5 = true;
$8481a9fe404a179c$export$bf2cd9c1afd10b96 = void 0;

var $8481a9fe404a179c$var$_react = $8481a9fe404a179c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $46eb34c25d0c5f74$export$1e511d4a378977f5;
var $46eb34c25d0c5f74$export$a8a98df84922a01b;
var $46eb34c25d0c5f74$export$b5956a4982c715c9;
var $46eb34c25d0c5f74$export$5d400b63d4a1c541;
var $46eb34c25d0c5f74$export$af663afbf59caa0b;
var $46eb34c25d0c5f74$export$58cb1cd3f7c80c90;
var $46eb34c25d0c5f74$export$b4687acc98530286;
var $46eb34c25d0c5f74$export$258e64b73a7a9f67;
var $46eb34c25d0c5f74$export$6c37302973078e01;
var $46eb34c25d0c5f74$export$dcf38ffba6c01577;
"use strict";
$46eb34c25d0c5f74$export$1e511d4a378977f5 = true;
$46eb34c25d0c5f74$export$a8a98df84922a01b = $46eb34c25d0c5f74$export$b5956a4982c715c9 = $46eb34c25d0c5f74$export$5d400b63d4a1c541 = $46eb34c25d0c5f74$export$af663afbf59caa0b = $46eb34c25d0c5f74$export$58cb1cd3f7c80c90 = $46eb34c25d0c5f74$export$b4687acc98530286 = $46eb34c25d0c5f74$export$258e64b73a7a9f67 = $46eb34c25d0c5f74$export$6c37302973078e01 = $46eb34c25d0c5f74$export$dcf38ffba6c01577 = void 0;

var $46eb34c25d0c5f74$var$_react = $46eb34c25d0c5f74$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $46eb34c25d0c5f74$var$_styledComponents = $46eb34c25d0c5f74$var$_interopRequireDefault((parcelRequire("iA1nz")));



var $b39d3fd88e3f6fd8$exports = {};

$parcel$export($b39d3fd88e3f6fd8$exports, "__esModule", function () { return $b39d3fd88e3f6fd8$export$1e511d4a378977f5; }, function (v) { return $b39d3fd88e3f6fd8$export$1e511d4a378977f5 = v; });
$parcel$export($b39d3fd88e3f6fd8$exports, "FormContext", function () { return $b39d3fd88e3f6fd8$export$c24727297075ec6a; }, function (v) { return $b39d3fd88e3f6fd8$export$c24727297075ec6a = v; });
$parcel$export($b39d3fd88e3f6fd8$exports, "Form", function () { return $b39d3fd88e3f6fd8$export$a7fed597f4b8afd8; }, function (v) { return $b39d3fd88e3f6fd8$export$a7fed597f4b8afd8 = v; });
var $b39d3fd88e3f6fd8$export$1e511d4a378977f5;
var $b39d3fd88e3f6fd8$export$c24727297075ec6a;
var $b39d3fd88e3f6fd8$export$a7fed597f4b8afd8;
"use strict";
$b39d3fd88e3f6fd8$export$1e511d4a378977f5 = true;
$b39d3fd88e3f6fd8$export$c24727297075ec6a = $b39d3fd88e3f6fd8$export$a7fed597f4b8afd8 = void 0;
var $19634264a80b511e$export$1e511d4a378977f5;
var $19634264a80b511e$export$a7fed597f4b8afd8;
"use strict";
$19634264a80b511e$export$1e511d4a378977f5 = true;
$19634264a80b511e$export$a7fed597f4b8afd8 = void 0;

var $19634264a80b511e$var$_react = $19634264a80b511e$var$_interopRequireWildcard((parcelRequire("2xPiy")));




var $e620ec03f3cd38f5$export$1e511d4a378977f5;
var $e620ec03f3cd38f5$export$87387e52a99daa8;
"use strict";
$e620ec03f3cd38f5$export$1e511d4a378977f5 = true;
$e620ec03f3cd38f5$export$87387e52a99daa8 = void 0;

var $e620ec03f3cd38f5$var$_propTypes = $e620ec03f3cd38f5$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $e620ec03f3cd38f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $e620ec03f3cd38f5$var$PropType = {};
$e620ec03f3cd38f5$var$PropType = {
    errors: $e620ec03f3cd38f5$var$_propTypes["default"].shape({}),
    infos: $e620ec03f3cd38f5$var$_propTypes["default"].shape({}),
    kind: $e620ec03f3cd38f5$var$_propTypes["default"].string,
    messages: $e620ec03f3cd38f5$var$_propTypes["default"].shape({
        invalid: $e620ec03f3cd38f5$var$_propTypes["default"].string,
        required: $e620ec03f3cd38f5$var$_propTypes["default"].string
    }),
    onChange: $e620ec03f3cd38f5$var$_propTypes["default"].func,
    onSubmit: $e620ec03f3cd38f5$var$_propTypes["default"].func,
    onReset: $e620ec03f3cd38f5$var$_propTypes["default"].func,
    onValidate: $e620ec03f3cd38f5$var$_propTypes["default"].func,
    validate: $e620ec03f3cd38f5$var$_propTypes["default"].oneOf([
        'blur',
        'submit',
        'change'
    ]),
    value: $e620ec03f3cd38f5$var$_propTypes["default"].shape({})
};
var $e620ec03f3cd38f5$var$FormPropTypes = $e620ec03f3cd38f5$export$87387e52a99daa8 = $e620ec03f3cd38f5$var$PropType;


var $19634264a80b511e$var$_excluded = [
    "children",
    "errors",
    "infos",
    "messages",
    "kind",
    "onChange",
    "onReset",
    "onSubmit",
    "onValidate",
    "validate",
    "value"
];
function $19634264a80b511e$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($19634264a80b511e$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $19634264a80b511e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $19634264a80b511e$var$_extends() {
    return $19634264a80b511e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $19634264a80b511e$var$_extends.apply(null, arguments);
}
var $19634264a80b511e$var$defaultValue = {};
var $19634264a80b511e$var$defaultTouched = {};
var $19634264a80b511e$var$defaultValidationResults = {
    errors: {},
    infos: {}
};
var $19634264a80b511e$var$defaultThreshold = 0.5;
var $19634264a80b511e$var$stringToArray = function stringToArray(string) {
    var match = string == null ? void 0 : string.match(/^(.+)\[([0-9]+)\]\.(.*)$/);
    if (match) {
        var arrayName = match[1], indexOfArray = match[2], arrayObjName = match[3];
        return {
            indexOfArray: indexOfArray,
            arrayName: arrayName,
            arrayObjName: arrayObjName
        };
    }
    return undefined;
};
var $19634264a80b511e$var$_getValueAt = function getValueAt(valueObject, pathArg) {
    if (valueObject === undefined) return undefined;
    var path = Array.isArray(pathArg) ? pathArg : pathArg.split('.');
    if (path.length === 1) return valueObject[path];
    return $19634264a80b511e$var$_getValueAt(valueObject[path.shift()], path);
};
var $19634264a80b511e$var$_setValueAt = function setValueAt(valueObject, pathArg, value) {
    var object = valueObject;
    var path = Array.isArray(pathArg) ? pathArg : pathArg.split('.');
    if (path.length === 1) object[path] = value;
    else {
        var key = path.shift();
        if (!object[key]) object[key] = {};
        $19634264a80b511e$var$_setValueAt(object[key], path, value);
    }
};
var $19634264a80b511e$var$getFieldValue = function getFieldValue(name, value) {
    var isArrayField = $19634264a80b511e$var$stringToArray(name);
    if (isArrayField) {
        var _value$arrayName;
        var indexOfArray = isArrayField.indexOfArray, arrayName = isArrayField.arrayName, arrayObjName = isArrayField.arrayObjName;
        var obj = (_value$arrayName = value[arrayName]) == null ? void 0 : _value$arrayName[indexOfArray];
        return arrayObjName ? obj == null ? void 0 : obj[arrayObjName] : obj;
    }
    return $19634264a80b511e$var$_getValueAt(value, name);
};
var $19634264a80b511e$var$setFieldValue = function setFieldValue(name, componentValue, prevValue) {
    var nextValue = $19634264a80b511e$var$_extends({}, prevValue);
    var isArrayField = $19634264a80b511e$var$stringToArray(name);
    if (isArrayField) {
        var indexOfArray = isArrayField.indexOfArray, arrayName = isArrayField.arrayName, arrayObjName = isArrayField.arrayObjName;
        if (!nextValue[arrayName]) nextValue[arrayName] = [];
        if (arrayObjName) {
            var _nextValue$arrayName$;
            if (!nextValue[arrayName][indexOfArray]) nextValue[arrayName][indexOfArray] = (_nextValue$arrayName$ = {}, _nextValue$arrayName$[arrayObjName] = componentValue, _nextValue$arrayName$);
            nextValue[arrayName][indexOfArray][arrayObjName] = componentValue;
        } else nextValue[arrayName][indexOfArray] = componentValue;
    } else $19634264a80b511e$var$_setValueAt(nextValue, name, componentValue);
    return nextValue;
};
var $19634264a80b511e$var$validateCharacterCount = function validateCharacterCount(format, rule, value) {
    var max = rule.max, threshold = rule.threshold;
    var getMessage = function getMessage() {
        var charactersRemaining = function charactersRemaining(plural) {
            return {
                id: "formField.maxCharacters.remaining." + (plural ? 'plural' : 'singular'),
                values: {
                    number: max - value.length
                }
            };
        };
        var charactersOverLimit = function charactersOverLimit(plural) {
            return {
                id: "formField.maxCharacters.overLimit." + (plural ? 'plural' : 'singular'),
                values: {
                    number: value.length - max
                }
            };
        };
        if (max - value.length >= 0) return format(charactersRemaining(max - value.length > 1));
        return format(charactersOverLimit(value.length - max > 1));
    };
    return value.length / max > (threshold != null ? threshold : $19634264a80b511e$var$defaultThreshold) ? {
        status: max - value.length >= 0 ? 'info' : 'error',
        message: getMessage()
    } : undefined;
};
// Apply validation rule to field value and send correct messaging.
var $19634264a80b511e$var$validate = function validate(rule, fieldValue, formValue, format, messages) {
    var result;
    if (typeof rule === 'function') result = rule(fieldValue, formValue);
    else if (rule.regexp) {
        if (!rule.regexp.test(fieldValue)) {
            result = rule.message || format({
                id: 'form.invalid',
                messages: messages
            });
            if (rule.status) result = {
                message: result,
                status: rule.status
            };
        }
    } else if (rule.max) result = $19634264a80b511e$var$validateCharacterCount(format, rule, fieldValue);
    return result;
};
// Validates particular key in formValue
var $19634264a80b511e$var$validateName = function validateName(validationRules, required) {
    return function(name, formValue, format, messages) {
        var fieldValue = $19634264a80b511e$var$getFieldValue(name, formValue);
        var validationResult;
        if (required && // false is for CheckBox
        (fieldValue === undefined || fieldValue === '' || fieldValue === false || Array.isArray(fieldValue) && !fieldValue.length)) validationResult = format({
            id: 'form.required',
            messages: messages
        });
        else if (validationRules) {
            if (Array.isArray(validationRules)) validationRules.some(function(rule) {
                validationResult = $19634264a80b511e$var$validate(rule, fieldValue, formValue, format, messages);
                return !!validationResult;
            });
            else validationResult = $19634264a80b511e$var$validate(validationRules, fieldValue, formValue, format, messages);
        }
        return validationResult;
    };
};
// Validates all keys in formValue
var $19634264a80b511e$var$validateForm = function validateForm(validationRules, formValue, format, messages, omitValid) {
    var nextErrors = {};
    var nextInfos = {};
    validationRules.forEach(function(_ref) {
        var name = _ref[0], _ref$ = _ref[1], field = _ref$.field, input = _ref$.input, validateOn = _ref$.validateOn;
        if (!omitValid) {
            nextErrors[name] = undefined;
            nextInfos[name] = undefined;
        }
        if (!validateOn) return;
        var result;
        if (input) // input() a validation function supplied through useFormInput()
        result = input(name, formValue, format, messages);
        if (field && !result) // field() a validation function supplied through useFormField()
        result = field(name, formValue, format, messages);
        // typeof error === 'object' is implied for both cases of error with
        // a status message and for an error object that is a react node
        if (typeof result === 'object') {
            if (result.status === 'info') nextInfos[name] = result.message;
            else nextErrors[name] = result.message || result; // could be a node
        } else if (typeof result === 'string') nextErrors[name] = result;
    });
    return [
        nextErrors,
        nextInfos
    ];
};
var $19634264a80b511e$var$isInstantValidate = function isInstantValidate(validateOn) {
    return [
        'blur',
        'change'
    ].includes(validateOn);
};
var $19634264a80b511e$var$Form = $19634264a80b511e$export$a7fed597f4b8afd8 = /*#__PURE__*/ (0, $19634264a80b511e$var$_react.forwardRef)(function(_ref2, ref) {
    var children = _ref2.children, _ref2$errors = _ref2.errors, errorsProp = _ref2$errors === void 0 ? $19634264a80b511e$var$defaultValidationResults.errors : _ref2$errors, _ref2$infos = _ref2.infos, infosProp = _ref2$infos === void 0 ? $19634264a80b511e$var$defaultValidationResults.infos : _ref2$infos, messages = _ref2.messages, kind = _ref2.kind, onChange = _ref2.onChange, _onReset = _ref2.onReset, _onSubmit = _ref2.onSubmit, onValidate = _ref2.onValidate, _ref2$validate = _ref2.validate, validateOnProp = _ref2$validate === void 0 ? 'submit' : _ref2$validate, valueProp = _ref2.value, rest = $19634264a80b511e$var$_objectWithoutPropertiesLoose(_ref2, $19634264a80b511e$var$_excluded);
    var formRef = (0, $4113023f9e0bafa0$exports.useForwardedRef)(ref);
    var _useContext = (0, $19634264a80b511e$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var _useState = (0, $19634264a80b511e$var$_react.useState)(valueProp || $19634264a80b511e$var$defaultValue), valueState = _useState[0], setValueState = _useState[1];
    var value = (0, $19634264a80b511e$var$_react.useMemo)(function() {
        return valueProp || valueState;
    }, [
        valueProp,
        valueState
    ]);
    var _useState2 = (0, $19634264a80b511e$var$_react.useState)($19634264a80b511e$var$defaultTouched), touched = _useState2[0], setTouched = _useState2[1];
    var _useState3 = (0, $19634264a80b511e$var$_react.useState)(validateOnProp), validateOn = _useState3[0], setValidateOn = _useState3[1];
    var _useState4 = (0, $19634264a80b511e$var$_react.useState)({
        errors: errorsProp,
        infos: infosProp
    }), validationResults = _useState4[0], setValidationResults = _useState4[1];
    // maintain a copy of validationResults in a ref for useEffects
    // which can't depend on validationResults directly without
    // causing infinite renders.
    var validationResultsRef = (0, $19634264a80b511e$var$_react.useRef)({});
    // Simulated onMount state. Consider Form to be mounted once it has
    // accounted for values originating from controlled inputs (available
    // at second rendering).
    var _useState5 = (0, $19634264a80b511e$var$_react.useState)('unmounted'), mounted = _useState5[0], setMounted = _useState5[1];
    (0, $19634264a80b511e$var$_react.useEffect)(function() {
        if (!mounted) setMounted('mounting');
        else if (mounted === 'mounting') setMounted('mounted');
    }, [
        mounted
    ]);
    // `pendingValidation` is the name of the FormField awaiting validation.
    var _useState6 = (0, $19634264a80b511e$var$_react.useState)(undefined), pendingValidation = _useState6[0], setPendingValidation = _useState6[1];
    var validationRulesRef = (0, $19634264a80b511e$var$_react.useRef)({});
    var requiredFields = (0, $19634264a80b511e$var$_react.useRef)([]);
    var analyticsRef = (0, $19634264a80b511e$var$_react.useRef)({
        start: new Date(),
        errors: {}
    });
    var sendAnalytics = (0, $58f4f715ab4fa2c4$exports.useAnalytics)();
    var buildValid = (0, $19634264a80b511e$var$_react.useCallback)(function(nextErrors) {
        var valid = false;
        valid = requiredFields.current.filter(function(n) {
            return Object.keys(validationRulesRef.current).includes(n);
        }).every(function(field) {
            return value[field] && (value[field] !== '' || value[field] !== false);
        });
        if (Object.keys(nextErrors).length > 0) valid = false;
        return valid;
    }, [
        value
    ]);
    // Only keep validation results for current form fields. In the case of a
    // dynamic form, a field possessing an error may have been removed from the
    // form; need to clean up any previous related validation results.
    var filterRemovedFields = function filterRemovedFields(prevValidations) {
        var nextValidations = prevValidations;
        return Object.keys(nextValidations).filter(function(n) {
            return !validationRulesRef.current[n] || nextValidations[n] === undefined;
        }).forEach(function(n) {
            return delete nextValidations[n];
        });
    };
    var updateAnalytics = function updateAnalytics() {
        var _validationResultsRef;
        var errorFields = Object.keys((_validationResultsRef = validationResultsRef.current) == null ? void 0 : _validationResultsRef.errors);
        var errorCounts = analyticsRef.current.errors;
        if (errorFields.length > 0) errorFields.forEach(function(key) {
            errorCounts[key] = (errorCounts[key] || 0) + 1;
        });
    };
    var applyValidationRules = (0, $19634264a80b511e$var$_react.useCallback)(function(validationRules) {
        var _validateForm = $19634264a80b511e$var$validateForm(validationRules, value, format, messages), validatedErrors = _validateForm[0], validatedInfos = _validateForm[1];
        setValidationResults(function(prevValidationResults) {
            // Keep any previous errors and infos for untouched keys,
            // these may have come from a Submit.
            var nextErrors = $19634264a80b511e$var$_extends({}, prevValidationResults.errors, validatedErrors);
            var nextInfos = $19634264a80b511e$var$_extends({}, prevValidationResults.infos, validatedInfos);
            // Remove previous errors and infos for keys no longer in the
            // form, these may have been fields removed from a dynamic form.
            filterRemovedFields(nextErrors);
            filterRemovedFields(nextInfos);
            var nextValidationResults = {
                errors: nextErrors,
                infos: nextInfos
            };
            if (onValidate) onValidate($19634264a80b511e$var$_extends({}, nextValidationResults, {
                valid: buildValid(nextErrors)
            }));
            validationResultsRef.current = nextValidationResults;
            updateAnalytics();
            return nextValidationResults;
        });
    }, [
        buildValid,
        format,
        messages,
        onValidate,
        value
    ]);
    // Validate all fields holding values onMount if set to
    // validate when blur or change.
    (0, $19634264a80b511e$var$_react.useEffect)(function() {
        var validationRules = Object.entries(validationRulesRef.current);
        // Use simulated onMount state to account for values provided by
        // controlled inputs.
        if (mounted !== 'mounted' && ($19634264a80b511e$var$isInstantValidate(validateOn) || validationRules.some(function(_ref3) {
            var v = _ref3[1];
            return $19634264a80b511e$var$isInstantValidate(v.validateOn);
        })) && Object.keys(value).length > 0 && Object.keys(touched).length === 0) applyValidationRules(validationRules.filter(function(_ref4) {
            var n = _ref4[0], v = _ref4[1];
            return $19634264a80b511e$var$getFieldValue(n, value) && v.validateOn;
        })// Exlude empty arrays which may be initial values in
        // an input such as DateInput.
        .filter(function(_ref5) {
            var n = _ref5[0];
            return !(Array.isArray($19634264a80b511e$var$getFieldValue(n, value)) && $19634264a80b511e$var$getFieldValue(n, value).length === 0);
        }));
    }, [
        applyValidationRules,
        mounted,
        touched,
        validateOn,
        value
    ]);
    // Run validation against fields with pendingValidations from onBlur
    // and/or onChange.
    (0, $19634264a80b511e$var$_react.useEffect)(function() {
        var validationRules = Object.entries(validationRulesRef.current);
        var timer = setTimeout(function() {
            if (pendingValidation && ($19634264a80b511e$var$isInstantValidate(validateOn) || validationRules.some(function(_ref6) {
                var v = _ref6[1];
                return $19634264a80b511e$var$isInstantValidate(v.validateOn);
            }))) {
                applyValidationRules(validationRules.filter(function(_ref7) {
                    var n = _ref7[0], v = _ref7[1];
                    return (touched[n] || pendingValidation.includes(n)) && v.validateOn;
                }));
                setPendingValidation(undefined);
            }
        // Complete any potential click events before running onBlur validation.
        // Otherwise, click events like reset, etc. may not be registered. For a
        // detailed scenario/discussion, see: https://github.com/grommet/grommet/issues/4863
        // Values empirically tested; 120 was selected because it is the largest
        // Chrome: 100, Safari: 120, Firefox: 80
        }, 120);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        applyValidationRules,
        pendingValidation,
        touched,
        validateOn
    ]);
    // Re-run validation rules for all fields with prior errors.
    // if validate=blur this helps re-validate if there are errors
    // as the user fixes them (basically act like validate=change for that)
    (0, $19634264a80b511e$var$_react.useEffect)(function() {
        var _validationResultsRef2;
        var validationRules = Object.entries(validationRulesRef.current);
        if ((_validationResultsRef2 = validationResultsRef.current) != null && _validationResultsRef2.errors && Object.keys(validationResultsRef.current.errors).length > 0) applyValidationRules(validationRules.filter(function(_ref8) {
            var n = _ref8[0];
            return touched[n] && validationResultsRef.current.errors[n];
        }));
    }, [
        applyValidationRules,
        touched
    ]);
    (0, $19634264a80b511e$var$_react.useEffect)(function() {
        var element = formRef.current;
        analyticsRef.current = {
            start: new Date(),
            errors: {}
        };
        sendAnalytics({
            type: 'formOpen',
            element: element
        });
        return function() {
            if (!analyticsRef.current.submitted) sendAnalytics({
                type: 'formClose',
                element: element,
                errors: analyticsRef.current.errors,
                elapsed: new Date().getTime() - analyticsRef.current.start.getTime()
            });
        };
    }, [
        sendAnalytics,
        formRef
    ]);
    // There are three basic patterns of handling form input value state:
    //
    // 1 - form controlled
    //
    // In this model, the caller sets `value` and `onChange` properties
    // on the Form component to supply the values used by the input fields.
    // In useFormContext(), componentValue would be undefined and formValue
    // is be set to whatever the form state has. Whenever the form state
    // changes, we update the contextValue so the input component will use
    // that. When the input component changes, we will call update() to
    // update the form state.
    //
    // 2 - input controlled
    //
    // In this model, the caller sets `value` and `onChange` properties
    // on the input components, like TextInput, to supply the value for it.
    // In useFormContext(), componentValue is this value and we ensure to
    // update the form state, via update(), and set the contextValue from
    // the componentValue. When the input component changes, we will
    // call update() to update the form state.
    //
    // 3 - uncontrolled
    //
    // In this model, the caller doesn't set a `value` or `onChange` property
    // at either the form or input component levels.
    // In useFormContext(), componentValue is undefined and valueProp is
    // undefined and nothing much happens here. That is, unless the
    // calling component needs to know the state in order to work, such
    // as CheckBox or Select. In this case, those components supply
    // an initialValue, which will trigger updating the contextValue so
    // they can have access to it.
    //
    var formContextValue = (0, $19634264a80b511e$var$_react.useMemo)(function() {
        var useFormInput = function useFormInput(_ref9) {
            var name = _ref9.name, componentValue = _ref9.value, initialValue = _ref9.initialValue, validateArg = _ref9.validate;
            var _useState7 = (0, $19634264a80b511e$var$_react.useState)(initialValue), inputValue = _useState7[0], setInputValue = _useState7[1];
            var formValue = name ? $19634264a80b511e$var$getFieldValue(name, value) : undefined;
            // for dynamic forms, we need to track when an input has been added to
            // the form value. if the input is unmounted, we will delete its
            // key/value from the form value.
            var keyCreated = (0, $19634264a80b511e$var$_react.useRef)(false);
            // This effect is for pattern #2, where the controlled input
            // component is driving the value via componentValue.
            (0, $19634264a80b511e$var$_react.useEffect)(function() {
                if (name && // we have somewhere to put this
                componentValue !== undefined && // input driving
                (Array.isArray(componentValue) && Array.isArray(formValue) ? componentValue.toString() !== formValue.toString() : componentValue !== formValue // don't already have it
                )) setValueState(function(prevValue) {
                    return $19634264a80b511e$var$setFieldValue(name, componentValue, prevValue);
                });
            }, [
                componentValue,
                formValue,
                name
            ]);
            // on unmount, if the form is uncontrolled, remove the key/value
            // from the form value
            (0, $19634264a80b511e$var$_react.useEffect)(function() {
                return function() {
                    if (keyCreated.current) {
                        keyCreated.current = false;
                        setValueState(function(prevValue) {
                            var nextValue = $19634264a80b511e$var$_extends({}, prevValue);
                            var isArrayField = $19634264a80b511e$var$stringToArray(name);
                            if (isArrayField) {
                                var arrayName = isArrayField.arrayName;
                                delete nextValue[arrayName];
                            } else delete nextValue[name];
                            return nextValue;
                        });
                    }
                };
            }, // eslint-disable-next-line react-hooks/exhaustive-deps
            [] // only run onmount and unmount
            );
            // Create validation rules for fields
            (0, $19634264a80b511e$var$_react.useEffect)(function() {
                if (validateArg) {
                    if (!validationRulesRef.current[name]) validationRulesRef.current[name] = {};
                    validationRulesRef.current[name].input = $19634264a80b511e$var$validateName(validateArg);
                    return function() {
                        return delete validationRulesRef.current[name].input;
                    };
                }
                return undefined;
            }, [
                validateArg,
                name
            ]);
            var useValue;
            if (componentValue !== undefined) // input component drives, pattern #2
            useValue = componentValue;
            else if (valueProp && name && formValue !== undefined) // form drives, pattern #1
            useValue = formValue;
            else if (formValue === undefined && name) // form has reset, so reset input value as well
            useValue = initialValue;
            else useValue = inputValue;
            return [
                useValue,
                function(nextComponentValue) {
                    if (name) {
                        // we have somewhere to put this
                        var nextTouched = $19634264a80b511e$var$_extends({}, touched);
                        nextTouched[name] = true;
                        if (!touched[name]) // don't update if not needed
                        setTouched(nextTouched);
                        // if nextValue doesn't have a key for name, this must be
                        // uncontrolled form. we will flag this field was added so
                        // we know to remove its value from the form if it is dynamically
                        // removed
                        if (!(name in value)) keyCreated.current = true;
                        var nextValue = $19634264a80b511e$var$setFieldValue(name, nextComponentValue, value);
                        setValueState(nextValue);
                        if (onChange) onChange(nextValue, {
                            touched: nextTouched
                        });
                    }
                    if (initialValue !== undefined) setInputValue(nextComponentValue);
                }
            ];
        };
        var useFormField = function useFormField(_ref0) {
            var errorArg = _ref0.error, infoArg = _ref0.info, name = _ref0.name, required = _ref0.required, disabled = _ref0.disabled, validateArg = _ref0.validate, validateOnArg = _ref0.validateOn;
            var error = disabled ? undefined : errorArg || validationResults.errors[name];
            var info = infoArg || validationResults.infos[name];
            (0, $19634264a80b511e$var$_react.useEffect)(function() {
                setValidateOn(function(prevValues) {
                    var _extends2;
                    if (typeof prevValues === 'string') {
                        var _ref1;
                        return _ref1 = {}, _ref1[name] = validateOnArg || validateOnProp, _ref1;
                    }
                    return $19634264a80b511e$var$_extends({}, prevValues, (_extends2 = {}, _extends2[name] = validateOnArg || validateOnProp, _extends2));
                });
            }, [
                validateOnArg,
                name
            ]);
            // Create validation rules for field
            (0, $19634264a80b511e$var$_react.useEffect)(function() {
                var index = requiredFields.current.indexOf(name);
                if (required) {
                    if (index === -1) requiredFields.current.push(name);
                } else if (index !== -1) requiredFields.current.splice(index, 1);
                if (validateArg || required) {
                    if (!validationRulesRef.current[name]) validationRulesRef.current[name] = {};
                    validationRulesRef.current[name].field = $19634264a80b511e$var$validateName(validateArg, required);
                    // priority is given to validateOn prop on formField, if it is
                    // undefined, then we will use the validate prop value of Form.
                    // The reason we don't want to add validateOn = "submit" here is
                    // because we don't want to trigger validation of "submit" field
                    // when the user is typing in the instant (blur, change)
                    // validation fields.
                    if (validateOnArg && validateOnArg !== 'submit') validationRulesRef.current[name].validateOn = validateOnArg;
                    else if (!validateOnArg && validateOnProp !== 'submit') validationRulesRef.current[name].validateOn = validateOnProp;
                    return function() {
                        delete validationRulesRef.current[name].field;
                        delete validationRulesRef.current[name].validateOn;
                        var requiredFieldIndex = requiredFields.current.indexOf(name);
                        if (requiredFieldIndex !== -1) requiredFields.current.splice(requiredFieldIndex, 1);
                    };
                }
                return undefined;
            }, [
                error,
                name,
                required,
                validateArg,
                disabled,
                validateOnArg
            ]);
            return {
                error: error,
                info: info,
                inForm: true,
                onBlur: validateOnArg === 'blur' || validateOn[name] === 'blur' ? function() {
                    return setPendingValidation(pendingValidation ? [].concat(pendingValidation, [
                        name
                    ]) : [
                        name
                    ]);
                } : undefined,
                onChange: validateOnArg === 'change' || validateOn[name] === 'change' ? function() {
                    return setPendingValidation(pendingValidation ? [].concat(pendingValidation, [
                        name
                    ]) : [
                        name
                    ]);
                } : undefined
            };
        };
        return {
            useFormField: useFormField,
            useFormInput: useFormInput,
            kind: kind
        };
    }, [
        onChange,
        kind,
        pendingValidation,
        touched,
        validateOn,
        validationResults.errors,
        validationResults.infos,
        value,
        valueProp,
        validateOnProp
    ]);
    return /*#__PURE__*/ $19634264a80b511e$var$_react["default"].createElement("form", $19634264a80b511e$var$_extends({
        ref: formRef
    }, rest, {
        onReset: function onReset(event) {
            sendAnalytics({
                type: 'formReset',
                element: formRef.current,
                data: event,
                errors: analyticsRef.current.errors,
                elapsed: new Date().getTime() - analyticsRef.current.start.getTime()
            });
            setPendingValidation(undefined);
            if (!valueProp) {
                setValueState($19634264a80b511e$var$defaultValue);
                if (onChange) onChange($19634264a80b511e$var$defaultValue, {
                    touched: $19634264a80b511e$var$defaultTouched
                });
            }
            setTouched($19634264a80b511e$var$defaultTouched);
            setValidationResults($19634264a80b511e$var$defaultValidationResults);
            analyticsRef.current = {
                start: new Date(),
                errors: {}
            };
            if (_onReset) {
                event.persist(); // extract from React's synthetic event pool
                var adjustedEvent = event;
                adjustedEvent.value = $19634264a80b511e$var$defaultValue;
                _onReset(adjustedEvent);
            }
        },
        onSubmit: function onSubmit(event) {
            // Don't submit the form via browser form action. We don't want it
            // if the validation fails. And, we assume a javascript action handler
            // otherwise.
            event.preventDefault();
            // Prevent any "outer" forms from performing `onSubmit`.
            // Nesting forms is not recommended in HTML. However, with React
            // portals, if the portal (such as Grommet's Layer) contains a form
            // and is nested within another form in the React tree, the event
            // bubbles up to the "outer" form even though in the DOM the portal
            // doesn't render as child of the "outer" form.
            // https://legacy.reactjs.org/docs/portals.html#event-bubbling-through-portals
            if (formRef.current && (event.target === formRef.current || event.target.form === formRef.current)) {
                setPendingValidation(undefined);
                // adding validateOn: "submit" prop to the undefined validateOn
                // fields as we want to trigger "submit" validation once form
                // is submitted
                var newValidationRulesRef = Object.keys(validationRulesRef.current).reduce(function(acc, key) {
                    acc[key] = validationRulesRef.current[key];
                    if (!acc[key].validateOn) acc[key] = $19634264a80b511e$var$_extends({}, validationRulesRef.current[key], {
                        validateOn: 'submit'
                    });
                    return acc;
                }, {});
                var _validateForm2 = $19634264a80b511e$var$validateForm(Object.entries(newValidationRulesRef), value, format, messages, true), nextErrors = _validateForm2[0], nextInfos = _validateForm2[1];
                setValidationResults(function() {
                    var nextValidationResults = {
                        errors: nextErrors,
                        infos: nextInfos,
                        // Show form's validity when clicking on Submit
                        valid: buildValid(nextErrors)
                    };
                    if (onValidate) onValidate(nextValidationResults);
                    validationResultsRef.current = nextValidationResults;
                    updateAnalytics();
                    return nextValidationResults;
                });
                if (Object.keys(nextErrors).length === 0 && _onSubmit) {
                    event.persist(); // extract from React's synthetic event pool
                    var adjustedEvent = event;
                    adjustedEvent.value = value;
                    adjustedEvent.touched = touched;
                    _onSubmit(adjustedEvent);
                    sendAnalytics({
                        type: 'formSubmit',
                        element: formRef.current,
                        data: adjustedEvent,
                        errors: analyticsRef.current.errors,
                        elapsed: new Date().getTime() - analyticsRef.current.start.getTime()
                    });
                    analyticsRef.current.errors = {};
                    analyticsRef.current.submitted = true;
                }
            }
        }
    }), /*#__PURE__*/ $19634264a80b511e$var$_react["default"].createElement($5c9c2e034f522b3e$export$c24727297075ec6a.Provider, {
        value: formContextValue
    }, children));
});
$19634264a80b511e$var$Form.displayName = 'Form';
$19634264a80b511e$var$Form.propTypes = $e620ec03f3cd38f5$export$87387e52a99daa8;


$b39d3fd88e3f6fd8$export$a7fed597f4b8afd8 = $19634264a80b511e$export$a7fed597f4b8afd8;

$b39d3fd88e3f6fd8$export$c24727297075ec6a = $5c9c2e034f522b3e$export$c24727297075ec6a;



var $b1a512ff039be377$export$1e511d4a378977f5;
var $b1a512ff039be377$export$e2b284ce8e93d8eb;
"use strict";
$b1a512ff039be377$export$1e511d4a378977f5 = true;
$b1a512ff039be377$export$e2b284ce8e93d8eb = void 0;

var $b1a512ff039be377$var$_react = $b1a512ff039be377$var$_interopRequireDefault((parcelRequire("2xPiy")));
function $b1a512ff039be377$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $b1a512ff039be377$var$DataFormContext = $b1a512ff039be377$export$e2b284ce8e93d8eb = /*#__PURE__*/ $b1a512ff039be377$var$_react["default"].createContext({});



var $9877d3477bf8576a$export$1e511d4a378977f5;
var $9877d3477bf8576a$export$21805fee57372823;
var $9877d3477bf8576a$export$2e2bcd8739ae039;
"use strict";
$9877d3477bf8576a$export$1e511d4a378977f5 = true;
$9877d3477bf8576a$export$21805fee57372823 = $9877d3477bf8576a$export$2e2bcd8739ae039 = void 0;

var $2xPiy = parcelRequire("2xPiy");

var $9877d3477bf8576a$var$useDebounce = $9877d3477bf8576a$export$21805fee57372823 = function useDebounce(debounceDelay) {
    var _useState = (0, $2xPiy.useState)(), func = _useState[0], setFunc = _useState[1];
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var delay = debounceDelay || theme.global.debounceDelay;
    (0, $2xPiy.useEffect)(function() {
        var timer;
        if (func) timer = setTimeout(function() {
            return func();
        }, delay);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        func,
        delay
    ]);
    return setFunc;
};
var $9877d3477bf8576a$var$_default = $9877d3477bf8576a$export$2e2bcd8739ae039 = $9877d3477bf8576a$var$useDebounce;



var $46eb34c25d0c5f74$var$_excluded = [
    "children",
    "footer",
    "onDone",
    "pad",
    "updateOn"
];
function $46eb34c25d0c5f74$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $46eb34c25d0c5f74$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($46eb34c25d0c5f74$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $46eb34c25d0c5f74$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $46eb34c25d0c5f74$var$_extends() {
    return $46eb34c25d0c5f74$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $46eb34c25d0c5f74$var$_extends.apply(null, arguments);
}
var $46eb34c25d0c5f74$var$MaxForm = (0, $46eb34c25d0c5f74$var$_styledComponents["default"])($b39d3fd88e3f6fd8$export$a7fed597f4b8afd8).withConfig({
    displayName: "DataForm__MaxForm",
    componentId: "sc-v64e1r-0"
})([
    "max-width:100%;",
    ""
], function(props) {
    return props.fill && 'max-height: 100%;';
});
// We convert the view structure to something more flat to work better
// with the Form inputs. These keys are how we flatten the Form value object
// from the view object.
var $46eb34c25d0c5f74$var$formSearchKey = $46eb34c25d0c5f74$export$af663afbf59caa0b = '_search';
var $46eb34c25d0c5f74$var$formSortKey = $46eb34c25d0c5f74$export$5d400b63d4a1c541 = '_sort';
var $46eb34c25d0c5f74$var$formRangeKey = $46eb34c25d0c5f74$export$58cb1cd3f7c80c90 = '_range';
var $46eb34c25d0c5f74$var$formStepKey = $46eb34c25d0c5f74$export$b5956a4982c715c9 = '_step';
var $46eb34c25d0c5f74$var$formPageKey = $46eb34c25d0c5f74$export$b4687acc98530286 = '_page';
var $46eb34c25d0c5f74$var$formColumnsKey = $46eb34c25d0c5f74$export$6c37302973078e01 = '_columns';
var $46eb34c25d0c5f74$var$formGroupByKey = $46eb34c25d0c5f74$export$258e64b73a7a9f67 = '_groupBy';
var $46eb34c25d0c5f74$var$formViewNameKey = $46eb34c25d0c5f74$export$a8a98df84922a01b = '_view';
var $46eb34c25d0c5f74$var$viewFormKeyMap = {
    search: $46eb34c25d0c5f74$var$formSearchKey,
    sort: $46eb34c25d0c5f74$var$formSortKey,
    step: $46eb34c25d0c5f74$var$formStepKey,
    page: $46eb34c25d0c5f74$var$formPageKey,
    columns: $46eb34c25d0c5f74$var$formColumnsKey,
    groupBy: $46eb34c25d0c5f74$var$formGroupByKey,
    view: $46eb34c25d0c5f74$var$formViewNameKey
};
// flatten nested objects.
// For example: { a: { b: v, c: z } } -> { 'a.b': v, 'a.c': z }
var $46eb34c25d0c5f74$var$_flatten = function flatten(formValue, options) {
    var result = JSON.parse(JSON.stringify(formValue));
    Object.keys(result).forEach(function(i) {
        // We check the type of the i using
        // typeof() function and recursively
        // call the function again
        // ignore _range situations
        if (typeof result[i] === 'object' && !Array.isArray(result[i]) && (options != null && options.full || !result[i][$46eb34c25d0c5f74$var$formRangeKey])) {
            var temp = $46eb34c25d0c5f74$var$_flatten(result[i], options);
            Object.keys(temp).forEach(function(j) {
                // Store temp in result
                // ignore empty arrays
                if (!Array.isArray(temp[j]) || Array.isArray(temp[j]) && temp[j].length) result[i + "." + j] = temp[j];
            });
            delete result[i];
        }
    });
    return result;
};
// unflatten nested objects. For example: { 'a.b': v } -> { a: { b: v } }
var $46eb34c25d0c5f74$var$unflatten = function unflatten(formValue) {
    var result = JSON.parse(JSON.stringify(formValue));
    var specialKeys = Object.values($46eb34c25d0c5f74$var$viewFormKeyMap);
    Object.keys(result).filter(function(k) {
        return !specialKeys.includes(k);
    }).forEach(function(k) {
        var parts = k.split('.');
        var val = result[k];
        delete result[k];
        var parent = result;
        while(parts.length > 1){
            var sub = parts.shift();
            if (!parent[sub]) parent[sub] = {};
            parent = parent[sub];
        }
        parent[parts.shift()] = val;
    });
    return result;
};
// converts from the external view format to the internal Form value format
var $46eb34c25d0c5f74$var$viewToFormValue = function viewToFormValue(view) {
    var result = $46eb34c25d0c5f74$var$_extends({}, (view == null ? void 0 : view.properties) || {});
    // convert { min: , max: } range to [min, max] for RangeSelector
    Object.keys(result).forEach(function(key) {
        var _result$key, _result$key2;
        if (typeof ((_result$key = result[key]) == null ? void 0 : _result$key.min) === 'number' || typeof ((_result$key2 = result[key]) == null ? void 0 : _result$key2.max) === 'number') {
            var _result$key3;
            result[key] = (_result$key3 = {}, _result$key3[$46eb34c25d0c5f74$var$formRangeKey] = [
                result[key].min,
                result[key].max
            ], _result$key3);
        }
    });
    // convert formal view keys to their form '_' prefixed counterparts
    Object.keys($46eb34c25d0c5f74$var$viewFormKeyMap).forEach(function(key) {
        if (view != null && view[key]) result[$46eb34c25d0c5f74$var$viewFormKeyMap[key]] = view[key];
    });
    // always have some blank search text
    if (!result[$46eb34c25d0c5f74$var$formSearchKey]) result[$46eb34c25d0c5f74$var$formSearchKey] = '';
    if (view != null && view.sort) result[$46eb34c25d0c5f74$var$formSortKey] = view.sort;
    if (view != null && view.name) result[$46eb34c25d0c5f74$var$formViewNameKey] = view.name;
    if (view != null && view.columns) result[$46eb34c25d0c5f74$var$formColumnsKey] = view.columns;
    if (view != null && view.groupBy) result[$46eb34c25d0c5f74$var$formGroupByKey] = view.groupBy;
    return $46eb34c25d0c5f74$var$unflatten(result);
};
// converts from the internal Form value format to the external view format
var $46eb34c25d0c5f74$var$formValueToView = function formValueToView(value, views) {
    var result = {};
    // if the user chose a view, use that
    if (value[$46eb34c25d0c5f74$var$formViewNameKey]) result = JSON.parse(JSON.stringify(views.find(function(v) {
        return v.name === value[$46eb34c25d0c5f74$var$formViewNameKey];
    })));
    var valueCopy = $46eb34c25d0c5f74$var$_extends({}, value);
    Object.keys($46eb34c25d0c5f74$var$viewFormKeyMap).forEach(function(key) {
        if (valueCopy[$46eb34c25d0c5f74$var$viewFormKeyMap[key]]) result[key] = valueCopy[$46eb34c25d0c5f74$var$viewFormKeyMap[key]];
        delete valueCopy[$46eb34c25d0c5f74$var$viewFormKeyMap[key]];
    });
    // flatten any nested objects
    var flatValue = $46eb34c25d0c5f74$var$_flatten(valueCopy);
    result.properties = $46eb34c25d0c5f74$var$_extends({}, result.properties || {}, flatValue);
    // convert any ranges
    Object.keys(result.properties).forEach(function(key) {
        if (result.properties[key][$46eb34c25d0c5f74$var$formRangeKey]) result.properties[key] = {
            min: result.properties[key][$46eb34c25d0c5f74$var$formRangeKey][0],
            max: result.properties[key][$46eb34c25d0c5f74$var$formRangeKey][1]
        };
    });
    return result;
};
// remove any empty arrays of property values by deleting the key for
// that property in the view properties
var $46eb34c25d0c5f74$var$clearEmpty = function clearEmpty(formValue, pendingReset) {
    var value = formValue;
    Object.keys(value).forEach(function(k) {
        if (Array.isArray(value[k]) && value[k].length === 0) delete value[k];
        // special case for when range selector returns to its min/max
        // flat format with full: true needed to match filter name structure
        // { a: b: { _range: [0, 100] } } ==> a.b._range: [0, 100]
        if (typeof value[k] === 'object' && !Array.isArray(value[k])) {
            var _pendingReset$current;
            var filterName = k + "." + Object.keys($46eb34c25d0c5f74$var$_flatten(value[k], {
                full: true
            }))[0];
            if (pendingReset != null && (_pendingReset$current = pendingReset.current) != null && _pendingReset$current.has(filterName)) {
                delete value[k];
                pendingReset.current["delete"](filterName);
            }
        }
    });
    return value;
};
// if paging, when anything other than the page changes, reset the page to 1
var $46eb34c25d0c5f74$var$resetPage = function resetPage(nextFormValue, prevFormValue) {
    if (prevFormValue[$46eb34c25d0c5f74$var$formPageKey] && prevFormValue[$46eb34c25d0c5f74$var$formPageKey] > 1) // eslint-disable-next-line no-param-reassign
    nextFormValue[$46eb34c25d0c5f74$var$formPageKey] = 1;
};
// function shared by onSubmit and onChange to coordinate view
// name changes
var $46eb34c25d0c5f74$var$normalizeValue = function normalizeValue(nextValue, prevValue, views, pendingReset) {
    if (nextValue[$46eb34c25d0c5f74$var$formViewNameKey] && nextValue[$46eb34c25d0c5f74$var$formViewNameKey] !== prevValue[$46eb34c25d0c5f74$var$formViewNameKey]) // view name changed, reset view contents from named view
    return $46eb34c25d0c5f74$var$viewToFormValue(views.find(function(v) {
        return v.name === nextValue[$46eb34c25d0c5f74$var$formViewNameKey];
    }));
    // something else changed
    // clear empty properties
    var result = $46eb34c25d0c5f74$var$clearEmpty(nextValue, pendingReset);
    // if we have a view and something changed, clear the view
    if (result[$46eb34c25d0c5f74$var$formViewNameKey]) {
        var view = views.find(function(v) {
            return v.name === result[$46eb34c25d0c5f74$var$formViewNameKey];
        });
        var viewValue = $46eb34c25d0c5f74$var$viewToFormValue(view);
        $46eb34c25d0c5f74$var$clearEmpty(viewValue, pendingReset);
        if (Object.keys(viewValue).length !== Object.keys(result).length) delete result[$46eb34c25d0c5f74$var$formViewNameKey];
        else if (Object.keys(viewValue).some(function(k) {
            return(// allow mismatch between empty and set strings
            viewValue[k] && result[k] && JSON.stringify(result[k]) !== JSON.stringify(viewValue[k]));
        })) delete result[$46eb34c25d0c5f74$var$formViewNameKey];
    }
    return result;
};
// 300ms was chosen empirically as a reasonable default
var $46eb34c25d0c5f74$var$DEBOUNCE_TIMEOUT = 300;
var $46eb34c25d0c5f74$var$DataForm = $46eb34c25d0c5f74$export$dcf38ffba6c01577 = function DataForm(_ref) {
    var children = _ref.children, footer = _ref.footer, onDone = _ref.onDone, pad = _ref.pad, _ref$updateOn = _ref.updateOn, updateOn = _ref$updateOn === void 0 ? 'submit' : _ref$updateOn, rest = $46eb34c25d0c5f74$var$_objectWithoutPropertiesLoose(_ref, $46eb34c25d0c5f74$var$_excluded);
    var _useContext = (0, $46eb34c25d0c5f74$var$_react.useContext)($932597a497e37de0$export$58d75f9829cbe158), messages = _useContext.messages, onView = _useContext.onView, view = _useContext.view, views = _useContext.views;
    var _useContext2 = (0, $46eb34c25d0c5f74$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext2.format;
    var _useState = (0, $46eb34c25d0c5f74$var$_react.useState)($46eb34c25d0c5f74$var$viewToFormValue(view)), formValue = _useState[0], setFormValue = _useState[1];
    // special case for range selectors which always have a value.
    // when value returns to its min/max, remove it from view
    // like other properties
    var pendingReset = (0, $46eb34c25d0c5f74$var$_react.useRef)(new Set());
    var contextValue = (0, $46eb34c25d0c5f74$var$_react.useMemo)(function() {
        return {
            inDataForm: true,
            pendingReset: pendingReset
        };
    }, []);
    var debounce = (0, $9877d3477bf8576a$export$21805fee57372823)($46eb34c25d0c5f74$var$DEBOUNCE_TIMEOUT);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var onSubmit = (0, $46eb34c25d0c5f74$var$_react.useCallback)(function(_ref2) {
        var value = _ref2.value;
        var nextValue = $46eb34c25d0c5f74$var$normalizeValue(value, formValue, views, pendingReset);
        $46eb34c25d0c5f74$var$resetPage(nextValue, formValue);
        setFormValue(nextValue);
        onView($46eb34c25d0c5f74$var$formValueToView(nextValue, views));
        if (onDone) onDone();
    }, [
        formValue,
        onDone,
        onView,
        views
    ]);
    var onChange = (0, $46eb34c25d0c5f74$var$_react.useCallback)(function(value, _ref3) {
        var touched = _ref3.touched;
        var nextValue = $46eb34c25d0c5f74$var$normalizeValue(value, formValue, views, pendingReset);
        $46eb34c25d0c5f74$var$resetPage(nextValue, formValue);
        setFormValue(nextValue);
        if (updateOn === 'change') {
            // debounce search
            if (touched[$46eb34c25d0c5f74$var$formSearchKey]) debounce(function() {
                return function() {
                    return onView($46eb34c25d0c5f74$var$formValueToView(nextValue, views));
                };
            });
            else onView($46eb34c25d0c5f74$var$formValueToView(nextValue, views));
        }
    }, [
        debounce,
        formValue,
        onView,
        updateOn,
        views
    ]);
    (0, $46eb34c25d0c5f74$var$_react.useEffect)(function() {
        return setFormValue($46eb34c25d0c5f74$var$viewToFormValue(view));
    }, [
        view
    ]);
    var content = children;
    if (footer !== false && updateOn === 'submit' || pad) {
        var _theme$dataFilters, _theme$dataFilters2;
        content = /*#__PURE__*/ $46eb34c25d0c5f74$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            fill: "vertical"
        }, /*#__PURE__*/ $46eb34c25d0c5f74$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            flex: true,
            overflow: "auto",
            pad: {
                horizontal: pad,
                top: pad
            }
        }, /*#__PURE__*/ $46eb34c25d0c5f74$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            flex: false
        }, content)), footer !== false && updateOn === 'submit' && /*#__PURE__*/ $46eb34c25d0c5f74$var$_react["default"].createElement($267fa7db763dabfc$export$a06f1c675e846f6f, {
            flex: false,
            pad: {
                horizontal: pad,
                bottom: pad
            },
            margin: (_theme$dataFilters = theme.dataFilters) == null || (_theme$dataFilters = _theme$dataFilters.footer) == null || (_theme$dataFilters = _theme$dataFilters.actions) == null ? void 0 : _theme$dataFilters.margin,
            gap: (_theme$dataFilters2 = theme.dataFilters) == null || (_theme$dataFilters2 = _theme$dataFilters2.footer) == null || (_theme$dataFilters2 = _theme$dataFilters2.actions) == null ? void 0 : _theme$dataFilters2.gap
        }, /*#__PURE__*/ $46eb34c25d0c5f74$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
            label: format({
                id: 'dataForm.submit',
                messages: messages == null ? void 0 : messages.dataForm
            }),
            type: "submit",
            primary: true
        })));
    }
    return /*#__PURE__*/ $46eb34c25d0c5f74$var$_react["default"].createElement($46eb34c25d0c5f74$var$MaxForm, $46eb34c25d0c5f74$var$_extends({}, rest, {
        value: formValue,
        onSubmit: updateOn === 'submit' ? onSubmit : undefined,
        onChange: onChange
    }), /*#__PURE__*/ $46eb34c25d0c5f74$var$_react["default"].createElement($b1a512ff039be377$export$e2b284ce8e93d8eb.Provider, {
        value: contextValue
    }, content));
};


var $af5ba9f7873798c6$exports = {};

$parcel$export($af5ba9f7873798c6$exports, "__esModule", function () { return $af5ba9f7873798c6$export$1e511d4a378977f5; }, function (v) { return $af5ba9f7873798c6$export$1e511d4a378977f5 = v; });
$parcel$export($af5ba9f7873798c6$exports, "FormField", function () { return $af5ba9f7873798c6$export$56e87bf42978147a; }, function (v) { return $af5ba9f7873798c6$export$56e87bf42978147a = v; });
var $af5ba9f7873798c6$export$1e511d4a378977f5;
var $af5ba9f7873798c6$export$56e87bf42978147a;
"use strict";
$af5ba9f7873798c6$export$1e511d4a378977f5 = true;
$af5ba9f7873798c6$export$56e87bf42978147a = void 0;
var $f89197e39af0c957$export$1e511d4a378977f5;
var $f89197e39af0c957$export$56e87bf42978147a;
"use strict";
$f89197e39af0c957$export$1e511d4a378977f5 = true;
$f89197e39af0c957$export$56e87bf42978147a = void 0;

var $f89197e39af0c957$var$_react = $f89197e39af0c957$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $f89197e39af0c957$var$_styledComponents = $f89197e39af0c957$var$_interopRequireDefault((parcelRequire("iA1nz")));








var $49bedb3ed8912461$exports = {};

$parcel$export($49bedb3ed8912461$exports, "__esModule", function () { return $49bedb3ed8912461$export$1e511d4a378977f5; }, function (v) { return $49bedb3ed8912461$export$1e511d4a378977f5 = v; });
$parcel$export($49bedb3ed8912461$exports, "RadioButtonGroup", function () { return $49bedb3ed8912461$export$c062ce1cc79ad58a; }, function (v) { return $49bedb3ed8912461$export$c062ce1cc79ad58a = v; });
var $49bedb3ed8912461$export$1e511d4a378977f5;
var $49bedb3ed8912461$export$c062ce1cc79ad58a;
"use strict";
$49bedb3ed8912461$export$1e511d4a378977f5 = true;
$49bedb3ed8912461$export$c062ce1cc79ad58a = void 0;
var $cae545b12fa54055$export$1e511d4a378977f5;
var $cae545b12fa54055$export$c062ce1cc79ad58a;
"use strict";
$cae545b12fa54055$export$1e511d4a378977f5 = true;
$cae545b12fa54055$export$c062ce1cc79ad58a = void 0;

var $cae545b12fa54055$var$_react = $cae545b12fa54055$var$_interopRequireWildcard((parcelRequire("2xPiy")));



var $2c032e59ff28f8f3$exports = {};

$parcel$export($2c032e59ff28f8f3$exports, "__esModule", function () { return $2c032e59ff28f8f3$export$1e511d4a378977f5; }, function (v) { return $2c032e59ff28f8f3$export$1e511d4a378977f5 = v; });
$parcel$export($2c032e59ff28f8f3$exports, "RadioButton", function () { return $2c032e59ff28f8f3$export$f4422ae58352e179; }, function (v) { return $2c032e59ff28f8f3$export$f4422ae58352e179 = v; });
var $2c032e59ff28f8f3$export$1e511d4a378977f5;
var $2c032e59ff28f8f3$export$f4422ae58352e179;
"use strict";
$2c032e59ff28f8f3$export$1e511d4a378977f5 = true;
$2c032e59ff28f8f3$export$f4422ae58352e179 = void 0;
var $70f9fc92a8b26002$export$1e511d4a378977f5;
var $70f9fc92a8b26002$export$f4422ae58352e179;
"use strict";
$70f9fc92a8b26002$export$1e511d4a378977f5 = true;
$70f9fc92a8b26002$export$f4422ae58352e179 = void 0;

var $70f9fc92a8b26002$var$_react = $70f9fc92a8b26002$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $cbcec3fbbddaa443$export$1e511d4a378977f5;
var $cbcec3fbbddaa443$export$9785e57ddfe69aa;
var $cbcec3fbbddaa443$export$e56967134e4288ed;
var $cbcec3fbbddaa443$export$be6e4fdf83e53746;
var $cbcec3fbbddaa443$export$8acf1677a08924d7;
var $cbcec3fbbddaa443$export$634d9fc8954dd28a;
var $cbcec3fbbddaa443$export$561b697fc173df1f;
"use strict";
$cbcec3fbbddaa443$export$1e511d4a378977f5 = true;
$cbcec3fbbddaa443$export$9785e57ddfe69aa = $cbcec3fbbddaa443$export$e56967134e4288ed = $cbcec3fbbddaa443$export$be6e4fdf83e53746 = $cbcec3fbbddaa443$export$8acf1677a08924d7 = $cbcec3fbbddaa443$export$634d9fc8954dd28a = $cbcec3fbbddaa443$export$561b697fc173df1f = void 0;

var $cbcec3fbbddaa443$var$_styledComponents = $cbcec3fbbddaa443$var$_interopRequireWildcard((parcelRequire("iA1nz")));


function $cbcec3fbbddaa443$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($cbcec3fbbddaa443$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $cbcec3fbbddaa443$var$disabledStyle = "\n  opacity: 0.5;\n  cursor: default;\n";
var $cbcec3fbbddaa443$var$StyledRadioButtonContainer = $cbcec3fbbddaa443$export$8acf1677a08924d7 = $cbcec3fbbddaa443$var$_styledComponents["default"].label.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledRadioButton__StyledRadioButtonContainer",
    componentId: "sc-g1f6ld-0"
})([
    "display:flex;flex-direction:row;align-items:center;user-select:none;width:fit-content;",
    " ",
    " &:hover input:not([disabled]) + div,&:hover input:not([disabled]) + span{border-color:",
    ";}&:hover{background-color:",
    ";}",
    " ",
    ";"
], function(props) {
    return props.disabled && $cbcec3fbbddaa443$var$disabledStyle;
}, function(props) {
    return !props.disabled && 'cursor: pointer;';
}, function(props) {
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.radioButton.hover.border.color, props.theme);
}, function(props) {
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(!props.disabled && props.theme.radioButton.hover && props.theme.radioButton.hover.background && props.theme.radioButton.hover.background.color, props.theme);
}, function(props) {
    return props.focus && !props.focusIndicator && "\n      input:not([disabled]) + div,\n      input:not([disabled]) + span {\n      border-color: " + (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.radioButton.hover.border.color, props.theme) + ";\n    }\n    background-color: " + (0, $4113023f9e0bafa0$exports.normalizeColor)(!props.disabled && props.theme.radioButton.hover && props.theme.radioButton.hover.background && props.theme.radioButton.hover.background.color, props.theme) + ";\n    ";
}, function(props) {
    return props.theme.radioButton.container.extend;
});
var $cbcec3fbbddaa443$var$StyledRadioButtonInput = $cbcec3fbbddaa443$export$e56967134e4288ed = $cbcec3fbbddaa443$var$_styledComponents["default"].input.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledRadioButton__StyledRadioButtonInput",
    componentId: "sc-g1f6ld-1"
})([
    "opacity:0;-moz-appearance:none;width:0;height:0;margin:0;",
    ";"
], function(props) {
    return !props.disabled && 'cursor: pointer;';
});
var $cbcec3fbbddaa443$var$StyledRadioButtonLabel = $cbcec3fbbddaa443$export$9785e57ddfe69aa = $cbcec3fbbddaa443$var$_styledComponents["default"].span.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledRadioButton__StyledRadioButtonLabel",
    componentId: "sc-g1f6ld-2"
})([
    "",
    ""
], function(props) {
    return props.theme.radioButton.font.weight && (0, $cbcec3fbbddaa443$var$_styledComponents.css)([
        "font-weight:",
        ";"
    ], props.theme.radioButton.font.weight);
});
var $cbcec3fbbddaa443$var$StyledRadioButtonIcon = $cbcec3fbbddaa443$export$be6e4fdf83e53746 = $cbcec3fbbddaa443$var$_styledComponents["default"].svg.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledRadioButton__StyledRadioButtonIcon",
    componentId: "sc-g1f6ld-3"
})([
    "box-sizing:border-box;width:",
    ";height:",
    ";fill:",
    ";transform:scale(1);",
    ";"
], function(props) {
    return props.theme.radioButton.icon.size || props.theme.radioButton.size;
}, function(props) {
    return props.theme.radioButton.icon.size || props.theme.radioButton.size;
}, function(props) {
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.radioButton.check.color || 'control', props.theme);
}, function(props) {
    return props.theme.radioButton.icon.extend;
});
var $cbcec3fbbddaa443$var$StyledRadioButtonBox = $cbcec3fbbddaa443$export$634d9fc8954dd28a = (0, $cbcec3fbbddaa443$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "StyledRadioButton__StyledRadioButtonBox",
    componentId: "sc-g1f6ld-4"
})([
    "background-color:",
    ";transform:scale(1);",
    ";",
    ";"
], function(props) {
    return props.backgroundColor;
}, function(props) {
    return props.focus && (0, $4113023f9e0bafa0$exports.focusStyle)();
}, function(props) {
    return props.theme.radioButton.check.extend;
});
var $cbcec3fbbddaa443$var$StyledRadioButton = $cbcec3fbbddaa443$export$561b697fc173df1f = (0, $cbcec3fbbddaa443$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "StyledRadioButton",
    componentId: "sc-g1f6ld-5"
})([
    "",
    ";"
], function(props) {
    return props.theme.radioButton && props.theme.radioButton.extend;
});


var $beba6e3615cdf6ec$export$1e511d4a378977f5;
var $beba6e3615cdf6ec$export$9044c49f71780958;
"use strict";
$beba6e3615cdf6ec$export$1e511d4a378977f5 = true;
$beba6e3615cdf6ec$export$9044c49f71780958 = void 0;

var $beba6e3615cdf6ec$var$_propTypes = $beba6e3615cdf6ec$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $beba6e3615cdf6ec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $beba6e3615cdf6ec$var$PropType = {};
$beba6e3615cdf6ec$var$PropType = {
    a11yTitle: $beba6e3615cdf6ec$var$_propTypes["default"].string,
    checked: $beba6e3615cdf6ec$var$_propTypes["default"].bool,
    children: $beba6e3615cdf6ec$var$_propTypes["default"].func,
    disabled: $beba6e3615cdf6ec$var$_propTypes["default"].bool,
    id: $beba6e3615cdf6ec$var$_propTypes["default"].string,
    label: $beba6e3615cdf6ec$var$_propTypes["default"].node,
    name: $beba6e3615cdf6ec$var$_propTypes["default"].string.isRequired,
    onChange: $beba6e3615cdf6ec$var$_propTypes["default"].func
};
var $beba6e3615cdf6ec$var$RadioButtonPropTypes = $beba6e3615cdf6ec$export$9044c49f71780958 = $beba6e3615cdf6ec$var$PropType;



var $70f9fc92a8b26002$var$_excluded = [
    "a11yTitle",
    "checked",
    "children",
    "disabled",
    "focus",
    "focusIndicator",
    "id",
    "label",
    "name",
    "onChange"
];
function $70f9fc92a8b26002$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($70f9fc92a8b26002$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $70f9fc92a8b26002$var$_extends() {
    return $70f9fc92a8b26002$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $70f9fc92a8b26002$var$_extends.apply(null, arguments);
}
function $70f9fc92a8b26002$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $70f9fc92a8b26002$var$RadioButton = $70f9fc92a8b26002$export$f4422ae58352e179 = /*#__PURE__*/ (0, $70f9fc92a8b26002$var$_react.forwardRef)(function(_ref, ref) {
    var _theme$radioButton$ba;
    var a11yTitle = _ref.a11yTitle, checked = _ref.checked, children = _ref.children, disabled = _ref.disabled, focusProp = _ref.focus, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, id = _ref.id, label = _ref.label, name = _ref.name, onChange = _ref.onChange, rest = $70f9fc92a8b26002$var$_objectWithoutPropertiesLoose(_ref, $70f9fc92a8b26002$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useState = (0, $70f9fc92a8b26002$var$_react.useState)(), hover = _useState[0], setHover = _useState[1];
    var _useState2 = (0, $70f9fc92a8b26002$var$_react.useState)(focusProp), focus = _useState2[0], setFocus = _useState2[1];
    var usingKeyboard = (0, $4113023f9e0bafa0$exports.useKeyboard)();
    var normalizedLabel = typeof label === 'string' ? /*#__PURE__*/ $70f9fc92a8b26002$var$_react["default"].createElement($cbcec3fbbddaa443$export$9785e57ddfe69aa, passThemeFlag, label) : label;
    var Icon = theme.radioButton.icons.circle;
    var borderColor = (0, $4113023f9e0bafa0$exports.normalizeColor)(theme.radioButton.border.color, theme);
    var backgroundColor = (0, $4113023f9e0bafa0$exports.normalizeColor)((_theme$radioButton$ba = theme.radioButton.background) == null ? void 0 : _theme$radioButton$ba.color, theme);
    if (checked) {
        var _theme$radioButton$ch;
        borderColor = (0, $4113023f9e0bafa0$exports.normalizeColor)(theme.radioButton.color || 'control', theme);
        if ((_theme$radioButton$ch = theme.radioButton.check) != null && (_theme$radioButton$ch = _theme$radioButton$ch.background) != null && _theme$radioButton$ch.color) backgroundColor = (0, $4113023f9e0bafa0$exports.normalizeColor)(theme.radioButton.check.background.color, theme);
    }
    return /*#__PURE__*/ $70f9fc92a8b26002$var$_react["default"].createElement($cbcec3fbbddaa443$export$8acf1677a08924d7, $70f9fc92a8b26002$var$_extends({}, (0, $4113023f9e0bafa0$exports.removeUndefined)({
        htmlFor: id,
        disabled: disabled
    }), {
        onClick: function onClick(event) {
            // prevents clicking on the label trigging the event twice
            // https://stackoverflow.com/questions/24501497/why-the-onclick-element-will-trigger-twice-for-label-element
            if (event.target.type !== 'radio') event.stopPropagation();
        },
        focus: focus,
        focusIndicator: focusIndicator,
        onFocus: function onFocus() {
            return setFocus(true);
        },
        onBlur: function onBlur() {
            return setFocus(false);
        },
        onMouseEnter: function onMouseEnter() {
            return setHover(true);
        },
        onMouseLeave: function onMouseLeave() {
            return setHover(false);
        }
    }, passThemeFlag), /*#__PURE__*/ $70f9fc92a8b26002$var$_react["default"].createElement($cbcec3fbbddaa443$export$561b697fc173df1f, $70f9fc92a8b26002$var$_extends({
        flex: false,
        margin: label ? {
            right: theme.radioButton.gap
        } : undefined
    }, passThemeFlag), /*#__PURE__*/ $70f9fc92a8b26002$var$_react["default"].createElement($cbcec3fbbddaa443$export$e56967134e4288ed, $70f9fc92a8b26002$var$_extends({
        "aria-label": a11yTitle
    }, rest, {
        ref: ref,
        type: "radio"
    }, (0, $4113023f9e0bafa0$exports.removeUndefined)({
        id: id,
        name: name,
        checked: checked,
        disabled: disabled,
        onChange: onChange
    }))), children ? children({
        checked: checked,
        focus: focus && focusIndicator,
        hover: hover
    }) : /*#__PURE__*/ $70f9fc92a8b26002$var$_react["default"].createElement($cbcec3fbbddaa443$export$634d9fc8954dd28a, $70f9fc92a8b26002$var$_extends({
        focus: focus && focusIndicator && usingKeyboard,
        align: "center",
        justify: "center",
        width: theme.radioButton.size,
        height: theme.radioButton.size,
        border: {
            size: theme.radioButton.border.width,
            color: borderColor
        },
        backgroundColor: backgroundColor,
        round: theme.radioButton.check.radius
    }, passThemeFlag), checked && (Icon ? /*#__PURE__*/ $70f9fc92a8b26002$var$_react["default"].createElement(Icon, {
        theme: theme,
        as: $cbcec3fbbddaa443$export$be6e4fdf83e53746
    }) : /*#__PURE__*/ $70f9fc92a8b26002$var$_react["default"].createElement($cbcec3fbbddaa443$export$be6e4fdf83e53746, $70f9fc92a8b26002$var$_extends({
        viewBox: "0 0 24 24",
        preserveAspectRatio: "xMidYMid meet"
    }, passThemeFlag), /*#__PURE__*/ $70f9fc92a8b26002$var$_react["default"].createElement("circle", {
        cx: 12,
        cy: 12,
        r: 6
    }))))), normalizedLabel);
});
$70f9fc92a8b26002$var$RadioButton.displayName = 'RadioButton';
$70f9fc92a8b26002$var$RadioButton.propTypes = $beba6e3615cdf6ec$export$9044c49f71780958;


$2c032e59ff28f8f3$export$f4422ae58352e179 = $70f9fc92a8b26002$export$f4422ae58352e179;


var $b762a7e5783ac39b$export$1e511d4a378977f5;
var $b762a7e5783ac39b$export$3412d151ae3be8eb;
"use strict";
$b762a7e5783ac39b$export$1e511d4a378977f5 = true;
$b762a7e5783ac39b$export$3412d151ae3be8eb = void 0;

var $b762a7e5783ac39b$var$_propTypes = $b762a7e5783ac39b$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $b762a7e5783ac39b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $b762a7e5783ac39b$var$PropType = {};
$b762a7e5783ac39b$var$PropType = {
    children: $b762a7e5783ac39b$var$_propTypes["default"].func,
    disabled: $b762a7e5783ac39b$var$_propTypes["default"].bool,
    name: $b762a7e5783ac39b$var$_propTypes["default"].string.isRequired,
    onChange: $b762a7e5783ac39b$var$_propTypes["default"].func,
    options: $b762a7e5783ac39b$var$_propTypes["default"].oneOfType([
        $b762a7e5783ac39b$var$_propTypes["default"].arrayOf($b762a7e5783ac39b$var$_propTypes["default"].string),
        $b762a7e5783ac39b$var$_propTypes["default"].arrayOf($b762a7e5783ac39b$var$_propTypes["default"].number),
        $b762a7e5783ac39b$var$_propTypes["default"].arrayOf($b762a7e5783ac39b$var$_propTypes["default"].bool),
        $b762a7e5783ac39b$var$_propTypes["default"].arrayOf($b762a7e5783ac39b$var$_propTypes["default"].shape({
            disabled: $b762a7e5783ac39b$var$_propTypes["default"].bool,
            id: $b762a7e5783ac39b$var$_propTypes["default"].string,
            label: $b762a7e5783ac39b$var$_propTypes["default"].oneOfType([
                $b762a7e5783ac39b$var$_propTypes["default"].string,
                $b762a7e5783ac39b$var$_propTypes["default"].element
            ]),
            value: $b762a7e5783ac39b$var$_propTypes["default"].oneOfType([
                $b762a7e5783ac39b$var$_propTypes["default"].string,
                $b762a7e5783ac39b$var$_propTypes["default"].number,
                $b762a7e5783ac39b$var$_propTypes["default"].bool
            ]).isRequired
        }))
    ]).isRequired,
    value: $b762a7e5783ac39b$var$_propTypes["default"].oneOfType([
        $b762a7e5783ac39b$var$_propTypes["default"].string,
        $b762a7e5783ac39b$var$_propTypes["default"].number,
        $b762a7e5783ac39b$var$_propTypes["default"].bool,
        $b762a7e5783ac39b$var$_propTypes["default"].object
    ])
};
var $b762a7e5783ac39b$var$RadioButtonGroupPropTypes = $b762a7e5783ac39b$export$3412d151ae3be8eb = $b762a7e5783ac39b$var$PropType;



var $cae545b12fa54055$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "children",
    "defaultValue",
    "disabled",
    "focusIndicator",
    "id",
    "name",
    "onChange",
    "options",
    "value",
    "gap"
], $cae545b12fa54055$var$_excluded2 = [
    "disabled",
    "id",
    "label",
    "value"
];
function $cae545b12fa54055$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($cae545b12fa54055$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $cae545b12fa54055$var$_extends() {
    return $cae545b12fa54055$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cae545b12fa54055$var$_extends.apply(null, arguments);
}
function $cae545b12fa54055$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $cae545b12fa54055$var$RadioButtonGroup = $cae545b12fa54055$export$c062ce1cc79ad58a = /*#__PURE__*/ (0, $cae545b12fa54055$var$_react.forwardRef)(function(_ref, ref) {
    var _formContext$useFormF, _theme$radioButtonGro;
    var ariaLabelProp = _ref['aria-label'], ariaLabelledByProp = _ref['aria-labelledby'], children = _ref.children, defaultValue = _ref.defaultValue, disabled = _ref.disabled, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, id = _ref.id, name = _ref.name, onChange = _ref.onChange, optionsProp = _ref.options, valueProp = _ref.value, gap = _ref.gap, rest = $cae545b12fa54055$var$_objectWithoutPropertiesLoose(_ref, $cae545b12fa54055$var$_excluded);
    var formContext = (0, $cae545b12fa54055$var$_react.useContext)($5c9c2e034f522b3e$export$c24727297075ec6a);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    // normalize options to always use an object
    var options = optionsProp.map(function(o) {
        return typeof o !== 'object' ? {
            disabled: disabled,
            id: id ? id + "-" + o : "" + o,
            // force string
            label: typeof o !== 'string' ? JSON.stringify(o) : o,
            value: o
        } : $cae545b12fa54055$var$_extends({
            disabled: disabled
        }, o);
    });
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp,
        initialValue: defaultValue != null ? defaultValue : ''
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    // track if focus is on one of the radio buttons
    var _useState = (0, $cae545b12fa54055$var$_react.useState)(), focus = _useState[0], setFocus = _useState[1];
    var optionRefs = (0, $cae545b12fa54055$var$_react.useRef)([]);
    var valueIndex = $cae545b12fa54055$var$_react["default"].useMemo(function() {
        var result;
        options.some(function(option, index) {
            if (option.value === value) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }, [
        options,
        value
    ]);
    var onNext = function onNext() {
        if (valueIndex !== undefined && valueIndex < options.length - 1) {
            var nextIndex = valueIndex + 1;
            // ensure change event occurs
            optionRefs.current[nextIndex].click();
        }
    };
    var onPrevious = function onPrevious() {
        if (valueIndex > 0) {
            var nextIndex = valueIndex - 1;
            // ensure change event occurs
            optionRefs.current[nextIndex].click();
        }
    };
    var onFocus = function onFocus() {
        // Delay just a wee bit so Chrome doesn't missing turning the button on.
        // Chrome behaves differently in that focus is given to radio buttons
        // when the user selects one, unlike Safari and Firefox.
        setTimeout(function() {
            setFocus(true);
        }, 1);
    };
    var onRadioButtonChange = function onRadioButtonChange(event, optionValue) {
        setValue(optionValue);
        if (onChange) {
            event.persist(); // extract from React synthetic event pool
            // event.target.value gives value as a string which needs to be
            // manually typecasted according to the type of original option value.
            // return the original option value attached with the event.
            var adjustedEvent = event;
            adjustedEvent.value = optionValue;
            onChange(adjustedEvent);
        }
    };
    var onBlur = function onBlur() {
        return setFocus(false);
    };
    var ariaLabelledBy;
    if (formContext != null && (_formContext$useFormF = formContext.useFormField({})) != null && _formContext$useFormF.inForm && id && !ariaLabelProp) ariaLabelledBy = "grommet-" + id + "__label";
    return /*#__PURE__*/ $cae545b12fa54055$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        target: "document",
        onUp: focus ? onPrevious : undefined,
        onDown: focus ? onNext : undefined,
        onLeft: focus ? onPrevious : undefined,
        onRight: focus ? onNext : undefined
    }, /*#__PURE__*/ $cae545b12fa54055$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $cae545b12fa54055$var$_extends({
        "aria-label": ariaLabelProp,
        "aria-labelledby": ariaLabelledByProp || ariaLabelledBy,
        id: id,
        ref: ref,
        role: "radiogroup"
    }, theme.radioButtonGroup.container, {
        gap: gap || ((_theme$radioButtonGro = theme.radioButtonGroup.container) == null ? void 0 : _theme$radioButtonGro.gap)
    }, rest), options.map(function(_ref2, index) {
        var optionDisabled = _ref2.disabled, optionId = _ref2.id, label = _ref2.label, optionValue = _ref2.value, optionRest = $cae545b12fa54055$var$_objectWithoutPropertiesLoose(_ref2, $cae545b12fa54055$var$_excluded2);
        // if focus is within the RadioButtonGroup, determine
        // which radio button should be the active one
        var focusable = optionValue === value || value === undefined && !index || // when nothing has been selected, show focus
        // on the first radiobutton
        value === '' && index === 0;
        if (optionRest.checked) console.warn("'checked' prop of an individual RadioButton shouldn't be used in a RadioButtonGroup component. Use the RadioButtonGroup 'value' prop instead.");
        return /*#__PURE__*/ $cae545b12fa54055$var$_react["default"].createElement($2c032e59ff28f8f3$export$f4422ae58352e179, $cae545b12fa54055$var$_extends({
            ref: function ref(aRef) {
                optionRefs.current[index] = aRef;
            },
            key: optionValue,
            name: name,
            label: !children ? label : undefined,
            disabled: optionDisabled,
            checked: optionValue === value,
            focus: focus && focusable,
            focusIndicator: focusIndicator,
            id: optionId,
            value: optionValue,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: function onChange(event) {
                return onRadioButtonChange(event, optionValue);
            },
            tabIndex: focusable ? '0' : '-1' // necessary for Firefox
        }, optionRest), children ? function(state) {
            return children(optionsProp[index], state);
        } : null);
    })));
});
$cae545b12fa54055$var$RadioButtonGroup.displayName = 'RadioButtonGroup';
$cae545b12fa54055$var$RadioButtonGroup.propTypes = $b762a7e5783ac39b$export$3412d151ae3be8eb;


$49bedb3ed8912461$export$c062ce1cc79ad58a = $cae545b12fa54055$export$c062ce1cc79ad58a;





var $82d0a9d7ad209f5b$export$1e511d4a378977f5;
var $82d0a9d7ad209f5b$export$4a795d94b8641430;
"use strict";
$82d0a9d7ad209f5b$export$1e511d4a378977f5 = true;
$82d0a9d7ad209f5b$export$4a795d94b8641430 = void 0;

var $82d0a9d7ad209f5b$var$_propTypes = $82d0a9d7ad209f5b$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $82d0a9d7ad209f5b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $82d0a9d7ad209f5b$var$PropType = {};
$82d0a9d7ad209f5b$var$PropType = {
    a11yTitle: $82d0a9d7ad209f5b$var$_propTypes["default"].string,
    component: $82d0a9d7ad209f5b$var$_propTypes["default"].oneOfType([
        $82d0a9d7ad209f5b$var$_propTypes["default"].func,
        $82d0a9d7ad209f5b$var$_propTypes["default"].object
    ]),
    contentProps: $82d0a9d7ad209f5b$var$_propTypes["default"].object,
    disabled: $82d0a9d7ad209f5b$var$_propTypes["default"].bool,
    error: $82d0a9d7ad209f5b$var$_propTypes["default"].oneOfType([
        $82d0a9d7ad209f5b$var$_propTypes["default"].string,
        $82d0a9d7ad209f5b$var$_propTypes["default"].node
    ]),
    help: $82d0a9d7ad209f5b$var$_propTypes["default"].oneOfType([
        $82d0a9d7ad209f5b$var$_propTypes["default"].string,
        $82d0a9d7ad209f5b$var$_propTypes["default"].node
    ]),
    htmlFor: $82d0a9d7ad209f5b$var$_propTypes["default"].string,
    info: $82d0a9d7ad209f5b$var$_propTypes["default"].oneOfType([
        $82d0a9d7ad209f5b$var$_propTypes["default"].string,
        $82d0a9d7ad209f5b$var$_propTypes["default"].node
    ]),
    label: $82d0a9d7ad209f5b$var$_propTypes["default"].oneOfType([
        $82d0a9d7ad209f5b$var$_propTypes["default"].string,
        $82d0a9d7ad209f5b$var$_propTypes["default"].node
    ]),
    name: $82d0a9d7ad209f5b$var$_propTypes["default"].string,
    margin: $5897bd367fbd90c1$export$7ece648387045365,
    pad: $82d0a9d7ad209f5b$var$_propTypes["default"].bool,
    required: $82d0a9d7ad209f5b$var$_propTypes["default"].oneOfType([
        $82d0a9d7ad209f5b$var$_propTypes["default"].bool,
        $82d0a9d7ad209f5b$var$_propTypes["default"].shape({
            indicator: $82d0a9d7ad209f5b$var$_propTypes["default"].bool
        })
    ]),
    validate: $82d0a9d7ad209f5b$var$_propTypes["default"].oneOfType([
        $82d0a9d7ad209f5b$var$_propTypes["default"].shape({
            regexp: $82d0a9d7ad209f5b$var$_propTypes["default"].instanceOf(RegExp),
            // regular expression
            message: $82d0a9d7ad209f5b$var$_propTypes["default"].oneOfType([
                $82d0a9d7ad209f5b$var$_propTypes["default"].string,
                $82d0a9d7ad209f5b$var$_propTypes["default"].node
            ]),
            status: $82d0a9d7ad209f5b$var$_propTypes["default"].oneOf([
                'error',
                'info'
            ])
        }),
        $82d0a9d7ad209f5b$var$_propTypes["default"].func,
        $82d0a9d7ad209f5b$var$_propTypes["default"].arrayOf($82d0a9d7ad209f5b$var$_propTypes["default"].oneOfType([
            $82d0a9d7ad209f5b$var$_propTypes["default"].shape({
                regexp: $82d0a9d7ad209f5b$var$_propTypes["default"].instanceOf(RegExp),
                // regular expression
                message: $82d0a9d7ad209f5b$var$_propTypes["default"].oneOfType([
                    $82d0a9d7ad209f5b$var$_propTypes["default"].string,
                    $82d0a9d7ad209f5b$var$_propTypes["default"].node
                ]),
                status: $82d0a9d7ad209f5b$var$_propTypes["default"].oneOf([
                    'error',
                    'info'
                ])
            }),
            $82d0a9d7ad209f5b$var$_propTypes["default"].func,
            $82d0a9d7ad209f5b$var$_propTypes["default"].shape({
                max: $82d0a9d7ad209f5b$var$_propTypes["default"].number,
                threshold: $82d0a9d7ad209f5b$var$_propTypes["default"].number
            })
        ]))
    ]),
    validateOn: $82d0a9d7ad209f5b$var$_propTypes["default"].oneOf([
        'blur',
        'submit',
        'change'
    ])
};
var $82d0a9d7ad209f5b$var$FormFieldPropTypes = $82d0a9d7ad209f5b$export$4a795d94b8641430 = $82d0a9d7ad209f5b$var$PropType;




var $f89197e39af0c957$var$_excluded = [
    "error",
    "info",
    "message",
    "type"
], $f89197e39af0c957$var$_excluded2 = [
    "component",
    "disabled",
    "invalid",
    "name",
    "onChange"
], $f89197e39af0c957$var$_excluded3 = [
    "children",
    "className",
    "component",
    "contentProps",
    "disabled",
    "error",
    "help",
    "htmlFor",
    "info",
    "label",
    "margin",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "pad",
    "required",
    "style",
    "validate",
    "validateOn"
];
function $f89197e39af0c957$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $f89197e39af0c957$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($f89197e39af0c957$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $f89197e39af0c957$var$_extends() {
    return $f89197e39af0c957$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f89197e39af0c957$var$_extends.apply(null, arguments);
}
function $f89197e39af0c957$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $f89197e39af0c957$var$grommetInputFocusNames = [
    'CheckBox',
    'CheckBoxGroup',
    'RadioButton',
    'RadioButtonGroup',
    'RangeInput',
    'RangeSelector',
    'StarRating',
    'ThumbsRating'
];
var $f89197e39af0c957$var$grommetInputNames = [
    'CheckBox',
    'CheckBoxGroup',
    'TextInput',
    'Select',
    'MaskedInput',
    'SelectMultiple',
    'TextArea',
    'DateInput',
    'TimeInput',
    'FileInput',
    'RadioButton',
    'RadioButtonGroup',
    'RangeInput',
    'RangeSelector',
    'StarRating',
    'ThumbsRating'
];
var $f89197e39af0c957$var$grommetInputPadNames = [
    'CheckBox',
    'CheckBoxGroup',
    'RadioButton',
    'RadioButtonGroup',
    'RangeInput',
    'RangeSelector'
];
var $f89197e39af0c957$var$isGrommetInput = function isGrommetInput(comp) {
    return comp && ($f89197e39af0c957$var$grommetInputNames.indexOf(comp.displayName) !== -1 || $f89197e39af0c957$var$grommetInputPadNames.indexOf(comp.displayName) !== -1);
};
var $f89197e39af0c957$var$getFocusStyle = function getFocusStyle(props) {
    var _props$theme$formFiel;
    if (props.focus && props.containerFocus === false && ((_props$theme$formFiel = props.theme.formField) == null || (_props$theme$formFiel = _props$theme$formFiel.focus) == null ? void 0 : _props$theme$formFiel.containerFocus) === false) return null;
    return props.focus ? (0, $9a7099e779e83517$export$efbff472cb39d8b)({
        justBorder: true
    }) : undefined;
};
var $f89197e39af0c957$var$FormFieldBox = (0, $f89197e39af0c957$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "FormField__FormFieldBox",
    componentId: "sc-m9hood-0"
})([
    "",
    " ",
    ""
], function(props) {
    return $f89197e39af0c957$var$getFocusStyle(props);
}, function(props) {
    var _props$theme$formFiel2;
    return (_props$theme$formFiel2 = props.theme.formField) == null ? void 0 : _props$theme$formFiel2.extend;
});
var $f89197e39af0c957$var$FormFieldContentBox = (0, $f89197e39af0c957$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "FormField__FormFieldContentBox",
    componentId: "sc-m9hood-1"
})([
    "",
    " ",
    ""
], function(props) {
    return $f89197e39af0c957$var$getFocusStyle(props);
}, function(props) {
    var _props$theme$formFiel3;
    return props.theme.formField && ((_props$theme$formFiel3 = props.theme.formField[props == null ? void 0 : props.componentName]) == null || (_props$theme$formFiel3 = _props$theme$formFiel3.container) == null ? void 0 : _props$theme$formFiel3.extend);
});
var $f89197e39af0c957$var$StyledContentsBox = (0, $f89197e39af0c957$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "FormField__StyledContentsBox",
    componentId: "sc-m9hood-2"
})([
    "",
    ""
], function(props) {
    var _props$theme$formFiel4;
    return props.theme.formField && ((_props$theme$formFiel4 = props.theme.formField[props == null ? void 0 : props.componentName]) == null || (_props$theme$formFiel4 = _props$theme$formFiel4.container) == null ? void 0 : _props$theme$formFiel4.extend);
});
var $f89197e39af0c957$var$StyledMessageContainer = (0, $f89197e39af0c957$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "FormField__StyledMessageContainer",
    componentId: "sc-m9hood-3"
})([
    "",
    ""
], function(props) {
    return props.messageType && props.theme.formField[props.messageType].container && props.theme.formField[props.messageType].container.extend;
});
var $f89197e39af0c957$var$RequiredText = (0, $f89197e39af0c957$var$_styledComponents["default"])($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6).withConfig({
    displayName: "FormField__RequiredText",
    componentId: "sc-m9hood-4"
})([
    "color:inherit;font-weight:inherit;line-height:inherit;"
]);
var $f89197e39af0c957$var$ScreenReaderOnly = (0, $f89197e39af0c957$var$_styledComponents["default"])($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6).withConfig({
    displayName: "FormField__ScreenReaderOnly",
    componentId: "sc-m9hood-5"
})([
    "position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0;"
]);
var $f89197e39af0c957$var$Message = function Message(_ref) {
    var error = _ref.error, info = _ref.info, message = _ref.message, type = _ref.type, rest = $f89197e39af0c957$var$_objectWithoutPropertiesLoose(_ref, $f89197e39af0c957$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    if (message) {
        var icon;
        var containerProps;
        if (type) {
            icon = theme.formField[type] && theme.formField[type].icon;
            containerProps = theme.formField[type] && theme.formField[type].container;
        }
        var messageContent;
        if (typeof message === 'string') messageContent = /*#__PURE__*/ $f89197e39af0c957$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, rest, message);
        else messageContent = /*#__PURE__*/ $f89197e39af0c957$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, rest, message);
        return icon || containerProps ? /*#__PURE__*/ $f89197e39af0c957$var$_react["default"].createElement($f89197e39af0c957$var$StyledMessageContainer, $f89197e39af0c957$var$_extends({
            direction: "row",
            messageType: type
        }, containerProps, passThemeFlag), icon && /*#__PURE__*/ $f89197e39af0c957$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            flex: false
        }, icon), messageContent) : messageContent;
    }
    return null;
};
var $f89197e39af0c957$var$Input = function Input(_ref2) {
    var component = _ref2.component, disabled = _ref2.disabled, invalid = _ref2.invalid, name = _ref2.name, _onChange = _ref2.onChange, rest = $f89197e39af0c957$var$_objectWithoutPropertiesLoose(_ref2, $f89197e39af0c957$var$_excluded2);
    var formContext = (0, $f89197e39af0c957$var$_react.useContext)($5c9c2e034f522b3e$export$c24727297075ec6a);
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: rest.value
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    var InputComponent = component || $99c7a15bc083da62$export$c86715117507e8e5;
    // Grommet input components already check for FormContext
    // and, using their `name`, end up calling the useFormInput.setValue()
    // already. For custom components, we expect they will call
    // this onChange() and we'll call setValue() here, primarily
    // for backwards compatibility.
    var extraProps = $f89197e39af0c957$var$isGrommetInput(InputComponent) ? {
        focusIndicator: false,
        onChange: _onChange,
        plain: true
    } : {
        value: value,
        onChange: function onChange(event) {
            setValue(event.value !== undefined ? event.value : event.target.value);
            if (_onChange) _onChange(event);
        }
    };
    return /*#__PURE__*/ $f89197e39af0c957$var$_react["default"].createElement(InputComponent, $f89197e39af0c957$var$_extends({
        name: name,
        disabled: disabled,
        "aria-invalid": invalid || undefined
    }, rest, extraProps));
};
var $f89197e39af0c957$var$FormField = $f89197e39af0c957$export$56e87bf42978147a = /*#__PURE__*/ (0, $f89197e39af0c957$var$_react.forwardRef)(function(_ref3, ref) {
    var _theme$formField2, _theme$global$input, _formFieldTheme$disab, _formFieldTheme$disab2;
    var children = _ref3.children, className = _ref3.className, component = _ref3.component, contentProps = _ref3.contentProps, disabled = _ref3.disabled, errorProp = _ref3.error, help = _ref3.help, htmlFor = _ref3.htmlFor, infoProp = _ref3.info, label = _ref3.label, margin = _ref3.margin, name = _ref3.name, _onBlur = _ref3.onBlur, onChange = _ref3.onChange, _onFocus = _ref3.onFocus, pad = _ref3.pad, required = _ref3.required, style = _ref3.style, validate = _ref3.validate, validateOn = _ref3.validateOn, rest = $f89197e39af0c957$var$_objectWithoutPropertiesLoose(_ref3, $f89197e39af0c957$var$_excluded3);
    var _useThemeValue2 = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue2.theme, passThemeFlag = _useThemeValue2.passThemeFlag;
    var formContext = (0, $f89197e39af0c957$var$_react.useContext)($5c9c2e034f522b3e$export$c24727297075ec6a);
    var _formContext$useFormF = formContext.useFormField({
        disabled: disabled,
        error: errorProp,
        info: infoProp,
        name: name,
        required: required,
        validate: validate,
        validateOn: validateOn
    }), error = _formContext$useFormF.error, info = _formContext$useFormF.info, inForm = _formContext$useFormF.inForm, contextOnBlur = _formContext$useFormF.onBlur, contextOnChange = _formContext$useFormF.onChange;
    var formKind = formContext.kind;
    var _useState = (0, $f89197e39af0c957$var$_react.useState)(), focus = _useState[0], setFocus = _useState[1];
    var formFieldRef = (0, $4c6ce388409ad0b3$export$61dc559f8a0b9bcf)(ref);
    var formFieldTheme = theme.formField;
    var themeBorder = formFieldTheme.border;
    var debounce = (0, $9877d3477bf8576a$export$21805fee57372823)();
    var portalContext = (0, $f89197e39af0c957$var$_react.useContext)($4113023f9e0bafa0$exports.PortalContext);
    var announce = (0, $f89197e39af0c957$var$_react.useContext)($cfbcb74d4f54e56b$export$dcc8f4bff0d51f50);
    (0, $f89197e39af0c957$var$_react.useEffect)(function() {
        if (error && validate != null && validate.max) announce(error, 'polite', 5000);
    }, [
        error,
        announce,
        validate == null ? void 0 : validate.max
    ]);
    var readOnlyField = (0, $f89197e39af0c957$var$_react.useMemo)(function() {
        var readOnly = false;
        if (children) $f89197e39af0c957$var$_react.Children.map(children, function(child) {
            var _child$props, _child$props2;
            if (((child == null || (_child$props = child.props) == null ? void 0 : _child$props.readOnly) === true || (child == null || (_child$props2 = child.props) == null ? void 0 : _child$props2.readOnlyCopy) === true) && child.type && ('TextInput'.indexOf(child.type.displayName) !== -1 || 'DateInput'.indexOf(child.type.displayName) !== -1)) readOnly = true;
        });
        return readOnly;
    }, [
        children
    ]);
    var containerFocus = (0, $f89197e39af0c957$var$_react.useMemo)(function() {
        var focusIndicatorFlag = true;
        $f89197e39af0c957$var$_react.Children.forEach(children, function(child) {
            var _theme$formField;
            if (child && child.type && $f89197e39af0c957$var$grommetInputFocusNames.includes(child.type.displayName) && ((_theme$formField = theme.formField) == null || (_theme$formField = _theme$formField.focus) == null ? void 0 : _theme$formField.containerFocus) !== true) focusIndicatorFlag = false;
        });
        return focusIndicatorFlag;
    }, [
        children,
        (_theme$formField2 = theme.formField) == null || (_theme$formField2 = _theme$formField2.focus) == null ? void 0 : _theme$formField2.containerFocus
    ]);
    // This is here for backwards compatibility. In case the child is a grommet
    // input component, set plain and focusIndicator props, if they aren't
    // already set.
    var wantContentPad = component && (component === $c15af89705eeb537$export$ea5f704b89d806f6 || component === $d26ee9a4af4863b0$export$b6a68782c21a95ce || component === $49bedb3ed8912461$export$c062ce1cc79ad58a);
    var contents = themeBorder && children && $f89197e39af0c957$var$_react.Children.map(children, function(child) {
        if (child && child.type && $f89197e39af0c957$var$grommetInputPadNames.indexOf(child.type.displayName) !== -1) wantContentPad = true;
        var isInputComponent = child && child.type && $f89197e39af0c957$var$grommetInputNames.indexOf(child.type.displayName) !== -1;
        if (isInputComponent && child.props.plain === undefined && child.props.focusIndicator === undefined) {
            var _formFieldTheme$check;
            return /*#__PURE__*/ (0, $f89197e39af0c957$var$_react.cloneElement)(child, {
                plain: true,
                focusIndicator: !containerFocus,
                pad: 'CheckBox'.indexOf(child.type.displayName) !== -1 ? formFieldTheme == null || (_formFieldTheme$check = formFieldTheme.checkBox) == null ? void 0 : _formFieldTheme$check.pad : undefined
            });
        }
        return child;
    }) || children;
    // put rest on container, unless we use internal Input
    var containerRest = rest;
    if (inForm) {
        if (!contents) containerRest = {};
        contents = contents || /*#__PURE__*/ $f89197e39af0c957$var$_react["default"].createElement($f89197e39af0c957$var$Input, $f89197e39af0c957$var$_extends({
            component: component,
            disabled: disabled,
            invalid: !!error,
            name: name,
            label: component === $c15af89705eeb537$export$ea5f704b89d806f6 ? label : undefined
        }, rest));
    }
    var themeContentProps = $f89197e39af0c957$var$_extends({}, formFieldTheme.content);
    if (!pad && !wantContentPad) themeContentProps.pad = undefined;
    if (themeBorder && themeBorder.position === 'inner') {
        if (readOnlyField) {
            var _theme$global$input$r;
            themeContentProps.background = (_theme$global$input$r = theme.global.input.readOnly) == null ? void 0 : _theme$global$input$r.background;
        } else if (error && formFieldTheme.error) themeContentProps.background = formFieldTheme.error.background;
        else if (disabled && formFieldTheme.disabled) themeContentProps.background = formFieldTheme.disabled.background;
    }
    // fileinput handle
    // use fileinput plain use formfield to drive the border
    var isFileInputComponent;
    children && $f89197e39af0c957$var$_react.Children.forEach(children, function(child) {
        if (child && child.type && 'FileInput'.indexOf(child.type.displayName) !== -1) isFileInputComponent = true;
    });
    if (component && component.displayName === 'FileInput' && !isFileInputComponent) isFileInputComponent = true;
    var childName;
    $f89197e39af0c957$var$_react.Children.forEach(children, function(child) {
        if (child && child.type) {
            var _childName;
            childName = child.type.displayName;
            // camelCase component name to match theme object key
            if (((_childName = childName) == null ? void 0 : _childName.length) > 0) childName = childName.charAt(0).toLowerCase() + childName.slice(1);
        }
    });
    if (!themeBorder) contents = /*#__PURE__*/ $f89197e39af0c957$var$_react["default"].createElement($f89197e39af0c957$var$StyledContentsBox, $f89197e39af0c957$var$_extends({
        disabledProp: disabled,
        error: error,
        componentName: childName
    }, themeContentProps, contentProps), contents);
    var borderColor;
    if (disabled && formFieldTheme.disabled.border && formFieldTheme.disabled.border.color) borderColor = formFieldTheme.disabled.border.color;
    else if (readOnlyField && (_theme$global$input = theme.global.input) != null && (_theme$global$input = _theme$global$input.readOnly) != null && (_theme$global$input = _theme$global$input.border) != null && _theme$global$input.color) {
        var _theme$global$input2;
        borderColor = (_theme$global$input2 = theme.global.input) == null || (_theme$global$input2 = _theme$global$input2.readOnly) == null || (_theme$global$input2 = _theme$global$input2.border) == null ? void 0 : _theme$global$input2.color;
    } else if (// backward compatibility check
    error && themeBorder && themeBorder.error.color || error && formFieldTheme.error && formFieldTheme.error.border) {
        if (themeBorder.error.color && formFieldTheme.error.border === undefined) borderColor = themeBorder.error.color || 'status-critical';
        else if (formFieldTheme.error.border && formFieldTheme.error.border.color) borderColor = formFieldTheme.error.border.color || 'status-critical';
    } else if (focus && formFieldTheme.focus && formFieldTheme.focus.border && formFieldTheme.focus.border.color) borderColor = formFieldTheme.focus.border.color;
    else borderColor = themeBorder && themeBorder.color || 'border';
    var labelStyle;
    if (formKind) labelStyle = $f89197e39af0c957$var$_extends({}, formFieldTheme[formKind].label);
    else labelStyle = $f89197e39af0c957$var$_extends({}, formFieldTheme.label);
    if (disabled) labelStyle.color = formFieldTheme.disabled && formFieldTheme.disabled.label ? formFieldTheme.disabled.label.color : labelStyle.color;
    var themeHelpProps = $f89197e39af0c957$var$_extends({}, formFieldTheme.help, disabled && {
        color: formFieldTheme == null || (_formFieldTheme$disab = formFieldTheme.disabled) == null || (_formFieldTheme$disab = _formFieldTheme$disab.help) == null ? void 0 : _formFieldTheme$disab.color
    });
    var themeInfoProps = $f89197e39af0c957$var$_extends({}, formFieldTheme.info, disabled && {
        color: formFieldTheme == null || (_formFieldTheme$disab2 = formFieldTheme.disabled) == null || (_formFieldTheme$disab2 = _formFieldTheme$disab2.info) == null ? void 0 : _formFieldTheme$disab2.color
    });
    var abut;
    var abutMargin;
    var outerStyle = style;
    // If fileinput is wrapped in a formfield we want to use
    // the border style from the fileInput.theme. We also do not
    // want the foocus around the formfield since the the focus
    // is on the anchor/button inside fileinput
    if (themeBorder) {
        var innerProps = themeBorder.position === 'inner' ? {
            border: $f89197e39af0c957$var$_extends({}, themeBorder, {
                size: isFileInputComponent ? theme.fileInput.border.size : undefined,
                style: isFileInputComponent ? theme.fileInput.border.style : undefined,
                side: isFileInputComponent ? theme.fileInput.border.side : themeBorder.side || 'bottom',
                color: borderColor
            }),
            round: formFieldTheme.round,
            focus: isFileInputComponent ? undefined : focus
        } : {};
        contents = /*#__PURE__*/ $f89197e39af0c957$var$_react["default"].createElement($f89197e39af0c957$var$FormFieldContentBox, $f89197e39af0c957$var$_extends({
            disabledProp: disabled,
            error: error,
            componentName: childName
        }, themeContentProps, innerProps, contentProps, {
            containerFocus: containerFocus // internal prop
        }, passThemeFlag), contents);
        var mergedMargin = margin || formFieldTheme.margin;
        abut = themeBorder.position === 'outer' && (themeBorder.side === 'all' || themeBorder.side === 'horizontal' || !themeBorder.side) && !(mergedMargin && (typeof mergedMargin === 'string' && mergedMargin !== 'none' || mergedMargin.bottom && mergedMargin.bottom !== 'none' || mergedMargin.horizontal && mergedMargin.horizontal !== 'none'));
        if (abut) {
            // marginBottom is set to overlap adjacent fields
            abutMargin = {
                bottom: '-1px'
            };
            if (margin) abutMargin = margin;
            else if (themeBorder.size) // if the user defines a margin,
            // then the default margin below will be overridden
            abutMargin = {
                bottom: "-" + (0, $d65b270127c3c07e$export$333c2219d71d27ce)(theme.global.borderSize[themeBorder.size] || themeBorder.size) + "px"
            };
            outerStyle = $f89197e39af0c957$var$_extends({
                position: focus ? 'relative' : undefined,
                zIndex: focus ? 10 : undefined
            }, style);
        }
    }
    var outerBackground;
    if (themeBorder && themeBorder.position === 'outer') {
        if (error && formFieldTheme.error && formFieldTheme.error.background) outerBackground = formFieldTheme.error.background;
        else if (focus && formFieldTheme.focus && formFieldTheme.focus.background && formFieldTheme.focus.background.color) outerBackground = formFieldTheme.focus.background.color;
        else if (disabled && formFieldTheme.disabled && formFieldTheme.disabled.background) outerBackground = formFieldTheme.disabled.background;
    }
    var outerProps = themeBorder && themeBorder.position === 'outer' ? {
        border: $f89197e39af0c957$var$_extends({}, themeBorder, {
            color: borderColor
        }),
        round: formFieldTheme.round,
        focus: focus
    } : {};
    var requiredIndicator = theme.formField.label.requiredIndicator;
    if (requiredIndicator === true) // accessibility resource: https://www.deque.com/blog/anatomy-of-accessible-forms-required-form-fields/
    // this approach allows the required indicator to be hidden visually,
    // but present for assistive tech.
    // using aria-hidden so screen does not read out "star" and
    // just reads out "required"
    requiredIndicator = /*#__PURE__*/ $f89197e39af0c957$var$_react["default"].createElement($f89197e39af0c957$var$_react["default"].Fragment, null, /*#__PURE__*/ $f89197e39af0c957$var$_react["default"].createElement($f89197e39af0c957$var$RequiredText, {
        "aria-hidden": "true"
    }, "*"), /*#__PURE__*/ $f89197e39af0c957$var$_react["default"].createElement($f89197e39af0c957$var$ScreenReaderOnly, null, "required"));
    var showRequiredIndicator = required && requiredIndicator;
    if (typeof required === 'object' && required.indicator === false) showRequiredIndicator = false;
    // Check if child is Select or SelectMultiple and modify htmlFor if needed
    var adjustedHtmlFor = htmlFor;
    if (htmlFor) {
        var isSelectComponent = false;
        // Check if children contain Select or SelectMultiple
        if (children) $f89197e39af0c957$var$_react.Children.forEach(children, function(child) {
            if (child && child.type && (child.type.displayName === 'Select' || child.type.displayName === 'SelectMultiple') && child.props.id === htmlFor) isSelectComponent = true;
        });
        // If it's a Select component and htmlFor doesn't end with __input, add it
        if (isSelectComponent && !htmlFor.endsWith('__input')) adjustedHtmlFor = htmlFor + "__input";
    }
    return /*#__PURE__*/ $f89197e39af0c957$var$_react["default"].createElement($f89197e39af0c957$var$FormFieldBox, $f89197e39af0c957$var$_extends({
        ref: formFieldRef,
        className: className,
        background: outerBackground,
        margin: abut ? abutMargin : margin || $f89197e39af0c957$var$_extends({}, formFieldTheme.margin)
    }, outerProps, {
        style: outerStyle,
        containerFocus: containerFocus // internal prop
        ,
        onFocus: function onFocus(event) {
            var _formFieldRef$current;
            var root = (_formFieldRef$current = formFieldRef.current) == null ? void 0 : _formFieldRef$current.getRootNode();
            if (root) setFocus((0, $4113023f9e0bafa0$exports.containsFocus)(formFieldRef.current) && (0, $4113023f9e0bafa0$exports.shouldKeepFocus)(root));
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            // if input has a drop and focus is within drop
            // prevent onBlur validation from running until
            // focus is no longer within the drop or input
            if (contextOnBlur && !formFieldRef.current.contains(event.relatedTarget) && !(0, $4113023f9e0bafa0$exports.withinDropPortal)(event.relatedTarget, portalContext)) contextOnBlur(event);
            if (_onBlur) _onBlur(event);
        },
        onChange: contextOnChange || onChange ? function(event) {
            event.persist();
            if (onChange) onChange(event);
            if (contextOnChange) debounce(function() {
                return function() {
                    return contextOnChange(event);
                };
            });
        } : undefined
    }, containerRest, passThemeFlag), label && component !== $c15af89705eeb537$export$ea5f704b89d806f6 || help ? /*#__PURE__*/ $f89197e39af0c957$var$_react["default"].createElement($f89197e39af0c957$var$_react["default"].Fragment, null, label && component !== $c15af89705eeb537$export$ea5f704b89d806f6 && /*#__PURE__*/ $f89197e39af0c957$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, $f89197e39af0c957$var$_extends({
        as: "label",
        id: htmlFor ? "grommet-" + adjustedHtmlFor + "__label" : undefined,
        htmlFor: adjustedHtmlFor
    }, labelStyle), label, showRequiredIndicator ? requiredIndicator : undefined), /*#__PURE__*/ $f89197e39af0c957$var$_react["default"].createElement($f89197e39af0c957$var$Message, $f89197e39af0c957$var$_extends({
        message: help
    }, themeHelpProps))) : undefined, contents, /*#__PURE__*/ $f89197e39af0c957$var$_react["default"].createElement($f89197e39af0c957$var$Message, $f89197e39af0c957$var$_extends({
        type: "error",
        message: error
    }, formFieldTheme.error)), /*#__PURE__*/ $f89197e39af0c957$var$_react["default"].createElement($f89197e39af0c957$var$Message, $f89197e39af0c957$var$_extends({
        type: "info",
        message: info
    }, themeInfoProps)));
});
$f89197e39af0c957$var$FormField.displayName = 'FormField';
$f89197e39af0c957$var$FormField.propTypes = $82d0a9d7ad209f5b$export$4a795d94b8641430;


$af5ba9f7873798c6$export$56e87bf42978147a = $f89197e39af0c957$export$56e87bf42978147a;



var $1efe7f9a2f6260b6$exports = {};

$parcel$export($1efe7f9a2f6260b6$exports, "__esModule", function () { return $1efe7f9a2f6260b6$export$1e511d4a378977f5; }, function (v) { return $1efe7f9a2f6260b6$export$1e511d4a378977f5 = v; });
$parcel$export($1efe7f9a2f6260b6$exports, "RangeSelector", function () { return $1efe7f9a2f6260b6$export$1081d70813d107d1; }, function (v) { return $1efe7f9a2f6260b6$export$1081d70813d107d1 = v; });
var $1efe7f9a2f6260b6$export$1e511d4a378977f5;
var $1efe7f9a2f6260b6$export$1081d70813d107d1;
"use strict";
$1efe7f9a2f6260b6$export$1e511d4a378977f5 = true;
$1efe7f9a2f6260b6$export$1081d70813d107d1 = void 0;
var $f0b28568f0d20c36$export$1e511d4a378977f5;
var $f0b28568f0d20c36$export$77f0bf899ca948b7;
var $f0b28568f0d20c36$export$d795fe2838a61f89;
var $f0b28568f0d20c36$export$1081d70813d107d1;
"use strict";
$f0b28568f0d20c36$export$1e511d4a378977f5 = true;
$f0b28568f0d20c36$export$77f0bf899ca948b7 = $f0b28568f0d20c36$export$d795fe2838a61f89 = $f0b28568f0d20c36$export$1081d70813d107d1 = void 0;

var $f0b28568f0d20c36$var$_react = $f0b28568f0d20c36$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $f0b28568f0d20c36$var$_styledComponents = $f0b28568f0d20c36$var$_interopRequireDefault((parcelRequire("iA1nz")));


var $416b4b91bab9ab06$export$1e511d4a378977f5;
var $416b4b91bab9ab06$export$808c583027c3e760;
"use strict";
$416b4b91bab9ab06$export$1e511d4a378977f5 = true;
$416b4b91bab9ab06$export$808c583027c3e760 = void 0;

var $416b4b91bab9ab06$var$_react = $416b4b91bab9ab06$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $416b4b91bab9ab06$var$_styledComponents = $416b4b91bab9ab06$var$_interopRequireDefault((parcelRequire("iA1nz")));





var $416b4b91bab9ab06$var$_excluded = [
    "color",
    "direction",
    "edge",
    "onDecrease",
    "onIncrease",
    "thickness",
    "max",
    "min",
    "messages",
    "value",
    "step"
];
function $416b4b91bab9ab06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $416b4b91bab9ab06$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($416b4b91bab9ab06$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $416b4b91bab9ab06$var$_extends() {
    return $416b4b91bab9ab06$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $416b4b91bab9ab06$var$_extends.apply(null, arguments);
}
function $416b4b91bab9ab06$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// Add visually hidden input styles
var $416b4b91bab9ab06$var$VisuallyHiddenInput = $416b4b91bab9ab06$var$_styledComponents["default"].input.withConfig({
    displayName: "EdgeControl__VisuallyHiddenInput",
    componentId: "sc-1xo2yt9-0"
})([
    "position:absolute;clip:rect(0 0 0 0);clip-path:inset(50%);height:1px;overflow:hidden;white-space:nowrap;width:1px;"
]);
var $416b4b91bab9ab06$var$DIRECTION_PROPS = {
    horizontal: {
        cursor: 'col-resize',
        fill: 'vertical'
    },
    vertical: {
        cursor: 'row-resize',
        fill: 'horizontal'
    }
};
var $416b4b91bab9ab06$var$StyledBox = (0, $416b4b91bab9ab06$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "EdgeControl__StyledBox",
    componentId: "sc-1xo2yt9-1"
})([
    "",
    ""
], function(props) {
    return props.focus && (0, $4113023f9e0bafa0$exports.focusStyle)();
});
var $416b4b91bab9ab06$var$EdgeControl = $416b4b91bab9ab06$export$808c583027c3e760 = /*#__PURE__*/ (0, $416b4b91bab9ab06$var$_react.forwardRef)(function(_ref, ref) {
    var _theme$rangeSelector;
    var color = _ref.color, direction = _ref.direction, edge = _ref.edge, onDecrease = _ref.onDecrease, onIncrease = _ref.onIncrease, thickness = _ref.thickness, max = _ref.max, min = _ref.min, messages = _ref.messages, value = _ref.value, step = _ref.step, rest = $416b4b91bab9ab06$var$_objectWithoutPropertiesLoose(_ref, $416b4b91bab9ab06$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useState = (0, $416b4b91bab9ab06$var$_react.useState)(false), focus = _useState[0], setFocus = _useState[1];
    var _DIRECTION_PROPS$dire = $416b4b91bab9ab06$var$DIRECTION_PROPS[direction], cursor = _DIRECTION_PROPS$dire.cursor, fill = _DIRECTION_PROPS$dire.fill;
    var _useContext = (0, $416b4b91bab9ab06$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var themeEdgeSize = (_theme$rangeSelector = theme.rangeSelector) == null || (_theme$rangeSelector = _theme$rangeSelector.edge) == null ? void 0 : _theme$rangeSelector.size;
    var size;
    if (themeEdgeSize) {
        var _theme$global$edgeSiz;
        // Try to look up the value in theme.global.edgeSize
        // If not found, assume it's a raw CSS value like '10px'.
        var themeEdge = ((_theme$global$edgeSiz = theme.global.edgeSize) == null ? void 0 : _theme$global$edgeSiz[themeEdgeSize]) || themeEdgeSize;
        var parsedSize = (0, $4113023f9e0bafa0$exports.parseMetricToNum)(themeEdge);
        var isValid = typeof parsedSize === 'number' && !Number.isNaN(parsedSize);
        // If parsedSize is a valid number, use it.
        // Otherwise, fallback to half of the theme's global spacing.
        size = isValid ? parsedSize : (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.spacing) / 2;
    } else // If no edge size was specified use default.
    size = (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.spacing) / 2;
    var keyboardProps = direction === 'vertical' ? {
        onUp: onDecrease,
        onDown: onIncrease
    } : {
        onLeft: onDecrease,
        onRight: onIncrease
    };
    var boxDirection = direction === 'vertical' ? 'row' : 'column';
    var type = theme.rangeSelector && theme.rangeSelector.edge && theme.rangeSelector.edge.type || 'disc';
    var node;
    var backgroundColor = (0, $4113023f9e0bafa0$exports.normalizeColor)(color || 'control', theme);
    if (type === 'bar') node = /*#__PURE__*/ $416b4b91bab9ab06$var$_react["default"].createElement($416b4b91bab9ab06$var$StyledBox, {
        flex: !thickness,
        justifySelf: "stretch",
        width: direction === 'vertical' ? thickness : size + "px",
        height: direction === 'vertical' ? size + "px" : thickness,
        background: backgroundColor,
        focus: focus
    });
    else if (type === 'disc') node = /*#__PURE__*/ $416b4b91bab9ab06$var$_react["default"].createElement($416b4b91bab9ab06$var$StyledBox, {
        width: size + "px",
        height: size + "px",
        round: "full",
        background: backgroundColor,
        focus: focus
    });
    else node = type;
    return /*#__PURE__*/ $416b4b91bab9ab06$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, keyboardProps, /*#__PURE__*/ $416b4b91bab9ab06$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        direction: boxDirection,
        style: {
            flex: '0 0 1px'
        },
        overflow: "visible",
        align: "center",
        justify: "center",
        alignSelf: "stretch"
    }, /*#__PURE__*/ $416b4b91bab9ab06$var$_react["default"].createElement($416b4b91bab9ab06$var$VisuallyHiddenInput, {
        type: "range",
        min: min,
        max: max,
        step: step,
        value: value,
        onFocus: function onFocus() {
            return setFocus(true);
        },
        onBlur: function onBlur() {
            return setFocus(false);
        },
        "aria-label": format({
            id: edge === 'lower' ? 'rangeSelector.lower' : 'rangeSelector.upper',
            messages: messages
        }),
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": value,
        readOnly: true
    }), /*#__PURE__*/ $416b4b91bab9ab06$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $416b4b91bab9ab06$var$_extends({
        ref: ref,
        direction: boxDirection,
        justify: "center",
        align: "center",
        basis: "full",
        fill: fill,
        style: {
            cursor: cursor,
            outline: 'none',
            minWidth: size,
            minHeight: size,
            zIndex: 1
        },
        tabIndex: -1
    }, rest), node)));
});
$416b4b91bab9ab06$var$EdgeControl.displayName = 'EdgeControl';





var $5e7e8012562e6ea7$export$1e511d4a378977f5;
var $5e7e8012562e6ea7$export$e09b9ed4d193265d;
"use strict";
$5e7e8012562e6ea7$export$1e511d4a378977f5 = true;
$5e7e8012562e6ea7$export$e09b9ed4d193265d = void 0;

var $5e7e8012562e6ea7$var$_propTypes = $5e7e8012562e6ea7$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $5e7e8012562e6ea7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $5e7e8012562e6ea7$var$PropType = {};
$5e7e8012562e6ea7$var$PropType = {
    color: $5897bd367fbd90c1$export$fc4c368d97afb623,
    defaultValues: $5e7e8012562e6ea7$var$_propTypes["default"].arrayOf($5e7e8012562e6ea7$var$_propTypes["default"].number),
    direction: $5e7e8012562e6ea7$var$_propTypes["default"].oneOf([
        'horizontal',
        'vertical'
    ]),
    invert: $5e7e8012562e6ea7$var$_propTypes["default"].bool,
    label: $5e7e8012562e6ea7$var$_propTypes["default"].oneOfType([
        $5e7e8012562e6ea7$var$_propTypes["default"].bool,
        $5e7e8012562e6ea7$var$_propTypes["default"].func
    ]),
    max: $5e7e8012562e6ea7$var$_propTypes["default"].number,
    messages: $5e7e8012562e6ea7$var$_propTypes["default"].shape({
        lower: $5e7e8012562e6ea7$var$_propTypes["default"].string,
        upper: $5e7e8012562e6ea7$var$_propTypes["default"].string
    }),
    min: $5e7e8012562e6ea7$var$_propTypes["default"].number,
    onChange: $5e7e8012562e6ea7$var$_propTypes["default"].func,
    opacity: $5e7e8012562e6ea7$var$_propTypes["default"].oneOfType([
        $5e7e8012562e6ea7$var$_propTypes["default"].oneOf([
            'weak',
            'medium',
            'strong'
        ]),
        $5e7e8012562e6ea7$var$_propTypes["default"].string,
        $5e7e8012562e6ea7$var$_propTypes["default"].bool
    ]),
    round: $5e7e8012562e6ea7$var$_propTypes["default"].oneOfType([
        $5e7e8012562e6ea7$var$_propTypes["default"].oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'full'
        ]),
        $5e7e8012562e6ea7$var$_propTypes["default"].string
    ]),
    size: $5e7e8012562e6ea7$var$_propTypes["default"].oneOfType([
        $5e7e8012562e6ea7$var$_propTypes["default"].oneOf([
            'xxsmall',
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            'full'
        ]),
        $5e7e8012562e6ea7$var$_propTypes["default"].string
    ]),
    step: $5e7e8012562e6ea7$var$_propTypes["default"].number,
    values: $5e7e8012562e6ea7$var$_propTypes["default"].arrayOf($5e7e8012562e6ea7$var$_propTypes["default"].number)
};
var $5e7e8012562e6ea7$var$RangeSelectorPropTypes = $5e7e8012562e6ea7$export$e09b9ed4d193265d = $5e7e8012562e6ea7$var$PropType;




var $f0b28568f0d20c36$var$_excluded = [
    "color",
    "defaultValues",
    "direction",
    "invert",
    "label",
    "max",
    "messages",
    "min",
    "name",
    "onChange",
    "opacity",
    "round",
    "size",
    "step",
    "values"
];
function $f0b28568f0d20c36$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $f0b28568f0d20c36$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($f0b28568f0d20c36$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $f0b28568f0d20c36$var$_extends() {
    return $f0b28568f0d20c36$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f0b28568f0d20c36$var$_extends.apply(null, arguments);
}
function $f0b28568f0d20c36$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $f0b28568f0d20c36$var$Container = (0, $f0b28568f0d20c36$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "RangeSelector__Container",
    componentId: "sc-siof5p-0"
})([
    "user-select:none;"
]);
var $f0b28568f0d20c36$var$getDecimalCount = $f0b28568f0d20c36$export$d795fe2838a61f89 = function getDecimalCount(number) {
    if (Number.isInteger(number)) return 0;
    // handle small numbers (0.00000001) which javascript
    // will turn into `e-`
    if (Math.abs(number) < 1) {
        var parts = number.toExponential().split('e-');
        var _decimalPart = parts[0].split('.')[1] || '';
        return _decimalPart.length + parseInt(parts[1], 10);
    }
    var decimalPart = number.toString().split('.')[1] || '';
    return decimalPart.length;
};
// avoid floating point issues like 0.15 + 0.3 = 0.44999999999999996
// and turn into 0.15 + 0.3 = 0.45
var $f0b28568f0d20c36$var$valueToStepPrecision = $f0b28568f0d20c36$export$77f0bf899ca948b7 = function valueToStepPrecision(value, step, min) {
    var nearestTrueStep = Math.round((value - min) / step) * step + min;
    return Number(nearestTrueStep.toFixed($f0b28568f0d20c36$var$getDecimalCount(step)));
};
// ensure values are within min/max
var $f0b28568f0d20c36$var$clamp = function clamp(value, min, max) {
    return Math.min(Math.max(min, value), max);
};
var $f0b28568f0d20c36$var$RangeSelector = $f0b28568f0d20c36$export$1081d70813d107d1 = /*#__PURE__*/ (0, $f0b28568f0d20c36$var$_react.forwardRef)(function(_ref, ref) {
    var color = _ref.color, _ref$defaultValues = _ref.defaultValues, defaultValues = _ref$defaultValues === void 0 ? [] : _ref$defaultValues, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? 'horizontal' : _ref$direction, invert = _ref.invert, label = _ref.label, _ref$max = _ref.max, max = _ref$max === void 0 ? 100 : _ref$max, messages = _ref.messages, _ref$min = _ref.min, min = _ref$min === void 0 ? 0 : _ref$min, name = _ref.name, onChange = _ref.onChange, _ref$opacity = _ref.opacity, opacity = _ref$opacity === void 0 ? 'medium' : _ref$opacity, round = _ref.round, _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, _ref$step = _ref.step, step = _ref$step === void 0 ? 1 : _ref$step, valuesProp = _ref.values, rest = $f0b28568f0d20c36$var$_objectWithoutPropertiesLoose(_ref, $f0b28568f0d20c36$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var formContext = (0, $f0b28568f0d20c36$var$_react.useContext)($5c9c2e034f522b3e$export$c24727297075ec6a);
    var _useState = (0, $f0b28568f0d20c36$var$_react.useState)(), changing = _useState[0], setChanging = _useState[1];
    var _useState2 = (0, $f0b28568f0d20c36$var$_react.useState)(), lastChange = _useState2[0], setLastChange = _useState2[1];
    var _useState3 = (0, $f0b28568f0d20c36$var$_react.useState)(), moveValue = _useState3[0], setMoveValue = _useState3[1];
    var containerRef = (0, $f0b28568f0d20c36$var$_react.useRef)();
    var maxRef = (0, $f0b28568f0d20c36$var$_react.useRef)();
    var minRef = (0, $f0b28568f0d20c36$var$_react.useRef)();
    var labelWidthRef = (0, $f0b28568f0d20c36$var$_react.useRef)(0);
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valuesProp == null ? void 0 : valuesProp.map(function(n) {
            return $f0b28568f0d20c36$var$clamp(n, min, max);
        }),
        initialValue: defaultValues
    }), values = _formContext$useFormI[0], setValues = _formContext$useFormI[1];
    // for DataFilters to know when RangeSelector is set to its min/max
    var _useContext = (0, $f0b28568f0d20c36$var$_react.useContext)($b1a512ff039be377$export$e2b284ce8e93d8eb), pendingReset = _useContext.pendingReset;
    var updatePendingReset = (0, $f0b28568f0d20c36$var$_react.useCallback)(function(nextMin, nextMax) {
        var _pendingReset$current;
        if (nextMin === min && nextMax === max) pendingReset == null || pendingReset.current.add(name);
        else if (pendingReset != null && (_pendingReset$current = pendingReset.current) != null && _pendingReset$current.has(name)) pendingReset == null || pendingReset.current["delete"](name);
    }, [
        max,
        min,
        name,
        pendingReset
    ]);
    var change = (0, $f0b28568f0d20c36$var$_react.useCallback)(function(nextValues) {
        var nextMin = nextValues[0], nextMax = nextValues[1];
        // only adjust value to step precision if it's not the min/max
        if (nextMin !== min && nextMin !== max) nextMin = $f0b28568f0d20c36$var$valueToStepPrecision(nextValues[0], step, min);
        if (nextMax !== min && nextMax !== max) nextMax = $f0b28568f0d20c36$var$valueToStepPrecision(nextValues[1], step, min);
        // ensure values are within min/max
        nextMin = $f0b28568f0d20c36$var$clamp(nextMin, min, max);
        nextMax = $f0b28568f0d20c36$var$clamp(nextMax, min, max);
        // make sure this is only called if both of the values
        // are actually distinct from the previous values
        if (nextMin !== values[0] || nextMax !== values[1]) {
            updatePendingReset(nextMin, nextMax);
            setValues([
                nextMin,
                nextMax
            ]);
            if (onChange) onChange([
                nextMin,
                nextMax
            ]);
        }
    }, [
        onChange,
        setValues,
        step,
        max,
        min,
        values,
        updatePendingReset
    ]);
    var valueForMouseCoord = (0, $f0b28568f0d20c36$var$_react.useCallback)(function(event) {
        var rect = containerRef.current.getBoundingClientRect();
        var value;
        if (direction === 'vertical') {
            // there is no x and y in unit testing
            var y = event.clientY - (rect.top || 0); // test resilience
            var scaleY = rect.height / (max - min + 1) || 1; // test resilience
            value = Math.floor(y / scaleY) + min;
        } else {
            var x = event.clientX - (rect.left || 0); // test resilience
            var scaleX = rect.width / (max - min + 1) || 1; // test resilience
            value = Math.floor(x / scaleX) + min;
        }
        // align with closest step within [min, max]
        var result = Math.ceil(value / step) * step;
        if (result < min) return min;
        if (result > max) return max;
        return result;
    }, [
        direction,
        max,
        min,
        step
    ]);
    var onMouseMove = (0, $f0b28568f0d20c36$var$_react.useCallback)(function(event) {
        var value = valueForMouseCoord(event);
        var nextValues;
        if (changing === 'lower' && value <= values[1] && value !== moveValue) nextValues = [
            value,
            values[1]
        ];
        else if (changing === 'upper' && value >= values[0] && value !== moveValue) nextValues = [
            values[0],
            value
        ];
        else if (changing === 'selection' && value !== moveValue) {
            if (value === max) nextValues = [
                max - (values[1] - values[0]),
                max
            ];
            else if (value === min) nextValues = [
                min,
                min + (values[1] - values[0])
            ];
            else {
                var delta = value - moveValue;
                if (values[0] + delta >= min && values[1] + delta <= max) nextValues = [
                    values[0] + delta,
                    values[1] + delta
                ];
            }
        }
        if (nextValues) {
            setMoveValue(value);
            change(nextValues);
        }
    }, [
        values,
        change,
        changing,
        moveValue,
        max,
        min,
        setMoveValue,
        valueForMouseCoord
    ]);
    (0, $f0b28568f0d20c36$var$_react.useEffect)(function() {
        var onMouseUp = function onMouseUp() {
            return setChanging(undefined);
        };
        if (changing) {
            window.addEventListener('mousemove', onMouseMove);
            window.addEventListener('mouseup', onMouseUp);
            return function() {
                window.removeEventListener('mousemove', onMouseMove);
                window.removeEventListener('mouseup', onMouseUp);
            };
        }
        return undefined;
    }, [
        changing,
        onMouseMove
    ]);
    var onClick = (0, $f0b28568f0d20c36$var$_react.useCallback)(function(event) {
        var value = valueForMouseCoord(event);
        if (value <= values[0] || value < values[1] && lastChange === 'lower') {
            setLastChange('lower');
            change([
                value,
                values[1]
            ]);
        } else if (value >= values[1] || value > values[0] && lastChange === 'upper') {
            setLastChange('upper');
            change([
                values[0],
                value
            ]);
        }
    }, [
        change,
        lastChange,
        valueForMouseCoord,
        values
    ]);
    var onTouchMove = (0, $f0b28568f0d20c36$var$_react.useCallback)(function(event) {
        var touchEvent = event.changedTouches[0];
        onMouseMove(touchEvent);
    }, [
        onMouseMove
    ]);
    // keep the text values size consistent
    (0, $6a5275ec792307a1$export$e5c5a5f917a5871c)(function() {
        if (maxRef.current && minRef.current) {
            maxRef.current.style.width = '';
            minRef.current.style.width = '';
            var width = Math.max(labelWidthRef.current, maxRef.current.getBoundingClientRect().width, minRef.current.getBoundingClientRect().width);
            maxRef.current.style.width = width + "px";
            minRef.current.style.width = width + "px";
            labelWidthRef.current = width;
        }
    });
    var lower = values[0], upper = values[1];
    // It needs to be true when vertical, due to how browsers manage height
    // const fill = direction === 'vertical' ? true : 'horizontal';
    var thickness = size === 'full' ? undefined : (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.edgeSize[size] || size) + "px";
    var layoutProps = {
        fill: direction,
        round: round
    };
    if (direction === 'vertical') layoutProps.width = thickness;
    else layoutProps.height = thickness;
    if (size === 'full') layoutProps.alignSelf = 'stretch';
    var content = /*#__PURE__*/ $f0b28568f0d20c36$var$_react["default"].createElement($f0b28568f0d20c36$var$Container, $f0b28568f0d20c36$var$_extends({
        ref: containerRef,
        direction: direction === 'vertical' ? 'column' : 'row',
        align: "center",
        fill: true
    }, label ? {} : rest, {
        tabIndex: "-1",
        onClick: onClick,
        onTouchMove: onTouchMove
    }), /*#__PURE__*/ $f0b28568f0d20c36$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $f0b28568f0d20c36$var$_extends({
        style: {
            flex: lower - min + " 0 0"
        },
        background: invert ? // preserve existing dark, instead of using darknes
        // of this color
        {
            color: color || theme.rangeSelector.background.invert.color,
            opacity: opacity,
            dark: theme.dark
        } : undefined
    }, layoutProps)), /*#__PURE__*/ $f0b28568f0d20c36$var$_react["default"].createElement($416b4b91bab9ab06$export$808c583027c3e760, {
        ref: ref,
        color: color,
        direction: direction,
        thickness: thickness,
        edge: "lower",
        min: min,
        max: max,
        messages: messages,
        value: lower,
        step: step,
        onMouseDown: function onMouseDown() {
            return setChanging('lower');
        },
        onTouchStart: function onTouchStart() {
            return setChanging('lower');
        },
        onDecrease: function onDecrease() {
            return change([
                lower - step,
                upper
            ]);
        },
        onIncrease: lower + step <= upper ? function() {
            return change([
                lower + step,
                upper
            ]);
        } : function() {
            return change([
                upper,
                upper
            ]);
        }
    }), /*#__PURE__*/ $f0b28568f0d20c36$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $f0b28568f0d20c36$var$_extends({
        style: {
            flex: upper - lower + 1 + " 0 0",
            cursor: direction === 'vertical' ? 'ns-resize' : 'ew-resize'
        },
        background: invert ? undefined : // preserve existing dark, instead of using darknes of
        // this color
        {
            color: color || 'control',
            opacity: opacity,
            dark: theme.dark
        }
    }, layoutProps, {
        onMouseDown: function onMouseDown(event) {
            var nextMoveValue = valueForMouseCoord(event);
            setChanging('selection');
            setMoveValue(nextMoveValue);
        }
    })), /*#__PURE__*/ $f0b28568f0d20c36$var$_react["default"].createElement($416b4b91bab9ab06$export$808c583027c3e760, {
        color: color,
        direction: direction,
        thickness: thickness,
        edge: "upper",
        min: min,
        max: max,
        value: upper,
        step: step,
        onMouseDown: function onMouseDown() {
            return setChanging('upper');
        },
        onTouchStart: function onTouchStart() {
            return setChanging('upper');
        },
        onDecrease: upper - step >= lower ? function() {
            return change([
                lower,
                upper - step
            ]);
        } : function() {
            return change([
                lower,
                lower
            ]);
        },
        onIncrease: function onIncrease() {
            return change([
                lower,
                upper + step
            ]);
        }
    }), /*#__PURE__*/ $f0b28568f0d20c36$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $f0b28568f0d20c36$var$_extends({
        style: {
            flex: max - upper + " 0 0"
        },
        background: invert ? // preserve existing dark, instead of using darknes of this
        // color
        {
            color: color || theme.rangeSelector.background.invert.color,
            opacity: opacity,
            dark: theme.dark
        } : undefined
    }, layoutProps, {
        round: round
    })));
    if (label) content = /*#__PURE__*/ $f0b28568f0d20c36$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $f0b28568f0d20c36$var$_extends({
        direction: direction === 'vertical' ? 'column' : 'row',
        align: "center",
        fill: true
    }, rest), /*#__PURE__*/ $f0b28568f0d20c36$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, {
        ref: minRef,
        textAlign: "end",
        size: "small",
        margin: theme.rangeSelector.label.margin
    }, typeof label === 'function' ? label(lower) : lower), content, /*#__PURE__*/ $f0b28568f0d20c36$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, {
        ref: maxRef,
        size: "small",
        margin: theme.rangeSelector.label.margin
    }, typeof label === 'function' ? label(upper) : upper));
    return content;
});
$f0b28568f0d20c36$var$RangeSelector.displayName = 'RangeSelector';
$f0b28568f0d20c36$var$RangeSelector.propTypes = $5e7e8012562e6ea7$export$e09b9ed4d193265d;


$1efe7f9a2f6260b6$export$1081d70813d107d1 = $f0b28568f0d20c36$export$1081d70813d107d1;


var $2b7901c119e4bd86$exports = {};

$parcel$export($2b7901c119e4bd86$exports, "__esModule", function () { return $2b7901c119e4bd86$export$1e511d4a378977f5; }, function (v) { return $2b7901c119e4bd86$export$1e511d4a378977f5 = v; });
$parcel$export($2b7901c119e4bd86$exports, "SelectMultiple", function () { return $2b7901c119e4bd86$export$12a18ac91a0d2aeb; }, function (v) { return $2b7901c119e4bd86$export$12a18ac91a0d2aeb = v; });
var $2b7901c119e4bd86$export$1e511d4a378977f5;
var $2b7901c119e4bd86$export$12a18ac91a0d2aeb;
"use strict";
$2b7901c119e4bd86$export$1e511d4a378977f5 = true;
$2b7901c119e4bd86$export$12a18ac91a0d2aeb = void 0;
var $4000afee7dbab46f$export$1e511d4a378977f5;
var $4000afee7dbab46f$export$12a18ac91a0d2aeb;
"use strict";
$4000afee7dbab46f$export$1e511d4a378977f5 = true;
$4000afee7dbab46f$export$12a18ac91a0d2aeb = void 0;

var $4000afee7dbab46f$var$_react = $4000afee7dbab46f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $4000afee7dbab46f$var$_styledComponents = $4000afee7dbab46f$var$_interopRequireDefault((parcelRequire("iA1nz")));





var $6f86de59327318fa$export$1e511d4a378977f5;
var $6f86de59327318fa$export$65ae1fa19d91e9b3;
"use strict";
$6f86de59327318fa$export$1e511d4a378977f5 = true;
$6f86de59327318fa$export$65ae1fa19d91e9b3 = void 0;

var $6f86de59327318fa$var$_react = $6f86de59327318fa$var$_interopRequireWildcard((parcelRequire("2xPiy")));






function $6f86de59327318fa$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($6f86de59327318fa$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $6f86de59327318fa$var$SelectMultipleValue = $6f86de59327318fa$export$65ae1fa19d91e9b3 = function SelectMultipleValue(_ref) {
    var _theme$selectMultiple2, _theme$selectMultiple3;
    var allOptions = _ref.allOptions, children = _ref.children, disabled = _ref.disabled, disabledKey = _ref.disabledKey, dropButtonRef = _ref.dropButtonRef, labelKey = _ref.labelKey, messages = _ref.messages, onRequestOpen = _ref.onRequestOpen, onSelectChange = _ref.onSelectChange, theme = _ref.theme, value = _ref.value, valueKey = _ref.valueKey;
    var _useState = (0, $6f86de59327318fa$var$_react.useState)(false), showA11yDiv = _useState[0], setShowA11yDiv = _useState[1];
    var _useContext = (0, $6f86de59327318fa$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var isDisabled = (0, $a1aed72b35405d54$export$c763bb7a184a0f11)(disabled, disabledKey, allOptions, valueKey || labelKey);
    var visibleValue = (0, $6f86de59327318fa$var$_react.useCallback)(function(i) {
        var optionValue = valueKey && valueKey.reduce ? (0, $a1aed72b35405d54$export$f9e47df77939ed56)(i, valueKey) : i;
        var optionSelected = (0, $a1aed72b35405d54$export$22012a5c726bef55)(value, optionValue, valueKey || labelKey);
        var indexOptions = (0, $a1aed72b35405d54$export$2921b90f3ed1b63a)(allOptions, i, valueKey || labelKey);
        var optionLabel = (0, $a1aed72b35405d54$export$dac6ace3020563ca)(indexOptions, allOptions, labelKey || valueKey);
        var optionDisabled = isDisabled(indexOptions);
        var valueIndex = (0, $a1aed72b35405d54$export$2921b90f3ed1b63a)(value, optionValue, valueKey || labelKey);
        if (valueIndex < theme.selectMultiple.maxInline) {
            var _theme$selectMultiple;
            var child;
            if (children) child = children(i, indexOptions, allOptions, {
                active: false,
                disabled: optionDisabled,
                selected: true
            });
            return /*#__PURE__*/ $6f86de59327318fa$var$_react["default"].createElement($c0f2e05c3c6f54d3$export$11a8a1ea41bf55d8, {
                role: "option",
                a11yTitle: format({
                    id: optionSelected ? 'selectMultiple.optionSelected' : 'selectMultiple.optionNotSelected',
                    messages: messages,
                    values: {
                        optionLabel: optionLabel
                    }
                }),
                "aria-setsize": value.length,
                "aria-posinset": valueIndex + 1,
                "aria-selected": optionSelected,
                "aria-disabled": optionDisabled,
                plain: true,
                hoverIndicator: !optionDisabled,
                fill: "horizontal",
                tabIndex: "0",
                onClick: function onClick(event) {
                    if (!optionDisabled) {
                        var intermediate = [].concat(value);
                        if ((0, $a1aed72b35405d54$export$22012a5c726bef55)(intermediate, optionValue, valueKey || labelKey)) {
                            onSelectChange(event, {
                                option: optionValue,
                                value: intermediate.filter(function(v) {
                                    return typeof v === 'object' ? (0, $a1aed72b35405d54$export$f9e47df77939ed56)(v, valueKey || labelKey) !== (0, $a1aed72b35405d54$export$f9e47df77939ed56)(optionValue, valueKey || labelKey) : v !== optionValue;
                                })
                            });
                            if (valueIndex !== intermediate.length - 1) setTimeout(function() {
                                var nextFocus = document.getElementById("selected-" + intermediate[valueIndex + 1]);
                                if (nextFocus) nextFocus.focus();
                                var result = intermediate[valueIndex + 1];
                                setShowA11yDiv("Unselected " + optionLabel + ". \n                        Focus moved to " + (0, $a1aed72b35405d54$export$dac6ace3020563ca)((0, $a1aed72b35405d54$export$2921b90f3ed1b63a)(allOptions, result, valueKey || labelKey), allOptions, labelKey || valueKey));
                            }, 200); // Timeout needed to allow screen reader
                            else if (intermediate.length !== 1) setTimeout(function() {
                                var nextFocus = document.getElementById("selected-" + intermediate[valueIndex - 1]);
                                if (nextFocus) nextFocus.focus();
                                var result = intermediate[valueIndex - 1];
                                setShowA11yDiv("Unselected " + optionLabel + ". Focus moved to \n                          " + (0, $a1aed72b35405d54$export$dac6ace3020563ca)((0, $a1aed72b35405d54$export$2921b90f3ed1b63a)(allOptions, result, valueKey || labelKey), allOptions, labelKey || valueKey));
                            }, 200); // Timeout needed to allow screen reader
                            else if (dropButtonRef.current) dropButtonRef.current.focus();
                        }
                    }
                },
                key: optionLabel,
                id: "selected-" + optionValue
            }, child || /*#__PURE__*/ $6f86de59327318fa$var$_react["default"].createElement($c15af89705eeb537$export$ea5f704b89d806f6, {
                disabled: optionDisabled,
                label: /*#__PURE__*/ $6f86de59327318fa$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
                    alignSelf: "center",
                    align: "start"
                }, optionLabel),
                key: optionLabel,
                pad: (_theme$selectMultiple = theme.selectMultiple) == null || (_theme$selectMultiple = _theme$selectMultiple.option) == null ? void 0 : _theme$selectMultiple.pad,
                tabIndex: "-1",
                checked: optionSelected,
                inert: $a1aed72b35405d54$export$6f8d7bb3dad10aa1,
                containerProps: {
                    // in Firefox when we have inert set, the checkbox
                    // click event gets swallowed by the checkbox.
                    // We need the click event to go the the button
                    // around the checkbox so we use pointerEvents =
                    // none. For code clarity we decided an inline
                    // style made sense here.
                    style: {
                        pointerEvents: 'none'
                    }
                }
            }));
        }
        return undefined;
    }, [
        allOptions,
        children,
        dropButtonRef,
        format,
        isDisabled,
        labelKey,
        messages,
        onSelectChange,
        theme.selectMultiple.maxInline,
        (_theme$selectMultiple2 = theme.selectMultiple) == null || (_theme$selectMultiple2 = _theme$selectMultiple2.option) == null ? void 0 : _theme$selectMultiple2.pad,
        value,
        valueKey
    ]);
    // After announcing set showA11yDiv to undefined so it won't
    // be read out again
    (0, $6f86de59327318fa$var$_react.useEffect)(function() {
        if (showA11yDiv !== undefined) setTimeout(function() {
            setShowA11yDiv(undefined);
        }, 1000);
    }, [
        showA11yDiv
    ]);
    return /*#__PURE__*/ $6f86de59327318fa$var$_react["default"].createElement($6f86de59327318fa$var$_react["default"].Fragment, null, /*#__PURE__*/ $6f86de59327318fa$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        width: "100%",
        role: "listbox",
        "aria-multiselectable": true,
        a11yTitle: format({
            id: 'selectMultiple.selectedOptions',
            messages: messages
        })
    }, value && allOptions.filter(function(i) {
        return (0, $a1aed72b35405d54$export$22012a5c726bef55)(value, valueKey && valueKey.reduce ? (0, $a1aed72b35405d54$export$f9e47df77939ed56)(i, valueKey) : i, valueKey || labelKey);
    }).map(function(i) {
        return visibleValue(i);
    }), showA11yDiv && /*#__PURE__*/ $6f86de59327318fa$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        height: "0px",
        width: "0px",
        overflow: "hidden",
        "aria-live": "assertive",
        role: "alert"
    }, showA11yDiv)), value && value.length > theme.selectMultiple.maxInline && /*#__PURE__*/ $6f86de59327318fa$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        pad: (_theme$selectMultiple3 = theme.selectMultiple) == null || (_theme$selectMultiple3 = _theme$selectMultiple3.showMore) == null ? void 0 : _theme$selectMultiple3.pad,
        alignSelf: "start"
    }, /*#__PURE__*/ $6f86de59327318fa$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
        onClick: onRequestOpen,
        size: "small",
        label: format({
            id: 'selectMultiple.showMore',
            messages: messages,
            values: {
                remaining: value.length - theme.selectMultiple.maxInline
            }
        })
    })));
};


var $41e6a9fd5de1d0b9$export$1e511d4a378977f5;
var $41e6a9fd5de1d0b9$export$2dd06c00b4faaa63;
"use strict";
$41e6a9fd5de1d0b9$export$1e511d4a378977f5 = true;
$41e6a9fd5de1d0b9$export$2dd06c00b4faaa63 = void 0;

var $41e6a9fd5de1d0b9$var$_react = $41e6a9fd5de1d0b9$var$_interopRequireWildcard((parcelRequire("2xPiy")));









var $b6388803ae6ac7a2$export$1e511d4a378977f5;
var $b6388803ae6ac7a2$export$4d281ebdf277250c;
"use strict";
$b6388803ae6ac7a2$export$1e511d4a378977f5 = true;
$b6388803ae6ac7a2$export$4d281ebdf277250c = void 0;

var $b6388803ae6ac7a2$var$_react = $b6388803ae6ac7a2$var$_interopRequireWildcard((parcelRequire("2xPiy")));






function $b6388803ae6ac7a2$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($b6388803ae6ac7a2$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $b6388803ae6ac7a2$var$SelectionSummary = $b6388803ae6ac7a2$export$4d281ebdf277250c = function SelectionSummary(_ref) {
    var _theme$selectMultiple, _theme$selectMultiple2, _theme$selectMultiple3, _theme$selectMultiple4;
    var allOptions = _ref.allOptions, clearRef = _ref.clearRef, disabled = _ref.disabled, disabledKey = _ref.disabledKey, isSelected = _ref.isSelected, labelKey = _ref.labelKey, limit = _ref.limit, messages = _ref.messages, onChange = _ref.onChange, onMore = _ref.onMore, options = _ref.options, search = _ref.search, setActiveIndex = _ref.setActiveIndex, showSelectedInline = _ref.showSelectedInline, value = _ref.value, valueKey = _ref.valueKey;
    var _useContext = (0, $b6388803ae6ac7a2$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var isDisabled = (0, $a1aed72b35405d54$export$c763bb7a184a0f11)(disabled, disabledKey, options, valueKey || labelKey);
    var selectedValuesDisabled = (0, $b6388803ae6ac7a2$var$_react.useCallback)(function() {
        var disabledSelected = 0;
        if (value) {
            for(var i = 0; i < allOptions.length; i += 1)if ((0, $a1aed72b35405d54$export$22012a5c726bef55)(value, (0, $a1aed72b35405d54$export$40be908210c5a79c)(i, options, valueKey || labelKey), valueKey || labelKey) && isDisabled(i)) disabledSelected += 1;
            if (value.length === disabledSelected) return true;
        }
        return false;
    }, [
        value,
        allOptions,
        options,
        valueKey,
        labelKey,
        isDisabled
    ]);
    var selectedInSearch = (0, $b6388803ae6ac7a2$var$_react.useCallback)(function() {
        return options == null ? void 0 : options.filter(function(option) {
            return (0, $a1aed72b35405d54$export$22012a5c726bef55)(value, option, valueKey || labelKey);
        });
    }, [
        options,
        value,
        valueKey,
        labelKey
    ]);
    var showSelectAll = !!((value == null ? void 0 : value.length) === 0 || selectedValuesDisabled() || !value || selectedInSearch().length === 0);
    var messageId = (value == null ? void 0 : value.length) === 0 || onMore || !value || search !== '' && search !== undefined ? 'selectMultiple.selected' : 'selectMultiple.selectedOfTotal';
    var summaryText = format({
        id: messageId,
        messages: messages,
        values: {
            selected: (value == null ? void 0 : value.length) || 0,
            total: options.length
        }
    });
    var summaryButtonClick = function summaryButtonClick(event) {
        if (onChange) {
            var nextSelected = options.filter(function(i, index) {
                return showSelectAll ? !isDisabled(index) || isSelected(index) : isDisabled(index) && isSelected(index);
            });
            if (search !== '' && search !== undefined && value) {
                if (showSelectAll) nextSelected = nextSelected.concat(value);
                else value.forEach(function(item) {
                    if (!(0, $a1aed72b35405d54$export$22012a5c726bef55)(options, item, valueKey || labelKey)) nextSelected.push(item);
                });
            }
            var nextValue = nextSelected.map(function(i) {
                return valueKey && valueKey.reduce ? (0, $a1aed72b35405d54$export$f9e47df77939ed56)(i, valueKey) : i;
            });
            onChange(event, {
                option: options,
                value: nextValue,
                selected: nextSelected
            });
        }
        if (limit && !showSelectAll) setActiveIndex(0);
    };
    return /*#__PURE__*/ $b6388803ae6ac7a2$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        pad: showSelectedInline ? (_theme$selectMultiple = theme.selectMultiple) == null || (_theme$selectMultiple = _theme$selectMultiple.summary) == null || (_theme$selectMultiple = _theme$selectMultiple.showSelectedInline) == null ? void 0 : _theme$selectMultiple.pad : (_theme$selectMultiple2 = theme.selectMultiple) == null || (_theme$selectMultiple2 = _theme$selectMultiple2.summary) == null ? void 0 : _theme$selectMultiple2.pad,
        direction: "row",
        justify: "between",
        gap: (_theme$selectMultiple3 = theme.selectMultiple) == null || (_theme$selectMultiple3 = _theme$selectMultiple3.summary) == null ? void 0 : _theme$selectMultiple3.gap,
        fill: "horizontal",
        flex: showSelectedInline,
        align: "center",
        height: (_theme$selectMultiple4 = theme.selectMultiple) == null || (_theme$selectMultiple4 = _theme$selectMultiple4.summary) == null ? void 0 : _theme$selectMultiple4.height
    }, /*#__PURE__*/ $b6388803ae6ac7a2$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, {
        size: "small"
    }, summaryText), (options.length && (!limit || !(!value || (value == null ? void 0 : value.length) === 0 && selectedValuesDisabled()))) > 0 && (!onMore || onMore && (value == null ? void 0 : value.length) !== 0) && /*#__PURE__*/ $b6388803ae6ac7a2$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
        a11yTitle: showSelectAll ? format({
            id: 'selectMultiple.selectAllA11y',
            messages: messages,
            values: {
                total: options.length
            }
        }) : format({
            id: 'selectMultiple.clearAllA11y',
            messages: messages,
            values: {
                selected: (value == null ? void 0 : value.length) || 0
            }
        }),
        label: format({
            id: showSelectAll ? 'selectMultiple.selectAll' : 'selectMultiple.clearAll',
            messages: messages
        }),
        onClick: function onClick(event) {
            return summaryButtonClick(event);
        },
        onFocus: function onFocus() {
            return setActiveIndex(-1);
        },
        ref: clearRef
    }));
};







function $41e6a9fd5de1d0b9$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($41e6a9fd5de1d0b9$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $41e6a9fd5de1d0b9$var$_extends() {
    return $41e6a9fd5de1d0b9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $41e6a9fd5de1d0b9$var$_extends.apply(null, arguments);
}
var $41e6a9fd5de1d0b9$var$SelectMultipleContainer = $41e6a9fd5de1d0b9$export$2dd06c00b4faaa63 = /*#__PURE__*/ (0, $41e6a9fd5de1d0b9$var$_react.forwardRef)(function(_ref, ref) {
    var _theme$select$icons, _theme$selectMultiple2;
    var allOptions = _ref.allOptions, _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children, disabledProp = _ref.disabled, disabledKey = _ref.disabledKey, dropHeight = _ref.dropHeight, _ref$emptySearchMessa = _ref.emptySearchMessage, emptySearchMessage = _ref$emptySearchMessa === void 0 ? 'No matches found' : _ref$emptySearchMessa, help = _ref.help, icon = _ref.icon, id = _ref.id, labelKey = _ref.labelKey, limit = _ref.limit, messages = _ref.messages, onChange = _ref.onChange, onClose = _ref.onClose, onKeyDown = _ref.onKeyDown, onMore = _ref.onMore, onSearch = _ref.onSearch, optionIndexesInValue = _ref.optionIndexesInValue, options = _ref.options, _ref$replace = _ref.replace, replace = _ref$replace === void 0 ? true : _ref$replace, searchPlaceholder = _ref.searchPlaceholder, search = _ref.search, setSearch = _ref.setSearch, usingKeyboard = _ref.usingKeyboard, _ref$value = _ref.value, value = _ref$value === void 0 ? [] : _ref$value, valueKey = _ref.valueKey, showSelectedInline = _ref.showSelectedInline;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    // the currently active option based on keyboard navigation
    // or mouse hover, -1 means no active option
    var _useState = (0, $41e6a9fd5de1d0b9$var$_react.useState)(-1), activeIndex = _useState[0], setActiveIndex = _useState[1];
    var _useState2 = (0, $41e6a9fd5de1d0b9$var$_react.useState)(usingKeyboard), keyboardNavigation = _useState2[0], setKeyboardNavigation = _useState2[1];
    var _useContext = (0, $41e6a9fd5de1d0b9$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var searchRef = (0, $41e6a9fd5de1d0b9$var$_react.useRef)();
    var optionsRef = (0, $41e6a9fd5de1d0b9$var$_react.useRef)();
    var _useState3 = (0, $41e6a9fd5de1d0b9$var$_react.useState)(disabledProp), disabled = _useState3[0], setDisabled = _useState3[1];
    // the node of the currently active option, as activeIndex changes
    // this is updated too and the useEffect below ensures the
    // active option remains in keyboard focus since we're
    // following roving tab index pattern
    var activeRef = (0, $41e6a9fd5de1d0b9$var$_react.useRef)();
    var _useState4 = (0, $41e6a9fd5de1d0b9$var$_react.useState)(), showA11yLimit = _useState4[0], setShowA11yLimit = _useState4[1];
    var clearRef = (0, $41e6a9fd5de1d0b9$var$_react.useRef)();
    var isDisabled = (0, $a1aed72b35405d54$export$c763bb7a184a0f11)(disabled, disabledKey, options, valueKey || labelKey);
    var searchIcon = ((_theme$select$icons = theme.select.icons) == null ? void 0 : _theme$select$icons.search) || /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement($ac084058cd06093e$export$4b85d3515bd863a5, {
        "aria-hidden": true
    });
    // for keyboard/screenreader, keep the active option in focus
    (0, $41e6a9fd5de1d0b9$var$_react.useEffect)(function() {
        var _activeRef$current;
        if (activeIndex) (_activeRef$current = activeRef.current) == null || _activeRef$current.focus();
    }, [
        activeIndex
    ]);
    // set initial focus
    (0, $41e6a9fd5de1d0b9$var$_react.useEffect)(function() {
        // need to wait for Drop to be ready
        var timer = setTimeout(function() {
            var clearButton = clearRef.current;
            if (clearButton && clearButton.focus) (0, $4113023f9e0bafa0$exports.setFocusWithoutScroll)(clearButton);
            else if (searchRef && searchRef.current) {
                var searchInput = searchRef.current;
                if (searchInput && searchInput.focus) (0, $4113023f9e0bafa0$exports.setFocusWithoutScroll)(searchInput);
            } else if (activeRef.current) (0, $4113023f9e0bafa0$exports.setFocusWithoutScroll)(activeRef.current);
            else if (optionsRef.current) setActiveIndex(0);
        }, 100); // Drop should be open after 100ms
        return function() {
            return clearTimeout(timer);
        };
    }, []);
    (0, $41e6a9fd5de1d0b9$var$_react.useEffect)(function() {
        var optionsNode = optionsRef.current;
        if (optionsNode != null && optionsNode.children) {
            var optionNode = optionsNode.children[activeIndex];
            if (optionNode) optionNode.focus();
        }
    }, [
        activeIndex
    ]);
    var isSelected = (0, $41e6a9fd5de1d0b9$var$_react.useCallback)(function(index) {
        var result;
        var optionVal = (0, $a1aed72b35405d54$export$40be908210c5a79c)(index, options, valueKey || labelKey);
        if (value) {
            if (value.length === 0) result = false;
            else if (typeof value[0] !== 'object') result = value.indexOf(optionVal) !== -1;
            else if (valueKey) result = value.some(function(valueItem) {
                var valueValue = typeof valueKey === 'function' ? valueKey(valueItem) : valueItem[valueKey];
                return valueValue === optionVal;
            });
        }
        return result;
    }, [
        value,
        valueKey,
        options,
        labelKey
    ]);
    var selectOption = (0, $41e6a9fd5de1d0b9$var$_react.useCallback)(function(index) {
        return function(event) {
            if (onChange) {
                var nextOptionIndexesInValue = optionIndexesInValue.slice(0);
                var allOptionsIndex = (0, $a1aed72b35405d54$export$2921b90f3ed1b63a)(allOptions, options[index], valueKey || labelKey);
                var valueIndex = optionIndexesInValue.indexOf(allOptionsIndex);
                if (valueIndex === -1 && (!limit || (value == null ? void 0 : value.length) < limit)) nextOptionIndexesInValue.push(allOptionsIndex);
                else nextOptionIndexesInValue.splice(valueIndex, 1);
                var nextValue = nextOptionIndexesInValue.map(function(i) {
                    return valueKey && valueKey.reduce ? (0, $a1aed72b35405d54$export$f9e47df77939ed56)(allOptions[i], valueKey) : allOptions[i];
                });
                var nextSelected = nextOptionIndexesInValue;
                onChange(event, {
                    option: options[index],
                    value: nextValue,
                    selected: nextSelected
                });
            }
        };
    }, [
        labelKey,
        limit,
        onChange,
        optionIndexesInValue,
        options,
        allOptions,
        valueKey,
        value
    ]);
    var onNextOption = (0, $41e6a9fd5de1d0b9$var$_react.useCallback)(function(event) {
        event.preventDefault();
        var nextActiveIndex = activeIndex + 1;
        // checking activeIndex > -1 ensures arrow keys don't
        // move focus when select all/clear all button or search input
        // are focused
        if (nextActiveIndex !== (options == null ? void 0 : options.length) && activeIndex > -1) {
            setActiveIndex(nextActiveIndex);
            setKeyboardNavigation(true);
        }
    }, [
        activeIndex,
        options
    ]);
    var onPreviousOption = (0, $41e6a9fd5de1d0b9$var$_react.useCallback)(function(event) {
        event.preventDefault();
        var nextActiveIndex = activeIndex - 1;
        // checking activeIndex > -1 ensures arrow keys don't
        // move focus when select all/clear all button or search input
        // are focused
        if (activeIndex > -1) {
            setActiveIndex(Math.max(nextActiveIndex, 0));
            setKeyboardNavigation(true);
        }
    }, [
        activeIndex
    ]);
    var onKeyDownOption = (0, $41e6a9fd5de1d0b9$var$_react.useCallback)(function(event) {
        if (!onSearch) {
            var nextActiveIndex = options.findIndex(function(e) {
                var label;
                if (typeof e === 'object') label = e.label || (0, $a1aed72b35405d54$export$f9e47df77939ed56)(e, labelKey);
                else label = e;
                return typeof label === 'string' && label.charAt(0).toLowerCase() === event.key.toLowerCase();
            });
            if (nextActiveIndex >= 0) {
                event.preventDefault();
                setActiveIndex(nextActiveIndex);
                setKeyboardNavigation(true);
            }
        }
        if (onKeyDown) onKeyDown(event);
    }, [
        onKeyDown,
        options,
        onSearch,
        labelKey
    ]);
    var onActiveOption = (0, $41e6a9fd5de1d0b9$var$_react.useCallback)(function(index) {
        return function() {
            if (!keyboardNavigation) setActiveIndex(index);
        };
    }, [
        keyboardNavigation
    ]);
    var onSelectOption = (0, $41e6a9fd5de1d0b9$var$_react.useCallback)(function(event) {
        if (!isDisabled(activeIndex) && activeIndex >= 0 && activeIndex < (options == null ? void 0 : options.length)) {
            event.preventDefault(); // prevent submitting forms
            selectOption(activeIndex)(event);
        }
    }, [
        activeIndex,
        selectOption,
        options,
        isDisabled
    ]);
    var customSearchInput = theme.select.searchInput;
    var SelectTextInput = customSearchInput || $99c7a15bc083da62$export$c86715117507e8e5;
    var selectOptionsStyle = theme.select.options ? $41e6a9fd5de1d0b9$var$_extends({}, theme.select.options.box, theme.select.options.container) : {};
    // handle when limit is reached
    (0, $41e6a9fd5de1d0b9$var$_react.useEffect)(function() {
        var originallyDisabled = function originallyDisabled(index) {
            var option = allOptions[index];
            var result;
            if (disabledKey) result = (0, $a1aed72b35405d54$export$f9e47df77939ed56)(option, disabledKey);
            else if (Array.isArray(disabledProp)) {
                if (typeof disabledProp[0] === 'number') result = disabledProp.indexOf(index) !== -1;
                else result = (0, $a1aed72b35405d54$export$2921b90f3ed1b63a)(disabledProp, (0, $a1aed72b35405d54$export$40be908210c5a79c)(index, options, valueKey || labelKey), valueKey || labelKey) !== -1;
            }
            return result;
        };
        if (value && limit) {
            if (value.length === limit) {
                var newDisabled = [].concat(disabledProp);
                // disable everything that is not selected
                for(var i = 0; i < (options == null ? void 0 : options.length); i += 1)if (!isSelected(i) && !originallyDisabled(i)) newDisabled.push(options[i]);
                if (usingKeyboard) setShowA11yLimit('Selected. Maximum selection limit reached.');
                setDisabled(newDisabled);
            } else {
                if (usingKeyboard) setShowA11yLimit(undefined);
                setDisabled(disabledProp);
            }
        }
    }, [
        isSelected,
        value,
        limit,
        disabledProp,
        allOptions,
        disabledKey,
        labelKey,
        options,
        usingKeyboard,
        valueKey
    ]);
    // reset showA11yLimit after announcement is read
    (0, $41e6a9fd5de1d0b9$var$_react.useEffect)(function() {
        if (showA11yLimit !== undefined) setTimeout(function() {
            setShowA11yLimit(undefined);
        }, 2000); // value chosen based on length of a11yLimit message
    }, [
        showA11yLimit
    ]);
    var summaryContent = /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement($b6388803ae6ac7a2$export$4d281ebdf277250c, {
        allOptions: allOptions,
        clearRef: clearRef,
        disabled: disabled,
        disabledKey: disabledKey,
        isSelected: isSelected,
        labelKey: labelKey,
        limit: limit,
        messages: messages,
        onChange: onChange,
        onMore: onMore,
        options: options,
        search: search,
        setActiveIndex: setActiveIndex,
        showSelectedInline: showSelectedInline,
        value: value,
        valueKey: valueKey
    });
    var helpContent;
    if (help) {
        var _theme$selectMultiple;
        if (typeof help === 'string') helpContent = /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            flex: false,
            pad: (_theme$selectMultiple = theme.selectMultiple) == null || (_theme$selectMultiple = _theme$selectMultiple.help) == null || (_theme$selectMultiple = _theme$selectMultiple.container) == null ? void 0 : _theme$selectMultiple.pad
        }, /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, {
            size: "small"
        }, help));
        else helpContent = /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            flex: false
        }, help);
    }
    if (showSelectedInline) summaryContent = /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        direction: "row",
        justify: "between",
        flex: false
    }, summaryContent, /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, null, /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
        fill: "vertical",
        onClick: onClose,
        a11yTitle: "Close Select"
    }, icon)));
    return /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onEnter: onSelectOption,
        onSpace: onSelectOption,
        onUp: onPreviousOption,
        onDown: onNextOption,
        onKeyDown: onKeyDownOption,
        onEsc: onClose
    }, /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement($c0f2e05c3c6f54d3$export$1d41361302b577a1, {
        ref: ref,
        id: id ? id + "__select-drop" : undefined,
        dropHeight: dropHeight,
        a11yTitle: format({
            id: 'selectMultiple.selectDrop',
            messages: messages
        })
    }, summaryContent, onSearch && /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        pad: !customSearchInput ? (_theme$selectMultiple2 = theme.selectMultiple) == null || (_theme$selectMultiple2 = _theme$selectMultiple2.search) == null ? void 0 : _theme$selectMultiple2.pad : undefined,
        flex: false
    }, /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onEnter: function onEnter(event) {
            onNextOption(event);
        }
    }, /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement(SelectTextInput, {
        a11yTitle: format({
            id: 'selectMultiple.search',
            messages: messages
        }),
        focusIndicator: !customSearchInput,
        size: "small",
        ref: searchRef,
        type: "search",
        value: search || '',
        placeholder: searchPlaceholder,
        onChange: function onChange(event) {
            var nextSearch = event.target.value;
            setSearch(nextSearch);
            setActiveIndex(-1);
            onSearch(nextSearch);
        },
        onFocus: function onFocus() {
            return setActiveIndex(-1);
        },
        icon: searchIcon
    }))), helpContent, (options == null ? void 0 : options.length) > 0 ? /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement($c0f2e05c3c6f54d3$export$1a780bb4ae54ddec, {
        "aria-label": format({
            id: 'selectMultiple.optionsA11y',
            messages: messages
        }),
        role: "listbox",
        tabIndex: "-1",
        ref: optionsRef,
        "aria-multiselectable": true,
        onMouseMove: function onMouseMove() {
            return setKeyboardNavigation(false);
        },
        selectMultiple: true // internal prop
    }, /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement($41010700ddcbac64$export$c5295390d6167a3e, {
        items: options,
        step: theme.select.step,
        onMore: onMore,
        replace: replace,
        show: activeIndex !== -1 ? activeIndex : undefined
    }, function(option, index, optionRef) {
        var optionDisabled = isDisabled(index);
        var optionSelected = value ? (0, $a1aed72b35405d54$export$22012a5c726bef55)(value, valueKey && valueKey.reduce ? (0, $a1aed72b35405d54$export$f9e47df77939ed56)(option, valueKey) : option, valueKey || labelKey) : false;
        var optionActive = activeIndex === index;
        var optionLabel = (0, $a1aed72b35405d54$export$dac6ace3020563ca)(index, options, labelKey || valueKey);
        // Determine whether the label is done as a child or
        // as an option Button kind property.
        var child;
        var textComponent = false;
        if (children) {
            child = children(option, index, options, {
                active: optionActive,
                disabled: optionDisabled,
                selected: optionSelected
            });
            if (typeof child === 'string' || child.props && child.props.children && typeof child.props.children === 'string') textComponent = true;
        } else {
            var _theme$selectMultiple3;
            child = /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement($c15af89705eeb537$export$ea5f704b89d806f6, {
                label: /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
                    alignSelf: "center",
                    width: "100%",
                    align: "start"
                }, optionLabel),
                pad: (_theme$selectMultiple3 = theme.selectMultiple) == null || (_theme$selectMultiple3 = _theme$selectMultiple3.option) == null ? void 0 : _theme$selectMultiple3.pad,
                tabIndex: "-1",
                checked: optionSelected,
                disabled: optionDisabled,
                inert: $a1aed72b35405d54$export$6f8d7bb3dad10aa1,
                containerProps: {
                    // in Firefox when we have inert set, the checkbox
                    // click event gets swallowed by the checkbox.
                    // We need the click event to go the the button
                    // around the checkbox so we use pointerEvents =
                    // none. For code clarity we decided an inline
                    // style made sense here.
                    style: {
                        pointerEvents: 'none'
                    }
                }
            });
        }
        if (!children && search) {
            var searchText = search.toLowerCase();
            if (typeof optionLabel === 'string' && optionLabel.toLowerCase().indexOf(searchText) >= 0) {
                var _theme$selectMultiple4;
                // code to bold search term in matching options
                var boldIndex = optionLabel.toLowerCase().indexOf(searchText);
                var childBeginning = optionLabel.substring(0, boldIndex);
                var childBold = optionLabel.substring(boldIndex, boldIndex + searchText.length);
                childBold = /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement("b", null, childBold);
                var childEnd = optionLabel.substring(boldIndex + searchText.length);
                child = /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement($c15af89705eeb537$export$ea5f704b89d806f6, {
                    label: /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
                        alignSelf: "center",
                        width: "100%",
                        align: "start",
                        direction: "row"
                    }, /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, null, childBeginning, childBold, childEnd)),
                    pad: (_theme$selectMultiple4 = theme.selectMultiple) == null || (_theme$selectMultiple4 = _theme$selectMultiple4.option) == null ? void 0 : _theme$selectMultiple4.pad,
                    tabIndex: "-1",
                    checked: optionSelected,
                    disabled: optionDisabled,
                    inert: $a1aed72b35405d54$export$6f8d7bb3dad10aa1,
                    containerProps: {
                        // in Firefox when we have inert set, the checkbox
                        // click event gets swallowed by the checkbox.
                        // We need the click event to go the the button
                        // around the checkbox so we use pointerEvents =
                        // none. For code clarity we decided an inline
                        // style made sense here.
                        style: {
                            pointerEvents: 'none'
                        }
                    }
                });
            }
        }
        // if we have a child, turn on plain, and hoverIndicator
        return /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement($c0f2e05c3c6f54d3$export$11a8a1ea41bf55d8, {
            a11yTitle: format({
                id: optionSelected ? 'selectMultiple.optionSelected' : 'selectMultiple.optionNotSelected',
                messages: messages,
                values: {
                    optionLabel: optionLabel
                }
            }),
            key: index,
            ref: function ref(node) {
                // eslint-disable-next-line no-param-reassign
                if (optionRef) optionRef.current = node;
                if (optionActive) activeRef.current = node;
            },
            tabIndex: optionSelected || activeIndex === index || // when nothing is selected and entering listbox
            // first option should be focused
            value.length === 0 && activeIndex === -1 && index === 0 ? '0' : '-1',
            role: "option",
            id: "option" + index,
            "aria-setsize": options.length,
            "aria-posinset": index + 1,
            "aria-selected": optionSelected,
            focusIndicator: usingKeyboard,
            "aria-disabled": optionDisabled || undefined,
            plain: !child ? undefined : true,
            align: "start",
            kind: !child ? 'option' : undefined,
            active: optionActive,
            selected: optionSelected,
            onMouseOver: !optionDisabled ? onActiveOption(index) : undefined,
            onClick: !optionDisabled ? selectOption(index) : undefined,
            onFocus: function onFocus() {
                return setActiveIndex(index);
            },
            textComponent: textComponent
        }, child);
    })) : /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement($f95174500a869a04$export$e87a5b03dc8a6193, {
        emptySearchMessage: emptySearchMessage,
        selectOptionsStyle: selectOptionsStyle,
        theme: theme
    }), usingKeyboard && showA11yLimit && /*#__PURE__*/ $41e6a9fd5de1d0b9$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        height: "0px",
        width: "0px",
        overflow: "hidden",
        "aria-live": "assertive",
        role: "alert"
    }, showA11yLimit)));
});






var $b67f210f9f4f69b4$export$1e511d4a378977f5;
var $b67f210f9f4f69b4$export$81241bedce0a1d47;
"use strict";
$b67f210f9f4f69b4$export$1e511d4a378977f5 = true;
$b67f210f9f4f69b4$export$81241bedce0a1d47 = void 0;

var $b67f210f9f4f69b4$var$_propTypes = $b67f210f9f4f69b4$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $b67f210f9f4f69b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $b67f210f9f4f69b4$var$_extends() {
    return $b67f210f9f4f69b4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b67f210f9f4f69b4$var$_extends.apply(null, arguments);
}
var $b67f210f9f4f69b4$var$PropType = {};
$b67f210f9f4f69b4$var$PropType = $b67f210f9f4f69b4$var$_extends({}, $b3898c3050a12e8b$export$257cf46788f4f52b, {
    defaultValue: $b67f210f9f4f69b4$var$_propTypes["default"].arrayOf($b67f210f9f4f69b4$var$_propTypes["default"].oneOfType([
        $b67f210f9f4f69b4$var$_propTypes["default"].string,
        $b67f210f9f4f69b4$var$_propTypes["default"].object,
        $b67f210f9f4f69b4$var$_propTypes["default"].number
    ])),
    help: $b67f210f9f4f69b4$var$_propTypes["default"].node,
    limit: $b67f210f9f4f69b4$var$_propTypes["default"].number,
    messages: $b67f210f9f4f69b4$var$_propTypes["default"].shape({
        clearAll: $b67f210f9f4f69b4$var$_propTypes["default"].string,
        clearAllA11y: $b67f210f9f4f69b4$var$_propTypes["default"].string,
        // "multiple" kept for backwards compatibility,
        // but summarizedValue should be used instead
        multiple: $b67f210f9f4f69b4$var$_propTypes["default"].string,
        open: $b67f210f9f4f69b4$var$_propTypes["default"].string,
        optionNotSelected: $b67f210f9f4f69b4$var$_propTypes["default"].string,
        optionSelected: $b67f210f9f4f69b4$var$_propTypes["default"].string,
        optionsA11y: $b67f210f9f4f69b4$var$_propTypes["default"].string,
        search: $b67f210f9f4f69b4$var$_propTypes["default"].string,
        selectAll: $b67f210f9f4f69b4$var$_propTypes["default"].string,
        selectAllA11y: $b67f210f9f4f69b4$var$_propTypes["default"].string,
        selectDrop: $b67f210f9f4f69b4$var$_propTypes["default"].string,
        selected: $b67f210f9f4f69b4$var$_propTypes["default"].string,
        selectedOfTotal: $b67f210f9f4f69b4$var$_propTypes["default"].string,
        selectedOptions: $b67f210f9f4f69b4$var$_propTypes["default"].string,
        showMore: $b67f210f9f4f69b4$var$_propTypes["default"].string,
        summarizedValue: $b67f210f9f4f69b4$var$_propTypes["default"].string
    }),
    showSelectedInline: $b67f210f9f4f69b4$var$_propTypes["default"].bool,
    sortSelectedOnClose: $b67f210f9f4f69b4$var$_propTypes["default"].bool,
    value: $b67f210f9f4f69b4$var$_propTypes["default"].arrayOf($b67f210f9f4f69b4$var$_propTypes["default"].oneOfType([
        $b67f210f9f4f69b4$var$_propTypes["default"].string,
        $b67f210f9f4f69b4$var$_propTypes["default"].object,
        $b67f210f9f4f69b4$var$_propTypes["default"].number
    ]))
});
var $b67f210f9f4f69b4$var$SelectMultiplePropTypes = $b67f210f9f4f69b4$export$81241bedce0a1d47 = $b67f210f9f4f69b4$var$PropType;



var $4000afee7dbab46f$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "aria-labelledby",
    "alignSelf",
    "children",
    "defaultValue",
    "disabled",
    "disabledKey",
    "dropAlign",
    "dropHeight",
    "dropProps",
    "dropTarget",
    "emptySearchMessage",
    "focusIndicator",
    "gridArea",
    "help",
    "id",
    "icon",
    "labelKey",
    "limit",
    "margin",
    "messages",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onClose",
    "onFocus",
    "onKeyDown",
    "onMore",
    "onOpen",
    "onSearch",
    "open",
    "options",
    "placeholder",
    "plain",
    "replace",
    "searchPlaceholder",
    "size",
    "sortSelectedOnClose",
    "value",
    "valueKey",
    "valueLabel",
    "showSelectedInline",
    "width"
];
function $4000afee7dbab46f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $4000afee7dbab46f$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($4000afee7dbab46f$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $4000afee7dbab46f$var$_extends() {
    return $4000afee7dbab46f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4000afee7dbab46f$var$_extends.apply(null, arguments);
}
function $4000afee7dbab46f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $4000afee7dbab46f$var$StyledSelectBox = (0, $4000afee7dbab46f$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "SelectMultiple__StyledSelectBox",
    componentId: "sc-18zwyth-0"
})([
    "",
    ";",
    ";",
    ";"
], function(props) {
    return !props.plainSelect && $4113023f9e0bafa0$exports.controlBorderStyle;
}, function(props) {
    var _props$theme$select;
    return (_props$theme$select = props.theme.select) == null || (_props$theme$select = _props$theme$select.control) == null ? void 0 : _props$theme$select.extend;
}, function(props) {
    var _props$theme$select$c;
    return props.open && ((_props$theme$select$c = props.theme.select.control) == null ? void 0 : _props$theme$select$c.open);
});
var $4000afee7dbab46f$var$SelectMultiple = $4000afee7dbab46f$export$12a18ac91a0d2aeb = /*#__PURE__*/ (0, $4000afee7dbab46f$var$_react.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], ariaLabelledByProp = _ref['aria-labelledby'], alignSelf = _ref.alignSelf, children = _ref.children, defaultValue = _ref.defaultValue, disabled = _ref.disabled, disabledKey = _ref.disabledKey, dropAlignProp = _ref.dropAlign, dropHeight = _ref.dropHeight, dropProps = _ref.dropProps, dropTarget = _ref.dropTarget, emptySearchMessage = _ref.emptySearchMessage, focusIndicator = _ref.focusIndicator, gridArea = _ref.gridArea, help = _ref.help, id = _ref.id, icon = _ref.icon, labelKey = _ref.labelKey, limit = _ref.limit, margin = _ref.margin, messages = _ref.messages, name = _ref.name, onBlur = _ref.onBlur, onChange = _ref.onChange, onClick = _ref.onClick, onClose = _ref.onClose, onFocus = _ref.onFocus, onKeyDown = _ref.onKeyDown, onMore = _ref.onMore, onOpen = _ref.onOpen, onSearch = _ref.onSearch, openProp = _ref.open, optionsProp = _ref.options, placeholder = _ref.placeholder, plain = _ref.plain, replace = _ref.replace, searchPlaceholder = _ref.searchPlaceholder, size = _ref.size, _ref$sortSelectedOnCl = _ref.sortSelectedOnClose, sortSelectedOnClose = _ref$sortSelectedOnCl === void 0 ? true : _ref$sortSelectedOnCl, valueProp = _ref.value, valueKey = _ref.valueKey, valueLabel = _ref.valueLabel, _ref$showSelectedInli = _ref.showSelectedInline, showSelectedInline = _ref$showSelectedInli === void 0 ? false : _ref$showSelectedInli, width = _ref.width, rest = $4000afee7dbab46f$var$_objectWithoutPropertiesLoose(_ref, $4000afee7dbab46f$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var inputRef = (0, $4000afee7dbab46f$var$_react.useRef)();
    var formContext = (0, $4000afee7dbab46f$var$_react.useContext)($5c9c2e034f522b3e$export$c24727297075ec6a);
    var _useContext = (0, $4000afee7dbab46f$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var selectBoxRef = (0, $4000afee7dbab46f$var$_react.useRef)();
    var dropButtonRef = (0, $4113023f9e0bafa0$exports.useForwardedRef)(ref);
    var usingKeyboard = (0, $4113023f9e0bafa0$exports.useKeyboard)();
    var formFieldData = formContext == null ? void 0 : formContext.useFormField({});
    var dropAlign = (0, $4000afee7dbab46f$var$_react.useMemo)(function() {
        return dropAlignProp || (showSelectedInline ? {
            top: 'top',
            right: 'right',
            left: 'left'
        } : {
            top: 'bottom',
            left: 'left'
        });
    }, [
        dropAlignProp,
        showSelectedInline
    ]);
    // value is used for what we receive in valueProp and the basis for
    // what we send with onChange
    // When 'valueKey' sets 'reduce', the value(s) here should match
    // what the 'valueKey' would return for the corresponding
    // selected option object.
    // Otherwise, the value(s) should match the selected options.
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp,
        initialValue: defaultValue || ''
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    var _useState = (0, $4000afee7dbab46f$var$_react.useState)(), ariaLabelledBy = _useState[0], setAriaLabelledBy = _useState[1];
    (0, $4000afee7dbab46f$var$_react.useEffect)(function() {
        if (formFieldData != null && formFieldData.inForm && id && !ariaLabel && !placeholder) {
            var labelElement = document.getElementById("grommet-" + id + "__input__label");
            if (labelElement) setAriaLabelledBy("grommet-" + id + "__input__label " + id);
        }
    }, [
        formFieldData == null ? void 0 : formFieldData.inForm,
        id,
        ariaLabel,
        placeholder
    ]);
    // normalizedValue is the value mapped with any valueKey applied
    // When the options array contains objects, this property indicates how
    // to retrieve the value of each option.
    // If a string is provided, it is used as the key to retrieve a
    // property of an option object.
    // If a function is provided, it is called with the option and should
    // return the value.
    // If reduce is true, this value will be used for the 'value'
    // delivered via 'onChange'.
    var normalizedValue = (0, $4000afee7dbab46f$var$_react.useMemo)(function() {
        return (0, $a1aed72b35405d54$export$49df40d5c24cf7e3)(value, valueKey);
    }, [
        value,
        valueKey
    ]);
    // search input value
    var _useState2 = (0, $4000afee7dbab46f$var$_react.useState)(), search = _useState2[0], setSearch = _useState2[1];
    // All select option indices and values
    var _useState3 = (0, $4000afee7dbab46f$var$_react.useState)(optionsProp), allOptions = _useState3[0], setAllOptions = _useState3[1];
    var _useState4 = (0, $4000afee7dbab46f$var$_react.useState)(), orderedOptions = _useState4[0], setOrderedOptions = _useState4[1];
    // Track changes to options property, except when options are being
    // updated due to search activity. Allows option's initial index value
    // to be referenced when filtered by search.
    (0, $4000afee7dbab46f$var$_react.useEffect)(function() {
        if (!search) setAllOptions(optionsProp);
    }, [
        optionsProp,
        search
    ]);
    (0, $4000afee7dbab46f$var$_react.useEffect)(function() {
        if (search && optionsProp && optionsProp.length > 0) {
            var additionalOptions = [].concat(allOptions);
            optionsProp.forEach(function(i) {
                return !additionalOptions.some(function(j) {
                    return typeof i === 'object' ? (0, $a1aed72b35405d54$export$f9e47df77939ed56)(i, valueKey) === (0, $a1aed72b35405d54$export$f9e47df77939ed56)(j, valueKey) : i === j;
                }) && additionalOptions.push(i);
            });
            if (allOptions.length !== additionalOptions.length) setAllOptions(additionalOptions);
        }
    }, [
        allOptions,
        optionsProp,
        search,
        valueKey
    ]);
    (0, $4000afee7dbab46f$var$_react.useEffect)(function() {
        if (sortSelectedOnClose) setOrderedOptions(optionsProp);
    }, [
        optionsProp,
        sortSelectedOnClose
    ]);
    // the option indexes present in the value
    var optionIndexesInValue = (0, $4000afee7dbab46f$var$_react.useMemo)(function() {
        var result = [];
        if (!Array.isArray(normalizedValue)) return result;
        normalizedValue.forEach(function(v) {
            var index = allOptions.map(function(option) {
                return (0, $a1aed72b35405d54$export$f9e47df77939ed56)(option, valueKey);
            }).indexOf(v);
            if (index !== -1) result.push(index);
        });
        return result;
    }, [
        allOptions,
        valueKey,
        normalizedValue
    ]);
    var _useState5 = (0, $4000afee7dbab46f$var$_react.useState)(openProp), open = _useState5[0], setOpen = _useState5[1];
    (0, $4000afee7dbab46f$var$_react.useEffect)(function() {
        return setOpen(openProp);
    }, [
        openProp
    ]);
    var onRequestOpen = (0, $4000afee7dbab46f$var$_react.useCallback)(function() {
        if (open) return;
        setOpen(true);
        if (onOpen) onOpen();
    }, [
        onOpen,
        open
    ]);
    // On drop close if sortSelectedOnClose is true, sort options so that
    // selected options appear first, followed by unselected options.
    (0, $4000afee7dbab46f$var$_react.useEffect)(function() {
        if (sortSelectedOnClose && value && !open) {
            var selectedOptions = optionsProp.filter(function(option) {
                return (0, $a1aed72b35405d54$export$22012a5c726bef55)(value, valueKey && valueKey.reduce ? (0, $a1aed72b35405d54$export$f9e47df77939ed56)(option, valueKey) : option, valueKey || labelKey);
            });
            var unselectedOptions = optionsProp.filter(function(i) {
                return !(0, $a1aed72b35405d54$export$22012a5c726bef55)(selectedOptions, i, valueKey || labelKey);
            });
            var nextOrderedOptions = selectedOptions.concat(unselectedOptions);
            setOrderedOptions(nextOrderedOptions);
        }
    }, [
        labelKey,
        open,
        sortSelectedOnClose,
        optionsProp,
        value,
        valueKey
    ]);
    var onRequestClose = (0, $4000afee7dbab46f$var$_react.useCallback)(function() {
        setOpen(false);
        if (onClose) onClose();
        setSearch();
    }, [
        onClose
    ]);
    var triggerChangeEvent = (0, $4000afee7dbab46f$var$_react.useCallback)(function(nextValue) {
        return (0, $a1aed72b35405d54$export$922aead9cd650d86)(inputRef, nextValue);
    }, []);
    var onSelectChange = (0, $4000afee7dbab46f$var$_react.useCallback)(function(event, _ref2) {
        var option = _ref2.option, nextValue = _ref2.value;
        // nextValue must not be of type object to set value directly on the
        // input. if it is an object, then the user has not provided necessary
        // props to reduce object option
        if (typeof nextValue !== 'object' && nextValue !== event.target.value && inputRef.current) // select registers changing option as a click event or keydown.
        // when in a form, we need to programatically trigger a change
        // event in order for the change event to be registered upstream
        // necessary for change validation in form
        triggerChangeEvent(nextValue);
        setValue(nextValue);
        if (onChange) {
            event.persist();
            var adjustedEvent;
            // support for native event used by Preact
            if (event instanceof Event) {
                adjustedEvent = new event.constructor(event.type, event);
                Object.defineProperties(adjustedEvent, {
                    target: {
                        value: inputRef.current
                    },
                    value: {
                        value: nextValue
                    },
                    option: {
                        value: option
                    }
                });
            } else {
                adjustedEvent = event;
                adjustedEvent.target = inputRef.current;
                adjustedEvent.value = nextValue;
                adjustedEvent.option = option;
            }
            onChange(adjustedEvent);
        }
    }, [
        onChange,
        setValue,
        triggerChangeEvent
    ]);
    var SelectIcon = (0, $a1aed72b35405d54$export$ea6782b1ec892245)(icon, theme, open);
    // element to show, trumps inputValue
    var selectValue = (0, $4000afee7dbab46f$var$_react.useMemo)(function() {
        var result;
        if (valueLabel) result = value && valueLabel instanceof Function ? valueLabel(value) : valueLabel;
        else if ((value == null ? void 0 : value.length) > 0 && showSelectedInline) result = /*#__PURE__*/ $4000afee7dbab46f$var$_react["default"].createElement($6f86de59327318fa$export$65ae1fa19d91e9b3, {
            allOptions: allOptions,
            disabled: disabled,
            disabledKey: disabledKey,
            dropButtonRef: dropButtonRef,
            labelKey: labelKey,
            messages: messages,
            onRequestOpen: onRequestOpen,
            onSelectChange: onSelectChange,
            theme: theme,
            value: value,
            valueKey: valueKey
        }, children);
        return result;
    }, [
        allOptions,
        children,
        disabled,
        disabledKey,
        dropButtonRef,
        labelKey,
        messages,
        onRequestOpen,
        onSelectChange,
        showSelectedInline,
        theme,
        value,
        valueKey,
        valueLabel
    ]);
    var displayLabelKey = (0, $4000afee7dbab46f$var$_react.useMemo)(function() {
        return (0, $a1aed72b35405d54$export$7e4915d842d2c2e)(labelKey, allOptions, optionIndexesInValue, selectValue);
    }, [
        labelKey,
        allOptions,
        optionIndexesInValue,
        selectValue
    ]);
    // text to show
    // When the options array contains objects, this property indicates how
    // to retrieve the value of each option.
    // If a string is provided, it is used as the key to retrieve a
    // property of an option object.
    // If a function is provided, it is called with the option and should
    // return the value.
    // If reduce is true, this value will be used for the 'value'
    // delivered via 'onChange'.
    var inputValue = (0, $4000afee7dbab46f$var$_react.useMemo)(function() {
        if (!selectValue) {
            if (optionIndexesInValue.length === 0) return '';
            if (optionIndexesInValue.length === 1) return (0, $a1aed72b35405d54$export$f9e47df77939ed56)(allOptions[optionIndexesInValue[0]], labelKey);
            // keeping messages.multiple for backwards compatibility
            if (messages != null && messages.multiple && !messages.summarizedValue) return format({
                id: 'select.multiple',
                messages: messages
            });
            return format({
                id: 'selectMultiple.summarizedValue',
                messages: messages,
                values: {
                    selected: optionIndexesInValue.length,
                    total: allOptions.length
                }
            });
        }
        return undefined;
    }, [
        selectValue,
        optionIndexesInValue,
        allOptions,
        labelKey,
        format,
        messages
    ]);
    var iconColor = (0, $a1aed72b35405d54$export$bb417e0702eb86b5)(theme);
    var displaySelectIcon = SelectIcon && /*#__PURE__*/ $4000afee7dbab46f$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        alignSelf: "center",
        margin: theme.select.icons.margin,
        width: {
            min: 'auto'
        }
    }, /*#__PURE__*/ (0, $4000afee7dbab46f$var$_react.isValidElement)(SelectIcon) ? SelectIcon : /*#__PURE__*/ $4000afee7dbab46f$var$_react["default"].createElement(SelectIcon, {
        color: iconColor,
        size: size
    }));
    var dropContent = /*#__PURE__*/ $4000afee7dbab46f$var$_react["default"].createElement($41e6a9fd5de1d0b9$export$2dd06c00b4faaa63, {
        allOptions: allOptions,
        disabled: disabled,
        disabledKey: disabledKey,
        dropHeight: dropHeight,
        emptySearchMessage: emptySearchMessage,
        help: help,
        icon: displaySelectIcon,
        id: id,
        labelKey: labelKey,
        limit: limit,
        messages: messages,
        onChange: onSelectChange,
        onClose: onRequestClose,
        onKeyDown: onKeyDown,
        onMore: onMore,
        onSearch: onSearch,
        options: orderedOptions || optionsProp,
        optionIndexesInValue: optionIndexesInValue,
        replace: replace,
        searchPlaceholder: searchPlaceholder,
        search: search,
        setSearch: setSearch,
        usingKeyboard: usingKeyboard,
        value: value,
        valueKey: valueKey,
        showSelectedInline: showSelectedInline
    }, children);
    var dropButtonProps = {
        ref: dropButtonRef,
        a11yTitle: (ariaLabel || a11yTitle || placeholder || format({
            id: 'selectMultiple.open',
            messages: messages
        })) + ". " + format({
            id: 'selectMultiple.selected',
            values: {
                selected: (value == null ? void 0 : value.length) || 0,
                total: allOptions.length
            }
        }),
        'aria-expanded': Boolean(open),
        'aria-haspopup': 'listbox',
        id: id,
        disabled: disabled === true || undefined,
        open: open,
        focusIndicator: focusIndicator,
        onFocus: onFocus,
        onBlur: onBlur,
        gridArea: gridArea,
        margin: margin,
        onOpen: onRequestOpen,
        onClose: onRequestClose,
        onClick: onClick,
        plainSelect: plain,
        plain: plain,
        // Button should be plain
        dropProps: dropProps,
        dropContent: dropContent,
        theme: theme
    };
    return /*#__PURE__*/ $4000afee7dbab46f$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onDown: onRequestOpen,
        onUp: onRequestOpen
    }, showSelectedInline ? /*#__PURE__*/ $4000afee7dbab46f$var$_react["default"].createElement($4000afee7dbab46f$var$StyledSelectBox, $4000afee7dbab46f$var$_extends({
        disabled: disabled === true || undefined,
        alignSelf: alignSelf,
        direction: "row",
        alignContent: "start",
        background: theme.select.background,
        ref: selectBoxRef,
        flex: false,
        plainSelect: plain,
        width: width
    }, passThemeFlag), /*#__PURE__*/ $4000afee7dbab46f$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        width: "100%"
    }, /*#__PURE__*/ $4000afee7dbab46f$var$_react["default"].createElement($d7e2a556593dc38b$export$64fff40e709e8b2e, $4000afee7dbab46f$var$_extends({
        fill: "horizontal",
        alignSelf: "start"
    }, dropButtonProps, {
        dropAlign: dropAlign,
        dropTarget: dropTarget || selectBoxRef.current
    }), selectValue || displayLabelKey ? /*#__PURE__*/ $4000afee7dbab46f$var$_react["default"].createElement($4000afee7dbab46f$var$_react["default"].Fragment, null, /*#__PURE__*/ $4000afee7dbab46f$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        direction: "row"
    }, /*#__PURE__*/ $4000afee7dbab46f$var$_react["default"].createElement($c0f2e05c3c6f54d3$export$b34b5c37a9633c78, $4000afee7dbab46f$var$_extends({
        a11yTitle: ariaLabel || a11yTitle,
        defaultCursor: disabled === true || undefined,
        focusIndicator: false,
        id: id ? (0, $a1aed72b35405d54$export$abfa4f6a3fb2b741)(id) : undefined,
        inert: $a1aed72b35405d54$export$6f8d7bb3dad10aa1,
        name: name,
        width: "100%"
    }, rest, {
        tabIndex: "-1",
        type: "text",
        placeholder: !value || (value == null ? void 0 : value.length) === 0 ? placeholder || selectValue || displayLabelKey : format({
            id: onMore ? 'selectMultiple.selected' : 'selectMultiple.selectedOfTotal',
            messages: messages,
            values: $4000afee7dbab46f$var$_extends({
                selected: (value == null ? void 0 : value.length) || 0
            }, !onMore ? {
                total: allOptions.length
            } : {})
        }),
        plain: true,
        readOnly: true,
        value: "",
        theme: theme
    })), displaySelectIcon), /*#__PURE__*/ $4000afee7dbab46f$var$_react["default"].createElement($c0f2e05c3c6f54d3$export$7196851310a3d0bf, {
        type: "text",
        name: name,
        id: id ? (0, $a1aed72b35405d54$export$abfa4f6a3fb2b741)(id) : undefined,
        inert: $a1aed72b35405d54$export$6f8d7bb3dad10aa1,
        value: inputValue,
        ref: inputRef,
        readOnly: true
    })) : /*#__PURE__*/ $4000afee7dbab46f$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        direction: "row"
    }, /*#__PURE__*/ $4000afee7dbab46f$var$_react["default"].createElement($2f5972626e30691d$export$2307ecc6c2fea308, $4000afee7dbab46f$var$_extends({
        a11yTitle: ariaLabel || a11yTitle,
        disabled: disabled,
        id: id,
        inert: $a1aed72b35405d54$export$6f8d7bb3dad10aa1,
        name: name,
        ref: inputRef,
        placeholder: placeholder || 'Select',
        value: inputValue,
        size: size,
        theme: theme
    }, rest)), displaySelectIcon)), !open && (value == null ? void 0 : value.length) > 0 && (selectValue || displayLabelKey))) : /*#__PURE__*/ $4000afee7dbab46f$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        width: width
    }, /*#__PURE__*/ $4000afee7dbab46f$var$_react["default"].createElement($c0f2e05c3c6f54d3$export$923536af422910c8, $4000afee7dbab46f$var$_extends({}, dropButtonProps, {
        dropAlign: dropAlign,
        dropTarget: dropTarget,
        alignSelf: alignSelf,
        tabIndex: "0",
        "aria-labelledby": ariaLabelledByProp || ariaLabelledBy
    }), /*#__PURE__*/ $4000afee7dbab46f$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        align: "center",
        direction: "row",
        justify: "between",
        background: theme.select.background
    }, /*#__PURE__*/ $4000afee7dbab46f$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        direction: "row",
        flex: true,
        basis: "auto"
    }, selectValue || displayLabelKey ? /*#__PURE__*/ $4000afee7dbab46f$var$_react["default"].createElement($4000afee7dbab46f$var$_react["default"].Fragment, null, selectValue || displayLabelKey, /*#__PURE__*/ $4000afee7dbab46f$var$_react["default"].createElement($c0f2e05c3c6f54d3$export$7196851310a3d0bf, {
        type: "text",
        name: name,
        id: id ? (0, $a1aed72b35405d54$export$abfa4f6a3fb2b741)(id) : undefined,
        inert: $a1aed72b35405d54$export$6f8d7bb3dad10aa1,
        value: inputValue,
        ref: inputRef,
        readOnly: true
    })) : /*#__PURE__*/ $4000afee7dbab46f$var$_react["default"].createElement($2f5972626e30691d$export$2307ecc6c2fea308, $4000afee7dbab46f$var$_extends({
        a11yTitle: ariaLabel || a11yTitle,
        disabled: disabled,
        id: id,
        inert: $a1aed72b35405d54$export$6f8d7bb3dad10aa1,
        name: name,
        ref: inputRef,
        placeholder: placeholder,
        value: inputValue,
        size: size,
        theme: theme
    }, rest))), displaySelectIcon))));
});
$4000afee7dbab46f$var$SelectMultiple.displayName = 'SelectMultiple';
$4000afee7dbab46f$var$SelectMultiple.propTypes = $b67f210f9f4f69b4$export$81241bedce0a1d47;


$2b7901c119e4bd86$export$12a18ac91a0d2aeb = $4000afee7dbab46f$export$12a18ac91a0d2aeb;


var $9ec3711a4a72b5cc$export$1e511d4a378977f5;
var $9ec3711a4a72b5cc$export$f6c44db1bdce73bb;
"use strict";
$9ec3711a4a72b5cc$export$1e511d4a378977f5 = true;
$9ec3711a4a72b5cc$export$f6c44db1bdce73bb = void 0;

var $9ec3711a4a72b5cc$var$_propTypes = $9ec3711a4a72b5cc$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $9ec3711a4a72b5cc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $9ec3711a4a72b5cc$var$PropType = {};
$9ec3711a4a72b5cc$var$PropType = {
    options: $9ec3711a4a72b5cc$var$_propTypes["default"].arrayOf($9ec3711a4a72b5cc$var$_propTypes["default"].oneOfType([
        $9ec3711a4a72b5cc$var$_propTypes["default"].string,
        $9ec3711a4a72b5cc$var$_propTypes["default"].number,
        $9ec3711a4a72b5cc$var$_propTypes["default"].shape({
            label: $9ec3711a4a72b5cc$var$_propTypes["default"].string,
            value: $9ec3711a4a72b5cc$var$_propTypes["default"].oneOfType([
                $9ec3711a4a72b5cc$var$_propTypes["default"].string,
                $9ec3711a4a72b5cc$var$_propTypes["default"].number,
                $9ec3711a4a72b5cc$var$_propTypes["default"].bool
            ])
        })
    ])),
    property: $9ec3711a4a72b5cc$var$_propTypes["default"].string,
    range: $9ec3711a4a72b5cc$var$_propTypes["default"].shape({
        max: $9ec3711a4a72b5cc$var$_propTypes["default"].number,
        min: $9ec3711a4a72b5cc$var$_propTypes["default"].number,
        step: $9ec3711a4a72b5cc$var$_propTypes["default"].number
    })
};
var $9ec3711a4a72b5cc$var$DataFilterPropTypes = $9ec3711a4a72b5cc$export$f6c44db1bdce73bb = $9ec3711a4a72b5cc$var$PropType;






var $8481a9fe404a179c$var$_excluded = [
    "children",
    "options",
    "property",
    "range"
];
function $8481a9fe404a179c$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($8481a9fe404a179c$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $8481a9fe404a179c$var$_extends() {
    return $8481a9fe404a179c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8481a9fe404a179c$var$_extends.apply(null, arguments);
}
function $8481a9fe404a179c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// empirical constants for when we change inputs
var $8481a9fe404a179c$var$maxCheckBoxGroupOptions = 4;
var $8481a9fe404a179c$var$minSelectSearchOptions = 10;
var $8481a9fe404a179c$var$defaultRangeSteps = 20;
var $8481a9fe404a179c$var$_getValueAt = function getValueAt(valueObject, pathArg) {
    if (!pathArg || valueObject === undefined) return undefined;
    var path = Array.isArray(pathArg) ? pathArg : pathArg.split('.');
    if (path.length === 1) return valueObject[path];
    return $8481a9fe404a179c$var$_getValueAt(valueObject[path.shift()], path);
};
var $8481a9fe404a179c$var$generateOptions = function generateOptions(data, property) {
    return Array.from(new Set(data.map(function(d) {
        return $8481a9fe404a179c$var$_getValueAt(d, property);
    }))).filter(function(v) {
        return v !== undefined && v !== '';
    })// ensure number values are sorted appropriately
    // [132, 15, 100] --> [15, 100, 132]
    // empty sort() would result in [100, 132, 15]
    .sort(function(a, b) {
        if (typeof a === 'number' && typeof b === 'number') return a - b;
        if (typeof a === 'string' && typeof b === 'string' || typeof a === 'boolean' && typeof b === 'boolean') return a < b ? -1 : 1;
        return 0;
    });
};
var $8481a9fe404a179c$var$booleanOptions = [
    {
        label: 'true',
        value: true
    },
    {
        label: 'false',
        value: false
    }
];
var $8481a9fe404a179c$var$DataFilter = $8481a9fe404a179c$export$bf2cd9c1afd10b96 = function DataFilter(_ref) {
    var _properties$property3, _properties$property5;
    var children = _ref.children, optionsProp = _ref.options, property = _ref.property, rangeProp = _ref.range, rest = $8481a9fe404a179c$var$_objectWithoutPropertiesLoose(_ref, $8481a9fe404a179c$var$_excluded);
    var _useContext = (0, $8481a9fe404a179c$var$_react.useContext)($932597a497e37de0$export$58d75f9829cbe158), data = _useContext.data, dataId = _useContext.id, properties = _useContext.properties, unfilteredData = _useContext.unfilteredData;
    var _useContext2 = (0, $8481a9fe404a179c$var$_react.useContext)($b1a512ff039be377$export$e2b284ce8e93d8eb), inDataForm = _useContext2.inDataForm;
    var _useState = (0, $8481a9fe404a179c$var$_react.useState)(''), searchText = _useState[0], setSearchText = _useState[1];
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useMemo = (0, $8481a9fe404a179c$var$_react.useMemo)(function() {
        var _properties$property, _properties$property2;
        if (children) return [
            undefined,
            undefined
        ]; // caller driving
        var optionsIn = optionsProp || (properties == null || (_properties$property = properties[property]) == null ? void 0 : _properties$property.options);
        var rangeIn = rangeProp || (properties == null || (_properties$property2 = properties[property]) == null ? void 0 : _properties$property2.range);
        if (optionsIn) return [
            optionsIn,
            undefined
        ];
        if (rangeIn && 'min' in rangeIn && 'max' in rangeIn) return [
            undefined,
            [
                rangeIn.min,
                rangeIn.max
            ]
        ];
        // generate options from all values for property
        var uniqueValues = $8481a9fe404a179c$var$generateOptions(unfilteredData || data, property);
        // if no values, nothing to filter
        // uniqueValues.length === 0 allows single item/value filters to render
        if (uniqueValues.length === 0) return [
            undefined,
            undefined
        ];
        // if any values aren't numeric, treat as options
        if (uniqueValues.some(function(v) {
            return v !== undefined && typeof v !== 'number';
        })) return [
            uniqueValues,
            undefined
        ];
        // all values are numeric, treat as range
        var min = uniqueValues[0];
        var max = uniqueValues[uniqueValues.length - 1];
        // Clean up floating-point precision artifacts, capped to 2 decimal places.
        // Use floor for min and ceil for max so actual data values always fall
        // within the computed range (e.g. -4.859 stays inside [-19.99, -4.85]).
        var maxDecimalPlaces = Math.max((0, $f0b28568f0d20c36$export$d795fe2838a61f89)(uniqueValues[0]), (0, $f0b28568f0d20c36$export$d795fe2838a61f89)(uniqueValues[uniqueValues.length - 1]));
        if (maxDecimalPlaces > 0) {
            var multiplier = Math.pow(10, Math.min(maxDecimalPlaces, 2));
            min = Math.floor(min * multiplier) / multiplier;
            max = Math.ceil(max * multiplier) / multiplier;
        }
        return [
            undefined,
            [
                min,
                max
            ]
        ];
    }, [
        children,
        data,
        optionsProp,
        properties,
        property,
        rangeProp,
        unfilteredData
    ]), options = _useMemo[0], range = _useMemo[1];
    var searchedOptions = (0, $8481a9fe404a179c$var$_react.useMemo)(function() {
        if (!searchText) return options;
        // The line below escapes regular expression special characters:
        // [ \ ^ $ . | ? * + ( )
        var escapedText = searchText.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&');
        // Create the regular expression with modified value which
        // handles escaping special characters. Without escaping special
        // characters, errors will appear in the console
        var exp = new RegExp(escapedText, 'i');
        return options.filter(function(o) {
            return typeof o === 'string' ? exp.test(o) : exp.test(o.label);
        });
    }, [
        options,
        searchText
    ]);
    var id = dataId + "-" + property;
    // only add aria-label for no form examples
    var ariaLabel = !inDataForm ? "" + ((properties == null || (_properties$property3 = properties[property]) == null ? void 0 : _properties$property3.label) || property) : undefined;
    var htmlFor = id;
    var content = children;
    if (!content) {
        if (range) {
            var _properties$property4, _theme$dataFilter;
            var step = // from `range` on DataFilter
            (rangeProp == null ? void 0 : rangeProp.step) || (properties == null || (_properties$property4 = properties[property]) == null || (_properties$property4 = _properties$property4.range) == null ? void 0 : _properties$property4.step);
            if (!step) {
                // avoid floating point issues where 4.4 - 2 returns 2.4000000000000004
                // and instead return 2.4 by doing calculations in integers then
                // restore order of magnitude
                var multiplicationFactor = Math.pow(10, Math.max((0, $f0b28568f0d20c36$export$d795fe2838a61f89)(range[1]), (0, $f0b28568f0d20c36$export$d795fe2838a61f89)(range[0])));
                var delta = (range[1] * multiplicationFactor - range[0] * multiplicationFactor) / multiplicationFactor;
                // avoid floating point issues where
                // 0.012 / 20 returns 0.0006000000000000001
                // and instead return 0.0006
                // or 2.8 / 20 returns 0.13999999999999999
                // and istead return 0.14
                var decimalCount = (0, $f0b28568f0d20c36$export$d795fe2838a61f89)(delta);
                if (decimalCount) {
                    var multiplier = Math.pow(10, decimalCount);
                    step = multiplier * delta / (multiplier * $8481a9fe404a179c$var$defaultRangeSteps);
                } else step = delta / $8481a9fe404a179c$var$defaultRangeSteps;
                // Cap step to maximum 2 decimal places to avoid long
                // precision artifacts
                var stepMultiplier = Math.pow(10, 2);
                step = Math.round(step * stepMultiplier) / stepMultiplier;
                // Ensure step is never 0 or negative (required for RangeSelector)
                if (step <= 0) step = Math.pow(10, -(Math.max((0, $f0b28568f0d20c36$export$d795fe2838a61f89)(range[0]), (0, $f0b28568f0d20c36$export$d795fe2838a61f89)(range[1])) || 1));
            }
            content = /*#__PURE__*/ $8481a9fe404a179c$var$_react["default"].createElement($1efe7f9a2f6260b6$export$1081d70813d107d1, $8481a9fe404a179c$var$_extends({
                "aria-label": ariaLabel,
                id: id,
                name: property + "._range",
                defaultValues: range,
                label: true,
                min: range[0],
                max: range[1],
                step: step
            }, (_theme$dataFilter = theme.dataFilter) == null ? void 0 : _theme$dataFilter.rangeSelector));
        } else if (options) {
            if (options.length === 2 && options[1] === true && options[0] === false) // special case boolean properties
            content = /*#__PURE__*/ $8481a9fe404a179c$var$_react["default"].createElement($d26ee9a4af4863b0$export$b6a68782c21a95ce, {
                "aria-label": ariaLabel,
                id: id,
                name: property,
                options: $8481a9fe404a179c$var$booleanOptions
            });
            else if (options.length <= $8481a9fe404a179c$var$maxCheckBoxGroupOptions) content = /*#__PURE__*/ $8481a9fe404a179c$var$_react["default"].createElement($d26ee9a4af4863b0$export$b6a68782c21a95ce, {
                "aria-label": ariaLabel,
                id: id,
                name: property,
                options: options
            });
            else {
                var _theme$dataFilter2;
                content = /*#__PURE__*/ $8481a9fe404a179c$var$_react["default"].createElement($2b7901c119e4bd86$export$12a18ac91a0d2aeb, $8481a9fe404a179c$var$_extends({
                    "aria-label": ariaLabel,
                    id: id,
                    name: property,
                    showSelectedInline: true,
                    options: searchedOptions,
                    onSearch: options.length >= $8481a9fe404a179c$var$minSelectSearchOptions ? setSearchText : undefined,
                    onClose: function onClose() {
                        return setSearchText('');
                    },
                    labelKey: "label",
                    valueKey: {
                        key: 'value',
                        reduce: true
                    }
                }, (_theme$dataFilter2 = theme.dataFilter) == null ? void 0 : _theme$dataFilter2.selectMultiple));
                htmlFor = (0, $a1aed72b35405d54$export$abfa4f6a3fb2b741)(id);
            }
        }
    }
    if (!content) return null;
    if (!inDataForm) // likely in Toolbar
    content = /*#__PURE__*/ $8481a9fe404a179c$var$_react["default"].createElement($46eb34c25d0c5f74$export$dcf38ffba6c01577, {
        footer: false,
        updateOn: "change"
    }, content);
    else content = /*#__PURE__*/ $8481a9fe404a179c$var$_react["default"].createElement($af5ba9f7873798c6$export$56e87bf42978147a, $8481a9fe404a179c$var$_extends({
        htmlFor: htmlFor,
        name: property,
        label: (properties == null || (_properties$property5 = properties[property]) == null ? void 0 : _properties$property5.label) || property
    }, rest), content);
    return content;
};
$8481a9fe404a179c$var$DataFilter.propTypes = $9ec3711a4a72b5cc$export$f6c44db1bdce73bb;


$b001492d8dcf4f6c$export$bf2cd9c1afd10b96 = $8481a9fe404a179c$export$bf2cd9c1afd10b96;






var $e03e15968966d631$exports = {};

$parcel$export($e03e15968966d631$exports, "__esModule", function () { return $e03e15968966d631$export$1e511d4a378977f5; }, function (v) { return $e03e15968966d631$export$1e511d4a378977f5 = v; });
$parcel$export($e03e15968966d631$exports, "Layer", function () { return $e03e15968966d631$export$936d0764594b6eb3; }, function (v) { return $e03e15968966d631$export$936d0764594b6eb3 = v; });
var $e03e15968966d631$export$1e511d4a378977f5;
var $e03e15968966d631$export$936d0764594b6eb3;
"use strict";
$e03e15968966d631$export$1e511d4a378977f5 = true;
$e03e15968966d631$export$936d0764594b6eb3 = void 0;
var $403e73b79eeb542b$export$1e511d4a378977f5;
var $403e73b79eeb542b$export$936d0764594b6eb3;
"use strict";
$403e73b79eeb542b$export$1e511d4a378977f5 = true;
$403e73b79eeb542b$export$936d0764594b6eb3 = void 0;

var $403e73b79eeb542b$var$_react = $403e73b79eeb542b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $cX5wj = parcelRequire("cX5wj");


var $c170271603ec9591$export$1e511d4a378977f5;
var $c170271603ec9591$export$802ffc1493ab0ff7;
"use strict";
$c170271603ec9591$export$1e511d4a378977f5 = true;
$c170271603ec9591$export$802ffc1493ab0ff7 = void 0;

var $c170271603ec9591$var$_react = $c170271603ec9591$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $c170271603ec9591$var$_styledComponents = $c170271603ec9591$var$_interopRequireWildcard((parcelRequire("iA1nz")));







var $555bced8be9ee38a$export$1e511d4a378977f5;
var $555bced8be9ee38a$export$82f5c257a11c5515;
var $555bced8be9ee38a$export$47f426cc93e497b4;
var $555bced8be9ee38a$export$465e4e6abe6afeb6;
var $555bced8be9ee38a$export$1d41361302b577a1;
"use strict";
$555bced8be9ee38a$export$1e511d4a378977f5 = true;
$555bced8be9ee38a$export$82f5c257a11c5515 = $555bced8be9ee38a$export$47f426cc93e497b4 = $555bced8be9ee38a$export$465e4e6abe6afeb6 = $555bced8be9ee38a$export$1d41361302b577a1 = void 0;

var $555bced8be9ee38a$var$_styledComponents = $555bced8be9ee38a$var$_interopRequireWildcard((parcelRequire("iA1nz")));

var $555bced8be9ee38a$var$_isPropValid = $555bced8be9ee38a$var$_interopRequireDefault((parcelRequire("8Fliv")));

function $555bced8be9ee38a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $555bced8be9ee38a$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($555bced8be9ee38a$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $555bced8be9ee38a$var$hiddenPositionStyle = (0, $555bced8be9ee38a$var$_styledComponents.css)([
    "left:-100%;right:100%;z-index:-1;position:fixed;"
]);
var $555bced8be9ee38a$var$desktopLayerStyle = "\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n";
var $555bced8be9ee38a$var$responsiveLayerStyle = "\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  min-height: 100vh;\n";
var $555bced8be9ee38a$var$StyledLayer = $555bced8be9ee38a$export$465e4e6abe6afeb6 = $555bced8be9ee38a$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledLayer",
    componentId: "sc-rmtehz-0"
})([
    "",
    " background:transparent;position:relative;z-index:",
    ";pointer-events:none;outline:none;",
    " ",
    ";"
], $4113023f9e0bafa0$exports.baseStyle, function(props) {
    return props.theme.layer.zIndex;
}, function(props) {
    if (props.position === 'hidden') return $555bced8be9ee38a$var$hiddenPositionStyle;
    var styles = [];
    styles.push($555bced8be9ee38a$var$desktopLayerStyle);
    if (props.responsive && props.theme.layer.responsiveBreakpoint && !props.layerTarget) {
        var breakpoint = props.theme.global.breakpoints[props.theme.layer.responsiveBreakpoint];
        styles.push((0, $4113023f9e0bafa0$exports.breakpointStyle)(breakpoint, $555bced8be9ee38a$var$responsiveLayerStyle));
    }
    return styles;
}, function(props) {
    return props.theme.layer && props.theme.layer.extend;
});
var $555bced8be9ee38a$var$StyledOverlay = $555bced8be9ee38a$export$47f426cc93e497b4 = $555bced8be9ee38a$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledLayer__StyledOverlay",
    componentId: "sc-rmtehz-1"
})([
    "position:absolute;",
    " top:0px;left:0px;right:0px;bottom:0px;",
    " ",
    " pointer-events:all;will-change:transform;"
], function(props) {
    if (props.responsive && props.theme.layer.responsiveBreakpoint) {
        var breakpoint = props.theme.global.breakpoints[props.theme.layer.responsiveBreakpoint];
        return (0, $4113023f9e0bafa0$exports.breakpointStyle)(breakpoint, 'position: relative;');
    }
    return '';
}, function(props) {
    return props.theme.layer.overlay.backdropFilter && "backdrop-filter: " + props.theme.layer.overlay.backdropFilter + ";";
}, function(props) {
    return !props.plain && props.theme.layer.overlay.background && (0, $4113023f9e0bafa0$exports.backgroundStyle)(props.theme.layer.overlay.background, props.theme);
});
var $555bced8be9ee38a$var$getMargin = function getMargin(margin, theme, position) {
    var axis = position.indexOf('top') !== -1 || position.indexOf('bottom') !== -1 ? 'vertical' : 'horizontal';
    var marginValue = margin[position] || margin[axis] || margin;
    var marginApplied = theme.global.edgeSize[marginValue] || marginValue;
    var marginInTheme = !!theme.global.edgeSize[marginValue];
    return !marginInTheme && typeof marginValue !== 'string' ? 0 : (0, $4113023f9e0bafa0$exports.parseMetricToNum)(marginApplied);
};
var $555bced8be9ee38a$var$getBounds = function getBounds(bounds, margin, theme, position) {
    if (position === void 0) position = undefined;
    if (position) return bounds[position] + $555bced8be9ee38a$var$getMargin(margin, theme, position);
    return {
        bottom: bounds.bottom + $555bced8be9ee38a$var$getMargin(margin, theme, 'bottom'),
        // 'bottom-left': getMargin(margin, theme, 'bottom-left'),
        // 'bottom-right': getMargin(margin, theme, 'bottom-right'),
        end: bounds.right + $555bced8be9ee38a$var$getMargin(margin, theme, 'end'),
        left: bounds.left + $555bced8be9ee38a$var$getMargin(margin, theme, 'left'),
        right: bounds.right + $555bced8be9ee38a$var$getMargin(margin, theme, 'right'),
        start: bounds.left + $555bced8be9ee38a$var$getMargin(margin, theme, 'start'),
        top: bounds.top + $555bced8be9ee38a$var$getMargin(margin, theme, 'top')
    };
};
var $555bced8be9ee38a$var$KEYFRAMES = {
    center: {
        vertical: (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translateX(-50%) scale(0.8);}100%{transform:translateX(-50%) scale(1);}"
        ]),
        horizontal: (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translateY(-50%) scale(0.8);}100%{transform:translateY(-50) scale(1);}"
        ]),
        "true": (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:scale(0.8);}100%{transform:scale(1);}"
        ]),
        "false": (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translate(-50%,-50%) scale(0.8);}100%{transform:translate(-50%,-50%) scale(1);}"
        ])
    },
    top: {
        vertical: (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translate(-50%,-100%);}100%{transform:translate(-50%,0);}"
        ]),
        horizontal: (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translateY(-100%);}100%{transform:translateY(0);}"
        ]),
        "true": (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translateY(-100%);}100%{transform:translateY(0);}"
        ]),
        "false": (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translate(-50%,-100%);}100%{transform:translate(-50%,0);}"
        ])
    },
    bottom: {
        vertical: (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translate(-50%,100%);}100%{transform:translate(-50%,0);}"
        ]),
        horizontal: (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translateY(100%);}100%{transform:translateY(0);}"
        ]),
        "true": (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translateY(100%);}100%{transform:translateY(0);}"
        ]),
        "false": (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translate(-50%,100%);}100%{transform:translate(-50%,0);}"
        ])
    },
    left: {
        vertical: (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translateX(-100%);}100%{transform:translateX(0);}"
        ]),
        horizontal: (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translate(-100%,-50%);}100%{transform:translate(0,-50%);}"
        ]),
        "true": (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translateX(-100%);}100%{transform:translateX(0);}"
        ]),
        "false": (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translate(-100%,-50%);}100%{transform:translate(0,-50%);}"
        ])
    },
    right: {
        vertical: (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translateX(100%);}100%{transform:translateX(0);}"
        ]),
        horizontal: (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translate(100%,-50%);}100%{transform:translate(0,-50%);}"
        ]),
        "true": (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translateX(100%);}100%{transform:translateX(0);}"
        ]),
        "false": (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translate(100%,-50%);}100%{transform:translate(0,-50%);}"
        ])
    },
    start: {
        vertical: (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translateX(-100%);}100%{transform:translateX(0);}"
        ]),
        horizontal: (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translate(-100%,-50%);}100%{transform:translate(0,-50%);}"
        ]),
        "true": (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translateX(-100%);}100%{transform:translateX(0);}"
        ]),
        "false": (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translate(-100%,-50%);}100%{transform:translate(0,-50%);}"
        ])
    },
    end: {
        vertical: (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translateX(100%);}100%{transform:translateX(0);}"
        ]),
        horizontal: (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translate(100%,-50%);}100%{transform:translate(0,-50%);}"
        ]),
        "true": (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translateX(100%);}100%{transform:translateX(0);}"
        ]),
        "false": (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
            "0%{transform:translate(100%,-50%);}100%{transform:translate(0,-50%);}"
        ])
    }
};
var $555bced8be9ee38a$var$animationDuration = $555bced8be9ee38a$export$82f5c257a11c5515 = 200;
var $555bced8be9ee38a$var$getAnimationStyle = function getAnimationStyle(props, position, full) {
    var animation = props.animation !== undefined ? props.animation : props.animate;
    if (animation === undefined) animation = 'slide';
    var keys;
    if (animation === 'slide' || animation === true) keys = $555bced8be9ee38a$var$KEYFRAMES[position][full];
    else if (animation === 'fadeIn') keys = (0, $555bced8be9ee38a$var$_styledComponents.keyframes)([
        "0%{opacity:0}100%{opacity:1}"
    ]);
    return keys ? (0, $555bced8be9ee38a$var$_styledComponents.css)([
        "animation:",
        " ",
        "s ease-in-out forwards;"
    ], keys, $555bced8be9ee38a$var$animationDuration / 1000.0) : '';
};
// POSITIONS combines 'position', 'full', and 'margin' properties, since
// they are all interdependent.
// Basically, non-full axes combine 50% position with -50% translation.
// full axes pin to the window edges offset by any margin.
// The keyframe animations are included as they are done via translations
// as well so they must take into account the non-animated positioning.
var $555bced8be9ee38a$var$POSITIONS = {
    center: {
        vertical: function vertical(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:50%;transform:translateX(-50%);",
                ""
            ], bounds.top, bounds.bottom, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'center', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "left:",
                "px;right:",
                "px;top:50%;transform:translateY(-50%);",
                ""
            ], bounds.left, bounds.right, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'center', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'center', 'true');
            });
        },
        "false": function _false() {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:50%;left:50%;transform:translate(-50%,-50%);",
                ""
            ], function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'center', 'false');
            });
        }
    },
    top: {
        vertical: function vertical(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:50%;transform:translate(-50%,0%);",
                ""
            ], bounds.top, bounds.bottom, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'top', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "left:",
                "px;right:",
                "px;top:",
                "px;transform:translateY(0);",
                ""
            ], bounds.left, bounds.right, bounds.top, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'top', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateY(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'top', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;left:50%;transform:translate(-50%,0);",
                ""
            ], bounds.top, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'top', 'false');
            });
        }
    },
    bottom: {
        vertical: function vertical(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:50%;transform:translate(-50%,0);",
                ""
            ], bounds.top, bounds.bottom, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'bottom', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "left:",
                "px;right:",
                "px;bottom:",
                "px;transform:translateY(0);",
                ""
            ], bounds.left, bounds.top, bounds.bottom, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'bottom', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateY(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'bottom', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "bottom:",
                "px;left:50%;transform:translate(-50%,0);",
                ""
            ], bounds.bottom, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'bottom', 'false');
            });
        }
    },
    left: {
        vertical: function vertical(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'left', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "left:",
                "px;right:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.left, bounds.right, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'left', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'left', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "left:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.left, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'left', 'false');
            });
        }
    },
    right: {
        vertical: function vertical(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.right, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'right', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "left:",
                "px;right:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.left, bounds.right, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'right', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'right', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "right:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.right, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'right', 'false');
            });
        }
    },
    start: {
        vertical: function vertical(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;inset-inline-start:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.start, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'start', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "inset-inline-start:",
                "px;inset-inline-end:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.start, bounds.end, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'start', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;inset-inline-start:",
                "px;inset-inline-end:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.start, bounds.end, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'start', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "inset-inline-start:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.start, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'start', 'false');
            });
        }
    },
    end: {
        vertical: function vertical(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;inset-inline-end:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.end, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'end', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "inset-inline-start:",
                "px;inset-inline-end:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.start, bounds.end, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'end', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;inset-inline-start:",
                "px;inset-inline-end:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.start, bounds.end, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'end', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "inset-inline-end:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.end, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'end', 'false');
            });
        }
    },
    'top-right': {
        vertical: function vertical(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;right:",
                "px;transform:translateX(0);",
                ";"
            ], bounds.top, bounds.bottom, bounds.right, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'top', 'true');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "left:",
                "px;right:",
                "px;top:0;transform:translateX(0);",
                ";"
            ], bounds.left, bounds.right, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'top', 'true');
            });
        },
        "true": function _true(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ";"
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'top', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;right:",
                "px;transform:translateY(0);",
                ";"
            ], bounds.top, bounds.right, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'top', 'true');
            });
        }
    },
    'top-left': {
        vertical: function vertical(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'top', 'true');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "left:",
                "px;right:",
                "px;top:0;transform:translateX(0);",
                ""
            ], bounds.left, bounds.right, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'top', 'true');
            });
        },
        "true": function _true(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'top', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;left:",
                "px;transform:translateY(0);",
                ""
            ], bounds.top, bounds.left, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'top', 'true');
            });
        }
    },
    'bottom-right': {
        vertical: function vertical(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.right, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'bottom', 'true');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "left:",
                "px;right:",
                "px;bottom:",
                "px;transform:translateY(0);",
                ""
            ], bounds.left, bounds.right, bounds.bottom, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'bottom', 'true');
            });
        },
        "true": function _true(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'bottom', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "bottom:",
                "px;right:",
                "px;transform:translateY(0);",
                ""
            ], bounds.bottom, bounds.right, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'bottom', 'true');
            });
        }
    },
    'bottom-left': {
        vertical: function vertical(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'bottom', 'true');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "left:",
                "px;right:",
                "px;bottom:",
                "px;transform:translateY(0);",
                ""
            ], bounds.left, bounds.right, bounds.bottom, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'bottom', 'true');
            });
        },
        "true": function _true(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'bottom', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $555bced8be9ee38a$var$_styledComponents.css)([
                "bottom:",
                "px;left:",
                "px;transform:translateY(0);",
                ""
            ], bounds.bottom, bounds.left, function(props) {
                return $555bced8be9ee38a$var$getAnimationStyle(props, 'bottom', 'true');
            });
        }
    }
};
var $555bced8be9ee38a$var$roundStyle = function roundStyle(data, theme, position, margin) {
    var styles = [];
    var size = data === true ? 'medium' : data;
    // fallback to edgeSize for backwards compatibility
    var round = theme.global[theme.global.radius ? 'radius' : 'edgeSize'][size] || size;
    // if user provides CSS string such as '50px 12px', apply that always
    var customCSS = round.split(' ').length > 1;
    if (margin === 'none' && !customCSS && theme.layer.border.intelligentRounding === true) {
        if (position === 'bottom') styles.push((0, $555bced8be9ee38a$var$_styledComponents.css)([
            "border-radius:",
            " ",
            " 0 0;"
        ], round, round));
        else if (position === 'bottom-left') styles.push((0, $555bced8be9ee38a$var$_styledComponents.css)([
            "border-radius:0 ",
            " 0 0;"
        ], round));
        else if (position === 'bottom-right') styles.push((0, $555bced8be9ee38a$var$_styledComponents.css)([
            "border-radius:",
            " 0 0 0;"
        ], round));
        else if (position === 'end') // only works on Firefox, what should be fallback?
        styles.push((0, $555bced8be9ee38a$var$_styledComponents.css)([
            "border-start-start-radius:",
            ";border-end-start-radius:",
            ";"
        ], round, round));
        else if (position === 'left') styles.push((0, $555bced8be9ee38a$var$_styledComponents.css)([
            "border-radius:0 ",
            " ",
            " 0;"
        ], round, round));
        else if (position === 'right') styles.push((0, $555bced8be9ee38a$var$_styledComponents.css)([
            "border-radius:",
            " 0 0 ",
            ";"
        ], round, round));
        else if (position === 'start') // only works on Firefox, what should be fallback?
        styles.push((0, $555bced8be9ee38a$var$_styledComponents.css)([
            "border-end-end-radius:",
            ";border-start-end-radius:",
            ";"
        ], round, round));
        else if (position === 'top') styles.push((0, $555bced8be9ee38a$var$_styledComponents.css)([
            "border-radius:0 0 ",
            " ",
            ";"
        ], round, round));
        else if (position === 'top-left') styles.push((0, $555bced8be9ee38a$var$_styledComponents.css)([
            "border-radius:0 0 ",
            " 0;"
        ], round));
        else if (position === 'top-right') styles.push((0, $555bced8be9ee38a$var$_styledComponents.css)([
            "border-radius:0 0 0 ",
            ";"
        ], round));
        else // position is center, apply uniform border-radius
        styles.push((0, $555bced8be9ee38a$var$_styledComponents.css)([
            "border-radius:",
            ";"
        ], round));
    } else // if there's a margin apply uniform border-radius, or if user has supplied
    // a complex CSS string such as "50px 20px" apply this
    styles.push((0, $555bced8be9ee38a$var$_styledComponents.css)([
        "border-radius:",
        ";"
    ], round));
    return styles;
};
var $555bced8be9ee38a$var$bounds = {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
};
var $555bced8be9ee38a$var$desktopContainerStyle = (0, $555bced8be9ee38a$var$_styledComponents.css)([
    "",
    " max-height:",
    ";max-width:",
    ";",
    ";",
    ";"
], function(props) {
    if (!props.modal && props.position === 'hidden') return $555bced8be9ee38a$var$hiddenPositionStyle;
    return (0, $555bced8be9ee38a$var$_styledComponents.css)([
        "position:",
        ";"
    ], props.modal || props.layerTarget ? 'absolute' : 'fixed');
}, function(props) {
    return "calc(100% - " + $555bced8be9ee38a$var$getBounds($555bced8be9ee38a$var$bounds, props.margin, props.theme, 'top') + "px - " + $555bced8be9ee38a$var$getBounds($555bced8be9ee38a$var$bounds, props.margin, props.theme, 'bottom') + "px)";
}, function(props) {
    return "calc(100% - " + $555bced8be9ee38a$var$getBounds($555bced8be9ee38a$var$bounds, props.margin, props.theme, 'left') + "px - " + $555bced8be9ee38a$var$getBounds($555bced8be9ee38a$var$bounds, props.margin, props.theme, 'right') + "px)";
}, function(props) {
    return props.plain || props.full && props.margin === 'none' ? "border-radius: 0;" : $555bced8be9ee38a$var$roundStyle(props.theme.layer.border.radius, props.theme, props.position, props.margin);
}, function(props) {
    return props.position !== 'hidden' && $555bced8be9ee38a$var$POSITIONS[props.position][props.full]($555bced8be9ee38a$var$getBounds($555bced8be9ee38a$var$bounds, props.margin, props.theme), $555bced8be9ee38a$var$bounds) || '';
});
var $555bced8be9ee38a$var$responsiveContainerStyle = function responsiveContainerStyle(props) {
    return (0, $555bced8be9ee38a$var$_styledComponents.css)([
        "position:relative;max-height:none;max-width:none;border-radius:0;height:",
        ";width:",
        ";"
    ], !props.layerTarget ? '100vh' : '100%', !props.layerTarget ? '100vw' : '100%');
};
var $555bced8be9ee38a$var$elevationStyle = (0, $555bced8be9ee38a$var$_styledComponents.css)([
    "box-shadow:",
    ";"
], function(props) {
    return props.theme.global.elevation[props.theme.dark ? 'dark' : 'light'][props.theme.layer.container.elevation];
});
var $555bced8be9ee38a$var$StyledContainer = $555bced8be9ee38a$export$1d41361302b577a1 = $555bced8be9ee38a$var$_styledComponents["default"].div.withConfig({
    shouldForwardProp: function shouldForwardProp(prop) {
        return (0, $555bced8be9ee38a$var$_isPropValid["default"])(prop) && ![
            'elevation'
        ].includes(prop);
    }
}).withConfig({
    displayName: "StyledLayer__StyledContainer",
    componentId: "sc-rmtehz-2"
})([
    "",
    " display:flex;flex-direction:column;",
    " ",
    " outline:none;pointer-events:all;z-index:",
    ";",
    " ",
    " ",
    ";",
    ";"
], function(props) {
    return !props.modal ? $4113023f9e0bafa0$exports.baseStyle : '';
}, function(props) {
    return (0, $4113023f9e0bafa0$exports.heightStyle)(props.theme.layer.container.height, props.theme);
}, function(props) {
    return !props.plain && (props.background || props.theme.layer.background) && (0, $4113023f9e0bafa0$exports.backgroundStyle)(props.background || props.theme.layer.background, props.theme);
}, function(props) {
    return props.theme.layer.container.zIndex;
}, function(props) {
    return !props.plain && props.theme.layer.container.elevation && $555bced8be9ee38a$var$elevationStyle;
}, $555bced8be9ee38a$var$desktopContainerStyle, function(props) {
    if (props.responsive && props.theme.layer.responsiveBreakpoint) {
        var breakpoint = props.theme.global.breakpoints[props.theme.layer.responsiveBreakpoint];
        if (breakpoint) return (0, $4113023f9e0bafa0$exports.breakpointStyle)(breakpoint, $555bced8be9ee38a$var$responsiveContainerStyle);
    }
    return '';
}, function(props) {
    return props.theme.layer.container && props.theme.layer.container.extend;
});



var $c170271603ec9591$var$_excluded = [
    "background",
    "children",
    "full",
    "id",
    "margin",
    "modal",
    "onClickOutside",
    "onEsc",
    "plain",
    "position",
    "responsive",
    "target"
];
function $c170271603ec9591$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($c170271603ec9591$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $c170271603ec9591$var$_extends() {
    return $c170271603ec9591$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c170271603ec9591$var$_extends.apply(null, arguments);
}
function $c170271603ec9591$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// The FocusSpan ensures the LayerContainer has focus when
// it is opened for user to start tabbing inside it.
// It helps for escaping the LayerContainer using the keyboard.
// It is hidden visually but still part of the accessibility tree.
var $c170271603ec9591$var$FocusSpan = $c170271603ec9591$var$_styledComponents["default"].span.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "LayerContainer__FocusSpan",
    componentId: "sc-1srj14c-0"
})([
    "width:0;height:0;overflow:hidden;position:absolute;clip-path:inset(50%);white-space:nowrap;border:0;&:focus{outline:none;}"
]);
var $c170271603ec9591$var$LayerContainer = $c170271603ec9591$export$802ffc1493ab0ff7 = /*#__PURE__*/ (0, $c170271603ec9591$var$_react.forwardRef)(function(_ref, ref) {
    var background = _ref.background, children = _ref.children, _ref$full = _ref.full, full = _ref$full === void 0 ? false : _ref$full, id = _ref.id, _ref$margin = _ref.margin, margin = _ref$margin === void 0 ? 'none' : _ref$margin, modal = _ref.modal, onClickOutside = _ref.onClickOutside, onEsc = _ref.onEsc, plain = _ref.plain, _ref$position = _ref.position, position = _ref$position === void 0 ? 'center' : _ref$position, _ref$responsive = _ref.responsive, responsive = _ref$responsive === void 0 ? true : _ref$responsive, layerTarget = _ref.target, rest = $c170271603ec9591$var$_objectWithoutPropertiesLoose(_ref, $c170271603ec9591$var$_excluded);
    var containerTarget = (0, $c170271603ec9591$var$_react.useContext)($9055da357324b5ab$export$64a849364cd772b4);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var size = (0, $c170271603ec9591$var$_react.useContext)($afb62f3be48d73fe$export$51e389dae84ec233);
    // layerOptions was created to preserve backwards compatibility but
    // should not be supported in v3
    var _useContext = (0, $c170271603ec9591$var$_react.useContext)($cddec80c12094a96$export$b709306b005c3ef), layerOptions = _useContext.layer;
    var focusSpanRef = (0, $c170271603ec9591$var$_react.useRef)();
    var containerRef = (0, $c170271603ec9591$var$_react.useRef)();
    var layerRef = (0, $c170271603ec9591$var$_react.useRef)();
    var portalContext = (0, $c170271603ec9591$var$_react.useContext)($4113023f9e0bafa0$exports.PortalContext);
    var portalId = (0, $c170271603ec9591$var$_react.useMemo)(function() {
        return portalContext.length;
    }, [
        portalContext
    ]);
    var nextPortalContext = (0, $c170271603ec9591$var$_react.useMemo)(function() {
        return [].concat(portalContext, [
            portalId
        ]);
    }, [
        portalContext,
        portalId
    ]);
    var sendAnalytics = (0, $995522def9ecf485$exports.useAnalytics)();
    (0, $c170271603ec9591$var$_react.useEffect)(function() {
        var start = new Date();
        var element = layerRef.current;
        var isHidden = position === 'hidden';
        if (!isHidden) sendAnalytics({
            type: 'layerOpen',
            element: element
        });
        return function() {
            if (!isHidden) sendAnalytics({
                type: 'layerClose',
                element: element,
                elapsed: new Date().getTime() - start.getTime()
            });
        };
    }, [
        sendAnalytics,
        layerRef,
        position
    ]);
    (0, $c170271603ec9591$var$_react.useEffect)(function() {
        if (position !== 'hidden') {
            var node = layerRef.current || containerRef.current || ref.current;
            if (node && node.scrollIntoView) node.scrollIntoView();
            // Once layer is open we make sure it has focus so that you
            // can start tabbing inside the layer. If the caller put focus
            // on an element already, we honor that. Otherwise, we put
            // the focus on the hidden span.
            var element = document.activeElement;
            while(element){
                if (element === containerRef.current) break;
                element = element.parentElement;
            }
            if (modal && !element && focusSpanRef.current) focusSpanRef.current.focus();
        }
    }, [
        modal,
        position,
        ref
    ]);
    (0, $c170271603ec9591$var$_react.useEffect)(function() {
        var onClickDocument = function onClickDocument(event) {
            // determine which portal id the target is in, if any
            var clickedPortalId = null;
            var node = event.composed && event.composedPath()[0] || event.target;
            while(clickedPortalId === null && node && node !== document && !(node instanceof ShadowRoot)){
                // check if user click occurred within the layer
                var attr = node.getAttribute('data-g-portal-id');
                if (attr !== null && attr !== '') clickedPortalId = parseInt(attr, 10);
                else node = node.parentNode;
            }
            if ((clickedPortalId === null || portalContext.indexOf(clickedPortalId) !== -1) && node !== null) // if the click occurred outside of the Layer portal, call
            // the user's onClickOutside function
            onClickOutside(event);
        };
        // if user provides an onClickOutside function, listen for mousedown event
        if (onClickOutside) document.addEventListener('mousedown', onClickDocument);
        if (layerTarget) {
            var updateBounds = function updateBounds() {
                var windowWidth = window.innerWidth;
                var windowHeight = window.innerHeight;
                var target = (0, $4113023f9e0bafa0$exports.findVisibleParent)(layerTarget);
                // affects StyledLayer
                var layer = layerRef.current;
                if (layer && target) {
                    // clear prior styling
                    layer.style.left = '';
                    layer.style.top = '';
                    layer.style.bottom = '';
                    layer.style.width = '';
                    // get bounds
                    var targetRect = target.getBoundingClientRect();
                    var layerRect = layer.getBoundingClientRect();
                    // ensure that layer moves with the target
                    layer.style.left = targetRect.left + "px";
                    layer.style.right = windowWidth - targetRect.right + "px";
                    layer.style.top = targetRect.top + "px";
                    layer.style.bottom = windowHeight - targetRect.bottom + "px";
                    layer.style.maxHeight = targetRect.height;
                    layer.style.maxWidth = Math.min(layerRect.width, windowWidth);
                }
            };
            updateBounds();
            window.addEventListener('resize', updateBounds);
            window.addEventListener('scroll', updateBounds, true);
            return function() {
                window.removeEventListener('resize', updateBounds);
                window.removeEventListener('scroll', updateBounds, true);
                if (onClickOutside) document.removeEventListener('mousedown', onClickDocument);
            };
        }
        return function() {
            if (onClickOutside) document.removeEventListener('mousedown', onClickDocument);
        };
    }, [
        containerTarget,
        layerTarget,
        onClickOutside,
        portalContext,
        portalId
    ]);
    var content = /*#__PURE__*/ $c170271603ec9591$var$_react["default"].createElement($555bced8be9ee38a$export$1d41361302b577a1, $c170271603ec9591$var$_extends({
        ref: ref || containerRef,
        background: background,
        elevation: theme.layer.container.elevation,
        id: layerOptions && layerOptions.singleId ? id + "__container" : id,
        full: full,
        margin: margin,
        modal: modal
    }, passThemeFlag, rest, {
        position: position,
        plain: plain,
        responsive: responsive,
        layerTarget: layerTarget,
        dir: theme.dir,
        "data-g-portal-id": portalId
    }), /*#__PURE__*/ $c170271603ec9591$var$_react["default"].createElement($c170271603ec9591$var$FocusSpan, {
        ref: focusSpanRef,
        tabIndex: "-1"
    }), children);
    content = /*#__PURE__*/ $c170271603ec9591$var$_react["default"].createElement($555bced8be9ee38a$export$465e4e6abe6afeb6, $c170271603ec9591$var$_extends({
        ref: layerRef,
        id: id,
        plain: plain,
        position: position,
        responsive: responsive,
        layerTarget: layerTarget,
        tabIndex: "-1",
        dir: theme.dir
    }, passThemeFlag), modal && /*#__PURE__*/ $c170271603ec9591$var$_react["default"].createElement($555bced8be9ee38a$export$47f426cc93e497b4, $c170271603ec9591$var$_extends({
        plain: plain,
        responsive: responsive,
        onMouseDown: onClickOutside
    }, passThemeFlag)), content);
    if (onEsc) content = /*#__PURE__*/ $c170271603ec9591$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onEsc: onEsc ? function(event) {
            // prevent further capturing or bubbling of event to other
            // child or parent elements
            event.stopPropagation();
            onEsc(event);
        } : undefined,
        target: modal === false ? 'document' : undefined
    }, content);
    var themeContextValue = (0, $c170271603ec9591$var$_react.useMemo)(function() {
        var dark = (0, $4113023f9e0bafa0$exports.backgroundIsDark)(theme.layer.background, theme);
        return $c170271603ec9591$var$_extends({}, theme, {
            dark: dark
        });
    }, [
        theme
    ]);
    if (theme.layer.background) {
        var dark = themeContextValue.dark;
        if (dark !== undefined && dark !== theme.dark) content = /*#__PURE__*/ $c170271603ec9591$var$_react["default"].createElement($c170271603ec9591$var$_styledComponents.ThemeContext.Provider, {
            value: themeContextValue
        }, content);
    }
    content = /*#__PURE__*/ $c170271603ec9591$var$_react["default"].createElement($4113023f9e0bafa0$exports.PortalContext.Provider, {
        value: nextPortalContext
    }, content);
    var hitResponsiveBreakpoint = responsive && size === theme.layer.responsiveBreakpoint;
    // if layer is responsive and we've hit the breakpoint,
    // the layer will be filling the viewport, so we want to
    // restrict the scroll to the layer and not allow the
    // body to scroll
    if (modal || hitResponsiveBreakpoint) content = /*#__PURE__*/ $c170271603ec9591$var$_react["default"].createElement($5b4f0795c5f45c3e$export$b0cd6833c93fb94d, {
        hidden: position === 'hidden',
        restrictScroll: !layerTarget && (modal || hitResponsiveBreakpoint) ? true : undefined,
        trapFocus: true
    }, content);
    return content;
});




var $e55421b7f433e5b7$export$1e511d4a378977f5;
var $e55421b7f433e5b7$export$413e9102c6e92d1b;
"use strict";
$e55421b7f433e5b7$export$1e511d4a378977f5 = true;
$e55421b7f433e5b7$export$413e9102c6e92d1b = void 0;

var $e55421b7f433e5b7$var$_propTypes = $e55421b7f433e5b7$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $e55421b7f433e5b7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $e55421b7f433e5b7$var$PAD_SIZES = [
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large'
];
var $e55421b7f433e5b7$var$PropType = {};
$e55421b7f433e5b7$var$PropType = {
    animate: $e55421b7f433e5b7$var$_propTypes["default"].bool,
    animation: $e55421b7f433e5b7$var$_propTypes["default"].oneOfType([
        $e55421b7f433e5b7$var$_propTypes["default"].oneOf([
            'slide',
            'fadeIn',
            'none'
        ]),
        $e55421b7f433e5b7$var$_propTypes["default"].bool
    ]),
    background: $5897bd367fbd90c1$export$aa372966d47f02af,
    full: $e55421b7f433e5b7$var$_propTypes["default"].oneOfType([
        $e55421b7f433e5b7$var$_propTypes["default"].bool,
        $e55421b7f433e5b7$var$_propTypes["default"].oneOf([
            'vertical',
            'horizontal'
        ])
    ]),
    margin: $e55421b7f433e5b7$var$_propTypes["default"].oneOfType([
        $e55421b7f433e5b7$var$_propTypes["default"].oneOf([
            'none'
        ].concat($e55421b7f433e5b7$var$PAD_SIZES)),
        $e55421b7f433e5b7$var$_propTypes["default"].shape({
            bottom: $e55421b7f433e5b7$var$_propTypes["default"].oneOfType([
                $e55421b7f433e5b7$var$_propTypes["default"].oneOf($e55421b7f433e5b7$var$PAD_SIZES),
                $e55421b7f433e5b7$var$_propTypes["default"].string
            ]),
            end: $e55421b7f433e5b7$var$_propTypes["default"].oneOfType([
                $e55421b7f433e5b7$var$_propTypes["default"].oneOf($e55421b7f433e5b7$var$PAD_SIZES),
                $e55421b7f433e5b7$var$_propTypes["default"].string
            ]),
            horizontal: $e55421b7f433e5b7$var$_propTypes["default"].oneOfType([
                $e55421b7f433e5b7$var$_propTypes["default"].oneOf($e55421b7f433e5b7$var$PAD_SIZES),
                $e55421b7f433e5b7$var$_propTypes["default"].string
            ]),
            left: $e55421b7f433e5b7$var$_propTypes["default"].oneOfType([
                $e55421b7f433e5b7$var$_propTypes["default"].oneOf($e55421b7f433e5b7$var$PAD_SIZES),
                $e55421b7f433e5b7$var$_propTypes["default"].string
            ]),
            right: $e55421b7f433e5b7$var$_propTypes["default"].oneOfType([
                $e55421b7f433e5b7$var$_propTypes["default"].oneOf($e55421b7f433e5b7$var$PAD_SIZES),
                $e55421b7f433e5b7$var$_propTypes["default"].string
            ]),
            start: $e55421b7f433e5b7$var$_propTypes["default"].oneOfType([
                $e55421b7f433e5b7$var$_propTypes["default"].oneOf($e55421b7f433e5b7$var$PAD_SIZES),
                $e55421b7f433e5b7$var$_propTypes["default"].string
            ]),
            top: $e55421b7f433e5b7$var$_propTypes["default"].oneOfType([
                $e55421b7f433e5b7$var$_propTypes["default"].oneOf($e55421b7f433e5b7$var$PAD_SIZES),
                $e55421b7f433e5b7$var$_propTypes["default"].string
            ]),
            vertical: $e55421b7f433e5b7$var$_propTypes["default"].oneOfType([
                $e55421b7f433e5b7$var$_propTypes["default"].oneOf($e55421b7f433e5b7$var$PAD_SIZES),
                $e55421b7f433e5b7$var$_propTypes["default"].string
            ])
        }),
        $e55421b7f433e5b7$var$_propTypes["default"].string
    ]),
    modal: $e55421b7f433e5b7$var$_propTypes["default"].bool,
    onClickOutside: $e55421b7f433e5b7$var$_propTypes["default"].func,
    onEsc: $e55421b7f433e5b7$var$_propTypes["default"].func,
    plain: $e55421b7f433e5b7$var$_propTypes["default"].bool,
    position: $e55421b7f433e5b7$var$_propTypes["default"].oneOf([
        'bottom',
        'bottom-left',
        'bottom-right',
        'center',
        'end',
        'hidden',
        'left',
        'right',
        'start',
        'top',
        'top-left',
        'top-right'
    ]),
    responsive: $e55421b7f433e5b7$var$_propTypes["default"].bool,
    target: $e55421b7f433e5b7$var$_propTypes["default"].object
};
var $e55421b7f433e5b7$var$LayerPropTypes = $e55421b7f433e5b7$export$413e9102c6e92d1b = $e55421b7f433e5b7$var$PropType;


function $403e73b79eeb542b$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($403e73b79eeb542b$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $403e73b79eeb542b$var$_extends() {
    return $403e73b79eeb542b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $403e73b79eeb542b$var$_extends.apply(null, arguments);
}
var $403e73b79eeb542b$var$Layer = $403e73b79eeb542b$export$936d0764594b6eb3 = /*#__PURE__*/ (0, $403e73b79eeb542b$var$_react.forwardRef)(function(props, ref) {
    var animate = props.animate, animation = props.animation, _props$modal = props.modal, modal = _props$modal === void 0 ? true : _props$modal, targetChildPosition = props.targetChildPosition;
    var _useState = (0, $403e73b79eeb542b$var$_react.useState)(), layerContainer = _useState[0], setLayerContainer = _useState[1];
    var containerTarget = (0, $403e73b79eeb542b$var$_react.useContext)($9055da357324b5ab$export$64a849364cd772b4);
    var originalFocusedElementRef = (0, $403e73b79eeb542b$var$_react.useRef)(null);
    var focusWithinLayerRef = (0, $403e73b79eeb542b$var$_react.useRef)(false);
    (0, $403e73b79eeb542b$var$_react.useEffect)(function() {
        originalFocusedElementRef.current = document.activeElement;
    }, []);
    (0, $403e73b79eeb542b$var$_react.useEffect)(function() {
        var handleFocusIn = function handleFocusIn(event) {
            if (layerContainer != null && layerContainer.contains != null && layerContainer.contains(event.target)) focusWithinLayerRef.current = true;
        };
        var handleFocusOut = function handleFocusOut(event) {
            if (layerContainer != null && layerContainer.contains != null && layerContainer.contains(event.target) && !layerContainer.contains(event.relatedTarget)) focusWithinLayerRef.current = false;
        };
        document.addEventListener('focusin', handleFocusIn);
        document.addEventListener('focusout', handleFocusOut);
        return function() {
            document.removeEventListener('focusin', handleFocusIn);
            document.removeEventListener('focusout', handleFocusOut);
        };
    }, [
        layerContainer
    ]);
    (0, $403e73b79eeb542b$var$_react.useEffect)(function() {
        return setLayerContainer((0, $4113023f9e0bafa0$exports.getNewContainer)(containerTarget, targetChildPosition));
    }, [
        containerTarget,
        targetChildPosition
    ]);
    // just a few things to clean up when the Layer is unmounted
    (0, $6a5275ec792307a1$export$e5c5a5f917a5871c)(function() {
        return function() {
            var originalFocusedElement = originalFocusedElementRef.current;
            if (originalFocusedElement) {
                // Restore focus if:
                // - modal layer (always restore), or
                // - non-modal layer that had focus when it closed
                var shouldRestoreFocus = modal || !modal && focusWithinLayerRef.current;
                if (shouldRestoreFocus && originalFocusedElement.focus) // wait for the fixed positioning to come back to normal
                // see layer styling for reference
                setTimeout(function() {
                    return originalFocusedElement.focus();
                }, 0);
                else if (originalFocusedElement.parentNode && originalFocusedElement.parentNode.focus) // required for IE11 and Edge
                originalFocusedElement.parentNode.focus();
            }
            if (layerContainer) {
                var activeAnimation = animation !== undefined ? animation : animate;
                if (activeAnimation !== false) {
                    // undefined uses 'slide' as the default
                    // animate out and remove later
                    var layerClone = layerContainer.cloneNode(true);
                    layerClone.id = 'layerClone';
                    containerTarget.appendChild(layerClone);
                    var clonedContainer = layerClone.querySelector('[class*="StyledLayer__StyledContainer"]');
                    if (clonedContainer && clonedContainer.style) clonedContainer.style.animationDirection = 'reverse';
                    setTimeout(function() {
                        // we add the id and query here so the unit tests work
                        var rootNode = containerTarget.getRootNode();
                        // Not all root nodes (ShadowRoot, DocumentFragment)
                        //  have getElementById.
                        if (rootNode && typeof rootNode.getElementById === 'function') {
                            var clone = rootNode.getElementById('layerClone');
                            if (clone) {
                                if (containerTarget.contains(clone)) containerTarget.removeChild(clone);
                                layerContainer.remove();
                            }
                        }
                    }, $555bced8be9ee38a$export$82f5c257a11c5515);
                } else if (containerTarget.contains(layerContainer)) containerTarget.removeChild(layerContainer);
            }
        };
    }, [
        animate,
        animation,
        containerTarget,
        layerContainer,
        modal
    ]);
    return layerContainer ? /*#__PURE__*/ (0, $cX5wj.createPortal)(/*#__PURE__*/ $403e73b79eeb542b$var$_react["default"].createElement($c170271603ec9591$export$802ffc1493ab0ff7, $403e73b79eeb542b$var$_extends({
        ref: ref
    }, props, {
        modal: modal
    })), layerContainer) : null;
});
$403e73b79eeb542b$var$Layer.displayName = 'Layer';
$403e73b79eeb542b$var$Layer.propTypes = $e55421b7f433e5b7$export$413e9102c6e92d1b;


$e03e15968966d631$export$936d0764594b6eb3 = $403e73b79eeb542b$export$936d0764594b6eb3;




var $5ecb194a2ace6700$export$1e511d4a378977f5;
var $5ecb194a2ace6700$export$9b65cbdc185d7492;
"use strict";
$5ecb194a2ace6700$export$1e511d4a378977f5 = true;
$5ecb194a2ace6700$export$9b65cbdc185d7492 = void 0;

var $5ecb194a2ace6700$var$_propTypes = $5ecb194a2ace6700$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $5ecb194a2ace6700$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $5ecb194a2ace6700$var$PropType = {};
$5ecb194a2ace6700$var$PropType = {
    clearFilters: $5ecb194a2ace6700$var$_propTypes["default"].bool,
    drop: $5ecb194a2ace6700$var$_propTypes["default"].bool,
    heading: $5ecb194a2ace6700$var$_propTypes["default"].string,
    layer: $5ecb194a2ace6700$var$_propTypes["default"].bool,
    updateOn: $5ecb194a2ace6700$var$_propTypes["default"].oneOf([
        'change',
        'submit'
    ])
};
var $5ecb194a2ace6700$var$DataFiltersPropTypes = $5ecb194a2ace6700$export$9b65cbdc185d7492 = $5ecb194a2ace6700$var$PropType;



var $ce0209180cc90fd1$var$_excluded = [
    "drop",
    "children",
    "clearFilters",
    "heading",
    "layer",
    "updateOn"
];
function $ce0209180cc90fd1$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($ce0209180cc90fd1$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $ce0209180cc90fd1$var$_extends() {
    return $ce0209180cc90fd1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ce0209180cc90fd1$var$_extends.apply(null, arguments);
}
function $ce0209180cc90fd1$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $ce0209180cc90fd1$var$dropProps = {
    align: {
        top: 'bottom',
        right: 'right'
    }
};
var $ce0209180cc90fd1$var$layerProps = {
    full: 'vertical',
    position: 'right'
};
var $ce0209180cc90fd1$var$defaultTouched = {};
var $ce0209180cc90fd1$var$DataFilters = $ce0209180cc90fd1$export$32443de3cfb88b3c = function DataFilters(_ref) {
    var _theme$dataFilters, _theme$dataFilters$ic, _theme$dataFilters2, _theme$dataFilters3, _theme$dataFilters4;
    var drop = _ref.drop, children = _ref.children, _ref$clearFilters = _ref.clearFilters, clearFilters = _ref$clearFilters === void 0 ? true : _ref$clearFilters, heading = _ref.heading, layer = _ref.layer, updateOn = _ref.updateOn, rest = $ce0209180cc90fd1$var$_objectWithoutPropertiesLoose(_ref, $ce0209180cc90fd1$var$_excluded);
    var _useContext = (0, $ce0209180cc90fd1$var$_react.useContext)($932597a497e37de0$export$58d75f9829cbe158), dataId = _useContext.id, messages = _useContext.messages, properties = _useContext.properties, unfilteredData = _useContext.unfilteredData, filtersCleared = _useContext.filtersCleared, setFiltersCleared = _useContext.setFiltersCleared, view = _useContext.view;
    var _useContext2 = (0, $ce0209180cc90fd1$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext2.format;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useState = (0, $ce0209180cc90fd1$var$_react.useState)(), showContent = _useState[0], setShowContent = _useState[1];
    // touched is a map of property to its value based on if user interacts
    // with a filter or a view applies of set of filters
    var _useState2 = (0, $ce0209180cc90fd1$var$_react.useState)($ce0209180cc90fd1$var$defaultTouched), touched = _useState2[0], setTouched = _useState2[1];
    var CloseIcon = ((_theme$dataFilters = theme.dataFilters) == null || (_theme$dataFilters = _theme$dataFilters.icons) == null ? void 0 : _theme$dataFilters.close) || $465d22e15ca8d0c4$export$f39c2d165cd861fe;
    var FilterIcon = ((_theme$dataFilters$ic = theme.dataFilters.icons) == null ? void 0 : _theme$dataFilters$ic.filter) || $77fad0572c6e1b7e$export$ec91da630f36d5ea;
    // if filters have been applied by this DataFilters, update
    // the DataContext that filters are not in a "cleared" state
    (0, $ce0209180cc90fd1$var$_react.useEffect)(function() {
        setFiltersCleared(!Object.keys(touched).length);
    }, [
        touched,
        setFiltersCleared
    ]);
    // if filters have been cleared via clearFilters in DataContext,
    // reset touched to default state so badge is removed
    (0, $ce0209180cc90fd1$var$_react.useEffect)(function() {
        if (filtersCleared) setTouched($ce0209180cc90fd1$var$defaultTouched);
    }, [
        filtersCleared
    ]);
    var controlled = (0, $ce0209180cc90fd1$var$_react.useMemo)(function() {
        return drop || layer;
    }, [
        drop,
        layer
    ]);
    var configured = $ce0209180cc90fd1$var$_react.Children.count(children) === 0;
    (0, $ce0209180cc90fd1$var$_react.useEffect)(function() {
        // when view changes via DataView or user interacting with filters,
        // adjust badge to reflect that
        if (controlled && view.properties) {
            var nextTouched = $ce0209180cc90fd1$var$_extends({}, view.properties);
            Object.keys(nextTouched).forEach(function(k) {
                var _properties$k;
                if ((properties == null || (_properties$k = properties[k]) == null ? void 0 : _properties$k.badge) === false || configured && properties && !(properties != null && properties[k])) delete nextTouched[k];
            });
            setTouched(nextTouched);
        }
    }, [
        configured,
        controlled,
        properties,
        view
    ]);
    // generate the badge value based on touched fields that have a value.
    // only show the badge based off of what's included in this DataFilters
    // since multiple DataFilters may exist
    var badge = (0, $ce0209180cc90fd1$var$_react.useMemo)(function() {
        return controlled && Object.keys(touched).filter(function(k) {
            return touched[k];
        }).length || undefined;
    }, [
        controlled,
        touched
    ]);
    var clearControl = badge && clearFilters && /*#__PURE__*/ $ce0209180cc90fd1$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        flex: false,
        margin: (_theme$dataFilters2 = theme.dataFilters) == null || (_theme$dataFilters2 = _theme$dataFilters2.clearControl) == null ? void 0 : _theme$dataFilters2.margin
    }, /*#__PURE__*/ $ce0209180cc90fd1$var$_react["default"].createElement($70cc0737328cfe1c$export$1129e998938c6510, null));
    var content = children;
    if ($ce0209180cc90fd1$var$_react.Children.count(children) === 0) {
        var filtersFor;
        if (!properties && unfilteredData && unfilteredData.length) // build from a piece of data, ignore object values
        filtersFor = Object.keys(unfilteredData[0]).filter(function(k) {
            return typeof unfilteredData[0][k] !== 'object';
        });
        else if (Array.isArray(properties)) filtersFor = properties;
        else if (typeof properties === 'object') filtersFor = Object.keys(properties).filter(function(property) {
            var _properties$property;
            return !(((_properties$property = properties[property]) == null ? void 0 : _properties$property.filter) === false);
        });
        else filtersFor = [];
        content = filtersFor.map(function(property) {
            return /*#__PURE__*/ $ce0209180cc90fd1$var$_react["default"].createElement($b001492d8dcf4f6c$export$bf2cd9c1afd10b96, {
                key: property,
                property: property
            });
        });
    }
    content = /*#__PURE__*/ $ce0209180cc90fd1$var$_react["default"].createElement($46eb34c25d0c5f74$export$dcf38ffba6c01577, $ce0209180cc90fd1$var$_extends({
        pad: controlled ? (_theme$dataFilters3 = theme.dataFilters) == null ? void 0 : _theme$dataFilters3.pad : undefined,
        onDone: function onDone() {
            return setShowContent(false);
        },
        updateOn: updateOn
    }, !controlled ? rest : {
        fill: 'vertical'
    }), layer && /*#__PURE__*/ $ce0209180cc90fd1$var$_react["default"].createElement($30d6151480c557a9$export$8b251419efc915eb, null, /*#__PURE__*/ $ce0209180cc90fd1$var$_react["default"].createElement($2d67f2629ee502eb$export$a8a3e93435678ff9, {
        margin: "none",
        level: 2
    }, heading || format({
        id: 'dataFilters.heading',
        messages: messages == null ? void 0 : messages.dataFilters
    })), !controlled && clearControl, /*#__PURE__*/ $ce0209180cc90fd1$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
        icon: /*#__PURE__*/ $ce0209180cc90fd1$var$_react["default"].createElement(CloseIcon, null),
        onClick: function onClick() {
            return setShowContent(undefined);
        }
    })), content);
    if (!controlled) return content;
    var tip = format({
        id: badge ? "dataFilters.openSet." + (badge === 1 ? 'singular' : 'plural') : 'dataFilters.open',
        messages: messages == null ? void 0 : messages.dataFilters,
        values: {
            number: badge
        }
    });
    var control;
    if (drop) {
        var _theme$data$button;
        control = /*#__PURE__*/ $ce0209180cc90fd1$var$_react["default"].createElement($d7e2a556593dc38b$export$64fff40e709e8b2e, {
            id: dataId + "--filters-control",
            tip: tip,
            "aria-label": tip,
            kind: (_theme$data$button = theme.data.button) == null ? void 0 : _theme$data$button.kind,
            icon: /*#__PURE__*/ $ce0209180cc90fd1$var$_react["default"].createElement(FilterIcon, null),
            dropProps: $ce0209180cc90fd1$var$dropProps,
            dropContent: content,
            badge: badge,
            open: showContent,
            onOpen: function onOpen() {
                return setShowContent(undefined);
            },
            onClose: function onClose() {
                return setShowContent(undefined);
            }
        });
    } else if (layer) {
        var _theme$data$button2;
        control = /*#__PURE__*/ $ce0209180cc90fd1$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
            id: dataId + "--filters-control",
            tip: tip,
            "aria-label": tip,
            kind: (_theme$data$button2 = theme.data.button) == null ? void 0 : _theme$data$button2.kind,
            icon: /*#__PURE__*/ $ce0209180cc90fd1$var$_react["default"].createElement(FilterIcon, null),
            badge: badge,
            onClick: function onClick() {
                return setShowContent(true);
            }
        });
    }
    return /*#__PURE__*/ $ce0209180cc90fd1$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $ce0209180cc90fd1$var$_extends({
        flex: false,
        direction: "row"
    }, rest), control, clearControl, layer && showContent && /*#__PURE__*/ $ce0209180cc90fd1$var$_react["default"].createElement($e03e15968966d631$export$936d0764594b6eb3, $ce0209180cc90fd1$var$_extends({
        id: dataId + "--filters-layer"
    }, typeof layer === 'object' ? layer : $ce0209180cc90fd1$var$layerProps, {
        onClickOutside: function onClickOutside() {
            return setShowContent(undefined);
        },
        onEsc: function onEsc() {
            return setShowContent(undefined);
        }
    }), /*#__PURE__*/ $ce0209180cc90fd1$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        width: (_theme$dataFilters4 = theme.dataFilters) == null ? void 0 : _theme$dataFilters4.width
    }, content)));
};
$ce0209180cc90fd1$var$DataFilters.propTypes = $5ecb194a2ace6700$export$9b65cbdc185d7492;


$3ee1846956b4e555$export$32443de3cfb88b3c = $ce0209180cc90fd1$export$32443de3cfb88b3c;


var $17143eb328c34dfb$exports = {};

$parcel$export($17143eb328c34dfb$exports, "__esModule", function () { return $17143eb328c34dfb$export$1e511d4a378977f5; }, function (v) { return $17143eb328c34dfb$export$1e511d4a378977f5 = v; });
$parcel$export($17143eb328c34dfb$exports, "DataSearch", function () { return $17143eb328c34dfb$export$20513e732c988e96; }, function (v) { return $17143eb328c34dfb$export$20513e732c988e96 = v; });
var $17143eb328c34dfb$export$1e511d4a378977f5;
var $17143eb328c34dfb$export$20513e732c988e96;
"use strict";
$17143eb328c34dfb$export$1e511d4a378977f5 = true;
$17143eb328c34dfb$export$20513e732c988e96 = void 0;
var $a055213ebaaf2737$export$1e511d4a378977f5;
var $a055213ebaaf2737$export$20513e732c988e96;
"use strict";
$a055213ebaaf2737$export$1e511d4a378977f5 = true;
$a055213ebaaf2737$export$20513e732c988e96 = void 0;

var $a055213ebaaf2737$var$_react = $a055213ebaaf2737$var$_interopRequireWildcard((parcelRequire("2xPiy")));











var $2094e06bb494a561$export$1e511d4a378977f5;
var $2094e06bb494a561$export$c4e0e0a575df7f14;
"use strict";
$2094e06bb494a561$export$1e511d4a378977f5 = true;
$2094e06bb494a561$export$c4e0e0a575df7f14 = void 0;

var $2094e06bb494a561$var$_propTypes = $2094e06bb494a561$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $2094e06bb494a561$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $2094e06bb494a561$var$PropType = {};
$2094e06bb494a561$var$PropType = {
    drop: $2094e06bb494a561$var$_propTypes["default"].bool,
    responsive: $2094e06bb494a561$var$_propTypes["default"].bool,
    updateOn: $2094e06bb494a561$var$_propTypes["default"].oneOf([
        'change',
        'submit'
    ])
};
var $2094e06bb494a561$var$DataSearchPropTypes = $2094e06bb494a561$export$c4e0e0a575df7f14 = $2094e06bb494a561$var$PropType;





var $a055213ebaaf2737$var$_excluded = [
    "drop",
    "id",
    "responsive",
    "updateOn"
];
function $a055213ebaaf2737$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($a055213ebaaf2737$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $a055213ebaaf2737$var$_extends() {
    return $a055213ebaaf2737$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a055213ebaaf2737$var$_extends.apply(null, arguments);
}
function $a055213ebaaf2737$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $a055213ebaaf2737$var$dropProps = {
    align: {
        top: 'bottom',
        left: 'left'
    }
};
// 300ms was chosen empirically as a reasonable default
var $a055213ebaaf2737$var$DEBOUNCE_TIMEOUT = 300;
var $a055213ebaaf2737$var$DataSearch = $a055213ebaaf2737$export$20513e732c988e96 = function DataSearch(_ref) {
    var _theme$dataSearch$ico, _theme$data$button, _theme$data;
    var drop = _ref.drop, idProp = _ref.id, responsive = _ref.responsive, updateOn = _ref.updateOn, rest = $a055213ebaaf2737$var$_objectWithoutPropertiesLoose(_ref, $a055213ebaaf2737$var$_excluded);
    var _useContext = (0, $a055213ebaaf2737$var$_react.useContext)($932597a497e37de0$export$58d75f9829cbe158), dataId = _useContext.id, messages = _useContext.messages, addToolbarKey = _useContext.addToolbarKey, onView = _useContext.onView, view = _useContext.view, views = _useContext.views;
    var _useContext2 = (0, $a055213ebaaf2737$var$_react.useContext)($b1a512ff039be377$export$e2b284ce8e93d8eb), inDataForm = _useContext2.inDataForm;
    var _useContext3 = (0, $a055213ebaaf2737$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext3.format;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var size = (0, $a055213ebaaf2737$var$_react.useContext)($afb62f3be48d73fe$export$51e389dae84ec233);
    var skeleton = (0, $ab65104eb6f9aa8a$exports.useSkeleton)();
    var debounce = (0, $9877d3477bf8576a$export$21805fee57372823)($a055213ebaaf2737$var$DEBOUNCE_TIMEOUT);
    var _useState = (0, $a055213ebaaf2737$var$_react.useState)(), showContent = _useState[0], setShowContent = _useState[1];
    var _useState2 = (0, $a055213ebaaf2737$var$_react.useState)(view == null ? void 0 : view.search), value = _useState2[0], setValue = _useState2[1];
    var id = idProp || dataId + "--search";
    var SearchIcon = ((_theme$dataSearch$ico = theme.dataSearch.icons) == null ? void 0 : _theme$dataSearch$ico.search) || $ac084058cd06093e$export$4b85d3515bd863a5;
    (0, $a055213ebaaf2737$var$_react.useEffect)(function() {
        if (!inDataForm) addToolbarKey('_search');
    }, [
        addToolbarKey,
        inDataForm
    ]);
    (0, $a055213ebaaf2737$var$_react.useEffect)(function() {
        return setValue(view == null ? void 0 : view.search);
    }, [
        view == null ? void 0 : view.search
    ]);
    var updateView = function updateView(e) {
        var _e$target;
        var nextView = $a055213ebaaf2737$var$_extends({}, view, {
            search: (_e$target = e.target) == null ? void 0 : _e$target.value
        });
        // If there's a named view in effect that has a search term
        // we'll clear the named view (but leave it's other filters)
        var currentView = nextView.view && (views == null ? void 0 : views.find(function(v) {
            return v.name === nextView.view;
        }));
        if (currentView != null && currentView.search) {
            delete nextView.view;
            delete nextView.name;
        }
        // If page is set, reset it to 1
        if (nextView.page) nextView.page = 1;
        onView(nextView);
    };
    var onChange = function onChange(e) {
        var _e$target2, _e$target3;
        setValue((_e$target2 = e.target) == null ? void 0 : _e$target2.value);
        // do the search if the input was cleared or update on change
        if (updateOn !== 'submit' || ((_e$target3 = e.target) == null ? void 0 : _e$target3.value) === '') debounce(function() {
            return function() {
                return updateView(e);
            };
        });
    };
    var content = skeleton ? null : /*#__PURE__*/ $a055213ebaaf2737$var$_react["default"].createElement($99c7a15bc083da62$export$c86715117507e8e5, $a055213ebaaf2737$var$_extends({
        "aria-label": format({
            id: 'dataSearch.label',
            messages: messages == null ? void 0 : messages.dataSearch
        }),
        id: id,
        name: "_search",
        icon: /*#__PURE__*/ $a055213ebaaf2737$var$_react["default"].createElement(SearchIcon, null),
        type: "search",
        value: value,
        onChange: onChange
    }, rest));
    if (updateOn === 'submit') content = /*#__PURE__*/ $a055213ebaaf2737$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onEnter: updateView
    }, content);
    if (!inDataForm) // likely in Toolbar.
    // Wrap in Box to give it a reasonable width
    content = /*#__PURE__*/ $a055213ebaaf2737$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, null, content);
    else content = /*#__PURE__*/ $a055213ebaaf2737$var$_react["default"].createElement($af5ba9f7873798c6$export$56e87bf42978147a, {
        htmlFor: id,
        label: format({
            id: 'dataSearch.label',
            messages: messages == null ? void 0 : messages.dataSearch
        })
    }, content);
    if (!drop && (!responsive || !(0, $80783f9dd7b08ab9$export$813595e92b2e7a6f)(size))) return content;
    var control = /*#__PURE__*/ $a055213ebaaf2737$var$_react["default"].createElement($d7e2a556593dc38b$export$64fff40e709e8b2e, $a055213ebaaf2737$var$_extends({
        id: dataId + "--search-control",
        "aria-label": format({
            id: 'dataSearch.open',
            messages: messages == null ? void 0 : messages.dataSort
        }),
        kind: (_theme$data$button = theme.data.button) == null ? void 0 : _theme$data$button.kind,
        icon: /*#__PURE__*/ $a055213ebaaf2737$var$_react["default"].createElement(SearchIcon, null),
        dropProps: $a055213ebaaf2737$var$dropProps,
        dropContent: /*#__PURE__*/ $a055213ebaaf2737$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            pad: (_theme$data = theme.data) == null || (_theme$data = _theme$data.drop) == null ? void 0 : _theme$data.pad
        }, content),
        open: showContent,
        onOpen: function onOpen() {
            return setShowContent(undefined);
        },
        onClose: function onClose() {
            return setShowContent(undefined);
        }
    }, rest));
    return control;
};
$a055213ebaaf2737$var$DataSearch.propTypes = $2094e06bb494a561$export$c4e0e0a575df7f14;


$17143eb328c34dfb$export$20513e732c988e96 = $a055213ebaaf2737$export$20513e732c988e96;


var $3d0ce75306f2014c$exports = {};

$parcel$export($3d0ce75306f2014c$exports, "__esModule", function () { return $3d0ce75306f2014c$export$1e511d4a378977f5; }, function (v) { return $3d0ce75306f2014c$export$1e511d4a378977f5 = v; });
$parcel$export($3d0ce75306f2014c$exports, "DataSummary", function () { return $3d0ce75306f2014c$export$fcbfa64cec0e2150; }, function (v) { return $3d0ce75306f2014c$export$fcbfa64cec0e2150 = v; });
var $3d0ce75306f2014c$export$1e511d4a378977f5;
var $3d0ce75306f2014c$export$fcbfa64cec0e2150;
"use strict";
$3d0ce75306f2014c$export$1e511d4a378977f5 = true;
$3d0ce75306f2014c$export$fcbfa64cec0e2150 = void 0;
var $ccbcce288e7d7ebc$export$1e511d4a378977f5;
var $ccbcce288e7d7ebc$export$fcbfa64cec0e2150;
"use strict";
$ccbcce288e7d7ebc$export$1e511d4a378977f5 = true;
$ccbcce288e7d7ebc$export$fcbfa64cec0e2150 = void 0;

var $ccbcce288e7d7ebc$var$_react = $ccbcce288e7d7ebc$var$_interopRequireWildcard((parcelRequire("2xPiy")));




var $65f25c947e59ee2b$export$1e511d4a378977f5;
var $65f25c947e59ee2b$export$a3199466acacee85;
"use strict";
$65f25c947e59ee2b$export$1e511d4a378977f5 = true;
$65f25c947e59ee2b$export$a3199466acacee85 = void 0;

var $65f25c947e59ee2b$var$_propTypes = $65f25c947e59ee2b$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $65f25c947e59ee2b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $65f25c947e59ee2b$var$PropType = {};
$65f25c947e59ee2b$var$PropType = {
    messages: $65f25c947e59ee2b$var$_propTypes["default"].shape({
        filtered: $65f25c947e59ee2b$var$_propTypes["default"].string,
        filteredSingle: $65f25c947e59ee2b$var$_propTypes["default"].string,
        items: $65f25c947e59ee2b$var$_propTypes["default"].string,
        itemsSingle: $65f25c947e59ee2b$var$_propTypes["default"].string,
        selected: $65f25c947e59ee2b$var$_propTypes["default"].string,
        total: $65f25c947e59ee2b$var$_propTypes["default"].string,
        totalSingle: $65f25c947e59ee2b$var$_propTypes["default"].string
    })
};
var $65f25c947e59ee2b$var$DataSummaryPropTypes = $65f25c947e59ee2b$export$a3199466acacee85 = $65f25c947e59ee2b$var$PropType;


var $ccbcce288e7d7ebc$var$_excluded = [
    "messages"
];
function $ccbcce288e7d7ebc$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($ccbcce288e7d7ebc$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $ccbcce288e7d7ebc$var$_extends() {
    return $ccbcce288e7d7ebc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ccbcce288e7d7ebc$var$_extends.apply(null, arguments);
}
function $ccbcce288e7d7ebc$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $ccbcce288e7d7ebc$var$DataSummary = $ccbcce288e7d7ebc$export$fcbfa64cec0e2150 = function DataSummary(_ref) {
    var _theme$dataSummary, _theme$dataSummary2;
    var messages = _ref.messages, rest = $ccbcce288e7d7ebc$var$_objectWithoutPropertiesLoose(_ref, $ccbcce288e7d7ebc$var$_excluded);
    var _useContext = (0, $ccbcce288e7d7ebc$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var _useContext2 = (0, $ccbcce288e7d7ebc$var$_react.useContext)($932597a497e37de0$export$58d75f9829cbe158), filteredTotal = _useContext2.filteredTotal, dataMessages = _useContext2.messages, selected = _useContext2.selected, total = _useContext2.total;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var messageId;
    if (total !== filteredTotal) {
        if (filteredTotal === 1) messageId = 'dataSummary.filteredSingle';
        else messageId = 'dataSummary.filtered';
    } else if (total === 1) messageId = 'dataSummary.totalSingle';
    else messageId = 'dataSummary.total';
    // helps account for cases like 0 results of 1 item
    var items = format({
        id: total === 1 ? 'dataSummary.itemsSingle' : 'dataSummary.items',
        messages: messages || (dataMessages == null ? void 0 : dataMessages.dataSummary)
    });
    return /*#__PURE__*/ $ccbcce288e7d7ebc$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, $ccbcce288e7d7ebc$var$_extends({
        margin: (_theme$dataSummary = theme.dataSummary) == null ? void 0 : _theme$dataSummary.margin
    }, rest), format({
        id: messageId,
        messages: messages || (dataMessages == null ? void 0 : dataMessages.dataSummary),
        values: {
            filteredTotal: filteredTotal,
            total: total,
            items: items
        }
    }), selected > 0 ? /*#__PURE__*/ $ccbcce288e7d7ebc$var$_react["default"].createElement($ccbcce288e7d7ebc$var$_react["default"].Fragment, null, /*#__PURE__*/ $ccbcce288e7d7ebc$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, {
        margin: (_theme$dataSummary2 = theme.dataSummary) == null || (_theme$dataSummary2 = _theme$dataSummary2.separator) == null ? void 0 : _theme$dataSummary2.margin
    }, "|"), /*#__PURE__*/ $ccbcce288e7d7ebc$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, null, format({
        id: 'dataSummary.selected',
        messages: messages || (dataMessages == null ? void 0 : dataMessages.dataSummary),
        values: {
            selected: selected
        }
    }))) : undefined);
};
$ccbcce288e7d7ebc$var$DataSummary.propTypes = $65f25c947e59ee2b$export$a3199466acacee85;


$3d0ce75306f2014c$export$fcbfa64cec0e2150 = $ccbcce288e7d7ebc$export$fcbfa64cec0e2150;


var $fd9964856b517b7a$exports = {};

$parcel$export($fd9964856b517b7a$exports, "__esModule", function () { return $fd9964856b517b7a$export$1e511d4a378977f5; }, function (v) { return $fd9964856b517b7a$export$1e511d4a378977f5 = v; });
$parcel$export($fd9964856b517b7a$exports, "DataView", function () { return $fd9964856b517b7a$export$5e15d737b33a1c27; }, function (v) { return $fd9964856b517b7a$export$5e15d737b33a1c27 = v; });
var $fd9964856b517b7a$export$1e511d4a378977f5;
var $fd9964856b517b7a$export$5e15d737b33a1c27;
"use strict";
$fd9964856b517b7a$export$1e511d4a378977f5 = true;
$fd9964856b517b7a$export$5e15d737b33a1c27 = void 0;
var $536620527818ee29$export$1e511d4a378977f5;
var $536620527818ee29$export$5e15d737b33a1c27;
"use strict";
$536620527818ee29$export$1e511d4a378977f5 = true;
$536620527818ee29$export$5e15d737b33a1c27 = void 0;

var $536620527818ee29$var$_react = $536620527818ee29$var$_interopRequireWildcard((parcelRequire("2xPiy")));







var $e569f5eac4e38258$export$1e511d4a378977f5;
var $e569f5eac4e38258$export$b9929fa9b7f4d505;
"use strict";
$e569f5eac4e38258$export$1e511d4a378977f5 = true;
$e569f5eac4e38258$export$b9929fa9b7f4d505 = void 0;
var $e569f5eac4e38258$var$PropType = {};
$e569f5eac4e38258$var$PropType = {};
var $e569f5eac4e38258$var$DataViewPropTypes = $e569f5eac4e38258$export$b9929fa9b7f4d505 = $e569f5eac4e38258$var$PropType;


var $536620527818ee29$var$_excluded = [
    "id"
];
function $536620527818ee29$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($536620527818ee29$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $536620527818ee29$var$_extends() {
    return $536620527818ee29$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $536620527818ee29$var$_extends.apply(null, arguments);
}
function $536620527818ee29$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $536620527818ee29$var$DataView = $536620527818ee29$export$5e15d737b33a1c27 = function DataView(_ref) {
    var idProp = _ref.id, rest = $536620527818ee29$var$_objectWithoutPropertiesLoose(_ref, $536620527818ee29$var$_excluded);
    var _useContext = (0, $536620527818ee29$var$_react.useContext)($932597a497e37de0$export$58d75f9829cbe158), dataId = _useContext.id, messages = _useContext.messages, view = _useContext.view, views = _useContext.views, addToolbarKey = _useContext.addToolbarKey;
    var _useContext2 = (0, $536620527818ee29$var$_react.useContext)($b1a512ff039be377$export$e2b284ce8e93d8eb), inDataForm = _useContext2.inDataForm;
    var _useContext3 = (0, $536620527818ee29$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext3.format;
    var id = idProp || dataId + "--view";
    (0, $536620527818ee29$var$_react.useEffect)(function() {
        if (!inDataForm) addToolbarKey('_view');
    }, [
        addToolbarKey,
        inDataForm
    ]);
    if (!views) return null;
    var names = views.map(function(v) {
        return v.name;
    });
    var content;
    if (inDataForm && names.length < 7) content = /*#__PURE__*/ $536620527818ee29$var$_react["default"].createElement($49bedb3ed8912461$export$c062ce1cc79ad58a, $536620527818ee29$var$_extends({
        id: id,
        name: "_view",
        options: names,
        value: view == null ? void 0 : view.name
    }, rest));
    else content = /*#__PURE__*/ $536620527818ee29$var$_react["default"].createElement($c692f0029c94fbb2$export$ef9b1a59e592288f, $536620527818ee29$var$_extends({
        id: id,
        name: "_view",
        showSelectedInline: true,
        placeholder: !inDataForm ? 'Select view' : undefined,
        options: names,
        value: view == null ? void 0 : view.name
    }, rest));
    if (!inDataForm) // likely in Toolbar
    content = /*#__PURE__*/ $536620527818ee29$var$_react["default"].createElement($46eb34c25d0c5f74$export$dcf38ffba6c01577, {
        footer: false,
        updateOn: "change"
    }, content);
    else content = /*#__PURE__*/ $536620527818ee29$var$_react["default"].createElement($af5ba9f7873798c6$export$56e87bf42978147a, {
        htmlFor: id,
        label: format({
            id: 'dataView.label',
            messages: messages == null ? void 0 : messages.dataView
        })
    }, content);
    return content;
};
$536620527818ee29$var$DataView.propTypes = $e569f5eac4e38258$export$b9929fa9b7f4d505;


$fd9964856b517b7a$export$5e15d737b33a1c27 = $536620527818ee29$export$5e15d737b33a1c27;


var $e235805748ea9d79$exports = {};

$parcel$export($e235805748ea9d79$exports, "__esModule", function () { return $e235805748ea9d79$export$1e511d4a378977f5; }, function (v) { return $e235805748ea9d79$export$1e511d4a378977f5 = v; });
$parcel$export($e235805748ea9d79$exports, "Toolbar", function () { return $e235805748ea9d79$export$4c260019440d418f; }, function (v) { return $e235805748ea9d79$export$4c260019440d418f = v; });
var $e235805748ea9d79$export$1e511d4a378977f5;
var $e235805748ea9d79$export$4c260019440d418f;
"use strict";
$e235805748ea9d79$export$1e511d4a378977f5 = true;
$e235805748ea9d79$export$4c260019440d418f = void 0;
var $20af8a084f58a029$export$1e511d4a378977f5;
var $20af8a084f58a029$export$4c260019440d418f;
"use strict";
$20af8a084f58a029$export$1e511d4a378977f5 = true;
$20af8a084f58a029$export$4c260019440d418f = void 0;

var $20af8a084f58a029$var$_react = $20af8a084f58a029$var$_interopRequireWildcard((parcelRequire("2xPiy")));


var $59eb8541409be143$export$1e511d4a378977f5;
var $59eb8541409be143$export$4233ab0257b2d4fe;
"use strict";
$59eb8541409be143$export$1e511d4a378977f5 = true;
$59eb8541409be143$export$4233ab0257b2d4fe = void 0;
var $59eb8541409be143$var$PropType = {};
$59eb8541409be143$var$PropType = {};
var $59eb8541409be143$var$ToolbarPropTypes = $59eb8541409be143$export$4233ab0257b2d4fe = $59eb8541409be143$var$PropType;




var $20af8a084f58a029$var$_excluded = [
    "children"
];
function $20af8a084f58a029$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($20af8a084f58a029$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $20af8a084f58a029$var$_extends() {
    return $20af8a084f58a029$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $20af8a084f58a029$var$_extends.apply(null, arguments);
}
function $20af8a084f58a029$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $20af8a084f58a029$var$Toolbar = $20af8a084f58a029$export$4c260019440d418f = function Toolbar(_ref) {
    var _theme$toolbar, _theme$toolbar2;
    var children = _ref.children, rest = $20af8a084f58a029$var$_objectWithoutPropertiesLoose(_ref, $20af8a084f58a029$var$_excluded);
    var size = (0, $20af8a084f58a029$var$_react.useContext)($afb62f3be48d73fe$export$51e389dae84ec233);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var defaultLayoutProps = {
        direction: 'row',
        align: 'start',
        gap: (_theme$toolbar = theme.toolbar) == null ? void 0 : _theme$toolbar.gap
    };
    var smallLayoutProps = {
        direction: 'row',
        wrap: true,
        align: 'start',
        gap: (_theme$toolbar2 = theme.toolbar) == null || (_theme$toolbar2 = _theme$toolbar2.small) == null ? void 0 : _theme$toolbar2.gap
    };
    var layoutProps = (0, $80783f9dd7b08ab9$export$813595e92b2e7a6f)(size) ? smallLayoutProps : defaultLayoutProps;
    return /*#__PURE__*/ $20af8a084f58a029$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $20af8a084f58a029$var$_extends({
        flex: false,
        cssGap: true
    }, layoutProps, rest), children);
};
$20af8a084f58a029$var$Toolbar.propTypes = $59eb8541409be143$export$4233ab0257b2d4fe;


$e235805748ea9d79$export$4c260019440d418f = $20af8a084f58a029$export$4c260019440d418f;



var $3afc956d2a00119a$export$1e511d4a378977f5;
var $3afc956d2a00119a$export$a54c7eaa3a05c9cf;
"use strict";
$3afc956d2a00119a$export$1e511d4a378977f5 = true;
$3afc956d2a00119a$export$a54c7eaa3a05c9cf = void 0;

var $3afc956d2a00119a$var$_propTypes = $3afc956d2a00119a$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $3afc956d2a00119a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $3afc956d2a00119a$var$viewType = $3afc956d2a00119a$var$_propTypes["default"].shape({
    properties: $3afc956d2a00119a$var$_propTypes["default"].oneOfType([
        $3afc956d2a00119a$var$_propTypes["default"].arrayOf($3afc956d2a00119a$var$_propTypes["default"].string),
        $3afc956d2a00119a$var$_propTypes["default"].shape({})
    ]),
    search: $3afc956d2a00119a$var$_propTypes["default"].string,
    sort: $3afc956d2a00119a$var$_propTypes["default"].shape({
        direction: $3afc956d2a00119a$var$_propTypes["default"].oneOf([
            'asc',
            'desc'
        ]),
        property: $3afc956d2a00119a$var$_propTypes["default"].string
    }),
    columns: $3afc956d2a00119a$var$_propTypes["default"].arrayOf($3afc956d2a00119a$var$_propTypes["default"].string)
});
var $3afc956d2a00119a$var$PropType = {};
$3afc956d2a00119a$var$PropType = {
    data: $3afc956d2a00119a$var$_propTypes["default"].arrayOf($3afc956d2a00119a$var$_propTypes["default"].shape({})),
    defaultView: $3afc956d2a00119a$var$viewType,
    filteredTotal: $3afc956d2a00119a$var$_propTypes["default"].number,
    id: $3afc956d2a00119a$var$_propTypes["default"].string,
    messages: $3afc956d2a00119a$var$_propTypes["default"].shape({
        dataFilters: $3afc956d2a00119a$var$_propTypes["default"].shape({
            clear: $3afc956d2a00119a$var$_propTypes["default"].string,
            heading: $3afc956d2a00119a$var$_propTypes["default"].string,
            open: $3afc956d2a00119a$var$_propTypes["default"].string,
            openSet: $3afc956d2a00119a$var$_propTypes["default"].shape({
                singular: $3afc956d2a00119a$var$_propTypes["default"].string,
                plural: $3afc956d2a00119a$var$_propTypes["default"].string
            })
        }),
        dataForm: $3afc956d2a00119a$var$_propTypes["default"].shape({
            submit: $3afc956d2a00119a$var$_propTypes["default"].string
        }),
        dataSearch: $3afc956d2a00119a$var$_propTypes["default"].shape({
            label: $3afc956d2a00119a$var$_propTypes["default"].string,
            open: $3afc956d2a00119a$var$_propTypes["default"].string
        }),
        dataSort: $3afc956d2a00119a$var$_propTypes["default"].shape({
            ascending: $3afc956d2a00119a$var$_propTypes["default"].string,
            by: $3afc956d2a00119a$var$_propTypes["default"].string,
            descending: $3afc956d2a00119a$var$_propTypes["default"].string,
            direction: $3afc956d2a00119a$var$_propTypes["default"].string,
            open: $3afc956d2a00119a$var$_propTypes["default"].string
        }),
        dataSummary: $3afc956d2a00119a$var$_propTypes["default"].shape({
            filtered: $3afc956d2a00119a$var$_propTypes["default"].string,
            filteredSingle: $3afc956d2a00119a$var$_propTypes["default"].string,
            items: $3afc956d2a00119a$var$_propTypes["default"].string,
            itemsSingle: $3afc956d2a00119a$var$_propTypes["default"].string,
            selected: $3afc956d2a00119a$var$_propTypes["default"].string,
            total: $3afc956d2a00119a$var$_propTypes["default"].string,
            totalSingle: $3afc956d2a00119a$var$_propTypes["default"].string
        }),
        dataTableColumns: $3afc956d2a00119a$var$_propTypes["default"].shape({
            open: $3afc956d2a00119a$var$_propTypes["default"].string,
            order: $3afc956d2a00119a$var$_propTypes["default"].string,
            pinned: $3afc956d2a00119a$var$_propTypes["default"].string,
            select: $3afc956d2a00119a$var$_propTypes["default"].string,
            tip: $3afc956d2a00119a$var$_propTypes["default"].string,
            selectAria: $3afc956d2a00119a$var$_propTypes["default"].string,
            orderAria: $3afc956d2a00119a$var$_propTypes["default"].string
        }),
        dataTableGroupBy: $3afc956d2a00119a$var$_propTypes["default"].shape({
            clear: $3afc956d2a00119a$var$_propTypes["default"].string,
            label: $3afc956d2a00119a$var$_propTypes["default"].string
        }),
        dataView: $3afc956d2a00119a$var$_propTypes["default"].shape({
            label: $3afc956d2a00119a$var$_propTypes["default"].string
        })
    }),
    onView: $3afc956d2a00119a$var$_propTypes["default"].func,
    properties: $3afc956d2a00119a$var$_propTypes["default"].oneOfType([
        $3afc956d2a00119a$var$_propTypes["default"].arrayOf($3afc956d2a00119a$var$_propTypes["default"].string),
        $3afc956d2a00119a$var$_propTypes["default"].objectOf($3afc956d2a00119a$var$_propTypes["default"].shape({
            badge: $3afc956d2a00119a$var$_propTypes["default"].bool,
            filter: $3afc956d2a00119a$var$_propTypes["default"].bool,
            label: $3afc956d2a00119a$var$_propTypes["default"].string,
            options: $3afc956d2a00119a$var$_propTypes["default"].arrayOf($3afc956d2a00119a$var$_propTypes["default"].oneOfType([
                $3afc956d2a00119a$var$_propTypes["default"].string,
                $3afc956d2a00119a$var$_propTypes["default"].shape({})
            ])),
            range: $3afc956d2a00119a$var$_propTypes["default"].shape({
                max: $3afc956d2a00119a$var$_propTypes["default"].number,
                min: $3afc956d2a00119a$var$_propTypes["default"].number,
                step: $3afc956d2a00119a$var$_propTypes["default"].number
            }),
            search: $3afc956d2a00119a$var$_propTypes["default"].bool,
            sort: $3afc956d2a00119a$var$_propTypes["default"].bool
        }))
    ]),
    toolbar: $3afc956d2a00119a$var$_propTypes["default"].oneOfType([
        $3afc956d2a00119a$var$_propTypes["default"].bool,
        $3afc956d2a00119a$var$_propTypes["default"].oneOf([
            'search',
            'filters',
            'view'
        ])
    ]),
    total: $3afc956d2a00119a$var$_propTypes["default"].number,
    view: $3afc956d2a00119a$var$_propTypes["default"].oneOfType([
        $3afc956d2a00119a$var$_propTypes["default"].string,
        $3afc956d2a00119a$var$viewType
    ]),
    views: $3afc956d2a00119a$var$_propTypes["default"].arrayOf($3afc956d2a00119a$var$viewType)
};
var $3afc956d2a00119a$var$DataPropTypes = $3afc956d2a00119a$export$a54c7eaa3a05c9cf = $3afc956d2a00119a$var$PropType;



var $a2339b30b1c61286$export$1e511d4a378977f5;
var $a2339b30b1c61286$export$3dea766d36a8935f;
"use strict";
$a2339b30b1c61286$export$1e511d4a378977f5 = true;
$a2339b30b1c61286$export$3dea766d36a8935f = void 0;
// TODO: share with DataTable, List, Cards, etc.
var $a2339b30b1c61286$var$_datumValue = function datumValue(datum, property) {
    if (!property) return undefined;
    var parts = property.split('.');
    if (parts.length === 1) return datum[property];
    if (!datum[parts[0]]) return undefined;
    return $a2339b30b1c61286$var$_datumValue(datum[parts[0]], parts.slice(1).join('.'));
};
// This is where we filter the data internally, when the caller doesn't
// provide an onView.
var $a2339b30b1c61286$var$filter = $a2339b30b1c61286$export$3dea766d36a8935f = function filter(data, view, properties) {
    var _view$sort, _view$sort2;
    // from https://stackoverflow.com/a/6300266/8513067
    var searchExp = view != null && view.search ? new RegExp(view.search.replace(/[#-.]|[[-^]|[?|{}]/g, '\\$&'), 'i') : undefined;
    var searchProperties;
    if (searchExp && properties) {
        // if we know where we want to search, look there
        searchProperties = Object.keys(properties).filter(function(k) {
            var _properties$k;
            return !(((_properties$k = properties[k]) == null ? void 0 : _properties$k.search) === false);
        });
        // if none specified, look in all defined properties
        if (searchProperties.length === 0) searchProperties = Object.keys(properties);
    }
    var filteredData = data.filter(function(datum) {
        var matched = true;
        // check whether it matches any search
        if (searchExp) {
            var searchWith = function searchWith(property) {
                var value = $a2339b30b1c61286$var$_datumValue(datum, property);
                if (value === undefined) return false;
                return searchExp.test(value);
            };
            if (searchProperties) matched = searchProperties.some(searchWith);
            else matched = Object.keys(datum).some(searchWith);
        }
        // check whether it matches any specific values
        if (matched && view != null && view.properties) // if any properties don't match, overall not matched
        matched = !Object.keys(view.properties).some(function(property) {
            // returning true means it doesn't match the filter,
            var filterValue = view.properties[property];
            var value = $a2339b30b1c61286$var$_datumValue(datum, property);
            // range case
            if (typeof (filterValue == null ? void 0 : filterValue.min) === 'number' || typeof (filterValue == null ? void 0 : filterValue.max) === 'number') return typeof value !== 'number' || value < filterValue.min || value > filterValue.max;
            // options case
            if (Array.isArray(filterValue)) return !filterValue.some(function(f) {
                // f may be an object with form {label: __, value: __}
                var isObject = typeof f === 'object';
                // match f within data value array using .includes()
                if (Array.isArray(value)) return isObject ? value.includes(f == null ? void 0 : f.value) : value.includes(f);
                // match f with data value using ===
                return isObject ? (f == null ? void 0 : f.value) === value : f === value;
            });
            // presence case
            if (typeof filterValue === 'boolean') return filterValue === !value;
            // not sure, keep it
            return false;
        });
        return matched;
    });
    if (view != null && (_view$sort = view.sort) != null && _view$sort.property || view != null && (_view$sort2 = view.sort) != null && _view$sort2.direction) {
        var _view$sort3 = view.sort, property = _view$sort3.property, direction = _view$sort3.direction;
        var prop = property || filteredData.length && Object.keys(filteredData[0])[0];
        var sortDesc = direction === 'desc'; // default to asc
        var before = sortDesc ? -1 : 1;
        var after = sortDesc ? 1 : -1;
        filteredData.sort(function(d1, d2) {
            var d1Val = $a2339b30b1c61286$var$_datumValue(d1, prop);
            var d2Val = $a2339b30b1c61286$var$_datumValue(d2, prop);
            // sort strings via locale case insensitive
            if (typeof d1Val === 'string' && typeof d2Val === 'string' || typeof d1Val === 'string' && !d2Val || typeof d2Val === 'string' && !d1Val) {
                var sortResult = (d1Val || '').localeCompare(d2Val || '', undefined, {
                    sensitivity: 'base'
                });
                return sortDesc ? -sortResult : sortResult;
            }
            // numbers are easier to sort
            if (d1Val > d2Val) return before;
            if (d1Val < d2Val) return after;
            return 0;
        });
    }
    var pagedData;
    if (view != null && view.step) {
        var _view$page;
        var start = view.step * (((_view$page = view == null ? void 0 : view.page) != null ? _view$page : 1) - 1);
        pagedData = filteredData.slice(start, start + view.step);
    }
    return {
        unfilteredData: data,
        data: pagedData || filteredData,
        total: data.length,
        filteredTotal: filteredData.length
    };
};



var $c3eaf414750edd8e$var$_excluded = [
    "children",
    "data",
    "defaultView",
    "filteredTotal",
    "id",
    "messages",
    "onView",
    "properties",
    "toolbar",
    "total",
    "view",
    "views"
];
function $c3eaf414750edd8e$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($c3eaf414750edd8e$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $c3eaf414750edd8e$var$_extends() {
    return $c3eaf414750edd8e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c3eaf414750edd8e$var$_extends.apply(null, arguments);
}
function $c3eaf414750edd8e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $c3eaf414750edd8e$var$defaultDefaultView = {
    search: ''
};
var $c3eaf414750edd8e$var$normalizeView = function normalizeView(viewProp, views) {
    return typeof viewProp === 'string' && (views == null ? void 0 : views.find(function(v) {
        return v.name === viewProp;
    })) || typeof viewProp === 'object' && viewProp;
};
var $c3eaf414750edd8e$var$Data = $c3eaf414750edd8e$export$2d0294657ab35f1b = function Data(_ref) {
    var children = _ref.children, _ref$data = _ref.data, dataProp = _ref$data === void 0 ? [] : _ref$data, _ref$defaultView = _ref.defaultView, defaultView = _ref$defaultView === void 0 ? $c3eaf414750edd8e$var$defaultDefaultView : _ref$defaultView, filteredTotal = _ref.filteredTotal, _ref$id = _ref.id, id = _ref$id === void 0 ? 'data' : _ref$id, messages = _ref.messages, onView = _ref.onView, properties = _ref.properties, toolbar = _ref.toolbar, total = _ref.total, viewProp = _ref.view, views = _ref.views, rest = $c3eaf414750edd8e$var$_objectWithoutPropertiesLoose(_ref, $c3eaf414750edd8e$var$_excluded);
    var _useState = (0, $c3eaf414750edd8e$var$_react.useState)($c3eaf414750edd8e$var$normalizeView(viewProp || defaultView, views)), view = _useState[0], setView = _useState[1];
    (0, $c3eaf414750edd8e$var$_react.useEffect)(function() {
        return setView($c3eaf414750edd8e$var$normalizeView(viewProp || defaultView, views));
    }, [
        defaultView,
        viewProp,
        views
    ]);
    var _useState2 = (0, $c3eaf414750edd8e$var$_react.useState)([]), toolbarKeys = _useState2[0], setToolbarKeys = _useState2[1];
    var result = (0, $c3eaf414750edd8e$var$_react.useMemo)(function() {
        var _ref2;
        if (onView) // caller is filtering
        return {
            data: dataProp,
            total: total,
            filteredTotal: (_ref2 = filteredTotal != null ? filteredTotal : dataProp == null ? void 0 : dataProp.length) != null ? _ref2 : 0
        };
        return (0, $a2339b30b1c61286$export$3dea766d36a8935f)(dataProp, view, properties);
    }, [
        dataProp,
        filteredTotal,
        onView,
        properties,
        total,
        view
    ]);
    // used by DataFilters to determine if badge should appear on Filter button
    var _useState3 = (0, $c3eaf414750edd8e$var$_react.useState)(true), filtersCleared = _useState3[0], setFiltersCleared = _useState3[1];
    var _useState4 = (0, $c3eaf414750edd8e$var$_react.useState)([]), selected = _useState4[0], setSelected = _useState4[1];
    var announce = (0, $c3eaf414750edd8e$var$_react.useContext)($58f4f715ab4fa2c4$exports.AnnounceContext);
    var _useContext = (0, $c3eaf414750edd8e$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    // Announce to screen readers when search or filters are
    // applied and affect the underlying result set
    (0, $c3eaf414750edd8e$var$_react.useEffect)(function() {
        var messageId;
        if (result.total !== result.filteredTotal) {
            if (result.filteredTotal === 1) messageId = 'dataSummary.filteredSingle';
            else messageId = 'dataSummary.filtered';
        } else if (result.total === 1) messageId = 'dataSummary.totalSingle';
        else messageId = 'dataSummary.total';
        // helps account for cases like 0 results of 1 item
        var items = format({
            id: result.total === 1 ? 'dataSummary.itemsSingle' : 'dataSummary.items',
            messages: messages == null ? void 0 : messages.dataSummary
        });
        announce("" + format({
            id: messageId,
            messages: messages == null ? void 0 : messages.dataSummary,
            values: {
                filteredTotal: result.filteredTotal,
                total: result.total,
                items: items
            }
        }) + (selected > 0 ? ", " + format({
            id: 'dataSummary.selected',
            messages: messages == null ? void 0 : messages.dataSummary,
            values: {
                selected: selected
            }
        }) : ''));
    }, [
        announce,
        format,
        messages == null ? void 0 : messages.dataSummary,
        result.filteredTotal,
        result.total,
        selected
    ]);
    // what we use for DataContext value
    var contextValue = (0, $c3eaf414750edd8e$var$_react.useMemo)(function() {
        var value = $c3eaf414750edd8e$var$_extends({
            id: id,
            messages: messages,
            properties: properties,
            filtersCleared: filtersCleared,
            setFiltersCleared: setFiltersCleared,
            selected: selected,
            setSelected: setSelected,
            view: view,
            views: views
        }, result);
        value.clearFilters = function() {
            var nextView = $c3eaf414750edd8e$var$_extends({}, view);
            delete nextView.properties;
            delete nextView.page;
            // by clearing the properties from a view, it is no
            // longer reflecting the view
            delete nextView.name;
            delete nextView.view;
            setFiltersCleared(true);
            setView(nextView);
            if (onView) onView(nextView);
        };
        value.onView = function(nextView) {
            setView(nextView);
            if (onView) onView(nextView);
        };
        value.addToolbarKey = function(key) {
            setToolbarKeys(function(prevKeys) {
                if (prevKeys.includes(key)) return prevKeys;
                return [].concat(prevKeys, [
                    key
                ]);
            });
        };
        value.toolbarKeys = toolbarKeys;
        return value;
    }, [
        id,
        messages,
        filtersCleared,
        onView,
        properties,
        result,
        selected,
        toolbarKeys,
        view,
        views
    ]);
    var toolbarContent;
    if (toolbar) {
        var _theme$data;
        toolbarContent = [
            /*#__PURE__*/ $c3eaf414750edd8e$var$_react["default"].createElement($e235805748ea9d79$export$4c260019440d418f, {
                key: "toolbar",
                gap: (_theme$data = theme.data) == null || (_theme$data = _theme$data.toolbar) == null ? void 0 : _theme$data.gap
            }, /*#__PURE__*/ $c3eaf414750edd8e$var$_react["default"].createElement($e235805748ea9d79$export$4c260019440d418f, null, (toolbar === true || toolbar === 'search') && /*#__PURE__*/ $c3eaf414750edd8e$var$_react["default"].createElement($17143eb328c34dfb$export$20513e732c988e96, null), (toolbar === true || toolbar === 'filters') && /*#__PURE__*/ $c3eaf414750edd8e$var$_react["default"].createElement($3ee1846956b4e555$export$32443de3cfb88b3c, {
                layer: true
            })), (toolbar === true || toolbar === 'view') && /*#__PURE__*/ $c3eaf414750edd8e$var$_react["default"].createElement($fd9964856b517b7a$export$5e15d737b33a1c27, null)),
            /*#__PURE__*/ $c3eaf414750edd8e$var$_react["default"].createElement($3d0ce75306f2014c$export$fcbfa64cec0e2150, {
                key: "summary"
            })
        ];
    }
    return /*#__PURE__*/ $c3eaf414750edd8e$var$_react["default"].createElement($932597a497e37de0$export$58d75f9829cbe158.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $c3eaf414750edd8e$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $c3eaf414750edd8e$var$_extends({
        id: id,
        flex: false
    }, rest), toolbarContent, children));
};
$c3eaf414750edd8e$var$Data.propTypes = $3afc956d2a00119a$export$a54c7eaa3a05c9cf;


$3ad925e2d12764e5$export$2d0294657ab35f1b = $c3eaf414750edd8e$export$2d0294657ab35f1b;

$3ad925e2d12764e5$export$dcf38ffba6c01577 = $46eb34c25d0c5f74$export$dcf38ffba6c01577;
$3ad925e2d12764e5$export$6c37302973078e01 = $46eb34c25d0c5f74$export$6c37302973078e01;
$3ad925e2d12764e5$export$58cb1cd3f7c80c90 = $46eb34c25d0c5f74$export$58cb1cd3f7c80c90;
$3ad925e2d12764e5$export$af663afbf59caa0b = $46eb34c25d0c5f74$export$af663afbf59caa0b;
$3ad925e2d12764e5$export$5d400b63d4a1c541 = $46eb34c25d0c5f74$export$5d400b63d4a1c541;


Object.keys($3ad925e2d12764e5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $3ad925e2d12764e5$exports[key]) return;
    $3321243da0932e1e$exports[key] = $3ad925e2d12764e5$exports[key];
});
var $21076d81dbd06644$exports = {};

$parcel$export($21076d81dbd06644$exports, "__esModule", function () { return $21076d81dbd06644$export$1e511d4a378977f5; }, function (v) { return $21076d81dbd06644$export$1e511d4a378977f5 = v; });
$parcel$export($21076d81dbd06644$exports, "DataChart", function () { return $21076d81dbd06644$export$56fe02f8cb89ca83; }, function (v) { return $21076d81dbd06644$export$56fe02f8cb89ca83 = v; });
var $21076d81dbd06644$export$1e511d4a378977f5;
var $21076d81dbd06644$export$56fe02f8cb89ca83;
"use strict";
$21076d81dbd06644$export$1e511d4a378977f5 = true;
$21076d81dbd06644$export$56fe02f8cb89ca83 = void 0;
var $ffaff9bfe81e5fa0$export$1e511d4a378977f5;
var $ffaff9bfe81e5fa0$export$56fe02f8cb89ca83;
"use strict";
$ffaff9bfe81e5fa0$export$1e511d4a378977f5 = true;
$ffaff9bfe81e5fa0$export$56fe02f8cb89ca83 = void 0;

var $ffaff9bfe81e5fa0$var$_react = $ffaff9bfe81e5fa0$var$_interopRequireWildcard((parcelRequire("2xPiy")));






var $a3076d855b6b40e8$export$1e511d4a378977f5;
var $a3076d855b6b40e8$export$47eb42ff093406d4;
"use strict";
$a3076d855b6b40e8$export$1e511d4a378977f5 = true;
$a3076d855b6b40e8$export$47eb42ff093406d4 = void 0;

var $a3076d855b6b40e8$var$_react = $a3076d855b6b40e8$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $a3076d855b6b40e8$var$_styledComponents = $a3076d855b6b40e8$var$_interopRequireDefault((parcelRequire("iA1nz")));








var $d81f39ef619cf721$export$1e511d4a378977f5;
var $d81f39ef619cf721$export$c463048d6131b309;
"use strict";
$d81f39ef619cf721$export$1e511d4a378977f5 = true;
$d81f39ef619cf721$export$c463048d6131b309 = void 0;

var $d81f39ef619cf721$var$_react = $d81f39ef619cf721$var$_interopRequireDefault((parcelRequire("2xPiy")));


function $d81f39ef619cf721$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $d81f39ef619cf721$var$_extends() {
    return $d81f39ef619cf721$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d81f39ef619cf721$var$_extends.apply(null, arguments);
}
var $d81f39ef619cf721$var$Swatch = $d81f39ef619cf721$export$c463048d6131b309 = function Swatch(_ref) {
    var aspect = _ref.aspect, color = _ref.color, dash = _ref.dash, opacityProp = _ref.opacity, point = _ref.point, round = _ref.round, thickness = _ref.thickness, type = _ref.type;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var dim = parseInt(theme.global.spacing, 10) / 2;
    var half = dim / 2;
    var height = dim;
    var width = dim;
    var normalizedColor = color ? (0, $4113023f9e0bafa0$exports.normalizeColor)(color.color || color, theme) : undefined;
    var fill = normalizedColor;
    var stroke = 'none';
    var content;
    if (aspect === 'x') content = /*#__PURE__*/ $d81f39ef619cf721$var$_react["default"].createElement("path", {
        d: "M 0 " + half + " L " + dim + " " + half,
        stroke: "#000"
    });
    else if (aspect === 'y') content = /*#__PURE__*/ $d81f39ef619cf721$var$_react["default"].createElement("path", {
        d: "M " + half + " 0 L " + half + " " + dim,
        stroke: "#000"
    });
    else if (aspect === 'thickness') content = /*#__PURE__*/ $d81f39ef619cf721$var$_react["default"].createElement("g", {
        stroke: "#000",
        fill: "none"
    }, /*#__PURE__*/ $d81f39ef619cf721$var$_react["default"].createElement("circle", {
        cx: half,
        cy: half,
        r: half / 4
    }), /*#__PURE__*/ $d81f39ef619cf721$var$_react["default"].createElement("circle", {
        cx: half,
        cy: half,
        r: half - 1
    }));
    else if (aspect === 'color') content = /*#__PURE__*/ $d81f39ef619cf721$var$_react["default"].createElement("g", null, /*#__PURE__*/ $d81f39ef619cf721$var$_react["default"].createElement("rect", {
        x: 0,
        y: 0,
        width: half,
        height: dim,
        fill: "#000",
        opacity: 0.4
    }), /*#__PURE__*/ $d81f39ef619cf721$var$_react["default"].createElement("rect", {
        x: half,
        y: 0,
        width: half,
        height: dim,
        fill: "#000",
        opacity: 0.8
    }));
    else if (point) {
        if (point === 'circle') content = /*#__PURE__*/ $d81f39ef619cf721$var$_react["default"].createElement("circle", {
            cx: half,
            cy: half,
            r: half
        });
        else {
            var d;
            if (point === 'diamond') d = "M " + half + " 0 L " + dim + " " + half + " L " + half + " " + dim + " L 0 " + half + " Z";
            else if (point === 'star') {
                var off1 = half / 3;
                var off2 = off1 * 2;
                d = "M " + half + " 0 L " + (half - off2) + " " + dim + " L " + dim + " " + (half - off1) + " L 0 " + (half - off1) + " L " + (half + off2) + " " + dim + " Z";
            } else if (point === 'triangle') d = "M " + half + " 0 L " + dim + " " + dim + " L 0 " + dim + " Z";
            else if (point === 'triangleDown') d = "M 0 0 L " + dim + " 0 L " + half + " " + dim + " Z";
            else if (point === 'square') d = "M 0 0 L " + dim + " 0 L " + dim + " " + dim + " L 0 " + dim + " Z";
            if (d) content = /*#__PURE__*/ $d81f39ef619cf721$var$_react["default"].createElement("path", {
                d: d
            });
        }
    } else if (type === 'area') {
        if (round) content = /*#__PURE__*/ $d81f39ef619cf721$var$_react["default"].createElement("circle", {
            cx: half,
            cy: half,
            r: half
        });
        else content = /*#__PURE__*/ $d81f39ef619cf721$var$_react["default"].createElement("rect", {
            x: 0,
            y: 0,
            width: width,
            height: height
        });
    } else {
        // draw a line oriented based on the type and then match style
        var strokeWidth = (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.edgeSize[thickness]) || dim;
        var _d;
        if (type === 'line' || type === 'area') {
            width = Math.max(width, strokeWidth * 4);
            height = strokeWidth;
            _d = "M 0 " + height / 2 + " L " + width + " " + height / 2;
        } else {
            width = strokeWidth;
            _d = "M " + width / 2 + " 0 L " + width / 2 + " " + dim;
        }
        fill = 'none';
        stroke = normalizedColor;
        var strokeProps = {};
        if (round) strokeProps.strokeLinecap = 'round';
        if (dash) strokeProps.strokeDasharray = round ? strokeWidth + " " + strokeWidth * 1.5 : strokeWidth * 2 + " " + strokeWidth / 2;
        content = /*#__PURE__*/ $d81f39ef619cf721$var$_react["default"].createElement("path", $d81f39ef619cf721$var$_extends({
            d: _d,
            strokeWidth: strokeWidth
        }, strokeProps));
    }
    var opacity = theme.global.opacity[(color == null ? void 0 : color.opacity) || opacityProp] || undefined;
    return /*#__PURE__*/ $d81f39ef619cf721$var$_react["default"].createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 " + width + " " + height,
        fill: fill,
        opacity: opacity,
        stroke: stroke
    }, content);
};



function $a3076d855b6b40e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $a3076d855b6b40e8$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($a3076d855b6b40e8$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $a3076d855b6b40e8$var$_extends() {
    return $a3076d855b6b40e8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a3076d855b6b40e8$var$_extends.apply(null, arguments);
}
var $a3076d855b6b40e8$var$DetailControl = (0, $a3076d855b6b40e8$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "Detail__DetailControl",
    componentId: "sc-huiwg9-0"
})([
    "&:focus{",
    "}&:focus:not(:focus-visible){",
    "}"
], (0, $4113023f9e0bafa0$exports.focusStyle)(), (0, $4113023f9e0bafa0$exports.unfocusStyle)());
var $a3076d855b6b40e8$var$Detail = $a3076d855b6b40e8$export$47eb42ff093406d4 = function Detail(_ref) {
    var activeProperty = _ref.activeProperty, axis = _ref.axis, data = _ref.data, horizontalProp = _ref.horizontal, padProp = _ref.pad, series = _ref.series, seriesStyles = _ref.seriesStyles, renderValue = _ref.renderValue, thickness = _ref.thickness;
    var announce = (0, $a3076d855b6b40e8$var$_react.useContext)($cfbcb74d4f54e56b$export$dcc8f4bff0d51f50);
    var _useContext = (0, $a3076d855b6b40e8$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useState = (0, $a3076d855b6b40e8$var$_react.useState)(), detailIndex = _useState[0], setDetailIndex = _useState[1];
    var activeIndex = (0, $a3076d855b6b40e8$var$_react.useRef)();
    var detailRefs = (0, $a3076d855b6b40e8$var$_react.useMemo)(function() {
        return [];
    }, []);
    var pad = (0, $a3076d855b6b40e8$var$_react.useMemo)(function() {
        // ensure the hit targets and center lines align with
        // the data/guide lines
        var horizontal = (padProp == null ? void 0 : padProp.horizontal) || typeof padProp === 'string' && padProp || 0;
        horizontal = theme.global.edgeSize[horizontal] || horizontal;
        horizontal = (0, $4113023f9e0bafa0$exports.parseMetricToNum)(horizontal);
        var vertical = (padProp == null ? void 0 : padProp.vertical) || typeof padProp === 'string' && padProp || 0;
        vertical = theme.global.edgeSize[vertical] || vertical;
        vertical = (0, $4113023f9e0bafa0$exports.parseMetricToNum)(vertical);
        return {
            horizontal: horizontal - (0, $4113023f9e0bafa0$exports.parseMetricToNum)(thickness) / 2 + "px",
            vertical: vertical + "px"
        };
    }, [
        padProp,
        theme.global.edgeSize,
        thickness
    ]);
    var onMouseLeave = (0, $a3076d855b6b40e8$var$_react.useCallback)(function(event) {
        // Only remove detail if the mouse isn't over the active index.
        // This helps distinguish leaving the drop on the edge where it is
        // anchored.
        var rect = activeIndex.current.getBoundingClientRect();
        if (event.pageX < rect.left || event.pageX > rect.right || event.pageY < rect.top || event.pageY > rect.bottom) {
            activeIndex.current = undefined;
            setDetailIndex(undefined);
        }
    }, []);
    var dropAlign = (0, $a3076d855b6b40e8$var$_react.useMemo)(function() {
        var res;
        if (detailIndex > data.length / 2) {
            if (horizontalProp) res = {
                bottom: 'top'
            };
            else res = {
                right: 'left'
            };
        } else if (horizontalProp) res = {
            top: 'bottom'
        };
        else res = {
            left: 'right'
        };
        return res;
    }, [
        data.length,
        detailIndex,
        horizontalProp
    ]);
    var getContent = (0, $a3076d855b6b40e8$var$_react.useCallback)(function(index) {
        if (index !== undefined) return series.filter(function(_ref2) {
            var _data$index;
            var property = _ref2.property;
            return (!activeProperty || activeProperty === property) && (data == null || (_data$index = data[index]) == null ? void 0 : _data$index[property]) !== undefined || axis && axis.x && axis.x.property === property;
        }).map(function(serie) {
            var axisValue = horizontalProp ? data[index][serie.property] : index;
            return (serie.label || serie.property) + " " + renderValue(serie, axisValue) + ".";
        }).join(' ');
        return undefined;
    }, [
        activeProperty,
        axis,
        data,
        horizontalProp,
        renderValue,
        series
    ]);
    return /*#__PURE__*/ $a3076d855b6b40e8$var$_react["default"].createElement($a3076d855b6b40e8$var$_react["default"].Fragment, null, /*#__PURE__*/ $a3076d855b6b40e8$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onLeft: function onLeft(event) {
            event.preventDefault();
            if (detailIndex === undefined) {
                setDetailIndex(data.length - 1);
                announce(getContent(data.length - 1), 'assertive');
            } else if (detailIndex > 0) {
                setDetailIndex(detailIndex - 1);
                announce(getContent(detailIndex - 1), 'assertive');
            }
        },
        onRight: function onRight(event) {
            event.preventDefault();
            if (detailIndex === undefined) {
                setDetailIndex(0);
                announce(getContent(0), 'assertive');
            } else if (detailIndex < data.length - 1) {
                setDetailIndex(detailIndex + 1);
                announce(getContent(detailIndex + 1), 'assertive');
            }
        }
    }, /*#__PURE__*/ $a3076d855b6b40e8$var$_react["default"].createElement($a3076d855b6b40e8$var$DetailControl, $a3076d855b6b40e8$var$_extends({
        key: "band",
        fill: true,
        role: "list",
        tabIndex: 0,
        "aria-label": format({
            id: 'dataChart.detailTitle'
        }),
        justify: "between",
        responsive: false
    }, horizontalProp ? {
        direction: 'column'
    } : {
        direction: 'row',
        pad: pad
    }, {
        onFocus: function onFocus() {
            announce(format({
                id: 'dataChart.detailFocus'
            }));
        },
        onBlur: function onBlur() {
            return setDetailIndex(undefined);
        }
    }), data.map(function(_, i) {
        var ref = function ref(c) {
            detailRefs[i] = c;
        };
        return /*#__PURE__*/ $a3076d855b6b40e8$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $a3076d855b6b40e8$var$_extends({
            key: i,
            role: "listitem",
            responsive: false
        }, horizontalProp ? {
            justify: 'center',
            height: thickness
        } : {
            align: 'center',
            width: thickness
        }, {
            onMouseOver: function onMouseOver(event) {
                activeIndex.current = event.currentTarget;
                setDetailIndex(i);
                announce(getContent(i), 'assertive');
            },
            onMouseLeave: onMouseLeave,
            onFocus: function onFocus() {},
            onBlur: function onBlur() {}
        }), /*#__PURE__*/ $a3076d855b6b40e8$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $a3076d855b6b40e8$var$_extends({
            role: "img",
            "aria-label": getContent(i)
        }, horizontalProp ? {
            fill: 'horizontal'
        } : {
            ref: ref,
            fill: 'vertical'
        }, {
            border: detailIndex === i ? true : undefined
        }), horizontalProp ? /*#__PURE__*/ $a3076d855b6b40e8$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            alignSelf: "center",
            ref: ref
        }) : null));
    }))), detailIndex !== undefined && detailRefs[detailIndex] && /*#__PURE__*/ $a3076d855b6b40e8$var$_react["default"].createElement($9097252a6690f3a9$export$aaa698cd7aa517d6, {
        key: "drop",
        target: detailRefs[detailIndex],
        align: dropAlign,
        plain: true,
        onMouseLeave: onMouseLeave,
        trapFocus: false
    }, /*#__PURE__*/ $a3076d855b6b40e8$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        pad: theme.dataChart.detail.pad,
        background: {
            color: 'background-back'
        }
    }, /*#__PURE__*/ $a3076d855b6b40e8$var$_react["default"].createElement($f75e849c2101cc4f$export$ef2184bd89960b14, {
        columns: [
            'auto',
            'auto',
            'auto'
        ],
        gap: theme.dataChart.detail.gap,
        align: "center"
    }, series.filter(function(_ref3) {
        var _data$detailIndex;
        var property = _ref3.property;
        return (!activeProperty || activeProperty === property) && (data == null || (_data$detailIndex = data[detailIndex]) == null ? void 0 : _data$detailIndex[property]) !== undefined || axis && axis.x && axis.x.property === property;
    }).map(function(serie) {
        var propertyStyle = seriesStyles[serie.property];
        var axisValue = horizontalProp ? data[detailIndex][serie.property] : detailIndex;
        return /*#__PURE__*/ $a3076d855b6b40e8$var$_react["default"].createElement($a3076d855b6b40e8$var$_react.Fragment, {
            key: serie.property
        }, propertyStyle ? /*#__PURE__*/ $a3076d855b6b40e8$var$_react["default"].createElement($d81f39ef619cf721$export$c463048d6131b309, propertyStyle) : /*#__PURE__*/ $a3076d855b6b40e8$var$_react["default"].createElement("span", null), /*#__PURE__*/ $a3076d855b6b40e8$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, {
            size: "small"
        }, serie.label || serie.property), /*#__PURE__*/ $a3076d855b6b40e8$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, {
            size: "small",
            weight: "bold"
        }, renderValue(serie, axisValue)));
    })))));
};


var $f205d62e9596491c$export$1e511d4a378977f5;
var $f205d62e9596491c$export$ed247974535929c7;
"use strict";
$f205d62e9596491c$export$1e511d4a378977f5 = true;
$f205d62e9596491c$export$ed247974535929c7 = void 0;

var $f205d62e9596491c$var$_react = $f205d62e9596491c$var$_interopRequireWildcard((parcelRequire("2xPiy")));





function $f205d62e9596491c$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($f205d62e9596491c$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $f205d62e9596491c$var$_extends() {
    return $f205d62e9596491c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f205d62e9596491c$var$_extends.apply(null, arguments);
}
var $f205d62e9596491c$var$Legend = $f205d62e9596491c$export$ed247974535929c7 = function Legend(_ref) {
    var activeProperty = _ref.activeProperty, seriesProp = _ref.series, seriesStyles = _ref.seriesStyles, setActiveProperty = _ref.setActiveProperty;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var series = (0, $f205d62e9596491c$var$_react.useMemo)(function() {
        return seriesProp.filter(function(s) {
            return seriesStyles[s.property];
        });
    }, [
        seriesProp,
        seriesStyles
    ]);
    var interactive = (0, $f205d62e9596491c$var$_react.useMemo)(// filter out properties that are used in point chart aspects
    function() {
        return series.filter(function(_ref2) {
            var property = _ref2.property;
            return !seriesStyles[property].aspect;
        }).length > 1;
    }, [
        series,
        seriesStyles
    ]);
    return /*#__PURE__*/ $f205d62e9596491c$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        margin: theme.dataChart.legend.margin,
        direction: "row",
        wrap: true,
        gap: theme.dataChart.legend.gap
    }, series.map(function(_ref3) {
        var _theme$dataChart, _theme$dataChart2;
        var property = _ref3.property, label = _ref3.label;
        var isActive = property === activeProperty;
        var swatchProps = {};
        var textProps = {};
        if (activeProperty !== undefined) {
            if (!isActive) // swatchProps.color = 'status-disabled';
            textProps.color = 'text-xweak';
            else textProps.color = 'text-strong';
        }
        var content = /*#__PURE__*/ $f205d62e9596491c$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            key: property,
            direction: "row",
            align: "center",
            pad: (_theme$dataChart = theme.dataChart) == null || (_theme$dataChart = _theme$dataChart.legend) == null || (_theme$dataChart = _theme$dataChart.item) == null ? void 0 : _theme$dataChart.pad,
            gap: (_theme$dataChart2 = theme.dataChart) == null || (_theme$dataChart2 = _theme$dataChart2.legend) == null || (_theme$dataChart2 = _theme$dataChart2.item) == null ? void 0 : _theme$dataChart2.gap
        }, /*#__PURE__*/ $f205d62e9596491c$var$_react["default"].createElement($d81f39ef619cf721$export$c463048d6131b309, $f205d62e9596491c$var$_extends({}, seriesStyles[property], swatchProps)), /*#__PURE__*/ $f205d62e9596491c$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, textProps, label || property));
        if (interactive) content = /*#__PURE__*/ $f205d62e9596491c$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
            key: property,
            active: isActive,
            "aria-pressed": isActive ? 'true' : 'false',
            onClick: function onClick() {
                return setActiveProperty(isActive ? undefined : property);
            },
            hoverIndicator: true
        }, content);
        return content;
    }));
};


var $b389b37faa77c8cf$export$1e511d4a378977f5;
var $b389b37faa77c8cf$export$ea77231de273b52d;
"use strict";
$b389b37faa77c8cf$export$1e511d4a378977f5 = true;
$b389b37faa77c8cf$export$ea77231de273b52d = void 0;

var $b389b37faa77c8cf$var$_react = $b389b37faa77c8cf$var$_interopRequireWildcard((parcelRequire("2xPiy")));


var $db766d5667e55157$export$1e511d4a378977f5;
var $db766d5667e55157$export$e0a3b92a473ae138;
var $db766d5667e55157$export$9f048bf86ee2e9d2;
var $db766d5667e55157$export$916782c1f0ddb132;
var $db766d5667e55157$export$b25e0be55f42c9a;
var $db766d5667e55157$export$62334491c2ae55f8;
var $db766d5667e55157$export$9baa821c53e22211;
var $db766d5667e55157$export$4b69f06627bf215d;
var $db766d5667e55157$export$d183fb34017af59a;
var $db766d5667e55157$export$e43fad80528301b6;
"use strict";
$db766d5667e55157$export$1e511d4a378977f5 = true;
$db766d5667e55157$export$e0a3b92a473ae138 = $db766d5667e55157$export$9f048bf86ee2e9d2 = $db766d5667e55157$export$916782c1f0ddb132 = $db766d5667e55157$export$b25e0be55f42c9a = $db766d5667e55157$export$62334491c2ae55f8 = $db766d5667e55157$export$9baa821c53e22211 = $db766d5667e55157$export$4b69f06627bf215d = $db766d5667e55157$export$d183fb34017af59a = $db766d5667e55157$export$e43fad80528301b6 = void 0;

var $db766d5667e55157$var$points = $db766d5667e55157$export$9f048bf86ee2e9d2 = [
    'circle',
    'diamond',
    'square',
    'star',
    'triangle',
    'triangleDown'
];
var $db766d5667e55157$var$heightYGranularity = $db766d5667e55157$export$9baa821c53e22211 = {
    xxsmall: {
        fine: 2,
        medium: 2
    },
    xsmall: {
        fine: 3,
        medium: 2
    },
    small: {
        fine: 5,
        medium: 3
    },
    medium: {
        fine: 7,
        medium: 5
    },
    large: {
        fine: 9,
        medium: 5
    },
    xlarge: {
        fine: 11,
        medium: 5
    }
};
var $db766d5667e55157$var$halfPad = $db766d5667e55157$export$4b69f06627bf215d = function halfPad(theme) {
    var _theme$dataChart;
    return (theme == null || (_theme$dataChart = theme.dataChart) == null ? void 0 : _theme$dataChart.halfPad) || {
        xlarge: 'large',
        large: 'medium',
        medium: 'small',
        small: 'xsmall',
        xsmall: 'xxsmall'
    };
};
var $db766d5667e55157$var$doublePad = $db766d5667e55157$export$d183fb34017af59a = {
    large: 'xlarge',
    medium: 'large',
    small: 'medium',
    xsmall: 'small',
    xxsmall: 'xsmall'
};
var $db766d5667e55157$var$getOrderedSizes = function getOrderedSizes(theme) {
    var _theme$dataChart2;
    return (theme == null || (_theme$dataChart2 = theme.dataChart) == null ? void 0 : _theme$dataChart2.orderedSizes) || [
        'xlarge',
        'large',
        'medium',
        'small',
        'xsmall',
        'xxsmall',
        'hair'
    ];
};
var $db766d5667e55157$var$showInUnits = $db766d5667e55157$export$e0a3b92a473ae138 = function showInUnits(content, maxValue) {
    var divideBy;
    var unit;
    var newContent = content;
    if (maxValue > 10000000) {
        divideBy = 1000000;
        unit = 'M';
    } else if (maxValue > 10000) {
        divideBy = 1000;
        unit = 'K';
    }
    if (divideBy) newContent = (0, $f6c8c05e7d725926$export$2077e0241d6afd3c)(newContent / divideBy, 0);
    if (unit) newContent = "" + newContent + unit;
    return newContent;
};
var $db766d5667e55157$var$largestSize = $db766d5667e55157$export$62334491c2ae55f8 = function largestSize(theme, size1, size2) {
    var orderedSizes = $db766d5667e55157$var$getOrderedSizes(theme);
    if (size1 && !size2) return size1;
    if (size2 && !size1) return size2;
    if (orderedSizes.indexOf(size1) < orderedSizes.indexOf(size2)) return size1;
    return size2;
};
var $db766d5667e55157$var$createDateFormat = $db766d5667e55157$export$e43fad80528301b6 = function createDateFormat(firstValue, lastValue, full) {
    var dateFormat;
    var startDate = new Date(firstValue);
    var endDate = new Date(lastValue);
    if (// check for valid dates, this is the fastest way
    !Number.isNaN(startDate.getTime()) && !Number.isNaN(endDate.getTime())) {
        var delta = Math.abs(endDate - startDate);
        var options;
        if (delta < 60000) // less than 1 minute
        options = full ? {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            day: undefined
        } : {
            second: '2-digit',
            day: undefined
        };
        else if (delta < 3600000) // less than 1 hour
        options = full ? {
            hour: 'numeric',
            minute: '2-digit',
            day: undefined
        } : {
            minute: '2-digit',
            day: undefined
        };
        else if (delta < 86400000) // less than 1 day
        options = {
            hour: 'numeric'
        };
        else if (delta < 2592000000) // less than 30 days
        options = {
            month: full ? 'short' : 'numeric',
            day: 'numeric'
        };
        else if (delta < 31557600000) // less than 1 year
        options = {
            month: full ? 'long' : 'short'
        };
        else options = {
            year: 'numeric'
        };
        if (options) dateFormat = new Intl.DateTimeFormat(undefined, options).format;
    }
    return dateFormat;
};
var $db766d5667e55157$var$minimum = $db766d5667e55157$export$916782c1f0ddb132 = function minimum(value1, value2) {
    return value1 !== undefined ? Math.min(value1, value2) : value2;
};
var $db766d5667e55157$var$maximum = $db766d5667e55157$export$b25e0be55f42c9a = function maximum(value1, value2) {
    return value1 !== undefined ? Math.max(value1, value2) : value2;
};


var $b389b37faa77c8cf$var$_excluded = [
    "values",
    "pad",
    "renderValue",
    "serie",
    "theme",
    "thickness"
];
function $b389b37faa77c8cf$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($b389b37faa77c8cf$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $b389b37faa77c8cf$var$_extends() {
    return $b389b37faa77c8cf$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b389b37faa77c8cf$var$_extends.apply(null, arguments);
}
function $b389b37faa77c8cf$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $b389b37faa77c8cf$var$onlyHorizontalPad = function onlyHorizontalPad(pad) {
    var result;
    if (pad) {
        if (typeof pad === 'string') result = {
            horizontal: pad
        };
        else result = {
            horizontal: pad.horizontal,
            start: pad.start,
            end: pad.end,
            left: pad.left,
            right: pad.right
        };
    }
    return result;
};
var $b389b37faa77c8cf$var$XAxis = $b389b37faa77c8cf$export$ea77231de273b52d = /*#__PURE__*/ (0, $b389b37faa77c8cf$var$_react.forwardRef)(function(_ref, ref) {
    var values = _ref.values, padProp = _ref.pad, renderValue = _ref.renderValue, serie = _ref.serie, theme = _ref.theme, thickness = _ref.thickness, rest = $b389b37faa77c8cf$var$_objectWithoutPropertiesLoose(_ref, $b389b37faa77c8cf$var$_excluded);
    var _ref2 = serie || {}, render = _ref2.render, suffix = _ref2.suffix;
    // pad to the edge of the thickness, for when padding is more than half
    // the thickness
    var pad = (0, $b389b37faa77c8cf$var$_react.useMemo)(function() {
        return thickness && padProp && {
            start: (0, $4113023f9e0bafa0$exports.edgeToNum)(padProp.start || padProp.horizontal, theme) - (0, $4113023f9e0bafa0$exports.edgeToNum)(thickness, theme) / 2 + "px",
            end: (0, $4113023f9e0bafa0$exports.edgeToNum)(padProp.end || padProp.horizontal, theme) - (0, $4113023f9e0bafa0$exports.edgeToNum)(thickness, theme) / 2 + "px"
        } || $b389b37faa77c8cf$var$onlyHorizontalPad(padProp);
    }, [
        padProp,
        theme,
        thickness
    ]);
    // When there are only labels at the end of the axis and there isn't
    // much space for them, let them take as much space as they like
    // flowing in from the edges.
    // Otherwise, align their container to the
    // data/guide lines and then let their content overflow that.
    var labelContainerProps = (0, $b389b37faa77c8cf$var$_react.useMemo)(function() {
        // 24px was chosen empirically as 48px is enough to show some simple text
        var centered = values.length !== 2 || (0, $4113023f9e0bafa0$exports.edgeToNum)((padProp == null ? void 0 : padProp.start) || (padProp == null ? void 0 : padProp.horizontal), theme) >= 24;
        if (centered) return {
            basis: thickness || '1px',
            overflow: 'visible',
            align: 'center'
        };
        return {};
    }, [
        padProp,
        theme,
        thickness,
        values
    ]);
    return /*#__PURE__*/ $b389b37faa77c8cf$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $b389b37faa77c8cf$var$_extends({
        ref: ref,
        gridArea: "xAxis",
        direction: "row",
        justify: "between",
        pad: pad
    }, rest), values.map(function(axisValue, i) {
        var content = serie ? renderValue(serie, axisValue) : axisValue;
        if (content === axisValue && !render && !suffix) {
            var maxValue = Math.max.apply(Math, values.map(function(v) {
                return Math.abs(v);
            }));
            content = (0, $db766d5667e55157$export$e0a3b92a473ae138)(content, maxValue);
        }
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        $b389b37faa77c8cf$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $b389b37faa77c8cf$var$_extends({
            key: i
        }, labelContainerProps), content));
    }));
});


var $3c4482142f55f495$export$1e511d4a378977f5;
var $3c4482142f55f495$export$f96c4024c52de8f4;
"use strict";
$3c4482142f55f495$export$1e511d4a378977f5 = true;
$3c4482142f55f495$export$f96c4024c52de8f4 = void 0;

var $3c4482142f55f495$var$_react = $3c4482142f55f495$var$_interopRequireWildcard((parcelRequire("2xPiy")));



function $3c4482142f55f495$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($3c4482142f55f495$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $3c4482142f55f495$var$_extends() {
    return $3c4482142f55f495$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3c4482142f55f495$var$_extends.apply(null, arguments);
}
var $3c4482142f55f495$var$onlyVerticalPad = function onlyVerticalPad(pad) {
    var result;
    if (pad) {
        if (typeof pad === 'string') result = {
            vertical: pad
        };
        else result = {
            vertical: pad.vertical,
            top: pad.top,
            bottom: pad.bottom
        };
    }
    return result;
};
var $3c4482142f55f495$var$YAxis = $3c4482142f55f495$export$f96c4024c52de8f4 = /*#__PURE__*/ (0, $3c4482142f55f495$var$_react.forwardRef)(function(_ref, ref) {
    var values = _ref.values, padProp = _ref.pad, renderValue = _ref.renderValue, serie = _ref.serie, theme = _ref.theme, thickness = _ref.thickness;
    var _ref2 = serie || {}, render = _ref2.render, suffix = _ref2.suffix;
    // pad to the edge of the thickness, for when padding is more than half
    // the thickness
    var pad = (0, $3c4482142f55f495$var$_react.useMemo)(function() {
        return padProp && thickness && {
            top: (0, $4113023f9e0bafa0$exports.edgeToNum)(padProp.top || padProp.vertical, theme) - (0, $4113023f9e0bafa0$exports.edgeToNum)(thickness, theme) / 2 + "px",
            bottom: (0, $4113023f9e0bafa0$exports.edgeToNum)(padProp.bottom || padProp.vertical, theme) - (0, $4113023f9e0bafa0$exports.edgeToNum)(thickness, theme) / 2 + "px"
        } || $3c4482142f55f495$var$onlyVerticalPad(padProp);
    }, [
        padProp,
        theme,
        thickness
    ]);
    // When there are only labels at the end of the axis and there isn't
    // much space for them, let them take as much space as they like
    // flowing in from the edges.
    // Otherwise, align their container to the
    // data/guide lines and then let their content overflow that.
    var labelContainerProps = (0, $3c4482142f55f495$var$_react.useMemo)(function() {
        // 24px was chosen empirically as 48px is enough to show some simple text
        var centered = values.length !== 2 || (0, $4113023f9e0bafa0$exports.edgeToNum)((padProp == null ? void 0 : padProp.start) || (padProp == null ? void 0 : padProp.horizontal), theme) >= 24;
        if (centered) return {
            basis: thickness || '1px',
            overflow: 'visible',
            justify: 'center'
        };
        return {};
    }, [
        padProp,
        theme,
        thickness,
        values
    ]);
    return /*#__PURE__*/ $3c4482142f55f495$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        ref: ref,
        gridArea: "yAxis",
        justify: "between",
        flex: true,
        pad: pad
    }, values.map(function(axisValue, i) {
        var content = serie ? renderValue(serie, axisValue, true) : axisValue;
        if (content === axisValue && !render && !suffix) {
            var maxValue = Math.max.apply(Math, values.map(function(v) {
                return Math.abs(v);
            }));
            content = (0, $db766d5667e55157$export$e0a3b92a473ae138)(content, maxValue);
        }
        return /*#__PURE__*/ $3c4482142f55f495$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $3c4482142f55f495$var$_extends({
            key: i,
            align: "end"
        }, labelContainerProps), content);
    }));
});


var $002eedfc8542d299$export$1e511d4a378977f5;
var $002eedfc8542d299$export$9881ef3fbedf2448;
"use strict";
$002eedfc8542d299$export$1e511d4a378977f5 = true;
$002eedfc8542d299$export$9881ef3fbedf2448 = void 0;

var $002eedfc8542d299$var$_react = $002eedfc8542d299$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $002eedfc8542d299$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($002eedfc8542d299$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $002eedfc8542d299$var$_extends() {
    return $002eedfc8542d299$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $002eedfc8542d299$var$_extends.apply(null, arguments);
}
var $002eedfc8542d299$var$XGuide = $002eedfc8542d299$export$9881ef3fbedf2448 = /*#__PURE__*/ (0, $002eedfc8542d299$var$_react.forwardRef)(function(_ref, ref) {
    var guide = _ref.guide, padArg = _ref.pad, thickness = _ref.thickness;
    var pad = padArg;
    if (thickness) {
        // omit any horizontal pad so the guides cover the thickness that
        // is within the pad
        if (typeof padArg === 'object') pad = $002eedfc8542d299$var$_extends({}, padArg, {
            top: 'none',
            bottom: 'none'
        });
        else if (typeof padArg === 'string') pad = {
            horizontal: padArg
        };
    }
    return /*#__PURE__*/ $002eedfc8542d299$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        ref: ref,
        fill: true,
        direction: "row",
        justify: "between",
        pad: pad,
        responsive: false
    }, Array.from({
        length: guide.x.count
    }).map(function(_, i) {
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        $002eedfc8542d299$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            key: i,
            border: "left"
        }));
    }));
});


var $8b78a20dde49ed0b$export$1e511d4a378977f5;
var $8b78a20dde49ed0b$export$b2ca9609f5e835a1;
"use strict";
$8b78a20dde49ed0b$export$1e511d4a378977f5 = true;
$8b78a20dde49ed0b$export$b2ca9609f5e835a1 = void 0;

var $8b78a20dde49ed0b$var$_react = $8b78a20dde49ed0b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $8b78a20dde49ed0b$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($8b78a20dde49ed0b$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $8b78a20dde49ed0b$var$_extends() {
    return $8b78a20dde49ed0b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8b78a20dde49ed0b$var$_extends.apply(null, arguments);
}
var $8b78a20dde49ed0b$var$YGuide = $8b78a20dde49ed0b$export$b2ca9609f5e835a1 = /*#__PURE__*/ (0, $8b78a20dde49ed0b$var$_react.forwardRef)(function(_ref, ref) {
    var guide = _ref.guide, padArg = _ref.pad, thickness = _ref.thickness;
    var pad = padArg;
    if (thickness) {
        // omit any horizontal pad so the guides cover the thickness that
        // is within the pad
        if (typeof padArg === 'object') pad = $8b78a20dde49ed0b$var$_extends({}, padArg, {
            start: 'none',
            end: 'none'
        });
        else if (typeof padArg === 'string') pad = {
            vertical: padArg
        };
    }
    return /*#__PURE__*/ $8b78a20dde49ed0b$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        ref: ref,
        fill: true,
        justify: "between",
        pad: pad,
        responsive: false
    }, Array.from({
        length: guide.y.count
    }).map(function(_, i) {
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        $8b78a20dde49ed0b$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            key: i,
            border: "top"
        }));
    }));
});



var $78e48c0aa97113c6$export$1e511d4a378977f5;
var $78e48c0aa97113c6$export$67bff0289e9bce98;
"use strict";
$78e48c0aa97113c6$export$1e511d4a378977f5 = true;
$78e48c0aa97113c6$export$67bff0289e9bce98 = void 0;

var $78e48c0aa97113c6$var$_propTypes = $78e48c0aa97113c6$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $78e48c0aa97113c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $78e48c0aa97113c6$var$_extends() {
    return $78e48c0aa97113c6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $78e48c0aa97113c6$var$_extends.apply(null, arguments);
}
var $78e48c0aa97113c6$var$colorType = $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
    $78e48c0aa97113c6$var$_propTypes["default"].string,
    $78e48c0aa97113c6$var$_propTypes["default"].arrayOf($78e48c0aa97113c6$var$_propTypes["default"].shape({
        color: $78e48c0aa97113c6$var$_propTypes["default"].string,
        value: $78e48c0aa97113c6$var$_propTypes["default"].number
    }))
]);
var $78e48c0aa97113c6$var$thicknessType = $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
    $78e48c0aa97113c6$var$_propTypes["default"].oneOf([
        'hair',
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge',
        'none'
    ]),
    $78e48c0aa97113c6$var$_propTypes["default"].string
]);
var $78e48c0aa97113c6$var$chartType = $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
    $78e48c0aa97113c6$var$_propTypes["default"].string,
    $78e48c0aa97113c6$var$_propTypes["default"].shape({
        property: $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
            $78e48c0aa97113c6$var$_propTypes["default"].string,
            $78e48c0aa97113c6$var$_propTypes["default"].arrayOf($78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
                $78e48c0aa97113c6$var$_propTypes["default"].string,
                $78e48c0aa97113c6$var$_propTypes["default"].shape({
                    property: $78e48c0aa97113c6$var$_propTypes["default"].string,
                    color: $78e48c0aa97113c6$var$colorType
                })
            ])),
            $78e48c0aa97113c6$var$_propTypes["default"].shape({
                color: $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
                    $78e48c0aa97113c6$var$_propTypes["default"].string,
                    $78e48c0aa97113c6$var$_propTypes["default"].shape({
                        property: $78e48c0aa97113c6$var$_propTypes["default"].string,
                        transform: $78e48c0aa97113c6$var$_propTypes["default"].func
                    })
                ]),
                thickness: $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
                    $78e48c0aa97113c6$var$_propTypes["default"].string,
                    $78e48c0aa97113c6$var$_propTypes["default"].shape({
                        property: $78e48c0aa97113c6$var$_propTypes["default"].string,
                        transform: $78e48c0aa97113c6$var$_propTypes["default"].func
                    })
                ]),
                x: $78e48c0aa97113c6$var$_propTypes["default"].string,
                y: $78e48c0aa97113c6$var$_propTypes["default"].string
            })
        ]),
        color: $78e48c0aa97113c6$var$colorType,
        dash: $78e48c0aa97113c6$var$_propTypes["default"].bool,
        opacity: $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
            $78e48c0aa97113c6$var$_propTypes["default"].oneOf([
                'weak',
                'medium',
                'strong'
            ]),
            $78e48c0aa97113c6$var$_propTypes["default"].number,
            $78e48c0aa97113c6$var$_propTypes["default"].bool
        ]),
        point: $5897bd367fbd90c1$export$fe1f7946fa764688,
        round: $78e48c0aa97113c6$var$_propTypes["default"].bool,
        thickness: $78e48c0aa97113c6$var$thicknessType,
        type: $78e48c0aa97113c6$var$_propTypes["default"].oneOf([
            'bar',
            'bars',
            'line',
            'area',
            'areas',
            'lines',
            'point'
        ])
    })
]);
var $78e48c0aa97113c6$var$seriesType = $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
    $78e48c0aa97113c6$var$_propTypes["default"].string,
    // property
    $78e48c0aa97113c6$var$_propTypes["default"].shape({
        label: $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
            $78e48c0aa97113c6$var$_propTypes["default"].string
        ]),
        prefix: $78e48c0aa97113c6$var$_propTypes["default"].string,
        property: $78e48c0aa97113c6$var$_propTypes["default"].string,
        render: $78e48c0aa97113c6$var$_propTypes["default"].func,
        suffix: $78e48c0aa97113c6$var$_propTypes["default"].string
    })
]);
var $78e48c0aa97113c6$var$granularityType = $78e48c0aa97113c6$var$_propTypes["default"].oneOf([
    'coarse',
    'medium',
    'fine'
]);
var $78e48c0aa97113c6$var$PropType = {};
$78e48c0aa97113c6$var$PropType = $78e48c0aa97113c6$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    axis: $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
        $78e48c0aa97113c6$var$_propTypes["default"].bool,
        $78e48c0aa97113c6$var$_propTypes["default"].shape({
            x: $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
                $78e48c0aa97113c6$var$_propTypes["default"].bool,
                $78e48c0aa97113c6$var$_propTypes["default"].string,
                $78e48c0aa97113c6$var$_propTypes["default"].shape({
                    property: $78e48c0aa97113c6$var$_propTypes["default"].string,
                    granularity: $78e48c0aa97113c6$var$granularityType
                })
            ]),
            y: $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
                $78e48c0aa97113c6$var$_propTypes["default"].bool,
                $78e48c0aa97113c6$var$_propTypes["default"].string,
                $78e48c0aa97113c6$var$_propTypes["default"].shape({
                    property: $78e48c0aa97113c6$var$_propTypes["default"].string,
                    granularity: $78e48c0aa97113c6$var$granularityType
                })
            ])
        })
    ]),
    bounds: $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
        $78e48c0aa97113c6$var$_propTypes["default"].oneOf([
            'align'
        ]),
        $78e48c0aa97113c6$var$_propTypes["default"].shape({
            x: $78e48c0aa97113c6$var$_propTypes["default"].arrayOf($78e48c0aa97113c6$var$_propTypes["default"].number),
            y: $78e48c0aa97113c6$var$_propTypes["default"].arrayOf($78e48c0aa97113c6$var$_propTypes["default"].number)
        })
    ]),
    chart: $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
        $78e48c0aa97113c6$var$chartType,
        $78e48c0aa97113c6$var$_propTypes["default"].arrayOf($78e48c0aa97113c6$var$chartType)
    ]),
    data: $78e48c0aa97113c6$var$_propTypes["default"].arrayOf($78e48c0aa97113c6$var$_propTypes["default"].shape({})),
    detail: $78e48c0aa97113c6$var$_propTypes["default"].bool,
    direction: $78e48c0aa97113c6$var$_propTypes["default"].oneOf([
        'horizontal',
        'vertical'
    ]),
    gap: $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
        $78e48c0aa97113c6$var$_propTypes["default"].oneOf([
            'none',
            'xxsmall',
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        $78e48c0aa97113c6$var$_propTypes["default"].string
    ]),
    guide: $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
        $78e48c0aa97113c6$var$_propTypes["default"].bool,
        $78e48c0aa97113c6$var$_propTypes["default"].shape({
            x: $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
                $78e48c0aa97113c6$var$_propTypes["default"].bool,
                $78e48c0aa97113c6$var$_propTypes["default"].shape({
                    granularity: $78e48c0aa97113c6$var$granularityType
                })
            ]),
            y: $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
                $78e48c0aa97113c6$var$_propTypes["default"].bool,
                $78e48c0aa97113c6$var$_propTypes["default"].shape({
                    granularity: $78e48c0aa97113c6$var$granularityType
                })
            ])
        })
    ]),
    legend: $78e48c0aa97113c6$var$_propTypes["default"].bool,
    offset: $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
        $78e48c0aa97113c6$var$_propTypes["default"].bool,
        $78e48c0aa97113c6$var$_propTypes["default"].shape({
            gap: $78e48c0aa97113c6$var$thicknessType
        })
    ]),
    pad: $5897bd367fbd90c1$export$b91a2ef62736aae3,
    placeholder: $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
        $78e48c0aa97113c6$var$_propTypes["default"].string,
        $78e48c0aa97113c6$var$_propTypes["default"].node
    ]),
    series: $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
        $78e48c0aa97113c6$var$seriesType,
        $78e48c0aa97113c6$var$_propTypes["default"].arrayOf($78e48c0aa97113c6$var$seriesType)
    ]),
    size: $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
        $78e48c0aa97113c6$var$_propTypes["default"].oneOf([
            'xxsmall',
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            'fill',
            'full'
        ]),
        $78e48c0aa97113c6$var$_propTypes["default"].shape({
            height: $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
                $78e48c0aa97113c6$var$_propTypes["default"].oneOf([
                    'xxsmall',
                    'xsmall',
                    'small',
                    'medium',
                    'large',
                    'xlarge',
                    'fill'
                ]),
                $78e48c0aa97113c6$var$_propTypes["default"].string
            ]),
            width: $78e48c0aa97113c6$var$_propTypes["default"].oneOfType([
                $78e48c0aa97113c6$var$_propTypes["default"].oneOf([
                    'xxsmall',
                    'xsmall',
                    'small',
                    'medium',
                    'large',
                    'xlarge',
                    'fill',
                    'auto'
                ]),
                $78e48c0aa97113c6$var$_propTypes["default"].string
            ])
        })
    ])
});
var $78e48c0aa97113c6$var$DataChartPropTypes = $78e48c0aa97113c6$export$67bff0289e9bce98 = $78e48c0aa97113c6$var$PropType;



var $ffaff9bfe81e5fa0$var$_excluded = [
    "a11yTitle",
    "axis",
    "bounds",
    "chart",
    "data",
    "detail",
    "direction",
    "gap",
    "guide",
    "legend",
    "offset",
    "placeholder",
    "pad",
    "series",
    "size"
], $ffaff9bfe81e5fa0$var$_excluded2 = [
    "property"
], $ffaff9bfe81e5fa0$var$_excluded3 = [
    "property",
    "type",
    "x",
    "y"
], $ffaff9bfe81e5fa0$var$_excluded4 = [
    "property"
];
function $ffaff9bfe81e5fa0$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($ffaff9bfe81e5fa0$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $ffaff9bfe81e5fa0$var$_extends() {
    return $ffaff9bfe81e5fa0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ffaff9bfe81e5fa0$var$_extends.apply(null, arguments);
}
function $ffaff9bfe81e5fa0$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $ffaff9bfe81e5fa0$var$stackedChartType = {
    areas: 'area',
    bars: 'bar',
    lines: 'line'
};
// DataChart takes a generic data array of objects plus as few properties
// as possible, and creates a Stack of Charts with x and y axes, a legend,
// and interactive detail.
// Much of the code here-in involves the "few properties" aspect where we
// normalize and automatically handle whatever the caller didn't specify.
var $ffaff9bfe81e5fa0$var$DataChart = $ffaff9bfe81e5fa0$export$56fe02f8cb89ca83 = /*#__PURE__*/ (0, $ffaff9bfe81e5fa0$var$_react.forwardRef)(function(_ref, ref) {
    var _theme$dataChart3, _boundsProp$x, _boundsProp$y, _theme$dataChart4;
    var a11yTitle = _ref.a11yTitle, _ref$axis = _ref.axis, axisProp = _ref$axis === void 0 ? true : _ref$axis, _ref$bounds = _ref.bounds, boundsProp = _ref$bounds === void 0 ? 'align' : _ref$bounds, chartProp = _ref.chart, _ref$data = _ref.data, data = _ref$data === void 0 ? [] : _ref$data, detail = _ref.detail, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? 'vertical' : _ref$direction, gap = _ref.gap, guideProp = _ref.guide, legend = _ref.legend, offset = _ref.offset, placeholder = _ref.placeholder, padProp = _ref.pad, seriesProp = _ref.series, size = _ref.size, rest = $ffaff9bfe81e5fa0$var$_objectWithoutPropertiesLoose(_ref, $ffaff9bfe81e5fa0$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    // legend interaction, if any
    var _useState = (0, $ffaff9bfe81e5fa0$var$_react.useState)(), activeProperty = _useState[0], setActiveProperty = _useState[1];
    var horizontal = (0, $ffaff9bfe81e5fa0$var$_react.useMemo)(function() {
        return direction === 'horizontal';
    }, [
        direction
    ]);
    // normalize seriesProp to an array of objects, one per property
    var series = (0, $ffaff9bfe81e5fa0$var$_react.useMemo)(function() {
        if (Array.isArray(seriesProp)) return seriesProp.filter(function(s) {
            return s.property || typeof s === 'string';
        }).map(function(s) {
            return typeof s === 'string' ? {
                property: s
            } : s;
        });
        if (typeof seriesProp === 'string') return [
            {
                property: seriesProp
            }
        ];
        if (seriesProp) return [
            seriesProp
        ];
        return [];
    }, [
        seriesProp
    ]);
    var getPropertySeries = function getPropertySeries(prop) {
        return series.find(function(_ref2) {
            var property = _ref2.property;
            return prop === property;
        });
    };
    // Normalize chartProp to an array of objects.
    // Each chart has one or more properties associated with it.
    // A stacked bar or area chart has an array of properties.
    // A point chart can have x, y, thickness, and color each driven
    // by a separate property.
    var charts = (0, $ffaff9bfe81e5fa0$var$_react.useMemo)(function() {
        if (!chartProp) {
            if (series.length === 1) return series.filter(function(s) {
                return s.property;
            }).map(function(s) {
                return {
                    property: s.property
                };
            });
            // if we have more than one property, we'll use the first for
            // the x-axis and we'll plot the rest
            return series.slice(1).map(function(s) {
                return {
                    property: s.property
                };
            });
        }
        if (Array.isArray(chartProp)) return chartProp.map(function(c) {
            return typeof c === 'string' ? {
                property: c
            } : c;
        }).filter(function(_ref3) {
            var property = _ref3.property;
            return property;
        });
        if (typeof chartProp === 'string') return [
            {
                property: chartProp
            }
        ];
        if (chartProp) return [
            chartProp
        ];
        return [];
    }, [
        chartProp,
        series
    ]);
    // map the series property values into their own arrays
    var seriesValues = (0, $ffaff9bfe81e5fa0$var$_react.useMemo)(function() {
        var result = {};
        series.forEach(function(_ref4) {
            var property = _ref4.property;
            result[property] = data.map(function(d) {
                return d[property];
            });
        });
        return result;
    }, [
        data,
        series
    ]);
    // Setup the values property for each chart.
    // The index into 'charts' can be used to index into 'chartValues'.
    var chartValues = (0, $ffaff9bfe81e5fa0$var$_react.useMemo)(function() {
        return charts.map(function(_ref5) {
            var opacity = _ref5.opacity, property = _ref5.property, type = _ref5.type;
            if (property) {
                if (Array.isArray(property)) {
                    // A range chart or a stacked bar or area chart has multiple
                    // properties.
                    // In this case, this returns an array of values,
                    // one per property.
                    if ($ffaff9bfe81e5fa0$var$stackedChartType[type]) {
                        // Further down, where we render, each property is rendered
                        // using a separate Chart component and the values are stacked
                        // such that they line up appropriately.
                        var totals = [];
                        return property.map(function(cp) {
                            // handle object or string
                            var aProperty = cp.property || cp;
                            var values = seriesValues[aProperty];
                            if (!values) return undefined; // property name isn't valid
                            return values.map(function(v, i) {
                                var base = totals[i] || 0;
                                totals[i] = base + v;
                                if (type === 'lines') return [
                                    i,
                                    base + v
                                ];
                                return [
                                    i,
                                    base,
                                    base + v
                                ];
                            });
                        });
                    }
                    return data.map(function(_, index) {
                        return [
                            index
                        ].concat(property.map(function(p) {
                            return seriesValues[p] ? seriesValues[p][index] : data[index][p];
                        }));
                    });
                }
                if (typeof property === 'object') {
                    // When 'property' is an array, the keys of this array indicate
                    // which property drives which part of the rendered Chart.
                    var color = property.color, thickness = property.thickness, x = property.x, y = property.y, y2 = property.y2;
                    return seriesValues[x].map(function(value, index) {
                        var aValue = {
                            value: [
                                value
                            ]
                        };
                        aValue.value.push(seriesValues[y][index]);
                        if (y2) aValue.value.push(seriesValues[y2][index]);
                        if (thickness) {
                            var t = seriesValues[thickness.property || thickness][index];
                            aValue.thickness = thickness.transform ? thickness.transform(t) : t;
                        }
                        if (color) {
                            var c = seriesValues[color.property || color][index];
                            aValue.color = color.transform ? color.transform(c) : c;
                        }
                        if (opacity) aValue.opacity = opacity;
                        return aValue;
                    });
                }
                return seriesValues[property];
            }
            return undefined;
        });
    }, [
        charts,
        data,
        seriesValues
    ]);
    // map granularities to work well with the number of data points we have
    var granularities = (0, $ffaff9bfe81e5fa0$var$_react.useMemo)(function() {
        var _theme$dataChart, _theme$dataChart$size;
        var medium;
        // determine a good medium granularity that will align well with the
        // length of the data
        var steps = data.length - 1;
        // special case property driven point charts
        if (charts[0] && typeof charts[0].property === 'object') medium = 3;
        else if (steps < 4) medium = data.length;
        else if (steps === 4) medium = 3;
        else if (steps % 4 === 0) medium = 5;
        else if (steps % 3 === 0) medium = 4;
        else if (steps % 2 === 0) medium = 3;
        else medium = 2;
        var granularity0 = {
            coarse: Math.min(data.length, 2),
            fine: data.length,
            medium: medium
        };
        var yGranularity = ((_theme$dataChart = theme.dataChart) == null || (_theme$dataChart = _theme$dataChart.granularity) == null ? void 0 : _theme$dataChart.y) || $db766d5667e55157$export$9baa821c53e22211;
        var granularity1 = $ffaff9bfe81e5fa0$var$_extends({}, yGranularity[size && size.height || ((_theme$dataChart$size = theme.dataChart.size) == null ? void 0 : _theme$dataChart$size.height)] || {
            fine: 5,
            medium: 3
        }, {
            coarse: 2
        });
        return horizontal ? {
            x: granularity1,
            y: granularity0
        } : {
            x: granularity0,
            y: granularity1
        };
    }, [
        charts,
        data.length,
        horizontal,
        size,
        theme
    ]);
    // normalize axis to objects, convert granularity to a number
    var axis = (0, $ffaff9bfe81e5fa0$var$_react.useMemo)(function() {
        if (!axisProp) return undefined;
        var result = {};
        if (axisProp === true || axisProp.x === true) result.x = {};
        if (axisProp === true || axisProp.y === true) result.y = {};
        if (!result.x && axisProp.x) result.x = typeof axisProp.x === 'string' ? {
            property: axisProp.x
        } : $ffaff9bfe81e5fa0$var$_extends({}, axisProp.x);
        if (!result.y && axisProp.y) result.y = typeof axisProp.y === 'string' ? {
            property: axisProp.y
        } : $ffaff9bfe81e5fa0$var$_extends({}, axisProp.y);
        if (result.x) {
            if (!result.x.property) {
                // see if we have a point chart that has an x property
                if (horizontal) {
                    if (charts[0]) result.x.property = charts[0].property.x || charts[0].property;
                } else if (data && data[0]) {
                    if (data[0].date) result.x.property = 'date';
                    else if (data[0].time) result.x.property = 'time';
                }
            }
            if (!result.x.granularity) result.x.granularity = 'coarse';
        }
        if (result.y) {
            if (!result.y.property) {
                // see if we have a point chart that has an y property
                if (horizontal) {
                    if (data && data[0]) {
                        if (data[0].date) result.y.property = 'date';
                        else if (data[0].time) result.y.property = 'time';
                    }
                } else if (charts[0]) result.y.property = charts[0].property.y || charts[0].property;
            }
            if (!result.y.granularity) result.y.granularity = 'coarse';
        }
        // calculate number of entries based on granularity
        if (result.x) {
            var _result$x$granularity = result.x.granularity, granularity = _result$x$granularity === void 0 ? 'coarse' : _result$x$granularity;
            result.x.count = granularities.x[granularity];
        }
        if (result.y) {
            var _result$y$granularity = result.y.granularity, _granularity = _result$y$granularity === void 0 ? 'coarse' : _result$y$granularity;
            result.y.count = granularities.y[_granularity];
        }
        return result;
    }, [
        axisProp,
        data,
        charts,
        granularities,
        horizontal
    ]);
    // calculate axis, bounds, and thickness for each chart
    var chartProps = (0, $ffaff9bfe81e5fa0$var$_react.useMemo)(function() {
        var steps = {};
        var coarseness = horizontal ? [
            5,
            undefined
        ] : [
            undefined,
            5
        ];
        if (axis && axis.x) {
            var _axis$x$granularity = axis.x.granularity, granularity = _axis$x$granularity === void 0 ? 'coarse' : _axis$x$granularity;
            steps.x = granularities.x[granularity] - 1;
        } else steps.x = horizontal ? 1 : data.length - 1;
        if (axis && axis.y) {
            var _axis$y$granularity = axis.y.granularity, _granularity2 = _axis$y$granularity === void 0 ? 'coarse' : _axis$y$granularity;
            steps.y = granularities.y[_granularity2] - 1;
        } else steps.y = horizontal ? data.length - 1 : 1;
        var chartBounds = chartValues.map(function(_, index) {
            var type = charts[index].type;
            if ($ffaff9bfe81e5fa0$var$stackedChartType[type]) {
                var _chartValues$index;
                // merge values for bars, areas, and lines cases
                var mergedValues = ((_chartValues$index = chartValues[index]) == null || (_chartValues$index = _chartValues$index[0]) == null ? void 0 : _chartValues$index.slice(0)) || [];
                chartValues[index].slice(1) // skip first index as that is the x value
                .filter(function(values) {
                    return values;
                }) // property name isn't valid
                .forEach(function(values) {
                    mergedValues = mergedValues.map(function(__, i) {
                        return type === 'lines' ? [
                            i,
                            Math.min(mergedValues[i][1], values[i][1]),
                            Math.max(mergedValues[i][1], values[i][1])
                        ] : [
                            i,
                            Math.min(mergedValues[i][1], values[i][1]),
                            Math.max(mergedValues[i][2], values[i][2])
                        ];
                    });
                });
                return (0, $f6c8c05e7d725926$export$de5d4336bd2f6d1d)(mergedValues, {
                    coarseness: coarseness,
                    direction: direction,
                    steps: steps
                });
            }
            // if this is a data driven x chart, set coarseness for x
            return (0, $f6c8c05e7d725926$export$de5d4336bd2f6d1d)(chartValues[index], {
                coarseness: charts[index].property.x ? {
                    x: 5,
                    y: 5
                } : coarseness,
                direction: direction,
                steps: steps
            });
        });
        if (boundsProp === 'align' && chartBounds.length) {
            var alignedBounds = {
                x: {},
                y: {}
            };
            chartBounds.forEach(function(bounds) {
                alignedBounds.x.min = (0, $db766d5667e55157$export$916782c1f0ddb132)(alignedBounds.x.min, bounds.x.min);
                alignedBounds.x.max = (0, $db766d5667e55157$export$b25e0be55f42c9a)(alignedBounds.x.max, bounds.x.max);
                alignedBounds.y.min = (0, $db766d5667e55157$export$916782c1f0ddb132)(alignedBounds.y.min, bounds.y.min);
                alignedBounds.y.max = (0, $db766d5667e55157$export$b25e0be55f42c9a)(alignedBounds.y.max, bounds.y.max);
            });
            chartBounds = chartBounds.map(function() {
                return alignedBounds;
            });
        }
        return chartValues.map(function(values, index) {
            var _charts$index = charts[index], thickness = _charts$index.thickness, type = _charts$index.type;
            var calcValues = $ffaff9bfe81e5fa0$var$stackedChartType[type] ? values[0] : values;
            return (0, $f6c8c05e7d725926$export$f210a4934359ec3b)(calcValues, {
                bounds: chartBounds[index],
                direction: direction,
                steps: steps,
                thickness: thickness,
                theme: theme
            });
        });
    }, [
        axis,
        boundsProp,
        charts,
        chartValues,
        data,
        direction,
        granularities,
        horizontal,
        theme
    ]);
    // normalize how we style data properties for use by Legend and Detail
    var seriesStyles = (0, $ffaff9bfe81e5fa0$var$_react.useMemo)(function() {
        var result = {};
        // start from what we were explicitly given
        charts.forEach(function(chart, index) {
            var calcThickness = chartProps[index].thickness;
            if (typeof chart.property === 'object' && !Array.isArray(chart.property)) // data driven point chart
            Object.keys(chart.property).forEach(function(aspect) {
                var prop = chart.property[aspect];
                if (!result[prop.property || prop]) result[prop.property || prop] = {
                    aspect: aspect
                };
            });
            else {
                var setPropertyStyle = function setPropertyStyle(_ref6) {
                    var property = _ref6.property, styles = $ffaff9bfe81e5fa0$var$_objectWithoutPropertiesLoose(_ref6, $ffaff9bfe81e5fa0$var$_excluded2);
                    // keep what we've got, use what is new
                    result[property] = $ffaff9bfe81e5fa0$var$_extends({}, styles, result[property] || {});
                    // unless the new style is has no opacity
                    if (!styles.opacity) delete result[property].opacity;
                    if (styles.type === 'point') result[property].point = false;
                    if (calcThickness && !result[property].thickness) result[property].thickness = calcThickness;
                };
                if (Array.isArray(chart.property)) chart.property.forEach(function(prop) {
                    if (typeof prop === 'string') setPropertyStyle($ffaff9bfe81e5fa0$var$_extends({}, chart, {
                        property: prop
                    }));
                    else if (typeof prop === 'object') setPropertyStyle($ffaff9bfe81e5fa0$var$_extends({}, chart, prop));
                });
                else if (typeof chart === 'object') setPropertyStyle(chart);
                else if (typeof chart === 'string') setPropertyStyle({
                    property: chart
                });
            }
        });
        // set color for any non-aspect properties we don't have one for yet
        var colorIndex = 0;
        var pointIndex = 0;
        Object.keys(result).forEach(function(key) {
            var seriesStyle = result[key];
            if (!seriesStyle.aspect && !seriesStyle.color) {
                var _theme$dataChart2;
                if (((_theme$dataChart2 = theme.dataChart) == null || (_theme$dataChart2 = _theme$dataChart2.colors) == null ? void 0 : _theme$dataChart2.length) > 0) seriesStyle.color = theme.dataChart.colors[colorIndex % theme.dataChart.colors.length];
                else seriesStyle.color = "graph-" + colorIndex;
                colorIndex += 1;
            }
            // set opacity if it isn't set and this isn't the active property
            if (activeProperty !== undefined && activeProperty !== key) seriesStyle.opacity = 'medium';
            if (seriesStyle.point === false) {
                seriesStyle.point = $db766d5667e55157$export$9f048bf86ee2e9d2[pointIndex];
                pointIndex += 1;
            }
        });
        return result;
    }, [
        activeProperty,
        charts,
        chartProps,
        (_theme$dataChart3 = theme.dataChart) == null ? void 0 : _theme$dataChart3.colors
    ]);
    // normalize guide
    var guide = (0, $ffaff9bfe81e5fa0$var$_react.useMemo)(function() {
        if (!guideProp) return undefined;
        var result;
        if (guideProp === true) result = {
            x: {},
            y: {}
        };
        else {
            result = {};
            if (guideProp.x) result.x = $ffaff9bfe81e5fa0$var$_extends({}, guideProp.x);
            if (guideProp.y) result.y = $ffaff9bfe81e5fa0$var$_extends({}, guideProp.y);
        }
        // set counts
        if (result.x) {
            // if no granularity and axis, align count with axis
            if (!result.x.granularity && axis && axis.x) result.x.count = axis.x.count;
            if (!result.x.count) result.x.count = granularities.x[result.x.granularity || 'coarse'];
        }
        if (result.y) {
            // if no granularity and axis, align count with axis
            if (!result.y.granularity && axis && axis.y) result.y.count = axis.y.count;
            if (!result.y.count) result.y.count = granularities.y[result.y.granularity || 'coarse'];
        }
        return result;
    }, [
        axis,
        granularities,
        guideProp
    ]);
    // set the pad to half the thickness, based on the chart types
    // except when using offset, then add even more horizontal pad
    var pad = (0, $ffaff9bfe81e5fa0$var$_react.useMemo)(function() {
        if (padProp !== undefined) return padProp;
        var pad0;
        var pad1;
        var halfPadValues = (0, $db766d5667e55157$export$4b69f06627bf215d)(theme);
        charts.forEach(function(_ref7, index) {
            var type = _ref7.type;
            var thickness = chartProps[index].thickness;
            pad0 = (0, $db766d5667e55157$export$62334491c2ae55f8)(theme, pad0, halfPadValues[thickness]);
            if (type && type !== 'bar') pad1 = (0, $db766d5667e55157$export$62334491c2ae55f8)(theme, pad1, halfPadValues[thickness]);
        });
        return horizontal ? {
            horizontal: pad1,
            vertical: pad0
        } : {
            horizontal: pad0,
            vertical: pad1
        };
    }, [
        chartProps,
        charts,
        horizontal,
        padProp,
        theme
    ]);
    // calculate the thickness in pixels of each chart
    var thicknesses = (0, $ffaff9bfe81e5fa0$var$_react.useMemo)(function() {
        return offset ? charts.map(function(_, index) {
            var thickness = chartProps[index].thickness;
            return (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.edgeSize[thickness] || thickness);
        }) : undefined;
    }, [
        charts,
        chartProps,
        offset,
        theme
    ]);
    // normalize any offset gap
    var offsetGap = (0, $ffaff9bfe81e5fa0$var$_react.useMemo)(function() {
        return (offset == null ? void 0 : offset.gap) && (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.edgeSize[offset.gap] || offset.gap) || 0;
    }, [
        offset,
        theme
    ]);
    // calculate the offset for each chart, which is a sum of the thicknesses
    // any offset gaps that preceded it
    var offsets = (0, $ffaff9bfe81e5fa0$var$_react.useMemo)(function() {
        if (offset) return thicknesses.map(function(t, i) {
            return thicknesses.slice(0, i).reduce(function(a, b) {
                return a + b + offsetGap;
            }, 0);
        });
        return undefined;
    }, [
        offset,
        offsetGap,
        thicknesses
    ]);
    // Calculate the total pad we should add to the end of each chart.
    // We do this to shrink the width of each chart so we can shift them
    // via `translate` and have them take up the right amount of width.
    var offsetPad = (0, $ffaff9bfe81e5fa0$var$_react.useMemo)(function() {
        return offsets ? offsets[offsets.length - 1] + thicknesses[thicknesses.length - 1] + "px" : undefined;
    }, [
        offsets,
        thicknesses
    ]);
    // The thickness of the segments. We need to convert to numbers
    // to be able to compare across charts where some might be using T-shirt
    // labels and others might be pixel values.
    var segmentThickness = (0, $ffaff9bfe81e5fa0$var$_react.useMemo)(function() {
        var result = 0;
        charts.forEach(function(_, index) {
            var thickness = chartProps[index].thickness;
            result = Math.max(result, (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.edgeSize[thickness] || thickness));
        });
        return result + "px";
    }, [
        charts,
        chartProps,
        theme
    ]);
    var dateFormats = (0, $ffaff9bfe81e5fa0$var$_react.useMemo)(function() {
        var result = {};
        var full = axis && axis.x && axis.x.granularity === 'coarse';
        series.forEach(function(_ref8) {
            var property = _ref8.property, render = _ref8.render;
            if (!render && data.length > 1 && typeof data[0][property] === 'string') result[property] = (0, $db766d5667e55157$export$e43fad80528301b6)(data[0][property], data[data.length - 1][property], full);
        });
        return result;
    }, [
        axis,
        data,
        series
    ]);
    var renderValue = function renderValue(serie, axisValue, y) {
        if (serie === void 0) serie = {};
        var _serie = serie, prefix = _serie.prefix, property = _serie.property, render = _serie.render, suffix = _serie.suffix;
        var value = axisValue;
        if (value !== undefined) {
            if (!property || !horizontal && y || horizontal && !y) {
                if (render) return render(value);
            } else {
                var datum = data[axisValue];
                value = datum[property];
                if (render) return render(value, datum, property);
            }
            if (property) {
                var dateFormat = dateFormats[property];
                if (dateFormat) return dateFormat(new Date(value));
                if (prefix) value = "" + prefix + value;
                if (suffix) value = "" + value + suffix;
            }
        }
        return value;
    };
    // TODO: revisit how x/y axis are hooked up to charts and series
    var xAxisElement = axis && axis.x && (chartProps.length || boundsProp != null && boundsProp.x) ? /*#__PURE__*/ $ffaff9bfe81e5fa0$var$_react["default"].createElement($b389b37faa77c8cf$export$ea77231de273b52d, {
        axis: axis,
        values: (boundsProp == null || (_boundsProp$x = boundsProp.x) == null ? void 0 : _boundsProp$x.slice(0)) || (Array.isArray(chartProps[0]) ? chartProps[0][0] : chartProps[0]).axis.x,
        pad: !horizontal && offsetPad ? $ffaff9bfe81e5fa0$var$_extends({}, pad, {
            end: offsetPad
        }) : pad,
        renderValue: renderValue,
        serie: axis.x.property && getPropertySeries(axis.x.property),
        style: offsetPad ? {
            transform: "translate(" + offsets[Math.floor(offsets.length / 2)] + "px, 0px)"
        } : {},
        thickness: horizontal ? undefined : segmentThickness,
        theme: theme
    }) : null;
    var yAxisElement = axis && axis.y && (chartProps.length || boundsProp != null && boundsProp.y) ? /*#__PURE__*/ $ffaff9bfe81e5fa0$var$_react["default"].createElement($3c4482142f55f495$export$f96c4024c52de8f4, {
        axis: axis,
        values: (boundsProp == null || (_boundsProp$y = boundsProp.y) == null ? void 0 : _boundsProp$y.slice(0).reverse()) || (Array.isArray(chartProps[0]) ? chartProps[0][0] : chartProps[0]).axis.y,
        pad: horizontal && offsetPad ? $ffaff9bfe81e5fa0$var$_extends({}, pad, {
            bottom: offsetPad
        }) : pad,
        renderValue: renderValue,
        serie: axis.y.property && getPropertySeries(axis.y.property),
        thickness: horizontal ? segmentThickness : undefined,
        theme: theme
    }) : null;
    var stackFill = (0, $ffaff9bfe81e5fa0$var$_react.useMemo)(function() {
        if (size === 'fill' || size && size.width === 'fill' && size.height === 'fill') return true;
        if (size && size.width === 'fill') return 'horizontal';
        if (size && size.height === 'fill') return 'vertical';
        return undefined;
    }, [
        size
    ]);
    var guidingChild = (0, $ffaff9bfe81e5fa0$var$_react.useMemo)(function() {
        var result = 0;
        if (guide && guide.x) result += 1;
        if (guide && guide.y) result += 1;
        return result;
    }, [
        guide
    ]);
    var stackElement = /*#__PURE__*/ $ffaff9bfe81e5fa0$var$_react["default"].createElement($8c60273918bcf71f$export$694e0d28c7ffc90c, {
        gridArea: "charts",
        guidingChild: guidingChild,
        fill: stackFill
    }, guide && guide.x && /*#__PURE__*/ $ffaff9bfe81e5fa0$var$_react["default"].createElement($002eedfc8542d299$export$9881ef3fbedf2448, {
        guide: guide,
        pad: pad,
        thickness: horizontal
    }), guide && guide.y && /*#__PURE__*/ $ffaff9bfe81e5fa0$var$_react["default"].createElement($8b78a20dde49ed0b$export$b2ca9609f5e835a1, {
        guide: guide,
        pad: pad,
        thickness: !horizontal
    }), charts.map(function(_ref9, i) {
        var prop = _ref9.property, type = _ref9.type, x = _ref9.x, y = _ref9.y, chartRest = $ffaff9bfe81e5fa0$var$_objectWithoutPropertiesLoose(_ref9, $ffaff9bfe81e5fa0$var$_excluded3);
        // When we offset, we increase the padding on the end for all charts
        // by the same amount and we shift each successive chart to the
        // right by an offset for that chart. The last chart's right side
        // will end up aligning with where the charts would have been
        // had we not padded their ends.
        var chartPad = offsetPad ? $ffaff9bfe81e5fa0$var$_extends({}, pad, {
            end: offsetPad
        }) : pad;
        var offsetProps = offsetPad ? {
            style: {
                transform: "translate(" + offsets[i] + "px, 0px)"
            }
        } : {};
        if ($ffaff9bfe81e5fa0$var$stackedChartType[type]) // reverse to ensure area Charts are stacked in the right order
        return prop.map(function(cProp, j) {
            var pProp = cProp.property || cProp;
            var _ref0 = typeof cProp === 'object' ? cProp : {}, property = _ref0.property, propRest = $ffaff9bfe81e5fa0$var$_objectWithoutPropertiesLoose(_ref0, $ffaff9bfe81e5fa0$var$_excluded4);
            return /*#__PURE__*/ $ffaff9bfe81e5fa0$var$_react["default"].createElement($f6c8c05e7d725926$export$acaa6426d77a227e, $ffaff9bfe81e5fa0$var$_extends({
                key: j,
                values: chartValues[i][j] || [],
                overflow: true,
                direction: direction
            }, seriesStyles[pProp], chartProps[i], chartRest, propRest, offsetProps, {
                type: $ffaff9bfe81e5fa0$var$stackedChartType[type] || type,
                size: size,
                pad: chartPad
            }));
        }).reverse();
        return /*#__PURE__*/ $ffaff9bfe81e5fa0$var$_react["default"].createElement($f6c8c05e7d725926$export$acaa6426d77a227e, $ffaff9bfe81e5fa0$var$_extends({
            key: i,
            values: chartValues[i],
            overflow: true,
            direction: direction
        }, seriesStyles[prop], chartProps[i], chartRest, offsetProps, {
            type: type,
            size: size,
            pad: chartPad
        }));
    }), placeholder && (typeof placeholder === 'string' && /*#__PURE__*/ $ffaff9bfe81e5fa0$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        fill: "vertical",
        align: "center",
        justify: "center",
        background: {
            color: 'background-front',
            opacity: 'strong'
        },
        margin: pad
    }, /*#__PURE__*/ $ffaff9bfe81e5fa0$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, {
        color: "text-weak"
    }, placeholder)) || placeholder), detail && /*#__PURE__*/ $ffaff9bfe81e5fa0$var$_react["default"].createElement($a3076d855b6b40e8$export$47eb42ff093406d4, {
        activeProperty: activeProperty,
        axis: axis,
        data: data,
        horizontal: horizontal,
        pad: pad,
        series: series,
        seriesStyles: seriesStyles,
        renderValue: renderValue,
        thickness: segmentThickness
    }));
    var legendElement = legend ? /*#__PURE__*/ $ffaff9bfe81e5fa0$var$_react["default"].createElement($f205d62e9596491c$export$ed247974535929c7, {
        series: series,
        seriesStyles: seriesStyles,
        activeProperty: activeProperty,
        setActiveProperty: setActiveProperty
    }) : null;
    var content = /*#__PURE__*/ $ffaff9bfe81e5fa0$var$_react["default"].createElement($f75e849c2101cc4f$export$ef2184bd89960b14, $ffaff9bfe81e5fa0$var$_extends({
        ref: ref,
        "aria-label": a11yTitle,
        fill: stackFill,
        columns: [
            'auto',
            stackFill === true || stackFill === 'horizontal' ? 'flex' : 'auto'
        ],
        rows: [
            stackFill === true || stackFill === 'vertical' ? 'flex' : 'auto',
            'auto'
        ],
        areas: [
            {
                name: 'yAxis',
                start: [
                    0,
                    0
                ],
                end: [
                    0,
                    0
                ]
            },
            {
                name: 'xAxis',
                start: [
                    1,
                    1
                ],
                end: [
                    1,
                    1
                ]
            },
            {
                name: 'charts',
                start: [
                    1,
                    0
                ],
                end: [
                    1,
                    0
                ]
            }
        ],
        gap: gap || ((_theme$dataChart4 = theme.dataChart) == null ? void 0 : _theme$dataChart4.gap)
    }, rest), xAxisElement, yAxisElement, stackElement);
    if (legendElement) content = /*#__PURE__*/ $ffaff9bfe81e5fa0$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        align: "start"
    }, content, legendElement);
    return content;
});
$ffaff9bfe81e5fa0$var$DataChart.displayName = 'DataChart';
$ffaff9bfe81e5fa0$var$DataChart.propTypes = $78e48c0aa97113c6$export$67bff0289e9bce98;


$21076d81dbd06644$export$56fe02f8cb89ca83 = $ffaff9bfe81e5fa0$export$56fe02f8cb89ca83;


Object.keys($21076d81dbd06644$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $21076d81dbd06644$exports[key]) return;
    $3321243da0932e1e$exports[key] = $21076d81dbd06644$exports[key];
});

Object.keys($70cc0737328cfe1c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $70cc0737328cfe1c$exports[key]) return;
    $3321243da0932e1e$exports[key] = $70cc0737328cfe1c$exports[key];
});

Object.keys($b001492d8dcf4f6c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $b001492d8dcf4f6c$exports[key]) return;
    $3321243da0932e1e$exports[key] = $b001492d8dcf4f6c$exports[key];
});

Object.keys($3ee1846956b4e555$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $3ee1846956b4e555$exports[key]) return;
    $3321243da0932e1e$exports[key] = $3ee1846956b4e555$exports[key];
});

Object.keys($17143eb328c34dfb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $17143eb328c34dfb$exports[key]) return;
    $3321243da0932e1e$exports[key] = $17143eb328c34dfb$exports[key];
});
var $c2087d33724c884d$exports = {};

$parcel$export($c2087d33724c884d$exports, "__esModule", function () { return $c2087d33724c884d$export$1e511d4a378977f5; }, function (v) { return $c2087d33724c884d$export$1e511d4a378977f5 = v; });
$parcel$export($c2087d33724c884d$exports, "DataSort", function () { return $c2087d33724c884d$export$6ad5778b6010d9c4; }, function (v) { return $c2087d33724c884d$export$6ad5778b6010d9c4 = v; });
var $c2087d33724c884d$export$1e511d4a378977f5;
var $c2087d33724c884d$export$6ad5778b6010d9c4;
"use strict";
$c2087d33724c884d$export$1e511d4a378977f5 = true;
$c2087d33724c884d$export$6ad5778b6010d9c4 = void 0;
var $6ba83435cd1c9ec4$export$1e511d4a378977f5;
var $6ba83435cd1c9ec4$export$6ad5778b6010d9c4;
"use strict";
$6ba83435cd1c9ec4$export$1e511d4a378977f5 = true;
$6ba83435cd1c9ec4$export$6ad5778b6010d9c4 = void 0;

var $6ba83435cd1c9ec4$var$_react = $6ba83435cd1c9ec4$var$_interopRequireWildcard((parcelRequire("2xPiy")));
var $c82a53117afbdd20$exports = {};

$parcel$export($c82a53117afbdd20$exports, "__esModule", function () { return $c82a53117afbdd20$export$1e511d4a378977f5; }, function (v) { return $c82a53117afbdd20$export$1e511d4a378977f5 = v; });
$parcel$export($c82a53117afbdd20$exports, "Descend", function () { return $c82a53117afbdd20$export$b0c43bd0bde94d9b; }, function (v) { return $c82a53117afbdd20$export$b0c43bd0bde94d9b = v; });
var $c82a53117afbdd20$export$1e511d4a378977f5;
var $c82a53117afbdd20$export$b0c43bd0bde94d9b;
"use strict";
$c82a53117afbdd20$export$1e511d4a378977f5 = true;
$c82a53117afbdd20$export$b0c43bd0bde94d9b = void 0;

var $c82a53117afbdd20$var$_react = $c82a53117afbdd20$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c82a53117afbdd20$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c82a53117afbdd20$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c82a53117afbdd20$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c82a53117afbdd20$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c82a53117afbdd20$var$_extends() {
    return $c82a53117afbdd20$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c82a53117afbdd20$var$_extends.apply(null, arguments);
}
var $c82a53117afbdd20$var$Descend = $c82a53117afbdd20$export$b0c43bd0bde94d9b = /*#__PURE__*/ (0, $c82a53117afbdd20$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c82a53117afbdd20$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c82a53117afbdd20$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Descend"
    }, props), /*#__PURE__*/ $c82a53117afbdd20$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m2 16 6 6 6-6M11 3h11M11 7h8m-8 4h5M8 22V2"
    }));
});
$c82a53117afbdd20$var$Descend.displayName = 'Descend';











var $b32bbe066301b082$export$1e511d4a378977f5;
var $b32bbe066301b082$export$8114c27961c1af2f;
"use strict";
$b32bbe066301b082$export$1e511d4a378977f5 = true;
$b32bbe066301b082$export$8114c27961c1af2f = void 0;

var $b32bbe066301b082$var$_propTypes = $b32bbe066301b082$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $b32bbe066301b082$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $b32bbe066301b082$var$PropType = {};
$b32bbe066301b082$var$PropType = {
    drop: $b32bbe066301b082$var$_propTypes["default"].bool
};
var $b32bbe066301b082$var$DataSortPropTypes = $b32bbe066301b082$export$8114c27961c1af2f = $b32bbe066301b082$var$PropType;




var $6ba83435cd1c9ec4$var$_excluded = [
    "drop",
    "options"
];
function $6ba83435cd1c9ec4$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($6ba83435cd1c9ec4$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $6ba83435cd1c9ec4$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $6ba83435cd1c9ec4$var$_extends() {
    return $6ba83435cd1c9ec4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6ba83435cd1c9ec4$var$_extends.apply(null, arguments);
}
var $6ba83435cd1c9ec4$var$dropProps = {
    align: {
        top: 'bottom',
        left: 'left'
    }
};
var $6ba83435cd1c9ec4$var$Content = function Content(_ref) {
    var optionsArg = _ref.options;
    var _useContext = (0, $6ba83435cd1c9ec4$var$_react.useContext)($932597a497e37de0$export$58d75f9829cbe158), data = _useContext.data, dataId = _useContext.id, messages = _useContext.messages, properties = _useContext.properties;
    var _useContext2 = (0, $6ba83435cd1c9ec4$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext2.format;
    var selectProps = (0, $6ba83435cd1c9ec4$var$_react.useMemo)(function() {
        var props = {};
        if (optionsArg) props = {
            options: optionsArg
        };
        if (properties && Array.isArray(properties)) props = {
            options: properties
        };
        else if (properties && typeof properties === 'object') props = {
            options: Object.entries(properties).filter(function(_ref2) {
                var sort = _ref2[1].sort;
                return !(sort === false);
            }).map(function(_ref3) {
                var key = _ref3[0], label = _ref3[1].label;
                return {
                    key: key,
                    label: label || key
                };
            }).sort(function(a, b) {
                return a.label.localeCompare(b.label);
            }),
            valueKey: {
                key: 'key',
                reduce: true
            },
            labelKey: 'label'
        };
        else props = {
            options: data.length > 0 && Object.keys(data[0]).sort() || data
        };
        return props;
    }, [
        data,
        optionsArg,
        properties
    ]);
    var directionOptions = [
        {
            label: format({
                id: 'dataSort.ascending',
                messages: messages == null ? void 0 : messages.dataSort
            }),
            value: 'asc'
        },
        {
            label: format({
                id: 'dataSort.descending',
                messages: messages == null ? void 0 : messages.dataSort
            }),
            value: 'desc'
        }
    ];
    var sortPropertyId = dataId + "--sort-property";
    var sortDirectionId = dataId + "--sort-direction";
    return [
        /*#__PURE__*/ $6ba83435cd1c9ec4$var$_react["default"].createElement($af5ba9f7873798c6$export$56e87bf42978147a, {
            key: "by",
            htmlFor: (0, $a1aed72b35405d54$export$abfa4f6a3fb2b741)(sortPropertyId),
            label: format({
                id: 'dataSort.by',
                messages: messages == null ? void 0 : messages.dataSort
            })
        }, /*#__PURE__*/ $6ba83435cd1c9ec4$var$_react["default"].createElement($c692f0029c94fbb2$export$ef9b1a59e592288f, $6ba83435cd1c9ec4$var$_extends({
            id: sortPropertyId,
            name: "_sort.property"
        }, selectProps))),
        /*#__PURE__*/ $6ba83435cd1c9ec4$var$_react["default"].createElement($af5ba9f7873798c6$export$56e87bf42978147a, {
            key: "dir",
            htmlFor: sortDirectionId,
            label: format({
                id: 'dataSort.direction',
                messages: messages == null ? void 0 : messages.dataSort
            })
        }, /*#__PURE__*/ $6ba83435cd1c9ec4$var$_react["default"].createElement($49bedb3ed8912461$export$c062ce1cc79ad58a, {
            id: sortDirectionId,
            name: "_sort.direction",
            options: directionOptions
        }))
    ];
};
var $6ba83435cd1c9ec4$var$DataSort = $6ba83435cd1c9ec4$export$6ad5778b6010d9c4 = function DataSort(_ref4) {
    var _theme$dataSort, _theme$data$button, _theme$data;
    var drop = _ref4.drop, options = _ref4.options, rest = $6ba83435cd1c9ec4$var$_objectWithoutPropertiesLoose(_ref4, $6ba83435cd1c9ec4$var$_excluded);
    var _useContext3 = (0, $6ba83435cd1c9ec4$var$_react.useContext)($932597a497e37de0$export$58d75f9829cbe158), dataId = _useContext3.id, messages = _useContext3.messages;
    var _useContext4 = (0, $6ba83435cd1c9ec4$var$_react.useContext)($b1a512ff039be377$export$e2b284ce8e93d8eb), inDataForm = _useContext4.inDataForm;
    var _useContext5 = (0, $6ba83435cd1c9ec4$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext5.format;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useState = (0, $6ba83435cd1c9ec4$var$_react.useState)(), showContent = _useState[0], setShowContent = _useState[1];
    var ControlIcon = ((_theme$dataSort = theme.dataSort) == null || (_theme$dataSort = _theme$dataSort.icons) == null ? void 0 : _theme$dataSort.control) || $c82a53117afbdd20$export$b0c43bd0bde94d9b;
    var content = /*#__PURE__*/ $6ba83435cd1c9ec4$var$_react["default"].createElement($6ba83435cd1c9ec4$var$Content, {
        options: options
    });
    if (!inDataForm) content = /*#__PURE__*/ $6ba83435cd1c9ec4$var$_react["default"].createElement($46eb34c25d0c5f74$export$dcf38ffba6c01577, {
        footer: false,
        updateOn: "change"
    }, content);
    if (!drop) return content;
    var tip = format({
        id: 'dataSort.open',
        messages: messages == null ? void 0 : messages.dataSort
    });
    var control = /*#__PURE__*/ $6ba83435cd1c9ec4$var$_react["default"].createElement($d7e2a556593dc38b$export$64fff40e709e8b2e, $6ba83435cd1c9ec4$var$_extends({
        id: dataId + "--sort-control",
        "aria-label": tip,
        tip: tip,
        kind: (_theme$data$button = theme.data.button) == null ? void 0 : _theme$data$button.kind,
        icon: /*#__PURE__*/ $6ba83435cd1c9ec4$var$_react["default"].createElement(ControlIcon, null),
        dropProps: $6ba83435cd1c9ec4$var$dropProps,
        dropContent: /*#__PURE__*/ $6ba83435cd1c9ec4$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            pad: (_theme$data = theme.data) == null || (_theme$data = _theme$data.drop) == null ? void 0 : _theme$data.pad
        }, content),
        open: showContent,
        onOpen: function onOpen() {
            return setShowContent(undefined);
        },
        onClose: function onClose() {
            return setShowContent(undefined);
        }
    }, rest));
    return control;
};
$6ba83435cd1c9ec4$var$DataSort.propTypes = $b32bbe066301b082$export$8114c27961c1af2f;


$c2087d33724c884d$export$6ad5778b6010d9c4 = $6ba83435cd1c9ec4$export$6ad5778b6010d9c4;


Object.keys($c2087d33724c884d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $c2087d33724c884d$exports[key]) return;
    $3321243da0932e1e$exports[key] = $c2087d33724c884d$exports[key];
});

Object.keys($3d0ce75306f2014c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $3d0ce75306f2014c$exports[key]) return;
    $3321243da0932e1e$exports[key] = $3d0ce75306f2014c$exports[key];
});
var $f1c8b837e0ea03b8$exports = {};

$parcel$export($f1c8b837e0ea03b8$exports, "__esModule", function () { return $f1c8b837e0ea03b8$export$1e511d4a378977f5; }, function (v) { return $f1c8b837e0ea03b8$export$1e511d4a378977f5 = v; });
$parcel$export($f1c8b837e0ea03b8$exports, "DataTable", function () { return $f1c8b837e0ea03b8$export$df30df7ec97b32b5; }, function (v) { return $f1c8b837e0ea03b8$export$df30df7ec97b32b5 = v; });
var $f1c8b837e0ea03b8$export$1e511d4a378977f5;
var $f1c8b837e0ea03b8$export$df30df7ec97b32b5;
"use strict";
$f1c8b837e0ea03b8$export$1e511d4a378977f5 = true;
$f1c8b837e0ea03b8$export$df30df7ec97b32b5 = void 0;
var $96c556b4e6e19733$export$1e511d4a378977f5;
var $96c556b4e6e19733$export$df30df7ec97b32b5;
"use strict";
$96c556b4e6e19733$export$1e511d4a378977f5 = true;
$96c556b4e6e19733$export$df30df7ec97b32b5 = void 0;

var $96c556b4e6e19733$var$_react = $96c556b4e6e19733$var$_interopRequireWildcard((parcelRequire("2xPiy")));






var $51e7385aa9e065e1$export$1e511d4a378977f5;
var $51e7385aa9e065e1$export$8b251419efc915eb;
"use strict";
$51e7385aa9e065e1$export$1e511d4a378977f5 = true;
$51e7385aa9e065e1$export$8b251419efc915eb = void 0;

var $51e7385aa9e065e1$var$_react = $51e7385aa9e065e1$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $51e7385aa9e065e1$var$_styledComponents = $51e7385aa9e065e1$var$_interopRequireWildcard((parcelRequire("iA1nz")));





var $a64a54bf804ade22$export$1e511d4a378977f5;
var $a64a54bf804ade22$export$4671998ee1170a79;
var $a64a54bf804ade22$export$1e4baea7053fc0e3;
"use strict";
$a64a54bf804ade22$export$1e511d4a378977f5 = true;
$a64a54bf804ade22$export$4671998ee1170a79 = $a64a54bf804ade22$export$1e4baea7053fc0e3 = void 0;

var $a64a54bf804ade22$var$_react = $a64a54bf804ade22$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $iA1nz = parcelRequire("iA1nz");



var $c821c6a8dcd18d9a$export$1e511d4a378977f5;
var $c821c6a8dcd18d9a$export$93e4b0b2cc49b648;
"use strict";
$c821c6a8dcd18d9a$export$1e511d4a378977f5 = true;
$c821c6a8dcd18d9a$export$93e4b0b2cc49b648 = void 0;

var $c821c6a8dcd18d9a$var$_react = $c821c6a8dcd18d9a$var$_interopRequireDefault((parcelRequire("2xPiy")));
function $c821c6a8dcd18d9a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $c821c6a8dcd18d9a$var$TableContext = $c821c6a8dcd18d9a$export$93e4b0b2cc49b648 = /*#__PURE__*/ $c821c6a8dcd18d9a$var$_react["default"].createContext(undefined);


var $cd80d74c75620d5a$export$1e511d4a378977f5;
var $cd80d74c75620d5a$export$8a602e750662ba27;
var $cd80d74c75620d5a$export$7f6303d004e2beb;
var $cd80d74c75620d5a$export$246ad668d62a675a;
var $cd80d74c75620d5a$export$9c29fe8f594afe44;
var $cd80d74c75620d5a$export$9253e4f716553796;
var $cd80d74c75620d5a$export$cd928bb20d3ce93f;
var $cd80d74c75620d5a$export$a6cc9d741fb2f287;
"use strict";
$cd80d74c75620d5a$export$1e511d4a378977f5 = true;
$cd80d74c75620d5a$export$8a602e750662ba27 = $cd80d74c75620d5a$export$7f6303d004e2beb = $cd80d74c75620d5a$export$246ad668d62a675a = $cd80d74c75620d5a$export$9c29fe8f594afe44 = $cd80d74c75620d5a$export$9253e4f716553796 = $cd80d74c75620d5a$export$cd928bb20d3ce93f = $cd80d74c75620d5a$export$a6cc9d741fb2f287 = void 0;

var $cd80d74c75620d5a$var$_styledComponents = $cd80d74c75620d5a$var$_interopRequireWildcard((parcelRequire("iA1nz")));

function $cd80d74c75620d5a$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($cd80d74c75620d5a$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $cd80d74c75620d5a$var$SIZE_MAP = {
    '1/2': '50%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    '1/3': '33.33%',
    '2/3': '66.66%'
};
var $cd80d74c75620d5a$var$sizeStyle = (0, $cd80d74c75620d5a$var$_styledComponents.css)([
    "width:",
    ";max-width:",
    ";overflow:hidden;"
], function(props) {
    return props.size === 'auto' ? // setting width to a small value will allow
    // the cell to fit width of its content. this
    // is a commonly implemented CSS pattern to
    // allow an auto-width behavior on fixed table
    // layouts (which is what DataTable applies)
    // https://stackoverflow.com/questions/4757844/css-table-column-autowidth?noredirect=1&lq=1
    '1px' : $cd80d74c75620d5a$var$SIZE_MAP[props.size] || props.theme.global.size[props.size] || props.size;
}, function(props) {
    return props.size !== 'auto' ? $cd80d74c75620d5a$var$SIZE_MAP[props.size] || props.theme.global.size[props.size] || props.size : undefined;
});
var $cd80d74c75620d5a$var$StyledTableCell = $cd80d74c75620d5a$export$9253e4f716553796 = $cd80d74c75620d5a$var$_styledComponents["default"].td.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledTable__StyledTableCell",
    componentId: "sc-1m3u5g-0"
})([
    "margin:0;padding:0;font-weight:inherit;text-align:inherit;",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return props.size && $cd80d74c75620d5a$var$sizeStyle;
}, function(props) {
    return props.verticalAlign && "vertical-align: " + props.verticalAlign + ";";
}, function(props) {
    return props.align && "text-align: " + props.align + ";";
}, function(props) {
    return props.background && (0, $4113023f9e0bafa0$exports.backgroundStyle)(props.background, props.theme);
}, function(props) {
    return props.border && (0, $4113023f9e0bafa0$exports.borderStyle)(props.border, props.responsive, props.theme);
}, function(props) {
    return props.pad && (0, $4113023f9e0bafa0$exports.edgeStyle)('padding', props.pad, props.responsive, props.theme.box.responsiveBreakpoint, props.theme);
}, function(props) {
    return props.tableContextTheme && props.tableContextTheme.extend;
});
var $cd80d74c75620d5a$var$StyledTableDataCaption = $cd80d74c75620d5a$export$9c29fe8f594afe44 = $cd80d74c75620d5a$var$_styledComponents["default"].caption.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledTable__StyledTableDataCaption",
    componentId: "sc-1m3u5g-1"
})([
    "",
    ""
], function(props) {
    return (0, $4113023f9e0bafa0$exports.edgeStyle)('margin', props.theme.table.caption.margin, false, props.theme.global.edgeSize.responsiveBreakpoint, props.theme);
});
var $cd80d74c75620d5a$var$StyledTableRow = $cd80d74c75620d5a$export$8a602e750662ba27 = $cd80d74c75620d5a$var$_styledComponents["default"].tr.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledTable__StyledTableRow",
    componentId: "sc-1m3u5g-2"
})([
    ""
]);
var $cd80d74c75620d5a$var$StyledTableBody = $cd80d74c75620d5a$export$cd928bb20d3ce93f = $cd80d74c75620d5a$var$_styledComponents["default"].tbody.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledTable__StyledTableBody",
    componentId: "sc-1m3u5g-3"
})([
    ""
]);
var $cd80d74c75620d5a$var$StyledTableHeader = $cd80d74c75620d5a$export$7f6303d004e2beb = $cd80d74c75620d5a$var$_styledComponents["default"].thead.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledTable__StyledTableHeader",
    componentId: "sc-1m3u5g-4"
})([
    ""
]);
var $cd80d74c75620d5a$var$StyledTableFooter = $cd80d74c75620d5a$export$246ad668d62a675a = $cd80d74c75620d5a$var$_styledComponents["default"].tfoot.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledTable__StyledTableFooter",
    componentId: "sc-1m3u5g-5"
})([
    ""
]);
var $cd80d74c75620d5a$var$StyledTable = $cd80d74c75620d5a$export$a6cc9d741fb2f287 = $cd80d74c75620d5a$var$_styledComponents["default"].table.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledTable",
    componentId: "sc-1m3u5g-6"
})([
    "border-spacing:0;border-collapse:collapse;width:inherit;",
    " ",
    ";"
], $4113023f9e0bafa0$exports.genericStyles, function(props) {
    return props.theme.table && props.theme.table.extend;
});


var $62c28aa812cad4aa$export$1e511d4a378977f5;
var $62c28aa812cad4aa$export$28beafd39afe4e80;
"use strict";
$62c28aa812cad4aa$export$1e511d4a378977f5 = true;
$62c28aa812cad4aa$export$28beafd39afe4e80 = void 0;

var $62c28aa812cad4aa$var$_propTypes = $62c28aa812cad4aa$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $62c28aa812cad4aa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $62c28aa812cad4aa$var$BORDER_SHAPE = $62c28aa812cad4aa$var$_propTypes["default"].shape({
    color: $62c28aa812cad4aa$var$_propTypes["default"].oneOfType([
        $62c28aa812cad4aa$var$_propTypes["default"].string,
        $62c28aa812cad4aa$var$_propTypes["default"].shape({
            dark: $62c28aa812cad4aa$var$_propTypes["default"].string,
            light: $62c28aa812cad4aa$var$_propTypes["default"].string
        })
    ]),
    side: $62c28aa812cad4aa$var$_propTypes["default"].oneOf([
        'top',
        'left',
        'bottom',
        'right',
        'start',
        'end',
        'horizontal',
        'vertical',
        'all',
        'between'
    ]),
    size: $62c28aa812cad4aa$var$_propTypes["default"].oneOfType([
        $62c28aa812cad4aa$var$_propTypes["default"].oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        $62c28aa812cad4aa$var$_propTypes["default"].string
    ]),
    style: $62c28aa812cad4aa$var$_propTypes["default"].oneOf([
        'solid',
        'dashed',
        'dotted',
        'double',
        'groove',
        'ridge',
        'inset',
        'outset',
        'hidden'
    ])
});
var $62c28aa812cad4aa$var$PropType = {};
$62c28aa812cad4aa$var$PropType = {
    border: $62c28aa812cad4aa$var$_propTypes["default"].oneOfType([
        $62c28aa812cad4aa$var$_propTypes["default"].bool,
        $62c28aa812cad4aa$var$_propTypes["default"].oneOf([
            'top',
            'left',
            'bottom',
            'right',
            'start',
            'end',
            'horizontal',
            'vertical',
            'all'
        ]),
        $62c28aa812cad4aa$var$BORDER_SHAPE,
        $62c28aa812cad4aa$var$_propTypes["default"].arrayOf($62c28aa812cad4aa$var$BORDER_SHAPE)
    ]),
    plain: $62c28aa812cad4aa$var$_propTypes["default"].oneOfType([
        $62c28aa812cad4aa$var$_propTypes["default"].bool,
        $62c28aa812cad4aa$var$_propTypes["default"].oneOf([
            'noPad'
        ])
    ]),
    scope: $62c28aa812cad4aa$var$_propTypes["default"].oneOf([
        'col',
        'row'
    ]),
    size: $62c28aa812cad4aa$var$_propTypes["default"].oneOfType([
        $62c28aa812cad4aa$var$_propTypes["default"].oneOf([
            'xxsmall',
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            '1/2',
            '1/3',
            '2/3',
            '1/4',
            '2/4',
            '3/4'
        ]),
        $62c28aa812cad4aa$var$_propTypes["default"].string
    ]),
    verticalAlign: $62c28aa812cad4aa$var$_propTypes["default"].oneOf([
        'top',
        'middle',
        'bottom'
    ]),
    align: $62c28aa812cad4aa$var$_propTypes["default"].oneOfType([
        $62c28aa812cad4aa$var$_propTypes["default"].oneOf([
            'left',
            'right',
            'center',
            'justify',
            'inherit',
            'start',
            'end'
        ]),
        $62c28aa812cad4aa$var$_propTypes["default"].string
    ])
};
var $62c28aa812cad4aa$var$TableCellPropTypes = $62c28aa812cad4aa$export$28beafd39afe4e80 = $62c28aa812cad4aa$var$PropType;



var $a64a54bf804ade22$var$_excluded = [
    "align",
    "aria-disabled",
    "background",
    "border",
    "children",
    "className",
    "colSpan",
    "onResize",
    "onWidth",
    "pad",
    "plain",
    "rowSpan",
    "scope",
    "size",
    "verticalAlign",
    "property"
];
function $a64a54bf804ade22$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($a64a54bf804ade22$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $a64a54bf804ade22$var$_extends() {
    return $a64a54bf804ade22$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a64a54bf804ade22$var$_extends.apply(null, arguments);
}
function $a64a54bf804ade22$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $a64a54bf804ade22$var$verticalAlignToJustify = $a64a54bf804ade22$export$4671998ee1170a79 = {
    middle: 'center',
    top: 'start',
    bottom: 'end'
};
var $a64a54bf804ade22$var$TableCell = $a64a54bf804ade22$export$1e4baea7053fc0e3 = /*#__PURE__*/ (0, $a64a54bf804ade22$var$_react.forwardRef)(function(_ref, ref) {
    var align = _ref.align, ariaDisabled = _ref['aria-disabled'], background = _ref.background, border = _ref.border, children = _ref.children, className = _ref.className, colSpan = _ref.colSpan, onResize = _ref.onResize, onWidth = _ref.onWidth, pad = _ref.pad, plain = _ref.plain, rowSpan = _ref.rowSpan, scope = _ref.scope, size = _ref.size, verticalAlign = _ref.verticalAlign, property = _ref.property, rest = $a64a54bf804ade22$var$_objectWithoutPropertiesLoose(_ref, $a64a54bf804ade22$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var tableContext = (0, $a64a54bf804ade22$var$_react.useContext)($c821c6a8dcd18d9a$export$93e4b0b2cc49b648);
    var cellRef = (0, $4113023f9e0bafa0$exports.useForwardedRef)(ref);
    var containerRef = (0, $a64a54bf804ade22$var$_react.useRef)();
    var widthRef = (0, $a64a54bf804ade22$var$_react.useRef)();
    // if the screen is resized, we need to recalculate the width
    (0, $6a5275ec792307a1$export$e5c5a5f917a5871c)(function() {
        var handleResize = function handleResize() {
            if (onResize && property && cellRef.current) {
                var _cellRef$current$getB = cellRef.current.getBoundingClientRect(), width = _cellRef$current$getB.width;
                onResize(property, width);
            }
        };
        window.addEventListener('resize', handleResize);
        return function() {
            return window.removeEventListener('resize', handleResize);
        };
    }, [
        cellRef,
        onResize,
        property
    ]);
    (0, $6a5275ec792307a1$export$e5c5a5f917a5871c)(function() {
        var resizeObserver;
        var element = cellRef.current;
        if (onWidth) {
            if (typeof window !== 'undefined' && window.ResizeObserver) {
                resizeObserver = new window.ResizeObserver(function(entries) {
                    var entry = entries[0].borderBoxSize[0];
                    var width = entry == null ? void 0 : entry.inlineSize;
                    if (widthRef.current !== width) {
                        widthRef.current = width;
                        onWidth(width);
                    }
                });
                if (element) resizeObserver.observe(cellRef.current);
            } else {
                // fallback for server side rendering
                var _cellRef$current$getB2 = cellRef.current.getBoundingClientRect(), width = _cellRef$current$getB2.width;
                if (widthRef.current !== width) {
                    widthRef.current = width;
                    onWidth(width);
                }
            }
        }
        return function() {
            if (resizeObserver && element) resizeObserver.unobserve(element);
        };
    }, [
        onWidth,
        cellRef,
        widthRef
    ]);
    // if window resizes, recalculate cell height so that content
    // will continue to fill the height if the dimensions of the cell
    // have changed
    (0, $a64a54bf804ade22$var$_react.useEffect)(function() {
        var updateHeight = function updateHeight() {
            if (plain === 'noPad') {
                var cell = cellRef.current;
                var container = containerRef.current;
                if (cell && container) {
                    container.style.height = '';
                    var cellRect = cell.getBoundingClientRect();
                    // height must match cell height otherwise table will apply some
                    // margin around the cell content
                    container.style.height = Math.max(cellRect.height - (border || theme.table[tableContext].border ? theme.global.borderSize.xsmall.replace('px', '') : 0), 0) + "px";
                }
            }
        };
        window.addEventListener('resize', updateHeight);
        updateHeight();
        return function() {
            window.removeEventListener('resize', updateHeight);
        };
    }, [
        border,
        cellRef,
        plain,
        tableContext,
        theme.global.borderSize,
        theme.table
    ]);
    var tableContextTheme;
    if (tableContext === 'header') tableContextTheme = theme.table && theme.table.header;
    else if (tableContext === 'footer') tableContextTheme = theme.table && theme.table.footer;
    else tableContextTheme = theme.table && theme.table.body;
    // merge tableContextTheme and rest
    var mergedProps = $a64a54bf804ade22$var$_extends({}, tableContextTheme, rest);
    Object.keys(mergedProps).forEach(function(key) {
        if (rest[key] === undefined) mergedProps[key] = tableContextTheme[key];
    });
    // split out background, border, pad, and aria-disabled
    var cellProps = {
        align: align || mergedProps.align || undefined,
        'aria-disabled': ariaDisabled || undefined,
        background: background || mergedProps.background || undefined,
        border: border || mergedProps.border || undefined,
        pad: plain !== 'noPad' ? pad || mergedProps.pad || undefined : undefined,
        verticalAlign: verticalAlign || mergedProps.verticalAlign || undefined
    };
    delete mergedProps.align;
    delete mergedProps.ariaDisabled;
    delete mergedProps.background;
    delete mergedProps.border;
    delete mergedProps.pad;
    delete mergedProps.verticalAlign;
    var content = children;
    if (plain === 'noPad' && children) // a Box with explicitly set height is necessary
    // for the child contents to be able to fill the
    // TableCell
    content = /*#__PURE__*/ $a64a54bf804ade22$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        ref: containerRef,
        justify: verticalAlign ? $a64a54bf804ade22$var$verticalAlignToJustify[verticalAlign] : 'center'
    }, children);
    // construct a new theme object in case we have a background that wants
    // to change the background color context
    var nextTheme = (0, $a64a54bf804ade22$var$_react.useMemo)(function() {
        var result;
        if (cellProps.background || theme.darkChanged) {
            var dark = (0, $4113023f9e0bafa0$exports.backgroundIsDark)(cellProps.background, theme);
            var darkChanged = dark !== undefined && dark !== theme.dark;
            if (darkChanged || theme.darkChanged) {
                result = $a64a54bf804ade22$var$_extends({}, theme);
                result.dark = dark === undefined ? theme.dark : dark;
                result.background = cellProps.background;
            } else if (cellProps.background) {
                // This allows DataTable to intelligently set the background
                // of a pinned header or footer.
                result = $a64a54bf804ade22$var$_extends({}, theme);
                result.background = cellProps.background;
            }
        }
        return result || theme;
    }, [
        cellProps.background,
        theme
    ]);
    return /*#__PURE__*/ $a64a54bf804ade22$var$_react["default"].createElement($iA1nz.ThemeContext.Provider, {
        value: nextTheme
    }, /*#__PURE__*/ $a64a54bf804ade22$var$_react["default"].createElement($cd80d74c75620d5a$export$9253e4f716553796, $a64a54bf804ade22$var$_extends({
        ref: cellRef,
        as: scope ? 'th' : undefined,
        scope: scope,
        size: size,
        colSpan: colSpan,
        rowSpan: rowSpan,
        tableContext: tableContext,
        tableContextTheme: tableContextTheme
    }, plain === true ? mergedProps : {}, cellProps, {
        className: className
    }, passThemeFlag), plain || !Object.keys(mergedProps).length ? content : /*#__PURE__*/ $a64a54bf804ade22$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $a64a54bf804ade22$var$_extends({}, mergedProps, {
        align: align,
        justify: $a64a54bf804ade22$var$verticalAlignToJustify[verticalAlign]
    }), children)));
});
$a64a54bf804ade22$var$TableCell.displayName = 'TableCell';
$a64a54bf804ade22$var$TableCell.propTypes = $62c28aa812cad4aa$export$28beafd39afe4e80;



var $0dd0f14dac199089$export$1e511d4a378977f5;
var $0dd0f14dac199089$export$48a76196cafe3b93;
"use strict";
$0dd0f14dac199089$export$1e511d4a378977f5 = true;
$0dd0f14dac199089$export$48a76196cafe3b93 = void 0;

var $0dd0f14dac199089$var$_react = $0dd0f14dac199089$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $0dd0f14dac199089$var$_styledComponents = $0dd0f14dac199089$var$_interopRequireDefault((parcelRequire("iA1nz")));









function $0dd0f14dac199089$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $0dd0f14dac199089$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($0dd0f14dac199089$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
// We determined 12 empirically as being wide enough to hit but
// not too wide to cause false hits.
var $0dd0f14dac199089$var$STEP = 12; // Used to determine the width change on resize
var $0dd0f14dac199089$var$resizerWidth = 24; // minimum width required for WCAG compliance
var $0dd0f14dac199089$var$StyledResizer = (0, $0dd0f14dac199089$var$_styledComponents["default"])($d7e2a556593dc38b$export$64fff40e709e8b2e).withConfig({
    displayName: "Resizer__StyledResizer",
    componentId: "sc-8l808w-0"
})([
    "display:flex;justify-content:center;",
    ";",
    ";",
    " ",
    " ",
    " ",
    " position:absolute;width:",
    "px;height:100%;top:0;cursor:col-resize;z-index:1;"
], function(props) {
    var _props$theme$dataTabl;
    return (0, $9a7099e779e83517$export$944a9710f9445eee)('padding-top', (_props$theme$dataTabl = props.theme.dataTable) == null || (_props$theme$dataTabl = _props$theme$dataTabl.resize) == null || (_props$theme$dataTabl = _props$theme$dataTabl.padding) == null ? void 0 : _props$theme$dataTabl.vertical, false, props.theme.global.edgeSize.responsiveBreakpoint, props.theme);
}, function(props) {
    var _props$theme$dataTabl2;
    return (0, $9a7099e779e83517$export$944a9710f9445eee)('padding-bottom', (_props$theme$dataTabl2 = props.theme.dataTable) == null || (_props$theme$dataTabl2 = _props$theme$dataTabl2.resize) == null || (_props$theme$dataTabl2 = _props$theme$dataTabl2.padding) == null ? void 0 : _props$theme$dataTabl2.vertical, false, props.theme.global.edgeSize.responsiveBreakpoint, props.theme);
}, function(props) {
    return props.side === 'start' && "margin-left: -" + ($0dd0f14dac199089$var$resizerWidth / 2 - props.theme.global.borderSize.xsmall.replace('px', '')) + "px;";
}, function(props) {
    return props.side === 'start' && "left: 0;";
}, function(props) {
    return props.side === 'end' && "margin-right: -" + ($0dd0f14dac199089$var$resizerWidth / 2 - props.theme.global.borderSize.xsmall.replace('px', '')) + "px;";
}, function(props) {
    return props.side === 'end' && "right: 0;";
}, $0dd0f14dac199089$var$resizerWidth);
var $0dd0f14dac199089$var$Resizer = $0dd0f14dac199089$export$48a76196cafe3b93 = function Resizer(_ref) {
    var _theme$dataTable$icon, _theme$dataTable$icon2, _border;
    var onResize = _ref.onResize, property = _ref.property, headerText = _ref.headerText, messages = _ref.messages, headerId = _ref.headerId;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useState = (0, $0dd0f14dac199089$var$_react.useState)(false), active = _useState[0], setActive = _useState[1];
    var _useState2 = (0, $0dd0f14dac199089$var$_react.useState)(), start = _useState2[0], setStart = _useState2[1];
    var _useState3 = (0, $0dd0f14dac199089$var$_react.useState)(0), width = _useState3[0], setWidth = _useState3[1];
    var ref = (0, $0dd0f14dac199089$var$_react.useRef)();
    var thRef = (0, $0dd0f14dac199089$var$_react.useRef)();
    var _useContext = (0, $0dd0f14dac199089$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var ResizeIncreaseIcon = ((_theme$dataTable$icon = theme.dataTable.icons) == null ? void 0 : _theme$dataTable$icon.resizeIncrease) || $7996618d0f2a9e28$export$d0265b2c425512d6;
    var ResizeDecreaseIcon = ((_theme$dataTable$icon2 = theme.dataTable.icons) == null ? void 0 : _theme$dataTable$icon2.resizeDecrease) || $6a2802ef8f2bd5f5$export$8bc67ae85ef4b74f;
    // Set the initial width based on the TH element's width and
    // store th element ref
    (0, $0dd0f14dac199089$var$_react.useEffect)(function() {
        if (ref.current) {
            var element = ref.current;
            // find TH parent
            while(element && element.nodeName !== 'TH')element = element.parentNode;
            thRef.current = element;
            var rect = element.getBoundingClientRect();
            // Set initial width based on the TH element's width
            setWidth(rect.width);
        }
    }, []);
    var onResizeStart = (0, $0dd0f14dac199089$var$_react.useCallback)(function(event) {
        var clientX = event.touches ? event.touches[0].clientX : event.clientX;
        if (thRef.current) {
            var element = thRef.current;
            var rect = element.getBoundingClientRect();
            setStart(clientX);
            setWidth(rect.width);
            setActive(true);
        }
    }, []);
    var onResizeMove = (0, $0dd0f14dac199089$var$_react.useCallback)(function(event) {
        var clientX = event.touches ? event.touches[0].clientX : event.clientX;
        var nextWidth = Math.max($0dd0f14dac199089$var$STEP, width + (clientX - start));
        onResize(property, nextWidth);
    }, [
        onResize,
        property,
        start,
        width
    ]);
    var onResizeEnd = (0, $0dd0f14dac199089$var$_react.useCallback)(function() {
        setActive(false);
        setStart(undefined);
        setWidth(undefined);
    }, []);
    (0, $0dd0f14dac199089$var$_react.useEffect)(function() {
        var remove = function remove() {
            document.removeEventListener('mouseup', onResizeEnd);
            document.removeEventListener('mousemove', onResizeMove);
            document.removeEventListener('touchend', onResizeEnd);
            document.removeEventListener('touchmove', onResizeMove);
        };
        if (active) {
            document.addEventListener('mouseup', onResizeEnd);
            document.addEventListener('mousemove', onResizeMove);
            document.addEventListener('touchend', onResizeEnd);
            document.addEventListener('touchmove', onResizeMove);
            return remove;
        }
        remove();
        return undefined;
    }, [
        active,
        onResizeMove,
        onResizeEnd
    ]);
    var border;
    if (theme.dataTable.resize.border.color && theme.dataTable.resize.border.side) {
        var _theme$dataTable$resi = theme.dataTable.resize.border, color = _theme$dataTable$resi.color, _theme$dataTable$resi2 = _theme$dataTable$resi.side, side = _theme$dataTable$resi2 === void 0 ? 'end' : _theme$dataTable$resi2;
        border = {
            color: color,
            side: side
        };
    }
    var hoverBorder = border;
    if (theme.dataTable.resize.hover && theme.dataTable.resize.hover.border) {
        var _theme$dataTable$resi3 = theme.dataTable.resize.hover.border, _color = _theme$dataTable$resi3.color, _theme$dataTable$resi4 = _theme$dataTable$resi3.side, _side = _theme$dataTable$resi4 === void 0 ? 'end' : _theme$dataTable$resi4, size = _theme$dataTable$resi3.size;
        hoverBorder = {
            color: _color,
            side: _side,
            size: size
        };
    }
    var onKeyDown = (0, $0dd0f14dac199089$var$_react.useCallback)(function(event) {
        event.preventDefault();
        if (!ref.current) return;
        if (thRef.current) {
            var element = thRef.current;
            var currentWidth = element.getBoundingClientRect().width;
            // Used STEP here to align with the value set in onMouseMove
            var delta = event.key === 'ArrowLeft' ? -$0dd0f14dac199089$var$STEP : $0dd0f14dac199089$var$STEP;
            onResize(property, currentWidth + delta);
            setWidth(currentWidth + delta);
        }
    }, [
        onResize,
        property
    ]);
    var onDecrease = (0, $0dd0f14dac199089$var$_react.useCallback)(function() {
        if (thRef.current) {
            var element = thRef.current;
            var rect = element.getBoundingClientRect();
            var currentWidth = rect.width;
            var nextWidth = Math.max($0dd0f14dac199089$var$STEP, currentWidth - $0dd0f14dac199089$var$STEP);
            setWidth(nextWidth);
            onResize(property, nextWidth);
        }
    }, [
        onResize,
        property
    ]);
    var onIncrease = (0, $0dd0f14dac199089$var$_react.useCallback)(function() {
        if (thRef.current) {
            var element = thRef.current;
            var rect = element.getBoundingClientRect();
            var currentWidth = rect.width;
            var nextWidth = Math.max($0dd0f14dac199089$var$STEP, currentWidth + $0dd0f14dac199089$var$STEP);
            setWidth(nextWidth);
            onResize(property, nextWidth);
        }
    }, [
        onResize,
        property
    ]);
    var _useState4 = (0, $0dd0f14dac199089$var$_react.useState)(false), hover = _useState4[0], setHover = _useState4[1];
    var ariaLabel = format({
        id: 'dataTable.resizerAria',
        values: {
            headerText: headerText
        },
        messages: messages
    });
    return /*#__PURE__*/ $0dd0f14dac199089$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onLeft: onKeyDown,
        onRight: onKeyDown
    }, /*#__PURE__*/ $0dd0f14dac199089$var$_react["default"].createElement($0dd0f14dac199089$var$StyledResizer, {
        "aria-label": width ? ariaLabel + " " + Math.trunc(width) + " pixels" : ariaLabel,
        onMouseEnter: function onMouseEnter() {
            return setHover(true);
        },
        onMouseLeave: function onMouseLeave() {
            return setHover(false);
        },
        ref: ref,
        role: "separator",
        "aria-valuenow": width,
        "aria-valuetext": width ? ariaLabel + " " + Math.trunc(width) + " pixels" : ariaLabel,
        "aria-controls": headerId,
        "aria-orientation": "vertical",
        onMouseDown: onResizeStart,
        onMouseMove: start !== undefined ? onResizeMove : undefined,
        onMouseUp: start !== undefined ? onResizeEnd : undefined,
        onTouchStart: onResizeStart,
        onTouchMove: start !== undefined ? onResizeMove : undefined,
        onTouchEnd: start !== undefined ? onResizeEnd : undefined,
        dropContent: /*#__PURE__*/ $0dd0f14dac199089$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            direction: "row",
            pad: "xsmall"
        }, /*#__PURE__*/ $0dd0f14dac199089$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
            "aria-label": format({
                id: 'dataTable.decrease',
                values: {
                    headerText: headerText
                },
                messages: messages
            }),
            icon: /*#__PURE__*/ $0dd0f14dac199089$var$_react["default"].createElement(ResizeDecreaseIcon, null),
            onClick: onDecrease,
            autoFocus: true
        }), /*#__PURE__*/ $0dd0f14dac199089$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
            "aria-label": format({
                id: 'dataTable.increase',
                values: {
                    headerText: headerText
                },
                messages: messages
            }),
            icon: /*#__PURE__*/ $0dd0f14dac199089$var$_react["default"].createElement(ResizeIncreaseIcon, null),
            onClick: onIncrease
        })),
        dropAlign: {
            top: 'bottom'
        },
        side: (_border = border) == null ? void 0 : _border.side
    }, /*#__PURE__*/ $0dd0f14dac199089$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        border: hover || active ? hoverBorder : border,
        height: "100%",
        alignSelf: "center"
    })));
};
$0dd0f14dac199089$var$Resizer.displayName = 'Resizer';


var $0e7344a4ac2b9bf9$export$1e511d4a378977f5;
var $0e7344a4ac2b9bf9$export$25746e77c1b1a497;
"use strict";
$0e7344a4ac2b9bf9$export$1e511d4a378977f5 = true;
$0e7344a4ac2b9bf9$export$25746e77c1b1a497 = void 0;

var $0e7344a4ac2b9bf9$var$_react = $0e7344a4ac2b9bf9$var$_interopRequireWildcard((parcelRequire("2xPiy")));









function $0e7344a4ac2b9bf9$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($0e7344a4ac2b9bf9$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $0e7344a4ac2b9bf9$var$Searcher = $0e7344a4ac2b9bf9$export$25746e77c1b1a497 = function Searcher(_ref) {
    var _theme$dataTable, _theme$dataTable$sear, _theme$dataTable$sear2;
    var filtering = _ref.filtering, filters = _ref.filters, focusIndicator = _ref.focusIndicator, messages = _ref.messages, onFilter = _ref.onFilter, onFiltering = _ref.onFiltering, property = _ref.property;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var inputRef = (0, $0e7344a4ac2b9bf9$var$_react.useRef)();
    var buttonRef = (0, $0e7344a4ac2b9bf9$var$_react.useRef)();
    var needsFocus = filtering === property;
    var _useState = (0, $0e7344a4ac2b9bf9$var$_react.useState)(false), buttonNeedsFocus = _useState[0], setButtonNeedsFocus = _useState[1];
    var _useContext = (0, $0e7344a4ac2b9bf9$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var SearchIcon = ((_theme$dataTable = theme.dataTable) == null || (_theme$dataTable = _theme$dataTable.icons) == null ? void 0 : _theme$dataTable.search) || $5e76eb42ddcb97c1$export$620e475702cadb1e;
    (0, $0e7344a4ac2b9bf9$var$_react.useEffect)(function() {
        if (inputRef && needsFocus) inputRef.current.focus();
    }, [
        needsFocus,
        inputRef
    ]);
    // Focus the button after closing the search
    (0, $0e7344a4ac2b9bf9$var$_react.useEffect)(function() {
        if (buttonNeedsFocus && buttonRef.current) {
            buttonRef.current.focus();
            setButtonNeedsFocus(false);
        }
    }, [
        buttonNeedsFocus
    ]);
    var a11yTitle = format({
        id: 'dataTable.searchBy',
        messages: messages,
        values: {
            property: property
        }
    });
    return filtering === property ? /*#__PURE__*/ $0e7344a4ac2b9bf9$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onEsc: function onEsc() {
            onFiltering(undefined);
            setButtonNeedsFocus(true);
        }
    }, /*#__PURE__*/ $0e7344a4ac2b9bf9$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        width: {
            min: 'xsmall'
        },
        flex: true,
        pad: (_theme$dataTable$sear = theme.dataTable.search) == null ? void 0 : _theme$dataTable$sear.pad
    }, /*#__PURE__*/ $0e7344a4ac2b9bf9$var$_react["default"].createElement($99c7a15bc083da62$export$c86715117507e8e5, {
        name: "search-" + property,
        a11yTitle: a11yTitle,
        ref: inputRef,
        value: filters[property],
        onChange: function onChange(event) {
            return onFilter(property, event.target.value);
        },
        onBlur: function onBlur() {
            return onFiltering(undefined);
        }
    }))) : /*#__PURE__*/ $0e7344a4ac2b9bf9$var$_react["default"].createElement($0e7344a4ac2b9bf9$var$_react["default"].Fragment, null, filters[property] ? /*#__PURE__*/ $0e7344a4ac2b9bf9$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        flex: false,
        pad: (_theme$dataTable$sear2 = theme.dataTable.search) == null || (_theme$dataTable$sear2 = _theme$dataTable$sear2.text) == null ? void 0 : _theme$dataTable$sear2.pad,
        direction: "row",
        align: "center"
    }, /*#__PURE__*/ $0e7344a4ac2b9bf9$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, null, filters[property])) : null, /*#__PURE__*/ $0e7344a4ac2b9bf9$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
        ref: buttonRef,
        a11yTitle: a11yTitle,
        icon: /*#__PURE__*/ $0e7344a4ac2b9bf9$var$_react["default"].createElement(SearchIcon, {
            color: (0, $4113023f9e0bafa0$exports.normalizeColor)(filtering === property ? 'brand' : 'border', theme)
        }),
        hoverIndicator: true,
        focusIndicator: focusIndicator,
        onClick: function onClick() {
            return onFiltering(filtering === property ? undefined : property);
        }
    }));
};
$0e7344a4ac2b9bf9$var$Searcher.displayName = 'Searcher';


var $45f69439fcb47049$export$1e511d4a378977f5;
var $45f69439fcb47049$export$8ebdff051337858b;
"use strict";
$45f69439fcb47049$export$1e511d4a378977f5 = true;
$45f69439fcb47049$export$8ebdff051337858b = void 0;

var $45f69439fcb47049$var$_react = $45f69439fcb47049$var$_interopRequireWildcard((parcelRequire("2xPiy")));



var $5501e7a1e1340982$exports = {};

$parcel$export($5501e7a1e1340982$exports, "__esModule", function () { return $5501e7a1e1340982$export$1e511d4a378977f5; }, function (v) { return $5501e7a1e1340982$export$1e511d4a378977f5 = v; });
$parcel$export($5501e7a1e1340982$exports, "TableCell", function () { return $5501e7a1e1340982$export$1e4baea7053fc0e3; }, function (v) { return $5501e7a1e1340982$export$1e4baea7053fc0e3 = v; });
var $5501e7a1e1340982$export$1e511d4a378977f5;
var $5501e7a1e1340982$export$1e4baea7053fc0e3;
"use strict";
$5501e7a1e1340982$export$1e511d4a378977f5 = true;
$5501e7a1e1340982$export$1e4baea7053fc0e3 = void 0;

$5501e7a1e1340982$export$1e4baea7053fc0e3 = $a64a54bf804ade22$export$1e4baea7053fc0e3;





var $45f69439fcb47049$var$_excluded = [
    "context",
    "expanded",
    "onToggle",
    "messages",
    "pad",
    "expandLabel"
], $45f69439fcb47049$var$_excluded2 = [
    "background",
    "border",
    "context",
    "expandLabel"
];
function $45f69439fcb47049$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($45f69439fcb47049$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $45f69439fcb47049$var$_extends() {
    return $45f69439fcb47049$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $45f69439fcb47049$var$_extends.apply(null, arguments);
}
function $45f69439fcb47049$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// ExpanderControl is separated from ExpanderCell to give TableCell a chance
// to set the ThemeContext dark context.
var $45f69439fcb47049$var$ExpanderControl = function ExpanderControl(_ref) {
    var context = _ref.context, expanded = _ref.expanded, onToggle = _ref.onToggle, messages = _ref.messages, pad = _ref.pad, expandLabel = _ref.expandLabel, rest = $45f69439fcb47049$var$_objectWithoutPropertiesLoose(_ref, $45f69439fcb47049$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useContext = (0, $45f69439fcb47049$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var content;
    if (onToggle) {
        var ExpandIcon = theme.dataTable.icons[expanded ? 'contract' : 'expand'];
        content = /*#__PURE__*/ $45f69439fcb47049$var$_react["default"].createElement(ExpandIcon, {
            color: (0, $4113023f9e0bafa0$exports.normalizeColor)('border', theme)
        });
    } else content = /*#__PURE__*/ $45f69439fcb47049$var$_react["default"].createElement($763c3cd9aa07485e$export$eb38fb18cfba1d64, null);
    var normalizedThemeProps = $45f69439fcb47049$var$_extends({}, theme.table[context], theme.dataTable[context]);
    delete normalizedThemeProps.background;
    delete normalizedThemeProps.border;
    delete normalizedThemeProps.pad;
    content = /*#__PURE__*/ $45f69439fcb47049$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $45f69439fcb47049$var$_extends({}, normalizedThemeProps, rest, {
        align: "center",
        fill: true,
        pad: pad
    }), content);
    if (onToggle) {
        var expandText = format({
            id: 'dataTable.expand',
            messages: messages,
            values: {
                label: expandLabel || ''
            }
        });
        var collapseText = format({
            id: 'dataTable.collapse',
            messages: messages,
            values: {
                label: expandLabel || ''
            }
        });
        var expandAllText = format({
            id: 'dataTable.expandAll',
            messages: messages
        });
        var collapseAllText = format({
            id: 'dataTable.collapseAll',
            messages: messages
        });
        var a11yTitle;
        if (expandLabel) a11yTitle = format({
            id: expanded ? 'dataTable.collapse' : 'dataTable.expand',
            messages: messages,
            values: {
                label: expandLabel
            }
        });
        else if (context === 'header') a11yTitle = expanded ? collapseAllText : expandAllText;
        else a11yTitle = expanded ? collapseText : expandText;
        content = /*#__PURE__*/ $45f69439fcb47049$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
            fill: true,
            "aria-expanded": expanded ? 'true' : 'false',
            a11yTitle: a11yTitle,
            hoverIndicator: true,
            focusIndicator: "inset",
            onClick: onToggle,
            plain: true
        }, content);
    }
    return content;
};
var $45f69439fcb47049$var$ExpanderCell = $45f69439fcb47049$export$8ebdff051337858b = function ExpanderCell(_ref2) {
    var _theme$dataTable$expa;
    var background = _ref2.background, border = _ref2.border, context = _ref2.context, expandLabel = _ref2.expandLabel, rest = $45f69439fcb47049$var$_objectWithoutPropertiesLoose(_ref2, $45f69439fcb47049$var$_excluded2);
    var _useThemeValue2 = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue2.theme;
    return /*#__PURE__*/ $45f69439fcb47049$var$_react["default"].createElement($5501e7a1e1340982$export$1e4baea7053fc0e3, {
        background: background,
        border: border,
        size: (_theme$dataTable$expa = theme.dataTable.expand) == null ? void 0 : _theme$dataTable$expa.size,
        plain: "noPad",
        verticalAlign: context === 'groupEnd' ? 'bottom' : 'top'
    }, /*#__PURE__*/ $45f69439fcb47049$var$_react["default"].createElement($45f69439fcb47049$var$ExpanderControl, $45f69439fcb47049$var$_extends({
        context: context,
        expandLabel: expandLabel
    }, rest)));
};
$45f69439fcb47049$var$ExpanderCell.displayName = 'ExpanderCell';


var $ff3a0b5a9b0cbb67$export$1e511d4a378977f5;
var $ff3a0b5a9b0cbb67$export$333ccef64da8eec4;
var $ff3a0b5a9b0cbb67$export$c9510f1c30960d9b;
var $ff3a0b5a9b0cbb67$export$35ee3cab512e9b03;
var $ff3a0b5a9b0cbb67$export$f632e2e61f1007ab;
var $ff3a0b5a9b0cbb67$export$27a3c65e9acad7cd;
var $ff3a0b5a9b0cbb67$export$ffaac7a4853e1cb0;
var $ff3a0b5a9b0cbb67$export$d272165a8a43ec6;
var $ff3a0b5a9b0cbb67$export$551fccb2985765ce;
var $ff3a0b5a9b0cbb67$export$1d41361302b577a1;
"use strict";
$ff3a0b5a9b0cbb67$export$1e511d4a378977f5 = true;
$ff3a0b5a9b0cbb67$export$333ccef64da8eec4 = $ff3a0b5a9b0cbb67$export$c9510f1c30960d9b = $ff3a0b5a9b0cbb67$export$35ee3cab512e9b03 = $ff3a0b5a9b0cbb67$export$f632e2e61f1007ab = $ff3a0b5a9b0cbb67$export$27a3c65e9acad7cd = $ff3a0b5a9b0cbb67$export$ffaac7a4853e1cb0 = $ff3a0b5a9b0cbb67$export$d272165a8a43ec6 = $ff3a0b5a9b0cbb67$export$551fccb2985765ce = $ff3a0b5a9b0cbb67$export$1d41361302b577a1 = void 0;

var $ff3a0b5a9b0cbb67$var$_styledComponents = $ff3a0b5a9b0cbb67$var$_interopRequireWildcard((parcelRequire("iA1nz")));


var $769e29b5528bbd43$exports = {};

$parcel$export($769e29b5528bbd43$exports, "__esModule", function () { return $769e29b5528bbd43$export$1e511d4a378977f5; }, function (v) { return $769e29b5528bbd43$export$1e511d4a378977f5 = v; });
$parcel$export($769e29b5528bbd43$exports, "TableRow", function () { return $769e29b5528bbd43$export$b05581f4e764e162; }, function (v) { return $769e29b5528bbd43$export$b05581f4e764e162 = v; });
var $769e29b5528bbd43$export$1e511d4a378977f5;
var $769e29b5528bbd43$export$b05581f4e764e162;
"use strict";
$769e29b5528bbd43$export$1e511d4a378977f5 = true;
$769e29b5528bbd43$export$b05581f4e764e162 = void 0;
var $cc35aa912f2935e4$export$1e511d4a378977f5;
var $cc35aa912f2935e4$export$b05581f4e764e162;
"use strict";
$cc35aa912f2935e4$export$1e511d4a378977f5 = true;
$cc35aa912f2935e4$export$b05581f4e764e162 = void 0;

var $cc35aa912f2935e4$var$_react = $cc35aa912f2935e4$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $cc35aa912f2935e4$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($cc35aa912f2935e4$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $cc35aa912f2935e4$var$_extends() {
    return $cc35aa912f2935e4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cc35aa912f2935e4$var$_extends.apply(null, arguments);
}
var $cc35aa912f2935e4$var$TableRow = $cc35aa912f2935e4$export$b05581f4e764e162 = /*#__PURE__*/ (0, $cc35aa912f2935e4$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $cc35aa912f2935e4$var$_react["default"].createElement($cd80d74c75620d5a$export$8a602e750662ba27, $cc35aa912f2935e4$var$_extends({
        ref: ref
    }, props));
});
$cc35aa912f2935e4$var$TableRow.displayName = 'TableRow';


$769e29b5528bbd43$export$b05581f4e764e162 = $cc35aa912f2935e4$export$b05581f4e764e162;


var $d18144d9f1ced4c1$exports = {};

$parcel$export($d18144d9f1ced4c1$exports, "__esModule", function () { return $d18144d9f1ced4c1$export$1e511d4a378977f5; }, function (v) { return $d18144d9f1ced4c1$export$1e511d4a378977f5 = v; });
$parcel$export($d18144d9f1ced4c1$exports, "Table", function () { return $d18144d9f1ced4c1$export$54ec01a60f47d33d; }, function (v) { return $d18144d9f1ced4c1$export$54ec01a60f47d33d = v; });
var $d18144d9f1ced4c1$export$1e511d4a378977f5;
var $d18144d9f1ced4c1$export$54ec01a60f47d33d;
"use strict";
$d18144d9f1ced4c1$export$1e511d4a378977f5 = true;
$d18144d9f1ced4c1$export$54ec01a60f47d33d = void 0;
var $d1dbccb5d5b89c8f$export$1e511d4a378977f5;
var $d1dbccb5d5b89c8f$export$54ec01a60f47d33d;
"use strict";
$d1dbccb5d5b89c8f$export$1e511d4a378977f5 = true;
$d1dbccb5d5b89c8f$export$54ec01a60f47d33d = void 0;

var $d1dbccb5d5b89c8f$var$_react = $d1dbccb5d5b89c8f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $bbbbd8029d758d09$export$1e511d4a378977f5;
var $bbbbd8029d758d09$export$6602ef7e207d68a0;
"use strict";
$bbbbd8029d758d09$export$1e511d4a378977f5 = true;
$bbbbd8029d758d09$export$6602ef7e207d68a0 = void 0;

var $bbbbd8029d758d09$var$_propTypes = $bbbbd8029d758d09$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $bbbbd8029d758d09$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $bbbbd8029d758d09$var$_extends() {
    return $bbbbd8029d758d09$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bbbbd8029d758d09$var$_extends.apply(null, arguments);
}
var $bbbbd8029d758d09$var$PropType = {};
$bbbbd8029d758d09$var$PropType = $bbbbd8029d758d09$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    caption: $bbbbd8029d758d09$var$_propTypes["default"].string
});
var $bbbbd8029d758d09$var$TablePropTypes = $bbbbd8029d758d09$export$6602ef7e207d68a0 = $bbbbd8029d758d09$var$PropType;



var $d1dbccb5d5b89c8f$var$_excluded = [
    "caption",
    "children"
];
function $d1dbccb5d5b89c8f$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($d1dbccb5d5b89c8f$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $d1dbccb5d5b89c8f$var$_extends() {
    return $d1dbccb5d5b89c8f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d1dbccb5d5b89c8f$var$_extends.apply(null, arguments);
}
function $d1dbccb5d5b89c8f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $d1dbccb5d5b89c8f$var$Table = $d1dbccb5d5b89c8f$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $d1dbccb5d5b89c8f$var$_react.forwardRef)(function(_ref, ref) {
    var caption = _ref.caption, children = _ref.children, rest = $d1dbccb5d5b89c8f$var$_objectWithoutPropertiesLoose(_ref, $d1dbccb5d5b89c8f$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    return /*#__PURE__*/ $d1dbccb5d5b89c8f$var$_react["default"].createElement($cd80d74c75620d5a$export$a6cc9d741fb2f287, $d1dbccb5d5b89c8f$var$_extends({
        ref: ref
    }, passThemeFlag, rest), caption ? /*#__PURE__*/ $d1dbccb5d5b89c8f$var$_react["default"].createElement($cd80d74c75620d5a$export$9c29fe8f594afe44, passThemeFlag, caption) : null, children);
});
$d1dbccb5d5b89c8f$var$Table.propTypes = $bbbbd8029d758d09$export$6602ef7e207d68a0;


$d18144d9f1ced4c1$export$54ec01a60f47d33d = $d1dbccb5d5b89c8f$export$54ec01a60f47d33d;


var $e3081fd3bb82ce0d$exports = {};

$parcel$export($e3081fd3bb82ce0d$exports, "__esModule", function () { return $e3081fd3bb82ce0d$export$1e511d4a378977f5; }, function (v) { return $e3081fd3bb82ce0d$export$1e511d4a378977f5 = v; });
$parcel$export($e3081fd3bb82ce0d$exports, "TableBody", function () { return $e3081fd3bb82ce0d$export$76ccd210b9029917; }, function (v) { return $e3081fd3bb82ce0d$export$76ccd210b9029917 = v; });
var $e3081fd3bb82ce0d$export$1e511d4a378977f5;
var $e3081fd3bb82ce0d$export$76ccd210b9029917;
"use strict";
$e3081fd3bb82ce0d$export$1e511d4a378977f5 = true;
$e3081fd3bb82ce0d$export$76ccd210b9029917 = void 0;
var $e95b77cd82238360$export$1e511d4a378977f5;
var $e95b77cd82238360$export$76ccd210b9029917;
"use strict";
$e95b77cd82238360$export$1e511d4a378977f5 = true;
$e95b77cd82238360$export$76ccd210b9029917 = void 0;

var $e95b77cd82238360$var$_react = $e95b77cd82238360$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $e95b77cd82238360$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($e95b77cd82238360$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $e95b77cd82238360$var$_extends() {
    return $e95b77cd82238360$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e95b77cd82238360$var$_extends.apply(null, arguments);
}
var $e95b77cd82238360$var$TableBody = $e95b77cd82238360$export$76ccd210b9029917 = /*#__PURE__*/ (0, $e95b77cd82238360$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e95b77cd82238360$var$_react["default"].createElement($c821c6a8dcd18d9a$export$93e4b0b2cc49b648.Provider, {
        value: "body"
    }, /*#__PURE__*/ $e95b77cd82238360$var$_react["default"].createElement($cd80d74c75620d5a$export$cd928bb20d3ce93f, $e95b77cd82238360$var$_extends({
        ref: ref
    }, props)));
});
$e95b77cd82238360$var$TableBody.displayName = 'TableBody';


$e3081fd3bb82ce0d$export$76ccd210b9029917 = $e95b77cd82238360$export$76ccd210b9029917;



var $2a5ab6af3c2b6348$exports = {};

$parcel$export($2a5ab6af3c2b6348$exports, "__esModule", function () { return $2a5ab6af3c2b6348$export$1e511d4a378977f5; }, function (v) { return $2a5ab6af3c2b6348$export$1e511d4a378977f5 = v; });
$parcel$export($2a5ab6af3c2b6348$exports, "TableHeader", function () { return $2a5ab6af3c2b6348$export$f850895b287ef28e; }, function (v) { return $2a5ab6af3c2b6348$export$f850895b287ef28e = v; });
var $2a5ab6af3c2b6348$export$1e511d4a378977f5;
var $2a5ab6af3c2b6348$export$f850895b287ef28e;
"use strict";
$2a5ab6af3c2b6348$export$1e511d4a378977f5 = true;
$2a5ab6af3c2b6348$export$f850895b287ef28e = void 0;
var $8f11d6b7744e0fe0$export$1e511d4a378977f5;
var $8f11d6b7744e0fe0$export$f850895b287ef28e;
"use strict";
$8f11d6b7744e0fe0$export$1e511d4a378977f5 = true;
$8f11d6b7744e0fe0$export$f850895b287ef28e = void 0;

var $8f11d6b7744e0fe0$var$_react = $8f11d6b7744e0fe0$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $8f11d6b7744e0fe0$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($8f11d6b7744e0fe0$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $8f11d6b7744e0fe0$var$_extends() {
    return $8f11d6b7744e0fe0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8f11d6b7744e0fe0$var$_extends.apply(null, arguments);
}
var $8f11d6b7744e0fe0$var$TableHeader = $8f11d6b7744e0fe0$export$f850895b287ef28e = /*#__PURE__*/ (0, $8f11d6b7744e0fe0$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $8f11d6b7744e0fe0$var$_react["default"].createElement($c821c6a8dcd18d9a$export$93e4b0b2cc49b648.Provider, {
        value: "header"
    }, /*#__PURE__*/ $8f11d6b7744e0fe0$var$_react["default"].createElement($cd80d74c75620d5a$export$7f6303d004e2beb, $8f11d6b7744e0fe0$var$_extends({
        ref: ref
    }, props)));
});
$8f11d6b7744e0fe0$var$TableHeader.displayName = 'TableHeader';


$2a5ab6af3c2b6348$export$f850895b287ef28e = $8f11d6b7744e0fe0$export$f850895b287ef28e;


var $b2b0be68b7012347$exports = {};

$parcel$export($b2b0be68b7012347$exports, "__esModule", function () { return $b2b0be68b7012347$export$1e511d4a378977f5; }, function (v) { return $b2b0be68b7012347$export$1e511d4a378977f5 = v; });
$parcel$export($b2b0be68b7012347$exports, "TableFooter", function () { return $b2b0be68b7012347$export$1f116082bba1f9a8; }, function (v) { return $b2b0be68b7012347$export$1f116082bba1f9a8 = v; });
var $b2b0be68b7012347$export$1e511d4a378977f5;
var $b2b0be68b7012347$export$1f116082bba1f9a8;
"use strict";
$b2b0be68b7012347$export$1e511d4a378977f5 = true;
$b2b0be68b7012347$export$1f116082bba1f9a8 = void 0;
var $a3a8ea06f98b70ec$export$1e511d4a378977f5;
var $a3a8ea06f98b70ec$export$1f116082bba1f9a8;
"use strict";
$a3a8ea06f98b70ec$export$1e511d4a378977f5 = true;
$a3a8ea06f98b70ec$export$1f116082bba1f9a8 = void 0;

var $a3a8ea06f98b70ec$var$_react = $a3a8ea06f98b70ec$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $a3a8ea06f98b70ec$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($a3a8ea06f98b70ec$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $a3a8ea06f98b70ec$var$_extends() {
    return $a3a8ea06f98b70ec$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a3a8ea06f98b70ec$var$_extends.apply(null, arguments);
}
var $a3a8ea06f98b70ec$var$TableFooter = $a3a8ea06f98b70ec$export$1f116082bba1f9a8 = /*#__PURE__*/ (0, $a3a8ea06f98b70ec$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a3a8ea06f98b70ec$var$_react["default"].createElement($c821c6a8dcd18d9a$export$93e4b0b2cc49b648.Provider, {
        value: "footer"
    }, /*#__PURE__*/ $a3a8ea06f98b70ec$var$_react["default"].createElement($cd80d74c75620d5a$export$246ad668d62a675a, $a3a8ea06f98b70ec$var$_extends({
        ref: ref
    }, props)));
});
$a3a8ea06f98b70ec$var$TableFooter.displayName = 'TableFooter';


$b2b0be68b7012347$export$1f116082bba1f9a8 = $a3a8ea06f98b70ec$export$1f116082bba1f9a8;


function $ff3a0b5a9b0cbb67$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($ff3a0b5a9b0cbb67$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
// border-collapse: separate is needed so pinned header/footer borders work
var $ff3a0b5a9b0cbb67$var$StyledDataTable = $ff3a0b5a9b0cbb67$export$551fccb2985765ce = (0, $ff3a0b5a9b0cbb67$var$_styledComponents["default"])($d18144d9f1ced4c1$export$54ec01a60f47d33d).withConfig({
    displayName: "StyledDataTable",
    componentId: "sc-xrlyjm-0"
})([
    "position:relative;border-spacing:0;border-collapse:separate;",
    " ",
    " ",
    ";"
], $4113023f9e0bafa0$exports.genericStyles, function(props) {
    return props.fillProp && (0, $4113023f9e0bafa0$exports.fillStyle)(props.fillProp);
}, function(props) {
    return props.theme.dataTable && props.theme.dataTable.body && props.theme.dataTable.body.extend;
});
// when paginated, this wraps the data table and pagination component
var $ff3a0b5a9b0cbb67$var$StyledContainer = $ff3a0b5a9b0cbb67$export$1d41361302b577a1 = (0, $ff3a0b5a9b0cbb67$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "StyledDataTable__StyledContainer",
    componentId: "sc-xrlyjm-1"
})([
    "",
    ";"
], function(props) {
    return props.theme.dataTable && props.theme.dataTable.container && props.theme.dataTable.container.extend;
});
var $ff3a0b5a9b0cbb67$var$hoverStyle = (0, $ff3a0b5a9b0cbb67$var$_styledComponents.css)([
    "",
    " color:",
    ";"
], function(props) {
    return (0, $4113023f9e0bafa0$exports.backgroundStyle)((0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.table && props.theme.table.row && props.theme.table.row.hover && props.theme.table.row.hover.background || props.theme.global.hover.background, props.theme), props.theme);
}, function(props) {
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.table && props.theme.table.row && props.theme.table.row.hover && props.theme.table.row.hover.color || props.theme.global.hover.color, props.theme);
});
var $ff3a0b5a9b0cbb67$var$rowStyles = (0, $ff3a0b5a9b0cbb67$var$_styledComponents.css)([
    "",
    " ",
    " ",
    ""
], function(props) {
    return props.size && "display: table;\n    width: 100%;\n    table-layout: fixed;\n  ";
}, function(props) {
    return props.onClick && "cursor: pointer;";
}, function(props) {
    return props.active && $ff3a0b5a9b0cbb67$var$hoverStyle;
});
var $ff3a0b5a9b0cbb67$var$StyledDataTableRow = $ff3a0b5a9b0cbb67$export$35ee3cab512e9b03 = (0, $ff3a0b5a9b0cbb67$var$_styledComponents["default"])($769e29b5528bbd43$export$b05581f4e764e162).withConfig({
    displayName: "StyledDataTable__StyledDataTableRow",
    componentId: "sc-xrlyjm-2"
})([
    "&:focus{",
    "}&:focus:not(:focus-visible){",
    "}",
    ";",
    ""
], (0, $4113023f9e0bafa0$exports.focusStyle)(), (0, $4113023f9e0bafa0$exports.unfocusStyle)(), function(props) {
    var _props$theme$dataTabl;
    return (_props$theme$dataTabl = props.theme.dataTable) == null || (_props$theme$dataTabl = _props$theme$dataTabl.body) == null || (_props$theme$dataTabl = _props$theme$dataTabl.row) == null ? void 0 : _props$theme$dataTabl.extend;
}, $ff3a0b5a9b0cbb67$var$rowStyles);
var $ff3a0b5a9b0cbb67$var$StyledDataTableRowHeader = $ff3a0b5a9b0cbb67$export$c9510f1c30960d9b = (0, $ff3a0b5a9b0cbb67$var$_styledComponents["default"])($769e29b5528bbd43$export$b05581f4e764e162).withConfig({
    displayName: "StyledDataTable__StyledDataTableRowHeader",
    componentId: "sc-xrlyjm-3"
})([
    "",
    ""
], $ff3a0b5a9b0cbb67$var$rowStyles);
// focus styling other than outline doesn't work on <tbody />
var $ff3a0b5a9b0cbb67$var$StyledDataTableBody = $ff3a0b5a9b0cbb67$export$d272165a8a43ec6 = (0, $ff3a0b5a9b0cbb67$var$_styledComponents["default"])($e3081fd3bb82ce0d$export$76ccd210b9029917).withConfig({
    displayName: "StyledDataTable__StyledDataTableBody",
    componentId: "sc-xrlyjm-4"
})([
    "",
    " &:focus{",
    "}&:focus:not(:focus-visible){",
    "}"
], function(props) {
    return props.size && "\n    display: block;\n    width: 100%;\n    max-height: " + (props.theme.global.size[props.size] || props.size) + ";\n    overflow: auto;\n  ";
}, (0, $4113023f9e0bafa0$exports.focusStyle)({
    skipSvgChildren: true,
    forceOutline: true
}), (0, $4113023f9e0bafa0$exports.unfocusStyle)({
    skipSvgChildren: true,
    forceOutline: true
}));
var $ff3a0b5a9b0cbb67$var$StyledDataTableHeader = $ff3a0b5a9b0cbb67$export$f632e2e61f1007ab = (0, $ff3a0b5a9b0cbb67$var$_styledComponents["default"])($2a5ab6af3c2b6348$export$f850895b287ef28e).withConfig({
    displayName: "StyledDataTable__StyledDataTableHeader",
    componentId: "sc-xrlyjm-5"
})([
    "",
    ""
], function(props) {
    return props.size && "\n    height: fit-content;\n    display: table;\n    width: calc(100% - " + props.scrollOffset + "px);\n    table-layout: fixed;\n  ";
});
var $ff3a0b5a9b0cbb67$var$StyledDataTableFooter = $ff3a0b5a9b0cbb67$export$27a3c65e9acad7cd = (0, $ff3a0b5a9b0cbb67$var$_styledComponents["default"])($b2b0be68b7012347$export$1f116082bba1f9a8).withConfig({
    displayName: "StyledDataTable__StyledDataTableFooter",
    componentId: "sc-xrlyjm-6"
})([
    "",
    " ",
    ""
], function(props) {
    return props.size && "\n    display: table;\n    width: calc(100% - " + props.scrollOffset + "px);\n    table-layout: fixed;\n  ";
}, function(props) {
    return props.pin && "\n      /* Safari needs the relative positioning of tfoot specified */\n      position: sticky;\n      bottom: 0;\n      z-index: 1;\n  ";
});
var $ff3a0b5a9b0cbb67$var$StyledDataTableCell = $ff3a0b5a9b0cbb67$export$ffaac7a4853e1cb0 = (0, $ff3a0b5a9b0cbb67$var$_styledComponents["default"])($5501e7a1e1340982$export$1e4baea7053fc0e3).withConfig({
    displayName: "StyledDataTable__StyledDataTableCell",
    componentId: "sc-xrlyjm-7"
})([
    "",
    ";",
    " ",
    ""
], function(props) {
    return props.context === 'header' && props.theme.dataTable && props.theme.dataTable.header && props.theme.dataTable.header.extend;
}, function(props) {
    return props.pin && props.pin.length > 0 && "position: sticky;\n    " + props.pin.map(function(p) {
        return p + ": " + (props.pinnedOffset && props.pinnedOffset[p] && props.pinnedOffset[p] + "px" || 0) + ";";
    }).join(' ') + "\n    z-index: " + Object.keys(props.pin).length + ";\n  ";
}, function(props) {
    return props.pin && props.pin.length > 0 && props.theme.dataTable.pinned && props.theme.dataTable.pinned[props.context] && props.theme.dataTable.pinned[props.context].extend ? props.theme.dataTable.pinned[props.context].extend : '';
});
var $ff3a0b5a9b0cbb67$var$StyledPlaceholder = $ff3a0b5a9b0cbb67$export$333ccef64da8eec4 = (0, $ff3a0b5a9b0cbb67$var$_styledComponents["default"])('caption').withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledDataTable__StyledPlaceholder",
    componentId: "sc-xrlyjm-8"
})([
    "position:absolute;",
    " ",
    " left:0;right:0;"
], function(props) {
    return "top: " + (props.top || 0) + "px;";
}, function(props) {
    return "bottom: " + (props.bottom || 0) + "px;";
});


var $f31f45a415daea9b$export$1e511d4a378977f5;
var $f31f45a415daea9b$export$adaa4cf7ef1b65be;
var $f31f45a415daea9b$export$ad33e27b4a0251a4;
var $f31f45a415daea9b$export$b3f0e4b3a6cf0421;
var $f31f45a415daea9b$export$e29cd744291e9244;
var $f31f45a415daea9b$export$4553511e3ef6f0d3;
var $f31f45a415daea9b$export$e8312bf6b7d1344d;
var $f31f45a415daea9b$export$3e02c678c13755e4;
var $f31f45a415daea9b$export$a4789ef9776cfd0d;
var $f31f45a415daea9b$export$682ea250e758ab92;
var $f31f45a415daea9b$export$680f59e10d3eb269;
var $f31f45a415daea9b$export$dd1eb10ac590717;
var $f31f45a415daea9b$export$bde56fd39aca7865;
"use strict";
$f31f45a415daea9b$export$1e511d4a378977f5 = true;
$f31f45a415daea9b$export$adaa4cf7ef1b65be = $f31f45a415daea9b$export$ad33e27b4a0251a4 = $f31f45a415daea9b$export$b3f0e4b3a6cf0421 = $f31f45a415daea9b$export$e29cd744291e9244 = $f31f45a415daea9b$export$4553511e3ef6f0d3 = $f31f45a415daea9b$export$e8312bf6b7d1344d = $f31f45a415daea9b$export$3e02c678c13755e4 = $f31f45a415daea9b$export$a4789ef9776cfd0d = $f31f45a415daea9b$export$682ea250e758ab92 = $f31f45a415daea9b$export$680f59e10d3eb269 = $f31f45a415daea9b$export$dd1eb10ac590717 = $f31f45a415daea9b$export$bde56fd39aca7865 = void 0;
function $f31f45a415daea9b$var$_extends() {
    return $f31f45a415daea9b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f31f45a415daea9b$var$_extends.apply(null, arguments);
}
// This file contains helper functions for DataTable, to keep the component
// files simpler.
var $f31f45a415daea9b$var$set = $f31f45a415daea9b$export$adaa4cf7ef1b65be = function set(obj, path, value) {
    var parts = path;
    if (Object(obj) !== obj) return obj;
    if (!Array.isArray(path)) parts = path.toString().match(/[^.[\]]+/g) || [];
    parts.slice(0, -1).reduce(function(acc, item, index) {
        if (Object(acc[item]) === acc[item]) return acc[item];
        acc[item] = (parts[index + 1], parts[index + 1], {});
        return acc[item];
    }, obj)[parts[parts.length - 1]] = value;
    return obj;
};
// get the value for the property in the datum object
var $f31f45a415daea9b$var$_datumValue = $f31f45a415daea9b$export$682ea250e758ab92 = function datumValue(datum, property) {
    if (!property || !datum) return undefined;
    var parts = property.split('.');
    if (parts.length === 1) return datum[property];
    if (!datum[parts[0]]) return undefined;
    return $f31f45a415daea9b$var$_datumValue(datum[parts[0]], parts.slice(1).join('.'));
};
// get the primary property name
var $f31f45a415daea9b$var$normalizePrimaryProperty = $f31f45a415daea9b$export$e29cd744291e9244 = function normalizePrimaryProperty(columns, primaryKey) {
    var result;
    if (typeof primaryKey === 'string' || typeof primaryKey === 'boolean') result = primaryKey;
    else if (primaryKey === null) console.warn('null is not a supported value for primaryKey. See supported values: https://v2.grommet.io/datatable#primaryKey');
    if (result === undefined) columns.forEach(function(column) {
        // remember the first key property
        if (column.primary && !result) result = column.property;
    });
    if (result === undefined && columns.length > 0) result = columns[0].property;
    return result;
};
// initialize filters with empty strings
var $f31f45a415daea9b$var$initializeFilters = $f31f45a415daea9b$export$3e02c678c13755e4 = function initializeFilters(columns) {
    var result = {};
    columns.forEach(function(column) {
        if (column.search) result[column.property] = '';
    });
    return result;
};
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
var $f31f45a415daea9b$var$escapeRegExp = function escapeRegExp(input) {
    return input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
// filter data based on filters then sort
var $f31f45a415daea9b$var$filterAndSortData = $f31f45a415daea9b$export$a4789ef9776cfd0d = function filterAndSortData(data, filters, onSearch, sort) {
    var result = data;
    if (!onSearch) {
        var regexps = {};
        Object.keys(filters).filter(function(n) {
            return filters[n];
        }).forEach(function(n) {
            regexps[n] = new RegExp($f31f45a415daea9b$var$escapeRegExp(filters[n]), 'i');
        });
        if (Object.keys(regexps).length > 0) result = data.filter(function(datum) {
            return !Object.keys(regexps).some(function(property) {
                return !regexps[property].test($f31f45a415daea9b$var$_datumValue(datum, property));
            });
        });
    }
    if (sort && !sort.external) {
        var property = sort.property, direction = sort.direction;
        result = result === data ? [].concat(data) : result; // don't sort caller's data
        var sortAsc = direction === 'asc';
        var before = sortAsc ? 1 : -1;
        var after = sortAsc ? -1 : 1;
        result.sort(function(d1, d2) {
            var d1Val = $f31f45a415daea9b$var$_datumValue(d1, property);
            var d2Val = $f31f45a415daea9b$var$_datumValue(d2, property);
            if (typeof d1Val === 'string' && typeof d2Val === 'string' || typeof d1Val === 'string' && !d2Val || typeof d2Val === 'string' && !d1Val) {
                var sortResult = (d1Val || '').localeCompare(d2Val || '', undefined, {
                    sensitivity: 'base'
                });
                return sortAsc ? sortResult : -sortResult;
            }
            if (d1Val > d2Val) return before;
            if (d1Val < d2Val) return after;
            return 0;
        });
    }
    return result;
};
// aggregate reducers
var $f31f45a415daea9b$var$sumReducer = function sumReducer(accumulated, next) {
    return accumulated + next;
};
var $f31f45a415daea9b$var$minReducer = function minReducer(accumulated, next) {
    return accumulated === undefined ? next : Math.min(accumulated, next);
};
var $f31f45a415daea9b$var$maxReducer = function maxReducer(accumulated, next) {
    return accumulated === undefined ? next : Math.max(accumulated, next);
};
var $f31f45a415daea9b$var$reducers = {
    max: $f31f45a415daea9b$var$maxReducer,
    min: $f31f45a415daea9b$var$minReducer,
    sum: $f31f45a415daea9b$var$sumReducer
};
// aggregate reducers init values
var $f31f45a415daea9b$var$reducersInitValues = {
    min: Number.MAX_VALUE,
    max: Number.MIN_VALUE,
    sum: 0
};
// aggregate a single column
var $f31f45a415daea9b$var$aggregateColumn = function aggregateColumn(column, data) {
    var value;
    if (column.aggregate === 'avg') {
        value = data.map(function(d) {
            return $f31f45a415daea9b$var$_datumValue(d, column.property);
        }).reduce($f31f45a415daea9b$var$sumReducer);
        value /= data.length;
    } else value = data.map(function(d) {
        return $f31f45a415daea9b$var$_datumValue(d, column.property);
    }).reduce($f31f45a415daea9b$var$reducers[column.aggregate], $f31f45a415daea9b$var$reducersInitValues[column.aggregate]);
    return value;
};
// aggregate all columns that can
var $f31f45a415daea9b$var$aggregate = function aggregate(columns, data) {
    var result = {};
    columns.forEach(function(column) {
        if (column.aggregate) {
            var value = $f31f45a415daea9b$var$aggregateColumn(column, data);
            result = $f31f45a415daea9b$var$set(result, column.property, value);
        }
    });
    return result;
};
// build the values for the footer cells
var $f31f45a415daea9b$var$buildFooterValues = $f31f45a415daea9b$export$bde56fd39aca7865 = function buildFooterValues(columns, data) {
    var aggregateValues = $f31f45a415daea9b$var$aggregate(columns, data);
    var result = {};
    columns.forEach(function(column) {
        if (column.footer) {
            if (column.footer.aggregate) {
                var value = $f31f45a415daea9b$var$_datumValue(aggregateValues, column.property);
                result = $f31f45a415daea9b$var$set(result, column.property, value);
            } else result = $f31f45a415daea9b$var$set(result, column.property, column.footer);
        }
    });
    return result;
};
// looks at the groupBy property of each data object and returns an
// array with one item for each unique value of that property.
var $f31f45a415daea9b$var$buildGroups = $f31f45a415daea9b$export$680f59e10d3eb269 = function buildGroups(columns, data, groupBy, primaryProperty) {
    var result;
    if (groupBy != null && groupBy.property || typeof groupBy === 'string') {
        result = [];
        var groupMap = {};
        data.forEach(function(datum) {
            var _groupBy$expandable;
            var key = $f31f45a415daea9b$var$_datumValue(datum, primaryProperty);
            var isGroup = key && ((_groupBy$expandable = groupBy.expandable) == null ? void 0 : _groupBy$expandable.includes(key));
            var groupByProperty = groupBy.property ? groupBy.property : groupBy;
            var groupValue = isGroup ? key : $f31f45a415daea9b$var$_datumValue(datum, groupByProperty);
            if (!groupMap[groupValue]) {
                var group = {
                    data: [],
                    datum: isGroup ? datum : {},
                    key: groupValue
                };
                group.datum[groupByProperty] = groupValue;
                result.push(group);
                groupMap[groupValue] = group;
            }
            if (!isGroup) groupMap[groupValue].data.push(datum);
        });
        // include any aggregate column values across the data for each group
        // If expandable was specified we let the onUpdate callback do it since
        // we may not have access to all the data to aggregate it.
        if (!groupBy.expandable) columns.forEach(function(column) {
            if (column.aggregate) result.forEach(function(group) {
                var datum = group.datum;
                datum[column.property] = $f31f45a415daea9b$var$aggregateColumn(column, group.data);
            });
        });
    } else if (groupBy != null && groupBy.expandable) result = groupBy.expandable.map(function(key) {
        return {
            data: [],
            datum: {},
            key: key
        };
    });
    return result;
};
// build group expanded state, expanding any in groupBy.expand
var $f31f45a415daea9b$var$buildGroupState = $f31f45a415daea9b$export$dd1eb10ac590717 = function buildGroupState(groups, groupBy) {
    var result = {};
    if (groups) groups.forEach(function(_ref) {
        var key = _ref.key;
        if (key !== undefined) result[key] = {
            expanded: false
        };
    });
    if (groupBy && groupBy.expand) groupBy.expand.forEach(function(value) {
        result[value] = {
            expanded: true
        };
    });
    return result;
};
var $f31f45a415daea9b$var$normalizeBackgroundColor = $f31f45a415daea9b$export$e8312bf6b7d1344d = function normalizeBackgroundColor(theme) {
    var background = theme.background; // context background
    if (typeof background === 'string') return background;
    if (background.light && background.dark) return background;
    if (background.color) return background.color;
    return undefined;
};
var $f31f45a415daea9b$var$normalizeRowProp = $f31f45a415daea9b$export$ad33e27b4a0251a4 = function normalizeRowProp(name, rowProp, prop) {
    if (rowProp && rowProp[name]) return rowProp[name];
    return prop;
};
var $f31f45a415daea9b$var$tableContextNames = [
    'header',
    'body',
    'footer',
    'groupHeader'
];
var $f31f45a415daea9b$var$cellPropertyNames = [
    'background',
    'border',
    'pad'
];
// Convert property specific cell props to context specific cell props.
// For example, background={{ header: { background } }}
// will become cellProps.header.background
var $f31f45a415daea9b$var$normalizeCellProps = $f31f45a415daea9b$export$4553511e3ef6f0d3 = function normalizeCellProps(props, theme) {
    var _theme$dataTable3;
    var result = {};
    $f31f45a415daea9b$var$tableContextNames.forEach(function(context) {
        result[context] = {
            pinned: {}
        };
        $f31f45a415daea9b$var$cellPropertyNames.forEach(function(propName) {
            var _props$propName, _theme$dataTable, _theme$table, _props$propName3, _props$propName5, _theme$dataTable2;
            var value = (props == null || (_props$propName = props[propName]) == null ? void 0 : _props$propName[context]) || // if the propName is used without context, it applies to all contexts
            $f31f45a415daea9b$var$tableContextNames.every(function(n) {
                var _props$propName2;
                return !(props != null && (_props$propName2 = props[propName]) != null && _props$propName2[n]);
            }) && (props == null ? void 0 : props[propName]) || (theme == null || (_theme$dataTable = theme.dataTable) == null || (_theme$dataTable = _theme$dataTable[context]) == null ? void 0 : _theme$dataTable[propName]) || (theme == null || (_theme$table = theme.table) == null || (_theme$table = _theme$table[context]) == null ? void 0 : _theme$table[propName]);
            if (value !== undefined) result[context][propName] = value;
            // pinned case
            value = (props == null || (_props$propName3 = props[propName]) == null || (_props$propName3 = _props$propName3.pinned) == null ? void 0 : _props$propName3[context]) || context === 'body' && $f31f45a415daea9b$var$tableContextNames.every(function(n) {
                var _props$propName4;
                return !(props != null && (_props$propName4 = props[propName]) != null && (_props$propName4 = _props$propName4.pinned) != null && _props$propName4[n]);
            }) && (props == null || (_props$propName5 = props[propName]) == null ? void 0 : _props$propName5.pinned) || (theme == null || (_theme$dataTable2 = theme.dataTable) == null || (_theme$dataTable2 = _theme$dataTable2.pinned) == null || (_theme$dataTable2 = _theme$dataTable2[context]) == null ? void 0 : _theme$dataTable2[propName]);
            if (value !== undefined) {
                if (propName === 'background' && theme.background && value.opacity && !value.color) // theme context has an active background color but the
                // theme doesn't set an explicit color, repeat the context
                // background explicitly
                value.color = $f31f45a415daea9b$var$normalizeBackgroundColor(theme);
                if (context === 'body') // in case we have pinned columns, store the pinned stuff in
                // cellProps.body.pinned
                result[context].pinned[propName] = value;
                else if (props.pin === true || props.pin === context) // this context is pinned, use the pinned value directly
                result[context][propName] = value;
            }
        });
    });
    result.body.selected = $f31f45a415daea9b$var$_extends({}, theme == null || (_theme$dataTable3 = theme.dataTable) == null || (_theme$dataTable3 = _theme$dataTable3.body) == null ? void 0 : _theme$dataTable3.selected);
    return result;
};
var $f31f45a415daea9b$var$normalizeRowCellProps = $f31f45a415daea9b$export$b3f0e4b3a6cf0421 = function normalizeRowCellProps(rowProps, cellProps, primaryKey, index) {
    var result = {
        pinned: {},
        selected: cellProps.selected
    };
    [
        'background',
        'border',
        'pad'
    ].forEach(function(propName) {
        var _rowProps$primaryKey;
        var row = primaryKey && rowProps && (rowProps == null || (_rowProps$primaryKey = rowProps[primaryKey]) == null ? void 0 : _rowProps$primaryKey[propName]);
        var cell = cellProps[propName];
        var value = row && (Array.isArray(row) ? row[index % row.length] : row) || (Array.isArray(cell) ? cell[index % cell.length] : cell);
        if (value !== undefined) result[propName] = value;
        var rowPin = rowProps && rowProps.pinned && rowProps.pinned[propName];
        var cellPin = cellProps.pinned[propName];
        value = rowPin && (Array.isArray(rowPin) ? rowPin[index % rowPin.length] : rowPin) || (Array.isArray(cellPin) ? cellPin[index % cellPin.length] : cellPin);
        if (value !== undefined) result.pinned[propName] = value;
    });
    return result;
};





var $51e7385aa9e065e1$var$_excluded = [
    "background",
    "border",
    "color",
    "font",
    "gap",
    "pad",
    "units"
], $51e7385aa9e065e1$var$_excluded2 = [
    "allowSelectAll",
    "cellProps",
    "columns",
    "data",
    "disabled",
    "fill",
    "filtering",
    "filters",
    "groupBy",
    "groups",
    "groupState",
    "messages",
    "onFilter",
    "onFiltering",
    "onResize",
    "onSelect",
    "onSort",
    "onToggle",
    "onWidths",
    "pin",
    "pinnedOffset",
    "primaryProperty",
    "selected",
    "rowDetails",
    "sort",
    "widths",
    "verticalAlign"
];
/* eslint-disable no-underscore-dangle */ function $51e7385aa9e065e1$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($51e7385aa9e065e1$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $51e7385aa9e065e1$var$_extends() {
    return $51e7385aa9e065e1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $51e7385aa9e065e1$var$_extends.apply(null, arguments);
}
function $51e7385aa9e065e1$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// delay before triggering width update. This allows most/all header resizes
// to be batched together causing fewer render passes
var $51e7385aa9e065e1$var$WIDTH_UPDATE_DELAY = 100;
// separate theme values into groupings depending on what
// part of header cell they should style
var $51e7385aa9e065e1$var$separateThemeProps = function separateThemeProps(theme) {
    var _theme$dataTable$head = theme.dataTable.header, background = _theme$dataTable$head.background, border = _theme$dataTable$head.border, color = _theme$dataTable$head.color, font = _theme$dataTable$head.font, gap = _theme$dataTable$head.gap, pad = _theme$dataTable$head.pad, units = _theme$dataTable$head.units, rest = $51e7385aa9e065e1$var$_objectWithoutPropertiesLoose(_theme$dataTable$head, $51e7385aa9e065e1$var$_excluded);
    var textProps = $51e7385aa9e065e1$var$_extends({
        color: color
    }, font);
    var iconProps = {
        color: color
    };
    var layoutProps = $51e7385aa9e065e1$var$_extends({}, rest);
    return [
        layoutProps,
        textProps,
        iconProps
    ];
};
// build up CSS from basic to specific based on the supplied sub-object paths.
// adapted from StyledButtonKind to only include parts relevant for DataTable
var $51e7385aa9e065e1$var$buttonStyle = function buttonStyle(_ref) {
    var pad = _ref.pad, theme = _ref.theme, verticalAlign = _ref.verticalAlign;
    var styles = [];
    var _separateThemeProps = $51e7385aa9e065e1$var$separateThemeProps(theme), layoutProps = _separateThemeProps[0], iconProps = _separateThemeProps[2];
    // if cell is sortable, we want pad to be applied
    // to the button instead of the cell
    if (pad) styles.push((0, $9a7099e779e83517$export$73d7bd5e5b0271ce)({
        pad: pad
    }, theme));
    if (layoutProps) styles.push((0, $9a7099e779e83517$export$73d7bd5e5b0271ce)(layoutProps, theme));
    if (layoutProps.hover) {
        // CSS for this sub-object in the theme
        var partStyles = (0, $9a7099e779e83517$export$73d7bd5e5b0271ce)(layoutProps.hover, theme);
        if (partStyles.length > 0) styles.push((0, $51e7385aa9e065e1$var$_styledComponents.css)([
            "&:hover{",
            "}"
        ], partStyles));
    }
    if (iconProps.color) styles.push((0, $51e7385aa9e065e1$var$_styledComponents.css)([
        "svg{stroke:",
        ";fill:",
        ";}"
    ], (0, $62e050f1cfc78056$export$4cde5df63f53f473)(iconProps.color, theme), (0, $62e050f1cfc78056$export$4cde5df63f53f473)(iconProps.color, theme)));
    var align = 'center';
    if (verticalAlign === 'bottom') align = 'end';
    if (verticalAlign === 'top') align = 'start';
    if (verticalAlign) styles.push((0, $51e7385aa9e065e1$var$_styledComponents.css)([
        "display:inline-flex;align-items:",
        ";"
    ], align));
    return styles;
};
var $51e7385aa9e065e1$var$StyledHeaderCellButton = (0, $51e7385aa9e065e1$var$_styledComponents["default"])($fb68f765668b25d0$export$353f5b6fc5456de1).withConfig({
    displayName: "Header__StyledHeaderCellButton",
    componentId: "sc-1baku5q-0"
})([
    "",
    ""
], function(props) {
    return $51e7385aa9e065e1$var$buttonStyle(props);
});
// allow extend to spread onto Box that surrounds column label
var $51e7385aa9e065e1$var$StyledContentBox = (0, $51e7385aa9e065e1$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "Header__StyledContentBox",
    componentId: "sc-1baku5q-1"
})([
    "",
    ""
], function(props) {
    return props.extend;
});
var $51e7385aa9e065e1$var$Header = $51e7385aa9e065e1$export$8b251419efc915eb = /*#__PURE__*/ (0, $51e7385aa9e065e1$var$_react.forwardRef)(function(_ref2, ref) {
    var _theme$dataTable$expa;
    var allowSelectAll = _ref2.allowSelectAll, cellProps = _ref2.cellProps, columns = _ref2.columns, data = _ref2.data, disabled = _ref2.disabled, fill = _ref2.fill, filtering = _ref2.filtering, filters = _ref2.filters, groupBy = _ref2.groupBy, groups = _ref2.groups, groupState = _ref2.groupState, messages = _ref2.messages, onFilter = _ref2.onFilter, onFiltering = _ref2.onFiltering, _onResize = _ref2.onResize, onSelect = _ref2.onSelect, onSort = _ref2.onSort, onToggle = _ref2.onToggle, onWidths = _ref2.onWidths, pinProp = _ref2.pin, pinnedOffset = _ref2.pinnedOffset, primaryProperty = _ref2.primaryProperty, selected = _ref2.selected, rowDetails = _ref2.rowDetails, sort = _ref2.sort, widths = _ref2.widths, verticalAlign = _ref2.verticalAlign, rest = $51e7385aa9e065e1$var$_objectWithoutPropertiesLoose(_ref2, $51e7385aa9e065e1$var$_excluded2);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _separateThemeProps2 = $51e7385aa9e065e1$var$separateThemeProps(theme), layoutProps = _separateThemeProps2[0], textProps = _separateThemeProps2[1];
    var _useContext = (0, $51e7385aa9e065e1$var$_react.useContext)($932597a497e37de0$export$58d75f9829cbe158), contextTotal = _useContext.total;
    var _useContext2 = (0, $51e7385aa9e065e1$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext2.format;
    var cellWidthsRef = (0, $51e7385aa9e065e1$var$_react.useRef)({});
    var timerRef = (0, $51e7385aa9e065e1$var$_react.useRef)();
    var handleWidths = (0, $51e7385aa9e065e1$var$_react.useCallback)(function() {
        var cellWidths = cellWidthsRef.current;
        if (onWidths && cellWidths) {
            var internalColumnWidths = selected || onSelect ? [
                cellWidths._grommetDataTableSelect
            ] : [];
            onWidths([].concat(internalColumnWidths, columns.map(function(_ref3) {
                var property = _ref3.property;
                return cellWidths[property];
            })));
        }
    }, [
        columns,
        onSelect,
        onWidths,
        selected
    ]);
    var updateWidths = (0, $51e7385aa9e065e1$var$_react.useCallback)(function(property, width) {
        if (typeof width !== 'number') return;
        // Only update if width actually changed
        if ((cellWidthsRef == null ? void 0 : cellWidthsRef.current[property]) !== width) {
            cellWidthsRef.current[property] = width;
            if (timerRef.current) clearTimeout(timerRef.current);
            timerRef.current = setTimeout(handleWidths, $51e7385aa9e065e1$var$WIDTH_UPDATE_DELAY);
        }
    }, [
        handleWidths
    ]);
    var pin = pinProp ? [
        'top'
    ] : [];
    var selectPin = pinnedOffset != null && pinnedOffset._grommetDataTableSelect ? [].concat(pin, [
        'left'
    ]) : pin;
    var totalSelectedGroups = groupBy != null && groupBy.select ? Object.keys(groupBy.select).reduce(function(total, cur) {
        return cur && groupBy.select[cur] === 'all' ? total + 1 : total;
    }, 0) : 0;
    var totalSelected = ((selected == null ? void 0 : selected.length) || 0) + totalSelectedGroups;
    var onChangeSelection = (0, $51e7385aa9e065e1$var$_react.useCallback)(function() {
        var nextSelected = [].concat(selected);
        var nextGroupSelected = {};
        // get primary values for current data view
        var primaryValues = data.map(function(datum) {
            return (0, $f31f45a415daea9b$export$682ea250e758ab92)(datum, primaryProperty);
        }) || [];
        // enabled includes what can be changed
        var enabled = disabled && primaryValues.filter(function(v) {
            return !disabled.includes(v);
        }) || primaryValues;
        // enabledSelected includes what can be changed and is currently selected
        var enabledSelected = selected && enabled.filter(function(v) {
            return selected.includes(v);
        }) || primaryValues;
        var allSelected = groupBy != null && groupBy.select ? groupBy.select[''] === 'all' : enabledSelected.length === enabled.length;
        // if all enabled are already selected, remove them from selected,
        // otherwise add them.
        if (allSelected) {
            enabledSelected.forEach(function(p) {
                var index = nextSelected.indexOf(p);
                if (index >= 0) nextSelected.splice(index, 1);
            });
            nextGroupSelected[''] = 'none';
        } else {
            var _groupBy$expandable;
            enabled.forEach(function(p) {
                if (!nextSelected.includes(p)) nextSelected.push(p);
            });
            nextGroupSelected[''] = 'all';
            groupBy == null || (_groupBy$expandable = groupBy.expandable) == null || _groupBy$expandable.forEach(function(key) {
                nextGroupSelected[key] = 'all';
            });
        }
        if (groupBy != null && groupBy.onSelect) groupBy.onSelect(nextSelected, undefined, nextGroupSelected);
        else onSelect(nextSelected);
    }, [
        data,
        disabled,
        groupBy,
        onSelect,
        primaryProperty,
        selected
    ]);
    return /*#__PURE__*/ $51e7385aa9e065e1$var$_react["default"].createElement($ff3a0b5a9b0cbb67$export$f632e2e61f1007ab, $51e7385aa9e065e1$var$_extends({
        ref: ref,
        fillProp: fill
    }, rest), /*#__PURE__*/ $51e7385aa9e065e1$var$_react["default"].createElement($ff3a0b5a9b0cbb67$export$c9510f1c30960d9b, null, groups && /*#__PURE__*/ $51e7385aa9e065e1$var$_react["default"].createElement($45f69439fcb47049$export$8ebdff051337858b, {
        background: cellProps.background,
        border: cellProps.border,
        context: "header",
        expanded: Object.keys(groupState).filter(function(k) {
            return !groupState[k].expanded;
        }).length === 0,
        onToggle: onToggle,
        pad: cellProps.pad
    }), (selected || onSelect) && /*#__PURE__*/ $51e7385aa9e065e1$var$_react["default"].createElement($ff3a0b5a9b0cbb67$export$ffaac7a4853e1cb0, $51e7385aa9e065e1$var$_extends({
        background: cellProps.background,
        onWidth: function onWidth(width) {
            return updateWidths('_grommetDataTableSelect', width);
        },
        plain: "noPad",
        size: "auto",
        context: "header",
        scope: "col",
        pin: selectPin,
        pinnedOffset: pinnedOffset == null ? void 0 : pinnedOffset._grommetDataTableSelect,
        verticalAlign: verticalAlign
    }, passThemeFlag), onSelect && allowSelectAll && /*#__PURE__*/ $51e7385aa9e065e1$var$_react["default"].createElement($c15af89705eeb537$export$ea5f704b89d806f6, {
        a11yTitle: totalSelected === data.length ? 'unselect all' : 'select all',
        checked: groupBy != null && groupBy.select ? groupBy.select[''] === 'all' : totalSelected > 0 && data.length > 0 && totalSelected === (contextTotal || data.length),
        indeterminate: groupBy != null && groupBy.select ? groupBy.select[''] === 'some' : totalSelected > 0 && totalSelected < (contextTotal || data.length),
        onChange: onChangeSelection,
        pad: cellProps.pad
    })), rowDetails && /*#__PURE__*/ $51e7385aa9e065e1$var$_react["default"].createElement($a64a54bf804ade22$export$1e4baea7053fc0e3, {
        size: (_theme$dataTable$expa = theme.dataTable.expand) == null ? void 0 : _theme$dataTable$expa.size,
        plain: true,
        pad: "none"
    }), columns.map(function(_ref4) {
        var property = _ref4.property, header = _ref4.header, align = _ref4.align, columnPin = _ref4.pin, search = _ref4.search, sortable = _ref4.sortable, columnVerticalAlign = _ref4.verticalAlign, size = _ref4.size, units = _ref4.units;
        var content;
        var unitsContent = units ? /*#__PURE__*/ $51e7385aa9e065e1$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, $51e7385aa9e065e1$var$_extends({}, textProps, theme.dataTable.header.units), units) : undefined;
        if (typeof header === 'string') {
            content = /*#__PURE__*/ $51e7385aa9e065e1$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, textProps, header);
            if (Object.keys(layoutProps).length && (sortable === false || !onSort)) // apply rest of layout styling if cell is not sortable,
            // otherwise this styling will be applied by
            // StyledHeaderCellButton
            content = /*#__PURE__*/ $51e7385aa9e065e1$var$_react["default"].createElement($51e7385aa9e065e1$var$StyledContentBox, layoutProps, content);
        } else content = header;
        if (unitsContent) content = /*#__PURE__*/ $51e7385aa9e065e1$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            justify: align,
            direction: "row"
        }, content, unitsContent);
        if (verticalAlign || columnVerticalAlign) {
            var vertical = verticalAlign || columnVerticalAlign;
            content = /*#__PURE__*/ $51e7385aa9e065e1$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
                height: "100%",
                justify: $a64a54bf804ade22$export$4671998ee1170a79[vertical]
            }, content);
        }
        var ariaSort;
        if (onSort && sortable !== false) {
            var _theme$dataTable$sort;
            var Icon;
            var iconAriaLabel;
            if (onSort && sortable !== false) {
                if (sort && sort.property === property) {
                    Icon = theme.dataTable.icons[sort.direction !== 'asc' ? 'ascending' : 'descending'];
                    if (sort.direction === 'asc') {
                        ariaSort = 'ascending';
                        iconAriaLabel = format({
                            id: 'dataTable.ascending',
                            messages: messages
                        });
                    } else if (sort.direction === 'desc') {
                        ariaSort = 'descending';
                        iconAriaLabel = format({
                            id: 'dataTable.descending',
                            messages: messages
                        });
                    }
                } else if (theme.dataTable.icons.sortable) Icon = theme.dataTable.icons.sortable;
            }
            content = /*#__PURE__*/ $51e7385aa9e065e1$var$_react["default"].createElement($51e7385aa9e065e1$var$StyledHeaderCellButton, $51e7385aa9e065e1$var$_extends({
                plain: true,
                column: property,
                fill: "vertical",
                focusIndicator: size ? 'inset' : undefined,
                onClick: onSort(property),
                sort: sort,
                pad: cellProps.pad,
                sortable: true,
                verticalAlign: verticalAlign || columnVerticalAlign
            }, passThemeFlag), /*#__PURE__*/ $51e7385aa9e065e1$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
                direction: "row",
                align: "center",
                gap: (_theme$dataTable$sort = theme.dataTable.sort) == null ? void 0 : _theme$dataTable$sort.gap,
                justify: align
            }, content, Icon && /*#__PURE__*/ $51e7385aa9e065e1$var$_react["default"].createElement(Icon, {
                "aria-label": iconAriaLabel
            })));
        }
        // content should fill any available space in cell
        // If `onResize` or `search` is true we need to explicitly set
        // fill because later if either of these props is true content
        // will be wrapped with an additional Box, preventing this Box
        // from automatically filling the vertical space.
        content = /*#__PURE__*/ $51e7385aa9e065e1$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            flex: _onResize || search ? {
                grow: 1,
                shrink: 1
            } : 'grow',
            fill: _onResize || search ? 'vertical' : false,
            justify: !align && 'center' || align
        }, content);
        if (search) {
            var searcher = search && filters ? /*#__PURE__*/ $51e7385aa9e065e1$var$_react["default"].createElement($0e7344a4ac2b9bf9$export$25746e77c1b1a497, {
                filtering: filtering,
                filters: filters,
                focusIndicator: size ? 'inset' : undefined,
                messages: messages,
                property: property,
                onFilter: onFilter,
                onFiltering: onFiltering
            }) : null;
            content = /*#__PURE__*/ $51e7385aa9e065e1$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
                direction: "row",
                align: "center",
                justify: !align || align === 'start' ? 'between' : align,
                gap: theme.dataTable.header.gap,
                fill: "vertical",
                style: _onResize ? {
                    position: 'relative'
                } : undefined
            }, content, searcher && _onResize ? /*#__PURE__*/ $51e7385aa9e065e1$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
                flex: {
                    shrink: filtering === property ? 1 : 0
                },
                direction: filtering === property ? 'column' : 'row',
                margin: {
                    right: '12px'
                }
            }, searcher) : searcher);
        }
        var cellPin = [].concat(pin);
        if (columnPin) cellPin.push('left');
        var headerId = "grommet-data-table-header-" + property;
        return /*#__PURE__*/ $51e7385aa9e065e1$var$_react["default"].createElement($ff3a0b5a9b0cbb67$export$ffaac7a4853e1cb0, $51e7385aa9e065e1$var$_extends({
            "aria-sort": ariaSort,
            key: property,
            align: align,
            context: "header",
            verticalAlign: verticalAlign || columnVerticalAlign,
            background: cellProps.background,
            border: cellProps.border,
            id: headerId,
            onWidth: function onWidth(width) {
                return updateWidths(property, width);
            },
            pad: sortable === false || !onSort ? cellProps.pad : 'none',
            pin: cellPin,
            plain: true,
            pinnedOffset: pinnedOffset && pinnedOffset[property],
            scope: "col",
            size: widths && widths[property] ? undefined : size,
            style: {
                width: widths != null && widths[property] ? widths[property] + "px" : undefined,
                boxSizing: _onResize ? 'border-box' : undefined,
                // Don't override positioning when DataTable has pin prop
                position: _onResize && !columnPin && !pinProp ? 'relative' : undefined,
                overflow: _onResize ? 'visible' : undefined
            },
            onResize: _onResize,
            property: property
        }, passThemeFlag), content, _onResize && /*#__PURE__*/ $51e7385aa9e065e1$var$_react["default"].createElement($0dd0f14dac199089$export$48a76196cafe3b93, {
            property: property,
            onResize: function onResize(prop, width) {
                _onResize(prop, width);
                updateWidths(prop, width);
            },
            headerText: typeof header === 'string' ? header : property,
            messages: messages,
            headerId: headerId
        }));
    })));
});
$51e7385aa9e065e1$var$Header.displayName = 'Header';


var $4e8e103f24b53120$export$1e511d4a378977f5;
var $4e8e103f24b53120$export$a06f1c675e846f6f;
"use strict";
$4e8e103f24b53120$export$1e511d4a378977f5 = true;
$4e8e103f24b53120$export$a06f1c675e846f6f = void 0;

var $4e8e103f24b53120$var$_react = $4e8e103f24b53120$var$_interopRequireWildcard((parcelRequire("2xPiy")));


var $1fa1fff43d8b78e6$export$1e511d4a378977f5;
var $1fa1fff43d8b78e6$export$f6f0c3fe4ec306ea;
"use strict";
$1fa1fff43d8b78e6$export$1e511d4a378977f5 = true;
$1fa1fff43d8b78e6$export$f6f0c3fe4ec306ea = void 0;

var $1fa1fff43d8b78e6$var$_react = $1fa1fff43d8b78e6$var$_interopRequireWildcard((parcelRequire("2xPiy")));





var $1fa1fff43d8b78e6$var$_excluded = [
    "background",
    "border",
    "column",
    "datum",
    "pad",
    "pin",
    "pinnedOffset",
    "primaryProperty",
    "scope",
    "verticalAlign"
];
function $1fa1fff43d8b78e6$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($1fa1fff43d8b78e6$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $1fa1fff43d8b78e6$var$_extends() {
    return $1fa1fff43d8b78e6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1fa1fff43d8b78e6$var$_extends.apply(null, arguments);
}
function $1fa1fff43d8b78e6$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $1fa1fff43d8b78e6$var$Cell = $1fa1fff43d8b78e6$export$f6f0c3fe4ec306ea = /*#__PURE__*/ (0, $1fa1fff43d8b78e6$var$_react.memo)(function(_ref) {
    var background = _ref.background, border = _ref.border, _ref$column = _ref.column, align = _ref$column.align, columnPin = _ref$column.pin, plain = _ref$column.plain, footer = _ref$column.footer, property = _ref$column.property, render = _ref$column.render, columnVerticalAlign = _ref$column.verticalAlign, size = _ref$column.size, datum = _ref.datum, pad = _ref.pad, cellPin = _ref.pin, pinnedOffset = _ref.pinnedOffset, primaryProperty = _ref.primaryProperty, scope = _ref.scope, verticalAlign = _ref.verticalAlign, rest = $1fa1fff43d8b78e6$var$_objectWithoutPropertiesLoose(_ref, $1fa1fff43d8b78e6$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var value = (0, $f31f45a415daea9b$export$682ea250e758ab92)(datum, property);
    var context = (0, $1fa1fff43d8b78e6$var$_react.useContext)($c821c6a8dcd18d9a$export$93e4b0b2cc49b648);
    var renderContexts = context === 'body' || context === 'footer' && footer && footer.aggregate;
    var content;
    if (render && renderContexts) content = render(datum);
    else if (value !== undefined) {
        if (typeof value === 'string' || typeof value === 'number' || /*#__PURE__*/ (0, $1fa1fff43d8b78e6$var$_react.isValidElement)(value)) content = value;
    }
    if (typeof content === 'string' || typeof content === 'number') {
        var textProps = property === primaryProperty ? theme.dataTable.primary : {};
        content = /*#__PURE__*/ $1fa1fff43d8b78e6$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, textProps, content);
    }
    var pin = [];
    if (cellPin) pin.push.apply(pin, cellPin);
    if (columnPin) pin.push('left');
    return /*#__PURE__*/ $1fa1fff43d8b78e6$var$_react["default"].createElement($ff3a0b5a9b0cbb67$export$ffaac7a4853e1cb0, $1fa1fff43d8b78e6$var$_extends({
        scope: scope
    }, theme.dataTable[context], {
        align: align,
        context: context,
        verticalAlign: verticalAlign || columnVerticalAlign,
        size: size,
        background: background,
        pinnedOffset: pinnedOffset,
        border: border,
        pad: pad,
        pin: pin,
        plain: plain ? 'noPad' : undefined
    }, passThemeFlag, rest), content);
});
$1fa1fff43d8b78e6$var$Cell.displayName = 'Cell';




var $4e8e103f24b53120$var$_excluded = [
    "cellProps",
    "columns",
    "fill",
    "footerValues",
    "groups",
    "onSelect",
    "pin",
    "pinnedOffset",
    "primaryProperty",
    "selected",
    "verticalAlign"
];
function $4e8e103f24b53120$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($4e8e103f24b53120$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $4e8e103f24b53120$var$_extends() {
    return $4e8e103f24b53120$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4e8e103f24b53120$var$_extends.apply(null, arguments);
}
function $4e8e103f24b53120$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $4e8e103f24b53120$var$Footer = $4e8e103f24b53120$export$a06f1c675e846f6f = /*#__PURE__*/ (0, $4e8e103f24b53120$var$_react.forwardRef)(function(_ref, ref) {
    var _theme$dataTable$expa;
    var cellProps = _ref.cellProps, columns = _ref.columns, fill = _ref.fill, footerValues = _ref.footerValues, groups = _ref.groups, onSelect = _ref.onSelect, pinProp = _ref.pin, pinnedOffset = _ref.pinnedOffset, primaryProperty = _ref.primaryProperty, selected = _ref.selected, verticalAlign = _ref.verticalAlign, rest = $4e8e103f24b53120$var$_objectWithoutPropertiesLoose(_ref, $4e8e103f24b53120$var$_excluded);
    var pin = pinProp ? [
        'bottom'
    ] : [];
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var _useThemeValue2 = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue2.theme;
    return /*#__PURE__*/ $4e8e103f24b53120$var$_react["default"].createElement($ff3a0b5a9b0cbb67$export$27a3c65e9acad7cd, $4e8e103f24b53120$var$_extends({
        ref: ref,
        fillProp: fill,
        pin: pinProp
    }, rest), /*#__PURE__*/ $4e8e103f24b53120$var$_react["default"].createElement($769e29b5528bbd43$export$b05581f4e764e162, null, groups && /*#__PURE__*/ $4e8e103f24b53120$var$_react["default"].createElement($5501e7a1e1340982$export$1e4baea7053fc0e3, {
        plain: true,
        size: (_theme$dataTable$expa = theme.dataTable.expand) == null ? void 0 : _theme$dataTable$expa.size,
        pad: "none",
        verticalAlign: "top",
        background: cellProps.background,
        border: cellProps.border
    }), (selected || onSelect) && /*#__PURE__*/ $4e8e103f24b53120$var$_react["default"].createElement($ff3a0b5a9b0cbb67$export$ffaac7a4853e1cb0, $4e8e103f24b53120$var$_extends({
        background: cellProps.background,
        context: "footer",
        pin: pin,
        verticalAlign: verticalAlign
    }, passThemeFlag)), columns.map(function(column) {
        var cellPin = [].concat(pin);
        if (column.pin) cellPin.push('left');
        return /*#__PURE__*/ $4e8e103f24b53120$var$_react["default"].createElement($1fa1fff43d8b78e6$export$f6f0c3fe4ec306ea, {
            key: column.property,
            background: column.pin && cellProps.pinned.background || cellProps.background,
            border: column.pin && cellProps.pinned.border || cellProps.border,
            context: "footer",
            column: column,
            datum: footerValues,
            pad: column.pin && cellProps.pinned.pad || cellProps.pad,
            pin: pin.length ? pin : undefined,
            pinnedOffset: pinnedOffset && pinnedOffset[column.property],
            primaryProperty: primaryProperty,
            verticalAlign: verticalAlign
        });
    })));
});
$4e8e103f24b53120$var$Footer.displayName = 'Footer';


var $e2c8f41c1887239d$export$1e511d4a378977f5;
var $e2c8f41c1887239d$export$4b2c32e08f77ff18;
"use strict";
$e2c8f41c1887239d$export$1e511d4a378977f5 = true;
$e2c8f41c1887239d$export$4b2c32e08f77ff18 = void 0;

var $e2c8f41c1887239d$var$_react = $e2c8f41c1887239d$var$_interopRequireWildcard((parcelRequire("2xPiy")));











var $e2c8f41c1887239d$var$_excluded = [
    "cellProps",
    "columns",
    "data",
    "disabled",
    "onMore",
    "replace",
    "onClickRow",
    "onSelect",
    "pinnedOffset",
    "primaryProperty",
    "rowProps",
    "selected",
    "rowDetails",
    "show",
    "size",
    "step",
    "rowExpand",
    "setRowExpand",
    "verticalAlign"
];
function $e2c8f41c1887239d$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($e2c8f41c1887239d$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $e2c8f41c1887239d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $e2c8f41c1887239d$var$_extends() {
    return $e2c8f41c1887239d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e2c8f41c1887239d$var$_extends.apply(null, arguments);
} /* eslint-disable no-underscore-dangle */ 
var $e2c8f41c1887239d$var$Row = /*#__PURE__*/ (0, $e2c8f41c1887239d$var$_react.memo)(function(_ref) {
    var expandLabel = _ref.expandLabel, cellProps = _ref.cellProps, primaryValue = _ref.primaryValue, index = _ref.index, rowRef = _ref.rowRef, size = _ref.size, active = _ref.active, focused = _ref.focused, lastFocused = _ref.lastFocused, onClickRow = _ref.onClickRow, datum = _ref.datum, selected = _ref.selected, onSelect = _ref.onSelect, passThemeFlag = _ref.passThemeFlag, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, rowDetails = _ref.rowDetails, isRowExpanded = _ref.isRowExpanded, setActive = _ref.setActive, setFocused = _ref.setFocused, setRowExpand = _ref.setRowExpand, rowExpand = _ref.rowExpand, columns = _ref.columns, pinnedOffset = _ref.pinnedOffset, primaryProperty = _ref.primaryProperty, verticalAlign = _ref.verticalAlign, onRowRefChange = _ref.onRowRefChange;
    return /*#__PURE__*/ $e2c8f41c1887239d$var$_react["default"].createElement($e2c8f41c1887239d$var$_react["default"].Fragment, null, /*#__PURE__*/ $e2c8f41c1887239d$var$_react["default"].createElement($ff3a0b5a9b0cbb67$export$35ee3cab512e9b03, $e2c8f41c1887239d$var$_extends({
        ref: function ref(element) {
            // Store the row element in the parent's ref map
            if (onRowRefChange) onRowRefChange(index, element);
            // Also call the original rowRef if it exists
            if (rowRef) {
                if (typeof rowRef === 'function') rowRef(element);
                else if (rowRef && typeof rowRef === 'object' && 'current' in rowRef) {
                    var refObj = rowRef;
                    refObj.current = element;
                }
            }
        },
        size: size,
        active: active,
        "aria-disabled": onClickRow && isDisabled || undefined,
        onClick: onClickRow ? function(event) {
            if (onClickRow && !isDisabled) {
                setFocused(index);
                setActive(index);
                if (typeof onClickRow === 'function') {
                    // extract from React's synthetic event pool
                    event.persist();
                    var adjustedEvent = event;
                    adjustedEvent.datum = datum;
                    adjustedEvent.index = index;
                    onClickRow(adjustedEvent);
                } else if (onClickRow === 'select') {
                    if (isSelected) onSelect(selected.filter(function(s) {
                        return s !== primaryValue;
                    }), datum);
                    else onSelect([].concat(selected, [
                        primaryValue
                    ]), datum);
                }
            }
        } : undefined,
        onFocus: function onFocus() {
            if (onClickRow && !isDisabled) {
                setFocused(index);
                setActive(index);
            }
        },
        onMouseOver: onClickRow && !isDisabled ? function() {
            return setActive(index);
        } : undefined,
        tabIndex: // eslint-disable-next-line no-nested-ternary
        !onClickRow ? undefined : // If this row is focused, it should be focusable
        // If no row is focused and this is the first row, make it focusable
        focused !== undefined && focused === index || focused === undefined && lastFocused === index || focused === undefined && index === 0 ? 0 : // Otherwise, not in tab order
        -1
    }, passThemeFlag), (selected || onSelect) && /*#__PURE__*/ $e2c8f41c1887239d$var$_react["default"].createElement($1fa1fff43d8b78e6$export$f6f0c3fe4ec306ea, {
        background: isSelected && cellProps.selected.background || (pinnedOffset == null ? void 0 : pinnedOffset._grommetDataTableSelect) && cellProps.pinned.background || cellProps.background,
        border: cellProps.pinned.border || cellProps.border,
        pinnedOffset: pinnedOffset == null ? void 0 : pinnedOffset._grommetDataTableSelect,
        "aria-disabled": isDisabled || !onSelect || undefined,
        column: {
            pin: Boolean(pinnedOffset == null ? void 0 : pinnedOffset._grommetDataTableSelect),
            plain: 'noPad',
            size: 'auto',
            render: function render() {
                return /*#__PURE__*/ $e2c8f41c1887239d$var$_react["default"].createElement($c15af89705eeb537$export$ea5f704b89d806f6, {
                    tabIndex: onClickRow === 'select' ? -1 : undefined,
                    a11yTitle: (isSelected ? 'unselect' : 'select') + " " + primaryValue,
                    checked: isSelected,
                    disabled: isDisabled || !onSelect,
                    onChange: function onChange() {
                        if (isSelected) onSelect(selected.filter(function(s) {
                            return s !== primaryValue;
                        }), datum);
                        else onSelect([].concat(selected, [
                            primaryValue
                        ]), datum);
                    },
                    pad: cellProps.pad
                });
            }
        },
        verticalAlign: verticalAlign
    }), rowDetails && /*#__PURE__*/ $e2c8f41c1887239d$var$_react["default"].createElement($45f69439fcb47049$export$8ebdff051337858b, {
        background: isSelected && cellProps.selected.background,
        context: isRowExpanded ? 'groupHeader' : 'body',
        expanded: isRowExpanded,
        expandLabel: expandLabel,
        onToggle: function onToggle() {
            var nextRowExpand;
            var rowKey = primaryValue || index;
            if (isRowExpanded) nextRowExpand = rowExpand.filter(function(s) {
                return s !== rowKey;
            });
            else nextRowExpand = [].concat(rowExpand, [
                rowKey
            ]);
            if (rowDetails.onExpand) rowDetails.onExpand(nextRowExpand, datum);
            else setRowExpand(nextRowExpand);
        },
        pad: cellProps.pad,
        verticalAlign: verticalAlign
    }), columns.map(function(column) {
        return /*#__PURE__*/ $e2c8f41c1887239d$var$_react["default"].createElement($1fa1fff43d8b78e6$export$f6f0c3fe4ec306ea, {
            key: column.property,
            background: isSelected && cellProps.selected.background || column.pin && cellProps.pinned.background || cellProps.background,
            border: column.pin && cellProps.pinned.border || cellProps.border,
            context: "body",
            column: column,
            datum: datum,
            isSelected: isSelected,
            pad: column.pin && cellProps.pinned.pad || cellProps.pad,
            pinnedOffset: pinnedOffset && pinnedOffset[column.property],
            primaryProperty: primaryProperty,
            scope: column.primary || column.property === primaryProperty ? 'row' : undefined,
            verticalAlign: verticalAlign
        });
    })), rowDetails && isRowExpanded && /*#__PURE__*/ $e2c8f41c1887239d$var$_react["default"].createElement($ff3a0b5a9b0cbb67$export$35ee3cab512e9b03, {
        key: index.toString() + "_expand"
    }, (selected || onSelect) && /*#__PURE__*/ $e2c8f41c1887239d$var$_react["default"].createElement($5501e7a1e1340982$export$1e4baea7053fc0e3, null), /*#__PURE__*/ $e2c8f41c1887239d$var$_react["default"].createElement($5501e7a1e1340982$export$1e4baea7053fc0e3, {
        colSpan: columns.length + 1
    }, rowDetails.render ? rowDetails.render(datum) : rowDetails(datum))));
});
var $e2c8f41c1887239d$var$Body = $e2c8f41c1887239d$export$4b2c32e08f77ff18 = /*#__PURE__*/ (0, $e2c8f41c1887239d$var$_react.forwardRef)(function(_ref2, ref) {
    var cellPropsProp = _ref2.cellProps, columns = _ref2.columns, data = _ref2.data, disabled = _ref2.disabled, onMore = _ref2.onMore, replace = _ref2.replace, onClickRow = _ref2.onClickRow, onSelect = _ref2.onSelect, pinnedOffset = _ref2.pinnedOffset, primaryProperty = _ref2.primaryProperty, rowProps = _ref2.rowProps, selected = _ref2.selected, rowDetails = _ref2.rowDetails, show = _ref2.show, size = _ref2.size, step = _ref2.step, rowExpand = _ref2.rowExpand, setRowExpand = _ref2.setRowExpand, verticalAlign = _ref2.verticalAlign, rest = $e2c8f41c1887239d$var$_objectWithoutPropertiesLoose(_ref2, $e2c8f41c1887239d$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _React$useState = $e2c8f41c1887239d$var$_react["default"].useState(), focused = _React$useState[0], setFocused = _React$useState[1];
    var _React$useState2 = $e2c8f41c1887239d$var$_react["default"].useState(), lastFocused = _React$useState2[0], setLastFocused = _React$useState2[1];
    var _React$useState3 = $e2c8f41c1887239d$var$_react["default"].useState(), active = _React$useState3[0], setActive = _React$useState3[1];
    var _React$useState4 = $e2c8f41c1887239d$var$_react["default"].useState(), scroll = _React$useState4[0], setScroll = _React$useState4[1];
    var containerRef = (0, $4113023f9e0bafa0$exports.useForwardedRef)(ref);
    // Store refs for each row to enable direct focus management
    var rowRefs = $e2c8f41c1887239d$var$_react["default"].useRef(new Map());
    // Callback to store row references
    var handleRowRefChange = $e2c8f41c1887239d$var$_react["default"].useCallback(function(index, element) {
        if (element) rowRefs.current.set(index, element);
        else rowRefs.current["delete"](index);
    }, []);
    var activePrimaryValue = active >= 0 ? (0, $f31f45a415daea9b$export$682ea250e758ab92)(data[active], primaryProperty) : undefined;
    var selectRow = function selectRow() {
        if (activePrimaryValue !== undefined) {
            if (selected && selected.includes(activePrimaryValue)) onSelect(selected.filter(function(s) {
                return s !== activePrimaryValue;
            }));
            else onSelect([].concat(selected, [
                activePrimaryValue
            ]));
        }
    };
    var clickableRow = onClickRow && active >= 0 && (!disabled || activePrimaryValue !== undefined && !disabled.includes(activePrimaryValue));
    // Determine if the DataTable body is scrollable
    (0, $e2c8f41c1887239d$var$_react.useEffect)(function() {
        if (containerRef.current) {
            var element = containerRef.current;
            if (element.scrollHeight > element.offsetHeight) setScroll(true);
        }
    }, [
        containerRef
    ]);
    // roving tab index, ensure row (when onClickRow) has DOM focus
    (0, $e2c8f41c1887239d$var$_react.useEffect)(function() {
        if (focused !== undefined && rowRefs.current.has(focused)) {
            var focusedRowElement = rowRefs.current.get(focused);
            if (focusedRowElement && focusedRowElement.focus) focusedRowElement.focus();
        }
    }, [
        focused
    ]);
    return /*#__PURE__*/ $e2c8f41c1887239d$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onEnter: clickableRow ? function(event) {
            if (clickableRow) {
                if (typeof onClickRow === 'function') {
                    event.persist();
                    var adjustedEvent = event;
                    adjustedEvent.datum = data[focused];
                    onClickRow(adjustedEvent);
                } else if (onClickRow === 'select') selectRow();
            }
        } : undefined,
        onSpace: clickableRow ? function(event) {
            event.preventDefault();
            if (typeof onClickRow === 'function') {
                event.persist();
                var adjustedEvent = event;
                adjustedEvent.datum = data == null ? void 0 : data[focused];
                onClickRow(adjustedEvent);
            } else if (onClickRow === 'select') selectRow();
        } : undefined,
        onUp: onClickRow && focused ? function() {
            var previousIndex = focused - 1;
            setFocused(previousIndex);
            setActive(previousIndex);
        } : undefined,
        onDown: onClickRow && data.length && focused < data.length - 1 ? function(event) {
            event.preventDefault();
            var nextIndex = (focused != null ? focused : -1) + 1;
            setFocused(nextIndex);
            setActive(nextIndex);
        } : undefined
    }, /*#__PURE__*/ $e2c8f41c1887239d$var$_react["default"].createElement($ff3a0b5a9b0cbb67$export$d272165a8a43ec6, $e2c8f41c1887239d$var$_extends({
        ref: containerRef,
        size: size,
        tabIndex: !onClickRow && scroll ? 0 : undefined,
        onMouseOut: function onMouseOut() {
            return setActive(undefined);
        },
        onBlur: function onBlur(event) {
            // only reset focused if the focus is leaving the table
            // and not moving to a child element of the table
            if (containerRef.current && !containerRef.current.contains(event.relatedTarget)) {
                setLastFocused(focused);
                setFocused(undefined);
                setActive(undefined);
            }
        }
    }, passThemeFlag, rest), /*#__PURE__*/ $e2c8f41c1887239d$var$_react["default"].createElement($41010700ddcbac64$export$c5295390d6167a3e, {
        items: data,
        onMore: onMore,
        replace: replace,
        renderMarker: function renderMarker(marker) {
            return /*#__PURE__*/ $e2c8f41c1887239d$var$_react["default"].createElement($769e29b5528bbd43$export$b05581f4e764e162, null, /*#__PURE__*/ $e2c8f41c1887239d$var$_react["default"].createElement($5501e7a1e1340982$export$1e4baea7053fc0e3, null, marker));
        },
        show: show,
        step: step
    }, function(datum, index, rowRef) {
        var primaryValue = primaryProperty ? (0, $f31f45a415daea9b$export$682ea250e758ab92)(datum, primaryProperty) : undefined;
        var isSelected = selected && selected.includes(primaryValue);
        var isDisabled = disabled && disabled.includes(primaryValue);
        var isRowExpanded = rowExpand && rowExpand.includes(primaryValue || index);
        var cellProps = (0, $f31f45a415daea9b$export$b3f0e4b3a6cf0421)(rowProps, cellPropsProp, primaryValue, index);
        var expandLabel;
        if (typeof rowDetails === 'object' && typeof rowDetails.expandLabel === 'function') expandLabel = rowDetails.expandLabel(datum);
        return /*#__PURE__*/ $e2c8f41c1887239d$var$_react["default"].createElement($e2c8f41c1887239d$var$Row, {
            expandLabel: expandLabel,
            key: primaryValue != null ? primaryValue : index,
            setActive: setActive,
            rowRef: rowRef,
            cellProps: cellProps,
            primaryValue: primaryValue,
            isDisabled: isDisabled,
            isSelected: isSelected,
            isRowExpanded: isRowExpanded,
            index: index,
            size: size,
            active: active >= 0 ? active === index : undefined,
            focused: focused,
            lastFocused: lastFocused,
            setFocused: setFocused,
            onRowRefChange: handleRowRefChange,
            onClickRow: onClickRow,
            passThemeFlag: passThemeFlag,
            datum: datum,
            selected: selected,
            onSelect: onSelect,
            rowDetails: rowDetails,
            setRowExpand: setRowExpand,
            rowExpand: rowExpand,
            columns: columns,
            primaryProperty: primaryProperty,
            rowProps: rowProps,
            data: data,
            theme: theme,
            pinnedOffset: pinnedOffset,
            verticalAlign: verticalAlign
        });
    })));
});


var $5b943aaad3aa7ed3$export$1e511d4a378977f5;
var $5b943aaad3aa7ed3$export$298bfb09deaa1b80;
"use strict";
$5b943aaad3aa7ed3$export$1e511d4a378977f5 = true;
$5b943aaad3aa7ed3$export$298bfb09deaa1b80 = void 0;

var $5b943aaad3aa7ed3$var$_react = $5b943aaad3aa7ed3$var$_interopRequireWildcard((parcelRequire("2xPiy")));









var $5b943aaad3aa7ed3$var$_excluded = [
    "cellProps",
    "columns",
    "data",
    "disabled",
    "groupBy",
    "groups",
    "groupState",
    "messages",
    "pinnedOffset",
    "primaryProperty",
    "onMore",
    "onSelect",
    "onToggle",
    "onUpdate",
    "replace",
    "rowProps",
    "selected",
    "size",
    "step",
    "verticalAlign"
];
function $5b943aaad3aa7ed3$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($5b943aaad3aa7ed3$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $5b943aaad3aa7ed3$var$_extends() {
    return $5b943aaad3aa7ed3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5b943aaad3aa7ed3$var$_extends.apply(null, arguments);
}
function $5b943aaad3aa7ed3$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $5b943aaad3aa7ed3$var$GroupedBody = $5b943aaad3aa7ed3$export$298bfb09deaa1b80 = /*#__PURE__*/ (0, $5b943aaad3aa7ed3$var$_react.forwardRef)(function(_ref, ref) {
    var cellPropsProp = _ref.cellProps, columns = _ref.columns, data = _ref.data, disabled = _ref.disabled, groupBy = _ref.groupBy, groups = _ref.groups, groupState = _ref.groupState, messages = _ref.messages, pinnedOffset = _ref.pinnedOffset, primaryProperty = _ref.primaryProperty, onMore = _ref.onMore, onSelect = _ref.onSelect, onToggle = _ref.onToggle, onUpdate = _ref.onUpdate, replace = _ref.replace, rowProps = _ref.rowProps, selected = _ref.selected, size = _ref.size, step = _ref.step, verticalAlign = _ref.verticalAlign, rest = $5b943aaad3aa7ed3$var$_objectWithoutPropertiesLoose(_ref, $5b943aaad3aa7ed3$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var items = (0, $5b943aaad3aa7ed3$var$_react.useMemo)(function() {
        var nextItems = [];
        groups.forEach(function(group) {
            var _ref2 = groupState[group.key] || {
                expanded: true
            }, expanded = _ref2.expanded;
            var memberCount = group.data.length;
            var groupSelected = [];
            var isGroupSelected = false;
            var groupDisabled = [];
            var isGroupDisabled = false;
            if (memberCount > 1 || onUpdate && group.key !== undefined) {
                // need a header
                var primaryKeys = group.data.map(function(datum) {
                    return datum[primaryProperty];
                });
                groupSelected = primaryKeys && selected ? primaryKeys.filter(function(val) {
                    return selected.includes(val);
                }) : [];
                isGroupSelected = groupBy.select ? groupBy.select[group.key] === 'all' : groupSelected.length === group.data.length && groupSelected.length > 0;
                var indeterminate = groupBy.select ? groupBy.select[group.key] === 'some' : groupSelected.length > 0 && groupSelected.length < group.data.length;
                groupDisabled = primaryKeys && disabled ? primaryKeys.filter(function(val) {
                    return disabled.includes(val);
                }) : [];
                isGroupDisabled = groupBy.disable ? groupBy.disable[group.key] === 'all' : groupDisabled.length === group.data.length && groupDisabled.length > 0;
                nextItems.push({
                    expanded: expanded,
                    key: group.key,
                    primaryValue: group.key,
                    datum: group.datum,
                    context: 'groupHeader',
                    isDisabled: isGroupDisabled,
                    isSelected: isGroupSelected,
                    indeterminate: indeterminate,
                    onChange: function onChange() {
                        var nextSelected = isGroupSelected || indeterminate ? selected.filter(function(s) {
                            return !groupSelected.includes(s);
                        }) : [].concat(selected, primaryKeys);
                        if (groupBy.onSelect) groupBy.onSelect(nextSelected, group.datum, groupBy.select);
                        else onSelect(nextSelected, group.datum);
                    }
                });
            }
            if (!onUpdate && memberCount === 1 || expanded) // add the group members
            group.data.forEach(function(datum, index) {
                var primaryValue = primaryProperty ? (0, $f31f45a415daea9b$export$682ea250e758ab92)(datum, primaryProperty) : undefined;
                var isSelected = selected == null ? void 0 : selected.includes(primaryValue);
                var isDisabled = disabled == null ? void 0 : disabled.includes(primaryValue);
                nextItems.push({
                    key: datum[primaryProperty],
                    primaryValue: primaryProperty ? (0, $f31f45a415daea9b$export$682ea250e758ab92)(datum, primaryProperty) : undefined,
                    datum: datum,
                    context: memberCount > 1 && index === memberCount - 1 ? 'groupEnd' : 'body',
                    isDisabled: isDisabled,
                    isSelected: isSelected,
                    onChange: function onChange() {
                        var nextSelected = isSelected ? selected.filter(function(s) {
                            return s !== primaryValue;
                        }) : [].concat(selected, [
                            primaryValue
                        ]);
                        onSelect(nextSelected, datum);
                    }
                });
            });
        });
        return nextItems;
    }, [
        disabled,
        groups,
        groupBy,
        groupState,
        primaryProperty,
        selected,
        onSelect,
        onUpdate
    ]);
    return /*#__PURE__*/ $5b943aaad3aa7ed3$var$_react["default"].createElement($ff3a0b5a9b0cbb67$export$d272165a8a43ec6, $5b943aaad3aa7ed3$var$_extends({
        ref: ref,
        size: size
    }, passThemeFlag, rest), /*#__PURE__*/ $5b943aaad3aa7ed3$var$_react["default"].createElement($41010700ddcbac64$export$c5295390d6167a3e, {
        items: items,
        onMore: onMore,
        replace: replace,
        renderMarker: function renderMarker(marker) {
            return /*#__PURE__*/ $5b943aaad3aa7ed3$var$_react["default"].createElement($769e29b5528bbd43$export$b05581f4e764e162, null, /*#__PURE__*/ $5b943aaad3aa7ed3$var$_react["default"].createElement($5501e7a1e1340982$export$1e4baea7053fc0e3, null, marker));
        },
        step: step
    }, function(row, index, rowRef) {
        var context = row.context, datum = row.datum, expanded = row.expanded, indeterminate = row.indeterminate, isDisabled = row.isDisabled, isSelected = row.isSelected, key = row.key, onChange = row.onChange, primaryValue = row.primaryValue;
        var cellProps = (0, $f31f45a415daea9b$export$b3f0e4b3a6cf0421)(rowProps, context === 'groupHeader' ? cellPropsProp.groupHeader : cellPropsProp.body, primaryValue, index);
        var ariaLabel;
        if (typeof groupBy === 'object' && typeof groupBy.expandLabel === 'function') {
            var labelRow = context === 'groupHeader' ? row.datum : row.datum;
            ariaLabel = groupBy.expandLabel(labelRow);
        }
        return /*#__PURE__*/ $5b943aaad3aa7ed3$var$_react["default"].createElement($ff3a0b5a9b0cbb67$export$35ee3cab512e9b03, $5b943aaad3aa7ed3$var$_extends({
            ref: rowRef,
            key: key,
            size: size
        }, passThemeFlag), /*#__PURE__*/ $5b943aaad3aa7ed3$var$_react["default"].createElement($45f69439fcb47049$export$8ebdff051337858b, {
            background: isSelected && cellProps.selected.background || cellProps.background,
            expandLabel: ariaLabel,
            border: cellProps.border,
            context: context,
            messages: messages,
            pad: cellProps.pad,
            onToggle: context === 'groupHeader' ? onToggle(key) : undefined,
            expanded: expanded,
            verticalAlign: verticalAlign
        }), (selected || onSelect) && /*#__PURE__*/ $5b943aaad3aa7ed3$var$_react["default"].createElement($5501e7a1e1340982$export$1e4baea7053fc0e3, {
            background: isSelected && cellProps.selected.background || cellProps.background,
            border: cellProps.pinned.border || cellProps.border,
            plain: "noPad",
            size: "auto",
            verticalAlign: verticalAlign,
            "aria-disabled": isDisabled || !onSelect || undefined
        }, /*#__PURE__*/ $5b943aaad3aa7ed3$var$_react["default"].createElement($572978a416f7ed0c$export$ea5f704b89d806f6, {
            a11yTitle: (isSelected ? 'unselect' : 'select') + " " + (context === 'groupHeader' ? key : primaryValue),
            checked: isSelected,
            indeterminate: indeterminate,
            disabled: isDisabled || !onSelect,
            onChange: onChange,
            pad: cellProps.pad
        })), columns.map(function(column) {
            var scope;
            if (context === 'groupHeader') scope = column.property === groupBy.property ? 'row' : undefined;
            else scope = column.primary ? 'row' : undefined;
            return /*#__PURE__*/ $5b943aaad3aa7ed3$var$_react["default"].createElement($1fa1fff43d8b78e6$export$f6f0c3fe4ec306ea, {
                key: column.property,
                background: isSelected && cellProps.selected.background || cellProps.background,
                border: cellProps.border,
                context: context,
                column: column,
                datum: datum,
                pad: cellProps.pad,
                scope: scope,
                pinnedOffset: pinnedOffset && pinnedOffset[column.property],
                verticalAlign: verticalAlign
            });
        }));
    }));
});






var $a3988d53b7647953$export$1e511d4a378977f5;
var $a3988d53b7647953$export$c2a4947702a2f5bb;
"use strict";
$a3988d53b7647953$export$1e511d4a378977f5 = true;
$a3988d53b7647953$export$c2a4947702a2f5bb = void 0;

var $a3988d53b7647953$var$_propTypes = $a3988d53b7647953$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $a3988d53b7647953$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $a3988d53b7647953$var$_extends() {
    return $a3988d53b7647953$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a3988d53b7647953$var$_extends.apply(null, arguments);
}
var $a3988d53b7647953$var$sizes = [
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge'
];
var $a3988d53b7647953$var$sides = [
    'horizontal',
    'vertical',
    'top',
    'bottom',
    'left',
    'right'
];
var $a3988d53b7647953$var$parts = [
    'header',
    'body',
    'footer'
];
var $a3988d53b7647953$var$verticalAlign = [
    'bottom',
    'middle',
    'top'
];
var $a3988d53b7647953$var$padShapeSides = {};
$a3988d53b7647953$var$sides.forEach(function(side) {
    $a3988d53b7647953$var$padShapeSides[side] = $a3988d53b7647953$var$_propTypes["default"].oneOfType([
        $a3988d53b7647953$var$_propTypes["default"].oneOf($a3988d53b7647953$var$sizes),
        $a3988d53b7647953$var$_propTypes["default"].string
    ]);
});
var $a3988d53b7647953$var$padShapeParts = {};
$a3988d53b7647953$var$parts.forEach(function(part) {
    $a3988d53b7647953$var$padShapeParts[part] = {};
    $a3988d53b7647953$var$sides.forEach(function(side) {
        $a3988d53b7647953$var$padShapeParts[part][side] = $a3988d53b7647953$var$_propTypes["default"].oneOf($a3988d53b7647953$var$sizes);
    });
});
var $a3988d53b7647953$var$backgroundShape = {};
[].concat($a3988d53b7647953$var$parts, [
    'pinned'
]).forEach(function(part) {
    $a3988d53b7647953$var$backgroundShape[part] = $a3988d53b7647953$var$_propTypes["default"].oneOfType([
        $a3988d53b7647953$var$_propTypes["default"].string,
        $a3988d53b7647953$var$_propTypes["default"].shape({
            dark: $a3988d53b7647953$var$_propTypes["default"].string,
            light: $a3988d53b7647953$var$_propTypes["default"].string
        }),
        $a3988d53b7647953$var$_propTypes["default"].arrayOf($a3988d53b7647953$var$_propTypes["default"].string)
    ]);
});
var $a3988d53b7647953$var$borderTypes = [
    $a3988d53b7647953$var$_propTypes["default"].bool,
    $a3988d53b7647953$var$_propTypes["default"].oneOf($a3988d53b7647953$var$sides),
    $a3988d53b7647953$var$_propTypes["default"].shape({
        color: $a3988d53b7647953$var$_propTypes["default"].oneOfType([
            $a3988d53b7647953$var$_propTypes["default"].string,
            $a3988d53b7647953$var$_propTypes["default"].shape({
                dark: $a3988d53b7647953$var$_propTypes["default"].string,
                light: $a3988d53b7647953$var$_propTypes["default"].string
            })
        ]),
        side: $a3988d53b7647953$var$_propTypes["default"].oneOf($a3988d53b7647953$var$sides),
        size: $a3988d53b7647953$var$_propTypes["default"].oneOfType([
            $a3988d53b7647953$var$_propTypes["default"].oneOf($a3988d53b7647953$var$sizes),
            $a3988d53b7647953$var$_propTypes["default"].string
        ])
    })
];
var $a3988d53b7647953$var$borderShape = {};
$a3988d53b7647953$var$parts.forEach(function(part) {
    $a3988d53b7647953$var$borderShape[part] = $a3988d53b7647953$var$_propTypes["default"].oneOfType($a3988d53b7647953$var$borderTypes);
});
var $a3988d53b7647953$var$PropType = {};
$a3988d53b7647953$var$PropType = $a3988d53b7647953$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    allowSelectAll: $a3988d53b7647953$var$_propTypes["default"].bool,
    background: $a3988d53b7647953$var$_propTypes["default"].oneOfType([
        $a3988d53b7647953$var$_propTypes["default"].string,
        $a3988d53b7647953$var$_propTypes["default"].arrayOf($a3988d53b7647953$var$_propTypes["default"].string),
        $a3988d53b7647953$var$_propTypes["default"].shape($a3988d53b7647953$var$backgroundShape)
    ]),
    border: $a3988d53b7647953$var$_propTypes["default"].oneOfType([].concat($a3988d53b7647953$var$borderTypes, [
        $a3988d53b7647953$var$_propTypes["default"].shape($a3988d53b7647953$var$borderShape)
    ])),
    columns: $a3988d53b7647953$var$_propTypes["default"].arrayOf($a3988d53b7647953$var$_propTypes["default"].shape({
        align: $a3988d53b7647953$var$_propTypes["default"].oneOf([
            'center',
            'start',
            'end'
        ]),
        aggregate: $a3988d53b7647953$var$_propTypes["default"].oneOf([
            'avg',
            'max',
            'min',
            'sum'
        ]),
        footer: $a3988d53b7647953$var$_propTypes["default"].oneOfType([
            $a3988d53b7647953$var$_propTypes["default"].node,
            $a3988d53b7647953$var$_propTypes["default"].shape({
                aggregate: $a3988d53b7647953$var$_propTypes["default"].bool
            })
        ]),
        header: $a3988d53b7647953$var$_propTypes["default"].oneOfType([
            $a3988d53b7647953$var$_propTypes["default"].string,
            $a3988d53b7647953$var$_propTypes["default"].node,
            $a3988d53b7647953$var$_propTypes["default"].shape({
                aggregate: $a3988d53b7647953$var$_propTypes["default"].bool
            })
        ]),
        pin: $a3988d53b7647953$var$_propTypes["default"].bool,
        plain: $a3988d53b7647953$var$_propTypes["default"].bool,
        primary: $a3988d53b7647953$var$_propTypes["default"].bool,
        property: $a3988d53b7647953$var$_propTypes["default"].string.isRequired,
        render: $a3988d53b7647953$var$_propTypes["default"].func,
        search: $a3988d53b7647953$var$_propTypes["default"].bool,
        sortable: $a3988d53b7647953$var$_propTypes["default"].bool,
        size: $a3988d53b7647953$var$_propTypes["default"].oneOfType([
            $a3988d53b7647953$var$_propTypes["default"].oneOf([
                'small',
                'medium',
                'large',
                'xlarge',
                '1/2',
                '1/4',
                '2/4',
                '3/4',
                '1/3',
                '2/3'
            ]),
            $a3988d53b7647953$var$_propTypes["default"].string
        ]),
        units: $a3988d53b7647953$var$_propTypes["default"].string,
        verticalAlign: $a3988d53b7647953$var$_propTypes["default"].oneOf([
            'middle',
            'top',
            'bottom'
        ])
    })),
    data: $a3988d53b7647953$var$_propTypes["default"].arrayOf($a3988d53b7647953$var$_propTypes["default"].shape({})),
    disabled: $a3988d53b7647953$var$_propTypes["default"].arrayOf($a3988d53b7647953$var$_propTypes["default"].oneOfType([
        $a3988d53b7647953$var$_propTypes["default"].string,
        $a3988d53b7647953$var$_propTypes["default"].number
    ])),
    fill: $a3988d53b7647953$var$_propTypes["default"].oneOfType([
        $a3988d53b7647953$var$_propTypes["default"].oneOf([
            'horizontal',
            'vertical'
        ]),
        $a3988d53b7647953$var$_propTypes["default"].bool
    ]),
    groupBy: $a3988d53b7647953$var$_propTypes["default"].oneOfType([
        $a3988d53b7647953$var$_propTypes["default"].string,
        $a3988d53b7647953$var$_propTypes["default"].shape({
            property: $a3988d53b7647953$var$_propTypes["default"].string,
            expand: $a3988d53b7647953$var$_propTypes["default"].arrayOf($a3988d53b7647953$var$_propTypes["default"].string),
            expandable: $a3988d53b7647953$var$_propTypes["default"].arrayOf($a3988d53b7647953$var$_propTypes["default"].string),
            expandLabel: $a3988d53b7647953$var$_propTypes["default"].func,
            select: $a3988d53b7647953$var$_propTypes["default"].objectOf($a3988d53b7647953$var$_propTypes["default"].oneOf([
                'all',
                'some',
                'none'
            ])),
            onExpand: $a3988d53b7647953$var$_propTypes["default"].func,
            onSelect: $a3988d53b7647953$var$_propTypes["default"].func
        })
    ]),
    messages: $a3988d53b7647953$var$_propTypes["default"].shape({
        ascending: $a3988d53b7647953$var$_propTypes["default"].string,
        collapse: $a3988d53b7647953$var$_propTypes["default"].string,
        collapseAll: $a3988d53b7647953$var$_propTypes["default"].string,
        decrease: $a3988d53b7647953$var$_propTypes["default"].string,
        descending: $a3988d53b7647953$var$_propTypes["default"].string,
        increase: $a3988d53b7647953$var$_propTypes["default"].string,
        expand: $a3988d53b7647953$var$_propTypes["default"].string,
        expandAll: $a3988d53b7647953$var$_propTypes["default"].string,
        resizerAria: $a3988d53b7647953$var$_propTypes["default"].string,
        rows: $a3988d53b7647953$var$_propTypes["default"].string,
        rowsChanged: $a3988d53b7647953$var$_propTypes["default"].string,
        rowsSingle: $a3988d53b7647953$var$_propTypes["default"].string,
        searchBy: $a3988d53b7647953$var$_propTypes["default"].string,
        total: $a3988d53b7647953$var$_propTypes["default"].string,
        totalSingle: $a3988d53b7647953$var$_propTypes["default"].string
    }),
    onClickRow: $a3988d53b7647953$var$_propTypes["default"].oneOfType([
        $a3988d53b7647953$var$_propTypes["default"].func,
        $a3988d53b7647953$var$_propTypes["default"].oneOf([
            'select'
        ])
    ]),
    rowDetails: $a3988d53b7647953$var$_propTypes["default"].oneOfType([
        $a3988d53b7647953$var$_propTypes["default"].func,
        $a3988d53b7647953$var$_propTypes["default"].shape({
            render: $a3988d53b7647953$var$_propTypes["default"].func.isRequired,
            expand: $a3988d53b7647953$var$_propTypes["default"].arrayOf($a3988d53b7647953$var$_propTypes["default"].oneOfType([
                $a3988d53b7647953$var$_propTypes["default"].string,
                $a3988d53b7647953$var$_propTypes["default"].number
            ])),
            expandLabel: $a3988d53b7647953$var$_propTypes["default"].func,
            onExpand: $a3988d53b7647953$var$_propTypes["default"].func
        })
    ]),
    onMore: $a3988d53b7647953$var$_propTypes["default"].func,
    onSearch: $a3988d53b7647953$var$_propTypes["default"].func,
    onSelect: $a3988d53b7647953$var$_propTypes["default"].func,
    onSort: $a3988d53b7647953$var$_propTypes["default"].func,
    onUpdate: $a3988d53b7647953$var$_propTypes["default"].func,
    pad: $a3988d53b7647953$var$_propTypes["default"].oneOfType([
        $a3988d53b7647953$var$_propTypes["default"].oneOf($a3988d53b7647953$var$sizes),
        $a3988d53b7647953$var$_propTypes["default"].string,
        $a3988d53b7647953$var$_propTypes["default"].shape($a3988d53b7647953$var$padShapeSides),
        $a3988d53b7647953$var$_propTypes["default"].shape($a3988d53b7647953$var$padShapeParts)
    ]),
    paginate: $a3988d53b7647953$var$_propTypes["default"].oneOfType([
        $a3988d53b7647953$var$_propTypes["default"].bool,
        $a3988d53b7647953$var$_propTypes["default"].object
    ]),
    pin: $a3988d53b7647953$var$_propTypes["default"].oneOfType([
        $a3988d53b7647953$var$_propTypes["default"].bool,
        $a3988d53b7647953$var$_propTypes["default"].oneOf([
            'header',
            'footer'
        ])
    ]),
    placeholder: $a3988d53b7647953$var$_propTypes["default"].oneOfType([
        $a3988d53b7647953$var$_propTypes["default"].string,
        $a3988d53b7647953$var$_propTypes["default"].node
    ]),
    primaryKey: $a3988d53b7647953$var$_propTypes["default"].oneOfType([
        $a3988d53b7647953$var$_propTypes["default"].string,
        $a3988d53b7647953$var$_propTypes["default"].bool
    ]),
    replace: $a3988d53b7647953$var$_propTypes["default"].bool,
    resizeable: $a3988d53b7647953$var$_propTypes["default"].bool,
    rowProps: $a3988d53b7647953$var$_propTypes["default"].shape({}),
    select: $a3988d53b7647953$var$_propTypes["default"].arrayOf($a3988d53b7647953$var$_propTypes["default"].oneOfType([
        $a3988d53b7647953$var$_propTypes["default"].string,
        $a3988d53b7647953$var$_propTypes["default"].number
    ])),
    show: $a3988d53b7647953$var$_propTypes["default"].oneOfType([
        $a3988d53b7647953$var$_propTypes["default"].number,
        $a3988d53b7647953$var$_propTypes["default"].shape({
            page: $a3988d53b7647953$var$_propTypes["default"].number
        })
    ]),
    size: $a3988d53b7647953$var$_propTypes["default"].oneOfType([
        $a3988d53b7647953$var$_propTypes["default"].oneOf([
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        $a3988d53b7647953$var$_propTypes["default"].string
    ]),
    sort: $a3988d53b7647953$var$_propTypes["default"].shape({
        direction: $a3988d53b7647953$var$_propTypes["default"].oneOf([
            'asc',
            'desc'
        ]),
        external: $a3988d53b7647953$var$_propTypes["default"].bool,
        property: $a3988d53b7647953$var$_propTypes["default"].string.isRequired
    }),
    sortable: $a3988d53b7647953$var$_propTypes["default"].bool,
    step: $a3988d53b7647953$var$_propTypes["default"].number,
    verticalAlign: $a3988d53b7647953$var$_propTypes["default"].oneOfType([
        $a3988d53b7647953$var$_propTypes["default"].oneOf($a3988d53b7647953$var$verticalAlign),
        $a3988d53b7647953$var$_propTypes["default"].shape({
            header: $a3988d53b7647953$var$_propTypes["default"].oneOf($a3988d53b7647953$var$verticalAlign),
            body: $a3988d53b7647953$var$_propTypes["default"].oneOf($a3988d53b7647953$var$verticalAlign),
            footer: $a3988d53b7647953$var$_propTypes["default"].oneOf($a3988d53b7647953$var$verticalAlign)
        })
    ])
});
var $a3988d53b7647953$var$DataTablePropTypes = $a3988d53b7647953$export$c2a4947702a2f5bb = $a3988d53b7647953$var$PropType;


var $94c2aaec2daed9f7$export$1e511d4a378977f5;
var $94c2aaec2daed9f7$export$ac217b2d9dd1ba17;
"use strict";
$94c2aaec2daed9f7$export$1e511d4a378977f5 = true;
$94c2aaec2daed9f7$export$ac217b2d9dd1ba17 = void 0;

var $94c2aaec2daed9f7$var$_react = $94c2aaec2daed9f7$var$_interopRequireWildcard((parcelRequire("2xPiy")));
function $94c2aaec2daed9f7$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($94c2aaec2daed9f7$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $94c2aaec2daed9f7$var$PlaceholderBody = $94c2aaec2daed9f7$export$ac217b2d9dd1ba17 = /*#__PURE__*/ (0, $94c2aaec2daed9f7$var$_react.forwardRef)(function(_ref, ref) {
    var _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? [] : _ref$columns, onSelect = _ref.onSelect, children = _ref.children;
    var colSpan = Math.max(columns.length + (onSelect ? 1 : 0), 1);
    return /*#__PURE__*/ $94c2aaec2daed9f7$var$_react["default"].createElement("tbody", {
        ref: ref
    }, /*#__PURE__*/ $94c2aaec2daed9f7$var$_react["default"].createElement("tr", null, /*#__PURE__*/ $94c2aaec2daed9f7$var$_react["default"].createElement("td", {
        colSpan: colSpan
    }, children)));
});



var $96c556b4e6e19733$var$_excluded = [
    "allowSelectAll",
    "background",
    "border",
    "columns",
    "data",
    "disabled",
    "fill",
    "groupBy",
    "messages",
    "onClickRow",
    "onMore",
    "onSearch",
    "onSelect",
    "onSort",
    "onUpdate",
    "replace",
    "pad",
    "paginate",
    "pin",
    "placeholder",
    "primaryKey",
    "resizeable",
    "rowProps",
    "select",
    "show",
    "size",
    "sort",
    "sortable",
    "rowDetails",
    "step",
    "verticalAlign"
];
function $96c556b4e6e19733$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($96c556b4e6e19733$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $96c556b4e6e19733$var$_extends() {
    return $96c556b4e6e19733$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $96c556b4e6e19733$var$_extends.apply(null, arguments);
}
function $96c556b4e6e19733$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $96c556b4e6e19733$var$emptyData = [];
function $96c556b4e6e19733$var$useGroupState(groups, groupBy) {
    var _useState = (0, $96c556b4e6e19733$var$_react.useState)(function() {
        return (0, $f31f45a415daea9b$export$dd1eb10ac590717)(groups, groupBy);
    }), groupState = _useState[0], setGroupState = _useState[1];
    var _useState2 = (0, $96c556b4e6e19733$var$_react.useState)({
        groups: groups,
        groupBy: groupBy
    }), prevDeps = _useState2[0], setPrevDeps = _useState2[1];
    var prevGroups = prevDeps.groups, prevGroupBy = prevDeps.groupBy;
    if (groups !== prevGroups || groupBy !== prevGroupBy) {
        setPrevDeps({
            groups: groups,
            groupBy: groupBy
        });
        var nextGroupState = (0, $f31f45a415daea9b$export$dd1eb10ac590717)(groups, groupBy);
        setGroupState(nextGroupState);
        return [
            nextGroupState,
            setGroupState
        ];
    }
    return [
        groupState,
        setGroupState
    ];
}
var $96c556b4e6e19733$var$DataTable = $96c556b4e6e19733$export$df30df7ec97b32b5 = function DataTable(_ref) {
    var _ref$allowSelectAll = _ref.allowSelectAll, allowSelectAll = _ref$allowSelectAll === void 0 ? true : _ref$allowSelectAll, background = _ref.background, border = _ref.border, columnsProp = _ref.columns, dataProp = _ref.data, disabled = _ref.disabled, fill = _ref.fill, groupByProp = _ref.groupBy, messages = _ref.messages, onClickRow = _ref.onClickRow, onMore = _ref.onMore, onSearch = _ref.onSearch, onSelect = _ref.onSelect, onSortProp = _ref.onSort, onUpdate = _ref.onUpdate, replace = _ref.replace, pad = _ref.pad, paginate = _ref.paginate, pin = _ref.pin, placeholder = _ref.placeholder, primaryKey = _ref.primaryKey, resizeable = _ref.resizeable, rowProps = _ref.rowProps, select = _ref.select, showProp = _ref.show, size = _ref.size, sortProp = _ref.sort, sortable = _ref.sortable, rowDetails = _ref.rowDetails, _ref$step = _ref.step, step = _ref$step === void 0 ? 50 : _ref$step, verticalAlign = _ref.verticalAlign, rest = $96c556b4e6e19733$var$_objectWithoutPropertiesLoose(_ref, $96c556b4e6e19733$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useContext = (0, $96c556b4e6e19733$var$_react.useContext)($932597a497e37de0$export$58d75f9829cbe158), view = _useContext.view, contextData = _useContext.data, properties = _useContext.properties, onView = _useContext.onView, setSelectedDataContext = _useContext.setSelected;
    var data = dataProp || contextData || $96c556b4e6e19733$var$emptyData;
    var columns = (0, $96c556b4e6e19733$var$_react.useMemo)(function() {
        var result = [];
        if (columnsProp) result = columnsProp;
        else if (properties) result = Object.keys(properties).map(function(p) {
            return $96c556b4e6e19733$var$_extends({
                property: p
            }, properties[p]);
        });
        else if (data.length) result = Object.keys(data[0]).map(function(p) {
            return {
                property: p
            };
        });
        if (view != null && view.columns) result = result.filter(function(c) {
            return view.columns.includes(c.property);
        }).sort(function(c1, c2) {
            return view.columns.indexOf(c1.property) - view.columns.indexOf(c2.property);
        });
        return result;
    }, [
        columnsProp,
        data,
        properties,
        view
    ]);
    // property name of the primary property
    var primaryProperty = (0, $96c556b4e6e19733$var$_react.useMemo)(function() {
        return (0, $f31f45a415daea9b$export$e29cd744291e9244)(columns, primaryKey);
    }, [
        columns,
        primaryKey
    ]);
    // whether or not we should show a footer
    var showFooter = (0, $96c556b4e6e19733$var$_react.useMemo)(function() {
        return columns.filter(function(c) {
            return c.footer;
        }).length > 0;
    }, [
        columns
    ]);
    // what column we are actively capturing filter input on
    var _useState3 = (0, $96c556b4e6e19733$var$_react.useState)(), filtering = _useState3[0], setFiltering = _useState3[1];
    // the currently active filters
    var _useState4 = (0, $96c556b4e6e19733$var$_react.useState)((0, $f31f45a415daea9b$export$3e02c678c13755e4)(columns)), filters = _useState4[0], setFilters = _useState4[1];
    // which column we are sorting on, with direction
    var _useState5 = (0, $96c556b4e6e19733$var$_react.useState)(sortProp || {}), sort = _useState5[0], setSort = _useState5[1];
    (0, $96c556b4e6e19733$var$_react.useEffect)(function() {
        if (sortProp) setSort(sortProp);
        else if (view != null && view.sort) setSort(view.sort);
    }, [
        sortProp,
        view
    ]);
    // what we are grouping on
    var groupBy = (view == null ? void 0 : view.groupBy) || groupByProp;
    // the data filtered and sorted, if needed
    // Note: onUpdate mode expects the data to be passed
    //   in completely filtered and sorted already.
    var adjustedData = (0, $96c556b4e6e19733$var$_react.useMemo)(function() {
        return onUpdate ? data : (0, $f31f45a415daea9b$export$a4789ef9776cfd0d)(data, filters, onSearch, sort);
    }, [
        data,
        filters,
        onSearch,
        onUpdate,
        sort
    ]);
    // the values to put in the footer cells
    var footerValues = (0, $96c556b4e6e19733$var$_react.useMemo)(function() {
        return (0, $f31f45a415daea9b$export$bde56fd39aca7865)(columns, adjustedData);
    }, [
        adjustedData,
        columns
    ]);
    // cell styling properties: background, border, pad
    var cellProps = (0, $96c556b4e6e19733$var$_react.useMemo)(function() {
        return (0, $f31f45a415daea9b$export$4553511e3ef6f0d3)({
            background: background,
            border: border,
            pad: pad,
            pin: pin
        }, theme);
    }, [
        background,
        border,
        pad,
        pin,
        theme
    ]);
    // if groupBy, an array with one item per unique groupBy key value
    var groups = (0, $96c556b4e6e19733$var$_react.useMemo)(function() {
        return (0, $f31f45a415daea9b$export$680f59e10d3eb269)(columns, adjustedData, groupBy, primaryProperty);
    }, [
        adjustedData,
        columns,
        groupBy,
        primaryProperty
    ]);
    // an object indicating which group values are expanded
    var _useGroupState = $96c556b4e6e19733$var$useGroupState(groups, groupBy), groupState = _useGroupState[0], setGroupState = _useGroupState[1];
    var _useState6 = (0, $96c556b4e6e19733$var$_react.useState)(step), limit = _useState6[0], setLimit = _useState6[1];
    var announce = (0, $96c556b4e6e19733$var$_react.useContext)($cfbcb74d4f54e56b$export$dcc8f4bff0d51f50);
    var _useContext2 = (0, $96c556b4e6e19733$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext2.format;
    // only announce number of rows that are rendered
    // when outside of DataContext, otherwise
    // Data will make this announcement
    (0, $96c556b4e6e19733$var$_react.useEffect)(function() {
        if (dataProp) {
            var messageId;
            var rows = format({
                id: adjustedData.length === 1 ? 'dataTable.rowsSingle' : 'dataTable.rows',
                messages: messages
            });
            // when less than one page returned, use specific amount
            if (adjustedData.length < limit) {
                if (adjustedData.length === 1) messageId = 'dataTable.totalSingle';
                else messageId = 'dataTable.total';
            } else messageId = 'dataTable.rowsChanged';
            announce(format({
                id: messageId,
                messages: messages,
                values: {
                    total: adjustedData.length,
                    rows: rows
                }
            }));
        }
    }, [
        dataProp,
        adjustedData,
        announce,
        format,
        limit,
        messages,
        paginate
    ]);
    var _useState7 = (0, $96c556b4e6e19733$var$_react.useState)(select || onSelect && [] || undefined), selected = _useState7[0], setSelected = _useState7[1];
    (0, $96c556b4e6e19733$var$_react.useEffect)(function() {
        return setSelected(select || onSelect && [] || undefined);
    }, [
        onSelect,
        select
    ]);
    (0, $96c556b4e6e19733$var$_react.useEffect)(function() {
        if (select && setSelectedDataContext) setSelectedDataContext(select.length);
    }, [
        select,
        setSelectedDataContext
    ]);
    var _useState8 = (0, $96c556b4e6e19733$var$_react.useState)((rowDetails == null ? void 0 : rowDetails.expand) || []), rowExpand = _useState8[0], setRowExpand = _useState8[1];
    (0, $96c556b4e6e19733$var$_react.useEffect)(function() {
        if (rowDetails != null && rowDetails.expand) setRowExpand(rowDetails.expand);
    }, [
        rowDetails == null ? void 0 : rowDetails.expand
    ]);
    // any customized column widths
    var _useState9 = (0, $96c556b4e6e19733$var$_react.useState)({}), widths = _useState9[0], setWidths = _useState9[1];
    // placeholder placement stuff
    var headerRef = (0, $96c556b4e6e19733$var$_react.useRef)();
    var bodyRef = (0, $96c556b4e6e19733$var$_react.useRef)();
    var footerRef = (0, $96c556b4e6e19733$var$_react.useRef)();
    var _useState0 = (0, $96c556b4e6e19733$var$_react.useState)(), headerHeight = _useState0[0], setHeaderHeight = _useState0[1];
    var _useState1 = (0, $96c556b4e6e19733$var$_react.useState)(), footerHeight = _useState1[0], setFooterHeight = _useState1[1];
    // offset compensation when body overflows
    var _useState10 = (0, $96c556b4e6e19733$var$_react.useState)(0), scrollOffset = _useState10[0], setScrollOffset = _useState10[1];
    // multiple pinned columns offset
    var _useState11 = (0, $96c556b4e6e19733$var$_react.useState)(), pinnedOffset = _useState11[0], setPinnedOffset = _useState11[1];
    var onHeaderWidths = (0, $96c556b4e6e19733$var$_react.useCallback)(function(columnWidths) {
        var hasSelectColumn = Boolean(select || onSelect);
        var pinnedProperties = columns.map(function(pinnedColumn) {
            return pinnedColumn.pin && pinnedColumn.property;
        }).filter(function(n) {
            return n;
        });
        if (hasSelectColumn && pinnedProperties.length > 0) pinnedProperties = [
            '_grommetDataTableSelect'
        ].concat(pinnedProperties);
        var nextPinnedOffset = {};
        if (columnWidths.length !== 0) {
            pinnedProperties.forEach(function(property, index) {
                var columnIndex = property === '_grommetDataTableSelect' ? 0 : columns.findIndex(function(column) {
                    return column.property === property;
                }) + hasSelectColumn;
                if (columnWidths[columnIndex]) nextPinnedOffset[property] = {
                    width: columnWidths[columnIndex],
                    left: index === 0 ? 0 : nextPinnedOffset[pinnedProperties[index - 1]].left + nextPinnedOffset[pinnedProperties[index - 1]].width
                };
            });
            setPinnedOffset(nextPinnedOffset);
        }
    }, [
        columns,
        setPinnedOffset,
        select,
        onSelect
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $6a5275ec792307a1$export$e5c5a5f917a5871c)(function() {
        var _bodyRef$current$pare;
        var nextScrollOffset = (((_bodyRef$current$pare = bodyRef.current.parentElement) == null ? void 0 : _bodyRef$current$pare.clientWidth) || 0) - bodyRef.current.clientWidth;
        if (nextScrollOffset !== scrollOffset) setScrollOffset(nextScrollOffset);
    });
    (0, $6a5275ec792307a1$export$e5c5a5f917a5871c)(function() {
        if (placeholder) {
            if (headerRef.current) {
                var nextHeaderHeight = headerRef.current.getBoundingClientRect().height;
                setHeaderHeight(nextHeaderHeight);
            } else setHeaderHeight(0);
            if (footerRef.current) {
                var nextFooterHeight = footerRef.current.getBoundingClientRect().height;
                setFooterHeight(nextFooterHeight);
            } else setFooterHeight(0);
        }
    }, [
        footerRef,
        headerRef,
        placeholder
    ]);
    // remember that we are filtering on this property
    var onFiltering = function onFiltering(property) {
        return setFiltering(property);
    };
    // remember the search text we should filter this property by
    var onFilter = function onFilter(property, value) {
        var nextFilters = $96c556b4e6e19733$var$_extends({}, filters);
        nextFilters[property] = value;
        setFilters(nextFilters);
        // Let caller know about search, if interested
        if (onSearch) onSearch(nextFilters);
    };
    // toggle the sort direction on this property
    var onSort = function onSort(property) {
        return function() {
            var external = sort ? sort.external : false;
            var direction;
            if (!sort || property !== sort.property) direction = 'asc';
            else if (sort.direction === 'asc') direction = 'desc';
            else direction = 'asc';
            var nextSort = {
                property: property,
                direction: direction,
                external: external
            };
            setSort(nextSort);
            if (onView) onView($96c556b4e6e19733$var$_extends({}, view, {
                sort: {
                    property: property,
                    direction: direction
                }
            }));
            if (onUpdate) {
                var opts = {
                    count: limit,
                    sort: nextSort
                };
                if (groups) opts.expanded = Object.keys(groupState).filter(function(k) {
                    return groupState[k].expanded;
                });
                if (showProp) opts.show = showProp;
                onUpdate(opts);
            }
            if (onSortProp) onSortProp(nextSort);
        };
    };
    // toggle whether the group is expanded
    var onToggleGroup = function onToggleGroup(groupValue) {
        return function() {
            var nextGroupState = $96c556b4e6e19733$var$_extends({}, groupState);
            nextGroupState[groupValue] = $96c556b4e6e19733$var$_extends({}, nextGroupState[groupValue], {
                expanded: !nextGroupState[groupValue].expanded
            });
            setGroupState(nextGroupState);
            var expandedKeys = Object.keys(nextGroupState).filter(function(k) {
                return nextGroupState[k].expanded;
            });
            if (onUpdate) {
                var opts = {
                    expanded: expandedKeys,
                    count: limit
                };
                if (sort != null && sort.property) opts.sort = sort;
                if (showProp) opts.show = showProp;
                onUpdate(opts);
            }
            if (groupBy.onExpand) groupBy.onExpand(expandedKeys);
        };
    };
    // toggle whether all groups are expanded
    var onToggleGroups = function onToggleGroups() {
        var expanded = Object.keys(groupState).filter(function(k) {
            return !groupState[k].expanded;
        }).length === 0;
        var nextGroupState = {};
        Object.keys(groupState).forEach(function(k) {
            nextGroupState[k] = $96c556b4e6e19733$var$_extends({}, groupState[k], {
                expanded: !expanded
            });
        });
        setGroupState(nextGroupState);
        var expandedKeys = Object.keys(nextGroupState).filter(function(k) {
            return nextGroupState[k].expanded;
        });
        if (onUpdate) {
            var opts = {
                expanded: expandedKeys,
                count: limit
            };
            if (showProp) opts.show = showProp;
            if (sort != null && sort.property) opts.sort = sort;
            onUpdate(opts);
        }
        if (groupBy.onExpand) groupBy.onExpand(expandedKeys);
    };
    // remember the width this property's column should be
    var onResize = (0, $96c556b4e6e19733$var$_react.useCallback)(function(property, width) {
        if (widths[property] !== width) {
            var nextWidths = $96c556b4e6e19733$var$_extends({}, widths);
            nextWidths[property] = width;
            setWidths(nextWidths);
        }
    }, [
        widths
    ]);
    if (size && resizeable) console.warn('DataTable cannot combine "size" and "resizeable".');
    if (onUpdate && onMore) console.warn('DataTable cannot combine "onUpdate" and "onMore".');
    var _usePagination = (0, $4113023f9e0bafa0$exports.usePagination)($96c556b4e6e19733$var$_extends({
        data: adjustedData,
        page: (0, $4113023f9e0bafa0$exports.normalizeShow)(showProp, step),
        step: step
    }, paginate)), items = _usePagination[0], paginationProps = _usePagination[1];
    var paginationStep = paginationProps.step;
    var Container = paginate ? $ff3a0b5a9b0cbb67$export$1d41361302b577a1 : $96c556b4e6e19733$var$_react.Fragment;
    var containterProps = paginate ? $96c556b4e6e19733$var$_extends({}, theme.dataTable.container, {
        fill: fill
    }, passThemeFlag) : undefined;
    // DataTable should overflow if paginating but pagination component
    // should remain in its location
    var OverflowContainer = paginate ? $090ffb0ba78fff3f$export$e71c4d32a2263218 : $96c556b4e6e19733$var$_react.Fragment;
    var overflowContainerProps = paginate ? {
        overflow: {
            horizontal: 'auto'
        }
    } : undefined;
    // necessary for Firefox, otherwise paginated DataTable will
    // not fill its container like it does by default on other
    // browsers like Chrome/Safari
    var paginatedDataTableProps = paginate && (fill === true || fill === 'horizontal') ? {
        style: {
            minWidth: '100%'
        }
    } : undefined;
    var placeholderContent = placeholder;
    if (placeholder && typeof placeholder === 'string') placeholderContent = /*#__PURE__*/ $96c556b4e6e19733$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        background: {
            color: 'background-front',
            opacity: 'strong'
        },
        align: "center",
        justify: "center",
        fill: "vertical"
    }, /*#__PURE__*/ $96c556b4e6e19733$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, null, placeholder));
    var handleSelect = function handleSelect(nextSelected, row) {
        setSelected(nextSelected);
        if (setSelectedDataContext) setSelectedDataContext(nextSelected.length);
        if (row) onSelect(nextSelected, row);
        else onSelect(nextSelected);
    };
    var bodyContent = groups ? /*#__PURE__*/ $96c556b4e6e19733$var$_react["default"].createElement($5b943aaad3aa7ed3$export$298bfb09deaa1b80, {
        ref: bodyRef,
        cellProps: {
            body: cellProps.body,
            groupHeader: $96c556b4e6e19733$var$_extends({}, cellProps.body, cellProps.groupHeader)
        },
        columns: columns,
        disabled: disabled,
        groupBy: typeof groupBy === 'string' ? {
            property: groupBy
        } : groupBy,
        groups: groups,
        groupState: groupState,
        messages: messages,
        pinnedOffset: pinnedOffset,
        primaryProperty: primaryProperty,
        onMore: onUpdate ? function() {
            if (adjustedData.length === limit) {
                var opts = {
                    expanded: Object.keys(groupState).filter(function(k) {
                        return groupState[k].expanded;
                    }),
                    count: limit + paginationStep
                };
                if (sort != null && sort.property) opts.sort = sort;
                if (showProp) opts.show = showProp;
                onUpdate(opts);
                setLimit(function(prev) {
                    return prev + paginationStep;
                });
            }
        } : onMore,
        onSelect: onSelect ? handleSelect : undefined,
        onToggle: onToggleGroup,
        onUpdate: onUpdate,
        replace: replace,
        rowProps: rowProps,
        selected: selected,
        size: size,
        step: paginationStep,
        verticalAlign: typeof verticalAlign === 'string' ? verticalAlign : verticalAlign == null ? void 0 : verticalAlign.body
    }) : /*#__PURE__*/ $96c556b4e6e19733$var$_react["default"].createElement($e2c8f41c1887239d$export$4b2c32e08f77ff18, {
        ref: bodyRef,
        cellProps: cellProps.body,
        columns: columns,
        data: !paginate ? adjustedData : items,
        disabled: disabled,
        onMore: onUpdate ? function() {
            if (adjustedData.length === limit) {
                var opts = {
                    count: limit + paginationStep
                };
                if (sort != null && sort.property) opts.sort = sort;
                if (showProp) opts.show = showProp;
                onUpdate(opts);
                setLimit(function(prev) {
                    return prev + paginationStep;
                });
            }
        } : onMore,
        replace: replace,
        onClickRow: onClickRow,
        onSelect: onSelect ? handleSelect : undefined,
        pinnedCellProps: cellProps.pinned,
        pinnedOffset: pinnedOffset,
        primaryProperty: primaryProperty,
        rowProps: rowProps,
        selected: selected,
        show: !paginate ? showProp : undefined,
        size: size,
        step: paginationStep,
        rowDetails: rowDetails,
        rowExpand: rowExpand,
        setRowExpand: setRowExpand,
        verticalAlign: typeof verticalAlign === 'string' ? verticalAlign : verticalAlign == null ? void 0 : verticalAlign.body
    });
    return /*#__PURE__*/ $96c556b4e6e19733$var$_react["default"].createElement(Container, containterProps, /*#__PURE__*/ $96c556b4e6e19733$var$_react["default"].createElement(OverflowContainer, overflowContainerProps, /*#__PURE__*/ $96c556b4e6e19733$var$_react["default"].createElement($ff3a0b5a9b0cbb67$export$551fccb2985765ce, $96c556b4e6e19733$var$_extends({
        fillProp: !paginate ? fill : undefined
    }, paginatedDataTableProps, passThemeFlag, rest), /*#__PURE__*/ $96c556b4e6e19733$var$_react["default"].createElement($51e7385aa9e065e1$export$8b251419efc915eb, {
        ref: headerRef,
        allowSelectAll: allowSelectAll,
        cellProps: cellProps.header,
        columns: columns,
        data: adjustedData,
        disabled: disabled,
        fill: fill,
        filtering: filtering,
        filters: filters,
        groupBy: groupBy,
        groups: groups,
        groupState: groupState,
        pin: pin === true || pin === 'header',
        pinnedOffset: pinnedOffset,
        selected: selected,
        size: size,
        sort: sort,
        widths: widths,
        messages: messages,
        onFiltering: onFiltering,
        onFilter: onFilter,
        onResize: resizeable ? onResize : undefined,
        onSelect: onSelect ? handleSelect : undefined,
        onSort: sortable || sortProp || onSortProp ? onSort : undefined,
        onToggle: onToggleGroups,
        onWidths: onHeaderWidths,
        primaryProperty: primaryProperty,
        scrollOffset: scrollOffset,
        rowDetails: rowDetails,
        verticalAlign: typeof verticalAlign === 'string' ? verticalAlign : verticalAlign == null ? void 0 : verticalAlign.header
    }), placeholder && (!items || items.length === 0) ? /*#__PURE__*/ $96c556b4e6e19733$var$_react["default"].createElement($94c2aaec2daed9f7$export$ac217b2d9dd1ba17, {
        ref: bodyRef,
        columns: columns,
        onSelect: onSelect
    }, placeholderContent) : bodyContent, showFooter && /*#__PURE__*/ $96c556b4e6e19733$var$_react["default"].createElement($4e8e103f24b53120$export$a06f1c675e846f6f, {
        ref: footerRef,
        cellProps: cellProps.footer,
        columns: columns,
        fill: fill,
        footerValues: footerValues,
        groups: groups,
        onSelect: onSelect,
        pin: pin === true || pin === 'footer',
        pinnedOffset: pinnedOffset,
        primaryProperty: primaryProperty,
        scrollOffset: scrollOffset,
        selected: selected,
        size: size,
        verticalAlign: typeof verticalAlign === 'string' ? verticalAlign : verticalAlign == null ? void 0 : verticalAlign.footer
    }), placeholder && items && items.length > 0 && /*#__PURE__*/ $96c556b4e6e19733$var$_react["default"].createElement($ff3a0b5a9b0cbb67$export$333ccef64da8eec4, {
        top: headerHeight,
        bottom: footerHeight
    }, placeholderContent))), paginate && adjustedData.length > paginationStep && items && items.length ? /*#__PURE__*/ $96c556b4e6e19733$var$_react["default"].createElement($98274833e85ef953$export$68f5e1453c188a82, $96c556b4e6e19733$var$_extends({
        alignSelf: "end"
    }, paginationProps)) : null);
};
$96c556b4e6e19733$var$DataTable.propTypes = $a3988d53b7647953$export$c2a4947702a2f5bb;


$f1c8b837e0ea03b8$export$df30df7ec97b32b5 = $96c556b4e6e19733$export$df30df7ec97b32b5;


Object.keys($f1c8b837e0ea03b8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $f1c8b837e0ea03b8$exports[key]) return;
    $3321243da0932e1e$exports[key] = $f1c8b837e0ea03b8$exports[key];
});
var $072c4c38bf436507$exports = {};

$parcel$export($072c4c38bf436507$exports, "__esModule", function () { return $072c4c38bf436507$export$1e511d4a378977f5; }, function (v) { return $072c4c38bf436507$export$1e511d4a378977f5 = v; });
$parcel$export($072c4c38bf436507$exports, "DataTableColumns", function () { return $072c4c38bf436507$export$ade1950b4d72969b; }, function (v) { return $072c4c38bf436507$export$ade1950b4d72969b = v; });
var $072c4c38bf436507$export$1e511d4a378977f5;
var $072c4c38bf436507$export$ade1950b4d72969b;
"use strict";
$072c4c38bf436507$export$1e511d4a378977f5 = true;
$072c4c38bf436507$export$ade1950b4d72969b = void 0;
var $95a6d7b31882ddea$export$1e511d4a378977f5;
var $95a6d7b31882ddea$export$ade1950b4d72969b;
"use strict";
$95a6d7b31882ddea$export$1e511d4a378977f5 = true;
$95a6d7b31882ddea$export$ade1950b4d72969b = void 0;

var $95a6d7b31882ddea$var$_react = $95a6d7b31882ddea$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $02934120194f172d$exports = {};

$parcel$export($02934120194f172d$exports, "__esModule", function () { return $02934120194f172d$export$1e511d4a378977f5; }, function (v) { return $02934120194f172d$export$1e511d4a378977f5 = v; });
$parcel$export($02934120194f172d$exports, "Splits", function () { return $02934120194f172d$export$ef2f09e23a44828b; }, function (v) { return $02934120194f172d$export$ef2f09e23a44828b = v; });
var $02934120194f172d$export$1e511d4a378977f5;
var $02934120194f172d$export$ef2f09e23a44828b;
"use strict";
$02934120194f172d$export$1e511d4a378977f5 = true;
$02934120194f172d$export$ef2f09e23a44828b = void 0;

var $02934120194f172d$var$_react = $02934120194f172d$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $02934120194f172d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($02934120194f172d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $02934120194f172d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $02934120194f172d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $02934120194f172d$var$_extends() {
    return $02934120194f172d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $02934120194f172d$var$_extends.apply(null, arguments);
}
var $02934120194f172d$var$Splits = $02934120194f172d$export$ef2f09e23a44828b = /*#__PURE__*/ (0, $02934120194f172d$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $02934120194f172d$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $02934120194f172d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Splits"
    }, props), /*#__PURE__*/ $02934120194f172d$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 22h22V2H1v20zM8 2v20V2zm8 0v20V2z"
    }));
});
$02934120194f172d$var$Splits.displayName = 'Splits';


var $a717426d13a4ad9f$exports = {};

$parcel$export($a717426d13a4ad9f$exports, "__esModule", function () { return $a717426d13a4ad9f$export$1e511d4a378977f5; }, function (v) { return $a717426d13a4ad9f$export$1e511d4a378977f5 = v; });
$parcel$export($a717426d13a4ad9f$exports, "Lock", function () { return $a717426d13a4ad9f$export$5b9db7ce80343746; }, function (v) { return $a717426d13a4ad9f$export$5b9db7ce80343746 = v; });
var $a717426d13a4ad9f$export$1e511d4a378977f5;
var $a717426d13a4ad9f$export$5b9db7ce80343746;
"use strict";
$a717426d13a4ad9f$export$1e511d4a378977f5 = true;
$a717426d13a4ad9f$export$5b9db7ce80343746 = void 0;

var $a717426d13a4ad9f$var$_react = $a717426d13a4ad9f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a717426d13a4ad9f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a717426d13a4ad9f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a717426d13a4ad9f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a717426d13a4ad9f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a717426d13a4ad9f$var$_extends() {
    return $a717426d13a4ad9f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a717426d13a4ad9f$var$_extends.apply(null, arguments);
}
var $a717426d13a4ad9f$var$Lock = $a717426d13a4ad9f$export$5b9db7ce80343746 = /*#__PURE__*/ (0, $a717426d13a4ad9f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a717426d13a4ad9f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a717426d13a4ad9f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Lock"
    }, props), /*#__PURE__*/ $a717426d13a4ad9f$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M19 23V11H5v12h14zm-7-8v4m5-8V7c0-3 0-6-5-6S7 4 7 7v4"
    }));
});
$a717426d13a4ad9f$var$Lock.displayName = 'Lock';








var $0d1b8e621fb6c667$exports = {};

$parcel$export($0d1b8e621fb6c667$exports, "__esModule", function () { return $0d1b8e621fb6c667$export$1e511d4a378977f5; }, function (v) { return $0d1b8e621fb6c667$export$1e511d4a378977f5 = v; });
$parcel$export($0d1b8e621fb6c667$exports, "List", function () { return $0d1b8e621fb6c667$export$54c2e3dc7acea9f5; }, function (v) { return $0d1b8e621fb6c667$export$54c2e3dc7acea9f5 = v; });
var $0d1b8e621fb6c667$export$1e511d4a378977f5;
var $0d1b8e621fb6c667$export$54c2e3dc7acea9f5;
"use strict";
$0d1b8e621fb6c667$export$1e511d4a378977f5 = true;
$0d1b8e621fb6c667$export$54c2e3dc7acea9f5 = void 0;
var $51525d6f8a1564fa$export$1e511d4a378977f5;
var $51525d6f8a1564fa$export$54c2e3dc7acea9f5;
"use strict";
$51525d6f8a1564fa$export$1e511d4a378977f5 = true;
$51525d6f8a1564fa$export$54c2e3dc7acea9f5 = void 0;

var $51525d6f8a1564fa$var$_react = $51525d6f8a1564fa$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $51525d6f8a1564fa$var$_styledComponents = $51525d6f8a1564fa$var$_interopRequireDefault((parcelRequire("iA1nz")));










var $af822f266f824f12$export$1e511d4a378977f5;
var $af822f266f824f12$export$ef96d43f6c91157;
"use strict";
$af822f266f824f12$export$1e511d4a378977f5 = true;
$af822f266f824f12$export$ef96d43f6c91157 = void 0;

var $af822f266f824f12$var$_propTypes = $af822f266f824f12$var$_interopRequireDefault((parcelRequire("dyr1f")));


function $af822f266f824f12$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $af822f266f824f12$var$_extends() {
    return $af822f266f824f12$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $af822f266f824f12$var$_extends.apply(null, arguments);
}
var $af822f266f824f12$var$sizes = [
    'none',
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge'
];
var $af822f266f824f12$var$sides = [
    'horizontal',
    'vertical',
    'top',
    'bottom',
    'left',
    'right',
    'start',
    'end'
];
var $af822f266f824f12$var$padShapeSides = {};
$af822f266f824f12$var$sides.forEach(function(side) {
    $af822f266f824f12$var$padShapeSides[side] = $af822f266f824f12$var$_propTypes["default"].oneOf($af822f266f824f12$var$sizes);
});
var $af822f266f824f12$var$borderTypes = [
    $af822f266f824f12$var$_propTypes["default"].bool,
    $af822f266f824f12$var$_propTypes["default"].oneOf($af822f266f824f12$var$sides),
    $af822f266f824f12$var$_propTypes["default"].shape({
        color: $af822f266f824f12$var$_propTypes["default"].oneOfType([
            $af822f266f824f12$var$_propTypes["default"].string,
            $af822f266f824f12$var$_propTypes["default"].shape({
                dark: $af822f266f824f12$var$_propTypes["default"].string,
                light: $af822f266f824f12$var$_propTypes["default"].string
            })
        ]),
        side: $af822f266f824f12$var$_propTypes["default"].oneOf($af822f266f824f12$var$sides),
        size: $af822f266f824f12$var$_propTypes["default"].oneOfType([
            $af822f266f824f12$var$_propTypes["default"].oneOf($af822f266f824f12$var$sizes),
            $af822f266f824f12$var$_propTypes["default"].string
        ])
    })
];
var $af822f266f824f12$var$PropType = {};
$af822f266f824f12$var$PropType = $af822f266f824f12$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    action: $af822f266f824f12$var$_propTypes["default"].func,
    as: $af822f266f824f12$var$_propTypes["default"].string,
    background: $af822f266f824f12$var$_propTypes["default"].oneOfType([
        $af822f266f824f12$var$_propTypes["default"].string,
        $af822f266f824f12$var$_propTypes["default"].arrayOf($af822f266f824f12$var$_propTypes["default"].string)
    ]),
    border: $af822f266f824f12$var$_propTypes["default"].oneOfType($af822f266f824f12$var$borderTypes),
    data: $af822f266f824f12$var$_propTypes["default"].arrayOf($af822f266f824f12$var$_propTypes["default"].oneOfType([
        $af822f266f824f12$var$_propTypes["default"].string,
        $af822f266f824f12$var$_propTypes["default"].shape({})
    ])),
    children: $af822f266f824f12$var$_propTypes["default"].func,
    defaultItemProps: $af822f266f824f12$var$_propTypes["default"].shape($eee1df2c89b8d329$export$39ef5a49fe6b4917),
    disabled: $af822f266f824f12$var$_propTypes["default"].arrayOf($af822f266f824f12$var$_propTypes["default"].string),
    showIndex: $af822f266f824f12$var$_propTypes["default"].bool,
    itemKey: $af822f266f824f12$var$_propTypes["default"].oneOfType([
        $af822f266f824f12$var$_propTypes["default"].string,
        $af822f266f824f12$var$_propTypes["default"].func
    ]),
    itemProps: $af822f266f824f12$var$_propTypes["default"].shape({}),
    messages: $af822f266f824f12$var$_propTypes["default"].shape({
        pinned: $af822f266f824f12$var$_propTypes["default"].string
    }),
    onActive: $af822f266f824f12$var$_propTypes["default"].func,
    onClickItem: $af822f266f824f12$var$_propTypes["default"].func,
    onMore: $af822f266f824f12$var$_propTypes["default"].func,
    onOrder: $af822f266f824f12$var$_propTypes["default"].func,
    pad: $af822f266f824f12$var$_propTypes["default"].oneOfType([
        $5897bd367fbd90c1$export$b91a2ef62736aae3
    ]),
    paginate: $af822f266f824f12$var$_propTypes["default"].oneOfType([
        $af822f266f824f12$var$_propTypes["default"].bool,
        $af822f266f824f12$var$_propTypes["default"].object
    ]),
    pinned: $af822f266f824f12$var$_propTypes["default"].oneOfType([
        $af822f266f824f12$var$_propTypes["default"].bool,
        $af822f266f824f12$var$_propTypes["default"].arrayOf($af822f266f824f12$var$_propTypes["default"].oneOfType([
            $af822f266f824f12$var$_propTypes["default"].string,
            $af822f266f824f12$var$_propTypes["default"].number
        ])),
        $af822f266f824f12$var$_propTypes["default"].shape({
            items: $af822f266f824f12$var$_propTypes["default"].arrayOf($af822f266f824f12$var$_propTypes["default"].oneOfType([
                $af822f266f824f12$var$_propTypes["default"].string,
                $af822f266f824f12$var$_propTypes["default"].number
            ])),
            background: $5897bd367fbd90c1$export$aa372966d47f02af,
            color: $af822f266f824f12$var$_propTypes["default"].string,
            icon: $af822f266f824f12$var$_propTypes["default"].element
        })
    ]),
    primaryKey: $af822f266f824f12$var$_propTypes["default"].oneOfType([
        $af822f266f824f12$var$_propTypes["default"].string,
        $af822f266f824f12$var$_propTypes["default"].func
    ]),
    secondaryKey: $af822f266f824f12$var$_propTypes["default"].oneOfType([
        $af822f266f824f12$var$_propTypes["default"].string,
        $af822f266f824f12$var$_propTypes["default"].func
    ]),
    show: $af822f266f824f12$var$_propTypes["default"].oneOfType([
        $af822f266f824f12$var$_propTypes["default"].number,
        $af822f266f824f12$var$_propTypes["default"].shape({
            page: $af822f266f824f12$var$_propTypes["default"].number
        })
    ]),
    step: $af822f266f824f12$var$_propTypes["default"].number
});
var $af822f266f824f12$var$ListPropTypes = $af822f266f824f12$export$ef96d43f6c91157 = $af822f266f824f12$var$PropType;



var $51525d6f8a1564fa$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "action",
    "as",
    "background",
    "border",
    "children",
    "data",
    "defaultItemProps",
    "disabled",
    "focus",
    "itemKey",
    "itemProps",
    "messages",
    "onActive",
    "onClickItem",
    "onKeyDown",
    "onMore",
    "onOrder",
    "showIndex",
    "pad",
    "paginate",
    "pinned",
    "primaryKey",
    "secondaryKey",
    "show",
    "step"
];
function $51525d6f8a1564fa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $51525d6f8a1564fa$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($51525d6f8a1564fa$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $51525d6f8a1564fa$var$_extends() {
    return $51525d6f8a1564fa$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $51525d6f8a1564fa$var$_extends.apply(null, arguments);
}
function $51525d6f8a1564fa$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $51525d6f8a1564fa$var$emptyData = [];
var $51525d6f8a1564fa$var$StyledList = $51525d6f8a1564fa$var$_styledComponents["default"].ul.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "List__StyledList",
    componentId: "sc-130gdqg-0"
})([
    "list-style:none;",
    " padding:0;",
    " ",
    "}"
], function(props) {
    return !props.margin && 'margin: 0;';
}, $4113023f9e0bafa0$exports.genericStyles, function(props) {
    return props.theme.list && props.theme.list.extend;
});
var $51525d6f8a1564fa$var$StyledItem = (0, $51525d6f8a1564fa$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "List__StyledItem",
    componentId: "sc-130gdqg-1"
})([
    "",
    " ",
    " ",
    " &:hover{",
    "}",
    ""
], function(props) {
    return props.onClick && !props.isDisabled && "cursor: pointer;";
}, function(props) {
    return props.draggable && !props.isDisabled && "cursor: move;";
}, function(props) {
    var _props$theme$list;
    var disabledStyle;
    if (props.isDisabled && (_props$theme$list = props.theme.list) != null && (_props$theme$list = _props$theme$list.item) != null && _props$theme$list.disabled) {
        var _props$theme$list$ite = props.theme.list.item.disabled, color = _props$theme$list$ite.color, cursor = _props$theme$list$ite.cursor;
        disabledStyle = {
            color: (0, $4113023f9e0bafa0$exports.normalizeColor)(color, props.theme),
            cursor: cursor
        };
    }
    return disabledStyle;
}, function(props) {
    return props.isDisabled && "background-color: unset;";
}, function(props) {
    return props.theme.list && props.theme.list.item && props.theme.list.item.extend;
});
// when paginated, this wraps the data table and pagination component
var $51525d6f8a1564fa$var$StyledContainer = (0, $51525d6f8a1564fa$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "List__StyledContainer",
    componentId: "sc-130gdqg-2"
})([
    "",
    ";"
], function(props) {
    return props.theme.list && props.theme.list.container && props.theme.list.container.extend;
});
var $51525d6f8a1564fa$var$getValue = function getValue(item, index, key) {
    if (typeof key === 'function') return key(item, index);
    if (typeof item === 'string') return item;
    if (key !== undefined) return item == null ? void 0 : item[key];
    return undefined;
};
var $51525d6f8a1564fa$var$reorder = function reorder(array, pinnedArray, source, target) {
    var result = array.slice(0);
    var tmp = result[source];
    if (source < target) for(var i = source; i < target; i += 1)result[i] = result[i + 1];
    else for(var _i = source; _i > target; _i -= 1)result[_i] = result[_i - 1];
    result[target] = tmp;
    // insert pinned items into their proper index within the orderable
    // data object to make the complete data set again
    if (pinnedArray.data.length > 0) pinnedArray.data.forEach(function(pinnedItem, index) {
        result.splice(pinnedArray.indexes[index], 0, pinnedItem);
    });
    return result;
};
/** Calculate tabIndex for order control buttons. */ var $51525d6f8a1564fa$var$calculateTabIndex = function calculateTabIndex(buttonIndex, focused, lastFocused, disabled) {
    if (disabled) return -1;
    // is currently focused
    return focused !== undefined && focused === buttonIndex || // was last focused
    focused === undefined && lastFocused === buttonIndex || // first "move down" button when entering the list for first time
    focused === undefined && lastFocused === undefined && buttonIndex === 1 ? 0 : -1;
};
var $51525d6f8a1564fa$var$List = $51525d6f8a1564fa$export$54c2e3dc7acea9f5 = /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].forwardRef(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], action = _ref.action, as = _ref.as, background = _ref.background, border = _ref.border, children = _ref.children, dataProp = _ref.data, defaultItemProps = _ref.defaultItemProps, disabledItems = _ref.disabled, focus = _ref.focus, defaultItemKey = _ref.itemKey, itemProps = _ref.itemProps, messages = _ref.messages, onActive = _ref.onActive, onClickItem = _ref.onClickItem, onKeyDown = _ref.onKeyDown, onMore = _ref.onMore, onOrder = _ref.onOrder, _ref$showIndex = _ref.showIndex, showIndex = _ref$showIndex === void 0 ? true : _ref$showIndex, pad = _ref.pad, paginate = _ref.paginate, _ref$pinned = _ref.pinned, pinned = _ref$pinned === void 0 ? [] : _ref$pinned, primaryKey = _ref.primaryKey, secondaryKey = _ref.secondaryKey, showProp = _ref.show, _ref$step = _ref.step, step = _ref$step === void 0 ? paginate ? 50 : undefined : _ref$step, rest = $51525d6f8a1564fa$var$_objectWithoutPropertiesLoose(_ref, $51525d6f8a1564fa$var$_excluded);
    var listRef = (0, $4113023f9e0bafa0$exports.useForwardedRef)(ref);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useContext = (0, $51525d6f8a1564fa$var$_react.useContext)($932597a497e37de0$export$58d75f9829cbe158), contextData = _useContext.data;
    var data = dataProp || contextData || $51525d6f8a1564fa$var$emptyData;
    var _useContext2 = (0, $51525d6f8a1564fa$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext2.format;
    // fixes issue where itemKey is undefined when only primaryKey is provided
    var itemKey = defaultItemKey || primaryKey || null;
    // active will be the index of the current 'active'
    // control in the list. If the onOrder property is defined
    // this will be the index of up or down control for ordering
    // items in the list. In this case the item index of that
    // control would be the active index / 2.
    // If onOrder is not defined but onClickItem is (e.g. the
    // List items are likely selectable), active will be the
    // index of the item which is currently active.
    var _useState = (0, $51525d6f8a1564fa$var$_react.useState)(), active = _useState[0], setActive = _useState[1];
    /** The item or order control that is most recently interacted with by
   * mouse over or keyboard  */ var updateActive = function updateActive(nextActive) {
        setActive(nextActive);
        // we occasionally call updateActive with undefined when it already is so,
        // no need to call onActive in that case
        if (onActive && onClickItem && nextActive !== active) onActive(nextActive);
    };
    var _useState2 = (0, $51525d6f8a1564fa$var$_react.useState)(), focused = _useState2[0], setFocused = _useState2[1];
    var _useState3 = (0, $51525d6f8a1564fa$var$_react.useState)(), lastFocused = _useState3[0], setLastFocused = _useState3[1];
    /** Update the item or move up/move down button that is focused
   * in the DOM  */ var updateFocused = function updateFocused(nextFocused) {
        setFocused(nextFocused);
    };
    var handleFocus = function handleFocus(nextFocused) {
        updateActive(nextFocused);
        updateFocused(nextFocused);
    };
    // roving tab index, ensure focused item (when onClickItem)
    // or move up / move down button (when onOrder) has DOM focus
    var focusedRef = (0, $51525d6f8a1564fa$var$_react.useRef)();
    (0, $51525d6f8a1564fa$var$_react.useEffect)(function() {
        if (focused !== undefined) {
            var _focusedRef$current;
            (_focusedRef$current = focusedRef.current) == null || _focusedRef$current.focus();
        }
    }, [
        focused,
        data
    ]);
    var _useState4 = (0, $51525d6f8a1564fa$var$_react.useState)(), dragging = _useState4[0], setDragging = _useState4[1];
    var _useState5 = (0, $51525d6f8a1564fa$var$_react.useState)(), orderingData = _useState5[0], setOrderingData = _useState5[1];
    // store a reference to the pinned and the data that is orderable
    var _useMemo = (0, $51525d6f8a1564fa$var$_react.useMemo)(function() {
        var orderable = [];
        var pinnedData = [];
        var pinnedIndexes = [];
        var currentData = orderingData || data;
        if (pinned.length === 0) return [
            currentData,
            {
                data: pinnedData,
                indexes: pinnedIndexes
            }
        ];
        currentData.forEach(function(item, index) {
            var _pinned$items;
            var key = $51525d6f8a1564fa$var$getValue(item, index, itemKey);
            var isPinned = Array.isArray(pinned) ? pinned.includes(key) : typeof pinned === 'object' && (pinned == null || (_pinned$items = pinned.items) == null ? void 0 : _pinned$items.includes(key));
            if (isPinned) {
                pinnedData.push(item);
                pinnedIndexes.push(index);
            } else orderable.push(item);
        });
        return [
            orderable,
            {
                data: pinnedData,
                indexes: pinnedIndexes
            }
        ];
    }, [
        data,
        orderingData,
        itemKey,
        pinned
    ]), orderableData = _useMemo[0], pinnedInfo = _useMemo[1];
    var _usePagination = (0, $4113023f9e0bafa0$exports.usePagination)($51525d6f8a1564fa$var$_extends({
        data: data,
        page: (0, $4113023f9e0bafa0$exports.normalizeShow)(showProp, step),
        step: step
    }, paginate)), items = _usePagination[0], paginationProps = _usePagination[1];
    var Container = paginate ? $51525d6f8a1564fa$var$StyledContainer : $51525d6f8a1564fa$var$_react.Fragment;
    var containterProps = paginate ? $51525d6f8a1564fa$var$_extends({}, theme.list.container, passThemeFlag) : undefined;
    var draggingRef = (0, $51525d6f8a1564fa$var$_react.useRef)();
    var sendAnalytics = (0, $995522def9ecf485$exports.useAnalytics)();
    var ariaProps = {
        role: onClickItem ? 'listbox' : 'list'
    };
    var onSelectOption = function onSelectOption(event, nextFocused) {
        if ((onClickItem || onOrder) && nextFocused >= 0) {
            if (onOrder) {
                var index = Math.trunc(nextFocused / 2);
                // Call onOrder with the re-ordered data.
                // Update the focused control index so that the
                // focused control will stay on the same item
                // even though it moved up or down.
                var newIndex = nextFocused % 2 ? index + 1 : index - 1;
                onOrder($51525d6f8a1564fa$var$reorder(orderableData, pinnedInfo, index, newIndex));
                // distinguish keyboard "click" from mouse "click" event
                // when keyboard, event.detail is always 0
                // https://developer.mozilla.org/en-US/docs/Web/API/Element/click_event#usage_notes
                // when keyboard, move focus with the moving item
                if (event.detail === 0) updateFocused(focused % 2 ? Math.min(focused + 2, orderableData.length * 2 - 2) : Math.max(focused - 2, 1));
                else updateFocused(nextFocused);
            } else if (disabledItems != null && disabledItems.includes($51525d6f8a1564fa$var$getValue(data[nextFocused], nextFocused, itemKey))) event.preventDefault();
            else if (onClickItem) {
                event.persist();
                updateFocused(nextFocused);
                var adjustedEvent = event;
                // When paginated, use 'items'
                var currentItems = !paginate ? orderingData || data : items;
                adjustedEvent.item = currentItems[nextFocused];
                adjustedEvent.index = !paginate ? nextFocused : (paginationProps.page - 1) * step + nextFocused;
                onClickItem(adjustedEvent);
                sendAnalytics({
                    type: 'listItemClick',
                    element: listRef.current,
                    event: adjustedEvent,
                    item: adjustedEvent.item,
                    index: adjustedEvent.index
                });
            }
        }
    };
    return /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].createElement(Container, containterProps, /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onUp: function onUp(event) {
            if (onClickItem || onOrder) {
                event.preventDefault();
                if (focused >= 0) {
                    var min = onOrder ? 1 : 0;
                    var focusedElementIndex = Math.max(focused - 1, min);
                    handleFocus(focusedElementIndex);
                    // Ensure the focused item is in view
                    // setTimeout for focusedElement to be updated
                    setTimeout(function() {
                        var _listRef$current;
                        // eslint-disable max-len
                        (_listRef$current = listRef.current) == null || (_listRef$current = _listRef$current.children[focusedElementIndex]) == null || _listRef$current.scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest'
                        });
                    }, 0);
                }
            }
        },
        onDown: function onDown(event) {
            if (onClickItem || onOrder) {
                event.preventDefault();
                if (orderableData && orderableData.length) {
                    var min = onOrder ? 1 : 0;
                    var max = onOrder ? orderableData.length * 2 - 2 : data.length - 1;
                    var focusedElementIndex = focused >= min ? Math.min(focused + 1, max) : min;
                    handleFocus(focusedElementIndex);
                    // Ensure the focused item is in view
                    // setTimeout for focusedElement to be updated
                    setTimeout(function() {
                        var _listRef$current2;
                        //  eslint-disable max-len
                        (_listRef$current2 = listRef.current) == null || (_listRef$current2 = _listRef$current2.children[focusedElementIndex]) == null || _listRef$current2.scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest'
                        });
                    }, 0);
                }
            }
        },
        onKeyDown: onKeyDown
    }, /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].createElement($51525d6f8a1564fa$var$StyledList, $51525d6f8a1564fa$var$_extends({
        "aria-label": ariaLabel || a11yTitle,
        ref: listRef,
        as: as || 'ul',
        onBlur: function onBlur(event) {
            setLastFocused(focused);
            // only reset focused if the focus is leaving the list
            // and not moving to a child element of the list
            if (listRef.current && !listRef.current.contains(event.relatedTarget)) updateFocused(undefined);
        },
        onMouseOut: function onMouseOut() {
            return updateActive(undefined);
        }
    }, ariaProps, passThemeFlag, rest), /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].createElement($41010700ddcbac64$export$c5295390d6167a3e, {
        items: !paginate ? orderingData || data : items,
        onMore: onMore,
        show: !paginate ? showProp : undefined,
        step: step,
        renderMarker: function renderMarker(marker) {
            return /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
                as: "li",
                flex: false
            }, marker);
        }
    }, function(item, index) {
        var _pinned$items2;
        var content;
        var boxProps = {};
        var key = $51525d6f8a1564fa$var$getValue(item, index, itemKey) || index;
        var isPinned;
        if (Array.isArray(pinned) && pinned.length > 0 || Array.isArray(pinned == null ? void 0 : pinned.items) && (pinned == null || (_pinned$items2 = pinned.items) == null ? void 0 : _pinned$items2.length) > 0) {
            if (typeof item === 'object' && !itemKey) console.error("Warning: Missing prop itemKey. Prop pin requires itemKey to be specified when data is of type 'object'.");
            isPinned = Array.isArray(pinned) ? pinned == null ? void 0 : pinned.includes(key) : pinned.items.some(function(pinnedItem) {
                return pinnedItem === key;
            });
        }
        var pinnedColor = isPinned ? pinned.color : undefined;
        if (children) content = children(item, index, onClickItem ? {
            active: active === index
        } : undefined);
        else if (primaryKey) {
            var primary = $51525d6f8a1564fa$var$getValue(item, index, primaryKey);
            content = typeof primary === 'string' || typeof primary === 'number' ? /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, $51525d6f8a1564fa$var$_extends({
                color: pinnedColor,
                key: "p"
            }, theme.list.primaryKey), primary) : primary;
            if (secondaryKey) {
                var _theme$list;
                var secondary = $51525d6f8a1564fa$var$getValue(item, index, secondaryKey);
                content = [
                    content,
                    typeof secondary === 'string' || typeof secondary === 'number' ? /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, {
                        color: pinnedColor,
                        key: "s"
                    }, $51525d6f8a1564fa$var$getValue(item, index, secondaryKey)) : secondary
                ];
                boxProps = {
                    direction: 'row',
                    align: 'center',
                    justify: 'between',
                    gap: (_theme$list = theme.list) == null || (_theme$list = _theme$list.item) == null ? void 0 : _theme$list.gap
                };
            }
        } else if (typeof item === 'object') {
            var value = item[Object.keys(item)[0]];
            content = // for backwards compatibility, only wrap in Text if
            // pinned.color is defined
            pinnedColor && typeof value === 'string' ? /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, {
                color: pinnedColor
            }, value) : value;
        } else // for backwards compatibility, only wrap in Text if
        // pinned.color is defined
        content = pinnedColor ? /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, {
            color: pinnedColor
        }, item) : item;
        var orderableIndex = orderableData.findIndex(function(ordItem, ordIndex) {
            return $51525d6f8a1564fa$var$getValue(ordItem, ordIndex, itemKey) === key;
        });
        var isDisabled;
        if (disabledItems) {
            if (typeof item === 'object' && !itemKey) console.error("Warning: Missing prop itemKey. Prop disabled requires itemKey to be specified when data is of type 'object'.");
            isDisabled = disabledItems == null ? void 0 : disabledItems.includes(key);
        }
        if (action) {
            var _theme$list2;
            content = [
                /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
                    align: "start",
                    key: "actionContainer" + index
                }, content),
                action(item, index)
            ];
            boxProps = {
                direction: 'row',
                align: secondaryKey ? 'start' : 'center',
                justify: 'between',
                gap: (_theme$list2 = theme.list) == null || (_theme$list2 = _theme$list2.item) == null ? void 0 : _theme$list2.gap
            };
        }
        var adjustedBackground = background || theme.list.item.background;
        if (!onOrder && active === index || dragging === index) adjustedBackground = theme.global.hover.background;
        else if (Array.isArray(adjustedBackground)) adjustedBackground = adjustedBackground[index % adjustedBackground.length];
        else if (isPinned) adjustedBackground = (pinned == null ? void 0 : pinned.background) || theme.list.item.pinned.background;
        var adjustedBorder = border !== undefined ? border : theme.list.item.border;
        if (adjustedBorder === 'horizontal' && index) adjustedBorder = 'bottom';
        var clickProps;
        if (onClickItem && !onOrder) clickProps = {
            role: 'option',
            tabIndex: // entering list for first time
            focused === undefined && lastFocused === undefined && index === 0 || // returning to list after already using keyboard
            focused === undefined && lastFocused !== undefined && lastFocused === index || // actively using keyboard
            focused === index ? 0 : -1,
            active: active === index,
            focus: focused === index,
            hoverIndicator: !isDisabled,
            ref: function ref(node) {
                if (focused === index) focusedRef.current = node;
            },
            onClick: function onClick(event) {
                // Only prevent event when disabled. We still want screen
                // readers to be aware that an option exists, but is in a
                // disabled state.
                if (isDisabled) event.preventDefault();
                else onSelectOption(event, index);
            },
            onFocus: function onFocus() {
                handleFocus(index);
            },
            onMouseOver: function onMouseOver() {
                return updateActive(index);
            }
        };
        var orderProps;
        var orderControls;
        if (onOrder && !isPinned) {
            var _theme$list3;
            orderProps = {
                draggable: true,
                onDragStart: function onDragStart(event) {
                    event.dataTransfer.setData('text/plain', '');
                    // allowed per
                    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API#define_the_drag_effect
                    // eslint-disable-next-line no-param-reassign
                    event.dataTransfer.effectAllowed = 'move';
                    setDragging(orderableIndex);
                    updateFocused(undefined);
                },
                onDragEnd: function onDragEnd() {
                    setDragging(undefined);
                    setOrderingData(undefined);
                },
                onDragOver: function onDragOver(event) {
                    if (dragging !== undefined) {
                        event.preventDefault();
                        if (dragging !== orderableIndex) {
                            // eslint-disable-next-line no-param-reassign
                            event.dataTransfer.dropEffect = 'move';
                            setOrderingData($51525d6f8a1564fa$var$reorder(orderableData, pinnedInfo, dragging, orderableIndex));
                            setDragging(orderableIndex);
                        }
                    }
                },
                onDrop: function onDrop() {
                    if (orderingData) onOrder(orderingData);
                },
                ref: dragging === orderableIndex ? draggingRef : undefined
            };
            var Up = theme.list.icons.up;
            var Down = theme.list.icons.down;
            var moveUpIndex = orderableIndex * 2;
            var moveUpTabIndex = $51525d6f8a1564fa$var$calculateTabIndex(moveUpIndex, focused, lastFocused, !orderableIndex // first item can't move up
            );
            var moveDownIndex = orderableIndex * 2 + 1;
            var moveDownTabIndex = $51525d6f8a1564fa$var$calculateTabIndex(moveDownIndex, focused, lastFocused, // last item can't move down
            orderableIndex >= orderableData.length - 1);
            orderControls = !isPinned && /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
                direction: "row",
                align: "center",
                justify: "end"
            }, /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
                id: key + "MoveUp",
                a11yTitle: orderableIndex + 1 + " " + key + " move up",
                icon: /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].createElement(Up, null),
                hoverIndicator: true,
                disabled: !orderableIndex,
                active: focused === moveUpIndex,
                onClick: function onClick(event) {
                    event.stopPropagation();
                    onSelectOption(event, moveUpIndex);
                },
                tabIndex: moveUpTabIndex,
                ref: function ref(node) {
                    if (focused === moveUpIndex) focusedRef.current = node;
                }
            }), /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
                id: key + "MoveDown",
                a11yTitle: orderableIndex + 1 + " " + key + " move down",
                icon: /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].createElement(Down, null),
                hoverIndicator: true,
                disabled: orderableIndex >= orderableData.length - 1,
                active: focused === moveDownIndex,
                onClick: function onClick(event) {
                    event.stopPropagation();
                    onSelectOption(event, moveDownIndex);
                },
                tabIndex: moveDownTabIndex,
                ref: function ref(node) {
                    if (focused === moveDownIndex) focusedRef.current = node;
                },
                onFocus: function onFocus() {
                    // make sure first "MoveDown" is focusable
                    if (focused === undefined && lastFocused === undefined) handleFocus(moveDownIndex);
                }
            }));
            // wrap the main content and use
            // the boxProps defined for the content
            content = /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $51525d6f8a1564fa$var$_extends({
                flex: true
            }, boxProps), content);
            // Adjust the boxProps to account for the order controls
            boxProps = {
                direction: 'row',
                align: defaultItemProps && defaultItemProps.align || 'center',
                gap: (_theme$list3 = theme.list) == null || (_theme$list3 = _theme$list3.item) == null ? void 0 : _theme$list3.gap
            };
        }
        var itemAriaProps;
        if (isDisabled) {
            itemAriaProps = {
                'aria-disabled': true
            };
            if (onClickItem) itemAriaProps = $51525d6f8a1564fa$var$_extends({}, itemAriaProps, {
                'aria-selected': false
            });
        }
        var displayPinned;
        if (isPinned) {
            var _pinIcon$props, _theme$list4;
            var pinSize = theme.list.item.pinned.icon.size;
            var pinPad = theme.list.item.pinned.icon.pad;
            var Icon = (pinned == null ? void 0 : pinned.icon) || theme.list.icons.pin;
            var pinIcon = /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].isValidElement(Icon) ? Icon : /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].createElement(Icon, null);
            pinIcon = /*#__PURE__*/ (0, $51525d6f8a1564fa$var$_react.cloneElement)(pinIcon, $51525d6f8a1564fa$var$_extends({}, !((_pinIcon$props = pinIcon.props) != null && _pinIcon$props.color) && pinnedColor ? {
                color: pinnedColor
            } : {}, {
                a11yTitle: format({
                    id: 'list.pinned',
                    messages: messages
                }),
                size: pinSize
            }));
            boxProps = {
                direction: 'row',
                align: defaultItemProps && defaultItemProps.align || 'center',
                gap: (_theme$list4 = theme.list) == null || (_theme$list4 = _theme$list4.item) == null ? void 0 : _theme$list4.gap
            };
            displayPinned = /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
                direction: "row",
                align: "center",
                justify: "end",
                pad: pinPad
            }, pinIcon);
            content = /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
                flex: true
            }, content);
        }
        if (itemProps && itemProps[index]) boxProps = $51525d6f8a1564fa$var$_extends({}, boxProps, itemProps[index]);
        return /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].createElement($51525d6f8a1564fa$var$StyledItem, $51525d6f8a1564fa$var$_extends({
            key: key,
            tag: "li",
            background: adjustedBackground,
            border: adjustedBorder,
            isDisabled: isDisabled,
            flex: false,
            pad: pad || theme.list.item.pad
        }, defaultItemProps, boxProps, clickProps, orderProps, itemAriaProps, passThemeFlag), showIndex && onOrder && /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, {
            color: pinnedColor
        }, index + 1), content, displayPinned, orderControls);
    }))), paginate && data.length > step && items && items.length ? /*#__PURE__*/ $51525d6f8a1564fa$var$_react["default"].createElement($98274833e85ef953$export$68f5e1453c188a82, $51525d6f8a1564fa$var$_extends({
        alignSelf: "end"
    }, paginationProps)) : null);
});
$51525d6f8a1564fa$var$List.displayName = 'List';
$51525d6f8a1564fa$var$List.propTypes = $af822f266f824f12$export$ef96d43f6c91157;


$0d1b8e621fb6c667$export$54c2e3dc7acea9f5 = $51525d6f8a1564fa$export$54c2e3dc7acea9f5;


var $acdc1459df0949e1$exports = {};

$parcel$export($acdc1459df0949e1$exports, "__esModule", function () { return $acdc1459df0949e1$export$1e511d4a378977f5; }, function (v) { return $acdc1459df0949e1$export$1e511d4a378977f5 = v; });
$parcel$export($acdc1459df0949e1$exports, "Tab", function () { return $acdc1459df0949e1$export$3e41faf802a29e71; }, function (v) { return $acdc1459df0949e1$export$3e41faf802a29e71 = v; });
var $acdc1459df0949e1$export$1e511d4a378977f5;
var $acdc1459df0949e1$export$3e41faf802a29e71;
"use strict";
$acdc1459df0949e1$export$1e511d4a378977f5 = true;
$acdc1459df0949e1$export$3e41faf802a29e71 = void 0;
var $21fd362c6aac30b6$export$1e511d4a378977f5;
var $21fd362c6aac30b6$export$3e41faf802a29e71;
"use strict";
$21fd362c6aac30b6$export$1e511d4a378977f5 = true;
$21fd362c6aac30b6$export$3e41faf802a29e71 = void 0;

var $21fd362c6aac30b6$var$_react = $21fd362c6aac30b6$var$_interopRequireWildcard((parcelRequire("2xPiy")));


var $60d0b83518e4d3af$export$1e511d4a378977f5;
var $60d0b83518e4d3af$export$cfa7aa87c26e7d1f;
"use strict";
$60d0b83518e4d3af$export$1e511d4a378977f5 = true;
$60d0b83518e4d3af$export$cfa7aa87c26e7d1f = void 0;

var $60d0b83518e4d3af$var$_react = $60d0b83518e4d3af$var$_interopRequireDefault((parcelRequire("2xPiy")));
function $60d0b83518e4d3af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $60d0b83518e4d3af$var$TabsContext = $60d0b83518e4d3af$export$cfa7aa87c26e7d1f = /*#__PURE__*/ $60d0b83518e4d3af$var$_react["default"].createContext({});



var $9bb91f564b3f3e7b$export$1e511d4a378977f5;
var $9bb91f564b3f3e7b$export$f43fc23d58ee4c2;
"use strict";
$9bb91f564b3f3e7b$export$1e511d4a378977f5 = true;
$9bb91f564b3f3e7b$export$f43fc23d58ee4c2 = void 0;

var $9bb91f564b3f3e7b$var$_styledComponents = $9bb91f564b3f3e7b$var$_interopRequireWildcard((parcelRequire("iA1nz")));


function $9bb91f564b3f3e7b$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($9bb91f564b3f3e7b$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $9bb91f564b3f3e7b$var$tabHoverStyle = (0, $9bb91f564b3f3e7b$var$_styledComponents.css)([
    "&:hover{",
    " ",
    " ",
    ";}&:focus{z-index:1;}"
], function(props) {
    return props.theme.tab.hover.background && (0, $9bb91f564b3f3e7b$var$_styledComponents.css)([
        "background:",
        ";"
    ], (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.tab.hover.background, props.theme));
}, function(props) {
    return props.theme.tab.hover.color && (0, $9bb91f564b3f3e7b$var$_styledComponents.css)([
        "color:",
        ";"
    ], (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.tab.hover.color, props.theme));
}, function(props) {
    return props.theme.tab.hover.extend;
});
var $9bb91f564b3f3e7b$var$StyledTab = $9bb91f564b3f3e7b$export$f43fc23d58ee4c2 = (0, $9bb91f564b3f3e7b$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "StyledTab",
    componentId: "sc-1nnwnsb-0"
})([
    "white-space:nowrap;",
    " ",
    " ",
    " ",
    ""
], $4113023f9e0bafa0$exports.genericStyles, function(props) {
    return !props.plain && !props.disabled && props.theme.tab.hover && $9bb91f564b3f3e7b$var$tabHoverStyle;
}, function(props) {
    return props.disabled && props.theme.tab.disabled;
}, function(props) {
    return props.theme.tab.extend;
});


var $e77f4116a02d560c$export$1e511d4a378977f5;
var $e77f4116a02d560c$export$5ced29b443316d9;
"use strict";
$e77f4116a02d560c$export$1e511d4a378977f5 = true;
$e77f4116a02d560c$export$5ced29b443316d9 = void 0;

var $e77f4116a02d560c$var$_propTypes = $e77f4116a02d560c$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $e77f4116a02d560c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $e77f4116a02d560c$var$PropType = {};
$e77f4116a02d560c$var$PropType = {
    disabled: $e77f4116a02d560c$var$_propTypes["default"].bool,
    icon: $e77f4116a02d560c$var$_propTypes["default"].element,
    plain: $e77f4116a02d560c$var$_propTypes["default"].bool,
    reverse: $e77f4116a02d560c$var$_propTypes["default"].bool,
    title: $e77f4116a02d560c$var$_propTypes["default"].node
};
var $e77f4116a02d560c$var$TabPropTypes = $e77f4116a02d560c$export$5ced29b443316d9 = $e77f4116a02d560c$var$PropType;




var $21fd362c6aac30b6$var$_excluded = [
    "active",
    "disabled",
    "children",
    "icon",
    "plain",
    "title",
    "onBlur",
    "onFocus",
    "onMouseOver",
    "onMouseOut",
    "reverse",
    "onClick",
    "onKeyDown"
];
function $21fd362c6aac30b6$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($21fd362c6aac30b6$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $21fd362c6aac30b6$var$_extends() {
    return $21fd362c6aac30b6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $21fd362c6aac30b6$var$_extends.apply(null, arguments);
}
function $21fd362c6aac30b6$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $21fd362c6aac30b6$var$Tab = $21fd362c6aac30b6$export$3e41faf802a29e71 = /*#__PURE__*/ (0, $21fd362c6aac30b6$var$_react.forwardRef)(function(_ref, ref) {
    var activeProp = _ref.active, disabled = _ref.disabled, children = _ref.children, icon = _ref.icon, plain = _ref.plain, title = _ref.title, _onBlur = _ref.onBlur, _onFocus = _ref.onFocus, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, reverse = _ref.reverse, onClick = _ref.onClick, onKeyDown = _ref.onKeyDown, rest = $21fd362c6aac30b6$var$_objectWithoutPropertiesLoose(_ref, $21fd362c6aac30b6$var$_excluded);
    var _useContext = (0, $21fd362c6aac30b6$var$_react.useContext)($60d0b83518e4d3af$export$cfa7aa87c26e7d1f), active = _useContext.active, activeIndex = _useContext.activeIndex, focusable = _useContext.focusable, index = _useContext.index, panelId = _useContext.panelId, tabsContextRef = _useContext.ref, onActivate = _useContext.onActivate, onTabsKeyDown = _useContext.onKeyDown, setActiveContent = _useContext.setActiveContent, setActiveTitle = _useContext.setActiveTitle, setFocusIndex = _useContext.setFocusIndex;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useState = (0, $21fd362c6aac30b6$var$_react.useState)(undefined), over = _useState[0], setOver = _useState[1];
    var normalizedTitle = title;
    var tabStyles = {};
    var tabRef = (0, $4113023f9e0bafa0$exports.useForwardedRef)(ref);
    (0, $6a5275ec792307a1$export$e5c5a5f917a5871c)(function() {
        if (tabRef.current && tabsContextRef) tabsContextRef.current = tabRef.current;
    });
    (0, $6a5275ec792307a1$export$e5c5a5f917a5871c)(function() {
        if (active) {
            setActiveContent(children);
            var activeTitle = typeof title === 'string' ? title : activeIndex + 1;
            setActiveTitle(activeTitle);
        }
    }, [
        active,
        activeIndex,
        children,
        setActiveContent,
        setActiveTitle,
        title
    ]);
    var onMouseOverTab = function onMouseOverTab(event) {
        setOver(true);
        if (onMouseOver) onMouseOver(event);
    };
    var onMouseOutTab = function onMouseOutTab(event) {
        setOver(undefined);
        if (onMouseOut) onMouseOut(event);
    };
    if (!plain) {
        if (typeof title !== 'string') normalizedTitle = title;
        else if (active) normalizedTitle = /*#__PURE__*/ $21fd362c6aac30b6$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, theme.tab.active, title);
        else if (disabled && theme.tab.disabled) normalizedTitle = /*#__PURE__*/ $21fd362c6aac30b6$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, theme.tab.disabled, title);
        else normalizedTitle = /*#__PURE__*/ $21fd362c6aac30b6$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, {
            color: over ? theme.tab.hover.color : theme.tab.color
        }, title);
    }
    var onClickTab = function onClickTab(event) {
        if (event) event.preventDefault();
        onActivate();
        if (onClick) onClick(event);
    };
    var onKeyDownTab = function onKeyDownTab(event) {
        if (disabled) return;
        onTabsKeyDown(event);
        if (onKeyDown) onKeyDown(event);
    };
    if (active && disabled) console.warn("Warning: Tab props 'active' and 'disabled' have both been set to TRUE on the same Tab resulting in an interesting Tab state. Is this your intent?");
    if (!plain) {
        if (typeof title !== 'string') normalizedTitle = title;
        else if (active) normalizedTitle = /*#__PURE__*/ $21fd362c6aac30b6$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, theme.tab.active, title);
        else if (disabled && theme.tab.disabled) normalizedTitle = /*#__PURE__*/ $21fd362c6aac30b6$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, theme.tab.disabled, title);
        else normalizedTitle = /*#__PURE__*/ $21fd362c6aac30b6$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, {
            color: over ? theme.tab.hover.color : theme.tab.color
        }, title);
        if (theme.tab.border) {
            var borderColor = theme.tab.border.color || theme.global.control.border.color;
            if (active) borderColor = theme.tab.border.active.color || borderColor;
            else if (disabled && theme.tab.border.disabled) borderColor = theme.tab.border.disabled.color || borderColor;
            else if (over) borderColor = theme.tab.border.hover.color || borderColor;
            borderColor = (0, $4113023f9e0bafa0$exports.normalizeColor)(borderColor, theme);
            tabStyles.border = {
                side: theme.tab.border.side,
                size: theme.tab.border.size,
                color: borderColor
            };
        }
        tabStyles.background = active ? theme.tab.active.background || theme.tab.background : theme.tab.background;
        tabStyles.pad = theme.tab.pad;
        tabStyles.margin = theme.tab.margin;
    }
    // needed to apply hover/active styles to the icon
    var renderIcon = function renderIcon(iconProp) {
        if (active) return /*#__PURE__*/ $21fd362c6aac30b6$var$_react["default"].cloneElement(iconProp, $21fd362c6aac30b6$var$_extends({}, theme.tab.active));
        if (disabled) return /*#__PURE__*/ $21fd362c6aac30b6$var$_react["default"].cloneElement(iconProp, $21fd362c6aac30b6$var$_extends({}, theme.tab.disabled));
        return /*#__PURE__*/ $21fd362c6aac30b6$var$_react["default"].cloneElement(iconProp, {
            color: over ? theme.tab.hover.color : theme.tab.color
        });
    };
    var normalizedIcon;
    if (icon) normalizedIcon = renderIcon(icon);
    var first = reverse ? normalizedTitle : normalizedIcon;
    var second = reverse ? normalizedIcon : normalizedTitle;
    var withIconStyles;
    if (first && second) {
        var _theme$tab;
        withIconStyles = {
            direction: 'row',
            align: 'center',
            justify: 'center',
            gap: (_theme$tab = theme.tab) == null ? void 0 : _theme$tab.gap
        };
    }
    return /*#__PURE__*/ $21fd362c6aac30b6$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, $21fd362c6aac30b6$var$_extends({
        ref: tabRef,
        plain: true,
        role: "tab",
        tabIndex: focusable ? 0 : -1,
        "aria-controls": panelId,
        "aria-selected": active,
        disabled: disabled
    }, rest, {
        onClick: onClickTab,
        onKeyDown: onKeyDownTab,
        onMouseOver: onMouseOverTab,
        onMouseOut: onMouseOutTab,
        onFocus: function onFocus(event) {
            if (_onFocus) _onFocus(event);
            setFocusIndex(index);
        },
        onBlur: function onBlur(event) {
            if (_onBlur) _onBlur(event);
            setFocusIndex(-1);
        }
    }), /*#__PURE__*/ $21fd362c6aac30b6$var$_react["default"].createElement($9bb91f564b3f3e7b$export$f43fc23d58ee4c2, $21fd362c6aac30b6$var$_extends({
        disabled: disabled,
        plain: plain
    }, withIconStyles, tabStyles, passThemeFlag), first, second));
});
$21fd362c6aac30b6$var$Tab.displayName = 'Tab';
$21fd362c6aac30b6$var$Tab.propTypes = $e77f4116a02d560c$export$5ced29b443316d9;


$acdc1459df0949e1$export$3e41faf802a29e71 = $21fd362c6aac30b6$export$3e41faf802a29e71;


var $fc47d46c0f08e384$exports = {};

$parcel$export($fc47d46c0f08e384$exports, "__esModule", function () { return $fc47d46c0f08e384$export$1e511d4a378977f5; }, function (v) { return $fc47d46c0f08e384$export$1e511d4a378977f5 = v; });
$parcel$export($fc47d46c0f08e384$exports, "Tabs", function () { return $fc47d46c0f08e384$export$b2539bed5023c21c; }, function (v) { return $fc47d46c0f08e384$export$b2539bed5023c21c = v; });
var $fc47d46c0f08e384$export$1e511d4a378977f5;
var $fc47d46c0f08e384$export$b2539bed5023c21c;
"use strict";
$fc47d46c0f08e384$export$1e511d4a378977f5 = true;
$fc47d46c0f08e384$export$b2539bed5023c21c = void 0;
var $07fdaaa93a4b9547$export$1e511d4a378977f5;
var $07fdaaa93a4b9547$export$b2539bed5023c21c;
"use strict";
$07fdaaa93a4b9547$export$1e511d4a378977f5 = true;
$07fdaaa93a4b9547$export$b2539bed5023c21c = void 0;

var $07fdaaa93a4b9547$var$_react = $07fdaaa93a4b9547$var$_interopRequireWildcard((parcelRequire("2xPiy")));







var $3ba8db5d357f14c3$export$1e511d4a378977f5;
var $3ba8db5d357f14c3$export$9c5a323fcd5fd5a3;
var $3ba8db5d357f14c3$export$594ebcebca054019;
var $3ba8db5d357f14c3$export$6dde272a8363b335;
"use strict";
$3ba8db5d357f14c3$export$1e511d4a378977f5 = true;
$3ba8db5d357f14c3$export$9c5a323fcd5fd5a3 = $3ba8db5d357f14c3$export$594ebcebca054019 = $3ba8db5d357f14c3$export$6dde272a8363b335 = void 0;

var $3ba8db5d357f14c3$var$_styledComponents = $3ba8db5d357f14c3$var$_interopRequireWildcard((parcelRequire("iA1nz")));


var $3ba8db5d357f14c3$var$_FLEX_MAP;
function $3ba8db5d357f14c3$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($3ba8db5d357f14c3$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $3ba8db5d357f14c3$var$StyledTabsHeader = $3ba8db5d357f14c3$export$9c5a323fcd5fd5a3 = (0, $3ba8db5d357f14c3$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "StyledTabs__StyledTabsHeader",
    componentId: "sc-a4fwxl-0"
})([
    "",
    ";"
], function(props) {
    return props.theme.tabs.header.extend;
});
var $3ba8db5d357f14c3$var$FLEX_MAP = ($3ba8db5d357f14c3$var$_FLEX_MAP = {}, $3ba8db5d357f14c3$var$_FLEX_MAP[true] = '1 1', $3ba8db5d357f14c3$var$_FLEX_MAP[false] = '0 0', $3ba8db5d357f14c3$var$_FLEX_MAP.grow = '1 0', $3ba8db5d357f14c3$var$_FLEX_MAP.shrink = '0 1', $3ba8db5d357f14c3$var$_FLEX_MAP);
var $3ba8db5d357f14c3$var$flexStyle = (0, $3ba8db5d357f14c3$var$_styledComponents.css)([
    "flex:",
    ";"
], function(props) {
    return "" + $3ba8db5d357f14c3$var$FLEX_MAP[props.flex] + (props.flex !== true ? ' auto' : '');
});
var $3ba8db5d357f14c3$var$StyledTabPanel = $3ba8db5d357f14c3$export$6dde272a8363b335 = $3ba8db5d357f14c3$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledTabs__StyledTabPanel",
    componentId: "sc-a4fwxl-1"
})([
    "min-height:0;",
    " ",
    ";"
], function(props) {
    return props.flex && $3ba8db5d357f14c3$var$flexStyle;
}, function(props) {
    return props.theme.tabs.panel.extend;
});
var $3ba8db5d357f14c3$var$StyledTabs = $3ba8db5d357f14c3$export$594ebcebca054019 = (0, $3ba8db5d357f14c3$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "StyledTabs",
    componentId: "sc-a4fwxl-2"
})([
    "",
    " ",
    ";"
], $4113023f9e0bafa0$exports.genericStyles, function(props) {
    return props.theme.tabs.extend;
});




var $9b69aad7136ab29e$export$1e511d4a378977f5;
var $9b69aad7136ab29e$export$45ba878828554cde;
"use strict";
$9b69aad7136ab29e$export$1e511d4a378977f5 = true;
$9b69aad7136ab29e$export$45ba878828554cde = void 0;

var $9b69aad7136ab29e$var$_propTypes = $9b69aad7136ab29e$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $9b69aad7136ab29e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $9b69aad7136ab29e$var$_extends() {
    return $9b69aad7136ab29e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9b69aad7136ab29e$var$_extends.apply(null, arguments);
}
var $9b69aad7136ab29e$var$PropType = {};
$9b69aad7136ab29e$var$PropType = $9b69aad7136ab29e$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    activeIndex: $9b69aad7136ab29e$var$_propTypes["default"].number,
    alignControls: $9b69aad7136ab29e$var$_propTypes["default"].oneOf([
        'start',
        'center',
        'end',
        'stretch'
    ]),
    children: $9b69aad7136ab29e$var$_propTypes["default"].node.isRequired,
    flex: $9b69aad7136ab29e$var$_propTypes["default"].oneOfType([
        $9b69aad7136ab29e$var$_propTypes["default"].oneOf([
            'grow',
            'shrink'
        ]),
        $9b69aad7136ab29e$var$_propTypes["default"].bool
    ]),
    justify: $9b69aad7136ab29e$var$_propTypes["default"].oneOf([
        'start',
        'center',
        'end'
    ]),
    messages: $9b69aad7136ab29e$var$_propTypes["default"].shape({
        tabContents: $9b69aad7136ab29e$var$_propTypes["default"].string
    }),
    onActive: $9b69aad7136ab29e$var$_propTypes["default"].func
});
var $9b69aad7136ab29e$var$TabsPropTypes = $9b69aad7136ab29e$export$45ba878828554cde = $9b69aad7136ab29e$var$PropType;




var $07fdaaa93a4b9547$var$_excluded = [
    "alignControls",
    "children",
    "flex",
    "justify",
    "messages",
    "responsive"
];
function $07fdaaa93a4b9547$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($07fdaaa93a4b9547$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $07fdaaa93a4b9547$var$_extends() {
    return $07fdaaa93a4b9547$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $07fdaaa93a4b9547$var$_extends.apply(null, arguments);
}
function $07fdaaa93a4b9547$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $07fdaaa93a4b9547$var$Tabs = $07fdaaa93a4b9547$export$b2539bed5023c21c = /*#__PURE__*/ (0, $07fdaaa93a4b9547$var$_react.forwardRef)(function(_ref, ref) {
    var _theme$tabs$header, _theme$tabs$header2, _theme$tabs$header3, _theme$tabs$header4;
    var alignControls = _ref.alignControls, children = _ref.children, flex = _ref.flex, _ref$justify = _ref.justify, justify = _ref$justify === void 0 ? 'center' : _ref$justify, messages = _ref.messages, _ref$responsive = _ref.responsive, responsive = _ref$responsive === void 0 ? true : _ref$responsive, rest = $07fdaaa93a4b9547$var$_objectWithoutPropertiesLoose(_ref, $07fdaaa93a4b9547$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useContext = (0, $07fdaaa93a4b9547$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var propsActiveIndex = rest.activeIndex, onActive = rest.onActive;
    var _useState = (0, $07fdaaa93a4b9547$var$_react.useState)(rest.activeIndex || 0), activeIndex = _useState[0], setActiveIndex = _useState[1];
    var _useState2 = (0, $07fdaaa93a4b9547$var$_react.useState)(), activeContent = _useState2[0], setActiveContent = _useState2[1];
    var _useState3 = (0, $07fdaaa93a4b9547$var$_react.useState)(), activeTitle = _useState3[0], setActiveTitle = _useState3[1];
    var _useState4 = (0, $07fdaaa93a4b9547$var$_react.useState)(), disableLeftArrow = _useState4[0], setDisableLeftArrow = _useState4[1];
    var _useState5 = (0, $07fdaaa93a4b9547$var$_react.useState)(), disableRightArrow = _useState5[0], setDisableRightArrow = _useState5[1];
    var _useState6 = (0, $07fdaaa93a4b9547$var$_react.useState)(), overflow = _useState6[0], setOverflow = _useState6[1];
    var _useState7 = (0, $07fdaaa93a4b9547$var$_react.useState)(-1), focusIndex = _useState7[0], setFocusIndex = _useState7[1];
    var headerRef = (0, $07fdaaa93a4b9547$var$_react.useRef)();
    var panelId = (0, $4113023f9e0bafa0$exports.useId)();
    var size = (0, $07fdaaa93a4b9547$var$_react.useContext)($afb62f3be48d73fe$export$51e389dae84ec233);
    var PreviousIcon = ((_theme$tabs$header = theme.tabs.header) == null || (_theme$tabs$header = _theme$tabs$header.previousButton) == null ? void 0 : _theme$tabs$header.icon) || $2ce319e09672cf9d$export$a499fb457891d86e;
    var NextIcon = ((_theme$tabs$header2 = theme.tabs.header) == null || (_theme$tabs$header2 = _theme$tabs$header2.nextButton) == null ? void 0 : _theme$tabs$header2.icon) || $395d1107a5183b93$export$b820fc49f2736e85;
    var sendAnalytics = (0, $c2ea26ca265fb09f$export$e955abb82869dc84)();
    if (activeIndex !== propsActiveIndex && propsActiveIndex !== undefined) setActiveIndex(propsActiveIndex);
    // Safari v15.5 has an issue with scrolling when overflow='hidden'
    // and scroll-behavior='smooth'. For now we are detecting if the browser
    // is safari to workaround this issue. The issue should be resolved soon
    // and we can remove this. https://github.com/WebKit/WebKit/pull/1387
    var isSafari = typeof window !== 'undefined' ? /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent) : true;
    /* eslint-disable no-param-reassign */ delete rest.activeIndex;
    delete rest.onActive;
    /* eslint-enable no-param-reassign */ var tabRefs = (0, $07fdaaa93a4b9547$var$_react.useMemo)(function() {
        return $07fdaaa93a4b9547$var$_react["default"].Children.map(children, function() {
            return /*#__PURE__*/ $07fdaaa93a4b9547$var$_react["default"].createRef();
        });
    }, [
        children
    ]);
    var disabledIndexes = (0, $07fdaaa93a4b9547$var$_react.useMemo)(function() {
        return $07fdaaa93a4b9547$var$_react["default"].Children.map(children, function(child) {
            if (!/*#__PURE__*/ $07fdaaa93a4b9547$var$_react["default"].isValidElement(child)) return true;
            return !!child.props.disabled;
        }) || [];
    }, [
        children
    ]);
    var focusTab = (0, $07fdaaa93a4b9547$var$_react.useCallback)(function(index) {
        var _tabRefs$index;
        if (index >= 0 && (_tabRefs$index = tabRefs[index]) != null && _tabRefs$index.current) tabRefs[index].current.focus();
    }, [
        tabRefs
    ]);
    var findEnabledIndex = (0, $07fdaaa93a4b9547$var$_react.useCallback)(function(startIndex, direction) {
        if (!disabledIndexes.length) return undefined;
        var normalizeIndex = function normalizeIndex(index) {
            if (index < 0) return disabledIndexes.length - 1;
            if (index >= disabledIndexes.length) return 0;
            return index;
        };
        var nextIndex = normalizeIndex(startIndex);
        var attempts = 0;
        while(attempts < disabledIndexes.length){
            if (!disabledIndexes[nextIndex]) return nextIndex;
            nextIndex = normalizeIndex(nextIndex + direction);
            attempts += 1;
        }
        return undefined;
    }, [
        disabledIndexes
    ]);
    var getClosestEnabledIndex = (0, $07fdaaa93a4b9547$var$_react.useCallback)(function(preferredIndex) {
        if (!disabledIndexes.length) return undefined;
        var clampedIndex = Math.min(Math.max(preferredIndex, 0), disabledIndexes.length - 1);
        if (!disabledIndexes[clampedIndex]) return clampedIndex;
        for(var offset = 1; offset < disabledIndexes.length; offset += 1){
            var nextIndex = clampedIndex + offset;
            if (nextIndex < disabledIndexes.length && !disabledIndexes[nextIndex]) return nextIndex;
            var previousIndex = clampedIndex - offset;
            if (previousIndex >= 0 && !disabledIndexes[previousIndex]) return previousIndex;
        }
        return undefined;
    }, [
        disabledIndexes
    ]);
    var resolvedActiveIndex = (0, $07fdaaa93a4b9547$var$_react.useMemo)(function() {
        if (!disabledIndexes.length) return undefined;
        if (activeIndex < 0 || activeIndex >= disabledIndexes.length) return getClosestEnabledIndex(activeIndex);
        if (disabledIndexes[activeIndex]) return getClosestEnabledIndex(activeIndex);
        return activeIndex;
    }, [
        activeIndex,
        disabledIndexes,
        getClosestEnabledIndex
    ]);
    var activateTab = (0, $07fdaaa93a4b9547$var$_react.useCallback)(function(nextIndex) {
        sendAnalytics({
            type: 'activateTab',
            element: tabRefs[nextIndex].current
        });
        if (propsActiveIndex === undefined) setActiveIndex(nextIndex);
        if (onActive) onActive(nextIndex);
    }, [
        onActive,
        propsActiveIndex,
        sendAnalytics,
        tabRefs
    ]);
    var moveFocus = (0, $07fdaaa93a4b9547$var$_react.useCallback)(function(targetIndex) {
        if (targetIndex === undefined) return;
        focusTab(targetIndex);
    }, [
        focusTab
    ]);
    var moveFocusByKey = (0, $07fdaaa93a4b9547$var$_react.useCallback)(function(currentIndex, direction) {
        moveFocus(findEnabledIndex(currentIndex + direction, direction));
    }, [
        findEnabledIndex,
        moveFocus
    ]);
    var moveFocusToEdge = (0, $07fdaaa93a4b9547$var$_react.useCallback)(function(direction) {
        var startIndex = direction > 0 ? 0 : tabRefs.length - 1;
        moveFocus(findEnabledIndex(startIndex, direction));
    }, [
        findEnabledIndex,
        moveFocus,
        tabRefs.length
    ]);
    var handleTabKeyDown = (0, $07fdaaa93a4b9547$var$_react.useCallback)(function(index, event) {
        switch(event.key){
            case 'ArrowRight':
                event.preventDefault();
                moveFocusByKey(index, 1);
                break;
            case 'ArrowLeft':
                event.preventDefault();
                moveFocusByKey(index, -1);
                break;
            case 'Home':
                event.preventDefault();
                moveFocusToEdge(1);
                break;
            case 'End':
                event.preventDefault();
                moveFocusToEdge(-1);
                break;
            case 'Enter':
            case ' ':
            case 'Spacebar':
                event.preventDefault();
                activateTab(index);
                break;
            default:
        }
    }, [
        activateTab,
        moveFocusByKey,
        moveFocusToEdge
    ]);
    // check if tab is in view
    var isVisible = (0, $07fdaaa93a4b9547$var$_react.useCallback)(function(index) {
        if (tabRefs[index].current) {
            var _headerRef$current;
            var tabRect = tabRefs[index].current.getBoundingClientRect();
            var headerRect = (_headerRef$current = headerRef.current) == null ? void 0 : _headerRef$current.getBoundingClientRect();
            if (tabRect && headerRect) // the -1 and +1 allow a little leniency when calculating if a tab
            // is in view. Without the -1 and +1 a tab could be fully in view
            // but isVisible will return false.
            return tabRect.left >= headerRect.left - 1 && tabRect.right <= headerRect.right + 1;
        }
        return undefined;
    }, [
        headerRef,
        tabRefs
    ]);
    var updateArrowState = (0, $07fdaaa93a4b9547$var$_react.useCallback)(function() {
        setDisableLeftArrow(isVisible(0));
        setDisableRightArrow(isVisible(tabRefs.length - 1));
    }, [
        tabRefs,
        isVisible
    ]);
    var scrollTo = (0, $07fdaaa93a4b9547$var$_react.useCallback)(function(index, keyboard) {
        var tabRect = tabRefs[index].current.getBoundingClientRect();
        var headerRect = headerRef.current.getBoundingClientRect();
        var amountHidden = 0;
        if (tabRect.left >= headerRect.left && tabRect.left <= headerRect.right) amountHidden = tabRect.width - (headerRect.right - tabRect.left);
        else if (tabRect.right >= headerRect.left && tabRect.right <= headerRect.right) {
            amountHidden = tabRect.width - (tabRect.right - headerRect.left);
            amountHidden = 0 - amountHidden;
        } else if (tabRect.left >= headerRect.right) amountHidden = tabRect.right - headerRect.right;
        else if (tabRect.right <= headerRect.left) {
            amountHidden = headerRect.left - tabRect.left;
            amountHidden = 0 - amountHidden;
        }
        // We are adding or subtracting 2 from amountHidden to
        // ensure the focusIndicator is visible when navigating
        // by keyboard
        if (keyboard) {
            if (amountHidden < 0) amountHidden -= 2;
            if (amountHidden > 0) amountHidden += 2;
        }
        if (isSafari) headerRef.current.scrollBy({
            left: amountHidden
        });
        else headerRef.current.scrollBy({
            left: amountHidden,
            behavior: 'smooth'
        });
        // wait for scroll animation to finish
        // checks every 50 milliseconds for 1000 milliseconds
        // if the scroll animation has finished. Most scroll
        // animations will finish in 1000 milliseconds unless
        // the tab name is very long.
        if (isSafari) updateArrowState();
        else {
            var checkVisible = setInterval(function() {
                if (tabRefs[index].current && isVisible(index)) {
                    updateArrowState();
                    clearInterval(checkVisible);
                }
            }, 50);
            setTimeout(function() {
                updateArrowState();
                clearInterval(checkVisible);
            }, 1000);
        }
    }, [
        tabRefs,
        headerRef,
        isVisible,
        updateArrowState,
        isSafari
    ]);
    var moveByArrowKey = function moveByArrowKey(direction) {
        var previous = direction === 'previous';
        var index = direction === 'previous' ? 0 : tabRefs.length - 1;
        var scrolledToIndex;
        var moveBy = theme.tabs.step[size] - 1 || 0;
        while(scrolledToIndex === undefined && (previous && index < tabRefs.length - 1 || !previous && index > 0)){
            if (!isVisible(index) && (previous && isVisible(index + 1) || !previous && isVisible(index - 1))) {
                if (previous) {
                    if (index - moveBy >= 0) {
                        scrollTo(index - moveBy, false);
                        scrolledToIndex = index - moveBy;
                    } else {
                        scrollTo(0, false);
                        scrolledToIndex = 0;
                    }
                } else if (index + moveBy < tabRefs.length) {
                    scrollTo(index + moveBy, false);
                    scrolledToIndex = index + moveBy;
                } else {
                    scrollTo(tabRefs.length - 1, false);
                    scrolledToIndex = tabRefs.length - 1;
                }
            }
            index = previous ? index + 1 : index - 1;
        }
    };
    (0, $07fdaaa93a4b9547$var$_react.useEffect)(function() {
        var _tabRefs$resolvedActi;
        // if the active tab isn't visible scroll to it
        if (overflow && tabRefs && resolvedActiveIndex !== undefined && (_tabRefs$resolvedActi = tabRefs[resolvedActiveIndex]) != null && _tabRefs$resolvedActi.current && !isVisible(resolvedActiveIndex)) scrollTo(resolvedActiveIndex, true);
    }, [
        overflow,
        resolvedActiveIndex,
        tabRefs,
        isVisible,
        scrollTo
    ]);
    (0, $07fdaaa93a4b9547$var$_react.useEffect)(function() {
        // scroll focus item into view if it is not already visible
        if (overflow && focusIndex !== -1 && !isVisible(focusIndex)) scrollTo(focusIndex, true);
        else if (overflow && focusIndex !== -1) {
            // If the browser scrolled the focused item into view and
            // the focusedTab is on the edge of the header container
            // scroll slightly further to show the focusIndicator
            var tabRect = tabRefs[focusIndex].current.getBoundingClientRect();
            var headerRect = headerRef.current.getBoundingClientRect();
            var amountHidden = 0;
            if (tabRect.left >= headerRect.left && tabRect.right <= headerRect.right && tabRect.right + 2 >= headerRect.right) amountHidden = 2;
            else if (tabRect.right <= headerRect.right && tabRect.left >= headerRect.left && tabRect.left - 2 <= headerRect.left) amountHidden = -2;
            headerRef.current.scrollBy({
                left: amountHidden
            });
        }
    }, [
        overflow,
        tabRefs,
        focusIndex,
        isVisible,
        scrollTo
    ]);
    (0, $6a5275ec792307a1$export$e5c5a5f917a5871c)(function() {
        var onResize = function onResize() {
            // check if tabs are overflowing
            if (headerRef.current.scrollWidth > headerRef.current.offsetWidth) setOverflow(true);
            else setOverflow(false);
            updateArrowState();
        };
        onResize();
        window.addEventListener('resize', onResize);
        return function() {
            return window.removeEventListener('resize', onResize);
        };
    }, [
        tabRefs,
        activeIndex,
        headerRef,
        updateArrowState
    ]);
    (0, $6a5275ec792307a1$export$e5c5a5f917a5871c)(function() {
        if (focusIndex === -1 || !headerRef.current) return;
        var _document = document, activeElement = _document.activeElement;
        if (headerRef.current.contains(activeElement)) return;
        var nextFocusIndex = getClosestEnabledIndex(focusIndex);
        if (nextFocusIndex === undefined) {
            setFocusIndex(-1);
            return;
        }
        setFocusIndex(nextFocusIndex);
        focusTab(nextFocusIndex);
    }, [
        children,
        focusIndex,
        focusTab,
        getClosestEnabledIndex
    ]);
    var getTabsContext = (0, $07fdaaa93a4b9547$var$_react.useCallback)(function(index) {
        return {
            activeIndex: resolvedActiveIndex,
            active: resolvedActiveIndex === index,
            focusable: focusIndex === -1 ? resolvedActiveIndex === index : focusIndex === index,
            index: index,
            panelId: panelId,
            ref: tabRefs[index],
            onActivate: function onActivate() {
                return activateTab(index);
            },
            onKeyDown: function onKeyDown(event) {
                return handleTabKeyDown(index, event);
            },
            onNext: function onNext() {
                return moveFocusByKey(index, 1);
            },
            onPrevious: function onPrevious() {
                return moveFocusByKey(index, -1);
            },
            onFirst: function onFirst() {
                return moveFocusToEdge(1);
            },
            onLast: function onLast() {
                return moveFocusToEdge(-1);
            },
            setActiveContent: setActiveContent,
            setActiveTitle: setActiveTitle,
            setFocusIndex: setFocusIndex
        };
    }, [
        focusIndex,
        activateTab,
        handleTabKeyDown,
        moveFocusByKey,
        moveFocusToEdge,
        panelId,
        resolvedActiveIndex,
        tabRefs
    ]);
    var tabs = $07fdaaa93a4b9547$var$_react["default"].Children.map(children, function(child, index) {
        return /*#__PURE__*/ $07fdaaa93a4b9547$var$_react["default"].createElement($60d0b83518e4d3af$export$cfa7aa87c26e7d1f.Provider, {
            value: getTabsContext(index)
        }, child ? /*#__PURE__*/ // cloneElement is needed for backward compatibility with custom
        // styled components that rely on props.active. We should reassess
        // if it is still necessary in our next major release.
        $07fdaaa93a4b9547$var$_react["default"].cloneElement(child, {
            active: resolvedActiveIndex === index
        }) : child);
    });
    var tabsHeaderStyles = {};
    if (theme.tabs.header && theme.tabs.header.border) {
        var borderColor = theme.tabs.header.border.color || theme.global.control.border.color;
        borderColor = (0, $4113023f9e0bafa0$exports.normalizeColor)(borderColor, theme);
        tabsHeaderStyles.border = {
            side: theme.tabs.header.border.side,
            size: theme.tabs.header.border.size,
            style: theme.tabs.header.border.style,
            color: borderColor
        };
    }
    var tabContentTitle = (activeTitle || '') + " " + format({
        id: 'tabs.tabContents',
        messages: messages
    });
    return /*#__PURE__*/ $07fdaaa93a4b9547$var$_react["default"].createElement($3ba8db5d357f14c3$export$594ebcebca054019, $07fdaaa93a4b9547$var$_extends({
        ref: ref,
        flex: flex,
        responsive: responsive
    }, passThemeFlag, rest, {
        background: theme.tabs.background
    }), /*#__PURE__*/ $07fdaaa93a4b9547$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $07fdaaa93a4b9547$var$_extends({
        alignSelf: alignControls || ((_theme$tabs$header3 = theme.tabs.header) == null ? void 0 : _theme$tabs$header3.alignSelf),
        flex: false,
        direction: overflow ? 'row' : 'column'
    }, tabsHeaderStyles), overflow && /*#__PURE__*/ $07fdaaa93a4b9547$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
        a11yTitle: format({
            id: 'tabs.previousTab',
            messages: messages
        }),
        disabled: disableLeftArrow,
        tabIndex: -1,
        onClick: function onClick() {
            return moveByArrowKey('previous');
        }
    }, /*#__PURE__*/ $07fdaaa93a4b9547$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        pad: theme.tabs.header.previousButton.pad
    }, /*#__PURE__*/ $07fdaaa93a4b9547$var$_react["default"].createElement(PreviousIcon, {
        color: disableLeftArrow ? theme.button.disabled.color : theme.global.colors.text
    }))), /*#__PURE__*/ $07fdaaa93a4b9547$var$_react["default"].createElement($3ba8db5d357f14c3$export$9c5a323fcd5fd5a3, $07fdaaa93a4b9547$var$_extends({
        role: "tablist",
        ref: headerRef,
        direction: "row",
        justify: overflow ? 'start' : justify,
        flex: !!overflow,
        wrap: false,
        overflow: overflow ? 'hidden' : 'visible',
        background: theme.tabs.header.background,
        gap: theme.tabs.gap,
        pad: overflow ? '2px' : undefined,
        margin: overflow ? '-2px' : undefined
    }, passThemeFlag), tabs), overflow && /*#__PURE__*/ $07fdaaa93a4b9547$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
        a11yTitle: format({
            id: 'tabs.nextTab',
            messages: messages
        }),
        disabled: disableRightArrow,
        tabIndex: -1,
        onClick: function onClick() {
            return moveByArrowKey('next');
        }
    }, /*#__PURE__*/ $07fdaaa93a4b9547$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        pad: (_theme$tabs$header4 = theme.tabs.header) == null || (_theme$tabs$header4 = _theme$tabs$header4.nextButton) == null ? void 0 : _theme$tabs$header4.pad
    }, /*#__PURE__*/ $07fdaaa93a4b9547$var$_react["default"].createElement(NextIcon, {
        color: disableRightArrow ? theme.button.disabled.color : theme.global.colors.text
    })))), /*#__PURE__*/ $07fdaaa93a4b9547$var$_react["default"].createElement($3ba8db5d357f14c3$export$6dde272a8363b335, $07fdaaa93a4b9547$var$_extends({
        id: panelId,
        flex: flex,
        "aria-label": tabContentTitle,
        role: "tabpanel"
    }, passThemeFlag), activeContent));
});
$07fdaaa93a4b9547$var$Tabs.displayName = 'Tabs';
$07fdaaa93a4b9547$var$Tabs.propTypes = $9b69aad7136ab29e$export$45ba878828554cde;


$fc47d46c0f08e384$export$b2539bed5023c21c = $07fdaaa93a4b9547$export$b2539bed5023c21c;





var $679c0a183e38ad08$export$1e511d4a378977f5;
var $679c0a183e38ad08$export$8c8e7715b681118f;
"use strict";
$679c0a183e38ad08$export$1e511d4a378977f5 = true;
$679c0a183e38ad08$export$8c8e7715b681118f = void 0;

var $679c0a183e38ad08$var$_propTypes = $679c0a183e38ad08$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $679c0a183e38ad08$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $679c0a183e38ad08$var$PropType = {};
$679c0a183e38ad08$var$PropType = {
    drop: $679c0a183e38ad08$var$_propTypes["default"].bool.isRequired,
    activePanel: $679c0a183e38ad08$var$_propTypes["default"].oneOf([
        'orderColumns',
        'selectColumns'
    ]),
    options: $679c0a183e38ad08$var$_propTypes["default"].oneOfType([
        $679c0a183e38ad08$var$_propTypes["default"].arrayOf($679c0a183e38ad08$var$_propTypes["default"].string),
        $679c0a183e38ad08$var$_propTypes["default"].arrayOf($679c0a183e38ad08$var$_propTypes["default"].shape({
            disabled: $679c0a183e38ad08$var$_propTypes["default"].bool,
            label: $679c0a183e38ad08$var$_propTypes["default"].string,
            pinned: $679c0a183e38ad08$var$_propTypes["default"].bool,
            property: $679c0a183e38ad08$var$_propTypes["default"].string
        }))
    ]).isRequired
};
var $679c0a183e38ad08$var$DataTableColumnsPropTypes = $679c0a183e38ad08$export$8c8e7715b681118f = $679c0a183e38ad08$var$PropType;




var $95a6d7b31882ddea$var$_excluded = [
    "drop",
    "options",
    "activePanel"
], $95a6d7b31882ddea$var$_excluded2 = [
    "drop",
    "options",
    "activePanel"
];
function $95a6d7b31882ddea$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($95a6d7b31882ddea$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $95a6d7b31882ddea$var$_extends() {
    return $95a6d7b31882ddea$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $95a6d7b31882ddea$var$_extends.apply(null, arguments);
}
function $95a6d7b31882ddea$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $95a6d7b31882ddea$var$dropProps = {
    align: {
        top: 'bottom',
        left: 'left'
    }
};
// options can either be an array of property names or an array of objects.
// The form value always uses an array of property names.
var $95a6d7b31882ddea$var$optionsToValue = function optionsToValue(options) {
    return (options == null ? void 0 : options.map(function(o) {
        return typeof o === 'object' && o.property || o;
    })) || [];
};
var $95a6d7b31882ddea$var$optionProperty = function optionProperty(option) {
    return typeof option === 'object' ? option.property : option;
};
// align the order in value to the order in options, as best we can
var $95a6d7b31882ddea$var$alignOrder = function alignOrder(value, prevValue, options) {
    return value.sort(function(p1, p2) {
        // if both are in prevValue, preserve the order from that
        var i1 = prevValue.findIndex(function(n) {
            return n === p1;
        });
        var i2 = prevValue.findIndex(function(n) {
            return n === p2;
        });
        if (i1 !== -1 && i2 !== -1) return i1 - i2;
        i1 = options.findIndex(function(o) {
            return $95a6d7b31882ddea$var$optionProperty(o) === p1;
        });
        i2 = options.findIndex(function(o) {
            return $95a6d7b31882ddea$var$optionProperty(o) === p2;
        });
        return i1 - i2;
    });
};
// Content is a separate component since it might be getting its form context
// from the DataForm rendered inside DataTableColumns.
var $95a6d7b31882ddea$var$Content = function Content(_ref) {
    var _theme$dataTableColum, _theme$dataTableColum2;
    var drop = _ref.drop, _ref$options = _ref.options, options = _ref$options === void 0 ? [] : _ref$options, activePanel = _ref.activePanel, rest = $95a6d7b31882ddea$var$_objectWithoutPropertiesLoose(_ref, $95a6d7b31882ddea$var$_excluded);
    var _useContext = (0, $95a6d7b31882ddea$var$_react.useContext)($932597a497e37de0$export$58d75f9829cbe158), dataId = _useContext.id, messages = _useContext.messages;
    var _useContext2 = (0, $95a6d7b31882ddea$var$_react.useContext)($5c9c2e034f522b3e$export$c24727297075ec6a), useFormInput = _useContext2.useFormInput;
    var _useContext3 = (0, $95a6d7b31882ddea$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext3.format;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var PinnedIcon = ((_theme$dataTableColum = theme.dataTableColumns) == null || (_theme$dataTableColum = _theme$dataTableColum.icons) == null ? void 0 : _theme$dataTableColum.pinned) || $a717426d13a4ad9f$export$5b9db7ce80343746;
    var SearchIcon = ((_theme$dataTableColum2 = theme.dataTableColumns) == null || (_theme$dataTableColum2 = _theme$dataTableColum2.icons) == null ? void 0 : _theme$dataTableColum2.search) || $ac084058cd06093e$export$4b85d3515bd863a5;
    var tabsProps = {
        drop: {
            pad: theme.dataTableColumns.tabs.pad
        },
        noDrop: {
            justify: 'start'
        }
    };
    // If the user searches for a particular option, render
    // the filtered list of options.
    var _useState = (0, $95a6d7b31882ddea$var$_react.useState)(''), search = _useState[0], setSearch = _useState[1];
    var _useState2 = (0, $95a6d7b31882ddea$var$_react.useState)(options), filteredOptions = _useState2[0], setFilteredOptions = _useState2[1];
    // Note whether options are objects so we can set up the *key properties
    // as needed when rendering.
    var objectOptions = (0, $95a6d7b31882ddea$var$_react.useMemo)(function() {
        return options && options.length && typeof options[0] === 'object';
    }, [
        options
    ]);
    var pinned = (0, $95a6d7b31882ddea$var$_react.useMemo)(function() {
        var items = objectOptions ? options.filter(function(option) {
            return option.pinned && option.label;
        }).map(function(option) {
            return option.label;
        }) : [];
        return items != null && items.length ? {
            background: 'none',
            color: 'text-weak',
            icon: /*#__PURE__*/ $95a6d7b31882ddea$var$_react["default"].createElement(PinnedIcon, null),
            items: items
        } : undefined;
    }, [
        options,
        objectOptions
    ]);
    // 'value' is an array of property names
    var _useFormInput = useFormInput({
        name: $3ad925e2d12764e5$export$6c37302973078e01,
        initialValue: $95a6d7b31882ddea$var$optionsToValue(options)
    }), value = _useFormInput[0], setValue = _useFormInput[1];
    // When the user searches, updated the filtered options based on the
    // search string.
    var onSearch = (0, $95a6d7b31882ddea$var$_react.useCallback)(function(nextSearch) {
        var nextFilteredOptions = options;
        if (nextSearch) {
            var lowerSearch = nextSearch.toLowerCase();
            nextFilteredOptions = options.filter(function(o) {
                var _ref2, _ref3, _o$label;
                return (_ref2 = (_ref3 = (_o$label = o.label) != null ? _o$label : o.property) != null ? _ref3 : o) == null ? void 0 : _ref2.toLowerCase().includes(lowerSearch);
            });
        }
        setSearch(nextSearch);
        setFilteredOptions(nextFilteredOptions);
    }, [
        options
    ]);
    var selectColumnsContent = /*#__PURE__*/ $95a6d7b31882ddea$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        pad: theme.dataTableColumns.selectColumns.pad,
        gap: theme.dataTableColumns.selectColumns.gap
    }, /*#__PURE__*/ $95a6d7b31882ddea$var$_react["default"].createElement($99c7a15bc083da62$export$c86715117507e8e5, {
        type: "search",
        icon: /*#__PURE__*/ $95a6d7b31882ddea$var$_react["default"].createElement(SearchIcon, null),
        placeholder: "Search",
        value: search,
        onChange: function onChange(event) {
            return onSearch(event.target.value);
        }
    }), /*#__PURE__*/ $95a6d7b31882ddea$var$_react["default"].createElement($d26ee9a4af4863b0$export$b6a68782c21a95ce, {
        id: dataId + "--select-columns",
        name: $3ad925e2d12764e5$export$6c37302973078e01,
        "aria-labelledby": dataId + "--select-columns-tab",
        options: filteredOptions,
        valueKey: objectOptions && 'property' || undefined,
        labelKey: objectOptions && 'label' || undefined,
        value: value,
        onChange: function onChange(_ref4) {
            var nextValue = _ref4.value;
            return setValue($95a6d7b31882ddea$var$alignOrder(nextValue, value, options));
        }
    }));
    var orderColumnsContent = /*#__PURE__*/ $95a6d7b31882ddea$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        pad: theme.dataTableColumns.orderColumns.pad
    }, /*#__PURE__*/ $95a6d7b31882ddea$var$_react["default"].createElement($0d1b8e621fb6c667$export$54c2e3dc7acea9f5, {
        id: dataId + "--order-columns",
        "aria-labelledby": dataId + "--order-columns-tab",
        data: value.map(function(v) {
            return objectOptions && options.find(function(o) {
                return o.property === v;
            }) || v;
        }),
        messages: {
            pinned: format({
                id: 'dataTableColumns.pinned',
                messages: messages == null ? void 0 : messages.dataTableColumns
            })
        },
        onOrder: function onOrder(nextData) {
            return setValue($95a6d7b31882ddea$var$optionsToValue(nextData));
        },
        pad: "none",
        primaryKey: objectOptions && 'label' || undefined,
        pinned: pinned
    }));
    var activeContent;
    if (activePanel) {
        if (activePanel === 'selectColumns') activeContent = selectColumnsContent;
        else if (activePanel === 'orderColumns') activeContent = orderColumnsContent;
        activeContent = /*#__PURE__*/ $95a6d7b31882ddea$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            pad: theme.dataTableColumns.tabs.pad
        }, /*#__PURE__*/ $95a6d7b31882ddea$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, null, activePanel === 'selectColumns' ? format({
            id: 'dataTableColumns.select',
            messages: messages == null ? void 0 : messages.dataTableColumns
        }) : format({
            id: 'dataTableColumns.order',
            messages: messages == null ? void 0 : messages.dataTableColumns
        })), activeContent);
    }
    return activeContent || /*#__PURE__*/ $95a6d7b31882ddea$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, null, /*#__PURE__*/ $95a6d7b31882ddea$var$_react["default"].createElement($fc47d46c0f08e384$export$b2539bed5023c21c, $95a6d7b31882ddea$var$_extends({}, tabsProps[drop ? 'drop' : 'noDrop'], rest), /*#__PURE__*/ $95a6d7b31882ddea$var$_react["default"].createElement($acdc1459df0949e1$export$3e41faf802a29e71, {
        id: dataId + "--select-columns-tab",
        title: format({
            id: 'dataTableColumns.select',
            messages: messages == null ? void 0 : messages.dataTableColumns
        }),
        "aria-label": format({
            id: 'dataTableColumns.selectAria',
            messages: messages == null ? void 0 : messages.dataTableColumns
        })
    }, selectColumnsContent), /*#__PURE__*/ $95a6d7b31882ddea$var$_react["default"].createElement($acdc1459df0949e1$export$3e41faf802a29e71, {
        id: dataId + "--order-columns-tab",
        "aria-label": format({
            id: 'dataTableColumns.orderAria',
            messages: messages == null ? void 0 : messages.dataTableColumns
        }),
        title: format({
            id: 'dataTableColumns.order',
            messages: messages == null ? void 0 : messages.dataTableColumns
        })
    }, orderColumnsContent)));
};
var $95a6d7b31882ddea$var$DataTableColumns = $95a6d7b31882ddea$export$ade1950b4d72969b = function DataTableColumns(_ref5) {
    var _theme$dataTableColum3, _theme$data$button;
    var drop = _ref5.drop, options = _ref5.options, activePanel = _ref5.activePanel, rest = $95a6d7b31882ddea$var$_objectWithoutPropertiesLoose(_ref5, $95a6d7b31882ddea$var$_excluded2);
    var _useContext4 = (0, $95a6d7b31882ddea$var$_react.useContext)($932597a497e37de0$export$58d75f9829cbe158), dataId = _useContext4.id, messages = _useContext4.messages;
    var _useContext5 = (0, $95a6d7b31882ddea$var$_react.useContext)($b1a512ff039be377$export$e2b284ce8e93d8eb), inDataForm = _useContext5.inDataForm;
    var _useContext6 = (0, $95a6d7b31882ddea$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext6.format;
    var _useThemeValue2 = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue2.theme;
    var _useState3 = (0, $95a6d7b31882ddea$var$_react.useState)(), showContent = _useState3[0], setShowContent = _useState3[1];
    var ControlIcon = ((_theme$dataTableColum3 = theme.dataTableColumns) == null || (_theme$dataTableColum3 = _theme$dataTableColum3.icons) == null ? void 0 : _theme$dataTableColum3.control) || $02934120194f172d$export$ef2f09e23a44828b;
    var tip = format({
        id: 'dataTableColumns.tip',
        messages: messages == null ? void 0 : messages.dataTableColumns
    });
    var content = /*#__PURE__*/ $95a6d7b31882ddea$var$_react["default"].createElement($95a6d7b31882ddea$var$Content, {
        drop: drop,
        options: options,
        activePanel: activePanel
    });
    if (!inDataForm) content = /*#__PURE__*/ $95a6d7b31882ddea$var$_react["default"].createElement($3ad925e2d12764e5$export$dcf38ffba6c01577, {
        footer: false,
        updateOn: "change"
    }, content);
    if (!drop) return content;
    var control = /*#__PURE__*/ $95a6d7b31882ddea$var$_react["default"].createElement($d7e2a556593dc38b$export$64fff40e709e8b2e, $95a6d7b31882ddea$var$_extends({
        id: dataId + "--columns-control",
        "aria-label": format({
            id: 'dataTableColumns.open',
            messages: messages == null ? void 0 : messages.dataTableColumns
        }),
        kind: (_theme$data$button = theme.data.button) == null ? void 0 : _theme$data$button.kind,
        icon: /*#__PURE__*/ $95a6d7b31882ddea$var$_react["default"].createElement(ControlIcon, null),
        tip: tip,
        dropProps: $95a6d7b31882ddea$var$dropProps,
        dropContent: content,
        open: showContent,
        onOpen: function onOpen() {
            return setShowContent(undefined);
        },
        onClose: function onClose() {
            return setShowContent(undefined);
        }
    }, rest));
    return control;
};
$95a6d7b31882ddea$var$DataTableColumns.propTypes = $679c0a183e38ad08$export$8c8e7715b681118f;


$072c4c38bf436507$export$ade1950b4d72969b = $95a6d7b31882ddea$export$ade1950b4d72969b;


Object.keys($072c4c38bf436507$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $072c4c38bf436507$exports[key]) return;
    $3321243da0932e1e$exports[key] = $072c4c38bf436507$exports[key];
});
var $e7ef25f557a83710$exports = {};

$parcel$export($e7ef25f557a83710$exports, "__esModule", function () { return $e7ef25f557a83710$export$1e511d4a378977f5; }, function (v) { return $e7ef25f557a83710$export$1e511d4a378977f5 = v; });
$parcel$export($e7ef25f557a83710$exports, "DataTableGroupBy", function () { return $e7ef25f557a83710$export$955f9bf4737af80a; }, function (v) { return $e7ef25f557a83710$export$955f9bf4737af80a = v; });
var $e7ef25f557a83710$export$1e511d4a378977f5;
var $e7ef25f557a83710$export$955f9bf4737af80a;
"use strict";
$e7ef25f557a83710$export$1e511d4a378977f5 = true;
$e7ef25f557a83710$export$955f9bf4737af80a = void 0;
var $8b62d4e5bc1ceb51$export$1e511d4a378977f5;
var $8b62d4e5bc1ceb51$export$955f9bf4737af80a;
"use strict";
$8b62d4e5bc1ceb51$export$1e511d4a378977f5 = true;
$8b62d4e5bc1ceb51$export$955f9bf4737af80a = void 0;

var $8b62d4e5bc1ceb51$var$_react = $8b62d4e5bc1ceb51$var$_interopRequireWildcard((parcelRequire("2xPiy")));






var $753bdb39d983b9e2$export$1e511d4a378977f5;
var $753bdb39d983b9e2$export$23f1337f653734a4;
"use strict";
$753bdb39d983b9e2$export$1e511d4a378977f5 = true;
$753bdb39d983b9e2$export$23f1337f653734a4 = void 0;

var $753bdb39d983b9e2$var$_propTypes = $753bdb39d983b9e2$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $753bdb39d983b9e2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $753bdb39d983b9e2$var$PropType = {};
$753bdb39d983b9e2$var$PropType = {
    options: $753bdb39d983b9e2$var$_propTypes["default"].oneOfType([
        $753bdb39d983b9e2$var$_propTypes["default"].arrayOf($753bdb39d983b9e2$var$_propTypes["default"].string),
        $753bdb39d983b9e2$var$_propTypes["default"].arrayOf($753bdb39d983b9e2$var$_propTypes["default"].shape({
            label: $753bdb39d983b9e2$var$_propTypes["default"].string,
            property: $753bdb39d983b9e2$var$_propTypes["default"].string
        }))
    ])
};
var $753bdb39d983b9e2$var$DataTableGroupByPropTypes = $753bdb39d983b9e2$export$23f1337f653734a4 = $753bdb39d983b9e2$var$PropType;


var $8b62d4e5bc1ceb51$var$_excluded = [
    "id",
    "options"
];
function $8b62d4e5bc1ceb51$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($8b62d4e5bc1ceb51$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $8b62d4e5bc1ceb51$var$_extends() {
    return $8b62d4e5bc1ceb51$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8b62d4e5bc1ceb51$var$_extends.apply(null, arguments);
}
function $8b62d4e5bc1ceb51$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $8b62d4e5bc1ceb51$var$DataTableGroupBy = $8b62d4e5bc1ceb51$export$955f9bf4737af80a = function DataTableGroupBy(_ref) {
    var idProp = _ref.id, options = _ref.options, rest = $8b62d4e5bc1ceb51$var$_objectWithoutPropertiesLoose(_ref, $8b62d4e5bc1ceb51$var$_excluded);
    var _useContext = (0, $8b62d4e5bc1ceb51$var$_react.useContext)($932597a497e37de0$export$58d75f9829cbe158), dataId = _useContext.id, messages = _useContext.messages, view = _useContext.view, addToolbarKey = _useContext.addToolbarKey;
    var _useContext2 = (0, $8b62d4e5bc1ceb51$var$_react.useContext)($b1a512ff039be377$export$e2b284ce8e93d8eb), inDataForm = _useContext2.inDataForm;
    var _useContext3 = (0, $8b62d4e5bc1ceb51$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext3.format;
    var id = idProp || dataId + "--groupby";
    (0, $8b62d4e5bc1ceb51$var$_react.useEffect)(function() {
        if (!inDataForm) addToolbarKey('_groupBy');
    }, [
        addToolbarKey,
        inDataForm
    ]);
    if (!options) return null;
    var content = /*#__PURE__*/ $8b62d4e5bc1ceb51$var$_react["default"].createElement($c692f0029c94fbb2$export$ef9b1a59e592288f, $8b62d4e5bc1ceb51$var$_extends({
        id: id,
        name: "_groupBy",
        showSelectedInline: true,
        placeholder: !inDataForm ? 'Group by' : undefined,
        options: options,
        labelKey: "label",
        clear: view != null && view.groupBy ? {
            position: 'top',
            label: format({
                id: 'dataTableGroupBy.clear',
                messages: messages == null ? void 0 : messages.dataTableGroupBy
            })
        } : undefined,
        value: view == null ? void 0 : view.groupBy
    }, rest));
    if (!inDataForm) // likely in Toolbar
    content = /*#__PURE__*/ $8b62d4e5bc1ceb51$var$_react["default"].createElement($46eb34c25d0c5f74$export$dcf38ffba6c01577, {
        footer: false,
        updateOn: "change"
    }, content);
    else content = /*#__PURE__*/ $8b62d4e5bc1ceb51$var$_react["default"].createElement($af5ba9f7873798c6$export$56e87bf42978147a, {
        htmlFor: id,
        label: format({
            id: 'dataTableGroupBy.label',
            messages: messages == null ? void 0 : messages.dataTableGroupBy
        })
    }, content);
    return content;
};
$8b62d4e5bc1ceb51$var$DataTableGroupBy.propTypes = $753bdb39d983b9e2$export$23f1337f653734a4;


$e7ef25f557a83710$export$955f9bf4737af80a = $8b62d4e5bc1ceb51$export$955f9bf4737af80a;


Object.keys($e7ef25f557a83710$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $e7ef25f557a83710$exports[key]) return;
    $3321243da0932e1e$exports[key] = $e7ef25f557a83710$exports[key];
});

Object.keys($fd9964856b517b7a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $fd9964856b517b7a$exports[key]) return;
    $3321243da0932e1e$exports[key] = $fd9964856b517b7a$exports[key];
});
var $b921a35fe79f8af7$exports = {};

$parcel$export($b921a35fe79f8af7$exports, "__esModule", function () { return $b921a35fe79f8af7$export$1e511d4a378977f5; }, function (v) { return $b921a35fe79f8af7$export$1e511d4a378977f5 = v; });
$parcel$export($b921a35fe79f8af7$exports, "DateInput", function () { return $b921a35fe79f8af7$export$7edc06cf1783b30f; }, function (v) { return $b921a35fe79f8af7$export$7edc06cf1783b30f = v; });
var $b921a35fe79f8af7$export$1e511d4a378977f5;
var $b921a35fe79f8af7$export$7edc06cf1783b30f;
"use strict";
$b921a35fe79f8af7$export$1e511d4a378977f5 = true;
$b921a35fe79f8af7$export$7edc06cf1783b30f = void 0;
var $42d21222a350a303$export$1e511d4a378977f5;
var $42d21222a350a303$export$7edc06cf1783b30f;
"use strict";
$42d21222a350a303$export$1e511d4a378977f5 = true;
$42d21222a350a303$export$7edc06cf1783b30f = void 0;

var $42d21222a350a303$var$_react = $42d21222a350a303$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $42d21222a350a303$var$_styledComponents = $42d21222a350a303$var$_interopRequireDefault((parcelRequire("iA1nz")));










var $0c17f9d155734634$exports = {};

$parcel$export($0c17f9d155734634$exports, "__esModule", function () { return $0c17f9d155734634$export$1e511d4a378977f5; }, function (v) { return $0c17f9d155734634$export$1e511d4a378977f5 = v; });
$parcel$export($0c17f9d155734634$exports, "MaskedInput", function () { return $0c17f9d155734634$export$dec03dc0f3ef8025; }, function (v) { return $0c17f9d155734634$export$dec03dc0f3ef8025 = v; });
var $0c17f9d155734634$export$1e511d4a378977f5;
var $0c17f9d155734634$export$dec03dc0f3ef8025;
"use strict";
$0c17f9d155734634$export$1e511d4a378977f5 = true;
$0c17f9d155734634$export$dec03dc0f3ef8025 = void 0;
var $4c071cd526cca19d$export$1e511d4a378977f5;
var $4c071cd526cca19d$export$dec03dc0f3ef8025;
"use strict";
$4c071cd526cca19d$export$1e511d4a378977f5 = true;
$4c071cd526cca19d$export$dec03dc0f3ef8025 = void 0;

var $4c071cd526cca19d$var$_react = $4c071cd526cca19d$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $4c071cd526cca19d$var$_styledComponents = $4c071cd526cca19d$var$_interopRequireDefault((parcelRequire("iA1nz")));






var $b5f76be92b9db15d$export$1e511d4a378977f5;
var $b5f76be92b9db15d$export$a3c8b952c846e4b1;
var $b5f76be92b9db15d$export$3b982a63cbad39fd;
var $b5f76be92b9db15d$export$7c8f159da0dc916;
"use strict";
$b5f76be92b9db15d$export$1e511d4a378977f5 = true;
$b5f76be92b9db15d$export$a3c8b952c846e4b1 = $b5f76be92b9db15d$export$3b982a63cbad39fd = $b5f76be92b9db15d$export$7c8f159da0dc916 = void 0;

var $b5f76be92b9db15d$var$_styledComponents = $b5f76be92b9db15d$var$_interopRequireDefault((parcelRequire("iA1nz")));


function $b5f76be92b9db15d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $b5f76be92b9db15d$var$StyledMaskedInput = $b5f76be92b9db15d$export$3b982a63cbad39fd = $b5f76be92b9db15d$var$_styledComponents["default"].input.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledMaskedInput",
    componentId: "sc-99vkfa-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    " ",
    ";"
], $4113023f9e0bafa0$exports.inputStyle, function(props) {
    return props.plain && $4113023f9e0bafa0$exports.plainInputStyle;
}, function(props) {
    return props.icon && $9a7099e779e83517$export$cd595fd57f72dbc4;
}, function(props) {
    return props.disabled && (0, $4113023f9e0bafa0$exports.disabledStyle)(props.theme.maskedInput.disabled && props.theme.maskedInput.disabled.opacity);
}, function(props) {
    return props.textAlign && $4113023f9e0bafa0$exports.textAlignStyle;
}, function(props) {
    return props.theme.maskedInput && props.theme.maskedInput.extend;
});
var $b5f76be92b9db15d$var$StyledMaskedInputContainer = $b5f76be92b9db15d$export$a3c8b952c846e4b1 = $b5f76be92b9db15d$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledMaskedInput__StyledMaskedInputContainer",
    componentId: "sc-99vkfa-1"
})([
    "position:relative;width:100%;",
    ";"
], function(props) {
    return props.theme.maskedInput && props.theme.maskedInput.container && props.theme.maskedInput.container.extend;
});
var $b5f76be92b9db15d$var$StyledIcon = $b5f76be92b9db15d$export$7c8f159da0dc916 = $b5f76be92b9db15d$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledMaskedInput__StyledIcon",
    componentId: "sc-99vkfa-2"
})([
    "position:absolute;display:flex;justify:center;top:50%;transform:translateY(-50%);pointer-events:none;",
    ""
], function(props) {
    return props.reverse ? "right: " + (0, $4113023f9e0bafa0$exports.getInputPadBySide)(props, 'right') + ";" : "left: " + (0, $4113023f9e0bafa0$exports.getInputPadBySide)(props, 'left') + ";";
});


var $9c4e133b0332e756$export$1e511d4a378977f5;
var $9c4e133b0332e756$export$2bbcb24fb0cd855c;
"use strict";
$9c4e133b0332e756$export$1e511d4a378977f5 = true;
$9c4e133b0332e756$export$2bbcb24fb0cd855c = void 0;

var $9c4e133b0332e756$var$_propTypes = $9c4e133b0332e756$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $9c4e133b0332e756$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $9c4e133b0332e756$var$PropType = {};
$9c4e133b0332e756$var$PropType = {
    a11yTitle: $9c4e133b0332e756$var$_propTypes["default"].string,
    dropHeight: $9c4e133b0332e756$var$_propTypes["default"].oneOfType([
        $9c4e133b0332e756$var$_propTypes["default"].oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        $9c4e133b0332e756$var$_propTypes["default"].string
    ]),
    dropProps: $9c4e133b0332e756$var$_propTypes["default"].object,
    icon: $9c4e133b0332e756$var$_propTypes["default"].element,
    id: $9c4e133b0332e756$var$_propTypes["default"].string,
    name: $9c4e133b0332e756$var$_propTypes["default"].string,
    onChange: $9c4e133b0332e756$var$_propTypes["default"].func,
    focusIndicator: $9c4e133b0332e756$var$_propTypes["default"].bool,
    onBlur: $9c4e133b0332e756$var$_propTypes["default"].func,
    mask: $9c4e133b0332e756$var$_propTypes["default"].arrayOf($9c4e133b0332e756$var$_propTypes["default"].shape({
        length: $9c4e133b0332e756$var$_propTypes["default"].oneOfType([
            $9c4e133b0332e756$var$_propTypes["default"].number,
            $9c4e133b0332e756$var$_propTypes["default"].arrayOf($9c4e133b0332e756$var$_propTypes["default"].number)
        ]),
        fixed: $9c4e133b0332e756$var$_propTypes["default"].string,
        options: $9c4e133b0332e756$var$_propTypes["default"].arrayOf($9c4e133b0332e756$var$_propTypes["default"].oneOfType([
            $9c4e133b0332e756$var$_propTypes["default"].string,
            $9c4e133b0332e756$var$_propTypes["default"].number
        ])),
        restrictToOptions: $9c4e133b0332e756$var$_propTypes["default"].bool,
        regexp: $9c4e133b0332e756$var$_propTypes["default"].shape({}) // RegExp
    })),
    reverse: $9c4e133b0332e756$var$_propTypes["default"].bool,
    size: $9c4e133b0332e756$var$_propTypes["default"].oneOfType([
        $9c4e133b0332e756$var$_propTypes["default"].oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            'xxlarge',
            '2xl',
            '3xl',
            '4xl',
            '5xl',
            '6xl'
        ]),
        $9c4e133b0332e756$var$_propTypes["default"].string
    ]),
    textAlign: $9c4e133b0332e756$var$_propTypes["default"].oneOf([
        'start',
        'center',
        'end'
    ]),
    value: $9c4e133b0332e756$var$_propTypes["default"].oneOfType([
        $9c4e133b0332e756$var$_propTypes["default"].string,
        $9c4e133b0332e756$var$_propTypes["default"].number
    ])
};
var $9c4e133b0332e756$var$MaskedInputPropTypes = $9c4e133b0332e756$export$2bbcb24fb0cd855c = $9c4e133b0332e756$var$PropType;



var $4c071cd526cca19d$var$_excluded = [
    "a11yTitle",
    "dropHeight",
    "dropProps",
    "focus",
    "focusIndicator",
    "icon",
    "id",
    "mask",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onKeyDown",
    "placeholder",
    "plain",
    "reverse",
    "textAlign",
    "value"
];
function $4c071cd526cca19d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $4c071cd526cca19d$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($4c071cd526cca19d$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $4c071cd526cca19d$var$_extends() {
    return $4c071cd526cca19d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4c071cd526cca19d$var$_extends.apply(null, arguments);
}
function $4c071cd526cca19d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $4c071cd526cca19d$var$parseValue = function parseValue(mask, value) {
    // break the value up into mask parts
    var valueParts = []; // { part, beginIndex, endIndex }
    var valueIndex = 0;
    var maskIndex = 0;
    while(value !== undefined && valueIndex < value.length && maskIndex < mask.length){
        var item = mask[maskIndex];
        var found = void 0;
        if (item.fixed) {
            var length = item.fixed.length;
            // grab however much of value (starting at valueIndex) matches
            // item.fixed. If none matches it and there is more in value
            // add in the fixed item.
            var matching = 0;
            while(matching < length && value[valueIndex + matching] === item.fixed[matching])matching += 1;
            if (matching > 0) {
                var part = value.slice(valueIndex, valueIndex + matching);
                if (valueIndex + matching < value.length) // matched part of the fixed portion but there's more stuff
                // after it. Go ahead and fill in the entire fixed chunk
                part = item.fixed;
                valueParts.push({
                    part: part,
                    beginIndex: valueIndex,
                    endIndex: valueIndex + matching - 1
                });
                valueIndex += matching;
            } else valueParts.push({
                part: item.fixed,
                beginIndex: valueIndex,
                endIndex: valueIndex + length - 1
            });
            maskIndex += 1;
            found = true;
        } else if (item.options && item.restrictToOptions !== false) // reverse assuming larger is later
        found = item.options.slice(0).reverse()// eslint-disable-next-line no-loop-func
        .some(function(option) {
            var length = option.length;
            var part = value.slice(valueIndex, valueIndex + length);
            if (part === option) {
                valueParts.push({
                    part: part,
                    beginIndex: valueIndex,
                    endIndex: valueIndex + length - 1
                });
                valueIndex += length;
                maskIndex += 1;
                return true;
            }
            return false;
        });
        if (!found) {
            if (item.regexp) {
                var minLength = Array.isArray(item.length) && item.length[0] || item.length || 1;
                var maxLength = Array.isArray(item.length) && item.length[1] || item.length || value.length - valueIndex;
                var _length = maxLength;
                while(!found && _length >= minLength){
                    var _part = value.slice(valueIndex, valueIndex + _length);
                    if (item.regexp.test(_part)) {
                        valueParts.push({
                            part: _part,
                            beginIndex: valueIndex,
                            endIndex: valueIndex + _length - 1
                        });
                        valueIndex += _length;
                        maskIndex += 1;
                        found = true;
                    }
                    _length -= 1;
                }
                if (!found) valueIndex = value.length;
            } else {
                var _length2 = Array.isArray(item.length) ? item.length[1] : item.length || value.length - valueIndex;
                var _part2 = value.slice(valueIndex, valueIndex + _length2);
                valueParts.push({
                    part: _part2,
                    beginIndex: valueIndex,
                    endIndex: valueIndex + _length2 - 1
                });
                valueIndex += _length2;
                maskIndex += 1;
            }
        }
    }
    return valueParts;
};
var $4c071cd526cca19d$var$defaultMask = [
    {
        regexp: /[^]*/
    }
];
var $4c071cd526cca19d$var$ContainerBox = (0, $4c071cd526cca19d$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "MaskedInput__ContainerBox",
    componentId: "sc-af8hzu-0"
})([
    "",
    ";"
], function(props) {
    return props.dropHeight ? (0, $4113023f9e0bafa0$exports.sizeStyle)('max-height', props.dropHeight, props.theme) : 'max-height: inherit;';
});
var $4c071cd526cca19d$var$dropAlign = {
    top: 'bottom',
    left: 'left'
};
var $4c071cd526cca19d$var$MaskedInput = $4c071cd526cca19d$export$dec03dc0f3ef8025 = /*#__PURE__*/ (0, $4c071cd526cca19d$var$_react.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, dropHeight = _ref.dropHeight, dropProps = _ref.dropProps, focusProp = _ref.focus, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, icon = _ref.icon, id = _ref.id, _ref$mask = _ref.mask, mask = _ref$mask === void 0 ? $4c071cd526cca19d$var$defaultMask : _ref$mask, name = _ref.name, _onBlur = _ref.onBlur, onChange = _ref.onChange, _onFocus = _ref.onFocus, onKeyDown = _ref.onKeyDown, placeholder = _ref.placeholder, plain = _ref.plain, reverse = _ref.reverse, textAlign = _ref.textAlign, valueProp = _ref.value, rest = $4c071cd526cca19d$var$_objectWithoutPropertiesLoose(_ref, $4c071cd526cca19d$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var formContext = (0, $4c071cd526cca19d$var$_react.useContext)($5c9c2e034f522b3e$export$c24727297075ec6a);
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp,
        initialValue: ''
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    var valueParts = (0, $4c071cd526cca19d$var$_react.useMemo)(function() {
        return $4c071cd526cca19d$var$parseValue(mask, value);
    }, [
        mask,
        value
    ]);
    var inputRef = (0, $4113023f9e0bafa0$exports.useForwardedRef)(ref);
    var dropRef = (0, $4c071cd526cca19d$var$_react.useRef)();
    // Caller's ref, if provided
    var _useState = (0, $4c071cd526cca19d$var$_react.useState)(), dropPropsTarget = _useState[0], setDropPropsTarget = _useState[1];
    (0, $4c071cd526cca19d$var$_react.useEffect)(function() {
        var nextDropPropsTarget;
        // If caller provided a ref, set to 'pending' until ref.current is defined
        if (dropProps && 'target' in dropProps) {
            nextDropPropsTarget = dropProps.target || 'pending';
            setDropPropsTarget(nextDropPropsTarget);
        }
    }, [
        dropProps
    ]);
    var _useState2 = (0, $4c071cd526cca19d$var$_react.useState)(focusProp), focus = _useState2[0], setFocus = _useState2[1];
    var _useState3 = (0, $4c071cd526cca19d$var$_react.useState)(), activeMaskIndex = _useState3[0], setActiveMaskIndex = _useState3[1];
    var _useState4 = (0, $4c071cd526cca19d$var$_react.useState)(), activeOptionIndex = _useState4[0], setActiveOptionIndex = _useState4[1];
    var _useState5 = (0, $4c071cd526cca19d$var$_react.useState)(), showDrop = _useState5[0], setShowDrop = _useState5[1];
    (0, $4c071cd526cca19d$var$_react.useEffect)(function() {
        if (focus) {
            var timer = setTimeout(function() {
                // determine which mask element the caret is at
                var caretIndex = inputRef.current.selectionStart;
                var maskIndex;
                valueParts.some(function(part, index) {
                    if (part.beginIndex <= caretIndex && part.endIndex >= caretIndex) {
                        maskIndex = index;
                        return true;
                    }
                    return false;
                });
                if (maskIndex === undefined && valueParts.length < mask.length) maskIndex = valueParts.length; // first unused one
                if (maskIndex && mask[maskIndex].fixed) maskIndex -= 1; // fixed mask parts are never "active"
                if (maskIndex !== activeMaskIndex) {
                    setActiveMaskIndex(maskIndex);
                    setActiveOptionIndex(-1);
                    setShowDrop(maskIndex >= 0 && mask[maskIndex].options && true);
                }
            }, 10); // 10ms empirically chosen
            return function() {
                return clearTimeout(timer);
            };
        }
        return undefined;
    }, [
        activeMaskIndex,
        focus,
        inputRef,
        mask,
        valueParts
    ]);
    var setInputValue = (0, $4c071cd526cca19d$var$_react.useCallback)(function(nextValue) {
        // Calling set value function directly on input because React library
        // overrides setter `event.target.value =` and loses original event
        // target fidelity.
        // https://stackoverflow.com/a/46012210 &&
        // https://github.com/grommet/grommet/pull/3171#discussion_r296415239
        var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
        nativeInputValueSetter.call(inputRef.current, nextValue);
        var event = new Event('input', {
            bubbles: true
        });
        inputRef.current.dispatchEvent(event);
    }, [
        inputRef
    ]);
    var _useState6 = (0, $4c071cd526cca19d$var$_react.useState)(), mouseMovedSinceLastKey = _useState6[0], setMouseMovedSinceLastKey = _useState6[1];
    // This could be due to a paste or as the user is typing.
    var onChangeInput = (0, $4c071cd526cca19d$var$_react.useCallback)(function(event) {
        var eventValue = event.target.value;
        // Align with the mask.
        var nextValueParts = $4c071cd526cca19d$var$parseValue(mask, eventValue);
        var nextValue = nextValueParts.map(function(part) {
            return part.part;
        }).join('');
        if (nextValue !== eventValue) {
            // The mask adjusted the next value. If something was added,
            // the value must be valid. Change the actual input value
            // to correspond.
            // This will re-trigger this callback with the next value.
            if (nextValue.length > eventValue.length) setInputValue(nextValue);
            else if (value && eventValue.length < value.length) {
                // If the user is removing characters, preserve what the
                // user is working on.
                setValue(eventValue);
                if (onChange) onChange(event);
            } else // If the user is adding invalid characters, don't allow it.
            // Revert to the prior value.
            setInputValue(value);
        } else if (value !== nextValue) {
            setValue(nextValue);
            if (onChange) onChange(event);
        }
    }, [
        mask,
        onChange,
        setInputValue,
        setValue,
        value
    ]);
    var onOption = (0, $4c071cd526cca19d$var$_react.useCallback)(function(option) {
        return function() {
            var nextValueParts = [].concat(valueParts);
            nextValueParts[activeMaskIndex] = {
                part: option
            };
            // add any fixed parts that follow
            var index = activeMaskIndex + 1;
            while(index < mask.length && !nextValueParts[index] && mask[index].fixed){
                nextValueParts[index] = {
                    part: mask[index].fixed
                };
                index += 1;
            }
            var nextValue = nextValueParts.map(function(part) {
                return part.part;
            }).join('');
            setInputValue(nextValue);
            // restore focus to input
            inputRef.current.focus();
        };
    }, [
        activeMaskIndex,
        inputRef,
        mask,
        setInputValue,
        valueParts
    ]);
    var onNextOption = (0, $4c071cd526cca19d$var$_react.useCallback)(function(event) {
        var item = mask[activeMaskIndex];
        if (item && item.options) {
            event.preventDefault();
            var index = Math.min(activeOptionIndex + 1, item.options.length - 1);
            setMouseMovedSinceLastKey(false);
            setActiveOptionIndex(index);
        }
    }, [
        activeMaskIndex,
        activeOptionIndex,
        mask
    ]);
    var onPreviousOption = (0, $4c071cd526cca19d$var$_react.useCallback)(function(event) {
        if (activeMaskIndex >= 0 && mask[activeMaskIndex].options) {
            event.preventDefault();
            var index = Math.max(activeOptionIndex - 1, 0);
            setMouseMovedSinceLastKey(false);
            setActiveOptionIndex(index);
        }
    }, [
        activeMaskIndex,
        activeOptionIndex,
        mask
    ]);
    var onSelectOption = (0, $4c071cd526cca19d$var$_react.useCallback)(function(event) {
        if (activeMaskIndex >= 0 && activeOptionIndex >= 0) {
            event.preventDefault();
            var option = mask[activeMaskIndex].options[activeOptionIndex];
            onOption(option)();
        }
    }, [
        activeMaskIndex,
        activeOptionIndex,
        mask,
        onOption
    ]);
    var onEsc = (0, $4c071cd526cca19d$var$_react.useCallback)(function(event) {
        if (showDrop) {
            // we have to stop both synthetic events and native events
            // drop and layer should not close by pressing esc on this input
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();
            setShowDrop(false);
        }
    }, [
        showDrop
    ]);
    var onHideDrop = (0, $4c071cd526cca19d$var$_react.useCallback)(function() {
        return setShowDrop(false);
    }, []);
    var renderPlaceholder = function renderPlaceholder() {
        return mask.map(function(item) {
            return item.placeholder || item.fixed;
        }).join('');
    };
    var maskedInputIcon = (0, $4113023f9e0bafa0$exports.useSizedIcon)(icon, rest.size, theme);
    /*
  If the masked input has a list of options, add the WAI-ARIA 1.2
  combobox role and states.
  */ var comboboxProps = {};
    var activeOptionID;
    var options = (0, $4c071cd526cca19d$var$_react.useMemo)(function() {
        var _mask$find, _mask$activeMaskIndex;
        var res;
        if (!activeMaskIndex) // ensures that comboboxProps gets set on input initially
        res = (_mask$find = mask.find(function(item) {
            var _item$options;
            return (item == null || (_item$options = item.options) == null ? void 0 : _item$options.length) > 0;
        })) == null ? void 0 : _mask$find.options;
        else res = (_mask$activeMaskIndex = mask[activeMaskIndex]) == null ? void 0 : _mask$activeMaskIndex.options;
        return res;
    }, [
        mask,
        activeMaskIndex
    ]);
    if (id && (options == null ? void 0 : options.length) > 0) {
        if (showDrop && options) activeOptionID = "listbox-option-" + activeOptionIndex + "__" + id;
        comboboxProps = {
            'aria-activedescendant': activeOptionID,
            'aria-autocomplete': 'list',
            'aria-expanded': showDrop ? 'true' : 'false',
            'aria-controls': showDrop ? "listbox__" + id : undefined,
            role: 'combobox'
        };
    }
    return /*#__PURE__*/ $4c071cd526cca19d$var$_react["default"].createElement($b5f76be92b9db15d$export$a3c8b952c846e4b1, $4c071cd526cca19d$var$_extends({
        plain: plain,
        onMouseMove: function onMouseMove() {
            return setMouseMovedSinceLastKey(true);
        }
    }, passThemeFlag), maskedInputIcon && /*#__PURE__*/ $4c071cd526cca19d$var$_react["default"].createElement($b5f76be92b9db15d$export$7c8f159da0dc916, {
        reverse: reverse,
        theme: theme
    }, maskedInputIcon), /*#__PURE__*/ $4c071cd526cca19d$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onEsc: onEsc,
        onTab: showDrop ? function() {
            return setShowDrop(false);
        } : undefined,
        onLeft: undefined,
        onRight: undefined,
        onUp: onPreviousOption,
        onDown: showDrop ? onNextOption : function() {
            return setShowDrop(true);
        },
        onEnter: onSelectOption,
        onKeyDown: onKeyDown
    }, /*#__PURE__*/ $4c071cd526cca19d$var$_react["default"].createElement($b5f76be92b9db15d$export$3b982a63cbad39fd, $4c071cd526cca19d$var$_extends({
        ref: inputRef,
        "aria-label": a11yTitle,
        id: id,
        name: name,
        autoComplete: "off",
        focusIndicator: focusIndicator,
        plain: plain,
        placeholder: placeholder || renderPlaceholder(),
        icon: icon,
        reverse: reverse,
        focus: focus,
        textAlign: textAlign
    }, comboboxProps, rest, {
        value: value,
        theme: theme,
        onFocus: function onFocus(event) {
            setFocus(true);
            setShowDrop(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            // This will be called when the user clicks on a suggestion,
            // check for that and don't remove the drop in that case.
            // Drop will already have removed itself if the user has focused
            // outside of the Drop.
            if (!dropRef.current) setShowDrop(false);
            if (_onBlur) _onBlur(event);
        },
        onChange: onChangeInput
    }))), showDrop && mask[activeMaskIndex] && mask[activeMaskIndex].options && // If caller has specified dropProps.target, ensure target is defined
    dropPropsTarget !== 'pending' && /*#__PURE__*/ $4c071cd526cca19d$var$_react["default"].createElement($9097252a6690f3a9$export$aaa698cd7aa517d6, $4c071cd526cca19d$var$_extends({
        id: id ? "masked-input-drop__" + id : undefined,
        align: $4c071cd526cca19d$var$dropAlign,
        responsive: false,
        target: inputRef.current,
        onClickOutside: onHideDrop,
        onEsc: onHideDrop,
        trapFocus: false
    }, dropProps), /*#__PURE__*/ $4c071cd526cca19d$var$_react["default"].createElement($4c071cd526cca19d$var$ContainerBox, $4c071cd526cca19d$var$_extends({
        ref: dropRef,
        overflow: "auto",
        id: id ? "listbox__" + id : undefined,
        role: "listbox",
        dropHeight: dropHeight,
        onMouseOver: function onMouseOver() {
            return setMouseMovedSinceLastKey(true);
        }
    }, passThemeFlag), mask[activeMaskIndex].options.map(function(option, index) {
        // Determine whether the label is done as a child or
        // as an option Button kind property.
        var child = !theme.button.option ? /*#__PURE__*/ // Not adding a theme object now because this code path
        // is not used in the HPE theme, but we may add theme
        // support here in the future.
        $4c071cd526cca19d$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            pad: {
                horizontal: 'small',
                vertical: 'xsmall'
            }
        }, option) : undefined;
        // if we have a child, turn on plain, and hoverIndicator
        return /*#__PURE__*/ $4c071cd526cca19d$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            key: option,
            flex: false
        }, /*#__PURE__*/ $4c071cd526cca19d$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
            id: id ? "listbox-option-" + index + "__" + id : undefined,
            tabIndex: "-1",
            onClick: onOption(option),
            onMouseOver: function onMouseOver() {
                return setActiveOptionIndex(index);
            },
            onFocus: function onFocus() {},
            active: index === activeOptionIndex,
            plain: !child ? undefined : true,
            align: "start",
            kind: !child ? 'option' : undefined,
            hoverIndicator: !child ? undefined : 'background',
            label: !child ? option : undefined,
            keyboard: !mouseMovedSinceLastKey
        }, child));
    }))));
});
$4c071cd526cca19d$var$MaskedInput.displayName = 'MaskedInput';
$4c071cd526cca19d$var$MaskedInput.propTypes = $9c4e133b0332e756$export$2bbcb24fb0cd855c;


$0c17f9d155734634$export$dec03dc0f3ef8025 = $4c071cd526cca19d$export$dec03dc0f3ef8025;




var $99386f30db1339e0$export$1e511d4a378977f5;
var $99386f30db1339e0$export$45491dafa4524293;
var $99386f30db1339e0$export$a1f20cd55d4f0f56;
var $99386f30db1339e0$export$51e58a02740fe411;
var $99386f30db1339e0$export$60c3f5dffac76ccb;
var $99386f30db1339e0$export$9235b47e9363044;
var $99386f30db1339e0$export$42f432bed9bbfa4a;
"use strict";
$99386f30db1339e0$export$1e511d4a378977f5 = true;
$99386f30db1339e0$export$45491dafa4524293 = $99386f30db1339e0$export$a1f20cd55d4f0f56 = $99386f30db1339e0$export$51e58a02740fe411 = $99386f30db1339e0$export$60c3f5dffac76ccb = $99386f30db1339e0$export$9235b47e9363044 = $99386f30db1339e0$export$42f432bed9bbfa4a = void 0;


function $99386f30db1339e0$var$_construct(t, e, r) {
    if ($99386f30db1339e0$var$_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $99386f30db1339e0$var$_setPrototypeOf(p, r.prototype), p;
}
function $99386f30db1339e0$var$_setPrototypeOf(t, e) {
    return $99386f30db1339e0$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $99386f30db1339e0$var$_setPrototypeOf(t, e);
}
function $99386f30db1339e0$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($99386f30db1339e0$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $99386f30db1339e0$var$_extends() {
    return $99386f30db1339e0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $99386f30db1339e0$var$_extends.apply(null, arguments);
}
// Converting between Date and String types is handled via a "schema".
// The schema is an array of strings, split into strings with identical
// characters. So, 'mm/dd/yyyy' will be ['mm', '/', 'dd', '/', 'yyyyy'].
var $99386f30db1339e0$var$formatToSchema = $99386f30db1339e0$export$42f432bed9bbfa4a = function formatToSchema(format) {
    if (!format) return undefined;
    var result = [];
    var i = 0;
    var part;
    while(i < format.length){
        if (!part || part[0] !== format[i]) {
            if (part) result.push(part);
            part = format[i];
        } else part += format[i];
        i += 1;
    }
    if (part) result.push(part);
    return result;
};
var $99386f30db1339e0$var$masks = {
    m: {
        length: [
            1,
            2
        ],
        regexp: /^[1-9]$|^1[0-2]$/
    },
    mm: {
        length: [
            1,
            2
        ],
        regexp: /^[0-1]$|^0[1-9]$|^1[0-2]$/
    },
    d: {
        length: [
            1,
            2
        ],
        regexp: /^[1-9]$|^[1-2][0-9]$|^3[0-1]$/
    },
    dd: {
        length: [
            1,
            2
        ],
        regexp: /^[0-3]$|^0[1-9]$|^[1-2][0-9]$|^3[0-1]$/
    },
    yy: {
        length: [
            1,
            2
        ],
        regexp: /^[0-9]{1,2}$/
    },
    yyyy: {
        length: [
            1,
            4
        ],
        regexp: /^[0-9]{1,4}$/
    }
};
var $99386f30db1339e0$var$schemaToMask = $99386f30db1339e0$export$9235b47e9363044 = function schemaToMask(schema) {
    if (!schema) return undefined;
    return schema.map(function(part) {
        var lower = part.toLowerCase();
        var _char = lower[0];
        if (_char === 'm' || _char === 'd' || _char === 'y') return $99386f30db1339e0$var$_extends({
            placeholder: part
        }, $99386f30db1339e0$var$masks[lower]);
        return {
            fixed: part
        };
    });
};
// convert value into text representation using the schema
var $99386f30db1339e0$var$valueToText = $99386f30db1339e0$export$a1f20cd55d4f0f56 = function valueToText(value, schema) {
    var text = '';
    // when user initializes dates as empty array, we want to still
    // show the placeholder text
    if (!value || Array.isArray(value) && !value.length) return text;
    var dates = (Array.isArray(value) ? value : [
        value
    ]).map(function(v) {
        return (0, $4113023f9e0bafa0$exports.setHoursWithOffset)(v);
    });
    var dateIndex = 0;
    var parts = {};
    schema.every(function(part) {
        var _char2 = part[0].toLowerCase();
        // advance dateIndex if we already have this part
        while(dateIndex < dates.length && (Number.isNaN(dates[dateIndex].date) || (_char2 === 'm' || _char2 === 'd' || _char2 === 'y') && parts[part])){
            dateIndex += 1;
            parts = {};
        }
        var date = dates[dateIndex];
        if (date && part === 'm') {
            text += date.getMonth() + 1;
            parts[part] = true;
        } else if (date && part === 'mm') {
            text += ("0" + (date.getMonth() + 1)).slice(-2);
            parts[part] = true;
        } else if (date && part === 'd') {
            text += date.getDate();
            parts[part] = true;
        } else if (date && part === 'dd') {
            text += ("0" + date.getDate()).slice(-2);
            parts[part] = true;
        } else if (date && part === 'yy') {
            text += date.getFullYear().toString().slice(-2);
            parts[part] = true;
        } else if (date && part === 'yyyy') {
            text += date.getFullYear();
            parts[part] = true;
        } else if (!date && (part[0] === 'm' || part[0] === 'd' || part[0] === 'y')) return false;
        else text += part;
        return true;
    });
    return text;
};
var $99386f30db1339e0$var$charCodeZero = '0'.charCodeAt(0);
var $99386f30db1339e0$var$charCodeNine = '9'.charCodeAt(0);
var $99386f30db1339e0$var$pullDigits = function pullDigits(text, index) {
    var end = index;
    while(text.charCodeAt(end) >= $99386f30db1339e0$var$charCodeZero && text.charCodeAt(end) <= $99386f30db1339e0$var$charCodeNine)end += 1;
    return text.slice(index, end);
};
var $99386f30db1339e0$var$validateBounds = $99386f30db1339e0$export$51e58a02740fe411 = function validateBounds(dateBounds, selectedDate) {
    if (!dateBounds || !selectedDate) return true;
    var _dateBounds$map = dateBounds.map(function(date) {
        return (0, $4113023f9e0bafa0$exports.setHoursWithOffset)(date).toISOString();
    }), startDate = _dateBounds$map[0], endDate = _dateBounds$map[1];
    var isoSelectedDates = (Array.isArray(selectedDate) ? selectedDate : [
        selectedDate
    ]).map(function(date) {
        return (0, $4113023f9e0bafa0$exports.setHoursWithOffset)(date).toISOString();
    });
    var validSelection = isoSelectedDates.every(function(isoSelectedDate) {
        return !endDate && startDate === isoSelectedDate || isoSelectedDate >= startDate && isoSelectedDate <= endDate;
    });
    return validSelection;
};
var $99386f30db1339e0$var$textToValue = $99386f30db1339e0$export$60c3f5dffac76ccb = function textToValue(text, schema, range, reference, outputFormat) {
    if (!text) return range ? [] : undefined;
    var result;
    var addDate = function addDate(parts) {
        var leapYear = parts.y % 4 === 0 && parts.y % 100 !== 0 || parts.y % 400 === 0;
        // Do a little sanity checking on the parts first.
        // If not valid, leave as is.
        if (!parts.m || !parts.d || !parts.y || parts.y.length < 4 || parts.m.length > 2 || parts.d.length > 2 || parts.m > 12 || parts.d > 31 || (parts.m === "02" || parts.m === "2") && parts.d > (leapYear ? 29 : 28)) return parts;
        // use time info from reference date
        var time = reference ? [
            reference.getHours(),
            reference.getMinutes(),
            reference.getSeconds(),
            reference.getMilliseconds()
        ] : null;
        var date = $99386f30db1339e0$var$_construct(Date, [
            parts.y,
            parts.m - 1,
            parts.d
        ].concat(time)).toISOString();
        if (date && outputFormat === 'no timezone') {
            var _handleOffset$toISOSt = (0, $6dca34d168a0b7e8$export$440bcced20c33405)(date).toISOString().split('T');
            date = _handleOffset$toISOSt[0];
        }
        if (!range) {
            if (!result) result = date;
        } else {
            if (!result) result = [];
            result.push(date);
        }
        // we've consumed these parts, return an empty object in case we need
        // to start building up another one for a range
        return {};
    };
    var parts = {};
    var index = 0;
    schema.forEach(function(part) {
        if (index < text.length) {
            var lower = part.toLowerCase();
            var _char3 = lower[0];
            if (parts[_char3] !== undefined) parts = addDate(parts);
            if (_char3 === 'm') {
                parts.m = $99386f30db1339e0$var$pullDigits(text, index);
                index += parts.m.length;
            } else if (_char3 === 'd') {
                var _parts;
                parts.d = $99386f30db1339e0$var$pullDigits(text, index);
                // when format is something like yyyy/mm/dd,
                // '0' as incomplete day can cause date to be
                // prematurely calculated.
                // ex: 2022/01/0 would reutrn 2021/12/31 in addDate()
                if (parts.d === '0') delete parts.d;
                index += ((_parts = parts) == null || (_parts = _parts.d) == null ? void 0 : _parts.length) || 0;
            } else if (_char3 === 'y') {
                parts.y = $99386f30db1339e0$var$pullDigits(text, index);
                index += parts.y.length;
                if (lower === 'yy' && parts.y.length === 2) // convert to full year, pivot at 69 based on POSIX strptime()
                parts.y = "" + (parts.y < 69 ? 20 : 19) + parts.y;
            } else if (text.slice(index, index + part.length) === part) index += part.length;
            else {
                // syntax error
                index = text.length;
                result = undefined;
            }
        }
    });
    parts = addDate(parts);
    if (!result) return range ? [] : undefined;
    return result;
};
var $99386f30db1339e0$var$valuesAreEqual = $99386f30db1339e0$export$45491dafa4524293 = function valuesAreEqual(value1, value2) {
    return Array.isArray(value1) && Array.isArray(value2) && value1.every(function(d1, i) {
        return d1 === value2[i];
    }) || value1 === value2;
};


var $5bedbd962e91d597$export$1e511d4a378977f5;
var $5bedbd962e91d597$export$22313ae4df6bbc32;
"use strict";
$5bedbd962e91d597$export$1e511d4a378977f5 = true;
$5bedbd962e91d597$export$22313ae4df6bbc32 = void 0;

var $5bedbd962e91d597$var$_propTypes = $5bedbd962e91d597$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $5bedbd962e91d597$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $5bedbd962e91d597$var$PropType = {};
$5bedbd962e91d597$var$PropType = {
    buttonProps: $5bedbd962e91d597$var$_propTypes["default"].shape({}),
    calendarProps: $5bedbd962e91d597$var$_propTypes["default"].shape({}),
    defaultValue: $5bedbd962e91d597$var$_propTypes["default"].oneOfType([
        $5bedbd962e91d597$var$_propTypes["default"].string,
        $5bedbd962e91d597$var$_propTypes["default"].arrayOf($5bedbd962e91d597$var$_propTypes["default"].string)
    ]),
    dropProps: $5bedbd962e91d597$var$_propTypes["default"].shape({}),
    format: $5bedbd962e91d597$var$_propTypes["default"].string,
    icon: $5bedbd962e91d597$var$_propTypes["default"].element,
    id: $5bedbd962e91d597$var$_propTypes["default"].string,
    inline: $5bedbd962e91d597$var$_propTypes["default"].bool,
    reverse: $5bedbd962e91d597$var$_propTypes["default"].bool,
    readOnlyCopy: $5bedbd962e91d597$var$_propTypes["default"].bool,
    inputProps: $5bedbd962e91d597$var$_propTypes["default"].shape({}),
    name: $5bedbd962e91d597$var$_propTypes["default"].string,
    onChange: $5bedbd962e91d597$var$_propTypes["default"].func,
    value: $5bedbd962e91d597$var$_propTypes["default"].oneOfType([
        $5bedbd962e91d597$var$_propTypes["default"].string,
        $5bedbd962e91d597$var$_propTypes["default"].arrayOf($5bedbd962e91d597$var$_propTypes["default"].string)
    ]),
    size: $5bedbd962e91d597$var$_propTypes["default"].oneOfType([
        $5bedbd962e91d597$var$_propTypes["default"].oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            'xxlarge',
            '2xl',
            '3xl',
            '4xl',
            '5xl',
            '6xl'
        ]),
        $5bedbd962e91d597$var$_propTypes["default"].string
    ])
};
var $5bedbd962e91d597$var$DateInputPropTypes = $5bedbd962e91d597$export$22313ae4df6bbc32 = $5bedbd962e91d597$var$PropType;





var $42d21222a350a303$var$_excluded = [
    "buttonProps",
    "calendarProps",
    "defaultValue",
    "disabled",
    "dropProps",
    "format",
    "id",
    "icon",
    "inline",
    "inputProps",
    "name",
    "onChange",
    "onFocus",
    "plain",
    "readOnly",
    "readOnlyCopy",
    "reverse",
    "value",
    "messages"
], $42d21222a350a303$var$_excluded2 = [
    "icon"
];
function $42d21222a350a303$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $42d21222a350a303$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($42d21222a350a303$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $42d21222a350a303$var$_extends() {
    return $42d21222a350a303$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $42d21222a350a303$var$_extends.apply(null, arguments);
}
function $42d21222a350a303$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $42d21222a350a303$var$StyledDateInputContainer = (0, $42d21222a350a303$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    // to not pass props on dom through Box
    shouldForwardProp: function shouldForwardProp(prop) {
        return prop !== 'disabled';
    }
}).withConfig({
    displayName: "DateInput__StyledDateInputContainer",
    componentId: "sc-1jfta23-0"
})([
    "",
    " ",
    "}"
], function(props) {
    return props.disabled && (0, $4113023f9e0bafa0$exports.disabledStyle)();
}, function(props) {
    return props.readOnlyProp && (0, $18fb38d78d6dde51$export$28ff5f3fef0ffa78)(props.theme);
});
var $42d21222a350a303$var$getReference = function getReference(value) {
    var adjustedDate;
    var res;
    if (typeof value === 'string') res = value;
    else if (Array.isArray(value) && Array.isArray(value[0])) res = value[0].find(function(date) {
        return date;
    });
    else if (Array.isArray(value) && value.length) res = value[0];
    if (res) adjustedDate = (0, $4113023f9e0bafa0$exports.setHoursWithOffset)(res);
    return adjustedDate;
};
var $42d21222a350a303$var$DateInput = $42d21222a350a303$export$7edc06cf1783b30f = /*#__PURE__*/ (0, $42d21222a350a303$var$_react.forwardRef)(function(_ref, refArg) {
    var _theme$icon, _theme$dateInput$icon, _theme$dateInput$icon2, _theme$dateInput$butt, _theme$dateInput$butt2;
    var buttonProps = _ref.buttonProps, calendarProps = _ref.calendarProps, defaultValue = _ref.defaultValue, disabled = _ref.disabled, dropProps = _ref.dropProps, format = _ref.format, id = _ref.id, icon = _ref.icon, _ref$inline = _ref.inline, inline = _ref$inline === void 0 ? false : _ref$inline, inputProps = _ref.inputProps, name = _ref.name, _onChange = _ref.onChange, _onFocus = _ref.onFocus, plain = _ref.plain, readOnlyProp = _ref.readOnly, readOnlyCopy = _ref.readOnlyCopy, _ref$reverse = _ref.reverse, reverseProp = _ref$reverse === void 0 ? false : _ref$reverse, valueArg = _ref.value, messages = _ref.messages, rest = $42d21222a350a303$var$_objectWithoutPropertiesLoose(_ref, $42d21222a350a303$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var announce = (0, $42d21222a350a303$var$_react.useContext)($cfbcb74d4f54e56b$export$dcc8f4bff0d51f50);
    var _useContext = (0, $42d21222a350a303$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), formatMessage = _useContext.format;
    var iconSize = ((_theme$icon = theme.icon) == null ? void 0 : _theme$icon.matchSize) && rest.size || ((_theme$dateInput$icon = theme.dateInput.icon) == null ? void 0 : _theme$dateInput$icon.size);
    var _useContext2 = (0, $42d21222a350a303$var$_react.useContext)($b39d3fd88e3f6fd8$export$c24727297075ec6a), useFormInput = _useContext2.useFormInput;
    var ref = (0, $4113023f9e0bafa0$exports.useForwardedRef)(refArg);
    var containerRef = (0, $42d21222a350a303$var$_react.useRef)();
    var readOnly = readOnlyProp || readOnlyCopy;
    var bounds = calendarProps == null ? void 0 : calendarProps.bounds;
    var validateBoundsForForm = (0, $42d21222a350a303$var$_react.useCallback)(function(fieldValue) {
        if (!bounds || !fieldValue) return undefined;
        var isValid = (0, $99386f30db1339e0$export$51e58a02740fe411)(bounds, fieldValue);
        if (!isValid) {
            var _bounds$map = bounds.map(function(date) {
                return (0, $4113023f9e0bafa0$exports.setHoursWithOffset)(date).toISOString();
            }), startBound = _bounds$map[0], endBound = _bounds$map[1];
            if (startBound && endBound) return formatMessage({
                id: 'dateInput.outOfBounds',
                messages: messages,
                values: {
                    start: new Date(startBound).toLocaleDateString(),
                    end: new Date(endBound).toLocaleDateString()
                }
            });
        }
        return undefined;
    }, [
        bounds,
        formatMessage,
        messages
    ]);
    var _useFormInput = useFormInput({
        name: name,
        value: valueArg,
        initialValue: defaultValue,
        validate: bounds ? validateBoundsForForm : undefined
    }), value = _useFormInput[0], setValue = _useFormInput[1];
    var usingKeyboard = (0, $4113023f9e0bafa0$exports.useKeyboard)();
    var CalendarIcon = ((_theme$dateInput$icon2 = theme.dateInput.icon) == null ? void 0 : _theme$dateInput$icon2.calendar) || $5958f18f8d688d50$export$e1aef45b828286de;
    var _useState = (0, $42d21222a350a303$var$_react.useState)(true), withinBounds = _useState[0], setWithinBounds = _useState[1];
    var _useState2 = (0, $42d21222a350a303$var$_react.useState)((0, $fcf2886c26d1d13d$export$c0c99f9031a45b3)(value)), outputFormat = _useState2[0], setOutputFormat = _useState2[1];
    (0, $42d21222a350a303$var$_react.useEffect)(function() {
        setOutputFormat(function(previousFormat) {
            var nextFormat = (0, $fcf2886c26d1d13d$export$c0c99f9031a45b3)(value);
            // when user types, date could become something like 07//2020
            // and value becomes undefined. don't lose the format from the
            // previous valid date
            return previousFormat !== nextFormat ? previousFormat : nextFormat;
        });
    }, [
        value
    ]);
    (0, $42d21222a350a303$var$_react.useEffect)(function() {
        if (value === undefined || bounds === undefined) setWithinBounds(true);
        else {
            var validNextValue = (0, $99386f30db1339e0$export$51e58a02740fe411)(bounds, value);
            setWithinBounds(validNextValue);
        }
    }, [
        value,
        bounds
    ]);
    // keep track of timestamp from original date(s)
    var _useState3 = (0, $42d21222a350a303$var$_react.useState)($42d21222a350a303$var$getReference(value)), reference = _useState3[0], setReference = _useState3[1];
    // do we expect multiple dates?
    var range = Array.isArray(value) || format && format.includes('-');
    // parse format and build a formal schema we can use elsewhere
    var schema = (0, $42d21222a350a303$var$_react.useMemo)(function() {
        return (0, $99386f30db1339e0$export$42f432bed9bbfa4a)(format);
    }, [
        format
    ]);
    // mask is only used when a format is provided
    var mask = (0, $42d21222a350a303$var$_react.useMemo)(function() {
        return (0, $99386f30db1339e0$export$9235b47e9363044)(schema);
    }, [
        schema
    ]);
    // textValue is only used when a format is provided
    var _useState4 = (0, $42d21222a350a303$var$_react.useState)(schema ? (0, $99386f30db1339e0$export$a1f20cd55d4f0f56)(value, schema) : undefined), textValue = _useState4[0], setTextValue = _useState4[1];
    var readOnlyCopyValidation = formatMessage({
        id: 'input.readOnlyCopy.validation',
        messages: messages
    });
    var readOnlyCopyPrompt = formatMessage({
        id: 'input.readOnlyCopy.prompt',
        messages: messages
    });
    var _useState5 = (0, $42d21222a350a303$var$_react.useState)(readOnlyCopyPrompt), tip = _useState5[0], setTip = _useState5[1];
    // Setting the icon through `inputProps` is deprecated.
    // The `icon` prop should be used instead.
    var _ref2 = inputProps || {}, MaskedInputIcon = _ref2.icon, restOfInputProps = $42d21222a350a303$var$_objectWithoutPropertiesLoose(_ref2, $42d21222a350a303$var$_excluded2);
    if (MaskedInputIcon) console.warn("Customizing the DateInput icon through inputProps is deprecated.\nUse the icon prop instead.");
    var reverse = reverseProp || restOfInputProps.reverse;
    var calendarDropdownAlign = {
        top: 'bottom',
        left: 'left'
    };
    // We need to distinguish between the caller changing a Form value
    // and the user typing a date that he isn't finished with yet.
    // To handle this, we see if we have a value and the text value
    // associated with it doesn't align to it, then we update the text value.
    // We compare using textToValue to avoid "06/01/2021" not
    // matching "06/1/2021".
    (0, $42d21222a350a303$var$_react.useEffect)(function() {
        if (schema && value !== undefined) {
            var nextTextValue = (0, $99386f30db1339e0$export$a1f20cd55d4f0f56)(value, schema);
            if (!(0, $99386f30db1339e0$export$45491dafa4524293)((0, $99386f30db1339e0$export$60c3f5dffac76ccb)(textValue, schema, range, reference), (0, $99386f30db1339e0$export$60c3f5dffac76ccb)(nextTextValue, schema, range, reference)) || textValue === '' && nextTextValue !== '') setTextValue(nextTextValue);
        }
    }, [
        range,
        schema,
        textValue,
        reference,
        value
    ]);
    // textValue of MaskedInput is controlled.
    // for uncontrolled forms, ensure the reset event
    // resets the textValue
    (0, $42d21222a350a303$var$_react.useEffect)(function() {
        var _ref$current;
        var form = ref == null || (_ref$current = ref.current) == null ? void 0 : _ref$current.form;
        var handleFormReset = function handleFormReset(e) {
            if (schema && ref.current && e.target.contains(ref.current)) setTextValue('');
        };
        // place the listener on the form directly. if listener is on window,
        // the event could get blocked if caller has e.stopPropagation(), etc. in
        // their form onReset
        form == null || form.addEventListener('reset', handleFormReset);
        return function() {
            return form == null ? void 0 : form.removeEventListener('reset', handleFormReset);
        };
    }, [
        schema,
        ref
    ]);
    // when format and not inline, whether to show the Calendar in a Drop
    var _useState6 = (0, $42d21222a350a303$var$_react.useState)(), open = _useState6[0], setOpen = _useState6[1];
    var openCalendar = (0, $42d21222a350a303$var$_react.useCallback)(function() {
        setOpen(true);
        announce(formatMessage({
            id: 'dateInput.enterCalendar',
            messages: messages
        }));
    }, [
        announce,
        formatMessage,
        messages
    ]);
    var closeCalendar = (0, $42d21222a350a303$var$_react.useCallback)(function() {
        if (usingKeyboard && !inline && ref != null && ref.current) setTimeout(function() {
            var _ref$current2;
            ref == null || (_ref$current2 = ref.current) == null || _ref$current2.focus();
        }, 0);
        setOpen(false);
        announce(formatMessage({
            id: 'dateInput.exitCalendar',
            messages: messages
        }));
    }, [
        announce,
        formatMessage,
        messages,
        usingKeyboard,
        ref,
        inline
    ]);
    var dates = (0, $42d21222a350a303$var$_react.useMemo)(function() {
        return range && value != null && value.length ? [
            value
        ] : undefined;
    }, [
        range,
        value
    ]);
    var calendar = /*#__PURE__*/ $42d21222a350a303$var$_react["default"].createElement($754c60248b2cdc9f$export$e1aef45b828286de, $42d21222a350a303$var$_extends({
        ref: inline ? ref : undefined,
        id: inline && !format ? id : undefined,
        range: range,
        date: range ? undefined : value,
        dates: dates,
        initialFocus: open ? 'days' : undefined,
        onSelect: disabled ? undefined : function(nextValue) {
            var normalizedValue;
            if (range && Array.isArray(nextValue)) normalizedValue = nextValue[0];
            else if (range && nextValue) normalizedValue = [
                nextValue,
                nextValue
            ];
            else normalizedValue = nextValue;
            if (schema) setTextValue((0, $99386f30db1339e0$export$a1f20cd55d4f0f56)(normalizedValue, schema));
            setValue(normalizedValue);
            setReference($42d21222a350a303$var$getReference(nextValue));
            if (_onChange) _onChange({
                value: normalizedValue
            });
            if (open && !range) closeCalendar();
        }
    }, calendarProps));
    var formContextValue = (0, $42d21222a350a303$var$_react.useMemo)(function() {
        return {
            useFormInput: function useFormInput(_ref3) {
                var valueProp = _ref3.value;
                return [
                    valueProp,
                    function() {}
                ];
            }
        };
    }, []);
    if (!format) {
        // When no format is specified, we don't give the user a way to type
        if (inline) return calendar;
        return /*#__PURE__*/ $42d21222a350a303$var$_react["default"].createElement($d7e2a556593dc38b$export$64fff40e709e8b2e, $42d21222a350a303$var$_extends({
            ref: ref,
            id: id,
            dropProps: $42d21222a350a303$var$_extends({
                align: calendarDropdownAlign
            }, dropProps),
            dropContent: calendar,
            icon: icon || MaskedInputIcon || /*#__PURE__*/ $42d21222a350a303$var$_react["default"].createElement(CalendarIcon, {
                size: iconSize
            })
        }, buttonProps));
    }
    var onClickCopy = function onClickCopy() {
        navigator.clipboard.writeText(textValue);
        announce(readOnlyCopyValidation, 'assertive');
        setTip(readOnlyCopyValidation);
    };
    var onBlurCopy = function onBlurCopy() {
        if (tip === readOnlyCopyValidation) setTip(readOnlyCopyPrompt);
    };
    var DateInputButton = readOnlyCopy ? /*#__PURE__*/ $42d21222a350a303$var$_react["default"].createElement($10cb694a8e7833c1$export$4f2558dd25106ae2, {
        disabled: disabled,
        onBlurCopy: onBlurCopy,
        onClickCopy: onClickCopy,
        readOnlyCopyPrompt: readOnlyCopyPrompt,
        tip: tip,
        value: value
    }) : /*#__PURE__*/ $42d21222a350a303$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
        onClick: open ? closeCalendar : openCalendar,
        disabled: disabled,
        plain: true,
        icon: icon || MaskedInputIcon || /*#__PURE__*/ $42d21222a350a303$var$_react["default"].createElement(CalendarIcon, {
            size: iconSize
        }),
        margin: reverse ? {
            left: (_theme$dateInput$butt = theme.dateInput.button) == null ? void 0 : _theme$dateInput$butt.margin
        } : {
            right: (_theme$dateInput$butt2 = theme.dateInput.button) == null ? void 0 : _theme$dateInput$butt2.margin
        }
    });
    var input = /*#__PURE__*/ $42d21222a350a303$var$_react["default"].createElement($b39d3fd88e3f6fd8$export$c24727297075ec6a.Provider, {
        key: "input",
        value: formContextValue
    }, /*#__PURE__*/ $42d21222a350a303$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onEsc: open ? function() {
            return closeCalendar();
        } : undefined,
        onSpace: function onSpace(event) {
            if (!readOnlyCopy) {
                event.preventDefault();
                if (!readOnly) openCalendar();
            }
        }
    }, /*#__PURE__*/ $42d21222a350a303$var$_react["default"].createElement($42d21222a350a303$var$StyledDateInputContainer, $42d21222a350a303$var$_extends({
        ref: containerRef,
        border: !plain,
        round: theme.dateInput.container.round,
        direction: "row",
        disabled: disabled,
        readOnlyProp: readOnly,
        fill: true
    }, passThemeFlag), reverse && (!readOnly || readOnlyCopy) && DateInputButton, /*#__PURE__*/ $42d21222a350a303$var$_react["default"].createElement($0c17f9d155734634$export$dec03dc0f3ef8025, $42d21222a350a303$var$_extends({
        "aria-invalid": bounds && !withinBounds ? true : undefined,
        readOnly: readOnly,
        ref: ref,
        id: id,
        name: name,
        reverse: true,
        disabled: disabled,
        mask: mask,
        plain: true
    }, restOfInputProps, rest, {
        value: textValue,
        onChange: function onChange(event) {
            var nextTextValue = event.target.value;
            setTextValue(nextTextValue);
            var nextValue = (0, $99386f30db1339e0$export$60c3f5dffac76ccb)(nextTextValue, schema, range, reference, outputFormat);
            var validNextValue = (0, $99386f30db1339e0$export$51e58a02740fe411)(bounds, nextValue);
            setWithinBounds(validNextValue);
            if (nextValue !== undefined) setReference($42d21222a350a303$var$getReference(nextValue));
            // update value even when undefined
            setValue(nextValue);
            if (_onChange) {
                event.persist(); // extract from React synthetic event pool
                var adjustedEvent = event;
                adjustedEvent.value = nextValue;
                _onChange(adjustedEvent);
            }
        },
        onFocus: function onFocus(event) {
            if (!readOnly) announce(formatMessage({
                id: 'dateInput.openCalendar',
                messages: messages
            }));
            if (_onFocus) _onFocus(event);
        }
    })), !reverse && (!readOnly || readOnlyCopy) && DateInputButton)));
    if (inline) return /*#__PURE__*/ $42d21222a350a303$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, null, input, calendar);
    if (open && !readOnly) return [
        input,
        /*#__PURE__*/ $42d21222a350a303$var$_react["default"].createElement($9097252a6690f3a9$export$aaa698cd7aa517d6, $42d21222a350a303$var$_extends({
            key: "drop",
            id: id ? id + "__drop" : undefined,
            target: containerRef.current,
            align: $42d21222a350a303$var$_extends({}, calendarDropdownAlign, dropProps),
            onEsc: closeCalendar,
            onClickOutside: function onClickOutside(_ref4) {
                var target = _ref4.target;
                if (target !== containerRef.current && !containerRef.current.contains(target)) closeCalendar();
            }
        }, dropProps), calendar)
    ];
    return input;
});
$42d21222a350a303$var$DateInput.displayName = 'DateInput';
$42d21222a350a303$var$DateInput.propTypes = $5bedbd962e91d597$export$22313ae4df6bbc32;


$b921a35fe79f8af7$export$7edc06cf1783b30f = $42d21222a350a303$export$7edc06cf1783b30f;


Object.keys($b921a35fe79f8af7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $b921a35fe79f8af7$exports[key]) return;
    $3321243da0932e1e$exports[key] = $b921a35fe79f8af7$exports[key];
});
var $cc173fc7db612d7f$exports = {};

$parcel$export($cc173fc7db612d7f$exports, "__esModule", function () { return $cc173fc7db612d7f$export$1e511d4a378977f5; }, function (v) { return $cc173fc7db612d7f$export$1e511d4a378977f5 = v; });
$parcel$export($cc173fc7db612d7f$exports, "Diagram", function () { return $cc173fc7db612d7f$export$5b87a37ba02474f4; }, function (v) { return $cc173fc7db612d7f$export$5b87a37ba02474f4 = v; });
var $cc173fc7db612d7f$export$1e511d4a378977f5;
var $cc173fc7db612d7f$export$5b87a37ba02474f4;
"use strict";
$cc173fc7db612d7f$export$1e511d4a378977f5 = true;
$cc173fc7db612d7f$export$5b87a37ba02474f4 = void 0;
var $efe3af74c8712aa1$export$1e511d4a378977f5;
var $efe3af74c8712aa1$export$5b87a37ba02474f4;
"use strict";
$efe3af74c8712aa1$export$1e511d4a378977f5 = true;
$efe3af74c8712aa1$export$5b87a37ba02474f4 = void 0;

var $efe3af74c8712aa1$var$_react = $efe3af74c8712aa1$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $86dd5cfe776b0c74$export$1e511d4a378977f5;
var $86dd5cfe776b0c74$export$d5baebd5ccf00ef;
"use strict";
$86dd5cfe776b0c74$export$1e511d4a378977f5 = true;
$86dd5cfe776b0c74$export$d5baebd5ccf00ef = void 0;

var $86dd5cfe776b0c74$var$_styledComponents = $86dd5cfe776b0c74$var$_interopRequireWildcard((parcelRequire("iA1nz")));


function $86dd5cfe776b0c74$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($86dd5cfe776b0c74$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $86dd5cfe776b0c74$var$animationItemStyle = function animationItemStyle(animationType, theme) {
    if (typeof animationType === 'string') return (0, $a0261dac70a40f19$export$1d0c30b40b07398)({
        type: animationType
    }, theme, theme.diagram);
    if (typeof animationType === 'object') return (0, $a0261dac70a40f19$export$1d0c30b40b07398)(animationType, theme, theme.diagram);
    if (typeof animationType === 'boolean') return (0, $a0261dac70a40f19$export$1d0c30b40b07398)({
        type: 'draw'
    }, theme, theme.diagram);
    return '';
};
var $86dd5cfe776b0c74$var$animationStyle = function animationStyle(props) {
    var animationCopy = props.animation;
    if (typeof props.animation === 'object') animationCopy.type = animationCopy.type || 'draw';
    var animationType = animationCopy.type || animationCopy;
    if (animationType === 'draw' || animationType === true) return (0, $86dd5cfe776b0c74$var$_styledComponents.css)([
        "path{stroke-dasharray:500;stroke-dashoffset:500;animation:",
        ";}"
    ], $86dd5cfe776b0c74$var$animationItemStyle(animationCopy, props.theme));
    return (0, $86dd5cfe776b0c74$var$_styledComponents.css)([
        "animation:",
        ";"
    ], $86dd5cfe776b0c74$var$animationItemStyle(animationCopy, props.theme));
};
var $86dd5cfe776b0c74$var$connectionStyle = function connectionStyle(connection, index, theme) {
    var type = connection.props.animation.type;
    if (typeof connection.props.animation === 'object') type = type || 'draw';
    var animationType = type || connection.props.animation;
    return (0, $86dd5cfe776b0c74$var$_styledComponents.css)([
        "path:nth-child(",
        "){stroke-dasharray:",
        ";stroke-dashoffset:",
        ";animation:",
        ";}"
    ], index + 1, animationType === 'draw' || animationType === true ? 500 : 0, animationType === 'draw' || animationType === true ? 500 : 0, $86dd5cfe776b0c74$var$animationItemStyle(connection.props.animation, theme));
};
var $86dd5cfe776b0c74$var$availableAnimations = [
    true,
    'draw',
    'pulse'
];
var $86dd5cfe776b0c74$var$StyledDiagram = $86dd5cfe776b0c74$export$d5baebd5ccf00ef = $86dd5cfe776b0c74$var$_styledComponents["default"].svg.withConfig($9a7099e779e83517$export$373e75d802fd707).withConfig({
    displayName: "StyledDiagram",
    componentId: "sc-1vzeu9f-0"
})([
    "max-width:100%;width:100%;height:100%;",
    " ",
    " ",
    ""
], function(props) {
    return props.connections && props.connections.map(function(connection, index) {
        if (connection !== undefined && connection.props.animation) {
            var animation = connection.props.animation;
            // setting type to 'draw' if user doesn't specify a type
            if (typeof animation === 'object') {
                // copying 'connection' to avoid linter error
                var connectionCopy = connection;
                connectionCopy.props.animation.type = animation.type || 'draw';
                return $86dd5cfe776b0c74$var$availableAnimations.includes(animation.type || animation) ? $86dd5cfe776b0c74$var$connectionStyle(connectionCopy, index, props.theme) : '';
            }
            return $86dd5cfe776b0c74$var$connectionStyle(connection, index, props.theme);
        }
        return '';
    });
}, function(props) {
    return props.animation && ($86dd5cfe776b0c74$var$availableAnimations.includes(props.animation.type || props.animation) || Object.keys(props.animation).length !== 0) ? $86dd5cfe776b0c74$var$animationStyle(props) : '';
}, function(props) {
    return props.theme.diagram && props.theme.diagram.extend;
});


var $4515f7ebe7b3e778$export$1e511d4a378977f5;
var $4515f7ebe7b3e778$export$7cdaef4029b615f8;
"use strict";
$4515f7ebe7b3e778$export$1e511d4a378977f5 = true;
$4515f7ebe7b3e778$export$7cdaef4029b615f8 = void 0;

var $4515f7ebe7b3e778$var$_propTypes = $4515f7ebe7b3e778$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $4515f7ebe7b3e778$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $4515f7ebe7b3e778$var$animationPropType = $4515f7ebe7b3e778$var$_propTypes["default"].oneOfType([
    $4515f7ebe7b3e778$var$_propTypes["default"].bool,
    $4515f7ebe7b3e778$var$_propTypes["default"].oneOf([
        'pulse',
        'draw'
    ]),
    $4515f7ebe7b3e778$var$_propTypes["default"].shape({
        type: $4515f7ebe7b3e778$var$_propTypes["default"].oneOf([
            'pulse',
            'draw'
        ]),
        delay: $4515f7ebe7b3e778$var$_propTypes["default"].oneOfType([
            $4515f7ebe7b3e778$var$_propTypes["default"].number,
            $4515f7ebe7b3e778$var$_propTypes["default"].string
        ]),
        duration: $4515f7ebe7b3e778$var$_propTypes["default"].oneOfType([
            $4515f7ebe7b3e778$var$_propTypes["default"].number,
            $4515f7ebe7b3e778$var$_propTypes["default"].string
        ]),
        size: $4515f7ebe7b3e778$var$_propTypes["default"].oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ])
    })
]);
var $4515f7ebe7b3e778$var$PropType = {};
$4515f7ebe7b3e778$var$PropType = {
    animation: $4515f7ebe7b3e778$var$animationPropType,
    connections: $4515f7ebe7b3e778$var$_propTypes["default"].arrayOf($4515f7ebe7b3e778$var$_propTypes["default"].shape({
        anchor: $4515f7ebe7b3e778$var$_propTypes["default"].oneOf([
            'center',
            'vertical',
            'horizontal'
        ]),
        animation: $4515f7ebe7b3e778$var$animationPropType,
        color: $5897bd367fbd90c1$export$fc4c368d97afb623,
        fromTarget: $4515f7ebe7b3e778$var$_propTypes["default"].oneOfType([
            $4515f7ebe7b3e778$var$_propTypes["default"].string,
            $4515f7ebe7b3e778$var$_propTypes["default"].object
        ]).isRequired,
        label: $4515f7ebe7b3e778$var$_propTypes["default"].string,
        // for accessibility
        offset: $4515f7ebe7b3e778$var$_propTypes["default"].oneOfType([
            $4515f7ebe7b3e778$var$_propTypes["default"].oneOf([
                'xsmall',
                'small',
                'medium',
                'large'
            ]),
            $4515f7ebe7b3e778$var$_propTypes["default"].string
        ]),
        thickness: $4515f7ebe7b3e778$var$_propTypes["default"].oneOfType([
            $4515f7ebe7b3e778$var$_propTypes["default"].oneOf([
                'hair',
                'xxsmall',
                'xsmall',
                'small',
                'medium',
                'large'
            ]),
            $4515f7ebe7b3e778$var$_propTypes["default"].string
        ]),
        toTarget: $4515f7ebe7b3e778$var$_propTypes["default"].oneOfType([
            $4515f7ebe7b3e778$var$_propTypes["default"].string,
            $4515f7ebe7b3e778$var$_propTypes["default"].object
        ]).isRequired,
        type: $4515f7ebe7b3e778$var$_propTypes["default"].oneOf([
            'direct',
            'curved',
            'rectilinear'
        ])
    }))
};
var $4515f7ebe7b3e778$var$DiagramPropTypes = $4515f7ebe7b3e778$export$7cdaef4029b615f8 = $4515f7ebe7b3e778$var$PropType;



var $efe3af74c8712aa1$var$_excluded = [
    "connections"
], $efe3af74c8712aa1$var$_excluded2 = [
    "anchor",
    "animation",
    "color",
    "offset",
    "round",
    "thickness",
    "type"
];
function $efe3af74c8712aa1$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($efe3af74c8712aa1$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $efe3af74c8712aa1$var$_extends() {
    return $efe3af74c8712aa1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $efe3af74c8712aa1$var$_extends.apply(null, arguments);
}
function $efe3af74c8712aa1$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $efe3af74c8712aa1$var$computeMidPoint = function computeMidPoint(fromPoint, toPoint) {
    return [
        fromPoint[0] > toPoint[0] ? toPoint[0] + (fromPoint[0] - toPoint[0]) / 2 : fromPoint[0] + (toPoint[0] - fromPoint[0]) / 2,
        fromPoint[1] > toPoint[1] ? toPoint[1] + (fromPoint[1] - toPoint[1]) / 2 : fromPoint[1] + (toPoint[1] - fromPoint[1]) / 2
    ];
};
var $efe3af74c8712aa1$var$COMMANDS = {
    curved: function curved(fromPoint, toPoint, offset, anchor) {
        var midPoint = $efe3af74c8712aa1$var$computeMidPoint(fromPoint, toPoint);
        var cmds = "M " + (fromPoint[0] + offset) + "," + (fromPoint[1] + offset) + " ";
        if (anchor === 'horizontal') cmds += "Q " + (midPoint[0] + offset) + "," + (fromPoint[1] + offset) + " " + (midPoint[0] + offset + "," + (midPoint[1] + offset) + " ");
        else cmds += "Q " + (fromPoint[0] + offset) + "," + (midPoint[1] + offset) + " " + (midPoint[0] + offset + "," + (midPoint[1] + offset) + " ");
        cmds += "T " + (toPoint[0] + offset) + "," + (toPoint[1] + offset);
        return cmds;
    },
    direct: function direct(fromPoint, toPoint, offset) {
        return "M " + (fromPoint[0] + offset) + "," + (fromPoint[1] + offset) + " " + ("L " + (toPoint[0] + offset) + "," + (toPoint[1] + offset));
    },
    rectilinear: function rectilinear(fromPoint, toPoint, offset, anchor) {
        var midPoint = $efe3af74c8712aa1$var$computeMidPoint(fromPoint, toPoint);
        var cmds = "M " + (fromPoint[0] + offset) + "," + (fromPoint[1] + offset) + " ";
        if (anchor === 'horizontal') cmds += "L " + (midPoint[0] + offset) + "," + (fromPoint[1] + offset) + " " + ("L " + (midPoint[0] + offset) + "," + (toPoint[1] + offset) + " ");
        else cmds += "L " + (fromPoint[0] + offset) + "," + (midPoint[1] + offset) + " " + ("L " + (toPoint[0] + offset) + "," + (midPoint[1] + offset) + " ");
        cmds += "L " + (toPoint[0] + offset) + "," + (toPoint[1] + offset);
        return cmds;
    }
};
var $efe3af74c8712aa1$var$findTarget = function findTarget(target) {
    if (typeof target === 'string') return document.getElementById(target);
    return target;
};
var $efe3af74c8712aa1$var$defaultConnections = [];
var $efe3af74c8712aa1$var$Diagram = $efe3af74c8712aa1$export$5b87a37ba02474f4 = /*#__PURE__*/ (0, $efe3af74c8712aa1$var$_react.forwardRef)(function(_ref, ref) {
    var _ref$connections = _ref.connections, connections = _ref$connections === void 0 ? $efe3af74c8712aa1$var$defaultConnections : _ref$connections, rest = $efe3af74c8712aa1$var$_objectWithoutPropertiesLoose(_ref, $efe3af74c8712aa1$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useState = (0, $efe3af74c8712aa1$var$_react.useState)({
        width: 0,
        height: 0
    }), dimensions = _useState[0], setDimensions = _useState[1];
    var _useState2 = (0, $efe3af74c8712aa1$var$_react.useState)(), connectionPoints = _useState2[0], setConnectionPoints = _useState2[1];
    var svgRef = (0, $4113023f9e0bafa0$exports.useForwardedRef)(ref);
    (0, $efe3af74c8712aa1$var$_react.useEffect)(function() {
        setConnectionPoints(undefined);
    }, [
        connections
    ]);
    var onResize = (0, $efe3af74c8712aa1$var$_react.useCallback)(function() {
        var svg = svgRef.current;
        if (svg) {
            var rect = svg.getBoundingClientRect();
            if (rect.width !== dimensions.width || rect.height !== dimensions.height) {
                setDimensions({
                    width: rect.width,
                    height: rect.height
                });
                setConnectionPoints(undefined);
            }
        }
    }, [
        dimensions.width,
        dimensions.height,
        svgRef
    ]);
    // Ref that stores resize handler
    var savedOnResize = (0, $efe3af74c8712aa1$var$_react.useRef)();
    // Update resize ref value if onResize changes.
    // This allows our effect below to always get latest handler
    (0, $efe3af74c8712aa1$var$_react.useEffect)(function() {
        savedOnResize.current = onResize;
    }, [
        onResize
    ]);
    (0, $efe3af74c8712aa1$var$_react.useEffect)(function() {
        var onResizeHandler = function onResizeHandler(event) {
            return savedOnResize.current(event);
        };
        onResizeHandler();
        window.addEventListener('resize', onResizeHandler);
        return function() {
            window.removeEventListener('resize', onResizeHandler);
        };
    }, []);
    var placeConnections = (0, $efe3af74c8712aa1$var$_react.useCallback)(function() {
        var containerRect = svgRef.current.getBoundingClientRect();
        var updatedConnectionPoints = connections.map(function(_ref2) {
            var anchor = _ref2.anchor, fromTarget = _ref2.fromTarget, toTarget = _ref2.toTarget;
            var points;
            var fromElement = $efe3af74c8712aa1$var$findTarget(fromTarget);
            var toElement = $efe3af74c8712aa1$var$findTarget(toTarget);
            if (!fromElement) console.warn("Diagram cannot find " + fromTarget);
            if (!toElement) console.warn("Diagram cannot find " + toTarget);
            if (fromElement && toElement) {
                var fromRect = fromElement.getBoundingClientRect();
                var toRect = toElement.getBoundingClientRect();
                // There is no x and y when unit testing.
                var fromPoint = [
                    fromRect.left - containerRect.left || 0,
                    fromRect.top - containerRect.top || 0
                ];
                var toPoint = [
                    toRect.left - containerRect.left || 0,
                    toRect.top - containerRect.top || 0
                ];
                if (anchor === 'vertical') {
                    fromPoint[0] += fromRect.width / 2;
                    toPoint[0] += toRect.width / 2;
                    if (fromRect.top < toRect.top) fromPoint[1] += fromRect.height;
                    else toPoint[1] += toRect.height;
                } else if (anchor === 'horizontal') {
                    fromPoint[1] += fromRect.height / 2;
                    toPoint[1] += toRect.height / 2;
                    if (fromRect.left < toRect.left) fromPoint[0] += fromRect.width;
                    else toPoint[0] += toRect.width;
                } else {
                    // center
                    fromPoint[0] += fromRect.width / 2;
                    fromPoint[1] += fromRect.height / 2;
                    toPoint[0] += toRect.width / 2;
                    toPoint[1] += toRect.height / 2;
                }
                points = [
                    fromPoint,
                    toPoint
                ];
            }
            return points;
        });
        setConnectionPoints(updatedConnectionPoints);
    }, [
        connections,
        svgRef
    ]);
    (0, $efe3af74c8712aa1$var$_react.useEffect)(function() {
        if (!connectionPoints) placeConnections();
    }, [
        connectionPoints,
        placeConnections
    ]);
    var paths;
    if (connectionPoints) paths = connections.map(function(_ref3, index) {
        var anchor = _ref3.anchor, animation = _ref3.animation, color = _ref3.color, offset = _ref3.offset, round = _ref3.round, thickness = _ref3.thickness, type = _ref3.type, connectionRest = $efe3af74c8712aa1$var$_objectWithoutPropertiesLoose(_ref3, $efe3af74c8712aa1$var$_excluded2);
        var path;
        var cleanedRest = $efe3af74c8712aa1$var$_extends({}, connectionRest);
        delete cleanedRest.fromTarget;
        delete cleanedRest.toTarget;
        var points = connectionPoints[index];
        if (points) {
            var offsetWidth = offset ? (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.edgeSize[offset]) : 0;
            var d = $efe3af74c8712aa1$var$COMMANDS[type || 'curved'](points[0], points[1], offsetWidth, anchor);
            var strokeWidth = thickness ? (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.edgeSize[thickness] || thickness) : 1;
            var colorName = color || theme.diagram.line && theme.diagram.line.color;
            if (!colorName) {
                var colors = Object.keys(theme.global.colors).filter(function(n) {
                    return n.match(/^graph-[0-9]$/);
                });
                colorName = colors[index % colors.length];
            }
            path = /*#__PURE__*/ $efe3af74c8712aa1$var$_react["default"].createElement("path", $efe3af74c8712aa1$var$_extends({
                // eslint-disable-next-line react/no-array-index-key
                key: index,
                animation: animation
            }, cleanedRest, {
                stroke: (0, $4113023f9e0bafa0$exports.normalizeColor)(colorName, theme),
                strokeWidth: strokeWidth,
                strokeLinecap: round ? 'round' : 'butt',
                strokeLinejoin: round ? 'round' : 'miter',
                fill: "none",
                d: d
            }));
        }
        return path;
    });
    return /*#__PURE__*/ $efe3af74c8712aa1$var$_react["default"].createElement($86dd5cfe776b0c74$export$d5baebd5ccf00ef, $efe3af74c8712aa1$var$_extends({
        ref: svgRef,
        viewBox: "0 0 " + dimensions.width + " " + dimensions.height,
        preserveAspectRatio: "xMinYMin meet",
        connections: paths
    }, passThemeFlag, rest), /*#__PURE__*/ $efe3af74c8712aa1$var$_react["default"].createElement("g", null, paths));
});
$efe3af74c8712aa1$var$Diagram.displayName = 'Diagram';
$efe3af74c8712aa1$var$Diagram.propTypes = $4515f7ebe7b3e778$export$7cdaef4029b615f8;


$cc173fc7db612d7f$export$5b87a37ba02474f4 = $efe3af74c8712aa1$export$5b87a37ba02474f4;


Object.keys($cc173fc7db612d7f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $cc173fc7db612d7f$exports[key]) return;
    $3321243da0932e1e$exports[key] = $cc173fc7db612d7f$exports[key];
});
var $a827ff5ac4800fdc$exports = {};

$parcel$export($a827ff5ac4800fdc$exports, "__esModule", function () { return $a827ff5ac4800fdc$export$1e511d4a378977f5; }, function (v) { return $a827ff5ac4800fdc$export$1e511d4a378977f5 = v; });
$parcel$export($a827ff5ac4800fdc$exports, "Distribution", function () { return $a827ff5ac4800fdc$export$af89084a0735e032; }, function (v) { return $a827ff5ac4800fdc$export$af89084a0735e032 = v; });
var $a827ff5ac4800fdc$export$1e511d4a378977f5;
var $a827ff5ac4800fdc$export$af89084a0735e032;
"use strict";
$a827ff5ac4800fdc$export$1e511d4a378977f5 = true;
$a827ff5ac4800fdc$export$af89084a0735e032 = void 0;
var $d251cf9dae77357c$export$1e511d4a378977f5;
var $d251cf9dae77357c$export$af89084a0735e032;
"use strict";
$d251cf9dae77357c$export$1e511d4a378977f5 = true;
$d251cf9dae77357c$export$af89084a0735e032 = void 0;

var $d251cf9dae77357c$var$_react = $d251cf9dae77357c$var$_interopRequireDefault((parcelRequire("2xPiy")));

var $d251cf9dae77357c$var$_propTypes = $d251cf9dae77357c$var$_interopRequireDefault((parcelRequire("dyr1f")));


var $f26b363634b45a7b$export$1e511d4a378977f5;
var $f26b363634b45a7b$export$c58f349dd14b3b94;
"use strict";
$f26b363634b45a7b$export$1e511d4a378977f5 = true;
$f26b363634b45a7b$export$c58f349dd14b3b94 = void 0;

var $f26b363634b45a7b$var$_propTypes = $f26b363634b45a7b$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $f26b363634b45a7b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $f26b363634b45a7b$var$_extends() {
    return $f26b363634b45a7b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f26b363634b45a7b$var$_extends.apply(null, arguments);
}
var $f26b363634b45a7b$var$PropType = {};
$f26b363634b45a7b$var$PropType = $f26b363634b45a7b$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    basis: $f26b363634b45a7b$var$_propTypes["default"].oneOfType([
        $f26b363634b45a7b$var$_propTypes["default"].oneOf([
            'xxsmall',
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            'xxlarge',
            'full',
            '1/2',
            '1/3',
            '2/3',
            '1/4',
            '2/4',
            '3/4',
            'auto'
        ]),
        $f26b363634b45a7b$var$_propTypes["default"].string
    ]),
    children: $f26b363634b45a7b$var$_propTypes["default"].func,
    fill: $f26b363634b45a7b$var$_propTypes["default"].bool,
    gap: $f26b363634b45a7b$var$_propTypes["default"].oneOfType([
        $f26b363634b45a7b$var$_propTypes["default"].oneOf([
            'none',
            'xxsmall',
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        $f26b363634b45a7b$var$_propTypes["default"].string
    ]),
    values: $f26b363634b45a7b$var$_propTypes["default"].arrayOf($f26b363634b45a7b$var$_propTypes["default"].shape({
        value: $f26b363634b45a7b$var$_propTypes["default"].number
    }))
});
var $f26b363634b45a7b$var$DistributionPropTypes = $f26b363634b45a7b$export$c58f349dd14b3b94 = $f26b363634b45a7b$var$PropType;



var $d251cf9dae77357c$var$_excluded = [
    "basis",
    "children",
    "direction",
    "fill",
    "gap",
    "values"
];
function $d251cf9dae77357c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $d251cf9dae77357c$var$_extends() {
    return $d251cf9dae77357c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d251cf9dae77357c$var$_extends.apply(null, arguments);
}
function $d251cf9dae77357c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $d251cf9dae77357c$var$Value = function Value(_ref) {
    var basis = _ref.basis, children = _ref.children;
    return /*#__PURE__*/ $d251cf9dae77357c$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        basis: basis,
        flex: "shrink",
        overflow: "hidden"
    }, children);
};
$d251cf9dae77357c$var$Value.propTypes = {
    basis: $d251cf9dae77357c$var$_propTypes["default"].string.isRequired,
    children: $d251cf9dae77357c$var$_propTypes["default"].node.isRequired
};
var $d251cf9dae77357c$var$defaultChildrenPropValue = function defaultChildrenPropValue(value) {
    return /*#__PURE__*/ $d251cf9dae77357c$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        fill: true,
        border: true
    }, /*#__PURE__*/ $d251cf9dae77357c$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, null, value.value));
};
var $d251cf9dae77357c$var$defaultValues = [];
var $d251cf9dae77357c$var$_Distribution = $d251cf9dae77357c$export$af89084a0735e032 = function Distribution(_ref2) {
    var basis = _ref2.basis, _ref2$children = _ref2.children, children = _ref2$children === void 0 ? $d251cf9dae77357c$var$defaultChildrenPropValue : _ref2$children, _ref2$direction = _ref2.direction, direction = _ref2$direction === void 0 ? 'row' : _ref2$direction, fill = _ref2.fill, gap = _ref2.gap, _ref2$values = _ref2.values, values = _ref2$values === void 0 ? $d251cf9dae77357c$var$defaultValues : _ref2$values, rest = $d251cf9dae77357c$var$_objectWithoutPropertiesLoose(_ref2, $d251cf9dae77357c$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    if (values.length === 1) {
        var value = values[0];
        return /*#__PURE__*/ $d251cf9dae77357c$var$_react["default"].createElement($d251cf9dae77357c$var$Value, {
            value: value,
            basis: basis
        }, children(value));
    }
    if (values.length > 1) {
        var _theme$distribution, _theme$distribution2, _theme$distribution3;
        var reducer = function reducer(accumulator, _ref3) {
            var value = _ref3.value;
            return accumulator + (value || 0);
        };
        var total = values.filter(function(v) {
            return Object.prototype.hasOwnProperty.call(v, 'value');
        }).reduce(reducer, 0);
        // figure out how many of the values area needed to represent half of the
        // total
        var subTotal = 0;
        var subIndex;
        values.some(function(v, index) {
            subTotal += Object.prototype.hasOwnProperty.call(v, 'value') && v.value || 0;
            if (subTotal >= total * 0.4) {
                subIndex = index + 1;
                return true;
            }
            return false;
        });
        if (subIndex === values.length) {
            var _value = values[0];
            return /*#__PURE__*/ $d251cf9dae77357c$var$_react["default"].createElement($d251cf9dae77357c$var$Value, {
                value: _value,
                basis: basis
            }, children(_value));
        }
        var childBasis;
        if (subTotal === 0) childBasis = [
            '0px',
            '0px'
        ];
        else if (subTotal === total) childBasis = [
            'full',
            '0px'
        ];
        else if (subTotal > total * 0.7) childBasis = [
            '3/4',
            '1/4'
        ];
        else if (subTotal > total * 0.6) childBasis = [
            '2/3',
            '1/3'
        ];
        else childBasis = [
            '1/2',
            '1/2'
        ];
        return /*#__PURE__*/ $d251cf9dae77357c$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $d251cf9dae77357c$var$_extends({
            direction: direction,
            basis: basis,
            flex: basis ? 'shrink' : true,
            overflow: "hidden",
            gap: gap || ((_theme$distribution = theme.distribution) == null ? void 0 : _theme$distribution.gap),
            fill: fill
        }, rest), /*#__PURE__*/ $d251cf9dae77357c$var$_react["default"].createElement($d251cf9dae77357c$var$_Distribution, {
            values: values.slice(0, subIndex),
            basis: childBasis[0],
            direction: direction === 'row' ? 'column' : 'row',
            gap: gap || ((_theme$distribution2 = theme.distribution) == null ? void 0 : _theme$distribution2.gap)
        }, children), /*#__PURE__*/ $d251cf9dae77357c$var$_react["default"].createElement($d251cf9dae77357c$var$_Distribution, {
            values: values.slice(subIndex),
            basis: childBasis[1],
            direction: direction === 'row' ? 'column' : 'row',
            gap: gap || ((_theme$distribution3 = theme.distribution) == null ? void 0 : _theme$distribution3.gap)
        }, children));
    }
    return null;
};
$d251cf9dae77357c$var$_Distribution.propTypes = $f26b363634b45a7b$export$c58f349dd14b3b94;


$a827ff5ac4800fdc$export$af89084a0735e032 = $d251cf9dae77357c$export$af89084a0735e032;


Object.keys($a827ff5ac4800fdc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $a827ff5ac4800fdc$exports[key]) return;
    $3321243da0932e1e$exports[key] = $a827ff5ac4800fdc$exports[key];
});

Object.keys($9097252a6690f3a9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $9097252a6690f3a9$exports[key]) return;
    $3321243da0932e1e$exports[key] = $9097252a6690f3a9$exports[key];
});

Object.keys($d7e2a556593dc38b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $d7e2a556593dc38b$exports[key]) return;
    $3321243da0932e1e$exports[key] = $d7e2a556593dc38b$exports[key];
});
var $270cc83832d3f244$exports = {};

$parcel$export($270cc83832d3f244$exports, "__esModule", function () { return $270cc83832d3f244$export$1e511d4a378977f5; }, function (v) { return $270cc83832d3f244$export$1e511d4a378977f5 = v; });
$parcel$export($270cc83832d3f244$exports, "FileInput", function () { return $270cc83832d3f244$export$b57af79a4ab2a1c6; }, function (v) { return $270cc83832d3f244$export$b57af79a4ab2a1c6 = v; });
var $270cc83832d3f244$export$1e511d4a378977f5;
var $270cc83832d3f244$export$b57af79a4ab2a1c6;
"use strict";
$270cc83832d3f244$export$1e511d4a378977f5 = true;
$270cc83832d3f244$export$b57af79a4ab2a1c6 = void 0;
var $c3aca0e60ea649a3$export$1e511d4a378977f5;
var $c3aca0e60ea649a3$export$b57af79a4ab2a1c6;
"use strict";
$c3aca0e60ea649a3$export$1e511d4a378977f5 = true;
$c3aca0e60ea649a3$export$b57af79a4ab2a1c6 = void 0;

var $c3aca0e60ea649a3$var$_react = $c3aca0e60ea649a3$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $c3aca0e60ea649a3$var$_styledComponents = $c3aca0e60ea649a3$var$_interopRequireDefault((parcelRequire("iA1nz")));
var $75c79f8c08ff67ad$exports = {};

$parcel$export($75c79f8c08ff67ad$exports, "__esModule", function () { return $75c79f8c08ff67ad$export$1e511d4a378977f5; }, function (v) { return $75c79f8c08ff67ad$export$1e511d4a378977f5 = v; });
$parcel$export($75c79f8c08ff67ad$exports, "CircleAlert", function () { return $75c79f8c08ff67ad$export$5a89edf87f611fb5; }, function (v) { return $75c79f8c08ff67ad$export$5a89edf87f611fb5 = v; });
var $75c79f8c08ff67ad$export$1e511d4a378977f5;
var $75c79f8c08ff67ad$export$5a89edf87f611fb5;
"use strict";
$75c79f8c08ff67ad$export$1e511d4a378977f5 = true;
$75c79f8c08ff67ad$export$5a89edf87f611fb5 = void 0;

var $75c79f8c08ff67ad$var$_react = $75c79f8c08ff67ad$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $75c79f8c08ff67ad$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($75c79f8c08ff67ad$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $75c79f8c08ff67ad$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $75c79f8c08ff67ad$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $75c79f8c08ff67ad$var$_extends() {
    return $75c79f8c08ff67ad$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $75c79f8c08ff67ad$var$_extends.apply(null, arguments);
}
var $75c79f8c08ff67ad$var$CircleAlert = $75c79f8c08ff67ad$export$5a89edf87f611fb5 = /*#__PURE__*/ (0, $75c79f8c08ff67ad$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $75c79f8c08ff67ad$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $75c79f8c08ff67ad$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CircleAlert"
    }, props), /*#__PURE__*/ $75c79f8c08ff67ad$var$_react["default"].createElement("path", {
        stroke: "#000",
        strokeWidth: "2",
        fill: "none",
        d: "M12 14V6m0 12v-2m0-14C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z"
    }));
});
$75c79f8c08ff67ad$var$CircleAlert.displayName = 'CircleAlert';










var $68084d0c5cff0159$export$1e511d4a378977f5;
var $68084d0c5cff0159$export$f603a3fe6ec80865;
"use strict";
$68084d0c5cff0159$export$1e511d4a378977f5 = true;
$68084d0c5cff0159$export$f603a3fe6ec80865 = void 0;

var $68084d0c5cff0159$var$_styledComponents = $68084d0c5cff0159$var$_interopRequireDefault((parcelRequire("iA1nz")));

function $68084d0c5cff0159$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $68084d0c5cff0159$var$StyledFileInput = $68084d0c5cff0159$export$f603a3fe6ec80865 = $68084d0c5cff0159$var$_styledComponents["default"].input.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledFileInput",
    componentId: "sc-rl7ywv-0"
})([
    "position:absolute;height:100%;width:100%;",
    " font-size:0;opacity:0;border:none;",
    " ",
    " &::-moz-focus-inner{border:none;outline:none;}&::-webkit-file-upload-button{cursor:pointer;}"
], $4113023f9e0bafa0$exports.inputStyle, function(props) {
    return !props.disabled && 'cursor: pointer;';
}, function(props) {
    return props.rightOffset && "\n    width: calc(100% - " + props.rightOffset + "px);\n    right: " + props.rightOffset + "px;\n    ";
});


var $407029fff3a3fc38$export$1e511d4a378977f5;
var $407029fff3a3fc38$export$659d53017e8cbd51;
"use strict";
$407029fff3a3fc38$export$1e511d4a378977f5 = true;
$407029fff3a3fc38$export$659d53017e8cbd51 = void 0;

var $407029fff3a3fc38$var$_propTypes = $407029fff3a3fc38$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $407029fff3a3fc38$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $407029fff3a3fc38$var$PropType = {};
$407029fff3a3fc38$var$PropType = {
    confirmRemove: $407029fff3a3fc38$var$_propTypes["default"].func,
    disabled: $407029fff3a3fc38$var$_propTypes["default"].bool,
    id: $407029fff3a3fc38$var$_propTypes["default"].string,
    maxSize: $407029fff3a3fc38$var$_propTypes["default"].number,
    messages: $407029fff3a3fc38$var$_propTypes["default"].shape({
        alert: $407029fff3a3fc38$var$_propTypes["default"].shape({
            maxFile: $407029fff3a3fc38$var$_propTypes["default"].string,
            maxSize: $407029fff3a3fc38$var$_propTypes["default"].string
        }),
        browse: $407029fff3a3fc38$var$_propTypes["default"].string,
        dropPrompt: $407029fff3a3fc38$var$_propTypes["default"].string,
        dropPromptMultiple: $407029fff3a3fc38$var$_propTypes["default"].string,
        files: $407029fff3a3fc38$var$_propTypes["default"].string,
        maxFile: $407029fff3a3fc38$var$_propTypes["default"].string,
        maxSizeSingle: $407029fff3a3fc38$var$_propTypes["default"].string,
        maxSizeMultiple: $407029fff3a3fc38$var$_propTypes["default"].shape({
            singular: $407029fff3a3fc38$var$_propTypes["default"].string,
            plural: $407029fff3a3fc38$var$_propTypes["default"].string
        }),
        remove: $407029fff3a3fc38$var$_propTypes["default"].string,
        removeAll: $407029fff3a3fc38$var$_propTypes["default"].string
    }),
    multiple: $407029fff3a3fc38$var$_propTypes["default"].oneOfType([
        $407029fff3a3fc38$var$_propTypes["default"].bool,
        $407029fff3a3fc38$var$_propTypes["default"].shape({
            aggregateThreshold: $407029fff3a3fc38$var$_propTypes["default"].number
        })
    ]),
    name: $407029fff3a3fc38$var$_propTypes["default"].string,
    onChange: $407029fff3a3fc38$var$_propTypes["default"].func,
    renderFile: $407029fff3a3fc38$var$_propTypes["default"].func
};
var $407029fff3a3fc38$var$FileInputPropTypes = $407029fff3a3fc38$export$659d53017e8cbd51 = $407029fff3a3fc38$var$PropType;


var $cde97e45ffc50674$export$1e511d4a378977f5;
var $cde97e45ffc50674$export$e1a3971de07c83b5;
"use strict";
$cde97e45ffc50674$export$1e511d4a378977f5 = true;
$cde97e45ffc50674$export$e1a3971de07c83b5 = void 0;
var $cde97e45ffc50674$var$SI_CONVERSION_FACTOR = 1000;
var $cde97e45ffc50674$var$IEC_CONVERSION_FACTOR = 1024;
var $cde97e45ffc50674$var$getCurrentOS = function getCurrentOS() {
    var currentOS = [
        'Win',
        'Linux',
        'Mac'
    ].find(function(v) {
        var _window;
        if (typeof window !== 'undefined') return ((_window = window) == null || (_window = _window.navigator) == null || (_window = _window.userAgent) == null ? void 0 : _window.indexOf(v)) >= 0;
        return undefined;
    });
    return currentOS;
};
var $cde97e45ffc50674$var$defaultFormat = function defaultFormat(size) {
    var units = [
        'B',
        'KB',
        'MB',
        'GB',
        'TB'
    ];
    var factor = $cde97e45ffc50674$var$SI_CONVERSION_FACTOR;
    var index = 0;
    var num = size;
    while(num >= factor && index < units.length - 1){
        num /= factor;
        index += 1;
    }
    return num.toFixed(1) + " " + units[index];
};
var $cde97e45ffc50674$var$windowsFormat = function windowsFormat(size) {
    var num = Math.ceil(size / $cde97e45ffc50674$var$IEC_CONVERSION_FACTOR);
    return Intl.NumberFormat().format(num) + " KB";
};
var $cde97e45ffc50674$var$makeFormatBytes = function makeFormatBytes(OS) {
    return function(size) {
        switch(OS){
            case 'Win':
                return $cde97e45ffc50674$var$windowsFormat(size);
            default:
                return $cde97e45ffc50674$var$defaultFormat(size);
        }
    };
};
var $cde97e45ffc50674$var$formatBytes = $cde97e45ffc50674$export$e1a3971de07c83b5 = $cde97e45ffc50674$var$makeFormatBytes($cde97e45ffc50674$var$getCurrentOS());



var $c3aca0e60ea649a3$var$_excluded = [
    "a11yTitle",
    "background",
    "border",
    "confirmRemove",
    "disabled",
    "id",
    "plain",
    "renderFile",
    "maxSize",
    "messages",
    "margin",
    "multiple",
    "name",
    "onChange",
    "pad",
    "value"
];
function $c3aca0e60ea649a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $c3aca0e60ea649a3$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($c3aca0e60ea649a3$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $c3aca0e60ea649a3$var$_extends() {
    return $c3aca0e60ea649a3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c3aca0e60ea649a3$var$_extends.apply(null, arguments);
}
function $c3aca0e60ea649a3$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// We want the interaction of <input type="file" /> but none of its styling.
// So, we put what we want to show underneath and
// position the <input /> on top with an opacity of zero.
// If there are any files selected, we need to show the buttons to remove them.
// So, we offset the <input /> from the right by the appropriate width.
// We don't use Stack because of how we need to control the positioning.
var $c3aca0e60ea649a3$var$ContentsBox = (0, $c3aca0e60ea649a3$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "FileInput__ContentsBox",
    componentId: "sc-1jzq7im-0"
})([
    "cursor:pointer;position:relative;",
    " ",
    ";",
    ";",
    ";",
    ";",
    ";"
], function(props) {
    return props.disabled && (0, $4113023f9e0bafa0$exports.disabledStyle)();
}, function(props) {
    return props.theme.fileInput && props.theme.fileInput.extend;
}, function(props) {
    return props.hover && props.theme.fileInput && props.theme.fileInput.hover && props.theme.fileInput.hover.extend;
}, function(props) {
    return props.dragOver && props.theme.fileInput && props.theme.fileInput.dragOver && props.theme.fileInput.dragOver.extend;
}, function(props) {
    return props.focus && (0, $4113023f9e0bafa0$exports.focusStyle)();
}, function(props) {
    return !props.focus && (0, $4113023f9e0bafa0$exports.unfocusStyle)();
});
var $c3aca0e60ea649a3$var$Label = (0, $c3aca0e60ea649a3$var$_styledComponents["default"])($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6).withConfig({
    displayName: "FileInput__Label",
    componentId: "sc-1jzq7im-1"
})([
    "",
    ";"
], function(props) {
    return props.theme.fileInput && props.theme.fileInput.label && props.theme.fileInput.label.extend;
});
var $c3aca0e60ea649a3$var$Message = (0, $c3aca0e60ea649a3$var$_styledComponents["default"])($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6).withConfig({
    displayName: "FileInput__Message",
    componentId: "sc-1jzq7im-2"
})([
    "",
    ";"
], function(props) {
    return props.theme.fileInput && props.theme.fileInput.message && props.theme.fileInput.message.extend;
});
var $c3aca0e60ea649a3$var$defaultPendingRemoval = {
    event: undefined,
    index: undefined
};
var $c3aca0e60ea649a3$var$FileInput = $c3aca0e60ea649a3$export$b57af79a4ab2a1c6 = /*#__PURE__*/ (0, $c3aca0e60ea649a3$var$_react.forwardRef)(function(_ref, ref) {
    var _theme$fileInput, _theme$fileInput$anch;
    var a11yTitle = _ref.a11yTitle, background = _ref.background, border = _ref.border, confirmRemove = _ref.confirmRemove, disabled = _ref.disabled, id = _ref.id, plain = _ref.plain, renderFile = _ref.renderFile, maxSize = _ref.maxSize, messages = _ref.messages, margin = _ref.margin, multiple = _ref.multiple, name = _ref.name, _onChange = _ref.onChange, pad = _ref.pad, valueProp = _ref.value, rest = $c3aca0e60ea649a3$var$_objectWithoutPropertiesLoose(_ref, $c3aca0e60ea649a3$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useContext = (0, $c3aca0e60ea649a3$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var formContext = (0, $c3aca0e60ea649a3$var$_react.useContext)($5c9c2e034f522b3e$export$c24727297075ec6a);
    var _React$useState = $c3aca0e60ea649a3$var$_react["default"].useState(), hover = _React$useState[0], setHover = _React$useState[1];
    var _React$useState2 = $c3aca0e60ea649a3$var$_react["default"].useState(), dragOver = _React$useState2[0], setDragOver = _React$useState2[1];
    var _React$useState3 = $c3aca0e60ea649a3$var$_react["default"].useState(), focus = _React$useState3[0], setFocus = _React$useState3[1];
    var _useState = (0, $c3aca0e60ea649a3$var$_react.useState)(false), showRemoveConfirmation = _useState[0], setShowRemoveConfirmation = _useState[1];
    var _useState2 = (0, $c3aca0e60ea649a3$var$_react.useState)($c3aca0e60ea649a3$var$defaultPendingRemoval), pendingRemoval = _useState2[0], setPendingRemoval = _useState2[1];
    var aggregateThreshold = multiple && multiple.aggregateThreshold || 10;
    var max = multiple == null ? void 0 : multiple.max;
    var inputRef = (0, $4113023f9e0bafa0$exports.useForwardedRef)(ref);
    var controlRef = (0, $c3aca0e60ea649a3$var$_react.useRef)();
    var removeRef = (0, $c3aca0e60ea649a3$var$_react.useRef)();
    var ConfirmRemove = confirmRemove;
    var RemoveIcon = theme.fileInput.icons.remove;
    var ErrorIcon = ((_theme$fileInput = theme.fileInput) == null || (_theme$fileInput = _theme$fileInput.icons) == null ? void 0 : _theme$fileInput.error) || $75c79f8c08ff67ad$export$5a89edf87f611fb5;
    var usingKeyboard = (0, $4113023f9e0bafa0$exports.useKeyboard)();
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp,
        initialValue: [],
        validate: [
            typeof maxSize === 'number' ? function() {
                var fileList = [].concat(files);
                var message = '';
                var numOfInvalidFiles = fileList.filter(function(_ref2) {
                    var size = _ref2.size;
                    return size > maxSize;
                }).length;
                if (numOfInvalidFiles) {
                    var _fileList$find;
                    var messageId = 'fileInput.maxSizeSingle';
                    if (multiple) messageId = "fileInput.maxSizeMultiple." + (numOfInvalidFiles === 1 ? 'singular' : 'plural');
                    message = format({
                        id: messageId,
                        messages: messages,
                        values: {
                            fileName: (_fileList$find = fileList.find(function(_ref3) {
                                var size = _ref3.size;
                                return size > maxSize;
                            })) == null ? void 0 : _fileList$find.name,
                            maxSize: (0, $cde97e45ffc50674$export$e1a3971de07c83b5)(maxSize),
                            numOfFiles: numOfInvalidFiles
                        }
                    });
                }
                return message;
            } : '',
            max ? function() {
                var fileList = [].concat(files);
                var message = '';
                if (fileList.length > max) message = format({
                    id: 'fileInput.maxFile',
                    messages: messages,
                    values: {
                        max: max
                    }
                });
                return message;
            } : ''
        ]
    }), files = _formContext$useFormI[0], setFiles = _formContext$useFormI[1];
    var mergeTheme = function mergeTheme(propertyName, defaultKey) {
        var result = {};
        var themeProp = theme.fileInput[propertyName];
        if (themeProp) {
            if (typeof themeProp !== 'object') {
                if (defaultKey) result[defaultKey] = themeProp;
                else result = themeProp;
            } else result = $c3aca0e60ea649a3$var$_extends({}, themeProp);
        }
        var hoverThemeProp = theme.fileInput.hover[propertyName];
        if (hover && hoverThemeProp) {
            if (typeof hoverThemeProp !== 'object') {
                if (defaultKey) result[defaultKey] = hoverThemeProp;
                else result = hoverThemeProp;
            } else result = $c3aca0e60ea649a3$var$_extends({}, result, hoverThemeProp);
        }
        var dragOverThemeProp = theme.fileInput.dragOver[propertyName];
        if (dragOver && dragOverThemeProp) {
            if (typeof dragOverThemeProp !== 'object') {
                if (defaultKey) result[defaultKey] = dragOverThemeProp;
                else result = dragOverThemeProp;
            } else result = $c3aca0e60ea649a3$var$_extends({}, result, dragOverThemeProp);
        }
        return typeof result === 'object' && Object.keys(result).length === 0 ? undefined : result;
    };
    // Show the number of files when more than one
    var message;
    if (!files.length) message = format({
        id: multiple ? 'fileInput.dropPromptMultiple' : 'fileInput.dropPrompt',
        messages: messages
    });
    else message = files.length + " items";
    var removeFile = function removeFile(index) {
        var nextFiles;
        if (index === 'all') nextFiles = [];
        else {
            nextFiles = [].concat(files);
            nextFiles.splice(index, 1);
        }
        setFiles(nextFiles);
        // Need to have a way to track the files other than an array
        // since inputRef.current.files is a read-only FileList
        // https://stackoverflow.com/a/64019766
        /* eslint-disable no-undef */ var dt = new DataTransfer();
        var curFiles = inputRef.current.files;
        if (index === 'all' || nextFiles.length === 0) inputRef.current.value = '';
        for(var i = 0; i < curFiles.length; i += 1){
            var curfile = curFiles[i];
            if (index !== i) dt.items.add(curfile);
        }
        var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'files').set;
        nativeInputValueSetter.call(inputRef.current, dt.files);
        var event = new Event('input', {
            bubbles: true
        });
        inputRef.current.dispatchEvent(event);
        if (_onChange) _onChange(event, {
            files: nextFiles
        });
        inputRef.current.focus();
    };
    // rightPad needs to be included in the rightOffset
    // otherwise input may cover the RemoveButton, making it
    // unreachable by mouse click.
    var rightPad = '0px';
    if (mergeTheme('pad')) {
        var _mergeTheme = mergeTheme('pad'), horizontal = _mergeTheme.horizontal, right = _mergeTheme.right;
        if (right) rightPad = theme.global.edgeSize[right] || right;
        else if (horizontal) rightPad = theme.global.edgeSize[horizontal] || horizontal;
    }
    var removeWidth = removeRef.current ? removeRef.current.getBoundingClientRect().width : 0;
    var controlWidth = controlRef.current ? controlRef.current.getBoundingClientRect().width : 0;
    if (controlRef.current && (_theme$fileInput$anch = theme.fileInput.anchor) != null && _theme$fileInput$anch.margin) {
        if (typeof theme.fileInput.anchor.margin === 'string') controlWidth += parseInt(theme.global.edgeSize[theme.fileInput.anchor.margin] || theme.fileInput.anchor.margin, 10) * 2;
        else if (typeof theme.fileInput.anchor.margin === 'object') {
            var _theme$fileInput$anch2, _theme$fileInput$anch3, _theme$fileInput$anch4;
            if ((_theme$fileInput$anch2 = theme.fileInput.anchor.margin) != null && _theme$fileInput$anch2.horizontal) controlWidth += parseInt(theme.global.edgeSize[theme.fileInput.anchor.margin.horizontal] || theme.fileInput.anchor.margin.horizontal, 10) * 2;
            if ((_theme$fileInput$anch3 = theme.fileInput.anchor.margin) != null && _theme$fileInput$anch3.right) controlWidth += parseInt(theme.global.edgeSize[theme.fileInput.anchor.margin.right] || theme.fileInput.anchor.margin.right, 10);
            if ((_theme$fileInput$anch4 = theme.fileInput.anchor.margin) != null && _theme$fileInput$anch4.left) controlWidth += parseInt(theme.global.edgeSize[theme.fileInput.anchor.margin.left] || theme.fileInput.anchor.margin.left, 10);
        }
    }
    var rightOffset = files.length > 1 ? removeWidth + parseInt(rightPad, 10) : removeWidth + controlWidth + parseInt(rightPad, 10);
    return /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($c3aca0e60ea649a3$var$_react["default"].Fragment, null, /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($c3aca0e60ea649a3$var$ContentsBox, $c3aca0e60ea649a3$var$_extends({
        theme: theme,
        flex: false,
        disabled: disabled,
        background: mergeTheme('background', 'color'),
        border: !plain ? mergeTheme('border', 'side') : undefined,
        margin: mergeTheme('margin'),
        pad: mergeTheme('pad'),
        round: mergeTheme('round', 'size'),
        align: files.length ? 'stretch' : 'center',
        justify: "center",
        hover: hover,
        onMouseOver: disabled ? undefined : function() {
            return setHover(true);
        },
        onMouseOut: disabled ? undefined : function() {
            return setHover(false);
        },
        dragOver: dragOver,
        focus: usingKeyboard && focus
    }, passThemeFlag), /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($68084d0c5cff0159$export$f603a3fe6ec80865, $c3aca0e60ea649a3$var$_extends({
        ref: inputRef,
        type: "file",
        id: id,
        name: name,
        maxSize: maxSize,
        multiple: multiple,
        disabled: disabled,
        plain: true,
        "aria-invalid": maxSize && files.some(function(f) {
            return f.size > maxSize;
        }) || max != null && files.length > max,
        rightOffset: rightOffset || undefined
    }, passThemeFlag, rest, {
        onDragOver: function onDragOver() {
            return setDragOver(true);
        },
        onDragLeave: function onDragLeave() {
            return setDragOver(false);
        },
        onChange: function onChange(event) {
            event.persist();
            var fileList = event.target.files;
            // If the user cancelled the file picker, fileList will be empty
            // and we should not clear any previously selected files.
            if (!fileList.length && files.length) return;
            var nextFiles = multiple ? [].concat(files) : [];
            var _loop = function _loop(i) {
                // avoid duplicates
                var existing = nextFiles.filter(function(file) {
                    return file.name === fileList[i].name && file.size === fileList[i].size;
                }).length > 0;
                if (!existing) nextFiles.push(fileList[i]);
            };
            for(var i = 0; i < fileList.length; i += 1)_loop(i);
            setFiles(nextFiles);
            setDragOver(false);
            if (_onChange) _onChange(event, {
                files: nextFiles
            });
        },
        onBlur: function onBlur() {
            return setFocus(false);
        },
        onFocus: function onFocus() {
            return setFocus(true);
        }
    })), (!files.length || files.length > 1) && /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        align: "center",
        fill: "horizontal",
        direction: "row",
        justify: "between"
    }, files.length <= aggregateThreshold && /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($c3aca0e60ea649a3$var$_react["default"].Fragment, null, /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($c3aca0e60ea649a3$var$Message, $c3aca0e60ea649a3$var$_extends({}, theme.fileInput.message, passThemeFlag), message), /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onSpace: function onSpace(event) {
            event.preventDefault();
            if (controlRef.current === event.target) inputRef.current.click();
        },
        onEnter: function onEnter(event) {
            if (controlRef.current === event.target) inputRef.current.click();
        }
    }, theme.fileInput.button ? /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
        tabIndex: -1,
        disabled: disabled,
        ref: controlRef,
        kind: theme.fileInput.button,
        label: format({
            id: 'fileInput.browse',
            messages: messages
        }),
        onClick: function onClick() {
            inputRef.current.click();
            inputRef.current.focus();
        }
    }) : /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($e78646567f384248$export$b688253958b8dfe7, {
        tabIndex: -1,
        alignSelf: "center",
        disabled: disabled,
        ref: controlRef,
        margin: theme.fileInput.anchor.margin,
        onClick: function onClick() {
            inputRef.current.click();
            inputRef.current.focus();
        },
        label: format({
            id: 'fileInput.browse',
            messages: messages
        })
    })))), files.length > aggregateThreshold && /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        justify: "between",
        direction: "row",
        align: "center"
    }, /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($c3aca0e60ea649a3$var$Label, $c3aca0e60ea649a3$var$_extends({}, theme.fileInput.label, passThemeFlag), files.length, ' ', format({
        id: 'fileInput.files',
        messages: messages
    })), /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        flex: false,
        direction: "row",
        align: "center"
    }, /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
        ref: removeRef,
        a11yTitle: format({
            id: 'fileInput.removeAll',
            messages: messages
        }),
        icon: /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement(RemoveIcon, null),
        hoverIndicator: true,
        disabled: disabled,
        onClick: function onClick(event) {
            if (confirmRemove) {
                event.persist(); // necessary for when React < v17
                setPendingRemoval({
                    event: event,
                    index: 'all'
                });
                setShowRemoveConfirmation(true);
            } else removeFile('all');
        }
    }), /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onSpace: function onSpace(event) {
            if (controlRef.current === event.target) inputRef.current.click();
        },
        onEnter: function onEnter(event) {
            if (controlRef.current === event.target) inputRef.current.click();
        }
    }, theme.fileInput.button ? /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
        tabIndex: -1,
        disabled: disabled,
        ref: controlRef,
        kind: theme.fileInput.button,
        label: format({
            id: 'fileInput.browse',
            messages: messages
        }),
        onClick: function onClick() {
            inputRef.current.click();
            inputRef.current.focus();
        }
    }) : /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($e78646567f384248$export$b688253958b8dfe7, {
        tabIndex: -1,
        alignSelf: "center",
        disabled: disabled,
        ref: controlRef,
        margin: theme.fileInput.anchor.margin,
        onClick: function onClick() {
            inputRef.current.click();
            inputRef.current.focus();
        },
        label: format({
            id: 'fileInput.browse',
            messages: messages
        })
    })))), files.length > 0 && files.length <= aggregateThreshold && files.map(function(file, index) {
        var messageId = '';
        if (maxSize && file.size > maxSize) messageId = 'fileInput.alert.maxSize';
        else if (max && index >= max) messageId = 'fileInput.alert.maxFile';
        return /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            key: file.name,
            justify: "between",
            direction: "row",
            align: "center"
        }, renderFile ? renderFile(file) : /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $c3aca0e60ea649a3$var$_extends({}, theme.fileInput.label, {
            align: "center",
            direction: "row"
        }), (typeof maxSize === 'number' && file.size > maxSize || typeof max === 'number' && index >= max) && /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement(ErrorIcon, {
            a11yTitle: format({
                id: messageId,
                messages: messages,
                values: {
                    maxFile: max,
                    fileName: file.name,
                    maxSize: (0, $cde97e45ffc50674$export$e1a3971de07c83b5)(maxSize)
                }
            })
        }), /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($c3aca0e60ea649a3$var$Label, $c3aca0e60ea649a3$var$_extends({
            weight: theme.global.input.weight || theme.global.input.font.weight,
            truncate: true
        }, passThemeFlag), file.name)), /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            flex: false,
            direction: "row",
            align: "center"
        }, /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
            ref: index ? undefined : removeRef,
            a11yTitle: format({
                id: 'fileInput.remove',
                messages: messages,
                values: {
                    fileName: file.name
                }
            }),
            icon: /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement(RemoveIcon, null),
            hoverIndicator: true,
            disabled: disabled,
            onClick: function onClick(event) {
                if (confirmRemove) {
                    event.persist(); // necessary for when React < v17
                    setPendingRemoval({
                        event: event,
                        index: index
                    });
                    setShowRemoveConfirmation(true);
                } else removeFile(index);
            }
        }), files.length === 1 && /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
            onSpace: function onSpace(event) {
                if (controlRef.current === event.target) inputRef.current.click();
            },
            onEnter: function onEnter(event) {
                if (controlRef.current === event.target) inputRef.current.click();
            }
        }, theme.fileInput.button ? /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
            tabIndex: -1,
            disabled: disabled,
            ref: controlRef,
            kind: theme.fileInput.button,
            label: format({
                id: 'fileInput.browse',
                messages: messages
            }),
            onClick: function onClick() {
                inputRef.current.click();
                inputRef.current.focus();
            }
        }) : /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement($e78646567f384248$export$b688253958b8dfe7, {
            tabIndex: -1,
            disabled: disabled,
            ref: controlRef,
            margin: theme.fileInput.anchor.margin,
            onClick: function onClick() {
                inputRef.current.click();
                inputRef.current.focus();
            },
            label: format({
                id: 'fileInput.browse',
                messages: messages
            })
        }))));
    })), showRemoveConfirmation && /*#__PURE__*/ $c3aca0e60ea649a3$var$_react["default"].createElement(ConfirmRemove, {
        onConfirm: function onConfirm() {
            removeFile(pendingRemoval.index);
            setPendingRemoval($c3aca0e60ea649a3$var$defaultPendingRemoval);
            setShowRemoveConfirmation(false);
        },
        onCancel: function onCancel() {
            return setShowRemoveConfirmation(false);
        }
    }));
});
$c3aca0e60ea649a3$var$FileInput.displayName = 'FileInput';
$c3aca0e60ea649a3$var$FileInput.propTypes = $407029fff3a3fc38$export$659d53017e8cbd51;


$270cc83832d3f244$export$b57af79a4ab2a1c6 = $c3aca0e60ea649a3$export$b57af79a4ab2a1c6;


Object.keys($270cc83832d3f244$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $270cc83832d3f244$exports[key]) return;
    $3321243da0932e1e$exports[key] = $270cc83832d3f244$exports[key];
});

Object.keys($267fa7db763dabfc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $267fa7db763dabfc$exports[key]) return;
    $3321243da0932e1e$exports[key] = $267fa7db763dabfc$exports[key];
});

Object.keys($b39d3fd88e3f6fd8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $b39d3fd88e3f6fd8$exports[key]) return;
    $3321243da0932e1e$exports[key] = $b39d3fd88e3f6fd8$exports[key];
});

Object.keys($af5ba9f7873798c6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $af5ba9f7873798c6$exports[key]) return;
    $3321243da0932e1e$exports[key] = $af5ba9f7873798c6$exports[key];
});

Object.keys($f75e849c2101cc4f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $f75e849c2101cc4f$exports[key]) return;
    $3321243da0932e1e$exports[key] = $f75e849c2101cc4f$exports[key];
});
var $bd3ef218560ec2c7$exports = {};

$parcel$export($bd3ef218560ec2c7$exports, "__esModule", function () { return $bd3ef218560ec2c7$export$1e511d4a378977f5; }, function (v) { return $bd3ef218560ec2c7$export$1e511d4a378977f5 = v; });
$parcel$export($bd3ef218560ec2c7$exports, "Grommet", function () { return $bd3ef218560ec2c7$export$efa1b86658154a31; }, function (v) { return $bd3ef218560ec2c7$export$efa1b86658154a31 = v; });
var $bd3ef218560ec2c7$export$1e511d4a378977f5;
var $bd3ef218560ec2c7$export$efa1b86658154a31;
"use strict";
$bd3ef218560ec2c7$export$1e511d4a378977f5 = true;
$bd3ef218560ec2c7$export$efa1b86658154a31 = void 0;
var $1f098cad96ce2c33$export$1e511d4a378977f5;
var $1f098cad96ce2c33$export$efa1b86658154a31;
"use strict";
$1f098cad96ce2c33$export$1e511d4a378977f5 = true;
$1f098cad96ce2c33$export$efa1b86658154a31 = void 0;

var $1f098cad96ce2c33$var$_react = $1f098cad96ce2c33$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $iA1nz = parcelRequire("iA1nz");



var $b924648a6cb15f84$export$1e511d4a378977f5;
var $b924648a6cb15f84$export$455b75b425a04280;
"use strict";
$b924648a6cb15f84$export$1e511d4a378977f5 = true;
$b924648a6cb15f84$export$455b75b425a04280 = void 0;

var $b924648a6cb15f84$var$_styledComponents = $b924648a6cb15f84$var$_interopRequireWildcard((parcelRequire("iA1nz")));

function $b924648a6cb15f84$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($b924648a6cb15f84$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $b924648a6cb15f84$var$fullStyle = function fullStyle(full) {
    if (full === 'min') return (0, $b924648a6cb15f84$var$_styledComponents.css)([
        "min-height:100vh;"
    ]);
    return (0, $b924648a6cb15f84$var$_styledComponents.css)([
        "width:100vw;height:100vh;overflow:auto;"
    ]);
};
var $b924648a6cb15f84$var$StyledGrommet = $b924648a6cb15f84$export$455b75b425a04280 = $b924648a6cb15f84$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledGrommet",
    componentId: "sc-19lkkz7-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return !props.plain && $4113023f9e0bafa0$exports.baseStyle;
}, function(props) {
    return props.full && $b924648a6cb15f84$var$fullStyle(props.full);
}, function(props) {
    return props.theme.global.font.face;
}, function(props) {
    return props.theme.grommet.extend;
}, function(props) {
    return props.cssVars && Object.keys(props.theme.global.colors).filter(function(k) {
        return typeof props.theme.global.colors[k] === 'string';
    }).map(function(k) {
        return "--" + k + ": " + props.theme.global.colors[k] + ";";
    }).join('\n');
});






var $1f098cad96ce2c33$var$_default = $1f098cad96ce2c33$var$_interopRequireDefault((parcelRequire("3YqNT")));
var $742b7e6bafa18b9d$export$1e511d4a378977f5;
var $742b7e6bafa18b9d$export$5d086f0c0fa8cc7a;
"use strict";
$742b7e6bafa18b9d$export$1e511d4a378977f5 = true;
$742b7e6bafa18b9d$export$5d086f0c0fa8cc7a = void 0;

var $742b7e6bafa18b9d$var$_propTypes = $742b7e6bafa18b9d$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $742b7e6bafa18b9d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $742b7e6bafa18b9d$var$PropType = {};
$742b7e6bafa18b9d$var$PropType = {
    background: $5897bd367fbd90c1$export$aa372966d47f02af,
    dir: $742b7e6bafa18b9d$var$_propTypes["default"].oneOf([
        'rtl'
    ]),
    full: $742b7e6bafa18b9d$var$_propTypes["default"].oneOfType([
        $742b7e6bafa18b9d$var$_propTypes["default"].bool,
        $742b7e6bafa18b9d$var$_propTypes["default"].oneOf([
            'min'
        ])
    ]),
    options: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
        box: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
            cssGap: $742b7e6bafa18b9d$var$_propTypes["default"].bool
        }),
        button: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
            childrenPlain: $742b7e6bafa18b9d$var$_propTypes["default"].bool
        }),
        layer: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
            singleId: $742b7e6bafa18b9d$var$_propTypes["default"].bool
        }),
        drop: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
            checkContainingBlock: $742b7e6bafa18b9d$var$_propTypes["default"].bool
        })
    }),
    plain: $742b7e6bafa18b9d$var$_propTypes["default"].bool,
    cssVars: $742b7e6bafa18b9d$var$_propTypes["default"].bool,
    theme: $742b7e6bafa18b9d$var$_propTypes["default"].object,
    themeMode: $742b7e6bafa18b9d$var$_propTypes["default"].oneOf([
        'dark',
        'light',
        'auto'
    ]),
    userAgent: $742b7e6bafa18b9d$var$_propTypes["default"].string,
    containerTarget: $742b7e6bafa18b9d$var$_propTypes["default"].object,
    messages: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
        format: $742b7e6bafa18b9d$var$_propTypes["default"].func,
        messages: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
            button: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                busy: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                success: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            calendar: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                previousMove: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                previous: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                nextMove: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                next: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            cards: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                moved: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                reorderHint: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                description: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            carousel: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                previous: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                next: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                jump: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            dateInput: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                openCalendar: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                enterCalendar: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                exitCalendar: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                outOfBounds: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            dataChart: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                detailTitle: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                detailFocus: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            dataFilters: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                clear: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                heading: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                open: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                openSet: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                    singular: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                    plural: $742b7e6bafa18b9d$var$_propTypes["default"].string
                })
            }),
            dataForm: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                submit: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            dataSearch: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                label: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                open: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            dataSort: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                ascending: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                by: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                descending: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                direction: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                open: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            dataSummary: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                filtered: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                filteredSingle: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                items: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                itemsSingle: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                selected: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                total: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                totalSingle: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            dataTable: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                ascending: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                collapse: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                collapseAll: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                decrease: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                descending: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                increase: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                expand: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                expandAll: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                resizerAria: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                rows: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                rowsChanged: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                rowsSingle: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                searchBy: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                total: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                totalSingle: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            dataTableColumns: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                open: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                order: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                pinned: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                select: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                tip: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                selectAria: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                orderAria: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            dataTableGroupBy: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                clear: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                label: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            dataView: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                label: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            fileInput: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                alert: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                    maxFile: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                    maxSize: $742b7e6bafa18b9d$var$_propTypes["default"].string
                }),
                browse: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                dropPrompt: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                dropPromptMultiple: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                files: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                maxFile: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                maxSizeSingle: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                maxSizeMultiple: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                    singular: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                    plural: $742b7e6bafa18b9d$var$_propTypes["default"].string
                }),
                remove: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                removeAll: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            form: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                invalid: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                required: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            formField: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                maxCharacters: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                    remaining: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                        singular: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                        plural: $742b7e6bafa18b9d$var$_propTypes["default"].string
                    }),
                    overLimit: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                        singular: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                        plural: $742b7e6bafa18b9d$var$_propTypes["default"].string
                    })
                })
            }),
            list: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                pinned: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            menu: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                openMenu: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                closeMenu: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            meter: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                bar: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                    singular: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                    plural: $742b7e6bafa18b9d$var$_propTypes["default"].string
                }),
                circle: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                    singular: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                    plural: $742b7e6bafa18b9d$var$_propTypes["default"].string
                }),
                pie: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                    singular: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                    plural: $742b7e6bafa18b9d$var$_propTypes["default"].string
                }),
                semicirlce: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                    singular: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                    plural: $742b7e6bafa18b9d$var$_propTypes["default"].string
                })
            }),
            notifcation: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                close: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            pagination: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                stepLabel: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                summary: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                summaryNoItems: $742b7e6bafa18b9d$var$PropType.string
            }),
            rangeSelector: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                lower: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                upper: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            select: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                optionsA11y: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                multiple: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                searchA11y: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                selected: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            selectMultiple: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                clearAll: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                clearAllA11y: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                open: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                optionSelected: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                optionNotSelected: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                optionsA11y: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                search: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                selectAll: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                selectAllA11y: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                selected: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                selectedOfTotal: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                selectDrop: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                selectedOptions: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                showMore: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                summarizedValue: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            skipLinks: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                skipTo: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            stepper: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                progress: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                step: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            tabs: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                nextTab: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                previousTab: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                tabContents: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            tag: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                removeLabel: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                    nameAndValue: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                    valueOnly: $742b7e6bafa18b9d$var$_propTypes["default"].string
                })
            }),
            textInput: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                enterSelect: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                suggestionsCount: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                suggestionsExist: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                suggestionIsOpen: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            timeInput: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                activePeriodValue: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                activeSection: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                activeSectionValue: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                chooseTime: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                currentValue: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                inputLabel: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                invalidTime: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                openDrop: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                sectionHours: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                sectionMeridiem: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                sectionMinutes: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                sectionSeconds: $742b7e6bafa18b9d$var$_propTypes["default"].string
            }),
            video: $742b7e6bafa18b9d$var$_propTypes["default"].shape({
                audioDescriptions: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                captions: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                closeMenu: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                description: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                fullScreen: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                progressMeter: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                scrubber: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                openMenu: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                pauseButton: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                playButton: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                volumeDown: $742b7e6bafa18b9d$var$_propTypes["default"].string,
                volumeUp: $742b7e6bafa18b9d$var$_propTypes["default"].string
            })
        }),
        onAnalytics: $742b7e6bafa18b9d$var$_propTypes["default"].func
    })
};
var $742b7e6bafa18b9d$var$GrommetPropTypes = $742b7e6bafa18b9d$export$5d086f0c0fa8cc7a = $742b7e6bafa18b9d$var$PropType;



var $1f098cad96ce2c33$var$_excluded = [
    "children",
    "full",
    "containerTarget",
    "theme",
    "options",
    "messages",
    "onAnalytics"
];
function $1f098cad96ce2c33$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $1f098cad96ce2c33$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($1f098cad96ce2c33$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $1f098cad96ce2c33$var$_extends() {
    return $1f098cad96ce2c33$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1f098cad96ce2c33$var$_extends.apply(null, arguments);
}
function $1f098cad96ce2c33$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $1f098cad96ce2c33$var$FullGlobalStyle = (0, $iA1nz.createGlobalStyle)([
    "body{margin:0;}"
]);
var $1f098cad96ce2c33$var$defaultOptions = {};
var $1f098cad96ce2c33$var$Grommet = $1f098cad96ce2c33$export$efa1b86658154a31 = /*#__PURE__*/ (0, $1f098cad96ce2c33$var$_react.forwardRef)(function(props, ref) {
    var children = props.children, full = props.full, _props$containerTarge = props.containerTarget, containerTarget = _props$containerTarge === void 0 ? typeof document === 'object' ? document.body : undefined : _props$containerTarge, themeProp = props.theme, _props$options = props.options, options = _props$options === void 0 ? $1f098cad96ce2c33$var$defaultOptions : _props$options, messagesProp = props.messages, onAnalytics = props.onAnalytics, rest = $1f098cad96ce2c33$var$_objectWithoutPropertiesLoose(props, $1f098cad96ce2c33$var$_excluded);
    var background = props.background, dir = props.dir, themeMode = props.themeMode, userAgent = props.userAgent;
    var _useState = (0, $1f098cad96ce2c33$var$_react.useState)(), stateResponsive = _useState[0], setResponsive = _useState[1];
    var theme = (0, $1f098cad96ce2c33$var$_react.useMemo)(function() {
        var nextTheme = (0, $4113023f9e0bafa0$exports.deepMerge)($45e3c754f67e1b77$export$e2253033e6e1df16, themeProp || {});
        // if user provides specific menu alignment, we don't want
        // the defaults to be included at all (can cause issues with controlMirror)
        // override merged value with themeProp value
        if (themeProp && themeProp.menu && themeProp.menu.drop && themeProp.menu.drop.align) {
            delete nextTheme.menu.drop.align;
            nextTheme.menu.drop.align = themeProp.menu.drop.align;
        }
        var themeBackground = nextTheme.global.colors.background;
        nextTheme.dark = (themeMode || nextTheme.defaultMode) === 'dark';
        if (themeMode === 'auto' && typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) nextTheme.dark = true;
        var color = (0, $4113023f9e0bafa0$exports.normalizeColor)(background || themeBackground, nextTheme);
        nextTheme.dark = (0, $4113023f9e0bafa0$exports.backgroundIsDark)(color, nextTheme);
        nextTheme.baseBackground = background || themeBackground;
        // This allows DataTable to intelligently set the background of a pinned
        // header or footer.
        nextTheme.background = nextTheme.baseBackground;
        if (dir) nextTheme.dir = dir;
        return nextTheme;
    }, [
        background,
        dir,
        themeMode,
        themeProp
    ]);
    var messages = (0, $1f098cad96ce2c33$var$_react.useMemo)(function() {
        // combine the passed in messages, if any, with the default
        // messages and format function.
        var nextMessages = (0, $4113023f9e0bafa0$exports.deepMerge)($1f098cad96ce2c33$var$_default["default"], (messagesProp == null ? void 0 : messagesProp.messages) || {});
        return {
            messages: nextMessages,
            format: function format(opts) {
                var message = (messagesProp == null ? void 0 : messagesProp.format) && messagesProp.format(opts);
                return typeof message !== 'undefined' ? message : (0, $3b30be80b148b2c8$export$d9468344d3651243)(opts, nextMessages);
            }
        };
    }, [
        messagesProp
    ]);
    (0, $1f098cad96ce2c33$var$_react.useEffect)(function() {
        var onResize = function onResize() {
            var _document$body$client, _document$body;
            setResponsive((0, $4113023f9e0bafa0$exports.getBreakpoint)((_document$body$client = (_document$body = document.body) == null ? void 0 : _document$body.clientWidth) != null ? _document$body$client : window.innerWidth, theme));
        };
        window.addEventListener('resize', onResize);
        onResize();
        return function() {
            window.removeEventListener('resize', onResize);
        };
    }, [
        theme
    ]);
    var responsive = stateResponsive || (0, $4113023f9e0bafa0$exports.deviceResponsive)(userAgent, theme) || theme.global.deviceBreakpoints.tablet;
    var grommetRef = (0, $4113023f9e0bafa0$exports.useForwardedRef)(ref);
    // track open FocusedContainers in a global array to manage
    // focus event listeners for trapFocus
    var roots = (0, $1f098cad96ce2c33$var$_react.useRef)([]);
    (0, $1f098cad96ce2c33$var$_react.useEffect)(function() {
        if (grommetRef.current) roots.current.push(grommetRef.current);
    }, [
        grommetRef
    ]);
    var rootsContextValue = (0, $1f098cad96ce2c33$var$_react.useMemo)(function() {
        return {
            roots: roots
        };
    }, []);
    return /*#__PURE__*/ $1f098cad96ce2c33$var$_react["default"].createElement($58f4f715ab4fa2c4$exports.ThemeContext.Provider, {
        value: theme
    }, /*#__PURE__*/ $1f098cad96ce2c33$var$_react["default"].createElement($58f4f715ab4fa2c4$exports.ResponsiveContext.Provider, {
        value: responsive
    }, /*#__PURE__*/ $1f098cad96ce2c33$var$_react["default"].createElement($f4322a4a0d63b89f$export$1eeeeda725eeeda.Provider, {
        value: rootsContextValue
    }, /*#__PURE__*/ $1f098cad96ce2c33$var$_react["default"].createElement($58f4f715ab4fa2c4$exports.ContainerTargetContext.Provider, {
        value: containerTarget
    }, /*#__PURE__*/ $1f098cad96ce2c33$var$_react["default"].createElement($cddec80c12094a96$export$b709306b005c3ef.Provider, {
        value: options
    }, /*#__PURE__*/ $1f098cad96ce2c33$var$_react["default"].createElement($3b30be80b148b2c8$export$b060d577040138d8.Provider, {
        value: messages
    }, /*#__PURE__*/ $1f098cad96ce2c33$var$_react["default"].createElement($995522def9ecf485$exports.AnalyticsProvider, {
        onAnalytics: onAnalytics
    }, /*#__PURE__*/ $1f098cad96ce2c33$var$_react["default"].createElement($b924648a6cb15f84$export$455b75b425a04280, $1f098cad96ce2c33$var$_extends({
        full: full
    }, rest, {
        ref: grommetRef
    }), children), full && /*#__PURE__*/ $1f098cad96ce2c33$var$_react["default"].createElement($1f098cad96ce2c33$var$FullGlobalStyle, null))))))));
});
$1f098cad96ce2c33$var$Grommet.displayName = 'Grommet';
$1f098cad96ce2c33$var$Grommet.propTypes = $742b7e6bafa18b9d$export$5d086f0c0fa8cc7a;


$bd3ef218560ec2c7$export$efa1b86658154a31 = $1f098cad96ce2c33$export$efa1b86658154a31;


Object.keys($bd3ef218560ec2c7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $bd3ef218560ec2c7$exports[key]) return;
    $3321243da0932e1e$exports[key] = $bd3ef218560ec2c7$exports[key];
});

Object.keys($30d6151480c557a9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $30d6151480c557a9$exports[key]) return;
    $3321243da0932e1e$exports[key] = $30d6151480c557a9$exports[key];
});

Object.keys($2d67f2629ee502eb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $2d67f2629ee502eb$exports[key]) return;
    $3321243da0932e1e$exports[key] = $2d67f2629ee502eb$exports[key];
});

Object.keys($ef77062b4b63719c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $ef77062b4b63719c$exports[key]) return;
    $3321243da0932e1e$exports[key] = $ef77062b4b63719c$exports[key];
});

Object.keys($41010700ddcbac64$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $41010700ddcbac64$exports[key]) return;
    $3321243da0932e1e$exports[key] = $41010700ddcbac64$exports[key];
});

Object.keys($0241778dbd7d3ddc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $0241778dbd7d3ddc$exports[key]) return;
    $3321243da0932e1e$exports[key] = $0241778dbd7d3ddc$exports[key];
});

Object.keys($e03e15968966d631$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $e03e15968966d631$exports[key]) return;
    $3321243da0932e1e$exports[key] = $e03e15968966d631$exports[key];
});

Object.keys($0d1b8e621fb6c667$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $0d1b8e621fb6c667$exports[key]) return;
    $3321243da0932e1e$exports[key] = $0d1b8e621fb6c667$exports[key];
});
var $84bcd32d32f0e3dd$exports = {};

$parcel$export($84bcd32d32f0e3dd$exports, "__esModule", function () { return $84bcd32d32f0e3dd$export$1e511d4a378977f5; }, function (v) { return $84bcd32d32f0e3dd$export$1e511d4a378977f5 = v; });
$parcel$export($84bcd32d32f0e3dd$exports, "Main", function () { return $84bcd32d32f0e3dd$export$861edd1ccea2f746; }, function (v) { return $84bcd32d32f0e3dd$export$861edd1ccea2f746 = v; });
var $84bcd32d32f0e3dd$export$1e511d4a378977f5;
var $84bcd32d32f0e3dd$export$861edd1ccea2f746;
"use strict";
$84bcd32d32f0e3dd$export$1e511d4a378977f5 = true;
$84bcd32d32f0e3dd$export$861edd1ccea2f746 = void 0;
var $55f1621ffc0777be$export$1e511d4a378977f5;
var $55f1621ffc0777be$export$861edd1ccea2f746;
"use strict";
$55f1621ffc0777be$export$1e511d4a378977f5 = true;
$55f1621ffc0777be$export$861edd1ccea2f746 = void 0;

var $55f1621ffc0777be$var$_react = $55f1621ffc0777be$var$_interopRequireDefault((parcelRequire("2xPiy")));

function $55f1621ffc0777be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $55f1621ffc0777be$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $55f1621ffc0777be$var$_extends() {
    return $55f1621ffc0777be$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $55f1621ffc0777be$var$_extends.apply(null, arguments);
}
var $55f1621ffc0777be$var$Main = $55f1621ffc0777be$export$861edd1ccea2f746 = function Main(_ref) {
    var rest = $55f1621ffc0777be$var$_extends({}, ($55f1621ffc0777be$var$_objectDestructuringEmpty(_ref), _ref));
    return /*#__PURE__*/ $55f1621ffc0777be$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $55f1621ffc0777be$var$_extends({
        as: "main",
        fill: "vertical",
        flex: "grow",
        overflow: "auto"
    }, rest));
};


$84bcd32d32f0e3dd$export$861edd1ccea2f746 = $55f1621ffc0777be$export$861edd1ccea2f746;


Object.keys($84bcd32d32f0e3dd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $84bcd32d32f0e3dd$exports[key]) return;
    $3321243da0932e1e$exports[key] = $84bcd32d32f0e3dd$exports[key];
});
var $07b9d8e0bc9e77c8$exports = {};

$parcel$export($07b9d8e0bc9e77c8$exports, "__esModule", function () { return $07b9d8e0bc9e77c8$export$1e511d4a378977f5; }, function (v) { return $07b9d8e0bc9e77c8$export$1e511d4a378977f5 = v; });
$parcel$export($07b9d8e0bc9e77c8$exports, "Markdown", function () { return $07b9d8e0bc9e77c8$export$7460c8b7e4ce9582; }, function (v) { return $07b9d8e0bc9e77c8$export$7460c8b7e4ce9582 = v; });
var $07b9d8e0bc9e77c8$export$1e511d4a378977f5;
var $07b9d8e0bc9e77c8$export$7460c8b7e4ce9582;
"use strict";
$07b9d8e0bc9e77c8$export$1e511d4a378977f5 = true;
$07b9d8e0bc9e77c8$export$7460c8b7e4ce9582 = void 0;
var $3dd7c26d64eb3096$export$1e511d4a378977f5;
var $3dd7c26d64eb3096$export$7460c8b7e4ce9582;
"use strict";
$3dd7c26d64eb3096$export$1e511d4a378977f5 = true;
$3dd7c26d64eb3096$export$7460c8b7e4ce9582 = void 0;

var $3dd7c26d64eb3096$var$_react = $3dd7c26d64eb3096$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $3dd7c26d64eb3096$var$_markdownToJsx = $3dd7c26d64eb3096$var$_interopRequireDefault((parcelRequire("5I6jx")));


var $5db3f40fe57c037a$exports = {};

$parcel$export($5db3f40fe57c037a$exports, "__esModule", function () { return $5db3f40fe57c037a$export$1e511d4a378977f5; }, function (v) { return $5db3f40fe57c037a$export$1e511d4a378977f5 = v; });
$parcel$export($5db3f40fe57c037a$exports, "Paragraph", function () { return $5db3f40fe57c037a$export$358a232cca1ab2ac; }, function (v) { return $5db3f40fe57c037a$export$358a232cca1ab2ac = v; });
var $5db3f40fe57c037a$export$1e511d4a378977f5;
var $5db3f40fe57c037a$export$358a232cca1ab2ac;
"use strict";
$5db3f40fe57c037a$export$1e511d4a378977f5 = true;
$5db3f40fe57c037a$export$358a232cca1ab2ac = void 0;
var $f8b2a5a44e8c94cd$export$1e511d4a378977f5;
var $f8b2a5a44e8c94cd$export$358a232cca1ab2ac;
"use strict";
$f8b2a5a44e8c94cd$export$1e511d4a378977f5 = true;
$f8b2a5a44e8c94cd$export$358a232cca1ab2ac = void 0;

var $f8b2a5a44e8c94cd$var$_react = $f8b2a5a44e8c94cd$var$_interopRequireWildcard((parcelRequire("2xPiy")));
var $5a264ee29e34bdfd$export$1e511d4a378977f5;
var $5a264ee29e34bdfd$export$b03ca7138a9b8b3b;
"use strict";
$5a264ee29e34bdfd$export$1e511d4a378977f5 = true;
$5a264ee29e34bdfd$export$b03ca7138a9b8b3b = void 0;

var $5a264ee29e34bdfd$var$_styledComponents = $5a264ee29e34bdfd$var$_interopRequireWildcard((parcelRequire("iA1nz")));

function $5a264ee29e34bdfd$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($5a264ee29e34bdfd$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $5a264ee29e34bdfd$var$colorStyle = (0, $5a264ee29e34bdfd$var$_styledComponents.css)([
    "color:",
    ";"
], function(props) {
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(props.colorProp, props.theme);
});
var $5a264ee29e34bdfd$var$sizeStyle = function sizeStyle(props) {
    var size = props.size || 'medium';
    var data = props.theme.paragraph[size];
    return (0, $5a264ee29e34bdfd$var$_styledComponents.css)([
        "font-size:",
        ";line-height:",
        ";max-width:",
        ";"
    ], data ? data.size : size, data ? data.height : 'normal', props.fillProp ? 'none' : data && data.maxWidth);
};
var $5a264ee29e34bdfd$var$fontFamily = (0, $5a264ee29e34bdfd$var$_styledComponents.css)([
    "font-family:",
    ";"
], function(props) {
    return props.theme.paragraph.font.family;
});
var $5a264ee29e34bdfd$var$maxlinesStyle = function maxlinesStyle(props) {
    return props.maxLines && (0, $5a264ee29e34bdfd$var$_styledComponents.css)([
        "display:-webkit-box;-webkit-line-clamp:",
        ";-webkit-box-orient:vertical;overflow:hidden;"
    ], props.maxLines);
};
var $5a264ee29e34bdfd$var$StyledParagraph = $5a264ee29e34bdfd$export$b03ca7138a9b8b3b = $5a264ee29e34bdfd$var$_styledComponents["default"].p.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledParagraph",
    componentId: "sc-tbetod-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], $4113023f9e0bafa0$exports.genericStyles, function(props) {
    return $5a264ee29e34bdfd$var$maxlinesStyle(props);
}, function(props) {
    return $5a264ee29e34bdfd$var$sizeStyle(props);
}, function(props) {
    return props.textAlign && $4113023f9e0bafa0$exports.textAlignStyle;
}, function(props) {
    return props.colorProp && $5a264ee29e34bdfd$var$colorStyle;
}, function(props) {
    return props.theme.paragraph.font && props.theme.paragraph.font.family && $5a264ee29e34bdfd$var$fontFamily;
}, function(props) {
    return props.theme.paragraph && props.theme.paragraph.extend;
});


var $574f42621a403ca7$export$1e511d4a378977f5;
var $574f42621a403ca7$export$961f75c86f1f6d0b;
"use strict";
$574f42621a403ca7$export$1e511d4a378977f5 = true;
$574f42621a403ca7$export$961f75c86f1f6d0b = void 0;

var $574f42621a403ca7$var$_propTypes = $574f42621a403ca7$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $574f42621a403ca7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $574f42621a403ca7$var$_extends() {
    return $574f42621a403ca7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $574f42621a403ca7$var$_extends.apply(null, arguments);
}
var $574f42621a403ca7$var$PropType = {};
$574f42621a403ca7$var$PropType = $574f42621a403ca7$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    color: $5897bd367fbd90c1$export$fc4c368d97afb623,
    fill: $574f42621a403ca7$var$_propTypes["default"].bool,
    maxLines: $574f42621a403ca7$var$_propTypes["default"].number,
    responsive: $574f42621a403ca7$var$_propTypes["default"].bool,
    size: $574f42621a403ca7$var$_propTypes["default"].oneOfType([
        $574f42621a403ca7$var$_propTypes["default"].oneOf([
            'small',
            'medium',
            'large',
            'xlarge',
            'xxlarge'
        ]),
        $574f42621a403ca7$var$_propTypes["default"].string
    ]),
    textAlign: $574f42621a403ca7$var$_propTypes["default"].oneOf([
        'start',
        'center',
        'end',
        'justify'
    ])
});
var $574f42621a403ca7$var$ParagraphPropTypes = $574f42621a403ca7$export$961f75c86f1f6d0b = $574f42621a403ca7$var$PropType;



var $4ee9b3557504e098$export$1e511d4a378977f5;
var $4ee9b3557504e098$export$1ab68081b234514;
"use strict";
$4ee9b3557504e098$export$1e511d4a378977f5 = true;
$4ee9b3557504e098$export$1ab68081b234514 = void 0;

var $4ee9b3557504e098$var$_react = $4ee9b3557504e098$var$_interopRequireWildcard((parcelRequire("2xPiy")));



function $4ee9b3557504e098$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($4ee9b3557504e098$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $4ee9b3557504e098$var$ParagraphSkeleton = $4ee9b3557504e098$export$1ab68081b234514 = /*#__PURE__*/ (0, $4ee9b3557504e098$var$_react.forwardRef)(function(_ref, ref) {
    var _theme$paragraph;
    var fill = _ref.fill, sizeProp = _ref.size;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var size = sizeProp || 'medium';
    var data = theme.paragraph[size];
    var height = data ? data.size : size;
    return /*#__PURE__*/ $4ee9b3557504e098$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        ref: ref,
        gap: (_theme$paragraph = theme.paragraph) == null || (_theme$paragraph = _theme$paragraph.skeleton) == null ? void 0 : _theme$paragraph.gap,
        width: {
            max: fill ? 'none' : data && data.maxWidth
        }
    }, /*#__PURE__*/ $4ee9b3557504e098$var$_react["default"].createElement($ab65104eb6f9aa8a$exports.Skeleton, {
        height: height
    }), /*#__PURE__*/ $4ee9b3557504e098$var$_react["default"].createElement($ab65104eb6f9aa8a$exports.Skeleton, {
        height: height
    }), /*#__PURE__*/ $4ee9b3557504e098$var$_react["default"].createElement($ab65104eb6f9aa8a$exports.Skeleton, {
        height: height,
        width: "30%"
    }));
});
$4ee9b3557504e098$var$ParagraphSkeleton.displayName = 'ParagraphSkeleton';




var $f8b2a5a44e8c94cd$var$_excluded = [
    "children",
    "color",
    "fill",
    "size"
];
function $f8b2a5a44e8c94cd$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($f8b2a5a44e8c94cd$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $f8b2a5a44e8c94cd$var$_extends() {
    return $f8b2a5a44e8c94cd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f8b2a5a44e8c94cd$var$_extends.apply(null, arguments);
}
function $f8b2a5a44e8c94cd$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $f8b2a5a44e8c94cd$var$Paragraph = $f8b2a5a44e8c94cd$export$358a232cca1ab2ac = /*#__PURE__*/ (0, $f8b2a5a44e8c94cd$var$_react.forwardRef)(function(_ref, ref) {
    var children = _ref.children, color = _ref.color, fill = _ref.fill, size = _ref.size, rest = $f8b2a5a44e8c94cd$var$_objectWithoutPropertiesLoose(_ref, $f8b2a5a44e8c94cd$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var skeleton = (0, $ab65104eb6f9aa8a$exports.useSkeleton)();
    var textContextValue = (0, $f8b2a5a44e8c94cd$var$_react.useMemo)(function() {
        return {
            size: size
        };
    }, [
        size
    ]);
    if (skeleton) return /*#__PURE__*/ $f8b2a5a44e8c94cd$var$_react["default"].createElement($4ee9b3557504e098$export$1ab68081b234514, $f8b2a5a44e8c94cd$var$_extends({
        ref: ref,
        fill: fill,
        size: size
    }, rest), children);
    return /*#__PURE__*/ $f8b2a5a44e8c94cd$var$_react["default"].createElement($5a264ee29e34bdfd$export$b03ca7138a9b8b3b, $f8b2a5a44e8c94cd$var$_extends({
        ref: ref,
        colorProp: color,
        fillProp: fill,
        size: size
    }, passThemeFlag, rest), children !== undefined ? /*#__PURE__*/ $f8b2a5a44e8c94cd$var$_react["default"].createElement($5eeccb5281d9dbdf$export$9afb8bc826b033ea.Provider, {
        value: textContextValue
    }, children) : undefined);
});
$f8b2a5a44e8c94cd$var$Paragraph.displayName = 'Paragraph';
$f8b2a5a44e8c94cd$var$Paragraph.prototype = $574f42621a403ca7$export$961f75c86f1f6d0b;


$5db3f40fe57c037a$export$358a232cca1ab2ac = $f8b2a5a44e8c94cd$export$358a232cca1ab2ac;










var $25eba4f46e1d4933$export$1e511d4a378977f5;
var $25eba4f46e1d4933$export$dcea95bccdb834f5;
"use strict";
$25eba4f46e1d4933$export$1e511d4a378977f5 = true;
$25eba4f46e1d4933$export$dcea95bccdb834f5 = void 0;

var $25eba4f46e1d4933$var$_propTypes = $25eba4f46e1d4933$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $25eba4f46e1d4933$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $25eba4f46e1d4933$var$PropType = {};
$25eba4f46e1d4933$var$PropType = {
    components: $25eba4f46e1d4933$var$_propTypes["default"].object,
    options: $25eba4f46e1d4933$var$_propTypes["default"].shape({})
};
var $25eba4f46e1d4933$var$MarkdownPropTypes = $25eba4f46e1d4933$export$dcea95bccdb834f5 = $25eba4f46e1d4933$var$PropType;


var $3dd7c26d64eb3096$var$_excluded = [
    "children",
    "components",
    "options",
    "theme"
];
function $3dd7c26d64eb3096$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $3dd7c26d64eb3096$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($3dd7c26d64eb3096$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $3dd7c26d64eb3096$var$_extends() {
    return $3dd7c26d64eb3096$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3dd7c26d64eb3096$var$_extends.apply(null, arguments);
}
function $3dd7c26d64eb3096$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $3dd7c26d64eb3096$var$GrommetMarkdown = $3dd7c26d64eb3096$export$7460c8b7e4ce9582 = /*#__PURE__*/ (0, $3dd7c26d64eb3096$var$_react.forwardRef)(function(_ref, ref) {
    var children = _ref.children, components = _ref.components, options = _ref.options, theme = _ref.theme, rest = $3dd7c26d64eb3096$var$_objectWithoutPropertiesLoose(_ref, $3dd7c26d64eb3096$var$_excluded);
    var heading = [
        1,
        2,
        3,
        4
    ].reduce(function(obj, level) {
        var result = $3dd7c26d64eb3096$var$_extends({}, obj);
        result["h" + level] = {
            component: $2d67f2629ee502eb$export$a8a3e93435678ff9,
            props: {
                level: level
            }
        };
        return result;
    }, {});
    var overrides = (0, $4113023f9e0bafa0$exports.deepMerge)({
        a: {
            component: $e78646567f384248$export$b688253958b8dfe7
        },
        img: {
            component: $ef77062b4b63719c$export$3e431a229df88919
        },
        p: {
            component: $5db3f40fe57c037a$export$358a232cca1ab2ac
        },
        table: {
            component: $d18144d9f1ced4c1$export$54ec01a60f47d33d
        },
        td: {
            component: $5501e7a1e1340982$export$1e4baea7053fc0e3,
            props: {
                plain: true
            }
        },
        tbody: {
            component: $e3081fd3bb82ce0d$export$76ccd210b9029917
        },
        tfoot: {
            component: $b2b0be68b7012347$export$1f116082bba1f9a8
        },
        th: {
            component: $5501e7a1e1340982$export$1e4baea7053fc0e3
        },
        thead: {
            component: $2a5ab6af3c2b6348$export$f850895b287ef28e
        },
        tr: {
            component: $769e29b5528bbd43$export$b05581f4e764e162
        }
    }, heading, components, options && options.overrides);
    // we use Fragment as the wrapper so we can assign the ref with the div
    // wrapper can still be overridden with the options.
    return /*#__PURE__*/ $3dd7c26d64eb3096$var$_react["default"].createElement("div", $3dd7c26d64eb3096$var$_extends({
        ref: ref
    }, rest), /*#__PURE__*/ $3dd7c26d64eb3096$var$_react["default"].createElement($3dd7c26d64eb3096$var$_markdownToJsx["default"], {
        children: children,
        options: $3dd7c26d64eb3096$var$_extends({
            wrapper: $3dd7c26d64eb3096$var$_react.Fragment
        }, options, {
            overrides: overrides
        })
    }));
});
$3dd7c26d64eb3096$var$GrommetMarkdown.propTypes = $25eba4f46e1d4933$export$dcea95bccdb834f5;


$07b9d8e0bc9e77c8$export$7460c8b7e4ce9582 = $3dd7c26d64eb3096$export$7460c8b7e4ce9582;


Object.keys($07b9d8e0bc9e77c8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $07b9d8e0bc9e77c8$exports[key]) return;
    $3321243da0932e1e$exports[key] = $07b9d8e0bc9e77c8$exports[key];
});

Object.keys($0c17f9d155734634$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $0c17f9d155734634$exports[key]) return;
    $3321243da0932e1e$exports[key] = $0c17f9d155734634$exports[key];
});
var $000ef1019d03e320$exports = {};

$parcel$export($000ef1019d03e320$exports, "__esModule", function () { return $000ef1019d03e320$export$1e511d4a378977f5; }, function (v) { return $000ef1019d03e320$export$1e511d4a378977f5 = v; });
$parcel$export($000ef1019d03e320$exports, "Menu", function () { return $000ef1019d03e320$export$d9b273488cd8ce6f; }, function (v) { return $000ef1019d03e320$export$d9b273488cd8ce6f = v; });
var $000ef1019d03e320$export$1e511d4a378977f5;
var $000ef1019d03e320$export$d9b273488cd8ce6f;
"use strict";
$000ef1019d03e320$export$1e511d4a378977f5 = true;
$000ef1019d03e320$export$d9b273488cd8ce6f = void 0;
var $a59003bb90f8b0dc$export$1e511d4a378977f5;
var $a59003bb90f8b0dc$export$d9b273488cd8ce6f;
"use strict";
$a59003bb90f8b0dc$export$1e511d4a378977f5 = true;
$a59003bb90f8b0dc$export$d9b273488cd8ce6f = void 0;

var $a59003bb90f8b0dc$var$_react = $a59003bb90f8b0dc$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $a59003bb90f8b0dc$var$_styledComponents = $a59003bb90f8b0dc$var$_interopRequireDefault((parcelRequire("iA1nz")));







var $99e07220c2afaf89$export$1e511d4a378977f5;
var $99e07220c2afaf89$export$debf9a822325d3f0;
"use strict";
$99e07220c2afaf89$export$1e511d4a378977f5 = true;
$99e07220c2afaf89$export$debf9a822325d3f0 = void 0;

var $99e07220c2afaf89$var$_propTypes = $99e07220c2afaf89$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $99e07220c2afaf89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $99e07220c2afaf89$var$_extends() {
    return $99e07220c2afaf89$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $99e07220c2afaf89$var$_extends.apply(null, arguments);
}
var $99e07220c2afaf89$var$VERTICAL_ALIGN_OPTIONS = [
    'top',
    'bottom'
];
var $99e07220c2afaf89$var$HORIZONTAL_ALIGN_OPTIONS = [
    'right',
    'left'
];
var $99e07220c2afaf89$var$PropType = {};
$99e07220c2afaf89$var$PropType = $99e07220c2afaf89$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    children: $99e07220c2afaf89$var$_propTypes["default"].oneOfType([
        $99e07220c2afaf89$var$_propTypes["default"].func,
        $99e07220c2afaf89$var$_propTypes["default"].node
    ]),
    disabled: $99e07220c2afaf89$var$_propTypes["default"].bool,
    dropAlign: $99e07220c2afaf89$var$_propTypes["default"].shape({
        top: $99e07220c2afaf89$var$_propTypes["default"].oneOf($99e07220c2afaf89$var$VERTICAL_ALIGN_OPTIONS),
        bottom: $99e07220c2afaf89$var$_propTypes["default"].oneOf($99e07220c2afaf89$var$VERTICAL_ALIGN_OPTIONS),
        left: $99e07220c2afaf89$var$_propTypes["default"].oneOf($99e07220c2afaf89$var$HORIZONTAL_ALIGN_OPTIONS),
        right: $99e07220c2afaf89$var$_propTypes["default"].oneOf($99e07220c2afaf89$var$HORIZONTAL_ALIGN_OPTIONS)
    }),
    dropBackground: $99e07220c2afaf89$var$_propTypes["default"].oneOfType([
        $99e07220c2afaf89$var$_propTypes["default"].string,
        $99e07220c2afaf89$var$_propTypes["default"].shape({
            color: $99e07220c2afaf89$var$_propTypes["default"].string,
            opacity: $99e07220c2afaf89$var$_propTypes["default"].oneOfType([
                $99e07220c2afaf89$var$_propTypes["default"].bool,
                $99e07220c2afaf89$var$_propTypes["default"].number,
                $99e07220c2afaf89$var$_propTypes["default"].oneOf([
                    'weak',
                    'medium',
                    'strong'
                ])
            ])
        })
    ]),
    dropTarget: $99e07220c2afaf89$var$_propTypes["default"].object,
    dropProps: $99e07220c2afaf89$var$_propTypes["default"].object,
    justifyContent: $99e07220c2afaf89$var$_propTypes["default"].oneOf([
        'start',
        'center',
        'end',
        'between',
        'around',
        'stretch'
    ]),
    icon: $99e07220c2afaf89$var$_propTypes["default"].oneOfType([
        $99e07220c2afaf89$var$_propTypes["default"].bool,
        $99e07220c2afaf89$var$_propTypes["default"].node
    ]),
    items: $99e07220c2afaf89$var$_propTypes["default"].oneOfType([
        $99e07220c2afaf89$var$_propTypes["default"].arrayOf($99e07220c2afaf89$var$_propTypes["default"].object),
        $99e07220c2afaf89$var$_propTypes["default"].arrayOf($99e07220c2afaf89$var$_propTypes["default"].arrayOf($99e07220c2afaf89$var$_propTypes["default"].object))
    ]),
    label: $99e07220c2afaf89$var$_propTypes["default"].oneOfType([
        $99e07220c2afaf89$var$_propTypes["default"].string,
        $99e07220c2afaf89$var$_propTypes["default"].node
    ]),
    messages: $99e07220c2afaf89$var$_propTypes["default"].shape({
        closeMenu: $99e07220c2afaf89$var$_propTypes["default"].string,
        openMenu: $99e07220c2afaf89$var$_propTypes["default"].string
    }),
    open: $99e07220c2afaf89$var$_propTypes["default"].bool,
    size: $99e07220c2afaf89$var$_propTypes["default"].oneOfType([
        $99e07220c2afaf89$var$_propTypes["default"].oneOf([
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        $99e07220c2afaf89$var$_propTypes["default"].string
    ])
});
var $99e07220c2afaf89$var$MenuPropTypes = $99e07220c2afaf89$export$debf9a822325d3f0 = $99e07220c2afaf89$var$PropType;



var $a59003bb90f8b0dc$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "children",
    "disabled",
    "dropAlign",
    "dropBackground",
    "dropProps",
    "dropTarget",
    "justifyContent",
    "icon",
    "items",
    "label",
    "messages",
    "onKeyDown",
    "open",
    "plain",
    "size"
], $a59003bb90f8b0dc$var$_excluded2 = [
    "align"
];
function $a59003bb90f8b0dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $a59003bb90f8b0dc$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($a59003bb90f8b0dc$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $a59003bb90f8b0dc$var$_extends() {
    return $a59003bb90f8b0dc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a59003bb90f8b0dc$var$_extends.apply(null, arguments);
}
function $a59003bb90f8b0dc$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $a59003bb90f8b0dc$var$ContainerBox = (0, $a59003bb90f8b0dc$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "Menu__ContainerBox",
    componentId: "sc-17fcys9-0"
})([
    "max-height:inherit;@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){width:100%;}&:focus{outline:none;}",
    ";"
], function(props) {
    return props.theme.menu.extend;
});
/* Notes on keyboard interactivity (based on W3) // For details reference: https://www.w3.org/TR/wai-aria-practices/#menu

To open menu when menu button is focused:
- Space/Enter/Up arrow/Down arrow will open menu

To navigate within menu:
- Up/down arrow keys can be used and will loop through options
(keeping focus within the Menu)
- Tab can be used, but once the last menu item is reached, Tab will close the
Menu and continue through page content.

To close the menu:
- Tabbing beyond the first or last menu item.
- Esc will close the menu
- Select a menu item

To make a selection:
- Enter key is pressed.
- Space is pressed.
*/ var $a59003bb90f8b0dc$var$defaultItems = [];
var $a59003bb90f8b0dc$var$Menu = $a59003bb90f8b0dc$export$d9b273488cd8ce6f = /*#__PURE__*/ (0, $a59003bb90f8b0dc$var$_react.forwardRef)(function(props, ref) {
    var _theme$menu$disabled;
    var a11yTitle = props.a11yTitle, ariaLabel = props['aria-label'], children = props.children, disabled = props.disabled, dropAlign = props.dropAlign, dropBackground = props.dropBackground, dropProps = props.dropProps, dropTarget = props.dropTarget, _props$justifyContent = props.justifyContent, justifyContent = _props$justifyContent === void 0 ? 'start' : _props$justifyContent, icon = props.icon, _props$items = props.items, items = _props$items === void 0 ? $a59003bb90f8b0dc$var$defaultItems : _props$items, label = props.label, messages = props.messages, onKeyDown = props.onKeyDown, open = props.open, plain = props.plain, size = props.size, rest = $a59003bb90f8b0dc$var$_objectWithoutPropertiesLoose(props, $a59003bb90f8b0dc$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useContext = (0, $a59003bb90f8b0dc$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var iconColor = (0, $4113023f9e0bafa0$exports.normalizeColor)(theme.menu.icons.color || 'control', theme);
    var iconDisabledColor = (0, $4113023f9e0bafa0$exports.normalizeColor)(((_theme$menu$disabled = theme.menu.disabled) == null || (_theme$menu$disabled = _theme$menu$disabled.icons) == null ? void 0 : _theme$menu$disabled.color) || theme.menu.icons.color || 'control', theme);
    // need to destructure the align otherwise it will get passed through
    // to DropButton and override prop values
    var _theme$menu$drop = theme.menu.drop, themeDropAlign = _theme$menu$drop.align, themeDropProps = $a59003bb90f8b0dc$var$_objectWithoutPropertiesLoose(_theme$menu$drop, $a59003bb90f8b0dc$var$_excluded2);
    var a11y = ariaLabel || a11yTitle;
    // total number of menu items
    var itemCount = (0, $a59003bb90f8b0dc$var$_react.useMemo)(function() {
        var count = 0;
        if (items && Array.isArray(items[0])) items.forEach(function(group) {
            count += group.length;
        });
        else count = items.length;
        return count;
    }, [
        items
    ]);
    var align = dropProps && dropProps.align || dropAlign || themeDropAlign;
    var controlButtonIndex = (0, $a59003bb90f8b0dc$var$_react.useMemo)(function() {
        if (align.top === 'top') return -1;
        if (align.bottom === 'bottom') return itemCount;
        return undefined;
    }, [
        align,
        itemCount
    ]);
    // Keeps track of whether menu options should be mirrored
    // when there's not enough space below DropButton. This state
    // is modified on /Drop/DropContainer.js.
    var _useState = (0, $a59003bb90f8b0dc$var$_react.useState)(), alignControlMirror = _useState[0], setAlignControlMirror = _useState[1];
    var initialAlignTop = alignControlMirror === align.top;
    var dropContainerRef = (0, $a59003bb90f8b0dc$var$_react.useRef)();
    var buttonRefs = (0, $a59003bb90f8b0dc$var$_react.useRef)([]);
    var constants = (0, $a59003bb90f8b0dc$var$_react.useMemo)(function() {
        return {
            none: 'none',
            tab: 9,
            // Menu control button included on top of menu items
            controlTop: align.top === 'top' || undefined,
            // Menu control button included on the bottom of menu items
            controlBottom: align.bottom === 'bottom' || undefined,
            controlButtonIndex: controlButtonIndex
        };
    }, [
        align,
        controlButtonIndex
    ]);
    var _useState2 = (0, $a59003bb90f8b0dc$var$_react.useState)(constants.none), activeItemIndex = _useState2[0], setActiveItemIndex = _useState2[1];
    var _useState3 = (0, $a59003bb90f8b0dc$var$_react.useState)(open || false), isOpen = _useState3[0], setOpen = _useState3[1];
    var MenuIcon = isOpen && theme.menu.icons.up ? theme.menu.icons.up : theme.menu.icons.down;
    var onDropClose = (0, $a59003bb90f8b0dc$var$_react.useCallback)(function() {
        setActiveItemIndex(constants.none);
        setOpen(false);
    }, [
        constants.none
    ]);
    var onDropOpen = (0, $a59003bb90f8b0dc$var$_react.useCallback)(function() {
        setOpen(true);
    }, []);
    (0, $a59003bb90f8b0dc$var$_react.useEffect)(function() {
        // need to wait for Drop to be ready
        var timer = setTimeout(function() {
            if (isOpen) {
                var optionsNode = dropContainerRef.current;
                if (optionsNode) optionsNode.focus();
            }
        }, 100);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        isOpen
    ]);
    var onSelectMenuItem = function onSelectMenuItem(event) {
        if (isOpen) {
            if (activeItemIndex >= 0) {
                event.preventDefault();
                event.stopPropagation();
                buttonRefs.current[activeItemIndex].click();
            }
        } else onDropOpen();
    };
    var isTab = function isTab(event) {
        return event.keyCode === constants.tab || event.which === constants.tab;
    };
    var onNextMenuItem = function onNextMenuItem(event) {
        event.preventDefault();
        if (!isOpen) onDropOpen();
        else if (isTab(event) && (!constants.controlBottom && activeItemIndex === itemCount - 1 || constants.controlBottom && activeItemIndex === controlButtonIndex)) // User has reached end of the menu, this tab will close
        // the menu drop because there are no more "next items" to access
        onDropClose();
        else {
            var index;
            if (// This checks if the user has reached the end of the menu.
            // In the case the the menu control button is located at the
            // bottom of the menu, it checks if the user has reached the button.
            // Otherwise, it checks if the user is at the last menu item.
            constants.controlBottom && activeItemIndex === controlButtonIndex || !constants.controlBottom && activeItemIndex === itemCount - 1 || activeItemIndex === constants.none) // place focus on the first menu item
            index = 0;
            else index = activeItemIndex + 1;
            setActiveItemIndex(index);
            if (buttonRefs.current[index]) buttonRefs.current[index].focus();
        }
    };
    var onPreviousMenuItem = function onPreviousMenuItem(event) {
        event.preventDefault();
        if (!isOpen) onDropOpen();
        else if (isTab(event) && (constants.controlTop && activeItemIndex === controlButtonIndex || !constants.controlTop && activeItemIndex - 1 < 0)) // User has reached beginning of the menu, this tab will close
        // the menu drop because there are no more "previous items" to access
        onDropClose();
        else {
            var index;
            if (activeItemIndex === 'none') index = itemCount - 1;
            else if (activeItemIndex - 1 < 0) {
                if (constants.controlTop && activeItemIndex - 1 === controlButtonIndex) index = itemCount;
                else index = itemCount - 1;
            } else index = activeItemIndex - 1;
            setActiveItemIndex(index);
            if (buttonRefs.current[index]) buttonRefs.current[index].focus();
        }
    };
    var menuIcon = icon !== false ? icon !== true && icon || /*#__PURE__*/ $a59003bb90f8b0dc$var$_react["default"].createElement(MenuIcon, {
        color: disabled ? iconDisabledColor : iconColor,
        size: size
    }) : null;
    var buttonProps = {
        plain: plain,
        size: size
    };
    var content;
    if (children) content = children;
    else if (!theme.button["default"]) /*
    Not adding a theme object now because this code path
    is not used in the HPE theme, but we may add theme
    support here in the future.
    */ content = /*#__PURE__*/ $a59003bb90f8b0dc$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        direction: "row",
        justify: justifyContent,
        align: "center",
        pad: "small",
        gap: label && icon !== false ? 'small' : undefined
    }, /*#__PURE__*/ $a59003bb90f8b0dc$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, {
        size: size
    }, label), menuIcon);
    else {
        // when a theme has theme.button.default, keep content as
        // undefined so we can rely on Button label & icon props
        buttonProps = {
            icon: menuIcon,
            label: label,
            plain: plain,
            reverse: true,
            size: size
        };
        content = undefined;
    }
    var controlMirror = /*#__PURE__*/ $a59003bb90f8b0dc$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        flex: false
    }, /*#__PURE__*/ $a59003bb90f8b0dc$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, $a59003bb90f8b0dc$var$_extends({
        ref: function ref(r) {
            // make it accessible at the end of all menu items
            buttonRefs.current[itemCount] = r;
        },
        a11yTitle: a11y || format({
            id: 'menu.closeMenu',
            messages: messages
        }),
        active: activeItemIndex === controlButtonIndex,
        focusIndicator: false,
        hoverIndicator: "background",
        onClick: onDropClose,
        onFocus: function onFocus() {
            return setActiveItemIndex(controlButtonIndex);
        },
        tabIndex: activeItemIndex === constants.none ? '-1' : undefined
    }, theme.menu.item, buttonProps), typeof content === 'function' ? function() {
        return content($a59003bb90f8b0dc$var$_extends({}, props, {
            drop: true
        }));
    } : content));
    var menuItem = function menuItem(item, index) {
        var _theme$menu$item, _theme$menu$item2, _theme$menu$item3, _theme$menu$item4;
        // Determine whether the label is done as a child or
        // as an option Button kind property.
        var child = !theme.button.option ? /*#__PURE__*/ /*
    Not adding a theme object now because this code path
    is not used in the HPE theme, but we may add theme
    support here in the future.
    */ $a59003bb90f8b0dc$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            align: ((_theme$menu$item = theme.menu.item) == null ? void 0 : _theme$menu$item.align) || 'start',
            pad: "small",
            direction: "row",
            gap: item.gap || ((_theme$menu$item2 = theme.menu.item) == null ? void 0 : _theme$menu$item2.gap),
            justify: item.justify || ((_theme$menu$item3 = theme.menu.item) == null ? void 0 : _theme$menu$item3.justify)
        }, item.reverse && item.label, item.icon, !item.reverse && item.label) : undefined;
        // if we have a child, turn on plain, and hoverIndicator
        return(/*#__PURE__*/ // lint isn't flagging this but we shouldn't use index as a key
        // see no-array-index-key lint rule
        $a59003bb90f8b0dc$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            key: index,
            flex: false,
            role: "none"
        }, /*#__PURE__*/ $a59003bb90f8b0dc$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, $a59003bb90f8b0dc$var$_extends({
            ref: function ref(r) {
                buttonRefs.current[index] = r;
            },
            role: "menuitem",
            onFocus: function onFocus() {
                setActiveItemIndex(index);
            },
            active: activeItemIndex === index,
            focusIndicator: false,
            plain: !child ? undefined : true,
            align: "start",
            kind: !child ? 'option' : undefined,
            hoverIndicator: !child ? undefined : 'background'
        }, theme.menu.item, {
            justify: item.justify || ((_theme$menu$item4 = theme.menu.item) == null ? void 0 : _theme$menu$item4.justify)
        }, !child ? item : $a59003bb90f8b0dc$var$_extends({}, item, {
            gap: undefined,
            icon: undefined,
            label: undefined,
            reverse: undefined
        }), {
            onClick: function onClick() {
                if (item.onClick) item.onClick.apply(item, arguments);
                if (item.close !== false) onDropClose();
            }
        }), child)));
    };
    var menuContent;
    var grouped = itemCount && Array.isArray(items[0]);
    if (grouped) {
        var index = 0;
        menuContent = items.map(function(group, groupIndex) {
            var _theme$menu$group, _theme$menu$group2, _theme$menu$group3;
            return /*#__PURE__*/ $a59003bb90f8b0dc$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
                key: groupIndex,
                flex: false
            }, groupIndex > 0 && /*#__PURE__*/ $a59003bb90f8b0dc$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
                pad: theme.menu.group.separator.pad
            }, /*#__PURE__*/ $a59003bb90f8b0dc$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
                border: {
                    side: 'top',
                    color: (_theme$menu$group = theme.menu.group) == null || (_theme$menu$group = _theme$menu$group.separator) == null ? void 0 : _theme$menu$group.color,
                    size: (_theme$menu$group2 = theme.menu.group) == null || (_theme$menu$group2 = _theme$menu$group2.separator) == null ? void 0 : _theme$menu$group2.size
                }
            })), /*#__PURE__*/ $a59003bb90f8b0dc$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $a59003bb90f8b0dc$var$_extends({}, theme.menu.container, (_theme$menu$group3 = theme.menu.group) == null ? void 0 : _theme$menu$group3.container), group.map(function(item) {
                // item index needs to be its index in the entire menu as if
                // it were a flat array
                var currentIndex = index;
                index += 1;
                return menuItem(item, currentIndex);
            })));
        });
    } else menuContent = items.map(function(item, index) {
        return menuItem(item, index);
    });
    return /*#__PURE__*/ $a59003bb90f8b0dc$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onDown: onDropOpen,
        onUp: onDropOpen,
        onSpace: onSelectMenuItem,
        onEsc: onDropClose,
        onTab: onDropClose,
        onKeyDown: onKeyDown
    }, /*#__PURE__*/ $a59003bb90f8b0dc$var$_react["default"].createElement($d7e2a556593dc38b$export$64fff40e709e8b2e, $a59003bb90f8b0dc$var$_extends({
        ref: ref
    }, rest, buttonProps, {
        a11yTitle: a11y || format({
            id: 'menu.openMenu',
            messages: messages
        }),
        "aria-haspopup": "menu",
        "aria-expanded": isOpen,
        onAlign: setAlignControlMirror,
        disabled: disabled,
        dropAlign: align,
        dropTarget: dropTarget,
        dropProps: dropProps || themeDropProps,
        open: isOpen,
        onOpen: onDropOpen,
        onClose: onDropClose,
        dropContent: /*#__PURE__*/ $a59003bb90f8b0dc$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
            onTab: function onTab(event) {
                return event.shiftKey ? onPreviousMenuItem(event) : onNextMenuItem(event);
            },
            onDown: onNextMenuItem,
            onUp: onPreviousMenuItem,
            onEnter: onSelectMenuItem
        }, /*#__PURE__*/ $a59003bb90f8b0dc$var$_react["default"].createElement($a59003bb90f8b0dc$var$ContainerBox, $a59003bb90f8b0dc$var$_extends({
            ref: dropContainerRef,
            tabIndex: -1,
            background: dropBackground || theme.menu.background
        }, passThemeFlag), alignControlMirror === 'top' && align.bottom !== 'top' && align.top !== 'bottom' ? controlMirror : undefined, /*#__PURE__*/ $a59003bb90f8b0dc$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $a59003bb90f8b0dc$var$_extends({
            overflow: "auto",
            role: "menu",
            a11yTitle: a11y
        }, !grouped ? theme.menu.container : {}), menuContent), !initialAlignTop && // don't show controlMirror if caller is using
        // align.bottom === 'top'
        alignControlMirror === 'bottom' && align.bottom !== 'top' && align.top !== 'bottom' ? controlMirror : undefined))
    }), content));
});
$a59003bb90f8b0dc$var$Menu.displayName = 'Menu';
$a59003bb90f8b0dc$var$Menu.propTypes = $99e07220c2afaf89$export$debf9a822325d3f0;


$000ef1019d03e320$export$d9b273488cd8ce6f = $a59003bb90f8b0dc$export$d9b273488cd8ce6f;


Object.keys($000ef1019d03e320$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $000ef1019d03e320$exports[key]) return;
    $3321243da0932e1e$exports[key] = $000ef1019d03e320$exports[key];
});
var $11d506dee5992445$exports = {};

$parcel$export($11d506dee5992445$exports, "__esModule", function () { return $11d506dee5992445$export$1e511d4a378977f5; }, function (v) { return $11d506dee5992445$export$1e511d4a378977f5 = v; });
$parcel$export($11d506dee5992445$exports, "Meter", function () { return $11d506dee5992445$export$62e3ae2a4090b879; }, function (v) { return $11d506dee5992445$export$62e3ae2a4090b879 = v; });
var $11d506dee5992445$export$1e511d4a378977f5;
var $11d506dee5992445$export$62e3ae2a4090b879;
"use strict";
$11d506dee5992445$export$1e511d4a378977f5 = true;
$11d506dee5992445$export$62e3ae2a4090b879 = void 0;
var $134ee1ff9cbc6ab8$export$1e511d4a378977f5;
var $134ee1ff9cbc6ab8$export$62e3ae2a4090b879;
"use strict";
$134ee1ff9cbc6ab8$export$1e511d4a378977f5 = true;
$134ee1ff9cbc6ab8$export$62e3ae2a4090b879 = void 0;

var $134ee1ff9cbc6ab8$var$_react = $134ee1ff9cbc6ab8$var$_interopRequireWildcard((parcelRequire("2xPiy")));
var $9777593562b8440d$export$1e511d4a378977f5;
var $9777593562b8440d$export$bbc6c6369b38e3d1;
"use strict";
$9777593562b8440d$export$1e511d4a378977f5 = true;
$9777593562b8440d$export$bbc6c6369b38e3d1 = void 0;

var $9777593562b8440d$var$_react = $9777593562b8440d$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $9e378c3b7e3919ef$export$1e511d4a378977f5;
var $9e378c3b7e3919ef$export$430a924eee89432c;
"use strict";
$9e378c3b7e3919ef$export$1e511d4a378977f5 = true;
$9e378c3b7e3919ef$export$430a924eee89432c = void 0;

var $9e378c3b7e3919ef$var$_styledComponents = $9e378c3b7e3919ef$var$_interopRequireWildcard((parcelRequire("iA1nz")));

function $9e378c3b7e3919ef$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($9e378c3b7e3919ef$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
// fallback to edgeSize for backwards compatibility
var $9e378c3b7e3919ef$var$roundStyle = (0, $9e378c3b7e3919ef$var$_styledComponents.css)([
    "border-radius:",
    ";"
], function(props) {
    return props.theme.global[props.theme.global.radius ? 'radius' : 'edgeSize'][props.round.size];
});
// overflow: hidden is needed for ie11
var $9e378c3b7e3919ef$var$StyledMeter = $9e378c3b7e3919ef$export$430a924eee89432c = $9e378c3b7e3919ef$var$_styledComponents["default"].svg.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledMeter",
    componentId: "sc-nsxarx-0"
})([
    "max-width:100%;overflow:hidden;",
    " ",
    " ",
    " path{transition:stroke 0.3s,stroke-width 0.3s;}",
    ";"
], function(props) {
    return props.reverse && (0, $9e378c3b7e3919ef$var$_styledComponents.css)([
        "transform:scale(-1,1);"
    ]);
}, $4113023f9e0bafa0$exports.genericStyles, function(props) {
    return props.round && $9e378c3b7e3919ef$var$roundStyle;
}, function(props) {
    return props.theme.meter && props.theme.meter.extend;
});


var $386a94958037ec1a$export$1e511d4a378977f5;
var $386a94958037ec1a$export$c6dfdb238d76e427;
var $386a94958037ec1a$export$4ccf064591ccdacd;
var $386a94958037ec1a$export$f705f0fde43a55a;
"use strict";
$386a94958037ec1a$export$1e511d4a378977f5 = true;
$386a94958037ec1a$export$c6dfdb238d76e427 = $386a94958037ec1a$export$4ccf064591ccdacd = $386a94958037ec1a$export$f705f0fde43a55a = void 0;

var $386a94958037ec1a$var$strokeProps = $386a94958037ec1a$export$c6dfdb238d76e427 = function strokeProps(color, theme) {
    var result = {};
    if (color) {
        if (typeof color === 'object') {
            result.stroke = (0, $4113023f9e0bafa0$exports.normalizeColor)(color.color, theme);
            if (color.opacity) result.strokeOpacity = "" + (color.opacity === true ? theme.global.opacity.medium : theme.global.opacity[color.opacity] || color.opacity);
        } else result.stroke = (0, $4113023f9e0bafa0$exports.normalizeColor)(color, theme);
    }
    return result;
};
var $386a94958037ec1a$var$fillProps = $386a94958037ec1a$export$4ccf064591ccdacd = function fillProps(color, theme) {
    var result = {};
    if (color) {
        if (typeof color === 'object') {
            result.fill = (0, $4113023f9e0bafa0$exports.normalizeColor)(color.color, theme);
            if (color.opacity) result.fillOpacity = "" + (color.opacity === true ? theme.global.opacity.medium : theme.global.opacity[color.opacity] || color.opacity);
        } else result.fill = (0, $4113023f9e0bafa0$exports.normalizeColor)(color, theme);
    }
    return result;
};
var $386a94958037ec1a$var$neutralExp = /^neutral-\d+/;
var $386a94958037ec1a$var$defaultColor = $386a94958037ec1a$export$f705f0fde43a55a = function defaultColor(index, theme, valuesLength) {
    if (index === valuesLength - 1 && theme.meter.color) return theme.meter.color;
    // We want the last value to have the first color
    var colorIndex = valuesLength - index - 1;
    if (theme.meter && theme.meter.colors) {
        var _colors = theme.meter.colors[theme.dark ? 'dark' : 'light'] || theme.meter.colors;
        return _colors[colorIndex % _colors.length];
    }
    var colors = Object.keys(theme.global.colors).filter(function(n) {
        return n.match(/^graph-[0-9]$/);
    });
    if (colors.length > 0) return colors[colorIndex % colors.length];
    // Deprecate using "neutral-*" color names. Remove eventually.
    var neutralColors = Object.keys(theme.global.colors).filter(function(k) {
        return $386a94958037ec1a$var$neutralExp.test(k);
    });
    return neutralColors[colorIndex % neutralColors.length];
};



var $9777593562b8440d$var$_excluded = [
    "background",
    "max",
    "round",
    "size",
    "thickness",
    "direction",
    "values",
    "reverse"
], $9777593562b8440d$var$_excluded2 = [
    "color",
    "highlight",
    "label",
    "onHover",
    "value"
];
function $9777593562b8440d$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($9777593562b8440d$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $9777593562b8440d$var$_extends() {
    return $9777593562b8440d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9777593562b8440d$var$_extends.apply(null, arguments);
}
function $9777593562b8440d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $9777593562b8440d$var$Bar = $9777593562b8440d$export$bbc6c6369b38e3d1 = /*#__PURE__*/ (0, $9777593562b8440d$var$_react.forwardRef)(function(props, ref) {
    var _theme$meter$gap, _theme$meter;
    var _props$background = props.background, background = _props$background === void 0 ? 'light-1' : _props$background, max = props.max, round = props.round, size = props.size, thicknessProp = props.thickness, direction = props.direction, values = props.values, reverse = props.reverse, rest = $9777593562b8440d$var$_objectWithoutPropertiesLoose(props, $9777593562b8440d$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var length = size === 'full' ? 288 : (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.size[size] || size);
    var thickness = (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.edgeSize[thicknessProp] || thicknessProp);
    var gapTheme = (_theme$meter$gap = (_theme$meter = theme.meter) == null ? void 0 : _theme$meter.gap) != null ? _theme$meter$gap : 0;
    var gap = (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.edgeSize[gapTheme] || gapTheme);
    // account for the round cap, if any
    var capRadius = round ? thickness / 2 : 0;
    var mid = thickness / 2;
    var someHighlight = (values || []).some(function(v) {
        return v.highlight;
    });
    var start = direction === 'horizontal' ? capRadius : length - capRadius;
    // Available space for the bar is the length of the meter minus an end cap
    // on each end, minus the gap between bars.
    var lengthAvailable = length - 2 * capRadius - gap * (values.length - 1);
    var paths = (values || []).reduce(function(acc, valueArg, index) {
        if (valueArg.value > 0) {
            var color = valueArg.color, highlight = valueArg.highlight, label = valueArg.label, onHover = valueArg.onHover, value = valueArg.value, pathRest = $9777593562b8440d$var$_objectWithoutPropertiesLoose(valueArg, $9777593562b8440d$var$_excluded2);
            var key = "p-" + index;
            var delta = value * lengthAvailable / max;
            // add a little bit extra to start to allow for larger rounded inset cap
            // The extra needed can be calculated by the Pythagorean theorem
            var extraGap = round && index !== 0 ? Math.sqrt(Math.pow(thickness / 2 + gap / 4, 2) - Math.pow(thickness / 2, 2)) : 0;
            var initialStart = direction === 'horizontal' ? start + extraGap : start - extraGap;
            // define the x,y points for the corners of the bar.
            var points = direction === 'horizontal' ? [
                initialStart + "," + thickness,
                initialStart + ",0",
                start + delta + ",0",
                start + delta + "," + thickness
            ] : [
                thickness + "," + initialStart,
                "0," + initialStart,
                "0," + (start - delta),
                thickness + "," + (start - delta)
            ];
            // if rounded, the starting cap is an arc. All but the first bar
            // will have a gap and a slightly larger radius
            var startRadius = index === 0 ? capRadius : capRadius + gap / 2;
            var startCap = round ? "A " + startRadius + "," + startRadius + " 0 0 " + (index === 0 ? 1 : 0) + " " + points[1] : "L " + points[1];
            var endCap = round ? "A " + capRadius + "," + capRadius + " 0 0 1 " + points[3] : "L " + points[3];
            var d = "M " + points[0] + " " + startCap + " L " + points[2] + " " + endCap + " Z";
            var colorName = color || (0, $386a94958037ec1a$export$f705f0fde43a55a)(index, theme, values ? values.length : 0);
            var hoverProps;
            if (onHover) hoverProps = {
                onMouseOver: function onMouseOver() {
                    return onHover(true);
                },
                onMouseLeave: function onMouseLeave() {
                    return onHover(false);
                }
            };
            var fill = (0, $386a94958037ec1a$export$4ccf064591ccdacd)(someHighlight && !highlight ? background : colorName, theme);
            acc.push(/*#__PURE__*/ $9777593562b8440d$var$_react["default"].createElement("path", $9777593562b8440d$var$_extends({
                key: key,
                d: d
            }, fill, {
                strokeWidth: 0,
                stroke: "none"
            }, hoverProps, pathRest)));
            if (direction === 'horizontal') start += delta + gap;
            else start -= delta + gap;
        }
        return acc;
    }, []).reverse(); // reverse so the caps look right
    var width;
    if (direction === 'horizontal') width = size === 'full' ? '100%' : length;
    else width = size === 'full' ? '100%' : thickness;
    var backgroundPath = direction === 'horizontal' ? "M " + capRadius + "," + mid + " L " + (length - capRadius) + "," + mid : "M " + mid + "," + capRadius + " L " + mid + "," + (length - capRadius);
    return /*#__PURE__*/ $9777593562b8440d$var$_react["default"].createElement($9e378c3b7e3919ef$export$430a924eee89432c, $9777593562b8440d$var$_extends({
        ref: ref,
        viewBox: direction === 'horizontal' ? "0 0 " + length + " " + thickness : "0 0 " + thickness + " " + length,
        preserveAspectRatio: "none",
        width: width,
        height: direction === 'horizontal' ? thickness : length,
        round: round ? {
            size: thicknessProp
        } : undefined
    }, passThemeFlag, rest, {
        reverse: reverse
    }), /*#__PURE__*/ $9777593562b8440d$var$_react["default"].createElement("path", $9777593562b8440d$var$_extends({
        d: backgroundPath,
        fill: "none"
    }, (0, $386a94958037ec1a$export$c6dfdb238d76e427)(background, theme), {
        strokeWidth: thickness,
        strokeLinecap: round ? 'round' : 'square'
    })), paths);
});
$9777593562b8440d$var$Bar.displayName = 'Bar';


var $fedb4e38dc9111f3$export$1e511d4a378977f5;
var $fedb4e38dc9111f3$export$c89a927ffc67e6fa;
"use strict";
$fedb4e38dc9111f3$export$1e511d4a378977f5 = true;
$fedb4e38dc9111f3$export$c89a927ffc67e6fa = void 0;

var $fedb4e38dc9111f3$var$_react = $fedb4e38dc9111f3$var$_interopRequireWildcard((parcelRequire("2xPiy")));




var $fedb4e38dc9111f3$var$_excluded = [
    "background",
    "max",
    "round",
    "size",
    "thickness",
    "type",
    "values"
], $fedb4e38dc9111f3$var$_excluded2 = [
    "color",
    "highlight",
    "label",
    "onHover",
    "value"
];
function $fedb4e38dc9111f3$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($fedb4e38dc9111f3$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $fedb4e38dc9111f3$var$_extends() {
    return $fedb4e38dc9111f3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fedb4e38dc9111f3$var$_extends.apply(null, arguments);
}
function $fedb4e38dc9111f3$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $fedb4e38dc9111f3$var$Circle = $fedb4e38dc9111f3$export$c89a927ffc67e6fa = /*#__PURE__*/ (0, $fedb4e38dc9111f3$var$_react.forwardRef)(function(props, ref) {
    var _theme$meter$gap, _theme$meter;
    var background = props.background, max = props.max, round = props.round, size = props.size, thickness = props.thickness, type = props.type, values = props.values, rest = $fedb4e38dc9111f3$var$_objectWithoutPropertiesLoose(props, $fedb4e38dc9111f3$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var width = size === 'full' ? 288 : (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.size[size] || size);
    var strokeWidth = type === 'pie' ? width / 2 : Math.min(width / 2 - 8, (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.edgeSize[thickness] || thickness));
    var centerX = width / 2;
    var centerY = width / 2;
    var radius = width / 2 - strokeWidth / 2;
    // truncate to avoid floating point arithmetic errors
    // see: https://github.com/grommet/grommet/issues/6190
    // Choose a scale factor at least 3 orders of magnitude above max
    var scalePower = Math.max(5, Math.ceil(Math.log10(max)) + 3);
    var scale = Math.pow(10, scalePower);
    var anglePer = Math.floor((type === 'semicircle' ? 180 : 360) / max * scale) / scale;
    var someHighlight = (values || []).some(function(v) {
        return v.highlight;
    });
    var gapTheme = (_theme$meter$gap = (_theme$meter = theme.meter) == null ? void 0 : _theme$meter.gap) != null ? _theme$meter$gap : '0';
    var gap = (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.edgeSize[gapTheme] || gapTheme);
    var isSemi = type === 'semicircle';
    var isFull = values.reduce(function(total, currentValue) {
        return total + currentValue.value;
    }, 0) >= max;
    var startValue = 0;
    var startAngle = isSemi ? 270 : 0;
    var paths = [];
    (values || []).filter(function(v) {
        return v.value > 0;
    }).forEach(function(valueArg, index, _ref) {
        var length = _ref.length;
        var color = valueArg.color, highlight = valueArg.highlight, label = valueArg.label, onHover = valueArg.onHover, value = valueArg.value, pathRest = $fedb4e38dc9111f3$var$_objectWithoutPropertiesLoose(valueArg, $fedb4e38dc9111f3$var$_excluded2);
        var key = "p-" + index;
        var colorName = color || (0, $386a94958037ec1a$export$f705f0fde43a55a)(index, theme, values ? values.length : 0);
        var endAngle;
        if (startValue + value >= max) endAngle = isSemi ? 90 : 360;
        else endAngle = (0, $4113023f9e0bafa0$exports.translateEndAngle)(startAngle, anglePer, value);
        var hoverProps;
        if (onHover) hoverProps = {
            onMouseOver: function onMouseOver() {
                return onHover(true);
            },
            onMouseLeave: function onMouseLeave() {
                return onHover(false);
            }
        };
        var stroke = (0, $386a94958037ec1a$export$c6dfdb238d76e427)(someHighlight && !highlight ? background : colorName, theme);
        var fill = (0, $386a94958037ec1a$export$4ccf064591ccdacd)(someHighlight && !highlight ? background : colorName, theme);
        var outerRadius = width / 2;
        var innerRadius = type === 'pie' ? 0 : width / 2 - strokeWidth;
        // We want a start gap if there's another segment before this one.
        // A circle's last segment can bump against the first segment if at max.
        var startGap = index === 0 && (isSemi || length === 1 || length > 1 && !isFull) ? 0 : gap / 2;
        // Similarly, we only need an end gap if there's a segment after this one.
        var endGap = index === length - 1 && (isSemi || length === 1) ? 0 : -gap / 2;
        var startRound = index === 0 && isSemi ? false : round;
        var d = (0, $4113023f9e0bafa0$exports.wedgeCommands)(centerX, centerY, outerRadius, innerRadius, startAngle, endAngle, startGap, endGap, startRound, round, index === 0 ? 1 : 0);
        paths.push(/*#__PURE__*/ $fedb4e38dc9111f3$var$_react["default"].createElement("path", $fedb4e38dc9111f3$var$_extends({
            key: key,
            d: d
        }, fill, stroke, {
            strokeWidth: 0,
            strokeLinecap: "butt"
        }, hoverProps, pathRest)));
        startValue += value;
        startAngle = endAngle;
    });
    var track;
    if (type === 'semicircle') {
        var d1 = (0, $4113023f9e0bafa0$exports.arcCommands)(centerX, centerY, radius, 270, 90);
        track = /*#__PURE__*/ $fedb4e38dc9111f3$var$_react["default"].createElement("path", $fedb4e38dc9111f3$var$_extends({
            d: d1,
            strokeWidth: strokeWidth,
            fill: "none"
        }, (0, $386a94958037ec1a$export$c6dfdb238d76e427)(background, theme), {
            strokeLinecap: round ? 'round' : 'square'
        }));
    } else track = /*#__PURE__*/ $fedb4e38dc9111f3$var$_react["default"].createElement("circle", $fedb4e38dc9111f3$var$_extends({
        cx: centerX,
        cy: centerY,
        r: radius
    }, (0, $386a94958037ec1a$export$c6dfdb238d76e427)(background, theme), {
        strokeWidth: strokeWidth,
        strokeLinecap: round ? 'round' : 'square',
        fill: "none"
    }));
    var viewBoxHeight = type === 'semicircle' ? width / 2 : width;
    return /*#__PURE__*/ $fedb4e38dc9111f3$var$_react["default"].createElement($9e378c3b7e3919ef$export$430a924eee89432c, $fedb4e38dc9111f3$var$_extends({
        ref: ref,
        viewBox: "0 0 " + width + " " + viewBoxHeight,
        width: size === 'full' ? '100%' : width,
        height: size === 'full' ? '100%' : viewBoxHeight
    }, passThemeFlag, rest), track, paths);
});
$fedb4e38dc9111f3$var$Circle.displayName = 'Circle';


var $a3d8ecb2ccfa06a1$export$1e511d4a378977f5;
var $a3d8ecb2ccfa06a1$export$1d51da36beba5791;
"use strict";
$a3d8ecb2ccfa06a1$export$1e511d4a378977f5 = true;
$a3d8ecb2ccfa06a1$export$1d51da36beba5791 = void 0;

var $a3d8ecb2ccfa06a1$var$_propTypes = $a3d8ecb2ccfa06a1$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $a3d8ecb2ccfa06a1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $a3d8ecb2ccfa06a1$var$_extends() {
    return $a3d8ecb2ccfa06a1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a3d8ecb2ccfa06a1$var$_extends.apply(null, arguments);
}
var $a3d8ecb2ccfa06a1$var$PropType = {};
$a3d8ecb2ccfa06a1$var$PropType = $a3d8ecb2ccfa06a1$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    background: $a3d8ecb2ccfa06a1$var$_propTypes["default"].oneOfType([
        $a3d8ecb2ccfa06a1$var$_propTypes["default"].string,
        $a3d8ecb2ccfa06a1$var$_propTypes["default"].shape({
            color: $a3d8ecb2ccfa06a1$var$_propTypes["default"].string,
            opacity: $a3d8ecb2ccfa06a1$var$_propTypes["default"].oneOfType([
                $a3d8ecb2ccfa06a1$var$_propTypes["default"].oneOf([
                    'weak',
                    'medium',
                    'strong'
                ]),
                $a3d8ecb2ccfa06a1$var$_propTypes["default"].number,
                $a3d8ecb2ccfa06a1$var$_propTypes["default"].bool
            ])
        })
    ]),
    color: $a3d8ecb2ccfa06a1$var$_propTypes["default"].string,
    max: $a3d8ecb2ccfa06a1$var$_propTypes["default"].oneOfType([
        $a3d8ecb2ccfa06a1$var$_propTypes["default"].number,
        $a3d8ecb2ccfa06a1$var$_propTypes["default"].string
    ]),
    messages: $a3d8ecb2ccfa06a1$var$_propTypes["default"].shape({
        bar: $a3d8ecb2ccfa06a1$var$_propTypes["default"].shape({
            singular: $a3d8ecb2ccfa06a1$var$_propTypes["default"].string,
            plural: $a3d8ecb2ccfa06a1$var$_propTypes["default"].string
        }),
        circle: $a3d8ecb2ccfa06a1$var$_propTypes["default"].shape({
            singular: $a3d8ecb2ccfa06a1$var$_propTypes["default"].string,
            plural: $a3d8ecb2ccfa06a1$var$_propTypes["default"].string
        }),
        pie: $a3d8ecb2ccfa06a1$var$_propTypes["default"].shape({
            singular: $a3d8ecb2ccfa06a1$var$_propTypes["default"].string,
            plural: $a3d8ecb2ccfa06a1$var$_propTypes["default"].string
        }),
        semicirlce: $a3d8ecb2ccfa06a1$var$_propTypes["default"].shape({
            singular: $a3d8ecb2ccfa06a1$var$_propTypes["default"].string,
            plural: $a3d8ecb2ccfa06a1$var$_propTypes["default"].string
        })
    }),
    reverse: $a3d8ecb2ccfa06a1$var$_propTypes["default"].bool,
    round: $a3d8ecb2ccfa06a1$var$_propTypes["default"].bool,
    size: $a3d8ecb2ccfa06a1$var$_propTypes["default"].oneOfType([
        $a3d8ecb2ccfa06a1$var$_propTypes["default"].oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            'full'
        ]),
        $a3d8ecb2ccfa06a1$var$_propTypes["default"].string
    ]),
    thickness: $a3d8ecb2ccfa06a1$var$_propTypes["default"].oneOfType([
        $a3d8ecb2ccfa06a1$var$_propTypes["default"].oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        $a3d8ecb2ccfa06a1$var$_propTypes["default"].string
    ]),
    type: $a3d8ecb2ccfa06a1$var$_propTypes["default"].oneOf([
        'bar',
        'circle',
        'pie',
        'semicircle'
    ]),
    direction: $a3d8ecb2ccfa06a1$var$_propTypes["default"].oneOf([
        'horizontal',
        'vertical'
    ]),
    value: $a3d8ecb2ccfa06a1$var$_propTypes["default"].number,
    values: $a3d8ecb2ccfa06a1$var$_propTypes["default"].arrayOf($a3d8ecb2ccfa06a1$var$_propTypes["default"].shape({
        color: $a3d8ecb2ccfa06a1$var$_propTypes["default"].string,
        highlight: $a3d8ecb2ccfa06a1$var$_propTypes["default"].bool,
        label: $a3d8ecb2ccfa06a1$var$_propTypes["default"].string.isRequired,
        // for accessibility
        onClick: $a3d8ecb2ccfa06a1$var$_propTypes["default"].func,
        onHover: $a3d8ecb2ccfa06a1$var$_propTypes["default"].func,
        value: $a3d8ecb2ccfa06a1$var$_propTypes["default"].number.isRequired
    }))
});
var $a3d8ecb2ccfa06a1$var$MeterPropTypes = $a3d8ecb2ccfa06a1$export$1d51da36beba5791 = $a3d8ecb2ccfa06a1$var$PropType;




var $134ee1ff9cbc6ab8$var$_excluded = [
    "aria-label",
    "background",
    "color",
    "direction",
    "max",
    "messages",
    "size",
    "thickness",
    "type",
    "reverse",
    "value",
    "values"
];
function $134ee1ff9cbc6ab8$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($134ee1ff9cbc6ab8$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $134ee1ff9cbc6ab8$var$_extends() {
    return $134ee1ff9cbc6ab8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $134ee1ff9cbc6ab8$var$_extends.apply(null, arguments);
}
function $134ee1ff9cbc6ab8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $134ee1ff9cbc6ab8$var$Meter = $134ee1ff9cbc6ab8$export$62e3ae2a4090b879 = /*#__PURE__*/ (0, $134ee1ff9cbc6ab8$var$_react.forwardRef)(function(_ref, ref) {
    var _theme$meter, _messages$meter;
    var ariaLabel = _ref['aria-label'], backgroundProp = _ref.background, color = _ref.color, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? 'horizontal' : _ref$direction, maxProp = _ref.max, messages = _ref.messages, _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, _ref$thickness = _ref.thickness, thickness = _ref$thickness === void 0 ? 'medium' : _ref$thickness, _ref$type = _ref.type, type = _ref$type === void 0 ? 'bar' : _ref$type, reverseProp = _ref.reverse, value = _ref.value, valuesProp = _ref.values, rest = $134ee1ff9cbc6ab8$var$_objectWithoutPropertiesLoose(_ref, $134ee1ff9cbc6ab8$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useContext = (0, $134ee1ff9cbc6ab8$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var background = backgroundProp || ((_theme$meter = theme.meter) == null ? void 0 : _theme$meter.background);
    // normalize values to an array of objects
    var values = (0, $134ee1ff9cbc6ab8$var$_react.useMemo)(function() {
        if (valuesProp) return valuesProp;
        if (value) return [
            {
                color: color,
                value: value
            }
        ];
        return [];
    }, [
        color,
        value,
        valuesProp
    ]);
    var reverse = direction === 'horizontal' && (theme.dir === 'rtl' || reverseProp) && !(theme.dir === 'rtl' && reverseProp);
    var max = (0, $134ee1ff9cbc6ab8$var$_react.useMemo)(function() {
        var maxValue = 100;
        if ((values == null ? void 0 : values.length) > 1) maxValue = values.reduce(function(total, currentValue) {
            return total + currentValue.value;
        }, 0);
        return maxProp || maxValue || 100;
    }, [
        maxProp,
        values
    ]);
    var messageId = (values == null ? void 0 : values.length) === 1 ? 'singular' : 'plural';
    var meterType = type || 'bar';
    var meterAriaLabel = ariaLabel || format({
        id: "meter." + meterType + "." + messageId,
        messages: messages == null || (_messages$meter = messages.meter) == null ? void 0 : _messages$meter[meterType],
        values: {
            meterValue: value || values.map(function(item) {
                var _item$value;
                return (_item$value = item.value) != null ? _item$value : 0;
            }).join(', ') || 0,
            type: type,
            max: max
        }
    });
    var content;
    if (type === 'bar') content = /*#__PURE__*/ $134ee1ff9cbc6ab8$var$_react["default"].createElement($9777593562b8440d$export$bbc6c6369b38e3d1, $134ee1ff9cbc6ab8$var$_extends({
        ref: ref,
        "aria-label": meterAriaLabel,
        max: max,
        values: values,
        size: size,
        thickness: thickness,
        background: background,
        direction: direction,
        reverse: reverse
    }, rest));
    else if (type === 'circle' || type === 'pie' || type === 'semicircle') content = /*#__PURE__*/ $134ee1ff9cbc6ab8$var$_react["default"].createElement($fedb4e38dc9111f3$export$c89a927ffc67e6fa, $134ee1ff9cbc6ab8$var$_extends({
        "aria-label": meterAriaLabel,
        ref: ref,
        max: max,
        values: values,
        size: size,
        thickness: thickness,
        type: type,
        background: background,
        reverse: reverse
    }, rest));
    return content;
});
$134ee1ff9cbc6ab8$var$Meter.displayName = 'Meter';
$134ee1ff9cbc6ab8$var$Meter.prototype = $a3d8ecb2ccfa06a1$export$1d51da36beba5791;


$11d506dee5992445$export$62e3ae2a4090b879 = $134ee1ff9cbc6ab8$export$62e3ae2a4090b879;


Object.keys($11d506dee5992445$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $11d506dee5992445$exports[key]) return;
    $3321243da0932e1e$exports[key] = $11d506dee5992445$exports[key];
});
var $a0e29c79f9a1e764$exports = {};

$parcel$export($a0e29c79f9a1e764$exports, "__esModule", function () { return $a0e29c79f9a1e764$export$1e511d4a378977f5; }, function (v) { return $a0e29c79f9a1e764$export$1e511d4a378977f5 = v; });
$parcel$export($a0e29c79f9a1e764$exports, "PageContext", function () { return $a0e29c79f9a1e764$export$9a1b410c76d0e146; }, function (v) { return $a0e29c79f9a1e764$export$9a1b410c76d0e146 = v; });
$parcel$export($a0e29c79f9a1e764$exports, "Page", function () { return $a0e29c79f9a1e764$export$6955bcca4cd3539f; }, function (v) { return $a0e29c79f9a1e764$export$6955bcca4cd3539f = v; });
var $a0e29c79f9a1e764$export$1e511d4a378977f5;
var $a0e29c79f9a1e764$export$9a1b410c76d0e146;
var $a0e29c79f9a1e764$export$6955bcca4cd3539f;
"use strict";
$a0e29c79f9a1e764$export$1e511d4a378977f5 = true;
$a0e29c79f9a1e764$export$9a1b410c76d0e146 = $a0e29c79f9a1e764$export$6955bcca4cd3539f = void 0;
var $3606f62066e58bf4$export$1e511d4a378977f5;
var $3606f62066e58bf4$export$6955bcca4cd3539f;
"use strict";
$3606f62066e58bf4$export$1e511d4a378977f5 = true;
$3606f62066e58bf4$export$6955bcca4cd3539f = void 0;

var $3606f62066e58bf4$var$_react = $3606f62066e58bf4$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $9637be594238fbd2$export$1e511d4a378977f5;
var $9637be594238fbd2$export$9a1b410c76d0e146;
"use strict";
$9637be594238fbd2$export$1e511d4a378977f5 = true;
$9637be594238fbd2$export$9a1b410c76d0e146 = void 0;

var $2xPiy = parcelRequire("2xPiy");
var $9637be594238fbd2$var$PageContext = $9637be594238fbd2$export$9a1b410c76d0e146 = /*#__PURE__*/ (0, $2xPiy.createContext)({});



var $fe2687272617e914$export$1e511d4a378977f5;
var $fe2687272617e914$export$6e56b613da9ebece;
"use strict";
$fe2687272617e914$export$1e511d4a378977f5 = true;
$fe2687272617e914$export$6e56b613da9ebece = void 0;

var $fe2687272617e914$var$_propTypes = $fe2687272617e914$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $fe2687272617e914$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $fe2687272617e914$var$PropType = {};
$fe2687272617e914$var$PropType = {
    kind: $fe2687272617e914$var$_propTypes["default"].string
};
var $fe2687272617e914$var$PagePropTypes = $fe2687272617e914$export$6e56b613da9ebece = $fe2687272617e914$var$PropType;



var $3606f62066e58bf4$var$_excluded = [
    "kind"
];
function $3606f62066e58bf4$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($3606f62066e58bf4$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $3606f62066e58bf4$var$_extends() {
    return $3606f62066e58bf4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3606f62066e58bf4$var$_extends.apply(null, arguments);
}
function $3606f62066e58bf4$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $3606f62066e58bf4$var$Page = $3606f62066e58bf4$export$6955bcca4cd3539f = function Page(_ref) {
    var _ref$kind = _ref.kind, kind = _ref$kind === void 0 ? 'wide' : _ref$kind, rest = $3606f62066e58bf4$var$_objectWithoutPropertiesLoose(_ref, $3606f62066e58bf4$var$_excluded);
    var size = (0, $3606f62066e58bf4$var$_react.useContext)($afb62f3be48d73fe$export$51e389dae84ec233);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var contentValue = (0, $3606f62066e58bf4$var$_react.useMemo)(function() {
        var _theme$page$kind, _theme$page$kind2;
        return $3606f62066e58bf4$var$_extends({
            alignSelf: (_theme$page$kind = theme.page[kind]) == null ? void 0 : _theme$page$kind.alignSelf,
            width: (_theme$page$kind2 = theme.page[kind]) == null ? void 0 : _theme$page$kind2.width
        }, theme.page[kind][size]);
    }, [
        theme,
        size,
        kind
    ]);
    return /*#__PURE__*/ $3606f62066e58bf4$var$_react["default"].createElement($9637be594238fbd2$export$9a1b410c76d0e146.Provider, {
        value: contentValue
    }, /*#__PURE__*/ $3606f62066e58bf4$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $3606f62066e58bf4$var$_extends({
        fill: "horizontal"
    }, rest)));
};
$3606f62066e58bf4$var$Page.displayName = 'Page';
$3606f62066e58bf4$var$Page.propTypes = $fe2687272617e914$export$6e56b613da9ebece;


$a0e29c79f9a1e764$export$6955bcca4cd3539f = $3606f62066e58bf4$export$6955bcca4cd3539f;

$a0e29c79f9a1e764$export$9a1b410c76d0e146 = $9637be594238fbd2$export$9a1b410c76d0e146;


Object.keys($a0e29c79f9a1e764$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $a0e29c79f9a1e764$exports[key]) return;
    $3321243da0932e1e$exports[key] = $a0e29c79f9a1e764$exports[key];
});
var $00f60b67cd517e35$exports = {};

$parcel$export($00f60b67cd517e35$exports, "__esModule", function () { return $00f60b67cd517e35$export$1e511d4a378977f5; }, function (v) { return $00f60b67cd517e35$export$1e511d4a378977f5 = v; });
$parcel$export($00f60b67cd517e35$exports, "PageContent", function () { return $00f60b67cd517e35$export$16800ac069904dff; }, function (v) { return $00f60b67cd517e35$export$16800ac069904dff = v; });
var $00f60b67cd517e35$export$1e511d4a378977f5;
var $00f60b67cd517e35$export$16800ac069904dff;
"use strict";
$00f60b67cd517e35$export$1e511d4a378977f5 = true;
$00f60b67cd517e35$export$16800ac069904dff = void 0;
var $0982486937048cfa$export$1e511d4a378977f5;
var $0982486937048cfa$export$16800ac069904dff;
"use strict";
$0982486937048cfa$export$1e511d4a378977f5 = true;
$0982486937048cfa$export$16800ac069904dff = void 0;

var $0982486937048cfa$var$_react = $0982486937048cfa$var$_interopRequireWildcard((parcelRequire("2xPiy")));


var $40090714fca69ced$export$1e511d4a378977f5;
var $40090714fca69ced$export$bd00041de5f1e7cc;
"use strict";
$40090714fca69ced$export$1e511d4a378977f5 = true;
$40090714fca69ced$export$bd00041de5f1e7cc = void 0;

var $40090714fca69ced$var$_propTypes = $40090714fca69ced$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $40090714fca69ced$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $40090714fca69ced$var$PropType = {};
$40090714fca69ced$var$PropType = {
    background: $40090714fca69ced$var$_propTypes["default"].oneOfType([
        $40090714fca69ced$var$_propTypes["default"].string,
        $40090714fca69ced$var$_propTypes["default"].shape({
            color: $5897bd367fbd90c1$export$fc4c368d97afb623,
            dark: $40090714fca69ced$var$_propTypes["default"].oneOfType([
                $40090714fca69ced$var$_propTypes["default"].bool,
                $40090714fca69ced$var$_propTypes["default"].string
            ]),
            image: $40090714fca69ced$var$_propTypes["default"].string,
            position: $40090714fca69ced$var$_propTypes["default"].string,
            opacity: $40090714fca69ced$var$_propTypes["default"].oneOfType([
                $40090714fca69ced$var$_propTypes["default"].string,
                $40090714fca69ced$var$_propTypes["default"].bool,
                $40090714fca69ced$var$_propTypes["default"].number,
                $40090714fca69ced$var$_propTypes["default"].oneOf([
                    'weak',
                    'medium',
                    'strong'
                ])
            ]),
            repeat: $40090714fca69ced$var$_propTypes["default"].oneOfType([
                $40090714fca69ced$var$_propTypes["default"].oneOf([
                    'no-repeat',
                    'repeat'
                ]),
                $40090714fca69ced$var$_propTypes["default"].string
            ]),
            size: $40090714fca69ced$var$_propTypes["default"].oneOfType([
                $40090714fca69ced$var$_propTypes["default"].oneOf([
                    'cover',
                    'contain'
                ]),
                $40090714fca69ced$var$_propTypes["default"].string
            ]),
            light: $40090714fca69ced$var$_propTypes["default"].string,
            fill: $40090714fca69ced$var$_propTypes["default"].oneOf([
                'horizontal'
            ])
        })
    ])
};
var $40090714fca69ced$var$PageContentPropTypes = $40090714fca69ced$export$bd00041de5f1e7cc = $40090714fca69ced$var$PropType;


var $0982486937048cfa$var$_excluded = [
    "children",
    "background"
];
function $0982486937048cfa$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($0982486937048cfa$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $0982486937048cfa$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $0982486937048cfa$var$_extends() {
    return $0982486937048cfa$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0982486937048cfa$var$_extends.apply(null, arguments);
}
function $0982486937048cfa$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $0982486937048cfa$var$PageContent = $0982486937048cfa$export$16800ac069904dff = function PageContent(_ref) {
    var children = _ref.children, background = _ref.background, rest = $0982486937048cfa$var$_objectWithoutPropertiesLoose(_ref, $0982486937048cfa$var$_excluded);
    var _useContext = (0, $0982486937048cfa$var$_react.useContext)($a0e29c79f9a1e764$export$9a1b410c76d0e146), pageContext = $0982486937048cfa$var$_extends({}, ($0982486937048cfa$var$_objectDestructuringEmpty(_useContext), _useContext));
    if (background != null && background.fill) return /*#__PURE__*/ $0982486937048cfa$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        background: background
    }, /*#__PURE__*/ $0982486937048cfa$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $0982486937048cfa$var$_extends({
        fill: "horizontal"
    }, pageContext, rest), children));
    return /*#__PURE__*/ $0982486937048cfa$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $0982486937048cfa$var$_extends({
        fill: "horizontal",
        background: background
    }, pageContext, rest), children);
};
$0982486937048cfa$var$PageContent.displayName = 'PageContent';
$0982486937048cfa$var$PageContent.propTypes = $40090714fca69ced$export$bd00041de5f1e7cc;


$00f60b67cd517e35$export$16800ac069904dff = $0982486937048cfa$export$16800ac069904dff;


Object.keys($00f60b67cd517e35$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $00f60b67cd517e35$exports[key]) return;
    $3321243da0932e1e$exports[key] = $00f60b67cd517e35$exports[key];
});
var $89bec56551035cc9$exports = {};

$parcel$export($89bec56551035cc9$exports, "__esModule", function () { return $89bec56551035cc9$export$1e511d4a378977f5; }, function (v) { return $89bec56551035cc9$export$1e511d4a378977f5 = v; });
$parcel$export($89bec56551035cc9$exports, "PageHeader", function () { return $89bec56551035cc9$export$53f1cd6809577fc5; }, function (v) { return $89bec56551035cc9$export$53f1cd6809577fc5 = v; });
var $89bec56551035cc9$export$1e511d4a378977f5;
var $89bec56551035cc9$export$53f1cd6809577fc5;
"use strict";
$89bec56551035cc9$export$1e511d4a378977f5 = true;
$89bec56551035cc9$export$53f1cd6809577fc5 = void 0;
var $07ae3b962a02d10f$export$1e511d4a378977f5;
var $07ae3b962a02d10f$export$53f1cd6809577fc5;
"use strict";
$07ae3b962a02d10f$export$1e511d4a378977f5 = true;
$07ae3b962a02d10f$export$53f1cd6809577fc5 = void 0;

var $07ae3b962a02d10f$var$_react = $07ae3b962a02d10f$var$_interopRequireWildcard((parcelRequire("2xPiy")));







var $07ae3b962a02d10f$var$_excluded = [
    "actions",
    "gridProps",
    "parent",
    "responsive",
    "size",
    "subtitle",
    "title",
    "level"
];
function $07ae3b962a02d10f$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($07ae3b962a02d10f$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $07ae3b962a02d10f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $07ae3b962a02d10f$var$_extends() {
    return $07ae3b962a02d10f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $07ae3b962a02d10f$var$_extends.apply(null, arguments);
}
var $07ae3b962a02d10f$var$sizeStyle = function sizeStyle(size, feature, theme, breakpoint) {
    var _ref, _theme$pageHeader$siz, _theme$global$breakpo, _theme$global$breakpo2;
    var style = $07ae3b962a02d10f$var$_extends({}, theme.pageHeader[feature], (_ref = size && ((_theme$pageHeader$siz = theme.pageHeader.size[size]) == null ? void 0 : _theme$pageHeader$siz[feature])) != null ? _ref : theme.pageHeader[feature], (!size || size === 'medium') && feature === 'subtitle' && ((_theme$global$breakpo = theme.global.breakpoints[breakpoint]) == null ? void 0 : _theme$global$breakpo.value) <= ((_theme$global$breakpo2 = theme.global.breakpoints.small) == null ? void 0 : _theme$global$breakpo2.value) && {
        size: 'medium'
    });
    return style;
};
var $07ae3b962a02d10f$var$PageHeader = $07ae3b962a02d10f$export$53f1cd6809577fc5 = /*#__PURE__*/ (0, $07ae3b962a02d10f$var$_react.forwardRef)(function(_ref2, ref) {
    var actions = _ref2.actions, gridPropsProp = _ref2.gridProps, parent = _ref2.parent, responsive = _ref2.responsive, size = _ref2.size, subtitle = _ref2.subtitle, title = _ref2.title, level = _ref2.level, rest = $07ae3b962a02d10f$var$_objectWithoutPropertiesLoose(_ref2, $07ae3b962a02d10f$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var breakpoint = (0, $07ae3b962a02d10f$var$_react.useContext)($afb62f3be48d73fe$export$51e389dae84ec233);
    var actionsProps = $07ae3b962a02d10f$var$_extends({}, theme.pageHeader.actions);
    var gridProps = theme.pageHeader[breakpoint] || theme.pageHeader.medium;
    if (responsive && theme.pageHeader.responsive.breakpoints.includes(breakpoint)) {
        gridProps = $07ae3b962a02d10f$var$_extends({}, gridProps, theme.pageHeader.responsive);
        actionsProps = $07ae3b962a02d10f$var$_extends({}, actionsProps, theme.pageHeader.responsive.actions);
    }
    var _gridProps = gridProps, areas = _gridProps.areas, columns = _gridProps.columns, gap = _gridProps.gap, rows = _gridProps.rows;
    return /*#__PURE__*/ $07ae3b962a02d10f$var$_react["default"].createElement($30d6151480c557a9$export$8b251419efc915eb, $07ae3b962a02d10f$var$_extends({
        ref: ref,
        direction: "column",
        gap: "none",
        pad: $07ae3b962a02d10f$var$sizeStyle(size, 'pad', theme)
    }, rest), /*#__PURE__*/ $07ae3b962a02d10f$var$_react["default"].createElement($f75e849c2101cc4f$export$ef2184bd89960b14, $07ae3b962a02d10f$var$_extends({
        columns: columns,
        rows: rows,
        areas: areas,
        gap: gap,
        fill: "horizontal"
    }, gridPropsProp), /*#__PURE__*/ $07ae3b962a02d10f$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $07ae3b962a02d10f$var$_extends({
        gridArea: "parent"
    }, theme.pageHeader.parent), parent), /*#__PURE__*/ $07ae3b962a02d10f$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        gridArea: "title"
    }, typeof title === 'string' ? /*#__PURE__*/ $07ae3b962a02d10f$var$_react["default"].createElement($2d67f2629ee502eb$export$a8a3e93435678ff9, $07ae3b962a02d10f$var$_extends({}, $07ae3b962a02d10f$var$sizeStyle(size, 'title', theme), {
        level: level
    }), title) : title), /*#__PURE__*/ $07ae3b962a02d10f$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        gridArea: "subtitle"
    }, typeof subtitle === 'string' ? /*#__PURE__*/ $07ae3b962a02d10f$var$_react["default"].createElement($5db3f40fe57c037a$export$358a232cca1ab2ac, $07ae3b962a02d10f$var$sizeStyle(size, 'subtitle', theme, breakpoint), subtitle) : subtitle), /*#__PURE__*/ $07ae3b962a02d10f$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $07ae3b962a02d10f$var$_extends({
        gridArea: "actions"
    }, actionsProps), actions)));
});
$07ae3b962a02d10f$var$PageHeader.displayName = 'PageHeader';


$89bec56551035cc9$export$53f1cd6809577fc5 = $07ae3b962a02d10f$export$53f1cd6809577fc5;


Object.keys($89bec56551035cc9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $89bec56551035cc9$exports[key]) return;
    $3321243da0932e1e$exports[key] = $89bec56551035cc9$exports[key];
});

Object.keys($98274833e85ef953$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $98274833e85ef953$exports[key]) return;
    $3321243da0932e1e$exports[key] = $98274833e85ef953$exports[key];
});

Object.keys($5db3f40fe57c037a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $5db3f40fe57c037a$exports[key]) return;
    $3321243da0932e1e$exports[key] = $5db3f40fe57c037a$exports[key];
});
var $6491b444acb2b209$exports = {};

$parcel$export($6491b444acb2b209$exports, "__esModule", function () { return $6491b444acb2b209$export$1e511d4a378977f5; }, function (v) { return $6491b444acb2b209$export$1e511d4a378977f5 = v; });
$parcel$export($6491b444acb2b209$exports, "NameValuePair", function () { return $6491b444acb2b209$export$9a496f4062109dc9; }, function (v) { return $6491b444acb2b209$export$9a496f4062109dc9 = v; });
var $6491b444acb2b209$export$1e511d4a378977f5;
var $6491b444acb2b209$export$9a496f4062109dc9;
"use strict";
$6491b444acb2b209$export$1e511d4a378977f5 = true;
$6491b444acb2b209$export$9a496f4062109dc9 = void 0;
var $468ef4af51751dd9$export$1e511d4a378977f5;
var $468ef4af51751dd9$export$9a496f4062109dc9;
"use strict";
$468ef4af51751dd9$export$1e511d4a378977f5 = true;
$468ef4af51751dd9$export$9a496f4062109dc9 = void 0;

var $468ef4af51751dd9$var$_react = $468ef4af51751dd9$var$_interopRequireWildcard((parcelRequire("2xPiy")));



var $9930ecf5ccd66b1b$export$1e511d4a378977f5;
var $9930ecf5ccd66b1b$export$efbf3df94e304ee;
"use strict";
$9930ecf5ccd66b1b$export$1e511d4a378977f5 = true;
$9930ecf5ccd66b1b$export$efbf3df94e304ee = void 0;

var $9930ecf5ccd66b1b$var$_react = $9930ecf5ccd66b1b$var$_interopRequireDefault((parcelRequire("2xPiy")));
function $9930ecf5ccd66b1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $9930ecf5ccd66b1b$var$NameValueListContext = $9930ecf5ccd66b1b$export$efbf3df94e304ee = /*#__PURE__*/ $9930ecf5ccd66b1b$var$_react["default"].createContext({});




function $468ef4af51751dd9$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($468ef4af51751dd9$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $468ef4af51751dd9$var$_extends() {
    return $468ef4af51751dd9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $468ef4af51751dd9$var$_extends.apply(null, arguments);
}
var $468ef4af51751dd9$var$NameValuePair = $468ef4af51751dd9$export$9a496f4062109dc9 = function NameValuePair(_ref) {
    var _theme$nameValuePair;
    var children = _ref.children, nameProp = _ref.name;
    var _useContext = (0, $468ef4af51751dd9$var$_react.useContext)($9930ecf5ccd66b1b$export$efbf3df94e304ee), nameProps = _useContext.nameProps, pairProps = _useContext.pairProps, valueProps = _useContext.valueProps;
    var size = (0, $468ef4af51751dd9$var$_react.useContext)($afb62f3be48d73fe$export$51e389dae84ec233);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var direction = pairProps == null ? void 0 : pairProps.direction;
    var column = direction === 'column' || direction === 'column-reverse' || (0, $80783f9dd7b08ab9$export$813595e92b2e7a6f)(size);
    var Container = column ? $090ffb0ba78fff3f$export$e71c4d32a2263218 : $468ef4af51751dd9$var$_react.Fragment;
    var nameAlign = !(0, $80783f9dd7b08ab9$export$813595e92b2e7a6f)(size) ? nameProps == null ? void 0 : nameProps.align : undefined;
    var valueAlign = !(0, $80783f9dd7b08ab9$export$813595e92b2e7a6f)(size) ? valueProps == null ? void 0 : valueProps.align : undefined;
    // using margin to act as gap
    // <dl> elements must only directly contain
    // properly-ordered <dt> and <dd> groups
    var valueGap;
    if (column && (_theme$nameValuePair = theme.nameValuePair) != null && (_theme$nameValuePair = _theme$nameValuePair.column) != null && _theme$nameValuePair.gap) valueGap = {
        bottom: theme.nameValuePair.column.gap
    };
    var name;
    if (typeof nameProp === 'string' || typeof nameProp === 'number') name = /*#__PURE__*/ $468ef4af51751dd9$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, $468ef4af51751dd9$var$_extends({
        as: "dt",
        margin: valueGap,
        textAlign: nameAlign
    }, theme.nameValuePair.name), nameProp);
    else name = /*#__PURE__*/ $468ef4af51751dd9$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        as: "dt",
        align: nameAlign
    }, nameProp);
    var value;
    if (typeof children === 'string' || typeof children === 'number') value = /*#__PURE__*/ // override browser default margin for dd
    $468ef4af51751dd9$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, $468ef4af51751dd9$var$_extends({
        as: "dd",
        margin: "none",
        textAlign: valueAlign
    }, theme.nameValuePair.value), children);
    else value = /*#__PURE__*/ // override browser default margin for dd
    $468ef4af51751dd9$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        margin: "none",
        as: "dd",
        align: valueAlign
    }, children);
    var first = direction !== 'column-reverse' ? name : value;
    var second = direction !== 'column-reverse' ? value : name;
    return /*#__PURE__*/ $468ef4af51751dd9$var$_react["default"].createElement(Container, null, first, second);
};


$6491b444acb2b209$export$9a496f4062109dc9 = $468ef4af51751dd9$export$9a496f4062109dc9;


Object.keys($6491b444acb2b209$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $6491b444acb2b209$exports[key]) return;
    $3321243da0932e1e$exports[key] = $6491b444acb2b209$exports[key];
});
var $9b18dc95e9a26648$exports = {};

$parcel$export($9b18dc95e9a26648$exports, "__esModule", function () { return $9b18dc95e9a26648$export$1e511d4a378977f5; }, function (v) { return $9b18dc95e9a26648$export$1e511d4a378977f5 = v; });
$parcel$export($9b18dc95e9a26648$exports, "NameValueList", function () { return $9b18dc95e9a26648$export$d6b8afbf3931ce21; }, function (v) { return $9b18dc95e9a26648$export$d6b8afbf3931ce21 = v; });
var $9b18dc95e9a26648$export$1e511d4a378977f5;
var $9b18dc95e9a26648$export$d6b8afbf3931ce21;
"use strict";
$9b18dc95e9a26648$export$1e511d4a378977f5 = true;
$9b18dc95e9a26648$export$d6b8afbf3931ce21 = void 0;
var $f118eeabcb012d6a$export$1e511d4a378977f5;
var $f118eeabcb012d6a$export$d6b8afbf3931ce21;
"use strict";
$f118eeabcb012d6a$export$1e511d4a378977f5 = true;
$f118eeabcb012d6a$export$d6b8afbf3931ce21 = void 0;

var $f118eeabcb012d6a$var$_react = $f118eeabcb012d6a$var$_interopRequireWildcard((parcelRequire("2xPiy")));





var $f118eeabcb012d6a$var$_excluded = [
    "align",
    "layout",
    "nameProps",
    "pairProps",
    "valueProps"
];
function $f118eeabcb012d6a$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($f118eeabcb012d6a$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $f118eeabcb012d6a$var$_extends() {
    return $f118eeabcb012d6a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f118eeabcb012d6a$var$_extends.apply(null, arguments);
}
function $f118eeabcb012d6a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $f118eeabcb012d6a$var$NameValueList = $f118eeabcb012d6a$export$d6b8afbf3931ce21 = /*#__PURE__*/ (0, $f118eeabcb012d6a$var$_react.forwardRef)(function(_ref, ref) {
    var _theme$nameValueList$;
    var align = _ref.align, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? 'column' : _ref$layout, nameProps = _ref.nameProps, _ref$pairProps = _ref.pairProps, pairProps = _ref$pairProps === void 0 ? {
        direction: 'row'
    } : _ref$pairProps, valueProps = _ref.valueProps, rest = $f118eeabcb012d6a$var$_objectWithoutPropertiesLoose(_ref, $f118eeabcb012d6a$var$_excluded);
    var size = (0, $f118eeabcb012d6a$var$_react.useContext)($afb62f3be48d73fe$export$51e389dae84ec233);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    // If layout is grid, valueWidth sets the max width of the column.
    // Grid will 'fit' as many columns of valueWidth per row as container's
    // width allows.
    var columns;
    var valueWidth = (valueProps == null ? void 0 : valueProps.width) || theme.nameValueList.value.width;
    var nameWidth = (nameProps == null ? void 0 : nameProps.width) || theme.nameValueList.name.width;
    var formatWidth = function formatWidth(width) {
        return typeof width === 'object' ? [
            width.min,
            width.max
        ] : width;
    };
    nameWidth = formatWidth(nameWidth);
    valueWidth = formatWidth(valueWidth);
    if ((0, $80783f9dd7b08ab9$export$813595e92b2e7a6f)(size) || layout === 'grid') columns = {
        count: 'fit',
        size: !Array.isArray(valueWidth) ? [
            'auto',
            valueWidth
        ] : valueWidth
    };
    else if (layout === 'column' && pairProps.direction === 'row') columns = [
        nameWidth,
        !Array.isArray(valueWidth) ? [
            'auto',
            valueWidth
        ] : valueWidth
    ];
    else columns = [
        valueWidth
    ];
    var gap = theme.nameValueList.gap;
    if ((pairProps.direction === 'column' || (0, $80783f9dd7b08ab9$export$813595e92b2e7a6f)(size)) && (_theme$nameValueList$ = theme.nameValueList.pair) != null && (_theme$nameValueList$ = _theme$nameValueList$.column) != null && _theme$nameValueList$.gap) gap = theme.nameValueList.pair.column.gap;
    var listContextValue = (0, $f118eeabcb012d6a$var$_react.useMemo)(function() {
        return {
            nameProps: nameProps,
            pairProps: pairProps,
            valueProps: valueProps
        };
    }, [
        nameProps,
        pairProps,
        valueProps
    ]);
    return /*#__PURE__*/ $f118eeabcb012d6a$var$_react["default"].createElement($9930ecf5ccd66b1b$export$efbf3df94e304ee.Provider, {
        value: listContextValue
    }, /*#__PURE__*/ $f118eeabcb012d6a$var$_react["default"].createElement($f75e849c2101cc4f$export$ef2184bd89960b14, $f118eeabcb012d6a$var$_extends({
        as: "dl",
        ref: ref,
        align: align,
        columns: columns,
        gap: gap,
        margin: "none" // override browser default margin for dl
    }, rest)));
});
$f118eeabcb012d6a$var$NameValueList.displayName = 'NameValueList';


$9b18dc95e9a26648$export$d6b8afbf3931ce21 = $f118eeabcb012d6a$export$d6b8afbf3931ce21;


Object.keys($9b18dc95e9a26648$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $9b18dc95e9a26648$exports[key]) return;
    $3321243da0932e1e$exports[key] = $9b18dc95e9a26648$exports[key];
});

Object.keys($30abe96e60597f25$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $30abe96e60597f25$exports[key]) return;
    $3321243da0932e1e$exports[key] = $30abe96e60597f25$exports[key];
});
var $c048938b9e4f97f2$exports = {};

$parcel$export($c048938b9e4f97f2$exports, "__esModule", function () { return $c048938b9e4f97f2$export$1e511d4a378977f5; }, function (v) { return $c048938b9e4f97f2$export$1e511d4a378977f5 = v; });
$parcel$export($c048938b9e4f97f2$exports, "Notification", function () { return $c048938b9e4f97f2$export$14834abbfce3b8cd; }, function (v) { return $c048938b9e4f97f2$export$14834abbfce3b8cd = v; });
var $c048938b9e4f97f2$export$1e511d4a378977f5;
var $c048938b9e4f97f2$export$14834abbfce3b8cd;
"use strict";
$c048938b9e4f97f2$export$1e511d4a378977f5 = true;
$c048938b9e4f97f2$export$14834abbfce3b8cd = void 0;
var $f42532ca859e63aa$export$1e511d4a378977f5;
var $f42532ca859e63aa$export$14834abbfce3b8cd;
"use strict";
$f42532ca859e63aa$export$1e511d4a378977f5 = true;
$f42532ca859e63aa$export$14834abbfce3b8cd = void 0;

var $f42532ca859e63aa$var$_react = $f42532ca859e63aa$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $f42532ca859e63aa$var$_styledComponents = $f42532ca859e63aa$var$_interopRequireDefault((parcelRequire("iA1nz")));








var $31345c76c3bf3505$export$1e511d4a378977f5;
var $31345c76c3bf3505$export$9130146a86a85749;
"use strict";
$31345c76c3bf3505$export$1e511d4a378977f5 = true;
$31345c76c3bf3505$export$9130146a86a85749 = void 0;

var $31345c76c3bf3505$var$_propTypes = $31345c76c3bf3505$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $31345c76c3bf3505$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $31345c76c3bf3505$var$PropType = {};
$31345c76c3bf3505$var$PropType = {
    id: $31345c76c3bf3505$var$_propTypes["default"].string,
    actions: $31345c76c3bf3505$var$_propTypes["default"].arrayOf($31345c76c3bf3505$var$_propTypes["default"].shape($f73163d0ec743d8c$export$503a586efc7a7ea1)),
    global: $31345c76c3bf3505$var$_propTypes["default"].bool,
    title: $31345c76c3bf3505$var$_propTypes["default"].string,
    message: $31345c76c3bf3505$var$_propTypes["default"].oneOfType([
        $31345c76c3bf3505$var$_propTypes["default"].string,
        $31345c76c3bf3505$var$_propTypes["default"].node
    ]),
    messages: $31345c76c3bf3505$var$_propTypes["default"].shape({
        close: $31345c76c3bf3505$var$_propTypes["default"].string
    }),
    status: $31345c76c3bf3505$var$_propTypes["default"].oneOf([
        'critical',
        'warning',
        'normal',
        'info',
        'unknown'
    ]),
    toast: $31345c76c3bf3505$var$_propTypes["default"].oneOfType([
        $31345c76c3bf3505$var$_propTypes["default"].bool,
        $31345c76c3bf3505$var$_propTypes["default"].shape({
            autoClose: $31345c76c3bf3505$var$_propTypes["default"].bool,
            position: $31345c76c3bf3505$var$_propTypes["default"].oneOf([
                'bottom',
                'bottom-left',
                'bottom-right',
                'center',
                'end',
                'hidden',
                'left',
                'right',
                'start',
                'top',
                'top-left',
                'top-right'
            ])
        })
    ]),
    onClose: $31345c76c3bf3505$var$_propTypes["default"].func,
    icon: $31345c76c3bf3505$var$_propTypes["default"].element,
    time: $31345c76c3bf3505$var$_propTypes["default"].number
};
var $31345c76c3bf3505$var$NotificationType = $31345c76c3bf3505$export$9130146a86a85749 = $31345c76c3bf3505$var$PropType;



var $f42532ca859e63aa$var$_excluded = [
    "fill",
    "direction"
], $f42532ca859e63aa$var$_excluded2 = [
    "actions",
    "message",
    "messages",
    "onClose",
    "id",
    "global",
    "status",
    "title",
    "toast",
    "icon",
    "time"
]; // eslint-disable-next-line max-len
function $f42532ca859e63aa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $f42532ca859e63aa$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($f42532ca859e63aa$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $f42532ca859e63aa$var$_extends() {
    return $f42532ca859e63aa$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f42532ca859e63aa$var$_extends.apply(null, arguments);
}
function $f42532ca859e63aa$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $f42532ca859e63aa$var$Message = function Message(_ref) {
    var fill = _ref.fill, direction = _ref.direction, rest = $f42532ca859e63aa$var$_objectWithoutPropertiesLoose(_ref, $f42532ca859e63aa$var$_excluded);
    return direction === 'row' ? /*#__PURE__*/ $f42532ca859e63aa$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, rest) : /*#__PURE__*/ $f42532ca859e63aa$var$_react["default"].createElement($5db3f40fe57c037a$export$358a232cca1ab2ac, $f42532ca859e63aa$var$_extends({}, rest, {
        fill: fill || false
    }));
};
var $f42532ca859e63aa$var$adaptThemeStyle = function adaptThemeStyle(value, theme) {
    var textStyle = value;
    var closeButtonStyle = value;
    if (typeof value === 'string' && theme.global.edgeSize[value]) {
        textStyle = {
            vertical: value,
            left: value,
            right: undefined
        };
        closeButtonStyle = {
            vertical: value,
            right: value
        };
    } else if (typeof value === 'object') {
        var left = value.left, right = value.right, top = value.top, bottom = value.bottom, horizontal = value.horizontal, vertical = value.vertical;
        textStyle = {
            top: top || vertical,
            bottom: bottom || vertical,
            left: left || horizontal,
            right: undefined
        };
        closeButtonStyle = {
            top: top || vertical,
            bottom: bottom || vertical,
            right: right || horizontal
        };
    }
    return [
        textStyle,
        closeButtonStyle
    ];
};
var $f42532ca859e63aa$var$getTextColor = function getTextColor(part, status, kind, theme) {
    var _theme$notification, _theme$notification2, _theme$notification3, _theme$notification4, _theme$notification5;
    var color;
    if ((_theme$notification = theme.notification) != null && (_theme$notification = _theme$notification[status]) != null && (_theme$notification = _theme$notification[kind]) != null && (_theme$notification = _theme$notification[part]) != null && _theme$notification.color) color = (_theme$notification2 = theme.notification) == null || (_theme$notification2 = _theme$notification2[status]) == null || (_theme$notification2 = _theme$notification2[kind]) == null || (_theme$notification2 = _theme$notification2[part]) == null ? void 0 : _theme$notification2.color;
    else if ((_theme$notification3 = theme.notification) != null && (_theme$notification3 = _theme$notification3[status]) != null && (_theme$notification3 = _theme$notification3[part]) != null && _theme$notification3.color) color = (_theme$notification4 = theme.notification) == null || (_theme$notification4 = _theme$notification4[status]) == null || (_theme$notification4 = _theme$notification4[part]) == null ? void 0 : _theme$notification4.color;
    else color = (_theme$notification5 = theme.notification) == null || (_theme$notification5 = _theme$notification5[part]) == null ? void 0 : _theme$notification5.color;
    return color;
};
var $f42532ca859e63aa$var$NotificationAnchor = (0, $f42532ca859e63aa$var$_styledComponents["default"])($e78646567f384248$export$b688253958b8dfe7).withConfig({
    displayName: "Notification__NotificationAnchor",
    componentId: "sc-1yq09yz-0"
})([
    "white-space:nowrap;"
]);
var $f42532ca859e63aa$var$Notification = $f42532ca859e63aa$export$14834abbfce3b8cd = function Notification(_ref2) {
    var _theme$notification6, _theme$notification7, _theme$notification8, _theme$notification9, _theme$notification0, _theme$notification1;
    var actionsProp = _ref2.actions, messageProp = _ref2.message, messages = _ref2.messages, onClose = _ref2.onClose, id = _ref2.id, global = _ref2.global, _ref2$status = _ref2.status, status = _ref2$status === void 0 ? 'unknown' : _ref2$status, title = _ref2.title, _ref2$toast = _ref2.toast, toast = _ref2$toast === void 0 ? false : _ref2$toast, icon = _ref2.icon, time = _ref2.time, rest = $f42532ca859e63aa$var$_objectWithoutPropertiesLoose(_ref2, $f42532ca859e63aa$var$_excluded2);
    var autoClose = toast && (toast == null ? void 0 : toast.autoClose) === undefined ? true : toast.autoClose;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useState = (0, $f42532ca859e63aa$var$_react.useState)(true), visible = _useState[0], setVisible = _useState[1];
    var _useContext = (0, $f42532ca859e63aa$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var position = (0, $f42532ca859e63aa$var$_react.useMemo)(function() {
        return toast && (toast == null ? void 0 : toast.position) || 'top';
    }, [
        toast
    ]);
    var announce = (0, $f42532ca859e63aa$var$_react.useContext)($f3d02c0ed94e6438$export$dcc8f4bff0d51f50);
    (0, $f42532ca859e63aa$var$_react.useEffect)(function() {
        if (visible && toast) {
            var announceText = typeof messageProp === 'string' ? title + ". " + messageProp : title;
            announce(announceText, 'polite', time || theme.notification.toast.time || theme.notification.time);
        }
    }, [
        announce,
        visible,
        toast,
        messageProp,
        title,
        theme.notification.toast.time,
        theme.notification.time,
        time
    ]);
    var close = (0, $f42532ca859e63aa$var$_react.useCallback)(function(event) {
        setVisible(false);
        if (onClose) onClose(event);
    }, [
        onClose
    ]);
    (0, $f42532ca859e63aa$var$_react.useEffect)(function() {
        if (autoClose) {
            var timer = setTimeout(close, time || theme.notification.toast.time || theme.notification.time);
            return function() {
                return clearTimeout(timer);
            };
        }
        return undefined;
    }, [
        autoClose,
        close,
        theme.notification.toast.time,
        theme.notification.time,
        time
    ]);
    var CloseIcon = theme.notification.close.icon;
    var _ref3 = ((_theme$notification6 = theme.notification) == null ? void 0 : _theme$notification6[status]) || theme.notification.unknown, StatusIcon = _ref3.icon, color = _ref3.color;
    var closeIconColor = theme.notification.close.color;
    var kind = (0, $f42532ca859e63aa$var$_react.useMemo)(function() {
        if (toast) return 'toast';
        if (global) return 'global';
        return undefined;
    }, [
        global,
        toast
    ]);
    var direction;
    if (kind && theme.notification[kind].direction) direction = theme.notification[kind].direction;
    else direction = theme.notification.direction;
    var background;
    if (kind && (_theme$notification7 = theme.notification) != null && (_theme$notification7 = _theme$notification7[status]) != null && (_theme$notification7 = _theme$notification7[kind]) != null && _theme$notification7.background) background = theme.notification[status][kind].background;
    else if ((_theme$notification8 = theme.notification) != null && (_theme$notification8 = _theme$notification8[status]) != null && _theme$notification8.background) background = theme.notification[status].background;
    else background = ((_theme$notification9 = theme.notification) == null || (_theme$notification9 = _theme$notification9[kind]) == null || (_theme$notification9 = _theme$notification9.container) == null ? void 0 : _theme$notification9.background) || theme.notification.container.background;
    var TextWrapper = direction === 'row' ? $2f0b7ad0e7a4866d$export$5f1af8db9871e1d6 : $f42532ca859e63aa$var$_react.Fragment;
    // notification is built with two child boxes that contain:
    // 1. icon + text (wrapped in button when clickable)
    // 2. close button
    // pad needs to be applied to the child boxes, but we don't want to apply
    // extra padding between the icon + text and the button.
    var pad;
    if (kind && theme.notification[kind].container.pad) pad = theme.notification[kind].container.pad;
    else pad = theme.notification.container.pad;
    var textPad;
    var closeButtonPad;
    if (onClose) {
        var _adaptThemeStyle = $f42532ca859e63aa$var$adaptThemeStyle(pad, theme);
        textPad = _adaptThemeStyle[0];
        closeButtonPad = _adaptThemeStyle[1];
    } else textPad = pad;
    var actions;
    var message = messageProp;
    var messageColor = $f42532ca859e63aa$var$getTextColor('message', status, kind, theme);
    var titleColor = $f42532ca859e63aa$var$getTextColor('title', status, kind, theme);
    if (actionsProp) actions = actionsProp.map(function(action) {
        var _theme$notification$a;
        return /*#__PURE__*/ $f42532ca859e63aa$var$_react["default"].createElement($f42532ca859e63aa$var$_react.Fragment, {
            key: action.label
        }, /*#__PURE__*/ $f42532ca859e63aa$var$_react["default"].createElement($f42532ca859e63aa$var$NotificationAnchor, $f42532ca859e63aa$var$_extends({
            margin: (_theme$notification$a = theme.notification.actions) == null ? void 0 : _theme$notification$a.margin
        }, action, theme.notification.actions)), ' ');
    });
    if (message || actions) {
        var _theme$notification$m;
        message = typeof message === 'string' ? /*#__PURE__*/ $f42532ca859e63aa$var$_react["default"].createElement($f42532ca859e63aa$var$Message, $f42532ca859e63aa$var$_extends({}, theme.notification.message, {
            color: messageColor,
            direction: direction
        }), /*#__PURE__*/ $f42532ca859e63aa$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, {
            margin: (_theme$notification$m = theme.notification.message) == null || (_theme$notification$m = _theme$notification$m.text) == null ? void 0 : _theme$notification$m.margin
        }, message), actions) : message;
    }
    var iconDimension = ((_theme$notification0 = theme.notification) == null || (_theme$notification0 = _theme$notification0.message) == null ? void 0 : _theme$notification0.size) || 'medium';
    var content = /*#__PURE__*/ $f42532ca859e63aa$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $f42532ca859e63aa$var$_extends({}, theme.notification.container, global ? $f42532ca859e63aa$var$_extends({}, theme.notification.global.container) : {}, toast ? $f42532ca859e63aa$var$_extends({}, theme.notification.toast.container) : {}, {
        background: background,
        pad: undefined,
        direction: "row",
        gap: (_theme$notification1 = theme.notification) == null ? void 0 : _theme$notification1.gap,
        id: toast ? undefined : id
    }, rest), /*#__PURE__*/ $f42532ca859e63aa$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        direction: "row",
        pad: textPad,
        flex: true
    }, /*#__PURE__*/ $f42532ca859e63aa$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, theme.notification.iconContainer, icon || /*#__PURE__*/ $f42532ca859e63aa$var$_react["default"].createElement(StatusIcon, {
        color: color,
        height: iconDimension
    })), /*#__PURE__*/ $f42532ca859e63aa$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, theme.notification.textContainer, /*#__PURE__*/ $f42532ca859e63aa$var$_react["default"].createElement(TextWrapper, null, title && /*#__PURE__*/ $f42532ca859e63aa$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, $f42532ca859e63aa$var$_extends({}, theme.notification.title, {
        color: titleColor
    }), title), message && title && direction === 'row' && /*#__PURE__*/ $f42532ca859e63aa$var$_react["default"].createElement($f42532ca859e63aa$var$_react["default"].Fragment, null, "\xA0"), message))), onClose && /*#__PURE__*/ // theme.notification.container and textContainer may both have pad,
    // account for both
    $f42532ca859e63aa$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        pad: closeButtonPad
    }, /*#__PURE__*/ $f42532ca859e63aa$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, theme.notification.textContainer, /*#__PURE__*/ $f42532ca859e63aa$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
        a11yTitle: format({
            id: 'notification.close',
            messages: messages
        }),
        icon: /*#__PURE__*/ $f42532ca859e63aa$var$_react["default"].createElement(CloseIcon, {
            color: closeIconColor,
            height: iconDimension,
            width: iconDimension
        }),
        onClick: close,
        hoverIndicator: true,
        plain: true
    }))));
    if (toast) content = visible && /*#__PURE__*/ $f42532ca859e63aa$var$_react["default"].createElement($e03e15968966d631$export$936d0764594b6eb3, $f42532ca859e63aa$var$_extends({}, theme.notification.toast.layer, {
        role: "status",
        modal: false,
        onEsc: onClose,
        id: id,
        responsive: false,
        plain: true,
        position: position
    }), content);
    return content;
};
$f42532ca859e63aa$var$Notification.displayName = 'Notification';
$f42532ca859e63aa$var$Notification.propTypes = $31345c76c3bf3505$export$9130146a86a85749;


$c048938b9e4f97f2$export$14834abbfce3b8cd = $f42532ca859e63aa$export$14834abbfce3b8cd;


Object.keys($c048938b9e4f97f2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $c048938b9e4f97f2$exports[key]) return;
    $3321243da0932e1e$exports[key] = $c048938b9e4f97f2$exports[key];
});

Object.keys($2c032e59ff28f8f3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $2c032e59ff28f8f3$exports[key]) return;
    $3321243da0932e1e$exports[key] = $2c032e59ff28f8f3$exports[key];
});

Object.keys($49bedb3ed8912461$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $49bedb3ed8912461$exports[key]) return;
    $3321243da0932e1e$exports[key] = $49bedb3ed8912461$exports[key];
});
var $954c2c1554a60438$exports = {};

$parcel$export($954c2c1554a60438$exports, "__esModule", function () { return $954c2c1554a60438$export$1e511d4a378977f5; }, function (v) { return $954c2c1554a60438$export$1e511d4a378977f5 = v; });
$parcel$export($954c2c1554a60438$exports, "RangeInput", function () { return $954c2c1554a60438$export$f5603a09670563b9; }, function (v) { return $954c2c1554a60438$export$f5603a09670563b9 = v; });
var $954c2c1554a60438$export$1e511d4a378977f5;
var $954c2c1554a60438$export$f5603a09670563b9;
"use strict";
$954c2c1554a60438$export$1e511d4a378977f5 = true;
$954c2c1554a60438$export$f5603a09670563b9 = void 0;
var $d4e333530e0f2f0c$export$1e511d4a378977f5;
var $d4e333530e0f2f0c$export$f5603a09670563b9;
"use strict";
$d4e333530e0f2f0c$export$1e511d4a378977f5 = true;
$d4e333530e0f2f0c$export$f5603a09670563b9 = void 0;

var $d4e333530e0f2f0c$var$_react = $d4e333530e0f2f0c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $7d6015f841618978$export$1e511d4a378977f5;
var $7d6015f841618978$export$647d0a7cb8b754c2;
"use strict";
$7d6015f841618978$export$1e511d4a378977f5 = true;
$7d6015f841618978$export$647d0a7cb8b754c2 = void 0;

var $7d6015f841618978$var$_styledComponents = $7d6015f841618978$var$_interopRequireWildcard((parcelRequire("iA1nz")));

function $7d6015f841618978$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($7d6015f841618978$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
// opacity of the bound trumps the track opacity
var $7d6015f841618978$var$getBoundOpacity = function getBoundOpacity(props, bound) {
    return props.theme.rangeInput && props.theme.rangeInput.track && props.theme.rangeInput.track[bound] && props.theme.rangeInput.track[bound].opacity ? props.theme.rangeInput.track[bound].opacity : 1;
};
var $7d6015f841618978$var$getBoundColor = function getBoundColor(props, bound) {
    if (props.theme.rangeInput && props.theme.rangeInput.track && props.theme.rangeInput.track[bound] && props.theme.rangeInput.track[bound].color) return (0, $4113023f9e0bafa0$exports.getRGBA)((0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.rangeInput.track[bound].color, props.theme), $7d6015f841618978$var$getBoundOpacity(props, bound));
    // If bound color is undefined pick the default track color with bound opacity
    return (0, $4113023f9e0bafa0$exports.getRGBA)((0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.rangeInput.track.color, props.theme), $7d6015f841618978$var$getBoundOpacity(props, bound));
};
var $7d6015f841618978$var$trackColorStyle = function trackColorStyle(props) {
    var _props$theme$rangeInp, _props$theme$rangeInp2;
    var max = props.max, min = props.min;
    var thumbPosition = ((props.value || 0) - min) / (max - min) * 100 + "%";
    var defaultTrackColor;
    // backward compatibility in case no bounds are defined
    if (props.theme.rangeInput && props.theme.rangeInput.track && !props.theme.rangeInput.track.lower && !props.theme.rangeInput.track.upper) {
        var color = (0, $4113023f9e0bafa0$exports.getRGBA)((0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.rangeInput.track.color, props.theme), 0.2);
        // Since the track color was changed from border-with-opacity to just border
        // this condition is used to make sure we are applying the opacity correctly
        // for 'border' color (for backward compatibility purposes).
        if (color === 'rgba(0, 0, 0, 0.2)') defaultTrackColor = color;
        else defaultTrackColor = (0, $4113023f9e0bafa0$exports.getRGBA)((0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.rangeInput.track.color, props.theme), props.theme.rangeInput.track.opacity || 1);
        if (!props.color) return "background: " + defaultTrackColor;
    }
    var upperTrackColor = (_props$theme$rangeInp = props.theme.rangeInput.track) != null && _props$theme$rangeInp.upper ? $7d6015f841618978$var$getBoundColor(props, 'upper') : defaultTrackColor;
    var lowerTrackColor = (_props$theme$rangeInp2 = props.theme.rangeInput.track) != null && _props$theme$rangeInp2.lower ? $7d6015f841618978$var$getBoundColor(props, 'lower') : (0, $4113023f9e0bafa0$exports.getRGBA)((0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.global.colors.control, props.theme), props.theme.rangeInput.track.opacity || 1);
    if (typeof props.color === 'string' || typeof props.color === 'object' && !Array.isArray(props.color)) {
        lowerTrackColor = (0, $4113023f9e0bafa0$exports.normalizeColor)(props.color, props.theme);
        return "background: linear-gradient(\n        to right,\n        " + lowerTrackColor + ",\n        " + lowerTrackColor + " " + thumbPosition + ",\n        " + upperTrackColor + " " + thumbPosition + ",\n        " + upperTrackColor + "\n      );\n    ";
    }
    if (Array.isArray(props.color)) {
        var arrayOfTrackColors = props.color;
        var valuePercentage = 0;
        var result = "background: linear-gradient(to right,";
        for(var index = 0; index < arrayOfTrackColors.length; index += 1){
            var _arrayOfTrackColors$i = arrayOfTrackColors[index], value = _arrayOfTrackColors$i.value, _color = _arrayOfTrackColors$i.color, opacity = _arrayOfTrackColors$i.opacity;
            result += (0, $4113023f9e0bafa0$exports.getRGBA)((0, $4113023f9e0bafa0$exports.normalizeColor)(_color, props.theme), opacity || 1) + " " + valuePercentage + "%,";
            if (props.value >= value) {
                valuePercentage = (value - min) / (max - min) * 100;
                result += (0, $4113023f9e0bafa0$exports.getRGBA)((0, $4113023f9e0bafa0$exports.normalizeColor)(_color, props.theme), opacity || 1) + " " + valuePercentage + "%,";
            } else {
                result += (0, $4113023f9e0bafa0$exports.getRGBA)((0, $4113023f9e0bafa0$exports.normalizeColor)(_color, props.theme), opacity || 1) + " " + thumbPosition + ",";
                result += upperTrackColor + " " + thumbPosition + ", " + upperTrackColor + ")";
                break;
            }
            if (index === arrayOfTrackColors.length - 1) result += upperTrackColor + " " + valuePercentage + "%, " + upperTrackColor + ")";
        }
        return result;
    }
    return "background: linear-gradient(\n      to right,\n      " + lowerTrackColor + ",\n      " + lowerTrackColor + " " + thumbPosition + ",\n      " + upperTrackColor + " " + thumbPosition + ",\n      " + upperTrackColor + "\n    );\n  ";
};
var $7d6015f841618978$var$disabledRangeInputStyle = function disabledRangeInputStyle(props, context) {
    var _props$theme$rangeInp3;
    return (0, $7d6015f841618978$var$_styledComponents.css)([
        "",
        " ",
        ""
    ], (0, $4113023f9e0bafa0$exports.disabledStyle)(props.theme.rangeInput.disabled.opacity), ((_props$theme$rangeInp3 = props.theme.rangeInput.disabled[context]) == null ? void 0 : _props$theme$rangeInp3.color) && "background: " + (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.rangeInput.disabled[context].color, props.theme) + ";");
};
var $7d6015f841618978$var$hoverStyle = function hoverStyle(props) {
    return (0, $7d6015f841618978$var$_styledComponents.css)([
        "box-shadow:0px 0px 0px 2px ",
        ";"
    ], (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.rangeInput.thumb.color || 'control', props.theme));
};
var $7d6015f841618978$var$rangeTrackStyle = (0, $7d6015f841618978$var$_styledComponents.css)([
    "box-sizing:border-box;width:100%;height:",
    ";",
    ";",
    " ",
    ";"
], function(props) {
    return props.theme.rangeInput.track.height;
}, function(props) {
    return $7d6015f841618978$var$trackColorStyle(props);
}, function(props) {
    return props.theme.rangeInput && props.theme.rangeInput.track && props.theme.rangeInput.track.extend;
}, function(props) {
    var _props$theme;
    return props.disabled && ((_props$theme = props.theme) == null || (_props$theme = _props$theme.rangeInput) == null ? void 0 : _props$theme.disabled) && $7d6015f841618978$var$disabledRangeInputStyle(props, 'track');
});
var $7d6015f841618978$var$rangeThumbStyle = (0, $7d6015f841618978$var$_styledComponents.css)([
    "box-sizing:border-box;position:relative;border-radius:",
    ";height:",
    ";width:",
    ";overflow:visible;background:",
    ";-webkit-appearance:none;cursor:pointer;",
    " ",
    ";"
], function(props) {
    return props.theme.global.spacing;
}, function(props) {
    return props.theme.global.spacing;
}, function(props) {
    return props.theme.global.spacing;
}, function(props) {
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.rangeInput.thumb.color || 'control', props.theme);
}, function(props) {
    return props.theme.rangeInput && props.theme.rangeInput.thumb && props.theme.rangeInput.thumb.extend;
}, function(props) {
    var _props$theme2;
    return props.disabled && ((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.rangeInput) == null ? void 0 : _props$theme2.disabled) && $7d6015f841618978$var$disabledRangeInputStyle(props, 'thumb');
});
var $7d6015f841618978$var$firefoxMicrosoftThumbStyle = (0, $7d6015f841618978$var$_styledComponents.css)([
    "",
    " margin-top:0px;height:",
    ";width:",
    ";",
    " ",
    ""
], $7d6015f841618978$var$rangeThumbStyle, function(props) {
    return props.theme.global.spacing;
}, function(props) {
    return props.theme.global.spacing;
}, function(props) {
    return props.focus && props.focusIndicator && (0, $4113023f9e0bafa0$exports.focusStyle)();
}, function(props) {
    return props.theme.rangeInput && props.theme.rangeInput.thumb && props.theme.rangeInput.thumb.extend;
});
/* eslint-disable max-len */ var $7d6015f841618978$var$StyledRangeInput = $7d6015f841618978$export$647d0a7cb8b754c2 = $7d6015f841618978$var$_styledComponents["default"].input.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledRangeInput",
    componentId: "sc-15st9ck-0"
})([
    "box-sizing:border-box;position:relative;-webkit-appearance:none;border-color:transparent;height:",
    ";width:100%;padding:0px;cursor:",
    ";background:transparent;margin:0px;",
    " &::-moz-focus-inner{border:none;}&::-moz-focus-outer{border:none;}&::-webkit-slider-runnable-track{",
    "}&::-webkit-slider-thumb{margin-top:-",
    "px;",
    " ",
    " ",
    "}&::-moz-range-track{",
    "}&::-moz-range-thumb{",
    "}&::-ms-thumb{",
    "}",
    " &::-ms-track{",
    " border-color:transparent;color:transparent;}&::-ms-fill-lower{",
    ";border-color:transparent;}&::-ms-fill-upper{",
    ";border-color:transparent;}&:focus::-webkit-slider-thumb{",
    "}&:focus-visible{outline:0;}&:focus{outline:none;}",
    ""
], function(props) {
    return props.theme.global.spacing;
}, function(props) {
    return props.disabled ? 'default' : 'pointer';
}, function(props) {
    return props.theme.rangeInput.pad && (0, $4113023f9e0bafa0$exports.edgeStyle)('padding', props.theme.rangeInput.pad, props.responsive, props.theme.box.responsiveBreakpoint, props.theme);
}, $7d6015f841618978$var$rangeTrackStyle, function(props) {
    return ((0, $4113023f9e0bafa0$exports.parseMetricToNum)(props.theme.global.spacing) - (0, $4113023f9e0bafa0$exports.parseMetricToNum)(props.theme.rangeInput.track.height || 0)) * 0.5;
}, $7d6015f841618978$var$rangeThumbStyle, function(props) {
    return !props.disabled && (0, $7d6015f841618978$var$_styledComponents.css)([
        "&:hover{",
        "}"
    ], $7d6015f841618978$var$hoverStyle(props));
}, function(props) {
    return props.focus && !props.focusIndicator && (0, $7d6015f841618978$var$_styledComponents.css)([
        "",
        ""
    ], $7d6015f841618978$var$hoverStyle(props));
}, $7d6015f841618978$var$rangeTrackStyle, $7d6015f841618978$var$firefoxMicrosoftThumbStyle, $7d6015f841618978$var$firefoxMicrosoftThumbStyle, function(props) {
    return !props.disabled && (0, $7d6015f841618978$var$_styledComponents.css)([
        "&:hover::-moz-range-thumb{",
        "}&:hover::-ms-thumb{",
        "}"
    ], $7d6015f841618978$var$hoverStyle(props), $7d6015f841618978$var$hoverStyle(props));
}, $7d6015f841618978$var$rangeTrackStyle, function(props) {
    return $7d6015f841618978$var$trackColorStyle(props, 'lower');
}, function(props) {
    return $7d6015f841618978$var$trackColorStyle(props, 'upper');
}, function(props) {
    return props.focus && props.focusIndicator && (0, $4113023f9e0bafa0$exports.focusStyle)();
}, function(props) {
    return props.theme.rangeInput && props.theme.rangeInput.extend;
}); /* eslint-enable max-len */ 


var $e7f7dd5dc4491ecf$export$1e511d4a378977f5;
var $e7f7dd5dc4491ecf$export$b02c8b389b8f64a5;
"use strict";
$e7f7dd5dc4491ecf$export$1e511d4a378977f5 = true;
$e7f7dd5dc4491ecf$export$b02c8b389b8f64a5 = void 0;

var $e7f7dd5dc4491ecf$var$_propTypes = $e7f7dd5dc4491ecf$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $e7f7dd5dc4491ecf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $e7f7dd5dc4491ecf$var$PropType = {};
$e7f7dd5dc4491ecf$var$PropType = {
    a11yTitle: $e7f7dd5dc4491ecf$var$_propTypes["default"].string,
    color: $e7f7dd5dc4491ecf$var$_propTypes["default"].oneOfType([
        $5897bd367fbd90c1$export$fc4c368d97afb623,
        $e7f7dd5dc4491ecf$var$_propTypes["default"].arrayOf($e7f7dd5dc4491ecf$var$_propTypes["default"].shape({
            color: $5897bd367fbd90c1$export$fc4c368d97afb623.isRequired,
            value: $e7f7dd5dc4491ecf$var$_propTypes["default"].number.isRequired,
            opacity: $e7f7dd5dc4491ecf$var$_propTypes["default"].number
        }))
    ]),
    id: $e7f7dd5dc4491ecf$var$_propTypes["default"].string,
    min: $e7f7dd5dc4491ecf$var$_propTypes["default"].oneOfType([
        $e7f7dd5dc4491ecf$var$_propTypes["default"].number,
        $e7f7dd5dc4491ecf$var$_propTypes["default"].string
    ]),
    max: $e7f7dd5dc4491ecf$var$_propTypes["default"].oneOfType([
        $e7f7dd5dc4491ecf$var$_propTypes["default"].number,
        $e7f7dd5dc4491ecf$var$_propTypes["default"].string
    ]),
    name: $e7f7dd5dc4491ecf$var$_propTypes["default"].string,
    onChange: $e7f7dd5dc4491ecf$var$_propTypes["default"].func,
    step: $e7f7dd5dc4491ecf$var$_propTypes["default"].number,
    value: $e7f7dd5dc4491ecf$var$_propTypes["default"].oneOfType([
        $e7f7dd5dc4491ecf$var$_propTypes["default"].number,
        $e7f7dd5dc4491ecf$var$_propTypes["default"].string
    ])
};
var $e7f7dd5dc4491ecf$var$RangeInputPropTypes = $e7f7dd5dc4491ecf$export$b02c8b389b8f64a5 = $e7f7dd5dc4491ecf$var$PropType;




var $d4e333530e0f2f0c$var$_excluded = [
    "a11yTitle",
    "color",
    "focus",
    "focusIndicator",
    "name",
    "onChange",
    "onFocus",
    "onBlur",
    "value",
    "step",
    "min",
    "max"
];
function $d4e333530e0f2f0c$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($d4e333530e0f2f0c$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $d4e333530e0f2f0c$var$_extends() {
    return $d4e333530e0f2f0c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d4e333530e0f2f0c$var$_extends.apply(null, arguments);
}
function $d4e333530e0f2f0c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $d4e333530e0f2f0c$var$RangeInput = $d4e333530e0f2f0c$export$f5603a09670563b9 = /*#__PURE__*/ (0, $d4e333530e0f2f0c$var$_react.forwardRef)(function(_ref, ref) {
    var _theme$rangeInput;
    var a11yTitle = _ref.a11yTitle, color = _ref.color, focusProp = _ref.focus, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, name = _ref.name, _onChange = _ref.onChange, _onFocus = _ref.onFocus, _onBlur = _ref.onBlur, valueProp = _ref.value, _ref$step = _ref.step, step = _ref$step === void 0 ? 1 : _ref$step, _ref$min = _ref.min, min = _ref$min === void 0 ? 0 : _ref$min, _ref$max = _ref.max, max = _ref$max === void 0 ? 100 : _ref$max, rest = $d4e333530e0f2f0c$var$_objectWithoutPropertiesLoose(_ref, $d4e333530e0f2f0c$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var formContext = (0, $d4e333530e0f2f0c$var$_react.useContext)($5c9c2e034f522b3e$export$c24727297075ec6a);
    var _useState = (0, $d4e333530e0f2f0c$var$_react.useState)(focusProp), focus = _useState[0], setFocus = _useState[1];
    var scrollEnabled = (theme == null || (_theme$rangeInput = theme.rangeInput) == null ? void 0 : _theme$rangeInput.wheel) !== false;
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    var _useState2 = (0, $d4e333530e0f2f0c$var$_react.useState)({
        x: null,
        y: null
    }), scroll = _useState2[0], setScroll = _useState2[1];
    var rangeInputRef = (0, $4113023f9e0bafa0$exports.useForwardedRef)(ref);
    (0, $d4e333530e0f2f0c$var$_react.useEffect)(function() {
        var x = scroll.x, y = scroll.y;
        var handleScrollTo = function handleScrollTo() {
            return window.scrollTo(x, y);
        };
        if (x !== null && y !== null && scrollEnabled) window.addEventListener('scroll', handleScrollTo);
        // there is no need to remove this event listener if scroll is disabled
        // but we need to remove it if scroll is enabled and user switches to
        // a theme with scroll disabled
        return function() {
            window.removeEventListener('scroll', handleScrollTo);
        };
    }, [
        scroll,
        scrollEnabled
    ]);
    var setRangeInputValue = (0, $d4e333530e0f2f0c$var$_react.useCallback)(function(nextValue) {
        if (nextValue > max || nextValue < min) return;
        // Calling set value function directly on input because React library
        // overrides setter `event.target.value =` and loses original event
        // target fidelity.
        // https://stackoverflow.com/a/46012210
        var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
        nativeInputValueSetter.call(rangeInputRef.current, nextValue);
        var event = new Event('input', {
            bubbles: true
        });
        rangeInputRef.current.dispatchEvent(event);
    }, [
        rangeInputRef,
        min,
        max
    ]);
    var handleOnWheel = function handleOnWheel(event) {
        var newValue = parseFloat(value);
        if (event.deltaY < 0) setRangeInputValue(newValue + step);
        else setRangeInputValue(newValue - step);
    };
    // This is to make sure scrollbar doesn't move
    // when user changes RangeInput value.
    var handleMouseOver = function handleMouseOver() {
        return setScroll({
            x: window.scrollX,
            y: window.scrollY
        });
    };
    var handleMouseOut = function handleMouseOut() {
        return setScroll({
            x: null,
            y: null
        });
    };
    return /*#__PURE__*/ $d4e333530e0f2f0c$var$_react["default"].createElement($7d6015f841618978$export$647d0a7cb8b754c2, $d4e333530e0f2f0c$var$_extends({
        "aria-label": a11yTitle,
        "aria-valuemax": max,
        "aria-valuemin": min,
        "aria-valuenow": value !== '' ? value : undefined,
        ref: rangeInputRef,
        name: name,
        focus: focus,
        focusIndicator: focusIndicator,
        value: value || value === 0 ? value : ''
    }, passThemeFlag, rest, {
        color: color,
        onFocus: function onFocus(event) {
            setFocus(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        onChange: function onChange(event) {
            setValue(event.target.value);
            if (_onChange) _onChange(event);
        },
        onMouseOver: scrollEnabled ? handleMouseOver : undefined,
        onMouseOut: scrollEnabled ? handleMouseOut : undefined,
        onWheel: scrollEnabled ? handleOnWheel : undefined,
        step: step,
        type: "range",
        min: min,
        max: max
    }));
});
$d4e333530e0f2f0c$var$RangeInput.displayName = 'RangeInput';
$d4e333530e0f2f0c$var$RangeInput.propTypes = $e7f7dd5dc4491ecf$export$b02c8b389b8f64a5;


$954c2c1554a60438$export$f5603a09670563b9 = $d4e333530e0f2f0c$export$f5603a09670563b9;


Object.keys($954c2c1554a60438$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $954c2c1554a60438$exports[key]) return;
    $3321243da0932e1e$exports[key] = $954c2c1554a60438$exports[key];
});

Object.keys($1efe7f9a2f6260b6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $1efe7f9a2f6260b6$exports[key]) return;
    $3321243da0932e1e$exports[key] = $1efe7f9a2f6260b6$exports[key];
});
var $d5621c2e270133bc$exports = {};

$parcel$export($d5621c2e270133bc$exports, "__esModule", function () { return $d5621c2e270133bc$export$1e511d4a378977f5; }, function (v) { return $d5621c2e270133bc$export$1e511d4a378977f5 = v; });
$parcel$export($d5621c2e270133bc$exports, "RoutedAnchor", function () { return $d5621c2e270133bc$export$4ea793b5dd5d95e9; }, function (v) { return $d5621c2e270133bc$export$4ea793b5dd5d95e9 = v; });
var $d5621c2e270133bc$export$1e511d4a378977f5;
var $d5621c2e270133bc$export$4ea793b5dd5d95e9;
"use strict";
$d5621c2e270133bc$export$1e511d4a378977f5 = true;
$d5621c2e270133bc$export$4ea793b5dd5d95e9 = void 0;
var $7a8448a192746d86$export$1e511d4a378977f5;
var $7a8448a192746d86$export$4ea793b5dd5d95e9;
"use strict";
$7a8448a192746d86$export$1e511d4a378977f5 = true;
$7a8448a192746d86$export$4ea793b5dd5d95e9 = void 0;

var $7a8448a192746d86$var$_react = $7a8448a192746d86$var$_interopRequireWildcard((parcelRequire("2xPiy")));
var $c1a409a88fbfbc24$export$1e511d4a378977f5;
var $c1a409a88fbfbc24$export$1bb667c10ab2e876;
"use strict";
$c1a409a88fbfbc24$export$1e511d4a378977f5 = true;
$c1a409a88fbfbc24$export$1bb667c10ab2e876 = void 0;

var $c1a409a88fbfbc24$var$_react = $c1a409a88fbfbc24$var$_interopRequireDefault((parcelRequire("2xPiy")));
function $c1a409a88fbfbc24$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $c1a409a88fbfbc24$var$RouterContext = $c1a409a88fbfbc24$export$1bb667c10ab2e876 = /*#__PURE__*/ $c1a409a88fbfbc24$var$_react["default"].createContext();



var $7a8448a192746d86$var$_excluded = [
    "path",
    "method"
];
function $7a8448a192746d86$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($7a8448a192746d86$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $7a8448a192746d86$var$_extends() {
    return $7a8448a192746d86$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7a8448a192746d86$var$_extends.apply(null, arguments);
}
function $7a8448a192746d86$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $7a8448a192746d86$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $7a8448a192746d86$var$_setPrototypeOf(t, o);
}
function $7a8448a192746d86$var$_setPrototypeOf(t, e) {
    return $7a8448a192746d86$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $7a8448a192746d86$var$_setPrototypeOf(t, e);
}
var $7a8448a192746d86$var$RoutedAnchor = $7a8448a192746d86$export$4ea793b5dd5d95e9 = /*#__PURE__*/ function(_Component) {
    function RoutedAnchor() {
        return _Component.apply(this, arguments) || this;
    }
    $7a8448a192746d86$var$_inheritsLoose(RoutedAnchor, _Component);
    var _proto = RoutedAnchor.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this$props = this.props, path = _this$props.path, method = _this$props.method, rest = $7a8448a192746d86$var$_objectWithoutPropertiesLoose(_this$props, $7a8448a192746d86$var$_excluded);
        console.warn("This component will be deprecated in the upcoming releases. \n        Please refer to https://github.com/grommet/grommet/issues/2855 \n        for more information.");
        return /*#__PURE__*/ $7a8448a192746d86$var$_react["default"].createElement($e78646567f384248$export$b688253958b8dfe7, $7a8448a192746d86$var$_extends({}, rest, {
            href: path,
            onClick: function onClick(event) {
                var onClick = _this.props.onClick;
                var router = _this.context;
                if (event) {
                    var modifierKey = event.ctrlKey || event.metaKey;
                    // if the user right-clicked in the Anchor we should let it go
                    if (modifierKey) return;
                }
                if (router) {
                    event.preventDefault();
                    (router.history || router)[method](path);
                }
                if (onClick) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                    onClick.apply(void 0, [
                        event
                    ].concat(args));
                }
            }
        }));
    };
    return RoutedAnchor;
}($7a8448a192746d86$var$_react.Component);
$7a8448a192746d86$var$RoutedAnchor.contextType = $c1a409a88fbfbc24$export$1bb667c10ab2e876;
$7a8448a192746d86$var$RoutedAnchor.defaultProps = {
    method: 'push'
};


$d5621c2e270133bc$export$4ea793b5dd5d95e9 = $7a8448a192746d86$export$4ea793b5dd5d95e9;


Object.keys($d5621c2e270133bc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $d5621c2e270133bc$exports[key]) return;
    $3321243da0932e1e$exports[key] = $d5621c2e270133bc$exports[key];
});
var $ed3606e1e9a8594d$exports = {};

$parcel$export($ed3606e1e9a8594d$exports, "__esModule", function () { return $ed3606e1e9a8594d$export$1e511d4a378977f5; }, function (v) { return $ed3606e1e9a8594d$export$1e511d4a378977f5 = v; });
$parcel$export($ed3606e1e9a8594d$exports, "RoutedButton", function () { return $ed3606e1e9a8594d$export$e7e70fe05f963513; }, function (v) { return $ed3606e1e9a8594d$export$e7e70fe05f963513 = v; });
var $ed3606e1e9a8594d$export$1e511d4a378977f5;
var $ed3606e1e9a8594d$export$e7e70fe05f963513;
"use strict";
$ed3606e1e9a8594d$export$1e511d4a378977f5 = true;
$ed3606e1e9a8594d$export$e7e70fe05f963513 = void 0;
var $88bf5a790d0da59e$export$1e511d4a378977f5;
var $88bf5a790d0da59e$export$e7e70fe05f963513;
"use strict";
$88bf5a790d0da59e$export$1e511d4a378977f5 = true;
$88bf5a790d0da59e$export$e7e70fe05f963513 = void 0;

var $88bf5a790d0da59e$var$_react = $88bf5a790d0da59e$var$_interopRequireWildcard((parcelRequire("2xPiy")));
var $446356a7669b7e08$export$1e511d4a378977f5;
var $446356a7669b7e08$export$1bb667c10ab2e876;
"use strict";
$446356a7669b7e08$export$1e511d4a378977f5 = true;
$446356a7669b7e08$export$1bb667c10ab2e876 = void 0;

var $446356a7669b7e08$var$_react = $446356a7669b7e08$var$_interopRequireDefault((parcelRequire("2xPiy")));
function $446356a7669b7e08$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $446356a7669b7e08$var$RouterContext = $446356a7669b7e08$export$1bb667c10ab2e876 = /*#__PURE__*/ $446356a7669b7e08$var$_react["default"].createContext();



var $88bf5a790d0da59e$var$_excluded = [
    "href",
    "path",
    "method",
    "onClick"
];
function $88bf5a790d0da59e$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($88bf5a790d0da59e$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $88bf5a790d0da59e$var$_extends() {
    return $88bf5a790d0da59e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $88bf5a790d0da59e$var$_extends.apply(null, arguments);
}
function $88bf5a790d0da59e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $88bf5a790d0da59e$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $88bf5a790d0da59e$var$_setPrototypeOf(t, o);
}
function $88bf5a790d0da59e$var$_setPrototypeOf(t, e) {
    return $88bf5a790d0da59e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $88bf5a790d0da59e$var$_setPrototypeOf(t, e);
}
var $88bf5a790d0da59e$var$RoutedButton = $88bf5a790d0da59e$export$e7e70fe05f963513 = /*#__PURE__*/ function(_Component) {
    function RoutedButton() {
        var _this;
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _Component.call.apply(_Component, [
            this
        ].concat(_args)) || this;
        _this.onClick = function(event) {
            var _this$props = _this.props, method = _this$props.method, onClick = _this$props.onClick, path = _this$props.path;
            var router = _this.context;
            if (event) {
                var modifierKey = event.ctrlKey || event.metaKey;
                // if the user right-clicked in the button we should let it go
                if (modifierKey) return;
            }
            if (router) {
                event.preventDefault();
                (router.history || router)[method](path);
            }
            if (onClick) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                onClick.apply(void 0, [
                    event
                ].concat(args));
            }
        };
        return _this;
    }
    $88bf5a790d0da59e$var$_inheritsLoose(RoutedButton, _Component);
    var _proto = RoutedButton.prototype;
    _proto.render = function render() {
        var _this$props2 = this.props, href = _this$props2.href, path = _this$props2.path, method = _this$props2.method, onClick = _this$props2.onClick, rest = $88bf5a790d0da59e$var$_objectWithoutPropertiesLoose(_this$props2, $88bf5a790d0da59e$var$_excluded);
        console.warn("This component will be deprecated in the upcoming releases.\n         Please refer to https://github.com/grommet/grommet/issues/2855\n         for more information.");
        return /*#__PURE__*/ $88bf5a790d0da59e$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, $88bf5a790d0da59e$var$_extends({}, rest, {
            href: path || href,
            disabled: !path && !onClick,
            onClick: this.onClick
        }));
    };
    return RoutedButton;
}($88bf5a790d0da59e$var$_react.Component);
$88bf5a790d0da59e$var$RoutedButton.contextType = $446356a7669b7e08$export$1bb667c10ab2e876;
$88bf5a790d0da59e$var$RoutedButton.defaultProps = {
    method: 'push'
};


$ed3606e1e9a8594d$export$e7e70fe05f963513 = $88bf5a790d0da59e$export$e7e70fe05f963513;


Object.keys($ed3606e1e9a8594d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $ed3606e1e9a8594d$exports[key]) return;
    $3321243da0932e1e$exports[key] = $ed3606e1e9a8594d$exports[key];
});

Object.keys($c692f0029c94fbb2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $c692f0029c94fbb2$exports[key]) return;
    $3321243da0932e1e$exports[key] = $c692f0029c94fbb2$exports[key];
});

Object.keys($2b7901c119e4bd86$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $2b7901c119e4bd86$exports[key]) return;
    $3321243da0932e1e$exports[key] = $2b7901c119e4bd86$exports[key];
});
var $c7451133454f66c9$exports = {};

$parcel$export($c7451133454f66c9$exports, "__esModule", function () { return $c7451133454f66c9$export$1e511d4a378977f5; }, function (v) { return $c7451133454f66c9$export$1e511d4a378977f5 = v; });
$parcel$export($c7451133454f66c9$exports, "Sidebar", function () { return $c7451133454f66c9$export$1ba59dacbcbf90fe; }, function (v) { return $c7451133454f66c9$export$1ba59dacbcbf90fe = v; });
var $c7451133454f66c9$export$1e511d4a378977f5;
var $c7451133454f66c9$export$1ba59dacbcbf90fe;
"use strict";
$c7451133454f66c9$export$1e511d4a378977f5 = true;
$c7451133454f66c9$export$1ba59dacbcbf90fe = void 0;
var $ba95f4a59bb2bf17$export$1e511d4a378977f5;
var $ba95f4a59bb2bf17$export$1ba59dacbcbf90fe;
"use strict";
$ba95f4a59bb2bf17$export$1e511d4a378977f5 = true;
$ba95f4a59bb2bf17$export$1ba59dacbcbf90fe = void 0;

var $ba95f4a59bb2bf17$var$_react = $ba95f4a59bb2bf17$var$_interopRequireDefault((parcelRequire("2xPiy")));

var $1e80e86027f75c3a$export$1e511d4a378977f5;
var $1e80e86027f75c3a$export$c4fece8c7e416b10;
"use strict";
$1e80e86027f75c3a$export$1e511d4a378977f5 = true;
$1e80e86027f75c3a$export$c4fece8c7e416b10 = void 0;

var $1e80e86027f75c3a$var$_propTypes = $1e80e86027f75c3a$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $1e80e86027f75c3a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $1e80e86027f75c3a$var$PropType = {};
$1e80e86027f75c3a$var$PropType = {
    children: $1e80e86027f75c3a$var$_propTypes["default"].node,
    footer: $1e80e86027f75c3a$var$_propTypes["default"].node,
    header: $1e80e86027f75c3a$var$_propTypes["default"].node
};
var $1e80e86027f75c3a$var$SidebarPropTypes = $1e80e86027f75c3a$export$c4fece8c7e416b10 = $1e80e86027f75c3a$var$PropType;



var $ba95f4a59bb2bf17$var$_excluded = [
    "children",
    "footer",
    "header"
];
function $ba95f4a59bb2bf17$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $ba95f4a59bb2bf17$var$_extends() {
    return $ba95f4a59bb2bf17$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ba95f4a59bb2bf17$var$_extends.apply(null, arguments);
}
function $ba95f4a59bb2bf17$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $ba95f4a59bb2bf17$var$Sidebar = $ba95f4a59bb2bf17$export$1ba59dacbcbf90fe = function Sidebar(_ref) {
    var children = _ref.children, footer = _ref.footer, header = _ref.header, rest = $ba95f4a59bb2bf17$var$_objectWithoutPropertiesLoose(_ref, $ba95f4a59bb2bf17$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ $ba95f4a59bb2bf17$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $ba95f4a59bb2bf17$var$_extends({
        height: {
            min: '100%'
        },
        gap: theme.sidebar.gap,
        pad: theme.sidebar.pad
    }, rest), header, /*#__PURE__*/ $ba95f4a59bb2bf17$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        flex: true
    }, children), footer);
};
$ba95f4a59bb2bf17$var$Sidebar.propTypes = $1e80e86027f75c3a$export$c4fece8c7e416b10;


$c7451133454f66c9$export$1ba59dacbcbf90fe = $ba95f4a59bb2bf17$export$1ba59dacbcbf90fe;


Object.keys($c7451133454f66c9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $c7451133454f66c9$exports[key]) return;
    $3321243da0932e1e$exports[key] = $c7451133454f66c9$exports[key];
});

Object.keys($ab65104eb6f9aa8a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $ab65104eb6f9aa8a$exports[key]) return;
    $3321243da0932e1e$exports[key] = $ab65104eb6f9aa8a$exports[key];
});
var $1e705fbc657525b1$exports = {};

$parcel$export($1e705fbc657525b1$exports, "__esModule", function () { return $1e705fbc657525b1$export$1e511d4a378977f5; }, function (v) { return $1e705fbc657525b1$export$1e511d4a378977f5 = v; });
$parcel$export($1e705fbc657525b1$exports, "SkipLink", function () { return $1e705fbc657525b1$export$ef95c37428582a65; }, function (v) { return $1e705fbc657525b1$export$ef95c37428582a65 = v; });
var $1e705fbc657525b1$export$1e511d4a378977f5;
var $1e705fbc657525b1$export$ef95c37428582a65;
"use strict";
$1e705fbc657525b1$export$1e511d4a378977f5 = true;
$1e705fbc657525b1$export$ef95c37428582a65 = void 0;
var $534d2a02baaef8aa$export$1e511d4a378977f5;
var $534d2a02baaef8aa$export$ef95c37428582a65;
"use strict";
$534d2a02baaef8aa$export$1e511d4a378977f5 = true;
$534d2a02baaef8aa$export$ef95c37428582a65 = void 0;

var $534d2a02baaef8aa$var$_react = $534d2a02baaef8aa$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $534d2a02baaef8aa$var$_excluded = [
    "id",
    "label"
];
function $534d2a02baaef8aa$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($534d2a02baaef8aa$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $534d2a02baaef8aa$var$_extends() {
    return $534d2a02baaef8aa$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $534d2a02baaef8aa$var$_extends.apply(null, arguments);
}
function $534d2a02baaef8aa$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $534d2a02baaef8aa$var$SkipLink = $534d2a02baaef8aa$export$ef95c37428582a65 = /*#__PURE__*/ (0, $534d2a02baaef8aa$var$_react.forwardRef)(function(_ref, ref) {
    var id = _ref.id, label = _ref.label, rest = $534d2a02baaef8aa$var$_objectWithoutPropertiesLoose(_ref, $534d2a02baaef8aa$var$_excluded);
    return /*#__PURE__*/ $534d2a02baaef8aa$var$_react["default"].createElement($e78646567f384248$export$b688253958b8dfe7, $534d2a02baaef8aa$var$_extends({
        href: "#" + id,
        ref: ref,
        label: label
    }, rest));
});


$1e705fbc657525b1$export$ef95c37428582a65 = $534d2a02baaef8aa$export$ef95c37428582a65;


Object.keys($1e705fbc657525b1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $1e705fbc657525b1$exports[key]) return;
    $3321243da0932e1e$exports[key] = $1e705fbc657525b1$exports[key];
});
var $6bfd32eb20402992$exports = {};

$parcel$export($6bfd32eb20402992$exports, "__esModule", function () { return $6bfd32eb20402992$export$1e511d4a378977f5; }, function (v) { return $6bfd32eb20402992$export$1e511d4a378977f5 = v; });
$parcel$export($6bfd32eb20402992$exports, "SkipLinks", function () { return $6bfd32eb20402992$export$92cc2ba017c8f912; }, function (v) { return $6bfd32eb20402992$export$92cc2ba017c8f912 = v; });
var $6bfd32eb20402992$export$1e511d4a378977f5;
var $6bfd32eb20402992$export$92cc2ba017c8f912;
"use strict";
$6bfd32eb20402992$export$1e511d4a378977f5 = true;
$6bfd32eb20402992$export$92cc2ba017c8f912 = void 0;
var $8a2bfe41e7bc855c$export$1e511d4a378977f5;
var $8a2bfe41e7bc855c$export$92cc2ba017c8f912;
"use strict";
$8a2bfe41e7bc855c$export$1e511d4a378977f5 = true;
$8a2bfe41e7bc855c$export$92cc2ba017c8f912 = void 0;

var $8a2bfe41e7bc855c$var$_react = $8a2bfe41e7bc855c$var$_interopRequireWildcard((parcelRequire("2xPiy")));




var $b8cb8ad189e0942b$export$1e511d4a378977f5;
var $b8cb8ad189e0942b$export$f51ab139cf297efe;
"use strict";
$b8cb8ad189e0942b$export$1e511d4a378977f5 = true;
$b8cb8ad189e0942b$export$f51ab139cf297efe = void 0;

var $b8cb8ad189e0942b$var$_propTypes = $b8cb8ad189e0942b$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $b8cb8ad189e0942b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $b8cb8ad189e0942b$var$PropType = {};
$b8cb8ad189e0942b$var$PropType = {
    id: $b8cb8ad189e0942b$var$_propTypes["default"].string,
    children: $b8cb8ad189e0942b$var$_propTypes["default"].node.isRequired,
    messages: $b8cb8ad189e0942b$var$_propTypes["default"].shape({
        skipTo: $b8cb8ad189e0942b$var$_propTypes["default"].string
    })
};
var $b8cb8ad189e0942b$var$SkipLinksPropTypes = $b8cb8ad189e0942b$export$f51ab139cf297efe = $b8cb8ad189e0942b$var$PropType;



function $8a2bfe41e7bc855c$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($8a2bfe41e7bc855c$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $8a2bfe41e7bc855c$var$SkipLinks = $8a2bfe41e7bc855c$export$92cc2ba017c8f912 = function SkipLinks(_ref) {
    var children = _ref.children, id = _ref.id, messages = _ref.messages;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useState = (0, $8a2bfe41e7bc855c$var$_react.useState)(false), showLayer = _useState[0], setShowLayer = _useState[1];
    var _useContext = (0, $8a2bfe41e7bc855c$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var layerRef = (0, $8a2bfe41e7bc855c$var$_react.useRef)(null);
    var onFocus = function onFocus() {
        setShowLayer(true);
    };
    var removeLayer = function removeLayer() {
        setShowLayer(false);
    };
    var onBlur = function onBlur() {
        // timeout needed so it gives enough time for activeElement to be updated
        setTimeout(function() {
            var layerNode = layerRef.current;
            if (layerNode && !layerNode.contains(document.activeElement)) // close the layer when the activeElement isn't contained in the layer
            removeLayer();
        }, 0);
    };
    return /*#__PURE__*/ $8a2bfe41e7bc855c$var$_react["default"].createElement($e03e15968966d631$export$936d0764594b6eb3, {
        id: id,
        position: showLayer ? theme.skipLinks.position : 'hidden',
        ref: layerRef,
        onFocus: onFocus,
        onBlur: onBlur,
        modal: false,
        targetChildPosition: "first",
        responsive: false
    }, /*#__PURE__*/ $8a2bfe41e7bc855c$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, theme.skipLinks.container, /*#__PURE__*/ $8a2bfe41e7bc855c$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, theme.skipLinks.label, format({
        id: 'skipLinks.skipTo',
        messages: messages
    })), /*#__PURE__*/ $8a2bfe41e7bc855c$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        align: "center",
        gap: "medium"
    }, $8a2bfe41e7bc855c$var$_react.Children.map(children, function(child, index) {
        return child && /*#__PURE__*/ (0, $8a2bfe41e7bc855c$var$_react.cloneElement)(child, {
            // eslint-disable-next-line react/no-array-index-key
            key: "skip-link-" + index,
            onClick: removeLayer
        });
    }))));
};
$8a2bfe41e7bc855c$var$SkipLinks.propTypes = $b8cb8ad189e0942b$export$f51ab139cf297efe;


$6bfd32eb20402992$export$92cc2ba017c8f912 = $8a2bfe41e7bc855c$export$92cc2ba017c8f912;


Object.keys($6bfd32eb20402992$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $6bfd32eb20402992$exports[key]) return;
    $3321243da0932e1e$exports[key] = $6bfd32eb20402992$exports[key];
});
var $663af17a0e90acb9$exports = {};

$parcel$export($663af17a0e90acb9$exports, "__esModule", function () { return $663af17a0e90acb9$export$1e511d4a378977f5; }, function (v) { return $663af17a0e90acb9$export$1e511d4a378977f5 = v; });
$parcel$export($663af17a0e90acb9$exports, "SkipLinkTarget", function () { return $663af17a0e90acb9$export$9c093c419bf6f759; }, function (v) { return $663af17a0e90acb9$export$9c093c419bf6f759 = v; });
var $663af17a0e90acb9$export$1e511d4a378977f5;
var $663af17a0e90acb9$export$9c093c419bf6f759;
"use strict";
$663af17a0e90acb9$export$1e511d4a378977f5 = true;
$663af17a0e90acb9$export$9c093c419bf6f759 = void 0;
var $6b1627fb4467e218$export$1e511d4a378977f5;
var $6b1627fb4467e218$export$9c093c419bf6f759;
"use strict";
$6b1627fb4467e218$export$1e511d4a378977f5 = true;
$6b1627fb4467e218$export$9c093c419bf6f759 = void 0;

var $6b1627fb4467e218$var$_react = $6b1627fb4467e218$var$_interopRequireDefault((parcelRequire("2xPiy")));

var $6b1627fb4467e218$var$_styledComponents = $6b1627fb4467e218$var$_interopRequireDefault((parcelRequire("iA1nz")));

var $6b1627fb4467e218$var$_excluded = [
    "label"
];
function $6b1627fb4467e218$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $6b1627fb4467e218$var$_extends() {
    return $6b1627fb4467e218$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6b1627fb4467e218$var$_extends.apply(null, arguments);
}
function $6b1627fb4467e218$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $6b1627fb4467e218$var$HiddenAnchor = (0, $6b1627fb4467e218$var$_styledComponents["default"])($e78646567f384248$export$b688253958b8dfe7).withConfig({
    displayName: "SkipLinkTarget__HiddenAnchor",
    componentId: "sc-16wjfgk-0"
})([
    "width:0;height:0;overflow:hidden;position:absolute;"
]);
var $6b1627fb4467e218$var$SkipLinkTarget = $6b1627fb4467e218$export$9c093c419bf6f759 = function SkipLinkTarget(_ref) {
    var label = _ref.label, rest = $6b1627fb4467e218$var$_objectWithoutPropertiesLoose(_ref, $6b1627fb4467e218$var$_excluded);
    return /*#__PURE__*/ $6b1627fb4467e218$var$_react["default"].createElement($6b1627fb4467e218$var$HiddenAnchor, $6b1627fb4467e218$var$_extends({}, rest, {
        tabIndex: "-1",
        "aria-hidden": "true"
    }), label);
};


$663af17a0e90acb9$export$9c093c419bf6f759 = $6b1627fb4467e218$export$9c093c419bf6f759;


Object.keys($663af17a0e90acb9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $663af17a0e90acb9$exports[key]) return;
    $3321243da0932e1e$exports[key] = $663af17a0e90acb9$exports[key];
});
var $1b7bf9d4062b4aa7$exports = {};

$parcel$export($1b7bf9d4062b4aa7$exports, "__esModule", function () { return $1b7bf9d4062b4aa7$export$1e511d4a378977f5; }, function (v) { return $1b7bf9d4062b4aa7$export$1e511d4a378977f5 = v; });
$parcel$export($1b7bf9d4062b4aa7$exports, "Spinner", function () { return $1b7bf9d4062b4aa7$export$7f7cbe89f1eacd2; }, function (v) { return $1b7bf9d4062b4aa7$export$7f7cbe89f1eacd2 = v; });
var $1b7bf9d4062b4aa7$export$1e511d4a378977f5;
var $1b7bf9d4062b4aa7$export$7f7cbe89f1eacd2;
"use strict";
$1b7bf9d4062b4aa7$export$1e511d4a378977f5 = true;
$1b7bf9d4062b4aa7$export$7f7cbe89f1eacd2 = void 0;
var $573efcd2be8c27d5$export$1e511d4a378977f5;
var $573efcd2be8c27d5$export$7f7cbe89f1eacd2;
"use strict";
$573efcd2be8c27d5$export$1e511d4a378977f5 = true;
$573efcd2be8c27d5$export$7f7cbe89f1eacd2 = void 0;

var $573efcd2be8c27d5$var$_react = $573efcd2be8c27d5$var$_interopRequireWildcard((parcelRequire("2xPiy")));


var $e7e0b501a1342718$export$1e511d4a378977f5;
var $e7e0b501a1342718$export$a41ccd36cbb5b95e;
"use strict";
$e7e0b501a1342718$export$1e511d4a378977f5 = true;
$e7e0b501a1342718$export$a41ccd36cbb5b95e = void 0;

var $e7e0b501a1342718$var$_propTypes = $e7e0b501a1342718$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $e7e0b501a1342718$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $e7e0b501a1342718$var$PropType = {};
$e7e0b501a1342718$var$PropType = {
    size: $e7e0b501a1342718$var$_propTypes["default"].oneOfType([
        $e7e0b501a1342718$var$_propTypes["default"].oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        $e7e0b501a1342718$var$_propTypes["default"].string
    ]),
    color: $e7e0b501a1342718$var$_propTypes["default"].oneOfType([
        $e7e0b501a1342718$var$_propTypes["default"].string,
        $e7e0b501a1342718$var$_propTypes["default"].shape({
            dark: $e7e0b501a1342718$var$_propTypes["default"].string,
            light: $e7e0b501a1342718$var$_propTypes["default"].string
        })
    ]),
    message: $e7e0b501a1342718$var$_propTypes["default"].oneOfType([
        $e7e0b501a1342718$var$_propTypes["default"].string,
        $e7e0b501a1342718$var$_propTypes["default"].shape({
            start: $e7e0b501a1342718$var$_propTypes["default"].string,
            end: $e7e0b501a1342718$var$_propTypes["default"].string
        })
    ])
};
var $e7e0b501a1342718$var$SpinnerPropTypes = $e7e0b501a1342718$export$a41ccd36cbb5b95e = $e7e0b501a1342718$var$PropType;



var $573efcd2be8c27d5$var$_excluded = [
    "ref",
    "size"
], $573efcd2be8c27d5$var$_excluded2 = [
    "children",
    "color",
    "size",
    "message"
], $573efcd2be8c27d5$var$_excluded3 = [
    "size",
    "color",
    "border"
];
function $573efcd2be8c27d5$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($573efcd2be8c27d5$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $573efcd2be8c27d5$var$_extends() {
    return $573efcd2be8c27d5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $573efcd2be8c27d5$var$_extends.apply(null, arguments);
}
function $573efcd2be8c27d5$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $573efcd2be8c27d5$var$BasicSpinner = function BasicSpinner(_ref) {
    var ref = _ref.ref, size = _ref.size, rest = $573efcd2be8c27d5$var$_objectWithoutPropertiesLoose(_ref, $573efcd2be8c27d5$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ $573efcd2be8c27d5$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $573efcd2be8c27d5$var$_extends({
        flex: false,
        height: size,
        width: size,
        ref: ref,
        responsive: theme.spinner.responsive
    }, rest));
};
/**
 * If the user is calling <Spinner>…</Spinner> with children, it will take
 * precedence over theme styling. Yet, it will still inherit the
 * default animation and size of the spinner, and of course any additional
 * given props.
 *
 * If the user is providing an icon/svg via the theme.spinner.icon,
 * the Spinner will use it as a child and will include all its relevant
 * theme props (size/color/pad…) as well,
 * user will only need to type <Spinner />.
 * If the icon has its own animation, user can turn it off via the theme.
 *
 * If none of the above is provider, <Spinner /> will provide its default
 * border, size and friends, all configurable via theme or props.
 */ var $573efcd2be8c27d5$var$Spinner = $573efcd2be8c27d5$export$7f7cbe89f1eacd2 = /*#__PURE__*/ (0, $573efcd2be8c27d5$var$_react.forwardRef)(function(_ref2, ref) {
    var children = _ref2.children, colorProp = _ref2.color, size = _ref2.size, message = _ref2.message, rest = $573efcd2be8c27d5$var$_objectWithoutPropertiesLoose(_ref2, $573efcd2be8c27d5$var$_excluded2);
    var _useThemeValue2 = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue2.theme;
    var announce = (0, $573efcd2be8c27d5$var$_react.useContext)($cfbcb74d4f54e56b$export$dcc8f4bff0d51f50);
    (0, $573efcd2be8c27d5$var$_react.useEffect)(function() {
        if (message != null && message.start) announce(message.start);
        else if (typeof message === 'string') announce(message);
        return function() {
            return (message == null ? void 0 : message.end) && announce(message.end);
        };
    }, [
        announce,
        message
    ]);
    // Avoid color and size leaking into the DOM
    var _theme$spinner$contai = theme.spinner.container, sizeThemeProp = _theme$spinner$contai.size, colorThemeProp = _theme$spinner$contai.color, borderThemeProp = _theme$spinner$contai.border, themeProps = $573efcd2be8c27d5$var$_objectWithoutPropertiesLoose(_theme$spinner$contai, $573efcd2be8c27d5$var$_excluded3);
    var normalizedSize = size || sizeThemeProp;
    var spinnerSize = theme.spinner.size[normalizedSize] || normalizedSize;
    var color = colorProp || colorThemeProp;
    var Icon = theme.spinner.icon;
    var defaultBorder = [
        {
            side: 'all',
            color: 'background-contrast',
            size: size
        },
        {
            side: 'top',
            color: color,
            size: size
        }
    ];
    var spinnerBorder = Array.isArray(borderThemeProp) ? borderThemeProp.map(function(borderSide) {
        return $573efcd2be8c27d5$var$_extends({}, borderSide, {
            color: borderSide.side === 'all' ? borderSide.color || 'background-contrast' : color
        });
    }) : borderThemeProp;
    // children will take precedence over theme attributes
    if (children) return /*#__PURE__*/ $573efcd2be8c27d5$var$_react["default"].createElement($573efcd2be8c27d5$var$BasicSpinner, $573efcd2be8c27d5$var$_extends({
        size: spinnerSize,
        ref: ref
    }, rest), children);
    // In case icon is provided by the theme
    if (Icon) return /*#__PURE__*/ $573efcd2be8c27d5$var$_react["default"].createElement($573efcd2be8c27d5$var$BasicSpinner, $573efcd2be8c27d5$var$_extends({
        size: spinnerSize,
        ref: ref
    }, themeProps, rest), /*#__PURE__*/ (0, $573efcd2be8c27d5$var$_react.isValidElement)(Icon) ? Icon : /*#__PURE__*/ $573efcd2be8c27d5$var$_react["default"].createElement(Icon, {
        size: spinnerSize,
        color: color
    }));
    return /*#__PURE__*/ $573efcd2be8c27d5$var$_react["default"].createElement($573efcd2be8c27d5$var$BasicSpinner, $573efcd2be8c27d5$var$_extends({
        size: spinnerSize,
        ref: ref,
        border: typeof borderThemeProp === 'undefined' ? defaultBorder : spinnerBorder
    }, themeProps, rest));
});
$573efcd2be8c27d5$var$Spinner.displayName = 'Spinner';
$573efcd2be8c27d5$var$Spinner.propTypes = $e7e0b501a1342718$export$a41ccd36cbb5b95e;


$1b7bf9d4062b4aa7$export$7f7cbe89f1eacd2 = $573efcd2be8c27d5$export$7f7cbe89f1eacd2;


Object.keys($1b7bf9d4062b4aa7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $1b7bf9d4062b4aa7$exports[key]) return;
    $3321243da0932e1e$exports[key] = $1b7bf9d4062b4aa7$exports[key];
});

Object.keys($8c60273918bcf71f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $8c60273918bcf71f$exports[key]) return;
    $3321243da0932e1e$exports[key] = $8c60273918bcf71f$exports[key];
});
var $28345f558df5ec3d$exports = {};

$parcel$export($28345f558df5ec3d$exports, "__esModule", function () { return $28345f558df5ec3d$export$1e511d4a378977f5; }, function (v) { return $28345f558df5ec3d$export$1e511d4a378977f5 = v; });
$parcel$export($28345f558df5ec3d$exports, "StarRating", function () { return $28345f558df5ec3d$export$5e19b9354e495cb9; }, function (v) { return $28345f558df5ec3d$export$5e19b9354e495cb9 = v; });
var $28345f558df5ec3d$export$1e511d4a378977f5;
var $28345f558df5ec3d$export$5e19b9354e495cb9;
"use strict";
$28345f558df5ec3d$export$1e511d4a378977f5 = true;
$28345f558df5ec3d$export$5e19b9354e495cb9 = void 0;
var $9a71ff4910abd209$export$1e511d4a378977f5;
var $9a71ff4910abd209$export$5e19b9354e495cb9;
"use strict";
$9a71ff4910abd209$export$1e511d4a378977f5 = true;
$9a71ff4910abd209$export$5e19b9354e495cb9 = void 0;

var $9a71ff4910abd209$var$_react = $9a71ff4910abd209$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $9a71ff4910abd209$var$_styledComponents = $9a71ff4910abd209$var$_interopRequireDefault((parcelRequire("iA1nz")));
var $bce2f380b26d5e03$exports = {};

$parcel$export($bce2f380b26d5e03$exports, "__esModule", function () { return $bce2f380b26d5e03$export$1e511d4a378977f5; }, function (v) { return $bce2f380b26d5e03$export$1e511d4a378977f5 = v; });
$parcel$export($bce2f380b26d5e03$exports, "Star", function () { return $bce2f380b26d5e03$export$1644ba17714857f1; }, function (v) { return $bce2f380b26d5e03$export$1644ba17714857f1 = v; });
var $bce2f380b26d5e03$export$1e511d4a378977f5;
var $bce2f380b26d5e03$export$1644ba17714857f1;
"use strict";
$bce2f380b26d5e03$export$1e511d4a378977f5 = true;
$bce2f380b26d5e03$export$1644ba17714857f1 = void 0;

var $bce2f380b26d5e03$var$_react = $bce2f380b26d5e03$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $bce2f380b26d5e03$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($bce2f380b26d5e03$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $bce2f380b26d5e03$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $bce2f380b26d5e03$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $bce2f380b26d5e03$var$_extends() {
    return $bce2f380b26d5e03$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bce2f380b26d5e03$var$_extends.apply(null, arguments);
}
var $bce2f380b26d5e03$var$Star = $bce2f380b26d5e03$export$1644ba17714857f1 = /*#__PURE__*/ (0, $bce2f380b26d5e03$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $bce2f380b26d5e03$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $bce2f380b26d5e03$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Star"
    }, props), /*#__PURE__*/ $bce2f380b26d5e03$var$_react["default"].createElement("path", {
        fill: "#FFC95E",
        fillRule: "evenodd",
        d: "M12 16.667 5 22l3-8-6-4.5h7.5L12 2l2.5 7.5H22L16 14l3 8z"
    }));
});
$bce2f380b26d5e03$var$Star.displayName = 'Star';


var $11e191990a1ec146$exports = {};

$parcel$export($11e191990a1ec146$exports, "__esModule", function () { return $11e191990a1ec146$export$1e511d4a378977f5; }, function (v) { return $11e191990a1ec146$export$1e511d4a378977f5 = v; });
$parcel$export($11e191990a1ec146$exports, "StarOutline", function () { return $11e191990a1ec146$export$ac31625c0615bb80; }, function (v) { return $11e191990a1ec146$export$ac31625c0615bb80 = v; });
var $11e191990a1ec146$export$1e511d4a378977f5;
var $11e191990a1ec146$export$ac31625c0615bb80;
"use strict";
$11e191990a1ec146$export$1e511d4a378977f5 = true;
$11e191990a1ec146$export$ac31625c0615bb80 = void 0;

var $11e191990a1ec146$var$_react = $11e191990a1ec146$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $11e191990a1ec146$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($11e191990a1ec146$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $11e191990a1ec146$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $11e191990a1ec146$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $11e191990a1ec146$var$_extends() {
    return $11e191990a1ec146$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $11e191990a1ec146$var$_extends.apply(null, arguments);
}
var $11e191990a1ec146$var$StarOutline = $11e191990a1ec146$export$ac31625c0615bb80 = /*#__PURE__*/ (0, $11e191990a1ec146$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $11e191990a1ec146$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $11e191990a1ec146$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Star"
    }, props), /*#__PURE__*/ $11e191990a1ec146$var$_react["default"].createElement("path", {
        stroke: "#000",
        fill: "none",
        strokeWidth: "2",
        d: "M12.606 16.805 12 16.343l-.606.462L5.755 21.1l2.381-6.35.263-.701-.599-.45L3 10h6.72l.229-.684L12 3.162l2.051 6.154.228.684H21l-4.8 3.6-.6.45.264.701 2.38 6.35-5.638-4.296Z"
    }));
});
$11e191990a1ec146$var$StarOutline.displayName = 'StarOutline';







var $9a71ff4910abd209$var$_excluded = [
    "name",
    "defaultValue",
    "value"
];
function $9a71ff4910abd209$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $9a71ff4910abd209$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($9a71ff4910abd209$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $9a71ff4910abd209$var$_extends() {
    return $9a71ff4910abd209$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9a71ff4910abd209$var$_extends.apply(null, arguments);
}
function $9a71ff4910abd209$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $9a71ff4910abd209$var$StyledStarRatingBox = (0, $9a71ff4910abd209$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "StarRating__StyledStarRatingBox",
    componentId: "sc-34rgjv-0"
})([
    "",
    ";"
], function(props) {
    return props.focus && (0, $4113023f9e0bafa0$exports.focusStyle)();
});
var $9a71ff4910abd209$var$StarRating = $9a71ff4910abd209$export$5e19b9354e495cb9 = function StarRating(_ref) {
    var _theme$starRating, _theme$starRating2;
    var name = _ref.name, defaultValue = _ref.defaultValue, valueProp = _ref.value, rest = $9a71ff4910abd209$var$_objectWithoutPropertiesLoose(_ref, $9a71ff4910abd209$var$_excluded);
    var formContext = (0, $9a71ff4910abd209$var$_react.useContext)($5c9c2e034f522b3e$export$c24727297075ec6a);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var usingKeyboard = (0, $4113023f9e0bafa0$exports.useKeyboard)();
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp,
        initialValue: defaultValue != null ? defaultValue : 0
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    var SelectedIcon = ((_theme$starRating = theme.starRating) == null || (_theme$starRating = _theme$starRating.icons) == null ? void 0 : _theme$starRating.selected) || $bce2f380b26d5e03$export$1644ba17714857f1;
    var UnselectedIcon = ((_theme$starRating2 = theme.starRating) == null || (_theme$starRating2 = _theme$starRating2.icons) == null ? void 0 : _theme$starRating2.unselected) || $11e191990a1ec146$export$ac31625c0615bb80;
    var options = [];
    for(var i = 1; i < 6; i += 1)options.push(i);
    return /*#__PURE__*/ $9a71ff4910abd209$var$_react["default"].createElement($49bedb3ed8912461$export$c062ce1cc79ad58a, $9a71ff4910abd209$var$_extends({
        name: name,
        direction: "row",
        options: options,
        onChange: function onChange(event) {
            setValue(event.value);
        }
    }, rest), function(option, _ref2) {
        var _theme$starRating3, _theme$starRating4;
        var focus = _ref2.focus;
        return /*#__PURE__*/ $9a71ff4910abd209$var$_react["default"].createElement($9a71ff4910abd209$var$StyledStarRatingBox, {
            focus: focus && usingKeyboard
        }, option <= value ? /*#__PURE__*/ $9a71ff4910abd209$var$_react["default"].createElement(SelectedIcon, {
            color: (_theme$starRating3 = theme.starRating) == null ? void 0 : _theme$starRating3.color
        }) : /*#__PURE__*/ $9a71ff4910abd209$var$_react["default"].createElement(UnselectedIcon, {
            color: (_theme$starRating4 = theme.starRating) == null ? void 0 : _theme$starRating4.color
        }));
    });
};
$9a71ff4910abd209$var$StarRating.displayName = 'StarRating';


$28345f558df5ec3d$export$5e19b9354e495cb9 = $9a71ff4910abd209$export$5e19b9354e495cb9;


Object.keys($28345f558df5ec3d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $28345f558df5ec3d$exports[key]) return;
    $3321243da0932e1e$exports[key] = $28345f558df5ec3d$exports[key];
});
var $e22b15673b435f55$exports = {};

$parcel$export($e22b15673b435f55$exports, "__esModule", function () { return $e22b15673b435f55$export$1e511d4a378977f5; }, function (v) { return $e22b15673b435f55$export$1e511d4a378977f5 = v; });
$parcel$export($e22b15673b435f55$exports, "useStepper", function () { return $e22b15673b435f55$export$9378619b14945e16; }, function (v) { return $e22b15673b435f55$export$9378619b14945e16 = v; });
$parcel$export($e22b15673b435f55$exports, "StepperLabel", function () { return $e22b15673b435f55$export$f885210784698446; }, function (v) { return $e22b15673b435f55$export$f885210784698446 = v; });
$parcel$export($e22b15673b435f55$exports, "StepperIndicator", function () { return $e22b15673b435f55$export$d3ab37ba13a08390; }, function (v) { return $e22b15673b435f55$export$d3ab37ba13a08390 = v; });
$parcel$export($e22b15673b435f55$exports, "StepperError", function () { return $e22b15673b435f55$export$482b3904ab0152e7; }, function (v) { return $e22b15673b435f55$export$482b3904ab0152e7 = v; });
$parcel$export($e22b15673b435f55$exports, "StepperDisabledReason", function () { return $e22b15673b435f55$export$6ebc62bc3521fc7; }, function (v) { return $e22b15673b435f55$export$6ebc62bc3521fc7 = v; });
$parcel$export($e22b15673b435f55$exports, "StepperDescription", function () { return $e22b15673b435f55$export$f0e13176f06b1b53; }, function (v) { return $e22b15673b435f55$export$f0e13176f06b1b53 = v; });
$parcel$export($e22b15673b435f55$exports, "StepperContext", function () { return $e22b15673b435f55$export$91b1e15bb76ddaff; }, function (v) { return $e22b15673b435f55$export$91b1e15bb76ddaff = v; });
$parcel$export($e22b15673b435f55$exports, "Stepper", function () { return $e22b15673b435f55$export$ed8ca599049e8881; }, function (v) { return $e22b15673b435f55$export$ed8ca599049e8881 = v; });
var $e22b15673b435f55$export$1e511d4a378977f5;
var $e22b15673b435f55$export$9378619b14945e16;
var $e22b15673b435f55$export$f885210784698446;
var $e22b15673b435f55$export$d3ab37ba13a08390;
var $e22b15673b435f55$export$482b3904ab0152e7;
var $e22b15673b435f55$export$6ebc62bc3521fc7;
var $e22b15673b435f55$export$f0e13176f06b1b53;
var $e22b15673b435f55$export$91b1e15bb76ddaff;
var $e22b15673b435f55$export$ed8ca599049e8881;
"use strict";
$e22b15673b435f55$export$1e511d4a378977f5 = true;
$e22b15673b435f55$export$9378619b14945e16 = $e22b15673b435f55$export$f885210784698446 = $e22b15673b435f55$export$d3ab37ba13a08390 = $e22b15673b435f55$export$482b3904ab0152e7 = $e22b15673b435f55$export$6ebc62bc3521fc7 = $e22b15673b435f55$export$f0e13176f06b1b53 = $e22b15673b435f55$export$91b1e15bb76ddaff = $e22b15673b435f55$export$ed8ca599049e8881 = void 0;
var $78e955b4419149e8$export$1e511d4a378977f5;
var $78e955b4419149e8$export$ed8ca599049e8881;
"use strict";
$78e955b4419149e8$export$1e511d4a378977f5 = true;
$78e955b4419149e8$export$ed8ca599049e8881 = void 0;

var $78e955b4419149e8$var$_react = $78e955b4419149e8$var$_interopRequireWildcard((parcelRequire("2xPiy")));



var $fb5dc6bad0dc9418$export$1e511d4a378977f5;
var $fb5dc6bad0dc9418$export$4a156f5690e82b42;
"use strict";
$fb5dc6bad0dc9418$export$1e511d4a378977f5 = true;
$fb5dc6bad0dc9418$export$4a156f5690e82b42 = void 0;

var $fb5dc6bad0dc9418$var$_react = $fb5dc6bad0dc9418$var$_interopRequireDefault((parcelRequire("2xPiy")));

var $3e046cacb0daec29$export$1e511d4a378977f5;
var $3e046cacb0daec29$export$d38c25e5d733acec;
var $3e046cacb0daec29$export$dc62e2075555ab43;
var $3e046cacb0daec29$export$25390ca7ad93a025;
var $3e046cacb0daec29$export$bd1caedcf570dd41;
var $3e046cacb0daec29$export$e1f766abd15de7fa;
"use strict";
$3e046cacb0daec29$export$1e511d4a378977f5 = true;
$3e046cacb0daec29$export$d38c25e5d733acec = $3e046cacb0daec29$export$dc62e2075555ab43 = $3e046cacb0daec29$export$25390ca7ad93a025 = $3e046cacb0daec29$export$bd1caedcf570dd41 = $3e046cacb0daec29$export$e1f766abd15de7fa = void 0;

var $3e046cacb0daec29$var$_styledComponents = $3e046cacb0daec29$var$_interopRequireWildcard((parcelRequire("iA1nz")));

function $3e046cacb0daec29$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($3e046cacb0daec29$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $3e046cacb0daec29$var$getMetricSize = function getMetricSize(theme, size) {
    var _theme$global, _theme$global2;
    return ((_theme$global = theme.global) == null || (_theme$global = _theme$global.edgeSize) == null ? void 0 : _theme$global[size]) || ((_theme$global2 = theme.global) == null || (_theme$global2 = _theme$global2.size) == null ? void 0 : _theme$global2[size]) || size;
};
var $3e046cacb0daec29$var$getTextMetric = function getTextMetric(theme, size, metric) {
    var _theme$text, _theme$text2;
    return ((_theme$text = theme.text) == null || (_theme$text = _theme$text[size]) == null ? void 0 : _theme$text[metric]) || ((_theme$text2 = theme.text) == null || (_theme$text2 = _theme$text2.medium) == null ? void 0 : _theme$text2[metric]);
};
var $3e046cacb0daec29$var$getSubStepSizeToken = function getSubStepSizeToken(indicatorSize) {
    switch(indicatorSize){
        case 'large':
            return 'small';
        case 'small':
            return 'xsmall';
        default:
            return 'small';
    }
};
var $3e046cacb0daec29$var$getConnectorColor = function getConnectorColor(stepStatus, theme) {
    var _theme$stepper;
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(((_theme$stepper = theme.stepper) == null || (_theme$stepper = _theme$stepper[stepStatus]) == null || (_theme$stepper = _theme$stepper.connector) == null ? void 0 : _theme$stepper.color) || 'border', theme);
};
var $3e046cacb0daec29$var$StyledStepItem = $3e046cacb0daec29$export$d38c25e5d733acec = $3e046cacb0daec29$var$_styledComponents["default"].li.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledStepper__StyledStepItem",
    componentId: "sc-gmpe0p-0"
})([
    "display:flex;position:relative;",
    ""
], function(props) {
    if (props.direction === 'vertical') {
        var _props$theme$global;
        return (0, $3e046cacb0daec29$var$_styledComponents.css)([
            "flex-direction:column;align-items:flex-start;padding-bottom:",
            ";"
        ], ((_props$theme$global = props.theme.global) == null || (_props$theme$global = _props$theme$global.edgeSize) == null ? void 0 : _props$theme$global.xxsmall) || '4px');
    }
    if (props.isSubStep) // horizontal and sub-steps isn't supported
    return (0, $3e046cacb0daec29$var$_styledComponents.css)([
        "flex-direction:row;align-items:center;flex:none;min-width:0;overflow:hidden;"
    ]);
    return (0, $3e046cacb0daec29$var$_styledComponents.css)([
        "flex-direction:column;align-items:center;flex:1;min-width:0;overflow:hidden;"
    ]);
});
var $3e046cacb0daec29$var$StyledStepButton = $3e046cacb0daec29$export$25390ca7ad93a025 = $3e046cacb0daec29$var$_styledComponents["default"].button.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledStepper__StyledStepButton",
    componentId: "sc-gmpe0p-1"
})([
    "display:flex;background:none;border:none;padding:",
    ";cursor:",
    ";outline:none;",
    ""
], function(props) {
    var _props$theme$global2;
    return ((_props$theme$global2 = props.theme.global) == null || (_props$theme$global2 = _props$theme$global2.edgeSize) == null ? void 0 : _props$theme$global2.xxsmall) || '4px';
}, function(props) {
    return props.isClickable ? 'pointer' : 'default';
}, function(props) {
    var _props$theme$global3, _props$theme$global4;
    return props.direction === 'vertical' ? (0, $3e046cacb0daec29$var$_styledComponents.css)([
        "flex-direction:row;align-items:flex-start;gap:",
        ";text-align:left;"
    ], (_props$theme$global3 = props.theme.global) == null || (_props$theme$global3 = _props$theme$global3.edgeSize) == null ? void 0 : _props$theme$global3.small) : (0, $3e046cacb0daec29$var$_styledComponents.css)([
        "flex-direction:column;align-items:center;gap:",
        ";text-align:center;width:100%;"
    ], (_props$theme$global4 = props.theme.global) == null || (_props$theme$global4 = _props$theme$global4.edgeSize) == null ? void 0 : _props$theme$global4.xxsmall);
});
var $3e046cacb0daec29$var$StyledStepContent = $3e046cacb0daec29$export$dc62e2075555ab43 = $3e046cacb0daec29$var$_styledComponents["default"].span.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledStepper__StyledStepContent",
    componentId: "sc-gmpe0p-2"
})([
    "display:flex;flex-direction:column;",
    ""
], function(props) {
    if (props.direction === 'vertical' && !props.isSubStep && !props.hasDescription) {
        var _props$theme$stepper;
        var indicatorSizeToken = ((_props$theme$stepper = props.theme.stepper) == null || (_props$theme$stepper = _props$theme$stepper.indicator) == null ? void 0 : _props$theme$stepper.size) || 'medium';
        var indicatorSize = $3e046cacb0daec29$var$getMetricSize(props.theme, indicatorSizeToken);
        var lineHeight = $3e046cacb0daec29$var$getTextMetric(props.theme, 'small', 'height');
        return (0, $3e046cacb0daec29$var$_styledComponents.css)([
            "padding-top:calc((",
            " - ",
            ") / 2);"
        ], indicatorSize, lineHeight);
    }
    return '';
});
var $3e046cacb0daec29$var$StyledIndicator = $3e046cacb0daec29$export$bd1caedcf570dd41 = $3e046cacb0daec29$var$_styledComponents["default"].span.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledStepper__StyledIndicator",
    componentId: "sc-gmpe0p-3"
})([
    "display:flex;align-items:center;justify-content:center;border-radius:50%;transition:transform 0.1s ease,background-color 0.15s ease,border-color 0.15s ease,color 0.15s ease;",
    " ",
    " ",
    ":focus-visible &{",
    "}",
    ""
], function(props) {
    return function(_props$theme$stepper2, _props$theme$stepper3, _props$theme$global5) {
        var indicatorSizeToken = ((_props$theme$stepper2 = props.theme.stepper) == null || (_props$theme$stepper2 = _props$theme$stepper2.indicator) == null ? void 0 : _props$theme$stepper2.size) || 'medium';
        var parentSize = $3e046cacb0daec29$var$getMetricSize(props.theme, indicatorSizeToken);
        var subStepSize = $3e046cacb0daec29$var$getMetricSize(props.theme, $3e046cacb0daec29$var$getSubStepSizeToken(indicatorSizeToken));
        var size = props.isSubStep ? subStepSize : parentSize;
        var borderWidth = ((_props$theme$stepper3 = props.theme.stepper) == null || (_props$theme$stepper3 = _props$theme$stepper3.indicator) == null || (_props$theme$stepper3 = _props$theme$stepper3.border) == null ? void 0 : _props$theme$stepper3.width) || ((_props$theme$global5 = props.theme.global) == null || (_props$theme$global5 = _props$theme$global5.borderSize) == null ? void 0 : _props$theme$global5.small) || '2px';
        return (0, $3e046cacb0daec29$var$_styledComponents.css)([
            "width:",
            ";height:",
            ";min-width:",
            ";min-height:",
            ";border:",
            " solid;"
        ], size, size, size, size, borderWidth);
    }();
}, function(props) {
    var _theme$stepper2;
    var theme = props.theme;
    var stateTheme = ((_theme$stepper2 = theme.stepper) == null || (_theme$stepper2 = _theme$stepper2[props.effectiveState]) == null ? void 0 : _theme$stepper2.indicator) || {};
    return (0, $3e046cacb0daec29$var$_styledComponents.css)([
        "background:",
        ";color:",
        ";border-color:",
        ";"
    ], (0, $4113023f9e0bafa0$exports.normalizeColor)((stateTheme == null ? void 0 : stateTheme.background) || 'transparent', theme), (0, $4113023f9e0bafa0$exports.normalizeColor)((stateTheme == null ? void 0 : stateTheme.color) || 'text-weak', theme), (0, $4113023f9e0bafa0$exports.normalizeColor)((stateTheme == null ? void 0 : stateTheme.border) || 'border', theme));
}, $3e046cacb0daec29$var$StyledStepButton, (0, $4113023f9e0bafa0$exports.focusStyle)(), function(props) {
    var _theme$stepper3, _stateTheme$hover, _stateTheme$hover2, _stateTheme$hover3, _theme$stepper4, _theme$stepper5;
    if (!props.isClickable) return '';
    var theme = props.theme;
    var stateTheme = ((_theme$stepper3 = theme.stepper) == null || (_theme$stepper3 = _theme$stepper3[props.effectiveState]) == null ? void 0 : _theme$stepper3.indicator) || {};
    var backgroundColor = stateTheme != null && stateTheme.background ? (0, $4113023f9e0bafa0$exports.normalizeColor)(stateTheme.background, theme) : undefined;
    var borderColor = stateTheme != null && stateTheme.border ? (0, $4113023f9e0bafa0$exports.normalizeColor)(stateTheme.border, theme) : undefined;
    var color = stateTheme != null && stateTheme.color ? (0, $4113023f9e0bafa0$exports.normalizeColor)(stateTheme.color, theme) : undefined;
    var stateBackgroundHoverColor = stateTheme != null && (_stateTheme$hover = stateTheme.hover) != null && _stateTheme$hover.background ? (0, $4113023f9e0bafa0$exports.normalizeColor)(stateTheme.hover.background, theme) : undefined;
    var stateBorderHoverColor = stateTheme != null && (_stateTheme$hover2 = stateTheme.hover) != null && _stateTheme$hover2.border ? (0, $4113023f9e0bafa0$exports.normalizeColor)(stateTheme.hover.border, theme) : undefined;
    var stateColorHoverColor = stateTheme != null && (_stateTheme$hover3 = stateTheme.hover) != null && _stateTheme$hover3.color ? (0, $4113023f9e0bafa0$exports.normalizeColor)(stateTheme.hover.color, theme) : undefined;
    var defaultBackgroundHoverColor = backgroundColor ? "color-mix(in srgb, " + backgroundColor + " 80%, black)" : (0, $4113023f9e0bafa0$exports.normalizeColor)(((_theme$stepper4 = theme.stepper) == null || (_theme$stepper4 = _theme$stepper4.hover) == null ? void 0 : _theme$stepper4.background) || 'background-contrast', theme);
    var defaultBorderHoverColor = borderColor ? "color-mix(in srgb, " + borderColor + " 80%, black)" : (0, $4113023f9e0bafa0$exports.normalizeColor)(((_theme$stepper5 = theme.stepper) == null || (_theme$stepper5 = _theme$stepper5.hover) == null ? void 0 : _theme$stepper5.border) || 'text', theme);
    var defaultColorHoverColor = color ? "color-mix(in srgb, " + color + " 80%, black)" : (0, $4113023f9e0bafa0$exports.normalizeColor)('text-strong', theme);
    var hoverBackgroundColor = stateBackgroundHoverColor || defaultBackgroundHoverColor;
    var hoverBorderColor = stateBorderHoverColor || defaultBorderHoverColor;
    var hoverColor = stateColorHoverColor || defaultColorHoverColor;
    var hoverStyles = function() {
        return (0, $3e046cacb0daec29$var$_styledComponents.css)([
            "background:",
            ";border-color:",
            ";color:",
            ";"
        ], hoverBackgroundColor, hoverBorderColor, hoverColor);
    }();
    return (0, $3e046cacb0daec29$var$_styledComponents.css)([
        "",
        ":not([aria-disabled]):active &{transform:scale(0.95);}",
        ":not([aria-disabled]):hover &{",
        "}"
    ], $3e046cacb0daec29$var$StyledStepButton, $3e046cacb0daec29$var$StyledStepButton, hoverStyles);
});
var $3e046cacb0daec29$var$StyledConnector = $3e046cacb0daec29$export$e1f766abd15de7fa = $3e046cacb0daec29$var$_styledComponents["default"].span.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledStepper__StyledConnector",
    componentId: "sc-gmpe0p-4"
})([
    "",
    " position:absolute;background:",
    ";"
], function(props) {
    var _theme$stepper6, _theme$stepper7, _theme$global3, _theme$stepper8, _theme$global4, _theme$global5;
    var theme = props.theme;
    var indicatorSizeToken = ((_theme$stepper6 = theme.stepper) == null || (_theme$stepper6 = _theme$stepper6.indicator) == null ? void 0 : _theme$stepper6.size) || 'medium';
    var parentSize = $3e046cacb0daec29$var$getMetricSize(theme, indicatorSizeToken);
    var indicatorBorderWidth = $3e046cacb0daec29$var$getMetricSize(theme, ((_theme$stepper7 = theme.stepper) == null || (_theme$stepper7 = _theme$stepper7.indicator) == null || (_theme$stepper7 = _theme$stepper7.border) == null ? void 0 : _theme$stepper7.width) || '2px');
    var buttonPad = ((_theme$global3 = theme.global) == null || (_theme$global3 = _theme$global3.edgeSize) == null ? void 0 : _theme$global3.xxsmall) || '4px';
    var connectorThickness = ((_theme$stepper8 = theme.stepper) == null || (_theme$stepper8 = _theme$stepper8.connector) == null || (_theme$stepper8 = _theme$stepper8.stroke) == null ? void 0 : _theme$stepper8.width) || ((_theme$global4 = theme.global) == null || (_theme$global4 = _theme$global4.borderSize) == null ? void 0 : _theme$global4.small) || '2px';
    var connectorRadius = ((_theme$global5 = theme.global) == null || (_theme$global5 = _theme$global5.edgeSize) == null ? void 0 : _theme$global5.xsmall) || '4px';
    var connectorOffset = "calc(" + parentSize + " / 2 + " + buttonPad + ")";
    return (0, $3e046cacb0daec29$var$_styledComponents.css)([
        "border-radius:",
        ";",
        ""
    ], connectorRadius, props.direction === 'horizontal' ? (0, $3e046cacb0daec29$var$_styledComponents.css)([
        "top:",
        ";left:calc(",
        "50% + ",
        ");right:calc(-50% + ",
        ");height:",
        ";"
    ], connectorOffset, props.isBetween ? '-' : '', connectorOffset, connectorOffset, connectorThickness) : (0, $3e046cacb0daec29$var$_styledComponents.css)([
        "left:calc( ",
        " + ",
        " - ",
        " / 2 );top:",
        ";bottom:0;width:",
        ";"
    ], connectorOffset, indicatorBorderWidth, connectorThickness, props.isBetween ? 0 : "calc(" + parentSize + " + " + buttonPad + " * 3)", connectorThickness));
}, function(props) {
    return $3e046cacb0daec29$var$getConnectorColor(props.status, props.theme);
});


function $fb5dc6bad0dc9418$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $fb5dc6bad0dc9418$var$_extends() {
    return $fb5dc6bad0dc9418$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fb5dc6bad0dc9418$var$_extends.apply(null, arguments);
}
var $fb5dc6bad0dc9418$var$StepConnector = $fb5dc6bad0dc9418$export$4a156f5690e82b42 = function StepConnector(_ref) {
    var _theme$stepper, _theme$global, _theme$global2, _theme$global3, _theme$global4, _theme$global5;
    var step = _ref.step, direction = _ref.direction, children = _ref.children;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var indicatorSize = (_theme$stepper = theme.stepper) != null && (_theme$stepper = _theme$stepper.indicator) != null && _theme$stepper.size && (_theme$global = theme.global) != null && (_theme$global = _theme$global.edgeSize) != null && _theme$global[theme.stepper.indicator.size] ? theme.global.edgeSize[theme.stepper.indicator.size] : ((_theme$global2 = theme.global) == null || (_theme$global2 = _theme$global2.edgeSize) == null ? void 0 : _theme$global2.medium) || '24px';
    var childGap = ((_theme$global3 = theme.global) == null || (_theme$global3 = _theme$global3.edgeSize) == null ? void 0 : _theme$global3.xsmall) || '8px';
    var childPadTop = ((_theme$global4 = theme.global) == null || (_theme$global4 = _theme$global4.edgeSize) == null ? void 0 : _theme$global4.medium) || '24px';
    var minConnectorInlineSize = ((_theme$global5 = theme.global) == null || (_theme$global5 = _theme$global5.edgeSize) == null ? void 0 : _theme$global5.small) || '12px';
    var directionStyle = direction === 'horizontal' ? {
        alignItems: 'center',
        minWidth: minConnectorInlineSize
    } : {
        justifyContent: 'flex-start',
        minHeight: minConnectorInlineSize
    };
    var renderChildren = function renderChildren() {
        var _theme$global6;
        if (!children) return null;
        var childIndent = "calc(" + indicatorSize + " + " + (((_theme$global6 = theme.global) == null || (_theme$global6 = _theme$global6.edgeSize) == null ? void 0 : _theme$global6.small) || '12px') + ")";
        return direction === 'horizontal' ? /*#__PURE__*/ $fb5dc6bad0dc9418$var$_react["default"].createElement("span", {
            style: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: childGap,
                paddingTop: childPadTop,
                maxWidth: '100%',
                flexWrap: 'wrap',
                justifyContent: 'center'
            }
        }, children) : /*#__PURE__*/ $fb5dc6bad0dc9418$var$_react["default"].createElement("ol", {
            style: {
                listStyle: 'none',
                padding: "0 0 0 " + childIndent,
                margin: 0
            }
        }, children);
    };
    return /*#__PURE__*/ $fb5dc6bad0dc9418$var$_react["default"].createElement("li", {
        role: "presentation",
        "aria-hidden": children ? undefined : 'true',
        style: $fb5dc6bad0dc9418$var$_extends({
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            flex: 1,
            overflow: 'visible'
        }, directionStyle)
    }, /*#__PURE__*/ $fb5dc6bad0dc9418$var$_react["default"].createElement($3e046cacb0daec29$export$e1f766abd15de7fa, $fb5dc6bad0dc9418$var$_extends({
        direction: direction,
        status: step.status,
        "aria-hidden": "true",
        isBetween: true
    }, passThemeFlag)), renderChildren());
};


var $4258e558ff024eeb$export$1e511d4a378977f5;
var $4258e558ff024eeb$export$9378619b14945e16;
var $4258e558ff024eeb$export$8d250186d342524a;
var $4258e558ff024eeb$export$91b1e15bb76ddaff;
var $4258e558ff024eeb$export$ee95d849f734b9b0;
"use strict";
$4258e558ff024eeb$export$1e511d4a378977f5 = true;
$4258e558ff024eeb$export$9378619b14945e16 = $4258e558ff024eeb$export$8d250186d342524a = $4258e558ff024eeb$export$91b1e15bb76ddaff = $4258e558ff024eeb$export$ee95d849f734b9b0 = void 0;

var $2xPiy = parcelRequire("2xPiy");
var $4258e558ff024eeb$var$StepperContext = $4258e558ff024eeb$export$91b1e15bb76ddaff = /*#__PURE__*/ (0, $2xPiy.createContext)({
    currentStep: '',
    steps: [],
    direction: 'horizontal',
    clickableSteps: true,
    onStepClick: undefined,
    showDescription: true,
    stepIndex: function stepIndex() {
        return -1;
    },
    isPriorStep: function isPriorStep() {
        return false;
    },
    isAfterStep: function isAfterStep() {
        return false;
    },
    isCurrentStep: function isCurrentStep() {
        return false;
    },
    canNavigateTo: function canNavigateTo() {
        return false;
    }
});
// Step-level context: provides the current step's data to subcomponents
var $4258e558ff024eeb$var$StepItemContext = $4258e558ff024eeb$export$ee95d849f734b9b0 = /*#__PURE__*/ (0, $2xPiy.createContext)({
    step: null,
    index: 0,
    isLast: false,
    isLabelRevealed: false,
    isSubStep: false
});
var $4258e558ff024eeb$var$useStepper = $4258e558ff024eeb$export$9378619b14945e16 = function useStepper() {
    return (0, $2xPiy.useContext)($4258e558ff024eeb$var$StepperContext);
};
var $4258e558ff024eeb$var$useStepItem = $4258e558ff024eeb$export$8d250186d342524a = function useStepItem() {
    return (0, $2xPiy.useContext)($4258e558ff024eeb$var$StepItemContext);
};


var $62cda09aed2b62ae$export$1e511d4a378977f5;
var $62cda09aed2b62ae$export$4ea00516583c5adc;
"use strict";
$62cda09aed2b62ae$export$1e511d4a378977f5 = true;
$62cda09aed2b62ae$export$4ea00516583c5adc = void 0;

var $62cda09aed2b62ae$var$_react = $62cda09aed2b62ae$var$_interopRequireWildcard((parcelRequire("2xPiy")));



var $5bc6dd4e98119d18$export$1e511d4a378977f5;
var $5bc6dd4e98119d18$export$d3ab37ba13a08390;
var $5bc6dd4e98119d18$export$8ecc614a51f68dbb;
"use strict";
$5bc6dd4e98119d18$export$1e511d4a378977f5 = true;
$5bc6dd4e98119d18$export$d3ab37ba13a08390 = void 0;
$5bc6dd4e98119d18$export$8ecc614a51f68dbb = $5bc6dd4e98119d18$var$getEffectiveState;

var $5bc6dd4e98119d18$var$_react = $5bc6dd4e98119d18$var$_interopRequireDefault((parcelRequire("2xPiy")));



function $5bc6dd4e98119d18$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $5bc6dd4e98119d18$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $5bc6dd4e98119d18$var$_extends() {
    return $5bc6dd4e98119d18$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5bc6dd4e98119d18$var$_extends.apply(null, arguments);
}
var $5bc6dd4e98119d18$var$renderIcon = function renderIcon(Icon, props) {
    if (!Icon) return null;
    var iconProps = $5bc6dd4e98119d18$var$_extends({
        color: 'currentColor'
    }, props);
    if (/*#__PURE__*/ $5bc6dd4e98119d18$var$_react["default"].isValidElement(Icon)) return /*#__PURE__*/ $5bc6dd4e98119d18$var$_react["default"].cloneElement(Icon, $5bc6dd4e98119d18$var$_extends({}, iconProps, {
        'aria-hidden': true
    }));
    return /*#__PURE__*/ $5bc6dd4e98119d18$var$_react["default"].createElement(Icon, $5bc6dd4e98119d18$var$_extends({}, iconProps, {
        "aria-hidden": true
    }));
};
// Maps step status + current position to a visual state
// used by both the indicator and label components.
function $5bc6dd4e98119d18$var$getEffectiveState(status, isCurrent) {
    if (status === 'disabled') return 'disabled';
    if (isCurrent) {
        if (status === 'completed') return 'currentCompleted';
        if (status === 'error') return 'currentError';
        return 'current';
    }
    if (status === 'completed') return 'completed';
    if (status === 'error') return 'error';
    return 'pending';
}
var $5bc6dd4e98119d18$var$StepperIndicator = $5bc6dd4e98119d18$export$d3ab37ba13a08390 = function StepperIndicator(_ref) {
    var _step$children, _theme$stepper, _stateTheme, _stateTheme2;
    var rest = $5bc6dd4e98119d18$var$_extends({}, ($5bc6dd4e98119d18$var$_objectDestructuringEmpty(_ref), _ref));
    var _useStepper = (0, $4258e558ff024eeb$export$9378619b14945e16)(), currentStep = _useStepper.currentStep, clickableSteps = _useStepper.clickableSteps;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useStepItem = (0, $4258e558ff024eeb$export$8d250186d342524a)(), step = _useStepItem.step, isSubStep = _useStepItem.isSubStep;
    if (!step) return null;
    var isCurrent = currentStep === step.id;
    var hasCurrentChild = !isSubStep && ((_step$children = step.children) == null ? void 0 : _step$children.some(function(c) {
        return c.id === currentStep;
    }));
    var isHighlighted = isCurrent || hasCurrentChild;
    var effectiveState = $5bc6dd4e98119d18$var$getEffectiveState(step.status, isHighlighted);
    var stateTheme = ((_theme$stepper = theme.stepper) == null || (_theme$stepper = _theme$stepper[effectiveState]) == null ? void 0 : _theme$stepper.indicator) || {};
    if (isSubStep && stateTheme.substep) stateTheme = $5bc6dd4e98119d18$var$_extends({}, stateTheme, stateTheme.substep);
    var isDisabled = step.status === 'disabled';
    var isClickable = clickableSteps && !isDisabled;
    var iconSize = ((_stateTheme = stateTheme) == null ? void 0 : _stateTheme.iconSize) || (isSubStep ? 'xsmall' : 'small');
    return /*#__PURE__*/ $5bc6dd4e98119d18$var$_react["default"].createElement($3e046cacb0daec29$export$bd1caedcf570dd41, $5bc6dd4e98119d18$var$_extends({
        effectiveState: effectiveState,
        isSubStep: isSubStep,
        isClickable: isClickable
    }, passThemeFlag, rest), $5bc6dd4e98119d18$var$renderIcon((_stateTheme2 = stateTheme) == null ? void 0 : _stateTheme2.icon, {
        size: iconSize
    }));
};


var $f04cc273b756b918$export$1e511d4a378977f5;
var $f04cc273b756b918$export$f885210784698446;
"use strict";
$f04cc273b756b918$export$1e511d4a378977f5 = true;
$f04cc273b756b918$export$f885210784698446 = void 0;

var $f04cc273b756b918$var$_react = $f04cc273b756b918$var$_interopRequireDefault((parcelRequire("2xPiy")));




function $f04cc273b756b918$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $f04cc273b756b918$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $f04cc273b756b918$var$_extends() {
    return $f04cc273b756b918$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f04cc273b756b918$var$_extends.apply(null, arguments);
}
var $f04cc273b756b918$var$getStateProps = function getStateProps(theme, effectiveState) {
    var _theme$stepper;
    return ((_theme$stepper = theme.stepper) == null || (_theme$stepper = _theme$stepper[effectiveState]) == null ? void 0 : _theme$stepper.label) || {};
};
var $f04cc273b756b918$var$StepperLabel = $f04cc273b756b918$export$f885210784698446 = function StepperLabel(_ref) {
    var _step$children, _theme$stepper2, _theme$stepper3;
    var rest = $f04cc273b756b918$var$_extends({}, ($f04cc273b756b918$var$_objectDestructuringEmpty(_ref), _ref));
    var _useStepper = (0, $4258e558ff024eeb$export$9378619b14945e16)(), currentStep = _useStepper.currentStep, direction = _useStepper.direction;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useStepItem = (0, $4258e558ff024eeb$export$8d250186d342524a)(), step = _useStepItem.step, isSubStep = _useStepItem.isSubStep;
    if (!step) return null;
    var isCurrent = currentStep === step.id;
    var hasCurrentChild = !isSubStep && ((_step$children = step.children) == null ? void 0 : _step$children.some(function(c) {
        return c.id === currentStep;
    }));
    var isHighlighted = isCurrent || hasCurrentChild;
    var effectiveState = (0, $5bc6dd4e98119d18$export$8ecc614a51f68dbb)(step.status, isHighlighted);
    var stateProps = $f04cc273b756b918$var$getStateProps(theme, effectiveState);
    var size = isSubStep ? ((_theme$stepper2 = theme.stepper) == null || (_theme$stepper2 = _theme$stepper2.label) == null || (_theme$stepper2 = _theme$stepper2.substep) == null ? void 0 : _theme$stepper2.size) || 'small' : ((_theme$stepper3 = theme.stepper) == null || (_theme$stepper3 = _theme$stepper3.label) == null ? void 0 : _theme$stepper3.size) || 'medium';
    return /*#__PURE__*/ $f04cc273b756b918$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, $f04cc273b756b918$var$_extends({
        size: size,
        truncate: direction === 'horizontal'
    }, stateProps, rest), step.title);
};


var $96ed6f1a730fef47$export$1e511d4a378977f5;
var $96ed6f1a730fef47$export$f0e13176f06b1b53;
"use strict";
$96ed6f1a730fef47$export$1e511d4a378977f5 = true;
$96ed6f1a730fef47$export$f0e13176f06b1b53 = void 0;

var $96ed6f1a730fef47$var$_react = $96ed6f1a730fef47$var$_interopRequireDefault((parcelRequire("2xPiy")));



function $96ed6f1a730fef47$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $96ed6f1a730fef47$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $96ed6f1a730fef47$var$_extends() {
    return $96ed6f1a730fef47$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $96ed6f1a730fef47$var$_extends.apply(null, arguments);
}
var $96ed6f1a730fef47$var$StepperDescription = $96ed6f1a730fef47$export$f0e13176f06b1b53 = function StepperDescription(_ref) {
    var _theme$stepper;
    var rest = $96ed6f1a730fef47$var$_extends({}, ($96ed6f1a730fef47$var$_objectDestructuringEmpty(_ref), _ref));
    var _useStepper = (0, $4258e558ff024eeb$export$9378619b14945e16)(), direction = _useStepper.direction;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var _useStepItem = (0, $4258e558ff024eeb$export$8d250186d342524a)(), step = _useStepItem.step;
    if (!step || !step.description) return null;
    var descriptionProps = (_theme$stepper = theme.stepper) == null ? void 0 : _theme$stepper.description;
    return /*#__PURE__*/ $96ed6f1a730fef47$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, $96ed6f1a730fef47$var$_extends({}, descriptionProps, {
        truncate: direction === 'horizontal'
    }, rest), step.description);
};


var $4048475bf089fb53$export$1e511d4a378977f5;
var $4048475bf089fb53$export$482b3904ab0152e7;
var $4048475bf089fb53$export$6ebc62bc3521fc7;
"use strict";
$4048475bf089fb53$export$1e511d4a378977f5 = true;
$4048475bf089fb53$export$482b3904ab0152e7 = $4048475bf089fb53$export$6ebc62bc3521fc7 = void 0;

var $4048475bf089fb53$var$_react = $4048475bf089fb53$var$_interopRequireDefault((parcelRequire("2xPiy")));



var $4048475bf089fb53$var$_excluded = [
    "variant"
];
function $4048475bf089fb53$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $4048475bf089fb53$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $4048475bf089fb53$var$_extends() {
    return $4048475bf089fb53$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4048475bf089fb53$var$_extends.apply(null, arguments);
}
function $4048475bf089fb53$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $4048475bf089fb53$var$StepperHelperText = function StepperHelperText(_ref) {
    var _theme$stepper, _theme$stepper2;
    var variant = _ref.variant, rest = $4048475bf089fb53$var$_objectWithoutPropertiesLoose(_ref, $4048475bf089fb53$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var helperTextProps = (_theme$stepper = theme.stepper) == null ? void 0 : _theme$stepper.helperText;
    var variantProps = variant ? ((_theme$stepper2 = theme.stepper) == null || (_theme$stepper2 = _theme$stepper2[variant]) == null ? void 0 : _theme$stepper2.helperText) || {} : {};
    return /*#__PURE__*/ $4048475bf089fb53$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, $4048475bf089fb53$var$_extends({}, helperTextProps, variantProps, rest));
};
var $4048475bf089fb53$var$StepperError = $4048475bf089fb53$export$482b3904ab0152e7 = function StepperError(_ref2) {
    var rest = $4048475bf089fb53$var$_extends({}, ($4048475bf089fb53$var$_objectDestructuringEmpty(_ref2), _ref2));
    var _useStepItem = (0, $4258e558ff024eeb$export$8d250186d342524a)(), step = _useStepItem.step;
    if (!step || step.status !== 'error' || !step.errorMessage) return null;
    return /*#__PURE__*/ $4048475bf089fb53$var$_react["default"].createElement($4048475bf089fb53$var$StepperHelperText, $4048475bf089fb53$var$_extends({
        id: "stepper-error-" + step.id,
        role: "alert",
        variant: "error"
    }, rest), step.errorMessage);
};
var $4048475bf089fb53$var$StepperDisabledReason = $4048475bf089fb53$export$6ebc62bc3521fc7 = function StepperDisabledReason(_ref3) {
    var rest = $4048475bf089fb53$var$_extends({}, ($4048475bf089fb53$var$_objectDestructuringEmpty(_ref3), _ref3));
    var _useStepItem2 = (0, $4258e558ff024eeb$export$8d250186d342524a)(), step = _useStepItem2.step;
    if (!step || step.status !== 'disabled' || !step.disabledReason) return null;
    return /*#__PURE__*/ $4048475bf089fb53$var$_react["default"].createElement($4048475bf089fb53$var$StepperHelperText, $4048475bf089fb53$var$_extends({
        id: "stepper-reason-" + step.id,
        variant: "disabled"
    }, rest), step.disabledReason);
};



function $62cda09aed2b62ae$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($62cda09aed2b62ae$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $62cda09aed2b62ae$var$_extends() {
    return $62cda09aed2b62ae$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $62cda09aed2b62ae$var$_extends.apply(null, arguments);
}
var $62cda09aed2b62ae$var$StepperStep = $62cda09aed2b62ae$export$4ea00516583c5adc = function StepperStep(_ref) {
    var _step$children, _stepsRef$current;
    var step = _ref.step, stepNumber = _ref.stepNumber, isLast = _ref.isLast, showConnector = _ref.showConnector, direction = _ref.direction, focusedIndex = _ref.focusedIndex, indexProp = _ref.index, isSubStep = _ref.isSubStep, onFocusStep = _ref.onFocusStep, stepsRef = _ref.stepsRef, stepRefs = _ref.stepRefs;
    var _useStepper = (0, $4258e558ff024eeb$export$9378619b14945e16)(), currentStep = _useStepper.currentStep, clickableSteps = _useStepper.clickableSteps, showDescription = _useStepper.showDescription, onStepClick = _useStepper.onStepClick, steps = _useStepper.steps;
    var _useContext = (0, $62cda09aed2b62ae$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var index = indexProp !== undefined ? indexProp : steps.findIndex(function(s) {
        return s.id === step.id;
    });
    var isCurrent = currentStep === step.id;
    var hasCurrentChild = !isSubStep && ((_step$children = step.children) == null ? void 0 : _step$children.some(function(c) {
        return c.id === currentStep;
    }));
    var isHighlighted = isCurrent || hasCurrentChild;
    var isDisabled = step.status === 'disabled';
    var isClickable = clickableSteps && !isDisabled;
    var isReadOnly = !clickableSteps;
    var stepItemValue = (0, $62cda09aed2b62ae$var$_react.useMemo)(function() {
        return {
            step: step,
            index: index,
            isLast: isLast,
            isLabelRevealed: direction === 'vertical' || focusedIndex === index,
            isSubStep: isSubStep
        };
    }, [
        step,
        index,
        isLast,
        direction,
        focusedIndex,
        isSubStep
    ]);
    var handleClick = function handleClick() {
        if (isClickable && onStepClick) onStepClick(step.id);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (isClickable && onStepClick) onStepClick(step.id);
        }
    };
    var totalSteps = ((_stepsRef$current = stepsRef.current) == null ? void 0 : _stepsRef$current.length) || stepNumber;
    var ariaLabel = step['aria-label'] || format({
        id: 'stepper.step',
        values: {
            step: stepNumber,
            total: totalSteps,
            title: step.title
        }
    });
    var describedBy = [];
    if (step.errorMessage && step.status === 'error') describedBy.push("stepper-error-" + step.id);
    if (step.disabledReason && step.status === 'disabled') describedBy.push("stepper-reason-" + step.id);
    var focusableProps = isReadOnly ? {} : {
        tabIndex: focusedIndex === index ? 0 : -1,
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        onFocus: function onFocus() {
            if (onFocusStep) onFocusStep(index);
        },
        type: 'button'
    };
    return /*#__PURE__*/ $62cda09aed2b62ae$var$_react["default"].createElement($4258e558ff024eeb$export$ee95d849f734b9b0.Provider, {
        value: stepItemValue
    }, /*#__PURE__*/ $62cda09aed2b62ae$var$_react["default"].createElement($3e046cacb0daec29$export$d38c25e5d733acec, $62cda09aed2b62ae$var$_extends({
        direction: direction,
        isSubStep: isSubStep
    }, passThemeFlag), /*#__PURE__*/ $62cda09aed2b62ae$var$_react["default"].createElement($3e046cacb0daec29$export$25390ca7ad93a025, $62cda09aed2b62ae$var$_extends({
        as: isReadOnly ? 'div' : 'button',
        role: isReadOnly ? 'group' : undefined,
        ref: function ref(el) {
            if (stepRefs) {
                if (el) stepRefs.current.set(index, el);
                else stepRefs.current["delete"](index);
            }
        },
        "aria-current": isHighlighted ? 'step' : undefined,
        "aria-disabled": isDisabled || undefined,
        "aria-label": ariaLabel,
        "aria-describedby": describedBy.length > 0 ? describedBy.join(' ') : undefined,
        isClickable: isClickable,
        isDisabled: isDisabled,
        isSubStep: isSubStep,
        direction: direction
    }, focusableProps, passThemeFlag), /*#__PURE__*/ $62cda09aed2b62ae$var$_react["default"].createElement($5bc6dd4e98119d18$export$d3ab37ba13a08390, null), /*#__PURE__*/ $62cda09aed2b62ae$var$_react["default"].createElement($3e046cacb0daec29$export$dc62e2075555ab43, $62cda09aed2b62ae$var$_extends({
        direction: direction,
        isSubStep: isSubStep,
        hasDescription: !!step.description
    }, passThemeFlag), /*#__PURE__*/ $62cda09aed2b62ae$var$_react["default"].createElement($f04cc273b756b918$export$f885210784698446, null), showDescription && /*#__PURE__*/ $62cda09aed2b62ae$var$_react["default"].createElement($96ed6f1a730fef47$export$f0e13176f06b1b53, null), /*#__PURE__*/ $62cda09aed2b62ae$var$_react["default"].createElement($4048475bf089fb53$export$482b3904ab0152e7, null), /*#__PURE__*/ $62cda09aed2b62ae$var$_react["default"].createElement($4048475bf089fb53$export$6ebc62bc3521fc7, null))), (showConnector !== undefined ? showConnector : !isLast) && /*#__PURE__*/ $62cda09aed2b62ae$var$_react["default"].createElement($3e046cacb0daec29$export$e1f766abd15de7fa, $62cda09aed2b62ae$var$_extends({
        direction: direction,
        status: step.status,
        "aria-hidden": "true"
    }, passThemeFlag))));
};


var $f32cf71659a5268b$export$1e511d4a378977f5;
var $f32cf71659a5268b$export$f60f1a94f0808dc5;
"use strict";
$f32cf71659a5268b$export$1e511d4a378977f5 = true;
$f32cf71659a5268b$export$f60f1a94f0808dc5 = void 0;

var $f32cf71659a5268b$var$_propTypes = $f32cf71659a5268b$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $f32cf71659a5268b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $f32cf71659a5268b$var$PropType = {};
$f32cf71659a5268b$var$PropType = {
    steps: $f32cf71659a5268b$var$_propTypes["default"].arrayOf($f32cf71659a5268b$var$_propTypes["default"].shape({
        id: $f32cf71659a5268b$var$_propTypes["default"].string.isRequired,
        title: $f32cf71659a5268b$var$_propTypes["default"].string.isRequired,
        description: $f32cf71659a5268b$var$_propTypes["default"].string,
        status: $f32cf71659a5268b$var$_propTypes["default"].oneOf([
            'pending',
            'completed',
            'error',
            'disabled'
        ]),
        disabledReason: $f32cf71659a5268b$var$_propTypes["default"].string,
        errorMessage: $f32cf71659a5268b$var$_propTypes["default"].string,
        children: $f32cf71659a5268b$var$_propTypes["default"].arrayOf($f32cf71659a5268b$var$_propTypes["default"].shape({
            id: $f32cf71659a5268b$var$_propTypes["default"].string.isRequired,
            title: $f32cf71659a5268b$var$_propTypes["default"].string.isRequired,
            description: $f32cf71659a5268b$var$_propTypes["default"].string,
            status: $f32cf71659a5268b$var$_propTypes["default"].oneOf([
                'pending',
                'completed',
                'error',
                'disabled'
            ]),
            disabledReason: $f32cf71659a5268b$var$_propTypes["default"].string,
            errorMessage: $f32cf71659a5268b$var$_propTypes["default"].string
        }))
    })).isRequired,
    currentStep: $f32cf71659a5268b$var$_propTypes["default"].string.isRequired,
    direction: $f32cf71659a5268b$var$_propTypes["default"].oneOf([
        'horizontal',
        'vertical'
    ]),
    clickableSteps: $f32cf71659a5268b$var$_propTypes["default"].bool,
    showDescription: $f32cf71659a5268b$var$_propTypes["default"].bool,
    onStepClick: $f32cf71659a5268b$var$_propTypes["default"].func,
    id: $f32cf71659a5268b$var$_propTypes["default"].string,
    children: $f32cf71659a5268b$var$_propTypes["default"].node
};
var $f32cf71659a5268b$var$StepperPropTypes = $f32cf71659a5268b$export$f60f1a94f0808dc5 = $f32cf71659a5268b$var$PropType;


var $78e955b4419149e8$var$_excluded = [
    "steps",
    "currentStep",
    "direction",
    "clickableSteps",
    "showDescription",
    "onStepClick",
    "aria-label",
    "children",
    "id"
];
function $78e955b4419149e8$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($78e955b4419149e8$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $78e955b4419149e8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $78e955b4419149e8$var$_extends() {
    return $78e955b4419149e8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $78e955b4419149e8$var$_extends.apply(null, arguments);
}
// Flattens steps with parent/child relationships into a linear list
// for keyboard navigation and index-based tracking.
var $78e955b4419149e8$var$flattenSteps = function flattenSteps(steps) {
    var flat = [];
    var hasSubSubSteps = false;
    steps.forEach(function(step, parentIdx) {
        var hasChildren = step.children && step.children.length > 0;
        var isLastParent = parentIdx === steps.length - 1;
        flat.push($78e955b4419149e8$var$_extends({}, step, {
            isSubStep: false,
            showConnector: !isLastParent,
            childIds: hasChildren ? step.children.map(function(c) {
                return c.id;
            }) : []
        }));
        if (hasChildren) step.children.forEach(function(child) {
            flat.push($78e955b4419149e8$var$_extends({}, child, {
                isSubStep: true,
                showConnector: false,
                parentId: step.id,
                childIds: []
            }));
            if (child.children && child.children.length > 0) hasSubSubSteps = true;
        });
    });
    if (hasSubSubSteps) console.warn('Stepper: sub-steps with their own children are not supported.');
    return flat;
};
var $78e955b4419149e8$var$Stepper = $78e955b4419149e8$export$ed8ca599049e8881 = /*#__PURE__*/ (0, $78e955b4419149e8$var$_react.forwardRef)(function(_ref, ref) {
    var _ref$steps = _ref.steps, steps = _ref$steps === void 0 ? [] : _ref$steps, currentStep = _ref.currentStep, _ref$direction = _ref.direction, directionProp = _ref$direction === void 0 ? 'horizontal' : _ref$direction, _ref$clickableSteps = _ref.clickableSteps, clickableSteps = _ref$clickableSteps === void 0 ? true : _ref$clickableSteps, _ref$showDescription = _ref.showDescription, showDescription = _ref$showDescription === void 0 ? true : _ref$showDescription, onStepClick = _ref.onStepClick, ariaLabel = _ref['aria-label'], children = _ref.children, id = _ref.id, rest = $78e955b4419149e8$var$_objectWithoutPropertiesLoose(_ref, $78e955b4419149e8$var$_excluded);
    var _useContext = (0, $78e955b4419149e8$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var stepRefs = (0, $78e955b4419149e8$var$_react.useRef)(new Map());
    var flatSteps = (0, $78e955b4419149e8$var$_react.useMemo)(function() {
        return $78e955b4419149e8$var$flattenSteps(steps);
    }, [
        steps
    ]);
    var stepsRef = (0, $78e955b4419149e8$var$_react.useRef)(flatSteps);
    stepsRef.current = flatSteps;
    (0, $78e955b4419149e8$var$_react.useEffect)(function() {
        console.warn("Warning: Stepper is currently in beta. The API is subject to change in future releases.");
    }, []);
    // Force vertical if steps have children
    // (horizontal substeps not supported)
    var hasSubSteps = steps.some(function(step) {
        return step.children && step.children.length > 0;
    });
    var direction = hasSubSteps && directionProp === 'horizontal' ? 'vertical' : directionProp;
    if (hasSubSteps && directionProp === 'horizontal') console.warn("Stepper: horizontal direction with sub-steps is not supported. Falling back to vertical.");
    if (currentStep) {
        var currentStepObj = flatSteps.find(function(s) {
            return s.id === currentStep;
        });
        if (!currentStepObj) console.warn('Stepper: currentStep "' + (currentStep + "\" does not match any ") + 'step id. Falling back to the ' + 'first non-disabled step.');
        else if (currentStepObj.status === 'disabled') console.warn("Stepper: currentStep \"" + currentStep + "\" matches a disabled step. " + "This is an invalid state. The step will render as disabled.");
    }
    // Determine effective current step (fallback to first non-disabled)
    var effectiveCurrentStep = (0, $78e955b4419149e8$var$_react.useMemo)(function() {
        var _flatSteps$;
        var match = flatSteps.find(function(s) {
            return s.id === currentStep;
        });
        if (match && match.status !== 'disabled') return currentStep;
        var fallback = flatSteps.find(function(s) {
            return s.status !== 'disabled';
        });
        return fallback ? fallback.id : ((_flatSteps$ = flatSteps[0]) == null ? void 0 : _flatSteps$.id) || '';
    }, [
        currentStep,
        flatSteps
    ]);
    // Roving tabindex: only the focused step has tabIndex=0,
    // all others have tabIndex=-1. A ref keeps the index synchronous
    // for keyboard handlers that fire before React re-renders.
    var currentIndex = flatSteps.findIndex(function(s) {
        return s.id === effectiveCurrentStep;
    });
    var flatStepsLength = flatSteps.length;
    var _useState = (0, $78e955b4419149e8$var$_react.useState)(currentIndex >= 0 ? currentIndex : 0), focusedIndex = _useState[0], setFocusedIndex = _useState[1];
    var focusedIndexRef = (0, $78e955b4419149e8$var$_react.useRef)(focusedIndex);
    var updateFocusedIndex = (0, $78e955b4419149e8$var$_react.useCallback)(function(idx) {
        focusedIndexRef.current = idx;
        setFocusedIndex(idx);
    }, []);
    var stepIndex = (0, $78e955b4419149e8$var$_react.useCallback)(function(stepId) {
        return flatSteps.findIndex(function(s) {
            return s.id === stepId;
        });
    }, [
        flatSteps
    ]);
    var isPriorStep = (0, $78e955b4419149e8$var$_react.useCallback)(function(stepId) {
        var idx = stepIndex(stepId);
        var curIdx = stepIndex(effectiveCurrentStep);
        return idx < curIdx;
    }, [
        stepIndex,
        effectiveCurrentStep
    ]);
    var isAfterStep = (0, $78e955b4419149e8$var$_react.useCallback)(function(stepId) {
        var idx = stepIndex(stepId);
        var curIdx = stepIndex(effectiveCurrentStep);
        return idx > curIdx;
    }, [
        stepIndex,
        effectiveCurrentStep
    ]);
    var isCurrentStep = (0, $78e955b4419149e8$var$_react.useCallback)(function(stepId) {
        return stepId === effectiveCurrentStep;
    }, [
        effectiveCurrentStep
    ]);
    var canNavigateTo = (0, $78e955b4419149e8$var$_react.useCallback)(function(stepId) {
        var step = flatSteps.find(function(s) {
            return s.id === stepId;
        });
        return clickableSteps && step && step.status !== 'disabled';
    }, [
        flatSteps,
        clickableSteps
    ]);
    var contextValue = (0, $78e955b4419149e8$var$_react.useMemo)(function() {
        return {
            currentStep: effectiveCurrentStep,
            steps: flatSteps,
            direction: direction,
            clickableSteps: clickableSteps,
            onStepClick: onStepClick,
            showDescription: showDescription,
            stepIndex: stepIndex,
            isPriorStep: isPriorStep,
            isAfterStep: isAfterStep,
            isCurrentStep: isCurrentStep,
            canNavigateTo: canNavigateTo
        };
    }, [
        effectiveCurrentStep,
        flatSteps,
        direction,
        clickableSteps,
        onStepClick,
        showDescription,
        stepIndex,
        isPriorStep,
        isAfterStep,
        isCurrentStep,
        canNavigateTo
    ]);
    // Wraps around the step list to find the next step
    // in the given direction (+1 forward, -1 backward).
    var findNextEnabledIndex = (0, $78e955b4419149e8$var$_react.useCallback)(function(startIndex, delta) {
        return (startIndex + delta + flatStepsLength) % flatStepsLength;
    }, [
        flatStepsLength
    ]);
    var findFirstEnabledIndex = (0, $78e955b4419149e8$var$_react.useCallback)(function() {
        return 0;
    }, []);
    var findLastEnabledIndex = (0, $78e955b4419149e8$var$_react.useCallback)(function() {
        return flatStepsLength - 1;
    }, [
        flatStepsLength
    ]);
    var moveFocus = (0, $78e955b4419149e8$var$_react.useCallback)(function(nextIndex) {
        if (nextIndex !== undefined && nextIndex !== focusedIndexRef.current) {
            updateFocusedIndex(nextIndex);
            var nextButton = stepRefs.current.get(nextIndex);
            if (nextButton) nextButton.focus();
        }
    }, [
        updateFocusedIndex
    ]);
    var onNext = (0, $78e955b4419149e8$var$_react.useCallback)(function() {
        moveFocus(findNextEnabledIndex(focusedIndexRef.current, 1));
    }, [
        findNextEnabledIndex,
        moveFocus
    ]);
    var onPrevious = (0, $78e955b4419149e8$var$_react.useCallback)(function() {
        moveFocus(findNextEnabledIndex(focusedIndexRef.current, -1));
    }, [
        findNextEnabledIndex,
        moveFocus
    ]);
    var handleKeyDown = (0, $78e955b4419149e8$var$_react.useCallback)(function(event) {
        var isHorizontal = direction === 'horizontal';
        switch(event.key){
            case 'ArrowRight':
                if (isHorizontal) {
                    event.preventDefault();
                    onNext();
                }
                break;
            case 'ArrowLeft':
                if (isHorizontal) {
                    event.preventDefault();
                    onPrevious();
                }
                break;
            case 'ArrowDown':
                if (!isHorizontal) {
                    event.preventDefault();
                    onNext();
                }
                break;
            case 'ArrowUp':
                if (!isHorizontal) {
                    event.preventDefault();
                    onPrevious();
                }
                break;
            case 'Home':
                event.preventDefault();
                moveFocus(findFirstEnabledIndex());
                break;
            case 'End':
                event.preventDefault();
                moveFocus(findLastEnabledIndex());
                break;
            default:
                break;
        }
    }, [
        direction,
        onNext,
        onPrevious,
        findFirstEnabledIndex,
        findLastEnabledIndex,
        moveFocus
    ]);
    var renderDefaultSteps = function renderDefaultSteps() {
        var flatIndex = 0;
        var elements = [];
        steps.forEach(function(step, parentIdx) {
            var parentFlatIndex = flatIndex;
            flatIndex += 1;
            var childElements = step.children ? step.children.map(function(child) {
                var childFlatIndex = flatIndex;
                flatIndex += 1;
                return /*#__PURE__*/ $78e955b4419149e8$var$_react["default"].createElement($62cda09aed2b62ae$export$4ea00516583c5adc, {
                    key: child.id,
                    step: child,
                    stepNumber: childFlatIndex + 1,
                    isLast: false,
                    showConnector: false,
                    direction: direction,
                    focusedIndex: focusedIndex,
                    index: childFlatIndex,
                    isSubStep: true,
                    onFocusStep: updateFocusedIndex,
                    stepsRef: stepsRef,
                    stepRefs: stepRefs
                });
            }) : null;
            var isLastParent = parentIdx === steps.length - 1;
            elements.push(/*#__PURE__*/ $78e955b4419149e8$var$_react["default"].createElement($62cda09aed2b62ae$export$4ea00516583c5adc, {
                key: step.id,
                step: step,
                stepNumber: parentFlatIndex + 1,
                isLast: isLastParent,
                showConnector: direction === 'horizontal' ? false : !isLastParent || !!childElements,
                direction: direction,
                focusedIndex: focusedIndex,
                index: parentFlatIndex,
                isSubStep: false,
                onFocusStep: updateFocusedIndex,
                stepsRef: stepsRef,
                stepRefs: stepRefs
            }));
            if (!isLastParent || childElements && direction === 'vertical') elements.push(/*#__PURE__*/ $78e955b4419149e8$var$_react["default"].createElement($fb5dc6bad0dc9418$export$4a156f5690e82b42, {
                key: step.id + "-connector",
                step: step,
                direction: direction
            }, childElements));
        });
        return elements;
    };
    var stepperContent = /*#__PURE__*/ $78e955b4419149e8$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $78e955b4419149e8$var$_extends({
        ref: ref,
        as: "ol",
        "aria-label": ariaLabel || format({
            id: 'stepper.progress'
        }),
        direction: direction === 'horizontal' ? 'row' : 'column',
        fill: direction,
        id: id,
        overflow: "hidden",
        pad: "none",
        margin: "none",
        style: {
            listStyle: 'none'
        }
    }, rest), children || renderDefaultSteps());
    return /*#__PURE__*/ $78e955b4419149e8$var$_react["default"].createElement($4258e558ff024eeb$export$91b1e15bb76ddaff.Provider, {
        value: contextValue
    }, clickableSteps ? /*#__PURE__*/ $78e955b4419149e8$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onKeyDown: handleKeyDown
    }, stepperContent) : stepperContent);
});
$78e955b4419149e8$var$Stepper.displayName = 'Stepper';
$78e955b4419149e8$var$Stepper.propTypes = $f32cf71659a5268b$export$f60f1a94f0808dc5;


$e22b15673b435f55$export$ed8ca599049e8881 = $78e955b4419149e8$export$ed8ca599049e8881;

$e22b15673b435f55$export$91b1e15bb76ddaff = $4258e558ff024eeb$export$91b1e15bb76ddaff;
$e22b15673b435f55$export$9378619b14945e16 = $4258e558ff024eeb$export$9378619b14945e16;

$e22b15673b435f55$export$d3ab37ba13a08390 = $5bc6dd4e98119d18$export$d3ab37ba13a08390;

$e22b15673b435f55$export$f0e13176f06b1b53 = $96ed6f1a730fef47$export$f0e13176f06b1b53;

$e22b15673b435f55$export$f885210784698446 = $f04cc273b756b918$export$f885210784698446;

$e22b15673b435f55$export$482b3904ab0152e7 = $4048475bf089fb53$export$482b3904ab0152e7;
$e22b15673b435f55$export$6ebc62bc3521fc7 = $4048475bf089fb53$export$6ebc62bc3521fc7;


Object.keys($e22b15673b435f55$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $e22b15673b435f55$exports[key]) return;
    $3321243da0932e1e$exports[key] = $e22b15673b435f55$exports[key];
});

Object.keys($d18144d9f1ced4c1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $d18144d9f1ced4c1$exports[key]) return;
    $3321243da0932e1e$exports[key] = $d18144d9f1ced4c1$exports[key];
});

Object.keys($e3081fd3bb82ce0d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $e3081fd3bb82ce0d$exports[key]) return;
    $3321243da0932e1e$exports[key] = $e3081fd3bb82ce0d$exports[key];
});

Object.keys($5501e7a1e1340982$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $5501e7a1e1340982$exports[key]) return;
    $3321243da0932e1e$exports[key] = $5501e7a1e1340982$exports[key];
});

Object.keys($b2b0be68b7012347$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $b2b0be68b7012347$exports[key]) return;
    $3321243da0932e1e$exports[key] = $b2b0be68b7012347$exports[key];
});

Object.keys($2a5ab6af3c2b6348$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $2a5ab6af3c2b6348$exports[key]) return;
    $3321243da0932e1e$exports[key] = $2a5ab6af3c2b6348$exports[key];
});

Object.keys($769e29b5528bbd43$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $769e29b5528bbd43$exports[key]) return;
    $3321243da0932e1e$exports[key] = $769e29b5528bbd43$exports[key];
});

Object.keys($acdc1459df0949e1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $acdc1459df0949e1$exports[key]) return;
    $3321243da0932e1e$exports[key] = $acdc1459df0949e1$exports[key];
});

Object.keys($fc47d46c0f08e384$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $fc47d46c0f08e384$exports[key]) return;
    $3321243da0932e1e$exports[key] = $fc47d46c0f08e384$exports[key];
});
var $5485c1ccfe640b1a$exports = {};

$parcel$export($5485c1ccfe640b1a$exports, "__esModule", function () { return $5485c1ccfe640b1a$export$1e511d4a378977f5; }, function (v) { return $5485c1ccfe640b1a$export$1e511d4a378977f5 = v; });
$parcel$export($5485c1ccfe640b1a$exports, "Tag", function () { return $5485c1ccfe640b1a$export$3288d34c523a1192; }, function (v) { return $5485c1ccfe640b1a$export$3288d34c523a1192 = v; });
var $5485c1ccfe640b1a$export$1e511d4a378977f5;
var $5485c1ccfe640b1a$export$3288d34c523a1192;
"use strict";
$5485c1ccfe640b1a$export$1e511d4a378977f5 = true;
$5485c1ccfe640b1a$export$3288d34c523a1192 = void 0;
var $f3017d333869ac22$export$1e511d4a378977f5;
var $f3017d333869ac22$export$3288d34c523a1192;
"use strict";
$f3017d333869ac22$export$1e511d4a378977f5 = true;
$f3017d333869ac22$export$3288d34c523a1192 = void 0;

var $f3017d333869ac22$var$_react = $f3017d333869ac22$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $785f1e81b72b86d2$export$1e511d4a378977f5;
var $785f1e81b72b86d2$export$8ec997bafd1b7980;
"use strict";
$785f1e81b72b86d2$export$1e511d4a378977f5 = true;
$785f1e81b72b86d2$export$8ec997bafd1b7980 = void 0;

var $785f1e81b72b86d2$var$_propTypes = $785f1e81b72b86d2$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $785f1e81b72b86d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $785f1e81b72b86d2$var$PropType = {};
$785f1e81b72b86d2$var$PropType = {
    children: $785f1e81b72b86d2$var$_propTypes["default"].node,
    name: $785f1e81b72b86d2$var$_propTypes["default"].oneOfType([
        $785f1e81b72b86d2$var$_propTypes["default"].node,
        $785f1e81b72b86d2$var$_propTypes["default"].string
    ]),
    value: $785f1e81b72b86d2$var$_propTypes["default"].oneOfType([
        $785f1e81b72b86d2$var$_propTypes["default"].node,
        $785f1e81b72b86d2$var$_propTypes["default"].string
    ]),
    onClick: $785f1e81b72b86d2$var$_propTypes["default"].func,
    onRemove: $785f1e81b72b86d2$var$_propTypes["default"].func,
    messages: $785f1e81b72b86d2$var$_propTypes["default"].shape({
        removeLabel: $785f1e81b72b86d2$var$_propTypes["default"].shape({
            nameAndValue: $785f1e81b72b86d2$var$_propTypes["default"].string,
            valueOnly: $785f1e81b72b86d2$var$_propTypes["default"].string
        })
    }),
    size: $785f1e81b72b86d2$var$_propTypes["default"].oneOfType([
        $785f1e81b72b86d2$var$_propTypes["default"].oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        $785f1e81b72b86d2$var$_propTypes["default"].string
    ])
};
var $785f1e81b72b86d2$var$TagPropTypes = $785f1e81b72b86d2$export$8ec997bafd1b7980 = $785f1e81b72b86d2$var$PropType;




var $5b92d56f04de6f85$export$1e511d4a378977f5;
var $5b92d56f04de6f85$export$14c8f6b8244084e9;
var $5b92d56f04de6f85$export$9f066111f6024136;
"use strict";
$5b92d56f04de6f85$export$1e511d4a378977f5 = true;
$5b92d56f04de6f85$export$14c8f6b8244084e9 = $5b92d56f04de6f85$export$9f066111f6024136 = void 0;

var $5b92d56f04de6f85$var$_styledComponents = $5b92d56f04de6f85$var$_interopRequireDefault((parcelRequire("iA1nz")));


function $5b92d56f04de6f85$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $5b92d56f04de6f85$var$StyledTagButton = $5b92d56f04de6f85$export$14c8f6b8244084e9 = (0, $5b92d56f04de6f85$var$_styledComponents["default"])($fb68f765668b25d0$export$353f5b6fc5456de1).withConfig({
    displayName: "StyledTag__StyledTagButton",
    componentId: "sc-cb9fl2-0"
})([
    "",
    " ",
    " ",
    " &:hover{",
    " ",
    "}"
], function(props) {
    return props.background && (0, $4113023f9e0bafa0$exports.backgroundStyle)(props.background, props.theme);
}, function(props) {
    return props.border && (0, $4113023f9e0bafa0$exports.borderStyle)(props.border, true, props.theme);
}, function(props) {
    return props.round && (0, $4113023f9e0bafa0$exports.roundStyle)(props.round, true, props.theme);
}, function(props) {
    var _props$theme;
    return props.background && props.onClick && ((_props$theme = props.theme) == null || (_props$theme = _props$theme.tag) == null || (_props$theme = _props$theme.hover) == null ? void 0 : _props$theme.background) && (0, $4113023f9e0bafa0$exports.backgroundStyle)(props.theme.tag.hover.background, props.theme);
}, function(props) {
    var _props$theme2;
    return props.border && props.onClick && ((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.tag) == null || (_props$theme2 = _props$theme2.hover) == null ? void 0 : _props$theme2.border) && (0, $4113023f9e0bafa0$exports.borderStyle)(props.theme.tag.hover.border, true, props.theme);
});
var $5b92d56f04de6f85$var$StyledRemoveButton = $5b92d56f04de6f85$export$9f066111f6024136 = (0, $5b92d56f04de6f85$var$_styledComponents["default"])($fb68f765668b25d0$export$353f5b6fc5456de1).withConfig({
    displayName: "StyledTag__StyledRemoveButton",
    componentId: "sc-cb9fl2-1"
})([
    "",
    ""
], function(props) {
    return props.round && (0, $4113023f9e0bafa0$exports.roundStyle)(props.round, true, props.theme);
});




var $f3017d333869ac22$var$_excluded = [
    "children",
    "name",
    "value",
    "size",
    "onRemove",
    "onClick",
    "messages"
];
function $f3017d333869ac22$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($f3017d333869ac22$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $f3017d333869ac22$var$_extends() {
    return $f3017d333869ac22$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f3017d333869ac22$var$_extends.apply(null, arguments);
}
function $f3017d333869ac22$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $f3017d333869ac22$var$Tag = $f3017d333869ac22$export$3288d34c523a1192 = /*#__PURE__*/ (0, $f3017d333869ac22$var$_react.forwardRef)(function(_ref, ref) {
    var _theme$tag$icons, _theme$tag$size, _theme$tag$size2, _theme$tag$size3, _theme$tag$size4, _theme$tag$size5;
    var children = _ref.children, name = _ref.name, value = _ref.value, _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, onRemove = _ref.onRemove, onClick = _ref.onClick, messages = _ref.messages, rest = $f3017d333869ac22$var$_objectWithoutPropertiesLoose(_ref, $f3017d333869ac22$var$_excluded);
    var _useContext = (0, $f3017d333869ac22$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var RemoveIcon = ((_theme$tag$icons = theme.tag.icons) == null ? void 0 : _theme$tag$icons.remove) || $da76b8daacd39c4f$export$fe20cfcdd41aa0ef;
    var removeLabelId = name ? 'tag.removeLabel.nameAndValue' : 'tag.removeLabel.valueOnly';
    var removeLabel = format({
        id: removeLabelId,
        messages: messages,
        values: {
            name: name,
            value: value
        }
    });
    var containerProps = $f3017d333869ac22$var$_extends({
        ref: ref,
        align: 'center',
        background: theme.tag.background,
        border: theme.tag.border,
        round: ((_theme$tag$size = theme.tag.size) == null || (_theme$tag$size = _theme$tag$size[size]) == null ? void 0 : _theme$tag$size.round) || theme.tag.round
    }, rest);
    var contents = children || /*#__PURE__*/ $f3017d333869ac22$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        width: {
            min: 'min-content'
        },
        pad: ((_theme$tag$size2 = theme.tag.size) == null || (_theme$tag$size2 = _theme$tag$size2[size]) == null ? void 0 : _theme$tag$size2.pad) || theme.tag.pad
    }, /*#__PURE__*/ $f3017d333869ac22$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, {
        size: size
    }, name && /*#__PURE__*/ $f3017d333869ac22$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, $f3017d333869ac22$var$_extends({}, theme.tag.name, {
        size: size
    }), ' ', name), name && value ? /*#__PURE__*/ $f3017d333869ac22$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, {
        size: size
    }, theme.tag.separator) : '', value && /*#__PURE__*/ $f3017d333869ac22$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, $f3017d333869ac22$var$_extends({}, theme.tag.value, {
        size: size
    }), value)));
    if (onClick && onRemove) console.warn('Tag cannot combine "onClick" and "onRemove".');
    var removeProps = !theme.tag.remove.kind ? {
        plain: true,
        hoverIndicator: true,
        focusIndicator: true
    } : {};
    return onRemove || !onClick ? /*#__PURE__*/ $f3017d333869ac22$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, $f3017d333869ac22$var$_extends({
        flex: false,
        direction: "row",
        width: {
            min: 'min-content'
        }
    }, containerProps), contents, onRemove && /*#__PURE__*/ $f3017d333869ac22$var$_react["default"].createElement($5b92d56f04de6f85$export$9f066111f6024136, $f3017d333869ac22$var$_extends({
        onClick: onRemove
    }, removeProps, {
        "aria-label": removeLabel,
        icon: /*#__PURE__*/ $f3017d333869ac22$var$_react["default"].createElement(RemoveIcon, (_theme$tag$size3 = theme.tag.size) == null || (_theme$tag$size3 = _theme$tag$size3[size]) == null ? void 0 : _theme$tag$size3.icon),
        round: ((_theme$tag$size4 = theme.tag.size) == null || (_theme$tag$size4 = _theme$tag$size4[size]) == null ? void 0 : _theme$tag$size4.round) || theme.tag.round
    }, theme.tag.remove, (_theme$tag$size5 = theme.tag.size) == null || (_theme$tag$size5 = _theme$tag$size5[size]) == null ? void 0 : _theme$tag$size5.remove, passThemeFlag))) : /*#__PURE__*/ $f3017d333869ac22$var$_react["default"].createElement($5b92d56f04de6f85$export$14c8f6b8244084e9, $f3017d333869ac22$var$_extends({
        flex: false,
        plain: true,
        onClick: onClick,
        hoverIndicator: true,
        focusIndicator: true
    }, containerProps, passThemeFlag), contents);
});
$f3017d333869ac22$var$Tag.displayName = 'Tag';
$f3017d333869ac22$var$Tag.prototype = $785f1e81b72b86d2$export$8ec997bafd1b7980;


$5485c1ccfe640b1a$export$3288d34c523a1192 = $f3017d333869ac22$export$3288d34c523a1192;


Object.keys($5485c1ccfe640b1a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $5485c1ccfe640b1a$exports[key]) return;
    $3321243da0932e1e$exports[key] = $5485c1ccfe640b1a$exports[key];
});

Object.keys($2f0b7ad0e7a4866d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $2f0b7ad0e7a4866d$exports[key]) return;
    $3321243da0932e1e$exports[key] = $2f0b7ad0e7a4866d$exports[key];
});
var $34c17d9e51c8a972$exports = {};

$parcel$export($34c17d9e51c8a972$exports, "__esModule", function () { return $34c17d9e51c8a972$export$1e511d4a378977f5; }, function (v) { return $34c17d9e51c8a972$export$1e511d4a378977f5 = v; });
$parcel$export($34c17d9e51c8a972$exports, "TextArea", function () { return $34c17d9e51c8a972$export$f5c9f3c2c4054eec; }, function (v) { return $34c17d9e51c8a972$export$f5c9f3c2c4054eec = v; });
var $34c17d9e51c8a972$export$1e511d4a378977f5;
var $34c17d9e51c8a972$export$f5c9f3c2c4054eec;
"use strict";
$34c17d9e51c8a972$export$1e511d4a378977f5 = true;
$34c17d9e51c8a972$export$f5c9f3c2c4054eec = void 0;
var $15edfcc3beb71fa0$export$1e511d4a378977f5;
var $15edfcc3beb71fa0$export$f5c9f3c2c4054eec;
"use strict";
$15edfcc3beb71fa0$export$1e511d4a378977f5 = true;
$15edfcc3beb71fa0$export$f5c9f3c2c4054eec = void 0;

var $15edfcc3beb71fa0$var$_react = $15edfcc3beb71fa0$var$_interopRequireWildcard((parcelRequire("2xPiy")));


var $33d594a959826bf7$export$1e511d4a378977f5;
var $33d594a959826bf7$export$e93364aaaa97e46f;
"use strict";
$33d594a959826bf7$export$1e511d4a378977f5 = true;
$33d594a959826bf7$export$e93364aaaa97e46f = void 0;

var $33d594a959826bf7$var$_styledComponents = $33d594a959826bf7$var$_interopRequireWildcard((parcelRequire("iA1nz")));

function $33d594a959826bf7$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($33d594a959826bf7$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $33d594a959826bf7$var$plainStyle = (0, $33d594a959826bf7$var$_styledComponents.css)([
    "outline:none;border:none;width:100%;-webkit-appearance:none;"
]);
var $33d594a959826bf7$var$resizeStyle = function resizeStyle(resize) {
    if (resize === 'horizontal') return 'resize: horizontal;';
    if (resize === 'vertical') return 'resize: vertical;';
    if (resize) return 'resize: both;';
    return 'resize: none;';
};
var $33d594a959826bf7$var$StyledTextArea = $33d594a959826bf7$export$e93364aaaa97e46f = $33d594a959826bf7$var$_styledComponents["default"].textarea.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledTextArea",
    componentId: "sc-17i3mwp-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    " ",
    ";max-width:100%;"
], $4113023f9e0bafa0$exports.inputStyle, function(props) {
    return props.resize !== undefined && $33d594a959826bf7$var$resizeStyle(props.resize);
}, function(props) {
    return props.fillArg && 'height: 100%;';
}, function(props) {
    return props.plain && $33d594a959826bf7$var$plainStyle;
}, function(props) {
    return props.disabled && (0, $4113023f9e0bafa0$exports.disabledStyle)(props.theme.textArea.disabled && props.theme.textArea.disabled.opacity);
}, function(props) {
    return props.theme.textArea && props.theme.textArea.extend;
});


var $4696fc481825bda7$export$1e511d4a378977f5;
var $4696fc481825bda7$export$84f313a0fe939ad2;
"use strict";
$4696fc481825bda7$export$1e511d4a378977f5 = true;
$4696fc481825bda7$export$84f313a0fe939ad2 = void 0;

var $4696fc481825bda7$var$_propTypes = $4696fc481825bda7$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $4696fc481825bda7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $4696fc481825bda7$var$PropType = {};
$4696fc481825bda7$var$PropType = {
    a11yTitle: $4696fc481825bda7$var$_propTypes["default"].string,
    id: $4696fc481825bda7$var$_propTypes["default"].string,
    fill: $4696fc481825bda7$var$_propTypes["default"].bool,
    focusIndicator: $4696fc481825bda7$var$_propTypes["default"].bool,
    name: $4696fc481825bda7$var$_propTypes["default"].string,
    onChange: $4696fc481825bda7$var$_propTypes["default"].func,
    placeholder: $4696fc481825bda7$var$_propTypes["default"].string,
    plain: $4696fc481825bda7$var$_propTypes["default"].bool,
    value: $4696fc481825bda7$var$_propTypes["default"].string,
    resize: $4696fc481825bda7$var$_propTypes["default"].oneOfType([
        $4696fc481825bda7$var$_propTypes["default"].oneOf([
            'vertical',
            'horizontal'
        ]),
        $4696fc481825bda7$var$_propTypes["default"].bool
    ]),
    size: $4696fc481825bda7$var$_propTypes["default"].oneOfType([
        $4696fc481825bda7$var$_propTypes["default"].oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            'xxlarge',
            '2xl',
            '3xl',
            '4xl',
            '5xl',
            '6xl'
        ]),
        $4696fc481825bda7$var$_propTypes["default"].string
    ])
};
var $4696fc481825bda7$var$TextAreaPropTypes = $4696fc481825bda7$export$84f313a0fe939ad2 = $4696fc481825bda7$var$PropType;



var $15edfcc3beb71fa0$var$_excluded = [
    "a11yTitle",
    "fill",
    "focusIndicator",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onKeyDown",
    "value"
];
function $15edfcc3beb71fa0$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($15edfcc3beb71fa0$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $15edfcc3beb71fa0$var$_extends() {
    return $15edfcc3beb71fa0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $15edfcc3beb71fa0$var$_extends.apply(null, arguments);
}
function $15edfcc3beb71fa0$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $15edfcc3beb71fa0$var$TextArea = $15edfcc3beb71fa0$export$f5c9f3c2c4054eec = /*#__PURE__*/ (0, $15edfcc3beb71fa0$var$_react.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, fill = _ref.fill, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, name = _ref.name, _onBlur = _ref.onBlur, _onChange = _ref.onChange, _onFocus = _ref.onFocus, onKeyDown = _ref.onKeyDown, valueProp = _ref.value, rest = $15edfcc3beb71fa0$var$_objectWithoutPropertiesLoose(_ref, $15edfcc3beb71fa0$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var formContext = (0, $15edfcc3beb71fa0$var$_react.useContext)($5c9c2e034f522b3e$export$c24727297075ec6a);
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    var _useState = (0, $15edfcc3beb71fa0$var$_react.useState)(), focus = _useState[0], setFocus = _useState[1];
    return /*#__PURE__*/ $15edfcc3beb71fa0$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onEsc: function onEsc(event) {
            // we have to stop both synthetic events and native events
            // drop and layer should not close by pressing esc on this input
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();
        },
        onKeyDown: onKeyDown
    }, /*#__PURE__*/ $15edfcc3beb71fa0$var$_react["default"].createElement($33d594a959826bf7$export$e93364aaaa97e46f, $15edfcc3beb71fa0$var$_extends({
        "aria-label": a11yTitle,
        ref: ref,
        name: name,
        fillArg: fill,
        focus: focus,
        value: value,
        focusIndicator: focusIndicator
    }, passThemeFlag, rest, {
        onFocus: function onFocus(event) {
            setFocus(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        onChange: function onChange(event) {
            setValue(event.target.value);
            if (_onChange) _onChange(event);
        }
    })));
});
$15edfcc3beb71fa0$var$TextArea.displayName = 'TextArea';
$15edfcc3beb71fa0$var$TextArea.propTypes = $4696fc481825bda7$export$84f313a0fe939ad2;


$34c17d9e51c8a972$export$f5c9f3c2c4054eec = $15edfcc3beb71fa0$export$f5c9f3c2c4054eec;


Object.keys($34c17d9e51c8a972$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $34c17d9e51c8a972$exports[key]) return;
    $3321243da0932e1e$exports[key] = $34c17d9e51c8a972$exports[key];
});

Object.keys($99c7a15bc083da62$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $99c7a15bc083da62$exports[key]) return;
    $3321243da0932e1e$exports[key] = $99c7a15bc083da62$exports[key];
});
var $3b61805c70340a15$exports = {};

$parcel$export($3b61805c70340a15$exports, "__esModule", function () { return $3b61805c70340a15$export$1e511d4a378977f5; }, function (v) { return $3b61805c70340a15$export$1e511d4a378977f5 = v; });
$parcel$export($3b61805c70340a15$exports, "TimeInput", function () { return $3b61805c70340a15$export$a1af6f79df847fac; }, function (v) { return $3b61805c70340a15$export$a1af6f79df847fac = v; });
var $3b61805c70340a15$export$1e511d4a378977f5;
var $3b61805c70340a15$export$a1af6f79df847fac;
"use strict";
$3b61805c70340a15$export$1e511d4a378977f5 = true;
$3b61805c70340a15$export$a1af6f79df847fac = void 0;
var $b8135998a0253aa7$export$1e511d4a378977f5;
var $b8135998a0253aa7$export$a1af6f79df847fac;
"use strict";
$b8135998a0253aa7$export$1e511d4a378977f5 = true;
$b8135998a0253aa7$export$a1af6f79df847fac = void 0;

var $b8135998a0253aa7$var$_react = $b8135998a0253aa7$var$_interopRequireWildcard((parcelRequire("2xPiy")));
var $4f80ce31f1e76523$exports = {};

$parcel$export($4f80ce31f1e76523$exports, "__esModule", function () { return $4f80ce31f1e76523$export$1e511d4a378977f5; }, function (v) { return $4f80ce31f1e76523$export$1e511d4a378977f5 = v; });
$parcel$export($4f80ce31f1e76523$exports, "Clock", function () { return $4f80ce31f1e76523$export$9735c82c4bae3302; }, function (v) { return $4f80ce31f1e76523$export$9735c82c4bae3302 = v; });
var $4f80ce31f1e76523$export$1e511d4a378977f5;
var $4f80ce31f1e76523$export$9735c82c4bae3302;
"use strict";
$4f80ce31f1e76523$export$1e511d4a378977f5 = true;
$4f80ce31f1e76523$export$9735c82c4bae3302 = void 0;

var $4f80ce31f1e76523$var$_react = $4f80ce31f1e76523$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $4f80ce31f1e76523$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4f80ce31f1e76523$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4f80ce31f1e76523$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $4f80ce31f1e76523$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $4f80ce31f1e76523$var$_extends() {
    return $4f80ce31f1e76523$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4f80ce31f1e76523$var$_extends.apply(null, arguments);
}
var $4f80ce31f1e76523$var$Clock = $4f80ce31f1e76523$export$9735c82c4bae3302 = /*#__PURE__*/ (0, $4f80ce31f1e76523$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $4f80ce31f1e76523$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $4f80ce31f1e76523$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Clock"
    }, props), /*#__PURE__*/ $4f80ce31f1e76523$var$_react["default"].createElement("path", {
        fill: "#000",
        d: "M13 7a1 1 0 1 0-2 0v5a1 1 0 0 0 .4.8l4 3a1 1 0 0 0 1.2-1.6L13 11.5V7z"
    }), /*#__PURE__*/ $4f80ce31f1e76523$var$_react["default"].createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0z",
        clipRule: "evenodd"
    }));
});
$4f80ce31f1e76523$var$Clock.displayName = 'Clock';










var $d48a672a2914e6a7$export$1e511d4a378977f5;
var $d48a672a2914e6a7$export$f8cc05fed0b0cc88;
var $d48a672a2914e6a7$export$e9cf87fca52843bc;
var $d48a672a2914e6a7$export$32ae72a65688ceb0;
var $d48a672a2914e6a7$export$99f3a58a09dbdbb6;
var $d48a672a2914e6a7$export$deb3bb5233490f02;
var $d48a672a2914e6a7$export$1f156eb46da7cdfb;
"use strict";
$d48a672a2914e6a7$export$1e511d4a378977f5 = true;
$d48a672a2914e6a7$export$f8cc05fed0b0cc88 = $d48a672a2914e6a7$export$e9cf87fca52843bc = $d48a672a2914e6a7$export$32ae72a65688ceb0 = $d48a672a2914e6a7$export$99f3a58a09dbdbb6 = $d48a672a2914e6a7$export$deb3bb5233490f02 = $d48a672a2914e6a7$export$1f156eb46da7cdfb = void 0;

var $d48a672a2914e6a7$var$_styledComponents = $d48a672a2914e6a7$var$_interopRequireWildcard((parcelRequire("iA1nz")));


function $d48a672a2914e6a7$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($d48a672a2914e6a7$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $d48a672a2914e6a7$var$StyledTimeInputContainer = $d48a672a2914e6a7$export$deb3bb5233490f02 = (0, $d48a672a2914e6a7$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    // Keep Box styling props like border and round flowing into Box.
    shouldForwardProp: function shouldForwardProp(prop) {
        return prop !== 'disabled' && prop !== 'readOnlyProp';
    }
}).withConfig({
    displayName: "StyledTimeInput__StyledTimeInputContainer",
    componentId: "sc-xktdr3-0"
})([
    "",
    " ",
    " ",
    ""
], function(props) {
    return props.disabled && (0, $4113023f9e0bafa0$exports.disabledStyle)();
}, function(props) {
    return props.readOnlyProp && (0, $4113023f9e0bafa0$exports.readOnlyStyle)(props.theme);
}, function(props) {
    return props.focusIndicator !== false && (0, $d48a672a2914e6a7$var$_styledComponents.css)([
        "&:focus-within{",
        "}"
    ], (0, $4113023f9e0bafa0$exports.focusStyle)());
});
var $d48a672a2914e6a7$var$StyledTimeInput = $d48a672a2914e6a7$export$1f156eb46da7cdfb = $d48a672a2914e6a7$var$_styledComponents["default"].input.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledTimeInput",
    componentId: "sc-xktdr3-1"
})([
    "",
    " ",
    " position:relative;pointer-events:none;color:transparent;caret-color:transparent;text-shadow:none;&::selection{background:transparent;color:transparent;}&::placeholder{color:transparent;}"
], $4113023f9e0bafa0$exports.inputStyle, $4113023f9e0bafa0$exports.plainInputStyle);
var $d48a672a2914e6a7$var$StyledTimeInputField = $d48a672a2914e6a7$export$32ae72a65688ceb0 = $d48a672a2914e6a7$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledTimeInput__StyledTimeInputField",
    componentId: "sc-xktdr3-2"
})([
    "position:relative;flex:1 1 auto;min-width:0;"
]);
var $d48a672a2914e6a7$var$StyledTimeInputDisplay = $d48a672a2914e6a7$export$99f3a58a09dbdbb6 = $d48a672a2914e6a7$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledTimeInput__StyledTimeInputDisplay",
    componentId: "sc-xktdr3-3"
})([
    "position:absolute;inset:0;display:flex;align-items:center;overflow:hidden;",
    ""
], function(props) {
    return props.theme.global.input.padding && (typeof props.theme.global.input.padding !== 'object' ? "padding: " + ((0, $4113023f9e0bafa0$exports.parseMetricToNum)(props.theme.global.edgeSize[props.theme.global.input.padding] || props.theme.global.input.padding) - (0, $4113023f9e0bafa0$exports.parseMetricToNum)(props.theme.global.control.border.width)) + "px;" : (0, $4113023f9e0bafa0$exports.edgeStyle)('padding', props.theme.global.input.padding, props.responsive, props.theme.box.responsiveBreakpoint, props.theme));
});
var $d48a672a2914e6a7$var$StyledTimeInputSeparator = $d48a672a2914e6a7$export$f8cc05fed0b0cc88 = $d48a672a2914e6a7$var$_styledComponents["default"].span.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledTimeInput__StyledTimeInputSeparator",
    componentId: "sc-xktdr3-4"
})([
    "display:inline-flex;align-items:center;line-height:inherit;color:",
    ";",
    ""
], function(props) {
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(props.$filled ? 'text' : props.theme.global.colors.placeholder, props.theme);
}, function(props) {
    var weight = props.theme.global.input.weight || props.theme.global.input.font.weight;
    return weight && "font-weight: " + weight + ";";
});
var $d48a672a2914e6a7$var$StyledTimeInputSegment = $d48a672a2914e6a7$export$e9cf87fca52843bc = $d48a672a2914e6a7$var$_styledComponents["default"].span.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledTimeInput__StyledTimeInputSegment",
    componentId: "sc-xktdr3-5"
})([
    "&:focus{outline:none;}display:inline-flex;align-items:center;position:relative;line-height:inherit;padding-inline:",
    ";color:",
    ";",
    " ",
    ""
], function(props) {
    var _props$theme$timeInpu, _props$theme$global$e;
    var padToken = (_props$theme$timeInpu = props.theme.timeInput) == null || (_props$theme$timeInpu = _props$theme$timeInpu.active) == null ? void 0 : _props$theme$timeInpu.pad;
    return ((_props$theme$global$e = props.theme.global.edgeSize) == null ? void 0 : _props$theme$global$e[padToken]) || padToken;
}, function(props) {
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(props.$filled ? 'text' : props.theme.global.colors.placeholder, props.theme);
}, function(props) {
    var weight = props.theme.global.input.weight || props.theme.global.input.font.weight;
    return weight && "font-weight: " + weight + ";";
}, function(props) {
    var _props$theme$global$e2, _props$theme$timeInpu2, _props$theme$global$b, _props$theme$global$e3, _props$theme$timeInpu3, _props$theme$timeInpu4;
    if (!props.$active) return '';
    // The active indicator's corner rounding is intentionally a fixed
    // "hair" edge size rather than a theme-exposed value we can expose
    // theme in future.
    var activeRound = (_props$theme$global$e2 = props.theme.global.edgeSize) == null ? void 0 : _props$theme$global$e2.hair;
    var activeBorderToken = (_props$theme$timeInpu2 = props.theme.timeInput) == null || (_props$theme$timeInpu2 = _props$theme$timeInpu2.active) == null || (_props$theme$timeInpu2 = _props$theme$timeInpu2.indicator) == null ? void 0 : _props$theme$timeInpu2.size;
    var activeBorderSize = ((_props$theme$global$b = props.theme.global.borderSize) == null ? void 0 : _props$theme$global$b[activeBorderToken]) || ((_props$theme$global$e3 = props.theme.global.edgeSize) == null ? void 0 : _props$theme$global$e3[activeBorderToken]) || activeBorderToken || props.theme.global.borderSize.small;
    return (0, $d48a672a2914e6a7$var$_styledComponents.css)([
        "&::before{content:'';position:absolute;inset:0;background-color:",
        ";border-top-left-radius:",
        ";border-top-right-radius:",
        ";}&::after{content:'';position:absolute;left:0;right:0;bottom:0;height:",
        ";background-color:",
        ";border-bottom-left-radius:",
        ";border-bottom-right-radius:",
        ";}"
    ], (0, $4113023f9e0bafa0$exports.normalizeColor)((_props$theme$timeInpu3 = props.theme.timeInput) == null || (_props$theme$timeInpu3 = _props$theme$timeInpu3.active) == null ? void 0 : _props$theme$timeInpu3.background, props.theme), activeRound, activeRound, activeBorderSize, (0, $4113023f9e0bafa0$exports.normalizeColor)(((_props$theme$timeInpu4 = props.theme.timeInput) == null || (_props$theme$timeInpu4 = _props$theme$timeInpu4.active) == null || (_props$theme$timeInpu4 = _props$theme$timeInpu4.indicator) == null ? void 0 : _props$theme$timeInpu4.color) || {
        dark: 'white',
        light: 'black'
    }, props.theme), activeRound, activeRound);
});


var $5d72290af5be4136$export$1e511d4a378977f5;
var $5d72290af5be4136$export$876ed7c9dcced57f;
"use strict";
$5d72290af5be4136$export$1e511d4a378977f5 = true;
$5d72290af5be4136$export$876ed7c9dcced57f = void 0;

var $5d72290af5be4136$var$_react = $5d72290af5be4136$var$_interopRequireWildcard((parcelRequire("2xPiy")));

var $5d72290af5be4136$var$_styledComponents = $5d72290af5be4136$var$_interopRequireDefault((parcelRequire("iA1nz")));






var $d4924d95c555d37f$export$1e511d4a378977f5;
var $d4924d95c555d37f$export$ad2b8f0ca25d63d3;
var $d4924d95c555d37f$export$c1950c29fa363b3f;
var $d4924d95c555d37f$export$c3adb9fdc8d42f95;
var $d4924d95c555d37f$export$b0b0940123b14a51;
var $d4924d95c555d37f$export$c9698ec7f05a07e1;
var $d4924d95c555d37f$export$5d04458e2a6c373e;
var $d4924d95c555d37f$export$2a60a6d359383427;
var $d4924d95c555d37f$export$c74c61c6f81bc561;
var $d4924d95c555d37f$export$d12a2b6ab14817dd;
var $d4924d95c555d37f$export$cff89feac2240fd3;
var $d4924d95c555d37f$export$3093877e9aefeaa9;
var $d4924d95c555d37f$export$876a6466078c921c;
var $d4924d95c555d37f$export$fef73dfaeb637bc9;
var $d4924d95c555d37f$export$3203edd9e5edd663;
var $d4924d95c555d37f$export$5c63e3af2cf08cbd;
var $d4924d95c555d37f$export$7b2413009a7e9b97;
var $d4924d95c555d37f$export$37e6e37fe825d0b6;
var $d4924d95c555d37f$export$9996d2c5481efa50;
var $d4924d95c555d37f$export$558c2e03e4d6f154;
var $d4924d95c555d37f$export$9ff9d7fe6c3fac81;
"use strict";
$d4924d95c555d37f$export$1e511d4a378977f5 = true;
$d4924d95c555d37f$export$ad2b8f0ca25d63d3 = $d4924d95c555d37f$export$c1950c29fa363b3f = $d4924d95c555d37f$export$c3adb9fdc8d42f95 = $d4924d95c555d37f$export$b0b0940123b14a51 = $d4924d95c555d37f$export$c9698ec7f05a07e1 = $d4924d95c555d37f$export$5d04458e2a6c373e = $d4924d95c555d37f$export$2a60a6d359383427 = $d4924d95c555d37f$export$c74c61c6f81bc561 = $d4924d95c555d37f$export$d12a2b6ab14817dd = $d4924d95c555d37f$export$cff89feac2240fd3 = $d4924d95c555d37f$export$3093877e9aefeaa9 = $d4924d95c555d37f$export$876a6466078c921c = $d4924d95c555d37f$export$fef73dfaeb637bc9 = $d4924d95c555d37f$export$3203edd9e5edd663 = $d4924d95c555d37f$export$5c63e3af2cf08cbd = $d4924d95c555d37f$export$7b2413009a7e9b97 = $d4924d95c555d37f$export$37e6e37fe825d0b6 = $d4924d95c555d37f$export$9996d2c5481efa50 = $d4924d95c555d37f$export$558c2e03e4d6f154 = $d4924d95c555d37f$export$9ff9d7fe6c3fac81 = void 0;
var $d4924d95c555d37f$var$SECTION_HOUR = $d4924d95c555d37f$export$558c2e03e4d6f154 = 0;
var $d4924d95c555d37f$var$SECTION_MINUTE = $d4924d95c555d37f$export$9996d2c5481efa50 = 1;
var $d4924d95c555d37f$var$SECTION_SECOND = $d4924d95c555d37f$export$7b2413009a7e9b97 = 2;
var $d4924d95c555d37f$var$SECTION_PERIOD = $d4924d95c555d37f$export$37e6e37fe825d0b6 = 3;
var $d4924d95c555d37f$var$pad = $d4924d95c555d37f$export$5d04458e2a6c373e = function pad(value) {
    return value.toString().padStart(2, '0');
};
var $d4924d95c555d37f$var$sectionMessageId = function sectionMessageId(section) {
    if (section === $d4924d95c555d37f$var$SECTION_HOUR) return 'timeInput.sectionHours';
    if (section === $d4924d95c555d37f$var$SECTION_MINUTE) return 'timeInput.sectionMinutes';
    if (section === $d4924d95c555d37f$var$SECTION_SECOND) return 'timeInput.sectionSeconds';
    return 'timeInput.sectionMeridiem';
};
var $d4924d95c555d37f$var$getSectionName = $d4924d95c555d37f$export$cff89feac2240fd3 = function getSectionName(section, format, formatMessage, messages) {
    if (formatMessage) return formatMessage({
        id: $d4924d95c555d37f$var$sectionMessageId(section),
        messages: messages
    });
    var names = format === '12' ? [
        'hours',
        'minutes',
        'seconds',
        'meridiem'
    ] : [
        'hours',
        'minutes',
        'seconds'
    ];
    return names[section];
};
var $d4924d95c555d37f$var$getRanges = $d4924d95c555d37f$export$876a6466078c921c = function getRanges(format) {
    if (format === '12') return [
        [
            0,
            2
        ],
        [
            3,
            5
        ],
        [
            6,
            8
        ],
        [
            9,
            11
        ]
    ];
    return [
        [
            0,
            2
        ],
        [
            3,
            5
        ],
        [
            6,
            8
        ]
    ];
};
// TimeInput always transacts (value/defaultValue/onChange) in a canonical
// 24-hour ISO time string ("HH:MM:SS"), regardless of the display `format`
// prop.
var $d4924d95c555d37f$var$ISO_TIME_REGEX = $d4924d95c555d37f$export$9ff9d7fe6c3fac81 = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;
var $d4924d95c555d37f$var$normalizeToIsoTime = $d4924d95c555d37f$export$2a60a6d359383427 = function normalizeToIsoTime(value) {
    if (typeof value !== 'string' || !value.trim()) return undefined;
    var trimmed = value.trim();
    if ($d4924d95c555d37f$var$ISO_TIME_REGEX.test(trimmed)) return trimmed;
    var parsed = new Date(trimmed);
    if (Number.isNaN(parsed.getTime())) return undefined;
    return $d4924d95c555d37f$var$pad(parsed.getHours()) + ":" + $d4924d95c555d37f$var$pad(parsed.getMinutes()) + ":" + $d4924d95c555d37f$var$pad(parsed.getSeconds());
};
// Converts a canonical 24-hour ISO time string into the section shape the
// sectioned editor uses for display, deriving 12-hour + period fields when
// needed.
var $d4924d95c555d37f$var$isoTimeToSections = $d4924d95c555d37f$export$c74c61c6f81bc561 = function isoTimeToSections(isoTime, format) {
    if (typeof isoTime !== 'string') return undefined;
    var match = isoTime.match($d4924d95c555d37f$var$ISO_TIME_REGEX);
    if (!match) return undefined;
    var hour24 = Number(match[1]);
    var minute = Number(match[2]);
    var second = Number(match[3]);
    if (format === '12') {
        var period = hour24 < 12 ? 'AM' : 'PM';
        var hour = hour24 % 12 || 12;
        return {
            hour: hour,
            minute: minute,
            second: second,
            period: period
        };
    }
    return {
        hour: hour24,
        minute: minute,
        second: second
    };
};
var $d4924d95c555d37f$var$sectionsToIsoTime = $d4924d95c555d37f$export$ad2b8f0ca25d63d3 = function sectionsToIsoTime(sections, format) {
    if (sections.hour === undefined || sections.minute === undefined || sections.second === undefined) return undefined;
    var hour24 = sections.hour;
    if (format === '12') {
        var period = sections.period || 'AM';
        hour24 = sections.hour % 12;
        if (period === 'PM') hour24 += 12;
    }
    return $d4924d95c555d37f$var$pad(hour24) + ":" + $d4924d95c555d37f$var$pad(sections.minute) + ":" + $d4924d95c555d37f$var$pad(sections.second);
};
var $d4924d95c555d37f$var$parseTime = $d4924d95c555d37f$export$c9698ec7f05a07e1 = function parseTime(value, format) {
    if (!value || typeof value !== 'string') return undefined;
    var trimmed = value.trim().toUpperCase();
    if (format === '12') {
        var _match = trimmed.match(/^(\d{1,2}):(\d{2}):(\d{2})\s*(AM|PM)$/);
        if (!_match) return undefined;
        var _hour = Number(_match[1]);
        var _minute = Number(_match[2]);
        var _second = Number(_match[3]);
        var period = _match[4];
        if (Number.isNaN(_hour) || Number.isNaN(_minute) || Number.isNaN(_second) || _hour < 1 || _hour > 12 || _minute < 0 || _minute > 59 || _second < 0 || _second > 59) return undefined;
        return {
            hour: _hour,
            minute: _minute,
            second: _second,
            period: period
        };
    }
    var match = trimmed.match(/^(\d{1,2}):(\d{2}):(\d{2})$/);
    if (!match) return undefined;
    var hour = Number(match[1]);
    var minute = Number(match[2]);
    var second = Number(match[3]);
    if (Number.isNaN(hour) || Number.isNaN(minute) || Number.isNaN(second) || hour < 0 || hour > 23 || minute < 0 || minute > 59 || second < 0 || second > 59) return undefined;
    return {
        hour: hour,
        minute: minute,
        second: second
    };
};
var $d4924d95c555d37f$var$formatTime = $d4924d95c555d37f$export$3203edd9e5edd663 = function formatTime(time, format) {
    if (!time) return undefined;
    if (format === '12') return $d4924d95c555d37f$var$pad(time.hour) + ":" + $d4924d95c555d37f$var$pad(time.minute) + ":" + $d4924d95c555d37f$var$pad(time.second) + " " + (time.period || 'AM');
    return $d4924d95c555d37f$var$pad(time.hour) + ":" + $d4924d95c555d37f$var$pad(time.minute) + ":" + $d4924d95c555d37f$var$pad(time.second);
};
var $d4924d95c555d37f$var$defaultSections = $d4924d95c555d37f$export$5c63e3af2cf08cbd = function defaultSections(format) {
    return format === '12' ? {
        hour: undefined,
        minute: undefined,
        second: undefined,
        period: undefined
    } : {
        hour: undefined,
        minute: undefined,
        second: undefined
    };
};
var $d4924d95c555d37f$var$hasAnyValue = $d4924d95c555d37f$export$d12a2b6ab14817dd = function hasAnyValue(sections) {
    return sections.hour !== undefined || sections.minute !== undefined || sections.second !== undefined || sections.period !== undefined;
};
var $d4924d95c555d37f$var$sectionMax = $d4924d95c555d37f$export$c3adb9fdc8d42f95 = function sectionMax(section, format) {
    if (section === $d4924d95c555d37f$var$SECTION_HOUR) return format === '12' ? 12 : 23;
    return 59;
};
var $d4924d95c555d37f$var$sectionMin = $d4924d95c555d37f$export$c1950c29fa363b3f = function sectionMin(section, format) {
    if (section === $d4924d95c555d37f$var$SECTION_HOUR) return format === '12' ? 1 : 0;
    return 0;
};
var $d4924d95c555d37f$var$sectionKey = $d4924d95c555d37f$export$b0b0940123b14a51 = function sectionKey(section) {
    if (section === $d4924d95c555d37f$var$SECTION_HOUR) return 'hour';
    if (section === $d4924d95c555d37f$var$SECTION_MINUTE) return 'minute';
    if (section === $d4924d95c555d37f$var$SECTION_SECOND) return 'second';
    return 'period';
};
var $d4924d95c555d37f$var$getSectionAriaMeta = $d4924d95c555d37f$export$3093877e9aefeaa9 = function getSectionAriaMeta(_ref) {
    var _sections$key;
    var section = _ref.section, format = _ref.format, sections = _ref.sections;
    if (section === $d4924d95c555d37f$var$SECTION_PERIOD) return {
        now: sections.period === 'PM' ? 1 : 0,
        min: 0,
        max: 1
    };
    var key = $d4924d95c555d37f$var$sectionKey(section);
    var min = $d4924d95c555d37f$var$sectionMin(section, format);
    var max = $d4924d95c555d37f$var$sectionMax(section, format);
    var now = (_sections$key = sections[key]) != null ? _sections$key : min;
    return {
        now: now,
        min: min,
        max: max
    };
};
var $d4924d95c555d37f$var$getActiveSectionAriaMeta = $d4924d95c555d37f$export$fef73dfaeb637bc9 = function getActiveSectionAriaMeta(_ref2) {
    var activeSection = _ref2.activeSection, format = _ref2.format, sections = _ref2.sections;
    return $d4924d95c555d37f$var$getSectionAriaMeta({
        section: activeSection,
        format: format,
        sections: sections
    });
};


function $5d72290af5be4136$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $5d72290af5be4136$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($5d72290af5be4136$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $5d72290af5be4136$var$_extends() {
    return $5d72290af5be4136$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5d72290af5be4136$var$_extends.apply(null, arguments);
} /* eslint-disable max-len */ 
var $5d72290af5be4136$var$PopupColumnBox = (0, $5d72290af5be4136$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "TimeInputPopup__PopupColumnBox",
    componentId: "sc-r2j8uh-0"
})([
    "scrollbar-gutter:stable;scrollbar-width:thin;"
]);
var $5d72290af5be4136$var$PopupOption = $5d72290af5be4136$var$_styledComponents["default"].div.withConfig({
    displayName: "TimeInputPopup__PopupOption",
    componentId: "sc-r2j8uh-1"
})([
    "box-sizing:border-box;cursor:pointer;display:flex;padding:",
    ";border-radius:",
    ";background:",
    ";&:hover{background:",
    ";}&:focus-visible{",
    "}"
], function(props) {
    return props.theme.global.edgeSize.xxsmall + " " + props.theme.global.edgeSize.xsmall;
}, function(props) {
    var _props$theme$global$c;
    return (_props$theme$global$c = props.theme.global.control) == null || (_props$theme$global$c = _props$theme$global$c.border) == null ? void 0 : _props$theme$global$c.radius;
}, function(props) {
    var _props$theme$timeInpu3;
    if (props.$selected) {
        var _props$theme$timeInpu;
        return (0, $4113023f9e0bafa0$exports.normalizeColor)((_props$theme$timeInpu = props.theme.timeInput) == null || (_props$theme$timeInpu = _props$theme$timeInpu.drop) == null || (_props$theme$timeInpu = _props$theme$timeInpu.option) == null || (_props$theme$timeInpu = _props$theme$timeInpu.selected) == null ? void 0 : _props$theme$timeInpu.background, props.theme);
    }
    if (props.$active) {
        var _props$theme$timeInpu2;
        return (0, $4113023f9e0bafa0$exports.normalizeColor)((_props$theme$timeInpu2 = props.theme.timeInput) == null || (_props$theme$timeInpu2 = _props$theme$timeInpu2.drop) == null || (_props$theme$timeInpu2 = _props$theme$timeInpu2.option) == null || (_props$theme$timeInpu2 = _props$theme$timeInpu2.hover) == null ? void 0 : _props$theme$timeInpu2.background, props.theme);
    }
    return (0, $4113023f9e0bafa0$exports.normalizeColor)((_props$theme$timeInpu3 = props.theme.timeInput) == null || (_props$theme$timeInpu3 = _props$theme$timeInpu3.drop) == null || (_props$theme$timeInpu3 = _props$theme$timeInpu3.option) == null ? void 0 : _props$theme$timeInpu3.background, props.theme);
}, function(props) {
    var _props$theme$timeInpu6;
    if (props.$selected) {
        var _props$theme$timeInpu4, _props$theme$timeInpu5;
        return (0, $4113023f9e0bafa0$exports.normalizeColor)(((_props$theme$timeInpu4 = props.theme.timeInput) == null || (_props$theme$timeInpu4 = _props$theme$timeInpu4.drop) == null || (_props$theme$timeInpu4 = _props$theme$timeInpu4.option) == null || (_props$theme$timeInpu4 = _props$theme$timeInpu4.selected) == null || (_props$theme$timeInpu4 = _props$theme$timeInpu4.hover) == null ? void 0 : _props$theme$timeInpu4.background) || ((_props$theme$timeInpu5 = props.theme.timeInput) == null || (_props$theme$timeInpu5 = _props$theme$timeInpu5.drop) == null || (_props$theme$timeInpu5 = _props$theme$timeInpu5.option) == null || (_props$theme$timeInpu5 = _props$theme$timeInpu5.selected) == null ? void 0 : _props$theme$timeInpu5.background), props.theme);
    }
    return (0, $4113023f9e0bafa0$exports.normalizeColor)((_props$theme$timeInpu6 = props.theme.timeInput) == null || (_props$theme$timeInpu6 = _props$theme$timeInpu6.drop) == null || (_props$theme$timeInpu6 = _props$theme$timeInpu6.option) == null || (_props$theme$timeInpu6 = _props$theme$timeInpu6.hover) == null ? void 0 : _props$theme$timeInpu6.background, props.theme);
}, (0, $4113023f9e0bafa0$exports.focusStyle)({
    inset: true
}));
var $5d72290af5be4136$var$optionKey = function optionKey(label, option) {
    return label.toLowerCase() + "-" + option;
};
var $5d72290af5be4136$var$PopupColumn = function PopupColumn(_ref) {
    var _theme$timeInput;
    var activeSection = _ref.activeSection, format = _ref.format, formatMessage = _ref.formatMessage, label = _ref.label, messages = _ref.messages, onClickCommitOption = _ref.onClickCommitOption, onPointerCommitOption = _ref.onPointerCommitOption, onSetSection = _ref.onSetSection, options = _ref.options, section = _ref.section, sections = _ref.sections, theme = _ref.theme;
    return /*#__PURE__*/ $5d72290af5be4136$var$_react["default"].createElement($5d72290af5be4136$var$PopupColumnBox, {
        role: "listbox",
        "aria-label": label,
        gap: "xxsmall",
        height: {
            max: ((_theme$timeInput = theme.timeInput) == null || (_theme$timeInput = _theme$timeInput.drop) == null || (_theme$timeInput = _theme$timeInput.column) == null ? void 0 : _theme$timeInput.maxHeight) || theme.global.size.small
        },
        overflow: "auto",
        flex: {
            grow: 0,
            shrink: 0
        }
    }, options.map(function(option) {
        var _theme$timeInput2;
        var key = $5d72290af5be4136$var$optionKey(label, option);
        var selected = section === $d4924d95c555d37f$export$558c2e03e4d6f154 && sections.hour === option || section === $d4924d95c555d37f$export$9996d2c5481efa50 && sections.minute === option || section === $d4924d95c555d37f$export$7b2413009a7e9b97 && sections.second === option || section === $d4924d95c555d37f$export$37e6e37fe825d0b6 && sections.period === option;
        var optionColor = selected ? ((_theme$timeInput2 = theme.timeInput) == null || (_theme$timeInput2 = _theme$timeInput2.drop) == null || (_theme$timeInput2 = _theme$timeInput2.option) == null || (_theme$timeInput2 = _theme$timeInput2.selected) == null ? void 0 : _theme$timeInput2.color) || 'text' : 'text';
        var isActive = selected && activeSection === section;
        return /*#__PURE__*/ $5d72290af5be4136$var$_react["default"].createElement($5d72290af5be4136$var$PopupOption, {
            key: key,
            "data-option-key": key,
            role: "option",
            "aria-selected": selected,
            tabIndex: isActive ? 0 : -1,
            "aria-label": (section === $d4924d95c555d37f$export$37e6e37fe825d0b6 ? option : (0, $d4924d95c555d37f$export$5d04458e2a6c373e)(option)) + " " + (0, $d4924d95c555d37f$export$cff89feac2240fd3)(section, format, formatMessage, messages),
            $active: isActive,
            $selected: selected,
            onMouseDown: function onMouseDown(event) {
                if (event.button !== 0) return;
                // Commit on pointer press so momentum scroll does not swallow
                // the first click commit on some trackpad/mouse flows.
                event.preventDefault();
                onPointerCommitOption(section, option);
            },
            onClick: function onClick() {
                return onClickCommitOption(section, option);
            },
            onFocus: function onFocus() {
                return onSetSection(section);
            }
        }, /*#__PURE__*/ $5d72290af5be4136$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, {
            size: theme.global.input.font.size || 'small',
            weight: selected ? 'bold' : 'normal',
            color: optionColor
        }, section === $d4924d95c555d37f$export$37e6e37fe825d0b6 ? option : (0, $d4924d95c555d37f$export$5d04458e2a6c373e)(option)));
    }));
};
var $5d72290af5be4136$var$TimeInputPopup = $5d72290af5be4136$export$876ed7c9dcced57f = function TimeInputPopup(_ref2) {
    var _theme$timeInput3, _theme$timeInput4;
    var activeSection = _ref2.activeSection, align = _ref2.align, format = _ref2.format, formatMessage = _ref2.formatMessage, hoursOptions = _ref2.hoursOptions, id = _ref2.id, incrementSection = _ref2.incrementSection, messages = _ref2.messages, minuteOptions = _ref2.minuteOptions, moveSection = _ref2.moveSection, onAccept = _ref2.onAccept, onClose = _ref2.onClose, onFocusLeave = _ref2.onFocusLeave, secondOptions = _ref2.secondOptions, sectionOrder = _ref2.sectionOrder, sections = _ref2.sections, setActiveSection = _ref2.setActiveSection, setSectionValue = _ref2.setSectionValue, target = _ref2.target, dropProps = _ref2.dropProps, label = _ref2.label;
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var dialogRef = (0, $5d72290af5be4136$var$_react.useRef)();
    var pointerDownInsideRef = (0, $5d72290af5be4136$var$_react.useRef)(false);
    var pointerSelectionCommittedRef = (0, $5d72290af5be4136$var$_react.useRef)(false);
    var suppressNextAutoScrollRef = (0, $5d72290af5be4136$var$_react.useRef)(false);
    var wheelInteractionTimeoutRef = (0, $5d72290af5be4136$var$_react.useRef)();
    var pointerReleaseTimeoutRef = (0, $5d72290af5be4136$var$_react.useRef)();
    var clearPointerReleaseTimeout = (0, $5d72290af5be4136$var$_react.useCallback)(function() {
        if (pointerReleaseTimeoutRef.current) {
            window.clearTimeout(pointerReleaseTimeoutRef.current);
            pointerReleaseTimeoutRef.current = undefined;
        }
    }, []);
    var clearInteractionInProgress = (0, $5d72290af5be4136$var$_react.useCallback)(function() {
        clearPointerReleaseTimeout();
        pointerDownInsideRef.current = false;
        if (wheelInteractionTimeoutRef.current) {
            window.clearTimeout(wheelInteractionTimeoutRef.current);
            wheelInteractionTimeoutRef.current = undefined;
        }
    }, [
        clearPointerReleaseTimeout
    ]);
    var releaseInteractionAfterClick = (0, $5d72290af5be4136$var$_react.useCallback)(function() {
        clearPointerReleaseTimeout();
        // Keep lock through click handler + resulting render/effect cycle.
        pointerReleaseTimeoutRef.current = window.setTimeout(function() {
            pointerDownInsideRef.current = false;
            pointerReleaseTimeoutRef.current = undefined;
        }, 0);
    }, [
        clearPointerReleaseTimeout
    ]);
    var markInteractionInProgress = (0, $5d72290af5be4136$var$_react.useCallback)(function() {
        pointerDownInsideRef.current = true;
    }, []);
    var suppressNextAutoScroll = (0, $5d72290af5be4136$var$_react.useCallback)(function() {
        suppressNextAutoScrollRef.current = true;
    }, []);
    var commitOptionSelection = (0, $5d72290af5be4136$var$_react.useCallback)(function(section, option) {
        setActiveSection(section);
        setSectionValue(section, option);
    }, [
        setActiveSection,
        setSectionValue
    ]);
    var commitPointerOptionSelection = (0, $5d72290af5be4136$var$_react.useCallback)(function(section, option) {
        pointerSelectionCommittedRef.current = true;
        suppressNextAutoScroll();
        commitOptionSelection(section, option);
    }, [
        commitOptionSelection,
        suppressNextAutoScroll
    ]);
    var commitClickOptionSelection = (0, $5d72290af5be4136$var$_react.useCallback)(function(section, option) {
        if (pointerSelectionCommittedRef.current) {
            pointerSelectionCommittedRef.current = false;
            return;
        }
        commitOptionSelection(section, option);
    }, [
        commitOptionSelection
    ]);
    var onPopupWheelCapture = (0, $5d72290af5be4136$var$_react.useCallback)(function() {
        pointerDownInsideRef.current = true;
        if (wheelInteractionTimeoutRef.current) window.clearTimeout(wheelInteractionTimeoutRef.current);
        // Trackpad and wheel events can continue after the pointer sequence.
        // Keep interaction lock briefly so refocus does not steal first selection.
        wheelInteractionTimeoutRef.current = window.setTimeout(function() {
            pointerDownInsideRef.current = false;
            wheelInteractionTimeoutRef.current = undefined;
        }, 120);
    }, []);
    (0, $5d72290af5be4136$var$_react.useEffect)(function() {
        return function() {
            clearPointerReleaseTimeout();
            if (wheelInteractionTimeoutRef.current) window.clearTimeout(wheelInteractionTimeoutRef.current);
        };
    }, [
        clearPointerReleaseTimeout
    ]);
    var popupSections = [
        {
            section: $d4924d95c555d37f$export$558c2e03e4d6f154,
            label: 'hour',
            options: hoursOptions
        },
        {
            section: $d4924d95c555d37f$export$9996d2c5481efa50,
            label: 'minute',
            options: minuteOptions
        },
        {
            section: $d4924d95c555d37f$export$7b2413009a7e9b97,
            label: 'second',
            options: secondOptions
        },
        {
            section: $d4924d95c555d37f$export$37e6e37fe825d0b6,
            label: 'period',
            options: [
                'AM',
                'PM'
            ]
        }
    ];
    var visiblePopupSections = popupSections.filter(function(_ref3) {
        var section = _ref3.section;
        return sectionOrder.includes(section);
    });
    var scrollSelectedOptionsIntoView = (0, $5d72290af5be4136$var$_react.useCallback)(function() {
        var _sectionLabel, _sectionValue;
        if (pointerDownInsideRef.current) return;
        if (suppressNextAutoScrollRef.current) {
            suppressNextAutoScrollRef.current = false;
            return;
        }
        var popupNode = dialogRef.current;
        if (!popupNode) return;
        var sectionLabel = (_sectionLabel = {}, _sectionLabel[$d4924d95c555d37f$export$558c2e03e4d6f154] = 'hour', _sectionLabel[$d4924d95c555d37f$export$9996d2c5481efa50] = 'minute', _sectionLabel[$d4924d95c555d37f$export$7b2413009a7e9b97] = 'second', _sectionLabel[$d4924d95c555d37f$export$37e6e37fe825d0b6] = 'period', _sectionLabel);
        var sectionValue = (_sectionValue = {}, _sectionValue[$d4924d95c555d37f$export$558c2e03e4d6f154] = sections.hour !== undefined ? sections.hour : hoursOptions[0], _sectionValue[$d4924d95c555d37f$export$9996d2c5481efa50] = sections.minute !== undefined ? sections.minute : minuteOptions[0], _sectionValue[$d4924d95c555d37f$export$7b2413009a7e9b97] = sections.second !== undefined ? sections.second : secondOptions[0], _sectionValue[$d4924d95c555d37f$export$37e6e37fe825d0b6] = sections.period || 'AM', _sectionValue);
        visiblePopupSections.forEach(function(_ref4) {
            var section = _ref4.section;
            var labelValue = sectionLabel[section];
            if (!labelValue) return;
            var listboxNode = popupNode.querySelector("[role=\"listbox\"][aria-label=\"" + labelValue + "\"]");
            if (!listboxNode) return;
            var selectedNode = popupNode.querySelector("[data-option-key=\"" + $5d72290af5be4136$var$optionKey(labelValue, sectionValue[section]) + "\"]") || listboxNode.querySelector('[role="option"][aria-selected="true"]');
            if (selectedNode) {
                if (selectedNode.scrollIntoView) selectedNode.scrollIntoView({
                    block: 'nearest'
                });
                // Center selected value in each listbox so all sections (hh/mm/ss)
                // are consistently aligned on open, not just the focused section.
                var selectedOffsetTop = selectedNode.offsetTop;
                var selectedHeight = selectedNode.offsetHeight;
                var targetScrollTop = selectedOffsetTop - (listboxNode.clientHeight / 2 - selectedHeight / 2);
                listboxNode.scrollTop = Math.max(0, targetScrollTop);
            }
        });
    }, [
        hoursOptions,
        minuteOptions,
        secondOptions,
        sections,
        visiblePopupSections
    ]);
    var focusCurrentPopupOption = (0, $5d72290af5be4136$var$_react.useCallback)(function() {
        var _labelMap, _keyMap, _dialogRef$current, _dialogRef$current2;
        var labelMap = (_labelMap = {}, _labelMap[$d4924d95c555d37f$export$558c2e03e4d6f154] = 'hour', _labelMap[$d4924d95c555d37f$export$9996d2c5481efa50] = 'minute', _labelMap[$d4924d95c555d37f$export$7b2413009a7e9b97] = 'second', _labelMap[$d4924d95c555d37f$export$37e6e37fe825d0b6] = 'period', _labelMap);
        var keyMap = (_keyMap = {}, _keyMap[$d4924d95c555d37f$export$558c2e03e4d6f154] = $5d72290af5be4136$var$optionKey('hour', sections.hour !== undefined ? sections.hour : hoursOptions[0]), _keyMap[$d4924d95c555d37f$export$9996d2c5481efa50] = $5d72290af5be4136$var$optionKey('minute', sections.minute !== undefined ? sections.minute : minuteOptions[0]), _keyMap[$d4924d95c555d37f$export$7b2413009a7e9b97] = $5d72290af5be4136$var$optionKey('second', sections.second !== undefined ? sections.second : secondOptions[0]), _keyMap[$d4924d95c555d37f$export$37e6e37fe825d0b6] = $5d72290af5be4136$var$optionKey('period', sections.period || 'AM'), _keyMap);
        var selector = "[data-option-key=\"" + keyMap[activeSection] + "\"]";
        var node = (_dialogRef$current = dialogRef.current) == null ? void 0 : _dialogRef$current.querySelector(selector);
        if (node) {
            node.focus();
            return true;
        }
        // Fallback: if current section value has no matching option
        // (e.g., minute=31 with minuteStep=15), focus first option in section.
        var sectionLabel = labelMap[activeSection];
        if (!sectionLabel) return false;
        var fallbackNode = (_dialogRef$current2 = dialogRef.current) == null ? void 0 : _dialogRef$current2.querySelector("[role=\"listbox\"][aria-label=\"" + sectionLabel + "\"] [role=\"option\"]");
        if (fallbackNode) {
            fallbackNode.focus();
            return true;
        }
        return false;
    }, [
        activeSection,
        hoursOptions,
        minuteOptions,
        secondOptions,
        sections
    ]);
    (0, $6a5275ec792307a1$export$e5c5a5f917a5871c)(function() {
        // Avoid stealing pointer interactions: while the user is actively
        // clicking inside the popup, let that click settle before refocusing.
        if (pointerDownInsideRef.current) return undefined;
        var scrollRaf = requestAnimationFrame(function() {
            scrollSelectedOptionsIntoView();
        });
        var rafB;
        var rafA = requestAnimationFrame(function() {
            scrollSelectedOptionsIntoView();
            var focused = focusCurrentPopupOption();
            // Retry one more frame to handle occasional mount timing races.
            if (!focused) rafB = requestAnimationFrame(function() {
                scrollSelectedOptionsIntoView();
                focusCurrentPopupOption();
            });
        });
        return function() {
            window.cancelAnimationFrame(scrollRaf);
            window.cancelAnimationFrame(rafA);
            if (rafB) window.cancelAnimationFrame(rafB);
        };
    }, [
        focusCurrentPopupOption,
        scrollSelectedOptionsIntoView
    ]);
    return /*#__PURE__*/ $5d72290af5be4136$var$_react["default"].createElement($9097252a6690f3a9$export$aaa698cd7aa517d6, $5d72290af5be4136$var$_extends({
        id: id ? id + "__drop" : undefined,
        target: target,
        align: align,
        onEsc: onClose,
        onClickOutside: onClose
    }, dropProps), /*#__PURE__*/ $5d72290af5be4136$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
        ref: dialogRef,
        role: "dialog",
        "aria-label": label,
        direction: "row",
        width: {
            width: (_theme$timeInput3 = theme.timeInput) == null || (_theme$timeInput3 = _theme$timeInput3.drop) == null ? void 0 : _theme$timeInput3.width,
            max: '100%'
        },
        minHeight: (_theme$timeInput4 = theme.timeInput) == null || (_theme$timeInput4 = _theme$timeInput4.drop) == null ? void 0 : _theme$timeInput4.minHeight,
        gap: "xsmall",
        pad: "small",
        onPointerDownCapture: markInteractionInProgress,
        onPointerUpCapture: releaseInteractionAfterClick,
        onPointerCancelCapture: clearInteractionInProgress,
        onWheelCapture: onPopupWheelCapture,
        onKeyDown: function onKeyDown(event) {
            if (event.key === 'Escape') {
                event.preventDefault();
                onClose();
            } else if (event.key === ' ' || event.key === 'Spacebar') {
                var _event$target, _document$activeEleme;
                event.preventDefault();
                var focusedOption = ((_event$target = event.target) == null || _event$target.closest == null ? void 0 : _event$target.closest('[role="option"]')) || ((_document$activeEleme = document.activeElement) == null || _document$activeEleme.closest == null ? void 0 : _document$activeEleme.closest('[role="option"]'));
                focusedOption == null || focusedOption.click == null || focusedOption.click();
            } else if (event.key === 'Tab') {
                event.preventDefault();
                setActiveSection(moveSection(event.shiftKey ? -1 : 1));
            } else if (event.key === 'ArrowLeft') {
                event.preventDefault();
                setActiveSection(moveSection(-1));
            } else if (event.key === 'ArrowRight') {
                event.preventDefault();
                setActiveSection(moveSection(1));
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                incrementSection(activeSection, -1);
            } else if (event.key === 'ArrowDown') {
                event.preventDefault();
                incrementSection(activeSection, 1);
            } else if (event.key === 'Enter') {
                event.preventDefault();
                onAccept == null || onAccept();
                onClose();
            }
        },
        onBlurCapture: function onBlurCapture(event) {
            var nextFocusTarget = event.relatedTarget;
            // Clicking the scrollbar blurs the focused option with
            // relatedTarget = null. Keep the popup open for that interaction.
            if (!nextFocusTarget) return;
            if (!event.currentTarget.contains(nextFocusTarget)) onFocusLeave == null || onFocusLeave();
        }
    }, visiblePopupSections.map(function(_ref5) {
        var section = _ref5.section, sectionLabel = _ref5.label, options = _ref5.options;
        return /*#__PURE__*/ $5d72290af5be4136$var$_react["default"].createElement($5d72290af5be4136$var$PopupColumn, {
            key: sectionLabel,
            activeSection: activeSection,
            format: format,
            formatMessage: formatMessage,
            label: sectionLabel,
            messages: messages,
            onClickCommitOption: commitClickOptionSelection,
            onPointerCommitOption: commitPointerOptionSelection,
            onSetSection: setActiveSection,
            options: options,
            section: section,
            sections: sections,
            theme: theme
        });
    })));
};


var $d1302124eed5c9bc$export$1e511d4a378977f5;
var $d1302124eed5c9bc$export$418e07601dd8a1c5;
"use strict";
$d1302124eed5c9bc$export$1e511d4a378977f5 = true;
$d1302124eed5c9bc$export$418e07601dd8a1c5 = void 0;

var $d1302124eed5c9bc$var$_propTypes = $d1302124eed5c9bc$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $d1302124eed5c9bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $d1302124eed5c9bc$var$PropType = {};
$d1302124eed5c9bc$var$PropType = {
    defaultValue: $d1302124eed5c9bc$var$_propTypes["default"].string,
    disabled: $d1302124eed5c9bc$var$_propTypes["default"].bool,
    format: $d1302124eed5c9bc$var$_propTypes["default"].oneOf([
        '12',
        '24'
    ]),
    id: $d1302124eed5c9bc$var$_propTypes["default"].string,
    messages: $d1302124eed5c9bc$var$_propTypes["default"].shape({
        activePeriodValue: $d1302124eed5c9bc$var$_propTypes["default"].string,
        activeSection: $d1302124eed5c9bc$var$_propTypes["default"].string,
        activeSectionValue: $d1302124eed5c9bc$var$_propTypes["default"].string,
        chooseTime: $d1302124eed5c9bc$var$_propTypes["default"].string,
        currentValue: $d1302124eed5c9bc$var$_propTypes["default"].string,
        inputLabel: $d1302124eed5c9bc$var$_propTypes["default"].string,
        invalidTime: $d1302124eed5c9bc$var$_propTypes["default"].string,
        openDrop: $d1302124eed5c9bc$var$_propTypes["default"].string,
        sectionHours: $d1302124eed5c9bc$var$_propTypes["default"].string,
        sectionMeridiem: $d1302124eed5c9bc$var$_propTypes["default"].string,
        sectionMinutes: $d1302124eed5c9bc$var$_propTypes["default"].string,
        sectionSeconds: $d1302124eed5c9bc$var$_propTypes["default"].string
    }),
    minuteStep: $d1302124eed5c9bc$var$_propTypes["default"].number,
    name: $d1302124eed5c9bc$var$_propTypes["default"].string,
    onChange: $d1302124eed5c9bc$var$_propTypes["default"].func,
    readOnly: $d1302124eed5c9bc$var$_propTypes["default"].bool,
    value: $d1302124eed5c9bc$var$_propTypes["default"].string
};
var $d1302124eed5c9bc$var$TimeInputPropTypes = $d1302124eed5c9bc$export$418e07601dd8a1c5 = $d1302124eed5c9bc$var$PropType;


var $b6eb4c89f9ba1d7a$export$1e511d4a378977f5;
var $b6eb4c89f9ba1d7a$export$eb76f452845c0886;
"use strict";
$b6eb4c89f9ba1d7a$export$1e511d4a378977f5 = true;
$b6eb4c89f9ba1d7a$export$eb76f452845c0886 = void 0;

var $2xPiy = parcelRequire("2xPiy");

function $b6eb4c89f9ba1d7a$var$_extends() {
    return $b6eb4c89f9ba1d7a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b6eb4c89f9ba1d7a$var$_extends.apply(null, arguments);
} /* eslint-disable no-nested-ternary */ 
var $b6eb4c89f9ba1d7a$var$separatorBeforeSection = function separatorBeforeSection(section) {
    return section === $d4924d95c555d37f$export$37e6e37fe825d0b6 ? ' ' : ':';
};
var $b6eb4c89f9ba1d7a$var$sectionToken = function sectionToken(section) {
    if (section === $d4924d95c555d37f$export$558c2e03e4d6f154) return 'hh';
    if (section === $d4924d95c555d37f$export$9996d2c5481efa50) return 'mm';
    if (section === $d4924d95c555d37f$export$7b2413009a7e9b97) return 'ss';
    return 'aa';
};
var $b6eb4c89f9ba1d7a$var$sectionPattern = function sectionPattern(section) {
    if (section === $d4924d95c555d37f$export$37e6e37fe825d0b6) return '(AM|PM)';
    return '(\\d{1,2})';
};
var $b6eb4c89f9ba1d7a$var$isNumericSection = function isNumericSection(section) {
    return section !== $d4924d95c555d37f$export$37e6e37fe825d0b6;
};
var $b6eb4c89f9ba1d7a$var$parseSectionsValue = function parseSectionsValue(value, format, sectionOrder) {
    if (!value || typeof value !== 'string') return undefined;
    var normalized = value.trim().toUpperCase();
    if (!normalized || !sectionOrder.length) return undefined;
    var pattern = sectionOrder.map(function(section, index) {
        var sectionRegex = $b6eb4c89f9ba1d7a$var$sectionPattern(section);
        if (index === 0) return sectionRegex;
        return $b6eb4c89f9ba1d7a$var$separatorBeforeSection(section) + "\\s*" + sectionRegex;
    }).join('');
    var regex = new RegExp("^" + pattern + "$");
    var match = normalized.match(regex);
    if (!match) return undefined;
    var parsed = (0, $d4924d95c555d37f$export$5c63e3af2cf08cbd)(format);
    sectionOrder.forEach(function(section, index) {
        var key = (0, $d4924d95c555d37f$export$b0b0940123b14a51)(section);
        var captured = match[index + 1];
        if (section === $d4924d95c555d37f$export$37e6e37fe825d0b6) parsed[key] = captured;
        else {
            var next = Number(captured);
            if (!Number.isNaN(next)) parsed[key] = next;
        }
    });
    for(var i = 0; i < sectionOrder.length; i += 1){
        var section = sectionOrder[i];
        if ($b6eb4c89f9ba1d7a$var$isNumericSection(section)) {
            var key = (0, $d4924d95c555d37f$export$b0b0940123b14a51)(section);
            var next = parsed[key];
            if (next === undefined || next < (0, $d4924d95c555d37f$export$c1950c29fa363b3f)(section, format) || next > (0, $d4924d95c555d37f$export$c3adb9fdc8d42f95)(section, format)) return undefined;
        }
    }
    return parsed;
};
var $b6eb4c89f9ba1d7a$var$formatSectionsValue = function formatSectionsValue(_ref) {
    var sections = _ref.sections, sectionOrder = _ref.sectionOrder, _ref$includeTokens = _ref.includeTokens, includeTokens = _ref$includeTokens === void 0 ? false : _ref$includeTokens;
    return sectionOrder.map(function(section, index) {
        var key = (0, $d4924d95c555d37f$export$b0b0940123b14a51)(section);
        var rawValue = sections[key];
        var rendered = rawValue === undefined ? includeTokens ? $b6eb4c89f9ba1d7a$var$sectionToken(section) : '' : section === $d4924d95c555d37f$export$37e6e37fe825d0b6 ? rawValue : (0, $d4924d95c555d37f$export$5d04458e2a6c373e)(rawValue);
        if (index === 0) return rendered;
        return "" + $b6eb4c89f9ba1d7a$var$separatorBeforeSection(section) + rendered;
    }).join('');
};
var $b6eb4c89f9ba1d7a$var$useSectionedTimeField = $b6eb4c89f9ba1d7a$export$eb76f452845c0886 = function useSectionedTimeField(_ref2) {
    var format = _ref2.format, sectionOrder = _ref2.sectionOrder, _ref2$minuteStep = _ref2.minuteStep, minuteStep = _ref2$minuteStep === void 0 ? 1 : _ref2$minuteStep, value = _ref2.value, onCommit = _ref2.onCommit, onInvalid = _ref2.onInvalid;
    var editStateRef = (0, $2xPiy.useRef)({
        section: $d4924d95c555d37f$export$558c2e03e4d6f154,
        digits: 0,
        previousValue: undefined,
        firstDigit: undefined
    });
    var preserveIncompleteSectionsRef = (0, $2xPiy.useRef)(false);
    // Track pending single digit for display without committing
    var _useState = (0, $2xPiy.useState)({}), pendingDigits = _useState[0], setPendingDigits = _useState[1];
    var parsedValue = (0, $2xPiy.useMemo)(function() {
        return (0, $d4924d95c555d37f$export$c74c61c6f81bc561)((0, $d4924d95c555d37f$export$2a60a6d359383427)(value), format);
    }, [
        format,
        value
    ]);
    var _useState2 = (0, $2xPiy.useState)(parsedValue || (0, $d4924d95c555d37f$export$5c63e3af2cf08cbd)(format)), sections = _useState2[0], setSections = _useState2[1];
    var _useState3 = (0, $2xPiy.useState)(sectionOrder[0] || $d4924d95c555d37f$export$558c2e03e4d6f154), activeSection = _useState3[0], setActiveSection = _useState3[1];
    (0, $2xPiy.useEffect)(function() {
        if (!sectionOrder.includes(activeSection)) setActiveSection(sectionOrder[0] || $d4924d95c555d37f$export$558c2e03e4d6f154);
    }, [
        activeSection,
        sectionOrder
    ]);
    (0, $2xPiy.useEffect)(function() {
        if (!parsedValue && preserveIncompleteSectionsRef.current) {
            preserveIncompleteSectionsRef.current = false;
            return;
        }
        setSections(parsedValue || (0, $d4924d95c555d37f$export$5c63e3af2cf08cbd)(format));
    }, [
        parsedValue,
        format
    ]);
    var displayValue = (0, $2xPiy.useMemo)(function() {
        if (!(0, $d4924d95c555d37f$export$d12a2b6ab14817dd)(sections)) return '';
        // Create a copy of sections with pending digits overlaid for display
        var displaySections = $b6eb4c89f9ba1d7a$var$_extends({}, sections);
        var pendingSection = Object.keys(pendingDigits)[0];
        if (pendingSection && pendingDigits[pendingSection] !== undefined) displaySections[pendingSection] = pendingDigits[pendingSection];
        return $b6eb4c89f9ba1d7a$var$formatSectionsValue({
            sections: displaySections,
            sectionOrder: sectionOrder,
            includeTokens: true
        });
    }, [
        sectionOrder,
        sections,
        pendingDigits
    ]);
    var commitSections = (0, $2xPiy.useCallback)(function(nextSections) {
        var _nextSections$second;
        setSections(nextSections);
        var complete = sectionOrder.every(function(section) {
            return nextSections[(0, $d4924d95c555d37f$export$b0b0940123b14a51)(section)] !== undefined;
        });
        // Check if all numeric sections are valid
        var allValid = sectionOrder.every(function(section) {
            if (!$b6eb4c89f9ba1d7a$var$isNumericSection(section)) return true; // skip period
            var key = (0, $d4924d95c555d37f$export$b0b0940123b14a51)(section);
            var sectionValue = nextSections[key];
            var min = (0, $d4924d95c555d37f$export$c1950c29fa363b3f)(section, format);
            var max = (0, $d4924d95c555d37f$export$c3adb9fdc8d42f95)(section, format);
            return sectionValue >= min && sectionValue <= max;
        });
        var nextValue = complete && sectionOrder.length && allValid ? (0, $d4924d95c555d37f$export$ad2b8f0ca25d63d3)($b6eb4c89f9ba1d7a$var$_extends({}, nextSections, {
            second: (_nextSections$second = nextSections.second) != null ? _nextSections$second : 0
        }), format) : undefined;
        // Mark as incomplete if: sections incomplete OR some invalid
        var hasIncompleteSections = !complete || !allValid;
        preserveIncompleteSectionsRef.current = hasIncompleteSections && (0, $d4924d95c555d37f$export$d12a2b6ab14817dd)(nextSections);
        onCommit(nextSections, nextValue);
    }, [
        onCommit,
        sectionOrder,
        format
    ]);
    var setSectionValue = (0, $2xPiy.useCallback)(function(section, rawValue) {
        var _extends2;
        var key = (0, $d4924d95c555d37f$export$b0b0940123b14a51)(section);
        var next = $b6eb4c89f9ba1d7a$var$_extends({}, sections, (_extends2 = {}, _extends2[key] = rawValue, _extends2));
        commitSections(next);
    }, [
        commitSections,
        sections
    ]);
    var moveSection = (0, $2xPiy.useCallback)(function(direction) {
        if (!sectionOrder.length) return activeSection;
        var activeIndex = Math.max(0, sectionOrder.indexOf(activeSection));
        var count = sectionOrder.length;
        var nextIndex = (activeIndex + direction + count) % count;
        var nextSection = sectionOrder[nextIndex];
        setActiveSection(nextSection);
        return nextSection;
    }, [
        activeSection,
        sectionOrder
    ]);
    var incrementSection = (0, $2xPiy.useCallback)(function(section, delta) {
        if (section === $d4924d95c555d37f$export$37e6e37fe825d0b6) {
            setSectionValue(section, sections.period === 'AM' ? 'PM' : 'AM');
            return;
        }
        var minValue = (0, $d4924d95c555d37f$export$c1950c29fa363b3f)(section, format);
        var maxValue = (0, $d4924d95c555d37f$export$c3adb9fdc8d42f95)(section, format);
        var key = (0, $d4924d95c555d37f$export$b0b0940123b14a51)(section);
        var current = sections[key];
        var step = section === $d4924d95c555d37f$export$9996d2c5481efa50 ? minuteStep : section === $d4924d95c555d37f$export$7b2413009a7e9b97 ? 1 : 1;
        var next;
        if (step > 1 && (section === $d4924d95c555d37f$export$9996d2c5481efa50 || section === $d4924d95c555d37f$export$7b2413009a7e9b97)) {
            var options = Array.from({
                length: Math.ceil((maxValue - minValue + 1) / step)
            }, function(_, index) {
                return minValue + index * step;
            }).filter(function(valueAtIndex) {
                return valueAtIndex <= maxValue;
            });
            var currentIndex = options.indexOf(current);
            if (currentIndex !== -1) {
                var wrappedIndex = ((currentIndex + delta) % options.length + options.length) % options.length;
                next = options[wrappedIndex];
            } else if (delta > 0) {
                var _options$find;
                next = (_options$find = options.find(function(option) {
                    return option > (current != null ? current : minValue - 1);
                })) != null ? _options$find : options[0];
            } else {
                var _descending$find;
                var descending = [].concat(options).reverse();
                next = (_descending$find = descending.find(function(option) {
                    return option < (current != null ? current : maxValue + 1);
                })) != null ? _descending$find : options[options.length - 1];
            }
        } else {
            var base = current === undefined ? minValue : current;
            next = base + delta;
            if (next > maxValue) next = minValue;
            if (next < minValue) next = maxValue;
        }
        setSectionValue(section, next);
    }, [
        format,
        minuteStep,
        sections,
        setSectionValue
    ]);
    var applyDigit = (0, $2xPiy.useCallback)(function(digit) {
        if (activeSection === $d4924d95c555d37f$export$37e6e37fe825d0b6) return undefined;
        var minValue = (0, $d4924d95c555d37f$export$c1950c29fa363b3f)(activeSection, format);
        var maxValue = (0, $d4924d95c555d37f$export$c3adb9fdc8d42f95)(activeSection, format);
        var key = (0, $d4924d95c555d37f$export$b0b0940123b14a51)(activeSection);
        var isSameSection = editStateRef.current.section === activeSection;
        var isSecondDigit = isSameSection && editStateRef.current.digits === 1;
        var currentRaw = sections[key] === undefined ? 0 : sections[key];
        var nextValue;
        if (isSecondDigit) {
            var _editStateRef$current;
            // Use the stored first digit from editState
            var firstDigit = (_editStateRef$current = editStateRef.current.firstDigit) != null ? _editStateRef$current : currentRaw % 10;
            nextValue = firstDigit * 10 + digit;
            editStateRef.current = {
                section: activeSection,
                digits: 0,
                previousValue: editStateRef.current.previousValue,
                firstDigit: undefined
            };
            // Clear pending digits since we're committing now
            setPendingDigits({});
        } else {
            var _setPendingDigits;
            // First digit: store in pending for display only
            nextValue = digit;
            editStateRef.current = {
                section: activeSection,
                digits: 1,
                previousValue: sections[key],
                firstDigit: digit
            };
            // Show the first digit in pending state
            setPendingDigits((_setPendingDigits = {}, _setPendingDigits[key] = digit, _setPendingDigits));
        }
        // For 2nd digit: validate combined value, but allow invalid 1st digit
        // (allows "0X" patterns in formats where single "0" is invalid)
        if (isSecondDigit && (nextValue < minValue || nextValue > maxValue)) {
            var _editStateRef$current2;
            // Combined value invalid. Try to use first digit for current section
            // and apply second digit to next section (MUI behavior)
            var _firstDigit = (_editStateRef$current2 = editStateRef.current.firstDigit) != null ? _editStateRef$current2 : currentRaw % 10;
            if (_firstDigit >= minValue && _firstDigit <= maxValue) {
                setSectionValue(activeSection, _firstDigit);
                // Get next section and check if second digit is valid there
                var currentSectionIndex = sectionOrder.indexOf(activeSection);
                var nextSection = sectionOrder[currentSectionIndex + 1];
                if (nextSection && $b6eb4c89f9ba1d7a$var$isNumericSection(nextSection)) {
                    var nextMinValue = (0, $d4924d95c555d37f$export$c1950c29fa363b3f)(nextSection, format);
                    var nextMaxValue = (0, $d4924d95c555d37f$export$c3adb9fdc8d42f95)(nextSection, format);
                    // If second digit is valid for next section, apply it there
                    if (digit >= nextMinValue && digit <= nextMaxValue) {
                        setSectionValue(nextSection, digit);
                        // Now move to section after that
                        return moveSection(2);
                    }
                }
                // If second digit not valid for next section, just move to next
                return moveSection(1);
            }
            // If even first digit alone is invalid, reject the entry
            onInvalid == null || onInvalid();
            setPendingDigits({});
            return undefined;
        }
        // MUI Pattern: Determine if we should commit and move to next section
        // shouldGoToNextSection = nextValue * 10 > max || digitCount === 2
        var shouldMoveToNextSection = nextValue * 10 > maxValue || isSecondDigit;
        setSectionValue(activeSection, nextValue);
        if (shouldMoveToNextSection) {
            // Don't move past the last section during digit entry
            // (Tab navigation can still wrap, but digit entry stops at last
            // section)
            var currentIndex = sectionOrder.indexOf(activeSection);
            var isLastSection = currentIndex === sectionOrder.length - 1;
            if (!isLastSection) return moveSection(1);
        }
        return activeSection;
    }, [
        activeSection,
        format,
        moveSection,
        onInvalid,
        sections,
        setSectionValue,
        setPendingDigits,
        sectionOrder
    ]);
    var clearActiveSection = (0, $2xPiy.useCallback)(function() {
        setSectionValue(activeSection, undefined);
    }, [
        activeSection,
        setSectionValue
    ]);
    var parsePasted = (0, $2xPiy.useCallback)(function(pasted) {
        var parsed = $b6eb4c89f9ba1d7a$var$parseSectionsValue(pasted, format, sectionOrder);
        if (parsed) return parsed;
        var digits = pasted.replace(/\D/g, '');
        var numericSections = sectionOrder.filter(function(section) {
            return section !== $d4924d95c555d37f$export$37e6e37fe825d0b6;
        });
        var hasExplicitPeriod = /\b(AM|PM)\b/i.test(pasted);
        var shouldInferPeriod = format === '12' && sectionOrder.includes($d4924d95c555d37f$export$37e6e37fe825d0b6) && !hasExplicitPeriod;
        if (digits.length >= numericSections.length * 2 && numericSections.length) {
            var next = $b6eb4c89f9ba1d7a$var$_extends({}, sections);
            for(var i = 0; i < numericSections.length; i += 1){
                var section = numericSections[i];
                var parsedNumber = Number(digits.slice(i * 2, i * 2 + 2));
                var minValue = section === $d4924d95c555d37f$export$558c2e03e4d6f154 && shouldInferPeriod ? 0 : (0, $d4924d95c555d37f$export$c1950c29fa363b3f)(section, format);
                var maxValue = section === $d4924d95c555d37f$export$558c2e03e4d6f154 && shouldInferPeriod ? 23 : (0, $d4924d95c555d37f$export$c3adb9fdc8d42f95)(section, format);
                if (Number.isNaN(parsedNumber) || parsedNumber < minValue || parsedNumber > maxValue) return undefined;
                next[(0, $d4924d95c555d37f$export$b0b0940123b14a51)(section)] = parsedNumber;
            }
            if (sectionOrder.includes($d4924d95c555d37f$export$37e6e37fe825d0b6)) {
                if (hasExplicitPeriod) next.period = /\bPM\b/i.test(pasted) ? 'PM' : 'AM';
                else if (shouldInferPeriod) {
                    var normalizedHour = next.hour;
                    if (normalizedHour === 0) {
                        next.hour = 12;
                        next.period = 'AM';
                    } else if (normalizedHour === 12) next.period = 'PM';
                    else if (normalizedHour > 12) {
                        next.hour = normalizedHour - 12;
                        next.period = 'PM';
                    } else next.period = 'AM';
                }
            }
            return next;
        }
        return undefined;
    }, [
        format,
        sectionOrder,
        sections
    ]);
    return {
        activeSection: activeSection,
        clearActiveSection: clearActiveSection,
        displayValue: displayValue,
        incrementSection: incrementSection,
        moveSection: moveSection,
        parsePasted: parsePasted,
        sections: sections,
        setActiveSection: setActiveSection,
        setSectionValue: setSectionValue,
        applyDigit: applyDigit,
        commitSections: commitSections,
        pendingDigits: pendingDigits
    };
};



var $b8135998a0253aa7$var$_excluded = [
    "defaultValue",
    "disabled",
    "format",
    "id",
    "messages",
    "minuteStep",
    "name",
    "onChange",
    "readOnly",
    "value"
], $b8135998a0253aa7$var$_excluded2 = [
    "plain",
    "focusIndicator"
];
function $b8135998a0253aa7$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($b8135998a0253aa7$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $b8135998a0253aa7$var$_extends() {
    return $b8135998a0253aa7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b8135998a0253aa7$var$_extends.apply(null, arguments);
}
function $b8135998a0253aa7$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $b8135998a0253aa7$var$sectionTypeToSection = {
    hours: $d4924d95c555d37f$export$558c2e03e4d6f154,
    minutes: $d4924d95c555d37f$export$9996d2c5481efa50,
    seconds: $d4924d95c555d37f$export$7b2413009a7e9b97,
    meridiem: $d4924d95c555d37f$export$37e6e37fe825d0b6
};
var $b8135998a0253aa7$var$getSectionKey = function getSectionKey(section) {
    if (section === $d4924d95c555d37f$export$558c2e03e4d6f154) return 'hour';
    if (section === $d4924d95c555d37f$export$9996d2c5481efa50) return 'minute';
    if (section === $d4924d95c555d37f$export$7b2413009a7e9b97) return 'second';
    return 'period';
};
var $b8135998a0253aa7$var$getSectionToken = function getSectionToken(section) {
    if (section === $d4924d95c555d37f$export$558c2e03e4d6f154) return 'hh';
    if (section === $d4924d95c555d37f$export$9996d2c5481efa50) return 'mm';
    if (section === $d4924d95c555d37f$export$7b2413009a7e9b97) return 'ss';
    return 'aa';
};
var $b8135998a0253aa7$var$getDisplaySectionKey = function getDisplaySectionKey(section) {
    if (section === $d4924d95c555d37f$export$558c2e03e4d6f154) return 'hour';
    if (section === $d4924d95c555d37f$export$9996d2c5481efa50) return 'minute';
    if (section === $d4924d95c555d37f$export$7b2413009a7e9b97) return 'second';
    return 'period';
};
var $b8135998a0253aa7$var$getDisplaySectionPrefix = function getDisplaySectionPrefix(section, index) {
    if (index === 0) return '';
    return section === $d4924d95c555d37f$export$37e6e37fe825d0b6 ? ' ' : ':';
};
var $b8135998a0253aa7$var$getDisplaySectionText = function getDisplaySectionText(_ref) {
    var key = _ref.key, section = _ref.section, sections = _ref.sections;
    if (sections[key] === undefined) return $b8135998a0253aa7$var$getSectionToken(section);
    if (section === $d4924d95c555d37f$export$37e6e37fe825d0b6) return sections[key];
    return (0, $d4924d95c555d37f$export$5d04458e2a6c373e)(sections[key]);
};
var $b8135998a0253aa7$var$getSectionOrder = function getSectionOrder(format, views) {
    var normalizedViews = Array.isArray(views) && views.length ? views : [
        'hours',
        'minutes',
        'seconds'
    ];
    var numericSections = normalizedViews.filter(function(view) {
        return view !== 'meridiem';
    }).map(function(view) {
        return $b8135998a0253aa7$var$sectionTypeToSection[view];
    }).filter(function(section) {
        return section !== undefined;
    });
    if (format === '12') {
        var includePeriod = normalizedViews.includes('meridiem') || normalizedViews.includes('hours');
        if (includePeriod) return [].concat(numericSections, [
            $d4924d95c555d37f$export$37e6e37fe825d0b6
        ]);
    }
    return numericSections;
};
var $b8135998a0253aa7$var$buildPlaceholder = function buildPlaceholder(sectionOrder) {
    return sectionOrder.map(function(section, index) {
        var token = $b8135998a0253aa7$var$getSectionToken(section);
        if (index === 0) return token;
        return "" + (section === $d4924d95c555d37f$export$37e6e37fe825d0b6 ? ' ' : ':') + token;
    }).join('');
};
var $b8135998a0253aa7$var$normalizeStep = function normalizeStep(step) {
    var parsed = Number(step);
    if (!Number.isFinite(parsed) || parsed <= 0) return 1;
    return Math.max(1, Math.floor(parsed));
};
// When `format` isn't explicitly provided, default to the 12/24-hour
// convention the browser's default locale uses, rather than hardcoding one.
var $b8135998a0253aa7$var$getDefaultFormat = function getDefaultFormat() {
    try {
        var _Intl$DateTimeFormat$ = new Intl.DateTimeFormat(undefined, {
            hour: 'numeric'
        }).resolvedOptions(), hour12 = _Intl$DateTimeFormat$.hour12;
        return hour12 ? '12' : '24';
    } catch (_unused) {
        return '24';
    }
};
var $b8135998a0253aa7$var$DEFAULT_FORMAT = $b8135998a0253aa7$var$getDefaultFormat();
var $b8135998a0253aa7$var$TimeInput = $b8135998a0253aa7$export$a1af6f79df847fac = /*#__PURE__*/ (0, $b8135998a0253aa7$var$_react.forwardRef)(function(_ref2, refArg) {
    var _theme$timeInput, _theme$global, _theme$timeInput2;
    var defaultValue = _ref2.defaultValue, disabled = _ref2.disabled, _ref2$format = _ref2.format, format = _ref2$format === void 0 ? $b8135998a0253aa7$var$DEFAULT_FORMAT : _ref2$format, id = _ref2.id, messages = _ref2.messages, _ref2$minuteStep = _ref2.minuteStep, minuteStep = _ref2$minuteStep === void 0 ? 1 : _ref2$minuteStep, name = _ref2.name, onChange = _ref2.onChange, _ref2$readOnly = _ref2.readOnly, readOnly = _ref2$readOnly === void 0 ? false : _ref2$readOnly, valueArg = _ref2.value, rest = $b8135998a0253aa7$var$_objectWithoutPropertiesLoose(_ref2, $b8135998a0253aa7$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var announce = (0, $b8135998a0253aa7$var$_react.useContext)($cfbcb74d4f54e56b$export$dcc8f4bff0d51f50);
    var _useContext = (0, $b8135998a0253aa7$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), formatMessage = _useContext.format;
    var formContext = (0, $b8135998a0253aa7$var$_react.useContext)($b39d3fd88e3f6fd8$export$c24727297075ec6a);
    var useFormInput = formContext.useFormInput;
    var inputRef = (0, $4113023f9e0bafa0$exports.useForwardedRef)(refArg);
    var containerRef = (0, $b8135998a0253aa7$var$_react.useRef)();
    var _useFormInput = useFormInput({
        name: name,
        value: valueArg,
        initialValue: defaultValue || ''
    }), value = _useFormInput[0], setValue = _useFormInput[1];
    (0, $b8135998a0253aa7$var$_react.useEffect)(function() {
        console.warn("Warning: TimeInput is currently in beta. The API is subject to change in future releases.");
    }, []);
    var _formContext$useFormF = formContext.useFormField({}), inForm = _formContext$useFormF.inForm;
    var formFieldLabelId = inForm && id ? "grommet-" + id + "__label" : undefined;
    var groupLabel = formFieldLabelId ? undefined : formatMessage({
        id: 'timeInput.inputLabel',
        messages: messages
    });
    var _useState = (0, $b8135998a0253aa7$var$_react.useState)(false), open = _useState[0], setOpen = _useState[1];
    var _useState2 = (0, $b8135998a0253aa7$var$_react.useState)(false), iconFocused = _useState2[0], setIconFocused = _useState2[1];
    var _useState3 = (0, $b8135998a0253aa7$var$_react.useState)(false), segmentFocused = _useState3[0], setSegmentFocused = _useState3[1];
    var segmentRefs = (0, $b8135998a0253aa7$var$_react.useRef)({});
    var plainProp = rest.plain, focusIndicatorProp = rest.focusIndicator, inputRest = $b8135998a0253aa7$var$_objectWithoutPropertiesLoose(rest, $b8135998a0253aa7$var$_excluded2);
    var normalizedMinuteStep = (0, $b8135998a0253aa7$var$_react.useMemo)(function() {
        return $b8135998a0253aa7$var$normalizeStep(minuteStep);
    }, [
        minuteStep
    ]);
    var handleInvalid = (0, $b8135998a0253aa7$var$_react.useCallback)(function() {
        var error = formatMessage({
            id: 'timeInput.invalidTime',
            messages: messages
        });
        announce(error, 'assertive');
    }, [
        announce,
        formatMessage,
        messages
    ]);
    var announceCurrentValue = (0, $b8135998a0253aa7$var$_react.useCallback)(function(nextSections) {
        if (nextSections.hour === undefined || nextSections.minute === undefined || nextSections.second === undefined) return;
        var period = format === '12' ? " " + (nextSections.period || 'AM') : '';
        announce(formatMessage({
            id: 'timeInput.currentValue',
            messages: messages,
            values: {
                hour: nextSections.hour,
                minute: nextSections.minute,
                second: nextSections.second,
                period: period
            }
        }), 'polite');
    }, [
        announce,
        format,
        formatMessage,
        messages
    ]);
    var sectionOrder = (0, $b8135998a0253aa7$var$_react.useMemo)(function() {
        return $b8135998a0253aa7$var$getSectionOrder(format);
    }, [
        format
    ]);
    var firstSection = sectionOrder[0] || $d4924d95c555d37f$export$558c2e03e4d6f154;
    var lastSection = sectionOrder[sectionOrder.length - 1] || $d4924d95c555d37f$export$558c2e03e4d6f154;
    var _useSectionedTimeFiel = (0, $b6eb4c89f9ba1d7a$export$eb76f452845c0886)({
        format: format,
        sectionOrder: sectionOrder,
        minuteStep: normalizedMinuteStep,
        value: value,
        onCommit: function onCommit(_nextSections, nextValue) {
            if (!nextValue) {
                setValue('');
                onChange == null || onChange({
                    value: undefined
                });
                return;
            }
            setValue(nextValue);
            onChange == null || onChange({
                value: nextValue
            });
            announceCurrentValue(_nextSections);
        },
        onInvalid: handleInvalid
    }), activeSection = _useSectionedTimeFiel.activeSection, applyDigit = _useSectionedTimeFiel.applyDigit, clearActiveSection = _useSectionedTimeFiel.clearActiveSection, commitSections = _useSectionedTimeFiel.commitSections, displayValue = _useSectionedTimeFiel.displayValue, incrementSection = _useSectionedTimeFiel.incrementSection, moveSection = _useSectionedTimeFiel.moveSection, parsePasted = _useSectionedTimeFiel.parsePasted, sections = _useSectionedTimeFiel.sections, setActiveSection = _useSectionedTimeFiel.setActiveSection, setSectionValue = _useSectionedTimeFiel.setSectionValue, pendingDigits = _useSectionedTimeFiel.pendingDigits;
    // Builds the announcement text for a given section: its current value
    // (e.g. "3 hours") if it has one, or just the section name (e.g. "hours
    // selected") when it doesn't yet. Called explicitly on every navigation
    // and edit interaction so screen readers hear meaningful feedback instead
    // of the raw separator/placeholder characters in the native input value.
    var getSectionValueAnnouncement = (0, $b8135998a0253aa7$var$_react.useCallback)(function(section) {
        var sectionName = (0, $d4924d95c555d37f$export$cff89feac2240fd3)(section, format, formatMessage, messages);
        if (section === $d4924d95c555d37f$export$37e6e37fe825d0b6) {
            if (sections.period === undefined) return formatMessage({
                id: 'timeInput.activeSection',
                messages: messages,
                values: {
                    section: sectionName
                }
            });
            return formatMessage({
                id: 'timeInput.activePeriodValue',
                messages: messages,
                values: {
                    period: sections.period
                }
            });
        }
        var sectionKey = $b8135998a0253aa7$var$getSectionKey(section);
        var sectionValue = sections[sectionKey];
        if (sectionValue === undefined) return formatMessage({
            id: 'timeInput.activeSection',
            messages: messages,
            values: {
                section: sectionName
            }
        });
        return formatMessage({
            id: 'timeInput.activeSectionValue',
            messages: messages,
            values: {
                value: sectionValue,
                section: sectionName
            }
        });
    }, [
        format,
        formatMessage,
        messages,
        sections
    ]);
    var focusSection = (0, $b8135998a0253aa7$var$_react.useCallback)(function(section) {
        var target = segmentRefs.current[section];
        if (target) target.focus();
    }, []);
    var placeholder = (0, $b8135998a0253aa7$var$_react.useMemo)(function() {
        return $b8135998a0253aa7$var$buildPlaceholder(sectionOrder);
    }, [
        sectionOrder
    ]);
    var inputValue = displayValue || placeholder;
    var hasDisplayValue = !!displayValue;
    var displaySections = (0, $b8135998a0253aa7$var$_react.useMemo)(function() {
        // Merge sections with pending digits for display
        var displaySectionsData = $b8135998a0253aa7$var$_extends({}, sections);
        var pendingSection = Object.keys(pendingDigits)[0];
        if (pendingSection && pendingDigits[pendingSection] !== undefined) displaySectionsData[pendingSection] = pendingDigits[pendingSection];
        return sectionOrder.map(function(section, index) {
            var key = $b8135998a0253aa7$var$getDisplaySectionKey(section);
            return {
                section: section,
                prefix: $b8135998a0253aa7$var$getDisplaySectionPrefix(section, index),
                text: $b8135998a0253aa7$var$getDisplaySectionText({
                    key: key,
                    section: section,
                    sections: displaySectionsData
                }),
                filled: displaySectionsData[key] !== undefined
            };
        });
    }, [
        sectionOrder,
        sections,
        pendingDigits
    ]);
    var onDisplaySectionMouseDown = (0, $b8135998a0253aa7$var$_react.useCallback)(function(section, event) {
        if (readOnly) return;
        if (disabled) return;
        if (event.button !== 0) return;
        if (event.defaultPrevented) return;
        event.preventDefault();
        event.stopPropagation();
        setSegmentFocused(true);
        setActiveSection(section);
        focusSection(section);
    }, [
        disabled,
        focusSection,
        readOnly,
        setSegmentFocused,
        setActiveSection
    ]);
    var onDisplayMouseDown = (0, $b8135998a0253aa7$var$_react.useCallback)(function(event) {
        var _sectionNode$dataset;
        if (readOnly) return;
        if (event.button !== 0) return;
        if (event.defaultPrevented) return;
        var sectionNode = event.target.closest == null ? void 0 : event.target.closest('[data-section]');
        if ((sectionNode == null || (_sectionNode$dataset = sectionNode.dataset) == null ? void 0 : _sectionNode$dataset.section) !== undefined) {
            var section = Number(sectionNode.dataset.section);
            if (!Number.isNaN(section)) {
                onDisplaySectionMouseDown(section, event);
                return;
            }
        }
        var nodes = Array.from(event.currentTarget.querySelectorAll('[data-section]'));
        if (nodes.length) {
            var _sectionFromBounds$no;
            var x = event.clientX;
            var sectionsWithRects = nodes.map(function(node) {
                return {
                    node: node,
                    rect: node.getBoundingClientRect()
                };
            }).sort(function(a, b) {
                return a.rect.left - b.rect.left;
            });
            var sectionFromBounds = sectionsWithRects.find(function(_ref3) {
                var rect = _ref3.rect;
                return x >= rect.left && x <= rect.right;
            });
            if ((sectionFromBounds == null || (_sectionFromBounds$no = sectionFromBounds.node) == null || (_sectionFromBounds$no = _sectionFromBounds$no.dataset) == null ? void 0 : _sectionFromBounds$no.section) !== undefined) {
                var _section = Number(sectionFromBounds.node.dataset.section);
                if (!Number.isNaN(_section)) {
                    onDisplaySectionMouseDown(_section, event);
                    return;
                }
            }
            var zones = sectionsWithRects.map(function(_ref4, index) {
                var rect = _ref4.rect;
                var prev = sectionsWithRects[index - 1];
                var next = sectionsWithRects[index + 1];
                var start = prev !== undefined ? (prev.rect.right + rect.left) / 2 : Number.NEGATIVE_INFINITY;
                var end = next !== undefined ? (rect.right + next.rect.left) / 2 : Number.POSITIVE_INFINITY;
                return {
                    index: index,
                    start: start,
                    end: end
                };
            });
            var zone = zones.find(function(_ref5) {
                var start = _ref5.start, end = _ref5.end;
                return x >= start && x <= end;
            }) || zones[0] || null;
            if (zone) {
                var _sectionsWithRects$zo, _matched$dataset;
                var matched = (_sectionsWithRects$zo = sectionsWithRects[zone.index]) == null ? void 0 : _sectionsWithRects$zo.node;
                if ((matched == null || (_matched$dataset = matched.dataset) == null ? void 0 : _matched$dataset.section) !== undefined) {
                    var _section2 = Number(matched.dataset.section);
                    if (!Number.isNaN(_section2)) {
                        onDisplaySectionMouseDown(_section2, event);
                        return;
                    }
                }
            }
        }
        event.preventDefault();
        setSegmentFocused(true);
        setActiveSection(firstSection);
        focusSection(firstSection);
    }, [
        firstSection,
        focusSection,
        onDisplaySectionMouseDown,
        readOnly,
        setSegmentFocused,
        setActiveSection
    ]);
    var openPicker = (0, $b8135998a0253aa7$var$_react.useCallback)(function() {
        if (disabled || readOnly) return;
        setActiveSection(firstSection);
        setOpen(true);
    }, [
        disabled,
        firstSection,
        readOnly,
        setActiveSection
    ]);
    var closePicker = (0, $b8135998a0253aa7$var$_react.useCallback)(function() {
        setOpen(false);
        setTimeout(function() {
            focusSection(activeSection);
        }, 0);
    }, [
        activeSection,
        focusSection
    ]);
    var onSegmentFocus = (0, $b8135998a0253aa7$var$_react.useCallback)(function(section) {
        if (!segmentFocused && !readOnly && !disabled && !open) announce(formatMessage({
            id: 'timeInput.openDrop',
            messages: messages
        }));
        setSegmentFocused(true);
        if (readOnly || disabled) return;
        setActiveSection(section);
    }, [
        announce,
        disabled,
        formatMessage,
        messages,
        open,
        readOnly,
        segmentFocused,
        setActiveSection
    ]);
    var onSegmentBlur = (0, $b8135998a0253aa7$var$_react.useCallback)(function() {
        requestAnimationFrame(function() {
            var _document = document, activeElement = _document.activeElement;
            var isSegmentFocused = Object.values(segmentRefs.current).includes(activeElement);
            if (!isSegmentFocused && activeElement === document.body && !readOnly && !disabled) {
                focusSection(activeSection);
                return;
            }
            if (!isSegmentFocused) setSegmentFocused(false);
        });
    }, [
        activeSection,
        disabled,
        focusSection,
        readOnly
    ]);
    var onSegmentKeyDown = (0, $b8135998a0253aa7$var$_react.useCallback)(function(section, event) {
        if (readOnly || disabled) return;
        var key = event.key;
        if (activeSection !== section) setActiveSection(section);
        if (key === 'ArrowRight') {
            event.preventDefault();
            var next = moveSection(1);
            setActiveSection(next);
            focusSection(next);
            return;
        }
        if (key === 'ArrowLeft') {
            event.preventDefault();
            var _next = moveSection(-1);
            setActiveSection(_next);
            focusSection(_next);
            return;
        }
        if (key === 'Home') {
            event.preventDefault();
            setActiveSection(firstSection);
            focusSection(firstSection);
            return;
        }
        if (key === 'End') {
            event.preventDefault();
            setActiveSection(lastSection);
            focusSection(lastSection);
            return;
        }
        if (key === 'ArrowUp') {
            event.preventDefault();
            incrementSection(section, open ? -1 : 1);
            return;
        }
        if (key === 'ArrowDown') {
            if (event.altKey) {
                event.preventDefault();
                openPicker();
                return;
            }
            event.preventDefault();
            incrementSection(section, open ? 1 : -1);
            return;
        }
        if (key === 'Delete' || key === 'Backspace') {
            event.preventDefault();
            clearActiveSection();
            return;
        }
        if (key === 'Enter') {
            event.preventDefault();
            if (open) closePicker();
            return;
        }
        if (key === 'Escape' && open) {
            event.preventDefault();
            closePicker();
            return;
        }
        if (key === ' ' || key === 'Spacebar') {
            event.preventDefault();
            openPicker();
            return;
        }
        if (format === '12' && section === $d4924d95c555d37f$export$37e6e37fe825d0b6) {
            var lower = key.toLowerCase();
            if (lower === 'a') {
                event.preventDefault();
                setSectionValue($d4924d95c555d37f$export$37e6e37fe825d0b6, 'AM');
            } else if (lower === 'p') {
                event.preventDefault();
                setSectionValue($d4924d95c555d37f$export$37e6e37fe825d0b6, 'PM');
            }
            return;
        }
        if (/^\d$/.test(key)) {
            event.preventDefault();
            var _next2 = applyDigit(Number(key));
            var targetSection = _next2 != null ? _next2 : section;
            setActiveSection(targetSection);
            if (targetSection === section) event.currentTarget.focus();
            else focusSection(targetSection);
        }
    }, [
        activeSection,
        applyDigit,
        clearActiveSection,
        closePicker,
        disabled,
        firstSection,
        focusSection,
        format,
        incrementSection,
        lastSection,
        moveSection,
        open,
        openPicker,
        readOnly,
        setActiveSection,
        setSectionValue
    ]);
    (0, $b8135998a0253aa7$var$_react.useEffect)(function() {
        if (!segmentFocused) return;
        if (readOnly || disabled) return;
        var activeSegment = segmentRefs.current[activeSection];
        if (activeSegment && document.activeElement !== activeSegment) activeSegment.focus();
    }, [
        activeSection,
        disabled,
        readOnly,
        segmentFocused
    ]);
    var onSegmentPaste = (0, $b8135998a0253aa7$var$_react.useCallback)(function(event) {
        if (readOnly) {
            event.preventDefault();
            return;
        }
        var pasted = event.clipboardData.getData('text');
        var parsed = parsePasted(pasted);
        if (!parsed) {
            handleInvalid();
            event.preventDefault();
            return;
        }
        commitSections(parsed);
        event.preventDefault();
    }, [
        commitSections,
        handleInvalid,
        parsePasted,
        readOnly
    ]);
    var hoursOptions = (0, $b8135998a0253aa7$var$_react.useMemo)(function() {
        return Array.from({
            length: format === '12' ? 12 : 24
        }, function(_, index) {
            return format === '12' ? index + 1 : index;
        });
    }, [
        format
    ]);
    var minuteOptions = (0, $b8135998a0253aa7$var$_react.useMemo)(function() {
        return Array.from({
            length: Math.ceil(60 / normalizedMinuteStep)
        }, function(_, index) {
            return index * normalizedMinuteStep;
        }).filter(function(valueAtIndex) {
            return valueAtIndex < 60;
        });
    }, [
        normalizedMinuteStep
    ]);
    var secondOptions = (0, $b8135998a0253aa7$var$_react.useMemo)(function() {
        return Array.from({
            length: 60
        }, function(_, index) {
            return index;
        });
    }, []);
    var showActiveSection = (segmentFocused || open) && !readOnly && !disabled;
    return /*#__PURE__*/ $b8135998a0253aa7$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onEsc: open ? closePicker : undefined
    }, /*#__PURE__*/ $b8135998a0253aa7$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, null, /*#__PURE__*/ $b8135998a0253aa7$var$_react["default"].createElement($d48a672a2914e6a7$export$deb3bb5233490f02, $b8135998a0253aa7$var$_extends({
        ref: containerRef,
        direction: "row",
        border: !plainProp,
        fill: true,
        round: ((_theme$timeInput = theme.timeInput) == null || (_theme$timeInput = _theme$timeInput.container) == null ? void 0 : _theme$timeInput.round) || ((_theme$global = theme.global) == null || (_theme$global = _theme$global.control) == null || (_theme$global = _theme$global.border) == null ? void 0 : _theme$global.radius),
        disabled: disabled,
        readOnlyProp: readOnly,
        focusIndicator: (focusIndicatorProp != null ? focusIndicatorProp : true) && !iconFocused
    }, passThemeFlag), /*#__PURE__*/ $b8135998a0253aa7$var$_react["default"].createElement($d48a672a2914e6a7$export$32ae72a65688ceb0, passThemeFlag, /*#__PURE__*/ $b8135998a0253aa7$var$_react["default"].createElement($d48a672a2914e6a7$export$99f3a58a09dbdbb6, $b8135998a0253aa7$var$_extends({
        role: "group",
        "aria-label": groupLabel,
        "aria-labelledby": formFieldLabelId,
        onMouseDown: onDisplayMouseDown
    }, passThemeFlag), displaySections.map(function(_ref6) {
        var section = _ref6.section, prefix = _ref6.prefix, text = _ref6.text, filled = _ref6.filled;
        return /*#__PURE__*/ $b8135998a0253aa7$var$_react["default"].createElement($b8135998a0253aa7$var$_react["default"].Fragment, {
            key: section
        }, !!prefix && /*#__PURE__*/ $b8135998a0253aa7$var$_react["default"].createElement($d48a672a2914e6a7$export$f8cc05fed0b0cc88, $b8135998a0253aa7$var$_extends({
            $filled: hasDisplayValue
        }, passThemeFlag), prefix), /*#__PURE__*/ $b8135998a0253aa7$var$_react["default"].createElement($d48a672a2914e6a7$export$e9cf87fca52843bc, $b8135998a0253aa7$var$_extends({
            ref: function ref(segmentNode) {
                segmentRefs.current[section] = segmentNode;
            },
            tabIndex: !readOnly && !disabled && activeSection === section ? 0 : -1,
            $active: showActiveSection && activeSection === section,
            $filled: filled,
            onFocus: function onFocus() {
                return onSegmentFocus(section);
            },
            onBlur: onSegmentBlur,
            onKeyDown: function onKeyDown(event) {
                return onSegmentKeyDown(section, event);
            },
            onPaste: onSegmentPaste,
            "data-active": showActiveSection && activeSection === section,
            "data-testid": showActiveSection && activeSection === section ? 'time-input-active-section' : undefined,
            "data-section": section
        }, passThemeFlag, {
            "aria-label": (0, $d4924d95c555d37f$export$cff89feac2240fd3)(section, format, formatMessage, messages),
            role: "spinbutton",
            "aria-disabled": disabled || undefined,
            "aria-readonly": readOnly || undefined,
            "aria-valuenow": (0, $d4924d95c555d37f$export$3093877e9aefeaa9)({
                section: section,
                format: format,
                sections: sections
            }).now,
            "aria-valuemin": (0, $d4924d95c555d37f$export$3093877e9aefeaa9)({
                section: section,
                format: format,
                sections: sections
            }).min,
            "aria-valuemax": (0, $d4924d95c555d37f$export$3093877e9aefeaa9)({
                section: section,
                format: format,
                sections: sections
            }).max,
            "aria-valuetext": getSectionValueAnnouncement(section)
        }), text));
    })), /*#__PURE__*/ $b8135998a0253aa7$var$_react["default"].createElement($d48a672a2914e6a7$export$1f156eb46da7cdfb, $b8135998a0253aa7$var$_extends({
        tabIndex: -1
    }, inputRest, {
        id: id,
        ref: inputRef,
        value: inputValue,
        "aria-hidden": "true",
        disabled: disabled,
        readOnly: true,
        focusIndicator: false,
        plain: true
    }))), name && /*#__PURE__*/ $b8135998a0253aa7$var$_react["default"].createElement("input", {
        "aria-hidden": "true",
        name: name,
        readOnly: true,
        tabIndex: -1,
        type: "hidden",
        value: value || ''
    }), !readOnly && /*#__PURE__*/ $b8135998a0253aa7$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
        icon: /*#__PURE__*/ $b8135998a0253aa7$var$_react["default"].createElement($4f80ce31f1e76523$export$9735c82c4bae3302, null),
        plain: true,
        disabled: disabled,
        margin: (_theme$timeInput2 = theme.timeInput) == null || (_theme$timeInput2 = _theme$timeInput2.button) == null ? void 0 : _theme$timeInput2.margin,
        "aria-label": formatMessage({
            id: 'timeInput.chooseTime',
            messages: messages
        }),
        "aria-haspopup": "dialog",
        "aria-expanded": open,
        "aria-controls": id ? id + "__drop" : undefined,
        onFocus: function onFocus() {
            setIconFocused(true);
        },
        onBlur: function onBlur() {
            setIconFocused(false);
        },
        onClick: open ? closePicker : openPicker
    })), open && /*#__PURE__*/ $b8135998a0253aa7$var$_react["default"].createElement($5d72290af5be4136$export$876ed7c9dcced57f, {
        activeSection: activeSection,
        align: {
            top: 'bottom',
            left: 'left'
        },
        dropProps: {
            stretch: false
        },
        format: format,
        formatMessage: formatMessage,
        hoursOptions: hoursOptions,
        id: id,
        incrementSection: incrementSection,
        label: formatMessage({
            id: 'timeInput.chooseTime',
            messages: messages
        }),
        messages: messages,
        minuteOptions: minuteOptions,
        moveSection: moveSection,
        sectionOrder: sectionOrder,
        onClose: closePicker,
        onFocusLeave: closePicker,
        secondOptions: secondOptions,
        sections: sections,
        setActiveSection: setActiveSection,
        setSectionValue: setSectionValue,
        target: containerRef.current
    })));
});
$b8135998a0253aa7$var$TimeInput.displayName = 'TimeInput';
$b8135998a0253aa7$var$TimeInput.propTypes = $d1302124eed5c9bc$export$418e07601dd8a1c5;


$3b61805c70340a15$export$a1af6f79df847fac = $b8135998a0253aa7$export$a1af6f79df847fac;


Object.keys($3b61805c70340a15$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $3b61805c70340a15$exports[key]) return;
    $3321243da0932e1e$exports[key] = $3b61805c70340a15$exports[key];
});

Object.keys($7946e73be6fde87a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $7946e73be6fde87a$exports[key]) return;
    $3321243da0932e1e$exports[key] = $7946e73be6fde87a$exports[key];
});

Object.keys($e235805748ea9d79$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $e235805748ea9d79$exports[key]) return;
    $3321243da0932e1e$exports[key] = $e235805748ea9d79$exports[key];
});
var $c83f11577c188057$exports = {};

$parcel$export($c83f11577c188057$exports, "__esModule", function () { return $c83f11577c188057$export$1e511d4a378977f5; }, function (v) { return $c83f11577c188057$export$1e511d4a378977f5 = v; });
$parcel$export($c83f11577c188057$exports, "ToggleGroup", function () { return $c83f11577c188057$export$af3ec21f6cfb5e30; }, function (v) { return $c83f11577c188057$export$af3ec21f6cfb5e30 = v; });
var $c83f11577c188057$export$1e511d4a378977f5;
var $c83f11577c188057$export$af3ec21f6cfb5e30;
"use strict";
$c83f11577c188057$export$1e511d4a378977f5 = true;
$c83f11577c188057$export$af3ec21f6cfb5e30 = void 0;
var $5a2c9900e20ff671$export$1e511d4a378977f5;
var $5a2c9900e20ff671$export$af3ec21f6cfb5e30;
"use strict";
$5a2c9900e20ff671$export$1e511d4a378977f5 = true;
$5a2c9900e20ff671$export$af3ec21f6cfb5e30 = void 0;

var $5a2c9900e20ff671$var$_react = $5a2c9900e20ff671$var$_interopRequireWildcard((parcelRequire("2xPiy")));


var $be94a914f3cc7f53$export$1e511d4a378977f5;
var $be94a914f3cc7f53$export$e095edad871319ce;
"use strict";
$be94a914f3cc7f53$export$1e511d4a378977f5 = true;
$be94a914f3cc7f53$export$e095edad871319ce = void 0;

var $be94a914f3cc7f53$var$_propTypes = $be94a914f3cc7f53$var$_interopRequireDefault((parcelRequire("dyr1f")));
function $be94a914f3cc7f53$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $be94a914f3cc7f53$var$PropType = {};
$be94a914f3cc7f53$var$PropType = {
    defaultValue: $be94a914f3cc7f53$var$_propTypes["default"].oneOfType([
        $be94a914f3cc7f53$var$_propTypes["default"].string,
        $be94a914f3cc7f53$var$_propTypes["default"].arrayOf($be94a914f3cc7f53$var$_propTypes["default"].string)
    ]),
    multiple: $be94a914f3cc7f53$var$_propTypes["default"].bool,
    onToggle: $be94a914f3cc7f53$var$_propTypes["default"].func,
    options: $be94a914f3cc7f53$var$_propTypes["default"].oneOfType([
        $be94a914f3cc7f53$var$_propTypes["default"].arrayOf($be94a914f3cc7f53$var$_propTypes["default"].string),
        $be94a914f3cc7f53$var$_propTypes["default"].arrayOf($be94a914f3cc7f53$var$_propTypes["default"].shape({
            icon: $be94a914f3cc7f53$var$_propTypes["default"].oneOfType([
                $be94a914f3cc7f53$var$_propTypes["default"].element,
                $be94a914f3cc7f53$var$_propTypes["default"].node
            ]),
            label: $be94a914f3cc7f53$var$_propTypes["default"].oneOfType([
                $be94a914f3cc7f53$var$_propTypes["default"].string,
                $be94a914f3cc7f53$var$_propTypes["default"].element
            ]),
            value: $be94a914f3cc7f53$var$_propTypes["default"].string,
            tip: $be94a914f3cc7f53$var$_propTypes["default"].string
        }))
    ]),
    value: $be94a914f3cc7f53$var$_propTypes["default"].oneOfType([
        $be94a914f3cc7f53$var$_propTypes["default"].string,
        $be94a914f3cc7f53$var$_propTypes["default"].arrayOf($be94a914f3cc7f53$var$_propTypes["default"].string)
    ])
};
var $be94a914f3cc7f53$var$ToggleGroupPropTypes = $be94a914f3cc7f53$export$e095edad871319ce = $be94a914f3cc7f53$var$PropType;


var $d786803b1c8cc761$export$1e511d4a378977f5;
var $d786803b1c8cc761$export$2d5d2ba3c7c8c40b;
var $d786803b1c8cc761$export$d675f139b342d51a;
"use strict";
$d786803b1c8cc761$export$1e511d4a378977f5 = true;
$d786803b1c8cc761$export$2d5d2ba3c7c8c40b = $d786803b1c8cc761$export$d675f139b342d51a = void 0;

var $d786803b1c8cc761$var$_styledComponents = $d786803b1c8cc761$var$_interopRequireDefault((parcelRequire("iA1nz")));



function $d786803b1c8cc761$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $d786803b1c8cc761$var$adjustPad = function adjustPad(value, theme) {
    // resolve t-shirt size if it exists
    var vertical = typeof value === 'string' ? value : value == null ? void 0 : value.vertical;
    vertical = theme.global.edgeSize[vertical] || vertical;
    var horizontal = typeof value === 'string' ? value : value == null ? void 0 : value.horizontal;
    horizontal = theme.global.edgeSize[horizontal] || horizontal;
    var borderWidth = (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.global.borderSize.xsmall);
    vertical = Math.max((0, $4113023f9e0bafa0$exports.parseMetricToNum)(vertical) - borderWidth, 0) + "px";
    horizontal = Math.max((0, $4113023f9e0bafa0$exports.parseMetricToNum)(horizontal) - borderWidth, 0) + "px";
    return {
        vertical: vertical,
        horizontal: horizontal
    };
};
var $d786803b1c8cc761$var$StyledButton = $d786803b1c8cc761$export$2d5d2ba3c7c8c40b = (0, $d786803b1c8cc761$var$_styledComponents["default"])($fb68f765668b25d0$export$353f5b6fc5456de1).withConfig({
    displayName: "StyledToggleGroup__StyledButton",
    componentId: "sc-13k5sx8-0"
})([
    "",
    " ",
    ";",
    " &:hover{",
    "}"
], function(props) {
    return !props.kind && "border: none;";
}, function(props) {
    return !props.kind && [
        'border-radius: 0;',
        props.round && (0, $4113023f9e0bafa0$exports.roundStyle)(props.round, false, props.theme)
    ];
}, function(props) {
    var _props$theme, _props$theme2, _props$theme3, _props$theme4, _props$theme5;
    var themePad = props.icon && !props.label && (_props$theme = props.theme) != null && (_props$theme = _props$theme.toggleGroup) != null && (_props$theme = _props$theme.button) != null && (_props$theme = _props$theme.iconOnly) != null && _props$theme.pad ? (_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.toggleGroup) == null || (_props$theme2 = _props$theme2.button) == null || (_props$theme2 = _props$theme2.iconOnly) == null ? void 0 : _props$theme2.pad : (_props$theme3 = props.theme) == null || (_props$theme3 = _props$theme3.toggleGroup.button) == null ? void 0 : _props$theme3.pad;
    // adjust pad for "kind" themes to align with how "kind" themes
    // manages this calculation
    var pad = (_props$theme4 = props.theme) != null && (_props$theme4 = _props$theme4.button) != null && _props$theme4["default"] && (_props$theme5 = props.theme) != null && (_props$theme5 = _props$theme5.button) != null && _props$theme5.intelligentPad ? $d786803b1c8cc761$var$adjustPad(themePad, props.theme) : themePad;
    return !props.kind && (0, $4113023f9e0bafa0$exports.edgeStyle)('padding', pad, false, undefined, props.theme);
}, function(props) {
    return(// remove hover style from StyledButton/StyledButtonKind theme
    !props.kind && "border: none;\n    box-shadow: none;");
});
var $d786803b1c8cc761$var$StyledBox = $d786803b1c8cc761$export$d675f139b342d51a = (0, $d786803b1c8cc761$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "StyledToggleGroup__StyledBox",
    componentId: "sc-13k5sx8-1"
})([
    "",
    ";"
], function(props) {
    var _props$theme$toggleGr;
    return (_props$theme$toggleGr = props.theme.toggleGroup) == null || (_props$theme$toggleGr = _props$theme$toggleGr.container) == null ? void 0 : _props$theme$toggleGr.extend;
});



var $5a2c9900e20ff671$var$_excluded = [
    "defaultValue",
    "multiple",
    "options",
    "onToggle",
    "value"
];
function $5a2c9900e20ff671$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($5a2c9900e20ff671$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $5a2c9900e20ff671$var$_extends() {
    return $5a2c9900e20ff671$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5a2c9900e20ff671$var$_extends.apply(null, arguments);
}
function $5a2c9900e20ff671$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $5a2c9900e20ff671$var$useControlled = function useControlled(_ref) {
    var prop = _ref.prop, defaultProp = _ref.defaultProp, _ref$onChange = _ref.onChange, onChange = _ref$onChange === void 0 ? function() {} : _ref$onChange;
    var _useState = (0, $5a2c9900e20ff671$var$_react.useState)(defaultProp), uncontrolledProp = _useState[0], setUncontrolledProp = _useState[1];
    var controlled = prop !== undefined;
    var value = controlled ? prop : uncontrolledProp;
    var handleChange = (0, $5a2c9900e20ff671$var$_react.useCallback)(onChange, [
        onChange
    ]);
    var setValue = (0, $5a2c9900e20ff671$var$_react.useCallback)(function(event) {
        // only update internal value in uncontrolled cases
        if (!controlled) setUncontrolledProp(event.value);
        handleChange(event);
    }, [
        controlled,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value,
        setValue
    ];
};
var $5a2c9900e20ff671$var$ToggleGroup = $5a2c9900e20ff671$export$af3ec21f6cfb5e30 = function ToggleGroup(_ref2) {
    var defaultValue = _ref2.defaultValue, multiple = _ref2.multiple, options = _ref2.options, onToggle = _ref2.onToggle, valueProp = _ref2.value, rest = $5a2c9900e20ff671$var$_objectWithoutPropertiesLoose(_ref2, $5a2c9900e20ff671$var$_excluded);
    var _useControlled = $5a2c9900e20ff671$var$useControlled({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onToggle
    }), _useControlled$ = _useControlled[0], value = _useControlled$ === void 0 ? multiple ? [] : '' : _useControlled$, setValue = _useControlled[1];
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var ref = (0, $5a2c9900e20ff671$var$_react.useRef)();
    var buttonRefs = (0, $5a2c9900e20ff671$var$_react.useRef)([]);
    var values = options == null ? void 0 : options.map(function(option) {
        return typeof option === 'object' ? option.value : option;
    });
    var getFocusableIndex = (0, $5a2c9900e20ff671$var$_react.useCallback)(function() {
        var defaultIndex = 0;
        if (value.length) // set earliest button that's part of value to active
        // assume that value might not be ordered the same as options
        defaultIndex = values.indexOf(values.find(function(option) {
            return value.includes(option);
        }));
        return defaultIndex;
    }, [
        value,
        values
    ]);
    var _useState2 = (0, $5a2c9900e20ff671$var$_react.useState)(function() {
        return getFocusableIndex();
    }), focusableIndex = _useState2[0], setFocusableIndex = _useState2[1];
    var onNext = function onNext(e) {
        // prevent page scroll
        e.preventDefault();
        var nextIndex = focusableIndex + 1 <= options.length - 1 ? focusableIndex + 1 : 0;
        setFocusableIndex(nextIndex);
        buttonRefs.current[nextIndex].focus();
    };
    var onPrevious = function onPrevious(e) {
        // prevent page scroll
        e.preventDefault();
        var nextIndex = focusableIndex - 1 >= 0 ? focusableIndex - 1 : options.length - 1;
        setFocusableIndex(nextIndex);
        buttonRefs.current[nextIndex].focus();
    };
    var handleToggle = function handleToggle(event, option) {
        var adjustedEvent = event;
        var nextValue;
        if (!multiple) nextValue = option;
        else nextValue = value.includes(option) ? value.filter(function(item) {
            return item !== option;
        }) : [].concat(value, [
            option
        ]);
        adjustedEvent.value = nextValue;
        setValue(adjustedEvent);
    };
    // if caller defines a button "kind", respect that kind style
    var kind = (0, $5a2c9900e20ff671$var$_react.useMemo)(function() {
        return theme.toggleGroup.button.kind;
    }, [
        theme.toggleGroup.button
    ]);
    return /*#__PURE__*/ $5a2c9900e20ff671$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onUp: onPrevious,
        onDown: onNext,
        onLeft: onPrevious,
        onRight: onNext
    }, /*#__PURE__*/ $5a2c9900e20ff671$var$_react["default"].createElement($d786803b1c8cc761$export$d675f139b342d51a, $5a2c9900e20ff671$var$_extends({
        ref: ref,
        alignSelf: "start",
        direction: "row",
        flex: false,
        onBlur: function onBlur(e) {
            if (!(ref != null && ref.current.contains(e.relatedTarget))) setFocusableIndex(getFocusableIndex());
        }
    }, theme.toggleGroup.container, {
        // match button rounding
        responsive: false,
        role: multiple ? 'group' : 'radiogroup'
    }, rest), options == null ? void 0 : options.map(function(option, index) {
        var label;
        var icon;
        var optionValue;
        var tip;
        if (typeof option === 'object') {
            icon = option.icon;
            label = option.label;
            tip = option.tip;
            optionValue = option.value;
        } else {
            label = option;
            optionValue = option;
        }
        var active = Array.isArray(value) ? !!value.includes(optionValue) : value === optionValue;
        var round;
        if (!kind) {
            var _theme$toggleGroup$bu;
            if ((_theme$toggleGroup$bu = theme.toggleGroup.button.border) != null && _theme$toggleGroup$bu.radius) round = theme.toggleGroup.button.border.radius;
            else if (typeof theme.toggleGroup.container.round === 'string' && (index === 0 || index === options.length - 1)) // round corners of first and last buttons to match container
            round = {
                corner: index === 0 ? 'left' : 'right',
                size: theme.toggleGroup.container.round
            };
            else round = 0;
        }
        return /*#__PURE__*/ $5a2c9900e20ff671$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            border: index < options.length - 1 && theme.toggleGroup.divider ? {
                side: 'right',
                color: theme.toggleGroup.divider.color
            } : undefined,
            key: optionValue || index
        }, /*#__PURE__*/ $5a2c9900e20ff671$var$_react["default"].createElement($d786803b1c8cc761$export$2d5d2ba3c7c8c40b, $5a2c9900e20ff671$var$_extends({
            active: active,
            "aria-pressed": multiple ? active : undefined,
            "aria-checked": !multiple ? active : undefined,
            icon: icon,
            kind: kind,
            label: label,
            tip: tip,
            onClick: function onClick(event) {
                return handleToggle(event, optionValue);
            },
            ref: function ref(r) {
                buttonRefs.current[index] = r;
            },
            role: !multiple ? 'radio' : undefined,
            round: round,
            tabIndex: index === focusableIndex ? '0' : '-1'
        }, passThemeFlag)));
    })));
};
$5a2c9900e20ff671$var$ToggleGroup.displayName = 'ToggleGroup';
$5a2c9900e20ff671$var$ToggleGroup.propTypes = $be94a914f3cc7f53$export$e095edad871319ce;


$c83f11577c188057$export$af3ec21f6cfb5e30 = $5a2c9900e20ff671$export$af3ec21f6cfb5e30;


Object.keys($c83f11577c188057$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $c83f11577c188057$exports[key]) return;
    $3321243da0932e1e$exports[key] = $c83f11577c188057$exports[key];
});
var $0a685b336b69be75$exports = {};

$parcel$export($0a685b336b69be75$exports, "__esModule", function () { return $0a685b336b69be75$export$1e511d4a378977f5; }, function (v) { return $0a685b336b69be75$export$1e511d4a378977f5 = v; });
$parcel$export($0a685b336b69be75$exports, "ThumbsRating", function () { return $0a685b336b69be75$export$1f46263fb4d4a2d4; }, function (v) { return $0a685b336b69be75$export$1f46263fb4d4a2d4 = v; });
var $0a685b336b69be75$export$1e511d4a378977f5;
var $0a685b336b69be75$export$1f46263fb4d4a2d4;
"use strict";
$0a685b336b69be75$export$1e511d4a378977f5 = true;
$0a685b336b69be75$export$1f46263fb4d4a2d4 = void 0;
var $9211904f1019140a$export$1e511d4a378977f5;
var $9211904f1019140a$export$1f46263fb4d4a2d4;
"use strict";
$9211904f1019140a$export$1e511d4a378977f5 = true;
$9211904f1019140a$export$1f46263fb4d4a2d4 = void 0;

var $9211904f1019140a$var$_react = $9211904f1019140a$var$_interopRequireDefault((parcelRequire("2xPiy")));

var $9211904f1019140a$var$_styledComponents = $9211904f1019140a$var$_interopRequireDefault((parcelRequire("iA1nz")));
var $fdfa878ef43b4b5a$exports = {};

$parcel$export($fdfa878ef43b4b5a$exports, "__esModule", function () { return $fdfa878ef43b4b5a$export$1e511d4a378977f5; }, function (v) { return $fdfa878ef43b4b5a$export$1e511d4a378977f5 = v; });
$parcel$export($fdfa878ef43b4b5a$exports, "Like", function () { return $fdfa878ef43b4b5a$export$6f56a75b829de4f0; }, function (v) { return $fdfa878ef43b4b5a$export$6f56a75b829de4f0 = v; });
var $fdfa878ef43b4b5a$export$1e511d4a378977f5;
var $fdfa878ef43b4b5a$export$6f56a75b829de4f0;
"use strict";
$fdfa878ef43b4b5a$export$1e511d4a378977f5 = true;
$fdfa878ef43b4b5a$export$6f56a75b829de4f0 = void 0;

var $fdfa878ef43b4b5a$var$_react = $fdfa878ef43b4b5a$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $fdfa878ef43b4b5a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($fdfa878ef43b4b5a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $fdfa878ef43b4b5a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $fdfa878ef43b4b5a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $fdfa878ef43b4b5a$var$_extends() {
    return $fdfa878ef43b4b5a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fdfa878ef43b4b5a$var$_extends.apply(null, arguments);
}
var $fdfa878ef43b4b5a$var$Like = $fdfa878ef43b4b5a$export$6f56a75b829de4f0 = /*#__PURE__*/ (0, $fdfa878ef43b4b5a$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $fdfa878ef43b4b5a$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $fdfa878ef43b4b5a$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Like"
    }, props), /*#__PURE__*/ $fdfa878ef43b4b5a$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 23h19c2 0 3-1 3-3V10h-7V4c0-2-1-3-3-3h-2s-.016 6-.016 7.326C10.984 9.652 10 11 8 11H1v12zm5 0V11"
    }));
});
$fdfa878ef43b4b5a$var$Like.displayName = 'Like';


var $16ad2167e9742ca9$exports = {};

$parcel$export($16ad2167e9742ca9$exports, "__esModule", function () { return $16ad2167e9742ca9$export$1e511d4a378977f5; }, function (v) { return $16ad2167e9742ca9$export$1e511d4a378977f5 = v; });
$parcel$export($16ad2167e9742ca9$exports, "LikeFill", function () { return $16ad2167e9742ca9$export$137a6f1e0b9d2878; }, function (v) { return $16ad2167e9742ca9$export$137a6f1e0b9d2878 = v; });
var $16ad2167e9742ca9$export$1e511d4a378977f5;
var $16ad2167e9742ca9$export$137a6f1e0b9d2878;
"use strict";
$16ad2167e9742ca9$export$1e511d4a378977f5 = true;
$16ad2167e9742ca9$export$137a6f1e0b9d2878 = void 0;

var $16ad2167e9742ca9$var$_react = $16ad2167e9742ca9$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $16ad2167e9742ca9$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($16ad2167e9742ca9$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $16ad2167e9742ca9$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $16ad2167e9742ca9$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $16ad2167e9742ca9$var$_extends() {
    return $16ad2167e9742ca9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $16ad2167e9742ca9$var$_extends.apply(null, arguments);
}
var $16ad2167e9742ca9$var$LikeFill = $16ad2167e9742ca9$export$137a6f1e0b9d2878 = /*#__PURE__*/ (0, $16ad2167e9742ca9$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $16ad2167e9742ca9$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $16ad2167e9742ca9$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Like"
    }, props), /*#__PURE__*/ $16ad2167e9742ca9$var$_react["default"].createElement("path", {
        stroke: "#000",
        fillRule: "evenodd",
        d: "M11 0h-.997L10 .997 11 1l-1-.003v.261l-.002.698-.006 2.207a2728.4 2728.4 0 0 0-.008 4.163c0 .42-.155.83-.454 1.132C9.243 9.749 8.763 10 8 10H1.001L1 11v-1H0v14h1v-1 1h19c1.154 0 2.203-.29 2.957-1.043C23.711 22.203 24 21.154 24 20v-9.999L23 10h1V9h-7V4c0-1.154-.29-2.203-1.043-2.957C15.203.289 14.154 0 13 0h-2ZM5 12v10H2V12h3Z",
        clipRule: "evenodd"
    }));
});
$16ad2167e9742ca9$var$LikeFill.displayName = 'LikeFill';


var $7ef108730670d60a$exports = {};

$parcel$export($7ef108730670d60a$exports, "__esModule", function () { return $7ef108730670d60a$export$1e511d4a378977f5; }, function (v) { return $7ef108730670d60a$export$1e511d4a378977f5 = v; });
$parcel$export($7ef108730670d60a$exports, "Dislike", function () { return $7ef108730670d60a$export$a8449069a293ea9f; }, function (v) { return $7ef108730670d60a$export$a8449069a293ea9f = v; });
var $7ef108730670d60a$export$1e511d4a378977f5;
var $7ef108730670d60a$export$a8449069a293ea9f;
"use strict";
$7ef108730670d60a$export$1e511d4a378977f5 = true;
$7ef108730670d60a$export$a8449069a293ea9f = void 0;

var $7ef108730670d60a$var$_react = $7ef108730670d60a$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $7ef108730670d60a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7ef108730670d60a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7ef108730670d60a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $7ef108730670d60a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7ef108730670d60a$var$_extends() {
    return $7ef108730670d60a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7ef108730670d60a$var$_extends.apply(null, arguments);
}
var $7ef108730670d60a$var$Dislike = $7ef108730670d60a$export$a8449069a293ea9f = /*#__PURE__*/ (0, $7ef108730670d60a$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $7ef108730670d60a$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $7ef108730670d60a$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Dislike"
    }, props), /*#__PURE__*/ $7ef108730670d60a$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M23 1H4C2 1 1 2 1 4v10h7v6c0 2 1 3 3 3h2s.016-6 .016-7.326C13.016 14.348 14 13 16 13h7V1zm-5 0v12"
    }));
});
$7ef108730670d60a$var$Dislike.displayName = 'Dislike';


var $3fa9fa210ed638fa$exports = {};

$parcel$export($3fa9fa210ed638fa$exports, "__esModule", function () { return $3fa9fa210ed638fa$export$1e511d4a378977f5; }, function (v) { return $3fa9fa210ed638fa$export$1e511d4a378977f5 = v; });
$parcel$export($3fa9fa210ed638fa$exports, "DislikeFill", function () { return $3fa9fa210ed638fa$export$bc96159b6e5be7ec; }, function (v) { return $3fa9fa210ed638fa$export$bc96159b6e5be7ec = v; });
var $3fa9fa210ed638fa$export$1e511d4a378977f5;
var $3fa9fa210ed638fa$export$bc96159b6e5be7ec;
"use strict";
$3fa9fa210ed638fa$export$1e511d4a378977f5 = true;
$3fa9fa210ed638fa$export$bc96159b6e5be7ec = void 0;

var $3fa9fa210ed638fa$var$_react = $3fa9fa210ed638fa$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $3fa9fa210ed638fa$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3fa9fa210ed638fa$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3fa9fa210ed638fa$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3fa9fa210ed638fa$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3fa9fa210ed638fa$var$_extends() {
    return $3fa9fa210ed638fa$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3fa9fa210ed638fa$var$_extends.apply(null, arguments);
}
var $3fa9fa210ed638fa$var$DislikeFill = $3fa9fa210ed638fa$export$bc96159b6e5be7ec = /*#__PURE__*/ (0, $3fa9fa210ed638fa$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3fa9fa210ed638fa$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3fa9fa210ed638fa$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Dislike"
    }, props), /*#__PURE__*/ $3fa9fa210ed638fa$var$_react["default"].createElement("path", {
        stroke: "#000",
        fillRule: "evenodd",
        d: "M13 24h.997l.003-.997L13 23l1 .003v-.261l.002-.698.006-2.207c.004-1.665.008-3.498.008-4.163 0-.42.155-.83.454-1.132.287-.291.767-.542 1.53-.542h6.999L23 13v1h1V0h-1v1-1H4C2.846 0 1.797.29 1.043 1.043.289 1.797 0 2.846 0 4v9.999L1 14H0v1h7v5c0 1.154.29 2.203 1.043 2.957C8.797 23.711 9.846 24 11 24h2Zm6-12V2h3v10h-3Z",
        clipRule: "evenodd"
    }));
});
$3fa9fa210ed638fa$var$DislikeFill.displayName = 'DislikeFill';






function $9211904f1019140a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $9211904f1019140a$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $9211904f1019140a$var$_extends() {
    return $9211904f1019140a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9211904f1019140a$var$_extends.apply(null, arguments);
}
var $9211904f1019140a$var$StyledThumbsRatingBox = (0, $9211904f1019140a$var$_styledComponents["default"])($090ffb0ba78fff3f$export$e71c4d32a2263218).withConfig({
    displayName: "ThumbsRating__StyledThumbsRatingBox",
    componentId: "sc-1xsgzvn-0"
})([
    "",
    ";"
], function(props) {
    return props.focus && (0, $4113023f9e0bafa0$exports.focusStyle)();
});
var $9211904f1019140a$var$ThumbsRating = $9211904f1019140a$export$1f46263fb4d4a2d4 = function ThumbsRating(_ref) {
    var _theme$thumbsRating, _theme$thumbsRating2, _theme$thumbsRating3, _theme$thumbsRating4;
    var rest = $9211904f1019140a$var$_extends({}, ($9211904f1019140a$var$_objectDestructuringEmpty(_ref), _ref));
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var usingKeyboard = (0, $4113023f9e0bafa0$exports.useKeyboard)();
    var LikeIcon = ((_theme$thumbsRating = theme.thumbsRating) == null || (_theme$thumbsRating = _theme$thumbsRating.icons) == null ? void 0 : _theme$thumbsRating.like) || $fdfa878ef43b4b5a$export$6f56a75b829de4f0;
    var LikeSelectedIcon = ((_theme$thumbsRating2 = theme.thumbsRating) == null || (_theme$thumbsRating2 = _theme$thumbsRating2.icons) == null ? void 0 : _theme$thumbsRating2.likeSelected) || $16ad2167e9742ca9$export$137a6f1e0b9d2878;
    var DislikeIcon = ((_theme$thumbsRating3 = theme.thumbsRating) == null || (_theme$thumbsRating3 = _theme$thumbsRating3.icons) == null ? void 0 : _theme$thumbsRating3.dislike) || $7ef108730670d60a$export$a8449069a293ea9f;
    var DislikeSelectedIcon = ((_theme$thumbsRating4 = theme.thumbsRating) == null || (_theme$thumbsRating4 = _theme$thumbsRating4.icons) == null ? void 0 : _theme$thumbsRating4.dislikeSelected) || $3fa9fa210ed638fa$export$bc96159b6e5be7ec;
    return /*#__PURE__*/ $9211904f1019140a$var$_react["default"].createElement($49bedb3ed8912461$export$c062ce1cc79ad58a, $9211904f1019140a$var$_extends({
        direction: "row",
        options: [
            'like',
            'dislike'
        ]
    }, rest), function(option, _ref2) {
        var _theme$thumbsRating7, _theme$thumbsRating8;
        var checked = _ref2.checked, focus = _ref2.focus;
        if (option === 'like') {
            var _theme$thumbsRating5, _theme$thumbsRating6;
            return /*#__PURE__*/ $9211904f1019140a$var$_react["default"].createElement($9211904f1019140a$var$StyledThumbsRatingBox, {
                focus: focus && usingKeyboard
            }, checked ? /*#__PURE__*/ $9211904f1019140a$var$_react["default"].createElement(LikeSelectedIcon, {
                color: (_theme$thumbsRating5 = theme.thumbsRating) == null || (_theme$thumbsRating5 = _theme$thumbsRating5.like) == null ? void 0 : _theme$thumbsRating5.color
            }) : /*#__PURE__*/ $9211904f1019140a$var$_react["default"].createElement(LikeIcon, {
                color: (_theme$thumbsRating6 = theme.thumbsRating) == null || (_theme$thumbsRating6 = _theme$thumbsRating6.like) == null ? void 0 : _theme$thumbsRating6.color
            }));
        }
        return /*#__PURE__*/ $9211904f1019140a$var$_react["default"].createElement($9211904f1019140a$var$StyledThumbsRatingBox, {
            focus: focus && usingKeyboard
        }, checked ? /*#__PURE__*/ $9211904f1019140a$var$_react["default"].createElement(DislikeSelectedIcon, {
            color: (_theme$thumbsRating7 = theme.thumbsRating) == null || (_theme$thumbsRating7 = _theme$thumbsRating7.dislike) == null ? void 0 : _theme$thumbsRating7.color
        }) : /*#__PURE__*/ $9211904f1019140a$var$_react["default"].createElement(DislikeIcon, {
            color: (_theme$thumbsRating8 = theme.thumbsRating) == null || (_theme$thumbsRating8 = _theme$thumbsRating8.dislike) == null ? void 0 : _theme$thumbsRating8.color
        }));
    });
};
$9211904f1019140a$var$ThumbsRating.displayName = 'ThumbsRating';


$0a685b336b69be75$export$1f46263fb4d4a2d4 = $9211904f1019140a$export$1f46263fb4d4a2d4;


Object.keys($0a685b336b69be75$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $0a685b336b69be75$exports[key]) return;
    $3321243da0932e1e$exports[key] = $0a685b336b69be75$exports[key];
});
var $e230244fdd1d67b9$exports = {};

$parcel$export($e230244fdd1d67b9$exports, "__esModule", function () { return $e230244fdd1d67b9$export$1e511d4a378977f5; }, function (v) { return $e230244fdd1d67b9$export$1e511d4a378977f5 = v; });
$parcel$export($e230244fdd1d67b9$exports, "Video", function () { return $e230244fdd1d67b9$export$ae01dedf5c052bb; }, function (v) { return $e230244fdd1d67b9$export$ae01dedf5c052bb = v; });
var $e230244fdd1d67b9$export$1e511d4a378977f5;
var $e230244fdd1d67b9$export$ae01dedf5c052bb;
"use strict";
$e230244fdd1d67b9$export$1e511d4a378977f5 = true;
$e230244fdd1d67b9$export$ae01dedf5c052bb = void 0;
var $d1e2ac476456ddc8$export$1e511d4a378977f5;
var $d1e2ac476456ddc8$export$ae01dedf5c052bb;
"use strict";
$d1e2ac476456ddc8$export$1e511d4a378977f5 = true;
$d1e2ac476456ddc8$export$ae01dedf5c052bb = void 0;

var $d1e2ac476456ddc8$var$_react = $d1e2ac476456ddc8$var$_interopRequireWildcard((parcelRequire("2xPiy")));










var $c11fd31f3f2f357c$export$1e511d4a378977f5;
var $c11fd31f3f2f357c$export$abea7d87552f46bc;
var $c11fd31f3f2f357c$export$7751399fc290cffb;
var $c11fd31f3f2f357c$export$6b75c55b46d797c5;
var $c11fd31f3f2f357c$export$b230c172e26df666;
"use strict";
$c11fd31f3f2f357c$export$1e511d4a378977f5 = true;
$c11fd31f3f2f357c$export$abea7d87552f46bc = $c11fd31f3f2f357c$export$7751399fc290cffb = $c11fd31f3f2f357c$export$6b75c55b46d797c5 = $c11fd31f3f2f357c$export$b230c172e26df666 = void 0;

var $c11fd31f3f2f357c$var$_styledComponents = $c11fd31f3f2f357c$var$_interopRequireWildcard((parcelRequire("iA1nz")));

function $c11fd31f3f2f357c$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($c11fd31f3f2f357c$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $c11fd31f3f2f357c$var$FIT_MAP = {
    cover: 'cover',
    contain: 'contain'
};
var $c11fd31f3f2f357c$var$fitStyle = (0, $c11fd31f3f2f357c$var$_styledComponents.css)([
    "flex:1 1;min-height:0;object-fit:",
    ";"
], function(props) {
    return $c11fd31f3f2f357c$var$FIT_MAP[props.fit];
});
// z-index is for Safari so controls aren't hidden
var $c11fd31f3f2f357c$var$StyledVideo = $c11fd31f3f2f357c$export$b230c172e26df666 = $c11fd31f3f2f357c$var$_styledComponents["default"].video.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledVideo",
    componentId: "sc-w4v8h9-0"
})([
    "max-width:100%;z-index:1;",
    " ::cue{background:",
    ";}",
    ";"
], function(props) {
    return props.fit && $c11fd31f3f2f357c$var$fitStyle;
}, function(props) {
    return props.theme.video.captions.background;
}, function(props) {
    return props.theme.video && props.theme.video.extend;
});
var $c11fd31f3f2f357c$var$StyledVideoContainer = $c11fd31f3f2f357c$export$6b75c55b46d797c5 = $c11fd31f3f2f357c$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledVideo__StyledVideoContainer",
    componentId: "sc-w4v8h9-1"
})([
    "flex:1 1;display:flex;flex-direction:column;overflow:hidden;position:relative;",
    ";&:focus{",
    "}"
], $4113023f9e0bafa0$exports.genericStyles, (0, $4113023f9e0bafa0$exports.focusStyle)());
// z-index is for Safari so controls aren't hidden
var $c11fd31f3f2f357c$var$positionStyle = (0, $c11fd31f3f2f357c$var$_styledComponents.css)([
    "position:absolute;left:0;right:0;bottom:0;z-index:1;"
]);
var $c11fd31f3f2f357c$var$StyledVideoControls = $c11fd31f3f2f357c$export$7751399fc290cffb = $c11fd31f3f2f357c$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledVideo__StyledVideoControls",
    componentId: "sc-w4v8h9-2"
})([
    "flex:0 0;",
    " opacity:0;transition:opacity 0.3s;",
    ";"
], function(props) {
    return props.over && $c11fd31f3f2f357c$var$positionStyle;
}, function(props) {
    return props.active ? 'opacity: 1;' : 'pointer-events: none';
});
var $c11fd31f3f2f357c$var$headStyle = (0, $c11fd31f3f2f357c$var$_styledComponents.css)([
    "::after{content:'';height:100%;width:",
    ";background:",
    ";position:absolute;left:",
    ";}"
], function(props) {
    return props.theme.global.edgeSize.xsmall;
}, function(props) {
    return (0, $4113023f9e0bafa0$exports.normalizeColor)(props.theme.video.scrubber.color, props.theme);
}, function(props) {
    return props.value + "%";
});
var $c11fd31f3f2f357c$var$StyledVideoScrubber = $c11fd31f3f2f357c$export$abea7d87552f46bc = $c11fd31f3f2f357c$var$_styledComponents["default"].div.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledVideo__StyledVideoScrubber",
    componentId: "sc-w4v8h9-3"
})([
    "cursor:pointer;width:100%;height:100%;",
    ";&:focus{",
    "}"
], function(props) {
    return props.value && $c11fd31f3f2f357c$var$headStyle;
}, (0, $4113023f9e0bafa0$exports.focusStyle)());



var $8c6bdbc55a49273c$export$1e511d4a378977f5;
var $8c6bdbc55a49273c$export$4c48a52d3ce6ecbb;
"use strict";
$8c6bdbc55a49273c$export$1e511d4a378977f5 = true;
$8c6bdbc55a49273c$export$4c48a52d3ce6ecbb = void 0;

var $8c6bdbc55a49273c$var$_propTypes = $8c6bdbc55a49273c$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $8c6bdbc55a49273c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $8c6bdbc55a49273c$var$_extends() {
    return $8c6bdbc55a49273c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8c6bdbc55a49273c$var$_extends.apply(null, arguments);
}
var $8c6bdbc55a49273c$var$PropType = {};
$8c6bdbc55a49273c$var$PropType = $8c6bdbc55a49273c$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    autoPlay: $8c6bdbc55a49273c$var$_propTypes["default"].bool,
    controls: $8c6bdbc55a49273c$var$_propTypes["default"].oneOfType([
        $8c6bdbc55a49273c$var$_propTypes["default"].oneOf([
            false,
            'over',
            'below'
        ]),
        $8c6bdbc55a49273c$var$_propTypes["default"].shape({
            position: $8c6bdbc55a49273c$var$_propTypes["default"].oneOf([
                false,
                'over',
                'below'
            ]),
            items: $8c6bdbc55a49273c$var$_propTypes["default"].arrayOf($8c6bdbc55a49273c$var$_propTypes["default"].oneOfType([
                $8c6bdbc55a49273c$var$_propTypes["default"].oneOf([
                    'captions',
                    'descriptions',
                    'fullScreen',
                    'play',
                    'pause',
                    'volume'
                ]),
                $8c6bdbc55a49273c$var$_propTypes["default"].shape({
                    icon: $8c6bdbc55a49273c$var$_propTypes["default"].element,
                    a11yTitle: $8c6bdbc55a49273c$var$_propTypes["default"].string,
                    onClick: $8c6bdbc55a49273c$var$_propTypes["default"].func,
                    disabled: $8c6bdbc55a49273c$var$_propTypes["default"].bool
                })
            ]))
        })
    ]),
    fit: $8c6bdbc55a49273c$var$_propTypes["default"].oneOf([
        'cover',
        'contain'
    ]),
    loop: $8c6bdbc55a49273c$var$_propTypes["default"].bool,
    mute: $8c6bdbc55a49273c$var$_propTypes["default"].bool,
    messages: $8c6bdbc55a49273c$var$_propTypes["default"].shape({
        closeMenu: $8c6bdbc55a49273c$var$_propTypes["default"].string,
        fullScreen: $8c6bdbc55a49273c$var$_propTypes["default"].string,
        openMenu: $8c6bdbc55a49273c$var$_propTypes["default"].string,
        pauseButton: $8c6bdbc55a49273c$var$_propTypes["default"].string,
        playButton: $8c6bdbc55a49273c$var$_propTypes["default"].string,
        progressMeter: $8c6bdbc55a49273c$var$_propTypes["default"].string,
        scrubber: $8c6bdbc55a49273c$var$_propTypes["default"].string,
        volumeDown: $8c6bdbc55a49273c$var$_propTypes["default"].string,
        volumeUp: $8c6bdbc55a49273c$var$_propTypes["default"].string
    }),
    skipInterval: $8c6bdbc55a49273c$var$_propTypes["default"].number
});
var $8c6bdbc55a49273c$var$VideoPropTypes = $8c6bdbc55a49273c$export$4c48a52d3ce6ecbb = $8c6bdbc55a49273c$var$PropType;



var $d1e2ac476456ddc8$var$_excluded = [
    "alignSelf",
    "autoPlay",
    "children",
    "controls",
    "gridArea",
    "loop",
    "margin",
    "messages",
    "mute",
    "onDurationChange",
    "onEnded",
    "onPause",
    "onPlay",
    "onTimeUpdate",
    "onVolumeChange",
    "skipInterval"
];
function $d1e2ac476456ddc8$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($d1e2ac476456ddc8$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $d1e2ac476456ddc8$var$_extends() {
    return $d1e2ac476456ddc8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d1e2ac476456ddc8$var$_extends.apply(null, arguments);
}
function $d1e2ac476456ddc8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// Split the volume control into 6 segments. Empirically determined.
var $d1e2ac476456ddc8$var$VOLUME_STEP = 0.166667;
var $d1e2ac476456ddc8$var$formatTime = function formatTime(time) {
    var minutes = Math.trunc(time / 60);
    if (minutes < 10) minutes = "0" + minutes;
    var seconds = Math.round(time) % 60;
    if (seconds < 10) seconds = "0" + seconds;
    return minutes + ":" + seconds;
};
var $d1e2ac476456ddc8$var$Video = $d1e2ac476456ddc8$export$ae01dedf5c052bb = /*#__PURE__*/ (0, $d1e2ac476456ddc8$var$_react.forwardRef)(function(_ref, ref) {
    var alignSelf = _ref.alignSelf, autoPlay = _ref.autoPlay, children = _ref.children, controlsProp = _ref.controls, gridArea = _ref.gridArea, loop = _ref.loop, margin = _ref.margin, messages = _ref.messages, mute = _ref.mute, _onDurationChange = _ref.onDurationChange, _onEnded = _ref.onEnded, _onPause = _ref.onPause, _onPlay = _ref.onPlay, _onTimeUpdate = _ref.onTimeUpdate, _onVolumeChange = _ref.onVolumeChange, skipInterval = _ref.skipInterval, rest = $d1e2ac476456ddc8$var$_objectWithoutPropertiesLoose(_ref, $d1e2ac476456ddc8$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useContext = (0, $d1e2ac476456ddc8$var$_react.useContext)($3b30be80b148b2c8$export$b060d577040138d8), format = _useContext.format;
    var announce = (0, $d1e2ac476456ddc8$var$_react.useContext)($cfbcb74d4f54e56b$export$dcc8f4bff0d51f50);
    var _useState = (0, $d1e2ac476456ddc8$var$_react.useState)([]), captions = _useState[0], setCaptions = _useState[1];
    var _useState2 = (0, $d1e2ac476456ddc8$var$_react.useState)(), currentTime = _useState2[0], setCurrentTime = _useState2[1];
    var _useState3 = (0, $d1e2ac476456ddc8$var$_react.useState)(), duration = _useState3[0], setDuration = _useState3[1];
    var _useState4 = (0, $d1e2ac476456ddc8$var$_react.useState)(), percentagePlayed = _useState4[0], setPercentagePlayed = _useState4[1];
    var _useState5 = (0, $d1e2ac476456ddc8$var$_react.useState)(false), playing = _useState5[0], setPlaying = _useState5[1];
    var _useState6 = (0, $d1e2ac476456ddc8$var$_react.useState)(false), announceAudioDescription = _useState6[0], setAnnounceAudioDescription = _useState6[1];
    var _useState7 = (0, $d1e2ac476456ddc8$var$_react.useState)(), scrubTime = _useState7[0], setScrubTime = _useState7[1];
    var _useState8 = (0, $d1e2ac476456ddc8$var$_react.useState)(), volume = _useState8[0], setVolume = _useState8[1];
    var _useState9 = (0, $d1e2ac476456ddc8$var$_react.useState)(false), hasPlayed = _useState9[0], setHasPlayed = _useState9[1];
    var _useState0 = (0, $d1e2ac476456ddc8$var$_react.useState)(), interacting = _useState0[0], setInteracting = _useState0[1];
    var _useState1 = (0, $d1e2ac476456ddc8$var$_react.useState)(), height = _useState1[0], setHeight = _useState1[1];
    var _useState10 = (0, $d1e2ac476456ddc8$var$_react.useState)(), width = _useState10[0], setWidth = _useState10[1];
    var containerRef = (0, $d1e2ac476456ddc8$var$_react.useRef)();
    var scrubberRef = (0, $d1e2ac476456ddc8$var$_react.useRef)();
    var videoRef = (0, $4113023f9e0bafa0$exports.useForwardedRef)(ref);
    var controls = (0, $d1e2ac476456ddc8$var$_react.useMemo)(function() {
        var result;
        if (typeof controlsProp === 'string' || typeof controlsProp === 'boolean') result = {
            items: [
                'volume',
                'fullScreen'
            ],
            position: controlsProp
        };
        else result = {
            items: (controlsProp == null ? void 0 : controlsProp.items) || [
                'volume',
                'fullScreen'
            ],
            position: (controlsProp == null ? void 0 : controlsProp.position) || 'over'
        };
        return result;
    }, [
        controlsProp
    ]);
    // mute if needed
    (0, $d1e2ac476456ddc8$var$_react.useEffect)(function() {
        var video = videoRef.current;
        if (video && mute) video.muted = true;
    }, [
        mute,
        videoRef
    ]);
    // when the video is first rendered, set state from it where needed
    (0, $d1e2ac476456ddc8$var$_react.useEffect)(function() {
        var video = videoRef.current;
        if (video) {
            // hide all captioning to start with
            var textTracks = video.textTracks;
            for(var i = 0; i < textTracks.length; i += 1)textTracks[i].mode = 'hidden';
            setCurrentTime(video.currentTime);
            setPercentagePlayed(video.currentTime / video.duration * 100);
            setVolume(videoRef.current.volume);
        }
    }, [
        videoRef
    ]);
    // turn off interacting after a while
    (0, $d1e2ac476456ddc8$var$_react.useEffect)(function() {
        var timer = setTimeout(function() {
            if (interacting && !(0, $4113023f9e0bafa0$exports.containsFocus)(containerRef.current)) setInteracting(false);
        }, 3000);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        interacting
    ]);
    // track which audio description track is active
    var _useState11 = (0, $d1e2ac476456ddc8$var$_react.useState)(), activeTrack = _useState11[0], setActiveTrack = _useState11[1];
    (0, $6a5275ec792307a1$export$e5c5a5f917a5871c)(function() {
        var video = videoRef.current;
        if (video) {
            if (video.videoHeight) {
                // set the size based on the video aspect ratio
                var rect = video.getBoundingClientRect();
                var ratio = rect.width / rect.height;
                var videoRatio = video.videoWidth / video.videoHeight;
                if (videoRatio > ratio) {
                    var nextHeight = rect.width / videoRatio;
                    if (nextHeight !== height) {
                        setHeight(nextHeight);
                        setWidth(undefined);
                    }
                } else {
                    var nextWidth = rect.height * videoRatio;
                    if (nextWidth !== width) {
                        setHeight(undefined);
                        setWidth(nextWidth);
                    }
                }
            }
            // remember the state of the text tracks for subsequent rendering
            var textTracks = video.textTracks;
            var nextCaptions = [];
            var set = false;
            // iterate through all of the tracks provided
            var _loop = function _loop() {
                var track = textTracks[i];
                var active = track.mode === 'showing';
                var getActiveTrack = function getActiveTrack(currentVideoTime) {
                    var nextActiveTrack;
                    for(var j = 0; j < track.cues.length; j += 1){
                        var _track$cues$j, _track$cues$j2;
                        if (currentVideoTime > (track == null || (_track$cues$j = track.cues[j]) == null ? void 0 : _track$cues$j.startTime) && currentVideoTime < (track == null || (_track$cues$j2 = track.cues[j]) == null ? void 0 : _track$cues$j2.endTime)) {
                            var _track$cues$j3;
                            nextActiveTrack = track == null || (_track$cues$j3 = track.cues[j]) == null ? void 0 : _track$cues$j3.text;
                        }
                    }
                    return nextActiveTrack;
                };
                // track is an audio description
                if (track.kind === 'descriptions') {
                    if (announceAudioDescription) video.ontimeupdate = function() {
                        var nextActiveTrack = getActiveTrack(video.currentTime);
                        if (activeTrack !== nextActiveTrack) {
                            if (nextActiveTrack) announce(nextActiveTrack, 'assertive');
                            setActiveTrack(nextActiveTrack);
                        }
                    };
                } else {
                    nextCaptions.push({
                        label: track.label,
                        active: active
                    });
                    if (!captions || !captions[i] || captions[i].active !== active) set = true;
                    if (set) setCaptions(nextCaptions);
                }
            };
            for(var i = 0; i < textTracks.length; i += 1)_loop();
        }
    }, [
        activeTrack,
        announce,
        announceAudioDescription,
        captions,
        height,
        videoRef,
        width
    ]);
    var play = (0, $d1e2ac476456ddc8$var$_react.useCallback)(function() {
        return videoRef.current.play();
    }, [
        videoRef
    ]);
    var pause = (0, $d1e2ac476456ddc8$var$_react.useCallback)(function() {
        return videoRef.current.pause();
    }, [
        videoRef
    ]);
    var scrub = (0, $d1e2ac476456ddc8$var$_react.useCallback)(function(event) {
        if (scrubberRef.current) {
            var scrubberRect = scrubberRef.current.getBoundingClientRect();
            var percent = (event.clientX - scrubberRect.left) / scrubberRect.width;
            setScrubTime(duration * percent);
        }
    }, [
        duration
    ]);
    var seek = (0, $d1e2ac476456ddc8$var$_react.useCallback)(function(event) {
        if (scrubberRef.current) {
            var scrubberRect = scrubberRef.current.getBoundingClientRect();
            var percent = (event.clientX - scrubberRect.left) / scrubberRect.width;
            if (duration) videoRef.current.currentTime = duration * percent;
        }
    }, [
        duration,
        videoRef
    ]);
    var seekForward = (0, $d1e2ac476456ddc8$var$_react.useCallback)(function() {
        setInteracting(true);
        videoRef.current.currentTime += skipInterval || theme.video.scrubber.interval;
    }, [
        skipInterval,
        theme.video.scrubber.interval,
        videoRef
    ]);
    var seekBackward = (0, $d1e2ac476456ddc8$var$_react.useCallback)(function() {
        setInteracting(true);
        videoRef.current.currentTime -= skipInterval || theme.video.scrubber.interval;
    }, [
        skipInterval,
        theme.video.scrubber.interval,
        videoRef
    ]);
    var louder = (0, $d1e2ac476456ddc8$var$_react.useCallback)(function() {
        videoRef.current.volume += $d1e2ac476456ddc8$var$VOLUME_STEP;
    }, [
        videoRef
    ]);
    var quieter = (0, $d1e2ac476456ddc8$var$_react.useCallback)(function() {
        videoRef.current.volume -= $d1e2ac476456ddc8$var$VOLUME_STEP;
    }, [
        videoRef
    ]);
    var showCaptions = (0, $d1e2ac476456ddc8$var$_react.useCallback)(function(index) {
        var textTracks = videoRef.current.textTracks;
        for(var i = 0; i < textTracks.length; i += 1)textTracks[i].mode = i === index ? 'showing' : 'hidden';
    }, [
        videoRef
    ]);
    var fullscreen = (0, $d1e2ac476456ddc8$var$_react.useCallback)(function() {
        var video = videoRef.current;
        if (video.requestFullscreen) video.requestFullscreen();
        else if (video.msRequestFullscreen) video.msRequestFullscreen();
        else if (video.mozRequestFullScreen) video.mozRequestFullScreen();
        else if (video.webkitRequestFullscreen) video.webkitRequestFullscreen();
        else console.warn("This browser doesn't support fullscreen.");
    }, [
        videoRef
    ]);
    var controlsElement;
    if (controls != null && controls.position) {
        var _controls$items, _theme$video, _theme$video2;
        var over = controls.position === 'over';
        var background = over ? theme.video.controls && theme.video.controls.background || {
            color: 'background-back',
            opacity: 'strong',
            dark: true
        } : undefined;
        var iconColor = over && (theme.video.icons.color || 'text');
        var formattedTime = $d1e2ac476456ddc8$var$formatTime(scrubTime || currentTime || duration);
        var Icons = {
            ClosedCaption: theme.video.icons.closedCaption,
            Configure: theme.video.icons.configure,
            FullScreen: theme.video.icons.fullScreen,
            Pause: theme.video.icons.pause,
            Play: theme.video.icons.play,
            ReduceVolume: theme.video.icons.reduceVolume,
            Volume: theme.video.icons.volume,
            Description: theme.video.icons.description
        };
        var captionControls = captions.map(function(caption, index) {
            return {
                icon: caption.label ? undefined : /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement(Icons.ClosedCaption, {
                    color: iconColor
                }),
                label: caption.label,
                active: caption.active,
                a11yTitle: caption.label || format({
                    id: 'video.captions',
                    messages: messages
                }),
                onClick: function onClick() {
                    showCaptions(caption.active ? -1 : index);
                    var updatedCaptions = [];
                    for(var i = 0; i < captions.length; i += 1){
                        updatedCaptions.push(captions[i]);
                        // set other captions to active=false
                        if (i !== index && updatedCaptions[i].active) updatedCaptions[i].active = false;
                        else if (i === index) updatedCaptions[i].active = !captions[index].active;
                    }
                    setCaptions(updatedCaptions);
                }
            };
        });
        var descriptionControls = {
            icon: /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement(Icons.Description, {
                color: iconColor
            }),
            a11yTitle: format({
                id: 'video.audioDescriptions',
                messages: messages
            }),
            active: announceAudioDescription,
            onClick: function onClick() {
                return setAnnounceAudioDescription(!announceAudioDescription);
            }
        };
        var volumeControls = [
            'volume',
            'reduceVolume'
        ].map(function(control) {
            return {
                icon: control === 'volume' ? /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement(Icons.Volume, {
                    color: iconColor
                }) : /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement(Icons.ReduceVolume, {
                    color: iconColor
                }),
                a11yTitle: format({
                    id: control === 'volume' ? 'video.volumeUp' : 'video.volumeDown',
                    messages: messages
                }),
                onClick: function onClick() {
                    if (volume <= 1 - $d1e2ac476456ddc8$var$VOLUME_STEP && control === 'volume') return louder();
                    if (volume >= $d1e2ac476456ddc8$var$VOLUME_STEP && control === 'reduceVolume') return quieter();
                    return undefined;
                },
                close: false
            };
        });
        var buttonProps = {
            captions: captionControls,
            descriptions: descriptionControls,
            volume: volumeControls,
            fullScreen: {
                icon: /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement(Icons.FullScreen, {
                    color: iconColor
                }),
                a11yTitle: format({
                    id: 'video.fullScreen',
                    messages: messages
                }),
                onClick: fullscreen
            },
            pause: {
                icon: /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement(Icons.Pause, {
                    color: iconColor
                }),
                a11yTitle: format({
                    id: 'video.pauseButton',
                    messages: messages
                }),
                disabled: !playing,
                onClick: pause
            },
            play: {
                icon: /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement(Icons.Play, {
                    color: iconColor
                }),
                a11yTitle: format({
                    id: 'video.playButton',
                    messages: messages
                }),
                disabled: playing,
                onClick: play
            }
        };
        var controlsMenuItems = [];
        (_controls$items = controls.items) == null || _controls$items.map(function(item) {
            if (item === 'volume') {
                volumeControls.map(function(control) {
                    return controlsMenuItems.push(control);
                });
                return undefined;
            }
            if (item === 'captions' && typeof buttonProps[item] === 'object') {
                for(var i = 0; i < buttonProps[item].length; i += 1)controlsMenuItems.push(buttonProps[item][i]);
                return undefined;
            }
            if (item === 'descriptions') {
                controlsMenuItems.push(buttonProps[item]);
                return undefined;
            }
            if (typeof item === 'string') return controlsMenuItems.push(buttonProps[item]);
            return controlsMenuItems.push(item);
        });
        controlsElement = /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement($c11fd31f3f2f357c$export$7751399fc290cffb, {
            over: over,
            active: !hasPlayed || controls.position === 'below' || over && interacting,
            onBlur: function onBlur() {
                if (!(0, $4113023f9e0bafa0$exports.containsFocus)(containerRef.current)) setInteracting(false);
            }
        }, /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            direction: "row",
            align: "center",
            justify: "between",
            background: background
        }, /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement($fb68f765668b25d0$export$353f5b6fc5456de1, {
            icon: playing ? /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement(Icons.Pause, {
                color: iconColor,
                a11yTitle: format({
                    id: 'video.pauseButton',
                    messages: messages
                })
            }) : /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement(Icons.Play, {
                color: iconColor,
                a11yTitle: format({
                    id: 'video.playButton',
                    messages: messages
                })
            }),
            hoverIndicator: "background",
            onClick: playing ? pause : play,
            onFocus: function onFocus() {
                return setInteracting(true);
            }
        }), /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            direction: "row",
            align: "center",
            flex: true
        }, /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            flex: true
        }, /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement($8c60273918bcf71f$export$694e0d28c7ffc90c, null, /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement($11d506dee5992445$export$62e3ae2a4090b879, {
            "aria-label": format({
                id: 'video.progressMeter',
                messages: messages
            }),
            background: over ? theme.video.scrubber && theme.video.scrubber.track && theme.video.scrubber.track.color || 'dark-3' : undefined,
            size: "full",
            thickness: (_theme$video = theme.video) == null || (_theme$video = _theme$video.scrubber) == null ? void 0 : _theme$video.thickness,
            values: [
                {
                    value: percentagePlayed || 0
                }
            ]
        }), /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement($c11fd31f3f2f357c$export$abea7d87552f46bc, $d1e2ac476456ddc8$var$_extends({
            "aria-label": format({
                id: 'video.scrubber',
                messages: messages
            }),
            ref: scrubberRef,
            tabIndex: 0,
            role: "button",
            value: scrubTime ? Math.round(scrubTime / duration * 100) : undefined,
            onMouseMove: scrub,
            onMouseLeave: function onMouseLeave() {
                return setScrubTime(undefined);
            },
            onClick: seek,
            onFocus: function onFocus() {
                return setInteracting(true);
            }
        }, passThemeFlag)))), /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement($090ffb0ba78fff3f$export$e71c4d32a2263218, {
            pad: theme == null || (_theme$video2 = theme.video) == null || (_theme$video2 = _theme$video2.time) == null || (_theme$video2 = _theme$video2.container) == null ? void 0 : _theme$video2.pad
        }, /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement($2f0b7ad0e7a4866d$export$5f1af8db9871e1d6, {
            margin: "none"
        }, formattedTime))), /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement($000ef1019d03e320$export$d9b273488cd8ce6f, {
            icon: /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement(Icons.Configure, {
                color: iconColor
            }),
            dropAlign: {
                bottom: 'top',
                right: 'right'
            },
            dropBackground: background,
            messages: {
                openMenu: format({
                    id: 'video.openMenu',
                    messages: messages
                }),
                closeMenu: format({
                    id: 'video.closeMenu',
                    messages: messages
                })
            },
            items: [].concat(controlsMenuItems),
            onFocus: function onFocus() {
                return setInteracting(true);
            }
        })));
    }
    var mouseEventListeners;
    if ((controls == null ? void 0 : controls.position) === 'over') mouseEventListeners = {
        onMouseEnter: function onMouseEnter() {
            return setInteracting(true);
        },
        onMouseMove: function onMouseMove() {
            return setInteracting(true);
        },
        onTouchStart: function onTouchStart() {
            return setInteracting(true);
        }
    };
    var style;
    if (rest.fit === 'contain' && (controls == null ? void 0 : controls.position) === 'over') {
        // constrain the size to fit the aspect ratio so the controls
        // overlap correctly
        if (width) style = {
            width: width
        };
        else if (height) style = {
            height: height
        };
    }
    return /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement($0241778dbd7d3ddc$export$16e4d70cc375e707, {
        onLeft: seekBackward,
        onRight: seekForward
    }, /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement($c11fd31f3f2f357c$export$6b75c55b46d797c5, $d1e2ac476456ddc8$var$_extends({
        ref: containerRef
    }, mouseEventListeners, {
        alignSelf: alignSelf,
        gridArea: gridArea,
        margin: margin,
        style: style,
        tabIndex: "-1"
    }, passThemeFlag), /*#__PURE__*/ $d1e2ac476456ddc8$var$_react["default"].createElement($c11fd31f3f2f357c$export$b230c172e26df666, $d1e2ac476456ddc8$var$_extends({}, passThemeFlag, rest, {
        ref: videoRef,
        onDurationChange: function onDurationChange(event) {
            var video = videoRef.current;
            setDuration(video.duration);
            setPercentagePlayed(video.currentTime / video.duration * 100);
            if (_onDurationChange) _onDurationChange(event);
        },
        onEnded: function onEnded(event) {
            setPlaying(false);
            if (_onEnded) _onEnded(event);
        },
        onPause: function onPause(event) {
            setPlaying(false);
            if (_onPause) _onPause(event);
        },
        onPlay: function onPlay(event) {
            setPlaying(true);
            setHasPlayed(true);
            if (_onPlay) _onPlay(event);
        },
        onTimeUpdate: function onTimeUpdate(event) {
            var video = videoRef.current;
            setCurrentTime(video.currentTime);
            setPercentagePlayed(video.currentTime / video.duration * 100);
            if (_onTimeUpdate) _onTimeUpdate(event);
        },
        onVolumeChange: function onVolumeChange(event) {
            setVolume(videoRef.current.volume);
            if (_onVolumeChange) _onVolumeChange(event);
        },
        autoPlay: autoPlay || false,
        loop: loop || false
    }), children), controlsElement));
});
$d1e2ac476456ddc8$var$Video.displayName = 'Video';
$d1e2ac476456ddc8$var$Video.propTypes = $8c6bdbc55a49273c$export$4c48a52d3ce6ecbb;


$e230244fdd1d67b9$export$ae01dedf5c052bb = $d1e2ac476456ddc8$export$ae01dedf5c052bb;


Object.keys($e230244fdd1d67b9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $e230244fdd1d67b9$exports[key]) return;
    $3321243da0932e1e$exports[key] = $e230244fdd1d67b9$exports[key];
});
var $906dce094c3f451c$exports = {};

$parcel$export($906dce094c3f451c$exports, "__esModule", function () { return $906dce094c3f451c$export$1e511d4a378977f5; }, function (v) { return $906dce094c3f451c$export$1e511d4a378977f5 = v; });
$parcel$export($906dce094c3f451c$exports, "WorldMap", function () { return $906dce094c3f451c$export$9a82c68eff2bb78f; }, function (v) { return $906dce094c3f451c$export$9a82c68eff2bb78f = v; });
var $906dce094c3f451c$export$1e511d4a378977f5;
var $906dce094c3f451c$export$9a82c68eff2bb78f;
"use strict";
$906dce094c3f451c$export$1e511d4a378977f5 = true;
$906dce094c3f451c$export$9a82c68eff2bb78f = void 0;
var $442adbae090fb373$export$1e511d4a378977f5;
var $442adbae090fb373$export$9a82c68eff2bb78f;
"use strict";
$442adbae090fb373$export$1e511d4a378977f5 = true;
$442adbae090fb373$export$9a82c68eff2bb78f = void 0;

var $442adbae090fb373$var$_react = $442adbae090fb373$var$_interopRequireWildcard((parcelRequire("2xPiy")));


var $b751c32e9a9443cc$export$1e511d4a378977f5;
var $b751c32e9a9443cc$export$d4d3b8cf744842c7;
"use strict";
$b751c32e9a9443cc$export$1e511d4a378977f5 = true;
$b751c32e9a9443cc$export$d4d3b8cf744842c7 = void 0;

var $b751c32e9a9443cc$var$_styledComponents = $b751c32e9a9443cc$var$_interopRequireDefault((parcelRequire("iA1nz")));

function $b751c32e9a9443cc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $b751c32e9a9443cc$var$fillStyle = function fillStyle(fillProp) {
    if (fillProp === 'horizontal') return "\n      width: 100%;\n      height: unset;\n    ";
    if (fillProp === 'vertical') return "\n      width: unset;\n      height: 100%;\n    ";
    if (fillProp) return "\n      width: 100%;\n      height: 100%;\n    ";
    return '';
};
// undefined fillProp has width for backwards compatibility
var $b751c32e9a9443cc$var$StyledWorldMap = $b751c32e9a9443cc$export$d4d3b8cf744842c7 = $b751c32e9a9443cc$var$_styledComponents["default"].svg.withConfig($4113023f9e0bafa0$exports.styledComponentsConfig).withConfig({
    displayName: "StyledWorldMap",
    componentId: "sc-had4c3-0"
})([
    "",
    " ",
    " ",
    ";"
], $4113023f9e0bafa0$exports.genericStyles, function(props) {
    return props.fillProp !== undefined ? $b751c32e9a9443cc$var$fillStyle(props.fillProp) : 'width: 100%;';
}, function(props) {
    return props.theme.worldMap && props.theme.worldMap.extend;
});


var $f5a18feb6273510f$export$1e511d4a378977f5;
var $f5a18feb6273510f$export$73349ef443631173;
"use strict";
$f5a18feb6273510f$export$1e511d4a378977f5 = true;
$f5a18feb6273510f$export$73349ef443631173 = void 0;

var $f5a18feb6273510f$var$_propTypes = $f5a18feb6273510f$var$_interopRequireDefault((parcelRequire("dyr1f")));

function $f5a18feb6273510f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $f5a18feb6273510f$var$_extends() {
    return $f5a18feb6273510f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f5a18feb6273510f$var$_extends.apply(null, arguments);
}
var $f5a18feb6273510f$var$PropType = {};
$f5a18feb6273510f$var$PropType = $f5a18feb6273510f$var$_extends({}, $5897bd367fbd90c1$export$ffe37ff34eeb9e21, {
    color: $5897bd367fbd90c1$export$fc4c368d97afb623,
    continents: $f5a18feb6273510f$var$_propTypes["default"].arrayOf($f5a18feb6273510f$var$_propTypes["default"].shape({
        color: $5897bd367fbd90c1$export$fc4c368d97afb623,
        name: $f5a18feb6273510f$var$_propTypes["default"].oneOf([
            'Africa',
            'Asia',
            'Australia',
            'Europe',
            'North America',
            'South America'
        ]).isRequired,
        onClick: $f5a18feb6273510f$var$_propTypes["default"].func,
        onHover: $f5a18feb6273510f$var$_propTypes["default"].func
    })),
    fill: $f5a18feb6273510f$var$_propTypes["default"].oneOfType([
        $f5a18feb6273510f$var$_propTypes["default"].oneOf([
            'horizontal',
            'vertical'
        ]),
        $f5a18feb6273510f$var$_propTypes["default"].bool
    ]),
    onSelectPlace: $f5a18feb6273510f$var$_propTypes["default"].func,
    places: $f5a18feb6273510f$var$_propTypes["default"].arrayOf($f5a18feb6273510f$var$_propTypes["default"].shape({
        color: $5897bd367fbd90c1$export$fc4c368d97afb623,
        content: $f5a18feb6273510f$var$_propTypes["default"].node,
        dropProps: $f5a18feb6273510f$var$_propTypes["default"].shape({}),
        name: $f5a18feb6273510f$var$_propTypes["default"].string,
        // for a11y aria-label
        location: $f5a18feb6273510f$var$_propTypes["default"].arrayOf($f5a18feb6273510f$var$_propTypes["default"].number).isRequired,
        onClick: $f5a18feb6273510f$var$_propTypes["default"].func,
        onHover: $f5a18feb6273510f$var$_propTypes["default"].func
    })),
    hoverColor: $5897bd367fbd90c1$export$fc4c368d97afb623
});
var $f5a18feb6273510f$var$WorldMapPropTypes = $f5a18feb6273510f$export$73349ef443631173 = $f5a18feb6273510f$var$PropType;



var $442adbae090fb373$var$_excluded = [
    "fill",
    "color",
    "continents",
    "hoverColor",
    "onSelectPlace",
    "places"
], $442adbae090fb373$var$_excluded2 = [
    "location"
], $442adbae090fb373$var$_excluded3 = [
    "color",
    "onClick",
    "onHover"
], $442adbae090fb373$var$_excluded4 = [
    "color",
    "coords",
    "content",
    "dropProps",
    "key",
    "name",
    "onClick",
    "onHover"
];
function $442adbae090fb373$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($442adbae090fb373$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $442adbae090fb373$var$_extends() {
    return $442adbae090fb373$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $442adbae090fb373$var$_extends.apply(null, arguments);
}
function $442adbae090fb373$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// The graphic is drawn as a rectangular grid using coordinates spaced
// by FACTOR pixels.
var $442adbae090fb373$var$FACTOR = 10;
// Mapping constants between coordinates and latitude+longitude.
// The map coordinate space isn't precisely a mercator projection. So,
// we have a few adjustments that we've empirically determined. The following
// cities were used to make the empirical determinations:
// London (0 lon), Quito (0 lat), Nome (far west), Sydney (far east),
// Svalbard (far north), Ushuaia (far south).
// These map to reality, they aren't adjusted.
var $442adbae090fb373$var$EQUATOR_Y = 32;
var $442adbae090fb373$var$WIDTH = 93;
// Scale the latitude and longitude to align better with actual locations.
var $442adbae090fb373$var$LAT_SCALE = 0.98;
// adjust more extreme latitudes to fit with the map dots better
var $442adbae090fb373$var$LAT_EXTREME_SCALE = 0.91;
var $442adbae090fb373$var$LON_SCALE = 0.99;
// We shift the map coordinates to align better with actual locations.
var $442adbae090fb373$var$X_OFFSET = -2;
var $442adbae090fb373$var$Y_OFFSET = -2;
// The continents have both an area boundary for interaction
// and dots described as rows where each row is described by three values:
// a starting coordinate and a length. This approach is more efficient than
// describing it via SVG elements, keeping the code/library size smaller.
var $442adbae090fb373$var$CONTINENTS = [
    {
        name: 'Australia',
        origin: [
            74,
            32
        ],
        area: [
            [
                4,
                0
            ],
            [
                7,
                1
            ],
            [
                15,
                7
            ],
            [
                13,
                9
            ],
            [
                8,
                8
            ],
            [
                0,
                6
            ],
            [
                0,
                2
            ]
        ],
        dots: [
            [
                4,
                0,
                1
            ],
            [
                2,
                1,
                6
            ],
            [
                0,
                2,
                9
            ],
            [
                0,
                3,
                10
            ],
            [
                0,
                4,
                10
            ],
            [
                0,
                5,
                3
            ],
            [
                5,
                5,
                5
            ],
            [
                5,
                6,
                4
            ],
            [
                8,
                8,
                1
            ],
            [
                15,
                7,
                1
            ],
            [
                14,
                8,
                1
            ],
            [
                13,
                9,
                1
            ]
        ]
    },
    {
        name: 'Asia',
        origin: [
            52,
            1
        ],
        area: [
            [
                16,
                0
            ],
            [
                38,
                5
            ],
            [
                40,
                7
            ],
            [
                28,
                17
            ],
            [
                24,
                25
            ],
            [
                29,
                29
            ],
            [
                19,
                29
            ],
            [
                11,
                24
            ],
            [
                3,
                23
            ],
            [
                0,
                20
            ],
            [
                0,
                19
            ],
            [
                6,
                13
            ],
            [
                7,
                6
            ]
        ],
        dots: [
            [
                16,
                0,
                1
            ],
            [
                17,
                1,
                2
            ],
            [
                18,
                2,
                2
            ],
            [
                15,
                3,
                6
            ],
            [
                28,
                3,
                1
            ],
            [
                30,
                3,
                1
            ],
            [
                10,
                4,
                2
            ],
            [
                13,
                4,
                10
            ],
            [
                24,
                4,
                1
            ],
            [
                9,
                5,
                22
            ],
            [
                32,
                5,
                1
            ],
            [
                38,
                5,
                1
            ],
            [
                7,
                6,
                2
            ],
            [
                10,
                6,
                1
            ],
            [
                12,
                6,
                27
            ],
            [
                7,
                7,
                34
            ],
            [
                7,
                8,
                31
            ],
            [
                7,
                9,
                26
            ],
            [
                34,
                9,
                3
            ],
            [
                7,
                10,
                22
            ],
            [
                31,
                10,
                1
            ],
            [
                33,
                10,
                1
            ],
            [
                7,
                11,
                21
            ],
            [
                32,
                11,
                2
            ],
            [
                7,
                12,
                21
            ],
            [
                32,
                12,
                1
            ],
            [
                6,
                13,
                22
            ],
            [
                32,
                13,
                1
            ],
            [
                6,
                14,
                22
            ],
            [
                5,
                15,
                22
            ],
            [
                3,
                16,
                2
            ],
            [
                6,
                16,
                20
            ],
            [
                2,
                17,
                3
            ],
            [
                6,
                17,
                16
            ],
            [
                24,
                17,
                1
            ],
            [
                28,
                17,
                1
            ],
            [
                1,
                18,
                22
            ],
            [
                26,
                18,
                2
            ],
            [
                0,
                19,
                24
            ],
            [
                0,
                20,
                5
            ],
            [
                6,
                20,
                17
            ],
            [
                2,
                21,
                5
            ],
            [
                10,
                21,
                14
            ],
            [
                2,
                22,
                5
            ],
            [
                11,
                22,
                4
            ],
            [
                16,
                22,
                4
            ],
            [
                3,
                23,
                3
            ],
            [
                11,
                23,
                2
            ],
            [
                17,
                23,
                3
            ],
            [
                23,
                23,
                1
            ],
            [
                11,
                24,
                2
            ],
            [
                18,
                24,
                2
            ],
            [
                23,
                24,
                1
            ],
            [
                24,
                25,
                1
            ],
            [
                18,
                26,
                1
            ],
            [
                22,
                26,
                1
            ],
            [
                18,
                27,
                1
            ],
            [
                20,
                27,
                4
            ],
            [
                18,
                28,
                1
            ],
            [
                21,
                28,
                1
            ],
            [
                23,
                28,
                1
            ],
            [
                26,
                28,
                3
            ],
            [
                19,
                29,
                1
            ],
            [
                28,
                29,
                2
            ]
        ]
    },
    {
        name: 'Africa',
        origin: [
            40,
            19
        ],
        area: [
            [
                3,
                0
            ],
            [
                6,
                0
            ],
            [
                11,
                2
            ],
            [
                16,
                7
            ],
            [
                16,
                15
            ],
            [
                11,
                18
            ],
            [
                9,
                18
            ],
            [
                0,
                6
            ],
            [
                0,
                3
            ]
        ],
        dots: [
            [
                3,
                0,
                4
            ],
            [
                2,
                1,
                6
            ],
            [
                9,
                1,
                2
            ],
            [
                1,
                2,
                11
            ],
            [
                0,
                3,
                13
            ],
            [
                0,
                4,
                14
            ],
            [
                0,
                5,
                14
            ],
            [
                0,
                6,
                16
            ],
            [
                1,
                7,
                16
            ],
            [
                2,
                8,
                2
            ],
            [
                6,
                8,
                11
            ],
            [
                7,
                9,
                9
            ],
            [
                7,
                10,
                8
            ],
            [
                7,
                11,
                7
            ],
            [
                8,
                12,
                7
            ],
            [
                7,
                13,
                8
            ],
            [
                7,
                14,
                7
            ],
            [
                16,
                14,
                1
            ],
            [
                8,
                15,
                5
            ],
            [
                15,
                15,
                2
            ],
            [
                8,
                16,
                5
            ],
            [
                9,
                17,
                3
            ],
            [
                9,
                18,
                3
            ]
        ]
    },
    {
        name: 'Europe',
        origin: [
            39,
            2
        ],
        area: [
            [
                8,
                0
            ],
            [
                10,
                0
            ],
            [
                20,
                2
            ],
            [
                19,
                11
            ],
            [
                18,
                13
            ],
            [
                14,
                16
            ],
            [
                3,
                16
            ],
            [
                0,
                7
            ]
        ],
        dots: [
            [
                8,
                0,
                3
            ],
            [
                9,
                1,
                1
            ],
            [
                20,
                2,
                1
            ],
            [
                19,
                3,
                1
            ],
            [
                12,
                4,
                1
            ],
            [
                19,
                4,
                1
            ],
            [
                9,
                5,
                6
            ],
            [
                9,
                6,
                7
            ],
            [
                17,
                6,
                3
            ],
            [
                0,
                7,
                1
            ],
            [
                8,
                7,
                12
            ],
            [
                7,
                8,
                3
            ],
            [
                11,
                8,
                9
            ],
            [
                7,
                9,
                3
            ],
            [
                11,
                9,
                9
            ],
            [
                4,
                10,
                1
            ],
            [
                7,
                10,
                1
            ],
            [
                9,
                10,
                1
            ],
            [
                11,
                10,
                9
            ],
            [
                3,
                11,
                2
            ],
            [
                7,
                11,
                13
            ],
            [
                4,
                12,
                1
            ],
            [
                6,
                12,
                13
            ],
            [
                4,
                13,
                15
            ],
            [
                5,
                14,
                3
            ],
            [
                9,
                14,
                4
            ],
            [
                15,
                14,
                2
            ],
            [
                3,
                15,
                3
            ],
            [
                8,
                15,
                1
            ],
            [
                10,
                15,
                5
            ],
            [
                6,
                15,
                2
            ],
            [
                3,
                16,
                2
            ],
            [
                10,
                16,
                5
            ]
        ]
    },
    {
        name: 'South America',
        origin: [
            22,
            26
        ],
        area: [
            [
                2,
                0
            ],
            [
                5,
                0
            ],
            [
                11,
                4
            ],
            [
                11,
                8
            ],
            [
                3,
                18
            ],
            [
                2,
                17
            ],
            [
                0,
                4
            ],
            [
                0,
                3
            ]
        ],
        dots: [
            [
                2,
                0,
                4
            ],
            [
                1,
                1,
                7
            ],
            [
                1,
                2,
                7
            ],
            [
                0,
                3,
                10
            ],
            [
                0,
                4,
                12
            ],
            [
                1,
                5,
                11
            ],
            [
                2,
                6,
                9
            ],
            [
                3,
                7,
                8
            ],
            [
                3,
                8,
                8
            ],
            [
                3,
                9,
                6
            ],
            [
                3,
                10,
                6
            ],
            [
                3,
                11,
                5
            ],
            [
                3,
                12,
                3
            ],
            [
                2,
                13,
                3
            ],
            [
                2,
                14,
                3
            ],
            [
                2,
                15,
                2
            ],
            [
                2,
                16,
                2
            ],
            [
                2,
                17,
                2
            ],
            [
                3,
                18,
                1
            ]
        ]
    },
    {
        name: 'North America',
        origin: [
            0,
            0
        ],
        area: [
            [
                21,
                0
            ],
            [
                39,
                0
            ],
            [
                39,
                6
            ],
            [
                22,
                26
            ],
            [
                16,
                23
            ],
            [
                2,
                12
            ],
            [
                0,
                7
            ]
        ],
        dots: [
            [
                22,
                0,
                6
            ],
            [
                29,
                0,
                1
            ],
            [
                31,
                0,
                1
            ],
            [
                33,
                0,
                5
            ],
            [
                20,
                1,
                1
            ],
            [
                22,
                1,
                1
            ],
            [
                24,
                1,
                2
            ],
            [
                27,
                1,
                13
            ],
            [
                17,
                2,
                1
            ],
            [
                20,
                2,
                5
            ],
            [
                26,
                2,
                13
            ],
            [
                13,
                3,
                1
            ],
            [
                19,
                3,
                1
            ],
            [
                21,
                3,
                3
            ],
            [
                26,
                3,
                14
            ],
            [
                14,
                4,
                1
            ],
            [
                16,
                4,
                4
            ],
            [
                21,
                4,
                3
            ],
            [
                29,
                4,
                11
            ],
            [
                12,
                5,
                3
            ],
            [
                16,
                5,
                1
            ],
            [
                18,
                5,
                1
            ],
            [
                20,
                5,
                3
            ],
            [
                24,
                5,
                1
            ],
            [
                30,
                5,
                8
            ],
            [
                14,
                6,
                3
            ],
            [
                19,
                6,
                1
            ],
            [
                22,
                6,
                4
            ],
            [
                31,
                6,
                8
            ],
            [
                0,
                7,
                15
            ],
            [
                16,
                7,
                1
            ],
            [
                18,
                7,
                4
            ],
            [
                24,
                7,
                2
            ],
            [
                30,
                7,
                7
            ],
            [
                2,
                8,
                20
            ],
            [
                24,
                8,
                3
            ],
            [
                29,
                8,
                5
            ],
            [
                2,
                9,
                20
            ],
            [
                24,
                9,
                2
            ],
            [
                30,
                9,
                3
            ],
            [
                1,
                10,
                18
            ],
            [
                23,
                10,
                2
            ],
            [
                31,
                10,
                1
            ],
            [
                2,
                11,
                2
            ],
            [
                8,
                11,
                11
            ],
            [
                23,
                11,
                2
            ],
            [
                26,
                11,
                1
            ],
            [
                2,
                12,
                1
            ],
            [
                8,
                12,
                13
            ],
            [
                24,
                12,
                3
            ],
            [
                10,
                13,
                12
            ],
            [
                23,
                13,
                5
            ],
            [
                11,
                14,
                17
            ],
            [
                11,
                15,
                9
            ],
            [
                21,
                15,
                6
            ],
            [
                28,
                15,
                2
            ],
            [
                11,
                16,
                11
            ],
            [
                23,
                16,
                4
            ],
            [
                11,
                17,
                14
            ],
            [
                12,
                18,
                11
            ],
            [
                12,
                19,
                12
            ],
            [
                13,
                20,
                9
            ],
            [
                15,
                21,
                3
            ],
            [
                22,
                21,
                1
            ],
            [
                16,
                22,
                2
            ],
            [
                16,
                23,
                2
            ],
            [
                20,
                23,
                1
            ],
            [
                23,
                23,
                1
            ],
            [
                18,
                24,
                3
            ],
            [
                21,
                25,
                1
            ],
            [
                22,
                26,
                1
            ]
        ]
    }
];
var $442adbae090fb373$var$mergeBounds = function mergeBounds(bounds1, bounds2) {
    return [
        bounds1 ? Math.min(bounds1[0], bounds2[0]) : bounds2[0],
        bounds1 ? Math.min(bounds1[1], bounds2[1]) : bounds2[1],
        bounds1 ? Math.max(bounds1[2], bounds2[2]) : bounds2[2],
        bounds1 ? Math.max(bounds1[3], bounds2[3]) : bounds2[3]
    ];
};
var $442adbae090fb373$var$midPoint = function midPoint(bounds) {
    return [
        bounds[0] + (bounds[2] - bounds[0]) / 2,
        bounds[1] + (bounds[3] - bounds[1]) / 2
    ];
};
// from https://stackoverflow.com/a/14457180/8513067
var $442adbae090fb373$var$latLonToCoord = function latLonToCoord(_ref) {
    var lat = _ref[0], lon = _ref[1];
    var scaledLon = lon * $442adbae090fb373$var$LON_SCALE;
    var x = Math.round((scaledLon + 180) * ($442adbae090fb373$var$WIDTH / 360));
    // adjust more extreme latitudes to fit with the map dots better
    var scaledLat = lat * (lat > 60 || lat < -50 ? $442adbae090fb373$var$LAT_EXTREME_SCALE : $442adbae090fb373$var$LAT_SCALE);
    var latRad = scaledLat * Math.PI / 180;
    var mercN = Math.log(Math.tan(Math.PI / 4 + latRad / 2));
    var y = Math.round($442adbae090fb373$var$EQUATOR_Y - $442adbae090fb373$var$WIDTH * mercN / (2 * Math.PI));
    return [
        x + $442adbae090fb373$var$X_OFFSET,
        y + $442adbae090fb373$var$Y_OFFSET
    ];
};
var $442adbae090fb373$var$coordToLatLon = function coordToLatLon(_ref2) {
    var x = _ref2[0], y = _ref2[1];
    var mercN = ($442adbae090fb373$var$EQUATOR_Y - (y - $442adbae090fb373$var$Y_OFFSET)) * (2 * Math.PI) / $442adbae090fb373$var$WIDTH;
    var latRad = (Math.atan(Math.exp(mercN)) - Math.PI / 4) * 2;
    var scaledLat = latRad * 180 / Math.PI / $442adbae090fb373$var$LAT_SCALE;
    // adjust more extreme latitudes to fit with the map dots better
    var lat = scaledLat / (scaledLat > 60 || scaledLat < -50 ? $442adbae090fb373$var$LAT_EXTREME_SCALE : $442adbae090fb373$var$LAT_SCALE);
    var lon = (x - $442adbae090fb373$var$X_OFFSET) * 360 / $442adbae090fb373$var$WIDTH - 180;
    return [
        lat,
        lon
    ];
};
var $442adbae090fb373$var$buildContinent = function buildContinent(_ref3) {
    var areaProp = _ref3.area, dotsProp = _ref3.dots, name = _ref3.name, origin = _ref3.origin;
    var bounds = [
        origin[0],
        origin[1],
        origin[0],
        origin[1]
    ];
    var dots = dotsProp.map(function(segment) {
        var count = segment[2];
        var spots = [];
        for(var i = 0; i < count; i += 1)spots.push('h0');
        var dotCommands = spots.join(' m10,0 ');
        var x = $442adbae090fb373$var$FACTOR * (origin[0] + segment[0] + 1);
        var y = $442adbae090fb373$var$FACTOR * (origin[1] + segment[1] + 1);
        bounds = $442adbae090fb373$var$mergeBounds(bounds, [
            origin[0],
            origin[1],
            origin[0] + segment[0] + segment[2],
            origin[1] + segment[1]
        ]);
        return "M" + x + "," + y + " " + dotCommands;
    }).join(' ');
    var area = areaProp.map(function(point, index) {
        var x = $442adbae090fb373$var$FACTOR * (point[0] + origin[0] + 1);
        var y = $442adbae090fb373$var$FACTOR * (point[1] + origin[1] + 1);
        return "" + (index === 0 ? 'M' : 'L') + x + "," + y;
    }).join(' ') + " Z";
    var mid = $442adbae090fb373$var$midPoint(bounds);
    return {
        area: area,
        dots: dots,
        name: name,
        origin: origin,
        bounds: bounds,
        mid: mid
    };
};
var $442adbae090fb373$var$buildWorld = function buildWorld() {
    // Build the SVG paths describing the individual dots
    var continents = $442adbae090fb373$var$CONTINENTS.map($442adbae090fb373$var$buildContinent);
    var bounds;
    continents.forEach(function(continent) {
        bounds = $442adbae090fb373$var$mergeBounds(bounds, continent.bounds);
    });
    return {
        continents: continents,
        bounds: bounds,
        x: bounds[0] * $442adbae090fb373$var$FACTOR,
        y: bounds[1] * $442adbae090fb373$var$FACTOR,
        width: (bounds[2] - bounds[0] + 1) * $442adbae090fb373$var$FACTOR,
        height: (bounds[3] - bounds[1] + 2) * $442adbae090fb373$var$FACTOR
    };
};
var $442adbae090fb373$var$buildInteractiveProps = function buildInteractiveProps(_ref4, activeFunc, active) {
    var name = _ref4.name, onClick = _ref4.onClick, onHover = _ref4.onHover;
    return {
        role: 'button',
        'aria-label': name,
        tabIndex: '0',
        onClick: onClick ? function() {
            return onClick(name);
        } : undefined,
        onMouseOver: function onMouseOver() {
            if (!active) {
                activeFunc(name);
                if (onHover) onHover(true);
            }
        },
        onMouseLeave: function onMouseLeave() {
            if (active) {
                activeFunc(undefined);
                if (onHover) onHover(false);
            }
        },
        onFocus: function onFocus() {
            // This moves the map unnecessarily. Instead, we should check
            // the position and scroll if it isn't already visible
            // this._worldMapRef.scrollIntoView();
            if (!active) activeFunc(name);
        },
        onBlur: function onBlur() {
            if (active) activeFunc(undefined);
        }
    };
};
var $442adbae090fb373$var$WorldMap = $442adbae090fb373$export$9a82c68eff2bb78f = /*#__PURE__*/ (0, $442adbae090fb373$var$_react.forwardRef)(function(_ref5, ref) {
    var fill = _ref5.fill, color = _ref5.color, continentsProp = _ref5.continents, hoverColor = _ref5.hoverColor, onSelectPlace = _ref5.onSelectPlace, placesProp = _ref5.places, rest = $442adbae090fb373$var$_objectWithoutPropertiesLoose(_ref5, $442adbae090fb373$var$_excluded);
    var _useThemeValue = (0, $c2bb495fd818831f$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var world = $442adbae090fb373$var$_react["default"].useMemo($442adbae090fb373$var$buildWorld, []);
    var _React$useState = $442adbae090fb373$var$_react["default"].useState({}), continents = _React$useState[0], setContinents = _React$useState[1];
    $442adbae090fb373$var$_react["default"].useEffect(function() {
        if (continentsProp) setContinents(continentsProp.reduce(function(obj, continent) {
            // eslint-disable-next-line no-param-reassign
            obj[continent.name] = continent;
            return obj;
        }, {}));
        else setContinents({});
    }, [
        continentsProp
    ]);
    var _React$useState2 = $442adbae090fb373$var$_react["default"].useState([]), places = _React$useState2[0], setPlaces = _React$useState2[1];
    // targets are used for the Drops associated with places content
    var _React$useState3 = $442adbae090fb373$var$_react["default"].useState([]), targets = _React$useState3[0], setTargets = _React$useState3[1];
    $442adbae090fb373$var$_react["default"].useEffect(function() {
        if (placesProp) setPlaces(placesProp.map(function(_ref6) {
            var location = _ref6.location, place = $442adbae090fb373$var$_objectWithoutPropertiesLoose(_ref6, $442adbae090fb373$var$_excluded2);
            var coords = $442adbae090fb373$var$latLonToCoord(location);
            return $442adbae090fb373$var$_extends({
                coords: coords,
                key: location.join(',')
            }, place);
        }));
        else setPlaces([]);
        return function() {
            setTargets([]);
        };
    }, [
        placesProp,
        world
    ]);
    var _React$useState4 = $442adbae090fb373$var$_react["default"].useState(), over = _React$useState4[0], setOver = _React$useState4[1];
    var _React$useState5 = $442adbae090fb373$var$_react["default"].useState(), activeCoords = _React$useState5[0], setActiveCoords = _React$useState5[1];
    var _React$useState6 = $442adbae090fb373$var$_react["default"].useState(), activeContinent = _React$useState6[0], setActiveContinent = _React$useState6[1];
    var _React$useState7 = $442adbae090fb373$var$_react["default"].useState(), activePlace = _React$useState7[0], setActivePlace = _React$useState7[1];
    var containerRef = $442adbae090fb373$var$_react["default"].useRef();
    var placeRef = $442adbae090fb373$var$_react["default"].useCallback(function(node, index) {
        setTargets(function(prevTargets) {
            if (!prevTargets[index]) {
                var nextTargets = [].concat(prevTargets);
                nextTargets[index] = node;
                return nextTargets;
            }
            return prevTargets;
        });
    }, []);
    var onMouseMove = $442adbae090fb373$var$_react["default"].useCallback(function(event) {
        // determine the map coordinates for where the mouse is
        // containerRef uses the group so we can handle aspect ratio scaling
        var rect = containerRef.current.getBoundingClientRect();
        // since the SVG viewBox might be scaled
        var scale = rect.width / world.width;
        var coords = [
            Math.round((event.clientX - rect.left) / scale / $442adbae090fb373$var$FACTOR),
            Math.round((event.clientY - rect.top) / scale / $442adbae090fb373$var$FACTOR)
        ];
        setActiveCoords(coords);
    }, [
        world.width
    ]);
    var continentElements = world.continents.map(function(_ref7) {
        var area = _ref7.area, dots = _ref7.dots, name = _ref7.name;
        var _ref8 = continents[name] || {}, continentColor = _ref8.color, onClick = _ref8.onClick, onHover = _ref8.onHover, restContinents = $442adbae090fb373$var$_objectWithoutPropertiesLoose(_ref8, $442adbae090fb373$var$_excluded3);
        var active = activeContinent && activeContinent === name;
        var interactiveProps = {};
        if (onClick || onHover) interactiveProps = $442adbae090fb373$var$buildInteractiveProps(continents[name], function(activate) {
            return setActiveContinent(activate);
        }, active);
        return /*#__PURE__*/ $442adbae090fb373$var$_react["default"].createElement("g", $442adbae090fb373$var$_extends({
            key: name
        }, interactiveProps, restContinents), /*#__PURE__*/ $442adbae090fb373$var$_react["default"].createElement("path", {
            stroke: "none",
            fill: "#fff",
            fillOpacity: "0.01",
            d: area
        }), /*#__PURE__*/ $442adbae090fb373$var$_react["default"].createElement("path", {
            d: dots,
            strokeLinecap: "round",
            strokeWidth: (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.worldMap.continent[active ? 'active' : 'base']),
            stroke: (0, $4113023f9e0bafa0$exports.normalizeColor)(continentColor || color || theme.worldMap.color, theme)
        }));
    });
    var placesContent = [];
    var placeElements = places.map(function(place, index) {
        var placeColor = place.color, coords = place.coords, content = place.content, dropProps = place.dropProps, key = place.key, name = place.name, onClick = place.onClick, onHover = place.onHover, restPlace = $442adbae090fb373$var$_objectWithoutPropertiesLoose(place, $442adbae090fb373$var$_excluded4);
        var d = "M" + $442adbae090fb373$var$FACTOR * coords[0] + ", " + $442adbae090fb373$var$FACTOR * coords[1] + " h0";
        var active = activePlace && activePlace === name;
        var interactiveProps = {};
        if (onClick || onHover) interactiveProps = $442adbae090fb373$var$buildInteractiveProps(place, function(activate) {
            return setActivePlace(activate);
        }, active);
        if (content && targets[index]) placesContent.push(/*#__PURE__*/ $442adbae090fb373$var$_react["default"].createElement($9097252a6690f3a9$export$aaa698cd7aa517d6, $442adbae090fb373$var$_extends({
            key: key || name
        }, dropProps, {
            target: targets[index]
        }), content));
        return /*#__PURE__*/ $442adbae090fb373$var$_react["default"].createElement("path", $442adbae090fb373$var$_extends({
            key: key,
            ref: function ref(node) {
                return placeRef(node, index);
            },
            strokeLinecap: "round",
            strokeWidth: (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.worldMap.place[active ? 'active' : 'base']),
            stroke: (0, $4113023f9e0bafa0$exports.normalizeColor)(placeColor || color || theme.worldMap.color, theme)
        }, interactiveProps, restPlace, {
            d: d
        }));
    });
    // If the caller is interested in onSelectPlace changes, track where the
    var interactiveProps = {};
    if (onSelectPlace) interactiveProps = {
        onMouseOver: function onMouseOver() {
            return setOver(true);
        },
        onMouseMove: over ? onMouseMove : undefined,
        onMouseLeave: function onMouseLeave() {
            setOver(false);
            setActiveCoords(undefined);
        }
    };
    var active;
    if (activeCoords) {
        var d = "M" + $442adbae090fb373$var$FACTOR * activeCoords[0] + ", " + $442adbae090fb373$var$FACTOR * activeCoords[1] + " h0";
        active = /*#__PURE__*/ $442adbae090fb373$var$_react["default"].createElement("g", {
            stroke: "none",
            fill: "none",
            fillRule: "evenodd",
            onClick: function onClick() {
                return onSelectPlace($442adbae090fb373$var$coordToLatLon(activeCoords, world.bounds));
            }
        }, /*#__PURE__*/ $442adbae090fb373$var$_react["default"].createElement("path", {
            strokeLinecap: "round",
            strokeWidth: (0, $4113023f9e0bafa0$exports.parseMetricToNum)(theme.worldMap.place.active),
            stroke: (0, $4113023f9e0bafa0$exports.normalizeColor)(hoverColor || color || theme.worldMap.hover.color, theme),
            d: d
        }));
    }
    return /*#__PURE__*/ $442adbae090fb373$var$_react["default"].createElement($442adbae090fb373$var$_react["default"].Fragment, null, /*#__PURE__*/ $442adbae090fb373$var$_react["default"].createElement($b751c32e9a9443cc$export$d4d3b8cf744842c7, $442adbae090fb373$var$_extends({
        ref: ref,
        viewBox: world.x + " " + world.y + " " + world.width + " " + world.height,
        preserveAspectRatio: "xMinYMin meet",
        fillProp: fill,
        width: world.width,
        height: world.height
    }, interactiveProps, passThemeFlag, rest), /*#__PURE__*/ $442adbae090fb373$var$_react["default"].createElement("g", {
        ref: containerRef,
        stroke: "none",
        fill: "none",
        fillRule: "evenodd"
    }, continentElements), placeElements, active), placesContent);
});
$442adbae090fb373$var$WorldMap.displayName = 'WorldMap';
$442adbae090fb373$var$WorldMap.propTypes = $f5a18feb6273510f$export$73349ef443631173;


$906dce094c3f451c$export$9a82c68eff2bb78f = $442adbae090fb373$export$9a82c68eff2bb78f;


Object.keys($906dce094c3f451c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3321243da0932e1e$exports && $3321243da0932e1e$exports[key] === $906dce094c3f451c$exports[key]) return;
    $3321243da0932e1e$exports[key] = $906dce094c3f451c$exports[key];
});




const $005c9245bea15c35$export$3ec85612ebfc507 = {
    chargingNetwork: undefined,
    subOrganization: undefined,
    serialNumber: undefined,
    state: undefined,
    chargerLevel: undefined,
    startDate: undefined,
    endDate: undefined
};
const $005c9245bea15c35$export$7aa1788812152cb5 = (availableColumns)=>availableColumns?.slice(0, 8) || [];
const $005c9245bea15c35$var$isEmptyValue = (value)=>value === null || value === undefined || value === '';
const $005c9245bea15c35$export$5b26cd89697b888e = (name)=>({
        property: name,
        align: 'center',
        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
            title: name,
            toUpperCase: true
        }),
        render: (dataRow)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $3321243da0932e1e$exports.Box), {
                pad: {
                    vertical: '1rem'
                },
                align: "center",
                width: {
                    min: '10rem'
                },
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                    children: $005c9245bea15c35$var$isEmptyValue(dataRow[name]) ? "\u2014" : dataRow[name]
                })
            })
    });



const $cc983f378776c51b$var$ApiDataTableBase = (props)=>{
    const { apiData: apiData, shownColumns: shownColumns, onSort: onSort, sortProperty: sortProperty, sortDirection: sortDirection, metadata: metadata, perPage: perPage, currentPage: currentPage, onPageChange: onPageChange } = props;
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const hasData = apiData && apiData.length > 0;
    const hasColumns = shownColumns.length > 0;
    const columns = (0, $2xPiy.useMemo)(()=>shownColumns.map((name)=>(0, $005c9245bea15c35$export$5b26cd89697b888e)(name)), [
        shownColumns
    ]);
    const sanitizedData = (0, $2xPiy.useMemo)(()=>{
        return apiData?.map((item, index)=>{
            const explicitId = item.session_id && String(item.session_id).trim() || item.serial_number && String(item.serial_number).trim() || `row_${index}`;
            return {
                ...item,
                // Uses existing identifier if available, otherwise falls back to index
                _rowId: explicitId
            };
        }) || [];
    }, [
        apiData
    ]);
    const handlePageChange = (page)=>{
        onPageChange(page);
    };
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                overflow: {
                    horizontal: 'auto'
                },
                children: [
                    hasColumns && hasData && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
                        id: "api_data_table",
                        style: {
                            width: '100%'
                        },
                        pad: {
                            horizontal: '0.5rem'
                        },
                        verticalAlign: {
                            body: 'middle'
                        },
                        step: perPage || 20,
                        columns: columns,
                        data: sanitizedData,
                        primaryKey: "_rowId",
                        sortable: true,
                        sort: sortProperty && sortDirection ? {
                            property: sortProperty,
                            direction: sortDirection
                        } : undefined,
                        onSort: onSort ? (sort)=>onSort(sort.property, sort.direction) : undefined,
                        background: [
                            'light-6',
                            'white'
                        ],
                        border: {
                            color: 'light-2',
                            side: 'bottom',
                            size: 'small'
                        }
                    }),
                    (!hasColumns || !hasData) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        pad: {
                            horizontal: '1.5rem',
                            vertical: '2rem'
                        },
                        background: "light-6",
                        justify: "center",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            alignSelf: "center",
                            size: "medium",
                            fontFamily: "Lato, sans-serif",
                            children: t(hasColumns ? 'apiData:noData' : 'apiData:noColumns')
                        })
                    })
                ]
            }),
            hasColumns && hasData && !!metadata && !!currentPage && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                pad: "1.5rem",
                flex: "grow",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ffccbada2139938a$export$68f5e1453c188a82), {
                    alignSelf: "center",
                    size: "small",
                    page: currentPage,
                    step: metadata?.per_page,
                    numberItems: metadata?.total,
                    onChange: (e)=>handlePageChange(e.page)
                })
            })
        ]
    });
};
const $cc983f378776c51b$export$8d7f3e9afc91a654 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).memo($cc983f378776c51b$var$ApiDataTableBase);




parcelRequire("2xPiy");



const $58d77c8a3a2a6b56$export$6ec7879ac5f2af1c = ()=>{
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        flex: true,
        align: "center",
        justify: "center",
        gap: "small",
        pad: {
            horizontal: '1.5rem',
            vertical: '3rem'
        },
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $eec4bc4b18205d01$export$ec91da630f36d5ea), {
                size: "32px",
                color: "brand"
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                size: "medium",
                textAlign: "center",
                fontFamily: "Lato, sans-serif",
                children: t('apiData:noFilters')
            })
        ]
    });
};




class $06b0d7fbe9c2274f$export$a6657da2963457d1 {
    /**
   * List ApiData
   */ static list(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/api-data',
            body: req,
            useArrayBrackets: true
        });
    }
    /**
   * Filter values for ApiData
   */ static filters(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/api-data/filters',
            query: req,
            useArrayBrackets: true
        });
    }
    /**
   * Available columns for ApiData
   */ static columns() {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/api-data/columns',
            useArrayBrackets: true
        });
    }
    /**
   * Get link for Download ApiData as CSV
   */ static getDownloadLink(req) {
        return new (0, $0b9c4bcf60738d6a$export$551a058e9626aa5a)((resolve, reject, onCancel)=>{
            const requestPromise = (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
                method: 'POST',
                url: '/api-data/getDownloadLink',
                body: req,
                useArrayBrackets: true
            });
            onCancel(()=>{
                requestPromise.cancel();
            });
            requestPromise.then((response)=>{
                resolve({
                    ...response,
                    url: new URL(response.url, (0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).api.url).href
                });
            }).catch(reject);
        });
    }
    /**
   * Data for charts
   */ static chartsData(req) {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/api-data/charts',
            body: req,
            useArrayBrackets: true
        });
    }
}


var $fdaf2691e72249ed$export$f78cff4a383213cc = /*#__PURE__*/ function(ApiDataViewType) {
    ApiDataViewType[ApiDataViewType["station"] = 0] = "station";
    ApiDataViewType[ApiDataViewType["session"] = 1] = "session";
    ApiDataViewType[ApiDataViewType["chart"] = 2] = "chart";
    return ApiDataViewType;
}({});
var $fdaf2691e72249ed$export$8daab548de70e374 = /*#__PURE__*/ function(ApiDataChartTimeframe) {
    ApiDataChartTimeframe["days"] = "days";
    ApiDataChartTimeframe["months"] = "months";
    ApiDataChartTimeframe["quarters"] = "quarters";
    ApiDataChartTimeframe["years"] = "years";
    return ApiDataChartTimeframe;
}({});
var $fdaf2691e72249ed$export$7b3d2fd449f65d23 = /*#__PURE__*/ function(ApiDataChartRangePreset) {
    ApiDataChartRangePreset["currentPage"] = "current";
    ApiDataChartRangePreset["days90"] = "days90";
    ApiDataChartRangePreset["months6"] = "months6";
    ApiDataChartRangePreset["year1"] = "year1";
    ApiDataChartRangePreset["year2"] = "year2";
    ApiDataChartRangePreset["year3"] = "year3";
    ApiDataChartRangePreset["year4"] = "year4";
    ApiDataChartRangePreset["year5"] = "year5";
    ApiDataChartRangePreset["year6"] = "year6";
    ApiDataChartRangePreset["year7"] = "year7";
    ApiDataChartRangePreset["custom"] = "custom";
    return ApiDataChartRangePreset;
}({});






const $1be5eb44a7b3049d$var$API_DATA_LIST_DEFAULTS = {
    page: 1,
    search: '',
    per_page: 30,
    order_by: undefined,
    order_direction: undefined,
    ...(0, $005c9245bea15c35$export$3ec85612ebfc507)
};
const $1be5eb44a7b3049d$export$b3c27e869d856b7 = (props)=>{
    /* Props */ const { view: view = (0, $fdaf2691e72249ed$export$f78cff4a383213cc).station, shownColumns: shownColumns, filters: filters, hasAppliedFilters: hasAppliedFilters, surfaceId: surfaceId, ...boxProps } = props;
    /* Context */ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const { handleApiError: handleApiError } = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /* Restorable state */ const restorableList = (0, $d73aac7e90cb996d$export$e4108de26414712f)({
        surfaceId: surfaceId || 'api-data-list',
        defaults: {
            ...$1be5eb44a7b3049d$var$API_DATA_LIST_DEFAULTS,
            ...filters
        },
        standalone: true
    });
    const queryState = restorableList.state;
    const setQueryState = restorableList.setState;
    /* Draft state */ const [draftSearch, setDraftSearch] = (0, $2xPiy.useState)(queryState.search);
    /* Build the API request */ const request = (0, $2xPiy.useMemo)(()=>({
            ...queryState,
            ...filters,
            view_type: view === (0, $fdaf2691e72249ed$export$f78cff4a383213cc).session ? 'session' : 'charger',
            page: queryState.page,
            search: queryState.search || undefined,
            per_page: queryState.per_page,
            order_by: queryState.order_by,
            order_direction: queryState.order_direction
        }), [
        queryState,
        filters,
        view
    ]);
    const areFiltersSynchronized = Object.entries(filters).every(([key, value])=>{
        const queryValue = queryState[key];
        return Array.isArray(value) && Array.isArray(queryValue) ? JSON.stringify(value) === JSON.stringify(queryValue) : value === queryValue;
    });
    /* React Query */ const { data: queryData, isLoading: queryIsLoading, isFetching: isFetching, error: queryError } = (0, $4130e158515cd100$export$dd0a697e1782aedd)({
        queryKey: [
            'api-data:list',
            userStore.user?.id,
            request
        ],
        queryFn: hasAppliedFilters && areFiltersSynchronized ? ()=>(0, $06b0d7fbe9c2274f$export$a6657da2963457d1).list(request) : (0, $43eecd02f94428b5$export$1aa5a89531b7670d),
        placeholderData: (prev)=>prev
    });
    const queryApiData = queryData?.data;
    const queryMetadata = queryData?.meta;
    (0, $2xPiy.useEffect)(()=>{
        setQueryState({
            ...filters,
            page: 1
        });
    }, [
        filters
    ]);
    /* Show toast on query error */ (0, $2xPiy.useEffect)(()=>{
        if (queryError) handleApiError(queryError, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listApiData.error);
    }, [
        queryError
    ]);
    /* Resolved values */ const _apiData = queryApiData;
    const _metadata = queryMetadata;
    const _currentPage = queryState.page;
    const _isLoading = queryIsLoading || isFetching;
    const isRefetching = isFetching && !queryIsLoading;
    /* Methods */ const search = (0, $2xPiy.useCallback)((query)=>{
        setQueryState({
            search: query || '',
            page: 1
        });
    }, [
        setQueryState
    ]);
    const handleSort = (0, $2xPiy.useCallback)((property, direction)=>{
        setQueryState({
            order_by: property,
            order_direction: direction,
            page: 1
        });
    }, [
        setQueryState
    ]);
    const handlePageChange = (0, $2xPiy.useCallback)((page)=>{
        setQueryState({
            page: page
        });
    }, [
        setQueryState
    ]);
    const handlePerPage = (0, $2xPiy.useCallback)((perPage)=>{
        setQueryState({
            per_page: perPage,
            page: 1
        });
    }, [
        setQueryState
    ]);
    /* Sync page from API response */ (0, $2xPiy.useEffect)(()=>{
        if (queryMetadata && queryMetadata.current_page !== queryState.page) setQueryState({
            page: queryMetadata.current_page
        });
    }, [
        queryMetadata?.current_page
    ]);
    /* Sync drafts when queryState changes */ (0, $d73aac7e90cb996d$export$b5b12661e3d1fa94)(queryState, setDraftSearch, (s)=>s.search);
    let titleString = '';
    let icon;
    switch(view){
        case (0, $fdaf2691e72249ed$export$f78cff4a383213cc).station:
            titleString = t('apiData:stationTitle');
            icon = /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f16983307411ac60$export$be11e187edb4cb0c), {
                size: "24px",
                color: "brand"
            });
            break;
        case (0, $fdaf2691e72249ed$export$f78cff4a383213cc).session:
            titleString = t('apiData:sessionTitle');
            icon = /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $91e0caa7b2d289da$export$54ec01a60f47d33d), {
                size: "24px",
                color: "brand"
            });
            break;
    }
    /* Render */ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
        ...boxProps,
        width: '80%',
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                title: titleString,
                icon: icon,
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f7f71094d2af306c$export$55d7609a8f1eccd2), {
                        searchQuery: draftSearch,
                        setSearchQuery: setDraftSearch,
                        placeholder: t('apiData:apiDataSearch'),
                        onSearch: search,
                        isSearching: isRefetching
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                        name: "per_page_selector",
                        value: queryState.per_page,
                        setValue: (value)=>handlePerPage(value),
                        options: [
                            {
                                label: '10 ' + t('apiData:perPage'),
                                value: 10
                            },
                            {
                                label: '30 ' + t('apiData:perPage'),
                                value: 30
                            },
                            {
                                label: '50 ' + t('apiData:perPage'),
                                value: 50
                            },
                            {
                                label: '100 ' + t('apiData:perPage'),
                                value: 100
                            }
                        ],
                        label: 'per page',
                        hideLabel: true,
                        width: "150px"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                pad: "none",
                gap: "none",
                flex: true,
                innerBoxProps: {
                    flex: true
                },
                children: [
                    (_isLoading || hasAppliedFilters && !areFiltersSynchronized) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}),
                    !_isLoading && hasAppliedFilters && areFiltersSynchronized && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        flex: true,
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc983f378776c51b$export$8d7f3e9afc91a654), {
                            apiData: _apiData,
                            shownColumns: shownColumns,
                            onSort: handleSort,
                            sortProperty: queryState.order_by,
                            sortDirection: queryState.order_direction,
                            metadata: _metadata,
                            currentPage: _currentPage,
                            perPage: queryState.per_page,
                            onPageChange: handlePageChange
                        })
                    }),
                    !hasAppliedFilters && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $58d77c8a3a2a6b56$export$6ec7879ac5f2af1c), {})
                ]
            })
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");




var $2xPiy = parcelRequire("2xPiy");

function $2ec8a9280c2f1e41$var$_extends() {
    return $2ec8a9280c2f1e41$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2ec8a9280c2f1e41$var$_extends.apply(null, arguments);
}
var $2ec8a9280c2f1e41$export$caec2af78bcc877f = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $2ec8a9280c2f1e41$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Alert"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 17v2m0-9v6m0-13L2 22h20L12 3z"
    }));
});
$2ec8a9280c2f1e41$export$caec2af78bcc877f.displayName = 'Alert';


var $2xPiy = parcelRequire("2xPiy");

function $d9150df54021eb88$var$_extends() {
    return $d9150df54021eb88$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d9150df54021eb88$var$_extends.apply(null, arguments);
}
var $d9150df54021eb88$export$94aefc399ef206a9 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $d9150df54021eb88$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "BarChart"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M0 22h24M22 2h-4v16h4V2zM6 6H2v12h4V6zm8 12h-4v-8h4v8z"
    }));
});
$d9150df54021eb88$export$94aefc399ef206a9.displayName = 'BarChart';




const $11b0dabc36148d2c$export$69756e9df852d1ec = (props)=>{
    const { innerBoxProps: innerBoxProps, cardHeader: cardHeader, children: children, ...boxProps } = props;
    // const { t } = useTranslation();
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
        flex: {
            shrink: 1,
            grow: 0
        },
        pad: "medium",
        ...boxProps,
        children: [
            cardHeader,
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                flex: true,
                innerBoxProps: {
                    flex: true,
                    elevation: 'none'
                },
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    flex: true,
                    elevation: "none",
                    ...innerBoxProps,
                    children: children
                })
            })
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");






const $8d2e9a6ef4a73b60$export$a2e1b199730e22ac = (props)=>{
    /**
   * Props
   */ const { data: data, height: height, highlightColumn: highlightColumn = false, ...boxProps } = props;
    const [seriesData, setSeriesData] = (0, $2xPiy.useState)([]);
    const chartLabels = data.map((item)=>item.label);
    const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    /* Context */ const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /* Refs */ const themeColors = (0, $2xPiy.useRef)((0, $edb3b666553e0b8a$export$2e2bcd8739ae039).global?.colors ?? {});
    const cardHeight = (0, $2xPiy.useRef)('31.5rem');
    const chartColors = (0, $2xPiy.useRef)([
        themeColors.current['accent-4'],
        themeColors.current['accent-5'],
        themeColors.current['brand'],
        themeColors.current['accent-6'],
        themeColors.current['accent-7'],
        themeColors.current['accent-2']
    ]);
    const chartOptions = (0, $2xPiy.useRef)({
        chart: {
            type: 'bar',
            fontFamily: 'Roboto Condensed, sans-serif',
            foreColor: themeColors.current['dark-3'],
            toolbar: {
                show: false
            },
            zoom: {
                enabled: false
            }
        },
        plotOptions: {
            bar: {
                borderRadius: 6,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last'
            }
        },
        dataLabels: {
            enabled: true
        },
        stroke: {
            show: false
        },
        colors: chartColors.current,
        grid: {
            borderColor: '#EAECEF',
            strokeDashArray: 4,
            xaxis: {
                lines: {
                    show: false
                }
            },
            yaxis: {
                lines: {
                    show: true
                }
            },
            padding: {
                left: 10,
                right: 10
            }
        },
        xaxis: {
            type: 'category',
            axisBorder: {
                show: false
            },
            crosshairs: {
                show: highlightColumn,
                width: 'tickWidth',
                position: 'back',
                opacity: 0.5,
                fill: {
                    type: 'solid',
                    color: '#EAECEF'
                },
                stroke: {
                    width: 0
                }
            },
            labels: {
                style: {
                    fontWeight: 500
                },
                hideOverlappingLabels: false,
                rotate: 0
            }
        },
        yaxis: {
            title: {
                text: t('apiData:totalEnergy')
            },
            labels: {
                style: {
                    fontWeight: 500,
                    fontSize: '12px'
                },
                maxWidth: 200,
                formatter: (value)=>value.toFixed(2)
            }
        },
        tooltip: {
            theme: 'light',
            shared: true,
            intersect: false,
            style: {
                fontSize: '13px'
            }
        },
        legend: {
            show: false
        }
    });
    /* Effects */ (0, $2xPiy.useEffect)(()=>{
        if (!data) return;
        // order labels
        //process
        chartOptions.current = {
            ...chartOptions.current,
            chart: {
                ...chartOptions.current.chart
            }
        };
        const seriesDataMap = {};
        data.forEach((item, index)=>{
            Object.entries(item.data).forEach(([stationName, value])=>{
                if (!seriesDataMap[stationName]) seriesDataMap[stationName] = new Array(data.length).fill(0);
                seriesDataMap[stationName][index] = value;
            });
        });
        setSeriesData(Object.entries(seriesDataMap).map(([name, data])=>({
                name: name,
                data: data
            })));
    }, [
        data,
        navigate
    ]);
    const dynamicWidth = chartLabels.length * 60;
    const legendFormatter = (value)=>{
        if (!value) return value;
        const maxLength = 20;
        if (value.length > maxLength) return value.substring(0, maxLength) + '...';
        return value;
    };
    /* Render */ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
        flex: "grow",
        height: height || cardHeight.current,
        ...boxProps,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $fdccc762800a972d$export$851de33184ecdac4), {
            pad: {
                horizontal: 'medium',
                bottom: '2rem'
            },
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                    width: "100%",
                    flex: "grow",
                    direction: "row",
                    style: {
                        overflowX: 'auto',
                        overflowY: 'hidden'
                    },
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        style: {
                            minWidth: `max(100%, ${dynamicWidth}px)`,
                            width: '100%',
                            height: '100%'
                        },
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($93d6258b67061950$exports))), {
                            options: {
                                ...chartOptions.current,
                                xaxis: {
                                    ...chartOptions.current.xaxis,
                                    categories: chartLabels
                                },
                                yaxis: {
                                    ...chartOptions.current.yaxis,
                                    title: {
                                        text: t('apiData:totalEnergy')
                                    }
                                }
                            },
                            series: seriesData,
                            type: "bar",
                            width: "100%",
                            height: "100%"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                    direction: "row",
                    justify: "center",
                    gap: "medium",
                    style: {
                        flexWrap: 'wrap'
                    },
                    height: "70px",
                    children: seriesData.map((series, index)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            direction: "row",
                            align: "center",
                            gap: "xsmall",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    width: "12px",
                                    height: "12px",
                                    round: "full",
                                    background: chartColors.current[index % chartColors.current.length]
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    size: "16px",
                                    // weight={500}
                                    color: themeColors.current['dark-3'],
                                    children: legendFormatter(series.name)
                                })
                            ]
                        }, series.name))
                })
            ]
        })
    });
};










const $8da8596352d0f44e$var$getMinTimeframe = (stationsCount)=>{
    if (stationsCount > 200) return Object.values((0, $fdaf2691e72249ed$export$8daab548de70e374)).indexOf((0, $fdaf2691e72249ed$export$8daab548de70e374).years);
    if (stationsCount > 50) return Object.values((0, $fdaf2691e72249ed$export$8daab548de70e374)).indexOf((0, $fdaf2691e72249ed$export$8daab548de70e374).quarters);
    if (stationsCount > 15) return Object.values((0, $fdaf2691e72249ed$export$8daab548de70e374)).indexOf((0, $fdaf2691e72249ed$export$8daab548de70e374).months);
    return Object.values((0, $fdaf2691e72249ed$export$8daab548de70e374)).indexOf((0, $fdaf2691e72249ed$export$8daab548de70e374).days);
};
const $8da8596352d0f44e$var$presetToDayRange = (preset, startDate, endDate, filterStartDate, filterEndDate)=>{
    let start;
    let end;
    if (preset === (0, $fdaf2691e72249ed$export$7b3d2fd449f65d23).custom) {
        start = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(startDate || filterStartDate || undefined); // undefined is here to prevent invalid date if one of params is empty string
        end = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(endDate || filterEndDate || undefined);
    } else {
        start = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(startDate || filterStartDate || undefined);
        switch(preset){
            case (0, $fdaf2691e72249ed$export$7b3d2fd449f65d23).days90:
                end = start.add(90, 'day').subtract(1, 'day');
                break;
            case (0, $fdaf2691e72249ed$export$7b3d2fd449f65d23).months6:
                end = start.add(6, 'month').subtract(1, 'day');
                break;
            case (0, $fdaf2691e72249ed$export$7b3d2fd449f65d23).year1:
                end = start.add(1, 'year').subtract(1, 'day');
                break;
            case (0, $fdaf2691e72249ed$export$7b3d2fd449f65d23).year2:
                end = start.add(2, 'year').subtract(1, 'day');
                break;
            case (0, $fdaf2691e72249ed$export$7b3d2fd449f65d23).year3:
                end = start.add(3, 'year').subtract(1, 'day');
                break;
            case (0, $fdaf2691e72249ed$export$7b3d2fd449f65d23).year4:
                end = start.add(4, 'year').subtract(1, 'day');
                break;
            case (0, $fdaf2691e72249ed$export$7b3d2fd449f65d23).year5:
                end = start.add(5, 'year').subtract(1, 'day');
                break;
            case (0, $fdaf2691e72249ed$export$7b3d2fd449f65d23).year6:
                end = start.add(6, 'year').subtract(1, 'day');
                break;
            case (0, $fdaf2691e72249ed$export$7b3d2fd449f65d23).year7:
                end = start.add(7, 'year').subtract(1, 'day');
                break;
            case (0, $fdaf2691e72249ed$export$7b3d2fd449f65d23).currentPage:
                start = filterStartDate ? (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(filterStartDate) : undefined;
                end = filterEndDate ? (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(filterEndDate) : undefined;
                break;
            default:
                start = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(startDate || filterStartDate || undefined);
                end = start;
                break;
        }
    }
    return [
        start,
        end
    ];
};
const $8da8596352d0f44e$export$fdd3c259c93c2a75 = (props)=>{
    const { filters: filters, hasAppliedFilters: hasAppliedFilters, surfaceId: surfaceId, ...boxProps } = props;
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const { handleApiError: handleApiError } = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const [draftStations, setDraftStations] = (0, $2xPiy.useState)([]);
    const [stationList, setStationList] = (0, $2xPiy.useState)([]);
    const restorableList = (0, $d73aac7e90cb996d$export$e4108de26414712f)({
        surfaceId: surfaceId || 'api-data-chart',
        defaults: {
            timeframe: Object.values((0, $fdaf2691e72249ed$export$8daab548de70e374))[$8da8596352d0f44e$var$getMinTimeframe(filters?.serialNumber?.length || 0)],
            rangePreset: (0, $fdaf2691e72249ed$export$7b3d2fd449f65d23).currentPage,
            ...filters
        },
        standalone: true
    });
    const queryState = restorableList.state;
    const setQueryState = restorableList.setState;
    const selectedSerialNumbers = queryState.serialNumber || [];
    const isStationsSelected = selectedSerialNumbers.length > 0;
    const appliedSerialNumbers = filters.serialNumber || [];
    const areStationsSynchronized = stationList.length === appliedSerialNumbers.length && stationList.every((serialNumber, index)=>serialNumber === appliedSerialNumbers[index]) && selectedSerialNumbers.every((serialNumber)=>appliedSerialNumbers.includes(serialNumber));
    const canLoadCharts = hasAppliedFilters && isStationsSelected && areStationsSynchronized;
    const requestDates = (0, $2xPiy.useMemo)(()=>queryState?.rangePreset ? $8da8596352d0f44e$var$presetToDayRange(queryState.rangePreset, queryState.startDate, queryState.endDate, filters.startDate, filters.endDate) : undefined, [
        queryState.rangePreset,
        queryState.startDate,
        queryState.endDate,
        filters.startDate,
        filters.endDate
    ]);
    const request = (0, $2xPiy.useMemo)(()=>{
        return {
            ...queryState,
            chargingNetwork: filters.chargingNetwork,
            subOrganization: filters.subOrganization,
            state: filters.state,
            chargerLevel: filters.chargerLevel,
            startDate: requestDates?.[0] ? requestDates[0].format('YYYY-MM-DD') : undefined,
            endDate: requestDates?.[1] ? requestDates[1].format('YYYY-MM-DD') : undefined
        };
    }, [
        queryState,
        requestDates,
        filters.chargingNetwork,
        filters.chargerLevel,
        filters.subOrganization,
        filters.state
    ]);
    /* React Query */ const { data: queryData, isLoading: isLoading, isFetching: isFetching, error: queryError } = (0, $4130e158515cd100$export$dd0a697e1782aedd)({
        queryKey: [
            'api-data',
            userStore.user?.id,
            request
        ],
        queryFn: canLoadCharts ? ()=>(0, $06b0d7fbe9c2274f$export$a6657da2963457d1).chartsData(request) : (0, $43eecd02f94428b5$export$1aa5a89531b7670d),
        placeholderData: (prev)=>prev,
        enabled: canLoadCharts
    });
    // const queryMetadata = queryData?.meta;
    /* Show toast on query error */ (0, $2xPiy.useEffect)(()=>{
        if (queryError) handleApiError(queryError, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listApiData.error);
    }, [
        queryError
    ]);
    (0, $2xPiy.useEffect)(()=>{
        const defaultStationSelection = [
            ...filters.serialNumber || []
        ].slice(0, 5); // Set no more then 5 items
        setStationList([
            ...filters.serialNumber || []
        ]);
        setDraftStations(defaultStationSelection);
        setQueryState({
            serialNumber: defaultStationSelection,
            timeframe: Object.values((0, $fdaf2691e72249ed$export$8daab548de70e374))[$8da8596352d0f44e$var$getMinTimeframe(defaultStationSelection.length)]
        });
    }, [
        filters.serialNumber
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (queryState.startDate && queryState.endDate) setQueryState({
            rangePreset: (0, $fdaf2691e72249ed$export$7b3d2fd449f65d23).custom
        });
    }, [
        queryState.startDate,
        queryState.endDate
    ]);
    const handleRangeChange = (newValue)=>{
        setQueryState({
            rangePreset: newValue,
            startDate: undefined,
            endDate: undefined
        });
    };
    const availableRangePresets = ()=>{
        const daysDiff = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(filters.endDate).diff(filters.startDate, 'day');
        return Object.values((0, $fdaf2691e72249ed$export$7b3d2fd449f65d23)).filter((preset)=>{
            if (preset === (0, $fdaf2691e72249ed$export$7b3d2fd449f65d23).currentPage || preset === (0, $fdaf2691e72249ed$export$7b3d2fd449f65d23).days90 || preset === (0, $fdaf2691e72249ed$export$7b3d2fd449f65d23).months6) return true;
            if (preset === (0, $fdaf2691e72249ed$export$7b3d2fd449f65d23).custom) return queryState.rangePreset === (0, $fdaf2691e72249ed$export$7b3d2fd449f65d23).custom;
            if (preset.startsWith('year')) {
                const years = parseInt(preset.slice(4), 10);
                if (years === 1) return daysDiff >= 180;
                return daysDiff >= years * 365;
            }
            return false;
        }).map((key)=>({
                label: t(`apiData:range_${key}`),
                value: key
            }));
    };
    const handleTimeFrame = (newValue)=>{
        setQueryState({
            timeframe: newValue
        });
    };
    const handleStartDate = (newValue)=>{
        setQueryState({
            startDate: newValue
        });
    };
    const handleEndDate = (newValue)=>{
        setQueryState({
            endDate: newValue
        });
    };
    const handleStations = (newValue)=>{
        const timeframes = Object.values((0, $fdaf2691e72249ed$export$8daab548de70e374));
        const minimumTimeframe = $8da8596352d0f44e$var$getMinTimeframe(newValue.length);
        const currentTimeframe = queryState.timeframe ? timeframes.indexOf(queryState.timeframe) : 0;
        setQueryState({
            serialNumber: newValue,
            timeframe: timeframes[Math.max(currentTimeframe, minimumTimeframe)]
        });
    };
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        pad: "none",
        flex: true,
        elevation: "none",
        ...boxProps,
        width: "80%",
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            flex: true,
            direction: "column",
            gap: "medium",
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $11b0dabc36148d2c$export$69756e9df852d1ec), {
                    pad: "none",
                    innerBoxProps: {
                        direction: 'column',
                        gap: 'small',
                        pad: {
                            top: 'medium',
                            horizontal: 'medium',
                            bottom: 'xsmall'
                        }
                    },
                    cardHeader: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                        title: t('apiData:chartTitle'),
                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d9150df54021eb88$export$94aefc399ef206a9), {
                            size: "24px",
                            color: "brand"
                        }),
                        pad: "medium"
                    }),
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        justify: "start",
                        flex: true,
                        direction: "row",
                        gap: "xsmall",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                id: "timeframe",
                                label: t('apiData:timeframe'),
                                placeholder: t('common:choose'),
                                options: Object.keys((0, $fdaf2691e72249ed$export$8daab548de70e374)).filter((_key, idx)=>idx >= $8da8596352d0f44e$var$getMinTimeframe(queryState?.serialNumber?.length || 0)).map((key)=>({
                                        label: t(`apiData:timeframe_${key}`),
                                        value: key
                                    })),
                                value: queryState.timeframe,
                                setValue: handleTimeFrame,
                                fontFamily: "Lato, sans-serif",
                                hideOptionalText: true
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                direction: "column",
                                gap: "xsmall",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                        id: "range",
                                        label: t('apiData:range'),
                                        placeholder: t('common:choose'),
                                        options: availableRangePresets(),
                                        value: queryState.rangePreset,
                                        setValue: handleRangeChange,
                                        fontFamily: "Lato, sans-serif",
                                        hideOptionalText: true
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        pad: {
                                            left: 'xsmall'
                                        },
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                            size: "small",
                                            color: "dark-5",
                                            children: t('apiData:rangeHelperText')
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                direction: "column",
                                gap: "xsmall",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        id: "startDateRange",
                                        label: t('apiData:startRange'),
                                        fill: "horizontal",
                                        value: queryState.startDate,
                                        setValue: handleStartDate,
                                        componentType: "date",
                                        dateBounds: [
                                            '1900-01-01',
                                            queryState.endDate || filters.endDate || '2100-01-01'
                                        ],
                                        width: {
                                            width: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(200),
                                            max: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(200)
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        pad: {
                                            left: 'xsmall'
                                        },
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                            size: "small",
                                            color: "dark-5",
                                            children: requestDates?.[0]?.format('YYYY-MM-DD')
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                direction: "column",
                                gap: "xsmall",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        id: "endDateRange",
                                        label: t('apiData:endRange'),
                                        fill: "horizontal",
                                        value: queryState.endDate,
                                        setValue: handleEndDate,
                                        componentType: "date",
                                        dateBounds: [
                                            queryState.startDate || filters.startDate || '1900-01-01',
                                            '2100-01-01'
                                        ],
                                        width: {
                                            width: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(200),
                                            max: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(200)
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        pad: {
                                            left: 'xsmall'
                                        },
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                            size: "small",
                                            color: "dark-5",
                                            children: requestDates?.[1]?.format('YYYY-MM-DD')
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                id: "stations",
                                label: t('apiData:stations'),
                                placeholder: t('common:choose'),
                                options: stationList,
                                multiple: true,
                                values: draftStations,
                                setValues: setDraftStations,
                                onClose: ()=>handleStations(draftStations),
                                fontFamily: "Lato, sans-serif",
                                hideOptionalText: true
                            })
                        ]
                    })
                }),
                !hasAppliedFilters && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $11b0dabc36148d2c$export$69756e9df852d1ec), {
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $58d77c8a3a2a6b56$export$6ec7879ac5f2af1c), {})
                }),
                hasAppliedFilters && !isStationsSelected && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $11b0dabc36148d2c$export$69756e9df852d1ec), {
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                        justify: "center",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2ec8a9280c2f1e41$export$caec2af78bcc877f), {
                                size: "16px"
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                fontFamily: "Lato, sans-serif",
                                size: "large",
                                children: t('apiData:notificationStationSelect')
                            })
                        ]
                    })
                }),
                (isLoading || isFetching) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}),
                !isLoading && !isFetching && canLoadCharts && queryData && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $11b0dabc36148d2c$export$69756e9df852d1ec), {
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8d2e9a6ef4a73b60$export$a2e1b199730e22ac), {
                        data: queryData?.dateChart,
                        highlightColumn: true
                    })
                }),
                !isLoading && !isFetching && canLoadCharts && queryData && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $11b0dabc36148d2c$export$69756e9df852d1ec), {
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8d2e9a6ef4a73b60$export$a2e1b199730e22ac), {
                        data: queryData?.stationChart
                    })
                })
            ]
        })
    });
};









var $2xPiy = parcelRequire("2xPiy");




var $2xPiy = parcelRequire("2xPiy");
/**
 * Inits the React SDK
 */ function $cd544be01d6a9a10$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $5c75d591cd944930$export$b9f95b027256052c)(opts, 'react');
    (0, $4af1b4aa86e906d6$export$2f04de43fe27971a)('react', {
        version: $2xPiy.version
    });
    return (0, $79a61d28a18d7e3e$export$2cd8252107eb640b)(opts);
}





/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $04ba5222c5cb5080$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $e228aefa610f8d34$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $e228aefa610f8d34$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $01d0eacec09c488a$export$69cd5c610c7bb96a)]: value,
            [(0, $01d0eacec09c488a$export$f5f95cff026507b5)]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function $04ba5222c5cb5080$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $01d0eacec09c488a$export$f5f95cff026507b5];
        const value = attributes[0, $01d0eacec09c488a$export$69cd5c610c7bb96a];
        if (typeof unit === 'string' && typeof value === 'number') measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}







const $cd2b9b0ae8266ea8$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return 'poor';
    if (value > thresholds[0]) return 'needs-improvement';
    return 'good';
};
const $cd2b9b0ae8266ea8$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $cd2b9b0ae8266ea8$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $713c1e1777455ae7$export$407ea409d1f3b539 = ()=>{
    return `v4-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // sentry-specific change:
// add optional param to not check for responseStart (see comment below)
const $31054a7415f4a7ba$export$6431553786c94949 = (checkResponseStart = true)=>{
    const navigationEntry = (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).performance && (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).performance.getEntriesByType && (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).performance.getEntriesByType('navigation')[0];
    // Check to ensure the `responseStart` property is present and valid.
    // In some cases no value is reported by the browser (for
    // privacy/security reasons), and in other cases (bugs) the value is
    // negative or is larger than the current page time. Ignore these cases:
    // https://github.com/GoogleChrome/web-vitals/issues/137
    // https://github.com/GoogleChrome/web-vitals/issues/162
    // https://github.com/GoogleChrome/web-vitals/issues/275
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2ed9c119848ed4e6$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $31054a7415f4a7ba$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $47af975f770db3e6$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $31054a7415f4a7ba$export$6431553786c94949)();
    let navigationType = 'navigate';
    if (navEntry) {
        if ((0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document && (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document.prerendering || (0, $2ed9c119848ed4e6$export$d3e828b3c7b5b845)() > 0) navigationType = 'prerender';
        else if ((0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document && (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document.wasDiscarded) navigationType = 'restore';
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, '-');
    }
    // Use `entries` type specific for the metric.
    const entries = [];
    return {
        name: name,
        value: typeof value === 'undefined' ? -1 : value,
        rating: 'good',
        delta: 0,
        entries: entries,
        id: (0, $713c1e1777455ae7$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $58bdcca403bb15a7$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                // Delay by a microtask to workaround a bug in Safari where the
                // callback is invoked immediately, rather than in a separate task.
                // See: https://github.com/GoogleChrome/web-vitals/issues/277
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Sentry-specific change:
// This function's logic was NOT updated to web-vitals 4.2.4 but we continue
// to use the web-vitals 3.5.2 due to us having stricter browser support.
// PR with context that made the changes: https://github.com/GoogleChrome/web-vitals/pull/442/files#r1530492402
// The PR removed listening to the `pagehide` event, in favour of only listening to `visibilitychange` event.
// This is "more correct" but some browsers we still support (Safari 12.1-14.0) don't fully support `visibilitychange`
// or have known bugs w.r.t the `visibilitychange` event.
// TODO (v9): If we decide to drop support for Safari 12.1-14.0, we can use the logic from web-vitals 4.2.4
// In this case, we also need to update the integration tests that currently trigger the `pagehide` event to
// simulate the page being hidden.
const $24ae8a9d6a54a3b2$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === 'pagehide' || (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document && (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') cb(event);
    };
    if ((0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document) {
        addEventListener('visibilitychange', onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener('pagehide', onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $64d8695c0aafeb44$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $3db2cd286668be31$var$firstHiddenTime = -1;
const $3db2cd286668be31$var$initHiddenTime = ()=>{
    // If the document is hidden when this code runs, assume it was always
    // hidden and the page was loaded in the background, with the one exception
    // that visibility state is always 'hidden' during prerendering, so we have
    // to ignore that case until prerendering finishes (see: `prerenderingchange`
    // event logic below).
    return (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document.visibilityState === 'hidden' && !(0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $3db2cd286668be31$var$onVisibilityUpdate = (event)=>{
    // If the document is 'hidden' and no previous hidden timestamp has been
    // set, update it based on the current event data.
    if ((0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document.visibilityState === 'hidden' && $3db2cd286668be31$var$firstHiddenTime > -1) {
        // If the event is a 'visibilitychange' event, it means the page was
        // visible prior to this change, so the event timestamp is the first
        // hidden time.
        // However, if the event is not a 'visibilitychange' event, then it must
        // be a 'prerenderingchange' event, and the fact that the document is
        // still 'hidden' from the above check means the tab was activated
        // in a background state and so has always been hidden.
        $3db2cd286668be31$var$firstHiddenTime = event.type === 'visibilitychange' ? event.timeStamp : 0;
        // Remove all listeners now that a `firstHiddenTime` value has been set.
        $3db2cd286668be31$var$removeChangeListeners();
    }
};
const $3db2cd286668be31$var$addChangeListeners = ()=>{
    addEventListener('visibilitychange', $3db2cd286668be31$var$onVisibilityUpdate, true);
    // IMPORTANT: when a page is prerendering, its `visibilityState` is
    // 'hidden', so in order to account for cases where this module checks for
    // visibility during prerendering, an additional check after prerendering
    // completes is also required.
    addEventListener('prerenderingchange', $3db2cd286668be31$var$onVisibilityUpdate, true);
};
const $3db2cd286668be31$var$removeChangeListeners = ()=>{
    removeEventListener('visibilitychange', $3db2cd286668be31$var$onVisibilityUpdate, true);
    removeEventListener('prerenderingchange', $3db2cd286668be31$var$onVisibilityUpdate, true);
};
const $3db2cd286668be31$export$443f86b2c77012c4 = ()=>{
    if ((0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document && $3db2cd286668be31$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $3db2cd286668be31$var$firstHiddenTime = $3db2cd286668be31$var$initHiddenTime();
        $3db2cd286668be31$var$addChangeListeners();
    }
    return {
        get firstHiddenTime () {
            return $3db2cd286668be31$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7230112e19be9c37$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document && (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document.prerendering) addEventListener('prerenderingchange', ()=>callback(), true);
    else callback();
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FCP. See https://web.dev/articles/fcp#what_is_a_good_fcp_score */ const $dbebc0f88a2ae876$export$e610c735b5510cec = [
    1800,
    3000
];
/**
 * Calculates the [FCP](https://web.dev/articles/fcp) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `paint` performance entry used to determine the value. The reported
 * value is a `DOMHighResTimeStamp`.
 */ const $dbebc0f88a2ae876$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $7230112e19be9c37$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $3db2cd286668be31$export$443f86b2c77012c4)();
        const metric = (0, $47af975f770db3e6$export$3c29b44508a0612b)('FCP');
        let report;
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.name === 'first-contentful-paint') {
                    po.disconnect();
                    // Only report if the page wasn't hidden prior to the first paint.
                    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                        // The activationStart reference is used because FCP should be
                        // relative to page activation rather than navigation start if the
                        // page was prerendered. But in cases where `activationStart` occurs
                        // after the FCP, this time should be clamped at 0.
                        metric.value = Math.max(entry.startTime - (0, $2ed9c119848ed4e6$export$d3e828b3c7b5b845)(), 0);
                        metric.entries.push(entry);
                        report(true);
                    }
                }
            });
        };
        const po = (0, $58bdcca403bb15a7$export$d1203567a167490e)('paint', handleEntries);
        if (po) report = (0, $cd2b9b0ae8266ea8$export$17679dccdd551979)(onReport, metric, $dbebc0f88a2ae876$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for CLS. See https://web.dev/articles/cls#what_is_a_good_cls_score */ const $c252276414c199c2$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
/**
 * Calculates the [CLS](https://web.dev/articles/cls) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/articles/cls#layout_shift_score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $c252276414c199c2$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    // Start monitoring FCP so we can only report CLS if FCP is also reported.
    // Note: this is done to match the current behavior of CrUX.
    (0, $dbebc0f88a2ae876$export$fe3c86b74e15d5de)((0, $64d8695c0aafeb44$export$b841d51e31c12bab)(()=>{
        const metric = (0, $47af975f770db3e6$export$3c29b44508a0612b)('CLS', 0);
        let report;
        let sessionValue = 0;
        let sessionEntries = [];
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                // Only count layout shifts without recent user input.
                if (!entry.hadRecentInput) {
                    const firstSessionEntry = sessionEntries[0];
                    const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                    // If the entry occurred less than 1 second after the previous entry
                    // and less than 5 seconds after the first entry in the session,
                    // include the entry in the current session. Otherwise, start a new
                    // session.
                    if (sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                        sessionValue += entry.value;
                        sessionEntries.push(entry);
                    } else {
                        sessionValue = entry.value;
                        sessionEntries = [
                            entry
                        ];
                    }
                }
            });
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (sessionValue > metric.value) {
                metric.value = sessionValue;
                metric.entries = sessionEntries;
                report();
            }
        };
        const po = (0, $58bdcca403bb15a7$export$d1203567a167490e)('layout-shift', handleEntries);
        if (po) {
            report = (0, $cd2b9b0ae8266ea8$export$17679dccdd551979)(onReport, metric, $c252276414c199c2$export$3f20d8e089ac35b2, opts.reportAllChanges);
            (0, $24ae8a9d6a54a3b2$export$91ec2be6fdd8f1b4)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            // Queue a task to report (if nothing else triggers a report first).
            // This allows CLS to be reported as soon as FCP fires when
            // `reportAllChanges` is true.
            setTimeout(report, 0);
        }
    }));
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FID. See https://web.dev/articles/fid#what_is_a_good_fid_score */ const $fb0065fe84ed1ad5$export$8f7f3c48ca6fbe34 = [
    100,
    300
];
/**
 * Calculates the [FID](https://web.dev/articles/fid) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $fb0065fe84ed1ad5$export$39705a25c49af873 = (onReport, opts = {})=>{
    (0, $7230112e19be9c37$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $3db2cd286668be31$export$443f86b2c77012c4)();
        const metric = (0, $47af975f770db3e6$export$3c29b44508a0612b)('FID');
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntry = (entry)=>{
            // Only report if the page wasn't hidden prior to the first input.
            if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                metric.value = entry.processingStart - entry.startTime;
                metric.entries.push(entry);
                report(true);
            }
        };
        const handleEntries = (entries)=>{
            entries.forEach(handleEntry);
        };
        const po = (0, $58bdcca403bb15a7$export$d1203567a167490e)('first-input', handleEntries);
        report = (0, $cd2b9b0ae8266ea8$export$17679dccdd551979)(onReport, metric, $fb0065fe84ed1ad5$export$8f7f3c48ca6fbe34, opts.reportAllChanges);
        if (po) (0, $24ae8a9d6a54a3b2$export$91ec2be6fdd8f1b4)((0, $64d8695c0aafeb44$export$b841d51e31c12bab)(()=>{
            handleEntries(po.takeRecords());
            po.disconnect();
        }));
    });
};






/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $23575399a3ad580f$var$interactionCountEstimate = 0;
let $23575399a3ad580f$var$minKnownInteractionId = Infinity;
let $23575399a3ad580f$var$maxKnownInteractionId = 0;
const $23575399a3ad580f$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $23575399a3ad580f$var$minKnownInteractionId = Math.min($23575399a3ad580f$var$minKnownInteractionId, e.interactionId);
            $23575399a3ad580f$var$maxKnownInteractionId = Math.max($23575399a3ad580f$var$maxKnownInteractionId, e.interactionId);
            $23575399a3ad580f$var$interactionCountEstimate = $23575399a3ad580f$var$maxKnownInteractionId ? ($23575399a3ad580f$var$maxKnownInteractionId - $23575399a3ad580f$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $23575399a3ad580f$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $23575399a3ad580f$export$8a962f2683a476d1 = ()=>{
    return $23575399a3ad580f$var$po ? $23575399a3ad580f$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $23575399a3ad580f$export$67d90cda6b78a2eb = ()=>{
    if ('interactionCount' in performance || $23575399a3ad580f$var$po) return;
    $23575399a3ad580f$var$po = (0, $58bdcca403bb15a7$export$d1203567a167490e)('event', $23575399a3ad580f$var$updateEstimate, {
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER long.
const $bdfc9aae61a23b98$export$fbb6a65efb09cd7a = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $bdfc9aae61a23b98$export$7b86959c9ded44e2 = new Map();
// The default `durationThreshold` used across this library for observing
// `event` entries via PerformanceObserver.
const $bdfc9aae61a23b98$export$9cebd8cf5d8d3416 = 40;
// Used to store the interaction count after a bfcache restore, since p98
// interaction latencies should only consider the current navigation.
let $bdfc9aae61a23b98$var$prevInteractionCount = 0;
/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $bdfc9aae61a23b98$var$getInteractionCountForNavigation = ()=>{
    return (0, $23575399a3ad580f$export$8a962f2683a476d1)() - $bdfc9aae61a23b98$var$prevInteractionCount;
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $bdfc9aae61a23b98$export$70cf089971ed4f82 = ()=>{
    const candidateInteractionIndex = Math.min($bdfc9aae61a23b98$export$fbb6a65efb09cd7a.length - 1, Math.floor($bdfc9aae61a23b98$var$getInteractionCountForNavigation() / 50));
    return $bdfc9aae61a23b98$export$fbb6a65efb09cd7a[candidateInteractionIndex];
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $bdfc9aae61a23b98$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
/**
 * A list of callback functions to run before each entry is processed.
 * Exposing this list allows the attribution build to hook into the
 * entry processing pipeline.
 */ const $bdfc9aae61a23b98$export$1c74e929da1e189d = [];
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $bdfc9aae61a23b98$export$6a7a48c2c643798f = (entry)=>{
    $bdfc9aae61a23b98$export$1c74e929da1e189d.forEach((cb)=>cb(entry));
    // Skip further processing for entries that cannot be INP candidates.
    if (!(entry.interactionId || entry.entryType === 'first-input')) return;
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $bdfc9aae61a23b98$export$fbb6a65efb09cd7a[$bdfc9aae61a23b98$export$fbb6a65efb09cd7a.length - 1];
    const existingInteraction = $bdfc9aae61a23b98$export$7b86959c9ded44e2.get(entry.interactionId);
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $bdfc9aae61a23b98$export$fbb6a65efb09cd7a.length < $bdfc9aae61a23b98$var$MAX_INTERACTIONS_TO_CONSIDER || minLongestInteraction && entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            // If the new entry has a longer duration, replace the old entries,
            // otherwise add to the array.
            if (entry.duration > existingInteraction.latency) {
                existingInteraction.entries = [
                    entry
                ];
                existingInteraction.latency = entry.duration;
            } else if (entry.duration === existingInteraction.latency && entry.startTime === (existingInteraction.entries[0] && existingInteraction.entries[0].startTime)) existingInteraction.entries.push(entry);
        } else {
            const interaction = {
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $bdfc9aae61a23b98$export$7b86959c9ded44e2.set(interaction.id, interaction);
            $bdfc9aae61a23b98$export$fbb6a65efb09cd7a.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $bdfc9aae61a23b98$export$fbb6a65efb09cd7a.sort((a, b)=>b.latency - a.latency);
        if ($bdfc9aae61a23b98$export$fbb6a65efb09cd7a.length > $bdfc9aae61a23b98$var$MAX_INTERACTIONS_TO_CONSIDER) $bdfc9aae61a23b98$export$fbb6a65efb09cd7a.splice($bdfc9aae61a23b98$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>$bdfc9aae61a23b98$export$7b86959c9ded44e2.delete(i.id));
    }
};









/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs the passed callback during the next idle period, or immediately
 * if the browser's visibility state is (or becomes) hidden.
 */ const $973a90c2eb666f87$export$4d9952dcbf5b2792 = (cb)=>{
    const rIC = (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).requestIdleCallback || (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).setTimeout;
    let handle = -1;
    // eslint-disable-next-line no-param-reassign
    cb = (0, $64d8695c0aafeb44$export$b841d51e31c12bab)(cb);
    // If the document is hidden, run the callback immediately, otherwise
    // race an idle callback with the next `visibilitychange` event.
    if ((0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document && (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') cb();
    else {
        handle = rIC(cb);
        (0, $24ae8a9d6a54a3b2$export$91ec2be6fdd8f1b4)(cb);
    }
    return handle;
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for INP. See https://web.dev/articles/inp#what_is_a_good_inp_score */ const $3ca1868288199d28$export$7f4cb060ded9173c = [
    200,
    500
];
/**
 * Calculates the [INP](https://web.dev/articles/inp) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/articles/inp#what_is_a_good_inp_score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $3ca1868288199d28$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    // Return if the browser doesn't support all APIs needed to measure INP.
    if (!('PerformanceEventTiming' in (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81) && 'interactionId' in PerformanceEventTiming.prototype)) return;
    (0, $7230112e19be9c37$export$8bdb38a5671b594e)(()=>{
        // TODO(philipwalton): remove once the polyfill is no longer needed.
        (0, $23575399a3ad580f$export$67d90cda6b78a2eb)();
        const metric = (0, $47af975f770db3e6$export$3c29b44508a0612b)('INP');
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntries = (entries)=>{
            // Queue the `handleEntries()` callback in the next idle task.
            // This is needed to increase the chances that all event entries that
            // occurred between the user interaction and the next paint
            // have been dispatched. Note: there is currently an experiment
            // running in Chrome (EventTimingKeypressAndCompositionInteractionId)
            // 123+ that if rolled out fully may make this no longer necessary.
            (0, $973a90c2eb666f87$export$4d9952dcbf5b2792)(()=>{
                entries.forEach((0, $bdfc9aae61a23b98$export$6a7a48c2c643798f));
                const inp = (0, $bdfc9aae61a23b98$export$70cf089971ed4f82)();
                if (inp && inp.latency !== metric.value) {
                    metric.value = inp.latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        const po = (0, $58bdcca403bb15a7$export$d1203567a167490e)('event', handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold != null ? opts.durationThreshold : (0, $bdfc9aae61a23b98$export$9cebd8cf5d8d3416)
        });
        report = (0, $cd2b9b0ae8266ea8$export$17679dccdd551979)(onReport, metric, $3ca1868288199d28$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            // Also observe entries of type `first-input`. This is useful in cases
            // where the first interaction is less than the `durationThreshold`.
            po.observe({
                type: 'first-input',
                buffered: true
            });
            (0, $24ae8a9d6a54a3b2$export$91ec2be6fdd8f1b4)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};












/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for LCP. See https://web.dev/articles/lcp#what_is_a_good_lcp_score */ const $dc6b1e113c76891f$export$948521ca5b0e1b17 = [
    2500,
    4000
];
const $dc6b1e113c76891f$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/articles/lcp) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called any time a new `largest-contentful-paint`
 * performance entry is dispatched, or once the final value of the metric has
 * been determined.
 */ const $dc6b1e113c76891f$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $7230112e19be9c37$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $3db2cd286668be31$export$443f86b2c77012c4)();
        const metric = (0, $47af975f770db3e6$export$3c29b44508a0612b)('LCP');
        let report;
        const handleEntries = (entries)=>{
            // If reportAllChanges is set then call this function for each entry,
            // otherwise only consider the last one.
            if (!opts.reportAllChanges) // eslint-disable-next-line no-param-reassign
            entries = entries.slice(-1);
            entries.forEach((entry)=>{
                // Only report if the page wasn't hidden prior to LCP.
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    // The startTime attribute returns the value of the renderTime if it is
                    // not 0, and the value of the loadTime otherwise. The activationStart
                    // reference is used because LCP should be relative to page activation
                    // rather than navigation start if the page was pre-rendered. But in cases
                    // where `activationStart` occurs after the LCP, this time should be
                    // clamped at 0.
                    metric.value = Math.max(entry.startTime - (0, $2ed9c119848ed4e6$export$d3e828b3c7b5b845)(), 0);
                    metric.entries = [
                        entry
                    ];
                    report();
                }
            });
        };
        const po = (0, $58bdcca403bb15a7$export$d1203567a167490e)('largest-contentful-paint', handleEntries);
        if (po) {
            report = (0, $cd2b9b0ae8266ea8$export$17679dccdd551979)(onReport, metric, $dc6b1e113c76891f$export$948521ca5b0e1b17, opts.reportAllChanges);
            const stopListening = (0, $64d8695c0aafeb44$export$b841d51e31c12bab)(()=>{
                if (!$dc6b1e113c76891f$var$reportedMetricIDs[metric.id]) {
                    handleEntries(po.takeRecords());
                    po.disconnect();
                    $dc6b1e113c76891f$var$reportedMetricIDs[metric.id] = true;
                    report(true);
                }
            });
            // Stop listening after input. Note: while scrolling is an input that
            // stops LCP observation, it's unreliable since it can be programmatically
            // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
            [
                'keydown',
                'click'
            ].forEach((type)=>{
                // Wrap in a setTimeout so the callback is run in a separate task
                // to avoid extending the keyboard/click handler to reduce INP impact
                // https://github.com/GoogleChrome/web-vitals/issues/383
                if ((0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document) addEventListener(type, ()=>(0, $973a90c2eb666f87$export$4d9952dcbf5b2792)(stopListening), {
                    once: true,
                    capture: true
                });
            });
            (0, $24ae8a9d6a54a3b2$export$91ec2be6fdd8f1b4)(stopListening);
        }
    });
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for TTFB. See https://web.dev/articles/ttfb#what_is_a_good_ttfb_score */ const $89f92de61cf8d587$export$65c59ea8064668fc = [
    800,
    1800
];
/**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $89f92de61cf8d587$var$whenReady = (callback)=>{
    if ((0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document && (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document.prerendering) (0, $7230112e19be9c37$export$8bdb38a5671b594e)(()=>$89f92de61cf8d587$var$whenReady(callback));
    else if ((0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document && (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).document.readyState !== 'complete') addEventListener('load', ()=>$89f92de61cf8d587$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/articles/ttfb) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $89f92de61cf8d587$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $47af975f770db3e6$export$3c29b44508a0612b)('TTFB');
    const report = (0, $cd2b9b0ae8266ea8$export$17679dccdd551979)(onReport, metric, $89f92de61cf8d587$export$65c59ea8064668fc, opts.reportAllChanges);
    $89f92de61cf8d587$var$whenReady(()=>{
        const navigationEntry = (0, $31054a7415f4a7ba$export$6431553786c94949)();
        if (navigationEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navigationEntry.responseStart - (0, $2ed9c119848ed4e6$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};


const $a938f5a5e4e7044e$var$handlers = {};
const $a938f5a5e4e7044e$var$instrumented = {};
let $a938f5a5e4e7044e$var$_previousCls;
let $a938f5a5e4e7044e$var$_previousFid;
let $a938f5a5e4e7044e$var$_previousLcp;
let $a938f5a5e4e7044e$var$_previousTtfb;
let $a938f5a5e4e7044e$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $a938f5a5e4e7044e$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $a938f5a5e4e7044e$var$addMetricObserver('cls', callback, $a938f5a5e4e7044e$var$instrumentCls, $a938f5a5e4e7044e$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $a938f5a5e4e7044e$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $a938f5a5e4e7044e$var$addMetricObserver('lcp', callback, $a938f5a5e4e7044e$var$instrumentLcp, $a938f5a5e4e7044e$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $a938f5a5e4e7044e$export$2707d7471c0b918f(callback) {
    return $a938f5a5e4e7044e$var$addMetricObserver('fid', callback, $a938f5a5e4e7044e$var$instrumentFid, $a938f5a5e4e7044e$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $a938f5a5e4e7044e$export$699d9529c099a797(callback) {
    return $a938f5a5e4e7044e$var$addMetricObserver('ttfb', callback, $a938f5a5e4e7044e$var$instrumentTtfb, $a938f5a5e4e7044e$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $a938f5a5e4e7044e$export$da3b76aa2022cbd7(callback) {
    return $a938f5a5e4e7044e$var$addMetricObserver('inp', callback, $a938f5a5e4e7044e$var$instrumentInp, $a938f5a5e4e7044e$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $a938f5a5e4e7044e$export$69816c1a049f8db6(type, callback) {
    $a938f5a5e4e7044e$var$addHandler(type, callback);
    if (!$a938f5a5e4e7044e$var$instrumented[type]) {
        $a938f5a5e4e7044e$var$instrumentPerformanceObserver(type);
        $a938f5a5e4e7044e$var$instrumented[type] = true;
    }
    return $a938f5a5e4e7044e$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $a938f5a5e4e7044e$var$triggerHandlers(type, data) {
    const typeHandlers = $a938f5a5e4e7044e$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $5ce69a8e194cc380$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $d668e2a4b0475ef5$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $a938f5a5e4e7044e$var$instrumentCls() {
    return (0, $c252276414c199c2$export$a7873055838e5ad8)((metric)=>{
        $a938f5a5e4e7044e$var$triggerHandlers('cls', {
            metric: metric
        });
        $a938f5a5e4e7044e$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $a938f5a5e4e7044e$var$instrumentFid() {
    return (0, $fb0065fe84ed1ad5$export$39705a25c49af873)((metric)=>{
        $a938f5a5e4e7044e$var$triggerHandlers('fid', {
            metric: metric
        });
        $a938f5a5e4e7044e$var$_previousFid = metric;
    });
}
function $a938f5a5e4e7044e$var$instrumentLcp() {
    return (0, $dc6b1e113c76891f$export$947b1626ab8d5632)((metric)=>{
        $a938f5a5e4e7044e$var$triggerHandlers('lcp', {
            metric: metric
        });
        $a938f5a5e4e7044e$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $a938f5a5e4e7044e$var$instrumentTtfb() {
    return (0, $89f92de61cf8d587$export$33a01e6c5f2c7e33)((metric)=>{
        $a938f5a5e4e7044e$var$triggerHandlers('ttfb', {
            metric: metric
        });
        $a938f5a5e4e7044e$var$_previousTtfb = metric;
    });
}
function $a938f5a5e4e7044e$var$instrumentInp() {
    return (0, $3ca1868288199d28$export$7df4b36ecaed99e1)((metric)=>{
        $a938f5a5e4e7044e$var$triggerHandlers('inp', {
            metric: metric
        });
        $a938f5a5e4e7044e$var$_previousInp = metric;
    });
}
function $a938f5a5e4e7044e$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $a938f5a5e4e7044e$var$addHandler(type, callback);
    let stopListening;
    if (!$a938f5a5e4e7044e$var$instrumented[type]) {
        stopListening = instrumentFn();
        $a938f5a5e4e7044e$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $a938f5a5e4e7044e$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $a938f5a5e4e7044e$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === 'event') options.durationThreshold = 0;
    (0, $58bdcca403bb15a7$export$d1203567a167490e)(type, (entries)=>{
        $a938f5a5e4e7044e$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $a938f5a5e4e7044e$var$addHandler(type, handler) {
    $a938f5a5e4e7044e$var$handlers[type] = $a938f5a5e4e7044e$var$handlers[type] || [];
    $a938f5a5e4e7044e$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $a938f5a5e4e7044e$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $a938f5a5e4e7044e$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
/**
 * Check if a PerformanceEntry is a PerformanceEventTiming by checking for the `duration` property.
 */ function $a938f5a5e4e7044e$export$7affb50b622d8714(entry) {
    return 'duration' in entry;
}











/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $39ca4404d060cc61$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $39ca4404d060cc61$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $39ca4404d060cc61$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $5d145fc2c94d286e$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}









/**
 * Print a log message for a started span.
 */ function $45447eba7bc3a550$export$2f3d84e767c9592b(span) {
    if (!(0, $1f46b14b25973594$export$16a28057038b10ef)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >', parent_span_id: parentSpanId } = (0, $e228aefa610f8d34$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $e228aefa610f8d34$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $e228aefa610f8d34$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? 'sampled' : 'unsampled'} ${isRootSpan ? 'root ' : ''}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $e228aefa610f8d34$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log(`${header}
  ${infoParts.join('\n  ')}`);
}
/**
 * Print a log message for an ended span.
 */ function $45447eba7bc3a550$export$b77c830667a4d630(span) {
    if (!(0, $1f46b14b25973594$export$16a28057038b10ef)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >' } = (0, $e228aefa610f8d34$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $e228aefa610f8d34$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? 'root ' : ''}span "${description}" with ID ${spanId}`;
    (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log(msg);
}







/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $2308f88f1cffce21$export$5f833db634b217bb(options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $e47ffb9996454191$export$5008da00b1b6dee6)(options)) return [
        false
    ];
    // Casting this from unknown, as the type of `sdkProcessingMetadata` is only changed in v9 and `normalizedRequest` is set in SentryHttpInstrumentation
    const normalizedRequest = (0, $a383148e3fcc828a$export$68f3af03034c9e90)().getScopeData().sdkProcessingMetadata.normalizedRequest;
    const enhancedSamplingContext = {
        ...samplingContext,
        normalizedRequest: samplingContext.normalizedRequest || normalizedRequest
    };
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') sampleRate = options.tracesSampler(enhancedSamplingContext);
    else if (enhancedSamplingContext.parentSampled !== undefined) sampleRate = enhancedSamplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') sampleRate = options.tracesSampleRate;
    else // When `enableTracing === true`, we use a sample rate of 100%
    sampleRate = 1;
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $783dda70189181e4$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn('[Tracing] Discarding transaction because of invalid sample rate.');
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        return [
            false,
            parsedSampleRate
        ];
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    const shouldSample = Math.random() < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) {
        (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return [
            false,
            parsedSampleRate
        ];
    }
    return [
        true,
        parsedSampleRate
    ];
}




/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $0ca84427e90c496c$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $3135b6e87c14d175$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $3135b6e87c14d175$export$295213bc4d0c54ad)();
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $e228aefa610f8d34$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLink(_link) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}
















const $7f1c7489ea6fd8cc$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $7f1c7489ea6fd8cc$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $7f1c7489ea6fd8cc$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $9d45b9df9881c412$export$e73679ffaf56810e)(span, $7f1c7489ea6fd8cc$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $9d45b9df9881c412$export$e73679ffaf56810e)(span, $7f1c7489ea6fd8cc$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $7f1c7489ea6fd8cc$export$c08fbc656a245d03(span) {
    return {
        scope: span[$7f1c7489ea6fd8cc$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$7f1c7489ea6fd8cc$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}


const $de252dc56275cdb4$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $de252dc56275cdb4$export$a92149b045260d9f {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $3135b6e87c14d175$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $3135b6e87c14d175$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $958146d03402aa5e$export$ee52dced521e3e18)();
        this._attributes = {};
        this.setAttributes({
            [(0, $01d0eacec09c488a$export$cca8dd30f57f805e)]: 'manual',
            [(0, $01d0eacec09c488a$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLink(_link) {
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $e228aefa610f8d34$export$eb571cd9b5d98de8) : (0, $e228aefa610f8d34$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $e228aefa610f8d34$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, $01d0eacec09c488a$export$d7a7d984b0791405), 'custom');
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $e228aefa610f8d34$export$3f7581298f56c6d7)(endTimestamp);
        (0, $45447eba7bc3a550$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $9d45b9df9881c412$export$d25f2688db1bb433)({
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $01d0eacec09c488a$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $e228aefa610f8d34$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $01d0eacec09c488a$export$cca8dd30f57f805e],
            _metrics_summary: (0, $265629da06370fb9$export$2e7205e45c58797d)(this),
            profile_id: this._attributes[0, $01d0eacec09c488a$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $01d0eacec09c488a$export$fea48ba9f4550879],
            measurements: (0, $04ba5222c5cb5080$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $e228aefa610f8d34$export$c4c6a79b1260ca1b)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $e228aefa610f8d34$export$c4c6a79b1260ca1b)(this).spanContext().spanId : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log('[Tracing] Adding an event to span:', name);
        const time = $de252dc56275cdb4$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $958146d03402aa5e$export$ee52dced521e3e18)();
        const attributes = $de252dc56275cdb4$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $e228aefa610f8d34$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
        if (client) client.emit('spanEnd', this);
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $e228aefa610f8d34$export$c4c6a79b1260ca1b)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $de252dc56275cdb4$var$sendSpanEnvelope((0, $b5349cc77e272d5a$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log('[Tracing] Discarding standalone span because its trace was not chosen to be sampled.');
                if (client) client.recordDroppedEvent('sample_rate', 'span');
            }
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $7f1c7489ea6fd8cc$export$c08fbc656a245d03)(this).scope || (0, $a383148e3fcc828a$export$c7be4b0125a10cba)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$de252dc56275cdb4$var$isFullFinishedSpan((0, $e228aefa610f8d34$export$92d8c23565496537)(this))) return undefined;
        if (!this._name) {
            (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $7f1c7489ea6fd8cc$export$c08fbc656a245d03)(this);
        const scope = capturedSpanScope || (0, $a383148e3fcc828a$export$c7be4b0125a10cba)();
        const client = scope.getClient() || (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            if (client) client.recordDroppedEvent('sample_rate', 'transaction');
            return undefined;
        }
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $e228aefa610f8d34$export$340c5c8a13ffc680)(this).filter((span)=>span !== this && !$de252dc56275cdb4$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $e228aefa610f8d34$export$92d8c23565496537)(span)).filter($de252dc56275cdb4$var$isFullFinishedSpan);
        const source = this._attributes[0, $01d0eacec09c488a$export$d7a7d984b0791405];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, $01d0eacec09c488a$export$165ce9a229f6f050];
        spans.forEach((span)=>{
            span.data && delete span.data[0, $01d0eacec09c488a$export$165ce9a229f6f050];
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = {
            contexts: {
                trace: (0, $e228aefa610f8d34$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $de252dc56275cdb4$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $de252dc56275cdb4$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $9d45b9df9881c412$export$d25f2688db1bb433)({
                    dynamicSamplingContext: (0, $1dfeb99fdc06c052$export$a117f995597e25df)(this)
                })
            },
            _metrics_summary: (0, $265629da06370fb9$export$2e7205e45c58797d)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $04ba5222c5cb5080$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log('[Measurements] Adding measurements to transaction event', JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $de252dc56275cdb4$var$isSpanTimeInput(value) {
    return value && typeof value === 'number' || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $de252dc56275cdb4$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $de252dc56275cdb4$var$isStandaloneSpan(span) {
    return span instanceof $de252dc56275cdb4$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $de252dc56275cdb4$var$sendSpanEnvelope(envelope) {
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent('before_send', 'span');
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}




const $ebc272b9d11b45c8$var$SUPPRESS_TRACING_KEY = '__SENTRY_SUPPRESS_TRACING__';
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $ebc272b9d11b45c8$export$a1bd95187356f372(options, callback) {
    const acs = $ebc272b9d11b45c8$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $ebc272b9d11b45c8$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    return (0, $a383148e3fcc828a$export$ec58d9285c204497)(options.scope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $ebc272b9d11b45c8$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $a383148e3fcc828a$export$c7be4b0125a10cba)();
            const parentSpan = $ebc272b9d11b45c8$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $0ca84427e90c496c$export$d6636b700b76c516)() : $ebc272b9d11b45c8$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $ee9e4ca60d4b7ed9$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $39ca4404d060cc61$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $e228aefa610f8d34$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $18260bff12274275$export$f966a0446ece71e),
                    message: 'internal_error'
                });
            }, ()=>activeSpan.end());
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $ebc272b9d11b45c8$export$c10292ad04b92aea(options, callback) {
    const acs = $ebc272b9d11b45c8$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $ebc272b9d11b45c8$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    return (0, $a383148e3fcc828a$export$ec58d9285c204497)(options.scope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $ebc272b9d11b45c8$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $a383148e3fcc828a$export$c7be4b0125a10cba)();
            const parentSpan = $ebc272b9d11b45c8$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $0ca84427e90c496c$export$d6636b700b76c516)() : $ebc272b9d11b45c8$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $ee9e4ca60d4b7ed9$export$3f25fa50c18e20ca)(scope, activeSpan);
            function finishAndSetSpan() {
                activeSpan.end();
            }
            return (0, $39ca4404d060cc61$export$18ce21a8b7efd7e9)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $e228aefa610f8d34$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $18260bff12274275$export$f966a0446ece71e),
                    message: 'internal_error'
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $ebc272b9d11b45c8$export$63dbba021a6b4047(options) {
    const acs = $ebc272b9d11b45c8$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $ebc272b9d11b45c8$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $a383148e3fcc828a$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$ebc272b9d11b45c8$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $a383148e3fcc828a$export$c7be4b0125a10cba)();
        const parentSpan = $ebc272b9d11b45c8$var$getParentSpan(scope);
        const shouldSkipSpan = options.onlyIfParent && !parentSpan;
        if (shouldSkipSpan) return new (0, $0ca84427e90c496c$export$d6636b700b76c516)();
        return $ebc272b9d11b45c8$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $ebc272b9d11b45c8$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $2efcafe7a288277a$export$19eade501500c6c1)();
    const acs = (0, $c744881b70afcb3e$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    return (0, $a383148e3fcc828a$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $9be700175edbb9b7$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $ebc272b9d11b45c8$export$e57ac09b143d92a2(span, callback) {
    const acs = $ebc272b9d11b45c8$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $a383148e3fcc828a$export$ec58d9285c204497)((scope)=>{
        (0, $ee9e4ca60d4b7ed9$export$3f25fa50c18e20ca)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $ebc272b9d11b45c8$export$869298f9835abc68(callback) {
    const acs = $ebc272b9d11b45c8$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $a383148e3fcc828a$export$ec58d9285c204497)((scope)=>{
        scope.setSDKProcessingMetadata({
            [$ebc272b9d11b45c8$var$SUPPRESS_TRACING_KEY]: true
        });
        return callback();
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $ebc272b9d11b45c8$export$f90b03291402f553(callback) {
    return (0, $a383148e3fcc828a$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $3135b6e87c14d175$export$dc6d7ea554bcce10)()
        });
        (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).info(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $ebc272b9d11b45c8$export$e57ac09b143d92a2(null, callback);
    });
}
function $ebc272b9d11b45c8$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $e47ffb9996454191$export$5008da00b1b6dee6)()) return new (0, $0ca84427e90c496c$export$d6636b700b76c516)();
    const isolationScope = (0, $a383148e3fcc828a$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $ebc272b9d11b45c8$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $e228aefa610f8d34$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $1dfeb99fdc06c052$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $e228aefa610f8d34$export$5caecac1caaf3a71)(parentSpan);
        span = $ebc272b9d11b45c8$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $1dfeb99fdc06c052$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $ebc272b9d11b45c8$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $1dfeb99fdc06c052$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $45447eba7bc3a550$export$2f3d84e767c9592b)(span);
    (0, $7f1c7489ea6fd8cc$export$cddb4027e3b0dd66)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $ebc272b9d11b45c8$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $e228aefa610f8d34$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $ebc272b9d11b45c8$var$getAcs() {
    const carrier = (0, $2efcafe7a288277a$export$19eade501500c6c1)();
    return (0, $c744881b70afcb3e$export$f639b0c2752203be)(carrier);
}
function $ebc272b9d11b45c8$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {};
    const { name: name = '', attributes: attributes } = spanArguments;
    const [sampled, sampleRate] = scope.getScopeData().sdkProcessingMetadata[$ebc272b9d11b45c8$var$SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, $2308f88f1cffce21$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: parentSampled,
        attributes: attributes,
        transactionContext: {
            name: name,
            parentSampled: parentSampled
        }
    });
    const rootSpan = new (0, $de252dc56275cdb4$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $01d0eacec09c488a$export$d7a7d984b0791405)]: 'custom',
            ...spanArguments.attributes
        },
        sampled: sampled
    });
    if (sampleRate !== undefined) rootSpan.setAttribute((0, $01d0eacec09c488a$export$ccfe0a40627cc34b), sampleRate);
    if (client) client.emit('spanStart', rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $ebc272b9d11b45c8$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const sampled = scope.getScopeData().sdkProcessingMetadata[$ebc272b9d11b45c8$var$SUPPRESS_TRACING_KEY] ? false : (0, $e228aefa610f8d34$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $de252dc56275cdb4$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $0ca84427e90c496c$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $e228aefa610f8d34$export$81397d924722cc65)(parentSpan, childSpan);
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    if (client) {
        client.emit('spanStart', childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit('spanEnd', childSpan);
    }
    return childSpan;
}
function $ebc272b9d11b45c8$var$getParentSpan(scope) {
    const span = (0, $ee9e4ca60d4b7ed9$export$91f063ebb8eff307)(scope);
    if (!span) return undefined;
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $e228aefa610f8d34$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $ebc272b9d11b45c8$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $ebc272b9d11b45c8$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}



/**
 * Checks if a given value is a valid measurement value.
 */ function $acc56c49fc365744$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $acc56c49fc365744$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, { ...ctx }) {
    const parentStartTime = (0, $e228aefa610f8d34$export$92d8c23565496537)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) // We can only do this for SentrySpans...
    {
        if (typeof parentSpan.updateStartTime === 'function') parentSpan.updateStartTime(startTimeInSeconds);
    }
    // The return value only exists for tests
    return (0, $ebc272b9d11b45c8$export$e57ac09b143d92a2)(parentSpan, ()=>{
        const span = (0, $ebc272b9d11b45c8$export$63dbba021a6b4047)({
            startTime: startTimeInSeconds,
            ...ctx
        });
        if (span) span.end(endTime);
        return span;
    });
}
/**
 * Starts an inactive, standalone span used to send web vital values to Sentry.
 * DO NOT use this for arbitrary spans, as these spans require special handling
 * during ingestion to extract metrics.
 *
 * This function adds a bunch of attributes and data to the span that's shared
 * by all web vital standalone spans. However, you need to take care of adding
 * the actual web vital value as an event to the span. Also, you need to assign
 * a transaction name and some other values that are specific to the web vital.
 *
 * Ultimately, you also need to take care of ending the span to send it off.
 *
 * @param options
 *
 * @returns an inactive, standalone and NOT YET ended span
 */ function $acc56c49fc365744$export$b71b9c7b60c5a4aa(options) {
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    if (!client) return;
    const { name: name, transaction: transaction, attributes: passedAttributes, startTime: startTime } = options;
    const { release: release, environment: environment } = client.getOptions();
    // We need to get the replay, user, and activeTransaction from the current scope
    // so that we can associate replay id, profile id, and a user display to the span
    const replay = client.getIntegrationByName('Replay');
    const replayId = replay && replay.getReplayId();
    const scope = (0, $a383148e3fcc828a$export$c7be4b0125a10cba)();
    const user = scope.getUser();
    const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
    let profileId;
    try {
        // @ts-expect-error skip optional chaining to save bundle size with try catch
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch (e) {
    // do nothing
    }
    const attributes = {
        release: release,
        environment: environment,
        user: userDisplay || undefined,
        profile_id: profileId || undefined,
        replay_id: replayId || undefined,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        'user_agent.original': (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).navigator && (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).navigator.userAgent,
        ...passedAttributes
    };
    return (0, $ebc272b9d11b45c8$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
/** Get the browser performance API. */ function $acc56c49fc365744$export$f72a13c439a30cab() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81) && (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).addEventListener && (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).performance;
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $acc56c49fc365744$export$b4785dbd4a81b33f(time) {
    return time / 1000;
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $acc56c49fc365744$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = 'unknown';
    let version = 'unknown';
    let _name = '';
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === '/') {
            [name, version] = nextHopProtocol.split('/');
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === 'h' ? 'http' : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}



/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop CLS measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the CLS value is sent as a standalone span and we stop
 * measuring CLS.
 */ function $4c4dc606ac72c026$export$585bab03c6c18c45() {
    let standaloneCLsValue = 0;
    let standaloneClsEntry;
    let pageloadSpanId;
    if (!$4c4dc606ac72c026$var$supportsLayoutShift()) return;
    let sentSpan = false;
    function _collectClsOnce() {
        if (sentSpan) return;
        sentSpan = true;
        if (pageloadSpanId) $4c4dc606ac72c026$var$sendStandaloneClsSpan(standaloneCLsValue, standaloneClsEntry, pageloadSpanId);
        cleanupClsHandler();
    }
    const cleanupClsHandler = (0, $a938f5a5e4e7044e$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    // use pagehide event from web-vitals
    (0, $24ae8a9d6a54a3b2$export$91ec2be6fdd8f1b4)(()=>{
        _collectClsOnce();
    });
    // Since the call chain of this function is synchronous and evaluates before the SDK client is created,
    // we need to wait with subscribing to a client hook until the client is created. Therefore, we defer
    // to the next tick after the SDK setup.
    setTimeout(()=>{
        const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
        if (!client) return;
        const unsubscribeStartNavigation = client.on('startNavigationSpan', ()=>{
            _collectClsOnce();
            unsubscribeStartNavigation && unsubscribeStartNavigation();
        });
        const activeSpan = (0, $e228aefa610f8d34$export$1be426a8e585c83e)();
        const rootSpan = activeSpan && (0, $e228aefa610f8d34$export$c4c6a79b1260ca1b)(activeSpan);
        const spanJSON = rootSpan && (0, $e228aefa610f8d34$export$92d8c23565496537)(rootSpan);
        if (spanJSON && spanJSON.op === 'pageload') pageloadSpanId = rootSpan.spanContext().spanId;
    }, 0);
}
function $4c4dc606ac72c026$var$sendStandaloneClsSpan(clsValue, entry, pageloadSpanId) {
    (0, $5ce69a8e194cc380$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log(`Sending CLS span (${clsValue})`);
    const startTime = (0, $acc56c49fc365744$export$b4785dbd4a81b33f)(((0, $958146d03402aa5e$export$baf075a948ffc0bf) || 0) + (entry && entry.startTime || 0));
    const routeName = (0, $a383148e3fcc828a$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $efa6e113a375d8ac$export$5647df6b7814ac86)(entry.sources[0] && entry.sources[0].node) : 'Layout shift';
    const attributes = (0, $9d45b9df9881c412$export$d25f2688db1bb433)({
        [(0, $01d0eacec09c488a$export$cca8dd30f57f805e)]: 'auto.http.browser.cls',
        [(0, $01d0eacec09c488a$export$1a413bd9a88fdb09)]: 'ui.webvital.cls',
        [(0, $01d0eacec09c488a$export$fea48ba9f4550879)]: entry && entry.duration || 0,
        // attach the pageload span id to the CLS span so that we can link them in the UI
        'sentry.pageload.span_id': pageloadSpanId
    });
    const span = (0, $acc56c49fc365744$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent('cls', {
            [(0, $01d0eacec09c488a$export$f5f95cff026507b5)]: '',
            [(0, $01d0eacec09c488a$export$69cd5c610c7bb96a)]: clsValue
        });
        // LayoutShift performance entries always have a duration of 0, so we don't need to add `entry.duration` here
        // see: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEntry/duration
        span.end(startTime);
    }
}
function $4c4dc606ac72c026$var$supportsLayoutShift() {
    try {
        return PerformanceObserver.supportedEntryTypes.includes('layout-shift');
    } catch (e) {
        return false;
    }
}







const $bbb24181a71b72fc$var$MAX_INT_AS_BYTES = 2147483647;
let $bbb24181a71b72fc$var$_performanceCursor = 0;
let $bbb24181a71b72fc$var$_measurements = {};
let $bbb24181a71b72fc$var$_lcpEntry;
let $bbb24181a71b72fc$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $bbb24181a71b72fc$export$7c69f0412d101b88({ recordClsStandaloneSpans: recordClsStandaloneSpans }) {
    const performance = (0, $acc56c49fc365744$export$f72a13c439a30cab)();
    if (performance && (0, $958146d03402aa5e$export$baf075a948ffc0bf)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).performance.mark('sentry-tracing-init');
        const fidCleanupCallback = $bbb24181a71b72fc$var$_trackFID();
        const lcpCleanupCallback = $bbb24181a71b72fc$var$_trackLCP();
        const ttfbCleanupCallback = $bbb24181a71b72fc$var$_trackTtfb();
        const clsCleanupCallback = recordClsStandaloneSpans ? (0, $4c4dc606ac72c026$export$585bab03c6c18c45)() : $bbb24181a71b72fc$var$_trackCLS();
        return ()=>{
            fidCleanupCallback();
            lcpCleanupCallback();
            ttfbCleanupCallback();
            clsCleanupCallback && clsCleanupCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $bbb24181a71b72fc$export$f396d19077034ad2() {
    (0, $a938f5a5e4e7044e$export$69816c1a049f8db6)('longtask', ({ entries: entries })=>{
        const parent = (0, $e228aefa610f8d34$export$1be426a8e585c83e)();
        if (!parent) return;
        const { op: parentOp, start_timestamp: parentStartTimestamp } = (0, $e228aefa610f8d34$export$92d8c23565496537)(parent);
        for (const entry of entries){
            const startTime = (0, $acc56c49fc365744$export$b4785dbd4a81b33f)((0, $958146d03402aa5e$export$baf075a948ffc0bf) + entry.startTime);
            const duration = (0, $acc56c49fc365744$export$b4785dbd4a81b33f)(entry.duration);
            if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            (0, $acc56c49fc365744$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: 'Main UI thread blocked',
                op: 'ui.long-task',
                attributes: {
                    [(0, $01d0eacec09c488a$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
                }
            });
        }
    });
}
/**
 * Start tracking long animation frames.
 */ function $bbb24181a71b72fc$export$5b823ab2ccbc801d() {
    // NOTE: the current web-vitals version (3.5.2) does not support long-animation-frame, so
    // we directly observe `long-animation-frame` events instead of through the web-vitals
    // `observe` helper function.
    const observer = new PerformanceObserver((list)=>{
        const parent = (0, $e228aefa610f8d34$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of list.getEntries()){
            if (!entry.scripts[0]) continue;
            const startTime = (0, $acc56c49fc365744$export$b4785dbd4a81b33f)((0, $958146d03402aa5e$export$baf075a948ffc0bf) + entry.startTime);
            const { start_timestamp: parentStartTimestamp, op: parentOp } = (0, $e228aefa610f8d34$export$92d8c23565496537)(parent);
            if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            const duration = (0, $acc56c49fc365744$export$b4785dbd4a81b33f)(entry.duration);
            const attributes = {
                [(0, $01d0eacec09c488a$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
            };
            const initialScript = entry.scripts[0];
            const { invoker: invoker, invokerType: invokerType, sourceURL: sourceURL, sourceFunctionName: sourceFunctionName, sourceCharPosition: sourceCharPosition } = initialScript;
            attributes['browser.script.invoker'] = invoker;
            attributes['browser.script.invoker_type'] = invokerType;
            if (sourceURL) attributes['code.filepath'] = sourceURL;
            if (sourceFunctionName) attributes['code.function'] = sourceFunctionName;
            if (sourceCharPosition !== -1) attributes['browser.script.source_char_position'] = sourceCharPosition;
            (0, $acc56c49fc365744$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: 'Main UI thread blocked',
                op: 'ui.long-animation-frame',
                attributes: attributes
            });
        }
    });
    observer.observe({
        type: 'long-animation-frame',
        buffered: true
    });
}
/**
 * Start tracking interaction events.
 */ function $bbb24181a71b72fc$export$e27543e0976315e4() {
    (0, $a938f5a5e4e7044e$export$69816c1a049f8db6)('event', ({ entries: entries })=>{
        const parent = (0, $e228aefa610f8d34$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of entries)if (entry.name === 'click') {
            const startTime = (0, $acc56c49fc365744$export$b4785dbd4a81b33f)((0, $958146d03402aa5e$export$baf075a948ffc0bf) + entry.startTime);
            const duration = (0, $acc56c49fc365744$export$b4785dbd4a81b33f)(entry.duration);
            const spanOptions = {
                name: (0, $efa6e113a375d8ac$export$5647df6b7814ac86)(entry.target),
                op: `ui.interaction.${entry.name}`,
                startTime: startTime,
                attributes: {
                    [(0, $01d0eacec09c488a$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
                }
            };
            const componentName = (0, $efa6e113a375d8ac$export$26727cfcc4d7e0fc)(entry.target);
            if (componentName) spanOptions.attributes['ui.component_name'] = componentName;
            (0, $acc56c49fc365744$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, spanOptions);
        }
    });
}
/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value and last entry
 * to the `_measurements` object which ultimately is applied to the pageload span's measurements.
 */ function $bbb24181a71b72fc$var$_trackCLS() {
    return (0, $a938f5a5e4e7044e$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $bbb24181a71b72fc$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $bbb24181a71b72fc$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $bbb24181a71b72fc$var$_trackLCP() {
    return (0, $a938f5a5e4e7044e$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $bbb24181a71b72fc$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $bbb24181a71b72fc$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $bbb24181a71b72fc$var$_trackFID() {
    return (0, $a938f5a5e4e7044e$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = (0, $acc56c49fc365744$export$b4785dbd4a81b33f)((0, $958146d03402aa5e$export$baf075a948ffc0bf));
        const startTime = (0, $acc56c49fc365744$export$b4785dbd4a81b33f)(entry.startTime);
        $bbb24181a71b72fc$var$_measurements['fid'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $bbb24181a71b72fc$var$_measurements['mark.fid'] = {
            value: timeOrigin + startTime,
            unit: 'second'
        };
    });
}
function $bbb24181a71b72fc$var$_trackTtfb() {
    return (0, $a938f5a5e4e7044e$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $bbb24181a71b72fc$var$_measurements['ttfb'] = {
            value: metric.value,
            unit: 'millisecond'
        };
    });
}
/** Add performance related spans to a transaction */ function $bbb24181a71b72fc$export$5f8fa6b3467a7443(span, options) {
    const performance = (0, $acc56c49fc365744$export$f72a13c439a30cab)();
    if (!performance || !performance.getEntries || !(0, $958146d03402aa5e$export$baf075a948ffc0bf)) // Gatekeeper if performance API not available
    return;
    const timeOrigin = (0, $acc56c49fc365744$export$b4785dbd4a81b33f)((0, $958146d03402aa5e$export$baf075a948ffc0bf));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $e228aefa610f8d34$export$92d8c23565496537)(span);
    performanceEntries.slice($bbb24181a71b72fc$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $acc56c49fc365744$export$b4785dbd4a81b33f)(entry.startTime);
        const duration = (0, $acc56c49fc365744$export$b4785dbd4a81b33f)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case 'navigation':
                $bbb24181a71b72fc$var$_addNavigationSpans(span, entry, timeOrigin);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $bbb24181a71b72fc$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $3db2cd286668be31$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) $bbb24181a71b72fc$var$_measurements['fp'] = {
                        value: entry.startTime,
                        unit: 'millisecond'
                    };
                    if (entry.name === 'first-contentful-paint' && shouldRecord) $bbb24181a71b72fc$var$_measurements['fcp'] = {
                        value: entry.startTime,
                        unit: 'millisecond'
                    };
                    break;
                }
            case 'resource':
                $bbb24181a71b72fc$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $bbb24181a71b72fc$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $bbb24181a71b72fc$var$_trackNavigator(span);
    // Measurements are only available for pageload transactions
    if (op === 'pageload') {
        $bbb24181a71b72fc$var$_addTtfbRequestTimeToMeasurements($bbb24181a71b72fc$var$_measurements);
        const fidMark = $bbb24181a71b72fc$var$_measurements['mark.fid'];
        if (fidMark && $bbb24181a71b72fc$var$_measurements['fid']) {
            // create span for FID
            (0, $acc56c49fc365744$export$7567a67bdb69a23d)(span, fidMark.value, fidMark.value + (0, $acc56c49fc365744$export$b4785dbd4a81b33f)($bbb24181a71b72fc$var$_measurements['fid'].value), {
                name: 'first input delay',
                op: 'ui.action',
                attributes: {
                    [(0, $01d0eacec09c488a$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
                }
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $bbb24181a71b72fc$var$_measurements['mark.fid'];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        // TODO: Check if the first condition is still necessary: `onCLS` already only fires once `onFCP` was called.
        if (!('fcp' in $bbb24181a71b72fc$var$_measurements) || !options.recordClsOnPageloadSpan) delete $bbb24181a71b72fc$var$_measurements.cls;
        Object.entries($bbb24181a71b72fc$var$_measurements).forEach(([measurementName, measurement])=>{
            (0, $04ba5222c5cb5080$export$7cc31b475d33a706)(measurementName, measurement.value, measurement.unit);
        });
        // Set timeOrigin which denotes the timestamp which to base the LCP/FCP/FP/TTFB measurements on
        span.setAttribute('performance.timeOrigin', timeOrigin);
        // In prerendering scenarios, where a page might be prefetched and pre-rendered before the user clicks the link,
        // the navigation starts earlier than when the user clicks it. Web Vitals should always be based on the
        // user-perceived time, so they are not reported from the actual start of the navigation, but rather from the
        // time where the user actively started the navigation, for example by clicking a link.
        // This is user action is called "activation" and the time between navigation and activation is stored in
        // the `activationStart` attribute of the "navigation" PerformanceEntry.
        span.setAttribute('performance.activationStart', (0, $2ed9c119848ed4e6$export$d3e828b3c7b5b845)());
        $bbb24181a71b72fc$var$_setWebVitalAttributes(span);
    }
    $bbb24181a71b72fc$var$_lcpEntry = undefined;
    $bbb24181a71b72fc$var$_clsEntry = undefined;
    $bbb24181a71b72fc$var$_measurements = {};
}
/**
 * Create measure related spans.
 * Exported only for tests.
 */ function $bbb24181a71b72fc$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin) {
    const navEntry = (0, $31054a7415f4a7ba$export$6431553786c94949)(false);
    const requestTime = (0, $acc56c49fc365744$export$b4785dbd4a81b33f)(navEntry ? navEntry.requestStart : 0);
    // Because performance.measure accepts arbitrary timestamps it can produce
    // spans that happen before the browser even makes a request for the page.
    //
    // An example of this is the automatically generated Next.js-before-hydration
    // spans created by the Next.js framework.
    //
    // To prevent this we will pin the start timestamp to the request start time
    // This does make duration inaccurate, so if this does happen, we will add
    // an attribute to the span
    const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    const startTimeStamp = timeOrigin + startTime;
    const measureEndTimestamp = startTimeStamp + duration;
    const attributes = {
        [(0, $01d0eacec09c488a$export$cca8dd30f57f805e)]: 'auto.resource.browser.metrics'
    };
    if (measureStartTimestamp !== startTimeStamp) {
        attributes['sentry.browser.measure_happened_before_request'] = true;
        attributes['sentry.browser.measure_start_time'] = measureStartTimestamp;
    }
    // Measurements from third parties can be off, which would create invalid spans, dropping transactions in the process.
    if (measureStartTimestamp <= measureEndTimestamp) (0, $acc56c49fc365744$export$7567a67bdb69a23d)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
}
/** Instrument navigation entries */ function $bbb24181a71b72fc$var$_addNavigationSpans(span, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach((event)=>{
        $bbb24181a71b72fc$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $bbb24181a71b72fc$var$_addPerformanceNavigationTiming(span, entry, 'secureConnection', timeOrigin, 'TLS/SSL');
    $bbb24181a71b72fc$var$_addPerformanceNavigationTiming(span, entry, 'fetch', timeOrigin, 'cache');
    $bbb24181a71b72fc$var$_addPerformanceNavigationTiming(span, entry, 'domainLookup', timeOrigin, 'DNS');
    $bbb24181a71b72fc$var$_addRequest(span, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $bbb24181a71b72fc$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin, name = event) {
    const eventEnd = $bbb24181a71b72fc$var$_getEndPropertyNameForNavigationTiming(event);
    const end = entry[eventEnd];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $acc56c49fc365744$export$7567a67bdb69a23d)(span, timeOrigin + (0, $acc56c49fc365744$export$b4785dbd4a81b33f)(start), timeOrigin + (0, $acc56c49fc365744$export$b4785dbd4a81b33f)(end), {
        op: `browser.${name}`,
        name: entry.name,
        attributes: {
            [(0, $01d0eacec09c488a$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
        }
    });
}
function $bbb24181a71b72fc$var$_getEndPropertyNameForNavigationTiming(event) {
    if (event === 'secureConnection') return 'connectEnd';
    if (event === 'fetch') return 'domainLookupStart';
    return `${event}End`;
}
/** Create request and response related spans */ function $bbb24181a71b72fc$var$_addRequest(span, entry, timeOrigin) {
    const requestStartTimestamp = timeOrigin + (0, $acc56c49fc365744$export$b4785dbd4a81b33f)(entry.requestStart);
    const responseEndTimestamp = timeOrigin + (0, $acc56c49fc365744$export$b4785dbd4a81b33f)(entry.responseEnd);
    const responseStartTimestamp = timeOrigin + (0, $acc56c49fc365744$export$b4785dbd4a81b33f)(entry.responseStart);
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire span if it contained faulty spans.
        (0, $acc56c49fc365744$export$7567a67bdb69a23d)(span, requestStartTimestamp, responseEndTimestamp, {
            op: 'browser.request',
            name: entry.name,
            attributes: {
                [(0, $01d0eacec09c488a$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
            }
        });
        (0, $acc56c49fc365744$export$7567a67bdb69a23d)(span, responseStartTimestamp, responseEndTimestamp, {
            op: 'browser.response',
            name: entry.name,
            attributes: {
                [(0, $01d0eacec09c488a$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
            }
        });
    }
}
/**
 * Create resource-related spans.
 * Exported only for tests.
 */ function $bbb24181a71b72fc$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    const parsedUrl = (0, $4584eb8e6be08f57$export$7a5253c0f62e0150)(resourceUrl);
    const attributes = {
        [(0, $01d0eacec09c488a$export$cca8dd30f57f805e)]: 'auto.resource.browser.metrics'
    };
    $bbb24181a71b72fc$var$setResourceEntrySizeData(attributes, entry, 'transferSize', 'http.response_transfer_size');
    $bbb24181a71b72fc$var$setResourceEntrySizeData(attributes, entry, 'encodedBodySize', 'http.response_content_length');
    $bbb24181a71b72fc$var$setResourceEntrySizeData(attributes, entry, 'decodedBodySize', 'http.decoded_response_content_length');
    // `deliveryType` is experimental and does not exist everywhere
    const deliveryType = entry.deliveryType;
    if (deliveryType != null) attributes['http.response_delivery_type'] = deliveryType;
    // Types do not reflect this property yet
    const renderBlockingStatus = entry.renderBlockingStatus;
    if (renderBlockingStatus) attributes['resource.render_blocking_status'] = renderBlockingStatus;
    if (parsedUrl.protocol) attributes['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) attributes['server.address'] = parsedUrl.host;
    attributes['url.same_origin'] = resourceUrl.includes((0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).location.origin);
    const { name: name, version: version } = (0, $acc56c49fc365744$export$57c6f824442f9fe1)(entry.nextHopProtocol);
    attributes['network.protocol.name'] = name;
    attributes['network.protocol.version'] = version;
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $acc56c49fc365744$export$7567a67bdb69a23d)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).location.origin, ''),
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
        attributes: attributes
    });
}
/**
 * Capture the information of the user agent.
 */ function $bbb24181a71b72fc$var$_trackNavigator(span) {
    const navigator = (0, $085c565c0b56f1a9$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute('effectiveConnectionType', connection.effectiveType);
        if (connection.type) span.setAttribute('connectionType', connection.type);
        if ((0, $acc56c49fc365744$export$27169ccae1b439e3)(connection.rtt)) $bbb24181a71b72fc$var$_measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, $acc56c49fc365744$export$27169ccae1b439e3)(navigator.deviceMemory)) span.setAttribute('deviceMemory', `${navigator.deviceMemory} GB`);
    if ((0, $acc56c49fc365744$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) span.setAttribute('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to span to allow debugging */ function $bbb24181a71b72fc$var$_setWebVitalAttributes(span) {
    if ($bbb24181a71b72fc$var$_lcpEntry) {
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($bbb24181a71b72fc$var$_lcpEntry.element) span.setAttribute('lcp.element', (0, $efa6e113a375d8ac$export$5647df6b7814ac86)($bbb24181a71b72fc$var$_lcpEntry.element));
        if ($bbb24181a71b72fc$var$_lcpEntry.id) span.setAttribute('lcp.id', $bbb24181a71b72fc$var$_lcpEntry.id);
        if ($bbb24181a71b72fc$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        span.setAttribute('lcp.url', $bbb24181a71b72fc$var$_lcpEntry.url.trim().slice(0, 200));
        if ($bbb24181a71b72fc$var$_lcpEntry.loadTime != null) // loadTime is the time of LCP that's related to receiving the LCP element response..
        span.setAttribute('lcp.loadTime', $bbb24181a71b72fc$var$_lcpEntry.loadTime);
        if ($bbb24181a71b72fc$var$_lcpEntry.renderTime != null) // renderTime is loadTime + rendering time
        // it's 0 if the LCP element is loaded from a 3rd party origin that doesn't send the
        // `Timing-Allow-Origin` header.
        span.setAttribute('lcp.renderTime', $bbb24181a71b72fc$var$_lcpEntry.renderTime);
        span.setAttribute('lcp.size', $bbb24181a71b72fc$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($bbb24181a71b72fc$var$_clsEntry && $bbb24181a71b72fc$var$_clsEntry.sources) $bbb24181a71b72fc$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $efa6e113a375d8ac$export$5647df6b7814ac86)(source.node)));
}
function $bbb24181a71b72fc$var$setResourceEntrySizeData(attributes, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $bbb24181a71b72fc$var$MAX_INT_AS_BYTES) attributes[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $bbb24181a71b72fc$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $31054a7415f4a7ba$export$6431553786c94949)(false);
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) _measurements['ttfb.requestTime'] = {
        value: responseStart - requestStart,
        unit: 'millisecond'
    };
}




const $6a555e1ddc84297e$var$LAST_INTERACTIONS = [];
const $6a555e1ddc84297e$var$INTERACTIONS_SPAN_MAP = new Map();
/**
 * Start tracking INP webvital events.
 */ function $6a555e1ddc84297e$export$f17d06681a4744a3() {
    const performance = (0, $acc56c49fc365744$export$f72a13c439a30cab)();
    if (performance && (0, $958146d03402aa5e$export$baf075a948ffc0bf)) {
        const inpCallback = $6a555e1ddc84297e$var$_trackINP();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
const $6a555e1ddc84297e$var$INP_ENTRY_MAP = {
    click: 'click',
    pointerdown: 'click',
    pointerup: 'click',
    mousedown: 'click',
    mouseup: 'click',
    touchstart: 'click',
    touchend: 'click',
    mouseover: 'hover',
    mouseout: 'hover',
    mouseenter: 'hover',
    mouseleave: 'hover',
    pointerover: 'hover',
    pointerout: 'hover',
    pointerenter: 'hover',
    pointerleave: 'hover',
    dragstart: 'drag',
    dragend: 'drag',
    drag: 'drag',
    dragenter: 'drag',
    dragleave: 'drag',
    dragover: 'drag',
    drop: 'drag',
    keydown: 'press',
    keyup: 'press',
    keypress: 'press',
    input: 'press'
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $6a555e1ddc84297e$var$_trackINP() {
    return (0, $a938f5a5e4e7044e$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        if (metric.value == undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $6a555e1ddc84297e$var$INP_ENTRY_MAP[entry.name]);
        if (!entry) return;
        const { interactionId: interactionId } = entry;
        const interactionType = $6a555e1ddc84297e$var$INP_ENTRY_MAP[entry.name];
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = (0, $acc56c49fc365744$export$b4785dbd4a81b33f)((0, $958146d03402aa5e$export$baf075a948ffc0bf) + entry.startTime);
        const duration = (0, $acc56c49fc365744$export$b4785dbd4a81b33f)(metric.value);
        const activeSpan = (0, $e228aefa610f8d34$export$1be426a8e585c83e)();
        const rootSpan = activeSpan ? (0, $e228aefa610f8d34$export$c4c6a79b1260ca1b)(activeSpan) : undefined;
        // We first try to lookup the span from our INTERACTIONS_SPAN_MAP,
        // where we cache the route per interactionId
        const cachedSpan = interactionId != null ? $6a555e1ddc84297e$var$INTERACTIONS_SPAN_MAP.get(interactionId) : undefined;
        const spanToUse = cachedSpan || rootSpan;
        // Else, we try to use the active span.
        // Finally, we fall back to look at the transactionName on the scope
        const routeName = spanToUse ? (0, $e228aefa610f8d34$export$92d8c23565496537)(spanToUse).description : (0, $a383148e3fcc828a$export$c7be4b0125a10cba)().getScopeData().transactionName;
        const name = (0, $efa6e113a375d8ac$export$5647df6b7814ac86)(entry.target);
        const attributes = (0, $9d45b9df9881c412$export$d25f2688db1bb433)({
            [(0, $01d0eacec09c488a$export$cca8dd30f57f805e)]: 'auto.http.browser.inp',
            [(0, $01d0eacec09c488a$export$1a413bd9a88fdb09)]: `ui.interaction.${interactionType}`,
            [(0, $01d0eacec09c488a$export$fea48ba9f4550879)]: entry.duration
        });
        const span = (0, $acc56c49fc365744$export$b71b9c7b60c5a4aa)({
            name: name,
            transaction: routeName,
            attributes: attributes,
            startTime: startTime
        });
        if (span) {
            span.addEvent('inp', {
                [(0, $01d0eacec09c488a$export$f5f95cff026507b5)]: 'millisecond',
                [(0, $01d0eacec09c488a$export$69cd5c610c7bb96a)]: metric.value
            });
            span.end(startTime + duration);
        }
    });
}
/**
 * Register a listener to cache route information for INP interactions.
 * TODO(v9): `latestRoute` no longer needs to be passed in and will be removed in v9.
 */ function $6a555e1ddc84297e$export$e4e04d43e223cce2(_latestRoute) {
    const handleEntries = ({ entries: entries })=>{
        const activeSpan = (0, $e228aefa610f8d34$export$1be426a8e585c83e)();
        const activeRootSpan = activeSpan && (0, $e228aefa610f8d34$export$c4c6a79b1260ca1b)(activeSpan);
        entries.forEach((entry)=>{
            if (!(0, $a938f5a5e4e7044e$export$7affb50b622d8714)(entry) || !activeRootSpan) return;
            const interactionId = entry.interactionId;
            if (interactionId == null) return;
            // If the interaction was already recorded before, nothing more to do
            if ($6a555e1ddc84297e$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            // We keep max. 10 interactions in the list, then remove the oldest one & clean up
            if ($6a555e1ddc84297e$var$LAST_INTERACTIONS.length > 10) {
                const last = $6a555e1ddc84297e$var$LAST_INTERACTIONS.shift();
                $6a555e1ddc84297e$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            // We add the interaction to the list of recorded interactions
            // and store the span for this interaction
            $6a555e1ddc84297e$var$LAST_INTERACTIONS.push(interactionId);
            $6a555e1ddc84297e$var$INTERACTIONS_SPAN_MAP.set(interactionId, activeRootSpan);
        });
    };
    (0, $a938f5a5e4e7044e$export$69816c1a049f8db6)('event', handleEntries);
    (0, $a938f5a5e4e7044e$export$69816c1a049f8db6)('first-input', handleEntries);
}








let $b43014688c4eb3d5$var$errorsInstrumented = false;
/**
 * Ensure that global errors automatically set the active span status.
 */ function $b43014688c4eb3d5$export$b0914730ee1f6c80() {
    if ($b43014688c4eb3d5$var$errorsInstrumented) return;
    $b43014688c4eb3d5$var$errorsInstrumented = true;
    (0, $8f992e0826d111dd$export$55b5c3ba2194f0c6)($b43014688c4eb3d5$var$errorCallback);
    (0, $545c8ea05bc34624$export$8bf4fc6858821a4e)($b43014688c4eb3d5$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active root span as failed
 */ function $b43014688c4eb3d5$var$errorCallback() {
    const activeSpan = (0, $e228aefa610f8d34$export$1be426a8e585c83e)();
    const rootSpan = activeSpan && (0, $e228aefa610f8d34$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        const message = 'internal_error';
        (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log(`[Tracing] Root span: ${message} -> Global error occurred`);
        rootSpan.setStatus({
            code: (0, $18260bff12274275$export$f966a0446ece71e),
            message: message
        });
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$b43014688c4eb3d5$var$errorCallback.tag = 'sentry_tracingErrorCallback';












const $ed2f6a1d79b708c2$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    childSpanTimeout: 15000
};
const $ed2f6a1d79b708c2$var$FINISH_REASON_HEARTBEAT_FAILED = 'heartbeatFailed';
const $ed2f6a1d79b708c2$var$FINISH_REASON_IDLE_TIMEOUT = 'idleTimeout';
const $ed2f6a1d79b708c2$var$FINISH_REASON_FINAL_TIMEOUT = 'finalTimeout';
const $ed2f6a1d79b708c2$var$FINISH_REASON_EXTERNAL_FINISH = 'externalFinish';
/**
 * An idle span is a span that automatically finishes. It does this by tracking child spans as activities.
 * An idle span is always the active span.
 */ function $ed2f6a1d79b708c2$export$901bffd97bd52797(startSpanOptions, options = {}) {
    // Activities store a list of active spans
    const activities = new Map();
    // We should not use heartbeat if we finished a span
    let _finished = false;
    // Timer that tracks idleTimeout
    let _idleTimeoutID;
    // The reason why the span was finished
    let _finishReason = $ed2f6a1d79b708c2$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $ed2f6a1d79b708c2$export$809a2b7987fd5306.idleTimeout, finalTimeout: finalTimeout = $ed2f6a1d79b708c2$export$809a2b7987fd5306.finalTimeout, childSpanTimeout: childSpanTimeout = $ed2f6a1d79b708c2$export$809a2b7987fd5306.childSpanTimeout, beforeSpanEnd: beforeSpanEnd } = options;
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    if (!client || !(0, $e47ffb9996454191$export$5008da00b1b6dee6)()) return new (0, $0ca84427e90c496c$export$d6636b700b76c516)();
    const scope = (0, $a383148e3fcc828a$export$c7be4b0125a10cba)();
    const previousActiveSpan = (0, $e228aefa610f8d34$export$1be426a8e585c83e)();
    const span = $ed2f6a1d79b708c2$var$_startIdleSpan(startSpanOptions);
    // We patch span.end to ensure we can run some things before the span is ended
    // eslint-disable-next-line @typescript-eslint/unbound-method
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            // Just ensuring that this keeps working, even if we ever have more arguments here
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || (0, $958146d03402aa5e$export$ee52dced521e3e18)();
            const spanEndTimestamp = (0, $e228aefa610f8d34$export$3f7581298f56c6d7)(timestamp);
            // Ensure we end with the last span timestamp, if possible
            const spans = (0, $e228aefa610f8d34$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
            // If we have no spans, we just end, nothing else to do here
            if (!spans.length) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const childEndTimestamps = spans.map((span)=>(0, $e228aefa610f8d34$export$92d8c23565496537)(span).timestamp).filter((timestamp)=>!!timestamp);
            const latestSpanEndTimestamp = childEndTimestamps.length ? Math.max(...childEndTimestamps) : undefined;
            // In reality this should always exist here, but type-wise it may be undefined...
            const spanStartTimestamp = (0, $e228aefa610f8d34$export$92d8c23565496537)(span).start_timestamp;
            // The final endTimestamp should:
            // * Never be before the span start timestamp
            // * Be the latestSpanEndTimestamp, if there is one, and it is smaller than the passed span end timestamp
            // * Otherwise be the passed end timestamp
            // Final timestamp can never be after finalTimeout
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1000 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    /**
   * Cancels the existing idle timeout, if there is one.
   */ function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = undefined;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $ed2f6a1d79b708c2$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    /**
   * Restarts child span timeout, if there is none running it will start one.
   */ function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $ed2f6a1d79b708c2$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = (0, $958146d03402aa5e$export$ee52dced521e3e18)();
        // We need to add the timeout here to have the real endtimestamp of the idle span
        // Remember timestampInSeconds is in seconds, timeout is in ms
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1000);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = (0, $958146d03402aa5e$export$ee52dced521e3e18)();
            // We need to add the timeout here to have the real endtimestamp of the idle span
            // Remember timestampInSeconds is in seconds, timeout is in ms
            _restartIdleTimeout(endTimestamp + idleTimeout / 1000);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        (0, $ee9e4ca60d4b7ed9$export$3f25fa50c18e20ca)(scope, previousActiveSpan);
        const spanJSON = (0, $e228aefa610f8d34$export$92d8c23565496537)(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        // This should never happen, but to make TS happy...
        if (!startTimestamp) return;
        const attributes = spanJSON.data || {};
        if (!attributes[0, $01d0eacec09c488a$export$ba73f34502b7a3b3]) span.setAttribute((0, $01d0eacec09c488a$export$ba73f34502b7a3b3), _finishReason);
        (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = (0, $e228aefa610f8d34$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            // We cancel all pending spans with status "cancelled" to indicate the idle span was finished early
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: (0, $18260bff12274275$export$f966a0446ece71e),
                    message: 'cancelled'
                });
                childSpan.end(endTimestamp);
                (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log('[Tracing] Cancelling span since span ended early', JSON.stringify(childSpan, undefined, 2));
            }
            const childSpanJSON = (0, $e228aefa610f8d34$export$92d8c23565496537)(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            // Add a delta with idle timeout so that we prevent false positives
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1000;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if (0, $1f46b14b25973594$export$16a28057038b10ef) {
                const stringifiedSpan = JSON.stringify(childSpan, undefined, 2);
                if (!spanStartedBeforeIdleSpanEnd) (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log('[Tracing] Discarding span since it happened after idle span was finished', stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log('[Tracing] Discarding span since it finished after idle span final timeout', stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                (0, $e228aefa610f8d34$export$c2a0c9438bb89d91)(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute('sentry.idle_span_discarded_spans', discardedSpans);
    }
    _cleanupHooks.push(client.on('spanStart', (startedSpan)=>{
        // If we already finished the idle span,
        // or if this is the idle span itself being started,
        // or if the started span has already been closed,
        // we don't care about it for activity
        if (_finished || startedSpan === span || !!(0, $e228aefa610f8d34$export$92d8c23565496537)(startedSpan).timestamp) return;
        const allSpans = (0, $e228aefa610f8d34$export$340c5c8a13ffc680)(span);
        // If the span that was just started is a child of the idle span, we should track it
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on('spanEnd', (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on('idleSpanEnableAutoFinish', (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    // We only start the initial idle timeout if we are not delaying the auto finish
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: (0, $18260bff12274275$export$f966a0446ece71e),
                message: 'deadline_exceeded'
            });
            _finishReason = $ed2f6a1d79b708c2$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $ed2f6a1d79b708c2$var$_startIdleSpan(options) {
    const span = (0, $ebc272b9d11b45c8$export$63dbba021a6b4047)(options);
    (0, $ee9e4ca60d4b7ed9$export$3f25fa50c18e20ca)((0, $a383148e3fcc828a$export$c7be4b0125a10cba)(), span);
    (0, $1f46b14b25973594$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log('[Tracing] Started span is an idle span');
    return span;
}







/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $23e2024822c9b1ec$export$6f18f55521af71a1() {
    if ((0, $df1f7a182305cd2c$export$56d8a8a25bd48b81) && (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).document) (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
        const activeSpan = (0, $e228aefa610f8d34$export$1be426a8e585c83e)();
        if (!activeSpan) return;
        const rootSpan = (0, $e228aefa610f8d34$export$c4c6a79b1260ca1b)(activeSpan);
        if ((0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).document.hidden && rootSpan) {
            const cancelledStatus = 'cancelled';
            const { op: op, status: status } = (0, $e228aefa610f8d34$export$92d8c23565496537)(rootSpan);
            if (0, $aea8a197a12f0967$export$16a28057038b10ef) (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) rootSpan.setStatus({
                code: (0, $18260bff12274275$export$f966a0446ece71e),
                message: cancelledStatus
            });
            rootSpan.setAttribute('sentry.cancellation_reason', 'document.hidden');
            rootSpan.end();
        }
    });
    else (0, $aea8a197a12f0967$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}
















/**
 * Extracts trace propagation data from the current span or from the client's scope (via transaction or propagation
 * context) and serializes it to `sentry-trace` and `baggage` values to strings. These values can be used to propagate
 * a trace via our tracing Http headers or Html `<meta>` tags.
 *
 * This function also applies some validation to the generated sentry-trace and baggage values to ensure that
 * only valid strings are returned.
 *
 * @returns an object with the tracing data values. The object keys are the name of the tracing key to be used as header
 * or meta tag name.
 */ function $faa6fcafcd34e0e3$export$dec8f001b9d982cb(options = {}) {
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    if (!(0, $4af1b4aa86e906d6$export$3b029eb57ac4d562)() || !client) return {};
    const carrier = (0, $2efcafe7a288277a$export$19eade501500c6c1)();
    const acs = (0, $c744881b70afcb3e$export$f639b0c2752203be)(carrier);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = (0, $a383148e3fcc828a$export$c7be4b0125a10cba)();
    const span = options.span || (0, $e228aefa610f8d34$export$1be426a8e585c83e)();
    const sentryTrace = span ? (0, $e228aefa610f8d34$export$7e9f8ae9e4a328ab)(span) : $faa6fcafcd34e0e3$var$scopeToTraceHeader(scope);
    const dsc = span ? (0, $1dfeb99fdc06c052$export$a117f995597e25df)(span) : (0, $1dfeb99fdc06c052$export$89ef1736f08c6b2b)(client, scope);
    const baggage = (0, $38bce5d11c2da882$export$56766feef403f365)(dsc);
    const isValidSentryTraceHeader = (0, $9be700175edbb9b7$export$394a210812ba3012).test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn('Invalid sentry-trace data. Cannot generate trace data');
        return {};
    }
    return {
        'sentry-trace': sentryTrace,
        baggage: baggage
    };
}
/**
 * Get a sentry-trace header value for the given scope.
 */ function $faa6fcafcd34e0e3$var$scopeToTraceHeader(scope) {
    // TODO(v9): Use generateSpanId() instead of spanId
    // eslint-disable-next-line deprecation/deprecation
    const { traceId: traceId, sampled: sampled, spanId: spanId } = scope.getPropagationContext();
    return (0, $9be700175edbb9b7$export$f35d907436da45cf)(traceId, spanId, sampled);
}

















/**
 * Create and track fetch request spans for usage in combination with `addFetchInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $07fc1b550ecd047c$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = 'auto.http.browser') {
    if (!handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = (0, $e47ffb9996454191$export$5008da00b1b6dee6)() && shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $07fc1b550ecd047c$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $07fc1b550ecd047c$var$getFullURL(url);
    const host = fullUrl ? (0, $4584eb8e6be08f57$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const hasParent = !!(0, $e228aefa610f8d34$export$1be426a8e585c83e)();
    const span = shouldCreateSpanResult && hasParent ? (0, $ebc272b9d11b45c8$export$63dbba021a6b4047)({
        name: `${method} ${url}`,
        attributes: {
            url: url,
            type: 'fetch',
            'http.method': method,
            'http.url': fullUrl,
            'server.address': host,
            [(0, $01d0eacec09c488a$export$cca8dd30f57f805e)]: spanOrigin,
            [(0, $01d0eacec09c488a$export$1a413bd9a88fdb09)]: 'http.client'
        }
    }) : new (0, $0ca84427e90c496c$export$d6636b700b76c516)();
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        const options = handlerData.args[1] || {};
        const headers = $07fc1b550ecd047c$var$_addTracingHeadersToFetchRequest(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        (0, $e47ffb9996454191$export$5008da00b1b6dee6)() && hasParent ? span : undefined);
        if (headers) {
            // Ensure this is actually set, if no options have been passed previously
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers.
 */ function $07fc1b550ecd047c$var$_addTracingHeadersToFetchRequest(request, fetchOptionsObj, span) {
    const traceHeaders = (0, $faa6fcafcd34e0e3$export$dec8f001b9d982cb)({
        span: span
    });
    const sentryTrace = traceHeaders['sentry-trace'];
    const baggage = traceHeaders.baggage;
    // Nothing to do, when we return undefined here, the original headers will be used
    if (!sentryTrace) return undefined;
    const headers = fetchOptionsObj.headers || ($07fc1b550ecd047c$var$isRequest(request) ? request.headers : undefined);
    if (!headers) return {
        ...traceHeaders
    };
    else if ($07fc1b550ecd047c$var$isHeaders(headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.set('sentry-trace', sentryTrace);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get('baggage');
            if (prevBaggageHeader) {
                const prevHeaderStrippedFromSentryBaggage = $07fc1b550ecd047c$var$stripBaggageHeaderOfSentryBaggageValues(prevBaggageHeader);
                newHeaders.set('baggage', // If there are non-sentry entries (i.e. if the stripped string is non-empty/truthy) combine the stripped header and sentry baggage header
                // otherwise just set the sentry baggage header
                prevHeaderStrippedFromSentryBaggage ? `${prevHeaderStrippedFromSentryBaggage},${baggage}` : baggage);
            } else newHeaders.set('baggage', baggage);
        }
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers// Remove any existing sentry-trace headers
            .filter((header)=>{
                return !(Array.isArray(header) && header[0] === 'sentry-trace');
            })// Get rid of previous sentry baggage values in baggage header
            .map((header)=>{
                if (Array.isArray(header) && header[0] === 'baggage' && typeof header[1] === 'string') {
                    const [headerName, headerValue, ...rest] = header;
                    return [
                        headerName,
                        $07fc1b550ecd047c$var$stripBaggageHeaderOfSentryBaggageValues(headerValue),
                        ...rest
                    ];
                } else return header;
            }),
            // Attach the new sentry-trace header
            [
                'sentry-trace',
                sentryTrace
            ]
        ];
        if (baggage) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            'baggage',
            baggage
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
        let newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders = existingBaggageHeader.map((headerItem)=>typeof headerItem === 'string' ? $07fc1b550ecd047c$var$stripBaggageHeaderOfSentryBaggageValues(headerItem) : headerItem).filter((headerItem)=>headerItem === '');
        else if (existingBaggageHeader) newBaggageHeaders.push($07fc1b550ecd047c$var$stripBaggageHeaderOfSentryBaggageValues(existingBaggageHeader));
        if (baggage) newBaggageHeaders.push(baggage);
        return {
            ...headers,
            'sentry-trace': sentryTrace,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        };
    }
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers.
 *
 * @deprecated This function will not be exported anymore in v9.
 */ function $07fc1b550ecd047c$export$6717acf674206871(request, _client, _scope, fetchOptionsObj, span) {
    return $07fc1b550ecd047c$var$_addTracingHeadersToFetchRequest(request, fetchOptionsObj, span);
}
function $07fc1b550ecd047c$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $07fc1b550ecd047c$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $18260bff12274275$export$2ad6630ec8164254)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute('http.response_content_length', contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: (0, $18260bff12274275$export$f966a0446ece71e),
        message: 'internal_error'
    });
    span.end();
}
function $07fc1b550ecd047c$var$stripBaggageHeaderOfSentryBaggageValues(baggageHeader) {
    return baggageHeader.split(',')// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .filter((baggageEntry)=>!baggageEntry.split('=')[0].startsWith((0, $38bce5d11c2da882$export$6e69537d67fa20f))).join(',');
}
function $07fc1b550ecd047c$var$isRequest(request) {
    return typeof Request !== 'undefined' && (0, $5d145fc2c94d286e$export$49034edbe6b62415)(request, Request);
}
function $07fc1b550ecd047c$var$isHeaders(headers) {
    return typeof Headers !== 'undefined' && (0, $5d145fc2c94d286e$export$49034edbe6b62415)(headers, Headers);
}



/** Options for Request Instrumentation */ const $1c43b95d469ba2ea$var$responseToSpanId = new WeakMap();
const $1c43b95d469ba2ea$var$spanIdToEndTimestamp = new Map();
const $1c43b95d469ba2ea$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    trackFetchStreamPerformance: false
};
/** Registers span creators for xhr and fetch requests  */ function $1c43b95d469ba2ea$export$864489cb3478db3e(client, _options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets } = {
        traceFetch: $1c43b95d469ba2ea$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $1c43b95d469ba2ea$export$cc17fb3c0bc95cd7.traceXHR,
        trackFetchStreamPerformance: $1c43b95d469ba2ea$export$cc17fb3c0bc95cd7.trackFetchStreamPerformance,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$1c43b95d469ba2ea$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    if (traceFetch) {
        // Keeping track of http requests, whose body payloads resolved later than the initial resolved request
        // e.g. streaming using server sent events (SSE)
        client.addEventProcessor((event)=>{
            if (event.type === 'transaction' && event.spans) event.spans.forEach((span)=>{
                if (span.op === 'http.client') {
                    const updatedTimestamp = $1c43b95d469ba2ea$var$spanIdToEndTimestamp.get(span.span_id);
                    if (updatedTimestamp) {
                        span.timestamp = updatedTimestamp / 1000;
                        $1c43b95d469ba2ea$var$spanIdToEndTimestamp.delete(span.span_id);
                    }
                }
            });
            return event;
        });
        if (trackFetchStreamPerformance) (0, $58ddee4fc1fd3ed5$export$1a79663eb318fe6a)((handlerData)=>{
            if (handlerData.response) {
                const span = $1c43b95d469ba2ea$var$responseToSpanId.get(handlerData.response);
                if (span && handlerData.endTimestamp) $1c43b95d469ba2ea$var$spanIdToEndTimestamp.set(span, handlerData.endTimestamp);
            }
        });
        (0, $58ddee4fc1fd3ed5$export$f75d3c772c923df0)((handlerData)=>{
            const createdSpan = (0, $07fc1b550ecd047c$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
            if (handlerData.response && handlerData.fetchData.__span) $1c43b95d469ba2ea$var$responseToSpanId.set(handlerData.response, handlerData.fetchData.__span);
            // We cannot use `window.location` in the generic fetch instrumentation,
            // but we need it for reliable `server.address` attribute.
            // so we extend this in here
            if (createdSpan) {
                const fullUrl = $1c43b95d469ba2ea$var$getFullURL(handlerData.fetchData.url);
                const host = fullUrl ? (0, $4584eb8e6be08f57$export$7a5253c0f62e0150)(fullUrl).host : undefined;
                createdSpan.setAttributes({
                    'http.url': fullUrl,
                    'server.address': host
                });
            }
            if (enableHTTPTimings && createdSpan) $1c43b95d469ba2ea$var$addHTTPTimings(createdSpan);
        });
    }
    if (traceXHR) (0, $3bd585063dd5b110$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $1c43b95d469ba2ea$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $1c43b95d469ba2ea$var$addHTTPTimings(createdSpan);
    });
}
function $1c43b95d469ba2ea$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $1c43b95d469ba2ea$var$addHTTPTimings(span) {
    const { url: url } = (0, $e228aefa610f8d34$export$92d8c23565496537)(span).data || {};
    if (!url || typeof url !== 'string') return;
    const cleanup = (0, $a938f5a5e4e7044e$export$69816c1a049f8db6)('resource', ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($1c43b95d469ba2ea$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $1c43b95d469ba2ea$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
function $1c43b95d469ba2ea$var$getAbsoluteTime(time = 0) {
    return (((0, $958146d03402aa5e$export$baf075a948ffc0bf) || performance.timeOrigin) + time) / 1000;
}
function $1c43b95d469ba2ea$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = (0, $acc56c49fc365744$export$57c6f824442f9fe1)(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        'network.protocol.version',
        version
    ], [
        'network.protocol.name',
        name
    ]);
    if (!(0, $958146d03402aa5e$export$baf075a948ffc0bf)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            'http.request.redirect_start',
            $1c43b95d469ba2ea$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            'http.request.fetch_start',
            $1c43b95d469ba2ea$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            'http.request.domain_lookup_start',
            $1c43b95d469ba2ea$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            'http.request.domain_lookup_end',
            $1c43b95d469ba2ea$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            'http.request.connect_start',
            $1c43b95d469ba2ea$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            'http.request.secure_connection_start',
            $1c43b95d469ba2ea$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            'http.request.connection_end',
            $1c43b95d469ba2ea$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            'http.request.request_start',
            $1c43b95d469ba2ea$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            'http.request.response_start',
            $1c43b95d469ba2ea$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            'http.request.response_end',
            $1c43b95d469ba2ea$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * We only export this function for testing purposes.
 */ function $1c43b95d469ba2ea$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    // window.location.href not being defined is an edge case in the browser but we need to handle it.
    // Potentially dangerous situations where it may not be defined: Browser Extensions, Web Workers, patching of the location obj
    const href = (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).location && (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).location.href;
    if (!href) {
        // If there is no window.location.origin, we default to only attaching tracing headers to relative requests, i.e. ones that start with `/`
        // BIG DISCLAIMER: Users can call URLs with a double slash (fetch("//example.com/api")), this is a shorthand for "send to the same protocol",
        // so we need a to exclude those requests, because they might be cross origin.
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $b846d2d7ea7b5879$export$a7a5ec66062ea5d)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        // URL parsing may fail, we default to not attaching trace headers in that case.
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch (e) {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $b846d2d7ea7b5879$export$a7a5ec66062ea5d)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $b846d2d7ea7b5879$export$a7a5ec66062ea5d)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ function $1c43b95d469ba2ea$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $3bd585063dd5b110$export$55b6bb1e45c6cf59];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = (0, $e47ffb9996454191$export$5008da00b1b6dee6)() && shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $18260bff12274275$export$2ad6630ec8164254)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const fullUrl = $1c43b95d469ba2ea$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $4584eb8e6be08f57$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const hasParent = !!(0, $e228aefa610f8d34$export$1be426a8e585c83e)();
    const span = shouldCreateSpanResult && hasParent ? (0, $ebc272b9d11b45c8$export$63dbba021a6b4047)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        attributes: {
            type: 'xhr',
            'http.method': sentryXhrData.method,
            'http.url': fullUrl,
            url: sentryXhrData.url,
            'server.address': host,
            [(0, $01d0eacec09c488a$export$cca8dd30f57f805e)]: 'auto.http.browser',
            [(0, $01d0eacec09c488a$export$1a413bd9a88fdb09)]: 'http.client'
        }
    }) : new (0, $0ca84427e90c496c$export$d6636b700b76c516)();
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    if (shouldAttachHeaders(sentryXhrData.url)) $1c43b95d469ba2ea$var$addTracingHeadersToXhrRequest(xhr, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $e47ffb9996454191$export$5008da00b1b6dee6)() && hasParent ? span : undefined);
    return span;
}
function $1c43b95d469ba2ea$var$addTracingHeadersToXhrRequest(xhr, span) {
    const { 'sentry-trace': sentryTrace, baggage: baggage } = (0, $faa6fcafcd34e0e3$export$dec8f001b9d982cb)({
        span: span
    });
    if (sentryTrace) $1c43b95d469ba2ea$var$setHeaderOnXhr(xhr, sentryTrace, baggage);
}
function $1c43b95d469ba2ea$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader('baggage', sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $1c43b95d469ba2ea$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e2) {
        return undefined;
    }
}


/* eslint-disable max-lines */ const $d29ddf1f6e0b4962$export$bbd2089f30bd3708 = 'BrowserTracing';
const $d29ddf1f6e0b4962$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $ed2f6a1d79b708c2$export$809a2b7987fd5306),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    _experiments: {},
    ...(0, $1c43b95d469ba2ea$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $d29ddf1f6e0b4962$export$b4109253475213e9 = (_options = {})=>{
    (0, $b43014688c4eb3d5$export$b0914730ee1f6c80)();
    const { enableInp: enableInp, enableLongTask: enableLongTask, enableLongAnimationFrame: enableLongAnimationFrame, _experiments: { enableInteractions: enableInteractions, enableStandaloneClsSpans: enableStandaloneClsSpans }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation } = {
        ...$d29ddf1f6e0b4962$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $bbb24181a71b72fc$export$7c69f0412d101b88)({
        recordClsStandaloneSpans: enableStandaloneClsSpans || false
    });
    if (enableInp) (0, $6a555e1ddc84297e$export$f17d06681a4744a3)();
    if (enableLongAnimationFrame && (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1).PerformanceObserver && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('long-animation-frame')) (0, $bbb24181a71b72fc$export$5b823ab2ccbc801d)();
    else if (enableLongTask) (0, $bbb24181a71b72fc$export$f396d19077034ad2)();
    if (enableInteractions) (0, $bbb24181a71b72fc$export$e27543e0976315e4)();
    const latestRoute = {
        name: undefined,
        source: undefined
    };
    /** Create routing idle transaction. */ function _createRouteSpan(client, startSpanOptions) {
        const isPageloadTransaction = startSpanOptions.op === 'pageload';
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const attributes = finalStartSpanOptions.attributes || {};
        // If `finalStartSpanOptions.name` is different than `startSpanOptions.name`
        // it is because `beforeStartSpan` set a custom name. Therefore we set the source to 'custom'.
        if (startSpanOptions.name !== finalStartSpanOptions.name) {
            attributes[0, $01d0eacec09c488a$export$d7a7d984b0791405] = 'custom';
            finalStartSpanOptions.attributes = attributes;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $01d0eacec09c488a$export$d7a7d984b0791405];
        const idleSpan = (0, $ed2f6a1d79b708c2$export$901bffd97bd52797)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadTransaction,
            beforeSpanEnd: (span)=>{
                _collectWebVitals();
                (0, $bbb24181a71b72fc$export$5f8fa6b3467a7443)(span, {
                    recordClsOnPageloadSpan: !enableStandaloneClsSpans
                });
            }
        });
        function emitFinish() {
            if ([
                'interactive',
                'complete'
            ].includes((0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).document.readyState)) client.emit('idleSpanEnableAutoFinish', idleSpan);
        }
        if (isPageloadTransaction && (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).document) {
            (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).document.addEventListener('readystatechange', ()=>{
                emitFinish();
            });
            emitFinish();
        }
        return idleSpan;
    }
    return {
        name: $d29ddf1f6e0b4962$export$bbd2089f30bd3708,
        afterAllSetup (client) {
            let activeSpan;
            let startingUrl = (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).location && (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).location.href;
            function maybeEndActiveSpan() {
                if (activeSpan && !(0, $e228aefa610f8d34$export$92d8c23565496537)(activeSpan).timestamp) {
                    (0, $aea8a197a12f0967$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).log(`[Tracing] Finishing current active span with op: ${(0, $e228aefa610f8d34$export$92d8c23565496537)(activeSpan).op}`);
                    // If there's an open active span, we need to finish it before creating an new one.
                    activeSpan.end();
                }
            }
            client.on('startNavigationSpan', (startSpanOptions)=>{
                if ((0, $a383148e3fcc828a$export$6bb76d6eba7e258c)() !== client) return;
                maybeEndActiveSpan();
                activeSpan = _createRouteSpan(client, {
                    op: 'navigation',
                    ...startSpanOptions
                });
            });
            client.on('startPageLoadSpan', (startSpanOptions, traceOptions = {})=>{
                if ((0, $a383148e3fcc828a$export$6bb76d6eba7e258c)() !== client) return;
                maybeEndActiveSpan();
                const sentryTrace = traceOptions.sentryTrace || $d29ddf1f6e0b4962$export$f147b32b03c9cf11('sentry-trace');
                const baggage = traceOptions.baggage || $d29ddf1f6e0b4962$export$f147b32b03c9cf11('baggage');
                const propagationContext = (0, $9be700175edbb9b7$export$261f383d16a93e39)(sentryTrace, baggage);
                (0, $a383148e3fcc828a$export$c7be4b0125a10cba)().setPropagationContext(propagationContext);
                activeSpan = _createRouteSpan(client, {
                    op: 'pageload',
                    ...startSpanOptions
                });
            });
            // A trace should to stay the consistent over the entire time span of one route.
            // Therefore, when the initial pageload or navigation root span ends, we update the
            // scope's propagation context to keep span-specific attributes like the `sampled` decision and
            // the dynamic sampling context valid, even after the root span has ended.
            // This ensures that the trace data is consistent for the entire duration of the route.
            client.on('spanEnd', (span)=>{
                const op = (0, $e228aefa610f8d34$export$92d8c23565496537)(span).op;
                if (span !== (0, $e228aefa610f8d34$export$c4c6a79b1260ca1b)(span) || op !== 'navigation' && op !== 'pageload') return;
                const scope = (0, $a383148e3fcc828a$export$c7be4b0125a10cba)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext({
                    ...oldPropagationContext,
                    sampled: oldPropagationContext.sampled !== undefined ? oldPropagationContext.sampled : (0, $e228aefa610f8d34$export$5caecac1caaf3a71)(span),
                    dsc: oldPropagationContext.dsc || (0, $1dfeb99fdc06c052$export$a117f995597e25df)(span)
                });
            });
            if ((0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).location) {
                if (instrumentPageLoad) $d29ddf1f6e0b4962$export$aa44a07f82af519f(client, {
                    name: (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTime: (0, $958146d03402aa5e$export$baf075a948ffc0bf) ? (0, $958146d03402aa5e$export$baf075a948ffc0bf) / 1000 : undefined,
                    attributes: {
                        [(0, $01d0eacec09c488a$export$d7a7d984b0791405)]: 'url',
                        [(0, $01d0eacec09c488a$export$cca8dd30f57f805e)]: 'auto.pageload.browser'
                    }
                });
                if (instrumentNavigation) (0, $66c7820cfb83137d$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                    /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                        startingUrl = undefined;
                        return;
                    }
                    if (from !== to) {
                        startingUrl = undefined;
                        $d29ddf1f6e0b4962$export$7d159749bd9969ad(client, {
                            name: (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).location.pathname,
                            attributes: {
                                [(0, $01d0eacec09c488a$export$d7a7d984b0791405)]: 'url',
                                [(0, $01d0eacec09c488a$export$cca8dd30f57f805e)]: 'auto.navigation.browser'
                            }
                        });
                    }
                });
            }
            if (markBackgroundSpan) (0, $23e2024822c9b1ec$export$6f18f55521af71a1)();
            if (enableInteractions) $d29ddf1f6e0b4962$var$registerInteractionListener(idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            if (enableInp) (0, $6a555e1ddc84297e$export$e4e04d43e223cce2)();
            (0, $1c43b95d469ba2ea$export$864489cb3478db3e)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                trackFetchStreamPerformance: trackFetchStreamPerformance,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        }
    };
};
/**
 * Manually start a page load span.
 * This will only do something if a browser tracing integration integration has been setup.
 *
 * If you provide a custom `traceOptions` object, it will be used to continue the trace
 * instead of the default behavior, which is to look it up on the <meta> tags.
 */ function $d29ddf1f6e0b4962$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit('startPageLoadSpan', spanOptions, traceOptions);
    (0, $a383148e3fcc828a$export$c7be4b0125a10cba)().setTransactionName(spanOptions.name);
    const span = (0, $e228aefa610f8d34$export$1be426a8e585c83e)();
    const op = span && (0, $e228aefa610f8d34$export$92d8c23565496537)(span).op;
    return op === 'pageload' ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if a browser tracing integration has been setup.
 */ function $d29ddf1f6e0b4962$export$7d159749bd9969ad(client, spanOptions) {
    (0, $a383148e3fcc828a$export$68f3af03034c9e90)().setPropagationContext({
        traceId: (0, $3135b6e87c14d175$export$dc6d7ea554bcce10)()
    });
    (0, $a383148e3fcc828a$export$c7be4b0125a10cba)().setPropagationContext({
        traceId: (0, $3135b6e87c14d175$export$dc6d7ea554bcce10)()
    });
    client.emit('startNavigationSpan', spanOptions);
    (0, $a383148e3fcc828a$export$c7be4b0125a10cba)().setTransactionName(spanOptions.name);
    const span = (0, $e228aefa610f8d34$export$1be426a8e585c83e)();
    const op = span && (0, $e228aefa610f8d34$export$92d8c23565496537)(span).op;
    return op === 'navigation' ? span : undefined;
}
/** Returns the value of a meta tag */ function $d29ddf1f6e0b4962$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    // eslint-disable-next-line deprecation/deprecation
    const metaTag = (0, $efa6e113a375d8ac$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute('content') : undefined;
}
/** Start listener for interaction transactions */ function $d29ddf1f6e0b4962$var$registerInteractionListener(idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = 'ui.action.click';
        const activeSpan = (0, $e228aefa610f8d34$export$1be426a8e585c83e)();
        const rootSpan = activeSpan && (0, $e228aefa610f8d34$export$c4c6a79b1260ca1b)(activeSpan);
        if (rootSpan) {
            const currentRootSpanOp = (0, $e228aefa610f8d34$export$92d8c23565496537)(rootSpan).op;
            if ([
                'navigation',
                'pageload'
            ].includes(currentRootSpanOp)) {
                (0, $aea8a197a12f0967$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return undefined;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $01d0eacec09c488a$export$ba73f34502b7a3b3), 'interactionInterrupted');
            inflightInteractionSpan.end();
            inflightInteractionSpan = undefined;
        }
        if (!latestRoute.name) {
            (0, $aea8a197a12f0967$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        inflightInteractionSpan = (0, $ed2f6a1d79b708c2$export$901bffd97bd52797)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $01d0eacec09c488a$export$d7a7d984b0791405)]: latestRoute.source || 'url'
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if ((0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).document) addEventListener('click', registerInteractionTransaction, {
        once: false,
        capture: true
    });
}




var $2xPiy = parcelRequire("2xPiy");

var $liOrM = parcelRequire("liOrM");

/* eslint-disable max-lines */ // Inspired from Donnie McNeal's solution:
// https://gist.github.com/wontondon/e8c4bdf2888875e4c755712e99279536
let $a974386c0397afb6$var$_useEffect;
let $a974386c0397afb6$var$_useLocation;
let $a974386c0397afb6$var$_useNavigationType;
let $a974386c0397afb6$var$_createRoutesFromChildren;
let $a974386c0397afb6$var$_matchRoutes;
let $a974386c0397afb6$var$_stripBasename = false;
const $a974386c0397afb6$var$CLIENTS_WITH_INSTRUMENT_NAVIGATION = new WeakSet();
// Keeping as a global variable for cross-usage in multiple functions
const $a974386c0397afb6$var$allRoutes = new Set();
/**
 * Creates a wrapCreateBrowserRouter function that can be used with all React Router v6 compatible versions.
 */ function $a974386c0397afb6$export$6f08ca2914060d3f(createRouterFunction, version) {
    if (!$a974386c0397afb6$var$_useEffect || !$a974386c0397afb6$var$_useLocation || !$a974386c0397afb6$var$_useNavigationType || !$a974386c0397afb6$var$_matchRoutes) {
        (0, $9552556577956458$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn(`reactRouterV${version}Instrumentation was unable to wrap the \`createRouter\` function because of one or more missing parameters.`);
        return createRouterFunction;
    }
    return function(routes, opts) {
        routes.forEach((route)=>{
            $a974386c0397afb6$var$allRoutes.add(route);
        });
        const router = createRouterFunction(routes, opts);
        const basename = opts && opts.basename;
        const activeRootSpan = $a974386c0397afb6$var$getActiveRootSpan();
        // The initial load ends when `createBrowserRouter` is called.
        // This is the earliest convenient time to update the transaction name.
        // Callbacks to `router.subscribe` are not called for the initial load.
        if (router.state.historyAction === 'POP' && activeRootSpan) $a974386c0397afb6$var$updatePageloadTransaction(activeRootSpan, router.state.location, routes, undefined, basename, Array.from($a974386c0397afb6$var$allRoutes));
        router.subscribe((state)=>{
            if (state.historyAction === 'PUSH' || state.historyAction === 'POP') {
                // Wait for the next render if loading an unsettled route
                if (state.navigation.state !== 'idle') requestAnimationFrame(()=>{
                    $a974386c0397afb6$export$706ad1af8096e280({
                        location: state.location,
                        routes: routes,
                        navigationType: state.historyAction,
                        version: version,
                        basename: basename,
                        allRoutes: Array.from($a974386c0397afb6$var$allRoutes)
                    });
                });
                else $a974386c0397afb6$export$706ad1af8096e280({
                    location: state.location,
                    routes: routes,
                    navigationType: state.historyAction,
                    version: version,
                    basename: basename,
                    allRoutes: Array.from($a974386c0397afb6$var$allRoutes)
                });
            }
        });
        return router;
    };
}
/**
 * Creates a wrapCreateMemoryRouter function that can be used with all React Router v6 compatible versions.
 */ function $a974386c0397afb6$export$ce6d63af7f6f9771(createRouterFunction, version) {
    if (!$a974386c0397afb6$var$_useEffect || !$a974386c0397afb6$var$_useLocation || !$a974386c0397afb6$var$_useNavigationType || !$a974386c0397afb6$var$_matchRoutes) {
        (0, $9552556577956458$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn(`reactRouterV${version}Instrumentation was unable to wrap the \`createMemoryRouter\` function because of one or more missing parameters.`);
        return createRouterFunction;
    }
    return function(routes, opts) {
        routes.forEach((route)=>{
            $a974386c0397afb6$var$allRoutes.add(route);
        });
        const router = createRouterFunction(routes, opts);
        const basename = opts ? opts.basename : undefined;
        const activeRootSpan = $a974386c0397afb6$var$getActiveRootSpan();
        let initialEntry = undefined;
        const initialEntries = opts ? opts.initialEntries : undefined;
        const initialIndex = opts ? opts.initialIndex : undefined;
        const hasOnlyOneInitialEntry = initialEntries && initialEntries.length === 1;
        const hasIndexedEntry = initialIndex !== undefined && initialEntries && initialEntries[initialIndex];
        initialEntry = hasOnlyOneInitialEntry ? initialEntries[0] : hasIndexedEntry ? initialEntries[initialIndex] : undefined;
        const location = initialEntry ? typeof initialEntry === 'string' ? {
            pathname: initialEntry
        } : initialEntry : router.state.location;
        if (router.state.historyAction === 'POP' && activeRootSpan) $a974386c0397afb6$var$updatePageloadTransaction(activeRootSpan, location, routes, undefined, basename, Array.from($a974386c0397afb6$var$allRoutes));
        router.subscribe((state)=>{
            const location = state.location;
            if (state.historyAction === 'PUSH' || state.historyAction === 'POP') $a974386c0397afb6$export$706ad1af8096e280({
                location: location,
                routes: routes,
                navigationType: state.historyAction,
                version: version,
                basename: basename,
                allRoutes: Array.from($a974386c0397afb6$var$allRoutes)
            });
        });
        return router;
    };
}
/**
 * Creates a browser tracing integration that can be used with all React Router v6 compatible versions.
 */ function $a974386c0397afb6$export$7e5bbc7e32f3c098(options, version) {
    const integration = (0, $d29ddf1f6e0b4962$export$b4109253475213e9)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { useEffect: useEffect, useLocation: useLocation, useNavigationType: useNavigationType, createRoutesFromChildren: createRoutesFromChildren, matchRoutes: matchRoutes, stripBasename: stripBasename, instrumentPageLoad: instrumentPageLoad = true, instrumentNavigation: instrumentNavigation = true } = options;
    return {
        ...integration,
        setup () {
            $a974386c0397afb6$var$_useEffect = useEffect;
            $a974386c0397afb6$var$_useLocation = useLocation;
            $a974386c0397afb6$var$_useNavigationType = useNavigationType;
            $a974386c0397afb6$var$_matchRoutes = matchRoutes;
            $a974386c0397afb6$var$_createRoutesFromChildren = createRoutesFromChildren;
            $a974386c0397afb6$var$_stripBasename = stripBasename || false;
        },
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            const initPathName = (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81) && (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).location && (0, $df1f7a182305cd2c$export$56d8a8a25bd48b81).location.pathname;
            if (instrumentPageLoad && initPathName) (0, $d29ddf1f6e0b4962$export$aa44a07f82af519f)(client, {
                name: initPathName,
                attributes: {
                    [(0, $01d0eacec09c488a$export$d7a7d984b0791405)]: 'url',
                    [(0, $01d0eacec09c488a$export$1a413bd9a88fdb09)]: 'pageload',
                    [(0, $01d0eacec09c488a$export$cca8dd30f57f805e)]: `auto.pageload.react.reactrouter_v${version}`
                }
            });
            if (instrumentNavigation) $a974386c0397afb6$var$CLIENTS_WITH_INSTRUMENT_NAVIGATION.add(client);
        }
    };
}
function $a974386c0397afb6$export$3881404ad6870e59(origUseRoutes, version) {
    if (!$a974386c0397afb6$var$_useEffect || !$a974386c0397afb6$var$_useLocation || !$a974386c0397afb6$var$_useNavigationType || !$a974386c0397afb6$var$_matchRoutes) {
        (0, $9552556577956458$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn('reactRouterV6Instrumentation was unable to wrap `useRoutes` because of one or more missing parameters.');
        return origUseRoutes;
    }
    const SentryRoutes = (props)=>{
        const isMountRenderPass = $2xPiy.useRef(true);
        const { routes: routes, locationArg: locationArg } = props;
        const Routes = origUseRoutes(routes, locationArg);
        const location = $a974386c0397afb6$var$_useLocation();
        const navigationType = $a974386c0397afb6$var$_useNavigationType();
        // A value with stable identity to either pick `locationArg` if available or `location` if not
        const stableLocationParam = typeof locationArg === 'string' || locationArg && locationArg.pathname ? locationArg : location;
        $a974386c0397afb6$var$_useEffect(()=>{
            const normalizedLocation = typeof stableLocationParam === 'string' ? {
                pathname: stableLocationParam
            } : stableLocationParam;
            if (isMountRenderPass.current) {
                routes.forEach((route)=>{
                    const extractedChildRoutes = $a974386c0397afb6$var$getChildRoutesRecursively(route);
                    extractedChildRoutes.forEach((r)=>{
                        $a974386c0397afb6$var$allRoutes.add(r);
                    });
                });
                $a974386c0397afb6$var$updatePageloadTransaction($a974386c0397afb6$var$getActiveRootSpan(), normalizedLocation, routes, undefined, undefined, Array.from($a974386c0397afb6$var$allRoutes));
                isMountRenderPass.current = false;
            } else $a974386c0397afb6$export$706ad1af8096e280({
                location: normalizedLocation,
                routes: routes,
                navigationType: navigationType,
                version: version,
                allRoutes: Array.from($a974386c0397afb6$var$allRoutes)
            });
        }, [
            navigationType,
            stableLocationParam
        ]);
        return Routes;
    };
    // eslint-disable-next-line react/display-name
    return (routes, locationArg)=>{
        return $2xPiy.createElement(SentryRoutes, {
            routes: routes,
            locationArg: locationArg
        });
    };
}
function $a974386c0397afb6$export$706ad1af8096e280(opts) {
    const { location: location, routes: routes, navigationType: navigationType, version: version, matches: matches, basename: basename, allRoutes: allRoutes } = opts;
    const branches = Array.isArray(matches) ? matches : $a974386c0397afb6$var$_matchRoutes(routes, location, basename);
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    if (!client || !$a974386c0397afb6$var$CLIENTS_WITH_INSTRUMENT_NAVIGATION.has(client)) return;
    if ((navigationType === 'PUSH' || navigationType === 'POP') && branches) {
        let name, source = 'url';
        const isInDescendantRoute = $a974386c0397afb6$var$locationIsInsideDescendantRoute(location, allRoutes || routes);
        if (isInDescendantRoute) {
            name = $a974386c0397afb6$var$prefixWithSlash($a974386c0397afb6$var$rebuildRoutePathFromAllRoutes(allRoutes || routes, location));
            source = 'route';
        }
        if (!isInDescendantRoute || !name) [name, source] = $a974386c0397afb6$var$getNormalizedName(routes, location, branches, basename);
        (0, $d29ddf1f6e0b4962$export$7d159749bd9969ad)(client, {
            name: name,
            attributes: {
                [(0, $01d0eacec09c488a$export$d7a7d984b0791405)]: source,
                [(0, $01d0eacec09c488a$export$1a413bd9a88fdb09)]: 'navigation',
                [(0, $01d0eacec09c488a$export$cca8dd30f57f805e)]: `auto.navigation.react.reactrouter_v${version}`
            }
        });
    }
}
/**
 * Strip the basename from a pathname if exists.
 *
 * Vendored and modified from `react-router`
 * https://github.com/remix-run/react-router/blob/462bb712156a3f739d6139a0f14810b76b002df6/packages/router/utils.ts#L1038
 */ function $a974386c0397afb6$var$stripBasenameFromPathname(pathname, basename) {
    if (!basename || basename === '/') return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return pathname;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    const startIndex = basename.endsWith('/') ? basename.length - 1 : basename.length;
    const nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== '/') // pathname does not start with basename/
    return pathname;
    return pathname.slice(startIndex) || '/';
}
function $a974386c0397afb6$var$sendIndexPath(pathBuilder, pathname, basename) {
    const reconstructedPath = pathBuilder || $a974386c0397afb6$var$_stripBasename ? $a974386c0397afb6$var$stripBasenameFromPathname(pathname, basename) : pathname;
    const formattedPath = // If the path ends with a slash, remove it
    reconstructedPath[reconstructedPath.length - 1] === '/' ? reconstructedPath.slice(0, -1) : reconstructedPath.slice(-2) === '/*' ? reconstructedPath.slice(0, -1) : reconstructedPath;
    return [
        formattedPath,
        'route'
    ];
}
function $a974386c0397afb6$var$pathEndsWithWildcard(path) {
    return path.endsWith('*');
}
function $a974386c0397afb6$var$pathIsWildcardAndHasChildren(path, branch) {
    return $a974386c0397afb6$var$pathEndsWithWildcard(path) && branch.route.children && branch.route.children.length > 0 || false;
}
function $a974386c0397afb6$var$routeIsDescendant(route) {
    return !!(!route.children && route.element && route.path && route.path.endsWith('/*'));
}
function $a974386c0397afb6$var$locationIsInsideDescendantRoute(location, routes) {
    const matchedRoutes = $a974386c0397afb6$var$_matchRoutes(routes, location);
    if (matchedRoutes) for (const match of matchedRoutes){
        if ($a974386c0397afb6$var$routeIsDescendant(match.route) && $a974386c0397afb6$var$pickSplat(match)) return true;
    }
    return false;
}
function $a974386c0397afb6$var$getChildRoutesRecursively(route, allRoutes = new Set()) {
    if (!allRoutes.has(route)) {
        allRoutes.add(route);
        if (route.children && !route.index) route.children.forEach((child)=>{
            const childRoutes = $a974386c0397afb6$var$getChildRoutesRecursively(child, allRoutes);
            childRoutes.forEach((r)=>allRoutes.add(r));
        });
    }
    return allRoutes;
}
function $a974386c0397afb6$var$pickPath(match) {
    return $a974386c0397afb6$var$trimWildcard(match.route.path || '');
}
function $a974386c0397afb6$var$pickSplat(match) {
    return match.params['*'] || '';
}
function $a974386c0397afb6$var$trimWildcard(path) {
    return path[path.length - 1] === '*' ? path.slice(0, -1) : path;
}
function $a974386c0397afb6$var$trimSlash(path) {
    return path[path.length - 1] === '/' ? path.slice(0, -1) : path;
}
function $a974386c0397afb6$var$prefixWithSlash(path) {
    return path[0] === '/' ? path : `/${path}`;
}
function $a974386c0397afb6$var$rebuildRoutePathFromAllRoutes(allRoutes, location) {
    const matchedRoutes = $a974386c0397afb6$var$_matchRoutes(allRoutes, location);
    if (!matchedRoutes || matchedRoutes.length === 0) return '';
    for (const match of matchedRoutes)if (match.route.path && match.route.path !== '*') {
        const path = $a974386c0397afb6$var$pickPath(match);
        const strippedPath = $a974386c0397afb6$var$stripBasenameFromPathname(location.pathname, $a974386c0397afb6$var$prefixWithSlash(match.pathnameBase));
        return $a974386c0397afb6$var$trimSlash($a974386c0397afb6$var$trimSlash(path || '') + $a974386c0397afb6$var$prefixWithSlash($a974386c0397afb6$var$rebuildRoutePathFromAllRoutes(allRoutes.filter((route)=>route !== match.route), {
            pathname: strippedPath
        })));
    }
    return '';
}
function $a974386c0397afb6$var$getNormalizedName(routes, location, branches, basename = '') {
    if (!routes || routes.length === 0) return [
        $a974386c0397afb6$var$_stripBasename ? $a974386c0397afb6$var$stripBasenameFromPathname(location.pathname, basename) : location.pathname,
        'url'
    ];
    let pathBuilder = '';
    if (branches) for (const branch of branches){
        const route = branch.route;
        if (route) {
            // Early return if index route
            if (route.index) return $a974386c0397afb6$var$sendIndexPath(pathBuilder, branch.pathname, basename);
            const path = route.path;
            // If path is not a wildcard and has no child routes, append the path
            if (path && !$a974386c0397afb6$var$pathIsWildcardAndHasChildren(path, branch)) {
                const newPath = path[0] === '/' || pathBuilder[pathBuilder.length - 1] === '/' ? path : `/${path}`;
                pathBuilder = $a974386c0397afb6$var$trimSlash(pathBuilder) + $a974386c0397afb6$var$prefixWithSlash(newPath);
                // If the path matches the current location, return the path
                if ($a974386c0397afb6$var$trimSlash(location.pathname) === $a974386c0397afb6$var$trimSlash(basename + branch.pathname)) {
                    if (// If the route defined on the element is something like
                    // <Route path="/stores/:storeId/products/:productId" element={<div>Product</div>} />
                    // We should check against the branch.pathname for the number of / separators
                    // TODO(v9): Put the implementation of `getNumberOfUrlSegments` in this file
                    // eslint-disable-next-line deprecation/deprecation
                    (0, $4584eb8e6be08f57$export$69dd85280a8d374c)(pathBuilder) !== (0, $4584eb8e6be08f57$export$69dd85280a8d374c)(branch.pathname) && // We should not count wildcard operators in the url segments calculation
                    !$a974386c0397afb6$var$pathEndsWithWildcard(pathBuilder)) return [
                        ($a974386c0397afb6$var$_stripBasename ? '' : basename) + newPath,
                        'route'
                    ];
                    // if the last character of the pathbuilder is a wildcard and there are children, remove the wildcard
                    if ($a974386c0397afb6$var$pathIsWildcardAndHasChildren(pathBuilder, branch)) pathBuilder = pathBuilder.slice(0, -1);
                    return [
                        ($a974386c0397afb6$var$_stripBasename ? '' : basename) + pathBuilder,
                        'route'
                    ];
                }
            }
        }
    }
    const fallbackTransactionName = $a974386c0397afb6$var$_stripBasename ? $a974386c0397afb6$var$stripBasenameFromPathname(location.pathname, basename) : location.pathname || '/';
    return [
        fallbackTransactionName,
        'url'
    ];
}
function $a974386c0397afb6$var$updatePageloadTransaction(activeRootSpan, location, routes, matches, basename, allRoutes) {
    const branches = Array.isArray(matches) ? matches : $a974386c0397afb6$var$_matchRoutes(allRoutes || routes, location, basename);
    if (branches) {
        let name, source = 'url';
        const isInDescendantRoute = $a974386c0397afb6$var$locationIsInsideDescendantRoute(location, allRoutes || routes);
        if (isInDescendantRoute) {
            name = $a974386c0397afb6$var$prefixWithSlash($a974386c0397afb6$var$rebuildRoutePathFromAllRoutes(allRoutes || routes, location));
            source = 'route';
        }
        if (!isInDescendantRoute || !name) [name, source] = $a974386c0397afb6$var$getNormalizedName(routes, location, branches, basename);
        (0, $a383148e3fcc828a$export$c7be4b0125a10cba)().setTransactionName(name || '/');
        if (activeRootSpan) {
            activeRootSpan.updateName(name);
            activeRootSpan.setAttribute((0, $01d0eacec09c488a$export$d7a7d984b0791405), source);
        }
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a974386c0397afb6$export$b90e0c8f3b3b5df0(Routes, version) {
    if (!$a974386c0397afb6$var$_useEffect || !$a974386c0397afb6$var$_useLocation || !$a974386c0397afb6$var$_useNavigationType || !$a974386c0397afb6$var$_createRoutesFromChildren || !$a974386c0397afb6$var$_matchRoutes) {
        (0, $9552556577956458$export$16a28057038b10ef) && (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).warn(`reactRouterV6Instrumentation was unable to wrap Routes because of one or more missing parameters.
      useEffect: ${$a974386c0397afb6$var$_useEffect}. useLocation: ${$a974386c0397afb6$var$_useLocation}. useNavigationType: ${$a974386c0397afb6$var$_useNavigationType}.
      createRoutesFromChildren: ${$a974386c0397afb6$var$_createRoutesFromChildren}. matchRoutes: ${$a974386c0397afb6$var$_matchRoutes}.`);
        return Routes;
    }
    const SentryRoutes = (props)=>{
        const isMountRenderPass = $2xPiy.useRef(true);
        const location = $a974386c0397afb6$var$_useLocation();
        const navigationType = $a974386c0397afb6$var$_useNavigationType();
        $a974386c0397afb6$var$_useEffect(()=>{
            const routes = $a974386c0397afb6$var$_createRoutesFromChildren(props.children);
            if (isMountRenderPass.current) {
                routes.forEach((route)=>{
                    const extractedChildRoutes = $a974386c0397afb6$var$getChildRoutesRecursively(route);
                    extractedChildRoutes.forEach((r)=>{
                        $a974386c0397afb6$var$allRoutes.add(r);
                    });
                });
                $a974386c0397afb6$var$updatePageloadTransaction($a974386c0397afb6$var$getActiveRootSpan(), location, routes, undefined, undefined, Array.from($a974386c0397afb6$var$allRoutes));
                isMountRenderPass.current = false;
            } else $a974386c0397afb6$export$706ad1af8096e280({
                location: location,
                routes: routes,
                navigationType: navigationType,
                version: version,
                allRoutes: Array.from($a974386c0397afb6$var$allRoutes)
            });
        }, // `props.children` is purposely not included in the dependency array, because we do not want to re-run this effect
        // when the children change. We only want to start transactions when the location or navigation type change.
        [
            location,
            navigationType
        ]);
        // @ts-expect-error Setting more specific React Component typing for `R` generic above
        // will break advanced type inference done by react router params
        return $2xPiy.createElement(Routes, {
            ...props
        });
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($liOrM)))(SentryRoutes, Routes);
    // @ts-expect-error Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params
    return SentryRoutes;
}
function $a974386c0397afb6$var$getActiveRootSpan() {
    const span = (0, $e228aefa610f8d34$export$1be426a8e585c83e)();
    const rootSpan = span ? (0, $e228aefa610f8d34$export$c4c6a79b1260ca1b)(span) : undefined;
    if (!rootSpan) return undefined;
    const op = (0, $e228aefa610f8d34$export$92d8c23565496537)(rootSpan).op;
    // Only use this root span if it is a pageload or navigation span
    return op === 'navigation' || op === 'pageload' ? rootSpan : undefined;
}


/**
 * A browser tracing integration that uses React Router v6 to instrument navigations.
 * Expects `useEffect`, `useLocation`, `useNavigationType`, `createRoutesFromChildren` and `matchRoutes` to be passed as options.
 */ function $931cb46b11381d85$export$47113a480541ff59(options) {
    return (0, $a974386c0397afb6$export$7e5bbc7e32f3c098)(options, '6');
}
/**
 * A wrapper function that adds Sentry routing instrumentation to a React Router v6 useRoutes hook.
 * This is used to automatically capture route changes as transactions when using the useRoutes hook.
 */ function $931cb46b11381d85$export$1ffd7287c0e61f32(origUseRoutes) {
    return (0, $a974386c0397afb6$export$3881404ad6870e59)(origUseRoutes, '6');
}
/**
 * Alias for backwards compatibility
 * @deprecated Use `wrapUseRoutesV6` or `wrapUseRoutesV7` instead.
 */ const $931cb46b11381d85$export$1f41b3e298c8040f = $931cb46b11381d85$export$1ffd7287c0e61f32;
/**
 * A wrapper function that adds Sentry routing instrumentation to a React Router v6 createBrowserRouter function.
 * This is used to automatically capture route changes as transactions when using the createBrowserRouter API.
 */ function $931cb46b11381d85$export$bd33b81dece50867(createRouterFunction) {
    return (0, $a974386c0397afb6$export$6f08ca2914060d3f)(createRouterFunction, '6');
}
/**
 * Alias for backwards compatibility
 * @deprecated Use `wrapCreateBrowserRouterV6` or `wrapCreateBrowserRouterV7` instead.
 */ const $931cb46b11381d85$export$7f4c656bd7ebbb6b = $931cb46b11381d85$export$bd33b81dece50867;
/**
 * A wrapper function that adds Sentry routing instrumentation to a React Router v6 createMemoryRouter function.
 * This is used to automatically capture route changes as transactions when using the createMemoryRouter API.
 * The difference between createBrowserRouter and createMemoryRouter is that with createMemoryRouter,
 * optional `initialEntries` are also taken into account.
 */ function $931cb46b11381d85$export$e61a765bf2bfccdc(createMemoryRouterFunction) {
    return (0, $a974386c0397afb6$export$ce6d63af7f6f9771)(createMemoryRouterFunction, '6');
}
/**
 * A higher-order component that adds Sentry routing instrumentation to a React Router v6 Route component.
 * This is used to automatically capture route changes as transactions.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $931cb46b11381d85$export$c6111e8561a02a8b(routes) {
    return (0, $a974386c0397afb6$export$b90e0c8f3b3b5df0)(routes, '6');
}

// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ function $20770badc0bcd955$export$8db64e83cc1a933c(lhs, rhsFn) {
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    return lhs != null ? lhs : rhsFn();
}

/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $bc10c19c6ecfa6c7$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}


var $3fkHd = parcelRequire("3fkHd");

/**
 * Returns true if we are in the browser.
 */ function $55b6076a1a1e5b18$export$4e09c449d6c407f7() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== 'undefined' && (!(0, $3fkHd.isNodeEnv)() || $55b6076a1a1e5b18$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $55b6076a1a1e5b18$var$isElectronNodeRenderer() {
    const process = (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1).process;
    return !!process && process.type === 'renderer';
}

/**
 * Checks whether given url points to Sentry server
 *
 * @param url url to verify
 */ function $0cb4b06d5363f64d$export$d92e61f5600202af(url, client) {
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    return $0cb4b06d5363f64d$var$checkDsn(url, dsn) || $0cb4b06d5363f64d$var$checkTunnel(url, tunnel);
}
function $0cb4b06d5363f64d$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $0cb4b06d5363f64d$var$removeTrailingSlash(url) === $0cb4b06d5363f64d$var$removeTrailingSlash(tunnel);
}
function $0cb4b06d5363f64d$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $0cb4b06d5363f64d$var$removeTrailingSlash(str) {
    return str[str.length - 1] === '/' ? str.slice(0, -1) : str;
}



// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $c466418904831ddc$var$WINDOW = (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1);
const $c466418904831ddc$var$REPLAY_SESSION_KEY = 'sentryReplaySession';
const $c466418904831ddc$var$REPLAY_EVENT_NAME = 'replay_event';
const $c466418904831ddc$var$UNABLE_TO_SEND_REPLAY = 'Unable to send Replay';
// The idle limit for a session after which recording is paused.
const $c466418904831ddc$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $c466418904831ddc$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ const $c466418904831ddc$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $c466418904831ddc$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $c466418904831ddc$var$BUFFER_CHECKOUT_TIME = 60000;
const $c466418904831ddc$var$RETRY_BASE_INTERVAL = 5000;
const $c466418904831ddc$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $c466418904831ddc$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $c466418904831ddc$var$CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const $c466418904831ddc$var$SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const $c466418904831ddc$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const $c466418904831ddc$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const $c466418904831ddc$var$MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ const $c466418904831ddc$var$MIN_REPLAY_DURATION_LIMIT = 15000;
/** The max. length of a replay. */ const $c466418904831ddc$var$MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
function $c466418904831ddc$var$_nullishCoalesce$1(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}
function $c466418904831ddc$var$_optionalChain$5(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var $c466418904831ddc$var$NodeType$3;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($c466418904831ddc$var$NodeType$3 || ($c466418904831ddc$var$NodeType$3 = {}));
function $c466418904831ddc$var$isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $c466418904831ddc$var$isShadowRoot(n) {
    const host = $c466418904831ddc$var$_optionalChain$5([
        n,
        'optionalAccess',
        (_)=>_.host
    ]);
    return Boolean($c466418904831ddc$var$_optionalChain$5([
        host,
        'optionalAccess',
        (_2)=>_2.shadowRoot
    ]) === n);
}
function $c466418904831ddc$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === '[object ShadowRoot]';
}
function $c466418904831ddc$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(' background-clip: text;') && !cssText.includes(' -webkit-background-clip: text;')) cssText = cssText.replace(/\sbackground-clip:\s*text;/g, ' -webkit-background-clip: text; background-clip: text;');
    return cssText;
}
function $c466418904831ddc$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        '@import',
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === '') statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(' ') + ';';
}
function $c466418904831ddc$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $c466418904831ddc$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $c466418904831ddc$var$stringifyRule).join('')) : null;
    } catch (error) {
        return null;
    }
}
function $c466418904831ddc$var$fixAllCssProperty(rule) {
    let styles = '';
    for(let i = 0; i < rule.style.length; i++){
        const styleDeclaration = rule.style;
        const attribute = styleDeclaration[i];
        const isImportant = styleDeclaration.getPropertyPriority(attribute);
        styles += `${attribute}:${styleDeclaration.getPropertyValue(attribute)}${isImportant ? ` !important` : ''};`;
    }
    return `${rule.selectorText} { ${styles} }`;
}
function $c466418904831ddc$var$stringifyRule(rule) {
    let importStringified;
    if ($c466418904831ddc$var$isCSSImportRule(rule)) try {
        importStringified = $c466418904831ddc$var$stringifyStylesheet(rule.styleSheet) || $c466418904831ddc$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($c466418904831ddc$var$isCSSStyleRule(rule)) {
        let cssText = rule.cssText;
        const needsSafariColonFix = rule.selectorText.includes(':');
        const needsAllFix = typeof rule.style['all'] === 'string' && rule.style['all'];
        if (needsAllFix) cssText = $c466418904831ddc$var$fixAllCssProperty(rule);
        if (needsSafariColonFix) cssText = $c466418904831ddc$var$fixSafariColons(cssText);
        if (needsSafariColonFix || needsAllFix) return cssText;
    }
    return importStringified || rule.cssText;
}
function $c466418904831ddc$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, '$1\\$2');
}
function $c466418904831ddc$var$isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function $c466418904831ddc$var$isCSSStyleRule(rule) {
    return 'selectorText' in rule;
}
class $c466418904831ddc$var$Mirror {
    constructor(){
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    getId(n) {
        if (!n) return -1;
        const id = $c466418904831ddc$var$_optionalChain$5([
            this,
            'access',
            (_3)=>_3.getMeta,
            'call',
            (_4)=>_4(n),
            'optionalAccess',
            (_5)=>_5.id
        ]);
        return $c466418904831ddc$var$_nullishCoalesce$1(id, ()=>-1);
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
}
function $c466418904831ddc$var$createMirror() {
    return new $c466418904831ddc$var$Mirror();
}
function $c466418904831ddc$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === 'OPTION') tagName = 'SELECT';
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === 'password' || tagName === 'INPUT' && !type && maskInputOptions['text']);
}
function $c466418904831ddc$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || '';
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return '*'.repeat(text.length);
}
function $c466418904831ddc$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $c466418904831ddc$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $c466418904831ddc$var$ORIGINAL_ATTRIBUTE_NAME = '__rrweb_original__';
function $c466418904831ddc$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext('2d');
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $c466418904831ddc$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$c466418904831ddc$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $c466418904831ddc$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute('data-rr-is-password') ? 'password' : type ? $c466418904831ddc$var$toLowerCase(type) : null;
}
function $c466418904831ddc$var$getInputValue(el, tagName, type) {
    if (tagName === 'INPUT' && (type === 'radio' || type === 'checkbox')) return el.getAttribute('value') || '';
    return el.value;
}
function $c466418904831ddc$var$extractFileExtension(path, baseURL) {
    let url;
    try {
        url = new URL(path, $c466418904831ddc$var$_nullishCoalesce$1(baseURL, ()=>window.location.href));
    } catch (err) {
        return null;
    }
    const regex = /\.([0-9a-z]+)(?:$)/i;
    const match = url.pathname.match(regex);
    return $c466418904831ddc$var$_nullishCoalesce$1($c466418904831ddc$var$_optionalChain$5([
        match,
        'optionalAccess',
        (_6)=>_6[1]
    ]), ()=>null);
}
const $c466418904831ddc$var$cachedImplementations$1 = {};
function $c466418904831ddc$var$getImplementation$1(name) {
    const cached = $c466418904831ddc$var$cachedImplementations$1[name];
    if (cached) return cached;
    const document1 = window.document;
    let impl = window[name];
    if (document1 && typeof document1.createElement === 'function') try {
        const sandbox = document1.createElement('iframe');
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return $c466418904831ddc$var$cachedImplementations$1[name] = impl.bind(window);
}
function $c466418904831ddc$var$setTimeout$2(...rest) {
    return $c466418904831ddc$var$getImplementation$1('setTimeout')(...rest);
}
function $c466418904831ddc$var$clearTimeout$2(...rest) {
    return $c466418904831ddc$var$getImplementation$1('clearTimeout')(...rest);
}
function $c466418904831ddc$var$getIframeContentDocument(iframe) {
    try {
        return iframe.contentDocument;
    } catch (e) {}
}
let $c466418904831ddc$var$_id = 1;
const $c466418904831ddc$var$tagNameRegex = new RegExp('[^a-z0-9-_:]');
const $c466418904831ddc$var$IGNORED_NODE = -2;
function $c466418904831ddc$var$genId() {
    return $c466418904831ddc$var$_id++;
}
function $c466418904831ddc$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return 'form';
    const processedTagName = $c466418904831ddc$var$toLowerCase(element.tagName);
    if ($c466418904831ddc$var$tagNameRegex.test(processedTagName)) return 'div';
    return processedTagName;
}
function $c466418904831ddc$var$extractOrigin(url) {
    let origin = '';
    if (url.indexOf('//') > -1) origin = url.split('/').slice(0, 3).join('/');
    else origin = url.split('/')[0];
    origin = origin.split('?')[0];
    return origin;
}
let $c466418904831ddc$var$canvasService;
let $c466418904831ddc$var$canvasCtx;
const $c466418904831ddc$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $c466418904831ddc$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $c466418904831ddc$var$URL_WWW_MATCH = /^www\..*/i;
const $c466418904831ddc$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $c466418904831ddc$var$absoluteToStylesheet(cssText, href) {
    return (cssText || '').replace($c466418904831ddc$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || '';
        if (!filePath) return origin;
        if ($c466418904831ddc$var$URL_PROTOCOL_MATCH.test(filePath) || $c466418904831ddc$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($c466418904831ddc$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === '/') return `url(${maybeQuote}${$c466418904831ddc$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split('/');
        const parts = filePath.split('/');
        stack.pop();
        for (const part of parts){
            if (part === '.') continue;
            else if (part === '..') stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join('/')}${maybeQuote})`;
    });
}
const $c466418904831ddc$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $c466418904831ddc$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $c466418904831ddc$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === '') return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return '';
    }
    const output = [];
    while(true){
        collectCharacters($c466418904831ddc$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($c466418904831ddc$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ',') {
            url = $c466418904831ddc$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = '';
            url = $c466418904831ddc$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === '') {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ',') {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === '(') inParens = true;
                } else if (c === ')') inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(', ');
}
const $c466418904831ddc$var$cachedDocument = new WeakMap();
function $c466418904831ddc$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === '') return attributeValue;
    return $c466418904831ddc$var$getHref(doc, attributeValue);
}
function $c466418904831ddc$var$isSVGElement(el) {
    return Boolean(el.tagName === 'svg' || el.ownerSVGElement);
}
function $c466418904831ddc$var$getHref(doc, customHref) {
    let a = $c466418904831ddc$var$cachedDocument.get(doc);
    if (!a) {
        a = doc.createElement('a');
        $c466418904831ddc$var$cachedDocument.set(doc, a);
    }
    if (!customHref) customHref = '';
    else if (customHref.startsWith('blob:') || customHref.startsWith('data:')) return customHref;
    a.setAttribute('href', customHref);
    return a.href;
}
function $c466418904831ddc$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
    if (!value) return value;
    if (name === 'src' || name === 'href' && !(tagName === 'use' && value[0] === '#')) return $c466418904831ddc$var$absoluteToDoc(doc, value);
    else if (name === 'xlink:href' && value[0] !== '#') return $c466418904831ddc$var$absoluteToDoc(doc, value);
    else if (name === 'background' && (tagName === 'table' || tagName === 'td' || tagName === 'th')) return $c466418904831ddc$var$absoluteToDoc(doc, value);
    else if (name === 'srcset') return $c466418904831ddc$var$getAbsoluteSrcsetString(doc, value);
    else if (name === 'style') return $c466418904831ddc$var$absoluteToStylesheet(value, $c466418904831ddc$var$getHref(doc));
    else if (tagName === 'object' && name === 'data') return $c466418904831ddc$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === 'function') return maskAttributeFn(name, value, element);
    return value;
}
function $c466418904831ddc$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === 'video' || tagName === 'audio') && name === 'autoplay';
}
function $c466418904831ddc$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === 'string') {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $c466418904831ddc$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $c466418904831ddc$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $c466418904831ddc$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $c466418904831ddc$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === 'string') {
                    if (el.matches(`.${className}`)) return true;
                } else if ($c466418904831ddc$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
function $c466418904831ddc$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === 'INPUT') {
            const autocomplete = el.getAttribute('autocomplete');
            const disallowedAutocompleteValues = [
                'current-password',
                'new-password',
                'cc-number',
                'cc-exp',
                'cc-exp-month',
                'cc-exp-year',
                'cc-csc'
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $c466418904831ddc$var$distanceToMatch(el, $c466418904831ddc$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $c466418904831ddc$var$distanceToMatch(el, $c466418904831ddc$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $c466418904831ddc$var$distanceToMatch(el, $c466418904831ddc$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $c466418904831ddc$var$distanceToMatch(el, $c466418904831ddc$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function $c466418904831ddc$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== 'complete') {
        const timer = $c466418904831ddc$var$setTimeout$2(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener('load', ()=>{
            $c466418904831ddc$var$clearTimeout$2(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = 'about:blank';
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === '') {
        $c466418904831ddc$var$setTimeout$2(listener, 0);
        return iframeEl.addEventListener('load', listener);
    }
    iframeEl.addEventListener('load', listener);
}
function $c466418904831ddc$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = $c466418904831ddc$var$setTimeout$2(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener('load', ()=>{
        $c466418904831ddc$var$clearTimeout$2(timer);
        fired = true;
        listener();
    });
}
function $c466418904831ddc$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false } = options;
    const rootId = $c466418904831ddc$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== 'CSS1Compat') return {
                type: $c466418904831ddc$var$NodeType$3.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $c466418904831ddc$var$NodeType$3.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $c466418904831ddc$var$NodeType$3.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $c466418904831ddc$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector
            });
        case n.TEXT_NODE:
            return $c466418904831ddc$var$serializeTextNode(n, {
                doc: doc,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $c466418904831ddc$var$NodeType$3.CDATA,
                textContent: '',
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $c466418904831ddc$var$NodeType$3.Comment,
                textContent: n.textContent || '',
                rootId: rootId
            };
        default:
            return false;
    }
}
function $c466418904831ddc$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return undefined;
    const docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function $c466418904831ddc$var$serializeTextNode(n, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === 'STYLE' ? true : undefined;
    const isScript = parentTagName === 'SCRIPT' ? true : undefined;
    const isTextarea = parentTagName === 'TEXTAREA' ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if ($c466418904831ddc$var$_optionalChain$5([
                n,
                'access',
                (_7)=>_7.parentNode,
                'access',
                (_8)=>_8.sheet,
                'optionalAccess',
                (_9)=>_9.cssRules
            ])) textContent = $c466418904831ddc$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $c466418904831ddc$var$absoluteToStylesheet(textContent, $c466418904831ddc$var$getHref(options.doc));
    }
    if (isScript) textContent = 'SCRIPT_PLACEHOLDER';
    const forceMask = $c466418904831ddc$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, '*');
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, '*');
    if (parentTagName === 'OPTION' && textContent) {
        const isInputMasked = $c466418904831ddc$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $c466418904831ddc$var$maskInputValue({
            isMasked: $c466418904831ddc$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $c466418904831ddc$var$NodeType$3.Text,
        textContent: textContent || '',
        isStyle: isStyle,
        rootId: rootId
    };
}
function $c466418904831ddc$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector } = options;
    const needBlock = $c466418904831ddc$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = $c466418904831ddc$var$getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (attr.name && !$c466418904831ddc$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $c466418904831ddc$var$transformAttribute(doc, tagName, $c466418904831ddc$var$toLowerCase(attr.name), attr.value, n, maskAttributeFn);
    }
    if (tagName === 'link' && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $c466418904831ddc$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            attributes.rel = null;
            attributes.href = null;
            attributes.crossorigin = null;
            attributes._cssText = $c466418904831ddc$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === 'style' && n.sheet && !(n.innerText || n.textContent || '').trim().length) {
        const cssText = $c466418904831ddc$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes._cssText = $c466418904831ddc$var$absoluteToStylesheet(cssText, $c466418904831ddc$var$getHref(doc));
    }
    if (tagName === 'input' || tagName === 'textarea' || tagName === 'select' || tagName === 'option') {
        const el = n;
        const type = $c466418904831ddc$var$getInputType(el);
        const value = $c466418904831ddc$var$getInputValue(el, $c466418904831ddc$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== 'submit' && type !== 'button' && value) {
            const forceMask = $c466418904831ddc$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $c466418904831ddc$var$shouldMaskInput({
                type: type,
                tagName: $c466418904831ddc$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes.value = $c466418904831ddc$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes.checked = checked;
    }
    if (tagName === 'option') {
        if (n.selected && !maskInputOptions['select']) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === 'canvas' && recordCanvas) {
        if (n.__context === '2d') {
            if (!$c466418904831ddc$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!('__context' in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = doc.createElement('canvas');
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === 'img' && inlineImages) {
        if (!$c466418904831ddc$var$canvasService) {
            $c466418904831ddc$var$canvasService = doc.createElement('canvas');
            $c466418904831ddc$var$canvasCtx = $c466418904831ddc$var$canvasService.getContext('2d');
        }
        const image = n;
        const imageSrc = image.currentSrc || image.getAttribute('src') || '<unknown-src>';
        const priorCrossOrigin = image.crossOrigin;
        const recordInlineImage = ()=>{
            image.removeEventListener('load', recordInlineImage);
            try {
                $c466418904831ddc$var$canvasService.width = image.naturalWidth;
                $c466418904831ddc$var$canvasService.height = image.naturalHeight;
                $c466418904831ddc$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $c466418904831ddc$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                if (image.crossOrigin !== 'anonymous') {
                    image.crossOrigin = 'anonymous';
                    if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                    else image.addEventListener('load', recordInlineImage);
                    return;
                } else console.warn(`Cannot inline img src=${imageSrc}! Error: ${err}`);
            }
            if (image.crossOrigin === 'anonymous') priorCrossOrigin ? attributes.crossOrigin = priorCrossOrigin : image.removeAttribute('crossorigin');
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener('load', recordInlineImage);
    }
    if (tagName === 'audio' || tagName === 'video') {
        attributes.rr_mediaState = n.paused ? 'paused' : 'played';
        attributes.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === 'iframe' && !keepIframeSrcFn(attributes.src)) {
        if (!needBlock && !$c466418904831ddc$var$getIframeContentDocument(n)) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $c466418904831ddc$var$NodeType$3.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $c466418904831ddc$var$isSVGElement(n) || undefined,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $c466418904831ddc$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return '';
    else return maybeAttr.toLowerCase();
}
function $c466418904831ddc$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $c466418904831ddc$var$NodeType$3.Comment) return true;
    else if (sn.type === $c466418904831ddc$var$NodeType$3.Element) {
        if (slimDOMOptions.script && (sn.tagName === 'script' || sn.tagName === 'link' && (sn.attributes.rel === 'preload' || sn.attributes.rel === 'modulepreload') || sn.tagName === 'link' && sn.attributes.rel === 'prefetch' && typeof sn.attributes.href === 'string' && $c466418904831ddc$var$extractFileExtension(sn.attributes.href) === 'js')) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === 'link' && sn.attributes.rel === 'shortcut icon' || sn.tagName === 'meta' && ($c466418904831ddc$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $c466418904831ddc$var$lowerIfExists(sn.attributes.name) === 'application-name' || $c466418904831ddc$var$lowerIfExists(sn.attributes.rel) === 'icon' || $c466418904831ddc$var$lowerIfExists(sn.attributes.rel) === 'apple-touch-icon' || $c466418904831ddc$var$lowerIfExists(sn.attributes.rel) === 'shortcut icon'))) return true;
        else if (sn.tagName === 'meta') {
            if (slimDOMOptions.headMetaDescKeywords && $c466418904831ddc$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($c466418904831ddc$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $c466418904831ddc$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $c466418904831ddc$var$lowerIfExists(sn.attributes.name) === 'pinterest')) return true;
            else if (slimDOMOptions.headMetaRobots && ($c466418904831ddc$var$lowerIfExists(sn.attributes.name) === 'robots' || $c466418904831ddc$var$lowerIfExists(sn.attributes.name) === 'googlebot' || $c466418904831ddc$var$lowerIfExists(sn.attributes.name) === 'bingbot')) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes['http-equiv'] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($c466418904831ddc$var$lowerIfExists(sn.attributes.name) === 'author' || $c466418904831ddc$var$lowerIfExists(sn.attributes.name) === 'generator' || $c466418904831ddc$var$lowerIfExists(sn.attributes.name) === 'framework' || $c466418904831ddc$var$lowerIfExists(sn.attributes.name) === 'publisher' || $c466418904831ddc$var$lowerIfExists(sn.attributes.name) === 'progid' || $c466418904831ddc$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $c466418904831ddc$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($c466418904831ddc$var$lowerIfExists(sn.attributes.name) === 'google-site-verification' || $c466418904831ddc$var$lowerIfExists(sn.attributes.name) === 'yandex-verification' || $c466418904831ddc$var$lowerIfExists(sn.attributes.name) === 'csrf-token' || $c466418904831ddc$var$lowerIfExists(sn.attributes.name) === 'p:domain_verify' || $c466418904831ddc$var$lowerIfExists(sn.attributes.name) === 'verify-v1' || $c466418904831ddc$var$lowerIfExists(sn.attributes.name) === 'verification' || $c466418904831ddc$var$lowerIfExists(sn.attributes.name) === 'shopify-checkout-api-token')) return true;
        }
    }
    return false;
}
function $c466418904831ddc$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5000, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5000, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $c466418904831ddc$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, 'not serialized');
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($c466418904831ddc$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $c466418904831ddc$var$NodeType$3.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, '').length) id = $c466418904831ddc$var$IGNORED_NODE;
    else id = $c466418904831ddc$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode);
    if (id === $c466418904831ddc$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $c466418904831ddc$var$NodeType$3.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $c466418904831ddc$var$isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $c466418904831ddc$var$NodeType$3.Document || serializedNode.type === $c466418904831ddc$var$NodeType$3.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $c466418904831ddc$var$NodeType$3.Element && serializedNode.tagName === 'head') preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $c466418904831ddc$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($c466418904831ddc$var$isElement$1(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $c466418904831ddc$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $c466418904831ddc$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $c466418904831ddc$var$isShadowRoot(n.parentNode) && $c466418904831ddc$var$isNativeShadowDom(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $c466418904831ddc$var$NodeType$3.Element && serializedNode.tagName === 'iframe') $c466418904831ddc$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = $c466418904831ddc$var$getIframeContentDocument(n);
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $c466418904831ddc$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $c466418904831ddc$var$NodeType$3.Element && serializedNode.tagName === 'link' && typeof serializedNode.attributes.rel === 'string' && (serializedNode.attributes.rel === 'stylesheet' || serializedNode.attributes.rel === 'preload' && typeof serializedNode.attributes.href === 'string' && $c466418904831ddc$var$extractFileExtension(serializedNode.attributes.href) === 'css')) $c466418904831ddc$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $c466418904831ddc$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $c466418904831ddc$var$snapshot(n, options) {
    const { mirror: mirror = new $c466418904831ddc$var$Mirror(), blockClass: blockClass = 'rr-block', blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = 'rr-mask', unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === 'all',
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $c466418904831ddc$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $c466418904831ddc$var$_optionalChain$4(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $c466418904831ddc$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $c466418904831ddc$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $c466418904831ddc$var$_mirror = {
    map: {},
    getId () {
        console.error($c466418904831ddc$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($c466418904831ddc$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($c466418904831ddc$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($c466418904831ddc$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($c466418904831ddc$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) $c466418904831ddc$var$_mirror = new Proxy($c466418904831ddc$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === 'map') console.error($c466418904831ddc$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $c466418904831ddc$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                $c466418904831ddc$var$clearTimeout$1(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = $c466418904831ddc$var$setTimeout$1(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $c466418904831ddc$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $c466418904831ddc$var$setTimeout$1(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$c466418904831ddc$var$hookSetter(target, key, original || {}, true);
}
function $c466418904831ddc$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === 'function') {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
let $c466418904831ddc$var$nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) $c466418904831ddc$var$nowTimestamp = ()=>new Date().getTime();
function $c466418904831ddc$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : $c466418904831ddc$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_)=>_.documentElement,
            'access',
            (_2)=>_2.scrollLeft
        ]) || $c466418904831ddc$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_3)=>_3.body,
            'optionalAccess',
            (_4)=>_4.parentElement,
            'optionalAccess',
            (_5)=>_5.scrollLeft
        ]) || $c466418904831ddc$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_6)=>_6.body,
            'optionalAccess',
            (_7)=>_7.scrollLeft
        ]) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : $c466418904831ddc$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_8)=>_8.documentElement,
            'access',
            (_9)=>_9.scrollTop
        ]) || $c466418904831ddc$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_10)=>_10.body,
            'optionalAccess',
            (_11)=>_11.parentElement,
            'optionalAccess',
            (_12)=>_12.scrollTop
        ]) || $c466418904831ddc$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_13)=>_13.body,
            'optionalAccess',
            (_14)=>_14.scrollTop
        ]) || 0
    };
}
function $c466418904831ddc$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $c466418904831ddc$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $c466418904831ddc$var$closestElementOfNode(node) {
    if (!node) return null;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function $c466418904831ddc$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $c466418904831ddc$var$closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = $c466418904831ddc$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $c466418904831ddc$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $c466418904831ddc$var$distanceToMatch(el, $c466418904831ddc$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $c466418904831ddc$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $c466418904831ddc$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $c466418904831ddc$var$IGNORED_NODE;
}
function $c466418904831ddc$var$isAncestorRemoved(target, mirror) {
    if ($c466418904831ddc$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $c466418904831ddc$var$isAncestorRemoved(target.parentNode, mirror);
}
function $c466418904831ddc$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $c466418904831ddc$var$polyfill(win = window) {
    if ('NodeList' in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ('DOMTokenList' in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError('1 argument is required');
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $c466418904831ddc$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === 'IFRAME' && mirror.getMeta(n));
}
function $c466418904831ddc$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === 'LINK' && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute('rel') === 'stylesheet' && mirror.getMeta(n));
}
function $c466418904831ddc$var$hasShadowRoot(n) {
    return Boolean($c466418904831ddc$var$_optionalChain$4([
        n,
        'optionalAccess',
        (_18)=>_18.shadowRoot
    ]));
}
class $c466418904831ddc$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
    getId(stylesheet) {
        return (0, $20770badc0bcd955$export$8db64e83cc1a933c)(this.styleIDMap.get(stylesheet), ()=>-1);
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === undefined) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $c466418904831ddc$var$getShadowHost(n) {
    let shadowHost = null;
    if ($c466418904831ddc$var$_optionalChain$4([
        n,
        'access',
        (_19)=>_19.getRootNode,
        'optionalCall',
        (_20)=>_20(),
        'optionalAccess',
        (_21)=>_21.nodeType
    ]) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $c466418904831ddc$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $c466418904831ddc$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $c466418904831ddc$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $c466418904831ddc$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $c466418904831ddc$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $c466418904831ddc$var$shadowHostInDom(n);
}
const $c466418904831ddc$var$cachedImplementations = {};
function $c466418904831ddc$var$getImplementation(name) {
    const cached = $c466418904831ddc$var$cachedImplementations[name];
    if (cached) return cached;
    const document1 = window.document;
    let impl = window[name];
    if (document1 && typeof document1.createElement === 'function') try {
        const sandbox = document1.createElement('iframe');
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return $c466418904831ddc$var$cachedImplementations[name] = impl.bind(window);
}
function $c466418904831ddc$var$onRequestAnimationFrame(...rest) {
    return $c466418904831ddc$var$getImplementation('requestAnimationFrame')(...rest);
}
function $c466418904831ddc$var$setTimeout$1(...rest) {
    return $c466418904831ddc$var$getImplementation('setTimeout')(...rest);
}
function $c466418904831ddc$var$clearTimeout$1(...rest) {
    return $c466418904831ddc$var$getImplementation('clearTimeout')(...rest);
}
var $c466418904831ddc$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($c466418904831ddc$var$EventType || {});
var $c466418904831ddc$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($c466418904831ddc$var$IncrementalSource || {});
var $c466418904831ddc$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($c466418904831ddc$var$MouseInteractions || {});
var $c466418904831ddc$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($c466418904831ddc$var$PointerTypes || {});
var $c466418904831ddc$var$NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($c466418904831ddc$var$NodeType$1 || ($c466418904831ddc$var$NodeType$1 = {}));
var $c466418904831ddc$var$NodeType$2;
(function(NodeType) {
    NodeType[NodeType["PLACEHOLDER"] = 0] = "PLACEHOLDER";
    NodeType[NodeType["ELEMENT_NODE"] = 1] = "ELEMENT_NODE";
    NodeType[NodeType["ATTRIBUTE_NODE"] = 2] = "ATTRIBUTE_NODE";
    NodeType[NodeType["TEXT_NODE"] = 3] = "TEXT_NODE";
    NodeType[NodeType["CDATA_SECTION_NODE"] = 4] = "CDATA_SECTION_NODE";
    NodeType[NodeType["ENTITY_REFERENCE_NODE"] = 5] = "ENTITY_REFERENCE_NODE";
    NodeType[NodeType["ENTITY_NODE"] = 6] = "ENTITY_NODE";
    NodeType[NodeType["PROCESSING_INSTRUCTION_NODE"] = 7] = "PROCESSING_INSTRUCTION_NODE";
    NodeType[NodeType["COMMENT_NODE"] = 8] = "COMMENT_NODE";
    NodeType[NodeType["DOCUMENT_NODE"] = 9] = "DOCUMENT_NODE";
    NodeType[NodeType["DOCUMENT_TYPE_NODE"] = 10] = "DOCUMENT_TYPE_NODE";
    NodeType[NodeType["DOCUMENT_FRAGMENT_NODE"] = 11] = "DOCUMENT_FRAGMENT_NODE";
})($c466418904831ddc$var$NodeType$2 || ($c466418904831ddc$var$NodeType$2 = {}));
function $c466418904831ddc$var$getIFrameContentDocument(iframe) {
    try {
        return iframe.contentDocument;
    } catch (e) {}
}
function $c466418904831ddc$var$getIFrameContentWindow(iframe) {
    try {
        return iframe.contentWindow;
    } catch (e) {}
}
function $c466418904831ddc$var$_optionalChain$3(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $c466418904831ddc$var$isNodeInLinkedList(n) {
    return '__ln' in n;
}
class $c466418904831ddc$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error('Position outside of list range');
        let current = this.head;
        for(let index = 0; index < position; index++)current = $c466418904831ddc$var$_optionalChain$3([
            current,
            'optionalAccess',
            (_)=>_.next
        ]) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $c466418904831ddc$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $c466418904831ddc$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const $c466418904831ddc$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $c466418904831ddc$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = new Set();
            const addList = new $c466418904831ddc$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $c466418904831ddc$var$IGNORED_NODE;
                while(nextId === $c466418904831ddc$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                if (!n.parentNode || !$c466418904831ddc$var$inDom(n)) return;
                const parentId = $c466418904831ddc$var$isShadowRoot(n.parentNode) ? this.mirror.getId($c466418904831ddc$var$getShadowHost(n)) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                const sn = $c466418904831ddc$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($c466418904831ddc$var$isSerializedIframe(currentN, this.mirror) && !$c466418904831ddc$var$isBlocked(currentN, this.blockClass, this.blockSelector, this.unblockSelector, false)) this.iframeManager.addIframe(currentN);
                        if ($c466418904831ddc$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($c466418904831ddc$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        if ($c466418904831ddc$var$isBlocked(iframe, this.blockClass, this.blockSelector, this.unblockSelector, false)) return;
                        this.iframeManager.attachIframe(iframe, childSn);
                        if (iframe.contentWindow) this.canvasManager.addWindow(iframe.contentWindow);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($c466418904831ddc$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$c466418904831ddc$var$isAncestorInSet(this.droppedSet, n) && !$c466418904831ddc$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($c466418904831ddc$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId = this.mirror.getId(shadowHost);
                                    if (parentId !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === 'string') {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split('var(').length === attributes.style.split('var(').length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = new WeakMap();
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($c466418904831ddc$var$isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case 'characterData':
                    {
                        const value = m.target.textContent;
                        if (!$c466418904831ddc$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $c466418904831ddc$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value, $c466418904831ddc$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, '*') : value,
                            node: m.target
                        });
                        break;
                    }
                case 'attributes':
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === 'value') {
                            const type = $c466418904831ddc$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $c466418904831ddc$var$getInputValue(target, tagName, type);
                            const isInputMasked = $c466418904831ddc$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $c466418904831ddc$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $c466418904831ddc$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($c466418904831ddc$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === 'IFRAME' && attributeName === 'src' && !this.keepIframeSrcFn(value)) {
                            const iframeDoc = $c466418904831ddc$var$getIFrameContentDocument(target);
                            if (!iframeDoc) attributeName = 'rr_src';
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === 'type' && target.tagName === 'INPUT' && (m.oldValue || '').toLowerCase() === 'password') target.setAttribute('data-rr-is-password', 'true');
                        if (!$c466418904831ddc$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $c466418904831ddc$var$transformAttribute(this.doc, $c466418904831ddc$var$toLowerCase(target.tagName), $c466418904831ddc$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === 'style') {
                                if (!this.unattachedDoc) try {
                                    this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e) {
                                    this.unattachedDoc = this.doc;
                                }
                                const old = this.unattachedDoc.createElement('span');
                                if (m.oldValue) old.setAttribute('style', m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === '') item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === '') item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case 'childList':
                    if ($c466418904831ddc$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $c466418904831ddc$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($c466418904831ddc$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $c466418904831ddc$var$isIgnored(n, this.mirror) || !$c466418904831ddc$var$isSerialized(n, this.mirror)) return;
                        if (this.addedSet.has(n)) {
                            $c466418904831ddc$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($c466418904831ddc$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$c466418904831ddc$var$moveKey(nodeId, parentId)]) $c466418904831ddc$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $c466418904831ddc$var$isShadowRoot(m.target) && $c466418904831ddc$var$isNativeShadowDom(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n, this)) return;
            if (this.addedSet.has(n) || this.movedSet.has(n)) return;
            if (this.mirror.hasNode(n)) {
                if ($c466418904831ddc$var$isIgnored(n, this.mirror)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$c466418904831ddc$var$moveKey(this.mirror.getId(n), targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$c466418904831ddc$var$isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                n.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($c466418904831ddc$var$hasShadowRoot(n)) n.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n);
                });
            }
        };
    }
    init(options) {
        [
            'mutationCb',
            'blockClass',
            'blockSelector',
            'unblockSelector',
            'maskAllText',
            'maskTextClass',
            'unmaskTextClass',
            'maskTextSelector',
            'unmaskTextSelector',
            'inlineStylesheet',
            'maskInputOptions',
            'maskAttributeFn',
            'maskTextFn',
            'maskInputFn',
            'keepIframeSrcFn',
            'recordCanvas',
            'inlineImages',
            'slimDOMOptions',
            'dataURLOptions',
            'doc',
            'mirror',
            'iframeManager',
            'stylesheetManager',
            'shadowDomManager',
            'canvasManager',
            'processedNodeManager'
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $c466418904831ddc$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$c466418904831ddc$var$deepDelete(addsSet, childN));
}
function $c466418904831ddc$var$isParentRemoved(removes, n, mirror) {
    if (removes.length === 0) return false;
    return $c466418904831ddc$var$_isParentRemoved(removes, n, mirror);
}
function $c466418904831ddc$var$_isParentRemoved(removes, n, mirror) {
    let node = n.parentNode;
    while(node){
        const parentId = mirror.getId(node);
        if (removes.some((r)=>r.id === parentId)) return true;
        node = node.parentNode;
    }
    return false;
}
function $c466418904831ddc$var$isAncestorInSet(set, n) {
    if (set.size === 0) return false;
    return $c466418904831ddc$var$_isAncestorInSet(set, n);
}
function $c466418904831ddc$var$_isAncestorInSet(set, n) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $c466418904831ddc$var$_isAncestorInSet(set, parentNode);
}
let $c466418904831ddc$var$errorHandler;
function $c466418904831ddc$var$registerErrorHandler(handler) {
    $c466418904831ddc$var$errorHandler = handler;
}
function $c466418904831ddc$var$unregisterErrorHandler() {
    $c466418904831ddc$var$errorHandler = undefined;
}
const $c466418904831ddc$var$callbackWrapper = (cb)=>{
    if (!$c466418904831ddc$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($c466418904831ddc$var$errorHandler && $c466418904831ddc$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
function $c466418904831ddc$var$_optionalChain$2(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
const $c466418904831ddc$var$mutationBuffers = [];
function $c466418904831ddc$var$getEventTarget(event) {
    try {
        if ('composedPath' in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ('path' in event && event.path.length) return event.path[0];
    } catch (e2) {}
    return event && event.target;
}
function $c466418904831ddc$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $c466418904831ddc$var$MutationBuffer();
    $c466418904831ddc$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = $c466418904831ddc$var$_optionalChain$2([
        window,
        'optionalAccess',
        (_)=>_.Zone,
        'optionalAccess',
        (_2)=>_2.__symbol__,
        'optionalCall',
        (_3)=>_3('MutationObserver')
    ]);
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($c466418904831ddc$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $c466418904831ddc$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === 'number' ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === 'number' ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $c466418904831ddc$var$throttle$1($c466418904831ddc$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $c466418904831ddc$var$callbackWrapper($c466418904831ddc$var$throttle$1($c466418904831ddc$var$callbackWrapper((evt)=>{
        const target = $c466418904831ddc$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $c466418904831ddc$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $c466418904831ddc$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: $c466418904831ddc$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== 'undefined' && evt instanceof DragEvent ? $c466418904831ddc$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $c466418904831ddc$var$IncrementalSource.MouseMove : $c466418904831ddc$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $c466418904831ddc$var$on('mousemove', updatePosition, doc),
        $c466418904831ddc$var$on('touchmove', updatePosition, doc),
        $c466418904831ddc$var$on('drag', updatePosition, doc)
    ];
    return $c466418904831ddc$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $c466418904831ddc$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $c466418904831ddc$var$getEventTarget(event);
            if ($c466418904831ddc$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ('pointerType' in event) {
                switch(event.pointerType){
                    case 'mouse':
                        pointerType = $c466418904831ddc$var$PointerTypes.Mouse;
                        break;
                    case 'touch':
                        pointerType = $c466418904831ddc$var$PointerTypes.Touch;
                        break;
                    case 'pen':
                        pointerType = $c466418904831ddc$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $c466418904831ddc$var$PointerTypes.Touch) {
                    if ($c466418904831ddc$var$MouseInteractions[eventKey] === $c466418904831ddc$var$MouseInteractions.MouseDown) thisEventKey = 'TouchStart';
                    else if ($c466418904831ddc$var$MouseInteractions[eventKey] === $c466418904831ddc$var$MouseInteractions.MouseUp) thisEventKey = 'TouchEnd';
                } else $c466418904831ddc$var$PointerTypes.Pen;
            } else if ($c466418904831ddc$var$legacy_isTouchEvent(event)) pointerType = $c466418904831ddc$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith('Touch') && pointerType === $c466418904831ddc$var$PointerTypes.Touch || thisEventKey.startsWith('Mouse') && pointerType === $c466418904831ddc$var$PointerTypes.Mouse) pointerType = null;
            } else if ($c466418904831ddc$var$MouseInteractions[eventKey] === $c466418904831ddc$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e = $c466418904831ddc$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX, clientY: clientY } = e;
            $c466418904831ddc$var$callbackWrapper(mouseInteractionCb)({
                type: $c466418904831ddc$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($c466418904831ddc$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith('_Departed') && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $c466418904831ddc$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($c466418904831ddc$var$MouseInteractions[eventKey]){
            case $c466418904831ddc$var$MouseInteractions.MouseDown:
            case $c466418904831ddc$var$MouseInteractions.MouseUp:
                eventName = eventName.replace('mouse', 'pointer');
                break;
            case $c466418904831ddc$var$MouseInteractions.TouchStart:
            case $c466418904831ddc$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($c466418904831ddc$var$on(eventName, handler, doc));
    });
    return $c466418904831ddc$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $c466418904831ddc$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $c466418904831ddc$var$callbackWrapper($c466418904831ddc$var$throttle$1($c466418904831ddc$var$callbackWrapper((evt)=>{
        const target = $c466418904831ddc$var$getEventTarget(evt);
        if (!target || $c466418904831ddc$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $c466418904831ddc$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $c466418904831ddc$var$on('scroll', updatePosition, doc);
}
function $c466418904831ddc$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $c466418904831ddc$var$callbackWrapper($c466418904831ddc$var$throttle$1($c466418904831ddc$var$callbackWrapper(()=>{
        const height = $c466418904831ddc$var$getWindowHeight();
        const width = $c466418904831ddc$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $c466418904831ddc$var$on('resize', updateDimension, win);
}
const $c466418904831ddc$var$INPUT_TAGS = [
    'INPUT',
    'TEXTAREA',
    'SELECT'
];
const $c466418904831ddc$var$lastInputValueMap = new WeakMap();
function $c466418904831ddc$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $c466418904831ddc$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $c466418904831ddc$var$toUpperCase(target.tagName);
        if (tagName === 'OPTION') target = target.parentElement;
        if (!target || !tagName || $c466418904831ddc$var$INPUT_TAGS.indexOf(tagName) < 0 || $c466418904831ddc$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $c466418904831ddc$var$getInputType(target);
        let text = $c466418904831ddc$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $c466418904831ddc$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $c466418904831ddc$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === 'radio' || type === 'checkbox') isChecked = target.checked;
        text = $c466418904831ddc$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === 'radio' && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = $c466418904831ddc$var$maskInputValue({
                    isMasked: forceMask,
                    element: el,
                    value: $c466418904831ddc$var$getInputValue(el, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $c466418904831ddc$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $c466418904831ddc$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            $c466418904831ddc$var$callbackWrapper(inputCb)({
                ...v,
                id: id
            });
        }
    }
    const events = sampling.input === 'last' ? [
        'change'
    ] : [
        'input',
        'change'
    ];
    const handlers = events.map((eventName)=>$c466418904831ddc$var$on(eventName, $c466418904831ddc$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, 'value');
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            'checked'
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            'selectedIndex'
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            'selected'
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$c466418904831ddc$var$hookSetter(p[0], p[1], {
            set () {
                $c466418904831ddc$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $c466418904831ddc$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $c466418904831ddc$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($c466418904831ddc$var$hasNestedCSSRule('CSSGroupingRule') && childRule.parentRule instanceof CSSGroupingRule || $c466418904831ddc$var$hasNestedCSSRule('CSSMediaRule') && childRule.parentRule instanceof CSSMediaRule || $c466418904831ddc$var$hasNestedCSSRule('CSSSupportsRule') && childRule.parentRule instanceof CSSSupportsRule || $c466418904831ddc$var$hasNestedCSSRule('CSSConditionRule') && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $c466418904831ddc$var$getIdAndStyleId(sheet, mirror, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $c466418904831ddc$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $c466418904831ddc$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $c466418904831ddc$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $c466418904831ddc$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $c466418904831ddc$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $c466418904831ddc$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $c466418904831ddc$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $c466418904831ddc$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $c466418904831ddc$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($c466418904831ddc$var$canMonkeyPatchNestedCSSRule('CSSGroupingRule')) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($c466418904831ddc$var$canMonkeyPatchNestedCSSRule('CSSMediaRule')) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($c466418904831ddc$var$canMonkeyPatchNestedCSSRule('CSSConditionRule')) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($c466418904831ddc$var$canMonkeyPatchNestedCSSRule('CSSSupportsRule')) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $c466418904831ddc$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $c466418904831ddc$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$c466418904831ddc$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $c466418904831ddc$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $c466418904831ddc$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$c466418904831ddc$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $c466418904831ddc$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $c466418904831ddc$var$initAdoptedStyleSheetObserver({ mirror: mirror, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === '#document') hostId = mirror.getId(host);
    else hostId = mirror.getId(host.host);
    const patchTarget = host.nodeName === '#document' ? $c466418904831ddc$var$_optionalChain$2([
        host,
        'access',
        (_4)=>_4.defaultView,
        'optionalAccess',
        (_5)=>_5.Document
    ]) : $c466418904831ddc$var$_optionalChain$2([
        host,
        'access',
        (_6)=>_6.ownerDocument,
        'optionalAccess',
        (_7)=>_7.defaultView,
        'optionalAccess',
        (_8)=>_8.ShadowRoot
    ]);
    const originalPropertyDescriptor = $c466418904831ddc$var$_optionalChain$2([
        patchTarget,
        'optionalAccess',
        (_9)=>_9.prototype
    ]) ? Object.getOwnPropertyDescriptor($c466418904831ddc$var$_optionalChain$2([
        patchTarget,
        'optionalAccess',
        (_10)=>_10.prototype
    ]), 'adoptedStyleSheets') : undefined;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, 'adoptedStyleSheets', {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return $c466418904831ddc$var$_optionalChain$2([
                originalPropertyDescriptor,
                'access',
                (_11)=>_11.get,
                'optionalAccess',
                (_12)=>_12.call,
                'call',
                (_13)=>_13(this)
            ]);
        },
        set (sheets) {
            const result = $c466418904831ddc$var$_optionalChain$2([
                originalPropertyDescriptor,
                'access',
                (_14)=>_14.set,
                'optionalAccess',
                (_15)=>_15.call,
                'call',
                (_16)=>_16(this, sheets)
            ]);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e) {}
            return result;
        }
    });
    return $c466418904831ddc$var$callbackWrapper(()=>{
        Object.defineProperty(host, 'adoptedStyleSheets', {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set
        });
    });
}
function $c466418904831ddc$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $c466418904831ddc$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $c466418904831ddc$var$getIdAndStyleId($c466418904831ddc$var$_optionalChain$2([
                thisArg,
                'access',
                (_17)=>_17.parentRule,
                'optionalAccess',
                (_18)=>_18.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $c466418904831ddc$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $c466418904831ddc$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $c466418904831ddc$var$getIdAndStyleId($c466418904831ddc$var$_optionalChain$2([
                thisArg,
                'access',
                (_19)=>_19.parentRule,
                'optionalAccess',
                (_20)=>_20.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                index: $c466418904831ddc$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $c466418904831ddc$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $c466418904831ddc$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror, sampling: sampling, doc: doc }) {
    const handler = $c466418904831ddc$var$callbackWrapper((type)=>$c466418904831ddc$var$throttle$1($c466418904831ddc$var$callbackWrapper((event)=>{
            const target = $c466418904831ddc$var$getEventTarget(event);
            if (!target || $c466418904831ddc$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $c466418904831ddc$var$on('play', handler(0), doc),
        $c466418904831ddc$var$on('pause', handler(1), doc),
        $c466418904831ddc$var$on('seeked', handler(2), doc),
        $c466418904831ddc$var$on('volumechange', handler(3), doc),
        $c466418904831ddc$var$on('ratechange', handler(4), doc)
    ];
    return $c466418904831ddc$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $c466418904831ddc$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== 'string',
            descriptors: descriptors,
            fontSource: typeof source === 'string' ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $c466418904831ddc$var$patch(doc.fonts, 'add', function(original) {
        return function(fontFace) {
            $c466418904831ddc$var$setTimeout$1($c466418904831ddc$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $c466418904831ddc$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $c466418904831ddc$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $c466418904831ddc$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && $c466418904831ddc$var$_optionalChain$2([
            selection,
            'optionalAccess',
            (_21)=>_21.isCollapsed
        ])) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i = 0; i < count; i++){
            const range = selection.getRangeAt(i);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $c466418904831ddc$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $c466418904831ddc$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset: startOffset,
                end: mirror.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $c466418904831ddc$var$on('selectionchange', updateSelection);
}
function $c466418904831ddc$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $c466418904831ddc$var$patch(win.customElements, 'define', function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $c466418904831ddc$var$initObservers(o, _hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    let mutationObserver;
    if (o.recordDOM) mutationObserver = $c466418904831ddc$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $c466418904831ddc$var$initMoveObserver(o);
    const mouseInteractionHandler = $c466418904831ddc$var$initMouseInteractionObserver(o);
    const scrollHandler = $c466418904831ddc$var$initScrollObserver(o);
    const viewportResizeHandler = $c466418904831ddc$var$initViewportResizeObserver(o, {
        win: currentWindow
    });
    const inputHandler = $c466418904831ddc$var$initInputObserver(o);
    const mediaInteractionHandler = $c466418904831ddc$var$initMediaInteractionObserver(o);
    let styleSheetObserver = ()=>{};
    let adoptedStyleSheetObserver = ()=>{};
    let styleDeclarationObserver = ()=>{};
    let fontObserver = ()=>{};
    if (o.recordDOM) {
        styleSheetObserver = $c466418904831ddc$var$initStyleSheetObserver(o, {
            win: currentWindow
        });
        adoptedStyleSheetObserver = $c466418904831ddc$var$initAdoptedStyleSheetObserver(o, o.doc);
        styleDeclarationObserver = $c466418904831ddc$var$initStyleDeclarationObserver(o, {
            win: currentWindow
        });
        if (o.collectFonts) fontObserver = $c466418904831ddc$var$initFontObserver(o);
    }
    const selectionObserver = $c466418904831ddc$var$initSelectionObserver(o);
    const customElementObserver = $c466418904831ddc$var$initCustomElementObserver(o);
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $c466418904831ddc$var$callbackWrapper(()=>{
        $c466418904831ddc$var$mutationBuffers.forEach((b)=>b.reset());
        $c466418904831ddc$var$_optionalChain$2([
            mutationObserver,
            'optionalAccess',
            (_22)=>_22.disconnect,
            'call',
            (_23)=>_23()
        ]);
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $c466418904831ddc$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== 'undefined';
}
function $c466418904831ddc$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== 'undefined' && window[prop].prototype && 'insertRule' in window[prop].prototype && 'deleteRule' in window[prop].prototype);
}
class $c466418904831ddc$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== 'number') return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = new WeakMap();
            this.iframeRemoteIdToIdMap = new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
function $c466418904831ddc$var$_optionalChain$1(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
class $c466418904831ddc$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $c466418904831ddc$var$CrossOriginIframeMirror($c466418904831ddc$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $c466418904831ddc$var$IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new $c466418904831ddc$var$CrossOriginIframeMirror($c466418904831ddc$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $c466418904831ddc$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener('message', this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        $c466418904831ddc$var$_optionalChain$1([
            this,
            'access',
            (_)=>_.loadListener,
            'optionalCall',
            (_2)=>_2(iframeEl)
        ]);
        const iframeDoc = $c466418904831ddc$var$getIFrameContentDocument(iframeEl);
        if (iframeDoc && iframeDoc.adoptedStyleSheets && iframeDoc.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeDoc.adoptedStyleSheets, this.mirror.getId(iframeDoc));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== 'rrweb' || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e) {
        switch(e.type){
            case $c466418904831ddc$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e.data.node, iframeEl);
                    const rootId = e.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e.data.node, rootId);
                    return {
                        timestamp: e.timestamp,
                        type: $c466418904831ddc$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $c466418904831ddc$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $c466418904831ddc$var$EventType.Meta:
            case $c466418904831ddc$var$EventType.Load:
            case $c466418904831ddc$var$EventType.DomContentLoaded:
                return false;
            case $c466418904831ddc$var$EventType.Plugin:
                return e;
            case $c466418904831ddc$var$EventType.Custom:
                this.replaceIds(e.data.payload, iframeEl, [
                    'id',
                    'parentId',
                    'previousId',
                    'nextId'
                ]);
                return e;
            case $c466418904831ddc$var$EventType.IncrementalSnapshot:
                switch(e.data.source){
                    case $c466418904831ddc$var$IncrementalSource.Mutation:
                        e.data.adds.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'parentId',
                                'nextId',
                                'previousId'
                            ]);
                            this.replaceIdOnNode(n.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n.node, rootId);
                        });
                        e.data.removes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'parentId',
                                'id'
                            ]);
                        });
                        e.data.attributes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'id'
                            ]);
                        });
                        e.data.texts.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'id'
                            ]);
                        });
                        return e;
                    case $c466418904831ddc$var$IncrementalSource.Drag:
                    case $c466418904831ddc$var$IncrementalSource.TouchMove:
                    case $c466418904831ddc$var$IncrementalSource.MouseMove:
                        e.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                'id'
                            ]);
                        });
                        return e;
                    case $c466418904831ddc$var$IncrementalSource.ViewportResize:
                        return false;
                    case $c466418904831ddc$var$IncrementalSource.MediaInteraction:
                    case $c466418904831ddc$var$IncrementalSource.MouseInteraction:
                    case $c466418904831ddc$var$IncrementalSource.Scroll:
                    case $c466418904831ddc$var$IncrementalSource.CanvasMutation:
                    case $c466418904831ddc$var$IncrementalSource.Input:
                        this.replaceIds(e.data, iframeEl, [
                            'id'
                        ]);
                        return e;
                    case $c466418904831ddc$var$IncrementalSource.StyleSheetRule:
                    case $c466418904831ddc$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e.data, iframeEl, [
                            'id'
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            'styleId'
                        ]);
                        return e;
                    case $c466418904831ddc$var$IncrementalSource.Font:
                        return e;
                    case $c466418904831ddc$var$IncrementalSource.Selection:
                        e.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                'start',
                                'end'
                            ]);
                        });
                        return e;
                    case $c466418904831ddc$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e.data, iframeEl, [
                            'id'
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            'styleIds'
                        ]);
                        $c466418904831ddc$var$_optionalChain$1([
                            e,
                            'access',
                            (_3)=>_3.data,
                            'access',
                            (_4)=>_4.styles,
                            'optionalAccess',
                            (_5)=>_5.forEach,
                            'call',
                            (_6)=>_6((style)=>{
                                    this.replaceStyleIds(style, iframeEl, [
                                        'styleId'
                                    ]);
                                })
                        ]);
                        return e;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== 'number') continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            'id',
            'rootId'
        ]);
        if ('childNodes' in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $c466418904831ddc$var$NodeType$3.Document && !node.rootId) node.rootId = rootId;
        if ('childNodes' in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $c466418904831ddc$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $c466418904831ddc$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$c466418904831ddc$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        this.bypassOptions.canvasManager.addShadowRoot(shadowRoot);
        const observer = $c466418904831ddc$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($c466418904831ddc$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
        $c466418904831ddc$var$setTimeout$1(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($c466418904831ddc$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    observeAttachShadow(iframeElement) {
        const iframeDoc = $c466418904831ddc$var$getIFrameContentDocument(iframeElement);
        const iframeWindow = $c466418904831ddc$var$getIFrameContentWindow(iframeElement);
        if (!iframeDoc || !iframeWindow) return;
        this.patchAttachShadow(iframeWindow.Element, iframeDoc);
    }
    patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($c466418904831ddc$var$patch(element.prototype, 'attachShadow', function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $c466418904831ddc$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = new WeakSet();
        this.bypassOptions.canvasManager.resetShadowRoots();
    }
}
class $c466418904831ddc$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
    addWindow() {}
    addShadowRoot() {}
    resetShadowRoots() {}
}
class $c466418904831ddc$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new $c466418904831ddc$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ('_cssText' in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r, index)=>({
                            rule: $c466418904831ddc$var$stringifyRule(r),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = new WeakSet();
    }
    trackStylesheetInLinkElement(linkEl) {}
}
class $c466418904831ddc$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = new WeakMap();
        this.active = false;
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        if (!this.active) {
            this.active = true;
            $c466418904831ddc$var$onRequestAnimationFrame(()=>{
                this.nodeMap = new WeakMap();
                this.active = false;
            });
        }
        this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
    destroy() {}
}
let $c466418904831ddc$var$wrappedEmit;
let $c466418904831ddc$var$_takeFullSnapshot;
try {
    if (Array.from([
        1
    ], (x)=>x * 2)[0] !== 2) {
        const cleanFrame = document.createElement('iframe');
        document.body.appendChild(cleanFrame);
        Array.from = (0, $bc10c19c6ecfa6c7$export$3cc482e6b02f32f7)([
            cleanFrame,
            'access',
            (_)=>_.contentWindow,
            'optionalAccess',
            (_2)=>_2.Array,
            'access',
            (_3)=>_3.from
        ]) || Array.from;
        document.body.removeChild(cleanFrame);
    }
} catch (err) {
    console.debug('Unable to override Array.from', err);
}
const $c466418904831ddc$var$mirror = $c466418904831ddc$var$createMirror();
function $c466418904831ddc$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = 'rr-block', blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = 'rr-ignore', ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = 'rr-mask', unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, maxCanvasSize: maxCanvasSize = null, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordDOM: recordDOM = true, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === 'DOMContentLoaded' ? options.recordAfter : 'load', userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = new Set([]), errorHandler: errorHandler, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $c466418904831ddc$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error('emit function is required');
    if (!inEmittingFrame && !passEmitsToParent) return ()=>{};
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    $c466418904831ddc$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === 'all',
        headMetaDescKeywords: _slimDOMOptions === 'all'
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $c466418904831ddc$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn && !passEmitsToParent) e = packFn(e);
        return e;
    };
    $c466418904831ddc$var$wrappedEmit = (r, isCheckout)=>{
        const e = r;
        e.timestamp = $c466418904831ddc$var$nowTimestamp();
        if ((0, $bc10c19c6ecfa6c7$export$3cc482e6b02f32f7)([
            $c466418904831ddc$var$mutationBuffers,
            'access',
            (_4)=>_4[0],
            'optionalAccess',
            (_5)=>_5.isFrozen,
            'call',
            (_6)=>_6()
        ]) && e.type !== $c466418904831ddc$var$EventType.FullSnapshot && !(e.type === $c466418904831ddc$var$EventType.IncrementalSnapshot && e.data.source === $c466418904831ddc$var$IncrementalSource.Mutation)) $c466418904831ddc$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) (0, $bc10c19c6ecfa6c7$export$3cc482e6b02f32f7)([
            emit,
            'optionalCall',
            (_7)=>_7(eventProcessor(e), isCheckout)
        ]);
        else if (passEmitsToParent) {
            const message = {
                type: 'rrweb',
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, '*');
        }
        if (e.type === $c466418904831ddc$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $c466418904831ddc$var$EventType.IncrementalSnapshot) {
            if (e.data.source === $c466418904831ddc$var$IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $c466418904831ddc$var$wrappedEmit({
            type: $c466418904831ddc$var$EventType.IncrementalSnapshot,
            data: {
                source: $c466418904831ddc$var$IncrementalSource.Mutation,
                ...m
            }
        });
    };
    const wrappedScrollEmit = (p)=>$c466418904831ddc$var$wrappedEmit({
            type: $c466418904831ddc$var$EventType.IncrementalSnapshot,
            data: {
                source: $c466418904831ddc$var$IncrementalSource.Scroll,
                ...p
            }
        });
    const wrappedCanvasMutationEmit = (p)=>$c466418904831ddc$var$wrappedEmit({
            type: $c466418904831ddc$var$EventType.IncrementalSnapshot,
            data: {
                source: $c466418904831ddc$var$IncrementalSource.CanvasMutation,
                ...p
            }
        });
    const wrappedAdoptedStyleSheetEmit = (a)=>$c466418904831ddc$var$wrappedEmit({
            type: $c466418904831ddc$var$EventType.IncrementalSnapshot,
            data: {
                source: $c466418904831ddc$var$IncrementalSource.AdoptedStyleSheet,
                ...a
            }
        });
    const stylesheetManager = new $c466418904831ddc$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === 'boolean' && __RRWEB_EXCLUDE_IFRAME__ ? new $c466418904831ddc$var$IframeManagerNoop() : new $c466418904831ddc$var$IframeManager({
        mirror: $c466418904831ddc$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $c466418904831ddc$var$wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $c466418904831ddc$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $c466418904831ddc$var$ProcessedNodeManager();
    const canvasManager = $c466418904831ddc$var$_getCanvasManager(getCanvasManager, {
        mirror: $c466418904831ddc$var$mirror,
        win: window,
        mutationCb: (p)=>$c466418904831ddc$var$wrappedEmit({
                type: $c466418904831ddc$var$EventType.IncrementalSnapshot,
                data: {
                    source: $c466418904831ddc$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            }),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling['canvas'],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === 'boolean' && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $c466418904831ddc$var$ShadowDomManagerNoop() : new $c466418904831ddc$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $c466418904831ddc$var$mirror
    });
    const takeFullSnapshot = (isCheckout = false)=>{
        if (!recordDOM) return;
        $c466418904831ddc$var$wrappedEmit({
            type: $c466418904831ddc$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $c466418904831ddc$var$getWindowWidth(),
                height: $c466418904831ddc$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $c466418904831ddc$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $c466418904831ddc$var$snapshot(document, {
            mirror: $c466418904831ddc$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($c466418904831ddc$var$isSerializedIframe(n, $c466418904831ddc$var$mirror)) iframeManager.addIframe(n);
                if ($c466418904831ddc$var$isSerializedStylesheet(n, $c466418904831ddc$var$mirror)) stylesheetManager.trackLinkElement(n);
                if ($c466418904831ddc$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                if (iframe.contentWindow) canvasManager.addWindow(iframe.contentWindow);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn('Failed to snapshot the document');
        $c466418904831ddc$var$wrappedEmit({
            type: $c466418904831ddc$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $c466418904831ddc$var$getWindowScroll(window)
            }
        });
        $c466418904831ddc$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $c466418904831ddc$var$mirror.getId(document));
    };
    $c466418904831ddc$var$_takeFullSnapshot = takeFullSnapshot;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $c466418904831ddc$var$callbackWrapper($c466418904831ddc$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$c466418904831ddc$var$wrappedEmit({
                        type: $c466418904831ddc$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }),
                mouseInteractionCb: (d)=>$c466418904831ddc$var$wrappedEmit({
                        type: $c466418904831ddc$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $c466418904831ddc$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$c466418904831ddc$var$wrappedEmit({
                        type: $c466418904831ddc$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $c466418904831ddc$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    }),
                inputCb: (v)=>$c466418904831ddc$var$wrappedEmit({
                        type: $c466418904831ddc$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $c466418904831ddc$var$IncrementalSource.Input,
                            ...v
                        }
                    }),
                mediaInteractionCb: (p)=>$c466418904831ddc$var$wrappedEmit({
                        type: $c466418904831ddc$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $c466418904831ddc$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    }),
                styleSheetRuleCb: (r)=>$c466418904831ddc$var$wrappedEmit({
                        type: $c466418904831ddc$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $c466418904831ddc$var$IncrementalSource.StyleSheetRule,
                            ...r
                        }
                    }),
                styleDeclarationCb: (r)=>$c466418904831ddc$var$wrappedEmit({
                        type: $c466418904831ddc$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $c466418904831ddc$var$IncrementalSource.StyleDeclaration,
                            ...r
                        }
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$c466418904831ddc$var$wrappedEmit({
                        type: $c466418904831ddc$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $c466418904831ddc$var$IncrementalSource.Font,
                            ...p
                        }
                    }),
                selectionCb: (p)=>{
                    $c466418904831ddc$var$wrappedEmit({
                        type: $c466418904831ddc$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $c466418904831ddc$var$IncrementalSource.Selection,
                            ...p
                        }
                    });
                },
                customElementCb: (c)=>{
                    $c466418904831ddc$var$wrappedEmit({
                        type: $c466418904831ddc$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $c466418904831ddc$var$IncrementalSource.CustomElement,
                            ...c
                        }
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordDOM: recordDOM,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $c466418904831ddc$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: (0, $bc10c19c6ecfa6c7$export$3cc482e6b02f32f7)([
                    plugins,
                    'optionalAccess',
                    (_8)=>_8.filter,
                    'call',
                    (_9)=>_9((p)=>p.observer),
                    'optionalAccess',
                    (_10)=>_10.map,
                    'call',
                    (_11)=>_11((p)=>({
                                observer: p.observer,
                                options: p.options,
                                callback: (payload)=>$c466418904831ddc$var$wrappedEmit({
                                        type: $c466418904831ddc$var$EventType.Plugin,
                                        data: {
                                            plugin: p.name,
                                            payload: payload
                                        }
                                    })
                            }))
                ]) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === 'interactive' || document.readyState === 'complete') init();
        else {
            handlers.push($c466418904831ddc$var$on('DOMContentLoaded', ()=>{
                $c466418904831ddc$var$wrappedEmit({
                    type: $c466418904831ddc$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === 'DOMContentLoaded') init();
            }));
            handlers.push($c466418904831ddc$var$on('load', ()=>{
                $c466418904831ddc$var$wrappedEmit({
                    type: $c466418904831ddc$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === 'load') init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $c466418904831ddc$var$_takeFullSnapshot = undefined;
            $c466418904831ddc$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $c466418904831ddc$var$takeFullSnapshot(isCheckout) {
    if (!$c466418904831ddc$var$_takeFullSnapshot) throw new Error('please take full snapshot after start recording');
    $c466418904831ddc$var$_takeFullSnapshot(isCheckout);
}
$c466418904831ddc$var$record.mirror = $c466418904831ddc$var$mirror;
$c466418904831ddc$var$record.takeFullSnapshot = $c466418904831ddc$var$takeFullSnapshot;
function $c466418904831ddc$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $c466418904831ddc$var$CanvasManagerNoop();
    } catch (e2) {
        console.warn('Unable to initialize CanvasManager');
        return new $c466418904831ddc$var$CanvasManagerNoop();
    }
}
const $c466418904831ddc$var$ReplayEventTypeIncrementalSnapshot = 3;
const $c466418904831ddc$var$ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $c466418904831ddc$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function $c466418904831ddc$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function $c466418904831ddc$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === 'sentry.transaction') return;
    if ([
        'ui.click',
        'ui.input'
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $c466418904831ddc$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: 'breadcrumb',
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $90e1e394273ecc0b$export$a3295358bff77e)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === 'console';
    });
}
const $c466418904831ddc$var$INTERACTIVE_SELECTOR = 'button,a';
/** Get the closest interactive parent element, or else return the given element. */ function $c466418904831ddc$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($c466418904831ddc$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function $c466418904831ddc$var$getClickTargetNode(event) {
    const target = $c466418904831ddc$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $c466418904831ddc$var$getClosestInteractive(target);
}
/** Get the event target node. */ function $c466418904831ddc$var$getTargetNode(event) {
    if ($c466418904831ddc$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $c466418904831ddc$var$isEventWithTarget(event) {
    return typeof event === 'object' && !!event && 'target' in event;
}
let $c466418904831ddc$var$handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function $c466418904831ddc$var$onWindowOpen(cb) {
    // Ensure to only register this once
    if (!$c466418904831ddc$var$handlers) {
        $c466418904831ddc$var$handlers = [];
        $c466418904831ddc$var$monkeyPatchWindowOpen();
    }
    $c466418904831ddc$var$handlers.push(cb);
    return ()=>{
        const pos = $c466418904831ddc$var$handlers ? $c466418904831ddc$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $c466418904831ddc$var$handlers.splice(pos, 1);
    };
}
function $c466418904831ddc$var$monkeyPatchWindowOpen() {
    (0, $9d45b9df9881c412$export$9563e054e6f787fb)($c466418904831ddc$var$WINDOW, 'open', function(originalWindowOpen) {
        return function(...args) {
            if ($c466418904831ddc$var$handlers) try {
                $c466418904831ddc$var$handlers.forEach((handler)=>handler());
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply($c466418904831ddc$var$WINDOW, args);
        };
    });
}
/** Any IncrementalSource for rrweb that we interpret as a kind of mutation. */ const $c466418904831ddc$var$IncrementalMutationSources = new Set([
    $c466418904831ddc$var$IncrementalSource.Mutation,
    $c466418904831ddc$var$IncrementalSource.StyleSheetRule,
    $c466418904831ddc$var$IncrementalSource.StyleDeclaration,
    $c466418904831ddc$var$IncrementalSource.AdoptedStyleSheet,
    $c466418904831ddc$var$IncrementalSource.CanvasMutation,
    $c466418904831ddc$var$IncrementalSource.Selection,
    $c466418904831ddc$var$IncrementalSource.MediaInteraction
]);
/** Handle a click. */ function $c466418904831ddc$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class $c466418904831ddc$var$ClickDetector {
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = $c466418904831ddc$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scrollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $c466418904831ddc$var$onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = $c466418904831ddc$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($c466418904831ddc$var$ignoreElement(node, this._ignoreSelector) || !$c466418904831ddc$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $c466418904831ddc$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $c466418904831ddc$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $c466418904831ddc$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $c466418904831ddc$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $c466418904831ddc$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scrollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? 'mutation' : 'timeout';
            const breadcrumb = {
                type: 'default',
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: 'ui.slowClickDetected',
                data: {
                    ...clickBreadcrumb.data,
                    url: $c466418904831ddc$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: 'default',
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: 'ui.multiClick',
                data: {
                    ...clickBreadcrumb.data,
                    url: $c466418904831ddc$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = (0, $d180a652670457c1$export$831dc9f2ab0a617b)(()=>this._checkClicks(), 1000);
    }
}
const $c466418904831ddc$var$SLOW_CLICK_TAGS = [
    'A',
    'BUTTON',
    'INPUT'
];
/** exported for tests only */ function $c466418904831ddc$var$ignoreElement(node, ignoreSelector) {
    if (!$c466418904831ddc$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === 'INPUT' && ![
        'submit',
        'button'
    ].includes(node.getAttribute('type') || '')) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === 'A' && (node.hasAttribute('download') || node.hasAttribute('target') && node.getAttribute('target') !== '_self')) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $c466418904831ddc$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === 'number' && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function $c466418904831ddc$var$nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function $c466418904831ddc$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!$c466418904831ddc$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if ($c466418904831ddc$var$IncrementalMutationSources.has(source)) clickDetector.registerMutation(event.timestamp);
        if (source === $c466418904831ddc$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($c466418904831ddc$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $c466418904831ddc$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $c466418904831ddc$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function $c466418904831ddc$var$isIncrementalEvent(event) {
    return event.type === $c466418904831ddc$var$ReplayEventTypeIncrementalSnapshot;
}
function $c466418904831ddc$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $c466418904831ddc$var$IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function $c466418904831ddc$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: 'default',
        ...breadcrumb
    };
}
var $c466418904831ddc$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($c466418904831ddc$var$NodeType || ($c466418904831ddc$var$NodeType = {}));
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $c466418904831ddc$var$ATTRIBUTES_TO_RECORD = new Set([
    'id',
    'class',
    'aria-label',
    'role',
    'name',
    'alt',
    'title',
    'data-test-id',
    'data-testid',
    'disabled',
    'aria-disabled',
    'data-sentry-component'
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $c466418904831ddc$var$getAttributesToRecord(attributes) {
    const obj = {};
    if (!attributes['data-sentry-component'] && attributes['data-sentry-element']) attributes['data-sentry-component'] = attributes['data-sentry-element'];
    for(const key in attributes)if ($c466418904831ddc$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === 'data-testid' || key === 'data-test-id') normalizedKey = 'testId';
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $c466418904831ddc$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $c466418904831ddc$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === 'click';
        const event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $c466418904831ddc$var$handleClick(replay.clickDetector, result, $c466418904831ddc$var$getClickTargetNode(handlerData.event));
        $c466418904831ddc$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $c466418904831ddc$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $c466418904831ddc$var$record.mirror.getId(target);
    const node = nodeId && $c466418904831ddc$var$record.mirror.getNode(nodeId);
    const meta = node && $c466418904831ddc$var$record.mirror.getMeta(node);
    const element = meta && $c466418904831ddc$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node)=>node.type === $c466418904831ddc$var$NodeType.Text && node.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join(''),
                attributes: $c466418904831ddc$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $c466418904831ddc$var$handleDom(handlerData) {
    const { target: target, message: message } = $c466418904831ddc$var$getDomTarget(handlerData);
    return $c466418904831ddc$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$c466418904831ddc$var$getBaseDomBreadcrumb(target, message)
    });
}
function $c466418904831ddc$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === 'click';
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $c466418904831ddc$var$getClickTargetNode(handlerData.event) : $c466418904831ddc$var$getTargetNode(handlerData.event);
        message = (0, $efa6e113a375d8ac$export$5647df6b7814ac86)(target, {
            maxStringLength: 200
        }) || '<unknown>';
    } catch (e) {
        message = '<unknown>';
    }
    return {
        target: target,
        message: message
    };
}
function $c466418904831ddc$var$isElement(node) {
    return node.type === $c466418904831ddc$var$NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function $c466418904831ddc$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = $c466418904831ddc$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $c466418904831ddc$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $c466418904831ddc$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $c466418904831ddc$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $efa6e113a375d8ac$export$5647df6b7814ac86)(target, {
        maxStringLength: 200
    }) || '<unknown>';
    const baseBreadcrumb = $c466418904831ddc$var$getBaseDomBreadcrumb(target, message);
    return $c466418904831ddc$var$createBreadcrumb({
        category: 'ui.keyDown',
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $c466418904831ddc$var$isInputElement(target) {
    return target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
const $c466418904831ddc$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $c466418904831ddc$var$createResourceEntry,
    paint: $c466418904831ddc$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $c466418904831ddc$var$createNavigationEntry
};
/**
 * Handler creater for web vitals
 */ function $c466418904831ddc$var$webVitalHandler(getter, replay) {
    return ({ metric: metric })=>void replay.replayPerformanceEntries.push(getter(metric));
}
/**
 * Create replay performance entries from the browser performance entries.
 */ function $c466418904831ddc$var$createPerformanceEntries(entries) {
    return entries.map($c466418904831ddc$var$createPerformanceEntry).filter(Boolean);
}
function $c466418904831ddc$var$createPerformanceEntry(entry) {
    const entryType = $c466418904831ddc$var$ENTRY_TYPES[entry.entryType];
    if (!entryType) return null;
    return entryType(entry);
}
function $c466418904831ddc$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $958146d03402aa5e$export$baf075a948ffc0bf) || $c466418904831ddc$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $c466418904831ddc$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $c466418904831ddc$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $c466418904831ddc$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $c466418904831ddc$var$getAbsoluteTime(startTime),
        end: $c466418904831ddc$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $c466418904831ddc$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        'fetch',
        'xmlhttprequest'
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $c466418904831ddc$var$getAbsoluteTime(startTime),
        end: $c466418904831ddc$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on a LCP metric.
 */ function $c466418904831ddc$var$getLargestContentfulPaint(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry && lastEntry.element ? [
        lastEntry.element
    ] : undefined;
    return $c466418904831ddc$var$getWebVital(metric, 'largest-contentful-paint', node);
}
function $c466418904831ddc$var$isLayoutShift(entry) {
    return entry.sources !== undefined;
}
/**
 * Add a CLS event to the replay based on a CLS metric.
 */ function $c466418904831ddc$var$getCumulativeLayoutShift(metric) {
    const layoutShifts = [];
    const nodes = [];
    for (const entry of metric.entries)if ($c466418904831ddc$var$isLayoutShift(entry)) {
        const nodeIds = [];
        for (const source of entry.sources)if (source.node) {
            nodes.push(source.node);
            const nodeId = $c466418904831ddc$var$record.mirror.getId(source.node);
            if (nodeId) nodeIds.push(nodeId);
        }
        layoutShifts.push({
            value: entry.value,
            nodeIds: nodeIds.length ? nodeIds : undefined
        });
    }
    return $c466418904831ddc$var$getWebVital(metric, 'cumulative-layout-shift', nodes, layoutShifts);
}
/**
 * Add a FID event to the replay based on a FID metric.
 */ function $c466418904831ddc$var$getFirstInputDelay(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry && lastEntry.target ? [
        lastEntry.target
    ] : undefined;
    return $c466418904831ddc$var$getWebVital(metric, 'first-input-delay', node);
}
/**
 * Add an INP event to the replay based on an INP metric.
 */ function $c466418904831ddc$var$getInteractionToNextPaint(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry && lastEntry.target ? [
        lastEntry.target
    ] : undefined;
    return $c466418904831ddc$var$getWebVital(metric, 'interaction-to-next-paint', node);
}
/**
 * Add an web vital event to the replay based on the web vital metric.
 */ function $c466418904831ddc$var$getWebVital(metric, name, nodes, attributions) {
    const value = metric.value;
    const rating = metric.rating;
    const end = $c466418904831ddc$var$getAbsoluteTime(value);
    return {
        type: 'web-vital',
        name: name,
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            rating: rating,
            nodeIds: nodes ? nodes.map((node)=>$c466418904831ddc$var$record.mirror.getId(node)) : undefined,
            attributions: attributions
        }
    };
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function $c466418904831ddc$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        'navigation',
        'paint',
        'resource'
    ].forEach((type)=>{
        clearCallbacks.push((0, $a938f5a5e4e7044e$export$69816c1a049f8db6)(type, onEntries));
    });
    clearCallbacks.push((0, $a938f5a5e4e7044e$export$3fd4b53331200102)($c466418904831ddc$var$webVitalHandler($c466418904831ddc$var$getLargestContentfulPaint, replay)), (0, $a938f5a5e4e7044e$export$861b82818b37ba5b)($c466418904831ddc$var$webVitalHandler($c466418904831ddc$var$getCumulativeLayoutShift, replay)), (0, $a938f5a5e4e7044e$export$2707d7471c0b918f)($c466418904831ddc$var$webVitalHandler($c466418904831ddc$var$getFirstInputDelay, replay)), (0, $a938f5a5e4e7044e$export$da3b76aa2022cbd7)($c466418904831ddc$var$webVitalHandler($c466418904831ddc$var$getInteractionToNextPaint, replay)));
    // A callback to cleanup all handlers
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $c466418904831ddc$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
const $c466418904831ddc$var$r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},_=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},x=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=A(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},A=function(t,n,r){return-1==t.s?Math.max(A(t.l,n,r+1),A(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},U=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=x(f,15),M=b.t,E=b.l,A=x(h,15),U=A.t,C=A.l,F=D(M),I=F.c,S=F.n,L=D(U),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=x(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,U)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(U,C,0),R=U;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){_(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;_(r,m,Q[et]),m+=R[et],et>3&&(_(r,m,rt>>5&8191),m+=i[et])}else _(r,m,N[rt]),m+=P[rt]}return _(r,m,N[256]),m+P[256]},C=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}},L=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},O=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=C[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,_=c.p||new n(32768),x=c.h||new n(z+1),A=Math.ceil(o/3),D=2*A,T=function(t){return(a[t]^a[t+1]<<A^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=x[H];if(_[J]=K,x[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=U(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-_[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=_[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=U(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=x,c.p=_,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},j=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},q=function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&j(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}},B=function(t){return 10+(t.filename?t.filename.length+1:0)},G=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(O(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();var H=function(){function t(t,n){this.c=L(),this.v=1,G.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),G.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=O(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=L();i.p(n.dictionary),j(t,2,i.d())}}(r,this.o),this.v=0),n&&j(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),J="undefined"!=typeof TextEncoder&&new TextEncoder,K="undefined"!=typeof TextDecoder&&new TextDecoder;try{K.decode(F,{stream:!0})}catch(t){}var N=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(P(t),this.d=n||!1)},t}();function P(n,r){if(J)return J.encode(n);for(var e=n.length,i=new t(n.length+(n.length>>1)),a=0,s=function(t){i[a++]=t},o=0;o<e;++o){if(a+5>i.length){var f=new t(a+8+(e-o<<1));f.set(i),i=f}var h=n.charCodeAt(o);h<128||r?s(h):h<2048?(s(192|h>>6),s(128|63&h)):h>55295&&h<57344?(s(240|(h=65536+(1047552&h)|1023&n.charCodeAt(++o))>>18),s(128|h>>12&63),s(128|h>>6&63),s(128|63&h)):(s(224|h>>12),s(128|h>>6&63),s(128|63&h))}return b(i,0,a)}function Q(t){return function(t,n){n||(n={});var r=S(),e=t.length;r.p(t);var i=O(t,n,B(n),8),a=i.length;return q(i,n),j(i,a-8,r.d()),j(i,a-4,e),i}(P(t))}const R=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(const r of t)n+=r.length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new H,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new N(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},V={clear:()=>{R.clear()},addEvent:t=>R.addEvent(t),finish:()=>R.finish(),compress:t=>Q(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in V&&"function"==typeof V[n])try{const t=V[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $c466418904831ddc$var$e() {
    const e = new Blob([
        $c466418904831ddc$var$r
    ]);
    return URL.createObjectURL(e);
}
const $c466418904831ddc$var$CONSOLE_LEVELS = [
    'info',
    'warn',
    'error',
    'log'
];
const $c466418904831ddc$var$PREFIX = '[Replay] ';
function $c466418904831ddc$var$_addBreadcrumb(message, level = 'info') {
    (0, $39b2704e5c5568a5$export$efda9a273d7a036d)({
        category: 'console',
        data: {
            logger: 'replay'
        },
        level: level,
        message: `${$c466418904831ddc$var$PREFIX}${message}`
    }, {
        level: level
    });
}
function $c466418904831ddc$var$makeReplayLogger() {
    let _capture = false;
    let _trace = false;
    const _logger = {
        exception: ()=>undefined,
        infoTick: ()=>undefined,
        setConfig: (opts)=>{
            _capture = opts.captureExceptions;
            _trace = opts.traceInternals;
        }
    };
    if ($c466418904831ddc$var$DEBUG_BUILD) {
        $c466418904831ddc$var$CONSOLE_LEVELS.forEach((name)=>{
            _logger[name] = (...args)=>{
                (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521)[name]($c466418904831ddc$var$PREFIX, ...args);
                if (_trace) $c466418904831ddc$var$_addBreadcrumb(args.join(''), (0, $6c101982fbcae8ee$export$d771ef054122c30a)(name));
            };
        });
        _logger.exception = (error, ...message)=>{
            if (message.length && _logger.error) _logger.error(...message);
            (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).error($c466418904831ddc$var$PREFIX, error);
            if (_capture) (0, $4af1b4aa86e906d6$export$f5282963edea4a68)(error);
            else if (_trace) // No need for a breadcrumb if `_capture` is enabled since it should be
            // captured as an exception
            $c466418904831ddc$var$_addBreadcrumb(error, 'error');
        };
        _logger.infoTick = (...args)=>{
            (0, $2c5c4ba32bebd8b3$export$af88d00dbe7f521).info($c466418904831ddc$var$PREFIX, ...args);
            if (_trace) // Wait a tick here to avoid race conditions for some initial logs
            // which may be added before replay is initialized
            setTimeout(()=>$c466418904831ddc$var$_addBreadcrumb(args[0]), 0);
        };
    } else $c466418904831ddc$var$CONSOLE_LEVELS.forEach((name)=>{
        _logger[name] = ()=>undefined;
    });
    return _logger;
}
const $c466418904831ddc$var$logger = $c466418904831ddc$var$makeReplayLogger();
/** This error indicates that the event buffer size exceeded the limit.. */ class $c466418904831ddc$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$c466418904831ddc$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $c466418904831ddc$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ /** @inheritdoc */ /** @inheritdoc */ constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
        this.waitForCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return 'sync';
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $c466418904831ddc$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $c466418904831ddc$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $c466418904831ddc$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $c466418904831ddc$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener('message', ({ data: data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener('error', (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.info('Destroying compression worker');
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener('message', listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.error('Error in compression worker: ', response.response);
                    reject(new Error('Error in compression worker'));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener('message', listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $c466418904831ddc$var$EventBufferCompressionWorker {
    /** @inheritdoc */ /** @inheritdoc */ constructor(worker){
        this._worker = new $c466418904831ddc$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        this.waitForCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return 'worker';
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully received and processed by worker.
   */ addEvent(event) {
        const timestamp = $c466418904831ddc$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $c466418904831ddc$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $c466418904831ddc$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage('clear').then(null, (e)=>{
            $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.exception(e, 'Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage('addEvent', data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage('finish');
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $c466418904831ddc$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $c466418904831ddc$var$EventBufferArray();
        this._compression = new $c466418904831ddc$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get waitForCheckout() {
        return this._used.waitForCheckout;
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
    set waitForCheckout(value) {
        this._used.waitForCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.exception(error, 'Failed to load the compression worker, falling back to simple buffer');
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout, waitForCheckout: waitForCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        this._compression.waitForCheckout = waitForCheckout;
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
            // Can now clear fallback buffer as it's no longer necessary
            this._fallback.clear();
        } catch (error) {
            $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.exception(error, 'Failed to add events when switching buffers.');
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $c466418904831ddc$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $c466418904831ddc$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.info('Using simple buffer');
    return new $c466418904831ddc$var$EventBufferArray();
}
function $c466418904831ddc$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $c466418904831ddc$var$_getWorkerUrl();
        if (!workerUrl) return;
        $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.info(`Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ''}`);
        const worker = new Worker(workerUrl);
        return new $c466418904831ddc$var$EventBufferProxy(worker);
    } catch (error) {
        $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.exception(error, 'Failed to create compression worker');
    // Fall back to use simple event buffer array
    }
}
function $c466418904831ddc$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === 'undefined' || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $c466418904831ddc$var$e();
    return '';
}
/** If sessionStorage is available. */ function $c466418904831ddc$var$hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return 'sessionStorage' in $c466418904831ddc$var$WINDOW && !!$c466418904831ddc$var$WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $c466418904831ddc$var$clearSession(replay) {
    $c466418904831ddc$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $c466418904831ddc$var$deleteSession() {
    if (!$c466418904831ddc$var$hasSessionStorage()) return;
    try {
        $c466418904831ddc$var$WINDOW.sessionStorage.removeItem($c466418904831ddc$var$REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $c466418904831ddc$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Get a session with defaults & applied sampling.
 */ function $c466418904831ddc$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $3340a52637a7f113$export$19f53698e68b2496)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId
    };
}
/**
 * Save a session to session storage.
 */ function $c466418904831ddc$var$saveSession(session) {
    if (!$c466418904831ddc$var$hasSessionStorage()) return;
    try {
        $c466418904831ddc$var$WINDOW.sessionStorage.setItem($c466418904831ddc$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $c466418904831ddc$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $c466418904831ddc$var$isSampled(sessionSampleRate) ? 'session' : allowBuffering ? 'buffer' : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $c466418904831ddc$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $c466418904831ddc$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $c466418904831ddc$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $c466418904831ddc$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $c466418904831ddc$var$fetchSession() {
    if (!$c466418904831ddc$var$hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $c466418904831ddc$var$WINDOW.sessionStorage.getItem($c466418904831ddc$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.infoTick('Loading existing session');
        return $c466418904831ddc$var$makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $c466418904831ddc$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $c466418904831ddc$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $c466418904831ddc$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $c466418904831ddc$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function $c466418904831ddc$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    // If not expired, all good, just keep the session
    if (!$c466418904831ddc$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === 'buffer' && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function $c466418904831ddc$var$loadOrCreateSession({ sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $c466418904831ddc$var$fetchSession();
    // No session exists yet, just create a new one
    if (!existingSession) {
        $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.infoTick('Creating new session');
        return $c466418904831ddc$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$c466418904831ddc$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.infoTick('Session in sessionStorage is expired, creating new one...');
    return $c466418904831ddc$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $c466418904831ddc$var$isCustomEvent(event) {
    return event.type === $c466418904831ddc$var$EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $c466418904831ddc$var$addEventSync(replay, event, isCheckout) {
    if (!$c466418904831ddc$var$shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $c466418904831ddc$var$_addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $c466418904831ddc$var$addEvent(replay, event, isCheckout) {
    if (!$c466418904831ddc$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $c466418904831ddc$var$_addEvent(replay, event, isCheckout);
}
async function $c466418904831ddc$var$_addEvent(replay, event, isCheckout) {
    const { eventBuffer: eventBuffer } = replay;
    if (!eventBuffer || eventBuffer.waitForCheckout && !isCheckout) return null;
    const isBufferMode = replay.recordingMode === 'buffer';
    try {
        if (isCheckout && isBufferMode) eventBuffer.clear();
        if (isCheckout) {
            eventBuffer.hasCheckout = true;
            eventBuffer.waitForCheckout = false;
        }
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $c466418904831ddc$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const isExceeded = error && error instanceof $c466418904831ddc$var$EventBufferSizeExceededError;
        const reason = isExceeded ? 'addEventSizeExceeded' : 'addEvent';
        if (isExceeded && isBufferMode) {
            // Clear buffer and wait for next checkout
            eventBuffer.clear();
            eventBuffer.waitForCheckout = true;
            return null;
        }
        replay.handleException(error);
        await replay.stop({
            reason: reason
        });
        const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
        if (client) client.recordDroppedEvent('internal_sdk_error', 'replay');
    }
}
/** Exported only for tests. */ function $c466418904831ddc$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $c466418904831ddc$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.infoTick(`Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`);
        return false;
    }
    return true;
}
function $c466418904831ddc$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === 'function' && $c466418904831ddc$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.exception(error, 'An error occurred in the `beforeAddRecordingEvent` callback, skipping the event...');
        return null;
    }
    return event;
}
/** If the event is an error event */ function $c466418904831ddc$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $c466418904831ddc$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** If the event is an replay event */ function $c466418904831ddc$var$isReplayEvent(event) {
    return event.type === 'replay_event';
}
/** If the event is a feedback event */ function $c466418904831ddc$var$isFeedbackEvent(event) {
    return event.type === 'feedback';
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $c466418904831ddc$var$handleAfterSendEvent(replay) {
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$c466418904831ddc$var$isErrorEvent(event) && !$c466418904831ddc$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (!statusCode || statusCode < 200 || statusCode >= 300) return;
        if ($c466418904831ddc$var$isTransactionEvent(event)) {
            $c466418904831ddc$var$handleTransactionEvent(replay, event);
            return;
        }
        $c466418904831ddc$var$handleErrorEvent(replay, event);
    };
}
function $c466418904831ddc$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $c466418904831ddc$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== 'buffer' || !event.tags || !event.tags.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === 'function' && !beforeErrorSampling(event)) return;
    (0, $d180a652670457c1$export$831dc9f2ab0a617b)(async ()=>{
        try {
            // Capture current event buffer as new replay
            await replay.sendBufferedReplayOrFlush();
        } catch (err) {
            replay.handleException(err);
        }
    });
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $c466418904831ddc$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$c466418904831ddc$var$isErrorEvent(event)) return;
        $c466418904831ddc$var$handleHydrationError(replay, event);
    };
}
function $c466418904831ddc$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception && event.exception.values && event.exception.values[0] && event.exception.values[0].value;
    if (typeof exceptionValue !== 'string') return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    // With newer React versions, the messages changed to a different website https://react.dev/errors/418
    exceptionValue.match(/(reactjs\.org\/docs\/error-decoder\.html\?invariant=|react\.dev\/errors\/)(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $c466418904831ddc$var$createBreadcrumb({
            category: 'replay.hydrate-error',
            data: {
                url: (0, $efa6e113a375d8ac$export$1cfafeee2987818b)()
            }
        });
        $c466418904831ddc$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Handle breadcrumbs that Sentry captures, and make sure to capture relevant breadcrumbs to Replay as well.
 */ function $c466418904831ddc$var$handleBreadcrumbs(replay) {
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    if (!client) return;
    client.on('beforeAddBreadcrumb', (breadcrumb)=>$c466418904831ddc$var$beforeAddBreadcrumb(replay, breadcrumb));
}
function $c466418904831ddc$var$beforeAddBreadcrumb(replay, breadcrumb) {
    if (!replay.isEnabled() || !$c466418904831ddc$var$isBreadcrumbWithCategory(breadcrumb)) return;
    const result = $c466418904831ddc$var$normalizeBreadcrumb(breadcrumb);
    if (result) $c466418904831ddc$var$addBreadcrumbEvent(replay, result);
}
/** Exported only for tests. */ function $c466418904831ddc$var$normalizeBreadcrumb(breadcrumb) {
    if (!$c466418904831ddc$var$isBreadcrumbWithCategory(breadcrumb) || [
        // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
        'fetch',
        'xhr',
        // These two are breadcrumbs for emitted sentry events, we don't care about them
        'sentry.event',
        'sentry.transaction'
    ].includes(breadcrumb.category) || // We capture UI breadcrumbs separately
    breadcrumb.category.startsWith('ui.')) return null;
    if (breadcrumb.category === 'console') return $c466418904831ddc$var$normalizeConsoleBreadcrumb(breadcrumb);
    return $c466418904831ddc$var$createBreadcrumb(breadcrumb);
}
/** exported for tests only */ function $c466418904831ddc$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return $c466418904831ddc$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === 'string') {
            if (arg.length > $c466418904831ddc$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $c466418904831ddc$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === 'object') try {
            const normalizedArg = (0, $90e1e394273ecc0b$export$a3295358bff77e)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $c466418904831ddc$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $c466418904831ddc$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return $c466418904831ddc$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        'CONSOLE_ARG_TRUNCATED'
                    ]
                }
            } : {}
        }
    });
}
function $c466418904831ddc$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $c466418904831ddc$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    return false;
}
/**
 * Reset the `replay_id` field on the DSC.
 */ function $c466418904831ddc$var$resetReplayIdOnDynamicSamplingContext() {
    // Reset DSC on the current scope, if there is one
    const dsc = (0, $a383148e3fcc828a$export$c7be4b0125a10cba)().getPropagationContext().dsc;
    if (dsc) delete dsc.replay_id;
    // Clear it from frozen DSC on the active span
    const activeSpan = (0, $e228aefa610f8d34$export$1be426a8e585c83e)();
    if (activeSpan) {
        const dsc = (0, $1dfeb99fdc06c052$export$a117f995597e25df)(activeSpan);
        delete dsc.replay_id;
    }
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function $c466418904831ddc$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $c466418904831ddc$var$EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: 'breadcrumb',
                payload: {
                    timestamp: event.timestamp,
                    type: 'default',
                    category: 'sentry.feedback',
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `handleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $c466418904831ddc$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== 'buffer') return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $c466418904831ddc$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $c466418904831ddc$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function $c466418904831ddc$var$handleGlobalEventListener(replay) {
    return Object.assign((event, hint)=>{
        // Do nothing if replay has been disabled or paused
        if (!replay.isEnabled() || replay.isPaused()) return event;
        if ($c466418904831ddc$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!$c466418904831ddc$var$isErrorEvent(event) && !$c466418904831ddc$var$isTransactionEvent(event) && !$c466418904831ddc$var$isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // prevent exceeding replay durations by removing the expired replayId from the DSC
            $c466418904831ddc$var$resetReplayIdOnDynamicSamplingContext();
            return event;
        }
        if ($c466418904831ddc$var$isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            $c466418904831ddc$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($c466418904831ddc$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.log('Ignoring error from rrweb internals', event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $c466418904831ddc$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === 'session';
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        return event;
    }, {
        id: 'Replay'
    });
}
/**
 * Create a "span" for each performance entry.
 */ function $c466418904831ddc$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $c466418904831ddc$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: 'performanceSpan',
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === 'string' ? Promise.resolve(null) : response;
    });
}
function $c466418904831ddc$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: 'navigation.push',
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function $c466418904831ddc$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $c466418904831ddc$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $c466418904831ddc$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $c466418904831ddc$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ($c466418904831ddc$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $0cb4b06d5363f64d$export$d92e61f5600202af)(url, (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)());
}
/** Add a performance entry breadcrumb */ function $c466418904831ddc$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($c466418904831ddc$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $c466418904831ddc$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** Get the size of a body. */ function $c466418904831ddc$var$getBodySize(body) {
    if (!body) return undefined;
    const textEncoder = new TextEncoder();
    try {
        if (typeof body === 'string') return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = $c466418904831ddc$var$_serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $c466418904831ddc$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function $c466418904831ddc$var$getBodyString(body) {
    try {
        if (typeof body === 'string') return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $c466418904831ddc$var$_serializeFormData(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (error) {
        $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.exception(error, 'Failed to serialize body', body);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
    $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.info('Skipping network body because of body type', body);
    return [
        undefined,
        'UNPARSEABLE_BODY_TYPE'
    ];
}
/** Merge a warning into an existing network request/response. */ function $c466418904831ddc$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $c466418904831ddc$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, $9d45b9df9881c412$export$d25f2688db1bb433)({
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $c466418904831ddc$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                'URL_SKIPPED'
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $c466418904831ddc$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $c466418904831ddc$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings && warnings.length > 0) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $c466418904831ddc$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.entries(headers).reduce((filteredHeaders, [key, value])=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = value;
        return filteredHeaders;
    }, {});
}
function $c466418904831ddc$var$_serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function $c466418904831ddc$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== 'string') return {
        body: body
    };
    const exceedsSizeLimit = body.length > $c466418904831ddc$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $c466418904831ddc$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $c466418904831ddc$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                'MAYBE_JSON_TRUNCATED'
            ]
        };
        return {
            body: `${truncatedBody}\u{2026}`,
            warnings: [
                'TEXT_TRUNCATED'
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch (e2) {
    // fall back to just send the body as string
    }
    return {
        body: body
    };
}
function $c466418904831ddc$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === '[' && last === ']' || first === '{' && last === '}';
}
/** Match an URL against a list of strings/Regex. */ function $c466418904831ddc$var$urlMatches(url, urls) {
    const fullUrl = $c466418904831ddc$var$getFullUrl(url);
    return (0, $b846d2d7ea7b5879$export$a7a5ec66062ea5d)(fullUrl, urls);
}
/** exported for tests */ function $c466418904831ddc$var$getFullUrl(url, baseURI = $c466418904831ddc$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith($c466418904831ddc$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith('/') && fullUrl.endsWith('/')) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where appropriate).
 */ async function $c466418904831ddc$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $c466418904831ddc$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $c466418904831ddc$var$makeNetworkReplayBreadcrumb('resource.fetch', data);
        $c466418904831ddc$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.exception(error, 'Failed to capture fetch breadcrumb');
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $c466418904831ddc$var$enrichFetchBreadcrumb(breadcrumb, hint) {
    const { input: input, response: response } = hint;
    const body = input ? $c466418904831ddc$var$_getFetchRequestArgBody(input) : undefined;
    const reqSize = $c466418904831ddc$var$getBodySize(body);
    const resSize = response ? $c466418904831ddc$var$parseContentLengthHeader(response.headers.get('content-length')) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $c466418904831ddc$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $c466418904831ddc$var$urlMatches(url, options.networkDetailAllowUrls) && !$c466418904831ddc$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $c466418904831ddc$var$_getRequestInfo(options, hint.input, requestBodySize) : $c466418904831ddc$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $c466418904831ddc$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $c466418904831ddc$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $c466418904831ddc$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $c466418904831ddc$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = $c466418904831ddc$var$_getFetchRequestArgBody(input);
    const [bodyStr, warning] = $c466418904831ddc$var$getBodyString(requestBody);
    const data = $c466418904831ddc$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $c466418904831ddc$var$mergeWarning(data, warning);
    return data;
}
/** Exported only for tests. */ async function $c466418904831ddc$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $c466418904831ddc$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $c466418904831ddc$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return $c466418904831ddc$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    const [bodyText, warning] = await $c466418904831ddc$var$_parseFetchResponseBody(response);
    const result = $c466418904831ddc$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $c466418904831ddc$var$mergeWarning(result, warning);
    return result;
}
function $c466418904831ddc$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText && bodyText.length && responseBodySize === undefined ? $c466418904831ddc$var$getBodySize(bodyText) : responseBodySize;
        if (!captureDetails) return $c466418904831ddc$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $c466418904831ddc$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $c466418904831ddc$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.exception(error, 'Failed to serialize response body');
        // fallback
        return $c466418904831ddc$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $c466418904831ddc$var$_parseFetchResponseBody(response) {
    const res = $c466418904831ddc$var$_tryCloneResponse(response);
    if (!res) return [
        undefined,
        'BODY_PARSE_ERROR'
    ];
    try {
        const text = await $c466418904831ddc$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        if (error instanceof Error && error.message.indexOf('Timeout') > -1) {
            $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.warn('Parsing text body from response timed out');
            return [
                undefined,
                'BODY_PARSE_TIMEOUT'
            ];
        }
        $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.exception(error, 'Failed to get text body from response');
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
}
function $c466418904831ddc$var$_getFetchRequestArgBody(fetchArgs = []) {
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== 'object') return undefined;
    return fetchArgs[1].body;
}
function $c466418904831ddc$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $c466418904831ddc$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== 'string') return $c466418904831ddc$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $c466418904831ddc$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $c466418904831ddc$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $c466418904831ddc$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $c466418904831ddc$var$getAllowedHeaders(headers, allowedHeaders);
}
function $c466418904831ddc$var$_tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.exception(error, 'Failed to clone response body');
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function $c466418904831ddc$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = (0, $d180a652670457c1$export$831dc9f2ab0a617b)(()=>reject(new Error('Timeout while trying to read response body')), 500);
        $c466418904831ddc$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $c466418904831ddc$var$_getResponseText(response) {
    // Force this to be a promise, just to be safe
    // eslint-disable-next-line no-return-await
    return await response.text();
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where appropriate).
 */ async function $c466418904831ddc$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $c466418904831ddc$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $c466418904831ddc$var$makeNetworkReplayBreadcrumb('resource.xhr', data);
        $c466418904831ddc$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.exception(error, 'Failed to capture xhr breadcrumb');
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $c466418904831ddc$var$enrichXhrBreadcrumb(breadcrumb, hint) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $c466418904831ddc$var$getBodySize(input);
    const resSize = xhr.getResponseHeader('content-length') ? $c466418904831ddc$var$parseContentLengthHeader(xhr.getResponseHeader('content-length')) : $c466418904831ddc$var$_getBodySize(xhr.response, xhr.responseType);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $c466418904831ddc$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$c466418904831ddc$var$urlMatches(url, options.networkDetailAllowUrls) || $c466418904831ddc$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request = $c466418904831ddc$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $c466418904831ddc$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    const xhrInfo = xhr[0, $3bd585063dd5b110$export$55b6bb1e45c6cf59];
    const networkRequestHeaders = xhrInfo ? $c466418904831ddc$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $c466418904831ddc$var$getAllowedHeaders($c466418904831ddc$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? $c466418904831ddc$var$getBodyString(input) : [
        undefined
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $c466418904831ddc$var$_getXhrResponseBody(xhr) : [
        undefined
    ];
    const request = $c466418904831ddc$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $c466418904831ddc$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $c466418904831ddc$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $c466418904831ddc$var$mergeWarning(response, responseWarning) : response
    };
}
function $c466418904831ddc$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split('\r\n').reduce((acc, line)=>{
        const [key, value] = line.split(': ');
        if (value) acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
function $c466418904831ddc$var$_getXhrResponseBody(xhr) {
    // We collect errors that happen, but only log them if we can't get any response body
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return $c466418904831ddc$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.warn('Failed to get xhr response body', ...errors);
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function $c466418904831ddc$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === 'string') return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === 'json' && body && typeof body === 'object') return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (error) {
        $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.exception(error, 'Failed to serialize body', body);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
    $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.info('Skipping network body because of body type', body);
    return [
        undefined,
        'UNPARSEABLE_BODY_TYPE'
    ];
}
function $c466418904831ddc$var$_getBodySize(body, responseType) {
    try {
        const bodyStr = responseType === 'json' && body && typeof body === 'object' ? JSON.stringify(body) : body;
        return $c466418904831ddc$var$getBodySize(bodyStr);
    } catch (e2) {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $c466418904831ddc$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    try {
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client) client.on('beforeAddBreadcrumb', (breadcrumb, hint)=>$c466418904831ddc$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function $c466418904831ddc$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($c466418904831ddc$var$_isXhrBreadcrumb(breadcrumb) && $c466418904831ddc$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $c466418904831ddc$var$enrichXhrBreadcrumb(breadcrumb, hint);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $c466418904831ddc$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($c466418904831ddc$var$_isFetchBreadcrumb(breadcrumb) && $c466418904831ddc$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $c466418904831ddc$var$enrichFetchBreadcrumb(breadcrumb, hint);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $c466418904831ddc$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.exception(e, 'Error when enriching network breadcrumb');
    }
}
function $c466418904831ddc$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'xhr';
}
function $c466418904831ddc$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'fetch';
}
function $c466418904831ddc$var$_isXhrHint(hint) {
    return hint && hint.xhr;
}
function $c466418904831ddc$var$_isFetchHint(hint) {
    return hint && hint.response;
}
/**
 * Add global listeners that cannot be removed.
 */ function $c466418904831ddc$var$addGlobalListeners(replay) {
    // Listeners from core SDK //
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    (0, $cd9614bbd73b83f8$export$5aeffd3db2cf9df7)($c466418904831ddc$var$handleDomListener(replay));
    (0, $66c7820cfb83137d$export$3f18c56c58114e75)($c466418904831ddc$var$handleHistorySpanListener(replay));
    $c466418904831ddc$var$handleBreadcrumbs(replay);
    $c466418904831ddc$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    const eventProcessor = $c466418904831ddc$var$handleGlobalEventListener(replay);
    (0, $4af1b4aa86e906d6$export$9aac0b9f77928fbf)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if (client) {
        client.on('beforeSendEvent', $c466418904831ddc$var$handleBeforeSendEvent(replay));
        client.on('afterSendEvent', $c466418904831ddc$var$handleAfterSendEvent(replay));
        client.on('createDsc', (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === 'session') {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on('spanStart', (span)=>{
            replay.lastActiveSpan = span;
        });
        // We may be missing the initial spanStart due to timing issues,
        // so we capture it on finish again.
        client.on('spanEnd', (span)=>{
            replay.lastActiveSpan = span;
        });
        // We want to flush replay
        client.on('beforeSendFeedback', (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options && options.includeReplay && replay.isEnabled() && replayId) // This should never reject
            {
                if (feedbackEvent.contexts && feedbackEvent.contexts.feedback) feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
    }
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $c466418904831ddc$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($c466418904831ddc$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $c466418904831ddc$var$createMemoryEntry($c466418904831ddc$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $c466418904831ddc$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: 'memory',
        name: 'memory',
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $c466418904831ddc$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = (0, $d180a652670457c1$export$831dc9f2ab0a617b)(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = (0, $d180a652670457c1$export$831dc9f2ab0a617b)(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
const $c466418904831ddc$var$NAVIGATOR = (0, $af8853bd97d114cc$export$f1a6cdb1459e81d1).navigator;
/**
 *  Disable sampling mousemove events on iOS browsers as this can cause blocking the main thread
 *  https://github.com/getsentry/sentry-javascript/issues/14534
 */ function $c466418904831ddc$var$getRecordingSamplingOptions() {
    if (/iPhone|iPad|iPod/i.test($c466418904831ddc$var$NAVIGATOR && $c466418904831ddc$var$NAVIGATOR.userAgent || '') || /Macintosh/i.test($c466418904831ddc$var$NAVIGATOR && $c466418904831ddc$var$NAVIGATOR.userAgent || '') && $c466418904831ddc$var$NAVIGATOR && $c466418904831ddc$var$NAVIGATOR.maxTouchPoints && $c466418904831ddc$var$NAVIGATOR.maxTouchPoints > 1) return {
        sampling: {
            mousemove: false
        }
    };
    return {};
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $c466418904831ddc$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.warn('Received replay event after session expired.');
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) $c466418904831ddc$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === 'buffer' && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!$c466418904831ddc$var$addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            const session = replay.session;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time. We have an experimental mode
            // to perform multiple checkouts a session (the idea is to improve
            // seeking during playback), so also only include if segmentId is 0
            // (handled in `addSettingsEvent`).
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $c466418904831ddc$var$addSettingsEvent(replay, isCheckout);
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === 'buffer' && session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.info(`Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`);
                    session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $c466418904831ddc$var$saveSession(session);
                }
            }
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (session && session.previousSessionId) return true;
            if (replay.recordingMode === 'session') // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $c466418904831ddc$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $c466418904831ddc$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: 'options',
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === 'worker' : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $c466418904831ddc$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    $c466418904831ddc$var$addEventSync(replay, $c466418904831ddc$var$createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $c466418904831ddc$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $1420d5a25389549d$export$f93f7f385160c44e)((0, $1420d5a25389549d$export$92b6093782fe661b)(replayEvent, (0, $1420d5a25389549d$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: 'replay_event'
            },
            replayEvent
        ],
        [
            {
                type: 'replay_recording',
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === 'string' ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $c466418904831ddc$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === 'string') payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $c466418904831ddc$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client._integrations === 'object' && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    client.emit('preprocessEvent', event, eventHint);
    const preparedEvent = await (0, $1708e90023694d2b$export$2d67fb380bd11267)(client.getOptions(), event, eventHint, scope, client, (0, $a383148e3fcc828a$export$68f3af03034c9e90)());
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || 'javascript';
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata();
    const { name: name, version: version } = metadata && metadata.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || 'sentry.javascript.unknown',
        version: version || '0.0.0'
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $c466418904831ddc$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $c466418904831ddc$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    const scope = (0, $a383148e3fcc828a$export$c7be4b0125a10cba)();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return (0, $c133b3629f3b6130$export$1fda8aa4d135f8aa)({});
    const baseEvent = {
        type: $c466418904831ddc$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $c466418904831ddc$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent('event_processor', 'replay', baseEvent);
        $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.info('An event processor returned `null`, will not send event.');
        return (0, $c133b3629f3b6130$export$1fda8aa4d135f8aa)({});
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $c466418904831ddc$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($c466418904831ddc$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = err;
        } catch (e) {
        // nothing to do
        }
        throw error;
    }
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === 'number' && (response.statusCode < 200 || response.statusCode >= 300)) throw new $c466418904831ddc$var$TransportStatusCodeError(response.statusCode);
    const rateLimits = (0, $08e9c02052b869f6$export$699aff705e0d49d4)({}, response);
    if ((0, $08e9c02052b869f6$export$6c91fec22056810a)(rateLimits, 'replay')) throw new $c466418904831ddc$var$RateLimitError(rateLimits);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $c466418904831ddc$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * This error indicates that we hit a rate limit API error.
 */ class $c466418904831ddc$var$RateLimitError extends Error {
    constructor(rateLimits){
        super('Rate limit hit');
        this.rateLimits = rateLimits;
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $c466418904831ddc$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $c466418904831ddc$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, onError: onError } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $c466418904831ddc$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $c466418904831ddc$var$TransportStatusCodeError || err instanceof $c466418904831ddc$var$RateLimitError) throw err;
        // Capture error for every failed replay
        (0, $4af1b4aa86e906d6$export$2f04de43fe27971a)('Replays', {
            _retryCount: retryConfig.count
        });
        if (onError) onError(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $c466418904831ddc$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$c466418904831ddc$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            (0, $d180a652670457c1$export$831dc9f2ab0a617b)(async ()=>{
                try {
                    await $c466418904831ddc$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $c466418904831ddc$var$THROTTLED = '__THROTTLED';
const $c466418904831ddc$var$SKIPPED = '__SKIPPED';
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c466418904831ddc$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $c466418904831ddc$var$SKIPPED : $c466418904831ddc$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $c466418904831ddc$var$ReplayContainer {
    /**
   * Recording can happen in one of two modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active span.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /** The replay has to be manually started, because no sample rate (neither session or error) was provided. */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ /**
   * Internal use for canvas recording options
   */ constructor({ options: options, recordingOptions: recordingOptions }){
        $c466418904831ddc$var$ReplayContainer.prototype.__init.call(this);
        $c466418904831ddc$var$ReplayContainer.prototype.__init2.call(this);
        $c466418904831ddc$var$ReplayContainer.prototype.__init3.call(this);
        $c466418904831ddc$var$ReplayContainer.prototype.__init4.call(this);
        $c466418904831ddc$var$ReplayContainer.prototype.__init5.call(this);
        $c466418904831ddc$var$ReplayContainer.prototype.__init6.call(this);
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = 'session';
        this.timeouts = {
            sessionIdlePause: $c466418904831ddc$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $c466418904831ddc$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._requiresManualStart = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ''
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $c466418904831ddc$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $c466418904831ddc$var$throttle((event, isCheckout)=>$c466418904831ddc$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($c466418904831ddc$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $c466418904831ddc$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(',') : ''
        } : undefined;
        if (slowClickConfig) this.clickDetector = new $c466418904831ddc$var$ClickDetector(this, slowClickConfig);
        // Configure replay logger w/ experimental options
        if ($c466418904831ddc$var$DEBUG_BUILD) {
            const experiments = options._experiments;
            $c466418904831ddc$var$logger.setConfig({
                captureExceptions: !!experiments.captureExceptions,
                traceInternals: !!experiments.traceInternals
            });
        }
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /** A wrapper to conditionally capture exceptions. */ handleException(error) {
        $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.exception(error);
        if (this._options.onError) this._options.onError(error);
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        const requiresManualStart = errorSampleRate <= 0 && sessionSampleRate <= 0;
        this._requiresManualStart = requiresManualStart;
        if (requiresManualStart) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            // This should not happen, something wrong has occurred
            $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.exception(new Error('Unable to initialize and create session'));
            return;
        }
        if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        // If segmentId > 0, it means we've previously already captured this session
        // In this case, we still want to continue in `session` recording mode
        this.recordingMode = this.session.sampled === 'buffer' && this.session.segmentId === 0 ? 'buffer' : 'session';
        $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.infoTick(`Starting replay in ${this.recordingMode} mode`);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === 'session') {
            $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.info('Recording is already in progress');
            return;
        }
        if (this._isEnabled && this.recordingMode === 'buffer') {
            $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.info('Buffering is in progress, call `flush()` to save the replay');
            return;
        }
        $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.infoTick('Starting replay in session mode');
        // Required as user activity is initially set in
        // constructor, so if `start()` is called after
        // session idle expiration, a replay will not be
        // created due to an idle timeout.
        this._updateUserActivity();
        const session = $c466418904831ddc$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) {
            $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.info('Buffering is in progress, call `flush()` to save the replay');
            return;
        }
        $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.infoTick('Starting replay in buffer mode');
        const session = $c466418904831ddc$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = 'buffer';
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $c466418904831ddc$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === 'buffer' ? {
                    checkoutEveryNms: $c466418904831ddc$var$BUFFER_CHECKOUT_TIME
                } : // This is to improve playback seeking as there could potentially be
                // less mutations to process in the worse cases.
                //
                // checkout by "N" events is probably ideal, but means we have less
                // control about the number of checkouts we make (which generally
                // increases replay size)
                this._options._experiments.continuousCheckout && {
                    // Minimum checkout time is 6 minutes
                    checkoutEveryNms: Math.max(360000, this._options._experiments.continuousCheckout)
                },
                emit: $c466418904831ddc$var$getHandleRecordingEmit(this),
                ...$c466418904831ddc$var$getRecordingSamplingOptions(),
                onMutation: this._onMutationHandler,
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this.handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        // We can't move `_isEnabled` after awaiting a flush, otherwise we can
        // enter into an infinite loop when `stop()` is called while flushing.
        this._isEnabled = false;
        try {
            $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.info(`Stopping Replay${reason ? ` triggered by ${reason}` : ''}`);
            $c466418904831ddc$var$resetReplayIdOnDynamicSamplingContext();
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (forceFlush) await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer && this.eventBuffer.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $c466418904831ddc$var$clearSession(this);
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.info('Pausing replay');
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.info('Resuming replay');
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === 'session') return this.flushImmediate();
        const activityTime = Date.now();
        $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.info('Converting buffer to session');
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === 'session') return;
        // Re-start recording in session-mode
        this.recordingMode = 'session';
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === 'buffer') return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._checkSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === 'buffer') return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of multiple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current session (=replay) ID */ getSessionId() {
        return this.session && this.session.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $c466418904831ddc$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === 'session') {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._checkSession()) // Check session handles the refreshing itself
        return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$c466418904831ddc$var$WINDOW.location.pathname}${$c466418904831ddc$var$WINDOW.location.hash}${$c466418904831ddc$var$WINDOW.location.search}`;
        const url = `${$c466418904831ddc$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $c466418904831ddc$var$THROTTLED) {
            const breadcrumb = $c466418904831ddc$var$createBreadcrumb({
                category: 'replay.throttled'
            });
            this.addUpdate(()=>{
                // Return `false` if the event _was_ added, as that means we schedule a flush
                return !$c466418904831ddc$var$addEventSync(this, {
                    type: $c466418904831ddc$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: 'breadcrumb',
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        const lastActiveSpan = this.lastActiveSpan || (0, $e228aefa610f8d34$export$1be426a8e585c83e)();
        const lastRootSpan = lastActiveSpan && (0, $e228aefa610f8d34$export$c4c6a79b1260ca1b)(lastActiveSpan);
        const attributes = lastRootSpan && (0, $e228aefa610f8d34$export$92d8c23565496537)(lastRootSpan).data || {};
        const source = attributes[0, $01d0eacec09c488a$export$d7a7d984b0791405];
        if (!lastRootSpan || !source || ![
            'route',
            'custom'
        ].includes(source)) return undefined;
        return (0, $e228aefa610f8d34$export$92d8c23565496537)(lastRootSpan).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $c466418904831ddc$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this._isPaused = false;
        this.startRecording();
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        // Whenever there is _any_ error sample rate, we always allow buffering
        // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $c466418904831ddc$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        // If there is no session yet, we do not want to refresh anything
        // This should generally not happen, but to be safe....
        if (!this.session) return false;
        const currentSession = this.session;
        if ($c466418904831ddc$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: 'refresh session'
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $c466418904831ddc$var$WINDOW.document.addEventListener('visibilitychange', this._handleVisibilityChange);
            $c466418904831ddc$var$WINDOW.addEventListener('blur', this._handleWindowBlur);
            $c466418904831ddc$var$WINDOW.addEventListener('focus', this._handleWindowFocus);
            $c466418904831ddc$var$WINDOW.addEventListener('keydown', this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $c466418904831ddc$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this.handleException(err);
        }
        this._performanceCleanupCallback = $c466418904831ddc$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $c466418904831ddc$var$WINDOW.document.removeEventListener('visibilitychange', this._handleVisibilityChange);
            $c466418904831ddc$var$WINDOW.removeEventListener('blur', this._handleWindowBlur);
            $c466418904831ddc$var$WINDOW.removeEventListener('focus', this._handleWindowFocus);
            $c466418904831ddc$var$WINDOW.removeEventListener('keydown', this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ __init() {
        this._handleVisibilityChange = ()=>{
            if ($c466418904831ddc$var$WINDOW.document.visibilityState === 'visible') this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
    }
    /**
   * Handle when page is blurred
   */ __init2() {
        this._handleWindowBlur = ()=>{
            const breadcrumb = $c466418904831ddc$var$createBreadcrumb({
                category: 'ui.blur'
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
    }
    /**
   * Handle when page is focused
   */ __init3() {
        this._handleWindowFocus = ()=>{
            const breadcrumb = $c466418904831ddc$var$createBreadcrumb({
                category: 'ui.focus'
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
    }
    /** Ensure page remains active when a key is pressed. */ __init4() {
        this._handleKeyboardEvent = (event)=>{
            $c466418904831ddc$var$handleKeyboardEvent(this, event);
        };
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $c466418904831ddc$var$isSessionExpired(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) return;
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.info('Document has become active, but session has expired');
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.throttledAddEvent({
                type: $c466418904831ddc$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: 'breadcrumb',
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        let performanceEntries = $c466418904831ddc$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // If we are manually starting, we want to ensure we only include performance entries
        // that are after the initial timestamp
        // The reason for this is that we may have performance entries from the page load, but may decide to start
        // the replay later on, in which case we do not want to include these entries.
        // without this, manually started replays can have events long before the actual replay recording starts,
        // which messes with the timeline etc.
        if (this._requiresManualStart) {
            const initialTimestampInSeconds = this._context.initialTimestamp / 1000;
            performanceEntries = performanceEntries.filter((entry)=>entry.start >= initialTimestampInSeconds);
        }
        return Promise.all($c466418904831ddc$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        // If replay was started manually (=no sample rate was given),
        // We do not want to back-port the initial timestamp
        if (!session || !eventBuffer || this._requiresManualStart) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.error('No session or eventBuffer found to flush.');
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer || !this.eventBuffer.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $c466418904831ddc$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
        if (replayId !== this.getSessionId()) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            // Check total duration again, to avoid sending outdated stuff
            // We leave 30s wiggle room to accommodate late flushing etc.
            // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new Error('Session is too long, not sending replay');
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            await $c466418904831ddc$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                timestamp: timestamp,
                onError: (err)=>this.handleException(err)
            });
        } catch (err) {
            this.handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: 'sendReplay'
            });
            const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
            if (client) {
                const dropReason = err instanceof $c466418904831ddc$var$RateLimitError ? 'ratelimit_backoff' : 'send_error';
                client.recordDroppedEvent(dropReason, 'replay');
            }
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ __init5() {
        this._flush = async ({ force: force = false } = {})=>{
            if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
            return;
            if (!this.checkAndHandleExpiredSession()) {
                $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.error('Attempting to finish replay event after session expired.');
                return;
            }
            if (!this.session) // should never happen, as we would have bailed out before
            return;
            const start = this.session.started;
            const now = Date.now();
            const duration = now - start;
            // A flush is about to happen, cancel any queued flushes
            this._debouncedFlush.cancel();
            // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
            // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
            const tooShort = duration < this._options.minReplayDuration;
            const tooLong = duration > this._options.maxReplayDuration + 5000;
            if (tooShort || tooLong) {
                $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.info(`Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? 'short' : 'long'}, not sending replay.`);
                if (tooShort) this._debouncedFlush();
                return;
            }
            const eventBuffer = this.eventBuffer;
            if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $c466418904831ddc$var$DEBUG_BUILD && $c466418904831ddc$var$logger.info('Flushing initial segment without checkout.');
            const _flushInProgress = !!this._flushLock;
            // this._flushLock acts as a lock so that future calls to `_flush()` will
            // be blocked until current flush is finished (i.e. this promise resolves)
            if (!this._flushLock) this._flushLock = this._runFlush();
            try {
                await this._flushLock;
            } catch (err) {
                this.handleException(err);
            } finally{
                this._flushLock = undefined;
                if (_flushInProgress) // Wait for previous flush to finish, then call the debounced
                // `_flush()`. It's possible there are other flush requests queued and
                // waiting for it to resolve. We want to reduce all outstanding
                // requests (as well as any new flush requests that occur within a
                // second of the locked flush completing) into a single flush.
                this._debouncedFlush();
            }
        };
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $c466418904831ddc$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ __init6() {
        this._onMutationHandler = (mutations)=>{
            const count = mutations.length;
            const mutationLimit = this._options.mutationLimit;
            const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
            const overMutationLimit = mutationLimit && count > mutationLimit;
            // Create a breadcrumb if a lot of mutations happen at the same time
            // We can show this in the UI as an information with potential performance improvements
            if (count > mutationBreadcrumbLimit || overMutationLimit) {
                const breadcrumb = $c466418904831ddc$var$createBreadcrumb({
                    category: 'replay.mutations',
                    data: {
                        count: count,
                        limit: overMutationLimit
                    }
                });
                this._createCustomBreadcrumb(breadcrumb);
            }
            // Stop replay if over the mutation limit
            if (overMutationLimit) {
                // This should never reject
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.stop({
                    reason: 'mutationLimit',
                    forceFlush: this.recordingMode === 'session'
                });
                return false;
            }
            // `true` means we use the regular mutation handling by rrweb
            return true;
        };
    }
}
function $c466418904831ddc$var$getOption(selectors, defaultSelectors) {
    return [
        ...selectors,
        // sentry defaults
        ...defaultSelectors
    ].join(',');
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $c466418904831ddc$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore }) {
    const defaultBlockedElements = [
        'base',
        'iframe[srcdoc]:not([src])'
    ];
    const maskSelector = $c466418904831ddc$var$getOption(mask, [
        '.sentry-mask',
        '[data-sentry-mask]'
    ]);
    const unmaskSelector = $c466418904831ddc$var$getOption(unmask, []);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $c466418904831ddc$var$getOption(block, [
            '.sentry-block',
            '[data-sentry-block]',
            ...defaultBlockedElements
        ]),
        unblockSelector: $c466418904831ddc$var$getOption(unblock, []),
        ignoreSelector: $c466418904831ddc$var$getOption(ignore, [
            '.sentry-ignore',
            '[data-sentry-ignore]',
            'input[type="file"]'
        ])
    };
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function $c466418904831ddc$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precedence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === 'value' && el.tagName === 'INPUT' && [
        'submit',
        'button'
    ].includes(el.getAttribute('type') || '')) return value.replace(/[\S]/g, '*');
    return value;
}
const $c466418904831ddc$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $c466418904831ddc$var$DEFAULT_NETWORK_HEADERS = [
    'content-length',
    'content-type',
    'accept'
];
let $c466418904831ddc$var$_initialized = false;
/**
 * Sentry integration for [Session Replay](https://sentry.io/for/session-replay/).
 *
 * See the [Replay documentation](https://docs.sentry.io/platforms/javascript/guides/session-replay/) for more information.
 *
 * @example
 *
 * ```
 * Sentry.init({
 *   dsn: '__DSN__',
 *   integrations: [Sentry.replayIntegration()],
 * });
 * ```
 */ const $c466418904831ddc$export$d7706faf7ab354bf = (options)=>{
    return new $c466418904831ddc$var$Replay(options);
};
/**
 * Replay integration
 *
 * TODO: Rewrite this to be functional integration
 * Exported for tests.
 */ class $c466418904831ddc$var$Replay {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Replay';
    }
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $c466418904831ddc$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $c466418904831ddc$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $c466418904831ddc$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $c466418904831ddc$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 10000, slowClickTimeout: slowClickTimeout = 7000, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        'title',
        'placeholder'
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling, onError: onError } = {}){
        this.name = $c466418904831ddc$var$Replay.id;
        const privacyOptions = $c466418904831ddc$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$c466418904831ddc$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: 'all',
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            }
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $c466418904831ddc$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $c466418904831ddc$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $c466418904831ddc$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $c466418904831ddc$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            onError: onError,
            _experiments: _experiments
        };
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $c466418904831ddc$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$c466418904831ddc$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && (0, $55b6076a1a1e5b18$export$4e09c449d6c407f7)()) throw new Error('Multiple Sentry Session Replay instances are not supported');
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $c466418904831ddc$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $c466418904831ddc$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ afterAllSetup(client) {
        if (!(0, $55b6076a1a1e5b18$export$4e09c449d6c407f7)() || this._replay) return;
        this._setup(client);
        this._initialize(client);
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === 'session'
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * If replay is not enabled, a new session replay is started.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay) return Promise.resolve();
        // assuming a session should be recorded in this case
        if (!this._replay.isEnabled()) {
            this._replay.start();
            return Promise.resolve();
        }
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Get the current recording mode. This can be either `session` or `buffer`.
   *
   * `session`: Recording the whole session, sending it continuously
   * `buffer`: Always keeping the last 60s of recording, requires:
   *   - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *   - or calling `flush()` to send the replay
   */ getRecordingMode() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.recordingMode;
    }
    /**
   * Initializes replay.
   */ _initialize(client) {
        if (!this._replay) return;
        this._maybeLoadFromReplayCanvasIntegration(client);
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup(client) {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $c466418904831ddc$var$loadReplayOptionsFromClient(this._initialOptions, client);
        this._replay = new $c466418904831ddc$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration(client) {
        // To save bundle size, we skip checking for stuff here
        // and instead just try-catch everything - as generally this should all be defined
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
            const canvasIntegration = client.getIntegrationByName('ReplayCanvas');
            if (!canvasIntegration) return;
            this._replay['_canvas'] = canvasIntegration.getOptions();
        } catch (e) {
        // ignore errors here
        }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
}
$c466418904831ddc$var$Replay.__initStatic();
/** Parse Replay-related options from SDK options */ function $c466418904831ddc$var$loadReplayOptionsFromClient(initialOptions, client) {
    const opt = client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...(0, $9d45b9df9881c412$export$d25f2688db1bb433)(initialOptions)
    };
    const replaysSessionSampleRate = (0, $783dda70189181e4$export$a5bd2d81656d9546)(opt.replaysSessionSampleRate);
    const replaysOnErrorSampleRate = (0, $783dda70189181e4$export$a5bd2d81656d9546)(opt.replaysOnErrorSampleRate);
    if (replaysSessionSampleRate == null && replaysOnErrorSampleRate == null) (0, $2c5c4ba32bebd8b3$export$cda52e2a8927a2ca)(()=>{
        // eslint-disable-next-line no-console
        console.warn('Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.');
    });
    if (replaysSessionSampleRate != null) finalOptions.sessionSampleRate = replaysSessionSampleRate;
    if (replaysOnErrorSampleRate != null) finalOptions.errorSampleRate = replaysOnErrorSampleRate;
    return finalOptions;
}
function $c466418904831ddc$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$c466418904831ddc$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ function $c466418904831ddc$export$b28310b2f161456b() {
    const client = (0, $a383148e3fcc828a$export$6bb76d6eba7e258c)();
    return client && client.getIntegrationByName('Replay');
}



const $77b0f1c8a5c7f48e$var$clientUrl = (0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.url.toLowerCase();
if (!$77b0f1c8a5c7f48e$var$clientUrl.includes('localhost') && !$77b0f1c8a5c7f48e$var$clientUrl.includes('127.0.0.1')) $cd544be01d6a9a10$export$2cd8252107eb640b({
    integrations: [
        // See docs for support of different versions of variation of react router
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
        $931cb46b11381d85$export$47113a480541ff59({
            useEffect: $2xPiy.useEffect,
            useLocation: $62d58f5c28b15c2e$export$45d76561a5302f2b,
            useNavigationType: $62d58f5c28b15c2e$export$1b3f31771c5d07c,
            createRoutesFromChildren: $62d58f5c28b15c2e$export$16da398f5434bdec,
            matchRoutes: $28152332635c962a$export$2708184779ceb39d
        }),
        $c466418904831ddc$export$d7706faf7ab354bf()
    ],
    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [
        /^\//,
        /^https:\/\/app\.usefuse\.com\//
    ],
    environment: "development",
    ...(0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).sentry
});




var $2xPiy = parcelRequire("2xPiy");







var $2xPiy = parcelRequire("2xPiy");










var $2xPiy = parcelRequire("2xPiy");

function $f314301545705a3f$var$_extends() {
    return $f314301545705a3f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f314301545705a3f$var$_extends.apply(null, arguments);
}
var $f314301545705a3f$export$e19cd5f9376f8cee = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $f314301545705a3f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Action"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m1 23 3-3-3 3zM20 4l3-3-3 3zM9 11l3-3-3 3zm4 4 3-3-3 3zM10 5l9 9 1-1c2-2 4.053-5 0-9s-7-2-9 0l-1 1zm-6 6 1-1 9 9-1 1c-2 2-5 4.087-9 0s-2-7 0-9z"
    }));
});
$f314301545705a3f$export$e19cd5f9376f8cee.displayName = 'Action';


var $2xPiy = parcelRequire("2xPiy");

function $2b7043a72f07c0fd$var$_extends() {
    return $2b7043a72f07c0fd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2b7043a72f07c0fd$var$_extends.apply(null, arguments);
}
var $2b7043a72f07c0fd$export$770682f56f7e9e8f = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $2b7043a72f07c0fd$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Calculator"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M22 23H2V1h20v22zm-6-6h2v2h-2v-2zm-5 0h2v2h-2v-2zm5-5h2v2h-2v-2zm-5 0h2v2h-2v-2zm-5 5h2v2H6v-2zm0-5h2v2H6v-2zm12-3H6V5h12v4z"
    }));
});
$2b7043a72f07c0fd$export$770682f56f7e9e8f.displayName = 'Calculator';


var $2xPiy = parcelRequire("2xPiy");

function $b70fce9e025404e3$var$_extends() {
    return $b70fce9e025404e3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b70fce9e025404e3$var$_extends.apply(null, arguments);
}
var $b70fce9e025404e3$export$9141d115599e4e05 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $b70fce9e025404e3$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentUpload"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2.998 1H17.5L21 4.5V23H3L2.998 1zM16 1v5h5m-9 14v-9m-4 3 4-4 4 4"
    }));
});
$b70fce9e025404e3$export$9141d115599e4e05.displayName = 'DocumentUpload';


var $2xPiy = parcelRequire("2xPiy");

function $45a461ce0671135b$var$_extends() {
    return $45a461ce0671135b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $45a461ce0671135b$var$_extends.apply(null, arguments);
}
var $45a461ce0671135b$export$e1dae5660003ffa7 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $45a461ce0671135b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "System"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 19h22V1H1v18zm4 4h14H5zm3 0h8v-4H8v4zM7.757 5.757l2.122 2.122-2.122-2.122zM9 10H6h3zm.879 2.121-2.122 2.122 2.122-2.122zM12 13v3-3zm2.121-.879 2.122 2.122-2.122-2.122zM18 10h-3 3zm-1.757-4.243-2.122 2.122 2.122-2.122zM12 7V4v3zm0 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
    }));
});
$45a461ce0671135b$export$e1dae5660003ffa7.displayName = 'System';




const $531f50b0ef9e074f$var$AdminSideNav = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    const location = (0, $62d58f5c28b15c2e$export$45d76561a5302f2b)();
    const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const navItems = [
        {
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $45a461ce0671135b$export$e1dae5660003ffa7), {
                color: "dark-3",
                size: "20px"
            }),
            label: 'Dashboard',
            path: '/fuse-admin'
        },
        {
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b70fce9e025404e3$export$9141d115599e4e05), {
                color: "dark-3",
                size: "20px"
            }),
            label: 'Importer',
            path: '/fuse-admin/importer'
        },
        {
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d9150df54021eb88$export$94aefc399ef206a9), {
                color: "dark-3",
                size: "20px"
            }),
            label: 'Credit Pricing',
            path: '/fuse-admin/credit-pricing'
        },
        {
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2b7043a72f07c0fd$export$770682f56f7e9e8f), {
                color: "dark-3",
                size: "20px"
            }),
            label: 'Credit Calculation',
            path: '/fuse-admin/credit-calculation'
        },
        {
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $77ee8bc744382cac$export$eb2fcfdbd7ba97d4), {
                color: "dark-3",
                size: "20px"
            }),
            label: 'Referral Partners',
            path: '/fuse-admin/referral-partners'
        },
        {
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f314301545705a3f$export$e19cd5f9376f8cee), {
                color: "dark-3",
                size: "20px"
            }),
            label: 'Charging Networks',
            path: '/fuse-admin/charging-networks'
        }
    ];
    const isActive = (path)=>{
        return location.pathname === path;
    };
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        width: "260px",
        background: "white",
        elevation: "none",
        pad: {
            vertical: 'medium'
        },
        border: {
            color: 'light-4',
            size: 'px'
        },
        children: navItems.map((item)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                pad: {
                    horizontal: 'medium',
                    vertical: 'small'
                },
                background: isActive(item.path) ? {
                    color: 'light-4',
                    opacity: 'strong'
                } : 'white',
                onClick: ()=>navigate(item.path),
                hoverIndicator: {
                    color: 'light-4',
                    opacity: 'strong'
                },
                direction: "row",
                align: "center",
                gap: "medium",
                round: "small",
                margin: {
                    vertical: '3px',
                    horizontal: 'small'
                },
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        width: "24px",
                        align: "center",
                        children: item.icon
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        color: "dark-1",
                        size: "medium",
                        weight: isActive(item.path) ? 500 : 'normal',
                        children: item.label
                    })
                ]
            }, item.label))
    });
});
var $531f50b0ef9e074f$export$2e2bcd8739ae039 = $531f50b0ef9e074f$var$AdminSideNav;





const $cebfdf44a3b436b1$var$FuseAdminChargingNetworks = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    const [searchQuery, setSearchQuery] = (0, $2xPiy.useState)('');
    const [chargingNetworks, setChargingNetworks] = (0, $2xPiy.useState)([]);
    const [filteredChargingNetworks, setFilteredChargingNetworks] = (0, $2xPiy.useState)([]);
    const [currentPage, setCurrentPage] = (0, $2xPiy.useState)(1);
    const itemsPerPage = 10;
    const [isLoading, setIsLoading] = (0, $2xPiy.useState)(true);
    const [isModalVisible, setIsModalVisible] = (0, $2xPiy.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $2xPiy.useState)(false);
    const [nameError, setNameError] = (0, $2xPiy.useState)('');
    const [formData, setFormData] = (0, $2xPiy.useState)({
        name: ''
    });
    (0, $2xPiy.useEffect)(()=>{
        fetchChargingNetworks();
    }, []);
    (0, $2xPiy.useEffect)(()=>{
        if (searchQuery.trim() === '') setFilteredChargingNetworks(chargingNetworks);
        else {
            const query = searchQuery.toLowerCase();
            const filtered = chargingNetworks.filter((network)=>network.name.toLowerCase().includes(query));
            setFilteredChargingNetworks(filtered);
        }
        setCurrentPage(1);
    }, [
        searchQuery,
        chargingNetworks
    ]);
    const fetchChargingNetworks = async ()=>{
        try {
            setIsLoading(true);
            const networks = await (0, $ab4a6d5758e27442$export$228f07cb35da672b).listChargingNetworks();
            setChargingNetworks(networks);
            setFilteredChargingNetworks(networks);
        } catch (err) {
            console.error('Error fetching charging networks:', err);
        } finally{
            setIsLoading(false);
        }
    };
    const handleSearch = (query)=>{
        setSearchQuery(query);
    };
    const paginatedChargingNetworks = filteredChargingNetworks.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    const handleSubmit = async ()=>{
        if (!formData.name.trim()) {
            setNameError('Charging network name is required');
            (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).createChargingNetwork.requiredFields);
            return;
        }
        try {
            setIsSubmitting(true);
            await (0, $ab4a6d5758e27442$export$228f07cb35da672b).create(formData);
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).createChargingNetwork.success);
            setIsModalVisible(false);
            setFormData({
                name: ''
            });
            setNameError('');
            fetchChargingNetworks();
        } catch (error) {
            console.error('Error creating charging network:', error);
            (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).createChargingNetwork.error(error));
        } finally{
            setIsSubmitting(false);
        }
    };
    const handleCloseModal = ()=>{
        setIsModalVisible(false);
        setFormData({
            name: ''
        });
        setNameError('');
    };
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        height: {
            min: '100vh'
        },
        background: "light",
        style: {
            display: 'flex',
            flexDirection: 'column'
        },
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c3e91fa8212c6d4c$export$50d7b5e01df871ca), {}),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                flex: "grow",
                style: {
                    display: 'flex',
                    flexDirection: 'row',
                    minHeight: 0
                },
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $531f50b0ef9e074f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        flex: "grow",
                        pad: {
                            horizontal: 'large',
                            vertical: 'medium'
                        },
                        overflow: "auto",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            flex: false,
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    direction: "row",
                                    align: "center",
                                    justify: "between",
                                    margin: {
                                        vertical: 'medium'
                                    },
                                    pad: {
                                        horizontal: 'small'
                                    },
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "xlarge",
                                        weight: "normal",
                                        children: "Charging Networks"
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    align: "end",
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                        primary: true,
                                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b354176c7fc1b147$export$d0265b2c425512d6), {}),
                                        label: "Add Charging Network",
                                        onClick: ()=>setIsModalVisible(true),
                                        style: {
                                            borderRadius: '8px',
                                            fontWeight: 'normal'
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
                                    margin: {
                                        vertical: 'small'
                                    },
                                    background: "white",
                                    elevation: "none",
                                    round: "xsmall",
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                                            title: "Charging Network List",
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                flex: "grow",
                                                align: "end",
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f7f71094d2af306c$export$55d7609a8f1eccd2), {
                                                    searchQuery: searchQuery,
                                                    setSearchQuery: setSearchQuery,
                                                    onSearch: handleSearch,
                                                    placeholder: "Search CNO/CMS..."
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                                            pad: "none",
                                            children: isLoading ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                pad: "large",
                                                align: "center",
                                                justify: "center",
                                                height: "200px",
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {})
                                            }) : chargingNetworks.length === 0 ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                pad: "large",
                                                align: "center",
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    children: "No charging networks found"
                                                })
                                            }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
                                                        pad: {
                                                            horizontal: '1.5rem'
                                                        },
                                                        columns: [
                                                            {
                                                                property: 'name',
                                                                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                                    toUpperCase: true,
                                                                    children: "Charging Network Name"
                                                                }),
                                                                size: '70%',
                                                                render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                        pad: {
                                                                            vertical: '1rem'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                            children: datum.name
                                                                        })
                                                                    })
                                                            }
                                                        ],
                                                        data: paginatedChargingNetworks,
                                                        sortable: true,
                                                        background: [
                                                            'light-6',
                                                            'white'
                                                        ],
                                                        border: {
                                                            color: 'light-2',
                                                            side: 'bottom',
                                                            size: 'small'
                                                        }
                                                    }),
                                                    filteredChargingNetworks.length > itemsPerPage && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                        pad: {
                                                            horizontal: 'medium',
                                                            vertical: 'small'
                                                        },
                                                        align: "center",
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ffccbada2139938a$export$68f5e1453c188a82), {
                                                            alignSelf: "center",
                                                            size: "small",
                                                            page: currentPage,
                                                            onChange: ({ page: page })=>setCurrentPage(page),
                                                            step: itemsPerPage,
                                                            numberItems: filteredChargingNetworks.length
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                flex: false,
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $605617a28ba64070$export$3210cca7a959581e), {})
            }),
            isModalVisible && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
                position: "center",
                onEsc: handleCloseModal,
                onClickOutside: handleCloseModal,
                responsive: false,
                style: {
                    width: 'auto',
                    maxWidth: 'min(95vw, 500px)',
                    maxHeight: '95vh',
                    overflow: 'auto',
                    borderRadius: '8px'
                },
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
                    width: "100%",
                    style: {
                        width: '100%'
                    },
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                            title: "Add Charging Network"
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                            pad: {
                                vertical: 'medium',
                                horizontal: 'large'
                            },
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                gap: "medium",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        label: "Charging Network Name",
                                        value: formData.name,
                                        setValue: (value)=>{
                                            setFormData({
                                                ...formData,
                                                name: value
                                            });
                                            if (nameError) setNameError('');
                                        },
                                        placeholder: "Enter charging network name",
                                        required: true,
                                        error: nameError,
                                        style: {
                                            width: '100%'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                        direction: "row",
                                        gap: "small",
                                        justify: "end",
                                        margin: {
                                            top: 'small'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                                label: "Cancel",
                                                onClick: handleCloseModal,
                                                disabled: isSubmitting,
                                                style: {
                                                    fontWeight: 'normal'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                                primary: true,
                                                label: isSubmitting ? 'Creating...' : 'Create Charging Network',
                                                onClick: handleSubmit,
                                                disabled: isSubmitting,
                                                style: {
                                                    fontWeight: 'normal'
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
});
var $cebfdf44a3b436b1$export$2e2bcd8739ae039 = $cebfdf44a3b436b1$var$FuseAdminChargingNetworks;




var $2xPiy = parcelRequire("2xPiy");


var $2xPiy = parcelRequire("2xPiy");

function $cecd6f5af26913b4$var$_extends() {
    return $cecd6f5af26913b4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cecd6f5af26913b4$var$_extends.apply(null, arguments);
}
var $cecd6f5af26913b4$export$de5f40ff1ff419d2 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $cecd6f5af26913b4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Configure"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M16 15c4.009-.065 7-3.033 7-7 0-3.012-.997-2.015-2-1-.991.98-3 3-3 3l-4-4s2.02-2.009 3-3c1.015-1.003 1.015-2-1-2-3.967 0-6.947 2.991-7 7 .042.976 0 3 0 3-1.885 1.897-4.34 4.353-6 6-2.932 2.944 1.056 6.932 4 4 1.65-1.662 4.113-4.125 6-6 0 0 2.024-.042 3 0z"
    }));
});
$cecd6f5af26913b4$export$de5f40ff1ff419d2.displayName = 'Configure';




class $29a3c5a1cdce122b$export$81e326dd2a85ea21 {
    /**
   * List Program Broker Fee Rates
   * @returns ProgramBrokerFeeRate[]
   */ static list() {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/programBrokerFeeRates'
        });
    }
}



class $1b240282fc1c3198$export$5f8caabb338db875 {
    /**
   * List Program REC Cost
   * @returns ProgramRecCost[]
   */ static list() {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/programRecCosts'
        });
    }
}








const $4d33aa7df6cb1fa2$var$FuseAdminCredit = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    const dashboardStore = (0, $116967e0234c3770$export$176f58333fc13682)();
    const reportingPeriods = dashboardStore.dashboardData?.reporting_periods || [];
    const [currentQuarterIndex, setCurrentQuarterIndex] = (0, $2xPiy.useState)(0);
    const [brokerFeeRates, setBrokerFeeRates] = (0, $2xPiy.useState)([]);
    const [recCosts, setRecCosts] = (0, $2xPiy.useState)([]);
    const [allPrograms, setAllPrograms] = (0, $2xPiy.useState)([]);
    const [isLoadingPrograms, setIsLoadingPrograms] = (0, $2xPiy.useState)(true);
    const [isLoadingBrokerFees, setIsLoadingBrokerFees] = (0, $2xPiy.useState)(true);
    const [isLoadingRecCosts, setIsLoadingRecCosts] = (0, $2xPiy.useState)(true);
    const [isDashboardLoading, setIsDashboardLoading] = (0, $2xPiy.useState)(true);
    const quarters = (0, $2xPiy.useMemo)(()=>{
        const quarterStrings = reportingPeriods.map((p)=>p.reporting_period);
        return quarterStrings.sort((a, b)=>{
            const parseQuarter = (quarterStr)=>{
                const match = quarterStr.match(/Q(\d+)\s+(\d+)/);
                if (!match) return {
                    quarter: 0,
                    year: 0
                };
                return {
                    quarter: parseInt(match[1], 10),
                    year: parseInt(match[2], 10)
                };
            };
            const aParsed = parseQuarter(a);
            const bParsed = parseQuarter(b);
            if (bParsed.year !== aParsed.year) return bParsed.year - aParsed.year;
            return bParsed.quarter - aParsed.quarter;
        });
    }, [
        reportingPeriods
    ]);
    (0, $2xPiy.useEffect)(()=>{
        setIsDashboardLoading(true);
        const fetchDashboard = async ()=>{
            try {
                await dashboardStore.getAdminView();
            } finally{
                setIsDashboardLoading(false);
            }
        };
        fetchDashboard();
        return ()=>dashboardStore.clearDashboardData();
    }, []);
    (0, $2xPiy.useEffect)(()=>{
        setIsLoadingPrograms(true);
        setIsLoadingBrokerFees(true);
        setIsLoadingRecCosts(true);
        (0, $1b240282fc1c3198$export$5f8caabb338db875).list().then(setRecCosts).finally(()=>setIsLoadingRecCosts(false));
        (0, $29a3c5a1cdce122b$export$81e326dd2a85ea21).list().then(setBrokerFeeRates).finally(()=>setIsLoadingBrokerFees(false));
        (0, $06590284a0c4fd89$export$84ac2881c878ff18).list().then(setAllPrograms).finally(()=>setIsLoadingPrograms(false));
    }, []);
    (0, $2xPiy.useEffect)(()=>{
        if (quarters.length > 0 && currentQuarterIndex >= quarters.length) setCurrentQuarterIndex(0);
    }, [
        quarters.length,
        currentQuarterIndex
    ]);
    const currentQuarter = quarters[currentQuarterIndex] || '';
    const getMatchingRate = (programId)=>{
        const brokerFeeRate = brokerFeeRates.find((rate)=>rate.program_id === programId && (0, $00658ccd6ec0135a$export$e774cbf6b137c816)(rate.start_reporting_quarter) === currentQuarter);
        const recCost = recCosts.find((cost)=>cost.program_id === programId && (0, $00658ccd6ec0135a$export$e774cbf6b137c816)(cost.start_reporting_quarter) === currentQuarter);
        return {
            brokerFeeRate: brokerFeeRate ?? undefined,
            recCost: recCost ?? undefined
        };
    };
    const getMatchingProgram = (programName)=>{
        const period = reportingPeriods.find((p)=>p.reporting_period === currentQuarter);
        return period?.programs.find((p)=>p.name === programName);
    };
    const combinedProgramData = (0, $2xPiy.useMemo)(()=>allPrograms.map((program)=>{
            const matchingRate = getMatchingRate(program.id);
            const matchingProgram = getMatchingProgram(program.name);
            const formattedPercentRate = matchingRate.brokerFeeRate ? `${matchingRate.brokerFeeRate.percent_rate}%` : "\u2014";
            return {
                program_id: program.id,
                program_name: program.name,
                price: matchingProgram?.price_per_credit ?? "\u2014",
                broker_fee: formattedPercentRate,
                rec_fee: matchingRate.recCost ? `${matchingRate.recCost.cost}` : "\u2014",
                quarter: currentQuarter || "\u2014"
            };
        }), [
        allPrograms,
        brokerFeeRates,
        recCosts,
        reportingPeriods,
        currentQuarter
    ]);
    const isPricingAndFeesLoading = isLoadingPrograms || isLoadingBrokerFees || isLoadingRecCosts || isDashboardLoading;
    // Navigation
    const handlePrev = ()=>{
        setCurrentQuarterIndex((i)=>Math.min(i + 1, quarters.length - 1));
    };
    const handleNext = ()=>{
        setCurrentQuarterIndex((i)=>Math.max(i - 1, 0));
    };
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        height: {
            min: '100vh'
        },
        background: "light",
        style: {
            display: 'flex',
            flexDirection: 'column'
        },
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c3e91fa8212c6d4c$export$50d7b5e01df871ca), {}),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                flex: "grow",
                style: {
                    display: 'flex',
                    flexDirection: 'row',
                    minHeight: 0
                },
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $531f50b0ef9e074f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        flex: "grow",
                        pad: {
                            horizontal: 'large',
                            vertical: 'medium'
                        },
                        overflow: "auto",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            flex: false,
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    direction: "row",
                                    align: "center",
                                    justify: "between",
                                    margin: {
                                        vertical: 'medium'
                                    },
                                    pad: {
                                        horizontal: 'small'
                                    },
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "xlarge",
                                        weight: "normal",
                                        children: "Credit Pricing & Fees"
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    direction: "row",
                                    border: {
                                        color: 'light-4',
                                        size: '1px'
                                    },
                                    round: "medium",
                                    width: "160px",
                                    align: "center",
                                    justify: "between",
                                    pad: {
                                        horizontal: 'small',
                                        vertical: 'xsmall'
                                    },
                                    background: "light-4",
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                            onClick: currentQuarterIndex < quarters.length - 1 ? handlePrev : undefined,
                                            pad: "xsmall",
                                            style: {
                                                cursor: currentQuarterIndex < quarters.length - 1 ? 'pointer' : 'not-allowed',
                                                opacity: currentQuarterIndex < quarters.length - 1 ? 1 : 0.5
                                            },
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "small",
                                                children: "\u2190"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                            size: "small",
                                            weight: "bold",
                                            children: currentQuarter
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                            onClick: currentQuarterIndex > 0 ? handleNext : undefined,
                                            pad: "xsmall",
                                            style: {
                                                cursor: currentQuarterIndex > 0 ? 'pointer' : 'not-allowed',
                                                opacity: currentQuarterIndex > 0 ? 1 : 0.5
                                            },
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "small",
                                                children: "\u2192"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
                                    margin: {
                                        vertical: 'large'
                                    },
                                    background: "white",
                                    elevation: "none",
                                    round: "xsmall",
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                                            pad: {
                                                horizontal: 'medium',
                                                vertical: 'medium'
                                            },
                                            border: {
                                                side: 'bottom',
                                                color: 'light-4',
                                                size: '1px'
                                            },
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "large",
                                                weight: "normal",
                                                children: "Credit Pricing, Broker Fees, and REC Fees"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                                            pad: "none",
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                elevation: "small",
                                                children: isPricingAndFeesLoading ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                    height: "200px",
                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {})
                                                }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
                                                    pad: {
                                                        horizontal: '1.5rem'
                                                    },
                                                    columns: [
                                                        {
                                                            property: 'program_name',
                                                            primary: true,
                                                            size: '25%',
                                                            align: 'start',
                                                            verticalAlign: 'top',
                                                            header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                                toUpperCase: true,
                                                                children: "PROGRAM NAME"
                                                            }),
                                                            render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                    pad: {
                                                                        vertical: '1rem'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cecd6f5af26913b4$export$de5f40ff1ff419d2), {
                                                                            size: "small",
                                                                            color: "brand"
                                                                        }),
                                                                        children: datum.program_name
                                                                    })
                                                                })
                                                        },
                                                        {
                                                            property: 'price',
                                                            size: '20%',
                                                            align: 'start',
                                                            verticalAlign: 'top',
                                                            header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                                toUpperCase: true,
                                                                children: "CREDIT PRICE"
                                                            }),
                                                            render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                    pad: {
                                                                        vertical: '1rem'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                        children: datum.price === "\u2014" ? datum.price : `$${datum.price}`
                                                                    })
                                                                })
                                                        },
                                                        {
                                                            property: 'rec_fee',
                                                            size: '20%',
                                                            align: 'start',
                                                            verticalAlign: 'top',
                                                            header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                                toUpperCase: true,
                                                                children: "REC Price"
                                                            }),
                                                            render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                    pad: {
                                                                        vertical: '1rem'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                        children: datum.rec_fee === "\u2014" ? datum.rec_fee : `$${datum.rec_fee}`
                                                                    })
                                                                })
                                                        },
                                                        {
                                                            property: 'broker_fee',
                                                            size: '20%',
                                                            align: 'start',
                                                            verticalAlign: 'top',
                                                            header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                                toUpperCase: true,
                                                                subText: "(Percent Rate)",
                                                                children: "BROKER FEE"
                                                            }),
                                                            render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                    pad: {
                                                                        vertical: '1rem'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                        children: datum.broker_fee
                                                                    })
                                                                })
                                                        },
                                                        {
                                                            property: 'quarter',
                                                            size: '15%',
                                                            align: 'start',
                                                            verticalAlign: 'top',
                                                            header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                                toUpperCase: true,
                                                                children: "QUARTER"
                                                            }),
                                                            render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                    pad: {
                                                                        vertical: '1rem'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                        children: datum.quarter
                                                                    })
                                                                })
                                                        }
                                                    ],
                                                    data: combinedProgramData,
                                                    background: [
                                                        'light-6',
                                                        'white'
                                                    ],
                                                    border: {
                                                        color: 'light-2',
                                                        side: 'bottom',
                                                        size: 'small'
                                                    }
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                flex: false,
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $605617a28ba64070$export$3210cca7a959581e), {})
            })
        ]
    });
});
var $4d33aa7df6cb1fa2$export$2e2bcd8739ae039 = $4d33aa7df6cb1fa2$var$FuseAdminCredit;









var $2xPiy = parcelRequire("2xPiy");







var $2xPiy = parcelRequire("2xPiy");




const $21fbb75a7acf588a$export$dda10b5589fa05d4 = ({ status: status, logLines: logLines, updatedCount: updatedCount, failureMessage: failureMessage, onCancel: onCancel })=>{
    const logContainerRef = (0, $2xPiy.useRef)(null);
    const isPinnedToBottomRef = (0, $2xPiy.useRef)(true);
    const handleLogScroll = ()=>{
        const logContainer = logContainerRef.current;
        if (logContainer) {
            const distanceFromBottom = logContainer.scrollHeight - logContainer.scrollTop - logContainer.clientHeight;
            isPinnedToBottomRef.current = distanceFromBottom < 40;
        }
    };
    (0, $2xPiy.useEffect)(()=>{
        const logContainer = logContainerRef.current;
        if (logContainer && isPinnedToBottomRef.current) logContainer.scrollTop = logContainer.scrollHeight;
    }, [
        logLines.length
    ]);
    if (status === 'idle' || status === 'submitting') return null;
    const statusBadge = (()=>{
        switch(status){
            case 'done':
                return {
                    text: `Done \u{2014} ${updatedCount} equipment usages updated`,
                    color: 'status-ok',
                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $24b518a2732bce28$export$4f481e0a96cfbed6), {
                        size: "small",
                        color: "status-ok"
                    })
                };
            case 'failed':
                return {
                    text: failureMessage,
                    color: 'status-critical',
                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c1da19823027de53$export$f39c2d165cd861fe), {
                        size: "small",
                        color: "status-critical"
                    })
                };
            case 'cancelled':
                return {
                    text: "Cancelled \u2014 no changes were saved",
                    color: 'dark-2',
                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c1da19823027de53$export$f39c2d165cd861fe), {
                        size: "small",
                        color: "dark-2"
                    })
                };
            default:
                return null;
        }
    })();
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
        margin: {
            vertical: 'medium'
        },
        background: "white",
        elevation: "none",
        round: "xsmall",
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                pad: {
                    horizontal: 'medium',
                    vertical: 'medium'
                },
                border: {
                    side: 'bottom',
                    color: 'light-4',
                    size: '1px'
                },
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    direction: "row",
                    align: "center",
                    gap: "small",
                    fill: "horizontal",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            direction: "row",
                            align: "center",
                            gap: "small",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    size: "large",
                                    weight: "normal",
                                    children: "Calculation Log"
                                }),
                                status === 'running' && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    direction: "row",
                                    align: "center",
                                    gap: "xsmall",
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8bec6e2e7dc53c4a$export$7f7cbe89f1eacd2), {
                                            size: "xsmall"
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                            size: "small",
                                            color: "dark-2",
                                            children: "Running..."
                                        })
                                    ]
                                }),
                                statusBadge !== null && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    direction: "row",
                                    align: "center",
                                    gap: "xsmall",
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                            size: "small",
                                            color: statusBadge.color,
                                            children: statusBadge.text
                                        }),
                                        statusBadge.icon
                                    ]
                                })
                            ]
                        }),
                        status === 'running' && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                            size: "small",
                            label: "Cancel",
                            style: {
                                fontWeight: 'normal',
                                borderRadius: '6px'
                            },
                            onClick: onCancel
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                pad: "medium",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                    ref: logContainerRef,
                    onScroll: handleLogScroll,
                    height: {
                        max: '400px'
                    },
                    overflow: "auto",
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        size: "small",
                        fontFamily: "monospace",
                        style: {
                            whiteSpace: 'pre-wrap'
                        },
                        children: logLines.join('\n')
                    })
                })
            })
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");


var $2xPiy = parcelRequire("2xPiy");

function $b356debd254c4cfa$var$_extends() {
    return $b356debd254c4cfa$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b356debd254c4cfa$var$_extends.apply(null, arguments);
}
var $b356debd254c4cfa$export$7dd0724a362def6d = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $b356debd254c4cfa$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormUp"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m18 15-6-6-6 6"
    }));
});
$b356debd254c4cfa$export$7dd0724a362def6d.displayName = 'FormUp';




const $c0ee171a2a342a81$var$ROWS_PER_PAGE = 50;
const $c0ee171a2a342a81$var$ERROR_COLOR = 'status-critical';
const $c0ee171a2a342a81$var$MissingDataSection = ({ title: title, columns: columns, rows: rows })=>{
    const [isOpen, setIsOpen] = (0, $2xPiy.useState)(false);
    const [visibleCount, setVisibleCount] = (0, $2xPiy.useState)($c0ee171a2a342a81$var$ROWS_PER_PAGE);
    const [isShowMoreHovered, setIsShowMoreHovered] = (0, $2xPiy.useState)(false);
    if (rows.length === 0) return null;
    const visibleRows = rows.slice(0, visibleCount);
    const remainingCount = rows.length - visibleRows.length;
    const toggleOpen = ()=>{
        if (isOpen) setVisibleCount($c0ee171a2a342a81$var$ROWS_PER_PAGE);
        setIsOpen(!isOpen);
    };
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        border: {
            side: 'bottom',
            color: 'light-4',
            size: '1px'
        },
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                direction: "row",
                align: "center",
                justify: "between",
                pad: {
                    horizontal: 'medium',
                    vertical: 'small'
                },
                background: {
                    color: $c0ee171a2a342a81$var$ERROR_COLOR,
                    opacity: 'weak'
                },
                onClick: toggleOpen,
                role: "button",
                tabIndex: 0,
                "aria-expanded": isOpen,
                hoverIndicator: {
                    color: $c0ee171a2a342a81$var$ERROR_COLOR,
                    opacity: 'medium'
                },
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        direction: "row",
                        align: "center",
                        gap: "small",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: "medium",
                                weight: 600,
                                color: $c0ee171a2a342a81$var$ERROR_COLOR,
                                children: title
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                background: $c0ee171a2a342a81$var$ERROR_COLOR,
                                round: "xlarge",
                                pad: {
                                    horizontal: 'small',
                                    vertical: '2px'
                                },
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    size: "xsmall",
                                    weight: 600,
                                    color: "white",
                                    children: rows.length
                                })
                            })
                        ]
                    }),
                    isOpen ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b356debd254c4cfa$export$7dd0724a362def6d), {
                        size: "20px",
                        color: $c0ee171a2a342a81$var$ERROR_COLOR
                    }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $aa240f1efb63cecd$export$cd1a8f5a55d5e9d3), {
                        size: "20px",
                        color: $c0ee171a2a342a81$var$ERROR_COLOR
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9dcd345e1cd244f1$export$6eb0f7ddcda6131f), {
                open: isOpen,
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    pad: {
                        horizontal: 'medium',
                        vertical: 'small'
                    },
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            direction: "row",
                            gap: "medium",
                            pad: {
                                vertical: 'xsmall',
                                horizontal: 'small'
                            },
                            border: [
                                {
                                    side: 'bottom',
                                    color: 'light-4',
                                    size: '1px'
                                },
                                {
                                    side: 'left',
                                    color: 'transparent',
                                    size: '2px'
                                }
                            ],
                            children: columns.map((column)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    basis: "0",
                                    flex: "grow",
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "small",
                                        weight: 600,
                                        color: "dark-1",
                                        children: column
                                    })
                                }, column))
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            height: {
                                max: '300px'
                            },
                            overflow: "auto",
                            gap: "small",
                            pad: {
                                top: 'small'
                            },
                            children: [
                                visibleRows.map((row, index)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        direction: "row",
                                        gap: "medium",
                                        height: {
                                            min: '2rem'
                                        },
                                        pad: {
                                            vertical: 'xsmall',
                                            horizontal: 'small'
                                        },
                                        border: {
                                            side: 'left',
                                            color: $c0ee171a2a342a81$var$ERROR_COLOR,
                                            size: '2px'
                                        },
                                        align: "center",
                                        children: row.map((value, columnIndex)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                basis: "0",
                                                flex: "grow",
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    size: "small",
                                                    color: "dark-2",
                                                    children: value
                                                })
                                            }, columns[columnIndex]))
                                    }, index)),
                                remainingCount > 0 && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    align: "center",
                                    justify: "center",
                                    margin: {
                                        top: 'medium'
                                    },
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        align: "center",
                                        justify: "center",
                                        onClick: ()=>setVisibleCount(visibleCount + $c0ee171a2a342a81$var$ROWS_PER_PAGE),
                                        onMouseEnter: ()=>setIsShowMoreHovered(true),
                                        onMouseLeave: ()=>setIsShowMoreHovered(false),
                                        flex: "shrink",
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                            size: "small",
                                            weight: 600,
                                            color: "button-hover",
                                            style: {
                                                textDecoration: isShowMoreHovered ? 'underline' : 'none'
                                            },
                                            children: [
                                                "Show ",
                                                Math.min($c0ee171a2a342a81$var$ROWS_PER_PAGE, remainingCount),
                                                " More (",
                                                remainingCount,
                                                " remaining)"
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $c0ee171a2a342a81$export$5d6dcce52a4a90a8 = ({ missingData: missingData })=>{
    if (missingData === null) return null;
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
        margin: {
            vertical: 'medium'
        },
        background: "white",
        elevation: "none",
        round: "xsmall",
        border: {
            color: $c0ee171a2a342a81$var$ERROR_COLOR,
            size: '1px'
        },
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                pad: {
                    horizontal: 'medium',
                    vertical: 'medium'
                },
                border: {
                    side: 'bottom',
                    color: 'light-4',
                    size: '1px'
                },
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    direction: "row",
                    align: "center",
                    gap: "small",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $11571e85aa9685ed$export$5a89edf87f611fb5), {
                            size: "20px",
                            color: $c0ee171a2a342a81$var$ERROR_COLOR
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            size: "large",
                            weight: "normal",
                            color: $c0ee171a2a342a81$var$ERROR_COLOR,
                            children: "ERROR: Could not validate data"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                pad: "none",
                gap: "none",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)($c0ee171a2a342a81$var$MissingDataSection, {
                        title: "The following client program reporting periods are already finalized",
                        columns: [
                            'Client',
                            'Program'
                        ],
                        rows: missingData.finalized_reporting_periods.map((item)=>[
                                item.client,
                                item.program
                            ])
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)($c0ee171a2a342a81$var$MissingDataSection, {
                        title: "Missing CIXD Standards",
                        columns: [
                            'Program',
                            'Baseline Fuel Type'
                        ],
                        rows: missingData.missing_cixd_standards.map((item)=>[
                                item.program,
                                item.baseline_fuel_type
                            ])
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)($c0ee171a2a342a81$var$MissingDataSection, {
                        title: "Missing Equipment Type EERs",
                        columns: [
                            'Program',
                            'Equipment Type'
                        ],
                        rows: missingData.missing_equipment_type_eers.map((item)=>[
                                item.program,
                                item.equipment_type
                            ])
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)($c0ee171a2a342a81$var$MissingDataSection, {
                        title: "Equipment Missing Fuel Pathways",
                        columns: [
                            'Client',
                            'Facility',
                            'Serial Number'
                        ],
                        rows: missingData.equipment_missing_fuel_pathways.map((item)=>[
                                item.client,
                                item.facility,
                                item.serial_number
                            ])
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)($c0ee171a2a342a81$var$MissingDataSection, {
                        title: "Equipment Missing kWh",
                        columns: [
                            'Client',
                            'Facility',
                            'Serial Number'
                        ],
                        rows: missingData.equipment_missing_kwh.map((item)=>[
                                item.client,
                                item.facility,
                                item.serial_number
                            ])
                    })
                ]
            })
        ]
    });
};








var $2xPiy = parcelRequire("2xPiy");




const $d9dd831fff3415d8$var$CONNECTION_LOST_MESSAGE = "The connection was lost before the calculation finished. All changes were rolled back \u2014 re-run the calculation.";
const $d9dd831fff3415d8$var$isMissingDataResponse = (body)=>typeof body === 'object' && body !== null && 'missing_cixd_standards' in body;
const $d9dd831fff3415d8$var$parseStreamEvents = (rawEvents)=>{
    const events = [];
    for (const rawEvent of rawEvents){
        let data = '';
        for (const line of rawEvent.split('\n'))if (line.startsWith('data: ')) data += line.slice(6);
        if (data !== '') events.push(JSON.parse(data));
    }
    return events;
};
const $d9dd831fff3415d8$export$f7970d7d5e4ecf96 = ()=>{
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const [status, setStatus] = (0, $2xPiy.useState)('idle');
    const [logLines, setLogLines] = (0, $2xPiy.useState)([]);
    const [updatedCount, setUpdatedCount] = (0, $2xPiy.useState)(null);
    const [failureMessage, setFailureMessage] = (0, $2xPiy.useState)(null);
    const [missingData, setMissingData] = (0, $2xPiy.useState)(null);
    const streamAbortRef = (0, $2xPiy.useRef)(null);
    const closeStream = ()=>{
        streamAbortRef.current?.abort();
        streamAbortRef.current = null;
    };
    (0, $2xPiy.useEffect)(()=>closeStream, []);
    const calculate = async (payload)=>{
        setStatus('submitting');
        setLogLines([]);
        setUpdatedCount(null);
        setFailureMessage(null);
        setMissingData(null);
        closeStream();
        const abortController = new AbortController();
        streamAbortRef.current = abortController;
        const handleTerminalEvent = (event)=>{
            if (event.type === 'done') {
                setUpdatedCount(event.updated_count);
                setStatus('done');
            } else if (event.type === 'cancelled') setStatus('cancelled');
            else {
                setFailureMessage(event.message);
                setStatus('failed');
            }
        };
        try {
            const response = await (0, $f54e9d7b4c02cd74$export$46ccbb23832f3e86).calculate(payload, abortController.signal);
            const contentType = response.headers.get('content-type') ?? '';
            if (!response.ok || !contentType.includes('text/event-stream') || response.body === null) {
                const body = await response.json().catch(()=>null);
                setStatus('idle');
                if (response.status === 401) {
                    (0, $c5482855026ef46a$export$775816c0de911c24)(body);
                    return;
                }
                if (response.status === 400 && $d9dd831fff3415d8$var$isMissingDataResponse(body)) {
                    setMissingData(body);
                    return;
                }
                globalStore.handleApiError({
                    status: response.status,
                    body: body
                }, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).calculateCredits.error);
                return;
            }
            setStatus('running');
            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer = '';
            for(;;){
                const { done: done, value: value } = await reader.read();
                if (done) break;
                buffer += decoder.decode(value, {
                    stream: true
                });
                const rawEvents = buffer.split('\n\n');
                buffer = rawEvents.pop() ?? '';
                const newLines = [];
                let terminalEvent;
                for (const event of $d9dd831fff3415d8$var$parseStreamEvents(rawEvents))if (event.type === 'line') newLines.push(event.line);
                else {
                    terminalEvent = event;
                    break;
                }
                if (newLines.length > 0) setLogLines((lines)=>[
                        ...lines,
                        ...newLines
                    ]);
                if (terminalEvent !== undefined) {
                    handleTerminalEvent(terminalEvent);
                    return;
                }
            }
            setFailureMessage($d9dd831fff3415d8$var$CONNECTION_LOST_MESSAGE);
            setStatus('failed');
        } catch (error) {
            if (abortController.signal.aborted) return;
            setFailureMessage($d9dd831fff3415d8$var$CONNECTION_LOST_MESSAGE);
            setStatus('failed');
        } finally{
            if (streamAbortRef.current === abortController) streamAbortRef.current = null;
        }
    };
    const cancel = ()=>{
        if (streamAbortRef.current === null) return;
        closeStream();
        setStatus('cancelled');
    };
    return {
        status: status,
        logLines: logLines,
        updatedCount: updatedCount,
        failureMessage: failureMessage,
        missingData: missingData,
        calculate: calculate,
        cancel: cancel
    };
};




const $395ba5b9443840b4$var$VALIDATION_MESSAGES = [
    'Parsing data...',
    'Validating CIXD Standards...',
    'Validating Equipment Type EERs...',
    'Validating equipment fuel pathways...',
    'Validating Equipment kWh values...',
    'This might take a few minutes...'
];
const $395ba5b9443840b4$var$VALIDATION_MESSAGE_INTERVAL_MS = 3000;
const $395ba5b9443840b4$var$PERIOD_VALUE_SEPARATOR = ':';
const $395ba5b9443840b4$var$toPeriodOptions = (options, typeId)=>options.map(({ label: label, value: value })=>({
            label: label,
            value: `${typeId}${$395ba5b9443840b4$var$PERIOD_VALUE_SEPARATOR}${value}`
        }));
const $395ba5b9443840b4$var$parsePeriodValue = (value)=>{
    if (value === '') return null;
    const [typeId, startDate] = value.split($395ba5b9443840b4$var$PERIOD_VALUE_SEPARATOR);
    return {
        typeId: Number(typeId),
        startDate: startDate
    };
};
const $395ba5b9443840b4$export$c783dff69de11ac9 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    /* Context */ const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    /* State */ const [selectedPeriodValue, setSelectedPeriodValue] = (0, $2xPiy.useState)('');
    const [selectedProgramIds, setSelectedProgramIds] = (0, $2xPiy.useState)([]);
    const [selectedClientIds, setSelectedClientIds] = (0, $2xPiy.useState)([]);
    const [skipMissingKwh, setSkipMissingKwh] = (0, $2xPiy.useState)(false);
    const [programs, setPrograms] = (0, $2xPiy.useState)([]);
    const [clientOptions, setClientOptions] = (0, $2xPiy.useState)([]);
    const [validationMessageIndex, setValidationMessageIndex] = (0, $2xPiy.useState)(0);
    const { status: status, logLines: logLines, updatedCount: updatedCount, failureMessage: failureMessage, missingData: missingData, calculate: calculate, cancel: cancel } = (0, $d9dd831fff3415d8$export$f7970d7d5e4ecf96)();
    /* Computed */ const selectedPeriod = $395ba5b9443840b4$var$parsePeriodValue(selectedPeriodValue);
    const selectedProgramTypeId = programs.find((program)=>program.id === selectedProgramIds[0])?.reporting_period_type_id ?? null;
    const activePeriodTypeId = selectedPeriod?.typeId ?? selectedProgramTypeId;
    const periodOptions = (0, $2xPiy.useMemo)(()=>[
            ...activePeriodTypeId !== (0, $0badf5665deea2b2$export$a121e4a6c908fa8f).Yearly ? $395ba5b9443840b4$var$toPeriodOptions(globalStore.reportingQuarterOptions, (0, $0badf5665deea2b2$export$a121e4a6c908fa8f).Quarterly) : [],
            ...activePeriodTypeId !== (0, $0badf5665deea2b2$export$a121e4a6c908fa8f).Quarterly ? $395ba5b9443840b4$var$toPeriodOptions(globalStore.reportingYearOptions, (0, $0badf5665deea2b2$export$a121e4a6c908fa8f).Yearly) : []
        ], [
        activePeriodTypeId,
        globalStore.reportingQuarterOptions,
        globalStore.reportingYearOptions
    ]);
    const programOptions = (0, $2xPiy.useMemo)(()=>programs.filter((program)=>activePeriodTypeId === null || program.reporting_period_type_id === activePeriodTypeId).map((program)=>({
                label: program.name,
                value: program.id
            })), [
        programs,
        activePeriodTypeId
    ]);
    const hasClientFilter = selectedPeriod !== null && selectedProgramIds.length > 0;
    const isSubmitting = status === 'submitting';
    const isBusy = isSubmitting || status === 'running';
    const canSubmit = selectedPeriod !== null && selectedProgramIds.length > 0 && !isBusy;
    /* Effects */ (0, $2xPiy.useEffect)(()=>{
        if (!isSubmitting) return;
        setValidationMessageIndex(0);
        const messageInterval = setInterval(()=>{
            setValidationMessageIndex((index)=>(index + 1) % $395ba5b9443840b4$var$VALIDATION_MESSAGES.length);
        }, $395ba5b9443840b4$var$VALIDATION_MESSAGE_INTERVAL_MS);
        return ()=>clearInterval(messageInterval);
    }, [
        isSubmitting
    ]);
    (0, $2xPiy.useEffect)(()=>{
        let isStale = false;
        const fetchPrograms = async ()=>{
            try {
                const programsList = await (0, $06590284a0c4fd89$export$84ac2881c878ff18).list();
                if (isStale) return;
                setPrograms(programsList);
            } catch (error) {
                globalStore.handleApiError(error, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listPrograms.error);
            }
        };
        fetchPrograms();
        return ()=>{
            isStale = true;
        };
    }, []);
    (0, $2xPiy.useEffect)(()=>{
        if (selectedPeriod === null || selectedProgramIds.length === 0) {
            setClientOptions([]);
            setSelectedClientIds([]);
            return;
        }
        let isStale = false;
        const startReportingQuarter = selectedPeriod.startDate;
        const fetchClients = async ()=>{
            try {
                const clients = await (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).listClientNames({
                    program_ids: selectedProgramIds,
                    start_reporting_quarter: startReportingQuarter
                });
                if (isStale) return;
                const options = clients.map((client)=>({
                        label: client.name,
                        value: client.id
                    }));
                setClientOptions(options);
                setSelectedClientIds((selected)=>selected.filter((clientId)=>options.some((option)=>option.value === clientId)));
            } catch (error) {
                if (isStale) return;
                setClientOptions([]);
                setSelectedClientIds([]);
                globalStore.handleApiError(error, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listClients.error);
            }
        };
        fetchClients();
        return ()=>{
            isStale = true;
        };
    }, [
        selectedProgramIds,
        selectedPeriodValue
    ]);
    /* Methods */ const handleCalculate = ()=>{
        if (selectedPeriod === null) return;
        calculate({
            start_reporting_quarter: selectedPeriod.startDate,
            program_ids: selectedProgramIds,
            ...selectedClientIds.length > 0 ? {
                client_ids: selectedClientIds
            } : {},
            skip_equipment_missing_kwh: skipMissingKwh
        });
    };
    /* Render */ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
                margin: {
                    vertical: 'medium'
                },
                background: "white",
                elevation: "none",
                round: "xsmall",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                        pad: {
                            horizontal: 'medium',
                            vertical: 'medium'
                        },
                        border: {
                            side: 'bottom',
                            color: 'light-4',
                            size: '1px'
                        },
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            size: "large",
                            weight: "normal",
                            children: "Recalculate Credits Generated"
                        })
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                        pad: "medium",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                direction: "row",
                                flex: "grow",
                                fill: "horizontal",
                                gap: "1rem",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                        id: "reporting_period",
                                        label: "Reporting Period",
                                        placeholder: "Select Period",
                                        options: periodOptions,
                                        value: selectedPeriodValue,
                                        setValue: setSelectedPeriodValue,
                                        disabled: isBusy,
                                        clear: true,
                                        required: true,
                                        fill: true
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $73a306fd56291544$export$fa00aa2901190e49), {
                                        multiple: true,
                                        label: "Programs",
                                        placeholder: "Select Programs",
                                        options: programOptions,
                                        selectedProgramIds: selectedProgramIds,
                                        setSelectedProgramIds: setSelectedProgramIds,
                                        hideSelectAll: true,
                                        disabled: isBusy,
                                        required: true,
                                        fill: true
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        fill: true,
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $209e44abb3ffd31f$export$c57133fe35f19a3e), {
                                                multiple: true,
                                                label: "Clients",
                                                placeholder: "Select Clients",
                                                options: clientOptions,
                                                selectedClientIds: selectedClientIds,
                                                setSelectedClientIds: setSelectedClientIds,
                                                disabled: !hasClientFilter || isBusy,
                                                fill: true
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "0.75rem",
                                                color: "accent-1",
                                                margin: {
                                                    top: '0.5rem',
                                                    left: '0.75rem'
                                                },
                                                children: "Optional: All clients in the selected programs are included by default."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                direction: "row",
                                align: "center",
                                gap: "medium",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                                        label: "Skip equipment missing kWh",
                                        checked: skipMissingKwh,
                                        onChange: (event)=>setSkipMissingKwh(event.target.checked),
                                        disabled: isBusy
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        width: "33%",
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7ac54c23a62de8c7$export$4ecda0163efe6d1d), {
                                            label: "CALCULATE",
                                            onClick: handleCalculate,
                                            disabled: !canSubmit,
                                            isLoading: isSubmitting
                                        })
                                    }),
                                    isSubmitting && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        direction: "row",
                                        align: "center",
                                        gap: "xsmall",
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8bec6e2e7dc53c4a$export$7f7cbe89f1eacd2), {
                                                size: "small"
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                animation: [
                                                    {
                                                        type: 'slideUp',
                                                        duration: 1000
                                                    },
                                                    {
                                                        type: 'fadeIn',
                                                        duration: 1000
                                                    }
                                                ],
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    size: "small",
                                                    color: "dark-2",
                                                    children: $395ba5b9443840b4$var$VALIDATION_MESSAGES[validationMessageIndex]
                                                })
                                            }, validationMessageIndex)
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c0ee171a2a342a81$export$5d6dcce52a4a90a8), {
                missingData: missingData
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $21fbb75a7acf588a$export$dda10b5589fa05d4), {
                status: status,
                logLines: logLines,
                updatedCount: updatedCount,
                failureMessage: failureMessage,
                onCancel: cancel
            })
        ]
    });
});



const $4a9428f6b6d26b41$var$FuseAdminCreditCalculation = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        height: {
            min: '100vh'
        },
        background: "light",
        style: {
            display: 'flex',
            flexDirection: 'column'
        },
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c3e91fa8212c6d4c$export$50d7b5e01df871ca), {}),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                flex: "grow",
                style: {
                    display: 'flex',
                    flexDirection: 'row',
                    minHeight: 0
                },
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $531f50b0ef9e074f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        flex: "grow",
                        pad: {
                            horizontal: 'large',
                            vertical: 'medium'
                        },
                        overflow: "auto",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            flex: false,
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    direction: "row",
                                    align: "center",
                                    justify: "between",
                                    margin: {
                                        vertical: 'medium'
                                    },
                                    pad: {
                                        horizontal: 'small'
                                    },
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "xlarge",
                                        weight: "normal",
                                        children: "Credit Calculation"
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $395ba5b9443840b4$export$c783dff69de11ac9), {})
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                flex: false,
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $605617a28ba64070$export$3210cca7a959581e), {})
            })
        ]
    });
});
var $4a9428f6b6d26b41$export$2e2bcd8739ae039 = $4a9428f6b6d26b41$var$FuseAdminCreditCalculation;




var $2xPiy = parcelRequire("2xPiy");






const $56b6582e7ad39ad9$var$FuseAdminDashboard = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    const dashboardStore = (0, $116967e0234c3770$export$176f58333fc13682)();
    const [isLoading, setIsLoading] = (0, $2xPiy.useState)(true);
    (0, $2xPiy.useEffect)(()=>{
        setIsLoading(true);
        const fetchDashboard = async ()=>{
            try {
                await dashboardStore.getAdminView();
            } finally{
                setIsLoading(false);
            }
        };
        fetchDashboard();
        return ()=>dashboardStore.clearDashboardData();
    }, []);
    let programData = [];
    if (dashboardStore.dashboardData) {
        const latestByProgram = new Map();
        dashboardStore.dashboardData.reporting_periods.forEach((period)=>{
            period.programs.forEach((program)=>{
                latestByProgram.set(program.name, {
                    price: program.price_per_credit ?? "\u2014",
                    updated: period.reporting_period
                });
            });
        });
        programData = Array.from(latestByProgram.entries()).map(([name, { price: price, updated: updated }])=>({
                name: name,
                price: price,
                updated: updated
            }));
    }
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        height: {
            min: '100vh'
        },
        background: "light",
        style: {
            display: 'flex',
            flexDirection: 'column'
        },
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c3e91fa8212c6d4c$export$50d7b5e01df871ca), {}),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                flex: "grow",
                style: {
                    display: 'flex',
                    flexDirection: 'row',
                    minHeight: 0
                },
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $531f50b0ef9e074f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        flex: "grow",
                        pad: {
                            horizontal: 'large',
                            vertical: 'medium'
                        },
                        overflow: "auto",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            flex: false,
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    direction: "row",
                                    align: "center",
                                    justify: "between",
                                    margin: {
                                        vertical: 'medium'
                                    },
                                    pad: {
                                        horizontal: 'small'
                                    },
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "xlarge",
                                        weight: "normal",
                                        children: "FuSE Admin"
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $724dfb7ecf65a151$export$60332b2344f7fe41), {
                                    margin: {
                                        vertical: 'large'
                                    },
                                    background: "white",
                                    elevation: "none",
                                    round: "xsmall",
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f557854f3abac6b7$export$5665775b26e26c5d), {
                                            pad: {
                                                horizontal: 'medium',
                                                vertical: 'medium'
                                            },
                                            border: {
                                                side: 'bottom',
                                                color: 'light-4',
                                                size: '1px'
                                            },
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "large",
                                                weight: "normal",
                                                children: "Current Credit Pricing"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $fdccc762800a972d$export$851de33184ecdac4), {
                                            pad: "none",
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                elevation: "small",
                                                children: isLoading ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                    height: "200px",
                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {})
                                                }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
                                                    pad: {
                                                        horizontal: '1.5rem'
                                                    },
                                                    columns: [
                                                        {
                                                            property: 'name',
                                                            primary: true,
                                                            size: '60%',
                                                            header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                                toUpperCase: true,
                                                                children: "PROGRAM NAME"
                                                            }),
                                                            render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                    pad: {
                                                                        vertical: '1rem'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cecd6f5af26913b4$export$de5f40ff1ff419d2), {
                                                                            size: "small",
                                                                            color: "brand"
                                                                        }),
                                                                        children: datum.name
                                                                    })
                                                                })
                                                        },
                                                        {
                                                            property: 'price',
                                                            size: '20%',
                                                            header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                                toUpperCase: true,
                                                                children: "PRICE"
                                                            }),
                                                            render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                    pad: {
                                                                        vertical: '1rem'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                        children: [
                                                                            "$",
                                                                            datum.price
                                                                        ]
                                                                    })
                                                                })
                                                        },
                                                        {
                                                            property: 'updated',
                                                            size: '20%',
                                                            header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                                toUpperCase: true,
                                                                children: "UPDATED"
                                                            }),
                                                            render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                    pad: {
                                                                        vertical: '1rem'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                        children: datum.updated
                                                                    })
                                                                })
                                                        }
                                                    ],
                                                    data: programData,
                                                    background: [
                                                        'light-6',
                                                        'white'
                                                    ],
                                                    border: {
                                                        color: 'light-2',
                                                        side: 'bottom',
                                                        size: 'small'
                                                    }
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    children: !isLoading && dashboardStore.dashboardData && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $fd4665cc6c98489d$export$27ae23542b46daac), {
                                        data: dashboardStore.dashboardData
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                flex: false,
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $605617a28ba64070$export$3210cca7a959581e), {})
            })
        ]
    });
});
var $56b6582e7ad39ad9$export$2e2bcd8739ae039 = $56b6582e7ad39ad9$var$FuseAdminDashboard;




var $2xPiy = parcelRequire("2xPiy");



var $2xPiy = parcelRequire("2xPiy");

function $c9012a71e61165a4$var$_extends() {
    return $c9012a71e61165a4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c9012a71e61165a4$var$_extends.apply(null, arguments);
}
var $c9012a71e61165a4$export$77bc526bfccc9372 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $c9012a71e61165a4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Tasks"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 3h22v4H1V3zm0 7h22v4H1v-4zm0 7h22v4H1v-4zM1 4h15v2H1V4zm0 7h5v2H1v-2zm0 7h10v2H1v-2z"
    }));
});
$c9012a71e61165a4$export$77bc526bfccc9372.displayName = 'Tasks';


var $2xPiy = parcelRequire("2xPiy");

function $83fb0b085ee727c4$var$_extends() {
    return $83fb0b085ee727c4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $83fb0b085ee727c4$var$_extends.apply(null, arguments);
}
var $83fb0b085ee727c4$export$41fb9f06171c75f4 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $83fb0b085ee727c4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Trigger"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4 14h6l-3 9h2L20 9h-6l4-8H7z"
    }));
});
$83fb0b085ee727c4$export$41fb9f06171c75f4.displayName = 'Trigger';




class $ede5aca97258907a$export$e18a13a5ea0bb57b {
    /**
   * Import equipment data
   * @param file File to import
   * @returns Import result
   * @throws ApiError
   */ static import(file) {
        const formData = new FormData();
        formData.append('file', file);
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/importers/equipment',
            body: formData
        });
    }
}



class $0e1311dd9c37780f$export$bc2ec8e81e9bfbdb {
    /**
   * Import facility data
   * @param file File to import
   * @returns Import result
   * @throws ApiError
   */ static import(file) {
        const formData = new FormData();
        formData.append('file', file);
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/importers/facilities',
            body: formData
        });
    }
}



class $a33649daad3e8b08$export$e923d4616141020d {
    /**
   * Import kWh data from Excel file
   * @param file File to import
   * @returns Import result
   * @throws ApiError
   */ static import(file) {
        const formData = new FormData();
        formData.append('file', file);
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/importers/kwh',
            body: formData
        });
    }
}



class $f0ec76a064b2a34c$export$280548841bcae7a9 {
    /**
   * Import FSE registration status data
   * @param file File to import
   * @returns Import result
   * @throws ApiError
   */ static import(file) {
        const formData = new FormData();
        formData.append('file', file);
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/importers/statuses',
            body: formData
        });
    }
}






var $2xPiy = parcelRequire("2xPiy");



var $2xPiy = parcelRequire("2xPiy");

function $75e19b0b448daba9$var$_extends() {
    return $75e19b0b448daba9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $75e19b0b448daba9$var$_extends.apply(null, arguments);
}
var $75e19b0b448daba9$export$c58532f0fb5faa97 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $75e19b0b448daba9$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Upload"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 17v6h22v-6M12 2v17M5 9l7-7 7 7"
    }));
});
$75e19b0b448daba9$export$c58532f0fb5faa97.displayName = 'Upload';




var $2xPiy = parcelRequire("2xPiy");



var $2xPiy = parcelRequire("2xPiy");

function $c0227736b4f29df5$var$_extends() {
    return $c0227736b4f29df5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c0227736b4f29df5$var$_extends.apply(null, arguments);
}
var $c0227736b4f29df5$export$b34a105447964f9f = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $c0227736b4f29df5$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Document"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M14 1v7h7m0 15H3V1h12l3 3 3 3v16z"
    }));
});
$c0227736b4f29df5$export$b34a105447964f9f.displayName = 'Document';


const $6f8f550f497b66c1$var$FileInput = ({ onFileSelect: onFileSelect, isUploading: isUploading = false, accept: accept = '', disabled: disabled = false, selectedFile: selectedFile = null, id: id = 'file-input' })=>{
    const [isDragOver, setIsDragOver] = (0, $2xPiy.useState)(false);
    const [isHover, setIsHover] = (0, $2xPiy.useState)(false);
    const isDisabled = !isUploading && !disabled;
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const handleFileSelect = (file)=>{
        if (file) onFileSelect(file);
    };
    const handleDragEvents = (e, isOver)=>{
        e.preventDefault();
        if (isDisabled) setIsDragOver(isOver);
    };
    const handleDrop = (e)=>{
        e.preventDefault();
        setIsDragOver(false);
        if (isDisabled && e.dataTransfer.files?.[0]) handleFileSelect(e.dataTransfer.files[0]);
    };
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        border: {
            color: 'light-5',
            size: '1px'
        },
        round: "xsmall",
        pad: {
            vertical: 'medium',
            horizontal: 'large'
        },
        direction: "row",
        align: "center",
        justify: "between",
        style: {
            opacity: isDisabled ? 1 : 0.5,
            borderColor: isDragOver || isHover ? '#00739D' : undefined,
            background: isDragOver || isHover ? '#F0F8FF' : undefined
        },
        onClick: ()=>isDisabled && document.getElementById(`${id}-input`)?.click(),
        onDragOver: (e)=>handleDragEvents(e, true),
        onDragLeave: (e)=>handleDragEvents(e, false),
        onDrop: handleDrop,
        onMouseEnter: ()=>setIsHover(true),
        onMouseLeave: ()=>setIsHover(false),
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                direction: "row",
                align: "center",
                gap: "small",
                flex: true,
                style: {
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        direction: "row",
                        wrap: true,
                        style: {
                            minWidth: 0
                        },
                        children: selectedFile ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), {
                                    color: "accent-1",
                                    margin: {
                                        right: 'xsmall'
                                    },
                                    style: {
                                        whiteSpace: 'nowrap',
                                        flexShrink: 0
                                    },
                                    children: t('documents:selectedFile')
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), {
                                    color: "accent-1",
                                    weight: "bold",
                                    wordBreak: "break-word",
                                    children: selectedFile.name
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), {
                            color: "accent-1",
                            children: [
                                t('documents:dropFiles'),
                                ' ',
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), {
                                    color: "accent-1",
                                    weight: "bold",
                                    children: t('documents:browse')
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        margin: {
                            left: 'small'
                        },
                        flex: false,
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c0227736b4f29df5$export$b34a105447964f9f), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("input", {
                id: `${id}-input`,
                type: "file",
                accept: accept,
                style: {
                    display: 'none'
                },
                onChange: (e)=>handleFileSelect(e.target.files?.[0]),
                disabled: !isDisabled
            })
        ]
    });
};
var $6f8f550f497b66c1$export$2e2bcd8739ae039 = $6f8f550f497b66c1$var$FileInput;




const $6a896806fd3e802c$export$80588cfff84a70f1 = ({ title: title, description: description, onFileSelect: onFileSelect, onUpload: onUpload, isUploading: isUploading, selectedFile: selectedFile, validationErrors: validationErrors, successMessage: successMessage })=>{
    const [isErrorsExpanded, setIsErrorsExpanded] = (0, $2xPiy.useState)(false);
    const handleFileSelect = (file)=>{
        if (!file.name.endsWith('.xlsx')) {
            (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).fileValidation.invalidExcelFile);
            return;
        }
        onFileSelect(file);
        setIsErrorsExpanded(false);
    };
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $724dfb7ecf65a151$export$60332b2344f7fe41), {
        background: "white",
        elevation: "none",
        round: "xsmall",
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f557854f3abac6b7$export$5665775b26e26c5d), {
                pad: {
                    horizontal: 'medium',
                    vertical: 'medium'
                },
                border: {
                    side: 'bottom',
                    color: 'light-4',
                    size: '1px'
                },
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    size: "large",
                    weight: "normal",
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $fdccc762800a972d$export$851de33184ecdac4), {
                pad: "medium",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                    gap: "medium",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                            children: description
                        }),
                        successMessage && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            background: "#4CAF50",
                            pad: "medium",
                            round: "small",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                color: "white",
                                children: successMessage
                            })
                        }),
                        Object.keys(validationErrors).length > 0 && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            background: "#C04B4B",
                            pad: "medium",
                            round: "small",
                            children: [
                                validationErrors.general && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    color: "white",
                                    children: validationErrors.general[0]
                                }),
                                Object.keys(validationErrors).filter((key)=>key !== 'general').length > 0 && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                            weight: "bold",
                                            margin: {
                                                bottom: 'small'
                                            },
                                            color: "white",
                                            children: [
                                                "Found errors in ",
                                                Object.keys(validationErrors).filter((key)=>key !== 'general').length,
                                                " rows:"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                            gap: "xsmall",
                                            children: Object.entries(validationErrors).filter(([key])=>key !== 'general').slice(0, isErrorsExpanded ? undefined : 5).map(([row, errors])=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                    gap: "xsmall",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            color: "white",
                                                            children: [
                                                                "Row ",
                                                                row,
                                                                ":"
                                                            ]
                                                        }),
                                                        errors.map((error, index)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                margin: {
                                                                    left: 'medium'
                                                                },
                                                                color: "white",
                                                                children: error
                                                            }, index))
                                                    ]
                                                }, row))
                                        }),
                                        Object.keys(validationErrors).filter((key)=>key !== 'general').length > 5 && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                            plain: true,
                                            onClick: ()=>setIsErrorsExpanded(!isErrorsExpanded),
                                            label: isErrorsExpanded ? 'Show less' : 'Show more',
                                            margin: {
                                                top: 'medium'
                                            },
                                            color: "white",
                                            style: {
                                                color: 'white'
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            direction: "row",
                            gap: "small",
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6f8f550f497b66c1$export$2e2bcd8739ae039), {
                                    onFileSelect: handleFileSelect,
                                    isUploading: isUploading,
                                    accept: ".xlsx",
                                    disabled: isUploading,
                                    selectedFile: selectedFile,
                                    id: title.toLowerCase().replace(/\s+/g, '-')
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                    primary: true,
                                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $75e19b0b448daba9$export$c58532f0fb5faa97), {}),
                                    label: "Upload",
                                    onClick: onUpload,
                                    disabled: !selectedFile || isUploading,
                                    style: {
                                        fontWeight: 'normal'
                                    }
                                }),
                                isUploading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8bec6e2e7dc53c4a$export$7f7cbe89f1eacd2), {})
                            ]
                        })
                    ]
                })
            })
        ]
    });
};




var $2xPiy = parcelRequire("2xPiy");



const $b58aae1de1013c76$export$d895cb13fe63f463 = ({ importerService: importerService })=>{
    const [selectedFile, setSelectedFile] = (0, $2xPiy.useState)(null);
    const [isUploading, setIsUploading] = (0, $2xPiy.useState)(false);
    const [validationErrors, setValidationErrors] = (0, $2xPiy.useState)({});
    const [successMessage, setSuccessMessage] = (0, $2xPiy.useState)(null);
    const handleFileSelect = (file)=>{
        if (!file.name.endsWith('.xlsx')) {
            (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).fileValidation.invalidExcelFile);
            return;
        }
        setSelectedFile(file);
        setValidationErrors({});
        setSuccessMessage(null);
    };
    const handleUpload = async ()=>{
        if (!selectedFile) {
            (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).fileValidation.requiredFile);
            return;
        }
        setIsUploading(true);
        setValidationErrors({});
        setSuccessMessage(null);
        try {
            const result = await importerService.import(selectedFile);
            setSuccessMessage(result.message);
            setSelectedFile(null);
            setValidationErrors({});
        } catch (error) {
            if (error instanceof (0, $0402375deeb915a2$export$f2e832acab1bdd79)) try {
                const parsedBody = typeof error.body === 'string' ? JSON.parse(error.body) : error.body;
                const newValidationErrors = {};
                if (parsedBody?.message) newValidationErrors.general = [
                    parsedBody.message
                ];
                if (parsedBody?.errors_by_row) Object.entries(parsedBody.errors_by_row).forEach(([row, errors])=>{
                    newValidationErrors[row] = Array.isArray(errors) ? errors : [
                        errors
                    ];
                });
                setValidationErrors(newValidationErrors);
            } catch (e) {
                const message = error.body || error.message;
                setValidationErrors({
                    general: [
                        message
                    ]
                });
                (0, $05d5739209a21833$export$b410431fab84fa58).error(message);
            }
            else {
                const errorMessage = 'An error occurred while uploading the file';
                setValidationErrors({
                    general: [
                        errorMessage
                    ]
                });
                (0, $05d5739209a21833$export$b410431fab84fa58).error(errorMessage);
            }
        } finally{
            setIsUploading(false);
        }
    };
    return {
        selectedFile: selectedFile,
        isUploading: isUploading,
        validationErrors: validationErrors,
        successMessage: successMessage,
        handleFileSelect: handleFileSelect,
        handleUpload: handleUpload
    };
};


const $88350b4d99686db4$var$FuseAdminImporter = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    const dashboardStore = (0, $116967e0234c3770$export$176f58333fc13682)();
    const [searchParams] = (0, $79bcac94ca400be1$export$f1a78c17382fe22a)();
    const location = (0, $62d58f5c28b15c2e$export$45d76561a5302f2b)();
    const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const activeTab = searchParams.get('tab') || 'kwh';
    const kwhImporter = (0, $b58aae1de1013c76$export$d895cb13fe63f463)({
        importerService: (0, $a33649daad3e8b08$export$e923d4616141020d)
    });
    const statusImporter = (0, $b58aae1de1013c76$export$d895cb13fe63f463)({
        importerService: (0, $f0ec76a064b2a34c$export$280548841bcae7a9)
    });
    const equipmentImporter = (0, $b58aae1de1013c76$export$d895cb13fe63f463)({
        importerService: (0, $ede5aca97258907a$export$e18a13a5ea0bb57b)
    });
    const facilityImporter = (0, $b58aae1de1013c76$export$d895cb13fe63f463)({
        importerService: (0, $0e1311dd9c37780f$export$bc2ec8e81e9bfbdb)
    });
    (0, $2xPiy.useEffect)(()=>{
        dashboardStore.getAdminView();
        return ()=>dashboardStore.clearDashboardData();
    }, []);
    (0, $2xPiy.useEffect)(()=>{
        if (!searchParams.get('tab')) setActiveTab('kwh');
    }, [
        location.search
    ]);
    const setActiveTab = (tab)=>{
        const newSearchParams = new URLSearchParams(location.search);
        newSearchParams.set('tab', tab);
        navigate(`?${newSearchParams.toString()}`, {
            replace: true
        });
    };
    const TabButton = ({ label: label, isActive: isActive, onClick: onClick, icon: icon })=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            pad: {
                vertical: 'medium',
                horizontal: 'large'
            },
            onClick: onClick,
            focusIndicator: false,
            hoverIndicator: {
                color: 'light-2',
                opacity: 'weak'
            },
            style: {
                cursor: 'pointer',
                transition: 'all 0.2s ease-in-out',
                borderBottom: isActive ? '2px solid #00739D' : '2px solid transparent',
                background: isActive ? 'white' : 'transparent',
                borderRadius: '8px 8px 0 0',
                minWidth: '140px',
                textAlign: 'center'
            },
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                    align: "center",
                    margin: {
                        bottom: 'xsmall'
                    },
                    children: icon
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    color: isActive ? 'brand' : 'dark-3',
                    size: "medium",
                    weight: isActive ? 'bold' : 'normal',
                    style: {
                        letterSpacing: '0.5px',
                        textAlign: 'center'
                    },
                    children: label
                })
            ]
        });
    const importers = [
        {
            key: 'kwh',
            label: 'kWh Importer',
            description: 'Upload an Excel file containing kWh data for equipment',
            Icon: (0, $83fb0b085ee727c4$export$41fb9f06171c75f4),
            importer: kwhImporter
        },
        {
            key: 'status',
            label: 'Status Importer',
            description: 'Upload an Excel file containing fse registration status data for equipment',
            Icon: (0, $c9012a71e61165a4$export$77bc526bfccc9372),
            importer: statusImporter
        },
        {
            key: 'equipment',
            label: 'Equipment Importer',
            description: 'Upload an Excel file containing new equipment data',
            Icon: (0, $4c7d348bb823ced4$export$ffec088e0621637),
            importer: equipmentImporter
        },
        {
            key: 'facility',
            label: 'Facility Importer',
            description: 'Upload an Excel file containing new facility data',
            Icon: (0, $546d71f0291023a6$export$f3a6aa388b70f149),
            importer: facilityImporter
        }
    ];
    const activeImporter = importers.find(({ key: key })=>key === activeTab);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        height: {
            min: '100vh'
        },
        background: "light",
        style: {
            display: 'flex',
            flexDirection: 'column'
        },
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c3e91fa8212c6d4c$export$50d7b5e01df871ca), {}),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                flex: "grow",
                style: {
                    display: 'flex',
                    flexDirection: 'row',
                    minHeight: 0
                },
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $531f50b0ef9e074f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        flex: "grow",
                        pad: {
                            horizontal: 'large',
                            vertical: 'medium'
                        },
                        overflow: "auto",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            flex: false,
                            gap: "large",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    direction: "row",
                                    align: "center",
                                    justify: "between",
                                    margin: {
                                        vertical: 'medium'
                                    },
                                    pad: {
                                        horizontal: 'small'
                                    },
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "xlarge",
                                        weight: "normal",
                                        children: "File Importer"
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $724dfb7ecf65a151$export$60332b2344f7fe41), {
                                    background: "white",
                                    elevation: "none",
                                    round: "xsmall",
                                    style: {
                                        marginBottom: -20
                                    },
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                        direction: "row",
                                        children: importers.map(({ key: key, label: label, Icon: Icon })=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)(TabButton, {
                                                label: label,
                                                isActive: activeTab === key,
                                                onClick: ()=>setActiveTab(key),
                                                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)(Icon, {
                                                    size: "24px",
                                                    color: activeTab === key ? '#00739D' : '#CCCCCC'
                                                })
                                            }, key))
                                    })
                                }),
                                activeImporter && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6a896806fd3e802c$export$80588cfff84a70f1), {
                                    title: activeImporter.label,
                                    description: activeImporter.description,
                                    onFileSelect: activeImporter.importer.handleFileSelect,
                                    onUpload: activeImporter.importer.handleUpload,
                                    isUploading: activeImporter.importer.isUploading,
                                    selectedFile: activeImporter.importer.selectedFile,
                                    validationErrors: activeImporter.importer.validationErrors,
                                    successMessage: activeImporter.importer.successMessage
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                flex: false,
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $605617a28ba64070$export$3210cca7a959581e), {})
            })
        ]
    });
});
var $88350b4d99686db4$export$2e2bcd8739ae039 = $88350b4d99686db4$var$FuseAdminImporter;




var $2xPiy = parcelRequire("2xPiy");

var $2xPiy = parcelRequire("2xPiy");



var $2xPiy = parcelRequire("2xPiy");
var $160c5cf4a8a6212d$export$cfa7aa87c26e7d1f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createContext({});




var $iA1nz = parcelRequire("iA1nz");


var $bb1066b337f78a70$var$tabHoverStyle = (0, $iA1nz.css)([
    "&:hover{",
    " ",
    " ",
    ";}&:focus{z-index:1;}"
], function(props) {
    return props.theme.tab.hover.background && (0, $iA1nz.css)([
        "background:",
        ";"
    ], (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.theme.tab.hover.background, props.theme));
}, function(props) {
    return props.theme.tab.hover.color && (0, $iA1nz.css)([
        "color:",
        ";"
    ], (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.theme.tab.hover.color, props.theme));
}, function(props) {
    return props.theme.tab.hover.extend;
});
var $bb1066b337f78a70$export$f43fc23d58ee4c2 = (0, $iA1nz.default)((0, $18c0523379e5dd9d$export$e71c4d32a2263218)).withConfig({
    displayName: "StyledTab",
    componentId: "sc-1nnwnsb-0"
})([
    "white-space:nowrap;",
    " ",
    " ",
    " ",
    ""
], (0, $73ba8e2d301b823f$export$a157b298d219a801), function(props) {
    return !props.plain && !props.disabled && props.theme.tab.hover && $bb1066b337f78a70$var$tabHoverStyle;
}, function(props) {
    return props.disabled && props.theme.tab.disabled;
}, function(props) {
    return props.theme.tab.extend;
});



var $dyr1f = parcelRequire("dyr1f");
var $6a27db80a4fdcfbf$var$PropType = {};
$6a27db80a4fdcfbf$var$PropType = {
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).element,
    plain: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    reverse: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node
};
var $6a27db80a4fdcfbf$export$5ced29b443316d9 = $6a27db80a4fdcfbf$var$PropType;




var $96a81eab79474076$var$_excluded = [
    "active",
    "disabled",
    "children",
    "icon",
    "plain",
    "title",
    "onBlur",
    "onFocus",
    "onMouseOver",
    "onMouseOut",
    "reverse",
    "onClick",
    "onKeyDown"
];
function $96a81eab79474076$var$_extends() {
    return $96a81eab79474076$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $96a81eab79474076$var$_extends.apply(null, arguments);
}
function $96a81eab79474076$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $96a81eab79474076$export$3e41faf802a29e71 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var activeProp = _ref.active, disabled = _ref.disabled, children = _ref.children, icon = _ref.icon, plain = _ref.plain, title = _ref.title, _onBlur = _ref.onBlur, _onFocus = _ref.onFocus, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, reverse = _ref.reverse, onClick = _ref.onClick, onKeyDown = _ref.onKeyDown, rest = $96a81eab79474076$var$_objectWithoutPropertiesLoose(_ref, $96a81eab79474076$var$_excluded);
    var _useContext = (0, $2xPiy.useContext)((0, $160c5cf4a8a6212d$export$cfa7aa87c26e7d1f)), active = _useContext.active, activeIndex = _useContext.activeIndex, focusable = _useContext.focusable, index = _useContext.index, panelId = _useContext.panelId, tabsContextRef = _useContext.ref, onActivate = _useContext.onActivate, onTabsKeyDown = _useContext.onKeyDown, setActiveContent = _useContext.setActiveContent, setActiveTitle = _useContext.setActiveTitle, setFocusIndex = _useContext.setFocusIndex;
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useState = (0, $2xPiy.useState)(undefined), over = _useState[0], setOver = _useState[1];
    var normalizedTitle = title;
    var tabStyles = {};
    var tabRef = (0, $3cecef11d3b9c451$export$61dc559f8a0b9bcf)(ref);
    (0, $9462599f26e06396$export$e5c5a5f917a5871c)(function() {
        if (tabRef.current && tabsContextRef) tabsContextRef.current = tabRef.current;
    });
    (0, $9462599f26e06396$export$e5c5a5f917a5871c)(function() {
        if (active) {
            setActiveContent(children);
            var activeTitle = typeof title === 'string' ? title : activeIndex + 1;
            setActiveTitle(activeTitle);
        }
    }, [
        active,
        activeIndex,
        children,
        setActiveContent,
        setActiveTitle,
        title
    ]);
    var onMouseOverTab = function onMouseOverTab(event) {
        setOver(true);
        if (onMouseOver) onMouseOver(event);
    };
    var onMouseOutTab = function onMouseOutTab(event) {
        setOver(undefined);
        if (onMouseOut) onMouseOut(event);
    };
    if (!plain) {
        if (typeof title !== 'string') normalizedTitle = title;
        else if (active) normalizedTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), theme.tab.active, title);
        else if (disabled && theme.tab.disabled) normalizedTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), theme.tab.disabled, title);
        else normalizedTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), {
            color: over ? theme.tab.hover.color : theme.tab.color
        }, title);
    }
    var onClickTab = function onClickTab(event) {
        if (event) event.preventDefault();
        onActivate();
        if (onClick) onClick(event);
    };
    var onKeyDownTab = function onKeyDownTab(event) {
        if (disabled) return;
        onTabsKeyDown(event);
        if (onKeyDown) onKeyDown(event);
    };
    if (active && disabled) console.warn("Warning: Tab props 'active' and 'disabled' have both been set to TRUE on the same Tab resulting in an interesting Tab state. Is this your intent?");
    if (!plain) {
        if (typeof title !== 'string') normalizedTitle = title;
        else if (active) normalizedTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), theme.tab.active, title);
        else if (disabled && theme.tab.disabled) normalizedTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), theme.tab.disabled, title);
        else normalizedTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), {
            color: over ? theme.tab.hover.color : theme.tab.color
        }, title);
        if (theme.tab.border) {
            var borderColor = theme.tab.border.color || theme.global.control.border.color;
            if (active) borderColor = theme.tab.border.active.color || borderColor;
            else if (disabled && theme.tab.border.disabled) borderColor = theme.tab.border.disabled.color || borderColor;
            else if (over) borderColor = theme.tab.border.hover.color || borderColor;
            borderColor = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(borderColor, theme);
            tabStyles.border = {
                side: theme.tab.border.side,
                size: theme.tab.border.size,
                color: borderColor
            };
        }
        tabStyles.background = active ? theme.tab.active.background || theme.tab.background : theme.tab.background;
        tabStyles.pad = theme.tab.pad;
        tabStyles.margin = theme.tab.margin;
    }
    // needed to apply hover/active styles to the icon
    var renderIcon = function renderIcon(iconProp) {
        if (active) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).cloneElement(iconProp, $96a81eab79474076$var$_extends({}, theme.tab.active));
        if (disabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).cloneElement(iconProp, $96a81eab79474076$var$_extends({}, theme.tab.disabled));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).cloneElement(iconProp, {
            color: over ? theme.tab.hover.color : theme.tab.color
        });
    };
    var normalizedIcon;
    if (icon) normalizedIcon = renderIcon(icon);
    var first = reverse ? normalizedTitle : normalizedIcon;
    var second = reverse ? normalizedIcon : normalizedTitle;
    var withIconStyles;
    if (first && second) {
        var _theme$tab;
        withIconStyles = {
            direction: 'row',
            align: 'center',
            justify: 'center',
            gap: (_theme$tab = theme.tab) == null ? void 0 : _theme$tab.gap
        };
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), $96a81eab79474076$var$_extends({
        ref: tabRef,
        plain: true,
        role: "tab",
        tabIndex: focusable ? 0 : -1,
        "aria-controls": panelId,
        "aria-selected": active,
        disabled: disabled
    }, rest, {
        onClick: onClickTab,
        onKeyDown: onKeyDownTab,
        onMouseOver: onMouseOverTab,
        onMouseOut: onMouseOutTab,
        onFocus: function onFocus(event) {
            if (_onFocus) _onFocus(event);
            setFocusIndex(index);
        },
        onBlur: function onBlur(event) {
            if (_onBlur) _onBlur(event);
            setFocusIndex(-1);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $bb1066b337f78a70$export$f43fc23d58ee4c2), $96a81eab79474076$var$_extends({
        disabled: disabled,
        plain: plain
    }, withIconStyles, tabStyles, passThemeFlag), first, second));
});
$96a81eab79474076$export$3e41faf802a29e71.displayName = 'Tab';
$96a81eab79474076$export$3e41faf802a29e71.propTypes = (0, $6a27db80a4fdcfbf$export$5ced29b443316d9);


var $2xPiy = parcelRequire("2xPiy");








var $iA1nz = parcelRequire("iA1nz");


var $70d377dbeb60d70c$var$_FLEX_MAP;
var $70d377dbeb60d70c$export$9c5a323fcd5fd5a3 = (0, $iA1nz.default)((0, $18c0523379e5dd9d$export$e71c4d32a2263218)).withConfig({
    displayName: "StyledTabs__StyledTabsHeader",
    componentId: "sc-a4fwxl-0"
})([
    "",
    ";"
], function(props) {
    return props.theme.tabs.header.extend;
});
var $70d377dbeb60d70c$var$FLEX_MAP = ($70d377dbeb60d70c$var$_FLEX_MAP = {}, $70d377dbeb60d70c$var$_FLEX_MAP[true] = '1 1', $70d377dbeb60d70c$var$_FLEX_MAP[false] = '0 0', $70d377dbeb60d70c$var$_FLEX_MAP.grow = '1 0', $70d377dbeb60d70c$var$_FLEX_MAP.shrink = '0 1', $70d377dbeb60d70c$var$_FLEX_MAP);
var $70d377dbeb60d70c$var$flexStyle = (0, $iA1nz.css)([
    "flex:",
    ";"
], function(props) {
    return "" + $70d377dbeb60d70c$var$FLEX_MAP[props.flex] + (props.flex !== true ? ' auto' : '');
});
var $70d377dbeb60d70c$export$6dde272a8363b335 = (0, $iA1nz.default).div.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledTabs__StyledTabPanel",
    componentId: "sc-a4fwxl-1"
})([
    "min-height:0;",
    " ",
    ";"
], function(props) {
    return props.flex && $70d377dbeb60d70c$var$flexStyle;
}, function(props) {
    return props.theme.tabs.panel.extend;
});
var $70d377dbeb60d70c$export$594ebcebca054019 = (0, $iA1nz.default)((0, $18c0523379e5dd9d$export$e71c4d32a2263218)).withConfig({
    displayName: "StyledTabs",
    componentId: "sc-a4fwxl-2"
})([
    "",
    " ",
    ";"
], (0, $73ba8e2d301b823f$export$a157b298d219a801), function(props) {
    return props.theme.tabs.extend;
});





var $dyr1f = parcelRequire("dyr1f");

function $31841148ce8e65e6$var$_extends() {
    return $31841148ce8e65e6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $31841148ce8e65e6$var$_extends.apply(null, arguments);
}
var $31841148ce8e65e6$var$PropType = {};
$31841148ce8e65e6$var$PropType = $31841148ce8e65e6$var$_extends({}, (0, $ab32ce3df36aa105$export$ffe37ff34eeb9e21), {
    activeIndex: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
    alignControls: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'start',
        'center',
        'end',
        'stretch'
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node.isRequired,
    flex: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'grow',
            'shrink'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool
    ]),
    justify: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'start',
        'center',
        'end'
    ]),
    messages: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).shape({
        tabContents: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    }),
    onActive: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func
});
var $31841148ce8e65e6$export$45ba878828554cde = $31841148ce8e65e6$var$PropType;




var $98fc76c952067c09$var$_excluded = [
    "alignControls",
    "children",
    "flex",
    "justify",
    "messages",
    "responsive"
];
function $98fc76c952067c09$var$_extends() {
    return $98fc76c952067c09$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $98fc76c952067c09$var$_extends.apply(null, arguments);
}
function $98fc76c952067c09$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $98fc76c952067c09$export$b2539bed5023c21c = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var _theme$tabs$header, _theme$tabs$header2, _theme$tabs$header3, _theme$tabs$header4;
    var alignControls = _ref.alignControls, children = _ref.children, flex = _ref.flex, _ref$justify = _ref.justify, justify = _ref$justify === void 0 ? 'center' : _ref$justify, messages = _ref.messages, _ref$responsive = _ref.responsive, responsive = _ref$responsive === void 0 ? true : _ref$responsive, rest = $98fc76c952067c09$var$_objectWithoutPropertiesLoose(_ref, $98fc76c952067c09$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useContext = (0, $2xPiy.useContext)((0, $f1ad7bf122eed3b0$export$b060d577040138d8)), format = _useContext.format;
    var propsActiveIndex = rest.activeIndex, onActive = rest.onActive;
    var _useState = (0, $2xPiy.useState)(rest.activeIndex || 0), activeIndex = _useState[0], setActiveIndex = _useState[1];
    var _useState2 = (0, $2xPiy.useState)(), activeContent = _useState2[0], setActiveContent = _useState2[1];
    var _useState3 = (0, $2xPiy.useState)(), activeTitle = _useState3[0], setActiveTitle = _useState3[1];
    var _useState4 = (0, $2xPiy.useState)(), disableLeftArrow = _useState4[0], setDisableLeftArrow = _useState4[1];
    var _useState5 = (0, $2xPiy.useState)(), disableRightArrow = _useState5[0], setDisableRightArrow = _useState5[1];
    var _useState6 = (0, $2xPiy.useState)(), overflow = _useState6[0], setOverflow = _useState6[1];
    var _useState7 = (0, $2xPiy.useState)(-1), focusIndex = _useState7[0], setFocusIndex = _useState7[1];
    var headerRef = (0, $2xPiy.useRef)();
    var panelId = (0, $6b7eb3480858eeaa$export$f680877a34711e37)();
    var size = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    var PreviousIcon = ((_theme$tabs$header = theme.tabs.header) == null || (_theme$tabs$header = _theme$tabs$header.previousButton) == null ? void 0 : _theme$tabs$header.icon) || (0, $2ce319e09672cf9d$export$a499fb457891d86e);
    var NextIcon = ((_theme$tabs$header2 = theme.tabs.header) == null || (_theme$tabs$header2 = _theme$tabs$header2.nextButton) == null ? void 0 : _theme$tabs$header2.icon) || (0, $395d1107a5183b93$export$b820fc49f2736e85);
    var sendAnalytics = (0, $5bd12fcfcb46b8f6$export$e955abb82869dc84)();
    if (activeIndex !== propsActiveIndex && propsActiveIndex !== undefined) setActiveIndex(propsActiveIndex);
    // Safari v15.5 has an issue with scrolling when overflow='hidden'
    // and scroll-behavior='smooth'. For now we are detecting if the browser
    // is safari to workaround this issue. The issue should be resolved soon
    // and we can remove this. https://github.com/WebKit/WebKit/pull/1387
    var isSafari = typeof window !== 'undefined' ? /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent) : true;
    /* eslint-disable no-param-reassign */ delete rest.activeIndex;
    delete rest.onActive;
    /* eslint-enable no-param-reassign */ var tabRefs = (0, $2xPiy.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).Children.map(children, function() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createRef();
        });
    }, [
        children
    ]);
    var disabledIndexes = (0, $2xPiy.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).Children.map(children, function(child) {
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).isValidElement(child)) return true;
            return !!child.props.disabled;
        }) || [];
    }, [
        children
    ]);
    var focusTab = (0, $2xPiy.useCallback)(function(index) {
        var _tabRefs$index;
        if (index >= 0 && (_tabRefs$index = tabRefs[index]) != null && _tabRefs$index.current) tabRefs[index].current.focus();
    }, [
        tabRefs
    ]);
    var findEnabledIndex = (0, $2xPiy.useCallback)(function(startIndex, direction) {
        if (!disabledIndexes.length) return undefined;
        var normalizeIndex = function normalizeIndex(index) {
            if (index < 0) return disabledIndexes.length - 1;
            if (index >= disabledIndexes.length) return 0;
            return index;
        };
        var nextIndex = normalizeIndex(startIndex);
        var attempts = 0;
        while(attempts < disabledIndexes.length){
            if (!disabledIndexes[nextIndex]) return nextIndex;
            nextIndex = normalizeIndex(nextIndex + direction);
            attempts += 1;
        }
        return undefined;
    }, [
        disabledIndexes
    ]);
    var getClosestEnabledIndex = (0, $2xPiy.useCallback)(function(preferredIndex) {
        if (!disabledIndexes.length) return undefined;
        var clampedIndex = Math.min(Math.max(preferredIndex, 0), disabledIndexes.length - 1);
        if (!disabledIndexes[clampedIndex]) return clampedIndex;
        for(var offset = 1; offset < disabledIndexes.length; offset += 1){
            var nextIndex = clampedIndex + offset;
            if (nextIndex < disabledIndexes.length && !disabledIndexes[nextIndex]) return nextIndex;
            var previousIndex = clampedIndex - offset;
            if (previousIndex >= 0 && !disabledIndexes[previousIndex]) return previousIndex;
        }
        return undefined;
    }, [
        disabledIndexes
    ]);
    var resolvedActiveIndex = (0, $2xPiy.useMemo)(function() {
        if (!disabledIndexes.length) return undefined;
        if (activeIndex < 0 || activeIndex >= disabledIndexes.length) return getClosestEnabledIndex(activeIndex);
        if (disabledIndexes[activeIndex]) return getClosestEnabledIndex(activeIndex);
        return activeIndex;
    }, [
        activeIndex,
        disabledIndexes,
        getClosestEnabledIndex
    ]);
    var activateTab = (0, $2xPiy.useCallback)(function(nextIndex) {
        sendAnalytics({
            type: 'activateTab',
            element: tabRefs[nextIndex].current
        });
        if (propsActiveIndex === undefined) setActiveIndex(nextIndex);
        if (onActive) onActive(nextIndex);
    }, [
        onActive,
        propsActiveIndex,
        sendAnalytics,
        tabRefs
    ]);
    var moveFocus = (0, $2xPiy.useCallback)(function(targetIndex) {
        if (targetIndex === undefined) return;
        focusTab(targetIndex);
    }, [
        focusTab
    ]);
    var moveFocusByKey = (0, $2xPiy.useCallback)(function(currentIndex, direction) {
        moveFocus(findEnabledIndex(currentIndex + direction, direction));
    }, [
        findEnabledIndex,
        moveFocus
    ]);
    var moveFocusToEdge = (0, $2xPiy.useCallback)(function(direction) {
        var startIndex = direction > 0 ? 0 : tabRefs.length - 1;
        moveFocus(findEnabledIndex(startIndex, direction));
    }, [
        findEnabledIndex,
        moveFocus,
        tabRefs.length
    ]);
    var handleTabKeyDown = (0, $2xPiy.useCallback)(function(index, event) {
        switch(event.key){
            case 'ArrowRight':
                event.preventDefault();
                moveFocusByKey(index, 1);
                break;
            case 'ArrowLeft':
                event.preventDefault();
                moveFocusByKey(index, -1);
                break;
            case 'Home':
                event.preventDefault();
                moveFocusToEdge(1);
                break;
            case 'End':
                event.preventDefault();
                moveFocusToEdge(-1);
                break;
            case 'Enter':
            case ' ':
            case 'Spacebar':
                event.preventDefault();
                activateTab(index);
                break;
            default:
        }
    }, [
        activateTab,
        moveFocusByKey,
        moveFocusToEdge
    ]);
    // check if tab is in view
    var isVisible = (0, $2xPiy.useCallback)(function(index) {
        if (tabRefs[index].current) {
            var _headerRef$current;
            var tabRect = tabRefs[index].current.getBoundingClientRect();
            var headerRect = (_headerRef$current = headerRef.current) == null ? void 0 : _headerRef$current.getBoundingClientRect();
            if (tabRect && headerRect) // the -1 and +1 allow a little leniency when calculating if a tab
            // is in view. Without the -1 and +1 a tab could be fully in view
            // but isVisible will return false.
            return tabRect.left >= headerRect.left - 1 && tabRect.right <= headerRect.right + 1;
        }
        return undefined;
    }, [
        headerRef,
        tabRefs
    ]);
    var updateArrowState = (0, $2xPiy.useCallback)(function() {
        setDisableLeftArrow(isVisible(0));
        setDisableRightArrow(isVisible(tabRefs.length - 1));
    }, [
        tabRefs,
        isVisible
    ]);
    var scrollTo = (0, $2xPiy.useCallback)(function(index, keyboard) {
        var tabRect = tabRefs[index].current.getBoundingClientRect();
        var headerRect = headerRef.current.getBoundingClientRect();
        var amountHidden = 0;
        if (tabRect.left >= headerRect.left && tabRect.left <= headerRect.right) amountHidden = tabRect.width - (headerRect.right - tabRect.left);
        else if (tabRect.right >= headerRect.left && tabRect.right <= headerRect.right) {
            amountHidden = tabRect.width - (tabRect.right - headerRect.left);
            amountHidden = 0 - amountHidden;
        } else if (tabRect.left >= headerRect.right) amountHidden = tabRect.right - headerRect.right;
        else if (tabRect.right <= headerRect.left) {
            amountHidden = headerRect.left - tabRect.left;
            amountHidden = 0 - amountHidden;
        }
        // We are adding or subtracting 2 from amountHidden to
        // ensure the focusIndicator is visible when navigating
        // by keyboard
        if (keyboard) {
            if (amountHidden < 0) amountHidden -= 2;
            if (amountHidden > 0) amountHidden += 2;
        }
        if (isSafari) headerRef.current.scrollBy({
            left: amountHidden
        });
        else headerRef.current.scrollBy({
            left: amountHidden,
            behavior: 'smooth'
        });
        // wait for scroll animation to finish
        // checks every 50 milliseconds for 1000 milliseconds
        // if the scroll animation has finished. Most scroll
        // animations will finish in 1000 milliseconds unless
        // the tab name is very long.
        if (isSafari) updateArrowState();
        else {
            var checkVisible = setInterval(function() {
                if (tabRefs[index].current && isVisible(index)) {
                    updateArrowState();
                    clearInterval(checkVisible);
                }
            }, 50);
            setTimeout(function() {
                updateArrowState();
                clearInterval(checkVisible);
            }, 1000);
        }
    }, [
        tabRefs,
        headerRef,
        isVisible,
        updateArrowState,
        isSafari
    ]);
    var moveByArrowKey = function moveByArrowKey(direction) {
        var previous = direction === 'previous';
        var index = direction === 'previous' ? 0 : tabRefs.length - 1;
        var scrolledToIndex;
        var moveBy = theme.tabs.step[size] - 1 || 0;
        while(scrolledToIndex === undefined && (previous && index < tabRefs.length - 1 || !previous && index > 0)){
            if (!isVisible(index) && (previous && isVisible(index + 1) || !previous && isVisible(index - 1))) {
                if (previous) {
                    if (index - moveBy >= 0) {
                        scrollTo(index - moveBy, false);
                        scrolledToIndex = index - moveBy;
                    } else {
                        scrollTo(0, false);
                        scrolledToIndex = 0;
                    }
                } else if (index + moveBy < tabRefs.length) {
                    scrollTo(index + moveBy, false);
                    scrolledToIndex = index + moveBy;
                } else {
                    scrollTo(tabRefs.length - 1, false);
                    scrolledToIndex = tabRefs.length - 1;
                }
            }
            index = previous ? index + 1 : index - 1;
        }
    };
    (0, $2xPiy.useEffect)(function() {
        var _tabRefs$resolvedActi;
        // if the active tab isn't visible scroll to it
        if (overflow && tabRefs && resolvedActiveIndex !== undefined && (_tabRefs$resolvedActi = tabRefs[resolvedActiveIndex]) != null && _tabRefs$resolvedActi.current && !isVisible(resolvedActiveIndex)) scrollTo(resolvedActiveIndex, true);
    }, [
        overflow,
        resolvedActiveIndex,
        tabRefs,
        isVisible,
        scrollTo
    ]);
    (0, $2xPiy.useEffect)(function() {
        // scroll focus item into view if it is not already visible
        if (overflow && focusIndex !== -1 && !isVisible(focusIndex)) scrollTo(focusIndex, true);
        else if (overflow && focusIndex !== -1) {
            // If the browser scrolled the focused item into view and
            // the focusedTab is on the edge of the header container
            // scroll slightly further to show the focusIndicator
            var tabRect = tabRefs[focusIndex].current.getBoundingClientRect();
            var headerRect = headerRef.current.getBoundingClientRect();
            var amountHidden = 0;
            if (tabRect.left >= headerRect.left && tabRect.right <= headerRect.right && tabRect.right + 2 >= headerRect.right) amountHidden = 2;
            else if (tabRect.right <= headerRect.right && tabRect.left >= headerRect.left && tabRect.left - 2 <= headerRect.left) amountHidden = -2;
            headerRef.current.scrollBy({
                left: amountHidden
            });
        }
    }, [
        overflow,
        tabRefs,
        focusIndex,
        isVisible,
        scrollTo
    ]);
    (0, $9462599f26e06396$export$e5c5a5f917a5871c)(function() {
        var onResize = function onResize() {
            // check if tabs are overflowing
            if (headerRef.current.scrollWidth > headerRef.current.offsetWidth) setOverflow(true);
            else setOverflow(false);
            updateArrowState();
        };
        onResize();
        window.addEventListener('resize', onResize);
        return function() {
            return window.removeEventListener('resize', onResize);
        };
    }, [
        tabRefs,
        activeIndex,
        headerRef,
        updateArrowState
    ]);
    (0, $9462599f26e06396$export$e5c5a5f917a5871c)(function() {
        if (focusIndex === -1 || !headerRef.current) return;
        var _document = document, activeElement = _document.activeElement;
        if (headerRef.current.contains(activeElement)) return;
        var nextFocusIndex = getClosestEnabledIndex(focusIndex);
        if (nextFocusIndex === undefined) {
            setFocusIndex(-1);
            return;
        }
        setFocusIndex(nextFocusIndex);
        focusTab(nextFocusIndex);
    }, [
        children,
        focusIndex,
        focusTab,
        getClosestEnabledIndex
    ]);
    var getTabsContext = (0, $2xPiy.useCallback)(function(index) {
        return {
            activeIndex: resolvedActiveIndex,
            active: resolvedActiveIndex === index,
            focusable: focusIndex === -1 ? resolvedActiveIndex === index : focusIndex === index,
            index: index,
            panelId: panelId,
            ref: tabRefs[index],
            onActivate: function onActivate() {
                return activateTab(index);
            },
            onKeyDown: function onKeyDown(event) {
                return handleTabKeyDown(index, event);
            },
            onNext: function onNext() {
                return moveFocusByKey(index, 1);
            },
            onPrevious: function onPrevious() {
                return moveFocusByKey(index, -1);
            },
            onFirst: function onFirst() {
                return moveFocusToEdge(1);
            },
            onLast: function onLast() {
                return moveFocusToEdge(-1);
            },
            setActiveContent: setActiveContent,
            setActiveTitle: setActiveTitle,
            setFocusIndex: setFocusIndex
        };
    }, [
        focusIndex,
        activateTab,
        handleTabKeyDown,
        moveFocusByKey,
        moveFocusToEdge,
        panelId,
        resolvedActiveIndex,
        tabRefs
    ]);
    var tabs = (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).Children.map(children, function(child, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $160c5cf4a8a6212d$export$cfa7aa87c26e7d1f).Provider, {
            value: getTabsContext(index)
        }, child ? /*#__PURE__*/ // cloneElement is needed for backward compatibility with custom
        // styled components that rely on props.active. We should reassess
        // if it is still necessary in our next major release.
        (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).cloneElement(child, {
            active: resolvedActiveIndex === index
        }) : child);
    });
    var tabsHeaderStyles = {};
    if (theme.tabs.header && theme.tabs.header.border) {
        var borderColor = theme.tabs.header.border.color || theme.global.control.border.color;
        borderColor = (0, $11317b0e49e0d157$export$4cde5df63f53f473)(borderColor, theme);
        tabsHeaderStyles.border = {
            side: theme.tabs.header.border.side,
            size: theme.tabs.header.border.size,
            style: theme.tabs.header.border.style,
            color: borderColor
        };
    }
    var tabContentTitle = (activeTitle || '') + " " + format({
        id: 'tabs.tabContents',
        messages: messages
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $70d377dbeb60d70c$export$594ebcebca054019), $98fc76c952067c09$var$_extends({
        ref: ref,
        flex: flex,
        responsive: responsive
    }, passThemeFlag, rest, {
        background: theme.tabs.background
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), $98fc76c952067c09$var$_extends({
        alignSelf: alignControls || ((_theme$tabs$header3 = theme.tabs.header) == null ? void 0 : _theme$tabs$header3.alignSelf),
        flex: false,
        direction: overflow ? 'row' : 'column'
    }, tabsHeaderStyles), overflow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
        a11yTitle: format({
            id: 'tabs.previousTab',
            messages: messages
        }),
        disabled: disableLeftArrow,
        tabIndex: -1,
        onClick: function onClick() {
            return moveByArrowKey('previous');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        pad: theme.tabs.header.previousButton.pad
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(PreviousIcon, {
        color: disableLeftArrow ? theme.button.disabled.color : theme.global.colors.text
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $70d377dbeb60d70c$export$9c5a323fcd5fd5a3), $98fc76c952067c09$var$_extends({
        role: "tablist",
        ref: headerRef,
        direction: "row",
        justify: overflow ? 'start' : justify,
        flex: !!overflow,
        wrap: false,
        overflow: overflow ? 'hidden' : 'visible',
        background: theme.tabs.header.background,
        gap: theme.tabs.gap,
        pad: overflow ? '2px' : undefined,
        margin: overflow ? '-2px' : undefined
    }, passThemeFlag), tabs), overflow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
        a11yTitle: format({
            id: 'tabs.nextTab',
            messages: messages
        }),
        disabled: disableRightArrow,
        tabIndex: -1,
        onClick: function onClick() {
            return moveByArrowKey('next');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        pad: (_theme$tabs$header4 = theme.tabs.header) == null || (_theme$tabs$header4 = _theme$tabs$header4.nextButton) == null ? void 0 : _theme$tabs$header4.pad
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement(NextIcon, {
        color: disableRightArrow ? theme.button.disabled.color : theme.global.colors.text
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $70d377dbeb60d70c$export$6dde272a8363b335), $98fc76c952067c09$var$_extends({
        id: panelId,
        flex: flex,
        "aria-label": tabContentTitle,
        role: "tabpanel"
    }, passThemeFlag), activeContent));
});
$98fc76c952067c09$export$b2539bed5023c21c.displayName = 'Tabs';
$98fc76c952067c09$export$b2539bed5023c21c.propTypes = (0, $31841148ce8e65e6$export$45ba878828554cde);







const $9a0a037d937851c5$var$FuseAdminPrograms = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    const [selectedProgram, setSelectedProgram] = (0, $2xPiy.useState)('CA - Low Carbon Fuel Standard');
    const [activeTab, setActiveTab] = (0, $2xPiy.useState)(0);
    const programs = [
        'CA - Low Carbon Fuel Standard',
        'OR - Clean Fuels Program',
        'WA - WA CFS',
        'BC - Low Carbon Fuel Standard (BC-LCFS)',
        'CFR - Canadian Clean Fuels Regulation'
    ];
    // Fuel data
    const fuelData = [
        {
            fuelType: 'Gasoline',
            baseline: '105.26',
            units: 'gCO2e/MJ',
            updated: 'JAN 15 2025'
        },
        {
            fuelType: 'Gasoline',
            baseline: '105.26',
            units: 'gCO2e/MJ',
            updated: 'JAN 15 2025'
        },
        {
            fuelType: 'Diesel',
            baseline: '105.26r',
            units: 'gCO2e/MJ',
            updated: 'JAN 15 2025'
        },
        {
            fuelType: 'Gasoline',
            baseline: '105.26',
            units: 'gCO2e/MJ',
            updated: 'JAN 15 2025'
        },
        {
            fuelType: 'Diesel',
            baseline: '105.26',
            units: 'gCO2e/MJ',
            updated: 'JAN 15 2025'
        }
    ];
    const years = Array.from({
        length: 8
    }, (_, i)=>2023 + i);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        height: {
            min: '100vh'
        },
        background: "light",
        style: {
            display: 'flex',
            flexDirection: 'column'
        },
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c3e91fa8212c6d4c$export$50d7b5e01df871ca), {}),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                flex: "grow",
                style: {
                    display: 'flex',
                    flexDirection: 'row',
                    minHeight: 0
                },
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $531f50b0ef9e074f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        flex: "grow",
                        pad: {
                            horizontal: 'large',
                            vertical: 'medium'
                        },
                        overflow: "auto",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            flex: false,
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    direction: "row",
                                    align: "center",
                                    justify: "between",
                                    margin: {
                                        vertical: 'medium'
                                    },
                                    pad: {
                                        horizontal: 'small'
                                    },
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "xlarge",
                                        weight: "normal",
                                        children: [
                                            "Program Configuration",
                                            ' ',
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                as: "span",
                                                size: "xlarge",
                                                color: "status-critical",
                                                weight: "normal",
                                                children: "Mock Data"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    direction: "row",
                                    justify: "between",
                                    align: "center",
                                    margin: {
                                        vertical: 'small'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b3fb5add06fccd6e$export$ef9b1a59e592288f), {
                                            value: selectedProgram,
                                            options: programs,
                                            onChange: ({ option: option })=>setSelectedProgram(option),
                                            style: {
                                                borderRadius: '8px',
                                                border: '1px solid #e0e0e0',
                                                minWidth: '400px'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                            primary: true,
                                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b354176c7fc1b147$export$d0265b2c425512d6), {}),
                                            label: "Add Partner",
                                            onClick: ()=>{},
                                            style: {
                                                borderRadius: '8px',
                                                fontWeight: 'normal'
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
                                    background: "white",
                                    elevation: "none",
                                    round: "xsmall",
                                    margin: {
                                        bottom: 'large'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                                            pad: {
                                                horizontal: 'medium',
                                                vertical: 'medium'
                                            },
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "large",
                                                weight: "normal",
                                                children: selectedProgram
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                                            pad: "none",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                    background: "light-4",
                                                    pad: {
                                                        horizontal: 'medium'
                                                    },
                                                    round: "small",
                                                    margin: {
                                                        horizontal: 'medium',
                                                        vertical: 'small'
                                                    },
                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $98fc76c952067c09$export$b2539bed5023c21c), {
                                                        activeIndex: activeTab,
                                                        onActive: setActiveTab,
                                                        children: [
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $96a81eab79474076$export$3e41faf802a29e71), {
                                                                title: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                    color: activeTab === 0 ? 'brand' : 'dark-3',
                                                                    children: "Baseline CI Scores"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $96a81eab79474076$export$3e41faf802a29e71), {
                                                                title: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                    color: activeTab === 1 ? 'brand' : 'dark-3',
                                                                    children: "Grid Carbon Intensity"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $96a81eab79474076$export$3e41faf802a29e71), {
                                                                title: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                    color: activeTab === 2 ? 'brand' : 'dark-3',
                                                                    children: "Equipment Details"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                activeTab === 0 && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                    pad: "medium",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                            direction: "row",
                                                            gap: "small",
                                                            margin: {
                                                                vertical: 'medium'
                                                            },
                                                            children: years.map((year)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                    pad: {
                                                                        horizontal: 'small',
                                                                        vertical: 'xsmall'
                                                                    },
                                                                    border: {
                                                                        color: 'light-4',
                                                                        size: '1px'
                                                                    },
                                                                    round: "medium",
                                                                    style: {
                                                                        minWidth: '70px',
                                                                        textAlign: 'center'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                        size: "small",
                                                                        children: year
                                                                    })
                                                                }, year))
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
                                                            pad: {
                                                                horizontal: '1.5rem'
                                                            },
                                                            columns: [
                                                                {
                                                                    property: 'fuelType',
                                                                    header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                                        toUpperCase: true,
                                                                        children: "Fuel Type"
                                                                    }),
                                                                    render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                            pad: {
                                                                                vertical: '1rem'
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                                children: datum.fuelType
                                                                            })
                                                                        })
                                                                },
                                                                {
                                                                    property: 'baseline',
                                                                    header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                                        toUpperCase: true,
                                                                        children: "Baseline CI Score"
                                                                    }),
                                                                    render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                            pad: {
                                                                                vertical: '1rem'
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                                children: datum.baseline
                                                                            })
                                                                        })
                                                                },
                                                                {
                                                                    property: 'units',
                                                                    header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                                        toUpperCase: true,
                                                                        children: "Units"
                                                                    }),
                                                                    render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                            pad: {
                                                                                vertical: '1rem'
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                                children: datum.units
                                                                            })
                                                                        })
                                                                },
                                                                {
                                                                    property: 'updated',
                                                                    header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                                        toUpperCase: true,
                                                                        children: "Updated"
                                                                    }),
                                                                    render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                            pad: {
                                                                                vertical: '1rem'
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                                children: datum.updated
                                                                            })
                                                                        })
                                                                }
                                                            ],
                                                            data: fuelData,
                                                            background: [
                                                                'light-6',
                                                                'white'
                                                            ],
                                                            border: {
                                                                color: 'light-2',
                                                                side: 'bottom',
                                                                size: 'small'
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                flex: false,
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $605617a28ba64070$export$3210cca7a959581e), {})
            })
        ]
    });
});
var $9a0a037d937851c5$export$2e2bcd8739ae039 = $9a0a037d937851c5$var$FuseAdminPrograms;




var $2xPiy = parcelRequire("2xPiy");










const $9ffdc6ade7098952$var$FuseAdminReferral = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    const [searchQuery, setSearchQuery] = (0, $2xPiy.useState)('');
    const [referralPartners, setReferralPartners] = (0, $2xPiy.useState)([]);
    const [filteredPartners, setFilteredPartners] = (0, $2xPiy.useState)([]);
    const [isLoading, setIsLoading] = (0, $2xPiy.useState)(true);
    const [currentPage, setCurrentPage] = (0, $2xPiy.useState)(1);
    const itemsPerPage = 10;
    const [isModalVisible, setIsModalVisible] = (0, $2xPiy.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $2xPiy.useState)(false);
    const [nameError, setNameError] = (0, $2xPiy.useState)('');
    const [formData, setFormData] = (0, $2xPiy.useState)({
        name: ''
    });
    (0, $2xPiy.useEffect)(()=>{
        fetchReferralPartners();
    }, []);
    (0, $2xPiy.useEffect)(()=>{
        if (searchQuery.trim() === '') setFilteredPartners(referralPartners);
        else {
            const query = searchQuery.toLowerCase();
            const filtered = referralPartners.filter((partner)=>partner.name.toLowerCase().includes(query));
            setFilteredPartners(filtered);
        }
        setCurrentPage(1);
    }, [
        searchQuery,
        referralPartners
    ]);
    const fetchReferralPartners = async ()=>{
        try {
            setIsLoading(true);
            const partners = await (0, $aab6e7692a93396d$export$fec76eb589c20b4f).list();
            const excludedIds = [
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                11,
                13,
                14,
                15,
                35
            ];
            const filteredPartners = partners.filter((partner)=>!excludedIds.includes(partner.id));
            setReferralPartners(filteredPartners);
            setFilteredPartners(filteredPartners);
        } catch (err) {
            console.error('Error fetching referral partners:', err);
        } finally{
            setIsLoading(false);
        }
    };
    const handleSearch = (query)=>{
        setSearchQuery(query);
    };
    const paginatedPartners = filteredPartners.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    const handleSubmit = async ()=>{
        if (!formData.name.trim()) {
            setNameError('Partner name is required');
            (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).createReferralPartner.requiredFields);
            return;
        }
        try {
            setIsSubmitting(true);
            await (0, $aab6e7692a93396d$export$fec76eb589c20b4f).create(formData);
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).createReferralPartner.success);
            setIsModalVisible(false);
            setFormData({
                name: ''
            });
            setNameError('');
            fetchReferralPartners();
        } catch (error) {
            console.error('Error creating referral partner:', error);
            (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).createReferralPartner.error(error));
        } finally{
            setIsSubmitting(false);
        }
    };
    const handleCloseModal = ()=>{
        setIsModalVisible(false);
        setFormData({
            name: ''
        });
        setNameError('');
    };
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        height: {
            min: '100vh'
        },
        background: "light",
        style: {
            display: 'flex',
            flexDirection: 'column'
        },
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c3e91fa8212c6d4c$export$50d7b5e01df871ca), {}),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                flex: "grow",
                style: {
                    display: 'flex',
                    flexDirection: 'row',
                    minHeight: 0
                },
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $531f50b0ef9e074f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        flex: "grow",
                        pad: {
                            horizontal: 'large',
                            vertical: 'medium'
                        },
                        overflow: "auto",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            flex: false,
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    direction: "row",
                                    align: "center",
                                    justify: "between",
                                    margin: {
                                        vertical: 'medium'
                                    },
                                    pad: {
                                        horizontal: 'small'
                                    },
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "xlarge",
                                        weight: "normal",
                                        children: "Referral Partners"
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    align: "end",
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                        primary: true,
                                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b354176c7fc1b147$export$d0265b2c425512d6), {}),
                                        label: "Add Partner",
                                        onClick: ()=>setIsModalVisible(true),
                                        style: {
                                            borderRadius: '8px',
                                            fontWeight: 'normal'
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
                                    margin: {
                                        vertical: 'small'
                                    },
                                    background: "white",
                                    elevation: "none",
                                    round: "xsmall",
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                                            title: "Referral List",
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                flex: "grow",
                                                align: "end",
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f7f71094d2af306c$export$55d7609a8f1eccd2), {
                                                    searchQuery: searchQuery,
                                                    setSearchQuery: setSearchQuery,
                                                    onSearch: handleSearch,
                                                    placeholder: "Search partners..."
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                                            pad: "none",
                                            children: isLoading ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                pad: "large",
                                                align: "center",
                                                justify: "center",
                                                height: "200px",
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {})
                                            }) : filteredPartners.length === 0 ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                pad: "large",
                                                align: "center",
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    children: "No referral partners found"
                                                })
                                            }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
                                                        pad: {
                                                            horizontal: '1.5rem'
                                                        },
                                                        columns: [
                                                            {
                                                                property: 'name',
                                                                header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                                    toUpperCase: true,
                                                                    children: "Partner Name"
                                                                }),
                                                                size: '70%',
                                                                render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                        pad: {
                                                                            vertical: '1rem'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                            children: datum.name
                                                                        })
                                                                    })
                                                            }
                                                        ],
                                                        data: paginatedPartners,
                                                        sortable: true,
                                                        background: [
                                                            'light-6',
                                                            'white'
                                                        ],
                                                        border: {
                                                            color: 'light-2',
                                                            side: 'bottom',
                                                            size: 'small'
                                                        }
                                                    }),
                                                    filteredPartners.length > itemsPerPage && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                        pad: {
                                                            horizontal: 'medium',
                                                            vertical: 'small'
                                                        },
                                                        align: "center",
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ffccbada2139938a$export$68f5e1453c188a82), {
                                                            alignSelf: "center",
                                                            size: "small",
                                                            page: currentPage,
                                                            onChange: ({ page: page })=>setCurrentPage(page),
                                                            step: itemsPerPage,
                                                            numberItems: filteredPartners.length
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                flex: false,
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $605617a28ba64070$export$3210cca7a959581e), {})
            }),
            isModalVisible && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
                position: "center",
                onEsc: handleCloseModal,
                onClickOutside: handleCloseModal,
                responsive: false,
                style: {
                    width: 'auto',
                    maxWidth: 'min(95vw, 500px)',
                    maxHeight: '95vh',
                    overflow: 'auto',
                    borderRadius: '8px'
                },
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
                    width: "100%",
                    style: {
                        width: '100%'
                    },
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                            title: "Add Referral Partner"
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                            pad: {
                                vertical: 'medium',
                                horizontal: 'large'
                            },
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                gap: "medium",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        label: "Referral Partner Name",
                                        value: formData.name,
                                        setValue: (value)=>{
                                            setFormData({
                                                ...formData,
                                                name: value
                                            });
                                            if (nameError) setNameError('');
                                        },
                                        placeholder: "Enter partner name",
                                        required: true,
                                        error: nameError,
                                        style: {
                                            width: '100%'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                        direction: "row",
                                        gap: "small",
                                        justify: "end",
                                        margin: {
                                            top: 'small'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                                label: "Cancel",
                                                onClick: handleCloseModal,
                                                disabled: isSubmitting,
                                                style: {
                                                    fontWeight: 'normal'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                                primary: true,
                                                label: isSubmitting ? 'Creating...' : 'Create Partner',
                                                onClick: handleSubmit,
                                                disabled: isSubmitting,
                                                style: {
                                                    fontWeight: 'normal'
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
});
var $9ffdc6ade7098952$export$2e2bcd8739ae039 = $9ffdc6ade7098952$var$FuseAdminReferral;




var $2xPiy = parcelRequire("2xPiy");


var $2xPiy = parcelRequire("2xPiy");

function $7fdd2ebba7fff41b$var$_extends() {
    return $7fdd2ebba7fff41b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7fdd2ebba7fff41b$var$_extends.apply(null, arguments);
}
var $7fdd2ebba7fff41b$export$d440bfe209149ca5 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $7fdd2ebba7fff41b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "More"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M3 13v-2h2v2H3zm8 0v-2h2v2h-2zm8 0v-2h2v2h-2z"
    }));
});
$7fdd2ebba7fff41b$export$d440bfe209149ca5.displayName = 'More';






var $2xPiy = parcelRequire("2xPiy");





class $b7af0d6ca3f47e77$export$9e3fe2960b03545c {
    /**
   * Get Stripe Global Payouts account info for a client
   * @param clientId The client ID
   * @returns StripeGlobalPayoutsAccount
   * @throws ApiError
   */ static getAccount = (clientId)=>(0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: `/clients/${clientId}/stripeGlobalPayouts`
        });
    /**
   * Update the notification email for a client's Stripe Global Payouts account
   * @param clientId The client ID
   * @param request UpdateEmailRequest
   * @returns updated email info
   * @throws ApiError
   */ static updateEmail = (clientId, request)=>(0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: `/clients/${clientId}/stripeGlobalPayouts/email`,
            body: request
        });
    /**
   * Update the bank account for a client's Stripe Global Payouts account
   * @param clientId The client ID
   * @param request UpdateBankAccountRequest
   * @returns updated bank account info
   * @throws ApiError
   */ static updateBankAccount = (clientId, request)=>(0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: `/clients/${clientId}/stripeGlobalPayouts/bankAccount`,
            body: request
        });
    /**
   * Create a recipient and return a Stripe-hosted onboarding link
   * @param clientId The client ID
   * @param email The recipient's email address
   * @returns onboarding URL
   * @throws ApiError
   */ static createOnboardingLink = (clientId, email)=>(0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: `/clients/${clientId}/stripeGlobalPayouts/onboarding`,
            body: {
                email: email
            }
        });
    /**
   * Create a new Stripe Global Payouts account for a client
   * @param clientId The client ID
   * @param recipientData The recipient data
   * @param bankAccountData Optional bank account data
   * @returns The client model with stripe_global_payouts_account_id
   * @throws ApiError
   */ static createRecipient = (clientId, recipientData, bankAccountData)=>(0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: `/clients/${clientId}/stripeGlobalPayouts`,
            body: {
                recipient_data: recipientData,
                bank_account_data: bankAccountData
            }
        });
}





const $2533e26425761f26$export$a0f90f17401b4548 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(({ isVisible: isVisible, setIsVisible: setIsVisible, onRecipientAdded: onRecipientAdded, clientId: clientId, clientName: clientName, client: client })=>{
    const isCanada = client?.hq_address_region?.country_id === (0, $0badf5665deea2b2$export$b77c37614753bffb).Canada;
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const regionOptions = globalStore.regions.filter((region)=>region.country_id === (0, $0badf5665deea2b2$export$b77c37614753bffb).USA && region.short_code).map((region)=>({
            label: `${region.name} (${region.short_code})`,
            value: region.id
        }));
    const [isSubmitting, setIsSubmitting] = (0, $2xPiy.useState)(false);
    const [errors, setErrors] = (0, $2xPiy.useState)({});
    const [submissionInProgress, setSubmissionInProgress] = (0, $2xPiy.useState)(false);
    const [bankData, setBankData] = (0, $2xPiy.useState)({
        routing_number: '',
        account_number: '',
        bank_account_type: 'checking'
    });
    const [onboardingEmail, setOnboardingEmail] = (0, $2xPiy.useState)('');
    const [isSendingOnboarding, setIsSendingOnboarding] = (0, $2xPiy.useState)(false);
    const [formData, setFormData] = (0, $2xPiy.useState)({
        contact_email: '',
        registered_name: '',
        address: {
            line1: '',
            line2: '',
            city: '',
            region_id: 0,
            postal_code: ''
        }
    });
    (0, $2xPiy.useEffect)(()=>{
        if (!isVisible || !clientName) return;
        setFormData((prev)=>{
            if (prev.registered_name.trim().length > 0) return prev;
            return {
                ...prev,
                registered_name: clientName
            };
        });
    }, [
        isVisible,
        clientName
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (!isVisible || !isCanada || !client) return;
        setFormData((prev)=>({
                ...prev,
                address: {
                    line1: client.hq_address_line1 ?? '',
                    line2: client.hq_address_line2 ?? '',
                    city: client.hq_address_city ?? '',
                    region_id: client.hq_address_region_id ?? 0,
                    postal_code: client.hq_address_post_code ?? ''
                }
            }));
    }, [
        isVisible,
        isCanada,
        client
    ]);
    const updateAddressField = (field, value)=>{
        setFormData((prev)=>{
            const prevAddress = prev.address ?? {
                line1: '',
                line2: '',
                city: '',
                region_id: 0,
                postal_code: ''
            };
            return {
                ...prev,
                address: {
                    ...prevAddress,
                    [field]: value
                }
            };
        });
    };
    const updateRegion = (regionId)=>{
        setFormData((prev)=>{
            const prevAddress = prev.address ?? {
                line1: '',
                line2: '',
                city: '',
                region_id: 0,
                postal_code: ''
            };
            return {
                ...prev,
                address: {
                    ...prevAddress,
                    region_id: regionId
                }
            };
        });
    };
    const validateForm = ()=>{
        const newErrors = {};
        if (!formData.registered_name.trim()) newErrors.registered_name = 'Registered Name is required';
        if (!formData.contact_email.trim()) newErrors.contact_email = 'Email is required';
        const hasRouting = bankData.routing_number.trim().length > 0;
        const hasAccount = bankData.account_number.trim().length > 0;
        if (hasRouting && !hasAccount) newErrors.account_number = 'Account Number is required';
        if (hasAccount && !hasRouting) newErrors.routing_number = 'Routing Number is required';
        if (isCanada) {
            const address = formData.address;
            if (!address?.line1?.trim()) newErrors.line1 = 'Address is required';
            if (!address?.city?.trim()) newErrors.city = 'City is required';
            if (!address?.region_id) newErrors.region_id = 'State is required';
            if (!address?.postal_code?.trim()) newErrors.postal_code = 'Postal Code is required';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const initialBankData = {
        routing_number: '',
        account_number: '',
        bank_account_type: 'checking'
    };
    const initialFormData = {
        contact_email: '',
        registered_name: '',
        address: {
            line1: '',
            line2: '',
            city: '',
            region_id: 0,
            postal_code: ''
        }
    };
    const resetForm = ()=>{
        setBankData(initialBankData);
        setFormData(initialFormData);
        setErrors({});
    };
    const handleClose = ()=>{
        resetForm();
        setOnboardingEmail('');
        setIsVisible(false);
    };
    const handleSubmit = async ()=>{
        if (!validateForm()) return;
        if (submissionInProgress) return;
        if (!clientId) {
            (0, $05d5739209a21833$export$b410431fab84fa58).error('Client ID is required');
            return;
        }
        setSubmissionInProgress(true);
        setIsSubmitting(true);
        try {
            const hasBankData = bankData.routing_number.trim().length > 0 && bankData.account_number.trim().length > 0;
            const recipientData = {
                contact_email: formData.contact_email,
                registered_name: formData.registered_name,
                address: isCanada ? formData.address : undefined
            };
            const result = await (0, $b7af0d6ca3f47e77$export$9e3fe2960b03545c).createRecipient(clientId, recipientData, hasBankData ? bankData : undefined);
            if (result.stripe_global_payouts_account_id) {
                (0, $05d5739209a21833$export$b410431fab84fa58).success(hasBankData ? 'Recipient and bank account added successfully' : 'Recipient added successfully');
                resetForm();
                setIsVisible(false);
                onRecipientAdded();
            } else (0, $05d5739209a21833$export$b410431fab84fa58).error('Failed to add recipient');
        } catch (error) {
            console.error('Error adding recipient:', error);
            let errorMsg = 'Failed to add recipient';
            if (error instanceof (0, $0402375deeb915a2$export$f2e832acab1bdd79) && error.body) {
                const body = error.body;
                errorMsg = body.error || body.message || errorMsg;
            } else if (error instanceof Error) errorMsg = error.message;
            (0, $05d5739209a21833$export$b410431fab84fa58).error(errorMsg);
        } finally{
            setIsSubmitting(false);
            setSubmissionInProgress(false);
        }
    };
    const handleSendOnboardingEmail = async ()=>{
        if (!onboardingEmail.trim()) {
            setErrors((prev)=>({
                    ...prev,
                    onboarding_email: 'Email is required'
                }));
            return;
        }
        if (!clientId) {
            (0, $05d5739209a21833$export$b410431fab84fa58).error('Client ID is required');
            return;
        }
        setIsSendingOnboarding(true);
        try {
            const result = await (0, $b7af0d6ca3f47e77$export$9e3fe2960b03545c).createOnboardingLink(clientId, onboardingEmail.trim());
            if (result.url) {
                window.open(result.url, '_blank');
                (0, $05d5739209a21833$export$b410431fab84fa58).success('Onboarding link opened');
                setOnboardingEmail('');
                setIsVisible(false);
                onRecipientAdded();
            } else (0, $05d5739209a21833$export$b410431fab84fa58).error('Failed to create onboarding link');
        } catch (error) {
            console.error('Error creating onboarding link:', error);
            let errorMsg = 'Failed to create onboarding link';
            if (error instanceof (0, $0402375deeb915a2$export$f2e832acab1bdd79) && error.body) {
                const body = error.body;
                errorMsg = body.error || body.message || errorMsg;
            } else if (error instanceof Error) errorMsg = error.message;
            (0, $05d5739209a21833$export$b410431fab84fa58).error(errorMsg);
        } finally{
            setIsSendingOnboarding(false);
        }
    };
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
        background: "transparent",
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
            width: "100%",
            style: {
                maxWidth: userStore.isFuseAdmin ? 760 : 600,
                minWidth: 500
            },
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                    title: "Create Stripe Recipient"
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                    pad: {
                        vertical: 'medium',
                        horizontal: 'large'
                    },
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        gap: "medium",
                        children: userStore.isFuseAdmin ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    direction: "row",
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            flex: true,
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    label: "Registered Name",
                                                    value: formData.registered_name,
                                                    setValue: (value)=>setFormData({
                                                            ...formData,
                                                            registered_name: value
                                                        }),
                                                    placeholder: "Enter registered name",
                                                    required: true,
                                                    error: errors.registered_name,
                                                    style: {
                                                        width: '100%'
                                                    },
                                                    margin: {
                                                        bottom: 'small'
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    label: "Email Address",
                                                    value: formData.contact_email,
                                                    setValue: (value)=>setFormData({
                                                            ...formData,
                                                            contact_email: value
                                                        }),
                                                    placeholder: "Enter email address",
                                                    type: "email",
                                                    required: true,
                                                    error: errors.contact_email,
                                                    style: {
                                                        width: '100%'
                                                    },
                                                    margin: {
                                                        bottom: 'small'
                                                    }
                                                }),
                                                isCanada && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                            label: "Address",
                                                            value: formData.address?.line1 ?? '',
                                                            setValue: (value)=>updateAddressField('line1', value),
                                                            placeholder: "Enter street address",
                                                            required: true,
                                                            error: errors.line1,
                                                            style: {
                                                                width: '100%'
                                                            },
                                                            margin: {
                                                                bottom: 'small'
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                            label: "Address Line 2",
                                                            value: formData.address?.line2 ?? '',
                                                            setValue: (value)=>updateAddressField('line2', value),
                                                            placeholder: "Apartment, suite, unit, etc. (optional)",
                                                            style: {
                                                                width: '100%'
                                                            },
                                                            margin: {
                                                                bottom: 'small'
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                            direction: "row",
                                                            gap: "small",
                                                            children: [
                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                    flex: true,
                                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                                        label: "City",
                                                                        value: formData.address?.city ?? '',
                                                                        setValue: (value)=>updateAddressField('city', value),
                                                                        placeholder: "Enter city",
                                                                        required: true,
                                                                        error: errors.city,
                                                                        style: {
                                                                            width: '100%'
                                                                        },
                                                                        margin: {
                                                                            bottom: 'small'
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                    flex: true,
                                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                                        label: "Postal Code",
                                                                        value: formData.address?.postal_code ?? '',
                                                                        setValue: (value)=>updateAddressField('postal_code', value),
                                                                        placeholder: "Enter postal code",
                                                                        required: true,
                                                                        error: errors.postal_code,
                                                                        style: {
                                                                            width: '100%'
                                                                        },
                                                                        margin: {
                                                                            bottom: 'small'
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                            label: "State",
                                                            value: formData.address?.region_id || '',
                                                            setValue: (value)=>updateRegion(Number(value)),
                                                            options: regionOptions,
                                                            placeholder: "Select state",
                                                            required: true,
                                                            error: errors.region_id,
                                                            margin: {
                                                                bottom: 'small'
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                            direction: "vertical",
                                            margin: "2rem"
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            flex: true,
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    label: "Routing Number",
                                                    value: bankData.routing_number,
                                                    setValue: (value)=>setBankData({
                                                            ...bankData,
                                                            routing_number: value
                                                        }),
                                                    placeholder: "Enter routing number",
                                                    error: errors.routing_number,
                                                    style: {
                                                        width: '100%'
                                                    },
                                                    margin: {
                                                        bottom: 'small'
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    label: "Account Number",
                                                    value: bankData.account_number,
                                                    setValue: (value)=>setBankData({
                                                            ...bankData,
                                                            account_number: value
                                                        }),
                                                    placeholder: "Enter account number",
                                                    error: errors.account_number,
                                                    style: {
                                                        width: '100%'
                                                    },
                                                    margin: {
                                                        bottom: 'small'
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    direction: "row",
                                    gap: "small",
                                    justify: "end",
                                    margin: {
                                        top: 'small'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                            label: "Cancel",
                                            onClick: handleClose,
                                            disabled: isSubmitting,
                                            style: {
                                                fontWeight: 'normal'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                            primary: true,
                                            label: isSubmitting ? 'Loading...' : 'Create Recipient',
                                            onClick: handleSubmit,
                                            disabled: isSubmitting || submissionInProgress,
                                            style: {
                                                fontWeight: 'normal'
                                            }
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), {
                                    size: "large",
                                    color: "#5A6672",
                                    margin: {
                                        bottom: 'small',
                                        top: 'none'
                                    },
                                    weight: 300,
                                    children: "Stripe-Hosted Onboarding"
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                                    margin: {
                                        bottom: 'small'
                                    },
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), {
                                        size: "small",
                                        children: "Open a Stripe-hosted form where the recipient can provide their own payment details."
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                    label: "Email Address",
                                    value: onboardingEmail,
                                    setValue: (value)=>{
                                        setOnboardingEmail(value);
                                        if (errors.onboarding_email) setErrors((prev)=>({
                                                ...prev,
                                                onboarding_email: ''
                                            }));
                                    },
                                    placeholder: "Enter email address",
                                    type: "email",
                                    required: true,
                                    error: errors.onboarding_email,
                                    style: {
                                        width: '100%'
                                    },
                                    margin: {
                                        bottom: 'small'
                                    }
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    direction: "row",
                                    gap: "small",
                                    justify: "end",
                                    margin: {
                                        top: 'small'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                            label: "Cancel",
                                            onClick: handleClose,
                                            style: {
                                                fontWeight: 'normal'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                            primary: true,
                                            label: isSendingOnboarding ? 'Loading...' : 'Open Onboarding Form',
                                            onClick: handleSendOnboardingEmail,
                                            disabled: isSendingOnboarding,
                                            style: {
                                                fontWeight: 'normal'
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
});





var $2xPiy = parcelRequire("2xPiy");




const $51eae3a9f651618e$export$51b5b69ffbb62d98 = ({ isVisible: isVisible, setIsVisible: setIsVisible, selectedAccount: selectedAccount, onRecipientUpdated: onRecipientUpdated })=>{
    const [email, setEmail] = (0, $2xPiy.useState)(selectedAccount?.contact_email || '');
    const [loading, setLoading] = (0, $2xPiy.useState)(false);
    const handleSubmit = async ()=>{
        if (!selectedAccount) return;
        try {
            setLoading(true);
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updateStripeRecipient.success);
            onRecipientUpdated();
            setIsVisible(false);
        } catch (error) {
            console.error('Error updating recipient:', error);
            (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updateStripeRecipient.error(error));
        } finally{
            setLoading(false);
        }
    };
    if (!isVisible || !selectedAccount) return null;
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
        onEsc: ()=>setIsVisible(false),
        onClickOutside: ()=>setIsVisible(false),
        position: "center",
        modal: true,
        background: "transparent",
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $724dfb7ecf65a151$export$60332b2344f7fe41), {
            width: "100%",
            style: {
                maxWidth: 480,
                minWidth: 320
            },
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                    title: "Edit Email"
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $fdccc762800a972d$export$851de33184ecdac4), {
                    pad: {
                        vertical: 'medium',
                        horizontal: 'large'
                    },
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        gap: "medium",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $04d59a1221f4208a$export$a7fed597f4b8afd8), {
                            onSubmit: handleSubmit,
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    margin: {
                                        bottom: 'small'
                                    },
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        label: "Email",
                                        value: email,
                                        setValue: setEmail,
                                        placeholder: "Enter email",
                                        type: "email",
                                        required: true,
                                        style: {
                                            width: '100%'
                                        },
                                        margin: {
                                            bottom: 'small'
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    direction: "row",
                                    gap: "small",
                                    justify: "end",
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                            label: "Cancel",
                                            onClick: ()=>setIsVisible(false),
                                            disabled: loading,
                                            style: {
                                                fontWeight: 'normal'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                            primary: true,
                                            label: "Save",
                                            type: "submit",
                                            disabled: loading,
                                            style: {
                                                fontWeight: 'normal'
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};




var $2xPiy = parcelRequire("2xPiy");




const $409a4348112b5278$export$7e4b2d9b481e8f66 = ({ isVisible: isVisible, setIsVisible: setIsVisible, selectedAccount: selectedAccount })=>{
    const [amount, setAmount] = (0, $2xPiy.useState)('');
    const [isSendingMoney, setIsSendingMoney] = (0, $2xPiy.useState)(false);
    const formatAmount = (value)=>{
        const numericValue = value.replace(/[^0-9.]/g, '');
        const parts = numericValue.split('.');
        if (parts.length > 2) return parts[0] + '.' + parts.slice(1).join('');
        if (parts.length === 2 && parts[1].length > 2) return parts[0] + '.' + parts[1].slice(0, 2);
        return numericValue;
    };
    const handleAmountChange = (event)=>{
        const formattedValue = formatAmount(event.target.value);
        setAmount(formattedValue);
    };
    const handleSendMoney = async ()=>{
        if (!selectedAccount || !amount) {
            (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).moneyStripeTransfer.missingInfo);
            return;
        }
        setIsSendingMoney(true);
        try {
            const amountInCents = parseFloat(amount) * 100;
            if (isNaN(amountInCents) || amountInCents <= 0) {
                (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).moneyStripeTransfer.invalidAmount);
                setIsSendingMoney(false);
                return;
            }
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).moneyStripeTransfer.success);
            setIsVisible(false);
            setAmount('');
        } catch (error) {
            console.error('Error sending money:', error);
            (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).moneyStripeTransfer.error(error));
        } finally{
            setIsSendingMoney(false);
        }
    };
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
        onEsc: ()=>setIsVisible(false),
        onClickOutside: ()=>setIsVisible(false),
        position: "center",
        modal: true,
        background: "transparent",
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $724dfb7ecf65a151$export$60332b2344f7fe41), {
            width: "100%",
            style: {
                maxWidth: 480,
                minWidth: 320
            },
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                    title: "Send Money"
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $fdccc762800a972d$export$851de33184ecdac4), {
                    pad: {
                        vertical: 'medium',
                        horizontal: 'large'
                    },
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        gap: "medium",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), {
                                size: "small",
                                children: "Selected Account ID:"
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $281e2fcec27a8e6b$export$5f1af8db9871e1d6), {
                                weight: "bold",
                                size: "medium",
                                children: selectedAccount?.id
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                margin: {
                                    top: 'small'
                                },
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                    label: "Amount (USD):",
                                    type: "text",
                                    value: amount,
                                    onChange: handleAmountChange,
                                    placeholder: "0.00",
                                    required: true,
                                    min: "0.01",
                                    step: "0.01",
                                    prefix: "$"
                                })
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                direction: "row",
                                gap: "small",
                                justify: "end",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                        label: "Cancel",
                                        onClick: ()=>setIsVisible(false),
                                        disabled: isSendingMoney,
                                        style: {
                                            fontWeight: 'normal'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                        primary: true,
                                        label: isSendingMoney ? 'Sending...' : 'Send Money',
                                        onClick: handleSendMoney,
                                        disabled: isSendingMoney || !selectedAccount || !amount || parseFloat(amount) <= 0,
                                        style: {
                                            fontWeight: 'normal'
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};



const $9a47e08c1c8fab5d$var$mockAccounts = [
    {
        id: 'acc_1',
        display_name: 'John Doe',
        contact_email: 'john.doe@example.com'
    },
    {
        id: 'acc_2',
        display_name: 'Jane Smith',
        contact_email: 'jane.smith@example.com'
    },
    {
        id: 'acc_3',
        display_name: 'Bob Johnson',
        contact_email: 'bob.johnson@example.com'
    }
];
const $9a47e08c1c8fab5d$var$FuseAdminRemittance = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    const [accounts, setAccounts] = (0, $2xPiy.useState)([]);
    const [loading, setLoading] = (0, $2xPiy.useState)(true);
    const [isAddRecipientModalVisible, setIsAddRecipientModalVisible] = (0, $2xPiy.useState)(false);
    const [isSendMoneyModalVisible, setIsSendMoneyModalVisible] = (0, $2xPiy.useState)(false);
    const [isEditRecipientModalVisible, setIsEditRecipientModalVisible] = (0, $2xPiy.useState)(false);
    const [selectedAccount, setSelectedAccount] = (0, $2xPiy.useState)(null);
    const [selectedAccounts, setSelectedAccounts] = (0, $2xPiy.useState)([]);
    const fetchAccounts = async ()=>{
        try {
            setLoading(true);
            await new Promise((resolve)=>setTimeout(resolve, 1000));
            setAccounts($9a47e08c1c8fab5d$var$mockAccounts);
        } catch (error) {
            console.error('Error fetching Stripe accounts:', error);
        } finally{
            setLoading(false);
        }
    };
    (0, $2xPiy.useEffect)(()=>{
        fetchAccounts();
    }, []);
    const handleSendMoney = (account)=>{
        setSelectedAccount(account);
        setIsSendMoneyModalVisible(true);
    };
    const handleCheckboxChange = (accountId)=>{
        setSelectedAccounts((prevSelected)=>prevSelected.includes(accountId) ? prevSelected.filter((id)=>id !== accountId) : [
                ...prevSelected,
                accountId
            ]);
    };
    const handleEditRecipient = (account)=>{
        setSelectedAccount(account);
        setIsEditRecipientModalVisible(true);
    };
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        height: {
            min: '100vh'
        },
        background: "light",
        style: {
            display: 'flex',
            flexDirection: 'column'
        },
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c3e91fa8212c6d4c$export$50d7b5e01df871ca), {}),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                flex: "grow",
                style: {
                    display: 'flex',
                    flexDirection: 'row',
                    minHeight: 0
                },
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $531f50b0ef9e074f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        flex: "grow",
                        pad: {
                            horizontal: 'large',
                            vertical: 'medium'
                        },
                        overflow: "auto",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            flex: false,
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    direction: "row",
                                    align: "center",
                                    justify: "between",
                                    margin: {
                                        vertical: 'medium'
                                    },
                                    pad: {
                                        horizontal: 'small'
                                    },
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "xlarge",
                                        weight: "normal",
                                        children: [
                                            "Remittance",
                                            ' ',
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                as: "span",
                                                size: "xlarge",
                                                color: "status-critical",
                                                weight: "normal",
                                                children: "Mock Data"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    align: "center",
                                    justify: "end",
                                    direction: "row",
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                            primary: true,
                                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b354176c7fc1b147$export$d0265b2c425512d6), {}),
                                            label: "Add Recipient",
                                            onClick: ()=>setIsAddRecipientModalVisible(true),
                                            style: {
                                                borderRadius: '8px',
                                                fontWeight: 'normal'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                            primary: true,
                                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b354176c7fc1b147$export$d0265b2c425512d6), {}),
                                            label: "Send Money",
                                            onClick: ()=>{},
                                            style: {
                                                borderRadius: '8px',
                                                fontWeight: 'normal',
                                                marginLeft: '8px'
                                            },
                                            disabled: selectedAccounts.length === 0
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $724dfb7ecf65a151$export$60332b2344f7fe41), {
                                    margin: {
                                        vertical: 'small'
                                    },
                                    background: "white",
                                    elevation: "none",
                                    round: "xsmall",
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f557854f3abac6b7$export$5665775b26e26c5d), {
                                            pad: {
                                                horizontal: 'medium',
                                                vertical: 'medium'
                                            },
                                            border: {
                                                side: 'bottom',
                                                color: 'light-4',
                                                size: '1px'
                                            },
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "large",
                                                weight: "normal",
                                                children: "Stripe"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $fdccc762800a972d$export$851de33184ecdac4), {
                                            pad: "none",
                                            children: loading ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                align: "center",
                                                justify: "center",
                                                pad: "large",
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8bec6e2e7dc53c4a$export$7f7cbe89f1eacd2), {
                                                    size: "medium"
                                                })
                                            }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
                                                pad: {
                                                    horizontal: '1.5rem'
                                                },
                                                columns: [
                                                    {
                                                        property: 'select',
                                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                                                            checked: selectedAccounts.length === accounts.length && accounts.length > 0,
                                                            onChange: ()=>{
                                                                if (selectedAccounts.length === accounts.length) setSelectedAccounts([]);
                                                                else setSelectedAccounts(accounts.map((acc)=>acc.id));
                                                            }
                                                        }),
                                                        render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                                                                checked: selectedAccounts.includes(datum.id),
                                                                onChange: ()=>handleCheckboxChange(datum.id)
                                                            }),
                                                        size: '0%'
                                                    },
                                                    {
                                                        property: 'display_name',
                                                        primary: true,
                                                        size: '30%',
                                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            toUpperCase: true,
                                                            children: "NAME"
                                                        }),
                                                        render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                pad: {
                                                                    vertical: '1rem'
                                                                },
                                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                    children: datum.display_name
                                                                })
                                                            })
                                                    },
                                                    {
                                                        property: 'contact_email',
                                                        size: '20%',
                                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            toUpperCase: true,
                                                            children: "EMAIL"
                                                        }),
                                                        render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                pad: {
                                                                    vertical: '1rem'
                                                                },
                                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                    children: datum.contact_email
                                                                })
                                                            })
                                                    },
                                                    {
                                                        property: 'id',
                                                        size: '20%',
                                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            toUpperCase: true,
                                                            children: "ID"
                                                        }),
                                                        render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                pad: {
                                                                    vertical: '1rem'
                                                                },
                                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                    children: datum.id
                                                                })
                                                            })
                                                    },
                                                    {
                                                        property: 'actions',
                                                        size: '10%',
                                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            toUpperCase: true,
                                                            children: "ACTIONS"
                                                        }),
                                                        render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                round: "xsmall",
                                                                pad: {
                                                                    vertical: '1rem'
                                                                },
                                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $41d136aeffe9860f$export$d9b273488cd8ce6f), {
                                                                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7fdd2ebba7fff41b$export$d440bfe209149ca5), {
                                                                        size: "medium"
                                                                    }),
                                                                    items: [
                                                                        {
                                                                            label: 'Send Money',
                                                                            onClick: ()=>handleSendMoney(datum)
                                                                        },
                                                                        {
                                                                            label: 'Edit Email',
                                                                            onClick: ()=>handleEditRecipient(datum)
                                                                        }
                                                                    ],
                                                                    dropAlign: {
                                                                        top: 'bottom',
                                                                        right: 'right'
                                                                    },
                                                                    dropProps: {
                                                                        round: 'small',
                                                                        elevation: 'medium',
                                                                        background: 'white',
                                                                        style: {
                                                                            minWidth: 180,
                                                                            borderRadius: 12,
                                                                            boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
                                                                            border: '1px solid #D2D8DF'
                                                                        }
                                                                    }
                                                                })
                                                            })
                                                    }
                                                ],
                                                data: accounts,
                                                background: [
                                                    'light-6',
                                                    'white'
                                                ],
                                                border: {
                                                    color: 'light-2',
                                                    side: 'bottom',
                                                    size: 'small'
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                flex: false,
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $605617a28ba64070$export$3210cca7a959581e), {})
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2533e26425761f26$export$a0f90f17401b4548), {
                isVisible: isAddRecipientModalVisible,
                setIsVisible: setIsAddRecipientModalVisible,
                onRecipientAdded: fetchAccounts
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $409a4348112b5278$export$7e4b2d9b481e8f66), {
                isVisible: isSendMoneyModalVisible,
                setIsVisible: setIsSendMoneyModalVisible,
                selectedAccount: selectedAccount
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $51eae3a9f651618e$export$51b5b69ffbb62d98), {
                isVisible: isEditRecipientModalVisible,
                setIsVisible: setIsEditRecipientModalVisible,
                selectedAccount: selectedAccount,
                onRecipientUpdated: fetchAccounts
            })
        ]
    });
});
var $9a47e08c1c8fab5d$export$2e2bcd8739ae039 = $9a47e08c1c8fab5d$var$FuseAdminRemittance;




var $2xPiy = parcelRequire("2xPiy");






const $7b685783e6ba55db$var$FuseAdminDashboardReports = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    const dashboardStore = (0, $116967e0234c3770$export$176f58333fc13682)();
    const [activeTab, setActiveTab] = (0, $2xPiy.useState)('financial');
    const [selectedLocation, setSelectedLocation] = (0, $2xPiy.useState)('All Locations');
    const [selectedEquipment, setSelectedEquipment] = (0, $2xPiy.useState)('All Equipment');
    const [selectedQuarter, setSelectedQuarter] = (0, $2xPiy.useState)('Q2 2023');
    (0, $2xPiy.useEffect)(()=>{
        dashboardStore.getAdminView();
        return ()=>dashboardStore.clearDashboardData();
    }, []);
    // Financial data
    const financialData = [
        {
            facility: 'West Coast Facility',
            location: 'California',
            revenue: '$125,000',
            expenses: '$85,000',
            profit: '$40,000'
        },
        {
            facility: 'East Coast Hub',
            location: 'New York',
            revenue: '$143,000',
            expenses: '$98,000',
            profit: '$45,000'
        },
        {
            facility: 'Midwest Center',
            location: 'Illinois',
            revenue: '$98,000',
            expenses: '$67,000',
            profit: '$31,000'
        },
        {
            facility: 'Southern Depot',
            location: 'Texas',
            revenue: '$112,000',
            expenses: '$76,000',
            profit: '$36,000'
        },
        {
            facility: 'Northwest Station',
            location: 'Washington',
            revenue: '$86,000',
            expenses: '$58,000',
            profit: '$28,000'
        }
    ];
    const TabButton = ({ label: label, isActive: isActive, onClick: onClick })=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
            pad: {
                vertical: 'small',
                horizontal: 'medium'
            },
            onClick: onClick,
            hoverIndicator: {
                color: 'light-2',
                opacity: 'weak'
            },
            style: {
                cursor: 'pointer',
                transition: 'all 0.2s ease-in-out'
            },
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                color: isActive ? 'brand' : 'dark-3',
                size: "small",
                weight: isActive ? 'bold' : 'normal',
                style: {
                    letterSpacing: '0.2px'
                },
                children: label
            })
        });
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        height: {
            min: '100vh'
        },
        background: "light",
        style: {
            display: 'flex',
            flexDirection: 'column'
        },
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c3e91fa8212c6d4c$export$50d7b5e01df871ca), {}),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                flex: "grow",
                style: {
                    display: 'flex',
                    flexDirection: 'row',
                    minHeight: 0
                },
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $531f50b0ef9e074f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                        flex: "grow",
                        pad: {
                            horizontal: 'large',
                            vertical: 'medium'
                        },
                        overflow: "auto",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            flex: false,
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    direction: "row",
                                    align: "center",
                                    justify: "between",
                                    margin: {
                                        vertical: 'medium'
                                    },
                                    pad: {
                                        horizontal: 'small'
                                    },
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "xlarge",
                                        weight: "normal",
                                        children: [
                                            "Reports",
                                            ' ',
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                as: "span",
                                                size: "xlarge",
                                                color: "status-critical",
                                                weight: "normal",
                                                children: "Mock Data"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $724dfb7ecf65a151$export$60332b2344f7fe41), {
                                    background: "white",
                                    pad: "medium",
                                    margin: {
                                        bottom: 'medium',
                                        vertical: 'large'
                                    },
                                    elevation: "none",
                                    round: "xsmall",
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                        gap: "small",
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "large",
                                                weight: "normal",
                                                children: "Filter Reports"
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "small",
                                                color: "dark-6",
                                                children: "Filter reports by location, equipment type, and quarter."
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                direction: "row",
                                                gap: "medium",
                                                margin: {
                                                    top: 'small'
                                                },
                                                wrap: false,
                                                align: "center",
                                                justify: "between",
                                                width: "100%",
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                        basis: "30%",
                                                        flex: false,
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b3fb5add06fccd6e$export$ef9b1a59e592288f), {
                                                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $eec4bc4b18205d01$export$ec91da630f36d5ea), {
                                                                size: "small"
                                                            }),
                                                            value: selectedLocation,
                                                            options: [
                                                                'All Locations',
                                                                'California',
                                                                'New York',
                                                                'Illinois',
                                                                'Texas',
                                                                'Washington'
                                                            ],
                                                            onChange: ({ option: option })=>setSelectedLocation(option),
                                                            placeholder: "Select Location",
                                                            plain: true,
                                                            dropProps: {
                                                                round: 'xsmall',
                                                                margin: {
                                                                    top: 'xsmall'
                                                                }
                                                            },
                                                            style: {
                                                                background: '#F8F9FA',
                                                                padding: '12px 16px',
                                                                borderRadius: '4px',
                                                                border: '1px solid #E9ECEF',
                                                                width: '100%',
                                                                height: '44px'
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                        basis: "30%",
                                                        flex: false,
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b3fb5add06fccd6e$export$ef9b1a59e592288f), {
                                                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $eec4bc4b18205d01$export$ec91da630f36d5ea), {
                                                                size: "small"
                                                            }),
                                                            value: selectedEquipment,
                                                            options: [
                                                                'All Equipment',
                                                                'Type A',
                                                                'Type B',
                                                                'Type C'
                                                            ],
                                                            onChange: ({ option: option })=>setSelectedEquipment(option),
                                                            placeholder: "Select Equipment",
                                                            plain: true,
                                                            dropProps: {
                                                                round: 'xsmall',
                                                                margin: {
                                                                    top: 'xsmall'
                                                                }
                                                            },
                                                            style: {
                                                                background: '#F8F9FA',
                                                                padding: '12px 16px',
                                                                borderRadius: '4px',
                                                                border: '1px solid #E9ECEF',
                                                                width: '100%',
                                                                height: '44px'
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                        basis: "30%",
                                                        flex: false,
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b3fb5add06fccd6e$export$ef9b1a59e592288f), {
                                                            value: selectedQuarter,
                                                            options: [
                                                                'Q1 2023',
                                                                'Q2 2023',
                                                                'Q3 2023',
                                                                'Q4 2023'
                                                            ],
                                                            onChange: ({ option: option })=>setSelectedQuarter(option),
                                                            placeholder: "Select Quarter",
                                                            plain: true,
                                                            dropProps: {
                                                                round: 'xsmall',
                                                                margin: {
                                                                    top: 'xsmall'
                                                                }
                                                            },
                                                            style: {
                                                                background: '#F8F9FA',
                                                                padding: '12px 16px',
                                                                borderRadius: '4px',
                                                                border: '1px solid #E9ECEF',
                                                                width: '100%',
                                                                height: '44px'
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $724dfb7ecf65a151$export$60332b2344f7fe41), {
                                    background: "white",
                                    elevation: "none",
                                    round: "xsmall",
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                        direction: "row",
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)(TabButton, {
                                                label: "Financial Reports",
                                                isActive: activeTab === 'financial',
                                                onClick: ()=>setActiveTab('financial')
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)(TabButton, {
                                                label: "Equipment Reports",
                                                isActive: activeTab === 'equipment',
                                                onClick: ()=>setActiveTab('equipment')
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)(TabButton, {
                                                label: "Facility Reports",
                                                isActive: activeTab === 'facility',
                                                onClick: ()=>setActiveTab('facility')
                                            })
                                        ]
                                    })
                                }),
                                activeTab === 'financial' && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $724dfb7ecf65a151$export$60332b2344f7fe41), {
                                    margin: {
                                        vertical: 'medium'
                                    },
                                    background: "white",
                                    elevation: "none",
                                    round: "xsmall",
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f557854f3abac6b7$export$5665775b26e26c5d), {
                                            pad: {
                                                horizontal: 'medium',
                                                vertical: 'medium'
                                            },
                                            border: {
                                                side: 'bottom',
                                                color: 'light-4',
                                                size: '1px'
                                            },
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        size: "large",
                                                        weight: "normal",
                                                        children: "Financial Report"
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        size: "small",
                                                        color: "dark-6",
                                                        margin: {
                                                            top: 'xsmall'
                                                        },
                                                        children: [
                                                            "Financial performance across facilities for ",
                                                            selectedQuarter
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $fdccc762800a972d$export$851de33184ecdac4), {
                                            pad: "none",
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
                                                pad: {
                                                    horizontal: '1.5rem'
                                                },
                                                columns: [
                                                    {
                                                        property: 'facility',
                                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            toUpperCase: true,
                                                            children: "Facility"
                                                        }),
                                                        render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                pad: {
                                                                    vertical: '1rem'
                                                                },
                                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                    children: datum.facility
                                                                })
                                                            })
                                                    },
                                                    {
                                                        property: 'location',
                                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            toUpperCase: true,
                                                            children: "Location"
                                                        }),
                                                        render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                pad: {
                                                                    vertical: '1rem'
                                                                },
                                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                    children: datum.location
                                                                })
                                                            })
                                                    },
                                                    {
                                                        property: 'revenue',
                                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            toUpperCase: true,
                                                            children: "Revenue"
                                                        }),
                                                        render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                pad: {
                                                                    vertical: '1rem'
                                                                },
                                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                    children: datum.revenue
                                                                })
                                                            })
                                                    },
                                                    {
                                                        property: 'expenses',
                                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            toUpperCase: true,
                                                            children: "Expenses"
                                                        }),
                                                        render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                pad: {
                                                                    vertical: '1rem'
                                                                },
                                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                    children: datum.expenses
                                                                })
                                                            })
                                                    },
                                                    {
                                                        property: 'profit',
                                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                            toUpperCase: true,
                                                            children: "Profit"
                                                        }),
                                                        render: (datum)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                pad: {
                                                                    vertical: '1rem'
                                                                },
                                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f42764fc1a81828a$export$d42fb77b9f0fb7ad), {
                                                                    children: datum.profit
                                                                })
                                                            })
                                                    }
                                                ],
                                                data: financialData,
                                                background: [
                                                    'light-6',
                                                    'white'
                                                ],
                                                border: {
                                                    color: 'light-2',
                                                    side: 'bottom',
                                                    size: 'small'
                                                }
                                            })
                                        })
                                    ]
                                }),
                                activeTab === 'equipment' && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    margin: {
                                        top: 'medium'
                                    },
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        children: "Equipment reports content will go here"
                                    })
                                }),
                                activeTab === 'facility' && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    margin: {
                                        top: 'medium'
                                    },
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        children: "Facility reports content will go here"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                flex: false,
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $605617a28ba64070$export$3210cca7a959581e), {})
            })
        ]
    });
});
var $7b685783e6ba55db$export$2e2bcd8739ae039 = $7b685783e6ba55db$var$FuseAdminDashboardReports;




const $ec5e163b64c585f7$export$b373742c5e146c8f = [
    // Dashboard
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/fuse-admin",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            allowedRoles: [
                (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FuseAdmin
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $56b6582e7ad39ad9$export$2e2bcd8739ae039), {})
            })
        })
    }),
    // Credit Pricing
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/fuse-admin/credit-pricing",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            allowedRoles: [
                (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FuseAdmin
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $4d33aa7df6cb1fa2$export$2e2bcd8739ae039), {})
            })
        })
    }),
    // Credit Calculation
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/fuse-admin/credit-calculation",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            allowedRoles: [
                (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FuseAdmin
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $4a9428f6b6d26b41$export$2e2bcd8739ae039), {})
            })
        })
    }),
    // Programs
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/fuse-admin/programs",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            allowedRoles: [
                (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FuseAdmin
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9a0a037d937851c5$export$2e2bcd8739ae039), {})
            })
        })
    }),
    // Reports
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/fuse-admin/reports",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            allowedRoles: [
                (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FuseAdmin
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7b685783e6ba55db$export$2e2bcd8739ae039), {})
            })
        })
    }),
    // Referral Partners
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/fuse-admin/referral-partners",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            allowedRoles: [
                (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FuseAdmin
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9ffdc6ade7098952$export$2e2bcd8739ae039), {})
            })
        })
    }),
    // Remittance
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/fuse-admin/remittance",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            allowedRoles: [
                (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FuseAdmin
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9a47e08c1c8fab5d$export$2e2bcd8739ae039), {})
            })
        })
    }),
    // Importer
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/fuse-admin/importer",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            allowedRoles: [
                (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FuseAdmin
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $88350b4d99686db4$export$2e2bcd8739ae039), {})
            })
        })
    }),
    // Charging Networks
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/fuse-admin/charging-networks",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            allowedRoles: [
                (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FuseAdmin
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cebfdf44a3b436b1$export$2e2bcd8739ae039), {})
            })
        })
    })
];




var $2xPiy = parcelRequire("2xPiy");




const $ff6fd5b6568aef67$var$ApiData = ()=>{
    (0, $2xPiy.useEffect)(()=>{
        document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, 'API Data');
    }, []);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        style: {
            minHeight: '100vh'
        },
        background: "light",
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c3e91fa8212c6d4c$export$50d7b5e01df871ca), {}),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d48fc541d96cd8f0$export$861edd1ccea2f746), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    flex: "grow",
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("iframe", {
                        id: "api-data",
                        title: "API Data",
                        style: {
                            display: 'flex',
                            flexBasis: 'auto',
                            flexDirection: 'column',
                            flexGrow: '1',
                            flexShrink: '0',
                            border: 'none',
                            margin: 0,
                            padding: 0
                        },
                        src: (0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).urls.apiDataUrl
                    })
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $605617a28ba64070$export$3210cca7a959581e), {})
            })
        ]
    });
};
var $ff6fd5b6568aef67$export$2e2bcd8739ae039 = $ff6fd5b6568aef67$var$ApiData;




var $2xPiy = parcelRequire("2xPiy");



var $fc01af1196a3263c$exports = {};
!function(e, n) {
    $fc01af1196a3263c$exports = n();
}($fc01af1196a3263c$exports, function() {
    "use strict";
    return function(e, n, t) {
        var i = function(e, n) {
            if (!n || !n.length || 1 === n.length && !n[0] || 1 === n.length && Array.isArray(n[0]) && !n[0].length) return null;
            var t;
            1 === n.length && n[0].length > 0 && (n = n[0]);
            t = (n = n.filter(function(e) {
                return e;
            }))[0];
            for(var i = 1; i < n.length; i += 1)n[i].isValid() && !n[i][e](t) || (t = n[i]);
            return t;
        };
        t.max = function() {
            var e = [].slice.call(arguments, 0);
            return i("isAfter", e);
        }, t.min = function() {
            var e = [].slice.call(arguments, 0);
            return i("isBefore", e);
        };
    };
});



var $2xPiy = parcelRequire("2xPiy");

function $400b12c0802e75f5$var$_extends() {
    return $400b12c0802e75f5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $400b12c0802e75f5$var$_extends.apply(null, arguments);
}
var $400b12c0802e75f5$export$a7aaed3e118dd255 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $400b12c0802e75f5$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Download"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 17v6h22v-6M12 2v17m-7-7 7 7 7-7"
    }));
});
$400b12c0802e75f5$export$a7aaed3e118dd255.displayName = 'Download';









var $2xPiy = parcelRequire("2xPiy");


var $90f36abf4e65ffb7$exports = {};
"use strict";
$90f36abf4e65ffb7$exports.__esModule = true;
var $90f36abf4e65ffb7$var$_exportNames = {
    Tictok: true
};
$90f36abf4e65ffb7$exports.Tictok = void 0;
var $3cfc3cde02049331$exports = {};

$parcel$export($3cfc3cde02049331$exports, "__esModule", function () { return $3cfc3cde02049331$export$1e511d4a378977f5; }, function (v) { return $3cfc3cde02049331$export$1e511d4a378977f5 = v; });
$parcel$export($3cfc3cde02049331$exports, "Accessibility", function () { return $3cfc3cde02049331$export$ea0f6181e3388ffd; }, function (v) { return $3cfc3cde02049331$export$ea0f6181e3388ffd = v; });
var $3cfc3cde02049331$export$1e511d4a378977f5;
var $3cfc3cde02049331$export$ea0f6181e3388ffd;
"use strict";
$3cfc3cde02049331$export$1e511d4a378977f5 = true;
$3cfc3cde02049331$export$ea0f6181e3388ffd = void 0;

var $3cfc3cde02049331$var$_react = $3cfc3cde02049331$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $3cfc3cde02049331$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3cfc3cde02049331$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3cfc3cde02049331$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3cfc3cde02049331$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3cfc3cde02049331$var$_extends() {
    return $3cfc3cde02049331$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3cfc3cde02049331$var$_extends.apply(null, arguments);
}
var $3cfc3cde02049331$var$Accessibility = $3cfc3cde02049331$export$ea0f6181e3388ffd = /*#__PURE__*/ (0, $3cfc3cde02049331$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3cfc3cde02049331$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3cfc3cde02049331$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Accessibility"
    }, props), /*#__PURE__*/ $3cfc3cde02049331$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M4 8h7v6l-4 7M20 8h-7v6l4 7M12 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-1 3h2v5h-2V8z"
    }));
});
$3cfc3cde02049331$var$Accessibility.displayName = 'Accessibility';


Object.keys($3cfc3cde02049331$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3cfc3cde02049331$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3cfc3cde02049331$exports[key];
});
var $174e7c4ba9fc0b50$exports = {};

$parcel$export($174e7c4ba9fc0b50$exports, "__esModule", function () { return $174e7c4ba9fc0b50$export$1e511d4a378977f5; }, function (v) { return $174e7c4ba9fc0b50$export$1e511d4a378977f5 = v; });
$parcel$export($174e7c4ba9fc0b50$exports, "Achievement", function () { return $174e7c4ba9fc0b50$export$27fdeeaa680fc644; }, function (v) { return $174e7c4ba9fc0b50$export$27fdeeaa680fc644 = v; });
var $174e7c4ba9fc0b50$export$1e511d4a378977f5;
var $174e7c4ba9fc0b50$export$27fdeeaa680fc644;
"use strict";
$174e7c4ba9fc0b50$export$1e511d4a378977f5 = true;
$174e7c4ba9fc0b50$export$27fdeeaa680fc644 = void 0;

var $174e7c4ba9fc0b50$var$_react = $174e7c4ba9fc0b50$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $174e7c4ba9fc0b50$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($174e7c4ba9fc0b50$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $174e7c4ba9fc0b50$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $174e7c4ba9fc0b50$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $174e7c4ba9fc0b50$var$_extends() {
    return $174e7c4ba9fc0b50$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $174e7c4ba9fc0b50$var$_extends.apply(null, arguments);
}
var $174e7c4ba9fc0b50$var$Achievement = $174e7c4ba9fc0b50$export$27fdeeaa680fc644 = /*#__PURE__*/ (0, $174e7c4ba9fc0b50$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $174e7c4ba9fc0b50$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $174e7c4ba9fc0b50$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Achievement"
    }, props), /*#__PURE__*/ $174e7c4ba9fc0b50$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M10.325 14.763A6.002 6.002 0 0 1 6 9V1h12v9M6 3H1v4c0 2.509 1.791 4 4 4h1m14.034-.115C21.742 10.49 23 9.103 23 7V3h-5m-8 16H5v4h11.5m0-13a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zm3.5 4-4.5 4.5L13 16m-2.794-.576A4 4 0 0 0 8 19"
    }));
});
$174e7c4ba9fc0b50$var$Achievement.displayName = 'Achievement';


Object.keys($174e7c4ba9fc0b50$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $174e7c4ba9fc0b50$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $174e7c4ba9fc0b50$exports[key];
});
var $82aecb00e2b3a264$exports = {};

$parcel$export($82aecb00e2b3a264$exports, "__esModule", function () { return $82aecb00e2b3a264$export$1e511d4a378977f5; }, function (v) { return $82aecb00e2b3a264$export$1e511d4a378977f5 = v; });
$parcel$export($82aecb00e2b3a264$exports, "Action", function () { return $82aecb00e2b3a264$export$e19cd5f9376f8cee; }, function (v) { return $82aecb00e2b3a264$export$e19cd5f9376f8cee = v; });
var $82aecb00e2b3a264$export$1e511d4a378977f5;
var $82aecb00e2b3a264$export$e19cd5f9376f8cee;
"use strict";
$82aecb00e2b3a264$export$1e511d4a378977f5 = true;
$82aecb00e2b3a264$export$e19cd5f9376f8cee = void 0;

var $82aecb00e2b3a264$var$_react = $82aecb00e2b3a264$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $82aecb00e2b3a264$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($82aecb00e2b3a264$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $82aecb00e2b3a264$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $82aecb00e2b3a264$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $82aecb00e2b3a264$var$_extends() {
    return $82aecb00e2b3a264$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $82aecb00e2b3a264$var$_extends.apply(null, arguments);
}
var $82aecb00e2b3a264$var$Action = $82aecb00e2b3a264$export$e19cd5f9376f8cee = /*#__PURE__*/ (0, $82aecb00e2b3a264$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $82aecb00e2b3a264$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $82aecb00e2b3a264$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Action"
    }, props), /*#__PURE__*/ $82aecb00e2b3a264$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m1 23 3-3-3 3zM20 4l3-3-3 3zM9 11l3-3-3 3zm4 4 3-3-3 3zM10 5l9 9 1-1c2-2 4.053-5 0-9s-7-2-9 0l-1 1zm-6 6 1-1 9 9-1 1c-2 2-5 4.087-9 0s-2-7 0-9z"
    }));
});
$82aecb00e2b3a264$var$Action.displayName = 'Action';


Object.keys($82aecb00e2b3a264$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $82aecb00e2b3a264$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $82aecb00e2b3a264$exports[key];
});

Object.keys($1de8541bdd93d251$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $1de8541bdd93d251$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $1de8541bdd93d251$exports[key];
});
var $503491cd0a383d8f$exports = {};

$parcel$export($503491cd0a383d8f$exports, "__esModule", function () { return $503491cd0a383d8f$export$1e511d4a378977f5; }, function (v) { return $503491cd0a383d8f$export$1e511d4a378977f5 = v; });
$parcel$export($503491cd0a383d8f$exports, "Ad", function () { return $503491cd0a383d8f$export$857b11641fa70c36; }, function (v) { return $503491cd0a383d8f$export$857b11641fa70c36 = v; });
var $503491cd0a383d8f$export$1e511d4a378977f5;
var $503491cd0a383d8f$export$857b11641fa70c36;
"use strict";
$503491cd0a383d8f$export$1e511d4a378977f5 = true;
$503491cd0a383d8f$export$857b11641fa70c36 = void 0;

var $503491cd0a383d8f$var$_react = $503491cd0a383d8f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $503491cd0a383d8f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($503491cd0a383d8f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $503491cd0a383d8f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $503491cd0a383d8f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $503491cd0a383d8f$var$_extends() {
    return $503491cd0a383d8f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $503491cd0a383d8f$var$_extends.apply(null, arguments);
}
var $503491cd0a383d8f$var$Ad = $503491cd0a383d8f$export$857b11641fa70c36 = /*#__PURE__*/ (0, $503491cd0a383d8f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $503491cd0a383d8f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $503491cd0a383d8f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Ad"
    }, props), /*#__PURE__*/ $503491cd0a383d8f$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M10 10h4v4h-4v-4zm4 8h-4a4 4 0 0 1-4-4v-4a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v4m-4 8h-4a8 8 0 0 1-8-8v-4a8 8 0 0 1 8-8h4a8 8 0 0 1 8 8v4"
    }));
});
$503491cd0a383d8f$var$Ad.displayName = 'Ad';


Object.keys($503491cd0a383d8f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $503491cd0a383d8f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $503491cd0a383d8f$exports[key];
});
var $f3c87cab5f402418$exports = {};

$parcel$export($f3c87cab5f402418$exports, "__esModule", function () { return $f3c87cab5f402418$export$1e511d4a378977f5; }, function (v) { return $f3c87cab5f402418$export$1e511d4a378977f5 = v; });
$parcel$export($f3c87cab5f402418$exports, "AddCircle", function () { return $f3c87cab5f402418$export$b5797ef40e68a059; }, function (v) { return $f3c87cab5f402418$export$b5797ef40e68a059 = v; });
var $f3c87cab5f402418$export$1e511d4a378977f5;
var $f3c87cab5f402418$export$b5797ef40e68a059;
"use strict";
$f3c87cab5f402418$export$1e511d4a378977f5 = true;
$f3c87cab5f402418$export$b5797ef40e68a059 = void 0;

var $f3c87cab5f402418$var$_react = $f3c87cab5f402418$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f3c87cab5f402418$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f3c87cab5f402418$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f3c87cab5f402418$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f3c87cab5f402418$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f3c87cab5f402418$var$_extends() {
    return $f3c87cab5f402418$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f3c87cab5f402418$var$_extends.apply(null, arguments);
}
var $f3c87cab5f402418$var$AddCircle = $f3c87cab5f402418$export$b5797ef40e68a059 = /*#__PURE__*/ (0, $f3c87cab5f402418$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f3c87cab5f402418$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f3c87cab5f402418$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "AddCircle"
    }, props), /*#__PURE__*/ $f3c87cab5f402418$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-4V6m-6 6h12"
    }));
});
$f3c87cab5f402418$var$AddCircle.displayName = 'AddCircle';


Object.keys($f3c87cab5f402418$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f3c87cab5f402418$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f3c87cab5f402418$exports[key];
});

Object.keys($7996618d0f2a9e28$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $7996618d0f2a9e28$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $7996618d0f2a9e28$exports[key];
});
var $6971735e594a6b00$exports = {};

$parcel$export($6971735e594a6b00$exports, "__esModule", function () { return $6971735e594a6b00$export$1e511d4a378977f5; }, function (v) { return $6971735e594a6b00$export$1e511d4a378977f5 = v; });
$parcel$export($6971735e594a6b00$exports, "AdobeCreativeCloud", function () { return $6971735e594a6b00$export$b674d8f6fcee582c; }, function (v) { return $6971735e594a6b00$export$b674d8f6fcee582c = v; });
var $6971735e594a6b00$export$1e511d4a378977f5;
var $6971735e594a6b00$export$b674d8f6fcee582c;
"use strict";
$6971735e594a6b00$export$1e511d4a378977f5 = true;
$6971735e594a6b00$export$b674d8f6fcee582c = void 0;

var $6971735e594a6b00$var$_react = $6971735e594a6b00$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $6971735e594a6b00$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6971735e594a6b00$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6971735e594a6b00$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6971735e594a6b00$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6971735e594a6b00$var$_extends() {
    return $6971735e594a6b00$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6971735e594a6b00$var$_extends.apply(null, arguments);
}
var $6971735e594a6b00$var$AdobeCreativeCloud = $6971735e594a6b00$export$b674d8f6fcee582c = /*#__PURE__*/ (0, $6971735e594a6b00$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $6971735e594a6b00$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $6971735e594a6b00$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "AdobeCreativeCloud"
    }, props), /*#__PURE__*/ $6971735e594a6b00$var$_react["default"].createElement("path", {
        fill: "#DA1F26",
        d: "M24 11.456v.79c-.008.043-.017.085-.022.128-.04.343-.067.69-.124 1.03a8.433 8.433 0 0 1-1.176 3.093 8.793 8.793 0 0 1-3.645 3.303 8.527 8.527 0 0 1-2.812.83c-.217.025-.434.047-.652.071H7.138c-.043-.008-.085-.02-.128-.023a7.19 7.19 0 0 1-2.448-.588C2.865 19.347 1.6 18.143.771 16.486a7.088 7.088 0 0 1-.7-2.33L0 13.563v-.767c.008-.043.02-.085.023-.128a7.062 7.062 0 0 1 .461-2.139C1.2 8.68 2.45 7.31 4.222 6.42a7.323 7.323 0 0 1 2.928-.756 8.132 8.132 0 0 1 1.503.069.19.19 0 0 0 .142-.046 8.892 8.892 0 0 1 2.457-1.781 8.6 8.6 0 0 1 2.826-.833c.234-.027.467-.049.7-.073h.72c.046.007.094.016.14.021.357.042.715.068 1.068.127a8.46 8.46 0 0 1 3.073 1.166 8.794 8.794 0 0 1 3.319 3.652c.438.883.719 1.835.83 2.814.026.226.048.45.072.676ZM10.58 6.343c.015.02.019.028.025.031.493.243.965.529 1.41.853.028.02.098.012.132-.01 1.222-.774 2.547-1.041 3.97-.789 1.395.247 2.53.944 3.397 2.057.982 1.26 1.357 2.684 1.085 4.27-.181 1.061-.607 2.014-1.33 2.812-1.32 1.456-2.972 2.057-4.917 1.803a5.191 5.191 0 0 1-3.086-1.538c-1.098-1.11-2.204-2.211-3.305-3.318-.147-.147-.31-.265-.521-.291a.829.829 0 0 0-.864.47c-.142.296-.124.63.185.934 1.227 1.205 2.444 2.421 3.67 3.627.21.208.435.4.674.573.896.65 1.906 1.01 3 1.155a7.22 7.22 0 0 0 2.555-.1 7.082 7.082 0 0 0 4-2.455 7.034 7.034 0 0 0 1.576-3.609 7.072 7.072 0 0 0-.065-2.32c-.244-1.251-.773-2.37-1.62-3.322-1.618-1.816-3.653-2.627-6.074-2.446a6.747 6.747 0 0 0-2.641.777 6.97 6.97 0 0 0-1.255.836ZM9.989 19.02l-.1-.093c-.501-.474-1.006-.945-1.502-1.425a.407.407 0 0 0-.32-.135c-.502.012-1.005.015-1.5-.097-2.461-.557-3.89-3.233-2.983-5.587.715-1.857 2.696-2.988 4.649-2.639.875.156 1.644.527 2.275 1.177.769.794 1.56 1.566 2.338 2.352.177.179.38.26.626.225.316-.045.569-.196.683-.507a.749.749 0 0 0-.173-.83c-.816-.826-1.613-1.673-2.462-2.465-1.647-1.536-3.588-1.992-5.736-1.34-2.888.878-4.579 3.86-3.919 6.804a5.816 5.816 0 0 0 5.691 4.566h2.299c.038 0 .076-.003.134-.006Z"
    }));
});
$6971735e594a6b00$var$AdobeCreativeCloud.displayName = 'AdobeCreativeCloud';


Object.keys($6971735e594a6b00$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $6971735e594a6b00$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $6971735e594a6b00$exports[key];
});
var $6f24d1c9d74c9bb4$exports = {};

$parcel$export($6f24d1c9d74c9bb4$exports, "__esModule", function () { return $6f24d1c9d74c9bb4$export$1e511d4a378977f5; }, function (v) { return $6f24d1c9d74c9bb4$export$1e511d4a378977f5 = v; });
$parcel$export($6f24d1c9d74c9bb4$exports, "Aed", function () { return $6f24d1c9d74c9bb4$export$3ece5bb2477f36a5; }, function (v) { return $6f24d1c9d74c9bb4$export$3ece5bb2477f36a5 = v; });
var $6f24d1c9d74c9bb4$export$1e511d4a378977f5;
var $6f24d1c9d74c9bb4$export$3ece5bb2477f36a5;
"use strict";
$6f24d1c9d74c9bb4$export$1e511d4a378977f5 = true;
$6f24d1c9d74c9bb4$export$3ece5bb2477f36a5 = void 0;

var $6f24d1c9d74c9bb4$var$_react = $6f24d1c9d74c9bb4$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $6f24d1c9d74c9bb4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6f24d1c9d74c9bb4$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6f24d1c9d74c9bb4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6f24d1c9d74c9bb4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6f24d1c9d74c9bb4$var$_extends() {
    return $6f24d1c9d74c9bb4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6f24d1c9d74c9bb4$var$_extends.apply(null, arguments);
}
var $6f24d1c9d74c9bb4$var$Aed = $6f24d1c9d74c9bb4$export$3ece5bb2477f36a5 = /*#__PURE__*/ (0, $6f24d1c9d74c9bb4$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $6f24d1c9d74c9bb4$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $6f24d1c9d74c9bb4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Aed"
    }, props), /*#__PURE__*/ $6f24d1c9d74c9bb4$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 8.4C2 4 5 3 7 3s4 2 5 3.5C13 5 15 3 17 3s5 1 5 5.4C22 15 12 21 12 21S2 15 2 8.4zM12 6c-.5-.5-2 4-2 4h2v2.5L14 9h-2s1-6 5-6c-4 0-5 3-5 3z"
    }));
});
$6f24d1c9d74c9bb4$var$Aed.displayName = 'Aed';


Object.keys($6f24d1c9d74c9bb4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $6f24d1c9d74c9bb4$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $6f24d1c9d74c9bb4$exports[key];
});
var $ddf3a921565b4d63$exports = {};

$parcel$export($ddf3a921565b4d63$exports, "__esModule", function () { return $ddf3a921565b4d63$export$1e511d4a378977f5; }, function (v) { return $ddf3a921565b4d63$export$1e511d4a378977f5 = v; });
$parcel$export($ddf3a921565b4d63$exports, "Aggregate", function () { return $ddf3a921565b4d63$export$b9601df20779e14a; }, function (v) { return $ddf3a921565b4d63$export$b9601df20779e14a = v; });
var $ddf3a921565b4d63$export$1e511d4a378977f5;
var $ddf3a921565b4d63$export$b9601df20779e14a;
"use strict";
$ddf3a921565b4d63$export$1e511d4a378977f5 = true;
$ddf3a921565b4d63$export$b9601df20779e14a = void 0;

var $ddf3a921565b4d63$var$_react = $ddf3a921565b4d63$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $ddf3a921565b4d63$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ddf3a921565b4d63$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ddf3a921565b4d63$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ddf3a921565b4d63$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ddf3a921565b4d63$var$_extends() {
    return $ddf3a921565b4d63$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ddf3a921565b4d63$var$_extends.apply(null, arguments);
}
var $ddf3a921565b4d63$var$Aggregate = $ddf3a921565b4d63$export$b9601df20779e14a = /*#__PURE__*/ (0, $ddf3a921565b4d63$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $ddf3a921565b4d63$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ddf3a921565b4d63$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Aggregate"
    }, props), /*#__PURE__*/ $ddf3a921565b4d63$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8 15h7V8a7 7 0 1 0-7 7zm8-6H9v7a7 7 0 1 0 7-7z"
    }));
});
$ddf3a921565b4d63$var$Aggregate.displayName = 'Aggregate';


Object.keys($ddf3a921565b4d63$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ddf3a921565b4d63$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ddf3a921565b4d63$exports[key];
});
var $c9949134220fdee8$exports = {};

$parcel$export($c9949134220fdee8$exports, "__esModule", function () { return $c9949134220fdee8$export$1e511d4a378977f5; }, function (v) { return $c9949134220fdee8$export$1e511d4a378977f5 = v; });
$parcel$export($c9949134220fdee8$exports, "AidOption", function () { return $c9949134220fdee8$export$4da554401f9a52bb; }, function (v) { return $c9949134220fdee8$export$4da554401f9a52bb = v; });
var $c9949134220fdee8$export$1e511d4a378977f5;
var $c9949134220fdee8$export$4da554401f9a52bb;
"use strict";
$c9949134220fdee8$export$1e511d4a378977f5 = true;
$c9949134220fdee8$export$4da554401f9a52bb = void 0;

var $c9949134220fdee8$var$_react = $c9949134220fdee8$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c9949134220fdee8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c9949134220fdee8$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c9949134220fdee8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c9949134220fdee8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c9949134220fdee8$var$_extends() {
    return $c9949134220fdee8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c9949134220fdee8$var$_extends.apply(null, arguments);
}
var $c9949134220fdee8$var$AidOption = $c9949134220fdee8$export$4da554401f9a52bb = /*#__PURE__*/ (0, $c9949134220fdee8$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c9949134220fdee8$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c9949134220fdee8$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "AidOption"
    }, props), /*#__PURE__*/ $c9949134220fdee8$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 9v10V9zm5 5H7h10zM1 6.995C1 5.893 1.89 5 2.991 5H21.01C22.109 5 23 5.893 23 6.995v14.01C23 22.107 22.11 23 21.009 23H2.99A1.992 1.992 0 0 1 1 21.005V6.995zM7 5V2.01C7 1.451 7.456 1 7.995 1h8.01c.55 0 .995.443.995 1.01V5"
    }));
});
$c9949134220fdee8$var$AidOption.displayName = 'AidOption';


Object.keys($c9949134220fdee8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c9949134220fdee8$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c9949134220fdee8$exports[key];
});
var $f26d9dc9ab1afe8c$exports = {};

$parcel$export($f26d9dc9ab1afe8c$exports, "__esModule", function () { return $f26d9dc9ab1afe8c$export$1e511d4a378977f5; }, function (v) { return $f26d9dc9ab1afe8c$export$1e511d4a378977f5 = v; });
$parcel$export($f26d9dc9ab1afe8c$exports, "Aid", function () { return $f26d9dc9ab1afe8c$export$7da9d0dda106246d; }, function (v) { return $f26d9dc9ab1afe8c$export$7da9d0dda106246d = v; });
var $f26d9dc9ab1afe8c$export$1e511d4a378977f5;
var $f26d9dc9ab1afe8c$export$7da9d0dda106246d;
"use strict";
$f26d9dc9ab1afe8c$export$1e511d4a378977f5 = true;
$f26d9dc9ab1afe8c$export$7da9d0dda106246d = void 0;

var $f26d9dc9ab1afe8c$var$_react = $f26d9dc9ab1afe8c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f26d9dc9ab1afe8c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f26d9dc9ab1afe8c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f26d9dc9ab1afe8c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f26d9dc9ab1afe8c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f26d9dc9ab1afe8c$var$_extends() {
    return $f26d9dc9ab1afe8c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f26d9dc9ab1afe8c$var$_extends.apply(null, arguments);
}
var $f26d9dc9ab1afe8c$var$Aid = $f26d9dc9ab1afe8c$export$7da9d0dda106246d = /*#__PURE__*/ (0, $f26d9dc9ab1afe8c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f26d9dc9ab1afe8c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f26d9dc9ab1afe8c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Aid"
    }, props), /*#__PURE__*/ $f26d9dc9ab1afe8c$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 22h22V6H1v16zM8 6h8V2H8v4zm0 8h8m-4-4v8"
    }));
});
$f26d9dc9ab1afe8c$var$Aid.displayName = 'Aid';


Object.keys($f26d9dc9ab1afe8c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f26d9dc9ab1afe8c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f26d9dc9ab1afe8c$exports[key];
});
var $5d900ef8880f6166$exports = {};

$parcel$export($5d900ef8880f6166$exports, "__esModule", function () { return $5d900ef8880f6166$export$1e511d4a378977f5; }, function (v) { return $5d900ef8880f6166$export$1e511d4a378977f5 = v; });
$parcel$export($5d900ef8880f6166$exports, "Alarm", function () { return $5d900ef8880f6166$export$60f2569f98be8ae8; }, function (v) { return $5d900ef8880f6166$export$60f2569f98be8ae8 = v; });
var $5d900ef8880f6166$export$1e511d4a378977f5;
var $5d900ef8880f6166$export$60f2569f98be8ae8;
"use strict";
$5d900ef8880f6166$export$1e511d4a378977f5 = true;
$5d900ef8880f6166$export$60f2569f98be8ae8 = void 0;

var $5d900ef8880f6166$var$_react = $5d900ef8880f6166$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5d900ef8880f6166$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5d900ef8880f6166$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5d900ef8880f6166$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5d900ef8880f6166$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5d900ef8880f6166$var$_extends() {
    return $5d900ef8880f6166$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5d900ef8880f6166$var$_extends.apply(null, arguments);
}
var $5d900ef8880f6166$var$Alarm = $5d900ef8880f6166$export$60f2569f98be8ae8 = /*#__PURE__*/ (0, $5d900ef8880f6166$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5d900ef8880f6166$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5d900ef8880f6166$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Alarm"
    }, props), /*#__PURE__*/ $5d900ef8880f6166$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M21 13a9 9 0 0 1-9 9 9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9zM5.5 19.5 2 23l3.5-3.5zm13 0L22 23l-3.5-3.5zM9 4c-.71-1.092-2.118-2-4-2-2.1 0-4 1.9-4 4 0 1.882.908 3.29 2 4m18 0c1.092-.71 2-2.118 2-4 0-2.1-1.9-4-4-4-1.882 0-3.29.908-4 2m-3 4v5l3 3"
    }));
});
$5d900ef8880f6166$var$Alarm.displayName = 'Alarm';


Object.keys($5d900ef8880f6166$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5d900ef8880f6166$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5d900ef8880f6166$exports[key];
});
var $410e8b62776be05c$exports = {};

$parcel$export($410e8b62776be05c$exports, "__esModule", function () { return $410e8b62776be05c$export$1e511d4a378977f5; }, function (v) { return $410e8b62776be05c$export$1e511d4a378977f5 = v; });
$parcel$export($410e8b62776be05c$exports, "Alert", function () { return $410e8b62776be05c$export$caec2af78bcc877f; }, function (v) { return $410e8b62776be05c$export$caec2af78bcc877f = v; });
var $410e8b62776be05c$export$1e511d4a378977f5;
var $410e8b62776be05c$export$caec2af78bcc877f;
"use strict";
$410e8b62776be05c$export$1e511d4a378977f5 = true;
$410e8b62776be05c$export$caec2af78bcc877f = void 0;

var $410e8b62776be05c$var$_react = $410e8b62776be05c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $410e8b62776be05c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($410e8b62776be05c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $410e8b62776be05c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $410e8b62776be05c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $410e8b62776be05c$var$_extends() {
    return $410e8b62776be05c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $410e8b62776be05c$var$_extends.apply(null, arguments);
}
var $410e8b62776be05c$var$Alert = $410e8b62776be05c$export$caec2af78bcc877f = /*#__PURE__*/ (0, $410e8b62776be05c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $410e8b62776be05c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $410e8b62776be05c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Alert"
    }, props), /*#__PURE__*/ $410e8b62776be05c$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 17v2m0-9v6m0-13L2 22h20L12 3z"
    }));
});
$410e8b62776be05c$var$Alert.displayName = 'Alert';


Object.keys($410e8b62776be05c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $410e8b62776be05c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $410e8b62776be05c$exports[key];
});
var $1782d13234bfb41f$exports = {};

$parcel$export($1782d13234bfb41f$exports, "__esModule", function () { return $1782d13234bfb41f$export$1e511d4a378977f5; }, function (v) { return $1782d13234bfb41f$export$1e511d4a378977f5 = v; });
$parcel$export($1782d13234bfb41f$exports, "Amazon", function () { return $1782d13234bfb41f$export$f5902bc0f4d77863; }, function (v) { return $1782d13234bfb41f$export$f5902bc0f4d77863 = v; });
var $1782d13234bfb41f$export$1e511d4a378977f5;
var $1782d13234bfb41f$export$f5902bc0f4d77863;
"use strict";
$1782d13234bfb41f$export$1e511d4a378977f5 = true;
$1782d13234bfb41f$export$f5902bc0f4d77863 = void 0;

var $1782d13234bfb41f$var$_react = $1782d13234bfb41f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $1782d13234bfb41f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1782d13234bfb41f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1782d13234bfb41f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $1782d13234bfb41f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1782d13234bfb41f$var$_extends() {
    return $1782d13234bfb41f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1782d13234bfb41f$var$_extends.apply(null, arguments);
}
var $1782d13234bfb41f$var$Amazon = $1782d13234bfb41f$export$f5902bc0f4d77863 = /*#__PURE__*/ (0, $1782d13234bfb41f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $1782d13234bfb41f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $1782d13234bfb41f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Amazon"
    }, props), /*#__PURE__*/ $1782d13234bfb41f$var$_react["default"].createElement("path", {
        fill: "#F90",
        fillRule: "evenodd",
        d: "M11.992 23.94c-3.155-.021-5.956-1.061-8.46-2.955a16.663 16.663 0 0 1-2.446-2.282c-.027-.03-.072-.058-.075-.09-.011-.117-.008-.234-.011-.35.1.016.218.003.298.053.67.417 1.314.878 2 1.264a18.612 18.612 0 0 0 6.378 2.192c1.18.18 2.365.24 3.55.17a17.755 17.755 0 0 0 6.486-1.648c.325-.151.644-.316.964-.479.154-.079.307-.111.438.028.139.146.133.322.036.485a1.11 1.11 0 0 1-.222.248c-1.841 1.633-3.995 2.636-6.396 3.103-.832.161-1.684.217-2.527.321l-.013-.06m8.89-5.095c-.456.044-.961.094-1.467.14-.11.01-.224.017-.334.01-.128-.008-.148-.086-.078-.18a.658.658 0 0 1 .162-.137c.536-.359 1.141-.516 1.769-.6a4.51 4.51 0 0 1 1.773.096c.394.106.48.153.45.61-.078 1.206-.466 2.303-1.34 3.183-.045.046-.087.104-.143.126-.074.029-.16.028-.24.04.002-.073-.013-.152.009-.219.208-.634.426-1.265.633-1.9a1.97 1.97 0 0 0 .073-.397c.051-.428-.12-.643-.574-.71-.212-.03-.427-.039-.693-.062M13.997 9.42c-.86-.005-1.68.032-2.466.296-.388.13-.781.295-1.115.527-.923.639-1.163 1.59-1.087 2.65.04.562.209 1.082.623 1.489.588.578 1.579.654 2.374.184.693-.41 1.107-1.042 1.375-1.779.395-1.085.27-2.216.296-3.367m.632 6.353c-.309.28-.594.545-.884.804-1.118.994-2.438 1.438-3.92 1.467-.805.017-1.596-.044-2.349-.342-1.342-.53-2.197-1.51-2.544-2.902-.431-1.728-.286-3.392.737-4.902.756-1.116 1.849-1.78 3.11-2.186 1.084-.35 2.205-.502 3.33-.628.618-.07 1.236-.13 1.884-.199-.02-.773.09-1.55-.181-2.297-.241-.662-.75-1.003-1.414-1.155-1.007-.23-2.147.145-2.688.938-.184.27-.296.597-.395.913-.139.445-.343.59-.805.535-.902-.107-1.807-.196-2.71-.302-.447-.052-.624-.307-.537-.742.397-1.98 1.543-3.363 3.41-4.09 2.201-.86 4.452-.927 6.684-.106 1.85.68 2.865 2.035 3 4.013.046.668.052 1.34.055 2.009.007 1.732.016 3.464-.003 5.196-.01.965.258 1.82.844 2.582.141.183.284.367.403.564.198.327.145.575-.141.822-.737.636-1.472 1.273-2.208 1.911-.404.352-.685.347-1.092.004a7.019 7.019 0 0 1-1.357-1.569c-.069-.107-.142-.21-.229-.338"
    }));
});
$1782d13234bfb41f$var$Amazon.displayName = 'Amazon';


Object.keys($1782d13234bfb41f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $1782d13234bfb41f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $1782d13234bfb41f$exports[key];
});
var $fe2126723bc51104$exports = {};

$parcel$export($fe2126723bc51104$exports, "__esModule", function () { return $fe2126723bc51104$export$1e511d4a378977f5; }, function (v) { return $fe2126723bc51104$export$1e511d4a378977f5 = v; });
$parcel$export($fe2126723bc51104$exports, "Amex", function () { return $fe2126723bc51104$export$2c1a29766a9f6edd; }, function (v) { return $fe2126723bc51104$export$2c1a29766a9f6edd = v; });
var $fe2126723bc51104$export$1e511d4a378977f5;
var $fe2126723bc51104$export$2c1a29766a9f6edd;
"use strict";
$fe2126723bc51104$export$1e511d4a378977f5 = true;
$fe2126723bc51104$export$2c1a29766a9f6edd = void 0;

var $fe2126723bc51104$var$_react = $fe2126723bc51104$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $fe2126723bc51104$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($fe2126723bc51104$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $fe2126723bc51104$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $fe2126723bc51104$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $fe2126723bc51104$var$_extends() {
    return $fe2126723bc51104$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fe2126723bc51104$var$_extends.apply(null, arguments);
}
var $fe2126723bc51104$var$Amex = $fe2126723bc51104$export$2c1a29766a9f6edd = /*#__PURE__*/ (0, $fe2126723bc51104$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $fe2126723bc51104$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $fe2126723bc51104$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Amex"
    }, props), /*#__PURE__*/ $fe2126723bc51104$var$_react["default"].createElement("path", {
        fill: "#002663",
        fillRule: "evenodd",
        d: "m4.314 11.965-.82-1.997-.815 1.997h1.635zm7.859 2.161-.005-3.922-1.736 3.922h-1.05L7.64 10.2v3.926H5.206l-.46-1.117H2.253l-.465 1.117h-1.3l2.144-5.008H4.41l2.036 4.742V9.118H8.4l1.567 3.397 1.439-3.397H13.4v5.008h-1.227zm3.133-1.024v-.997h2.628v-1.022h-2.628v-.911h3.001l1.31 1.46-1.368 1.47h-2.943zm8.111 1.044h-1.556l-1.474-1.659-1.532 1.659h-4.742v-5.01h4.815l1.473 1.642 1.523-1.642h1.564l-2.327 2.505 2.256 2.505z"
    }));
});
$fe2126723bc51104$var$Amex.displayName = 'Amex';


Object.keys($fe2126723bc51104$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $fe2126723bc51104$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $fe2126723bc51104$exports[key];
});
var $d2f7877792e7a0e6$exports = {};

$parcel$export($d2f7877792e7a0e6$exports, "__esModule", function () { return $d2f7877792e7a0e6$export$1e511d4a378977f5; }, function (v) { return $d2f7877792e7a0e6$export$1e511d4a378977f5 = v; });
$parcel$export($d2f7877792e7a0e6$exports, "Analytics", function () { return $d2f7877792e7a0e6$export$2b3af6baec22bd98; }, function (v) { return $d2f7877792e7a0e6$export$2b3af6baec22bd98 = v; });
var $d2f7877792e7a0e6$export$1e511d4a378977f5;
var $d2f7877792e7a0e6$export$2b3af6baec22bd98;
"use strict";
$d2f7877792e7a0e6$export$1e511d4a378977f5 = true;
$d2f7877792e7a0e6$export$2b3af6baec22bd98 = void 0;

var $d2f7877792e7a0e6$var$_react = $d2f7877792e7a0e6$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $d2f7877792e7a0e6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d2f7877792e7a0e6$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d2f7877792e7a0e6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d2f7877792e7a0e6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d2f7877792e7a0e6$var$_extends() {
    return $d2f7877792e7a0e6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d2f7877792e7a0e6$var$_extends.apply(null, arguments);
}
var $d2f7877792e7a0e6$var$Analytics = $d2f7877792e7a0e6$export$2b3af6baec22bd98 = /*#__PURE__*/ (0, $d2f7877792e7a0e6$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d2f7877792e7a0e6$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $d2f7877792e7a0e6$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Analytics"
    }, props), /*#__PURE__*/ $d2f7877792e7a0e6$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M20 7c1.25 1.67 2 3.75 2 6 0 5.52-4.48 10-10 10S2 18.52 2 13 6.48 3 12 3m0-2v12l9.6-7.2C19.41 2.89 15.92 1 12 1z"
    }));
});
$d2f7877792e7a0e6$var$Analytics.displayName = 'Analytics';


Object.keys($d2f7877792e7a0e6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $d2f7877792e7a0e6$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $d2f7877792e7a0e6$exports[key];
});
var $ffcb4b91b9b1d115$exports = {};

$parcel$export($ffcb4b91b9b1d115$exports, "__esModule", function () { return $ffcb4b91b9b1d115$export$1e511d4a378977f5; }, function (v) { return $ffcb4b91b9b1d115$export$1e511d4a378977f5 = v; });
$parcel$export($ffcb4b91b9b1d115$exports, "Anchor", function () { return $ffcb4b91b9b1d115$export$b688253958b8dfe7; }, function (v) { return $ffcb4b91b9b1d115$export$b688253958b8dfe7 = v; });
var $ffcb4b91b9b1d115$export$1e511d4a378977f5;
var $ffcb4b91b9b1d115$export$b688253958b8dfe7;
"use strict";
$ffcb4b91b9b1d115$export$1e511d4a378977f5 = true;
$ffcb4b91b9b1d115$export$b688253958b8dfe7 = void 0;

var $ffcb4b91b9b1d115$var$_react = $ffcb4b91b9b1d115$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $ffcb4b91b9b1d115$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ffcb4b91b9b1d115$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ffcb4b91b9b1d115$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ffcb4b91b9b1d115$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ffcb4b91b9b1d115$var$_extends() {
    return $ffcb4b91b9b1d115$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ffcb4b91b9b1d115$var$_extends.apply(null, arguments);
}
var $ffcb4b91b9b1d115$var$Anchor = $ffcb4b91b9b1d115$export$b688253958b8dfe7 = /*#__PURE__*/ (0, $ffcb4b91b9b1d115$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $ffcb4b91b9b1d115$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ffcb4b91b9b1d115$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Anchor"
    }, props), /*#__PURE__*/ $ffcb4b91b9b1d115$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm8 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM4 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm8-11v15m-8-5.027C6.194 19.324 8.86 21 12 21c3.14 0 5.807-1.676 8-5.027M16 10H8"
    }));
});
$ffcb4b91b9b1d115$var$Anchor.displayName = 'Anchor';


Object.keys($ffcb4b91b9b1d115$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ffcb4b91b9b1d115$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ffcb4b91b9b1d115$exports[key];
});
var $3ef7bf739477e47d$exports = {};

$parcel$export($3ef7bf739477e47d$exports, "__esModule", function () { return $3ef7bf739477e47d$export$1e511d4a378977f5; }, function (v) { return $3ef7bf739477e47d$export$1e511d4a378977f5 = v; });
$parcel$export($3ef7bf739477e47d$exports, "Android", function () { return $3ef7bf739477e47d$export$9c05caacc72cdd64; }, function (v) { return $3ef7bf739477e47d$export$9c05caacc72cdd64 = v; });
var $3ef7bf739477e47d$export$1e511d4a378977f5;
var $3ef7bf739477e47d$export$9c05caacc72cdd64;
"use strict";
$3ef7bf739477e47d$export$1e511d4a378977f5 = true;
$3ef7bf739477e47d$export$9c05caacc72cdd64 = void 0;

var $3ef7bf739477e47d$var$_react = $3ef7bf739477e47d$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $3ef7bf739477e47d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3ef7bf739477e47d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3ef7bf739477e47d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3ef7bf739477e47d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3ef7bf739477e47d$var$_extends() {
    return $3ef7bf739477e47d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3ef7bf739477e47d$var$_extends.apply(null, arguments);
}
var $3ef7bf739477e47d$var$Android = $3ef7bf739477e47d$export$9c05caacc72cdd64 = /*#__PURE__*/ (0, $3ef7bf739477e47d$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3ef7bf739477e47d$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3ef7bf739477e47d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Android"
    }, props), /*#__PURE__*/ $3ef7bf739477e47d$var$_react["default"].createElement("path", {
        fill: "#A4C639",
        fillRule: "evenodd",
        d: "M5.685 7.914h12.718v10.364c0 .615-.499 1.115-1.114 1.115h-1.274v3.156A1.44 1.44 0 0 1 14.587 24a1.44 1.44 0 0 1-1.43-1.451v-3.156h-2.225v3.156A1.44 1.44 0 0 1 9.502 24a1.44 1.44 0 0 1-1.429-1.451v-3.156H6.8c-.615 0-1.115-.5-1.115-1.115V7.914zm-2.492-.085c-.797 0-1.443.656-1.443 1.466v5.727c0 .808.646 1.465 1.443 1.465s1.443-.657 1.443-1.465V9.295c0-.81-.646-1.466-1.443-1.466zm15.21-.96H5.685C5.842 5.059 7.018 3.5 8.71 2.597L7.5.82a.525.525 0 1 1 .868-.59l1.318 1.936a7.204 7.204 0 0 1 4.717 0L15.721.23a.524.524 0 1 1 .867.59L15.38 2.596c1.692.902 2.866 2.461 3.023 4.274zm-8.338-2.461a.703.703 0 1 0-1.406-.001.703.703 0 0 0 1.406 0zm5.454 0a.704.704 0 1 0-1.408 0 .704.704 0 0 0 1.408 0zm5.378 3.42c-.797 0-1.444.656-1.444 1.466v5.729c0 .81.647 1.466 1.444 1.466.797 0 1.441-.657 1.441-1.466v-5.73c0-.809-.644-1.466-1.441-1.466z"
    }));
});
$3ef7bf739477e47d$var$Android.displayName = 'Android';


Object.keys($3ef7bf739477e47d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3ef7bf739477e47d$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3ef7bf739477e47d$exports[key];
});
var $565e907cb7c6df86$exports = {};

$parcel$export($565e907cb7c6df86$exports, "__esModule", function () { return $565e907cb7c6df86$export$1e511d4a378977f5; }, function (v) { return $565e907cb7c6df86$export$1e511d4a378977f5 = v; });
$parcel$export($565e907cb7c6df86$exports, "Announce", function () { return $565e907cb7c6df86$export$722c724746ce2960; }, function (v) { return $565e907cb7c6df86$export$722c724746ce2960 = v; });
var $565e907cb7c6df86$export$1e511d4a378977f5;
var $565e907cb7c6df86$export$722c724746ce2960;
"use strict";
$565e907cb7c6df86$export$1e511d4a378977f5 = true;
$565e907cb7c6df86$export$722c724746ce2960 = void 0;

var $565e907cb7c6df86$var$_react = $565e907cb7c6df86$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $565e907cb7c6df86$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($565e907cb7c6df86$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $565e907cb7c6df86$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $565e907cb7c6df86$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $565e907cb7c6df86$var$_extends() {
    return $565e907cb7c6df86$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $565e907cb7c6df86$var$_extends.apply(null, arguments);
}
var $565e907cb7c6df86$var$Announce = $565e907cb7c6df86$export$722c724746ce2960 = /*#__PURE__*/ (0, $565e907cb7c6df86$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $565e907cb7c6df86$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $565e907cb7c6df86$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Announce"
    }, props), /*#__PURE__*/ $565e907cb7c6df86$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M11 15c3 0 8 4 8 4V3s-5 4-8 4v8zm-6 0 3 8h4l-3-8m10-1a3 3 0 1 0 0-6m-8 11c1 0 3-1 3-3M2 11c0-3.111 1.791-4 4-4h5v8H6c-2.209 0-4-.889-4-4z"
    }));
});
$565e907cb7c6df86$var$Announce.displayName = 'Announce';


Object.keys($565e907cb7c6df86$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $565e907cb7c6df86$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $565e907cb7c6df86$exports[key];
});
var $30cdbbd9769b9462$exports = {};

$parcel$export($30cdbbd9769b9462$exports, "__esModule", function () { return $30cdbbd9769b9462$export$1e511d4a378977f5; }, function (v) { return $30cdbbd9769b9462$export$1e511d4a378977f5 = v; });
$parcel$export($30cdbbd9769b9462$exports, "AppleAppStore", function () { return $30cdbbd9769b9462$export$d9c8e623646dcd42; }, function (v) { return $30cdbbd9769b9462$export$d9c8e623646dcd42 = v; });
var $30cdbbd9769b9462$export$1e511d4a378977f5;
var $30cdbbd9769b9462$export$d9c8e623646dcd42;
"use strict";
$30cdbbd9769b9462$export$1e511d4a378977f5 = true;
$30cdbbd9769b9462$export$d9c8e623646dcd42 = void 0;

var $30cdbbd9769b9462$var$_react = $30cdbbd9769b9462$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $30cdbbd9769b9462$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($30cdbbd9769b9462$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $30cdbbd9769b9462$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $30cdbbd9769b9462$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $30cdbbd9769b9462$var$_extends() {
    return $30cdbbd9769b9462$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $30cdbbd9769b9462$var$_extends.apply(null, arguments);
}
var $30cdbbd9769b9462$var$AppleAppStore = $30cdbbd9769b9462$export$d9c8e623646dcd42 = /*#__PURE__*/ (0, $30cdbbd9769b9462$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $30cdbbd9769b9462$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $30cdbbd9769b9462$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "AppleAppStore"
    }, props), /*#__PURE__*/ $30cdbbd9769b9462$var$_react["default"].createElement("path", {
        fill: "#1D81F3",
        d: "M3 17a1 1 0 0 1 0-2h10.5c1 0 2 2 1.5 2H3zm14 0a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2h-4zM12.633 3.501a1 1 0 0 1 1.734.998L7.46 16.495a1 1 0 0 1-1.734-.997L12.633 3.5zM4 18.5c.5-1 3.5-2 2.5-.28A852.88 852.88 0 0 1 4.867 21a1 1 0 0 1-1.734-.998L4 18.5zM9.133 4.499a1 1 0 1 1 1.734-.998L12.61 6.53a1 1 0 1 1-1.733.998L9.133 4.499zM13 11.5c-.898-1.5 0-4.5.716-3.004L20.366 20a1 1 0 0 1-1.733.998L13 11.5z"
    }));
});
$30cdbbd9769b9462$var$AppleAppStore.displayName = 'AppleAppStore';


Object.keys($30cdbbd9769b9462$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $30cdbbd9769b9462$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $30cdbbd9769b9462$exports[key];
});
var $f9949e5600f8702f$exports = {};

$parcel$export($f9949e5600f8702f$exports, "__esModule", function () { return $f9949e5600f8702f$export$1e511d4a378977f5; }, function (v) { return $f9949e5600f8702f$export$1e511d4a378977f5 = v; });
$parcel$export($f9949e5600f8702f$exports, "AppleMusic", function () { return $f9949e5600f8702f$export$1d2deb7d4ce5b1fc; }, function (v) { return $f9949e5600f8702f$export$1d2deb7d4ce5b1fc = v; });
var $f9949e5600f8702f$export$1e511d4a378977f5;
var $f9949e5600f8702f$export$1d2deb7d4ce5b1fc;
"use strict";
$f9949e5600f8702f$export$1e511d4a378977f5 = true;
$f9949e5600f8702f$export$1d2deb7d4ce5b1fc = void 0;

var $f9949e5600f8702f$var$_react = $f9949e5600f8702f$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $f9949e5600f8702f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f9949e5600f8702f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f9949e5600f8702f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f9949e5600f8702f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f9949e5600f8702f$var$_extends() {
    return $f9949e5600f8702f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f9949e5600f8702f$var$_extends.apply(null, arguments);
}
var $f9949e5600f8702f$var$AppleMusic = $f9949e5600f8702f$export$1d2deb7d4ce5b1fc = /*#__PURE__*/ (0, $f9949e5600f8702f$var$_react.forwardRef)(function(props, ref) {
    var prefix = (0, $1b754218be0a6592$export$3794798abb123ff6)('AppleMusic');
    return /*#__PURE__*/ $f9949e5600f8702f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f9949e5600f8702f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "AppleMusic"
    }, props), /*#__PURE__*/ $f9949e5600f8702f$var$_react["default"].createElement("g", {
        clipPath: "url(#" + prefix + "-a)"
    }, /*#__PURE__*/ $f9949e5600f8702f$var$_react["default"].createElement("path", {
        fill: "url(#" + prefix + "-b)",
        fillRule: "evenodd",
        d: "M21.992 22.816c.768-.592 1.304-1.424 1.536-2.016.464-1.192.472-2.544.472-3.4V6.6c0-.848 0-2.208-.472-3.4-.232-.592-.776-1.432-1.536-2.016a4.99 4.99 0 0 0-1.688-.88C19.528.08 18.584 0 17.4 0H6.6C5.416 0 4.472.08 3.696.304a5.137 5.137 0 0 0-1.688.88C1.24 1.776.704 2.608.472 3.2.008 4.392 0 5.744 0 6.6v10.8c0 .856.008 2.208.472 3.4.232.592.776 1.432 1.536 2.016.44.344.968.664 1.688.88.776.224 1.72.304 2.904.304h10.8c1.184 0 2.136-.072 2.904-.304a5.137 5.137 0 0 0 1.688-.88Zm-5.706-19.05c.062-.013.576-.104.634-.11.385-.033.6.22.6.63v11.289c0 .303-.003.577-.067.881a2.212 2.212 0 0 1-.348.821 2.087 2.087 0 0 1-.655.606 2.605 2.605 0 0 1-.831.303c-.552.11-.93.136-1.284.065a1.791 1.791 0 0 1-.864-.44 1.88 1.88 0 0 1-.604-1.184 1.886 1.886 0 0 1 .51-1.488c.197-.207.445-.37.776-.499.347-.134.729-.215 1.317-.333l.464-.094c.205-.041.379-.093.52-.265.142-.173.144-.384.144-.593V8.084c0-.404-.182-.514-.566-.44-.276.054-6.19 1.247-6.19 1.247-.333.08-.45.19-.45.603v7.722c0 .303-.015.578-.08.882a2.213 2.213 0 0 1-.348.82 2.088 2.088 0 0 1-.654.606 2.613 2.613 0 0 1-.831.307c-.552.112-.93.136-1.284.065a1.792 1.792 0 0 1-.864-.443 1.863 1.863 0 0 1-.59-1.184 1.874 1.874 0 0 1 .496-1.488c.197-.208.445-.371.776-.5.347-.134.729-.214 1.317-.333l.464-.093c.204-.042.379-.094.52-.266.14-.172.157-.374.157-.582V6.104c0-.12.01-.201.016-.241a.724.724 0 0 1 .24-.462.992.992 0 0 1 .443-.2h.003l7.113-1.435Z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ $f9949e5600f8702f$var$_react["default"].createElement("defs", null, /*#__PURE__*/ $f9949e5600f8702f$var$_react["default"].createElement("linearGradient", {
        id: prefix + "-b",
        x1: "12",
        x2: "12",
        y1: "23.907",
        y2: ".517",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $f9949e5600f8702f$var$_react["default"].createElement("stop", {
        stopColor: "#FA233B"
    }), /*#__PURE__*/ $f9949e5600f8702f$var$_react["default"].createElement("stop", {
        offset: "1",
        stopColor: "#FB5C74"
    })), /*#__PURE__*/ $f9949e5600f8702f$var$_react["default"].createElement("clipPath", {
        id: prefix + "-a"
    }, /*#__PURE__*/ $f9949e5600f8702f$var$_react["default"].createElement("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
    }))));
});
$f9949e5600f8702f$var$AppleMusic.displayName = 'AppleMusic';


Object.keys($f9949e5600f8702f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f9949e5600f8702f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f9949e5600f8702f$exports[key];
});
var $c67eb12edafd80da$exports = {};

$parcel$export($c67eb12edafd80da$exports, "__esModule", function () { return $c67eb12edafd80da$export$1e511d4a378977f5; }, function (v) { return $c67eb12edafd80da$export$1e511d4a378977f5 = v; });
$parcel$export($c67eb12edafd80da$exports, "ApplePodcasts", function () { return $c67eb12edafd80da$export$5881b037bea3adaf; }, function (v) { return $c67eb12edafd80da$export$5881b037bea3adaf = v; });
var $c67eb12edafd80da$export$1e511d4a378977f5;
var $c67eb12edafd80da$export$5881b037bea3adaf;
"use strict";
$c67eb12edafd80da$export$1e511d4a378977f5 = true;
$c67eb12edafd80da$export$5881b037bea3adaf = void 0;

var $c67eb12edafd80da$var$_react = $c67eb12edafd80da$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $c67eb12edafd80da$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c67eb12edafd80da$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c67eb12edafd80da$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c67eb12edafd80da$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c67eb12edafd80da$var$_extends() {
    return $c67eb12edafd80da$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c67eb12edafd80da$var$_extends.apply(null, arguments);
}
var $c67eb12edafd80da$var$ApplePodcasts = $c67eb12edafd80da$export$5881b037bea3adaf = /*#__PURE__*/ (0, $c67eb12edafd80da$var$_react.forwardRef)(function(props, ref) {
    var prefix = (0, $1b754218be0a6592$export$3794798abb123ff6)('ApplePodcasts');
    return /*#__PURE__*/ $c67eb12edafd80da$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c67eb12edafd80da$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ApplePodcasts"
    }, props), /*#__PURE__*/ $c67eb12edafd80da$var$_react["default"].createElement("g", {
        clipPath: "url(#" + prefix + "-a)"
    }, /*#__PURE__*/ $c67eb12edafd80da$var$_react["default"].createElement("path", {
        fill: "url(#" + prefix + "-b)",
        fillRule: "evenodd",
        d: "M21.992 22.816c.768-.592 1.304-1.424 1.536-2.016.464-1.192.472-2.544.472-3.4V6.6c0-.848 0-2.208-.472-3.4-.232-.592-.776-1.432-1.536-2.016a4.99 4.99 0 0 0-1.688-.88C19.528.08 18.584 0 17.4 0H6.6C5.416 0 4.472.08 3.696.304a5.137 5.137 0 0 0-1.688.88C1.24 1.776.704 2.608.472 3.2.008 4.392 0 5.744 0 6.6v10.8c0 .856.008 2.208.472 3.4.232.592.776 1.432 1.536 2.016.44.344.968.664 1.688.88.776.224 1.72.304 2.904.304h10.8c1.184 0 2.136-.072 2.904-.304a5.137 5.137 0 0 0 1.688-.88ZM3.56 10.992c.064-4.592 3.824-8.32 8.416-8.336 4.664-.008 8.464 3.784 8.48 8.44 0 3.68-2.36 6.816-5.648 7.968-.08.032-.168-.032-.152-.12l.12-.864a.272.272 0 0 1 .168-.232c2.6-1.144 4.424-3.736 4.424-6.752 0-4.08-3.336-7.392-7.424-7.36-3.992.032-7.256 3.288-7.296 7.288a7.365 7.365 0 0 0 4.424 6.824.317.317 0 0 1 .168.232c.021.192.05.384.078.576l.042.288c.008.08-.072.152-.152.12-3.32-1.168-5.696-4.352-5.648-8.072Zm10.408-.584c0 1.088-.88 1.968-1.968 1.968a1.967 1.967 0 0 1-1.968-1.968c0-1.088.88-1.968 1.968-1.968s1.968.888 1.968 1.968Zm.088 4.08a1.069 1.069 0 0 0-.32-.688c-.36-.376-.992-.624-1.736-.624s-1.376.24-1.736.624c-.184.2-.288.4-.32.688-.064.558-.024 1.037.04 1.807v.009c.064.736.184 1.72.336 2.712.112.712.2 1.096.28 1.368.136.448.624.832 1.4.832.776 0 1.272-.392 1.4-.832.08-.272.168-.656.28-1.368.152-1 .272-1.976.336-2.712.072-.776.104-1.256.04-1.816Zm-2.272-9.032c-2.992.112-5.392 2.584-5.432 5.576a5.65 5.65 0 0 0 2.472 4.744c.072.048.176-.008.176-.096a7.853 7.853 0 0 1-.008-.968.326.326 0 0 0-.112-.272 4.574 4.574 0 0 1-1.448-3.456 4.585 4.585 0 0 1 4.392-4.448 4.574 4.574 0 0 1 4.752 4.568c0 1.312-.56 2.496-1.448 3.336a.381.381 0 0 0-.112.272c.016.312.008.616-.008.96-.008.088.096.152.176.096a5.661 5.661 0 0 0 2.472-4.672c.008-3.184-2.656-5.768-5.872-5.64Z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ $c67eb12edafd80da$var$_react["default"].createElement("defs", null, /*#__PURE__*/ $c67eb12edafd80da$var$_react["default"].createElement("linearGradient", {
        id: prefix + "-b",
        x1: "12",
        x2: "12",
        y1: "0",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $c67eb12edafd80da$var$_react["default"].createElement("stop", {
        stopColor: "#F452FF"
    }), /*#__PURE__*/ $c67eb12edafd80da$var$_react["default"].createElement("stop", {
        offset: "1",
        stopColor: "#832BC1"
    })), /*#__PURE__*/ $c67eb12edafd80da$var$_react["default"].createElement("clipPath", {
        id: prefix + "-a"
    }, /*#__PURE__*/ $c67eb12edafd80da$var$_react["default"].createElement("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
    }))));
});
$c67eb12edafd80da$var$ApplePodcasts.displayName = 'ApplePodcasts';


Object.keys($c67eb12edafd80da$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c67eb12edafd80da$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c67eb12edafd80da$exports[key];
});
var $a96dc1705c6907e5$exports = {};

$parcel$export($a96dc1705c6907e5$exports, "__esModule", function () { return $a96dc1705c6907e5$export$1e511d4a378977f5; }, function (v) { return $a96dc1705c6907e5$export$1e511d4a378977f5 = v; });
$parcel$export($a96dc1705c6907e5$exports, "Apple", function () { return $a96dc1705c6907e5$export$e3fccb5d29105673; }, function (v) { return $a96dc1705c6907e5$export$e3fccb5d29105673 = v; });
var $a96dc1705c6907e5$export$1e511d4a378977f5;
var $a96dc1705c6907e5$export$e3fccb5d29105673;
"use strict";
$a96dc1705c6907e5$export$1e511d4a378977f5 = true;
$a96dc1705c6907e5$export$e3fccb5d29105673 = void 0;

var $a96dc1705c6907e5$var$_react = $a96dc1705c6907e5$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a96dc1705c6907e5$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a96dc1705c6907e5$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a96dc1705c6907e5$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a96dc1705c6907e5$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a96dc1705c6907e5$var$_extends() {
    return $a96dc1705c6907e5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a96dc1705c6907e5$var$_extends.apply(null, arguments);
}
var $a96dc1705c6907e5$var$Apple = $a96dc1705c6907e5$export$e3fccb5d29105673 = /*#__PURE__*/ (0, $a96dc1705c6907e5$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a96dc1705c6907e5$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a96dc1705c6907e5$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Apple"
    }, props), /*#__PURE__*/ $a96dc1705c6907e5$var$_react["default"].createElement("path", {
        fill: "#AAA",
        fillRule: "evenodd",
        d: "M15.3 3.832c.84-1.014 1.404-2.427 1.25-3.832-1.208.049-2.67.805-3.535 1.819-.777.898-1.457 2.335-1.273 3.712 1.346.105 2.722-.684 3.56-1.699m3.02 8.918c.034 3.632 3.186 4.841 3.22 4.857-.025.085-.502 1.722-1.66 3.413-1 1.462-2.038 2.919-3.674 2.949-1.607.029-2.123-.953-3.961-.953-1.836 0-2.41.923-3.932.982-1.578.06-2.78-1.581-3.79-3.037-2.06-2.98-3.635-8.42-1.52-12.092C4.054 7.045 5.932 5.89 7.97 5.861c1.55-.03 3.013 1.043 3.96 1.043.948 0 2.726-1.29 4.595-1.101.783.033 2.979.316 4.39 2.381-.114.07-2.621 1.53-2.594 4.566"
    }));
});
$a96dc1705c6907e5$var$Apple.displayName = 'Apple';


Object.keys($a96dc1705c6907e5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a96dc1705c6907e5$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a96dc1705c6907e5$exports[key];
});
var $d9a3ef3bb912dddb$exports = {};

$parcel$export($d9a3ef3bb912dddb$exports, "__esModule", function () { return $d9a3ef3bb912dddb$export$1e511d4a378977f5; }, function (v) { return $d9a3ef3bb912dddb$export$1e511d4a378977f5 = v; });
$parcel$export($d9a3ef3bb912dddb$exports, "AppsRounded", function () { return $d9a3ef3bb912dddb$export$4d625b79c471dd7a; }, function (v) { return $d9a3ef3bb912dddb$export$4d625b79c471dd7a = v; });
var $d9a3ef3bb912dddb$export$1e511d4a378977f5;
var $d9a3ef3bb912dddb$export$4d625b79c471dd7a;
"use strict";
$d9a3ef3bb912dddb$export$1e511d4a378977f5 = true;
$d9a3ef3bb912dddb$export$4d625b79c471dd7a = void 0;

var $d9a3ef3bb912dddb$var$_react = $d9a3ef3bb912dddb$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $d9a3ef3bb912dddb$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d9a3ef3bb912dddb$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d9a3ef3bb912dddb$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d9a3ef3bb912dddb$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d9a3ef3bb912dddb$var$_extends() {
    return $d9a3ef3bb912dddb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d9a3ef3bb912dddb$var$_extends.apply(null, arguments);
}
var $d9a3ef3bb912dddb$var$AppsRounded = $d9a3ef3bb912dddb$export$4d625b79c471dd7a = /*#__PURE__*/ (0, $d9a3ef3bb912dddb$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d9a3ef3bb912dddb$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $d9a3ef3bb912dddb$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "AppsRounded"
    }, props), /*#__PURE__*/ $d9a3ef3bb912dddb$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M3 6.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C4.52 3 5.08 3 6.2 3h.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C10 4.52 10 5.08 10 6.2v.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C8.48 10 7.92 10 6.8 10h-.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 8.48 3 7.92 3 6.8v-.6zm11 0c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C15.52 3 16.08 3 17.2 3h.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C21 4.52 21 5.08 21 6.2v.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C19.48 10 18.92 10 17.8 10h-.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C14 8.48 14 7.92 14 6.8v-.6zm-11 11c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C4.52 14 5.08 14 6.2 14h.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C10 15.52 10 16.08 10 17.2v.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C8.48 21 7.92 21 6.8 21h-.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 19.48 3 18.92 3 17.8v-.6zm11 0c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C15.52 14 16.08 14 17.2 14h.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C21 15.52 21 16.08 21 17.2v.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C19.48 21 18.92 21 17.8 21h-.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C14 19.48 14 18.92 14 17.8v-.6z"
    }));
});
$d9a3ef3bb912dddb$var$AppsRounded.displayName = 'AppsRounded';


Object.keys($d9a3ef3bb912dddb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $d9a3ef3bb912dddb$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $d9a3ef3bb912dddb$exports[key];
});
var $9445cdbc20e201db$exports = {};

$parcel$export($9445cdbc20e201db$exports, "__esModule", function () { return $9445cdbc20e201db$export$1e511d4a378977f5; }, function (v) { return $9445cdbc20e201db$export$1e511d4a378977f5 = v; });
$parcel$export($9445cdbc20e201db$exports, "Apps", function () { return $9445cdbc20e201db$export$1ba5735493686b70; }, function (v) { return $9445cdbc20e201db$export$1ba5735493686b70 = v; });
var $9445cdbc20e201db$export$1e511d4a378977f5;
var $9445cdbc20e201db$export$1ba5735493686b70;
"use strict";
$9445cdbc20e201db$export$1e511d4a378977f5 = true;
$9445cdbc20e201db$export$1ba5735493686b70 = void 0;

var $9445cdbc20e201db$var$_react = $9445cdbc20e201db$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $9445cdbc20e201db$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9445cdbc20e201db$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9445cdbc20e201db$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $9445cdbc20e201db$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $9445cdbc20e201db$var$_extends() {
    return $9445cdbc20e201db$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9445cdbc20e201db$var$_extends.apply(null, arguments);
}
var $9445cdbc20e201db$var$Apps = $9445cdbc20e201db$export$1ba5735493686b70 = /*#__PURE__*/ (0, $9445cdbc20e201db$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $9445cdbc20e201db$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $9445cdbc20e201db$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Apps"
    }, props), /*#__PURE__*/ $9445cdbc20e201db$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M19 5h2V3h-2v2zm-8 0h2V3h-2v2zM3 5h2V3H3v2zm16 8h2v-2h-2v2zm-8 0h2v-2h-2v2zm-8 0h2v-2H3v2zm16 8h2v-2h-2v2zm-8 0h2v-2h-2v2zm-8 0h2v-2H3v2z"
    }));
});
$9445cdbc20e201db$var$Apps.displayName = 'Apps';


Object.keys($9445cdbc20e201db$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $9445cdbc20e201db$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $9445cdbc20e201db$exports[key];
});
var $33938118431392e3$exports = {};

$parcel$export($33938118431392e3$exports, "__esModule", function () { return $33938118431392e3$export$1e511d4a378977f5; }, function (v) { return $33938118431392e3$export$1e511d4a378977f5 = v; });
$parcel$export($33938118431392e3$exports, "Archive", function () { return $33938118431392e3$export$767c3cfd836ab901; }, function (v) { return $33938118431392e3$export$767c3cfd836ab901 = v; });
var $33938118431392e3$export$1e511d4a378977f5;
var $33938118431392e3$export$767c3cfd836ab901;
"use strict";
$33938118431392e3$export$1e511d4a378977f5 = true;
$33938118431392e3$export$767c3cfd836ab901 = void 0;

var $33938118431392e3$var$_react = $33938118431392e3$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $33938118431392e3$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($33938118431392e3$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $33938118431392e3$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $33938118431392e3$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $33938118431392e3$var$_extends() {
    return $33938118431392e3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $33938118431392e3$var$_extends.apply(null, arguments);
}
var $33938118431392e3$var$Archive = $33938118431392e3$export$767c3cfd836ab901 = /*#__PURE__*/ (0, $33938118431392e3$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $33938118431392e3$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $33938118431392e3$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Archive"
    }, props), /*#__PURE__*/ $33938118431392e3$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M3 23h18V6H3v17zm6-9h6v-4H9v4zM1 6h22V1H1v5z"
    }));
});
$33938118431392e3$var$Archive.displayName = 'Archive';


Object.keys($33938118431392e3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $33938118431392e3$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $33938118431392e3$exports[key];
});
var $c40249d2f716ca15$exports = {};

$parcel$export($c40249d2f716ca15$exports, "__esModule", function () { return $c40249d2f716ca15$export$1e511d4a378977f5; }, function (v) { return $c40249d2f716ca15$export$1e511d4a378977f5 = v; });
$parcel$export($c40249d2f716ca15$exports, "Archlinux", function () { return $c40249d2f716ca15$export$288450f56c18f861; }, function (v) { return $c40249d2f716ca15$export$288450f56c18f861 = v; });
var $c40249d2f716ca15$export$1e511d4a378977f5;
var $c40249d2f716ca15$export$288450f56c18f861;
"use strict";
$c40249d2f716ca15$export$1e511d4a378977f5 = true;
$c40249d2f716ca15$export$288450f56c18f861 = void 0;

var $c40249d2f716ca15$var$_react = $c40249d2f716ca15$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c40249d2f716ca15$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c40249d2f716ca15$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c40249d2f716ca15$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c40249d2f716ca15$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c40249d2f716ca15$var$_extends() {
    return $c40249d2f716ca15$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c40249d2f716ca15$var$_extends.apply(null, arguments);
}
var $c40249d2f716ca15$var$Archlinux = $c40249d2f716ca15$export$288450f56c18f861 = /*#__PURE__*/ (0, $c40249d2f716ca15$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c40249d2f716ca15$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c40249d2f716ca15$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Archlinux"
    }, props), /*#__PURE__*/ $c40249d2f716ca15$var$_react["default"].createElement("path", {
        fill: "#1793D1",
        fillRule: "evenodd",
        d: "M11.995 0c-1.068 2.619-1.712 4.332-2.901 6.873.729.773 1.624 1.673 3.077 2.69-1.562-.643-2.628-1.289-3.425-1.959C7.224 10.78 4.84 15.304 0 24c3.804-2.196 6.752-3.55 9.5-4.066a6.964 6.964 0 0 1-.18-1.63l.004-.121c.06-2.437 1.328-4.311 2.83-4.184 1.501.127 2.668 2.207 2.608 4.644-.011.459-.063.9-.153 1.309 2.717.532 5.634 1.882 9.387 4.048-.74-1.362-1.4-2.59-2.031-3.76-.994-.77-2.03-1.771-4.143-2.856 1.452.377 2.493.813 3.303 1.3C14.713 6.746 14.195 5.16 11.995 0z"
    }));
});
$c40249d2f716ca15$var$Archlinux.displayName = 'Archlinux';


Object.keys($c40249d2f716ca15$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c40249d2f716ca15$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c40249d2f716ca15$exports[key];
});
var $73eb72e1535220da$exports = {};

$parcel$export($73eb72e1535220da$exports, "__esModule", function () { return $73eb72e1535220da$export$1e511d4a378977f5; }, function (v) { return $73eb72e1535220da$export$1e511d4a378977f5 = v; });
$parcel$export($73eb72e1535220da$exports, "Article", function () { return $73eb72e1535220da$export$89693000420c0acd; }, function (v) { return $73eb72e1535220da$export$89693000420c0acd = v; });
var $73eb72e1535220da$export$1e511d4a378977f5;
var $73eb72e1535220da$export$89693000420c0acd;
"use strict";
$73eb72e1535220da$export$1e511d4a378977f5 = true;
$73eb72e1535220da$export$89693000420c0acd = void 0;

var $73eb72e1535220da$var$_react = $73eb72e1535220da$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $73eb72e1535220da$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($73eb72e1535220da$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $73eb72e1535220da$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $73eb72e1535220da$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $73eb72e1535220da$var$_extends() {
    return $73eb72e1535220da$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $73eb72e1535220da$var$_extends.apply(null, arguments);
}
var $73eb72e1535220da$var$Article = $73eb72e1535220da$export$89693000420c0acd = /*#__PURE__*/ (0, $73eb72e1535220da$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $73eb72e1535220da$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $73eb72e1535220da$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Article"
    }, props), /*#__PURE__*/ $73eb72e1535220da$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M16 7h3v4h-3V7zm-7 8h11M9 11h4M9 7h4M6 18.5a2.5 2.5 0 1 1-5 0V7h5.025M6 18.5V3h17v15.5a2.5 2.5 0 0 1-2.5 2.5h-17"
    }));
});
$73eb72e1535220da$var$Article.displayName = 'Article';


Object.keys($73eb72e1535220da$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $73eb72e1535220da$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $73eb72e1535220da$exports[key];
});
var $e8a08fe9120bf0bd$exports = {};

$parcel$export($e8a08fe9120bf0bd$exports, "__esModule", function () { return $e8a08fe9120bf0bd$export$1e511d4a378977f5; }, function (v) { return $e8a08fe9120bf0bd$export$1e511d4a378977f5 = v; });
$parcel$export($e8a08fe9120bf0bd$exports, "Aruba", function () { return $e8a08fe9120bf0bd$export$4f290c64bf139111; }, function (v) { return $e8a08fe9120bf0bd$export$4f290c64bf139111 = v; });
var $e8a08fe9120bf0bd$export$1e511d4a378977f5;
var $e8a08fe9120bf0bd$export$4f290c64bf139111;
"use strict";
$e8a08fe9120bf0bd$export$1e511d4a378977f5 = true;
$e8a08fe9120bf0bd$export$4f290c64bf139111 = void 0;

var $e8a08fe9120bf0bd$var$_react = $e8a08fe9120bf0bd$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e8a08fe9120bf0bd$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e8a08fe9120bf0bd$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e8a08fe9120bf0bd$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e8a08fe9120bf0bd$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e8a08fe9120bf0bd$var$_extends() {
    return $e8a08fe9120bf0bd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e8a08fe9120bf0bd$var$_extends.apply(null, arguments);
}
var $e8a08fe9120bf0bd$var$Aruba = $e8a08fe9120bf0bd$export$4f290c64bf139111 = /*#__PURE__*/ (0, $e8a08fe9120bf0bd$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e8a08fe9120bf0bd$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e8a08fe9120bf0bd$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Aruba"
    }, props), /*#__PURE__*/ $e8a08fe9120bf0bd$var$_react["default"].createElement("path", {
        fill: "#FF8300",
        fillRule: "evenodd",
        d: "M12.11 17.302c-3.074 0-5.602-2.46-5.602-5.465 0-3.006 2.528-5.465 5.602-5.465 3.074 0 5.601 2.46 5.601 5.465s-2.527 5.465-5.601 5.465zM12.11 2C6.508 2 2 6.44 2 11.837c0 5.465 4.508 9.836 10.11 9.836 2.323 0 4.44-.751 6.148-2.049 1.025 1.708 3.962 2.05 3.962 2.05v-9.837C22.22 6.44 17.71 2 12.11 2z"
    }));
});
$e8a08fe9120bf0bd$var$Aruba.displayName = 'Aruba';


Object.keys($e8a08fe9120bf0bd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e8a08fe9120bf0bd$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e8a08fe9120bf0bd$exports[key];
});
var $7a161eb42618d8da$exports = {};

$parcel$export($7a161eb42618d8da$exports, "__esModule", function () { return $7a161eb42618d8da$export$1e511d4a378977f5; }, function (v) { return $7a161eb42618d8da$export$1e511d4a378977f5 = v; });
$parcel$export($7a161eb42618d8da$exports, "Ascend", function () { return $7a161eb42618d8da$export$9a8e8f7aaef0534d; }, function (v) { return $7a161eb42618d8da$export$9a8e8f7aaef0534d = v; });
var $7a161eb42618d8da$export$1e511d4a378977f5;
var $7a161eb42618d8da$export$9a8e8f7aaef0534d;
"use strict";
$7a161eb42618d8da$export$1e511d4a378977f5 = true;
$7a161eb42618d8da$export$9a8e8f7aaef0534d = void 0;

var $7a161eb42618d8da$var$_react = $7a161eb42618d8da$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $7a161eb42618d8da$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7a161eb42618d8da$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7a161eb42618d8da$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $7a161eb42618d8da$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7a161eb42618d8da$var$_extends() {
    return $7a161eb42618d8da$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7a161eb42618d8da$var$_extends.apply(null, arguments);
}
var $7a161eb42618d8da$var$Ascend = $7a161eb42618d8da$export$9a8e8f7aaef0534d = /*#__PURE__*/ (0, $7a161eb42618d8da$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $7a161eb42618d8da$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $7a161eb42618d8da$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Ascend"
    }, props), /*#__PURE__*/ $7a161eb42618d8da$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m2 8 6-6 6 6m-3 13h11m-11-4h8m-8-4h5M8 2v20"
    }));
});
$7a161eb42618d8da$var$Ascend.displayName = 'Ascend';


Object.keys($7a161eb42618d8da$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $7a161eb42618d8da$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $7a161eb42618d8da$exports[key];
});
var $8f206f8c8f7108ad$exports = {};

$parcel$export($8f206f8c8f7108ad$exports, "__esModule", function () { return $8f206f8c8f7108ad$export$1e511d4a378977f5; }, function (v) { return $8f206f8c8f7108ad$export$1e511d4a378977f5 = v; });
$parcel$export($8f206f8c8f7108ad$exports, "Ascending", function () { return $8f206f8c8f7108ad$export$7a30a6276ac0e39e; }, function (v) { return $8f206f8c8f7108ad$export$7a30a6276ac0e39e = v; });
var $8f206f8c8f7108ad$export$1e511d4a378977f5;
var $8f206f8c8f7108ad$export$7a30a6276ac0e39e;
"use strict";
$8f206f8c8f7108ad$export$1e511d4a378977f5 = true;
$8f206f8c8f7108ad$export$7a30a6276ac0e39e = void 0;

var $8f206f8c8f7108ad$var$_react = $8f206f8c8f7108ad$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $8f206f8c8f7108ad$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8f206f8c8f7108ad$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8f206f8c8f7108ad$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $8f206f8c8f7108ad$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8f206f8c8f7108ad$var$_extends() {
    return $8f206f8c8f7108ad$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8f206f8c8f7108ad$var$_extends.apply(null, arguments);
}
var $8f206f8c8f7108ad$var$Ascending = $8f206f8c8f7108ad$export$7a30a6276ac0e39e = /*#__PURE__*/ (0, $8f206f8c8f7108ad$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $8f206f8c8f7108ad$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $8f206f8c8f7108ad$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Ascending"
    }, props), /*#__PURE__*/ $8f206f8c8f7108ad$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m12.08 7.286.354-.353.354.353L17 11.498l-.707.708-3.358-3.359V17h-1V8.847l-3.359 3.359-.707-.708 4.212-4.212z",
        fill: "#000"
    }));
});
$8f206f8c8f7108ad$var$Ascending.displayName = 'Ascending';


Object.keys($8f206f8c8f7108ad$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $8f206f8c8f7108ad$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $8f206f8c8f7108ad$exports[key];
});

Object.keys($2504912870405b96$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $2504912870405b96$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $2504912870405b96$exports[key];
});
var $172597bba3d9e4ff$exports = {};

$parcel$export($172597bba3d9e4ff$exports, "__esModule", function () { return $172597bba3d9e4ff$export$1e511d4a378977f5; }, function (v) { return $172597bba3d9e4ff$export$1e511d4a378977f5 = v; });
$parcel$export($172597bba3d9e4ff$exports, "Atm", function () { return $172597bba3d9e4ff$export$98b86f27d6a6bbac; }, function (v) { return $172597bba3d9e4ff$export$98b86f27d6a6bbac = v; });
var $172597bba3d9e4ff$export$1e511d4a378977f5;
var $172597bba3d9e4ff$export$98b86f27d6a6bbac;
"use strict";
$172597bba3d9e4ff$export$1e511d4a378977f5 = true;
$172597bba3d9e4ff$export$98b86f27d6a6bbac = void 0;

var $172597bba3d9e4ff$var$_react = $172597bba3d9e4ff$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $172597bba3d9e4ff$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($172597bba3d9e4ff$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $172597bba3d9e4ff$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $172597bba3d9e4ff$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $172597bba3d9e4ff$var$_extends() {
    return $172597bba3d9e4ff$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $172597bba3d9e4ff$var$_extends.apply(null, arguments);
}
var $172597bba3d9e4ff$var$Atm = $172597bba3d9e4ff$export$98b86f27d6a6bbac = /*#__PURE__*/ (0, $172597bba3d9e4ff$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $172597bba3d9e4ff$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $172597bba3d9e4ff$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Atm"
    }, props), /*#__PURE__*/ $172597bba3d9e4ff$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4 10H1V6h22v4h-3M6 6h12v14.006A2.003 2.003 0 0 1 15.991 22H8.01A2.002 2.002 0 0 1 6 20.006V6zm7 12h3m-3-3h3m-3-3h3m-6 10V6M3 2h3m2 0h3m2 0h3m2 0h3"
    }));
});
$172597bba3d9e4ff$var$Atm.displayName = 'Atm';


Object.keys($172597bba3d9e4ff$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $172597bba3d9e4ff$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $172597bba3d9e4ff$exports[key];
});
var $648b6aff077e9506$exports = {};

$parcel$export($648b6aff077e9506$exports, "__esModule", function () { return $648b6aff077e9506$export$1e511d4a378977f5; }, function (v) { return $648b6aff077e9506$export$1e511d4a378977f5 = v; });
$parcel$export($648b6aff077e9506$exports, "Attachment", function () { return $648b6aff077e9506$export$71e4db985cfcf9e3; }, function (v) { return $648b6aff077e9506$export$71e4db985cfcf9e3 = v; });
var $648b6aff077e9506$export$1e511d4a378977f5;
var $648b6aff077e9506$export$71e4db985cfcf9e3;
"use strict";
$648b6aff077e9506$export$1e511d4a378977f5 = true;
$648b6aff077e9506$export$71e4db985cfcf9e3 = void 0;

var $648b6aff077e9506$var$_react = $648b6aff077e9506$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $648b6aff077e9506$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($648b6aff077e9506$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $648b6aff077e9506$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $648b6aff077e9506$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $648b6aff077e9506$var$_extends() {
    return $648b6aff077e9506$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $648b6aff077e9506$var$_extends.apply(null, arguments);
}
var $648b6aff077e9506$var$Attachment = $648b6aff077e9506$export$71e4db985cfcf9e3 = /*#__PURE__*/ (0, $648b6aff077e9506$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $648b6aff077e9506$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $648b6aff077e9506$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Attachment"
    }, props), /*#__PURE__*/ $648b6aff077e9506$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m22 12-9 9c-6 6-15-3-9-9l9-9c4-4 10 2 6 6l-9 9c-2 2-5-1-3-3l9-9"
    }));
});
$648b6aff077e9506$var$Attachment.displayName = 'Attachment';


Object.keys($648b6aff077e9506$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $648b6aff077e9506$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $648b6aff077e9506$exports[key];
});
var $f6786e2867ef5b2a$exports = {};

$parcel$export($f6786e2867ef5b2a$exports, "__esModule", function () { return $f6786e2867ef5b2a$export$1e511d4a378977f5; }, function (v) { return $f6786e2867ef5b2a$export$1e511d4a378977f5 = v; });
$parcel$export($f6786e2867ef5b2a$exports, "Attraction", function () { return $f6786e2867ef5b2a$export$13cd57b1bcb75e07; }, function (v) { return $f6786e2867ef5b2a$export$13cd57b1bcb75e07 = v; });
var $f6786e2867ef5b2a$export$1e511d4a378977f5;
var $f6786e2867ef5b2a$export$13cd57b1bcb75e07;
"use strict";
$f6786e2867ef5b2a$export$1e511d4a378977f5 = true;
$f6786e2867ef5b2a$export$13cd57b1bcb75e07 = void 0;

var $f6786e2867ef5b2a$var$_react = $f6786e2867ef5b2a$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f6786e2867ef5b2a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f6786e2867ef5b2a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f6786e2867ef5b2a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f6786e2867ef5b2a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f6786e2867ef5b2a$var$_extends() {
    return $f6786e2867ef5b2a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f6786e2867ef5b2a$var$_extends.apply(null, arguments);
}
var $f6786e2867ef5b2a$var$Attraction = $f6786e2867ef5b2a$export$13cd57b1bcb75e07 = /*#__PURE__*/ (0, $f6786e2867ef5b2a$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f6786e2867ef5b2a$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f6786e2867ef5b2a$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Attraction"
    }, props), /*#__PURE__*/ $f6786e2867ef5b2a$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m13 2 1.5.5L13 3V2zm1 16 1 5h-2l1-5zm0-1.5 2 6.5h-4l2-6.5zM12 6l9 5v2H3v-2l9-5zm-7.5 7h15c0 4.167 1.5 10 1.5 10H3s1.5-5.833 1.5-10zm0 0h15c0 4.167 1.5 10 1.5 10H3s1.5-5.833 1.5-10z"
    }));
});
$f6786e2867ef5b2a$var$Attraction.displayName = 'Attraction';


Object.keys($f6786e2867ef5b2a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f6786e2867ef5b2a$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f6786e2867ef5b2a$exports[key];
});
var $7c330926321cc3b1$exports = {};

$parcel$export($7c330926321cc3b1$exports, "__esModule", function () { return $7c330926321cc3b1$export$1e511d4a378977f5; }, function (v) { return $7c330926321cc3b1$export$1e511d4a378977f5 = v; });
$parcel$export($7c330926321cc3b1$exports, "Baby", function () { return $7c330926321cc3b1$export$203882ffff267543; }, function (v) { return $7c330926321cc3b1$export$203882ffff267543 = v; });
var $7c330926321cc3b1$export$1e511d4a378977f5;
var $7c330926321cc3b1$export$203882ffff267543;
"use strict";
$7c330926321cc3b1$export$1e511d4a378977f5 = true;
$7c330926321cc3b1$export$203882ffff267543 = void 0;

var $7c330926321cc3b1$var$_react = $7c330926321cc3b1$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $7c330926321cc3b1$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7c330926321cc3b1$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7c330926321cc3b1$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $7c330926321cc3b1$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7c330926321cc3b1$var$_extends() {
    return $7c330926321cc3b1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7c330926321cc3b1$var$_extends.apply(null, arguments);
}
var $7c330926321cc3b1$var$Baby = $7c330926321cc3b1$export$203882ffff267543 = /*#__PURE__*/ (0, $7c330926321cc3b1$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $7c330926321cc3b1$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $7c330926321cc3b1$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Baby"
    }, props), /*#__PURE__*/ $7c330926321cc3b1$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M10 15h4s-1 1.5-2 1.5-2-1.5-2-1.5zm2-9a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm6 6-4-3m0 6 3 2.5-2.5 2.5M6 12l4-3m0 6-2.5 2.75L10 20m0-11h4v3h-4V9z"
    }));
});
$7c330926321cc3b1$var$Baby.displayName = 'Baby';


Object.keys($7c330926321cc3b1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $7c330926321cc3b1$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $7c330926321cc3b1$exports[key];
});
var $ac79a98f00183add$exports = {};

$parcel$export($ac79a98f00183add$exports, "__esModule", function () { return $ac79a98f00183add$export$1e511d4a378977f5; }, function (v) { return $ac79a98f00183add$export$1e511d4a378977f5 = v; });
$parcel$export($ac79a98f00183add$exports, "BackTen", function () { return $ac79a98f00183add$export$5cdc2f9f113099e6; }, function (v) { return $ac79a98f00183add$export$5cdc2f9f113099e6 = v; });
var $ac79a98f00183add$export$1e511d4a378977f5;
var $ac79a98f00183add$export$5cdc2f9f113099e6;
"use strict";
$ac79a98f00183add$export$1e511d4a378977f5 = true;
$ac79a98f00183add$export$5cdc2f9f113099e6 = void 0;

var $ac79a98f00183add$var$_react = $ac79a98f00183add$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $ac79a98f00183add$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ac79a98f00183add$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ac79a98f00183add$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ac79a98f00183add$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ac79a98f00183add$var$_extends() {
    return $ac79a98f00183add$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ac79a98f00183add$var$_extends.apply(null, arguments);
}
var $ac79a98f00183add$var$BackTen = $ac79a98f00183add$export$5cdc2f9f113099e6 = /*#__PURE__*/ (0, $ac79a98f00183add$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $ac79a98f00183add$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ac79a98f00183add$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "BackTen"
    }, props), /*#__PURE__*/ $ac79a98f00183add$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M3.111 7.556C4.67 4.267 8.07 2 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12m0-8v4h4m3 8V9l-2 .533M17 12c0-2-1-3.5-2.5-3.5S12 10 12 12s1 3.5 2.5 3.5S17 14 17 12zm-2.5-3.5C16.925 8.5 17 11 17 12s0 3.5-2.5 3.5S12 13 12 12s.059-3.5 2.5-3.5z"
    }));
});
$ac79a98f00183add$var$BackTen.displayName = 'BackTen';


Object.keys($ac79a98f00183add$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ac79a98f00183add$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ac79a98f00183add$exports[key];
});
var $57425bafa776d9af$exports = {};

$parcel$export($57425bafa776d9af$exports, "__esModule", function () { return $57425bafa776d9af$export$1e511d4a378977f5; }, function (v) { return $57425bafa776d9af$export$1e511d4a378977f5 = v; });
$parcel$export($57425bafa776d9af$exports, "BarChart", function () { return $57425bafa776d9af$export$94aefc399ef206a9; }, function (v) { return $57425bafa776d9af$export$94aefc399ef206a9 = v; });
var $57425bafa776d9af$export$1e511d4a378977f5;
var $57425bafa776d9af$export$94aefc399ef206a9;
"use strict";
$57425bafa776d9af$export$1e511d4a378977f5 = true;
$57425bafa776d9af$export$94aefc399ef206a9 = void 0;

var $57425bafa776d9af$var$_react = $57425bafa776d9af$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $57425bafa776d9af$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($57425bafa776d9af$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $57425bafa776d9af$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $57425bafa776d9af$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $57425bafa776d9af$var$_extends() {
    return $57425bafa776d9af$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $57425bafa776d9af$var$_extends.apply(null, arguments);
}
var $57425bafa776d9af$var$BarChart = $57425bafa776d9af$export$94aefc399ef206a9 = /*#__PURE__*/ (0, $57425bafa776d9af$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $57425bafa776d9af$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $57425bafa776d9af$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "BarChart"
    }, props), /*#__PURE__*/ $57425bafa776d9af$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M0 22h24M22 2h-4v16h4V2zM6 6H2v12h4V6zm8 12h-4v-8h4v8z"
    }));
});
$57425bafa776d9af$var$BarChart.displayName = 'BarChart';


Object.keys($57425bafa776d9af$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $57425bafa776d9af$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $57425bafa776d9af$exports[key];
});
var $85fb2b9ea88e8436$exports = {};

$parcel$export($85fb2b9ea88e8436$exports, "__esModule", function () { return $85fb2b9ea88e8436$export$1e511d4a378977f5; }, function (v) { return $85fb2b9ea88e8436$export$1e511d4a378977f5 = v; });
$parcel$export($85fb2b9ea88e8436$exports, "Bar", function () { return $85fb2b9ea88e8436$export$bbc6c6369b38e3d1; }, function (v) { return $85fb2b9ea88e8436$export$bbc6c6369b38e3d1 = v; });
var $85fb2b9ea88e8436$export$1e511d4a378977f5;
var $85fb2b9ea88e8436$export$bbc6c6369b38e3d1;
"use strict";
$85fb2b9ea88e8436$export$1e511d4a378977f5 = true;
$85fb2b9ea88e8436$export$bbc6c6369b38e3d1 = void 0;

var $85fb2b9ea88e8436$var$_react = $85fb2b9ea88e8436$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $85fb2b9ea88e8436$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($85fb2b9ea88e8436$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $85fb2b9ea88e8436$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $85fb2b9ea88e8436$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $85fb2b9ea88e8436$var$_extends() {
    return $85fb2b9ea88e8436$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $85fb2b9ea88e8436$var$_extends.apply(null, arguments);
}
var $85fb2b9ea88e8436$var$Bar = $85fb2b9ea88e8436$export$bbc6c6369b38e3d1 = /*#__PURE__*/ (0, $85fb2b9ea88e8436$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $85fb2b9ea88e8436$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $85fb2b9ea88e8436$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Bar"
    }, props), /*#__PURE__*/ $85fb2b9ea88e8436$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M7 5h16v18H7V5zm0 0h16V3c0-1.105-.895-2-1.994-2H8.994A1.992 1.992 0 0 0 7 3v2zM1 8.009C1 6.899 1.898 6 2.998 6H7v12H2.998A2.005 2.005 0 0 1 1 15.991V8.01zM11 8v10m4-10v10m4-10v10"
    }));
});
$85fb2b9ea88e8436$var$Bar.displayName = 'Bar';


Object.keys($85fb2b9ea88e8436$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $85fb2b9ea88e8436$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $85fb2b9ea88e8436$exports[key];
});
var $35224dcdf03e4089$exports = {};

$parcel$export($35224dcdf03e4089$exports, "__esModule", function () { return $35224dcdf03e4089$export$1e511d4a378977f5; }, function (v) { return $35224dcdf03e4089$export$1e511d4a378977f5 = v; });
$parcel$export($35224dcdf03e4089$exports, "Basket", function () { return $35224dcdf03e4089$export$9b886c3342be06c4; }, function (v) { return $35224dcdf03e4089$export$9b886c3342be06c4 = v; });
var $35224dcdf03e4089$export$1e511d4a378977f5;
var $35224dcdf03e4089$export$9b886c3342be06c4;
"use strict";
$35224dcdf03e4089$export$1e511d4a378977f5 = true;
$35224dcdf03e4089$export$9b886c3342be06c4 = void 0;

var $35224dcdf03e4089$var$_react = $35224dcdf03e4089$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $35224dcdf03e4089$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($35224dcdf03e4089$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $35224dcdf03e4089$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $35224dcdf03e4089$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $35224dcdf03e4089$var$_extends() {
    return $35224dcdf03e4089$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $35224dcdf03e4089$var$_extends.apply(null, arguments);
}
var $35224dcdf03e4089$var$Basket = $35224dcdf03e4089$export$9b886c3342be06c4 = /*#__PURE__*/ (0, $35224dcdf03e4089$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $35224dcdf03e4089$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $35224dcdf03e4089$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Basket"
    }, props), /*#__PURE__*/ $35224dcdf03e4089$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 12h20l-2 11H4L2 12zm18-4-6-7M4 8l6-7M1 8h22v4H1V8zm7 7v5m8-5v5m-4-5v5"
    }));
});
$35224dcdf03e4089$var$Basket.displayName = 'Basket';


Object.keys($35224dcdf03e4089$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $35224dcdf03e4089$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $35224dcdf03e4089$exports[key];
});
var $4b169616c583927e$exports = {};

$parcel$export($4b169616c583927e$exports, "__esModule", function () { return $4b169616c583927e$export$1e511d4a378977f5; }, function (v) { return $4b169616c583927e$export$1e511d4a378977f5 = v; });
$parcel$export($4b169616c583927e$exports, "Beacon", function () { return $4b169616c583927e$export$3a072735a9f1591c; }, function (v) { return $4b169616c583927e$export$3a072735a9f1591c = v; });
var $4b169616c583927e$export$1e511d4a378977f5;
var $4b169616c583927e$export$3a072735a9f1591c;
"use strict";
$4b169616c583927e$export$1e511d4a378977f5 = true;
$4b169616c583927e$export$3a072735a9f1591c = void 0;

var $4b169616c583927e$var$_react = $4b169616c583927e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $4b169616c583927e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4b169616c583927e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4b169616c583927e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $4b169616c583927e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $4b169616c583927e$var$_extends() {
    return $4b169616c583927e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4b169616c583927e$var$_extends.apply(null, arguments);
}
var $4b169616c583927e$var$Beacon = $4b169616c583927e$export$3a072735a9f1591c = /*#__PURE__*/ (0, $4b169616c583927e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $4b169616c583927e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $4b169616c583927e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Beacon"
    }, props), /*#__PURE__*/ $4b169616c583927e$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 0v11M7.05 4.05A6.978 6.978 0 0 0 5 9c0 1.933.784 3.683 2.05 4.95m9.9 0A6.978 6.978 0 0 0 19 9a6.978 6.978 0 0 0-2.05-4.95M4.222 1.222A10.966 10.966 0 0 0 1 9c0 3.037 1.231 5.787 3.222 7.778m15.556 0A10.966 10.966 0 0 0 23 9c0-3.038-1.231-5.788-3.222-7.778"
    }));
});
$4b169616c583927e$var$Beacon.displayName = 'Beacon';


Object.keys($4b169616c583927e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $4b169616c583927e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $4b169616c583927e$exports[key];
});
var $4e2609d4fa63ab96$exports = {};

$parcel$export($4e2609d4fa63ab96$exports, "__esModule", function () { return $4e2609d4fa63ab96$export$1e511d4a378977f5; }, function (v) { return $4e2609d4fa63ab96$export$1e511d4a378977f5 = v; });
$parcel$export($4e2609d4fa63ab96$exports, "Bike", function () { return $4e2609d4fa63ab96$export$ce3f2c13b1523463; }, function (v) { return $4e2609d4fa63ab96$export$ce3f2c13b1523463 = v; });
var $4e2609d4fa63ab96$export$1e511d4a378977f5;
var $4e2609d4fa63ab96$export$ce3f2c13b1523463;
"use strict";
$4e2609d4fa63ab96$export$1e511d4a378977f5 = true;
$4e2609d4fa63ab96$export$ce3f2c13b1523463 = void 0;

var $4e2609d4fa63ab96$var$_react = $4e2609d4fa63ab96$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $4e2609d4fa63ab96$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4e2609d4fa63ab96$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4e2609d4fa63ab96$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $4e2609d4fa63ab96$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $4e2609d4fa63ab96$var$_extends() {
    return $4e2609d4fa63ab96$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4e2609d4fa63ab96$var$_extends.apply(null, arguments);
}
var $4e2609d4fa63ab96$var$Bike = $4e2609d4fa63ab96$export$ce3f2c13b1523463 = /*#__PURE__*/ (0, $4e2609d4fa63ab96$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $4e2609d4fa63ab96$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $4e2609d4fa63ab96$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Bike"
    }, props), /*#__PURE__*/ $4e2609d4fa63ab96$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M5 19a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm14 0a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM5 6h5m9 9L16 5h-3M9 9l-4 6h7c0-3 2-6 5-6H9zm0 0L7 6"
    }));
});
$4e2609d4fa63ab96$var$Bike.displayName = 'Bike';


Object.keys($4e2609d4fa63ab96$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $4e2609d4fa63ab96$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $4e2609d4fa63ab96$exports[key];
});
var $06d57443dc1519dc$exports = {};

$parcel$export($06d57443dc1519dc$exports, "__esModule", function () { return $06d57443dc1519dc$export$1e511d4a378977f5; }, function (v) { return $06d57443dc1519dc$export$1e511d4a378977f5 = v; });
$parcel$export($06d57443dc1519dc$exports, "Bitcoin", function () { return $06d57443dc1519dc$export$531e9646a019ef61; }, function (v) { return $06d57443dc1519dc$export$531e9646a019ef61 = v; });
var $06d57443dc1519dc$export$1e511d4a378977f5;
var $06d57443dc1519dc$export$531e9646a019ef61;
"use strict";
$06d57443dc1519dc$export$1e511d4a378977f5 = true;
$06d57443dc1519dc$export$531e9646a019ef61 = void 0;

var $06d57443dc1519dc$var$_react = $06d57443dc1519dc$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $06d57443dc1519dc$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($06d57443dc1519dc$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $06d57443dc1519dc$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $06d57443dc1519dc$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $06d57443dc1519dc$var$_extends() {
    return $06d57443dc1519dc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $06d57443dc1519dc$var$_extends.apply(null, arguments);
}
var $06d57443dc1519dc$var$Bitcoin = $06d57443dc1519dc$export$531e9646a019ef61 = /*#__PURE__*/ (0, $06d57443dc1519dc$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $06d57443dc1519dc$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $06d57443dc1519dc$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Bitcoin"
    }, props), /*#__PURE__*/ $06d57443dc1519dc$var$_react["default"].createElement("path", {
        fill: "#F90",
        fillRule: "evenodd",
        d: "M23.64 14.905c-1.602 6.429-8.114 10.342-14.544 8.738C2.669 22.041-1.244 15.528.359 9.1 1.962 2.67 8.473-1.244 14.902.36c6.43 1.603 10.342 8.116 8.739 14.546zm-6.349-4.613c.24-1.597-.977-2.456-2.64-3.028l.54-2.164-1.317-.328-.525 2.106a55.083 55.083 0 0 0-1.055-.248l.53-2.12-1.317-.328-.54 2.162a44.05 44.05 0 0 1-.84-.197l.001-.007-1.816-.453-.35 1.406s.977.224.956.238c.534.133.63.486.614.766l-.615 2.464c.037.01.085.023.137.044l-.139-.035-.86 3.453c-.066.162-.231.405-.604.312.013.02-.957-.239-.957-.239l-.654 1.508 1.713.427c.32.08.632.163.94.242l-.546 2.188 1.316.328.54-2.164c.359.097.707.187 1.049.272l-.538 2.155 1.317.328.544-2.184c2.246.425 3.934.253 4.645-1.778.573-1.635-.029-2.578-1.21-3.193.86-.198 1.508-.764 1.681-1.933zm-3.008 4.219c-.407 1.635-3.16.75-4.053.53l.723-2.9c.893.223 3.755.664 3.33 2.37zm.407-4.243c-.371 1.487-2.663.732-3.406.547l.656-2.63c.743.186 3.137.532 2.75 2.083z"
    }));
});
$06d57443dc1519dc$var$Bitcoin.displayName = 'Bitcoin';


Object.keys($06d57443dc1519dc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $06d57443dc1519dc$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $06d57443dc1519dc$exports[key];
});
var $c6e3022c877ca6aa$exports = {};

$parcel$export($c6e3022c877ca6aa$exports, "__esModule", function () { return $c6e3022c877ca6aa$export$1e511d4a378977f5; }, function (v) { return $c6e3022c877ca6aa$export$1e511d4a378977f5 = v; });
$parcel$export($c6e3022c877ca6aa$exports, "BladesHorizontal", function () { return $c6e3022c877ca6aa$export$9144ab270b40465e; }, function (v) { return $c6e3022c877ca6aa$export$9144ab270b40465e = v; });
var $c6e3022c877ca6aa$export$1e511d4a378977f5;
var $c6e3022c877ca6aa$export$9144ab270b40465e;
"use strict";
$c6e3022c877ca6aa$export$1e511d4a378977f5 = true;
$c6e3022c877ca6aa$export$9144ab270b40465e = void 0;

var $c6e3022c877ca6aa$var$_react = $c6e3022c877ca6aa$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c6e3022c877ca6aa$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c6e3022c877ca6aa$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c6e3022c877ca6aa$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c6e3022c877ca6aa$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c6e3022c877ca6aa$var$_extends() {
    return $c6e3022c877ca6aa$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c6e3022c877ca6aa$var$_extends.apply(null, arguments);
}
var $c6e3022c877ca6aa$var$BladesHorizontal = $c6e3022c877ca6aa$export$9144ab270b40465e = /*#__PURE__*/ (0, $c6e3022c877ca6aa$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c6e3022c877ca6aa$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c6e3022c877ca6aa$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "BladesHorizontal"
    }, props), /*#__PURE__*/ $c6e3022c877ca6aa$var$_react["default"].createElement("path", {
        stroke: "#000",
        strokeWidth: "2",
        fill: "none",
        d: "M3 17h4m3 0h4m3 0h4M4 21h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1zm7 0h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1zm7 0h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1z"
    }));
});
$c6e3022c877ca6aa$var$BladesHorizontal.displayName = 'BladesHorizontal';


Object.keys($c6e3022c877ca6aa$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c6e3022c877ca6aa$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c6e3022c877ca6aa$exports[key];
});
var $f531999bf61b49e7$exports = {};

$parcel$export($f531999bf61b49e7$exports, "__esModule", function () { return $f531999bf61b49e7$export$1e511d4a378977f5; }, function (v) { return $f531999bf61b49e7$export$1e511d4a378977f5 = v; });
$parcel$export($f531999bf61b49e7$exports, "BladesVertical", function () { return $f531999bf61b49e7$export$b81577dbf0fe06a2; }, function (v) { return $f531999bf61b49e7$export$b81577dbf0fe06a2 = v; });
var $f531999bf61b49e7$export$1e511d4a378977f5;
var $f531999bf61b49e7$export$b81577dbf0fe06a2;
"use strict";
$f531999bf61b49e7$export$1e511d4a378977f5 = true;
$f531999bf61b49e7$export$b81577dbf0fe06a2 = void 0;

var $f531999bf61b49e7$var$_react = $f531999bf61b49e7$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f531999bf61b49e7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f531999bf61b49e7$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f531999bf61b49e7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f531999bf61b49e7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f531999bf61b49e7$var$_extends() {
    return $f531999bf61b49e7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f531999bf61b49e7$var$_extends.apply(null, arguments);
}
var $f531999bf61b49e7$var$BladesVertical = $f531999bf61b49e7$export$b81577dbf0fe06a2 = /*#__PURE__*/ (0, $f531999bf61b49e7$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f531999bf61b49e7$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f531999bf61b49e7$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "BladesVertical"
    }, props), /*#__PURE__*/ $f531999bf61b49e7$var$_react["default"].createElement("path", {
        stroke: "#000",
        strokeWidth: "2",
        fill: "none",
        d: "M17 3v4m0 3v4m0 3v4m4-17v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1zm0 7v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1zm0 7v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1z"
    }));
});
$f531999bf61b49e7$var$BladesVertical.displayName = 'BladesVertical';


Object.keys($f531999bf61b49e7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f531999bf61b49e7$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f531999bf61b49e7$exports[key];
});
var $42b1f50c99f9d5c9$exports = {};

$parcel$export($42b1f50c99f9d5c9$exports, "__esModule", function () { return $42b1f50c99f9d5c9$export$1e511d4a378977f5; }, function (v) { return $42b1f50c99f9d5c9$export$1e511d4a378977f5 = v; });
$parcel$export($42b1f50c99f9d5c9$exports, "BlockQuote", function () { return $42b1f50c99f9d5c9$export$181f102f0a3746b9; }, function (v) { return $42b1f50c99f9d5c9$export$181f102f0a3746b9 = v; });
var $42b1f50c99f9d5c9$export$1e511d4a378977f5;
var $42b1f50c99f9d5c9$export$181f102f0a3746b9;
"use strict";
$42b1f50c99f9d5c9$export$1e511d4a378977f5 = true;
$42b1f50c99f9d5c9$export$181f102f0a3746b9 = void 0;

var $42b1f50c99f9d5c9$var$_react = $42b1f50c99f9d5c9$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $42b1f50c99f9d5c9$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($42b1f50c99f9d5c9$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $42b1f50c99f9d5c9$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $42b1f50c99f9d5c9$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $42b1f50c99f9d5c9$var$_extends() {
    return $42b1f50c99f9d5c9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $42b1f50c99f9d5c9$var$_extends.apply(null, arguments);
}
var $42b1f50c99f9d5c9$var$BlockQuote = $42b1f50c99f9d5c9$export$181f102f0a3746b9 = /*#__PURE__*/ (0, $42b1f50c99f9d5c9$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $42b1f50c99f9d5c9$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $42b1f50c99f9d5c9$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "BlockQuote"
    }, props), /*#__PURE__*/ $42b1f50c99f9d5c9$var$_react["default"].createElement("path", {
        d: "M.78 8.89c0-3.07 1.53-4.3 4.3-4.34L5.38 6C3.78 6.17 3 7 3.1 8.31h1.44V12H.78zm5.9 0c0-3.07 1.53-4.3 4.3-4.34l.3 1.45C9.68 6.17 8.89 7 9 8.31h1.44V12H6.68zm10.26 6.22c0 3.07-1.53 4.3-4.3 4.34L12.35 18c1.6-.16 2.39-1 2.28-2.3h-1.45V12h3.76zm5.9 0c0 3.07-1.53 4.3-4.3 4.34l-.3-1.45c1.6-.16 2.39-1 2.28-2.3h-1.44V12h3.76z"
    }));
});
$42b1f50c99f9d5c9$var$BlockQuote.displayName = 'BlockQuote';


Object.keys($42b1f50c99f9d5c9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $42b1f50c99f9d5c9$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $42b1f50c99f9d5c9$exports[key];
});
var $b0e32054c1a59970$exports = {};

$parcel$export($b0e32054c1a59970$exports, "__esModule", function () { return $b0e32054c1a59970$export$1e511d4a378977f5; }, function (v) { return $b0e32054c1a59970$export$1e511d4a378977f5 = v; });
$parcel$export($b0e32054c1a59970$exports, "Blog", function () { return $b0e32054c1a59970$export$b68be92453dfc5b6; }, function (v) { return $b0e32054c1a59970$export$b68be92453dfc5b6 = v; });
var $b0e32054c1a59970$export$1e511d4a378977f5;
var $b0e32054c1a59970$export$b68be92453dfc5b6;
"use strict";
$b0e32054c1a59970$export$1e511d4a378977f5 = true;
$b0e32054c1a59970$export$b68be92453dfc5b6 = void 0;

var $b0e32054c1a59970$var$_react = $b0e32054c1a59970$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $b0e32054c1a59970$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b0e32054c1a59970$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b0e32054c1a59970$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $b0e32054c1a59970$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b0e32054c1a59970$var$_extends() {
    return $b0e32054c1a59970$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b0e32054c1a59970$var$_extends.apply(null, arguments);
}
var $b0e32054c1a59970$var$Blog = $b0e32054c1a59970$export$b68be92453dfc5b6 = /*#__PURE__*/ (0, $b0e32054c1a59970$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $b0e32054c1a59970$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $b0e32054c1a59970$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Blog"
    }, props), /*#__PURE__*/ $b0e32054c1a59970$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M5 16a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM5 1c9.925 0 18 8.075 18 18m-5 0c0-7.168-5.832-13-13-13m8 13c0-4.411-3.589-8-8-8m-3 0v8"
    }));
});
$b0e32054c1a59970$var$Blog.displayName = 'Blog';


Object.keys($b0e32054c1a59970$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $b0e32054c1a59970$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $b0e32054c1a59970$exports[key];
});
var $09b9945254ab732b$exports = {};

$parcel$export($09b9945254ab732b$exports, "__esModule", function () { return $09b9945254ab732b$export$1e511d4a378977f5; }, function (v) { return $09b9945254ab732b$export$1e511d4a378977f5 = v; });
$parcel$export($09b9945254ab732b$exports, "Bluetooth", function () { return $09b9945254ab732b$export$3f015ab66c3e5653; }, function (v) { return $09b9945254ab732b$export$3f015ab66c3e5653 = v; });
var $09b9945254ab732b$export$1e511d4a378977f5;
var $09b9945254ab732b$export$3f015ab66c3e5653;
"use strict";
$09b9945254ab732b$export$1e511d4a378977f5 = true;
$09b9945254ab732b$export$3f015ab66c3e5653 = void 0;

var $09b9945254ab732b$var$_react = $09b9945254ab732b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $09b9945254ab732b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($09b9945254ab732b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $09b9945254ab732b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $09b9945254ab732b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $09b9945254ab732b$var$_extends() {
    return $09b9945254ab732b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $09b9945254ab732b$var$_extends.apply(null, arguments);
}
var $09b9945254ab732b$var$Bluetooth = $09b9945254ab732b$export$3f015ab66c3e5653 = /*#__PURE__*/ (0, $09b9945254ab732b$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $09b9945254ab732b$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $09b9945254ab732b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Bluetooth"
    }, props), /*#__PURE__*/ $09b9945254ab732b$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m7 7 10 9-5 4V4l5 4-10 8"
    }));
});
$09b9945254ab732b$var$Bluetooth.displayName = 'Bluetooth';


Object.keys($09b9945254ab732b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $09b9945254ab732b$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $09b9945254ab732b$exports[key];
});
var $a68f5e7339ac959e$exports = {};

$parcel$export($a68f5e7339ac959e$exports, "__esModule", function () { return $a68f5e7339ac959e$export$1e511d4a378977f5; }, function (v) { return $a68f5e7339ac959e$export$1e511d4a378977f5 = v; });
$parcel$export($a68f5e7339ac959e$exports, "Bold", function () { return $a68f5e7339ac959e$export$95aa4184327d6b72; }, function (v) { return $a68f5e7339ac959e$export$95aa4184327d6b72 = v; });
var $a68f5e7339ac959e$export$1e511d4a378977f5;
var $a68f5e7339ac959e$export$95aa4184327d6b72;
"use strict";
$a68f5e7339ac959e$export$1e511d4a378977f5 = true;
$a68f5e7339ac959e$export$95aa4184327d6b72 = void 0;

var $a68f5e7339ac959e$var$_react = $a68f5e7339ac959e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a68f5e7339ac959e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a68f5e7339ac959e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a68f5e7339ac959e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a68f5e7339ac959e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a68f5e7339ac959e$var$_extends() {
    return $a68f5e7339ac959e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a68f5e7339ac959e$var$_extends.apply(null, arguments);
}
var $a68f5e7339ac959e$var$Bold = $a68f5e7339ac959e$export$95aa4184327d6b72 = /*#__PURE__*/ (0, $a68f5e7339ac959e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a68f5e7339ac959e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a68f5e7339ac959e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Bold"
    }, props), /*#__PURE__*/ $a68f5e7339ac959e$var$_react["default"].createElement("path", {
        d: "M14 11.57a7.93 7.93 0 0 1 3.11 1.25 3.32 3.32 0 0 1 1.28 2.71A3.58 3.58 0 0 1 17 18.42a7.9 7.9 0 0 1-5 1.39H4.07v-.42a3.57 3.57 0 0 0 1.46-.2 1.17 1.17 0 0 0 .54-.52 4.75 4.75 0 0 0 .15-1.58V7a4.81 4.81 0 0 0-.15-1.6 1.13 1.13 0 0 0-.54-.52 3.67 3.67 0 0 0-1.46-.2v-.42h7.45a10.57 10.57 0 0 1 3.78.48 3.94 3.94 0 0 1 1.75 1.42 3.52 3.52 0 0 1 .64 2 2.86 2.86 0 0 1-.81 2A5.84 5.84 0 0 1 14 11.57zm-4.17.58v5.56a1.27 1.27 0 0 0 .32.93 1.27 1.27 0 0 0 .93.31 3.57 3.57 0 0 0 1.69-.41A2.79 2.79 0 0 0 14 17.37a3.61 3.61 0 0 0 .41-1.73 3.81 3.81 0 0 0-.5-2 2.72 2.72 0 0 0-1.39-1.21 7.52 7.52 0 0 0-2.67-.28zm0-.89a5.92 5.92 0 0 0 2.4-.37 2.73 2.73 0 0 0 1.19-1 3.17 3.17 0 0 0 .41-1.7 3.18 3.18 0 0 0-.41-1.69 2.59 2.59 0 0 0-1.16-1 6.2 6.2 0 0 0-2.43-.33z"
    }));
});
$a68f5e7339ac959e$var$Bold.displayName = 'Bold';


Object.keys($a68f5e7339ac959e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a68f5e7339ac959e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a68f5e7339ac959e$exports[key];
});
var $a9d3adceed8cb5d9$exports = {};

$parcel$export($a9d3adceed8cb5d9$exports, "__esModule", function () { return $a9d3adceed8cb5d9$export$1e511d4a378977f5; }, function (v) { return $a9d3adceed8cb5d9$export$1e511d4a378977f5 = v; });
$parcel$export($a9d3adceed8cb5d9$exports, "Book", function () { return $a9d3adceed8cb5d9$export$c959ddfb5bf9a14a; }, function (v) { return $a9d3adceed8cb5d9$export$c959ddfb5bf9a14a = v; });
var $a9d3adceed8cb5d9$export$1e511d4a378977f5;
var $a9d3adceed8cb5d9$export$c959ddfb5bf9a14a;
"use strict";
$a9d3adceed8cb5d9$export$1e511d4a378977f5 = true;
$a9d3adceed8cb5d9$export$c959ddfb5bf9a14a = void 0;

var $a9d3adceed8cb5d9$var$_react = $a9d3adceed8cb5d9$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a9d3adceed8cb5d9$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a9d3adceed8cb5d9$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a9d3adceed8cb5d9$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a9d3adceed8cb5d9$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a9d3adceed8cb5d9$var$_extends() {
    return $a9d3adceed8cb5d9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a9d3adceed8cb5d9$var$_extends.apply(null, arguments);
}
var $a9d3adceed8cb5d9$var$Book = $a9d3adceed8cb5d9$export$c959ddfb5bf9a14a = /*#__PURE__*/ (0, $a9d3adceed8cb5d9$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a9d3adceed8cb5d9$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a9d3adceed8cb5d9$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Book"
    }, props), /*#__PURE__*/ $a9d3adceed8cb5d9$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M10 1v10l3-2 3 2V1M5.5 18a2.5 2.5 0 1 0 0 5H22M3 20.5v-17A2.5 2.5 0 0 1 5.5 1H21v17.007H5.492M20.5 18a2.5 2.5 0 1 0 0 5"
    }));
});
$a9d3adceed8cb5d9$var$Book.displayName = 'Book';


Object.keys($a9d3adceed8cb5d9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a9d3adceed8cb5d9$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a9d3adceed8cb5d9$exports[key];
});
var $8278aa8e545fe6ff$exports = {};

$parcel$export($8278aa8e545fe6ff$exports, "__esModule", function () { return $8278aa8e545fe6ff$export$1e511d4a378977f5; }, function (v) { return $8278aa8e545fe6ff$export$1e511d4a378977f5 = v; });
$parcel$export($8278aa8e545fe6ff$exports, "Bookmark", function () { return $8278aa8e545fe6ff$export$301ef70c5c7bdf65; }, function (v) { return $8278aa8e545fe6ff$export$301ef70c5c7bdf65 = v; });
var $8278aa8e545fe6ff$export$1e511d4a378977f5;
var $8278aa8e545fe6ff$export$301ef70c5c7bdf65;
"use strict";
$8278aa8e545fe6ff$export$1e511d4a378977f5 = true;
$8278aa8e545fe6ff$export$301ef70c5c7bdf65 = void 0;

var $8278aa8e545fe6ff$var$_react = $8278aa8e545fe6ff$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $8278aa8e545fe6ff$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8278aa8e545fe6ff$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8278aa8e545fe6ff$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $8278aa8e545fe6ff$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8278aa8e545fe6ff$var$_extends() {
    return $8278aa8e545fe6ff$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8278aa8e545fe6ff$var$_extends.apply(null, arguments);
}
var $8278aa8e545fe6ff$var$Bookmark = $8278aa8e545fe6ff$export$301ef70c5c7bdf65 = /*#__PURE__*/ (0, $8278aa8e545fe6ff$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $8278aa8e545fe6ff$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $8278aa8e545fe6ff$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Bookmark"
    }, props), /*#__PURE__*/ $8278aa8e545fe6ff$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M5 1v21l7-5 7 5V1z"
    }));
});
$8278aa8e545fe6ff$var$Bookmark.displayName = 'Bookmark';


Object.keys($8278aa8e545fe6ff$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $8278aa8e545fe6ff$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $8278aa8e545fe6ff$exports[key];
});
var $5a60863f4e12a04f$exports = {};

$parcel$export($5a60863f4e12a04f$exports, "__esModule", function () { return $5a60863f4e12a04f$export$1e511d4a378977f5; }, function (v) { return $5a60863f4e12a04f$export$1e511d4a378977f5 = v; });
$parcel$export($5a60863f4e12a04f$exports, "BottomCorner", function () { return $5a60863f4e12a04f$export$718021395527fba3; }, function (v) { return $5a60863f4e12a04f$export$718021395527fba3 = v; });
var $5a60863f4e12a04f$export$1e511d4a378977f5;
var $5a60863f4e12a04f$export$718021395527fba3;
"use strict";
$5a60863f4e12a04f$export$1e511d4a378977f5 = true;
$5a60863f4e12a04f$export$718021395527fba3 = void 0;

var $5a60863f4e12a04f$var$_react = $5a60863f4e12a04f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5a60863f4e12a04f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5a60863f4e12a04f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5a60863f4e12a04f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5a60863f4e12a04f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5a60863f4e12a04f$var$_extends() {
    return $5a60863f4e12a04f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5a60863f4e12a04f$var$_extends.apply(null, arguments);
}
var $5a60863f4e12a04f$var$BottomCorner = $5a60863f4e12a04f$export$718021395527fba3 = /*#__PURE__*/ (0, $5a60863f4e12a04f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5a60863f4e12a04f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5a60863f4e12a04f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "BottomCorner"
    }, props), /*#__PURE__*/ $5a60863f4e12a04f$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8 20h12V8"
    }));
});
$5a60863f4e12a04f$var$BottomCorner.displayName = 'BottomCorner';


Object.keys($5a60863f4e12a04f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5a60863f4e12a04f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5a60863f4e12a04f$exports[key];
});
var $4e8303845823e5bd$exports = {};

$parcel$export($4e8303845823e5bd$exports, "__esModule", function () { return $4e8303845823e5bd$export$1e511d4a378977f5; }, function (v) { return $4e8303845823e5bd$export$1e511d4a378977f5 = v; });
$parcel$export($4e8303845823e5bd$exports, "Braille", function () { return $4e8303845823e5bd$export$9ce34da86ebcdca1; }, function (v) { return $4e8303845823e5bd$export$9ce34da86ebcdca1 = v; });
var $4e8303845823e5bd$export$1e511d4a378977f5;
var $4e8303845823e5bd$export$9ce34da86ebcdca1;
"use strict";
$4e8303845823e5bd$export$1e511d4a378977f5 = true;
$4e8303845823e5bd$export$9ce34da86ebcdca1 = void 0;

var $4e8303845823e5bd$var$_react = $4e8303845823e5bd$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $4e8303845823e5bd$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4e8303845823e5bd$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4e8303845823e5bd$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $4e8303845823e5bd$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $4e8303845823e5bd$var$_extends() {
    return $4e8303845823e5bd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4e8303845823e5bd$var$_extends.apply(null, arguments);
}
var $4e8303845823e5bd$var$Braille = $4e8303845823e5bd$export$9ce34da86ebcdca1 = /*#__PURE__*/ (0, $4e8303845823e5bd$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $4e8303845823e5bd$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $4e8303845823e5bd$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Braille"
    }, props), /*#__PURE__*/ $4e8303845823e5bd$var$_react["default"].createElement("path", {
        d: "M7 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm10 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM7 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm10 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM7 20a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm10-10a3 3 0 1 1 0-6 3 3 0 0 1 0 6z",
        fill: "none",
        stroke: "#000",
        strokeWidth: "2"
    }));
});
$4e8303845823e5bd$var$Braille.displayName = 'Braille';


Object.keys($4e8303845823e5bd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $4e8303845823e5bd$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $4e8303845823e5bd$exports[key];
});
var $651f2c4f23c8c4a1$exports = {};

$parcel$export($651f2c4f23c8c4a1$exports, "__esModule", function () { return $651f2c4f23c8c4a1$export$1e511d4a378977f5; }, function (v) { return $651f2c4f23c8c4a1$export$1e511d4a378977f5 = v; });
$parcel$export($651f2c4f23c8c4a1$exports, "Briefcase", function () { return $651f2c4f23c8c4a1$export$e7d61f8a47ad0cdc; }, function (v) { return $651f2c4f23c8c4a1$export$e7d61f8a47ad0cdc = v; });
var $651f2c4f23c8c4a1$export$1e511d4a378977f5;
var $651f2c4f23c8c4a1$export$e7d61f8a47ad0cdc;
"use strict";
$651f2c4f23c8c4a1$export$1e511d4a378977f5 = true;
$651f2c4f23c8c4a1$export$e7d61f8a47ad0cdc = void 0;

var $651f2c4f23c8c4a1$var$_react = $651f2c4f23c8c4a1$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $651f2c4f23c8c4a1$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($651f2c4f23c8c4a1$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $651f2c4f23c8c4a1$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $651f2c4f23c8c4a1$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $651f2c4f23c8c4a1$var$_extends() {
    return $651f2c4f23c8c4a1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $651f2c4f23c8c4a1$var$_extends.apply(null, arguments);
}
var $651f2c4f23c8c4a1$var$Briefcase = $651f2c4f23c8c4a1$export$e7d61f8a47ad0cdc = /*#__PURE__*/ (0, $651f2c4f23c8c4a1$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $651f2c4f23c8c4a1$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $651f2c4f23c8c4a1$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Briefcase"
    }, props), /*#__PURE__*/ $651f2c4f23c8c4a1$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 6h22v15H1V6zm5 0v15M18 6v15M8 6V3h8v3"
    }));
});
$651f2c4f23c8c4a1$var$Briefcase.displayName = 'Briefcase';


Object.keys($651f2c4f23c8c4a1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $651f2c4f23c8c4a1$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $651f2c4f23c8c4a1$exports[key];
});
var $d1a05815bce2edb2$exports = {};

$parcel$export($d1a05815bce2edb2$exports, "__esModule", function () { return $d1a05815bce2edb2$export$1e511d4a378977f5; }, function (v) { return $d1a05815bce2edb2$export$1e511d4a378977f5 = v; });
$parcel$export($d1a05815bce2edb2$exports, "Brush", function () { return $d1a05815bce2edb2$export$59bc2e3533b384a0; }, function (v) { return $d1a05815bce2edb2$export$59bc2e3533b384a0 = v; });
var $d1a05815bce2edb2$export$1e511d4a378977f5;
var $d1a05815bce2edb2$export$59bc2e3533b384a0;
"use strict";
$d1a05815bce2edb2$export$1e511d4a378977f5 = true;
$d1a05815bce2edb2$export$59bc2e3533b384a0 = void 0;

var $d1a05815bce2edb2$var$_react = $d1a05815bce2edb2$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $d1a05815bce2edb2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d1a05815bce2edb2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d1a05815bce2edb2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d1a05815bce2edb2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d1a05815bce2edb2$var$_extends() {
    return $d1a05815bce2edb2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d1a05815bce2edb2$var$_extends.apply(null, arguments);
}
var $d1a05815bce2edb2$var$Brush = $d1a05815bce2edb2$export$59bc2e3533b384a0 = /*#__PURE__*/ (0, $d1a05815bce2edb2$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d1a05815bce2edb2$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $d1a05815bce2edb2$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Brush"
    }, props), /*#__PURE__*/ $d1a05815bce2edb2$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M9.312 11.73a5.001 5.001 0 0 0-5.362 1.12c-1.953 1.952-1.414 8.485-1.414 8.485s6.532.538 8.485-1.415a5.001 5.001 0 0 0 1.12-5.362L22.334 4.364a1.997 1.997 0 0 0 0-2.828 1.995 1.995 0 0 0-2.828 0L9.312 11.729zm1.002-1.617 1.838 1.838 1.697 1.697"
    }));
});
$d1a05815bce2edb2$var$Brush.displayName = 'Brush';


Object.keys($d1a05815bce2edb2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $d1a05815bce2edb2$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $d1a05815bce2edb2$exports[key];
});
var $0e9b28092759baf6$exports = {};

$parcel$export($0e9b28092759baf6$exports, "__esModule", function () { return $0e9b28092759baf6$export$1e511d4a378977f5; }, function (v) { return $0e9b28092759baf6$export$1e511d4a378977f5 = v; });
$parcel$export($0e9b28092759baf6$exports, "Bucket", function () { return $0e9b28092759baf6$export$356eb44c374cfc19; }, function (v) { return $0e9b28092759baf6$export$356eb44c374cfc19 = v; });
var $0e9b28092759baf6$export$1e511d4a378977f5;
var $0e9b28092759baf6$export$356eb44c374cfc19;
"use strict";
$0e9b28092759baf6$export$1e511d4a378977f5 = true;
$0e9b28092759baf6$export$356eb44c374cfc19 = void 0;

var $0e9b28092759baf6$var$_react = $0e9b28092759baf6$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0e9b28092759baf6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0e9b28092759baf6$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0e9b28092759baf6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0e9b28092759baf6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0e9b28092759baf6$var$_extends() {
    return $0e9b28092759baf6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0e9b28092759baf6$var$_extends.apply(null, arguments);
}
var $0e9b28092759baf6$var$Bucket = $0e9b28092759baf6$export$356eb44c374cfc19 = /*#__PURE__*/ (0, $0e9b28092759baf6$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0e9b28092759baf6$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0e9b28092759baf6$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Bucket"
    }, props), /*#__PURE__*/ $0e9b28092759baf6$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4 10H2c0-5.523 0-9 10-9s10 3.477 10 9h-2m-8 0c4.418 0 8-.895 8-2s-3.582-2-8-2-8 .895-8 2 3.582 2 8 2ZM4 20c0 1.657 3.582 3 8 3s8-1.343 8-3m0-12v12V8ZM4 20V8v12Z"
    }));
});
$0e9b28092759baf6$var$Bucket.displayName = 'Bucket';


Object.keys($0e9b28092759baf6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0e9b28092759baf6$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0e9b28092759baf6$exports[key];
});
var $48dec3f90a7f5c77$exports = {};

$parcel$export($48dec3f90a7f5c77$exports, "__esModule", function () { return $48dec3f90a7f5c77$export$1e511d4a378977f5; }, function (v) { return $48dec3f90a7f5c77$export$1e511d4a378977f5 = v; });
$parcel$export($48dec3f90a7f5c77$exports, "Bug", function () { return $48dec3f90a7f5c77$export$1d4edeb465626d27; }, function (v) { return $48dec3f90a7f5c77$export$1d4edeb465626d27 = v; });
var $48dec3f90a7f5c77$export$1e511d4a378977f5;
var $48dec3f90a7f5c77$export$1d4edeb465626d27;
"use strict";
$48dec3f90a7f5c77$export$1e511d4a378977f5 = true;
$48dec3f90a7f5c77$export$1d4edeb465626d27 = void 0;

var $48dec3f90a7f5c77$var$_react = $48dec3f90a7f5c77$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $48dec3f90a7f5c77$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($48dec3f90a7f5c77$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $48dec3f90a7f5c77$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $48dec3f90a7f5c77$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $48dec3f90a7f5c77$var$_extends() {
    return $48dec3f90a7f5c77$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $48dec3f90a7f5c77$var$_extends.apply(null, arguments);
}
var $48dec3f90a7f5c77$var$Bug = $48dec3f90a7f5c77$export$1d4edeb465626d27 = /*#__PURE__*/ (0, $48dec3f90a7f5c77$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $48dec3f90a7f5c77$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $48dec3f90a7f5c77$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Bug"
    }, props), /*#__PURE__*/ $48dec3f90a7f5c77$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M23 20c-1.38-2.09-3-3-4-3M5 17c-1 0-2.62.91-4 3M19 9c3 0 4-3 4-3M1 6s1 3 4 3m14 4h5-5zM5 13H0h5zm7 10V12v11zm0 0c-4 0-7-3-7-7V9s3-2.012 7-2c4 .012 7 2 7 2v7c0 4-3 7-7 7zM7 8V6c0-2.76 2.24-5 5-5s5 2.24 5 5v2"
    }));
});
$48dec3f90a7f5c77$var$Bug.displayName = 'Bug';


Object.keys($48dec3f90a7f5c77$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $48dec3f90a7f5c77$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $48dec3f90a7f5c77$exports[key];
});
var $0fa2632cc28647a4$exports = {};

$parcel$export($0fa2632cc28647a4$exports, "__esModule", function () { return $0fa2632cc28647a4$export$1e511d4a378977f5; }, function (v) { return $0fa2632cc28647a4$export$1e511d4a378977f5 = v; });
$parcel$export($0fa2632cc28647a4$exports, "Bundle", function () { return $0fa2632cc28647a4$export$5cd9646dcf5a212c; }, function (v) { return $0fa2632cc28647a4$export$5cd9646dcf5a212c = v; });
var $0fa2632cc28647a4$export$1e511d4a378977f5;
var $0fa2632cc28647a4$export$5cd9646dcf5a212c;
"use strict";
$0fa2632cc28647a4$export$1e511d4a378977f5 = true;
$0fa2632cc28647a4$export$5cd9646dcf5a212c = void 0;

var $0fa2632cc28647a4$var$_react = $0fa2632cc28647a4$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0fa2632cc28647a4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0fa2632cc28647a4$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0fa2632cc28647a4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0fa2632cc28647a4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0fa2632cc28647a4$var$_extends() {
    return $0fa2632cc28647a4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0fa2632cc28647a4$var$_extends.apply(null, arguments);
}
var $0fa2632cc28647a4$var$Bundle = $0fa2632cc28647a4$export$5cd9646dcf5a212c = /*#__PURE__*/ (0, $0fa2632cc28647a4$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0fa2632cc28647a4$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0fa2632cc28647a4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Bundle"
    }, props), /*#__PURE__*/ $0fa2632cc28647a4$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M17 14H7h10zm0-11h6v10h-6M1 13v4h6m10 0h6v-4M1 17v4h6m16-4v4h-6M7 22h10V2H7v20zm0-9H1V3h6"
    }));
});
$0fa2632cc28647a4$var$Bundle.displayName = 'Bundle';


Object.keys($0fa2632cc28647a4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0fa2632cc28647a4$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0fa2632cc28647a4$exports[key];
});
var $50d110807521a20c$exports = {};

$parcel$export($50d110807521a20c$exports, "__esModule", function () { return $50d110807521a20c$export$1e511d4a378977f5; }, function (v) { return $50d110807521a20c$export$1e511d4a378977f5 = v; });
$parcel$export($50d110807521a20c$exports, "Bus", function () { return $50d110807521a20c$export$708a7950207459e2; }, function (v) { return $50d110807521a20c$export$708a7950207459e2 = v; });
var $50d110807521a20c$export$1e511d4a378977f5;
var $50d110807521a20c$export$708a7950207459e2;
"use strict";
$50d110807521a20c$export$1e511d4a378977f5 = true;
$50d110807521a20c$export$708a7950207459e2 = void 0;

var $50d110807521a20c$var$_react = $50d110807521a20c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $50d110807521a20c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($50d110807521a20c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $50d110807521a20c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $50d110807521a20c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $50d110807521a20c$var$_extends() {
    return $50d110807521a20c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $50d110807521a20c$var$_extends.apply(null, arguments);
}
var $50d110807521a20c$var$Bus = $50d110807521a20c$export$708a7950207459e2 = /*#__PURE__*/ (0, $50d110807521a20c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $50d110807521a20c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $50d110807521a20c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Bus"
    }, props), /*#__PURE__*/ $50d110807521a20c$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M3 12h18v8H3v-8zm0-8c0-1.105.893-2 1.995-2h14.01C20.107 2 21 2.887 21 4v8H3V4zm0 16h3v2.001a.996.996 0 0 1-.999.999H3.999A.996.996 0 0 1 3 22.001V20zm15 0h3v2.001a.996.996 0 0 1-.999.999h-1.002a.996.996 0 0 1-.999-.999V20zM7 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM12 6v6M1 5v8m22-8v8m-13 3h4M3 6h18"
    }));
});
$50d110807521a20c$var$Bus.displayName = 'Bus';


Object.keys($50d110807521a20c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $50d110807521a20c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $50d110807521a20c$exports[key];
});
var $8e99080de5ae1cb5$exports = {};

$parcel$export($8e99080de5ae1cb5$exports, "__esModule", function () { return $8e99080de5ae1cb5$export$1e511d4a378977f5; }, function (v) { return $8e99080de5ae1cb5$export$1e511d4a378977f5 = v; });
$parcel$export($8e99080de5ae1cb5$exports, "BusinessService", function () { return $8e99080de5ae1cb5$export$5dbec65c52377b38; }, function (v) { return $8e99080de5ae1cb5$export$5dbec65c52377b38 = v; });
var $8e99080de5ae1cb5$export$1e511d4a378977f5;
var $8e99080de5ae1cb5$export$5dbec65c52377b38;
"use strict";
$8e99080de5ae1cb5$export$1e511d4a378977f5 = true;
$8e99080de5ae1cb5$export$5dbec65c52377b38 = void 0;

var $8e99080de5ae1cb5$var$_react = $8e99080de5ae1cb5$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $8e99080de5ae1cb5$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8e99080de5ae1cb5$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8e99080de5ae1cb5$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $8e99080de5ae1cb5$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8e99080de5ae1cb5$var$_extends() {
    return $8e99080de5ae1cb5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8e99080de5ae1cb5$var$_extends.apply(null, arguments);
}
var $8e99080de5ae1cb5$var$BusinessService = $8e99080de5ae1cb5$export$5dbec65c52377b38 = /*#__PURE__*/ (0, $8e99080de5ae1cb5$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $8e99080de5ae1cb5$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $8e99080de5ae1cb5$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "BusinessService"
    }, props), /*#__PURE__*/ $8e99080de5ae1cb5$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4 23H1V5h22v18h-7M8 5V1h8v4M9 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm5.008 1.876a4 4 0 1 0-1.244-7.193m-5.062 5.043A4 4 0 0 0 10 23a4 4 0 0 0 1.401-7.748"
    }));
});
$8e99080de5ae1cb5$var$BusinessService.displayName = 'BusinessService';


Object.keys($8e99080de5ae1cb5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $8e99080de5ae1cb5$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $8e99080de5ae1cb5$exports[key];
});
var $c5e319a27ea1ca88$exports = {};

$parcel$export($c5e319a27ea1ca88$exports, "__esModule", function () { return $c5e319a27ea1ca88$export$1e511d4a378977f5; }, function (v) { return $c5e319a27ea1ca88$export$1e511d4a378977f5 = v; });
$parcel$export($c5e319a27ea1ca88$exports, "Cafeteria", function () { return $c5e319a27ea1ca88$export$db9600670c149537; }, function (v) { return $c5e319a27ea1ca88$export$db9600670c149537 = v; });
var $c5e319a27ea1ca88$export$1e511d4a378977f5;
var $c5e319a27ea1ca88$export$db9600670c149537;
"use strict";
$c5e319a27ea1ca88$export$1e511d4a378977f5 = true;
$c5e319a27ea1ca88$export$db9600670c149537 = void 0;

var $c5e319a27ea1ca88$var$_react = $c5e319a27ea1ca88$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c5e319a27ea1ca88$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c5e319a27ea1ca88$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c5e319a27ea1ca88$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c5e319a27ea1ca88$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c5e319a27ea1ca88$var$_extends() {
    return $c5e319a27ea1ca88$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c5e319a27ea1ca88$var$_extends.apply(null, arguments);
}
var $c5e319a27ea1ca88$var$Cafeteria = $c5e319a27ea1ca88$export$db9600670c149537 = /*#__PURE__*/ (0, $c5e319a27ea1ca88$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c5e319a27ea1ca88$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c5e319a27ea1ca88$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Cafeteria"
    }, props), /*#__PURE__*/ $c5e319a27ea1ca88$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 1v7c0 1.657-1.347 3-2.997 3H5.997A3.002 3.002 0 0 1 3 8V1m3 6V1m3 6V1M6 11v10.504C6 22.33 6.666 23 7.5 23c.828 0 1.5-.68 1.5-1.496V11m6 7v3.5a1.5 1.5 0 1 0 3-.005V15s3 0 3-3V7c0-3-2-5-6-5v16z"
    }));
});
$c5e319a27ea1ca88$var$Cafeteria.displayName = 'Cafeteria';


Object.keys($c5e319a27ea1ca88$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c5e319a27ea1ca88$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c5e319a27ea1ca88$exports[key];
});
var $8b00d827ca609f91$exports = {};

$parcel$export($8b00d827ca609f91$exports, "__esModule", function () { return $8b00d827ca609f91$export$1e511d4a378977f5; }, function (v) { return $8b00d827ca609f91$export$1e511d4a378977f5 = v; });
$parcel$export($8b00d827ca609f91$exports, "Calculator", function () { return $8b00d827ca609f91$export$770682f56f7e9e8f; }, function (v) { return $8b00d827ca609f91$export$770682f56f7e9e8f = v; });
var $8b00d827ca609f91$export$1e511d4a378977f5;
var $8b00d827ca609f91$export$770682f56f7e9e8f;
"use strict";
$8b00d827ca609f91$export$1e511d4a378977f5 = true;
$8b00d827ca609f91$export$770682f56f7e9e8f = void 0;

var $8b00d827ca609f91$var$_react = $8b00d827ca609f91$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $8b00d827ca609f91$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8b00d827ca609f91$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8b00d827ca609f91$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $8b00d827ca609f91$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8b00d827ca609f91$var$_extends() {
    return $8b00d827ca609f91$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8b00d827ca609f91$var$_extends.apply(null, arguments);
}
var $8b00d827ca609f91$var$Calculator = $8b00d827ca609f91$export$770682f56f7e9e8f = /*#__PURE__*/ (0, $8b00d827ca609f91$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $8b00d827ca609f91$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $8b00d827ca609f91$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Calculator"
    }, props), /*#__PURE__*/ $8b00d827ca609f91$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M22 23H2V1h20v22zm-6-6h2v2h-2v-2zm-5 0h2v2h-2v-2zm5-5h2v2h-2v-2zm-5 0h2v2h-2v-2zm-5 5h2v2H6v-2zm0-5h2v2H6v-2zm12-3H6V5h12v4z"
    }));
});
$8b00d827ca609f91$var$Calculator.displayName = 'Calculator';


Object.keys($8b00d827ca609f91$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $8b00d827ca609f91$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $8b00d827ca609f91$exports[key];
});

Object.keys($5958f18f8d688d50$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5958f18f8d688d50$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5958f18f8d688d50$exports[key];
});
var $d930422df8573ad5$exports = {};

$parcel$export($d930422df8573ad5$exports, "__esModule", function () { return $d930422df8573ad5$export$1e511d4a378977f5; }, function (v) { return $d930422df8573ad5$export$1e511d4a378977f5 = v; });
$parcel$export($d930422df8573ad5$exports, "Camera", function () { return $d930422df8573ad5$export$79f141de891a5fed; }, function (v) { return $d930422df8573ad5$export$79f141de891a5fed = v; });
var $d930422df8573ad5$export$1e511d4a378977f5;
var $d930422df8573ad5$export$79f141de891a5fed;
"use strict";
$d930422df8573ad5$export$1e511d4a378977f5 = true;
$d930422df8573ad5$export$79f141de891a5fed = void 0;

var $d930422df8573ad5$var$_react = $d930422df8573ad5$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $d930422df8573ad5$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d930422df8573ad5$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d930422df8573ad5$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d930422df8573ad5$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d930422df8573ad5$var$_extends() {
    return $d930422df8573ad5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d930422df8573ad5$var$_extends.apply(null, arguments);
}
var $d930422df8573ad5$var$Camera = $d930422df8573ad5$export$79f141de891a5fed = /*#__PURE__*/ (0, $d930422df8573ad5$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d930422df8573ad5$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $d930422df8573ad5$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Camera"
    }, props), /*#__PURE__*/ $d930422df8573ad5$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 21V7h5l2-4h8l2 4h5v14H1zm11-3a5 5 0 1 0 0-10 5 5 0 0 0 0 10z"
    }));
});
$d930422df8573ad5$var$Camera.displayName = 'Camera';


Object.keys($d930422df8573ad5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $d930422df8573ad5$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $d930422df8573ad5$exports[key];
});
var $b407c5f10afabd56$exports = {};

$parcel$export($b407c5f10afabd56$exports, "__esModule", function () { return $b407c5f10afabd56$export$1e511d4a378977f5; }, function (v) { return $b407c5f10afabd56$export$1e511d4a378977f5 = v; });
$parcel$export($b407c5f10afabd56$exports, "Capacity", function () { return $b407c5f10afabd56$export$a9fa7f35035e017c; }, function (v) { return $b407c5f10afabd56$export$a9fa7f35035e017c = v; });
var $b407c5f10afabd56$export$1e511d4a378977f5;
var $b407c5f10afabd56$export$a9fa7f35035e017c;
"use strict";
$b407c5f10afabd56$export$1e511d4a378977f5 = true;
$b407c5f10afabd56$export$a9fa7f35035e017c = void 0;

var $b407c5f10afabd56$var$_react = $b407c5f10afabd56$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $b407c5f10afabd56$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b407c5f10afabd56$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b407c5f10afabd56$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $b407c5f10afabd56$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b407c5f10afabd56$var$_extends() {
    return $b407c5f10afabd56$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b407c5f10afabd56$var$_extends.apply(null, arguments);
}
var $b407c5f10afabd56$var$Capacity = $b407c5f10afabd56$export$a9fa7f35035e017c = /*#__PURE__*/ (0, $b407c5f10afabd56$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $b407c5f10afabd56$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $b407c5f10afabd56$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Capacity"
    }, props), /*#__PURE__*/ $b407c5f10afabd56$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: "2",
        d: "M1 19h22V5H1v14zm3-3h3V8H4v8zm6 0h3V8h-3v8z"
    }));
});
$b407c5f10afabd56$var$Capacity.displayName = 'Capacity';


Object.keys($b407c5f10afabd56$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $b407c5f10afabd56$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $b407c5f10afabd56$exports[key];
});
var $9833b34f2a72ae74$exports = {};

$parcel$export($9833b34f2a72ae74$exports, "__esModule", function () { return $9833b34f2a72ae74$export$1e511d4a378977f5; }, function (v) { return $9833b34f2a72ae74$export$1e511d4a378977f5 = v; });
$parcel$export($9833b34f2a72ae74$exports, "Car", function () { return $9833b34f2a72ae74$export$91030e912f5b0749; }, function (v) { return $9833b34f2a72ae74$export$91030e912f5b0749 = v; });
var $9833b34f2a72ae74$export$1e511d4a378977f5;
var $9833b34f2a72ae74$export$91030e912f5b0749;
"use strict";
$9833b34f2a72ae74$export$1e511d4a378977f5 = true;
$9833b34f2a72ae74$export$91030e912f5b0749 = void 0;

var $9833b34f2a72ae74$var$_react = $9833b34f2a72ae74$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $9833b34f2a72ae74$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9833b34f2a72ae74$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9833b34f2a72ae74$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $9833b34f2a72ae74$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $9833b34f2a72ae74$var$_extends() {
    return $9833b34f2a72ae74$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9833b34f2a72ae74$var$_extends.apply(null, arguments);
}
var $9833b34f2a72ae74$var$Car = $9833b34f2a72ae74$export$91030e912f5b0749 = /*#__PURE__*/ (0, $9833b34f2a72ae74$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $9833b34f2a72ae74$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $9833b34f2a72ae74$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Car"
    }, props), /*#__PURE__*/ $9833b34f2a72ae74$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 10.997c0-.55.44-.997 1.002-.997h19.996c.553 0 1.002.453 1.002.997v6.006c0 .55-.44.997-1.002.997H2.002A1.004 1.004 0 0 1 1 17.003v-6.006zM6 2h12l4 8H2l4-8zm6 8.5L15 5M3 18h3v2.99c0 .558-.443 1.01-.999 1.01H3.999A.999.999 0 0 1 3 20.99V18zm15 0h3v2.99c0 .558-.443 1.01-.999 1.01h-1.002A.999.999 0 0 1 18 20.99V18zM5 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm14 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-7-2v2m2-2v2m-4-2v2"
    }));
});
$9833b34f2a72ae74$var$Car.displayName = 'Car';


Object.keys($9833b34f2a72ae74$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $9833b34f2a72ae74$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $9833b34f2a72ae74$exports[key];
});
var $dfbecdc631c6a743$exports = {};

$parcel$export($dfbecdc631c6a743$exports, "__esModule", function () { return $dfbecdc631c6a743$export$1e511d4a378977f5; }, function (v) { return $dfbecdc631c6a743$export$1e511d4a378977f5 = v; });
$parcel$export($dfbecdc631c6a743$exports, "CaretDownFill", function () { return $dfbecdc631c6a743$export$c22d792887f3cb87; }, function (v) { return $dfbecdc631c6a743$export$c22d792887f3cb87 = v; });
var $dfbecdc631c6a743$export$1e511d4a378977f5;
var $dfbecdc631c6a743$export$c22d792887f3cb87;
"use strict";
$dfbecdc631c6a743$export$1e511d4a378977f5 = true;
$dfbecdc631c6a743$export$c22d792887f3cb87 = void 0;

var $dfbecdc631c6a743$var$_react = $dfbecdc631c6a743$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $dfbecdc631c6a743$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($dfbecdc631c6a743$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $dfbecdc631c6a743$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $dfbecdc631c6a743$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $dfbecdc631c6a743$var$_extends() {
    return $dfbecdc631c6a743$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $dfbecdc631c6a743$var$_extends.apply(null, arguments);
}
var $dfbecdc631c6a743$var$CaretDownFill = $dfbecdc631c6a743$export$c22d792887f3cb87 = /*#__PURE__*/ (0, $dfbecdc631c6a743$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $dfbecdc631c6a743$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $dfbecdc631c6a743$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CaretDownFill"
    }, props), /*#__PURE__*/ $dfbecdc631c6a743$var$_react["default"].createElement("path", {
        d: "M18 9H6l6 6 6-6z",
        fill: "#000"
    }));
});
$dfbecdc631c6a743$var$CaretDownFill.displayName = 'CaretDownFill';


Object.keys($dfbecdc631c6a743$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $dfbecdc631c6a743$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $dfbecdc631c6a743$exports[key];
});
var $fa9cac8c38153a4e$exports = {};

$parcel$export($fa9cac8c38153a4e$exports, "__esModule", function () { return $fa9cac8c38153a4e$export$1e511d4a378977f5; }, function (v) { return $fa9cac8c38153a4e$export$1e511d4a378977f5 = v; });
$parcel$export($fa9cac8c38153a4e$exports, "CaretDown", function () { return $fa9cac8c38153a4e$export$14643e45770079c3; }, function (v) { return $fa9cac8c38153a4e$export$14643e45770079c3 = v; });
var $fa9cac8c38153a4e$export$1e511d4a378977f5;
var $fa9cac8c38153a4e$export$14643e45770079c3;
"use strict";
$fa9cac8c38153a4e$export$1e511d4a378977f5 = true;
$fa9cac8c38153a4e$export$14643e45770079c3 = void 0;

var $fa9cac8c38153a4e$var$_react = $fa9cac8c38153a4e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $fa9cac8c38153a4e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($fa9cac8c38153a4e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $fa9cac8c38153a4e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $fa9cac8c38153a4e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $fa9cac8c38153a4e$var$_extends() {
    return $fa9cac8c38153a4e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fa9cac8c38153a4e$var$_extends.apply(null, arguments);
}
var $fa9cac8c38153a4e$var$CaretDown = $fa9cac8c38153a4e$export$14643e45770079c3 = /*#__PURE__*/ (0, $fa9cac8c38153a4e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $fa9cac8c38153a4e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $fa9cac8c38153a4e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CaretDown"
    }, props), /*#__PURE__*/ $fa9cac8c38153a4e$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M22 8 12 20 2 8z"
    }));
});
$fa9cac8c38153a4e$var$CaretDown.displayName = 'CaretDown';


Object.keys($fa9cac8c38153a4e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $fa9cac8c38153a4e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $fa9cac8c38153a4e$exports[key];
});
var $eea13935041d7b35$exports = {};

$parcel$export($eea13935041d7b35$exports, "__esModule", function () { return $eea13935041d7b35$export$1e511d4a378977f5; }, function (v) { return $eea13935041d7b35$export$1e511d4a378977f5 = v; });
$parcel$export($eea13935041d7b35$exports, "CaretLeftFill", function () { return $eea13935041d7b35$export$2e90203ea73187a; }, function (v) { return $eea13935041d7b35$export$2e90203ea73187a = v; });
var $eea13935041d7b35$export$1e511d4a378977f5;
var $eea13935041d7b35$export$2e90203ea73187a;
"use strict";
$eea13935041d7b35$export$1e511d4a378977f5 = true;
$eea13935041d7b35$export$2e90203ea73187a = void 0;

var $eea13935041d7b35$var$_react = $eea13935041d7b35$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $eea13935041d7b35$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($eea13935041d7b35$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $eea13935041d7b35$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $eea13935041d7b35$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $eea13935041d7b35$var$_extends() {
    return $eea13935041d7b35$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $eea13935041d7b35$var$_extends.apply(null, arguments);
}
var $eea13935041d7b35$var$CaretLeftFill = $eea13935041d7b35$export$2e90203ea73187a = /*#__PURE__*/ (0, $eea13935041d7b35$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $eea13935041d7b35$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $eea13935041d7b35$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CaretLeftFill"
    }, props), /*#__PURE__*/ $eea13935041d7b35$var$_react["default"].createElement("path", {
        d: "M15 18V6l-6 6z",
        fill: "#000"
    }));
});
$eea13935041d7b35$var$CaretLeftFill.displayName = 'CaretLeftFill';


Object.keys($eea13935041d7b35$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $eea13935041d7b35$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $eea13935041d7b35$exports[key];
});
var $1f91cb329237dfe8$exports = {};

$parcel$export($1f91cb329237dfe8$exports, "__esModule", function () { return $1f91cb329237dfe8$export$1e511d4a378977f5; }, function (v) { return $1f91cb329237dfe8$export$1e511d4a378977f5 = v; });
$parcel$export($1f91cb329237dfe8$exports, "CaretNext", function () { return $1f91cb329237dfe8$export$2123731c9a952c65; }, function (v) { return $1f91cb329237dfe8$export$2123731c9a952c65 = v; });
var $1f91cb329237dfe8$export$1e511d4a378977f5;
var $1f91cb329237dfe8$export$2123731c9a952c65;
"use strict";
$1f91cb329237dfe8$export$1e511d4a378977f5 = true;
$1f91cb329237dfe8$export$2123731c9a952c65 = void 0;

var $1f91cb329237dfe8$var$_react = $1f91cb329237dfe8$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $1f91cb329237dfe8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1f91cb329237dfe8$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1f91cb329237dfe8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $1f91cb329237dfe8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1f91cb329237dfe8$var$_extends() {
    return $1f91cb329237dfe8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1f91cb329237dfe8$var$_extends.apply(null, arguments);
}
var $1f91cb329237dfe8$var$CaretNext = $1f91cb329237dfe8$export$2123731c9a952c65 = /*#__PURE__*/ (0, $1f91cb329237dfe8$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $1f91cb329237dfe8$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $1f91cb329237dfe8$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CaretNext"
    }, props), /*#__PURE__*/ $1f91cb329237dfe8$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m6 2 12 10L6 22z"
    }));
});
$1f91cb329237dfe8$var$CaretNext.displayName = 'CaretNext';


Object.keys($1f91cb329237dfe8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $1f91cb329237dfe8$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $1f91cb329237dfe8$exports[key];
});
var $068416756afd3b8d$exports = {};

$parcel$export($068416756afd3b8d$exports, "__esModule", function () { return $068416756afd3b8d$export$1e511d4a378977f5; }, function (v) { return $068416756afd3b8d$export$1e511d4a378977f5 = v; });
$parcel$export($068416756afd3b8d$exports, "CaretPrevious", function () { return $068416756afd3b8d$export$26268ffaf53bad2; }, function (v) { return $068416756afd3b8d$export$26268ffaf53bad2 = v; });
var $068416756afd3b8d$export$1e511d4a378977f5;
var $068416756afd3b8d$export$26268ffaf53bad2;
"use strict";
$068416756afd3b8d$export$1e511d4a378977f5 = true;
$068416756afd3b8d$export$26268ffaf53bad2 = void 0;

var $068416756afd3b8d$var$_react = $068416756afd3b8d$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $068416756afd3b8d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($068416756afd3b8d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $068416756afd3b8d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $068416756afd3b8d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $068416756afd3b8d$var$_extends() {
    return $068416756afd3b8d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $068416756afd3b8d$var$_extends.apply(null, arguments);
}
var $068416756afd3b8d$var$CaretPrevious = $068416756afd3b8d$export$26268ffaf53bad2 = /*#__PURE__*/ (0, $068416756afd3b8d$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $068416756afd3b8d$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $068416756afd3b8d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CaretPrevious"
    }, props), /*#__PURE__*/ $068416756afd3b8d$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M18 2 6 12l12 10z"
    }));
});
$068416756afd3b8d$var$CaretPrevious.displayName = 'CaretPrevious';


Object.keys($068416756afd3b8d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $068416756afd3b8d$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $068416756afd3b8d$exports[key];
});
var $6fd8124c6709474a$exports = {};

$parcel$export($6fd8124c6709474a$exports, "__esModule", function () { return $6fd8124c6709474a$export$1e511d4a378977f5; }, function (v) { return $6fd8124c6709474a$export$1e511d4a378977f5 = v; });
$parcel$export($6fd8124c6709474a$exports, "CaretRightFill", function () { return $6fd8124c6709474a$export$970973453ca186b7; }, function (v) { return $6fd8124c6709474a$export$970973453ca186b7 = v; });
var $6fd8124c6709474a$export$1e511d4a378977f5;
var $6fd8124c6709474a$export$970973453ca186b7;
"use strict";
$6fd8124c6709474a$export$1e511d4a378977f5 = true;
$6fd8124c6709474a$export$970973453ca186b7 = void 0;

var $6fd8124c6709474a$var$_react = $6fd8124c6709474a$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $6fd8124c6709474a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6fd8124c6709474a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6fd8124c6709474a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6fd8124c6709474a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6fd8124c6709474a$var$_extends() {
    return $6fd8124c6709474a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6fd8124c6709474a$var$_extends.apply(null, arguments);
}
var $6fd8124c6709474a$var$CaretRightFill = $6fd8124c6709474a$export$970973453ca186b7 = /*#__PURE__*/ (0, $6fd8124c6709474a$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $6fd8124c6709474a$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $6fd8124c6709474a$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CaretRightFill"
    }, props), /*#__PURE__*/ $6fd8124c6709474a$var$_react["default"].createElement("path", {
        d: "M9 6v12l6-6z",
        fill: "#000"
    }));
});
$6fd8124c6709474a$var$CaretRightFill.displayName = 'CaretRightFill';


Object.keys($6fd8124c6709474a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $6fd8124c6709474a$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $6fd8124c6709474a$exports[key];
});
var $ede5daea7cba7924$exports = {};

$parcel$export($ede5daea7cba7924$exports, "__esModule", function () { return $ede5daea7cba7924$export$1e511d4a378977f5; }, function (v) { return $ede5daea7cba7924$export$1e511d4a378977f5 = v; });
$parcel$export($ede5daea7cba7924$exports, "CaretUpFill", function () { return $ede5daea7cba7924$export$cb86d8fdcb9f94b5; }, function (v) { return $ede5daea7cba7924$export$cb86d8fdcb9f94b5 = v; });
var $ede5daea7cba7924$export$1e511d4a378977f5;
var $ede5daea7cba7924$export$cb86d8fdcb9f94b5;
"use strict";
$ede5daea7cba7924$export$1e511d4a378977f5 = true;
$ede5daea7cba7924$export$cb86d8fdcb9f94b5 = void 0;

var $ede5daea7cba7924$var$_react = $ede5daea7cba7924$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $ede5daea7cba7924$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ede5daea7cba7924$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ede5daea7cba7924$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ede5daea7cba7924$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ede5daea7cba7924$var$_extends() {
    return $ede5daea7cba7924$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ede5daea7cba7924$var$_extends.apply(null, arguments);
}
var $ede5daea7cba7924$var$CaretUpFill = $ede5daea7cba7924$export$cb86d8fdcb9f94b5 = /*#__PURE__*/ (0, $ede5daea7cba7924$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $ede5daea7cba7924$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ede5daea7cba7924$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CaretUpFill"
    }, props), /*#__PURE__*/ $ede5daea7cba7924$var$_react["default"].createElement("path", {
        d: "M6 15h12l-6-6-6 6z",
        fill: "#000"
    }));
});
$ede5daea7cba7924$var$CaretUpFill.displayName = 'CaretUpFill';


Object.keys($ede5daea7cba7924$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ede5daea7cba7924$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ede5daea7cba7924$exports[key];
});
var $b3fe711d0d80377e$exports = {};

$parcel$export($b3fe711d0d80377e$exports, "__esModule", function () { return $b3fe711d0d80377e$export$1e511d4a378977f5; }, function (v) { return $b3fe711d0d80377e$export$1e511d4a378977f5 = v; });
$parcel$export($b3fe711d0d80377e$exports, "CaretUp", function () { return $b3fe711d0d80377e$export$b67edd7bdacb81b5; }, function (v) { return $b3fe711d0d80377e$export$b67edd7bdacb81b5 = v; });
var $b3fe711d0d80377e$export$1e511d4a378977f5;
var $b3fe711d0d80377e$export$b67edd7bdacb81b5;
"use strict";
$b3fe711d0d80377e$export$1e511d4a378977f5 = true;
$b3fe711d0d80377e$export$b67edd7bdacb81b5 = void 0;

var $b3fe711d0d80377e$var$_react = $b3fe711d0d80377e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $b3fe711d0d80377e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b3fe711d0d80377e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b3fe711d0d80377e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $b3fe711d0d80377e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b3fe711d0d80377e$var$_extends() {
    return $b3fe711d0d80377e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b3fe711d0d80377e$var$_extends.apply(null, arguments);
}
var $b3fe711d0d80377e$var$CaretUp = $b3fe711d0d80377e$export$b67edd7bdacb81b5 = /*#__PURE__*/ (0, $b3fe711d0d80377e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $b3fe711d0d80377e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $b3fe711d0d80377e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CaretUp"
    }, props), /*#__PURE__*/ $b3fe711d0d80377e$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M22 16 12 4 2 16z"
    }));
});
$b3fe711d0d80377e$var$CaretUp.displayName = 'CaretUp';


Object.keys($b3fe711d0d80377e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $b3fe711d0d80377e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $b3fe711d0d80377e$exports[key];
});
var $eb309e3d7d1b1b44$exports = {};

$parcel$export($eb309e3d7d1b1b44$exports, "__esModule", function () { return $eb309e3d7d1b1b44$export$1e511d4a378977f5; }, function (v) { return $eb309e3d7d1b1b44$export$1e511d4a378977f5 = v; });
$parcel$export($eb309e3d7d1b1b44$exports, "Cart", function () { return $eb309e3d7d1b1b44$export$494d083da011ade5; }, function (v) { return $eb309e3d7d1b1b44$export$494d083da011ade5 = v; });
var $eb309e3d7d1b1b44$export$1e511d4a378977f5;
var $eb309e3d7d1b1b44$export$494d083da011ade5;
"use strict";
$eb309e3d7d1b1b44$export$1e511d4a378977f5 = true;
$eb309e3d7d1b1b44$export$494d083da011ade5 = void 0;

var $eb309e3d7d1b1b44$var$_react = $eb309e3d7d1b1b44$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $eb309e3d7d1b1b44$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($eb309e3d7d1b1b44$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $eb309e3d7d1b1b44$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $eb309e3d7d1b1b44$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $eb309e3d7d1b1b44$var$_extends() {
    return $eb309e3d7d1b1b44$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $eb309e3d7d1b1b44$var$_extends.apply(null, arguments);
}
var $eb309e3d7d1b1b44$var$Cart = $eb309e3d7d1b1b44$export$494d083da011ade5 = /*#__PURE__*/ (0, $eb309e3d7d1b1b44$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $eb309e3d7d1b1b44$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $eb309e3d7d1b1b44$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Cart"
    }, props), /*#__PURE__*/ $eb309e3d7d1b1b44$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M5 5h17l-2 9H7L4 2H0m7 12 1 4h13m-2 5a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM9 23a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
    }));
});
$eb309e3d7d1b1b44$var$Cart.displayName = 'Cart';


Object.keys($eb309e3d7d1b1b44$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $eb309e3d7d1b1b44$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $eb309e3d7d1b1b44$exports[key];
});
var $6e0088e41bc28d18$exports = {};

$parcel$export($6e0088e41bc28d18$exports, "__esModule", function () { return $6e0088e41bc28d18$export$1e511d4a378977f5; }, function (v) { return $6e0088e41bc28d18$export$1e511d4a378977f5 = v; });
$parcel$export($6e0088e41bc28d18$exports, "CatalogOption", function () { return $6e0088e41bc28d18$export$e7a23b17367425a; }, function (v) { return $6e0088e41bc28d18$export$e7a23b17367425a = v; });
var $6e0088e41bc28d18$export$1e511d4a378977f5;
var $6e0088e41bc28d18$export$e7a23b17367425a;
"use strict";
$6e0088e41bc28d18$export$1e511d4a378977f5 = true;
$6e0088e41bc28d18$export$e7a23b17367425a = void 0;

var $6e0088e41bc28d18$var$_react = $6e0088e41bc28d18$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $6e0088e41bc28d18$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6e0088e41bc28d18$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6e0088e41bc28d18$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6e0088e41bc28d18$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6e0088e41bc28d18$var$_extends() {
    return $6e0088e41bc28d18$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6e0088e41bc28d18$var$_extends.apply(null, arguments);
}
var $6e0088e41bc28d18$var$CatalogOption = $6e0088e41bc28d18$export$e7a23b17367425a = /*#__PURE__*/ (0, $6e0088e41bc28d18$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $6e0088e41bc28d18$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $6e0088e41bc28d18$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CatalogOption"
    }, props), /*#__PURE__*/ $6e0088e41bc28d18$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M5.5 18a2.5 2.5 0 1 0 0 5H22M3 20.5v-17A2.5 2.5 0 0 1 5.5 1H21v17.007H5.492M20.5 18a2.5 2.5 0 1 0 0 5"
    }));
});
$6e0088e41bc28d18$var$CatalogOption.displayName = 'CatalogOption';


Object.keys($6e0088e41bc28d18$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $6e0088e41bc28d18$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $6e0088e41bc28d18$exports[key];
});
var $4926ef6a01466ddd$exports = {};

$parcel$export($4926ef6a01466ddd$exports, "__esModule", function () { return $4926ef6a01466ddd$export$1e511d4a378977f5; }, function (v) { return $4926ef6a01466ddd$export$1e511d4a378977f5 = v; });
$parcel$export($4926ef6a01466ddd$exports, "Catalog", function () { return $4926ef6a01466ddd$export$c401078f1496a453; }, function (v) { return $4926ef6a01466ddd$export$c401078f1496a453 = v; });
var $4926ef6a01466ddd$export$1e511d4a378977f5;
var $4926ef6a01466ddd$export$c401078f1496a453;
"use strict";
$4926ef6a01466ddd$export$1e511d4a378977f5 = true;
$4926ef6a01466ddd$export$c401078f1496a453 = void 0;

var $4926ef6a01466ddd$var$_react = $4926ef6a01466ddd$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $4926ef6a01466ddd$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4926ef6a01466ddd$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4926ef6a01466ddd$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $4926ef6a01466ddd$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $4926ef6a01466ddd$var$_extends() {
    return $4926ef6a01466ddd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4926ef6a01466ddd$var$_extends.apply(null, arguments);
}
var $4926ef6a01466ddd$var$Catalog = $4926ef6a01466ddd$export$c401078f1496a453 = /*#__PURE__*/ (0, $4926ef6a01466ddd$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $4926ef6a01466ddd$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $4926ef6a01466ddd$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Catalog"
    }, props), /*#__PURE__*/ $4926ef6a01466ddd$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M5 6 1 4.5v13.943L12 23l11-4.557V4l-4 2M5 16V2l7 3 7-3v14l-7 3-7-3zm6.95-11v14"
    }));
});
$4926ef6a01466ddd$var$Catalog.displayName = 'Catalog';


Object.keys($4926ef6a01466ddd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $4926ef6a01466ddd$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $4926ef6a01466ddd$exports[key];
});
var $805f7dc179ba24b4$exports = {};

$parcel$export($805f7dc179ba24b4$exports, "__esModule", function () { return $805f7dc179ba24b4$export$1e511d4a378977f5; }, function (v) { return $805f7dc179ba24b4$export$1e511d4a378977f5 = v; });
$parcel$export($805f7dc179ba24b4$exports, "Centos", function () { return $805f7dc179ba24b4$export$529354db3f4ca670; }, function (v) { return $805f7dc179ba24b4$export$529354db3f4ca670 = v; });
var $805f7dc179ba24b4$export$1e511d4a378977f5;
var $805f7dc179ba24b4$export$529354db3f4ca670;
"use strict";
$805f7dc179ba24b4$export$1e511d4a378977f5 = true;
$805f7dc179ba24b4$export$529354db3f4ca670 = void 0;

var $805f7dc179ba24b4$var$_react = $805f7dc179ba24b4$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $805f7dc179ba24b4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($805f7dc179ba24b4$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $805f7dc179ba24b4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $805f7dc179ba24b4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $805f7dc179ba24b4$var$_extends() {
    return $805f7dc179ba24b4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $805f7dc179ba24b4$var$_extends.apply(null, arguments);
}
var $805f7dc179ba24b4$var$Centos = $805f7dc179ba24b4$export$529354db3f4ca670 = /*#__PURE__*/ (0, $805f7dc179ba24b4$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $805f7dc179ba24b4$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $805f7dc179ba24b4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Centos"
    }, props), /*#__PURE__*/ $805f7dc179ba24b4$var$_react["default"].createElement("path", {
        fill: "#7E2F76",
        fillRule: "evenodd",
        d: "M5.161 6.25 3.249 8.164V3.227h4.935L6.24 5.172l-.147.146.147.147 4.514 4.516v.738h-.83L5.457 6.251l-.15-.15-.146.15zm5.594 3.142V3.227H8.772l-2.09 2.091 4.073 4.074zM5.307 6.693 3.25 8.753v1.966h6.083L5.307 6.693zm7.964 2.67 4.044-4.045-2.119-2.12h-1.925v6.165zm4.636-4.045-.15.147-4.486 4.49v.764h.786l4.477-4.478.146-.146.15.146 1.96 1.96V3.2h-5.005l1.973 1.973.15.146zm-6.736-2.51v7l.828.828.856-.856V2.782h1.924L12 0 9.192 2.807h1.98zm3.478 7.911h6.141V8.794l-2.11-2.11-4.031 4.035zm-4.025 1.292-.872-.872h-6.92V9.17L0 12.002l2.832 2.832V12.81h6.993l.8-.799zm2.647 2.68v6.056h1.964l2.045-2.046-4.009-4.01zM5.317 17.32l4.092-4.093h-6.16v2.024l2.068 2.069zm13.364 0 2.11-2.11v-1.983h-6.2l4.09 4.093zm2.529-2.53 2.787-2.788-2.787-2.788v1.925h-6.98l-.863.863.808.808h7.035v1.98zm-2.53 3.118-.146-.146L14 13.227h-.729v.875l4.452 4.452.146.147-.146.15-1.897 1.896h4.964v-4.945l-1.96 1.96-.15.146zm-5.825 3.256v-6.89l-.872-.872-.799.799v6.963h-2.04L11.984 24l2.835-2.836h-1.964zm-6.762-2.463.147-.147 4.527-4.528v-.8h-.77l-4.534 4.536-.146.146-.147-.146-1.92-1.922v4.907h4.887L6.24 18.85l-.147-.15zm4.674-4.083L6.682 18.7l2.046 2.046h2.04v-6.13z"
    }));
});
$805f7dc179ba24b4$var$Centos.displayName = 'Centos';


Object.keys($805f7dc179ba24b4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $805f7dc179ba24b4$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $805f7dc179ba24b4$exports[key];
});
var $f515d7e963ff7659$exports = {};

$parcel$export($f515d7e963ff7659$exports, "__esModule", function () { return $f515d7e963ff7659$export$1e511d4a378977f5; }, function (v) { return $f515d7e963ff7659$export$1e511d4a378977f5 = v; });
$parcel$export($f515d7e963ff7659$exports, "Certificate", function () { return $f515d7e963ff7659$export$ca20b3ed1788c40a; }, function (v) { return $f515d7e963ff7659$export$ca20b3ed1788c40a = v; });
var $f515d7e963ff7659$export$1e511d4a378977f5;
var $f515d7e963ff7659$export$ca20b3ed1788c40a;
"use strict";
$f515d7e963ff7659$export$1e511d4a378977f5 = true;
$f515d7e963ff7659$export$ca20b3ed1788c40a = void 0;

var $f515d7e963ff7659$var$_react = $f515d7e963ff7659$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f515d7e963ff7659$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f515d7e963ff7659$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f515d7e963ff7659$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f515d7e963ff7659$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f515d7e963ff7659$var$_extends() {
    return $f515d7e963ff7659$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f515d7e963ff7659$var$_extends.apply(null, arguments);
}
var $f515d7e963ff7659$var$Certificate = $f515d7e963ff7659$export$ca20b3ed1788c40a = /*#__PURE__*/ (0, $f515d7e963ff7659$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f515d7e963ff7659$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f515d7e963ff7659$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Certificate"
    }, props), /*#__PURE__*/ $f515d7e963ff7659$var$_react["default"].createElement("path", {
        stroke: "#000",
        strokeWidth: "2",
        fill: "none",
        d: "M15 19H2V1h16v4m0 0a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm-3 9v8l3-2 3 2v-8M5 8h6m-6 3h5m-5 3h2M5 5h2"
    }));
});
$f515d7e963ff7659$var$Certificate.displayName = 'Certificate';


Object.keys($f515d7e963ff7659$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f515d7e963ff7659$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f515d7e963ff7659$exports[key];
});
var $317640a083bf9584$exports = {};

$parcel$export($317640a083bf9584$exports, "__esModule", function () { return $317640a083bf9584$export$1e511d4a378977f5; }, function (v) { return $317640a083bf9584$export$1e511d4a378977f5 = v; });
$parcel$export($317640a083bf9584$exports, "Channel", function () { return $317640a083bf9584$export$cfdacaa37f9b4dd7; }, function (v) { return $317640a083bf9584$export$cfdacaa37f9b4dd7 = v; });
var $317640a083bf9584$export$1e511d4a378977f5;
var $317640a083bf9584$export$cfdacaa37f9b4dd7;
"use strict";
$317640a083bf9584$export$1e511d4a378977f5 = true;
$317640a083bf9584$export$cfdacaa37f9b4dd7 = void 0;

var $317640a083bf9584$var$_react = $317640a083bf9584$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $317640a083bf9584$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($317640a083bf9584$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $317640a083bf9584$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $317640a083bf9584$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $317640a083bf9584$var$_extends() {
    return $317640a083bf9584$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $317640a083bf9584$var$_extends.apply(null, arguments);
}
var $317640a083bf9584$var$Channel = $317640a083bf9584$export$cfdacaa37f9b4dd7 = /*#__PURE__*/ (0, $317640a083bf9584$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $317640a083bf9584$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $317640a083bf9584$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Channel"
    }, props), /*#__PURE__*/ $317640a083bf9584$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 9h20v13H2V9zm19-7-8 7h-2L3 2"
    }));
});
$317640a083bf9584$var$Channel.displayName = 'Channel';


Object.keys($317640a083bf9584$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $317640a083bf9584$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $317640a083bf9584$exports[key];
});
var $3f1e7c7457d6a4c9$exports = {};

$parcel$export($3f1e7c7457d6a4c9$exports, "__esModule", function () { return $3f1e7c7457d6a4c9$export$1e511d4a378977f5; }, function (v) { return $3f1e7c7457d6a4c9$export$1e511d4a378977f5 = v; });
$parcel$export($3f1e7c7457d6a4c9$exports, "ChapterAdd", function () { return $3f1e7c7457d6a4c9$export$584d27f07a20e3d5; }, function (v) { return $3f1e7c7457d6a4c9$export$584d27f07a20e3d5 = v; });
var $3f1e7c7457d6a4c9$export$1e511d4a378977f5;
var $3f1e7c7457d6a4c9$export$584d27f07a20e3d5;
"use strict";
$3f1e7c7457d6a4c9$export$1e511d4a378977f5 = true;
$3f1e7c7457d6a4c9$export$584d27f07a20e3d5 = void 0;

var $3f1e7c7457d6a4c9$var$_react = $3f1e7c7457d6a4c9$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $3f1e7c7457d6a4c9$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3f1e7c7457d6a4c9$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3f1e7c7457d6a4c9$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3f1e7c7457d6a4c9$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3f1e7c7457d6a4c9$var$_extends() {
    return $3f1e7c7457d6a4c9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3f1e7c7457d6a4c9$var$_extends.apply(null, arguments);
}
var $3f1e7c7457d6a4c9$var$ChapterAdd = $3f1e7c7457d6a4c9$export$584d27f07a20e3d5 = /*#__PURE__*/ (0, $3f1e7c7457d6a4c9$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3f1e7c7457d6a4c9$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3f1e7c7457d6a4c9$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ChapterAdd"
    }, props), /*#__PURE__*/ $3f1e7c7457d6a4c9$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M5 14V5h14v15h-8m8-4h4V1H9v4M5 16v8m4-4H1"
    }));
});
$3f1e7c7457d6a4c9$var$ChapterAdd.displayName = 'ChapterAdd';


Object.keys($3f1e7c7457d6a4c9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3f1e7c7457d6a4c9$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3f1e7c7457d6a4c9$exports[key];
});
var $dabb110a5bf5ca57$exports = {};

$parcel$export($dabb110a5bf5ca57$exports, "__esModule", function () { return $dabb110a5bf5ca57$export$1e511d4a378977f5; }, function (v) { return $dabb110a5bf5ca57$export$1e511d4a378977f5 = v; });
$parcel$export($dabb110a5bf5ca57$exports, "ChapterNext", function () { return $dabb110a5bf5ca57$export$99dc6369e90ae31f; }, function (v) { return $dabb110a5bf5ca57$export$99dc6369e90ae31f = v; });
var $dabb110a5bf5ca57$export$1e511d4a378977f5;
var $dabb110a5bf5ca57$export$99dc6369e90ae31f;
"use strict";
$dabb110a5bf5ca57$export$1e511d4a378977f5 = true;
$dabb110a5bf5ca57$export$99dc6369e90ae31f = void 0;

var $dabb110a5bf5ca57$var$_react = $dabb110a5bf5ca57$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $dabb110a5bf5ca57$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($dabb110a5bf5ca57$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $dabb110a5bf5ca57$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $dabb110a5bf5ca57$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $dabb110a5bf5ca57$var$_extends() {
    return $dabb110a5bf5ca57$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $dabb110a5bf5ca57$var$_extends.apply(null, arguments);
}
var $dabb110a5bf5ca57$var$ChapterNext = $dabb110a5bf5ca57$export$99dc6369e90ae31f = /*#__PURE__*/ (0, $dabb110a5bf5ca57$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $dabb110a5bf5ca57$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $dabb110a5bf5ca57$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ChapterNext"
    }, props), /*#__PURE__*/ $dabb110a5bf5ca57$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 3.5V20l9-6v6l11-8-11-8v6L1 3.5zM22 2v20V2z"
    }));
});
$dabb110a5bf5ca57$var$ChapterNext.displayName = 'ChapterNext';


Object.keys($dabb110a5bf5ca57$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $dabb110a5bf5ca57$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $dabb110a5bf5ca57$exports[key];
});
var $f6702d7c34f7a12e$exports = {};

$parcel$export($f6702d7c34f7a12e$exports, "__esModule", function () { return $f6702d7c34f7a12e$export$1e511d4a378977f5; }, function (v) { return $f6702d7c34f7a12e$export$1e511d4a378977f5 = v; });
$parcel$export($f6702d7c34f7a12e$exports, "ChapterPrevious", function () { return $f6702d7c34f7a12e$export$5471a185889359af; }, function (v) { return $f6702d7c34f7a12e$export$5471a185889359af = v; });
var $f6702d7c34f7a12e$export$1e511d4a378977f5;
var $f6702d7c34f7a12e$export$5471a185889359af;
"use strict";
$f6702d7c34f7a12e$export$1e511d4a378977f5 = true;
$f6702d7c34f7a12e$export$5471a185889359af = void 0;

var $f6702d7c34f7a12e$var$_react = $f6702d7c34f7a12e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f6702d7c34f7a12e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f6702d7c34f7a12e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f6702d7c34f7a12e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f6702d7c34f7a12e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f6702d7c34f7a12e$var$_extends() {
    return $f6702d7c34f7a12e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f6702d7c34f7a12e$var$_extends.apply(null, arguments);
}
var $f6702d7c34f7a12e$var$ChapterPrevious = $f6702d7c34f7a12e$export$5471a185889359af = /*#__PURE__*/ (0, $f6702d7c34f7a12e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f6702d7c34f7a12e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f6702d7c34f7a12e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ChapterPrevious"
    }, props), /*#__PURE__*/ $f6702d7c34f7a12e$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M23 3.5V20l-9-6v6L3 12l11-8v6l9-6.5zM2 2v20V2z"
    }));
});
$f6702d7c34f7a12e$var$ChapterPrevious.displayName = 'ChapterPrevious';


Object.keys($f6702d7c34f7a12e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f6702d7c34f7a12e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f6702d7c34f7a12e$exports[key];
});
var $458ab04dc7c6d7b5$exports = {};

$parcel$export($458ab04dc7c6d7b5$exports, "__esModule", function () { return $458ab04dc7c6d7b5$export$1e511d4a378977f5; }, function (v) { return $458ab04dc7c6d7b5$export$1e511d4a378977f5 = v; });
$parcel$export($458ab04dc7c6d7b5$exports, "ChatOption", function () { return $458ab04dc7c6d7b5$export$7111acc32417a856; }, function (v) { return $458ab04dc7c6d7b5$export$7111acc32417a856 = v; });
var $458ab04dc7c6d7b5$export$1e511d4a378977f5;
var $458ab04dc7c6d7b5$export$7111acc32417a856;
"use strict";
$458ab04dc7c6d7b5$export$1e511d4a378977f5 = true;
$458ab04dc7c6d7b5$export$7111acc32417a856 = void 0;

var $458ab04dc7c6d7b5$var$_react = $458ab04dc7c6d7b5$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $458ab04dc7c6d7b5$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($458ab04dc7c6d7b5$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $458ab04dc7c6d7b5$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $458ab04dc7c6d7b5$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $458ab04dc7c6d7b5$var$_extends() {
    return $458ab04dc7c6d7b5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $458ab04dc7c6d7b5$var$_extends.apply(null, arguments);
}
var $458ab04dc7c6d7b5$var$ChatOption = $458ab04dc7c6d7b5$export$7111acc32417a856 = /*#__PURE__*/ (0, $458ab04dc7c6d7b5$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $458ab04dc7c6d7b5$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $458ab04dc7c6d7b5$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ChatOption"
    }, props), /*#__PURE__*/ $458ab04dc7c6d7b5$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M9 7V1h14v10h-3v5l-5-4M1 7h14v11H9l-5 4v-4H1V7z"
    }));
});
$458ab04dc7c6d7b5$var$ChatOption.displayName = 'ChatOption';


Object.keys($458ab04dc7c6d7b5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $458ab04dc7c6d7b5$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $458ab04dc7c6d7b5$exports[key];
});
var $f45628575ec72f49$exports = {};

$parcel$export($f45628575ec72f49$exports, "__esModule", function () { return $f45628575ec72f49$export$1e511d4a378977f5; }, function (v) { return $f45628575ec72f49$export$1e511d4a378977f5 = v; });
$parcel$export($f45628575ec72f49$exports, "Chat", function () { return $f45628575ec72f49$export$d49dffca20dba6f7; }, function (v) { return $f45628575ec72f49$export$d49dffca20dba6f7 = v; });
var $f45628575ec72f49$export$1e511d4a378977f5;
var $f45628575ec72f49$export$d49dffca20dba6f7;
"use strict";
$f45628575ec72f49$export$1e511d4a378977f5 = true;
$f45628575ec72f49$export$d49dffca20dba6f7 = void 0;

var $f45628575ec72f49$var$_react = $f45628575ec72f49$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f45628575ec72f49$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f45628575ec72f49$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f45628575ec72f49$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f45628575ec72f49$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f45628575ec72f49$var$_extends() {
    return $f45628575ec72f49$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f45628575ec72f49$var$_extends.apply(null, arguments);
}
var $f45628575ec72f49$var$Chat = $f45628575ec72f49$export$d49dffca20dba6f7 = /*#__PURE__*/ (0, $f45628575ec72f49$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f45628575ec72f49$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f45628575ec72f49$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Chat"
    }, props), /*#__PURE__*/ $f45628575ec72f49$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M19 1H5a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h12l6 5V5a4 4 0 0 0-4-4zm0 6H6m13 4h-9"
    }));
});
$f45628575ec72f49$var$Chat.displayName = 'Chat';


Object.keys($f45628575ec72f49$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f45628575ec72f49$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f45628575ec72f49$exports[key];
});
var $344cbc25c0060803$exports = {};

$parcel$export($344cbc25c0060803$exports, "__esModule", function () { return $344cbc25c0060803$export$1e511d4a378977f5; }, function (v) { return $344cbc25c0060803$export$1e511d4a378977f5 = v; });
$parcel$export($344cbc25c0060803$exports, "CheckboxSelected", function () { return $344cbc25c0060803$export$684b29877fc1ca9b; }, function (v) { return $344cbc25c0060803$export$684b29877fc1ca9b = v; });
var $344cbc25c0060803$export$1e511d4a378977f5;
var $344cbc25c0060803$export$684b29877fc1ca9b;
"use strict";
$344cbc25c0060803$export$1e511d4a378977f5 = true;
$344cbc25c0060803$export$684b29877fc1ca9b = void 0;

var $344cbc25c0060803$var$_react = $344cbc25c0060803$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $344cbc25c0060803$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($344cbc25c0060803$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $344cbc25c0060803$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $344cbc25c0060803$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $344cbc25c0060803$var$_extends() {
    return $344cbc25c0060803$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $344cbc25c0060803$var$_extends.apply(null, arguments);
}
var $344cbc25c0060803$var$CheckboxSelected = $344cbc25c0060803$export$684b29877fc1ca9b = /*#__PURE__*/ (0, $344cbc25c0060803$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $344cbc25c0060803$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $344cbc25c0060803$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CheckboxSelected"
    }, props), /*#__PURE__*/ $344cbc25c0060803$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 2h20v20H2V2zm3 11 5 4 9-11"
    }));
});
$344cbc25c0060803$var$CheckboxSelected.displayName = 'CheckboxSelected';


Object.keys($344cbc25c0060803$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $344cbc25c0060803$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $344cbc25c0060803$exports[key];
});
var $0a7a24f94b9b494f$exports = {};

$parcel$export($0a7a24f94b9b494f$exports, "__esModule", function () { return $0a7a24f94b9b494f$export$1e511d4a378977f5; }, function (v) { return $0a7a24f94b9b494f$export$1e511d4a378977f5 = v; });
$parcel$export($0a7a24f94b9b494f$exports, "Checkbox", function () { return $0a7a24f94b9b494f$export$48513f6b9f8ce62d; }, function (v) { return $0a7a24f94b9b494f$export$48513f6b9f8ce62d = v; });
var $0a7a24f94b9b494f$export$1e511d4a378977f5;
var $0a7a24f94b9b494f$export$48513f6b9f8ce62d;
"use strict";
$0a7a24f94b9b494f$export$1e511d4a378977f5 = true;
$0a7a24f94b9b494f$export$48513f6b9f8ce62d = void 0;

var $0a7a24f94b9b494f$var$_react = $0a7a24f94b9b494f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0a7a24f94b9b494f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0a7a24f94b9b494f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0a7a24f94b9b494f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0a7a24f94b9b494f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0a7a24f94b9b494f$var$_extends() {
    return $0a7a24f94b9b494f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0a7a24f94b9b494f$var$_extends.apply(null, arguments);
}
var $0a7a24f94b9b494f$var$Checkbox = $0a7a24f94b9b494f$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $0a7a24f94b9b494f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0a7a24f94b9b494f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0a7a24f94b9b494f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Checkbox"
    }, props), /*#__PURE__*/ $0a7a24f94b9b494f$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 2h20v20H2z"
    }));
});
$0a7a24f94b9b494f$var$Checkbox.displayName = 'Checkbox';


Object.keys($0a7a24f94b9b494f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0a7a24f94b9b494f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0a7a24f94b9b494f$exports[key];
});

Object.keys($efa3551e30470d99$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $efa3551e30470d99$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $efa3551e30470d99$exports[key];
});
var $0c5a90c89791220b$exports = {};

$parcel$export($0c5a90c89791220b$exports, "__esModule", function () { return $0c5a90c89791220b$export$1e511d4a378977f5; }, function (v) { return $0c5a90c89791220b$export$1e511d4a378977f5 = v; });
$parcel$export($0c5a90c89791220b$exports, "Chrome", function () { return $0c5a90c89791220b$export$31a305e9779b48b4; }, function (v) { return $0c5a90c89791220b$export$31a305e9779b48b4 = v; });
var $0c5a90c89791220b$export$1e511d4a378977f5;
var $0c5a90c89791220b$export$31a305e9779b48b4;
"use strict";
$0c5a90c89791220b$export$1e511d4a378977f5 = true;
$0c5a90c89791220b$export$31a305e9779b48b4 = void 0;

var $0c5a90c89791220b$var$_react = $0c5a90c89791220b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0c5a90c89791220b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0c5a90c89791220b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0c5a90c89791220b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0c5a90c89791220b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0c5a90c89791220b$var$_extends() {
    return $0c5a90c89791220b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0c5a90c89791220b$var$_extends.apply(null, arguments);
}
var $0c5a90c89791220b$var$Chrome = $0c5a90c89791220b$export$31a305e9779b48b4 = /*#__PURE__*/ (0, $0c5a90c89791220b$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0c5a90c89791220b$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0c5a90c89791220b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Chrome"
    }, props), /*#__PURE__*/ $0c5a90c89791220b$var$_react["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $0c5a90c89791220b$var$_react["default"].createElement("path", {
        fill: "#4285F4",
        d: "M11.973 16.414A4.32 4.32 0 0 1 7.66 12.1a4.32 4.32 0 0 1 4.314-4.315 4.32 4.32 0 0 1 4.315 4.315 4.32 4.32 0 0 1-4.315 4.314z"
    }), /*#__PURE__*/ $0c5a90c89791220b$var$_react["default"].createElement("path", {
        fill: "#4AAE48",
        d: "M13.791 17.181a5.507 5.507 0 0 1-5.38-.926 5.496 5.496 0 0 1-1.718-2.505l-.002-.006L1.936 5.51A11.892 11.892 0 0 0 .23 14.35a11.896 11.896 0 0 0 5.08 7.627 11.894 11.894 0 0 0 4.557 1.84l3.924-6.635z"
    }), /*#__PURE__*/ $0c5a90c89791220b$var$_react["default"].createElement("path", {
        fill: "#EA3939",
        d: "M22.76 6.707a12.08 12.08 0 0 0-20.185-2.25l4.016 6.956a5.393 5.393 0 0 1 5.274-4.706H22.76z"
    }), /*#__PURE__*/ $0c5a90c89791220b$var$_react["default"].createElement("path", {
        fill: "#FED14B",
        d: "M11.926 24c3.01 0 5.891-1.129 8.11-3.178a11.932 11.932 0 0 0 3.816-7.893 12.05 12.05 0 0 0-.744-5.144h-7.856a5.506 5.506 0 0 1 2.09 4.34 5.529 5.529 0 0 1-1.182 3.381l-5.008 8.47c.258.016.518.024.774.024z"
    })));
});
$0c5a90c89791220b$var$Chrome.displayName = 'Chrome';


Object.keys($0c5a90c89791220b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0c5a90c89791220b$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0c5a90c89791220b$exports[key];
});

Object.keys($75c79f8c08ff67ad$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $75c79f8c08ff67ad$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $75c79f8c08ff67ad$exports[key];
});

Object.keys($8943ffd4a7fe1a81$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $8943ffd4a7fe1a81$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $8943ffd4a7fe1a81$exports[key];
});
var $c344d9874b246cb7$exports = {};

$parcel$export($c344d9874b246cb7$exports, "__esModule", function () { return $c344d9874b246cb7$export$1e511d4a378977f5; }, function (v) { return $c344d9874b246cb7$export$1e511d4a378977f5 = v; });
$parcel$export($c344d9874b246cb7$exports, "CirclePlay", function () { return $c344d9874b246cb7$export$e9ed5a053e329c6; }, function (v) { return $c344d9874b246cb7$export$e9ed5a053e329c6 = v; });
var $c344d9874b246cb7$export$1e511d4a378977f5;
var $c344d9874b246cb7$export$e9ed5a053e329c6;
"use strict";
$c344d9874b246cb7$export$1e511d4a378977f5 = true;
$c344d9874b246cb7$export$e9ed5a053e329c6 = void 0;

var $c344d9874b246cb7$var$_react = $c344d9874b246cb7$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c344d9874b246cb7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c344d9874b246cb7$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c344d9874b246cb7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c344d9874b246cb7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c344d9874b246cb7$var$_extends() {
    return $c344d9874b246cb7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c344d9874b246cb7$var$_extends.apply(null, arguments);
}
var $c344d9874b246cb7$var$CirclePlay = $c344d9874b246cb7$export$e9ed5a053e329c6 = /*#__PURE__*/ (0, $c344d9874b246cb7$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c344d9874b246cb7$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c344d9874b246cb7$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CirclePlay"
    }, props), /*#__PURE__*/ $c344d9874b246cb7$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-2.5-6.5 6-3.5-6-3.5v7zm1-2 2-1.5-2-1.5v3z"
    }));
});
$c344d9874b246cb7$var$CirclePlay.displayName = 'CirclePlay';


Object.keys($c344d9874b246cb7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c344d9874b246cb7$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c344d9874b246cb7$exports[key];
});
var $5b7c159dcd729e14$exports = {};

$parcel$export($5b7c159dcd729e14$exports, "__esModule", function () { return $5b7c159dcd729e14$export$1e511d4a378977f5; }, function (v) { return $5b7c159dcd729e14$export$1e511d4a378977f5 = v; });
$parcel$export($5b7c159dcd729e14$exports, "CircleQuestion", function () { return $5b7c159dcd729e14$export$59596d9b033ace49; }, function (v) { return $5b7c159dcd729e14$export$59596d9b033ace49 = v; });
var $5b7c159dcd729e14$export$1e511d4a378977f5;
var $5b7c159dcd729e14$export$59596d9b033ace49;
"use strict";
$5b7c159dcd729e14$export$1e511d4a378977f5 = true;
$5b7c159dcd729e14$export$59596d9b033ace49 = void 0;

var $5b7c159dcd729e14$var$_react = $5b7c159dcd729e14$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5b7c159dcd729e14$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5b7c159dcd729e14$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5b7c159dcd729e14$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5b7c159dcd729e14$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5b7c159dcd729e14$var$_extends() {
    return $5b7c159dcd729e14$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5b7c159dcd729e14$var$_extends.apply(null, arguments);
}
var $5b7c159dcd729e14$var$CircleQuestion = $5b7c159dcd729e14$export$59596d9b033ace49 = /*#__PURE__*/ (0, $5b7c159dcd729e14$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5b7c159dcd729e14$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5b7c159dcd729e14$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CircleQuestion"
    }, props), /*#__PURE__*/ $5b7c159dcd729e14$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-7v-1c0-1 0-1.5 1-2s2-1 2-2.5c0-1-1-2.5-3-2.5s-3 1.264-3 3m3 6v2"
    }));
});
$5b7c159dcd729e14$var$CircleQuestion.displayName = 'CircleQuestion';


Object.keys($5b7c159dcd729e14$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5b7c159dcd729e14$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5b7c159dcd729e14$exports[key];
});
var $d615107b8cb1f715$exports = {};

$parcel$export($d615107b8cb1f715$exports, "__esModule", function () { return $d615107b8cb1f715$export$1e511d4a378977f5; }, function (v) { return $d615107b8cb1f715$export$1e511d4a378977f5 = v; });
$parcel$export($d615107b8cb1f715$exports, "ClearOption", function () { return $d615107b8cb1f715$export$efc0cd6c220e58be; }, function (v) { return $d615107b8cb1f715$export$efc0cd6c220e58be = v; });
var $d615107b8cb1f715$export$1e511d4a378977f5;
var $d615107b8cb1f715$export$efc0cd6c220e58be;
"use strict";
$d615107b8cb1f715$export$1e511d4a378977f5 = true;
$d615107b8cb1f715$export$efc0cd6c220e58be = void 0;

var $d615107b8cb1f715$var$_react = $d615107b8cb1f715$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $d615107b8cb1f715$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d615107b8cb1f715$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d615107b8cb1f715$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d615107b8cb1f715$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d615107b8cb1f715$var$_extends() {
    return $d615107b8cb1f715$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d615107b8cb1f715$var$_extends.apply(null, arguments);
}
var $d615107b8cb1f715$var$ClearOption = $d615107b8cb1f715$export$efc0cd6c220e58be = /*#__PURE__*/ (0, $d615107b8cb1f715$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d615107b8cb1f715$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $d615107b8cb1f715$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ClearOption"
    }, props), /*#__PURE__*/ $d615107b8cb1f715$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M10 4a2 2 0 1 1 4 0v6h6v4H4v-4h6V4zM4 14h16v8H4v-8zm12 8v-5.635M8 22v-5.635M12 22v-5.635"
    }));
});
$d615107b8cb1f715$var$ClearOption.displayName = 'ClearOption';


Object.keys($d615107b8cb1f715$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $d615107b8cb1f715$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $d615107b8cb1f715$exports[key];
});
var $1581f39857d4c4b2$exports = {};

$parcel$export($1581f39857d4c4b2$exports, "__esModule", function () { return $1581f39857d4c4b2$export$1e511d4a378977f5; }, function (v) { return $1581f39857d4c4b2$export$1e511d4a378977f5 = v; });
$parcel$export($1581f39857d4c4b2$exports, "Clear", function () { return $1581f39857d4c4b2$export$47d037774b685574; }, function (v) { return $1581f39857d4c4b2$export$47d037774b685574 = v; });
var $1581f39857d4c4b2$export$1e511d4a378977f5;
var $1581f39857d4c4b2$export$47d037774b685574;
"use strict";
$1581f39857d4c4b2$export$1e511d4a378977f5 = true;
$1581f39857d4c4b2$export$47d037774b685574 = void 0;

var $1581f39857d4c4b2$var$_react = $1581f39857d4c4b2$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $1581f39857d4c4b2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1581f39857d4c4b2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1581f39857d4c4b2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $1581f39857d4c4b2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1581f39857d4c4b2$var$_extends() {
    return $1581f39857d4c4b2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1581f39857d4c4b2$var$_extends.apply(null, arguments);
}
var $1581f39857d4c4b2$var$Clear = $1581f39857d4c4b2$export$47d037774b685574 = /*#__PURE__*/ (0, $1581f39857d4c4b2$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $1581f39857d4c4b2$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $1581f39857d4c4b2$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Clear"
    }, props), /*#__PURE__*/ $1581f39857d4c4b2$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM5 5l14 14"
    }));
});
$1581f39857d4c4b2$var$Clear.displayName = 'Clear';


Object.keys($1581f39857d4c4b2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $1581f39857d4c4b2$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $1581f39857d4c4b2$exports[key];
});
var $907b6ad5ad7d1293$exports = {};

$parcel$export($907b6ad5ad7d1293$exports, "__esModule", function () { return $907b6ad5ad7d1293$export$1e511d4a378977f5; }, function (v) { return $907b6ad5ad7d1293$export$1e511d4a378977f5 = v; });
$parcel$export($907b6ad5ad7d1293$exports, "Cli", function () { return $907b6ad5ad7d1293$export$2af27388a2acc921; }, function (v) { return $907b6ad5ad7d1293$export$2af27388a2acc921 = v; });
var $907b6ad5ad7d1293$export$1e511d4a378977f5;
var $907b6ad5ad7d1293$export$2af27388a2acc921;
"use strict";
$907b6ad5ad7d1293$export$1e511d4a378977f5 = true;
$907b6ad5ad7d1293$export$2af27388a2acc921 = void 0;

var $907b6ad5ad7d1293$var$_react = $907b6ad5ad7d1293$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $907b6ad5ad7d1293$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($907b6ad5ad7d1293$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $907b6ad5ad7d1293$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $907b6ad5ad7d1293$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $907b6ad5ad7d1293$var$_extends() {
    return $907b6ad5ad7d1293$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $907b6ad5ad7d1293$var$_extends.apply(null, arguments);
}
var $907b6ad5ad7d1293$var$Cli = $907b6ad5ad7d1293$export$2af27388a2acc921 = /*#__PURE__*/ (0, $907b6ad5ad7d1293$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $907b6ad5ad7d1293$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $907b6ad5ad7d1293$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Cli"
    }, props), /*#__PURE__*/ $907b6ad5ad7d1293$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 1h22v22H1V1zm0 4h22M5 1v4m6 11h8M5 10l3 3-3 3"
    }));
});
$907b6ad5ad7d1293$var$Cli.displayName = 'Cli';


Object.keys($907b6ad5ad7d1293$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $907b6ad5ad7d1293$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $907b6ad5ad7d1293$exports[key];
});
var $7155d3760d9d070c$exports = {};

$parcel$export($7155d3760d9d070c$exports, "__esModule", function () { return $7155d3760d9d070c$export$1e511d4a378977f5; }, function (v) { return $7155d3760d9d070c$export$1e511d4a378977f5 = v; });
$parcel$export($7155d3760d9d070c$exports, "Clipboard", function () { return $7155d3760d9d070c$export$8b44c43c7d8f0830; }, function (v) { return $7155d3760d9d070c$export$8b44c43c7d8f0830 = v; });
var $7155d3760d9d070c$export$1e511d4a378977f5;
var $7155d3760d9d070c$export$8b44c43c7d8f0830;
"use strict";
$7155d3760d9d070c$export$1e511d4a378977f5 = true;
$7155d3760d9d070c$export$8b44c43c7d8f0830 = void 0;

var $7155d3760d9d070c$var$_react = $7155d3760d9d070c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $7155d3760d9d070c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7155d3760d9d070c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7155d3760d9d070c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $7155d3760d9d070c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7155d3760d9d070c$var$_extends() {
    return $7155d3760d9d070c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7155d3760d9d070c$var$_extends.apply(null, arguments);
}
var $7155d3760d9d070c$var$Clipboard = $7155d3760d9d070c$export$8b44c43c7d8f0830 = /*#__PURE__*/ (0, $7155d3760d9d070c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $7155d3760d9d070c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $7155d3760d9d070c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Clipboard"
    }, props), /*#__PURE__*/ $7155d3760d9d070c$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M16 3h5v20H3V3h5m0-2h8v5H8V1z"
    }));
});
$7155d3760d9d070c$var$Clipboard.displayName = 'Clipboard';


Object.keys($7155d3760d9d070c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $7155d3760d9d070c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $7155d3760d9d070c$exports[key];
});

Object.keys($4f80ce31f1e76523$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $4f80ce31f1e76523$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $4f80ce31f1e76523$exports[key];
});
var $fed8a642cf3e7e00$exports = {};

$parcel$export($fed8a642cf3e7e00$exports, "__esModule", function () { return $fed8a642cf3e7e00$export$1e511d4a378977f5; }, function (v) { return $fed8a642cf3e7e00$export$1e511d4a378977f5 = v; });
$parcel$export($fed8a642cf3e7e00$exports, "Clone", function () { return $fed8a642cf3e7e00$export$b5d07669a5562b23; }, function (v) { return $fed8a642cf3e7e00$export$b5d07669a5562b23 = v; });
var $fed8a642cf3e7e00$export$1e511d4a378977f5;
var $fed8a642cf3e7e00$export$b5d07669a5562b23;
"use strict";
$fed8a642cf3e7e00$export$1e511d4a378977f5 = true;
$fed8a642cf3e7e00$export$b5d07669a5562b23 = void 0;

var $fed8a642cf3e7e00$var$_react = $fed8a642cf3e7e00$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $fed8a642cf3e7e00$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($fed8a642cf3e7e00$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $fed8a642cf3e7e00$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $fed8a642cf3e7e00$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $fed8a642cf3e7e00$var$_extends() {
    return $fed8a642cf3e7e00$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fed8a642cf3e7e00$var$_extends.apply(null, arguments);
}
var $fed8a642cf3e7e00$var$Clone = $fed8a642cf3e7e00$export$b5d07669a5562b23 = /*#__PURE__*/ (0, $fed8a642cf3e7e00$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $fed8a642cf3e7e00$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $fed8a642cf3e7e00$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Clone"
    }, props), /*#__PURE__*/ $fed8a642cf3e7e00$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M7 23h16V7H7v16zM17 4V1h-3M1 14v3h3m-3-5V6v6zM4 1H1v3m5-3h6-6z"
    }));
});
$fed8a642cf3e7e00$var$Clone.displayName = 'Clone';


Object.keys($fed8a642cf3e7e00$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $fed8a642cf3e7e00$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $fed8a642cf3e7e00$exports[key];
});

Object.keys($465d22e15ca8d0c4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $465d22e15ca8d0c4$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $465d22e15ca8d0c4$exports[key];
});

Object.keys($173838d506ca9170$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $173838d506ca9170$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $173838d506ca9170$exports[key];
});
var $54ad5c837115001c$exports = {};

$parcel$export($54ad5c837115001c$exports, "__esModule", function () { return $54ad5c837115001c$export$1e511d4a378977f5; }, function (v) { return $54ad5c837115001c$export$1e511d4a378977f5 = v; });
$parcel$export($54ad5c837115001c$exports, "CloudComputer", function () { return $54ad5c837115001c$export$dd7e315aa3385f8b; }, function (v) { return $54ad5c837115001c$export$dd7e315aa3385f8b = v; });
var $54ad5c837115001c$export$1e511d4a378977f5;
var $54ad5c837115001c$export$dd7e315aa3385f8b;
"use strict";
$54ad5c837115001c$export$1e511d4a378977f5 = true;
$54ad5c837115001c$export$dd7e315aa3385f8b = void 0;

var $54ad5c837115001c$var$_react = $54ad5c837115001c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $54ad5c837115001c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($54ad5c837115001c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $54ad5c837115001c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $54ad5c837115001c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $54ad5c837115001c$var$_extends() {
    return $54ad5c837115001c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $54ad5c837115001c$var$_extends.apply(null, arguments);
}
var $54ad5c837115001c$var$CloudComputer = $54ad5c837115001c$export$dd7e315aa3385f8b = /*#__PURE__*/ (0, $54ad5c837115001c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $54ad5c837115001c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $54ad5c837115001c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CloudComputer"
    }, props), /*#__PURE__*/ $54ad5c837115001c$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M6 6V5c0-3 1.5-4 4-4h4c2.5 0 4 1.5 4 4v1c3 0 5 2 5 5s-2 5-5 5M14 6H6c-3 0-5 1.5-5 5s2 5 5 5m2 3h8v-7H8v7zm4 0v4-4zm-3 4h6-6z"
    }));
});
$54ad5c837115001c$var$CloudComputer.displayName = 'CloudComputer';


Object.keys($54ad5c837115001c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $54ad5c837115001c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $54ad5c837115001c$exports[key];
});
var $259552b8f7c1564a$exports = {};

$parcel$export($259552b8f7c1564a$exports, "__esModule", function () { return $259552b8f7c1564a$export$1e511d4a378977f5; }, function (v) { return $259552b8f7c1564a$export$1e511d4a378977f5 = v; });
$parcel$export($259552b8f7c1564a$exports, "CloudDownload", function () { return $259552b8f7c1564a$export$3a083cd204da2316; }, function (v) { return $259552b8f7c1564a$export$3a083cd204da2316 = v; });
var $259552b8f7c1564a$export$1e511d4a378977f5;
var $259552b8f7c1564a$export$3a083cd204da2316;
"use strict";
$259552b8f7c1564a$export$1e511d4a378977f5 = true;
$259552b8f7c1564a$export$3a083cd204da2316 = void 0;

var $259552b8f7c1564a$var$_react = $259552b8f7c1564a$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $259552b8f7c1564a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($259552b8f7c1564a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $259552b8f7c1564a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $259552b8f7c1564a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $259552b8f7c1564a$var$_extends() {
    return $259552b8f7c1564a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $259552b8f7c1564a$var$_extends.apply(null, arguments);
}
var $259552b8f7c1564a$var$CloudDownload = $259552b8f7c1564a$export$3a083cd204da2316 = /*#__PURE__*/ (0, $259552b8f7c1564a$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $259552b8f7c1564a$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $259552b8f7c1564a$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CloudDownload"
    }, props), /*#__PURE__*/ $259552b8f7c1564a$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M6 17A5 5 0 0 1 6 7h6M6 7V6c0-3 2-4 5-4h2c3 0 5 1 5 4v1a5 5 0 0 1 0 10m-6-5v9m-4-4 4 4 4-4"
    }));
});
$259552b8f7c1564a$var$CloudDownload.displayName = 'CloudDownload';


Object.keys($259552b8f7c1564a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $259552b8f7c1564a$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $259552b8f7c1564a$exports[key];
});
var $29b6c03f39fc0209$exports = {};

$parcel$export($29b6c03f39fc0209$exports, "__esModule", function () { return $29b6c03f39fc0209$export$1e511d4a378977f5; }, function (v) { return $29b6c03f39fc0209$export$1e511d4a378977f5 = v; });
$parcel$export($29b6c03f39fc0209$exports, "CloudSoftware", function () { return $29b6c03f39fc0209$export$f580f0f2d5a24d67; }, function (v) { return $29b6c03f39fc0209$export$f580f0f2d5a24d67 = v; });
var $29b6c03f39fc0209$export$1e511d4a378977f5;
var $29b6c03f39fc0209$export$f580f0f2d5a24d67;
"use strict";
$29b6c03f39fc0209$export$1e511d4a378977f5 = true;
$29b6c03f39fc0209$export$f580f0f2d5a24d67 = void 0;

var $29b6c03f39fc0209$var$_react = $29b6c03f39fc0209$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $29b6c03f39fc0209$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($29b6c03f39fc0209$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $29b6c03f39fc0209$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $29b6c03f39fc0209$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $29b6c03f39fc0209$var$_extends() {
    return $29b6c03f39fc0209$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $29b6c03f39fc0209$var$_extends.apply(null, arguments);
}
var $29b6c03f39fc0209$var$CloudSoftware = $29b6c03f39fc0209$export$f580f0f2d5a24d67 = /*#__PURE__*/ (0, $29b6c03f39fc0209$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $29b6c03f39fc0209$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $29b6c03f39fc0209$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CloudSoftware"
    }, props), /*#__PURE__*/ $29b6c03f39fc0209$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8 23h8V12H8v11zm0-7h8m-4-4v4M6 6V5c0-3 1.5-4 4-4h4c2.5 0 4 1.5 4 4v1c3 0 5 2 5 5s-2 5-5 5M14 6H6c-3 0-5 1.5-5 5s2 5 5 5"
    }));
});
$29b6c03f39fc0209$var$CloudSoftware.displayName = 'CloudSoftware';


Object.keys($29b6c03f39fc0209$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $29b6c03f39fc0209$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $29b6c03f39fc0209$exports[key];
});
var $59a425b538bf3e96$exports = {};

$parcel$export($59a425b538bf3e96$exports, "__esModule", function () { return $59a425b538bf3e96$export$1e511d4a378977f5; }, function (v) { return $59a425b538bf3e96$export$1e511d4a378977f5 = v; });
$parcel$export($59a425b538bf3e96$exports, "CloudUpload", function () { return $59a425b538bf3e96$export$613a29ed35edc9c6; }, function (v) { return $59a425b538bf3e96$export$613a29ed35edc9c6 = v; });
var $59a425b538bf3e96$export$1e511d4a378977f5;
var $59a425b538bf3e96$export$613a29ed35edc9c6;
"use strict";
$59a425b538bf3e96$export$1e511d4a378977f5 = true;
$59a425b538bf3e96$export$613a29ed35edc9c6 = void 0;

var $59a425b538bf3e96$var$_react = $59a425b538bf3e96$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $59a425b538bf3e96$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($59a425b538bf3e96$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $59a425b538bf3e96$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $59a425b538bf3e96$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $59a425b538bf3e96$var$_extends() {
    return $59a425b538bf3e96$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $59a425b538bf3e96$var$_extends.apply(null, arguments);
}
var $59a425b538bf3e96$var$CloudUpload = $59a425b538bf3e96$export$613a29ed35edc9c6 = /*#__PURE__*/ (0, $59a425b538bf3e96$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $59a425b538bf3e96$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $59a425b538bf3e96$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CloudUpload"
    }, props), /*#__PURE__*/ $59a425b538bf3e96$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M6 17A5 5 0 0 1 6 7h6M6 7V6c0-3 2-4 5-4h2c3 0 5 1 5 4v1a5 5 0 0 1 0 10m-6-4v9m-4-6 3.965-4.035L16 16"
    }));
});
$59a425b538bf3e96$var$CloudUpload.displayName = 'CloudUpload';


Object.keys($59a425b538bf3e96$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $59a425b538bf3e96$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $59a425b538bf3e96$exports[key];
});
var $3c07d1cf2c1785b9$exports = {};

$parcel$export($3c07d1cf2c1785b9$exports, "__esModule", function () { return $3c07d1cf2c1785b9$export$1e511d4a378977f5; }, function (v) { return $3c07d1cf2c1785b9$export$1e511d4a378977f5 = v; });
$parcel$export($3c07d1cf2c1785b9$exports, "Cloud", function () { return $3c07d1cf2c1785b9$export$e2767e27b246eae1; }, function (v) { return $3c07d1cf2c1785b9$export$e2767e27b246eae1 = v; });
var $3c07d1cf2c1785b9$export$1e511d4a378977f5;
var $3c07d1cf2c1785b9$export$e2767e27b246eae1;
"use strict";
$3c07d1cf2c1785b9$export$1e511d4a378977f5 = true;
$3c07d1cf2c1785b9$export$e2767e27b246eae1 = void 0;

var $3c07d1cf2c1785b9$var$_react = $3c07d1cf2c1785b9$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $3c07d1cf2c1785b9$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3c07d1cf2c1785b9$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3c07d1cf2c1785b9$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3c07d1cf2c1785b9$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3c07d1cf2c1785b9$var$_extends() {
    return $3c07d1cf2c1785b9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3c07d1cf2c1785b9$var$_extends.apply(null, arguments);
}
var $3c07d1cf2c1785b9$var$Cloud = $3c07d1cf2c1785b9$export$e2767e27b246eae1 = /*#__PURE__*/ (0, $3c07d1cf2c1785b9$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3c07d1cf2c1785b9$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3c07d1cf2c1785b9$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Cloud"
    }, props), /*#__PURE__*/ $3c07d1cf2c1785b9$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M18 17v1c0 3-2 4-5 4h-2c-3 0-5-1-5-4v-1A5 5 0 0 1 6 7h6M6 7V6c0-3 2-4 5-4h2c3 0 5 1 5 4v1a5 5 0 0 1 0 10h-6"
    }));
});
$3c07d1cf2c1785b9$var$Cloud.displayName = 'Cloud';


Object.keys($3c07d1cf2c1785b9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3c07d1cf2c1785b9$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3c07d1cf2c1785b9$exports[key];
});
var $720c33a5491868fa$exports = {};

$parcel$export($720c33a5491868fa$exports, "__esModule", function () { return $720c33a5491868fa$export$1e511d4a378977f5; }, function (v) { return $720c33a5491868fa$export$1e511d4a378977f5 = v; });
$parcel$export($720c33a5491868fa$exports, "Cloudlinux", function () { return $720c33a5491868fa$export$d3cf3bd2608e5ac6; }, function (v) { return $720c33a5491868fa$export$d3cf3bd2608e5ac6 = v; });
var $720c33a5491868fa$export$1e511d4a378977f5;
var $720c33a5491868fa$export$d3cf3bd2608e5ac6;
"use strict";
$720c33a5491868fa$export$1e511d4a378977f5 = true;
$720c33a5491868fa$export$d3cf3bd2608e5ac6 = void 0;

var $720c33a5491868fa$var$_react = $720c33a5491868fa$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $720c33a5491868fa$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($720c33a5491868fa$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $720c33a5491868fa$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $720c33a5491868fa$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $720c33a5491868fa$var$_extends() {
    return $720c33a5491868fa$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $720c33a5491868fa$var$_extends.apply(null, arguments);
}
var $720c33a5491868fa$var$Cloudlinux = $720c33a5491868fa$export$d3cf3bd2608e5ac6 = /*#__PURE__*/ (0, $720c33a5491868fa$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $720c33a5491868fa$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $720c33a5491868fa$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Cloudlinux"
    }, props), /*#__PURE__*/ $720c33a5491868fa$var$_react["default"].createElement("path", {
        fill: "#5875B8",
        fillRule: "evenodd",
        d: "M14.068 5.79c.05.046.095.092.142.139.314.323.609.674.881 1.055l.001.001c.266.381.51.792.744 1.234.046-1.496-.243-2.81-.914-4.036-.307-.563-.618-1.141-1.14-1.532-.749-.562-1.596-.944-2.502-1.185a8.126 8.126 0 0 0-1.242-.229C6.917.809 3.77 2.365 2.093 5.477c.188.05.268-.111.376-.198 3.53-2.871 8.406-2.579 11.539.451l.06.06zm-3.528 10.9c-.575-.335-1.099-.74-1.638-1.185.545 1.559 2.637 3.432 4.421 3.92-.073-.06-.14-.127-.22-.178-.908-.585-1.654-1.338-2.29-2.206-.087-.12-.153-.282-.273-.351zM23.593 9.6c.015-.065.018-.123-.068-.137l-.013.138-.028.327a8.633 8.633 0 0 1-10.866 7.614c-.174-.047-.346-.097-.519-.145 1.151 1.294 2.568 2.07 4.244 2.387.563.106 1.108.09 1.662-.06 2.074-.567 3.706-1.75 4.812-3.583 1.235-2.048 1.52-4.243.776-6.542zM14.47 20.53c-2.821-.515-4.856-2.149-6.25-4.638a7.351 7.351 0 0 0 1.16 4.367c.256.403.498.832.908 1.1 2.679 1.743 5.467 1.921 8.32.483 1.49-.75 2.59-1.927 3.324-3.44-2.166 1.853-4.644 2.641-7.462 2.128zM9.766.5c5.73.51 9.29 5.722 7.69 11.262-.018.063-.062.127.047.168 1.308-1.283 2.121-2.818 2.357-4.65a2.62 2.62 0 0 0-.04-.935C19.26 3.91 17.88 2.08 15.678.922c-1.922-1.01-3.952-1.2-6.038-.523-.065-.012-.127-.017-.137.074l.141.013c.04.006.081.012.122.016zm6.969 11.226-.002-.038-.002-.016-.006.016.01.038zm3.816-2.163c-.515 2.819-2.154 4.848-4.747 6.253 1.576.038 2.942-.281 4.202-1.015.508-.295 1.037-.583 1.382-1.076 2.771-3.958 1.356-9.512-2.99-11.658 1.876 2.169 2.671 4.661 2.153 7.496zm-1.094 1.196a.248.248 0 0 0-.155.105 8.36 8.36 0 0 1-2.433 2.46.53.53 0 0 0-.174.169c-.315.577-.731 1.082-1.121 1.608 1.866-.936 3.163-2.38 3.883-4.342zM16.36 5.667c-.117.098-.041.179-.024.247.235.94.335 1.904.153 2.844-.196 1.014.162 1.945.242 2.915.247-.55.329-1.137.388-1.727.15-1.492-.115-2.912-.76-4.279zm-1.836 10.702a.692.692 0 0 0-.323.01c-.58.156-1.176.228-1.772.293-.036-.017-.077-.03-.086.021-.003.014.052.037.08.056 1.993.643 3.93.468 5.854-.37-.053-.036-.073-.061-.096-.063a.378.378 0 0 0-.121.01 8.324 8.324 0 0 1-3.536.043zm-5.65-.855a2.158 2.158 0 0 1-.034-.02c.009.01.018.017.028.026l.006-.006zm-.486-6.56c.037-.014.076-.034.046-.077-.008-.01-.063.011-.097.018a.41.41 0 0 0 .05.058zM5.496 21.848c.034.056.073.1.143.048l-.087-.106a.448.448 0 0 0-.056.058zM10.65 4.51c.967.61 1.825 1.352 2.447 2.307.347.534.73.595 1.3.4-1.003-1.293-2.218-2.219-3.747-2.707zM8.337 8.895c-1.863.954-3.11 2.448-3.877 4.4.063-.011.095-.008.112-.023a.38.38 0 0 0 .079-.093 8.322 8.322 0 0 1 2.47-2.53.69.69 0 0 0 .221-.235c.3-.521.67-.993 1.046-1.46a.41.41 0 0 1-.05-.059zM7.6 18.103a.25.25 0 0 0 .036-.184 8.364 8.364 0 0 1-.02-3.46.53.53 0 0 0 .004-.242c-.186-.63-.248-1.282-.345-1.93-.658 1.982-.554 3.92.325 5.816zM6.09 7.61c1.056-.229 2.117-.224 3.18-.06.147.024.308.091.441.056.644-.17 1.3-.255 1.997-.32-1.488-.718-4.292-.563-5.898.354.094-.01.19-.01.28-.03zm-.538 14.18-.212-.25a8.633 8.633 0 0 1 2.3-13.068c.155-.09.313-.176.47-.264-1.73-.101-3.281.352-4.69 1.313-.472.323-.847.72-1.132 1.218-1.066 1.867-1.384 3.857-.87 5.936.576 2.321 1.926 4.074 4.078 5.174a.448.448 0 0 1 .056-.058zm2.119-2.068c-1.63-2.357-1.906-4.951-1.065-7.779-1.141 1.09-1.881 2.28-2.254 3.69-.15.568-.321 1.145-.216 1.738.839 4.759 5.767 7.686 10.357 6.13-2.86-.208-5.184-1.408-6.822-3.779zM.445 14.447C-.105 12.86-.16 11.25.363 9.664c1-3.033 3.098-4.879 6.225-5.54.479-.101.954.032 1.419.136a7.355 7.355 0 0 1 3.908 2.267c-2.745-.774-5.34-.49-7.697 1.14-2.356 1.63-3.551 3.94-3.773 6.78z"
    }));
});
$720c33a5491868fa$var$Cloudlinux.displayName = 'Cloudlinux';


Object.keys($720c33a5491868fa$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $720c33a5491868fa$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $720c33a5491868fa$exports[key];
});
var $99d427c1057b095a$exports = {};

$parcel$export($99d427c1057b095a$exports, "__esModule", function () { return $99d427c1057b095a$export$1e511d4a378977f5; }, function (v) { return $99d427c1057b095a$export$1e511d4a378977f5 = v; });
$parcel$export($99d427c1057b095a$exports, "Cluster", function () { return $99d427c1057b095a$export$57ed47926628b770; }, function (v) { return $99d427c1057b095a$export$57ed47926628b770 = v; });
var $99d427c1057b095a$export$1e511d4a378977f5;
var $99d427c1057b095a$export$57ed47926628b770;
"use strict";
$99d427c1057b095a$export$1e511d4a378977f5 = true;
$99d427c1057b095a$export$57ed47926628b770 = void 0;

var $99d427c1057b095a$var$_react = $99d427c1057b095a$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $99d427c1057b095a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($99d427c1057b095a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $99d427c1057b095a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $99d427c1057b095a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $99d427c1057b095a$var$_extends() {
    return $99d427c1057b095a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $99d427c1057b095a$var$_extends.apply(null, arguments);
}
var $99d427c1057b095a$var$Cluster = $99d427c1057b095a$export$57ed47926628b770 = /*#__PURE__*/ (0, $99d427c1057b095a$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $99d427c1057b095a$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $99d427c1057b095a$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Cluster"
    }, props), /*#__PURE__*/ $99d427c1057b095a$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8 9h8V1H8v8zM1 23h8v-8H1v8zm14 0h8v-8h-8v8zM5 15l3-6-3 6zm5 4h4-4zm6-10 3 6-3-6z"
    }));
});
$99d427c1057b095a$var$Cluster.displayName = 'Cluster';


Object.keys($99d427c1057b095a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $99d427c1057b095a$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $99d427c1057b095a$exports[key];
});
var $7ad9d7ad5a9c5c41$exports = {};

$parcel$export($7ad9d7ad5a9c5c41$exports, "__esModule", function () { return $7ad9d7ad5a9c5c41$export$1e511d4a378977f5; }, function (v) { return $7ad9d7ad5a9c5c41$export$1e511d4a378977f5 = v; });
$parcel$export($7ad9d7ad5a9c5c41$exports, "CoatCheck", function () { return $7ad9d7ad5a9c5c41$export$9c062585b6b9d5f3; }, function (v) { return $7ad9d7ad5a9c5c41$export$9c062585b6b9d5f3 = v; });
var $7ad9d7ad5a9c5c41$export$1e511d4a378977f5;
var $7ad9d7ad5a9c5c41$export$9c062585b6b9d5f3;
"use strict";
$7ad9d7ad5a9c5c41$export$1e511d4a378977f5 = true;
$7ad9d7ad5a9c5c41$export$9c062585b6b9d5f3 = void 0;

var $7ad9d7ad5a9c5c41$var$_react = $7ad9d7ad5a9c5c41$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $7ad9d7ad5a9c5c41$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7ad9d7ad5a9c5c41$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7ad9d7ad5a9c5c41$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $7ad9d7ad5a9c5c41$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7ad9d7ad5a9c5c41$var$_extends() {
    return $7ad9d7ad5a9c5c41$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7ad9d7ad5a9c5c41$var$_extends.apply(null, arguments);
}
var $7ad9d7ad5a9c5c41$var$CoatCheck = $7ad9d7ad5a9c5c41$export$9c062585b6b9d5f3 = /*#__PURE__*/ (0, $7ad9d7ad5a9c5c41$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $7ad9d7ad5a9c5c41$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $7ad9d7ad5a9c5c41$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CoatCheck"
    }, props), /*#__PURE__*/ $7ad9d7ad5a9c5c41$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m12 11 10.155 6.462c.467.297.845.981.845 1.547v1.982A1 1 0 0 1 21.998 22H2.002A1 1 0 0 1 1 20.99v-1.98c0-.558.379-1.251.845-1.548L12 11zm3-6a3 3 0 0 0-6 0c0 .932.411 1.802 1.09 2.314C11 8 12 8 12 9.5V11"
    }));
});
$7ad9d7ad5a9c5c41$var$CoatCheck.displayName = 'CoatCheck';


Object.keys($7ad9d7ad5a9c5c41$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $7ad9d7ad5a9c5c41$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $7ad9d7ad5a9c5c41$exports[key];
});
var $68e2f4c0d4a7a98a$exports = {};

$parcel$export($68e2f4c0d4a7a98a$exports, "__esModule", function () { return $68e2f4c0d4a7a98a$export$1e511d4a378977f5; }, function (v) { return $68e2f4c0d4a7a98a$export$1e511d4a378977f5 = v; });
$parcel$export($68e2f4c0d4a7a98a$exports, "CodeSandbox", function () { return $68e2f4c0d4a7a98a$export$bb05fd8460a29549; }, function (v) { return $68e2f4c0d4a7a98a$export$bb05fd8460a29549 = v; });
var $68e2f4c0d4a7a98a$export$1e511d4a378977f5;
var $68e2f4c0d4a7a98a$export$bb05fd8460a29549;
"use strict";
$68e2f4c0d4a7a98a$export$1e511d4a378977f5 = true;
$68e2f4c0d4a7a98a$export$bb05fd8460a29549 = void 0;

var $68e2f4c0d4a7a98a$var$_react = $68e2f4c0d4a7a98a$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $68e2f4c0d4a7a98a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($68e2f4c0d4a7a98a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $68e2f4c0d4a7a98a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $68e2f4c0d4a7a98a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $68e2f4c0d4a7a98a$var$_extends() {
    return $68e2f4c0d4a7a98a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $68e2f4c0d4a7a98a$var$_extends.apply(null, arguments);
}
var $68e2f4c0d4a7a98a$var$CodeSandbox = $68e2f4c0d4a7a98a$export$bb05fd8460a29549 = /*#__PURE__*/ (0, $68e2f4c0d4a7a98a$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $68e2f4c0d4a7a98a$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $68e2f4c0d4a7a98a$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CodeSandbox"
    }, props), /*#__PURE__*/ $68e2f4c0d4a7a98a$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#444",
        strokeWidth: "2",
        d: "m12 1.5-9 5v11l9 5 9-5v-11l-9-5zm0 21v-11m9-5-9 5m0 0-9-5m18 11V12l-4.5 2.5V20l4.5-2.5zm-18 0V12l4.5 2.5V20L3 17.5zm9-16L7.5 4 12 6.5 16.5 4 12 1.5z"
    }));
});
$68e2f4c0d4a7a98a$var$CodeSandbox.displayName = 'CodeSandbox';


Object.keys($68e2f4c0d4a7a98a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $68e2f4c0d4a7a98a$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $68e2f4c0d4a7a98a$exports[key];
});
var $c3ef73694a0c6ec7$exports = {};

$parcel$export($c3ef73694a0c6ec7$exports, "__esModule", function () { return $c3ef73694a0c6ec7$export$1e511d4a378977f5; }, function (v) { return $c3ef73694a0c6ec7$export$1e511d4a378977f5 = v; });
$parcel$export($c3ef73694a0c6ec7$exports, "Code", function () { return $c3ef73694a0c6ec7$export$52f0f02147b12c03; }, function (v) { return $c3ef73694a0c6ec7$export$52f0f02147b12c03 = v; });
var $c3ef73694a0c6ec7$export$1e511d4a378977f5;
var $c3ef73694a0c6ec7$export$52f0f02147b12c03;
"use strict";
$c3ef73694a0c6ec7$export$1e511d4a378977f5 = true;
$c3ef73694a0c6ec7$export$52f0f02147b12c03 = void 0;

var $c3ef73694a0c6ec7$var$_react = $c3ef73694a0c6ec7$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c3ef73694a0c6ec7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c3ef73694a0c6ec7$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c3ef73694a0c6ec7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c3ef73694a0c6ec7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c3ef73694a0c6ec7$var$_extends() {
    return $c3ef73694a0c6ec7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c3ef73694a0c6ec7$var$_extends.apply(null, arguments);
}
var $c3ef73694a0c6ec7$var$Code = $c3ef73694a0c6ec7$export$52f0f02147b12c03 = /*#__PURE__*/ (0, $c3ef73694a0c6ec7$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c3ef73694a0c6ec7$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c3ef73694a0c6ec7$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Code"
    }, props), /*#__PURE__*/ $c3ef73694a0c6ec7$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m9 22 6-20m2 15 5-5-5-5M7 17l-5-5 5-5"
    }));
});
$c3ef73694a0c6ec7$var$Code.displayName = 'Code';


Object.keys($c3ef73694a0c6ec7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c3ef73694a0c6ec7$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c3ef73694a0c6ec7$exports[key];
});
var $ba78f0cb5cd6d030$exports = {};

$parcel$export($ba78f0cb5cd6d030$exports, "__esModule", function () { return $ba78f0cb5cd6d030$export$1e511d4a378977f5; }, function (v) { return $ba78f0cb5cd6d030$export$1e511d4a378977f5 = v; });
$parcel$export($ba78f0cb5cd6d030$exports, "Codepen", function () { return $ba78f0cb5cd6d030$export$c2881c60c2d7c6cc; }, function (v) { return $ba78f0cb5cd6d030$export$c2881c60c2d7c6cc = v; });
var $ba78f0cb5cd6d030$export$1e511d4a378977f5;
var $ba78f0cb5cd6d030$export$c2881c60c2d7c6cc;
"use strict";
$ba78f0cb5cd6d030$export$1e511d4a378977f5 = true;
$ba78f0cb5cd6d030$export$c2881c60c2d7c6cc = void 0;

var $ba78f0cb5cd6d030$var$_react = $ba78f0cb5cd6d030$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $ba78f0cb5cd6d030$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ba78f0cb5cd6d030$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ba78f0cb5cd6d030$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ba78f0cb5cd6d030$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ba78f0cb5cd6d030$var$_extends() {
    return $ba78f0cb5cd6d030$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ba78f0cb5cd6d030$var$_extends.apply(null, arguments);
}
var $ba78f0cb5cd6d030$var$Codepen = $ba78f0cb5cd6d030$export$c2881c60c2d7c6cc = /*#__PURE__*/ (0, $ba78f0cb5cd6d030$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $ba78f0cb5cd6d030$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ba78f0cb5cd6d030$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Codepen"
    }, props), /*#__PURE__*/ $ba78f0cb5cd6d030$var$_react["default"].createElement("path", {
        fill: "#333",
        fillRule: "evenodd",
        d: "M12 22.03c-5.53 0-10.03-4.5-10.03-10.03C1.97 6.47 6.47 1.97 12 1.97c5.53 0 10.03 4.5 10.03 10.03 0 5.53-4.5 10.03-10.03 10.03M12 0C5.372 0 0 5.373 0 12c0 6.628 5.372 12 12 12s12-5.372 12-12c0-6.627-5.372-12-12-12m6.144 13.067L16.55 12l1.595-1.067v2.134zm-5.506 4.524v-2.975l2.764-1.849 2.232 1.493-4.996 3.33zM12 13.509 9.745 12 12 10.492 14.255 12 12 13.51zm-.638 4.082L6.366 14.26l2.232-1.493 2.764 1.85v2.974zm-5.506-6.658L7.45 12l-1.595 1.067v-2.134zm5.506-4.523v2.974l-2.764 1.85L6.366 9.74l4.996-3.33zm1.276 0 4.996 3.33-2.232 1.493-2.764-1.85V6.41zm6.776 3.246-.005-.027a.624.624 0 0 0-.011-.054l-.01-.03a.617.617 0 0 0-.052-.12l-.019-.03a.568.568 0 0 0-.08-.101l-.026-.025a.728.728 0 0 0-.036-.03l-.029-.022-.01-.008-6.782-4.521a.637.637 0 0 0-.708 0l-6.782 4.52-.01.009-.03.022a.578.578 0 0 0-.035.03c-.01.008-.017.016-.026.025a.553.553 0 0 0-.099.13.594.594 0 0 0-.021.043l-.014.03c-.007.016-.012.032-.017.047l-.01.031c-.004.018-.008.036-.01.054l-.006.027a.613.613 0 0 0-.006.083v4.522a.57.57 0 0 0 .006.083l.005.028.011.053.01.031c.005.016.01.031.017.047l.014.03a.755.755 0 0 0 .067.111.422.422 0 0 0 .053.062l.026.025a.545.545 0 0 0 .065.052l.01.008 6.782 4.522a.637.637 0 0 0 .708 0l6.782-4.522.01-.008a.711.711 0 0 0 .065-.052c.01-.008.017-.016.026-.025a.611.611 0 0 0 .032-.034l.021-.028a.568.568 0 0 0 .027-.039l.019-.029a.574.574 0 0 0 .021-.042l.014-.031a.443.443 0 0 0 .017-.047l.01-.03a.628.628 0 0 0 .01-.054l.006-.028a.66.66 0 0 0 .006-.083V9.739a.648.648 0 0 0-.006-.083z"
    }));
});
$ba78f0cb5cd6d030$var$Codepen.displayName = 'Codepen';


Object.keys($ba78f0cb5cd6d030$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ba78f0cb5cd6d030$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ba78f0cb5cd6d030$exports[key];
});
var $7c3d779e31603e19$exports = {};

$parcel$export($7c3d779e31603e19$exports, "__esModule", function () { return $7c3d779e31603e19$export$1e511d4a378977f5; }, function (v) { return $7c3d779e31603e19$export$1e511d4a378977f5 = v; });
$parcel$export($7c3d779e31603e19$exports, "Coffee", function () { return $7c3d779e31603e19$export$d350a92ac3718aff; }, function (v) { return $7c3d779e31603e19$export$d350a92ac3718aff = v; });
var $7c3d779e31603e19$export$1e511d4a378977f5;
var $7c3d779e31603e19$export$d350a92ac3718aff;
"use strict";
$7c3d779e31603e19$export$1e511d4a378977f5 = true;
$7c3d779e31603e19$export$d350a92ac3718aff = void 0;

var $7c3d779e31603e19$var$_react = $7c3d779e31603e19$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $7c3d779e31603e19$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7c3d779e31603e19$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7c3d779e31603e19$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $7c3d779e31603e19$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7c3d779e31603e19$var$_extends() {
    return $7c3d779e31603e19$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7c3d779e31603e19$var$_extends.apply(null, arguments);
}
var $7c3d779e31603e19$var$Coffee = $7c3d779e31603e19$export$d350a92ac3718aff = /*#__PURE__*/ (0, $7c3d779e31603e19$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $7c3d779e31603e19$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $7c3d779e31603e19$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Coffee"
    }, props), /*#__PURE__*/ $7c3d779e31603e19$var$_react["default"].createElement("g", {
        fill: "none"
    }, /*#__PURE__*/ $7c3d779e31603e19$var$_react["default"].createElement("path", {
        stroke: "#000",
        strokeWidth: "2",
        d: "M6.264 20.192c4.096 2.868 8.602-.081 11.47-4.177 2.868-4.095 4.097-9.338.002-12.206-4.096-2.868-8.602.08-11.47 4.176-2.868 4.096-4.098 9.339-.002 12.207z"
    }), /*#__PURE__*/ $7c3d779e31603e19$var$_react["default"].createElement("path", {
        fill: "#000",
        d: "M16.589 5.447c-1.393.246-5.326 2.375-5.408 5.98-.083 3.604-2.787 6.594-3.77 7.126 1.803.042 5.326-2.375 5.408-5.98.083-3.604 2.786-6.594 3.77-7.126z"
    })));
});
$7c3d779e31603e19$var$Coffee.displayName = 'Coffee';


Object.keys($7c3d779e31603e19$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $7c3d779e31603e19$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $7c3d779e31603e19$exports[key];
});
var $a45215fb192ac329$exports = {};

$parcel$export($a45215fb192ac329$exports, "__esModule", function () { return $a45215fb192ac329$export$1e511d4a378977f5; }, function (v) { return $a45215fb192ac329$export$1e511d4a378977f5 = v; });
$parcel$export($a45215fb192ac329$exports, "Columns", function () { return $a45215fb192ac329$export$f02cc02ad0e0bba3; }, function (v) { return $a45215fb192ac329$export$f02cc02ad0e0bba3 = v; });
var $a45215fb192ac329$export$1e511d4a378977f5;
var $a45215fb192ac329$export$f02cc02ad0e0bba3;
"use strict";
$a45215fb192ac329$export$1e511d4a378977f5 = true;
$a45215fb192ac329$export$f02cc02ad0e0bba3 = void 0;

var $a45215fb192ac329$var$_react = $a45215fb192ac329$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a45215fb192ac329$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a45215fb192ac329$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a45215fb192ac329$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a45215fb192ac329$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a45215fb192ac329$var$_extends() {
    return $a45215fb192ac329$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a45215fb192ac329$var$_extends.apply(null, arguments);
}
var $a45215fb192ac329$var$Columns = $a45215fb192ac329$export$f02cc02ad0e0bba3 = /*#__PURE__*/ (0, $a45215fb192ac329$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a45215fb192ac329$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a45215fb192ac329$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Columns"
    }, props), /*#__PURE__*/ $a45215fb192ac329$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M17 2v20V2zm-5 0v20V2zM7 2v20V2zM2 22h20V2H2v20z"
    }));
});
$a45215fb192ac329$var$Columns.displayName = 'Columns';


Object.keys($a45215fb192ac329$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a45215fb192ac329$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a45215fb192ac329$exports[key];
});
var $ae33daacecff5e2e$exports = {};

$parcel$export($ae33daacecff5e2e$exports, "__esModule", function () { return $ae33daacecff5e2e$export$1e511d4a378977f5; }, function (v) { return $ae33daacecff5e2e$export$1e511d4a378977f5 = v; });
$parcel$export($ae33daacecff5e2e$exports, "Command", function () { return $ae33daacecff5e2e$export$cc7e12c76513e857; }, function (v) { return $ae33daacecff5e2e$export$cc7e12c76513e857 = v; });
var $ae33daacecff5e2e$export$1e511d4a378977f5;
var $ae33daacecff5e2e$export$cc7e12c76513e857;
"use strict";
$ae33daacecff5e2e$export$1e511d4a378977f5 = true;
$ae33daacecff5e2e$export$cc7e12c76513e857 = void 0;

var $ae33daacecff5e2e$var$_react = $ae33daacecff5e2e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $ae33daacecff5e2e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ae33daacecff5e2e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ae33daacecff5e2e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ae33daacecff5e2e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ae33daacecff5e2e$var$_extends() {
    return $ae33daacecff5e2e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ae33daacecff5e2e$var$_extends.apply(null, arguments);
}
var $ae33daacecff5e2e$var$Command = $ae33daacecff5e2e$export$cc7e12c76513e857 = /*#__PURE__*/ (0, $ae33daacecff5e2e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $ae33daacecff5e2e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ae33daacecff5e2e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Command"
    }, props), /*#__PURE__*/ $ae33daacecff5e2e$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 9H5.5C3.5 9 2 7.5 2 5.5S3.5 2 5.5 2 9 3.5 9 5.5v13c0 2-1.5 3.5-3.5 3.5S2 20.5 2 18.5 3.5 15 5.5 15h13c2 0 3.5 1.5 3.5 3.5S20.5 22 18.5 22 15 20.5 15 18.5v-13c0-2 1.5-3.5 3.5-3.5S22 3.5 22 5.5 20.5 9 18.5 9H12z"
    }));
});
$ae33daacecff5e2e$var$Command.displayName = 'Command';


Object.keys($ae33daacecff5e2e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ae33daacecff5e2e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ae33daacecff5e2e$exports[key];
});
var $e17d7f2c43a06d2c$exports = {};

$parcel$export($e17d7f2c43a06d2c$exports, "__esModule", function () { return $e17d7f2c43a06d2c$export$1e511d4a378977f5; }, function (v) { return $e17d7f2c43a06d2c$export$1e511d4a378977f5 = v; });
$parcel$export($e17d7f2c43a06d2c$exports, "Compare", function () { return $e17d7f2c43a06d2c$export$2c1d9c1fe3e6577a; }, function (v) { return $e17d7f2c43a06d2c$export$2c1d9c1fe3e6577a = v; });
var $e17d7f2c43a06d2c$export$1e511d4a378977f5;
var $e17d7f2c43a06d2c$export$2c1d9c1fe3e6577a;
"use strict";
$e17d7f2c43a06d2c$export$1e511d4a378977f5 = true;
$e17d7f2c43a06d2c$export$2c1d9c1fe3e6577a = void 0;

var $e17d7f2c43a06d2c$var$_react = $e17d7f2c43a06d2c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e17d7f2c43a06d2c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e17d7f2c43a06d2c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e17d7f2c43a06d2c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e17d7f2c43a06d2c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e17d7f2c43a06d2c$var$_extends() {
    return $e17d7f2c43a06d2c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e17d7f2c43a06d2c$var$_extends.apply(null, arguments);
}
var $e17d7f2c43a06d2c$var$Compare = $e17d7f2c43a06d2c$export$2c1d9c1fe3e6577a = /*#__PURE__*/ (0, $e17d7f2c43a06d2c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e17d7f2c43a06d2c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e17d7f2c43a06d2c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Compare"
    }, props), /*#__PURE__*/ $e17d7f2c43a06d2c$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M11 7H1v10h6V8m4-3v4l2-2-2-2zm0 12 2 2v-4l-2 2zm2 0h10V7h-6v9"
    }));
});
$e17d7f2c43a06d2c$var$Compare.displayName = 'Compare';


Object.keys($e17d7f2c43a06d2c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e17d7f2c43a06d2c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e17d7f2c43a06d2c$exports[key];
});
var $27256482bf911740$exports = {};

$parcel$export($27256482bf911740$exports, "__esModule", function () { return $27256482bf911740$export$1e511d4a378977f5; }, function (v) { return $27256482bf911740$export$1e511d4a378977f5 = v; });
$parcel$export($27256482bf911740$exports, "Compass", function () { return $27256482bf911740$export$87ae43576cc53e22; }, function (v) { return $27256482bf911740$export$87ae43576cc53e22 = v; });
var $27256482bf911740$export$1e511d4a378977f5;
var $27256482bf911740$export$87ae43576cc53e22;
"use strict";
$27256482bf911740$export$1e511d4a378977f5 = true;
$27256482bf911740$export$87ae43576cc53e22 = void 0;

var $27256482bf911740$var$_react = $27256482bf911740$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $27256482bf911740$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($27256482bf911740$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $27256482bf911740$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $27256482bf911740$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $27256482bf911740$var$_extends() {
    return $27256482bf911740$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $27256482bf911740$var$_extends.apply(null, arguments);
}
var $27256482bf911740$var$Compass = $27256482bf911740$export$87ae43576cc53e22 = /*#__PURE__*/ (0, $27256482bf911740$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $27256482bf911740$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $27256482bf911740$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Compass"
    }, props), /*#__PURE__*/ $27256482bf911740$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-2-12 5-1-1 5-5 1 1-5zm2 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
    }));
});
$27256482bf911740$var$Compass.displayName = 'Compass';


Object.keys($27256482bf911740$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $27256482bf911740$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $27256482bf911740$exports[key];
});
var $c0fb64bc12487147$exports = {};

$parcel$export($c0fb64bc12487147$exports, "__esModule", function () { return $c0fb64bc12487147$export$1e511d4a378977f5; }, function (v) { return $c0fb64bc12487147$export$1e511d4a378977f5 = v; });
$parcel$export($c0fb64bc12487147$exports, "Compliance", function () { return $c0fb64bc12487147$export$1e0368964bf0f7b0; }, function (v) { return $c0fb64bc12487147$export$1e0368964bf0f7b0 = v; });
var $c0fb64bc12487147$export$1e511d4a378977f5;
var $c0fb64bc12487147$export$1e0368964bf0f7b0;
"use strict";
$c0fb64bc12487147$export$1e511d4a378977f5 = true;
$c0fb64bc12487147$export$1e0368964bf0f7b0 = void 0;

var $c0fb64bc12487147$var$_react = $c0fb64bc12487147$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c0fb64bc12487147$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c0fb64bc12487147$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c0fb64bc12487147$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c0fb64bc12487147$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c0fb64bc12487147$var$_extends() {
    return $c0fb64bc12487147$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c0fb64bc12487147$var$_extends.apply(null, arguments);
}
var $c0fb64bc12487147$var$Compliance = $c0fb64bc12487147$export$1e0368964bf0f7b0 = /*#__PURE__*/ (0, $c0fb64bc12487147$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c0fb64bc12487147$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c0fb64bc12487147$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Compliance"
    }, props), /*#__PURE__*/ $c0fb64bc12487147$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#231F20",
        strokeWidth: "2",
        d: "M8 6h8V1H8v5zm8-3h5v20H3V3h5m0 11 3 3 6-6"
    }));
});
$c0fb64bc12487147$var$Compliance.displayName = 'Compliance';


Object.keys($c0fb64bc12487147$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c0fb64bc12487147$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c0fb64bc12487147$exports[key];
});
var $8ad9448510a7e5cb$exports = {};

$parcel$export($8ad9448510a7e5cb$exports, "__esModule", function () { return $8ad9448510a7e5cb$export$1e511d4a378977f5; }, function (v) { return $8ad9448510a7e5cb$export$1e511d4a378977f5 = v; });
$parcel$export($8ad9448510a7e5cb$exports, "Configure", function () { return $8ad9448510a7e5cb$export$de5f40ff1ff419d2; }, function (v) { return $8ad9448510a7e5cb$export$de5f40ff1ff419d2 = v; });
var $8ad9448510a7e5cb$export$1e511d4a378977f5;
var $8ad9448510a7e5cb$export$de5f40ff1ff419d2;
"use strict";
$8ad9448510a7e5cb$export$1e511d4a378977f5 = true;
$8ad9448510a7e5cb$export$de5f40ff1ff419d2 = void 0;

var $8ad9448510a7e5cb$var$_react = $8ad9448510a7e5cb$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $8ad9448510a7e5cb$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8ad9448510a7e5cb$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8ad9448510a7e5cb$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $8ad9448510a7e5cb$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8ad9448510a7e5cb$var$_extends() {
    return $8ad9448510a7e5cb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8ad9448510a7e5cb$var$_extends.apply(null, arguments);
}
var $8ad9448510a7e5cb$var$Configure = $8ad9448510a7e5cb$export$de5f40ff1ff419d2 = /*#__PURE__*/ (0, $8ad9448510a7e5cb$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $8ad9448510a7e5cb$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $8ad9448510a7e5cb$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Configure"
    }, props), /*#__PURE__*/ $8ad9448510a7e5cb$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M16 15c4.009-.065 7-3.033 7-7 0-3.012-.997-2.015-2-1-.991.98-3 3-3 3l-4-4s2.02-2.009 3-3c1.015-1.003 1.015-2-1-2-3.967 0-6.947 2.991-7 7 .042.976 0 3 0 3-1.885 1.897-4.34 4.353-6 6-2.932 2.944 1.056 6.932 4 4 1.65-1.662 4.113-4.125 6-6 0 0 2.024-.042 3 0z"
    }));
});
$8ad9448510a7e5cb$var$Configure.displayName = 'Configure';


Object.keys($8ad9448510a7e5cb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $8ad9448510a7e5cb$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $8ad9448510a7e5cb$exports[key];
});
var $d682f897bbc148ac$exports = {};

$parcel$export($d682f897bbc148ac$exports, "__esModule", function () { return $d682f897bbc148ac$export$1e511d4a378977f5; }, function (v) { return $d682f897bbc148ac$export$1e511d4a378977f5 = v; });
$parcel$export($d682f897bbc148ac$exports, "Connect", function () { return $d682f897bbc148ac$export$59e6910693f047c2; }, function (v) { return $d682f897bbc148ac$export$59e6910693f047c2 = v; });
var $d682f897bbc148ac$export$1e511d4a378977f5;
var $d682f897bbc148ac$export$59e6910693f047c2;
"use strict";
$d682f897bbc148ac$export$1e511d4a378977f5 = true;
$d682f897bbc148ac$export$59e6910693f047c2 = void 0;

var $d682f897bbc148ac$var$_react = $d682f897bbc148ac$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $d682f897bbc148ac$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d682f897bbc148ac$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d682f897bbc148ac$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d682f897bbc148ac$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d682f897bbc148ac$var$_extends() {
    return $d682f897bbc148ac$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d682f897bbc148ac$var$_extends.apply(null, arguments);
}
var $d682f897bbc148ac$var$Connect = $d682f897bbc148ac$export$59e6910693f047c2 = /*#__PURE__*/ (0, $d682f897bbc148ac$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d682f897bbc148ac$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $d682f897bbc148ac$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Connect"
    }, props), /*#__PURE__*/ $d682f897bbc148ac$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M10 21c-2.5 2.5-5 2-7 0s-2.5-4.5 0-7l3-3 7 7-3 3zm4-18c2.5-2.5 5-2 7.001 0 2.001 2 2.499 4.5 0 7l-3 3L11 6l3-3zm-3 7-2.5 2.5L11 10zm3 3-2.5 2.5L14 13z"
    }));
});
$d682f897bbc148ac$var$Connect.displayName = 'Connect';


Object.keys($d682f897bbc148ac$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $d682f897bbc148ac$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $d682f897bbc148ac$exports[key];
});
var $48bcfc72362975a7$exports = {};

$parcel$export($48bcfc72362975a7$exports, "__esModule", function () { return $48bcfc72362975a7$export$1e511d4a378977f5; }, function (v) { return $48bcfc72362975a7$export$1e511d4a378977f5 = v; });
$parcel$export($48bcfc72362975a7$exports, "Connectivity", function () { return $48bcfc72362975a7$export$a419a7104f53b1d9; }, function (v) { return $48bcfc72362975a7$export$a419a7104f53b1d9 = v; });
var $48bcfc72362975a7$export$1e511d4a378977f5;
var $48bcfc72362975a7$export$a419a7104f53b1d9;
"use strict";
$48bcfc72362975a7$export$1e511d4a378977f5 = true;
$48bcfc72362975a7$export$a419a7104f53b1d9 = void 0;

var $48bcfc72362975a7$var$_react = $48bcfc72362975a7$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $48bcfc72362975a7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($48bcfc72362975a7$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $48bcfc72362975a7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $48bcfc72362975a7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $48bcfc72362975a7$var$_extends() {
    return $48bcfc72362975a7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $48bcfc72362975a7$var$_extends.apply(null, arguments);
}
var $48bcfc72362975a7$var$Connectivity = $48bcfc72362975a7$export$a419a7104f53b1d9 = /*#__PURE__*/ (0, $48bcfc72362975a7$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $48bcfc72362975a7$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $48bcfc72362975a7$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Connectivity"
    }, props), /*#__PURE__*/ $48bcfc72362975a7$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M6 8v4l3 3 6-6-4-4H5L2.5 3M17 7l3 3v7m-7-6 3 3m-5-1 3 3m-7 1 3 3h10"
    }));
});
$48bcfc72362975a7$var$Connectivity.displayName = 'Connectivity';


Object.keys($48bcfc72362975a7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $48bcfc72362975a7$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $48bcfc72362975a7$exports[key];
});
var $77330087e7928734$exports = {};

$parcel$export($77330087e7928734$exports, "__esModule", function () { return $77330087e7928734$export$1e511d4a378977f5; }, function (v) { return $77330087e7928734$export$1e511d4a378977f5 = v; });
$parcel$export($77330087e7928734$exports, "Console", function () { return $77330087e7928734$export$8d5400d15923e166; }, function (v) { return $77330087e7928734$export$8d5400d15923e166 = v; });
var $77330087e7928734$export$1e511d4a378977f5;
var $77330087e7928734$export$8d5400d15923e166;
"use strict";
$77330087e7928734$export$1e511d4a378977f5 = true;
$77330087e7928734$export$8d5400d15923e166 = void 0;

var $77330087e7928734$var$_react = $77330087e7928734$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $77330087e7928734$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($77330087e7928734$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $77330087e7928734$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $77330087e7928734$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $77330087e7928734$var$_extends() {
    return $77330087e7928734$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $77330087e7928734$var$_extends.apply(null, arguments);
}
var $77330087e7928734$var$Console = $77330087e7928734$export$8d5400d15923e166 = /*#__PURE__*/ (0, $77330087e7928734$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $77330087e7928734$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $77330087e7928734$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Console"
    }, props), /*#__PURE__*/ $77330087e7928734$var$_react["default"].createElement("path", {
        fill: "#000",
        d: "M16 18a1 1 0 1 0 0-2v2zm-8-2a1 1 0 1 0 0 2v-2zm.707-8.707a1 1 0 1 0-1.414 1.414l1.414-1.414zM11 11l.707.707a1 1 0 0 0 0-1.414L11 11zm-3.707 2.293a1 1 0 1 0 1.414 1.414l-1.414-1.414zM7 4h10V2H7v2zm13 3v10h2V7h-2zm-3 13H7v2h10v-2zM4 17V7H2v10h2zm3 3a3 3 0 0 1-3-3H2a5 5 0 0 0 5 5v-2zm13-3a3 3 0 0 1-3 3v2a5 5 0 0 0 5-5h-2zM17 4a3 3 0 0 1 3 3h2a5 5 0 0 0-5-5v2zM7 2a5 5 0 0 0-5 5h2a3 3 0 0 1 3-3V2zm9 14H8v2h8v-2zM7.293 8.707l3 3 1.414-1.414-3-3-1.414 1.414zm3 1.586-3 3 1.414 1.414 3-3-1.414-1.414z"
    }));
});
$77330087e7928734$var$Console.displayName = 'Console';


Object.keys($77330087e7928734$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $77330087e7928734$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $77330087e7928734$exports[key];
});
var $ceb08e5a5457416a$exports = {};

$parcel$export($ceb08e5a5457416a$exports, "__esModule", function () { return $ceb08e5a5457416a$export$1e511d4a378977f5; }, function (v) { return $ceb08e5a5457416a$export$1e511d4a378977f5 = v; });
$parcel$export($ceb08e5a5457416a$exports, "ContactInfo", function () { return $ceb08e5a5457416a$export$edd98d03726b2474; }, function (v) { return $ceb08e5a5457416a$export$edd98d03726b2474 = v; });
var $ceb08e5a5457416a$export$1e511d4a378977f5;
var $ceb08e5a5457416a$export$edd98d03726b2474;
"use strict";
$ceb08e5a5457416a$export$1e511d4a378977f5 = true;
$ceb08e5a5457416a$export$edd98d03726b2474 = void 0;

var $ceb08e5a5457416a$var$_react = $ceb08e5a5457416a$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $ceb08e5a5457416a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ceb08e5a5457416a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ceb08e5a5457416a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ceb08e5a5457416a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ceb08e5a5457416a$var$_extends() {
    return $ceb08e5a5457416a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ceb08e5a5457416a$var$_extends.apply(null, arguments);
}
var $ceb08e5a5457416a$var$ContactInfo = $ceb08e5a5457416a$export$edd98d03726b2474 = /*#__PURE__*/ (0, $ceb08e5a5457416a$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $ceb08e5a5457416a$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ceb08e5a5457416a$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ContactInfo"
    }, props), /*#__PURE__*/ $ceb08e5a5457416a$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M5 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm4 6v-2c0-2.25-1.787-4-4.036-4h.054C2.768 12 1 13.75 1 16v2M12 7h12M12 17h10m-10-5h7"
    }));
});
$ceb08e5a5457416a$var$ContactInfo.displayName = 'ContactInfo';


Object.keys($ceb08e5a5457416a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ceb08e5a5457416a$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ceb08e5a5457416a$exports[key];
});
var $ceeef7151f62abb6$exports = {};

$parcel$export($ceeef7151f62abb6$exports, "__esModule", function () { return $ceeef7151f62abb6$export$1e511d4a378977f5; }, function (v) { return $ceeef7151f62abb6$export$1e511d4a378977f5 = v; });
$parcel$export($ceeef7151f62abb6$exports, "Contact", function () { return $ceeef7151f62abb6$export$836a6ea60fb78f25; }, function (v) { return $ceeef7151f62abb6$export$836a6ea60fb78f25 = v; });
var $ceeef7151f62abb6$export$1e511d4a378977f5;
var $ceeef7151f62abb6$export$836a6ea60fb78f25;
"use strict";
$ceeef7151f62abb6$export$1e511d4a378977f5 = true;
$ceeef7151f62abb6$export$836a6ea60fb78f25 = void 0;

var $ceeef7151f62abb6$var$_react = $ceeef7151f62abb6$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $ceeef7151f62abb6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ceeef7151f62abb6$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ceeef7151f62abb6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ceeef7151f62abb6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ceeef7151f62abb6$var$_extends() {
    return $ceeef7151f62abb6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ceeef7151f62abb6$var$_extends.apply(null, arguments);
}
var $ceeef7151f62abb6$var$Contact = $ceeef7151f62abb6$export$836a6ea60fb78f25 = /*#__PURE__*/ (0, $ceeef7151f62abb6$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $ceeef7151f62abb6$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ceeef7151f62abb6$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Contact"
    }, props), /*#__PURE__*/ $ceeef7151f62abb6$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 2h21v16h-8l-8 4v-4H1V2zm5 8h1v1H6v-1zm5 0h1v1h-1v-1zm5 0h1v1h-1v-1z"
    }));
});
$ceeef7151f62abb6$var$Contact.displayName = 'Contact';


Object.keys($ceeef7151f62abb6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ceeef7151f62abb6$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ceeef7151f62abb6$exports[key];
});
var $f9d54de49969039d$exports = {};

$parcel$export($f9d54de49969039d$exports, "__esModule", function () { return $f9d54de49969039d$export$1e511d4a378977f5; }, function (v) { return $f9d54de49969039d$export$1e511d4a378977f5 = v; });
$parcel$export($f9d54de49969039d$exports, "Contract", function () { return $f9d54de49969039d$export$8517d80acf00e19a; }, function (v) { return $f9d54de49969039d$export$8517d80acf00e19a = v; });
var $f9d54de49969039d$export$1e511d4a378977f5;
var $f9d54de49969039d$export$8517d80acf00e19a;
"use strict";
$f9d54de49969039d$export$1e511d4a378977f5 = true;
$f9d54de49969039d$export$8517d80acf00e19a = void 0;

var $f9d54de49969039d$var$_react = $f9d54de49969039d$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f9d54de49969039d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f9d54de49969039d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f9d54de49969039d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f9d54de49969039d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f9d54de49969039d$var$_extends() {
    return $f9d54de49969039d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f9d54de49969039d$var$_extends.apply(null, arguments);
}
var $f9d54de49969039d$var$Contract = $f9d54de49969039d$export$8517d80acf00e19a = /*#__PURE__*/ (0, $f9d54de49969039d$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f9d54de49969039d$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f9d54de49969039d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Contract"
    }, props), /*#__PURE__*/ $f9d54de49969039d$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 14h8v8m-9 1 9-9M23 1l-9 9m8 0h-8V2"
    }));
});
$f9d54de49969039d$var$Contract.displayName = 'Contract';


Object.keys($f9d54de49969039d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f9d54de49969039d$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f9d54de49969039d$exports[key];
});

Object.keys($cf62a042166a0000$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $cf62a042166a0000$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $cf62a042166a0000$exports[key];
});
var $a6ec663b649e784e$exports = {};

$parcel$export($a6ec663b649e784e$exports, "__esModule", function () { return $a6ec663b649e784e$export$1e511d4a378977f5; }, function (v) { return $a6ec663b649e784e$export$1e511d4a378977f5 = v; });
$parcel$export($a6ec663b649e784e$exports, "Cpu", function () { return $a6ec663b649e784e$export$1df9025937e8ffa7; }, function (v) { return $a6ec663b649e784e$export$1df9025937e8ffa7 = v; });
var $a6ec663b649e784e$export$1e511d4a378977f5;
var $a6ec663b649e784e$export$1df9025937e8ffa7;
"use strict";
$a6ec663b649e784e$export$1e511d4a378977f5 = true;
$a6ec663b649e784e$export$1df9025937e8ffa7 = void 0;

var $a6ec663b649e784e$var$_react = $a6ec663b649e784e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a6ec663b649e784e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a6ec663b649e784e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a6ec663b649e784e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a6ec663b649e784e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a6ec663b649e784e$var$_extends() {
    return $a6ec663b649e784e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a6ec663b649e784e$var$_extends.apply(null, arguments);
}
var $a6ec663b649e784e$var$Cpu = $a6ec663b649e784e$export$1df9025937e8ffa7 = /*#__PURE__*/ (0, $a6ec663b649e784e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a6ec663b649e784e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a6ec663b649e784e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Cpu"
    }, props), /*#__PURE__*/ $a6ec663b649e784e$var$_react["default"].createElement("path", {
        stroke: "#000",
        strokeWidth: "2",
        fill: "none",
        d: "M1 18h3m-3-4h3m-3-4h3M1 6h3m16 12h3m-3-4h3m-3-4h3m-3-4h3M6 1v3m4-3v3m4-3v3m4-3v3M6 20v3m4-3v3m4-3v3m4-3v3M5 20h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1zm8-13h4v4h-4V7z"
    }));
});
$a6ec663b649e784e$var$Cpu.displayName = 'Cpu';


Object.keys($a6ec663b649e784e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a6ec663b649e784e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a6ec663b649e784e$exports[key];
});
var $1bc56923d69c0585$exports = {};

$parcel$export($1bc56923d69c0585$exports, "__esModule", function () { return $1bc56923d69c0585$export$1e511d4a378977f5; }, function (v) { return $1bc56923d69c0585$export$1e511d4a378977f5 = v; });
$parcel$export($1bc56923d69c0585$exports, "CreativeCommons", function () { return $1bc56923d69c0585$export$ecf61585b9b69d87; }, function (v) { return $1bc56923d69c0585$export$ecf61585b9b69d87 = v; });
var $1bc56923d69c0585$export$1e511d4a378977f5;
var $1bc56923d69c0585$export$ecf61585b9b69d87;
"use strict";
$1bc56923d69c0585$export$1e511d4a378977f5 = true;
$1bc56923d69c0585$export$ecf61585b9b69d87 = void 0;

var $1bc56923d69c0585$var$_react = $1bc56923d69c0585$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $1bc56923d69c0585$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1bc56923d69c0585$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1bc56923d69c0585$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $1bc56923d69c0585$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1bc56923d69c0585$var$_extends() {
    return $1bc56923d69c0585$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1bc56923d69c0585$var$_extends.apply(null, arguments);
}
var $1bc56923d69c0585$var$CreativeCommons = $1bc56923d69c0585$export$ecf61585b9b69d87 = /*#__PURE__*/ (0, $1bc56923d69c0585$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $1bc56923d69c0585$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $1bc56923d69c0585$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CreativeCommons"
    }, props), /*#__PURE__*/ $1bc56923d69c0585$var$_react["default"].createElement("path", {
        fill: "#333",
        fillRule: "evenodd",
        d: "M11.984 0c-3.292 0-6.19 1.218-8.428 3.49C1.25 5.827 0 8.856 0 12.016c0 3.194 1.218 6.157 3.523 8.461 2.304 2.305 5.3 3.556 8.46 3.556 3.16 0 6.223-1.251 8.593-3.588C22.815 18.239 24 15.309 24 12.016c0-3.259-1.185-6.222-3.457-8.493C18.24 1.218 15.276 0 11.983 0zm.032 2.173c2.7 0 5.104 1.02 6.98 2.897 1.843 1.843 2.83 4.28 2.83 6.946 0 2.7-.954 5.07-2.797 6.881-1.943 1.91-4.445 2.93-7.013 2.93-2.6 0-5.037-1.02-6.913-2.897-1.877-1.877-2.93-4.346-2.93-6.914 0-2.6 1.053-5.07 2.93-6.98 1.843-1.875 4.214-2.863 6.913-2.863zm-.154 7.846c-.68-1.237-1.837-1.73-3.181-1.73-1.957 0-3.514 1.384-3.514 3.727 0 2.382 1.464 3.727 3.58 3.727 1.358 0 2.516-.745 3.154-1.877l-1.49-.758c-.333.798-.839 1.038-1.478 1.038-1.105 0-1.61-.919-1.61-2.13 0-1.21.426-2.13 1.61-2.13.32 0 .959.173 1.331.972l1.598-.839zm6.932 0c-.68-1.237-1.837-1.73-3.181-1.73-1.957 0-3.514 1.384-3.514 3.727 0 2.382 1.464 3.727 3.58 3.727 1.358 0 2.516-.745 3.154-1.877l-1.49-.758c-.333.798-.839 1.038-1.477 1.038-1.105 0-1.611-.919-1.611-2.13 0-1.21.426-2.13 1.61-2.13.32 0 .959.173 1.331.972l1.598-.839z"
    }));
});
$1bc56923d69c0585$var$CreativeCommons.displayName = 'CreativeCommons';


Object.keys($1bc56923d69c0585$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $1bc56923d69c0585$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $1bc56923d69c0585$exports[key];
});
var $fda1c93cae81b222$exports = {};

$parcel$export($fda1c93cae81b222$exports, "__esModule", function () { return $fda1c93cae81b222$export$1e511d4a378977f5; }, function (v) { return $fda1c93cae81b222$export$1e511d4a378977f5 = v; });
$parcel$export($fda1c93cae81b222$exports, "CreditCard", function () { return $fda1c93cae81b222$export$769b6865db9774d4; }, function (v) { return $fda1c93cae81b222$export$769b6865db9774d4 = v; });
var $fda1c93cae81b222$export$1e511d4a378977f5;
var $fda1c93cae81b222$export$769b6865db9774d4;
"use strict";
$fda1c93cae81b222$export$1e511d4a378977f5 = true;
$fda1c93cae81b222$export$769b6865db9774d4 = void 0;

var $fda1c93cae81b222$var$_react = $fda1c93cae81b222$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $fda1c93cae81b222$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($fda1c93cae81b222$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $fda1c93cae81b222$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $fda1c93cae81b222$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $fda1c93cae81b222$var$_extends() {
    return $fda1c93cae81b222$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fda1c93cae81b222$var$_extends.apply(null, arguments);
}
var $fda1c93cae81b222$var$CreditCard = $fda1c93cae81b222$export$769b6865db9774d4 = /*#__PURE__*/ (0, $fda1c93cae81b222$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $fda1c93cae81b222$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $fda1c93cae81b222$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CreditCard"
    }, props), /*#__PURE__*/ $fda1c93cae81b222$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 5c0-.552.44-1 1.002-1h19.996A1 1 0 0 1 23 5v14c0 .552-.44 1-1.002 1H2.002A1 1 0 0 1 1 19V5zm0 3h22v2H1V8zm4 7h2v.5H5V15zm5 0h6v.5h-6V15z"
    }));
});
$fda1c93cae81b222$var$CreditCard.displayName = 'CreditCard';


Object.keys($fda1c93cae81b222$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $fda1c93cae81b222$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $fda1c93cae81b222$exports[key];
});
var $a450d97bc11b6560$exports = {};

$parcel$export($a450d97bc11b6560$exports, "__esModule", function () { return $a450d97bc11b6560$export$1e511d4a378977f5; }, function (v) { return $a450d97bc11b6560$export$1e511d4a378977f5 = v; });
$parcel$export($a450d97bc11b6560$exports, "Css3", function () { return $a450d97bc11b6560$export$9277e579b733416f; }, function (v) { return $a450d97bc11b6560$export$9277e579b733416f = v; });
var $a450d97bc11b6560$export$1e511d4a378977f5;
var $a450d97bc11b6560$export$9277e579b733416f;
"use strict";
$a450d97bc11b6560$export$1e511d4a378977f5 = true;
$a450d97bc11b6560$export$9277e579b733416f = void 0;

var $a450d97bc11b6560$var$_react = $a450d97bc11b6560$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a450d97bc11b6560$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a450d97bc11b6560$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a450d97bc11b6560$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a450d97bc11b6560$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a450d97bc11b6560$var$_extends() {
    return $a450d97bc11b6560$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a450d97bc11b6560$var$_extends.apply(null, arguments);
}
var $a450d97bc11b6560$var$Css3 = $a450d97bc11b6560$export$9277e579b733416f = /*#__PURE__*/ (0, $a450d97bc11b6560$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a450d97bc11b6560$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a450d97bc11b6560$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Css3"
    }, props), /*#__PURE__*/ $a450d97bc11b6560$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M7 3h14l-3 15-8 4-7-4 1-4m1-5h14"
    }));
});
$a450d97bc11b6560$var$Css3.displayName = 'Css3';


Object.keys($a450d97bc11b6560$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a450d97bc11b6560$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a450d97bc11b6560$exports[key];
});
var $7a872bb4aabeb090$exports = {};

$parcel$export($7a872bb4aabeb090$exports, "__esModule", function () { return $7a872bb4aabeb090$export$1e511d4a378977f5; }, function (v) { return $7a872bb4aabeb090$export$1e511d4a378977f5 = v; });
$parcel$export($7a872bb4aabeb090$exports, "Cube", function () { return $7a872bb4aabeb090$export$a15f0a83a652dd40; }, function (v) { return $7a872bb4aabeb090$export$a15f0a83a652dd40 = v; });
var $7a872bb4aabeb090$export$1e511d4a378977f5;
var $7a872bb4aabeb090$export$a15f0a83a652dd40;
"use strict";
$7a872bb4aabeb090$export$1e511d4a378977f5 = true;
$7a872bb4aabeb090$export$a15f0a83a652dd40 = void 0;

var $7a872bb4aabeb090$var$_react = $7a872bb4aabeb090$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $7a872bb4aabeb090$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7a872bb4aabeb090$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7a872bb4aabeb090$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $7a872bb4aabeb090$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7a872bb4aabeb090$var$_extends() {
    return $7a872bb4aabeb090$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7a872bb4aabeb090$var$_extends.apply(null, arguments);
}
var $7a872bb4aabeb090$var$Cube = $7a872bb4aabeb090$export$a15f0a83a652dd40 = /*#__PURE__*/ (0, $7a872bb4aabeb090$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $7a872bb4aabeb090$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $7a872bb4aabeb090$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Cube"
    }, props), /*#__PURE__*/ $7a872bb4aabeb090$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m12 2 10 5v10l-10 5-10-5V7l10-5zM2 7l10 5 10-5m-10 5v10-10z"
    }));
});
$7a872bb4aabeb090$var$Cube.displayName = 'Cube';


Object.keys($7a872bb4aabeb090$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $7a872bb4aabeb090$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $7a872bb4aabeb090$exports[key];
});
var $cee880a99a38b1c2$exports = {};

$parcel$export($cee880a99a38b1c2$exports, "__esModule", function () { return $cee880a99a38b1c2$export$1e511d4a378977f5; }, function (v) { return $cee880a99a38b1c2$export$1e511d4a378977f5 = v; });
$parcel$export($cee880a99a38b1c2$exports, "Cubes", function () { return $cee880a99a38b1c2$export$b95229f4716494f4; }, function (v) { return $cee880a99a38b1c2$export$b95229f4716494f4 = v; });
var $cee880a99a38b1c2$export$1e511d4a378977f5;
var $cee880a99a38b1c2$export$b95229f4716494f4;
"use strict";
$cee880a99a38b1c2$export$1e511d4a378977f5 = true;
$cee880a99a38b1c2$export$b95229f4716494f4 = void 0;

var $cee880a99a38b1c2$var$_react = $cee880a99a38b1c2$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $cee880a99a38b1c2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($cee880a99a38b1c2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $cee880a99a38b1c2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $cee880a99a38b1c2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $cee880a99a38b1c2$var$_extends() {
    return $cee880a99a38b1c2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cee880a99a38b1c2$var$_extends.apply(null, arguments);
}
var $cee880a99a38b1c2$var$Cubes = $cee880a99a38b1c2$export$b95229f4716494f4 = /*#__PURE__*/ (0, $cee880a99a38b1c2$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $cee880a99a38b1c2$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $cee880a99a38b1c2$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Cubes"
    }, props), /*#__PURE__*/ $cee880a99a38b1c2$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m6.5 10.5 5.5 3 5.5-3v-6l-5.5-3-5.5 3v6zm0-6 5.5 3 5.5-3m-5.5 3v6-6zm-11 12 5.5 3 5.5-3v-6l-5.5-3-5.5 3v6zm0-6 5.5 3 5.5-3m-5.5 3v6-6zm5.5 3 5.5 3 5.5-3v-6l-5.5-3-5.5 3v6zm0-6 5.5 3 5.5-3m-5.5 3v6-6z"
    }));
});
$cee880a99a38b1c2$var$Cubes.displayName = 'Cubes';


Object.keys($cee880a99a38b1c2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $cee880a99a38b1c2$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $cee880a99a38b1c2$exports[key];
});
var $d723c09cc6de85a2$exports = {};

$parcel$export($d723c09cc6de85a2$exports, "__esModule", function () { return $d723c09cc6de85a2$export$1e511d4a378977f5; }, function (v) { return $d723c09cc6de85a2$export$1e511d4a378977f5 = v; });
$parcel$export($d723c09cc6de85a2$exports, "Currency", function () { return $d723c09cc6de85a2$export$b733e092f9f44b2c; }, function (v) { return $d723c09cc6de85a2$export$b733e092f9f44b2c = v; });
var $d723c09cc6de85a2$export$1e511d4a378977f5;
var $d723c09cc6de85a2$export$b733e092f9f44b2c;
"use strict";
$d723c09cc6de85a2$export$1e511d4a378977f5 = true;
$d723c09cc6de85a2$export$b733e092f9f44b2c = void 0;

var $d723c09cc6de85a2$var$_react = $d723c09cc6de85a2$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $d723c09cc6de85a2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d723c09cc6de85a2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d723c09cc6de85a2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d723c09cc6de85a2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d723c09cc6de85a2$var$_extends() {
    return $d723c09cc6de85a2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d723c09cc6de85a2$var$_extends.apply(null, arguments);
}
var $d723c09cc6de85a2$var$Currency = $d723c09cc6de85a2$export$b733e092f9f44b2c = /*#__PURE__*/ (0, $d723c09cc6de85a2$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d723c09cc6de85a2$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $d723c09cc6de85a2$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Currency"
    }, props), /*#__PURE__*/ $d723c09cc6de85a2$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 5h22v14H1V5zm1 4a3 3 0 0 0 3-3m-3 9a3 3 0 0 1 3 3m17-9a3 3 0 0 1-3-3m3 9a3 3 0 0 0-3 3m-7-2c1.657 0 3-1.79 3-4s-1.343-4-3-4-3 1.79-3 4 1.343 4 3 4z"
    }));
});
$d723c09cc6de85a2$var$Currency.displayName = 'Currency';


Object.keys($d723c09cc6de85a2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $d723c09cc6de85a2$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $d723c09cc6de85a2$exports[key];
});
var $45a4c5d35e58428d$exports = {};

$parcel$export($45a4c5d35e58428d$exports, "__esModule", function () { return $45a4c5d35e58428d$export$1e511d4a378977f5; }, function (v) { return $45a4c5d35e58428d$export$1e511d4a378977f5 = v; });
$parcel$export($45a4c5d35e58428d$exports, "Cursor", function () { return $45a4c5d35e58428d$export$b6a79797ad180576; }, function (v) { return $45a4c5d35e58428d$export$b6a79797ad180576 = v; });
var $45a4c5d35e58428d$export$1e511d4a378977f5;
var $45a4c5d35e58428d$export$b6a79797ad180576;
"use strict";
$45a4c5d35e58428d$export$1e511d4a378977f5 = true;
$45a4c5d35e58428d$export$b6a79797ad180576 = void 0;

var $45a4c5d35e58428d$var$_react = $45a4c5d35e58428d$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $45a4c5d35e58428d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($45a4c5d35e58428d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $45a4c5d35e58428d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $45a4c5d35e58428d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $45a4c5d35e58428d$var$_extends() {
    return $45a4c5d35e58428d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $45a4c5d35e58428d$var$_extends.apply(null, arguments);
}
var $45a4c5d35e58428d$var$Cursor = $45a4c5d35e58428d$export$b6a79797ad180576 = /*#__PURE__*/ (0, $45a4c5d35e58428d$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $45a4c5d35e58428d$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $45a4c5d35e58428d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Cursor"
    }, props), /*#__PURE__*/ $45a4c5d35e58428d$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m6 3 12 11-5 1 3 5.5-3 1.5-3-6-4 3z"
    }));
});
$45a4c5d35e58428d$var$Cursor.displayName = 'Cursor';


Object.keys($45a4c5d35e58428d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $45a4c5d35e58428d$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $45a4c5d35e58428d$exports[key];
});
var $5e61a17ebe07ca76$exports = {};

$parcel$export($5e61a17ebe07ca76$exports, "__esModule", function () { return $5e61a17ebe07ca76$export$1e511d4a378977f5; }, function (v) { return $5e61a17ebe07ca76$export$1e511d4a378977f5 = v; });
$parcel$export($5e61a17ebe07ca76$exports, "Cut", function () { return $5e61a17ebe07ca76$export$e5934e6b116b2ede; }, function (v) { return $5e61a17ebe07ca76$export$e5934e6b116b2ede = v; });
var $5e61a17ebe07ca76$export$1e511d4a378977f5;
var $5e61a17ebe07ca76$export$e5934e6b116b2ede;
"use strict";
$5e61a17ebe07ca76$export$1e511d4a378977f5 = true;
$5e61a17ebe07ca76$export$e5934e6b116b2ede = void 0;

var $5e61a17ebe07ca76$var$_react = $5e61a17ebe07ca76$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5e61a17ebe07ca76$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5e61a17ebe07ca76$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5e61a17ebe07ca76$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5e61a17ebe07ca76$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5e61a17ebe07ca76$var$_extends() {
    return $5e61a17ebe07ca76$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5e61a17ebe07ca76$var$_extends.apply(null, arguments);
}
var $5e61a17ebe07ca76$var$Cut = $5e61a17ebe07ca76$export$e5934e6b116b2ede = /*#__PURE__*/ (0, $5e61a17ebe07ca76$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5e61a17ebe07ca76$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5e61a17ebe07ca76$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Cut"
    }, props), /*#__PURE__*/ $5e61a17ebe07ca76$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M23 4 8 16 23 4zm0 16L8 8l15 12zM5 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
    }));
});
$5e61a17ebe07ca76$var$Cut.displayName = 'Cut';


Object.keys($5e61a17ebe07ca76$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5e61a17ebe07ca76$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5e61a17ebe07ca76$exports[key];
});
var $f3dce00156b45cf9$exports = {};

$parcel$export($f3dce00156b45cf9$exports, "__esModule", function () { return $f3dce00156b45cf9$export$1e511d4a378977f5; }, function (v) { return $f3dce00156b45cf9$export$1e511d4a378977f5 = v; });
$parcel$export($f3dce00156b45cf9$exports, "Cycle", function () { return $f3dce00156b45cf9$export$126db9180177689d; }, function (v) { return $f3dce00156b45cf9$export$126db9180177689d = v; });
var $f3dce00156b45cf9$export$1e511d4a378977f5;
var $f3dce00156b45cf9$export$126db9180177689d;
"use strict";
$f3dce00156b45cf9$export$1e511d4a378977f5 = true;
$f3dce00156b45cf9$export$126db9180177689d = void 0;

var $f3dce00156b45cf9$var$_react = $f3dce00156b45cf9$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f3dce00156b45cf9$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f3dce00156b45cf9$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f3dce00156b45cf9$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f3dce00156b45cf9$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f3dce00156b45cf9$var$_extends() {
    return $f3dce00156b45cf9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f3dce00156b45cf9$var$_extends.apply(null, arguments);
}
var $f3dce00156b45cf9$var$Cycle = $f3dce00156b45cf9$export$126db9180177689d = /*#__PURE__*/ (0, $f3dce00156b45cf9$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f3dce00156b45cf9$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f3dce00156b45cf9$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Cycle"
    }, props), /*#__PURE__*/ $f3dce00156b45cf9$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M13 20c6-1 8-6 8-10m-7 6-2 4 4 3M0 9l4-3 3 4m2 10c-6-3-7-8-5-14m16 1C16 1 10 1 6 4.006M20 2v5h-5"
    }));
});
$f3dce00156b45cf9$var$Cycle.displayName = 'Cycle';


Object.keys($f3dce00156b45cf9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f3dce00156b45cf9$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f3dce00156b45cf9$exports[key];
});
var $dcf4bfc4898fafa7$exports = {};

$parcel$export($dcf4bfc4898fafa7$exports, "__esModule", function () { return $dcf4bfc4898fafa7$export$1e511d4a378977f5; }, function (v) { return $dcf4bfc4898fafa7$export$1e511d4a378977f5 = v; });
$parcel$export($dcf4bfc4898fafa7$exports, "Dashboard", function () { return $dcf4bfc4898fafa7$export$fe82a520fc33e5f4; }, function (v) { return $dcf4bfc4898fafa7$export$fe82a520fc33e5f4 = v; });
var $dcf4bfc4898fafa7$export$1e511d4a378977f5;
var $dcf4bfc4898fafa7$export$fe82a520fc33e5f4;
"use strict";
$dcf4bfc4898fafa7$export$1e511d4a378977f5 = true;
$dcf4bfc4898fafa7$export$fe82a520fc33e5f4 = void 0;

var $dcf4bfc4898fafa7$var$_react = $dcf4bfc4898fafa7$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $dcf4bfc4898fafa7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($dcf4bfc4898fafa7$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $dcf4bfc4898fafa7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $dcf4bfc4898fafa7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $dcf4bfc4898fafa7$var$_extends() {
    return $dcf4bfc4898fafa7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $dcf4bfc4898fafa7$var$_extends.apply(null, arguments);
}
var $dcf4bfc4898fafa7$var$Dashboard = $dcf4bfc4898fafa7$export$fe82a520fc33e5f4 = /*#__PURE__*/ (0, $dcf4bfc4898fafa7$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $dcf4bfc4898fafa7$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $dcf4bfc4898fafa7$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Dashboard"
    }, props), /*#__PURE__*/ $dcf4bfc4898fafa7$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm3-6a3 3 0 0 0-6 0M5 5l2 2m5 0v6m0-10v2m7 7h2M3 12h2m12-5 2-2M3 17h18"
    }));
});
$dcf4bfc4898fafa7$var$Dashboard.displayName = 'Dashboard';


Object.keys($dcf4bfc4898fafa7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $dcf4bfc4898fafa7$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $dcf4bfc4898fafa7$exports[key];
});
var $30f2285ecf6f7665$exports = {};

$parcel$export($30f2285ecf6f7665$exports, "__esModule", function () { return $30f2285ecf6f7665$export$1e511d4a378977f5; }, function (v) { return $30f2285ecf6f7665$export$1e511d4a378977f5 = v; });
$parcel$export($30f2285ecf6f7665$exports, "Database", function () { return $30f2285ecf6f7665$export$6feb5ea51a7b0b47; }, function (v) { return $30f2285ecf6f7665$export$6feb5ea51a7b0b47 = v; });
var $30f2285ecf6f7665$export$1e511d4a378977f5;
var $30f2285ecf6f7665$export$6feb5ea51a7b0b47;
"use strict";
$30f2285ecf6f7665$export$1e511d4a378977f5 = true;
$30f2285ecf6f7665$export$6feb5ea51a7b0b47 = void 0;

var $30f2285ecf6f7665$var$_react = $30f2285ecf6f7665$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $30f2285ecf6f7665$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($30f2285ecf6f7665$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $30f2285ecf6f7665$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $30f2285ecf6f7665$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $30f2285ecf6f7665$var$_extends() {
    return $30f2285ecf6f7665$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $30f2285ecf6f7665$var$_extends.apply(null, arguments);
}
var $30f2285ecf6f7665$var$Database = $30f2285ecf6f7665$export$6feb5ea51a7b0b47 = /*#__PURE__*/ (0, $30f2285ecf6f7665$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $30f2285ecf6f7665$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $30f2285ecf6f7665$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Database"
    }, props), /*#__PURE__*/ $30f2285ecf6f7665$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 2h22v7H1V2zm3 10h1v1H4v-1zm0-7h1v1H4V5zm0 14h1v1H4v-1zm-3-3h22v7H1v-7zm0-7h22v7H1V9z"
    }));
});
$30f2285ecf6f7665$var$Database.displayName = 'Database';


Object.keys($30f2285ecf6f7665$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $30f2285ecf6f7665$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $30f2285ecf6f7665$exports[key];
});
var $67467b7daa10a7fd$exports = {};

$parcel$export($67467b7daa10a7fd$exports, "__esModule", function () { return $67467b7daa10a7fd$export$1e511d4a378977f5; }, function (v) { return $67467b7daa10a7fd$export$1e511d4a378977f5 = v; });
$parcel$export($67467b7daa10a7fd$exports, "Debian", function () { return $67467b7daa10a7fd$export$528c34b67ea560e2; }, function (v) { return $67467b7daa10a7fd$export$528c34b67ea560e2 = v; });
var $67467b7daa10a7fd$export$1e511d4a378977f5;
var $67467b7daa10a7fd$export$528c34b67ea560e2;
"use strict";
$67467b7daa10a7fd$export$1e511d4a378977f5 = true;
$67467b7daa10a7fd$export$528c34b67ea560e2 = void 0;

var $67467b7daa10a7fd$var$_react = $67467b7daa10a7fd$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $67467b7daa10a7fd$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($67467b7daa10a7fd$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $67467b7daa10a7fd$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $67467b7daa10a7fd$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $67467b7daa10a7fd$var$_extends() {
    return $67467b7daa10a7fd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $67467b7daa10a7fd$var$_extends.apply(null, arguments);
}
var $67467b7daa10a7fd$var$Debian = $67467b7daa10a7fd$export$528c34b67ea560e2 = /*#__PURE__*/ (0, $67467b7daa10a7fd$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $67467b7daa10a7fd$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $67467b7daa10a7fd$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Debian"
    }, props), /*#__PURE__*/ $67467b7daa10a7fd$var$_react["default"].createElement("path", {
        fill: "#A80030",
        fillRule: "evenodd",
        d: "M2.656 5.167c.03.167.383-.233.107.39-.532.371-.064.162-.107-.39zm.003.032-.005-.06c0 .023.001.043.005.06zm-.446 1.76c-.344.44-.159.535-.195.834.125-.382.147-.612.195-.833zM13.04 0c-.372.031-.742.05-1.108.097l.161.022c.27-.099.661-.054.947-.119zm-.611.467.01-.04-.15.066.14-.026zM12.015.31c.212.038.459.067.424.118.232-.051.285-.098-.424-.118zM9.8 13.202c-.138-.153-.22-.338-.312-.521.088.323.267.6.434.881l-.122-.36zm4.317-.237c.144-.112.274-.226.39-.336a2.97 2.97 0 0 1-.984.05c-.398.007.075.206.594.286zm1.54-.817c.237-.327.41-.685.47-1.055-.053.264-.196.492-.33.732-.744.468-.07-.278-.001-.561-.8 1.006-.11.603-.139.884zm.788-2.05c.048-.716-.141-.49-.205-.217.075.039.133.505.205.217zm-4.558 5.147a4.674 4.674 0 0 1-1.527-1.168c.228.335.475.66.794.916-.54-.183-1.26-1.308-1.47-1.354.93 1.666 3.773 2.92 5.262 2.298-.69.026-1.565.014-2.339-.272-.294-.151-.685-.45-.697-.553-.015.038-.038.076-.023.133zm.04-.157a.057.057 0 0 0-.016.05.367.367 0 0 0 .016-.05zm-2.8-1.583c.26.355.468.74.802 1.017-.24-.469-.419-.663-.747-1.296l-.056.279zM20.46 8.576c.006-.365.101-.191.138-.281-.071-.041-.26-.321-.374-.858.083-.126.222.327.335.345-.073-.426-.198-.752-.203-1.08-.33-.689-.117.092-.384-.295-.351-1.095.29-.254.334-.752.532.771.836 1.965.975 2.46a10.077 10.077 0 0 0-.488-1.753c.162.068-.26-1.241.21-.374-.502-1.848-2.15-3.575-3.665-4.386.185.17.42.383.335.416-.753-.448-.621-.483-.729-.673-.614-.25-.654.02-1.06 0-1.159-.613-1.382-.548-2.447-.933l.049.227c-.767-.256-.894.097-1.722 0-.05-.039.265-.142.525-.18-.741.098-.706-.146-1.432.027.179-.125.368-.208.559-.315-.605.037-1.444.352-1.185.065-.986.44-2.737 1.058-3.72 1.98l-.03-.207c-.451.54-1.965 1.615-2.085 2.315l-.12.028c-.235.397-.387.846-.573 1.255-.306.522-.449.2-.405.282-.603 1.223-.902 2.25-1.161 3.092.184.276.004 1.659.074 2.766-.303 5.467 3.837 10.775 8.362 12 .663.238 1.65.229 2.488.253-.99-.283-1.118-.15-2.082-.486-.695-.328-.848-.702-1.34-1.13l.195.345c-.966-.342-.562-.423-1.348-.672l.208-.272c-.313-.023-.83-.528-.97-.807l-.343.014c-.412-.508-.631-.874-.615-1.158l-.11.197c-.126-.215-1.515-1.904-.795-1.511-.134-.122-.312-.2-.505-.55l.147-.167c-.346-.447-.638-1.018-.616-1.209.185.25.313.297.44.34-.875-2.173-.924-.12-1.588-2.212l.14-.012c-.107-.162-.172-.337-.259-.51l.061-.609c-.63-.729-.176-3.1-.085-4.4.063-.528.526-1.09.879-1.973L4.26 7.18c.41-.716 2.343-2.875 3.238-2.764.433-.544-.086-.002-.171-.139.952-.985 1.251-.696 1.894-.873.693-.412-.595.16-.266-.157 1.198-.306.849-.696 2.412-.851.165.094-.383.145-.52.266.998-.488 3.16-.377 4.562.271 1.63.762 3.459 3.011 3.53 5.128l.083.022c-.042.842.129 1.815-.166 2.709l.2-.424c.024.644-.188.955-.378 1.508l-.344.172c-.281.546.027.346-.174.78-.44.391-1.333 1.222-1.619 1.298-.209-.004.142-.246.188-.34-.588.403-.472.605-1.371.85l-.026-.058c-2.218 1.043-5.297-1.024-5.256-3.844-.024.179-.068.134-.117.206-.114-1.45.67-2.908 1.993-3.503 1.294-.64 2.812-.378 3.739.486-.51-.667-1.523-1.374-2.724-1.308-1.177.019-2.278.767-2.645 1.578-.603.38-.673 1.463-.935 1.662-.354 2.597.664 3.72 2.387 5.04.137.092.155.145.144.192l.001-.002c2.032.76 4.131.575 5.89-.834.447-.348.935-.94 1.077-.95-.213.32.036.155-.128.437.446-.719-.193-.293.461-1.241l.242.332c-.09-.596.741-1.32.657-2.264.19-.289.212.31.01.974.28-.736.074-.855.146-1.462.078.204.18.42.233.636-.183-.711.187-1.198.279-1.612-.09-.04-.282.315-.326-.526z"
    }));
});
$67467b7daa10a7fd$var$Debian.displayName = 'Debian';


Object.keys($67467b7daa10a7fd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $67467b7daa10a7fd$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $67467b7daa10a7fd$exports[key];
});
var $f84d15ff83ebfd8f$exports = {};

$parcel$export($f84d15ff83ebfd8f$exports, "__esModule", function () { return $f84d15ff83ebfd8f$export$1e511d4a378977f5; }, function (v) { return $f84d15ff83ebfd8f$export$1e511d4a378977f5 = v; });
$parcel$export($f84d15ff83ebfd8f$exports, "Deliver", function () { return $f84d15ff83ebfd8f$export$ffec088e0621637; }, function (v) { return $f84d15ff83ebfd8f$export$ffec088e0621637 = v; });
var $f84d15ff83ebfd8f$export$1e511d4a378977f5;
var $f84d15ff83ebfd8f$export$ffec088e0621637;
"use strict";
$f84d15ff83ebfd8f$export$1e511d4a378977f5 = true;
$f84d15ff83ebfd8f$export$ffec088e0621637 = void 0;

var $f84d15ff83ebfd8f$var$_react = $f84d15ff83ebfd8f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f84d15ff83ebfd8f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f84d15ff83ebfd8f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f84d15ff83ebfd8f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f84d15ff83ebfd8f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f84d15ff83ebfd8f$var$_extends() {
    return $f84d15ff83ebfd8f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f84d15ff83ebfd8f$var$_extends.apply(null, arguments);
}
var $f84d15ff83ebfd8f$var$Deliver = $f84d15ff83ebfd8f$export$ffec088e0621637 = /*#__PURE__*/ (0, $f84d15ff83ebfd8f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f84d15ff83ebfd8f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f84d15ff83ebfd8f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Deliver"
    }, props), /*#__PURE__*/ $f84d15ff83ebfd8f$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M3 18H1V3h13v14m0 1H9m-3 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm11 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM14 8h5l4 5v5h-3"
    }));
});
$f84d15ff83ebfd8f$var$Deliver.displayName = 'Deliver';


Object.keys($f84d15ff83ebfd8f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f84d15ff83ebfd8f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f84d15ff83ebfd8f$exports[key];
});
var $5fd8db9196b71882$exports = {};

$parcel$export($5fd8db9196b71882$exports, "__esModule", function () { return $5fd8db9196b71882$export$1e511d4a378977f5; }, function (v) { return $5fd8db9196b71882$export$1e511d4a378977f5 = v; });
$parcel$export($5fd8db9196b71882$exports, "Deploy", function () { return $5fd8db9196b71882$export$5b4031b3d2835620; }, function (v) { return $5fd8db9196b71882$export$5b4031b3d2835620 = v; });
var $5fd8db9196b71882$export$1e511d4a378977f5;
var $5fd8db9196b71882$export$5b4031b3d2835620;
"use strict";
$5fd8db9196b71882$export$1e511d4a378977f5 = true;
$5fd8db9196b71882$export$5b4031b3d2835620 = void 0;

var $5fd8db9196b71882$var$_react = $5fd8db9196b71882$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5fd8db9196b71882$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5fd8db9196b71882$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5fd8db9196b71882$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5fd8db9196b71882$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5fd8db9196b71882$var$_extends() {
    return $5fd8db9196b71882$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5fd8db9196b71882$var$_extends.apply(null, arguments);
}
var $5fd8db9196b71882$var$Deploy = $5fd8db9196b71882$export$5b4031b3d2835620 = /*#__PURE__*/ (0, $5fd8db9196b71882$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5fd8db9196b71882$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5fd8db9196b71882$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Deploy"
    }, props), /*#__PURE__*/ $5fd8db9196b71882$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M23 1s-6.528-.458-9 2c-.023.037-4 4-4 4L5 8l-3 2 8 4 4 8 2-3 1-5s3.963-3.977 4-4c2.458-2.472 2-9 2-9zm-6 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM7 17c-1-1-3-1-4 0s-1 5-1 5 4 0 5-1 1-3 0-4z"
    }));
});
$5fd8db9196b71882$var$Deploy.displayName = 'Deploy';


Object.keys($5fd8db9196b71882$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5fd8db9196b71882$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5fd8db9196b71882$exports[key];
});

Object.keys($c82a53117afbdd20$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c82a53117afbdd20$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c82a53117afbdd20$exports[key];
});
var $80f56a292f0a4704$exports = {};

$parcel$export($80f56a292f0a4704$exports, "__esModule", function () { return $80f56a292f0a4704$export$1e511d4a378977f5; }, function (v) { return $80f56a292f0a4704$export$1e511d4a378977f5 = v; });
$parcel$export($80f56a292f0a4704$exports, "Descending", function () { return $80f56a292f0a4704$export$fe34ed788ae9e386; }, function (v) { return $80f56a292f0a4704$export$fe34ed788ae9e386 = v; });
var $80f56a292f0a4704$export$1e511d4a378977f5;
var $80f56a292f0a4704$export$fe34ed788ae9e386;
"use strict";
$80f56a292f0a4704$export$1e511d4a378977f5 = true;
$80f56a292f0a4704$export$fe34ed788ae9e386 = void 0;

var $80f56a292f0a4704$var$_react = $80f56a292f0a4704$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $80f56a292f0a4704$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($80f56a292f0a4704$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $80f56a292f0a4704$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $80f56a292f0a4704$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $80f56a292f0a4704$var$_extends() {
    return $80f56a292f0a4704$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $80f56a292f0a4704$var$_extends.apply(null, arguments);
}
var $80f56a292f0a4704$var$Descending = $80f56a292f0a4704$export$fe34ed788ae9e386 = /*#__PURE__*/ (0, $80f56a292f0a4704$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $80f56a292f0a4704$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $80f56a292f0a4704$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Descending"
    }, props), /*#__PURE__*/ $80f56a292f0a4704$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m11.92 16.714-.354.353-.354-.353L7 12.502l.707-.708 3.359 3.359V7h1v8.153l3.358-3.359.707.708-4.212 4.212z",
        fill: "#000"
    }));
});
$80f56a292f0a4704$var$Descending.displayName = 'Descending';


Object.keys($80f56a292f0a4704$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $80f56a292f0a4704$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $80f56a292f0a4704$exports[key];
});
var $035c9478a0b7cb0e$exports = {};

$parcel$export($035c9478a0b7cb0e$exports, "__esModule", function () { return $035c9478a0b7cb0e$export$1e511d4a378977f5; }, function (v) { return $035c9478a0b7cb0e$export$1e511d4a378977f5 = v; });
$parcel$export($035c9478a0b7cb0e$exports, "Desktop", function () { return $035c9478a0b7cb0e$export$eb8deef317734844; }, function (v) { return $035c9478a0b7cb0e$export$eb8deef317734844 = v; });
var $035c9478a0b7cb0e$export$1e511d4a378977f5;
var $035c9478a0b7cb0e$export$eb8deef317734844;
"use strict";
$035c9478a0b7cb0e$export$1e511d4a378977f5 = true;
$035c9478a0b7cb0e$export$eb8deef317734844 = void 0;

var $035c9478a0b7cb0e$var$_react = $035c9478a0b7cb0e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $035c9478a0b7cb0e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($035c9478a0b7cb0e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $035c9478a0b7cb0e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $035c9478a0b7cb0e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $035c9478a0b7cb0e$var$_extends() {
    return $035c9478a0b7cb0e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $035c9478a0b7cb0e$var$_extends.apply(null, arguments);
}
var $035c9478a0b7cb0e$var$Desktop = $035c9478a0b7cb0e$export$eb8deef317734844 = /*#__PURE__*/ (0, $035c9478a0b7cb0e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $035c9478a0b7cb0e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $035c9478a0b7cb0e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Desktop"
    }, props), /*#__PURE__*/ $035c9478a0b7cb0e$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 1h22v18H1V1zm4 22h14H5zm5-4v4-4zm4 0v4-4z"
    }));
});
$035c9478a0b7cb0e$var$Desktop.displayName = 'Desktop';


Object.keys($035c9478a0b7cb0e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $035c9478a0b7cb0e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $035c9478a0b7cb0e$exports[key];
});
var $7c506052d64ae40e$exports = {};

$parcel$export($7c506052d64ae40e$exports, "__esModule", function () { return $7c506052d64ae40e$export$1e511d4a378977f5; }, function (v) { return $7c506052d64ae40e$export$1e511d4a378977f5 = v; });
$parcel$export($7c506052d64ae40e$exports, "Detach", function () { return $7c506052d64ae40e$export$bdc6dc6c633f9da5; }, function (v) { return $7c506052d64ae40e$export$bdc6dc6c633f9da5 = v; });
var $7c506052d64ae40e$export$1e511d4a378977f5;
var $7c506052d64ae40e$export$bdc6dc6c633f9da5;
"use strict";
$7c506052d64ae40e$export$1e511d4a378977f5 = true;
$7c506052d64ae40e$export$bdc6dc6c633f9da5 = void 0;

var $7c506052d64ae40e$var$_react = $7c506052d64ae40e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $7c506052d64ae40e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7c506052d64ae40e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7c506052d64ae40e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $7c506052d64ae40e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7c506052d64ae40e$var$_extends() {
    return $7c506052d64ae40e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7c506052d64ae40e$var$_extends.apply(null, arguments);
}
var $7c506052d64ae40e$var$Detach = $7c506052d64ae40e$export$bdc6dc6c633f9da5 = /*#__PURE__*/ (0, $7c506052d64ae40e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $7c506052d64ae40e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $7c506052d64ae40e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Detach"
    }, props), /*#__PURE__*/ $7c506052d64ae40e$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m4 4 16 16m2-8-5.28 5.28M15 19l-2 2c-6 6-15-3-9-9l2-2m2-2 5-5c4-4 10 2 6 6l-5 5m-2 2-2 2c-2 2-5-1-3-3l2-2m2-2 5-5"
    }));
});
$7c506052d64ae40e$var$Detach.displayName = 'Detach';


Object.keys($7c506052d64ae40e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $7c506052d64ae40e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $7c506052d64ae40e$exports[key];
});
var $9fdfa7431b0298fe$exports = {};

$parcel$export($9fdfa7431b0298fe$exports, "__esModule", function () { return $9fdfa7431b0298fe$export$1e511d4a378977f5; }, function (v) { return $9fdfa7431b0298fe$export$1e511d4a378977f5 = v; });
$parcel$export($9fdfa7431b0298fe$exports, "Device", function () { return $9fdfa7431b0298fe$export$8215d14a63d9fb10; }, function (v) { return $9fdfa7431b0298fe$export$8215d14a63d9fb10 = v; });
var $9fdfa7431b0298fe$export$1e511d4a378977f5;
var $9fdfa7431b0298fe$export$8215d14a63d9fb10;
"use strict";
$9fdfa7431b0298fe$export$1e511d4a378977f5 = true;
$9fdfa7431b0298fe$export$8215d14a63d9fb10 = void 0;

var $9fdfa7431b0298fe$var$_react = $9fdfa7431b0298fe$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $9fdfa7431b0298fe$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9fdfa7431b0298fe$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9fdfa7431b0298fe$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $9fdfa7431b0298fe$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $9fdfa7431b0298fe$var$_extends() {
    return $9fdfa7431b0298fe$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9fdfa7431b0298fe$var$_extends.apply(null, arguments);
}
var $9fdfa7431b0298fe$var$Device = $9fdfa7431b0298fe$export$8215d14a63d9fb10 = /*#__PURE__*/ (0, $9fdfa7431b0298fe$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $9fdfa7431b0298fe$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $9fdfa7431b0298fe$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Device"
    }, props), /*#__PURE__*/ $9fdfa7431b0298fe$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M2 7h20v14h-6l-4-4-4 4H2V7zm4-5 5 5h2l5-5"
    }));
});
$9fdfa7431b0298fe$var$Device.displayName = 'Device';


Object.keys($9fdfa7431b0298fe$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $9fdfa7431b0298fe$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $9fdfa7431b0298fe$exports[key];
});
var $1d6993fbcc9a5dba$exports = {};

$parcel$export($1d6993fbcc9a5dba$exports, "__esModule", function () { return $1d6993fbcc9a5dba$export$1e511d4a378977f5; }, function (v) { return $1d6993fbcc9a5dba$export$1e511d4a378977f5 = v; });
$parcel$export($1d6993fbcc9a5dba$exports, "Diamond", function () { return $1d6993fbcc9a5dba$export$8c2a6f376d2e35fc; }, function (v) { return $1d6993fbcc9a5dba$export$8c2a6f376d2e35fc = v; });
var $1d6993fbcc9a5dba$export$1e511d4a378977f5;
var $1d6993fbcc9a5dba$export$8c2a6f376d2e35fc;
"use strict";
$1d6993fbcc9a5dba$export$1e511d4a378977f5 = true;
$1d6993fbcc9a5dba$export$8c2a6f376d2e35fc = void 0;

var $1d6993fbcc9a5dba$var$_react = $1d6993fbcc9a5dba$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $1d6993fbcc9a5dba$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1d6993fbcc9a5dba$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1d6993fbcc9a5dba$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $1d6993fbcc9a5dba$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1d6993fbcc9a5dba$var$_extends() {
    return $1d6993fbcc9a5dba$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1d6993fbcc9a5dba$var$_extends.apply(null, arguments);
}
var $1d6993fbcc9a5dba$var$Diamond = $1d6993fbcc9a5dba$export$8c2a6f376d2e35fc = /*#__PURE__*/ (0, $1d6993fbcc9a5dba$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $1d6993fbcc9a5dba$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $1d6993fbcc9a5dba$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Diamond"
    }, props), /*#__PURE__*/ $1d6993fbcc9a5dba$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M6 3h12l4 6-10 12L2 9l4-6zM2 9h20M11 3 7 9l5 11m1-17 4 6-5 11"
    }));
});
$1d6993fbcc9a5dba$var$Diamond.displayName = 'Diamond';


Object.keys($1d6993fbcc9a5dba$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $1d6993fbcc9a5dba$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $1d6993fbcc9a5dba$exports[key];
});
var $f7bd443f0edaad74$exports = {};

$parcel$export($f7bd443f0edaad74$exports, "__esModule", function () { return $f7bd443f0edaad74$export$1e511d4a378977f5; }, function (v) { return $f7bd443f0edaad74$export$1e511d4a378977f5 = v; });
$parcel$export($f7bd443f0edaad74$exports, "Directions", function () { return $f7bd443f0edaad74$export$86ae6e8ac17a67c6; }, function (v) { return $f7bd443f0edaad74$export$86ae6e8ac17a67c6 = v; });
var $f7bd443f0edaad74$export$1e511d4a378977f5;
var $f7bd443f0edaad74$export$86ae6e8ac17a67c6;
"use strict";
$f7bd443f0edaad74$export$1e511d4a378977f5 = true;
$f7bd443f0edaad74$export$86ae6e8ac17a67c6 = void 0;

var $f7bd443f0edaad74$var$_react = $f7bd443f0edaad74$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f7bd443f0edaad74$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f7bd443f0edaad74$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f7bd443f0edaad74$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f7bd443f0edaad74$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f7bd443f0edaad74$var$_extends() {
    return $f7bd443f0edaad74$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f7bd443f0edaad74$var$_extends.apply(null, arguments);
}
var $f7bd443f0edaad74$var$Directions = $f7bd443f0edaad74$export$86ae6e8ac17a67c6 = /*#__PURE__*/ (0, $f7bd443f0edaad74$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f7bd443f0edaad74$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f7bd443f0edaad74$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Directions"
    }, props), /*#__PURE__*/ $f7bd443f0edaad74$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m17 11 5-5-5-5m5 5h-4a6 6 0 0 0-6 6v12M7 6l-5 5 5 5m-5-5h4a6 6 0 0 1 6 6v7"
    }));
});
$f7bd443f0edaad74$var$Directions.displayName = 'Directions';


Object.keys($f7bd443f0edaad74$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f7bd443f0edaad74$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f7bd443f0edaad74$exports[key];
});
var $256dae55f5df8227$exports = {};

$parcel$export($256dae55f5df8227$exports, "__esModule", function () { return $256dae55f5df8227$export$1e511d4a378977f5; }, function (v) { return $256dae55f5df8227$export$1e511d4a378977f5 = v; });
$parcel$export($256dae55f5df8227$exports, "DisabledOutline", function () { return $256dae55f5df8227$export$e138f661e7886f95; }, function (v) { return $256dae55f5df8227$export$e138f661e7886f95 = v; });
var $256dae55f5df8227$export$1e511d4a378977f5;
var $256dae55f5df8227$export$e138f661e7886f95;
"use strict";
$256dae55f5df8227$export$1e511d4a378977f5 = true;
$256dae55f5df8227$export$e138f661e7886f95 = void 0;

var $256dae55f5df8227$var$_react = $256dae55f5df8227$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $256dae55f5df8227$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($256dae55f5df8227$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $256dae55f5df8227$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $256dae55f5df8227$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $256dae55f5df8227$var$_extends() {
    return $256dae55f5df8227$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $256dae55f5df8227$var$_extends.apply(null, arguments);
}
var $256dae55f5df8227$var$DisabledOutline = $256dae55f5df8227$export$e138f661e7886f95 = /*#__PURE__*/ (0, $256dae55f5df8227$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $256dae55f5df8227$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $256dae55f5df8227$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DisabledOutline"
    }, props), /*#__PURE__*/ $256dae55f5df8227$var$_react["default"].createElement("path", {
        stroke: "#000",
        strokeWidth: "2",
        fill: "none",
        d: "M18 12H6M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2z"
    }));
});
$256dae55f5df8227$var$DisabledOutline.displayName = 'DisabledOutline';


Object.keys($256dae55f5df8227$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $256dae55f5df8227$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $256dae55f5df8227$exports[key];
});
var $ae81faf37f20cad5$exports = {};

$parcel$export($ae81faf37f20cad5$exports, "__esModule", function () { return $ae81faf37f20cad5$export$1e511d4a378977f5; }, function (v) { return $ae81faf37f20cad5$export$1e511d4a378977f5 = v; });
$parcel$export($ae81faf37f20cad5$exports, "Disc", function () { return $ae81faf37f20cad5$export$ca90b5a79ea0d79c; }, function (v) { return $ae81faf37f20cad5$export$ca90b5a79ea0d79c = v; });
var $ae81faf37f20cad5$export$1e511d4a378977f5;
var $ae81faf37f20cad5$export$ca90b5a79ea0d79c;
"use strict";
$ae81faf37f20cad5$export$1e511d4a378977f5 = true;
$ae81faf37f20cad5$export$ca90b5a79ea0d79c = void 0;

var $ae81faf37f20cad5$var$_react = $ae81faf37f20cad5$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $ae81faf37f20cad5$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ae81faf37f20cad5$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ae81faf37f20cad5$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ae81faf37f20cad5$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ae81faf37f20cad5$var$_extends() {
    return $ae81faf37f20cad5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ae81faf37f20cad5$var$_extends.apply(null, arguments);
}
var $ae81faf37f20cad5$var$Disc = $ae81faf37f20cad5$export$ca90b5a79ea0d79c = /*#__PURE__*/ (0, $ae81faf37f20cad5$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $ae81faf37f20cad5$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ae81faf37f20cad5$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Disc"
    }, props), /*#__PURE__*/ $ae81faf37f20cad5$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm0-7a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
    }));
});
$ae81faf37f20cad5$var$Disc.displayName = 'Disc';


Object.keys($ae81faf37f20cad5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ae81faf37f20cad5$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ae81faf37f20cad5$exports[key];
});

Object.keys($3fa9fa210ed638fa$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3fa9fa210ed638fa$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3fa9fa210ed638fa$exports[key];
});

Object.keys($7ef108730670d60a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $7ef108730670d60a$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $7ef108730670d60a$exports[key];
});
var $b3a2d295265db352$exports = {};

$parcel$export($b3a2d295265db352$exports, "__esModule", function () { return $b3a2d295265db352$export$1e511d4a378977f5; }, function (v) { return $b3a2d295265db352$export$1e511d4a378977f5 = v; });
$parcel$export($b3a2d295265db352$exports, "Docker", function () { return $b3a2d295265db352$export$89cac05426948392; }, function (v) { return $b3a2d295265db352$export$89cac05426948392 = v; });
var $b3a2d295265db352$export$1e511d4a378977f5;
var $b3a2d295265db352$export$89cac05426948392;
"use strict";
$b3a2d295265db352$export$1e511d4a378977f5 = true;
$b3a2d295265db352$export$89cac05426948392 = void 0;

var $b3a2d295265db352$var$_react = $b3a2d295265db352$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $b3a2d295265db352$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b3a2d295265db352$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b3a2d295265db352$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $b3a2d295265db352$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b3a2d295265db352$var$_extends() {
    return $b3a2d295265db352$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b3a2d295265db352$var$_extends.apply(null, arguments);
}
var $b3a2d295265db352$var$Docker = $b3a2d295265db352$export$89cac05426948392 = /*#__PURE__*/ (0, $b3a2d295265db352$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $b3a2d295265db352$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $b3a2d295265db352$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Docker"
    }, props), /*#__PURE__*/ $b3a2d295265db352$var$_react["default"].createElement("path", {
        fill: "#0DB7ED",
        fillRule: "evenodd",
        d: "M6.942 14.9c.056 0 .11.01.158.03a.179.179 0 1 0 .246.24.438.438 0 1 1-.404-.27zm0 1.185a.749.749 0 1 1 .002-1.497.749.749 0 0 1-.002 1.497zm13.444-4.901c-2.124 5.628-6.92 8.135-12.576 8.135-2.672 0-4.803-.92-6.167-2.452l.01-.006c.393.02.745.026 1.101.026.327 0 .646-.003.941-.02l.084-.006s.091-.006.046-.007a8.545 8.545 0 0 0 1.877-.306 4.82 4.82 0 0 0 .286-.09.197.197 0 0 0-.128-.371c-.69.239-1.6.37-2.715.395a21.668 21.668 0 0 1-1.86-.045 6.3 6.3 0 0 1-.386-.58l-.187-.34C.15 14.411-.096 13.12.034 11.716h16.363c1.344 0 2.656-.502 3.28-1.055-1.117-.908-1.006-3.064-.295-3.886.618.496 1.613 1.54 1.442 2.871.777-.39 2.127-.583 3.176.022-.659 1.286-2.107 1.67-3.614 1.516zm-18.13.135h2.212V9.106H2.255v2.213zm2.552 0h2.213V9.106H4.808v2.213zm0-2.553h2.213V6.553H4.808v2.213zm2.553 2.553h2.213V9.106H7.361v2.213zm0-2.553h2.213V6.553H7.361v2.213zm2.553 2.553h2.213V9.106H9.914v2.213zm0-2.553h2.213V6.553H9.914v2.213zm0-2.553h2.213V4H9.914v2.213zm2.553 5.106h2.213V9.106h-2.213v2.213z"
    }));
});
$b3a2d295265db352$var$Docker.displayName = 'Docker';


Object.keys($b3a2d295265db352$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $b3a2d295265db352$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $b3a2d295265db352$exports[key];
});
var $9c9be6f59c8bdcc1$exports = {};

$parcel$export($9c9be6f59c8bdcc1$exports, "__esModule", function () { return $9c9be6f59c8bdcc1$export$1e511d4a378977f5; }, function (v) { return $9c9be6f59c8bdcc1$export$1e511d4a378977f5 = v; });
$parcel$export($9c9be6f59c8bdcc1$exports, "DocumentCloud", function () { return $9c9be6f59c8bdcc1$export$323888f2fbc7ac1e; }, function (v) { return $9c9be6f59c8bdcc1$export$323888f2fbc7ac1e = v; });
var $9c9be6f59c8bdcc1$export$1e511d4a378977f5;
var $9c9be6f59c8bdcc1$export$323888f2fbc7ac1e;
"use strict";
$9c9be6f59c8bdcc1$export$1e511d4a378977f5 = true;
$9c9be6f59c8bdcc1$export$323888f2fbc7ac1e = void 0;

var $9c9be6f59c8bdcc1$var$_react = $9c9be6f59c8bdcc1$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $9c9be6f59c8bdcc1$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9c9be6f59c8bdcc1$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9c9be6f59c8bdcc1$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $9c9be6f59c8bdcc1$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $9c9be6f59c8bdcc1$var$_extends() {
    return $9c9be6f59c8bdcc1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9c9be6f59c8bdcc1$var$_extends.apply(null, arguments);
}
var $9c9be6f59c8bdcc1$var$DocumentCloud = $9c9be6f59c8bdcc1$export$323888f2fbc7ac1e = /*#__PURE__*/ (0, $9c9be6f59c8bdcc1$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $9c9be6f59c8bdcc1$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $9c9be6f59c8bdcc1$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentCloud"
    }, props), /*#__PURE__*/ $9c9be6f59c8bdcc1$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 7V1H19.5L23 4.5V23h-4M18 1v5h5m-12 7H6.002A3.003 3.003 0 0 0 3 16c0 1.657 1.343 3 2.99 3H7v1.01A2.993 2.993 0 0 0 10.002 23h1.996A2.999 2.999 0 0 0 15 20.01V19m-4 0h4.998A3.003 3.003 0 0 0 19 16c0-1.657-1.343-3-2.99-3H15v-1.01A2.993 2.993 0 0 0 11.998 9h-1.996A2.999 2.999 0 0 0 7 11.99V13"
    }));
});
$9c9be6f59c8bdcc1$var$DocumentCloud.displayName = 'DocumentCloud';


Object.keys($9c9be6f59c8bdcc1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $9c9be6f59c8bdcc1$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $9c9be6f59c8bdcc1$exports[key];
});
var $2d02ee279390b2a2$exports = {};

$parcel$export($2d02ee279390b2a2$exports, "__esModule", function () { return $2d02ee279390b2a2$export$1e511d4a378977f5; }, function (v) { return $2d02ee279390b2a2$export$1e511d4a378977f5 = v; });
$parcel$export($2d02ee279390b2a2$exports, "DocumentConfig", function () { return $2d02ee279390b2a2$export$486aa8a34aa41d70; }, function (v) { return $2d02ee279390b2a2$export$486aa8a34aa41d70 = v; });
var $2d02ee279390b2a2$export$1e511d4a378977f5;
var $2d02ee279390b2a2$export$486aa8a34aa41d70;
"use strict";
$2d02ee279390b2a2$export$1e511d4a378977f5 = true;
$2d02ee279390b2a2$export$486aa8a34aa41d70 = void 0;

var $2d02ee279390b2a2$var$_react = $2d02ee279390b2a2$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $2d02ee279390b2a2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2d02ee279390b2a2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2d02ee279390b2a2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $2d02ee279390b2a2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $2d02ee279390b2a2$var$_extends() {
    return $2d02ee279390b2a2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2d02ee279390b2a2$var$_extends.apply(null, arguments);
}
var $2d02ee279390b2a2$var$DocumentConfig = $2d02ee279390b2a2$export$486aa8a34aa41d70 = /*#__PURE__*/ (0, $2d02ee279390b2a2$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $2d02ee279390b2a2$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $2d02ee279390b2a2$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentConfig"
    }, props), /*#__PURE__*/ $2d02ee279390b2a2$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 9V1H19.5L23 4.5V23h-7m2-22v5h5M9 14v-3m0 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 3v-3m3-3h3M3 17h3m-1-4 2 2m4 4 2 2m0-8-2 2m-4 4-2 2"
    }));
});
$2d02ee279390b2a2$var$DocumentConfig.displayName = 'DocumentConfig';


Object.keys($2d02ee279390b2a2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $2d02ee279390b2a2$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $2d02ee279390b2a2$exports[key];
});
var $0da547e5dda46984$exports = {};

$parcel$export($0da547e5dda46984$exports, "__esModule", function () { return $0da547e5dda46984$export$1e511d4a378977f5; }, function (v) { return $0da547e5dda46984$export$1e511d4a378977f5 = v; });
$parcel$export($0da547e5dda46984$exports, "DocumentCsv", function () { return $0da547e5dda46984$export$e3b0f3dfea1b7a9c; }, function (v) { return $0da547e5dda46984$export$e3b0f3dfea1b7a9c = v; });
var $0da547e5dda46984$export$1e511d4a378977f5;
var $0da547e5dda46984$export$e3b0f3dfea1b7a9c;
"use strict";
$0da547e5dda46984$export$1e511d4a378977f5 = true;
$0da547e5dda46984$export$e3b0f3dfea1b7a9c = void 0;

var $0da547e5dda46984$var$_react = $0da547e5dda46984$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0da547e5dda46984$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0da547e5dda46984$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0da547e5dda46984$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0da547e5dda46984$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0da547e5dda46984$var$_extends() {
    return $0da547e5dda46984$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0da547e5dda46984$var$_extends.apply(null, arguments);
}
var $0da547e5dda46984$var$DocumentCsv = $0da547e5dda46984$export$e3b0f3dfea1b7a9c = /*#__PURE__*/ (0, $0da547e5dda46984$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0da547e5dda46984$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0da547e5dda46984$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentCsv"
    }, props), /*#__PURE__*/ $0da547e5dda46984$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 9V1H19.5L23 4.5V23H4M18 1v5h5M7 13H5c-1 0-2 .5-2 1.5v3c0 1 1 1.5 2 1.5h2m6.25-6h-2.5c-1.5 0-2 .5-2 1.5s.5 1.5 2 1.5 2 .5 2 1.5-.5 1.5-2 1.5h-2.5m12.25-7v.5C20.5 13 18 19 18 19h-.5S15 13 15 12.5V12"
    }));
});
$0da547e5dda46984$var$DocumentCsv.displayName = 'DocumentCsv';


Object.keys($0da547e5dda46984$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0da547e5dda46984$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0da547e5dda46984$exports[key];
});
var $7147269fc1e5a812$exports = {};

$parcel$export($7147269fc1e5a812$exports, "__esModule", function () { return $7147269fc1e5a812$export$1e511d4a378977f5; }, function (v) { return $7147269fc1e5a812$export$1e511d4a378977f5 = v; });
$parcel$export($7147269fc1e5a812$exports, "DocumentDownload", function () { return $7147269fc1e5a812$export$2c4ef4153bb78178; }, function (v) { return $7147269fc1e5a812$export$2c4ef4153bb78178 = v; });
var $7147269fc1e5a812$export$1e511d4a378977f5;
var $7147269fc1e5a812$export$2c4ef4153bb78178;
"use strict";
$7147269fc1e5a812$export$1e511d4a378977f5 = true;
$7147269fc1e5a812$export$2c4ef4153bb78178 = void 0;

var $7147269fc1e5a812$var$_react = $7147269fc1e5a812$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $7147269fc1e5a812$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7147269fc1e5a812$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7147269fc1e5a812$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $7147269fc1e5a812$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7147269fc1e5a812$var$_extends() {
    return $7147269fc1e5a812$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7147269fc1e5a812$var$_extends.apply(null, arguments);
}
var $7147269fc1e5a812$var$DocumentDownload = $7147269fc1e5a812$export$2c4ef4153bb78178 = /*#__PURE__*/ (0, $7147269fc1e5a812$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $7147269fc1e5a812$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $7147269fc1e5a812$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentDownload"
    }, props), /*#__PURE__*/ $7147269fc1e5a812$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2.998 1H17.5L21 4.5V23H3L2.998 1zM16 1v5h5m-9 3v9m-4-3 4 4 4-4"
    }));
});
$7147269fc1e5a812$var$DocumentDownload.displayName = 'DocumentDownload';


Object.keys($7147269fc1e5a812$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $7147269fc1e5a812$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $7147269fc1e5a812$exports[key];
});
var $6fd7a3e9f4bd1927$exports = {};

$parcel$export($6fd7a3e9f4bd1927$exports, "__esModule", function () { return $6fd7a3e9f4bd1927$export$1e511d4a378977f5; }, function (v) { return $6fd7a3e9f4bd1927$export$1e511d4a378977f5 = v; });
$parcel$export($6fd7a3e9f4bd1927$exports, "DocumentExcel", function () { return $6fd7a3e9f4bd1927$export$6337df568c09b462; }, function (v) { return $6fd7a3e9f4bd1927$export$6337df568c09b462 = v; });
var $6fd7a3e9f4bd1927$export$1e511d4a378977f5;
var $6fd7a3e9f4bd1927$export$6337df568c09b462;
"use strict";
$6fd7a3e9f4bd1927$export$1e511d4a378977f5 = true;
$6fd7a3e9f4bd1927$export$6337df568c09b462 = void 0;

var $6fd7a3e9f4bd1927$var$_react = $6fd7a3e9f4bd1927$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $6fd7a3e9f4bd1927$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6fd7a3e9f4bd1927$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6fd7a3e9f4bd1927$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6fd7a3e9f4bd1927$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6fd7a3e9f4bd1927$var$_extends() {
    return $6fd7a3e9f4bd1927$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6fd7a3e9f4bd1927$var$_extends.apply(null, arguments);
}
var $6fd7a3e9f4bd1927$var$DocumentExcel = $6fd7a3e9f4bd1927$export$6337df568c09b462 = /*#__PURE__*/ (0, $6fd7a3e9f4bd1927$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $6fd7a3e9f4bd1927$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $6fd7a3e9f4bd1927$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentExcel"
    }, props), /*#__PURE__*/ $6fd7a3e9f4bd1927$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 9V1H19.5L23 4.5V23H4M18 1v5h5M9.25 12l-2 3.25-2-3.25H5l2.25 3.5-2.5 3.5H5l2.25-3.25L9.5 19h.25l-2.5-3.5L9.5 12h-.25z"
    }));
});
$6fd7a3e9f4bd1927$var$DocumentExcel.displayName = 'DocumentExcel';


Object.keys($6fd7a3e9f4bd1927$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $6fd7a3e9f4bd1927$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $6fd7a3e9f4bd1927$exports[key];
});
var $434bac5dab3e68b8$exports = {};

$parcel$export($434bac5dab3e68b8$exports, "__esModule", function () { return $434bac5dab3e68b8$export$1e511d4a378977f5; }, function (v) { return $434bac5dab3e68b8$export$1e511d4a378977f5 = v; });
$parcel$export($434bac5dab3e68b8$exports, "DocumentImage", function () { return $434bac5dab3e68b8$export$dbcd9ec27c3174af; }, function (v) { return $434bac5dab3e68b8$export$dbcd9ec27c3174af = v; });
var $434bac5dab3e68b8$export$1e511d4a378977f5;
var $434bac5dab3e68b8$export$dbcd9ec27c3174af;
"use strict";
$434bac5dab3e68b8$export$1e511d4a378977f5 = true;
$434bac5dab3e68b8$export$dbcd9ec27c3174af = void 0;

var $434bac5dab3e68b8$var$_react = $434bac5dab3e68b8$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $434bac5dab3e68b8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($434bac5dab3e68b8$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $434bac5dab3e68b8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $434bac5dab3e68b8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $434bac5dab3e68b8$var$_extends() {
    return $434bac5dab3e68b8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $434bac5dab3e68b8$var$_extends.apply(null, arguments);
}
var $434bac5dab3e68b8$var$DocumentImage = $434bac5dab3e68b8$export$dbcd9ec27c3174af = /*#__PURE__*/ (0, $434bac5dab3e68b8$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $434bac5dab3e68b8$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $434bac5dab3e68b8$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentImage"
    }, props), /*#__PURE__*/ $434bac5dab3e68b8$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 7V1H19.5L23 4.5V23h-3M18 1v5h5M3 11h13v12H3V11zm4 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-2 7 2-3 2 2 4-6 3 4"
    }));
});
$434bac5dab3e68b8$var$DocumentImage.displayName = 'DocumentImage';


Object.keys($434bac5dab3e68b8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $434bac5dab3e68b8$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $434bac5dab3e68b8$exports[key];
});
var $86a69e6c59588278$exports = {};

$parcel$export($86a69e6c59588278$exports, "__esModule", function () { return $86a69e6c59588278$export$1e511d4a378977f5; }, function (v) { return $86a69e6c59588278$export$1e511d4a378977f5 = v; });
$parcel$export($86a69e6c59588278$exports, "DocumentLocked", function () { return $86a69e6c59588278$export$c58f6d26807c576b; }, function (v) { return $86a69e6c59588278$export$c58f6d26807c576b = v; });
var $86a69e6c59588278$export$1e511d4a378977f5;
var $86a69e6c59588278$export$c58f6d26807c576b;
"use strict";
$86a69e6c59588278$export$1e511d4a378977f5 = true;
$86a69e6c59588278$export$c58f6d26807c576b = void 0;

var $86a69e6c59588278$var$_react = $86a69e6c59588278$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $86a69e6c59588278$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($86a69e6c59588278$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $86a69e6c59588278$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $86a69e6c59588278$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $86a69e6c59588278$var$_extends() {
    return $86a69e6c59588278$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $86a69e6c59588278$var$_extends.apply(null, arguments);
}
var $86a69e6c59588278$var$DocumentLocked = $86a69e6c59588278$export$c58f6d26807c576b = /*#__PURE__*/ (0, $86a69e6c59588278$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $86a69e6c59588278$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $86a69e6c59588278$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentLocked"
    }, props), /*#__PURE__*/ $86a69e6c59588278$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 7V1H19.5L23 4.5V23h-6m1-22v5h5M4 15h10v8H4v-8zm2 0v-2a3 3 0 0 1 6 0v2m-4 4h2"
    }));
});
$86a69e6c59588278$var$DocumentLocked.displayName = 'DocumentLocked';


Object.keys($86a69e6c59588278$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $86a69e6c59588278$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $86a69e6c59588278$exports[key];
});
var $e876dbcb08679e9b$exports = {};

$parcel$export($e876dbcb08679e9b$exports, "__esModule", function () { return $e876dbcb08679e9b$export$1e511d4a378977f5; }, function (v) { return $e876dbcb08679e9b$export$1e511d4a378977f5 = v; });
$parcel$export($e876dbcb08679e9b$exports, "DocumentMissing", function () { return $e876dbcb08679e9b$export$148b4113a61ea7bc; }, function (v) { return $e876dbcb08679e9b$export$148b4113a61ea7bc = v; });
var $e876dbcb08679e9b$export$1e511d4a378977f5;
var $e876dbcb08679e9b$export$148b4113a61ea7bc;
"use strict";
$e876dbcb08679e9b$export$1e511d4a378977f5 = true;
$e876dbcb08679e9b$export$148b4113a61ea7bc = void 0;

var $e876dbcb08679e9b$var$_react = $e876dbcb08679e9b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e876dbcb08679e9b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e876dbcb08679e9b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e876dbcb08679e9b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e876dbcb08679e9b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e876dbcb08679e9b$var$_extends() {
    return $e876dbcb08679e9b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e876dbcb08679e9b$var$_extends.apply(null, arguments);
}
var $e876dbcb08679e9b$var$DocumentMissing = $e876dbcb08679e9b$export$148b4113a61ea7bc = /*#__PURE__*/ (0, $e876dbcb08679e9b$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e876dbcb08679e9b$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e876dbcb08679e9b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentMissing"
    }, props), /*#__PURE__*/ $e876dbcb08679e9b$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2.998 1H17.5L21 4.5V23H3L2.998 1zM16 1v5h5M9 12l6 6m0-6-6 6"
    }));
});
$e876dbcb08679e9b$var$DocumentMissing.displayName = 'DocumentMissing';


Object.keys($e876dbcb08679e9b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e876dbcb08679e9b$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e876dbcb08679e9b$exports[key];
});
var $edeed2c924863d88$exports = {};

$parcel$export($edeed2c924863d88$exports, "__esModule", function () { return $edeed2c924863d88$export$1e511d4a378977f5; }, function (v) { return $edeed2c924863d88$export$1e511d4a378977f5 = v; });
$parcel$export($edeed2c924863d88$exports, "DocumentNotes", function () { return $edeed2c924863d88$export$741d9ab0cbbe800a; }, function (v) { return $edeed2c924863d88$export$741d9ab0cbbe800a = v; });
var $edeed2c924863d88$export$1e511d4a378977f5;
var $edeed2c924863d88$export$741d9ab0cbbe800a;
"use strict";
$edeed2c924863d88$export$1e511d4a378977f5 = true;
$edeed2c924863d88$export$741d9ab0cbbe800a = void 0;

var $edeed2c924863d88$var$_react = $edeed2c924863d88$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $edeed2c924863d88$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($edeed2c924863d88$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $edeed2c924863d88$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $edeed2c924863d88$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $edeed2c924863d88$var$_extends() {
    return $edeed2c924863d88$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $edeed2c924863d88$var$_extends.apply(null, arguments);
}
var $edeed2c924863d88$var$DocumentNotes = $edeed2c924863d88$export$741d9ab0cbbe800a = /*#__PURE__*/ (0, $edeed2c924863d88$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $edeed2c924863d88$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $edeed2c924863d88$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentNotes"
    }, props), /*#__PURE__*/ $edeed2c924863d88$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 9V1H19.5L23 4.5V23H4M18 1v5h5M9.75 12v6.5H9.5l-5-6.5H4v7h.25v-6.5h.25l5 6.5h.5v-7h-.25z"
    }));
});
$edeed2c924863d88$var$DocumentNotes.displayName = 'DocumentNotes';


Object.keys($edeed2c924863d88$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $edeed2c924863d88$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $edeed2c924863d88$exports[key];
});
var $d71a0d019081e57e$exports = {};

$parcel$export($d71a0d019081e57e$exports, "__esModule", function () { return $d71a0d019081e57e$export$1e511d4a378977f5; }, function (v) { return $d71a0d019081e57e$export$1e511d4a378977f5 = v; });
$parcel$export($d71a0d019081e57e$exports, "DocumentOutlook", function () { return $d71a0d019081e57e$export$afc57ba7bbadf2b9; }, function (v) { return $d71a0d019081e57e$export$afc57ba7bbadf2b9 = v; });
var $d71a0d019081e57e$export$1e511d4a378977f5;
var $d71a0d019081e57e$export$afc57ba7bbadf2b9;
"use strict";
$d71a0d019081e57e$export$1e511d4a378977f5 = true;
$d71a0d019081e57e$export$afc57ba7bbadf2b9 = void 0;

var $d71a0d019081e57e$var$_react = $d71a0d019081e57e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $d71a0d019081e57e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d71a0d019081e57e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d71a0d019081e57e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d71a0d019081e57e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d71a0d019081e57e$var$_extends() {
    return $d71a0d019081e57e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d71a0d019081e57e$var$_extends.apply(null, arguments);
}
var $d71a0d019081e57e$var$DocumentOutlook = $d71a0d019081e57e$export$afc57ba7bbadf2b9 = /*#__PURE__*/ (0, $d71a0d019081e57e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d71a0d019081e57e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $d71a0d019081e57e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentOutlook"
    }, props), /*#__PURE__*/ $d71a0d019081e57e$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2.998 9V1H17.5L21 4.5V23H2M16 1v5h5M7.75 15.75C7.75 13.5 6.5 12 5 12s-2.75 1.5-2.75 3.75S3.5 19.5 5 19.5s2.75-1.5 2.75-3.75zM5 12c2.425 0 3 2.5 3 3.75s-.5 3.75-3 3.75-3-2.5-3-3.75S2.559 12 5 12z"
    }));
});
$d71a0d019081e57e$var$DocumentOutlook.displayName = 'DocumentOutlook';


Object.keys($d71a0d019081e57e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $d71a0d019081e57e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $d71a0d019081e57e$exports[key];
});
var $e16582d014d3839e$exports = {};

$parcel$export($e16582d014d3839e$exports, "__esModule", function () { return $e16582d014d3839e$export$1e511d4a378977f5; }, function (v) { return $e16582d014d3839e$export$1e511d4a378977f5 = v; });
$parcel$export($e16582d014d3839e$exports, "DocumentPdf", function () { return $e16582d014d3839e$export$9a8976280dae288d; }, function (v) { return $e16582d014d3839e$export$9a8976280dae288d = v; });
var $e16582d014d3839e$export$1e511d4a378977f5;
var $e16582d014d3839e$export$9a8976280dae288d;
"use strict";
$e16582d014d3839e$export$1e511d4a378977f5 = true;
$e16582d014d3839e$export$9a8976280dae288d = void 0;

var $e16582d014d3839e$var$_react = $e16582d014d3839e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e16582d014d3839e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e16582d014d3839e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e16582d014d3839e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e16582d014d3839e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e16582d014d3839e$var$_extends() {
    return $e16582d014d3839e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e16582d014d3839e$var$_extends.apply(null, arguments);
}
var $e16582d014d3839e$var$DocumentPdf = $e16582d014d3839e$export$9a8976280dae288d = /*#__PURE__*/ (0, $e16582d014d3839e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e16582d014d3839e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e16582d014d3839e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentPdf"
    }, props), /*#__PURE__*/ $e16582d014d3839e$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 9V1H19.5L23 4.5V23H4M18 1v5h5M3 12h1.5c2 0 2.25 1.25 2.25 2s-.25 2-2.25 2H3.25v2H3v-6zm6.5 6v-6h1.705c1.137 0 2.295.5 2.295 3s-1.158 3-2.295 3H9.5zm7 1v-7h4m-4 3.5h3"
    }));
});
$e16582d014d3839e$var$DocumentPdf.displayName = 'DocumentPdf';


Object.keys($e16582d014d3839e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e16582d014d3839e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e16582d014d3839e$exports[key];
});
var $e4b994f7627c9a57$exports = {};

$parcel$export($e4b994f7627c9a57$exports, "__esModule", function () { return $e4b994f7627c9a57$export$1e511d4a378977f5; }, function (v) { return $e4b994f7627c9a57$export$1e511d4a378977f5 = v; });
$parcel$export($e4b994f7627c9a57$exports, "DocumentPerformance", function () { return $e4b994f7627c9a57$export$79ca5226d76bea73; }, function (v) { return $e4b994f7627c9a57$export$79ca5226d76bea73 = v; });
var $e4b994f7627c9a57$export$1e511d4a378977f5;
var $e4b994f7627c9a57$export$79ca5226d76bea73;
"use strict";
$e4b994f7627c9a57$export$1e511d4a378977f5 = true;
$e4b994f7627c9a57$export$79ca5226d76bea73 = void 0;

var $e4b994f7627c9a57$var$_react = $e4b994f7627c9a57$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e4b994f7627c9a57$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e4b994f7627c9a57$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e4b994f7627c9a57$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e4b994f7627c9a57$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e4b994f7627c9a57$var$_extends() {
    return $e4b994f7627c9a57$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e4b994f7627c9a57$var$_extends.apply(null, arguments);
}
var $e4b994f7627c9a57$var$DocumentPerformance = $e4b994f7627c9a57$export$79ca5226d76bea73 = /*#__PURE__*/ (0, $e4b994f7627c9a57$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e4b994f7627c9a57$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e4b994f7627c9a57$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentPerformance"
    }, props), /*#__PURE__*/ $e4b994f7627c9a57$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 9V1H19.5L23 4.5V23H4M18 1v5h5M3 19l5-5 4 4 6.5-6.5M19 17v-6h-6"
    }));
});
$e4b994f7627c9a57$var$DocumentPerformance.displayName = 'DocumentPerformance';


Object.keys($e4b994f7627c9a57$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e4b994f7627c9a57$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e4b994f7627c9a57$exports[key];
});
var $d5e3a4e680fe71e4$exports = {};

$parcel$export($d5e3a4e680fe71e4$exports, "__esModule", function () { return $d5e3a4e680fe71e4$export$1e511d4a378977f5; }, function (v) { return $d5e3a4e680fe71e4$export$1e511d4a378977f5 = v; });
$parcel$export($d5e3a4e680fe71e4$exports, "DocumentPpt", function () { return $d5e3a4e680fe71e4$export$48ada90565649a07; }, function (v) { return $d5e3a4e680fe71e4$export$48ada90565649a07 = v; });
var $d5e3a4e680fe71e4$export$1e511d4a378977f5;
var $d5e3a4e680fe71e4$export$48ada90565649a07;
"use strict";
$d5e3a4e680fe71e4$export$1e511d4a378977f5 = true;
$d5e3a4e680fe71e4$export$48ada90565649a07 = void 0;

var $d5e3a4e680fe71e4$var$_react = $d5e3a4e680fe71e4$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $d5e3a4e680fe71e4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d5e3a4e680fe71e4$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d5e3a4e680fe71e4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d5e3a4e680fe71e4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d5e3a4e680fe71e4$var$_extends() {
    return $d5e3a4e680fe71e4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d5e3a4e680fe71e4$var$_extends.apply(null, arguments);
}
var $d5e3a4e680fe71e4$var$DocumentPpt = $d5e3a4e680fe71e4$export$48ada90565649a07 = /*#__PURE__*/ (0, $d5e3a4e680fe71e4$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d5e3a4e680fe71e4$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $d5e3a4e680fe71e4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentPpt"
    }, props), /*#__PURE__*/ $d5e3a4e680fe71e4$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 9V1H19.5L23 4.5V23H4M18 1v5h5M4 12h1.5c2 0 3.5.5 3.5 2.25S7.5 16.5 5.5 16.5H4.25V19H4v-7z"
    }));
});
$d5e3a4e680fe71e4$var$DocumentPpt.displayName = 'DocumentPpt';


Object.keys($d5e3a4e680fe71e4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $d5e3a4e680fe71e4$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $d5e3a4e680fe71e4$exports[key];
});
var $e2868ae538fe6834$exports = {};

$parcel$export($e2868ae538fe6834$exports, "__esModule", function () { return $e2868ae538fe6834$export$1e511d4a378977f5; }, function (v) { return $e2868ae538fe6834$export$1e511d4a378977f5 = v; });
$parcel$export($e2868ae538fe6834$exports, "DocumentRtf", function () { return $e2868ae538fe6834$export$4617c281ba095456; }, function (v) { return $e2868ae538fe6834$export$4617c281ba095456 = v; });
var $e2868ae538fe6834$export$1e511d4a378977f5;
var $e2868ae538fe6834$export$4617c281ba095456;
"use strict";
$e2868ae538fe6834$export$1e511d4a378977f5 = true;
$e2868ae538fe6834$export$4617c281ba095456 = void 0;

var $e2868ae538fe6834$var$_react = $e2868ae538fe6834$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e2868ae538fe6834$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e2868ae538fe6834$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e2868ae538fe6834$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e2868ae538fe6834$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e2868ae538fe6834$var$_extends() {
    return $e2868ae538fe6834$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e2868ae538fe6834$var$_extends.apply(null, arguments);
}
var $e2868ae538fe6834$var$DocumentRtf = $e2868ae538fe6834$export$4617c281ba095456 = /*#__PURE__*/ (0, $e2868ae538fe6834$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e2868ae538fe6834$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e2868ae538fe6834$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentRtf"
    }, props), /*#__PURE__*/ $e2868ae538fe6834$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 9V1H19.5L23 4.5V23H4M18 1v5h5m-2.5 6h-4v7m3-3.5h-3m-8-3.5h6m-3 0v7M3 19v-7h1.5C5 12 7 12 7 14s-2 2-2.5 2H3m2.25 0 2.25 3"
    }));
});
$e2868ae538fe6834$var$DocumentRtf.displayName = 'DocumentRtf';


Object.keys($e2868ae538fe6834$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e2868ae538fe6834$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e2868ae538fe6834$exports[key];
});
var $13df902cde3fa0cf$exports = {};

$parcel$export($13df902cde3fa0cf$exports, "__esModule", function () { return $13df902cde3fa0cf$export$1e511d4a378977f5; }, function (v) { return $13df902cde3fa0cf$export$1e511d4a378977f5 = v; });
$parcel$export($13df902cde3fa0cf$exports, "DocumentSound", function () { return $13df902cde3fa0cf$export$98a9116f06d89bdf; }, function (v) { return $13df902cde3fa0cf$export$98a9116f06d89bdf = v; });
var $13df902cde3fa0cf$export$1e511d4a378977f5;
var $13df902cde3fa0cf$export$98a9116f06d89bdf;
"use strict";
$13df902cde3fa0cf$export$1e511d4a378977f5 = true;
$13df902cde3fa0cf$export$98a9116f06d89bdf = void 0;

var $13df902cde3fa0cf$var$_react = $13df902cde3fa0cf$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $13df902cde3fa0cf$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($13df902cde3fa0cf$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $13df902cde3fa0cf$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $13df902cde3fa0cf$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $13df902cde3fa0cf$var$_extends() {
    return $13df902cde3fa0cf$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $13df902cde3fa0cf$var$_extends.apply(null, arguments);
}
var $13df902cde3fa0cf$var$DocumentSound = $13df902cde3fa0cf$export$98a9116f06d89bdf = /*#__PURE__*/ (0, $13df902cde3fa0cf$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $13df902cde3fa0cf$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $13df902cde3fa0cf$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentSound"
    }, props), /*#__PURE__*/ $13df902cde3fa0cf$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2.998 9V1H17.5L21 4.5V23h-3M16 1v5h5M1 14.01v4h3l4 3V11l-4 3.01H1zM11 18a2 2 0 1 0 0-4m0 8a6 6 0 1 0 0-12"
    }));
});
$13df902cde3fa0cf$var$DocumentSound.displayName = 'DocumentSound';


Object.keys($13df902cde3fa0cf$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $13df902cde3fa0cf$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $13df902cde3fa0cf$exports[key];
});
var $67f864e75923f592$exports = {};

$parcel$export($67f864e75923f592$exports, "__esModule", function () { return $67f864e75923f592$export$1e511d4a378977f5; }, function (v) { return $67f864e75923f592$export$1e511d4a378977f5 = v; });
$parcel$export($67f864e75923f592$exports, "DocumentStore", function () { return $67f864e75923f592$export$ee5c430a5c32a00b; }, function (v) { return $67f864e75923f592$export$ee5c430a5c32a00b = v; });
var $67f864e75923f592$export$1e511d4a378977f5;
var $67f864e75923f592$export$ee5c430a5c32a00b;
"use strict";
$67f864e75923f592$export$1e511d4a378977f5 = true;
$67f864e75923f592$export$ee5c430a5c32a00b = void 0;

var $67f864e75923f592$var$_react = $67f864e75923f592$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $67f864e75923f592$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($67f864e75923f592$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $67f864e75923f592$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $67f864e75923f592$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $67f864e75923f592$var$_extends() {
    return $67f864e75923f592$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $67f864e75923f592$var$_extends.apply(null, arguments);
}
var $67f864e75923f592$var$DocumentStore = $67f864e75923f592$export$ee5c430a5c32a00b = /*#__PURE__*/ (0, $67f864e75923f592$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $67f864e75923f592$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $67f864e75923f592$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentStore"
    }, props), /*#__PURE__*/ $67f864e75923f592$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 7V1H19.5L23 4.5V23h-6m1-22v5h5M3 12s1-2 6-2 6 2 6 2v9s-1 2-6 2-6-2-6-2v-9zm0 5s2 2 6 2 6-2 6-2M3 13s2 2 6 2 6-2 6-2"
    }));
});
$67f864e75923f592$var$DocumentStore.displayName = 'DocumentStore';


Object.keys($67f864e75923f592$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $67f864e75923f592$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $67f864e75923f592$exports[key];
});
var $ac852159e04ab7b6$exports = {};

$parcel$export($ac852159e04ab7b6$exports, "__esModule", function () { return $ac852159e04ab7b6$export$1e511d4a378977f5; }, function (v) { return $ac852159e04ab7b6$export$1e511d4a378977f5 = v; });
$parcel$export($ac852159e04ab7b6$exports, "DocumentTest", function () { return $ac852159e04ab7b6$export$3810cad4032a6b9f; }, function (v) { return $ac852159e04ab7b6$export$3810cad4032a6b9f = v; });
var $ac852159e04ab7b6$export$1e511d4a378977f5;
var $ac852159e04ab7b6$export$3810cad4032a6b9f;
"use strict";
$ac852159e04ab7b6$export$1e511d4a378977f5 = true;
$ac852159e04ab7b6$export$3810cad4032a6b9f = void 0;

var $ac852159e04ab7b6$var$_react = $ac852159e04ab7b6$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $ac852159e04ab7b6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ac852159e04ab7b6$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ac852159e04ab7b6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ac852159e04ab7b6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ac852159e04ab7b6$var$_extends() {
    return $ac852159e04ab7b6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ac852159e04ab7b6$var$_extends.apply(null, arguments);
}
var $ac852159e04ab7b6$var$DocumentTest = $ac852159e04ab7b6$export$3810cad4032a6b9f = /*#__PURE__*/ (0, $ac852159e04ab7b6$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $ac852159e04ab7b6$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ac852159e04ab7b6$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentTest"
    }, props), /*#__PURE__*/ $ac852159e04ab7b6$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 6V1H19.5L23 4.5V23h-3M18 1v5h5M6 9h8M8 9v4.5l-5 8V23h14v-1.581L12 13.5V9m-6.5 8.5s2 1.5 4.5 0 4.5 0 4.5 0"
    }));
});
$ac852159e04ab7b6$var$DocumentTest.displayName = 'DocumentTest';


Object.keys($ac852159e04ab7b6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ac852159e04ab7b6$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ac852159e04ab7b6$exports[key];
});
var $a0c91956ad8517d7$exports = {};

$parcel$export($a0c91956ad8517d7$exports, "__esModule", function () { return $a0c91956ad8517d7$export$1e511d4a378977f5; }, function (v) { return $a0c91956ad8517d7$export$1e511d4a378977f5 = v; });
$parcel$export($a0c91956ad8517d7$exports, "DocumentText", function () { return $a0c91956ad8517d7$export$1b5fea8128845fdf; }, function (v) { return $a0c91956ad8517d7$export$1b5fea8128845fdf = v; });
var $a0c91956ad8517d7$export$1e511d4a378977f5;
var $a0c91956ad8517d7$export$1b5fea8128845fdf;
"use strict";
$a0c91956ad8517d7$export$1e511d4a378977f5 = true;
$a0c91956ad8517d7$export$1b5fea8128845fdf = void 0;

var $a0c91956ad8517d7$var$_react = $a0c91956ad8517d7$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a0c91956ad8517d7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a0c91956ad8517d7$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a0c91956ad8517d7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a0c91956ad8517d7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a0c91956ad8517d7$var$_extends() {
    return $a0c91956ad8517d7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a0c91956ad8517d7$var$_extends.apply(null, arguments);
}
var $a0c91956ad8517d7$var$DocumentText = $a0c91956ad8517d7$export$1b5fea8128845fdf = /*#__PURE__*/ (0, $a0c91956ad8517d7$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a0c91956ad8517d7$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a0c91956ad8517d7$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentText"
    }, props), /*#__PURE__*/ $a0c91956ad8517d7$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M6 16h10H6zm0-4h12H6zm0-4h5-5zm8-7v7h7M3 23V1h12l6 6v16H3z"
    }));
});
$a0c91956ad8517d7$var$DocumentText.displayName = 'DocumentText';


Object.keys($a0c91956ad8517d7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a0c91956ad8517d7$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a0c91956ad8517d7$exports[key];
});
var $78ef03ef56c33327$exports = {};

$parcel$export($78ef03ef56c33327$exports, "__esModule", function () { return $78ef03ef56c33327$export$1e511d4a378977f5; }, function (v) { return $78ef03ef56c33327$export$1e511d4a378977f5 = v; });
$parcel$export($78ef03ef56c33327$exports, "DocumentThreat", function () { return $78ef03ef56c33327$export$4554dabec990aca5; }, function (v) { return $78ef03ef56c33327$export$4554dabec990aca5 = v; });
var $78ef03ef56c33327$export$1e511d4a378977f5;
var $78ef03ef56c33327$export$4554dabec990aca5;
"use strict";
$78ef03ef56c33327$export$1e511d4a378977f5 = true;
$78ef03ef56c33327$export$4554dabec990aca5 = void 0;

var $78ef03ef56c33327$var$_react = $78ef03ef56c33327$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $78ef03ef56c33327$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($78ef03ef56c33327$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $78ef03ef56c33327$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $78ef03ef56c33327$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $78ef03ef56c33327$var$_extends() {
    return $78ef03ef56c33327$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $78ef03ef56c33327$var$_extends.apply(null, arguments);
}
var $78ef03ef56c33327$var$DocumentThreat = $78ef03ef56c33327$export$4554dabec990aca5 = /*#__PURE__*/ (0, $78ef03ef56c33327$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $78ef03ef56c33327$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $78ef03ef56c33327$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentThreat"
    }, props), /*#__PURE__*/ $78ef03ef56c33327$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 7V1H19.5L23 4.5V23h-6m1-22v5h5M9 23a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm0-12V9c0-1 0-2 2-2s2 1 2 2 0 2 2 2h2m-9 0h2v2H8v-2z"
    }));
});
$78ef03ef56c33327$var$DocumentThreat.displayName = 'DocumentThreat';


Object.keys($78ef03ef56c33327$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $78ef03ef56c33327$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $78ef03ef56c33327$exports[key];
});
var $0f912289af486048$exports = {};

$parcel$export($0f912289af486048$exports, "__esModule", function () { return $0f912289af486048$export$1e511d4a378977f5; }, function (v) { return $0f912289af486048$export$1e511d4a378977f5 = v; });
$parcel$export($0f912289af486048$exports, "DocumentTime", function () { return $0f912289af486048$export$cdf4ab476395e3a; }, function (v) { return $0f912289af486048$export$cdf4ab476395e3a = v; });
var $0f912289af486048$export$1e511d4a378977f5;
var $0f912289af486048$export$cdf4ab476395e3a;
"use strict";
$0f912289af486048$export$1e511d4a378977f5 = true;
$0f912289af486048$export$cdf4ab476395e3a = void 0;

var $0f912289af486048$var$_react = $0f912289af486048$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0f912289af486048$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0f912289af486048$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0f912289af486048$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0f912289af486048$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0f912289af486048$var$_extends() {
    return $0f912289af486048$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0f912289af486048$var$_extends.apply(null, arguments);
}
var $0f912289af486048$var$DocumentTime = $0f912289af486048$export$cdf4ab476395e3a = /*#__PURE__*/ (0, $0f912289af486048$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0f912289af486048$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0f912289af486048$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentTime"
    }, props), /*#__PURE__*/ $0f912289af486048$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 7V1H19.5L23 4.5V23h-6m1-22v5h5M10 23a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm0-11v4l3 3"
    }));
});
$0f912289af486048$var$DocumentTime.displayName = 'DocumentTime';


Object.keys($0f912289af486048$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0f912289af486048$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0f912289af486048$exports[key];
});
var $3debb79bb242e81d$exports = {};

$parcel$export($3debb79bb242e81d$exports, "__esModule", function () { return $3debb79bb242e81d$export$1e511d4a378977f5; }, function (v) { return $3debb79bb242e81d$export$1e511d4a378977f5 = v; });
$parcel$export($3debb79bb242e81d$exports, "DocumentTransfer", function () { return $3debb79bb242e81d$export$d4e97ad511a4ce4f; }, function (v) { return $3debb79bb242e81d$export$d4e97ad511a4ce4f = v; });
var $3debb79bb242e81d$export$1e511d4a378977f5;
var $3debb79bb242e81d$export$d4e97ad511a4ce4f;
"use strict";
$3debb79bb242e81d$export$1e511d4a378977f5 = true;
$3debb79bb242e81d$export$d4e97ad511a4ce4f = void 0;

var $3debb79bb242e81d$var$_react = $3debb79bb242e81d$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $3debb79bb242e81d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3debb79bb242e81d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3debb79bb242e81d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3debb79bb242e81d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3debb79bb242e81d$var$_extends() {
    return $3debb79bb242e81d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3debb79bb242e81d$var$_extends.apply(null, arguments);
}
var $3debb79bb242e81d$var$DocumentTransfer = $3debb79bb242e81d$export$d4e97ad511a4ce4f = /*#__PURE__*/ (0, $3debb79bb242e81d$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3debb79bb242e81d$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3debb79bb242e81d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentTransfer"
    }, props), /*#__PURE__*/ $3debb79bb242e81d$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 9V1H19.5L23 4.5V23H4M18 1v5h5M8 12l-4 4 4 4m-4-4h11"
    }));
});
$3debb79bb242e81d$var$DocumentTransfer.displayName = 'DocumentTransfer';


Object.keys($3debb79bb242e81d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3debb79bb242e81d$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3debb79bb242e81d$exports[key];
});
var $aa0bc1a3fbaa27c5$exports = {};

$parcel$export($aa0bc1a3fbaa27c5$exports, "__esModule", function () { return $aa0bc1a3fbaa27c5$export$1e511d4a378977f5; }, function (v) { return $aa0bc1a3fbaa27c5$export$1e511d4a378977f5 = v; });
$parcel$export($aa0bc1a3fbaa27c5$exports, "DocumentTxt", function () { return $aa0bc1a3fbaa27c5$export$4bf36df358fab0fd; }, function (v) { return $aa0bc1a3fbaa27c5$export$4bf36df358fab0fd = v; });
var $aa0bc1a3fbaa27c5$export$1e511d4a378977f5;
var $aa0bc1a3fbaa27c5$export$4bf36df358fab0fd;
"use strict";
$aa0bc1a3fbaa27c5$export$1e511d4a378977f5 = true;
$aa0bc1a3fbaa27c5$export$4bf36df358fab0fd = void 0;

var $aa0bc1a3fbaa27c5$var$_react = $aa0bc1a3fbaa27c5$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $aa0bc1a3fbaa27c5$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($aa0bc1a3fbaa27c5$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $aa0bc1a3fbaa27c5$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $aa0bc1a3fbaa27c5$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $aa0bc1a3fbaa27c5$var$_extends() {
    return $aa0bc1a3fbaa27c5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $aa0bc1a3fbaa27c5$var$_extends.apply(null, arguments);
}
var $aa0bc1a3fbaa27c5$var$DocumentTxt = $aa0bc1a3fbaa27c5$export$4bf36df358fab0fd = /*#__PURE__*/ (0, $aa0bc1a3fbaa27c5$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $aa0bc1a3fbaa27c5$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $aa0bc1a3fbaa27c5$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentTxt"
    }, props), /*#__PURE__*/ $aa0bc1a3fbaa27c5$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 9V1H19.5L23 4.5V23H4M18 1v5h5M2 12h5m-2.5 0v7M16 12h5m-2.5 0v7m-4-7.5-6 7m0-7 6 7"
    }));
});
$aa0bc1a3fbaa27c5$var$DocumentTxt.displayName = 'DocumentTxt';


Object.keys($aa0bc1a3fbaa27c5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $aa0bc1a3fbaa27c5$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $aa0bc1a3fbaa27c5$exports[key];
});
var $4cc612e289a753ff$exports = {};

$parcel$export($4cc612e289a753ff$exports, "__esModule", function () { return $4cc612e289a753ff$export$1e511d4a378977f5; }, function (v) { return $4cc612e289a753ff$export$1e511d4a378977f5 = v; });
$parcel$export($4cc612e289a753ff$exports, "DocumentUpdate", function () { return $4cc612e289a753ff$export$2f03ec2263bf9eae; }, function (v) { return $4cc612e289a753ff$export$2f03ec2263bf9eae = v; });
var $4cc612e289a753ff$export$1e511d4a378977f5;
var $4cc612e289a753ff$export$2f03ec2263bf9eae;
"use strict";
$4cc612e289a753ff$export$1e511d4a378977f5 = true;
$4cc612e289a753ff$export$2f03ec2263bf9eae = void 0;

var $4cc612e289a753ff$var$_react = $4cc612e289a753ff$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $4cc612e289a753ff$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4cc612e289a753ff$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4cc612e289a753ff$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $4cc612e289a753ff$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $4cc612e289a753ff$var$_extends() {
    return $4cc612e289a753ff$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4cc612e289a753ff$var$_extends.apply(null, arguments);
}
var $4cc612e289a753ff$var$DocumentUpdate = $4cc612e289a753ff$export$2f03ec2263bf9eae = /*#__PURE__*/ (0, $4cc612e289a753ff$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $4cc612e289a753ff$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $4cc612e289a753ff$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentUpdate"
    }, props), /*#__PURE__*/ $4cc612e289a753ff$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2.998 7V1H17.5L21 4.5V23h-6m1-22v5h5M8 23A7 7 0 1 0 8 9a7 7 0 0 0 0 14zm-3.5-6.5L8 13l3.5 3.5m-3.5-3V20"
    }));
});
$4cc612e289a753ff$var$DocumentUpdate.displayName = 'DocumentUpdate';


Object.keys($4cc612e289a753ff$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $4cc612e289a753ff$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $4cc612e289a753ff$exports[key];
});
var $8b2a3a38159eddbd$exports = {};

$parcel$export($8b2a3a38159eddbd$exports, "__esModule", function () { return $8b2a3a38159eddbd$export$1e511d4a378977f5; }, function (v) { return $8b2a3a38159eddbd$export$1e511d4a378977f5 = v; });
$parcel$export($8b2a3a38159eddbd$exports, "DocumentUpload", function () { return $8b2a3a38159eddbd$export$9141d115599e4e05; }, function (v) { return $8b2a3a38159eddbd$export$9141d115599e4e05 = v; });
var $8b2a3a38159eddbd$export$1e511d4a378977f5;
var $8b2a3a38159eddbd$export$9141d115599e4e05;
"use strict";
$8b2a3a38159eddbd$export$1e511d4a378977f5 = true;
$8b2a3a38159eddbd$export$9141d115599e4e05 = void 0;

var $8b2a3a38159eddbd$var$_react = $8b2a3a38159eddbd$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $8b2a3a38159eddbd$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8b2a3a38159eddbd$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8b2a3a38159eddbd$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $8b2a3a38159eddbd$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8b2a3a38159eddbd$var$_extends() {
    return $8b2a3a38159eddbd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8b2a3a38159eddbd$var$_extends.apply(null, arguments);
}
var $8b2a3a38159eddbd$var$DocumentUpload = $8b2a3a38159eddbd$export$9141d115599e4e05 = /*#__PURE__*/ (0, $8b2a3a38159eddbd$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $8b2a3a38159eddbd$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $8b2a3a38159eddbd$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentUpload"
    }, props), /*#__PURE__*/ $8b2a3a38159eddbd$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2.998 1H17.5L21 4.5V23H3L2.998 1zM16 1v5h5m-9 14v-9m-4 3 4-4 4 4"
    }));
});
$8b2a3a38159eddbd$var$DocumentUpload.displayName = 'DocumentUpload';


Object.keys($8b2a3a38159eddbd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $8b2a3a38159eddbd$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $8b2a3a38159eddbd$exports[key];
});
var $825476d1ad946457$exports = {};

$parcel$export($825476d1ad946457$exports, "__esModule", function () { return $825476d1ad946457$export$1e511d4a378977f5; }, function (v) { return $825476d1ad946457$export$1e511d4a378977f5 = v; });
$parcel$export($825476d1ad946457$exports, "DocumentUser", function () { return $825476d1ad946457$export$2a780b730cfdcb8; }, function (v) { return $825476d1ad946457$export$2a780b730cfdcb8 = v; });
var $825476d1ad946457$export$1e511d4a378977f5;
var $825476d1ad946457$export$2a780b730cfdcb8;
"use strict";
$825476d1ad946457$export$1e511d4a378977f5 = true;
$825476d1ad946457$export$2a780b730cfdcb8 = void 0;

var $825476d1ad946457$var$_react = $825476d1ad946457$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $825476d1ad946457$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($825476d1ad946457$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $825476d1ad946457$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $825476d1ad946457$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $825476d1ad946457$var$_extends() {
    return $825476d1ad946457$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $825476d1ad946457$var$_extends.apply(null, arguments);
}
var $825476d1ad946457$var$DocumentUser = $825476d1ad946457$export$2a780b730cfdcb8 = /*#__PURE__*/ (0, $825476d1ad946457$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $825476d1ad946457$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $825476d1ad946457$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentUser"
    }, props), /*#__PURE__*/ $825476d1ad946457$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 9V1H19.5L23 4.5V23h-7m2-22v5h5M8 11a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM3 23v-1c0-4 3-5 5-5s5 1 5 5v1H3z"
    }));
});
$825476d1ad946457$var$DocumentUser.displayName = 'DocumentUser';


Object.keys($825476d1ad946457$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $825476d1ad946457$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $825476d1ad946457$exports[key];
});
var $75744b0967190fb4$exports = {};

$parcel$export($75744b0967190fb4$exports, "__esModule", function () { return $75744b0967190fb4$export$1e511d4a378977f5; }, function (v) { return $75744b0967190fb4$export$1e511d4a378977f5 = v; });
$parcel$export($75744b0967190fb4$exports, "DocumentVerified", function () { return $75744b0967190fb4$export$a2d1aa8c93ec8809; }, function (v) { return $75744b0967190fb4$export$a2d1aa8c93ec8809 = v; });
var $75744b0967190fb4$export$1e511d4a378977f5;
var $75744b0967190fb4$export$a2d1aa8c93ec8809;
"use strict";
$75744b0967190fb4$export$1e511d4a378977f5 = true;
$75744b0967190fb4$export$a2d1aa8c93ec8809 = void 0;

var $75744b0967190fb4$var$_react = $75744b0967190fb4$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $75744b0967190fb4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($75744b0967190fb4$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $75744b0967190fb4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $75744b0967190fb4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $75744b0967190fb4$var$_extends() {
    return $75744b0967190fb4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $75744b0967190fb4$var$_extends.apply(null, arguments);
}
var $75744b0967190fb4$var$DocumentVerified = $75744b0967190fb4$export$a2d1aa8c93ec8809 = /*#__PURE__*/ (0, $75744b0967190fb4$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $75744b0967190fb4$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $75744b0967190fb4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentVerified"
    }, props), /*#__PURE__*/ $75744b0967190fb4$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2.998 1H17.5L21 4.5V23H3L2.998 1zM16 1v5h5M7.5 15l3 3 6-6"
    }));
});
$75744b0967190fb4$var$DocumentVerified.displayName = 'DocumentVerified';


Object.keys($75744b0967190fb4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $75744b0967190fb4$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $75744b0967190fb4$exports[key];
});
var $05f6536c3463cc30$exports = {};

$parcel$export($05f6536c3463cc30$exports, "__esModule", function () { return $05f6536c3463cc30$export$1e511d4a378977f5; }, function (v) { return $05f6536c3463cc30$export$1e511d4a378977f5 = v; });
$parcel$export($05f6536c3463cc30$exports, "DocumentVideo", function () { return $05f6536c3463cc30$export$971a01590c824813; }, function (v) { return $05f6536c3463cc30$export$971a01590c824813 = v; });
var $05f6536c3463cc30$export$1e511d4a378977f5;
var $05f6536c3463cc30$export$971a01590c824813;
"use strict";
$05f6536c3463cc30$export$1e511d4a378977f5 = true;
$05f6536c3463cc30$export$971a01590c824813 = void 0;

var $05f6536c3463cc30$var$_react = $05f6536c3463cc30$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $05f6536c3463cc30$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($05f6536c3463cc30$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $05f6536c3463cc30$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $05f6536c3463cc30$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $05f6536c3463cc30$var$_extends() {
    return $05f6536c3463cc30$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $05f6536c3463cc30$var$_extends.apply(null, arguments);
}
var $05f6536c3463cc30$var$DocumentVideo = $05f6536c3463cc30$export$971a01590c824813 = /*#__PURE__*/ (0, $05f6536c3463cc30$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $05f6536c3463cc30$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $05f6536c3463cc30$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentVideo"
    }, props), /*#__PURE__*/ $05f6536c3463cc30$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 7V1H19.5L23 4.5V23H4M18 1v5h5M3 10h9v9H3v-9zm9 3 5-2.5v8L12 16v-3z"
    }));
});
$05f6536c3463cc30$var$DocumentVideo.displayName = 'DocumentVideo';


Object.keys($05f6536c3463cc30$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $05f6536c3463cc30$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $05f6536c3463cc30$exports[key];
});
var $5c7eba8ac392b469$exports = {};

$parcel$export($5c7eba8ac392b469$exports, "__esModule", function () { return $5c7eba8ac392b469$export$1e511d4a378977f5; }, function (v) { return $5c7eba8ac392b469$export$1e511d4a378977f5 = v; });
$parcel$export($5c7eba8ac392b469$exports, "DocumentWindows", function () { return $5c7eba8ac392b469$export$225ed8a6ac11db74; }, function (v) { return $5c7eba8ac392b469$export$225ed8a6ac11db74 = v; });
var $5c7eba8ac392b469$export$1e511d4a378977f5;
var $5c7eba8ac392b469$export$225ed8a6ac11db74;
"use strict";
$5c7eba8ac392b469$export$1e511d4a378977f5 = true;
$5c7eba8ac392b469$export$225ed8a6ac11db74 = void 0;

var $5c7eba8ac392b469$var$_react = $5c7eba8ac392b469$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5c7eba8ac392b469$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5c7eba8ac392b469$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5c7eba8ac392b469$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5c7eba8ac392b469$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5c7eba8ac392b469$var$_extends() {
    return $5c7eba8ac392b469$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5c7eba8ac392b469$var$_extends.apply(null, arguments);
}
var $5c7eba8ac392b469$var$DocumentWindows = $5c7eba8ac392b469$export$225ed8a6ac11db74 = /*#__PURE__*/ (0, $5c7eba8ac392b469$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5c7eba8ac392b469$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5c7eba8ac392b469$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentWindows"
    }, props), /*#__PURE__*/ $5c7eba8ac392b469$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 9V1H19.5L23 4.5V23H4M18 1v5h5m-8.75 5.5-6 7m0-7 6 7M20.5 12h-4v6h4m-1-3h-3M7 12H3v6h4m-1-3H3"
    }));
});
$5c7eba8ac392b469$var$DocumentWindows.displayName = 'DocumentWindows';


Object.keys($5c7eba8ac392b469$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5c7eba8ac392b469$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5c7eba8ac392b469$exports[key];
});
var $d888a2f7146de0b4$exports = {};

$parcel$export($d888a2f7146de0b4$exports, "__esModule", function () { return $d888a2f7146de0b4$export$1e511d4a378977f5; }, function (v) { return $d888a2f7146de0b4$export$1e511d4a378977f5 = v; });
$parcel$export($d888a2f7146de0b4$exports, "DocumentWord", function () { return $d888a2f7146de0b4$export$5d30858d3ce350b8; }, function (v) { return $d888a2f7146de0b4$export$5d30858d3ce350b8 = v; });
var $d888a2f7146de0b4$export$1e511d4a378977f5;
var $d888a2f7146de0b4$export$5d30858d3ce350b8;
"use strict";
$d888a2f7146de0b4$export$1e511d4a378977f5 = true;
$d888a2f7146de0b4$export$5d30858d3ce350b8 = void 0;

var $d888a2f7146de0b4$var$_react = $d888a2f7146de0b4$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $d888a2f7146de0b4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d888a2f7146de0b4$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d888a2f7146de0b4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d888a2f7146de0b4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d888a2f7146de0b4$var$_extends() {
    return $d888a2f7146de0b4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d888a2f7146de0b4$var$_extends.apply(null, arguments);
}
var $d888a2f7146de0b4$var$DocumentWord = $d888a2f7146de0b4$export$5d30858d3ce350b8 = /*#__PURE__*/ (0, $d888a2f7146de0b4$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d888a2f7146de0b4$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $d888a2f7146de0b4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentWord"
    }, props), /*#__PURE__*/ $d888a2f7146de0b4$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 9V1H19.5L23 4.5V23H4M18 1v5h5m-9 6-1.5 6.75h-.25L9.5 12H9l-2.75 6.75H6L4.5 12H4l2 7h.5L9 12.5h.5L12 19h.5l2-7H14z"
    }));
});
$d888a2f7146de0b4$var$DocumentWord.displayName = 'DocumentWord';


Object.keys($d888a2f7146de0b4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $d888a2f7146de0b4$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $d888a2f7146de0b4$exports[key];
});
var $0a6ee20c23a7fb67$exports = {};

$parcel$export($0a6ee20c23a7fb67$exports, "__esModule", function () { return $0a6ee20c23a7fb67$export$1e511d4a378977f5; }, function (v) { return $0a6ee20c23a7fb67$export$1e511d4a378977f5 = v; });
$parcel$export($0a6ee20c23a7fb67$exports, "DocumentZip", function () { return $0a6ee20c23a7fb67$export$652e2e77d7421c2c; }, function (v) { return $0a6ee20c23a7fb67$export$652e2e77d7421c2c = v; });
var $0a6ee20c23a7fb67$export$1e511d4a378977f5;
var $0a6ee20c23a7fb67$export$652e2e77d7421c2c;
"use strict";
$0a6ee20c23a7fb67$export$1e511d4a378977f5 = true;
$0a6ee20c23a7fb67$export$652e2e77d7421c2c = void 0;

var $0a6ee20c23a7fb67$var$_react = $0a6ee20c23a7fb67$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0a6ee20c23a7fb67$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0a6ee20c23a7fb67$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0a6ee20c23a7fb67$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0a6ee20c23a7fb67$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0a6ee20c23a7fb67$var$_extends() {
    return $0a6ee20c23a7fb67$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0a6ee20c23a7fb67$var$_extends.apply(null, arguments);
}
var $0a6ee20c23a7fb67$var$DocumentZip = $0a6ee20c23a7fb67$export$652e2e77d7421c2c = /*#__PURE__*/ (0, $0a6ee20c23a7fb67$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0a6ee20c23a7fb67$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0a6ee20c23a7fb67$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentZip"
    }, props), /*#__PURE__*/ $0a6ee20c23a7fb67$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 9V1H19.5L23 4.5V23H4M18 1v5h5M2 13h5v1l-4 4v1h5m3-7v8-8zm4 1v7-7zm5 2a2 2 0 0 0-2-2h-3v4h3a2 2 0 0 0 2-2z"
    }));
});
$0a6ee20c23a7fb67$var$DocumentZip.displayName = 'DocumentZip';


Object.keys($0a6ee20c23a7fb67$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0a6ee20c23a7fb67$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0a6ee20c23a7fb67$exports[key];
});
var $9e45c2590fd957cb$exports = {};

$parcel$export($9e45c2590fd957cb$exports, "__esModule", function () { return $9e45c2590fd957cb$export$1e511d4a378977f5; }, function (v) { return $9e45c2590fd957cb$export$1e511d4a378977f5 = v; });
$parcel$export($9e45c2590fd957cb$exports, "Document", function () { return $9e45c2590fd957cb$export$b34a105447964f9f; }, function (v) { return $9e45c2590fd957cb$export$b34a105447964f9f = v; });
var $9e45c2590fd957cb$export$1e511d4a378977f5;
var $9e45c2590fd957cb$export$b34a105447964f9f;
"use strict";
$9e45c2590fd957cb$export$1e511d4a378977f5 = true;
$9e45c2590fd957cb$export$b34a105447964f9f = void 0;

var $9e45c2590fd957cb$var$_react = $9e45c2590fd957cb$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $9e45c2590fd957cb$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9e45c2590fd957cb$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9e45c2590fd957cb$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $9e45c2590fd957cb$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $9e45c2590fd957cb$var$_extends() {
    return $9e45c2590fd957cb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9e45c2590fd957cb$var$_extends.apply(null, arguments);
}
var $9e45c2590fd957cb$var$Document = $9e45c2590fd957cb$export$b34a105447964f9f = /*#__PURE__*/ (0, $9e45c2590fd957cb$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $9e45c2590fd957cb$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $9e45c2590fd957cb$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Document"
    }, props), /*#__PURE__*/ $9e45c2590fd957cb$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M14 1v7h7m0 15H3V1h12l3 3 3 3v16z"
    }));
});
$9e45c2590fd957cb$var$Document.displayName = 'Document';


Object.keys($9e45c2590fd957cb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $9e45c2590fd957cb$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $9e45c2590fd957cb$exports[key];
});
var $6d7b6d74a527c70e$exports = {};

$parcel$export($6d7b6d74a527c70e$exports, "__esModule", function () { return $6d7b6d74a527c70e$export$1e511d4a378977f5; }, function (v) { return $6d7b6d74a527c70e$export$1e511d4a378977f5 = v; });
$parcel$export($6d7b6d74a527c70e$exports, "Domain", function () { return $6d7b6d74a527c70e$export$f102e87ccfb079d0; }, function (v) { return $6d7b6d74a527c70e$export$f102e87ccfb079d0 = v; });
var $6d7b6d74a527c70e$export$1e511d4a378977f5;
var $6d7b6d74a527c70e$export$f102e87ccfb079d0;
"use strict";
$6d7b6d74a527c70e$export$1e511d4a378977f5 = true;
$6d7b6d74a527c70e$export$f102e87ccfb079d0 = void 0;

var $6d7b6d74a527c70e$var$_react = $6d7b6d74a527c70e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $6d7b6d74a527c70e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6d7b6d74a527c70e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6d7b6d74a527c70e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6d7b6d74a527c70e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6d7b6d74a527c70e$var$_extends() {
    return $6d7b6d74a527c70e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6d7b6d74a527c70e$var$_extends.apply(null, arguments);
}
var $6d7b6d74a527c70e$var$Domain = $6d7b6d74a527c70e$export$f102e87ccfb079d0 = /*#__PURE__*/ (0, $6d7b6d74a527c70e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $6d7b6d74a527c70e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $6d7b6d74a527c70e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Domain"
    }, props), /*#__PURE__*/ $6d7b6d74a527c70e$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M13 3v4-4zM9 3v4-4zM5 3v4-4zM1 7h22H1zm0 14h22V3H1v18z"
    }));
});
$6d7b6d74a527c70e$var$Domain.displayName = 'Domain';


Object.keys($6d7b6d74a527c70e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $6d7b6d74a527c70e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $6d7b6d74a527c70e$exports[key];
});
var $fc4f6af1d485dfe9$exports = {};

$parcel$export($fc4f6af1d485dfe9$exports, "__esModule", function () { return $fc4f6af1d485dfe9$export$1e511d4a378977f5; }, function (v) { return $fc4f6af1d485dfe9$export$1e511d4a378977f5 = v; });
$parcel$export($fc4f6af1d485dfe9$exports, "Dos", function () { return $fc4f6af1d485dfe9$export$86d67ec68a50204c; }, function (v) { return $fc4f6af1d485dfe9$export$86d67ec68a50204c = v; });
var $fc4f6af1d485dfe9$export$1e511d4a378977f5;
var $fc4f6af1d485dfe9$export$86d67ec68a50204c;
"use strict";
$fc4f6af1d485dfe9$export$1e511d4a378977f5 = true;
$fc4f6af1d485dfe9$export$86d67ec68a50204c = void 0;

var $fc4f6af1d485dfe9$var$_react = $fc4f6af1d485dfe9$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $fc4f6af1d485dfe9$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($fc4f6af1d485dfe9$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $fc4f6af1d485dfe9$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $fc4f6af1d485dfe9$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $fc4f6af1d485dfe9$var$_extends() {
    return $fc4f6af1d485dfe9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fc4f6af1d485dfe9$var$_extends.apply(null, arguments);
}
var $fc4f6af1d485dfe9$var$Dos = $fc4f6af1d485dfe9$export$86d67ec68a50204c = /*#__PURE__*/ (0, $fc4f6af1d485dfe9$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $fc4f6af1d485dfe9$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $fc4f6af1d485dfe9$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Dos"
    }, props), /*#__PURE__*/ $fc4f6af1d485dfe9$var$_react["default"].createElement("path", {
        fill: "#333",
        fillRule: "evenodd",
        d: "m0 4.546 4.934-.124c.958-.02 1.844.082 2.74.392v.175C6.9 5.648 6.345 6.43 5.84 7.306l-2.997.021.02 8.498 1.772.123 1.813-.02c1.082-.011 2.08-1.741 2.174-2.679l.267-2.955c.114-1.298.865-2.297 2.03-2.833.73 1.226 1.05 2.585 1.05 4.017 0 4.501-2.791 7.344-7.19 7.18L0 18.471V4.546zm20.704 4.172c-.237-1.37-1.38-2.05-2.75-2.05-.938 0-2.473.411-2.524 1.586-.01.062 0 .113.02.165l.557 1.596c.113.33.134.69.134 1.04 0 .402-.052.804-.103 1.206-1.978-.556-3.369-1.514-3.369-3.74 0-2.997 2.421-4.398 5.181-4.398 3.07 0 5.47 1.432 5.666 4.595h-2.812zm-8.24 5.366 2.75.02c.288 1.762 1.452 2.246 3.182 2.246 1.082 0 2.699-.257 2.699-1.638 0-.72-.567-1.092-1.143-1.41l.144-2.75c2.194.596 3.904 1.42 3.904 3.995 0 3.05-2.905 4.337-5.583 4.337-1.916 0-4.398-.556-5.418-2.369-.32-.556-.618-1.277-.618-1.926a.78.78 0 0 1 .02-.155l.062-.35zm7.24-2.627c0 1.576-.422 3.049-1.143 4.43-.185.01-.37.03-.556.03-.597 0-2.05-.401-2.05-1.133 0-.123.02-.247.062-.36l.546-1.823c.113-.36.072-.794.072-1.154 0-1.411-.639-2.297-.69-3.265-.03-.68 1.257-1 1.71-1 .309 0 .618 0 .927.031a8.49 8.49 0 0 1 1.123 4.244zM10.61 17.03l.648-.927 1.082.02c.515 1.123 1.36 1.885 2.39 2.545a7.166 7.166 0 0 1-2.277.37c-1.143 0-2.215-.257-3.275-.659l1.432-1.35zm1.926-10.321a8.19 8.19 0 0 0-.495-.02c-1.74 0-3.327 1.523-3.533 3.233l-.453 3.719c-.062.525-.515 1.06-.855 1.442-.288.309-.628.37-1.05.37h-.052a9.589 9.589 0 0 1-.814-3.862C5.284 7.358 7.654 4 12.062 4c.865 0 1.689.165 2.502.391-.864.639-1.544 1.35-2.028 2.318z"
    }));
});
$fc4f6af1d485dfe9$var$Dos.displayName = 'Dos';


Object.keys($fc4f6af1d485dfe9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $fc4f6af1d485dfe9$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $fc4f6af1d485dfe9$exports[key];
});
var $456f0011a094194c$exports = {};

$parcel$export($456f0011a094194c$exports, "__esModule", function () { return $456f0011a094194c$export$1e511d4a378977f5; }, function (v) { return $456f0011a094194c$export$1e511d4a378977f5 = v; });
$parcel$export($456f0011a094194c$exports, "Down", function () { return $456f0011a094194c$export$b30b8791dbbface4; }, function (v) { return $456f0011a094194c$export$b30b8791dbbface4 = v; });
var $456f0011a094194c$export$1e511d4a378977f5;
var $456f0011a094194c$export$b30b8791dbbface4;
"use strict";
$456f0011a094194c$export$1e511d4a378977f5 = true;
$456f0011a094194c$export$b30b8791dbbface4 = void 0;

var $456f0011a094194c$var$_react = $456f0011a094194c$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $456f0011a094194c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($456f0011a094194c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $456f0011a094194c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $456f0011a094194c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $456f0011a094194c$var$_extends() {
    return $456f0011a094194c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $456f0011a094194c$var$_extends.apply(null, arguments);
}
var $456f0011a094194c$var$Down = $456f0011a094194c$export$b30b8791dbbface4 = /*#__PURE__*/ (0, $456f0011a094194c$var$_react.forwardRef)(function(props, ref) {
    var scaleProps = (0, $1b754218be0a6592$export$56a2e46cd4a7c217)(props);
    return /*#__PURE__*/ $456f0011a094194c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $456f0011a094194c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Down"
    }, props), /*#__PURE__*/ $456f0011a094194c$var$_react["default"].createElement("path", $456f0011a094194c$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m2 8.35 10.173 9.823L21.997 8"
    }, scaleProps)));
});
$456f0011a094194c$var$Down.displayName = 'Down';


Object.keys($456f0011a094194c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $456f0011a094194c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $456f0011a094194c$exports[key];
});
var $02ae6fb6c8f5469d$exports = {};

$parcel$export($02ae6fb6c8f5469d$exports, "__esModule", function () { return $02ae6fb6c8f5469d$export$1e511d4a378977f5; }, function (v) { return $02ae6fb6c8f5469d$export$1e511d4a378977f5 = v; });
$parcel$export($02ae6fb6c8f5469d$exports, "DownloadOption", function () { return $02ae6fb6c8f5469d$export$6b86e9f2aeb0c0bc; }, function (v) { return $02ae6fb6c8f5469d$export$6b86e9f2aeb0c0bc = v; });
var $02ae6fb6c8f5469d$export$1e511d4a378977f5;
var $02ae6fb6c8f5469d$export$6b86e9f2aeb0c0bc;
"use strict";
$02ae6fb6c8f5469d$export$1e511d4a378977f5 = true;
$02ae6fb6c8f5469d$export$6b86e9f2aeb0c0bc = void 0;

var $02ae6fb6c8f5469d$var$_react = $02ae6fb6c8f5469d$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $02ae6fb6c8f5469d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($02ae6fb6c8f5469d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $02ae6fb6c8f5469d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $02ae6fb6c8f5469d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $02ae6fb6c8f5469d$var$_extends() {
    return $02ae6fb6c8f5469d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $02ae6fb6c8f5469d$var$_extends.apply(null, arguments);
}
var $02ae6fb6c8f5469d$var$DownloadOption = $02ae6fb6c8f5469d$export$6b86e9f2aeb0c0bc = /*#__PURE__*/ (0, $02ae6fb6c8f5469d$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $02ae6fb6c8f5469d$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $02ae6fb6c8f5469d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DownloadOption"
    }, props), /*#__PURE__*/ $02ae6fb6c8f5469d$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zM2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12zm14.293-.707L13 14.586V6h-2v8.586l-3.293-3.293-1.414 1.414 5 5 .707.707.707-.707 5-5-1.414-1.414z",
        fill: "#000"
    }));
});
$02ae6fb6c8f5469d$var$DownloadOption.displayName = 'DownloadOption';


Object.keys($02ae6fb6c8f5469d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $02ae6fb6c8f5469d$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $02ae6fb6c8f5469d$exports[key];
});
var $88fc2ba061f3e6a6$exports = {};

$parcel$export($88fc2ba061f3e6a6$exports, "__esModule", function () { return $88fc2ba061f3e6a6$export$1e511d4a378977f5; }, function (v) { return $88fc2ba061f3e6a6$export$1e511d4a378977f5 = v; });
$parcel$export($88fc2ba061f3e6a6$exports, "Download", function () { return $88fc2ba061f3e6a6$export$a7aaed3e118dd255; }, function (v) { return $88fc2ba061f3e6a6$export$a7aaed3e118dd255 = v; });
var $88fc2ba061f3e6a6$export$1e511d4a378977f5;
var $88fc2ba061f3e6a6$export$a7aaed3e118dd255;
"use strict";
$88fc2ba061f3e6a6$export$1e511d4a378977f5 = true;
$88fc2ba061f3e6a6$export$a7aaed3e118dd255 = void 0;

var $88fc2ba061f3e6a6$var$_react = $88fc2ba061f3e6a6$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $88fc2ba061f3e6a6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($88fc2ba061f3e6a6$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $88fc2ba061f3e6a6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $88fc2ba061f3e6a6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $88fc2ba061f3e6a6$var$_extends() {
    return $88fc2ba061f3e6a6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $88fc2ba061f3e6a6$var$_extends.apply(null, arguments);
}
var $88fc2ba061f3e6a6$var$Download = $88fc2ba061f3e6a6$export$a7aaed3e118dd255 = /*#__PURE__*/ (0, $88fc2ba061f3e6a6$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $88fc2ba061f3e6a6$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $88fc2ba061f3e6a6$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Download"
    }, props), /*#__PURE__*/ $88fc2ba061f3e6a6$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 17v6h22v-6M12 2v17m-7-7 7 7 7-7"
    }));
});
$88fc2ba061f3e6a6$var$Download.displayName = 'Download';


Object.keys($88fc2ba061f3e6a6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $88fc2ba061f3e6a6$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $88fc2ba061f3e6a6$exports[key];
});
var $3d30e4dd694c96a4$exports = {};

$parcel$export($3d30e4dd694c96a4$exports, "__esModule", function () { return $3d30e4dd694c96a4$export$1e511d4a378977f5; }, function (v) { return $3d30e4dd694c96a4$export$1e511d4a378977f5 = v; });
$parcel$export($3d30e4dd694c96a4$exports, "Drag", function () { return $3d30e4dd694c96a4$export$b48985bba8f530f5; }, function (v) { return $3d30e4dd694c96a4$export$b48985bba8f530f5 = v; });
var $3d30e4dd694c96a4$export$1e511d4a378977f5;
var $3d30e4dd694c96a4$export$b48985bba8f530f5;
"use strict";
$3d30e4dd694c96a4$export$1e511d4a378977f5 = true;
$3d30e4dd694c96a4$export$b48985bba8f530f5 = void 0;

var $3d30e4dd694c96a4$var$_react = $3d30e4dd694c96a4$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $3d30e4dd694c96a4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3d30e4dd694c96a4$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3d30e4dd694c96a4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3d30e4dd694c96a4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3d30e4dd694c96a4$var$_extends() {
    return $3d30e4dd694c96a4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3d30e4dd694c96a4$var$_extends.apply(null, arguments);
}
var $3d30e4dd694c96a4$var$Drag = $3d30e4dd694c96a4$export$b48985bba8f530f5 = /*#__PURE__*/ (0, $3d30e4dd694c96a4$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3d30e4dd694c96a4$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3d30e4dd694c96a4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Drag"
    }, props), /*#__PURE__*/ $3d30e4dd694c96a4$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M15 5h2V3h-2v2zM7 5h2V3H7v2zm8 8h2v-2h-2v2zm-8 0h2v-2H7v2zm8 8h2v-2h-2v2zm-8 0h2v-2H7v2z"
    }));
});
$3d30e4dd694c96a4$var$Drag.displayName = 'Drag';


Object.keys($3d30e4dd694c96a4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3d30e4dd694c96a4$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3d30e4dd694c96a4$exports[key];
});
var $429b63b9171b870c$exports = {};

$parcel$export($429b63b9171b870c$exports, "__esModule", function () { return $429b63b9171b870c$export$1e511d4a378977f5; }, function (v) { return $429b63b9171b870c$export$1e511d4a378977f5 = v; });
$parcel$export($429b63b9171b870c$exports, "Drawer", function () { return $429b63b9171b870c$export$4071300121a182f5; }, function (v) { return $429b63b9171b870c$export$4071300121a182f5 = v; });
var $429b63b9171b870c$export$1e511d4a378977f5;
var $429b63b9171b870c$export$4071300121a182f5;
"use strict";
$429b63b9171b870c$export$1e511d4a378977f5 = true;
$429b63b9171b870c$export$4071300121a182f5 = void 0;

var $429b63b9171b870c$var$_react = $429b63b9171b870c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $429b63b9171b870c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($429b63b9171b870c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $429b63b9171b870c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $429b63b9171b870c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $429b63b9171b870c$var$_extends() {
    return $429b63b9171b870c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $429b63b9171b870c$var$_extends.apply(null, arguments);
}
var $429b63b9171b870c$var$Drawer = $429b63b9171b870c$export$4071300121a182f5 = /*#__PURE__*/ (0, $429b63b9171b870c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $429b63b9171b870c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $429b63b9171b870c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Drawer"
    }, props), /*#__PURE__*/ $429b63b9171b870c$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 14 6 2h12l5 12-2 8H3l-2-8zm0 0h22"
    }));
});
$429b63b9171b870c$var$Drawer.displayName = 'Drawer';


Object.keys($429b63b9171b870c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $429b63b9171b870c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $429b63b9171b870c$exports[key];
});
var $c5afa2f6f5498dbd$exports = {};

$parcel$export($c5afa2f6f5498dbd$exports, "__esModule", function () { return $c5afa2f6f5498dbd$export$1e511d4a378977f5; }, function (v) { return $c5afa2f6f5498dbd$export$1e511d4a378977f5 = v; });
$parcel$export($c5afa2f6f5498dbd$exports, "Dribbble", function () { return $c5afa2f6f5498dbd$export$66c7b03233506adc; }, function (v) { return $c5afa2f6f5498dbd$export$66c7b03233506adc = v; });
var $c5afa2f6f5498dbd$export$1e511d4a378977f5;
var $c5afa2f6f5498dbd$export$66c7b03233506adc;
"use strict";
$c5afa2f6f5498dbd$export$1e511d4a378977f5 = true;
$c5afa2f6f5498dbd$export$66c7b03233506adc = void 0;

var $c5afa2f6f5498dbd$var$_react = $c5afa2f6f5498dbd$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c5afa2f6f5498dbd$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c5afa2f6f5498dbd$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c5afa2f6f5498dbd$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c5afa2f6f5498dbd$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c5afa2f6f5498dbd$var$_extends() {
    return $c5afa2f6f5498dbd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c5afa2f6f5498dbd$var$_extends.apply(null, arguments);
}
var $c5afa2f6f5498dbd$var$Dribbble = $c5afa2f6f5498dbd$export$66c7b03233506adc = /*#__PURE__*/ (0, $c5afa2f6f5498dbd$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c5afa2f6f5498dbd$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c5afa2f6f5498dbd$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Dribbble"
    }, props), /*#__PURE__*/ $c5afa2f6f5498dbd$var$_react["default"].createElement("path", {
        fill: "#E74D89",
        d: "M11.432 8.635c-1.77-3.15-3.666-5.716-3.803-5.904A10.263 10.263 0 0 0 1.97 9.887c.27.004 4.54.056 9.46-1.252zm1.278 3.443c.135-.041.27-.083.404-.122a34.204 34.204 0 0 0-.832-1.741c-5.278 1.58-10.342 1.464-10.521 1.46-.003.107-.008.215-.008.325a10.2 10.2 0 0 0 2.63 6.852l-.007-.01s2.804-4.976 8.334-6.764zM5.701 20.08l.003-.005c-.076-.058-.157-.115-.233-.176.137.11.23.181.23.181zM9.62 2.076c-.036.01-.063.02-.1.03a.535.535 0 0 1 .1-.03zm9.15 2.234A10.198 10.198 0 0 0 12 1.751c-.833 0-1.64.103-2.415.289.157.206 2.08 2.762 3.83 5.978 3.865-1.447 5.327-3.666 5.354-3.708zM12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm1.744-10.322c-6.015 2.096-8.001 6.31-8.04 6.396A10.2 10.2 0 0 0 12 22.247c1.42 0 2.772-.29 4.002-.811-.152-.899-.747-4.038-2.19-7.783-.024.01-.046.015-.068.025zm.46-4.132a30.12 30.12 0 0 1 .901 2.016c3.54-.446 7.024.31 7.14.335a10.206 10.206 0 0 0-2.332-6.406c-.02.029-1.663 2.405-5.709 4.055zm1.528 3.634c1.347 3.698 1.89 6.708 1.994 7.32a10.242 10.242 0 0 0 4.39-6.874c-.203-.066-3.07-.977-6.384-.446z"
    }));
});
$c5afa2f6f5498dbd$var$Dribbble.displayName = 'Dribbble';


Object.keys($c5afa2f6f5498dbd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c5afa2f6f5498dbd$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c5afa2f6f5498dbd$exports[key];
});
var $c23091bd7df045bc$exports = {};

$parcel$export($c23091bd7df045bc$exports, "__esModule", function () { return $c23091bd7df045bc$export$1e511d4a378977f5; }, function (v) { return $c23091bd7df045bc$export$1e511d4a378977f5 = v; });
$parcel$export($c23091bd7df045bc$exports, "DriveCage", function () { return $c23091bd7df045bc$export$f29d16dc2ab0af7f; }, function (v) { return $c23091bd7df045bc$export$f29d16dc2ab0af7f = v; });
var $c23091bd7df045bc$export$1e511d4a378977f5;
var $c23091bd7df045bc$export$f29d16dc2ab0af7f;
"use strict";
$c23091bd7df045bc$export$1e511d4a378977f5 = true;
$c23091bd7df045bc$export$f29d16dc2ab0af7f = void 0;

var $c23091bd7df045bc$var$_react = $c23091bd7df045bc$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c23091bd7df045bc$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c23091bd7df045bc$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c23091bd7df045bc$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c23091bd7df045bc$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c23091bd7df045bc$var$_extends() {
    return $c23091bd7df045bc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c23091bd7df045bc$var$_extends.apply(null, arguments);
}
var $c23091bd7df045bc$var$DriveCage = $c23091bd7df045bc$export$f29d16dc2ab0af7f = /*#__PURE__*/ (0, $c23091bd7df045bc$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c23091bd7df045bc$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c23091bd7df045bc$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DriveCage"
    }, props), /*#__PURE__*/ $c23091bd7df045bc$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 23V2h22v21M1 8h22H1zm0 6h22H1zm0 6h22H1zM4 5h12H4zm14 0h2-2zm0 6h2-2zm0 6h2-2zM4 11h12H4zm0 6h12H4z"
    }));
});
$c23091bd7df045bc$var$DriveCage.displayName = 'DriveCage';


Object.keys($c23091bd7df045bc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c23091bd7df045bc$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c23091bd7df045bc$exports[key];
});
var $9831ebf7a15044cb$exports = {};

$parcel$export($9831ebf7a15044cb$exports, "__esModule", function () { return $9831ebf7a15044cb$export$1e511d4a378977f5; }, function (v) { return $9831ebf7a15044cb$export$1e511d4a378977f5 = v; });
$parcel$export($9831ebf7a15044cb$exports, "Dropbox", function () { return $9831ebf7a15044cb$export$a8b78cb9fb18b384; }, function (v) { return $9831ebf7a15044cb$export$a8b78cb9fb18b384 = v; });
var $9831ebf7a15044cb$export$1e511d4a378977f5;
var $9831ebf7a15044cb$export$a8b78cb9fb18b384;
"use strict";
$9831ebf7a15044cb$export$1e511d4a378977f5 = true;
$9831ebf7a15044cb$export$a8b78cb9fb18b384 = void 0;

var $9831ebf7a15044cb$var$_react = $9831ebf7a15044cb$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $9831ebf7a15044cb$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9831ebf7a15044cb$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9831ebf7a15044cb$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $9831ebf7a15044cb$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $9831ebf7a15044cb$var$_extends() {
    return $9831ebf7a15044cb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9831ebf7a15044cb$var$_extends.apply(null, arguments);
}
var $9831ebf7a15044cb$var$Dropbox = $9831ebf7a15044cb$export$a8b78cb9fb18b384 = /*#__PURE__*/ (0, $9831ebf7a15044cb$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $9831ebf7a15044cb$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $9831ebf7a15044cb$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Dropbox"
    }, props), /*#__PURE__*/ $9831ebf7a15044cb$var$_react["default"].createElement("path", {
        fill: "#007EE5",
        fillRule: "evenodd",
        d: "M7.06 1 0 5.61l4.882 3.908L12 5.123 7.06 1zM0 13.428l7.06 4.61L12 13.914 4.882 9.52 0 13.43zm12 .486 4.94 4.124 7.06-4.61-4.882-3.91L12 13.914zM24 5.61 16.94 1 12 5.124l7.118 4.395L24 5.609zM12.014 14.8 7.06 18.913l-2.12-1.385v1.552l7.074 4.243 7.075-4.243v-1.552l-2.12 1.385-4.955-4.112z"
    }));
});
$9831ebf7a15044cb$var$Dropbox.displayName = 'Dropbox';


Object.keys($9831ebf7a15044cb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $9831ebf7a15044cb$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $9831ebf7a15044cb$exports[key];
});
var $6be9a3ab3318283a$exports = {};

$parcel$export($6be9a3ab3318283a$exports, "__esModule", function () { return $6be9a3ab3318283a$export$1e511d4a378977f5; }, function (v) { return $6be9a3ab3318283a$export$1e511d4a378977f5 = v; });
$parcel$export($6be9a3ab3318283a$exports, "Duplicate", function () { return $6be9a3ab3318283a$export$4a82481d9e63c9e1; }, function (v) { return $6be9a3ab3318283a$export$4a82481d9e63c9e1 = v; });
var $6be9a3ab3318283a$export$1e511d4a378977f5;
var $6be9a3ab3318283a$export$4a82481d9e63c9e1;
"use strict";
$6be9a3ab3318283a$export$1e511d4a378977f5 = true;
$6be9a3ab3318283a$export$4a82481d9e63c9e1 = void 0;

var $6be9a3ab3318283a$var$_react = $6be9a3ab3318283a$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $6be9a3ab3318283a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6be9a3ab3318283a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6be9a3ab3318283a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6be9a3ab3318283a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6be9a3ab3318283a$var$_extends() {
    return $6be9a3ab3318283a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6be9a3ab3318283a$var$_extends.apply(null, arguments);
}
var $6be9a3ab3318283a$var$Duplicate = $6be9a3ab3318283a$export$4a82481d9e63c9e1 = /*#__PURE__*/ (0, $6be9a3ab3318283a$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $6be9a3ab3318283a$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $6be9a3ab3318283a$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Duplicate"
    }, props), /*#__PURE__*/ $6be9a3ab3318283a$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.5 17H1V1h16v3.5M7 7h16v16H7V7zm8 4v8-8zm-4 4h8-8z"
    }));
});
$6be9a3ab3318283a$var$Duplicate.displayName = 'Duplicate';


Object.keys($6be9a3ab3318283a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $6be9a3ab3318283a$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $6be9a3ab3318283a$exports[key];
});
var $89177741d637771e$exports = {};

$parcel$export($89177741d637771e$exports, "__esModule", function () { return $89177741d637771e$export$1e511d4a378977f5; }, function (v) { return $89177741d637771e$export$1e511d4a378977f5 = v; });
$parcel$export($89177741d637771e$exports, "Dxc", function () { return $89177741d637771e$export$a4b6c0c04e6a96ad; }, function (v) { return $89177741d637771e$export$a4b6c0c04e6a96ad = v; });
var $89177741d637771e$export$1e511d4a378977f5;
var $89177741d637771e$export$a4b6c0c04e6a96ad;
"use strict";
$89177741d637771e$export$1e511d4a378977f5 = true;
$89177741d637771e$export$a4b6c0c04e6a96ad = void 0;

var $89177741d637771e$var$_react = $89177741d637771e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $89177741d637771e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($89177741d637771e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $89177741d637771e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $89177741d637771e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $89177741d637771e$var$_extends() {
    return $89177741d637771e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $89177741d637771e$var$_extends.apply(null, arguments);
}
var $89177741d637771e$var$Dxc = $89177741d637771e$export$a4b6c0c04e6a96ad = /*#__PURE__*/ (0, $89177741d637771e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $89177741d637771e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $89177741d637771e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Dxc"
    }, props), /*#__PURE__*/ $89177741d637771e$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "m12 14 4 7H8l4-7zm0-4L8 3h8l-4 7zM2 18H0V6h2a6 6 0 1 1 0 12zm20 0a6 6 0 1 1 0-12h2v12h-2z"
    }));
});
$89177741d637771e$var$Dxc.displayName = 'Dxc';


Object.keys($89177741d637771e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $89177741d637771e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $89177741d637771e$exports[key];
});
var $f32d6a168d2651f0$exports = {};

$parcel$export($f32d6a168d2651f0$exports, "__esModule", function () { return $f32d6a168d2651f0$export$1e511d4a378977f5; }, function (v) { return $f32d6a168d2651f0$export$1e511d4a378977f5 = v; });
$parcel$export($f32d6a168d2651f0$exports, "Ebay", function () { return $f32d6a168d2651f0$export$b3e9a0ccec3db049; }, function (v) { return $f32d6a168d2651f0$export$b3e9a0ccec3db049 = v; });
var $f32d6a168d2651f0$export$1e511d4a378977f5;
var $f32d6a168d2651f0$export$b3e9a0ccec3db049;
"use strict";
$f32d6a168d2651f0$export$1e511d4a378977f5 = true;
$f32d6a168d2651f0$export$b3e9a0ccec3db049 = void 0;

var $f32d6a168d2651f0$var$_react = $f32d6a168d2651f0$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f32d6a168d2651f0$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f32d6a168d2651f0$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f32d6a168d2651f0$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f32d6a168d2651f0$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f32d6a168d2651f0$var$_extends() {
    return $f32d6a168d2651f0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f32d6a168d2651f0$var$_extends.apply(null, arguments);
}
var $f32d6a168d2651f0$var$Ebay = $f32d6a168d2651f0$export$b3e9a0ccec3db049 = /*#__PURE__*/ (0, $f32d6a168d2651f0$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f32d6a168d2651f0$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f32d6a168d2651f0$var$_extends({
        ref: ref,
        viewBox: "0 0 60 24",
        a11yTitle: "Ebay"
    }, props), /*#__PURE__*/ $f32d6a168d2651f0$var$_react["default"].createElement("g", {
        fill: "none"
    }, /*#__PURE__*/ $f32d6a168d2651f0$var$_react["default"].createElement("path", {
        fill: "#E53238",
        d: "M7.773 5.218C3.544 5.218.02 6.998.02 12.366c0 4.253 2.37 6.931 7.862 6.931 6.466 0 6.88-4.224 6.88-4.224H11.63s-.671 2.275-3.938 2.275c-2.66 0-4.573-1.783-4.573-4.28H15.09V11.5c0-2.472-1.582-6.282-7.317-6.282zm-.109 2.004c2.533 0 4.259 1.538 4.259 3.844H3.187c0-2.448 2.253-3.844 4.477-3.844z"
    }), /*#__PURE__*/ $f32d6a168d2651f0$var$_react["default"].createElement("path", {
        fill: "#0064D2",
        d: "M15.088.02V16.6c0 .941-.068 2.263-.068 2.263h2.988s.107-.95.107-1.817c0 0 1.476 2.29 5.49 2.29 4.227 0 7.098-2.91 7.098-7.08 0-3.878-2.637-6.998-7.09-6.998-4.172 0-5.468 2.233-5.468 2.233V.02h-3.057zm7.753 7.29c2.87 0 4.695 2.112 4.695 4.948 0 3.04-2.108 5.029-4.675 5.029-3.063 0-4.716-2.373-4.716-5.002 0-2.45 1.483-4.975 4.696-4.975z"
    }), /*#__PURE__*/ $f32d6a168d2651f0$var$_react["default"].createElement("path", {
        fill: "#F5AF02",
        d: "M38.129 5.218c-6.362 0-6.77 3.455-6.77 4.007h3.166s.166-2.017 3.386-2.017c2.091 0 3.712.95 3.712 2.775v.65h-3.712c-4.93 0-7.535 1.43-7.535 4.332 0 2.856 2.407 4.41 5.661 4.41 4.434 0 5.863-2.43 5.863-2.43 0 .966.075 1.919.075 1.919h2.815s-.109-1.18-.109-1.936V10.4c0-4.281-3.481-5.182-6.552-5.182zm3.494 7.365v.866c0 1.13-.703 3.94-4.842 3.94-2.267 0-3.238-1.123-3.238-2.424 0-2.367 3.272-2.382 8.08-2.382z"
    }), /*#__PURE__*/ $f32d6a168d2651f0$var$_react["default"].createElement("path", {
        fill: "#86B817",
        d: "M42.976 5.76h3.562l5.113 10.159L56.753 5.76h3.227l-9.292 18.086h-3.385l2.681-5.042z"
    })));
});
$f32d6a168d2651f0$var$Ebay.displayName = 'Ebay';


Object.keys($f32d6a168d2651f0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f32d6a168d2651f0$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f32d6a168d2651f0$exports[key];
});
var $2cadc57abb7a6ac9$exports = {};

$parcel$export($2cadc57abb7a6ac9$exports, "__esModule", function () { return $2cadc57abb7a6ac9$export$1e511d4a378977f5; }, function (v) { return $2cadc57abb7a6ac9$export$1e511d4a378977f5 = v; });
$parcel$export($2cadc57abb7a6ac9$exports, "Edge", function () { return $2cadc57abb7a6ac9$export$b9d9805c9b77a56d; }, function (v) { return $2cadc57abb7a6ac9$export$b9d9805c9b77a56d = v; });
var $2cadc57abb7a6ac9$export$1e511d4a378977f5;
var $2cadc57abb7a6ac9$export$b9d9805c9b77a56d;
"use strict";
$2cadc57abb7a6ac9$export$1e511d4a378977f5 = true;
$2cadc57abb7a6ac9$export$b9d9805c9b77a56d = void 0;

var $2cadc57abb7a6ac9$var$_react = $2cadc57abb7a6ac9$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $2cadc57abb7a6ac9$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2cadc57abb7a6ac9$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2cadc57abb7a6ac9$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $2cadc57abb7a6ac9$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $2cadc57abb7a6ac9$var$_extends() {
    return $2cadc57abb7a6ac9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2cadc57abb7a6ac9$var$_extends.apply(null, arguments);
}
var $2cadc57abb7a6ac9$var$Edge = $2cadc57abb7a6ac9$export$b9d9805c9b77a56d = /*#__PURE__*/ (0, $2cadc57abb7a6ac9$var$_react.forwardRef)(function(props, ref) {
    var prefix = (0, $1b754218be0a6592$export$3794798abb123ff6)('Edge');
    return /*#__PURE__*/ $2cadc57abb7a6ac9$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $2cadc57abb7a6ac9$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Edge"
    }, props), /*#__PURE__*/ $2cadc57abb7a6ac9$var$_react["default"].createElement("g", {
        clipPath: "url(#" + prefix + "-a)"
    }, /*#__PURE__*/ $2cadc57abb7a6ac9$var$_react["default"].createElement("path", {
        fill: "url(#" + prefix + "-b)",
        d: "M21.666 17.873c-.32.165-.65.308-.991.44a9.628 9.628 0 0 1-3.369.606c-4.437 0-8.3-3.05-8.3-6.97 0-1.102.638-2.06 1.54-2.556-4.018.166-5.042 4.35-5.042 6.795 0 6.927 6.386 7.632 7.762 7.632.737 0 1.86-.22 2.532-.43a.539.539 0 0 0 .12-.044 12.066 12.066 0 0 0 6.243-4.956c.21-.319-.154-.704-.495-.517Z"
    }), /*#__PURE__*/ $2cadc57abb7a6ac9$var$_react["default"].createElement("path", {
        fill: "url(#" + prefix + "-c)",
        d: "M9.908 22.641a7.411 7.411 0 0 1-2.136-2.004 7.623 7.623 0 0 1-1.42-4.449 7.616 7.616 0 0 1 2.896-6.002 7.658 7.658 0 0 1 1.288-.804c.297-.143.792-.385 1.453-.374 1.1.011 1.937.573 2.41 1.211a3.02 3.02 0 0 1 .595 1.751c0-.022 2.29-7.466-7.508-7.466C3.391 4.504 0 8.414 0 11.849c0 2.17.506 3.91 1.134 5.253a12.065 12.065 0 0 0 7.21 6.343 11.88 11.88 0 0 0 3.667.573c1.32 0 2.598-.22 3.798-.617a7.14 7.14 0 0 1-2.136.33 7.2 7.2 0 0 1-3.765-1.09Z"
    }), /*#__PURE__*/ $2cadc57abb7a6ac9$var$_react["default"].createElement("path", {
        fill: "url(#" + prefix + "-d)",
        d: "M14.279 13.964c-.077.099-.309.23-.309.528 0 .242.154.485.44.683 1.355.936 3.887.815 3.898.815 1.046 0 1.992-.297 2.84-.782.386-.22.738-.496 1.057-.793 1.101-1.046 1.773-2.522 1.795-4.163.022-2.103-.75-3.502-1.068-4.118C20.95 2.235 16.668 0 12 0 5.427 0 .088 5.286 0 11.838c.044-3.425 3.446-6.2 7.497-6.2.33 0 2.202.033 3.941.947 1.53.804 2.334 1.773 2.896 2.742.583 1.002.682 2.269.682 2.764 0 .496-.264 1.256-.737 1.873Z"
    })), /*#__PURE__*/ $2cadc57abb7a6ac9$var$_react["default"].createElement("defs", null, /*#__PURE__*/ $2cadc57abb7a6ac9$var$_react["default"].createElement("linearGradient", {
        id: prefix + "-b",
        x1: "5.501",
        x2: "22.225",
        y1: "16.605",
        y2: "16.605",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $2cadc57abb7a6ac9$var$_react["default"].createElement("stop", {
        stopColor: "#0C59A4"
    }), /*#__PURE__*/ $2cadc57abb7a6ac9$var$_react["default"].createElement("stop", {
        offset: "1",
        stopColor: "#114A8B"
    })), /*#__PURE__*/ $2cadc57abb7a6ac9$var$_react["default"].createElement("linearGradient", {
        id: prefix + "-c",
        x1: "14.318",
        x2: "3.868",
        y1: "9.347",
        y2: "20.726",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $2cadc57abb7a6ac9$var$_react["default"].createElement("stop", {
        stopColor: "#1B9DE2"
    }), /*#__PURE__*/ $2cadc57abb7a6ac9$var$_react["default"].createElement("stop", {
        offset: ".162",
        stopColor: "#1595DF"
    }), /*#__PURE__*/ $2cadc57abb7a6ac9$var$_react["default"].createElement("stop", {
        offset: ".667",
        stopColor: "#0680D7"
    }), /*#__PURE__*/ $2cadc57abb7a6ac9$var$_react["default"].createElement("stop", {
        offset: "1",
        stopColor: "#0078D4"
    })), /*#__PURE__*/ $2cadc57abb7a6ac9$var$_react["default"].createElement("radialGradient", {
        id: prefix + "-d",
        cx: "0",
        cy: "0",
        r: "1",
        gradientTransform: "rotate(92.128 -.93 3.333) scale(18.9898 40.4341)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $2cadc57abb7a6ac9$var$_react["default"].createElement("stop", {
        stopColor: "#35C1F1"
    }), /*#__PURE__*/ $2cadc57abb7a6ac9$var$_react["default"].createElement("stop", {
        offset: ".111",
        stopColor: "#34C1ED"
    }), /*#__PURE__*/ $2cadc57abb7a6ac9$var$_react["default"].createElement("stop", {
        offset: ".232",
        stopColor: "#2FC2DF"
    }), /*#__PURE__*/ $2cadc57abb7a6ac9$var$_react["default"].createElement("stop", {
        offset: ".315",
        stopColor: "#2BC3D2"
    }), /*#__PURE__*/ $2cadc57abb7a6ac9$var$_react["default"].createElement("stop", {
        offset: ".673",
        stopColor: "#36C752"
    }), /*#__PURE__*/ $2cadc57abb7a6ac9$var$_react["default"].createElement("stop", {
        offset: "1",
        stopColor: "#36C752"
    })), /*#__PURE__*/ $2cadc57abb7a6ac9$var$_react["default"].createElement("clipPath", {
        id: prefix + "-a"
    }, /*#__PURE__*/ $2cadc57abb7a6ac9$var$_react["default"].createElement("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
    }))));
});
$2cadc57abb7a6ac9$var$Edge.displayName = 'Edge';


Object.keys($2cadc57abb7a6ac9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $2cadc57abb7a6ac9$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $2cadc57abb7a6ac9$exports[key];
});
var $bd1ad8e2cc0ff7e4$exports = {};

$parcel$export($bd1ad8e2cc0ff7e4$exports, "__esModule", function () { return $bd1ad8e2cc0ff7e4$export$1e511d4a378977f5; }, function (v) { return $bd1ad8e2cc0ff7e4$export$1e511d4a378977f5 = v; });
$parcel$export($bd1ad8e2cc0ff7e4$exports, "Edit", function () { return $bd1ad8e2cc0ff7e4$export$6ed0965c9443aaa6; }, function (v) { return $bd1ad8e2cc0ff7e4$export$6ed0965c9443aaa6 = v; });
var $bd1ad8e2cc0ff7e4$export$1e511d4a378977f5;
var $bd1ad8e2cc0ff7e4$export$6ed0965c9443aaa6;
"use strict";
$bd1ad8e2cc0ff7e4$export$1e511d4a378977f5 = true;
$bd1ad8e2cc0ff7e4$export$6ed0965c9443aaa6 = void 0;

var $bd1ad8e2cc0ff7e4$var$_react = $bd1ad8e2cc0ff7e4$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $bd1ad8e2cc0ff7e4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($bd1ad8e2cc0ff7e4$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $bd1ad8e2cc0ff7e4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $bd1ad8e2cc0ff7e4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $bd1ad8e2cc0ff7e4$var$_extends() {
    return $bd1ad8e2cc0ff7e4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bd1ad8e2cc0ff7e4$var$_extends.apply(null, arguments);
}
var $bd1ad8e2cc0ff7e4$var$Edit = $bd1ad8e2cc0ff7e4$export$6ed0965c9443aaa6 = /*#__PURE__*/ (0, $bd1ad8e2cc0ff7e4$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $bd1ad8e2cc0ff7e4$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $bd1ad8e2cc0ff7e4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Edit"
    }, props), /*#__PURE__*/ $bd1ad8e2cc0ff7e4$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m14 4 6 6-6-6zm8.294 1.294c.39.39.387 1.025-.008 1.42L9 20l-7 2 2-7L17.286 1.714a1 1 0 0 1 1.42-.008l3.588 3.588zM3 19l2 2m2-4 8-8"
    }));
});
$bd1ad8e2cc0ff7e4$var$Edit.displayName = 'Edit';


Object.keys($bd1ad8e2cc0ff7e4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $bd1ad8e2cc0ff7e4$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $bd1ad8e2cc0ff7e4$exports[key];
});
var $2a6f15566f5c6721$exports = {};

$parcel$export($2a6f15566f5c6721$exports, "__esModule", function () { return $2a6f15566f5c6721$export$1e511d4a378977f5; }, function (v) { return $2a6f15566f5c6721$export$1e511d4a378977f5 = v; });
$parcel$export($2a6f15566f5c6721$exports, "Eject", function () { return $2a6f15566f5c6721$export$d4dc4917073a0ad9; }, function (v) { return $2a6f15566f5c6721$export$d4dc4917073a0ad9 = v; });
var $2a6f15566f5c6721$export$1e511d4a378977f5;
var $2a6f15566f5c6721$export$d4dc4917073a0ad9;
"use strict";
$2a6f15566f5c6721$export$1e511d4a378977f5 = true;
$2a6f15566f5c6721$export$d4dc4917073a0ad9 = void 0;

var $2a6f15566f5c6721$var$_react = $2a6f15566f5c6721$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $2a6f15566f5c6721$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2a6f15566f5c6721$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2a6f15566f5c6721$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $2a6f15566f5c6721$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $2a6f15566f5c6721$var$_extends() {
    return $2a6f15566f5c6721$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2a6f15566f5c6721$var$_extends.apply(null, arguments);
}
var $2a6f15566f5c6721$var$Eject = $2a6f15566f5c6721$export$d4dc4917073a0ad9 = /*#__PURE__*/ (0, $2a6f15566f5c6721$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $2a6f15566f5c6721$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $2a6f15566f5c6721$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Eject"
    }, props), /*#__PURE__*/ $2a6f15566f5c6721$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M21 14 12 2 3 14h18zM2 22h20v-4H2v4z"
    }));
});
$2a6f15566f5c6721$var$Eject.displayName = 'Eject';


Object.keys($2a6f15566f5c6721$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $2a6f15566f5c6721$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $2a6f15566f5c6721$exports[key];
});
var $f293ed56c816bf38$exports = {};

$parcel$export($f293ed56c816bf38$exports, "__esModule", function () { return $f293ed56c816bf38$export$1e511d4a378977f5; }, function (v) { return $f293ed56c816bf38$export$1e511d4a378977f5 = v; });
$parcel$export($f293ed56c816bf38$exports, "Elevator", function () { return $f293ed56c816bf38$export$af3a9a068f518943; }, function (v) { return $f293ed56c816bf38$export$af3a9a068f518943 = v; });
var $f293ed56c816bf38$export$1e511d4a378977f5;
var $f293ed56c816bf38$export$af3a9a068f518943;
"use strict";
$f293ed56c816bf38$export$1e511d4a378977f5 = true;
$f293ed56c816bf38$export$af3a9a068f518943 = void 0;

var $f293ed56c816bf38$var$_react = $f293ed56c816bf38$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f293ed56c816bf38$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f293ed56c816bf38$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f293ed56c816bf38$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f293ed56c816bf38$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f293ed56c816bf38$var$_extends() {
    return $f293ed56c816bf38$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f293ed56c816bf38$var$_extends.apply(null, arguments);
}
var $f293ed56c816bf38$var$Elevator = $f293ed56c816bf38$export$af3a9a068f518943 = /*#__PURE__*/ (0, $f293ed56c816bf38$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f293ed56c816bf38$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f293ed56c816bf38$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Elevator"
    }, props), /*#__PURE__*/ $f293ed56c816bf38$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: "2",
        d: "M1 2.991C1 1.891 1.89 1 2.991 1H21.01C22.109 1 23 1.89 23 2.991V21.01c0 1.1-.89 1.991-1.991 1.991H2.99A1.99 1.99 0 0 1 1 21.009V2.99zM16.5 8l1.5 2h-3l1.5-2zm0 8 1.5-2h-3l1.5 2zM5 13l1.556-3.112C6.801 9.398 7.444 9 8 9h0c.552 0 1.2.398 1.444.888L11 13m-4.5 5 1.25-8h.5l1.25 8M8 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
    }));
});
$f293ed56c816bf38$var$Elevator.displayName = 'Elevator';


Object.keys($f293ed56c816bf38$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f293ed56c816bf38$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f293ed56c816bf38$exports[key];
});
var $9eb14f675b0b3b83$exports = {};

$parcel$export($9eb14f675b0b3b83$exports, "__esModule", function () { return $9eb14f675b0b3b83$export$1e511d4a378977f5; }, function (v) { return $9eb14f675b0b3b83$export$1e511d4a378977f5 = v; });
$parcel$export($9eb14f675b0b3b83$exports, "Emergency", function () { return $9eb14f675b0b3b83$export$b692444947d69bd1; }, function (v) { return $9eb14f675b0b3b83$export$b692444947d69bd1 = v; });
var $9eb14f675b0b3b83$export$1e511d4a378977f5;
var $9eb14f675b0b3b83$export$b692444947d69bd1;
"use strict";
$9eb14f675b0b3b83$export$1e511d4a378977f5 = true;
$9eb14f675b0b3b83$export$b692444947d69bd1 = void 0;

var $9eb14f675b0b3b83$var$_react = $9eb14f675b0b3b83$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $9eb14f675b0b3b83$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9eb14f675b0b3b83$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9eb14f675b0b3b83$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $9eb14f675b0b3b83$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $9eb14f675b0b3b83$var$_extends() {
    return $9eb14f675b0b3b83$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9eb14f675b0b3b83$var$_extends.apply(null, arguments);
}
var $9eb14f675b0b3b83$var$Emergency = $9eb14f675b0b3b83$export$b692444947d69bd1 = /*#__PURE__*/ (0, $9eb14f675b0b3b83$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $9eb14f675b0b3b83$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $9eb14f675b0b3b83$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Emergency"
    }, props), /*#__PURE__*/ $9eb14f675b0b3b83$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M10 7.172V2h4v5.172l3.657-3.657 2.828 2.828L16.828 10H22v4h-5.172l3.657 3.657-2.828 2.828L14 16.828V22h-4v-5.172l-3.657 3.657-2.828-2.828L7.172 14H2v-4h5.172L3.515 6.343l2.828-2.828L10 7.172z"
    }));
});
$9eb14f675b0b3b83$var$Emergency.displayName = 'Emergency';


Object.keys($9eb14f675b0b3b83$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $9eb14f675b0b3b83$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $9eb14f675b0b3b83$exports[key];
});
var $7762f5f353ae6031$exports = {};

$parcel$export($7762f5f353ae6031$exports, "__esModule", function () { return $7762f5f353ae6031$export$1e511d4a378977f5; }, function (v) { return $7762f5f353ae6031$export$1e511d4a378977f5 = v; });
$parcel$export($7762f5f353ae6031$exports, "Emoji", function () { return $7762f5f353ae6031$export$56cc48506ff790a; }, function (v) { return $7762f5f353ae6031$export$56cc48506ff790a = v; });
var $7762f5f353ae6031$export$1e511d4a378977f5;
var $7762f5f353ae6031$export$56cc48506ff790a;
"use strict";
$7762f5f353ae6031$export$1e511d4a378977f5 = true;
$7762f5f353ae6031$export$56cc48506ff790a = void 0;

var $7762f5f353ae6031$var$_react = $7762f5f353ae6031$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $7762f5f353ae6031$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7762f5f353ae6031$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7762f5f353ae6031$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $7762f5f353ae6031$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7762f5f353ae6031$var$_extends() {
    return $7762f5f353ae6031$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7762f5f353ae6031$var$_extends.apply(null, arguments);
}
var $7762f5f353ae6031$var$Emoji = $7762f5f353ae6031$export$56cc48506ff790a = /*#__PURE__*/ (0, $7762f5f353ae6031$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $7762f5f353ae6031$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $7762f5f353ae6031$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Emoji"
    }, props), /*#__PURE__*/ $7762f5f353ae6031$var$_react["default"].createElement("path", {
        d: "M12 1.73A10.27 10.27 0 1 0 22.24 12 10.25 10.25 0 0 0 12 1.73zM21 12a9 9 0 1 1-9-9 9 9 0 0 1 9 9z"
    }), /*#__PURE__*/ $7762f5f353ae6031$var$_react["default"].createElement("path", {
        d: "M8.8 11.05a1.55 1.55 0 1 0-1.51-1.5 1.56 1.56 0 0 0 1.51 1.5zm6.64 0a1.55 1.55 0 1 0 0-3.09 1.53 1.53 0 0 0-1.51 1.59 1.51 1.51 0 0 0 1.51 1.5zm-3.25 5.3A6.58 6.58 0 0 1 6.9 13.5a5.71 5.71 0 0 0 5.3 4 5.54 5.54 0 0 0 5.31-4 6.27 6.27 0 0 1-5.32 2.85z"
    }));
});
$7762f5f353ae6031$var$Emoji.displayName = 'Emoji';


Object.keys($7762f5f353ae6031$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $7762f5f353ae6031$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $7762f5f353ae6031$exports[key];
});
var $9ff90c02dfa36517$exports = {};

$parcel$export($9ff90c02dfa36517$exports, "__esModule", function () { return $9ff90c02dfa36517$export$1e511d4a378977f5; }, function (v) { return $9ff90c02dfa36517$export$1e511d4a378977f5 = v; });
$parcel$export($9ff90c02dfa36517$exports, "EmptyCircle", function () { return $9ff90c02dfa36517$export$1d29c2d7ac8ffc52; }, function (v) { return $9ff90c02dfa36517$export$1d29c2d7ac8ffc52 = v; });
var $9ff90c02dfa36517$export$1e511d4a378977f5;
var $9ff90c02dfa36517$export$1d29c2d7ac8ffc52;
"use strict";
$9ff90c02dfa36517$export$1e511d4a378977f5 = true;
$9ff90c02dfa36517$export$1d29c2d7ac8ffc52 = void 0;

var $9ff90c02dfa36517$var$_react = $9ff90c02dfa36517$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $9ff90c02dfa36517$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9ff90c02dfa36517$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9ff90c02dfa36517$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $9ff90c02dfa36517$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $9ff90c02dfa36517$var$_extends() {
    return $9ff90c02dfa36517$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9ff90c02dfa36517$var$_extends.apply(null, arguments);
}
var $9ff90c02dfa36517$var$EmptyCircle = $9ff90c02dfa36517$export$1d29c2d7ac8ffc52 = /*#__PURE__*/ (0, $9ff90c02dfa36517$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $9ff90c02dfa36517$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $9ff90c02dfa36517$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "EmptyCircle"
    }, props), /*#__PURE__*/ $9ff90c02dfa36517$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-6a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
    }));
});
$9ff90c02dfa36517$var$EmptyCircle.displayName = 'EmptyCircle';


Object.keys($9ff90c02dfa36517$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $9ff90c02dfa36517$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $9ff90c02dfa36517$exports[key];
});
var $77463cfff778082d$exports = {};

$parcel$export($77463cfff778082d$exports, "__esModule", function () { return $77463cfff778082d$export$1e511d4a378977f5; }, function (v) { return $77463cfff778082d$export$1e511d4a378977f5 = v; });
$parcel$export($77463cfff778082d$exports, "Erase", function () { return $77463cfff778082d$export$6d970b920ce148c1; }, function (v) { return $77463cfff778082d$export$6d970b920ce148c1 = v; });
var $77463cfff778082d$export$1e511d4a378977f5;
var $77463cfff778082d$export$6d970b920ce148c1;
"use strict";
$77463cfff778082d$export$1e511d4a378977f5 = true;
$77463cfff778082d$export$6d970b920ce148c1 = void 0;

var $77463cfff778082d$var$_react = $77463cfff778082d$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $77463cfff778082d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($77463cfff778082d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $77463cfff778082d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $77463cfff778082d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $77463cfff778082d$var$_extends() {
    return $77463cfff778082d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $77463cfff778082d$var$_extends.apply(null, arguments);
}
var $77463cfff778082d$var$Erase = $77463cfff778082d$export$6d970b920ce148c1 = /*#__PURE__*/ (0, $77463cfff778082d$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $77463cfff778082d$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $77463cfff778082d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Erase"
    }, props), /*#__PURE__*/ $77463cfff778082d$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M7 21 22 6l-4-4L2 18l3 3h14M6 14l4 4"
    }));
});
$77463cfff778082d$var$Erase.displayName = 'Erase';


Object.keys($77463cfff778082d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $77463cfff778082d$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $77463cfff778082d$exports[key];
});
var $10ddfcf361733435$exports = {};

$parcel$export($10ddfcf361733435$exports, "__esModule", function () { return $10ddfcf361733435$export$1e511d4a378977f5; }, function (v) { return $10ddfcf361733435$export$1e511d4a378977f5 = v; });
$parcel$export($10ddfcf361733435$exports, "Escalator", function () { return $10ddfcf361733435$export$dbe41f70f8efa9fe; }, function (v) { return $10ddfcf361733435$export$dbe41f70f8efa9fe = v; });
var $10ddfcf361733435$export$1e511d4a378977f5;
var $10ddfcf361733435$export$dbe41f70f8efa9fe;
"use strict";
$10ddfcf361733435$export$1e511d4a378977f5 = true;
$10ddfcf361733435$export$dbe41f70f8efa9fe = void 0;

var $10ddfcf361733435$var$_react = $10ddfcf361733435$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $10ddfcf361733435$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($10ddfcf361733435$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $10ddfcf361733435$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $10ddfcf361733435$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $10ddfcf361733435$var$_extends() {
    return $10ddfcf361733435$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $10ddfcf361733435$var$_extends.apply(null, arguments);
}
var $10ddfcf361733435$var$Escalator = $10ddfcf361733435$export$dbe41f70f8efa9fe = /*#__PURE__*/ (0, $10ddfcf361733435$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $10ddfcf361733435$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $10ddfcf361733435$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Escalator"
    }, props), /*#__PURE__*/ $10ddfcf361733435$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: "2",
        d: "M22 9a2 2 0 0 0-1.998-2H16L6 17H4c-1.105 0-2 .888-2 2h0a2 2 0 0 0 1.998 2H8l10-10h2c1.105 0 2-.888 2-2h0zM7 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 6v-2.505c0-.273.232-.495.5-.495h0c.276 0 .5.214.5.505V14l-1 1zm5-11a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 6V7.495c0-.273.232-.495.5-.495h0c.276 0 .5.214.5.505V9l-1 1z"
    }));
});
$10ddfcf361733435$var$Escalator.displayName = 'Escalator';


Object.keys($10ddfcf361733435$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $10ddfcf361733435$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $10ddfcf361733435$exports[key];
});

Object.keys($210911c17625cb22$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $210911c17625cb22$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $210911c17625cb22$exports[key];
});
var $cc5bdb3a379936a2$exports = {};

$parcel$export($cc5bdb3a379936a2$exports, "__esModule", function () { return $cc5bdb3a379936a2$export$1e511d4a378977f5; }, function (v) { return $cc5bdb3a379936a2$export$1e511d4a378977f5 = v; });
$parcel$export($cc5bdb3a379936a2$exports, "Ezmeral", function () { return $cc5bdb3a379936a2$export$c7d35a5600593589; }, function (v) { return $cc5bdb3a379936a2$export$c7d35a5600593589 = v; });
var $cc5bdb3a379936a2$export$1e511d4a378977f5;
var $cc5bdb3a379936a2$export$c7d35a5600593589;
"use strict";
$cc5bdb3a379936a2$export$1e511d4a378977f5 = true;
$cc5bdb3a379936a2$export$c7d35a5600593589 = void 0;

var $cc5bdb3a379936a2$var$_react = $cc5bdb3a379936a2$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $cc5bdb3a379936a2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($cc5bdb3a379936a2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $cc5bdb3a379936a2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $cc5bdb3a379936a2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $cc5bdb3a379936a2$var$_extends() {
    return $cc5bdb3a379936a2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cc5bdb3a379936a2$var$_extends.apply(null, arguments);
}
var $cc5bdb3a379936a2$var$Ezmeral = $cc5bdb3a379936a2$export$c7d35a5600593589 = /*#__PURE__*/ (0, $cc5bdb3a379936a2$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $cc5bdb3a379936a2$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $cc5bdb3a379936a2$var$_extends({
        ref: ref,
        viewBox: "0 0 48 24",
        a11yTitle: "Ezmeral"
    }, props), /*#__PURE__*/ $cc5bdb3a379936a2$var$_react["default"].createElement("path", {
        d: "M7 8h34v8H7V8z",
        fill: "#01A982"
    }), /*#__PURE__*/ $cc5bdb3a379936a2$var$_react["default"].createElement("path", {
        d: "M1 8h6v8H1V8zm40 0h6v8h-6V8zM7 16h34v6H7v-6z",
        fill: "#00775B"
    }), /*#__PURE__*/ $cc5bdb3a379936a2$var$_react["default"].createElement("path", {
        d: "M7 2h34v6H7V2z",
        fill: "#00C781"
    }), /*#__PURE__*/ $cc5bdb3a379936a2$var$_react["default"].createElement("path", {
        d: "m1 8 6-6v6H1zm0 8 6 6v-6H1zm46-8-6-6v6h6zm0 8-6 6v-6h6z",
        fill: "#01A982"
    }));
});
$cc5bdb3a379936a2$var$Ezmeral.displayName = 'Ezmeral';


Object.keys($cc5bdb3a379936a2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $cc5bdb3a379936a2$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $cc5bdb3a379936a2$exports[key];
});
var $b587d2e6bb6c609a$exports = {};

$parcel$export($b587d2e6bb6c609a$exports, "__esModule", function () { return $b587d2e6bb6c609a$export$1e511d4a378977f5; }, function (v) { return $b587d2e6bb6c609a$export$1e511d4a378977f5 = v; });
$parcel$export($b587d2e6bb6c609a$exports, "FacebookOption", function () { return $b587d2e6bb6c609a$export$26fe41e79f906ec0; }, function (v) { return $b587d2e6bb6c609a$export$26fe41e79f906ec0 = v; });
var $b587d2e6bb6c609a$export$1e511d4a378977f5;
var $b587d2e6bb6c609a$export$26fe41e79f906ec0;
"use strict";
$b587d2e6bb6c609a$export$1e511d4a378977f5 = true;
$b587d2e6bb6c609a$export$26fe41e79f906ec0 = void 0;

var $b587d2e6bb6c609a$var$_react = $b587d2e6bb6c609a$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $b587d2e6bb6c609a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b587d2e6bb6c609a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b587d2e6bb6c609a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $b587d2e6bb6c609a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b587d2e6bb6c609a$var$_extends() {
    return $b587d2e6bb6c609a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b587d2e6bb6c609a$var$_extends.apply(null, arguments);
}
var $b587d2e6bb6c609a$var$FacebookOption = $b587d2e6bb6c609a$export$26fe41e79f906ec0 = /*#__PURE__*/ (0, $b587d2e6bb6c609a$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $b587d2e6bb6c609a$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $b587d2e6bb6c609a$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FacebookOption"
    }, props), /*#__PURE__*/ $b587d2e6bb6c609a$var$_react["default"].createElement("path", {
        fill: "#3B5998",
        fillRule: "evenodd",
        d: "M9.945 22v-8.834H7V9.485h2.945V6.54c0-3.043 1.926-4.54 4.64-4.54 1.3 0 2.418.097 2.744.14v3.18h-1.883c-1.476 0-1.82.703-1.82 1.732v2.433h3.68l-.736 3.68h-2.944L13.685 22"
    }));
});
$b587d2e6bb6c609a$var$FacebookOption.displayName = 'FacebookOption';


Object.keys($b587d2e6bb6c609a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $b587d2e6bb6c609a$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $b587d2e6bb6c609a$exports[key];
});
var $d72e278c39c95a3a$exports = {};

$parcel$export($d72e278c39c95a3a$exports, "__esModule", function () { return $d72e278c39c95a3a$export$1e511d4a378977f5; }, function (v) { return $d72e278c39c95a3a$export$1e511d4a378977f5 = v; });
$parcel$export($d72e278c39c95a3a$exports, "Facebook", function () { return $d72e278c39c95a3a$export$a4f57375e50e81d5; }, function (v) { return $d72e278c39c95a3a$export$a4f57375e50e81d5 = v; });
var $d72e278c39c95a3a$export$1e511d4a378977f5;
var $d72e278c39c95a3a$export$a4f57375e50e81d5;
"use strict";
$d72e278c39c95a3a$export$1e511d4a378977f5 = true;
$d72e278c39c95a3a$export$a4f57375e50e81d5 = void 0;

var $d72e278c39c95a3a$var$_react = $d72e278c39c95a3a$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $d72e278c39c95a3a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d72e278c39c95a3a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d72e278c39c95a3a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d72e278c39c95a3a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d72e278c39c95a3a$var$_extends() {
    return $d72e278c39c95a3a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d72e278c39c95a3a$var$_extends.apply(null, arguments);
}
var $d72e278c39c95a3a$var$Facebook = $d72e278c39c95a3a$export$a4f57375e50e81d5 = /*#__PURE__*/ (0, $d72e278c39c95a3a$var$_react.forwardRef)(function(props, ref) {
    var prefix = (0, $1b754218be0a6592$export$3794798abb123ff6)('Facebook');
    return /*#__PURE__*/ $d72e278c39c95a3a$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $d72e278c39c95a3a$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Facebook"
    }, props), /*#__PURE__*/ $d72e278c39c95a3a$var$_react["default"].createElement("g", {
        clipPath: "url(#" + prefix + "-a)"
    }, /*#__PURE__*/ $d72e278c39c95a3a$var$_react["default"].createElement("path", {
        fill: "#1089FB",
        d: "M12 0C5.373 0 0 5.373 0 12c0 6.016 4.432 10.984 10.207 11.852V15.18h-2.97v-3.155h2.97V9.927c0-3.475 1.693-5 4.58-5 1.384 0 2.115.102 2.462.149v2.753h-1.97c-1.226 0-1.655 1.163-1.655 2.473v1.724h3.594l-.488 3.155h-3.106v8.696C19.481 23.083 24 18.075 24 12c0-6.627-5.373-12-12-12Z"
    })), /*#__PURE__*/ $d72e278c39c95a3a$var$_react["default"].createElement("defs", null, /*#__PURE__*/ $d72e278c39c95a3a$var$_react["default"].createElement("clipPath", {
        id: prefix + "-a"
    }, /*#__PURE__*/ $d72e278c39c95a3a$var$_react["default"].createElement("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
    }))));
});
$d72e278c39c95a3a$var$Facebook.displayName = 'Facebook';


Object.keys($d72e278c39c95a3a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $d72e278c39c95a3a$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $d72e278c39c95a3a$exports[key];
});
var $d743f17f081e0ee8$exports = {};

$parcel$export($d743f17f081e0ee8$exports, "__esModule", function () { return $d743f17f081e0ee8$export$1e511d4a378977f5; }, function (v) { return $d743f17f081e0ee8$export$1e511d4a378977f5 = v; });
$parcel$export($d743f17f081e0ee8$exports, "FanOption", function () { return $d743f17f081e0ee8$export$c0941e17ed9a3809; }, function (v) { return $d743f17f081e0ee8$export$c0941e17ed9a3809 = v; });
var $d743f17f081e0ee8$export$1e511d4a378977f5;
var $d743f17f081e0ee8$export$c0941e17ed9a3809;
"use strict";
$d743f17f081e0ee8$export$1e511d4a378977f5 = true;
$d743f17f081e0ee8$export$c0941e17ed9a3809 = void 0;

var $d743f17f081e0ee8$var$_react = $d743f17f081e0ee8$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $d743f17f081e0ee8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d743f17f081e0ee8$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d743f17f081e0ee8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d743f17f081e0ee8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d743f17f081e0ee8$var$_extends() {
    return $d743f17f081e0ee8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d743f17f081e0ee8$var$_extends.apply(null, arguments);
}
var $d743f17f081e0ee8$var$FanOption = $d743f17f081e0ee8$export$c0941e17ed9a3809 = /*#__PURE__*/ (0, $d743f17f081e0ee8$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d743f17f081e0ee8$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $d743f17f081e0ee8$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FanOption"
    }, props), /*#__PURE__*/ $d743f17f081e0ee8$var$_react["default"].createElement("rect", {
        x: "2",
        y: "2",
        width: "20",
        height: "20",
        rx: "1",
        stroke: "#000",
        strokeWidth: "2",
        fill: "none"
    }), /*#__PURE__*/ $d743f17f081e0ee8$var$_react["default"].createElement("rect", {
        x: "2",
        y: "2",
        width: "20",
        height: "20",
        rx: "10",
        stroke: "#000",
        strokeWidth: "2",
        fill: "none"
    }), /*#__PURE__*/ $d743f17f081e0ee8$var$_react["default"].createElement("path", {
        d: "M15 9.5c.5-.333.9-1.7.5-2.5S13.333 5.667 13 5.5m1 5c1.5-2 0-3.5-2.5-5-1.546-.927 2-1.5 4.5.5 1.875 1.5 1 2.5-2 5.5v-1zm-5.015 3.902c-.5.333-.9 1.7-.5 2.5s2.167 1.333 2.5 1.5m-1-5c-1.5 2 0 3.5 2.5 5 1.546.927-2 1.5-4.5-.5-1.875-1.5-1-2.5 2-5.5v1zm-.443-4.458c-.334-.5-1.7-.9-2.5-.5s-1.334 2.166-1.5 2.5m5-1c-2-1.5-3.5 0-5 2.5-.928 1.546-1.5-2 .5-4.5 1.5-1.875 2.5-1 5.5 2h-1zm3.902 5.014c.333.5 1.7.9 2.5.5s1.333-2.166 1.5-2.5m-5 1c2 1.5 3.5 0 5-2.5.927-1.546 1.5 2-.5 4.5-1.5 1.876-2.5 1-5.5-2h1z",
        stroke: "#000",
        strokeWidth: "2",
        fill: "none"
    }), /*#__PURE__*/ $d743f17f081e0ee8$var$_react["default"].createElement("path", {
        clipRule: "evenodd",
        d: "M3.5 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm0 17a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm17 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm0-17a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
        stroke: "#000",
        strokeWidth: "2",
        fill: "none"
    }));
});
$d743f17f081e0ee8$var$FanOption.displayName = 'FanOption';


Object.keys($d743f17f081e0ee8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $d743f17f081e0ee8$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $d743f17f081e0ee8$exports[key];
});
var $1394671cd2fd8d69$exports = {};

$parcel$export($1394671cd2fd8d69$exports, "__esModule", function () { return $1394671cd2fd8d69$export$1e511d4a378977f5; }, function (v) { return $1394671cd2fd8d69$export$1e511d4a378977f5 = v; });
$parcel$export($1394671cd2fd8d69$exports, "Fan", function () { return $1394671cd2fd8d69$export$becccff7f5b0a408; }, function (v) { return $1394671cd2fd8d69$export$becccff7f5b0a408 = v; });
var $1394671cd2fd8d69$export$1e511d4a378977f5;
var $1394671cd2fd8d69$export$becccff7f5b0a408;
"use strict";
$1394671cd2fd8d69$export$1e511d4a378977f5 = true;
$1394671cd2fd8d69$export$becccff7f5b0a408 = void 0;

var $1394671cd2fd8d69$var$_react = $1394671cd2fd8d69$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $1394671cd2fd8d69$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1394671cd2fd8d69$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1394671cd2fd8d69$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $1394671cd2fd8d69$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1394671cd2fd8d69$var$_extends() {
    return $1394671cd2fd8d69$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1394671cd2fd8d69$var$_extends.apply(null, arguments);
}
var $1394671cd2fd8d69$var$Fan = $1394671cd2fd8d69$export$becccff7f5b0a408 = /*#__PURE__*/ (0, $1394671cd2fd8d69$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $1394671cd2fd8d69$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $1394671cd2fd8d69$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Fan"
    }, props), /*#__PURE__*/ $1394671cd2fd8d69$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm3-3c4 3 5 7 5 7m-8 4c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm0-14c3-5 7-6 7-6m-7 12c-3 4-7 5-7 5m4-8C5 9 4 5 4 5"
    }));
});
$1394671cd2fd8d69$var$Fan.displayName = 'Fan';


Object.keys($1394671cd2fd8d69$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $1394671cd2fd8d69$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $1394671cd2fd8d69$exports[key];
});
var $6b9ec9aec76a7b61$exports = {};

$parcel$export($6b9ec9aec76a7b61$exports, "__esModule", function () { return $6b9ec9aec76a7b61$export$1e511d4a378977f5; }, function (v) { return $6b9ec9aec76a7b61$export$1e511d4a378977f5 = v; });
$parcel$export($6b9ec9aec76a7b61$exports, "FastForward", function () { return $6b9ec9aec76a7b61$export$4833d53cc4b504e1; }, function (v) { return $6b9ec9aec76a7b61$export$4833d53cc4b504e1 = v; });
var $6b9ec9aec76a7b61$export$1e511d4a378977f5;
var $6b9ec9aec76a7b61$export$4833d53cc4b504e1;
"use strict";
$6b9ec9aec76a7b61$export$1e511d4a378977f5 = true;
$6b9ec9aec76a7b61$export$4833d53cc4b504e1 = void 0;

var $6b9ec9aec76a7b61$var$_react = $6b9ec9aec76a7b61$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $6b9ec9aec76a7b61$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6b9ec9aec76a7b61$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6b9ec9aec76a7b61$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6b9ec9aec76a7b61$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6b9ec9aec76a7b61$var$_extends() {
    return $6b9ec9aec76a7b61$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6b9ec9aec76a7b61$var$_extends.apply(null, arguments);
}
var $6b9ec9aec76a7b61$var$FastForward = $6b9ec9aec76a7b61$export$4833d53cc4b504e1 = /*#__PURE__*/ (0, $6b9ec9aec76a7b61$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $6b9ec9aec76a7b61$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $6b9ec9aec76a7b61$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FastForward"
    }, props), /*#__PURE__*/ $6b9ec9aec76a7b61$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M9 2.059V8L1 2.059v20L9 16v6.059l13-10z"
    }));
});
$6b9ec9aec76a7b61$var$FastForward.displayName = 'FastForward';


Object.keys($6b9ec9aec76a7b61$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $6b9ec9aec76a7b61$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $6b9ec9aec76a7b61$exports[key];
});
var $20df48e9a2e6f1a8$exports = {};

$parcel$export($20df48e9a2e6f1a8$exports, "__esModule", function () { return $20df48e9a2e6f1a8$export$1e511d4a378977f5; }, function (v) { return $20df48e9a2e6f1a8$export$1e511d4a378977f5 = v; });
$parcel$export($20df48e9a2e6f1a8$exports, "Favorite", function () { return $20df48e9a2e6f1a8$export$d71633542cb09b03; }, function (v) { return $20df48e9a2e6f1a8$export$d71633542cb09b03 = v; });
var $20df48e9a2e6f1a8$export$1e511d4a378977f5;
var $20df48e9a2e6f1a8$export$d71633542cb09b03;
"use strict";
$20df48e9a2e6f1a8$export$1e511d4a378977f5 = true;
$20df48e9a2e6f1a8$export$d71633542cb09b03 = void 0;

var $20df48e9a2e6f1a8$var$_react = $20df48e9a2e6f1a8$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $20df48e9a2e6f1a8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($20df48e9a2e6f1a8$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $20df48e9a2e6f1a8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $20df48e9a2e6f1a8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $20df48e9a2e6f1a8$var$_extends() {
    return $20df48e9a2e6f1a8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $20df48e9a2e6f1a8$var$_extends.apply(null, arguments);
}
var $20df48e9a2e6f1a8$var$Favorite = $20df48e9a2e6f1a8$export$d71633542cb09b03 = /*#__PURE__*/ (0, $20df48e9a2e6f1a8$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $20df48e9a2e6f1a8$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $20df48e9a2e6f1a8$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Favorite"
    }, props), /*#__PURE__*/ $20df48e9a2e6f1a8$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 8.4C1 4 4.5 3 6.5 3 9 3 11 5 12 6.5 13 5 15 3 17.5 3c2 0 5.5 1 5.5 5.4C23 15 12 21 12 21S1 15 1 8.4z"
    }));
});
$20df48e9a2e6f1a8$var$Favorite.displayName = 'Favorite';


Object.keys($20df48e9a2e6f1a8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $20df48e9a2e6f1a8$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $20df48e9a2e6f1a8$exports[key];
});
var $fa42385b1d5dfd50$exports = {};

$parcel$export($fa42385b1d5dfd50$exports, "__esModule", function () { return $fa42385b1d5dfd50$export$1e511d4a378977f5; }, function (v) { return $fa42385b1d5dfd50$export$1e511d4a378977f5 = v; });
$parcel$export($fa42385b1d5dfd50$exports, "Fedora", function () { return $fa42385b1d5dfd50$export$d1b6ff23fbf7f758; }, function (v) { return $fa42385b1d5dfd50$export$d1b6ff23fbf7f758 = v; });
var $fa42385b1d5dfd50$export$1e511d4a378977f5;
var $fa42385b1d5dfd50$export$d1b6ff23fbf7f758;
"use strict";
$fa42385b1d5dfd50$export$1e511d4a378977f5 = true;
$fa42385b1d5dfd50$export$d1b6ff23fbf7f758 = void 0;

var $fa42385b1d5dfd50$var$_react = $fa42385b1d5dfd50$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $fa42385b1d5dfd50$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($fa42385b1d5dfd50$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $fa42385b1d5dfd50$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $fa42385b1d5dfd50$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $fa42385b1d5dfd50$var$_extends() {
    return $fa42385b1d5dfd50$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fa42385b1d5dfd50$var$_extends.apply(null, arguments);
}
var $fa42385b1d5dfd50$var$Fedora = $fa42385b1d5dfd50$export$d1b6ff23fbf7f758 = /*#__PURE__*/ (0, $fa42385b1d5dfd50$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $fa42385b1d5dfd50$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $fa42385b1d5dfd50$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Fedora"
    }, props), /*#__PURE__*/ $fa42385b1d5dfd50$var$_react["default"].createElement("path", {
        fill: "#4F6DB1",
        fillRule: "evenodd",
        d: "M12 0C5.375 0 .005 5.368 0 11.992v9.286A2.728 2.728 0 0 0 2.728 24h9.277C18.63 23.997 24 18.626 24 12c0-6.627-5.373-12-12-12zm4.595 5.577c-.379 0-.517-.073-1.072-.073a2.973 2.973 0 0 0-2.973 2.968v2.583a.42.42 0 0 0 .42.419h1.953c.728 0 1.316.58 1.316 1.31 0 .734-.594 1.312-1.33 1.312H12.55v2.985a5.632 5.632 0 0 1-5.631 5.632c-.472 0-.808-.053-1.245-.167-.637-.167-1.157-.689-1.157-1.296 0-.734.533-1.269 1.33-1.269.378 0 .516.073 1.072.073 1.64 0 2.97-1.328 2.972-2.968v-2.583a.42.42 0 0 0-.42-.419H7.518c-.727 0-1.315-.58-1.315-1.31 0-.735.594-1.312 1.33-1.312H9.89V8.476a5.632 5.632 0 0 1 5.632-5.632c.472 0 .807.054 1.244.168.637.167 1.158.689 1.158 1.296 0 .734-.533 1.269-1.33 1.269z"
    }));
});
$fa42385b1d5dfd50$var$Fedora.displayName = 'Fedora';


Object.keys($fa42385b1d5dfd50$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $fa42385b1d5dfd50$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $fa42385b1d5dfd50$exports[key];
});
var $552ac11a9ec455aa$exports = {};

$parcel$export($552ac11a9ec455aa$exports, "__esModule", function () { return $552ac11a9ec455aa$export$1e511d4a378977f5; }, function (v) { return $552ac11a9ec455aa$export$1e511d4a378977f5 = v; });
$parcel$export($552ac11a9ec455aa$exports, "Figma", function () { return $552ac11a9ec455aa$export$20e9d0c3ea261874; }, function (v) { return $552ac11a9ec455aa$export$20e9d0c3ea261874 = v; });
var $552ac11a9ec455aa$export$1e511d4a378977f5;
var $552ac11a9ec455aa$export$20e9d0c3ea261874;
"use strict";
$552ac11a9ec455aa$export$1e511d4a378977f5 = true;
$552ac11a9ec455aa$export$20e9d0c3ea261874 = void 0;

var $552ac11a9ec455aa$var$_react = $552ac11a9ec455aa$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $552ac11a9ec455aa$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($552ac11a9ec455aa$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $552ac11a9ec455aa$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $552ac11a9ec455aa$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $552ac11a9ec455aa$var$_extends() {
    return $552ac11a9ec455aa$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $552ac11a9ec455aa$var$_extends.apply(null, arguments);
}
var $552ac11a9ec455aa$var$Figma = $552ac11a9ec455aa$export$20e9d0c3ea261874 = /*#__PURE__*/ (0, $552ac11a9ec455aa$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $552ac11a9ec455aa$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $552ac11a9ec455aa$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Figma"
    }, props), /*#__PURE__*/ $552ac11a9ec455aa$var$_react["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        transform: "translate(4)"
    }, /*#__PURE__*/ $552ac11a9ec455aa$var$_react["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "4",
        fill: "#19BCFE"
    }), /*#__PURE__*/ $552ac11a9ec455aa$var$_react["default"].createElement("path", {
        fill: "#09CF83",
        d: "M4 24a4 4 0 0 0 4-4v-4H4a4 4 0 1 0 0 8z"
    }), /*#__PURE__*/ $552ac11a9ec455aa$var$_react["default"].createElement("path", {
        fill: "#A259FF",
        d: "M4 16h4V8H4a4 4 0 1 0 0 8z"
    }), /*#__PURE__*/ $552ac11a9ec455aa$var$_react["default"].createElement("path", {
        fill: "#F24E1E",
        d: "M4 8h4V0H4a4 4 0 1 0 0 8z"
    }), /*#__PURE__*/ $552ac11a9ec455aa$var$_react["default"].createElement("path", {
        fill: "#FF7262",
        d: "M12 8H8V0h4a4 4 0 1 1 0 8z"
    })));
});
$552ac11a9ec455aa$var$Figma.displayName = 'Figma';


Object.keys($552ac11a9ec455aa$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $552ac11a9ec455aa$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $552ac11a9ec455aa$exports[key];
});

Object.keys($77fad0572c6e1b7e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $77fad0572c6e1b7e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $77fad0572c6e1b7e$exports[key];
});
var $6266f9affa57da6b$exports = {};

$parcel$export($6266f9affa57da6b$exports, "__esModule", function () { return $6266f9affa57da6b$export$1e511d4a378977f5; }, function (v) { return $6266f9affa57da6b$export$1e511d4a378977f5 = v; });
$parcel$export($6266f9affa57da6b$exports, "FingerPrint", function () { return $6266f9affa57da6b$export$60a1f32067f9fc31; }, function (v) { return $6266f9affa57da6b$export$60a1f32067f9fc31 = v; });
var $6266f9affa57da6b$export$1e511d4a378977f5;
var $6266f9affa57da6b$export$60a1f32067f9fc31;
"use strict";
$6266f9affa57da6b$export$1e511d4a378977f5 = true;
$6266f9affa57da6b$export$60a1f32067f9fc31 = void 0;

var $6266f9affa57da6b$var$_react = $6266f9affa57da6b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $6266f9affa57da6b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6266f9affa57da6b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6266f9affa57da6b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6266f9affa57da6b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6266f9affa57da6b$var$_extends() {
    return $6266f9affa57da6b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6266f9affa57da6b$var$_extends.apply(null, arguments);
}
var $6266f9affa57da6b$var$FingerPrint = $6266f9affa57da6b$export$60a1f32067f9fc31 = /*#__PURE__*/ (0, $6266f9affa57da6b$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $6266f9affa57da6b$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $6266f9affa57da6b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FingerPrint"
    }, props), /*#__PURE__*/ $6266f9affa57da6b$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: "2",
        d: "M14 15a2 2 0 1 0-2 2h0m0 3a5 5 0 1 1 5-5 1.5 1.5 0 0 0 3 0 8 8 0 1 0-8 8h2M1 15c0 2.672.953 5.122 2.537 7.027M20.52 8.042A10.978 10.978 0 0 0 12 4a10.977 10.977 0 0 0-8.464 3.974m14.99-5.363A13.939 13.939 0 0 0 12 1a13.94 13.94 0 0 0-6.481 1.587"
    }));
});
$6266f9affa57da6b$var$FingerPrint.displayName = 'FingerPrint';


Object.keys($6266f9affa57da6b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $6266f9affa57da6b$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $6266f9affa57da6b$exports[key];
});
var $3aff9cf76e44a057$exports = {};

$parcel$export($3aff9cf76e44a057$exports, "__esModule", function () { return $3aff9cf76e44a057$export$1e511d4a378977f5; }, function (v) { return $3aff9cf76e44a057$export$1e511d4a378977f5 = v; });
$parcel$export($3aff9cf76e44a057$exports, "Fireball", function () { return $3aff9cf76e44a057$export$598227018e7cacb0; }, function (v) { return $3aff9cf76e44a057$export$598227018e7cacb0 = v; });
var $3aff9cf76e44a057$export$1e511d4a378977f5;
var $3aff9cf76e44a057$export$598227018e7cacb0;
"use strict";
$3aff9cf76e44a057$export$1e511d4a378977f5 = true;
$3aff9cf76e44a057$export$598227018e7cacb0 = void 0;

var $3aff9cf76e44a057$var$_react = $3aff9cf76e44a057$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $3aff9cf76e44a057$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3aff9cf76e44a057$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3aff9cf76e44a057$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3aff9cf76e44a057$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3aff9cf76e44a057$var$_extends() {
    return $3aff9cf76e44a057$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3aff9cf76e44a057$var$_extends.apply(null, arguments);
}
var $3aff9cf76e44a057$var$Fireball = $3aff9cf76e44a057$export$598227018e7cacb0 = /*#__PURE__*/ (0, $3aff9cf76e44a057$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3aff9cf76e44a057$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3aff9cf76e44a057$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Fireball"
    }, props), /*#__PURE__*/ $3aff9cf76e44a057$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-9-1.75 1 .75-2-1.25-1h1.5L12 9.25l.75 1.75h1.5L13 12l.75 2L12 13z"
    }));
});
$3aff9cf76e44a057$var$Fireball.displayName = 'Fireball';


Object.keys($3aff9cf76e44a057$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3aff9cf76e44a057$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3aff9cf76e44a057$exports[key];
});
var $fe88f21fc1fc3296$exports = {};

$parcel$export($fe88f21fc1fc3296$exports, "__esModule", function () { return $fe88f21fc1fc3296$export$1e511d4a378977f5; }, function (v) { return $fe88f21fc1fc3296$export$1e511d4a378977f5 = v; });
$parcel$export($fe88f21fc1fc3296$exports, "Firefox", function () { return $fe88f21fc1fc3296$export$91ff3a4ec2da796e; }, function (v) { return $fe88f21fc1fc3296$export$91ff3a4ec2da796e = v; });
var $fe88f21fc1fc3296$export$1e511d4a378977f5;
var $fe88f21fc1fc3296$export$91ff3a4ec2da796e;
"use strict";
$fe88f21fc1fc3296$export$1e511d4a378977f5 = true;
$fe88f21fc1fc3296$export$91ff3a4ec2da796e = void 0;

var $fe88f21fc1fc3296$var$_react = $fe88f21fc1fc3296$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $fe88f21fc1fc3296$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($fe88f21fc1fc3296$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $fe88f21fc1fc3296$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $fe88f21fc1fc3296$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $fe88f21fc1fc3296$var$_extends() {
    return $fe88f21fc1fc3296$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fe88f21fc1fc3296$var$_extends.apply(null, arguments);
}
var $fe88f21fc1fc3296$var$Firefox = $fe88f21fc1fc3296$export$91ff3a4ec2da796e = /*#__PURE__*/ (0, $fe88f21fc1fc3296$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $fe88f21fc1fc3296$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $fe88f21fc1fc3296$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Firefox"
    }, props), /*#__PURE__*/ $fe88f21fc1fc3296$var$_react["default"].createElement("path", {
        fill: "#E66000",
        fillRule: "evenodd",
        d: "m4.25 1-.145 3.684c.624-.154 1.235-.246 1.83.01 1.291-1.768 3.148-2.376 5.194-2.6l.038.06c-.04.045-.08.089-.122.131a9.473 9.473 0 0 0-1.948 2.847c-.134.306-.166.658-.238.99-.029.129.037.198.168.216.607.083 1.212.18 1.822.25.382.043.769.051 1.154.067.18.008.258.097.262.267.015.684-.213 1.27-.759 1.69a4.414 4.414 0 0 1-1.781.804c-.068.015-.135.035-.208.054l.198 2.515-1.854-.888c-.186.392-.2.78-.082 1.176.316 1.073 1.431 1.695 2.586 1.41.404-.1.795-.27 1.176-.444.376-.17.729-.39 1.096-.583.622-.324 1.249-.296 1.874-.006.09.041.18.095.249.165.234.234.417.503.323.857-.091.342-.34.54-.677.611a2.823 2.823 0 0 1-.594.059c-.132-.001-.202.042-.274.148-.68 1.009-1.562 1.752-2.79 1.964-.517.09-1.05.075-1.576.104-.07.004-.14-.006-.255-.012.07.064.105.104.147.135 1.39 1.027 2.927 1.378 4.614.974 1.381-.33 2.61-.949 3.623-1.965.966-.968 1.408-2.15 1.422-3.496.014-1.353-.288-2.634-.98-3.807-.121-.205-.279-.39-.454-.63 1.19.54 2.24 1.153 2.727 2.42.143-1.582-.148-3.08-.758-4.525-.61-1.444-1.485-2.695-2.682-3.731.05.01.1.018.149.034 2.694.844 4.763 2.45 6.056 4.991.626 1.23.946 2.552 1.111 3.913.177 1.457.156 2.906-.216 4.338-.622 2.398-1.935 4.359-3.753 6.013-1.73 1.574-3.745 2.595-6.052 2.887-5.14.651-9.19-1.198-12.063-5.526C.665 16.849.126 14.92.023 12.859-.144 9.51.61 6.385 2.272 3.478A9.851 9.851 0 0 1 4.049 1.18c.05-.048.102-.093.2-.181"
    }));
});
$fe88f21fc1fc3296$var$Firefox.displayName = 'Firefox';


Object.keys($fe88f21fc1fc3296$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $fe88f21fc1fc3296$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $fe88f21fc1fc3296$exports[key];
});
var $2f74fb23f81e8e40$exports = {};

$parcel$export($2f74fb23f81e8e40$exports, "__esModule", function () { return $2f74fb23f81e8e40$export$1e511d4a378977f5; }, function (v) { return $2f74fb23f81e8e40$export$1e511d4a378977f5 = v; });
$parcel$export($2f74fb23f81e8e40$exports, "Firewall", function () { return $2f74fb23f81e8e40$export$a0e020eeac88cef2; }, function (v) { return $2f74fb23f81e8e40$export$a0e020eeac88cef2 = v; });
var $2f74fb23f81e8e40$export$1e511d4a378977f5;
var $2f74fb23f81e8e40$export$a0e020eeac88cef2;
"use strict";
$2f74fb23f81e8e40$export$1e511d4a378977f5 = true;
$2f74fb23f81e8e40$export$a0e020eeac88cef2 = void 0;

var $2f74fb23f81e8e40$var$_react = $2f74fb23f81e8e40$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $2f74fb23f81e8e40$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2f74fb23f81e8e40$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2f74fb23f81e8e40$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $2f74fb23f81e8e40$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $2f74fb23f81e8e40$var$_extends() {
    return $2f74fb23f81e8e40$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2f74fb23f81e8e40$var$_extends.apply(null, arguments);
}
var $2f74fb23f81e8e40$var$Firewall = $2f74fb23f81e8e40$export$a0e020eeac88cef2 = /*#__PURE__*/ (0, $2f74fb23f81e8e40$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $2f74fb23f81e8e40$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $2f74fb23f81e8e40$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Firewall"
    }, props), /*#__PURE__*/ $2f74fb23f81e8e40$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.006 2.02a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6zm5.916 2.976a1.1 1.1 0 0 0-1.1 1.1v1.8a1.1 1.1 0 0 0 1.1 1.1h5.8a1.1 1.1 0 0 0 1.1-1.1v-1.8a1.1 1.1 0 0 0-1.1-1.1h-5.8zm-8.822 0a1.1 1.1 0 0 0-1.1 1.1v1.8a1.1 1.1 0 0 0 1.1 1.1h5.8a1.1 1.1 0 0 0 1.1-1.1v-1.8a1.1 1.1 0 0 0-1.1-1.1H3.1zm0 9.992a1.1 1.1 0 0 0-1.1 1.1v1.8a1.1 1.1 0 0 0 1.1 1.1h5.8a1.1 1.1 0 0 0 1.1-1.1v-1.8a1.1 1.1 0 0 0-1.1-1.1H3.1zm7.723 1.1a1.1 1.1 0 0 1 1.1-1.1h5.8a1.1 1.1 0 0 1 1.1 1.1v1.8a1.1 1.1 0 0 1-1.1 1.1h-5.8a1.1 1.1 0 0 1-1.1-1.1v-1.8zm-5.975-5.015a1.1 1.1 0 0 1 1.1-1.1h5.8a1.1 1.1 0 0 1 1.1 1.1v1.8a1.1 1.1 0 0 1-1.1 1.1h-5.8a1.1 1.1 0 0 1-1.1-1.1v-1.8zm9.866-1.061a1.1 1.1 0 0 0-1.1 1.1v1.8a1.1 1.1 0 0 0 1.1 1.1h5.8a1.1 1.1 0 0 0 1.1-1.1v-1.8a1.1 1.1 0 0 0-1.1-1.1h-5.8zM14 3.019a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1zm1 16.962a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2h-6zm-9.988 1a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1-1-1zM3 9.973a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1zm16.63-3.977a1 1 0 1 1 2 0v2a1 1 0 0 1-2 0v-2zm1.015 8.992a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1zM2 20.981a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM3.011 2.019a1 1 0 1 0 0 2 1 1 0 0 0 0-2z",
        fill: "#000"
    }));
});
$2f74fb23f81e8e40$var$Firewall.displayName = 'Firewall';


Object.keys($2f74fb23f81e8e40$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $2f74fb23f81e8e40$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $2f74fb23f81e8e40$exports[key];
});
var $3d11c15a574e925c$exports = {};

$parcel$export($3d11c15a574e925c$exports, "__esModule", function () { return $3d11c15a574e925c$export$1e511d4a378977f5; }, function (v) { return $3d11c15a574e925c$export$1e511d4a378977f5 = v; });
$parcel$export($3d11c15a574e925c$exports, "FlagFill", function () { return $3d11c15a574e925c$export$78bb60cc86f19b62; }, function (v) { return $3d11c15a574e925c$export$78bb60cc86f19b62 = v; });
var $3d11c15a574e925c$export$1e511d4a378977f5;
var $3d11c15a574e925c$export$78bb60cc86f19b62;
"use strict";
$3d11c15a574e925c$export$1e511d4a378977f5 = true;
$3d11c15a574e925c$export$78bb60cc86f19b62 = void 0;

var $3d11c15a574e925c$var$_react = $3d11c15a574e925c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $3d11c15a574e925c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3d11c15a574e925c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3d11c15a574e925c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3d11c15a574e925c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3d11c15a574e925c$var$_extends() {
    return $3d11c15a574e925c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3d11c15a574e925c$var$_extends.apply(null, arguments);
}
var $3d11c15a574e925c$var$FlagFill = $3d11c15a574e925c$export$78bb60cc86f19b62 = /*#__PURE__*/ (0, $3d11c15a574e925c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3d11c15a574e925c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3d11c15a574e925c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FlagFill"
    }, props), /*#__PURE__*/ $3d11c15a574e925c$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 24V2c8-3.524 11 4.644 20 0v12c-8 4.895-13-4.103-20 0"
    }));
});
$3d11c15a574e925c$var$FlagFill.displayName = 'FlagFill';


Object.keys($3d11c15a574e925c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3d11c15a574e925c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3d11c15a574e925c$exports[key];
});
var $357a0aea6bbf95b6$exports = {};

$parcel$export($357a0aea6bbf95b6$exports, "__esModule", function () { return $357a0aea6bbf95b6$export$1e511d4a378977f5; }, function (v) { return $357a0aea6bbf95b6$export$1e511d4a378977f5 = v; });
$parcel$export($357a0aea6bbf95b6$exports, "Flag", function () { return $357a0aea6bbf95b6$export$48ea269755562084; }, function (v) { return $357a0aea6bbf95b6$export$48ea269755562084 = v; });
var $357a0aea6bbf95b6$export$1e511d4a378977f5;
var $357a0aea6bbf95b6$export$48ea269755562084;
"use strict";
$357a0aea6bbf95b6$export$1e511d4a378977f5 = true;
$357a0aea6bbf95b6$export$48ea269755562084 = void 0;

var $357a0aea6bbf95b6$var$_react = $357a0aea6bbf95b6$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $357a0aea6bbf95b6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($357a0aea6bbf95b6$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $357a0aea6bbf95b6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $357a0aea6bbf95b6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $357a0aea6bbf95b6$var$_extends() {
    return $357a0aea6bbf95b6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $357a0aea6bbf95b6$var$_extends.apply(null, arguments);
}
var $357a0aea6bbf95b6$var$Flag = $357a0aea6bbf95b6$export$48ea269755562084 = /*#__PURE__*/ (0, $357a0aea6bbf95b6$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $357a0aea6bbf95b6$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $357a0aea6bbf95b6$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Flag"
    }, props), /*#__PURE__*/ $357a0aea6bbf95b6$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 24V2c8-3.524 11 4.644 20 0v12c-8 4.895-13-4.103-20 0"
    }));
});
$357a0aea6bbf95b6$var$Flag.displayName = 'Flag';


Object.keys($357a0aea6bbf95b6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $357a0aea6bbf95b6$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $357a0aea6bbf95b6$exports[key];
});
var $dd199f60191ea6eb$exports = {};

$parcel$export($dd199f60191ea6eb$exports, "__esModule", function () { return $dd199f60191ea6eb$export$1e511d4a378977f5; }, function (v) { return $dd199f60191ea6eb$export$1e511d4a378977f5 = v; });
$parcel$export($dd199f60191ea6eb$exports, "Flows", function () { return $dd199f60191ea6eb$export$a1ef158a6380b092; }, function (v) { return $dd199f60191ea6eb$export$a1ef158a6380b092 = v; });
var $dd199f60191ea6eb$export$1e511d4a378977f5;
var $dd199f60191ea6eb$export$a1ef158a6380b092;
"use strict";
$dd199f60191ea6eb$export$1e511d4a378977f5 = true;
$dd199f60191ea6eb$export$a1ef158a6380b092 = void 0;

var $dd199f60191ea6eb$var$_react = $dd199f60191ea6eb$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $dd199f60191ea6eb$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($dd199f60191ea6eb$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $dd199f60191ea6eb$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $dd199f60191ea6eb$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $dd199f60191ea6eb$var$_extends() {
    return $dd199f60191ea6eb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $dd199f60191ea6eb$var$_extends.apply(null, arguments);
}
var $dd199f60191ea6eb$var$Flows = $dd199f60191ea6eb$export$a1ef158a6380b092 = /*#__PURE__*/ (0, $dd199f60191ea6eb$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $dd199f60191ea6eb$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $dd199f60191ea6eb$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Flows"
    }, props), /*#__PURE__*/ $dd199f60191ea6eb$var$_react["default"].createElement("path", {
        stroke: "#000",
        strokeWidth: "2",
        fill: "none",
        d: "M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5zm0 11a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3z"
    }));
});
$dd199f60191ea6eb$var$Flows.displayName = 'Flows';


Object.keys($dd199f60191ea6eb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $dd199f60191ea6eb$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $dd199f60191ea6eb$exports[key];
});
var $5b4bb1ccd6e5d5ef$exports = {};

$parcel$export($5b4bb1ccd6e5d5ef$exports, "__esModule", function () { return $5b4bb1ccd6e5d5ef$export$1e511d4a378977f5; }, function (v) { return $5b4bb1ccd6e5d5ef$export$1e511d4a378977f5 = v; });
$parcel$export($5b4bb1ccd6e5d5ef$exports, "FolderCycle", function () { return $5b4bb1ccd6e5d5ef$export$38d6ca1682283df9; }, function (v) { return $5b4bb1ccd6e5d5ef$export$38d6ca1682283df9 = v; });
var $5b4bb1ccd6e5d5ef$export$1e511d4a378977f5;
var $5b4bb1ccd6e5d5ef$export$38d6ca1682283df9;
"use strict";
$5b4bb1ccd6e5d5ef$export$1e511d4a378977f5 = true;
$5b4bb1ccd6e5d5ef$export$38d6ca1682283df9 = void 0;

var $5b4bb1ccd6e5d5ef$var$_react = $5b4bb1ccd6e5d5ef$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5b4bb1ccd6e5d5ef$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5b4bb1ccd6e5d5ef$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5b4bb1ccd6e5d5ef$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5b4bb1ccd6e5d5ef$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5b4bb1ccd6e5d5ef$var$_extends() {
    return $5b4bb1ccd6e5d5ef$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5b4bb1ccd6e5d5ef$var$_extends.apply(null, arguments);
}
var $5b4bb1ccd6e5d5ef$var$FolderCycle = $5b4bb1ccd6e5d5ef$export$38d6ca1682283df9 = /*#__PURE__*/ (0, $5b4bb1ccd6e5d5ef$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5b4bb1ccd6e5d5ef$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5b4bb1ccd6e5d5ef$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FolderCycle"
    }, props), /*#__PURE__*/ $5b4bb1ccd6e5d5ef$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M7 18a5 5 0 0 1 5-5c1.985 0 3.7 1.156 4.5 3m.5 2a5 5 0 0 1-5 5c-1.985 0-3.699-1.156-4.5-3m5.5-4h4v-4m-6 8H7v4m-3-1H1V1h8l3 4h11v18h-4M1 9h22M4 23H1V1h8l3 4h11v18h-4M1 9h22"
    }));
});
$5b4bb1ccd6e5d5ef$var$FolderCycle.displayName = 'FolderCycle';


Object.keys($5b4bb1ccd6e5d5ef$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5b4bb1ccd6e5d5ef$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5b4bb1ccd6e5d5ef$exports[key];
});
var $e1c3bfe89df0c7d8$exports = {};

$parcel$export($e1c3bfe89df0c7d8$exports, "__esModule", function () { return $e1c3bfe89df0c7d8$export$1e511d4a378977f5; }, function (v) { return $e1c3bfe89df0c7d8$export$1e511d4a378977f5 = v; });
$parcel$export($e1c3bfe89df0c7d8$exports, "FolderOpen", function () { return $e1c3bfe89df0c7d8$export$6032e6db9bc400f5; }, function (v) { return $e1c3bfe89df0c7d8$export$6032e6db9bc400f5 = v; });
var $e1c3bfe89df0c7d8$export$1e511d4a378977f5;
var $e1c3bfe89df0c7d8$export$6032e6db9bc400f5;
"use strict";
$e1c3bfe89df0c7d8$export$1e511d4a378977f5 = true;
$e1c3bfe89df0c7d8$export$6032e6db9bc400f5 = void 0;

var $e1c3bfe89df0c7d8$var$_react = $e1c3bfe89df0c7d8$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e1c3bfe89df0c7d8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e1c3bfe89df0c7d8$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e1c3bfe89df0c7d8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e1c3bfe89df0c7d8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e1c3bfe89df0c7d8$var$_extends() {
    return $e1c3bfe89df0c7d8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e1c3bfe89df0c7d8$var$_extends.apply(null, arguments);
}
var $e1c3bfe89df0c7d8$var$FolderOpen = $e1c3bfe89df0c7d8$export$6032e6db9bc400f5 = /*#__PURE__*/ (0, $e1c3bfe89df0c7d8$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e1c3bfe89df0c7d8$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e1c3bfe89df0c7d8$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FolderOpen"
    }, props), /*#__PURE__*/ $e1c3bfe89df0c7d8$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M5 2h6l2 4h6v4H5V2zm-3 8h20l-3 12H5L2 10z"
    }));
});
$e1c3bfe89df0c7d8$var$FolderOpen.displayName = 'FolderOpen';


Object.keys($e1c3bfe89df0c7d8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e1c3bfe89df0c7d8$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e1c3bfe89df0c7d8$exports[key];
});
var $22e10d80c72308ae$exports = {};

$parcel$export($22e10d80c72308ae$exports, "__esModule", function () { return $22e10d80c72308ae$export$1e511d4a378977f5; }, function (v) { return $22e10d80c72308ae$export$1e511d4a378977f5 = v; });
$parcel$export($22e10d80c72308ae$exports, "Folder", function () { return $22e10d80c72308ae$export$80729fed35a16515; }, function (v) { return $22e10d80c72308ae$export$80729fed35a16515 = v; });
var $22e10d80c72308ae$export$1e511d4a378977f5;
var $22e10d80c72308ae$export$80729fed35a16515;
"use strict";
$22e10d80c72308ae$export$1e511d4a378977f5 = true;
$22e10d80c72308ae$export$80729fed35a16515 = void 0;

var $22e10d80c72308ae$var$_react = $22e10d80c72308ae$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $22e10d80c72308ae$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($22e10d80c72308ae$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $22e10d80c72308ae$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $22e10d80c72308ae$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $22e10d80c72308ae$var$_extends() {
    return $22e10d80c72308ae$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $22e10d80c72308ae$var$_extends.apply(null, arguments);
}
var $22e10d80c72308ae$var$Folder = $22e10d80c72308ae$export$80729fed35a16515 = /*#__PURE__*/ (0, $22e10d80c72308ae$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $22e10d80c72308ae$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $22e10d80c72308ae$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Folder"
    }, props), /*#__PURE__*/ $22e10d80c72308ae$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 10V2h8l3 4h9v4H2zm0 0h20v12H2V10z"
    }));
});
$22e10d80c72308ae$var$Folder.displayName = 'Folder';


Object.keys($22e10d80c72308ae$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $22e10d80c72308ae$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $22e10d80c72308ae$exports[key];
});
var $991a9bab2585b774$exports = {};

$parcel$export($991a9bab2585b774$exports, "__esModule", function () { return $991a9bab2585b774$export$1e511d4a378977f5; }, function (v) { return $991a9bab2585b774$export$1e511d4a378977f5 = v; });
$parcel$export($991a9bab2585b774$exports, "FormAdd", function () { return $991a9bab2585b774$export$db57e7b2a936077c; }, function (v) { return $991a9bab2585b774$export$db57e7b2a936077c = v; });
var $991a9bab2585b774$export$1e511d4a378977f5;
var $991a9bab2585b774$export$db57e7b2a936077c;
"use strict";
$991a9bab2585b774$export$1e511d4a378977f5 = true;
$991a9bab2585b774$export$db57e7b2a936077c = void 0;

var $991a9bab2585b774$var$_react = $991a9bab2585b774$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $991a9bab2585b774$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($991a9bab2585b774$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $991a9bab2585b774$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $991a9bab2585b774$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $991a9bab2585b774$var$_extends() {
    return $991a9bab2585b774$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $991a9bab2585b774$var$_extends.apply(null, arguments);
}
var $991a9bab2585b774$var$FormAdd = $991a9bab2585b774$export$db57e7b2a936077c = /*#__PURE__*/ (0, $991a9bab2585b774$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $991a9bab2585b774$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $991a9bab2585b774$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormAdd"
    }, props), /*#__PURE__*/ $991a9bab2585b774$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 18V6m-6 6h12"
    }));
});
$991a9bab2585b774$var$FormAdd.displayName = 'FormAdd';


Object.keys($991a9bab2585b774$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $991a9bab2585b774$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $991a9bab2585b774$exports[key];
});
var $887f70690887937a$exports = {};

$parcel$export($887f70690887937a$exports, "__esModule", function () { return $887f70690887937a$export$1e511d4a378977f5; }, function (v) { return $887f70690887937a$export$1e511d4a378977f5 = v; });
$parcel$export($887f70690887937a$exports, "FormAttachment", function () { return $887f70690887937a$export$baeba309c80ed796; }, function (v) { return $887f70690887937a$export$baeba309c80ed796 = v; });
var $887f70690887937a$export$1e511d4a378977f5;
var $887f70690887937a$export$baeba309c80ed796;
"use strict";
$887f70690887937a$export$1e511d4a378977f5 = true;
$887f70690887937a$export$baeba309c80ed796 = void 0;

var $887f70690887937a$var$_react = $887f70690887937a$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $887f70690887937a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($887f70690887937a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $887f70690887937a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $887f70690887937a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $887f70690887937a$var$_extends() {
    return $887f70690887937a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $887f70690887937a$var$_extends.apply(null, arguments);
}
var $887f70690887937a$var$FormAttachment = $887f70690887937a$export$baeba309c80ed796 = /*#__PURE__*/ (0, $887f70690887937a$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $887f70690887937a$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $887f70690887937a$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormAttachment"
    }, props), /*#__PURE__*/ $887f70690887937a$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m6 13.293 6.36-6.36c2.828-2.828 7.069 1.413 4.242 4.24l-6.361 6.36c-1.414 1.414-3.534-.706-2.12-2.12l6.36-6.36"
    }));
});
$887f70690887937a$var$FormAttachment.displayName = 'FormAttachment';


Object.keys($887f70690887937a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $887f70690887937a$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $887f70690887937a$exports[key];
});
var $a799549edd839e17$exports = {};

$parcel$export($a799549edd839e17$exports, "__esModule", function () { return $a799549edd839e17$export$1e511d4a378977f5; }, function (v) { return $a799549edd839e17$export$1e511d4a378977f5 = v; });
$parcel$export($a799549edd839e17$exports, "FormCalendar", function () { return $a799549edd839e17$export$765bc72aca29083d; }, function (v) { return $a799549edd839e17$export$765bc72aca29083d = v; });
var $a799549edd839e17$export$1e511d4a378977f5;
var $a799549edd839e17$export$765bc72aca29083d;
"use strict";
$a799549edd839e17$export$1e511d4a378977f5 = true;
$a799549edd839e17$export$765bc72aca29083d = void 0;

var $a799549edd839e17$var$_react = $a799549edd839e17$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a799549edd839e17$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a799549edd839e17$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a799549edd839e17$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a799549edd839e17$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a799549edd839e17$var$_extends() {
    return $a799549edd839e17$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a799549edd839e17$var$_extends.apply(null, arguments);
}
var $a799549edd839e17$var$FormCalendar = $a799549edd839e17$export$765bc72aca29083d = /*#__PURE__*/ (0, $a799549edd839e17$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a799549edd839e17$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a799549edd839e17$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormCalendar"
    }, props), /*#__PURE__*/ $a799549edd839e17$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M6 19h12V8H6v11zm9-11V5v3zM9 8V5v3zm-3 3.5h12H6z"
    }));
});
$a799549edd839e17$var$FormCalendar.displayName = 'FormCalendar';


Object.keys($a799549edd839e17$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a799549edd839e17$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a799549edd839e17$exports[key];
});

Object.keys($7aaaa7abc2375846$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $7aaaa7abc2375846$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $7aaaa7abc2375846$exports[key];
});
var $a38c85afaefa8da0$exports = {};

$parcel$export($a38c85afaefa8da0$exports, "__esModule", function () { return $a38c85afaefa8da0$export$1e511d4a378977f5; }, function (v) { return $a38c85afaefa8da0$export$1e511d4a378977f5 = v; });
$parcel$export($a38c85afaefa8da0$exports, "FormClock", function () { return $a38c85afaefa8da0$export$f3fb0ad36b29fb18; }, function (v) { return $a38c85afaefa8da0$export$f3fb0ad36b29fb18 = v; });
var $a38c85afaefa8da0$export$1e511d4a378977f5;
var $a38c85afaefa8da0$export$f3fb0ad36b29fb18;
"use strict";
$a38c85afaefa8da0$export$1e511d4a378977f5 = true;
$a38c85afaefa8da0$export$f3fb0ad36b29fb18 = void 0;

var $a38c85afaefa8da0$var$_react = $a38c85afaefa8da0$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a38c85afaefa8da0$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a38c85afaefa8da0$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a38c85afaefa8da0$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a38c85afaefa8da0$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a38c85afaefa8da0$var$_extends() {
    return $a38c85afaefa8da0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a38c85afaefa8da0$var$_extends.apply(null, arguments);
}
var $a38c85afaefa8da0$var$FormClock = $a38c85afaefa8da0$export$f3fb0ad36b29fb18 = /*#__PURE__*/ (0, $a38c85afaefa8da0$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a38c85afaefa8da0$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a38c85afaefa8da0$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormClock"
    }, props), /*#__PURE__*/ $a38c85afaefa8da0$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12zm0-10v4l3 1"
    }));
});
$a38c85afaefa8da0$var$FormClock.displayName = 'FormClock';


Object.keys($a38c85afaefa8da0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a38c85afaefa8da0$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a38c85afaefa8da0$exports[key];
});

Object.keys($da76b8daacd39c4f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $da76b8daacd39c4f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $da76b8daacd39c4f$exports[key];
});
var $52b33c111385e402$exports = {};

$parcel$export($52b33c111385e402$exports, "__esModule", function () { return $52b33c111385e402$export$1e511d4a378977f5; }, function (v) { return $52b33c111385e402$export$1e511d4a378977f5 = v; });
$parcel$export($52b33c111385e402$exports, "FormCut", function () { return $52b33c111385e402$export$84e3d56ecb8593d; }, function (v) { return $52b33c111385e402$export$84e3d56ecb8593d = v; });
var $52b33c111385e402$export$1e511d4a378977f5;
var $52b33c111385e402$export$84e3d56ecb8593d;
"use strict";
$52b33c111385e402$export$1e511d4a378977f5 = true;
$52b33c111385e402$export$84e3d56ecb8593d = void 0;

var $52b33c111385e402$var$_react = $52b33c111385e402$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $52b33c111385e402$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($52b33c111385e402$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $52b33c111385e402$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $52b33c111385e402$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $52b33c111385e402$var$_extends() {
    return $52b33c111385e402$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $52b33c111385e402$var$_extends.apply(null, arguments);
}
var $52b33c111385e402$var$FormCut = $52b33c111385e402$export$84e3d56ecb8593d = /*#__PURE__*/ (0, $52b33c111385e402$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $52b33c111385e402$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $52b33c111385e402$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormCut"
    }, props), /*#__PURE__*/ $52b33c111385e402$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m18 7.524-7.857 6.286L18 7.524zm0 8.38L10.143 9.62 18 15.905zm-9.429-5.761a1.571 1.571 0 1 0 0-3.143 1.571 1.571 0 0 0 0 3.143zm0 6.286a1.571 1.571 0 1 0 0-3.143 1.571 1.571 0 0 0 0 3.143z"
    }));
});
$52b33c111385e402$var$FormCut.displayName = 'FormCut';


Object.keys($52b33c111385e402$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $52b33c111385e402$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $52b33c111385e402$exports[key];
});

Object.keys($08156255a6733056$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $08156255a6733056$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $08156255a6733056$exports[key];
});
var $24992df5de31aa26$exports = {};

$parcel$export($24992df5de31aa26$exports, "__esModule", function () { return $24992df5de31aa26$export$1e511d4a378977f5; }, function (v) { return $24992df5de31aa26$export$1e511d4a378977f5 = v; });
$parcel$export($24992df5de31aa26$exports, "FormEdit", function () { return $24992df5de31aa26$export$e1932b71cd99bf5a; }, function (v) { return $24992df5de31aa26$export$e1932b71cd99bf5a = v; });
var $24992df5de31aa26$export$1e511d4a378977f5;
var $24992df5de31aa26$export$e1932b71cd99bf5a;
"use strict";
$24992df5de31aa26$export$1e511d4a378977f5 = true;
$24992df5de31aa26$export$e1932b71cd99bf5a = void 0;

var $24992df5de31aa26$var$_react = $24992df5de31aa26$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $24992df5de31aa26$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($24992df5de31aa26$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $24992df5de31aa26$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $24992df5de31aa26$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $24992df5de31aa26$var$_extends() {
    return $24992df5de31aa26$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $24992df5de31aa26$var$_extends.apply(null, arguments);
}
var $24992df5de31aa26$var$FormEdit = $24992df5de31aa26$export$e1932b71cd99bf5a = /*#__PURE__*/ (0, $24992df5de31aa26$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $24992df5de31aa26$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $24992df5de31aa26$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormEdit"
    }, props), /*#__PURE__*/ $24992df5de31aa26$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m11.996 8.336 3.497 3.498-3.497-3.498zm5.54-.54a.994.994 0 0 1-.004 1.416l-7.451 7.451L6 17.83l1.166-4.08 7.451-7.452a.997.997 0 0 1 1.416-.005l1.504 1.504z"
    }));
});
$24992df5de31aa26$var$FormEdit.displayName = 'FormEdit';


Object.keys($24992df5de31aa26$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $24992df5de31aa26$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $24992df5de31aa26$exports[key];
});
var $ec42aa71cdd6ee74$exports = {};

$parcel$export($ec42aa71cdd6ee74$exports, "__esModule", function () { return $ec42aa71cdd6ee74$export$1e511d4a378977f5; }, function (v) { return $ec42aa71cdd6ee74$export$1e511d4a378977f5 = v; });
$parcel$export($ec42aa71cdd6ee74$exports, "FormFilter", function () { return $ec42aa71cdd6ee74$export$61dc9cfe8209d168; }, function (v) { return $ec42aa71cdd6ee74$export$61dc9cfe8209d168 = v; });
var $ec42aa71cdd6ee74$export$1e511d4a378977f5;
var $ec42aa71cdd6ee74$export$61dc9cfe8209d168;
"use strict";
$ec42aa71cdd6ee74$export$1e511d4a378977f5 = true;
$ec42aa71cdd6ee74$export$61dc9cfe8209d168 = void 0;

var $ec42aa71cdd6ee74$var$_react = $ec42aa71cdd6ee74$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $ec42aa71cdd6ee74$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ec42aa71cdd6ee74$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ec42aa71cdd6ee74$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ec42aa71cdd6ee74$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ec42aa71cdd6ee74$var$_extends() {
    return $ec42aa71cdd6ee74$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ec42aa71cdd6ee74$var$_extends.apply(null, arguments);
}
var $ec42aa71cdd6ee74$var$FormFilter = $ec42aa71cdd6ee74$export$61dc9cfe8209d168 = /*#__PURE__*/ (0, $ec42aa71cdd6ee74$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $ec42aa71cdd6ee74$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ec42aa71cdd6ee74$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormFilter"
    }, props), /*#__PURE__*/ $ec42aa71cdd6ee74$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m6 8 5.667 4.667V18h.666v-5.333L18 8V6H6z"
    }));
});
$ec42aa71cdd6ee74$var$FormFilter.displayName = 'FormFilter';


Object.keys($ec42aa71cdd6ee74$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ec42aa71cdd6ee74$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ec42aa71cdd6ee74$exports[key];
});
var $8cc35a1e73582541$exports = {};

$parcel$export($8cc35a1e73582541$exports, "__esModule", function () { return $8cc35a1e73582541$export$1e511d4a378977f5; }, function (v) { return $8cc35a1e73582541$export$1e511d4a378977f5 = v; });
$parcel$export($8cc35a1e73582541$exports, "FormFolder", function () { return $8cc35a1e73582541$export$f32f3a3140b7e727; }, function (v) { return $8cc35a1e73582541$export$f32f3a3140b7e727 = v; });
var $8cc35a1e73582541$export$1e511d4a378977f5;
var $8cc35a1e73582541$export$f32f3a3140b7e727;
"use strict";
$8cc35a1e73582541$export$1e511d4a378977f5 = true;
$8cc35a1e73582541$export$f32f3a3140b7e727 = void 0;

var $8cc35a1e73582541$var$_react = $8cc35a1e73582541$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $8cc35a1e73582541$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8cc35a1e73582541$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8cc35a1e73582541$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $8cc35a1e73582541$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8cc35a1e73582541$var$_extends() {
    return $8cc35a1e73582541$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8cc35a1e73582541$var$_extends.apply(null, arguments);
}
var $8cc35a1e73582541$var$FormFolder = $8cc35a1e73582541$export$f32f3a3140b7e727 = /*#__PURE__*/ (0, $8cc35a1e73582541$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $8cc35a1e73582541$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $8cc35a1e73582541$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormFolder"
    }, props), /*#__PURE__*/ $8cc35a1e73582541$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M6 18V6h4.8l1.8 2.4H18V18z"
    }));
});
$8cc35a1e73582541$var$FormFolder.displayName = 'FormFolder';


Object.keys($8cc35a1e73582541$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $8cc35a1e73582541$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $8cc35a1e73582541$exports[key];
});
var $29433d65c3e3fe21$exports = {};

$parcel$export($29433d65c3e3fe21$exports, "__esModule", function () { return $29433d65c3e3fe21$export$1e511d4a378977f5; }, function (v) { return $29433d65c3e3fe21$export$1e511d4a378977f5 = v; });
$parcel$export($29433d65c3e3fe21$exports, "FormLocation", function () { return $29433d65c3e3fe21$export$c79224a800e67ab5; }, function (v) { return $29433d65c3e3fe21$export$c79224a800e67ab5 = v; });
var $29433d65c3e3fe21$export$1e511d4a378977f5;
var $29433d65c3e3fe21$export$c79224a800e67ab5;
"use strict";
$29433d65c3e3fe21$export$1e511d4a378977f5 = true;
$29433d65c3e3fe21$export$c79224a800e67ab5 = void 0;

var $29433d65c3e3fe21$var$_react = $29433d65c3e3fe21$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $29433d65c3e3fe21$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($29433d65c3e3fe21$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $29433d65c3e3fe21$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $29433d65c3e3fe21$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $29433d65c3e3fe21$var$_extends() {
    return $29433d65c3e3fe21$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $29433d65c3e3fe21$var$_extends.apply(null, arguments);
}
var $29433d65c3e3fe21$var$FormLocation = $29433d65c3e3fe21$export$c79224a800e67ab5 = /*#__PURE__*/ (0, $29433d65c3e3fe21$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $29433d65c3e3fe21$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $29433d65c3e3fe21$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormLocation"
    }, props), /*#__PURE__*/ $29433d65c3e3fe21$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 17s-4-3-4-6c0-2.5 2-4 4-4s4 1.5 4 4c0 3-4 6-4 6zm0-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
    }));
});
$29433d65c3e3fe21$var$FormLocation.displayName = 'FormLocation';


Object.keys($29433d65c3e3fe21$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $29433d65c3e3fe21$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $29433d65c3e3fe21$exports[key];
});
var $00a992af185fe5ef$exports = {};

$parcel$export($00a992af185fe5ef$exports, "__esModule", function () { return $00a992af185fe5ef$export$1e511d4a378977f5; }, function (v) { return $00a992af185fe5ef$export$1e511d4a378977f5 = v; });
$parcel$export($00a992af185fe5ef$exports, "FormLock", function () { return $00a992af185fe5ef$export$be05c93846c15d02; }, function (v) { return $00a992af185fe5ef$export$be05c93846c15d02 = v; });
var $00a992af185fe5ef$export$1e511d4a378977f5;
var $00a992af185fe5ef$export$be05c93846c15d02;
"use strict";
$00a992af185fe5ef$export$1e511d4a378977f5 = true;
$00a992af185fe5ef$export$be05c93846c15d02 = void 0;

var $00a992af185fe5ef$var$_react = $00a992af185fe5ef$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $00a992af185fe5ef$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($00a992af185fe5ef$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $00a992af185fe5ef$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $00a992af185fe5ef$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $00a992af185fe5ef$var$_extends() {
    return $00a992af185fe5ef$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $00a992af185fe5ef$var$_extends.apply(null, arguments);
}
var $00a992af185fe5ef$var$FormLock = $00a992af185fe5ef$export$be05c93846c15d02 = /*#__PURE__*/ (0, $00a992af185fe5ef$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $00a992af185fe5ef$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $00a992af185fe5ef$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormLock"
    }, props), /*#__PURE__*/ $00a992af185fe5ef$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M9 11V8a3 3 0 0 1 6 0v3m-3 2v3m5 2v-7H7v7h10z"
    }));
});
$00a992af185fe5ef$var$FormLock.displayName = 'FormLock';


Object.keys($00a992af185fe5ef$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $00a992af185fe5ef$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $00a992af185fe5ef$exports[key];
});
var $cf2585ca349650d0$exports = {};

$parcel$export($cf2585ca349650d0$exports, "__esModule", function () { return $cf2585ca349650d0$export$1e511d4a378977f5; }, function (v) { return $cf2585ca349650d0$export$1e511d4a378977f5 = v; });
$parcel$export($cf2585ca349650d0$exports, "FormNextLink", function () { return $cf2585ca349650d0$export$93f38f17672890ac; }, function (v) { return $cf2585ca349650d0$export$93f38f17672890ac = v; });
var $cf2585ca349650d0$export$1e511d4a378977f5;
var $cf2585ca349650d0$export$93f38f17672890ac;
"use strict";
$cf2585ca349650d0$export$1e511d4a378977f5 = true;
$cf2585ca349650d0$export$93f38f17672890ac = void 0;

var $cf2585ca349650d0$var$_react = $cf2585ca349650d0$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $cf2585ca349650d0$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($cf2585ca349650d0$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $cf2585ca349650d0$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $cf2585ca349650d0$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $cf2585ca349650d0$var$_extends() {
    return $cf2585ca349650d0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cf2585ca349650d0$var$_extends.apply(null, arguments);
}
var $cf2585ca349650d0$var$FormNextLink = $cf2585ca349650d0$export$93f38f17672890ac = /*#__PURE__*/ (0, $cf2585ca349650d0$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $cf2585ca349650d0$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $cf2585ca349650d0$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormNextLink"
    }, props), /*#__PURE__*/ $cf2585ca349650d0$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M6 12.4h12M12.6 7l5.4 5.4-5.4 5.4"
    }));
});
$cf2585ca349650d0$var$FormNextLink.displayName = 'FormNextLink';


Object.keys($cf2585ca349650d0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $cf2585ca349650d0$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $cf2585ca349650d0$exports[key];
});

Object.keys($0736b9499c5aa664$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0736b9499c5aa664$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0736b9499c5aa664$exports[key];
});

Object.keys($5c441c37eb1f2356$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5c441c37eb1f2356$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5c441c37eb1f2356$exports[key];
});
var $950f532fd6aa4183$exports = {};

$parcel$export($950f532fd6aa4183$exports, "__esModule", function () { return $950f532fd6aa4183$export$1e511d4a378977f5; }, function (v) { return $950f532fd6aa4183$export$1e511d4a378977f5 = v; });
$parcel$export($950f532fd6aa4183$exports, "FormPreviousLink", function () { return $950f532fd6aa4183$export$93b624d2f88996c0; }, function (v) { return $950f532fd6aa4183$export$93b624d2f88996c0 = v; });
var $950f532fd6aa4183$export$1e511d4a378977f5;
var $950f532fd6aa4183$export$93b624d2f88996c0;
"use strict";
$950f532fd6aa4183$export$1e511d4a378977f5 = true;
$950f532fd6aa4183$export$93b624d2f88996c0 = void 0;

var $950f532fd6aa4183$var$_react = $950f532fd6aa4183$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $950f532fd6aa4183$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($950f532fd6aa4183$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $950f532fd6aa4183$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $950f532fd6aa4183$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $950f532fd6aa4183$var$_extends() {
    return $950f532fd6aa4183$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $950f532fd6aa4183$var$_extends.apply(null, arguments);
}
var $950f532fd6aa4183$var$FormPreviousLink = $950f532fd6aa4183$export$93b624d2f88996c0 = /*#__PURE__*/ (0, $950f532fd6aa4183$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $950f532fd6aa4183$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $950f532fd6aa4183$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormPreviousLink"
    }, props), /*#__PURE__*/ $950f532fd6aa4183$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M18 12.4H6M11.4 7 6 12.4l5.4 5.4"
    }));
});
$950f532fd6aa4183$var$FormPreviousLink.displayName = 'FormPreviousLink';


Object.keys($950f532fd6aa4183$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $950f532fd6aa4183$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $950f532fd6aa4183$exports[key];
});

Object.keys($e416b67dbaf66fc1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e416b67dbaf66fc1$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e416b67dbaf66fc1$exports[key];
});
var $72399dd284e8dde1$exports = {};

$parcel$export($72399dd284e8dde1$exports, "__esModule", function () { return $72399dd284e8dde1$export$1e511d4a378977f5; }, function (v) { return $72399dd284e8dde1$export$1e511d4a378977f5 = v; });
$parcel$export($72399dd284e8dde1$exports, "FormRefresh", function () { return $72399dd284e8dde1$export$d7b28ee6bd099d26; }, function (v) { return $72399dd284e8dde1$export$d7b28ee6bd099d26 = v; });
var $72399dd284e8dde1$export$1e511d4a378977f5;
var $72399dd284e8dde1$export$d7b28ee6bd099d26;
"use strict";
$72399dd284e8dde1$export$1e511d4a378977f5 = true;
$72399dd284e8dde1$export$d7b28ee6bd099d26 = void 0;

var $72399dd284e8dde1$var$_react = $72399dd284e8dde1$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $72399dd284e8dde1$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($72399dd284e8dde1$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $72399dd284e8dde1$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $72399dd284e8dde1$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $72399dd284e8dde1$var$_extends() {
    return $72399dd284e8dde1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $72399dd284e8dde1$var$_extends.apply(null, arguments);
}
var $72399dd284e8dde1$var$FormRefresh = $72399dd284e8dde1$export$d7b28ee6bd099d26 = /*#__PURE__*/ (0, $72399dd284e8dde1$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $72399dd284e8dde1$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $72399dd284e8dde1$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormRefresh"
    }, props), /*#__PURE__*/ $72399dd284e8dde1$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M17.333 9.333C16.398 7.36 14.358 6 12 6a6 6 0 1 0 6 6m.5-6v4h-4"
    }));
});
$72399dd284e8dde1$var$FormRefresh.displayName = 'FormRefresh';


Object.keys($72399dd284e8dde1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $72399dd284e8dde1$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $72399dd284e8dde1$exports[key];
});
var $a01811a601bc719f$exports = {};

$parcel$export($a01811a601bc719f$exports, "__esModule", function () { return $a01811a601bc719f$export$1e511d4a378977f5; }, function (v) { return $a01811a601bc719f$export$1e511d4a378977f5 = v; });
$parcel$export($a01811a601bc719f$exports, "FormSchedule", function () { return $a01811a601bc719f$export$8a3c04dc6f33ce17; }, function (v) { return $a01811a601bc719f$export$8a3c04dc6f33ce17 = v; });
var $a01811a601bc719f$export$1e511d4a378977f5;
var $a01811a601bc719f$export$8a3c04dc6f33ce17;
"use strict";
$a01811a601bc719f$export$1e511d4a378977f5 = true;
$a01811a601bc719f$export$8a3c04dc6f33ce17 = void 0;

var $a01811a601bc719f$var$_react = $a01811a601bc719f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a01811a601bc719f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a01811a601bc719f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a01811a601bc719f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a01811a601bc719f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a01811a601bc719f$var$_extends() {
    return $a01811a601bc719f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a01811a601bc719f$var$_extends.apply(null, arguments);
}
var $a01811a601bc719f$var$FormSchedule = $a01811a601bc719f$export$8a3c04dc6f33ce17 = /*#__PURE__*/ (0, $a01811a601bc719f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a01811a601bc719f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a01811a601bc719f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormSchedule"
    }, props), /*#__PURE__*/ $a01811a601bc719f$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M6 19h12V8H6v11zm2-4h2-2zm3 0h5-5zm4-7V5v3zM9 8V5v3zm-3 3.5h12H6z"
    }));
});
$a01811a601bc719f$var$FormSchedule.displayName = 'FormSchedule';


Object.keys($a01811a601bc719f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a01811a601bc719f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a01811a601bc719f$exports[key];
});

Object.keys($5e76eb42ddcb97c1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5e76eb42ddcb97c1$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5e76eb42ddcb97c1$exports[key];
});
var $98a33709782c9c37$exports = {};

$parcel$export($98a33709782c9c37$exports, "__esModule", function () { return $98a33709782c9c37$export$1e511d4a378977f5; }, function (v) { return $98a33709782c9c37$export$1e511d4a378977f5 = v; });
$parcel$export($98a33709782c9c37$exports, "FormSubtract", function () { return $98a33709782c9c37$export$e847aa8e75c118a0; }, function (v) { return $98a33709782c9c37$export$e847aa8e75c118a0 = v; });
var $98a33709782c9c37$export$1e511d4a378977f5;
var $98a33709782c9c37$export$e847aa8e75c118a0;
"use strict";
$98a33709782c9c37$export$1e511d4a378977f5 = true;
$98a33709782c9c37$export$e847aa8e75c118a0 = void 0;

var $98a33709782c9c37$var$_react = $98a33709782c9c37$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $98a33709782c9c37$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($98a33709782c9c37$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $98a33709782c9c37$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $98a33709782c9c37$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $98a33709782c9c37$var$_extends() {
    return $98a33709782c9c37$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $98a33709782c9c37$var$_extends.apply(null, arguments);
}
var $98a33709782c9c37$var$FormSubtract = $98a33709782c9c37$export$e847aa8e75c118a0 = /*#__PURE__*/ (0, $98a33709782c9c37$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $98a33709782c9c37$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $98a33709782c9c37$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormSubtract"
    }, props), /*#__PURE__*/ $98a33709782c9c37$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M6 12h12"
    }));
});
$98a33709782c9c37$var$FormSubtract.displayName = 'FormSubtract';


Object.keys($98a33709782c9c37$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $98a33709782c9c37$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $98a33709782c9c37$exports[key];
});
var $b8880139bc0ad947$exports = {};

$parcel$export($b8880139bc0ad947$exports, "__esModule", function () { return $b8880139bc0ad947$export$1e511d4a378977f5; }, function (v) { return $b8880139bc0ad947$export$1e511d4a378977f5 = v; });
$parcel$export($b8880139bc0ad947$exports, "FormTrash", function () { return $b8880139bc0ad947$export$b4c37836426a49cb; }, function (v) { return $b8880139bc0ad947$export$b4c37836426a49cb = v; });
var $b8880139bc0ad947$export$1e511d4a378977f5;
var $b8880139bc0ad947$export$b4c37836426a49cb;
"use strict";
$b8880139bc0ad947$export$1e511d4a378977f5 = true;
$b8880139bc0ad947$export$b4c37836426a49cb = void 0;

var $b8880139bc0ad947$var$_react = $b8880139bc0ad947$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $b8880139bc0ad947$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b8880139bc0ad947$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b8880139bc0ad947$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $b8880139bc0ad947$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b8880139bc0ad947$var$_extends() {
    return $b8880139bc0ad947$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b8880139bc0ad947$var$_extends.apply(null, arguments);
}
var $b8880139bc0ad947$var$FormTrash = $b8880139bc0ad947$export$b4c37836426a49cb = /*#__PURE__*/ (0, $b8880139bc0ad947$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $b8880139bc0ad947$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $b8880139bc0ad947$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormTrash"
    }, props), /*#__PURE__*/ $b8880139bc0ad947$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M7.5 9h9v10h-9V9zM5 9h14M9.364 6h5v3h-5V6zm1.181 5v6m3-6v6"
    }));
});
$b8880139bc0ad947$var$FormTrash.displayName = 'FormTrash';


Object.keys($b8880139bc0ad947$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $b8880139bc0ad947$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $b8880139bc0ad947$exports[key];
});

Object.keys($ef56e12f46c6eb58$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ef56e12f46c6eb58$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ef56e12f46c6eb58$exports[key];
});
var $415afa6a27ff1572$exports = {};

$parcel$export($415afa6a27ff1572$exports, "__esModule", function () { return $415afa6a27ff1572$export$1e511d4a378977f5; }, function (v) { return $415afa6a27ff1572$export$1e511d4a378977f5 = v; });
$parcel$export($415afa6a27ff1572$exports, "FormUpload", function () { return $415afa6a27ff1572$export$d9c41cec1a1de26a; }, function (v) { return $415afa6a27ff1572$export$d9c41cec1a1de26a = v; });
var $415afa6a27ff1572$export$1e511d4a378977f5;
var $415afa6a27ff1572$export$d9c41cec1a1de26a;
"use strict";
$415afa6a27ff1572$export$1e511d4a378977f5 = true;
$415afa6a27ff1572$export$d9c41cec1a1de26a = void 0;

var $415afa6a27ff1572$var$_react = $415afa6a27ff1572$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $415afa6a27ff1572$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($415afa6a27ff1572$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $415afa6a27ff1572$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $415afa6a27ff1572$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $415afa6a27ff1572$var$_extends() {
    return $415afa6a27ff1572$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $415afa6a27ff1572$var$_extends.apply(null, arguments);
}
var $415afa6a27ff1572$var$FormUpload = $415afa6a27ff1572$export$d9c41cec1a1de26a = /*#__PURE__*/ (0, $415afa6a27ff1572$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $415afa6a27ff1572$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $415afa6a27ff1572$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormUpload"
    }, props), /*#__PURE__*/ $415afa6a27ff1572$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M6 14.182v3.273h12v-3.273M12 6v8M8.182 9.818 12 6l3.818 3.818"
    }));
});
$415afa6a27ff1572$var$FormUpload.displayName = 'FormUpload';


Object.keys($415afa6a27ff1572$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $415afa6a27ff1572$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $415afa6a27ff1572$exports[key];
});
var $5ba20cdaef825cef$exports = {};

$parcel$export($5ba20cdaef825cef$exports, "__esModule", function () { return $5ba20cdaef825cef$export$1e511d4a378977f5; }, function (v) { return $5ba20cdaef825cef$export$1e511d4a378977f5 = v; });
$parcel$export($5ba20cdaef825cef$exports, "FormViewHide", function () { return $5ba20cdaef825cef$export$54207bf7585e2223; }, function (v) { return $5ba20cdaef825cef$export$54207bf7585e2223 = v; });
var $5ba20cdaef825cef$export$1e511d4a378977f5;
var $5ba20cdaef825cef$export$54207bf7585e2223;
"use strict";
$5ba20cdaef825cef$export$1e511d4a378977f5 = true;
$5ba20cdaef825cef$export$54207bf7585e2223 = void 0;

var $5ba20cdaef825cef$var$_react = $5ba20cdaef825cef$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5ba20cdaef825cef$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5ba20cdaef825cef$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5ba20cdaef825cef$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5ba20cdaef825cef$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5ba20cdaef825cef$var$_extends() {
    return $5ba20cdaef825cef$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5ba20cdaef825cef$var$_extends.apply(null, arguments);
}
var $5ba20cdaef825cef$var$FormViewHide = $5ba20cdaef825cef$export$54207bf7585e2223 = /*#__PURE__*/ (0, $5ba20cdaef825cef$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5ba20cdaef825cef$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5ba20cdaef825cef$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormViewHide"
    }, props), /*#__PURE__*/ $5ba20cdaef825cef$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M3 12h3c.5 2.5 3.273 5 6 5s5.5-2.5 6-5h3m-9 5v3m-4.5-4.5-2 2m11-2 2 2"
    }));
});
$5ba20cdaef825cef$var$FormViewHide.displayName = 'FormViewHide';


Object.keys($5ba20cdaef825cef$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5ba20cdaef825cef$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5ba20cdaef825cef$exports[key];
});
var $ee7cfe182bdbc07b$exports = {};

$parcel$export($ee7cfe182bdbc07b$exports, "__esModule", function () { return $ee7cfe182bdbc07b$export$1e511d4a378977f5; }, function (v) { return $ee7cfe182bdbc07b$export$1e511d4a378977f5 = v; });
$parcel$export($ee7cfe182bdbc07b$exports, "FormView", function () { return $ee7cfe182bdbc07b$export$d1d60b7e9d4b2964; }, function (v) { return $ee7cfe182bdbc07b$export$d1d60b7e9d4b2964 = v; });
var $ee7cfe182bdbc07b$export$1e511d4a378977f5;
var $ee7cfe182bdbc07b$export$d1d60b7e9d4b2964;
"use strict";
$ee7cfe182bdbc07b$export$1e511d4a378977f5 = true;
$ee7cfe182bdbc07b$export$d1d60b7e9d4b2964 = void 0;

var $ee7cfe182bdbc07b$var$_react = $ee7cfe182bdbc07b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $ee7cfe182bdbc07b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ee7cfe182bdbc07b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ee7cfe182bdbc07b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ee7cfe182bdbc07b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ee7cfe182bdbc07b$var$_extends() {
    return $ee7cfe182bdbc07b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ee7cfe182bdbc07b$var$_extends.apply(null, arguments);
}
var $ee7cfe182bdbc07b$var$FormView = $ee7cfe182bdbc07b$export$d1d60b7e9d4b2964 = /*#__PURE__*/ (0, $ee7cfe182bdbc07b$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $ee7cfe182bdbc07b$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ee7cfe182bdbc07b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormView"
    }, props), /*#__PURE__*/ $ee7cfe182bdbc07b$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 17c-2.727 0-6-2.778-6-5s3.273-5 6-5 6 2.778 6 5-3.273 5-6 5zm-1-5a1 1 0 1 0 2 0 1 1 0 0 0-2 0z"
    }));
});
$ee7cfe182bdbc07b$var$FormView.displayName = 'FormView';


Object.keys($ee7cfe182bdbc07b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ee7cfe182bdbc07b$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ee7cfe182bdbc07b$exports[key];
});
var $da0b3b7f2631f88b$exports = {};

$parcel$export($da0b3b7f2631f88b$exports, "__esModule", function () { return $da0b3b7f2631f88b$export$1e511d4a378977f5; }, function (v) { return $da0b3b7f2631f88b$export$1e511d4a378977f5 = v; });
$parcel$export($da0b3b7f2631f88b$exports, "ForwardTen", function () { return $da0b3b7f2631f88b$export$a0e8a50d47f6e60; }, function (v) { return $da0b3b7f2631f88b$export$a0e8a50d47f6e60 = v; });
var $da0b3b7f2631f88b$export$1e511d4a378977f5;
var $da0b3b7f2631f88b$export$a0e8a50d47f6e60;
"use strict";
$da0b3b7f2631f88b$export$1e511d4a378977f5 = true;
$da0b3b7f2631f88b$export$a0e8a50d47f6e60 = void 0;

var $da0b3b7f2631f88b$var$_react = $da0b3b7f2631f88b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $da0b3b7f2631f88b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($da0b3b7f2631f88b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $da0b3b7f2631f88b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $da0b3b7f2631f88b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $da0b3b7f2631f88b$var$_extends() {
    return $da0b3b7f2631f88b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $da0b3b7f2631f88b$var$_extends.apply(null, arguments);
}
var $da0b3b7f2631f88b$var$ForwardTen = $da0b3b7f2631f88b$export$a0e8a50d47f6e60 = /*#__PURE__*/ (0, $da0b3b7f2631f88b$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $da0b3b7f2631f88b$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $da0b3b7f2631f88b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ForwardTen"
    }, props), /*#__PURE__*/ $da0b3b7f2631f88b$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M20.889 7.556C19.33 4.267 15.93 2 12 2 6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10m0-8v4h-4m-9 8V9l-2 .533M17 12c0-2-1-3.5-2.5-3.5S12 10 12 12s1 3.5 2.5 3.5S17 14 17 12zm-2.5-3.5C16.925 8.5 17 11 17 12s0 3.5-2.5 3.5S12 13 12 12s.059-3.5 2.5-3.5z"
    }));
});
$da0b3b7f2631f88b$var$ForwardTen.displayName = 'ForwardTen';


Object.keys($da0b3b7f2631f88b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $da0b3b7f2631f88b$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $da0b3b7f2631f88b$exports[key];
});
var $ec88adeb8909157b$exports = {};

$parcel$export($ec88adeb8909157b$exports, "__esModule", function () { return $ec88adeb8909157b$export$1e511d4a378977f5; }, function (v) { return $ec88adeb8909157b$export$1e511d4a378977f5 = v; });
$parcel$export($ec88adeb8909157b$exports, "Freebsd", function () { return $ec88adeb8909157b$export$6b8cd8f656a18c7; }, function (v) { return $ec88adeb8909157b$export$6b8cd8f656a18c7 = v; });
var $ec88adeb8909157b$export$1e511d4a378977f5;
var $ec88adeb8909157b$export$6b8cd8f656a18c7;
"use strict";
$ec88adeb8909157b$export$1e511d4a378977f5 = true;
$ec88adeb8909157b$export$6b8cd8f656a18c7 = void 0;

var $ec88adeb8909157b$var$_react = $ec88adeb8909157b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $ec88adeb8909157b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ec88adeb8909157b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ec88adeb8909157b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ec88adeb8909157b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ec88adeb8909157b$var$_extends() {
    return $ec88adeb8909157b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ec88adeb8909157b$var$_extends.apply(null, arguments);
}
var $ec88adeb8909157b$var$Freebsd = $ec88adeb8909157b$export$6b8cd8f656a18c7 = /*#__PURE__*/ (0, $ec88adeb8909157b$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $ec88adeb8909157b$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ec88adeb8909157b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Freebsd"
    }, props), /*#__PURE__*/ $ec88adeb8909157b$var$_react["default"].createElement("path", {
        fill: "#9B2718",
        fillRule: "evenodd",
        d: "M23.725.403c1.273 1.272-2.254 6.862-2.85 7.458-.597.596-2.111.048-3.383-1.224-1.272-1.272-1.82-2.787-1.224-3.383.596-.596 6.185-4.123 7.457-2.85zM5.885 1.75C3.943.647 1.179-.58.3.3c-.891.89.38 3.717 1.493 5.662A11.945 11.945 0 0 1 5.885 1.75zm15.9 5.674c.179.606.147 1.108-.143 1.397-.678.678-2.508-.044-4.158-1.614a8.227 8.227 0 0 1-.341-.323c-.596-.597-1.06-1.232-1.357-1.817-.578-1.036-.723-1.952-.286-2.388.238-.238.619-.303 1.083-.22.303-.19.66-.404 1.053-.623a11.491 11.491 0 0 0-5.33-1.301C5.928.534.757 5.704.757 12.082S5.927 23.63 12.306 23.63c6.378 0 11.548-5.17 11.548-11.548 0-2.06-.54-3.991-1.485-5.666-.204.373-.403.714-.584 1.007z"
    }));
});
$ec88adeb8909157b$var$Freebsd.displayName = 'Freebsd';


Object.keys($ec88adeb8909157b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ec88adeb8909157b$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ec88adeb8909157b$exports[key];
});
var $4b25e7c86544b678$exports = {};

$parcel$export($4b25e7c86544b678$exports, "__esModule", function () { return $4b25e7c86544b678$export$1e511d4a378977f5; }, function (v) { return $4b25e7c86544b678$export$1e511d4a378977f5 = v; });
$parcel$export($4b25e7c86544b678$exports, "Gallery", function () { return $4b25e7c86544b678$export$ace63239d21d36e; }, function (v) { return $4b25e7c86544b678$export$ace63239d21d36e = v; });
var $4b25e7c86544b678$export$1e511d4a378977f5;
var $4b25e7c86544b678$export$ace63239d21d36e;
"use strict";
$4b25e7c86544b678$export$1e511d4a378977f5 = true;
$4b25e7c86544b678$export$ace63239d21d36e = void 0;

var $4b25e7c86544b678$var$_react = $4b25e7c86544b678$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $4b25e7c86544b678$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4b25e7c86544b678$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4b25e7c86544b678$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $4b25e7c86544b678$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $4b25e7c86544b678$var$_extends() {
    return $4b25e7c86544b678$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4b25e7c86544b678$var$_extends.apply(null, arguments);
}
var $4b25e7c86544b678$var$Gallery = $4b25e7c86544b678$export$ace63239d21d36e = /*#__PURE__*/ (0, $4b25e7c86544b678$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $4b25e7c86544b678$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $4b25e7c86544b678$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Gallery"
    }, props), /*#__PURE__*/ $4b25e7c86544b678$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 1h18v18H1V1zm4 18v4h18V5.97h-4M6 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM2 18l5-6 3 3 4-5 5 6"
    }));
});
$4b25e7c86544b678$var$Gallery.displayName = 'Gallery';


Object.keys($4b25e7c86544b678$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $4b25e7c86544b678$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $4b25e7c86544b678$exports[key];
});
var $78016d70f8f3a1c7$exports = {};

$parcel$export($78016d70f8f3a1c7$exports, "__esModule", function () { return $78016d70f8f3a1c7$export$1e511d4a378977f5; }, function (v) { return $78016d70f8f3a1c7$export$1e511d4a378977f5 = v; });
$parcel$export($78016d70f8f3a1c7$exports, "Gamepad", function () { return $78016d70f8f3a1c7$export$27a9cd7ebdd38262; }, function (v) { return $78016d70f8f3a1c7$export$27a9cd7ebdd38262 = v; });
var $78016d70f8f3a1c7$export$1e511d4a378977f5;
var $78016d70f8f3a1c7$export$27a9cd7ebdd38262;
"use strict";
$78016d70f8f3a1c7$export$1e511d4a378977f5 = true;
$78016d70f8f3a1c7$export$27a9cd7ebdd38262 = void 0;

var $78016d70f8f3a1c7$var$_react = $78016d70f8f3a1c7$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $78016d70f8f3a1c7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($78016d70f8f3a1c7$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $78016d70f8f3a1c7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $78016d70f8f3a1c7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $78016d70f8f3a1c7$var$_extends() {
    return $78016d70f8f3a1c7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $78016d70f8f3a1c7$var$_extends.apply(null, arguments);
}
var $78016d70f8f3a1c7$var$Gamepad = $78016d70f8f3a1c7$export$27a9cd7ebdd38262 = /*#__PURE__*/ (0, $78016d70f8f3a1c7$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $78016d70f8f3a1c7$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $78016d70f8f3a1c7$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Gamepad"
    }, props), /*#__PURE__*/ $78016d70f8f3a1c7$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 6V2m0 4c2.498.044 4.006 0 5 0 2 0 4 .5 5 4s1 5.5 1 8-2 3-4 3-3.054-4-7-4-5 4-7 4-4-.5-4-3 0-4.5 1-8 3-4 5-4c.994 0 2.502.044 5 0zm6 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-4-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM4 12h6M7 9v6"
    }));
});
$78016d70f8f3a1c7$var$Gamepad.displayName = 'Gamepad';


Object.keys($78016d70f8f3a1c7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $78016d70f8f3a1c7$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $78016d70f8f3a1c7$exports[key];
});
var $3083df7c9688799b$exports = {};

$parcel$export($3083df7c9688799b$exports, "__esModule", function () { return $3083df7c9688799b$export$1e511d4a378977f5; }, function (v) { return $3083df7c9688799b$export$1e511d4a378977f5 = v; });
$parcel$export($3083df7c9688799b$exports, "Gateway", function () { return $3083df7c9688799b$export$a0e1fa6601cae894; }, function (v) { return $3083df7c9688799b$export$a0e1fa6601cae894 = v; });
var $3083df7c9688799b$export$1e511d4a378977f5;
var $3083df7c9688799b$export$a0e1fa6601cae894;
"use strict";
$3083df7c9688799b$export$1e511d4a378977f5 = true;
$3083df7c9688799b$export$a0e1fa6601cae894 = void 0;

var $3083df7c9688799b$var$_react = $3083df7c9688799b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $3083df7c9688799b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3083df7c9688799b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3083df7c9688799b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3083df7c9688799b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3083df7c9688799b$var$_extends() {
    return $3083df7c9688799b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3083df7c9688799b$var$_extends.apply(null, arguments);
}
var $3083df7c9688799b$var$Gateway = $3083df7c9688799b$export$a0e1fa6601cae894 = /*#__PURE__*/ (0, $3083df7c9688799b$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3083df7c9688799b$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3083df7c9688799b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Gateway"
    }, props), /*#__PURE__*/ $3083df7c9688799b$var$_react["default"].createElement("path", {
        stroke: "#000",
        strokeWidth: "2",
        fill: "none",
        d: "M12 20v-5m0-6V4m-7 8h5m9 0h-5m-.969-4.031L12 9.344l-1.031-1.375h2.062zm-2.062 8.07L12 14.664l1.031 1.375H10.97zM6 13.031 4.625 12 6 10.969v2.062zm12-2.062L19.375 12 18 13.031V10.97zM12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1z"
    }));
});
$3083df7c9688799b$var$Gateway.displayName = 'Gateway';


Object.keys($3083df7c9688799b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3083df7c9688799b$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3083df7c9688799b$exports[key];
});
var $262e6c2d5e759492$exports = {};

$parcel$export($262e6c2d5e759492$exports, "__esModule", function () { return $262e6c2d5e759492$export$1e511d4a378977f5; }, function (v) { return $262e6c2d5e759492$export$1e511d4a378977f5 = v; });
$parcel$export($262e6c2d5e759492$exports, "Gatsbyjs", function () { return $262e6c2d5e759492$export$11abae57c194b70c; }, function (v) { return $262e6c2d5e759492$export$11abae57c194b70c = v; });
var $262e6c2d5e759492$export$1e511d4a378977f5;
var $262e6c2d5e759492$export$11abae57c194b70c;
"use strict";
$262e6c2d5e759492$export$1e511d4a378977f5 = true;
$262e6c2d5e759492$export$11abae57c194b70c = void 0;

var $262e6c2d5e759492$var$_react = $262e6c2d5e759492$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $262e6c2d5e759492$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($262e6c2d5e759492$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $262e6c2d5e759492$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $262e6c2d5e759492$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $262e6c2d5e759492$var$_extends() {
    return $262e6c2d5e759492$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $262e6c2d5e759492$var$_extends.apply(null, arguments);
}
var $262e6c2d5e759492$var$Gatsbyjs = $262e6c2d5e759492$export$11abae57c194b70c = /*#__PURE__*/ (0, $262e6c2d5e759492$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $262e6c2d5e759492$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $262e6c2d5e759492$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Gatsbyjs"
    }, props), /*#__PURE__*/ $262e6c2d5e759492$var$_react["default"].createElement("path", {
        fill: "#639",
        d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm10-11.908h-6.452v1.834h4.424c-.645 2.753-2.674 5.046-5.346 5.964L4.027 9.34c1.106-3.211 4.24-5.505 7.835-5.505 2.765 0 5.254 1.377 6.82 3.487l1.383-1.193C18.22 3.651 15.272 2 11.862 2 7.069 2 3.014 5.395 2 9.89L14.165 22C18.59 20.899 22 16.862 22 12.091v.001zM2 12c0 2.593 1.018 5.092 2.963 7.037C6.908 20.982 9.5 22 12 22L2 12z"
    }));
});
$262e6c2d5e759492$var$Gatsbyjs.displayName = 'Gatsbyjs';


Object.keys($262e6c2d5e759492$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $262e6c2d5e759492$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $262e6c2d5e759492$exports[key];
});
var $1800a136a15dfb2a$exports = {};

$parcel$export($1800a136a15dfb2a$exports, "__esModule", function () { return $1800a136a15dfb2a$export$1e511d4a378977f5; }, function (v) { return $1800a136a15dfb2a$export$1e511d4a378977f5 = v; });
$parcel$export($1800a136a15dfb2a$exports, "Gem", function () { return $1800a136a15dfb2a$export$c8466cd826c8cf12; }, function (v) { return $1800a136a15dfb2a$export$c8466cd826c8cf12 = v; });
var $1800a136a15dfb2a$export$1e511d4a378977f5;
var $1800a136a15dfb2a$export$c8466cd826c8cf12;
"use strict";
$1800a136a15dfb2a$export$1e511d4a378977f5 = true;
$1800a136a15dfb2a$export$c8466cd826c8cf12 = void 0;

var $1800a136a15dfb2a$var$_react = $1800a136a15dfb2a$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $1800a136a15dfb2a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1800a136a15dfb2a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1800a136a15dfb2a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $1800a136a15dfb2a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1800a136a15dfb2a$var$_extends() {
    return $1800a136a15dfb2a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1800a136a15dfb2a$var$_extends.apply(null, arguments);
}
var $1800a136a15dfb2a$var$Gem = $1800a136a15dfb2a$export$c8466cd826c8cf12 = /*#__PURE__*/ (0, $1800a136a15dfb2a$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $1800a136a15dfb2a$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $1800a136a15dfb2a$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Gem"
    }, props), /*#__PURE__*/ $1800a136a15dfb2a$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 1h-.414l-.293.293-3 3L3 4.586v14.828l.293.293 3 3 .293.293h10.828l.293-.293 3-3 .293-.293V4.586l-.293-.293-3-3L17.414 1H7zM5 6v12h1V6H5zm3 15h8v-1H8v1zm11-3V6h-1v12h1zM16 3H8v1h8V3zm0 3v12H8V6h8z",
        fill: "#000"
    }));
});
$1800a136a15dfb2a$var$Gem.displayName = 'Gem';


Object.keys($1800a136a15dfb2a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $1800a136a15dfb2a$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $1800a136a15dfb2a$exports[key];
});
var $0dca5f6afb6dcd7f$exports = {};

$parcel$export($0dca5f6afb6dcd7f$exports, "__esModule", function () { return $0dca5f6afb6dcd7f$export$1e511d4a378977f5; }, function (v) { return $0dca5f6afb6dcd7f$export$1e511d4a378977f5 = v; });
$parcel$export($0dca5f6afb6dcd7f$exports, "GenAI", function () { return $0dca5f6afb6dcd7f$export$1d5e32dd76265767; }, function (v) { return $0dca5f6afb6dcd7f$export$1d5e32dd76265767 = v; });
var $0dca5f6afb6dcd7f$export$1e511d4a378977f5;
var $0dca5f6afb6dcd7f$export$1d5e32dd76265767;
"use strict";
$0dca5f6afb6dcd7f$export$1e511d4a378977f5 = true;
$0dca5f6afb6dcd7f$export$1d5e32dd76265767 = void 0;

var $0dca5f6afb6dcd7f$var$_react = $0dca5f6afb6dcd7f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0dca5f6afb6dcd7f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0dca5f6afb6dcd7f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0dca5f6afb6dcd7f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0dca5f6afb6dcd7f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0dca5f6afb6dcd7f$var$_extends() {
    return $0dca5f6afb6dcd7f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0dca5f6afb6dcd7f$var$_extends.apply(null, arguments);
}
var $0dca5f6afb6dcd7f$var$GenAI = $0dca5f6afb6dcd7f$export$1d5e32dd76265767 = /*#__PURE__*/ (0, $0dca5f6afb6dcd7f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0dca5f6afb6dcd7f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0dca5f6afb6dcd7f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "GenAI"
    }, props), /*#__PURE__*/ $0dca5f6afb6dcd7f$var$_react["default"].createElement("path", {
        xmlns: "http://www.w3.org/2000/svg",
        d: "M9.42594 5.10286C9.64755 4.20679 10.9221 4.20679 11.1437 5.10286C12.0893 8.92626 15.0743 11.9113 18.8976 12.8568C19.7937 13.0785 19.7937 14.353 18.8976 14.5746L18.5412 14.6684C14.8893 15.7068 12.0597 18.6248 11.1437 22.3286L11.09 22.4859C10.7882 23.172 9.7814 23.172 9.47966 22.4859L9.42594 22.3286C8.50996 18.6248 5.6804 15.7068 2.02848 14.6684L1.67204 14.5746C0.776056 14.353 0.776082 13.0785 1.67204 12.8568C5.49539 11.9113 8.48037 8.92625 9.42594 5.10286ZM10.2843 8.42907C9.09758 10.6837 7.25288 12.5285 4.99821 13.7153C7.25282 14.9019 9.09751 16.747 10.2843 19.0014C11.471 16.747 13.3161 14.902 15.5705 13.7153C13.316 12.5284 11.4709 10.6837 10.2843 8.42907ZM18.0988 1.32352C18.1942 0.891549 18.81 0.891549 18.9054 1.32352C19.3217 3.207 20.7925 4.67786 22.6759 5.09407C23.1079 5.18951 23.1079 5.80528 22.6759 5.90072L22.4865 5.94955C20.6945 6.42005 19.3075 7.85246 18.9054 9.67224L18.881 9.74842C18.7439 10.0786 18.2593 10.0786 18.1222 9.74842L18.0988 9.67224C17.7087 7.90645 16.391 6.50311 14.6759 5.99154L14.3273 5.90072C13.8954 5.8052 13.8954 5.18951 14.3273 5.09407C16.2109 4.67788 17.6826 3.20712 18.0988 1.32352ZM18.5011 4.82551C18.2927 5.06451 18.0683 5.28898 17.8293 5.4974C18.0683 5.70579 18.2927 5.93031 18.5011 6.16928C18.7095 5.93031 18.9341 5.70579 19.173 5.4974C18.9341 5.28897 18.7095 5.06451 18.5011 4.82551Z",
        fill: "#000"
    }));
});
$0dca5f6afb6dcd7f$var$GenAI.displayName = 'GenAI';


Object.keys($0dca5f6afb6dcd7f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0dca5f6afb6dcd7f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0dca5f6afb6dcd7f$exports[key];
});
var $b073789d655a4f3f$exports = {};

$parcel$export($b073789d655a4f3f$exports, "__esModule", function () { return $b073789d655a4f3f$export$1e511d4a378977f5; }, function (v) { return $b073789d655a4f3f$export$1e511d4a378977f5 = v; });
$parcel$export($b073789d655a4f3f$exports, "GenAIFill", function () { return $b073789d655a4f3f$export$ed57a34d7047cd79; }, function (v) { return $b073789d655a4f3f$export$ed57a34d7047cd79 = v; });
var $b073789d655a4f3f$export$1e511d4a378977f5;
var $b073789d655a4f3f$export$ed57a34d7047cd79;
"use strict";
$b073789d655a4f3f$export$1e511d4a378977f5 = true;
$b073789d655a4f3f$export$ed57a34d7047cd79 = void 0;

var $b073789d655a4f3f$var$_react = $b073789d655a4f3f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $b073789d655a4f3f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b073789d655a4f3f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b073789d655a4f3f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $b073789d655a4f3f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b073789d655a4f3f$var$_extends() {
    return $b073789d655a4f3f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b073789d655a4f3f$var$_extends.apply(null, arguments);
}
var $b073789d655a4f3f$var$GenAIFill = $b073789d655a4f3f$export$ed57a34d7047cd79 = /*#__PURE__*/ (0, $b073789d655a4f3f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $b073789d655a4f3f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $b073789d655a4f3f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "GenAIFill"
    }, props), /*#__PURE__*/ $b073789d655a4f3f$var$_react["default"].createElement("path", {
        d: "M18.8974 12.8573C19.7935 13.0789 19.7935 14.3527 18.8974 14.5743C15.0741 15.5198 12.0888 18.5051 11.1433 22.3284C10.9217 23.2245 9.64788 23.2245 9.42628 22.3284C8.48072 18.5051 5.49548 15.5198 1.67211 14.5743C0.776046 14.3527 0.776046 13.0789 1.67211 12.8573C5.49548 11.9117 8.48073 8.92648 9.42628 5.1031C9.64788 4.20704 10.9217 4.20704 11.1433 5.1031C12.0888 8.92647 15.0741 11.9117 18.8974 12.8573Z",
        fill: "#000"
    }), /*#__PURE__*/ $b073789d655a4f3f$var$_react["default"].createElement("path", {
        d: "M22.6759 5.0945C23.1079 5.18994 23.1079 5.8058 22.6759 5.90125C20.7923 6.31744 19.3212 7.78858 18.905 9.67223C18.8095 10.1042 18.1937 10.1042 18.0982 9.67223C17.682 7.78858 16.2109 6.31743 14.3272 5.90125C13.8953 5.8058 13.8953 5.18994 14.3272 5.0945C16.2109 4.67831 17.682 3.20717 18.0982 1.32352C18.1937 0.89155 18.8095 0.89155 18.905 1.32352C19.3212 3.20717 20.7923 4.67831 22.6759 5.0945Z",
        fill: "#000"
    }));
});
$b073789d655a4f3f$var$GenAIFill.displayName = 'GenAIFill';


Object.keys($b073789d655a4f3f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $b073789d655a4f3f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $b073789d655a4f3f$exports[key];
});
var $8c004212b4238bfc$exports = {};

$parcel$export($8c004212b4238bfc$exports, "__esModule", function () { return $8c004212b4238bfc$export$1e511d4a378977f5; }, function (v) { return $8c004212b4238bfc$export$1e511d4a378977f5 = v; });
$parcel$export($8c004212b4238bfc$exports, "Gift", function () { return $8c004212b4238bfc$export$af880670b5567579; }, function (v) { return $8c004212b4238bfc$export$af880670b5567579 = v; });
var $8c004212b4238bfc$export$1e511d4a378977f5;
var $8c004212b4238bfc$export$af880670b5567579;
"use strict";
$8c004212b4238bfc$export$1e511d4a378977f5 = true;
$8c004212b4238bfc$export$af880670b5567579 = void 0;

var $8c004212b4238bfc$var$_react = $8c004212b4238bfc$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $8c004212b4238bfc$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8c004212b4238bfc$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8c004212b4238bfc$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $8c004212b4238bfc$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8c004212b4238bfc$var$_extends() {
    return $8c004212b4238bfc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8c004212b4238bfc$var$_extends.apply(null, arguments);
}
var $8c004212b4238bfc$var$Gift = $8c004212b4238bfc$export$af880670b5567579 = /*#__PURE__*/ (0, $8c004212b4238bfc$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $8c004212b4238bfc$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $8c004212b4238bfc$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Gift"
    }, props), /*#__PURE__*/ $8c004212b4238bfc$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M3 11h18v12H3V11zm-1 0V7h20v4H2zm10 12V7v16zM7 7h5s-2-5-5-5C3.5 2 3 7 7 7zm10.184 0h-5s1.816-5 5-5c3.316 0 4 5 0 5z"
    }));
});
$8c004212b4238bfc$var$Gift.displayName = 'Gift';


Object.keys($8c004212b4238bfc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $8c004212b4238bfc$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $8c004212b4238bfc$exports[key];
});
var $e9bd550c4796681f$exports = {};

$parcel$export($e9bd550c4796681f$exports, "__esModule", function () { return $e9bd550c4796681f$export$1e511d4a378977f5; }, function (v) { return $e9bd550c4796681f$export$1e511d4a378977f5 = v; });
$parcel$export($e9bd550c4796681f$exports, "Github", function () { return $e9bd550c4796681f$export$61d478c2aba5d9a5; }, function (v) { return $e9bd550c4796681f$export$61d478c2aba5d9a5 = v; });
var $e9bd550c4796681f$export$1e511d4a378977f5;
var $e9bd550c4796681f$export$61d478c2aba5d9a5;
"use strict";
$e9bd550c4796681f$export$1e511d4a378977f5 = true;
$e9bd550c4796681f$export$61d478c2aba5d9a5 = void 0;

var $e9bd550c4796681f$var$_react = $e9bd550c4796681f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e9bd550c4796681f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e9bd550c4796681f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e9bd550c4796681f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e9bd550c4796681f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e9bd550c4796681f$var$_extends() {
    return $e9bd550c4796681f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e9bd550c4796681f$var$_extends.apply(null, arguments);
}
var $e9bd550c4796681f$var$Github = $e9bd550c4796681f$export$61d478c2aba5d9a5 = /*#__PURE__*/ (0, $e9bd550c4796681f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e9bd550c4796681f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e9bd550c4796681f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Github"
    }, props), /*#__PURE__*/ $e9bd550c4796681f$var$_react["default"].createElement("path", {
        fill: "#333",
        fillRule: "evenodd",
        d: "M11.999 1C5.926 1 1 5.925 1 12c0 4.86 3.152 8.983 7.523 10.437.55.102.75-.238.75-.53 0-.26-.009-.952-.014-1.87-3.06.664-3.706-1.475-3.706-1.475-.5-1.27-1.221-1.61-1.221-1.61-.999-.681.075-.668.075-.668 1.105.078 1.685 1.134 1.685 1.134.981 1.68 2.575 1.195 3.202.914.1-.71.384-1.195.698-1.47-2.442-.278-5.01-1.222-5.01-5.437 0-1.2.428-2.183 1.132-2.952-.114-.278-.491-1.397.108-2.91 0 0 .923-.297 3.025 1.127A10.536 10.536 0 0 1 12 6.32a10.49 10.49 0 0 1 2.754.37c2.1-1.424 3.022-1.128 3.022-1.128.6 1.514.223 2.633.11 2.911.705.769 1.13 1.751 1.13 2.952 0 4.226-2.572 5.156-5.022 5.428.395.34.747 1.01.747 2.037 0 1.47-.014 2.657-.014 3.017 0 .295.199.637.756.53C19.851 20.979 23 16.859 23 12c0-6.075-4.926-11-11.001-11"
    }));
});
$e9bd550c4796681f$var$Github.displayName = 'Github';


Object.keys($e9bd550c4796681f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e9bd550c4796681f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e9bd550c4796681f$exports[key];
});
var $60ea590479d4f0f5$exports = {};

$parcel$export($60ea590479d4f0f5$exports, "__esModule", function () { return $60ea590479d4f0f5$export$1e511d4a378977f5; }, function (v) { return $60ea590479d4f0f5$export$1e511d4a378977f5 = v; });
$parcel$export($60ea590479d4f0f5$exports, "Globe", function () { return $60ea590479d4f0f5$export$3bc50e457b7f164b; }, function (v) { return $60ea590479d4f0f5$export$3bc50e457b7f164b = v; });
var $60ea590479d4f0f5$export$1e511d4a378977f5;
var $60ea590479d4f0f5$export$3bc50e457b7f164b;
"use strict";
$60ea590479d4f0f5$export$1e511d4a378977f5 = true;
$60ea590479d4f0f5$export$3bc50e457b7f164b = void 0;

var $60ea590479d4f0f5$var$_react = $60ea590479d4f0f5$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $60ea590479d4f0f5$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($60ea590479d4f0f5$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $60ea590479d4f0f5$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $60ea590479d4f0f5$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $60ea590479d4f0f5$var$_extends() {
    return $60ea590479d4f0f5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $60ea590479d4f0f5$var$_extends.apply(null, arguments);
}
var $60ea590479d4f0f5$var$Globe = $60ea590479d4f0f5$export$3bc50e457b7f164b = /*#__PURE__*/ (0, $60ea590479d4f0f5$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $60ea590479d4f0f5$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $60ea590479d4f0f5$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Globe"
    }, props), /*#__PURE__*/ $60ea590479d4f0f5$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 8s3.5 1 5 2 .564 2.42 1 3c.436.58 2-1 2 2s3 1 3 4 2.5 2.5 3 1 2.233-3.134 2-5c-.233-1.866-1-3-3-3s-3.5-.5-4-2 3-2 2-5 0-4 0-4m10 11c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11z"
    }));
});
$60ea590479d4f0f5$var$Globe.displayName = 'Globe';


Object.keys($60ea590479d4f0f5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $60ea590479d4f0f5$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $60ea590479d4f0f5$exports[key];
});
var $f450143326f7cde9$exports = {};

$parcel$export($f450143326f7cde9$exports, "__esModule", function () { return $f450143326f7cde9$export$1e511d4a378977f5; }, function (v) { return $f450143326f7cde9$export$1e511d4a378977f5 = v; });
$parcel$export($f450143326f7cde9$exports, "Golang", function () { return $f450143326f7cde9$export$ac1c5aac1f5b6d57; }, function (v) { return $f450143326f7cde9$export$ac1c5aac1f5b6d57 = v; });
var $f450143326f7cde9$export$1e511d4a378977f5;
var $f450143326f7cde9$export$ac1c5aac1f5b6d57;
"use strict";
$f450143326f7cde9$export$1e511d4a378977f5 = true;
$f450143326f7cde9$export$ac1c5aac1f5b6d57 = void 0;

var $f450143326f7cde9$var$_react = $f450143326f7cde9$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f450143326f7cde9$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f450143326f7cde9$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f450143326f7cde9$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f450143326f7cde9$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f450143326f7cde9$var$_extends() {
    return $f450143326f7cde9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f450143326f7cde9$var$_extends.apply(null, arguments);
}
var $f450143326f7cde9$var$Golang = $f450143326f7cde9$export$ac1c5aac1f5b6d57 = /*#__PURE__*/ (0, $f450143326f7cde9$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f450143326f7cde9$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f450143326f7cde9$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Golang"
    }, props), /*#__PURE__*/ $f450143326f7cde9$var$_react["default"].createElement("g", {
        fill: "none"
    }, /*#__PURE__*/ $f450143326f7cde9$var$_react["default"].createElement("path", {
        fill: "#8CC5E7",
        d: "M21.468 3.206c.713 1.474-1.455 1.631-1.344 2.289.204 1.186.065 2.947-.092 4.68-.27 2.937 1.927 9.97-2.65 12.796-.862.538-2.91.834-4.93.88h-.019c-2.02-.046-4.346-.342-5.208-.88-4.568-2.826-2.372-9.859-2.631-12.796-.167-1.733-.306-3.494-.093-4.68.111-.658-2.057-.806-1.343-2.289.611-1.27 2.122-.148 2.501-.547C7.596.65 9.95.111 11.803.065h1.02c1.843.093 4.197.593 6.143 2.594.38.399 1.881-.722 2.502.547zm-10.036 7.7c-.083.038-.222.946.204.992.288.028 1.075.12 1.26 0 .362-.232.325-.788.121-.927-.343-.222-1.492-.11-1.585-.064zm-2.352-6.8c-.955-.111-2.558.778-2.799 2.669-.26 1.964 2.057 3.91 4.281 1.964 1.196-1.047 1.613-4.272-1.482-4.633zm6.45 0c-3.096.361-2.679 3.586-1.483 4.633 2.223 1.946 4.54 0 4.28-1.964-.231-1.89-1.834-2.78-2.798-2.669z"
    }), /*#__PURE__*/ $f450143326f7cde9$var$_react["default"].createElement("path", {
        fill: "#B8937F",
        d: "M12.313 8.988c.584-.083 1.983.584 1.89 1.372-.111.917-3.605 1.038-3.79-.056-.111-.667.417-1.093 1.9-1.316zm7.885 7.386c-.287-.01-.472-.39-.472-.621 0-.417.055-.908.361-1.121.63-.436 1.13 1.751.111 1.742zm-15.78 0c-1.02.009-.52-2.178.111-1.742.306.213.361.704.361 1.12 0 .233-.185.612-.472.622zm13.844 6.718c.185.269.194.454-.102.593-1.13.519-2.14-.176-1.76-.37.805-.408 1.306-1.048 1.862-.223zm-11.908.093c.556-.825 1.057-.186 1.863.222.38.195-.63.89-1.76.37-.297-.138-.288-.324-.103-.592z"
    }), /*#__PURE__*/ $f450143326f7cde9$var$_react["default"].createElement("path", {
        fill: "#000",
        d: "M19.735 3.429c.046-.195.528-.288.797.046.324.398-.473.945-.51.723-.092-.603-.342-.575-.287-.77zm-14.854 0c.056.194-.195.166-.287.769-.037.222-.834-.325-.51-.723.26-.334.741-.241.797-.046zm10.86 4.512a1.056 1.056 0 1 1 0-2.112 1.056 1.056 0 0 1 0 2.112zm-.278-1.177a.334.334 0 1 0 0-.667.334.334 0 0 0 0 .667zm-4.105 2.67c.111-.427.5-.566.816-.575.806-.019 1.112.417 1.14.76.055.583-2.206.722-1.956-.186zM8.875 7.94a1.056 1.056 0 1 1 0-2.112 1.056 1.056 0 0 1 0 2.112zm.278-1.177a.334.334 0 1 0 0-.667.334.334 0 0 0 0 .667z"
    })));
});
$f450143326f7cde9$var$Golang.displayName = 'Golang';


Object.keys($f450143326f7cde9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f450143326f7cde9$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f450143326f7cde9$exports[key];
});
var $a05c334ca5f1b4b3$exports = {};

$parcel$export($a05c334ca5f1b4b3$exports, "__esModule", function () { return $a05c334ca5f1b4b3$export$1e511d4a378977f5; }, function (v) { return $a05c334ca5f1b4b3$export$1e511d4a378977f5 = v; });
$parcel$export($a05c334ca5f1b4b3$exports, "GooglePay", function () { return $a05c334ca5f1b4b3$export$c9d6e23903ec4d1c; }, function (v) { return $a05c334ca5f1b4b3$export$c9d6e23903ec4d1c = v; });
var $a05c334ca5f1b4b3$export$1e511d4a378977f5;
var $a05c334ca5f1b4b3$export$c9d6e23903ec4d1c;
"use strict";
$a05c334ca5f1b4b3$export$1e511d4a378977f5 = true;
$a05c334ca5f1b4b3$export$c9d6e23903ec4d1c = void 0;

var $a05c334ca5f1b4b3$var$_react = $a05c334ca5f1b4b3$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $a05c334ca5f1b4b3$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a05c334ca5f1b4b3$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a05c334ca5f1b4b3$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a05c334ca5f1b4b3$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a05c334ca5f1b4b3$var$_extends() {
    return $a05c334ca5f1b4b3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a05c334ca5f1b4b3$var$_extends.apply(null, arguments);
}
var $a05c334ca5f1b4b3$var$GooglePay = $a05c334ca5f1b4b3$export$c9d6e23903ec4d1c = /*#__PURE__*/ (0, $a05c334ca5f1b4b3$var$_react.forwardRef)(function(props, ref) {
    var prefix = (0, $1b754218be0a6592$export$3794798abb123ff6)('GooglePay');
    return /*#__PURE__*/ $a05c334ca5f1b4b3$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a05c334ca5f1b4b3$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "GooglePay"
    }, props), /*#__PURE__*/ $a05c334ca5f1b4b3$var$_react["default"].createElement("g", {
        clipPath: "url(#" + prefix + "-a)"
    }, /*#__PURE__*/ $a05c334ca5f1b4b3$var$_react["default"].createElement("path", {
        fill: "#EB4434",
        d: "m12.645 14.34 5.937-10.285 3.234 1.867a4.366 4.366 0 0 1 1.598 5.964l-3.344 5.791a2.732 2.732 0 0 1-3.728 1l-3.002-1.732a1.909 1.909 0 0 1-.695-2.606Z"
    }), /*#__PURE__*/ $a05c334ca5f1b4b3$var$_react["default"].createElement("path", {
        fill: "#FDBD00",
        d: "M12.012 7.2 4.625 19.991l3.235 1.867a4.367 4.367 0 0 0 5.964-1.598l4.791-8.298a2.729 2.729 0 0 0-1-3.729l-3.002-1.732a1.903 1.903 0 0 0-2.601.697Z"
    }), /*#__PURE__*/ $a05c334ca5f1b4b3$var$_react["default"].createElement("path", {
        fill: "#2DA94F",
        d: "m18.582 4.053-2.29-1.32A5.456 5.456 0 0 0 8.839 4.73l-4.246 7.352a2.729 2.729 0 0 0 1 3.728l2.289 1.32a2.729 2.729 0 0 0 3.728-1l5.069-8.779a3.81 3.81 0 0 1 5.206-1.394l-3.302-1.904Z"
    }), /*#__PURE__*/ $a05c334ca5f1b4b3$var$_react["default"].createElement("path", {
        fill: "#2B7AF0",
        d: "M9.496 6.885 6.971 5.43a2.357 2.357 0 0 0-3.215.86L.725 11.524a5.383 5.383 0 0 0 1.977 7.363l1.923 1.108 2.332 1.343 1.012.582a4.138 4.138 0 0 1-1.27-5.51l.786-1.355 2.872-4.964a2.343 2.343 0 0 0-.86-3.207Z"
    })), /*#__PURE__*/ $a05c334ca5f1b4b3$var$_react["default"].createElement("defs", null, /*#__PURE__*/ $a05c334ca5f1b4b3$var$_react["default"].createElement("clipPath", {
        id: prefix + "-a"
    }, /*#__PURE__*/ $a05c334ca5f1b4b3$var$_react["default"].createElement("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
    }))));
});
$a05c334ca5f1b4b3$var$GooglePay.displayName = 'GooglePay';


Object.keys($a05c334ca5f1b4b3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a05c334ca5f1b4b3$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a05c334ca5f1b4b3$exports[key];
});
var $fd4b8a459f8a0ea7$exports = {};

$parcel$export($fd4b8a459f8a0ea7$exports, "__esModule", function () { return $fd4b8a459f8a0ea7$export$1e511d4a378977f5; }, function (v) { return $fd4b8a459f8a0ea7$export$1e511d4a378977f5 = v; });
$parcel$export($fd4b8a459f8a0ea7$exports, "GooglePlay", function () { return $fd4b8a459f8a0ea7$export$eda9b10e4d916e45; }, function (v) { return $fd4b8a459f8a0ea7$export$eda9b10e4d916e45 = v; });
var $fd4b8a459f8a0ea7$export$1e511d4a378977f5;
var $fd4b8a459f8a0ea7$export$eda9b10e4d916e45;
"use strict";
$fd4b8a459f8a0ea7$export$1e511d4a378977f5 = true;
$fd4b8a459f8a0ea7$export$eda9b10e4d916e45 = void 0;

var $fd4b8a459f8a0ea7$var$_react = $fd4b8a459f8a0ea7$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $fd4b8a459f8a0ea7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($fd4b8a459f8a0ea7$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $fd4b8a459f8a0ea7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $fd4b8a459f8a0ea7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $fd4b8a459f8a0ea7$var$_extends() {
    return $fd4b8a459f8a0ea7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fd4b8a459f8a0ea7$var$_extends.apply(null, arguments);
}
var $fd4b8a459f8a0ea7$var$GooglePlay = $fd4b8a459f8a0ea7$export$eda9b10e4d916e45 = /*#__PURE__*/ (0, $fd4b8a459f8a0ea7$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $fd4b8a459f8a0ea7$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $fd4b8a459f8a0ea7$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "GooglePlay"
    }, props), /*#__PURE__*/ $fd4b8a459f8a0ea7$var$_react["default"].createElement("path", {
        fill: "#EA4335",
        d: "M11.128 12.003 1.09 22.011a2.73 2.73 0 0 0 3.999 1.62l11.29-6.377-5.251-5.25Z"
    }), /*#__PURE__*/ $fd4b8a459f8a0ea7$var$_react["default"].createElement("path", {
        fill: "#FBBC04",
        d: "m21.338 9.67-4.899-2.806-5.311 5.14 5.251 5.25 4.944-2.865a2.663 2.663 0 0 0 0-4.719h.015Z"
    }), /*#__PURE__*/ $fd4b8a459f8a0ea7$var$_react["default"].createElement("path", {
        fill: "#4285F4",
        d: "M1.09 1.995c-.06.225-.091.457-.09.69V21.32c0 .233.03.465.09.69l10.038-10.007L1.09 1.995Z"
    }), /*#__PURE__*/ $fd4b8a459f8a0ea7$var$_react["default"].createElement("path", {
        fill: "#34A853",
        d: "m11.128 12.003 5.311-5.139L5.126.383A2.79 2.79 0 0 0 3.723 0 2.73 2.73 0 0 0 1.09 1.988l10.038 10.015Z"
    }));
});
$fd4b8a459f8a0ea7$var$GooglePlay.displayName = 'GooglePlay';


Object.keys($fd4b8a459f8a0ea7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $fd4b8a459f8a0ea7$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $fd4b8a459f8a0ea7$exports[key];
});
var $e2a688180be88e78$exports = {};

$parcel$export($e2a688180be88e78$exports, "__esModule", function () { return $e2a688180be88e78$export$1e511d4a378977f5; }, function (v) { return $e2a688180be88e78$export$1e511d4a378977f5 = v; });
$parcel$export($e2a688180be88e78$exports, "GooglePlus", function () { return $e2a688180be88e78$export$a09032be5c1494cd; }, function (v) { return $e2a688180be88e78$export$a09032be5c1494cd = v; });
var $e2a688180be88e78$export$1e511d4a378977f5;
var $e2a688180be88e78$export$a09032be5c1494cd;
"use strict";
$e2a688180be88e78$export$1e511d4a378977f5 = true;
$e2a688180be88e78$export$a09032be5c1494cd = void 0;

var $e2a688180be88e78$var$_react = $e2a688180be88e78$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e2a688180be88e78$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e2a688180be88e78$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e2a688180be88e78$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e2a688180be88e78$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e2a688180be88e78$var$_extends() {
    return $e2a688180be88e78$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e2a688180be88e78$var$_extends.apply(null, arguments);
}
var $e2a688180be88e78$var$GooglePlus = $e2a688180be88e78$export$a09032be5c1494cd = /*#__PURE__*/ (0, $e2a688180be88e78$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e2a688180be88e78$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e2a688180be88e78$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "GooglePlus"
    }, props), /*#__PURE__*/ $e2a688180be88e78$var$_react["default"].createElement("path", {
        fill: "#4285F4",
        fillRule: "evenodd",
        d: "M.02 11.203c.066-3.906 3.676-7.327 7.603-7.197 1.882-.087 3.65.728 5.091 1.872a27.061 27.061 0 0 1-1.932 1.991C9.05 6.68 6.586 6.338 4.853 7.713c-2.478 1.705-2.59 5.731-.207 7.567 2.318 2.092 6.7 1.053 7.34-2.15-1.451-.022-2.907 0-4.36-.048-.003-.861-.007-1.723-.003-2.585a707.94 707.94 0 0 1 7.286.008c.145 2.027-.124 4.185-1.376 5.86-1.896 2.655-5.702 3.43-8.672 2.292-2.98-1.13-5.092-4.26-4.84-7.454m19.623-2.882h2.165c.004.721.007 1.445.015 2.165.724.008 1.452.008 2.176.015v2.154c-.724.007-1.448.011-2.176.018-.008.724-.011 1.445-.015 2.165H19.64c-.007-.72-.007-1.44-.014-2.161l-2.177-.022v-2.154c.725-.007 1.449-.01 2.177-.015.003-.724.01-1.444.018-2.165"
    }));
});
$e2a688180be88e78$var$GooglePlus.displayName = 'GooglePlus';


Object.keys($e2a688180be88e78$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e2a688180be88e78$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e2a688180be88e78$exports[key];
});
var $5c10a057f4a18b4e$exports = {};

$parcel$export($5c10a057f4a18b4e$exports, "__esModule", function () { return $5c10a057f4a18b4e$export$1e511d4a378977f5; }, function (v) { return $5c10a057f4a18b4e$export$1e511d4a378977f5 = v; });
$parcel$export($5c10a057f4a18b4e$exports, "GoogleWallet", function () { return $5c10a057f4a18b4e$export$fe24cf6f9908ed17; }, function (v) { return $5c10a057f4a18b4e$export$fe24cf6f9908ed17 = v; });
var $5c10a057f4a18b4e$export$1e511d4a378977f5;
var $5c10a057f4a18b4e$export$fe24cf6f9908ed17;
"use strict";
$5c10a057f4a18b4e$export$1e511d4a378977f5 = true;
$5c10a057f4a18b4e$export$fe24cf6f9908ed17 = void 0;

var $5c10a057f4a18b4e$var$_react = $5c10a057f4a18b4e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5c10a057f4a18b4e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5c10a057f4a18b4e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5c10a057f4a18b4e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5c10a057f4a18b4e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5c10a057f4a18b4e$var$_extends() {
    return $5c10a057f4a18b4e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5c10a057f4a18b4e$var$_extends.apply(null, arguments);
}
var $5c10a057f4a18b4e$var$GoogleWallet = $5c10a057f4a18b4e$export$fe24cf6f9908ed17 = /*#__PURE__*/ (0, $5c10a057f4a18b4e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5c10a057f4a18b4e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5c10a057f4a18b4e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "GoogleWallet"
    }, props), /*#__PURE__*/ $5c10a057f4a18b4e$var$_react["default"].createElement("path", {
        fill: "#4285F4",
        fillRule: "evenodd",
        d: "M12.3 20.206a2.365 2.365 0 0 1-2.722 1.046 2.386 2.386 0 0 1-1.687-2.377c-.34-3.8-2.458-7.06-5.693-8.798a2.258 2.258 0 0 1-.93-3.058c.4-.748 1.162-1.2 2-1.2.375 0 .749.09 1.071.271 2.145 1.143 4.035 2.785 5.4 4.658-.185-1.543-.673-3.047-1.49-4.36a2.393 2.393 0 0 1-.193-2.04 2.339 2.339 0 0 1 1.393-1.432 2.05 2.05 0 0 1 .852-.155c.464 0 .916.142 1.29.387.035.022.068.043.101.066-.036-.04-.1-.079-.1-.079 2.782 1.701 5.153 4.045 6.791 6.66a19.654 19.654 0 0 0-1.773-6.22 2.497 2.497 0 0 1 1.188-3.33A2.37 2.37 0 0 1 18.868 0a2.53 2.53 0 0 1 2.259 1.432 24.472 24.472 0 0 1 1.767 5.084c.4 1.78.62 3.652.633 5.51 0 1.884-.22 3.716-.62 5.51-.103.477-.22.929-.361 1.406-.439 1.587-.942 2.813-1.445 3.755A2.504 2.504 0 0 1 18.907 24c-.374 0-.735-.09-1.07-.245-.75-.349-1.2-.994-1.368-1.703a2.49 2.49 0 0 1-.065-.581c0-.542-.026-.903-.026-.903 0-2.695-.644-5.261-1.83-7.518a15.707 15.707 0 0 1-2.247 7.156z"
    }));
});
$5c10a057f4a18b4e$var$GoogleWallet.displayName = 'GoogleWallet';


Object.keys($5c10a057f4a18b4e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5c10a057f4a18b4e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5c10a057f4a18b4e$exports[key];
});
var $37339f480e47bb59$exports = {};

$parcel$export($37339f480e47bb59$exports, "__esModule", function () { return $37339f480e47bb59$export$1e511d4a378977f5; }, function (v) { return $37339f480e47bb59$export$1e511d4a378977f5 = v; });
$parcel$export($37339f480e47bb59$exports, "Google", function () { return $37339f480e47bb59$export$347eee6e8bf67997; }, function (v) { return $37339f480e47bb59$export$347eee6e8bf67997 = v; });
var $37339f480e47bb59$export$1e511d4a378977f5;
var $37339f480e47bb59$export$347eee6e8bf67997;
"use strict";
$37339f480e47bb59$export$1e511d4a378977f5 = true;
$37339f480e47bb59$export$347eee6e8bf67997 = void 0;

var $37339f480e47bb59$var$_react = $37339f480e47bb59$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $37339f480e47bb59$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($37339f480e47bb59$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $37339f480e47bb59$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $37339f480e47bb59$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $37339f480e47bb59$var$_extends() {
    return $37339f480e47bb59$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $37339f480e47bb59$var$_extends.apply(null, arguments);
}
var $37339f480e47bb59$var$Google = $37339f480e47bb59$export$347eee6e8bf67997 = /*#__PURE__*/ (0, $37339f480e47bb59$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $37339f480e47bb59$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $37339f480e47bb59$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Google"
    }, props), /*#__PURE__*/ $37339f480e47bb59$var$_react["default"].createElement("path", {
        fill: "#EA4335",
        d: "M5.266 9.765A7.077 7.077 0 0 1 12 4.909c1.69 0 3.218.6 4.418 1.582L19.91 3C17.782 1.145 15.055 0 12 0 7.27 0 3.198 2.698 1.24 6.65l4.026 3.115z"
    }), /*#__PURE__*/ $37339f480e47bb59$var$_react["default"].createElement("path", {
        fill: "#34A853",
        d: "M16.04 18.013c-1.09.703-2.474 1.078-4.04 1.078a7.077 7.077 0 0 1-6.723-4.823l-4.04 3.067A11.965 11.965 0 0 0 12 24c2.933 0 5.735-1.043 7.834-3l-3.793-2.987z"
    }), /*#__PURE__*/ $37339f480e47bb59$var$_react["default"].createElement("path", {
        fill: "#4A90E2",
        d: "M19.834 21c2.195-2.048 3.62-5.096 3.62-9 0-.71-.109-1.473-.272-2.182H12v4.637h6.436c-.317 1.559-1.17 2.766-2.395 3.558L19.834 21z"
    }), /*#__PURE__*/ $37339f480e47bb59$var$_react["default"].createElement("path", {
        fill: "#FBBC05",
        d: "M5.277 14.268A7.12 7.12 0 0 1 4.909 12c0-.782.125-1.533.357-2.235L1.24 6.65A11.934 11.934 0 0 0 0 12c0 1.92.445 3.73 1.237 5.335l4.04-3.067z"
    }));
});
$37339f480e47bb59$var$Google.displayName = 'Google';


Object.keys($37339f480e47bb59$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $37339f480e47bb59$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $37339f480e47bb59$exports[key];
});
var $d9e120fd82a01fc7$exports = {};

$parcel$export($d9e120fd82a01fc7$exports, "__esModule", function () { return $d9e120fd82a01fc7$export$1e511d4a378977f5; }, function (v) { return $d9e120fd82a01fc7$export$1e511d4a378977f5 = v; });
$parcel$export($d9e120fd82a01fc7$exports, "GraphQl", function () { return $d9e120fd82a01fc7$export$6ed368a40f73768e; }, function (v) { return $d9e120fd82a01fc7$export$6ed368a40f73768e = v; });
var $d9e120fd82a01fc7$export$1e511d4a378977f5;
var $d9e120fd82a01fc7$export$6ed368a40f73768e;
"use strict";
$d9e120fd82a01fc7$export$1e511d4a378977f5 = true;
$d9e120fd82a01fc7$export$6ed368a40f73768e = void 0;

var $d9e120fd82a01fc7$var$_react = $d9e120fd82a01fc7$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $d9e120fd82a01fc7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d9e120fd82a01fc7$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d9e120fd82a01fc7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d9e120fd82a01fc7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d9e120fd82a01fc7$var$_extends() {
    return $d9e120fd82a01fc7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d9e120fd82a01fc7$var$_extends.apply(null, arguments);
}
var $d9e120fd82a01fc7$var$GraphQl = $d9e120fd82a01fc7$export$6ed368a40f73768e = /*#__PURE__*/ (0, $d9e120fd82a01fc7$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d9e120fd82a01fc7$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $d9e120fd82a01fc7$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "GraphQl"
    }, props), /*#__PURE__*/ $d9e120fd82a01fc7$var$_react["default"].createElement("path", {
        fill: "#E535AB",
        d: "m14.334 2.852 4.71 2.72c.142-.15.308-.28.495-.39A2.234 2.234 0 0 1 22.585 6a2.234 2.234 0 0 1-1.546 3.31v5.38a2.228 2.228 0 1 1-2.166 3.544l-4.626 2.67A2.231 2.231 0 0 1 12.192 24a2.227 2.227 0 0 1-2.12-2.925l-4.678-2.701a2.23 2.23 0 1 1-2.27-3.634l.001-5.48A2.232 2.232 0 0 1 1.798 6a2.232 2.232 0 0 1 3.458-.51l4.765-2.752A2.227 2.227 0 0 1 12.192 0a2.227 2.227 0 0 1 2.142 2.852zm-.493.88c-.05.054-.103.106-.157.155l6.278 10.875.069-.02V9.255a2.226 2.226 0 0 1-1.501-2.816L13.84 3.73zm-3.28.019a2.237 2.237 0 0 1-.093-.107L5.816 6.33a2.227 2.227 0 0 1-1.683 2.976v5.386l.1.02L10.56 3.751zm2.24.624a2.237 2.237 0 0 1-1.401-.06L5.14 15.154a2.238 2.238 0 0 1 .74 1.12h12.621a2.236 2.236 0 0 1 .595-.996L12.8 4.375zm.949 15.8 4.739-2.736a2.247 2.247 0 0 1-.035-.157H5.93c-.013.07-.03.14-.049.208l4.716 2.723a2.22 2.22 0 0 1 1.596-.672c.607 0 1.156.242 1.558.634z"
    }));
});
$d9e120fd82a01fc7$var$GraphQl.displayName = 'GraphQl';


Object.keys($d9e120fd82a01fc7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $d9e120fd82a01fc7$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $d9e120fd82a01fc7$exports[key];
});
var $ea1bcfe0529bba02$exports = {};

$parcel$export($ea1bcfe0529bba02$exports, "__esModule", function () { return $ea1bcfe0529bba02$export$1e511d4a378977f5; }, function (v) { return $ea1bcfe0529bba02$export$1e511d4a378977f5 = v; });
$parcel$export($ea1bcfe0529bba02$exports, "Gremlin", function () { return $ea1bcfe0529bba02$export$68c0ab7e965bc132; }, function (v) { return $ea1bcfe0529bba02$export$68c0ab7e965bc132 = v; });
var $ea1bcfe0529bba02$export$1e511d4a378977f5;
var $ea1bcfe0529bba02$export$68c0ab7e965bc132;
"use strict";
$ea1bcfe0529bba02$export$1e511d4a378977f5 = true;
$ea1bcfe0529bba02$export$68c0ab7e965bc132 = void 0;

var $ea1bcfe0529bba02$var$_react = $ea1bcfe0529bba02$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $ea1bcfe0529bba02$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ea1bcfe0529bba02$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ea1bcfe0529bba02$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ea1bcfe0529bba02$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ea1bcfe0529bba02$var$_extends() {
    return $ea1bcfe0529bba02$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ea1bcfe0529bba02$var$_extends.apply(null, arguments);
}
var $ea1bcfe0529bba02$var$Gremlin = $ea1bcfe0529bba02$export$68c0ab7e965bc132 = /*#__PURE__*/ (0, $ea1bcfe0529bba02$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $ea1bcfe0529bba02$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ea1bcfe0529bba02$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Gremlin"
    }, props), /*#__PURE__*/ $ea1bcfe0529bba02$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M7 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-5 2c.5 0 1-.321 1-1 0-.113-2-.075-2 0 0 .679.5 1 1 1zm-9 8s.003-8 0-12c.003-4-.447-8 9-8s8.997 4 9 8c-.003 4 0 12 0 12m-.932-17c3.26 0 3.58-3.58 2.046-5.114C20.58.352 17 .673 17 3.932M7 19c0-.203 2.5 1.152 5 1 2.5.152 5-1.499 5-1 0 .802-1.5 2-5 2s-5-1.493-5-2zM3.945 7C.605 7 .38 3.42 1.908 1.886 3.435.352 7 .673 7 3.932"
    }));
});
$ea1bcfe0529bba02$var$Gremlin.displayName = 'Gremlin';


Object.keys($ea1bcfe0529bba02$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ea1bcfe0529bba02$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ea1bcfe0529bba02$exports[key];
});
var $0a3e2bec4a4019d3$exports = {};

$parcel$export($0a3e2bec4a4019d3$exports, "__esModule", function () { return $0a3e2bec4a4019d3$export$1e511d4a378977f5; }, function (v) { return $0a3e2bec4a4019d3$export$1e511d4a378977f5 = v; });
$parcel$export($0a3e2bec4a4019d3$exports, "Grid", function () { return $0a3e2bec4a4019d3$export$ef2184bd89960b14; }, function (v) { return $0a3e2bec4a4019d3$export$ef2184bd89960b14 = v; });
var $0a3e2bec4a4019d3$export$1e511d4a378977f5;
var $0a3e2bec4a4019d3$export$ef2184bd89960b14;
"use strict";
$0a3e2bec4a4019d3$export$1e511d4a378977f5 = true;
$0a3e2bec4a4019d3$export$ef2184bd89960b14 = void 0;

var $0a3e2bec4a4019d3$var$_react = $0a3e2bec4a4019d3$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0a3e2bec4a4019d3$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0a3e2bec4a4019d3$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0a3e2bec4a4019d3$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0a3e2bec4a4019d3$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0a3e2bec4a4019d3$var$_extends() {
    return $0a3e2bec4a4019d3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0a3e2bec4a4019d3$var$_extends.apply(null, arguments);
}
var $0a3e2bec4a4019d3$var$Grid = $0a3e2bec4a4019d3$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $0a3e2bec4a4019d3$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0a3e2bec4a4019d3$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0a3e2bec4a4019d3$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Grid"
    }, props), /*#__PURE__*/ $0a3e2bec4a4019d3$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8 1v22m8-22v22M1 8h22M1 16h22M1 1h22v22H1V1z"
    }));
});
$0a3e2bec4a4019d3$var$Grid.displayName = 'Grid';


Object.keys($0a3e2bec4a4019d3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0a3e2bec4a4019d3$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0a3e2bec4a4019d3$exports[key];
});
var $264c2f6b595bfe24$exports = {};

$parcel$export($264c2f6b595bfe24$exports, "__esModule", function () { return $264c2f6b595bfe24$export$1e511d4a378977f5; }, function (v) { return $264c2f6b595bfe24$export$1e511d4a378977f5 = v; });
$parcel$export($264c2f6b595bfe24$exports, "Grommet", function () { return $264c2f6b595bfe24$export$efa1b86658154a31; }, function (v) { return $264c2f6b595bfe24$export$efa1b86658154a31 = v; });
var $264c2f6b595bfe24$export$1e511d4a378977f5;
var $264c2f6b595bfe24$export$efa1b86658154a31;
"use strict";
$264c2f6b595bfe24$export$1e511d4a378977f5 = true;
$264c2f6b595bfe24$export$efa1b86658154a31 = void 0;

var $264c2f6b595bfe24$var$_react = $264c2f6b595bfe24$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $264c2f6b595bfe24$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($264c2f6b595bfe24$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $264c2f6b595bfe24$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $264c2f6b595bfe24$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $264c2f6b595bfe24$var$_extends() {
    return $264c2f6b595bfe24$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $264c2f6b595bfe24$var$_extends.apply(null, arguments);
}
var $264c2f6b595bfe24$var$Grommet = $264c2f6b595bfe24$export$efa1b86658154a31 = /*#__PURE__*/ (0, $264c2f6b595bfe24$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $264c2f6b595bfe24$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $264c2f6b595bfe24$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Grommet"
    }, props), /*#__PURE__*/ $264c2f6b595bfe24$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#865CD6",
        strokeWidth: "4",
        d: "M12 2C6.485 2 2 6.485 2 12s4.485 10 10 10 10-4.485 10-10S17.515 2 12 2z"
    }));
});
$264c2f6b595bfe24$var$Grommet.displayName = 'Grommet';


Object.keys($264c2f6b595bfe24$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $264c2f6b595bfe24$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $264c2f6b595bfe24$exports[key];
});
var $122560b910b0b155$exports = {};

$parcel$export($122560b910b0b155$exports, "__esModule", function () { return $122560b910b0b155$export$1e511d4a378977f5; }, function (v) { return $122560b910b0b155$export$1e511d4a378977f5 = v; });
$parcel$export($122560b910b0b155$exports, "Group", function () { return $122560b910b0b155$export$eb2fcfdbd7ba97d4; }, function (v) { return $122560b910b0b155$export$eb2fcfdbd7ba97d4 = v; });
var $122560b910b0b155$export$1e511d4a378977f5;
var $122560b910b0b155$export$eb2fcfdbd7ba97d4;
"use strict";
$122560b910b0b155$export$1e511d4a378977f5 = true;
$122560b910b0b155$export$eb2fcfdbd7ba97d4 = void 0;

var $122560b910b0b155$var$_react = $122560b910b0b155$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $122560b910b0b155$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($122560b910b0b155$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $122560b910b0b155$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $122560b910b0b155$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $122560b910b0b155$var$_extends() {
    return $122560b910b0b155$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $122560b910b0b155$var$_extends.apply(null, arguments);
}
var $122560b910b0b155$var$Group = $122560b910b0b155$export$eb2fcfdbd7ba97d4 = /*#__PURE__*/ (0, $122560b910b0b155$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $122560b910b0b155$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $122560b910b0b155$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Group"
    }, props), /*#__PURE__*/ $122560b910b0b155$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm-6 9v-3a6 6 0 1 1 12 0v3M13 5c.404-1.664 2.015-3 4-3 2.172 0 3.98 1.79 4 4-.02 2.21-1.828 4-4 4h-1 1c3.288 0 6 2.686 6 6v2M11 5c-.404-1.664-2.015-3-4-3-2.172 0-3.98 1.79-4 4 .02 2.21 1.828 4 4 4h1-1c-3.288 0-6 2.686-6 6v2"
    }));
});
$122560b910b0b155$var$Group.displayName = 'Group';


Object.keys($122560b910b0b155$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $122560b910b0b155$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $122560b910b0b155$exports[key];
});
var $e43d30f9375afdda$exports = {};

$parcel$export($e43d30f9375afdda$exports, "__esModule", function () { return $e43d30f9375afdda$export$1e511d4a378977f5; }, function (v) { return $e43d30f9375afdda$export$1e511d4a378977f5 = v; });
$parcel$export($e43d30f9375afdda$exports, "Grow", function () { return $e43d30f9375afdda$export$1894143dedd4d355; }, function (v) { return $e43d30f9375afdda$export$1894143dedd4d355 = v; });
var $e43d30f9375afdda$export$1e511d4a378977f5;
var $e43d30f9375afdda$export$1894143dedd4d355;
"use strict";
$e43d30f9375afdda$export$1e511d4a378977f5 = true;
$e43d30f9375afdda$export$1894143dedd4d355 = void 0;

var $e43d30f9375afdda$var$_react = $e43d30f9375afdda$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e43d30f9375afdda$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e43d30f9375afdda$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e43d30f9375afdda$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e43d30f9375afdda$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e43d30f9375afdda$var$_extends() {
    return $e43d30f9375afdda$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e43d30f9375afdda$var$_extends.apply(null, arguments);
}
var $e43d30f9375afdda$var$Grow = $e43d30f9375afdda$export$1894143dedd4d355 = /*#__PURE__*/ (0, $e43d30f9375afdda$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e43d30f9375afdda$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e43d30f9375afdda$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Grow"
    }, props), /*#__PURE__*/ $e43d30f9375afdda$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 16V7m0 4c0-3 0-6-7-6 0 3 0 6 7 6zm-8 5h16m-2 0-2 7H8l-2-7m6-9c0-3 0-6 7-6 0 3 0 6-7 6z"
    }));
});
$e43d30f9375afdda$var$Grow.displayName = 'Grow';


Object.keys($e43d30f9375afdda$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e43d30f9375afdda$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e43d30f9375afdda$exports[key];
});
var $6d8ed9a5fb3265e4$exports = {};

$parcel$export($6d8ed9a5fb3265e4$exports, "__esModule", function () { return $6d8ed9a5fb3265e4$export$1e511d4a378977f5; }, function (v) { return $6d8ed9a5fb3265e4$export$1e511d4a378977f5 = v; });
$parcel$export($6d8ed9a5fb3265e4$exports, "Hadoop", function () { return $6d8ed9a5fb3265e4$export$33a4d9bc08a2139a; }, function (v) { return $6d8ed9a5fb3265e4$export$33a4d9bc08a2139a = v; });
var $6d8ed9a5fb3265e4$export$1e511d4a378977f5;
var $6d8ed9a5fb3265e4$export$33a4d9bc08a2139a;
"use strict";
$6d8ed9a5fb3265e4$export$1e511d4a378977f5 = true;
$6d8ed9a5fb3265e4$export$33a4d9bc08a2139a = void 0;

var $6d8ed9a5fb3265e4$var$_react = $6d8ed9a5fb3265e4$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $6d8ed9a5fb3265e4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6d8ed9a5fb3265e4$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6d8ed9a5fb3265e4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6d8ed9a5fb3265e4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6d8ed9a5fb3265e4$var$_extends() {
    return $6d8ed9a5fb3265e4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6d8ed9a5fb3265e4$var$_extends.apply(null, arguments);
}
var $6d8ed9a5fb3265e4$var$Hadoop = $6d8ed9a5fb3265e4$export$33a4d9bc08a2139a = /*#__PURE__*/ (0, $6d8ed9a5fb3265e4$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $6d8ed9a5fb3265e4$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $6d8ed9a5fb3265e4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Hadoop"
    }, props), /*#__PURE__*/ $6d8ed9a5fb3265e4$var$_react["default"].createElement("path", {
        fill: "#92CCF4",
        fillRule: "evenodd",
        d: "M22.615 8.515c-.162.64-.49 1.186-1.168 1.428-.332.118-.547-.004-.886-.102.333.032.524.083.822-.064a2.72 2.72 0 0 0 1.232-1.262zm1.355 4.215c-.08.777-.287 1.532-.656 2.172a3.548 3.548 0 0 1-1.407 1.385c-.417.222-.902.35-1.403.403a5.83 5.83 0 0 1-1.56-.06l-.07.234c-.03.097-.06.194-.088.29-.103.337-.347.64-.652.865-.314.232-.698.383-1.055.4a1.443 1.443 0 0 1-.84-.203c-.226-.133-.42-.318-.631-.522l-.277-.267-.187-.18-.02.123c.098.197.167.382.237.572.045.12.09.241.145.373.082.195.144.358.187.527.043.17.066.344.072.557l.015.542c.004.17.008.341.014.512.075.136.12.23.142.334a1.3 1.3 0 0 1 .01.393c-.028.394-.158.614-.377.739-.206.116-.478.133-.814.132l-.235-.001c-.327 0-.832 0-.986-.01a3.395 3.395 0 0 1-.525-.066.762.762 0 0 1-.28-.121c-.112.09-.21.171-.309.252-.29.24-.584.483-.702.561a4.06 4.06 0 0 0-.125.206c-.121.214-.211.371-.498.527-.564.304-1 .278-1.382.043-.365-.224-.666-.635-.98-1.12-.15-.23-.39-.61-.506-.983-.129-.412-.11-.812.3-1.023l.058-.03.123-.064a7.16 7.16 0 0 1-1.393-.05l.012.086c.024.208.04.344.02.48-.02.14-.075.265-.193.442l-.058.082c-.11.163-.175.26-.326.594.015.165.02.298.009.43a2.702 2.702 0 0 1-.093.477c-.13.478-.61.588-1.142.554-.488-.03-1.023-.184-1.332-.268l-.174-.046a4.952 4.952 0 0 1-.778-.248c-.473-.216-.777-.555-.481-1.204a4.04 4.04 0 0 0 .127-.314c.014-.037.024-.073.036-.11a1.48 1.48 0 0 1-.746-.103c-.437-.166-.853-.483-1.108-.738a2.696 2.696 0 0 1-.482-.65 2.495 2.495 0 0 1-.252-.748c-.069-.408-.02-.455.22-.687l.087-.083.357-.354c.127-.126.256-.253.382-.38l.175-.472.111-.305a5.999 5.999 0 0 1-.083-.596 9.29 9.29 0 0 1-.037-1.14c.01-.256.034-.492.073-.718-.2.044-.402.041-.586-.017a.905.905 0 0 1-.55-.489 2.162 2.162 0 0 1-.116-.299 5.379 5.379 0 0 1-.088-.322.993.993 0 0 1-.286-.525 1.016 1.016 0 0 1 .098-.612 2.04 2.04 0 0 1 .384-.536c.425-.442 1.03-.774 1.31-.823l.212-.037-.07.203c-.037.102-.08.21-.12.315-.013.03-.024.061-.037.095a.69.69 0 0 1 .243.406c.057.25.02.537-.028.753l-.058.258-.163-.207c-.04-.049-.073-.1-.104-.149a1.443 1.443 0 0 0-.086-.122c-.022.336-.063.672-.302.902.007.028.01.044.015.047.004.002.044-.02.142-.058.169-.065.318-.172.46-.298.144-.13.276-.28.41-.426.152-.294.325-.573.528-.837.205-.27.441-.526.713-.766a6.577 6.577 0 0 1 2.047-1.266c.72-.278 1.521-.453 2.506-.611a12.88 12.88 0 0 1 .809-.78 1.96 1.96 0 0 1 .562-.368c.158-.065.313-.09.488-.103.301-.4.575-.744.898-1.042a4.13 4.13 0 0 1 1.247-.792c1.082-.456 1.999-.694 2.866-.64.873.055 1.69.405 2.566 1.128.165.136.334.284.502.43.367.324.727.64 1.15.904.16.099.294.185.427.286.132.1.253.212.38.362.153.183.292.366.415.562.103.163.193.337.272.527.18-.072.369-.152.521-.28.131-.113.24-.273.35-.432.097-.143.195-.286.312-.403a.476.476 0 0 1 .128-.095c.178-.094.404-.079.618-.005.202.07.397.192.53.323.06.06.11.123.141.185.266.509.458 1.216.573 1.943.13.818.164 1.665.102 2.288zm-3.725-3.348a9.904 9.904 0 0 0-.113.003.614.614 0 0 1 .13.19.414.414 0 0 1 .052-.043 6.955 6.955 0 0 0-.069-.15zM1.499 11.654c.098-.011.16.04.236.116-.014-.181-.048-.316-.176-.39l-.025.088c-.016.059-.026.12-.035.186zm.391 1.98a9.669 9.669 0 0 1 .228-.666 1.715 1.715 0 0 1-.518.33c-.524.21-.513.029-.739-.426.48-.383.258-.853.41-1.382.036-.122.087-.24.16-.397C.93 11.395.006 12.24.623 12.88c.067.241.118.43.21.62.189.395.682.294 1.057.135zm1.389 6.399c-.537-.811-1.021-1.778-1.305-2.76l-.158.421-.72.73c-.178.18-.213.187-.177.442.048.35.255.723.564 1.038.282.288 1.258 1.04 1.641.528.082-.11.12-.245.155-.384v-.015zm11.783-1.536c-.085-.202-.131-.39-.19-.582-.128.457-.3.886-.456 1.38-.148.467-.909 1.822-1.356 2.151.087.065.247.09.532.115.201.017.995.021 1.195.024.439.008.606-.025.65-.525.022-.245.002-.29-.12-.505l-.032-1.148c-.01-.362-.08-.572-.223-.91zm7.89-9.624c-.103-.247-.51-.618-.77-.366-.262.255-.459.614-.744.84-.389.305-1.057.2-.936.85.088.472.114 1.001.012 1.442-.096.423-.196 1.024-.417 1.308.065-.24.175-.867.206-1.29a3.72 3.72 0 0 0-.053-.791l-.147.003c-.178.004-.469.26-.547.419-.218.444-.233.856-.477 1.279.197-.473.086-.899.266-1.405.063-.179.223-.333.409-.427-.104-.015-.207.03-.36.065-.651.156-.622.668-1.023 1.157.387-.709.19-1.179 1.028-1.37.275-.063.477-.088.658.057h.011l.143-.012c-.023-.13-.049-.258-.074-.379a3.908 3.908 0 0 0-1.13.02c.085-.037.168-.071.248-.1.125-.046.247-.082.367-.103a.238.238 0 0 0 .023-.079.243.243 0 0 0-.218-.263.238.238 0 0 0-.259.218.303.303 0 0 0 .025.13.594.594 0 0 1 .015-.569.725.725 0 0 1-.42.006 2.616 2.616 0 0 0 .62-.21.59.59 0 0 1 .554-.034c.079.023.167.054.273.093a6.158 6.158 0 0 0-.562-.948c-.208-.289-.382-.388-.689-.57a6.177 6.177 0 0 1-.196-.12c-.227-.042-.48-.083-.698-.041.18-.07.315-.1.473-.112-.434-.311-.809-.66-1.237-1.02-1.653-1.39-2.99-1.292-5.095-.378-.854.372-1.16.746-1.686 1.418h.017a23.346 23.346 0 0 0 1.615-.084c-.568.133-1.112.239-1.67.323-.615.094-.804.078-1.269.53-.855.833-1.572 1.774-2.355 2.618-.453.49-.679.98-.945 1.537-.264.554-.227.764.127 1.243.362.491.58.713.734 1.148.4-.617.882-1.13 1.39-1.743a25.384 25.384 0 0 0-1.136 1.97c-.214.42-.319.635-.312 1.1.401.462.653.709 1.025.81.401.111.78.093 1.142-.095.902-.467 1.759-1.076 2.76-1.153.517-.92.372-2.079.186-3.127-.154-.87-.115-1.638.093-2.511.052.848.12 1.635.288 2.467.245 1.218.297 2.27-.216 3.528-1.106.027-2.014.675-2.995 1.177-.441.225-.854.248-1.348.13-.503-.119-.889-.507-1.407-1.074.05-.429.107-.695.26-1.01-.185-.557-.414-.812-.838-1.381-.49-.66-.499-.946-.128-1.697.268-.544.519-1.047.942-1.543.417-.492.8-.95 1.188-1.384-1.61.245-2.638.633-3.738 1.598-.815.715-1.324 1.604-1.687 2.63-.23.648-.294 1.3-.185 2.36.139 1.364.864 2.904 1.644 4.027-.095.7-.219 1.226-.414 1.726-.221.566.66.74 1.085.856.345.095 1.656.455 1.786-.01.077-.278.077-.473.058-.767.234-.466.305-.528.472-.804.178-.295.193-.413.195-.76 0-.447-.011-1.245.008-1.534.06.258.132.618.192.963a7.332 7.332 0 0 0 2.789-.036c.012-.065.033-.136.057-.223.063-.218.188-.436.25-.654l-.05.644c-.018.221-.019.4.009.62l.044.364c-.067-.11-.172-.218-.233-.33-.415.274-.643.428-1.05.643-.431.228.062 1.043.24 1.326.39.62.857 1.355 1.583.971.238-.125.378-.417.537-.626.213-.126 1.343-1.08 1.523-1.183.254-.146 1.167-1.642 1.283-2.015.255-.827.555-1.456.64-2.318-.582-.245-.864-.517-1.281-1.007a5.436 5.436 0 0 0 1.723.867c.23.203.463.408.704.623.35.312.672.63 1.18.639.55.01 1.17-.41 1.33-.931l.184-.602a5.48 5.48 0 0 1-.318-.087c-.114.274-.105.38-.158.582-.093.344-.567.583-1.063.463-.176-.043-.28-.067-.343-.113.05.136.147.251.328.284.2.037.347.053.638-.013-.36.187-.475.195-.73.138-.67-.149-.434-.956-.288-1.45.092-.31.06-.64-.009-.951.254.16.455.302.744.4 1.354.455 2.96.92 4.322.159 1.068-.596 1.654-1.919 1.785-3.13.118-1.08-.085-2.765-.527-3.836zm-6.909 6.503c-.026.168-.062.376-.089.544.072-.19.157-.41.24-.591.087-.192.136-.209.32-.31.133-.072.372-.17.503-.242-.135.023-.378.072-.512.095-.362.061-.405.148-.462.504zM9.865 8.908c-.419.415-.826 1.84-.956 2.409.204-.474.718-1.797 1.112-2.134a1.39 1.39 0 0 1 .266-.192c-.282.473-.261.59-.162 1.224.084-.644.307-.893.672-1.373.4-.101.776-.22 1.187-.381-.464.052-.926.1-1.39.144-.39.036-.452.03-.729.303zm6.964 1.58a.767.767 0 0 0-.432-.392c.167-.09.33-.183.457-.298-.373.173-.807.13-1.127.347-.283.19-.672.794-.959 1.05.207-.08.407-.22.591-.367a.762.762 0 0 0 .286.589.314.314 0 0 1-.06-.085.323.323 0 1 1 .6-.231 2.06 2.06 0 0 0-.412.403 1.729 1.729 0 0 0-.25.457 4.386 4.386 0 0 1 2.081-1.345 2.255 2.255 0 0 0-.705.118.763.763 0 0 0-.07-.247zm-2.666-.584c.126-.556.349-1.092 1.212-1.506-1.144.286-1.359.767-1.212 1.506z"
    }));
});
$6d8ed9a5fb3265e4$var$Hadoop.displayName = 'Hadoop';


Object.keys($6d8ed9a5fb3265e4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $6d8ed9a5fb3265e4$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $6d8ed9a5fb3265e4$exports[key];
});
var $9765c2fee8041220$exports = {};

$parcel$export($9765c2fee8041220$exports, "__esModule", function () { return $9765c2fee8041220$export$1e511d4a378977f5; }, function (v) { return $9765c2fee8041220$export$1e511d4a378977f5 = v; });
$parcel$export($9765c2fee8041220$exports, "Halt", function () { return $9765c2fee8041220$export$c0f9a370bfd0262b; }, function (v) { return $9765c2fee8041220$export$c0f9a370bfd0262b = v; });
var $9765c2fee8041220$export$1e511d4a378977f5;
var $9765c2fee8041220$export$c0f9a370bfd0262b;
"use strict";
$9765c2fee8041220$export$1e511d4a378977f5 = true;
$9765c2fee8041220$export$c0f9a370bfd0262b = void 0;

var $9765c2fee8041220$var$_react = $9765c2fee8041220$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $9765c2fee8041220$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9765c2fee8041220$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9765c2fee8041220$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $9765c2fee8041220$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $9765c2fee8041220$var$_extends() {
    return $9765c2fee8041220$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9765c2fee8041220$var$_extends.apply(null, arguments);
}
var $9765c2fee8041220$var$Halt = $9765c2fee8041220$export$c0f9a370bfd0262b = /*#__PURE__*/ (0, $9765c2fee8041220$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $9765c2fee8041220$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $9765c2fee8041220$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Halt"
    }, props), /*#__PURE__*/ $9765c2fee8041220$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8 23h7c3 0 4-2 4-5V6c0-2-1-2-1.5-2S16 4 16 6v7-9c0-1 0-2-1.5-2S13 3 13 4v9V3c0-1 0-2-1.5-2S10 2 10 3v10-9c0-1 .03-2-1.5-2C7 2 7 3 7 4v14-4c0-1-.55-2-2-2H4v6c0 3.962 2 5.024 4 5z"
    }));
});
$9765c2fee8041220$var$Halt.displayName = 'Halt';


Object.keys($9765c2fee8041220$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $9765c2fee8041220$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $9765c2fee8041220$exports[key];
});
var $00c63743dba561b7$exports = {};

$parcel$export($00c63743dba561b7$exports, "__esModule", function () { return $00c63743dba561b7$export$1e511d4a378977f5; }, function (v) { return $00c63743dba561b7$export$1e511d4a378977f5 = v; });
$parcel$export($00c63743dba561b7$exports, "HelpBook", function () { return $00c63743dba561b7$export$d700ca6905dab072; }, function (v) { return $00c63743dba561b7$export$d700ca6905dab072 = v; });
var $00c63743dba561b7$export$1e511d4a378977f5;
var $00c63743dba561b7$export$d700ca6905dab072;
"use strict";
$00c63743dba561b7$export$1e511d4a378977f5 = true;
$00c63743dba561b7$export$d700ca6905dab072 = void 0;

var $00c63743dba561b7$var$_react = $00c63743dba561b7$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $00c63743dba561b7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($00c63743dba561b7$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $00c63743dba561b7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $00c63743dba561b7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $00c63743dba561b7$var$_extends() {
    return $00c63743dba561b7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $00c63743dba561b7$var$_extends.apply(null, arguments);
}
var $00c63743dba561b7$var$HelpBook = $00c63743dba561b7$export$d700ca6905dab072 = /*#__PURE__*/ (0, $00c63743dba561b7$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $00c63743dba561b7$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $00c63743dba561b7$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "HelpBook"
    }, props), /*#__PURE__*/ $00c63743dba561b7$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M11.937 12.136v-.864c0-.864 0-1.296.797-1.728.798-.432 1.595-.864 1.595-2.16 0-.865-.797-2.16-2.392-2.16-1.594 0-2.391 1.092-2.391 2.592"
    }), /*#__PURE__*/ $00c63743dba561b7$var$_react["default"].createElement("path", {
        stroke: "#000",
        strokeWidth: "2",
        d: "M11.938 13v1.728"
    }), /*#__PURE__*/ $00c63743dba561b7$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M5.5 18a2.5 2.5 0 1 0 0 5H22M3 20.5v-17A2.5 2.5 0 0 1 5.5 1H21v17.007H5.492M20.5 18a2.5 2.5 0 1 0 0 5"
    }));
});
$00c63743dba561b7$var$HelpBook.displayName = 'HelpBook';


Object.keys($00c63743dba561b7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $00c63743dba561b7$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $00c63743dba561b7$exports[key];
});
var $e19f6d74acf41835$exports = {};

$parcel$export($e19f6d74acf41835$exports, "__esModule", function () { return $e19f6d74acf41835$export$1e511d4a378977f5; }, function (v) { return $e19f6d74acf41835$export$1e511d4a378977f5 = v; });
$parcel$export($e19f6d74acf41835$exports, "HelpOption", function () { return $e19f6d74acf41835$export$58faf3767be8235a; }, function (v) { return $e19f6d74acf41835$export$58faf3767be8235a = v; });
var $e19f6d74acf41835$export$1e511d4a378977f5;
var $e19f6d74acf41835$export$58faf3767be8235a;
"use strict";
$e19f6d74acf41835$export$1e511d4a378977f5 = true;
$e19f6d74acf41835$export$58faf3767be8235a = void 0;

var $e19f6d74acf41835$var$_react = $e19f6d74acf41835$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e19f6d74acf41835$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e19f6d74acf41835$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e19f6d74acf41835$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e19f6d74acf41835$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e19f6d74acf41835$var$_extends() {
    return $e19f6d74acf41835$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e19f6d74acf41835$var$_extends.apply(null, arguments);
}
var $e19f6d74acf41835$var$HelpOption = $e19f6d74acf41835$export$58faf3767be8235a = /*#__PURE__*/ (0, $e19f6d74acf41835$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e19f6d74acf41835$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e19f6d74acf41835$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "HelpOption"
    }, props), /*#__PURE__*/ $e19f6d74acf41835$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 7a5 5 0 0 1 5-5h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7zm5-3a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7zm5 3.5c-1.448 0-2 1.052-2 1.5a1 1 0 1 1-2 0c0-1.552 1.448-3.5 4-3.5 1.156 0 2.17.289 2.909.935C15.664 7.096 16 8.017 16 9c0 1.188-.306 2.028-.882 2.668a4.313 4.313 0 0 1-.828.693 14.92 14.92 0 0 1-.368.235l-.018.011c-.124.078-.236.15-.347.223-.35.236-.493.412-.55.526-.046.088-.077.205-.028.438a1 1 0 0 1-1.958.412c-.126-.6-.083-1.197.204-1.759.273-.535.718-.942 1.218-1.277.14-.094.277-.18.399-.257l.009-.006c.122-.076.228-.142.328-.21.205-.136.346-.25.453-.368.174-.193.368-.516.368-1.329 0-.517-.164-.846-.409-1.06-.261-.229-.747-.44-1.591-.44zm0 8.281a1 1 0 1 0 0 2 1 1 0 0 0 0-2z",
        fill: "#000"
    }));
});
$e19f6d74acf41835$var$HelpOption.displayName = 'HelpOption';


Object.keys($e19f6d74acf41835$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e19f6d74acf41835$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e19f6d74acf41835$exports[key];
});
var $f9fcb99c002aca78$exports = {};

$parcel$export($f9fcb99c002aca78$exports, "__esModule", function () { return $f9fcb99c002aca78$export$1e511d4a378977f5; }, function (v) { return $f9fcb99c002aca78$export$1e511d4a378977f5 = v; });
$parcel$export($f9fcb99c002aca78$exports, "Help", function () { return $f9fcb99c002aca78$export$1be7516c0280bee8; }, function (v) { return $f9fcb99c002aca78$export$1be7516c0280bee8 = v; });
var $f9fcb99c002aca78$export$1e511d4a378977f5;
var $f9fcb99c002aca78$export$1be7516c0280bee8;
"use strict";
$f9fcb99c002aca78$export$1e511d4a378977f5 = true;
$f9fcb99c002aca78$export$1be7516c0280bee8 = void 0;

var $f9fcb99c002aca78$var$_react = $f9fcb99c002aca78$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f9fcb99c002aca78$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f9fcb99c002aca78$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f9fcb99c002aca78$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f9fcb99c002aca78$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f9fcb99c002aca78$var$_extends() {
    return $f9fcb99c002aca78$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f9fcb99c002aca78$var$_extends.apply(null, arguments);
}
var $f9fcb99c002aca78$var$Help = $f9fcb99c002aca78$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $f9fcb99c002aca78$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f9fcb99c002aca78$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f9fcb99c002aca78$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Help"
    }, props), /*#__PURE__*/ $f9fcb99c002aca78$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 23a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0-5v-3c0-2 1-2 3-3s3-2.842 3-5A6 6 0 1 0 6 7"
    }));
});
$f9fcb99c002aca78$var$Help.displayName = 'Help';


Object.keys($f9fcb99c002aca78$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f9fcb99c002aca78$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f9fcb99c002aca78$exports[key];
});
var $65fccf7b5c771024$exports = {};

$parcel$export($65fccf7b5c771024$exports, "__esModule", function () { return $65fccf7b5c771024$export$1e511d4a378977f5; }, function (v) { return $65fccf7b5c771024$export$1e511d4a378977f5 = v; });
$parcel$export($65fccf7b5c771024$exports, "Heroku", function () { return $65fccf7b5c771024$export$cb2df528dfd8db52; }, function (v) { return $65fccf7b5c771024$export$cb2df528dfd8db52 = v; });
var $65fccf7b5c771024$export$1e511d4a378977f5;
var $65fccf7b5c771024$export$cb2df528dfd8db52;
"use strict";
$65fccf7b5c771024$export$1e511d4a378977f5 = true;
$65fccf7b5c771024$export$cb2df528dfd8db52 = void 0;

var $65fccf7b5c771024$var$_react = $65fccf7b5c771024$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $65fccf7b5c771024$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($65fccf7b5c771024$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $65fccf7b5c771024$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $65fccf7b5c771024$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $65fccf7b5c771024$var$_extends() {
    return $65fccf7b5c771024$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $65fccf7b5c771024$var$_extends.apply(null, arguments);
}
var $65fccf7b5c771024$var$Heroku = $65fccf7b5c771024$export$cb2df528dfd8db52 = /*#__PURE__*/ (0, $65fccf7b5c771024$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $65fccf7b5c771024$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $65fccf7b5c771024$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Heroku"
    }, props), /*#__PURE__*/ $65fccf7b5c771024$var$_react["default"].createElement("path", {
        fill: "#6762A6",
        fillRule: "evenodd",
        d: "M20.443 0H3.162A2.162 2.162 0 0 0 1 2.162V21.84C1 23.034 1.97 24 3.162 24h17.28a2.159 2.159 0 0 0 2.16-2.16V2.162A2.16 2.16 0 0 0 20.442 0zm.958 21.84a.96.96 0 0 1-.958.96H3.162a.961.961 0 0 1-.962-.96V2.162c0-.532.432-.962.962-.962h17.28c.53 0 .96.43.96.962V21.84zm-15-1.439 2.701-2.4L6.4 15.6v4.8zm9.757-9.729c-.486-.488-1.373-1.071-2.856-1.071-1.627 0-3.303.424-4.5.812V3.6H6.4v10.41l1.697-.769c.028-.013 2.763-1.239 5.205-1.239 1.218 0 1.488.67 1.501 1.231v7.17h2.398v-7.2c.003-.155-.012-1.486-1.043-2.53M13 7.5h2.401c1.085-1.228 1.637-2.536 1.8-3.899h-2.399c-.267 1.36-.858 2.66-1.802 3.9"
    }));
});
$65fccf7b5c771024$var$Heroku.displayName = 'Heroku';


Object.keys($65fccf7b5c771024$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $65fccf7b5c771024$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $65fccf7b5c771024$exports[key];
});
var $80a5cb4dda78d667$exports = {};

$parcel$export($80a5cb4dda78d667$exports, "__esModule", function () { return $80a5cb4dda78d667$export$1e511d4a378977f5; }, function (v) { return $80a5cb4dda78d667$export$1e511d4a378977f5 = v; });
$parcel$export($80a5cb4dda78d667$exports, "Hide", function () { return $80a5cb4dda78d667$export$bed28288a051538; }, function (v) { return $80a5cb4dda78d667$export$bed28288a051538 = v; });
var $80a5cb4dda78d667$export$1e511d4a378977f5;
var $80a5cb4dda78d667$export$bed28288a051538;
"use strict";
$80a5cb4dda78d667$export$1e511d4a378977f5 = true;
$80a5cb4dda78d667$export$bed28288a051538 = void 0;

var $80a5cb4dda78d667$var$_react = $80a5cb4dda78d667$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $80a5cb4dda78d667$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($80a5cb4dda78d667$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $80a5cb4dda78d667$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $80a5cb4dda78d667$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $80a5cb4dda78d667$var$_extends() {
    return $80a5cb4dda78d667$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $80a5cb4dda78d667$var$_extends.apply(null, arguments);
}
var $80a5cb4dda78d667$var$Hide = $80a5cb4dda78d667$export$bed28288a051538 = /*#__PURE__*/ (0, $80a5cb4dda78d667$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $80a5cb4dda78d667$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $80a5cb4dda78d667$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Hide"
    }, props), /*#__PURE__*/ $80a5cb4dda78d667$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 17c-2.727 0-6-2.778-6-5s3.273-5 6-5 6 2.778 6 5-3.273 5-6 5zm-1-5a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm9-7L4 19"
    }));
});
$80a5cb4dda78d667$var$Hide.displayName = 'Hide';


Object.keys($80a5cb4dda78d667$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $80a5cb4dda78d667$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $80a5cb4dda78d667$exports[key];
});
var $6206384739ff31c4$exports = {};

$parcel$export($6206384739ff31c4$exports, "__esModule", function () { return $6206384739ff31c4$export$1e511d4a378977f5; }, function (v) { return $6206384739ff31c4$export$1e511d4a378977f5 = v; });
$parcel$export($6206384739ff31c4$exports, "History", function () { return $6206384739ff31c4$export$84202caead5689ba; }, function (v) { return $6206384739ff31c4$export$84202caead5689ba = v; });
var $6206384739ff31c4$export$1e511d4a378977f5;
var $6206384739ff31c4$export$84202caead5689ba;
"use strict";
$6206384739ff31c4$export$1e511d4a378977f5 = true;
$6206384739ff31c4$export$84202caead5689ba = void 0;

var $6206384739ff31c4$var$_react = $6206384739ff31c4$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $6206384739ff31c4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6206384739ff31c4$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6206384739ff31c4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6206384739ff31c4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6206384739ff31c4$var$_extends() {
    return $6206384739ff31c4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6206384739ff31c4$var$_extends.apply(null, arguments);
}
var $6206384739ff31c4$var$History = $6206384739ff31c4$export$84202caead5689ba = /*#__PURE__*/ (0, $6206384739ff31c4$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $6206384739ff31c4$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $6206384739ff31c4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "History"
    }, props), /*#__PURE__*/ $6206384739ff31c4$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 12c0 6.075 4.925 11 11 11s11-4.925 11-11S18.075 1 12 1C7.563 1 4 4 2 7.5M1 1v7h7m8 9-4-4V6"
    }));
});
$6206384739ff31c4$var$History.displayName = 'History';


Object.keys($6206384739ff31c4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $6206384739ff31c4$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $6206384739ff31c4$exports[key];
});
var $468d0c4e4a091c23$exports = {};

$parcel$export($468d0c4e4a091c23$exports, "__esModule", function () { return $468d0c4e4a091c23$export$1e511d4a378977f5; }, function (v) { return $468d0c4e4a091c23$export$1e511d4a378977f5 = v; });
$parcel$export($468d0c4e4a091c23$exports, "HomeOption", function () { return $468d0c4e4a091c23$export$23d3719cbd99151f; }, function (v) { return $468d0c4e4a091c23$export$23d3719cbd99151f = v; });
var $468d0c4e4a091c23$export$1e511d4a378977f5;
var $468d0c4e4a091c23$export$23d3719cbd99151f;
"use strict";
$468d0c4e4a091c23$export$1e511d4a378977f5 = true;
$468d0c4e4a091c23$export$23d3719cbd99151f = void 0;

var $468d0c4e4a091c23$var$_react = $468d0c4e4a091c23$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $468d0c4e4a091c23$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($468d0c4e4a091c23$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $468d0c4e4a091c23$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $468d0c4e4a091c23$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $468d0c4e4a091c23$var$_extends() {
    return $468d0c4e4a091c23$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $468d0c4e4a091c23$var$_extends.apply(null, arguments);
}
var $468d0c4e4a091c23$var$HomeOption = $468d0c4e4a091c23$export$23d3719cbd99151f = /*#__PURE__*/ (0, $468d0c4e4a091c23$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $468d0c4e4a091c23$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $468d0c4e4a091c23$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "HomeOption"
    }, props), /*#__PURE__*/ $468d0c4e4a091c23$var$_react["default"].createElement("rect", {
        x: "3",
        y: "3",
        width: "18",
        height: "18",
        rx: "4",
        stroke: "#000",
        strokeWidth: "2",
        fill: "none"
    }));
});
$468d0c4e4a091c23$var$HomeOption.displayName = 'HomeOption';


Object.keys($468d0c4e4a091c23$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $468d0c4e4a091c23$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $468d0c4e4a091c23$exports[key];
});
var $1343fcc9c4697aa8$exports = {};

$parcel$export($1343fcc9c4697aa8$exports, "__esModule", function () { return $1343fcc9c4697aa8$export$1e511d4a378977f5; }, function (v) { return $1343fcc9c4697aa8$export$1e511d4a378977f5 = v; });
$parcel$export($1343fcc9c4697aa8$exports, "HomeRounded", function () { return $1343fcc9c4697aa8$export$bc68ca542931f624; }, function (v) { return $1343fcc9c4697aa8$export$bc68ca542931f624 = v; });
var $1343fcc9c4697aa8$export$1e511d4a378977f5;
var $1343fcc9c4697aa8$export$bc68ca542931f624;
"use strict";
$1343fcc9c4697aa8$export$1e511d4a378977f5 = true;
$1343fcc9c4697aa8$export$bc68ca542931f624 = void 0;

var $1343fcc9c4697aa8$var$_react = $1343fcc9c4697aa8$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $1343fcc9c4697aa8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1343fcc9c4697aa8$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1343fcc9c4697aa8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $1343fcc9c4697aa8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1343fcc9c4697aa8$var$_extends() {
    return $1343fcc9c4697aa8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1343fcc9c4697aa8$var$_extends.apply(null, arguments);
}
var $1343fcc9c4697aa8$var$HomeRounded = $1343fcc9c4697aa8$export$bc68ca542931f624 = /*#__PURE__*/ (0, $1343fcc9c4697aa8$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $1343fcc9c4697aa8$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $1343fcc9c4697aa8$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "HomeRounded"
    }, props), /*#__PURE__*/ $1343fcc9c4697aa8$var$_react["default"].createElement("path", {
        stroke: "#000",
        strokeWidth: "2",
        fill: "none",
        d: "M1 22V9.76a2 2 0 0 1 .851-1.636l9.575-6.72a1 1 0 0 1 1.149 0l9.574 6.72A2 2 0 0 1 23 9.76V22a1 1 0 0 1-1 1h-5.333a1 1 0 0 1-1-1v-5.674a1 1 0 0 0-1-1H9.333a1 1 0 0 0-1 1V22a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1z"
    }));
});
$1343fcc9c4697aa8$var$HomeRounded.displayName = 'HomeRounded';


Object.keys($1343fcc9c4697aa8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $1343fcc9c4697aa8$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $1343fcc9c4697aa8$exports[key];
});
var $f93777e5d06f06cc$exports = {};

$parcel$export($f93777e5d06f06cc$exports, "__esModule", function () { return $f93777e5d06f06cc$export$1e511d4a378977f5; }, function (v) { return $f93777e5d06f06cc$export$1e511d4a378977f5 = v; });
$parcel$export($f93777e5d06f06cc$exports, "Home", function () { return $f93777e5d06f06cc$export$b94310965bed44e6; }, function (v) { return $f93777e5d06f06cc$export$b94310965bed44e6 = v; });
var $f93777e5d06f06cc$export$1e511d4a378977f5;
var $f93777e5d06f06cc$export$b94310965bed44e6;
"use strict";
$f93777e5d06f06cc$export$1e511d4a378977f5 = true;
$f93777e5d06f06cc$export$b94310965bed44e6 = void 0;

var $f93777e5d06f06cc$var$_react = $f93777e5d06f06cc$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f93777e5d06f06cc$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f93777e5d06f06cc$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f93777e5d06f06cc$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f93777e5d06f06cc$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f93777e5d06f06cc$var$_extends() {
    return $f93777e5d06f06cc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f93777e5d06f06cc$var$_extends.apply(null, arguments);
}
var $f93777e5d06f06cc$var$Home = $f93777e5d06f06cc$export$b94310965bed44e6 = /*#__PURE__*/ (0, $f93777e5d06f06cc$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f93777e5d06f06cc$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f93777e5d06f06cc$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Home"
    }, props), /*#__PURE__*/ $f93777e5d06f06cc$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m1 11 11-9 11 9m-8 12v-8H9v8m-5 0V9m16 14V9"
    }));
});
$f93777e5d06f06cc$var$Home.displayName = 'Home';


Object.keys($f93777e5d06f06cc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f93777e5d06f06cc$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f93777e5d06f06cc$exports[key];
});
var $df1daf7a32caebfb$exports = {};

$parcel$export($df1daf7a32caebfb$exports, "__esModule", function () { return $df1daf7a32caebfb$export$1e511d4a378977f5; }, function (v) { return $df1daf7a32caebfb$export$1e511d4a378977f5 = v; });
$parcel$export($df1daf7a32caebfb$exports, "Horton", function () { return $df1daf7a32caebfb$export$6365629d86cf9546; }, function (v) { return $df1daf7a32caebfb$export$6365629d86cf9546 = v; });
var $df1daf7a32caebfb$export$1e511d4a378977f5;
var $df1daf7a32caebfb$export$6365629d86cf9546;
"use strict";
$df1daf7a32caebfb$export$1e511d4a378977f5 = true;
$df1daf7a32caebfb$export$6365629d86cf9546 = void 0;

var $df1daf7a32caebfb$var$_react = $df1daf7a32caebfb$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $df1daf7a32caebfb$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($df1daf7a32caebfb$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $df1daf7a32caebfb$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $df1daf7a32caebfb$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $df1daf7a32caebfb$var$_extends() {
    return $df1daf7a32caebfb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $df1daf7a32caebfb$var$_extends.apply(null, arguments);
}
var $df1daf7a32caebfb$var$Horton = $df1daf7a32caebfb$export$6365629d86cf9546 = /*#__PURE__*/ (0, $df1daf7a32caebfb$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $df1daf7a32caebfb$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $df1daf7a32caebfb$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Horton"
    }, props), /*#__PURE__*/ $df1daf7a32caebfb$var$_react["default"].createElement("path", {
        fill: "#89BA4E",
        fillRule: "evenodd",
        d: "M2.3 12.977h-.157c-.319.989-.755 1.957-.932 2.97-.222 1.292-.238 2.624-.34 3.936-.027.339.126.517.465.52 1.526.02 1.352.081 1.602-1.198.017-.089.029-.178.057-.267.52-1.658.545-3.285-.27-4.875-.178-.344-.283-.723-.424-1.086zm16.606-5.922a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0zm2.176 2.737c.206.44.153 1.021.15 1.538-.005.924-.057 1.849-.098 2.773a609.04 609.04 0 0 1-.125 2.922c-.577-.355-1.037-.605-1.457-.908-.141-.1-.242-.335-.254-.517-.097-1.097-.194-2.2-.226-3.301-.017-.695-.202-1.207-.925-1.405-.383-.1-.58-.367-.726-.735-.614-1.525-1.251-3.047-1.93-4.686 1.163.214 2.237.388 3.298.618.19.04.375.278.488.472.622 1.066 1.276 2.115 1.805 3.23zm.569 7.225c0 .016.016.028.04.08.771.057 1.615.352 2.172-.718-.364-.105-.686-.201-1.01-.286-1.202-.315-1.202-.315-1.202.924zm-6.3-3.205c-.098-.347-.271-.496-.63-.549-.436-.068-.933-.117-1.272-.359-1.497-1.086-2.942-2.244-4.424-3.354-.4-.303-.496-.618-.33-1.082.245-.694.455-1.4.718-2.208-.226.025-.331.029-.432.049-1.308.29-2.604.646-3.928.86-.86.14-1.38.577-1.9 1.25C1.888 10.055.92 11.79.564 13.85c-.13.754-.371 1.489-.565 2.232.06.04.125.08.186.12.125-.144.302-.27.367-.435.404-1.09.779-2.188 1.175-3.278.205-.565.387-.61.762-.129.243.307.465.658.594 1.021.69 1.95 1.352 3.908 2.026 5.861.408 1.19.412 1.17 1.683 1.175.48 0 .654-.17.614-.638-.085-1.013-.138-2.026-.23-3.035-.045-.517.185-.755.662-.884 1.174-.315 2.34-.654 3.507-.99.735-.205.807-.18 1.17.473.764 1.36 1.563 2.704 2.261 4.101.38.767.884 1.062 1.715.973.61-.065.658-.073.493-.682-.545-1.974-1.102-3.948-1.635-5.922zm-.118-7.54c-.38-1.04-.928-1.61-2.054-1.719-.719-.069-1.417-.36-2.128-.553h-.217c-.097.214-.214.42-.287.638-.408 1.223-.787 2.454-1.207 3.669-.157.452-.056.742.327 1.021 1.062.787 2.127 1.578 3.148 2.422 1.635.989 2.24.989 2.975.985.735-.004 1.32 0 2.059 0-.093-.263-.15-.448-.222-.626-.808-1.941-1.68-3.859-2.394-5.837zm-3.786 9.18c-.287.035-.658.052-.682.536-.053 1.082-.15 2.163-.234 3.354.02.25-.073.78.113.912.274.19.759.154 1.138.101.153-.02.34-.307.392-.508.14-.521.153-1.082.327-1.59.318-.945.12-1.777-.453-2.531-.12-.162-.411-.3-.601-.275zM24 15.725c-.093-.566-.145-1.082-.274-1.579-.033-.125-.291-.238-.46-.258-.11-.016-.32.113-.36.222-.286.75.19 1.506 1.094 1.615z"
    }));
});
$df1daf7a32caebfb$var$Horton.displayName = 'Horton';


Object.keys($df1daf7a32caebfb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $df1daf7a32caebfb$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $df1daf7a32caebfb$exports[key];
});
var $8d14697276de7220$exports = {};

$parcel$export($8d14697276de7220$exports, "__esModule", function () { return $8d14697276de7220$export$1e511d4a378977f5; }, function (v) { return $8d14697276de7220$export$1e511d4a378977f5 = v; });
$parcel$export($8d14697276de7220$exports, "HostMaintenance", function () { return $8d14697276de7220$export$be60a531b4a278e; }, function (v) { return $8d14697276de7220$export$be60a531b4a278e = v; });
var $8d14697276de7220$export$1e511d4a378977f5;
var $8d14697276de7220$export$be60a531b4a278e;
"use strict";
$8d14697276de7220$export$1e511d4a378977f5 = true;
$8d14697276de7220$export$be60a531b4a278e = void 0;

var $8d14697276de7220$var$_react = $8d14697276de7220$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $8d14697276de7220$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8d14697276de7220$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8d14697276de7220$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $8d14697276de7220$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8d14697276de7220$var$_extends() {
    return $8d14697276de7220$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8d14697276de7220$var$_extends.apply(null, arguments);
}
var $8d14697276de7220$var$HostMaintenance = $8d14697276de7220$export$be60a531b4a278e = /*#__PURE__*/ (0, $8d14697276de7220$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $8d14697276de7220$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $8d14697276de7220$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "HostMaintenance"
    }, props), /*#__PURE__*/ $8d14697276de7220$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m14 23 6-6m1-3a2 2 0 1 0 2 2M17 4h1v1h-1V4zm-7 19H3V1h18v10M3 13h14M3 18h10M3 8h18"
    }));
});
$8d14697276de7220$var$HostMaintenance.displayName = 'HostMaintenance';


Object.keys($8d14697276de7220$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $8d14697276de7220$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $8d14697276de7220$exports[key];
});
var $f107ac3754a94c2f$exports = {};

$parcel$export($f107ac3754a94c2f$exports, "__esModule", function () { return $f107ac3754a94c2f$export$1e511d4a378977f5; }, function (v) { return $f107ac3754a94c2f$export$1e511d4a378977f5 = v; });
$parcel$export($f107ac3754a94c2f$exports, "Host", function () { return $f107ac3754a94c2f$export$5d2c872882e2b878; }, function (v) { return $f107ac3754a94c2f$export$5d2c872882e2b878 = v; });
var $f107ac3754a94c2f$export$1e511d4a378977f5;
var $f107ac3754a94c2f$export$5d2c872882e2b878;
"use strict";
$f107ac3754a94c2f$export$1e511d4a378977f5 = true;
$f107ac3754a94c2f$export$5d2c872882e2b878 = void 0;

var $f107ac3754a94c2f$var$_react = $f107ac3754a94c2f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f107ac3754a94c2f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f107ac3754a94c2f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f107ac3754a94c2f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f107ac3754a94c2f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f107ac3754a94c2f$var$_extends() {
    return $f107ac3754a94c2f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f107ac3754a94c2f$var$_extends.apply(null, arguments);
}
var $f107ac3754a94c2f$var$Host = $f107ac3754a94c2f$export$5d2c872882e2b878 = /*#__PURE__*/ (0, $f107ac3754a94c2f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f107ac3754a94c2f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f107ac3754a94c2f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Host"
    }, props), /*#__PURE__*/ $f107ac3754a94c2f$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M17 4h1v1h-1V4zM3 1h18v22H3V1zm0 12h18H3zm0 5h18H3zM3 8h18H3z"
    }));
});
$f107ac3754a94c2f$var$Host.displayName = 'Host';


Object.keys($f107ac3754a94c2f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f107ac3754a94c2f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f107ac3754a94c2f$exports[key];
});
var $56ffc0f5d8206b8f$exports = {};

$parcel$export($56ffc0f5d8206b8f$exports, "__esModule", function () { return $56ffc0f5d8206b8f$export$1e511d4a378977f5; }, function (v) { return $56ffc0f5d8206b8f$export$1e511d4a378977f5 = v; });
$parcel$export($56ffc0f5d8206b8f$exports, "Hp", function () { return $56ffc0f5d8206b8f$export$d6b81f59cdb268dc; }, function (v) { return $56ffc0f5d8206b8f$export$d6b81f59cdb268dc = v; });
var $56ffc0f5d8206b8f$export$1e511d4a378977f5;
var $56ffc0f5d8206b8f$export$d6b81f59cdb268dc;
"use strict";
$56ffc0f5d8206b8f$export$1e511d4a378977f5 = true;
$56ffc0f5d8206b8f$export$d6b81f59cdb268dc = void 0;

var $56ffc0f5d8206b8f$var$_react = $56ffc0f5d8206b8f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $56ffc0f5d8206b8f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($56ffc0f5d8206b8f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $56ffc0f5d8206b8f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $56ffc0f5d8206b8f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $56ffc0f5d8206b8f$var$_extends() {
    return $56ffc0f5d8206b8f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $56ffc0f5d8206b8f$var$_extends.apply(null, arguments);
}
var $56ffc0f5d8206b8f$var$Hp = $56ffc0f5d8206b8f$export$d6b81f59cdb268dc = /*#__PURE__*/ (0, $56ffc0f5d8206b8f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $56ffc0f5d8206b8f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $56ffc0f5d8206b8f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Hp"
    }, props), /*#__PURE__*/ $56ffc0f5d8206b8f$var$_react["default"].createElement("path", {
        fill: "#333",
        fillRule: "evenodd",
        d: "M8.421 0 5 15.127h2.138L10.56 0H8.421zm8.993 8.873-1.496 6.225h2.138l1.496-6.225h-2.138zm-3.635 0L10.36 24h2.138l3.42-15.127H13.78zm-3.647 0-1.497 6.225h2.138l1.496-6.225h-2.137z"
    }));
});
$56ffc0f5d8206b8f$var$Hp.displayName = 'Hp';


Object.keys($56ffc0f5d8206b8f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $56ffc0f5d8206b8f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $56ffc0f5d8206b8f$exports[key];
});
var $5071cc1031a4c98c$exports = {};

$parcel$export($5071cc1031a4c98c$exports, "__esModule", function () { return $5071cc1031a4c98c$export$1e511d4a378977f5; }, function (v) { return $5071cc1031a4c98c$export$1e511d4a378977f5 = v; });
$parcel$export($5071cc1031a4c98c$exports, "HpeLabs", function () { return $5071cc1031a4c98c$export$db4253a923049ff0; }, function (v) { return $5071cc1031a4c98c$export$db4253a923049ff0 = v; });
var $5071cc1031a4c98c$export$1e511d4a378977f5;
var $5071cc1031a4c98c$export$db4253a923049ff0;
"use strict";
$5071cc1031a4c98c$export$1e511d4a378977f5 = true;
$5071cc1031a4c98c$export$db4253a923049ff0 = void 0;

var $5071cc1031a4c98c$var$_react = $5071cc1031a4c98c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5071cc1031a4c98c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5071cc1031a4c98c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5071cc1031a4c98c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5071cc1031a4c98c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5071cc1031a4c98c$var$_extends() {
    return $5071cc1031a4c98c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5071cc1031a4c98c$var$_extends.apply(null, arguments);
}
var $5071cc1031a4c98c$var$HpeLabs = $5071cc1031a4c98c$export$db4253a923049ff0 = /*#__PURE__*/ (0, $5071cc1031a4c98c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5071cc1031a4c98c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5071cc1031a4c98c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "HpeLabs"
    }, props), /*#__PURE__*/ $5071cc1031a4c98c$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#01A982",
        strokeWidth: "2",
        d: "M14 23H5V2h12v13h-4V6H9v13h11"
    }));
});
$5071cc1031a4c98c$var$HpeLabs.displayName = 'HpeLabs';


Object.keys($5071cc1031a4c98c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5071cc1031a4c98c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5071cc1031a4c98c$exports[key];
});
var $0c9b0f03c476f37a$exports = {};

$parcel$export($0c9b0f03c476f37a$exports, "__esModule", function () { return $0c9b0f03c476f37a$export$1e511d4a378977f5; }, function (v) { return $0c9b0f03c476f37a$export$1e511d4a378977f5 = v; });
$parcel$export($0c9b0f03c476f37a$exports, "Hpe", function () { return $0c9b0f03c476f37a$export$a7615a44cbe1275; }, function (v) { return $0c9b0f03c476f37a$export$a7615a44cbe1275 = v; });
var $0c9b0f03c476f37a$export$1e511d4a378977f5;
var $0c9b0f03c476f37a$export$a7615a44cbe1275;
"use strict";
$0c9b0f03c476f37a$export$1e511d4a378977f5 = true;
$0c9b0f03c476f37a$export$a7615a44cbe1275 = void 0;

var $0c9b0f03c476f37a$var$_react = $0c9b0f03c476f37a$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0c9b0f03c476f37a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0c9b0f03c476f37a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0c9b0f03c476f37a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0c9b0f03c476f37a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0c9b0f03c476f37a$var$_extends() {
    return $0c9b0f03c476f37a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0c9b0f03c476f37a$var$_extends.apply(null, arguments);
}
var $0c9b0f03c476f37a$var$Hpe = $0c9b0f03c476f37a$export$a7615a44cbe1275 = /*#__PURE__*/ (0, $0c9b0f03c476f37a$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0c9b0f03c476f37a$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0c9b0f03c476f37a$var$_extends({
        ref: ref,
        viewBox: "0 0 48 24",
        a11yTitle: "Hpe"
    }, props), /*#__PURE__*/ $0c9b0f03c476f37a$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 6h44v12H2V6zm3 3h38v6H5V9z",
        fill: "#00C781"
    }));
});
$0c9b0f03c476f37a$var$Hpe.displayName = 'Hpe';


Object.keys($0c9b0f03c476f37a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0c9b0f03c476f37a$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0c9b0f03c476f37a$exports[key];
});
var $6dfee57d40159787$exports = {};

$parcel$export($6dfee57d40159787$exports, "__esModule", function () { return $6dfee57d40159787$export$1e511d4a378977f5; }, function (v) { return $6dfee57d40159787$export$1e511d4a378977f5 = v; });
$parcel$export($6dfee57d40159787$exports, "Hpi", function () { return $6dfee57d40159787$export$7e6645668f4b8ce7; }, function (v) { return $6dfee57d40159787$export$7e6645668f4b8ce7 = v; });
var $6dfee57d40159787$export$1e511d4a378977f5;
var $6dfee57d40159787$export$7e6645668f4b8ce7;
"use strict";
$6dfee57d40159787$export$1e511d4a378977f5 = true;
$6dfee57d40159787$export$7e6645668f4b8ce7 = void 0;

var $6dfee57d40159787$var$_react = $6dfee57d40159787$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $6dfee57d40159787$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6dfee57d40159787$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6dfee57d40159787$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6dfee57d40159787$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6dfee57d40159787$var$_extends() {
    return $6dfee57d40159787$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6dfee57d40159787$var$_extends.apply(null, arguments);
}
var $6dfee57d40159787$var$Hpi = $6dfee57d40159787$export$7e6645668f4b8ce7 = /*#__PURE__*/ (0, $6dfee57d40159787$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $6dfee57d40159787$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $6dfee57d40159787$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Hpi"
    }, props), /*#__PURE__*/ $6dfee57d40159787$var$_react["default"].createElement("path", {
        fill: "#0096D6",
        fillRule: "evenodd",
        d: "M15.793 15.333a.5.5 0 0 0 .442-.315l2.196-6.37c.06-.173-.04-.315-.225-.315h-1a.502.502 0 0 0-.443.315l-2.206 6.37c-.06.174.041.315.225.315h1.01zM24 12c0 6.627-5.373 12-12 12-.183 0-.36-.02-.542-.027l2.42-6.991a.503.503 0 0 1 .443-.315H16c2.607 0 2.631-.865 2.906-1.66.642-1.862 1.75-5.073 1.964-5.701C21.178 8.41 21.28 7 19.001 7H15a.504.504 0 0 0-.443.315L8.925 23.587C3.79 22.227 0 17.562 0 12 0 6.694 3.448 2.2 8.223.615L2.776 16.351c-.06.174.04.316.224.316h2a.503.503 0 0 0 .443-.316l2.666-7.703a.501.501 0 0 1 .442-.315h.989c.183 0 .284.142.224.315l-2.656 7.703c-.059.174.042.316.225.316h2a.501.501 0 0 0 .442-.316l2.427-7.036C12.765 7.682 12.312 7 10.346 7H9.013c-.183 0-.284-.142-.224-.315L11.086.046C11.39.023 11.691 0 12 0c6.627 0 12 5.373 12 12z"
    }));
});
$6dfee57d40159787$var$Hpi.displayName = 'Hpi';


Object.keys($6dfee57d40159787$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $6dfee57d40159787$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $6dfee57d40159787$exports[key];
});
var $8f9375b2df7ef041$exports = {};

$parcel$export($8f9375b2df7ef041$exports, "__esModule", function () { return $8f9375b2df7ef041$export$1e511d4a378977f5; }, function (v) { return $8f9375b2df7ef041$export$1e511d4a378977f5 = v; });
$parcel$export($8f9375b2df7ef041$exports, "Html5", function () { return $8f9375b2df7ef041$export$3cf7c2a12a5b8694; }, function (v) { return $8f9375b2df7ef041$export$3cf7c2a12a5b8694 = v; });
var $8f9375b2df7ef041$export$1e511d4a378977f5;
var $8f9375b2df7ef041$export$3cf7c2a12a5b8694;
"use strict";
$8f9375b2df7ef041$export$1e511d4a378977f5 = true;
$8f9375b2df7ef041$export$3cf7c2a12a5b8694 = void 0;

var $8f9375b2df7ef041$var$_react = $8f9375b2df7ef041$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $8f9375b2df7ef041$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8f9375b2df7ef041$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8f9375b2df7ef041$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $8f9375b2df7ef041$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8f9375b2df7ef041$var$_extends() {
    return $8f9375b2df7ef041$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8f9375b2df7ef041$var$_extends.apply(null, arguments);
}
var $8f9375b2df7ef041$var$Html5 = $8f9375b2df7ef041$export$3cf7c2a12a5b8694 = /*#__PURE__*/ (0, $8f9375b2df7ef041$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $8f9375b2df7ef041$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $8f9375b2df7ef041$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Html5"
    }, props), /*#__PURE__*/ $8f9375b2df7ef041$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M3 2h18v16l-9 4-9-4V2zm14 4H8v5h8v5l-4 1.5L8 16v-2"
    }));
});
$8f9375b2df7ef041$var$Html5.displayName = 'Html5';


Object.keys($8f9375b2df7ef041$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $8f9375b2df7ef041$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $8f9375b2df7ef041$exports[key];
});
var $3021bc2615be9f97$exports = {};

$parcel$export($3021bc2615be9f97$exports, "__esModule", function () { return $3021bc2615be9f97$export$1e511d4a378977f5; }, function (v) { return $3021bc2615be9f97$export$1e511d4a378977f5 = v; });
$parcel$export($3021bc2615be9f97$exports, "IceCream", function () { return $3021bc2615be9f97$export$3e98347679d84c37; }, function (v) { return $3021bc2615be9f97$export$3e98347679d84c37 = v; });
var $3021bc2615be9f97$export$1e511d4a378977f5;
var $3021bc2615be9f97$export$3e98347679d84c37;
"use strict";
$3021bc2615be9f97$export$1e511d4a378977f5 = true;
$3021bc2615be9f97$export$3e98347679d84c37 = void 0;

var $3021bc2615be9f97$var$_react = $3021bc2615be9f97$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $3021bc2615be9f97$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3021bc2615be9f97$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3021bc2615be9f97$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3021bc2615be9f97$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3021bc2615be9f97$var$_extends() {
    return $3021bc2615be9f97$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3021bc2615be9f97$var$_extends.apply(null, arguments);
}
var $3021bc2615be9f97$var$IceCream = $3021bc2615be9f97$export$3e98347679d84c37 = /*#__PURE__*/ (0, $3021bc2615be9f97$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3021bc2615be9f97$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3021bc2615be9f97$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "IceCream"
    }, props), /*#__PURE__*/ $3021bc2615be9f97$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M17 8c2 0 2-1.5.5-1.5 0-3-2-5.5-5.5-5.5S6.5 3.5 6.5 6.5C5 6.5 5 8 7 8m0 0h10l-5 13L7 8z"
    }));
});
$3021bc2615be9f97$var$IceCream.displayName = 'IceCream';


Object.keys($3021bc2615be9f97$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3021bc2615be9f97$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3021bc2615be9f97$exports[key];
});
var $642977a3d774af03$exports = {};

$parcel$export($642977a3d774af03$exports, "__esModule", function () { return $642977a3d774af03$export$1e511d4a378977f5; }, function (v) { return $642977a3d774af03$export$1e511d4a378977f5 = v; });
$parcel$export($642977a3d774af03$exports, "Image", function () { return $642977a3d774af03$export$3e431a229df88919; }, function (v) { return $642977a3d774af03$export$3e431a229df88919 = v; });
var $642977a3d774af03$export$1e511d4a378977f5;
var $642977a3d774af03$export$3e431a229df88919;
"use strict";
$642977a3d774af03$export$1e511d4a378977f5 = true;
$642977a3d774af03$export$3e431a229df88919 = void 0;

var $642977a3d774af03$var$_react = $642977a3d774af03$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $642977a3d774af03$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($642977a3d774af03$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $642977a3d774af03$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $642977a3d774af03$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $642977a3d774af03$var$_extends() {
    return $642977a3d774af03$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $642977a3d774af03$var$_extends.apply(null, arguments);
}
var $642977a3d774af03$var$Image = $642977a3d774af03$export$3e431a229df88919 = /*#__PURE__*/ (0, $642977a3d774af03$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $642977a3d774af03$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $642977a3d774af03$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Image"
    }, props), /*#__PURE__*/ $642977a3d774af03$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 3h22v18H1V3zm5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm17 6-5-6-6 7-3-3-8 8"
    }));
});
$642977a3d774af03$var$Image.displayName = 'Image';


Object.keys($642977a3d774af03$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $642977a3d774af03$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $642977a3d774af03$exports[key];
});
var $7ad35c44db7ab2ed$exports = {};

$parcel$export($7ad35c44db7ab2ed$exports, "__esModule", function () { return $7ad35c44db7ab2ed$export$1e511d4a378977f5; }, function (v) { return $7ad35c44db7ab2ed$export$1e511d4a378977f5 = v; });
$parcel$export($7ad35c44db7ab2ed$exports, "Impact", function () { return $7ad35c44db7ab2ed$export$eea6bc44018f25a8; }, function (v) { return $7ad35c44db7ab2ed$export$eea6bc44018f25a8 = v; });
var $7ad35c44db7ab2ed$export$1e511d4a378977f5;
var $7ad35c44db7ab2ed$export$eea6bc44018f25a8;
"use strict";
$7ad35c44db7ab2ed$export$1e511d4a378977f5 = true;
$7ad35c44db7ab2ed$export$eea6bc44018f25a8 = void 0;

var $7ad35c44db7ab2ed$var$_react = $7ad35c44db7ab2ed$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $7ad35c44db7ab2ed$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7ad35c44db7ab2ed$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7ad35c44db7ab2ed$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $7ad35c44db7ab2ed$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7ad35c44db7ab2ed$var$_extends() {
    return $7ad35c44db7ab2ed$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7ad35c44db7ab2ed$var$_extends.apply(null, arguments);
}
var $7ad35c44db7ab2ed$var$Impact = $7ad35c44db7ab2ed$export$eea6bc44018f25a8 = /*#__PURE__*/ (0, $7ad35c44db7ab2ed$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $7ad35c44db7ab2ed$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $7ad35c44db7ab2ed$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Impact"
    }, props), /*#__PURE__*/ $7ad35c44db7ab2ed$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m13 2 9 4v11l-9 5V2zm9 4-9 5 9-5zM9 22V2v20zm0-10L3 5l6 7zm0 0H1h8zm0 0-6 7 6-7z"
    }));
});
$7ad35c44db7ab2ed$var$Impact.displayName = 'Impact';


Object.keys($7ad35c44db7ab2ed$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $7ad35c44db7ab2ed$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $7ad35c44db7ab2ed$exports[key];
});
var $5a7cc6021213453f$exports = {};

$parcel$export($5a7cc6021213453f$exports, "__esModule", function () { return $5a7cc6021213453f$export$1e511d4a378977f5; }, function (v) { return $5a7cc6021213453f$export$1e511d4a378977f5 = v; });
$parcel$export($5a7cc6021213453f$exports, "InProgress", function () { return $5a7cc6021213453f$export$e4563dc022bb8e8d; }, function (v) { return $5a7cc6021213453f$export$e4563dc022bb8e8d = v; });
var $5a7cc6021213453f$export$1e511d4a378977f5;
var $5a7cc6021213453f$export$e4563dc022bb8e8d;
"use strict";
$5a7cc6021213453f$export$1e511d4a378977f5 = true;
$5a7cc6021213453f$export$e4563dc022bb8e8d = void 0;

var $5a7cc6021213453f$var$_react = $5a7cc6021213453f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5a7cc6021213453f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5a7cc6021213453f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5a7cc6021213453f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5a7cc6021213453f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5a7cc6021213453f$var$_extends() {
    return $5a7cc6021213453f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5a7cc6021213453f$var$_extends.apply(null, arguments);
}
var $5a7cc6021213453f$var$InProgress = $5a7cc6021213453f$export$e4563dc022bb8e8d = /*#__PURE__*/ (0, $5a7cc6021213453f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5a7cc6021213453f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5a7cc6021213453f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "InProgress"
    }, props), /*#__PURE__*/ $5a7cc6021213453f$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 1h22M10 4.5h4V6c0 1-2 2-2 2s-2-1-2-2V4.5zM5 1v5c0 3 5 3.235 5 6s-5 3-5 6v5M19 1v5c0 3-5 3.235-5 6s5 3 5 6v5M1 23h22M8 21c0-2 4-4 4-4s4 2 4 4v2H8v-2z"
    }));
});
$5a7cc6021213453f$var$InProgress.displayName = 'InProgress';


Object.keys($5a7cc6021213453f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5a7cc6021213453f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5a7cc6021213453f$exports[key];
});
var $58c13d25451ae801$exports = {};

$parcel$export($58c13d25451ae801$exports, "__esModule", function () { return $58c13d25451ae801$export$1e511d4a378977f5; }, function (v) { return $58c13d25451ae801$export$1e511d4a378977f5 = v; });
$parcel$export($58c13d25451ae801$exports, "Inbox", function () { return $58c13d25451ae801$export$9f6ccca23639b351; }, function (v) { return $58c13d25451ae801$export$9f6ccca23639b351 = v; });
var $58c13d25451ae801$export$1e511d4a378977f5;
var $58c13d25451ae801$export$9f6ccca23639b351;
"use strict";
$58c13d25451ae801$export$1e511d4a378977f5 = true;
$58c13d25451ae801$export$9f6ccca23639b351 = void 0;

var $58c13d25451ae801$var$_react = $58c13d25451ae801$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $58c13d25451ae801$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($58c13d25451ae801$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $58c13d25451ae801$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $58c13d25451ae801$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $58c13d25451ae801$var$_extends() {
    return $58c13d25451ae801$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $58c13d25451ae801$var$_extends.apply(null, arguments);
}
var $58c13d25451ae801$var$Inbox = $58c13d25451ae801$export$9f6ccca23639b351 = /*#__PURE__*/ (0, $58c13d25451ae801$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $58c13d25451ae801$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $58c13d25451ae801$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Inbox"
    }, props), /*#__PURE__*/ $58c13d25451ae801$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 13 6 2h12l5 11v9H1v-9zm0 0h7v3h8v-3h7"
    }));
});
$58c13d25451ae801$var$Inbox.displayName = 'Inbox';


Object.keys($58c13d25451ae801$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $58c13d25451ae801$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $58c13d25451ae801$exports[key];
});
var $7eb4f75c65ff11ac$exports = {};

$parcel$export($7eb4f75c65ff11ac$exports, "__esModule", function () { return $7eb4f75c65ff11ac$export$1e511d4a378977f5; }, function (v) { return $7eb4f75c65ff11ac$export$1e511d4a378977f5 = v; });
$parcel$export($7eb4f75c65ff11ac$exports, "Indicator", function () { return $7eb4f75c65ff11ac$export$adb584737d712b70; }, function (v) { return $7eb4f75c65ff11ac$export$adb584737d712b70 = v; });
var $7eb4f75c65ff11ac$export$1e511d4a378977f5;
var $7eb4f75c65ff11ac$export$adb584737d712b70;
"use strict";
$7eb4f75c65ff11ac$export$1e511d4a378977f5 = true;
$7eb4f75c65ff11ac$export$adb584737d712b70 = void 0;

var $7eb4f75c65ff11ac$var$_react = $7eb4f75c65ff11ac$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $7eb4f75c65ff11ac$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7eb4f75c65ff11ac$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7eb4f75c65ff11ac$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $7eb4f75c65ff11ac$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7eb4f75c65ff11ac$var$_extends() {
    return $7eb4f75c65ff11ac$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7eb4f75c65ff11ac$var$_extends.apply(null, arguments);
}
var $7eb4f75c65ff11ac$var$Indicator = $7eb4f75c65ff11ac$export$adb584737d712b70 = /*#__PURE__*/ (0, $7eb4f75c65ff11ac$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $7eb4f75c65ff11ac$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $7eb4f75c65ff11ac$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Indicator"
    }, props), /*#__PURE__*/ $7eb4f75c65ff11ac$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm7-3A7 7 0 0 0 5 8c0 1.933.5 3 2 5s3 3.5 3 6v4h4v-4c0-2.5 1.5-4 3-6s2-3.067 2-5z"
    }));
});
$7eb4f75c65ff11ac$var$Indicator.displayName = 'Indicator';


Object.keys($7eb4f75c65ff11ac$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $7eb4f75c65ff11ac$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $7eb4f75c65ff11ac$exports[key];
});
var $51175dc2359d64fc$exports = {};

$parcel$export($51175dc2359d64fc$exports, "__esModule", function () { return $51175dc2359d64fc$export$1e511d4a378977f5; }, function (v) { return $51175dc2359d64fc$export$1e511d4a378977f5 = v; });
$parcel$export($51175dc2359d64fc$exports, "Info", function () { return $51175dc2359d64fc$export$c4868e4a24d48fad; }, function (v) { return $51175dc2359d64fc$export$c4868e4a24d48fad = v; });
var $51175dc2359d64fc$export$1e511d4a378977f5;
var $51175dc2359d64fc$export$c4868e4a24d48fad;
"use strict";
$51175dc2359d64fc$export$1e511d4a378977f5 = true;
$51175dc2359d64fc$export$c4868e4a24d48fad = void 0;

var $51175dc2359d64fc$var$_react = $51175dc2359d64fc$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $51175dc2359d64fc$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($51175dc2359d64fc$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $51175dc2359d64fc$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $51175dc2359d64fc$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $51175dc2359d64fc$var$_extends() {
    return $51175dc2359d64fc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $51175dc2359d64fc$var$_extends.apply(null, arguments);
}
var $51175dc2359d64fc$var$Info = $51175dc2359d64fc$export$c4868e4a24d48fad = /*#__PURE__*/ (0, $51175dc2359d64fc$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $51175dc2359d64fc$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $51175dc2359d64fc$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Info"
    }, props), /*#__PURE__*/ $51175dc2359d64fc$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M15 17c0-3 4-5 4-9s-3-7-7-7-7 3-7 7 4 6 4 9v3c0 2 1 3 3 3s3-1 3-3v-3zm-6 1h6"
    }));
});
$51175dc2359d64fc$var$Info.displayName = 'Info';


Object.keys($51175dc2359d64fc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $51175dc2359d64fc$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $51175dc2359d64fc$exports[key];
});
var $24a5d2c58d75e80a$exports = {};

$parcel$export($24a5d2c58d75e80a$exports, "__esModule", function () { return $24a5d2c58d75e80a$export$1e511d4a378977f5; }, function (v) { return $24a5d2c58d75e80a$export$1e511d4a378977f5 = v; });
$parcel$export($24a5d2c58d75e80a$exports, "Inherit", function () { return $24a5d2c58d75e80a$export$90bfc659784fb526; }, function (v) { return $24a5d2c58d75e80a$export$90bfc659784fb526 = v; });
var $24a5d2c58d75e80a$export$1e511d4a378977f5;
var $24a5d2c58d75e80a$export$90bfc659784fb526;
"use strict";
$24a5d2c58d75e80a$export$1e511d4a378977f5 = true;
$24a5d2c58d75e80a$export$90bfc659784fb526 = void 0;

var $24a5d2c58d75e80a$var$_react = $24a5d2c58d75e80a$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $24a5d2c58d75e80a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($24a5d2c58d75e80a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $24a5d2c58d75e80a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $24a5d2c58d75e80a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $24a5d2c58d75e80a$var$_extends() {
    return $24a5d2c58d75e80a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $24a5d2c58d75e80a$var$_extends.apply(null, arguments);
}
var $24a5d2c58d75e80a$var$Inherit = $24a5d2c58d75e80a$export$90bfc659784fb526 = /*#__PURE__*/ (0, $24a5d2c58d75e80a$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $24a5d2c58d75e80a$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $24a5d2c58d75e80a$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Inherit"
    }, props), /*#__PURE__*/ $24a5d2c58d75e80a$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#231F20",
        strokeWidth: "2",
        d: "m17 18-5-3 5 3zM7 18l5-3v-4m5 9a3 3 0 1 0 6 0 3 3 0 0 0-6 0zM4 17a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM17 6a5 5 0 1 1-10.001-.001A5 5 0 0 1 17 6z"
    }));
});
$24a5d2c58d75e80a$var$Inherit.displayName = 'Inherit';


Object.keys($24a5d2c58d75e80a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $24a5d2c58d75e80a$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $24a5d2c58d75e80a$exports[key];
});
var $2cd6d26d08e1ccfb$exports = {};

$parcel$export($2cd6d26d08e1ccfb$exports, "__esModule", function () { return $2cd6d26d08e1ccfb$export$1e511d4a378977f5; }, function (v) { return $2cd6d26d08e1ccfb$export$1e511d4a378977f5 = v; });
$parcel$export($2cd6d26d08e1ccfb$exports, "Insecure", function () { return $2cd6d26d08e1ccfb$export$2bea71771b154137; }, function (v) { return $2cd6d26d08e1ccfb$export$2bea71771b154137 = v; });
var $2cd6d26d08e1ccfb$export$1e511d4a378977f5;
var $2cd6d26d08e1ccfb$export$2bea71771b154137;
"use strict";
$2cd6d26d08e1ccfb$export$1e511d4a378977f5 = true;
$2cd6d26d08e1ccfb$export$2bea71771b154137 = void 0;

var $2cd6d26d08e1ccfb$var$_react = $2cd6d26d08e1ccfb$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $2cd6d26d08e1ccfb$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2cd6d26d08e1ccfb$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2cd6d26d08e1ccfb$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $2cd6d26d08e1ccfb$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $2cd6d26d08e1ccfb$var$_extends() {
    return $2cd6d26d08e1ccfb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2cd6d26d08e1ccfb$var$_extends.apply(null, arguments);
}
var $2cd6d26d08e1ccfb$var$Insecure = $2cd6d26d08e1ccfb$export$2bea71771b154137 = /*#__PURE__*/ (0, $2cd6d26d08e1ccfb$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $2cd6d26d08e1ccfb$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $2cd6d26d08e1ccfb$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Insecure"
    }, props), /*#__PURE__*/ $2cd6d26d08e1ccfb$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M7 6.919V6a4.724 4.724 0 0 1 5-5 4.724 4.724 0 0 1 5 5v5.052M12 23a7 7 0 1 0-7-7 7 7 0 0 0 7 7zm2.985-7h-5.97"
    }));
});
$2cd6d26d08e1ccfb$var$Insecure.displayName = 'Insecure';


Object.keys($2cd6d26d08e1ccfb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $2cd6d26d08e1ccfb$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $2cd6d26d08e1ccfb$exports[key];
});
var $79f49524bced2a6c$exports = {};

$parcel$export($79f49524bced2a6c$exports, "__esModule", function () { return $79f49524bced2a6c$export$1e511d4a378977f5; }, function (v) { return $79f49524bced2a6c$export$1e511d4a378977f5 = v; });
$parcel$export($79f49524bced2a6c$exports, "Inspect", function () { return $79f49524bced2a6c$export$d1a121333e17a5bb; }, function (v) { return $79f49524bced2a6c$export$d1a121333e17a5bb = v; });
var $79f49524bced2a6c$export$1e511d4a378977f5;
var $79f49524bced2a6c$export$d1a121333e17a5bb;
"use strict";
$79f49524bced2a6c$export$1e511d4a378977f5 = true;
$79f49524bced2a6c$export$d1a121333e17a5bb = void 0;

var $79f49524bced2a6c$var$_react = $79f49524bced2a6c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $79f49524bced2a6c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($79f49524bced2a6c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $79f49524bced2a6c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $79f49524bced2a6c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $79f49524bced2a6c$var$_extends() {
    return $79f49524bced2a6c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $79f49524bced2a6c$var$_extends.apply(null, arguments);
}
var $79f49524bced2a6c$var$Inspect = $79f49524bced2a6c$export$d1a121333e17a5bb = /*#__PURE__*/ (0, $79f49524bced2a6c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $79f49524bced2a6c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $79f49524bced2a6c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Inspect"
    }, props), /*#__PURE__*/ $79f49524bced2a6c$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M5.5 21a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zM1 16V6.5A4.5 4.5 0 0 1 5.5 2H6m17 14V6.5A4.5 4.5 0 0 0 18.5 2H18m.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zM10 17s0-2 2-2 2 2 2 2"
    }));
});
$79f49524bced2a6c$var$Inspect.displayName = 'Inspect';


Object.keys($79f49524bced2a6c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $79f49524bced2a6c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $79f49524bced2a6c$exports[key];
});
var $c1d5abee002f6150$exports = {};

$parcel$export($c1d5abee002f6150$exports, "__esModule", function () { return $c1d5abee002f6150$export$1e511d4a378977f5; }, function (v) { return $c1d5abee002f6150$export$1e511d4a378977f5 = v; });
$parcel$export($c1d5abee002f6150$exports, "Instagram", function () { return $c1d5abee002f6150$export$6afe72be63c708bc; }, function (v) { return $c1d5abee002f6150$export$6afe72be63c708bc = v; });
var $c1d5abee002f6150$export$1e511d4a378977f5;
var $c1d5abee002f6150$export$6afe72be63c708bc;
"use strict";
$c1d5abee002f6150$export$1e511d4a378977f5 = true;
$c1d5abee002f6150$export$6afe72be63c708bc = void 0;

var $c1d5abee002f6150$var$_react = $c1d5abee002f6150$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c1d5abee002f6150$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c1d5abee002f6150$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c1d5abee002f6150$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c1d5abee002f6150$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c1d5abee002f6150$var$_extends() {
    return $c1d5abee002f6150$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c1d5abee002f6150$var$_extends.apply(null, arguments);
}
var $c1d5abee002f6150$var$Instagram = $c1d5abee002f6150$export$6afe72be63c708bc = /*#__PURE__*/ (0, $c1d5abee002f6150$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c1d5abee002f6150$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c1d5abee002f6150$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Instagram"
    }, props), /*#__PURE__*/ $c1d5abee002f6150$var$_react["default"].createElement("path", {
        d: "M17.318.077c1.218.056 2.06.235 2.838.537a5.36 5.36 0 0 1 1.956 1.274 5.36 5.36 0 0 1 1.274 1.956c.302.779.481 1.62.537 2.838C23.992 8.192 24 8.724 24 12s-.008 3.808-.077 5.318c-.056 1.218-.235 2.06-.537 2.839a5.36 5.36 0 0 1-1.274 1.955 5.359 5.359 0 0 1-1.956 1.274c-.779.302-1.62.481-2.838.537-1.51.069-2.041.077-5.318.077-3.277 0-3.809-.008-5.318-.077-1.218-.056-2.06-.235-2.839-.537a5.359 5.359 0 0 1-1.955-1.274 5.36 5.36 0 0 1-1.274-1.956c-.302-.779-.481-1.62-.537-2.838C.008 15.81 0 15.278 0 12c0-3.277.008-3.81.077-5.318.056-1.218.235-2.06.537-2.838a5.36 5.36 0 0 1 1.274-1.956A5.36 5.36 0 0 1 3.843.614C4.623.312 5.464.133 6.682.077 8.19.008 8.722 0 12 0c3.277 0 3.81.008 5.318.077zM12 2.667c-3.24 0-3.736.007-5.197.074-.927.042-1.483.16-1.994.359a2.73 2.73 0 0 0-1.036.673A2.707 2.707 0 0 0 3.1 4.809c-.198.51-.317 1.067-.359 1.994C2.674 8.264 2.667 8.76 2.667 12s.007 3.736.074 5.197c.042.927.16 1.483.359 1.993.17.436.35.713.673 1.037.324.324.601.504 1.036.673.51.198 1.067.317 1.994.359 1.462.067 1.958.074 5.197.074 3.24 0 3.735-.007 5.197-.074.927-.042 1.483-.16 1.994-.359a2.73 2.73 0 0 0 1.036-.673c.324-.324.504-.601.673-1.036.198-.51.317-1.067.359-1.994.067-1.462.074-1.958.074-5.197s-.007-3.735-.074-5.197c-.042-.927-.16-1.483-.359-1.993a2.709 2.709 0 0 0-.673-1.037A2.708 2.708 0 0 0 19.19 3.1c-.51-.198-1.067-.317-1.994-.359-1.461-.067-1.957-.074-5.197-.074zm0 15.555a6.222 6.222 0 1 1 0-12.444 6.222 6.222 0 0 1 0 12.444zm0-2.666a3.556 3.556 0 1 0 0-7.112 3.556 3.556 0 0 0 0 7.112zm6.222-8.445a1.333 1.333 0 1 1 0-2.667 1.333 1.333 0 0 1 0 2.667z"
    }));
});
$c1d5abee002f6150$var$Instagram.displayName = 'Instagram';


Object.keys($c1d5abee002f6150$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c1d5abee002f6150$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c1d5abee002f6150$exports[key];
});
var $b3fbaf040b75ced9$exports = {};

$parcel$export($b3fbaf040b75ced9$exports, "__esModule", function () { return $b3fbaf040b75ced9$export$1e511d4a378977f5; }, function (v) { return $b3fbaf040b75ced9$export$1e511d4a378977f5 = v; });
$parcel$export($b3fbaf040b75ced9$exports, "InstallOption", function () { return $b3fbaf040b75ced9$export$334fc37c80045876; }, function (v) { return $b3fbaf040b75ced9$export$334fc37c80045876 = v; });
var $b3fbaf040b75ced9$export$1e511d4a378977f5;
var $b3fbaf040b75ced9$export$334fc37c80045876;
"use strict";
$b3fbaf040b75ced9$export$1e511d4a378977f5 = true;
$b3fbaf040b75ced9$export$334fc37c80045876 = void 0;

var $b3fbaf040b75ced9$var$_react = $b3fbaf040b75ced9$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $b3fbaf040b75ced9$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b3fbaf040b75ced9$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b3fbaf040b75ced9$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $b3fbaf040b75ced9$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b3fbaf040b75ced9$var$_extends() {
    return $b3fbaf040b75ced9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b3fbaf040b75ced9$var$_extends.apply(null, arguments);
}
var $b3fbaf040b75ced9$var$InstallOption = $b3fbaf040b75ced9$export$334fc37c80045876 = /*#__PURE__*/ (0, $b3fbaf040b75ced9$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $b3fbaf040b75ced9$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $b3fbaf040b75ced9$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "InstallOption"
    }, props), /*#__PURE__*/ $b3fbaf040b75ced9$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 6v10V6zm0-5c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm5 11-5 5-5-5"
    }));
});
$b3fbaf040b75ced9$var$InstallOption.displayName = 'InstallOption';


Object.keys($b3fbaf040b75ced9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $b3fbaf040b75ced9$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $b3fbaf040b75ced9$exports[key];
});
var $ad0f330522c5a02e$exports = {};

$parcel$export($ad0f330522c5a02e$exports, "__esModule", function () { return $ad0f330522c5a02e$export$1e511d4a378977f5; }, function (v) { return $ad0f330522c5a02e$export$1e511d4a378977f5 = v; });
$parcel$export($ad0f330522c5a02e$exports, "Install", function () { return $ad0f330522c5a02e$export$a42b9a5b3f9ab95d; }, function (v) { return $ad0f330522c5a02e$export$a42b9a5b3f9ab95d = v; });
var $ad0f330522c5a02e$export$1e511d4a378977f5;
var $ad0f330522c5a02e$export$a42b9a5b3f9ab95d;
"use strict";
$ad0f330522c5a02e$export$1e511d4a378977f5 = true;
$ad0f330522c5a02e$export$a42b9a5b3f9ab95d = void 0;

var $ad0f330522c5a02e$var$_react = $ad0f330522c5a02e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $ad0f330522c5a02e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ad0f330522c5a02e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ad0f330522c5a02e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ad0f330522c5a02e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ad0f330522c5a02e$var$_extends() {
    return $ad0f330522c5a02e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ad0f330522c5a02e$var$_extends.apply(null, arguments);
}
var $ad0f330522c5a02e$var$Install = $ad0f330522c5a02e$export$a42b9a5b3f9ab95d = /*#__PURE__*/ (0, $ad0f330522c5a02e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $ad0f330522c5a02e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ad0f330522c5a02e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Install"
    }, props), /*#__PURE__*/ $ad0f330522c5a02e$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M19 13.5v4L12 22l-7-4.5v-4m7 8.5v-8.5m6.5-5-6.5-4L15.5 2 22 6l-3.5 2.5zm-13 0 6.5-4L8.5 2 2 6l3.5 2.5zm13 .5L12 13l3.5 2.5 6.5-4L18.5 9zm-13 0 6.5 4-3.5 2.5-6.5-4L5.5 9z"
    }));
});
$ad0f330522c5a02e$var$Install.displayName = 'Install';


Object.keys($ad0f330522c5a02e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ad0f330522c5a02e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ad0f330522c5a02e$exports[key];
});
var $c2eecac0a441d333$exports = {};

$parcel$export($c2eecac0a441d333$exports, "__esModule", function () { return $c2eecac0a441d333$export$1e511d4a378977f5; }, function (v) { return $c2eecac0a441d333$export$1e511d4a378977f5 = v; });
$parcel$export($c2eecac0a441d333$exports, "Integration", function () { return $c2eecac0a441d333$export$8912007324034abd; }, function (v) { return $c2eecac0a441d333$export$8912007324034abd = v; });
var $c2eecac0a441d333$export$1e511d4a378977f5;
var $c2eecac0a441d333$export$8912007324034abd;
"use strict";
$c2eecac0a441d333$export$1e511d4a378977f5 = true;
$c2eecac0a441d333$export$8912007324034abd = void 0;

var $c2eecac0a441d333$var$_react = $c2eecac0a441d333$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c2eecac0a441d333$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c2eecac0a441d333$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c2eecac0a441d333$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c2eecac0a441d333$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c2eecac0a441d333$var$_extends() {
    return $c2eecac0a441d333$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c2eecac0a441d333$var$_extends.apply(null, arguments);
}
var $c2eecac0a441d333$var$Integration = $c2eecac0a441d333$export$8912007324034abd = /*#__PURE__*/ (0, $c2eecac0a441d333$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c2eecac0a441d333$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c2eecac0a441d333$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Integration"
    }, props), /*#__PURE__*/ $c2eecac0a441d333$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#231F20",
        strokeWidth: "2",
        d: "M5 21h18V9H5m14 6H1V3h18"
    }));
});
$c2eecac0a441d333$var$Integration.displayName = 'Integration';


Object.keys($c2eecac0a441d333$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c2eecac0a441d333$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c2eecac0a441d333$exports[key];
});
var $af96f580d2962e5e$exports = {};

$parcel$export($af96f580d2962e5e$exports, "__esModule", function () { return $af96f580d2962e5e$export$1e511d4a378977f5; }, function (v) { return $af96f580d2962e5e$export$1e511d4a378977f5 = v; });
$parcel$export($af96f580d2962e5e$exports, "InternetExplorer", function () { return $af96f580d2962e5e$export$dbf6f5fa72f10aa7; }, function (v) { return $af96f580d2962e5e$export$dbf6f5fa72f10aa7 = v; });
var $af96f580d2962e5e$export$1e511d4a378977f5;
var $af96f580d2962e5e$export$dbf6f5fa72f10aa7;
"use strict";
$af96f580d2962e5e$export$1e511d4a378977f5 = true;
$af96f580d2962e5e$export$dbf6f5fa72f10aa7 = void 0;

var $af96f580d2962e5e$var$_react = $af96f580d2962e5e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $af96f580d2962e5e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($af96f580d2962e5e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $af96f580d2962e5e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $af96f580d2962e5e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $af96f580d2962e5e$var$_extends() {
    return $af96f580d2962e5e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $af96f580d2962e5e$var$_extends.apply(null, arguments);
}
var $af96f580d2962e5e$var$InternetExplorer = $af96f580d2962e5e$export$dbf6f5fa72f10aa7 = /*#__PURE__*/ (0, $af96f580d2962e5e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $af96f580d2962e5e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $af96f580d2962e5e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "InternetExplorer"
    }, props), /*#__PURE__*/ $af96f580d2962e5e$var$_react["default"].createElement("path", {
        fill: "#00A1F1",
        fillRule: "evenodd",
        d: "M24 12.337c0-1.898-.491-3.68-1.351-5.229 3.666-8.298-3.929-7.083-4.352-7-1.609.315-3.097.82-4.47 1.461a10.868 10.868 0 0 0-.612-.017C8.09 1.552 3.8 5.126 2.702 9.918c2.702-3.03 4.592-4.253 5.724-4.742-.18.161-.358.324-.532.489l-.17.165c-.115.11-.23.22-.342.332l-.196.2c-.1.101-.199.202-.295.304-.07.072-.136.144-.204.216a26.855 26.855 0 0 0-1.15 1.31 31.222 31.222 0 0 0-.41.505l-.2.253-.183.24-.206.272-.14.193a33.453 33.453 0 0 0-1.168 1.7l-.002.003c-.093.145-.182.287-.27.428l-.014.023c-.088.141-.173.28-.255.418l-.009.014c-.222.37-.427.727-.613 1.063-.971 1.76-1.444 2.99-1.464 3.063-3.068 10.966 6.505 6.335 7.841 5.644a10.74 10.74 0 0 0 4.77 1.11c4.69 0 8.68-2.993 10.165-7.173h-5.666c-.839 1.416-2.453 2.376-4.308 2.376-2.717 0-4.92-2.059-4.92-4.598h15.426c.059-.455.089-.919.089-1.39zM21.985 1.724c.929.627 1.674 1.61.394 4.926a10.82 10.82 0 0 0-5.267-4.372c.998-.482 3.47-1.501 4.873-.554zM2.248 21.989c-.757-.776-.89-2.665.779-6.108a10.816 10.816 0 0 0 4.696 5.739c-1.08.595-3.95 1.934-5.475.369zM8.46 10.776c.086-2.468 2.235-4.444 4.874-4.444 2.64 0 4.787 1.976 4.874 4.444H8.46z"
    }));
});
$af96f580d2962e5e$var$InternetExplorer.displayName = 'InternetExplorer';


Object.keys($af96f580d2962e5e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $af96f580d2962e5e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $af96f580d2962e5e$exports[key];
});
var $ca132c76853f9d8a$exports = {};

$parcel$export($ca132c76853f9d8a$exports, "__esModule", function () { return $ca132c76853f9d8a$export$1e511d4a378977f5; }, function (v) { return $ca132c76853f9d8a$export$1e511d4a378977f5 = v; });
$parcel$export($ca132c76853f9d8a$exports, "Italic", function () { return $ca132c76853f9d8a$export$1cfcf4275506b1c6; }, function (v) { return $ca132c76853f9d8a$export$1cfcf4275506b1c6 = v; });
var $ca132c76853f9d8a$export$1e511d4a378977f5;
var $ca132c76853f9d8a$export$1cfcf4275506b1c6;
"use strict";
$ca132c76853f9d8a$export$1e511d4a378977f5 = true;
$ca132c76853f9d8a$export$1cfcf4275506b1c6 = void 0;

var $ca132c76853f9d8a$var$_react = $ca132c76853f9d8a$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $ca132c76853f9d8a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ca132c76853f9d8a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ca132c76853f9d8a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ca132c76853f9d8a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ca132c76853f9d8a$var$_extends() {
    return $ca132c76853f9d8a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ca132c76853f9d8a$var$_extends.apply(null, arguments);
}
var $ca132c76853f9d8a$var$Italic = $ca132c76853f9d8a$export$1cfcf4275506b1c6 = /*#__PURE__*/ (0, $ca132c76853f9d8a$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $ca132c76853f9d8a$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ca132c76853f9d8a$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Italic"
    }, props), /*#__PURE__*/ $ca132c76853f9d8a$var$_react["default"].createElement("path", {
        d: "m13 19.56-.13.43H6.3l.16-.43a4.05 4.05 0 0 0 1.3-.17 1.6 1.6 0 0 0 .76-.55 7.22 7.22 0 0 0 .8-2l2.77-9.61a7.07 7.07 0 0 0 .35-1.81.86.86 0 0 0-.15-.52.94.94 0 0 0-.46-.32 4.28 4.28 0 0 0-1.22-.11l.14-.43h6.16l-.13.43a2.6 2.6 0 0 0-1.12.17 1.78 1.78 0 0 0-.81.67 9.08 9.08 0 0 0-.71 1.93l-2.74 9.63a8.76 8.76 0 0 0-.4 1.69.83.83 0 0 0 .15.5.92.92 0 0 0 .47.32 6.35 6.35 0 0 0 1.38.18z"
    }));
});
$ca132c76853f9d8a$var$Italic.displayName = 'Italic';


Object.keys($ca132c76853f9d8a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ca132c76853f9d8a$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ca132c76853f9d8a$exports[key];
});
var $95193f447ac64fd6$exports = {};

$parcel$export($95193f447ac64fd6$exports, "__esModule", function () { return $95193f447ac64fd6$export$1e511d4a378977f5; }, function (v) { return $95193f447ac64fd6$export$1e511d4a378977f5 = v; });
$parcel$export($95193f447ac64fd6$exports, "Iteration", function () { return $95193f447ac64fd6$export$3e59743fd866525b; }, function (v) { return $95193f447ac64fd6$export$3e59743fd866525b = v; });
var $95193f447ac64fd6$export$1e511d4a378977f5;
var $95193f447ac64fd6$export$3e59743fd866525b;
"use strict";
$95193f447ac64fd6$export$1e511d4a378977f5 = true;
$95193f447ac64fd6$export$3e59743fd866525b = void 0;

var $95193f447ac64fd6$var$_react = $95193f447ac64fd6$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $95193f447ac64fd6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($95193f447ac64fd6$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $95193f447ac64fd6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $95193f447ac64fd6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $95193f447ac64fd6$var$_extends() {
    return $95193f447ac64fd6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $95193f447ac64fd6$var$_extends.apply(null, arguments);
}
var $95193f447ac64fd6$var$Iteration = $95193f447ac64fd6$export$3e59743fd866525b = /*#__PURE__*/ (0, $95193f447ac64fd6$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $95193f447ac64fd6$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $95193f447ac64fd6$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Iteration"
    }, props), /*#__PURE__*/ $95193f447ac64fd6$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 9v14h14M5 5v14h14M9 15h14V1H9v14z"
    }));
});
$95193f447ac64fd6$var$Iteration.displayName = 'Iteration';


Object.keys($95193f447ac64fd6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $95193f447ac64fd6$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $95193f447ac64fd6$exports[key];
});
var $1b25709afeeac8f1$exports = {};

$parcel$export($1b25709afeeac8f1$exports, "__esModule", function () { return $1b25709afeeac8f1$export$1e511d4a378977f5; }, function (v) { return $1b25709afeeac8f1$export$1e511d4a378977f5 = v; });
$parcel$export($1b25709afeeac8f1$exports, "Java", function () { return $1b25709afeeac8f1$export$9366920ef55db4a; }, function (v) { return $1b25709afeeac8f1$export$9366920ef55db4a = v; });
var $1b25709afeeac8f1$export$1e511d4a378977f5;
var $1b25709afeeac8f1$export$9366920ef55db4a;
"use strict";
$1b25709afeeac8f1$export$1e511d4a378977f5 = true;
$1b25709afeeac8f1$export$9366920ef55db4a = void 0;

var $1b25709afeeac8f1$var$_react = $1b25709afeeac8f1$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $1b25709afeeac8f1$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1b25709afeeac8f1$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1b25709afeeac8f1$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $1b25709afeeac8f1$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1b25709afeeac8f1$var$_extends() {
    return $1b25709afeeac8f1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1b25709afeeac8f1$var$_extends.apply(null, arguments);
}
var $1b25709afeeac8f1$var$Java = $1b25709afeeac8f1$export$9366920ef55db4a = /*#__PURE__*/ (0, $1b25709afeeac8f1$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $1b25709afeeac8f1$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $1b25709afeeac8f1$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Java"
    }, props), /*#__PURE__*/ $1b25709afeeac8f1$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 18V9h16v9c0 4-2 5-8 5s-8-1-8-5zm16-9v3a3 3 0 1 0 3-3h-3zm-4-3V2M5 6V4m4 2V0"
    }));
});
$1b25709afeeac8f1$var$Java.displayName = 'Java';


Object.keys($1b25709afeeac8f1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $1b25709afeeac8f1$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $1b25709afeeac8f1$exports[key];
});
var $5bd84403611e985d$exports = {};

$parcel$export($5bd84403611e985d$exports, "__esModule", function () { return $5bd84403611e985d$export$1e511d4a378977f5; }, function (v) { return $5bd84403611e985d$export$1e511d4a378977f5 = v; });
$parcel$export($5bd84403611e985d$exports, "Js", function () { return $5bd84403611e985d$export$2e05a4736c47d8f6; }, function (v) { return $5bd84403611e985d$export$2e05a4736c47d8f6 = v; });
var $5bd84403611e985d$export$1e511d4a378977f5;
var $5bd84403611e985d$export$2e05a4736c47d8f6;
"use strict";
$5bd84403611e985d$export$1e511d4a378977f5 = true;
$5bd84403611e985d$export$2e05a4736c47d8f6 = void 0;

var $5bd84403611e985d$var$_react = $5bd84403611e985d$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5bd84403611e985d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5bd84403611e985d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5bd84403611e985d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5bd84403611e985d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5bd84403611e985d$var$_extends() {
    return $5bd84403611e985d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5bd84403611e985d$var$_extends.apply(null, arguments);
}
var $5bd84403611e985d$var$Js = $5bd84403611e985d$export$2e05a4736c47d8f6 = /*#__PURE__*/ (0, $5bd84403611e985d$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5bd84403611e985d$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5bd84403611e985d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Js"
    }, props), /*#__PURE__*/ $5bd84403611e985d$var$_react["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $5bd84403611e985d$var$_react["default"].createElement("path", {
        fill: "#F1DC50",
        d: "M0 0h24v24H0z"
    }), /*#__PURE__*/ $5bd84403611e985d$var$_react["default"].createElement("path", {
        stroke: "#333",
        strokeWidth: "2",
        d: "M12 11v8c0 .876-.523 2-2 2-2.385 0-2.5-2-2.5-2m13.29-5.484c-.6-1.01-1.396-1.516-2.386-1.516C16.856 12 16 13 16 14s.5 2 2.508 2.5c1.278.318 2.492 1 2.492 2.5s-1.315 2-2.5 2c-1.514 0-2.514-.667-3-2"
    })));
});
$5bd84403611e985d$var$Js.displayName = 'Js';


Object.keys($5bd84403611e985d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5bd84403611e985d$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5bd84403611e985d$exports[key];
});
var $842d78254a413c34$exports = {};

$parcel$export($842d78254a413c34$exports, "__esModule", function () { return $842d78254a413c34$export$1e511d4a378977f5; }, function (v) { return $842d78254a413c34$export$1e511d4a378977f5 = v; });
$parcel$export($842d78254a413c34$exports, "Key", function () { return $842d78254a413c34$export$cd0f44441c3b7719; }, function (v) { return $842d78254a413c34$export$cd0f44441c3b7719 = v; });
var $842d78254a413c34$export$1e511d4a378977f5;
var $842d78254a413c34$export$cd0f44441c3b7719;
"use strict";
$842d78254a413c34$export$1e511d4a378977f5 = true;
$842d78254a413c34$export$cd0f44441c3b7719 = void 0;

var $842d78254a413c34$var$_react = $842d78254a413c34$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $842d78254a413c34$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($842d78254a413c34$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $842d78254a413c34$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $842d78254a413c34$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $842d78254a413c34$var$_extends() {
    return $842d78254a413c34$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $842d78254a413c34$var$_extends.apply(null, arguments);
}
var $842d78254a413c34$var$Key = $842d78254a413c34$export$cd0f44441c3b7719 = /*#__PURE__*/ (0, $842d78254a413c34$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $842d78254a413c34$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $842d78254a413c34$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Key"
    }, props), /*#__PURE__*/ $842d78254a413c34$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M10 13v3h3v3h3v2l2 2h5v-4L12.74 8.74C12.91 8.19 13 7.6 13 7c0-3.31-2.69-6-6-6S1 3.69 1 7a6.005 6.005 0 0 0 8.47 5.47L10 13zM6 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
    }));
});
$842d78254a413c34$var$Key.displayName = 'Key';


Object.keys($842d78254a413c34$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $842d78254a413c34$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $842d78254a413c34$exports[key];
});
var $e2cf19213d2aff8b$exports = {};

$parcel$export($e2cf19213d2aff8b$exports, "__esModule", function () { return $e2cf19213d2aff8b$export$1e511d4a378977f5; }, function (v) { return $e2cf19213d2aff8b$export$1e511d4a378977f5 = v; });
$parcel$export($e2cf19213d2aff8b$exports, "Keyboard", function () { return $e2cf19213d2aff8b$export$16e4d70cc375e707; }, function (v) { return $e2cf19213d2aff8b$export$16e4d70cc375e707 = v; });
var $e2cf19213d2aff8b$export$1e511d4a378977f5;
var $e2cf19213d2aff8b$export$16e4d70cc375e707;
"use strict";
$e2cf19213d2aff8b$export$1e511d4a378977f5 = true;
$e2cf19213d2aff8b$export$16e4d70cc375e707 = void 0;

var $e2cf19213d2aff8b$var$_react = $e2cf19213d2aff8b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e2cf19213d2aff8b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e2cf19213d2aff8b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e2cf19213d2aff8b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e2cf19213d2aff8b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e2cf19213d2aff8b$var$_extends() {
    return $e2cf19213d2aff8b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e2cf19213d2aff8b$var$_extends.apply(null, arguments);
}
var $e2cf19213d2aff8b$var$Keyboard = $e2cf19213d2aff8b$export$16e4d70cc375e707 = /*#__PURE__*/ (0, $e2cf19213d2aff8b$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e2cf19213d2aff8b$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e2cf19213d2aff8b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Keyboard"
    }, props), /*#__PURE__*/ $e2cf19213d2aff8b$var$_react["default"].createElement("path", {
        stroke: "#000",
        fill: "none",
        strokeWidth: "2",
        d: "M3 9h3m-3 3h2m-2 3h1m3 0h10m1 0h1m1 0h1m-3-3h3m-2-3h2m-5 0h2M7 9h2m1 0h2m1 0h2M5 15h1m0-3h2m1 0h2m1 0h2m1 0h2M1 7v10a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1z"
    }));
});
$e2cf19213d2aff8b$var$Keyboard.displayName = 'Keyboard';


Object.keys($e2cf19213d2aff8b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e2cf19213d2aff8b$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e2cf19213d2aff8b$exports[key];
});
var $e43e9870deba4f1c$exports = {};

$parcel$export($e43e9870deba4f1c$exports, "__esModule", function () { return $e43e9870deba4f1c$export$1e511d4a378977f5; }, function (v) { return $e43e9870deba4f1c$export$1e511d4a378977f5 = v; });
$parcel$export($e43e9870deba4f1c$exports, "Kubernetes", function () { return $e43e9870deba4f1c$export$2c50ad89f39ec5b7; }, function (v) { return $e43e9870deba4f1c$export$2c50ad89f39ec5b7 = v; });
var $e43e9870deba4f1c$export$1e511d4a378977f5;
var $e43e9870deba4f1c$export$2c50ad89f39ec5b7;
"use strict";
$e43e9870deba4f1c$export$1e511d4a378977f5 = true;
$e43e9870deba4f1c$export$2c50ad89f39ec5b7 = void 0;

var $e43e9870deba4f1c$var$_react = $e43e9870deba4f1c$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $e43e9870deba4f1c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e43e9870deba4f1c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e43e9870deba4f1c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e43e9870deba4f1c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e43e9870deba4f1c$var$_extends() {
    return $e43e9870deba4f1c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e43e9870deba4f1c$var$_extends.apply(null, arguments);
}
var $e43e9870deba4f1c$var$Kubernetes = $e43e9870deba4f1c$export$2c50ad89f39ec5b7 = /*#__PURE__*/ (0, $e43e9870deba4f1c$var$_react.forwardRef)(function(props, ref) {
    var prefix = (0, $1b754218be0a6592$export$3794798abb123ff6)('Kubernetes');
    return /*#__PURE__*/ $e43e9870deba4f1c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e43e9870deba4f1c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Kubernetes"
    }, props), /*#__PURE__*/ $e43e9870deba4f1c$var$_react["default"].createElement("g", {
        clipPath: "url(#" + prefix + "-a)"
    }, /*#__PURE__*/ $e43e9870deba4f1c$var$_react["default"].createElement("path", {
        fill: "#326CE5",
        d: "M14.27 13.385h-.268c-.21.129-.302.373-.21.582l1.002 2.457a5.15 5.15 0 0 0 2.084-2.62l-2.596-.419h-.012Zm-4.016.338a.483.483 0 0 0-.443-.338h-.093l-2.584.431a5.143 5.143 0 0 0 2.084 2.596l.99-2.41v-.035c.046-.058.046-.162.046-.244Zm2.13.943a.44.44 0 0 0-.594-.175c-.081.059-.14.094-.174.175h-.012l-1.269 2.293a5.195 5.195 0 0 0 2.83.14c.162-.035.337-.081.5-.14l-1.27-2.293h-.01Zm4.017-5.32-1.956 1.711.011.035a.43.43 0 0 0-.046.617c.058.07.128.116.21.14l.011.011 2.526.722c.082-1.13-.163-2.27-.756-3.236Zm-3.621.186c.012.244.21.43.454.419a.54.54 0 0 0 .245-.058h.011l2.13-1.525a5.182 5.182 0 0 0-2.991-1.444l.151 2.608Zm-2.258.36a.442.442 0 0 0 .605-.104.45.45 0 0 0 .093-.244h.012l.14-2.62c-.175.023-.35.058-.536.093a5.064 5.064 0 0 0-2.468 1.35l2.142 1.526h.011ZM9.368 11.86a.426.426 0 0 0 .303-.535c0-.093-.059-.163-.128-.221v-.012L7.588 9.31a5.194 5.194 0 0 0-.734 3.283l2.515-.722v-.012Zm1.91.769.721.349.722-.35.174-.78-.5-.616h-.804l-.5.617.186.78Zm12.677 1.536-2.06-8.929a1.588 1.588 0 0 0-.862-1.094L12.687.148a1.69 1.69 0 0 0-1.385 0L2.966 4.142c-.431.21-.757.605-.862 1.094l-2.06 8.93a1.373 1.373 0 0 0 0 .686c.011.07.035.14.058.21.035.105.093.221.151.314.035.047.058.093.105.128L6.121 22.7c.023 0 .058.047.058.07.116.105.221.186.326.256.14.093.303.163.466.198.128.058.267.058.372.058h9.454c.081 0 .162-.035.232-.058.059-.012.117-.035.163-.047.047-.023.082-.035.128-.058.059-.023.117-.058.175-.093.14-.093.268-.21.384-.326l.175-.233 5.588-6.962c.116-.14.198-.29.256-.442a1.4 1.4 0 0 0 .058-.21 1.37 1.37 0 0 0 0-.687Zm-8.65 3.481c.024.07.047.14.082.198a.392.392 0 0 0-.035.303c.14.28.268.536.442.792.093.128.187.267.28.395 0 .035.035.094.046.14a.5.5 0 0 1-.174.687.495.495 0 0 1-.687-.175c-.012-.035-.024-.058-.035-.093-.023-.035-.047-.105-.07-.105a5.205 5.205 0 0 1-.14-.477c-.104-.29-.198-.57-.349-.838a.437.437 0 0 0-.245-.163l-.093-.186a6.517 6.517 0 0 1-4.621-.012l-.117.21a.394.394 0 0 0-.221.104c-.163.28-.28.57-.384.897a4.155 4.155 0 0 1-.14.465c-.023 0-.047.082-.07.117a.501.501 0 0 1-.943-.338c.012-.035.035-.058.047-.093.046-.035.046-.093.046-.128.105-.14.187-.268.28-.407.186-.245.337-.524.454-.804a.628.628 0 0 0-.035-.29l.081-.21a6.532 6.532 0 0 1-2.875-3.598l-.233.035a.451.451 0 0 0-.268-.104 6.044 6.044 0 0 0-.896.256c-.128.07-.28.128-.431.174a1.01 1.01 0 0 1-.151.035.51.51 0 0 1-.63-.314.504.504 0 0 1 .327-.64c.023 0 .058-.012.093-.012v-.012h.012l.128-.023c.163-.047.326-.047.477-.047.303 0 .605-.07.896-.14a.67.67 0 0 0 .222-.22l.22-.059a6.35 6.35 0 0 1 1.002-4.505l-.163-.14a.51.51 0 0 0-.093-.29 4.765 4.765 0 0 0-.745-.525c-.14-.07-.28-.151-.42-.244-.022-.024-.07-.059-.092-.082l-.012-.011c-.233-.187-.291-.49-.128-.734a.528.528 0 0 1 .407-.175.655.655 0 0 1 .35.14l.104.082c.117.104.222.233.326.349.21.221.431.43.676.605a.45.45 0 0 0 .302.035l.175.128a6.398 6.398 0 0 1 3.26-1.862c.29-.07.605-.117.908-.14l.011-.21a.524.524 0 0 0 .163-.267 4.583 4.583 0 0 0-.058-.897 3.14 3.14 0 0 1-.07-.477v-.14a.517.517 0 0 1 .454-.559.497.497 0 0 1 .548.443v.256a3.14 3.14 0 0 1-.07.477c-.047.291-.07.594-.058.897a.397.397 0 0 0 .163.256l.011.22A6.49 6.49 0 0 1 16.692 7.6l.186-.14a.45.45 0 0 0 .303-.034 4.18 4.18 0 0 0 .675-.606c.105-.116.21-.233.326-.349.035-.023.081-.07.116-.07.198-.21.513-.21.687 0 .221.186.21.5 0 .699 0 .023-.035.046-.07.07a2.907 2.907 0 0 1-.512.326 4.274 4.274 0 0 0-.745.523.357.357 0 0 0-.093.28l-.186.163a6.333 6.333 0 0 1 1.024 4.494l.221.058a.483.483 0 0 0 .222.21c.29.08.593.127.896.162h.477c.035.035.093.047.14.059a.5.5 0 0 1 .43.57c-.058.268-.279.466-.558.43-.035-.01-.082-.01-.082-.023v-.011a.605.605 0 0 1-.163-.023 2.27 2.27 0 0 1-.419-.175 4.101 4.101 0 0 0-.896-.245c-.105 0-.198 0-.268.094a8.755 8.755 0 0 1-.221-.035c-.477 1.525-1.525 2.805-2.876 3.62Z"
    })), /*#__PURE__*/ $e43e9870deba4f1c$var$_react["default"].createElement("defs", null, /*#__PURE__*/ $e43e9870deba4f1c$var$_react["default"].createElement("clipPath", {
        id: prefix + "-a"
    }, /*#__PURE__*/ $e43e9870deba4f1c$var$_react["default"].createElement("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
    }))));
});
$e43e9870deba4f1c$var$Kubernetes.displayName = 'Kubernetes';


Object.keys($e43e9870deba4f1c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e43e9870deba4f1c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e43e9870deba4f1c$exports[key];
});
var $64899910fd8ac40a$exports = {};

$parcel$export($64899910fd8ac40a$exports, "__esModule", function () { return $64899910fd8ac40a$export$1e511d4a378977f5; }, function (v) { return $64899910fd8ac40a$export$1e511d4a378977f5 = v; });
$parcel$export($64899910fd8ac40a$exports, "Language", function () { return $64899910fd8ac40a$export$ce4fe1c9e6520c1a; }, function (v) { return $64899910fd8ac40a$export$ce4fe1c9e6520c1a = v; });
var $64899910fd8ac40a$export$1e511d4a378977f5;
var $64899910fd8ac40a$export$ce4fe1c9e6520c1a;
"use strict";
$64899910fd8ac40a$export$1e511d4a378977f5 = true;
$64899910fd8ac40a$export$ce4fe1c9e6520c1a = void 0;

var $64899910fd8ac40a$var$_react = $64899910fd8ac40a$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $64899910fd8ac40a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($64899910fd8ac40a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $64899910fd8ac40a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $64899910fd8ac40a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $64899910fd8ac40a$var$_extends() {
    return $64899910fd8ac40a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $64899910fd8ac40a$var$_extends.apply(null, arguments);
}
var $64899910fd8ac40a$var$Language = $64899910fd8ac40a$export$ce4fe1c9e6520c1a = /*#__PURE__*/ (0, $64899910fd8ac40a$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $64899910fd8ac40a$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $64899910fd8ac40a$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Language"
    }, props), /*#__PURE__*/ $64899910fd8ac40a$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm0 0c3 0 4-5 4-11S15 1 12 1 8 6 8 12s1 11 4 11zM2 16h20M2 8h20"
    }));
});
$64899910fd8ac40a$var$Language.displayName = 'Language';


Object.keys($64899910fd8ac40a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $64899910fd8ac40a$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $64899910fd8ac40a$exports[key];
});
var $3f9daf5c06f79aea$exports = {};

$parcel$export($3f9daf5c06f79aea$exports, "__esModule", function () { return $3f9daf5c06f79aea$export$1e511d4a378977f5; }, function (v) { return $3f9daf5c06f79aea$export$1e511d4a378977f5 = v; });
$parcel$export($3f9daf5c06f79aea$exports, "Lastfm", function () { return $3f9daf5c06f79aea$export$1bb4a2eb53c2c86c; }, function (v) { return $3f9daf5c06f79aea$export$1bb4a2eb53c2c86c = v; });
var $3f9daf5c06f79aea$export$1e511d4a378977f5;
var $3f9daf5c06f79aea$export$1bb4a2eb53c2c86c;
"use strict";
$3f9daf5c06f79aea$export$1e511d4a378977f5 = true;
$3f9daf5c06f79aea$export$1bb4a2eb53c2c86c = void 0;

var $3f9daf5c06f79aea$var$_react = $3f9daf5c06f79aea$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $3f9daf5c06f79aea$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3f9daf5c06f79aea$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3f9daf5c06f79aea$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3f9daf5c06f79aea$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3f9daf5c06f79aea$var$_extends() {
    return $3f9daf5c06f79aea$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3f9daf5c06f79aea$var$_extends.apply(null, arguments);
}
var $3f9daf5c06f79aea$var$Lastfm = $3f9daf5c06f79aea$export$1bb4a2eb53c2c86c = /*#__PURE__*/ (0, $3f9daf5c06f79aea$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3f9daf5c06f79aea$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3f9daf5c06f79aea$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Lastfm"
    }, props), /*#__PURE__*/ $3f9daf5c06f79aea$var$_react["default"].createElement("path", {
        fill: "#B72024",
        d: "M20.297 10.924c-.21-.069-.413-.132-.609-.194-1.494-.47-2.394-.753-2.394-1.916 0-.943.727-1.627 1.73-1.627.769 0 1.341.319 1.855 1.038.048.067.138.09.213.05l1.507-.768a.162.162 0 0 0 .084-.101.166.166 0 0 0-.014-.131c-.807-1.435-1.972-2.133-3.56-2.133-2.417 0-3.98 1.462-3.98 3.725 0 2.314 1.511 3.25 4.298 4.168 1.616.538 2.33.824 2.33 1.973 0 1.291-1.165 2.22-2.755 2.166-1.666-.056-2.17-.94-2.806-2.386a720.097 720.097 0 0 1-2.307-5.337C12.662 6.621 10.232 5 7.22 5 3.239 5 0 8.239 0 12.22c0 3.98 3.238 7.219 7.219 7.219 2.17 0 4.206-.962 5.582-2.641a.167.167 0 0 0 .025-.173l-.91-2.1a.171.171 0 0 0-.149-.1.165.165 0 0 0-.154.09 4.946 4.946 0 0 1-4.395 2.66 4.96 4.96 0 0 1-4.954-4.955 4.96 4.96 0 0 1 4.954-4.955c1.989 0 3.81 1.18 4.534 2.941l2.251 5.134.26.577c1.017 2.37 2.512 3.432 4.854 3.44 2.784 0 4.883-1.844 4.883-4.29 0-2.457-1.358-3.378-3.703-4.143z"
    }));
});
$3f9daf5c06f79aea$var$Lastfm.displayName = 'Lastfm';


Object.keys($3f9daf5c06f79aea$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3f9daf5c06f79aea$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3f9daf5c06f79aea$exports[key];
});
var $3069877f8816a9d1$exports = {};

$parcel$export($3069877f8816a9d1$exports, "__esModule", function () { return $3069877f8816a9d1$export$1e511d4a378977f5; }, function (v) { return $3069877f8816a9d1$export$1e511d4a378977f5 = v; });
$parcel$export($3069877f8816a9d1$exports, "Launch", function () { return $3069877f8816a9d1$export$1d754dd096cb56ed; }, function (v) { return $3069877f8816a9d1$export$1d754dd096cb56ed = v; });
var $3069877f8816a9d1$export$1e511d4a378977f5;
var $3069877f8816a9d1$export$1d754dd096cb56ed;
"use strict";
$3069877f8816a9d1$export$1e511d4a378977f5 = true;
$3069877f8816a9d1$export$1d754dd096cb56ed = void 0;

var $3069877f8816a9d1$var$_react = $3069877f8816a9d1$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $3069877f8816a9d1$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3069877f8816a9d1$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3069877f8816a9d1$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3069877f8816a9d1$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3069877f8816a9d1$var$_extends() {
    return $3069877f8816a9d1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3069877f8816a9d1$var$_extends.apply(null, arguments);
}
var $3069877f8816a9d1$var$Launch = $3069877f8816a9d1$export$1d754dd096cb56ed = /*#__PURE__*/ (0, $3069877f8816a9d1$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3069877f8816a9d1$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3069877f8816a9d1$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Launch"
    }, props), /*#__PURE__*/ $3069877f8816a9d1$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M7 9v5s-3 2-3 5v1h4l2 3h4l2-3h4v-1c0-3-3-5-3-5V9c0-4-3-8-5-8S7 5 7 9zm1 11h8M12 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
    }));
});
$3069877f8816a9d1$var$Launch.displayName = 'Launch';


Object.keys($3069877f8816a9d1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3069877f8816a9d1$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3069877f8816a9d1$exports[key];
});
var $590b189535ab8cce$exports = {};

$parcel$export($590b189535ab8cce$exports, "__esModule", function () { return $590b189535ab8cce$export$1e511d4a378977f5; }, function (v) { return $590b189535ab8cce$export$1e511d4a378977f5 = v; });
$parcel$export($590b189535ab8cce$exports, "Layer", function () { return $590b189535ab8cce$export$936d0764594b6eb3; }, function (v) { return $590b189535ab8cce$export$936d0764594b6eb3 = v; });
var $590b189535ab8cce$export$1e511d4a378977f5;
var $590b189535ab8cce$export$936d0764594b6eb3;
"use strict";
$590b189535ab8cce$export$1e511d4a378977f5 = true;
$590b189535ab8cce$export$936d0764594b6eb3 = void 0;

var $590b189535ab8cce$var$_react = $590b189535ab8cce$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $590b189535ab8cce$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($590b189535ab8cce$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $590b189535ab8cce$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $590b189535ab8cce$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $590b189535ab8cce$var$_extends() {
    return $590b189535ab8cce$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $590b189535ab8cce$var$_extends.apply(null, arguments);
}
var $590b189535ab8cce$var$Layer = $590b189535ab8cce$export$936d0764594b6eb3 = /*#__PURE__*/ (0, $590b189535ab8cce$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $590b189535ab8cce$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $590b189535ab8cce$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Layer"
    }, props), /*#__PURE__*/ $590b189535ab8cce$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 1h16v16H1V1zm19 6h3v16H7v-3"
    }));
});
$590b189535ab8cce$var$Layer.displayName = 'Layer';


Object.keys($590b189535ab8cce$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $590b189535ab8cce$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $590b189535ab8cce$exports[key];
});
var $4df65a49b41bb2a2$exports = {};

$parcel$export($4df65a49b41bb2a2$exports, "__esModule", function () { return $4df65a49b41bb2a2$export$1e511d4a378977f5; }, function (v) { return $4df65a49b41bb2a2$export$1e511d4a378977f5 = v; });
$parcel$export($4df65a49b41bb2a2$exports, "License", function () { return $4df65a49b41bb2a2$export$1944193dc26cf6ac; }, function (v) { return $4df65a49b41bb2a2$export$1944193dc26cf6ac = v; });
var $4df65a49b41bb2a2$export$1e511d4a378977f5;
var $4df65a49b41bb2a2$export$1944193dc26cf6ac;
"use strict";
$4df65a49b41bb2a2$export$1e511d4a378977f5 = true;
$4df65a49b41bb2a2$export$1944193dc26cf6ac = void 0;

var $4df65a49b41bb2a2$var$_react = $4df65a49b41bb2a2$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $4df65a49b41bb2a2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4df65a49b41bb2a2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4df65a49b41bb2a2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $4df65a49b41bb2a2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $4df65a49b41bb2a2$var$_extends() {
    return $4df65a49b41bb2a2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4df65a49b41bb2a2$var$_extends.apply(null, arguments);
}
var $4df65a49b41bb2a2$var$License = $4df65a49b41bb2a2$export$1944193dc26cf6ac = /*#__PURE__*/ (0, $4df65a49b41bb2a2$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $4df65a49b41bb2a2$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $4df65a49b41bb2a2$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "License"
    }, props), /*#__PURE__*/ $4df65a49b41bb2a2$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M10 13v3h3v3h3v2l2 2h5v-4L12.74 8.74C12.91 8.19 13 7.6 13 7c0-3.31-2.69-6-6-6S1 3.69 1 7a6.005 6.005 0 0 0 8.47 5.47L10 13zM6 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
    }));
});
$4df65a49b41bb2a2$var$License.displayName = 'License';


Object.keys($4df65a49b41bb2a2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $4df65a49b41bb2a2$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $4df65a49b41bb2a2$exports[key];
});

Object.keys($16ad2167e9742ca9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $16ad2167e9742ca9$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $16ad2167e9742ca9$exports[key];
});

Object.keys($fdfa878ef43b4b5a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $fdfa878ef43b4b5a$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $fdfa878ef43b4b5a$exports[key];
});
var $6c76ac8a4d2cc01e$exports = {};

$parcel$export($6c76ac8a4d2cc01e$exports, "__esModule", function () { return $6c76ac8a4d2cc01e$export$1e511d4a378977f5; }, function (v) { return $6c76ac8a4d2cc01e$export$1e511d4a378977f5 = v; });
$parcel$export($6c76ac8a4d2cc01e$exports, "LineChart", function () { return $6c76ac8a4d2cc01e$export$54d0e8420ac838ac; }, function (v) { return $6c76ac8a4d2cc01e$export$54d0e8420ac838ac = v; });
var $6c76ac8a4d2cc01e$export$1e511d4a378977f5;
var $6c76ac8a4d2cc01e$export$54d0e8420ac838ac;
"use strict";
$6c76ac8a4d2cc01e$export$1e511d4a378977f5 = true;
$6c76ac8a4d2cc01e$export$54d0e8420ac838ac = void 0;

var $6c76ac8a4d2cc01e$var$_react = $6c76ac8a4d2cc01e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $6c76ac8a4d2cc01e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6c76ac8a4d2cc01e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6c76ac8a4d2cc01e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6c76ac8a4d2cc01e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6c76ac8a4d2cc01e$var$_extends() {
    return $6c76ac8a4d2cc01e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6c76ac8a4d2cc01e$var$_extends.apply(null, arguments);
}
var $6c76ac8a4d2cc01e$var$LineChart = $6c76ac8a4d2cc01e$export$54d0e8420ac838ac = /*#__PURE__*/ (0, $6c76ac8a4d2cc01e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $6c76ac8a4d2cc01e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $6c76ac8a4d2cc01e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "LineChart"
    }, props), /*#__PURE__*/ $6c76ac8a4d2cc01e$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m1 16 7-7 5 5L23 4M0 22h23.999M16 4h7v7"
    }));
});
$6c76ac8a4d2cc01e$var$LineChart.displayName = 'LineChart';


Object.keys($6c76ac8a4d2cc01e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $6c76ac8a4d2cc01e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $6c76ac8a4d2cc01e$exports[key];
});
var $d6f60cd8bd47bc98$exports = {};

$parcel$export($d6f60cd8bd47bc98$exports, "__esModule", function () { return $d6f60cd8bd47bc98$export$1e511d4a378977f5; }, function (v) { return $d6f60cd8bd47bc98$export$1e511d4a378977f5 = v; });
$parcel$export($d6f60cd8bd47bc98$exports, "LinkBottom", function () { return $d6f60cd8bd47bc98$export$5844a33377f61e24; }, function (v) { return $d6f60cd8bd47bc98$export$5844a33377f61e24 = v; });
var $d6f60cd8bd47bc98$export$1e511d4a378977f5;
var $d6f60cd8bd47bc98$export$5844a33377f61e24;
"use strict";
$d6f60cd8bd47bc98$export$1e511d4a378977f5 = true;
$d6f60cd8bd47bc98$export$5844a33377f61e24 = void 0;

var $d6f60cd8bd47bc98$var$_react = $d6f60cd8bd47bc98$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $d6f60cd8bd47bc98$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d6f60cd8bd47bc98$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d6f60cd8bd47bc98$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d6f60cd8bd47bc98$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d6f60cd8bd47bc98$var$_extends() {
    return $d6f60cd8bd47bc98$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d6f60cd8bd47bc98$var$_extends.apply(null, arguments);
}
var $d6f60cd8bd47bc98$var$LinkBottom = $d6f60cd8bd47bc98$export$5844a33377f61e24 = /*#__PURE__*/ (0, $d6f60cd8bd47bc98$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d6f60cd8bd47bc98$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $d6f60cd8bd47bc98$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "LinkBottom"
    }, props), /*#__PURE__*/ $d6f60cd8bd47bc98$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 19V1M4 11l8 8 8-8M2 22h20"
    }));
});
$d6f60cd8bd47bc98$var$LinkBottom.displayName = 'LinkBottom';


Object.keys($d6f60cd8bd47bc98$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $d6f60cd8bd47bc98$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $d6f60cd8bd47bc98$exports[key];
});
var $ee9854f10fbb794d$exports = {};

$parcel$export($ee9854f10fbb794d$exports, "__esModule", function () { return $ee9854f10fbb794d$export$1e511d4a378977f5; }, function (v) { return $ee9854f10fbb794d$export$1e511d4a378977f5 = v; });
$parcel$export($ee9854f10fbb794d$exports, "LinkDown", function () { return $ee9854f10fbb794d$export$11350e5b9f8763a7; }, function (v) { return $ee9854f10fbb794d$export$11350e5b9f8763a7 = v; });
var $ee9854f10fbb794d$export$1e511d4a378977f5;
var $ee9854f10fbb794d$export$11350e5b9f8763a7;
"use strict";
$ee9854f10fbb794d$export$1e511d4a378977f5 = true;
$ee9854f10fbb794d$export$11350e5b9f8763a7 = void 0;

var $ee9854f10fbb794d$var$_react = $ee9854f10fbb794d$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $ee9854f10fbb794d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ee9854f10fbb794d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ee9854f10fbb794d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ee9854f10fbb794d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ee9854f10fbb794d$var$_extends() {
    return $ee9854f10fbb794d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ee9854f10fbb794d$var$_extends.apply(null, arguments);
}
var $ee9854f10fbb794d$var$LinkDown = $ee9854f10fbb794d$export$11350e5b9f8763a7 = /*#__PURE__*/ (0, $ee9854f10fbb794d$var$_react.forwardRef)(function(props, ref) {
    var scaleProps = (0, $1b754218be0a6592$export$56a2e46cd4a7c217)(props);
    return /*#__PURE__*/ $ee9854f10fbb794d$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ee9854f10fbb794d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "LinkDown"
    }, props), /*#__PURE__*/ $ee9854f10fbb794d$var$_react["default"].createElement("path", $ee9854f10fbb794d$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22V2M3 13l9 9 9-9"
    }, scaleProps)));
});
$ee9854f10fbb794d$var$LinkDown.displayName = 'LinkDown';


Object.keys($ee9854f10fbb794d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ee9854f10fbb794d$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ee9854f10fbb794d$exports[key];
});
var $3c7de5129641efb8$exports = {};

$parcel$export($3c7de5129641efb8$exports, "__esModule", function () { return $3c7de5129641efb8$export$1e511d4a378977f5; }, function (v) { return $3c7de5129641efb8$export$1e511d4a378977f5 = v; });
$parcel$export($3c7de5129641efb8$exports, "LinkNext", function () { return $3c7de5129641efb8$export$18f0836c03a64fbe; }, function (v) { return $3c7de5129641efb8$export$18f0836c03a64fbe = v; });
var $3c7de5129641efb8$export$1e511d4a378977f5;
var $3c7de5129641efb8$export$18f0836c03a64fbe;
"use strict";
$3c7de5129641efb8$export$1e511d4a378977f5 = true;
$3c7de5129641efb8$export$18f0836c03a64fbe = void 0;

var $3c7de5129641efb8$var$_react = $3c7de5129641efb8$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $3c7de5129641efb8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3c7de5129641efb8$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3c7de5129641efb8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3c7de5129641efb8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3c7de5129641efb8$var$_extends() {
    return $3c7de5129641efb8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3c7de5129641efb8$var$_extends.apply(null, arguments);
}
var $3c7de5129641efb8$var$LinkNext = $3c7de5129641efb8$export$18f0836c03a64fbe = /*#__PURE__*/ (0, $3c7de5129641efb8$var$_react.forwardRef)(function(props, ref) {
    var scaleProps = (0, $1b754218be0a6592$export$56a2e46cd4a7c217)(props);
    return /*#__PURE__*/ $3c7de5129641efb8$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3c7de5129641efb8$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "LinkNext"
    }, props), /*#__PURE__*/ $3c7de5129641efb8$var$_react["default"].createElement("path", $3c7de5129641efb8$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 12h20m-9-9 9 9-9 9"
    }, scaleProps)));
});
$3c7de5129641efb8$var$LinkNext.displayName = 'LinkNext';


Object.keys($3c7de5129641efb8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3c7de5129641efb8$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3c7de5129641efb8$exports[key];
});
var $922c4cf5e30ac6d2$exports = {};

$parcel$export($922c4cf5e30ac6d2$exports, "__esModule", function () { return $922c4cf5e30ac6d2$export$1e511d4a378977f5; }, function (v) { return $922c4cf5e30ac6d2$export$1e511d4a378977f5 = v; });
$parcel$export($922c4cf5e30ac6d2$exports, "LinkPrevious", function () { return $922c4cf5e30ac6d2$export$196d3360b25bb94; }, function (v) { return $922c4cf5e30ac6d2$export$196d3360b25bb94 = v; });
var $922c4cf5e30ac6d2$export$1e511d4a378977f5;
var $922c4cf5e30ac6d2$export$196d3360b25bb94;
"use strict";
$922c4cf5e30ac6d2$export$1e511d4a378977f5 = true;
$922c4cf5e30ac6d2$export$196d3360b25bb94 = void 0;

var $922c4cf5e30ac6d2$var$_react = $922c4cf5e30ac6d2$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $922c4cf5e30ac6d2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($922c4cf5e30ac6d2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $922c4cf5e30ac6d2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $922c4cf5e30ac6d2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $922c4cf5e30ac6d2$var$_extends() {
    return $922c4cf5e30ac6d2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $922c4cf5e30ac6d2$var$_extends.apply(null, arguments);
}
var $922c4cf5e30ac6d2$var$LinkPrevious = $922c4cf5e30ac6d2$export$196d3360b25bb94 = /*#__PURE__*/ (0, $922c4cf5e30ac6d2$var$_react.forwardRef)(function(props, ref) {
    var scaleProps = (0, $1b754218be0a6592$export$56a2e46cd4a7c217)(props);
    return /*#__PURE__*/ $922c4cf5e30ac6d2$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $922c4cf5e30ac6d2$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "LinkPrevious"
    }, props), /*#__PURE__*/ $922c4cf5e30ac6d2$var$_react["default"].createElement("path", $922c4cf5e30ac6d2$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M22 12H2m9-9-9 9 9 9"
    }, scaleProps)));
});
$922c4cf5e30ac6d2$var$LinkPrevious.displayName = 'LinkPrevious';


Object.keys($922c4cf5e30ac6d2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $922c4cf5e30ac6d2$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $922c4cf5e30ac6d2$exports[key];
});
var $a3f9bbfa90a9c0aa$exports = {};

$parcel$export($a3f9bbfa90a9c0aa$exports, "__esModule", function () { return $a3f9bbfa90a9c0aa$export$1e511d4a378977f5; }, function (v) { return $a3f9bbfa90a9c0aa$export$1e511d4a378977f5 = v; });
$parcel$export($a3f9bbfa90a9c0aa$exports, "LinkTop", function () { return $a3f9bbfa90a9c0aa$export$d6050fd891ee8648; }, function (v) { return $a3f9bbfa90a9c0aa$export$d6050fd891ee8648 = v; });
var $a3f9bbfa90a9c0aa$export$1e511d4a378977f5;
var $a3f9bbfa90a9c0aa$export$d6050fd891ee8648;
"use strict";
$a3f9bbfa90a9c0aa$export$1e511d4a378977f5 = true;
$a3f9bbfa90a9c0aa$export$d6050fd891ee8648 = void 0;

var $a3f9bbfa90a9c0aa$var$_react = $a3f9bbfa90a9c0aa$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a3f9bbfa90a9c0aa$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a3f9bbfa90a9c0aa$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a3f9bbfa90a9c0aa$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a3f9bbfa90a9c0aa$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a3f9bbfa90a9c0aa$var$_extends() {
    return $a3f9bbfa90a9c0aa$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a3f9bbfa90a9c0aa$var$_extends.apply(null, arguments);
}
var $a3f9bbfa90a9c0aa$var$LinkTop = $a3f9bbfa90a9c0aa$export$d6050fd891ee8648 = /*#__PURE__*/ (0, $a3f9bbfa90a9c0aa$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a3f9bbfa90a9c0aa$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a3f9bbfa90a9c0aa$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "LinkTop"
    }, props), /*#__PURE__*/ $a3f9bbfa90a9c0aa$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 5v18M4 13l8-8 8 8M2 2h20"
    }));
});
$a3f9bbfa90a9c0aa$var$LinkTop.displayName = 'LinkTop';


Object.keys($a3f9bbfa90a9c0aa$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a3f9bbfa90a9c0aa$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a3f9bbfa90a9c0aa$exports[key];
});
var $15621bf5082824e2$exports = {};

$parcel$export($15621bf5082824e2$exports, "__esModule", function () { return $15621bf5082824e2$export$1e511d4a378977f5; }, function (v) { return $15621bf5082824e2$export$1e511d4a378977f5 = v; });
$parcel$export($15621bf5082824e2$exports, "LinkUp", function () { return $15621bf5082824e2$export$56045e1e4a9bb85e; }, function (v) { return $15621bf5082824e2$export$56045e1e4a9bb85e = v; });
var $15621bf5082824e2$export$1e511d4a378977f5;
var $15621bf5082824e2$export$56045e1e4a9bb85e;
"use strict";
$15621bf5082824e2$export$1e511d4a378977f5 = true;
$15621bf5082824e2$export$56045e1e4a9bb85e = void 0;

var $15621bf5082824e2$var$_react = $15621bf5082824e2$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $15621bf5082824e2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($15621bf5082824e2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $15621bf5082824e2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $15621bf5082824e2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $15621bf5082824e2$var$_extends() {
    return $15621bf5082824e2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $15621bf5082824e2$var$_extends.apply(null, arguments);
}
var $15621bf5082824e2$var$LinkUp = $15621bf5082824e2$export$56045e1e4a9bb85e = /*#__PURE__*/ (0, $15621bf5082824e2$var$_react.forwardRef)(function(props, ref) {
    var scaleProps = (0, $1b754218be0a6592$export$56a2e46cd4a7c217)(props);
    return /*#__PURE__*/ $15621bf5082824e2$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $15621bf5082824e2$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "LinkUp"
    }, props), /*#__PURE__*/ $15621bf5082824e2$var$_react["default"].createElement("path", $15621bf5082824e2$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 2v20M3 11l9-9 9 9"
    }, scaleProps)));
});
$15621bf5082824e2$var$LinkUp.displayName = 'LinkUp';


Object.keys($15621bf5082824e2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $15621bf5082824e2$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $15621bf5082824e2$exports[key];
});
var $a8b4b883b3f599f8$exports = {};

$parcel$export($a8b4b883b3f599f8$exports, "__esModule", function () { return $a8b4b883b3f599f8$export$1e511d4a378977f5; }, function (v) { return $a8b4b883b3f599f8$export$1e511d4a378977f5 = v; });
$parcel$export($a8b4b883b3f599f8$exports, "Link", function () { return $a8b4b883b3f599f8$export$a6c7ac8248d6e38a; }, function (v) { return $a8b4b883b3f599f8$export$a6c7ac8248d6e38a = v; });
var $a8b4b883b3f599f8$export$1e511d4a378977f5;
var $a8b4b883b3f599f8$export$a6c7ac8248d6e38a;
"use strict";
$a8b4b883b3f599f8$export$1e511d4a378977f5 = true;
$a8b4b883b3f599f8$export$a6c7ac8248d6e38a = void 0;

var $a8b4b883b3f599f8$var$_react = $a8b4b883b3f599f8$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a8b4b883b3f599f8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a8b4b883b3f599f8$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a8b4b883b3f599f8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a8b4b883b3f599f8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a8b4b883b3f599f8$var$_extends() {
    return $a8b4b883b3f599f8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a8b4b883b3f599f8$var$_extends.apply(null, arguments);
}
var $a8b4b883b3f599f8$var$Link = $a8b4b883b3f599f8$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $a8b4b883b3f599f8$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a8b4b883b3f599f8$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a8b4b883b3f599f8$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Link"
    }, props), /*#__PURE__*/ $a8b4b883b3f599f8$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M16.125 2.42a2.009 2.009 0 0 1 2.84-.001l2.616 2.617a2 2 0 0 1-.001 2.839l-3.705 3.705a2.009 2.009 0 0 1-2.84.001L12.42 8.964a2 2 0 0 1 .001-2.839l3.705-3.705zm-10 10a2.009 2.009 0 0 1 2.84-.001l2.616 2.617a2 2 0 0 1-.001 2.839L7.875 21.58a2.009 2.009 0 0 1-2.84.001L2.42 18.964a2 2 0 0 1 .001-2.839l3.705-3.705zM7 17 17 7"
    }));
});
$a8b4b883b3f599f8$var$Link.displayName = 'Link';


Object.keys($a8b4b883b3f599f8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a8b4b883b3f599f8$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a8b4b883b3f599f8$exports[key];
});
var $e8284852a01ba942$exports = {};

$parcel$export($e8284852a01ba942$exports, "__esModule", function () { return $e8284852a01ba942$export$1e511d4a378977f5; }, function (v) { return $e8284852a01ba942$export$1e511d4a378977f5 = v; });
$parcel$export($e8284852a01ba942$exports, "LinkedinOption", function () { return $e8284852a01ba942$export$4398910ea8ab27a4; }, function (v) { return $e8284852a01ba942$export$4398910ea8ab27a4 = v; });
var $e8284852a01ba942$export$1e511d4a378977f5;
var $e8284852a01ba942$export$4398910ea8ab27a4;
"use strict";
$e8284852a01ba942$export$1e511d4a378977f5 = true;
$e8284852a01ba942$export$4398910ea8ab27a4 = void 0;

var $e8284852a01ba942$var$_react = $e8284852a01ba942$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e8284852a01ba942$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e8284852a01ba942$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e8284852a01ba942$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e8284852a01ba942$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e8284852a01ba942$var$_extends() {
    return $e8284852a01ba942$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e8284852a01ba942$var$_extends.apply(null, arguments);
}
var $e8284852a01ba942$var$LinkedinOption = $e8284852a01ba942$export$4398910ea8ab27a4 = /*#__PURE__*/ (0, $e8284852a01ba942$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e8284852a01ba942$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e8284852a01ba942$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "LinkedinOption"
    }, props), /*#__PURE__*/ $e8284852a01ba942$var$_react["default"].createElement("path", {
        fill: "#0077B5",
        fillRule: "evenodd",
        d: "M22.037 22h-4.152v-6.496c0-1.55-.026-3.542-2.157-3.542-2.16 0-2.49 1.688-2.49 3.43V22H9.09V8.64h3.98v1.827h.058c.553-1.05 1.908-2.158 3.928-2.158 4.204 0 4.98 2.766 4.98 6.364V22zM4.409 6.816A2.407 2.407 0 0 1 2 4.407a2.408 2.408 0 1 1 2.41 2.408zM6.486 22H2.33V8.64h4.156V22z"
    }));
});
$e8284852a01ba942$var$LinkedinOption.displayName = 'LinkedinOption';


Object.keys($e8284852a01ba942$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e8284852a01ba942$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e8284852a01ba942$exports[key];
});
var $74475fec2d4f2f53$exports = {};

$parcel$export($74475fec2d4f2f53$exports, "__esModule", function () { return $74475fec2d4f2f53$export$1e511d4a378977f5; }, function (v) { return $74475fec2d4f2f53$export$1e511d4a378977f5 = v; });
$parcel$export($74475fec2d4f2f53$exports, "Linkedin", function () { return $74475fec2d4f2f53$export$ca041de6a87fe8b; }, function (v) { return $74475fec2d4f2f53$export$ca041de6a87fe8b = v; });
var $74475fec2d4f2f53$export$1e511d4a378977f5;
var $74475fec2d4f2f53$export$ca041de6a87fe8b;
"use strict";
$74475fec2d4f2f53$export$1e511d4a378977f5 = true;
$74475fec2d4f2f53$export$ca041de6a87fe8b = void 0;

var $74475fec2d4f2f53$var$_react = $74475fec2d4f2f53$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $74475fec2d4f2f53$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($74475fec2d4f2f53$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $74475fec2d4f2f53$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $74475fec2d4f2f53$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $74475fec2d4f2f53$var$_extends() {
    return $74475fec2d4f2f53$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $74475fec2d4f2f53$var$_extends.apply(null, arguments);
}
var $74475fec2d4f2f53$var$Linkedin = $74475fec2d4f2f53$export$ca041de6a87fe8b = /*#__PURE__*/ (0, $74475fec2d4f2f53$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $74475fec2d4f2f53$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $74475fec2d4f2f53$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Linkedin"
    }, props), /*#__PURE__*/ $74475fec2d4f2f53$var$_react["default"].createElement("path", {
        fill: "#0077B5",
        fillRule: "evenodd",
        d: "M20.452 20.45h-3.56v-5.57c0-1.328-.022-3.036-1.85-3.036-1.851 0-2.134 1.447-2.134 2.942v5.664H9.352V8.997h3.413v1.566h.049c.475-.9 1.636-1.85 3.367-1.85 3.605 0 4.27 2.371 4.27 5.456v6.281zM5.339 7.433a2.063 2.063 0 1 1 0-4.13 2.065 2.065 0 0 1 0 4.13zM7.12 20.45H3.558V8.997H7.12V20.45zM23 0H1a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1z"
    }));
});
$74475fec2d4f2f53$var$Linkedin.displayName = 'Linkedin';


Object.keys($74475fec2d4f2f53$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $74475fec2d4f2f53$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $74475fec2d4f2f53$exports[key];
});
var $a539916d3867960d$exports = {};

$parcel$export($a539916d3867960d$exports, "__esModule", function () { return $a539916d3867960d$export$1e511d4a378977f5; }, function (v) { return $a539916d3867960d$export$1e511d4a378977f5 = v; });
$parcel$export($a539916d3867960d$exports, "List", function () { return $a539916d3867960d$export$54c2e3dc7acea9f5; }, function (v) { return $a539916d3867960d$export$54c2e3dc7acea9f5 = v; });
var $a539916d3867960d$export$1e511d4a378977f5;
var $a539916d3867960d$export$54c2e3dc7acea9f5;
"use strict";
$a539916d3867960d$export$1e511d4a378977f5 = true;
$a539916d3867960d$export$54c2e3dc7acea9f5 = void 0;

var $a539916d3867960d$var$_react = $a539916d3867960d$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a539916d3867960d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a539916d3867960d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a539916d3867960d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a539916d3867960d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a539916d3867960d$var$_extends() {
    return $a539916d3867960d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a539916d3867960d$var$_extends.apply(null, arguments);
}
var $a539916d3867960d$var$List = $a539916d3867960d$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $a539916d3867960d$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a539916d3867960d$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a539916d3867960d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "List"
    }, props), /*#__PURE__*/ $a539916d3867960d$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: "2",
        d: "M9 6h12M9 12h12M9 18h8M4 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
    }));
});
$a539916d3867960d$var$List.displayName = 'List';


Object.keys($a539916d3867960d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a539916d3867960d$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a539916d3867960d$exports[key];
});
var $0569191a1117facc$exports = {};

$parcel$export($0569191a1117facc$exports, "__esModule", function () { return $0569191a1117facc$export$1e511d4a378977f5; }, function (v) { return $0569191a1117facc$export$1e511d4a378977f5 = v; });
$parcel$export($0569191a1117facc$exports, "Local", function () { return $0569191a1117facc$export$56bc6f4ec5e6b463; }, function (v) { return $0569191a1117facc$export$56bc6f4ec5e6b463 = v; });
var $0569191a1117facc$export$1e511d4a378977f5;
var $0569191a1117facc$export$56bc6f4ec5e6b463;
"use strict";
$0569191a1117facc$export$1e511d4a378977f5 = true;
$0569191a1117facc$export$56bc6f4ec5e6b463 = void 0;

var $0569191a1117facc$var$_react = $0569191a1117facc$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0569191a1117facc$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0569191a1117facc$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0569191a1117facc$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0569191a1117facc$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0569191a1117facc$var$_extends() {
    return $0569191a1117facc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0569191a1117facc$var$_extends.apply(null, arguments);
}
var $0569191a1117facc$var$Local = $0569191a1117facc$export$56bc6f4ec5e6b463 = /*#__PURE__*/ (0, $0569191a1117facc$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0569191a1117facc$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0569191a1117facc$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Local"
    }, props), /*#__PURE__*/ $0569191a1117facc$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 4h22v16H1V4zm10 4h12M1 16h22M1 12h22M11 4v8"
    }));
});
$0569191a1117facc$var$Local.displayName = 'Local';


Object.keys($0569191a1117facc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0569191a1117facc$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0569191a1117facc$exports[key];
});
var $156783c8b512912c$exports = {};

$parcel$export($156783c8b512912c$exports, "__esModule", function () { return $156783c8b512912c$export$1e511d4a378977f5; }, function (v) { return $156783c8b512912c$export$1e511d4a378977f5 = v; });
$parcel$export($156783c8b512912c$exports, "LocationPin", function () { return $156783c8b512912c$export$31790a3eeff59d4a; }, function (v) { return $156783c8b512912c$export$31790a3eeff59d4a = v; });
var $156783c8b512912c$export$1e511d4a378977f5;
var $156783c8b512912c$export$31790a3eeff59d4a;
"use strict";
$156783c8b512912c$export$1e511d4a378977f5 = true;
$156783c8b512912c$export$31790a3eeff59d4a = void 0;

var $156783c8b512912c$var$_react = $156783c8b512912c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $156783c8b512912c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($156783c8b512912c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $156783c8b512912c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $156783c8b512912c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $156783c8b512912c$var$_extends() {
    return $156783c8b512912c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $156783c8b512912c$var$_extends.apply(null, arguments);
}
var $156783c8b512912c$var$LocationPin = $156783c8b512912c$export$31790a3eeff59d4a = /*#__PURE__*/ (0, $156783c8b512912c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $156783c8b512912c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $156783c8b512912c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "LocationPin"
    }, props), /*#__PURE__*/ $156783c8b512912c$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0 0v12"
    }));
});
$156783c8b512912c$var$LocationPin.displayName = 'LocationPin';


Object.keys($156783c8b512912c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $156783c8b512912c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $156783c8b512912c$exports[key];
});
var $c191f8b47f441417$exports = {};

$parcel$export($c191f8b47f441417$exports, "__esModule", function () { return $c191f8b47f441417$export$1e511d4a378977f5; }, function (v) { return $c191f8b47f441417$export$1e511d4a378977f5 = v; });
$parcel$export($c191f8b47f441417$exports, "Location", function () { return $c191f8b47f441417$export$18a2be9195644f38; }, function (v) { return $c191f8b47f441417$export$18a2be9195644f38 = v; });
var $c191f8b47f441417$export$1e511d4a378977f5;
var $c191f8b47f441417$export$18a2be9195644f38;
"use strict";
$c191f8b47f441417$export$1e511d4a378977f5 = true;
$c191f8b47f441417$export$18a2be9195644f38 = void 0;

var $c191f8b47f441417$var$_react = $c191f8b47f441417$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c191f8b47f441417$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c191f8b47f441417$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c191f8b47f441417$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c191f8b47f441417$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c191f8b47f441417$var$_extends() {
    return $c191f8b47f441417$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c191f8b47f441417$var$_extends.apply(null, arguments);
}
var $c191f8b47f441417$var$Location = $c191f8b47f441417$export$18a2be9195644f38 = /*#__PURE__*/ (0, $c191f8b47f441417$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c191f8b47f441417$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c191f8b47f441417$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Location"
    }, props), /*#__PURE__*/ $c191f8b47f441417$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22s-8-6-8-12c0-5 4-8 8-8s8 3 8 8c0 6-8 12-8 12zm0-9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
    }));
});
$c191f8b47f441417$var$Location.displayName = 'Location';


Object.keys($c191f8b47f441417$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c191f8b47f441417$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c191f8b47f441417$exports[key];
});

Object.keys($a717426d13a4ad9f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a717426d13a4ad9f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a717426d13a4ad9f$exports[key];
});
var $678a325c1c930d0e$exports = {};

$parcel$export($678a325c1c930d0e$exports, "__esModule", function () { return $678a325c1c930d0e$export$1e511d4a378977f5; }, function (v) { return $678a325c1c930d0e$export$1e511d4a378977f5 = v; });
$parcel$export($678a325c1c930d0e$exports, "Login", function () { return $678a325c1c930d0e$export$21a94553ffa41578; }, function (v) { return $678a325c1c930d0e$export$21a94553ffa41578 = v; });
var $678a325c1c930d0e$export$1e511d4a378977f5;
var $678a325c1c930d0e$export$21a94553ffa41578;
"use strict";
$678a325c1c930d0e$export$1e511d4a378977f5 = true;
$678a325c1c930d0e$export$21a94553ffa41578 = void 0;

var $678a325c1c930d0e$var$_react = $678a325c1c930d0e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $678a325c1c930d0e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($678a325c1c930d0e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $678a325c1c930d0e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $678a325c1c930d0e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $678a325c1c930d0e$var$_extends() {
    return $678a325c1c930d0e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $678a325c1c930d0e$var$_extends.apply(null, arguments);
}
var $678a325c1c930d0e$var$Login = $678a325c1c930d0e$export$21a94553ffa41578 = /*#__PURE__*/ (0, $678a325c1c930d0e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $678a325c1c930d0e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $678a325c1c930d0e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Login"
    }, props), /*#__PURE__*/ $678a325c1c930d0e$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M9 15v7h13V2H9v7m9 3H0m13-5 5 5-5 5"
    }));
});
$678a325c1c930d0e$var$Login.displayName = 'Login';


Object.keys($678a325c1c930d0e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $678a325c1c930d0e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $678a325c1c930d0e$exports[key];
});
var $c49080af810fd837$exports = {};

$parcel$export($c49080af810fd837$exports, "__esModule", function () { return $c49080af810fd837$export$1e511d4a378977f5; }, function (v) { return $c49080af810fd837$export$1e511d4a378977f5 = v; });
$parcel$export($c49080af810fd837$exports, "Logout", function () { return $c49080af810fd837$export$cad1a703886b4e3a; }, function (v) { return $c49080af810fd837$export$cad1a703886b4e3a = v; });
var $c49080af810fd837$export$1e511d4a378977f5;
var $c49080af810fd837$export$cad1a703886b4e3a;
"use strict";
$c49080af810fd837$export$1e511d4a378977f5 = true;
$c49080af810fd837$export$cad1a703886b4e3a = void 0;

var $c49080af810fd837$var$_react = $c49080af810fd837$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c49080af810fd837$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c49080af810fd837$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c49080af810fd837$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c49080af810fd837$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c49080af810fd837$var$_extends() {
    return $c49080af810fd837$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c49080af810fd837$var$_extends.apply(null, arguments);
}
var $c49080af810fd837$var$Logout = $c49080af810fd837$export$cad1a703886b4e3a = /*#__PURE__*/ (0, $c49080af810fd837$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c49080af810fd837$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c49080af810fd837$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Logout"
    }, props), /*#__PURE__*/ $c49080af810fd837$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#231F20",
        strokeWidth: "2",
        d: "M13 9V2H1v20h12v-7m9-3H5m12-5 5 5-5 5"
    }));
});
$c49080af810fd837$var$Logout.displayName = 'Logout';


Object.keys($c49080af810fd837$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c49080af810fd837$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c49080af810fd837$exports[key];
});
var $a40773be6261a745$exports = {};

$parcel$export($a40773be6261a745$exports, "__esModule", function () { return $a40773be6261a745$export$1e511d4a378977f5; }, function (v) { return $a40773be6261a745$export$1e511d4a378977f5 = v; });
$parcel$export($a40773be6261a745$exports, "Lounge", function () { return $a40773be6261a745$export$514323d6b438f4dc; }, function (v) { return $a40773be6261a745$export$514323d6b438f4dc = v; });
var $a40773be6261a745$export$1e511d4a378977f5;
var $a40773be6261a745$export$514323d6b438f4dc;
"use strict";
$a40773be6261a745$export$1e511d4a378977f5 = true;
$a40773be6261a745$export$514323d6b438f4dc = void 0;

var $a40773be6261a745$var$_react = $a40773be6261a745$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a40773be6261a745$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a40773be6261a745$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a40773be6261a745$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a40773be6261a745$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a40773be6261a745$var$_extends() {
    return $a40773be6261a745$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a40773be6261a745$var$_extends.apply(null, arguments);
}
var $a40773be6261a745$var$Lounge = $a40773be6261a745$export$514323d6b438f4dc = /*#__PURE__*/ (0, $a40773be6261a745$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a40773be6261a745$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a40773be6261a745$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Lounge"
    }, props), /*#__PURE__*/ $a40773be6261a745$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M5 5.997C5 5.447 5.45 5 6.007 5h11.986C18.55 5 19 5.453 19 5.997V13H5V5.997zM22 8v7.003c0 .55-.455.997-.992.997H2.992A.999.999 0 0 1 2 15.003V8m3 8v2-2zm14 0v2-2z"
    }));
});
$a40773be6261a745$var$Lounge.displayName = 'Lounge';


Object.keys($a40773be6261a745$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a40773be6261a745$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a40773be6261a745$exports[key];
});
var $5e044ac3c287cce0$exports = {};

$parcel$export($5e044ac3c287cce0$exports, "__esModule", function () { return $5e044ac3c287cce0$export$1e511d4a378977f5; }, function (v) { return $5e044ac3c287cce0$export$1e511d4a378977f5 = v; });
$parcel$export($5e044ac3c287cce0$exports, "Magic", function () { return $5e044ac3c287cce0$export$480e4c19201e4e74; }, function (v) { return $5e044ac3c287cce0$export$480e4c19201e4e74 = v; });
var $5e044ac3c287cce0$export$1e511d4a378977f5;
var $5e044ac3c287cce0$export$480e4c19201e4e74;
"use strict";
$5e044ac3c287cce0$export$1e511d4a378977f5 = true;
$5e044ac3c287cce0$export$480e4c19201e4e74 = void 0;

var $5e044ac3c287cce0$var$_react = $5e044ac3c287cce0$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5e044ac3c287cce0$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5e044ac3c287cce0$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5e044ac3c287cce0$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5e044ac3c287cce0$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5e044ac3c287cce0$var$_extends() {
    return $5e044ac3c287cce0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5e044ac3c287cce0$var$_extends.apply(null, arguments);
}
var $5e044ac3c287cce0$var$Magic = $5e044ac3c287cce0$export$480e4c19201e4e74 = /*#__PURE__*/ (0, $5e044ac3c287cce0$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5e044ac3c287cce0$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5e044ac3c287cce0$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Magic"
    }, props), /*#__PURE__*/ $5e044ac3c287cce0$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m2.5 19.5 17-17 2 2-17 17-2-2zm.5.5L15 8l1 1L4 21l-1-1zM5.5 3l-.5.5.5.5.5-.5-.5-.5zm6 0-.5.5.5.5.5-.5-.5-.5zm-3 3-.5.5.5.5.5-.5-.5-.5zm12 6-.5.5.5.5.5-.5-.5-.5zm0 5-.5.5.5.5.5-.5-.5-.5z"
    }));
});
$5e044ac3c287cce0$var$Magic.displayName = 'Magic';


Object.keys($5e044ac3c287cce0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5e044ac3c287cce0$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5e044ac3c287cce0$exports[key];
});
var $704e8a762dec7445$exports = {};

$parcel$export($704e8a762dec7445$exports, "__esModule", function () { return $704e8a762dec7445$export$1e511d4a378977f5; }, function (v) { return $704e8a762dec7445$export$1e511d4a378977f5 = v; });
$parcel$export($704e8a762dec7445$exports, "MailOption", function () { return $704e8a762dec7445$export$4e080815042668f8; }, function (v) { return $704e8a762dec7445$export$4e080815042668f8 = v; });
var $704e8a762dec7445$export$1e511d4a378977f5;
var $704e8a762dec7445$export$4e080815042668f8;
"use strict";
$704e8a762dec7445$export$1e511d4a378977f5 = true;
$704e8a762dec7445$export$4e080815042668f8 = void 0;

var $704e8a762dec7445$var$_react = $704e8a762dec7445$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $704e8a762dec7445$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($704e8a762dec7445$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $704e8a762dec7445$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $704e8a762dec7445$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $704e8a762dec7445$var$_extends() {
    return $704e8a762dec7445$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $704e8a762dec7445$var$_extends.apply(null, arguments);
}
var $704e8a762dec7445$var$MailOption = $704e8a762dec7445$export$4e080815042668f8 = /*#__PURE__*/ (0, $704e8a762dec7445$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $704e8a762dec7445$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $704e8a762dec7445$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "MailOption"
    }, props), /*#__PURE__*/ $704e8a762dec7445$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 4h22v16H1V4zm0 1 11 8.5L23 5"
    }));
});
$704e8a762dec7445$var$MailOption.displayName = 'MailOption';


Object.keys($704e8a762dec7445$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $704e8a762dec7445$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $704e8a762dec7445$exports[key];
});
var $0b5477d572d9cf0b$exports = {};

$parcel$export($0b5477d572d9cf0b$exports, "__esModule", function () { return $0b5477d572d9cf0b$export$1e511d4a378977f5; }, function (v) { return $0b5477d572d9cf0b$export$1e511d4a378977f5 = v; });
$parcel$export($0b5477d572d9cf0b$exports, "Mail", function () { return $0b5477d572d9cf0b$export$c1e4990d597057b5; }, function (v) { return $0b5477d572d9cf0b$export$c1e4990d597057b5 = v; });
var $0b5477d572d9cf0b$export$1e511d4a378977f5;
var $0b5477d572d9cf0b$export$c1e4990d597057b5;
"use strict";
$0b5477d572d9cf0b$export$1e511d4a378977f5 = true;
$0b5477d572d9cf0b$export$c1e4990d597057b5 = void 0;

var $0b5477d572d9cf0b$var$_react = $0b5477d572d9cf0b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0b5477d572d9cf0b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0b5477d572d9cf0b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0b5477d572d9cf0b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0b5477d572d9cf0b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0b5477d572d9cf0b$var$_extends() {
    return $0b5477d572d9cf0b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0b5477d572d9cf0b$var$_extends.apply(null, arguments);
}
var $0b5477d572d9cf0b$var$Mail = $0b5477d572d9cf0b$export$c1e4990d597057b5 = /*#__PURE__*/ (0, $0b5477d572d9cf0b$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0b5477d572d9cf0b$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0b5477d572d9cf0b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Mail"
    }, props), /*#__PURE__*/ $0b5477d572d9cf0b$var$_react["default"].createElement("path", {
        fill: "#01A982",
        fillRule: "evenodd",
        d: "M23 20V6l-11 9L1 6v14h22zm-11-8 10-8H2l10 8z"
    }));
});
$0b5477d572d9cf0b$var$Mail.displayName = 'Mail';


Object.keys($0b5477d572d9cf0b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0b5477d572d9cf0b$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0b5477d572d9cf0b$exports[key];
});
var $3eb1e625a417dcd3$exports = {};

$parcel$export($3eb1e625a417dcd3$exports, "__esModule", function () { return $3eb1e625a417dcd3$export$1e511d4a378977f5; }, function (v) { return $3eb1e625a417dcd3$export$1e511d4a378977f5 = v; });
$parcel$export($3eb1e625a417dcd3$exports, "Mandriva", function () { return $3eb1e625a417dcd3$export$ea40c9515e41b5da; }, function (v) { return $3eb1e625a417dcd3$export$ea40c9515e41b5da = v; });
var $3eb1e625a417dcd3$export$1e511d4a378977f5;
var $3eb1e625a417dcd3$export$ea40c9515e41b5da;
"use strict";
$3eb1e625a417dcd3$export$1e511d4a378977f5 = true;
$3eb1e625a417dcd3$export$ea40c9515e41b5da = void 0;

var $3eb1e625a417dcd3$var$_react = $3eb1e625a417dcd3$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $3eb1e625a417dcd3$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3eb1e625a417dcd3$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3eb1e625a417dcd3$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3eb1e625a417dcd3$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3eb1e625a417dcd3$var$_extends() {
    return $3eb1e625a417dcd3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3eb1e625a417dcd3$var$_extends.apply(null, arguments);
}
var $3eb1e625a417dcd3$var$Mandriva = $3eb1e625a417dcd3$export$ea40c9515e41b5da = /*#__PURE__*/ (0, $3eb1e625a417dcd3$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3eb1e625a417dcd3$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3eb1e625a417dcd3$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Mandriva"
    }, props), /*#__PURE__*/ $3eb1e625a417dcd3$var$_react["default"].createElement("path", {
        fill: "#E8B845",
        fillRule: "evenodd",
        d: "M14.557 17.2c-3.021 2.72-6.354 4.146-9.075 4.148h-.008c-1.938-.001-3.565-.726-4.544-2.222C-1.43 15.519.858 8.797 6.042 4.11c.44-.398.888-.768 1.339-1.111-4.343 4.582-6.112 10.546-3.938 13.868 1.952 2.983 6.474 2.899 10.912.13l-1.323-1.332c-.157-.157-.428-.258-.692-.258a.826.826 0 0 0-.292.05l-4.279 1.656a.774.774 0 0 1-.275.06c-.176 0-.259-.093-.292-.148-.052-.085-.087-.24.042-.495l2.094-4.082c.148-.29.1-.748-.105-1L6.336 7.892c-.195-.239-.18-.406-.134-.504.033-.07.126-.19.372-.19.048 0 .1.006.155.015l4.528.729a.68.68 0 0 0 .11.008c.307 0 .655-.18.809-.417l2.487-3.853c.152-.237.302-.287.4-.287.09 0 .306.044.368.449l.706 4.533c.05.322.358.664.672.747l4.434 1.175c.332.088.399.259.408.352.01.094-.019.274-.325.43l-4.094 2.07c-.29.147-.52.545-.502.87l.253 4.582c.01.193-.027.337-.113.428a.292.292 0 0 1-.217.093c-.123 0-.253-.068-.387-.203L14.557 17.2zM24 11.403c-1.245-.672-1.423-.64-2.355.424.671-1.244.639-1.423-.425-2.356 1.245.672 1.424.64 2.356-.424-.672 1.245-.64 1.424.424 2.356z"
    }));
});
$3eb1e625a417dcd3$var$Mandriva.displayName = 'Mandriva';


Object.keys($3eb1e625a417dcd3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3eb1e625a417dcd3$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3eb1e625a417dcd3$exports[key];
});
var $8f4ca7fd610ca53e$exports = {};

$parcel$export($8f4ca7fd610ca53e$exports, "__esModule", function () { return $8f4ca7fd610ca53e$export$1e511d4a378977f5; }, function (v) { return $8f4ca7fd610ca53e$export$1e511d4a378977f5 = v; });
$parcel$export($8f4ca7fd610ca53e$exports, "Manual", function () { return $8f4ca7fd610ca53e$export$20024d1b84b1eccc; }, function (v) { return $8f4ca7fd610ca53e$export$20024d1b84b1eccc = v; });
var $8f4ca7fd610ca53e$export$1e511d4a378977f5;
var $8f4ca7fd610ca53e$export$20024d1b84b1eccc;
"use strict";
$8f4ca7fd610ca53e$export$1e511d4a378977f5 = true;
$8f4ca7fd610ca53e$export$20024d1b84b1eccc = void 0;

var $8f4ca7fd610ca53e$var$_react = $8f4ca7fd610ca53e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $8f4ca7fd610ca53e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8f4ca7fd610ca53e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8f4ca7fd610ca53e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $8f4ca7fd610ca53e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8f4ca7fd610ca53e$var$_extends() {
    return $8f4ca7fd610ca53e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8f4ca7fd610ca53e$var$_extends.apply(null, arguments);
}
var $8f4ca7fd610ca53e$var$Manual = $8f4ca7fd610ca53e$export$20024d1b84b1eccc = /*#__PURE__*/ (0, $8f4ca7fd610ca53e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $8f4ca7fd610ca53e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $8f4ca7fd610ca53e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Manual"
    }, props), /*#__PURE__*/ $8f4ca7fd610ca53e$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M14 9v8-8zm-4 0v8-8zM8 5a4 4 0 1 0 8 0 4 4 0 0 0-8 0zM4 23h16v-3H4v3zm3-3h10v-3H7v3z"
    }));
});
$8f4ca7fd610ca53e$var$Manual.displayName = 'Manual';


Object.keys($8f4ca7fd610ca53e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $8f4ca7fd610ca53e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $8f4ca7fd610ca53e$exports[key];
});
var $934b74652e6336a2$exports = {};

$parcel$export($934b74652e6336a2$exports, "__esModule", function () { return $934b74652e6336a2$export$1e511d4a378977f5; }, function (v) { return $934b74652e6336a2$export$1e511d4a378977f5 = v; });
$parcel$export($934b74652e6336a2$exports, "MapLocation", function () { return $934b74652e6336a2$export$919cd7230f55bee7; }, function (v) { return $934b74652e6336a2$export$919cd7230f55bee7 = v; });
var $934b74652e6336a2$export$1e511d4a378977f5;
var $934b74652e6336a2$export$919cd7230f55bee7;
"use strict";
$934b74652e6336a2$export$1e511d4a378977f5 = true;
$934b74652e6336a2$export$919cd7230f55bee7 = void 0;

var $934b74652e6336a2$var$_react = $934b74652e6336a2$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $934b74652e6336a2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($934b74652e6336a2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $934b74652e6336a2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $934b74652e6336a2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $934b74652e6336a2$var$_extends() {
    return $934b74652e6336a2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $934b74652e6336a2$var$_extends.apply(null, arguments);
}
var $934b74652e6336a2$var$MapLocation = $934b74652e6336a2$export$919cd7230f55bee7 = /*#__PURE__*/ (0, $934b74652e6336a2$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $934b74652e6336a2$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $934b74652e6336a2$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "MapLocation"
    }, props), /*#__PURE__*/ $934b74652e6336a2$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M17.5 6.5 23 9v13l-7-3-8 3-7-3V6l5 2m10 11v-7M8 22V12m4 4.273S6 11.5 6 7c0-3.75 3-6 6-6s6 2.25 6 6c0 4.5-6 9.273-6 9.273zM13 7a1 1 0 1 0-2 0 1 1 0 0 0 2 0z"
    }));
});
$934b74652e6336a2$var$MapLocation.displayName = 'MapLocation';


Object.keys($934b74652e6336a2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $934b74652e6336a2$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $934b74652e6336a2$exports[key];
});
var $d75e1e899ba15866$exports = {};

$parcel$export($d75e1e899ba15866$exports, "__esModule", function () { return $d75e1e899ba15866$export$1e511d4a378977f5; }, function (v) { return $d75e1e899ba15866$export$1e511d4a378977f5 = v; });
$parcel$export($d75e1e899ba15866$exports, "Map", function () { return $d75e1e899ba15866$export$a5c7b93649eaf8f8; }, function (v) { return $d75e1e899ba15866$export$a5c7b93649eaf8f8 = v; });
var $d75e1e899ba15866$export$1e511d4a378977f5;
var $d75e1e899ba15866$export$a5c7b93649eaf8f8;
"use strict";
$d75e1e899ba15866$export$1e511d4a378977f5 = true;
$d75e1e899ba15866$export$a5c7b93649eaf8f8 = void 0;

var $d75e1e899ba15866$var$_react = $d75e1e899ba15866$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $d75e1e899ba15866$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d75e1e899ba15866$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d75e1e899ba15866$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d75e1e899ba15866$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d75e1e899ba15866$var$_extends() {
    return $d75e1e899ba15866$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d75e1e899ba15866$var$_extends.apply(null, arguments);
}
var $d75e1e899ba15866$var$Map = $d75e1e899ba15866$export$a5c7b93649eaf8f8 = /*#__PURE__*/ (0, $d75e1e899ba15866$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d75e1e899ba15866$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $d75e1e899ba15866$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Map"
    }, props), /*#__PURE__*/ $d75e1e899ba15866$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M15 15h4l3 7H2l3-7h4m4-7a1 1 0 1 1-2 0 1 1 0 0 1 2 0M6 8c0 5 6 10 6 10s6-5 6-10c0-3.417-2.686-6-6-6S6 4.583 6 8z"
    }));
});
$d75e1e899ba15866$var$Map.displayName = 'Map';


Object.keys($d75e1e899ba15866$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $d75e1e899ba15866$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $d75e1e899ba15866$exports[key];
});
var $8076da56620c0049$exports = {};

$parcel$export($8076da56620c0049$exports, "__esModule", function () { return $8076da56620c0049$export$1e511d4a378977f5; }, function (v) { return $8076da56620c0049$export$1e511d4a378977f5 = v; });
$parcel$export($8076da56620c0049$exports, "Mastercard", function () { return $8076da56620c0049$export$a2697f3d1c498148; }, function (v) { return $8076da56620c0049$export$a2697f3d1c498148 = v; });
var $8076da56620c0049$export$1e511d4a378977f5;
var $8076da56620c0049$export$a2697f3d1c498148;
"use strict";
$8076da56620c0049$export$1e511d4a378977f5 = true;
$8076da56620c0049$export$a2697f3d1c498148 = void 0;

var $8076da56620c0049$var$_react = $8076da56620c0049$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $8076da56620c0049$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8076da56620c0049$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8076da56620c0049$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $8076da56620c0049$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8076da56620c0049$var$_extends() {
    return $8076da56620c0049$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8076da56620c0049$var$_extends.apply(null, arguments);
}
var $8076da56620c0049$var$Mastercard = $8076da56620c0049$export$a2697f3d1c498148 = /*#__PURE__*/ (0, $8076da56620c0049$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $8076da56620c0049$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $8076da56620c0049$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Mastercard"
    }, props), /*#__PURE__*/ $8076da56620c0049$var$_react["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $8076da56620c0049$var$_react["default"].createElement("circle", {
        cx: "7",
        cy: "12",
        r: "7",
        fill: "#EA001B"
    }), /*#__PURE__*/ $8076da56620c0049$var$_react["default"].createElement("circle", {
        cx: "17",
        cy: "12",
        r: "7",
        fill: "#FFA200",
        fillOpacity: ".8"
    })));
});
$8076da56620c0049$var$Mastercard.displayName = 'Mastercard';


Object.keys($8076da56620c0049$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $8076da56620c0049$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $8076da56620c0049$exports[key];
});
var $25b2e3e62a69fcce$exports = {};

$parcel$export($25b2e3e62a69fcce$exports, "__esModule", function () { return $25b2e3e62a69fcce$export$1e511d4a378977f5; }, function (v) { return $25b2e3e62a69fcce$export$1e511d4a378977f5 = v; });
$parcel$export($25b2e3e62a69fcce$exports, "Medium", function () { return $25b2e3e62a69fcce$export$c7835fd8b8ca1d68; }, function (v) { return $25b2e3e62a69fcce$export$c7835fd8b8ca1d68 = v; });
var $25b2e3e62a69fcce$export$1e511d4a378977f5;
var $25b2e3e62a69fcce$export$c7835fd8b8ca1d68;
"use strict";
$25b2e3e62a69fcce$export$1e511d4a378977f5 = true;
$25b2e3e62a69fcce$export$c7835fd8b8ca1d68 = void 0;

var $25b2e3e62a69fcce$var$_react = $25b2e3e62a69fcce$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $25b2e3e62a69fcce$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($25b2e3e62a69fcce$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $25b2e3e62a69fcce$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $25b2e3e62a69fcce$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $25b2e3e62a69fcce$var$_extends() {
    return $25b2e3e62a69fcce$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $25b2e3e62a69fcce$var$_extends.apply(null, arguments);
}
var $25b2e3e62a69fcce$var$Medium = $25b2e3e62a69fcce$export$c7835fd8b8ca1d68 = /*#__PURE__*/ (0, $25b2e3e62a69fcce$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $25b2e3e62a69fcce$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $25b2e3e62a69fcce$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Medium"
    }, props), /*#__PURE__*/ $25b2e3e62a69fcce$var$_react["default"].createElement("path", {
        fill: "#000",
        d: "M6.783 5a6.783 6.783 0 1 0 0 13.565A6.783 6.783 0 0 0 6.783 5Zm10.695.522c-1.873 0-3.391 2.803-3.391 6.26 0 .65.053 1.274.152 1.862.132.784.346 1.502.622 2.121.138.31.292.594.46.849.335.51.724.904 1.149 1.148.319.183.657.282 1.008.282s.69-.1 1.009-.282c.425-.244.814-.638 1.149-1.148.167-.255.321-.54.46-.849.276-.618.49-1.337.621-2.12.1-.589.153-1.214.153-1.862 0-3.458-1.519-6.261-3.392-6.261Zm5.218.521c-.136 0-.266.09-.388.259-.082.111-.16.257-.234.434a4.007 4.007 0 0 0-.107.288c-.07.206-.134.441-.193.7-.118.52-.214 1.138-.28 1.825a22.61 22.61 0 0 0-.103 2.234 24.502 24.502 0 0 0 .103 2.234c.066.686.162 1.305.28 1.824.059.26.123.495.193.7.034.104.07.2.107.288.074.177.153.323.234.435.122.168.253.258.388.258.72 0 1.304-2.57 1.304-5.74 0-3.169-.584-5.739-1.304-5.739Z"
    }));
});
$25b2e3e62a69fcce$var$Medium.displayName = 'Medium';


Object.keys($25b2e3e62a69fcce$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $25b2e3e62a69fcce$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $25b2e3e62a69fcce$exports[key];
});
var $f83b000c717dbbf9$exports = {};

$parcel$export($f83b000c717dbbf9$exports, "__esModule", function () { return $f83b000c717dbbf9$export$1e511d4a378977f5; }, function (v) { return $f83b000c717dbbf9$export$1e511d4a378977f5 = v; });
$parcel$export($f83b000c717dbbf9$exports, "Memory", function () { return $f83b000c717dbbf9$export$29d4d7bc03c348a5; }, function (v) { return $f83b000c717dbbf9$export$29d4d7bc03c348a5 = v; });
var $f83b000c717dbbf9$export$1e511d4a378977f5;
var $f83b000c717dbbf9$export$29d4d7bc03c348a5;
"use strict";
$f83b000c717dbbf9$export$1e511d4a378977f5 = true;
$f83b000c717dbbf9$export$29d4d7bc03c348a5 = void 0;

var $f83b000c717dbbf9$var$_react = $f83b000c717dbbf9$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f83b000c717dbbf9$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f83b000c717dbbf9$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f83b000c717dbbf9$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f83b000c717dbbf9$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f83b000c717dbbf9$var$_extends() {
    return $f83b000c717dbbf9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f83b000c717dbbf9$var$_extends.apply(null, arguments);
}
var $f83b000c717dbbf9$var$Memory = $f83b000c717dbbf9$export$29d4d7bc03c348a5 = /*#__PURE__*/ (0, $f83b000c717dbbf9$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f83b000c717dbbf9$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f83b000c717dbbf9$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Memory"
    }, props), /*#__PURE__*/ $f83b000c717dbbf9$var$_react["default"].createElement("path", {
        stroke: "#000",
        strokeWidth: "2",
        fill: "none",
        d: "M10 18h4m-4-4h4m-4-4h4m-4-4h4m6 12h3m-3-4h3m-3-4h3m-3-4h3M1 18h3m-3-4h3m-3-4h3M1 6h3m11 14h4a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1zM5 20h4a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1z"
    }));
});
$f83b000c717dbbf9$var$Memory.displayName = 'Memory';


Object.keys($f83b000c717dbbf9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f83b000c717dbbf9$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f83b000c717dbbf9$exports[key];
});
var $93016bff78bf081f$exports = {};

$parcel$export($93016bff78bf081f$exports, "__esModule", function () { return $93016bff78bf081f$export$1e511d4a378977f5; }, function (v) { return $93016bff78bf081f$export$1e511d4a378977f5 = v; });
$parcel$export($93016bff78bf081f$exports, "Menu", function () { return $93016bff78bf081f$export$d9b273488cd8ce6f; }, function (v) { return $93016bff78bf081f$export$d9b273488cd8ce6f = v; });
var $93016bff78bf081f$export$1e511d4a378977f5;
var $93016bff78bf081f$export$d9b273488cd8ce6f;
"use strict";
$93016bff78bf081f$export$1e511d4a378977f5 = true;
$93016bff78bf081f$export$d9b273488cd8ce6f = void 0;

var $93016bff78bf081f$var$_react = $93016bff78bf081f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $93016bff78bf081f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($93016bff78bf081f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $93016bff78bf081f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $93016bff78bf081f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $93016bff78bf081f$var$_extends() {
    return $93016bff78bf081f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $93016bff78bf081f$var$_extends.apply(null, arguments);
}
var $93016bff78bf081f$var$Menu = $93016bff78bf081f$export$d9b273488cd8ce6f = /*#__PURE__*/ (0, $93016bff78bf081f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $93016bff78bf081f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $93016bff78bf081f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Menu"
    }, props), /*#__PURE__*/ $93016bff78bf081f$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 19h20M2 5h20M2 12h20"
    }));
});
$93016bff78bf081f$var$Menu.displayName = 'Menu';


Object.keys($93016bff78bf081f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $93016bff78bf081f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $93016bff78bf081f$exports[key];
});
var $52de7a09f1f4242f$exports = {};

$parcel$export($52de7a09f1f4242f$exports, "__esModule", function () { return $52de7a09f1f4242f$export$1e511d4a378977f5; }, function (v) { return $52de7a09f1f4242f$export$1e511d4a378977f5 = v; });
$parcel$export($52de7a09f1f4242f$exports, "Meta", function () { return $52de7a09f1f4242f$export$b08a9033b36413fb; }, function (v) { return $52de7a09f1f4242f$export$b08a9033b36413fb = v; });
var $52de7a09f1f4242f$export$1e511d4a378977f5;
var $52de7a09f1f4242f$export$b08a9033b36413fb;
"use strict";
$52de7a09f1f4242f$export$1e511d4a378977f5 = true;
$52de7a09f1f4242f$export$b08a9033b36413fb = void 0;

var $52de7a09f1f4242f$var$_react = $52de7a09f1f4242f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $52de7a09f1f4242f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($52de7a09f1f4242f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $52de7a09f1f4242f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $52de7a09f1f4242f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $52de7a09f1f4242f$var$_extends() {
    return $52de7a09f1f4242f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $52de7a09f1f4242f$var$_extends.apply(null, arguments);
}
var $52de7a09f1f4242f$var$Meta = $52de7a09f1f4242f$export$b08a9033b36413fb = /*#__PURE__*/ (0, $52de7a09f1f4242f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $52de7a09f1f4242f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $52de7a09f1f4242f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Meta"
    }, props), /*#__PURE__*/ $52de7a09f1f4242f$var$_react["default"].createElement("path", {
        fill: "#0081FB",
        d: "M2.562 14.676c0-3.929 1.965-8.028 4.27-8.028 1.282 0 2.307.768 3.93 3.074a1702.683 1702.683 0 0 1-2.477 3.844c-2.05 3.245-2.733 3.929-3.844 3.929-1.11.085-1.879-.94-1.879-2.819Zm13.41-1.452-1.452-2.391c-.342-.598-.77-1.196-1.11-1.708 1.28-1.965 2.305-2.99 3.586-2.99 2.563 0 4.613 3.844 4.613 8.627 0 1.793-.598 2.818-1.794 2.818-1.196 0-1.623-.769-3.844-4.356Zm-3.673-5.808C10.419 4.94 8.797 4 6.919 4 2.988 4 0 9.21 0 14.676c0 3.417 1.623 5.552 4.356 5.552 1.964 0 3.33-.94 5.893-5.381 0 0 1.025-1.879 1.794-3.16.256.427.512.854.768 1.366l1.196 2.05c2.306 3.929 3.587 5.21 5.893 5.21 2.648 0 4.1-2.22 4.1-5.722C23.915 8.783 20.84 4 17.167 4c-1.964 0-3.502 1.537-4.868 3.416Z"
    }));
});
$52de7a09f1f4242f$var$Meta.displayName = 'Meta';


Object.keys($52de7a09f1f4242f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $52de7a09f1f4242f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $52de7a09f1f4242f$exports[key];
});
var $af323413040fa3a4$exports = {};

$parcel$export($af323413040fa3a4$exports, "__esModule", function () { return $af323413040fa3a4$export$1e511d4a378977f5; }, function (v) { return $af323413040fa3a4$export$1e511d4a378977f5 = v; });
$parcel$export($af323413040fa3a4$exports, "Microfocus", function () { return $af323413040fa3a4$export$7bb593b69ef98e09; }, function (v) { return $af323413040fa3a4$export$7bb593b69ef98e09 = v; });
var $af323413040fa3a4$export$1e511d4a378977f5;
var $af323413040fa3a4$export$7bb593b69ef98e09;
"use strict";
$af323413040fa3a4$export$1e511d4a378977f5 = true;
$af323413040fa3a4$export$7bb593b69ef98e09 = void 0;

var $af323413040fa3a4$var$_react = $af323413040fa3a4$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $af323413040fa3a4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($af323413040fa3a4$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $af323413040fa3a4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $af323413040fa3a4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $af323413040fa3a4$var$_extends() {
    return $af323413040fa3a4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $af323413040fa3a4$var$_extends.apply(null, arguments);
}
var $af323413040fa3a4$var$Microfocus = $af323413040fa3a4$export$7bb593b69ef98e09 = /*#__PURE__*/ (0, $af323413040fa3a4$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $af323413040fa3a4$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $af323413040fa3a4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Microfocus"
    }, props), /*#__PURE__*/ $af323413040fa3a4$var$_react["default"].createElement("path", {
        fill: "#0078EF",
        fillRule: "evenodd",
        d: "M1 5h4v14h14v4H1V5zm4-4h18v18h-4V5H5V1z"
    }));
});
$af323413040fa3a4$var$Microfocus.displayName = 'Microfocus';


Object.keys($af323413040fa3a4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $af323413040fa3a4$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $af323413040fa3a4$exports[key];
});
var $4c615a1d257b9668$exports = {};

$parcel$export($4c615a1d257b9668$exports, "__esModule", function () { return $4c615a1d257b9668$export$1e511d4a378977f5; }, function (v) { return $4c615a1d257b9668$export$1e511d4a378977f5 = v; });
$parcel$export($4c615a1d257b9668$exports, "Microphone", function () { return $4c615a1d257b9668$export$df91f3efeb156795; }, function (v) { return $4c615a1d257b9668$export$df91f3efeb156795 = v; });
var $4c615a1d257b9668$export$1e511d4a378977f5;
var $4c615a1d257b9668$export$df91f3efeb156795;
"use strict";
$4c615a1d257b9668$export$1e511d4a378977f5 = true;
$4c615a1d257b9668$export$df91f3efeb156795 = void 0;

var $4c615a1d257b9668$var$_react = $4c615a1d257b9668$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $4c615a1d257b9668$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4c615a1d257b9668$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4c615a1d257b9668$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $4c615a1d257b9668$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $4c615a1d257b9668$var$_extends() {
    return $4c615a1d257b9668$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4c615a1d257b9668$var$_extends.apply(null, arguments);
}
var $4c615a1d257b9668$var$Microphone = $4c615a1d257b9668$export$df91f3efeb156795 = /*#__PURE__*/ (0, $4c615a1d257b9668$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $4c615a1d257b9668$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $4c615a1d257b9668$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Microphone"
    }, props), /*#__PURE__*/ $4c615a1d257b9668$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8 11c0 3 1.79 4 4 4s4-1 4-4V5c0-3-1.79-4-4-4S8 2 8 5v6zM4 9v2c0 5 3.582 8 8 8s8-3 8-8V9m-8 15v-5"
    }));
});
$4c615a1d257b9668$var$Microphone.displayName = 'Microphone';


Object.keys($4c615a1d257b9668$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $4c615a1d257b9668$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $4c615a1d257b9668$exports[key];
});
var $b69c3a0f31fdfe28$exports = {};

$parcel$export($b69c3a0f31fdfe28$exports, "__esModule", function () { return $b69c3a0f31fdfe28$export$1e511d4a378977f5; }, function (v) { return $b69c3a0f31fdfe28$export$1e511d4a378977f5 = v; });
$parcel$export($b69c3a0f31fdfe28$exports, "Money", function () { return $b69c3a0f31fdfe28$export$d26bcf891bc220f6; }, function (v) { return $b69c3a0f31fdfe28$export$d26bcf891bc220f6 = v; });
var $b69c3a0f31fdfe28$export$1e511d4a378977f5;
var $b69c3a0f31fdfe28$export$d26bcf891bc220f6;
"use strict";
$b69c3a0f31fdfe28$export$1e511d4a378977f5 = true;
$b69c3a0f31fdfe28$export$d26bcf891bc220f6 = void 0;

var $b69c3a0f31fdfe28$var$_react = $b69c3a0f31fdfe28$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $b69c3a0f31fdfe28$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b69c3a0f31fdfe28$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b69c3a0f31fdfe28$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $b69c3a0f31fdfe28$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b69c3a0f31fdfe28$var$_extends() {
    return $b69c3a0f31fdfe28$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b69c3a0f31fdfe28$var$_extends.apply(null, arguments);
}
var $b69c3a0f31fdfe28$var$Money = $b69c3a0f31fdfe28$export$d26bcf891bc220f6 = /*#__PURE__*/ (0, $b69c3a0f31fdfe28$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $b69c3a0f31fdfe28$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $b69c3a0f31fdfe28$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Money"
    }, props), /*#__PURE__*/ $b69c3a0f31fdfe28$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M16 16c0-1.105-3.134-2-7-2s-7 .895-7 2 3.134 2 7 2 7-.895 7-2zM2 16v4.937C2 22.077 5.134 23 9 23s7-.924 7-2.063V16M9 5c-4.418 0-8 .895-8 2s3.582 2 8 2M1 7v5c0 1.013 3.582 2 8 2M23 4c0-1.105-3.1-2-6.923-2-3.824 0-6.923.895-6.923 2s3.1 2 6.923 2S23 5.105 23 4zm-7 12c3.824 0 7-.987 7-2V4M9.154 4v10.166M9 9c0 1.013 3.253 2 7.077 2C19.9 11 23 10.013 23 9"
    }));
});
$b69c3a0f31fdfe28$var$Money.displayName = 'Money';


Object.keys($b69c3a0f31fdfe28$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $b69c3a0f31fdfe28$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $b69c3a0f31fdfe28$exports[key];
});
var $8f2ff287a1a1cb53$exports = {};

$parcel$export($8f2ff287a1a1cb53$exports, "__esModule", function () { return $8f2ff287a1a1cb53$export$1e511d4a378977f5; }, function (v) { return $8f2ff287a1a1cb53$export$1e511d4a378977f5 = v; });
$parcel$export($8f2ff287a1a1cb53$exports, "Monitor", function () { return $8f2ff287a1a1cb53$export$3de16b9a4e4a99f4; }, function (v) { return $8f2ff287a1a1cb53$export$3de16b9a4e4a99f4 = v; });
var $8f2ff287a1a1cb53$export$1e511d4a378977f5;
var $8f2ff287a1a1cb53$export$3de16b9a4e4a99f4;
"use strict";
$8f2ff287a1a1cb53$export$1e511d4a378977f5 = true;
$8f2ff287a1a1cb53$export$3de16b9a4e4a99f4 = void 0;

var $8f2ff287a1a1cb53$var$_react = $8f2ff287a1a1cb53$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $8f2ff287a1a1cb53$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8f2ff287a1a1cb53$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8f2ff287a1a1cb53$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $8f2ff287a1a1cb53$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8f2ff287a1a1cb53$var$_extends() {
    return $8f2ff287a1a1cb53$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8f2ff287a1a1cb53$var$_extends.apply(null, arguments);
}
var $8f2ff287a1a1cb53$var$Monitor = $8f2ff287a1a1cb53$export$3de16b9a4e4a99f4 = /*#__PURE__*/ (0, $8f2ff287a1a1cb53$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $8f2ff287a1a1cb53$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $8f2ff287a1a1cb53$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Monitor"
    }, props), /*#__PURE__*/ $8f2ff287a1a1cb53$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 16h22V2H1v14zm4 6h14H5zm4 0h6v-6H9v6z"
    }));
});
$8f2ff287a1a1cb53$var$Monitor.displayName = 'Monitor';


Object.keys($8f2ff287a1a1cb53$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $8f2ff287a1a1cb53$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $8f2ff287a1a1cb53$exports[key];
});
var $76cdeaf73ee2809c$exports = {};

$parcel$export($76cdeaf73ee2809c$exports, "__esModule", function () { return $76cdeaf73ee2809c$export$1e511d4a378977f5; }, function (v) { return $76cdeaf73ee2809c$export$1e511d4a378977f5 = v; });
$parcel$export($76cdeaf73ee2809c$exports, "Monospace", function () { return $76cdeaf73ee2809c$export$7eabc8613fb46543; }, function (v) { return $76cdeaf73ee2809c$export$7eabc8613fb46543 = v; });
var $76cdeaf73ee2809c$export$1e511d4a378977f5;
var $76cdeaf73ee2809c$export$7eabc8613fb46543;
"use strict";
$76cdeaf73ee2809c$export$1e511d4a378977f5 = true;
$76cdeaf73ee2809c$export$7eabc8613fb46543 = void 0;

var $76cdeaf73ee2809c$var$_react = $76cdeaf73ee2809c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $76cdeaf73ee2809c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($76cdeaf73ee2809c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $76cdeaf73ee2809c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $76cdeaf73ee2809c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $76cdeaf73ee2809c$var$_extends() {
    return $76cdeaf73ee2809c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $76cdeaf73ee2809c$var$_extends.apply(null, arguments);
}
var $76cdeaf73ee2809c$var$Monospace = $76cdeaf73ee2809c$export$7eabc8613fb46543 = /*#__PURE__*/ (0, $76cdeaf73ee2809c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $76cdeaf73ee2809c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $76cdeaf73ee2809c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Monospace"
    }, props), /*#__PURE__*/ $76cdeaf73ee2809c$var$_react["default"].createElement("path", {
        d: "M11.88 17h-2.3l-.93-2.9H4.44L3.57 17H1.32L5.41 4.17h2.25zM8 11.93 6.52 7.17l-1.43 4.76zM14.13 17 12.22 4.17h1.66L15.07 13l1.46-8.82h1.92l1.4 9 1.23-9h1.62L20.78 17h-1.72l-1.6-9.6-1.58 9.6zm-2.77.95v1.39H1.89v-1.39h-.51v1.91h10.49v-1.91h-.51zm10.81.05v1.39h-9.48V18h-.5v1.91h10.49V18h-.51z"
    }));
});
$76cdeaf73ee2809c$var$Monospace.displayName = 'Monospace';


Object.keys($76cdeaf73ee2809c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $76cdeaf73ee2809c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $76cdeaf73ee2809c$exports[key];
});
var $b877cf2e886ed56b$exports = {};

$parcel$export($b877cf2e886ed56b$exports, "__esModule", function () { return $b877cf2e886ed56b$export$1e511d4a378977f5; }, function (v) { return $b877cf2e886ed56b$export$1e511d4a378977f5 = v; });
$parcel$export($b877cf2e886ed56b$exports, "Moon", function () { return $b877cf2e886ed56b$export$ab2e8fc3a68054ee; }, function (v) { return $b877cf2e886ed56b$export$ab2e8fc3a68054ee = v; });
var $b877cf2e886ed56b$export$1e511d4a378977f5;
var $b877cf2e886ed56b$export$ab2e8fc3a68054ee;
"use strict";
$b877cf2e886ed56b$export$1e511d4a378977f5 = true;
$b877cf2e886ed56b$export$ab2e8fc3a68054ee = void 0;

var $b877cf2e886ed56b$var$_react = $b877cf2e886ed56b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $b877cf2e886ed56b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b877cf2e886ed56b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b877cf2e886ed56b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $b877cf2e886ed56b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b877cf2e886ed56b$var$_extends() {
    return $b877cf2e886ed56b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b877cf2e886ed56b$var$_extends.apply(null, arguments);
}
var $b877cf2e886ed56b$var$Moon = $b877cf2e886ed56b$export$ab2e8fc3a68054ee = /*#__PURE__*/ (0, $b877cf2e886ed56b$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $b877cf2e886ed56b$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $b877cf2e886ed56b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Moon"
    }, props), /*#__PURE__*/ $b877cf2e886ed56b$var$_react["default"].createElement("path", {
        stroke: "#000",
        fill: "none",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M9.874 5.008c2.728-1.68 6.604-1.014 8.25.197-2.955.84-5.11 3.267-5.242 6.415-.18 4.28 3.006 6.588 5.24 7.152-1.964 1.343-4.36 1.293-5.235 1.172-3.568-.492-6.902-3.433-7.007-7.711-.106-4.278 2.573-6.35 3.994-7.225z"
    }));
});
$b877cf2e886ed56b$var$Moon.displayName = 'Moon';


Object.keys($b877cf2e886ed56b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $b877cf2e886ed56b$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $b877cf2e886ed56b$exports[key];
});
var $b8dc09db7c242d46$exports = {};

$parcel$export($b8dc09db7c242d46$exports, "__esModule", function () { return $b8dc09db7c242d46$export$1e511d4a378977f5; }, function (v) { return $b8dc09db7c242d46$export$1e511d4a378977f5 = v; });
$parcel$export($b8dc09db7c242d46$exports, "MoreVertical", function () { return $b8dc09db7c242d46$export$882edb4b4a2c0561; }, function (v) { return $b8dc09db7c242d46$export$882edb4b4a2c0561 = v; });
var $b8dc09db7c242d46$export$1e511d4a378977f5;
var $b8dc09db7c242d46$export$882edb4b4a2c0561;
"use strict";
$b8dc09db7c242d46$export$1e511d4a378977f5 = true;
$b8dc09db7c242d46$export$882edb4b4a2c0561 = void 0;

var $b8dc09db7c242d46$var$_react = $b8dc09db7c242d46$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $b8dc09db7c242d46$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b8dc09db7c242d46$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b8dc09db7c242d46$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $b8dc09db7c242d46$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b8dc09db7c242d46$var$_extends() {
    return $b8dc09db7c242d46$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b8dc09db7c242d46$var$_extends.apply(null, arguments);
}
var $b8dc09db7c242d46$var$MoreVertical = $b8dc09db7c242d46$export$882edb4b4a2c0561 = /*#__PURE__*/ (0, $b8dc09db7c242d46$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $b8dc09db7c242d46$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $b8dc09db7c242d46$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "MoreVertical"
    }, props), /*#__PURE__*/ $b8dc09db7c242d46$var$_react["default"].createElement("path", {
        d: "M14 14h-4v-4h4v4zm0-7h-4V3h4v4zm0 14h-4v-4h4v4z"
    }));
});
$b8dc09db7c242d46$var$MoreVertical.displayName = 'MoreVertical';


Object.keys($b8dc09db7c242d46$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $b8dc09db7c242d46$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $b8dc09db7c242d46$exports[key];
});
var $6132f77fdec9d5b1$exports = {};

$parcel$export($6132f77fdec9d5b1$exports, "__esModule", function () { return $6132f77fdec9d5b1$export$1e511d4a378977f5; }, function (v) { return $6132f77fdec9d5b1$export$1e511d4a378977f5 = v; });
$parcel$export($6132f77fdec9d5b1$exports, "More", function () { return $6132f77fdec9d5b1$export$d440bfe209149ca5; }, function (v) { return $6132f77fdec9d5b1$export$d440bfe209149ca5 = v; });
var $6132f77fdec9d5b1$export$1e511d4a378977f5;
var $6132f77fdec9d5b1$export$d440bfe209149ca5;
"use strict";
$6132f77fdec9d5b1$export$1e511d4a378977f5 = true;
$6132f77fdec9d5b1$export$d440bfe209149ca5 = void 0;

var $6132f77fdec9d5b1$var$_react = $6132f77fdec9d5b1$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $6132f77fdec9d5b1$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6132f77fdec9d5b1$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6132f77fdec9d5b1$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6132f77fdec9d5b1$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6132f77fdec9d5b1$var$_extends() {
    return $6132f77fdec9d5b1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6132f77fdec9d5b1$var$_extends.apply(null, arguments);
}
var $6132f77fdec9d5b1$var$More = $6132f77fdec9d5b1$export$d440bfe209149ca5 = /*#__PURE__*/ (0, $6132f77fdec9d5b1$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $6132f77fdec9d5b1$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $6132f77fdec9d5b1$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "More"
    }, props), /*#__PURE__*/ $6132f77fdec9d5b1$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M3 13v-2h2v2H3zm8 0v-2h2v2h-2zm8 0v-2h2v2h-2z"
    }));
});
$6132f77fdec9d5b1$var$More.displayName = 'More';


Object.keys($6132f77fdec9d5b1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $6132f77fdec9d5b1$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $6132f77fdec9d5b1$exports[key];
});
var $0551f26625fac291$exports = {};

$parcel$export($0551f26625fac291$exports, "__esModule", function () { return $0551f26625fac291$export$1e511d4a378977f5; }, function (v) { return $0551f26625fac291$export$1e511d4a378977f5 = v; });
$parcel$export($0551f26625fac291$exports, "Mouse", function () { return $0551f26625fac291$export$7caecd373b84cec3; }, function (v) { return $0551f26625fac291$export$7caecd373b84cec3 = v; });
var $0551f26625fac291$export$1e511d4a378977f5;
var $0551f26625fac291$export$7caecd373b84cec3;
"use strict";
$0551f26625fac291$export$1e511d4a378977f5 = true;
$0551f26625fac291$export$7caecd373b84cec3 = void 0;

var $0551f26625fac291$var$_react = $0551f26625fac291$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0551f26625fac291$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0551f26625fac291$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0551f26625fac291$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0551f26625fac291$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0551f26625fac291$var$_extends() {
    return $0551f26625fac291$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0551f26625fac291$var$_extends.apply(null, arguments);
}
var $0551f26625fac291$var$Mouse = $0551f26625fac291$export$7caecd373b84cec3 = /*#__PURE__*/ (0, $0551f26625fac291$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0551f26625fac291$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0551f26625fac291$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Mouse"
    }, props), /*#__PURE__*/ $0551f26625fac291$var$_react["default"].createElement("path", {
        stroke: "#000",
        strokeWidth: "2",
        fill: "none",
        d: "M12 4a5 5 0 0 1 5 5v6a5 5 0 0 1-10 0V9a5 5 0 0 1 5-5zm0 0v6m-6 0h12"
    }));
});
$0551f26625fac291$var$Mouse.displayName = 'Mouse';


Object.keys($0551f26625fac291$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0551f26625fac291$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0551f26625fac291$exports[key];
});
var $2e9aaa2f0da9cef6$exports = {};

$parcel$export($2e9aaa2f0da9cef6$exports, "__esModule", function () { return $2e9aaa2f0da9cef6$export$1e511d4a378977f5; }, function (v) { return $2e9aaa2f0da9cef6$export$1e511d4a378977f5 = v; });
$parcel$export($2e9aaa2f0da9cef6$exports, "Multimedia", function () { return $2e9aaa2f0da9cef6$export$1ab8637ce7e4d8f2; }, function (v) { return $2e9aaa2f0da9cef6$export$1ab8637ce7e4d8f2 = v; });
var $2e9aaa2f0da9cef6$export$1e511d4a378977f5;
var $2e9aaa2f0da9cef6$export$1ab8637ce7e4d8f2;
"use strict";
$2e9aaa2f0da9cef6$export$1e511d4a378977f5 = true;
$2e9aaa2f0da9cef6$export$1ab8637ce7e4d8f2 = void 0;

var $2e9aaa2f0da9cef6$var$_react = $2e9aaa2f0da9cef6$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $2e9aaa2f0da9cef6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2e9aaa2f0da9cef6$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2e9aaa2f0da9cef6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $2e9aaa2f0da9cef6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $2e9aaa2f0da9cef6$var$_extends() {
    return $2e9aaa2f0da9cef6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2e9aaa2f0da9cef6$var$_extends.apply(null, arguments);
}
var $2e9aaa2f0da9cef6$var$Multimedia = $2e9aaa2f0da9cef6$export$1ab8637ce7e4d8f2 = /*#__PURE__*/ (0, $2e9aaa2f0da9cef6$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $2e9aaa2f0da9cef6$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $2e9aaa2f0da9cef6$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Multimedia"
    }, props), /*#__PURE__*/ $2e9aaa2f0da9cef6$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M2 8v14h20V9M11 4 7 8M2 4v4h15l4-4H2zm14 0-4 4"
    }));
});
$2e9aaa2f0da9cef6$var$Multimedia.displayName = 'Multimedia';


Object.keys($2e9aaa2f0da9cef6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $2e9aaa2f0da9cef6$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $2e9aaa2f0da9cef6$exports[key];
});
var $c6902e7b3b6a071c$exports = {};

$parcel$export($c6902e7b3b6a071c$exports, "__esModule", function () { return $c6902e7b3b6a071c$export$1e511d4a378977f5; }, function (v) { return $c6902e7b3b6a071c$export$1e511d4a378977f5 = v; });
$parcel$export($c6902e7b3b6a071c$exports, "Multiple", function () { return $c6902e7b3b6a071c$export$96933ea99fed18ef; }, function (v) { return $c6902e7b3b6a071c$export$96933ea99fed18ef = v; });
var $c6902e7b3b6a071c$export$1e511d4a378977f5;
var $c6902e7b3b6a071c$export$96933ea99fed18ef;
"use strict";
$c6902e7b3b6a071c$export$1e511d4a378977f5 = true;
$c6902e7b3b6a071c$export$96933ea99fed18ef = void 0;

var $c6902e7b3b6a071c$var$_react = $c6902e7b3b6a071c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c6902e7b3b6a071c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c6902e7b3b6a071c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c6902e7b3b6a071c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c6902e7b3b6a071c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c6902e7b3b6a071c$var$_extends() {
    return $c6902e7b3b6a071c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c6902e7b3b6a071c$var$_extends.apply(null, arguments);
}
var $c6902e7b3b6a071c$var$Multiple = $c6902e7b3b6a071c$export$96933ea99fed18ef = /*#__PURE__*/ (0, $c6902e7b3b6a071c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c6902e7b3b6a071c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c6902e7b3b6a071c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Multiple"
    }, props), /*#__PURE__*/ $c6902e7b3b6a071c$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M19 15h4V1H9v4m6 14h4V5H5v4M1 23h14V9H1v14z"
    }));
});
$c6902e7b3b6a071c$var$Multiple.displayName = 'Multiple';


Object.keys($c6902e7b3b6a071c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c6902e7b3b6a071c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c6902e7b3b6a071c$exports[key];
});
var $28329a4d8c9c3b67$exports = {};

$parcel$export($28329a4d8c9c3b67$exports, "__esModule", function () { return $28329a4d8c9c3b67$export$1e511d4a378977f5; }, function (v) { return $28329a4d8c9c3b67$export$1e511d4a378977f5 = v; });
$parcel$export($28329a4d8c9c3b67$exports, "Music", function () { return $28329a4d8c9c3b67$export$8336555462a952f6; }, function (v) { return $28329a4d8c9c3b67$export$8336555462a952f6 = v; });
var $28329a4d8c9c3b67$export$1e511d4a378977f5;
var $28329a4d8c9c3b67$export$8336555462a952f6;
"use strict";
$28329a4d8c9c3b67$export$1e511d4a378977f5 = true;
$28329a4d8c9c3b67$export$8336555462a952f6 = void 0;

var $28329a4d8c9c3b67$var$_react = $28329a4d8c9c3b67$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $28329a4d8c9c3b67$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($28329a4d8c9c3b67$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $28329a4d8c9c3b67$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $28329a4d8c9c3b67$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $28329a4d8c9c3b67$var$_extends() {
    return $28329a4d8c9c3b67$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $28329a4d8c9c3b67$var$_extends.apply(null, arguments);
}
var $28329a4d8c9c3b67$var$Music = $28329a4d8c9c3b67$export$8336555462a952f6 = /*#__PURE__*/ (0, $28329a4d8c9c3b67$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $28329a4d8c9c3b67$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $28329a4d8c9c3b67$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Music"
    }, props), /*#__PURE__*/ $28329a4d8c9c3b67$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 17.998C1 16.894 1.887 16 2.998 16H9v4.002A1.993 1.993 0 0 1 7.002 22H2.998A2 2 0 0 1 1 20.002v-2.004zm14 0c0-1.104.887-1.998 1.998-1.998H23v4.002A1.993 1.993 0 0 1 21.002 22h-4.004A2 2 0 0 1 15 20.002v-2.004zM9 16V2h14v13.5M9 6h14"
    }));
});
$28329a4d8c9c3b67$var$Music.displayName = 'Music';


Object.keys($28329a4d8c9c3b67$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $28329a4d8c9c3b67$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $28329a4d8c9c3b67$exports[key];
});
var $3ea876de2344a788$exports = {};

$parcel$export($3ea876de2344a788$exports, "__esModule", function () { return $3ea876de2344a788$export$1e511d4a378977f5; }, function (v) { return $3ea876de2344a788$export$1e511d4a378977f5 = v; });
$parcel$export($3ea876de2344a788$exports, "Mysql", function () { return $3ea876de2344a788$export$a2cc26ff91a3f8ad; }, function (v) { return $3ea876de2344a788$export$a2cc26ff91a3f8ad = v; });
var $3ea876de2344a788$export$1e511d4a378977f5;
var $3ea876de2344a788$export$a2cc26ff91a3f8ad;
"use strict";
$3ea876de2344a788$export$1e511d4a378977f5 = true;
$3ea876de2344a788$export$a2cc26ff91a3f8ad = void 0;

var $3ea876de2344a788$var$_react = $3ea876de2344a788$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $3ea876de2344a788$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3ea876de2344a788$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3ea876de2344a788$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3ea876de2344a788$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3ea876de2344a788$var$_extends() {
    return $3ea876de2344a788$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3ea876de2344a788$var$_extends.apply(null, arguments);
}
var $3ea876de2344a788$var$Mysql = $3ea876de2344a788$export$a2cc26ff91a3f8ad = /*#__PURE__*/ (0, $3ea876de2344a788$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3ea876de2344a788$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3ea876de2344a788$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Mysql"
    }, props), /*#__PURE__*/ $3ea876de2344a788$var$_react["default"].createElement("path", {
        fill: "#00758F",
        fillRule: "evenodd",
        d: "M5.462 4.04a2.65 2.65 0 0 0-.67.074v.038h.037c.13.267.36.44.521.67l.372.781.038-.037c.23-.162.336-.422.335-.819-.093-.097-.107-.219-.187-.335-.106-.154-.312-.242-.446-.372zm18.017 19.097c.175.129.293.329.521.41v-.038c-.12-.152-.15-.362-.26-.521a73.62 73.62 0 0 1-.484-.484 7.948 7.948 0 0 0-1.713-1.638c-.508-.365-1.649-.859-1.861-1.451l-.038-.038c.361-.04.784-.171 1.117-.26.56-.15 1.06-.112 1.638-.26.261-.076.521-.15.782-.224v-.15c-.292-.3-.5-.696-.819-.967-.834-.71-1.743-1.42-2.68-2.01-.52-.329-1.162-.541-1.713-.82-.185-.093-.51-.142-.632-.297-.29-.37-.447-.837-.67-1.266-.467-.9-.927-1.883-1.34-2.83-.283-.645-.467-1.281-.82-1.86-1.69-2.78-3.51-4.457-6.328-6.106-.6-.35-1.322-.489-2.084-.67l-1.229-.074c-.25-.105-.51-.41-.744-.559C3.188.434.792-.849.102.838c-.437 1.065.652 2.104 1.042 2.643.273.379.623.803.819 1.229.128.28.15.56.26.856.271.73.506 1.522.856 2.196.178.341.373.7.596 1.005.138.187.372.27.409.559-.23.321-.242.82-.371 1.228-.582 1.835-.363 4.115.484 5.473.259.416.87 1.31 1.711.967.736-.3.572-1.228.782-2.047.047-.186.019-.323.112-.447v.037l.67 1.34c.496.799 1.376 1.634 2.122 2.197.386.292.69.797 1.191.968v-.038h-.037c-.098-.15-.25-.213-.372-.335a8.554 8.554 0 0 1-.857-.968c-.678-.92-1.277-1.928-1.823-2.977-.261-.502-.488-1.054-.708-1.564-.085-.197-.084-.494-.26-.596-.241.374-.596.676-.782 1.117-.298.705-.337 1.565-.447 2.457-.065.023-.036.007-.075.037-.518-.125-.7-.659-.893-1.117-.487-1.157-.578-3.022-.149-4.355.111-.345.613-1.431.41-1.75-.098-.318-.417-.501-.596-.744A5.83 5.83 0 0 1 3.6 7.166c-.398-.902-.585-1.916-1.005-2.829-.2-.436-.54-.877-.819-1.265-.308-.43-.654-.746-.893-1.266-.085-.185-.201-.48-.075-.67.04-.128.097-.182.224-.223.216-.167.817.055 1.042.148.597.248 1.095.484 1.6.82.243.16.489.472.782.558h.335c.525.12 1.112.037 1.601.186.865.263 1.64.672 2.345 1.117 2.146 1.355 3.9 3.283 5.1 5.584.193.37.277.724.447 1.117.343.792.775 1.607 1.116 2.382.34.773.673 1.553 1.154 2.196.253.338 1.231.52 1.676.708.311.131.821.269 1.116.446.564.34 1.11.745 1.638 1.117.264.187 1.077.595 1.117.93-1.31-.034-2.31.087-3.164.448-.243.102-.63.105-.67.409.133.14.154.35.26.521.204.33.549.773.856 1.005.337.254.683.525 1.043.745.64.39 1.356.614 1.972 1.005.365.231.726.521 1.08.782z"
    }));
});
$3ea876de2344a788$var$Mysql.displayName = 'Mysql';


Object.keys($3ea876de2344a788$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3ea876de2344a788$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3ea876de2344a788$exports[key];
});
var $1e794923012ae221$exports = {};

$parcel$export($1e794923012ae221$exports, "__esModule", function () { return $1e794923012ae221$export$1e511d4a378977f5; }, function (v) { return $1e794923012ae221$export$1e511d4a378977f5 = v; });
$parcel$export($1e794923012ae221$exports, "Navigate", function () { return $1e794923012ae221$export$444b3ab0cb9aec40; }, function (v) { return $1e794923012ae221$export$444b3ab0cb9aec40 = v; });
var $1e794923012ae221$export$1e511d4a378977f5;
var $1e794923012ae221$export$444b3ab0cb9aec40;
"use strict";
$1e794923012ae221$export$1e511d4a378977f5 = true;
$1e794923012ae221$export$444b3ab0cb9aec40 = void 0;

var $1e794923012ae221$var$_react = $1e794923012ae221$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $1e794923012ae221$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1e794923012ae221$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1e794923012ae221$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $1e794923012ae221$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1e794923012ae221$var$_extends() {
    return $1e794923012ae221$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1e794923012ae221$var$_extends.apply(null, arguments);
}
var $1e794923012ae221$var$Navigate = $1e794923012ae221$export$444b3ab0cb9aec40 = /*#__PURE__*/ (0, $1e794923012ae221$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $1e794923012ae221$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $1e794923012ae221$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Navigate"
    }, props), /*#__PURE__*/ $1e794923012ae221$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m20 11 2-3-2-3h-8v6h8zm-8 13V0M4 2 2 5l2 3h8V2H4z"
    }));
});
$1e794923012ae221$var$Navigate.displayName = 'Navigate';


Object.keys($1e794923012ae221$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $1e794923012ae221$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $1e794923012ae221$exports[key];
});
var $b42f0b12137284ed$exports = {};

$parcel$export($b42f0b12137284ed$exports, "__esModule", function () { return $b42f0b12137284ed$export$1e511d4a378977f5; }, function (v) { return $b42f0b12137284ed$export$1e511d4a378977f5 = v; });
$parcel$export($b42f0b12137284ed$exports, "NetworkDrive", function () { return $b42f0b12137284ed$export$9defcd0820396336; }, function (v) { return $b42f0b12137284ed$export$9defcd0820396336 = v; });
var $b42f0b12137284ed$export$1e511d4a378977f5;
var $b42f0b12137284ed$export$9defcd0820396336;
"use strict";
$b42f0b12137284ed$export$1e511d4a378977f5 = true;
$b42f0b12137284ed$export$9defcd0820396336 = void 0;

var $b42f0b12137284ed$var$_react = $b42f0b12137284ed$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $b42f0b12137284ed$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b42f0b12137284ed$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b42f0b12137284ed$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $b42f0b12137284ed$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b42f0b12137284ed$var$_extends() {
    return $b42f0b12137284ed$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b42f0b12137284ed$var$_extends.apply(null, arguments);
}
var $b42f0b12137284ed$var$NetworkDrive = $b42f0b12137284ed$export$9defcd0820396336 = /*#__PURE__*/ (0, $b42f0b12137284ed$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $b42f0b12137284ed$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $b42f0b12137284ed$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "NetworkDrive"
    }, props), /*#__PURE__*/ $b42f0b12137284ed$var$_react["default"].createElement("path", {
        stroke: "#000",
        strokeWidth: "2",
        fill: "none",
        d: "M12 14v4M22 6v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zM12 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM6 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
    }));
});
$b42f0b12137284ed$var$NetworkDrive.displayName = 'NetworkDrive';


Object.keys($b42f0b12137284ed$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $b42f0b12137284ed$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $b42f0b12137284ed$exports[key];
});
var $a0b3aaa71ddb181a$exports = {};

$parcel$export($a0b3aaa71ddb181a$exports, "__esModule", function () { return $a0b3aaa71ddb181a$export$1e511d4a378977f5; }, function (v) { return $a0b3aaa71ddb181a$export$1e511d4a378977f5 = v; });
$parcel$export($a0b3aaa71ddb181a$exports, "Network", function () { return $a0b3aaa71ddb181a$export$95be4ae94445245a; }, function (v) { return $a0b3aaa71ddb181a$export$95be4ae94445245a = v; });
var $a0b3aaa71ddb181a$export$1e511d4a378977f5;
var $a0b3aaa71ddb181a$export$95be4ae94445245a;
"use strict";
$a0b3aaa71ddb181a$export$1e511d4a378977f5 = true;
$a0b3aaa71ddb181a$export$95be4ae94445245a = void 0;

var $a0b3aaa71ddb181a$var$_react = $a0b3aaa71ddb181a$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a0b3aaa71ddb181a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a0b3aaa71ddb181a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a0b3aaa71ddb181a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a0b3aaa71ddb181a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a0b3aaa71ddb181a$var$_extends() {
    return $a0b3aaa71ddb181a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a0b3aaa71ddb181a$var$_extends.apply(null, arguments);
}
var $a0b3aaa71ddb181a$var$Network = $a0b3aaa71ddb181a$export$95be4ae94445245a = /*#__PURE__*/ (0, $a0b3aaa71ddb181a$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a0b3aaa71ddb181a$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a0b3aaa71ddb181a$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Network"
    }, props), /*#__PURE__*/ $a0b3aaa71ddb181a$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M7.5 7v8.514c0 4.243 5.5 2.829 5.5 6.6V24m-2-14L7.5 7 4 10m12.5-8v8.44c0 4.068-3.5 2.712-3.5 6.328V24m0-19 3.5-3L20 5"
    }));
});
$a0b3aaa71ddb181a$var$Network.displayName = 'Network';


Object.keys($a0b3aaa71ddb181a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a0b3aaa71ddb181a$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a0b3aaa71ddb181a$exports[key];
});
var $c459fc4a8fc97d5e$exports = {};

$parcel$export($c459fc4a8fc97d5e$exports, "__esModule", function () { return $c459fc4a8fc97d5e$export$1e511d4a378977f5; }, function (v) { return $c459fc4a8fc97d5e$export$1e511d4a378977f5 = v; });
$parcel$export($c459fc4a8fc97d5e$exports, "NewWindow", function () { return $c459fc4a8fc97d5e$export$3c9349f20e62121b; }, function (v) { return $c459fc4a8fc97d5e$export$3c9349f20e62121b = v; });
var $c459fc4a8fc97d5e$export$1e511d4a378977f5;
var $c459fc4a8fc97d5e$export$3c9349f20e62121b;
"use strict";
$c459fc4a8fc97d5e$export$1e511d4a378977f5 = true;
$c459fc4a8fc97d5e$export$3c9349f20e62121b = void 0;

var $c459fc4a8fc97d5e$var$_react = $c459fc4a8fc97d5e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c459fc4a8fc97d5e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c459fc4a8fc97d5e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c459fc4a8fc97d5e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c459fc4a8fc97d5e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c459fc4a8fc97d5e$var$_extends() {
    return $c459fc4a8fc97d5e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c459fc4a8fc97d5e$var$_extends.apply(null, arguments);
}
var $c459fc4a8fc97d5e$var$NewWindow = $c459fc4a8fc97d5e$export$3c9349f20e62121b = /*#__PURE__*/ (0, $c459fc4a8fc97d5e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c459fc4a8fc97d5e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c459fc4a8fc97d5e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "NewWindow"
    }, props), /*#__PURE__*/ $c459fc4a8fc97d5e$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M11 9h8m-4 4V5m2 12v6H1V7h6m0-6h16v16H7V1z"
    }));
});
$c459fc4a8fc97d5e$var$NewWindow.displayName = 'NewWindow';


Object.keys($c459fc4a8fc97d5e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c459fc4a8fc97d5e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c459fc4a8fc97d5e$exports[key];
});
var $c3f5530248564989$exports = {};

$parcel$export($c3f5530248564989$exports, "__esModule", function () { return $c3f5530248564989$export$1e511d4a378977f5; }, function (v) { return $c3f5530248564989$export$1e511d4a378977f5 = v; });
$parcel$export($c3f5530248564989$exports, "New", function () { return $c3f5530248564989$export$6fbbeb565555321b; }, function (v) { return $c3f5530248564989$export$6fbbeb565555321b = v; });
var $c3f5530248564989$export$1e511d4a378977f5;
var $c3f5530248564989$export$6fbbeb565555321b;
"use strict";
$c3f5530248564989$export$1e511d4a378977f5 = true;
$c3f5530248564989$export$6fbbeb565555321b = void 0;

var $c3f5530248564989$var$_react = $c3f5530248564989$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c3f5530248564989$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c3f5530248564989$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c3f5530248564989$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c3f5530248564989$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c3f5530248564989$var$_extends() {
    return $c3f5530248564989$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c3f5530248564989$var$_extends.apply(null, arguments);
}
var $c3f5530248564989$var$New = $c3f5530248564989$export$6fbbeb565555321b = /*#__PURE__*/ (0, $c3f5530248564989$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c3f5530248564989$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c3f5530248564989$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "New"
    }, props), /*#__PURE__*/ $c3f5530248564989$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 1v22M2 6l20 12m0-12L2 18"
    }));
});
$c3f5530248564989$var$New.displayName = 'New';


Object.keys($c3f5530248564989$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c3f5530248564989$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c3f5530248564989$exports[key];
});

Object.keys($395d1107a5183b93$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $395d1107a5183b93$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $395d1107a5183b93$exports[key];
});
var $5d32b7be6b9b0b28$exports = {};

$parcel$export($5d32b7be6b9b0b28$exports, "__esModule", function () { return $5d32b7be6b9b0b28$export$1e511d4a378977f5; }, function (v) { return $5d32b7be6b9b0b28$export$1e511d4a378977f5 = v; });
$parcel$export($5d32b7be6b9b0b28$exports, "Node", function () { return $5d32b7be6b9b0b28$export$85c928794f8d04d4; }, function (v) { return $5d32b7be6b9b0b28$export$85c928794f8d04d4 = v; });
var $5d32b7be6b9b0b28$export$1e511d4a378977f5;
var $5d32b7be6b9b0b28$export$85c928794f8d04d4;
"use strict";
$5d32b7be6b9b0b28$export$1e511d4a378977f5 = true;
$5d32b7be6b9b0b28$export$85c928794f8d04d4 = void 0;

var $5d32b7be6b9b0b28$var$_react = $5d32b7be6b9b0b28$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5d32b7be6b9b0b28$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5d32b7be6b9b0b28$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5d32b7be6b9b0b28$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5d32b7be6b9b0b28$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5d32b7be6b9b0b28$var$_extends() {
    return $5d32b7be6b9b0b28$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5d32b7be6b9b0b28$var$_extends.apply(null, arguments);
}
var $5d32b7be6b9b0b28$var$Node = $5d32b7be6b9b0b28$export$85c928794f8d04d4 = /*#__PURE__*/ (0, $5d32b7be6b9b0b28$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5d32b7be6b9b0b28$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5d32b7be6b9b0b28$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Node"
    }, props), /*#__PURE__*/ $5d32b7be6b9b0b28$var$_react["default"].createElement("path", {
        fill: "#689F63",
        d: "M11.899 24c-.322 0-.64-.084-.923-.247l-2.935-1.738c-.439-.245-.225-.332-.08-.382.584-.204.703-.25 1.327-.605.066-.037.152-.024.219.015l2.255 1.339a.298.298 0 0 0 .273 0l8.794-5.077a.277.277 0 0 0 .134-.237V6.919a.282.282 0 0 0-.136-.242l-8.79-5.072a.27.27 0 0 0-.271 0l-8.79 5.072a.28.28 0 0 0-.139.24v10.148c0 .097.053.19.137.236l2.408 1.391c1.308.654 2.107-.116 2.107-.891V7.785a.25.25 0 0 1 .255-.254h1.114c.139 0 .253.11.253.254v10.02c0 1.744-.95 2.745-2.604 2.745-.509 0-.91 0-2.028-.55l-2.307-1.33a1.86 1.86 0 0 1-.922-1.605V6.917c0-.66.352-1.277.922-1.602L10.976.236a1.928 1.928 0 0 1 1.849 0l8.792 5.08c.568.329.922.943.922 1.603v10.149a1.86 1.86 0 0 1-.922 1.602l-8.792 5.079a1.848 1.848 0 0 1-.927.246V24zm2.716-6.993c-3.848 0-4.654-1.766-4.654-3.248 0-.14.113-.253.254-.253h1.136c.126 0 .231.091.251.215.172 1.158.683 1.742 3.01 1.742 1.853 0 2.641-.419 2.641-1.402 0-.566-.225-.986-3.104-1.268-2.408-.238-3.896-.768-3.896-2.694 0-1.775 1.497-2.831 4.004-2.831 2.815 0 4.211.977 4.387 3.077a.256.256 0 0 1-.255.278h-1.143a.252.252 0 0 1-.246-.199c-.275-1.217-.94-1.607-2.747-1.607-2.023 0-2.259.705-2.259 1.233 0 .64.277.828 3.007 1.189 2.703.359 3.987.865 3.987 2.765 0 1.915-1.599 3.014-4.385 3.014l.012-.01z"
    }));
});
$5d32b7be6b9b0b28$var$Node.displayName = 'Node';


Object.keys($5d32b7be6b9b0b28$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5d32b7be6b9b0b28$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5d32b7be6b9b0b28$exports[key];
});
var $eee20543eb1b08e2$exports = {};

$parcel$export($eee20543eb1b08e2$exports, "__esModule", function () { return $eee20543eb1b08e2$export$1e511d4a378977f5; }, function (v) { return $eee20543eb1b08e2$export$1e511d4a378977f5 = v; });
$parcel$export($eee20543eb1b08e2$exports, "Nodes", function () { return $eee20543eb1b08e2$export$dd0831c4963b4170; }, function (v) { return $eee20543eb1b08e2$export$dd0831c4963b4170 = v; });
var $eee20543eb1b08e2$export$1e511d4a378977f5;
var $eee20543eb1b08e2$export$dd0831c4963b4170;
"use strict";
$eee20543eb1b08e2$export$1e511d4a378977f5 = true;
$eee20543eb1b08e2$export$dd0831c4963b4170 = void 0;

var $eee20543eb1b08e2$var$_react = $eee20543eb1b08e2$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $eee20543eb1b08e2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($eee20543eb1b08e2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $eee20543eb1b08e2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $eee20543eb1b08e2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $eee20543eb1b08e2$var$_extends() {
    return $eee20543eb1b08e2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $eee20543eb1b08e2$var$_extends.apply(null, arguments);
}
var $eee20543eb1b08e2$var$Nodes = $eee20543eb1b08e2$export$dd0831c4963b4170 = /*#__PURE__*/ (0, $eee20543eb1b08e2$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $eee20543eb1b08e2$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $eee20543eb1b08e2$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Nodes"
    }, props), /*#__PURE__*/ $eee20543eb1b08e2$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M14 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm0 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM7 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm0 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm14-8a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm0 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
    }));
});
$eee20543eb1b08e2$var$Nodes.displayName = 'Nodes';


Object.keys($eee20543eb1b08e2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $eee20543eb1b08e2$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $eee20543eb1b08e2$exports[key];
});
var $130350242271d3bb$exports = {};

$parcel$export($130350242271d3bb$exports, "__esModule", function () { return $130350242271d3bb$export$1e511d4a378977f5; }, function (v) { return $130350242271d3bb$export$1e511d4a378977f5 = v; });
$parcel$export($130350242271d3bb$exports, "Norton", function () { return $130350242271d3bb$export$b36356d13f49f32d; }, function (v) { return $130350242271d3bb$export$b36356d13f49f32d = v; });
var $130350242271d3bb$export$1e511d4a378977f5;
var $130350242271d3bb$export$b36356d13f49f32d;
"use strict";
$130350242271d3bb$export$1e511d4a378977f5 = true;
$130350242271d3bb$export$b36356d13f49f32d = void 0;

var $130350242271d3bb$var$_react = $130350242271d3bb$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $130350242271d3bb$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($130350242271d3bb$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $130350242271d3bb$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $130350242271d3bb$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $130350242271d3bb$var$_extends() {
    return $130350242271d3bb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $130350242271d3bb$var$_extends.apply(null, arguments);
}
var $130350242271d3bb$var$Norton = $130350242271d3bb$export$b36356d13f49f32d = /*#__PURE__*/ (0, $130350242271d3bb$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $130350242271d3bb$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $130350242271d3bb$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Norton"
    }, props), /*#__PURE__*/ $130350242271d3bb$var$_react["default"].createElement("path", {
        fill: "#E0B02F",
        d: "M21.91.816h.797v.797h-.797V.816zm0 .797h-1.477v.797h1.477v-.797zm-1.477.797v1.554h-.738V2.41h.738zm0 1.554h.758v.758h-.758v-.758zm.758 0v-.748h.836v.748h-.836zm-.758.758v1.613h-.65v.632h-.69v.923H18.5v.787h-.758V7.9h-.758l-.01.777h.768v.826h-.758l.01.903h-.651l.01.758h-.603l-.01.855c-1.136 1.635-1.923 3.351-2.633 5.063-.09.217-.123.395-.233.524-.239.28-.595.368-.885.36-.542-.015-1.02-.268-1.272-.855-.85-1.97-1.27-3.35-3.605-5.937-.376-.417-.289-.949.01-1.117.286-.163.687-.046 1.136.204 1.258.7 1.958 1.415 3.45 3.4.543-1.311 1.482-3.084 2.652-5.004h.544V7.9h.515v-.75h.758V5.956h.817l-.01.758h.758v-.758h-.748v-.68h.68v-.554h1.253V5.5h.768v-.778h.738zm-1.506 0v-.758h.768v.758h-.768zm0-.758h-.767v-.728h.767v.728zm1.506-1.55h.757v.798h-.757v-.798zm2.27-.799h.819v.799h-.82v-.799zm-6.156 2.929v.742h-.933V6.53h-.933v.734a7.115 7.115 0 0 0-3.313-.812c-3.947 0-7.152 3.195-7.152 7.142 0 3.946 3.205 7.141 7.152 7.141a7.139 7.139 0 0 0 7.141-7.141 7.115 7.115 0 0 0-.823-3.333h.726v-.933h.622v-.933h.622v-.777h.27a10.357 10.357 0 0 1 1.887 5.976C21.813 19.34 17.153 24 11.406 24 5.66 24 1 19.34 1 13.594 1 7.847 5.66 3.187 11.406 3.187c1.87 0 3.624.493 5.14 1.357zM22.703 0h.819v.817h-.82V0z"
    }));
});
$130350242271d3bb$var$Norton.displayName = 'Norton';


Object.keys($130350242271d3bb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $130350242271d3bb$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $130350242271d3bb$exports[key];
});
var $5be8a877d2b3723c$exports = {};

$parcel$export($5be8a877d2b3723c$exports, "__esModule", function () { return $5be8a877d2b3723c$export$1e511d4a378977f5; }, function (v) { return $5be8a877d2b3723c$export$1e511d4a378977f5 = v; });
$parcel$export($5be8a877d2b3723c$exports, "Note", function () { return $5be8a877d2b3723c$export$6c88bf799aca3d2b; }, function (v) { return $5be8a877d2b3723c$export$6c88bf799aca3d2b = v; });
var $5be8a877d2b3723c$export$1e511d4a378977f5;
var $5be8a877d2b3723c$export$6c88bf799aca3d2b;
"use strict";
$5be8a877d2b3723c$export$1e511d4a378977f5 = true;
$5be8a877d2b3723c$export$6c88bf799aca3d2b = void 0;

var $5be8a877d2b3723c$var$_react = $5be8a877d2b3723c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5be8a877d2b3723c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5be8a877d2b3723c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5be8a877d2b3723c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5be8a877d2b3723c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5be8a877d2b3723c$var$_extends() {
    return $5be8a877d2b3723c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5be8a877d2b3723c$var$_extends.apply(null, arguments);
}
var $5be8a877d2b3723c$var$Note = $5be8a877d2b3723c$export$6c88bf799aca3d2b = /*#__PURE__*/ (0, $5be8a877d2b3723c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5be8a877d2b3723c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5be8a877d2b3723c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Note"
    }, props), /*#__PURE__*/ $5be8a877d2b3723c$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 23h15l7-7V1H1v22zm14 0v-8h8"
    }));
});
$5be8a877d2b3723c$var$Note.displayName = 'Note';


Object.keys($5be8a877d2b3723c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5be8a877d2b3723c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5be8a877d2b3723c$exports[key];
});
var $64078544ee75273f$exports = {};

$parcel$export($64078544ee75273f$exports, "__esModule", function () { return $64078544ee75273f$export$1e511d4a378977f5; }, function (v) { return $64078544ee75273f$export$1e511d4a378977f5 = v; });
$parcel$export($64078544ee75273f$exports, "Notes", function () { return $64078544ee75273f$export$aa31b211d2f4c3af; }, function (v) { return $64078544ee75273f$export$aa31b211d2f4c3af = v; });
var $64078544ee75273f$export$1e511d4a378977f5;
var $64078544ee75273f$export$aa31b211d2f4c3af;
"use strict";
$64078544ee75273f$export$1e511d4a378977f5 = true;
$64078544ee75273f$export$aa31b211d2f4c3af = void 0;

var $64078544ee75273f$var$_react = $64078544ee75273f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $64078544ee75273f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($64078544ee75273f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $64078544ee75273f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $64078544ee75273f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $64078544ee75273f$var$_extends() {
    return $64078544ee75273f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $64078544ee75273f$var$_extends.apply(null, arguments);
}
var $64078544ee75273f$var$Notes = $64078544ee75273f$export$aa31b211d2f4c3af = /*#__PURE__*/ (0, $64078544ee75273f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $64078544ee75273f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $64078544ee75273f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Notes"
    }, props), /*#__PURE__*/ $64078544ee75273f$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M3 1v22h13l5-5V1H3zm3 16h5m-5-4h12M6 9h10M3 5h18m0 12h-6v6"
    }));
});
$64078544ee75273f$var$Notes.displayName = 'Notes';


Object.keys($64078544ee75273f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $64078544ee75273f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $64078544ee75273f$exports[key];
});
var $01c2b2b326877124$exports = {};

$parcel$export($01c2b2b326877124$exports, "__esModule", function () { return $01c2b2b326877124$export$1e511d4a378977f5; }, function (v) { return $01c2b2b326877124$export$1e511d4a378977f5 = v; });
$parcel$export($01c2b2b326877124$exports, "Notification", function () { return $01c2b2b326877124$export$14834abbfce3b8cd; }, function (v) { return $01c2b2b326877124$export$14834abbfce3b8cd = v; });
var $01c2b2b326877124$export$1e511d4a378977f5;
var $01c2b2b326877124$export$14834abbfce3b8cd;
"use strict";
$01c2b2b326877124$export$1e511d4a378977f5 = true;
$01c2b2b326877124$export$14834abbfce3b8cd = void 0;

var $01c2b2b326877124$var$_react = $01c2b2b326877124$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $01c2b2b326877124$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($01c2b2b326877124$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $01c2b2b326877124$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $01c2b2b326877124$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $01c2b2b326877124$var$_extends() {
    return $01c2b2b326877124$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $01c2b2b326877124$var$_extends.apply(null, arguments);
}
var $01c2b2b326877124$var$Notification = $01c2b2b326877124$export$14834abbfce3b8cd = /*#__PURE__*/ (0, $01c2b2b326877124$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $01c2b2b326877124$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $01c2b2b326877124$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Notification"
    }, props), /*#__PURE__*/ $01c2b2b326877124$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4 19V9a8 8 0 0 1 16 0v10M1 19h22m-8 0v1a3 3 0 1 1-6 0v-1"
    }));
});
$01c2b2b326877124$var$Notification.displayName = 'Notification';


Object.keys($01c2b2b326877124$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $01c2b2b326877124$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $01c2b2b326877124$exports[key];
});
var $7eab7c6c538f1ba7$exports = {};

$parcel$export($7eab7c6c538f1ba7$exports, "__esModule", function () { return $7eab7c6c538f1ba7$export$1e511d4a378977f5; }, function (v) { return $7eab7c6c538f1ba7$export$1e511d4a378977f5 = v; });
$parcel$export($7eab7c6c538f1ba7$exports, "Npm", function () { return $7eab7c6c538f1ba7$export$bc651973ec076cd0; }, function (v) { return $7eab7c6c538f1ba7$export$bc651973ec076cd0 = v; });
var $7eab7c6c538f1ba7$export$1e511d4a378977f5;
var $7eab7c6c538f1ba7$export$bc651973ec076cd0;
"use strict";
$7eab7c6c538f1ba7$export$1e511d4a378977f5 = true;
$7eab7c6c538f1ba7$export$bc651973ec076cd0 = void 0;

var $7eab7c6c538f1ba7$var$_react = $7eab7c6c538f1ba7$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $7eab7c6c538f1ba7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7eab7c6c538f1ba7$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7eab7c6c538f1ba7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $7eab7c6c538f1ba7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7eab7c6c538f1ba7$var$_extends() {
    return $7eab7c6c538f1ba7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7eab7c6c538f1ba7$var$_extends.apply(null, arguments);
}
var $7eab7c6c538f1ba7$var$Npm = $7eab7c6c538f1ba7$export$bc651973ec076cd0 = /*#__PURE__*/ (0, $7eab7c6c538f1ba7$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $7eab7c6c538f1ba7$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $7eab7c6c538f1ba7$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Npm"
    }, props), /*#__PURE__*/ $7eab7c6c538f1ba7$var$_react["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $7eab7c6c538f1ba7$var$_react["default"].createElement("path", {
        fill: "#D40001",
        d: "M0 0h24v24H0z"
    }), /*#__PURE__*/ $7eab7c6c538f1ba7$var$_react["default"].createElement("path", {
        fill: "#FFF",
        d: "M16.718 7.928h-4.513V20.25H4V3h16v17.249h-3.282V7.93z"
    })));
});
$7eab7c6c538f1ba7$var$Npm.displayName = 'Npm';


Object.keys($7eab7c6c538f1ba7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $7eab7c6c538f1ba7$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $7eab7c6c538f1ba7$exports[key];
});
var $f28600e87a19e40c$exports = {};

$parcel$export($f28600e87a19e40c$exports, "__esModule", function () { return $f28600e87a19e40c$export$1e511d4a378977f5; }, function (v) { return $f28600e87a19e40c$export$1e511d4a378977f5 = v; });
$parcel$export($f28600e87a19e40c$exports, "ObjectGroup", function () { return $f28600e87a19e40c$export$8ea55f27ce0a7db4; }, function (v) { return $f28600e87a19e40c$export$8ea55f27ce0a7db4 = v; });
var $f28600e87a19e40c$export$1e511d4a378977f5;
var $f28600e87a19e40c$export$8ea55f27ce0a7db4;
"use strict";
$f28600e87a19e40c$export$1e511d4a378977f5 = true;
$f28600e87a19e40c$export$8ea55f27ce0a7db4 = void 0;

var $f28600e87a19e40c$var$_react = $f28600e87a19e40c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f28600e87a19e40c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f28600e87a19e40c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f28600e87a19e40c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f28600e87a19e40c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f28600e87a19e40c$var$_extends() {
    return $f28600e87a19e40c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f28600e87a19e40c$var$_extends.apply(null, arguments);
}
var $f28600e87a19e40c$var$ObjectGroup = $f28600e87a19e40c$export$8ea55f27ce0a7db4 = /*#__PURE__*/ (0, $f28600e87a19e40c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f28600e87a19e40c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f28600e87a19e40c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ObjectGroup"
    }, props), /*#__PURE__*/ $f28600e87a19e40c$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 1h3v3H1V1zm19 0h3v3h-3V1zM4 2h16M4 22h16M1 20h3v3H1v-3zm19 0h3v3h-3v-3zM2 4v16M22 4v16M7 7h7v6H7V7zm10 3v7h-7v-2"
    }));
});
$f28600e87a19e40c$var$ObjectGroup.displayName = 'ObjectGroup';


Object.keys($f28600e87a19e40c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f28600e87a19e40c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f28600e87a19e40c$exports[key];
});
var $fb5a95d5d232b097$exports = {};

$parcel$export($fb5a95d5d232b097$exports, "__esModule", function () { return $fb5a95d5d232b097$export$1e511d4a378977f5; }, function (v) { return $fb5a95d5d232b097$export$1e511d4a378977f5 = v; });
$parcel$export($fb5a95d5d232b097$exports, "ObjectUngroup", function () { return $fb5a95d5d232b097$export$8305ee169bcc1a75; }, function (v) { return $fb5a95d5d232b097$export$8305ee169bcc1a75 = v; });
var $fb5a95d5d232b097$export$1e511d4a378977f5;
var $fb5a95d5d232b097$export$8305ee169bcc1a75;
"use strict";
$fb5a95d5d232b097$export$1e511d4a378977f5 = true;
$fb5a95d5d232b097$export$8305ee169bcc1a75 = void 0;

var $fb5a95d5d232b097$var$_react = $fb5a95d5d232b097$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $fb5a95d5d232b097$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($fb5a95d5d232b097$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $fb5a95d5d232b097$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $fb5a95d5d232b097$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $fb5a95d5d232b097$var$_extends() {
    return $fb5a95d5d232b097$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fb5a95d5d232b097$var$_extends.apply(null, arguments);
}
var $fb5a95d5d232b097$var$ObjectUngroup = $fb5a95d5d232b097$export$8305ee169bcc1a75 = /*#__PURE__*/ (0, $fb5a95d5d232b097$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $fb5a95d5d232b097$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $fb5a95d5d232b097$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ObjectUngroup"
    }, props), /*#__PURE__*/ $fb5a95d5d232b097$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 1h3v3H1V1zm12 0h3v3h-3V1zM4 2h9m2 7h5M4 15h9M1 13h3v3H1v-3zm12 0h3v3h-3v-3zM2 4v9m13-9v9m5-5h3v3h-3V8zm-9 14h9M8 20h3v3H8v-3zm12 0h3v3h-3v-3zM9 16v4m13-9v9"
    }));
});
$fb5a95d5d232b097$var$ObjectUngroup.displayName = 'ObjectUngroup';


Object.keys($fb5a95d5d232b097$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $fb5a95d5d232b097$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $fb5a95d5d232b097$exports[key];
});
var $24cb9187e983edaa$exports = {};

$parcel$export($24cb9187e983edaa$exports, "__esModule", function () { return $24cb9187e983edaa$export$1e511d4a378977f5; }, function (v) { return $24cb9187e983edaa$export$1e511d4a378977f5 = v; });
$parcel$export($24cb9187e983edaa$exports, "OfflineStorage", function () { return $24cb9187e983edaa$export$4f4d5b54138999ec; }, function (v) { return $24cb9187e983edaa$export$4f4d5b54138999ec = v; });
var $24cb9187e983edaa$export$1e511d4a378977f5;
var $24cb9187e983edaa$export$4f4d5b54138999ec;
"use strict";
$24cb9187e983edaa$export$1e511d4a378977f5 = true;
$24cb9187e983edaa$export$4f4d5b54138999ec = void 0;

var $24cb9187e983edaa$var$_react = $24cb9187e983edaa$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $24cb9187e983edaa$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($24cb9187e983edaa$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $24cb9187e983edaa$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $24cb9187e983edaa$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $24cb9187e983edaa$var$_extends() {
    return $24cb9187e983edaa$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $24cb9187e983edaa$var$_extends.apply(null, arguments);
}
var $24cb9187e983edaa$var$OfflineStorage = $24cb9187e983edaa$export$4f4d5b54138999ec = /*#__PURE__*/ (0, $24cb9187e983edaa$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $24cb9187e983edaa$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $24cb9187e983edaa$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "OfflineStorage"
    }, props), /*#__PURE__*/ $24cb9187e983edaa$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 21a9 9 0 1 0 0-18 9 9 0 1 0 0 18zm8-12h-8a3 3 0 0 0 0 6h8"
    }));
});
$24cb9187e983edaa$var$OfflineStorage.displayName = 'OfflineStorage';


Object.keys($24cb9187e983edaa$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $24cb9187e983edaa$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $24cb9187e983edaa$exports[key];
});
var $88806dd1b6b33a42$exports = {};

$parcel$export($88806dd1b6b33a42$exports, "__esModule", function () { return $88806dd1b6b33a42$export$1e511d4a378977f5; }, function (v) { return $88806dd1b6b33a42$export$1e511d4a378977f5 = v; });
$parcel$export($88806dd1b6b33a42$exports, "Onedrive", function () { return $88806dd1b6b33a42$export$51437629ac8ca95a; }, function (v) { return $88806dd1b6b33a42$export$51437629ac8ca95a = v; });
var $88806dd1b6b33a42$export$1e511d4a378977f5;
var $88806dd1b6b33a42$export$51437629ac8ca95a;
"use strict";
$88806dd1b6b33a42$export$1e511d4a378977f5 = true;
$88806dd1b6b33a42$export$51437629ac8ca95a = void 0;

var $88806dd1b6b33a42$var$_react = $88806dd1b6b33a42$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $88806dd1b6b33a42$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($88806dd1b6b33a42$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $88806dd1b6b33a42$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $88806dd1b6b33a42$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $88806dd1b6b33a42$var$_extends() {
    return $88806dd1b6b33a42$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $88806dd1b6b33a42$var$_extends.apply(null, arguments);
}
var $88806dd1b6b33a42$var$Onedrive = $88806dd1b6b33a42$export$51437629ac8ca95a = /*#__PURE__*/ (0, $88806dd1b6b33a42$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $88806dd1b6b33a42$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $88806dd1b6b33a42$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Onedrive"
    }, props), /*#__PURE__*/ $88806dd1b6b33a42$var$_react["default"].createElement("path", {
        fill: "#4F8AD8",
        fillRule: "evenodd",
        d: "M21.692 13.987a2.733 2.733 0 0 1 .602 5.232h-13.7a3.166 3.166 0 1 1 .281-6.321 3.963 3.963 0 0 1 7.482-2.05 3.454 3.454 0 0 1 5.336 3.138zM8.187 12.209a3.873 3.873 0 0 0-3.44 3.843c0 .81.252 1.563.681 2.186h-2.15a3.279 3.279 0 0 1-.237-6.549 3.692 3.692 0 0 1 5.668-3.86 5.103 5.103 0 0 1 9.648 1.757c-.036-.001-.072-.003-.109-.003-.568 0-1.125.115-1.64.337a4.644 4.644 0 0 0-3.778-1.929 4.67 4.67 0 0 0-4.643 4.218z"
    }));
});
$88806dd1b6b33a42$var$Onedrive.displayName = 'Onedrive';


Object.keys($88806dd1b6b33a42$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $88806dd1b6b33a42$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $88806dd1b6b33a42$exports[key];
});
var $63dd332a49bbb504$exports = {};

$parcel$export($63dd332a49bbb504$exports, "__esModule", function () { return $63dd332a49bbb504$export$1e511d4a378977f5; }, function (v) { return $63dd332a49bbb504$export$1e511d4a378977f5 = v; });
$parcel$export($63dd332a49bbb504$exports, "Opera", function () { return $63dd332a49bbb504$export$92641a28753ba6eb; }, function (v) { return $63dd332a49bbb504$export$92641a28753ba6eb = v; });
var $63dd332a49bbb504$export$1e511d4a378977f5;
var $63dd332a49bbb504$export$92641a28753ba6eb;
"use strict";
$63dd332a49bbb504$export$1e511d4a378977f5 = true;
$63dd332a49bbb504$export$92641a28753ba6eb = void 0;

var $63dd332a49bbb504$var$_react = $63dd332a49bbb504$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $63dd332a49bbb504$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($63dd332a49bbb504$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $63dd332a49bbb504$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $63dd332a49bbb504$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $63dd332a49bbb504$var$_extends() {
    return $63dd332a49bbb504$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $63dd332a49bbb504$var$_extends.apply(null, arguments);
}
var $63dd332a49bbb504$var$Opera = $63dd332a49bbb504$export$92641a28753ba6eb = /*#__PURE__*/ (0, $63dd332a49bbb504$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $63dd332a49bbb504$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $63dd332a49bbb504$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Opera"
    }, props), /*#__PURE__*/ $63dd332a49bbb504$var$_react["default"].createElement("path", {
        fill: "#CC0F16",
        fillRule: "evenodd",
        d: "M12.125 0C5.568 0 1 4.756 1 11.889 1 18.236 5.438 24 12.125 24c6.752 0 11.226-5.763 11.226-12.111C23.35 4.699 18.62 0 12.125 0zm0 21.32a3.308 3.308 0 0 1-1.425-.298c-1.141-.575-1.828-1.85-2.23-3.41-.435-1.809-.484-4.004-.484-5.926 0-3.431.25-6.532 1.65-8.08.612-.65 1.418-1.034 2.476-1.037h.013c1.379 0 2.345.675 3.016 1.734 1 1.688 1.227 4.424 1.227 7.368 0 4.18-.278 9.65-4.243 9.65z"
    }));
});
$63dd332a49bbb504$var$Opera.displayName = 'Opera';


Object.keys($63dd332a49bbb504$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $63dd332a49bbb504$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $63dd332a49bbb504$exports[key];
});
var $cb8f9fc993a03b7f$exports = {};

$parcel$export($cb8f9fc993a03b7f$exports, "__esModule", function () { return $cb8f9fc993a03b7f$export$1e511d4a378977f5; }, function (v) { return $cb8f9fc993a03b7f$export$1e511d4a378977f5 = v; });
$parcel$export($cb8f9fc993a03b7f$exports, "Optimize", function () { return $cb8f9fc993a03b7f$export$b8e51e84bc71aff9; }, function (v) { return $cb8f9fc993a03b7f$export$b8e51e84bc71aff9 = v; });
var $cb8f9fc993a03b7f$export$1e511d4a378977f5;
var $cb8f9fc993a03b7f$export$b8e51e84bc71aff9;
"use strict";
$cb8f9fc993a03b7f$export$1e511d4a378977f5 = true;
$cb8f9fc993a03b7f$export$b8e51e84bc71aff9 = void 0;

var $cb8f9fc993a03b7f$var$_react = $cb8f9fc993a03b7f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $cb8f9fc993a03b7f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($cb8f9fc993a03b7f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $cb8f9fc993a03b7f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $cb8f9fc993a03b7f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $cb8f9fc993a03b7f$var$_extends() {
    return $cb8f9fc993a03b7f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cb8f9fc993a03b7f$var$_extends.apply(null, arguments);
}
var $cb8f9fc993a03b7f$var$Optimize = $cb8f9fc993a03b7f$export$b8e51e84bc71aff9 = /*#__PURE__*/ (0, $cb8f9fc993a03b7f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $cb8f9fc993a03b7f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $cb8f9fc993a03b7f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Optimize"
    }, props), /*#__PURE__*/ $cb8f9fc993a03b7f$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 22h4v-4H2v4zM22 2 12 12m10-2V2h-8m8 11h-4v9h4v-9zm-12 9h4v-6h-4v6z"
    }));
});
$cb8f9fc993a03b7f$var$Optimize.displayName = 'Optimize';


Object.keys($cb8f9fc993a03b7f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $cb8f9fc993a03b7f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $cb8f9fc993a03b7f$exports[key];
});
var $7e85a8b63062b302$exports = {};

$parcel$export($7e85a8b63062b302$exports, "__esModule", function () { return $7e85a8b63062b302$export$1e511d4a378977f5; }, function (v) { return $7e85a8b63062b302$export$1e511d4a378977f5 = v; });
$parcel$export($7e85a8b63062b302$exports, "Oracle", function () { return $7e85a8b63062b302$export$64829c80d3c0f673; }, function (v) { return $7e85a8b63062b302$export$64829c80d3c0f673 = v; });
var $7e85a8b63062b302$export$1e511d4a378977f5;
var $7e85a8b63062b302$export$64829c80d3c0f673;
"use strict";
$7e85a8b63062b302$export$1e511d4a378977f5 = true;
$7e85a8b63062b302$export$64829c80d3c0f673 = void 0;

var $7e85a8b63062b302$var$_react = $7e85a8b63062b302$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $7e85a8b63062b302$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7e85a8b63062b302$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7e85a8b63062b302$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $7e85a8b63062b302$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7e85a8b63062b302$var$_extends() {
    return $7e85a8b63062b302$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7e85a8b63062b302$var$_extends.apply(null, arguments);
}
var $7e85a8b63062b302$var$Oracle = $7e85a8b63062b302$export$64829c80d3c0f673 = /*#__PURE__*/ (0, $7e85a8b63062b302$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $7e85a8b63062b302$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $7e85a8b63062b302$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Oracle"
    }, props), /*#__PURE__*/ $7e85a8b63062b302$var$_react["default"].createElement("path", {
        fill: "red",
        fillRule: "evenodd",
        d: "M7.957 18.912A6.953 6.953 0 0 1 1 11.962 6.963 6.963 0 0 1 7.957 5h8.087A6.961 6.961 0 0 1 23 11.962a6.952 6.952 0 0 1-6.956 6.95H7.957zm7.907-2.453a4.497 4.497 0 0 0 4.503-4.497 4.507 4.507 0 0 0-4.503-4.508H8.136a4.507 4.507 0 0 0-4.503 4.508 4.498 4.498 0 0 0 4.503 4.497h7.728z"
    }));
});
$7e85a8b63062b302$var$Oracle.displayName = 'Oracle';


Object.keys($7e85a8b63062b302$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $7e85a8b63062b302$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $7e85a8b63062b302$exports[key];
});
var $3df78bf5850c71c8$exports = {};

$parcel$export($3df78bf5850c71c8$exports, "__esModule", function () { return $3df78bf5850c71c8$export$1e511d4a378977f5; }, function (v) { return $3df78bf5850c71c8$export$1e511d4a378977f5 = v; });
$parcel$export($3df78bf5850c71c8$exports, "OrderedList", function () { return $3df78bf5850c71c8$export$547f885a1fca4e31; }, function (v) { return $3df78bf5850c71c8$export$547f885a1fca4e31 = v; });
var $3df78bf5850c71c8$export$1e511d4a378977f5;
var $3df78bf5850c71c8$export$547f885a1fca4e31;
"use strict";
$3df78bf5850c71c8$export$1e511d4a378977f5 = true;
$3df78bf5850c71c8$export$547f885a1fca4e31 = void 0;

var $3df78bf5850c71c8$var$_react = $3df78bf5850c71c8$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $3df78bf5850c71c8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3df78bf5850c71c8$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3df78bf5850c71c8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3df78bf5850c71c8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3df78bf5850c71c8$var$_extends() {
    return $3df78bf5850c71c8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3df78bf5850c71c8$var$_extends.apply(null, arguments);
}
var $3df78bf5850c71c8$var$OrderedList = $3df78bf5850c71c8$export$547f885a1fca4e31 = /*#__PURE__*/ (0, $3df78bf5850c71c8$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3df78bf5850c71c8$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3df78bf5850c71c8$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "OrderedList"
    }, props), /*#__PURE__*/ $3df78bf5850c71c8$var$_react["default"].createElement("path", {
        d: "M5.77 6.42h18.06v1.75H5.77zm0 5.29h18.06v1.75H5.77zm0 5.28h18.06v1.75H5.77zM3.13 4.87V8a2 2 0 0 0 0 .45.3.3 0 0 0 .13.16.62.62 0 0 0 .32.06h.12v.11h-2v-.07h.1a.79.79 0 0 0 .35-.06.29.29 0 0 0 .14-.16A1.75 1.75 0 0 0 2.3 8V6a1.28 1.28 0 0 0 0-.33.24.24 0 0 0-.1-.11.28.28 0 0 0-.16 0 .91.91 0 0 0-.35.09l-.05-.1L3 4.87zm.52 9.43H1.37v-.06a12.51 12.51 0 0 0 1.27-1.67 1.81 1.81 0 0 0 .22-.84.7.7 0 0 0-.18-.5.6.6 0 0 0-.45-.2.75.75 0 0 0-.68.44h-.11a1.58 1.58 0 0 1 .47-.81 1.09 1.09 0 0 1 .72-.26 1.06 1.06 0 0 1 .54.14 1 1 0 0 1 .38.37.9.9 0 0 1 .14.45 1.6 1.6 0 0 1-.21.77 7.28 7.28 0 0 1-1.25 1.47h.83a1.87 1.87 0 0 0 .4 0 .33.33 0 0 0 .15-.09 1.16 1.16 0 0 0 .16-.26h.1zM2.09 18v-.1a1.88 1.88 0 0 0 .45-.17.67.67 0 0 0 .22-.25.69.69 0 0 0 .09-.34.55.55 0 0 0-.17-.41.58.58 0 0 0-.43-.17.8.8 0 0 0-.68.42h-.11a1.72 1.72 0 0 1 .54-.79 1.16 1.16 0 0 1 .71-.24.93.93 0 0 1 .66.24.76.76 0 0 1 .26.57.78.78 0 0 1-.12.41 1 1 0 0 1-.38.35 1.34 1.34 0 0 1 .51.4 1 1 0 0 1 .17.6 1.38 1.38 0 0 1-.44 1A1.62 1.62 0 0 1 2.2 20a1.24 1.24 0 0 1-.71-.16.34.34 0 0 1-.16-.29.32.32 0 0 1 .31-.32.41.41 0 0 1 .18 0l.32.25a.84.84 0 0 0 .52.23.47.47 0 0 0 .34-.16.61.61 0 0 0 .15-.42 1.1 1.1 0 0 0-.27-.72 1.42 1.42 0 0 0-.79-.41z"
    }));
});
$3df78bf5850c71c8$var$OrderedList.displayName = 'OrderedList';


Object.keys($3df78bf5850c71c8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3df78bf5850c71c8$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3df78bf5850c71c8$exports[key];
});
var $a451b49809cce0e4$exports = {};

$parcel$export($a451b49809cce0e4$exports, "__esModule", function () { return $a451b49809cce0e4$export$1e511d4a378977f5; }, function (v) { return $a451b49809cce0e4$export$1e511d4a378977f5 = v; });
$parcel$export($a451b49809cce0e4$exports, "Organization", function () { return $a451b49809cce0e4$export$f3a6aa388b70f149; }, function (v) { return $a451b49809cce0e4$export$f3a6aa388b70f149 = v; });
var $a451b49809cce0e4$export$1e511d4a378977f5;
var $a451b49809cce0e4$export$f3a6aa388b70f149;
"use strict";
$a451b49809cce0e4$export$1e511d4a378977f5 = true;
$a451b49809cce0e4$export$f3a6aa388b70f149 = void 0;

var $a451b49809cce0e4$var$_react = $a451b49809cce0e4$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a451b49809cce0e4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a451b49809cce0e4$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a451b49809cce0e4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a451b49809cce0e4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a451b49809cce0e4$var$_extends() {
    return $a451b49809cce0e4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a451b49809cce0e4$var$_extends.apply(null, arguments);
}
var $a451b49809cce0e4$var$Organization = $a451b49809cce0e4$export$f3a6aa388b70f149 = /*#__PURE__*/ (0, $a451b49809cce0e4$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a451b49809cce0e4$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a451b49809cce0e4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Organization"
    }, props), /*#__PURE__*/ $a451b49809cce0e4$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M20 3v20H4V3h16zM8.042 9h2V7h-2v2zM14 9h2V7h-2v2zm-5.958 6h2v-2h-2v2zm2 8h4v-4h-4v4zM14 15h2v-2h-2v2zM2 3h20V1H2v2z"
    }));
});
$a451b49809cce0e4$var$Organization.displayName = 'Organization';


Object.keys($a451b49809cce0e4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a451b49809cce0e4$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a451b49809cce0e4$exports[key];
});
var $1de095f489bdfb0f$exports = {};

$parcel$export($1de095f489bdfb0f$exports, "__esModule", function () { return $1de095f489bdfb0f$export$1e511d4a378977f5; }, function (v) { return $1de095f489bdfb0f$export$1e511d4a378977f5 = v; });
$parcel$export($1de095f489bdfb0f$exports, "Overview", function () { return $1de095f489bdfb0f$export$d7a9e6ef755e50e3; }, function (v) { return $1de095f489bdfb0f$export$d7a9e6ef755e50e3 = v; });
var $1de095f489bdfb0f$export$1e511d4a378977f5;
var $1de095f489bdfb0f$export$d7a9e6ef755e50e3;
"use strict";
$1de095f489bdfb0f$export$1e511d4a378977f5 = true;
$1de095f489bdfb0f$export$d7a9e6ef755e50e3 = void 0;

var $1de095f489bdfb0f$var$_react = $1de095f489bdfb0f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $1de095f489bdfb0f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1de095f489bdfb0f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1de095f489bdfb0f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $1de095f489bdfb0f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1de095f489bdfb0f$var$_extends() {
    return $1de095f489bdfb0f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1de095f489bdfb0f$var$_extends.apply(null, arguments);
}
var $1de095f489bdfb0f$var$Overview = $1de095f489bdfb0f$export$d7a9e6ef755e50e3 = /*#__PURE__*/ (0, $1de095f489bdfb0f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $1de095f489bdfb0f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $1de095f489bdfb0f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Overview"
    }, props), /*#__PURE__*/ $1de095f489bdfb0f$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M18.5 21a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zM10 7h4M1.5 14.5S5.5 5 6 4s1.5-1 2-1 2 0 2 2v11m-4.5 5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zm17-6.5S18.5 5 18 4s-1.5-1-2-1-2 0-2 2v11m-4 0h4"
    }));
});
$1de095f489bdfb0f$var$Overview.displayName = 'Overview';


Object.keys($1de095f489bdfb0f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $1de095f489bdfb0f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $1de095f489bdfb0f$exports[key];
});
var $542dbe68fcd3a843$exports = {};

$parcel$export($542dbe68fcd3a843$exports, "__esModule", function () { return $542dbe68fcd3a843$export$1e511d4a378977f5; }, function (v) { return $542dbe68fcd3a843$export$1e511d4a378977f5 = v; });
$parcel$export($542dbe68fcd3a843$exports, "Package", function () { return $542dbe68fcd3a843$export$19705fd60e4de464; }, function (v) { return $542dbe68fcd3a843$export$19705fd60e4de464 = v; });
var $542dbe68fcd3a843$export$1e511d4a378977f5;
var $542dbe68fcd3a843$export$19705fd60e4de464;
"use strict";
$542dbe68fcd3a843$export$1e511d4a378977f5 = true;
$542dbe68fcd3a843$export$19705fd60e4de464 = void 0;

var $542dbe68fcd3a843$var$_react = $542dbe68fcd3a843$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $542dbe68fcd3a843$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($542dbe68fcd3a843$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $542dbe68fcd3a843$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $542dbe68fcd3a843$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $542dbe68fcd3a843$var$_extends() {
    return $542dbe68fcd3a843$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $542dbe68fcd3a843$var$_extends.apply(null, arguments);
}
var $542dbe68fcd3a843$var$Package = $542dbe68fcd3a843$export$19705fd60e4de464 = /*#__PURE__*/ (0, $542dbe68fcd3a843$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $542dbe68fcd3a843$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $542dbe68fcd3a843$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Package"
    }, props), /*#__PURE__*/ $542dbe68fcd3a843$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.371.571 12 .423l-.371.148-10 4L1 4.823v14.354l.629.251 10 4 .371.149.371-.149 10-4 .629-.251V4.823l-.629-.252-10-4zM3 6.977v10.846l8 3.2V10.177l-8-3.2zm10 3.2v10.846l8-3.2V6.977l-8 3.2zM19.307 5.5 12 2.577 9.943 3.4l7.307 2.923 2.057-.823zm-14.614 0L7.25 4.477 14.557 7.4 12 8.423 4.693 5.5z",
        fill: "#000"
    }));
});
$542dbe68fcd3a843$var$Package.displayName = 'Package';


Object.keys($542dbe68fcd3a843$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $542dbe68fcd3a843$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $542dbe68fcd3a843$exports[key];
});
var $582b4b21490ba074$exports = {};

$parcel$export($582b4b21490ba074$exports, "__esModule", function () { return $582b4b21490ba074$export$1e511d4a378977f5; }, function (v) { return $582b4b21490ba074$export$1e511d4a378977f5 = v; });
$parcel$export($582b4b21490ba074$exports, "Paint", function () { return $582b4b21490ba074$export$fbe17ae5b75efa7; }, function (v) { return $582b4b21490ba074$export$fbe17ae5b75efa7 = v; });
var $582b4b21490ba074$export$1e511d4a378977f5;
var $582b4b21490ba074$export$fbe17ae5b75efa7;
"use strict";
$582b4b21490ba074$export$1e511d4a378977f5 = true;
$582b4b21490ba074$export$fbe17ae5b75efa7 = void 0;

var $582b4b21490ba074$var$_react = $582b4b21490ba074$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $582b4b21490ba074$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($582b4b21490ba074$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $582b4b21490ba074$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $582b4b21490ba074$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $582b4b21490ba074$var$_extends() {
    return $582b4b21490ba074$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $582b4b21490ba074$var$_extends.apply(null, arguments);
}
var $582b4b21490ba074$var$Paint = $582b4b21490ba074$export$fbe17ae5b75efa7 = /*#__PURE__*/ (0, $582b4b21490ba074$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $582b4b21490ba074$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $582b4b21490ba074$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Paint"
    }, props), /*#__PURE__*/ $582b4b21490ba074$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4 10H2c0-5.523 0-9 10-9s10 3.477 10 9h-2m-8 0c4.418 0 8-.895 8-2s-3.582-2-8-2-8 .895-8 2 3.582 2 8 2zM4 20c0 1.657 3.582 3 8 3s8-1.343 8-3m0-12v12V8zM4 20V8v12zm4-7v4m5-4v4m-6-5c-1.5 0-3-1-3-4m14 5.5V12c0-2 2-1 2-4M8 13a1 1 0 0 0-1-1m6 1a1 1 0 0 1 2 0v.5m0 0a1.5 1.5 0 0 0 3 0M8 17a2.5 2.5 0 1 0 5 0"
    }));
});
$582b4b21490ba074$var$Paint.displayName = 'Paint';


Object.keys($582b4b21490ba074$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $582b4b21490ba074$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $582b4b21490ba074$exports[key];
});
var $976fca6b59ad7eb0$exports = {};

$parcel$export($976fca6b59ad7eb0$exports, "__esModule", function () { return $976fca6b59ad7eb0$export$1e511d4a378977f5; }, function (v) { return $976fca6b59ad7eb0$export$1e511d4a378977f5 = v; });
$parcel$export($976fca6b59ad7eb0$exports, "Pan", function () { return $976fca6b59ad7eb0$export$f86166cd6057c2d1; }, function (v) { return $976fca6b59ad7eb0$export$f86166cd6057c2d1 = v; });
var $976fca6b59ad7eb0$export$1e511d4a378977f5;
var $976fca6b59ad7eb0$export$f86166cd6057c2d1;
"use strict";
$976fca6b59ad7eb0$export$1e511d4a378977f5 = true;
$976fca6b59ad7eb0$export$f86166cd6057c2d1 = void 0;

var $976fca6b59ad7eb0$var$_react = $976fca6b59ad7eb0$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $976fca6b59ad7eb0$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($976fca6b59ad7eb0$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $976fca6b59ad7eb0$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $976fca6b59ad7eb0$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $976fca6b59ad7eb0$var$_extends() {
    return $976fca6b59ad7eb0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $976fca6b59ad7eb0$var$_extends.apply(null, arguments);
}
var $976fca6b59ad7eb0$var$Pan = $976fca6b59ad7eb0$export$f86166cd6057c2d1 = /*#__PURE__*/ (0, $976fca6b59ad7eb0$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $976fca6b59ad7eb0$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $976fca6b59ad7eb0$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Pan"
    }, props), /*#__PURE__*/ $976fca6b59ad7eb0$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8.5 5.5 12 2l3.5 3.5M22 12H2m3.5-3.5L2 12l3.5 3.5m13 0L22 12l-3.5-3.5M12 22V2M8.5 18.5 12 22l3.5-3.5"
    }));
});
$976fca6b59ad7eb0$var$Pan.displayName = 'Pan';


Object.keys($976fca6b59ad7eb0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $976fca6b59ad7eb0$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $976fca6b59ad7eb0$exports[key];
});
var $2eea4036bf80d044$exports = {};

$parcel$export($2eea4036bf80d044$exports, "__esModule", function () { return $2eea4036bf80d044$export$1e511d4a378977f5; }, function (v) { return $2eea4036bf80d044$export$1e511d4a378977f5 = v; });
$parcel$export($2eea4036bf80d044$exports, "PauseFill", function () { return $2eea4036bf80d044$export$d7cc50af67a5753; }, function (v) { return $2eea4036bf80d044$export$d7cc50af67a5753 = v; });
var $2eea4036bf80d044$export$1e511d4a378977f5;
var $2eea4036bf80d044$export$d7cc50af67a5753;
"use strict";
$2eea4036bf80d044$export$1e511d4a378977f5 = true;
$2eea4036bf80d044$export$d7cc50af67a5753 = void 0;

var $2eea4036bf80d044$var$_react = $2eea4036bf80d044$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $2eea4036bf80d044$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2eea4036bf80d044$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2eea4036bf80d044$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $2eea4036bf80d044$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $2eea4036bf80d044$var$_extends() {
    return $2eea4036bf80d044$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2eea4036bf80d044$var$_extends.apply(null, arguments);
}
var $2eea4036bf80d044$var$PauseFill = $2eea4036bf80d044$export$d7cc50af67a5753 = /*#__PURE__*/ (0, $2eea4036bf80d044$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $2eea4036bf80d044$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $2eea4036bf80d044$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "PauseFill"
    }, props), /*#__PURE__*/ $2eea4036bf80d044$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M3 21h6V3H3v18zm1-2h4V5H4v14zm1-2h2V7H5v10zm10 4h6V3h-6v18zm1-2h4V5h-4v14zm1-2h2V7h-2v10z"
    }));
});
$2eea4036bf80d044$var$PauseFill.displayName = 'PauseFill';


Object.keys($2eea4036bf80d044$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $2eea4036bf80d044$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $2eea4036bf80d044$exports[key];
});

Object.keys($e751bc12b719d8f4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e751bc12b719d8f4$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e751bc12b719d8f4$exports[key];
});
var $6babab36fc1e37fb$exports = {};

$parcel$export($6babab36fc1e37fb$exports, "__esModule", function () { return $6babab36fc1e37fb$export$1e511d4a378977f5; }, function (v) { return $6babab36fc1e37fb$export$1e511d4a378977f5 = v; });
$parcel$export($6babab36fc1e37fb$exports, "Paypal", function () { return $6babab36fc1e37fb$export$6058da33c8008905; }, function (v) { return $6babab36fc1e37fb$export$6058da33c8008905 = v; });
var $6babab36fc1e37fb$export$1e511d4a378977f5;
var $6babab36fc1e37fb$export$6058da33c8008905;
"use strict";
$6babab36fc1e37fb$export$1e511d4a378977f5 = true;
$6babab36fc1e37fb$export$6058da33c8008905 = void 0;

var $6babab36fc1e37fb$var$_react = $6babab36fc1e37fb$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $6babab36fc1e37fb$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6babab36fc1e37fb$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6babab36fc1e37fb$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6babab36fc1e37fb$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6babab36fc1e37fb$var$_extends() {
    return $6babab36fc1e37fb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6babab36fc1e37fb$var$_extends.apply(null, arguments);
}
var $6babab36fc1e37fb$var$Paypal = $6babab36fc1e37fb$export$6058da33c8008905 = /*#__PURE__*/ (0, $6babab36fc1e37fb$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $6babab36fc1e37fb$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $6babab36fc1e37fb$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Paypal"
    }, props), /*#__PURE__*/ $6babab36fc1e37fb$var$_react["default"].createElement("path", {
        fill: "#003087",
        fillRule: "evenodd",
        d: "M21.495 7.054c-1.07 4.973-4.48 7.604-9.89 7.604H9.643L8.18 24h3.182c.46 0 .85-.334.923-.788l.037-.198.732-4.636.047-.256a.933.933 0 0 1 .922-.788h.581c3.76 0 6.705-1.528 7.565-5.946.345-1.773.179-3.26-.674-4.334M19.317 1.81C18.206.543 16.197 0 13.627 0H6.169c-.526 0-.973.383-1.055.9L2.008 20.598a.64.64 0 0 0 .633.74h4.604l1.157-7.335-.036.23c.082-.518.526-.9 1.051-.9h2.188c4.299 0 7.664-1.747 8.648-6.797.029-.15.076-.438.076-.438.279-1.869-.002-3.137-1.012-4.287"
    }));
});
$6babab36fc1e37fb$var$Paypal.displayName = 'Paypal';


Object.keys($6babab36fc1e37fb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $6babab36fc1e37fb$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $6babab36fc1e37fb$exports[key];
});
var $488b6a1370cb6925$exports = {};

$parcel$export($488b6a1370cb6925$exports, "__esModule", function () { return $488b6a1370cb6925$export$1e511d4a378977f5; }, function (v) { return $488b6a1370cb6925$export$1e511d4a378977f5 = v; });
$parcel$export($488b6a1370cb6925$exports, "Performance", function () { return $488b6a1370cb6925$export$7e252627609de684; }, function (v) { return $488b6a1370cb6925$export$7e252627609de684 = v; });
var $488b6a1370cb6925$export$1e511d4a378977f5;
var $488b6a1370cb6925$export$7e252627609de684;
"use strict";
$488b6a1370cb6925$export$1e511d4a378977f5 = true;
$488b6a1370cb6925$export$7e252627609de684 = void 0;

var $488b6a1370cb6925$var$_react = $488b6a1370cb6925$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $488b6a1370cb6925$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($488b6a1370cb6925$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $488b6a1370cb6925$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $488b6a1370cb6925$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $488b6a1370cb6925$var$_extends() {
    return $488b6a1370cb6925$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $488b6a1370cb6925$var$_extends.apply(null, arguments);
}
var $488b6a1370cb6925$var$Performance = $488b6a1370cb6925$export$7e252627609de684 = /*#__PURE__*/ (0, $488b6a1370cb6925$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $488b6a1370cb6925$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $488b6a1370cb6925$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Performance"
    }, props), /*#__PURE__*/ $488b6a1370cb6925$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m12 19-2 3-3-1-.5-3.5L3 17l-1-3 3-2-3-2 1-3 3.5-.5L7 3l3-1 2 3 2-3 3 1 .5 3.5L21 7l1 3-3 2 3 2-1 3-3.5.5L17 21l-3 1-2-3zm0-3a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
    }));
});
$488b6a1370cb6925$var$Performance.displayName = 'Performance';


Object.keys($488b6a1370cb6925$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $488b6a1370cb6925$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $488b6a1370cb6925$exports[key];
});
var $1eadb12310ef3f04$exports = {};

$parcel$export($1eadb12310ef3f04$exports, "__esModule", function () { return $1eadb12310ef3f04$export$1e511d4a378977f5; }, function (v) { return $1eadb12310ef3f04$export$1e511d4a378977f5 = v; });
$parcel$export($1eadb12310ef3f04$exports, "PersonalComputer", function () { return $1eadb12310ef3f04$export$3320a20d5d3fad3d; }, function (v) { return $1eadb12310ef3f04$export$3320a20d5d3fad3d = v; });
var $1eadb12310ef3f04$export$1e511d4a378977f5;
var $1eadb12310ef3f04$export$3320a20d5d3fad3d;
"use strict";
$1eadb12310ef3f04$export$1e511d4a378977f5 = true;
$1eadb12310ef3f04$export$3320a20d5d3fad3d = void 0;

var $1eadb12310ef3f04$var$_react = $1eadb12310ef3f04$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $1eadb12310ef3f04$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1eadb12310ef3f04$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1eadb12310ef3f04$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $1eadb12310ef3f04$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1eadb12310ef3f04$var$_extends() {
    return $1eadb12310ef3f04$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1eadb12310ef3f04$var$_extends.apply(null, arguments);
}
var $1eadb12310ef3f04$var$PersonalComputer = $1eadb12310ef3f04$export$3320a20d5d3fad3d = /*#__PURE__*/ (0, $1eadb12310ef3f04$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $1eadb12310ef3f04$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $1eadb12310ef3f04$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "PersonalComputer"
    }, props), /*#__PURE__*/ $1eadb12310ef3f04$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M3 18h18V5a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v13zm-1 2h20c1 0 1-1 1-1H1s0 1 1 1z"
    }));
});
$1eadb12310ef3f04$var$PersonalComputer.displayName = 'PersonalComputer';


Object.keys($1eadb12310ef3f04$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $1eadb12310ef3f04$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $1eadb12310ef3f04$exports[key];
});
var $7ce99fc1729015c1$exports = {};

$parcel$export($7ce99fc1729015c1$exports, "__esModule", function () { return $7ce99fc1729015c1$export$1e511d4a378977f5; }, function (v) { return $7ce99fc1729015c1$export$1e511d4a378977f5 = v; });
$parcel$export($7ce99fc1729015c1$exports, "PhoneFlip", function () { return $7ce99fc1729015c1$export$3c5de9470abbf85c; }, function (v) { return $7ce99fc1729015c1$export$3c5de9470abbf85c = v; });
var $7ce99fc1729015c1$export$1e511d4a378977f5;
var $7ce99fc1729015c1$export$3c5de9470abbf85c;
"use strict";
$7ce99fc1729015c1$export$1e511d4a378977f5 = true;
$7ce99fc1729015c1$export$3c5de9470abbf85c = void 0;

var $7ce99fc1729015c1$var$_react = $7ce99fc1729015c1$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $7ce99fc1729015c1$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7ce99fc1729015c1$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7ce99fc1729015c1$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $7ce99fc1729015c1$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7ce99fc1729015c1$var$_extends() {
    return $7ce99fc1729015c1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7ce99fc1729015c1$var$_extends.apply(null, arguments);
}
var $7ce99fc1729015c1$var$PhoneFlip = $7ce99fc1729015c1$export$3c5de9470abbf85c = /*#__PURE__*/ (0, $7ce99fc1729015c1$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $7ce99fc1729015c1$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $7ce99fc1729015c1$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "PhoneFlip"
    }, props), /*#__PURE__*/ $7ce99fc1729015c1$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 1a1 1 0 0 0-.928.629l-4 10a1 1 0 0 0 0 .742l4 10A1 1 0 0 0 8 23h10a1 1 0 0 0 .928-1.371L15.078 12l3.851-9.629A1 1 0 0 0 18 1H8zM5.477 11l3.2-8h2.794a1 1 0 0 0 1 1h.057a1 1 0 0 0 1.001-1h2.994l-3.2 8H5.477zm0 2 3.2 8h7.846l-3.2-8H5.477zm5.558 6.773a1 1 0 0 1 .937-1.351h.056a1 1 0 1 1 0 2h-.056a1 1 0 0 1-.937-.649z",
        fill: "#000"
    }));
});
$7ce99fc1729015c1$var$PhoneFlip.displayName = 'PhoneFlip';


Object.keys($7ce99fc1729015c1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $7ce99fc1729015c1$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $7ce99fc1729015c1$exports[key];
});
var $e2de5ebc31eab138$exports = {};

$parcel$export($e2de5ebc31eab138$exports, "__esModule", function () { return $e2de5ebc31eab138$export$1e511d4a378977f5; }, function (v) { return $e2de5ebc31eab138$export$1e511d4a378977f5 = v; });
$parcel$export($e2de5ebc31eab138$exports, "PhoneHorizontal", function () { return $e2de5ebc31eab138$export$9dec7cbb121f08e4; }, function (v) { return $e2de5ebc31eab138$export$9dec7cbb121f08e4 = v; });
var $e2de5ebc31eab138$export$1e511d4a378977f5;
var $e2de5ebc31eab138$export$9dec7cbb121f08e4;
"use strict";
$e2de5ebc31eab138$export$1e511d4a378977f5 = true;
$e2de5ebc31eab138$export$9dec7cbb121f08e4 = void 0;

var $e2de5ebc31eab138$var$_react = $e2de5ebc31eab138$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e2de5ebc31eab138$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e2de5ebc31eab138$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e2de5ebc31eab138$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e2de5ebc31eab138$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e2de5ebc31eab138$var$_extends() {
    return $e2de5ebc31eab138$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e2de5ebc31eab138$var$_extends.apply(null, arguments);
}
var $e2de5ebc31eab138$var$PhoneHorizontal = $e2de5ebc31eab138$export$9dec7cbb121f08e4 = /*#__PURE__*/ (0, $e2de5ebc31eab138$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e2de5ebc31eab138$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e2de5ebc31eab138$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "PhoneHorizontal"
    }, props), /*#__PURE__*/ $e2de5ebc31eab138$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23 7a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V7zm-2 5.996V17H3V7h18v4.004a1.038 1.038 0 0 0-.094-.004h-1a1 1 0 0 0 0 2h1c.032 0 .063-.002.094-.004z",
        fill: "#000"
    }));
});
$e2de5ebc31eab138$var$PhoneHorizontal.displayName = 'PhoneHorizontal';


Object.keys($e2de5ebc31eab138$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e2de5ebc31eab138$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e2de5ebc31eab138$exports[key];
});
var $8c1d009b68ac1892$exports = {};

$parcel$export($8c1d009b68ac1892$exports, "__esModule", function () { return $8c1d009b68ac1892$export$1e511d4a378977f5; }, function (v) { return $8c1d009b68ac1892$export$1e511d4a378977f5 = v; });
$parcel$export($8c1d009b68ac1892$exports, "PhoneVertical", function () { return $8c1d009b68ac1892$export$58685cd6c2e2c658; }, function (v) { return $8c1d009b68ac1892$export$58685cd6c2e2c658 = v; });
var $8c1d009b68ac1892$export$1e511d4a378977f5;
var $8c1d009b68ac1892$export$58685cd6c2e2c658;
"use strict";
$8c1d009b68ac1892$export$1e511d4a378977f5 = true;
$8c1d009b68ac1892$export$58685cd6c2e2c658 = void 0;

var $8c1d009b68ac1892$var$_react = $8c1d009b68ac1892$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $8c1d009b68ac1892$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8c1d009b68ac1892$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8c1d009b68ac1892$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $8c1d009b68ac1892$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8c1d009b68ac1892$var$_extends() {
    return $8c1d009b68ac1892$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8c1d009b68ac1892$var$_extends.apply(null, arguments);
}
var $8c1d009b68ac1892$var$PhoneVertical = $8c1d009b68ac1892$export$58685cd6c2e2c658 = /*#__PURE__*/ (0, $8c1d009b68ac1892$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $8c1d009b68ac1892$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $8c1d009b68ac1892$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "PhoneVertical"
    }, props), /*#__PURE__*/ $8c1d009b68ac1892$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17 23a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h10zm-6-2H7V3h10v18h-4v-1.031a1 1 0 0 0-2 0V21z",
        fill: "#000"
    }));
});
$8c1d009b68ac1892$var$PhoneVertical.displayName = 'PhoneVertical';


Object.keys($8c1d009b68ac1892$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $8c1d009b68ac1892$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $8c1d009b68ac1892$exports[key];
});
var $b54513b46811b130$exports = {};

$parcel$export($b54513b46811b130$exports, "__esModule", function () { return $b54513b46811b130$export$1e511d4a378977f5; }, function (v) { return $b54513b46811b130$export$1e511d4a378977f5 = v; });
$parcel$export($b54513b46811b130$exports, "Phone", function () { return $b54513b46811b130$export$2de540f0cd7c073a; }, function (v) { return $b54513b46811b130$export$2de540f0cd7c073a = v; });
var $b54513b46811b130$export$1e511d4a378977f5;
var $b54513b46811b130$export$2de540f0cd7c073a;
"use strict";
$b54513b46811b130$export$1e511d4a378977f5 = true;
$b54513b46811b130$export$2de540f0cd7c073a = void 0;

var $b54513b46811b130$var$_react = $b54513b46811b130$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $b54513b46811b130$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b54513b46811b130$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b54513b46811b130$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $b54513b46811b130$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b54513b46811b130$var$_extends() {
    return $b54513b46811b130$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b54513b46811b130$var$_extends.apply(null, arguments);
}
var $b54513b46811b130$var$Phone = $b54513b46811b130$export$2de540f0cd7c073a = /*#__PURE__*/ (0, $b54513b46811b130$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $b54513b46811b130$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $b54513b46811b130$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Phone"
    }, props), /*#__PURE__*/ $b54513b46811b130$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M6.375 2C5 2 3 3.5 2.5 4.5c-.715 1.43-.597 1.99-.125 3.5.625 2 2.457 5.545 5 8 3.625 3.5 7 5 8.5 5.5s3.125 0 4.125-1 2-2 .875-3.5c-.797-1.063-1.959-2.292-3.375-3-1.288-.644-2.056-.41-2.5.5-.246.503-.322 1.466-.5 2-.225.674-1.125.5-2.125 0C11.418 16.021 9 14 7 11c-1.24-1.859.742-1.87 2-2.5 1-.5 1.31-1.65.5-3C8 3 7.5 2 6.375 2z"
    }));
});
$b54513b46811b130$var$Phone.displayName = 'Phone';


Object.keys($b54513b46811b130$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $b54513b46811b130$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $b54513b46811b130$exports[key];
});
var $8edd37a2c7eb9793$exports = {};

$parcel$export($8edd37a2c7eb9793$exports, "__esModule", function () { return $8edd37a2c7eb9793$export$1e511d4a378977f5; }, function (v) { return $8edd37a2c7eb9793$export$1e511d4a378977f5 = v; });
$parcel$export($8edd37a2c7eb9793$exports, "PieChart", function () { return $8edd37a2c7eb9793$export$b99d3348f709c998; }, function (v) { return $8edd37a2c7eb9793$export$b99d3348f709c998 = v; });
var $8edd37a2c7eb9793$export$1e511d4a378977f5;
var $8edd37a2c7eb9793$export$b99d3348f709c998;
"use strict";
$8edd37a2c7eb9793$export$1e511d4a378977f5 = true;
$8edd37a2c7eb9793$export$b99d3348f709c998 = void 0;

var $8edd37a2c7eb9793$var$_react = $8edd37a2c7eb9793$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $8edd37a2c7eb9793$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8edd37a2c7eb9793$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8edd37a2c7eb9793$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $8edd37a2c7eb9793$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8edd37a2c7eb9793$var$_extends() {
    return $8edd37a2c7eb9793$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8edd37a2c7eb9793$var$_extends.apply(null, arguments);
}
var $8edd37a2c7eb9793$var$PieChart = $8edd37a2c7eb9793$export$b99d3348f709c998 = /*#__PURE__*/ (0, $8edd37a2c7eb9793$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $8edd37a2c7eb9793$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $8edd37a2c7eb9793$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "PieChart"
    }, props), /*#__PURE__*/ $8edd37a2c7eb9793$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M10 23a9 9 0 0 1 0-18v9l1.162 1.162 5.202 5.202A8.972 8.972 0 0 1 10 23zm4-13V1a9 9 0 0 1 9 9h-9zm0 3h8a8.964 8.964 0 0 1-2.107 5.787L14 13z"
    }));
});
$8edd37a2c7eb9793$var$PieChart.displayName = 'PieChart';


Object.keys($8edd37a2c7eb9793$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $8edd37a2c7eb9793$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $8edd37a2c7eb9793$exports[key];
});
var $05168a0270146bd6$exports = {};

$parcel$export($05168a0270146bd6$exports, "__esModule", function () { return $05168a0270146bd6$export$1e511d4a378977f5; }, function (v) { return $05168a0270146bd6$export$1e511d4a378977f5 = v; });
$parcel$export($05168a0270146bd6$exports, "PiedPiper", function () { return $05168a0270146bd6$export$c362797d98d781d8; }, function (v) { return $05168a0270146bd6$export$c362797d98d781d8 = v; });
var $05168a0270146bd6$export$1e511d4a378977f5;
var $05168a0270146bd6$export$c362797d98d781d8;
"use strict";
$05168a0270146bd6$export$1e511d4a378977f5 = true;
$05168a0270146bd6$export$c362797d98d781d8 = void 0;

var $05168a0270146bd6$var$_react = $05168a0270146bd6$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $05168a0270146bd6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($05168a0270146bd6$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $05168a0270146bd6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $05168a0270146bd6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $05168a0270146bd6$var$_extends() {
    return $05168a0270146bd6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $05168a0270146bd6$var$_extends.apply(null, arguments);
}
var $05168a0270146bd6$var$PiedPiper = $05168a0270146bd6$export$c362797d98d781d8 = /*#__PURE__*/ (0, $05168a0270146bd6$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $05168a0270146bd6$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $05168a0270146bd6$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "PiedPiper"
    }, props), /*#__PURE__*/ $05168a0270146bd6$var$_react["default"].createElement("path", {
        fill: "#609B4D",
        fillRule: "evenodd",
        d: "M0 19.421c2.274 0 4.042-.758 4.042-.758s3.032-7.579 7.326-7.579c3.285 0 3.79 2.527 3.79 2.527S19.958 4.263 24 3c-3.79 3.032-3.284 6.316-5.053 7.832-1.768 1.515-1.768.006-3.79 3.543-4.546.505-6.032 2.014-9.094 3.783 5.305-2.526 6.316-2.78 11.116-2.526.504.026.758.252.505.757-.733 1.466-1.28 3.673-2.273 3.537-5.558-.758-8.843.506-11.622.506-2.778 0-3.789-.506-3.789-1.01z"
    }));
});
$05168a0270146bd6$var$PiedPiper.displayName = 'PiedPiper';


Object.keys($05168a0270146bd6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $05168a0270146bd6$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $05168a0270146bd6$exports[key];
});
var $5e71c012db50e96c$exports = {};

$parcel$export($5e71c012db50e96c$exports, "__esModule", function () { return $5e71c012db50e96c$export$1e511d4a378977f5; }, function (v) { return $5e71c012db50e96c$export$1e511d4a378977f5 = v; });
$parcel$export($5e71c012db50e96c$exports, "Pin", function () { return $5e71c012db50e96c$export$656559010049c8e; }, function (v) { return $5e71c012db50e96c$export$656559010049c8e = v; });
var $5e71c012db50e96c$export$1e511d4a378977f5;
var $5e71c012db50e96c$export$656559010049c8e;
"use strict";
$5e71c012db50e96c$export$1e511d4a378977f5 = true;
$5e71c012db50e96c$export$656559010049c8e = void 0;

var $5e71c012db50e96c$var$_react = $5e71c012db50e96c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5e71c012db50e96c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5e71c012db50e96c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5e71c012db50e96c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5e71c012db50e96c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5e71c012db50e96c$var$_extends() {
    return $5e71c012db50e96c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5e71c012db50e96c$var$_extends.apply(null, arguments);
}
var $5e71c012db50e96c$var$Pin = $5e71c012db50e96c$export$656559010049c8e = /*#__PURE__*/ (0, $5e71c012db50e96c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5e71c012db50e96c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5e71c012db50e96c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Pin"
    }, props), /*#__PURE__*/ $5e71c012db50e96c$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m16 3-6 6s-4-1-7 2l10 10c3-3 2-7 2-7l6-6-5-5zM1 23l7-7m6-15 9 9"
    }));
});
$5e71c012db50e96c$var$Pin.displayName = 'Pin';


Object.keys($5e71c012db50e96c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5e71c012db50e96c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5e71c012db50e96c$exports[key];
});
var $1c514e4fcea9425e$exports = {};

$parcel$export($1c514e4fcea9425e$exports, "__esModule", function () { return $1c514e4fcea9425e$export$1e511d4a378977f5; }, function (v) { return $1c514e4fcea9425e$export$1e511d4a378977f5 = v; });
$parcel$export($1c514e4fcea9425e$exports, "Pinterest", function () { return $1c514e4fcea9425e$export$28e96eb427698463; }, function (v) { return $1c514e4fcea9425e$export$28e96eb427698463 = v; });
var $1c514e4fcea9425e$export$1e511d4a378977f5;
var $1c514e4fcea9425e$export$28e96eb427698463;
"use strict";
$1c514e4fcea9425e$export$1e511d4a378977f5 = true;
$1c514e4fcea9425e$export$28e96eb427698463 = void 0;

var $1c514e4fcea9425e$var$_react = $1c514e4fcea9425e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $1c514e4fcea9425e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1c514e4fcea9425e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1c514e4fcea9425e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $1c514e4fcea9425e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1c514e4fcea9425e$var$_extends() {
    return $1c514e4fcea9425e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1c514e4fcea9425e$var$_extends.apply(null, arguments);
}
var $1c514e4fcea9425e$var$Pinterest = $1c514e4fcea9425e$export$28e96eb427698463 = /*#__PURE__*/ (0, $1c514e4fcea9425e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $1c514e4fcea9425e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $1c514e4fcea9425e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Pinterest"
    }, props), /*#__PURE__*/ $1c514e4fcea9425e$var$_react["default"].createElement("path", {
        fill: "#BD081C",
        fillRule: "evenodd",
        d: "M12 0C5.372 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.95-.2-2.406.042-3.442.217-.936 1.407-5.965 1.407-5.965s-.36-.718-.36-1.781c0-1.669.968-2.915 2.172-2.915 1.024 0 1.518.769 1.518 1.69 0 1.03-.655 2.57-.993 3.996-.283 1.195.598 2.169 1.777 2.169 2.133 0 3.772-2.25 3.772-5.495 0-2.873-2.065-4.883-5.013-4.883-3.414 0-5.418 2.562-5.418 5.208 0 1.031.397 2.138.893 2.739a.359.359 0 0 1 .083.344c-.091.38-.293 1.194-.333 1.361-.053.219-.174.266-.402.16-1.499-.698-2.436-2.888-2.436-4.649 0-3.785 2.75-7.261 7.93-7.261 4.162 0 7.397 2.966 7.397 6.93 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.358-.632-2.75-1.378l-.748 2.853c-.27 1.042-1.002 2.348-1.492 3.146A11.99 11.99 0 0 0 12 24c6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12"
    }));
});
$1c514e4fcea9425e$var$Pinterest.displayName = 'Pinterest';


Object.keys($1c514e4fcea9425e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $1c514e4fcea9425e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $1c514e4fcea9425e$exports[key];
});
var $b48cec091a614891$exports = {};

$parcel$export($b48cec091a614891$exports, "__esModule", function () { return $b48cec091a614891$export$1e511d4a378977f5; }, function (v) { return $b48cec091a614891$export$1e511d4a378977f5 = v; });
$parcel$export($b48cec091a614891$exports, "Plan", function () { return $b48cec091a614891$export$814cc77def5a44df; }, function (v) { return $b48cec091a614891$export$814cc77def5a44df = v; });
var $b48cec091a614891$export$1e511d4a378977f5;
var $b48cec091a614891$export$814cc77def5a44df;
"use strict";
$b48cec091a614891$export$1e511d4a378977f5 = true;
$b48cec091a614891$export$814cc77def5a44df = void 0;

var $b48cec091a614891$var$_react = $b48cec091a614891$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $b48cec091a614891$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b48cec091a614891$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b48cec091a614891$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $b48cec091a614891$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b48cec091a614891$var$_extends() {
    return $b48cec091a614891$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b48cec091a614891$var$_extends.apply(null, arguments);
}
var $b48cec091a614891$var$Plan = $b48cec091a614891$export$814cc77def5a44df = /*#__PURE__*/ (0, $b48cec091a614891$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $b48cec091a614891$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $b48cec091a614891$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Plan"
    }, props), /*#__PURE__*/ $b48cec091a614891$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M18 4V0v4zM7 18H5h2zm12 0H9h10zM7 14H5h2zm12 0H9h10zM6 4V0v4zM1 9h22H1zm0 14h22V4H1v19z"
    }));
});
$b48cec091a614891$var$Plan.displayName = 'Plan';


Object.keys($b48cec091a614891$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $b48cec091a614891$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $b48cec091a614891$exports[key];
});
var $1b42483fb3a60291$exports = {};

$parcel$export($1b42483fb3a60291$exports, "__esModule", function () { return $1b42483fb3a60291$export$1e511d4a378977f5; }, function (v) { return $1b42483fb3a60291$export$1e511d4a378977f5 = v; });
$parcel$export($1b42483fb3a60291$exports, "PlayFill", function () { return $1b42483fb3a60291$export$928b8ae56e1c59b5; }, function (v) { return $1b42483fb3a60291$export$928b8ae56e1c59b5 = v; });
var $1b42483fb3a60291$export$1e511d4a378977f5;
var $1b42483fb3a60291$export$928b8ae56e1c59b5;
"use strict";
$1b42483fb3a60291$export$1e511d4a378977f5 = true;
$1b42483fb3a60291$export$928b8ae56e1c59b5 = void 0;

var $1b42483fb3a60291$var$_react = $1b42483fb3a60291$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $1b42483fb3a60291$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1b42483fb3a60291$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1b42483fb3a60291$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $1b42483fb3a60291$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1b42483fb3a60291$var$_extends() {
    return $1b42483fb3a60291$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1b42483fb3a60291$var$_extends.apply(null, arguments);
}
var $1b42483fb3a60291$var$PlayFill = $1b42483fb3a60291$export$928b8ae56e1c59b5 = /*#__PURE__*/ (0, $1b42483fb3a60291$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $1b42483fb3a60291$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $1b42483fb3a60291$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "PlayFill"
    }, props), /*#__PURE__*/ $1b42483fb3a60291$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m3 22 18-10L3 2v20zm2-3 12.6-7L5 5v14zm2-3 7.2-4L7 8v8zm2-3 1.8-1L9 11v2z"
    }));
});
$1b42483fb3a60291$var$PlayFill.displayName = 'PlayFill';


Object.keys($1b42483fb3a60291$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $1b42483fb3a60291$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $1b42483fb3a60291$exports[key];
});

Object.keys($82c01c28d93e7046$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $82c01c28d93e7046$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $82c01c28d93e7046$exports[key];
});
var $a544bdef7b1ef308$exports = {};

$parcel$export($a544bdef7b1ef308$exports, "__esModule", function () { return $a544bdef7b1ef308$export$1e511d4a378977f5; }, function (v) { return $a544bdef7b1ef308$export$1e511d4a378977f5 = v; });
$parcel$export($a544bdef7b1ef308$exports, "Plug", function () { return $a544bdef7b1ef308$export$59a9c83b43c38f33; }, function (v) { return $a544bdef7b1ef308$export$59a9c83b43c38f33 = v; });
var $a544bdef7b1ef308$export$1e511d4a378977f5;
var $a544bdef7b1ef308$export$59a9c83b43c38f33;
"use strict";
$a544bdef7b1ef308$export$1e511d4a378977f5 = true;
$a544bdef7b1ef308$export$59a9c83b43c38f33 = void 0;

var $a544bdef7b1ef308$var$_react = $a544bdef7b1ef308$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a544bdef7b1ef308$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a544bdef7b1ef308$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a544bdef7b1ef308$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a544bdef7b1ef308$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a544bdef7b1ef308$var$_extends() {
    return $a544bdef7b1ef308$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a544bdef7b1ef308$var$_extends.apply(null, arguments);
}
var $a544bdef7b1ef308$var$Plug = $a544bdef7b1ef308$export$59a9c83b43c38f33 = /*#__PURE__*/ (0, $a544bdef7b1ef308$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a544bdef7b1ef308$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a544bdef7b1ef308$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Plug"
    }, props), /*#__PURE__*/ $a544bdef7b1ef308$var$_react["default"].createElement("path", {
        stroke: "#000",
        strokeWidth: "2",
        fill: "none",
        d: "M15 6V1m-3 23v-9M9 6V1M6 6h12v7a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6z"
    }));
});
$a544bdef7b1ef308$var$Plug.displayName = 'Plug';


Object.keys($a544bdef7b1ef308$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a544bdef7b1ef308$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a544bdef7b1ef308$exports[key];
});
var $2f1ae4c3677fb3d2$exports = {};

$parcel$export($2f1ae4c3677fb3d2$exports, "__esModule", function () { return $2f1ae4c3677fb3d2$export$1e511d4a378977f5; }, function (v) { return $2f1ae4c3677fb3d2$export$1e511d4a378977f5 = v; });
$parcel$export($2f1ae4c3677fb3d2$exports, "Pocket", function () { return $2f1ae4c3677fb3d2$export$929c1822f3c0a05a; }, function (v) { return $2f1ae4c3677fb3d2$export$929c1822f3c0a05a = v; });
var $2f1ae4c3677fb3d2$export$1e511d4a378977f5;
var $2f1ae4c3677fb3d2$export$929c1822f3c0a05a;
"use strict";
$2f1ae4c3677fb3d2$export$1e511d4a378977f5 = true;
$2f1ae4c3677fb3d2$export$929c1822f3c0a05a = void 0;

var $2f1ae4c3677fb3d2$var$_react = $2f1ae4c3677fb3d2$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $2f1ae4c3677fb3d2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2f1ae4c3677fb3d2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2f1ae4c3677fb3d2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $2f1ae4c3677fb3d2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $2f1ae4c3677fb3d2$var$_extends() {
    return $2f1ae4c3677fb3d2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2f1ae4c3677fb3d2$var$_extends.apply(null, arguments);
}
var $2f1ae4c3677fb3d2$var$Pocket = $2f1ae4c3677fb3d2$export$929c1822f3c0a05a = /*#__PURE__*/ (0, $2f1ae4c3677fb3d2$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $2f1ae4c3677fb3d2$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $2f1ae4c3677fb3d2$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Pocket"
    }, props), /*#__PURE__*/ $2f1ae4c3677fb3d2$var$_react["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $2f1ae4c3677fb3d2$var$_react["default"].createElement("path", {
        fill: "#F50057",
        d: "M12 2H2a2 2 0 0 0-2 2v8c0 5.982 6 11 12 11s12-5.018 12-11V4a2 2 0 0 0-2-2H12z"
    }), /*#__PURE__*/ $2f1ae4c3677fb3d2$var$_react["default"].createElement("path", {
        stroke: "#FFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "3",
        d: "m6 9 6.404 6L18 9"
    })));
});
$2f1ae4c3677fb3d2$var$Pocket.displayName = 'Pocket';


Object.keys($2f1ae4c3677fb3d2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $2f1ae4c3677fb3d2$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $2f1ae4c3677fb3d2$exports[key];
});
var $1d4f8cd80a14844b$exports = {};

$parcel$export($1d4f8cd80a14844b$exports, "__esModule", function () { return $1d4f8cd80a14844b$export$1e511d4a378977f5; }, function (v) { return $1d4f8cd80a14844b$export$1e511d4a378977f5 = v; });
$parcel$export($1d4f8cd80a14844b$exports, "PowerCycle", function () { return $1d4f8cd80a14844b$export$55c87e8bad455629; }, function (v) { return $1d4f8cd80a14844b$export$55c87e8bad455629 = v; });
var $1d4f8cd80a14844b$export$1e511d4a378977f5;
var $1d4f8cd80a14844b$export$55c87e8bad455629;
"use strict";
$1d4f8cd80a14844b$export$1e511d4a378977f5 = true;
$1d4f8cd80a14844b$export$55c87e8bad455629 = void 0;

var $1d4f8cd80a14844b$var$_react = $1d4f8cd80a14844b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $1d4f8cd80a14844b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1d4f8cd80a14844b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1d4f8cd80a14844b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $1d4f8cd80a14844b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1d4f8cd80a14844b$var$_extends() {
    return $1d4f8cd80a14844b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1d4f8cd80a14844b$var$_extends.apply(null, arguments);
}
var $1d4f8cd80a14844b$var$PowerCycle = $1d4f8cd80a14844b$export$55c87e8bad455629 = /*#__PURE__*/ (0, $1d4f8cd80a14844b$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $1d4f8cd80a14844b$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $1d4f8cd80a14844b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "PowerCycle"
    }, props), /*#__PURE__*/ $1d4f8cd80a14844b$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M20 8a8.955 8.955 0 0 0-8.036-5C7.014 3 3 7.03 3 12m1 4a8.955 8.955 0 0 0 8.036 5C16.986 21 21 16.97 21 12M9 16H3v6M21 2v6h-6"
    }));
});
$1d4f8cd80a14844b$var$PowerCycle.displayName = 'PowerCycle';


Object.keys($1d4f8cd80a14844b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $1d4f8cd80a14844b$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $1d4f8cd80a14844b$exports[key];
});
var $fbd5ede787a306a3$exports = {};

$parcel$export($fbd5ede787a306a3$exports, "__esModule", function () { return $fbd5ede787a306a3$export$1e511d4a378977f5; }, function (v) { return $fbd5ede787a306a3$export$1e511d4a378977f5 = v; });
$parcel$export($fbd5ede787a306a3$exports, "PowerForceShutdown", function () { return $fbd5ede787a306a3$export$a5a22a0ebb70af47; }, function (v) { return $fbd5ede787a306a3$export$a5a22a0ebb70af47 = v; });
var $fbd5ede787a306a3$export$1e511d4a378977f5;
var $fbd5ede787a306a3$export$a5a22a0ebb70af47;
"use strict";
$fbd5ede787a306a3$export$1e511d4a378977f5 = true;
$fbd5ede787a306a3$export$a5a22a0ebb70af47 = void 0;

var $fbd5ede787a306a3$var$_react = $fbd5ede787a306a3$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $fbd5ede787a306a3$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($fbd5ede787a306a3$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $fbd5ede787a306a3$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $fbd5ede787a306a3$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $fbd5ede787a306a3$var$_extends() {
    return $fbd5ede787a306a3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fbd5ede787a306a3$var$_extends.apply(null, arguments);
}
var $fbd5ede787a306a3$var$PowerForceShutdown = $fbd5ede787a306a3$export$a5a22a0ebb70af47 = /*#__PURE__*/ (0, $fbd5ede787a306a3$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $fbd5ede787a306a3$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $fbd5ede787a306a3$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "PowerForceShutdown"
    }, props), /*#__PURE__*/ $fbd5ede787a306a3$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm0-13v8"
    }));
});
$fbd5ede787a306a3$var$PowerForceShutdown.displayName = 'PowerForceShutdown';


Object.keys($fbd5ede787a306a3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $fbd5ede787a306a3$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $fbd5ede787a306a3$exports[key];
});
var $2dd467bb7e41b433$exports = {};

$parcel$export($2dd467bb7e41b433$exports, "__esModule", function () { return $2dd467bb7e41b433$export$1e511d4a378977f5; }, function (v) { return $2dd467bb7e41b433$export$1e511d4a378977f5 = v; });
$parcel$export($2dd467bb7e41b433$exports, "PowerReset", function () { return $2dd467bb7e41b433$export$c60674b24c887d80; }, function (v) { return $2dd467bb7e41b433$export$c60674b24c887d80 = v; });
var $2dd467bb7e41b433$export$1e511d4a378977f5;
var $2dd467bb7e41b433$export$c60674b24c887d80;
"use strict";
$2dd467bb7e41b433$export$1e511d4a378977f5 = true;
$2dd467bb7e41b433$export$c60674b24c887d80 = void 0;

var $2dd467bb7e41b433$var$_react = $2dd467bb7e41b433$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $2dd467bb7e41b433$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2dd467bb7e41b433$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2dd467bb7e41b433$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $2dd467bb7e41b433$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $2dd467bb7e41b433$var$_extends() {
    return $2dd467bb7e41b433$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2dd467bb7e41b433$var$_extends.apply(null, arguments);
}
var $2dd467bb7e41b433$var$PowerReset = $2dd467bb7e41b433$export$c60674b24c887d80 = /*#__PURE__*/ (0, $2dd467bb7e41b433$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $2dd467bb7e41b433$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $2dd467bb7e41b433$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "PowerReset"
    }, props), /*#__PURE__*/ $2dd467bb7e41b433$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M20 8c-1.403-2.96-4.463-5-8-5a9 9 0 1 0 0 18 9 9 0 0 0 9-9m0-9v6h-6"
    }));
});
$2dd467bb7e41b433$var$PowerReset.displayName = 'PowerReset';


Object.keys($2dd467bb7e41b433$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $2dd467bb7e41b433$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $2dd467bb7e41b433$exports[key];
});
var $190c606cf9298e68$exports = {};

$parcel$export($190c606cf9298e68$exports, "__esModule", function () { return $190c606cf9298e68$export$1e511d4a378977f5; }, function (v) { return $190c606cf9298e68$export$1e511d4a378977f5 = v; });
$parcel$export($190c606cf9298e68$exports, "PowerShutdown", function () { return $190c606cf9298e68$export$10a2e58f3399e0cb; }, function (v) { return $190c606cf9298e68$export$10a2e58f3399e0cb = v; });
var $190c606cf9298e68$export$1e511d4a378977f5;
var $190c606cf9298e68$export$10a2e58f3399e0cb;
"use strict";
$190c606cf9298e68$export$1e511d4a378977f5 = true;
$190c606cf9298e68$export$10a2e58f3399e0cb = void 0;

var $190c606cf9298e68$var$_react = $190c606cf9298e68$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $190c606cf9298e68$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($190c606cf9298e68$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $190c606cf9298e68$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $190c606cf9298e68$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $190c606cf9298e68$var$_extends() {
    return $190c606cf9298e68$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $190c606cf9298e68$var$_extends.apply(null, arguments);
}
var $190c606cf9298e68$var$PowerShutdown = $190c606cf9298e68$export$10a2e58f3399e0cb = /*#__PURE__*/ (0, $190c606cf9298e68$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $190c606cf9298e68$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $190c606cf9298e68$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "PowerShutdown"
    }, props), /*#__PURE__*/ $190c606cf9298e68$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 1v8M6.994 4.52a9.044 9.044 0 0 0-1.358 1.116 9 9 0 1 0 11.37-1.117"
    }));
});
$190c606cf9298e68$var$PowerShutdown.displayName = 'PowerShutdown';


Object.keys($190c606cf9298e68$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $190c606cf9298e68$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $190c606cf9298e68$exports[key];
});
var $9e5d340e6c33319c$exports = {};

$parcel$export($9e5d340e6c33319c$exports, "__esModule", function () { return $9e5d340e6c33319c$export$1e511d4a378977f5; }, function (v) { return $9e5d340e6c33319c$export$1e511d4a378977f5 = v; });
$parcel$export($9e5d340e6c33319c$exports, "Power", function () { return $9e5d340e6c33319c$export$462bb9472183e274; }, function (v) { return $9e5d340e6c33319c$export$462bb9472183e274 = v; });
var $9e5d340e6c33319c$export$1e511d4a378977f5;
var $9e5d340e6c33319c$export$462bb9472183e274;
"use strict";
$9e5d340e6c33319c$export$1e511d4a378977f5 = true;
$9e5d340e6c33319c$export$462bb9472183e274 = void 0;

var $9e5d340e6c33319c$var$_react = $9e5d340e6c33319c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $9e5d340e6c33319c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9e5d340e6c33319c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9e5d340e6c33319c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $9e5d340e6c33319c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $9e5d340e6c33319c$var$_extends() {
    return $9e5d340e6c33319c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9e5d340e6c33319c$var$_extends.apply(null, arguments);
}
var $9e5d340e6c33319c$var$Power = $9e5d340e6c33319c$export$462bb9472183e274 = /*#__PURE__*/ (0, $9e5d340e6c33319c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $9e5d340e6c33319c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $9e5d340e6c33319c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Power"
    }, props), /*#__PURE__*/ $9e5d340e6c33319c$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M16 4c3.364 1.43 6 4.99 6 9 0 5.6-4.473 10-10 10S2 18.6 2 13c0-4.01 2.636-7.57 6-9m4-3v10"
    }));
});
$9e5d340e6c33319c$var$Power.displayName = 'Power';


Object.keys($9e5d340e6c33319c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $9e5d340e6c33319c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $9e5d340e6c33319c$exports[key];
});

Object.keys($2ce319e09672cf9d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $2ce319e09672cf9d$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $2ce319e09672cf9d$exports[key];
});
var $f504574324f8622e$exports = {};

$parcel$export($f504574324f8622e$exports, "__esModule", function () { return $f504574324f8622e$export$1e511d4a378977f5; }, function (v) { return $f504574324f8622e$export$1e511d4a378977f5 = v; });
$parcel$export($f504574324f8622e$exports, "Print", function () { return $f504574324f8622e$export$531cef85654f2406; }, function (v) { return $f504574324f8622e$export$531cef85654f2406 = v; });
var $f504574324f8622e$export$1e511d4a378977f5;
var $f504574324f8622e$export$531cef85654f2406;
"use strict";
$f504574324f8622e$export$1e511d4a378977f5 = true;
$f504574324f8622e$export$531cef85654f2406 = void 0;

var $f504574324f8622e$var$_react = $f504574324f8622e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f504574324f8622e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f504574324f8622e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f504574324f8622e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f504574324f8622e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f504574324f8622e$var$_extends() {
    return $f504574324f8622e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f504574324f8622e$var$_extends.apply(null, arguments);
}
var $f504574324f8622e$var$Print = $f504574324f8622e$export$531cef85654f2406 = /*#__PURE__*/ (0, $f504574324f8622e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f504574324f8622e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f504574324f8622e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Print"
    }, props), /*#__PURE__*/ $f504574324f8622e$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M6 19H1V7h22v12h-5M3 16h18M6 16v7h12v-7m0-9V1H6v6m11 5h2v-1h-2v1z"
    }));
});
$f504574324f8622e$var$Print.displayName = 'Print';


Object.keys($f504574324f8622e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f504574324f8622e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f504574324f8622e$exports[key];
});
var $b5d2d74e4bbd94f9$exports = {};

$parcel$export($b5d2d74e4bbd94f9$exports, "__esModule", function () { return $b5d2d74e4bbd94f9$export$1e511d4a378977f5; }, function (v) { return $b5d2d74e4bbd94f9$export$1e511d4a378977f5 = v; });
$parcel$export($b5d2d74e4bbd94f9$exports, "ProductHunt", function () { return $b5d2d74e4bbd94f9$export$2127d9538533257; }, function (v) { return $b5d2d74e4bbd94f9$export$2127d9538533257 = v; });
var $b5d2d74e4bbd94f9$export$1e511d4a378977f5;
var $b5d2d74e4bbd94f9$export$2127d9538533257;
"use strict";
$b5d2d74e4bbd94f9$export$1e511d4a378977f5 = true;
$b5d2d74e4bbd94f9$export$2127d9538533257 = void 0;

var $b5d2d74e4bbd94f9$var$_react = $b5d2d74e4bbd94f9$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $b5d2d74e4bbd94f9$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b5d2d74e4bbd94f9$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b5d2d74e4bbd94f9$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $b5d2d74e4bbd94f9$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b5d2d74e4bbd94f9$var$_extends() {
    return $b5d2d74e4bbd94f9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b5d2d74e4bbd94f9$var$_extends.apply(null, arguments);
}
var $b5d2d74e4bbd94f9$var$ProductHunt = $b5d2d74e4bbd94f9$export$2127d9538533257 = /*#__PURE__*/ (0, $b5d2d74e4bbd94f9$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $b5d2d74e4bbd94f9$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $b5d2d74e4bbd94f9$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ProductHunt"
    }, props), /*#__PURE__*/ $b5d2d74e4bbd94f9$var$_react["default"].createElement("path", {
        fill: "#DA552F",
        fillRule: "evenodd",
        d: "M13.6 8.4h-3.4V12h3.4a1.8 1.8 0 1 0 0-3.6m0 6h-3.4V18H7.8V6h5.8a4.2 4.2 0 1 1 0 8.4M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12c6.627 0 12-5.372 12-12S18.627 0 12 0"
    }));
});
$b5d2d74e4bbd94f9$var$ProductHunt.displayName = 'ProductHunt';


Object.keys($b5d2d74e4bbd94f9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $b5d2d74e4bbd94f9$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $b5d2d74e4bbd94f9$exports[key];
});
var $0f431b3fd8fd7951$exports = {};

$parcel$export($0f431b3fd8fd7951$exports, "__esModule", function () { return $0f431b3fd8fd7951$export$1e511d4a378977f5; }, function (v) { return $0f431b3fd8fd7951$export$1e511d4a378977f5 = v; });
$parcel$export($0f431b3fd8fd7951$exports, "Projects", function () { return $0f431b3fd8fd7951$export$ca6fbb51b35e375c; }, function (v) { return $0f431b3fd8fd7951$export$ca6fbb51b35e375c = v; });
var $0f431b3fd8fd7951$export$1e511d4a378977f5;
var $0f431b3fd8fd7951$export$ca6fbb51b35e375c;
"use strict";
$0f431b3fd8fd7951$export$1e511d4a378977f5 = true;
$0f431b3fd8fd7951$export$ca6fbb51b35e375c = void 0;

var $0f431b3fd8fd7951$var$_react = $0f431b3fd8fd7951$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0f431b3fd8fd7951$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0f431b3fd8fd7951$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0f431b3fd8fd7951$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0f431b3fd8fd7951$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0f431b3fd8fd7951$var$_extends() {
    return $0f431b3fd8fd7951$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0f431b3fd8fd7951$var$_extends.apply(null, arguments);
}
var $0f431b3fd8fd7951$var$Projects = $0f431b3fd8fd7951$export$ca6fbb51b35e375c = /*#__PURE__*/ (0, $0f431b3fd8fd7951$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0f431b3fd8fd7951$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0f431b3fd8fd7951$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Projects"
    }, props), /*#__PURE__*/ $0f431b3fd8fd7951$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M9 15v8H1v-8h8zm14 0v8h-8v-8h8zM9 1v8H1V1h8zm14 0v8h-8V1h8z"
    }));
});
$0f431b3fd8fd7951$var$Projects.displayName = 'Projects';


Object.keys($0f431b3fd8fd7951$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0f431b3fd8fd7951$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0f431b3fd8fd7951$exports[key];
});
var $0bf7530499f5206c$exports = {};

$parcel$export($0bf7530499f5206c$exports, "__esModule", function () { return $0bf7530499f5206c$export$1e511d4a378977f5; }, function (v) { return $0bf7530499f5206c$export$1e511d4a378977f5 = v; });
$parcel$export($0bf7530499f5206c$exports, "Qr", function () { return $0bf7530499f5206c$export$5631afde407885cb; }, function (v) { return $0bf7530499f5206c$export$5631afde407885cb = v; });
var $0bf7530499f5206c$export$1e511d4a378977f5;
var $0bf7530499f5206c$export$5631afde407885cb;
"use strict";
$0bf7530499f5206c$export$1e511d4a378977f5 = true;
$0bf7530499f5206c$export$5631afde407885cb = void 0;

var $0bf7530499f5206c$var$_react = $0bf7530499f5206c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0bf7530499f5206c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0bf7530499f5206c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0bf7530499f5206c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0bf7530499f5206c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0bf7530499f5206c$var$_extends() {
    return $0bf7530499f5206c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0bf7530499f5206c$var$_extends.apply(null, arguments);
}
var $0bf7530499f5206c$var$Qr = $0bf7530499f5206c$export$5631afde407885cb = /*#__PURE__*/ (0, $0bf7530499f5206c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0bf7530499f5206c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0bf7530499f5206c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Qr"
    }, props), /*#__PURE__*/ $0bf7530499f5206c$var$_react["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $0bf7530499f5206c$var$_react["default"].createElement("path", {
        fill: "#000",
        d: "M13 14h1v1h-1v-1zm1 1h1v1h-1v-1zm0 1h1v1h-1v-1zm2 0h1v1h-1v-1zm0 1h1v1h-1v-1zm-3-1h1v1h-1v-1zm2 0h1v1h-1v-1zm0 1h1v1h-1v-1zm3-1h1v1h-1v-1zm0-1h1v1h-1v-1zm1-1h1v1h-1v-1zm-2 2h1v1h-1v-1zm0 1h1v1h-1v-1zm-1 1h1v1h-1v-1zm-1 0h1v1h-1v-1zm2 0h1v1h-1v-1zm1 0h1v1h-1v-1zm-2 1h1v1h-1v-1zm-2 0h1v1h-1v-1zm1 0h1v1h-1v-1zm-2 0h1v1h-1v-1zm0 1h1v1h-1v-1zm1 1h1v1h-1v-1zm1 0h1v1h-1v-1zm2 0h1v1h-1v-1zm1 0h1v1h-1v-1zm-1-2h1v1h-1v-1zm1 0h1v1h-1v-1zm1-1h1v1h-1v-1zm0-1h1v1h-1v-1zm0 3h1v1h-1v-1zm0-1h1v1h-1v-1zm1-1h1v1h-1v-1zm0-1h1v1h-1v-1zm1 3h1v1h-1v-1zm0-2h1v1h-1v-1zm0 1h1v1h-1v-1zm-2-3h1v1h-1v-1zm-6 1h1v1h-1v-1zm-1 0h1v1h-1v-1zm0 1h1v1h-1v-1zm2 0h1v1h-1v-1zm-3 0h1v1h-1v-1zm2 0h1v1h-1v-1zm-2 1h1v1h-1v-1zm0 1h1v1h-1v-1zm0-19h1v1h-1V1zm1 1h1v1h-1V2zm-1 2h1v1h-1V4zm1 1h1v1h-1V5zm-1 1h1v1h-1V6zm1 0h1v1h-1V6zm0 1h1v1h-1V7zm0 1h1v1h-1V8zm-1 1h1v1h-1V9zm1 0h1v1h-1V9zm-1 1h1v1h-1v-1zM1 11h1v1H1v-1zm1 1h1v1H2v-1zm2-1h1v1H4v-1zm0 1h1v1H4v-1zm1-1h1v1H5v-1zm1 1h1v1H6v-1zm1-1h1v1H7v-1zm1 1h1v1H8v-1zm0-1h1v1H8v-1zm1 0h1v1H9v-1zm1 0h1v1h-1v-1zm1 1h1v1h-1v-1zm2 0h1v1h-1v-1zm1-1h1v1h-1v-1zm1 0h1v1h-1v-1zm1 0h1v1h-1v-1zm-1 2h1v1h-1v-1zm-2 9h1v1h-1v-1zm-1 0h1v1h-1v-1zm0-9h1v1h-1v-1zm-1 0h1v1h-1v-1zm0 1h1v1h-1v-1zm0 1h1v1h-1v-1zm11-1h1v1h-1v-1zm-1 1h1v1h-1v-1zm1 2h1v1h-1v-1zm-5-4h1v1h-1v-1zm1-1h1v1h-1v-1zm4 0h1v1h-1v-1zm0 1h1v1h-1v-1zm-1 0h1v1h-1v-1zm1 8h1v1h-1v-1zm-1 1h1v1h-1v-1zm-2 0h1v1h-1v-1zm3 0h1v1h-1v-1z"
    }), /*#__PURE__*/ $0bf7530499f5206c$var$_react["default"].createElement("path", {
        stroke: "#000",
        strokeWidth: "2",
        d: "M15 2h7v7h-7V2zM2 2h7v7H2V2zm0 13h7v7H2v-7zM18 5h1v1h-1V5zM5 5h1v1H5V5zm0 13h1v1H5v-1z"
    })));
});
$0bf7530499f5206c$var$Qr.displayName = 'Qr';


Object.keys($0bf7530499f5206c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0bf7530499f5206c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0bf7530499f5206c$exports[key];
});
var $30f007eab4dd43ee$exports = {};

$parcel$export($30f007eab4dd43ee$exports, "__esModule", function () { return $30f007eab4dd43ee$export$1e511d4a378977f5; }, function (v) { return $30f007eab4dd43ee$export$1e511d4a378977f5 = v; });
$parcel$export($30f007eab4dd43ee$exports, "RadialSelected", function () { return $30f007eab4dd43ee$export$97c84da2dd9adc92; }, function (v) { return $30f007eab4dd43ee$export$97c84da2dd9adc92 = v; });
var $30f007eab4dd43ee$export$1e511d4a378977f5;
var $30f007eab4dd43ee$export$97c84da2dd9adc92;
"use strict";
$30f007eab4dd43ee$export$1e511d4a378977f5 = true;
$30f007eab4dd43ee$export$97c84da2dd9adc92 = void 0;

var $30f007eab4dd43ee$var$_react = $30f007eab4dd43ee$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $30f007eab4dd43ee$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($30f007eab4dd43ee$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $30f007eab4dd43ee$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $30f007eab4dd43ee$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $30f007eab4dd43ee$var$_extends() {
    return $30f007eab4dd43ee$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $30f007eab4dd43ee$var$_extends.apply(null, arguments);
}
var $30f007eab4dd43ee$var$RadialSelected = $30f007eab4dd43ee$export$97c84da2dd9adc92 = /*#__PURE__*/ (0, $30f007eab4dd43ee$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $30f007eab4dd43ee$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $30f007eab4dd43ee$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "RadialSelected"
    }, props), /*#__PURE__*/ $30f007eab4dd43ee$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm0-10a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 2a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 2a5 5 0 1 0 0-10 5 5 0 0 0 0 10z"
    }));
});
$30f007eab4dd43ee$var$RadialSelected.displayName = 'RadialSelected';


Object.keys($30f007eab4dd43ee$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $30f007eab4dd43ee$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $30f007eab4dd43ee$exports[key];
});
var $7af49b5078bd984c$exports = {};

$parcel$export($7af49b5078bd984c$exports, "__esModule", function () { return $7af49b5078bd984c$export$1e511d4a378977f5; }, function (v) { return $7af49b5078bd984c$export$1e511d4a378977f5 = v; });
$parcel$export($7af49b5078bd984c$exports, "Radial", function () { return $7af49b5078bd984c$export$c04a4665dc6c306a; }, function (v) { return $7af49b5078bd984c$export$c04a4665dc6c306a = v; });
var $7af49b5078bd984c$export$1e511d4a378977f5;
var $7af49b5078bd984c$export$c04a4665dc6c306a;
"use strict";
$7af49b5078bd984c$export$1e511d4a378977f5 = true;
$7af49b5078bd984c$export$c04a4665dc6c306a = void 0;

var $7af49b5078bd984c$var$_react = $7af49b5078bd984c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $7af49b5078bd984c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7af49b5078bd984c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7af49b5078bd984c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $7af49b5078bd984c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7af49b5078bd984c$var$_extends() {
    return $7af49b5078bd984c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7af49b5078bd984c$var$_extends.apply(null, arguments);
}
var $7af49b5078bd984c$var$Radial = $7af49b5078bd984c$export$c04a4665dc6c306a = /*#__PURE__*/ (0, $7af49b5078bd984c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $7af49b5078bd984c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $7af49b5078bd984c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Radial"
    }, props), /*#__PURE__*/ $7af49b5078bd984c$var$_react["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "11",
        fill: "none",
        stroke: "#000",
        strokeWidth: "2"
    }));
});
$7af49b5078bd984c$var$Radial.displayName = 'Radial';


Object.keys($7af49b5078bd984c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $7af49b5078bd984c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $7af49b5078bd984c$exports[key];
});
var $f6070b8a14f1984f$exports = {};

$parcel$export($f6070b8a14f1984f$exports, "__esModule", function () { return $f6070b8a14f1984f$export$1e511d4a378977f5; }, function (v) { return $f6070b8a14f1984f$export$1e511d4a378977f5 = v; });
$parcel$export($f6070b8a14f1984f$exports, "Raspberry", function () { return $f6070b8a14f1984f$export$ec1ff19127ba4ebc; }, function (v) { return $f6070b8a14f1984f$export$ec1ff19127ba4ebc = v; });
var $f6070b8a14f1984f$export$1e511d4a378977f5;
var $f6070b8a14f1984f$export$ec1ff19127ba4ebc;
"use strict";
$f6070b8a14f1984f$export$1e511d4a378977f5 = true;
$f6070b8a14f1984f$export$ec1ff19127ba4ebc = void 0;

var $f6070b8a14f1984f$var$_react = $f6070b8a14f1984f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f6070b8a14f1984f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f6070b8a14f1984f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f6070b8a14f1984f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f6070b8a14f1984f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f6070b8a14f1984f$var$_extends() {
    return $f6070b8a14f1984f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f6070b8a14f1984f$var$_extends.apply(null, arguments);
}
var $f6070b8a14f1984f$var$Raspberry = $f6070b8a14f1984f$export$ec1ff19127ba4ebc = /*#__PURE__*/ (0, $f6070b8a14f1984f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f6070b8a14f1984f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f6070b8a14f1984f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Raspberry"
    }, props), /*#__PURE__*/ $f6070b8a14f1984f$var$_react["default"].createElement("path", {
        fill: "#C7053D",
        fillRule: "evenodd",
        d: "M8.087 0a.667.667 0 0 0-.399.165c-.363-.14-.717-.19-1.032.096-.486-.063-.643.067-.762.22-.107-.003-.8-.11-1.117.364-.798-.095-1.049.47-.763.994-.163.253-.332.5.048.981-.134.268-.05.558.267.91-.084.376.081.641.376.848-.055.515.472.815.629.922.06.3.187.584.79.74.099.447.46.525.811.619-1.159.673-2.153 1.558-2.146 3.733l-.17.303c-1.328.808-2.524 3.406-.654 5.518.122.66.326 1.134.508 1.66.273 2.117 2.054 3.11 2.523 3.227.688.524 1.422 1.02 2.413 1.369.935.964 1.946 1.331 3.005 1.331s2.07-.367 3.005-1.331c.992-.348 1.725-.845 2.413-1.37.47-.117 2.25-1.11 2.523-3.226.182-.526.386-1 .508-1.66 1.87-2.112.674-4.71-.655-5.518l-.169-.303c.007-2.175-.987-3.06-2.146-3.733.35-.094.712-.172.812-.619.602-.156.729-.44.79-.74.157-.107.683-.407.628-.922.295-.207.46-.472.376-.848.318-.352.402-.642.267-.91.38-.48.212-.728.049-.98.285-.526.034-1.09-.763-.995-.318-.474-1.01-.367-1.117-.365-.12-.152-.277-.282-.763-.22-.315-.284-.669-.235-1.032-.095A.667.667 0 0 0 16.742 0c-.232-.007-.43.134-.643.202-.523-.17-.641.061-.898.156-.569-.12-.742.143-1.015.42l-.32-.007c-.858.506-1.282 1.535-1.452 1.535-.17 0-.594-1.029-1.453-1.535l-.319.006C10.37.501 10.196.238 9.627.358 9.37.263 9.252.031 8.73.202 8.516.134 8.318-.007 8.087 0zm.03.609c.436.161.663.37.9.575.08-.108.202-.188.052-.45.31.18.544.39.717.625.191-.122.112-.287.113-.441.322.262.528.54.778.812.05-.037.093-.162.132-.358.768.744 1.852 2.62.279 3.365C9.749 3.633 8.15 2.83 6.38 2.228c2.277 1.174 3.602 2.123 4.327 2.932-.371 1.49-2.31 1.56-3.019 1.518.145-.068.266-.15.31-.275-.179-.127-.81-.013-1.25-.26.17-.036.249-.069.328-.194-.416-.132-.864-.248-1.128-.468.143.002.275.033.46-.095-.372-.201-.77-.36-1.078-.668.193-.004.4-.002.46-.073a4.155 4.155 0 0 1-.867-.704c.27.033.382.006.448-.04-.258-.265-.583-.487-.739-.812.2.069.383.093.515-.008-.088-.198-.464-.314-.68-.776.211.02.436.046.48 0-.097-.398-.264-.622-.429-.854.451-.007 1.134.001 1.103-.037l-.279-.285c.44-.118.892.02 1.219.122.147-.115-.004-.263-.183-.413.374.05.713.136 1.019.255C7.56.945 7.289.799 7.159.65c.578.11.825.263 1.068.417.177-.169.01-.312-.11-.46zm8.594 0c-.12.147-.287.29-.11.46.244-.155.49-.308 1.068-.418-.13.148-.401.294-.238.442a4.431 4.431 0 0 1 1.02-.255c-.18.15-.33.298-.184.413.328-.102.779-.24 1.22-.122l-.28.285c-.03.038.652.03 1.103.037-.165.232-.331.456-.43.854.045.046.27.02.48 0-.215.462-.591.578-.679.776.132.101.315.077.515.008-.155.325-.48.547-.738.811.065.047.178.074.447.041a4.155 4.155 0 0 1-.866.704c.06.07.267.069.46.073-.31.307-.706.467-1.079.668.186.128.318.097.46.095-.264.22-.711.336-1.127.468.079.125.158.158.327.193-.44.248-1.071.134-1.249.26.043.125.164.208.31.276-.71.041-2.648-.029-3.02-1.518.726-.81 2.05-1.758 4.328-2.932-1.772.602-3.37 1.405-4.708 2.509-1.574-.744-.49-2.62.278-3.365.04.196.082.32.133.358.25-.272.455-.55.777-.812 0 .154-.078.32.114.441.172-.235.406-.446.716-.624-.15.26-.027.341.053.45.236-.207.463-.415.899-.576zM12.414 6.77c1.359 0 2.492.923 2.494 1.466.004.68-.994 1.38-2.476 1.398h-.036c-1.482-.018-2.48-.717-2.476-1.398.003-.543 1.136-1.466 2.494-1.466zm-3.813.447h.084c.22 0 .447.02.677.059.777.13-3.72 4.058-3.79 3.182-.062-2.003 1.278-3.213 3.03-3.241zm7.542 0h.084c1.751.028 3.091 1.238 3.03 3.24-.07.877-4.567-3.05-3.791-3.181.23-.04.457-.058.677-.06zm-6.825 2.5c.259-.002.521.036.777.122 1.363.458 2.052 2.053 1.54 3.56-.513 1.509-2.034 2.36-3.398 1.903-1.363-.458-2.052-2.053-1.54-3.56.417-1.226 1.498-2.017 2.62-2.025zm6.193 0c1.122.008 2.204.8 2.62 2.024.513 1.508-.176 3.103-1.54 3.56-1.364.459-2.885-.393-3.398-1.901-.512-1.508.177-3.103 1.54-3.56.256-.087.519-.125.778-.123zM5.33 11.4c1.062.015.273 5.052-.69 4.624-1.092-.879-1.444-3.451.582-4.608a.405.405 0 0 1 .082-.014l.026-.002zm14.168 0 .027.002a.404.404 0 0 1 .081.014c2.026 1.157 1.675 3.73.582 4.608-.963.428-1.752-4.609-.69-4.624zm-7.084 3.482a2.8 2.8 0 0 1 1.874.7c.52.47.822 1.14.818 1.811 0 .66-.295 1.313-.8 1.778a2.88 2.88 0 0 1-1.892.739 2.884 2.884 0 0 1-1.892-.739 2.448 2.448 0 0 1-.8-1.778 2.456 2.456 0 0 1 .818-1.81 2.796 2.796 0 0 1 1.874-.7zM6.148 16.2c.703-.014 1.568.541 2.268 1.353.78.94 1.136 2.593.485 3.08-.617.372-2.115.218-3.178-1.31-.718-1.282-.624-2.587-.12-2.97.164-.1.348-.149.545-.153zm12.465 0h.067c.197.004.38.052.546.153.503.383.597 1.688-.12 2.97-1.064 1.528-2.562 1.682-3.178 1.31-.652-.487-.297-2.14.484-3.08.678-.787 1.51-1.333 2.201-1.353zm-6.199 4.504c1.09-.012 2.71.447 2.69 1.032.017.405-1.312 1.574-2.667 1.516h-.045c-1.356.058-2.685-1.11-2.667-1.516-.02-.585 1.6-1.044 2.69-1.032z"
    }));
});
$f6070b8a14f1984f$var$Raspberry.displayName = 'Raspberry';


Object.keys($f6070b8a14f1984f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f6070b8a14f1984f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f6070b8a14f1984f$exports[key];
});
var $c3a54387bbdae9eb$exports = {};

$parcel$export($c3a54387bbdae9eb$exports, "__esModule", function () { return $c3a54387bbdae9eb$export$1e511d4a378977f5; }, function (v) { return $c3a54387bbdae9eb$export$1e511d4a378977f5 = v; });
$parcel$export($c3a54387bbdae9eb$exports, "Reactjs", function () { return $c3a54387bbdae9eb$export$7f896c63f9262762; }, function (v) { return $c3a54387bbdae9eb$export$7f896c63f9262762 = v; });
var $c3a54387bbdae9eb$export$1e511d4a378977f5;
var $c3a54387bbdae9eb$export$7f896c63f9262762;
"use strict";
$c3a54387bbdae9eb$export$1e511d4a378977f5 = true;
$c3a54387bbdae9eb$export$7f896c63f9262762 = void 0;

var $c3a54387bbdae9eb$var$_react = $c3a54387bbdae9eb$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c3a54387bbdae9eb$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c3a54387bbdae9eb$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c3a54387bbdae9eb$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c3a54387bbdae9eb$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c3a54387bbdae9eb$var$_extends() {
    return $c3a54387bbdae9eb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c3a54387bbdae9eb$var$_extends.apply(null, arguments);
}
var $c3a54387bbdae9eb$var$Reactjs = $c3a54387bbdae9eb$export$7f896c63f9262762 = /*#__PURE__*/ (0, $c3a54387bbdae9eb$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c3a54387bbdae9eb$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c3a54387bbdae9eb$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Reactjs"
    }, props), /*#__PURE__*/ $c3a54387bbdae9eb$var$_react["default"].createElement("g", {
        fill: "#00D8FF",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $c3a54387bbdae9eb$var$_react["default"].createElement("circle", {
        cx: "11.996",
        cy: "11.653",
        r: "2.142"
    }), /*#__PURE__*/ $c3a54387bbdae9eb$var$_react["default"].createElement("path", {
        fillRule: "nonzero",
        d: "M11.996 7.81c2.768 0 5.397.39 7.396 1.078 2.22.764 3.575 1.894 3.575 2.765 0 .927-1.463 2.131-3.838 2.918-1.89.626-4.42.968-7.133.968-2.85 0-5.409-.335-7.277-.974-1.17-.4-2.136-.92-2.799-1.486-.595-.51-.895-1.016-.895-1.426 0-.874 1.302-1.988 3.475-2.746 2-.697 4.693-1.098 7.496-1.098m0-1.025c-2.912 0-5.718.418-7.834 1.156C1.622 8.825 0 10.213 0 11.653c0 1.486 1.741 2.978 4.387 3.882 1.989.68 4.654 1.029 7.609 1.029 2.816 0 5.451-.356 7.456-1.02 2.75-.912 4.54-2.385 4.54-3.891 0-1.445-1.675-2.842-4.266-3.735-2.113-.727-4.854-1.134-7.73-1.134m-3.348 2.96c1.383-2.399 3.034-4.481 4.63-5.87 1.77-1.54 3.426-2.15 4.18-1.714.803.463 1.116 2.331.611 4.782-.402 1.95-1.37 4.312-2.725 6.663-1.424 2.469-2.992 4.518-4.48 5.817-.93.814-1.863 1.391-2.685 1.682-.738.26-1.327.268-1.682.063-.757-.436-1.072-2.121-.643-4.381.395-2.081 1.394-4.615 2.794-7.043m-.888-.512c-1.455 2.522-2.495 5.162-2.913 7.363-.501 2.643-.11 4.742 1.137 5.46 1.289.744 3.45-.02 5.555-1.86 1.583-1.383 3.217-3.518 4.693-6.077 1.406-2.44 2.415-4.9 2.84-6.969.585-2.837.203-5.124-1.102-5.876-1.252-.722-3.298.03-5.366 1.83C10.92 4.568 9.197 6.74 7.76 9.231m.891 4.378C7.264 11.215 6.285 8.744 5.879 6.67c-.451-2.305-.152-4.043.602-4.479.802-.465 2.577.198 4.448 1.859 1.49 1.322 3.052 3.34 4.411 5.689 1.429 2.467 2.42 4.848 2.804 6.785.24 1.213.274 2.31.115 3.167-.143.77-.43 1.284-.785 1.49-.756.437-2.373-.132-4.117-1.633-1.605-1.38-3.302-3.511-4.706-5.937m-.887.514c1.459 2.52 3.226 4.74 4.925 6.2 2.039 1.755 4.052 2.463 5.298 1.742 1.287-.745 1.705-2.999 1.162-5.742-.408-2.061-1.441-4.543-2.922-7.1-1.41-2.437-3.039-4.54-4.618-5.942C9.443 1.36 7.271.548 5.967 1.303c-1.25.724-1.62 2.873-1.094 5.563.429 2.193 1.45 4.769 2.891 7.258"
    })));
});
$c3a54387bbdae9eb$var$Reactjs.displayName = 'Reactjs';


Object.keys($c3a54387bbdae9eb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c3a54387bbdae9eb$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c3a54387bbdae9eb$exports[key];
});
var $75462433e264c262$exports = {};

$parcel$export($75462433e264c262$exports, "__esModule", function () { return $75462433e264c262$export$1e511d4a378977f5; }, function (v) { return $75462433e264c262$export$1e511d4a378977f5 = v; });
$parcel$export($75462433e264c262$exports, "Reddit", function () { return $75462433e264c262$export$f140366548526b7e; }, function (v) { return $75462433e264c262$export$f140366548526b7e = v; });
var $75462433e264c262$export$1e511d4a378977f5;
var $75462433e264c262$export$f140366548526b7e;
"use strict";
$75462433e264c262$export$1e511d4a378977f5 = true;
$75462433e264c262$export$f140366548526b7e = void 0;

var $75462433e264c262$var$_react = $75462433e264c262$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $75462433e264c262$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($75462433e264c262$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $75462433e264c262$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $75462433e264c262$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $75462433e264c262$var$_extends() {
    return $75462433e264c262$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $75462433e264c262$var$_extends.apply(null, arguments);
}
var $75462433e264c262$var$Reddit = $75462433e264c262$export$f140366548526b7e = /*#__PURE__*/ (0, $75462433e264c262$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $75462433e264c262$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $75462433e264c262$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Reddit"
    }, props), /*#__PURE__*/ $75462433e264c262$var$_react["default"].createElement("path", {
        fill: "#FF4500",
        fillRule: "evenodd",
        d: "M15.57 15.284c-.897 0-1.65-.728-1.65-1.625s.753-1.648 1.65-1.648c.897 0 1.625.752 1.625 1.649 0 .896-.728 1.624-1.625 1.624m.381 3.153c-.835.835-2.124 1.24-3.939 1.24h-.026c-1.815 0-3.102-.405-3.937-1.24a.655.655 0 1 1 .927-.927c.576.576 1.56.856 3.01.856l.013.001h.013c1.45 0 2.435-.281 3.012-.857a.655.655 0 1 1 .927.927m-9.146-4.778c0-.896.753-1.648 1.649-1.648.897 0 1.624.752 1.624 1.649 0 .896-.727 1.624-1.624 1.624-.896 0-1.649-.728-1.649-1.625M19.998 3.311c.607 0 1.102.494 1.102 1.101s-.495 1.102-1.102 1.102a1.103 1.103 0 0 1-1.102-1.102c0-.607.494-1.101 1.102-1.101M24 11.875a2.887 2.887 0 0 0-2.884-2.884c-.689 0-1.321.243-1.818.647-1.758-1.105-3.99-1.771-6.383-1.912l1.248-3.946 3.43.808a2.415 2.415 0 0 0 2.405 2.237 2.415 2.415 0 0 0 2.412-2.413A2.415 2.415 0 0 0 19.998 2c-.93 0-1.739.53-2.141 1.303l-3.986-.938a.655.655 0 0 0-.774.44l-1.55 4.897c-2.578.063-5.001.732-6.889 1.902a2.87 2.87 0 0 0-1.774-.613A2.887 2.887 0 0 0 0 11.875a2.88 2.88 0 0 0 1.249 2.373 5.063 5.063 0 0 0-.048.693c0 1.988 1.155 3.837 3.254 5.207 2.011 1.313 4.674 2.036 7.496 2.036s5.485-.723 7.497-2.036c2.098-1.37 3.254-3.22 3.254-5.207 0-.213-.015-.424-.04-.633A2.884 2.884 0 0 0 24 11.875"
    }));
});
$75462433e264c262$var$Reddit.displayName = 'Reddit';


Object.keys($75462433e264c262$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $75462433e264c262$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $75462433e264c262$exports[key];
});
var $090be39f27e2e13f$exports = {};

$parcel$export($090be39f27e2e13f$exports, "__esModule", function () { return $090be39f27e2e13f$export$1e511d4a378977f5; }, function (v) { return $090be39f27e2e13f$export$1e511d4a378977f5 = v; });
$parcel$export($090be39f27e2e13f$exports, "Redhat", function () { return $090be39f27e2e13f$export$8d3b774c825085ce; }, function (v) { return $090be39f27e2e13f$export$8d3b774c825085ce = v; });
var $090be39f27e2e13f$export$1e511d4a378977f5;
var $090be39f27e2e13f$export$8d3b774c825085ce;
"use strict";
$090be39f27e2e13f$export$1e511d4a378977f5 = true;
$090be39f27e2e13f$export$8d3b774c825085ce = void 0;

var $090be39f27e2e13f$var$_react = $090be39f27e2e13f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $090be39f27e2e13f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($090be39f27e2e13f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $090be39f27e2e13f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $090be39f27e2e13f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $090be39f27e2e13f$var$_extends() {
    return $090be39f27e2e13f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $090be39f27e2e13f$var$_extends.apply(null, arguments);
}
var $090be39f27e2e13f$var$Redhat = $090be39f27e2e13f$export$8d3b774c825085ce = /*#__PURE__*/ (0, $090be39f27e2e13f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $090be39f27e2e13f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $090be39f27e2e13f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Redhat"
    }, props), /*#__PURE__*/ $090be39f27e2e13f$var$_react["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $090be39f27e2e13f$var$_react["default"].createElement("path", {
        fill: "#E00",
        d: "M5.832 6.125c.645-2.404 1.531-3.365 2.66-2.885 1.691.722 2.416.481 3.141 0 .484-.32 1.209-.32 2.175 0l3.384 1.443c.967.32 1.611 1.442 1.934 3.366.322 1.923.564 3.205.725 3.846 2.417.962 3.786 2.405 4.109 4.328.483 2.885-3.384 5.77-11.36 4.327C4.624 19.108-.452 14.54.032 11.895c.322-1.763 1.853-2.644 4.592-2.644l1.208-3.126z"
    }), /*#__PURE__*/ $090be39f27e2e13f$var$_react["default"].createElement("path", {
        fill: "#000",
        d: "M4.887 8.538c1.462 2.507 4.142 4.074 8.04 4.7 3.897.627 6.171 0 6.82-1.88.278 1.417.278 2.357 0 2.82-.914 1.527-3.411 1.969-6.09 1.646-3.897-.47-6.74-1.724-8.526-3.76-.487-.627-.731-1.175-.731-1.646 0-.47.162-1.096.487-1.88z"
    })));
});
$090be39f27e2e13f$var$Redhat.displayName = 'Redhat';


Object.keys($090be39f27e2e13f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $090be39f27e2e13f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $090be39f27e2e13f$exports[key];
});
var $21d1d66a100289ac$exports = {};

$parcel$export($21d1d66a100289ac$exports, "__esModule", function () { return $21d1d66a100289ac$export$1e511d4a378977f5; }, function (v) { return $21d1d66a100289ac$export$1e511d4a378977f5 = v; });
$parcel$export($21d1d66a100289ac$exports, "Redo", function () { return $21d1d66a100289ac$export$c51819d211d1dad; }, function (v) { return $21d1d66a100289ac$export$c51819d211d1dad = v; });
var $21d1d66a100289ac$export$1e511d4a378977f5;
var $21d1d66a100289ac$export$c51819d211d1dad;
"use strict";
$21d1d66a100289ac$export$1e511d4a378977f5 = true;
$21d1d66a100289ac$export$c51819d211d1dad = void 0;

var $21d1d66a100289ac$var$_react = $21d1d66a100289ac$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $21d1d66a100289ac$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($21d1d66a100289ac$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $21d1d66a100289ac$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $21d1d66a100289ac$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $21d1d66a100289ac$var$_extends() {
    return $21d1d66a100289ac$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $21d1d66a100289ac$var$_extends.apply(null, arguments);
}
var $21d1d66a100289ac$var$Redo = $21d1d66a100289ac$export$c51819d211d1dad = /*#__PURE__*/ (0, $21d1d66a100289ac$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $21d1d66a100289ac$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $21d1d66a100289ac$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Redo"
    }, props), /*#__PURE__*/ $21d1d66a100289ac$var$_react["default"].createElement("path", {
        d: "M16.82 4 15.4 5.44 17.94 8H8.23a6 6 0 0 0 0 12h2v-2h-2a4 4 0 0 1 0-8h9.71l-2.54 2.51 1.41 1.41L21.77 9z"
    }));
});
$21d1d66a100289ac$var$Redo.displayName = 'Redo';


Object.keys($21d1d66a100289ac$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $21d1d66a100289ac$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $21d1d66a100289ac$exports[key];
});
var $d7e8023ebcc9643f$exports = {};

$parcel$export($d7e8023ebcc9643f$exports, "__esModule", function () { return $d7e8023ebcc9643f$export$1e511d4a378977f5; }, function (v) { return $d7e8023ebcc9643f$export$1e511d4a378977f5 = v; });
$parcel$export($d7e8023ebcc9643f$exports, "Refresh", function () { return $d7e8023ebcc9643f$export$f93ec6528f706bfe; }, function (v) { return $d7e8023ebcc9643f$export$f93ec6528f706bfe = v; });
var $d7e8023ebcc9643f$export$1e511d4a378977f5;
var $d7e8023ebcc9643f$export$f93ec6528f706bfe;
"use strict";
$d7e8023ebcc9643f$export$1e511d4a378977f5 = true;
$d7e8023ebcc9643f$export$f93ec6528f706bfe = void 0;

var $d7e8023ebcc9643f$var$_react = $d7e8023ebcc9643f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $d7e8023ebcc9643f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d7e8023ebcc9643f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d7e8023ebcc9643f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d7e8023ebcc9643f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d7e8023ebcc9643f$var$_extends() {
    return $d7e8023ebcc9643f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d7e8023ebcc9643f$var$_extends.apply(null, arguments);
}
var $d7e8023ebcc9643f$var$Refresh = $d7e8023ebcc9643f$export$f93ec6528f706bfe = /*#__PURE__*/ (0, $d7e8023ebcc9643f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d7e8023ebcc9643f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $d7e8023ebcc9643f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Refresh"
    }, props), /*#__PURE__*/ $d7e8023ebcc9643f$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M20 8c-1.403-2.96-4.463-5-8-5a9 9 0 1 0 0 18 9 9 0 0 0 9-9m0-9v6h-6"
    }));
});
$d7e8023ebcc9643f$var$Refresh.displayName = 'Refresh';


Object.keys($d7e8023ebcc9643f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $d7e8023ebcc9643f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $d7e8023ebcc9643f$exports[key];
});
var $6f6b6b9169c56f2e$exports = {};

$parcel$export($6f6b6b9169c56f2e$exports, "__esModule", function () { return $6f6b6b9169c56f2e$export$1e511d4a378977f5; }, function (v) { return $6f6b6b9169c56f2e$export$1e511d4a378977f5 = v; });
$parcel$export($6f6b6b9169c56f2e$exports, "Resources", function () { return $6f6b6b9169c56f2e$export$e9a269813a6315a4; }, function (v) { return $6f6b6b9169c56f2e$export$e9a269813a6315a4 = v; });
var $6f6b6b9169c56f2e$export$1e511d4a378977f5;
var $6f6b6b9169c56f2e$export$e9a269813a6315a4;
"use strict";
$6f6b6b9169c56f2e$export$1e511d4a378977f5 = true;
$6f6b6b9169c56f2e$export$e9a269813a6315a4 = void 0;

var $6f6b6b9169c56f2e$var$_react = $6f6b6b9169c56f2e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $6f6b6b9169c56f2e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6f6b6b9169c56f2e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6f6b6b9169c56f2e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6f6b6b9169c56f2e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6f6b6b9169c56f2e$var$_extends() {
    return $6f6b6b9169c56f2e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6f6b6b9169c56f2e$var$_extends.apply(null, arguments);
}
var $6f6b6b9169c56f2e$var$Resources = $6f6b6b9169c56f2e$export$e9a269813a6315a4 = /*#__PURE__*/ (0, $6f6b6b9169c56f2e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $6f6b6b9169c56f2e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $6f6b6b9169c56f2e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Resources"
    }, props), /*#__PURE__*/ $6f6b6b9169c56f2e$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m12 3 9 4.5-9 4.5-9-4.5L12 3zm4.5 7.25L21 12.5 12 17l-9-4.5 4.5-2.25m9 5L21 17.5 12 22l-9-4.5 4.5-2.25"
    }));
});
$6f6b6b9169c56f2e$var$Resources.displayName = 'Resources';


Object.keys($6f6b6b9169c56f2e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $6f6b6b9169c56f2e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $6f6b6b9169c56f2e$exports[key];
});
var $314cf1c12e898fd9$exports = {};

$parcel$export($314cf1c12e898fd9$exports, "__esModule", function () { return $314cf1c12e898fd9$export$1e511d4a378977f5; }, function (v) { return $314cf1c12e898fd9$export$1e511d4a378977f5 = v; });
$parcel$export($314cf1c12e898fd9$exports, "Restaurant", function () { return $314cf1c12e898fd9$export$ef057c0c7e2aeb5b; }, function (v) { return $314cf1c12e898fd9$export$ef057c0c7e2aeb5b = v; });
var $314cf1c12e898fd9$export$1e511d4a378977f5;
var $314cf1c12e898fd9$export$ef057c0c7e2aeb5b;
"use strict";
$314cf1c12e898fd9$export$1e511d4a378977f5 = true;
$314cf1c12e898fd9$export$ef057c0c7e2aeb5b = void 0;

var $314cf1c12e898fd9$var$_react = $314cf1c12e898fd9$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $314cf1c12e898fd9$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($314cf1c12e898fd9$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $314cf1c12e898fd9$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $314cf1c12e898fd9$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $314cf1c12e898fd9$var$_extends() {
    return $314cf1c12e898fd9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $314cf1c12e898fd9$var$_extends.apply(null, arguments);
}
var $314cf1c12e898fd9$var$Restaurant = $314cf1c12e898fd9$export$ef057c0c7e2aeb5b = /*#__PURE__*/ (0, $314cf1c12e898fd9$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $314cf1c12e898fd9$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $314cf1c12e898fd9$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Restaurant"
    }, props), /*#__PURE__*/ $314cf1c12e898fd9$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M19 18H5h14zm-7 0v-6 6zm3 0v-4 4zm-6 0v-4 4zm10 4V11.33a3.001 3.001 0 1 0-2.08-5.63C16.55 3.874 14.46 2 12 2S7.45 3.874 7.08 5.7A3 3 0 1 0 5 11.33V22h14z"
    }));
});
$314cf1c12e898fd9$var$Restaurant.displayName = 'Restaurant';


Object.keys($314cf1c12e898fd9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $314cf1c12e898fd9$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $314cf1c12e898fd9$exports[key];
});
var $57ed25a7ba88c704$exports = {};

$parcel$export($57ed25a7ba88c704$exports, "__esModule", function () { return $57ed25a7ba88c704$export$1e511d4a378977f5; }, function (v) { return $57ed25a7ba88c704$export$1e511d4a378977f5 = v; });
$parcel$export($57ed25a7ba88c704$exports, "RestroomMen", function () { return $57ed25a7ba88c704$export$d2aff0747ea0f1a2; }, function (v) { return $57ed25a7ba88c704$export$d2aff0747ea0f1a2 = v; });
var $57ed25a7ba88c704$export$1e511d4a378977f5;
var $57ed25a7ba88c704$export$d2aff0747ea0f1a2;
"use strict";
$57ed25a7ba88c704$export$1e511d4a378977f5 = true;
$57ed25a7ba88c704$export$d2aff0747ea0f1a2 = void 0;

var $57ed25a7ba88c704$var$_react = $57ed25a7ba88c704$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $57ed25a7ba88c704$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($57ed25a7ba88c704$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $57ed25a7ba88c704$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $57ed25a7ba88c704$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $57ed25a7ba88c704$var$_extends() {
    return $57ed25a7ba88c704$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $57ed25a7ba88c704$var$_extends.apply(null, arguments);
}
var $57ed25a7ba88c704$var$RestroomMen = $57ed25a7ba88c704$export$d2aff0747ea0f1a2 = /*#__PURE__*/ (0, $57ed25a7ba88c704$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $57ed25a7ba88c704$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $57ed25a7ba88c704$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "RestroomMen"
    }, props), /*#__PURE__*/ $57ed25a7ba88c704$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M7 13.5 11 8l-1 13m7-7.5L13 8l1 13M12 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-1 3h2v5.5h-2V8z"
    }));
});
$57ed25a7ba88c704$var$RestroomMen.displayName = 'RestroomMen';


Object.keys($57ed25a7ba88c704$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $57ed25a7ba88c704$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $57ed25a7ba88c704$exports[key];
});
var $6e258074c08b2925$exports = {};

$parcel$export($6e258074c08b2925$exports, "__esModule", function () { return $6e258074c08b2925$export$1e511d4a378977f5; }, function (v) { return $6e258074c08b2925$export$1e511d4a378977f5 = v; });
$parcel$export($6e258074c08b2925$exports, "RestroomWomen", function () { return $6e258074c08b2925$export$905bbb7f0ff3fc61; }, function (v) { return $6e258074c08b2925$export$905bbb7f0ff3fc61 = v; });
var $6e258074c08b2925$export$1e511d4a378977f5;
var $6e258074c08b2925$export$905bbb7f0ff3fc61;
"use strict";
$6e258074c08b2925$export$1e511d4a378977f5 = true;
$6e258074c08b2925$export$905bbb7f0ff3fc61 = void 0;

var $6e258074c08b2925$var$_react = $6e258074c08b2925$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $6e258074c08b2925$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6e258074c08b2925$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6e258074c08b2925$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6e258074c08b2925$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6e258074c08b2925$var$_extends() {
    return $6e258074c08b2925$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6e258074c08b2925$var$_extends.apply(null, arguments);
}
var $6e258074c08b2925$var$RestroomWomen = $6e258074c08b2925$export$905bbb7f0ff3fc61 = /*#__PURE__*/ (0, $6e258074c08b2925$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $6e258074c08b2925$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $6e258074c08b2925$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "RestroomWomen"
    }, props), /*#__PURE__*/ $6e258074c08b2925$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M7 13.5 11 8l1 13m5-7.5L13 8l-1 13m0-16a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-1 3h2l1.5 8.5h-5L11 8z"
    }));
});
$6e258074c08b2925$var$RestroomWomen.displayName = 'RestroomWomen';


Object.keys($6e258074c08b2925$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $6e258074c08b2925$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $6e258074c08b2925$exports[key];
});
var $eac4edbe56ae2655$exports = {};

$parcel$export($eac4edbe56ae2655$exports, "__esModule", function () { return $eac4edbe56ae2655$export$1e511d4a378977f5; }, function (v) { return $eac4edbe56ae2655$export$1e511d4a378977f5 = v; });
$parcel$export($eac4edbe56ae2655$exports, "Restroom", function () { return $eac4edbe56ae2655$export$d9e8a9fda66eab87; }, function (v) { return $eac4edbe56ae2655$export$d9e8a9fda66eab87 = v; });
var $eac4edbe56ae2655$export$1e511d4a378977f5;
var $eac4edbe56ae2655$export$d9e8a9fda66eab87;
"use strict";
$eac4edbe56ae2655$export$1e511d4a378977f5 = true;
$eac4edbe56ae2655$export$d9e8a9fda66eab87 = void 0;

var $eac4edbe56ae2655$var$_react = $eac4edbe56ae2655$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $eac4edbe56ae2655$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($eac4edbe56ae2655$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $eac4edbe56ae2655$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $eac4edbe56ae2655$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $eac4edbe56ae2655$var$_extends() {
    return $eac4edbe56ae2655$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $eac4edbe56ae2655$var$_extends.apply(null, arguments);
}
var $eac4edbe56ae2655$var$Restroom = $eac4edbe56ae2655$export$d9e8a9fda66eab87 = /*#__PURE__*/ (0, $eac4edbe56ae2655$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $eac4edbe56ae2655$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $eac4edbe56ae2655$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Restroom"
    }, props), /*#__PURE__*/ $eac4edbe56ae2655$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: "2",
        d: "M6 11h12M6 3h12m-6 13a5 5 0 0 0 5-5H7a5 5 0 0 0 5 5zM7 3h10v8H7V3zm0 3h2.5m5 9.5 1.5 6H8l1.5-6"
    }));
});
$eac4edbe56ae2655$var$Restroom.displayName = 'Restroom';


Object.keys($eac4edbe56ae2655$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $eac4edbe56ae2655$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $eac4edbe56ae2655$exports[key];
});
var $5683cfac3cbe49db$exports = {};

$parcel$export($5683cfac3cbe49db$exports, "__esModule", function () { return $5683cfac3cbe49db$export$1e511d4a378977f5; }, function (v) { return $5683cfac3cbe49db$export$1e511d4a378977f5 = v; });
$parcel$export($5683cfac3cbe49db$exports, "Resume", function () { return $5683cfac3cbe49db$export$1cb6264f9ac3fff4; }, function (v) { return $5683cfac3cbe49db$export$1cb6264f9ac3fff4 = v; });
var $5683cfac3cbe49db$export$1e511d4a378977f5;
var $5683cfac3cbe49db$export$1cb6264f9ac3fff4;
"use strict";
$5683cfac3cbe49db$export$1e511d4a378977f5 = true;
$5683cfac3cbe49db$export$1cb6264f9ac3fff4 = void 0;

var $5683cfac3cbe49db$var$_react = $5683cfac3cbe49db$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5683cfac3cbe49db$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5683cfac3cbe49db$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5683cfac3cbe49db$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5683cfac3cbe49db$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5683cfac3cbe49db$var$_extends() {
    return $5683cfac3cbe49db$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5683cfac3cbe49db$var$_extends.apply(null, arguments);
}
var $5683cfac3cbe49db$var$Resume = $5683cfac3cbe49db$export$1cb6264f9ac3fff4 = /*#__PURE__*/ (0, $5683cfac3cbe49db$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5683cfac3cbe49db$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5683cfac3cbe49db$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Resume"
    }, props), /*#__PURE__*/ $5683cfac3cbe49db$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 20h5V4H1v16zm10-1 11-7-11-7v14z"
    }));
});
$5683cfac3cbe49db$var$Resume.displayName = 'Resume';


Object.keys($5683cfac3cbe49db$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5683cfac3cbe49db$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5683cfac3cbe49db$exports[key];
});
var $57f48ef04081a38a$exports = {};

$parcel$export($57f48ef04081a38a$exports, "__esModule", function () { return $57f48ef04081a38a$export$1e511d4a378977f5; }, function (v) { return $57f48ef04081a38a$export$1e511d4a378977f5 = v; });
$parcel$export($57f48ef04081a38a$exports, "Return", function () { return $57f48ef04081a38a$export$e87088760199ee7a; }, function (v) { return $57f48ef04081a38a$export$e87088760199ee7a = v; });
var $57f48ef04081a38a$export$1e511d4a378977f5;
var $57f48ef04081a38a$export$e87088760199ee7a;
"use strict";
$57f48ef04081a38a$export$1e511d4a378977f5 = true;
$57f48ef04081a38a$export$e87088760199ee7a = void 0;

var $57f48ef04081a38a$var$_react = $57f48ef04081a38a$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $57f48ef04081a38a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($57f48ef04081a38a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $57f48ef04081a38a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $57f48ef04081a38a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $57f48ef04081a38a$var$_extends() {
    return $57f48ef04081a38a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $57f48ef04081a38a$var$_extends.apply(null, arguments);
}
var $57f48ef04081a38a$var$Return = $57f48ef04081a38a$export$e87088760199ee7a = /*#__PURE__*/ (0, $57f48ef04081a38a$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $57f48ef04081a38a$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $57f48ef04081a38a$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Return"
    }, props), /*#__PURE__*/ $57f48ef04081a38a$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m9 19-5-5 5-5m9-5v10H5"
    }));
});
$57f48ef04081a38a$var$Return.displayName = 'Return';


Object.keys($57f48ef04081a38a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $57f48ef04081a38a$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $57f48ef04081a38a$exports[key];
});
var $ffd363128351a9bb$exports = {};

$parcel$export($ffd363128351a9bb$exports, "__esModule", function () { return $ffd363128351a9bb$export$1e511d4a378977f5; }, function (v) { return $ffd363128351a9bb$export$1e511d4a378977f5 = v; });
$parcel$export($ffd363128351a9bb$exports, "Revert", function () { return $ffd363128351a9bb$export$a987ae91e0799a3c; }, function (v) { return $ffd363128351a9bb$export$a987ae91e0799a3c = v; });
var $ffd363128351a9bb$export$1e511d4a378977f5;
var $ffd363128351a9bb$export$a987ae91e0799a3c;
"use strict";
$ffd363128351a9bb$export$1e511d4a378977f5 = true;
$ffd363128351a9bb$export$a987ae91e0799a3c = void 0;

var $ffd363128351a9bb$var$_react = $ffd363128351a9bb$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $ffd363128351a9bb$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ffd363128351a9bb$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ffd363128351a9bb$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ffd363128351a9bb$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ffd363128351a9bb$var$_extends() {
    return $ffd363128351a9bb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ffd363128351a9bb$var$_extends.apply(null, arguments);
}
var $ffd363128351a9bb$var$Revert = $ffd363128351a9bb$export$a987ae91e0799a3c = /*#__PURE__*/ (0, $ffd363128351a9bb$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $ffd363128351a9bb$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ffd363128351a9bb$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Revert"
    }, props), /*#__PURE__*/ $ffd363128351a9bb$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8 3 3 8l5 5m4 7h3a6 6 0 1 0 0-12H4"
    }));
});
$ffd363128351a9bb$var$Revert.displayName = 'Revert';


Object.keys($ffd363128351a9bb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ffd363128351a9bb$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ffd363128351a9bb$exports[key];
});
var $0adc9200117d9935$exports = {};

$parcel$export($0adc9200117d9935$exports, "__esModule", function () { return $0adc9200117d9935$export$1e511d4a378977f5; }, function (v) { return $0adc9200117d9935$export$1e511d4a378977f5 = v; });
$parcel$export($0adc9200117d9935$exports, "Rewind", function () { return $0adc9200117d9935$export$a0283110eba26e0d; }, function (v) { return $0adc9200117d9935$export$a0283110eba26e0d = v; });
var $0adc9200117d9935$export$1e511d4a378977f5;
var $0adc9200117d9935$export$a0283110eba26e0d;
"use strict";
$0adc9200117d9935$export$1e511d4a378977f5 = true;
$0adc9200117d9935$export$a0283110eba26e0d = void 0;

var $0adc9200117d9935$var$_react = $0adc9200117d9935$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0adc9200117d9935$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0adc9200117d9935$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0adc9200117d9935$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0adc9200117d9935$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0adc9200117d9935$var$_extends() {
    return $0adc9200117d9935$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0adc9200117d9935$var$_extends.apply(null, arguments);
}
var $0adc9200117d9935$var$Rewind = $0adc9200117d9935$export$a0283110eba26e0d = /*#__PURE__*/ (0, $0adc9200117d9935$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0adc9200117d9935$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0adc9200117d9935$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Rewind"
    }, props), /*#__PURE__*/ $0adc9200117d9935$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M22 3.5V20l-9-6v6L2 12l11-8v6z"
    }));
});
$0adc9200117d9935$var$Rewind.displayName = 'Rewind';


Object.keys($0adc9200117d9935$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0adc9200117d9935$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0adc9200117d9935$exports[key];
});
var $644fb00a2a723ee0$exports = {};

$parcel$export($644fb00a2a723ee0$exports, "__esModule", function () { return $644fb00a2a723ee0$export$1e511d4a378977f5; }, function (v) { return $644fb00a2a723ee0$export$1e511d4a378977f5 = v; });
$parcel$export($644fb00a2a723ee0$exports, "Risk", function () { return $644fb00a2a723ee0$export$74fa1eb58be3f831; }, function (v) { return $644fb00a2a723ee0$export$74fa1eb58be3f831 = v; });
var $644fb00a2a723ee0$export$1e511d4a378977f5;
var $644fb00a2a723ee0$export$74fa1eb58be3f831;
"use strict";
$644fb00a2a723ee0$export$1e511d4a378977f5 = true;
$644fb00a2a723ee0$export$74fa1eb58be3f831 = void 0;

var $644fb00a2a723ee0$var$_react = $644fb00a2a723ee0$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $644fb00a2a723ee0$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($644fb00a2a723ee0$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $644fb00a2a723ee0$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $644fb00a2a723ee0$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $644fb00a2a723ee0$var$_extends() {
    return $644fb00a2a723ee0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $644fb00a2a723ee0$var$_extends.apply(null, arguments);
}
var $644fb00a2a723ee0$var$Risk = $644fb00a2a723ee0$export$74fa1eb58be3f831 = /*#__PURE__*/ (0, $644fb00a2a723ee0$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $644fb00a2a723ee0$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $644fb00a2a723ee0$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Risk"
    }, props), /*#__PURE__*/ $644fb00a2a723ee0$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M14 10h1V9h-1v1zm4 0h1V9h-1v1zm0-4h1V5h-1v1zm-4 0h1V5h-1v1zM9 19h1v-1H9v1zm-4-4h1v-1H5v1zm5-5H1v13h13v-9m-4 0h13V1H10v13z"
    }));
});
$644fb00a2a723ee0$var$Risk.displayName = 'Risk';


Object.keys($644fb00a2a723ee0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $644fb00a2a723ee0$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $644fb00a2a723ee0$exports[key];
});
var $d32b991d953c80a3$exports = {};

$parcel$export($d32b991d953c80a3$exports, "__esModule", function () { return $d32b991d953c80a3$export$1e511d4a378977f5; }, function (v) { return $d32b991d953c80a3$export$1e511d4a378977f5 = v; });
$parcel$export($d32b991d953c80a3$exports, "Robot", function () { return $d32b991d953c80a3$export$20db0c138a037d2a; }, function (v) { return $d32b991d953c80a3$export$20db0c138a037d2a = v; });
var $d32b991d953c80a3$export$1e511d4a378977f5;
var $d32b991d953c80a3$export$20db0c138a037d2a;
"use strict";
$d32b991d953c80a3$export$1e511d4a378977f5 = true;
$d32b991d953c80a3$export$20db0c138a037d2a = void 0;

var $d32b991d953c80a3$var$_react = $d32b991d953c80a3$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $d32b991d953c80a3$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d32b991d953c80a3$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d32b991d953c80a3$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d32b991d953c80a3$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d32b991d953c80a3$var$_extends() {
    return $d32b991d953c80a3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d32b991d953c80a3$var$_extends.apply(null, arguments);
}
var $d32b991d953c80a3$var$Robot = $d32b991d953c80a3$export$20db0c138a037d2a = /*#__PURE__*/ (0, $d32b991d953c80a3$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d32b991d953c80a3$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $d32b991d953c80a3$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Robot"
    }, props), /*#__PURE__*/ $d32b991d953c80a3$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M18.348 15.954a7 7 0 1 0-12.622.156M12 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0-17V3M9 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm6 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 4.988L5 16s.072-.772.5-.5c.93.591 3.074 1.5 6.5 1.5 3.554 0 5.618-.916 6.5-1.5.359-.238.5.5.5.5l-1 2.988S17.005 21 12 21s-6-2.012-6-2.012z"
    }));
});
$d32b991d953c80a3$var$Robot.displayName = 'Robot';


Object.keys($d32b991d953c80a3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $d32b991d953c80a3$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $d32b991d953c80a3$exports[key];
});
var $d548a66372fc4e01$exports = {};

$parcel$export($d548a66372fc4e01$exports, "__esModule", function () { return $d548a66372fc4e01$export$1e511d4a378977f5; }, function (v) { return $d548a66372fc4e01$export$1e511d4a378977f5 = v; });
$parcel$export($d548a66372fc4e01$exports, "RotateLeft", function () { return $d548a66372fc4e01$export$b204c8549f010cd; }, function (v) { return $d548a66372fc4e01$export$b204c8549f010cd = v; });
var $d548a66372fc4e01$export$1e511d4a378977f5;
var $d548a66372fc4e01$export$b204c8549f010cd;
"use strict";
$d548a66372fc4e01$export$1e511d4a378977f5 = true;
$d548a66372fc4e01$export$b204c8549f010cd = void 0;

var $d548a66372fc4e01$var$_react = $d548a66372fc4e01$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $d548a66372fc4e01$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d548a66372fc4e01$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d548a66372fc4e01$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d548a66372fc4e01$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d548a66372fc4e01$var$_extends() {
    return $d548a66372fc4e01$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d548a66372fc4e01$var$_extends.apply(null, arguments);
}
var $d548a66372fc4e01$var$RotateLeft = $d548a66372fc4e01$export$b204c8549f010cd = /*#__PURE__*/ (0, $d548a66372fc4e01$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d548a66372fc4e01$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $d548a66372fc4e01$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "RotateLeft"
    }, props), /*#__PURE__*/ $d548a66372fc4e01$var$_react["default"].createElement("path", {
        d: "M11.52 3.43A9.09 9.09 0 0 0 5.7 5.55v-3.2H4.07v6.5h6.5V7.21H6.3a7.46 7.46 0 1 1-1.47 8.65l-1.46.73a9.11 9.11 0 1 0 8.15-13.16z"
    }));
});
$d548a66372fc4e01$var$RotateLeft.displayName = 'RotateLeft';


Object.keys($d548a66372fc4e01$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $d548a66372fc4e01$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $d548a66372fc4e01$exports[key];
});
var $8ed42b638483d250$exports = {};

$parcel$export($8ed42b638483d250$exports, "__esModule", function () { return $8ed42b638483d250$export$1e511d4a378977f5; }, function (v) { return $8ed42b638483d250$export$1e511d4a378977f5 = v; });
$parcel$export($8ed42b638483d250$exports, "RotateRight", function () { return $8ed42b638483d250$export$75099d76a78789f; }, function (v) { return $8ed42b638483d250$export$75099d76a78789f = v; });
var $8ed42b638483d250$export$1e511d4a378977f5;
var $8ed42b638483d250$export$75099d76a78789f;
"use strict";
$8ed42b638483d250$export$1e511d4a378977f5 = true;
$8ed42b638483d250$export$75099d76a78789f = void 0;

var $8ed42b638483d250$var$_react = $8ed42b638483d250$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $8ed42b638483d250$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8ed42b638483d250$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8ed42b638483d250$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $8ed42b638483d250$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8ed42b638483d250$var$_extends() {
    return $8ed42b638483d250$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8ed42b638483d250$var$_extends.apply(null, arguments);
}
var $8ed42b638483d250$var$RotateRight = $8ed42b638483d250$export$75099d76a78789f = /*#__PURE__*/ (0, $8ed42b638483d250$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $8ed42b638483d250$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $8ed42b638483d250$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "RotateRight"
    }, props), /*#__PURE__*/ $8ed42b638483d250$var$_react["default"].createElement("path", {
        d: "M12.48 3.43a9.09 9.09 0 0 1 5.82 2.12v-3.2h1.64v6.5h-6.5V7.21h4.26a7.46 7.46 0 1 0 1.47 8.65l1.46.73a9.11 9.11 0 1 1-8.15-13.16z"
    }));
});
$8ed42b638483d250$var$RotateRight.displayName = 'RotateRight';


Object.keys($8ed42b638483d250$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $8ed42b638483d250$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $8ed42b638483d250$exports[key];
});
var $f7a3792486fca092$exports = {};

$parcel$export($f7a3792486fca092$exports, "__esModule", function () { return $f7a3792486fca092$export$1e511d4a378977f5; }, function (v) { return $f7a3792486fca092$export$1e511d4a378977f5 = v; });
$parcel$export($f7a3792486fca092$exports, "Rss", function () { return $f7a3792486fca092$export$931c8cb50984cb09; }, function (v) { return $f7a3792486fca092$export$931c8cb50984cb09 = v; });
var $f7a3792486fca092$export$1e511d4a378977f5;
var $f7a3792486fca092$export$931c8cb50984cb09;
"use strict";
$f7a3792486fca092$export$1e511d4a378977f5 = true;
$f7a3792486fca092$export$931c8cb50984cb09 = void 0;

var $f7a3792486fca092$var$_react = $f7a3792486fca092$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f7a3792486fca092$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f7a3792486fca092$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f7a3792486fca092$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f7a3792486fca092$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f7a3792486fca092$var$_extends() {
    return $f7a3792486fca092$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f7a3792486fca092$var$_extends.apply(null, arguments);
}
var $f7a3792486fca092$var$Rss = $f7a3792486fca092$export$931c8cb50984cb09 = /*#__PURE__*/ (0, $f7a3792486fca092$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f7a3792486fca092$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f7a3792486fca092$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Rss"
    }, props), /*#__PURE__*/ $f7a3792486fca092$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M22 21C22 10.507 13.493 2 3 2m14 19c0-7.732-6.268-14-14-14m9 14a9 9 0 0 0-9-9m1 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
    }));
});
$f7a3792486fca092$var$Rss.displayName = 'Rss';


Object.keys($f7a3792486fca092$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f7a3792486fca092$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f7a3792486fca092$exports[key];
});
var $c073adb0435855dc$exports = {};

$parcel$export($c073adb0435855dc$exports, "__esModule", function () { return $c073adb0435855dc$export$1e511d4a378977f5; }, function (v) { return $c073adb0435855dc$export$1e511d4a378977f5 = v; });
$parcel$export($c073adb0435855dc$exports, "Run", function () { return $c073adb0435855dc$export$ddae37e51c7979e2; }, function (v) { return $c073adb0435855dc$export$ddae37e51c7979e2 = v; });
var $c073adb0435855dc$export$1e511d4a378977f5;
var $c073adb0435855dc$export$ddae37e51c7979e2;
"use strict";
$c073adb0435855dc$export$1e511d4a378977f5 = true;
$c073adb0435855dc$export$ddae37e51c7979e2 = void 0;

var $c073adb0435855dc$var$_react = $c073adb0435855dc$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c073adb0435855dc$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c073adb0435855dc$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c073adb0435855dc$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c073adb0435855dc$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c073adb0435855dc$var$_extends() {
    return $c073adb0435855dc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c073adb0435855dc$var$_extends.apply(null, arguments);
}
var $c073adb0435855dc$var$Run = $c073adb0435855dc$export$ddae37e51c7979e2 = /*#__PURE__*/ (0, $c073adb0435855dc$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c073adb0435855dc$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c073adb0435855dc$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Run"
    }, props), /*#__PURE__*/ $c073adb0435855dc$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m15 11 3 2m0-8a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM9.5 9.5 9.525 6H15L8 17H4m11-9-3 5 .5 1L17 7.5 15 6m-4 7 5 3.5v5"
    }));
});
$c073adb0435855dc$var$Run.displayName = 'Run';


Object.keys($c073adb0435855dc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c073adb0435855dc$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c073adb0435855dc$exports[key];
});
var $e0dcef55a93cc35d$exports = {};

$parcel$export($e0dcef55a93cc35d$exports, "__esModule", function () { return $e0dcef55a93cc35d$export$1e511d4a378977f5; }, function (v) { return $e0dcef55a93cc35d$export$1e511d4a378977f5 = v; });
$parcel$export($e0dcef55a93cc35d$exports, "SafariOption", function () { return $e0dcef55a93cc35d$export$93b0c5154cf77e41; }, function (v) { return $e0dcef55a93cc35d$export$93b0c5154cf77e41 = v; });
var $e0dcef55a93cc35d$export$1e511d4a378977f5;
var $e0dcef55a93cc35d$export$93b0c5154cf77e41;
"use strict";
$e0dcef55a93cc35d$export$1e511d4a378977f5 = true;
$e0dcef55a93cc35d$export$93b0c5154cf77e41 = void 0;

var $e0dcef55a93cc35d$var$_react = $e0dcef55a93cc35d$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e0dcef55a93cc35d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e0dcef55a93cc35d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e0dcef55a93cc35d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e0dcef55a93cc35d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e0dcef55a93cc35d$var$_extends() {
    return $e0dcef55a93cc35d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e0dcef55a93cc35d$var$_extends.apply(null, arguments);
}
var $e0dcef55a93cc35d$var$SafariOption = $e0dcef55a93cc35d$export$93b0c5154cf77e41 = /*#__PURE__*/ (0, $e0dcef55a93cc35d$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e0dcef55a93cc35d$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e0dcef55a93cc35d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "SafariOption"
    }, props), /*#__PURE__*/ $e0dcef55a93cc35d$var$_react["default"].createElement("path", {
        fill: "#87C5F8",
        fillRule: "evenodd",
        d: "M12.541 11.844c.022-.414-.33-.772-.775-.79-.47-.02-.827.325-.835.802-.007.423.337.758.79.772.45.014.795-.317.82-.784m4.673-6.722-.053-.04c-.053.044-.109.087-.16.135-1.914 1.787-3.831 3.571-5.741 5.364a3.48 3.48 0 0 0-.588.696c-1.401 2.307-2.789 4.623-4.179 6.936-.057.094-.102.194-.153.292a.242.242 0 0 0 .172-.069c1.94-1.812 3.883-3.62 5.814-5.443a4.03 4.03 0 0 0 .65-.824c1.371-2.256 2.73-4.521 4.092-6.783.052-.086.098-.176.146-.264m-.07-1.094c1.999 1.394 3.251 3.257 3.89 5.607-.233.057-.45.093-.652.167-.087.032-.145.144-.216.219.094.041.193.124.283.117.206-.02.408-.083.655-.138.45 2.407.068 4.629-1.183 6.729-.195-.118-.357-.242-.537-.317-.12-.05-.266-.033-.4-.045.065.109.11.242.202.323.148.129.327.224.533.36-1.375 2.01-3.215 3.324-5.6 3.961-.07-.266-.121-.526-.212-.773-.033-.09-.157-.147-.241-.22-.026.1-.087.206-.074.3.035.242.103.48.17.774-2.431.453-4.689.095-6.835-1.19.164-.256.33-.483.458-.73.053-.101.025-.244.034-.368-.113.06-.259.095-.332.187-.167.208-.298.446-.47.713-2.039-1.396-3.342-3.275-3.983-5.68.31-.072.574-.12.826-.203.085-.028.14-.146.21-.224-.1-.033-.204-.104-.299-.092-.253.033-.502.1-.797.164-.448-2.44-.062-4.696 1.251-6.829.19.12.354.25.54.334.144.066.314.074.473.108-.096-.14-.172-.3-.294-.412-.145-.131-.33-.219-.525-.343 1.425-1.992 3.285-3.301 5.708-3.895.056.241.087.471.165.683.045.119.165.208.251.31.03-.12.092-.245.08-.362-.022-.22-.087-.434-.145-.698 2.415-.423 4.647-.028 6.751 1.255-.15.242-.302.46-.42.695-.042.082.003.208.008.313.09-.04.208-.056.262-.123.16-.201.293-.422.465-.677M11.845 22.42c5.876-.014 10.586-4.76 10.577-10.659-.008-5.772-4.783-10.507-10.589-10.499C5.936 1.27 1.25 6.01 1.264 11.95c.015 5.752 4.797 10.484 10.581 10.47M11.836 0c6.506-.007 11.845 5.307 11.85 11.794A11.86 11.86 0 0 1 11.86 23.683C5.328 23.715 0 18.378 0 11.8 0 5.303 5.312.007 11.836.001"
    }));
});
$e0dcef55a93cc35d$var$SafariOption.displayName = 'SafariOption';


Object.keys($e0dcef55a93cc35d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e0dcef55a93cc35d$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e0dcef55a93cc35d$exports[key];
});
var $f0af0f91dbf69d7c$exports = {};

$parcel$export($f0af0f91dbf69d7c$exports, "__esModule", function () { return $f0af0f91dbf69d7c$export$1e511d4a378977f5; }, function (v) { return $f0af0f91dbf69d7c$export$1e511d4a378977f5 = v; });
$parcel$export($f0af0f91dbf69d7c$exports, "SamsungPay", function () { return $f0af0f91dbf69d7c$export$20aff6a3ed704870; }, function (v) { return $f0af0f91dbf69d7c$export$20aff6a3ed704870 = v; });
var $f0af0f91dbf69d7c$export$1e511d4a378977f5;
var $f0af0f91dbf69d7c$export$20aff6a3ed704870;
"use strict";
$f0af0f91dbf69d7c$export$1e511d4a378977f5 = true;
$f0af0f91dbf69d7c$export$20aff6a3ed704870 = void 0;

var $f0af0f91dbf69d7c$var$_react = $f0af0f91dbf69d7c$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $f0af0f91dbf69d7c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f0af0f91dbf69d7c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f0af0f91dbf69d7c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f0af0f91dbf69d7c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f0af0f91dbf69d7c$var$_extends() {
    return $f0af0f91dbf69d7c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f0af0f91dbf69d7c$var$_extends.apply(null, arguments);
}
var $f0af0f91dbf69d7c$var$SamsungPay = $f0af0f91dbf69d7c$export$20aff6a3ed704870 = /*#__PURE__*/ (0, $f0af0f91dbf69d7c$var$_react.forwardRef)(function(props, ref) {
    var prefix = (0, $1b754218be0a6592$export$3794798abb123ff6)('SamsungPay');
    return /*#__PURE__*/ $f0af0f91dbf69d7c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f0af0f91dbf69d7c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "SamsungPay"
    }, props), /*#__PURE__*/ $f0af0f91dbf69d7c$var$_react["default"].createElement("g", {
        clipPath: "url(#" + prefix + "-a)"
    }, /*#__PURE__*/ $f0af0f91dbf69d7c$var$_react["default"].createElement("path", {
        fill: "#1E4BC6",
        fillRule: "evenodd",
        d: "M21.33 2.688c1.395 1.48 2.192 3.502 2.477 5.723.284 2.135.17 3.587.17 3.587s.086 1.452-.199 3.587c-.284 2.22-1.082 4.243-2.477 5.723-1.48 1.395-3.502 2.192-5.722 2.477-2.136.256-3.588.2-3.588.2s-1.451.084-3.587-.2c-2.22-.285-4.242-1.082-5.722-2.477-1.395-1.48-2.193-3.502-2.477-5.723-.257-2.135-.2-3.587-.2-3.587s-.057-1.452.228-3.587C.518 6.19 1.315 4.169 2.71 2.688 4.19 1.293 6.212.496 8.433.211 10.568-.045 12.02.012 12.02.012s1.452-.085 3.587.2c2.22.284 4.242 1.081 5.723 2.476ZM6.582 8.496H4.447v6.292h1.167v-1.793h.968c.342 0 .655-.058.911-.172.256-.113.513-.284.712-.483a2.1 2.1 0 0 0 .484-.712c.114-.285.17-.57.17-.883a2.32 2.32 0 0 0-.17-.882 2.103 2.103 0 0 0-.484-.712 2.1 2.1 0 0 0-.712-.484 2.36 2.36 0 0 0-.91-.17Zm-.996 3.388V9.55h.91c.172 0 .342.028.485.085a1.1 1.1 0 0 1 .37.256c.085.114.17.228.228.37.057.143.085.285.085.456 0 .17-.028.313-.085.456a1.082 1.082 0 0 1-.598.626 1.329 1.329 0 0 1-.484.085h-.911Zm5.067 2.733c.314.114.598.171.912.171.341 0 .626-.057.91-.171.285-.142.542-.313.712-.541v.712h1.168V9.72h-1.168v.655c-.199-.2-.427-.37-.711-.484a2.261 2.261 0 0 0-.912-.17c-.341 0-.626.056-.939.17-.285.114-.57.256-.797.484a2.707 2.707 0 0 0-.57.797c-.142.313-.199.684-.199 1.082 0 .399.086.769.228 1.082.142.313.342.57.57.797.227.2.512.37.796.484Zm1.709-.996c-.171.085-.37.114-.598.114a1.87 1.87 0 0 1-.598-.114l-.004-.002c-.17-.085-.339-.17-.48-.311a2.801 2.801 0 0 1-.313-.484 1.273 1.273 0 0 1-.114-.57c0-.199.028-.398.114-.569.057-.17.17-.313.313-.456a1.42 1.42 0 0 1 .484-.313c.2-.085.399-.114.598-.114.2 0 .398.029.598.143.199.085.341.17.484.313.142.114.227.285.313.456.085.17.114.37.114.569 0 .199-.029.398-.114.57a1.63 1.63 0 0 1-.313.455c-.143.142-.313.228-.484.313Zm5.039-.427-1.424-3.445h-1.224l2.05 4.812-1.053 2.533h1.195l2.99-7.345H18.71l-1.31 3.445Z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ $f0af0f91dbf69d7c$var$_react["default"].createElement("defs", null, /*#__PURE__*/ $f0af0f91dbf69d7c$var$_react["default"].createElement("clipPath", {
        id: prefix + "-a"
    }, /*#__PURE__*/ $f0af0f91dbf69d7c$var$_react["default"].createElement("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
    }))));
});
$f0af0f91dbf69d7c$var$SamsungPay.displayName = 'SamsungPay';


Object.keys($f0af0f91dbf69d7c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f0af0f91dbf69d7c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f0af0f91dbf69d7c$exports[key];
});
var $d3554a57b6779190$exports = {};

$parcel$export($d3554a57b6779190$exports, "__esModule", function () { return $d3554a57b6779190$export$1e511d4a378977f5; }, function (v) { return $d3554a57b6779190$export$1e511d4a378977f5 = v; });
$parcel$export($d3554a57b6779190$exports, "Sans", function () { return $d3554a57b6779190$export$b133839ee4db1f65; }, function (v) { return $d3554a57b6779190$export$b133839ee4db1f65 = v; });
var $d3554a57b6779190$export$1e511d4a378977f5;
var $d3554a57b6779190$export$b133839ee4db1f65;
"use strict";
$d3554a57b6779190$export$1e511d4a378977f5 = true;
$d3554a57b6779190$export$b133839ee4db1f65 = void 0;

var $d3554a57b6779190$var$_react = $d3554a57b6779190$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $d3554a57b6779190$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d3554a57b6779190$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d3554a57b6779190$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d3554a57b6779190$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d3554a57b6779190$var$_extends() {
    return $d3554a57b6779190$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d3554a57b6779190$var$_extends.apply(null, arguments);
}
var $d3554a57b6779190$var$Sans = $d3554a57b6779190$export$b133839ee4db1f65 = /*#__PURE__*/ (0, $d3554a57b6779190$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d3554a57b6779190$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $d3554a57b6779190$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Sans"
    }, props), /*#__PURE__*/ $d3554a57b6779190$var$_react["default"].createElement("path", {
        stroke: "#000",
        strokeWidth: "2",
        fill: "none",
        d: "M1 12h22M2 22h20a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1zM5 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
    }));
});
$d3554a57b6779190$var$Sans.displayName = 'Sans';


Object.keys($d3554a57b6779190$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $d3554a57b6779190$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $d3554a57b6779190$exports[key];
});
var $b5b15f19f0a384ac$exports = {};

$parcel$export($b5b15f19f0a384ac$exports, "__esModule", function () { return $b5b15f19f0a384ac$export$1e511d4a378977f5; }, function (v) { return $b5b15f19f0a384ac$export$1e511d4a378977f5 = v; });
$parcel$export($b5b15f19f0a384ac$exports, "Satellite", function () { return $b5b15f19f0a384ac$export$66ff15a0c73eab24; }, function (v) { return $b5b15f19f0a384ac$export$66ff15a0c73eab24 = v; });
var $b5b15f19f0a384ac$export$1e511d4a378977f5;
var $b5b15f19f0a384ac$export$66ff15a0c73eab24;
"use strict";
$b5b15f19f0a384ac$export$1e511d4a378977f5 = true;
$b5b15f19f0a384ac$export$66ff15a0c73eab24 = void 0;

var $b5b15f19f0a384ac$var$_react = $b5b15f19f0a384ac$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $b5b15f19f0a384ac$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b5b15f19f0a384ac$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b5b15f19f0a384ac$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $b5b15f19f0a384ac$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b5b15f19f0a384ac$var$_extends() {
    return $b5b15f19f0a384ac$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b5b15f19f0a384ac$var$_extends.apply(null, arguments);
}
var $b5b15f19f0a384ac$var$Satellite = $b5b15f19f0a384ac$export$66ff15a0c73eab24 = /*#__PURE__*/ (0, $b5b15f19f0a384ac$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $b5b15f19f0a384ac$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $b5b15f19f0a384ac$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Satellite"
    }, props), /*#__PURE__*/ $b5b15f19f0a384ac$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M7 17C2.97 12.794 2.97 6.118 7 2l15 15c-4.118 4.03-10.794 4.03-15 0zm0 0c-3.295 0-6 2.95-6 6h12c0-1.139-.37-2.034-1-3m3-11 4-4-4 4zm5.5-8a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"
    }));
});
$b5b15f19f0a384ac$var$Satellite.displayName = 'Satellite';


Object.keys($b5b15f19f0a384ac$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $b5b15f19f0a384ac$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $b5b15f19f0a384ac$exports[key];
});
var $e1568a771d67478c$exports = {};

$parcel$export($e1568a771d67478c$exports, "__esModule", function () { return $e1568a771d67478c$export$1e511d4a378977f5; }, function (v) { return $e1568a771d67478c$export$1e511d4a378977f5 = v; });
$parcel$export($e1568a771d67478c$exports, "Save", function () { return $e1568a771d67478c$export$be11e187edb4cb0c; }, function (v) { return $e1568a771d67478c$export$be11e187edb4cb0c = v; });
var $e1568a771d67478c$export$1e511d4a378977f5;
var $e1568a771d67478c$export$be11e187edb4cb0c;
"use strict";
$e1568a771d67478c$export$1e511d4a378977f5 = true;
$e1568a771d67478c$export$be11e187edb4cb0c = void 0;

var $e1568a771d67478c$var$_react = $e1568a771d67478c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e1568a771d67478c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e1568a771d67478c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e1568a771d67478c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e1568a771d67478c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e1568a771d67478c$var$_extends() {
    return $e1568a771d67478c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e1568a771d67478c$var$_extends.apply(null, arguments);
}
var $e1568a771d67478c$var$Save = $e1568a771d67478c$export$be11e187edb4cb0c = /*#__PURE__*/ (0, $e1568a771d67478c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e1568a771d67478c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e1568a771d67478c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Save"
    }, props), /*#__PURE__*/ $e1568a771d67478c$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M3 2v19h18V3h-9v11m-4-3 4 4 4-4"
    }));
});
$e1568a771d67478c$var$Save.displayName = 'Save';


Object.keys($e1568a771d67478c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e1568a771d67478c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e1568a771d67478c$exports[key];
});
var $864a03792e53d5b8$exports = {};

$parcel$export($864a03792e53d5b8$exports, "__esModule", function () { return $864a03792e53d5b8$export$1e511d4a378977f5; }, function (v) { return $864a03792e53d5b8$export$1e511d4a378977f5 = v; });
$parcel$export($864a03792e53d5b8$exports, "Scan", function () { return $864a03792e53d5b8$export$f2b7c70641756fd4; }, function (v) { return $864a03792e53d5b8$export$f2b7c70641756fd4 = v; });
var $864a03792e53d5b8$export$1e511d4a378977f5;
var $864a03792e53d5b8$export$f2b7c70641756fd4;
"use strict";
$864a03792e53d5b8$export$1e511d4a378977f5 = true;
$864a03792e53d5b8$export$f2b7c70641756fd4 = void 0;

var $864a03792e53d5b8$var$_react = $864a03792e53d5b8$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $864a03792e53d5b8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($864a03792e53d5b8$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $864a03792e53d5b8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $864a03792e53d5b8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $864a03792e53d5b8$var$_extends() {
    return $864a03792e53d5b8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $864a03792e53d5b8$var$_extends.apply(null, arguments);
}
var $864a03792e53d5b8$var$Scan = $864a03792e53d5b8$export$f2b7c70641756fd4 = /*#__PURE__*/ (0, $864a03792e53d5b8$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $864a03792e53d5b8$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $864a03792e53d5b8$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Scan"
    }, props), /*#__PURE__*/ $864a03792e53d5b8$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M20 10V3H4v7m-3 2h22H1zm3 1v3-3zm16 3v-3 3zM7 21H4v-3m16 0v3h-3m-8 0h6-6z"
    }));
});
$864a03792e53d5b8$var$Scan.displayName = 'Scan';


Object.keys($864a03792e53d5b8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $864a03792e53d5b8$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $864a03792e53d5b8$exports[key];
});
var $80270b7e500555d2$exports = {};

$parcel$export($80270b7e500555d2$exports, "__esModule", function () { return $80270b7e500555d2$export$1e511d4a378977f5; }, function (v) { return $80270b7e500555d2$export$1e511d4a378977f5 = v; });
$parcel$export($80270b7e500555d2$exports, "ScheduleNew", function () { return $80270b7e500555d2$export$300554c2e7ee538; }, function (v) { return $80270b7e500555d2$export$300554c2e7ee538 = v; });
var $80270b7e500555d2$export$1e511d4a378977f5;
var $80270b7e500555d2$export$300554c2e7ee538;
"use strict";
$80270b7e500555d2$export$1e511d4a378977f5 = true;
$80270b7e500555d2$export$300554c2e7ee538 = void 0;

var $80270b7e500555d2$var$_react = $80270b7e500555d2$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $80270b7e500555d2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($80270b7e500555d2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $80270b7e500555d2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $80270b7e500555d2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $80270b7e500555d2$var$_extends() {
    return $80270b7e500555d2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $80270b7e500555d2$var$_extends.apply(null, arguments);
}
var $80270b7e500555d2$var$ScheduleNew = $80270b7e500555d2$export$300554c2e7ee538 = /*#__PURE__*/ (0, $80270b7e500555d2$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $80270b7e500555d2$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $80270b7e500555d2$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ScheduleNew"
    }, props), /*#__PURE__*/ $80270b7e500555d2$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M14 0v3M1 7h18M6 0v3m-2 8h2m2 0h8M4 15h2m2 0h6m-2 4H1V3h18v10m0 2v9m-4-7 8 5m0-5-8 5"
    }));
});
$80270b7e500555d2$var$ScheduleNew.displayName = 'ScheduleNew';


Object.keys($80270b7e500555d2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $80270b7e500555d2$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $80270b7e500555d2$exports[key];
});
var $0e0b1519ff09ad66$exports = {};

$parcel$export($0e0b1519ff09ad66$exports, "__esModule", function () { return $0e0b1519ff09ad66$export$1e511d4a378977f5; }, function (v) { return $0e0b1519ff09ad66$export$1e511d4a378977f5 = v; });
$parcel$export($0e0b1519ff09ad66$exports, "SchedulePlay", function () { return $0e0b1519ff09ad66$export$d728d26bf9b1ea41; }, function (v) { return $0e0b1519ff09ad66$export$d728d26bf9b1ea41 = v; });
var $0e0b1519ff09ad66$export$1e511d4a378977f5;
var $0e0b1519ff09ad66$export$d728d26bf9b1ea41;
"use strict";
$0e0b1519ff09ad66$export$1e511d4a378977f5 = true;
$0e0b1519ff09ad66$export$d728d26bf9b1ea41 = void 0;

var $0e0b1519ff09ad66$var$_react = $0e0b1519ff09ad66$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0e0b1519ff09ad66$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0e0b1519ff09ad66$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0e0b1519ff09ad66$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0e0b1519ff09ad66$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0e0b1519ff09ad66$var$_extends() {
    return $0e0b1519ff09ad66$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0e0b1519ff09ad66$var$_extends.apply(null, arguments);
}
var $0e0b1519ff09ad66$var$SchedulePlay = $0e0b1519ff09ad66$export$d728d26bf9b1ea41 = /*#__PURE__*/ (0, $0e0b1519ff09ad66$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0e0b1519ff09ad66$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0e0b1519ff09ad66$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "SchedulePlay"
    }, props), /*#__PURE__*/ $0e0b1519ff09ad66$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M14 0v3M1 7h18M6 0v3m-2 8h2m2 0h8M4 15h2m2 0h6m-1 4H1V3h18v10m-1 10a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm-.5-6 1.5 1-1.5 1v-2z"
    }));
});
$0e0b1519ff09ad66$var$SchedulePlay.displayName = 'SchedulePlay';


Object.keys($0e0b1519ff09ad66$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0e0b1519ff09ad66$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0e0b1519ff09ad66$exports[key];
});
var $5073abb3686aaf52$exports = {};

$parcel$export($5073abb3686aaf52$exports, "__esModule", function () { return $5073abb3686aaf52$export$1e511d4a378977f5; }, function (v) { return $5073abb3686aaf52$export$1e511d4a378977f5 = v; });
$parcel$export($5073abb3686aaf52$exports, "Schedule", function () { return $5073abb3686aaf52$export$a74e4df6c6355a42; }, function (v) { return $5073abb3686aaf52$export$a74e4df6c6355a42 = v; });
var $5073abb3686aaf52$export$1e511d4a378977f5;
var $5073abb3686aaf52$export$a74e4df6c6355a42;
"use strict";
$5073abb3686aaf52$export$1e511d4a378977f5 = true;
$5073abb3686aaf52$export$a74e4df6c6355a42 = void 0;

var $5073abb3686aaf52$var$_react = $5073abb3686aaf52$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5073abb3686aaf52$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5073abb3686aaf52$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5073abb3686aaf52$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5073abb3686aaf52$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5073abb3686aaf52$var$_extends() {
    return $5073abb3686aaf52$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5073abb3686aaf52$var$_extends.apply(null, arguments);
}
var $5073abb3686aaf52$var$Schedule = $5073abb3686aaf52$export$a74e4df6c6355a42 = /*#__PURE__*/ (0, $5073abb3686aaf52$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5073abb3686aaf52$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5073abb3686aaf52$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Schedule"
    }, props), /*#__PURE__*/ $5073abb3686aaf52$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 23h22V4H1v19zM18 4V0v4zM6 4V0v4zM1 8.5h22H1zM6 14c.556-1.333 1.39-2 2.5-2 1.3 0 2 1 2 2s-1 2-2 3l-2 2v.5h5.405m5.08 1L17 12h-.5c-.5 1.5-2 2-2.743 2"
    }));
});
$5073abb3686aaf52$var$Schedule.displayName = 'Schedule';


Object.keys($5073abb3686aaf52$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5073abb3686aaf52$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5073abb3686aaf52$exports[key];
});
var $7d9295b28183ee80$exports = {};

$parcel$export($7d9295b28183ee80$exports, "__esModule", function () { return $7d9295b28183ee80$export$1e511d4a378977f5; }, function (v) { return $7d9295b28183ee80$export$1e511d4a378977f5 = v; });
$parcel$export($7d9295b28183ee80$exports, "Schedules", function () { return $7d9295b28183ee80$export$4d8c8cd2c300d546; }, function (v) { return $7d9295b28183ee80$export$4d8c8cd2c300d546 = v; });
var $7d9295b28183ee80$export$1e511d4a378977f5;
var $7d9295b28183ee80$export$4d8c8cd2c300d546;
"use strict";
$7d9295b28183ee80$export$1e511d4a378977f5 = true;
$7d9295b28183ee80$export$4d8c8cd2c300d546 = void 0;

var $7d9295b28183ee80$var$_react = $7d9295b28183ee80$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $7d9295b28183ee80$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7d9295b28183ee80$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7d9295b28183ee80$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $7d9295b28183ee80$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7d9295b28183ee80$var$_extends() {
    return $7d9295b28183ee80$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7d9295b28183ee80$var$_extends.apply(null, arguments);
}
var $7d9295b28183ee80$var$Schedules = $7d9295b28183ee80$export$4d8c8cd2c300d546 = /*#__PURE__*/ (0, $7d9295b28183ee80$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $7d9295b28183ee80$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $7d9295b28183ee80$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Schedules"
    }, props), /*#__PURE__*/ $7d9295b28183ee80$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M17 7h6v16H7v-4m16-8h-6M13 0v3M1 7h16M1 3h16v16H1V3zm4-3v3m-1 8h2m2 0h6M4 15h2m2 0h6"
    }));
});
$7d9295b28183ee80$var$Schedules.displayName = 'Schedules';


Object.keys($7d9295b28183ee80$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $7d9295b28183ee80$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $7d9295b28183ee80$exports[key];
});
var $92985afcc045df32$exports = {};

$parcel$export($92985afcc045df32$exports, "__esModule", function () { return $92985afcc045df32$export$1e511d4a378977f5; }, function (v) { return $92985afcc045df32$export$1e511d4a378977f5 = v; });
$parcel$export($92985afcc045df32$exports, "Sco", function () { return $92985afcc045df32$export$c9794325ec23f4fe; }, function (v) { return $92985afcc045df32$export$c9794325ec23f4fe = v; });
var $92985afcc045df32$export$1e511d4a378977f5;
var $92985afcc045df32$export$c9794325ec23f4fe;
"use strict";
$92985afcc045df32$export$1e511d4a378977f5 = true;
$92985afcc045df32$export$c9794325ec23f4fe = void 0;

var $92985afcc045df32$var$_react = $92985afcc045df32$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $92985afcc045df32$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($92985afcc045df32$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $92985afcc045df32$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $92985afcc045df32$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $92985afcc045df32$var$_extends() {
    return $92985afcc045df32$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $92985afcc045df32$var$_extends.apply(null, arguments);
}
var $92985afcc045df32$var$Sco = $92985afcc045df32$export$c9794325ec23f4fe = /*#__PURE__*/ (0, $92985afcc045df32$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $92985afcc045df32$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $92985afcc045df32$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Sco"
    }, props), /*#__PURE__*/ $92985afcc045df32$var$_react["default"].createElement("path", {
        fill: "#3158A0",
        fillRule: "evenodd",
        d: "M16.16 16.105H24c-.247.746-.99 1.367-1.794 1.367H1.273c-.804 0-1.33-.62-1.268-1.367h14.702a3.784 3.784 0 0 1-.2-1.957h.959c0 .187 0 .343.03.497.31-.093.62-.28.897-.497h.619c-.526.56-1.02 1.025-1.268 1.212.114.277.261.528.416.745zm5.583-8.39C20.692 7.28 19.362 7 17.847 7c-1.546 0-3.03.28-4.206.715l.032.062h8.009l.06-.062zm-6.617 4.941c.031-.062.062-.124.093-.218l-10.792.032-.03-.125c2.659-.528 5.967-.839 9.523-.839.557 0 1.144 0 1.67.031.03-.124.062-.217.093-.342H7.026l-.031-.093c2.319-.497 5.225-.808 8.348-.808h.34c-.03-.062-.061-.186-.092-.28H9.715l-.03-.093a29.155 29.155 0 0 1 5.38-.684 1.616 1.616 0 0 0-.34-.31h-2.876l-.062-.094c1.484-.466 3.278-.745 5.226-.745 1.887 0 3.556.31 4.885.745l-.03.063-6.555.03c.092.063.185.156.278.28.37-.031.741-.031 1.113-.031 2.35 0 4.514.28 6.245.653l-.03.186h-6.896c.031.094.031.218.062.311 2.505.032 4.793.31 6.71.683l-.031.187h-6.617c0 .125 0 .249-.031.342 2.412.124 4.638.373 6.494.745l-.031.156h-4.144a.554.554 0 0 1-.155.218h-.494c.03-.062.093-.125.124-.218h-1.948c-.031.093-.031.156-.063.218h-.773zm-.62 1.492c.032-.156.063-.31.125-.467H6.839l-.062-.124c2.32-.466 5.195-.777 8.287-.777 0-.031.031-.093.062-.124h.773c0 .031-.031.093-.031.124.587.031 1.206.031 1.762.093a.958.958 0 0 0 .154-.217h.495c-.03.093-.093.155-.186.249a33.22 33.22 0 0 1 4.36.559l-.03.217h-4.98c-.154.156-.278.31-.432.467h-.618c.217-.125.402-.31.557-.467h-1.423a2.767 2.767 0 0 0-.062.467h-.958z"
    }));
});
$92985afcc045df32$var$Sco.displayName = 'Sco';


Object.keys($92985afcc045df32$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $92985afcc045df32$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $92985afcc045df32$exports[key];
});
var $ba2fe2f08e5c6509$exports = {};

$parcel$export($ba2fe2f08e5c6509$exports, "__esModule", function () { return $ba2fe2f08e5c6509$export$1e511d4a378977f5; }, function (v) { return $ba2fe2f08e5c6509$export$1e511d4a378977f5 = v; });
$parcel$export($ba2fe2f08e5c6509$exports, "Scorecard", function () { return $ba2fe2f08e5c6509$export$8600647e879baa18; }, function (v) { return $ba2fe2f08e5c6509$export$8600647e879baa18 = v; });
var $ba2fe2f08e5c6509$export$1e511d4a378977f5;
var $ba2fe2f08e5c6509$export$8600647e879baa18;
"use strict";
$ba2fe2f08e5c6509$export$1e511d4a378977f5 = true;
$ba2fe2f08e5c6509$export$8600647e879baa18 = void 0;

var $ba2fe2f08e5c6509$var$_react = $ba2fe2f08e5c6509$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $ba2fe2f08e5c6509$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ba2fe2f08e5c6509$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ba2fe2f08e5c6509$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ba2fe2f08e5c6509$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ba2fe2f08e5c6509$var$_extends() {
    return $ba2fe2f08e5c6509$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ba2fe2f08e5c6509$var$_extends.apply(null, arguments);
}
var $ba2fe2f08e5c6509$var$Scorecard = $ba2fe2f08e5c6509$export$8600647e879baa18 = /*#__PURE__*/ (0, $ba2fe2f08e5c6509$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $ba2fe2f08e5c6509$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ba2fe2f08e5c6509$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Scorecard"
    }, props), /*#__PURE__*/ $ba2fe2f08e5c6509$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M9 18v-6m3 6v-5m3 5v-8m2-7h4v20H3V3h4m0-2h10v4H7V1z"
    }));
});
$ba2fe2f08e5c6509$var$Scorecard.displayName = 'Scorecard';


Object.keys($ba2fe2f08e5c6509$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ba2fe2f08e5c6509$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ba2fe2f08e5c6509$exports[key];
});
var $2552e5f26658b16e$exports = {};

$parcel$export($2552e5f26658b16e$exports, "__esModule", function () { return $2552e5f26658b16e$export$1e511d4a378977f5; }, function (v) { return $2552e5f26658b16e$export$1e511d4a378977f5 = v; });
$parcel$export($2552e5f26658b16e$exports, "Script", function () { return $2552e5f26658b16e$export$2f8b47a141e57afc; }, function (v) { return $2552e5f26658b16e$export$2f8b47a141e57afc = v; });
var $2552e5f26658b16e$export$1e511d4a378977f5;
var $2552e5f26658b16e$export$2f8b47a141e57afc;
"use strict";
$2552e5f26658b16e$export$1e511d4a378977f5 = true;
$2552e5f26658b16e$export$2f8b47a141e57afc = void 0;

var $2552e5f26658b16e$var$_react = $2552e5f26658b16e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $2552e5f26658b16e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2552e5f26658b16e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2552e5f26658b16e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $2552e5f26658b16e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $2552e5f26658b16e$var$_extends() {
    return $2552e5f26658b16e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2552e5f26658b16e$var$_extends.apply(null, arguments);
}
var $2552e5f26658b16e$var$Script = $2552e5f26658b16e$export$2f8b47a141e57afc = /*#__PURE__*/ (0, $2552e5f26658b16e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $2552e5f26658b16e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $2552e5f26658b16e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Script"
    }, props), /*#__PURE__*/ $2552e5f26658b16e$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 1a4 4 0 0 0-4 4v1h5.847L4.01 18.859l-.01.07V19a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-1h-5.847L19.99 5.141l.01-.07V5a4 4 0 0 0-4-4H4zm0 2a2 2 0 0 0-1.732 1h3.464A2 2 0 0 0 4 3zm3.465 0H16a2 2 0 0 1 1.999 1.936L16.133 18H10v1a2 2 0 0 1-3.999.064L7.99 5.141l.01-.07V5c0-.729-.195-1.412-.535-2zM20 21h-8.535a3.97 3.97 0 0 0 .409-1h9.858A2 2 0 0 1 20 21z",
        fill: "#000"
    }));
});
$2552e5f26658b16e$var$Script.displayName = 'Script';


Object.keys($2552e5f26658b16e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $2552e5f26658b16e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $2552e5f26658b16e$exports[key];
});
var $05d158c2316804f3$exports = {};

$parcel$export($05d158c2316804f3$exports, "__esModule", function () { return $05d158c2316804f3$export$1e511d4a378977f5; }, function (v) { return $05d158c2316804f3$export$1e511d4a378977f5 = v; });
$parcel$export($05d158c2316804f3$exports, "Sd", function () { return $05d158c2316804f3$export$44d86a37f141d255; }, function (v) { return $05d158c2316804f3$export$44d86a37f141d255 = v; });
var $05d158c2316804f3$export$1e511d4a378977f5;
var $05d158c2316804f3$export$44d86a37f141d255;
"use strict";
$05d158c2316804f3$export$1e511d4a378977f5 = true;
$05d158c2316804f3$export$44d86a37f141d255 = void 0;

var $05d158c2316804f3$var$_react = $05d158c2316804f3$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $05d158c2316804f3$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($05d158c2316804f3$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $05d158c2316804f3$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $05d158c2316804f3$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $05d158c2316804f3$var$_extends() {
    return $05d158c2316804f3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $05d158c2316804f3$var$_extends.apply(null, arguments);
}
var $05d158c2316804f3$var$Sd = $05d158c2316804f3$export$44d86a37f141d255 = /*#__PURE__*/ (0, $05d158c2316804f3$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $05d158c2316804f3$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $05d158c2316804f3$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Sd"
    }, props), /*#__PURE__*/ $05d158c2316804f3$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 2a2 2 0 0 1 2-2h13a1 1 0 0 1 .707.293l4 4A1 1 0 0 1 22 5v17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm14.586 0H4v20h16V5.414L16.586 2zM5 7V3h2v4H5zm3-4v4h2V3H8zm3 4V3h2v4h-2zm3-2v2h2V5h-2z",
        fill: "#000"
    }));
});
$05d158c2316804f3$var$Sd.displayName = 'Sd';


Object.keys($05d158c2316804f3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $05d158c2316804f3$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $05d158c2316804f3$exports[key];
});
var $ba05b51906a84c5f$exports = {};

$parcel$export($ba05b51906a84c5f$exports, "__esModule", function () { return $ba05b51906a84c5f$export$1e511d4a378977f5; }, function (v) { return $ba05b51906a84c5f$export$1e511d4a378977f5 = v; });
$parcel$export($ba05b51906a84c5f$exports, "SearchAdvanced", function () { return $ba05b51906a84c5f$export$7aeb42941576d607; }, function (v) { return $ba05b51906a84c5f$export$7aeb42941576d607 = v; });
var $ba05b51906a84c5f$export$1e511d4a378977f5;
var $ba05b51906a84c5f$export$7aeb42941576d607;
"use strict";
$ba05b51906a84c5f$export$1e511d4a378977f5 = true;
$ba05b51906a84c5f$export$7aeb42941576d607 = void 0;

var $ba05b51906a84c5f$var$_react = $ba05b51906a84c5f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $ba05b51906a84c5f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ba05b51906a84c5f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ba05b51906a84c5f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ba05b51906a84c5f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ba05b51906a84c5f$var$_extends() {
    return $ba05b51906a84c5f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ba05b51906a84c5f$var$_extends.apply(null, arguments);
}
var $ba05b51906a84c5f$var$SearchAdvanced = $ba05b51906a84c5f$export$7aeb42941576d607 = /*#__PURE__*/ (0, $ba05b51906a84c5f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $ba05b51906a84c5f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ba05b51906a84c5f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "SearchAdvanced"
    }, props), /*#__PURE__*/ $ba05b51906a84c5f$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m15 16 6 6-6-6zm-5 2a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM20 1v6m-3-3h6"
    }));
});
$ba05b51906a84c5f$var$SearchAdvanced.displayName = 'SearchAdvanced';


Object.keys($ba05b51906a84c5f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ba05b51906a84c5f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ba05b51906a84c5f$exports[key];
});

Object.keys($ac084058cd06093e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ac084058cd06093e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ac084058cd06093e$exports[key];
});
var $1169ad8ec3b4557c$exports = {};

$parcel$export($1169ad8ec3b4557c$exports, "__esModule", function () { return $1169ad8ec3b4557c$export$1e511d4a378977f5; }, function (v) { return $1169ad8ec3b4557c$export$1e511d4a378977f5 = v; });
$parcel$export($1169ad8ec3b4557c$exports, "Secure", function () { return $1169ad8ec3b4557c$export$e1b0282644a4fdba; }, function (v) { return $1169ad8ec3b4557c$export$e1b0282644a4fdba = v; });
var $1169ad8ec3b4557c$export$1e511d4a378977f5;
var $1169ad8ec3b4557c$export$e1b0282644a4fdba;
"use strict";
$1169ad8ec3b4557c$export$1e511d4a378977f5 = true;
$1169ad8ec3b4557c$export$e1b0282644a4fdba = void 0;

var $1169ad8ec3b4557c$var$_react = $1169ad8ec3b4557c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $1169ad8ec3b4557c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1169ad8ec3b4557c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1169ad8ec3b4557c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $1169ad8ec3b4557c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1169ad8ec3b4557c$var$_extends() {
    return $1169ad8ec3b4557c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1169ad8ec3b4557c$var$_extends.apply(null, arguments);
}
var $1169ad8ec3b4557c$var$Secure = $1169ad8ec3b4557c$export$e1b0282644a4fdba = /*#__PURE__*/ (0, $1169ad8ec3b4557c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $1169ad8ec3b4557c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $1169ad8ec3b4557c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Secure"
    }, props), /*#__PURE__*/ $1169ad8ec3b4557c$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M7 11V6c0-3 2-5 5-5s5 2 5 5v5m-5 12a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm0-8v4m0-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
    }));
});
$1169ad8ec3b4557c$var$Secure.displayName = 'Secure';


Object.keys($1169ad8ec3b4557c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $1169ad8ec3b4557c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $1169ad8ec3b4557c$exports[key];
});
var $61c18f792160ea83$exports = {};

$parcel$export($61c18f792160ea83$exports, "__esModule", function () { return $61c18f792160ea83$export$1e511d4a378977f5; }, function (v) { return $61c18f792160ea83$export$1e511d4a378977f5 = v; });
$parcel$export($61c18f792160ea83$exports, "Select", function () { return $61c18f792160ea83$export$ef9b1a59e592288f; }, function (v) { return $61c18f792160ea83$export$ef9b1a59e592288f = v; });
var $61c18f792160ea83$export$1e511d4a378977f5;
var $61c18f792160ea83$export$ef9b1a59e592288f;
"use strict";
$61c18f792160ea83$export$1e511d4a378977f5 = true;
$61c18f792160ea83$export$ef9b1a59e592288f = void 0;

var $61c18f792160ea83$var$_react = $61c18f792160ea83$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $61c18f792160ea83$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($61c18f792160ea83$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $61c18f792160ea83$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $61c18f792160ea83$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $61c18f792160ea83$var$_extends() {
    return $61c18f792160ea83$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $61c18f792160ea83$var$_extends.apply(null, arguments);
}
var $61c18f792160ea83$var$Select = $61c18f792160ea83$export$ef9b1a59e592288f = /*#__PURE__*/ (0, $61c18f792160ea83$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $61c18f792160ea83$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $61c18f792160ea83$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Select"
    }, props), /*#__PURE__*/ $61c18f792160ea83$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8 1h6-6zm11.188 18.472L16 22l-3.5-4.5-3 3.5L7 7l13 6.5-4.5 1.5 3.688 4.472zM19 4V1h-3M6 1H3v3m0 10v3h3M19 6v4-4zM3 12V6v6z"
    }));
});
$61c18f792160ea83$var$Select.displayName = 'Select';


Object.keys($61c18f792160ea83$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $61c18f792160ea83$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $61c18f792160ea83$exports[key];
});
var $73b5eddca54eab49$exports = {};

$parcel$export($73b5eddca54eab49$exports, "__esModule", function () { return $73b5eddca54eab49$export$1e511d4a378977f5; }, function (v) { return $73b5eddca54eab49$export$1e511d4a378977f5 = v; });
$parcel$export($73b5eddca54eab49$exports, "Selection", function () { return $73b5eddca54eab49$export$52baac22726c72bf; }, function (v) { return $73b5eddca54eab49$export$52baac22726c72bf = v; });
var $73b5eddca54eab49$export$1e511d4a378977f5;
var $73b5eddca54eab49$export$52baac22726c72bf;
"use strict";
$73b5eddca54eab49$export$1e511d4a378977f5 = true;
$73b5eddca54eab49$export$52baac22726c72bf = void 0;

var $73b5eddca54eab49$var$_react = $73b5eddca54eab49$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $73b5eddca54eab49$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($73b5eddca54eab49$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $73b5eddca54eab49$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $73b5eddca54eab49$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $73b5eddca54eab49$var$_extends() {
    return $73b5eddca54eab49$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $73b5eddca54eab49$var$_extends.apply(null, arguments);
}
var $73b5eddca54eab49$var$Selection = $73b5eddca54eab49$export$52baac22726c72bf = /*#__PURE__*/ (0, $73b5eddca54eab49$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $73b5eddca54eab49$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $73b5eddca54eab49$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Selection"
    }, props), /*#__PURE__*/ $73b5eddca54eab49$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M5 18h3V6H5v12zm7-16v20V2zM1 22h22V2H1v20z"
    }));
});
$73b5eddca54eab49$var$Selection.displayName = 'Selection';


Object.keys($73b5eddca54eab49$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $73b5eddca54eab49$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $73b5eddca54eab49$exports[key];
});
var $e872863638d90781$exports = {};

$parcel$export($e872863638d90781$exports, "__esModule", function () { return $e872863638d90781$export$1e511d4a378977f5; }, function (v) { return $e872863638d90781$export$1e511d4a378977f5 = v; });
$parcel$export($e872863638d90781$exports, "Semantics", function () { return $e872863638d90781$export$9d201e891b56e96e; }, function (v) { return $e872863638d90781$export$9d201e891b56e96e = v; });
var $e872863638d90781$export$1e511d4a378977f5;
var $e872863638d90781$export$9d201e891b56e96e;
"use strict";
$e872863638d90781$export$1e511d4a378977f5 = true;
$e872863638d90781$export$9d201e891b56e96e = void 0;

var $e872863638d90781$var$_react = $e872863638d90781$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e872863638d90781$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e872863638d90781$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e872863638d90781$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e872863638d90781$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e872863638d90781$var$_extends() {
    return $e872863638d90781$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e872863638d90781$var$_extends.apply(null, arguments);
}
var $e872863638d90781$var$Semantics = $e872863638d90781$export$9d201e891b56e96e = /*#__PURE__*/ (0, $e872863638d90781$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e872863638d90781$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e872863638d90781$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Semantics"
    }, props), /*#__PURE__*/ $e872863638d90781$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m2 17 10-5 10 5v4l-10-5-10 5v-4zm0-9 10-5 10 5v4L12 7 2 12V8z"
    }));
});
$e872863638d90781$var$Semantics.displayName = 'Semantics';


Object.keys($e872863638d90781$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e872863638d90781$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e872863638d90781$exports[key];
});
var $096a311538975598$exports = {};

$parcel$export($096a311538975598$exports, "__esModule", function () { return $096a311538975598$export$1e511d4a378977f5; }, function (v) { return $096a311538975598$export$1e511d4a378977f5 = v; });
$parcel$export($096a311538975598$exports, "Send", function () { return $096a311538975598$export$8689cbce9c2c90e9; }, function (v) { return $096a311538975598$export$8689cbce9c2c90e9 = v; });
var $096a311538975598$export$1e511d4a378977f5;
var $096a311538975598$export$8689cbce9c2c90e9;
"use strict";
$096a311538975598$export$1e511d4a378977f5 = true;
$096a311538975598$export$8689cbce9c2c90e9 = void 0;

var $096a311538975598$var$_react = $096a311538975598$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $096a311538975598$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($096a311538975598$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $096a311538975598$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $096a311538975598$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $096a311538975598$var$_extends() {
    return $096a311538975598$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $096a311538975598$var$_extends.apply(null, arguments);
}
var $096a311538975598$var$Send = $096a311538975598$export$8689cbce9c2c90e9 = /*#__PURE__*/ (0, $096a311538975598$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $096a311538975598$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $096a311538975598$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Send"
    }, props), /*#__PURE__*/ $096a311538975598$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M22 3 2 11l18.5 8L22 3zM10 20.5l3-4.5m2.5-6.5L9 14l.859 6.012c.078.546.216.537.306-.003L11 15l4.5-5.5z"
    }));
});
$096a311538975598$var$Send.displayName = 'Send';


Object.keys($096a311538975598$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $096a311538975598$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $096a311538975598$exports[key];
});
var $4038f94ef3f4ed68$exports = {};

$parcel$export($4038f94ef3f4ed68$exports, "__esModule", function () { return $4038f94ef3f4ed68$export$1e511d4a378977f5; }, function (v) { return $4038f94ef3f4ed68$export$1e511d4a378977f5 = v; });
$parcel$export($4038f94ef3f4ed68$exports, "ServerCluster", function () { return $4038f94ef3f4ed68$export$f74a36682421b4b7; }, function (v) { return $4038f94ef3f4ed68$export$f74a36682421b4b7 = v; });
var $4038f94ef3f4ed68$export$1e511d4a378977f5;
var $4038f94ef3f4ed68$export$f74a36682421b4b7;
"use strict";
$4038f94ef3f4ed68$export$1e511d4a378977f5 = true;
$4038f94ef3f4ed68$export$f74a36682421b4b7 = void 0;

var $4038f94ef3f4ed68$var$_react = $4038f94ef3f4ed68$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $4038f94ef3f4ed68$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4038f94ef3f4ed68$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4038f94ef3f4ed68$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $4038f94ef3f4ed68$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $4038f94ef3f4ed68$var$_extends() {
    return $4038f94ef3f4ed68$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4038f94ef3f4ed68$var$_extends.apply(null, arguments);
}
var $4038f94ef3f4ed68$var$ServerCluster = $4038f94ef3f4ed68$export$f74a36682421b4b7 = /*#__PURE__*/ (0, $4038f94ef3f4ed68$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $4038f94ef3f4ed68$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $4038f94ef3f4ed68$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ServerCluster"
    }, props), /*#__PURE__*/ $4038f94ef3f4ed68$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 8h22V1H1v7zm10-3h1V4h-1v1zm8 0h1V4h-1v1zm-4 0h1V4h-1v1zm-4 7h1v-1h-1v1zm8 0h1v-1h-1v1zm-4 0h1v-1h-1v1zm-4 7h1v-1h-1v1zm8 0h1v-1h-1v1zm-4 0h1v-1h-1v1zM1 15h22V8H1v7zm0 7h22v-7H1v7zm20 1H3"
    }));
});
$4038f94ef3f4ed68$var$ServerCluster.displayName = 'ServerCluster';


Object.keys($4038f94ef3f4ed68$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $4038f94ef3f4ed68$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $4038f94ef3f4ed68$exports[key];
});
var $34ea4aa5f691d640$exports = {};

$parcel$export($34ea4aa5f691d640$exports, "__esModule", function () { return $34ea4aa5f691d640$export$1e511d4a378977f5; }, function (v) { return $34ea4aa5f691d640$export$1e511d4a378977f5 = v; });
$parcel$export($34ea4aa5f691d640$exports, "Server", function () { return $34ea4aa5f691d640$export$d59771a2e9612de9; }, function (v) { return $34ea4aa5f691d640$export$d59771a2e9612de9 = v; });
var $34ea4aa5f691d640$export$1e511d4a378977f5;
var $34ea4aa5f691d640$export$d59771a2e9612de9;
"use strict";
$34ea4aa5f691d640$export$1e511d4a378977f5 = true;
$34ea4aa5f691d640$export$d59771a2e9612de9 = void 0;

var $34ea4aa5f691d640$var$_react = $34ea4aa5f691d640$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $34ea4aa5f691d640$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($34ea4aa5f691d640$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $34ea4aa5f691d640$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $34ea4aa5f691d640$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $34ea4aa5f691d640$var$_extends() {
    return $34ea4aa5f691d640$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $34ea4aa5f691d640$var$_extends.apply(null, arguments);
}
var $34ea4aa5f691d640$var$Server = $34ea4aa5f691d640$export$d59771a2e9612de9 = /*#__PURE__*/ (0, $34ea4aa5f691d640$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $34ea4aa5f691d640$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $34ea4aa5f691d640$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Server"
    }, props), /*#__PURE__*/ $34ea4aa5f691d640$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M14 19h1v-1h-1v1zm-9 4h14V1H5v22zM8 5h8-8zm0 4h8-8zm0 4h8-8z"
    }));
});
$34ea4aa5f691d640$var$Server.displayName = 'Server';


Object.keys($34ea4aa5f691d640$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $34ea4aa5f691d640$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $34ea4aa5f691d640$exports[key];
});
var $0fb8c0f5befe2661$exports = {};

$parcel$export($0fb8c0f5befe2661$exports, "__esModule", function () { return $0fb8c0f5befe2661$export$1e511d4a378977f5; }, function (v) { return $0fb8c0f5befe2661$export$1e511d4a378977f5 = v; });
$parcel$export($0fb8c0f5befe2661$exports, "Servers", function () { return $0fb8c0f5befe2661$export$26585b0cb202ac5c; }, function (v) { return $0fb8c0f5befe2661$export$26585b0cb202ac5c = v; });
var $0fb8c0f5befe2661$export$1e511d4a378977f5;
var $0fb8c0f5befe2661$export$26585b0cb202ac5c;
"use strict";
$0fb8c0f5befe2661$export$1e511d4a378977f5 = true;
$0fb8c0f5befe2661$export$26585b0cb202ac5c = void 0;

var $0fb8c0f5befe2661$var$_react = $0fb8c0f5befe2661$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0fb8c0f5befe2661$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0fb8c0f5befe2661$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0fb8c0f5befe2661$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0fb8c0f5befe2661$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0fb8c0f5befe2661$var$_extends() {
    return $0fb8c0f5befe2661$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0fb8c0f5befe2661$var$_extends.apply(null, arguments);
}
var $0fb8c0f5befe2661$var$Servers = $0fb8c0f5befe2661$export$26585b0cb202ac5c = /*#__PURE__*/ (0, $0fb8c0f5befe2661$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0fb8c0f5befe2661$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0fb8c0f5befe2661$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Servers"
    }, props), /*#__PURE__*/ $0fb8c0f5befe2661$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M7 19h1v-1H7v1zm11 0h1v-1h-1v1zM1 23h11V1H1v22zm11 0h11V1H12v22zM4 5h5-5zm11 0h5-5zM4 9h5-5zm11 0h5-5zM4 13h5-5zm11 0h5-5z"
    }));
});
$0fb8c0f5befe2661$var$Servers.displayName = 'Servers';


Object.keys($0fb8c0f5befe2661$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0fb8c0f5befe2661$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0fb8c0f5befe2661$exports[key];
});
var $acbf7c58f7e7fd2f$exports = {};

$parcel$export($acbf7c58f7e7fd2f$exports, "__esModule", function () { return $acbf7c58f7e7fd2f$export$1e511d4a378977f5; }, function (v) { return $acbf7c58f7e7fd2f$export$1e511d4a378977f5 = v; });
$parcel$export($acbf7c58f7e7fd2f$exports, "ServicePlay", function () { return $acbf7c58f7e7fd2f$export$3ee648cc1304861a; }, function (v) { return $acbf7c58f7e7fd2f$export$3ee648cc1304861a = v; });
var $acbf7c58f7e7fd2f$export$1e511d4a378977f5;
var $acbf7c58f7e7fd2f$export$3ee648cc1304861a;
"use strict";
$acbf7c58f7e7fd2f$export$1e511d4a378977f5 = true;
$acbf7c58f7e7fd2f$export$3ee648cc1304861a = void 0;

var $acbf7c58f7e7fd2f$var$_react = $acbf7c58f7e7fd2f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $acbf7c58f7e7fd2f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($acbf7c58f7e7fd2f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $acbf7c58f7e7fd2f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $acbf7c58f7e7fd2f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $acbf7c58f7e7fd2f$var$_extends() {
    return $acbf7c58f7e7fd2f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $acbf7c58f7e7fd2f$var$_extends.apply(null, arguments);
}
var $acbf7c58f7e7fd2f$var$ServicePlay = $acbf7c58f7e7fd2f$export$3ee648cc1304861a = /*#__PURE__*/ (0, $acbf7c58f7e7fd2f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $acbf7c58f7e7fd2f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $acbf7c58f7e7fd2f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ServicePlay"
    }, props), /*#__PURE__*/ $acbf7c58f7e7fd2f$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M7 13A6 6 0 1 0 7 1a6 6 0 0 0 0 12zm7.995 3.657a6 6 0 1 0-1.89-10.22m-8.281 6.255A6 6 0 0 0 9 23a6 6 0 0 0 2.127-11.612M6.5 6 8 7 6.5 8V6z"
    }));
});
$acbf7c58f7e7fd2f$var$ServicePlay.displayName = 'ServicePlay';


Object.keys($acbf7c58f7e7fd2f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $acbf7c58f7e7fd2f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $acbf7c58f7e7fd2f$exports[key];
});
var $be83b0172638a5b6$exports = {};

$parcel$export($be83b0172638a5b6$exports, "__esModule", function () { return $be83b0172638a5b6$export$1e511d4a378977f5; }, function (v) { return $be83b0172638a5b6$export$1e511d4a378977f5 = v; });
$parcel$export($be83b0172638a5b6$exports, "Services", function () { return $be83b0172638a5b6$export$c447b0cdbd1cd184; }, function (v) { return $be83b0172638a5b6$export$c447b0cdbd1cd184 = v; });
var $be83b0172638a5b6$export$1e511d4a378977f5;
var $be83b0172638a5b6$export$c447b0cdbd1cd184;
"use strict";
$be83b0172638a5b6$export$1e511d4a378977f5 = true;
$be83b0172638a5b6$export$c447b0cdbd1cd184 = void 0;

var $be83b0172638a5b6$var$_react = $be83b0172638a5b6$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $be83b0172638a5b6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($be83b0172638a5b6$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $be83b0172638a5b6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $be83b0172638a5b6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $be83b0172638a5b6$var$_extends() {
    return $be83b0172638a5b6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $be83b0172638a5b6$var$_extends.apply(null, arguments);
}
var $be83b0172638a5b6$var$Services = $be83b0172638a5b6$export$c447b0cdbd1cd184 = /*#__PURE__*/ (0, $be83b0172638a5b6$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $be83b0172638a5b6$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $be83b0172638a5b6$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Services"
    }, props), /*#__PURE__*/ $be83b0172638a5b6$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M6 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-6V0m0 12V9M0 6h3m6 0h3M2 2l2 2m4 4 2 2m0-8L8 4M4 8l-2 2m16 2a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-6V3m0 12v-3m-6-3h3m6 0h3M14 5l2 2m4 4 2 2m0-8-2 2m-4 4-2 2m-5 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-6v-3m0 12v-3m-6-3h3m6 0h3M5 14l2 2m4 4 2 2m0-8-2 2m-4 4-2 2"
    }));
});
$be83b0172638a5b6$var$Services.displayName = 'Services';


Object.keys($be83b0172638a5b6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $be83b0172638a5b6$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $be83b0172638a5b6$exports[key];
});
var $443da53faa1f16ce$exports = {};

$parcel$export($443da53faa1f16ce$exports, "__esModule", function () { return $443da53faa1f16ce$export$1e511d4a378977f5; }, function (v) { return $443da53faa1f16ce$export$1e511d4a378977f5 = v; });
$parcel$export($443da53faa1f16ce$exports, "SettingsOption", function () { return $443da53faa1f16ce$export$6d128738bddfaa67; }, function (v) { return $443da53faa1f16ce$export$6d128738bddfaa67 = v; });
var $443da53faa1f16ce$export$1e511d4a378977f5;
var $443da53faa1f16ce$export$6d128738bddfaa67;
"use strict";
$443da53faa1f16ce$export$1e511d4a378977f5 = true;
$443da53faa1f16ce$export$6d128738bddfaa67 = void 0;

var $443da53faa1f16ce$var$_react = $443da53faa1f16ce$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $443da53faa1f16ce$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($443da53faa1f16ce$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $443da53faa1f16ce$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $443da53faa1f16ce$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $443da53faa1f16ce$var$_extends() {
    return $443da53faa1f16ce$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $443da53faa1f16ce$var$_extends.apply(null, arguments);
}
var $443da53faa1f16ce$var$SettingsOption = $443da53faa1f16ce$export$6d128738bddfaa67 = /*#__PURE__*/ (0, $443da53faa1f16ce$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $443da53faa1f16ce$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $443da53faa1f16ce$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "SettingsOption"
    }, props), /*#__PURE__*/ $443da53faa1f16ce$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 9V0m3 12h9M0 12h9m3 12v-9m0 6a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM3.5 8.5 1 7.5m19.5 8 2.5 1M3 3l2.5 2.5M3 3l2.5 2.5M18 18l2.5 2.5m0-17.5L18 5.5M5.5 18 3 20.5m9-5.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm8.5-6.5 2.5-1m-7.5-4 1-2.5m-1 19.5 1 2.5m-8-2.5-1 2.5m-4-7.5-2.5 1m7.5-13L7.5 1"
    }));
});
$443da53faa1f16ce$var$SettingsOption.displayName = 'SettingsOption';


Object.keys($443da53faa1f16ce$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $443da53faa1f16ce$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $443da53faa1f16ce$exports[key];
});
var $044d6a48c0af119f$exports = {};

$parcel$export($044d6a48c0af119f$exports, "__esModule", function () { return $044d6a48c0af119f$export$1e511d4a378977f5; }, function (v) { return $044d6a48c0af119f$export$1e511d4a378977f5 = v; });
$parcel$export($044d6a48c0af119f$exports, "ShareOption", function () { return $044d6a48c0af119f$export$955d09dc9b28f767; }, function (v) { return $044d6a48c0af119f$export$955d09dc9b28f767 = v; });
var $044d6a48c0af119f$export$1e511d4a378977f5;
var $044d6a48c0af119f$export$955d09dc9b28f767;
"use strict";
$044d6a48c0af119f$export$1e511d4a378977f5 = true;
$044d6a48c0af119f$export$955d09dc9b28f767 = void 0;

var $044d6a48c0af119f$var$_react = $044d6a48c0af119f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $044d6a48c0af119f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($044d6a48c0af119f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $044d6a48c0af119f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $044d6a48c0af119f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $044d6a48c0af119f$var$_extends() {
    return $044d6a48c0af119f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $044d6a48c0af119f$var$_extends.apply(null, arguments);
}
var $044d6a48c0af119f$var$ShareOption = $044d6a48c0af119f$export$955d09dc9b28f767 = /*#__PURE__*/ (0, $044d6a48c0af119f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $044d6a48c0af119f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $044d6a48c0af119f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ShareOption"
    }, props), /*#__PURE__*/ $044d6a48c0af119f$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M18 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm12 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-2-4-8-5m8-7-8 5"
    }));
});
$044d6a48c0af119f$var$ShareOption.displayName = 'ShareOption';


Object.keys($044d6a48c0af119f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $044d6a48c0af119f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $044d6a48c0af119f$exports[key];
});
var $a8fd736fbe513521$exports = {};

$parcel$export($a8fd736fbe513521$exports, "__esModule", function () { return $a8fd736fbe513521$export$1e511d4a378977f5; }, function (v) { return $a8fd736fbe513521$export$1e511d4a378977f5 = v; });
$parcel$export($a8fd736fbe513521$exports, "ShareRounded", function () { return $a8fd736fbe513521$export$6402a9b85505c4db; }, function (v) { return $a8fd736fbe513521$export$6402a9b85505c4db = v; });
var $a8fd736fbe513521$export$1e511d4a378977f5;
var $a8fd736fbe513521$export$6402a9b85505c4db;
"use strict";
$a8fd736fbe513521$export$1e511d4a378977f5 = true;
$a8fd736fbe513521$export$6402a9b85505c4db = void 0;

var $a8fd736fbe513521$var$_react = $a8fd736fbe513521$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a8fd736fbe513521$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a8fd736fbe513521$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a8fd736fbe513521$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a8fd736fbe513521$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a8fd736fbe513521$var$_extends() {
    return $a8fd736fbe513521$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a8fd736fbe513521$var$_extends.apply(null, arguments);
}
var $a8fd736fbe513521$var$ShareRounded = $a8fd736fbe513521$export$6402a9b85505c4db = /*#__PURE__*/ (0, $a8fd736fbe513521$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a8fd736fbe513521$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a8fd736fbe513521$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ShareRounded"
    }, props), /*#__PURE__*/ $a8fd736fbe513521$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.924 3.617a.997.997 0 0 0-.215-.322l-.004-.004A.997.997 0 0 0 20 3h-6a1 1 0 1 0 0 2h3.586l-7.293 7.293a1 1 0 1 0 1.414 1.414L19 6.414V10a1 1 0 1 0 2 0V3.997a.999.999 0 0 0-.076-.38zM3 8a5 5 0 0 1 5-5h1a1 1 0 0 1 0 2H8a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-1a1 1 0 1 1 2 0v1a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5V8z",
        fill: "#000"
    }));
});
$a8fd736fbe513521$var$ShareRounded.displayName = 'ShareRounded';


Object.keys($a8fd736fbe513521$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a8fd736fbe513521$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a8fd736fbe513521$exports[key];
});
var $0e26da8133d72916$exports = {};

$parcel$export($0e26da8133d72916$exports, "__esModule", function () { return $0e26da8133d72916$export$1e511d4a378977f5; }, function (v) { return $0e26da8133d72916$export$1e511d4a378977f5 = v; });
$parcel$export($0e26da8133d72916$exports, "Share", function () { return $0e26da8133d72916$export$c9915453de10000b; }, function (v) { return $0e26da8133d72916$export$c9915453de10000b = v; });
var $0e26da8133d72916$export$1e511d4a378977f5;
var $0e26da8133d72916$export$c9915453de10000b;
"use strict";
$0e26da8133d72916$export$1e511d4a378977f5 = true;
$0e26da8133d72916$export$c9915453de10000b = void 0;

var $0e26da8133d72916$var$_react = $0e26da8133d72916$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0e26da8133d72916$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0e26da8133d72916$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0e26da8133d72916$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0e26da8133d72916$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0e26da8133d72916$var$_extends() {
    return $0e26da8133d72916$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0e26da8133d72916$var$_extends.apply(null, arguments);
}
var $0e26da8133d72916$var$Share = $0e26da8133d72916$export$c9915453de10000b = /*#__PURE__*/ (0, $0e26da8133d72916$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0e26da8133d72916$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0e26da8133d72916$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Share"
    }, props), /*#__PURE__*/ $0e26da8133d72916$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M19 13v10H1V5h10m3-4h9v9m-13 4L23 1 10 14z"
    }));
});
$0e26da8133d72916$var$Share.displayName = 'Share';


Object.keys($0e26da8133d72916$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0e26da8133d72916$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0e26da8133d72916$exports[key];
});
var $9c3245b88846077e$exports = {};

$parcel$export($9c3245b88846077e$exports, "__esModule", function () { return $9c3245b88846077e$export$1e511d4a378977f5; }, function (v) { return $9c3245b88846077e$export$1e511d4a378977f5 = v; });
$parcel$export($9c3245b88846077e$exports, "ShieldSecurity", function () { return $9c3245b88846077e$export$a54f877592c39cc4; }, function (v) { return $9c3245b88846077e$export$a54f877592c39cc4 = v; });
var $9c3245b88846077e$export$1e511d4a378977f5;
var $9c3245b88846077e$export$a54f877592c39cc4;
"use strict";
$9c3245b88846077e$export$1e511d4a378977f5 = true;
$9c3245b88846077e$export$a54f877592c39cc4 = void 0;

var $9c3245b88846077e$var$_react = $9c3245b88846077e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $9c3245b88846077e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9c3245b88846077e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9c3245b88846077e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $9c3245b88846077e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $9c3245b88846077e$var$_extends() {
    return $9c3245b88846077e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9c3245b88846077e$var$_extends.apply(null, arguments);
}
var $9c3245b88846077e$var$ShieldSecurity = $9c3245b88846077e$export$a54f877592c39cc4 = /*#__PURE__*/ (0, $9c3245b88846077e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $9c3245b88846077e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $9c3245b88846077e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ShieldSecurity"
    }, props), /*#__PURE__*/ $9c3245b88846077e$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22s-9-4-9-11V5l9-3 9 3v6c0 7-9 11-9 11zm0-8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-6V5m0 12v-3m-6-3h3m6 0h3M8 7l2 2m4 4 2 2m0-8-2 2m-4 4-2 2"
    }));
});
$9c3245b88846077e$var$ShieldSecurity.displayName = 'ShieldSecurity';


Object.keys($9c3245b88846077e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $9c3245b88846077e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $9c3245b88846077e$exports[key];
});
var $54e88a896ad9bb65$exports = {};

$parcel$export($54e88a896ad9bb65$exports, "__esModule", function () { return $54e88a896ad9bb65$export$1e511d4a378977f5; }, function (v) { return $54e88a896ad9bb65$export$1e511d4a378977f5 = v; });
$parcel$export($54e88a896ad9bb65$exports, "Shield", function () { return $54e88a896ad9bb65$export$83d8a86bc01f36bd; }, function (v) { return $54e88a896ad9bb65$export$83d8a86bc01f36bd = v; });
var $54e88a896ad9bb65$export$1e511d4a378977f5;
var $54e88a896ad9bb65$export$83d8a86bc01f36bd;
"use strict";
$54e88a896ad9bb65$export$1e511d4a378977f5 = true;
$54e88a896ad9bb65$export$83d8a86bc01f36bd = void 0;

var $54e88a896ad9bb65$var$_react = $54e88a896ad9bb65$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $54e88a896ad9bb65$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($54e88a896ad9bb65$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $54e88a896ad9bb65$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $54e88a896ad9bb65$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $54e88a896ad9bb65$var$_extends() {
    return $54e88a896ad9bb65$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $54e88a896ad9bb65$var$_extends.apply(null, arguments);
}
var $54e88a896ad9bb65$var$Shield = $54e88a896ad9bb65$export$83d8a86bc01f36bd = /*#__PURE__*/ (0, $54e88a896ad9bb65$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $54e88a896ad9bb65$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $54e88a896ad9bb65$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Shield"
    }, props), /*#__PURE__*/ $54e88a896ad9bb65$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22S3 18 3 5l9-3 9 3c0 13-9 17-9 17zM4 11h16m-8-9v20"
    }));
});
$54e88a896ad9bb65$var$Shield.displayName = 'Shield';


Object.keys($54e88a896ad9bb65$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $54e88a896ad9bb65$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $54e88a896ad9bb65$exports[key];
});
var $b2e4a38dadb2e6b2$exports = {};

$parcel$export($b2e4a38dadb2e6b2$exports, "__esModule", function () { return $b2e4a38dadb2e6b2$export$1e511d4a378977f5; }, function (v) { return $b2e4a38dadb2e6b2$export$1e511d4a378977f5 = v; });
$parcel$export($b2e4a38dadb2e6b2$exports, "Shift", function () { return $b2e4a38dadb2e6b2$export$e6d3b4e5ac18cdaf; }, function (v) { return $b2e4a38dadb2e6b2$export$e6d3b4e5ac18cdaf = v; });
var $b2e4a38dadb2e6b2$export$1e511d4a378977f5;
var $b2e4a38dadb2e6b2$export$e6d3b4e5ac18cdaf;
"use strict";
$b2e4a38dadb2e6b2$export$1e511d4a378977f5 = true;
$b2e4a38dadb2e6b2$export$e6d3b4e5ac18cdaf = void 0;

var $b2e4a38dadb2e6b2$var$_react = $b2e4a38dadb2e6b2$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $b2e4a38dadb2e6b2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b2e4a38dadb2e6b2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b2e4a38dadb2e6b2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $b2e4a38dadb2e6b2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b2e4a38dadb2e6b2$var$_extends() {
    return $b2e4a38dadb2e6b2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b2e4a38dadb2e6b2$var$_extends.apply(null, arguments);
}
var $b2e4a38dadb2e6b2$var$Shift = $b2e4a38dadb2e6b2$export$e6d3b4e5ac18cdaf = /*#__PURE__*/ (0, $b2e4a38dadb2e6b2$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $b2e4a38dadb2e6b2$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $b2e4a38dadb2e6b2$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Shift"
    }, props), /*#__PURE__*/ $b2e4a38dadb2e6b2$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 0v24M2 12h10m10 0H12M6 8l-4 4 4 4m12-8 4 4-4 4"
    }));
});
$b2e4a38dadb2e6b2$var$Shift.displayName = 'Shift';


Object.keys($b2e4a38dadb2e6b2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $b2e4a38dadb2e6b2$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $b2e4a38dadb2e6b2$exports[key];
});
var $df49d7978777e7ba$exports = {};

$parcel$export($df49d7978777e7ba$exports, "__esModule", function () { return $df49d7978777e7ba$export$1e511d4a378977f5; }, function (v) { return $df49d7978777e7ba$export$1e511d4a378977f5 = v; });
$parcel$export($df49d7978777e7ba$exports, "Shop", function () { return $df49d7978777e7ba$export$aa82d568fb2f38da; }, function (v) { return $df49d7978777e7ba$export$aa82d568fb2f38da = v; });
var $df49d7978777e7ba$export$1e511d4a378977f5;
var $df49d7978777e7ba$export$aa82d568fb2f38da;
"use strict";
$df49d7978777e7ba$export$1e511d4a378977f5 = true;
$df49d7978777e7ba$export$aa82d568fb2f38da = void 0;

var $df49d7978777e7ba$var$_react = $df49d7978777e7ba$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $df49d7978777e7ba$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($df49d7978777e7ba$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $df49d7978777e7ba$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $df49d7978777e7ba$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $df49d7978777e7ba$var$_extends() {
    return $df49d7978777e7ba$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $df49d7978777e7ba$var$_extends.apply(null, arguments);
}
var $df49d7978777e7ba$var$Shop = $df49d7978777e7ba$export$aa82d568fb2f38da = /*#__PURE__*/ (0, $df49d7978777e7ba$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $df49d7978777e7ba$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $df49d7978777e7ba$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Shop"
    }, props), /*#__PURE__*/ $df49d7978777e7ba$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: "2",
        d: "M4 7h16v16H4V7zm4 2V5c0-2.21 1.795-4 4-4h0c2.21 0 4 1.795 4 4v4"
    }));
});
$df49d7978777e7ba$var$Shop.displayName = 'Shop';


Object.keys($df49d7978777e7ba$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $df49d7978777e7ba$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $df49d7978777e7ba$exports[key];
});
var $4a25f8d68389bf19$exports = {};

$parcel$export($4a25f8d68389bf19$exports, "__esModule", function () { return $4a25f8d68389bf19$export$1e511d4a378977f5; }, function (v) { return $4a25f8d68389bf19$export$1e511d4a378977f5 = v; });
$parcel$export($4a25f8d68389bf19$exports, "Sidebar", function () { return $4a25f8d68389bf19$export$1ba59dacbcbf90fe; }, function (v) { return $4a25f8d68389bf19$export$1ba59dacbcbf90fe = v; });
var $4a25f8d68389bf19$export$1e511d4a378977f5;
var $4a25f8d68389bf19$export$1ba59dacbcbf90fe;
"use strict";
$4a25f8d68389bf19$export$1e511d4a378977f5 = true;
$4a25f8d68389bf19$export$1ba59dacbcbf90fe = void 0;

var $4a25f8d68389bf19$var$_react = $4a25f8d68389bf19$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $4a25f8d68389bf19$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4a25f8d68389bf19$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4a25f8d68389bf19$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $4a25f8d68389bf19$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $4a25f8d68389bf19$var$_extends() {
    return $4a25f8d68389bf19$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4a25f8d68389bf19$var$_extends.apply(null, arguments);
}
var $4a25f8d68389bf19$var$Sidebar = $4a25f8d68389bf19$export$1ba59dacbcbf90fe = /*#__PURE__*/ (0, $4a25f8d68389bf19$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $4a25f8d68389bf19$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $4a25f8d68389bf19$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Sidebar"
    }, props), /*#__PURE__*/ $4a25f8d68389bf19$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 22h22V2H1v20zM16 2v20V2z"
    }));
});
$4a25f8d68389bf19$var$Sidebar.displayName = 'Sidebar';


Object.keys($4a25f8d68389bf19$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $4a25f8d68389bf19$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $4a25f8d68389bf19$exports[key];
});
var $2051219d2de9ae1f$exports = {};

$parcel$export($2051219d2de9ae1f$exports, "__esModule", function () { return $2051219d2de9ae1f$export$1e511d4a378977f5; }, function (v) { return $2051219d2de9ae1f$export$1e511d4a378977f5 = v; });
$parcel$export($2051219d2de9ae1f$exports, "Sign", function () { return $2051219d2de9ae1f$export$1db683ad541682f6; }, function (v) { return $2051219d2de9ae1f$export$1db683ad541682f6 = v; });
var $2051219d2de9ae1f$export$1e511d4a378977f5;
var $2051219d2de9ae1f$export$1db683ad541682f6;
"use strict";
$2051219d2de9ae1f$export$1e511d4a378977f5 = true;
$2051219d2de9ae1f$export$1db683ad541682f6 = void 0;

var $2051219d2de9ae1f$var$_react = $2051219d2de9ae1f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $2051219d2de9ae1f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2051219d2de9ae1f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2051219d2de9ae1f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $2051219d2de9ae1f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $2051219d2de9ae1f$var$_extends() {
    return $2051219d2de9ae1f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2051219d2de9ae1f$var$_extends.apply(null, arguments);
}
var $2051219d2de9ae1f$var$Sign = $2051219d2de9ae1f$export$1db683ad541682f6 = /*#__PURE__*/ (0, $2051219d2de9ae1f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $2051219d2de9ae1f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $2051219d2de9ae1f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Sign"
    }, props), /*#__PURE__*/ $2051219d2de9ae1f$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8 23h7c3 0 4-2 4-5V6c0-2-1-2-1.5-2S16 4 16 6v7c0-1 0-2-1.5-2S13 13 13 13c0-1 0-2-1.5-2S10 12 10 13V4c0-1 .03-2-1.5-2C7 2 7 3 7 4v14-4c0-1-.55-2-2-2H4v6c0 3.962 2 5.024 4 5z"
    }));
});
$2051219d2de9ae1f$var$Sign.displayName = 'Sign';


Object.keys($2051219d2de9ae1f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $2051219d2de9ae1f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $2051219d2de9ae1f$exports[key];
});
var $15cfe2ba07a08100$exports = {};

$parcel$export($15cfe2ba07a08100$exports, "__esModule", function () { return $15cfe2ba07a08100$export$1e511d4a378977f5; }, function (v) { return $15cfe2ba07a08100$export$1e511d4a378977f5 = v; });
$parcel$export($15cfe2ba07a08100$exports, "Skype", function () { return $15cfe2ba07a08100$export$6552145fdbf0d995; }, function (v) { return $15cfe2ba07a08100$export$6552145fdbf0d995 = v; });
var $15cfe2ba07a08100$export$1e511d4a378977f5;
var $15cfe2ba07a08100$export$6552145fdbf0d995;
"use strict";
$15cfe2ba07a08100$export$1e511d4a378977f5 = true;
$15cfe2ba07a08100$export$6552145fdbf0d995 = void 0;

var $15cfe2ba07a08100$var$_react = $15cfe2ba07a08100$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $15cfe2ba07a08100$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($15cfe2ba07a08100$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $15cfe2ba07a08100$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $15cfe2ba07a08100$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $15cfe2ba07a08100$var$_extends() {
    return $15cfe2ba07a08100$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $15cfe2ba07a08100$var$_extends.apply(null, arguments);
}
var $15cfe2ba07a08100$var$Skype = $15cfe2ba07a08100$export$6552145fdbf0d995 = /*#__PURE__*/ (0, $15cfe2ba07a08100$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $15cfe2ba07a08100$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $15cfe2ba07a08100$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Skype"
    }, props), /*#__PURE__*/ $15cfe2ba07a08100$var$_react["default"].createElement("path", {
        fill: "#00AFF0",
        fillRule: "evenodd",
        d: "M12.052 18.856c-4.027 0-5.828-1.98-5.828-3.463 0-.761.562-1.295 1.336-1.295 1.724 0 1.277 2.475 4.492 2.475 1.645 0 2.554-.894 2.554-1.809 0-.55-.271-1.159-1.355-1.426l-3.581-.894c-2.884-.723-3.407-2.282-3.407-3.748 0-3.043 2.864-4.185 5.556-4.185 2.477 0 5.4 1.369 5.4 3.194 0 .783-.678 1.238-1.452 1.238-1.47 0-1.2-2.035-4.162-2.035-1.47 0-2.283.665-2.283 1.618 0 .95 1.16 1.254 2.168 1.483l2.651.59c2.903.646 3.64 2.34 3.64 3.938 0 2.472-1.898 4.319-5.73 4.319m11.1-4.887-.022.127-.04-.241c.021.037.04.076.061.114.124-.674.19-1.364.19-2.054a11.297 11.297 0 0 0-3.32-8.014A11.287 11.287 0 0 0 12.006.583c-.722 0-1.444.067-2.147.202l-.005.001c.04.021.08.04.118.061L9.736.81l.12-.024A6.722 6.722 0 0 0 6.709 0a6.663 6.663 0 0 0-4.744 1.965A6.666 6.666 0 0 0 0 6.71c0 1.14.293 2.26.844 3.252.007-.041.012-.083.02-.123l.041.237C.883 10.04.865 10 .844 9.962a11.402 11.402 0 0 0-.171 1.953c0 1.53.3 3.015.891 4.412a11.285 11.285 0 0 0 2.428 3.602 11.268 11.268 0 0 0 3.603 2.428c1.397.592 2.882.892 4.412.892.665 0 1.332-.061 1.984-.177-.038-.02-.077-.04-.115-.063l.242.043c-.042.008-.084.013-.127.02 1.004.569 2.14.87 3.3.87a6.66 6.66 0 0 0 4.744-1.965A6.66 6.66 0 0 0 24 17.233a6.707 6.707 0 0 0-.85-3.264"
    }));
});
$15cfe2ba07a08100$var$Skype.displayName = 'Skype';


Object.keys($15cfe2ba07a08100$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $15cfe2ba07a08100$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $15cfe2ba07a08100$exports[key];
});
var $a63587bc47fde078$exports = {};

$parcel$export($a63587bc47fde078$exports, "__esModule", function () { return $a63587bc47fde078$export$1e511d4a378977f5; }, function (v) { return $a63587bc47fde078$export$1e511d4a378977f5 = v; });
$parcel$export($a63587bc47fde078$exports, "Slack", function () { return $a63587bc47fde078$export$f9b9e065d49c5620; }, function (v) { return $a63587bc47fde078$export$f9b9e065d49c5620 = v; });
var $a63587bc47fde078$export$1e511d4a378977f5;
var $a63587bc47fde078$export$f9b9e065d49c5620;
"use strict";
$a63587bc47fde078$export$1e511d4a378977f5 = true;
$a63587bc47fde078$export$f9b9e065d49c5620 = void 0;

var $a63587bc47fde078$var$_react = $a63587bc47fde078$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a63587bc47fde078$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a63587bc47fde078$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a63587bc47fde078$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a63587bc47fde078$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a63587bc47fde078$var$_extends() {
    return $a63587bc47fde078$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a63587bc47fde078$var$_extends.apply(null, arguments);
}
var $a63587bc47fde078$var$Slack = $a63587bc47fde078$export$f9b9e065d49c5620 = /*#__PURE__*/ (0, $a63587bc47fde078$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a63587bc47fde078$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a63587bc47fde078$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Slack"
    }, props), /*#__PURE__*/ $a63587bc47fde078$var$_react["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $a63587bc47fde078$var$_react["default"].createElement("path", {
        fill: "#E01E5A",
        d: "M5.048 15.124a2.512 2.512 0 0 1-2.515 2.514A2.512 2.512 0 0 1 .02 15.124a2.512 2.512 0 0 1 2.514-2.514h2.515v2.514zm1.257 0a2.512 2.512 0 0 1 2.514-2.514 2.512 2.512 0 0 1 2.514 2.514v6.286a2.512 2.512 0 0 1-2.514 2.514 2.512 2.512 0 0 1-2.514-2.514v-6.286z"
    }), /*#__PURE__*/ $a63587bc47fde078$var$_react["default"].createElement("path", {
        fill: "#36C5F0",
        d: "M8.819 5.029a2.512 2.512 0 0 1-2.514-2.515A2.512 2.512 0 0 1 8.819 0a2.512 2.512 0 0 1 2.514 2.514V5.03H8.82zm0 1.276a2.512 2.512 0 0 1 2.514 2.514 2.512 2.512 0 0 1-2.514 2.514H2.514A2.512 2.512 0 0 1 0 8.82a2.512 2.512 0 0 1 2.514-2.514H8.82z"
    }), /*#__PURE__*/ $a63587bc47fde078$var$_react["default"].createElement("path", {
        fill: "#2EB67D",
        d: "M18.895 8.819a2.512 2.512 0 0 1 2.515-2.514 2.512 2.512 0 0 1 2.514 2.514 2.512 2.512 0 0 1-2.514 2.514h-2.515V8.82zm-1.257 0a2.512 2.512 0 0 1-2.514 2.514 2.512 2.512 0 0 1-2.515-2.514V2.514A2.512 2.512 0 0 1 15.124 0a2.512 2.512 0 0 1 2.514 2.514V8.82z"
    }), /*#__PURE__*/ $a63587bc47fde078$var$_react["default"].createElement("path", {
        fill: "#ECB22E",
        d: "M15.124 18.895a2.512 2.512 0 0 1 2.514 2.514 2.512 2.512 0 0 1-2.514 2.515 2.512 2.512 0 0 1-2.514-2.515v-2.514h2.514zm0-1.257a2.512 2.512 0 0 1-2.514-2.514 2.512 2.512 0 0 1 2.514-2.514h6.305a2.512 2.512 0 0 1 2.514 2.514 2.512 2.512 0 0 1-2.514 2.514h-6.305z"
    })));
});
$a63587bc47fde078$var$Slack.displayName = 'Slack';


Object.keys($a63587bc47fde078$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a63587bc47fde078$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a63587bc47fde078$exports[key];
});
var $9e2ce6ca3f0c2af8$exports = {};

$parcel$export($9e2ce6ca3f0c2af8$exports, "__esModule", function () { return $9e2ce6ca3f0c2af8$export$1e511d4a378977f5; }, function (v) { return $9e2ce6ca3f0c2af8$export$1e511d4a378977f5 = v; });
$parcel$export($9e2ce6ca3f0c2af8$exports, "Snapchat", function () { return $9e2ce6ca3f0c2af8$export$3890e5376d67c7fe; }, function (v) { return $9e2ce6ca3f0c2af8$export$3890e5376d67c7fe = v; });
var $9e2ce6ca3f0c2af8$export$1e511d4a378977f5;
var $9e2ce6ca3f0c2af8$export$3890e5376d67c7fe;
"use strict";
$9e2ce6ca3f0c2af8$export$1e511d4a378977f5 = true;
$9e2ce6ca3f0c2af8$export$3890e5376d67c7fe = void 0;

var $9e2ce6ca3f0c2af8$var$_react = $9e2ce6ca3f0c2af8$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $9e2ce6ca3f0c2af8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9e2ce6ca3f0c2af8$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9e2ce6ca3f0c2af8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $9e2ce6ca3f0c2af8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $9e2ce6ca3f0c2af8$var$_extends() {
    return $9e2ce6ca3f0c2af8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9e2ce6ca3f0c2af8$var$_extends.apply(null, arguments);
}
var $9e2ce6ca3f0c2af8$var$Snapchat = $9e2ce6ca3f0c2af8$export$3890e5376d67c7fe = /*#__PURE__*/ (0, $9e2ce6ca3f0c2af8$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $9e2ce6ca3f0c2af8$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $9e2ce6ca3f0c2af8$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Snapchat"
    }, props), /*#__PURE__*/ $9e2ce6ca3f0c2af8$var$_react["default"].createElement("path", {
        fill: "#FFFC00",
        fillRule: "evenodd",
        d: "M12.151 22.532c-.068 0-.133-.003-.182-.005-.04.003-.08.005-.12.005-1.43 0-2.385-.676-3.228-1.272-.604-.427-1.174-.83-1.842-.941a5.947 5.947 0 0 0-.97-.082c-.567 0-1.016.088-1.344.152-.201.039-.375.073-.51.073-.14 0-.311-.031-.383-.275a8.157 8.157 0 0 1-.136-.557c-.098-.447-.169-.72-.336-.746C1.308 18.607.249 18.2.038 17.706A.458.458 0 0 1 0 17.551a.288.288 0 0 1 .241-.3c1.423-.235 2.689-.987 3.762-2.237a8.434 8.434 0 0 0 1.29-2.008c.206-.42.247-.782.122-1.078-.231-.544-.996-.787-1.502-.948a5.405 5.405 0 0 1-.34-.115c-.448-.177-1.186-.551-1.088-1.068.072-.377.57-.64.973-.64.112 0 .211.02.294.06.456.213.865.321 1.217.321.438 0 .65-.167.7-.214a74.562 74.562 0 0 0-.042-.717c-.103-1.636-.231-3.67.29-4.838C7.473.276 10.777.005 11.752.005A249 249 0 0 0 12.236 0c.978 0 4.289.272 5.848 3.767.52 1.168.392 3.205.289 4.842l-.005.078a67.21 67.21 0 0 0-.038.637c.048.044.242.197.635.212.336-.013.722-.12 1.147-.32a.906.906 0 0 1 .375-.074c.15 0 .301.03.428.082l.007.003c.36.128.596.384.601.652.005.25-.181.625-1.097.986a5.552 5.552 0 0 1-.34.116c-.506.16-1.27.403-1.501.947-.126.295-.084.658.123 1.077l.006.014c.064.15 1.605 3.665 5.045 4.231a.288.288 0 0 1 .24.3.462.462 0 0 1-.038.157c-.209.491-1.268.898-3.06 1.175-.169.026-.24.298-.337.743-.04.184-.08.364-.136.553-.053.179-.169.266-.355.266h-.028a2.83 2.83 0 0 1-.51-.065 6.712 6.712 0 0 0-1.345-.142c-.315 0-.64.027-.97.082-.666.11-1.236.513-1.84.94-.844.597-1.8 1.273-3.229 1.273"
    }));
});
$9e2ce6ca3f0c2af8$var$Snapchat.displayName = 'Snapchat';


Object.keys($9e2ce6ca3f0c2af8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $9e2ce6ca3f0c2af8$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $9e2ce6ca3f0c2af8$exports[key];
});
var $37ee74a7af70094c$exports = {};

$parcel$export($37ee74a7af70094c$exports, "__esModule", function () { return $37ee74a7af70094c$export$1e511d4a378977f5; }, function (v) { return $37ee74a7af70094c$export$1e511d4a378977f5 = v; });
$parcel$export($37ee74a7af70094c$exports, "Solaris", function () { return $37ee74a7af70094c$export$f000f9872dbfcd93; }, function (v) { return $37ee74a7af70094c$export$f000f9872dbfcd93 = v; });
var $37ee74a7af70094c$export$1e511d4a378977f5;
var $37ee74a7af70094c$export$f000f9872dbfcd93;
"use strict";
$37ee74a7af70094c$export$1e511d4a378977f5 = true;
$37ee74a7af70094c$export$f000f9872dbfcd93 = void 0;

var $37ee74a7af70094c$var$_react = $37ee74a7af70094c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $37ee74a7af70094c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($37ee74a7af70094c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $37ee74a7af70094c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $37ee74a7af70094c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $37ee74a7af70094c$var$_extends() {
    return $37ee74a7af70094c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $37ee74a7af70094c$var$_extends.apply(null, arguments);
}
var $37ee74a7af70094c$var$Solaris = $37ee74a7af70094c$export$f000f9872dbfcd93 = /*#__PURE__*/ (0, $37ee74a7af70094c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $37ee74a7af70094c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $37ee74a7af70094c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Solaris"
    }, props), /*#__PURE__*/ $37ee74a7af70094c$var$_react["default"].createElement("path", {
        fill: "#D47B27",
        fillRule: "evenodd",
        d: "M10.18 4.764c-.872-.309-1.27-1.127-1.27-1.127-.068-.094-.353-.779-.353-.78-.3-.792-.845-1.035-.845-1.035-.671-.394-1.5-.404-1.5-.404.035-.005.493.207.493.207 1.08.515.756 1.744.756 1.744-.07.331-.086.97-.086.97a1.55 1.55 0 0 0 .659 1.312 7.557 7.557 0 0 1 2.147-.887M5.597 8.17c-.836.399-1.696.102-1.696.102-.115-.018-.8-.3-.8-.3-.773-.35-1.33-.136-1.33-.136-.754.196-1.347.775-1.347.775.021-.028.495-.202.495-.202 1.128-.4 1.768.698 1.768.698.184.284.625.747.625.747a1.551 1.551 0 0 0 1.393.462 7.54 7.54 0 0 1 .892-2.146m-.832 5.65c-.31.872-1.127 1.272-1.127 1.272-.095.067-.78.352-.78.352-.793.3-1.035.846-1.035.846-.395.67-.404 1.5-.404 1.5-.005-.036.206-.494.206-.494.515-1.08 1.745-.756 1.745-.756.33.07.969.086.969.086a1.55 1.55 0 0 0 1.312-.658 7.596 7.596 0 0 1-.886-2.148m3.406 4.583c.398.836.102 1.696.102 1.696-.019.115-.301.801-.302.801-.349.772-.134 1.33-.134 1.33.195.754.775 1.347.775 1.347-.029-.022-.203-.496-.203-.496-.4-1.127.699-1.767.699-1.767.283-.185.747-.626.747-.626a1.55 1.55 0 0 0 .461-1.393 7.602 7.602 0 0 1-2.145-.892m5.649.833c.873.309 1.272 1.127 1.272 1.127.068.094.353.78.352.78.3.792.846 1.035.846 1.035.671.395 1.5.404 1.5.404-.035.005-.493-.207-.493-.207-1.08-.515-.757-1.744-.757-1.744.07-.33.086-.97.086-.97a1.55 1.55 0 0 0-.658-1.312 7.587 7.587 0 0 1-2.148.887m4.584-3.406c.835-.399 1.696-.102 1.696-.102.115.018.8.301.8.301.773.35 1.33.135 1.33.135.754-.196 1.347-.775 1.347-.775-.022.029-.495.202-.495.202-1.128.4-1.768-.698-1.768-.698-.185-.284-.625-.747-.625-.747a1.55 1.55 0 0 0-1.394-.462 7.573 7.573 0 0 1-.891 2.146m.832-5.65c.31-.872 1.127-1.272 1.127-1.272.094-.067.78-.353.78-.352.792-.3 1.035-.845 1.035-.845.395-.672.405-1.5.405-1.5.004.035-.208.493-.208.493-.514 1.08-1.744.756-1.744.756-.33-.07-.97-.086-.97-.086a1.551 1.551 0 0 0-1.312.658c.204.335.384.692.536 1.066.147.358.264.72.351 1.082M15.83 5.597c-.398-.836-.103-1.696-.103-1.696.02-.115.302-.801.303-.8.349-.773.134-1.33.134-1.33-.196-.755-.775-1.348-.775-1.348.029.022.203.496.203.496.399 1.127-.7 1.768-.7 1.768-.282.185-.746.625-.746.625a1.55 1.55 0 0 0-.462 1.393 7.562 7.562 0 0 1 2.146.892m-8.243.387c-.925.042-1.602-.565-1.602-.565-.099-.061-.62-.588-.62-.589-.577-.621-1.174-.64-1.174-.64-.77-.113-1.542.19-1.542.19.031-.017.535.007.535.007 1.194.07 1.358 1.33 1.358 1.33.06.333.286.93.286.93a1.55 1.55 0 0 0 1.104.967 7.566 7.566 0 0 1 1.655-1.63m-2.961 4.882c-.624.684-1.533.734-1.533.734-.113.026-.855.023-.855.022C1.391 11.59.956 12 .956 12 .33 12.464 0 13.225 0 13.225c.01-.035.383-.375.383-.375.893-.795 1.9-.02 1.9-.02.278.194.86.457.86.457a1.55 1.55 0 0 0 1.465-.097 7.57 7.57 0 0 1 .018-2.324m1.358 5.547c.042.925-.564 1.603-.564 1.603-.062.098-.59.62-.59.62-.621.576-.64 1.173-.64 1.173-.113.77.19 1.542.19 1.542-.017-.03.007-.535.007-.535.07-1.194 1.33-1.358 1.33-1.358.333-.06.93-.285.93-.285a1.55 1.55 0 0 0 .968-1.105 7.603 7.603 0 0 1-1.631-1.655m4.882 2.962c.684.624.734 1.532.734 1.532.026.113.023.855.023.855-.033.847.376 1.283.376 1.283.465.624 1.226.955 1.226.955-.035-.01-.375-.382-.375-.382-.795-.894-.019-1.901-.019-1.901.193-.278.456-.86.456-.86a1.552 1.552 0 0 0-.097-1.465 7.544 7.544 0 0 1-2.324-.017m5.547-1.358c.925-.043 1.603.564 1.603.564.098.062.62.589.62.589.576.622 1.173.64 1.173.64.77.113 1.542-.19 1.542-.19-.03.017-.535-.006-.535-.006-1.194-.07-1.358-1.33-1.358-1.33-.06-.333-.285-.931-.285-.931a1.55 1.55 0 0 0-1.105-.967 7.55 7.55 0 0 1-1.655 1.63m2.962-4.882c.624-.684 1.532-.734 1.532-.734.114-.026.856-.023.856-.022.846.032 1.282-.377 1.282-.377.624-.465.955-1.225.955-1.225-.01.034-.382.374-.382.374-.894.795-1.901.02-1.901.02-.278-.194-.86-.457-.86-.457a1.55 1.55 0 0 0-1.465.097 7.56 7.56 0 0 1-.017 2.324m-1.358-5.547c-.043-.925.564-1.602.564-1.602.062-.099.589-.621.59-.62.62-.577.64-1.174.64-1.174.112-.77-.191-1.542-.191-1.542.018.031-.006.535-.006.535-.07 1.194-1.33 1.358-1.33 1.358-.333.06-.931.286-.931.286a1.551 1.551 0 0 0-.968 1.104 7.574 7.574 0 0 1 1.632 1.655m-4.883-2.961c-.684-.624-.734-1.533-.734-1.533-.026-.113-.023-.855-.022-.855C12.41 1.39 12 .956 12 .956 11.536.33 10.776 0 10.776 0c.034.01.374.383.374.383.795.894.02 1.9.02 1.9-.193.278-.457.86-.457.86-.345.78.053 1.399.097 1.466a7.526 7.526 0 0 1 2.324.017"
    }));
});
$37ee74a7af70094c$var$Solaris.displayName = 'Solaris';


Object.keys($37ee74a7af70094c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $37ee74a7af70094c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $37ee74a7af70094c$exports[key];
});
var $36b5ada4b3c257ff$exports = {};

$parcel$export($36b5ada4b3c257ff$exports, "__esModule", function () { return $36b5ada4b3c257ff$export$1e511d4a378977f5; }, function (v) { return $36b5ada4b3c257ff$export$1e511d4a378977f5 = v; });
$parcel$export($36b5ada4b3c257ff$exports, "Sort", function () { return $36b5ada4b3c257ff$export$d43f91ac58cde147; }, function (v) { return $36b5ada4b3c257ff$export$d43f91ac58cde147 = v; });
var $36b5ada4b3c257ff$export$1e511d4a378977f5;
var $36b5ada4b3c257ff$export$d43f91ac58cde147;
"use strict";
$36b5ada4b3c257ff$export$1e511d4a378977f5 = true;
$36b5ada4b3c257ff$export$d43f91ac58cde147 = void 0;

var $36b5ada4b3c257ff$var$_react = $36b5ada4b3c257ff$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $36b5ada4b3c257ff$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($36b5ada4b3c257ff$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $36b5ada4b3c257ff$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $36b5ada4b3c257ff$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $36b5ada4b3c257ff$var$_extends() {
    return $36b5ada4b3c257ff$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $36b5ada4b3c257ff$var$_extends.apply(null, arguments);
}
var $36b5ada4b3c257ff$var$Sort = $36b5ada4b3c257ff$export$d43f91ac58cde147 = /*#__PURE__*/ (0, $36b5ada4b3c257ff$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $36b5ada4b3c257ff$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $36b5ada4b3c257ff$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Sort"
    }, props), /*#__PURE__*/ $36b5ada4b3c257ff$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M7 3h15M7 9h9m-9 6h15M2 2h2v2H2V2zm0 6h2v2H2V8zm0 6h2v2H2v-2zm0 6h2v2H2v-2zm5 1h9"
    }));
});
$36b5ada4b3c257ff$var$Sort.displayName = 'Sort';


Object.keys($36b5ada4b3c257ff$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $36b5ada4b3c257ff$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $36b5ada4b3c257ff$exports[key];
});
var $5fe5bd95099f350e$exports = {};

$parcel$export($5fe5bd95099f350e$exports, "__esModule", function () { return $5fe5bd95099f350e$export$1e511d4a378977f5; }, function (v) { return $5fe5bd95099f350e$export$1e511d4a378977f5 = v; });
$parcel$export($5fe5bd95099f350e$exports, "Soundcloud", function () { return $5fe5bd95099f350e$export$50d53acbd9cba6; }, function (v) { return $5fe5bd95099f350e$export$50d53acbd9cba6 = v; });
var $5fe5bd95099f350e$export$1e511d4a378977f5;
var $5fe5bd95099f350e$export$50d53acbd9cba6;
"use strict";
$5fe5bd95099f350e$export$1e511d4a378977f5 = true;
$5fe5bd95099f350e$export$50d53acbd9cba6 = void 0;

var $5fe5bd95099f350e$var$_react = $5fe5bd95099f350e$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $5fe5bd95099f350e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5fe5bd95099f350e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5fe5bd95099f350e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5fe5bd95099f350e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5fe5bd95099f350e$var$_extends() {
    return $5fe5bd95099f350e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5fe5bd95099f350e$var$_extends.apply(null, arguments);
}
var $5fe5bd95099f350e$var$Soundcloud = $5fe5bd95099f350e$export$50d53acbd9cba6 = /*#__PURE__*/ (0, $5fe5bd95099f350e$var$_react.forwardRef)(function(props, ref) {
    var prefix = (0, $1b754218be0a6592$export$3794798abb123ff6)('Soundcloud');
    return /*#__PURE__*/ $5fe5bd95099f350e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5fe5bd95099f350e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Soundcloud"
    }, props), /*#__PURE__*/ $5fe5bd95099f350e$var$_react["default"].createElement("path", {
        fill: "url(#" + prefix + "-a)",
        d: "M0 15.922c0 .298.108.523.324.676a.885.885 0 0 0 .692.162c.231-.045.393-.127.486-.246.093-.119.14-.316.14-.592v-3.238a.799.799 0 0 0-.24-.587.798.798 0 0 0-.587-.24.785.785 0 0 0-.575.24.797.797 0 0 0-.24.587v3.238Zm2.569 1.385c0 .216.076.378.229.486.152.108.348.162.586.162.246 0 .445-.054.597-.162.153-.108.23-.27.23-.486v-7.55a.785.785 0 0 0-.24-.575.798.798 0 0 0-.587-.24.785.785 0 0 0-.575.24.785.785 0 0 0-.24.576v7.55Zm2.557.358c0 .215.078.377.235.485.156.108.357.162.603.162.238 0 .433-.054.586-.162.153-.108.229-.27.229-.485v-6.891c0-.23-.08-.428-.24-.592a.776.776 0 0 0-.575-.246.807.807 0 0 0-.592.246.807.807 0 0 0-.246.592v6.89Zm2.569.033c0 .41.275.614.826.614.551 0 .827-.204.827-.614V6.53c0-.625-.19-.979-.57-1.06-.246-.06-.488.01-.726.211-.238.201-.357.484-.357.849v11.168Zm2.613.324V5.872c0-.388.116-.619.346-.693a6.542 6.542 0 0 1 4.668.625A6.556 6.556 0 0 1 17.707 8a6.543 6.543 0 0 1 1.055 3.065c.454-.193.938-.29 1.452-.29 1.042 0 1.934.368 2.675 1.106.74.737 1.111 1.623 1.111 2.657 0 1.043-.37 1.933-1.111 2.67-.741.737-1.629 1.105-2.664 1.105l-9.716-.01a.261.261 0 0 1-.15-.124.33.33 0 0 1-.05-.156Z"
    }), /*#__PURE__*/ $5fe5bd95099f350e$var$_react["default"].createElement("defs", null, /*#__PURE__*/ $5fe5bd95099f350e$var$_react["default"].createElement("linearGradient", {
        id: prefix + "-a",
        x1: "30064.2",
        x2: "30064.2",
        y1: "507.299",
        y2: "18096.6",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $5fe5bd95099f350e$var$_react["default"].createElement("stop", {
        stopColor: "#F80"
    }), /*#__PURE__*/ $5fe5bd95099f350e$var$_react["default"].createElement("stop", {
        offset: "1",
        stopColor: "#F30"
    }))));
});
$5fe5bd95099f350e$var$Soundcloud.displayName = 'Soundcloud';


Object.keys($5fe5bd95099f350e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5fe5bd95099f350e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5fe5bd95099f350e$exports[key];
});
var $bf19c63b3de58753$exports = {};

$parcel$export($bf19c63b3de58753$exports, "__esModule", function () { return $bf19c63b3de58753$export$1e511d4a378977f5; }, function (v) { return $bf19c63b3de58753$export$1e511d4a378977f5 = v; });
$parcel$export($bf19c63b3de58753$exports, "Spa", function () { return $bf19c63b3de58753$export$6d4069f4b64f7492; }, function (v) { return $bf19c63b3de58753$export$6d4069f4b64f7492 = v; });
var $bf19c63b3de58753$export$1e511d4a378977f5;
var $bf19c63b3de58753$export$6d4069f4b64f7492;
"use strict";
$bf19c63b3de58753$export$1e511d4a378977f5 = true;
$bf19c63b3de58753$export$6d4069f4b64f7492 = void 0;

var $bf19c63b3de58753$var$_react = $bf19c63b3de58753$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $bf19c63b3de58753$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($bf19c63b3de58753$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $bf19c63b3de58753$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $bf19c63b3de58753$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $bf19c63b3de58753$var$_extends() {
    return $bf19c63b3de58753$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bf19c63b3de58753$var$_extends.apply(null, arguments);
}
var $bf19c63b3de58753$var$Spa = $bf19c63b3de58753$export$6d4069f4b64f7492 = /*#__PURE__*/ (0, $bf19c63b3de58753$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $bf19c63b3de58753$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $bf19c63b3de58753$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Spa"
    }, props), /*#__PURE__*/ $bf19c63b3de58753$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c1.5 0 4-1 4-5.5S12 6 12 6s-4 6-4 10.5 2.5 5.5 4 5.5zm0 0c-1.5 0-2.953-.22-5-1.5C3 18 2.5 10 2.5 10s4.5.5 6.5 2m3 10c1.5 0 2.953-.22 5-1.5C21 18 21.5 10 21.5 10s-4.5.5-6.5 2"
    }));
});
$bf19c63b3de58753$var$Spa.displayName = 'Spa';


Object.keys($bf19c63b3de58753$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $bf19c63b3de58753$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $bf19c63b3de58753$exports[key];
});
var $9025f60540cd060b$exports = {};

$parcel$export($9025f60540cd060b$exports, "__esModule", function () { return $9025f60540cd060b$export$1e511d4a378977f5; }, function (v) { return $9025f60540cd060b$export$1e511d4a378977f5 = v; });
$parcel$export($9025f60540cd060b$exports, "Spectrum", function () { return $9025f60540cd060b$export$6c494bbe6f966e0c; }, function (v) { return $9025f60540cd060b$export$6c494bbe6f966e0c = v; });
var $9025f60540cd060b$export$1e511d4a378977f5;
var $9025f60540cd060b$export$6c494bbe6f966e0c;
"use strict";
$9025f60540cd060b$export$1e511d4a378977f5 = true;
$9025f60540cd060b$export$6c494bbe6f966e0c = void 0;

var $9025f60540cd060b$var$_react = $9025f60540cd060b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $9025f60540cd060b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9025f60540cd060b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9025f60540cd060b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $9025f60540cd060b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $9025f60540cd060b$var$_extends() {
    return $9025f60540cd060b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9025f60540cd060b$var$_extends.apply(null, arguments);
}
var $9025f60540cd060b$var$Spectrum = $9025f60540cd060b$export$6c494bbe6f966e0c = /*#__PURE__*/ (0, $9025f60540cd060b$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $9025f60540cd060b$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $9025f60540cd060b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Spectrum"
    }, props), /*#__PURE__*/ $9025f60540cd060b$var$_react["default"].createElement("path", {
        fill: "#7B2DFB",
        fillRule: "evenodd",
        d: "M22.131 23.399h-9.006c-.795 0-1.506-.62-1.503-1.417.018-4.958-.878-6.584-2.753-8.224-1.969-1.72-5.414-2.055-7.375-2.094a1.508 1.508 0 0 1-1.479-1.507L0 1.533A1.505 1.505 0 0 1 1.431.023c2.95-.133 9.632.183 15.09 4.956 4.434 3.875 6.824 9.541 7.118 16.859a1.507 1.507 0 0 1-1.508 1.56"
    }));
});
$9025f60540cd060b$var$Spectrum.displayName = 'Spectrum';


Object.keys($9025f60540cd060b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $9025f60540cd060b$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $9025f60540cd060b$exports[key];
});
var $268594aea208a2f2$exports = {};

$parcel$export($268594aea208a2f2$exports, "__esModule", function () { return $268594aea208a2f2$export$1e511d4a378977f5; }, function (v) { return $268594aea208a2f2$export$1e511d4a378977f5 = v; });
$parcel$export($268594aea208a2f2$exports, "Split", function () { return $268594aea208a2f2$export$f836382419f64c98; }, function (v) { return $268594aea208a2f2$export$f836382419f64c98 = v; });
var $268594aea208a2f2$export$1e511d4a378977f5;
var $268594aea208a2f2$export$f836382419f64c98;
"use strict";
$268594aea208a2f2$export$1e511d4a378977f5 = true;
$268594aea208a2f2$export$f836382419f64c98 = void 0;

var $268594aea208a2f2$var$_react = $268594aea208a2f2$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $268594aea208a2f2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($268594aea208a2f2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $268594aea208a2f2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $268594aea208a2f2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $268594aea208a2f2$var$_extends() {
    return $268594aea208a2f2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $268594aea208a2f2$var$_extends.apply(null, arguments);
}
var $268594aea208a2f2$var$Split = $268594aea208a2f2$export$f836382419f64c98 = /*#__PURE__*/ (0, $268594aea208a2f2$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $268594aea208a2f2$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $268594aea208a2f2$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Split"
    }, props), /*#__PURE__*/ $268594aea208a2f2$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 22h22V2H1v20zM12 2v20V2z"
    }));
});
$268594aea208a2f2$var$Split.displayName = 'Split';


Object.keys($268594aea208a2f2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $268594aea208a2f2$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $268594aea208a2f2$exports[key];
});

Object.keys($02934120194f172d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $02934120194f172d$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $02934120194f172d$exports[key];
});
var $e3bc584323151d22$exports = {};

$parcel$export($e3bc584323151d22$exports, "__esModule", function () { return $e3bc584323151d22$export$1e511d4a378977f5; }, function (v) { return $e3bc584323151d22$export$1e511d4a378977f5 = v; });
$parcel$export($e3bc584323151d22$exports, "Spotify", function () { return $e3bc584323151d22$export$8b05054050bd9726; }, function (v) { return $e3bc584323151d22$export$8b05054050bd9726 = v; });
var $e3bc584323151d22$export$1e511d4a378977f5;
var $e3bc584323151d22$export$8b05054050bd9726;
"use strict";
$e3bc584323151d22$export$1e511d4a378977f5 = true;
$e3bc584323151d22$export$8b05054050bd9726 = void 0;

var $e3bc584323151d22$var$_react = $e3bc584323151d22$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e3bc584323151d22$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e3bc584323151d22$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e3bc584323151d22$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e3bc584323151d22$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e3bc584323151d22$var$_extends() {
    return $e3bc584323151d22$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e3bc584323151d22$var$_extends.apply(null, arguments);
}
var $e3bc584323151d22$var$Spotify = $e3bc584323151d22$export$8b05054050bd9726 = /*#__PURE__*/ (0, $e3bc584323151d22$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e3bc584323151d22$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e3bc584323151d22$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Spotify"
    }, props), /*#__PURE__*/ $e3bc584323151d22$var$_react["default"].createElement("path", {
        fill: "#1ED760",
        fillRule: "evenodd",
        d: "M19.098 10.638C15.23 8.341 8.85 8.13 5.158 9.251a1.122 1.122 0 1 1-.652-2.148C8.745 5.816 15.79 6.064 20.244 8.708a1.122 1.122 0 1 1-1.146 1.93m-.126 3.403a.936.936 0 0 1-1.287.308c-3.225-1.983-8.142-2.557-11.958-1.399a.937.937 0 0 1-1.167-.623.937.937 0 0 1 .624-1.167c4.358-1.322 9.776-.682 13.48 1.594.44.271.578.847.308 1.287m-1.469 3.267a.748.748 0 0 1-1.028.25c-2.818-1.723-6.365-2.112-10.542-1.158a.748.748 0 1 1-.333-1.458c4.571-1.045 8.492-.595 11.655 1.338a.748.748 0 0 1 .248 1.028M12 0C5.373 0 0 5.372 0 12s5.373 12 12 12c6.628 0 12-5.372 12-12S18.628 0 12 0"
    }));
});
$e3bc584323151d22$var$Spotify.displayName = 'Spotify';


Object.keys($e3bc584323151d22$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e3bc584323151d22$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e3bc584323151d22$exports[key];
});
var $adb8f73e584ce910$exports = {};

$parcel$export($adb8f73e584ce910$exports, "__esModule", function () { return $adb8f73e584ce910$export$1e511d4a378977f5; }, function (v) { return $adb8f73e584ce910$export$1e511d4a378977f5 = v; });
$parcel$export($adb8f73e584ce910$exports, "Square", function () { return $adb8f73e584ce910$export$b09fb900337259de; }, function (v) { return $adb8f73e584ce910$export$b09fb900337259de = v; });
var $adb8f73e584ce910$export$1e511d4a378977f5;
var $adb8f73e584ce910$export$b09fb900337259de;
"use strict";
$adb8f73e584ce910$export$1e511d4a378977f5 = true;
$adb8f73e584ce910$export$b09fb900337259de = void 0;

var $adb8f73e584ce910$var$_react = $adb8f73e584ce910$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $adb8f73e584ce910$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($adb8f73e584ce910$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $adb8f73e584ce910$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $adb8f73e584ce910$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $adb8f73e584ce910$var$_extends() {
    return $adb8f73e584ce910$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $adb8f73e584ce910$var$_extends.apply(null, arguments);
}
var $adb8f73e584ce910$var$Square = $adb8f73e584ce910$export$b09fb900337259de = /*#__PURE__*/ (0, $adb8f73e584ce910$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $adb8f73e584ce910$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $adb8f73e584ce910$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Square"
    }, props), /*#__PURE__*/ $adb8f73e584ce910$var$_react["default"].createElement("path", {
        fill: "#28C101",
        fillRule: "evenodd",
        d: "M14.444 8.333H9.556c-.675 0-1.223.548-1.223 1.223v4.888c0 .675.548 1.223 1.223 1.223h4.888c.675 0 1.223-.548 1.223-1.223V9.556c0-.675-.548-1.223-1.223-1.223M18.111 22H5.89A3.89 3.89 0 0 1 2 18.111V5.89A3.89 3.89 0 0 1 5.889 2H18.11A3.89 3.89 0 0 1 22 5.889V18.11A3.89 3.89 0 0 1 18.111 22zm0 2A5.89 5.89 0 0 0 24 18.111V5.89A5.89 5.89 0 0 0 18.111 0H5.89A5.89 5.89 0 0 0 0 5.889V18.11A5.89 5.89 0 0 0 5.889 24H18.11z"
    }));
});
$adb8f73e584ce910$var$Square.displayName = 'Square';


Object.keys($adb8f73e584ce910$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $adb8f73e584ce910$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $adb8f73e584ce910$exports[key];
});
var $a9997a7f584cd30c$exports = {};

$parcel$export($a9997a7f584cd30c$exports, "__esModule", function () { return $a9997a7f584cd30c$export$1e511d4a378977f5; }, function (v) { return $a9997a7f584cd30c$export$1e511d4a378977f5 = v; });
$parcel$export($a9997a7f584cd30c$exports, "StackOverflow", function () { return $a9997a7f584cd30c$export$269f85c93158d5b5; }, function (v) { return $a9997a7f584cd30c$export$269f85c93158d5b5 = v; });
var $a9997a7f584cd30c$export$1e511d4a378977f5;
var $a9997a7f584cd30c$export$269f85c93158d5b5;
"use strict";
$a9997a7f584cd30c$export$1e511d4a378977f5 = true;
$a9997a7f584cd30c$export$269f85c93158d5b5 = void 0;

var $a9997a7f584cd30c$var$_react = $a9997a7f584cd30c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a9997a7f584cd30c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a9997a7f584cd30c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a9997a7f584cd30c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a9997a7f584cd30c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a9997a7f584cd30c$var$_extends() {
    return $a9997a7f584cd30c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a9997a7f584cd30c$var$_extends.apply(null, arguments);
}
var $a9997a7f584cd30c$var$StackOverflow = $a9997a7f584cd30c$export$269f85c93158d5b5 = /*#__PURE__*/ (0, $a9997a7f584cd30c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a9997a7f584cd30c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a9997a7f584cd30c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "StackOverflow"
    }, props), /*#__PURE__*/ $a9997a7f584cd30c$var$_react["default"].createElement("path", {
        fill: "#BCBBBB",
        d: "M19.127 21.866v-6.43h2.134V24H2v-8.563h2.134v6.43h14.993Z"
    }), /*#__PURE__*/ $a9997a7f584cd30c$var$_react["default"].createElement("path", {
        fill: "#F48023",
        d: "m6.49 14.827 10.475 2.19.444-2.107-10.476-2.19-.443 2.107Zm1.385-4.989 9.7 4.518.887-1.94-9.7-4.545-.887 1.967Zm2.688-4.766 8.231 6.845 1.358-1.635-8.23-6.846-1.359 1.636ZM15.884 0l-1.718 1.275 6.374 8.591 1.719-1.275L15.884 0ZM6.268 19.704h10.697V17.57H6.268v2.134Z"
    }));
});
$a9997a7f584cd30c$var$StackOverflow.displayName = 'StackOverflow';


Object.keys($a9997a7f584cd30c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a9997a7f584cd30c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a9997a7f584cd30c$exports[key];
});
var $02f86ea052014ce5$exports = {};

$parcel$export($02f86ea052014ce5$exports, "__esModule", function () { return $02f86ea052014ce5$export$1e511d4a378977f5; }, function (v) { return $02f86ea052014ce5$export$1e511d4a378977f5 = v; });
$parcel$export($02f86ea052014ce5$exports, "Stakeholder", function () { return $02f86ea052014ce5$export$2622562fc32e41eb; }, function (v) { return $02f86ea052014ce5$export$2622562fc32e41eb = v; });
var $02f86ea052014ce5$export$1e511d4a378977f5;
var $02f86ea052014ce5$export$2622562fc32e41eb;
"use strict";
$02f86ea052014ce5$export$1e511d4a378977f5 = true;
$02f86ea052014ce5$export$2622562fc32e41eb = void 0;

var $02f86ea052014ce5$var$_react = $02f86ea052014ce5$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $02f86ea052014ce5$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($02f86ea052014ce5$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $02f86ea052014ce5$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $02f86ea052014ce5$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $02f86ea052014ce5$var$_extends() {
    return $02f86ea052014ce5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $02f86ea052014ce5$var$_extends.apply(null, arguments);
}
var $02f86ea052014ce5$var$Stakeholder = $02f86ea052014ce5$export$2622562fc32e41eb = /*#__PURE__*/ (0, $02f86ea052014ce5$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $02f86ea052014ce5$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $02f86ea052014ce5$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Stakeholder"
    }, props), /*#__PURE__*/ $02f86ea052014ce5$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m14 9 4.5 2L23 9V4l-4.5-2L14 4v5zM7 7a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM1 23v-2c0-4 2.5-6 6-6s6 2 6 6v2H1zM14 4l4.5 2L23 4m-4.5 2v5-5z"
    }));
});
$02f86ea052014ce5$var$Stakeholder.displayName = 'Stakeholder';


Object.keys($02f86ea052014ce5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $02f86ea052014ce5$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $02f86ea052014ce5$exports[key];
});
var $a8b78e21f5712dfc$exports = {};

$parcel$export($a8b78e21f5712dfc$exports, "__esModule", function () { return $a8b78e21f5712dfc$export$1e511d4a378977f5; }, function (v) { return $a8b78e21f5712dfc$export$1e511d4a378977f5 = v; });
$parcel$export($a8b78e21f5712dfc$exports, "StarHalf", function () { return $a8b78e21f5712dfc$export$6494e795a7a607ff; }, function (v) { return $a8b78e21f5712dfc$export$6494e795a7a607ff = v; });
var $a8b78e21f5712dfc$export$1e511d4a378977f5;
var $a8b78e21f5712dfc$export$6494e795a7a607ff;
"use strict";
$a8b78e21f5712dfc$export$1e511d4a378977f5 = true;
$a8b78e21f5712dfc$export$6494e795a7a607ff = void 0;

var $a8b78e21f5712dfc$var$_react = $a8b78e21f5712dfc$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a8b78e21f5712dfc$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a8b78e21f5712dfc$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a8b78e21f5712dfc$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a8b78e21f5712dfc$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a8b78e21f5712dfc$var$_extends() {
    return $a8b78e21f5712dfc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a8b78e21f5712dfc$var$_extends.apply(null, arguments);
}
var $a8b78e21f5712dfc$var$StarHalf = $a8b78e21f5712dfc$export$6494e795a7a607ff = /*#__PURE__*/ (0, $a8b78e21f5712dfc$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a8b78e21f5712dfc$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a8b78e21f5712dfc$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "StarHalf"
    }, props), /*#__PURE__*/ $a8b78e21f5712dfc$var$_react["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $a8b78e21f5712dfc$var$_react["default"].createElement("path", {
        fill: "#000",
        fillOpacity: ".2",
        d: "M12 16.667V2l2.5 7.5H22L16 14l3 8z"
    }), /*#__PURE__*/ $a8b78e21f5712dfc$var$_react["default"].createElement("path", {
        fill: "#FFC95E",
        d: "M12 16.667 5 22l3-8-6-4.5h7.5L12 2z"
    })));
});
$a8b78e21f5712dfc$var$StarHalf.displayName = 'StarHalf';


Object.keys($a8b78e21f5712dfc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a8b78e21f5712dfc$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a8b78e21f5712dfc$exports[key];
});

Object.keys($11e191990a1ec146$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $11e191990a1ec146$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $11e191990a1ec146$exports[key];
});

Object.keys($bce2f380b26d5e03$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $bce2f380b26d5e03$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $bce2f380b26d5e03$exports[key];
});

Object.keys($845b68b8616c04e1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $845b68b8616c04e1$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $845b68b8616c04e1$exports[key];
});
var $a51a342c513bb6fb$exports = {};

$parcel$export($a51a342c513bb6fb$exports, "__esModule", function () { return $a51a342c513bb6fb$export$1e511d4a378977f5; }, function (v) { return $a51a342c513bb6fb$export$1e511d4a378977f5 = v; });
$parcel$export($a51a342c513bb6fb$exports, "StatusCritical", function () { return $a51a342c513bb6fb$export$6d1a073fc8ad89c2; }, function (v) { return $a51a342c513bb6fb$export$6d1a073fc8ad89c2 = v; });
var $a51a342c513bb6fb$export$1e511d4a378977f5;
var $a51a342c513bb6fb$export$6d1a073fc8ad89c2;
"use strict";
$a51a342c513bb6fb$export$1e511d4a378977f5 = true;
$a51a342c513bb6fb$export$6d1a073fc8ad89c2 = void 0;

var $a51a342c513bb6fb$var$_react = $a51a342c513bb6fb$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a51a342c513bb6fb$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a51a342c513bb6fb$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a51a342c513bb6fb$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a51a342c513bb6fb$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a51a342c513bb6fb$var$_extends() {
    return $a51a342c513bb6fb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a51a342c513bb6fb$var$_extends.apply(null, arguments);
}
var $a51a342c513bb6fb$var$StatusCritical = $a51a342c513bb6fb$export$6d1a073fc8ad89c2 = /*#__PURE__*/ (0, $a51a342c513bb6fb$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a51a342c513bb6fb$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a51a342c513bb6fb$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Status is critical"
    }, props), /*#__PURE__*/ $a51a342c513bb6fb$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12.703 2.703a.99.99 0 0 0-1.406 0l-8.594 8.594a.99.99 0 0 0 0 1.406l8.594 8.594a.99.99 0 0 0 1.406 0l8.594-8.594a.99.99 0 0 0 0-1.406l-8.594-8.594zM8.983 14.7 14.7 8.983m-5.717 0L14.7 14.7"
    }));
});
$a51a342c513bb6fb$var$StatusCritical.displayName = 'StatusCritical';


Object.keys($a51a342c513bb6fb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a51a342c513bb6fb$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a51a342c513bb6fb$exports[key];
});
var $0a45049237176f62$exports = {};

$parcel$export($0a45049237176f62$exports, "__esModule", function () { return $0a45049237176f62$export$1e511d4a378977f5; }, function (v) { return $0a45049237176f62$export$1e511d4a378977f5 = v; });
$parcel$export($0a45049237176f62$exports, "StatusDisabledSmall", function () { return $0a45049237176f62$export$2940d1cc0da23f77; }, function (v) { return $0a45049237176f62$export$2940d1cc0da23f77 = v; });
var $0a45049237176f62$export$1e511d4a378977f5;
var $0a45049237176f62$export$2940d1cc0da23f77;
"use strict";
$0a45049237176f62$export$1e511d4a378977f5 = true;
$0a45049237176f62$export$2940d1cc0da23f77 = void 0;

var $0a45049237176f62$var$_react = $0a45049237176f62$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0a45049237176f62$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0a45049237176f62$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0a45049237176f62$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0a45049237176f62$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0a45049237176f62$var$_extends() {
    return $0a45049237176f62$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0a45049237176f62$var$_extends.apply(null, arguments);
}
var $0a45049237176f62$var$StatusDisabledSmall = $0a45049237176f62$export$2940d1cc0da23f77 = /*#__PURE__*/ (0, $0a45049237176f62$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0a45049237176f62$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0a45049237176f62$var$_extends({
        ref: ref,
        viewBox: "0 0 12 12",
        a11yTitle: "Status is disabled"
    }, props), /*#__PURE__*/ $0a45049237176f62$var$_react["default"].createElement("rect", {
        width: "10",
        height: "10",
        x: "1",
        y: "1",
        fillRule: "evenodd",
        stroke: "#000",
        rx: "1"
    }));
});
$0a45049237176f62$var$StatusDisabledSmall.displayName = 'StatusDisabledSmall';


Object.keys($0a45049237176f62$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0a45049237176f62$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0a45049237176f62$exports[key];
});
var $59e31180b6e983dc$exports = {};

$parcel$export($59e31180b6e983dc$exports, "__esModule", function () { return $59e31180b6e983dc$export$1e511d4a378977f5; }, function (v) { return $59e31180b6e983dc$export$1e511d4a378977f5 = v; });
$parcel$export($59e31180b6e983dc$exports, "StatusDisabled", function () { return $59e31180b6e983dc$export$248bf5b7ee0c189a; }, function (v) { return $59e31180b6e983dc$export$248bf5b7ee0c189a = v; });
var $59e31180b6e983dc$export$1e511d4a378977f5;
var $59e31180b6e983dc$export$248bf5b7ee0c189a;
"use strict";
$59e31180b6e983dc$export$1e511d4a378977f5 = true;
$59e31180b6e983dc$export$248bf5b7ee0c189a = void 0;

var $59e31180b6e983dc$var$_react = $59e31180b6e983dc$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $59e31180b6e983dc$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($59e31180b6e983dc$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $59e31180b6e983dc$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $59e31180b6e983dc$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $59e31180b6e983dc$var$_extends() {
    return $59e31180b6e983dc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $59e31180b6e983dc$var$_extends.apply(null, arguments);
}
var $59e31180b6e983dc$var$StatusDisabled = $59e31180b6e983dc$export$248bf5b7ee0c189a = /*#__PURE__*/ (0, $59e31180b6e983dc$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $59e31180b6e983dc$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $59e31180b6e983dc$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Status is disabled"
    }, props), /*#__PURE__*/ $59e31180b6e983dc$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 3.99C2 2.892 2.898 2 3.99 2h16.02C21.108 2 22 2.898 22 3.99v16.02c0 1.099-.898 1.99-1.99 1.99H3.99A1.995 1.995 0 0 1 2 20.01V3.99zM18 12H6"
    }));
});
$59e31180b6e983dc$var$StatusDisabled.displayName = 'StatusDisabled';


Object.keys($59e31180b6e983dc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $59e31180b6e983dc$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $59e31180b6e983dc$exports[key];
});

Object.keys($e82314c0e829446b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e82314c0e829446b$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e82314c0e829446b$exports[key];
});
var $fec3251ba1ec5714$exports = {};

$parcel$export($fec3251ba1ec5714$exports, "__esModule", function () { return $fec3251ba1ec5714$export$1e511d4a378977f5; }, function (v) { return $fec3251ba1ec5714$export$1e511d4a378977f5 = v; });
$parcel$export($fec3251ba1ec5714$exports, "StatusGood", function () { return $fec3251ba1ec5714$export$2f4a3096121829b3; }, function (v) { return $fec3251ba1ec5714$export$2f4a3096121829b3 = v; });
var $fec3251ba1ec5714$export$1e511d4a378977f5;
var $fec3251ba1ec5714$export$2f4a3096121829b3;
"use strict";
$fec3251ba1ec5714$export$1e511d4a378977f5 = true;
$fec3251ba1ec5714$export$2f4a3096121829b3 = void 0;

var $fec3251ba1ec5714$var$_react = $fec3251ba1ec5714$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $fec3251ba1ec5714$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($fec3251ba1ec5714$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $fec3251ba1ec5714$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $fec3251ba1ec5714$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $fec3251ba1ec5714$var$_extends() {
    return $fec3251ba1ec5714$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fec3251ba1ec5714$var$_extends.apply(null, arguments);
}
var $fec3251ba1ec5714$var$StatusGood = $fec3251ba1ec5714$export$2f4a3096121829b3 = /*#__PURE__*/ (0, $fec3251ba1ec5714$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $fec3251ba1ec5714$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $fec3251ba1ec5714$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Status is okay"
    }, props), /*#__PURE__*/ $fec3251ba1ec5714$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM7 12l4 3 5-7"
    }));
});
$fec3251ba1ec5714$var$StatusGood.displayName = 'StatusGood';


Object.keys($fec3251ba1ec5714$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $fec3251ba1ec5714$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $fec3251ba1ec5714$exports[key];
});
var $086d8f41aab4c165$exports = {};

$parcel$export($086d8f41aab4c165$exports, "__esModule", function () { return $086d8f41aab4c165$export$1e511d4a378977f5; }, function (v) { return $086d8f41aab4c165$export$1e511d4a378977f5 = v; });
$parcel$export($086d8f41aab4c165$exports, "StatusInfoSmall", function () { return $086d8f41aab4c165$export$3c7c36195a647ae8; }, function (v) { return $086d8f41aab4c165$export$3c7c36195a647ae8 = v; });
var $086d8f41aab4c165$export$1e511d4a378977f5;
var $086d8f41aab4c165$export$3c7c36195a647ae8;
"use strict";
$086d8f41aab4c165$export$1e511d4a378977f5 = true;
$086d8f41aab4c165$export$3c7c36195a647ae8 = void 0;

var $086d8f41aab4c165$var$_react = $086d8f41aab4c165$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $086d8f41aab4c165$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($086d8f41aab4c165$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $086d8f41aab4c165$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $086d8f41aab4c165$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $086d8f41aab4c165$var$_extends() {
    return $086d8f41aab4c165$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $086d8f41aab4c165$var$_extends.apply(null, arguments);
}
var $086d8f41aab4c165$var$StatusInfoSmall = $086d8f41aab4c165$export$3c7c36195a647ae8 = /*#__PURE__*/ (0, $086d8f41aab4c165$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $086d8f41aab4c165$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $086d8f41aab4c165$var$_extends({
        ref: ref,
        viewBox: "0 0 12 12",
        a11yTitle: "Information Status"
    }, props), /*#__PURE__*/ $086d8f41aab4c165$var$_react["default"].createElement("rect", {
        width: "10",
        height: "10",
        x: "1",
        y: "1",
        fillRule: "evenodd",
        stroke: "#000",
        rx: "1"
    }));
});
$086d8f41aab4c165$var$StatusInfoSmall.displayName = 'StatusInfoSmall';


Object.keys($086d8f41aab4c165$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $086d8f41aab4c165$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $086d8f41aab4c165$exports[key];
});
var $a9ca705d91ec579b$exports = {};

$parcel$export($a9ca705d91ec579b$exports, "__esModule", function () { return $a9ca705d91ec579b$export$1e511d4a378977f5; }, function (v) { return $a9ca705d91ec579b$export$1e511d4a378977f5 = v; });
$parcel$export($a9ca705d91ec579b$exports, "StatusInfo", function () { return $a9ca705d91ec579b$export$c8c69a8a599ae97d; }, function (v) { return $a9ca705d91ec579b$export$c8c69a8a599ae97d = v; });
var $a9ca705d91ec579b$export$1e511d4a378977f5;
var $a9ca705d91ec579b$export$c8c69a8a599ae97d;
"use strict";
$a9ca705d91ec579b$export$1e511d4a378977f5 = true;
$a9ca705d91ec579b$export$c8c69a8a599ae97d = void 0;

var $a9ca705d91ec579b$var$_react = $a9ca705d91ec579b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a9ca705d91ec579b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a9ca705d91ec579b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a9ca705d91ec579b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a9ca705d91ec579b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a9ca705d91ec579b$var$_extends() {
    return $a9ca705d91ec579b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a9ca705d91ec579b$var$_extends.apply(null, arguments);
}
var $a9ca705d91ec579b$var$StatusInfo = $a9ca705d91ec579b$export$c8c69a8a599ae97d = /*#__PURE__*/ (0, $a9ca705d91ec579b$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a9ca705d91ec579b$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a9ca705d91ec579b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Information Status"
    }, props), /*#__PURE__*/ $a9ca705d91ec579b$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 3.99C2 2.892 2.898 2 3.99 2h16.02C21.108 2 22 2.898 22 3.99v16.02c0 1.099-.898 1.99-1.99 1.99H3.99A1.995 1.995 0 0 1 2 20.01V3.99zM12 10v8m0-12v2"
    }));
});
$a9ca705d91ec579b$var$StatusInfo.displayName = 'StatusInfo';


Object.keys($a9ca705d91ec579b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a9ca705d91ec579b$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a9ca705d91ec579b$exports[key];
});
var $220873e611d34746$exports = {};

$parcel$export($220873e611d34746$exports, "__esModule", function () { return $220873e611d34746$export$1e511d4a378977f5; }, function (v) { return $220873e611d34746$export$1e511d4a378977f5 = v; });
$parcel$export($220873e611d34746$exports, "StatusPlaceholderSmall", function () { return $220873e611d34746$export$f1ced3e777bd0d56; }, function (v) { return $220873e611d34746$export$f1ced3e777bd0d56 = v; });
var $220873e611d34746$export$1e511d4a378977f5;
var $220873e611d34746$export$f1ced3e777bd0d56;
"use strict";
$220873e611d34746$export$1e511d4a378977f5 = true;
$220873e611d34746$export$f1ced3e777bd0d56 = void 0;

var $220873e611d34746$var$_react = $220873e611d34746$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $220873e611d34746$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($220873e611d34746$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $220873e611d34746$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $220873e611d34746$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $220873e611d34746$var$_extends() {
    return $220873e611d34746$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $220873e611d34746$var$_extends.apply(null, arguments);
}
var $220873e611d34746$var$StatusPlaceholderSmall = $220873e611d34746$export$f1ced3e777bd0d56 = /*#__PURE__*/ (0, $220873e611d34746$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $220873e611d34746$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $220873e611d34746$var$_extends({
        ref: ref,
        viewBox: "0 0 12 12",
        a11yTitle: "Placeholder Status"
    }, props), /*#__PURE__*/ $220873e611d34746$var$_react["default"].createElement("rect", {
        width: "10",
        height: "10",
        x: "1",
        y: "1",
        fillRule: "evenodd",
        stroke: "#000",
        rx: "1"
    }));
});
$220873e611d34746$var$StatusPlaceholderSmall.displayName = 'StatusPlaceholderSmall';


Object.keys($220873e611d34746$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $220873e611d34746$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $220873e611d34746$exports[key];
});
var $00577f9fa37bd7b7$exports = {};

$parcel$export($00577f9fa37bd7b7$exports, "__esModule", function () { return $00577f9fa37bd7b7$export$1e511d4a378977f5; }, function (v) { return $00577f9fa37bd7b7$export$1e511d4a378977f5 = v; });
$parcel$export($00577f9fa37bd7b7$exports, "StatusPlaceholder", function () { return $00577f9fa37bd7b7$export$3513a49dd0661ea7; }, function (v) { return $00577f9fa37bd7b7$export$3513a49dd0661ea7 = v; });
var $00577f9fa37bd7b7$export$1e511d4a378977f5;
var $00577f9fa37bd7b7$export$3513a49dd0661ea7;
"use strict";
$00577f9fa37bd7b7$export$1e511d4a378977f5 = true;
$00577f9fa37bd7b7$export$3513a49dd0661ea7 = void 0;

var $00577f9fa37bd7b7$var$_react = $00577f9fa37bd7b7$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $00577f9fa37bd7b7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($00577f9fa37bd7b7$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $00577f9fa37bd7b7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $00577f9fa37bd7b7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $00577f9fa37bd7b7$var$_extends() {
    return $00577f9fa37bd7b7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $00577f9fa37bd7b7$var$_extends.apply(null, arguments);
}
var $00577f9fa37bd7b7$var$StatusPlaceholder = $00577f9fa37bd7b7$export$3513a49dd0661ea7 = /*#__PURE__*/ (0, $00577f9fa37bd7b7$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $00577f9fa37bd7b7$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $00577f9fa37bd7b7$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Placeholder Status"
    }, props), /*#__PURE__*/ $00577f9fa37bd7b7$var$_react["default"].createElement("rect", {
        width: "20",
        height: "20",
        x: "2",
        y: "2",
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        rx: "2"
    }));
});
$00577f9fa37bd7b7$var$StatusPlaceholder.displayName = 'StatusPlaceholder';


Object.keys($00577f9fa37bd7b7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $00577f9fa37bd7b7$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $00577f9fa37bd7b7$exports[key];
});

Object.keys($cf8d6a20ce9c71c6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $cf8d6a20ce9c71c6$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $cf8d6a20ce9c71c6$exports[key];
});
var $f01c29ac288c220f$exports = {};

$parcel$export($f01c29ac288c220f$exports, "__esModule", function () { return $f01c29ac288c220f$export$1e511d4a378977f5; }, function (v) { return $f01c29ac288c220f$export$1e511d4a378977f5 = v; });
$parcel$export($f01c29ac288c220f$exports, "StatusUnknown", function () { return $f01c29ac288c220f$export$e8fe4ce11ea7420e; }, function (v) { return $f01c29ac288c220f$export$e8fe4ce11ea7420e = v; });
var $f01c29ac288c220f$export$1e511d4a378977f5;
var $f01c29ac288c220f$export$e8fe4ce11ea7420e;
"use strict";
$f01c29ac288c220f$export$1e511d4a378977f5 = true;
$f01c29ac288c220f$export$e8fe4ce11ea7420e = void 0;

var $f01c29ac288c220f$var$_react = $f01c29ac288c220f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f01c29ac288c220f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f01c29ac288c220f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f01c29ac288c220f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f01c29ac288c220f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f01c29ac288c220f$var$_extends() {
    return $f01c29ac288c220f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f01c29ac288c220f$var$_extends.apply(null, arguments);
}
var $f01c29ac288c220f$var$StatusUnknown = $f01c29ac288c220f$export$e8fe4ce11ea7420e = /*#__PURE__*/ (0, $f01c29ac288c220f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f01c29ac288c220f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f01c29ac288c220f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Status is unknown"
    }, props), /*#__PURE__*/ $f01c29ac288c220f$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 3.99C2 2.892 2.898 2 3.99 2h16.02C21.108 2 22 2.898 22 3.99v16.02c0 1.099-.898 1.99-1.99 1.99H3.99A1.995 1.995 0 0 1 2 20.01V3.99zM12 15v-1c0-1 0-1.5 1-2s2-1 2-2.5c0-1-1-2.5-3-2.5s-3 1.264-3 3m3 6v2"
    }));
});
$f01c29ac288c220f$var$StatusUnknown.displayName = 'StatusUnknown';


Object.keys($f01c29ac288c220f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f01c29ac288c220f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f01c29ac288c220f$exports[key];
});

Object.keys($b90cae8b1dd80e4e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $b90cae8b1dd80e4e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $b90cae8b1dd80e4e$exports[key];
});
var $3271720a662c836c$exports = {};

$parcel$export($3271720a662c836c$exports, "__esModule", function () { return $3271720a662c836c$export$1e511d4a378977f5; }, function (v) { return $3271720a662c836c$export$1e511d4a378977f5 = v; });
$parcel$export($3271720a662c836c$exports, "StatusWarning", function () { return $3271720a662c836c$export$a2518b5310db22ab; }, function (v) { return $3271720a662c836c$export$a2518b5310db22ab = v; });
var $3271720a662c836c$export$1e511d4a378977f5;
var $3271720a662c836c$export$a2518b5310db22ab;
"use strict";
$3271720a662c836c$export$1e511d4a378977f5 = true;
$3271720a662c836c$export$a2518b5310db22ab = void 0;

var $3271720a662c836c$var$_react = $3271720a662c836c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $3271720a662c836c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3271720a662c836c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3271720a662c836c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3271720a662c836c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3271720a662c836c$var$_extends() {
    return $3271720a662c836c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3271720a662c836c$var$_extends.apply(null, arguments);
}
var $3271720a662c836c$var$StatusWarning = $3271720a662c836c$export$a2518b5310db22ab = /*#__PURE__*/ (0, $3271720a662c836c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3271720a662c836c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3271720a662c836c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Status is warning"
    }, props), /*#__PURE__*/ $3271720a662c836c$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m12 3 10 18H2L12 3zm0 6v6m0 1v2"
    }));
});
$3271720a662c836c$var$StatusWarning.displayName = 'StatusWarning';


Object.keys($3271720a662c836c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3271720a662c836c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3271720a662c836c$exports[key];
});
var $6d32312c2b9be8e5$exports = {};

$parcel$export($6d32312c2b9be8e5$exports, "__esModule", function () { return $6d32312c2b9be8e5$export$1e511d4a378977f5; }, function (v) { return $6d32312c2b9be8e5$export$1e511d4a378977f5 = v; });
$parcel$export($6d32312c2b9be8e5$exports, "StepsOption", function () { return $6d32312c2b9be8e5$export$22cff6ac8f9e84dc; }, function (v) { return $6d32312c2b9be8e5$export$22cff6ac8f9e84dc = v; });
var $6d32312c2b9be8e5$export$1e511d4a378977f5;
var $6d32312c2b9be8e5$export$22cff6ac8f9e84dc;
"use strict";
$6d32312c2b9be8e5$export$1e511d4a378977f5 = true;
$6d32312c2b9be8e5$export$22cff6ac8f9e84dc = void 0;

var $6d32312c2b9be8e5$var$_react = $6d32312c2b9be8e5$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $6d32312c2b9be8e5$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6d32312c2b9be8e5$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6d32312c2b9be8e5$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6d32312c2b9be8e5$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6d32312c2b9be8e5$var$_extends() {
    return $6d32312c2b9be8e5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6d32312c2b9be8e5$var$_extends.apply(null, arguments);
}
var $6d32312c2b9be8e5$var$StepsOption = $6d32312c2b9be8e5$export$22cff6ac8f9e84dc = /*#__PURE__*/ (0, $6d32312c2b9be8e5$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $6d32312c2b9be8e5$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $6d32312c2b9be8e5$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "StepsOption"
    }, props), /*#__PURE__*/ $6d32312c2b9be8e5$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M24 9h-5v5h-5v5H9v5m-8 0v-7.003c0-.55.313-1.31.703-1.7L15.297 1.703c.388-.388 1.156-.703 1.7-.703H24"
    }));
});
$6d32312c2b9be8e5$var$StepsOption.displayName = 'StepsOption';


Object.keys($6d32312c2b9be8e5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $6d32312c2b9be8e5$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $6d32312c2b9be8e5$exports[key];
});
var $299c92df9e2d8110$exports = {};

$parcel$export($299c92df9e2d8110$exports, "__esModule", function () { return $299c92df9e2d8110$export$1e511d4a378977f5; }, function (v) { return $299c92df9e2d8110$export$1e511d4a378977f5 = v; });
$parcel$export($299c92df9e2d8110$exports, "Steps", function () { return $299c92df9e2d8110$export$fb587a27d5a722e7; }, function (v) { return $299c92df9e2d8110$export$fb587a27d5a722e7 = v; });
var $299c92df9e2d8110$export$1e511d4a378977f5;
var $299c92df9e2d8110$export$fb587a27d5a722e7;
"use strict";
$299c92df9e2d8110$export$1e511d4a378977f5 = true;
$299c92df9e2d8110$export$fb587a27d5a722e7 = void 0;

var $299c92df9e2d8110$var$_react = $299c92df9e2d8110$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $299c92df9e2d8110$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($299c92df9e2d8110$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $299c92df9e2d8110$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $299c92df9e2d8110$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $299c92df9e2d8110$var$_extends() {
    return $299c92df9e2d8110$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $299c92df9e2d8110$var$_extends.apply(null, arguments);
}
var $299c92df9e2d8110$var$Steps = $299c92df9e2d8110$export$fb587a27d5a722e7 = /*#__PURE__*/ (0, $299c92df9e2d8110$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $299c92df9e2d8110$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $299c92df9e2d8110$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Steps"
    }, props), /*#__PURE__*/ $299c92df9e2d8110$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M16 6h-5v5H6v5H1v7h22V1h-7z"
    }));
});
$299c92df9e2d8110$var$Steps.displayName = 'Steps';


Object.keys($299c92df9e2d8110$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $299c92df9e2d8110$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $299c92df9e2d8110$exports[key];
});
var $4c207b7ef4a209a6$exports = {};

$parcel$export($4c207b7ef4a209a6$exports, "__esModule", function () { return $4c207b7ef4a209a6$export$1e511d4a378977f5; }, function (v) { return $4c207b7ef4a209a6$export$1e511d4a378977f5 = v; });
$parcel$export($4c207b7ef4a209a6$exports, "StopFill", function () { return $4c207b7ef4a209a6$export$d02d99399c9ffb29; }, function (v) { return $4c207b7ef4a209a6$export$d02d99399c9ffb29 = v; });
var $4c207b7ef4a209a6$export$1e511d4a378977f5;
var $4c207b7ef4a209a6$export$d02d99399c9ffb29;
"use strict";
$4c207b7ef4a209a6$export$1e511d4a378977f5 = true;
$4c207b7ef4a209a6$export$d02d99399c9ffb29 = void 0;

var $4c207b7ef4a209a6$var$_react = $4c207b7ef4a209a6$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $4c207b7ef4a209a6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4c207b7ef4a209a6$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4c207b7ef4a209a6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $4c207b7ef4a209a6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $4c207b7ef4a209a6$var$_extends() {
    return $4c207b7ef4a209a6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4c207b7ef4a209a6$var$_extends.apply(null, arguments);
}
var $4c207b7ef4a209a6$var$StopFill = $4c207b7ef4a209a6$export$d02d99399c9ffb29 = /*#__PURE__*/ (0, $4c207b7ef4a209a6$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $4c207b7ef4a209a6$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $4c207b7ef4a209a6$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "StopFill"
    }, props), /*#__PURE__*/ $4c207b7ef4a209a6$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4 4h16v16H4V4zm2 2h12v12H6V6zm2 2h8v8H8V8zm2 2h4v4h-4v-4zm1 1h2v2h-2v-2z"
    }));
});
$4c207b7ef4a209a6$var$StopFill.displayName = 'StopFill';


Object.keys($4c207b7ef4a209a6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $4c207b7ef4a209a6$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $4c207b7ef4a209a6$exports[key];
});
var $a2307f71612d1ad5$exports = {};

$parcel$export($a2307f71612d1ad5$exports, "__esModule", function () { return $a2307f71612d1ad5$export$1e511d4a378977f5; }, function (v) { return $a2307f71612d1ad5$export$1e511d4a378977f5 = v; });
$parcel$export($a2307f71612d1ad5$exports, "Stop", function () { return $a2307f71612d1ad5$export$ac4156b3386a7c70; }, function (v) { return $a2307f71612d1ad5$export$ac4156b3386a7c70 = v; });
var $a2307f71612d1ad5$export$1e511d4a378977f5;
var $a2307f71612d1ad5$export$ac4156b3386a7c70;
"use strict";
$a2307f71612d1ad5$export$1e511d4a378977f5 = true;
$a2307f71612d1ad5$export$ac4156b3386a7c70 = void 0;

var $a2307f71612d1ad5$var$_react = $a2307f71612d1ad5$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a2307f71612d1ad5$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a2307f71612d1ad5$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a2307f71612d1ad5$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a2307f71612d1ad5$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a2307f71612d1ad5$var$_extends() {
    return $a2307f71612d1ad5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a2307f71612d1ad5$var$_extends.apply(null, arguments);
}
var $a2307f71612d1ad5$var$Stop = $a2307f71612d1ad5$export$ac4156b3386a7c70 = /*#__PURE__*/ (0, $a2307f71612d1ad5$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a2307f71612d1ad5$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a2307f71612d1ad5$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Stop"
    }, props), /*#__PURE__*/ $a2307f71612d1ad5$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4 4h16v16H4z"
    }));
});
$a2307f71612d1ad5$var$Stop.displayName = 'Stop';


Object.keys($a2307f71612d1ad5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a2307f71612d1ad5$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a2307f71612d1ad5$exports[key];
});
var $af0a1f19352b6a40$exports = {};

$parcel$export($af0a1f19352b6a40$exports, "__esModule", function () { return $af0a1f19352b6a40$export$1e511d4a378977f5; }, function (v) { return $af0a1f19352b6a40$export$1e511d4a378977f5 = v; });
$parcel$export($af0a1f19352b6a40$exports, "Storage", function () { return $af0a1f19352b6a40$export$bf2a15d34f3c441c; }, function (v) { return $af0a1f19352b6a40$export$bf2a15d34f3c441c = v; });
var $af0a1f19352b6a40$export$1e511d4a378977f5;
var $af0a1f19352b6a40$export$bf2a15d34f3c441c;
"use strict";
$af0a1f19352b6a40$export$1e511d4a378977f5 = true;
$af0a1f19352b6a40$export$bf2a15d34f3c441c = void 0;

var $af0a1f19352b6a40$var$_react = $af0a1f19352b6a40$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $af0a1f19352b6a40$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($af0a1f19352b6a40$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $af0a1f19352b6a40$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $af0a1f19352b6a40$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $af0a1f19352b6a40$var$_extends() {
    return $af0a1f19352b6a40$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $af0a1f19352b6a40$var$_extends.apply(null, arguments);
}
var $af0a1f19352b6a40$var$Storage = $af0a1f19352b6a40$export$bf2a15d34f3c441c = /*#__PURE__*/ (0, $af0a1f19352b6a40$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $af0a1f19352b6a40$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $af0a1f19352b6a40$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Storage"
    }, props), /*#__PURE__*/ $af0a1f19352b6a40$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 5.077S3.667 2 12 2s10 3.077 10 3.077v13.846S20.333 22 12 22 2 18.923 2 18.923V5.077zM2 13s3.333 3 10 3 10-3 10-3M2 7s3.333 3 10 3 10-3 10-3"
    }));
});
$af0a1f19352b6a40$var$Storage.displayName = 'Storage';


Object.keys($af0a1f19352b6a40$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $af0a1f19352b6a40$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $af0a1f19352b6a40$exports[key];
});
var $9e1d6540727f6325$exports = {};

$parcel$export($9e1d6540727f6325$exports, "__esModule", function () { return $9e1d6540727f6325$export$1e511d4a378977f5; }, function (v) { return $9e1d6540727f6325$export$1e511d4a378977f5 = v; });
$parcel$export($9e1d6540727f6325$exports, "StreetView", function () { return $9e1d6540727f6325$export$56bf5ff42373ff14; }, function (v) { return $9e1d6540727f6325$export$56bf5ff42373ff14 = v; });
var $9e1d6540727f6325$export$1e511d4a378977f5;
var $9e1d6540727f6325$export$56bf5ff42373ff14;
"use strict";
$9e1d6540727f6325$export$1e511d4a378977f5 = true;
$9e1d6540727f6325$export$56bf5ff42373ff14 = void 0;

var $9e1d6540727f6325$var$_react = $9e1d6540727f6325$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $9e1d6540727f6325$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9e1d6540727f6325$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9e1d6540727f6325$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $9e1d6540727f6325$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $9e1d6540727f6325$var$_extends() {
    return $9e1d6540727f6325$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9e1d6540727f6325$var$_extends.apply(null, arguments);
}
var $9e1d6540727f6325$var$StreetView = $9e1d6540727f6325$export$56bf5ff42373ff14 = /*#__PURE__*/ (0, $9e1d6540727f6325$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $9e1d6540727f6325$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $9e1d6540727f6325$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "StreetView"
    }, props), /*#__PURE__*/ $9e1d6540727f6325$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M16 5a4 4 0 1 1-8 0 4 4 0 0 1 8 0zm-1 18v-6h3v-2c0-3.34-2.76-5.97-6-6-3.21.03-6 2.66-6 6v2h3v6m-5.5 0h17-17z"
    }));
});
$9e1d6540727f6325$var$StreetView.displayName = 'StreetView';


Object.keys($9e1d6540727f6325$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $9e1d6540727f6325$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $9e1d6540727f6325$exports[key];
});
var $6a26f0e773864d94$exports = {};

$parcel$export($6a26f0e773864d94$exports, "__esModule", function () { return $6a26f0e773864d94$export$1e511d4a378977f5; }, function (v) { return $6a26f0e773864d94$export$1e511d4a378977f5 = v; });
$parcel$export($6a26f0e773864d94$exports, "StrikeThrough", function () { return $6a26f0e773864d94$export$c70466048188b38d; }, function (v) { return $6a26f0e773864d94$export$c70466048188b38d = v; });
var $6a26f0e773864d94$export$1e511d4a378977f5;
var $6a26f0e773864d94$export$c70466048188b38d;
"use strict";
$6a26f0e773864d94$export$1e511d4a378977f5 = true;
$6a26f0e773864d94$export$c70466048188b38d = void 0;

var $6a26f0e773864d94$var$_react = $6a26f0e773864d94$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $6a26f0e773864d94$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6a26f0e773864d94$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6a26f0e773864d94$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6a26f0e773864d94$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6a26f0e773864d94$var$_extends() {
    return $6a26f0e773864d94$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6a26f0e773864d94$var$_extends.apply(null, arguments);
}
var $6a26f0e773864d94$var$StrikeThrough = $6a26f0e773864d94$export$c70466048188b38d = /*#__PURE__*/ (0, $6a26f0e773864d94$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $6a26f0e773864d94$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $6a26f0e773864d94$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "StrikeThrough"
    }, props), /*#__PURE__*/ $6a26f0e773864d94$var$_react["default"].createElement("path", {
        d: "M5.77 12.17h12.46v1.09H5.77zm10.93 1.48h-3.81c.59.34 1 .6 1.18.74a3.39 3.39 0 0 1 1 1.07 2.38 2.38 0 0 1 .31 1.14 2.3 2.3 0 0 1-.82 1.76 3.18 3.18 0 0 1-2.22.74 4.7 4.7 0 0 1-2.23-.54 3.77 3.77 0 0 1-1.55-1.36 7.41 7.41 0 0 1-.79-2.46h-.41V20h.41a1.35 1.35 0 0 1 .24-.7.59.59 0 0 1 .44-.17 6.5 6.5 0 0 1 1.39.35 12.63 12.63 0 0 0 1.45.41 7.26 7.26 0 0 0 1.25.1A4.87 4.87 0 0 0 16 18.72a4 4 0 0 0 1.34-3 3.8 3.8 0 0 0-.42-1.72c-.06-.13-.14-.23-.22-.35zm-7.81-2.44c.21.17.49.36.81.57h4.87c-.48-.29-1.07-.62-1.76-1a12.49 12.49 0 0 1-3.33-2.24A1.93 1.93 0 0 1 9 7.26a2.18 2.18 0 0 1 .77-1.63 2.72 2.72 0 0 1 1.93-.71 4.14 4.14 0 0 1 2 .53 3.78 3.78 0 0 1 1.49 1.43 6.6 6.6 0 0 1 .73 2.42h.41V4h-.41a1.39 1.39 0 0 1-.3.7.67.67 0 0 1-.48.17 2.64 2.64 0 0 1-.89-.28A6.45 6.45 0 0 0 11.68 4a4.49 4.49 0 0 0-3.21 1.21A3.75 3.75 0 0 0 7.21 8a3.57 3.57 0 0 0 .43 1.73 4.72 4.72 0 0 0 1.25 1.48z"
    }));
});
$6a26f0e773864d94$var$StrikeThrough.displayName = 'StrikeThrough';


Object.keys($6a26f0e773864d94$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $6a26f0e773864d94$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $6a26f0e773864d94$exports[key];
});
var $5ee5d5be37ca2ced$exports = {};

$parcel$export($5ee5d5be37ca2ced$exports, "__esModule", function () { return $5ee5d5be37ca2ced$export$1e511d4a378977f5; }, function (v) { return $5ee5d5be37ca2ced$export$1e511d4a378977f5 = v; });
$parcel$export($5ee5d5be37ca2ced$exports, "Stripe", function () { return $5ee5d5be37ca2ced$export$3c7919ca4c48cda4; }, function (v) { return $5ee5d5be37ca2ced$export$3c7919ca4c48cda4 = v; });
var $5ee5d5be37ca2ced$export$1e511d4a378977f5;
var $5ee5d5be37ca2ced$export$3c7919ca4c48cda4;
"use strict";
$5ee5d5be37ca2ced$export$1e511d4a378977f5 = true;
$5ee5d5be37ca2ced$export$3c7919ca4c48cda4 = void 0;

var $5ee5d5be37ca2ced$var$_react = $5ee5d5be37ca2ced$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5ee5d5be37ca2ced$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5ee5d5be37ca2ced$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5ee5d5be37ca2ced$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5ee5d5be37ca2ced$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5ee5d5be37ca2ced$var$_extends() {
    return $5ee5d5be37ca2ced$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5ee5d5be37ca2ced$var$_extends.apply(null, arguments);
}
var $5ee5d5be37ca2ced$var$Stripe = $5ee5d5be37ca2ced$export$3c7919ca4c48cda4 = /*#__PURE__*/ (0, $5ee5d5be37ca2ced$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5ee5d5be37ca2ced$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5ee5d5be37ca2ced$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Stripe"
    }, props), /*#__PURE__*/ $5ee5d5be37ca2ced$var$_react["default"].createElement("path", {
        fill: "#AACBFB",
        fillRule: "evenodd",
        d: "M1 1h22v22H1V1zm10.12 8.19c0-.604.494-.836 1.314-.836 1.174 0 2.658.356 3.833.99V5.71c-1.283-.509-2.55-.71-3.833-.71-3.138 0-5.225 1.639-5.225 4.375 0 4.266 5.874 3.586 5.874 5.425 0 .711-.619.943-1.484.943-1.283 0-2.922-.525-4.22-1.236v3.679c1.437.618 2.89.88 4.22.88 3.215 0 5.426-1.591 5.426-4.358-.016-4.607-5.905-3.788-5.905-5.519z"
    }));
});
$5ee5d5be37ca2ced$var$Stripe.displayName = 'Stripe';


Object.keys($5ee5d5be37ca2ced$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5ee5d5be37ca2ced$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5ee5d5be37ca2ced$exports[key];
});
var $018ee6b034978e29$exports = {};

$parcel$export($018ee6b034978e29$exports, "__esModule", function () { return $018ee6b034978e29$export$1e511d4a378977f5; }, function (v) { return $018ee6b034978e29$export$1e511d4a378977f5 = v; });
$parcel$export($018ee6b034978e29$exports, "Subscript", function () { return $018ee6b034978e29$export$54eb3b8088f84d2b; }, function (v) { return $018ee6b034978e29$export$54eb3b8088f84d2b = v; });
var $018ee6b034978e29$export$1e511d4a378977f5;
var $018ee6b034978e29$export$54eb3b8088f84d2b;
"use strict";
$018ee6b034978e29$export$1e511d4a378977f5 = true;
$018ee6b034978e29$export$54eb3b8088f84d2b = void 0;

var $018ee6b034978e29$var$_react = $018ee6b034978e29$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $018ee6b034978e29$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($018ee6b034978e29$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $018ee6b034978e29$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $018ee6b034978e29$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $018ee6b034978e29$var$_extends() {
    return $018ee6b034978e29$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $018ee6b034978e29$var$_extends.apply(null, arguments);
}
var $018ee6b034978e29$var$Subscript = $018ee6b034978e29$export$54eb3b8088f84d2b = /*#__PURE__*/ (0, $018ee6b034978e29$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $018ee6b034978e29$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $018ee6b034978e29$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Subscript"
    }, props), /*#__PURE__*/ $018ee6b034978e29$var$_react["default"].createElement("path", {
        d: "m18.74 3.63.19 4.07h-.49a4.92 4.92 0 0 0-.38-1.54A2.58 2.58 0 0 0 17 5.07a3.68 3.68 0 0 0-1.73-.35h-2.44V18a3.54 3.54 0 0 0 .35 2 1.92 1.92 0 0 0 1.5.54h.6V21H7.92v-.5h.61a1.76 1.76 0 0 0 1.56-.67 3.88 3.88 0 0 0 .29-1.83V4.72H8.29a5.79 5.79 0 0 0-1.73.18 2.37 2.37 0 0 0-1.14.93 3.78 3.78 0 0 0-.56 1.87h-.48l.21-4.07zm3.74 13.05h.33v5.59a1.13 1.13 0 0 0 .06.4.41.41 0 0 0 .17.21.63.63 0 0 0 .28.08h.4v.27h-2.96V23h.45a.62.62 0 0 0 .29-.1.38.38 0 0 0 .15-.22 1.4 1.4 0 0 0 0-.37v-3.89a4.45 4.45 0 0 0 0-.64c0-.15-.1-.23-.24-.23a.82.82 0 0 0-.28 0l-.3.13-.18-.25z"
    }));
});
$018ee6b034978e29$var$Subscript.displayName = 'Subscript';


Object.keys($018ee6b034978e29$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $018ee6b034978e29$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $018ee6b034978e29$exports[key];
});
var $30b1bdd8d7a8a492$exports = {};

$parcel$export($30b1bdd8d7a8a492$exports, "__esModule", function () { return $30b1bdd8d7a8a492$export$1e511d4a378977f5; }, function (v) { return $30b1bdd8d7a8a492$export$1e511d4a378977f5 = v; });
$parcel$export($30b1bdd8d7a8a492$exports, "SubtractCircle", function () { return $30b1bdd8d7a8a492$export$5e6937876551669c; }, function (v) { return $30b1bdd8d7a8a492$export$5e6937876551669c = v; });
var $30b1bdd8d7a8a492$export$1e511d4a378977f5;
var $30b1bdd8d7a8a492$export$5e6937876551669c;
"use strict";
$30b1bdd8d7a8a492$export$1e511d4a378977f5 = true;
$30b1bdd8d7a8a492$export$5e6937876551669c = void 0;

var $30b1bdd8d7a8a492$var$_react = $30b1bdd8d7a8a492$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $30b1bdd8d7a8a492$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($30b1bdd8d7a8a492$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $30b1bdd8d7a8a492$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $30b1bdd8d7a8a492$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $30b1bdd8d7a8a492$var$_extends() {
    return $30b1bdd8d7a8a492$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $30b1bdd8d7a8a492$var$_extends.apply(null, arguments);
}
var $30b1bdd8d7a8a492$var$SubtractCircle = $30b1bdd8d7a8a492$export$5e6937876551669c = /*#__PURE__*/ (0, $30b1bdd8d7a8a492$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $30b1bdd8d7a8a492$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $30b1bdd8d7a8a492$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "SubtractCircle"
    }, props), /*#__PURE__*/ $30b1bdd8d7a8a492$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM6 12h12"
    }));
});
$30b1bdd8d7a8a492$var$SubtractCircle.displayName = 'SubtractCircle';


Object.keys($30b1bdd8d7a8a492$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $30b1bdd8d7a8a492$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $30b1bdd8d7a8a492$exports[key];
});

Object.keys($6a2802ef8f2bd5f5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $6a2802ef8f2bd5f5$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $6a2802ef8f2bd5f5$exports[key];
});
var $d7c611d108b909d2$exports = {};

$parcel$export($d7c611d108b909d2$exports, "__esModule", function () { return $d7c611d108b909d2$export$1e511d4a378977f5; }, function (v) { return $d7c611d108b909d2$export$1e511d4a378977f5 = v; });
$parcel$export($d7c611d108b909d2$exports, "Sun", function () { return $d7c611d108b909d2$export$a059d7a0f1f6fc48; }, function (v) { return $d7c611d108b909d2$export$a059d7a0f1f6fc48 = v; });
var $d7c611d108b909d2$export$1e511d4a378977f5;
var $d7c611d108b909d2$export$a059d7a0f1f6fc48;
"use strict";
$d7c611d108b909d2$export$1e511d4a378977f5 = true;
$d7c611d108b909d2$export$a059d7a0f1f6fc48 = void 0;

var $d7c611d108b909d2$var$_react = $d7c611d108b909d2$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $d7c611d108b909d2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d7c611d108b909d2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d7c611d108b909d2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d7c611d108b909d2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d7c611d108b909d2$var$_extends() {
    return $d7c611d108b909d2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d7c611d108b909d2$var$_extends.apply(null, arguments);
}
var $d7c611d108b909d2$var$Sun = $d7c611d108b909d2$export$a059d7a0f1f6fc48 = /*#__PURE__*/ (0, $d7c611d108b909d2$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d7c611d108b909d2$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $d7c611d108b909d2$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Sun"
    }, props), /*#__PURE__*/ $d7c611d108b909d2$var$_react["default"].createElement("path", {
        stroke: "#000",
        fill: "none",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M12 4V2m0 20v-2m8-8h2M2 12h2m13.657-5.657L19.07 4.93M4.93 19.07l1.414-1.414m0-11.314L4.93 4.93m14.14 14.14-1.414-1.414M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10z"
    }));
});
$d7c611d108b909d2$var$Sun.displayName = 'Sun';


Object.keys($d7c611d108b909d2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $d7c611d108b909d2$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $d7c611d108b909d2$exports[key];
});
var $750b06b83f72afb7$exports = {};

$parcel$export($750b06b83f72afb7$exports, "__esModule", function () { return $750b06b83f72afb7$export$1e511d4a378977f5; }, function (v) { return $750b06b83f72afb7$export$1e511d4a378977f5 = v; });
$parcel$export($750b06b83f72afb7$exports, "Superscript", function () { return $750b06b83f72afb7$export$a4eac561e2e9d419; }, function (v) { return $750b06b83f72afb7$export$a4eac561e2e9d419 = v; });
var $750b06b83f72afb7$export$1e511d4a378977f5;
var $750b06b83f72afb7$export$a4eac561e2e9d419;
"use strict";
$750b06b83f72afb7$export$1e511d4a378977f5 = true;
$750b06b83f72afb7$export$a4eac561e2e9d419 = void 0;

var $750b06b83f72afb7$var$_react = $750b06b83f72afb7$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $750b06b83f72afb7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($750b06b83f72afb7$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $750b06b83f72afb7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $750b06b83f72afb7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $750b06b83f72afb7$var$_extends() {
    return $750b06b83f72afb7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $750b06b83f72afb7$var$_extends.apply(null, arguments);
}
var $750b06b83f72afb7$var$Superscript = $750b06b83f72afb7$export$a4eac561e2e9d419 = /*#__PURE__*/ (0, $750b06b83f72afb7$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $750b06b83f72afb7$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $750b06b83f72afb7$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Superscript"
    }, props), /*#__PURE__*/ $750b06b83f72afb7$var$_react["default"].createElement("path", {
        d: "m18.74 3.63.19 4.07h-.49a4.9 4.9 0 0 0-.38-1.54A2.57 2.57 0 0 0 17 5.07a3.68 3.68 0 0 0-1.73-.35h-2.44V18a3.56 3.56 0 0 0 .34 2 1.92 1.92 0 0 0 1.5.54h.6V21H7.92v-.5h.61a1.76 1.76 0 0 0 1.56-.67 3.88 3.88 0 0 0 .29-1.83V4.72H8.29a5.82 5.82 0 0 0-1.73.18 2.37 2.37 0 0 0-1.14.93 3.78 3.78 0 0 0-.56 1.87h-.48l.21-4.07zM22.48 1h.33v5.62a1.13 1.13 0 0 0 .06.4.41.41 0 0 0 .17.21.63.63 0 0 0 .28.08h.4v.29h-2.96v-.27h.45a.62.62 0 0 0 .29-.1.38.38 0 0 0 .15-.23 1.4 1.4 0 0 0 0-.37V2.77a4.45 4.45 0 0 0 0-.64c0-.15-.1-.23-.24-.23a.82.82 0 0 0-.28 0l-.3.13-.18-.25z"
    }));
});
$750b06b83f72afb7$var$Superscript.displayName = 'Superscript';


Object.keys($750b06b83f72afb7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $750b06b83f72afb7$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $750b06b83f72afb7$exports[key];
});
var $18a02b1197951dac$exports = {};

$parcel$export($18a02b1197951dac$exports, "__esModule", function () { return $18a02b1197951dac$export$1e511d4a378977f5; }, function (v) { return $18a02b1197951dac$export$1e511d4a378977f5 = v; });
$parcel$export($18a02b1197951dac$exports, "Support", function () { return $18a02b1197951dac$export$c7a1df07a9ed91ad; }, function (v) { return $18a02b1197951dac$export$c7a1df07a9ed91ad = v; });
var $18a02b1197951dac$export$1e511d4a378977f5;
var $18a02b1197951dac$export$c7a1df07a9ed91ad;
"use strict";
$18a02b1197951dac$export$1e511d4a378977f5 = true;
$18a02b1197951dac$export$c7a1df07a9ed91ad = void 0;

var $18a02b1197951dac$var$_react = $18a02b1197951dac$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $18a02b1197951dac$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($18a02b1197951dac$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $18a02b1197951dac$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $18a02b1197951dac$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $18a02b1197951dac$var$_extends() {
    return $18a02b1197951dac$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $18a02b1197951dac$var$_extends.apply(null, arguments);
}
var $18a02b1197951dac$var$Support = $18a02b1197951dac$export$c7a1df07a9ed91ad = /*#__PURE__*/ (0, $18a02b1197951dac$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $18a02b1197951dac$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $18a02b1197951dac$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Support"
    }, props), /*#__PURE__*/ $18a02b1197951dac$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.222 19.778c4.296 4.296 11.26 4.296 15.556 0 4.296-4.296 4.296-11.26 0-15.556-4.296-4.296-11.26-4.296-15.556 0-4.296 4.296-4.296 11.26 0 15.556zM6.343 21.9l4.243-4.242m-8.485 0 4.242-4.243m11.314-2.828 4.242-4.243m-8.485 0 4.243-4.242m-9.9 14.142a6 6 0 1 0 8.486-8.486 6 6 0 0 0-8.486 8.486zm-5.656-9.9 4.242 4.243m0-8.485 4.243 4.242m2.828 11.314 4.243 4.242m0-8.485 4.242 4.243"
    }));
});
$18a02b1197951dac$var$Support.displayName = 'Support';


Object.keys($18a02b1197951dac$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $18a02b1197951dac$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $18a02b1197951dac$exports[key];
});
var $50d9d5e18edbd83a$exports = {};

$parcel$export($50d9d5e18edbd83a$exports, "__esModule", function () { return $50d9d5e18edbd83a$export$1e511d4a378977f5; }, function (v) { return $50d9d5e18edbd83a$export$1e511d4a378977f5 = v; });
$parcel$export($50d9d5e18edbd83a$exports, "Suse", function () { return $50d9d5e18edbd83a$export$46549a3fd0e683a8; }, function (v) { return $50d9d5e18edbd83a$export$46549a3fd0e683a8 = v; });
var $50d9d5e18edbd83a$export$1e511d4a378977f5;
var $50d9d5e18edbd83a$export$46549a3fd0e683a8;
"use strict";
$50d9d5e18edbd83a$export$1e511d4a378977f5 = true;
$50d9d5e18edbd83a$export$46549a3fd0e683a8 = void 0;

var $50d9d5e18edbd83a$var$_react = $50d9d5e18edbd83a$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $50d9d5e18edbd83a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($50d9d5e18edbd83a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $50d9d5e18edbd83a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $50d9d5e18edbd83a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $50d9d5e18edbd83a$var$_extends() {
    return $50d9d5e18edbd83a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $50d9d5e18edbd83a$var$_extends.apply(null, arguments);
}
var $50d9d5e18edbd83a$var$Suse = $50d9d5e18edbd83a$export$46549a3fd0e683a8 = /*#__PURE__*/ (0, $50d9d5e18edbd83a$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $50d9d5e18edbd83a$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $50d9d5e18edbd83a$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Suse"
    }, props), /*#__PURE__*/ $50d9d5e18edbd83a$var$_react["default"].createElement("path", {
        fill: "#7AC142",
        fillRule: "evenodd",
        d: "M24 8.285c-1.42-2.294-3.663-3.936-6.087-4.354-2.037-.354-5.752-.391-7.72 3.322-.822 1.55-.771 3.568.13 5.268.919 1.74 2.561 2.859 4.504 3.072 1.928.21 3.376-.236 4.19-1.288.82-1.063.972-2.509.39-3.687-.624-1.265-1.567-1.937-2.875-2.048-.999-.089-1.737.327-2.005.75a1.417 1.417 0 0 0-.218.737c0 .95.867 1.21 1.043 1.222.054-.003.316-.008.662-.095l.168-.056.2-.056a1.234 1.234 0 0 1 1.463 1.21c0 .408-.207.789-.631 1.071-.182.115-.35.179-.525.234a4.356 4.356 0 0 1-1.373.236c-1.505-.002-3.6-1.295-3.626-3.724-.014-1.371.673-2.618 1.885-3.422 1.394-.922 3.803-1.235 6.04.137 2.75 1.682 3.469 4.981 2.75 7.23-1.043 3.258-3.98 5-7.853 4.653-2.745-.244-5.295-1.693-6.812-3.874a9.615 9.615 0 0 1-1.44-3.119c-.62-2.456.006-5.066.472-6.222.8-1.981 1.993-3.813 3.566-5.482H1.001A1 1 0 0 0 0 1v22a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V8.285z"
    }));
});
$50d9d5e18edbd83a$var$Suse.displayName = 'Suse';


Object.keys($50d9d5e18edbd83a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $50d9d5e18edbd83a$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $50d9d5e18edbd83a$exports[key];
});
var $abfbc1d87ffcdadf$exports = {};

$parcel$export($abfbc1d87ffcdadf$exports, "__esModule", function () { return $abfbc1d87ffcdadf$export$1e511d4a378977f5; }, function (v) { return $abfbc1d87ffcdadf$export$1e511d4a378977f5 = v; });
$parcel$export($abfbc1d87ffcdadf$exports, "Swift", function () { return $abfbc1d87ffcdadf$export$8165f615068c9eea; }, function (v) { return $abfbc1d87ffcdadf$export$8165f615068c9eea = v; });
var $abfbc1d87ffcdadf$export$1e511d4a378977f5;
var $abfbc1d87ffcdadf$export$8165f615068c9eea;
"use strict";
$abfbc1d87ffcdadf$export$1e511d4a378977f5 = true;
$abfbc1d87ffcdadf$export$8165f615068c9eea = void 0;

var $abfbc1d87ffcdadf$var$_react = $abfbc1d87ffcdadf$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $abfbc1d87ffcdadf$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($abfbc1d87ffcdadf$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $abfbc1d87ffcdadf$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $abfbc1d87ffcdadf$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $abfbc1d87ffcdadf$var$_extends() {
    return $abfbc1d87ffcdadf$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $abfbc1d87ffcdadf$var$_extends.apply(null, arguments);
}
var $abfbc1d87ffcdadf$var$Swift = $abfbc1d87ffcdadf$export$8165f615068c9eea = /*#__PURE__*/ (0, $abfbc1d87ffcdadf$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $abfbc1d87ffcdadf$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $abfbc1d87ffcdadf$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Swift"
    }, props), /*#__PURE__*/ $abfbc1d87ffcdadf$var$_react["default"].createElement("path", {
        fill: "#D15F3E",
        fillRule: "evenodd",
        d: "M18.103 21.018c-2.827 1.633-6.714 1.801-10.625.125-3.166-1.347-5.794-3.705-7.478-6.4.808.674 1.752 1.213 2.762 1.684 4.039 1.893 8.077 1.764 10.918.005l-.004-.005C9.634 13.328 6.198 9.286 3.638 5.985c-.54-.539-.943-1.212-1.348-1.819 3.1 2.83 8.018 6.4 9.769 7.411C8.354 7.67 5.053 2.82 5.187 2.954c5.861 5.928 11.319 9.297 11.319 9.297.18.101.32.186.432.262.118-.3.221-.612.308-.936.944-3.436-.134-7.343-2.492-10.577 5.456 3.301 8.69 9.499 7.343 14.686-.035.14-.074.279-.115.414l.048.058c2.694 3.369 1.953 6.94 1.616 6.266-1.461-2.86-4.167-1.986-5.543-1.406z"
    }));
});
$abfbc1d87ffcdadf$var$Swift.displayName = 'Swift';


Object.keys($abfbc1d87ffcdadf$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $abfbc1d87ffcdadf$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $abfbc1d87ffcdadf$exports[key];
});
var $a1101ef29e5fd87b$exports = {};

$parcel$export($a1101ef29e5fd87b$exports, "__esModule", function () { return $a1101ef29e5fd87b$export$1e511d4a378977f5; }, function (v) { return $a1101ef29e5fd87b$export$1e511d4a378977f5 = v; });
$parcel$export($a1101ef29e5fd87b$exports, "Swim", function () { return $a1101ef29e5fd87b$export$3d104a6416d78ee6; }, function (v) { return $a1101ef29e5fd87b$export$3d104a6416d78ee6 = v; });
var $a1101ef29e5fd87b$export$1e511d4a378977f5;
var $a1101ef29e5fd87b$export$3d104a6416d78ee6;
"use strict";
$a1101ef29e5fd87b$export$1e511d4a378977f5 = true;
$a1101ef29e5fd87b$export$3d104a6416d78ee6 = void 0;

var $a1101ef29e5fd87b$var$_react = $a1101ef29e5fd87b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a1101ef29e5fd87b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a1101ef29e5fd87b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a1101ef29e5fd87b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a1101ef29e5fd87b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a1101ef29e5fd87b$var$_extends() {
    return $a1101ef29e5fd87b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a1101ef29e5fd87b$var$_extends.apply(null, arguments);
}
var $a1101ef29e5fd87b$var$Swim = $a1101ef29e5fd87b$export$3d104a6416d78ee6 = /*#__PURE__*/ (0, $a1101ef29e5fd87b$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a1101ef29e5fd87b$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a1101ef29e5fd87b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Swim"
    }, props), /*#__PURE__*/ $a1101ef29e5fd87b$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M11 13c.5.5 2.13-.112 3.262-.5 1.46-.5 3.238 0 2.738-.5l-2-2s-4.5 2.5-4 3zm-9 7c2 0 3-1 5-1s3 1 5 1 3-1 5-1 3 1 5 1M2 16c2 0 3-1 5-1s3 1 5 1 3-1 5-1 3 1 5 1M17.5 4l-5.278 3 3.278 3.5L12 12m7.222-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
    }));
});
$a1101ef29e5fd87b$var$Swim.displayName = 'Swim';


Object.keys($a1101ef29e5fd87b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a1101ef29e5fd87b$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a1101ef29e5fd87b$exports[key];
});
var $3b671069a70885c6$exports = {};

$parcel$export($3b671069a70885c6$exports, "__esModule", function () { return $3b671069a70885c6$export$1e511d4a378977f5; }, function (v) { return $3b671069a70885c6$export$1e511d4a378977f5 = v; });
$parcel$export($3b671069a70885c6$exports, "Switch", function () { return $3b671069a70885c6$export$b5d5cf8927ab7262; }, function (v) { return $3b671069a70885c6$export$b5d5cf8927ab7262 = v; });
var $3b671069a70885c6$export$1e511d4a378977f5;
var $3b671069a70885c6$export$b5d5cf8927ab7262;
"use strict";
$3b671069a70885c6$export$1e511d4a378977f5 = true;
$3b671069a70885c6$export$b5d5cf8927ab7262 = void 0;

var $3b671069a70885c6$var$_react = $3b671069a70885c6$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $3b671069a70885c6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3b671069a70885c6$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3b671069a70885c6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3b671069a70885c6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3b671069a70885c6$var$_extends() {
    return $3b671069a70885c6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3b671069a70885c6$var$_extends.apply(null, arguments);
}
var $3b671069a70885c6$var$Switch = $3b671069a70885c6$export$b5d5cf8927ab7262 = /*#__PURE__*/ (0, $3b671069a70885c6$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3b671069a70885c6$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3b671069a70885c6$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Switch"
    }, props), /*#__PURE__*/ $3b671069a70885c6$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 1h14v22H5V1zm2.5 10H17v10H7V11h.5zM15 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm-4 13v-5h2v5h-2zm1-13.998a1 1 0 1 0 0 2 1 1 0 0 0 0-2z",
        fill: "#000"
    }));
});
$3b671069a70885c6$var$Switch.displayName = 'Switch';


Object.keys($3b671069a70885c6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3b671069a70885c6$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3b671069a70885c6$exports[key];
});
var $de052d30655b2cbd$exports = {};

$parcel$export($de052d30655b2cbd$exports, "__esModule", function () { return $de052d30655b2cbd$export$1e511d4a378977f5; }, function (v) { return $de052d30655b2cbd$export$1e511d4a378977f5 = v; });
$parcel$export($de052d30655b2cbd$exports, "Sync", function () { return $de052d30655b2cbd$export$2ae15352e0a80063; }, function (v) { return $de052d30655b2cbd$export$2ae15352e0a80063 = v; });
var $de052d30655b2cbd$export$1e511d4a378977f5;
var $de052d30655b2cbd$export$2ae15352e0a80063;
"use strict";
$de052d30655b2cbd$export$1e511d4a378977f5 = true;
$de052d30655b2cbd$export$2ae15352e0a80063 = void 0;

var $de052d30655b2cbd$var$_react = $de052d30655b2cbd$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $de052d30655b2cbd$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($de052d30655b2cbd$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $de052d30655b2cbd$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $de052d30655b2cbd$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $de052d30655b2cbd$var$_extends() {
    return $de052d30655b2cbd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $de052d30655b2cbd$var$_extends.apply(null, arguments);
}
var $de052d30655b2cbd$var$Sync = $de052d30655b2cbd$export$2ae15352e0a80063 = /*#__PURE__*/ (0, $de052d30655b2cbd$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $de052d30655b2cbd$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $de052d30655b2cbd$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Sync"
    }, props), /*#__PURE__*/ $de052d30655b2cbd$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M5 19h11a7 7 0 0 0 7-7V9M8 15l-4 4 4 4M19 5H8a7 7 0 0 0-7 7v3M16 1l4 4-4 4"
    }));
});
$de052d30655b2cbd$var$Sync.displayName = 'Sync';


Object.keys($de052d30655b2cbd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $de052d30655b2cbd$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $de052d30655b2cbd$exports[key];
});
var $b0ea606cd241c618$exports = {};

$parcel$export($b0ea606cd241c618$exports, "__esModule", function () { return $b0ea606cd241c618$export$1e511d4a378977f5; }, function (v) { return $b0ea606cd241c618$export$1e511d4a378977f5 = v; });
$parcel$export($b0ea606cd241c618$exports, "System", function () { return $b0ea606cd241c618$export$e1dae5660003ffa7; }, function (v) { return $b0ea606cd241c618$export$e1dae5660003ffa7 = v; });
var $b0ea606cd241c618$export$1e511d4a378977f5;
var $b0ea606cd241c618$export$e1dae5660003ffa7;
"use strict";
$b0ea606cd241c618$export$1e511d4a378977f5 = true;
$b0ea606cd241c618$export$e1dae5660003ffa7 = void 0;

var $b0ea606cd241c618$var$_react = $b0ea606cd241c618$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $b0ea606cd241c618$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b0ea606cd241c618$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b0ea606cd241c618$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $b0ea606cd241c618$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b0ea606cd241c618$var$_extends() {
    return $b0ea606cd241c618$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b0ea606cd241c618$var$_extends.apply(null, arguments);
}
var $b0ea606cd241c618$var$System = $b0ea606cd241c618$export$e1dae5660003ffa7 = /*#__PURE__*/ (0, $b0ea606cd241c618$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $b0ea606cd241c618$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $b0ea606cd241c618$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "System"
    }, props), /*#__PURE__*/ $b0ea606cd241c618$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 19h22V1H1v18zm4 4h14H5zm3 0h8v-4H8v4zM7.757 5.757l2.122 2.122-2.122-2.122zM9 10H6h3zm.879 2.121-2.122 2.122 2.122-2.122zM12 13v3-3zm2.121-.879 2.122 2.122-2.122-2.122zM18 10h-3 3zm-1.757-4.243-2.122 2.122 2.122-2.122zM12 7V4v3zm0 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
    }));
});
$b0ea606cd241c618$var$System.displayName = 'System';


Object.keys($b0ea606cd241c618$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $b0ea606cd241c618$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $b0ea606cd241c618$exports[key];
});
var $8ea35b1fb283c31d$exports = {};

$parcel$export($8ea35b1fb283c31d$exports, "__esModule", function () { return $8ea35b1fb283c31d$export$1e511d4a378977f5; }, function (v) { return $8ea35b1fb283c31d$export$1e511d4a378977f5 = v; });
$parcel$export($8ea35b1fb283c31d$exports, "TableAdd", function () { return $8ea35b1fb283c31d$export$220c03c797baa05f; }, function (v) { return $8ea35b1fb283c31d$export$220c03c797baa05f = v; });
var $8ea35b1fb283c31d$export$1e511d4a378977f5;
var $8ea35b1fb283c31d$export$220c03c797baa05f;
"use strict";
$8ea35b1fb283c31d$export$1e511d4a378977f5 = true;
$8ea35b1fb283c31d$export$220c03c797baa05f = void 0;

var $8ea35b1fb283c31d$var$_react = $8ea35b1fb283c31d$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $8ea35b1fb283c31d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8ea35b1fb283c31d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8ea35b1fb283c31d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $8ea35b1fb283c31d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8ea35b1fb283c31d$var$_extends() {
    return $8ea35b1fb283c31d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8ea35b1fb283c31d$var$_extends.apply(null, arguments);
}
var $8ea35b1fb283c31d$var$TableAdd = $8ea35b1fb283c31d$export$220c03c797baa05f = /*#__PURE__*/ (0, $8ea35b1fb283c31d$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $8ea35b1fb283c31d$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $8ea35b1fb283c31d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "TableAdd"
    }, props), /*#__PURE__*/ $8ea35b1fb283c31d$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8 5v18m8-18v6M1 11h16M1 5h22M1 17h10m6 6H1V1h22v16m-6 6a6 6 0 1 0 0-12 6 6 0 0 0 0 12zm0-9v6m0-6v6m-3-3h6"
    }));
});
$8ea35b1fb283c31d$var$TableAdd.displayName = 'TableAdd';


Object.keys($8ea35b1fb283c31d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $8ea35b1fb283c31d$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $8ea35b1fb283c31d$exports[key];
});
var $1b17d44a4e60fb18$exports = {};

$parcel$export($1b17d44a4e60fb18$exports, "__esModule", function () { return $1b17d44a4e60fb18$export$1e511d4a378977f5; }, function (v) { return $1b17d44a4e60fb18$export$1e511d4a378977f5 = v; });
$parcel$export($1b17d44a4e60fb18$exports, "Table", function () { return $1b17d44a4e60fb18$export$54ec01a60f47d33d; }, function (v) { return $1b17d44a4e60fb18$export$54ec01a60f47d33d = v; });
var $1b17d44a4e60fb18$export$1e511d4a378977f5;
var $1b17d44a4e60fb18$export$54ec01a60f47d33d;
"use strict";
$1b17d44a4e60fb18$export$1e511d4a378977f5 = true;
$1b17d44a4e60fb18$export$54ec01a60f47d33d = void 0;

var $1b17d44a4e60fb18$var$_react = $1b17d44a4e60fb18$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $1b17d44a4e60fb18$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1b17d44a4e60fb18$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1b17d44a4e60fb18$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $1b17d44a4e60fb18$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1b17d44a4e60fb18$var$_extends() {
    return $1b17d44a4e60fb18$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1b17d44a4e60fb18$var$_extends.apply(null, arguments);
}
var $1b17d44a4e60fb18$var$Table = $1b17d44a4e60fb18$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $1b17d44a4e60fb18$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $1b17d44a4e60fb18$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $1b17d44a4e60fb18$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Table"
    }, props), /*#__PURE__*/ $1b17d44a4e60fb18$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8 5v18m8-18v18M1 11h22M1 5h22M1 17h22M1 1h22v22H1V1z"
    }));
});
$1b17d44a4e60fb18$var$Table.displayName = 'Table';


Object.keys($1b17d44a4e60fb18$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $1b17d44a4e60fb18$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $1b17d44a4e60fb18$exports[key];
});
var $2f4d1f02c58b6281$exports = {};

$parcel$export($2f4d1f02c58b6281$exports, "__esModule", function () { return $2f4d1f02c58b6281$export$1e511d4a378977f5; }, function (v) { return $2f4d1f02c58b6281$export$1e511d4a378977f5 = v; });
$parcel$export($2f4d1f02c58b6281$exports, "Tag", function () { return $2f4d1f02c58b6281$export$3288d34c523a1192; }, function (v) { return $2f4d1f02c58b6281$export$3288d34c523a1192 = v; });
var $2f4d1f02c58b6281$export$1e511d4a378977f5;
var $2f4d1f02c58b6281$export$3288d34c523a1192;
"use strict";
$2f4d1f02c58b6281$export$1e511d4a378977f5 = true;
$2f4d1f02c58b6281$export$3288d34c523a1192 = void 0;

var $2f4d1f02c58b6281$var$_react = $2f4d1f02c58b6281$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $2f4d1f02c58b6281$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2f4d1f02c58b6281$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2f4d1f02c58b6281$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $2f4d1f02c58b6281$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $2f4d1f02c58b6281$var$_extends() {
    return $2f4d1f02c58b6281$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2f4d1f02c58b6281$var$_extends.apply(null, arguments);
}
var $2f4d1f02c58b6281$var$Tag = $2f4d1f02c58b6281$export$3288d34c523a1192 = /*#__PURE__*/ (0, $2f4d1f02c58b6281$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $2f4d1f02c58b6281$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $2f4d1f02c58b6281$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Tag"
    }, props), /*#__PURE__*/ $2f4d1f02c58b6281$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M11.706 22.294a.992.992 0 0 1-1.41.003l-8.593-8.594a1 1 0 0 1 .003-1.409L13 1h10v10L11.706 22.294zM6 12l6 6M9 9l6 6m2-9a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
    }));
});
$2f4d1f02c58b6281$var$Tag.displayName = 'Tag';


Object.keys($2f4d1f02c58b6281$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $2f4d1f02c58b6281$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $2f4d1f02c58b6281$exports[key];
});
var $fe66cfb7374a3fd4$exports = {};

$parcel$export($fe66cfb7374a3fd4$exports, "__esModule", function () { return $fe66cfb7374a3fd4$export$1e511d4a378977f5; }, function (v) { return $fe66cfb7374a3fd4$export$1e511d4a378977f5 = v; });
$parcel$export($fe66cfb7374a3fd4$exports, "TapeOption", function () { return $fe66cfb7374a3fd4$export$6a9d31e0a40f5003; }, function (v) { return $fe66cfb7374a3fd4$export$6a9d31e0a40f5003 = v; });
var $fe66cfb7374a3fd4$export$1e511d4a378977f5;
var $fe66cfb7374a3fd4$export$6a9d31e0a40f5003;
"use strict";
$fe66cfb7374a3fd4$export$1e511d4a378977f5 = true;
$fe66cfb7374a3fd4$export$6a9d31e0a40f5003 = void 0;

var $fe66cfb7374a3fd4$var$_react = $fe66cfb7374a3fd4$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $fe66cfb7374a3fd4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($fe66cfb7374a3fd4$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $fe66cfb7374a3fd4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $fe66cfb7374a3fd4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $fe66cfb7374a3fd4$var$_extends() {
    return $fe66cfb7374a3fd4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fe66cfb7374a3fd4$var$_extends.apply(null, arguments);
}
var $fe66cfb7374a3fd4$var$TapeOption = $fe66cfb7374a3fd4$export$6a9d31e0a40f5003 = /*#__PURE__*/ (0, $fe66cfb7374a3fd4$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $fe66cfb7374a3fd4$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $fe66cfb7374a3fd4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "TapeOption"
    }, props), /*#__PURE__*/ $fe66cfb7374a3fd4$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 2h21v20H2V7m10 12a7 7 0 0 1-7-7m7 7a7 7 0 0 0 0-14H1m11 4c-1.655 0-3 1.345-3 3s1.345 3 3 3 3-1.345 3-3-1.345-3-3-3z"
    }));
});
$fe66cfb7374a3fd4$var$TapeOption.displayName = 'TapeOption';


Object.keys($fe66cfb7374a3fd4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $fe66cfb7374a3fd4$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $fe66cfb7374a3fd4$exports[key];
});
var $9d318a1774b4b352$exports = {};

$parcel$export($9d318a1774b4b352$exports, "__esModule", function () { return $9d318a1774b4b352$export$1e511d4a378977f5; }, function (v) { return $9d318a1774b4b352$export$1e511d4a378977f5 = v; });
$parcel$export($9d318a1774b4b352$exports, "Tape", function () { return $9d318a1774b4b352$export$d627a2ba003c55c9; }, function (v) { return $9d318a1774b4b352$export$d627a2ba003c55c9 = v; });
var $9d318a1774b4b352$export$1e511d4a378977f5;
var $9d318a1774b4b352$export$d627a2ba003c55c9;
"use strict";
$9d318a1774b4b352$export$1e511d4a378977f5 = true;
$9d318a1774b4b352$export$d627a2ba003c55c9 = void 0;

var $9d318a1774b4b352$var$_react = $9d318a1774b4b352$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $9d318a1774b4b352$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9d318a1774b4b352$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9d318a1774b4b352$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $9d318a1774b4b352$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $9d318a1774b4b352$var$_extends() {
    return $9d318a1774b4b352$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9d318a1774b4b352$var$_extends.apply(null, arguments);
}
var $9d318a1774b4b352$var$Tape = $9d318a1774b4b352$export$d627a2ba003c55c9 = /*#__PURE__*/ (0, $9d318a1774b4b352$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $9d318a1774b4b352$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $9d318a1774b4b352$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Tape"
    }, props), /*#__PURE__*/ $9d318a1774b4b352$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 2h20v20H2V2zm17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0zm-7-3c-1.655 0-3 1.345-3 3s1.345 3 3 3 3-1.345 3-3-1.345-3-3-3z"
    }));
});
$9d318a1774b4b352$var$Tape.displayName = 'Tape';


Object.keys($9d318a1774b4b352$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $9d318a1774b4b352$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $9d318a1774b4b352$exports[key];
});
var $bd570b9e0678da66$exports = {};

$parcel$export($bd570b9e0678da66$exports, "__esModule", function () { return $bd570b9e0678da66$export$1e511d4a378977f5; }, function (v) { return $bd570b9e0678da66$export$1e511d4a378977f5 = v; });
$parcel$export($bd570b9e0678da66$exports, "Target", function () { return $bd570b9e0678da66$export$a51f2b8e6ae258ea; }, function (v) { return $bd570b9e0678da66$export$a51f2b8e6ae258ea = v; });
var $bd570b9e0678da66$export$1e511d4a378977f5;
var $bd570b9e0678da66$export$a51f2b8e6ae258ea;
"use strict";
$bd570b9e0678da66$export$1e511d4a378977f5 = true;
$bd570b9e0678da66$export$a51f2b8e6ae258ea = void 0;

var $bd570b9e0678da66$var$_react = $bd570b9e0678da66$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $bd570b9e0678da66$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($bd570b9e0678da66$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $bd570b9e0678da66$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $bd570b9e0678da66$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $bd570b9e0678da66$var$_extends() {
    return $bd570b9e0678da66$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bd570b9e0678da66$var$_extends.apply(null, arguments);
}
var $bd570b9e0678da66$var$Target = $bd570b9e0678da66$export$a51f2b8e6ae258ea = /*#__PURE__*/ (0, $bd570b9e0678da66$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $bd570b9e0678da66$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $bd570b9e0678da66$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Target"
    }, props), /*#__PURE__*/ $bd570b9e0678da66$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11zm-5 0c0-3.309-2.691-6-6-6s-6 2.691-6 6 2.691 6 6 6 6-2.691 6-6zm-5 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0z"
    }));
});
$bd570b9e0678da66$var$Target.displayName = 'Target';


Object.keys($bd570b9e0678da66$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $bd570b9e0678da66$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $bd570b9e0678da66$exports[key];
});
var $34dbb900154ed57c$exports = {};

$parcel$export($34dbb900154ed57c$exports, "__esModule", function () { return $34dbb900154ed57c$export$1e511d4a378977f5; }, function (v) { return $34dbb900154ed57c$export$1e511d4a378977f5 = v; });
$parcel$export($34dbb900154ed57c$exports, "Task", function () { return $34dbb900154ed57c$export$2dea7024bcdd7731; }, function (v) { return $34dbb900154ed57c$export$2dea7024bcdd7731 = v; });
var $34dbb900154ed57c$export$1e511d4a378977f5;
var $34dbb900154ed57c$export$2dea7024bcdd7731;
"use strict";
$34dbb900154ed57c$export$1e511d4a378977f5 = true;
$34dbb900154ed57c$export$2dea7024bcdd7731 = void 0;

var $34dbb900154ed57c$var$_react = $34dbb900154ed57c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $34dbb900154ed57c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($34dbb900154ed57c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $34dbb900154ed57c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $34dbb900154ed57c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $34dbb900154ed57c$var$_extends() {
    return $34dbb900154ed57c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $34dbb900154ed57c$var$_extends.apply(null, arguments);
}
var $34dbb900154ed57c$var$Task = $34dbb900154ed57c$export$2dea7024bcdd7731 = /*#__PURE__*/ (0, $34dbb900154ed57c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $34dbb900154ed57c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $34dbb900154ed57c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Task"
    }, props), /*#__PURE__*/ $34dbb900154ed57c$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 20h12m-12-8h12M12 4h12M1 19l3 3 5-5m-8-6 3 3 5-5m0-8L4 6 1 3"
    }));
});
$34dbb900154ed57c$var$Task.displayName = 'Task';


Object.keys($34dbb900154ed57c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $34dbb900154ed57c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $34dbb900154ed57c$exports[key];
});
var $6a907828b5fe8f07$exports = {};

$parcel$export($6a907828b5fe8f07$exports, "__esModule", function () { return $6a907828b5fe8f07$export$1e511d4a378977f5; }, function (v) { return $6a907828b5fe8f07$export$1e511d4a378977f5 = v; });
$parcel$export($6a907828b5fe8f07$exports, "Tasks", function () { return $6a907828b5fe8f07$export$77bc526bfccc9372; }, function (v) { return $6a907828b5fe8f07$export$77bc526bfccc9372 = v; });
var $6a907828b5fe8f07$export$1e511d4a378977f5;
var $6a907828b5fe8f07$export$77bc526bfccc9372;
"use strict";
$6a907828b5fe8f07$export$1e511d4a378977f5 = true;
$6a907828b5fe8f07$export$77bc526bfccc9372 = void 0;

var $6a907828b5fe8f07$var$_react = $6a907828b5fe8f07$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $6a907828b5fe8f07$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6a907828b5fe8f07$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6a907828b5fe8f07$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6a907828b5fe8f07$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6a907828b5fe8f07$var$_extends() {
    return $6a907828b5fe8f07$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6a907828b5fe8f07$var$_extends.apply(null, arguments);
}
var $6a907828b5fe8f07$var$Tasks = $6a907828b5fe8f07$export$77bc526bfccc9372 = /*#__PURE__*/ (0, $6a907828b5fe8f07$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $6a907828b5fe8f07$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $6a907828b5fe8f07$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Tasks"
    }, props), /*#__PURE__*/ $6a907828b5fe8f07$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 3h22v4H1V3zm0 7h22v4H1v-4zm0 7h22v4H1v-4zM1 4h15v2H1V4zm0 7h5v2H1v-2zm0 7h10v2H1v-2z"
    }));
});
$6a907828b5fe8f07$var$Tasks.displayName = 'Tasks';


Object.keys($6a907828b5fe8f07$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $6a907828b5fe8f07$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $6a907828b5fe8f07$exports[key];
});
var $14d724a8b809f8a8$exports = {};

$parcel$export($14d724a8b809f8a8$exports, "__esModule", function () { return $14d724a8b809f8a8$export$1e511d4a378977f5; }, function (v) { return $14d724a8b809f8a8$export$1e511d4a378977f5 = v; });
$parcel$export($14d724a8b809f8a8$exports, "Technology", function () { return $14d724a8b809f8a8$export$90e03c3df5406970; }, function (v) { return $14d724a8b809f8a8$export$90e03c3df5406970 = v; });
var $14d724a8b809f8a8$export$1e511d4a378977f5;
var $14d724a8b809f8a8$export$90e03c3df5406970;
"use strict";
$14d724a8b809f8a8$export$1e511d4a378977f5 = true;
$14d724a8b809f8a8$export$90e03c3df5406970 = void 0;

var $14d724a8b809f8a8$var$_react = $14d724a8b809f8a8$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $14d724a8b809f8a8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($14d724a8b809f8a8$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $14d724a8b809f8a8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $14d724a8b809f8a8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $14d724a8b809f8a8$var$_extends() {
    return $14d724a8b809f8a8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $14d724a8b809f8a8$var$_extends.apply(null, arguments);
}
var $14d724a8b809f8a8$var$Technology = $14d724a8b809f8a8$export$90e03c3df5406970 = /*#__PURE__*/ (0, $14d724a8b809f8a8$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $14d724a8b809f8a8$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $14d724a8b809f8a8$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Technology"
    }, props), /*#__PURE__*/ $14d724a8b809f8a8$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M16.5 19a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM10 5l2-2m-4.5 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm.5 6 8-8M5.5 21a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm13-13a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM12 21l2-2"
    }));
});
$14d724a8b809f8a8$var$Technology.displayName = 'Technology';


Object.keys($14d724a8b809f8a8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $14d724a8b809f8a8$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $14d724a8b809f8a8$exports[key];
});
var $330fd0dd2b6df316$exports = {};

$parcel$export($330fd0dd2b6df316$exports, "__esModule", function () { return $330fd0dd2b6df316$export$1e511d4a378977f5; }, function (v) { return $330fd0dd2b6df316$export$1e511d4a378977f5 = v; });
$parcel$export($330fd0dd2b6df316$exports, "Template", function () { return $330fd0dd2b6df316$export$14416b8d99d47caa; }, function (v) { return $330fd0dd2b6df316$export$14416b8d99d47caa = v; });
var $330fd0dd2b6df316$export$1e511d4a378977f5;
var $330fd0dd2b6df316$export$14416b8d99d47caa;
"use strict";
$330fd0dd2b6df316$export$1e511d4a378977f5 = true;
$330fd0dd2b6df316$export$14416b8d99d47caa = void 0;

var $330fd0dd2b6df316$var$_react = $330fd0dd2b6df316$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $330fd0dd2b6df316$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($330fd0dd2b6df316$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $330fd0dd2b6df316$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $330fd0dd2b6df316$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $330fd0dd2b6df316$var$_extends() {
    return $330fd0dd2b6df316$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $330fd0dd2b6df316$var$_extends.apply(null, arguments);
}
var $330fd0dd2b6df316$var$Template = $330fd0dd2b6df316$export$14416b8d99d47caa = /*#__PURE__*/ (0, $330fd0dd2b6df316$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $330fd0dd2b6df316$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $330fd0dd2b6df316$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Template"
    }, props), /*#__PURE__*/ $330fd0dd2b6df316$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 3h22v18H1V3zm0 5h22M7 8v13"
    }));
});
$330fd0dd2b6df316$var$Template.displayName = 'Template';


Object.keys($330fd0dd2b6df316$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $330fd0dd2b6df316$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $330fd0dd2b6df316$exports[key];
});
var $a28989a1df5821f0$exports = {};

$parcel$export($a28989a1df5821f0$exports, "__esModule", function () { return $a28989a1df5821f0$export$1e511d4a378977f5; }, function (v) { return $a28989a1df5821f0$export$1e511d4a378977f5 = v; });
$parcel$export($a28989a1df5821f0$exports, "Terminal", function () { return $a28989a1df5821f0$export$8dd80f06eb58bfe1; }, function (v) { return $a28989a1df5821f0$export$8dd80f06eb58bfe1 = v; });
var $a28989a1df5821f0$export$1e511d4a378977f5;
var $a28989a1df5821f0$export$8dd80f06eb58bfe1;
"use strict";
$a28989a1df5821f0$export$1e511d4a378977f5 = true;
$a28989a1df5821f0$export$8dd80f06eb58bfe1 = void 0;

var $a28989a1df5821f0$var$_react = $a28989a1df5821f0$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a28989a1df5821f0$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a28989a1df5821f0$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a28989a1df5821f0$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a28989a1df5821f0$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a28989a1df5821f0$var$_extends() {
    return $a28989a1df5821f0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a28989a1df5821f0$var$_extends.apply(null, arguments);
}
var $a28989a1df5821f0$var$Terminal = $a28989a1df5821f0$export$8dd80f06eb58bfe1 = /*#__PURE__*/ (0, $a28989a1df5821f0$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a28989a1df5821f0$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a28989a1df5821f0$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Terminal"
    }, props), /*#__PURE__*/ $a28989a1df5821f0$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m2 5 6 6-6 6m7 0h14"
    }));
});
$a28989a1df5821f0$var$Terminal.displayName = 'Terminal';


Object.keys($a28989a1df5821f0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a28989a1df5821f0$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a28989a1df5821f0$exports[key];
});
var $959d2ed892e3ecfe$exports = {};

$parcel$export($959d2ed892e3ecfe$exports, "__esModule", function () { return $959d2ed892e3ecfe$export$1e511d4a378977f5; }, function (v) { return $959d2ed892e3ecfe$export$1e511d4a378977f5 = v; });
$parcel$export($959d2ed892e3ecfe$exports, "TestDesktop", function () { return $959d2ed892e3ecfe$export$d602cb31f9e4353e; }, function (v) { return $959d2ed892e3ecfe$export$d602cb31f9e4353e = v; });
var $959d2ed892e3ecfe$export$1e511d4a378977f5;
var $959d2ed892e3ecfe$export$d602cb31f9e4353e;
"use strict";
$959d2ed892e3ecfe$export$1e511d4a378977f5 = true;
$959d2ed892e3ecfe$export$d602cb31f9e4353e = void 0;

var $959d2ed892e3ecfe$var$_react = $959d2ed892e3ecfe$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $959d2ed892e3ecfe$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($959d2ed892e3ecfe$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $959d2ed892e3ecfe$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $959d2ed892e3ecfe$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $959d2ed892e3ecfe$var$_extends() {
    return $959d2ed892e3ecfe$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $959d2ed892e3ecfe$var$_extends.apply(null, arguments);
}
var $959d2ed892e3ecfe$var$TestDesktop = $959d2ed892e3ecfe$export$d602cb31f9e4353e = /*#__PURE__*/ (0, $959d2ed892e3ecfe$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $959d2ed892e3ecfe$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $959d2ed892e3ecfe$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "TestDesktop"
    }, props), /*#__PURE__*/ $959d2ed892e3ecfe$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M18.218 1H23v18H1V1h5m11 9c-4-3-6 3-10 0M5 23h14H5zm5-22v4.773l-5 7.182V15h14v-2.045l-5-7.182V1M8 1h8-8zm0 22h8v-4H8v4z"
    }));
});
$959d2ed892e3ecfe$var$TestDesktop.displayName = 'TestDesktop';


Object.keys($959d2ed892e3ecfe$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $959d2ed892e3ecfe$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $959d2ed892e3ecfe$exports[key];
});
var $d7bff94ed37179ab$exports = {};

$parcel$export($d7bff94ed37179ab$exports, "__esModule", function () { return $d7bff94ed37179ab$export$1e511d4a378977f5; }, function (v) { return $d7bff94ed37179ab$export$1e511d4a378977f5 = v; });
$parcel$export($d7bff94ed37179ab$exports, "Test", function () { return $d7bff94ed37179ab$export$1b16fc9eb974a84d; }, function (v) { return $d7bff94ed37179ab$export$1b16fc9eb974a84d = v; });
var $d7bff94ed37179ab$export$1e511d4a378977f5;
var $d7bff94ed37179ab$export$1b16fc9eb974a84d;
"use strict";
$d7bff94ed37179ab$export$1e511d4a378977f5 = true;
$d7bff94ed37179ab$export$1b16fc9eb974a84d = void 0;

var $d7bff94ed37179ab$var$_react = $d7bff94ed37179ab$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $d7bff94ed37179ab$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d7bff94ed37179ab$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d7bff94ed37179ab$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d7bff94ed37179ab$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d7bff94ed37179ab$var$_extends() {
    return $d7bff94ed37179ab$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d7bff94ed37179ab$var$_extends.apply(null, arguments);
}
var $d7bff94ed37179ab$var$Test = $d7bff94ed37179ab$export$1b16fc9eb974a84d = /*#__PURE__*/ (0, $d7bff94ed37179ab$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d7bff94ed37179ab$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $d7bff94ed37179ab$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Test"
    }, props), /*#__PURE__*/ $d7bff94ed37179ab$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M9 1v7L2 20v3h20v-3L15 8V1m0 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-6 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm9-7c-7-3-6 4-12 1M6 1h12"
    }));
});
$d7bff94ed37179ab$var$Test.displayName = 'Test';


Object.keys($d7bff94ed37179ab$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $d7bff94ed37179ab$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $d7bff94ed37179ab$exports[key];
});
var $430cddbdaeafbc47$exports = {};

$parcel$export($430cddbdaeafbc47$exports, "__esModule", function () { return $430cddbdaeafbc47$export$1e511d4a378977f5; }, function (v) { return $430cddbdaeafbc47$export$1e511d4a378977f5 = v; });
$parcel$export($430cddbdaeafbc47$exports, "TextAlignCenter", function () { return $430cddbdaeafbc47$export$947061ab5aa95bc2; }, function (v) { return $430cddbdaeafbc47$export$947061ab5aa95bc2 = v; });
var $430cddbdaeafbc47$export$1e511d4a378977f5;
var $430cddbdaeafbc47$export$947061ab5aa95bc2;
"use strict";
$430cddbdaeafbc47$export$1e511d4a378977f5 = true;
$430cddbdaeafbc47$export$947061ab5aa95bc2 = void 0;

var $430cddbdaeafbc47$var$_react = $430cddbdaeafbc47$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $430cddbdaeafbc47$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($430cddbdaeafbc47$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $430cddbdaeafbc47$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $430cddbdaeafbc47$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $430cddbdaeafbc47$var$_extends() {
    return $430cddbdaeafbc47$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $430cddbdaeafbc47$var$_extends.apply(null, arguments);
}
var $430cddbdaeafbc47$var$TextAlignCenter = $430cddbdaeafbc47$export$947061ab5aa95bc2 = /*#__PURE__*/ (0, $430cddbdaeafbc47$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $430cddbdaeafbc47$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $430cddbdaeafbc47$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "TextAlignCenter"
    }, props), /*#__PURE__*/ $430cddbdaeafbc47$var$_react["default"].createElement("path", {
        d: "M.46 3.06h23.08v2.18H.46zM4.1 8.29h15.81v2.18H4.1zM.46 13.53h23.08v2.18H.46zm3.64 5.23h15.81v2.18H4.1z"
    }));
});
$430cddbdaeafbc47$var$TextAlignCenter.displayName = 'TextAlignCenter';


Object.keys($430cddbdaeafbc47$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $430cddbdaeafbc47$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $430cddbdaeafbc47$exports[key];
});
var $c7645cb7c56b0505$exports = {};

$parcel$export($c7645cb7c56b0505$exports, "__esModule", function () { return $c7645cb7c56b0505$export$1e511d4a378977f5; }, function (v) { return $c7645cb7c56b0505$export$1e511d4a378977f5 = v; });
$parcel$export($c7645cb7c56b0505$exports, "TextAlignFull", function () { return $c7645cb7c56b0505$export$ad026ac65286c664; }, function (v) { return $c7645cb7c56b0505$export$ad026ac65286c664 = v; });
var $c7645cb7c56b0505$export$1e511d4a378977f5;
var $c7645cb7c56b0505$export$ad026ac65286c664;
"use strict";
$c7645cb7c56b0505$export$1e511d4a378977f5 = true;
$c7645cb7c56b0505$export$ad026ac65286c664 = void 0;

var $c7645cb7c56b0505$var$_react = $c7645cb7c56b0505$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c7645cb7c56b0505$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c7645cb7c56b0505$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c7645cb7c56b0505$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c7645cb7c56b0505$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c7645cb7c56b0505$var$_extends() {
    return $c7645cb7c56b0505$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c7645cb7c56b0505$var$_extends.apply(null, arguments);
}
var $c7645cb7c56b0505$var$TextAlignFull = $c7645cb7c56b0505$export$ad026ac65286c664 = /*#__PURE__*/ (0, $c7645cb7c56b0505$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c7645cb7c56b0505$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c7645cb7c56b0505$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "TextAlignFull"
    }, props), /*#__PURE__*/ $c7645cb7c56b0505$var$_react["default"].createElement("path", {
        d: "M.46 3.06h23.08v2.18H.46zm0 5.23h23.08v2.18H.46zm0 5.24h23.08v2.18H.46zm0 5.23h15.81v2.18H.46z"
    }));
});
$c7645cb7c56b0505$var$TextAlignFull.displayName = 'TextAlignFull';


Object.keys($c7645cb7c56b0505$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c7645cb7c56b0505$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c7645cb7c56b0505$exports[key];
});
var $4e349c39952553d4$exports = {};

$parcel$export($4e349c39952553d4$exports, "__esModule", function () { return $4e349c39952553d4$export$1e511d4a378977f5; }, function (v) { return $4e349c39952553d4$export$1e511d4a378977f5 = v; });
$parcel$export($4e349c39952553d4$exports, "TextAlignLeft", function () { return $4e349c39952553d4$export$6ba4cbdfb8fd88e7; }, function (v) { return $4e349c39952553d4$export$6ba4cbdfb8fd88e7 = v; });
var $4e349c39952553d4$export$1e511d4a378977f5;
var $4e349c39952553d4$export$6ba4cbdfb8fd88e7;
"use strict";
$4e349c39952553d4$export$1e511d4a378977f5 = true;
$4e349c39952553d4$export$6ba4cbdfb8fd88e7 = void 0;

var $4e349c39952553d4$var$_react = $4e349c39952553d4$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $4e349c39952553d4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4e349c39952553d4$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4e349c39952553d4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $4e349c39952553d4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $4e349c39952553d4$var$_extends() {
    return $4e349c39952553d4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4e349c39952553d4$var$_extends.apply(null, arguments);
}
var $4e349c39952553d4$var$TextAlignLeft = $4e349c39952553d4$export$6ba4cbdfb8fd88e7 = /*#__PURE__*/ (0, $4e349c39952553d4$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $4e349c39952553d4$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $4e349c39952553d4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "TextAlignLeft"
    }, props), /*#__PURE__*/ $4e349c39952553d4$var$_react["default"].createElement("path", {
        d: "M.46 3.06h23.08v2.18H.46zm0 5.23h15.81v2.18H.46zm0 5.24h23.08v2.18H.46zm0 5.23h15.81v2.18H.46z"
    }));
});
$4e349c39952553d4$var$TextAlignLeft.displayName = 'TextAlignLeft';


Object.keys($4e349c39952553d4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $4e349c39952553d4$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $4e349c39952553d4$exports[key];
});
var $7f435e39218d3ad0$exports = {};

$parcel$export($7f435e39218d3ad0$exports, "__esModule", function () { return $7f435e39218d3ad0$export$1e511d4a378977f5; }, function (v) { return $7f435e39218d3ad0$export$1e511d4a378977f5 = v; });
$parcel$export($7f435e39218d3ad0$exports, "TextAlignRight", function () { return $7f435e39218d3ad0$export$66501ddcb1b67996; }, function (v) { return $7f435e39218d3ad0$export$66501ddcb1b67996 = v; });
var $7f435e39218d3ad0$export$1e511d4a378977f5;
var $7f435e39218d3ad0$export$66501ddcb1b67996;
"use strict";
$7f435e39218d3ad0$export$1e511d4a378977f5 = true;
$7f435e39218d3ad0$export$66501ddcb1b67996 = void 0;

var $7f435e39218d3ad0$var$_react = $7f435e39218d3ad0$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $7f435e39218d3ad0$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7f435e39218d3ad0$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7f435e39218d3ad0$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $7f435e39218d3ad0$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7f435e39218d3ad0$var$_extends() {
    return $7f435e39218d3ad0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7f435e39218d3ad0$var$_extends.apply(null, arguments);
}
var $7f435e39218d3ad0$var$TextAlignRight = $7f435e39218d3ad0$export$66501ddcb1b67996 = /*#__PURE__*/ (0, $7f435e39218d3ad0$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $7f435e39218d3ad0$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $7f435e39218d3ad0$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "TextAlignRight"
    }, props), /*#__PURE__*/ $7f435e39218d3ad0$var$_react["default"].createElement("path", {
        d: "M.46 3.06h23.08v2.18H.46zm7.27 5.23h15.81v2.18H7.73zM.46 13.53h23.08v2.18H.46zm7.27 5.23h15.81v2.18H7.73z"
    }));
});
$7f435e39218d3ad0$var$TextAlignRight.displayName = 'TextAlignRight';


Object.keys($7f435e39218d3ad0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $7f435e39218d3ad0$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $7f435e39218d3ad0$exports[key];
});
var $ef07f5bb9ccb469d$exports = {};

$parcel$export($ef07f5bb9ccb469d$exports, "__esModule", function () { return $ef07f5bb9ccb469d$export$1e511d4a378977f5; }, function (v) { return $ef07f5bb9ccb469d$export$1e511d4a378977f5 = v; });
$parcel$export($ef07f5bb9ccb469d$exports, "TextWrap", function () { return $ef07f5bb9ccb469d$export$56d41d926b26924c; }, function (v) { return $ef07f5bb9ccb469d$export$56d41d926b26924c = v; });
var $ef07f5bb9ccb469d$export$1e511d4a378977f5;
var $ef07f5bb9ccb469d$export$56d41d926b26924c;
"use strict";
$ef07f5bb9ccb469d$export$1e511d4a378977f5 = true;
$ef07f5bb9ccb469d$export$56d41d926b26924c = void 0;

var $ef07f5bb9ccb469d$var$_react = $ef07f5bb9ccb469d$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $ef07f5bb9ccb469d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ef07f5bb9ccb469d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ef07f5bb9ccb469d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ef07f5bb9ccb469d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ef07f5bb9ccb469d$var$_extends() {
    return $ef07f5bb9ccb469d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ef07f5bb9ccb469d$var$_extends.apply(null, arguments);
}
var $ef07f5bb9ccb469d$var$TextWrap = $ef07f5bb9ccb469d$export$56d41d926b26924c = /*#__PURE__*/ (0, $ef07f5bb9ccb469d$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $ef07f5bb9ccb469d$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ef07f5bb9ccb469d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "TextWrap"
    }, props), /*#__PURE__*/ $ef07f5bb9ccb469d$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M17 10h7-7zM1 14h13V2H1v12zm5-8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m11 0h7-7zm0-4h7-7zm0 12h7-7zM0 18h24H0zm0 4h24H0zm14-8v-1l-4-5-3 3-1-1-4 4h12z"
    }));
});
$ef07f5bb9ccb469d$var$TextWrap.displayName = 'TextWrap';


Object.keys($ef07f5bb9ccb469d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ef07f5bb9ccb469d$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ef07f5bb9ccb469d$exports[key];
});
var $c6510cc5292326f6$exports = {};

$parcel$export($c6510cc5292326f6$exports, "__esModule", function () { return $c6510cc5292326f6$export$1e511d4a378977f5; }, function (v) { return $c6510cc5292326f6$export$1e511d4a378977f5 = v; });
$parcel$export($c6510cc5292326f6$exports, "Threads", function () { return $c6510cc5292326f6$export$78bbaacfefdb10b2; }, function (v) { return $c6510cc5292326f6$export$78bbaacfefdb10b2 = v; });
var $c6510cc5292326f6$export$1e511d4a378977f5;
var $c6510cc5292326f6$export$78bbaacfefdb10b2;
"use strict";
$c6510cc5292326f6$export$1e511d4a378977f5 = true;
$c6510cc5292326f6$export$78bbaacfefdb10b2 = void 0;

var $c6510cc5292326f6$var$_react = $c6510cc5292326f6$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c6510cc5292326f6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c6510cc5292326f6$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c6510cc5292326f6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c6510cc5292326f6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c6510cc5292326f6$var$_extends() {
    return $c6510cc5292326f6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c6510cc5292326f6$var$_extends.apply(null, arguments);
}
var $c6510cc5292326f6$var$Threads = $c6510cc5292326f6$export$78bbaacfefdb10b2 = /*#__PURE__*/ (0, $c6510cc5292326f6$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c6510cc5292326f6$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c6510cc5292326f6$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Threads"
    }, props), /*#__PURE__*/ $c6510cc5292326f6$var$_react["default"].createElement("path", {
        fill: "#000",
        d: "M18.067 11.123a8.547 8.547 0 0 0-.315-.142c-.185-3.414-2.05-5.368-5.182-5.388h-.042c-1.873 0-3.431.8-4.39 2.255L9.86 9.029c.716-1.087 1.84-1.318 2.669-1.318h.028c1.031.006 1.81.306 2.313.89.367.426.612 1.015.733 1.757a13.176 13.176 0 0 0-2.96-.143c-2.977.172-4.892 1.909-4.763 4.322.065 1.223.675 2.277 1.717 2.964.88.582 2.015.866 3.194.802 1.558-.085 2.78-.68 3.632-1.766.647-.825 1.056-1.894 1.237-3.241.742.448 1.292 1.037 1.596 1.745.516 1.205.546 3.184-1.068 4.797-1.415 1.414-3.116 2.025-5.686 2.044-2.851-.02-5.008-.935-6.41-2.717-1.313-1.67-1.991-4.08-2.016-7.165.025-3.085.703-5.496 2.016-7.165 1.402-1.782 3.558-2.696 6.41-2.717 2.871.02 5.065.94 6.521 2.73.714.879 1.252 1.983 1.607 3.27l2.018-.538c-.43-1.585-1.107-2.95-2.027-4.083C18.755 1.2 16.025.024 12.509 0h-.014c-3.51.024-6.208 1.205-8.021 3.51C2.86 5.56 2.028 8.414 2 11.992v.016c.028 3.578.86 6.431 2.474 8.482 1.813 2.305 4.511 3.486 8.02 3.51h.015c3.12-.022 5.319-.838 7.13-2.649 2.371-2.368 2.3-5.336 1.518-7.158-.56-1.307-1.629-2.368-3.09-3.07Zm-5.387 5.065c-1.305.074-2.66-.512-2.728-1.766-.05-.93.662-1.969 2.808-2.092.246-.015.487-.021.724-.021.78 0 1.508.075 2.171.22-.247 3.088-1.697 3.59-2.975 3.66Z"
    }));
});
$c6510cc5292326f6$var$Threads.displayName = 'Threads';


Object.keys($c6510cc5292326f6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c6510cc5292326f6$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c6510cc5292326f6$exports[key];
});
var $1c35bf28d27c5310$exports = {};

$parcel$export($1c35bf28d27c5310$exports, "__esModule", function () { return $1c35bf28d27c5310$export$1e511d4a378977f5; }, function (v) { return $1c35bf28d27c5310$export$1e511d4a378977f5 = v; });
$parcel$export($1c35bf28d27c5310$exports, "Threats", function () { return $1c35bf28d27c5310$export$43f6668db721fff5; }, function (v) { return $1c35bf28d27c5310$export$43f6668db721fff5 = v; });
var $1c35bf28d27c5310$export$1e511d4a378977f5;
var $1c35bf28d27c5310$export$43f6668db721fff5;
"use strict";
$1c35bf28d27c5310$export$1e511d4a378977f5 = true;
$1c35bf28d27c5310$export$43f6668db721fff5 = void 0;

var $1c35bf28d27c5310$var$_react = $1c35bf28d27c5310$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $1c35bf28d27c5310$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1c35bf28d27c5310$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1c35bf28d27c5310$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $1c35bf28d27c5310$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1c35bf28d27c5310$var$_extends() {
    return $1c35bf28d27c5310$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1c35bf28d27c5310$var$_extends.apply(null, arguments);
}
var $1c35bf28d27c5310$var$Threats = $1c35bf28d27c5310$export$43f6668db721fff5 = /*#__PURE__*/ (0, $1c35bf28d27c5310$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $1c35bf28d27c5310$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $1c35bf28d27c5310$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Threats"
    }, props), /*#__PURE__*/ $1c35bf28d27c5310$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M9 23A7 7 0 1 0 9 9a7 7 0 0 0 0 14zM9 6V5c0-3 2-4 4-4s4 1 4 4v3c0 1 0 3 2 3s2-2 2-3c0-2 1-2 2-2m-11 7-6 6m0-6 6 6m-6-9V6h6v4"
    }));
});
$1c35bf28d27c5310$var$Threats.displayName = 'Threats';


Object.keys($1c35bf28d27c5310$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $1c35bf28d27c5310$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $1c35bf28d27c5310$exports[key];
});
var $76f2fec4a3276dd7$exports = {};

$parcel$export($76f2fec4a3276dd7$exports, "__esModule", function () { return $76f2fec4a3276dd7$export$1e511d4a378977f5; }, function (v) { return $76f2fec4a3276dd7$export$1e511d4a378977f5 = v; });
$parcel$export($76f2fec4a3276dd7$exports, "ThreeDffects", function () { return $76f2fec4a3276dd7$export$4e1dc72a537ab691; }, function (v) { return $76f2fec4a3276dd7$export$4e1dc72a537ab691 = v; });
var $76f2fec4a3276dd7$export$1e511d4a378977f5;
var $76f2fec4a3276dd7$export$4e1dc72a537ab691;
"use strict";
$76f2fec4a3276dd7$export$1e511d4a378977f5 = true;
$76f2fec4a3276dd7$export$4e1dc72a537ab691 = void 0;

var $76f2fec4a3276dd7$var$_react = $76f2fec4a3276dd7$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $76f2fec4a3276dd7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($76f2fec4a3276dd7$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $76f2fec4a3276dd7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $76f2fec4a3276dd7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $76f2fec4a3276dd7$var$_extends() {
    return $76f2fec4a3276dd7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $76f2fec4a3276dd7$var$_extends.apply(null, arguments);
}
var $76f2fec4a3276dd7$var$ThreeDffects = $76f2fec4a3276dd7$export$4e1dc72a537ab691 = /*#__PURE__*/ (0, $76f2fec4a3276dd7$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $76f2fec4a3276dd7$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $76f2fec4a3276dd7$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ThreeDffects"
    }, props), /*#__PURE__*/ $76f2fec4a3276dd7$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M11 3h2l9 3v11l-10 3.5L2 17V6.5L4 6l9 2.5-2 .5-9-2.5"
    }));
});
$76f2fec4a3276dd7$var$ThreeDffects.displayName = 'ThreeDffects';


Object.keys($76f2fec4a3276dd7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $76f2fec4a3276dd7$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $76f2fec4a3276dd7$exports[key];
});
var $f83cad4939716b04$exports = {};

$parcel$export($f83cad4939716b04$exports, "__esModule", function () { return $f83cad4939716b04$export$1e511d4a378977f5; }, function (v) { return $f83cad4939716b04$export$1e511d4a378977f5 = v; });
$parcel$export($f83cad4939716b04$exports, "ThreeD", function () { return $f83cad4939716b04$export$4a83dae52091ab63; }, function (v) { return $f83cad4939716b04$export$4a83dae52091ab63 = v; });
var $f83cad4939716b04$export$1e511d4a378977f5;
var $f83cad4939716b04$export$4a83dae52091ab63;
"use strict";
$f83cad4939716b04$export$1e511d4a378977f5 = true;
$f83cad4939716b04$export$4a83dae52091ab63 = void 0;

var $f83cad4939716b04$var$_react = $f83cad4939716b04$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f83cad4939716b04$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f83cad4939716b04$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f83cad4939716b04$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f83cad4939716b04$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f83cad4939716b04$var$_extends() {
    return $f83cad4939716b04$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f83cad4939716b04$var$_extends.apply(null, arguments);
}
var $f83cad4939716b04$var$ThreeD = $f83cad4939716b04$export$4a83dae52091ab63 = /*#__PURE__*/ (0, $f83cad4939716b04$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f83cad4939716b04$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f83cad4939716b04$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ThreeD"
    }, props), /*#__PURE__*/ $f83cad4939716b04$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 5.5v13l10 4 10-4v-13l-10-4-10 4zM13 12h5v5M2 5.5l10 4 10-4M6 14s6 6.5 12-2"
    }));
});
$f83cad4939716b04$var$ThreeD.displayName = 'ThreeD';


Object.keys($f83cad4939716b04$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f83cad4939716b04$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f83cad4939716b04$exports[key];
});
var $c3f724a141805aca$exports = {};

$parcel$export($c3f724a141805aca$exports, "__esModule", function () { return $c3f724a141805aca$export$1e511d4a378977f5; }, function (v) { return $c3f724a141805aca$export$1e511d4a378977f5 = v; });
$parcel$export($c3f724a141805aca$exports, "Ticket", function () { return $c3f724a141805aca$export$ed207b05bbcf0a37; }, function (v) { return $c3f724a141805aca$export$ed207b05bbcf0a37 = v; });
var $c3f724a141805aca$export$1e511d4a378977f5;
var $c3f724a141805aca$export$ed207b05bbcf0a37;
"use strict";
$c3f724a141805aca$export$1e511d4a378977f5 = true;
$c3f724a141805aca$export$ed207b05bbcf0a37 = void 0;

var $c3f724a141805aca$var$_react = $c3f724a141805aca$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c3f724a141805aca$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c3f724a141805aca$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c3f724a141805aca$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c3f724a141805aca$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c3f724a141805aca$var$_extends() {
    return $c3f724a141805aca$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c3f724a141805aca$var$_extends.apply(null, arguments);
}
var $c3f724a141805aca$var$Ticket = $c3f724a141805aca$export$ed207b05bbcf0a37 = /*#__PURE__*/ (0, $c3f724a141805aca$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c3f724a141805aca$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c3f724a141805aca$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Ticket"
    }, props), /*#__PURE__*/ $c3f724a141805aca$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M7 16h10V8H7v8zm13-4c0 2 1 3 3 3v5H1v-5c2 0 3-1 3-3S3 9 1 9V4h22v5c-2 0-3 1-3 3z"
    }));
});
$c3f724a141805aca$var$Ticket.displayName = 'Ticket';


Object.keys($c3f724a141805aca$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c3f724a141805aca$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c3f724a141805aca$exports[key];
});
var $f74bf57d25bb35bd$exports = {};

$parcel$export($f74bf57d25bb35bd$exports, "__esModule", function () { return $f74bf57d25bb35bd$export$1e511d4a378977f5; }, function (v) { return $f74bf57d25bb35bd$export$1e511d4a378977f5 = v; });
$parcel$export($f74bf57d25bb35bd$exports, "Tiktok", function () { return $f74bf57d25bb35bd$export$9022d18fa8b96971; }, function (v) { return $f74bf57d25bb35bd$export$9022d18fa8b96971 = v; });
var $f74bf57d25bb35bd$export$1e511d4a378977f5;
var $f74bf57d25bb35bd$export$9022d18fa8b96971;
"use strict";
$f74bf57d25bb35bd$export$1e511d4a378977f5 = true;
$f74bf57d25bb35bd$export$9022d18fa8b96971 = void 0;

var $f74bf57d25bb35bd$var$_react = $f74bf57d25bb35bd$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f74bf57d25bb35bd$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f74bf57d25bb35bd$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f74bf57d25bb35bd$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f74bf57d25bb35bd$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f74bf57d25bb35bd$var$_extends() {
    return $f74bf57d25bb35bd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f74bf57d25bb35bd$var$_extends.apply(null, arguments);
}
var $f74bf57d25bb35bd$var$Tiktok = $f74bf57d25bb35bd$export$9022d18fa8b96971 = /*#__PURE__*/ (0, $f74bf57d25bb35bd$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f74bf57d25bb35bd$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f74bf57d25bb35bd$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Tiktok"
    }, props), /*#__PURE__*/ $f74bf57d25bb35bd$var$_react["default"].createElement("path", {
        fill: "#FF004F",
        d: "M22.459 6.846v3.659c-.197 0-.433.04-.669.04a7.295 7.295 0 0 1-4.682-1.732v7.79a6.987 6.987 0 0 1-1.416 4.25 7.02 7.02 0 0 1-5.626 2.832 6.993 6.993 0 0 1-5.941-3.305c1.259 1.18 2.95 1.928 4.8 1.928a6.893 6.893 0 0 0 5.586-2.833c.866-1.18 1.417-2.636 1.417-4.249v-7.83c1.259 1.102 2.872 1.732 4.682 1.732.236 0 .433 0 .669-.04v-2.36c.354.079.669.118 1.023.118h.157z"
    }), /*#__PURE__*/ $f74bf57d25bb35bd$var$_react["default"].createElement("path", {
        fill: "#FF004F",
        d: "M11.05 9.56v4.053a3.277 3.277 0 0 0-.866-.118c-1.732 0-3.148 1.456-3.148 3.226 0 .394.079.748.197 1.102-.787-.59-1.338-1.535-1.338-2.597 0-1.77 1.416-3.226 3.148-3.226.314 0 .59.04.865.118V9.521h.236c.315 0 .63 0 .905.04zm6.648-5.626c-.708-.63-1.22-1.495-1.495-2.4h.945v.551a6.25 6.25 0 0 0 .55 1.85z"
    }), /*#__PURE__*/ $f74bf57d25bb35bd$var$_react["default"].createElement("path", {
        fill: "#000",
        d: "M21.318 6.767v2.36c-.197.04-.433.04-.669.04a7.295 7.295 0 0 1-4.682-1.73v7.79a6.987 6.987 0 0 1-1.416 4.248c-1.299 1.732-3.305 2.833-5.587 2.833-1.85 0-3.541-.747-4.8-1.928a7.136 7.136 0 0 1-1.062-3.737c0-3.817 3.03-6.925 6.806-7.043v2.597a3.277 3.277 0 0 0-.865-.118c-1.732 0-3.148 1.455-3.148 3.226 0 1.062.512 2.046 1.338 2.597.433 1.22 1.613 2.124 2.95 2.124 1.732 0 3.148-1.456 3.148-3.226V1.534h2.872c.276.945.787 1.77 1.495 2.4a5.397 5.397 0 0 0 3.62 2.833z"
    }), /*#__PURE__*/ $f74bf57d25bb35bd$var$_react["default"].createElement("g", {
        fill: "#00F7EF"
    }, /*#__PURE__*/ $f74bf57d25bb35bd$var$_react["default"].createElement("path", {
        d: "M9.908 8.184V9.52c-3.777.118-6.806 3.226-6.806 7.043 0 1.377.393 2.636 1.062 3.738A7.122 7.122 0 0 1 2 15.148c0-3.896 3.148-7.043 7.003-7.043.315 0 .63.04.905.079z"
    }), /*#__PURE__*/ $f74bf57d25bb35bd$var$_react["default"].createElement("path", {
        d: "M16.203 1.534h-2.872v15.187c0 1.77-1.416 3.227-3.147 3.227-1.377 0-2.518-.866-2.951-2.125.511.354 1.14.59 1.81.59 1.73 0 3.147-1.416 3.147-3.187V0h3.817v.079c0 .157 0 .314.039.472 0 .315.079.669.157.983zm5.115 3.777v1.417c-1.574-.315-2.911-1.377-3.659-2.794a5.11 5.11 0 0 0 3.659 1.377z"
    })));
});
$f74bf57d25bb35bd$var$Tiktok.displayName = 'Tiktok';


$90f36abf4e65ffb7$exports.Tictok = $f74bf57d25bb35bd$exports.Tiktok;
Object.keys($f74bf57d25bb35bd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f74bf57d25bb35bd$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f74bf57d25bb35bd$exports[key];
});
var $582eba7a5bb19f55$exports = {};

$parcel$export($582eba7a5bb19f55$exports, "__esModule", function () { return $582eba7a5bb19f55$export$1e511d4a378977f5; }, function (v) { return $582eba7a5bb19f55$export$1e511d4a378977f5 = v; });
$parcel$export($582eba7a5bb19f55$exports, "Time", function () { return $582eba7a5bb19f55$export$680ea196effce5f; }, function (v) { return $582eba7a5bb19f55$export$680ea196effce5f = v; });
var $582eba7a5bb19f55$export$1e511d4a378977f5;
var $582eba7a5bb19f55$export$680ea196effce5f;
"use strict";
$582eba7a5bb19f55$export$1e511d4a378977f5 = true;
$582eba7a5bb19f55$export$680ea196effce5f = void 0;

var $582eba7a5bb19f55$var$_react = $582eba7a5bb19f55$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $582eba7a5bb19f55$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($582eba7a5bb19f55$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $582eba7a5bb19f55$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $582eba7a5bb19f55$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $582eba7a5bb19f55$var$_extends() {
    return $582eba7a5bb19f55$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $582eba7a5bb19f55$var$_extends.apply(null, arguments);
}
var $582eba7a5bb19f55$var$Time = $582eba7a5bb19f55$export$680ea196effce5f = /*#__PURE__*/ (0, $582eba7a5bb19f55$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $582eba7a5bb19f55$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $582eba7a5bb19f55$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Time"
    }, props), /*#__PURE__*/ $582eba7a5bb19f55$var$_react["default"].createElement("path", {
        d: "M1 13h4l2.5-9 5 16.5L17 9l2 4h4",
        stroke: "#000",
        strokeWidth: "2",
        fill: "none"
    }));
});
$582eba7a5bb19f55$var$Time.displayName = 'Time';


Object.keys($582eba7a5bb19f55$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $582eba7a5bb19f55$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $582eba7a5bb19f55$exports[key];
});
var $512b628d7d43b56b$exports = {};

$parcel$export($512b628d7d43b56b$exports, "__esModule", function () { return $512b628d7d43b56b$export$1e511d4a378977f5; }, function (v) { return $512b628d7d43b56b$export$1e511d4a378977f5 = v; });
$parcel$export($512b628d7d43b56b$exports, "Tip", function () { return $512b628d7d43b56b$export$c92c6401b52a9298; }, function (v) { return $512b628d7d43b56b$export$c92c6401b52a9298 = v; });
var $512b628d7d43b56b$export$1e511d4a378977f5;
var $512b628d7d43b56b$export$c92c6401b52a9298;
"use strict";
$512b628d7d43b56b$export$1e511d4a378977f5 = true;
$512b628d7d43b56b$export$c92c6401b52a9298 = void 0;

var $512b628d7d43b56b$var$_react = $512b628d7d43b56b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $512b628d7d43b56b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($512b628d7d43b56b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $512b628d7d43b56b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $512b628d7d43b56b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $512b628d7d43b56b$var$_extends() {
    return $512b628d7d43b56b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $512b628d7d43b56b$var$_extends.apply(null, arguments);
}
var $512b628d7d43b56b$var$Tip = $512b628d7d43b56b$export$c92c6401b52a9298 = /*#__PURE__*/ (0, $512b628d7d43b56b$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $512b628d7d43b56b$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $512b628d7d43b56b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Tip"
    }, props), /*#__PURE__*/ $512b628d7d43b56b$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M16.007 18H22V2H2v16h6.243l3.882 4 3.882-4z"
    }));
});
$512b628d7d43b56b$var$Tip.displayName = 'Tip';


Object.keys($512b628d7d43b56b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $512b628d7d43b56b$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $512b628d7d43b56b$exports[key];
});
var $9777b2861fb55c6d$exports = {};

$parcel$export($9777b2861fb55c6d$exports, "__esModule", function () { return $9777b2861fb55c6d$export$1e511d4a378977f5; }, function (v) { return $9777b2861fb55c6d$export$1e511d4a378977f5 = v; });
$parcel$export($9777b2861fb55c6d$exports, "Toast", function () { return $9777b2861fb55c6d$export$8d8dc7d5f743331b; }, function (v) { return $9777b2861fb55c6d$export$8d8dc7d5f743331b = v; });
var $9777b2861fb55c6d$export$1e511d4a378977f5;
var $9777b2861fb55c6d$export$8d8dc7d5f743331b;
"use strict";
$9777b2861fb55c6d$export$1e511d4a378977f5 = true;
$9777b2861fb55c6d$export$8d8dc7d5f743331b = void 0;

var $9777b2861fb55c6d$var$_react = $9777b2861fb55c6d$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $9777b2861fb55c6d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9777b2861fb55c6d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9777b2861fb55c6d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $9777b2861fb55c6d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $9777b2861fb55c6d$var$_extends() {
    return $9777b2861fb55c6d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9777b2861fb55c6d$var$_extends.apply(null, arguments);
}
var $9777b2861fb55c6d$var$Toast = $9777b2861fb55c6d$export$8d8dc7d5f743331b = /*#__PURE__*/ (0, $9777b2861fb55c6d$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $9777b2861fb55c6d$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $9777b2861fb55c6d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Toast"
    }, props), /*#__PURE__*/ $9777b2861fb55c6d$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8 2a4 4 0 0 0-2 7.465V16h12V9.465A4 4 0 0 0 16 2H8zm3.321 4.874a1.004 1.004 0 0 1 1.38-.37l1.715.991c.483.279.652.889.37 1.38l-.991 1.715a1.004 1.004 0 0 1-1.38.37L10.7 9.968a1.004 1.004 0 0 1-.37-1.379l.991-1.716zM8 18v2m4-2v5m4-5v3"
    }));
});
$9777b2861fb55c6d$var$Toast.displayName = 'Toast';


Object.keys($9777b2861fb55c6d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $9777b2861fb55c6d$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $9777b2861fb55c6d$exports[key];
});
var $a80a71148c98f65f$exports = {};

$parcel$export($a80a71148c98f65f$exports, "__esModule", function () { return $a80a71148c98f65f$export$1e511d4a378977f5; }, function (v) { return $a80a71148c98f65f$export$1e511d4a378977f5 = v; });
$parcel$export($a80a71148c98f65f$exports, "Tools", function () { return $a80a71148c98f65f$export$390d11d353c16e49; }, function (v) { return $a80a71148c98f65f$export$390d11d353c16e49 = v; });
var $a80a71148c98f65f$export$1e511d4a378977f5;
var $a80a71148c98f65f$export$390d11d353c16e49;
"use strict";
$a80a71148c98f65f$export$1e511d4a378977f5 = true;
$a80a71148c98f65f$export$390d11d353c16e49 = void 0;

var $a80a71148c98f65f$var$_react = $a80a71148c98f65f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a80a71148c98f65f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a80a71148c98f65f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a80a71148c98f65f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a80a71148c98f65f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a80a71148c98f65f$var$_extends() {
    return $a80a71148c98f65f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a80a71148c98f65f$var$_extends.apply(null, arguments);
}
var $a80a71148c98f65f$var$Tools = $a80a71148c98f65f$export$390d11d353c16e49 = /*#__PURE__*/ (0, $a80a71148c98f65f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a80a71148c98f65f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a80a71148c98f65f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Tools"
    }, props), /*#__PURE__*/ $a80a71148c98f65f$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m11 2 11 11-4.5 4.5-11-11L11 2zm5 4 1-1 2 2-1 1m-5 5-9 9-2-2 9-9m-6 7 1 1"
    }));
});
$a80a71148c98f65f$var$Tools.displayName = 'Tools';


Object.keys($a80a71148c98f65f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a80a71148c98f65f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a80a71148c98f65f$exports[key];
});
var $1700c2a8489092be$exports = {};

$parcel$export($1700c2a8489092be$exports, "__esModule", function () { return $1700c2a8489092be$export$1e511d4a378977f5; }, function (v) { return $1700c2a8489092be$export$1e511d4a378977f5 = v; });
$parcel$export($1700c2a8489092be$exports, "Tooltip", function () { return $1700c2a8489092be$export$28c660c63b792dea; }, function (v) { return $1700c2a8489092be$export$28c660c63b792dea = v; });
var $1700c2a8489092be$export$1e511d4a378977f5;
var $1700c2a8489092be$export$28c660c63b792dea;
"use strict";
$1700c2a8489092be$export$1e511d4a378977f5 = true;
$1700c2a8489092be$export$28c660c63b792dea = void 0;

var $1700c2a8489092be$var$_react = $1700c2a8489092be$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $1700c2a8489092be$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1700c2a8489092be$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1700c2a8489092be$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $1700c2a8489092be$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1700c2a8489092be$var$_extends() {
    return $1700c2a8489092be$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1700c2a8489092be$var$_extends.apply(null, arguments);
}
var $1700c2a8489092be$var$Tooltip = $1700c2a8489092be$export$28c660c63b792dea = /*#__PURE__*/ (0, $1700c2a8489092be$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $1700c2a8489092be$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $1700c2a8489092be$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Tooltip"
    }, props), /*#__PURE__*/ $1700c2a8489092be$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M16.5 18 12 22.5 7.5 18H1V1h22v17h-6.5zM6 10h1V9H6v1zm5.5 0h1V9h-1v1zm5.5 0h1V9h-1v1z"
    }));
});
$1700c2a8489092be$var$Tooltip.displayName = 'Tooltip';


Object.keys($1700c2a8489092be$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $1700c2a8489092be$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $1700c2a8489092be$exports[key];
});
var $1caec0da8de27145$exports = {};

$parcel$export($1caec0da8de27145$exports, "__esModule", function () { return $1caec0da8de27145$export$1e511d4a378977f5; }, function (v) { return $1caec0da8de27145$export$1e511d4a378977f5 = v; });
$parcel$export($1caec0da8de27145$exports, "TopCorner", function () { return $1caec0da8de27145$export$73e552d483b124d5; }, function (v) { return $1caec0da8de27145$export$73e552d483b124d5 = v; });
var $1caec0da8de27145$export$1e511d4a378977f5;
var $1caec0da8de27145$export$73e552d483b124d5;
"use strict";
$1caec0da8de27145$export$1e511d4a378977f5 = true;
$1caec0da8de27145$export$73e552d483b124d5 = void 0;

var $1caec0da8de27145$var$_react = $1caec0da8de27145$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $1caec0da8de27145$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1caec0da8de27145$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1caec0da8de27145$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $1caec0da8de27145$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1caec0da8de27145$var$_extends() {
    return $1caec0da8de27145$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1caec0da8de27145$var$_extends.apply(null, arguments);
}
var $1caec0da8de27145$var$TopCorner = $1caec0da8de27145$export$73e552d483b124d5 = /*#__PURE__*/ (0, $1caec0da8de27145$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $1caec0da8de27145$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $1caec0da8de27145$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "TopCorner"
    }, props), /*#__PURE__*/ $1caec0da8de27145$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M16 4H4v12"
    }));
});
$1caec0da8de27145$var$TopCorner.displayName = 'TopCorner';


Object.keys($1caec0da8de27145$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $1caec0da8de27145$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $1caec0da8de27145$exports[key];
});
var $8fec983af946ae29$exports = {};

$parcel$export($8fec983af946ae29$exports, "__esModule", function () { return $8fec983af946ae29$export$1e511d4a378977f5; }, function (v) { return $8fec983af946ae29$export$1e511d4a378977f5 = v; });
$parcel$export($8fec983af946ae29$exports, "Train", function () { return $8fec983af946ae29$export$ea17a89aebb487cc; }, function (v) { return $8fec983af946ae29$export$ea17a89aebb487cc = v; });
var $8fec983af946ae29$export$1e511d4a378977f5;
var $8fec983af946ae29$export$ea17a89aebb487cc;
"use strict";
$8fec983af946ae29$export$1e511d4a378977f5 = true;
$8fec983af946ae29$export$ea17a89aebb487cc = void 0;

var $8fec983af946ae29$var$_react = $8fec983af946ae29$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $8fec983af946ae29$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8fec983af946ae29$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8fec983af946ae29$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $8fec983af946ae29$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8fec983af946ae29$var$_extends() {
    return $8fec983af946ae29$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8fec983af946ae29$var$_extends.apply(null, arguments);
}
var $8fec983af946ae29$var$Train = $8fec983af946ae29$export$ea17a89aebb487cc = /*#__PURE__*/ (0, $8fec983af946ae29$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $8fec983af946ae29$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $8fec983af946ae29$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Train"
    }, props), /*#__PURE__*/ $8fec983af946ae29$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M5 1h14a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm4 1h6M3 5h18M4 23h16M3 12h18M7 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM12 5v7m-3 8-2 3m8-3 2 3"
    }));
});
$8fec983af946ae29$var$Train.displayName = 'Train';


Object.keys($8fec983af946ae29$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $8fec983af946ae29$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $8fec983af946ae29$exports[key];
});
var $597236e819a1e171$exports = {};

$parcel$export($597236e819a1e171$exports, "__esModule", function () { return $597236e819a1e171$export$1e511d4a378977f5; }, function (v) { return $597236e819a1e171$export$1e511d4a378977f5 = v; });
$parcel$export($597236e819a1e171$exports, "Transaction", function () { return $597236e819a1e171$export$febc5573c75cefb0; }, function (v) { return $597236e819a1e171$export$febc5573c75cefb0 = v; });
var $597236e819a1e171$export$1e511d4a378977f5;
var $597236e819a1e171$export$febc5573c75cefb0;
"use strict";
$597236e819a1e171$export$1e511d4a378977f5 = true;
$597236e819a1e171$export$febc5573c75cefb0 = void 0;

var $597236e819a1e171$var$_react = $597236e819a1e171$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $597236e819a1e171$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($597236e819a1e171$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $597236e819a1e171$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $597236e819a1e171$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $597236e819a1e171$var$_extends() {
    return $597236e819a1e171$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $597236e819a1e171$var$_extends.apply(null, arguments);
}
var $597236e819a1e171$var$Transaction = $597236e819a1e171$export$febc5573c75cefb0 = /*#__PURE__*/ (0, $597236e819a1e171$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $597236e819a1e171$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $597236e819a1e171$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Transaction"
    }, props), /*#__PURE__*/ $597236e819a1e171$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 7h18m-4-5 5 5-5 5m6 5H4m4-5-5 5 5 5"
    }));
});
$597236e819a1e171$var$Transaction.displayName = 'Transaction';


Object.keys($597236e819a1e171$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $597236e819a1e171$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $597236e819a1e171$exports[key];
});
var $a30fcfaed5be1317$exports = {};

$parcel$export($a30fcfaed5be1317$exports, "__esModule", function () { return $a30fcfaed5be1317$export$1e511d4a378977f5; }, function (v) { return $a30fcfaed5be1317$export$1e511d4a378977f5 = v; });
$parcel$export($a30fcfaed5be1317$exports, "Trash", function () { return $a30fcfaed5be1317$export$99442c433de1441d; }, function (v) { return $a30fcfaed5be1317$export$99442c433de1441d = v; });
var $a30fcfaed5be1317$export$1e511d4a378977f5;
var $a30fcfaed5be1317$export$99442c433de1441d;
"use strict";
$a30fcfaed5be1317$export$1e511d4a378977f5 = true;
$a30fcfaed5be1317$export$99442c433de1441d = void 0;

var $a30fcfaed5be1317$var$_react = $a30fcfaed5be1317$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a30fcfaed5be1317$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a30fcfaed5be1317$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a30fcfaed5be1317$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a30fcfaed5be1317$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a30fcfaed5be1317$var$_extends() {
    return $a30fcfaed5be1317$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a30fcfaed5be1317$var$_extends.apply(null, arguments);
}
var $a30fcfaed5be1317$var$Trash = $a30fcfaed5be1317$export$99442c433de1441d = /*#__PURE__*/ (0, $a30fcfaed5be1317$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a30fcfaed5be1317$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a30fcfaed5be1317$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Trash"
    }, props), /*#__PURE__*/ $a30fcfaed5be1317$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4 5h16v18H4V5zM1 5h22M9 1h6v4H9V1zm0 0h6v4H9V1zm6 8v10M9 9v10"
    }));
});
$a30fcfaed5be1317$var$Trash.displayName = 'Trash';


Object.keys($a30fcfaed5be1317$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a30fcfaed5be1317$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a30fcfaed5be1317$exports[key];
});
var $2f218926754f819b$exports = {};

$parcel$export($2f218926754f819b$exports, "__esModule", function () { return $2f218926754f819b$export$1e511d4a378977f5; }, function (v) { return $2f218926754f819b$export$1e511d4a378977f5 = v; });
$parcel$export($2f218926754f819b$exports, "TreeOption", function () { return $2f218926754f819b$export$42b468c5d8539c66; }, function (v) { return $2f218926754f819b$export$42b468c5d8539c66 = v; });
var $2f218926754f819b$export$1e511d4a378977f5;
var $2f218926754f819b$export$42b468c5d8539c66;
"use strict";
$2f218926754f819b$export$1e511d4a378977f5 = true;
$2f218926754f819b$export$42b468c5d8539c66 = void 0;

var $2f218926754f819b$var$_react = $2f218926754f819b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $2f218926754f819b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2f218926754f819b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2f218926754f819b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $2f218926754f819b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $2f218926754f819b$var$_extends() {
    return $2f218926754f819b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2f218926754f819b$var$_extends.apply(null, arguments);
}
var $2f218926754f819b$var$TreeOption = $2f218926754f819b$export$42b468c5d8539c66 = /*#__PURE__*/ (0, $2f218926754f819b$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $2f218926754f819b$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $2f218926754f819b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "TreeOption"
    }, props), /*#__PURE__*/ $2f218926754f819b$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m7 13 4.375-7H9l3-4 3 4h-2.375L17 13h-2l4 6.667H5L9 13H7zm5 11v-4"
    }));
});
$2f218926754f819b$var$TreeOption.displayName = 'TreeOption';


Object.keys($2f218926754f819b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $2f218926754f819b$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $2f218926754f819b$exports[key];
});
var $3407a8c74bb8271b$exports = {};

$parcel$export($3407a8c74bb8271b$exports, "__esModule", function () { return $3407a8c74bb8271b$export$1e511d4a378977f5; }, function (v) { return $3407a8c74bb8271b$export$1e511d4a378977f5 = v; });
$parcel$export($3407a8c74bb8271b$exports, "Tree", function () { return $3407a8c74bb8271b$export$7fbedc92909ed28e; }, function (v) { return $3407a8c74bb8271b$export$7fbedc92909ed28e = v; });
var $3407a8c74bb8271b$export$1e511d4a378977f5;
var $3407a8c74bb8271b$export$7fbedc92909ed28e;
"use strict";
$3407a8c74bb8271b$export$1e511d4a378977f5 = true;
$3407a8c74bb8271b$export$7fbedc92909ed28e = void 0;

var $3407a8c74bb8271b$var$_react = $3407a8c74bb8271b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $3407a8c74bb8271b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3407a8c74bb8271b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3407a8c74bb8271b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3407a8c74bb8271b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3407a8c74bb8271b$var$_extends() {
    return $3407a8c74bb8271b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3407a8c74bb8271b$var$_extends.apply(null, arguments);
}
var $3407a8c74bb8271b$var$Tree = $3407a8c74bb8271b$export$7fbedc92909ed28e = /*#__PURE__*/ (0, $3407a8c74bb8271b$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3407a8c74bb8271b$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3407a8c74bb8271b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Tree"
    }, props), /*#__PURE__*/ $3407a8c74bb8271b$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4 1h6v6H4V1zm12 10h4v4h-4v-4zm0 8h4v4h-4v-4zM7 7v14h9m-9-8h9"
    }));
});
$3407a8c74bb8271b$var$Tree.displayName = 'Tree';


Object.keys($3407a8c74bb8271b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3407a8c74bb8271b$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3407a8c74bb8271b$exports[key];
});
var $54d206aa3a314ac4$exports = {};

$parcel$export($54d206aa3a314ac4$exports, "__esModule", function () { return $54d206aa3a314ac4$export$1e511d4a378977f5; }, function (v) { return $54d206aa3a314ac4$export$1e511d4a378977f5 = v; });
$parcel$export($54d206aa3a314ac4$exports, "Trigger", function () { return $54d206aa3a314ac4$export$41fb9f06171c75f4; }, function (v) { return $54d206aa3a314ac4$export$41fb9f06171c75f4 = v; });
var $54d206aa3a314ac4$export$1e511d4a378977f5;
var $54d206aa3a314ac4$export$41fb9f06171c75f4;
"use strict";
$54d206aa3a314ac4$export$1e511d4a378977f5 = true;
$54d206aa3a314ac4$export$41fb9f06171c75f4 = void 0;

var $54d206aa3a314ac4$var$_react = $54d206aa3a314ac4$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $54d206aa3a314ac4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($54d206aa3a314ac4$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $54d206aa3a314ac4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $54d206aa3a314ac4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $54d206aa3a314ac4$var$_extends() {
    return $54d206aa3a314ac4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $54d206aa3a314ac4$var$_extends.apply(null, arguments);
}
var $54d206aa3a314ac4$var$Trigger = $54d206aa3a314ac4$export$41fb9f06171c75f4 = /*#__PURE__*/ (0, $54d206aa3a314ac4$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $54d206aa3a314ac4$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $54d206aa3a314ac4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Trigger"
    }, props), /*#__PURE__*/ $54d206aa3a314ac4$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4 14h6l-3 9h2L20 9h-6l4-8H7z"
    }));
});
$54d206aa3a314ac4$var$Trigger.displayName = 'Trigger';


Object.keys($54d206aa3a314ac4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $54d206aa3a314ac4$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $54d206aa3a314ac4$exports[key];
});
var $5d981a12faa6c72d$exports = {};

$parcel$export($5d981a12faa6c72d$exports, "__esModule", function () { return $5d981a12faa6c72d$export$1e511d4a378977f5; }, function (v) { return $5d981a12faa6c72d$export$1e511d4a378977f5 = v; });
$parcel$export($5d981a12faa6c72d$exports, "Trophy", function () { return $5d981a12faa6c72d$export$c902dcd836bd9c4f; }, function (v) { return $5d981a12faa6c72d$export$c902dcd836bd9c4f = v; });
var $5d981a12faa6c72d$export$1e511d4a378977f5;
var $5d981a12faa6c72d$export$c902dcd836bd9c4f;
"use strict";
$5d981a12faa6c72d$export$1e511d4a378977f5 = true;
$5d981a12faa6c72d$export$c902dcd836bd9c4f = void 0;

var $5d981a12faa6c72d$var$_react = $5d981a12faa6c72d$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5d981a12faa6c72d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5d981a12faa6c72d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5d981a12faa6c72d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5d981a12faa6c72d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5d981a12faa6c72d$var$_extends() {
    return $5d981a12faa6c72d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5d981a12faa6c72d$var$_extends.apply(null, arguments);
}
var $5d981a12faa6c72d$var$Trophy = $5d981a12faa6c72d$export$c902dcd836bd9c4f = /*#__PURE__*/ (0, $5d981a12faa6c72d$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5d981a12faa6c72d$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5d981a12faa6c72d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Trophy"
    }, props), /*#__PURE__*/ $5d981a12faa6c72d$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 15a6 6 0 0 1-6-6V1h12v8a6 6 0 0 1-6 6zM6 3H1v4c0 2.509 1.791 4 4 4h1V3zm12 8h1c2.209 0 4-1.491 4-4V3h-5v8zM5 23h14v-4H5v4zm11-4a4 4 0 1 0-8 0"
    }));
});
$5d981a12faa6c72d$var$Trophy.displayName = 'Trophy';


Object.keys($5d981a12faa6c72d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5d981a12faa6c72d$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5d981a12faa6c72d$exports[key];
});
var $78040b0d6e5566fb$exports = {};

$parcel$export($78040b0d6e5566fb$exports, "__esModule", function () { return $78040b0d6e5566fb$export$1e511d4a378977f5; }, function (v) { return $78040b0d6e5566fb$export$1e511d4a378977f5 = v; });
$parcel$export($78040b0d6e5566fb$exports, "Troubleshoot", function () { return $78040b0d6e5566fb$export$372b7de2702b54b; }, function (v) { return $78040b0d6e5566fb$export$372b7de2702b54b = v; });
var $78040b0d6e5566fb$export$1e511d4a378977f5;
var $78040b0d6e5566fb$export$372b7de2702b54b;
"use strict";
$78040b0d6e5566fb$export$1e511d4a378977f5 = true;
$78040b0d6e5566fb$export$372b7de2702b54b = void 0;

var $78040b0d6e5566fb$var$_react = $78040b0d6e5566fb$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $78040b0d6e5566fb$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($78040b0d6e5566fb$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $78040b0d6e5566fb$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $78040b0d6e5566fb$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $78040b0d6e5566fb$var$_extends() {
    return $78040b0d6e5566fb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $78040b0d6e5566fb$var$_extends.apply(null, arguments);
}
var $78040b0d6e5566fb$var$Troubleshoot = $78040b0d6e5566fb$export$372b7de2702b54b = /*#__PURE__*/ (0, $78040b0d6e5566fb$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $78040b0d6e5566fb$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $78040b0d6e5566fb$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Troubleshoot"
    }, props), /*#__PURE__*/ $78040b0d6e5566fb$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 5c0-2 1-4 2-4l2 4h2l2-4c1 0 2 2 2 4 0 2.254-1 4-3 5v11c0 1 0 2-2 2s-2-1-2-2V10C2 9 1 7.254 1 5zm18 7v6m-2 0 1 5h2l1-5h-4zm-3-6h10-10zm7 0V3a2 2 0 1 0-4 0v9"
    }));
});
$78040b0d6e5566fb$var$Troubleshoot.displayName = 'Troubleshoot';


Object.keys($78040b0d6e5566fb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $78040b0d6e5566fb$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $78040b0d6e5566fb$exports[key];
});
var $c47981c9de329853$exports = {};

$parcel$export($c47981c9de329853$exports, "__esModule", function () { return $c47981c9de329853$export$1e511d4a378977f5; }, function (v) { return $c47981c9de329853$export$1e511d4a378977f5 = v; });
$parcel$export($c47981c9de329853$exports, "Tty", function () { return $c47981c9de329853$export$844b3f71e43def07; }, function (v) { return $c47981c9de329853$export$844b3f71e43def07 = v; });
var $c47981c9de329853$export$1e511d4a378977f5;
var $c47981c9de329853$export$844b3f71e43def07;
"use strict";
$c47981c9de329853$export$1e511d4a378977f5 = true;
$c47981c9de329853$export$844b3f71e43def07 = void 0;

var $c47981c9de329853$var$_react = $c47981c9de329853$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c47981c9de329853$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c47981c9de329853$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c47981c9de329853$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c47981c9de329853$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c47981c9de329853$var$_extends() {
    return $c47981c9de329853$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c47981c9de329853$var$_extends.apply(null, arguments);
}
var $c47981c9de329853$var$Tty = $c47981c9de329853$export$844b3f71e43def07 = /*#__PURE__*/ (0, $c47981c9de329853$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c47981c9de329853$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c47981c9de329853$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Tty"
    }, props), /*#__PURE__*/ $c47981c9de329853$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: "2",
        d: "M7 19h10a1 1 0 0 1 1 1h0a1 1 0 0 1-1 1H7h0a1 1 0 0 1-1-1h0a1 1 0 0 1 1-1zm0-9a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm5-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm5-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
    }));
});
$c47981c9de329853$var$Tty.displayName = 'Tty';


Object.keys($c47981c9de329853$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c47981c9de329853$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c47981c9de329853$exports[key];
});
var $3159a0b6e9649072$exports = {};

$parcel$export($3159a0b6e9649072$exports, "__esModule", function () { return $3159a0b6e9649072$export$1e511d4a378977f5; }, function (v) { return $3159a0b6e9649072$export$1e511d4a378977f5 = v; });
$parcel$export($3159a0b6e9649072$exports, "Tumblr", function () { return $3159a0b6e9649072$export$9aaaae3a1c3d6cc4; }, function (v) { return $3159a0b6e9649072$export$9aaaae3a1c3d6cc4 = v; });
var $3159a0b6e9649072$export$1e511d4a378977f5;
var $3159a0b6e9649072$export$9aaaae3a1c3d6cc4;
"use strict";
$3159a0b6e9649072$export$1e511d4a378977f5 = true;
$3159a0b6e9649072$export$9aaaae3a1c3d6cc4 = void 0;

var $3159a0b6e9649072$var$_react = $3159a0b6e9649072$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $3159a0b6e9649072$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3159a0b6e9649072$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3159a0b6e9649072$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3159a0b6e9649072$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3159a0b6e9649072$var$_extends() {
    return $3159a0b6e9649072$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3159a0b6e9649072$var$_extends.apply(null, arguments);
}
var $3159a0b6e9649072$var$Tumblr = $3159a0b6e9649072$export$9aaaae3a1c3d6cc4 = /*#__PURE__*/ (0, $3159a0b6e9649072$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3159a0b6e9649072$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3159a0b6e9649072$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Tumblr"
    }, props), /*#__PURE__*/ $3159a0b6e9649072$var$_react["default"].createElement("path", {
        fill: "#35465C",
        fillRule: "evenodd",
        d: "M17.639 19.17c-.446.212-1.3.398-1.937.415-1.92.05-2.293-1.35-2.31-2.367v-7.47h4.82V6.114H13.41V0H9.894c-.057 0-.158.051-.172.18C9.516 2.051 8.64 5.335 5 6.647v3.1h2.428v7.842c0 2.685 1.981 6.499 7.21 6.41 1.763-.031 3.722-.77 4.155-1.406L17.64 19.17z"
    }));
});
$3159a0b6e9649072$var$Tumblr.displayName = 'Tumblr';


Object.keys($3159a0b6e9649072$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3159a0b6e9649072$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3159a0b6e9649072$exports[key];
});
var $1c4e4f7e08edc1d2$exports = {};

$parcel$export($1c4e4f7e08edc1d2$exports, "__esModule", function () { return $1c4e4f7e08edc1d2$export$1e511d4a378977f5; }, function (v) { return $1c4e4f7e08edc1d2$export$1e511d4a378977f5 = v; });
$parcel$export($1c4e4f7e08edc1d2$exports, "Turbolinux", function () { return $1c4e4f7e08edc1d2$export$7df7bcca19177661; }, function (v) { return $1c4e4f7e08edc1d2$export$7df7bcca19177661 = v; });
var $1c4e4f7e08edc1d2$export$1e511d4a378977f5;
var $1c4e4f7e08edc1d2$export$7df7bcca19177661;
"use strict";
$1c4e4f7e08edc1d2$export$1e511d4a378977f5 = true;
$1c4e4f7e08edc1d2$export$7df7bcca19177661 = void 0;

var $1c4e4f7e08edc1d2$var$_react = $1c4e4f7e08edc1d2$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $1c4e4f7e08edc1d2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1c4e4f7e08edc1d2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1c4e4f7e08edc1d2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $1c4e4f7e08edc1d2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1c4e4f7e08edc1d2$var$_extends() {
    return $1c4e4f7e08edc1d2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1c4e4f7e08edc1d2$var$_extends.apply(null, arguments);
}
var $1c4e4f7e08edc1d2$var$Turbolinux = $1c4e4f7e08edc1d2$export$7df7bcca19177661 = /*#__PURE__*/ (0, $1c4e4f7e08edc1d2$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $1c4e4f7e08edc1d2$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $1c4e4f7e08edc1d2$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Turbolinux"
    }, props), /*#__PURE__*/ $1c4e4f7e08edc1d2$var$_react["default"].createElement("path", {
        fill: "#528DC4",
        fillRule: "evenodd",
        d: "m9.419 6.222.547 1.23h-3.35L6 6.223h3.419zm3.692 5.949L7.094 0l7.042 4.17.41 1.984h3.351l-.752 2.051h-2.188l1.778 8.274-4.171-2.052L14.684 24 8.187 10.803l4.923 1.368z"
    }));
});
$1c4e4f7e08edc1d2$var$Turbolinux.displayName = 'Turbolinux';


Object.keys($1c4e4f7e08edc1d2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $1c4e4f7e08edc1d2$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $1c4e4f7e08edc1d2$exports[key];
});
var $260ade777658a8f8$exports = {};

$parcel$export($260ade777658a8f8$exports, "__esModule", function () { return $260ade777658a8f8$export$1e511d4a378977f5; }, function (v) { return $260ade777658a8f8$export$1e511d4a378977f5 = v; });
$parcel$export($260ade777658a8f8$exports, "Twitch", function () { return $260ade777658a8f8$export$2165cf31ff2dd606; }, function (v) { return $260ade777658a8f8$export$2165cf31ff2dd606 = v; });
var $260ade777658a8f8$export$1e511d4a378977f5;
var $260ade777658a8f8$export$2165cf31ff2dd606;
"use strict";
$260ade777658a8f8$export$1e511d4a378977f5 = true;
$260ade777658a8f8$export$2165cf31ff2dd606 = void 0;

var $260ade777658a8f8$var$_react = $260ade777658a8f8$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $260ade777658a8f8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($260ade777658a8f8$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $260ade777658a8f8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $260ade777658a8f8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $260ade777658a8f8$var$_extends() {
    return $260ade777658a8f8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $260ade777658a8f8$var$_extends.apply(null, arguments);
}
var $260ade777658a8f8$var$Twitch = $260ade777658a8f8$export$2165cf31ff2dd606 = /*#__PURE__*/ (0, $260ade777658a8f8$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $260ade777658a8f8$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $260ade777658a8f8$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Twitch"
    }, props), /*#__PURE__*/ $260ade777658a8f8$var$_react["default"].createElement("path", {
        fill: "#6441A5",
        fillRule: "evenodd",
        d: "m16.673 16.163 3.43-3.429V1.959H3.939v14.204h4.408v2.939l2.94-2.939h5.386ZM1 3.92 1.98 0h20.08v13.715l-7.836 7.835h-3.917L7.857 24H5.409v-2.45H1V3.92Zm10.286 7.836h-1.96V5.877h1.96v5.878Zm5.387 0h-1.959V5.877h1.96v5.878Z",
        clipRule: "evenodd"
    }));
});
$260ade777658a8f8$var$Twitch.displayName = 'Twitch';


Object.keys($260ade777658a8f8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $260ade777658a8f8$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $260ade777658a8f8$exports[key];
});
var $5678926910060be2$exports = {};

$parcel$export($5678926910060be2$exports, "__esModule", function () { return $5678926910060be2$export$1e511d4a378977f5; }, function (v) { return $5678926910060be2$export$1e511d4a378977f5 = v; });
$parcel$export($5678926910060be2$exports, "Twitter", function () { return $5678926910060be2$export$9e389cdad32a5b7a; }, function (v) { return $5678926910060be2$export$9e389cdad32a5b7a = v; });
var $5678926910060be2$export$1e511d4a378977f5;
var $5678926910060be2$export$9e389cdad32a5b7a;
"use strict";
$5678926910060be2$export$1e511d4a378977f5 = true;
$5678926910060be2$export$9e389cdad32a5b7a = void 0;

var $5678926910060be2$var$_react = $5678926910060be2$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $5678926910060be2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5678926910060be2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5678926910060be2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5678926910060be2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5678926910060be2$var$_extends() {
    return $5678926910060be2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5678926910060be2$var$_extends.apply(null, arguments);
}
var $5678926910060be2$var$Twitter = $5678926910060be2$export$9e389cdad32a5b7a = /*#__PURE__*/ (0, $5678926910060be2$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5678926910060be2$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $5678926910060be2$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Twitter"
    }, props), /*#__PURE__*/ $5678926910060be2$var$_react["default"].createElement("path", {
        fill: "#1DA1F2",
        fillRule: "evenodd",
        d: "M24 4.309a9.83 9.83 0 0 1-2.828.775 4.94 4.94 0 0 0 2.165-2.724 9.865 9.865 0 0 1-3.127 1.196 4.925 4.925 0 0 0-8.39 4.49A13.974 13.974 0 0 1 1.671 2.9a4.902 4.902 0 0 0-.667 2.476c0 1.708.869 3.216 2.191 4.099A4.936 4.936 0 0 1 .964 8.86v.06a4.926 4.926 0 0 0 3.95 4.829 4.964 4.964 0 0 1-2.224.085 4.93 4.93 0 0 0 4.6 3.42 9.886 9.886 0 0 1-6.115 2.107c-.398 0-.79-.023-1.175-.068a13.945 13.945 0 0 0 7.548 2.212c9.057 0 14.009-7.503 14.009-14.01 0-.213-.005-.425-.014-.636A10.012 10.012 0 0 0 24 4.309"
    }));
});
$5678926910060be2$var$Twitter.displayName = 'Twitter';


Object.keys($5678926910060be2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $5678926910060be2$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $5678926910060be2$exports[key];
});
var $4595a86aec393b97$exports = {};

$parcel$export($4595a86aec393b97$exports, "__esModule", function () { return $4595a86aec393b97$export$1e511d4a378977f5; }, function (v) { return $4595a86aec393b97$export$1e511d4a378977f5 = v; });
$parcel$export($4595a86aec393b97$exports, "Ubuntu", function () { return $4595a86aec393b97$export$90a8aa28858e3b55; }, function (v) { return $4595a86aec393b97$export$90a8aa28858e3b55 = v; });
var $4595a86aec393b97$export$1e511d4a378977f5;
var $4595a86aec393b97$export$90a8aa28858e3b55;
"use strict";
$4595a86aec393b97$export$1e511d4a378977f5 = true;
$4595a86aec393b97$export$90a8aa28858e3b55 = void 0;

var $4595a86aec393b97$var$_react = $4595a86aec393b97$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $4595a86aec393b97$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4595a86aec393b97$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4595a86aec393b97$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $4595a86aec393b97$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $4595a86aec393b97$var$_extends() {
    return $4595a86aec393b97$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4595a86aec393b97$var$_extends.apply(null, arguments);
}
var $4595a86aec393b97$var$Ubuntu = $4595a86aec393b97$export$90a8aa28858e3b55 = /*#__PURE__*/ (0, $4595a86aec393b97$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $4595a86aec393b97$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $4595a86aec393b97$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Ubuntu"
    }, props), /*#__PURE__*/ $4595a86aec393b97$var$_react["default"].createElement("path", {
        fill: "#DD4814",
        fillRule: "evenodd",
        d: "M24 12c0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12S5.372 0 12 0c6.627 0 12 5.373 12 12zM3.84 10.398a1.602 1.602 0 1 0 0 3.204 1.602 1.602 0 0 0 0-3.204zm11.44 7.282a1.601 1.601 0 1 0 1.6 2.774 1.601 1.601 0 0 0-1.6-2.774zM7.32 12c0-1.583.787-2.982 1.99-3.829L8.14 6.21a6.972 6.972 0 0 0-2.878 4.046c.506.413.829 1.041.829 1.745 0 .704-.323 1.332-.83 1.745A6.97 6.97 0 0 0 8.14 17.79l1.171-1.962A4.672 4.672 0 0 1 7.32 12zM12 7.32a4.68 4.68 0 0 1 4.66 4.265l2.284-.033a6.938 6.938 0 0 0-2.068-4.515c-.61.23-1.313.195-1.92-.156a2.244 2.244 0 0 1-1.097-1.588 6.96 6.96 0 0 0-4.943.468l1.113 1.994A4.66 4.66 0 0 1 12 7.32zm0 9.36a4.66 4.66 0 0 1-1.971-.435l-1.114 1.994a6.961 6.961 0 0 0 4.944.467 2.245 2.245 0 0 1 1.096-1.587 2.245 2.245 0 0 1 1.921-.156 6.938 6.938 0 0 0 2.068-4.515l-2.283-.033A4.679 4.679 0 0 1 12 16.68zm3.279-10.36a1.601 1.601 0 1 0 1.602-2.773A1.601 1.601 0 0 0 15.28 6.32z"
    }));
});
$4595a86aec393b97$var$Ubuntu.displayName = 'Ubuntu';


Object.keys($4595a86aec393b97$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $4595a86aec393b97$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $4595a86aec393b97$exports[key];
});
var $4bee1749bf4c74c0$exports = {};

$parcel$export($4bee1749bf4c74c0$exports, "__esModule", function () { return $4bee1749bf4c74c0$export$1e511d4a378977f5; }, function (v) { return $4bee1749bf4c74c0$export$1e511d4a378977f5 = v; });
$parcel$export($4bee1749bf4c74c0$exports, "Underline", function () { return $4bee1749bf4c74c0$export$741ee5bff4f2bc22; }, function (v) { return $4bee1749bf4c74c0$export$741ee5bff4f2bc22 = v; });
var $4bee1749bf4c74c0$export$1e511d4a378977f5;
var $4bee1749bf4c74c0$export$741ee5bff4f2bc22;
"use strict";
$4bee1749bf4c74c0$export$1e511d4a378977f5 = true;
$4bee1749bf4c74c0$export$741ee5bff4f2bc22 = void 0;

var $4bee1749bf4c74c0$var$_react = $4bee1749bf4c74c0$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $4bee1749bf4c74c0$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4bee1749bf4c74c0$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4bee1749bf4c74c0$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $4bee1749bf4c74c0$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $4bee1749bf4c74c0$var$_extends() {
    return $4bee1749bf4c74c0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4bee1749bf4c74c0$var$_extends.apply(null, arguments);
}
var $4bee1749bf4c74c0$var$Underline = $4bee1749bf4c74c0$export$741ee5bff4f2bc22 = /*#__PURE__*/ (0, $4bee1749bf4c74c0$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $4bee1749bf4c74c0$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $4bee1749bf4c74c0$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Underline"
    }, props), /*#__PURE__*/ $4bee1749bf4c74c0$var$_react["default"].createElement("path", {
        d: "M14.41 4.53v-.35h4.66v.36h-.49a1.34 1.34 0 0 0-1.19.65 3 3 0 0 0-.2 1.4v5.33a9.45 9.45 0 0 1-.41 3.08 3.85 3.85 0 0 1-1.54 1.87 5.49 5.49 0 0 1-3.13.78 5.89 5.89 0 0 1-3.27-.75 4 4 0 0 1-1.58-2A11.14 11.14 0 0 1 7 11.64V6.5a2.58 2.58 0 0 0-.33-1.59 1.38 1.38 0 0 0-1.08-.38H5v-.35h5.68v.36h-.5A1.3 1.3 0 0 0 9.06 5a2.87 2.87 0 0 0-.25 1.5v5.73A12.52 12.52 0 0 0 9 14a3.71 3.71 0 0 0 .51 1.54 2.77 2.77 0 0 0 1.06.91 3.68 3.68 0 0 0 1.7.36 4.69 4.69 0 0 0 2.31-.56 3 3 0 0 0 1.39-1.44 8.33 8.33 0 0 0 .37-3V6.5A2.72 2.72 0 0 0 16 5a1.43 1.43 0 0 0-1.12-.43zM4.93 20v-1H19v1z"
    }));
});
$4bee1749bf4c74c0$var$Underline.displayName = 'Underline';


Object.keys($4bee1749bf4c74c0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $4bee1749bf4c74c0$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $4bee1749bf4c74c0$exports[key];
});
var $7e569545d01be9e7$exports = {};

$parcel$export($7e569545d01be9e7$exports, "__esModule", function () { return $7e569545d01be9e7$export$1e511d4a378977f5; }, function (v) { return $7e569545d01be9e7$export$1e511d4a378977f5 = v; });
$parcel$export($7e569545d01be9e7$exports, "Undo", function () { return $7e569545d01be9e7$export$897c9ed706d8ea48; }, function (v) { return $7e569545d01be9e7$export$897c9ed706d8ea48 = v; });
var $7e569545d01be9e7$export$1e511d4a378977f5;
var $7e569545d01be9e7$export$897c9ed706d8ea48;
"use strict";
$7e569545d01be9e7$export$1e511d4a378977f5 = true;
$7e569545d01be9e7$export$897c9ed706d8ea48 = void 0;

var $7e569545d01be9e7$var$_react = $7e569545d01be9e7$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $7e569545d01be9e7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7e569545d01be9e7$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7e569545d01be9e7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $7e569545d01be9e7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7e569545d01be9e7$var$_extends() {
    return $7e569545d01be9e7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7e569545d01be9e7$var$_extends.apply(null, arguments);
}
var $7e569545d01be9e7$var$Undo = $7e569545d01be9e7$export$897c9ed706d8ea48 = /*#__PURE__*/ (0, $7e569545d01be9e7$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $7e569545d01be9e7$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $7e569545d01be9e7$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Undo"
    }, props), /*#__PURE__*/ $7e569545d01be9e7$var$_react["default"].createElement("path", {
        d: "M7.18 4 8.6 5.44 6.06 8h9.71a6 6 0 0 1 0 12h-2v-2h2a4 4 0 0 0 0-8H6.06l2.54 2.51-1.42 1.41L2.23 9z"
    }));
});
$7e569545d01be9e7$var$Undo.displayName = 'Undo';


Object.keys($7e569545d01be9e7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $7e569545d01be9e7$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $7e569545d01be9e7$exports[key];
});
var $89a3429fae74a7c0$exports = {};

$parcel$export($89a3429fae74a7c0$exports, "__esModule", function () { return $89a3429fae74a7c0$export$1e511d4a378977f5; }, function (v) { return $89a3429fae74a7c0$export$1e511d4a378977f5 = v; });
$parcel$export($89a3429fae74a7c0$exports, "Unlink", function () { return $89a3429fae74a7c0$export$4984548082beebc6; }, function (v) { return $89a3429fae74a7c0$export$4984548082beebc6 = v; });
var $89a3429fae74a7c0$export$1e511d4a378977f5;
var $89a3429fae74a7c0$export$4984548082beebc6;
"use strict";
$89a3429fae74a7c0$export$1e511d4a378977f5 = true;
$89a3429fae74a7c0$export$4984548082beebc6 = void 0;

var $89a3429fae74a7c0$var$_react = $89a3429fae74a7c0$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $89a3429fae74a7c0$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($89a3429fae74a7c0$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $89a3429fae74a7c0$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $89a3429fae74a7c0$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $89a3429fae74a7c0$var$_extends() {
    return $89a3429fae74a7c0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $89a3429fae74a7c0$var$_extends.apply(null, arguments);
}
var $89a3429fae74a7c0$var$Unlink = $89a3429fae74a7c0$export$4984548082beebc6 = /*#__PURE__*/ (0, $89a3429fae74a7c0$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $89a3429fae74a7c0$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $89a3429fae74a7c0$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Unlink"
    }, props), /*#__PURE__*/ $89a3429fae74a7c0$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m17 11 4.586 4.586a1.998 1.998 0 0 1 0 2.828l-3.172 3.172a1.998 1.998 0 0 1-2.828 0L11 17m6-9h4m-5-1V3M8 21v-4m-5-1h4m0-3L2.414 8.414a1.998 1.998 0 0 1 0-2.828l3.172-3.172a1.998 1.998 0 0 1 2.828 0L13 7"
    }));
});
$89a3429fae74a7c0$var$Unlink.displayName = 'Unlink';


Object.keys($89a3429fae74a7c0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $89a3429fae74a7c0$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $89a3429fae74a7c0$exports[key];
});
var $c955a977ef925ed3$exports = {};

$parcel$export($c955a977ef925ed3$exports, "__esModule", function () { return $c955a977ef925ed3$export$1e511d4a378977f5; }, function (v) { return $c955a977ef925ed3$export$1e511d4a378977f5 = v; });
$parcel$export($c955a977ef925ed3$exports, "Unlock", function () { return $c955a977ef925ed3$export$a818bbe058f189e; }, function (v) { return $c955a977ef925ed3$export$a818bbe058f189e = v; });
var $c955a977ef925ed3$export$1e511d4a378977f5;
var $c955a977ef925ed3$export$a818bbe058f189e;
"use strict";
$c955a977ef925ed3$export$1e511d4a378977f5 = true;
$c955a977ef925ed3$export$a818bbe058f189e = void 0;

var $c955a977ef925ed3$var$_react = $c955a977ef925ed3$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c955a977ef925ed3$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c955a977ef925ed3$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c955a977ef925ed3$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c955a977ef925ed3$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c955a977ef925ed3$var$_extends() {
    return $c955a977ef925ed3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c955a977ef925ed3$var$_extends.apply(null, arguments);
}
var $c955a977ef925ed3$var$Unlock = $c955a977ef925ed3$export$a818bbe058f189e = /*#__PURE__*/ (0, $c955a977ef925ed3$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c955a977ef925ed3$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c955a977ef925ed3$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Unlock"
    }, props), /*#__PURE__*/ $c955a977ef925ed3$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M23 23V11H9v12h14zm-9-6h4m-7-6V7c0-3 0-6-5-6S1 4 1 7v4"
    }));
});
$c955a977ef925ed3$var$Unlock.displayName = 'Unlock';


Object.keys($c955a977ef925ed3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c955a977ef925ed3$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c955a977ef925ed3$exports[key];
});
var $1b5ecb297b7a31db$exports = {};

$parcel$export($1b5ecb297b7a31db$exports, "__esModule", function () { return $1b5ecb297b7a31db$export$1e511d4a378977f5; }, function (v) { return $1b5ecb297b7a31db$export$1e511d4a378977f5 = v; });
$parcel$export($1b5ecb297b7a31db$exports, "UnorderedList", function () { return $1b5ecb297b7a31db$export$30b2abb1ad323770; }, function (v) { return $1b5ecb297b7a31db$export$30b2abb1ad323770 = v; });
var $1b5ecb297b7a31db$export$1e511d4a378977f5;
var $1b5ecb297b7a31db$export$30b2abb1ad323770;
"use strict";
$1b5ecb297b7a31db$export$1e511d4a378977f5 = true;
$1b5ecb297b7a31db$export$30b2abb1ad323770 = void 0;

var $1b5ecb297b7a31db$var$_react = $1b5ecb297b7a31db$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $1b5ecb297b7a31db$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1b5ecb297b7a31db$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1b5ecb297b7a31db$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $1b5ecb297b7a31db$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1b5ecb297b7a31db$var$_extends() {
    return $1b5ecb297b7a31db$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1b5ecb297b7a31db$var$_extends.apply(null, arguments);
}
var $1b5ecb297b7a31db$var$UnorderedList = $1b5ecb297b7a31db$export$30b2abb1ad323770 = /*#__PURE__*/ (0, $1b5ecb297b7a31db$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $1b5ecb297b7a31db$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $1b5ecb297b7a31db$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "UnorderedList"
    }, props), /*#__PURE__*/ $1b5ecb297b7a31db$var$_react["default"].createElement("path", {
        d: "M5.94 6.42H24v1.75H5.94zm0 5.29H24v1.75H5.94zm0 5.28H24v1.75H5.94z"
    }), /*#__PURE__*/ $1b5ecb297b7a31db$var$_react["default"].createElement("circle", {
        cx: "1.85",
        cy: "7.29",
        r: "1.52"
    }), /*#__PURE__*/ $1b5ecb297b7a31db$var$_react["default"].createElement("circle", {
        cx: "1.85",
        cy: "12.58",
        r: "1.52"
    }), /*#__PURE__*/ $1b5ecb297b7a31db$var$_react["default"].createElement("circle", {
        cx: "1.85",
        cy: "17.87",
        r: "1.52"
    }));
});
$1b5ecb297b7a31db$var$UnorderedList.displayName = 'UnorderedList';


Object.keys($1b5ecb297b7a31db$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $1b5ecb297b7a31db$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $1b5ecb297b7a31db$exports[key];
});
var $f7cb7d0506ca5f9b$exports = {};

$parcel$export($f7cb7d0506ca5f9b$exports, "__esModule", function () { return $f7cb7d0506ca5f9b$export$1e511d4a378977f5; }, function (v) { return $f7cb7d0506ca5f9b$export$1e511d4a378977f5 = v; });
$parcel$export($f7cb7d0506ca5f9b$exports, "Unsorted", function () { return $f7cb7d0506ca5f9b$export$59632621a3136e9f; }, function (v) { return $f7cb7d0506ca5f9b$export$59632621a3136e9f = v; });
var $f7cb7d0506ca5f9b$export$1e511d4a378977f5;
var $f7cb7d0506ca5f9b$export$59632621a3136e9f;
"use strict";
$f7cb7d0506ca5f9b$export$1e511d4a378977f5 = true;
$f7cb7d0506ca5f9b$export$59632621a3136e9f = void 0;

var $f7cb7d0506ca5f9b$var$_react = $f7cb7d0506ca5f9b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f7cb7d0506ca5f9b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f7cb7d0506ca5f9b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f7cb7d0506ca5f9b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f7cb7d0506ca5f9b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f7cb7d0506ca5f9b$var$_extends() {
    return $f7cb7d0506ca5f9b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f7cb7d0506ca5f9b$var$_extends.apply(null, arguments);
}
var $f7cb7d0506ca5f9b$var$Unsorted = $f7cb7d0506ca5f9b$export$59632621a3136e9f = /*#__PURE__*/ (0, $f7cb7d0506ca5f9b$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f7cb7d0506ca5f9b$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f7cb7d0506ca5f9b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Unsorted"
    }, props), /*#__PURE__*/ $f7cb7d0506ca5f9b$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m15.204 15.321 1.597-1.597.707.707-2.45 2.45-.354.354-.353-.353-2.45-2.45.707-.708 1.596 1.597V7.217h1v8.104zm-5.9-6.407v8.104h1V8.914l1.597 1.597.707-.707-2.45-2.45L9.803 7l-.354.354L7 9.804l.707.707 1.597-1.597z",
        fill: "#000"
    }));
});
$f7cb7d0506ca5f9b$var$Unsorted.displayName = 'Unsorted';


Object.keys($f7cb7d0506ca5f9b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f7cb7d0506ca5f9b$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f7cb7d0506ca5f9b$exports[key];
});
var $e287fd8e066f1de9$exports = {};

$parcel$export($e287fd8e066f1de9$exports, "__esModule", function () { return $e287fd8e066f1de9$export$1e511d4a378977f5; }, function (v) { return $e287fd8e066f1de9$export$1e511d4a378977f5 = v; });
$parcel$export($e287fd8e066f1de9$exports, "Up", function () { return $e287fd8e066f1de9$export$523db0166afee5e8; }, function (v) { return $e287fd8e066f1de9$export$523db0166afee5e8 = v; });
var $e287fd8e066f1de9$export$1e511d4a378977f5;
var $e287fd8e066f1de9$export$523db0166afee5e8;
"use strict";
$e287fd8e066f1de9$export$1e511d4a378977f5 = true;
$e287fd8e066f1de9$export$523db0166afee5e8 = void 0;

var $e287fd8e066f1de9$var$_react = $e287fd8e066f1de9$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $e287fd8e066f1de9$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e287fd8e066f1de9$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e287fd8e066f1de9$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e287fd8e066f1de9$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e287fd8e066f1de9$var$_extends() {
    return $e287fd8e066f1de9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e287fd8e066f1de9$var$_extends.apply(null, arguments);
}
var $e287fd8e066f1de9$var$Up = $e287fd8e066f1de9$export$523db0166afee5e8 = /*#__PURE__*/ (0, $e287fd8e066f1de9$var$_react.forwardRef)(function(props, ref) {
    var scaleProps = (0, $1b754218be0a6592$export$56a2e46cd4a7c217)(props);
    return /*#__PURE__*/ $e287fd8e066f1de9$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e287fd8e066f1de9$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Up"
    }, props), /*#__PURE__*/ $e287fd8e066f1de9$var$_react["default"].createElement("path", $e287fd8e066f1de9$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m2 15.999 10.173-9.824 9.824 10.173"
    }, scaleProps)));
});
$e287fd8e066f1de9$var$Up.displayName = 'Up';


Object.keys($e287fd8e066f1de9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e287fd8e066f1de9$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e287fd8e066f1de9$exports[key];
});
var $190f6fa8ec40de67$exports = {};

$parcel$export($190f6fa8ec40de67$exports, "__esModule", function () { return $190f6fa8ec40de67$export$1e511d4a378977f5; }, function (v) { return $190f6fa8ec40de67$export$1e511d4a378977f5 = v; });
$parcel$export($190f6fa8ec40de67$exports, "Update", function () { return $190f6fa8ec40de67$export$489a84f048b0ef8; }, function (v) { return $190f6fa8ec40de67$export$489a84f048b0ef8 = v; });
var $190f6fa8ec40de67$export$1e511d4a378977f5;
var $190f6fa8ec40de67$export$489a84f048b0ef8;
"use strict";
$190f6fa8ec40de67$export$1e511d4a378977f5 = true;
$190f6fa8ec40de67$export$489a84f048b0ef8 = void 0;

var $190f6fa8ec40de67$var$_react = $190f6fa8ec40de67$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $190f6fa8ec40de67$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($190f6fa8ec40de67$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $190f6fa8ec40de67$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $190f6fa8ec40de67$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $190f6fa8ec40de67$var$_extends() {
    return $190f6fa8ec40de67$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $190f6fa8ec40de67$var$_extends.apply(null, arguments);
}
var $190f6fa8ec40de67$var$Update = $190f6fa8ec40de67$export$489a84f048b0ef8 = /*#__PURE__*/ (0, $190f6fa8ec40de67$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $190f6fa8ec40de67$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $190f6fa8ec40de67$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Update"
    }, props), /*#__PURE__*/ $190f6fa8ec40de67$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1.75 16.002C3.353 20.098 7.338 23 12 23c6.075 0 11-4.925 11-11m-.75-4.002C20.649 3.901 16.663 1 12 1 5.925 1 1 5.925 1 12m8 4H1v8M23 0v8h-8"
    }));
});
$190f6fa8ec40de67$var$Update.displayName = 'Update';


Object.keys($190f6fa8ec40de67$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $190f6fa8ec40de67$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $190f6fa8ec40de67$exports[key];
});
var $322b9c6577ffd881$exports = {};

$parcel$export($322b9c6577ffd881$exports, "__esModule", function () { return $322b9c6577ffd881$export$1e511d4a378977f5; }, function (v) { return $322b9c6577ffd881$export$1e511d4a378977f5 = v; });
$parcel$export($322b9c6577ffd881$exports, "Upgrade", function () { return $322b9c6577ffd881$export$f046020f8a79a829; }, function (v) { return $322b9c6577ffd881$export$f046020f8a79a829 = v; });
var $322b9c6577ffd881$export$1e511d4a378977f5;
var $322b9c6577ffd881$export$f046020f8a79a829;
"use strict";
$322b9c6577ffd881$export$1e511d4a378977f5 = true;
$322b9c6577ffd881$export$f046020f8a79a829 = void 0;

var $322b9c6577ffd881$var$_react = $322b9c6577ffd881$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $322b9c6577ffd881$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($322b9c6577ffd881$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $322b9c6577ffd881$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $322b9c6577ffd881$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $322b9c6577ffd881$var$_extends() {
    return $322b9c6577ffd881$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $322b9c6577ffd881$var$_extends.apply(null, arguments);
}
var $322b9c6577ffd881$var$Upgrade = $322b9c6577ffd881$export$f046020f8a79a829 = /*#__PURE__*/ (0, $322b9c6577ffd881$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $322b9c6577ffd881$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $322b9c6577ffd881$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Upgrade"
    }, props), /*#__PURE__*/ $322b9c6577ffd881$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 18V8v10zm0 5c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm5-11-5-5-5 5"
    }));
});
$322b9c6577ffd881$var$Upgrade.displayName = 'Upgrade';


Object.keys($322b9c6577ffd881$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $322b9c6577ffd881$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $322b9c6577ffd881$exports[key];
});
var $f955fcffb9eff6b5$exports = {};

$parcel$export($f955fcffb9eff6b5$exports, "__esModule", function () { return $f955fcffb9eff6b5$export$1e511d4a378977f5; }, function (v) { return $f955fcffb9eff6b5$export$1e511d4a378977f5 = v; });
$parcel$export($f955fcffb9eff6b5$exports, "UploadOption", function () { return $f955fcffb9eff6b5$export$37091551735c4ab6; }, function (v) { return $f955fcffb9eff6b5$export$37091551735c4ab6 = v; });
var $f955fcffb9eff6b5$export$1e511d4a378977f5;
var $f955fcffb9eff6b5$export$37091551735c4ab6;
"use strict";
$f955fcffb9eff6b5$export$1e511d4a378977f5 = true;
$f955fcffb9eff6b5$export$37091551735c4ab6 = void 0;

var $f955fcffb9eff6b5$var$_react = $f955fcffb9eff6b5$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f955fcffb9eff6b5$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f955fcffb9eff6b5$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f955fcffb9eff6b5$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f955fcffb9eff6b5$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f955fcffb9eff6b5$var$_extends() {
    return $f955fcffb9eff6b5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f955fcffb9eff6b5$var$_extends.apply(null, arguments);
}
var $f955fcffb9eff6b5$var$UploadOption = $f955fcffb9eff6b5$export$37091551735c4ab6 = /*#__PURE__*/ (0, $f955fcffb9eff6b5$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f955fcffb9eff6b5$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f955fcffb9eff6b5$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "UploadOption"
    }, props), /*#__PURE__*/ $f955fcffb9eff6b5$var$_react["default"].createElement("path", {
        stroke: "#000",
        strokeWidth: "2",
        fill: "none",
        d: "m17 12-5-5-5 5m5-4v10m0 5c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11z"
    }));
});
$f955fcffb9eff6b5$var$UploadOption.displayName = 'UploadOption';


Object.keys($f955fcffb9eff6b5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f955fcffb9eff6b5$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f955fcffb9eff6b5$exports[key];
});
var $0e6587cf765fa56e$exports = {};

$parcel$export($0e6587cf765fa56e$exports, "__esModule", function () { return $0e6587cf765fa56e$export$1e511d4a378977f5; }, function (v) { return $0e6587cf765fa56e$export$1e511d4a378977f5 = v; });
$parcel$export($0e6587cf765fa56e$exports, "Upload", function () { return $0e6587cf765fa56e$export$c58532f0fb5faa97; }, function (v) { return $0e6587cf765fa56e$export$c58532f0fb5faa97 = v; });
var $0e6587cf765fa56e$export$1e511d4a378977f5;
var $0e6587cf765fa56e$export$c58532f0fb5faa97;
"use strict";
$0e6587cf765fa56e$export$1e511d4a378977f5 = true;
$0e6587cf765fa56e$export$c58532f0fb5faa97 = void 0;

var $0e6587cf765fa56e$var$_react = $0e6587cf765fa56e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0e6587cf765fa56e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0e6587cf765fa56e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0e6587cf765fa56e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0e6587cf765fa56e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0e6587cf765fa56e$var$_extends() {
    return $0e6587cf765fa56e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0e6587cf765fa56e$var$_extends.apply(null, arguments);
}
var $0e6587cf765fa56e$var$Upload = $0e6587cf765fa56e$export$c58532f0fb5faa97 = /*#__PURE__*/ (0, $0e6587cf765fa56e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0e6587cf765fa56e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0e6587cf765fa56e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Upload"
    }, props), /*#__PURE__*/ $0e6587cf765fa56e$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 17v6h22v-6M12 2v17M5 9l7-7 7 7"
    }));
});
$0e6587cf765fa56e$var$Upload.displayName = 'Upload';


Object.keys($0e6587cf765fa56e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0e6587cf765fa56e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0e6587cf765fa56e$exports[key];
});
var $6752c00a0a02c83b$exports = {};

$parcel$export($6752c00a0a02c83b$exports, "__esModule", function () { return $6752c00a0a02c83b$export$1e511d4a378977f5; }, function (v) { return $6752c00a0a02c83b$export$1e511d4a378977f5 = v; });
$parcel$export($6752c00a0a02c83b$exports, "UsbKey", function () { return $6752c00a0a02c83b$export$7e97d71736b743ea; }, function (v) { return $6752c00a0a02c83b$export$7e97d71736b743ea = v; });
var $6752c00a0a02c83b$export$1e511d4a378977f5;
var $6752c00a0a02c83b$export$7e97d71736b743ea;
"use strict";
$6752c00a0a02c83b$export$1e511d4a378977f5 = true;
$6752c00a0a02c83b$export$7e97d71736b743ea = void 0;

var $6752c00a0a02c83b$var$_react = $6752c00a0a02c83b$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $6752c00a0a02c83b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6752c00a0a02c83b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6752c00a0a02c83b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6752c00a0a02c83b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6752c00a0a02c83b$var$_extends() {
    return $6752c00a0a02c83b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6752c00a0a02c83b$var$_extends.apply(null, arguments);
}
var $6752c00a0a02c83b$var$UsbKey = $6752c00a0a02c83b$export$7e97d71736b743ea = /*#__PURE__*/ (0, $6752c00a0a02c83b$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $6752c00a0a02c83b$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $6752c00a0a02c83b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "UsbKey"
    }, props), /*#__PURE__*/ $6752c00a0a02c83b$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 6a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h14v-1h7V7h-7V6H3zm14 3v5h5V9h-5zm-2 6V8H3a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h12zm4-3.992h1.01v-1.01H19v1.01zm.51 2h-.5v-1.01h1.01v1.01h-.51z",
        fill: "#000"
    }));
});
$6752c00a0a02c83b$var$UsbKey.displayName = 'UsbKey';


Object.keys($6752c00a0a02c83b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $6752c00a0a02c83b$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $6752c00a0a02c83b$exports[key];
});
var $b19a63d3d013f646$exports = {};

$parcel$export($b19a63d3d013f646$exports, "__esModule", function () { return $b19a63d3d013f646$export$1e511d4a378977f5; }, function (v) { return $b19a63d3d013f646$export$1e511d4a378977f5 = v; });
$parcel$export($b19a63d3d013f646$exports, "UserAdd", function () { return $b19a63d3d013f646$export$17edafa619a8f958; }, function (v) { return $b19a63d3d013f646$export$17edafa619a8f958 = v; });
var $b19a63d3d013f646$export$1e511d4a378977f5;
var $b19a63d3d013f646$export$17edafa619a8f958;
"use strict";
$b19a63d3d013f646$export$1e511d4a378977f5 = true;
$b19a63d3d013f646$export$17edafa619a8f958 = void 0;

var $b19a63d3d013f646$var$_react = $b19a63d3d013f646$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $b19a63d3d013f646$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b19a63d3d013f646$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b19a63d3d013f646$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $b19a63d3d013f646$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b19a63d3d013f646$var$_extends() {
    return $b19a63d3d013f646$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b19a63d3d013f646$var$_extends.apply(null, arguments);
}
var $b19a63d3d013f646$var$UserAdd = $b19a63d3d013f646$export$17edafa619a8f958 = /*#__PURE__*/ (0, $b19a63d3d013f646$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $b19a63d3d013f646$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $b19a63d3d013f646$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "UserAdd"
    }, props), /*#__PURE__*/ $b19a63d3d013f646$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M5 24v-5m6 5v-5M1 24v-6c0-4.97 3.134-7 7-7s7 2 7 7v6M8 11A5 5 0 1 0 8 1a5 5 0 0 0 0 10zm8 0h8m-4-4v8"
    }));
});
$b19a63d3d013f646$var$UserAdd.displayName = 'UserAdd';


Object.keys($b19a63d3d013f646$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $b19a63d3d013f646$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $b19a63d3d013f646$exports[key];
});
var $08962546adf6d17c$exports = {};

$parcel$export($08962546adf6d17c$exports, "__esModule", function () { return $08962546adf6d17c$export$1e511d4a378977f5; }, function (v) { return $08962546adf6d17c$export$1e511d4a378977f5 = v; });
$parcel$export($08962546adf6d17c$exports, "UserAdmin", function () { return $08962546adf6d17c$export$c3e1ca01f11b1d01; }, function (v) { return $08962546adf6d17c$export$c3e1ca01f11b1d01 = v; });
var $08962546adf6d17c$export$1e511d4a378977f5;
var $08962546adf6d17c$export$c3e1ca01f11b1d01;
"use strict";
$08962546adf6d17c$export$1e511d4a378977f5 = true;
$08962546adf6d17c$export$c3e1ca01f11b1d01 = void 0;

var $08962546adf6d17c$var$_react = $08962546adf6d17c$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $08962546adf6d17c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($08962546adf6d17c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $08962546adf6d17c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $08962546adf6d17c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $08962546adf6d17c$var$_extends() {
    return $08962546adf6d17c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $08962546adf6d17c$var$_extends.apply(null, arguments);
}
var $08962546adf6d17c$var$UserAdmin = $08962546adf6d17c$export$c3e1ca01f11b1d01 = /*#__PURE__*/ (0, $08962546adf6d17c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $08962546adf6d17c$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $08962546adf6d17c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "UserAdmin"
    }, props), /*#__PURE__*/ $08962546adf6d17c$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8 11A5 5 0 1 0 8 1a5 5 0 0 0 0 10zm5.023 2.023C11.772 11.76 10.013 11 8 11c-4 0-7 3-7 7v5h7m2-3.5a2.5 2.5 0 1 0 5.002-.002A2.5 2.5 0 0 0 10 19.5zM23 15l-3-3-6 6m3.5-3.5 3 3-3-3z"
    }));
});
$08962546adf6d17c$var$UserAdmin.displayName = 'UserAdmin';


Object.keys($08962546adf6d17c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $08962546adf6d17c$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $08962546adf6d17c$exports[key];
});
var $7455d0776b4a504a$exports = {};

$parcel$export($7455d0776b4a504a$exports, "__esModule", function () { return $7455d0776b4a504a$export$1e511d4a378977f5; }, function (v) { return $7455d0776b4a504a$export$1e511d4a378977f5 = v; });
$parcel$export($7455d0776b4a504a$exports, "UserExpert", function () { return $7455d0776b4a504a$export$23d4598e3685cc9; }, function (v) { return $7455d0776b4a504a$export$23d4598e3685cc9 = v; });
var $7455d0776b4a504a$export$1e511d4a378977f5;
var $7455d0776b4a504a$export$23d4598e3685cc9;
"use strict";
$7455d0776b4a504a$export$1e511d4a378977f5 = true;
$7455d0776b4a504a$export$23d4598e3685cc9 = void 0;

var $7455d0776b4a504a$var$_react = $7455d0776b4a504a$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $7455d0776b4a504a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7455d0776b4a504a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7455d0776b4a504a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $7455d0776b4a504a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $7455d0776b4a504a$var$_extends() {
    return $7455d0776b4a504a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7455d0776b4a504a$var$_extends.apply(null, arguments);
}
var $7455d0776b4a504a$var$UserExpert = $7455d0776b4a504a$export$23d4598e3685cc9 = /*#__PURE__*/ (0, $7455d0776b4a504a$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $7455d0776b4a504a$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $7455d0776b4a504a$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "UserExpert"
    }, props), /*#__PURE__*/ $7455d0776b4a504a$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8 11A5 5 0 1 0 8 1a5 5 0 0 0 0 10zm6.643 4.696a6.745 6.745 0 0 0-1.62-2.673C11.772 11.76 10.013 11 8 11c-4 0-7 3-7 7v5h10m1-4.176L16.19 22 23 13"
    }));
});
$7455d0776b4a504a$var$UserExpert.displayName = 'UserExpert';


Object.keys($7455d0776b4a504a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $7455d0776b4a504a$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $7455d0776b4a504a$exports[key];
});
var $589302a57cc50bf6$exports = {};

$parcel$export($589302a57cc50bf6$exports, "__esModule", function () { return $589302a57cc50bf6$export$1e511d4a378977f5; }, function (v) { return $589302a57cc50bf6$export$1e511d4a378977f5 = v; });
$parcel$export($589302a57cc50bf6$exports, "UserFemale", function () { return $589302a57cc50bf6$export$28b514220dde9273; }, function (v) { return $589302a57cc50bf6$export$28b514220dde9273 = v; });
var $589302a57cc50bf6$export$1e511d4a378977f5;
var $589302a57cc50bf6$export$28b514220dde9273;
"use strict";
$589302a57cc50bf6$export$1e511d4a378977f5 = true;
$589302a57cc50bf6$export$28b514220dde9273 = void 0;

var $589302a57cc50bf6$var$_react = $589302a57cc50bf6$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $589302a57cc50bf6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($589302a57cc50bf6$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $589302a57cc50bf6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $589302a57cc50bf6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $589302a57cc50bf6$var$_extends() {
    return $589302a57cc50bf6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $589302a57cc50bf6$var$_extends.apply(null, arguments);
}
var $589302a57cc50bf6$var$UserFemale = $589302a57cc50bf6$export$28b514220dde9273 = /*#__PURE__*/ (0, $589302a57cc50bf6$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $589302a57cc50bf6$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $589302a57cc50bf6$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "UserFemale"
    }, props), /*#__PURE__*/ $589302a57cc50bf6$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M20 24v-5c0-4-4.06-5-5-5 3.948 0 5-2 5-2s-3.057-1.969-3-6c-.057-3-2.15-5-5-5-2.988 0-5.081 2-5 5-.081 3.969-3 6-3 6s.914 2 5 2c-1.079 0-5 1-5 5v5m12-5v5m-8-5v5"
    }));
});
$589302a57cc50bf6$var$UserFemale.displayName = 'UserFemale';


Object.keys($589302a57cc50bf6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $589302a57cc50bf6$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $589302a57cc50bf6$exports[key];
});
var $0eac9bd879dc412e$exports = {};

$parcel$export($0eac9bd879dc412e$exports, "__esModule", function () { return $0eac9bd879dc412e$export$1e511d4a378977f5; }, function (v) { return $0eac9bd879dc412e$export$1e511d4a378977f5 = v; });
$parcel$export($0eac9bd879dc412e$exports, "UserManager", function () { return $0eac9bd879dc412e$export$4c4d82ee86d9366d; }, function (v) { return $0eac9bd879dc412e$export$4c4d82ee86d9366d = v; });
var $0eac9bd879dc412e$export$1e511d4a378977f5;
var $0eac9bd879dc412e$export$4c4d82ee86d9366d;
"use strict";
$0eac9bd879dc412e$export$1e511d4a378977f5 = true;
$0eac9bd879dc412e$export$4c4d82ee86d9366d = void 0;

var $0eac9bd879dc412e$var$_react = $0eac9bd879dc412e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0eac9bd879dc412e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0eac9bd879dc412e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0eac9bd879dc412e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0eac9bd879dc412e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0eac9bd879dc412e$var$_extends() {
    return $0eac9bd879dc412e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0eac9bd879dc412e$var$_extends.apply(null, arguments);
}
var $0eac9bd879dc412e$var$UserManager = $0eac9bd879dc412e$export$4c4d82ee86d9366d = /*#__PURE__*/ (0, $0eac9bd879dc412e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0eac9bd879dc412e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0eac9bd879dc412e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "UserManager"
    }, props), /*#__PURE__*/ $0eac9bd879dc412e$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M16 12c2.374 1.183 4 3.65 4 7v4H4v-4c0-3.354 1.631-5.825 4-7m4 1a6 6 0 1 0 0-12 6 6 0 0 0 0 12zm6-6c-1.5 0-3 .36-5-2-2 2.36-4.5 3-7 2m1 6 5.025 5.257L17 13m-5 5v5"
    }));
});
$0eac9bd879dc412e$var$UserManager.displayName = 'UserManager';


Object.keys($0eac9bd879dc412e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0eac9bd879dc412e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0eac9bd879dc412e$exports[key];
});
var $91d40c0d08b7073e$exports = {};

$parcel$export($91d40c0d08b7073e$exports, "__esModule", function () { return $91d40c0d08b7073e$export$1e511d4a378977f5; }, function (v) { return $91d40c0d08b7073e$export$1e511d4a378977f5 = v; });
$parcel$export($91d40c0d08b7073e$exports, "UserNew", function () { return $91d40c0d08b7073e$export$53810e79fef0a664; }, function (v) { return $91d40c0d08b7073e$export$53810e79fef0a664 = v; });
var $91d40c0d08b7073e$export$1e511d4a378977f5;
var $91d40c0d08b7073e$export$53810e79fef0a664;
"use strict";
$91d40c0d08b7073e$export$1e511d4a378977f5 = true;
$91d40c0d08b7073e$export$53810e79fef0a664 = void 0;

var $91d40c0d08b7073e$var$_react = $91d40c0d08b7073e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $91d40c0d08b7073e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($91d40c0d08b7073e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $91d40c0d08b7073e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $91d40c0d08b7073e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $91d40c0d08b7073e$var$_extends() {
    return $91d40c0d08b7073e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $91d40c0d08b7073e$var$_extends.apply(null, arguments);
}
var $91d40c0d08b7073e$var$UserNew = $91d40c0d08b7073e$export$53810e79fef0a664 = /*#__PURE__*/ (0, $91d40c0d08b7073e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $91d40c0d08b7073e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $91d40c0d08b7073e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "UserNew"
    }, props), /*#__PURE__*/ $91d40c0d08b7073e$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M18 24V12m5 10-10-7m10 0-10 7M8 11A5 5 0 1 0 8 1a5 5 0 0 0 0 10zm5.023 2.023C11.772 11.76 10.013 11 8 11c-4 0-7 3-7 7v5h10"
    }));
});
$91d40c0d08b7073e$var$UserNew.displayName = 'UserNew';


Object.keys($91d40c0d08b7073e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $91d40c0d08b7073e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $91d40c0d08b7073e$exports[key];
});
var $f9ba88d2b31092f3$exports = {};

$parcel$export($f9ba88d2b31092f3$exports, "__esModule", function () { return $f9ba88d2b31092f3$export$1e511d4a378977f5; }, function (v) { return $f9ba88d2b31092f3$export$1e511d4a378977f5 = v; });
$parcel$export($f9ba88d2b31092f3$exports, "UserPolice", function () { return $f9ba88d2b31092f3$export$ab40e9606b4e71d8; }, function (v) { return $f9ba88d2b31092f3$export$ab40e9606b4e71d8 = v; });
var $f9ba88d2b31092f3$export$1e511d4a378977f5;
var $f9ba88d2b31092f3$export$ab40e9606b4e71d8;
"use strict";
$f9ba88d2b31092f3$export$1e511d4a378977f5 = true;
$f9ba88d2b31092f3$export$ab40e9606b4e71d8 = void 0;

var $f9ba88d2b31092f3$var$_react = $f9ba88d2b31092f3$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f9ba88d2b31092f3$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f9ba88d2b31092f3$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f9ba88d2b31092f3$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f9ba88d2b31092f3$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f9ba88d2b31092f3$var$_extends() {
    return $f9ba88d2b31092f3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f9ba88d2b31092f3$var$_extends.apply(null, arguments);
}
var $f9ba88d2b31092f3$var$UserPolice = $f9ba88d2b31092f3$export$ab40e9606b4e71d8 = /*#__PURE__*/ (0, $f9ba88d2b31092f3$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f9ba88d2b31092f3$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f9ba88d2b31092f3$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "UserPolice"
    }, props), /*#__PURE__*/ $f9ba88d2b31092f3$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M16 14c2.374 1.183 4 3.65 4 7v2H4v-2c0-3.354 1.631-5.825 4-7m4 1c3.26 0 5.903-2.686 5.903-5.999 0-.702.218-1.375 0-2.001M6.093 7c-.21.615 0 1.313 0 2.001C6.093 12.314 8.738 15 12 15M6 8h12l3-4c-1.912-1.735-5.21-3-9-3-3.836 0-7.168 1.296-9 3l3 4zm6-3a1 1 0 0 0 1-1h-2a1 1 0 0 0 1 1z"
    }));
});
$f9ba88d2b31092f3$var$UserPolice.displayName = 'UserPolice';


Object.keys($f9ba88d2b31092f3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f9ba88d2b31092f3$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f9ba88d2b31092f3$exports[key];
});
var $afc61bb912798964$exports = {};

$parcel$export($afc61bb912798964$exports, "__esModule", function () { return $afc61bb912798964$export$1e511d4a378977f5; }, function (v) { return $afc61bb912798964$export$1e511d4a378977f5 = v; });
$parcel$export($afc61bb912798964$exports, "UserSettings", function () { return $afc61bb912798964$export$6587c76ebf15601c; }, function (v) { return $afc61bb912798964$export$6587c76ebf15601c = v; });
var $afc61bb912798964$export$1e511d4a378977f5;
var $afc61bb912798964$export$6587c76ebf15601c;
"use strict";
$afc61bb912798964$export$1e511d4a378977f5 = true;
$afc61bb912798964$export$6587c76ebf15601c = void 0;

var $afc61bb912798964$var$_react = $afc61bb912798964$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $afc61bb912798964$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($afc61bb912798964$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $afc61bb912798964$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $afc61bb912798964$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $afc61bb912798964$var$_extends() {
    return $afc61bb912798964$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $afc61bb912798964$var$_extends.apply(null, arguments);
}
var $afc61bb912798964$var$UserSettings = $afc61bb912798964$export$6587c76ebf15601c = /*#__PURE__*/ (0, $afc61bb912798964$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $afc61bb912798964$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $afc61bb912798964$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "UserSettings"
    }, props), /*#__PURE__*/ $afc61bb912798964$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M18 21c-1.655 0-3-1.346-3-3s1.345-3 3-3c1.654 0 3 1.346 3 3s-1.346 3-3 3zm6-3h-3 3zm-3.879 2.122 2.121 2.12-2.12-2.12zM18.001 24v-3 3zm-4.244-1.757 2.121-2.122-2.12 2.122zM12 18h3-3zm3.878-2.121-2.12-2.121 2.12 2.12zm2.122-.88v-3 3zm2.121.88 2.121-2.121-2.12 2.12zM12.5 12.5C11.266 11.446 9.775 11 8 11c-3.866 0-7 2.03-7 7v5h10M8 11A5 5 0 1 0 8 1a5 5 0 0 0 0 10z"
    }));
});
$afc61bb912798964$var$UserSettings.displayName = 'UserSettings';


Object.keys($afc61bb912798964$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $afc61bb912798964$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $afc61bb912798964$exports[key];
});
var $f3cd4412a820c601$exports = {};

$parcel$export($f3cd4412a820c601$exports, "__esModule", function () { return $f3cd4412a820c601$export$1e511d4a378977f5; }, function (v) { return $f3cd4412a820c601$export$1e511d4a378977f5 = v; });
$parcel$export($f3cd4412a820c601$exports, "UserWorker", function () { return $f3cd4412a820c601$export$c98209c1ad7a655b; }, function (v) { return $f3cd4412a820c601$export$c98209c1ad7a655b = v; });
var $f3cd4412a820c601$export$1e511d4a378977f5;
var $f3cd4412a820c601$export$c98209c1ad7a655b;
"use strict";
$f3cd4412a820c601$export$1e511d4a378977f5 = true;
$f3cd4412a820c601$export$c98209c1ad7a655b = void 0;

var $f3cd4412a820c601$var$_react = $f3cd4412a820c601$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $f3cd4412a820c601$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f3cd4412a820c601$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f3cd4412a820c601$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f3cd4412a820c601$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f3cd4412a820c601$var$_extends() {
    return $f3cd4412a820c601$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f3cd4412a820c601$var$_extends.apply(null, arguments);
}
var $f3cd4412a820c601$var$UserWorker = $f3cd4412a820c601$export$c98209c1ad7a655b = /*#__PURE__*/ (0, $f3cd4412a820c601$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f3cd4412a820c601$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $f3cd4412a820c601$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "UserWorker"
    }, props), /*#__PURE__*/ $f3cd4412a820c601$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M3 6h18H3zm7-4v2m4-2v2m2 8c2.374 1.183 4 3.65 4 7v4H4v-4c0-3.354 1.631-5.825 4-7m4 4.5V23m0-10a6 6 0 1 0 0-12 6 6 0 0 0 0 12zm-4-1a4 4 0 1 0 8 0"
    }));
});
$f3cd4412a820c601$var$UserWorker.displayName = 'UserWorker';


Object.keys($f3cd4412a820c601$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f3cd4412a820c601$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f3cd4412a820c601$exports[key];
});
var $16263764f4172049$exports = {};

$parcel$export($16263764f4172049$exports, "__esModule", function () { return $16263764f4172049$export$1e511d4a378977f5; }, function (v) { return $16263764f4172049$export$1e511d4a378977f5 = v; });
$parcel$export($16263764f4172049$exports, "User", function () { return $16263764f4172049$export$1f44aaf2ec115b54; }, function (v) { return $16263764f4172049$export$1f44aaf2ec115b54 = v; });
var $16263764f4172049$export$1e511d4a378977f5;
var $16263764f4172049$export$1f44aaf2ec115b54;
"use strict";
$16263764f4172049$export$1e511d4a378977f5 = true;
$16263764f4172049$export$1f44aaf2ec115b54 = void 0;

var $16263764f4172049$var$_react = $16263764f4172049$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $16263764f4172049$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($16263764f4172049$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $16263764f4172049$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $16263764f4172049$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $16263764f4172049$var$_extends() {
    return $16263764f4172049$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $16263764f4172049$var$_extends.apply(null, arguments);
}
var $16263764f4172049$var$User = $16263764f4172049$export$1f44aaf2ec115b54 = /*#__PURE__*/ (0, $16263764f4172049$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $16263764f4172049$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $16263764f4172049$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "User"
    }, props), /*#__PURE__*/ $16263764f4172049$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8 24v-5m8 5v-5M3 24v-5c0-4.97 4.03-8 9-8s9 3.03 9 8v5m-9-13a5 5 0 1 0 0-10 5 5 0 0 0 0 10z"
    }));
});
$16263764f4172049$var$User.displayName = 'User';


Object.keys($16263764f4172049$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $16263764f4172049$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $16263764f4172049$exports[key];
});
var $2d7ecdd413179bbd$exports = {};

$parcel$export($2d7ecdd413179bbd$exports, "__esModule", function () { return $2d7ecdd413179bbd$export$1e511d4a378977f5; }, function (v) { return $2d7ecdd413179bbd$export$1e511d4a378977f5 = v; });
$parcel$export($2d7ecdd413179bbd$exports, "Validate", function () { return $2d7ecdd413179bbd$export$3605b1b47e399b43; }, function (v) { return $2d7ecdd413179bbd$export$3605b1b47e399b43 = v; });
var $2d7ecdd413179bbd$export$1e511d4a378977f5;
var $2d7ecdd413179bbd$export$3605b1b47e399b43;
"use strict";
$2d7ecdd413179bbd$export$1e511d4a378977f5 = true;
$2d7ecdd413179bbd$export$3605b1b47e399b43 = void 0;

var $2d7ecdd413179bbd$var$_react = $2d7ecdd413179bbd$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $2d7ecdd413179bbd$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2d7ecdd413179bbd$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2d7ecdd413179bbd$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $2d7ecdd413179bbd$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $2d7ecdd413179bbd$var$_extends() {
    return $2d7ecdd413179bbd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2d7ecdd413179bbd$var$_extends.apply(null, arguments);
}
var $2d7ecdd413179bbd$var$Validate = $2d7ecdd413179bbd$export$3605b1b47e399b43 = /*#__PURE__*/ (0, $2d7ecdd413179bbd$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $2d7ecdd413179bbd$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $2d7ecdd413179bbd$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Validate"
    }, props), /*#__PURE__*/ $2d7ecdd413179bbd$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M20 15c-1 1 1.25 3.75 0 5s-4-1-5 0-1.5 3-3 3-2-2-3-3-3.75 1.25-5 0 1-4 0-5-3-1.5-3-3 2-2 3-3-1.25-3.75 0-5 4 1 5 0 1.5-3 3-3 2 2 3 3 3.75-1.25 5 0-1 4 0 5 3 1.5 3 3-2 2-3 3zM7 12l3 3 7-7"
    }));
});
$2d7ecdd413179bbd$var$Validate.displayName = 'Validate';


Object.keys($2d7ecdd413179bbd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $2d7ecdd413179bbd$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $2d7ecdd413179bbd$exports[key];
});
var $3d24895e7ad673c7$exports = {};

$parcel$export($3d24895e7ad673c7$exports, "__esModule", function () { return $3d24895e7ad673c7$export$1e511d4a378977f5; }, function (v) { return $3d24895e7ad673c7$export$1e511d4a378977f5 = v; });
$parcel$export($3d24895e7ad673c7$exports, "Vend", function () { return $3d24895e7ad673c7$export$a0d9aa2fd11d647a; }, function (v) { return $3d24895e7ad673c7$export$a0d9aa2fd11d647a = v; });
var $3d24895e7ad673c7$export$1e511d4a378977f5;
var $3d24895e7ad673c7$export$a0d9aa2fd11d647a;
"use strict";
$3d24895e7ad673c7$export$1e511d4a378977f5 = true;
$3d24895e7ad673c7$export$a0d9aa2fd11d647a = void 0;

var $3d24895e7ad673c7$var$_react = $3d24895e7ad673c7$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $3d24895e7ad673c7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3d24895e7ad673c7$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3d24895e7ad673c7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3d24895e7ad673c7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3d24895e7ad673c7$var$_extends() {
    return $3d24895e7ad673c7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3d24895e7ad673c7$var$_extends.apply(null, arguments);
}
var $3d24895e7ad673c7$var$Vend = $3d24895e7ad673c7$export$a0d9aa2fd11d647a = /*#__PURE__*/ (0, $3d24895e7ad673c7$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3d24895e7ad673c7$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3d24895e7ad673c7$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Vend"
    }, props), /*#__PURE__*/ $3d24895e7ad673c7$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M3 2.002A.998.998 0 0 1 3.993 1h16.014c.548 0 .993.44.993 1.002V23H3V2.002zM15 1v22M3 16h12m-7 1h2m-3-1v-4m0-3V5m4 11v-4m0-3V5m6 7h1m-1-3h2m-2 11h2M3 9h12"
    }));
});
$3d24895e7ad673c7$var$Vend.displayName = 'Vend';


Object.keys($3d24895e7ad673c7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3d24895e7ad673c7$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3d24895e7ad673c7$exports[key];
});
var $b8afffabbd1d3a84$exports = {};

$parcel$export($b8afffabbd1d3a84$exports, "__esModule", function () { return $b8afffabbd1d3a84$export$1e511d4a378977f5; }, function (v) { return $b8afffabbd1d3a84$export$1e511d4a378977f5 = v; });
$parcel$export($b8afffabbd1d3a84$exports, "Venmo", function () { return $b8afffabbd1d3a84$export$c5521b90391a18e2; }, function (v) { return $b8afffabbd1d3a84$export$c5521b90391a18e2 = v; });
var $b8afffabbd1d3a84$export$1e511d4a378977f5;
var $b8afffabbd1d3a84$export$c5521b90391a18e2;
"use strict";
$b8afffabbd1d3a84$export$1e511d4a378977f5 = true;
$b8afffabbd1d3a84$export$c5521b90391a18e2 = void 0;

var $b8afffabbd1d3a84$var$_react = $b8afffabbd1d3a84$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $b8afffabbd1d3a84$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b8afffabbd1d3a84$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b8afffabbd1d3a84$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $b8afffabbd1d3a84$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b8afffabbd1d3a84$var$_extends() {
    return $b8afffabbd1d3a84$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b8afffabbd1d3a84$var$_extends.apply(null, arguments);
}
var $b8afffabbd1d3a84$var$Venmo = $b8afffabbd1d3a84$export$c5521b90391a18e2 = /*#__PURE__*/ (0, $b8afffabbd1d3a84$var$_react.forwardRef)(function(props, ref) {
    var prefix = (0, $1b754218be0a6592$export$3794798abb123ff6)('Venmo');
    return /*#__PURE__*/ $b8afffabbd1d3a84$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $b8afffabbd1d3a84$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Venmo"
    }, props), /*#__PURE__*/ $b8afffabbd1d3a84$var$_react["default"].createElement("g", {
        clipPath: "url(#" + prefix + "-a)"
    }, /*#__PURE__*/ $b8afffabbd1d3a84$var$_react["default"].createElement("path", {
        fill: "#008CFF",
        fillRule: "evenodd",
        d: "M24 12c0 6.628-5.372 12-12 12-6.627 0-12-5.372-12-12C0 5.373 5.373 0 12 0c6.628 0 12 5.373 12 12Zm-5.982-3.571c0-1-.21-1.79-.677-2.558l-4.035.814c.256.535.42 1.185.42 2.14 0 1.744-1.237 4.303-2.24 5.93L10.413 6.15l-4.431.42 2.03 12.094h5.06c2.216-2.907 4.946-7.047 4.946-10.234Z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ $b8afffabbd1d3a84$var$_react["default"].createElement("defs", null, /*#__PURE__*/ $b8afffabbd1d3a84$var$_react["default"].createElement("clipPath", {
        id: prefix + "-a"
    }, /*#__PURE__*/ $b8afffabbd1d3a84$var$_react["default"].createElement("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
    }))));
});
$b8afffabbd1d3a84$var$Venmo.displayName = 'Venmo';


Object.keys($b8afffabbd1d3a84$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $b8afffabbd1d3a84$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $b8afffabbd1d3a84$exports[key];
});
var $2f9dff41da42a8d2$exports = {};

$parcel$export($2f9dff41da42a8d2$exports, "__esModule", function () { return $2f9dff41da42a8d2$export$1e511d4a378977f5; }, function (v) { return $2f9dff41da42a8d2$export$1e511d4a378977f5 = v; });
$parcel$export($2f9dff41da42a8d2$exports, "Video", function () { return $2f9dff41da42a8d2$export$ae01dedf5c052bb; }, function (v) { return $2f9dff41da42a8d2$export$ae01dedf5c052bb = v; });
var $2f9dff41da42a8d2$export$1e511d4a378977f5;
var $2f9dff41da42a8d2$export$ae01dedf5c052bb;
"use strict";
$2f9dff41da42a8d2$export$1e511d4a378977f5 = true;
$2f9dff41da42a8d2$export$ae01dedf5c052bb = void 0;

var $2f9dff41da42a8d2$var$_react = $2f9dff41da42a8d2$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $2f9dff41da42a8d2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2f9dff41da42a8d2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2f9dff41da42a8d2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $2f9dff41da42a8d2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $2f9dff41da42a8d2$var$_extends() {
    return $2f9dff41da42a8d2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2f9dff41da42a8d2$var$_extends.apply(null, arguments);
}
var $2f9dff41da42a8d2$var$Video = $2f9dff41da42a8d2$export$ae01dedf5c052bb = /*#__PURE__*/ (0, $2f9dff41da42a8d2$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $2f9dff41da42a8d2$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $2f9dff41da42a8d2$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Video"
    }, props), /*#__PURE__*/ $2f9dff41da42a8d2$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m15 9 8-4v14l-8-4V9zM1 5h14v14H1V5z"
    }));
});
$2f9dff41da42a8d2$var$Video.displayName = 'Video';


Object.keys($2f9dff41da42a8d2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $2f9dff41da42a8d2$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $2f9dff41da42a8d2$exports[key];
});
var $bd41169723bdab71$exports = {};

$parcel$export($bd41169723bdab71$exports, "__esModule", function () { return $bd41169723bdab71$export$1e511d4a378977f5; }, function (v) { return $bd41169723bdab71$export$1e511d4a378977f5 = v; });
$parcel$export($bd41169723bdab71$exports, "View", function () { return $bd41169723bdab71$export$27a5bd065ad55220; }, function (v) { return $bd41169723bdab71$export$27a5bd065ad55220 = v; });
var $bd41169723bdab71$export$1e511d4a378977f5;
var $bd41169723bdab71$export$27a5bd065ad55220;
"use strict";
$bd41169723bdab71$export$1e511d4a378977f5 = true;
$bd41169723bdab71$export$27a5bd065ad55220 = void 0;

var $bd41169723bdab71$var$_react = $bd41169723bdab71$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $bd41169723bdab71$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($bd41169723bdab71$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $bd41169723bdab71$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $bd41169723bdab71$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $bd41169723bdab71$var$_extends() {
    return $bd41169723bdab71$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bd41169723bdab71$var$_extends.apply(null, arguments);
}
var $bd41169723bdab71$var$View = $bd41169723bdab71$export$27a5bd065ad55220 = /*#__PURE__*/ (0, $bd41169723bdab71$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $bd41169723bdab71$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $bd41169723bdab71$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "View"
    }, props), /*#__PURE__*/ $bd41169723bdab71$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 21c-5 0-11-5-11-9s6-9 11-9 11 5 11 9-6 9-11 9zm0-14a5 5 0 1 0 0 10 5 5 0 0 0 0-10z"
    }));
});
$bd41169723bdab71$var$View.displayName = 'View';


Object.keys($bd41169723bdab71$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $bd41169723bdab71$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $bd41169723bdab71$exports[key];
});
var $8d34d41d7381756d$exports = {};

$parcel$export($8d34d41d7381756d$exports, "__esModule", function () { return $8d34d41d7381756d$export$1e511d4a378977f5; }, function (v) { return $8d34d41d7381756d$export$1e511d4a378977f5 = v; });
$parcel$export($8d34d41d7381756d$exports, "Vimeo", function () { return $8d34d41d7381756d$export$61a8d60a274ac790; }, function (v) { return $8d34d41d7381756d$export$61a8d60a274ac790 = v; });
var $8d34d41d7381756d$export$1e511d4a378977f5;
var $8d34d41d7381756d$export$61a8d60a274ac790;
"use strict";
$8d34d41d7381756d$export$1e511d4a378977f5 = true;
$8d34d41d7381756d$export$61a8d60a274ac790 = void 0;

var $8d34d41d7381756d$var$_react = $8d34d41d7381756d$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $8d34d41d7381756d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8d34d41d7381756d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8d34d41d7381756d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $8d34d41d7381756d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8d34d41d7381756d$var$_extends() {
    return $8d34d41d7381756d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8d34d41d7381756d$var$_extends.apply(null, arguments);
}
var $8d34d41d7381756d$var$Vimeo = $8d34d41d7381756d$export$61a8d60a274ac790 = /*#__PURE__*/ (0, $8d34d41d7381756d$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $8d34d41d7381756d$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $8d34d41d7381756d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Vimeo"
    }, props), /*#__PURE__*/ $8d34d41d7381756d$var$_react["default"].createElement("path", {
        fill: "#1AB7EA",
        fillRule: "evenodd",
        d: "M23.988 6.802c-.107 2.336-1.738 5.534-4.894 9.595-3.264 4.24-6.024 6.36-8.282 6.36-1.4 0-2.584-1.29-3.55-3.873-.646-2.368-1.291-4.736-1.938-7.103-.718-2.582-1.488-3.874-2.312-3.874-.18 0-.808.378-1.884 1.13L0 7.583c1.184-1.04 2.352-2.08 3.502-3.123 1.58-1.364 2.767-2.082 3.556-2.155 1.868-.18 3.018 1.097 3.449 3.83.466 2.948.79 4.782.97 5.5.54 2.446 1.132 3.668 1.779 3.668.501 0 1.257-.794 2.262-2.382 1.005-1.586 1.544-2.793 1.616-3.623.144-1.369-.395-2.055-1.616-2.055-.574 0-1.167.132-1.776.393 1.18-3.862 3.433-5.738 6.76-5.632 2.466.073 3.629 1.672 3.486 4.798"
    }));
});
$8d34d41d7381756d$var$Vimeo.displayName = 'Vimeo';


Object.keys($8d34d41d7381756d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $8d34d41d7381756d$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $8d34d41d7381756d$exports[key];
});
var $a1bcfbd689406948$exports = {};

$parcel$export($a1bcfbd689406948$exports, "__esModule", function () { return $a1bcfbd689406948$export$1e511d4a378977f5; }, function (v) { return $a1bcfbd689406948$export$1e511d4a378977f5 = v; });
$parcel$export($a1bcfbd689406948$exports, "VirtualMachine", function () { return $a1bcfbd689406948$export$d4057312c1c9b9a4; }, function (v) { return $a1bcfbd689406948$export$d4057312c1c9b9a4 = v; });
var $a1bcfbd689406948$export$1e511d4a378977f5;
var $a1bcfbd689406948$export$d4057312c1c9b9a4;
"use strict";
$a1bcfbd689406948$export$1e511d4a378977f5 = true;
$a1bcfbd689406948$export$d4057312c1c9b9a4 = void 0;

var $a1bcfbd689406948$var$_react = $a1bcfbd689406948$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a1bcfbd689406948$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a1bcfbd689406948$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a1bcfbd689406948$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a1bcfbd689406948$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a1bcfbd689406948$var$_extends() {
    return $a1bcfbd689406948$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a1bcfbd689406948$var$_extends.apply(null, arguments);
}
var $a1bcfbd689406948$var$VirtualMachine = $a1bcfbd689406948$export$d4057312c1c9b9a4 = /*#__PURE__*/ (0, $a1bcfbd689406948$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a1bcfbd689406948$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a1bcfbd689406948$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "VirtualMachine"
    }, props), /*#__PURE__*/ $a1bcfbd689406948$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 23h13V10H1v13zm9-4h13V6H10v13zm-5-5h13V1H5v13z"
    }));
});
$a1bcfbd689406948$var$VirtualMachine.displayName = 'VirtualMachine';


Object.keys($a1bcfbd689406948$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a1bcfbd689406948$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a1bcfbd689406948$exports[key];
});
var $d439bfb499e3b1de$exports = {};

$parcel$export($d439bfb499e3b1de$exports, "__esModule", function () { return $d439bfb499e3b1de$export$1e511d4a378977f5; }, function (v) { return $d439bfb499e3b1de$export$1e511d4a378977f5 = v; });
$parcel$export($d439bfb499e3b1de$exports, "VirtualStorage", function () { return $d439bfb499e3b1de$export$eb50adfda516b39e; }, function (v) { return $d439bfb499e3b1de$export$eb50adfda516b39e = v; });
var $d439bfb499e3b1de$export$1e511d4a378977f5;
var $d439bfb499e3b1de$export$eb50adfda516b39e;
"use strict";
$d439bfb499e3b1de$export$1e511d4a378977f5 = true;
$d439bfb499e3b1de$export$eb50adfda516b39e = void 0;

var $d439bfb499e3b1de$var$_react = $d439bfb499e3b1de$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $d439bfb499e3b1de$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d439bfb499e3b1de$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d439bfb499e3b1de$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d439bfb499e3b1de$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d439bfb499e3b1de$var$_extends() {
    return $d439bfb499e3b1de$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d439bfb499e3b1de$var$_extends.apply(null, arguments);
}
var $d439bfb499e3b1de$var$VirtualStorage = $d439bfb499e3b1de$export$eb50adfda516b39e = /*#__PURE__*/ (0, $d439bfb499e3b1de$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d439bfb499e3b1de$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $d439bfb499e3b1de$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "VirtualStorage"
    }, props), /*#__PURE__*/ $d439bfb499e3b1de$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c4.97 0 9-2.239 9-5s-4.03-5-9-5-9 2.239-9 5 4.03 5 9 5zm0-4.5c4.97 0 9-2.239 9-5s-4.03-5-9-5-9 2.239-9 5 4.03 5 9 5zm0-5.5c4.97 0 9-2.239 9-5s-4.03-5-9-5-9 2.239-9 5 4.03 5 9 5z"
    }));
});
$d439bfb499e3b1de$var$VirtualStorage.displayName = 'VirtualStorage';


Object.keys($d439bfb499e3b1de$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $d439bfb499e3b1de$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $d439bfb499e3b1de$exports[key];
});
var $529ad4a3f3d318bb$exports = {};

$parcel$export($529ad4a3f3d318bb$exports, "__esModule", function () { return $529ad4a3f3d318bb$export$1e511d4a378977f5; }, function (v) { return $529ad4a3f3d318bb$export$1e511d4a378977f5 = v; });
$parcel$export($529ad4a3f3d318bb$exports, "Visa", function () { return $529ad4a3f3d318bb$export$aa8e94041b1dae31; }, function (v) { return $529ad4a3f3d318bb$export$aa8e94041b1dae31 = v; });
var $529ad4a3f3d318bb$export$1e511d4a378977f5;
var $529ad4a3f3d318bb$export$aa8e94041b1dae31;
"use strict";
$529ad4a3f3d318bb$export$1e511d4a378977f5 = true;
$529ad4a3f3d318bb$export$aa8e94041b1dae31 = void 0;

var $529ad4a3f3d318bb$var$_react = $529ad4a3f3d318bb$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $529ad4a3f3d318bb$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($529ad4a3f3d318bb$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $529ad4a3f3d318bb$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $529ad4a3f3d318bb$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $529ad4a3f3d318bb$var$_extends() {
    return $529ad4a3f3d318bb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $529ad4a3f3d318bb$var$_extends.apply(null, arguments);
}
var $529ad4a3f3d318bb$var$Visa = $529ad4a3f3d318bb$export$aa8e94041b1dae31 = /*#__PURE__*/ (0, $529ad4a3f3d318bb$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $529ad4a3f3d318bb$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $529ad4a3f3d318bb$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Visa"
    }, props), /*#__PURE__*/ $529ad4a3f3d318bb$var$_react["default"].createElement("path", {
        fill: "#1A1F71",
        fillRule: "evenodd",
        d: "M5.756 6.342C4.344 5.56 2.733 4.93.931 4.494l.059-.35h7.407c.997.036 1.804.355 2.082 1.422l1.61 7.743v.001l.48 2.335 4.497-11.491h4.865L14.7 20.974l-4.86.005L5.756 6.342z"
    }));
});
$529ad4a3f3d318bb$var$Visa.displayName = 'Visa';


Object.keys($529ad4a3f3d318bb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $529ad4a3f3d318bb$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $529ad4a3f3d318bb$exports[key];
});
var $2a4d0c9037c205cd$exports = {};

$parcel$export($2a4d0c9037c205cd$exports, "__esModule", function () { return $2a4d0c9037c205cd$export$1e511d4a378977f5; }, function (v) { return $2a4d0c9037c205cd$export$1e511d4a378977f5 = v; });
$parcel$export($2a4d0c9037c205cd$exports, "VmMaintenance", function () { return $2a4d0c9037c205cd$export$e57fea62f6bbb9b5; }, function (v) { return $2a4d0c9037c205cd$export$e57fea62f6bbb9b5 = v; });
var $2a4d0c9037c205cd$export$1e511d4a378977f5;
var $2a4d0c9037c205cd$export$e57fea62f6bbb9b5;
"use strict";
$2a4d0c9037c205cd$export$1e511d4a378977f5 = true;
$2a4d0c9037c205cd$export$e57fea62f6bbb9b5 = void 0;

var $2a4d0c9037c205cd$var$_react = $2a4d0c9037c205cd$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $2a4d0c9037c205cd$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2a4d0c9037c205cd$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2a4d0c9037c205cd$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $2a4d0c9037c205cd$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $2a4d0c9037c205cd$var$_extends() {
    return $2a4d0c9037c205cd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2a4d0c9037c205cd$var$_extends.apply(null, arguments);
}
var $2a4d0c9037c205cd$var$VmMaintenance = $2a4d0c9037c205cd$export$e57fea62f6bbb9b5 = /*#__PURE__*/ (0, $2a4d0c9037c205cd$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $2a4d0c9037c205cd$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $2a4d0c9037c205cd$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "VmMaintenance"
    }, props), /*#__PURE__*/ $2a4d0c9037c205cd$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M19 10V2H7v12h7V7H2v12h8m4 4 6-6m1-3a2 2 0 1 0 2 2"
    }));
});
$2a4d0c9037c205cd$var$VmMaintenance.displayName = 'VmMaintenance';


Object.keys($2a4d0c9037c205cd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $2a4d0c9037c205cd$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $2a4d0c9037c205cd$exports[key];
});
var $0e3ba0bcf66a8e39$exports = {};

$parcel$export($0e3ba0bcf66a8e39$exports, "__esModule", function () { return $0e3ba0bcf66a8e39$export$1e511d4a378977f5; }, function (v) { return $0e3ba0bcf66a8e39$export$1e511d4a378977f5 = v; });
$parcel$export($0e3ba0bcf66a8e39$exports, "Vmware", function () { return $0e3ba0bcf66a8e39$export$6fb01dbd9a4a08a6; }, function (v) { return $0e3ba0bcf66a8e39$export$6fb01dbd9a4a08a6 = v; });
var $0e3ba0bcf66a8e39$export$1e511d4a378977f5;
var $0e3ba0bcf66a8e39$export$6fb01dbd9a4a08a6;
"use strict";
$0e3ba0bcf66a8e39$export$1e511d4a378977f5 = true;
$0e3ba0bcf66a8e39$export$6fb01dbd9a4a08a6 = void 0;

var $0e3ba0bcf66a8e39$var$_react = $0e3ba0bcf66a8e39$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $0e3ba0bcf66a8e39$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0e3ba0bcf66a8e39$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0e3ba0bcf66a8e39$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $0e3ba0bcf66a8e39$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0e3ba0bcf66a8e39$var$_extends() {
    return $0e3ba0bcf66a8e39$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0e3ba0bcf66a8e39$var$_extends.apply(null, arguments);
}
var $0e3ba0bcf66a8e39$var$Vmware = $0e3ba0bcf66a8e39$export$6fb01dbd9a4a08a6 = /*#__PURE__*/ (0, $0e3ba0bcf66a8e39$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $0e3ba0bcf66a8e39$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $0e3ba0bcf66a8e39$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Vmware"
    }, props), /*#__PURE__*/ $0e3ba0bcf66a8e39$var$_react["default"].createElement("path", {
        fill: "#879AC3",
        fillRule: "evenodd",
        d: "M5.574 0c-.959 0-1.728.754-1.728 1.68v5.744H1.728C.77 7.424 0 8.18 0 9.104v12.438c0 .926.77 1.68 1.728 1.68H14.58c.96 0 1.753-.754 1.753-1.68v-2.045h5.939c.958 0 1.728-.757 1.728-1.68V5.38c0-.924-.77-1.655-1.728-1.655h-2.118V1.68c0-.926-.771-1.68-1.728-1.68H5.574zm0 .95h12.852c.42 0 .755.323.755.73v2.044H9.42c-.957 0-1.753.731-1.753 1.655v2.045H4.82V1.68c0-.407.332-.73.755-.73zm3.846 3.7h9.76v9.443a.759.759 0 0 1-.754.755h-2.093V9.103c0-.923-.794-1.68-1.753-1.68H8.641V5.38c0-.406.36-.73.779-.73zm10.734 0h2.118c.42 0 .754.323.754.73v12.437c0 .406-.334.73-.754.73h-5.94v-2.75h2.094c.957 0 1.728-.778 1.728-1.704V4.65zM1.728 8.372h2.118v5.72c0 .926.769 1.704 1.728 1.704h2.093v2.02c0 .923.796 1.68 1.753 1.68h5.939v2.045c0 .406-.356.73-.779.73H1.728a.735.735 0 0 1-.754-.73V9.103c0-.405.329-.73.754-.73zm3.091 0h2.848v6.475H5.574a.757.757 0 0 1-.755-.755v-5.72zm3.822 0h5.94c.422 0 .778.325.778.73v5.745H8.641V8.373zm0 7.424h6.718v2.75h-5.94c-.419 0-.778-.324-.778-.73v-2.02z"
    }));
});
$0e3ba0bcf66a8e39$var$Vmware.displayName = 'Vmware';


Object.keys($0e3ba0bcf66a8e39$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $0e3ba0bcf66a8e39$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $0e3ba0bcf66a8e39$exports[key];
});
var $a560e41661b887d3$exports = {};

$parcel$export($a560e41661b887d3$exports, "__esModule", function () { return $a560e41661b887d3$export$1e511d4a378977f5; }, function (v) { return $a560e41661b887d3$export$1e511d4a378977f5 = v; });
$parcel$export($a560e41661b887d3$exports, "VolumeControl", function () { return $a560e41661b887d3$export$48b39e39df750a7c; }, function (v) { return $a560e41661b887d3$export$48b39e39df750a7c = v; });
var $a560e41661b887d3$export$1e511d4a378977f5;
var $a560e41661b887d3$export$48b39e39df750a7c;
"use strict";
$a560e41661b887d3$export$1e511d4a378977f5 = true;
$a560e41661b887d3$export$48b39e39df750a7c = void 0;

var $a560e41661b887d3$var$_react = $a560e41661b887d3$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $a560e41661b887d3$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a560e41661b887d3$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a560e41661b887d3$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a560e41661b887d3$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a560e41661b887d3$var$_extends() {
    return $a560e41661b887d3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a560e41661b887d3$var$_extends.apply(null, arguments);
}
var $a560e41661b887d3$var$VolumeControl = $a560e41661b887d3$export$48b39e39df750a7c = /*#__PURE__*/ (0, $a560e41661b887d3$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a560e41661b887d3$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $a560e41661b887d3$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "VolumeControl"
    }, props), /*#__PURE__*/ $a560e41661b887d3$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12zM8 8l3 3m1 11a9.99 9.99 0 0 0 8.307-4.43A9.953 9.953 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12"
    }));
});
$a560e41661b887d3$var$VolumeControl.displayName = 'VolumeControl';


Object.keys($a560e41661b887d3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $a560e41661b887d3$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $a560e41661b887d3$exports[key];
});

Object.keys($f6223518e88a1b05$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $f6223518e88a1b05$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $f6223518e88a1b05$exports[key];
});
var $fdabd9199f498f22$exports = {};

$parcel$export($fdabd9199f498f22$exports, "__esModule", function () { return $fdabd9199f498f22$export$1e511d4a378977f5; }, function (v) { return $fdabd9199f498f22$export$1e511d4a378977f5 = v; });
$parcel$export($fdabd9199f498f22$exports, "VolumeMute", function () { return $fdabd9199f498f22$export$12840a1a62933e; }, function (v) { return $fdabd9199f498f22$export$12840a1a62933e = v; });
var $fdabd9199f498f22$export$1e511d4a378977f5;
var $fdabd9199f498f22$export$12840a1a62933e;
"use strict";
$fdabd9199f498f22$export$1e511d4a378977f5 = true;
$fdabd9199f498f22$export$12840a1a62933e = void 0;

var $fdabd9199f498f22$var$_react = $fdabd9199f498f22$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $fdabd9199f498f22$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($fdabd9199f498f22$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $fdabd9199f498f22$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $fdabd9199f498f22$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $fdabd9199f498f22$var$_extends() {
    return $fdabd9199f498f22$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fdabd9199f498f22$var$_extends.apply(null, arguments);
}
var $fdabd9199f498f22$var$VolumeMute = $fdabd9199f498f22$export$12840a1a62933e = /*#__PURE__*/ (0, $fdabd9199f498f22$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $fdabd9199f498f22$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $fdabd9199f498f22$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "VolumeMute"
    }, props), /*#__PURE__*/ $fdabd9199f498f22$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 8v8h5.099L12 21V3L6 8H1zm14 1 6 6m0-6-6 6"
    }));
});
$fdabd9199f498f22$var$VolumeMute.displayName = 'VolumeMute';


Object.keys($fdabd9199f498f22$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $fdabd9199f498f22$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $fdabd9199f498f22$exports[key];
});

Object.keys($230d45e2108d7875$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $230d45e2108d7875$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $230d45e2108d7875$exports[key];
});
var $3557f291658d1002$exports = {};

$parcel$export($3557f291658d1002$exports, "__esModule", function () { return $3557f291658d1002$export$1e511d4a378977f5; }, function (v) { return $3557f291658d1002$export$1e511d4a378977f5 = v; });
$parcel$export($3557f291658d1002$exports, "Vulnerability", function () { return $3557f291658d1002$export$64ddc546e448f388; }, function (v) { return $3557f291658d1002$export$64ddc546e448f388 = v; });
var $3557f291658d1002$export$1e511d4a378977f5;
var $3557f291658d1002$export$64ddc546e448f388;
"use strict";
$3557f291658d1002$export$1e511d4a378977f5 = true;
$3557f291658d1002$export$64ddc546e448f388 = void 0;

var $3557f291658d1002$var$_react = $3557f291658d1002$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $3557f291658d1002$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3557f291658d1002$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3557f291658d1002$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3557f291658d1002$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3557f291658d1002$var$_extends() {
    return $3557f291658d1002$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3557f291658d1002$var$_extends.apply(null, arguments);
}
var $3557f291658d1002$var$Vulnerability = $3557f291658d1002$export$64ddc546e448f388 = /*#__PURE__*/ (0, $3557f291658d1002$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3557f291658d1002$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3557f291658d1002$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Vulnerability"
    }, props), /*#__PURE__*/ $3557f291658d1002$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 0v24V0zM0 12h24H0zm17 0c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5zm-5 9c-4.962 0-9-4.037-9-9s4.038-9 9-9 9 4.037 9 9-4.038 9-9 9z"
    }));
});
$3557f291658d1002$var$Vulnerability.displayName = 'Vulnerability';


Object.keys($3557f291658d1002$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3557f291658d1002$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3557f291658d1002$exports[key];
});
var $fc6d3e8145e840b3$exports = {};

$parcel$export($fc6d3e8145e840b3$exports, "__esModule", function () { return $fc6d3e8145e840b3$export$1e511d4a378977f5; }, function (v) { return $fc6d3e8145e840b3$export$1e511d4a378977f5 = v; });
$parcel$export($fc6d3e8145e840b3$exports, "Waypoint", function () { return $fc6d3e8145e840b3$export$ab2dbb7f7727f800; }, function (v) { return $fc6d3e8145e840b3$export$ab2dbb7f7727f800 = v; });
var $fc6d3e8145e840b3$export$1e511d4a378977f5;
var $fc6d3e8145e840b3$export$ab2dbb7f7727f800;
"use strict";
$fc6d3e8145e840b3$export$1e511d4a378977f5 = true;
$fc6d3e8145e840b3$export$ab2dbb7f7727f800 = void 0;

var $fc6d3e8145e840b3$var$_react = $fc6d3e8145e840b3$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $fc6d3e8145e840b3$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($fc6d3e8145e840b3$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $fc6d3e8145e840b3$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $fc6d3e8145e840b3$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $fc6d3e8145e840b3$var$_extends() {
    return $fc6d3e8145e840b3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fc6d3e8145e840b3$var$_extends.apply(null, arguments);
}
var $fc6d3e8145e840b3$var$Waypoint = $fc6d3e8145e840b3$export$ab2dbb7f7727f800 = /*#__PURE__*/ (0, $fc6d3e8145e840b3$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $fc6d3e8145e840b3$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $fc6d3e8145e840b3$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Waypoint"
    }, props), /*#__PURE__*/ $fc6d3e8145e840b3$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m3 11 8 2 2 8 8-18z"
    }));
});
$fc6d3e8145e840b3$var$Waypoint.displayName = 'Waypoint';


Object.keys($fc6d3e8145e840b3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $fc6d3e8145e840b3$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $fc6d3e8145e840b3$exports[key];
});
var $8144ee940e1770d0$exports = {};

$parcel$export($8144ee940e1770d0$exports, "__esModule", function () { return $8144ee940e1770d0$export$1e511d4a378977f5; }, function (v) { return $8144ee940e1770d0$export$1e511d4a378977f5 = v; });
$parcel$export($8144ee940e1770d0$exports, "Webcam", function () { return $8144ee940e1770d0$export$8e57ef02c5f4056d; }, function (v) { return $8144ee940e1770d0$export$8e57ef02c5f4056d = v; });
var $8144ee940e1770d0$export$1e511d4a378977f5;
var $8144ee940e1770d0$export$8e57ef02c5f4056d;
"use strict";
$8144ee940e1770d0$export$1e511d4a378977f5 = true;
$8144ee940e1770d0$export$8e57ef02c5f4056d = void 0;

var $8144ee940e1770d0$var$_react = $8144ee940e1770d0$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $8144ee940e1770d0$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8144ee940e1770d0$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8144ee940e1770d0$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $8144ee940e1770d0$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8144ee940e1770d0$var$_extends() {
    return $8144ee940e1770d0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8144ee940e1770d0$var$_extends.apply(null, arguments);
}
var $8144ee940e1770d0$var$Webcam = $8144ee940e1770d0$export$8e57ef02c5f4056d = /*#__PURE__*/ (0, $8144ee940e1770d0$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $8144ee940e1770d0$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $8144ee940e1770d0$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Webcam"
    }, props), /*#__PURE__*/ $8144ee940e1770d0$var$_react["default"].createElement("path", {
        d: "M20 22H4",
        stroke: "#000",
        strokeWidth: "2",
        strokeLinecap: "round",
        fill: "none"
    }), /*#__PURE__*/ $8144ee940e1770d0$var$_react["default"].createElement("path", {
        d: "M15.5 18v3m-7.5.5V18",
        stroke: "#000",
        strokeWidth: "2",
        fill: "none"
    }), /*#__PURE__*/ $8144ee940e1770d0$var$_react["default"].createElement("path", {
        clipRule: "evenodd",
        d: "M12 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18z",
        stroke: "#000",
        strokeWidth: "2",
        fill: "none"
    }), /*#__PURE__*/ $8144ee940e1770d0$var$_react["default"].createElement("path", {
        clipRule: "evenodd",
        d: "M12 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z",
        stroke: "#000",
        strokeWidth: "2",
        fill: "none"
    }), /*#__PURE__*/ $8144ee940e1770d0$var$_react["default"].createElement("path", {
        clipRule: "evenodd",
        d: "M12 14a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
        stroke: "#000",
        strokeWidth: "2",
        fill: "none"
    }), /*#__PURE__*/ $8144ee940e1770d0$var$_react["default"].createElement("path", {
        clipRule: "evenodd",
        d: "M12 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
        stroke: "#000",
        strokeWidth: "2",
        fill: "none"
    }));
});
$8144ee940e1770d0$var$Webcam.displayName = 'Webcam';


Object.keys($8144ee940e1770d0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $8144ee940e1770d0$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $8144ee940e1770d0$exports[key];
});
var $67b18b1014734cbc$exports = {};

$parcel$export($67b18b1014734cbc$exports, "__esModule", function () { return $67b18b1014734cbc$export$1e511d4a378977f5; }, function (v) { return $67b18b1014734cbc$export$1e511d4a378977f5 = v; });
$parcel$export($67b18b1014734cbc$exports, "WeChat", function () { return $67b18b1014734cbc$export$7c7a48987e83ad79; }, function (v) { return $67b18b1014734cbc$export$7c7a48987e83ad79 = v; });
var $67b18b1014734cbc$export$1e511d4a378977f5;
var $67b18b1014734cbc$export$7c7a48987e83ad79;
"use strict";
$67b18b1014734cbc$export$1e511d4a378977f5 = true;
$67b18b1014734cbc$export$7c7a48987e83ad79 = void 0;

var $67b18b1014734cbc$var$_react = $67b18b1014734cbc$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $67b18b1014734cbc$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($67b18b1014734cbc$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $67b18b1014734cbc$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $67b18b1014734cbc$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $67b18b1014734cbc$var$_extends() {
    return $67b18b1014734cbc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $67b18b1014734cbc$var$_extends.apply(null, arguments);
}
var $67b18b1014734cbc$var$WeChat = $67b18b1014734cbc$export$7c7a48987e83ad79 = /*#__PURE__*/ (0, $67b18b1014734cbc$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $67b18b1014734cbc$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $67b18b1014734cbc$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "WeChat"
    }, props), /*#__PURE__*/ $67b18b1014734cbc$var$_react["default"].createElement("path", {
        fill: "#51CE5E",
        fillRule: "evenodd",
        d: "M21.502 19.228C23.026 18.123 24 16.49 24 14.674c0-3.326-3.237-6.023-7.229-6.023s-7.229 2.697-7.229 6.023c0 3.327 3.237 6.024 7.229 6.024.825 0 1.621-.117 2.36-.33l.212-.032c.139 0 .265.043.384.111l1.583.914.139.045a.241.241 0 0 0 .241-.241l-.039-.176-.326-1.215-.025-.154a.48.48 0 0 1 .202-.392ZM8.675 2C3.884 2 0 5.236 0 9.229c0 2.178 1.168 4.139 2.997 5.464a.575.575 0 0 1 .243.471l-.03.184-.391 1.458-.047.211c0 .16.13.29.289.29l.168-.054 1.899-1.097a.908.908 0 0 1 .46-.133l.255.038c.886.255 1.842.397 2.832.397l.476-.012a5.586 5.586 0 0 1-.291-1.771c0-3.641 3.542-6.593 7.911-6.593l.471.012C16.589 4.641 13.002 2 8.675 2Zm5.686 11.711a.964.964 0 1 1 .001-1.927.964.964 0 0 1-.001 1.927Zm4.82 0a.964.964 0 1 1 0-1.928.964.964 0 0 1 0 1.928ZM5.783 8.072a1.156 1.156 0 1 1 0-2.312 1.156 1.156 0 0 1 0 2.312Zm5.783 0a1.156 1.156 0 1 1 0-2.312 1.156 1.156 0 0 1 0 2.312Z",
        clipRule: "evenodd"
    }));
});
$67b18b1014734cbc$var$WeChat.displayName = 'WeChat';


Object.keys($67b18b1014734cbc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $67b18b1014734cbc$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $67b18b1014734cbc$exports[key];
});
var $2d41a1fd15360f46$exports = {};

$parcel$export($2d41a1fd15360f46$exports, "__esModule", function () { return $2d41a1fd15360f46$export$1e511d4a378977f5; }, function (v) { return $2d41a1fd15360f46$export$1e511d4a378977f5 = v; });
$parcel$export($2d41a1fd15360f46$exports, "WhatsApp", function () { return $2d41a1fd15360f46$export$509779fa2500ebe5; }, function (v) { return $2d41a1fd15360f46$export$509779fa2500ebe5 = v; });
var $2d41a1fd15360f46$export$1e511d4a378977f5;
var $2d41a1fd15360f46$export$509779fa2500ebe5;
"use strict";
$2d41a1fd15360f46$export$1e511d4a378977f5 = true;
$2d41a1fd15360f46$export$509779fa2500ebe5 = void 0;

var $2d41a1fd15360f46$var$_react = $2d41a1fd15360f46$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $2d41a1fd15360f46$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2d41a1fd15360f46$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2d41a1fd15360f46$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $2d41a1fd15360f46$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $2d41a1fd15360f46$var$_extends() {
    return $2d41a1fd15360f46$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2d41a1fd15360f46$var$_extends.apply(null, arguments);
}
var $2d41a1fd15360f46$var$WhatsApp = $2d41a1fd15360f46$export$509779fa2500ebe5 = /*#__PURE__*/ (0, $2d41a1fd15360f46$var$_react.forwardRef)(function(props, ref) {
    var prefix = (0, $1b754218be0a6592$export$3794798abb123ff6)('WhatsApp');
    return /*#__PURE__*/ $2d41a1fd15360f46$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $2d41a1fd15360f46$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "WhatsApp"
    }, props), /*#__PURE__*/ $2d41a1fd15360f46$var$_react["default"].createElement("g", {
        clipPath: "url(#" + prefix + "-a)"
    }, /*#__PURE__*/ $2d41a1fd15360f46$var$_react["default"].createElement("path", {
        fill: "#51CE5E",
        d: "m.057 24 1.687-6.163a11.867 11.867 0 0 1-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 0 1 8.413 3.488 11.824 11.824 0 0 1 3.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 0 1-5.688-1.448L.057 24Zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.89 9.884 0 2.225.652 3.891 1.747 5.634l-1 3.648 3.743-.981Zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.67.149-.197.297-.767.967-.94 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.15-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.67-1.611-.916-2.206-.242-.579-.487-.501-.67-.51l-.57-.01c-.197 0-.52.074-.791.372-.272.298-1.04 1.016-1.04 2.479s1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.57-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414Z"
    })), /*#__PURE__*/ $2d41a1fd15360f46$var$_react["default"].createElement("defs", null, /*#__PURE__*/ $2d41a1fd15360f46$var$_react["default"].createElement("clipPath", {
        id: prefix + "-a"
    }, /*#__PURE__*/ $2d41a1fd15360f46$var$_react["default"].createElement("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
    }))));
});
$2d41a1fd15360f46$var$WhatsApp.displayName = 'WhatsApp';


Object.keys($2d41a1fd15360f46$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $2d41a1fd15360f46$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $2d41a1fd15360f46$exports[key];
});
var $70313b86172daba8$exports = {};

$parcel$export($70313b86172daba8$exports, "__esModule", function () { return $70313b86172daba8$export$1e511d4a378977f5; }, function (v) { return $70313b86172daba8$export$1e511d4a378977f5 = v; });
$parcel$export($70313b86172daba8$exports, "WheelchairActive", function () { return $70313b86172daba8$export$e19d807aaa664f5b; }, function (v) { return $70313b86172daba8$export$e19d807aaa664f5b = v; });
var $70313b86172daba8$export$1e511d4a378977f5;
var $70313b86172daba8$export$e19d807aaa664f5b;
"use strict";
$70313b86172daba8$export$1e511d4a378977f5 = true;
$70313b86172daba8$export$e19d807aaa664f5b = void 0;

var $70313b86172daba8$var$_react = $70313b86172daba8$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $70313b86172daba8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($70313b86172daba8$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $70313b86172daba8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $70313b86172daba8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $70313b86172daba8$var$_extends() {
    return $70313b86172daba8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $70313b86172daba8$var$_extends.apply(null, arguments);
}
var $70313b86172daba8$var$WheelchairActive = $70313b86172daba8$export$e19d807aaa664f5b = /*#__PURE__*/ (0, $70313b86172daba8$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $70313b86172daba8$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $70313b86172daba8$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "WheelchairActive"
    }, props), /*#__PURE__*/ $70313b86172daba8$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m7 6 3-3 7 3v2l-3 3M9 22a6 6 0 1 0 0-12 6 6 0 0 0 0 12zm0-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm5-5 5 3-2 6m2-17a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-6 6 4-4m-6 4 4-4"
    }));
});
$70313b86172daba8$var$WheelchairActive.displayName = 'WheelchairActive';


Object.keys($70313b86172daba8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $70313b86172daba8$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $70313b86172daba8$exports[key];
});
var $88d5ebee14c1d529$exports = {};

$parcel$export($88d5ebee14c1d529$exports, "__esModule", function () { return $88d5ebee14c1d529$export$1e511d4a378977f5; }, function (v) { return $88d5ebee14c1d529$export$1e511d4a378977f5 = v; });
$parcel$export($88d5ebee14c1d529$exports, "Wheelchair", function () { return $88d5ebee14c1d529$export$a4708350b121814; }, function (v) { return $88d5ebee14c1d529$export$a4708350b121814 = v; });
var $88d5ebee14c1d529$export$1e511d4a378977f5;
var $88d5ebee14c1d529$export$a4708350b121814;
"use strict";
$88d5ebee14c1d529$export$1e511d4a378977f5 = true;
$88d5ebee14c1d529$export$a4708350b121814 = void 0;

var $88d5ebee14c1d529$var$_react = $88d5ebee14c1d529$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $88d5ebee14c1d529$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($88d5ebee14c1d529$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $88d5ebee14c1d529$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $88d5ebee14c1d529$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $88d5ebee14c1d529$var$_extends() {
    return $88d5ebee14c1d529$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $88d5ebee14c1d529$var$_extends.apply(null, arguments);
}
var $88d5ebee14c1d529$var$Wheelchair = $88d5ebee14c1d529$export$a4708350b121814 = /*#__PURE__*/ (0, $88d5ebee14c1d529$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $88d5ebee14c1d529$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $88d5ebee14c1d529$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Wheelchair"
    }, props), /*#__PURE__*/ $88d5ebee14c1d529$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M10 3v9h7l2 6h2m-6-9H9a6 6 0 1 0 6 6M11 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
    }));
});
$88d5ebee14c1d529$var$Wheelchair.displayName = 'Wheelchair';


Object.keys($88d5ebee14c1d529$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $88d5ebee14c1d529$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $88d5ebee14c1d529$exports[key];
});
var $e427a435e9092f2e$exports = {};

$parcel$export($e427a435e9092f2e$exports, "__esModule", function () { return $e427a435e9092f2e$export$1e511d4a378977f5; }, function (v) { return $e427a435e9092f2e$export$1e511d4a378977f5 = v; });
$parcel$export($e427a435e9092f2e$exports, "WifiLow", function () { return $e427a435e9092f2e$export$ff8c29138e11ed2a; }, function (v) { return $e427a435e9092f2e$export$ff8c29138e11ed2a = v; });
var $e427a435e9092f2e$export$1e511d4a378977f5;
var $e427a435e9092f2e$export$ff8c29138e11ed2a;
"use strict";
$e427a435e9092f2e$export$1e511d4a378977f5 = true;
$e427a435e9092f2e$export$ff8c29138e11ed2a = void 0;

var $e427a435e9092f2e$var$_react = $e427a435e9092f2e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e427a435e9092f2e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e427a435e9092f2e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e427a435e9092f2e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e427a435e9092f2e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e427a435e9092f2e$var$_extends() {
    return $e427a435e9092f2e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e427a435e9092f2e$var$_extends.apply(null, arguments);
}
var $e427a435e9092f2e$var$WifiLow = $e427a435e9092f2e$export$ff8c29138e11ed2a = /*#__PURE__*/ (0, $e427a435e9092f2e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e427a435e9092f2e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e427a435e9092f2e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "WifiLow"
    }, props), /*#__PURE__*/ $e427a435e9092f2e$var$_react["default"].createElement("g", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2"
    }, /*#__PURE__*/ $e427a435e9092f2e$var$_react["default"].createElement("path", {
        d: "M12 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm-4.243-6.243a6 6 0 0 1 8.486 0"
    }), /*#__PURE__*/ $e427a435e9092f2e$var$_react["default"].createElement("path", {
        strokeOpacity: ".2",
        d: "M4.929 10.929c3.905-3.905 10.237-3.905 14.142 0M2.101 8.1c5.467-5.468 14.331-5.468 19.798 0",
        opacity: ".8"
    })));
});
$e427a435e9092f2e$var$WifiLow.displayName = 'WifiLow';


Object.keys($e427a435e9092f2e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e427a435e9092f2e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e427a435e9092f2e$exports[key];
});
var $e656802b26e9640f$exports = {};

$parcel$export($e656802b26e9640f$exports, "__esModule", function () { return $e656802b26e9640f$export$1e511d4a378977f5; }, function (v) { return $e656802b26e9640f$export$1e511d4a378977f5 = v; });
$parcel$export($e656802b26e9640f$exports, "WifiMedium", function () { return $e656802b26e9640f$export$d4a49169b74d95e; }, function (v) { return $e656802b26e9640f$export$d4a49169b74d95e = v; });
var $e656802b26e9640f$export$1e511d4a378977f5;
var $e656802b26e9640f$export$d4a49169b74d95e;
"use strict";
$e656802b26e9640f$export$1e511d4a378977f5 = true;
$e656802b26e9640f$export$d4a49169b74d95e = void 0;

var $e656802b26e9640f$var$_react = $e656802b26e9640f$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e656802b26e9640f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e656802b26e9640f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e656802b26e9640f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e656802b26e9640f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e656802b26e9640f$var$_extends() {
    return $e656802b26e9640f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e656802b26e9640f$var$_extends.apply(null, arguments);
}
var $e656802b26e9640f$var$WifiMedium = $e656802b26e9640f$export$d4a49169b74d95e = /*#__PURE__*/ (0, $e656802b26e9640f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e656802b26e9640f$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e656802b26e9640f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "WifiMedium"
    }, props), /*#__PURE__*/ $e656802b26e9640f$var$_react["default"].createElement("g", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2"
    }, /*#__PURE__*/ $e656802b26e9640f$var$_react["default"].createElement("path", {
        d: "M12 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm-4.243-6.243a6 6 0 0 1 8.486 0M4.929 10.93c3.905-3.905 10.237-3.905 14.142 0"
    }), /*#__PURE__*/ $e656802b26e9640f$var$_react["default"].createElement("path", {
        strokeOpacity: ".2",
        d: "M2.1 8.1c5.468-5.467 14.332-5.467 19.8 0",
        opacity: ".8"
    })));
});
$e656802b26e9640f$var$WifiMedium.displayName = 'WifiMedium';


Object.keys($e656802b26e9640f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e656802b26e9640f$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e656802b26e9640f$exports[key];
});
var $c6a2784b06060156$exports = {};

$parcel$export($c6a2784b06060156$exports, "__esModule", function () { return $c6a2784b06060156$export$1e511d4a378977f5; }, function (v) { return $c6a2784b06060156$export$1e511d4a378977f5 = v; });
$parcel$export($c6a2784b06060156$exports, "WifiNone", function () { return $c6a2784b06060156$export$4e29cbb9af8c33c0; }, function (v) { return $c6a2784b06060156$export$4e29cbb9af8c33c0 = v; });
var $c6a2784b06060156$export$1e511d4a378977f5;
var $c6a2784b06060156$export$4e29cbb9af8c33c0;
"use strict";
$c6a2784b06060156$export$1e511d4a378977f5 = true;
$c6a2784b06060156$export$4e29cbb9af8c33c0 = void 0;

var $c6a2784b06060156$var$_react = $c6a2784b06060156$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $c6a2784b06060156$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c6a2784b06060156$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c6a2784b06060156$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c6a2784b06060156$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c6a2784b06060156$var$_extends() {
    return $c6a2784b06060156$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c6a2784b06060156$var$_extends.apply(null, arguments);
}
var $c6a2784b06060156$var$WifiNone = $c6a2784b06060156$export$4e29cbb9af8c33c0 = /*#__PURE__*/ (0, $c6a2784b06060156$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c6a2784b06060156$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $c6a2784b06060156$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "WifiNone"
    }, props), /*#__PURE__*/ $c6a2784b06060156$var$_react["default"].createElement("g", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2"
    }, /*#__PURE__*/ $c6a2784b06060156$var$_react["default"].createElement("circle", {
        cx: "12",
        cy: "18",
        r: "2"
    }), /*#__PURE__*/ $c6a2784b06060156$var$_react["default"].createElement("path", {
        strokeOpacity: ".2",
        d: "M7.757 13.757a6 6 0 0 1 8.486 0M4.929 10.93c3.905-3.905 10.237-3.905 14.142 0M2.101 8.1c5.467-5.468 14.331-5.468 19.798 0",
        opacity: ".8"
    })));
});
$c6a2784b06060156$var$WifiNone.displayName = 'WifiNone';


Object.keys($c6a2784b06060156$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $c6a2784b06060156$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $c6a2784b06060156$exports[key];
});
var $9c871c3dc473882e$exports = {};

$parcel$export($9c871c3dc473882e$exports, "__esModule", function () { return $9c871c3dc473882e$export$1e511d4a378977f5; }, function (v) { return $9c871c3dc473882e$export$1e511d4a378977f5 = v; });
$parcel$export($9c871c3dc473882e$exports, "Wifi", function () { return $9c871c3dc473882e$export$218f293018a09125; }, function (v) { return $9c871c3dc473882e$export$218f293018a09125 = v; });
var $9c871c3dc473882e$export$1e511d4a378977f5;
var $9c871c3dc473882e$export$218f293018a09125;
"use strict";
$9c871c3dc473882e$export$1e511d4a378977f5 = true;
$9c871c3dc473882e$export$218f293018a09125 = void 0;

var $9c871c3dc473882e$var$_react = $9c871c3dc473882e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $9c871c3dc473882e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9c871c3dc473882e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9c871c3dc473882e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $9c871c3dc473882e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $9c871c3dc473882e$var$_extends() {
    return $9c871c3dc473882e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9c871c3dc473882e$var$_extends.apply(null, arguments);
}
var $9c871c3dc473882e$var$Wifi = $9c871c3dc473882e$export$218f293018a09125 = /*#__PURE__*/ (0, $9c871c3dc473882e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $9c871c3dc473882e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $9c871c3dc473882e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Wifi"
    }, props), /*#__PURE__*/ $9c871c3dc473882e$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm-4.243-6.243a6 6 0 0 1 8.486 0M4.929 10.93c3.905-3.905 10.237-3.905 14.142 0M2.101 8.1c5.467-5.468 14.331-5.468 19.798 0"
    }));
});
$9c871c3dc473882e$var$Wifi.displayName = 'Wifi';


Object.keys($9c871c3dc473882e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $9c871c3dc473882e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $9c871c3dc473882e$exports[key];
});
var $71715b272925fd5e$exports = {};

$parcel$export($71715b272925fd5e$exports, "__esModule", function () { return $71715b272925fd5e$export$1e511d4a378977f5; }, function (v) { return $71715b272925fd5e$export$1e511d4a378977f5 = v; });
$parcel$export($71715b272925fd5e$exports, "WindowsLegacy", function () { return $71715b272925fd5e$export$ccd9d906842ef61; }, function (v) { return $71715b272925fd5e$export$ccd9d906842ef61 = v; });
var $71715b272925fd5e$export$1e511d4a378977f5;
var $71715b272925fd5e$export$ccd9d906842ef61;
"use strict";
$71715b272925fd5e$export$1e511d4a378977f5 = true;
$71715b272925fd5e$export$ccd9d906842ef61 = void 0;

var $71715b272925fd5e$var$_react = $71715b272925fd5e$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $71715b272925fd5e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($71715b272925fd5e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $71715b272925fd5e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $71715b272925fd5e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $71715b272925fd5e$var$_extends() {
    return $71715b272925fd5e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $71715b272925fd5e$var$_extends.apply(null, arguments);
}
var $71715b272925fd5e$var$WindowsLegacy = $71715b272925fd5e$export$ccd9d906842ef61 = /*#__PURE__*/ (0, $71715b272925fd5e$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $71715b272925fd5e$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $71715b272925fd5e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "WindowsLegacy"
    }, props), /*#__PURE__*/ $71715b272925fd5e$var$_react["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $71715b272925fd5e$var$_react["default"].createElement("path", {
        fill: "#F35325",
        d: "m2.613 10.096.282-.985c.666-2.301 1.332-4.603 1.996-6.904.026-.09.054-.164.157-.205 1.15-.461 2.327-.825 3.565-.959 1.666-.18 3.195.21 4.607 1.094.184.115.362.24.55.347.12.069.136.142.098.272-.553 1.897-1.1 3.795-1.648 5.694-.192.661-.388 1.322-.574 1.986-.04.148-.075.173-.211.08-.814-.553-1.672-1.017-2.633-1.263-1.212-.312-2.423-.25-3.632.015-.862.19-1.692.474-2.557.828"
    }), /*#__PURE__*/ $71715b272925fd5e$var$_react["default"].createElement("path", {
        fill: "#81BC06",
        d: "M17.277 13.025c-1.529.01-2.878-.526-4.134-1.351-.355-.234-.354-.232-.238-.635.712-2.458 1.421-4.918 2.134-7.376.07-.241.019-.285.29-.104.895.6 1.839 1.094 2.908 1.31 1.128.228 2.248.15 3.362-.099.7-.157 1.38-.377 2.048-.635.096-.036.195-.098.294-.007.097.09.052.19.022.293-.713 2.465-1.426 4.93-2.134 7.397-.033.115-.093.171-.2.214-1.162.465-2.351.831-3.604.95-.248.025-.498.03-.748.043"
    }), /*#__PURE__*/ $71715b272925fd5e$var$_react["default"].createElement("path", {
        fill: "#FFBA08",
        d: "m21.377 13.352-.442 1.533c-.602 2.08-1.206 4.162-1.801 6.245a.437.437 0 0 1-.298.32c-1.026.395-2.069.72-3.163.874-1.693.238-3.268-.082-4.73-.963-.242-.146-.475-.306-.72-.45-.12-.07-.13-.144-.093-.272.523-1.796 1.04-3.594 1.56-5.392l.635-2.194c.067-.23.068-.23.28-.09.76.501 1.551.936 2.434 1.186 1.273.36 2.547.3 3.822.018.849-.187 1.668-.472 2.516-.815"
    }), /*#__PURE__*/ $71715b272925fd5e$var$_react["default"].createElement("path", {
        fill: "#05A6F0",
        d: "m11.179 12.047-.366 1.261c-.623 2.156-1.249 4.312-1.866 6.47-.054.185-.103.19-.253.088-.857-.585-1.764-1.065-2.787-1.298-1.157-.264-2.309-.193-3.458.059-.72.157-1.418.384-2.106.649-.09.034-.183.085-.277.008-.105-.086-.06-.191-.03-.291l2.132-7.377a.282.282 0 0 1 .185-.203c1.18-.475 2.389-.844 3.663-.962 1.571-.144 3.026.212 4.372 1.029.23.14.457.285.684.43.058.038.138.07.107.137"
    })));
});
$71715b272925fd5e$var$WindowsLegacy.displayName = 'WindowsLegacy';


Object.keys($71715b272925fd5e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $71715b272925fd5e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $71715b272925fd5e$exports[key];
});
var $3036bba6febea5bf$exports = {};

$parcel$export($3036bba6febea5bf$exports, "__esModule", function () { return $3036bba6febea5bf$export$1e511d4a378977f5; }, function (v) { return $3036bba6febea5bf$export$1e511d4a378977f5 = v; });
$parcel$export($3036bba6febea5bf$exports, "Windows", function () { return $3036bba6febea5bf$export$5116cfbd80368cab; }, function (v) { return $3036bba6febea5bf$export$5116cfbd80368cab = v; });
var $3036bba6febea5bf$export$1e511d4a378977f5;
var $3036bba6febea5bf$export$5116cfbd80368cab;
"use strict";
$3036bba6febea5bf$export$1e511d4a378977f5 = true;
$3036bba6febea5bf$export$5116cfbd80368cab = void 0;

var $3036bba6febea5bf$var$_react = $3036bba6febea5bf$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $3036bba6febea5bf$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3036bba6febea5bf$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3036bba6febea5bf$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3036bba6febea5bf$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3036bba6febea5bf$var$_extends() {
    return $3036bba6febea5bf$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3036bba6febea5bf$var$_extends.apply(null, arguments);
}
var $3036bba6febea5bf$var$Windows = $3036bba6febea5bf$export$5116cfbd80368cab = /*#__PURE__*/ (0, $3036bba6febea5bf$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3036bba6febea5bf$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $3036bba6febea5bf$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Windows"
    }, props), /*#__PURE__*/ $3036bba6febea5bf$var$_react["default"].createElement("path", {
        fill: "#001589",
        fillRule: "evenodd",
        d: "M23.923 0 10.959 1.893v9.588l12.964-.102V0zM0 3.398l.009 8.155 9.773-.055-.004-9.432L0 3.398zm.008 17.283 9.773 1.344-.008-9.44-9.766-.063.001 8.159zm10.951 1.49L23.923 24l.004-11.326-12.986-.022.018 9.519z"
    }));
});
$3036bba6febea5bf$var$Windows.displayName = 'Windows';


Object.keys($3036bba6febea5bf$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $3036bba6febea5bf$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $3036bba6febea5bf$exports[key];
});
var $841d70eaed441175$exports = {};

$parcel$export($841d70eaed441175$exports, "__esModule", function () { return $841d70eaed441175$export$1e511d4a378977f5; }, function (v) { return $841d70eaed441175$export$1e511d4a378977f5 = v; });
$parcel$export($841d70eaed441175$exports, "Wordpress", function () { return $841d70eaed441175$export$5a2f5a2e1a7d4f4e; }, function (v) { return $841d70eaed441175$export$5a2f5a2e1a7d4f4e = v; });
var $841d70eaed441175$export$1e511d4a378977f5;
var $841d70eaed441175$export$5a2f5a2e1a7d4f4e;
"use strict";
$841d70eaed441175$export$1e511d4a378977f5 = true;
$841d70eaed441175$export$5a2f5a2e1a7d4f4e = void 0;

var $841d70eaed441175$var$_react = $841d70eaed441175$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $841d70eaed441175$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($841d70eaed441175$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $841d70eaed441175$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $841d70eaed441175$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $841d70eaed441175$var$_extends() {
    return $841d70eaed441175$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $841d70eaed441175$var$_extends.apply(null, arguments);
}
var $841d70eaed441175$var$Wordpress = $841d70eaed441175$export$5a2f5a2e1a7d4f4e = /*#__PURE__*/ (0, $841d70eaed441175$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $841d70eaed441175$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $841d70eaed441175$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Wordpress"
    }, props), /*#__PURE__*/ $841d70eaed441175$var$_react["default"].createElement("path", {
        fill: "#21759B",
        fillRule: "evenodd",
        d: "M0 12a12 12 0 0 0 6.763 10.799L1.039 7.116A11.958 11.958 0 0 0 0 11.999m20.1-.605c0-1.483-.533-2.51-.99-3.309-.607-.99-1.178-1.826-1.178-2.815 0-1.103.836-2.13 2.015-2.13.053 0 .104.007.155.01A11.954 11.954 0 0 0 12 0C7.807 0 4.12 2.151 1.973 5.408c.282.01.548.014.773.014 1.255 0 3.198-.152 3.198-.152.646-.038.723.913.076.989 0 0-.65.076-1.373.114l4.37 12.998 2.626-7.876-1.869-5.121a22.087 22.087 0 0 1-1.26-.115c-.646-.038-.57-1.027.077-.989 0 0 1.982.153 3.16.153 1.256 0 3.199-.153 3.199-.153.647-.038.723.913.076.989 0 0-.65.076-1.373.114l4.337 12.899 1.197-3.999c.518-1.66.913-2.852.913-3.879m-7.89 1.655L8.61 23.51a11.988 11.988 0 0 0 7.374-.192 1.14 1.14 0 0 1-.085-.165L12.21 13.05zm10.32-6.807c.051.383.08.792.08 1.234 0 1.217-.228 2.586-.912 4.298l-3.666 10.597A11.993 11.993 0 0 0 24 12c0-2.086-.533-4.047-1.47-5.757"
    }));
});
$841d70eaed441175$var$Wordpress.displayName = 'Wordpress';


Object.keys($841d70eaed441175$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $841d70eaed441175$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $841d70eaed441175$exports[key];
});
var $bdcdb0a4e201cca8$exports = {};

$parcel$export($bdcdb0a4e201cca8$exports, "__esModule", function () { return $bdcdb0a4e201cca8$export$1e511d4a378977f5; }, function (v) { return $bdcdb0a4e201cca8$export$1e511d4a378977f5 = v; });
$parcel$export($bdcdb0a4e201cca8$exports, "Workshop", function () { return $bdcdb0a4e201cca8$export$6e5f9bb1ece75cb9; }, function (v) { return $bdcdb0a4e201cca8$export$6e5f9bb1ece75cb9 = v; });
var $bdcdb0a4e201cca8$export$1e511d4a378977f5;
var $bdcdb0a4e201cca8$export$6e5f9bb1ece75cb9;
"use strict";
$bdcdb0a4e201cca8$export$1e511d4a378977f5 = true;
$bdcdb0a4e201cca8$export$6e5f9bb1ece75cb9 = void 0;

var $bdcdb0a4e201cca8$var$_react = $bdcdb0a4e201cca8$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $bdcdb0a4e201cca8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($bdcdb0a4e201cca8$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $bdcdb0a4e201cca8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $bdcdb0a4e201cca8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $bdcdb0a4e201cca8$var$_extends() {
    return $bdcdb0a4e201cca8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bdcdb0a4e201cca8$var$_extends.apply(null, arguments);
}
var $bdcdb0a4e201cca8$var$Workshop = $bdcdb0a4e201cca8$export$6e5f9bb1ece75cb9 = /*#__PURE__*/ (0, $bdcdb0a4e201cca8$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $bdcdb0a4e201cca8$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $bdcdb0a4e201cca8$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Workshop"
    }, props), /*#__PURE__*/ $bdcdb0a4e201cca8$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M19 7s-5 7-12.5 7c-2 0-5.5 1-5.5 5v4h11v-4c0-2.5 3-1 7-8l-1.5-1.5M3 5V2h20v14h-3M11 1h4v2h-4V1zM6.5 14a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"
    }));
});
$bdcdb0a4e201cca8$var$Workshop.displayName = 'Workshop';


Object.keys($bdcdb0a4e201cca8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $bdcdb0a4e201cca8$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $bdcdb0a4e201cca8$exports[key];
});
var $ffb68cbf2feb89b3$exports = {};

$parcel$export($ffb68cbf2feb89b3$exports, "__esModule", function () { return $ffb68cbf2feb89b3$export$1e511d4a378977f5; }, function (v) { return $ffb68cbf2feb89b3$export$1e511d4a378977f5 = v; });
$parcel$export($ffb68cbf2feb89b3$exports, "X", function () { return $ffb68cbf2feb89b3$export$78acf4525d8a74c4; }, function (v) { return $ffb68cbf2feb89b3$export$78acf4525d8a74c4 = v; });
var $ffb68cbf2feb89b3$export$1e511d4a378977f5;
var $ffb68cbf2feb89b3$export$78acf4525d8a74c4;
"use strict";
$ffb68cbf2feb89b3$export$1e511d4a378977f5 = true;
$ffb68cbf2feb89b3$export$78acf4525d8a74c4 = void 0;

var $ffb68cbf2feb89b3$var$_react = $ffb68cbf2feb89b3$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $ffb68cbf2feb89b3$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ffb68cbf2feb89b3$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ffb68cbf2feb89b3$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ffb68cbf2feb89b3$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ffb68cbf2feb89b3$var$_extends() {
    return $ffb68cbf2feb89b3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ffb68cbf2feb89b3$var$_extends.apply(null, arguments);
}
var $ffb68cbf2feb89b3$var$X = $ffb68cbf2feb89b3$export$78acf4525d8a74c4 = /*#__PURE__*/ (0, $ffb68cbf2feb89b3$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $ffb68cbf2feb89b3$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $ffb68cbf2feb89b3$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "X"
    }, props), /*#__PURE__*/ $ffb68cbf2feb89b3$var$_react["default"].createElement("path", {
        fill: "#000",
        d: "m.058 1 9.267 12.39L0 23.462h2.099l8.163-8.82 6.596 8.82H24l-9.788-13.087L22.892 1h-2.1l-7.517 8.122L7.2 1H.058Zm3.087 1.546h3.28l14.488 19.37h-3.28L3.145 2.547Z"
    }));
});
$ffb68cbf2feb89b3$var$X.displayName = 'X';


Object.keys($ffb68cbf2feb89b3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $ffb68cbf2feb89b3$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $ffb68cbf2feb89b3$exports[key];
});
var $fb6f83b450933cdb$exports = {};

$parcel$export($fb6f83b450933cdb$exports, "__esModule", function () { return $fb6f83b450933cdb$export$1e511d4a378977f5; }, function (v) { return $fb6f83b450933cdb$export$1e511d4a378977f5 = v; });
$parcel$export($fb6f83b450933cdb$exports, "Xing", function () { return $fb6f83b450933cdb$export$d6a8c2212db5838f; }, function (v) { return $fb6f83b450933cdb$export$d6a8c2212db5838f = v; });
var $fb6f83b450933cdb$export$1e511d4a378977f5;
var $fb6f83b450933cdb$export$d6a8c2212db5838f;
"use strict";
$fb6f83b450933cdb$export$1e511d4a378977f5 = true;
$fb6f83b450933cdb$export$d6a8c2212db5838f = void 0;

var $fb6f83b450933cdb$var$_react = $fb6f83b450933cdb$var$_interopRequireWildcard((parcelRequire("2xPiy")));


function $fb6f83b450933cdb$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($fb6f83b450933cdb$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $fb6f83b450933cdb$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $fb6f83b450933cdb$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $fb6f83b450933cdb$var$_extends() {
    return $fb6f83b450933cdb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fb6f83b450933cdb$var$_extends.apply(null, arguments);
}
var $fb6f83b450933cdb$var$Xing = $fb6f83b450933cdb$export$d6a8c2212db5838f = /*#__PURE__*/ (0, $fb6f83b450933cdb$var$_react.forwardRef)(function(props, ref) {
    var prefix = (0, $1b754218be0a6592$export$3794798abb123ff6)('Xing');
    return /*#__PURE__*/ $fb6f83b450933cdb$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $fb6f83b450933cdb$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Xing"
    }, props), /*#__PURE__*/ $fb6f83b450933cdb$var$_react["default"].createElement("g", {
        clipPath: "url(#" + prefix + "-a)"
    }, /*#__PURE__*/ $fb6f83b450933cdb$var$_react["default"].createElement("path", {
        fill: "#005A5F",
        d: "M3.86 4.74c-.209 0-.384.074-.472.217-.092.147-.078.338.02.53l2.34 4.052c.004.008.004.013 0 .02l-3.678 6.49c-.096.19-.091.383 0 .53a.51.51 0 0 0 .453.237h3.461c.517 0 .767-.35.944-.669l3.737-6.608-2.38-4.15c-.172-.306-.433-.649-.963-.649H3.86Z"
    }), /*#__PURE__*/ $fb6f83b450933cdb$var$_react["default"].createElement("path", {
        fill: "#D4D600",
        d: "M18.401 0c-.517 0-.74.326-.927.66 0 0-7.456 13.224-7.702 13.658l4.918 9.023c.172.307.437.659.967.659h3.457c.209 0 .372-.078.46-.221.092-.148.09-.343-.007-.535l-4.88-8.915a.02.02 0 0 1 0-.023L22.351.756c.096-.192.098-.387.007-.535C22.27.08 22.106 0 21.898 0H18.4Z"
    })), /*#__PURE__*/ $fb6f83b450933cdb$var$_react["default"].createElement("defs", null, /*#__PURE__*/ $fb6f83b450933cdb$var$_react["default"].createElement("clipPath", {
        id: prefix + "-a"
    }, /*#__PURE__*/ $fb6f83b450933cdb$var$_react["default"].createElement("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
    }))));
});
$fb6f83b450933cdb$var$Xing.displayName = 'Xing';


Object.keys($fb6f83b450933cdb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $fb6f83b450933cdb$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $fb6f83b450933cdb$exports[key];
});
var $e7a2c42fc641d023$exports = {};

$parcel$export($e7a2c42fc641d023$exports, "__esModule", function () { return $e7a2c42fc641d023$export$1e511d4a378977f5; }, function (v) { return $e7a2c42fc641d023$export$1e511d4a378977f5 = v; });
$parcel$export($e7a2c42fc641d023$exports, "Yoga", function () { return $e7a2c42fc641d023$export$1e507fef8dca0624; }, function (v) { return $e7a2c42fc641d023$export$1e507fef8dca0624 = v; });
var $e7a2c42fc641d023$export$1e511d4a378977f5;
var $e7a2c42fc641d023$export$1e507fef8dca0624;
"use strict";
$e7a2c42fc641d023$export$1e511d4a378977f5 = true;
$e7a2c42fc641d023$export$1e507fef8dca0624 = void 0;

var $e7a2c42fc641d023$var$_react = $e7a2c42fc641d023$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $e7a2c42fc641d023$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e7a2c42fc641d023$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e7a2c42fc641d023$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e7a2c42fc641d023$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e7a2c42fc641d023$var$_extends() {
    return $e7a2c42fc641d023$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e7a2c42fc641d023$var$_extends.apply(null, arguments);
}
var $e7a2c42fc641d023$var$Yoga = $e7a2c42fc641d023$export$1e507fef8dca0624 = /*#__PURE__*/ (0, $e7a2c42fc641d023$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e7a2c42fc641d023$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $e7a2c42fc641d023$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Yoga"
    }, props), /*#__PURE__*/ $e7a2c42fc641d023$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m12 11-1 3 1 3h-1.5L9 14l.5-4.5L12 11zm1-9L9 6v8l1 3H6l-3 5m17.5 0-5-3.5L12 17l-1-3 1-3 3.5 2v5.5M14 8.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-3 2L10 17v-3.5l1-3z"
    }));
});
$e7a2c42fc641d023$var$Yoga.displayName = 'Yoga';


Object.keys($e7a2c42fc641d023$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $e7a2c42fc641d023$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $e7a2c42fc641d023$exports[key];
});
var $8ec796b4eb1ba059$exports = {};

$parcel$export($8ec796b4eb1ba059$exports, "__esModule", function () { return $8ec796b4eb1ba059$export$1e511d4a378977f5; }, function (v) { return $8ec796b4eb1ba059$export$1e511d4a378977f5 = v; });
$parcel$export($8ec796b4eb1ba059$exports, "Youtube", function () { return $8ec796b4eb1ba059$export$9967558ab3090fa1; }, function (v) { return $8ec796b4eb1ba059$export$9967558ab3090fa1 = v; });
var $8ec796b4eb1ba059$export$1e511d4a378977f5;
var $8ec796b4eb1ba059$export$9967558ab3090fa1;
"use strict";
$8ec796b4eb1ba059$export$1e511d4a378977f5 = true;
$8ec796b4eb1ba059$export$9967558ab3090fa1 = void 0;

var $8ec796b4eb1ba059$var$_react = $8ec796b4eb1ba059$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $8ec796b4eb1ba059$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8ec796b4eb1ba059$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8ec796b4eb1ba059$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $8ec796b4eb1ba059$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8ec796b4eb1ba059$var$_extends() {
    return $8ec796b4eb1ba059$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8ec796b4eb1ba059$var$_extends.apply(null, arguments);
}
var $8ec796b4eb1ba059$var$Youtube = $8ec796b4eb1ba059$export$9967558ab3090fa1 = /*#__PURE__*/ (0, $8ec796b4eb1ba059$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $8ec796b4eb1ba059$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $8ec796b4eb1ba059$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Youtube"
    }, props), /*#__PURE__*/ $8ec796b4eb1ba059$var$_react["default"].createElement("path", {
        fill: "#CD201F",
        fillRule: "evenodd",
        d: "M9.522 15.553V8.81l6.484 3.383-6.484 3.36zM23.76 7.641s-.235-1.654-.954-2.382c-.913-.956-1.936-.96-2.405-1.016C17.043 4 12.005 4 12.005 4h-.01s-5.038 0-8.396.243c-.47.055-1.492.06-2.406 1.016C.474 5.987.24 7.641.24 7.641S0 9.584 0 11.525v1.822c0 1.942.24 3.884.24 3.884s.234 1.653.953 2.382c.914.956 2.113.926 2.647 1.026 1.92.184 8.16.241 8.16.241s5.043-.007 8.401-.25c.47-.056 1.492-.061 2.405-1.017.72-.729.954-2.382.954-2.382s.24-1.942.24-3.885v-1.82c0-1.942-.24-3.885-.24-3.885z"
    }));
});
$8ec796b4eb1ba059$var$Youtube.displayName = 'Youtube';


Object.keys($8ec796b4eb1ba059$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $8ec796b4eb1ba059$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $8ec796b4eb1ba059$exports[key];
});
var $72b82352ff517d09$exports = {};

$parcel$export($72b82352ff517d09$exports, "__esModule", function () { return $72b82352ff517d09$export$1e511d4a378977f5; }, function (v) { return $72b82352ff517d09$export$1e511d4a378977f5 = v; });
$parcel$export($72b82352ff517d09$exports, "ZoomIn", function () { return $72b82352ff517d09$export$d13069184bfa0730; }, function (v) { return $72b82352ff517d09$export$d13069184bfa0730 = v; });
var $72b82352ff517d09$export$1e511d4a378977f5;
var $72b82352ff517d09$export$d13069184bfa0730;
"use strict";
$72b82352ff517d09$export$1e511d4a378977f5 = true;
$72b82352ff517d09$export$d13069184bfa0730 = void 0;

var $72b82352ff517d09$var$_react = $72b82352ff517d09$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $72b82352ff517d09$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($72b82352ff517d09$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $72b82352ff517d09$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $72b82352ff517d09$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $72b82352ff517d09$var$_extends() {
    return $72b82352ff517d09$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $72b82352ff517d09$var$_extends.apply(null, arguments);
}
var $72b82352ff517d09$var$ZoomIn = $72b82352ff517d09$export$d13069184bfa0730 = /*#__PURE__*/ (0, $72b82352ff517d09$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $72b82352ff517d09$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $72b82352ff517d09$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ZoomIn"
    }, props), /*#__PURE__*/ $72b82352ff517d09$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m16 16 7 7-7-7zm-6 2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-3V5m-5 5h10"
    }));
});
$72b82352ff517d09$var$ZoomIn.displayName = 'ZoomIn';


Object.keys($72b82352ff517d09$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $72b82352ff517d09$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $72b82352ff517d09$exports[key];
});
var $96c1ad6d5f5521a2$exports = {};

$parcel$export($96c1ad6d5f5521a2$exports, "__esModule", function () { return $96c1ad6d5f5521a2$export$1e511d4a378977f5; }, function (v) { return $96c1ad6d5f5521a2$export$1e511d4a378977f5 = v; });
$parcel$export($96c1ad6d5f5521a2$exports, "ZoomOut", function () { return $96c1ad6d5f5521a2$export$adc4acb67269225; }, function (v) { return $96c1ad6d5f5521a2$export$adc4acb67269225 = v; });
var $96c1ad6d5f5521a2$export$1e511d4a378977f5;
var $96c1ad6d5f5521a2$export$adc4acb67269225;
"use strict";
$96c1ad6d5f5521a2$export$1e511d4a378977f5 = true;
$96c1ad6d5f5521a2$export$adc4acb67269225 = void 0;

var $96c1ad6d5f5521a2$var$_react = $96c1ad6d5f5521a2$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $96c1ad6d5f5521a2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($96c1ad6d5f5521a2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $96c1ad6d5f5521a2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $96c1ad6d5f5521a2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $96c1ad6d5f5521a2$var$_extends() {
    return $96c1ad6d5f5521a2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $96c1ad6d5f5521a2$var$_extends.apply(null, arguments);
}
var $96c1ad6d5f5521a2$var$ZoomOut = $96c1ad6d5f5521a2$export$adc4acb67269225 = /*#__PURE__*/ (0, $96c1ad6d5f5521a2$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $96c1ad6d5f5521a2$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $96c1ad6d5f5521a2$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ZoomOut"
    }, props), /*#__PURE__*/ $96c1ad6d5f5521a2$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m16 16 7 7-7-7zm-6 2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-5-8h10"
    }));
});
$96c1ad6d5f5521a2$var$ZoomOut.displayName = 'ZoomOut';


Object.keys($96c1ad6d5f5521a2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $96c1ad6d5f5521a2$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $96c1ad6d5f5521a2$exports[key];
});
var $d2f4beb370565424$exports = {};

$parcel$export($d2f4beb370565424$exports, "__esModule", function () { return $d2f4beb370565424$export$1e511d4a378977f5; }, function (v) { return $d2f4beb370565424$export$1e511d4a378977f5 = v; });
$parcel$export($d2f4beb370565424$exports, "Zoom", function () { return $d2f4beb370565424$export$65cfd44a2050f99; }, function (v) { return $d2f4beb370565424$export$65cfd44a2050f99 = v; });
var $d2f4beb370565424$export$1e511d4a378977f5;
var $d2f4beb370565424$export$65cfd44a2050f99;
"use strict";
$d2f4beb370565424$export$1e511d4a378977f5 = true;
$d2f4beb370565424$export$65cfd44a2050f99 = void 0;

var $d2f4beb370565424$var$_react = $d2f4beb370565424$var$_interopRequireWildcard((parcelRequire("2xPiy")));

function $d2f4beb370565424$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d2f4beb370565424$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d2f4beb370565424$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d2f4beb370565424$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d2f4beb370565424$var$_extends() {
    return $d2f4beb370565424$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d2f4beb370565424$var$_extends.apply(null, arguments);
}
var $d2f4beb370565424$var$Zoom = $d2f4beb370565424$export$65cfd44a2050f99 = /*#__PURE__*/ (0, $d2f4beb370565424$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d2f4beb370565424$var$_react["default"].createElement($0a9c4ff31cc3584b$export$7c8f159da0dc916, $d2f4beb370565424$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Zoom"
    }, props), /*#__PURE__*/ $d2f4beb370565424$var$_react["default"].createElement("path", {
        d: "M0 8a8 8 0 0 1 8-8h8a8 8 0 0 1 8 8v8a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8z",
        fill: "#3984FD"
    }), /*#__PURE__*/ $d2f4beb370565424$var$_react["default"].createElement("path", {
        d: "M5 9a1 1 0 0 1 1-1h6a3 3 0 0 1 3 3v4a1 1 0 0 1-1 1H8a3 3 0 0 1-3-3V9zm10.5 2.752a2 2 0 0 1 .495-1.318l1.69-1.932c.457-.52 1.315-.198 1.315.494v6.008c0 .693-.858 1.015-1.314.494l-1.691-1.932a2 2 0 0 1-.495-1.317v-.498z",
        fill: "#fff"
    }));
});
$d2f4beb370565424$var$Zoom.displayName = 'Zoom';


Object.keys($d2f4beb370565424$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $d2f4beb370565424$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $d2f4beb370565424$exports[key];
});

Object.keys($763c3cd9aa07485e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($90f36abf4e65ffb7$var$_exportNames, key)) return;
    if (key in $90f36abf4e65ffb7$exports && $90f36abf4e65ffb7$exports[key] === $763c3cd9aa07485e$exports[key]) return;
    $90f36abf4e65ffb7$exports[key] = $763c3cd9aa07485e$exports[key];
});




var $2xPiy = parcelRequire("2xPiy");


const $18eeebe660135d54$export$cefe7bb1923a7b5e = (props)=>{
    const { label: label, onClick: onClick, ...boxProps } = props;
    const [isHover, setIsHover] = (0, $2xPiy.useState)(false);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        justify: "center",
        pad: "xsmall",
        background: isHover ? 'light-5' : 'light-4',
        elevation: isHover ? 'small' : undefined,
        border: {
            color: 'light-2',
            size: '0.05rem'
        },
        borderRadius: "6px",
        onMouseOver: ()=>setIsHover(true),
        onMouseOut: ()=>setIsHover(false),
        ...boxProps,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
            onClick: ()=>onClick?.(),
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                alignSelf: "center",
                size: "1rem",
                weight: 500,
                children: label
            })
        })
    });
};






const $d048c2f49f73d65f$export$2406d6d747b214a5 = (props)=>{
    const { shownColumns: shownColumns, availableColumns: availableColumns, disabled: disabled = false, onChange: onChange } = props;
    const tooltips = (0, $d597772cdbe12609$export$4713da6aa4410043)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const columnsList = (0, $2xPiy.useMemo)(()=>availableColumns ? availableColumns.map((name)=>({
                label: name,
                value: name
            })) : [], [
        t,
        availableColumns
    ]);
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const isMobile = (0, $2xPiy.useMemo)(()=>screenSize === 'small' || screenSize === 'xsmall', [
        screenSize
    ]);
    const [isMenuOpen, setIsMenuOpen] = (0, $2xPiy.useState)(false);
    const [isMenuHovered, setIsMenuHovered] = (0, $2xPiy.useState)(false);
    const handleToggle = (value, isChecked)=>{
        let newValues;
        if (isChecked) newValues = [
            ...shownColumns,
            value
        ];
        else newValues = shownColumns.filter((id)=>id !== value);
        onChange?.(newValues);
    };
    const handleSelectAll = ()=>{
        onChange?.([
            ...availableColumns || []
        ]);
    };
    const handleClear = ()=>{
        onChange?.([]);
    };
    const handleSetDefault = ()=>{
        onChange?.((0, $005c9245bea15c35$export$7aa1788812152cb5)(availableColumns));
    };
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c9158ac1cba12f75$export$64fff40e709e8b2e), {
        plain: true,
        disabled: disabled,
        open: isMenuOpen,
        onOpen: ()=>setIsMenuOpen(true),
        onClose: ()=>setIsMenuOpen(false),
        onMouseOver: ()=>setIsMenuHovered(true),
        onMouseOut: ()=>setIsMenuHovered(false),
        tip: tooltips.columnSettings,
        dropAlign: {
            right: 'right',
            top: 'bottom'
        },
        dropContent: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
            width: {
                min: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(600)
            },
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                    pad: {
                        horizontal: 'medium',
                        vertical: 'small'
                    },
                    title: t('apiData:selectColumns'),
                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $90f36abf4e65ffb7$exports.Configure), {
                        size: "24px",
                        color: "brand"
                    }),
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        direction: "row",
                        gap: "xsmall",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18eeebe660135d54$export$cefe7bb1923a7b5e), {
                                label: "Select All",
                                onClick: handleSelectAll
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18eeebe660135d54$export$cefe7bb1923a7b5e), {
                                label: "Default",
                                onClick: handleSetDefault
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18eeebe660135d54$export$cefe7bb1923a7b5e), {
                                label: "Clear All",
                                onClick: handleClear
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                    pad: "1.5rem",
                    gap: "medium",
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $225251299c21678a$export$ef2184bd89960b14), {
                        rows: "auto",
                        columns: {
                            count: 3,
                            size: 'flex'
                        },
                        gap: "small",
                        children: columnsList?.map((item)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2c7296f45cd5dd1d$export$ea5f704b89d806f6), {
                                label: item.label,
                                checked: shownColumns.includes(item.value),
                                onChange: (event)=>handleToggle(item.value, event.target.checked)
                            }, item.value))
                    })
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            direction: "row",
            align: "center",
            height: isMobile ? undefined : 'xxlarge',
            style: {
                boxShadow: isMenuHovered ? 'rgba(0, 0, 0, 0.2) 0 10px 10px -10px' : ''
            },
            transitionProperty: "background, color, box-shadow, padding-bottom",
            transitionDuration: "0.15s, 0.15s, 0.15s, 0.15s",
            transitionTimingFunction: "ease, ease, ease, ease",
            pad: {
                horizontal: '0.75rem',
                vertical: isMobile ? '0.5rem' : undefined,
                bottom: isMenuHovered ? '1px' : undefined
            },
            gap: "xsmall",
            border: {
                color: 'light-5',
                size: '0.8px'
            },
            borderRadius: "6px",
            cursor: "pointer",
            round: "6px",
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $90f36abf4e65ffb7$exports.Configure), {
                color: isMenuOpen ? 'brand' : undefined,
                size: "14px"
            })
        })
    });
};




var $2xPiy = parcelRequire("2xPiy");

const $bf33f3ce6f8de921$var$radius = '6px';
const $bf33f3ce6f8de921$export$40258cc1d95ff477 = (props)=>{
    const { options: options, disabled: disabled, value: value, onChange: onChange, ...boxProps } = props;
    const [isHover, setIsHover] = (0, $2xPiy.useState)(false);
    const [hoverOption, setHoverOption] = (0, $2xPiy.useState)(null);
    const [selected, setSelected] = (0, $2xPiy.useState)(options?.[0]?.value);
    (0, $2xPiy.useEffect)(()=>{
        if (options) setSelected(value !== undefined ? value : options[0]?.value);
    }, [
        options,
        value
    ]);
    const handleClick = (value)=>{
        setSelected(value);
        onChange?.(value);
    };
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        direction: "row",
        overflow: "hidden",
        pad: "0",
        elevation: isHover ? 'small' : undefined,
        border: {
            color: 'light-2',
            size: '0.05rem'
        },
        borderRadius: $bf33f3ce6f8de921$var$radius,
        ...boxProps,
        children: options.map((opt, idx)=>{
            const isSelected = selected === opt.value;
            const isFirst = idx === 0;
            const isLast = idx === options.length - 1;
            const radiusStyle = {
                borderTopLeftRadius: isFirst ? $bf33f3ce6f8de921$var$radius : '0px',
                borderBottomLeftRadius: isFirst ? $bf33f3ce6f8de921$var$radius : '0px',
                borderTopRightRadius: isLast ? $bf33f3ce6f8de921$var$radius : '0px',
                borderBottomRightRadius: isLast ? $bf33f3ce6f8de921$var$radius : '0px'
            };
            const bgStyle = isSelected ? hoverOption === opt.value ? 'button-hover' : 'accent-1' : hoverOption === opt.value ? 'light-5' : 'light-4';
            return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $85ab7488c493b81c$export$6d88ebe453be59d7), {
                label: opt.label,
                icon: opt.icon,
                active: isSelected,
                primary: isSelected,
                disabled: disabled,
                background: bgStyle,
                color: isSelected ? 'white' : 'inherit',
                style: {
                    ...radiusStyle
                },
                tip: opt.tooltip,
                onMouseOver: ()=>{
                    setIsHover(true);
                    setHoverOption(opt.value);
                },
                onMouseOut: ()=>{
                    setIsHover(false);
                    setHoverOption(null);
                },
                onClick: ()=>handleClick(opt.value)
            }, opt.value);
        })
    });
};








(0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($fc01af1196a3263c$exports))));
const $506e53226ab4525a$var$FILTER_OPTIONS_STALE_TIME_MS = 300000;
const $506e53226ab4525a$var$normalizeSelection = (values)=>values?.length ? [
        ...values
    ].sort() : undefined;
const $506e53226ab4525a$var$toFiltersRequest = (filters)=>({
        chargingNetwork: $506e53226ab4525a$var$normalizeSelection(filters.chargingNetwork),
        subOrganization: $506e53226ab4525a$var$normalizeSelection(filters.subOrganization),
        state: $506e53226ab4525a$var$normalizeSelection(filters.state),
        chargerLevel: $506e53226ab4525a$var$normalizeSelection(filters.chargerLevel)
    });
const $506e53226ab4525a$var$keepAvailable = (selected, available)=>selected && available ? selected.filter((value)=>available.includes(value)) : selected;
const $506e53226ab4525a$var$SERIAL_NUMBER_MIN_SEARCH_LENGTH = 3;
const $506e53226ab4525a$var$SERIAL_NUMBER_MAX_RESULTS = 20;
const $506e53226ab4525a$var$searchSerialNumbers = (serialNumbers, query)=>{
    const needle = query.trim().toLowerCase();
    const matches = serialNumbers.filter((serialNumber)=>serialNumber.toLowerCase().includes(needle));
    const prefixMatches = matches.filter((serialNumber)=>serialNumber.toLowerCase().startsWith(needle));
    const otherMatches = matches.filter((serialNumber)=>!serialNumber.toLowerCase().startsWith(needle));
    return [
        ...prefixMatches,
        ...otherMatches
    ].slice(0, $506e53226ab4525a$var$SERIAL_NUMBER_MAX_RESULTS);
};
const $506e53226ab4525a$export$af4b354ff577aa8a = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const { handleApiError: handleApiError } = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const restorableList = (0, $d73aac7e90cb996d$export$e4108de26414712f)({
        surfaceId: 'api-data-filters',
        defaults: {
            ...(0, $005c9245bea15c35$export$3ec85612ebfc507),
            hasAppliedFilters: false
        },
        standalone: true
    });
    const hasAppliedFilters = restorableList.state.hasAppliedFilters;
    const filterState = (0, $2xPiy.useMemo)(()=>({
            chargingNetwork: restorableList.state.chargingNetwork,
            subOrganization: restorableList.state.subOrganization,
            serialNumber: restorableList.state.serialNumber,
            state: restorableList.state.state,
            chargerLevel: restorableList.state.chargerLevel,
            startDate: restorableList.state.startDate,
            endDate: restorableList.state.endDate
        }), [
        restorableList.state
    ]);
    const setFilterState = restorableList.setState;
    const [view, setView] = (0, $2xPiy.useState)((0, $fdaf2691e72249ed$export$f78cff4a383213cc).station);
    const [isCsvDownloading, setIsCsvDownloading] = (0, $2xPiy.useState)(false);
    const [shownColumns, setShownColumns] = (0, $2xPiy.useState)([]);
    const [draftFilters, setDraftFilters] = (0, $2xPiy.useState)({
        ...filterState
    });
    const [filtersRequest, setFiltersRequest] = (0, $2xPiy.useState)(()=>$506e53226ab4525a$var$toFiltersRequest(filterState));
    (0, $2xPiy.useEffect)(()=>{
        document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, 'Data Api');
    }, []);
    const refreshFilterOptions = ()=>setFiltersRequest($506e53226ab4525a$var$toFiltersRequest(draftFilters));
    const { data: filtersData, isFetching: isFiltersFetching, isPlaceholderData: isFiltersPlaceholderData, error: queryFiltersError } = (0, $4130e158515cd100$export$dd0a697e1782aedd)({
        queryKey: [
            'api-data-filters',
            userStore.user?.id,
            filtersRequest
        ],
        queryFn: ()=>(0, $06b0d7fbe9c2274f$export$a6657da2963457d1).filters(filtersRequest),
        placeholderData: (prev)=>prev,
        staleTime: $506e53226ab4525a$var$FILTER_OPTIONS_STALE_TIME_MS
    });
    (0, $2xPiy.useEffect)(()=>{
        if (!filtersData || isFiltersPlaceholderData) return;
        setDraftFilters((draft)=>({
                ...draft,
                chargingNetwork: $506e53226ab4525a$var$keepAvailable(draft.chargingNetwork, filtersData.chargingNetwork),
                subOrganization: $506e53226ab4525a$var$keepAvailable(draft.subOrganization, filtersData.subOrganization),
                chargerLevel: $506e53226ab4525a$var$keepAvailable(draft.chargerLevel, filtersData.chargerLevel),
                state: $506e53226ab4525a$var$keepAvailable(draft.state, filtersData.state),
                serialNumber: $506e53226ab4525a$var$keepAvailable(draft.serialNumber, filtersData.serialNumber)
            }));
    }, [
        filtersData,
        isFiltersPlaceholderData
    ]);
    const [serialNumberSearch, setSerialNumberSearch] = (0, $2xPiy.useState)('');
    const isSerialNumberSearchTooShort = serialNumberSearch.trim().length < $506e53226ab4525a$var$SERIAL_NUMBER_MIN_SEARCH_LENGTH;
    const serialNumberOptions = (0, $2xPiy.useMemo)(()=>isSerialNumberSearchTooShort ? draftFilters.serialNumber ?? [] : $506e53226ab4525a$var$searchSerialNumbers(filtersData?.serialNumber ?? [], serialNumberSearch), [
        isSerialNumberSearchTooShort,
        serialNumberSearch,
        draftFilters.serialNumber,
        filtersData?.serialNumber
    ]);
    const { data: columnsData, error: queryColumnsError } = (0, $4130e158515cd100$export$dd0a697e1782aedd)({
        queryKey: [
            'api-data-columns',
            userStore.user?.id
        ],
        queryFn: ()=>(0, $06b0d7fbe9c2274f$export$a6657da2963457d1).columns(),
        placeholderData: (prev)=>prev
    });
    (0, $2xPiy.useEffect)(()=>{
        if (queryFiltersError) handleApiError(queryFiltersError, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).filtersApiData.error);
    }, [
        queryFiltersError
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (queryColumnsError) handleApiError(queryColumnsError, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listApiData.error);
    }, [
        queryColumnsError
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (columnsData && columnsData.sessions.length > 0) setShownColumns((0, $005c9245bea15c35$export$7aa1788812152cb5)(columnsData.sessions));
    }, [
        columnsData
    ]);
    const applyFilters = (0, $2xPiy.useCallback)(()=>{
        setFilterState({
            ...draftFilters,
            hasAppliedFilters: true
        });
    }, [
        setFilterState,
        draftFilters
    ]);
    const clearFilters = (0, $2xPiy.useCallback)(()=>{
        setDraftFilters({
            ...(0, $005c9245bea15c35$export$3ec85612ebfc507)
        });
        setFilterState({
            ...(0, $005c9245bea15c35$export$3ec85612ebfc507),
            hasAppliedFilters: false
        });
        setFiltersRequest($506e53226ab4525a$var$toFiltersRequest((0, $005c9245bea15c35$export$3ec85612ebfc507)));
    }, [
        setFilterState
    ]);
    const handleDownloadClick = async ()=>{
        try {
            setIsCsvDownloading(true);
            const filters = {
                ...filterState,
                view_type: view === (0, $fdaf2691e72249ed$export$f78cff4a383213cc).session ? 'session' : 'charger'
            };
            const response = await (0, $06b0d7fbe9c2274f$export$a6657da2963457d1).getDownloadLink(filters);
            //Download process
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = response.url;
            document.body.appendChild(iframe);
            setTimeout(()=>{
                document.body.removeChild(iframe);
                setIsCsvDownloading(false);
            }, 5000);
        } catch (err) {
            handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).downloadData.error);
            setIsCsvDownloading(false);
        }
    };
    const hasUnappliedFilters = (0, $2xPiy.useMemo)(()=>JSON.stringify(filterState) !== JSON.stringify(draftFilters), [
        filterState,
        draftFilters
    ]);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
        children: [
            isCsvDownloading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c0392a917902c1b9$export$361d78b5461c6788), {}),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9057517707360bf5$export$9b7824917a0c851e), {
                title: t('apiData:title'),
                pageHeader: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $c61d91bfa75be0a1$export$53f1cd6809577fc5), {
                    title: t('apiData:title'),
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $bf33f3ce6f8de921$export$40258cc1d95ff477), {
                            options: [
                                {
                                    value: (0, $fdaf2691e72249ed$export$f78cff4a383213cc).station,
                                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f16983307411ac60$export$be11e187edb4cb0c), {
                                        size: "14px"
                                    }),
                                    label: t('apiData:chargersView')
                                },
                                {
                                    value: (0, $fdaf2691e72249ed$export$f78cff4a383213cc).session,
                                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $91e0caa7b2d289da$export$54ec01a60f47d33d), {
                                        size: "14px"
                                    }),
                                    label: t('apiData:sessionsView')
                                },
                                {
                                    value: (0, $fdaf2691e72249ed$export$f78cff4a383213cc).chart,
                                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d9150df54021eb88$export$94aefc399ef206a9), {
                                        size: "14px"
                                    }),
                                    label: t('apiData:chartView')
                                }
                            ],
                            value: view,
                            onChange: (value)=>setView(value)
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d048c2f49f73d65f$export$2406d6d747b214a5), {
                            disabled: view !== (0, $fdaf2691e72249ed$export$f78cff4a383213cc).session,
                            availableColumns: columnsData?.sessions || [],
                            shownColumns: shownColumns,
                            onChange: (newValues)=>setShownColumns(newValues)
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $85ab7488c493b81c$export$6d88ebe453be59d7), {
                            label: t('apiData:download'),
                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $400b12c0802e75f5$export$a7aaed3e118dd255), {
                                size: "14px"
                            }),
                            onClick: handleDownloadClick,
                            disabled: view === (0, $fdaf2691e72249ed$export$f78cff4a383213cc).chart || !hasAppliedFilters
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    direction: "row",
                    gap: "medium",
                    fill: "horizontal",
                    children: [
                        view === (0, $fdaf2691e72249ed$export$f78cff4a383213cc).station && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $1be5eb44a7b3049d$export$b3c27e869d856b7), {
                            surfaceId: 'api_data_table_station}',
                            shownColumns: columnsData?.chargers || [],
                            view: view,
                            filters: filterState,
                            hasAppliedFilters: hasAppliedFilters
                        }),
                        view === (0, $fdaf2691e72249ed$export$f78cff4a383213cc).session && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $1be5eb44a7b3049d$export$b3c27e869d856b7), {
                            surfaceId: 'api_data_table_session}',
                            shownColumns: shownColumns,
                            view: view,
                            filters: filterState,
                            hasAppliedFilters: hasAppliedFilters
                        }),
                        view === (0, $fdaf2691e72249ed$export$f78cff4a383213cc).chart && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8da8596352d0f44e$export$fdd3c259c93c2a75), {
                            filters: filterState,
                            hasAppliedFilters: hasAppliedFilters
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ea2652f405b477a3$export$92a576f896a9bf72), {
                            width: {
                                width: '20%',
                                min: '20%'
                            },
                            onSubmit: ()=>applyFilters(),
                            onClear: ()=>clearFilters(),
                            hasUnapplied: hasUnappliedFilters,
                            submitLabel: t('apiData:searchFilters'),
                            description: t('apiData:filtersDisclaimer'),
                            filters: [
                                {
                                    type: 'multi-select',
                                    label: t('apiData:chargingNetworkFilter'),
                                    values: draftFilters.chargingNetwork,
                                    setValues: (value)=>setDraftFilters({
                                            ...draftFilters,
                                            chargingNetwork: value
                                        }),
                                    onClose: refreshFilterOptions,
                                    isLoadingOptions: isFiltersFetching,
                                    options: filtersData?.chargingNetwork || []
                                },
                                {
                                    type: 'multi-select',
                                    label: t('apiData:subOrganizationFilter'),
                                    values: draftFilters.subOrganization,
                                    setValues: (value)=>setDraftFilters({
                                            ...draftFilters,
                                            subOrganization: value
                                        }),
                                    onClose: refreshFilterOptions,
                                    isLoadingOptions: isFiltersFetching,
                                    options: filtersData?.subOrganization || []
                                },
                                {
                                    type: 'multi-select',
                                    label: t('apiData:chargerLevelFilter'),
                                    values: draftFilters.chargerLevel,
                                    setValues: (value)=>setDraftFilters({
                                            ...draftFilters,
                                            chargerLevel: value.map(Number)
                                        }),
                                    onClose: refreshFilterOptions,
                                    isLoadingOptions: isFiltersFetching,
                                    options: filtersData?.chargerLevel?.map((item)=>({
                                            label: String(item),
                                            value: item
                                        })) || []
                                },
                                {
                                    type: 'multi-select',
                                    label: t('apiData:stateFilter'),
                                    values: draftFilters.state,
                                    setValues: (value)=>setDraftFilters({
                                            ...draftFilters,
                                            state: value
                                        }),
                                    onClose: refreshFilterOptions,
                                    isLoadingOptions: isFiltersFetching,
                                    options: filtersData?.state || []
                                },
                                {
                                    type: 'multi-select',
                                    label: t('apiData:serialNumberFilter'),
                                    values: draftFilters.serialNumber,
                                    setValues: (value)=>setDraftFilters({
                                            ...draftFilters,
                                            serialNumber: value
                                        }),
                                    onSearch: setSerialNumberSearch,
                                    onClose: ()=>setSerialNumberSearch(''),
                                    emptySearchMessage: isSerialNumberSearchTooShort ? t('apiData:serialNumberSearchHint', {
                                        min: $506e53226ab4525a$var$SERIAL_NUMBER_MIN_SEARCH_LENGTH
                                    }) : undefined,
                                    isLoadingOptions: isFiltersFetching,
                                    options: serialNumberOptions
                                },
                                {
                                    type: 'date',
                                    label: t('apiData:startDateFilter'),
                                    value: draftFilters.startDate,
                                    setValue: (value)=>setDraftFilters({
                                            ...draftFilters,
                                            startDate: value
                                        }),
                                    dateBounds: [
                                        (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports))).max([
                                            filtersData?.startDate,
                                            '1900-01-01'
                                        ].filter(Boolean).map((d)=>(0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(d)))?.format('YYYY-MM-DD') ?? '',
                                        (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports))).min([
                                            draftFilters.endDate,
                                            filtersData?.endDate,
                                            '2100-01-01'
                                        ].filter(Boolean).map((d)=>(0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(d)))?.format('YYYY-MM-DD') ?? ''
                                    ]
                                },
                                {
                                    type: 'date',
                                    label: t('apiData:endDateFilter'),
                                    value: draftFilters.endDate,
                                    setValue: (value)=>setDraftFilters({
                                            ...draftFilters,
                                            endDate: value
                                        }),
                                    dateBounds: [
                                        (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports))).max([
                                            draftFilters.startDate,
                                            filtersData?.startDate,
                                            '1900-01-01'
                                        ].filter(Boolean).map((d)=>(0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(d)))?.format('YYYY-MM-DD') ?? '',
                                        (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports))).min([
                                            filtersData?.endDate,
                                            '2100-01-01'
                                        ].filter(Boolean).map((d)=>(0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(d)))?.format('YYYY-MM-DD') ?? ''
                                    ]
                                }
                            ]
                        })
                    ]
                })
            })
        ]
    });
});
var $506e53226ab4525a$export$2e2bcd8739ae039 = $506e53226ab4525a$export$af4b354ff577aa8a;





var $2xPiy = parcelRequire("2xPiy");


var $2xPiy = parcelRequire("2xPiy");

function $8e40d460e890b2f5$var$_extends() {
    return $8e40d460e890b2f5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8e40d460e890b2f5$var$_extends.apply(null, arguments);
}
var $8e40d460e890b2f5$export$919cd7230f55bee7 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $8e40d460e890b2f5$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "MapLocation"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M17.5 6.5 23 9v13l-7-3-8 3-7-3V6l5 2m10 11v-7M8 22V12m4 4.273S6 11.5 6 7c0-3.75 3-6 6-6s6 2.25 6 6c0 4.5-6 9.273-6 9.273zM13 7a1 1 0 1 0-2 0 1 1 0 0 0 2 0z"
    }));
});
$8e40d460e890b2f5$export$919cd7230f55bee7.displayName = 'MapLocation';






const $8fedf23083f90239$var$PageNotFound = ()=>{
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const isMobile = (0, $18588a518ac6fdc7$export$2ac00d7098bf223)(screenSize);
    (0, $2xPiy.useEffect)(()=>{
        document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, 'Page Not Found');
    }, []);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f068601a66842d6c$export$c1faa9c8f42906a), {
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            flex: "grow",
            justify: "center",
            align: "center",
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
                flex: "shrink",
                width: !isMobile ? '35%' : '80%',
                margin: {
                    bottom: 'xlarge'
                },
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                        title: "Page Not Found",
                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8e40d460e890b2f5$export$919cd7230f55bee7), {
                            color: "brand"
                        })
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            pad: {
                                vertical: 'xsmall'
                            },
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                fontFamily: "Lato, sans-serif",
                                children: "We couldn't find anything at this address. Check the URL and try again."
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $8fedf23083f90239$export$2e2bcd8739ae039 = $8fedf23083f90239$var$PageNotFound;






var $2xPiy = parcelRequire("2xPiy");




const $1577dcc7ba6a8c71$export$1b4ae13a52aea1f0 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    const isLoading = false;
    (0, $2xPiy.useEffect)(()=>{
        document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, 'Change Logs');
    }, []);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9057517707360bf5$export$9b7824917a0c851e), {
        title: "Change Logs",
        isLoading: isLoading,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $372c0dd4210c0f1d$export$9b4fb0669564c0d5), {
            showSearchInput: true,
            showFilters: true
        })
    });
});




var $2xPiy = parcelRequire("2xPiy");















const $e10a26f6a07ef952$export$bd1ccd7b1546b694 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const modelAuditLogStore = (0, $116967e0234c3770$export$88b0cc0fc4818e39)();
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const params = (0, $62d58f5c28b15c2e$export$99eaa27ddbbb95ef)();
    /** State **/ const [isUpdating, setIsUpdating] = (0, $2xPiy.useState)(false);
    const [isFetching, setIsFetching] = (0, $2xPiy.useState)(true);
    const [usageEquipment, setUsageEquipment] = (0, $2xPiy.useState)();
    const [modelAuditLog, setModelAuditLog] = (0, $2xPiy.useState)();
    const [isInvalidParams, setIsInvalidParams] = (0, $2xPiy.useState)(false);
    /** Computed **/ const modelAuditLogId = parseInt(params.model_audit_log_id ?? '');
    const isMobile = screenSize === 'small' || screenSize === 'xsmall';
    const isResolvable = modelAuditLog?.model_audit_log_state_id !== null;
    const isResolved = modelAuditLog?.model_audit_log_state_id !== null && modelAuditLog?.model_audit_log_state_id === (0, $0badf5665deea2b2$export$b60056a547589254).Resolved;
    const modelUrl = usageEquipment ? (0, $00658ccd6ec0135a$export$d9d91b4addd2e9b8)(usageEquipment, (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Equipment) : modelAuditLog ? (0, $00658ccd6ec0135a$export$d9d91b4addd2e9b8)(modelAuditLog.model, modelAuditLog.model_name) : '';
    const modelLabel = usageEquipment ? (0, $00658ccd6ec0135a$export$83ca57d51225263a)(usageEquipment, (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Equipment) : modelAuditLog ? (0, $00658ccd6ec0135a$export$83ca57d51225263a)(modelAuditLog.model, modelAuditLog.model_name) : '';
    const breadcrumbModelName = modelAuditLog?.model_audit_log_event_type.name === (0, $0badf5665deea2b2$export$f4dd91be846acd3a).Create ? 'Creation' : modelAuditLog?.model_audit_log_event_type.name === (0, $0badf5665deea2b2$export$f4dd91be846acd3a).Delete ? 'Deletion' : modelAuditLog?.model_audit_log_event_type.name;
    const isLoading = isUpdating || isFetching;
    const changedValues = (0, $2xPiy.useMemo)(()=>{
        if (!modelAuditLog) return [];
        return Object.keys(modelAuditLog.old_data ?? {}).map((field)=>({
                field: field,
                old_value: modelAuditLog.old_data?.[field] ?? null,
                new_value: modelAuditLog.new_data?.[field] ?? null
            }));
    }, [
        modelAuditLog
    ]);
    /** Methods **/ const fetchModelAuditLog = async (modelAuditLogId)=>{
        try {
            const modelAuditLog = await (0, $05bcb43788f04b5c$export$ef093b57d2fc4c08).get({
                id: modelAuditLogId
            });
            if (!modelAuditLog.model && modelAuditLog.old_data) {
                const equipmentId = typeof modelAuditLog.old_data.equipmentId === 'string' ? parseInt(modelAuditLog.old_data.equipmentId) : modelAuditLog.old_data.equipmentId;
                if (equipmentId) {
                    const equipment = await (0, $64087c41a5036744$export$f3cdcae448e94402).get({
                        id: equipmentId
                    });
                    setUsageEquipment(equipment);
                }
            }
            setModelAuditLog(modelAuditLog);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).fetchAuditLog.error);
        } finally{
            setIsFetching(false);
        }
    };
    const replaceAliases = (input)=>{
        let output = input;
        Object.keys(modelAuditLogStore.fieldAliases).forEach((key)=>{
            if (input.includes(key)) output = output.replace(key, modelAuditLogStore.fieldAliases[key]);
        });
        return output;
    };
    const markAsResolved = async ()=>{
        if (!modelAuditLog) return;
        try {
            setIsUpdating(true);
            await (0, $05bcb43788f04b5c$export$ef093b57d2fc4c08).updateState({
                model_audit_log_id: modelAuditLog.id,
                model_audit_log_state_id: (0, $0badf5665deea2b2$export$b60056a547589254).Resolved
            });
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).resolveAuditLog.success);
            navigate('/change-logs');
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).resolveAuditLog.error);
        } finally{
            setIsUpdating(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, 'Change Logs');
    }, []);
    (0, $2xPiy.useEffect)(()=>{
        if (modelAuditLogId) fetchModelAuditLog(modelAuditLogId);
    }, [
        modelAuditLogId
    ]);
    //404 Redirect
    (0, $2xPiy.useEffect)(()=>{
        if (isFetching || isUpdating) return;
        setIsInvalidParams(Number.isNaN(modelAuditLogId) || modelAuditLog?.id === undefined);
    }, [
        modelAuditLogId,
        modelAuditLog,
        isFetching,
        isUpdating
    ]);
    /** Render **/ return isInvalidParams ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8fedf23083f90239$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $3d99c6153124a6ba$export$7234abc5d81adb58), {
        title: "Log Details",
        breadcrumbNav: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e7dd63b10d4904e9$export$988959db72b892c3), {
            previousPages: [
                {
                    name: 'Change Logs',
                    link: '/change-logs'
                }
            ],
            currentPageName: modelAuditLog ? `${(0, $00658ccd6ec0135a$export$87429743646c3257)(modelAuditLog.model_name)} ${breadcrumbModelName}` : 'Log Details'
        }),
        isLoading: isLoading,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $98b6153ed086d9bd$export$11154b700737b45e), {
            width: "40rem",
            title: modelAuditLog ? modelAuditLog.model_name === (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).EquipmentUsage ? `${(0, $00658ccd6ec0135a$export$87429743646c3257)(modelAuditLog.model_name)} Log` : `${(0, $00658ccd6ec0135a$export$83ca57d51225263a)(modelAuditLog.model, modelAuditLog.model_name)}` : 'Log',
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $796804e8c8878bbf$export$8e3d391089488a08), {}),
            onSubmit: ()=>markAsResolved(),
            isLoading: isLoading,
            hideSaveButton: isResolved,
            hideRequiredText: true,
            saveButtonLabel: "MARK AS RESOLVED",
            saveButtonLoadingLabel: "SAVING...",
            children: [
                isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}),
                !isLoading && modelAuditLog && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    direction: isMobile ? 'column' : 'row',
                                    gap: "medium",
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            flex: "grow",
                                            gap: "xsmall",
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                gap: "xsmall",
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        color: "dark-4",
                                                        size: "small",
                                                        toUpperCase: true,
                                                        children: "STATUS"
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                        direction: "row",
                                                        align: "center",
                                                        gap: "xsmall",
                                                        children: [
                                                            isResolvable && (isResolved ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $24b518a2732bce28$export$4f481e0a96cfbed6), {
                                                                size: "18px",
                                                                color: "green"
                                                            }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $11571e85aa9685ed$export$5a89edf87f611fb5), {
                                                                size: "18px"
                                                            })),
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                fontFamily: "Lato, sans-serif",
                                                                color: isResolved ? 'green' : undefined,
                                                                weight: isResolved ? 500 : undefined,
                                                                children: isResolvable ? isResolved ? 'Resolved' : 'Unresolved' : "\u2014"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        isResolved && modelAuditLog.resolved_by_user && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            flex: "grow",
                                            gap: "xsmall",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    color: "dark-4",
                                                    size: "small",
                                                    toUpperCase: true,
                                                    children: "RESOLVED BY"
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                                                    to: `/users/${modelAuditLog.resolved_by_user.id}`,
                                                    textDecoration: "none",
                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        color: "accent-1",
                                                        size: "medium",
                                                        fontFamily: "Lato, sans-serif",
                                                        lineHeight: "1rem",
                                                        children: modelAuditLog.resolved_by_user.name
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            flex: "grow",
                                            gap: "xsmall",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    color: "dark-4",
                                                    size: "small",
                                                    toUpperCase: true,
                                                    children: "EVENT TYPE"
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                    direction: "row",
                                                    align: "center",
                                                    gap: "xsmall",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f3cc7d38ce51a564$export$9f4a842c4554f9c9), {
                                                            auditLogEventTypeName: modelAuditLog.model_audit_log_event_type.name,
                                                            size: "16px",
                                                            color: "text"
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            size: "medium",
                                                            fontFamily: "Lato, sans-serif",
                                                            children: modelAuditLog.model_audit_log_event_type.name
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            flex: "grow",
                                            gap: "xsmall",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    color: "dark-4",
                                                    size: "small",
                                                    toUpperCase: true,
                                                    children: "MODEL"
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                    direction: "row",
                                                    align: "center",
                                                    gap: "xsmall",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d8fcb0015cca0f72$export$825a3c81a577bf46), {
                                                            entityName: modelAuditLog.model_name,
                                                            size: "18px",
                                                            color: "text"
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            size: "medium",
                                                            fontFamily: "Lato, sans-serif",
                                                            children: (0, $00658ccd6ec0135a$export$87429743646c3257)(modelAuditLog.model_name)
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            flex: "grow",
                                            gap: "xsmall",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    color: "dark-4",
                                                    size: "small",
                                                    toUpperCase: true,
                                                    children: [
                                                        usageEquipment ? (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Equipment : (0, $00658ccd6ec0135a$export$87429743646c3257)(modelAuditLog.model_name),
                                                        " Name"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                                                    to: modelUrl,
                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        size: "medium",
                                                        fontFamily: "Lato, sans-serif",
                                                        color: "accent-1",
                                                        children: modelLabel || "\u2014"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            flex: "grow",
                                            gap: "xsmall",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    color: "dark-4",
                                                    size: "small",
                                                    toUpperCase: true,
                                                    children: [
                                                        modelAuditLog.model_audit_log_event_type.name,
                                                        "D BY"
                                                    ]
                                                }),
                                                modelAuditLog.user ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                                                            to: `/users/${modelAuditLog.user.id}`,
                                                            textDecoration: "none",
                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                color: "accent-1",
                                                                size: "medium",
                                                                fontFamily: "Lato, sans-serif",
                                                                lineHeight: "1rem",
                                                                children: modelAuditLog.user.name
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            size: "medium",
                                                            fontFamily: "Lato, sans-serif",
                                                            lineHeight: "1.25rem",
                                                            children: modelAuditLog.user.email
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            size: "small",
                                                            fontFamily: "Lato, sans-serif",
                                                            lineHeight: "1rem",
                                                            children: modelAuditLog.user.phone
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    children: "\u2014"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            flex: "grow",
                                            gap: "xsmall",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    color: "dark-4",
                                                    size: "small",
                                                    toUpperCase: true,
                                                    children: "USER ROLE"
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    size: "medium",
                                                    fontFamily: "Lato, sans-serif",
                                                    children: globalStore.roles.find((role)=>role.id === modelAuditLog?.role_id)?.name || "\u2014"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            flex: "grow",
                                            gap: "xsmall",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    color: "dark-4",
                                                    size: "small",
                                                    toUpperCase: true,
                                                    children: "DATE"
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    fontFamily: "Lato, sans-serif",
                                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(modelAuditLog.created_at).format('MM/DD/YYYY')
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            flex: "grow",
                                            gap: "xsmall",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    color: "dark-4",
                                                    size: "small",
                                                    toUpperCase: true,
                                                    children: "TIME"
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    fontFamily: "Lato, sans-serif",
                                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(modelAuditLog.created_at).format('h:mm A')
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $972a591c1e48136a$export$a766cd26d0d69044), {
                                    border: undefined,
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f178d3b6d5320b3a$export$7cad6f17fd6e117b), {
                                        label: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "small",
                                                color: "dark-4",
                                                children: "REQUEST METADATA"
                                            })
                                        }),
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            pad: {
                                                top: 'small'
                                            },
                                            gap: "small",
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                direction: "row",
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                        flex: "grow",
                                                        gap: "xsmall",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                size: "small",
                                                                color: "dark-4",
                                                                children: "IP"
                                                            }),
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                fontFamily: "Lato, sans-serif",
                                                                children: modelAuditLog.request_ip
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                        flex: "grow",
                                                        gap: "xsmall",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                size: "small",
                                                                color: "dark-4",
                                                                children: "METHOD"
                                                            }),
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                fontFamily: "Lato, sans-serif",
                                                                children: modelAuditLog.request_method
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                        flex: "grow",
                                                        gap: "xsmall",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                size: "small",
                                                                color: "dark-4",
                                                                children: "URL"
                                                            }),
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                fontFamily: "Lato, sans-serif",
                                                                children: modelAuditLog.request_url
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                        width: "50%",
                                                        gap: "xsmall",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                size: "small",
                                                                color: "dark-4",
                                                                children: "BODY"
                                                            }),
                                                            modelAuditLog.request_body ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f281159a7d882928$export$f5c9f3c2c4054eec), {
                                                                name: "request_body",
                                                                value: typeof modelAuditLog.request_body === 'object' ? JSON.stringify(modelAuditLog.request_body) : modelAuditLog.request_body,
                                                                resize: false,
                                                                rows: 10,
                                                                readOnly: true
                                                            }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                color: "light-1",
                                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("i", {
                                                                    children: "None"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        !!changedValues?.length && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {}),
                        !!changedValues?.length && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                            title: "Data Changes",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                border: {
                                    side: 'all',
                                    size: '0.5px',
                                    color: 'light-2'
                                },
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
                                    data: changedValues,
                                    columns: [
                                        {
                                            property: 'field',
                                            primary: true,
                                            size: '45%',
                                            header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                color: "dark-4",
                                                size: "small",
                                                children: "FIELD"
                                            }),
                                            render: ({ field: field })=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    fontFamily: "Lato, sans-serif",
                                                    children: replaceAliases((0, $00658ccd6ec0135a$export$87429743646c3257)(field))
                                                })
                                        },
                                        {
                                            property: 'old_value',
                                            header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                color: "dark-4",
                                                size: "small",
                                                children: "OLD VALUE"
                                            }),
                                            render: ({ old_value: old_value })=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                    children: [
                                                        !!old_value && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            fontFamily: "Lato, sans-serif",
                                                            children: old_value?.toString()
                                                        }),
                                                        !old_value && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            size: "small",
                                                            color: "light-1",
                                                            fontFamily: "Lato, sans-serif",
                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("i", {
                                                                children: "None"
                                                            })
                                                        })
                                                    ]
                                                })
                                        },
                                        {
                                            property: 'new_value',
                                            header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                color: "dark-4",
                                                size: "small",
                                                children: "NEW VALUE"
                                            }),
                                            render: ({ new_value: new_value })=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                    children: [
                                                        !!new_value && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            fontFamily: "Lato, sans-serif",
                                                            children: new_value?.toString()
                                                        }),
                                                        !new_value && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            size: "small",
                                                            color: "light-1",
                                                            fontFamily: "Lato, sans-serif",
                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("i", {
                                                                children: "None"
                                                            })
                                                        })
                                                    ]
                                                })
                                        }
                                    ],
                                    border: {
                                        side: 'all',
                                        size: '0.5px',
                                        color: 'light-2'
                                    }
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
});




const $3d825225a4fbdfd5$export$c8fb8863e470b0d1 = [
    // Model Audit Log Details
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/change-logs/:model_audit_log_id",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            allowedRoles: [
                (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FuseAdmin
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e10a26f6a07ef952$export$bd1ccd7b1546b694), {})
            })
        })
    }),
    // List Model Audit Logs
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/change-logs",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            allowedRoles: [
                (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FuseAdmin
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $1577dcc7ba6a8c71$export$1b4ae13a52aea1f0), {})
            })
        })
    })
];






var $2xPiy = parcelRequire("2xPiy");












var $2xPiy = parcelRequire("2xPiy");







var $2xPiy = parcelRequire("2xPiy");






const $2da001d821d11a29$export$94fe3cbff7c48a05 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(({ isVisible: isVisible, setIsVisible: setIsVisible, clientId: clientId, onBankAccountAdded: onBankAccountAdded })=>{
    const [isSubmitting, setIsSubmitting] = (0, $2xPiy.useState)(false);
    const [errors, setErrors] = (0, $2xPiy.useState)({});
    const [bankData, setBankData] = (0, $2xPiy.useState)({
        routing_number: '',
        account_number: '',
        bank_account_type: 'checking'
    });
    const validateBank = ()=>{
        const newErrors = {};
        if (!bankData.routing_number.trim()) newErrors.routing_number = 'Routing Number is required';
        if (!bankData.account_number.trim()) newErrors.account_number = 'Account Number is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async ()=>{
        if (!validateBank()) return;
        try {
            setIsSubmitting(true);
            await (0, $b7af0d6ca3f47e77$export$9e3fe2960b03545c).updateBankAccount(clientId, bankData);
            (0, $05d5739209a21833$export$b410431fab84fa58).success('Bank account updated successfully. Previous bank account has been replaced.');
            setIsVisible(false);
            onBankAccountAdded();
            setErrors({});
            setBankData({
                routing_number: '',
                account_number: '',
                bank_account_type: 'checking'
            });
        } catch (error) {
            console.error('Error adding bank account:', error);
            const errorMessage = error?.body?.error?.user_message || 'Failed to update bank account';
            (0, $05d5739209a21833$export$b410431fab84fa58).error(errorMessage);
        } finally{
            setIsSubmitting(false);
        }
    };
    const handleClose = ()=>{
        setIsVisible(false);
        setErrors({});
        setBankData({
            routing_number: '',
            account_number: '',
            bank_account_type: 'checking'
        });
    };
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
        onEsc: handleClose,
        onClickOutside: handleClose,
        background: "transparent",
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
            width: "100%",
            style: {
                maxWidth: 480,
                minWidth: 320
            },
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                    title: "Update Bank Account"
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                    pad: {
                        vertical: 'medium',
                        horizontal: 'large'
                    },
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        gap: "small",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                                gap: "1rem",
                                direction: "row",
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e23e190c1adfeb13$export$a2518b5310db22ab), {
                                        size: "medium",
                                        color: "status-warning"
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        children: "Adding a new bank account will replace your existing bank account. This action cannot be undone."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                label: "Routing Number",
                                value: bankData.routing_number,
                                setValue: (value)=>setBankData({
                                        ...bankData,
                                        routing_number: value
                                    }),
                                placeholder: "Enter routing number",
                                required: true,
                                error: errors.routing_number,
                                style: {
                                    width: '100%'
                                }
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                label: "Account Number",
                                value: bankData.account_number,
                                setValue: (value)=>setBankData({
                                        ...bankData,
                                        account_number: value
                                    }),
                                placeholder: "Enter account number",
                                required: true,
                                error: errors.account_number,
                                style: {
                                    width: '100%'
                                },
                                margin: {
                                    bottom: 'small'
                                }
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                direction: "row",
                                gap: "small",
                                justify: "end",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                        label: "Cancel",
                                        onClick: handleClose,
                                        disabled: isSubmitting,
                                        style: {
                                            fontWeight: 'normal'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                        primary: true,
                                        label: isSubmitting ? 'Processing...' : 'Update Bank Account',
                                        onClick: handleSubmit,
                                        disabled: isSubmitting,
                                        style: {
                                            fontWeight: 'normal'
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
});











const $80f166595780ff32$export$c1431067121b97 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(({ clientId: clientId, onEmailChange: onEmailChange, emailUpdateRef: emailUpdateRef })=>{
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const clientStore = (0, $116967e0234c3770$export$3b47afa599c78f61)();
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const isCanada = clientStore.selectedClient?.hq_address_region?.country_id === (0, $0badf5665deea2b2$export$b77c37614753bffb).Canada;
    const [payoutMethods, setPayoutMethods] = (0, $2xPiy.useState)([]);
    const [loading, setLoading] = (0, $2xPiy.useState)(false);
    const [showAddBankModal, setShowAddBankModal] = (0, $2xPiy.useState)(false);
    const [email, setEmail] = (0, $2xPiy.useState)('');
    const [originalEmail, setOriginalEmail] = (0, $2xPiy.useState)('');
    const [stripeAccountId, setStripeAccountId] = (0, $2xPiy.useState)(null);
    const [showAddRecipientModal, setShowAddRecipientModal] = (0, $2xPiy.useState)(false);
    const [redirecting, setRedirecting] = (0, $2xPiy.useState)(false);
    const [emailError, setEmailError] = (0, $2xPiy.useState)('');
    const fetchData = (0, $2xPiy.useCallback)(async ()=>{
        if (!clientId || !clientStore.selectedClient) return;
        setLoading(true);
        try {
            const accountInfo = await (0, $b7af0d6ca3f47e77$export$9e3fe2960b03545c).getAccount(clientId);
            const stripeId = clientStore.selectedClient.stripe_global_payouts_account_id;
            setEmail(accountInfo.email || '');
            setOriginalEmail(accountInfo.email || '');
            if (!stripeId) {
                setPayoutMethods([]);
                setEmail('');
                setOriginalEmail('');
                setStripeAccountId(null);
                return;
            }
            setStripeAccountId(stripeId);
            setPayoutMethods(accountInfo.bank_accounts || []);
        } catch (err) {
            console.error('Error fetching Stripe account data:', err);
            setPayoutMethods([]);
        } finally{
            setLoading(false);
        }
    }, [
        clientId,
        clientStore.selectedClient
    ]);
    (0, $2xPiy.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (onEmailChange) {
            const hasChanges = email !== originalEmail;
            onEmailChange(hasChanges);
        }
    }, [
        email,
        originalEmail,
        onEmailChange
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (emailUpdateRef) emailUpdateRef.current = {
            validate: validateEmail,
            save: handleEmailUpdate
        };
    }, [
        emailUpdateRef,
        email,
        clientId
    ]);
    const pxToRem = (px)=>{
        return `${parseInt(px) / 16}rem`;
    };
    const validateEmail = ()=>{
        const trimmedEmail = email.trim();
        if (!trimmedEmail) {
            setEmailError('Email is required');
            return false;
        }
        if (!(0, $2e4d07611f552ce8$export$371e338370561054)(trimmedEmail)) {
            setEmailError('Must be a valid email address');
            return false;
        }
        return true;
    };
    const handleEmailUpdate = async ()=>{
        if (!clientId) return;
        const result = await (0, $b7af0d6ca3f47e77$export$9e3fe2960b03545c).updateEmail(clientId, {
            email: email.trim()
        });
        setOriginalEmail(result.email);
    };
    const handleCompleteBankingDetails = async ()=>{
        if (!clientId || !validateEmail()) return;
        const stripeTab = window.open('', '_blank');
        if (stripeTab) stripeTab.opener = null;
        try {
            setRedirecting(true);
            const result = await (0, $b7af0d6ca3f47e77$export$9e3fe2960b03545c).createOnboardingLink(clientId, email.trim());
            if (!result.url) throw new Error('No onboarding URL returned');
            if (stripeTab) stripeTab.location.href = result.url;
            else window.location.assign(result.url);
        } catch (error) {
            stripeTab?.close();
            console.error('Error creating onboarding link:', error);
            (0, $05d5739209a21833$export$b410431fab84fa58).error('Failed to start banking setup');
        } finally{
            setRedirecting(false);
        }
    };
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        gap: "2rem",
        children: [
            loading ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                align: "center",
                justify: "center",
                pad: "large",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8bec6e2e7dc53c4a$export$7f7cbe89f1eacd2), {
                    size: "medium"
                })
            }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        gap: "1rem",
                        fill: "horizontal",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            gap: "1rem",
                            children: stripeAccountId ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                gap: "1rem",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        direction: "row",
                                        align: "center",
                                        gap: "small",
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                color: "dark-1",
                                                size: "large",
                                                weight: 300,
                                                children: t('client:accountDetails')
                                            }),
                                            userStore.isFuseAdmin && !!(0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).stripe.platformAccountId && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                                pad: "xsmall",
                                                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ce7c3f634dc2ea76$export$c9915453de10000b), {
                                                    size: "16px"
                                                }),
                                                href: `https://dashboard.stripe.com/${(0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).stripe.platformAccountId}/global-payouts/recipients/${stripeAccountId}`,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                tip: "Stripe Account"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        name: "display_name",
                                        label: t('client:displayName'),
                                        placeholder: t('client:noDisplayName'),
                                        flex: "grow",
                                        value: clientStore.selectedClient?.name || '',
                                        disabled: true
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        direction: "row",
                                        gap: "medium",
                                        align: "end",
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                            name: "contact_email",
                                            label: t('client:contactEmail'),
                                            placeholder: t('client:enterEmailAddress'),
                                            type: "email",
                                            flex: "grow",
                                            value: email,
                                            setValue: (value)=>{
                                                setEmail(value);
                                                if (emailError) setEmailError('');
                                            },
                                            error: emailError,
                                            required: true
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                align: "center",
                                justify: "center",
                                pad: "medium",
                                background: "light-6",
                                round: "small",
                                gap: "medium",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "large",
                                        textAlign: "center",
                                        children: t('client:noStripeAccountConnected')
                                    }),
                                    isCanada ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        size: "medium",
                                        textAlign: "center",
                                        color: "dark-3",
                                        children: t('client:stripeUnavailableForCanada')
                                    }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $85ab7488c493b81c$export$6d88ebe453be59d7), {
                                        label: t('client:addStripeDetails'),
                                        onClick: ()=>setShowAddRecipientModal(true)
                                    })
                                ]
                            })
                        })
                    }),
                    stripeAccountId ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        gap: "1rem",
                        margin: {
                            top: '2rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                direction: "row",
                                align: "center",
                                justify: "between",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                        color: "dark-1",
                                        size: "large",
                                        weight: 300,
                                        children: t('client:linkedBankAccount')
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        direction: "row",
                                        gap: "small",
                                        children: [
                                            payoutMethods.length === 0 && userStore.isClientAdmin && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $85ab7488c493b81c$export$6d88ebe453be59d7), {
                                                label: t('client:completeBankingDetails'),
                                                onClick: handleCompleteBankingDetails,
                                                disabled: redirecting
                                            }),
                                            userStore.isFuseAdmin && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $85ab7488c493b81c$export$6d88ebe453be59d7), {
                                                label: t('client:updateBankAccount'),
                                                onClick: ()=>clientId && setShowAddBankModal(true)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                                    pad: "none",
                                    gap: "none",
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        elevation: "small",
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
                                            pad: {
                                                horizontal: '1.5rem'
                                            },
                                            columns: [
                                                {
                                                    property: 'bank_name',
                                                    size: '30%',
                                                    header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                        title: t('client:bankName')
                                                    }),
                                                    sortable: false,
                                                    render: (method)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                            margin: {
                                                                vertical: pxToRem('14px')
                                                            },
                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                size: "medium",
                                                                fontFamily: "Lato, sans-serif",
                                                                children: method.bank_account?.bank_name || ''
                                                            })
                                                        })
                                                },
                                                {
                                                    property: 'routing_number',
                                                    size: '25%',
                                                    header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                        title: t('client:routingNumber')
                                                    }),
                                                    sortable: false,
                                                    render: (method)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                            margin: {
                                                                vertical: pxToRem('14px')
                                                            },
                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                size: "medium",
                                                                fontFamily: "Lato, sans-serif",
                                                                children: method.bank_account?.routing_number || ''
                                                            })
                                                        })
                                                },
                                                {
                                                    property: 'last4',
                                                    size: '15%',
                                                    header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                                        title: t('client:last4')
                                                    }),
                                                    sortable: false,
                                                    render: (method)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                            margin: {
                                                                vertical: pxToRem('14px')
                                                            },
                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                size: "medium",
                                                                fontFamily: "Lato, sans-serif",
                                                                children: method.bank_account?.last4 || ''
                                                            })
                                                        })
                                                }
                                            ],
                                            data: payoutMethods,
                                            background: [
                                                'light-6',
                                                'white'
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }) : null
                ]
            }),
            clientId && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2da001d821d11a29$export$94fe3cbff7c48a05), {
                        isVisible: showAddBankModal,
                        setIsVisible: setShowAddBankModal,
                        clientId: clientId,
                        onBankAccountAdded: async ()=>{
                            fetchData();
                        }
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2533e26425761f26$export$a0f90f17401b4548), {
                        isVisible: showAddRecipientModal,
                        setIsVisible: setShowAddRecipientModal,
                        clientId: clientId,
                        clientName: clientStore.selectedClient?.name,
                        client: clientStore.selectedClient ?? undefined,
                        onRecipientAdded: async ()=>{
                            if (clientId && clientStore.selectedClient) {
                                const updatedClient = await (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).get({
                                    id: clientId
                                });
                                clientStore.setSelectedClient(updatedClient);
                                fetchData();
                            }
                        }
                    })
                ]
            })
        ]
    });
});




var $2xPiy = parcelRequire("2xPiy");



var $2xPiy = parcelRequire("2xPiy");

var $iA1nz = parcelRequire("iA1nz");

var $33ff98d0c5770dbd$var$colorStyle = (0, $iA1nz.css)([
    "color:",
    ";"
], function(props) {
    return (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.colorProp, props.theme);
});
var $33ff98d0c5770dbd$var$sizeStyle = function sizeStyle(props) {
    var size = props.size || 'medium';
    var data = props.theme.paragraph[size];
    return (0, $iA1nz.css)([
        "font-size:",
        ";line-height:",
        ";max-width:",
        ";"
    ], data ? data.size : size, data ? data.height : 'normal', props.fillProp ? 'none' : data && data.maxWidth);
};
var $33ff98d0c5770dbd$var$fontFamily = (0, $iA1nz.css)([
    "font-family:",
    ";"
], function(props) {
    return props.theme.paragraph.font.family;
});
var $33ff98d0c5770dbd$var$maxlinesStyle = function maxlinesStyle(props) {
    return props.maxLines && (0, $iA1nz.css)([
        "display:-webkit-box;-webkit-line-clamp:",
        ";-webkit-box-orient:vertical;overflow:hidden;"
    ], props.maxLines);
};
var $33ff98d0c5770dbd$export$b03ca7138a9b8b3b = (0, $iA1nz.default).p.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledParagraph",
    componentId: "sc-tbetod-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], (0, $73ba8e2d301b823f$export$a157b298d219a801), function(props) {
    return $33ff98d0c5770dbd$var$maxlinesStyle(props);
}, function(props) {
    return $33ff98d0c5770dbd$var$sizeStyle(props);
}, function(props) {
    return props.textAlign && (0, $73ba8e2d301b823f$export$4fc8e4871b69e1d6);
}, function(props) {
    return props.colorProp && $33ff98d0c5770dbd$var$colorStyle;
}, function(props) {
    return props.theme.paragraph.font && props.theme.paragraph.font.family && $33ff98d0c5770dbd$var$fontFamily;
}, function(props) {
    return props.theme.paragraph && props.theme.paragraph.extend;
});



var $dyr1f = parcelRequire("dyr1f");

function $8dab47af82427083$var$_extends() {
    return $8dab47af82427083$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8dab47af82427083$var$_extends.apply(null, arguments);
}
var $8dab47af82427083$var$PropType = {};
$8dab47af82427083$var$PropType = $8dab47af82427083$var$_extends({}, (0, $ab32ce3df36aa105$export$ffe37ff34eeb9e21), {
    color: (0, $ab32ce3df36aa105$export$fc4c368d97afb623),
    fill: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    maxLines: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number,
    responsive: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'small',
            'medium',
            'large',
            'xlarge',
            'xxlarge'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    textAlign: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
        'start',
        'center',
        'end',
        'justify'
    ])
});
var $8dab47af82427083$export$961f75c86f1f6d0b = $8dab47af82427083$var$PropType;




var $2xPiy = parcelRequire("2xPiy");



var $78284bbc0f9fdd5b$export$1ab68081b234514 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var _theme$paragraph;
    var fill = _ref.fill, sizeProp = _ref.size;
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme;
    var size = sizeProp || 'medium';
    var data = theme.paragraph[size];
    var height = data ? data.size : size;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        ref: ref,
        gap: (_theme$paragraph = theme.paragraph) == null || (_theme$paragraph = _theme$paragraph.skeleton) == null ? void 0 : _theme$paragraph.gap,
        width: {
            max: fill ? 'none' : data && data.maxWidth
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3c6eab35cbfc0e04$export$8f31e4c4a37b8e9c), {
        height: height
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3c6eab35cbfc0e04$export$8f31e4c4a37b8e9c), {
        height: height
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $3c6eab35cbfc0e04$export$8f31e4c4a37b8e9c), {
        height: height,
        width: "30%"
    }));
});
$78284bbc0f9fdd5b$export$1ab68081b234514.displayName = 'ParagraphSkeleton';




var $9df83b0a9dbf91c5$var$_excluded = [
    "children",
    "color",
    "fill",
    "size"
];
function $9df83b0a9dbf91c5$var$_extends() {
    return $9df83b0a9dbf91c5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9df83b0a9dbf91c5$var$_extends.apply(null, arguments);
}
function $9df83b0a9dbf91c5$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $9df83b0a9dbf91c5$export$358a232cca1ab2ac = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var children = _ref.children, color = _ref.color, fill = _ref.fill, size = _ref.size, rest = $9df83b0a9dbf91c5$var$_objectWithoutPropertiesLoose(_ref, $9df83b0a9dbf91c5$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var skeleton = (0, $b03c62556e524549$export$9489db5f14593d18)();
    var textContextValue = (0, $2xPiy.useMemo)(function() {
        return {
            size: size
        };
    }, [
        size
    ]);
    if (skeleton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $78284bbc0f9fdd5b$export$1ab68081b234514), $9df83b0a9dbf91c5$var$_extends({
        ref: ref,
        fill: fill,
        size: size
    }, rest), children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $33ff98d0c5770dbd$export$b03ca7138a9b8b3b), $9df83b0a9dbf91c5$var$_extends({
        ref: ref,
        colorProp: color,
        fillProp: fill,
        size: size
    }, passThemeFlag, rest), children !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $fb9a4f68d412304d$export$9afb8bc826b033ea).Provider, {
        value: textContextValue
    }, children) : undefined);
});
$9df83b0a9dbf91c5$export$358a232cca1ab2ac.displayName = 'Paragraph';
$9df83b0a9dbf91c5$export$358a232cca1ab2ac.prototype = (0, $8dab47af82427083$export$961f75c86f1f6d0b);



var $2xPiy = parcelRequire("2xPiy");

function $933b206c59f003bb$var$_extends() {
    return $933b206c59f003bb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $933b206c59f003bb$var$_extends.apply(null, arguments);
}
var $933b206c59f003bb$export$126db9180177689d = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $933b206c59f003bb$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Cycle"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M13 20c6-1 8-6 8-10m-7 6-2 4 4 3M0 9l4-3 3 4m2 10c-6-3-7-8-5-14m16 1C16 1 10 1 6 4.006M20 2v5h-5"
    }));
});
$933b206c59f003bb$export$126db9180177689d.displayName = 'Cycle';




var $2xPiy = parcelRequire("2xPiy");




class $75e1dad554a21f8e$export$3d684735af7a6c35 {
    /**
   * List ClientFileTypes
   * @returns ClientFileType[]
   */ static listClientFileTypes() {
        return (0, $fe63a2be2027e28c$export$b5fe3f66a567bec0)((0, $cb036f6eccd47057$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/clientFileTypes'
        });
    }
}




const $75a3dedec9c5143a$var$ALLOWED_EXTENSIONS = [
    'jpg',
    'jpeg',
    'gif',
    'png',
    'pdf',
    'csv',
    'doc',
    'docx',
    'xls',
    'xlsx'
];
const $75a3dedec9c5143a$export$b145f5fea76038de = ({ onClose: onClose, onUpload: onUpload })=>{
    const [selectedFile, setSelectedFile] = (0, $2xPiy.useState)(null);
    const [selectedTypeId, setSelectedTypeId] = (0, $2xPiy.useState)(null);
    const [comments, setComments] = (0, $2xPiy.useState)(null);
    const [error, setError] = (0, $2xPiy.useState)(null);
    const [documentTypes, setDocumentTypes] = (0, $2xPiy.useState)([]);
    const [isLoading, setIsLoading] = (0, $2xPiy.useState)(true);
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    (0, $2xPiy.useEffect)(()=>{
        const fetchDocumentTypes = async ()=>{
            try {
                const types = await (0, $75e1dad554a21f8e$export$3d684735af7a6c35).listClientFileTypes();
                setDocumentTypes(types);
            } catch (error) {
                console.error('Error fetching document types:', error);
                setError('Failed to load document types');
            } finally{
                setIsLoading(false);
            }
        };
        fetchDocumentTypes();
    }, []);
    const validateFile = (file)=>{
        const extension = file.name.split('.').pop()?.toLowerCase();
        if (!extension || !$75a3dedec9c5143a$var$ALLOWED_EXTENSIONS.includes(extension)) {
            setError(`Invalid file type. Allowed types: ${$75a3dedec9c5143a$var$ALLOWED_EXTENSIONS.join(', ')}`);
            return false;
        }
        setError(null);
        return true;
    };
    const handleFileChange = (file)=>{
        if (validateFile(file)) setSelectedFile(file);
        else setSelectedFile(null);
    };
    const handleUploadClick = ()=>{
        if (!selectedFile || !selectedTypeId) return;
        try {
            const typeId = typeof selectedTypeId === 'object' ? selectedTypeId.id : selectedTypeId;
            const processedComments = comments === null ? null : comments.trim() || null;
            onUpload(selectedFile, typeId, processedComments);
        } catch (error) {
            console.error('Error in handleUploadClick:', error);
            setError('Failed to start upload process');
        }
    };
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
        position: "center",
        onEsc: onClose,
        responsive: false,
        style: {
            width: 'auto',
            maxWidth: 'min(95vw, 500px)',
            maxHeight: '95vh',
            overflow: 'auto',
            borderRadius: '8px'
        },
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
            width: "100%",
            style: {
                width: '100%'
            },
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                    title: t('documents:uploadDocument')
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                    pad: {
                        vertical: 'medium',
                        horizontal: 'large',
                        ...typeof window !== 'undefined' && window.innerWidth < 768 ? {
                            horizontal: 'medium'
                        } : {}
                    },
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            gap: "medium",
                            style: {
                                maxWidth: '100%',
                                overflow: 'hidden'
                            },
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6f8f550f497b66c1$export$2e2bcd8739ae039), {
                                            onFileSelect: handleFileChange,
                                            accept: $75a3dedec9c5143a$var$ALLOWED_EXTENSIONS.map((ext)=>`.${ext}`).join(','),
                                            selectedFile: selectedFile
                                        }),
                                        error && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            direction: "row",
                                            gap: "small",
                                            margin: {
                                                top: '0.5rem',
                                                left: '0.75rem'
                                            },
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                color: "status-critical",
                                                size: "small",
                                                children: error
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                    label: t('documents:documentType'),
                                    options: documentTypes.map((type)=>({
                                            label: type.name,
                                            value: type.id
                                        })),
                                    value: selectedTypeId || '',
                                    setValue: (value)=>setSelectedTypeId(Number(value)),
                                    placeholder: t('documents:selectDocumentType'),
                                    disabled: isLoading,
                                    required: true
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    flex: "grow",
                                    height: {
                                        min: '6rem'
                                    },
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        label: t('common:comments'),
                                        placeholder: t('documents:addComments'),
                                        value: comments ?? '',
                                        setValue: (value)=>{
                                            setComments(value === '' ? null : value);
                                        },
                                        maxLength: 500,
                                        componentType: "textArea"
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    size: "small",
                                    color: "dark-6",
                                    margin: {
                                        top: '-1rem'
                                    },
                                    children: (comments?.length || 0) + t('documents:characterLimit')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            direction: "row",
                            gap: "small",
                            justify: "end",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                    label: t('documents:cancel'),
                                    onClick: onClose,
                                    style: {
                                        fontWeight: 'normal'
                                    }
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                    label: t('documents:upload'),
                                    primary: true,
                                    onClick: handleUploadClick,
                                    disabled: !selectedFile || !selectedTypeId,
                                    style: {
                                        fontWeight: 'normal'
                                    }
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};









const $0e46cba362a640b5$var$formatDate = (dateString)=>{
    return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
};
const $0e46cba362a640b5$var$DOCUMENT_FILTERS_DEFAULTS = {
    typeId: '',
    uploadedById: ''
};
const $0e46cba362a640b5$var$REFRESH_INTERVAL_MS = (0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).documents.refreshIntervalMs;
const $0e46cba362a640b5$var$REFRESH_MAX_INTERVAL_MS = 30000;
const $0e46cba362a640b5$var$REFRESH_TIMEOUT_MS = 300000;
const $0e46cba362a640b5$var$CommentPreview = ({ comment: comment })=>{
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const textRef = (0, $2xPiy.useRef)(null);
    const [isExpanded, setIsExpanded] = (0, $2xPiy.useState)(false);
    const [isClamped, setIsClamped] = (0, $2xPiy.useState)(false);
    (0, $2xPiy.useLayoutEffect)(()=>{
        const element = textRef.current;
        if (isExpanded || !element) return;
        const measure = ()=>setIsClamped(element.scrollHeight > element.clientHeight);
        measure();
        const observer = new ResizeObserver(measure);
        observer.observe(element);
        return ()=>observer.disconnect();
    }, [
        comment,
        isExpanded
    ]);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        direction: "row",
        align: isExpanded ? 'start' : 'center',
        gap: "xsmall",
        height: {
            min: '36px'
        },
        style: {
            width: 0,
            minWidth: '100%'
        },
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9df83b0a9dbf91c5$export$358a232cca1ab2ac), {
                ref: textRef,
                size: "small",
                fill: true,
                margin: "none",
                maxLines: isExpanded ? undefined : 3,
                style: {
                    fontFamily: 'Lato, sans-serif',
                    flex: 1,
                    minWidth: 0,
                    wordBreak: 'break-word'
                },
                children: comment
            }),
            (isClamped || isExpanded) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ad3dfa44adb42595$export$353f5b6fc5456de1), {
                icon: isExpanded ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b356debd254c4cfa$export$7dd0724a362def6d), {
                    size: "small"
                }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $aa240f1efb63cecd$export$cd1a8f5a55d5e9d3), {
                    size: "small"
                }),
                onClick: ()=>setIsExpanded(!isExpanded),
                "aria-expanded": isExpanded,
                tip: isExpanded ? t('documents:collapse') : t('documents:seeMore')
            })
        ]
    });
};
const $0e46cba362a640b5$var$CommentEditor = ({ initialValue: initialValue, onChange: onChange })=>{
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const [draft, setDraft] = (0, $2xPiy.useState)(initialValue);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        direction: "row",
        align: "center",
        height: "36px",
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8c9c99ffe8765a99$export$c86715117507e8e5), {
                value: draft,
                onChange: (e)=>{
                    setDraft(e.target.value);
                    onChange(e.target.value);
                },
                maxLength: 500
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                size: "small",
                color: "dark-6",
                margin: {
                    left: 'small'
                },
                wordBreak: "break-word",
                children: draft.length + t('documents:characterLimit')
            })
        ]
    });
};
const $0e46cba362a640b5$export$490c14823245408e = ({ clientId: clientId })=>{
    /** Config **/ const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const tooltips = (0, $d597772cdbe12609$export$4713da6aa4410043)();
    /** State **/ const [isLoading, setIsLoading] = (0, $2xPiy.useState)(true);
    const [showUploadModal, setShowUploadModal] = (0, $2xPiy.useState)(false);
    const [documents, setDocuments] = (0, $2xPiy.useState)([]);
    const [isDeletingId, setIsDeletingId] = (0, $2xPiy.useState)(null);
    const [isSavingId, setIsSavingId] = (0, $2xPiy.useState)(null);
    const [isDownloadingId, setIsDownloadingId] = (0, $2xPiy.useState)(null);
    const [documentToDelete, setDocumentToDelete] = (0, $2xPiy.useState)(null);
    const [searchQuery, setSearchQuery] = (0, $2xPiy.useState)('');
    const [selectedIds, setSelectedIds] = (0, $2xPiy.useState)([]);
    const [isBulkDownloading, setIsBulkDownloading] = (0, $2xPiy.useState)(false);
    const [appliedFilters, setAppliedFilters] = (0, $2xPiy.useState)($0e46cba362a640b5$var$DOCUMENT_FILTERS_DEFAULTS);
    const [draftFilters, setDraftFilters] = (0, $2xPiy.useState)($0e46cba362a640b5$var$DOCUMENT_FILTERS_DEFAULTS);
    const [isFiltersMenuOpen, setIsFiltersMenuOpen] = (0, $2xPiy.useState)(false);
    const [isFiltersMenuHovered, setIsFiltersMenuHovered] = (0, $2xPiy.useState)(false);
    const commentDrafts = (0, $2xPiy.useRef)(new Map());
    const hasActiveFilters = !!(appliedFilters.typeId || appliedFilters.uploadedById);
    /** Computed **/ const buildOptions = (0, $2xPiy.useCallback)((entries)=>{
        const unique = new Map(entries.map((entry)=>[
                entry.id,
                {
                    label: entry.name,
                    value: String(entry.id)
                }
            ]));
        return [
            {
                label: t('documents:all'),
                value: ''
            },
            ...Array.from(unique.values()).sort((a, b)=>a.label.localeCompare(b.label))
        ];
    }, [
        t
    ]);
    const typeOptions = (0, $2xPiy.useMemo)(()=>buildOptions(documents.flatMap((doc)=>doc.client_file_type?.id && doc.client_file_type?.name ? [
                {
                    id: doc.client_file_type.id,
                    name: doc.client_file_type.name
                }
            ] : [])), [
        documents,
        buildOptions
    ]);
    const uploadedByOptions = (0, $2xPiy.useMemo)(()=>buildOptions(documents.flatMap((doc)=>doc.user?.id && doc.user?.name ? [
                {
                    id: doc.user.id,
                    name: doc.user.name
                }
            ] : [])), [
        documents,
        buildOptions
    ]);
    const filteredDocuments = (0, $2xPiy.useMemo)(()=>{
        const normalizedQuery = searchQuery.trim().toLowerCase();
        return documents.filter((doc)=>{
            if (normalizedQuery && !doc.name?.toLowerCase().includes(normalizedQuery)) return false;
            if (appliedFilters.typeId && String(doc.client_file_type?.id) !== appliedFilters.typeId) return false;
            if (appliedFilters.uploadedById && String(doc.user?.id) !== appliedFilters.uploadedById) return false;
            return true;
        });
    }, [
        documents,
        searchQuery,
        appliedFilters
    ]);
    (0, $2xPiy.useEffect)(()=>{
        setSelectedIds((prev)=>{
            const visibleIds = new Set(filteredDocuments.map((doc)=>doc.id));
            const pruned = prev.filter((id)=>visibleIds.has(id));
            return pruned.length === prev.length ? prev : pruned;
        });
    }, [
        filteredDocuments
    ]);
    const fetchDocuments = async ()=>{
        try {
            setIsLoading(true);
            const clientFilesResponse = await (0, $3c4d1dd9732ea0da$export$e8b677291114e035).listClientFiles(clientId.toString(), {
                limit: 2000
            });
            await (0, $75e1dad554a21f8e$export$3d684735af7a6c35).listClientFileTypes();
            const filteredDocs = clientFilesResponse.data.filter((doc)=>doc.client_id === clientId);
            setDocuments(filteredDocs);
        } catch (error) {
            console.error('Error fetching data:', error);
            (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).fetchDocuments.error(error));
        } finally{
            setIsLoading(false);
        }
    };
    (0, $2xPiy.useEffect)(()=>{
        fetchDocuments();
    }, [
        clientId
    ]);
    const processingKey = (0, $2xPiy.useMemo)(()=>documents.filter((doc)=>doc.client_file_state?.id === 1).map((doc)=>doc.id).join(','), [
        documents
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (!processingKey) return;
        const processingDocs = processingKey.split(',').map(Number);
        const startedAt = Date.now();
        let delay = $0e46cba362a640b5$var$REFRESH_INTERVAL_MS;
        let timer;
        let cancelled = false;
        const schedule = ()=>{
            if (Date.now() - startedAt >= $0e46cba362a640b5$var$REFRESH_TIMEOUT_MS) return;
            clearTimeout(timer);
            timer = setTimeout(refreshDocuments, delay);
            delay = Math.min(delay * 2, $0e46cba362a640b5$var$REFRESH_MAX_INTERVAL_MS);
        };
        const refreshDocuments = async ()=>{
            const results = await Promise.allSettled(processingDocs.map((id)=>(0, $3c4d1dd9732ea0da$export$e8b677291114e035).getClientFile(id)));
            if (cancelled) return;
            const updates = new Map();
            results.forEach((result)=>{
                if (result.status === 'fulfilled') updates.set(result.value.id, result.value);
                else console.error('Error refreshing documents:', result.reason);
            });
            setDocuments((prevDocs)=>{
                let changed = false;
                const nextDocs = prevDocs.map((doc)=>{
                    const updated = updates.get(doc.id);
                    if (!updated || updated.client_file_state_id === doc.client_file_state_id) return doc;
                    changed = true;
                    return {
                        ...doc,
                        client_file_state_id: updated.client_file_state_id,
                        client_file_state: updated.client_file_state
                    };
                });
                return changed ? nextDocs : prevDocs;
            });
            schedule();
        };
        schedule();
        return ()=>{
            cancelled = true;
            clearTimeout(timer);
        };
    }, [
        processingKey
    ]);
    /** Methods **/ const handleUploadClick = ()=>{
        setShowUploadModal(true);
    };
    const applyFilters = (0, $2xPiy.useCallback)(()=>{
        setAppliedFilters(draftFilters);
        setIsFiltersMenuOpen(false);
    }, [
        draftFilters
    ]);
    const clearFilters = (0, $2xPiy.useCallback)(()=>{
        setDraftFilters($0e46cba362a640b5$var$DOCUMENT_FILTERS_DEFAULTS);
        setAppliedFilters($0e46cba362a640b5$var$DOCUMENT_FILTERS_DEFAULTS);
        setIsFiltersMenuOpen(false);
    }, []);
    const openFilters = (0, $2xPiy.useCallback)(()=>{
        setDraftFilters(appliedFilters);
        setIsFiltersMenuOpen(true);
    }, [
        appliedFilters
    ]);
    const handleDeleteDocument = async ()=>{
        if (!documentToDelete) return;
        const documentId = documentToDelete.id;
        try {
            setIsDeletingId(documentId);
            await (0, $3c4d1dd9732ea0da$export$e8b677291114e035).deleteClientFile(documentId);
            setDocuments((prevDocs)=>prevDocs.filter((doc)=>doc.id !== documentId));
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).deleteDocument.success);
            setDocumentToDelete(null);
        } catch (error) {
            console.error('Error deleting document:', error);
            (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).deleteDocument.error(error));
        } finally{
            setIsDeletingId(null);
        }
    };
    const handleBulkDownload = (0, $2xPiy.useCallback)(async ()=>{
        const selectedDocs = documents.filter((doc)=>selectedIds.includes(doc.id));
        const docsToDownload = selectedDocs.filter((doc)=>doc.client_file_state?.id !== 1 && doc.client_file_state?.id !== 2);
        const skippedCount = selectedDocs.length - docsToDownload.length;
        if (!docsToDownload.length) {
            (0, $05d5739209a21833$export$b410431fab84fa58).error(t('documents:bulkDownloadUnavailable', {
                count: selectedDocs.length
            }));
            return;
        }
        try {
            setIsBulkDownloading(true);
            for (const doc of docsToDownload){
                const { url: url } = await (0, $3c4d1dd9732ea0da$export$e8b677291114e035).getClientFileUrl(doc.id);
                const link = document.createElement('a');
                link.href = url;
                link.download = doc.name;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                await new Promise((resolve)=>setTimeout(resolve, 150));
            }
            (0, $05d5739209a21833$export$b410431fab84fa58).success(skippedCount > 0 ? t('documents:bulkDownloadPartial', {
                downloaded: docsToDownload.length,
                skipped: skippedCount
            }) : (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).bulkDownloadDocuments.success);
            setSelectedIds([]);
        } catch (error) {
            console.error('Error bulk downloading documents:', error);
            (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).bulkDownloadDocuments.error(error));
        } finally{
            setIsBulkDownloading(false);
        }
    }, [
        documents,
        selectedIds,
        t
    ]);
    const handleDownloadDocument = async (documentFile)=>{
        try {
            setIsDownloadingId(documentFile.id);
            const response = await (0, $3c4d1dd9732ea0da$export$e8b677291114e035).getClientFileUrl(documentFile.id);
            const link = document.createElement('a');
            link.href = response.url;
            link.download = documentFile.name;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).downloadDocument.success);
        } catch (error) {
            console.error('Error downloading document:', error);
            (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).downloadDocument.error(error));
        } finally{
            setIsDownloadingId(null);
        }
    };
    const handleEditDocument = (document1)=>{
        commentDrafts.current.set(document1.id, document1.comments ?? '');
        setDocuments((prevDocs)=>prevDocs.map((doc)=>doc.id === document1.id ? {
                    ...doc,
                    isEditing: true
                } : doc));
    };
    const handleCancelEdit = (documentId)=>{
        commentDrafts.current.delete(documentId);
        setDocuments((prevDocs)=>prevDocs.map((doc)=>doc.id === documentId ? {
                    ...doc,
                    isEditing: false
                } : doc));
    };
    const handleSaveDocument = async (document1)=>{
        const comments = commentDrafts.current.get(document1.id)?.trim() || null;
        try {
            setIsSavingId(document1.id);
            await (0, $3c4d1dd9732ea0da$export$e8b677291114e035).updateClientFile(document1.id, {
                comments: comments
            });
            commentDrafts.current.delete(document1.id);
            setDocuments((prevDocs)=>prevDocs.map((doc)=>doc.id === document1.id ? {
                        ...doc,
                        comments: comments,
                        isEditing: false
                    } : doc));
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updateDocument.success);
        } catch (error) {
            console.error('Error updating document:', error);
            (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updateDocument.error(error));
        } finally{
            setIsSavingId(null);
        }
    };
    const handleFileUpload = async (file, typeId, comments)=>{
        try {
            setIsLoading(true);
            const uploadedFile = await (0, $3c4d1dd9732ea0da$export$e8b677291114e035).createClientFile(clientId.toString(), {
                file: file,
                client_file_type_id: typeId,
                comments: comments
            });
            const response = await (0, $3c4d1dd9732ea0da$export$e8b677291114e035).listClientFiles(clientId.toString(), {
                limit: 2000
            });
            const filteredDocs = response.data.filter((doc)=>doc.client_id === clientId);
            const newDocExists = filteredDocs.some((doc)=>doc.name === file.name && doc.client_id === clientId);
            if (!newDocExists && uploadedFile) filteredDocs.push(uploadedFile);
            setDocuments(filteredDocs);
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).uploadDocument.success);
            setShowUploadModal(false);
        } catch (error) {
            console.error('DocumentLibrary: File upload failed:', error);
            (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).uploadDocument.error(error));
        } finally{
            setIsLoading(false);
        }
    };
    const handleOpenDeleteModal = (document1)=>{
        setDocumentToDelete(document1);
    };
    const handleCloseDeleteModal = ()=>{
        setDocumentToDelete(null);
    };
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                direction: "row",
                align: "center",
                justify: "between",
                pad: {
                    bottom: '1rem'
                },
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                        color: "dark-1",
                        size: "large",
                        weight: 300,
                        children: t('documents:title')
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        direction: "row",
                        align: "center",
                        gap: "small",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f7f71094d2af306c$export$55d7609a8f1eccd2), {
                                searchQuery: searchQuery,
                                placeholder: t('documents:searchByName'),
                                setSearchQuery: setSearchQuery,
                                onSearch: setSearchQuery
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c9158ac1cba12f75$export$64fff40e709e8b2e), {
                                plain: true,
                                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $eec4bc4b18205d01$export$ec91da630f36d5ea), {
                                    color: isFiltersMenuHovered || isFiltersMenuOpen ? 'brand' : undefined
                                }),
                                open: isFiltersMenuOpen,
                                onOpen: openFilters,
                                onClose: ()=>setIsFiltersMenuOpen(false),
                                onMouseOver: ()=>setIsFiltersMenuHovered(true),
                                onMouseOut: ()=>setIsFiltersMenuHovered(false),
                                tip: tooltips.filterDocuments,
                                dropAlign: {
                                    right: 'right',
                                    top: 'bottom'
                                },
                                dropContent: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d5dc00f4222e17dc$export$c9824d87391788f3), {
                                    isFiltering: false,
                                    onSubmit: applyFilters,
                                    onClear: clearFilters,
                                    filters: [
                                        {
                                            label: t('documents:documentType'),
                                            value: draftFilters.typeId,
                                            setValue: (value)=>setDraftFilters({
                                                    ...draftFilters,
                                                    typeId: value || ''
                                                }),
                                            options: typeOptions
                                        },
                                        {
                                            label: t('documents:uploadedBy'),
                                            value: draftFilters.uploadedById,
                                            setValue: (value)=>setDraftFilters({
                                                    ...draftFilters,
                                                    uploadedById: value || ''
                                                }),
                                            options: uploadedByOptions
                                        }
                                    ]
                                })
                            }),
                            selectedIds.length > 0 && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $85ab7488c493b81c$export$6d88ebe453be59d7), {
                                label: `${isBulkDownloading ? t('documents:preparingDownload') : t('documents:downloadSelected')} (${selectedIds.length})`,
                                onClick: handleBulkDownload,
                                disabled: isBulkDownloading,
                                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $400b12c0802e75f5$export$a7aaed3e118dd255), {
                                    size: "small"
                                })
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $85ab7488c493b81c$export$6d88ebe453be59d7), {
                                label: t('documents:uploadDocument'),
                                onClick: handleUploadClick,
                                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $75e19b0b448daba9$export$c58532f0fb5faa97), {
                                    size: "small"
                                })
                            })
                        ]
                    })
                ]
            }),
            showUploadModal && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $75a3dedec9c5143a$export$b145f5fea76038de), {
                onClose: ()=>setShowUploadModal(false),
                onUpload: handleFileUpload
            }),
            documentToDelete && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
                position: "center",
                onEsc: handleCloseDeleteModal,
                onClickOutside: handleCloseDeleteModal,
                responsive: false,
                style: {
                    width: 'auto',
                    maxWidth: 'min(95vw, 500px)',
                    maxHeight: '95vh',
                    overflow: 'auto',
                    borderRadius: '8px'
                },
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $98b6153ed086d9bd$export$11154b700737b45e), {
                    width: "100%",
                    title: t('documents:deleteDocument'),
                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c0227736b4f29df5$export$b34a105447964f9f), {
                        size: "20px",
                        color: "status-warning"
                    }),
                    onSubmit: handleDeleteDocument,
                    isLoading: isDeletingId === documentToDelete.id,
                    hideRequiredText: true,
                    saveButtonLabel: "DELETE",
                    saveButtonLoadingLabel: "DELETING...",
                    saveButtonDisabled: isDeletingId === documentToDelete.id,
                    headerChildren: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                            pad: "none",
                            onClick: handleCloseDeleteModal,
                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c1da19823027de53$export$f39c2d165cd861fe), {
                                size: "20px"
                            }),
                            tip: t('common:close')
                        }, "close")
                    ],
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        pad: {
                            horizontal: 'medium'
                        },
                        gap: "small",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                            gap: "1rem",
                            direction: "row",
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e23e190c1adfeb13$export$a2518b5310db22ab), {
                                    size: "medium",
                                    color: "status-warning"
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    children: [
                                        t('documents:deleteDocumentWarning'),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                            weight: "bold",
                                            as: "span",
                                            wordBreak: "break-word",
                                            children: documentToDelete.name
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                    pad: "none",
                    gap: "none",
                    children: [
                        isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}),
                        !isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            elevation: "small",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6312252410d7d442$export$df30df7ec97b32b5), {
                                pad: {
                                    horizontal: '1rem'
                                },
                                columns: [
                                    {
                                        property: 'name',
                                        size: '39%',
                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                            title: t('documents:documentName')
                                        }),
                                        render: (document1)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                margin: {
                                                    vertical: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)('14px')
                                                },
                                                direction: "row",
                                                align: "center",
                                                gap: "xsmall",
                                                children: [
                                                    document1.client_file_state?.id === 1 && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ceab9ef72b825454$export$c92c6401b52a9298), {
                                                        content: t('documents:processing'),
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $933b206c59f003bb$export$126db9180177689d), {
                                                            className: "rotate",
                                                            color: "accent-1",
                                                            size: "18px"
                                                        })
                                                    }),
                                                    document1.client_file_state?.id === 2 && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ceab9ef72b825454$export$c92c6401b52a9298), {
                                                        content: t('documents:needsReview'),
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $11571e85aa9685ed$export$5a89edf87f611fb5), {
                                                            color: "status-warning",
                                                            size: "18px"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        size: "medium",
                                                        fontFamily: "Lato, sans-serif",
                                                        wordBreak: "break-word",
                                                        style: {
                                                            textWrap: 'pretty'
                                                        },
                                                        children: document1.name
                                                    })
                                                ]
                                            })
                                    },
                                    {
                                        property: 'client_file_type.name',
                                        size: '16%',
                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                            title: t('documents:documentType')
                                        }),
                                        render: (document1)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                margin: {
                                                    vertical: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)('14px')
                                                },
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    size: "medium",
                                                    fontFamily: "Lato, sans-serif",
                                                    children: document1.client_file_type?.name || 'Unknown'
                                                })
                                            })
                                    },
                                    {
                                        property: 'uploaded_at',
                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                            title: t('documents:dateUploaded'),
                                            style: {
                                                whiteSpace: 'nowrap'
                                            }
                                        }),
                                        render: (document1)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                margin: {
                                                    vertical: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)('14px')
                                                },
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    size: "medium",
                                                    fontFamily: "Lato, sans-serif",
                                                    style: {
                                                        whiteSpace: 'nowrap'
                                                    },
                                                    children: document1.uploaded_at ? $0e46cba362a640b5$var$formatDate(document1.uploaded_at) : 'N/A'
                                                })
                                            })
                                    },
                                    {
                                        property: 'user.name',
                                        size: '15%',
                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                            title: t('documents:uploadedBy')
                                        }),
                                        render: (document1)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                margin: {
                                                    vertical: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)('14px')
                                                },
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    size: "medium",
                                                    fontFamily: "Lato, sans-serif",
                                                    children: document1.user?.name || 'N/A'
                                                })
                                            })
                                    },
                                    {
                                        property: 'comments',
                                        size: '30%',
                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                            title: t('common:comments')
                                        }),
                                        render: (document1)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                margin: {
                                                    vertical: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)('14px')
                                                },
                                                children: document1.isEditing ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)($0e46cba362a640b5$var$CommentEditor, {
                                                    initialValue: commentDrafts.current.get(document1.id) ?? '',
                                                    onChange: (value)=>commentDrafts.current.set(document1.id, value)
                                                }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)($0e46cba362a640b5$var$CommentPreview, {
                                                    comment: document1.comments || t('documents:noComments')
                                                })
                                            })
                                    },
                                    {
                                        property: 'actions',
                                        sortable: false,
                                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2e9b6825878d9ee2$export$c000c84d05eea37), {
                                            title: ""
                                        }),
                                        render: (document1)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                margin: {
                                                    vertical: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)('18px')
                                                },
                                                direction: "row",
                                                gap: "small",
                                                justify: "center",
                                                width: '175px',
                                                children: document1.isEditing ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cb4cc5db45d03478$exports.Fragment), {
                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                        direction: "row",
                                                        gap: "small",
                                                        justify: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ad3dfa44adb42595$export$353f5b6fc5456de1), {
                                                                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f16983307411ac60$export$be11e187edb4cb0c), {
                                                                    size: "small"
                                                                }),
                                                                onClick: ()=>handleSaveDocument(document1),
                                                                disabled: isSavingId === document1.id,
                                                                tip: t('documents:saveChanges')
                                                            }),
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ad3dfa44adb42595$export$353f5b6fc5456de1), {
                                                                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c1da19823027de53$export$f39c2d165cd861fe), {
                                                                    size: "small"
                                                                }),
                                                                onClick: ()=>handleCancelEdit(document1.id),
                                                                disabled: isSavingId === document1.id,
                                                                tip: t('documents:cancelEditing')
                                                            })
                                                        ]
                                                    }, `edit-${document1.id}`)
                                                }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cb4cc5db45d03478$exports.Fragment), {
                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                        direction: "row",
                                                        gap: "small",
                                                        justify: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ceab9ef72b825454$export$c92c6401b52a9298), {
                                                                content: document1.client_file_state?.id === 1 ? t('documents:cannotDownloadWhileProcessing') : document1.client_file_state?.id === 2 ? t('documents:cannotDownloadFileNeedsReview') : t('documents:downloadDocument'),
                                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)("span", {
                                                                    style: {
                                                                        display: 'inline-block',
                                                                        pointerEvents: 'auto'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ad3dfa44adb42595$export$353f5b6fc5456de1), {
                                                                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $400b12c0802e75f5$export$a7aaed3e118dd255), {
                                                                            size: "small"
                                                                        }),
                                                                        onClick: ()=>handleDownloadDocument(document1),
                                                                        disabled: isDownloadingId === document1.id || document1.client_file_state?.id === 2 || document1.client_file_state?.id === 1,
                                                                        style: {
                                                                            pointerEvents: 'auto'
                                                                        }
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ad3dfa44adb42595$export$353f5b6fc5456de1), {
                                                                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $a40a45464445f23e$export$6ed0965c9443aaa6), {
                                                                    size: "small"
                                                                }),
                                                                onClick: ()=>handleEditDocument(document1),
                                                                tip: t('documents:editComments')
                                                            }),
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ad3dfa44adb42595$export$353f5b6fc5456de1), {
                                                                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $3e20861326453585$export$99442c433de1441d), {
                                                                    size: "small"
                                                                }),
                                                                onClick: ()=>handleOpenDeleteModal(document1),
                                                                disabled: isDeletingId === document1.id,
                                                                tip: t('documents:deleteDocument')
                                                            })
                                                        ]
                                                    }, `view-${document1.id}`)
                                                })
                                            })
                                    }
                                ],
                                data: filteredDocuments,
                                primaryKey: "id",
                                select: selectedIds,
                                onSelect: (ids)=>setSelectedIds(ids.map(Number)),
                                sortable: true,
                                step: 20,
                                paginate: {
                                    alignSelf: 'center',
                                    size: 'small',
                                    margin: {
                                        vertical: '1.5rem'
                                    }
                                },
                                background: [
                                    'light-6',
                                    'white'
                                ],
                                style: {
                                    minWidth: '900px'
                                }
                            })
                        }),
                        filteredDocuments.length === 0 && !isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            pad: {
                                horizontal: '1.5rem',
                                vertical: '2rem'
                            },
                            background: "light-6",
                            align: "center",
                            justify: "center",
                            gap: "small",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    size: "medium",
                                    fontFamily: "Lato, sans-serif",
                                    children: hasActiveFilters ? t('documents:noDocumentsMatchFilters') : t('documents:noDocumentsFound')
                                }),
                                hasActiveFilters && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ad3dfa44adb42595$export$353f5b6fc5456de1), {
                                    label: t('documents:clearFilters'),
                                    onClick: clearFilters
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};





var $2xPiy = parcelRequire("2xPiy");


const $ea039e16ca87cc85$export$28f524c77ee81092 = ({ tourName: tourName, steps: steps, autoStart: autoStart = false, showOnce: showOnce = true, config: config })=>{
    const { isFuseAdmin: isFuseAdmin } = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const startTour = (0, $2xPiy.useCallback)(()=>{
        if (isFuseAdmin) return;
        const tour = (0, $3d0c747b3f894c98$export$a491843cc088839f)(steps, {
            ...config,
            onDestroyed: ()=>{
                if (showOnce) (0, $3d0c747b3f894c98$export$23395c972863dbd3)(tourName);
                if (config?.onDestroyed) config.onDestroyed();
            },
            onNextClick: (element, step, options)=>{
                const currentStepIndex = options.state.activeIndex ?? 0;
                if (currentStepIndex === steps.length - 1) tour.destroy();
                else tour.moveNext();
                config?.onNextClick?.(element, step, options);
            }
        });
        tour.drive();
    }, [
        steps,
        config,
        tourName,
        showOnce,
        isFuseAdmin
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (autoStart && (!showOnce || !(0, $3d0c747b3f894c98$export$77062b4cb4095a52)(tourName))) {
            const timer = setTimeout(()=>{
                startTour();
            }, 500);
            return ()=>clearTimeout(timer);
        }
    }, [
        autoStart,
        showOnce,
        tourName,
        startTour
    ]);
    return {
        startTour: startTour,
        hasSeenTour: (0, $3d0c747b3f894c98$export$77062b4cb4095a52)(tourName)
    };
};








const $1459dcf2d83e59a2$export$98997b5b698aaf10 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const clientStore = (0, $116967e0234c3770$export$3b47afa599c78f61)();
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const params = (0, $62d58f5c28b15c2e$export$99eaa27ddbbb95ef)();
    const location = (0, $62d58f5c28b15c2e$export$45d76561a5302f2b)();
    const [searchParams] = (0, $79bcac94ca400be1$export$f1a78c17382fe22a)();
    const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const queryClient = (0, $bccbe1b43ff3d0cc$export$22e77b9572c4fded)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** Refs **/ const defaultFormData = (0, $2xPiy.useRef)({
        name: '',
        website: '',
        business_id: '',
        start_date: '',
        end_date: '',
        first_active_reporting_quarter: '',
        jumpstart_amount: '',
        comments: '',
        hq_address_line1: '',
        hq_address_line2: '',
        hq_address_city: '',
        hq_address_region_id: NaN,
        country_id: NaN,
        hq_address_post_code: '',
        programs: [],
        sales: [],
        referral: []
    });
    /** State **/ const [isLoading, setIsLoading] = (0, $2xPiy.useState)(true);
    const [isUpdating, setIsUpdating] = (0, $2xPiy.useState)(false);
    const [activeTab, setActiveTab] = (0, $2xPiy.useState)(getInitialActiveTab());
    const [focusedTab, setFocusedTab] = (0, $2xPiy.useState)('');
    const stripeEmailUpdateRef = (0, $2xPiy.useRef)(null);
    const [formValues, setFormValues] = (0, $2xPiy.useState)(defaultFormData.current);
    const [originalFormValues, setOriginalFormValues] = (0, $2xPiy.useState)(defaultFormData.current);
    const [formErrors, setFormErrors] = (0, $2xPiy.useState)({});
    const [isInvalidParams, setIsInvalidParams] = (0, $2xPiy.useState)(false);
    const [hasChanges, setHasChanges] = (0, $2xPiy.useState)(false);
    const [stripeEmailHasChanges, setStripeEmailHasChanges] = (0, $2xPiy.useState)(false);
    const [isRetired, setIsRetired] = (0, $2xPiy.useState)(false);
    const [showRetireModal, setShowRetireModal] = (0, $2xPiy.useState)(false);
    const [shouldRefresh, setShouldRefresh] = (0, $2xPiy.useState)(false);
    /** Computed **/ const clientId = parseInt(params.client_id ?? '');
    const isMobile = (0, $18588a518ac6fdc7$export$2ac00d7098bf223)(screenSize);
    const isCanada = clientStore.selectedClient?.country_id === (0, $0badf5665deea2b2$export$b77c37614753bffb).Canada;
    const lastReportingPeriod = clientStore.selectedClient?.last_active_reporting_quarter ? isCanada ? clientStore.selectedClient?.last_active_reporting_quarter?.slice(0, 4) : (0, $00658ccd6ec0135a$export$6a2a5264dcc16b56)((0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(clientStore.selectedClient?.last_active_reporting_quarter).toDate()) : undefined;
    const titleBar = (0, $2xPiy.useMemo)(()=>{
        const badges = [];
        if (lastReportingPeriod) badges.push(/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
            pad: {
                horizontal: '0.5rem'
            },
            gap: "xsmall",
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                size: "0.95rem",
                weight: 600,
                toUpperCase: true,
                children: `${t('client:retired')}: ${lastReportingPeriod}`
            })
        }, "retired"));
        if (clientStore.selectedClient?.is_demo) badges.push(/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
            pad: {
                horizontal: '0.5rem'
            },
            gap: "xsmall",
            background: {
                color: 'status-critical',
                opacity: 'medium'
            },
            border: {
                color: 'status-critical'
            },
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                size: "0.95rem",
                weight: 600,
                toUpperCase: true,
                children: "Demo Client"
            })
        }, "demo"));
        return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            gap: "small",
            direction: "row",
            children: badges
        });
    }, [
        lastReportingPeriod,
        t,
        clientStore.selectedClient?.is_demo
    ]);
    const userCanRetire = userStore.isFuseAdmin && !isRetired;
    const menuButtonItems = (0, $2xPiy.useMemo)(()=>userCanRetire ? [
            {
                label: t('client:retireClient'),
                onClick: ()=>setShowRetireModal(true)
            }
        ] : [], [
        userCanRetire,
        t
    ]);
    /** Methods **/ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const updateFormValue = (key, value)=>{
        setFormValues((prev)=>{
            const newFormValues = {
                ...prev,
                [key]: value
            };
            const changesExist = Object.keys(newFormValues).some((k)=>JSON.stringify(newFormValues[k]) !== JSON.stringify(originalFormValues[k]));
            setHasChanges(changesExist);
            return newFormValues;
        });
        if (formErrors[key]) setFormErrors((prev)=>({
                ...prev,
                [key]: ''
            }));
    };
    const fetchPageData = async (clientId)=>{
        try {
            setIsLoading(true);
            const client = await (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).get({
                id: clientId
            });
            clientStore.setSelectedClient(client);
            document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, client.name);
            setIsRetired((0, $2e4d07611f552ce8$export$f35193465aab1579)(client));
            const formData = {
                ...formValues,
                name: client.name,
                first_active_reporting_quarter: client.first_active_reporting_quarter,
                start_date: client.start_date,
                end_date: client.end_date ?? '',
                website: client.website ?? '',
                business_id: client.business_id ?? '',
                jumpstart_amount: '',
                comments: client.comments,
                hq_address_line1: client.hq_address_line1 ?? '',
                hq_address_line2: client.hq_address_line2 ?? '',
                hq_address_city: client.hq_address_city ?? '',
                hq_address_region_id: client.hq_address_region?.id ?? NaN,
                country_id: client.country_id ?? NaN,
                hq_address_post_code: client.hq_address_post_code ?? ''
            };
            setFormValues(formData);
            setOriginalFormValues({
                ...formData
            });
            setHasChanges(false);
            setStripeEmailHasChanges(false);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).fetchClient.error);
        } finally{
            setIsLoading(false);
        }
    };
    const validateForm = ()=>{
        const formFields = {
            name: {
                label: 'Name',
                max: 100,
                required: true
            },
            start_date: {
                label: 'Start date',
                required: true
            },
            website: {
                label: 'Website',
                max: 255
            },
            business_id: {
                label: 'FEIN or Business Number',
                required: true,
                max: 20
            },
            comments: {
                label: 'Comments',
                max: 500
            },
            hq_address_line1: {
                label: 'Address',
                max: 100,
                required: true
            },
            hq_address_line2: {
                label: 'Address',
                max: 100
            },
            hq_address_city: {
                label: 'City',
                max: 50,
                required: true
            },
            hq_address_region_id: {
                label: 'Region',
                required: true
            },
            hq_address_post_code: {
                label: 'Postal code',
                max: 20,
                required: true
            }
        };
        const errors = (0, $084681c8221d0a24$export$5fafec8d1b047c0)(formFields, formValues);
        if (errors) setFormErrors(errors);
        return !errors;
    };
    const updateClient = async ()=>{
        const stripeEmailHandle = activeTab === 3 && stripeEmailHasChanges ? stripeEmailUpdateRef.current : null;
        if (stripeEmailHandle && !stripeEmailHandle.validate()) return;
        if (stripeEmailHandle && !hasChanges) {
            setIsUpdating(true);
            try {
                await stripeEmailHandle.save();
                setStripeEmailHasChanges(false);
                (0, $05d5739209a21833$export$b410431fab84fa58).success('Email updated successfully');
            } catch (err) {
                globalStore.handleApiError(err, ()=>'Failed to update email');
            } finally{
                setIsUpdating(false);
            }
            return;
        }
        if (!validateForm()) return;
        const clientWebsite = formValues.website ? formValues.website.split('://').length === 1 ? `https://${formValues.website}` : formValues.website : null;
        const updatedClient = {
            id: clientId,
            name: formValues.name,
            website: clientWebsite,
            business_id: formValues.business_id,
            jumpstart_amount: null,
            comments: formValues.comments || null,
            hq_address_line1: formValues.hq_address_line1,
            hq_address_line2: formValues.hq_address_line2 || null,
            hq_address_city: formValues.hq_address_city,
            hq_address_region_id: formValues.hq_address_region_id,
            hq_address_post_code: formValues.hq_address_post_code
        };
        try {
            setIsUpdating(true);
            const client = await (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).update(updatedClient);
            clientStore.setSelectedClient(client);
            queryClient.invalidateQueries({
                queryKey: [
                    'clients'
                ]
            });
            setFormErrors({});
            if (stripeEmailHandle) {
                await stripeEmailHandle.save();
                setStripeEmailHasChanges(false);
            }
            const updatedFormValues = {
                ...formValues
            };
            setFormValues(updatedFormValues);
            setOriginalFormValues({
                ...updatedFormValues
            });
            setHasChanges(false);
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updateClient.success);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updateClient.error);
        } finally{
            setIsUpdating(false);
        }
    };
    function getInitialActiveTab() {
        const view = searchParams.get('view');
        if (view === 'contacts') return 1;
        if (view === 'documents') return 2;
        if (view === 'stripe') return 3;
        return 0;
    }
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (!clientId || globalStore.isLoading) return;
        fetchPageData(clientId);
    }, [
        clientId,
        globalStore.isLoading
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (!clientId || globalStore.isLoading || !shouldRefresh) return;
        queryClient.invalidateQueries({
            queryKey: [
                'clients'
            ]
        });
        queryClient.invalidateQueries({
            queryKey: [
                'facilities'
            ]
        });
        queryClient.invalidateQueries({
            queryKey: [
                'equipment'
            ]
        });
        fetchPageData(clientId).finally(()=>setShouldRefresh(false));
    }, [
        clientId,
        globalStore.isLoading,
        shouldRefresh
    ]);
    (0, $2xPiy.useEffect)(()=>{
        const searchParams = new URLSearchParams(location.search);
        const view = searchParams.get('view');
        if (view === 'contacts' && activeTab !== 1) setActiveTab(1);
        else if (view === 'documents' && activeTab !== 2) setActiveTab(2);
        else if (view === 'stripe' && activeTab !== 3) setActiveTab(3);
        else if (!view && activeTab !== 0) setActiveTab(0);
    }, [
        location.search,
        activeTab
    ]);
    //404 Redirect
    (0, $2xPiy.useEffect)(()=>{
        if (isLoading) return;
        setIsInvalidParams(Number.isNaN(clientId) || clientStore.selectedClient?.id === undefined);
    }, [
        clientId,
        clientStore.selectedClient,
        isLoading
    ]);
    /* Product Tour */ (0, $ea039e16ca87cc85$export$28f524c77ee81092)({
        tourName: 'company-tour',
        steps: (0, $3d0c747b3f894c98$export$c55ca0fafd817c94),
        autoStart: true,
        showOnce: true
    });
    /** Render **/ return isInvalidParams ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8fedf23083f90239$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $3d99c6153124a6ba$export$7234abc5d81adb58), {
        title: clientStore.selectedClient?.name,
        titleBar: titleBar,
        breadcrumbNav: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e7dd63b10d4904e9$export$988959db72b892c3), {
            previousPages: [
                {
                    name: t('navigation:clients'),
                    link: !userStore.isClientUser && !userStore.isFacilityUser ? '/clients' : undefined
                }
            ],
            currentPageName: clientStore.selectedClient?.name ?? ''
        }),
        isLoading: isLoading,
        isDetailPage: true,
        isClientPage: true,
        clientId: clientId,
        hideMenuButton: !isLoading && !menuButtonItems.length,
        menuButtonItems: menuButtonItems,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                gap: "2rem",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $98b6153ed086d9bd$export$11154b700737b45e), {
                        title: "Client Details",
                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7dacb42a28be9c15$export$7036cd8426a1245b), {
                            size: "24px",
                            color: "brand"
                        }),
                        isLoading: isLoading || isUpdating,
                        onSubmit: updateClient,
                        hideSaveButton: activeTab === 1 || activeTab === 2 || activeTab === 3 && !clientStore.selectedClient?.stripe_global_payouts_account_id,
                        hideRequiredText: activeTab === 1 || activeTab === 2 || activeTab === 3,
                        saveButtonLabel: t('common:saveChanges'),
                        saveButtonDisabled: !hasChanges && !stripeEmailHasChanges,
                        header: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f557854f3abac6b7$export$5665775b26e26c5d), {
                            pad: "none",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b012ec9a92c56d14$export$b2539bed5023c21c), {
                                titles: [
                                    t('client:details'),
                                    t('client:contacts'),
                                    t('client:documents'),
                                    t('client:stripeDetails')
                                ],
                                activeTab: activeTab,
                                focusedTab: focusedTab,
                                dataTours: [
                                    'details-tab',
                                    'contacts-tab',
                                    'documents-tab',
                                    'stripe-tab'
                                ],
                                setActiveTab: (index)=>{
                                    if (activeTab === 3 && index !== 3) setStripeEmailHasChanges(false);
                                    setActiveTab(index);
                                    const newSearchParams = new URLSearchParams(location.search);
                                    if (index === 1) newSearchParams.set('view', 'contacts');
                                    else if (index === 2) newSearchParams.set('view', 'documents');
                                    else if (index === 3) newSearchParams.set('view', 'stripe');
                                    else newSearchParams.delete('view');
                                    navigate(`/clients/${clientId}?${newSearchParams.toString()}`, {
                                        replace: true
                                    });
                                },
                                setFocusedTab: setFocusedTab
                            })
                        }),
                        children: [
                            activeTab === 0 && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                "data-tour": "company-info",
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $de52040ad2eb6f89$export$993f34602c1007f2), {
                                    id: "general_information",
                                    updateFormValue: updateFormValue,
                                    formValues: formValues,
                                    formErrors: formErrors,
                                    isCanada: isCanada,
                                    isRetired: !!lastReportingPeriod,
                                    retirementReasonText: clientStore.selectedClient?.retirement_reason,
                                    onSubmit: ()=>updateClient(),
                                    isUpdatePage: true
                                })
                            }),
                            activeTab === 0 && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                margin: "1rem"
                            }),
                            activeTab === 0 && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                direction: isMobile ? 'column' : 'row',
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        id: "corporate_information",
                                        width: isMobile ? '100%' : '50%',
                                        "data-tour": "corporate-info",
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e31e2b64690d9b7f$export$626f1e8296fbac24), {
                                            updateFormValue: updateFormValue,
                                            formValues: formValues,
                                            formErrors: formErrors,
                                            onSubmit: ()=>updateClient()
                                        })
                                    }),
                                    isMobile ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                        margin: "0.5rem"
                                    }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                        direction: "vertical",
                                        margin: "2rem"
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        width: isMobile ? '100%' : '50%',
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6b8a0ccd47eb1071$export$d0e26fee1e9d154b), {
                                            updateFormValue: updateFormValue,
                                            formValues: formValues,
                                            formErrors: formErrors,
                                            disabled: true
                                        })
                                    })
                                ]
                            }),
                            activeTab === 1 && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                "data-tour": "contacts",
                                gap: "none",
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8c584e3e17a0dda3$export$78c2aadc68a82149), {
                                    id: "contacts",
                                    contacts: (clientStore.selectedClient?.users ?? []).filter((user)=>user.is_active && user.role.id === (0, $a65473e9746b33bb$export$2cb4a31baf73b247).ClientAdmin),
                                    isCorporate: true,
                                    isUpdatePage: true
                                })
                            }),
                            activeTab === 2 && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                "data-tour": "document-library",
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $0e46cba362a640b5$export$490c14823245408e), {
                                    clientId: clientId
                                })
                            }),
                            activeTab === 3 && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                "data-tour": "remittance-details",
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $80f166595780ff32$export$c1431067121b97), {
                                    clientId: clientId,
                                    onEmailChange: setStripeEmailHasChanges,
                                    emailUpdateRef: stripeEmailUpdateRef
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $93b56b8d4d0da6dd$export$9f76c3e28857a02f), {
                        id: "facility_list",
                        title: t('common:facilities'),
                        clientId: clientId,
                        showAddButton: true,
                        showSearchInput: true,
                        showShareButton: true,
                        "data-tour": "facilities-list"
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        "data-tour": "statements-list",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $659efb5a52c8fd59$export$c2a262540e4917c2), {
                            id: "statement_list",
                            title: t('statements:statements'),
                            clientId: clientId
                        })
                    }),
                    userStore.user && userStore.isInternalUser && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        "data-tour": "commission-rates",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ae84c926caf84bce$export$59a928bbf298277f), {
                            id: "commission_list",
                            title: t('commissions:commissions'),
                            clientId: clientId,
                            clientPrograms: clientStore.selectedClient?.client_programs,
                            salesCommissions: clientStore.selectedClient?.sales_commission_rates,
                            referralCommissions: clientStore.selectedClient?.referral_commission_rates
                        })
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        "data-tour": "users-list",
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b8d120ccf98e8417$export$21b6143e6c635cfa), {
                            id: "user_list",
                            title: t('user:users'),
                            mode: "controlled",
                            users: clientStore.selectedClient?.users,
                            clientId: clientId,
                            isClientPage: true,
                            showAddButton: true
                        })
                    })
                ]
            }),
            showRetireModal && clientStore.selectedClient && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $0a4cd5935f7bb50d$export$22a9bb52ea2aeb6d), {
                client: clientStore.selectedClient,
                setIsVisible: setShowRetireModal,
                setShouldRefresh: setShouldRefresh,
                isCanada: isCanada
            })
        ]
    });
});




var $2xPiy = parcelRequire("2xPiy");











const $703e9c669e2e0f9f$export$a59b2fd874460803 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { id: id, commissions: commissions, setCommissions: setCommissions, formErrors: formErrors } = props;
    /** Methods **/ const updateFormValue = (key, index, value)=>{
        const updatedValues = [
            ...commissions
        ];
        updatedValues[index] = {
            ...updatedValues[index],
            [key]: value
        };
        setCommissions(updatedValues);
        formErrors[index] ??= {};
        if (formErrors[index][key]) formErrors[index][key] = '';
    };
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
        id: id,
        title: "Referral Commissions",
        children: commissions.map((commission, index)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                row: true,
                gap: "1rem",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                        id: "referral_partner_id",
                        label: "Referrer",
                        value: commission.referral_partner_id,
                        setValue: (value)=>updateFormValue('referral_partner_id', index, value),
                        options: props.referralPartners?.map((partner)=>({
                                label: partner.name,
                                value: partner.id
                            })) || [],
                        error: formErrors[index]?.['referral_partner_id'],
                        fill: "horizontal"
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $eabeffcc0be0175a$export$dec03dc0f3ef8025), {
                        id: "referral_commission_percent_rate",
                        label: "Commission Percent (%)",
                        value: commission.percent_rate,
                        setValue: (value)=>updateFormValue('percent_rate', index, value),
                        error: formErrors[index]?.['percent_rate'],
                        componentType: "percent",
                        isActiveLabel: true,
                        fill: "horizontal"
                    })
                ]
            }, index))
    });
});





const $94833b8dafbeb94f$export$b464f644e6e70fd = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)((props)=>{
    const { id: id, commissions: commissions, setCommissions: setCommissions, formErrors: formErrors } = props;
    /** Methods **/ const updateFormValue = (key, index, value)=>{
        const updatedValues = [
            ...commissions
        ];
        updatedValues[index] = {
            ...updatedValues[index],
            [key]: value
        };
        setCommissions(updatedValues);
        formErrors[index] ??= {};
        if (formErrors[index][key]) formErrors[index][key] = '';
    };
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
        id: id,
        title: "Sales Commissions",
        children: commissions.map((commission, index)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                row: true,
                gap: "1rem",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                        id: "user_id",
                        label: "Salesperson",
                        value: commission.user_id,
                        setValue: (value)=>updateFormValue('user_id', index, value),
                        options: props.users?.filter((user)=>[
                                977,
                                22,
                                53,
                                58,
                                1175,
                                7,
                                10
                            ].includes(user.id)).map((user)=>({
                                label: user.name,
                                value: user.id
                            })) || [],
                        error: formErrors[index]?.['user_id'],
                        fill: "horizontal"
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $eabeffcc0be0175a$export$dec03dc0f3ef8025), {
                        id: "sales_commission_percent_rate",
                        label: "Commission Percent (%)",
                        value: commission.percent_rate,
                        setValue: (value)=>updateFormValue('percent_rate', index, value),
                        error: formErrors[index]?.['percent_rate'],
                        componentType: "percent",
                        isActiveLabel: true,
                        fill: "horizontal"
                    })
                ]
            }, index))
    });
});







const $9af6a02c74f839ab$export$2b805d58bbc86d8c = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    /** Refs **/ const defaultFormData = (0, $2xPiy.useRef)({
        name: '',
        website: '',
        business_id: '',
        start_date: '',
        first_active_reporting_quarter: '',
        jumpstart_amount: '',
        comments: '',
        hq_address_line1: '',
        hq_address_line2: '',
        hq_address_city: '',
        hq_address_region_id: NaN,
        country_id: NaN,
        hq_address_post_code: '',
        sales: [
            {
                user_id: undefined,
                percent_rate: ''
            }
        ],
        referral: [
            {
                referral_partner_id: undefined,
                percent_rate: ''
            }
        ],
        programs: []
    });
    /** State **/ const [isLoading] = (0, $2xPiy.useState)(false);
    const [referralPartners, setReferralPartners] = (0, $2xPiy.useState)([]);
    const [isCreating, setIsCreating] = (0, $2xPiy.useState)(false);
    // Form Values
    const [formValues, setFormValues] = (0, $2xPiy.useState)(defaultFormData.current);
    const [formErrors, setFormErrors] = (0, $2xPiy.useState)({});
    const [commissionErrors, setCommissionErrors] = (0, $2xPiy.useState)({});
    const [salesCommissionErrors, setSalesCommissionErrors] = (0, $2xPiy.useState)({});
    const [referralCommissionErrors, setReferralCommissionErrors] = (0, $2xPiy.useState)({});
    /** Computed **/ const isMobile = (0, $18588a518ac6fdc7$export$2ac00d7098bf223)(screenSize);
    const isCanada = formValues.country_id === (0, $0badf5665deea2b2$export$b77c37614753bffb).Canada;
    /** Methods **/ const updateFormValue = (key, value)=>{
        setFormValues((prev)=>({
                ...prev,
                [key]: value
            }));
        if (formErrors[key]) formErrors[key] = '';
    };
    const validateForm = (formValues, shouldSetErrors = true)=>{
        if (!formValues) return false;
        const formFields = {
            name: {
                label: 'Name',
                max: 100,
                required: true
            },
            website: {
                label: 'Website',
                max: 255
            },
            business_id: {
                label: 'FEIN or Business Number',
                required: true,
                max: 20
            },
            start_date: {
                label: 'Start date',
                required: true
            },
            first_active_reporting_quarter: {
                label: 'First Reporting Period',
                required: true
            },
            comments: {
                label: 'Comments',
                max: 500
            },
            hq_address_line1: {
                label: 'Address',
                max: 100,
                required: true
            },
            hq_address_line2: {
                label: 'Address',
                max: 100
            },
            hq_address_city: {
                label: 'City',
                max: 50,
                required: true
            },
            country_id: {
                label: 'Country',
                required: true
            },
            hq_address_region_id: {
                label: 'Region',
                required: true
            },
            hq_address_post_code: {
                label: 'Postal code',
                max: 20,
                required: true
            }
        };
        const errors = (0, $084681c8221d0a24$export$5fafec8d1b047c0)(formFields, formValues);
        const programErrors = {};
        let hasProgramErrors = false;
        formValues.programs.forEach((programData, i)=>{
            const dataErrors = (0, $084681c8221d0a24$export$5fafec8d1b047c0)({
                program_id: {
                    label: 'Program',
                    required: true
                },
                rate: {
                    label: 'Commission rate',
                    required: true,
                    nonZero: true,
                    maxValue: programData.is_percent_rate ? 99.99 : 1
                }
            }, programData);
            if (dataErrors) {
                programErrors[i] = dataErrors;
                hasProgramErrors = true;
            }
        });
        const percentRateField = {
            label: 'Commission percent',
            required: true,
            nonZero: true,
            maxValue: 100
        };
        const salesErrors = {};
        let hasSalesErrors = false;
        formValues.sales.forEach((commission, i)=>{
            if (commission.user_id === undefined && !commission.percent_rate) return;
            const dataErrors = (0, $084681c8221d0a24$export$5fafec8d1b047c0)({
                user_id: {
                    label: 'Salesperson',
                    required: true
                },
                percent_rate: percentRateField
            }, commission);
            if (dataErrors) {
                salesErrors[i] = dataErrors;
                hasSalesErrors = true;
            }
        });
        const referralErrors = {};
        let hasReferralErrors = false;
        formValues.referral.forEach((commission, i)=>{
            if (commission.referral_partner_id === undefined && !commission.percent_rate) return;
            const dataErrors = (0, $084681c8221d0a24$export$5fafec8d1b047c0)({
                referral_partner_id: {
                    label: 'Referrer',
                    required: true
                },
                percent_rate: percentRateField
            }, commission);
            if (dataErrors) {
                referralErrors[i] = dataErrors;
                hasReferralErrors = true;
            }
        });
        if (shouldSetErrors) {
            if (errors) setFormErrors(errors);
            if (hasProgramErrors) setCommissionErrors(programErrors);
            setSalesCommissionErrors(salesErrors);
            setReferralCommissionErrors(referralErrors);
        }
        return !errors && !hasProgramErrors && !hasSalesErrors && !hasReferralErrors;
    };
    const createClient = async ()=>{
        const isValid = validateForm(formValues);
        if (!isValid) {
            (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).formValidation.requiredFields);
            return;
        }
        const clientWebsite = formValues.website ? formValues.website.split('://').length === 1 ? `https://${formValues.website}` : formValues.website : null;
        const filteredSalesCommissions = formValues.sales.filter((commission)=>commission.user_id && commission.percent_rate);
        const filteredReferralCommissions = formValues.referral.filter((commission)=>commission.referral_partner_id && commission.percent_rate);
        const totalCommissionRate = [
            ...filteredSalesCommissions,
            ...filteredReferralCommissions
        ].reduce((sum, commission)=>sum + Number(commission.percent_rate), 0);
        if (Math.round(totalCommissionRate * 1e6) / 1e6 > 100) {
            (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).formValidation.commissionTotal);
            return;
        }
        const newClient = {
            name: formValues.name,
            website: clientWebsite,
            business_id: formValues.business_id,
            start_date: formValues.start_date,
            first_active_reporting_quarter: formValues.first_active_reporting_quarter,
            jumpstart_amount: null,
            comments: formValues.comments || null,
            hq_address_line1: formValues.hq_address_line1,
            hq_address_line2: formValues.hq_address_line2 || null,
            hq_address_city: formValues.hq_address_city,
            hq_address_region_id: formValues.hq_address_region_id,
            country_id: formValues.country_id,
            hq_address_post_code: formValues.hq_address_post_code,
            programs: formValues.programs,
            sales_commission_rates: filteredSalesCommissions,
            referral_commission_rates: filteredReferralCommissions
        };
        try {
            setIsCreating(true);
            const client = await (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).create(newClient);
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).createClient.success);
            navigate(`/clients/${client.id}`);
        } catch (err) {
            const apiError = err;
            console.error('[CreateClient] API Error:', apiError.status, apiError.body);
            if (apiError.body?.errors) {
                const errorItems = apiError.body.errors;
                const errors = {
                    ...formErrors
                };
                errorItems.forEach((error)=>{
                    errors[error.field] = (0, $00658ccd6ec0135a$export$9a00dee1beb8f576)(error.message);
                });
                setFormErrors(errors);
            } else globalStore.handleApiError(apiError, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).createClient.error);
        } finally{
            setIsCreating(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, 'Add Client');
        userStore.fetchUsers({
            is_internal: true
        });
        (0, $aab6e7692a93396d$export$fec76eb589c20b4f).list().then((partners)=>{
            const excludedIds = [
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                11,
                13,
                14,
                15,
                35
            ];
            const filteredPartners = partners.filter((partner)=>!excludedIds.includes(partner.id));
            setReferralPartners(filteredPartners);
        }).catch(console.error);
    }, [
        userStore
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $3d99c6153124a6ba$export$7234abc5d81adb58), {
        title: "Add Client",
        breadcrumbNav: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e7dd63b10d4904e9$export$988959db72b892c3), {
            previousPages: [
                {
                    name: 'Clients',
                    link: '/clients'
                }
            ],
            currentPageName: 'Add Client'
        }),
        isLoading: isLoading,
        isDetailPage: true,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $98b6153ed086d9bd$export$11154b700737b45e), {
            title: "Client Details",
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7dacb42a28be9c15$export$7036cd8426a1245b), {
                size: "24px",
                color: "brand"
            }),
            isLoading: isLoading || isCreating,
            onSubmit: createClient,
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $de52040ad2eb6f89$export$993f34602c1007f2), {
                    updateFormValue: updateFormValue,
                    formValues: formValues,
                    formErrors: formErrors,
                    onSubmit: createClient,
                    isCanada: isCanada
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                    margin: "1rem"
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    direction: isMobile ? 'column' : 'row',
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            width: isMobile ? '100%' : '50%',
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e31e2b64690d9b7f$export$626f1e8296fbac24), {
                                updateFormValue: updateFormValue,
                                formValues: formValues,
                                formErrors: formErrors,
                                onSubmit: createClient
                            })
                        }),
                        isMobile ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                            margin: "0.5rem"
                        }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                            direction: "vertical",
                            margin: "2rem"
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            width: isMobile ? '100%' : '50%',
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6b8a0ccd47eb1071$export$d0e26fee1e9d154b), {
                                updateFormValue: updateFormValue,
                                formValues: formValues,
                                formErrors: formErrors
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                    margin: "1rem"
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e51bffab3446bc0d$export$2c87cdb10b310a7c), {
                    countryId: formValues.country_id,
                    commissions: formValues.programs,
                    setCommissions: (value)=>updateFormValue('programs', value),
                    formErrors: commissionErrors
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $94833b8dafbeb94f$export$b464f644e6e70fd), {
                    commissions: formValues.sales,
                    setCommissions: (value)=>updateFormValue('sales', value),
                    formErrors: salesCommissionErrors,
                    users: userStore.users
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $703e9c669e2e0f9f$export$a59b2fd874460803), {
                    commissions: formValues.referral,
                    setCommissions: (value)=>updateFormValue('referral', value),
                    formErrors: referralCommissionErrors,
                    referralPartners: referralPartners
                })
            ]
        })
    });
});




var $2xPiy = parcelRequire("2xPiy");






const $4c3857ef80bdd58c$export$6dbd483c3ae79c29 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    const { isInternalUser: isInternalUser, isAdminUser: isAdminUser, isClientUser: isClientUser } = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    const isLoading = false;
    (0, $2xPiy.useEffect)(()=>{
        document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, 'Clients');
    }, []);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9057517707360bf5$export$9b7824917a0c851e), {
        title: "Clients",
        pageHeader: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c61d91bfa75be0a1$export$53f1cd6809577fc5), {
            title: "Clients",
            showAddButton: isInternalUser || isAdminUser && isClientUser,
            addButtonLabel: t('client:addClient'),
            addButtonUrl: "/clients/create"
        }),
        isLoading: isLoading,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2542f3c44047daf5$export$fb3600cebe42014a), {
            showSearchInput: true,
            showFilters: true,
            standalone: true
        })
    });
});








var $2xPiy = parcelRequire("2xPiy");





var $1hFlE = parcelRequire("1hFlE");
/** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 3.0.4 Built on 2025-11-19T12:48:37.232Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2025 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2025 yWorks GmbH, http://www.yworks.com
 *               2015-2025 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, https://github.com/willowsystems
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */ var $12c96b00a8f2ac07$exports = {};
function $12c96b00a8f2ac07$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $12c96b00a8f2ac07$exports = $12c96b00a8f2ac07$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $12c96b00a8f2ac07$exports.__esModule = true, $12c96b00a8f2ac07$exports["default"] = $12c96b00a8f2ac07$exports, $12c96b00a8f2ac07$var$_typeof(o);
}
$12c96b00a8f2ac07$exports = $12c96b00a8f2ac07$var$_typeof, $12c96b00a8f2ac07$exports.__esModule = true, $12c96b00a8f2ac07$exports["default"] = $12c96b00a8f2ac07$exports;


// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $39aa643a4d3f17c3$var$ch2 = {};
var $39aa643a4d3f17c3$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($39aa643a4d3f17c3$var$ch2[id] || ($39aa643a4d3f17c3$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $39aa643a4d3f17c3$var$u8 = Uint8Array, $39aa643a4d3f17c3$var$u16 = Uint16Array, $39aa643a4d3f17c3$var$i32 = Int32Array;
// fixed length extra bits
var $39aa643a4d3f17c3$var$fleb = new $39aa643a4d3f17c3$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $39aa643a4d3f17c3$var$fdeb = new $39aa643a4d3f17c3$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $39aa643a4d3f17c3$var$clim = new $39aa643a4d3f17c3$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $39aa643a4d3f17c3$var$freb = function(eb, start) {
    var b = new $39aa643a4d3f17c3$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $39aa643a4d3f17c3$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $39aa643a4d3f17c3$var$_a = $39aa643a4d3f17c3$var$freb($39aa643a4d3f17c3$var$fleb, 2), $39aa643a4d3f17c3$var$fl = $39aa643a4d3f17c3$var$_a.b, $39aa643a4d3f17c3$var$revfl = $39aa643a4d3f17c3$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$39aa643a4d3f17c3$var$fl[28] = 258, $39aa643a4d3f17c3$var$revfl[258] = 28;
var $39aa643a4d3f17c3$var$_b = $39aa643a4d3f17c3$var$freb($39aa643a4d3f17c3$var$fdeb, 0), $39aa643a4d3f17c3$var$fd = $39aa643a4d3f17c3$var$_b.b, $39aa643a4d3f17c3$var$revfd = $39aa643a4d3f17c3$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $39aa643a4d3f17c3$var$rev = new $39aa643a4d3f17c3$var$u16(32768);
for(var $39aa643a4d3f17c3$var$i = 0; $39aa643a4d3f17c3$var$i < 32768; ++$39aa643a4d3f17c3$var$i){
    // reverse table algorithm from SO
    var $39aa643a4d3f17c3$var$x = ($39aa643a4d3f17c3$var$i & 0xAAAA) >> 1 | ($39aa643a4d3f17c3$var$i & 0x5555) << 1;
    $39aa643a4d3f17c3$var$x = ($39aa643a4d3f17c3$var$x & 0xCCCC) >> 2 | ($39aa643a4d3f17c3$var$x & 0x3333) << 2;
    $39aa643a4d3f17c3$var$x = ($39aa643a4d3f17c3$var$x & 0xF0F0) >> 4 | ($39aa643a4d3f17c3$var$x & 0x0F0F) << 4;
    $39aa643a4d3f17c3$var$rev[$39aa643a4d3f17c3$var$i] = (($39aa643a4d3f17c3$var$x & 0xFF00) >> 8 | ($39aa643a4d3f17c3$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $39aa643a4d3f17c3$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $39aa643a4d3f17c3$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $39aa643a4d3f17c3$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $39aa643a4d3f17c3$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$39aa643a4d3f17c3$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $39aa643a4d3f17c3$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $39aa643a4d3f17c3$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $39aa643a4d3f17c3$var$flt = new $39aa643a4d3f17c3$var$u8(288);
for(var $39aa643a4d3f17c3$var$i = 0; $39aa643a4d3f17c3$var$i < 144; ++$39aa643a4d3f17c3$var$i)$39aa643a4d3f17c3$var$flt[$39aa643a4d3f17c3$var$i] = 8;
for(var $39aa643a4d3f17c3$var$i = 144; $39aa643a4d3f17c3$var$i < 256; ++$39aa643a4d3f17c3$var$i)$39aa643a4d3f17c3$var$flt[$39aa643a4d3f17c3$var$i] = 9;
for(var $39aa643a4d3f17c3$var$i = 256; $39aa643a4d3f17c3$var$i < 280; ++$39aa643a4d3f17c3$var$i)$39aa643a4d3f17c3$var$flt[$39aa643a4d3f17c3$var$i] = 7;
for(var $39aa643a4d3f17c3$var$i = 280; $39aa643a4d3f17c3$var$i < 288; ++$39aa643a4d3f17c3$var$i)$39aa643a4d3f17c3$var$flt[$39aa643a4d3f17c3$var$i] = 8;
// fixed distance tree
var $39aa643a4d3f17c3$var$fdt = new $39aa643a4d3f17c3$var$u8(32);
for(var $39aa643a4d3f17c3$var$i = 0; $39aa643a4d3f17c3$var$i < 32; ++$39aa643a4d3f17c3$var$i)$39aa643a4d3f17c3$var$fdt[$39aa643a4d3f17c3$var$i] = 5;
// fixed length map
var $39aa643a4d3f17c3$var$flm = /*#__PURE__*/ $39aa643a4d3f17c3$var$hMap($39aa643a4d3f17c3$var$flt, 9, 0), $39aa643a4d3f17c3$var$flrm = /*#__PURE__*/ $39aa643a4d3f17c3$var$hMap($39aa643a4d3f17c3$var$flt, 9, 1);
// fixed distance map
var $39aa643a4d3f17c3$var$fdm = /*#__PURE__*/ $39aa643a4d3f17c3$var$hMap($39aa643a4d3f17c3$var$fdt, 5, 0), $39aa643a4d3f17c3$var$fdrm = /*#__PURE__*/ $39aa643a4d3f17c3$var$hMap($39aa643a4d3f17c3$var$fdt, 5, 1);
// find max of array
var $39aa643a4d3f17c3$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $39aa643a4d3f17c3$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $39aa643a4d3f17c3$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $39aa643a4d3f17c3$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $39aa643a4d3f17c3$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $39aa643a4d3f17c3$var$u8(v.subarray(s, e));
};
var $39aa643a4d3f17c3$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $39aa643a4d3f17c3$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $39aa643a4d3f17c3$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $39aa643a4d3f17c3$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $39aa643a4d3f17c3$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $39aa643a4d3f17c3$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $39aa643a4d3f17c3$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $39aa643a4d3f17c3$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $39aa643a4d3f17c3$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $39aa643a4d3f17c3$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $39aa643a4d3f17c3$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $39aa643a4d3f17c3$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $39aa643a4d3f17c3$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $39aa643a4d3f17c3$var$flrm, dm = $39aa643a4d3f17c3$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $39aa643a4d3f17c3$var$bits(dat, pos, 31) + 257, hcLen = $39aa643a4d3f17c3$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $39aa643a4d3f17c3$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $39aa643a4d3f17c3$var$u8(tl);
                // code length tree
                var clt = new $39aa643a4d3f17c3$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$39aa643a4d3f17c3$var$clim[i]] = $39aa643a4d3f17c3$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $39aa643a4d3f17c3$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $39aa643a4d3f17c3$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$39aa643a4d3f17c3$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $39aa643a4d3f17c3$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $39aa643a4d3f17c3$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $39aa643a4d3f17c3$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $39aa643a4d3f17c3$var$max(lt);
                // max dist bits
                dbt = $39aa643a4d3f17c3$var$max(dt);
                lm = $39aa643a4d3f17c3$var$hMap(lt, lbt, 1);
                dm = $39aa643a4d3f17c3$var$hMap(dt, dbt, 1);
            } else $39aa643a4d3f17c3$var$err(1);
            if (pos > tbts) {
                if (noSt) $39aa643a4d3f17c3$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$39aa643a4d3f17c3$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $39aa643a4d3f17c3$var$err(0);
                break;
            }
            if (!c) $39aa643a4d3f17c3$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $39aa643a4d3f17c3$var$fleb[i];
                    add = $39aa643a4d3f17c3$var$bits(dat, pos, (1 << b) - 1) + $39aa643a4d3f17c3$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$39aa643a4d3f17c3$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $39aa643a4d3f17c3$var$err(3);
                pos += d & 15;
                var dt = $39aa643a4d3f17c3$var$fd[dsym];
                if (dsym > 3) {
                    var b = $39aa643a4d3f17c3$var$fdeb[dsym];
                    dt += $39aa643a4d3f17c3$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $39aa643a4d3f17c3$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $39aa643a4d3f17c3$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $39aa643a4d3f17c3$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $39aa643a4d3f17c3$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $39aa643a4d3f17c3$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $39aa643a4d3f17c3$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $39aa643a4d3f17c3$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $39aa643a4d3f17c3$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $39aa643a4d3f17c3$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $39aa643a4d3f17c3$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $39aa643a4d3f17c3$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $39aa643a4d3f17c3$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($39aa643a4d3f17c3$var$ln(n.l, l, d + 1), $39aa643a4d3f17c3$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $39aa643a4d3f17c3$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $39aa643a4d3f17c3$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $39aa643a4d3f17c3$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $39aa643a4d3f17c3$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $39aa643a4d3f17c3$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $39aa643a4d3f17c3$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $39aa643a4d3f17c3$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $39aa643a4d3f17c3$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $39aa643a4d3f17c3$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $39aa643a4d3f17c3$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $39aa643a4d3f17c3$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $39aa643a4d3f17c3$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $39aa643a4d3f17c3$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$39aa643a4d3f17c3$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $39aa643a4d3f17c3$var$clen(lf, $39aa643a4d3f17c3$var$flt) + $39aa643a4d3f17c3$var$clen(df, $39aa643a4d3f17c3$var$fdt) + eb;
    var dtlen = $39aa643a4d3f17c3$var$clen(lf, dlt) + $39aa643a4d3f17c3$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $39aa643a4d3f17c3$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $39aa643a4d3f17c3$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $39aa643a4d3f17c3$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $39aa643a4d3f17c3$var$hMap(dlt, mlb, 0), ll = dlt, dm = $39aa643a4d3f17c3$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $39aa643a4d3f17c3$var$hMap(lct, mlcb, 0);
        $39aa643a4d3f17c3$var$wbits(out, p, nlc - 257);
        $39aa643a4d3f17c3$var$wbits(out, p + 5, ndc - 1);
        $39aa643a4d3f17c3$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$39aa643a4d3f17c3$var$wbits(out, p + 3 * i, lct[$39aa643a4d3f17c3$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $39aa643a4d3f17c3$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $39aa643a4d3f17c3$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $39aa643a4d3f17c3$var$flm, ll = $39aa643a4d3f17c3$var$flt, dm = $39aa643a4d3f17c3$var$fdm, dl = $39aa643a4d3f17c3$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $39aa643a4d3f17c3$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $39aa643a4d3f17c3$var$wbits(out, p, sym >> 23 & 31), p += $39aa643a4d3f17c3$var$fleb[len];
            var dst = sym & 31;
            $39aa643a4d3f17c3$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $39aa643a4d3f17c3$var$wbits16(out, p, sym >> 5 & 8191), p += $39aa643a4d3f17c3$var$fdeb[dst];
        } else $39aa643a4d3f17c3$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $39aa643a4d3f17c3$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $39aa643a4d3f17c3$var$deo = /*#__PURE__*/ new $39aa643a4d3f17c3$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $39aa643a4d3f17c3$var$et = /*#__PURE__*/ new $39aa643a4d3f17c3$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $39aa643a4d3f17c3$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $39aa643a4d3f17c3$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $39aa643a4d3f17c3$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $39aa643a4d3f17c3$var$u16(32768), head = st.h || new $39aa643a4d3f17c3$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $39aa643a4d3f17c3$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $39aa643a4d3f17c3$var$u16(288), df = new $39aa643a4d3f17c3$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $39aa643a4d3f17c3$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $39aa643a4d3f17c3$var$revfl[l] << 18 | $39aa643a4d3f17c3$var$revfd[d];
                    var lin = $39aa643a4d3f17c3$var$revfl[l] & 31, din = $39aa643a4d3f17c3$var$revfd[d] & 31;
                    eb += $39aa643a4d3f17c3$var$fleb[lin] + $39aa643a4d3f17c3$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $39aa643a4d3f17c3$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $39aa643a4d3f17c3$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $39aa643a4d3f17c3$var$slc(o, 0, pre + $39aa643a4d3f17c3$var$shft(pos) + post);
};
// CRC32 table
var $39aa643a4d3f17c3$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $39aa643a4d3f17c3$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $39aa643a4d3f17c3$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $39aa643a4d3f17c3$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $39aa643a4d3f17c3$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $39aa643a4d3f17c3$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $39aa643a4d3f17c3$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $39aa643a4d3f17c3$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $39aa643a4d3f17c3$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $39aa643a4d3f17c3$var$ch = [];
// clone bufs
var $39aa643a4d3f17c3$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $39aa643a4d3f17c3$var$wrkr = function(fns, init, id, cb) {
    if (!$39aa643a4d3f17c3$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $39aa643a4d3f17c3$var$wcln(fns[i], fnStr, td_1);
        $39aa643a4d3f17c3$var$ch[id] = {
            c: $39aa643a4d3f17c3$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $39aa643a4d3f17c3$var$mrg({}, $39aa643a4d3f17c3$var$ch[id].e);
    return $39aa643a4d3f17c3$var$wk($39aa643a4d3f17c3$var$ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $39aa643a4d3f17c3$var$cbfs(td), cb);
};
// base async inflate fn
var $39aa643a4d3f17c3$var$bInflt = function() {
    return [
        $39aa643a4d3f17c3$var$u8,
        $39aa643a4d3f17c3$var$u16,
        $39aa643a4d3f17c3$var$i32,
        $39aa643a4d3f17c3$var$fleb,
        $39aa643a4d3f17c3$var$fdeb,
        $39aa643a4d3f17c3$var$clim,
        $39aa643a4d3f17c3$var$fl,
        $39aa643a4d3f17c3$var$fd,
        $39aa643a4d3f17c3$var$flrm,
        $39aa643a4d3f17c3$var$fdrm,
        $39aa643a4d3f17c3$var$rev,
        $39aa643a4d3f17c3$var$ec,
        $39aa643a4d3f17c3$var$hMap,
        $39aa643a4d3f17c3$var$max,
        $39aa643a4d3f17c3$var$bits,
        $39aa643a4d3f17c3$var$bits16,
        $39aa643a4d3f17c3$var$shft,
        $39aa643a4d3f17c3$var$slc,
        $39aa643a4d3f17c3$var$err,
        $39aa643a4d3f17c3$var$inflt,
        $39aa643a4d3f17c3$export$90366d8b308ba94a,
        $39aa643a4d3f17c3$var$pbf,
        $39aa643a4d3f17c3$var$gopt
    ];
};
var $39aa643a4d3f17c3$var$bDflt = function() {
    return [
        $39aa643a4d3f17c3$var$u8,
        $39aa643a4d3f17c3$var$u16,
        $39aa643a4d3f17c3$var$i32,
        $39aa643a4d3f17c3$var$fleb,
        $39aa643a4d3f17c3$var$fdeb,
        $39aa643a4d3f17c3$var$clim,
        $39aa643a4d3f17c3$var$revfl,
        $39aa643a4d3f17c3$var$revfd,
        $39aa643a4d3f17c3$var$flm,
        $39aa643a4d3f17c3$var$flt,
        $39aa643a4d3f17c3$var$fdm,
        $39aa643a4d3f17c3$var$fdt,
        $39aa643a4d3f17c3$var$rev,
        $39aa643a4d3f17c3$var$deo,
        $39aa643a4d3f17c3$var$et,
        $39aa643a4d3f17c3$var$hMap,
        $39aa643a4d3f17c3$var$wbits,
        $39aa643a4d3f17c3$var$wbits16,
        $39aa643a4d3f17c3$var$hTree,
        $39aa643a4d3f17c3$var$ln,
        $39aa643a4d3f17c3$var$lc,
        $39aa643a4d3f17c3$var$clen,
        $39aa643a4d3f17c3$var$wfblk,
        $39aa643a4d3f17c3$var$wblk,
        $39aa643a4d3f17c3$var$shft,
        $39aa643a4d3f17c3$var$slc,
        $39aa643a4d3f17c3$var$dflt,
        $39aa643a4d3f17c3$var$dopt,
        $39aa643a4d3f17c3$export$21533ff51b8a0b4a,
        $39aa643a4d3f17c3$var$pbf
    ];
};
// gzip extra
var $39aa643a4d3f17c3$var$gze = function() {
    return [
        $39aa643a4d3f17c3$var$gzh,
        $39aa643a4d3f17c3$var$gzhl,
        $39aa643a4d3f17c3$var$wbytes,
        $39aa643a4d3f17c3$var$crc,
        $39aa643a4d3f17c3$var$crct
    ];
};
// gunzip extra
var $39aa643a4d3f17c3$var$guze = function() {
    return [
        $39aa643a4d3f17c3$var$gzs,
        $39aa643a4d3f17c3$var$gzl
    ];
};
// zlib extra
var $39aa643a4d3f17c3$var$zle = function() {
    return [
        $39aa643a4d3f17c3$var$zlh,
        $39aa643a4d3f17c3$var$wbytes,
        $39aa643a4d3f17c3$var$adler
    ];
};
// unzlib extra
var $39aa643a4d3f17c3$var$zule = function() {
    return [
        $39aa643a4d3f17c3$var$zls
    ];
};
// post buf
var $39aa643a4d3f17c3$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $39aa643a4d3f17c3$var$gopt = function(o) {
    return o && {
        out: o.size && new $39aa643a4d3f17c3$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $39aa643a4d3f17c3$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $39aa643a4d3f17c3$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $39aa643a4d3f17c3$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data[0]) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush(ev.data[1]);
    };
};
// async stream attach
var $39aa643a4d3f17c3$var$astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = $39aa643a4d3f17c3$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) $39aa643a4d3f17c3$var$err(5);
        if (t) strm.ondata($39aa643a4d3f17c3$var$err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        // can fail for cross-realm Uint8Array, but ok - only a small performance penalty
        w.postMessage([
            d,
            t = f
        ], d.buffer instanceof ArrayBuffer ? [
            d.buffer
        ] : []);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function(sync) {
        w.postMessage([
            0,
            sync
        ]);
    };
};
// read 2 bytes
var $39aa643a4d3f17c3$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $39aa643a4d3f17c3$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
// read 8 bytes
var $39aa643a4d3f17c3$var$b8 = function(d, b) {
    return $39aa643a4d3f17c3$var$b4(d, b) + $39aa643a4d3f17c3$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $39aa643a4d3f17c3$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $39aa643a4d3f17c3$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $39aa643a4d3f17c3$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $39aa643a4d3f17c3$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $39aa643a4d3f17c3$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $39aa643a4d3f17c3$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $39aa643a4d3f17c3$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $39aa643a4d3f17c3$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $39aa643a4d3f17c3$var$adler();
        h.p(o.dictionary);
        $39aa643a4d3f17c3$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $39aa643a4d3f17c3$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $39aa643a4d3f17c3$var$err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) $39aa643a4d3f17c3$var$err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function $39aa643a4d3f17c3$var$StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $39aa643a4d3f17c3$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $39aa643a4d3f17c3$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($39aa643a4d3f17c3$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $39aa643a4d3f17c3$var$err(5);
        if (this.s.l) $39aa643a4d3f17c3$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $39aa643a4d3f17c3$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
        if (final) {
            // cleanup unneeded buffers/state to reduce memory usage
            this.s = this.o = {};
            this.b = $39aa643a4d3f17c3$var$et;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible. A separate DEFLATE stream may be concatenated
     *             with the current output after a sync flush.
     */ Deflate.prototype.flush = function(sync) {
        if (!this.ondata) $39aa643a4d3f17c3$var$err(5);
        if (this.s.l) $39aa643a4d3f17c3$var$err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
        // could technically skip writing the type-0 block for (this.s.r & 7) == 0,
        // but the deterministic trailer (00 00 FF FF) is useful in some situations
        if (sync) {
            var c = new $39aa643a4d3f17c3$var$u8(6);
            c[0] = this.s.r >> 3;
            // write empty, non-final type-0 block
            var ep = $39aa643a4d3f17c3$var$wfblk(c, this.s.r, $39aa643a4d3f17c3$var$et);
            this.s.r = 0;
            this.ondata(c.subarray(0, ep >> 3), false);
        }
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $39aa643a4d3f17c3$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $39aa643a4d3f17c3$var$astrmify([
            $39aa643a4d3f17c3$var$bDflt,
            function() {
                return [
                    $39aa643a4d3f17c3$var$astrm,
                    $39aa643a4d3f17c3$export$ae157b6234afe138
                ];
            }
        ], this, $39aa643a4d3f17c3$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $39aa643a4d3f17c3$export$ae157b6234afe138(ev.data);
            onmessage = $39aa643a4d3f17c3$var$astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function $39aa643a4d3f17c3$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $39aa643a4d3f17c3$var$err(7);
    return $39aa643a4d3f17c3$var$cbify(data, opts, [
        $39aa643a4d3f17c3$var$bDflt
    ], function(ev) {
        return $39aa643a4d3f17c3$var$pbf($39aa643a4d3f17c3$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $39aa643a4d3f17c3$export$21533ff51b8a0b4a(data, opts) {
    return $39aa643a4d3f17c3$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $39aa643a4d3f17c3$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $39aa643a4d3f17c3$var$u8(32768);
        this.p = new $39aa643a4d3f17c3$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $39aa643a4d3f17c3$var$err(5);
        if (this.d) $39aa643a4d3f17c3$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $39aa643a4d3f17c3$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $39aa643a4d3f17c3$var$inflt(this.p, this.s, this.o);
        this.ondata($39aa643a4d3f17c3$var$slc(dt, bts, this.s.b), this.d);
        this.o = $39aa643a4d3f17c3$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $39aa643a4d3f17c3$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $39aa643a4d3f17c3$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $39aa643a4d3f17c3$var$astrmify([
            $39aa643a4d3f17c3$var$bInflt,
            function() {
                return [
                    $39aa643a4d3f17c3$var$astrm,
                    $39aa643a4d3f17c3$export$d1de70a877d6e43c
                ];
            }
        ], this, $39aa643a4d3f17c3$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $39aa643a4d3f17c3$export$d1de70a877d6e43c(ev.data);
            onmessage = $39aa643a4d3f17c3$var$astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function $39aa643a4d3f17c3$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $39aa643a4d3f17c3$var$err(7);
    return $39aa643a4d3f17c3$var$cbify(data, opts, [
        $39aa643a4d3f17c3$var$bInflt
    ], function(ev) {
        return $39aa643a4d3f17c3$var$pbf($39aa643a4d3f17c3$export$90366d8b308ba94a(ev.data[0], $39aa643a4d3f17c3$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $39aa643a4d3f17c3$export$90366d8b308ba94a(data, opts) {
    return $39aa643a4d3f17c3$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $39aa643a4d3f17c3$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $39aa643a4d3f17c3$var$crc();
        this.l = 0;
        this.v = 1;
        $39aa643a4d3f17c3$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $39aa643a4d3f17c3$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $39aa643a4d3f17c3$var$dopt(c, this.o, this.v && $39aa643a4d3f17c3$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $39aa643a4d3f17c3$var$gzh(raw, this.o), this.v = 0;
        if (f) $39aa643a4d3f17c3$var$wbytes(raw, raw.length - 8, this.c.d()), $39aa643a4d3f17c3$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible.
     */ Gzip.prototype.flush = function(sync) {
        $39aa643a4d3f17c3$export$ae157b6234afe138.prototype.flush.call(this, sync);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $39aa643a4d3f17c3$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $39aa643a4d3f17c3$var$astrmify([
            $39aa643a4d3f17c3$var$bDflt,
            $39aa643a4d3f17c3$var$gze,
            function() {
                return [
                    $39aa643a4d3f17c3$var$astrm,
                    $39aa643a4d3f17c3$export$ae157b6234afe138,
                    $39aa643a4d3f17c3$export$8e4b66d280bf8342
                ];
            }
        ], this, $39aa643a4d3f17c3$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $39aa643a4d3f17c3$export$8e4b66d280bf8342(ev.data);
            onmessage = $39aa643a4d3f17c3$var$astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function $39aa643a4d3f17c3$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $39aa643a4d3f17c3$var$err(7);
    return $39aa643a4d3f17c3$var$cbify(data, opts, [
        $39aa643a4d3f17c3$var$bDflt,
        $39aa643a4d3f17c3$var$gze,
        function() {
            return [
                $39aa643a4d3f17c3$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $39aa643a4d3f17c3$var$pbf($39aa643a4d3f17c3$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $39aa643a4d3f17c3$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $39aa643a4d3f17c3$var$crc(), l = data.length;
    c.p(data);
    var d = $39aa643a4d3f17c3$var$dopt(data, opts, $39aa643a4d3f17c3$var$gzhl(opts), 8), s = d.length;
    return $39aa643a4d3f17c3$var$gzh(d, opts), $39aa643a4d3f17c3$var$wbytes(d, s - 8, c.d()), $39aa643a4d3f17c3$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $39aa643a4d3f17c3$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $39aa643a4d3f17c3$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $39aa643a4d3f17c3$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $39aa643a4d3f17c3$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $39aa643a4d3f17c3$export$d1de70a877d6e43c.prototype.c.call(this, 0);
        // process concatenated GZIP
        if (this.s.f && !this.s.l) {
            this.v = $39aa643a4d3f17c3$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $39aa643a4d3f17c3$var$u8(0);
            this.push(new $39aa643a4d3f17c3$var$u8(0), final);
        } else if (final) $39aa643a4d3f17c3$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $39aa643a4d3f17c3$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        $39aa643a4d3f17c3$var$astrmify([
            $39aa643a4d3f17c3$var$bInflt,
            $39aa643a4d3f17c3$var$guze,
            function() {
                return [
                    $39aa643a4d3f17c3$var$astrm,
                    $39aa643a4d3f17c3$export$d1de70a877d6e43c,
                    $39aa643a4d3f17c3$export$4cb607de6db70415
                ];
            }
        ], this, $39aa643a4d3f17c3$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $39aa643a4d3f17c3$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $39aa643a4d3f17c3$var$astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $39aa643a4d3f17c3$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $39aa643a4d3f17c3$var$err(7);
    return $39aa643a4d3f17c3$var$cbify(data, opts, [
        $39aa643a4d3f17c3$var$bInflt,
        $39aa643a4d3f17c3$var$guze,
        function() {
            return [
                $39aa643a4d3f17c3$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $39aa643a4d3f17c3$var$pbf($39aa643a4d3f17c3$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $39aa643a4d3f17c3$export$c80456f7aaba691c(data, opts) {
    var st = $39aa643a4d3f17c3$var$gzs(data);
    if (st + 8 > data.length) $39aa643a4d3f17c3$var$err(6, 'invalid gzip data');
    return $39aa643a4d3f17c3$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $39aa643a4d3f17c3$var$u8($39aa643a4d3f17c3$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $39aa643a4d3f17c3$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $39aa643a4d3f17c3$var$adler();
        this.v = 1;
        $39aa643a4d3f17c3$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $39aa643a4d3f17c3$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $39aa643a4d3f17c3$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $39aa643a4d3f17c3$var$zlh(raw, this.o), this.v = 0;
        if (f) $39aa643a4d3f17c3$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible.
     */ Zlib.prototype.flush = function(sync) {
        $39aa643a4d3f17c3$export$ae157b6234afe138.prototype.flush.call(this, sync);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $39aa643a4d3f17c3$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $39aa643a4d3f17c3$var$astrmify([
            $39aa643a4d3f17c3$var$bDflt,
            $39aa643a4d3f17c3$var$zle,
            function() {
                return [
                    $39aa643a4d3f17c3$var$astrm,
                    $39aa643a4d3f17c3$export$ae157b6234afe138,
                    $39aa643a4d3f17c3$export$4187ccf2467013b9
                ];
            }
        ], this, $39aa643a4d3f17c3$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $39aa643a4d3f17c3$export$4187ccf2467013b9(ev.data);
            onmessage = $39aa643a4d3f17c3$var$astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function $39aa643a4d3f17c3$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $39aa643a4d3f17c3$var$err(7);
    return $39aa643a4d3f17c3$var$cbify(data, opts, [
        $39aa643a4d3f17c3$var$bDflt,
        $39aa643a4d3f17c3$var$zle,
        function() {
            return [
                $39aa643a4d3f17c3$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $39aa643a4d3f17c3$var$pbf($39aa643a4d3f17c3$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $39aa643a4d3f17c3$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $39aa643a4d3f17c3$var$adler();
    a.p(data);
    var d = $39aa643a4d3f17c3$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $39aa643a4d3f17c3$var$zlh(d, opts), $39aa643a4d3f17c3$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $39aa643a4d3f17c3$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $39aa643a4d3f17c3$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $39aa643a4d3f17c3$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($39aa643a4d3f17c3$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $39aa643a4d3f17c3$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $39aa643a4d3f17c3$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $39aa643a4d3f17c3$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $39aa643a4d3f17c3$var$astrmify([
            $39aa643a4d3f17c3$var$bInflt,
            $39aa643a4d3f17c3$var$zule,
            function() {
                return [
                    $39aa643a4d3f17c3$var$astrm,
                    $39aa643a4d3f17c3$export$d1de70a877d6e43c,
                    $39aa643a4d3f17c3$export$af2424f875ff1b17
                ];
            }
        ], this, $39aa643a4d3f17c3$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $39aa643a4d3f17c3$export$af2424f875ff1b17(ev.data);
            onmessage = $39aa643a4d3f17c3$var$astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function $39aa643a4d3f17c3$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $39aa643a4d3f17c3$var$err(7);
    return $39aa643a4d3f17c3$var$cbify(data, opts, [
        $39aa643a4d3f17c3$var$bInflt,
        $39aa643a4d3f17c3$var$zule,
        function() {
            return [
                $39aa643a4d3f17c3$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $39aa643a4d3f17c3$var$pbf($39aa643a4d3f17c3$export$9ec8134f0f1b9fc6(ev.data[0], $39aa643a4d3f17c3$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $39aa643a4d3f17c3$export$9ec8134f0f1b9fc6(data, opts) {
    return $39aa643a4d3f17c3$var$inflt(data.subarray($39aa643a4d3f17c3$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $39aa643a4d3f17c3$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = $39aa643a4d3f17c3$var$StrmOpt.call(this, opts, cb) || {};
        this.G = $39aa643a4d3f17c3$export$4cb607de6db70415;
        this.I = $39aa643a4d3f17c3$export$d1de70a877d6e43c;
        this.Z = $39aa643a4d3f17c3$export$af2424f875ff1b17;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $39aa643a4d3f17c3$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $39aa643a4d3f17c3$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $39aa643a4d3f17c3$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        $39aa643a4d3f17c3$export$578fe199ef655b76.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = $39aa643a4d3f17c3$export$d5adcdd968132151;
        this.I = $39aa643a4d3f17c3$export$fff8358d6dbaa9cc;
        this.Z = $39aa643a4d3f17c3$export$cf6668790220dcad;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        $39aa643a4d3f17c3$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $39aa643a4d3f17c3$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $39aa643a4d3f17c3$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $39aa643a4d3f17c3$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $39aa643a4d3f17c3$export$cae1ce83fe4a1782(data, opts, cb) : $39aa643a4d3f17c3$export$ca7cbb494e731274(data, opts, cb);
}
function $39aa643a4d3f17c3$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $39aa643a4d3f17c3$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $39aa643a4d3f17c3$export$90366d8b308ba94a(data, opts) : $39aa643a4d3f17c3$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $39aa643a4d3f17c3$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $39aa643a4d3f17c3$var$mrg(o, val[1]), val = val[0];
        if (ArrayBuffer.isView(val)) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $39aa643a4d3f17c3$var$u8(0),
                op
            ];
            $39aa643a4d3f17c3$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $39aa643a4d3f17c3$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $39aa643a4d3f17c3$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $39aa643a4d3f17c3$var$tds = 0;
try {
    $39aa643a4d3f17c3$var$td.decode($39aa643a4d3f17c3$var$et, {
        stream: true
    });
    $39aa643a4d3f17c3$var$tds = 1;
} catch (e) {}
// decode UTF8
var $39aa643a4d3f17c3$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $39aa643a4d3f17c3$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $39aa643a4d3f17c3$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($39aa643a4d3f17c3$var$tds) this.t = new TextDecoder();
        else this.p = $39aa643a4d3f17c3$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $39aa643a4d3f17c3$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $39aa643a4d3f17c3$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $39aa643a4d3f17c3$var$err(4);
        var dat = new $39aa643a4d3f17c3$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $39aa643a4d3f17c3$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $39aa643a4d3f17c3$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $39aa643a4d3f17c3$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $39aa643a4d3f17c3$var$err(5);
        if (this.d) $39aa643a4d3f17c3$var$err(4);
        this.ondata($39aa643a4d3f17c3$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $39aa643a4d3f17c3$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $39aa643a4d3f17c3$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($39aa643a4d3f17c3$var$te) return $39aa643a4d3f17c3$var$te.encode(str);
    var l = str.length;
    var ar = new $39aa643a4d3f17c3$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $39aa643a4d3f17c3$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $39aa643a4d3f17c3$var$slc(ar, 0, ai);
}
function $39aa643a4d3f17c3$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($39aa643a4d3f17c3$var$td) return $39aa643a4d3f17c3$var$td.decode(dat);
    else {
        var _a = $39aa643a4d3f17c3$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $39aa643a4d3f17c3$var$err(8);
        return s;
    }
}
// deflate bit flag
var $39aa643a4d3f17c3$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $39aa643a4d3f17c3$var$slzh = function(d, b) {
    return b + 30 + $39aa643a4d3f17c3$var$b2(d, b + 26) + $39aa643a4d3f17c3$var$b2(d, b + 28);
};
// read zip header
var $39aa643a4d3f17c3$var$zh = function(d, b, z) {
    var fnl = $39aa643a4d3f17c3$var$b2(d, b + 28), efl = $39aa643a4d3f17c3$var$b2(d, b + 30), fn = $39aa643a4d3f17c3$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($39aa643a4d3f17c3$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl;
    var _a = $39aa643a4d3f17c3$var$z64hs(d, es, efl, z, $39aa643a4d3f17c3$var$b4(d, b + 20), $39aa643a4d3f17c3$var$b4(d, b + 24), $39aa643a4d3f17c3$var$b4(d, b + 42)), sc = _a[0], su = _a[1], off = _a[2];
    return [
        $39aa643a4d3f17c3$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + efl + $39aa643a4d3f17c3$var$b2(d, b + 32),
        off
    ];
};
// read zip64 header sizes
var $39aa643a4d3f17c3$var$z64hs = function(d, b, l, z, sc, su, off) {
    var nsc = sc == 4294967295, nsu = su == 4294967295, noff = off == 4294967295, e = b + l;
    var nf = nsc + nsu + noff;
    if (z && nf) {
        for(; b + 4 < e; b += 4 + $39aa643a4d3f17c3$var$b2(d, b + 2)){
            if ($39aa643a4d3f17c3$var$b2(d, b) == 1) return [
                nsc ? $39aa643a4d3f17c3$var$b8(d, b + 4 + 8 * nsu) : sc,
                nsu ? $39aa643a4d3f17c3$var$b8(d, b + 4) : su,
                noff ? $39aa643a4d3f17c3$var$b8(d, b + 4 + 8 * (nsu + nsc)) : off,
                1
            ];
        }
        // z == 2 for unknown whether or not zip64
        if (z < 2) $39aa643a4d3f17c3$var$err(13);
    }
    return [
        sc,
        su,
        off,
        0
    ];
};
// extra field length
var $39aa643a4d3f17c3$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $39aa643a4d3f17c3$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $39aa643a4d3f17c3$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $39aa643a4d3f17c3$var$exfl(ex);
    $39aa643a4d3f17c3$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $39aa643a4d3f17c3$var$err(10);
    $39aa643a4d3f17c3$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $39aa643a4d3f17c3$var$wbytes(d, b, f.crc);
        $39aa643a4d3f17c3$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $39aa643a4d3f17c3$var$wbytes(d, b + 8, f.size);
    }
    $39aa643a4d3f17c3$var$wbytes(d, b + 12, fl);
    $39aa643a4d3f17c3$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $39aa643a4d3f17c3$var$wbytes(d, b, col);
        $39aa643a4d3f17c3$var$wbytes(d, b + 6, f.attrs);
        $39aa643a4d3f17c3$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $39aa643a4d3f17c3$var$wbytes(d, b, +k);
        $39aa643a4d3f17c3$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $39aa643a4d3f17c3$var$wzf = function(o, b, c, d, e) {
    $39aa643a4d3f17c3$var$wbytes(o, b, 0x6054B50); // skip disk
    $39aa643a4d3f17c3$var$wbytes(o, b + 8, c);
    $39aa643a4d3f17c3$var$wbytes(o, b + 10, c);
    $39aa643a4d3f17c3$var$wbytes(o, b + 12, d);
    $39aa643a4d3f17c3$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $39aa643a4d3f17c3$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $39aa643a4d3f17c3$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $39aa643a4d3f17c3$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        // we shouldn't really do this cast, but properly handling ArrayBufferLike
        // makes the API unergonomic with Buffer
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $39aa643a4d3f17c3$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $39aa643a4d3f17c3$export$2b25194e1767ea06.call(this, filename);
        this.d = new $39aa643a4d3f17c3$export$ae157b6234afe138(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $39aa643a4d3f17c3$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $39aa643a4d3f17c3$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $39aa643a4d3f17c3$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $39aa643a4d3f17c3$export$2b25194e1767ea06.call(this, filename);
        this.d = new $39aa643a4d3f17c3$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $39aa643a4d3f17c3$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $39aa643a4d3f17c3$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $39aa643a4d3f17c3$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) $39aa643a4d3f17c3$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($39aa643a4d3f17c3$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $39aa643a4d3f17c3$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $39aa643a4d3f17c3$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $39aa643a4d3f17c3$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($39aa643a4d3f17c3$var$err(11, 0, 1), null, false);
            var header = new $39aa643a4d3f17c3$var$u8(hl_1);
            $39aa643a4d3f17c3$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $39aa643a4d3f17c3$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $39aa643a4d3f17c3$var$u8(16);
                        $39aa643a4d3f17c3$var$wbytes(dd, 0, 0x8074B50);
                        $39aa643a4d3f17c3$var$wbytes(dd, 4, file.crc);
                        $39aa643a4d3f17c3$var$wbytes(dd, 8, cl_1);
                        $39aa643a4d3f17c3$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata($39aa643a4d3f17c3$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $39aa643a4d3f17c3$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $39aa643a4d3f17c3$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $39aa643a4d3f17c3$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $39aa643a4d3f17c3$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $39aa643a4d3f17c3$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $39aa643a4d3f17c3$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $39aa643a4d3f17c3$var$err(7);
    var r = {};
    $39aa643a4d3f17c3$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $39aa643a4d3f17c3$var$mt(function() {
            cb(a, b);
        });
    };
    $39aa643a4d3f17c3$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $39aa643a4d3f17c3$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $39aa643a4d3f17c3$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $39aa643a4d3f17c3$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $39aa643a4d3f17c3$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $39aa643a4d3f17c3$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $39aa643a4d3f17c3$var$crc(), size = file.length;
        c.p(file);
        var f = $39aa643a4d3f17c3$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $39aa643a4d3f17c3$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $39aa643a4d3f17c3$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $39aa643a4d3f17c3$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($39aa643a4d3f17c3$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $39aa643a4d3f17c3$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($39aa643a4d3f17c3$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $39aa643a4d3f17c3$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $39aa643a4d3f17c3$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $39aa643a4d3f17c3$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $39aa643a4d3f17c3$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $39aa643a4d3f17c3$var$exfl(p.extra);
        if (s > 65535) $39aa643a4d3f17c3$var$err(11);
        var d = compression ? $39aa643a4d3f17c3$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $39aa643a4d3f17c3$var$crc();
        c.p(file);
        files.push($39aa643a4d3f17c3$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $39aa643a4d3f17c3$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $39aa643a4d3f17c3$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $39aa643a4d3f17c3$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $39aa643a4d3f17c3$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $39aa643a4d3f17c3$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $39aa643a4d3f17c3$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(chunk, final) {
        // same as ZipPassThrough: cast to retain Buffer ergonomics
        this.ondata(null, chunk, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $39aa643a4d3f17c3$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new $39aa643a4d3f17c3$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(chunk, final) {
        try {
            this.i.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $39aa643a4d3f17c3$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new $39aa643a4d3f17c3$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new $39aa643a4d3f17c3$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(chunk, final) {
        if (this.i.terminate) chunk = $39aa643a4d3f17c3$var$slc(chunk, 0);
        this.i.push(chunk, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $39aa643a4d3f17c3$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $39aa643a4d3f17c3$export$93f81d5bbbb7c6bf
        };
        this.p = $39aa643a4d3f17c3$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) $39aa643a4d3f17c3$var$err(5);
        if (!this.p) $39aa643a4d3f17c3$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $39aa643a4d3f17c3$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var sig = $39aa643a4d3f17c3$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $39aa643a4d3f17c3$var$b2(buf, i + 6), cmp_1 = $39aa643a4d3f17c3$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $39aa643a4d3f17c3$var$b2(buf, i + 26), es = $39aa643a4d3f17c3$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var lsc = $39aa643a4d3f17c3$var$b4(buf, i + 18), lsu = $39aa643a4d3f17c3$var$b4(buf, i + 22);
                        var fn_1 = $39aa643a4d3f17c3$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        var _a = $39aa643a4d3f17c3$var$z64hs(buf, i, es, 2, lsc, lsu, 0), sc_1 = _a[0], su_1 = _a[1], z64 = _a[3];
                        if (dd) sc_1 = -1 - z64;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $39aa643a4d3f17c3$var$err(5);
                                if (!sc_1) file_1.ondata(null, $39aa643a4d3f17c3$var$et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata($39aa643a4d3f17c3$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push($39aa643a4d3f17c3$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $39aa643a4d3f17c3$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($39aa643a4d3f17c3$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $39aa643a4d3f17c3$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $39aa643a4d3f17c3$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $39aa643a4d3f17c3$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $39aa643a4d3f17c3$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $39aa643a4d3f17c3$var$mt(function() {
            cb(a, b);
        });
    };
    $39aa643a4d3f17c3$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $39aa643a4d3f17c3$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($39aa643a4d3f17c3$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $39aa643a4d3f17c3$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $39aa643a4d3f17c3$var$b4(data, e + 16);
        var z = $39aa643a4d3f17c3$var$b4(data, e - 20) == 0x7064B50;
        if (z) {
            var ze = $39aa643a4d3f17c3$var$b4(data, e - 12);
            z = $39aa643a4d3f17c3$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $39aa643a4d3f17c3$var$b4(data, ze + 32);
                o = $39aa643a4d3f17c3$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $39aa643a4d3f17c3$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $39aa643a4d3f17c3$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $39aa643a4d3f17c3$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, $39aa643a4d3f17c3$export$90366d8b308ba94a(infl, {
                            out: new $39aa643a4d3f17c3$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($39aa643a4d3f17c3$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($39aa643a4d3f17c3$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $39aa643a4d3f17c3$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $39aa643a4d3f17c3$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $39aa643a4d3f17c3$var$err(13);
    var c = $39aa643a4d3f17c3$var$b2(data, e + 8);
    if (!c) return {};
    var o = $39aa643a4d3f17c3$var$b4(data, e + 16);
    var z = $39aa643a4d3f17c3$var$b4(data, e - 20) == 0x7064B50;
    if (z) {
        var ze = $39aa643a4d3f17c3$var$b4(data, e - 12);
        z = $39aa643a4d3f17c3$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $39aa643a4d3f17c3$var$b4(data, ze + 32);
            o = $39aa643a4d3f17c3$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $39aa643a4d3f17c3$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $39aa643a4d3f17c3$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $39aa643a4d3f17c3$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $39aa643a4d3f17c3$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $39aa643a4d3f17c3$var$u8(su)
            });
            else $39aa643a4d3f17c3$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}


var $66525ca70e76a405$exports = {};
var $d694d9566f7aefcd$exports = {};
function $d694d9566f7aefcd$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$d694d9566f7aefcd$exports = $d694d9566f7aefcd$var$_arrayWithHoles, $d694d9566f7aefcd$exports.__esModule = true, $d694d9566f7aefcd$exports["default"] = $d694d9566f7aefcd$exports;


var $05c13a2e14f23d66$exports = {};
function $05c13a2e14f23d66$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$05c13a2e14f23d66$exports = $05c13a2e14f23d66$var$_iterableToArrayLimit, $05c13a2e14f23d66$exports.__esModule = true, $05c13a2e14f23d66$exports["default"] = $05c13a2e14f23d66$exports;


var $c3466d566a9c2cd6$exports = {};
var $53fb01eebbeac7d6$exports = {};
function $53fb01eebbeac7d6$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$53fb01eebbeac7d6$exports = $53fb01eebbeac7d6$var$_arrayLikeToArray, $53fb01eebbeac7d6$exports.__esModule = true, $53fb01eebbeac7d6$exports["default"] = $53fb01eebbeac7d6$exports;


function $c3466d566a9c2cd6$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $53fb01eebbeac7d6$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $53fb01eebbeac7d6$exports(r, a) : void 0;
    }
}
$c3466d566a9c2cd6$exports = $c3466d566a9c2cd6$var$_unsupportedIterableToArray, $c3466d566a9c2cd6$exports.__esModule = true, $c3466d566a9c2cd6$exports["default"] = $c3466d566a9c2cd6$exports;


var $99624d3240283c12$exports = {};
function $99624d3240283c12$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$99624d3240283c12$exports = $99624d3240283c12$var$_nonIterableRest, $99624d3240283c12$exports.__esModule = true, $99624d3240283c12$exports["default"] = $99624d3240283c12$exports;


function $66525ca70e76a405$var$_slicedToArray(r, e) {
    return $d694d9566f7aefcd$exports(r) || $05c13a2e14f23d66$exports(r, e) || $c3466d566a9c2cd6$exports(r, e) || $99624d3240283c12$exports();
}
$66525ca70e76a405$exports = $66525ca70e76a405$var$_slicedToArray, $66525ca70e76a405$exports.__esModule = true, $66525ca70e76a405$exports["default"] = $66525ca70e76a405$exports;


function $56db9f3ae9e82722$export$2f872c0f2117be69(bytes, encoding = 'utf8') {
    const decoder = new TextDecoder(encoding);
    return decoder.decode(bytes);
}
const $56db9f3ae9e82722$var$encoder = new TextEncoder();
function $56db9f3ae9e82722$export$c564cdbbe6da493(str) {
    return $56db9f3ae9e82722$var$encoder.encode(str);
}


const $e51a952610d7661c$var$defaultByteLength = 8192;
const $e51a952610d7661c$var$hostBigEndian = (()=>{
    const array = new Uint8Array(4);
    const view = new Uint32Array(array.buffer);
    return !((view[0] = 1) & array[0]);
})();
const $e51a952610d7661c$var$typedArrays = {
    int8: globalThis.Int8Array,
    uint8: globalThis.Uint8Array,
    int16: globalThis.Int16Array,
    uint16: globalThis.Uint16Array,
    int32: globalThis.Int32Array,
    uint32: globalThis.Uint32Array,
    uint64: globalThis.BigUint64Array,
    int64: globalThis.BigInt64Array,
    float32: globalThis.Float32Array,
    float64: globalThis.Float64Array
};
class $e51a952610d7661c$export$6b4c32f3d5b8738a {
    /**
     * Reference to the internal ArrayBuffer object.
     */ buffer;
    /**
     * Byte length of the internal ArrayBuffer.
     */ byteLength;
    /**
     * Byte offset of the internal ArrayBuffer.
     */ byteOffset;
    /**
     * Byte length of the internal ArrayBuffer.
     */ length;
    /**
     * The current offset of the buffer's pointer.
     */ offset;
    lastWrittenByte;
    littleEndian;
    _data;
    _mark;
    _marks;
    /**
     * Create a new IOBuffer.
     * @param data - The data to construct the IOBuffer with.
     * If data is a number, it will be the new buffer's length<br>
     * If data is `undefined`, the buffer will be initialized with a default length of 8Kb<br>
     * If data is an ArrayBuffer, SharedArrayBuffer, an ArrayBufferView (Typed Array), an IOBuffer instance,
     * or a Node.js Buffer, a view will be created over the underlying ArrayBuffer.
     * @param options - An object for the options.
     * @returns A new IOBuffer instance.
     */ constructor(data = $e51a952610d7661c$var$defaultByteLength, options = {}){
        let dataIsGiven = false;
        if (typeof data === 'number') data = new ArrayBuffer(data);
        else {
            dataIsGiven = true;
            this.lastWrittenByte = data.byteLength;
        }
        const offset = options.offset ? options.offset >>> 0 : 0;
        const byteLength = data.byteLength - offset;
        let dvOffset = offset;
        if (ArrayBuffer.isView(data) || data instanceof $e51a952610d7661c$export$6b4c32f3d5b8738a) {
            if (data.byteLength !== data.buffer.byteLength) dvOffset = data.byteOffset + offset;
            data = data.buffer;
        }
        if (dataIsGiven) this.lastWrittenByte = byteLength;
        else this.lastWrittenByte = 0;
        this.buffer = data;
        this.length = byteLength;
        this.byteLength = byteLength;
        this.byteOffset = dvOffset;
        this.offset = 0;
        this.littleEndian = true;
        this._data = new DataView(this.buffer, dvOffset, byteLength);
        this._mark = 0;
        this._marks = [];
    }
    /**
     * Checks if the memory allocated to the buffer is sufficient to store more
     * bytes after the offset.
     * @param byteLength - The needed memory in bytes.
     * @returns `true` if there is sufficient space and `false` otherwise.
     */ available(byteLength = 1) {
        return this.offset + byteLength <= this.length;
    }
    /**
     * Check if little-endian mode is used for reading and writing multi-byte
     * values.
     * @returns `true` if little-endian mode is used, `false` otherwise.
     */ isLittleEndian() {
        return this.littleEndian;
    }
    /**
     * Set little-endian mode for reading and writing multi-byte values.
     * @returns This.
     */ setLittleEndian() {
        this.littleEndian = true;
        return this;
    }
    /**
     * Check if big-endian mode is used for reading and writing multi-byte values.
     * @returns `true` if big-endian mode is used, `false` otherwise.
     */ isBigEndian() {
        return !this.littleEndian;
    }
    /**
     * Switches to big-endian mode for reading and writing multi-byte values.
     * @returns This.
     */ setBigEndian() {
        this.littleEndian = false;
        return this;
    }
    /**
     * Move the pointer n bytes forward.
     * @param n - Number of bytes to skip.
     * @returns This.
     */ skip(n = 1) {
        this.offset += n;
        return this;
    }
    /**
     * Move the pointer n bytes backward.
     * @param n - Number of bytes to move back.
     * @returns This.
     */ back(n = 1) {
        this.offset -= n;
        return this;
    }
    /**
     * Move the pointer to the given offset.
     * @param offset - The offset to move to.
     * @returns This.
     */ seek(offset) {
        this.offset = offset;
        return this;
    }
    /**
     * Store the current pointer offset.
     * @see {@link IOBuffer#reset}
     * @returns This.
     */ mark() {
        this._mark = this.offset;
        return this;
    }
    /**
     * Move the pointer back to the last pointer offset set by mark.
     * @see {@link IOBuffer#mark}
     * @returns This.
     */ reset() {
        this.offset = this._mark;
        return this;
    }
    /**
     * Push the current pointer offset to the mark stack.
     * @see {@link IOBuffer#popMark}
     * @returns This.
     */ pushMark() {
        this._marks.push(this.offset);
        return this;
    }
    /**
     * Pop the last pointer offset from the mark stack, and set the current
     * pointer offset to the popped value.
     * @see {@link IOBuffer#pushMark}
     * @returns This.
     */ popMark() {
        const offset = this._marks.pop();
        if (offset === undefined) throw new Error('Mark stack empty');
        this.seek(offset);
        return this;
    }
    /**
     * Move the pointer offset back to 0.
     * @returns This.
     */ rewind() {
        this.offset = 0;
        return this;
    }
    /**
     * Make sure the buffer has sufficient memory to write a given byteLength at
     * the current pointer offset.
     * If the buffer's memory is insufficient, this method will create a new
     * buffer (a copy) with a length that is twice (byteLength + current offset).
     * @param byteLength - The needed memory in bytes.
     * @returns This.
     */ ensureAvailable(byteLength = 1) {
        if (!this.available(byteLength)) {
            const lengthNeeded = this.offset + byteLength;
            const newLength = lengthNeeded * 2;
            const newArray = new Uint8Array(newLength);
            newArray.set(new Uint8Array(this.buffer));
            this.buffer = newArray.buffer;
            this.length = newLength;
            this.byteLength = newLength;
            this._data = new DataView(this.buffer);
        }
        return this;
    }
    /**
     * Read a byte and return false if the byte's value is 0, or true otherwise.
     * Moves pointer forward by one byte.
     * @returns The read boolean.
     */ readBoolean() {
        return this.readUint8() !== 0;
    }
    /**
     * Read a signed 8-bit integer and move pointer forward by 1 byte.
     * @returns The read byte.
     */ readInt8() {
        return this._data.getInt8(this.offset++);
    }
    /**
     * Read an unsigned 8-bit integer and move pointer forward by 1 byte.
     * @returns The read byte.
     */ readUint8() {
        return this._data.getUint8(this.offset++);
    }
    /**
     * Alias for {@link IOBuffer#readUint8}.
     * @returns The read byte.
     */ readByte() {
        return this.readUint8();
    }
    /**
     * Read `n` bytes and move pointer forward by `n` bytes.
     * @param n - Number of bytes to read.
     * @returns The read bytes.
     */ readBytes(n = 1) {
        return this.readArray(n, 'uint8');
    }
    /**
     * Creates an array of corresponding to the type `type` and size `size`.
     * For example type `uint8` will create a `Uint8Array`.
     * @param size - size of the resulting array
     * @param type - number type of elements to read
     * @returns The read array.
     */ readArray(size, type) {
        const bytes = $e51a952610d7661c$var$typedArrays[type].BYTES_PER_ELEMENT * size;
        const offset = this.byteOffset + this.offset;
        const slice = this.buffer.slice(offset, offset + bytes);
        if (this.littleEndian === $e51a952610d7661c$var$hostBigEndian && type !== 'uint8' && type !== 'int8') {
            const slice = new Uint8Array(this.buffer.slice(offset, offset + bytes));
            slice.reverse();
            const returnArray = new $e51a952610d7661c$var$typedArrays[type](slice.buffer);
            this.offset += bytes;
            returnArray.reverse();
            return returnArray;
        }
        const returnArray = new $e51a952610d7661c$var$typedArrays[type](slice);
        this.offset += bytes;
        return returnArray;
    }
    /**
     * Read a 16-bit signed integer and move pointer forward by 2 bytes.
     * @returns The read value.
     */ readInt16() {
        const value = this._data.getInt16(this.offset, this.littleEndian);
        this.offset += 2;
        return value;
    }
    /**
     * Read a 16-bit unsigned integer and move pointer forward by 2 bytes.
     * @returns The read value.
     */ readUint16() {
        const value = this._data.getUint16(this.offset, this.littleEndian);
        this.offset += 2;
        return value;
    }
    /**
     * Read a 32-bit signed integer and move pointer forward by 4 bytes.
     * @returns The read value.
     */ readInt32() {
        const value = this._data.getInt32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    /**
     * Read a 32-bit unsigned integer and move pointer forward by 4 bytes.
     * @returns The read value.
     */ readUint32() {
        const value = this._data.getUint32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    /**
     * Read a 32-bit floating number and move pointer forward by 4 bytes.
     * @returns The read value.
     */ readFloat32() {
        const value = this._data.getFloat32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    /**
     * Read a 64-bit floating number and move pointer forward by 8 bytes.
     * @returns The read value.
     */ readFloat64() {
        const value = this._data.getFloat64(this.offset, this.littleEndian);
        this.offset += 8;
        return value;
    }
    /**
     * Read a 64-bit signed integer number and move pointer forward by 8 bytes.
     * @returns The read value.
     */ readBigInt64() {
        const value = this._data.getBigInt64(this.offset, this.littleEndian);
        this.offset += 8;
        return value;
    }
    /**
     * Read a 64-bit unsigned integer number and move pointer forward by 8 bytes.
     * @returns The read value.
     */ readBigUint64() {
        const value = this._data.getBigUint64(this.offset, this.littleEndian);
        this.offset += 8;
        return value;
    }
    /**
     * Read a 1-byte ASCII character and move pointer forward by 1 byte.
     * @returns The read character.
     */ readChar() {
        // eslint-disable-next-line unicorn/prefer-code-point
        return String.fromCharCode(this.readInt8());
    }
    /**
     * Read `n` 1-byte ASCII characters and move pointer forward by `n` bytes.
     * @param n - Number of characters to read.
     * @returns The read characters.
     */ readChars(n = 1) {
        let result = '';
        for(let i = 0; i < n; i++)result += this.readChar();
        return result;
    }
    /**
     * Read the next `n` bytes, return a UTF-8 decoded string and move pointer
     * forward by `n` bytes.
     * @param n - Number of bytes to read.
     * @returns The decoded string.
     */ readUtf8(n = 1) {
        return (0, $56db9f3ae9e82722$export$2f872c0f2117be69)(this.readBytes(n));
    }
    /**
     * Read the next `n` bytes, return a string decoded with `encoding` and move pointer
     * forward by `n` bytes.
     * If no encoding is passed, the function is equivalent to @see {@link IOBuffer#readUtf8}
     * @param n - Number of bytes to read.
     * @param encoding - The encoding to use. Default is 'utf8'.
     * @returns The decoded string.
     */ decodeText(n = 1, encoding = 'utf8') {
        return (0, $56db9f3ae9e82722$export$2f872c0f2117be69)(this.readBytes(n), encoding);
    }
    /**
     * Write 0xff if the passed value is truthy, 0x00 otherwise and move pointer
     * forward by 1 byte.
     * @param value - The value to write.
     * @returns This.
     */ writeBoolean(value) {
        this.writeUint8(value ? 0xff : 0x00);
        return this;
    }
    /**
     * Write `value` as an 8-bit signed integer and move pointer forward by 1 byte.
     * @param value - The value to write.
     * @returns This.
     */ writeInt8(value) {
        this.ensureAvailable(1);
        this._data.setInt8(this.offset++, value);
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as an 8-bit unsigned integer and move pointer forward by 1
     * byte.
     * @param value - The value to write.
     * @returns This.
     */ writeUint8(value) {
        this.ensureAvailable(1);
        this._data.setUint8(this.offset++, value);
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * An alias for {@link IOBuffer#writeUint8}.
     * @param value - The value to write.
     * @returns This.
     */ writeByte(value) {
        return this.writeUint8(value);
    }
    /**
     * Write all elements of `bytes` as uint8 values and move pointer forward by
     * `bytes.length` bytes.
     * @param bytes - The array of bytes to write.
     * @returns This.
     */ writeBytes(bytes) {
        this.ensureAvailable(bytes.length);
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < bytes.length; i++)this._data.setUint8(this.offset++, bytes[i]);
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 16-bit signed integer and move pointer forward by 2
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeInt16(value) {
        this.ensureAvailable(2);
        this._data.setInt16(this.offset, value, this.littleEndian);
        this.offset += 2;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 16-bit unsigned integer and move pointer forward by 2
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeUint16(value) {
        this.ensureAvailable(2);
        this._data.setUint16(this.offset, value, this.littleEndian);
        this.offset += 2;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 32-bit signed integer and move pointer forward by 4
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeInt32(value) {
        this.ensureAvailable(4);
        this._data.setInt32(this.offset, value, this.littleEndian);
        this.offset += 4;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 32-bit unsigned integer and move pointer forward by 4
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeUint32(value) {
        this.ensureAvailable(4);
        this._data.setUint32(this.offset, value, this.littleEndian);
        this.offset += 4;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 32-bit floating number and move pointer forward by 4
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeFloat32(value) {
        this.ensureAvailable(4);
        this._data.setFloat32(this.offset, value, this.littleEndian);
        this.offset += 4;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 64-bit floating number and move pointer forward by 8
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeFloat64(value) {
        this.ensureAvailable(8);
        this._data.setFloat64(this.offset, value, this.littleEndian);
        this.offset += 8;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 64-bit signed bigint and move pointer forward by 8
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeBigInt64(value) {
        this.ensureAvailable(8);
        this._data.setBigInt64(this.offset, value, this.littleEndian);
        this.offset += 8;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 64-bit unsigned bigint and move pointer forward by 8
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeBigUint64(value) {
        this.ensureAvailable(8);
        this._data.setBigUint64(this.offset, value, this.littleEndian);
        this.offset += 8;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write the charCode of `str`'s first character as an 8-bit unsigned integer
     * and move pointer forward by 1 byte.
     * @param str - The character to write.
     * @returns This.
     */ writeChar(str) {
        // eslint-disable-next-line unicorn/prefer-code-point
        return this.writeUint8(str.charCodeAt(0));
    }
    /**
     * Write the charCodes of all `str`'s characters as 8-bit unsigned integers
     * and move pointer forward by `str.length` bytes.
     * @param str - The characters to write.
     * @returns This.
     */ writeChars(str) {
        for(let i = 0; i < str.length; i++)// eslint-disable-next-line unicorn/prefer-code-point
        this.writeUint8(str.charCodeAt(i));
        return this;
    }
    /**
     * UTF-8 encode and write `str` to the current pointer offset and move pointer
     * forward according to the encoded length.
     * @param str - The string to write.
     * @returns This.
     */ writeUtf8(str) {
        return this.writeBytes((0, $56db9f3ae9e82722$export$c564cdbbe6da493)(str));
    }
    /**
     * Export a Uint8Array view of the internal buffer.
     * The view starts at the byte offset and its length
     * is calculated to stop at the last written byte or the original length.
     * @returns A new Uint8Array view.
     */ toArray() {
        return new Uint8Array(this.buffer, this.byteOffset, this.lastWrittenByte);
    }
    /**
     *  Get the total number of bytes written so far, regardless of the current offset.
     * @returns - Total number of bytes.
     */ getWrittenByteLength() {
        return this.lastWrittenByte - this.byteOffset;
    }
    /**
     * Update the last written byte offset
     * @private
     */ _updateLastWrittenByte() {
        if (this.offset > this.lastWrittenByte) this.lastWrittenByte = this.offset;
    }
}


/*! pako 2.2.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */ // (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ /* Public constants ==========================================================*/ /* ===========================================================================*/ //const Z_FILTERED          = 1;
//const Z_HUFFMAN_ONLY      = 2;
//const Z_RLE               = 3;
const $a81b0407d764b29f$var$Z_FIXED$1 = 4;
//const Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ const $a81b0407d764b29f$var$Z_BINARY = 0;
const $a81b0407d764b29f$var$Z_TEXT = 1;
//const Z_ASCII             = 1; // = Z_TEXT
const $a81b0407d764b29f$var$Z_UNKNOWN$1 = 2;
/*============================================================================*/ function $a81b0407d764b29f$var$zero$1(buf) {
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
const $a81b0407d764b29f$var$STORED_BLOCK = 0;
const $a81b0407d764b29f$var$STATIC_TREES = 1;
const $a81b0407d764b29f$var$DYN_TREES = 2;
/* The three kinds of block type */ const $a81b0407d764b29f$var$MIN_MATCH$1 = 3;
const $a81b0407d764b29f$var$MAX_MATCH$1 = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ const $a81b0407d764b29f$var$LENGTH_CODES$1 = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $a81b0407d764b29f$var$LITERALS$1 = 256;
/* number of literal bytes 0..255 */ const $a81b0407d764b29f$var$L_CODES$1 = $a81b0407d764b29f$var$LITERALS$1 + 1 + $a81b0407d764b29f$var$LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */ const $a81b0407d764b29f$var$D_CODES$1 = 30;
/* number of distance codes */ const $a81b0407d764b29f$var$BL_CODES$1 = 19;
/* number of codes used to transfer the bit lengths */ const $a81b0407d764b29f$var$HEAP_SIZE$1 = 2 * $a81b0407d764b29f$var$L_CODES$1 + 1;
/* maximum heap size */ const $a81b0407d764b29f$var$MAX_BITS$1 = 15;
/* All codes must not exceed MAX_BITS bits */ const $a81b0407d764b29f$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ const $a81b0407d764b29f$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ const $a81b0407d764b29f$var$END_BLOCK = 256;
/* end of block literal code */ const $a81b0407d764b29f$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ const $a81b0407d764b29f$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ const $a81b0407d764b29f$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ const $a81b0407d764b29f$var$extra_lbits = /* extra bits for each length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
]);
const $a81b0407d764b29f$var$extra_dbits = /* extra bits for each distance code */ new Uint8Array([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
]);
const $a81b0407d764b29f$var$extra_blbits = /* extra bits for each bit length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
]);
const $a81b0407d764b29f$var$bl_order = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
const $a81b0407d764b29f$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
const $a81b0407d764b29f$var$static_ltree = new Array(($a81b0407d764b29f$var$L_CODES$1 + 2) * 2);
$a81b0407d764b29f$var$zero$1($a81b0407d764b29f$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ const $a81b0407d764b29f$var$static_dtree = new Array($a81b0407d764b29f$var$D_CODES$1 * 2);
$a81b0407d764b29f$var$zero$1($a81b0407d764b29f$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ const $a81b0407d764b29f$var$_dist_code = new Array($a81b0407d764b29f$var$DIST_CODE_LEN);
$a81b0407d764b29f$var$zero$1($a81b0407d764b29f$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ const $a81b0407d764b29f$var$_length_code = new Array($a81b0407d764b29f$var$MAX_MATCH$1 - $a81b0407d764b29f$var$MIN_MATCH$1 + 1);
$a81b0407d764b29f$var$zero$1($a81b0407d764b29f$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ const $a81b0407d764b29f$var$base_length = new Array($a81b0407d764b29f$var$LENGTH_CODES$1);
$a81b0407d764b29f$var$zero$1($a81b0407d764b29f$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ const $a81b0407d764b29f$var$base_dist = new Array($a81b0407d764b29f$var$D_CODES$1);
$a81b0407d764b29f$var$zero$1($a81b0407d764b29f$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $a81b0407d764b29f$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
let $a81b0407d764b29f$var$static_l_desc;
let $a81b0407d764b29f$var$static_d_desc;
let $a81b0407d764b29f$var$static_bl_desc;
function $a81b0407d764b29f$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
const $a81b0407d764b29f$var$d_code = (dist)=>{
    return dist < 256 ? $a81b0407d764b29f$var$_dist_code[dist] : $a81b0407d764b29f$var$_dist_code[256 + (dist >>> 7)];
};
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ const $a81b0407d764b29f$var$put_short = (s, w)=>{
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
};
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ const $a81b0407d764b29f$var$send_bits = (s, value, length)=>{
    if (s.bi_valid > $a81b0407d764b29f$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $a81b0407d764b29f$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $a81b0407d764b29f$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $a81b0407d764b29f$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
};
const $a81b0407d764b29f$var$send_code = (s, c, tree)=>{
    $a81b0407d764b29f$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
};
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ const $a81b0407d764b29f$var$bi_reverse = (code, len)=>{
    let res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
};
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ const $a81b0407d764b29f$var$bi_flush = (s)=>{
    if (s.bi_valid === 16) {
        $a81b0407d764b29f$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
};
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ const $a81b0407d764b29f$var$gen_bitlen = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc;    /* the tree descriptor */
    const tree = desc.dyn_tree;
    const max_code = desc.max_code;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const extra = desc.stat_desc.extra_bits;
    const base = desc.stat_desc.extra_base;
    const max_length = desc.stat_desc.max_length;
    let h; /* heap index */ 
    let n, m; /* iterate over the tree elements */ 
    let bits; /* bit length */ 
    let xbits; /* extra bits */ 
    let f; /* frequency */ 
    let overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $a81b0407d764b29f$var$MAX_BITS$1; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $a81b0407d764b29f$var$HEAP_SIZE$1; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Tracev((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Tracev((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
};
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ const $a81b0407d764b29f$var$gen_codes = (tree, max_code, bl_count)=>{
    //    ct_data *tree;             /* the tree to decorate */
    //    int max_code;              /* largest code with non zero frequency */
    //    ushf *bl_count;            /* number of codes at each bit length */
    const next_code = new Array($a81b0407d764b29f$var$MAX_BITS$1 + 1); /* next code value for each bit length */ 
    let code = 0; /* running code value */ 
    let bits; /* bit index */ 
    let n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $a81b0407d764b29f$var$MAX_BITS$1; bits++){
        code = code + bl_count[bits - 1] << 1;
        next_code[bits] = code;
    }
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        let len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $a81b0407d764b29f$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
};
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ const $a81b0407d764b29f$var$tr_static_init = ()=>{
    let n; /* iterates over tree elements */ 
    let bits; /* bit counter */ 
    let length; /* length value */ 
    let code; /* code value */ 
    let dist; /* distance index */ 
    const bl_count = new Array($a81b0407d764b29f$var$MAX_BITS$1 + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $a81b0407d764b29f$var$LENGTH_CODES$1 - 1; code++){
        $a81b0407d764b29f$var$base_length[code] = length;
        for(n = 0; n < 1 << $a81b0407d764b29f$var$extra_lbits[code]; n++)$a81b0407d764b29f$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $a81b0407d764b29f$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $a81b0407d764b29f$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $a81b0407d764b29f$var$extra_dbits[code]; n++)$a81b0407d764b29f$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $a81b0407d764b29f$var$D_CODES$1; code++){
        $a81b0407d764b29f$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $a81b0407d764b29f$var$extra_dbits[code] - 7; n++)$a81b0407d764b29f$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $a81b0407d764b29f$var$MAX_BITS$1; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $a81b0407d764b29f$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $a81b0407d764b29f$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $a81b0407d764b29f$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $a81b0407d764b29f$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $a81b0407d764b29f$var$gen_codes($a81b0407d764b29f$var$static_ltree, $a81b0407d764b29f$var$L_CODES$1 + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $a81b0407d764b29f$var$D_CODES$1; n++){
        $a81b0407d764b29f$var$static_dtree[n * 2 + 1] = 5;
        $a81b0407d764b29f$var$static_dtree[n * 2] = $a81b0407d764b29f$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $a81b0407d764b29f$var$static_l_desc = new $a81b0407d764b29f$var$StaticTreeDesc($a81b0407d764b29f$var$static_ltree, $a81b0407d764b29f$var$extra_lbits, $a81b0407d764b29f$var$LITERALS$1 + 1, $a81b0407d764b29f$var$L_CODES$1, $a81b0407d764b29f$var$MAX_BITS$1);
    $a81b0407d764b29f$var$static_d_desc = new $a81b0407d764b29f$var$StaticTreeDesc($a81b0407d764b29f$var$static_dtree, $a81b0407d764b29f$var$extra_dbits, 0, $a81b0407d764b29f$var$D_CODES$1, $a81b0407d764b29f$var$MAX_BITS$1);
    $a81b0407d764b29f$var$static_bl_desc = new $a81b0407d764b29f$var$StaticTreeDesc(new Array(0), $a81b0407d764b29f$var$extra_blbits, 0, $a81b0407d764b29f$var$BL_CODES$1, $a81b0407d764b29f$var$MAX_BL_BITS);
//static_init_done = true;
};
/* ===========================================================================
 * Initialize a new block.
 */ const $a81b0407d764b29f$var$init_block = (s)=>{
    let n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $a81b0407d764b29f$var$L_CODES$1; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $a81b0407d764b29f$var$D_CODES$1; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $a81b0407d764b29f$var$BL_CODES$1; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$a81b0407d764b29f$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.sym_next = s.matches = 0;
};
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ const $a81b0407d764b29f$var$bi_windup = (s)=>{
    if (s.bi_valid > 8) $a81b0407d764b29f$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
};
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ const $a81b0407d764b29f$var$smaller = (tree, n, m, depth)=>{
    const _n2 = n * 2;
    const _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
};
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ const $a81b0407d764b29f$var$pqdownheap = (s, tree, k)=>{
    //    deflate_state *s;
    //    ct_data *tree;  /* the tree to restore */
    //    int k;               /* node to move down */
    const v = s.heap[k];
    let j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $a81b0407d764b29f$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($a81b0407d764b29f$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
};
// inlined manually
// const SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ const $a81b0407d764b29f$var$compress_block = (s, ltree, dtree)=>{
    //    deflate_state *s;
    //    const ct_data *ltree; /* literal tree */
    //    const ct_data *dtree; /* distance tree */
    let dist; /* distance of matched string */ 
    let lc; /* match length or unmatched char (if dist == 0) */ 
    let sx = 0; /* running index in sym_buf */ 
    let code; /* the code to send */ 
    let extra; /* number of extra bits to send */ 
    if (s.sym_next !== 0) do {
        dist = s.pending_buf[s.sym_buf + sx++] & 0xff;
        dist += (s.pending_buf[s.sym_buf + sx++] & 0xff) << 8;
        lc = s.pending_buf[s.sym_buf + sx++];
        if (dist === 0) $a81b0407d764b29f$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $a81b0407d764b29f$var$_length_code[lc];
            $a81b0407d764b29f$var$send_code(s, code + $a81b0407d764b29f$var$LITERALS$1 + 1, ltree); /* send the length code */ 
            extra = $a81b0407d764b29f$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $a81b0407d764b29f$var$base_length[code];
                $a81b0407d764b29f$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $a81b0407d764b29f$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $a81b0407d764b29f$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $a81b0407d764b29f$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $a81b0407d764b29f$var$base_dist[code];
                $a81b0407d764b29f$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and sym_buf is ok: */ //Assert(s->pending < s->lit_bufsize + sx, "pendingBuf overflow");
    }while (sx < s.sym_next);
    $a81b0407d764b29f$var$send_code(s, $a81b0407d764b29f$var$END_BLOCK, ltree);
};
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ const $a81b0407d764b29f$var$build_tree = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc; /* the tree descriptor */
    const tree = desc.dyn_tree;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const elems = desc.stat_desc.elems;
    let n, m; /* iterate over heap elements */ 
    let max_code = -1; /* largest code with non zero frequency */ 
    let node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $a81b0407d764b29f$var$HEAP_SIZE$1;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$a81b0407d764b29f$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $a81b0407d764b29f$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $a81b0407d764b29f$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $a81b0407d764b29f$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $a81b0407d764b29f$var$gen_codes(tree, max_code, s.bl_count);
};
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ const $a81b0407d764b29f$var$scan_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree;   /* the tree to be scanned */
    //    int max_code;    /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$a81b0407d764b29f$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$a81b0407d764b29f$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$a81b0407d764b29f$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ const $a81b0407d764b29f$var$send_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree; /* the tree to be scanned */
    //    int max_code;       /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $a81b0407d764b29f$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $a81b0407d764b29f$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $a81b0407d764b29f$var$send_code(s, $a81b0407d764b29f$var$REP_3_6, s.bl_tree);
            $a81b0407d764b29f$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $a81b0407d764b29f$var$send_code(s, $a81b0407d764b29f$var$REPZ_3_10, s.bl_tree);
            $a81b0407d764b29f$var$send_bits(s, count - 3, 3);
        } else {
            $a81b0407d764b29f$var$send_code(s, $a81b0407d764b29f$var$REPZ_11_138, s.bl_tree);
            $a81b0407d764b29f$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ const $a81b0407d764b29f$var$build_bl_tree = (s)=>{
    let max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $a81b0407d764b29f$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $a81b0407d764b29f$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $a81b0407d764b29f$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $a81b0407d764b29f$var$BL_CODES$1 - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$a81b0407d764b29f$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
};
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ const $a81b0407d764b29f$var$send_all_trees = (s, lcodes, dcodes, blcodes)=>{
    //    deflate_state *s;
    //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
    let rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $a81b0407d764b29f$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $a81b0407d764b29f$var$send_bits(s, dcodes - 1, 5);
    $a81b0407d764b29f$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $a81b0407d764b29f$var$send_bits(s, s.bl_tree[$a81b0407d764b29f$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $a81b0407d764b29f$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $a81b0407d764b29f$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
};
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "block list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "allow list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ const $a81b0407d764b29f$var$detect_data_type = (s)=>{
    /* block_mask is the bit mask of block-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ let block_mask = 0xf3ffc07f;
    let n;
    /* Check for non-textual ("block-listed") bytes. */ for(n = 0; n <= 31; n++, block_mask >>>= 1){
        if (block_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $a81b0407d764b29f$var$Z_BINARY;
    }
    /* Check for textual ("allow-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $a81b0407d764b29f$var$Z_TEXT;
    for(n = 32; n < $a81b0407d764b29f$var$LITERALS$1; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $a81b0407d764b29f$var$Z_TEXT;
    }
    /* There are no "block-listed" or "allow-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $a81b0407d764b29f$var$Z_BINARY;
};
let $a81b0407d764b29f$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ const $a81b0407d764b29f$var$_tr_init$1 = (s)=>{
    if (!$a81b0407d764b29f$var$static_init_done) {
        $a81b0407d764b29f$var$tr_static_init();
        $a81b0407d764b29f$var$static_init_done = true;
    }
    s.l_desc = new $a81b0407d764b29f$var$TreeDesc(s.dyn_ltree, $a81b0407d764b29f$var$static_l_desc);
    s.d_desc = new $a81b0407d764b29f$var$TreeDesc(s.dyn_dtree, $a81b0407d764b29f$var$static_d_desc);
    s.bl_desc = new $a81b0407d764b29f$var$TreeDesc(s.bl_tree, $a81b0407d764b29f$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $a81b0407d764b29f$var$init_block(s);
};
/* ===========================================================================
 * Send a stored block
 */ const $a81b0407d764b29f$var$_tr_stored_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    $a81b0407d764b29f$var$send_bits(s, ($a81b0407d764b29f$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $a81b0407d764b29f$var$bi_windup(s); /* align on byte boundary */ 
    $a81b0407d764b29f$var$put_short(s, stored_len);
    $a81b0407d764b29f$var$put_short(s, ~stored_len);
    if (stored_len) s.pending_buf.set(s.window.subarray(buf, buf + stored_len), s.pending);
    s.pending += stored_len;
};
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ const $a81b0407d764b29f$var$_tr_align$1 = (s)=>{
    $a81b0407d764b29f$var$send_bits(s, $a81b0407d764b29f$var$STATIC_TREES << 1, 3);
    $a81b0407d764b29f$var$send_code(s, $a81b0407d764b29f$var$END_BLOCK, $a81b0407d764b29f$var$static_ltree);
    $a81b0407d764b29f$var$bi_flush(s);
};
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and write out the encoded block.
 */ const $a81b0407d764b29f$var$_tr_flush_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block, or NULL if too old */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    let opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    let max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $a81b0407d764b29f$var$Z_UNKNOWN$1) s.strm.data_type = $a81b0407d764b29f$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $a81b0407d764b29f$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $a81b0407d764b29f$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $a81b0407d764b29f$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->sym_next / 3));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $a81b0407d764b29f$var$_tr_stored_block$1(s, buf, stored_len, last);
    else if (s.strategy === $a81b0407d764b29f$var$Z_FIXED$1 || static_lenb === opt_lenb) {
        $a81b0407d764b29f$var$send_bits(s, ($a81b0407d764b29f$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $a81b0407d764b29f$var$compress_block(s, $a81b0407d764b29f$var$static_ltree, $a81b0407d764b29f$var$static_dtree);
    } else {
        $a81b0407d764b29f$var$send_bits(s, ($a81b0407d764b29f$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $a81b0407d764b29f$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $a81b0407d764b29f$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $a81b0407d764b29f$var$init_block(s);
    if (last) $a81b0407d764b29f$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
};
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ const $a81b0407d764b29f$var$_tr_tally$1 = (s, dist, lc)=>{
    //    deflate_state *s;
    //    unsigned dist;  /* distance of matched string */
    //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
    s.pending_buf[s.sym_buf + s.sym_next++] = dist;
    s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
    s.pending_buf[s.sym_buf + s.sym_next++] = lc;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($a81b0407d764b29f$var$_length_code[lc] + $a81b0407d764b29f$var$LITERALS$1 + 1) * 2]++;
        s.dyn_dtree[$a81b0407d764b29f$var$d_code(dist) * 2]++;
    }
    return s.sym_next === s.sym_end;
};
var $a81b0407d764b29f$var$_tr_init_1 = $a81b0407d764b29f$var$_tr_init$1;
var $a81b0407d764b29f$var$_tr_stored_block_1 = $a81b0407d764b29f$var$_tr_stored_block$1;
var $a81b0407d764b29f$var$_tr_flush_block_1 = $a81b0407d764b29f$var$_tr_flush_block$1;
var $a81b0407d764b29f$var$_tr_tally_1 = $a81b0407d764b29f$var$_tr_tally$1;
var $a81b0407d764b29f$var$_tr_align_1 = $a81b0407d764b29f$var$_tr_align$1;
var $a81b0407d764b29f$var$trees = {
    _tr_init: $a81b0407d764b29f$var$_tr_init_1,
    _tr_stored_block: $a81b0407d764b29f$var$_tr_stored_block_1,
    _tr_flush_block: $a81b0407d764b29f$var$_tr_flush_block_1,
    _tr_tally: $a81b0407d764b29f$var$_tr_tally_1,
    _tr_align: $a81b0407d764b29f$var$_tr_align_1
};
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $a81b0407d764b29f$var$adler32 = (adler, buf, len, pos)=>{
    let s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
};
var $a81b0407d764b29f$var$adler32_1 = $a81b0407d764b29f$var$adler32;
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
const $a81b0407d764b29f$var$makeTable = ()=>{
    let c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
};
// Create table on load. Just 255 signed longs. Not a problem.
const $a81b0407d764b29f$var$crcTable = new Uint32Array($a81b0407d764b29f$var$makeTable());
const $a81b0407d764b29f$var$crc32 = (crc, buf, len, pos)=>{
    const t = $a81b0407d764b29f$var$crcTable;
    const end = pos + len;
    crc ^= -1;
    for(let i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
};
var $a81b0407d764b29f$var$crc32_1 = $a81b0407d764b29f$var$crc32;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $a81b0407d764b29f$var$messages = {
    2: 'need dictionary',
    /* Z_NEED_DICT       2  */ 1: 'stream end',
    /* Z_STREAM_END      1  */ 0: '',
    /* Z_OK              0  */ '-1': 'file error',
    /* Z_ERRNO         (-1) */ '-2': 'stream error',
    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $a81b0407d764b29f$var$constants$2 = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_MEM_ERROR: -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const { _tr_init: $a81b0407d764b29f$var$_tr_init, _tr_stored_block: $a81b0407d764b29f$var$_tr_stored_block, _tr_flush_block: $a81b0407d764b29f$var$_tr_flush_block, _tr_tally: $a81b0407d764b29f$var$_tr_tally, _tr_align: $a81b0407d764b29f$var$_tr_align } = $a81b0407d764b29f$var$trees;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $a81b0407d764b29f$var$Z_NO_FLUSH$2, Z_PARTIAL_FLUSH: $a81b0407d764b29f$var$Z_PARTIAL_FLUSH, Z_FULL_FLUSH: $a81b0407d764b29f$var$Z_FULL_FLUSH$1, Z_FINISH: $a81b0407d764b29f$var$Z_FINISH$3, Z_BLOCK: $a81b0407d764b29f$var$Z_BLOCK$1, Z_OK: $a81b0407d764b29f$var$Z_OK$3, Z_STREAM_END: $a81b0407d764b29f$var$Z_STREAM_END$3, Z_STREAM_ERROR: $a81b0407d764b29f$var$Z_STREAM_ERROR$2, Z_DATA_ERROR: $a81b0407d764b29f$var$Z_DATA_ERROR$2, Z_BUF_ERROR: $a81b0407d764b29f$var$Z_BUF_ERROR$2, Z_DEFAULT_COMPRESSION: $a81b0407d764b29f$var$Z_DEFAULT_COMPRESSION$1, Z_FILTERED: $a81b0407d764b29f$var$Z_FILTERED, Z_HUFFMAN_ONLY: $a81b0407d764b29f$var$Z_HUFFMAN_ONLY, Z_RLE: $a81b0407d764b29f$var$Z_RLE, Z_FIXED: $a81b0407d764b29f$var$Z_FIXED, Z_DEFAULT_STRATEGY: $a81b0407d764b29f$var$Z_DEFAULT_STRATEGY$1, Z_UNKNOWN: $a81b0407d764b29f$var$Z_UNKNOWN, Z_DEFLATED: $a81b0407d764b29f$var$Z_DEFLATED$2 } = $a81b0407d764b29f$var$constants$2;
/*============================================================================*/ const $a81b0407d764b29f$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ const $a81b0407d764b29f$var$MAX_WBITS$1 = 15;
/* 32K LZ77 window */ const $a81b0407d764b29f$var$DEF_MEM_LEVEL = 8;
const $a81b0407d764b29f$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $a81b0407d764b29f$var$LITERALS = 256;
/* number of literal bytes 0..255 */ const $a81b0407d764b29f$var$L_CODES = $a81b0407d764b29f$var$LITERALS + 1 + $a81b0407d764b29f$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ const $a81b0407d764b29f$var$D_CODES = 30;
/* number of distance codes */ const $a81b0407d764b29f$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ const $a81b0407d764b29f$var$HEAP_SIZE = 2 * $a81b0407d764b29f$var$L_CODES + 1;
/* maximum heap size */ const $a81b0407d764b29f$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ const $a81b0407d764b29f$var$MIN_MATCH = 3;
const $a81b0407d764b29f$var$MAX_MATCH = 258;
const $a81b0407d764b29f$var$MIN_LOOKAHEAD = $a81b0407d764b29f$var$MAX_MATCH + $a81b0407d764b29f$var$MIN_MATCH + 1;
const $a81b0407d764b29f$var$PRESET_DICT = 0x20;
const $a81b0407d764b29f$var$INIT_STATE = 42; /* zlib header -> BUSY_STATE */ 
//#ifdef GZIP
const $a81b0407d764b29f$var$GZIP_STATE = 57; /* gzip header -> BUSY_STATE | EXTRA_STATE */ 
//#endif
const $a81b0407d764b29f$var$EXTRA_STATE = 69; /* gzip extra block -> NAME_STATE */ 
const $a81b0407d764b29f$var$NAME_STATE = 73; /* gzip file name -> COMMENT_STATE */ 
const $a81b0407d764b29f$var$COMMENT_STATE = 91; /* gzip comment -> HCRC_STATE */ 
const $a81b0407d764b29f$var$HCRC_STATE = 103; /* gzip header CRC -> BUSY_STATE */ 
const $a81b0407d764b29f$var$BUSY_STATE = 113; /* deflate -> FINISH_STATE */ 
const $a81b0407d764b29f$var$FINISH_STATE = 666; /* stream complete */ 
const $a81b0407d764b29f$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
const $a81b0407d764b29f$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
const $a81b0407d764b29f$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
const $a81b0407d764b29f$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
const $a81b0407d764b29f$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
const $a81b0407d764b29f$var$err = (strm, errorCode)=>{
    strm.msg = $a81b0407d764b29f$var$messages[errorCode];
    return errorCode;
};
const $a81b0407d764b29f$var$rank = (f)=>{
    return f * 2 - (f > 4 ? 9 : 0);
};
const $a81b0407d764b29f$var$zero = (buf)=>{
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
};
/* ===========================================================================
 * Slide the hash table when sliding the window down (could be avoided with 32
 * bit values at the expense of memory usage). We slide even when level == 0 to
 * keep the hash table consistent if we switch back to level > 0 later.
 */ const $a81b0407d764b29f$var$slide_hash = (s)=>{
    let n, m;
    let p;
    let wsize = s.w_size;
    n = s.hash_size;
    p = n;
    do {
        m = s.head[--p];
        s.head[p] = m >= wsize ? m - wsize : 0;
    }while (--n);
    n = wsize;
    //#ifndef FASTEST
    p = n;
    do {
        m = s.prev[--p];
        s.prev[p] = m >= wsize ? m - wsize : 0;
    /* If n is not on any hash chain, prev[n] is garbage but
     * its value will never be used.
     */ }while (--n);
//#endif
};
/* eslint-disable new-cap */ let $a81b0407d764b29f$var$HASH = (s, prev, data)=>(prev << s.hash_shift ^ data) & s.hash_mask;
/* ===========================================================================
 * Insert string str in the dictionary and set match_head to the previous head
 * of the hash chain (the most recent string with same hash key). Return
 * the previous length of the hash chain.
 * IN  assertion: all calls to INSERT_STRING are made with consecutive input
 *    characters and the first MIN_MATCH bytes of str are valid (except for
 *    the last MIN_MATCH-1 bytes of the input file).
 */ const $a81b0407d764b29f$var$INSERT_STRING = (s, str)=>{
    let h;
    if (s.legacy_hash) /* UPDATE_HASH(s, s->ins_h, s->window[(str) + (MIN_MATCH-1)]); */ h = s.ins_h = $a81b0407d764b29f$var$HASH(s, s.ins_h, s.window[str + $a81b0407d764b29f$var$MIN_MATCH - 1]);
    else {
        // ANZAC++ hash: reads 4 bytes, matches node.js zlib output (legacyHash
        // restores classic zlib hash). Faster, with fewer collisions.
        const w = s.window;
        // Read 4 bytes little-endian. Math.imul reproduces C uint32 overflow in
        // `(value * 66521 + 66521) >> 16` exactly.
        const value = w[str] | w[str + 1] << 8 | w[str + 2] << 16 | w[str + 3] << 24;
        h = s.ins_h = Math.imul(value, 66521) + 66521 >>> 16 & s.hash_mask;
    }
    const hash_head = s.prev[str & s.w_mask] = s.head[h];
    s.head[h] = str;
    return hash_head;
};
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output, except for
 * some deflate_stored() output, goes through this function so some
 * applications may wish to modify it to avoid allocating a large
 * strm->next_out buffer and copying into it. (See also read_buf()).
 */ const $a81b0407d764b29f$var$flush_pending = (strm)=>{
    const s = strm.state;
    //_tr_flush_bits(s);
    let len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
};
const $a81b0407d764b29f$var$flush_block_only = (s, last)=>{
    $a81b0407d764b29f$var$_tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $a81b0407d764b29f$var$flush_pending(s.strm);
};
const $a81b0407d764b29f$var$put_byte = (s, b)=>{
    s.pending_buf[s.pending++] = b;
};
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ const $a81b0407d764b29f$var$putShortMSB = (s, b)=>{
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
};
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ const $a81b0407d764b29f$var$read_buf = (strm, buf, start, size)=>{
    let len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
    if (strm.state.wrap === 1) strm.adler = $a81b0407d764b29f$var$adler32_1(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $a81b0407d764b29f$var$crc32_1(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
};
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ const $a81b0407d764b29f$var$longest_match = (s, cur_match)=>{
    let chain_length = s.max_chain_length; /* max hash chain length */ 
    let scan = s.strstart; /* current string */ 
    let match; /* matched string */ 
    let len; /* length of current match */ 
    let best_len = s.prev_length; /* best match length so far */ 
    let nice_match = s.nice_match; /* stop if match long enough */ 
    const limit = s.strstart > s.w_size - $a81b0407d764b29f$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $a81b0407d764b29f$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    const _win = s.window; // shortcut
    const wmask = s.w_mask;
    const prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ const strend = s.strstart + $a81b0407d764b29f$var$MAX_MATCH;
    let scan_end1 = _win[scan + best_len - 1];
    let scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $a81b0407d764b29f$var$MAX_MATCH - (strend - scan);
        scan = strend - $a81b0407d764b29f$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
};
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ const $a81b0407d764b29f$var$fill_window = (s)=>{
    const _w_size = s.w_size;
    let n, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $a81b0407d764b29f$var$MIN_LOOKAHEAD)) {
            s.window.set(s.window.subarray(_w_size, _w_size + _w_size - more), 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            if (s.insert > s.strstart) s.insert = s.strstart;
            $a81b0407d764b29f$var$slide_hash(s);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $a81b0407d764b29f$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (!s.legacy_hash) /* The 4-byte hash reads one extra byte, so it needs one more available. */ {
            if (s.lookahead + s.insert > $a81b0407d764b29f$var$MIN_MATCH) {
                str = s.strstart - s.insert;
                while(s.insert){
                    $a81b0407d764b29f$var$INSERT_STRING(s, str);
                    str++;
                    s.insert--;
                    if (s.lookahead + s.insert <= $a81b0407d764b29f$var$MIN_MATCH) break;
                }
            }
        } else if (s.lookahead + s.insert >= $a81b0407d764b29f$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = $a81b0407d764b29f$var$HASH(s, s.ins_h, s.window[str + 1]);
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                $a81b0407d764b29f$var$INSERT_STRING(s, str);
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $a81b0407d764b29f$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $a81b0407d764b29f$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    const curr = s.strstart + s.lookahead;
//    let init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
};
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 *
 * In case deflateParams() is used to later switch to a non-zero compression
 * level, s->matches (otherwise unused when storing) keeps track of the number
 * of hash table slides to perform. If s->matches is 1, then one hash table
 * slide will be done when switching. If s->matches is 2, the maximum value
 * allowed here, then the hash table will be cleared, since two or more slides
 * is the same as a clear.
 *
 * deflate_stored() is written to minimize the number of times an input byte is
 * copied. It is most efficient with large input and output buffers, which
 * maximizes the opportunites to have a single copy from next_in to next_out.
 */ const $a81b0407d764b29f$var$deflate_stored = (s, flush)=>{
    /* Smallest worthy block size when not flushing or finishing. By default
   * this is 32K. This can be as small as 507 bytes for memLevel == 1. For
   * large input and output buffers, the stored block size will be larger.
   */ let min_block = s.pending_buf_size - 5 > s.w_size ? s.w_size : s.pending_buf_size - 5;
    /* Copy as many min_block or larger stored blocks directly to next_out as
   * possible. If flushing, copy the remaining available input to next_out as
   * stored blocks, if there is enough space.
   */ let len, left, have, last = 0;
    let used = s.strm.avail_in;
    do {
        /* Set len to the maximum size block that we can copy directly with the
     * available input data and output space. Set left to how much of that
     * would be copied from what's left in the window.
     */ len = 65535 /* MAX_STORED */ ; /* maximum deflate stored block length */ 
        have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
        if (s.strm.avail_out < have) break;
        /* maximum stored block length that will fit in avail_out: */ have = s.strm.avail_out - have;
        left = s.strstart - s.block_start; /* bytes left in window */ 
        if (len > left + s.strm.avail_in) len = left + s.strm.avail_in; /* limit len to the input */ 
        if (len > have) len = have; /* limit len to the output */ 
        /* If the stored block would be less than min_block in length, or if
     * unable to copy all of the available input when flushing, then try
     * copying to the window and the pending buffer instead. Also don't
     * write an empty block when flushing -- deflate() does that.
     */ if (len < min_block && (len === 0 && flush !== $a81b0407d764b29f$var$Z_FINISH$3 || flush === $a81b0407d764b29f$var$Z_NO_FLUSH$2 || len !== left + s.strm.avail_in)) break;
        /* Make a dummy stored block in pending to get the header bytes,
     * including any pending bits. This also updates the debugging counts.
     */ last = flush === $a81b0407d764b29f$var$Z_FINISH$3 && len === left + s.strm.avail_in ? 1 : 0;
        $a81b0407d764b29f$var$_tr_stored_block(s, 0, 0, last);
        /* Replace the lengths in the dummy stored block with len. */ s.pending_buf[s.pending - 4] = len;
        s.pending_buf[s.pending - 3] = len >> 8;
        s.pending_buf[s.pending - 2] = ~len;
        s.pending_buf[s.pending - 1] = ~len >> 8;
        /* Write the stored block header bytes. */ $a81b0407d764b29f$var$flush_pending(s.strm);
        //#ifdef ZLIB_DEBUG
        //    /* Update debugging counts for the data about to be copied. */
        //    s->compressed_len += len << 3;
        //    s->bits_sent += len << 3;
        //#endif
        /* Copy uncompressed bytes from the window to next_out. */ if (left) {
            if (left > len) left = len;
            //zmemcpy(s->strm->next_out, s->window + s->block_start, left);
            s.strm.output.set(s.window.subarray(s.block_start, s.block_start + left), s.strm.next_out);
            s.strm.next_out += left;
            s.strm.avail_out -= left;
            s.strm.total_out += left;
            s.block_start += left;
            len -= left;
        }
        /* Copy uncompressed bytes directly from next_in to next_out, updating
     * the check value.
     */ if (len) {
            $a81b0407d764b29f$var$read_buf(s.strm, s.strm.output, s.strm.next_out, len);
            s.strm.next_out += len;
            s.strm.avail_out -= len;
            s.strm.total_out += len;
        }
    }while (last === 0);
    /* Update the sliding window with the last s->w_size bytes of the copied
   * data, or append all of the copied data to the existing window if less
   * than s->w_size bytes were copied. Also update the number of bytes to
   * insert in the hash tables, in the event that deflateParams() switches to
   * a non-zero compression level.
   */ used -= s.strm.avail_in; /* number of input bytes directly copied */ 
    if (used) {
        /* If any input was used, then no unused input remains in the window,
     * therefore s->block_start == s->strstart.
     */ if (used >= s.w_size) {
            s.matches = 2; /* clear hash */ 
            //zmemcpy(s->window, s->strm->next_in - s->w_size, s->w_size);
            s.window.set(s.strm.input.subarray(s.strm.next_in - s.w_size, s.strm.next_in), 0);
            s.strstart = s.w_size;
            s.insert = s.strstart;
        } else {
            if (s.window_size - s.strstart <= used) {
                /* Slide the window down. */ s.strstart -= s.w_size;
                //zmemcpy(s->window, s->window + s->w_size, s->strstart);
                s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
                if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
                if (s.insert > s.strstart) s.insert = s.strstart;
            }
            //zmemcpy(s->window + s->strstart, s->strm->next_in - used, used);
            s.window.set(s.strm.input.subarray(s.strm.next_in - used, s.strm.next_in), s.strstart);
            s.strstart += used;
            s.insert += used > s.w_size - s.insert ? s.w_size - s.insert : used;
        }
        s.block_start = s.strstart;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* If the last block was written to next_out, then done. */ if (last) return $a81b0407d764b29f$var$BS_FINISH_DONE;
    /* If flushing and all input has been consumed, then done. */ if (flush !== $a81b0407d764b29f$var$Z_NO_FLUSH$2 && flush !== $a81b0407d764b29f$var$Z_FINISH$3 && s.strm.avail_in === 0 && s.strstart === s.block_start) return $a81b0407d764b29f$var$BS_BLOCK_DONE;
    /* Fill the window with any remaining input. */ have = s.window_size - s.strstart;
    if (s.strm.avail_in > have && s.block_start >= s.w_size) {
        /* Slide the window down. */ s.block_start -= s.w_size;
        s.strstart -= s.w_size;
        //zmemcpy(s->window, s->window + s->w_size, s->strstart);
        s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
        if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
        have += s.w_size; /* more space now */ 
        if (s.insert > s.strstart) s.insert = s.strstart;
    }
    if (have > s.strm.avail_in) have = s.strm.avail_in;
    if (have) {
        $a81b0407d764b29f$var$read_buf(s.strm, s.window, s.strstart, have);
        s.strstart += have;
        s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* There was not enough avail_out to write a complete worthy or flushed
   * stored block to next_out. Write a stored block to pending instead, if we
   * have enough input for a worthy block, or if flushing and there is enough
   * room for the remaining input as a stored block in the pending buffer.
   */ have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
    /* maximum stored block length that will fit in pending: */ have = s.pending_buf_size - have > 65535 /* MAX_STORED */  ? 65535 /* MAX_STORED */  : s.pending_buf_size - have;
    min_block = have > s.w_size ? s.w_size : have;
    left = s.strstart - s.block_start;
    if (left >= min_block || (left || flush === $a81b0407d764b29f$var$Z_FINISH$3) && flush !== $a81b0407d764b29f$var$Z_NO_FLUSH$2 && s.strm.avail_in === 0 && left <= have) {
        len = left > have ? have : left;
        last = flush === $a81b0407d764b29f$var$Z_FINISH$3 && s.strm.avail_in === 0 && len === left ? 1 : 0;
        $a81b0407d764b29f$var$_tr_stored_block(s, s.block_start, len, last);
        s.block_start += len;
        $a81b0407d764b29f$var$flush_pending(s.strm);
    }
    /* We've done all we can with the available input and output. */ return last ? $a81b0407d764b29f$var$BS_FINISH_STARTED : $a81b0407d764b29f$var$BS_NEED_MORE;
};
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ const $a81b0407d764b29f$var$deflate_fast = (s, flush)=>{
    let hash_head; /* head of the hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $a81b0407d764b29f$var$MIN_LOOKAHEAD) {
            $a81b0407d764b29f$var$fill_window(s);
            if (s.lookahead < $a81b0407d764b29f$var$MIN_LOOKAHEAD && flush === $a81b0407d764b29f$var$Z_NO_FLUSH$2) return $a81b0407d764b29f$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $a81b0407d764b29f$var$MIN_MATCH) hash_head = $a81b0407d764b29f$var$INSERT_STRING(s, s.strstart);
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $a81b0407d764b29f$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $a81b0407d764b29f$var$longest_match(s, hash_head);
        if (s.match_length >= $a81b0407d764b29f$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $a81b0407d764b29f$var$_tr_tally(s, s.strstart - s.match_start, s.match_length - $a81b0407d764b29f$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $a81b0407d764b29f$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    hash_head = $a81b0407d764b29f$var$INSERT_STRING(s, s.strstart);
                /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                if (s.legacy_hash) {
                    s.ins_h = s.window[s.strstart];
                    /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = $a81b0407d764b29f$var$HASH(s, s.ins_h, s.window[s.strstart + 1]);
                //#if MIN_MATCH != 3
                //                Call UPDATE_HASH() MIN_MATCH-3 more times
                //#endif
                /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
           * matter since it will be recomputed at next deflate call.
           */ }
            }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $a81b0407d764b29f$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $a81b0407d764b29f$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $a81b0407d764b29f$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $a81b0407d764b29f$var$MIN_MATCH - 1 ? s.strstart : $a81b0407d764b29f$var$MIN_MATCH - 1;
    if (flush === $a81b0407d764b29f$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $a81b0407d764b29f$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $a81b0407d764b29f$var$BS_FINISH_STARTED;
        /***/ return $a81b0407d764b29f$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $a81b0407d764b29f$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $a81b0407d764b29f$var$BS_NEED_MORE;
    /***/ }
    return $a81b0407d764b29f$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ const $a81b0407d764b29f$var$deflate_slow = (s, flush)=>{
    let hash_head; /* head of hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    let max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $a81b0407d764b29f$var$MIN_LOOKAHEAD) {
            $a81b0407d764b29f$var$fill_window(s);
            if (s.lookahead < $a81b0407d764b29f$var$MIN_LOOKAHEAD && flush === $a81b0407d764b29f$var$Z_NO_FLUSH$2) return $a81b0407d764b29f$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $a81b0407d764b29f$var$MIN_MATCH) hash_head = $a81b0407d764b29f$var$INSERT_STRING(s, s.strstart);
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $a81b0407d764b29f$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $a81b0407d764b29f$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $a81b0407d764b29f$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $a81b0407d764b29f$var$Z_FILTERED || s.match_length === $a81b0407d764b29f$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $a81b0407d764b29f$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $a81b0407d764b29f$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $a81b0407d764b29f$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $a81b0407d764b29f$var$_tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $a81b0407d764b29f$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) hash_head = $a81b0407d764b29f$var$INSERT_STRING(s, s.strstart);
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $a81b0407d764b29f$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $a81b0407d764b29f$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $a81b0407d764b29f$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $a81b0407d764b29f$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $a81b0407d764b29f$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $a81b0407d764b29f$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $a81b0407d764b29f$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $a81b0407d764b29f$var$MIN_MATCH - 1 ? s.strstart : $a81b0407d764b29f$var$MIN_MATCH - 1;
    if (flush === $a81b0407d764b29f$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $a81b0407d764b29f$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $a81b0407d764b29f$var$BS_FINISH_STARTED;
        /***/ return $a81b0407d764b29f$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $a81b0407d764b29f$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $a81b0407d764b29f$var$BS_NEED_MORE;
    /***/ }
    return $a81b0407d764b29f$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ const $a81b0407d764b29f$var$deflate_rle = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    let prev; /* byte at distance one to match */ 
    let scan, strend; /* scan goes up to strend for length of run */ 
    const _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $a81b0407d764b29f$var$MAX_MATCH) {
            $a81b0407d764b29f$var$fill_window(s);
            if (s.lookahead <= $a81b0407d764b29f$var$MAX_MATCH && flush === $a81b0407d764b29f$var$Z_NO_FLUSH$2) return $a81b0407d764b29f$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $a81b0407d764b29f$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $a81b0407d764b29f$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $a81b0407d764b29f$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $a81b0407d764b29f$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $a81b0407d764b29f$var$_tr_tally(s, 1, s.match_length - $a81b0407d764b29f$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $a81b0407d764b29f$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $a81b0407d764b29f$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $a81b0407d764b29f$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $a81b0407d764b29f$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $a81b0407d764b29f$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $a81b0407d764b29f$var$BS_FINISH_STARTED;
        /***/ return $a81b0407d764b29f$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $a81b0407d764b29f$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $a81b0407d764b29f$var$BS_NEED_MORE;
    /***/ }
    return $a81b0407d764b29f$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ const $a81b0407d764b29f$var$deflate_huff = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $a81b0407d764b29f$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $a81b0407d764b29f$var$Z_NO_FLUSH$2) return $a81b0407d764b29f$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $a81b0407d764b29f$var$_tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $a81b0407d764b29f$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $a81b0407d764b29f$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $a81b0407d764b29f$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $a81b0407d764b29f$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $a81b0407d764b29f$var$BS_FINISH_STARTED;
        /***/ return $a81b0407d764b29f$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $a81b0407d764b29f$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $a81b0407d764b29f$var$BS_NEED_MORE;
    /***/ }
    return $a81b0407d764b29f$var$BS_BLOCK_DONE;
};
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $a81b0407d764b29f$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
const $a81b0407d764b29f$var$configuration_table = [
    /*      good lazy nice chain */ new $a81b0407d764b29f$var$Config(0, 0, 0, 0, $a81b0407d764b29f$var$deflate_stored),
    /* 0 store only */ new $a81b0407d764b29f$var$Config(4, 4, 8, 4, $a81b0407d764b29f$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $a81b0407d764b29f$var$Config(4, 5, 16, 8, $a81b0407d764b29f$var$deflate_fast),
    /* 2 */ new $a81b0407d764b29f$var$Config(4, 6, 32, 32, $a81b0407d764b29f$var$deflate_fast),
    /* 3 */ new $a81b0407d764b29f$var$Config(4, 4, 16, 16, $a81b0407d764b29f$var$deflate_slow),
    /* 4 lazy matches */ new $a81b0407d764b29f$var$Config(8, 16, 32, 32, $a81b0407d764b29f$var$deflate_slow),
    /* 5 */ new $a81b0407d764b29f$var$Config(8, 16, 128, 128, $a81b0407d764b29f$var$deflate_slow),
    /* 6 */ new $a81b0407d764b29f$var$Config(8, 32, 128, 256, $a81b0407d764b29f$var$deflate_slow),
    /* 7 */ new $a81b0407d764b29f$var$Config(32, 128, 258, 1024, $a81b0407d764b29f$var$deflate_slow),
    /* 8 */ new $a81b0407d764b29f$var$Config(32, 258, 258, 4096, $a81b0407d764b29f$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ const $a81b0407d764b29f$var$lm_init = (s)=>{
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $a81b0407d764b29f$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $a81b0407d764b29f$var$configuration_table[s.level].max_lazy;
    s.good_match = $a81b0407d764b29f$var$configuration_table[s.level].good_length;
    s.nice_match = $a81b0407d764b29f$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $a81b0407d764b29f$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $a81b0407d764b29f$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
};
function $a81b0407d764b29f$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $a81b0407d764b29f$var$Z_DEFLATED$2; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.legacy_hash = 0; /* use classic zlib hash instead of default ANZAC++ */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new Uint16Array($a81b0407d764b29f$var$HEAP_SIZE * 2);
    this.dyn_dtree = new Uint16Array((2 * $a81b0407d764b29f$var$D_CODES + 1) * 2);
    this.bl_tree = new Uint16Array((2 * $a81b0407d764b29f$var$BL_CODES + 1) * 2);
    $a81b0407d764b29f$var$zero(this.dyn_ltree);
    $a81b0407d764b29f$var$zero(this.dyn_dtree);
    $a81b0407d764b29f$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new Uint16Array($a81b0407d764b29f$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new Uint16Array(2 * $a81b0407d764b29f$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $a81b0407d764b29f$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new Uint16Array(2 * $a81b0407d764b29f$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $a81b0407d764b29f$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.sym_buf = 0; /* buffer for distances and literals/lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.sym_next = 0; /* running index in sym_buf */ 
    this.sym_end = 0; /* symbol table full when sym_next reaches this */ 
    this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
/* =========================================================================
 * Check for a valid deflate stream state. Return 0 if ok, 1 if not.
 */ const $a81b0407d764b29f$var$deflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const s = strm.state;
    if (!s || s.strm !== strm || s.status !== $a81b0407d764b29f$var$INIT_STATE && //#ifdef GZIP
    s.status !== $a81b0407d764b29f$var$GZIP_STATE && //#endif
    s.status !== $a81b0407d764b29f$var$EXTRA_STATE && s.status !== $a81b0407d764b29f$var$NAME_STATE && s.status !== $a81b0407d764b29f$var$COMMENT_STATE && s.status !== $a81b0407d764b29f$var$HCRC_STATE && s.status !== $a81b0407d764b29f$var$BUSY_STATE && s.status !== $a81b0407d764b29f$var$FINISH_STATE) return 1;
    return 0;
};
const $a81b0407d764b29f$var$deflateResetKeep = (strm)=>{
    if ($a81b0407d764b29f$var$deflateStateCheck(strm)) return $a81b0407d764b29f$var$err(strm, $a81b0407d764b29f$var$Z_STREAM_ERROR$2);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $a81b0407d764b29f$var$Z_UNKNOWN;
    const s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = //#ifdef GZIP
    s.wrap === 2 ? $a81b0407d764b29f$var$GZIP_STATE : //#endif
    s.wrap ? $a81b0407d764b29f$var$INIT_STATE : $a81b0407d764b29f$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = -2;
    $a81b0407d764b29f$var$_tr_init(s);
    return $a81b0407d764b29f$var$Z_OK$3;
};
const $a81b0407d764b29f$var$deflateReset = (strm)=>{
    const ret = $a81b0407d764b29f$var$deflateResetKeep(strm);
    if (ret === $a81b0407d764b29f$var$Z_OK$3) $a81b0407d764b29f$var$lm_init(strm.state);
    return ret;
};
const $a81b0407d764b29f$var$deflateSetHeader = (strm, head)=>{
    if ($a81b0407d764b29f$var$deflateStateCheck(strm) || strm.state.wrap !== 2) return $a81b0407d764b29f$var$Z_STREAM_ERROR$2;
    strm.state.gzhead = head;
    return $a81b0407d764b29f$var$Z_OK$3;
};
const $a81b0407d764b29f$var$deflateInit2 = (strm, level, method, windowBits, memLevel, strategy, legacyHash)=>{
    if (!strm) return $a81b0407d764b29f$var$Z_STREAM_ERROR$2;
    let wrap = 1;
    if (level === $a81b0407d764b29f$var$Z_DEFAULT_COMPRESSION$1) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $a81b0407d764b29f$var$MAX_MEM_LEVEL || method !== $a81b0407d764b29f$var$Z_DEFLATED$2 || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $a81b0407d764b29f$var$Z_FIXED || windowBits === 8 && wrap !== 1) return $a81b0407d764b29f$var$err(strm, $a81b0407d764b29f$var$Z_STREAM_ERROR$2);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ const s = new $a81b0407d764b29f$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.status = $a81b0407d764b29f$var$INIT_STATE; /* to pass state test in deflateReset() */ 
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.legacy_hash = legacyHash ? 1 : 0;
    s.hash_bits = memLevel + 7;
    /* ANZAC++ hash needs >= 15 hash bits to span its 4 read bytes. */ if (!s.legacy_hash && s.hash_bits < 15) s.hash_bits = 15;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $a81b0407d764b29f$var$MIN_MATCH - 1) / $a81b0407d764b29f$var$MIN_MATCH);
    s.window = new Uint8Array(s.w_size * 2);
    s.head = new Uint16Array(s.hash_size);
    s.prev = new Uint16Array(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    /* We overlay pending_buf and sym_buf. This works since the average size
   * for length/distance pairs over any compressed block is assured to be 31
   * bits or less.
   *
   * Analysis: The longest fixed codes are a length code of 8 bits plus 5
   * extra bits, for lengths 131 to 257. The longest fixed distance codes are
   * 5 bits plus 13 extra bits, for distances 16385 to 32768. The longest
   * possible fixed-codes length/distance pair is then 31 bits total.
   *
   * sym_buf starts one-fourth of the way into pending_buf. So there are
   * three bytes in sym_buf for every four bytes in pending_buf. Each symbol
   * in sym_buf is three bytes -- two for the distance and one for the
   * literal/length. As each symbol is consumed, the pointer to the next
   * sym_buf value to read moves forward three bytes. From that symbol, up to
   * 31 bits are written to pending_buf. The closest the written pending_buf
   * bits gets to the next sym_buf symbol to read is just before the last
   * code is written. At that time, 31*(n-2) bits have been written, just
   * after 24*(n-2) bits have been consumed from sym_buf. sym_buf starts at
   * 8*n bits into pending_buf. (Note that the symbol buffer fills when n-1
   * symbols are written.) The closest the writing gets to what is unread is
   * then n+14 bits. Here n is lit_bufsize, which is 16384 by default, and
   * can range from 128 to 32768.
   *
   * Therefore, at a minimum, there are 142 bits of space between what is
   * written and what is read in the overlain buffers, so the symbols cannot
   * be overwritten by the compressed data. That space is actually 139 bits,
   * due to the three-bit fixed-code block header.
   *
   * That covers the case where either Z_FIXED is specified, forcing fixed
   * codes, or when the use of fixed codes is chosen, because that choice
   * results in a smaller compressed block than dynamic codes. That latter
   * condition then assures that the above analysis also covers all dynamic
   * blocks. A dynamic-code block will only be chosen to be emitted if it has
   * fewer bits than a fixed-code block would for the same set of symbols.
   * Therefore its average symbol length is assured to be less than 31. So
   * the compressed data for a dynamic block also cannot overwrite the
   * symbols from which it is being constructed.
   */ s.pending_buf_size = s.lit_bufsize * 4;
    s.pending_buf = new Uint8Array(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->sym_buf = s->pending_buf + s->lit_bufsize;
    s.sym_buf = s.lit_bufsize;
    //s->sym_end = (s->lit_bufsize - 1) * 3;
    s.sym_end = (s.lit_bufsize - 1) * 3;
    /* We avoid equality with lit_bufsize*3 because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $a81b0407d764b29f$var$deflateReset(strm);
};
const $a81b0407d764b29f$var$deflateInit = (strm, level)=>{
    return $a81b0407d764b29f$var$deflateInit2(strm, level, $a81b0407d764b29f$var$Z_DEFLATED$2, $a81b0407d764b29f$var$MAX_WBITS$1, $a81b0407d764b29f$var$DEF_MEM_LEVEL, $a81b0407d764b29f$var$Z_DEFAULT_STRATEGY$1);
};
/* ========================================================================= */ const $a81b0407d764b29f$var$deflate$2 = (strm, flush)=>{
    if ($a81b0407d764b29f$var$deflateStateCheck(strm) || flush > $a81b0407d764b29f$var$Z_BLOCK$1 || flush < 0) return strm ? $a81b0407d764b29f$var$err(strm, $a81b0407d764b29f$var$Z_STREAM_ERROR$2) : $a81b0407d764b29f$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    if (!strm.output || strm.avail_in !== 0 && !strm.input || s.status === $a81b0407d764b29f$var$FINISH_STATE && flush !== $a81b0407d764b29f$var$Z_FINISH$3) return $a81b0407d764b29f$var$err(strm, strm.avail_out === 0 ? $a81b0407d764b29f$var$Z_BUF_ERROR$2 : $a81b0407d764b29f$var$Z_STREAM_ERROR$2);
    const old_flush = s.last_flush;
    s.last_flush = flush;
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $a81b0407d764b29f$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $a81b0407d764b29f$var$Z_OK$3;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $a81b0407d764b29f$var$rank(flush) <= $a81b0407d764b29f$var$rank(old_flush) && flush !== $a81b0407d764b29f$var$Z_FINISH$3) return $a81b0407d764b29f$var$err(strm, $a81b0407d764b29f$var$Z_BUF_ERROR$2);
    /* User must not provide more input after the first FINISH: */ if (s.status === $a81b0407d764b29f$var$FINISH_STATE && strm.avail_in !== 0) return $a81b0407d764b29f$var$err(strm, $a81b0407d764b29f$var$Z_BUF_ERROR$2);
    /* Write the header */ if (s.status === $a81b0407d764b29f$var$INIT_STATE && s.wrap === 0) s.status = $a81b0407d764b29f$var$BUSY_STATE;
    if (s.status === $a81b0407d764b29f$var$INIT_STATE) {
        /* zlib header */ let header = $a81b0407d764b29f$var$Z_DEFLATED$2 + (s.w_bits - 8 << 4) << 8;
        let level_flags = -1;
        if (s.strategy >= $a81b0407d764b29f$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
        else if (s.level < 6) level_flags = 1;
        else if (s.level === 6) level_flags = 2;
        else level_flags = 3;
        header |= level_flags << 6;
        if (s.strstart !== 0) header |= $a81b0407d764b29f$var$PRESET_DICT;
        header += 31 - header % 31;
        $a81b0407d764b29f$var$putShortMSB(s, header);
        /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
            $a81b0407d764b29f$var$putShortMSB(s, strm.adler >>> 16);
            $a81b0407d764b29f$var$putShortMSB(s, strm.adler & 0xffff);
        }
        strm.adler = 1; // adler32(0L, Z_NULL, 0);
        s.status = $a81b0407d764b29f$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $a81b0407d764b29f$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $a81b0407d764b29f$var$Z_OK$3;
        }
    }
    //#ifdef GZIP
    if (s.status === $a81b0407d764b29f$var$GZIP_STATE) {
        /* gzip header */ strm.adler = 0; //crc32(0L, Z_NULL, 0);
        $a81b0407d764b29f$var$put_byte(s, 31);
        $a81b0407d764b29f$var$put_byte(s, 139);
        $a81b0407d764b29f$var$put_byte(s, 8);
        if (!s.gzhead) {
            $a81b0407d764b29f$var$put_byte(s, 0);
            $a81b0407d764b29f$var$put_byte(s, 0);
            $a81b0407d764b29f$var$put_byte(s, 0);
            $a81b0407d764b29f$var$put_byte(s, 0);
            $a81b0407d764b29f$var$put_byte(s, 0);
            $a81b0407d764b29f$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $a81b0407d764b29f$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $a81b0407d764b29f$var$put_byte(s, $a81b0407d764b29f$var$OS_CODE);
            s.status = $a81b0407d764b29f$var$BUSY_STATE;
            /* Compression must start with an empty pending buffer */ $a81b0407d764b29f$var$flush_pending(strm);
            if (s.pending !== 0) {
                s.last_flush = -1;
                return $a81b0407d764b29f$var$Z_OK$3;
            }
        } else {
            $a81b0407d764b29f$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
            $a81b0407d764b29f$var$put_byte(s, s.gzhead.time & 0xff);
            $a81b0407d764b29f$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
            $a81b0407d764b29f$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
            $a81b0407d764b29f$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
            $a81b0407d764b29f$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $a81b0407d764b29f$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $a81b0407d764b29f$var$put_byte(s, s.gzhead.os & 0xff);
            if (s.gzhead.extra && s.gzhead.extra.length) {
                $a81b0407d764b29f$var$put_byte(s, s.gzhead.extra.length & 0xff);
                $a81b0407d764b29f$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
            }
            if (s.gzhead.hcrc) strm.adler = $a81b0407d764b29f$var$crc32_1(strm.adler, s.pending_buf, s.pending, 0);
            s.gzindex = 0;
            s.status = $a81b0407d764b29f$var$EXTRA_STATE;
        }
    }
    if (s.status === $a81b0407d764b29f$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let left = (s.gzhead.extra.length & 0xffff) - s.gzindex;
            while(s.pending + left > s.pending_buf_size){
                let copy = s.pending_buf_size - s.pending;
                // zmemcpy(s.pending_buf + s.pending,
                //    s.gzhead.extra + s.gzindex, copy);
                s.pending_buf.set(s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy), s.pending);
                s.pending = s.pending_buf_size;
                //--- HCRC_UPDATE(beg) ---//
                if (s.gzhead.hcrc && s.pending > beg) strm.adler = $a81b0407d764b29f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                //---//
                s.gzindex += copy;
                $a81b0407d764b29f$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $a81b0407d764b29f$var$Z_OK$3;
                }
                beg = 0;
                left -= copy;
            }
            // JS specific: s.gzhead.extra may be TypedArray or Array for backward compatibility
            //              TypedArray.slice and TypedArray.from don't exist in IE10-IE11
            let gzhead_extra = new Uint8Array(s.gzhead.extra);
            // zmemcpy(s->pending_buf + s->pending,
            //     s->gzhead->extra + s->gzindex, left);
            s.pending_buf.set(gzhead_extra.subarray(s.gzindex, s.gzindex + left), s.pending);
            s.pending += left;
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $a81b0407d764b29f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $a81b0407d764b29f$var$NAME_STATE;
    }
    if (s.status === $a81b0407d764b29f$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $a81b0407d764b29f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $a81b0407d764b29f$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $a81b0407d764b29f$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $a81b0407d764b29f$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $a81b0407d764b29f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $a81b0407d764b29f$var$COMMENT_STATE;
    }
    if (s.status === $a81b0407d764b29f$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $a81b0407d764b29f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $a81b0407d764b29f$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $a81b0407d764b29f$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $a81b0407d764b29f$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $a81b0407d764b29f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
        //---//
        }
        s.status = $a81b0407d764b29f$var$HCRC_STATE;
    }
    if (s.status === $a81b0407d764b29f$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) {
                $a81b0407d764b29f$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $a81b0407d764b29f$var$Z_OK$3;
                }
            }
            $a81b0407d764b29f$var$put_byte(s, strm.adler & 0xff);
            $a81b0407d764b29f$var$put_byte(s, strm.adler >> 8 & 0xff);
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
        }
        s.status = $a81b0407d764b29f$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $a81b0407d764b29f$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $a81b0407d764b29f$var$Z_OK$3;
        }
    }
    //#endif
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $a81b0407d764b29f$var$Z_NO_FLUSH$2 && s.status !== $a81b0407d764b29f$var$FINISH_STATE) {
        let bstate = s.level === 0 ? $a81b0407d764b29f$var$deflate_stored(s, flush) : s.strategy === $a81b0407d764b29f$var$Z_HUFFMAN_ONLY ? $a81b0407d764b29f$var$deflate_huff(s, flush) : s.strategy === $a81b0407d764b29f$var$Z_RLE ? $a81b0407d764b29f$var$deflate_rle(s, flush) : $a81b0407d764b29f$var$configuration_table[s.level].func(s, flush);
        if (bstate === $a81b0407d764b29f$var$BS_FINISH_STARTED || bstate === $a81b0407d764b29f$var$BS_FINISH_DONE) s.status = $a81b0407d764b29f$var$FINISH_STATE;
        if (bstate === $a81b0407d764b29f$var$BS_NEED_MORE || bstate === $a81b0407d764b29f$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $a81b0407d764b29f$var$Z_OK$3;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $a81b0407d764b29f$var$BS_BLOCK_DONE) {
            if (flush === $a81b0407d764b29f$var$Z_PARTIAL_FLUSH) $a81b0407d764b29f$var$_tr_align(s);
            else if (flush !== $a81b0407d764b29f$var$Z_BLOCK$1) {
                $a81b0407d764b29f$var$_tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $a81b0407d764b29f$var$Z_FULL_FLUSH$1) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $a81b0407d764b29f$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $a81b0407d764b29f$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $a81b0407d764b29f$var$Z_OK$3;
            }
        }
    }
    if (flush !== $a81b0407d764b29f$var$Z_FINISH$3) return $a81b0407d764b29f$var$Z_OK$3;
    if (s.wrap <= 0) return $a81b0407d764b29f$var$Z_STREAM_END$3;
    /* Write the trailer */ if (s.wrap === 2) {
        $a81b0407d764b29f$var$put_byte(s, strm.adler & 0xff);
        $a81b0407d764b29f$var$put_byte(s, strm.adler >> 8 & 0xff);
        $a81b0407d764b29f$var$put_byte(s, strm.adler >> 16 & 0xff);
        $a81b0407d764b29f$var$put_byte(s, strm.adler >> 24 & 0xff);
        $a81b0407d764b29f$var$put_byte(s, strm.total_in & 0xff);
        $a81b0407d764b29f$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $a81b0407d764b29f$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $a81b0407d764b29f$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $a81b0407d764b29f$var$putShortMSB(s, strm.adler >>> 16);
        $a81b0407d764b29f$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $a81b0407d764b29f$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $a81b0407d764b29f$var$Z_OK$3 : $a81b0407d764b29f$var$Z_STREAM_END$3;
};
const $a81b0407d764b29f$var$deflateEnd = (strm)=>{
    if ($a81b0407d764b29f$var$deflateStateCheck(strm)) return $a81b0407d764b29f$var$Z_STREAM_ERROR$2;
    const status = strm.state.status;
    strm.state = null;
    return status === $a81b0407d764b29f$var$BUSY_STATE ? $a81b0407d764b29f$var$err(strm, $a81b0407d764b29f$var$Z_DATA_ERROR$2) : $a81b0407d764b29f$var$Z_OK$3;
};
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ const $a81b0407d764b29f$var$deflateSetDictionary = (strm, dictionary)=>{
    let dictLength = dictionary.length;
    if ($a81b0407d764b29f$var$deflateStateCheck(strm)) return $a81b0407d764b29f$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    const wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $a81b0407d764b29f$var$INIT_STATE || s.lookahead) return $a81b0407d764b29f$var$Z_STREAM_ERROR$2;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $a81b0407d764b29f$var$adler32_1(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $a81b0407d764b29f$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        let tmpDict = new Uint8Array(s.w_size);
        tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ const avail = strm.avail_in;
    const next = strm.next_in;
    const input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $a81b0407d764b29f$var$fill_window(s);
    while(s.lookahead >= $a81b0407d764b29f$var$MIN_MATCH){
        let str = s.strstart;
        let n = s.lookahead - ($a81b0407d764b29f$var$MIN_MATCH - 1);
        do {
            $a81b0407d764b29f$var$INSERT_STRING(s, str);
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $a81b0407d764b29f$var$MIN_MATCH - 1;
        $a81b0407d764b29f$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $a81b0407d764b29f$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $a81b0407d764b29f$var$Z_OK$3;
};
var $a81b0407d764b29f$var$deflateInit_1 = $a81b0407d764b29f$var$deflateInit;
var $a81b0407d764b29f$var$deflateInit2_1 = $a81b0407d764b29f$var$deflateInit2;
var $a81b0407d764b29f$var$deflateReset_1 = $a81b0407d764b29f$var$deflateReset;
var $a81b0407d764b29f$var$deflateResetKeep_1 = $a81b0407d764b29f$var$deflateResetKeep;
var $a81b0407d764b29f$var$deflateSetHeader_1 = $a81b0407d764b29f$var$deflateSetHeader;
var $a81b0407d764b29f$var$deflate_2$1 = $a81b0407d764b29f$var$deflate$2;
var $a81b0407d764b29f$var$deflateEnd_1 = $a81b0407d764b29f$var$deflateEnd;
var $a81b0407d764b29f$var$deflateSetDictionary_1 = $a81b0407d764b29f$var$deflateSetDictionary;
var $a81b0407d764b29f$var$deflateInfo = 'pako deflate (from Nodeca project)';
/* Not implemented
module.exports.deflateBound = deflateBound;
module.exports.deflateCopy = deflateCopy;
module.exports.deflateGetDictionary = deflateGetDictionary;
module.exports.deflateParams = deflateParams;
module.exports.deflatePending = deflatePending;
module.exports.deflatePrime = deflatePrime;
module.exports.deflateTune = deflateTune;
*/ var $a81b0407d764b29f$var$deflate_1$2 = {
    deflateInit: $a81b0407d764b29f$var$deflateInit_1,
    deflateInit2: $a81b0407d764b29f$var$deflateInit2_1,
    deflateReset: $a81b0407d764b29f$var$deflateReset_1,
    deflateResetKeep: $a81b0407d764b29f$var$deflateResetKeep_1,
    deflateSetHeader: $a81b0407d764b29f$var$deflateSetHeader_1,
    deflate: $a81b0407d764b29f$var$deflate_2$1,
    deflateEnd: $a81b0407d764b29f$var$deflateEnd_1,
    deflateSetDictionary: $a81b0407d764b29f$var$deflateSetDictionary_1,
    deflateInfo: $a81b0407d764b29f$var$deflateInfo
};
const $a81b0407d764b29f$var$_has = (obj, key)=>{
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var $a81b0407d764b29f$var$assign = function(obj /*from1, from2, from3, ...*/ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        const source = sources.shift();
        if (!source) continue;
        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
        for(const p in source)if ($a81b0407d764b29f$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// Join array of chunks to single array.
var $a81b0407d764b29f$var$flattenChunks = (chunks)=>{
    // calculate data length
    let len = 0;
    for(let i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
    // join chunks
    const result = new Uint8Array(len);
    for(let i = 0, pos = 0, l = chunks.length; i < l; i++){
        let chunk = chunks[i];
        result.set(chunk, pos);
        pos += chunk.length;
    }
    return result;
};
var $a81b0407d764b29f$var$common = {
    assign: $a81b0407d764b29f$var$assign,
    flattenChunks: $a81b0407d764b29f$var$flattenChunks
};
// String encode/decode helpers
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
let $a81b0407d764b29f$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $a81b0407d764b29f$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
const $a81b0407d764b29f$var$_utf8len = new Uint8Array(256);
for(let q = 0; q < 256; q++)$a81b0407d764b29f$var$_utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
$a81b0407d764b29f$var$_utf8len[254] = $a81b0407d764b29f$var$_utf8len[255] = 1; // Invalid sequence start
// convert string to array (typed, when possible)
var $a81b0407d764b29f$var$string2buf = (str)=>{
    if (typeof TextEncoder === 'function' && TextEncoder.prototype.encode) return new TextEncoder().encode(str);
    let buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new Uint8Array(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper
const $a81b0407d764b29f$var$buf2binstring = (buf, len)=>{
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $a81b0407d764b29f$var$STR_APPLY_UIA_OK) return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
    }
    let result = '';
    for(let i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
};
// convert array to string
var $a81b0407d764b29f$var$buf2string = (buf, max)=>{
    const len = max || buf.length;
    if (typeof TextDecoder === 'function' && TextDecoder.prototype.decode) return new TextDecoder().decode(buf.subarray(0, max));
    let i, out;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    const utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        let c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        let c_len = $a81b0407d764b29f$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $a81b0407d764b29f$var$buf2binstring(utf16buf, out);
};
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $a81b0407d764b29f$var$utf8border = (buf, max)=>{
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    let pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $a81b0407d764b29f$var$_utf8len[buf[pos]] > max ? pos : max;
};
var $a81b0407d764b29f$var$strings = {
    string2buf: $a81b0407d764b29f$var$string2buf,
    buf2string: $a81b0407d764b29f$var$buf2string,
    utf8border: $a81b0407d764b29f$var$utf8border
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $a81b0407d764b29f$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
var $a81b0407d764b29f$var$zstream = $a81b0407d764b29f$var$ZStream;
const $a81b0407d764b29f$var$toString$1 = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $a81b0407d764b29f$var$Z_NO_FLUSH$1, Z_SYNC_FLUSH: $a81b0407d764b29f$var$Z_SYNC_FLUSH, Z_FULL_FLUSH: $a81b0407d764b29f$var$Z_FULL_FLUSH, Z_FINISH: $a81b0407d764b29f$var$Z_FINISH$2, Z_OK: $a81b0407d764b29f$var$Z_OK$2, Z_STREAM_END: $a81b0407d764b29f$var$Z_STREAM_END$2, Z_DEFAULT_COMPRESSION: $a81b0407d764b29f$var$Z_DEFAULT_COMPRESSION, Z_DEFAULT_STRATEGY: $a81b0407d764b29f$var$Z_DEFAULT_STRATEGY, Z_DEFLATED: $a81b0407d764b29f$var$Z_DEFLATED$1 } = $a81b0407d764b29f$var$constants$2;
/* ===========================================================================*/ const $a81b0407d764b29f$var$defaultOptions$1 = {
    level: $a81b0407d764b29f$var$Z_DEFAULT_COMPRESSION,
    method: $a81b0407d764b29f$var$Z_DEFLATED$1,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: $a81b0407d764b29f$var$Z_DEFAULT_STRATEGY,
    legacyHash: true
};
/**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * - `legacyHash` (Boolean) - use the classic zlib hash (default), which matches
 *   canonical zlib output byte-for-byte. Set to `false` to use the faster
 *   ANZAC++ hash, which matches recent (chromium) node.js output instead.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $a81b0407d764b29f$var$Deflate$1(options) {
    this.options = $a81b0407d764b29f$var$common.assign({}, $a81b0407d764b29f$var$defaultOptions$1, options || {});
    let opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $a81b0407d764b29f$var$zstream();
    this.strm.avail_out = 0;
    let status = $a81b0407d764b29f$var$deflate_1$2.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy, opt.legacyHash);
    if (status !== $a81b0407d764b29f$var$Z_OK$2) throw new Error($a81b0407d764b29f$var$messages[status]);
    if (opt.header) $a81b0407d764b29f$var$deflate_1$2.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        let dict;
        // Convert data if needed
        if (typeof opt.dictionary === 'string') // If we need to compress text, change encoding to utf8.
        dict = $a81b0407d764b29f$var$strings.string2buf(opt.dictionary);
        else if ($a81b0407d764b29f$var$toString$1.call(opt.dictionary) === '[object ArrayBuffer]') dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $a81b0407d764b29f$var$deflate_1$2.deflateSetDictionary(this.strm, dict);
        if (status !== $a81b0407d764b29f$var$Z_OK$2) throw new Error($a81b0407d764b29f$var$messages[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must
 * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
 * buffers and call [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $a81b0407d764b29f$var$Deflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    let status, _flush_mode;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $a81b0407d764b29f$var$Z_FINISH$2 : $a81b0407d764b29f$var$Z_NO_FLUSH$1;
    // Convert data if needed
    if (typeof data === 'string') // If we need to compress text, change encoding to utf8.
    strm.input = $a81b0407d764b29f$var$strings.string2buf(data);
    else if ($a81b0407d764b29f$var$toString$1.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        // Make sure avail_out > 6 to avoid repeating markers
        if ((_flush_mode === $a81b0407d764b29f$var$Z_SYNC_FLUSH || _flush_mode === $a81b0407d764b29f$var$Z_FULL_FLUSH) && strm.avail_out <= 6) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        status = $a81b0407d764b29f$var$deflate_1$2.deflate(strm, _flush_mode);
        // Ended => flush and finish
        if (status === $a81b0407d764b29f$var$Z_STREAM_END$2) {
            if (strm.next_out > 0) this.onData(strm.output.subarray(0, strm.next_out));
            status = $a81b0407d764b29f$var$deflate_1$2.deflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return status === $a81b0407d764b29f$var$Z_OK$2;
        }
        // Flush if out buffer full
        if (strm.avail_out === 0) {
            this.onData(strm.output);
            continue;
        }
        // Flush if requested and has data
        if (_flush_mode > 0 && strm.next_out > 0) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array): output data.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $a81b0407d764b29f$var$Deflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $a81b0407d764b29f$var$Deflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $a81b0407d764b29f$var$Z_OK$2) this.result = $a81b0407d764b29f$var$common.flattenChunks(this.chunks);
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $a81b0407d764b29f$var$deflate$1(input, options) {
    const deflator = new $a81b0407d764b29f$var$Deflate$1(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $a81b0407d764b29f$var$messages[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $a81b0407d764b29f$var$deflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $a81b0407d764b29f$var$deflate$1(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $a81b0407d764b29f$var$gzip$1(input, options) {
    options = options || {};
    options.gzip = true;
    return $a81b0407d764b29f$var$deflate$1(input, options);
}
var $a81b0407d764b29f$var$Deflate_1$1 = $a81b0407d764b29f$var$Deflate$1;
var $a81b0407d764b29f$var$deflate_2 = $a81b0407d764b29f$var$deflate$1;
var $a81b0407d764b29f$var$deflateRaw_1$1 = $a81b0407d764b29f$var$deflateRaw$1;
var $a81b0407d764b29f$var$gzip_1$1 = $a81b0407d764b29f$var$gzip$1;
var $a81b0407d764b29f$var$constants$1 = $a81b0407d764b29f$var$constants$2;
var $a81b0407d764b29f$var$deflate_1$1 = {
    Deflate: $a81b0407d764b29f$var$Deflate_1$1,
    deflate: $a81b0407d764b29f$var$deflate_2,
    deflateRaw: $a81b0407d764b29f$var$deflateRaw_1$1,
    gzip: $a81b0407d764b29f$var$gzip_1$1,
    constants: $a81b0407d764b29f$var$constants$1
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
const $a81b0407d764b29f$var$BAD$1 = 16209; /* got a data error -- remain here until reset */ 
const $a81b0407d764b29f$var$TYPE$1 = 16191; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ var $a81b0407d764b29f$var$inffast = function inflate_fast(strm, start) {
    let _in; /* local strm.input */ 
    let last; /* have enough input while in < last */ 
    let _out; /* local strm.output */ 
    let beg; /* inflate()'s initial strm.output */ 
    let end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    let dmax; /* maximum distance from zlib header */ 
    //#endif
    let wsize; /* window size or zero if not using window */ 
    let whave; /* valid bytes in the window */ 
    let wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    let s_window; /* allocated sliding window, if wsize != 0 */ 
    let hold; /* local strm.hold */ 
    let bits; /* local strm.bits */ 
    let lcode; /* local strm.lencode */ 
    let dcode; /* local strm.distcode */ 
    let lmask; /* mask for first level of length codes */ 
    let dmask; /* mask for first level of distance codes */ 
    let here; /* retrieved table entry */ 
    let op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ let len; /* match length, unused bytes */ 
    let dist; /* match distance */ 
    let from; /* where to copy match from */ 
    let from_source;
    let input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ const state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = 'invalid distance too far back';
                            state.mode = $a81b0407d764b29f$var$BAD$1;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = 'invalid distance too far back';
                                    state.mode = $a81b0407d764b29f$var$BAD$1;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = 'invalid distance code';
                        state.mode = $a81b0407d764b29f$var$BAD$1;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $a81b0407d764b29f$var$TYPE$1;
                break top;
            } else {
                strm.msg = 'invalid literal/length code';
                state.mode = $a81b0407d764b29f$var$BAD$1;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $a81b0407d764b29f$var$MAXBITS = 15;
const $a81b0407d764b29f$var$ENOUGH_LENS$1 = 852;
const $a81b0407d764b29f$var$ENOUGH_DISTS$1 = 592;
//const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
const $a81b0407d764b29f$var$CODES$1 = 0;
const $a81b0407d764b29f$var$LENS$1 = 1;
const $a81b0407d764b29f$var$DISTS$1 = 2;
const $a81b0407d764b29f$var$lbase = new Uint16Array([
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
]);
const $a81b0407d764b29f$var$lext = new Uint8Array([
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    199,
    75
]);
const $a81b0407d764b29f$var$dbase = new Uint16Array([
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
]);
const $a81b0407d764b29f$var$dext = new Uint8Array([
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
]);
const $a81b0407d764b29f$var$inflate_table = (type, lens, lens_index, codes, table, table_index, work, opts)=>{
    const bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    let len = 0; /* a code's length in bits */ 
    let sym = 0; /* index of code symbols */ 
    let min = 0, max = 0; /* minimum and maximum code lengths */ 
    let root = 0; /* number of index bits for root table */ 
    let curr = 0; /* number of index bits for current table */ 
    let drop = 0; /* code bits to drop for sub-table */ 
    let left = 0; /* number of prefix codes available */ 
    let used = 0; /* code entries in table used */ 
    let huff = 0; /* Huffman code */ 
    let incr; /* for incrementing code, index */ 
    let fill; /* index for replicating entries */ 
    let low; /* low bits for current root entry */ 
    let mask; /* mask for low root bits */ 
    let next; /* next available space in table */ 
    let base = null; /* base value table to use */ 
    //  let shoextra;    /* extra bits table to use */
    let match; /* use base and extra for symbol >= match */ 
    const count = new Uint16Array($a81b0407d764b29f$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    const offs = new Uint16Array($a81b0407d764b29f$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    let extra = null;
    let here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $a81b0407d764b29f$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $a81b0407d764b29f$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $a81b0407d764b29f$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $a81b0407d764b29f$var$CODES$1 || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $a81b0407d764b29f$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $a81b0407d764b29f$var$CODES$1) {
        base = extra = work; /* dummy value--not used */ 
        match = 20;
    } else if (type === $a81b0407d764b29f$var$LENS$1) {
        base = $a81b0407d764b29f$var$lbase;
        extra = $a81b0407d764b29f$var$lext;
        match = 257;
    } else {
        base = $a81b0407d764b29f$var$dbase;
        extra = $a81b0407d764b29f$var$dext;
        match = 0;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $a81b0407d764b29f$var$LENS$1 && used > $a81b0407d764b29f$var$ENOUGH_LENS$1 || type === $a81b0407d764b29f$var$DISTS$1 && used > $a81b0407d764b29f$var$ENOUGH_DISTS$1) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] + 1 < match) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] >= match) {
            here_op = extra[work[sym] - match];
            here_val = base[work[sym] - match];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $a81b0407d764b29f$var$LENS$1 && used > $a81b0407d764b29f$var$ENOUGH_LENS$1 || type === $a81b0407d764b29f$var$DISTS$1 && used > $a81b0407d764b29f$var$ENOUGH_DISTS$1) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};
var $a81b0407d764b29f$var$inftrees = $a81b0407d764b29f$var$inflate_table;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $a81b0407d764b29f$var$CODES = 0;
const $a81b0407d764b29f$var$LENS = 1;
const $a81b0407d764b29f$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_FINISH: $a81b0407d764b29f$var$Z_FINISH$1, Z_BLOCK: $a81b0407d764b29f$var$Z_BLOCK, Z_TREES: $a81b0407d764b29f$var$Z_TREES, Z_OK: $a81b0407d764b29f$var$Z_OK$1, Z_STREAM_END: $a81b0407d764b29f$var$Z_STREAM_END$1, Z_NEED_DICT: $a81b0407d764b29f$var$Z_NEED_DICT$1, Z_STREAM_ERROR: $a81b0407d764b29f$var$Z_STREAM_ERROR$1, Z_DATA_ERROR: $a81b0407d764b29f$var$Z_DATA_ERROR$1, Z_MEM_ERROR: $a81b0407d764b29f$var$Z_MEM_ERROR$1, Z_BUF_ERROR: $a81b0407d764b29f$var$Z_BUF_ERROR$1, Z_DEFLATED: $a81b0407d764b29f$var$Z_DEFLATED } = $a81b0407d764b29f$var$constants$2;
/* STATES ====================================================================*/ /* ===========================================================================*/ const $a81b0407d764b29f$var$HEAD = 16180; /* i: waiting for magic header */ 
const $a81b0407d764b29f$var$FLAGS = 16181; /* i: waiting for method and flags (gzip) */ 
const $a81b0407d764b29f$var$TIME = 16182; /* i: waiting for modification time (gzip) */ 
const $a81b0407d764b29f$var$OS = 16183; /* i: waiting for extra flags and operating system (gzip) */ 
const $a81b0407d764b29f$var$EXLEN = 16184; /* i: waiting for extra length (gzip) */ 
const $a81b0407d764b29f$var$EXTRA = 16185; /* i: waiting for extra bytes (gzip) */ 
const $a81b0407d764b29f$var$NAME = 16186; /* i: waiting for end of file name (gzip) */ 
const $a81b0407d764b29f$var$COMMENT = 16187; /* i: waiting for end of comment (gzip) */ 
const $a81b0407d764b29f$var$HCRC = 16188; /* i: waiting for header crc (gzip) */ 
const $a81b0407d764b29f$var$DICTID = 16189; /* i: waiting for dictionary check value */ 
const $a81b0407d764b29f$var$DICT = 16190; /* waiting for inflateSetDictionary() call */ 
const $a81b0407d764b29f$var$TYPE = 16191; /* i: waiting for type bits, including last-flag bit */ 
const $a81b0407d764b29f$var$TYPEDO = 16192; /* i: same, but skip check to exit inflate on new block */ 
const $a81b0407d764b29f$var$STORED = 16193; /* i: waiting for stored size (length and complement) */ 
const $a81b0407d764b29f$var$COPY_ = 16194; /* i/o: same as COPY below, but only first time in */ 
const $a81b0407d764b29f$var$COPY = 16195; /* i/o: waiting for input or output to copy stored block */ 
const $a81b0407d764b29f$var$TABLE = 16196; /* i: waiting for dynamic block table lengths */ 
const $a81b0407d764b29f$var$LENLENS = 16197; /* i: waiting for code length code lengths */ 
const $a81b0407d764b29f$var$CODELENS = 16198; /* i: waiting for length/lit and distance code lengths */ 
const $a81b0407d764b29f$var$LEN_ = 16199; /* i: same as LEN below, but only first time in */ 
const $a81b0407d764b29f$var$LEN = 16200; /* i: waiting for length/lit/eob code */ 
const $a81b0407d764b29f$var$LENEXT = 16201; /* i: waiting for length extra bits */ 
const $a81b0407d764b29f$var$DIST = 16202; /* i: waiting for distance code */ 
const $a81b0407d764b29f$var$DISTEXT = 16203; /* i: waiting for distance extra bits */ 
const $a81b0407d764b29f$var$MATCH = 16204; /* o: waiting for output space to copy string */ 
const $a81b0407d764b29f$var$LIT = 16205; /* o: waiting for output space to write literal */ 
const $a81b0407d764b29f$var$CHECK = 16206; /* i: waiting for 32-bit check value */ 
const $a81b0407d764b29f$var$LENGTH = 16207; /* i: waiting for 32-bit length (gzip) */ 
const $a81b0407d764b29f$var$DONE = 16208; /* finished check, done -- remain here until reset */ 
const $a81b0407d764b29f$var$BAD = 16209; /* got a data error -- remain here until reset */ 
const $a81b0407d764b29f$var$MEM = 16210; /* got an inflate() memory error -- remain here until reset */ 
const $a81b0407d764b29f$var$SYNC = 16211; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ const $a81b0407d764b29f$var$ENOUGH_LENS = 852;
const $a81b0407d764b29f$var$ENOUGH_DISTS = 592;
//const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
const $a81b0407d764b29f$var$MAX_WBITS = 15;
/* 32K LZ77 window */ const $a81b0407d764b29f$var$DEF_WBITS = $a81b0407d764b29f$var$MAX_WBITS;
const $a81b0407d764b29f$var$zswap32 = (q)=>{
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
};
function $a81b0407d764b29f$var$InflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip,
                                 bit 2 true to validate check value */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib), or
                                 -1 if raw or no header yet */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new Uint16Array(320); /* temporary storage for code lengths */ 
    this.work = new Uint16Array(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
const $a81b0407d764b29f$var$inflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const state = strm.state;
    if (!state || state.strm !== strm || state.mode < $a81b0407d764b29f$var$HEAD || state.mode > $a81b0407d764b29f$var$SYNC) return 1;
    return 0;
};
const $a81b0407d764b29f$var$inflateResetKeep = (strm)=>{
    if ($a81b0407d764b29f$var$inflateStateCheck(strm)) return $a81b0407d764b29f$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ''; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $a81b0407d764b29f$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.flags = -1;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new Int32Array($a81b0407d764b29f$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new Int32Array($a81b0407d764b29f$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $a81b0407d764b29f$var$Z_OK$1;
};
const $a81b0407d764b29f$var$inflateReset = (strm)=>{
    if ($a81b0407d764b29f$var$inflateStateCheck(strm)) return $a81b0407d764b29f$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $a81b0407d764b29f$var$inflateResetKeep(strm);
};
const $a81b0407d764b29f$var$inflateReset2 = (strm, windowBits)=>{
    let wrap;
    /* get the state */ if ($a81b0407d764b29f$var$inflateStateCheck(strm)) return $a81b0407d764b29f$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 5;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $a81b0407d764b29f$var$Z_STREAM_ERROR$1;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $a81b0407d764b29f$var$inflateReset(strm);
};
const $a81b0407d764b29f$var$inflateInit2 = (strm, windowBits)=>{
    if (!strm) return $a81b0407d764b29f$var$Z_STREAM_ERROR$1;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    const state = new $a81b0407d764b29f$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.strm = strm;
    state.window = null /*Z_NULL*/ ;
    state.mode = $a81b0407d764b29f$var$HEAD; /* to pass state test in inflateReset2() */ 
    const ret = $a81b0407d764b29f$var$inflateReset2(strm, windowBits);
    if (ret !== $a81b0407d764b29f$var$Z_OK$1) strm.state = null /*Z_NULL*/ ;
    return ret;
};
const $a81b0407d764b29f$var$inflateInit = (strm)=>{
    return $a81b0407d764b29f$var$inflateInit2(strm, $a81b0407d764b29f$var$DEF_WBITS);
};
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ let $a81b0407d764b29f$var$virgin = true;
let $a81b0407d764b29f$var$lenfix, $a81b0407d764b29f$var$distfix; // We have no pointers in JS, so keep tables separate
const $a81b0407d764b29f$var$fixedtables = (state)=>{
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($a81b0407d764b29f$var$virgin) {
        $a81b0407d764b29f$var$lenfix = new Int32Array(512);
        $a81b0407d764b29f$var$distfix = new Int32Array(32);
        /* literal/length table */ let sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $a81b0407d764b29f$var$inftrees($a81b0407d764b29f$var$LENS, state.lens, 0, 288, $a81b0407d764b29f$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $a81b0407d764b29f$var$inftrees($a81b0407d764b29f$var$DISTS, state.lens, 0, 32, $a81b0407d764b29f$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $a81b0407d764b29f$var$virgin = false;
    }
    state.lencode = $a81b0407d764b29f$var$lenfix;
    state.lenbits = 9;
    state.distcode = $a81b0407d764b29f$var$distfix;
    state.distbits = 5;
};
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ const $a81b0407d764b29f$var$updatewindow = (strm, src, end, copy)=>{
    let dist;
    const state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) state.window = new Uint8Array(1 << state.wbits);
    /* if window not in use yet, initialize */ if (state.wsize === 0) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        state.window.set(src.subarray(end - state.wsize, end), 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            state.window.set(src.subarray(end - copy, end), 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
};
const $a81b0407d764b29f$var$inflate$2 = (strm, flush)=>{
    let state;
    let input, output; // input/output buffers
    let next; /* next input INDEX */ 
    let put; /* next output INDEX */ 
    let have, left; /* available input and output */ 
    let hold; /* bit buffer */ 
    let bits; /* bits in bit buffer */ 
    let _in, _out; /* save starting available input and output */ 
    let copy; /* number of stored or match bytes to copy */ 
    let from; /* where to copy match bytes from */ 
    let from_source;
    let here = 0; /* current decoding table entry */ 
    let here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //let last;                   /* parent table entry */
    let last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    let len; /* length to copy for repeats, bits to drop */ 
    let ret; /* return code */ 
    const hbuf = new Uint8Array(4); /* buffer for gzip header crc calculation */ 
    let opts;
    let n; // temporary variable for NEED_BITS
    const order = /* permutation of code lengths */ new Uint8Array([
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ]);
    if ($a81b0407d764b29f$var$inflateStateCheck(strm) || !strm.output || !strm.input && strm.avail_in !== 0) return $a81b0407d764b29f$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.mode === $a81b0407d764b29f$var$TYPE) state.mode = $a81b0407d764b29f$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $a81b0407d764b29f$var$Z_OK$1;
    inf_leave: for(;;)switch(state.mode){
        case $a81b0407d764b29f$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $a81b0407d764b29f$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                if (state.wbits === 0) state.wbits = 15;
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $a81b0407d764b29f$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $a81b0407d764b29f$var$FLAGS;
                break;
            }
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = $a81b0407d764b29f$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $a81b0407d764b29f$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $a81b0407d764b29f$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            if (len > 15 || len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = $a81b0407d764b29f$var$BAD;
                break;
            }
            // !!! pako patch. Force use `options.windowBits` if passed.
            // Required to always use max window size by default.
            state.dmax = 1 << state.wbits;
            //state.dmax = 1 << len;
            state.flags = 0; /* indicate zlib header */ 
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $a81b0407d764b29f$var$DICTID : $a81b0407d764b29f$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $a81b0407d764b29f$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $a81b0407d764b29f$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $a81b0407d764b29f$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = $a81b0407d764b29f$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $a81b0407d764b29f$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $a81b0407d764b29f$var$TIME;
        /* falls through */ case $a81b0407d764b29f$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $a81b0407d764b29f$var$crc32_1(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $a81b0407d764b29f$var$OS;
        /* falls through */ case $a81b0407d764b29f$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $a81b0407d764b29f$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $a81b0407d764b29f$var$EXLEN;
        /* falls through */ case $a81b0407d764b29f$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200 && state.wrap & 4) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $a81b0407d764b29f$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $a81b0407d764b29f$var$EXTRA;
        /* falls through */ case $a81b0407d764b29f$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Uint8Array(state.head.extra_len);
                        state.head.extra.set(input.subarray(next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        next + copy), /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200 && state.wrap & 4) state.check = $a81b0407d764b29f$var$crc32_1(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $a81b0407d764b29f$var$NAME;
        /* falls through */ case $a81b0407d764b29f$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $a81b0407d764b29f$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $a81b0407d764b29f$var$COMMENT;
        /* falls through */ case $a81b0407d764b29f$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $a81b0407d764b29f$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $a81b0407d764b29f$var$HCRC;
        /* falls through */ case $a81b0407d764b29f$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.check & 0xffff)) {
                    strm.msg = 'header crc mismatch';
                    state.mode = $a81b0407d764b29f$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $a81b0407d764b29f$var$TYPE;
            break;
        case $a81b0407d764b29f$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $a81b0407d764b29f$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $a81b0407d764b29f$var$DICT;
        /* falls through */ case $a81b0407d764b29f$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $a81b0407d764b29f$var$Z_NEED_DICT$1;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $a81b0407d764b29f$var$TYPE;
        /* falls through */ case $a81b0407d764b29f$var$TYPE:
            if (flush === $a81b0407d764b29f$var$Z_BLOCK || flush === $a81b0407d764b29f$var$Z_TREES) break inf_leave;
        /* falls through */ case $a81b0407d764b29f$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $a81b0407d764b29f$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $a81b0407d764b29f$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $a81b0407d764b29f$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $a81b0407d764b29f$var$LEN_; /* decode codes */ 
                    if (flush === $a81b0407d764b29f$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $a81b0407d764b29f$var$TABLE;
                    break;
                case 3:
                    strm.msg = 'invalid block type';
                    state.mode = $a81b0407d764b29f$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $a81b0407d764b29f$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = $a81b0407d764b29f$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $a81b0407d764b29f$var$COPY_;
            if (flush === $a81b0407d764b29f$var$Z_TREES) break inf_leave;
        /* falls through */ case $a81b0407d764b29f$var$COPY_:
            state.mode = $a81b0407d764b29f$var$COPY;
        /* falls through */ case $a81b0407d764b29f$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                output.set(input.subarray(next, next + copy), put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $a81b0407d764b29f$var$TYPE;
            break;
        case $a81b0407d764b29f$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = $a81b0407d764b29f$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $a81b0407d764b29f$var$LENLENS;
        /* falls through */ case $a81b0407d764b29f$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $a81b0407d764b29f$var$inftrees($a81b0407d764b29f$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = $a81b0407d764b29f$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $a81b0407d764b29f$var$CODELENS;
        /* falls through */ case $a81b0407d764b29f$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = 'invalid bit length repeat';
                            state.mode = $a81b0407d764b29f$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = 'invalid bit length repeat';
                        state.mode = $a81b0407d764b29f$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $a81b0407d764b29f$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = $a81b0407d764b29f$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $a81b0407d764b29f$var$inftrees($a81b0407d764b29f$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = $a81b0407d764b29f$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $a81b0407d764b29f$var$inftrees($a81b0407d764b29f$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = $a81b0407d764b29f$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $a81b0407d764b29f$var$LEN_;
            if (flush === $a81b0407d764b29f$var$Z_TREES) break inf_leave;
        /* falls through */ case $a81b0407d764b29f$var$LEN_:
            state.mode = $a81b0407d764b29f$var$LEN;
        /* falls through */ case $a81b0407d764b29f$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $a81b0407d764b29f$var$inffast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $a81b0407d764b29f$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $a81b0407d764b29f$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $a81b0407d764b29f$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = $a81b0407d764b29f$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $a81b0407d764b29f$var$LENEXT;
        /* falls through */ case $a81b0407d764b29f$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $a81b0407d764b29f$var$DIST;
        /* falls through */ case $a81b0407d764b29f$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = $a81b0407d764b29f$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $a81b0407d764b29f$var$DISTEXT;
        /* falls through */ case $a81b0407d764b29f$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = $a81b0407d764b29f$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $a81b0407d764b29f$var$MATCH;
        /* falls through */ case $a81b0407d764b29f$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = $a81b0407d764b29f$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $a81b0407d764b29f$var$LEN;
            break;
        case $a81b0407d764b29f$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $a81b0407d764b29f$var$LEN;
            break;
        case $a81b0407d764b29f$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/ state.flags ? $a81b0407d764b29f$var$crc32_1(state.check, output, _out, put - _out) : $a81b0407d764b29f$var$adler32_1(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if (state.wrap & 4 && (state.flags ? hold : $a81b0407d764b29f$var$zswap32(hold)) !== state.check) {
                    strm.msg = 'incorrect data check';
                    state.mode = $a81b0407d764b29f$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $a81b0407d764b29f$var$LENGTH;
        /* falls through */ case $a81b0407d764b29f$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.total & 0xffffffff)) {
                    strm.msg = 'incorrect length check';
                    state.mode = $a81b0407d764b29f$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $a81b0407d764b29f$var$DONE;
        /* falls through */ case $a81b0407d764b29f$var$DONE:
            ret = $a81b0407d764b29f$var$Z_STREAM_END$1;
            break inf_leave;
        case $a81b0407d764b29f$var$BAD:
            ret = $a81b0407d764b29f$var$Z_DATA_ERROR$1;
            break inf_leave;
        case $a81b0407d764b29f$var$MEM:
            return $a81b0407d764b29f$var$Z_MEM_ERROR$1;
        case $a81b0407d764b29f$var$SYNC:
        /* falls through */ default:
            return $a81b0407d764b29f$var$Z_STREAM_ERROR$1;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $a81b0407d764b29f$var$BAD && (state.mode < $a81b0407d764b29f$var$CHECK || flush !== $a81b0407d764b29f$var$Z_FINISH$1)) $a81b0407d764b29f$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out);
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/ state.flags ? $a81b0407d764b29f$var$crc32_1(state.check, output, _out, strm.next_out - _out) : $a81b0407d764b29f$var$adler32_1(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $a81b0407d764b29f$var$TYPE ? 128 : 0) + (state.mode === $a81b0407d764b29f$var$LEN_ || state.mode === $a81b0407d764b29f$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $a81b0407d764b29f$var$Z_FINISH$1) && ret === $a81b0407d764b29f$var$Z_OK$1) ret = $a81b0407d764b29f$var$Z_BUF_ERROR$1;
    return ret;
};
const $a81b0407d764b29f$var$inflateEnd = (strm)=>{
    if ($a81b0407d764b29f$var$inflateStateCheck(strm)) return $a81b0407d764b29f$var$Z_STREAM_ERROR$1;
    let state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $a81b0407d764b29f$var$Z_OK$1;
};
const $a81b0407d764b29f$var$inflateGetHeader = (strm, head)=>{
    /* check state */ if ($a81b0407d764b29f$var$inflateStateCheck(strm)) return $a81b0407d764b29f$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    if ((state.wrap & 2) === 0) return $a81b0407d764b29f$var$Z_STREAM_ERROR$1;
    /* save header structure */ state.head = head;
    head.done = false;
    return $a81b0407d764b29f$var$Z_OK$1;
};
const $a81b0407d764b29f$var$inflateSetDictionary = (strm, dictionary)=>{
    const dictLength = dictionary.length;
    let state;
    let dictid;
    let ret;
    /* check state */ if ($a81b0407d764b29f$var$inflateStateCheck(strm)) return $a81b0407d764b29f$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $a81b0407d764b29f$var$DICT) return $a81b0407d764b29f$var$Z_STREAM_ERROR$1;
    /* check for correct dictionary identifier */ if (state.mode === $a81b0407d764b29f$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $a81b0407d764b29f$var$adler32_1(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $a81b0407d764b29f$var$Z_DATA_ERROR$1;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $a81b0407d764b29f$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $a81b0407d764b29f$var$MEM;
        return $a81b0407d764b29f$var$Z_MEM_ERROR$1;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $a81b0407d764b29f$var$Z_OK$1;
};
var $a81b0407d764b29f$var$inflateReset_1 = $a81b0407d764b29f$var$inflateReset;
var $a81b0407d764b29f$var$inflateReset2_1 = $a81b0407d764b29f$var$inflateReset2;
var $a81b0407d764b29f$var$inflateResetKeep_1 = $a81b0407d764b29f$var$inflateResetKeep;
var $a81b0407d764b29f$var$inflateInit_1 = $a81b0407d764b29f$var$inflateInit;
var $a81b0407d764b29f$var$inflateInit2_1 = $a81b0407d764b29f$var$inflateInit2;
var $a81b0407d764b29f$var$inflate_2$1 = $a81b0407d764b29f$var$inflate$2;
var $a81b0407d764b29f$var$inflateEnd_1 = $a81b0407d764b29f$var$inflateEnd;
var $a81b0407d764b29f$var$inflateGetHeader_1 = $a81b0407d764b29f$var$inflateGetHeader;
var $a81b0407d764b29f$var$inflateSetDictionary_1 = $a81b0407d764b29f$var$inflateSetDictionary;
var $a81b0407d764b29f$var$inflateInfo = 'pako inflate (from Nodeca project)';
/* Not implemented
module.exports.inflateCodesUsed = inflateCodesUsed;
module.exports.inflateCopy = inflateCopy;
module.exports.inflateGetDictionary = inflateGetDictionary;
module.exports.inflateMark = inflateMark;
module.exports.inflatePrime = inflatePrime;
module.exports.inflateSync = inflateSync;
module.exports.inflateSyncPoint = inflateSyncPoint;
module.exports.inflateUndermine = inflateUndermine;
module.exports.inflateValidate = inflateValidate;
*/ var $a81b0407d764b29f$var$inflate_1$2 = {
    inflateReset: $a81b0407d764b29f$var$inflateReset_1,
    inflateReset2: $a81b0407d764b29f$var$inflateReset2_1,
    inflateResetKeep: $a81b0407d764b29f$var$inflateResetKeep_1,
    inflateInit: $a81b0407d764b29f$var$inflateInit_1,
    inflateInit2: $a81b0407d764b29f$var$inflateInit2_1,
    inflate: $a81b0407d764b29f$var$inflate_2$1,
    inflateEnd: $a81b0407d764b29f$var$inflateEnd_1,
    inflateGetHeader: $a81b0407d764b29f$var$inflateGetHeader_1,
    inflateSetDictionary: $a81b0407d764b29f$var$inflateSetDictionary_1,
    inflateInfo: $a81b0407d764b29f$var$inflateInfo
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $a81b0407d764b29f$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = '';
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = '';
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
var $a81b0407d764b29f$var$gzheader = $a81b0407d764b29f$var$GZheader;
const $a81b0407d764b29f$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $a81b0407d764b29f$var$Z_NO_FLUSH, Z_FINISH: $a81b0407d764b29f$var$Z_FINISH, Z_OK: $a81b0407d764b29f$var$Z_OK, Z_STREAM_END: $a81b0407d764b29f$var$Z_STREAM_END, Z_NEED_DICT: $a81b0407d764b29f$var$Z_NEED_DICT, Z_STREAM_ERROR: $a81b0407d764b29f$var$Z_STREAM_ERROR, Z_DATA_ERROR: $a81b0407d764b29f$var$Z_DATA_ERROR, Z_MEM_ERROR: $a81b0407d764b29f$var$Z_MEM_ERROR, Z_BUF_ERROR: $a81b0407d764b29f$var$Z_BUF_ERROR } = $a81b0407d764b29f$var$constants$2;
/* ===========================================================================*/ const $a81b0407d764b29f$var$defaultOptions = {
    chunkSize: 65536,
    windowBits: 15,
    to: ''
};
/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $a81b0407d764b29f$var$Inflate$1(options) {
    this.options = $a81b0407d764b29f$var$common.assign({}, $a81b0407d764b29f$var$defaultOptions, options || {});
    const opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $a81b0407d764b29f$var$zstream();
    this.strm.avail_out = 0;
    let status = $a81b0407d764b29f$var$inflate_1$2.inflateInit2(this.strm, opt.windowBits);
    if (status !== $a81b0407d764b29f$var$Z_OK) throw new Error($a81b0407d764b29f$var$messages[status]);
    this.header = new $a81b0407d764b29f$var$gzheader();
    $a81b0407d764b29f$var$inflate_1$2.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === 'string') opt.dictionary = $a81b0407d764b29f$var$strings.string2buf(opt.dictionary);
        else if ($a81b0407d764b29f$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $a81b0407d764b29f$var$inflate_1$2.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $a81b0407d764b29f$var$Z_OK) throw new Error($a81b0407d764b29f$var$messages[status]);
        }
    }
}
/**
 * Inflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer): input data
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
 *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
 *   `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. If end of stream detected,
 * [[Inflate#onEnd]] will be called.
 *
 * `flush_mode` is not needed for normal operation, because end of stream
 * detected automatically. You may try to use it for advanced things, but
 * this functionality was not tested.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $a81b0407d764b29f$var$Inflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    const dictionary = this.options.dictionary;
    let status, _flush_mode, last_avail_out;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $a81b0407d764b29f$var$Z_FINISH : $a81b0407d764b29f$var$Z_NO_FLUSH;
    // Convert data if needed
    if ($a81b0407d764b29f$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $a81b0407d764b29f$var$inflate_1$2.inflate(strm, _flush_mode);
        if (status === $a81b0407d764b29f$var$Z_NEED_DICT && dictionary) {
            status = $a81b0407d764b29f$var$inflate_1$2.inflateSetDictionary(strm, dictionary);
            if (status === $a81b0407d764b29f$var$Z_OK) status = $a81b0407d764b29f$var$inflate_1$2.inflate(strm, _flush_mode);
            else if (status === $a81b0407d764b29f$var$Z_DATA_ERROR) // Replace code with more verbose
            status = $a81b0407d764b29f$var$Z_NEED_DICT;
        }
        // Only the gzip format defines concatenated members (RFC 1952: a gzip file
        // is "a series of members"). A zlib stream (RFC 1950) ends after its
        // ADLER32, and a raw DEFLATE stream (RFC 1951) ends after its final block -
        // neither format allows anything to follow, so bytes after the end are not
        // ours to interpret and must be left in the input. Restart decoding only
        // for a gzip member: `state.flags` is non-zero only once a gzip header has
        // actually been decoded (it stays 0 for a zlib member, even when the format
        // was auto-detected and the gzip bit of `wrap` is set). A trailing zero
        // byte is padding, not the start of a member (no member can begin with 0).
        while(strm.avail_in > 0 && status === $a81b0407d764b29f$var$Z_STREAM_END && strm.state.wrap & 2 && strm.state.flags !== 0 && strm.input[strm.next_in] !== 0){
            $a81b0407d764b29f$var$inflate_1$2.inflateReset(strm);
            status = $a81b0407d764b29f$var$inflate_1$2.inflate(strm, _flush_mode);
        }
        switch(status){
            case $a81b0407d764b29f$var$Z_STREAM_ERROR:
            case $a81b0407d764b29f$var$Z_DATA_ERROR:
            case $a81b0407d764b29f$var$Z_NEED_DICT:
            case $a81b0407d764b29f$var$Z_MEM_ERROR:
                this.onEnd(status);
                this.ended = true;
                return false;
        }
        // Remember real `avail_out` value, because we may patch out buffer content
        // to align utf8 strings boundaries.
        last_avail_out = strm.avail_out;
        if (strm.next_out) // Flush output if buffer is full, stream ended, or an explicit flush was
        // requested (e.g. Z_SYNC_FLUSH) - to push out the tail, same as node's zlib.
        {
            if (strm.avail_out === 0 || status === $a81b0407d764b29f$var$Z_STREAM_END || _flush_mode > 0) {
                if (this.options.to === 'string') {
                    let next_out_utf8 = $a81b0407d764b29f$var$strings.utf8border(strm.output, strm.next_out);
                    let tail = strm.next_out - next_out_utf8;
                    let utf8str = $a81b0407d764b29f$var$strings.buf2string(strm.output, next_out_utf8);
                    // move tail & realign counters
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);
                    this.onData(utf8str);
                } else {
                    this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
                    // Force a fresh output buffer on next iteration / next push, so the
                    // already emitted tail is not sent again.
                    strm.avail_out = 0;
                    strm.next_out = 0;
                }
            }
        }
        // A full output buffer means there may be more to produce - allocate a new
        // one and call inflate again. The status depends on the flush mode: with
        // Z_NO_FLUSH a full buffer is reported as Z_OK, but with Z_FINISH the same
        // situation is reported as Z_BUF_ERROR ("could not make progress now",
        // non-fatal) even though output is still pending. Both must continue; the
        // distinction that matters is purely "was the output buffer exhausted".
        if ((status === $a81b0407d764b29f$var$Z_OK || status === $a81b0407d764b29f$var$Z_BUF_ERROR) && last_avail_out === 0) continue;
        // Finalize if end of stream reached.
        if (status === $a81b0407d764b29f$var$Z_STREAM_END) {
            status = $a81b0407d764b29f$var$inflate_1$2.inflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return true;
        }
        if (strm.avail_in === 0) {
            // Input is exhausted. If the caller declared this the end of the stream
            // (Z_FINISH) but we never saw Z_STREAM_END, the compressed data ended
            // before its terminating marker - i.e. it is truncated/incomplete. That
            // is an error: returning the partial output as success would be
            // indistinguishable from a complete decode, hiding the data loss. Report
            // it via Z_BUF_ERROR. (Reached only when the output buffer still had room
            // - a full buffer is handled by the `continue` above - so this genuinely
            // means "ran out of input", not "ran out of output".)
            if (_flush_mode === $a81b0407d764b29f$var$Z_FINISH) {
                status = $a81b0407d764b29f$var$inflate_1$2.inflateEnd(this.strm);
                this.onEnd(status === $a81b0407d764b29f$var$Z_OK ? $a81b0407d764b29f$var$Z_BUF_ERROR : status);
                this.ended = true;
                return false;
            }
            break;
        }
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|String): output data. When string output requested,
 *   each chunk will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $a81b0407d764b29f$var$Inflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $a81b0407d764b29f$var$Inflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $a81b0407d764b29f$var$Z_OK) {
        if (this.options.to === 'string') this.result = this.chunks.join('');
        else this.result = $a81b0407d764b29f$var$common.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako');
 * const input = pako.deflate(new Uint8Array([1,2,3,4,5,6,7,8,9]));
 * let output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err) {
 *   console.log(err);
 * }
 * ```
 **/ function $a81b0407d764b29f$var$inflate$1(input, options) {
    const inflator = new $a81b0407d764b29f$var$Inflate$1(options);
    inflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $a81b0407d764b29f$var$messages[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $a81b0407d764b29f$var$inflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $a81b0407d764b29f$var$inflate$1(input, options);
}
/**
 * ungzip(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $a81b0407d764b29f$var$Inflate_1$1 = $a81b0407d764b29f$var$Inflate$1;
var $a81b0407d764b29f$var$inflate_2 = $a81b0407d764b29f$var$inflate$1;
var $a81b0407d764b29f$var$inflateRaw_1$1 = $a81b0407d764b29f$var$inflateRaw$1;
var $a81b0407d764b29f$var$ungzip$1 = $a81b0407d764b29f$var$inflate$1;
var $a81b0407d764b29f$var$constants = $a81b0407d764b29f$var$constants$2;
var $a81b0407d764b29f$var$inflate_1$1 = {
    Inflate: $a81b0407d764b29f$var$Inflate_1$1,
    inflate: $a81b0407d764b29f$var$inflate_2,
    inflateRaw: $a81b0407d764b29f$var$inflateRaw_1$1,
    ungzip: $a81b0407d764b29f$var$ungzip$1,
    constants: $a81b0407d764b29f$var$constants
};
const { Deflate: $a81b0407d764b29f$var$Deflate, deflate: $a81b0407d764b29f$var$deflate, deflateRaw: $a81b0407d764b29f$var$deflateRaw, gzip: $a81b0407d764b29f$var$gzip } = $a81b0407d764b29f$var$deflate_1$1;
const { Inflate: $a81b0407d764b29f$var$Inflate, inflate: $a81b0407d764b29f$var$inflate, inflateRaw: $a81b0407d764b29f$var$inflateRaw, ungzip: $a81b0407d764b29f$var$ungzip } = $a81b0407d764b29f$var$inflate_1$1;
var $a81b0407d764b29f$export$ae157b6234afe138 = $a81b0407d764b29f$var$Deflate;
var $a81b0407d764b29f$export$2316623ecd1285ab = $a81b0407d764b29f$var$deflate;
var $a81b0407d764b29f$export$e95d6a8f69fb340a = $a81b0407d764b29f$var$deflateRaw;
var $a81b0407d764b29f$export$69f0ea7cf3a331a8 = $a81b0407d764b29f$var$gzip;
var $a81b0407d764b29f$export$d1de70a877d6e43c = $a81b0407d764b29f$var$Inflate;
var $a81b0407d764b29f$export$cae1ce83fe4a1782 = $a81b0407d764b29f$var$inflate;
var $a81b0407d764b29f$export$d0f0aa2d05c905c5 = $a81b0407d764b29f$var$inflateRaw;
var $a81b0407d764b29f$export$95adf9d270383091 = $a81b0407d764b29f$var$ungzip;
var $a81b0407d764b29f$export$1a988e7317c65621 = $a81b0407d764b29f$var$constants$2;
var $a81b0407d764b29f$export$2e2bcd8739ae039 = {
    Deflate: $a81b0407d764b29f$export$ae157b6234afe138,
    deflate: $a81b0407d764b29f$export$2316623ecd1285ab,
    deflateRaw: $a81b0407d764b29f$export$e95d6a8f69fb340a,
    gzip: $a81b0407d764b29f$export$69f0ea7cf3a331a8,
    Inflate: $a81b0407d764b29f$export$d1de70a877d6e43c,
    inflate: $a81b0407d764b29f$export$cae1ce83fe4a1782,
    inflateRaw: $a81b0407d764b29f$export$d0f0aa2d05c905c5,
    ungzip: $a81b0407d764b29f$export$95adf9d270383091,
    constants: $a81b0407d764b29f$export$1a988e7317c65621
};


const $3e655b30d056552e$var$crcTable = [];
for(let n = 0; n < 256; n++){
    let c = n;
    for(let k = 0; k < 8; k++)if (c & 1) c = 0xedb88320 ^ c >>> 1;
    else c = c >>> 1;
    $3e655b30d056552e$var$crcTable[n] = c;
}
const $3e655b30d056552e$var$initialCrc = 0xffffffff;
function $3e655b30d056552e$var$updateCrc(currentCrc, data, length) {
    let c = currentCrc;
    for(let n = 0; n < length; n++)c = $3e655b30d056552e$var$crcTable[(c ^ data[n]) & 0xff] ^ c >>> 8;
    return c;
}
function $3e655b30d056552e$var$crc(data, length) {
    return ($3e655b30d056552e$var$updateCrc($3e655b30d056552e$var$initialCrc, data, length) ^ $3e655b30d056552e$var$initialCrc) >>> 0;
}
function $3e655b30d056552e$export$a27e44f4abee07bd(buffer, crcLength, chunkName) {
    const expectedCrc = buffer.readUint32();
    const actualCrc = $3e655b30d056552e$var$crc(new Uint8Array(buffer.buffer, buffer.byteOffset + buffer.offset - crcLength - 4, crcLength), crcLength); // "- 4" because we already advanced by reading the CRC
    if (actualCrc !== expectedCrc) throw new Error(`CRC mismatch for chunk ${chunkName}. Expected ${expectedCrc}, found ${actualCrc}`);
}
function $3e655b30d056552e$export$f1eadea2b27d7525(buffer, length) {
    buffer.writeUint32($3e655b30d056552e$var$crc(new Uint8Array(buffer.buffer, buffer.byteOffset + buffer.offset - length, length), length));
}


function $049a567c09769aec$export$b7b5bfc0952df2ea(currentLine, newLine, bytesPerLine) {
    for(let i = 0; i < bytesPerLine; i++)newLine[i] = currentLine[i];
}
function $049a567c09769aec$export$74a31f89f2bf5d02(currentLine, newLine, bytesPerLine, bytesPerPixel) {
    let i = 0;
    for(; i < bytesPerPixel; i++)// just copy first bytes
    newLine[i] = currentLine[i];
    for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + newLine[i - bytesPerPixel] & 0xff;
}
function $049a567c09769aec$export$42813f03f0be1153(currentLine, newLine, prevLine, bytesPerLine) {
    let i = 0;
    if (prevLine.length === 0) // just copy bytes for first line
    for(; i < bytesPerLine; i++)newLine[i] = currentLine[i];
    else for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + prevLine[i] & 0xff;
}
function $049a567c09769aec$export$ad0279a52dc26d29(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel) {
    let i = 0;
    if (prevLine.length === 0) {
        for(; i < bytesPerPixel; i++)newLine[i] = currentLine[i];
        for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + (newLine[i - bytesPerPixel] >> 1) & 0xff;
    } else {
        for(; i < bytesPerPixel; i++)newLine[i] = currentLine[i] + (prevLine[i] >> 1) & 0xff;
        for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + (newLine[i - bytesPerPixel] + prevLine[i] >> 1) & 0xff;
    }
}
function $049a567c09769aec$export$6c7fcb68da6b62(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel) {
    let i = 0;
    if (prevLine.length === 0) {
        for(; i < bytesPerPixel; i++)newLine[i] = currentLine[i];
        for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + newLine[i - bytesPerPixel] & 0xff;
    } else {
        for(; i < bytesPerPixel; i++)newLine[i] = currentLine[i] + prevLine[i] & 0xff;
        for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + $049a567c09769aec$var$paethPredictor(newLine[i - bytesPerPixel], prevLine[i], prevLine[i - bytesPerPixel]) & 0xff;
    }
}
function $049a567c09769aec$var$paethPredictor(a, b, c) {
    const p = a + b - c;
    const pa = Math.abs(p - a);
    const pb = Math.abs(p - b);
    const pc = Math.abs(p - c);
    if (pa <= pb && pa <= pc) return a;
    else if (pb <= pc) return b;
    else return c;
}


function $88bc10d9f6aabfd6$export$cf2952a533e34237(filterType, currentLine, newLine, prevLine, passLineBytes, bytesPerPixel) {
    switch(filterType){
        case 0:
            (0, $049a567c09769aec$export$b7b5bfc0952df2ea)(currentLine, newLine, passLineBytes);
            break;
        case 1:
            (0, $049a567c09769aec$export$74a31f89f2bf5d02)(currentLine, newLine, passLineBytes, bytesPerPixel);
            break;
        case 2:
            (0, $049a567c09769aec$export$42813f03f0be1153)(currentLine, newLine, prevLine, passLineBytes);
            break;
        case 3:
            (0, $049a567c09769aec$export$ad0279a52dc26d29)(currentLine, newLine, prevLine, passLineBytes, bytesPerPixel);
            break;
        case 4:
            (0, $049a567c09769aec$export$6c7fcb68da6b62)(currentLine, newLine, prevLine, passLineBytes, bytesPerPixel);
            break;
        default:
            throw new Error(`Unsupported filter: ${filterType}`);
    }
}


const $7588c770b2c606cd$var$uint16 = new Uint16Array([
    0x00ff
]);
const $7588c770b2c606cd$var$uint8 = new Uint8Array($7588c770b2c606cd$var$uint16.buffer);
const $7588c770b2c606cd$var$osIsLittleEndian = $7588c770b2c606cd$var$uint8[0] === 0xff;
function $7588c770b2c606cd$export$4e311ab71083585(params) {
    const { data: data, width: width, height: height, channels: channels, depth: depth } = params;
    // Adam7 interlacing pattern
    const passes = [
        {
            x: 0,
            y: 0,
            xStep: 8,
            yStep: 8
        },
        {
            x: 4,
            y: 0,
            xStep: 8,
            yStep: 8
        },
        {
            x: 0,
            y: 4,
            xStep: 4,
            yStep: 8
        },
        {
            x: 2,
            y: 0,
            xStep: 4,
            yStep: 4
        },
        {
            x: 0,
            y: 2,
            xStep: 2,
            yStep: 4
        },
        {
            x: 1,
            y: 0,
            xStep: 2,
            yStep: 2
        },
        {
            x: 0,
            y: 1,
            xStep: 1,
            yStep: 2
        }
    ];
    const bytesPerPixel = Math.ceil(depth / 8) * channels;
    const resultData = new Uint8Array(height * width * bytesPerPixel);
    let offset = 0;
    // Process each pass
    for(let passIndex = 0; passIndex < 7; passIndex++){
        const pass = passes[passIndex];
        // Calculate pass dimensions
        const passWidth = Math.ceil((width - pass.x) / pass.xStep);
        const passHeight = Math.ceil((height - pass.y) / pass.yStep);
        if (passWidth <= 0 || passHeight <= 0) continue;
        const passLineBytes = passWidth * bytesPerPixel;
        const prevLine = new Uint8Array(passLineBytes);
        // Process each scanline in this pass
        for(let y = 0; y < passHeight; y++){
            // First byte is the filter type
            const filterType = data[offset++];
            const currentLine = data.subarray(offset, offset + passLineBytes);
            offset += passLineBytes;
            // Create a new line for the unfiltered data
            const newLine = new Uint8Array(passLineBytes);
            // Apply the appropriate unfilter
            (0, $88bc10d9f6aabfd6$export$cf2952a533e34237)(filterType, currentLine, newLine, prevLine, passLineBytes, bytesPerPixel);
            prevLine.set(newLine);
            for(let x = 0; x < passWidth; x++){
                const outputX = pass.x + x * pass.xStep;
                const outputY = pass.y + y * pass.yStep;
                if (outputX >= width || outputY >= height) continue;
                for(let i = 0; i < bytesPerPixel; i++)resultData[(outputY * width + outputX) * bytesPerPixel + i] = newLine[x * bytesPerPixel + i];
            }
        }
    }
    if (depth === 16) {
        const uint16Data = new Uint16Array(resultData.buffer);
        if ($7588c770b2c606cd$var$osIsLittleEndian) for(let k = 0; k < uint16Data.length; k++)// PNG is always big endian. Swap the bytes.
        uint16Data[k] = $7588c770b2c606cd$var$swap16(uint16Data[k]);
        return uint16Data;
    } else return resultData;
}
function $7588c770b2c606cd$var$swap16(val) {
    return (val & 0xff) << 8 | val >> 8 & 0xff;
}



const $2611e4e182a7049f$var$uint16 = new Uint16Array([
    0x00ff
]);
const $2611e4e182a7049f$var$uint8 = new Uint8Array($2611e4e182a7049f$var$uint16.buffer);
const $2611e4e182a7049f$var$osIsLittleEndian = $2611e4e182a7049f$var$uint8[0] === 0xff;
const $2611e4e182a7049f$var$empty = new Uint8Array(0);
function $2611e4e182a7049f$export$fe66f1bbb29d778e(params) {
    const { data: data, width: width, height: height, channels: channels, depth: depth } = params;
    const bytesPerPixel = Math.ceil(depth / 8) * channels;
    const bytesPerLine = Math.ceil(depth / 8 * channels * width);
    const newData = new Uint8Array(height * bytesPerLine);
    let prevLine = $2611e4e182a7049f$var$empty;
    let offset = 0;
    let currentLine;
    let newLine;
    for(let i = 0; i < height; i++){
        currentLine = data.subarray(offset + 1, offset + 1 + bytesPerLine);
        newLine = newData.subarray(i * bytesPerLine, (i + 1) * bytesPerLine);
        switch(data[offset]){
            case 0:
                (0, $049a567c09769aec$export$b7b5bfc0952df2ea)(currentLine, newLine, bytesPerLine);
                break;
            case 1:
                (0, $049a567c09769aec$export$74a31f89f2bf5d02)(currentLine, newLine, bytesPerLine, bytesPerPixel);
                break;
            case 2:
                (0, $049a567c09769aec$export$42813f03f0be1153)(currentLine, newLine, prevLine, bytesPerLine);
                break;
            case 3:
                (0, $049a567c09769aec$export$ad0279a52dc26d29)(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel);
                break;
            case 4:
                (0, $049a567c09769aec$export$6c7fcb68da6b62)(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel);
                break;
            default:
                throw new Error(`Unsupported filter: ${data[offset]}`);
        }
        prevLine = newLine;
        offset += bytesPerLine + 1;
    }
    if (depth === 16) {
        const uint16Data = new Uint16Array(newData.buffer);
        if ($2611e4e182a7049f$var$osIsLittleEndian) for(let k = 0; k < uint16Data.length; k++)// PNG is always big endian. Swap the bytes.
        uint16Data[k] = $2611e4e182a7049f$var$swap16(uint16Data[k]);
        return uint16Data;
    } else return newData;
}
function $2611e4e182a7049f$var$swap16(val) {
    return (val & 0xff) << 8 | val >> 8 & 0xff;
}


// https://www.w3.org/TR/PNG/#5PNG-file-signature
const $edd0b61260515a90$var$pngSignature = Uint8Array.of(137, 80, 78, 71, 13, 10, 26, 10);
function $edd0b61260515a90$export$6d91aec43a397576(buffer) {
    buffer.writeBytes($edd0b61260515a90$var$pngSignature);
}
function $edd0b61260515a90$export$9b20e139d888fd41(buffer) {
    if (!$edd0b61260515a90$export$eb3857d891b50bba(buffer.readBytes($edd0b61260515a90$var$pngSignature.length))) throw new Error('wrong PNG signature');
}
function $edd0b61260515a90$export$eb3857d891b50bba(array) {
    if (array.length < $edd0b61260515a90$var$pngSignature.length) return false;
    for(let i = 0; i < $edd0b61260515a90$var$pngSignature.length; i++){
        if (array[i] !== $edd0b61260515a90$var$pngSignature[i]) return false;
    }
    return true;
}



const $aaee4b86c30f1b7f$export$b7828eccb3fa75e = 'tEXt';
const $aaee4b86c30f1b7f$var$NULL = 0;
const $aaee4b86c30f1b7f$var$latin1Decoder = new TextDecoder('latin1');
function $aaee4b86c30f1b7f$var$validateKeyword(keyword) {
    $aaee4b86c30f1b7f$var$validateLatin1(keyword);
    if (keyword.length === 0 || keyword.length > 79) throw new Error('keyword length must be between 1 and 79');
}
// eslint-disable-next-line no-control-regex
const $aaee4b86c30f1b7f$var$latin1Regex = /^[\u0000-\u00FF]*$/;
function $aaee4b86c30f1b7f$var$validateLatin1(text) {
    if (!$aaee4b86c30f1b7f$var$latin1Regex.test(text)) throw new Error('invalid latin1 text');
}
function $aaee4b86c30f1b7f$export$eaa080cfa45e66ec(text, buffer, length) {
    const keyword = $aaee4b86c30f1b7f$export$7ff9b48854e294c6(buffer);
    text[keyword] = $aaee4b86c30f1b7f$export$6f32b93aa65863bd(buffer, length - keyword.length - 1);
}
function $aaee4b86c30f1b7f$export$304fabbece3077af(buffer, keyword, text) {
    $aaee4b86c30f1b7f$var$validateKeyword(keyword);
    $aaee4b86c30f1b7f$var$validateLatin1(text);
    const length = keyword.length + 1 /* NULL */  + text.length;
    buffer.writeUint32(length);
    buffer.writeChars($aaee4b86c30f1b7f$export$b7828eccb3fa75e);
    buffer.writeChars(keyword);
    buffer.writeByte($aaee4b86c30f1b7f$var$NULL);
    buffer.writeChars(text);
    (0, $3e655b30d056552e$export$f1eadea2b27d7525)(buffer, length + 4);
}
function $aaee4b86c30f1b7f$export$7ff9b48854e294c6(buffer) {
    buffer.mark();
    while(buffer.readByte() !== $aaee4b86c30f1b7f$var$NULL);
    const end = buffer.offset;
    buffer.reset();
    const keyword = $aaee4b86c30f1b7f$var$latin1Decoder.decode(buffer.readBytes(end - buffer.offset - 1));
    // NULL
    buffer.skip(1);
    $aaee4b86c30f1b7f$var$validateKeyword(keyword);
    return keyword;
}
function $aaee4b86c30f1b7f$export$6f32b93aa65863bd(buffer, length) {
    return $aaee4b86c30f1b7f$var$latin1Decoder.decode(buffer.readBytes(length));
}


const $12de0e4ca2f2f701$export$2cd82751acc0e609 = {
    UNKNOWN: -1,
    GREYSCALE: 0,
    TRUECOLOUR: 2,
    INDEXED_COLOUR: 3,
    GREYSCALE_ALPHA: 4,
    TRUECOLOUR_ALPHA: 6
};
const $12de0e4ca2f2f701$export$825f3c317f99229 = {
    UNKNOWN: -1,
    DEFLATE: 0
};
const $12de0e4ca2f2f701$export$3ecd618ea72c47f7 = {
    UNKNOWN: -1,
    ADAPTIVE: 0
};
const $12de0e4ca2f2f701$export$2b1dd3da86572fe2 = {
    UNKNOWN: -1,
    NO_INTERLACE: 0,
    ADAM7: 1
};
const $12de0e4ca2f2f701$export$c2de24028defae28 = {
    NONE: 0,
    BACKGROUND: 1,
    PREVIOUS: 2
};
const $12de0e4ca2f2f701$export$b8d06ec133a3a0ca = {
    SOURCE: 0,
    OVER: 1
};


class $3145a3311b7576e1$export$2e2bcd8739ae039 extends (0, $e51a952610d7661c$export$6b4c32f3d5b8738a) {
    _checkCrc;
    _inflator;
    _png;
    _apng;
    _end;
    _hasPalette;
    _palette;
    _hasTransparency;
    _transparency;
    _compressionMethod;
    _filterMethod;
    _interlaceMethod;
    _colorType;
    _isAnimated;
    _numberOfFrames;
    _numberOfPlays;
    _frames;
    _writingDataChunks;
    constructor(data, options = {}){
        super(data);
        const { checkCrc: checkCrc = false } = options;
        this._checkCrc = checkCrc;
        this._inflator = new (0, $a81b0407d764b29f$export$d1de70a877d6e43c)();
        this._png = {
            width: -1,
            height: -1,
            channels: -1,
            data: new Uint8Array(0),
            depth: 1,
            text: {}
        };
        this._apng = {
            width: -1,
            height: -1,
            channels: -1,
            depth: 1,
            numberOfFrames: 1,
            numberOfPlays: 0,
            text: {},
            frames: []
        };
        this._end = false;
        this._hasPalette = false;
        this._palette = [];
        this._hasTransparency = false;
        this._transparency = new Uint16Array(0);
        this._compressionMethod = (0, $12de0e4ca2f2f701$export$825f3c317f99229).UNKNOWN;
        this._filterMethod = (0, $12de0e4ca2f2f701$export$3ecd618ea72c47f7).UNKNOWN;
        this._interlaceMethod = (0, $12de0e4ca2f2f701$export$2b1dd3da86572fe2).UNKNOWN;
        this._colorType = (0, $12de0e4ca2f2f701$export$2cd82751acc0e609).UNKNOWN;
        this._isAnimated = false;
        this._numberOfFrames = 1;
        this._numberOfPlays = 0;
        this._frames = [];
        this._writingDataChunks = false;
        // PNG is always big endian
        // https://www.w3.org/TR/PNG/#7Integers-and-byte-order
        this.setBigEndian();
    }
    decode() {
        (0, $edd0b61260515a90$export$9b20e139d888fd41)(this);
        while(!this._end){
            const length = this.readUint32();
            const type = this.readChars(4);
            this.decodeChunk(length, type);
        }
        this.decodeImage();
        return this._png;
    }
    decodeApng() {
        (0, $edd0b61260515a90$export$9b20e139d888fd41)(this);
        while(!this._end){
            const length = this.readUint32();
            const type = this.readChars(4);
            this.decodeApngChunk(length, type);
        }
        this.decodeApngImage();
        return this._apng;
    }
    // https://www.w3.org/TR/PNG/#5Chunk-layout
    decodeChunk(length, type) {
        const offset = this.offset;
        switch(type){
            // 11.2 Critical chunks
            case 'IHDR':
                this.decodeIHDR();
                break;
            case 'PLTE':
                this.decodePLTE(length);
                break;
            case 'IDAT':
                this.decodeIDAT(length);
                break;
            case 'IEND':
                this._end = true;
                break;
            // 11.3 Ancillary chunks
            case 'tRNS':
                this.decodetRNS(length);
                break;
            case 'iCCP':
                this.decodeiCCP(length);
                break;
            case 0, $aaee4b86c30f1b7f$export$b7828eccb3fa75e:
                (0, $aaee4b86c30f1b7f$export$eaa080cfa45e66ec)(this._png.text, this, length);
                break;
            case 'pHYs':
                this.decodepHYs();
                break;
            default:
                this.skip(length);
                break;
        }
        if (this.offset - offset !== length) throw new Error(`Length mismatch while decoding chunk ${type}`);
        if (this._checkCrc) (0, $3e655b30d056552e$export$a27e44f4abee07bd)(this, length + 4, type);
        else this.skip(4);
    }
    decodeApngChunk(length, type) {
        const offset = this.offset;
        if (type !== 'fdAT' && type !== 'IDAT' && this._writingDataChunks) this.pushDataToFrame();
        switch(type){
            case 'acTL':
                this.decodeACTL();
                break;
            case 'fcTL':
                this.decodeFCTL();
                break;
            case 'fdAT':
                this.decodeFDAT(length);
                break;
            default:
                this.decodeChunk(length, type);
                this.offset = offset + length;
                break;
        }
        if (this.offset - offset !== length) throw new Error(`Length mismatch while decoding chunk ${type}`);
        if (this._checkCrc) (0, $3e655b30d056552e$export$a27e44f4abee07bd)(this, length + 4, type);
        else this.skip(4);
    }
    // https://www.w3.org/TR/PNG/#11IHDR
    decodeIHDR() {
        const image = this._png;
        image.width = this.readUint32();
        image.height = this.readUint32();
        image.depth = $3145a3311b7576e1$var$checkBitDepth(this.readUint8());
        const colorType = this.readUint8();
        this._colorType = colorType;
        let channels;
        switch(colorType){
            case (0, $12de0e4ca2f2f701$export$2cd82751acc0e609).GREYSCALE:
                channels = 1;
                break;
            case (0, $12de0e4ca2f2f701$export$2cd82751acc0e609).TRUECOLOUR:
                channels = 3;
                break;
            case (0, $12de0e4ca2f2f701$export$2cd82751acc0e609).INDEXED_COLOUR:
                channels = 1;
                break;
            case (0, $12de0e4ca2f2f701$export$2cd82751acc0e609).GREYSCALE_ALPHA:
                channels = 2;
                break;
            case (0, $12de0e4ca2f2f701$export$2cd82751acc0e609).TRUECOLOUR_ALPHA:
                channels = 4;
                break;
            // Kept for exhaustiveness.
            // eslint-disable-next-line unicorn/no-useless-switch-case
            case (0, $12de0e4ca2f2f701$export$2cd82751acc0e609).UNKNOWN:
            default:
                throw new Error(`Unknown color type: ${colorType}`);
        }
        this._png.channels = channels;
        this._compressionMethod = this.readUint8();
        if (this._compressionMethod !== (0, $12de0e4ca2f2f701$export$825f3c317f99229).DEFLATE) throw new Error(`Unsupported compression method: ${this._compressionMethod}`);
        this._filterMethod = this.readUint8();
        this._interlaceMethod = this.readUint8();
    }
    decodeACTL() {
        this._numberOfFrames = this.readUint32();
        this._numberOfPlays = this.readUint32();
        this._isAnimated = true;
    }
    decodeFCTL() {
        const image = {
            sequenceNumber: this.readUint32(),
            width: this.readUint32(),
            height: this.readUint32(),
            xOffset: this.readUint32(),
            yOffset: this.readUint32(),
            delayNumber: this.readUint16(),
            delayDenominator: this.readUint16(),
            disposeOp: this.readUint8(),
            blendOp: this.readUint8(),
            data: new Uint8Array(0)
        };
        this._frames.push(image);
    }
    // https://www.w3.org/TR/PNG/#11PLTE
    decodePLTE(length) {
        if (length % 3 !== 0) throw new RangeError(`PLTE field length must be a multiple of 3. Got ${length}`);
        const l = length / 3;
        this._hasPalette = true;
        const palette = [];
        this._palette = palette;
        for(let i = 0; i < l; i++)palette.push([
            this.readUint8(),
            this.readUint8(),
            this.readUint8()
        ]);
    }
    // https://www.w3.org/TR/PNG/#11IDAT
    decodeIDAT(length) {
        this._writingDataChunks = true;
        const dataLength = length;
        const dataOffset = this.offset + this.byteOffset;
        this._inflator.push(new Uint8Array(this.buffer, dataOffset, dataLength));
        if (this._inflator.err) throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
        this.skip(length);
    }
    decodeFDAT(length) {
        this._writingDataChunks = true;
        let dataLength = length;
        let dataOffset = this.offset + this.byteOffset;
        dataOffset += 4;
        dataLength -= 4;
        this._inflator.push(new Uint8Array(this.buffer, dataOffset, dataLength));
        if (this._inflator.err) throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
        this.skip(length);
    }
    // https://www.w3.org/TR/PNG/#11tRNS
    decodetRNS(length) {
        switch(this._colorType){
            case (0, $12de0e4ca2f2f701$export$2cd82751acc0e609).GREYSCALE:
            case (0, $12de0e4ca2f2f701$export$2cd82751acc0e609).TRUECOLOUR:
                if (length % 2 !== 0) throw new RangeError(`tRNS chunk length must be a multiple of 2. Got ${length}`);
                if (length / 2 > this._png.width * this._png.height) throw new Error(`tRNS chunk contains more alpha values than there are pixels (${length / 2} vs ${this._png.width * this._png.height})`);
                this._hasTransparency = true;
                this._transparency = new Uint16Array(length / 2);
                for(let i = 0; i < length / 2; i++)this._transparency[i] = this.readUint16();
                break;
            case (0, $12de0e4ca2f2f701$export$2cd82751acc0e609).INDEXED_COLOUR:
                {
                    if (length > this._palette.length) throw new Error(`tRNS chunk contains more alpha values than there are palette colors (${length} vs ${this._palette.length})`);
                    let i = 0;
                    for(; i < length; i++){
                        const alpha = this.readByte();
                        this._palette[i].push(alpha);
                    }
                    for(; i < this._palette.length; i++)this._palette[i].push(255);
                    break;
                }
            // Kept for exhaustiveness.
            /* eslint-disable unicorn/no-useless-switch-case */ case (0, $12de0e4ca2f2f701$export$2cd82751acc0e609).UNKNOWN:
            case (0, $12de0e4ca2f2f701$export$2cd82751acc0e609).GREYSCALE_ALPHA:
            case (0, $12de0e4ca2f2f701$export$2cd82751acc0e609).TRUECOLOUR_ALPHA:
            default:
                throw new Error(`tRNS chunk is not supported for color type ${this._colorType}`);
        }
    }
    // https://www.w3.org/TR/PNG/#11iCCP
    decodeiCCP(length) {
        const name = (0, $aaee4b86c30f1b7f$export$7ff9b48854e294c6)(this);
        const compressionMethod = this.readUint8();
        if (compressionMethod !== (0, $12de0e4ca2f2f701$export$825f3c317f99229).DEFLATE) throw new Error(`Unsupported iCCP compression method: ${compressionMethod}`);
        const compressedProfile = this.readBytes(length - name.length - 2);
        this._png.iccEmbeddedProfile = {
            name: name,
            profile: (0, $a81b0407d764b29f$export$cae1ce83fe4a1782)(compressedProfile)
        };
    }
    // https://www.w3.org/TR/PNG/#11pHYs
    decodepHYs() {
        const ppuX = this.readUint32();
        const ppuY = this.readUint32();
        const unitSpecifier = this.readByte();
        this._png.resolution = {
            x: ppuX,
            y: ppuY,
            unit: unitSpecifier
        };
    }
    decodeApngImage() {
        this._apng.width = this._png.width;
        this._apng.height = this._png.height;
        this._apng.channels = this._png.channels;
        this._apng.depth = this._png.depth;
        this._apng.numberOfFrames = this._numberOfFrames;
        this._apng.numberOfPlays = this._numberOfPlays;
        this._apng.text = this._png.text;
        this._apng.resolution = this._png.resolution;
        for(let i = 0; i < this._numberOfFrames; i++){
            const newFrame = {
                sequenceNumber: this._frames[i].sequenceNumber,
                delayNumber: this._frames[i].delayNumber,
                delayDenominator: this._frames[i].delayDenominator,
                data: this._apng.depth === 8 ? new Uint8Array(this._apng.width * this._apng.height * this._apng.channels) : new Uint16Array(this._apng.width * this._apng.height * this._apng.channels)
            };
            const frame = this._frames.at(i);
            if (frame) {
                frame.data = (0, $2611e4e182a7049f$export$fe66f1bbb29d778e)({
                    data: frame.data,
                    width: frame.width,
                    height: frame.height,
                    channels: this._apng.channels,
                    depth: this._apng.depth
                });
                if (this._hasPalette) this._apng.palette = this._palette;
                if (this._hasTransparency) this._apng.transparency = this._transparency;
                if (i === 0 || frame.xOffset === 0 && frame.yOffset === 0 && frame.width === this._png.width && frame.height === this._png.height) newFrame.data = frame.data;
                else {
                    const prevFrame = this._apng.frames.at(i - 1);
                    this.disposeFrame(frame, prevFrame, newFrame);
                    this.addFrameDataToCanvas(newFrame, frame);
                }
                this._apng.frames.push(newFrame);
            }
        }
        return this._apng;
    }
    disposeFrame(frame, prevFrame, imageFrame) {
        switch(frame.disposeOp){
            case (0, $12de0e4ca2f2f701$export$c2de24028defae28).NONE:
                break;
            case (0, $12de0e4ca2f2f701$export$c2de24028defae28).BACKGROUND:
                for(let row = 0; row < this._png.height; row++)for(let col = 0; col < this._png.width; col++){
                    const index = (row * frame.width + col) * this._png.channels;
                    for(let channel = 0; channel < this._png.channels; channel++)imageFrame.data[index + channel] = 0;
                }
                break;
            case (0, $12de0e4ca2f2f701$export$c2de24028defae28).PREVIOUS:
                imageFrame.data.set(prevFrame.data);
                break;
            default:
                throw new Error('Unknown disposeOp');
        }
    }
    addFrameDataToCanvas(imageFrame, frame) {
        const maxValue = 1 << this._png.depth;
        const calculatePixelIndices = (row, col)=>{
            const index = ((row + frame.yOffset) * this._png.width + frame.xOffset + col) * this._png.channels;
            const frameIndex = (row * frame.width + col) * this._png.channels;
            return {
                index: index,
                frameIndex: frameIndex
            };
        };
        switch(frame.blendOp){
            case (0, $12de0e4ca2f2f701$export$b8d06ec133a3a0ca).SOURCE:
                for(let row = 0; row < frame.height; row++)for(let col = 0; col < frame.width; col++){
                    const { index: index, frameIndex: frameIndex } = calculatePixelIndices(row, col);
                    for(let channel = 0; channel < this._png.channels; channel++)imageFrame.data[index + channel] = frame.data[frameIndex + channel];
                }
                break;
            // https://www.w3.org/TR/png-3/#13Alpha-channel-processing
            case (0, $12de0e4ca2f2f701$export$b8d06ec133a3a0ca).OVER:
                for(let row = 0; row < frame.height; row++)for(let col = 0; col < frame.width; col++){
                    const { index: index, frameIndex: frameIndex } = calculatePixelIndices(row, col);
                    for(let channel = 0; channel < this._png.channels; channel++){
                        const sourceAlpha = frame.data[frameIndex + this._png.channels - 1] / maxValue;
                        const foregroundValue = channel % (this._png.channels - 1) === 0 ? 1 : frame.data[frameIndex + channel];
                        const value = Math.floor(sourceAlpha * foregroundValue + (1 - sourceAlpha) * imageFrame.data[index + channel]);
                        imageFrame.data[index + channel] += value;
                    }
                }
                break;
            default:
                throw new Error('Unknown blendOp');
        }
    }
    decodeImage() {
        if (this._inflator.err) throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
        const data = this._isAnimated ? (this._frames?.at(0)).data : this._inflator.result;
        if (this._filterMethod !== (0, $12de0e4ca2f2f701$export$3ecd618ea72c47f7).ADAPTIVE) throw new Error(`Filter method ${this._filterMethod} not supported`);
        if (this._interlaceMethod === (0, $12de0e4ca2f2f701$export$2b1dd3da86572fe2).NO_INTERLACE) this._png.data = (0, $2611e4e182a7049f$export$fe66f1bbb29d778e)({
            data: data,
            width: this._png.width,
            height: this._png.height,
            channels: this._png.channels,
            depth: this._png.depth
        });
        else if (this._interlaceMethod === (0, $12de0e4ca2f2f701$export$2b1dd3da86572fe2).ADAM7) this._png.data = (0, $7588c770b2c606cd$export$4e311ab71083585)({
            data: data,
            width: this._png.width,
            height: this._png.height,
            channels: this._png.channels,
            depth: this._png.depth
        });
        else throw new Error(`Interlace method ${this._interlaceMethod} not supported`);
        if (this._hasPalette) this._png.palette = this._palette;
        if (this._hasTransparency) this._png.transparency = this._transparency;
    }
    pushDataToFrame() {
        const result = this._inflator.result;
        const lastFrame = this._frames.at(-1);
        if (lastFrame) lastFrame.data = result;
        else this._frames.push({
            sequenceNumber: 0,
            width: this._png.width,
            height: this._png.height,
            xOffset: 0,
            yOffset: 0,
            delayNumber: 0,
            delayDenominator: 0,
            disposeOp: (0, $12de0e4ca2f2f701$export$c2de24028defae28).NONE,
            blendOp: (0, $12de0e4ca2f2f701$export$b8d06ec133a3a0ca).SOURCE,
            data: result
        });
        this._inflator = new (0, $a81b0407d764b29f$export$d1de70a877d6e43c)();
        this._writingDataChunks = false;
    }
}
function $3145a3311b7576e1$var$checkBitDepth(value) {
    if (value !== 1 && value !== 2 && value !== 4 && value !== 8 && value !== 16) throw new Error(`invalid bit depth: ${value}`);
    return value;
}








const $205ab75bcf37547a$var$defaultZlibOptions = {
    level: 3
};
class $205ab75bcf37547a$export$2e2bcd8739ae039 extends (0, $e51a952610d7661c$export$6b4c32f3d5b8738a) {
    _png;
    _zlibOptions;
    _colorType;
    _interlaceMethod;
    constructor(data, options = {}){
        super();
        this._colorType = (0, $12de0e4ca2f2f701$export$2cd82751acc0e609).UNKNOWN;
        this._zlibOptions = {
            ...$205ab75bcf37547a$var$defaultZlibOptions,
            ...options.zlib
        };
        this._png = this._checkData(data);
        this._interlaceMethod = (options.interlace === 'Adam7' ? (0, $12de0e4ca2f2f701$export$2b1dd3da86572fe2).ADAM7 : (0, $12de0e4ca2f2f701$export$2b1dd3da86572fe2).NO_INTERLACE) ?? (0, $12de0e4ca2f2f701$export$2b1dd3da86572fe2).NO_INTERLACE;
        this.setBigEndian();
    }
    encode() {
        (0, $edd0b61260515a90$export$6d91aec43a397576)(this);
        this.encodeIHDR();
        if (this._png.palette) {
            this.encodePLTE();
            if (this._png.palette[0].length === 4) this.encodeTRNS();
        }
        this.encodeData();
        if (this._png.text) for (const [keyword, text] of Object.entries(this._png.text))(0, $aaee4b86c30f1b7f$export$304fabbece3077af)(this, keyword, text);
        this.encodeIEND();
        return this.toArray();
    }
    // https://www.w3.org/TR/PNG/#11IHDR
    encodeIHDR() {
        this.writeUint32(13);
        this.writeChars('IHDR');
        this.writeUint32(this._png.width);
        this.writeUint32(this._png.height);
        this.writeByte(this._png.depth);
        this.writeByte(this._colorType);
        this.writeByte((0, $12de0e4ca2f2f701$export$825f3c317f99229).DEFLATE);
        this.writeByte((0, $12de0e4ca2f2f701$export$3ecd618ea72c47f7).ADAPTIVE);
        this.writeByte(this._interlaceMethod);
        (0, $3e655b30d056552e$export$f1eadea2b27d7525)(this, 17);
    }
    // https://www.w3.org/TR/PNG/#11IEND
    encodeIEND() {
        this.writeUint32(0);
        this.writeChars('IEND');
        (0, $3e655b30d056552e$export$f1eadea2b27d7525)(this, 4);
    }
    encodePLTE() {
        const paletteLength = this._png.palette?.length * 3;
        this.writeUint32(paletteLength);
        this.writeChars('PLTE');
        for (const color of this._png.palette){
            this.writeByte(color[0]);
            this.writeByte(color[1]);
            this.writeByte(color[2]);
        }
        (0, $3e655b30d056552e$export$f1eadea2b27d7525)(this, 4 + paletteLength);
    }
    encodeTRNS() {
        const alpha = this._png.palette.filter((color)=>{
            return color.at(-1) !== 255;
        });
        this.writeUint32(alpha.length);
        this.writeChars('tRNS');
        for (const el of alpha)this.writeByte(el.at(-1));
        (0, $3e655b30d056552e$export$f1eadea2b27d7525)(this, 4 + alpha.length);
    }
    // https://www.w3.org/TR/PNG/#11IDAT
    encodeIDAT(data) {
        this.writeUint32(data.length);
        this.writeChars('IDAT');
        this.writeBytes(data);
        (0, $3e655b30d056552e$export$f1eadea2b27d7525)(this, data.length + 4);
    }
    encodeData() {
        const { width: width, height: height, channels: channels, depth: depth, data: data } = this._png;
        const slotsPerLine = depth <= 8 ? Math.ceil(width * depth / 8) * channels : Math.ceil(width * depth / 8 * channels / 2);
        const newData = new (0, $e51a952610d7661c$export$6b4c32f3d5b8738a)().setBigEndian();
        let offset = 0;
        if (this._interlaceMethod === (0, $12de0e4ca2f2f701$export$2b1dd3da86572fe2).NO_INTERLACE) for(let i = 0; i < height; i++){
            newData.writeByte(0); // no filter
            if (depth === 16) offset = $205ab75bcf37547a$var$writeDataUint16(data, newData, slotsPerLine, offset);
            else offset = $205ab75bcf37547a$var$writeDataBytes(data, newData, slotsPerLine, offset);
        }
        else if (this._interlaceMethod === (0, $12de0e4ca2f2f701$export$2b1dd3da86572fe2).ADAM7) // Adam7 interlacing
        offset = $205ab75bcf37547a$var$writeDataInterlaced(this._png, data, newData, offset);
        const buffer = newData.toArray();
        const compressed = (0, $a81b0407d764b29f$export$2316623ecd1285ab)(buffer, this._zlibOptions);
        this.encodeIDAT(compressed);
    }
    _checkData(data) {
        const { colorType: colorType, channels: channels, depth: depth } = $205ab75bcf37547a$var$getColorType(data, data.palette);
        const png = {
            width: $205ab75bcf37547a$var$checkInteger(data.width, 'width'),
            height: $205ab75bcf37547a$var$checkInteger(data.height, 'height'),
            channels: channels,
            data: data.data,
            depth: depth,
            text: data.text,
            palette: data.palette
        };
        this._colorType = colorType;
        const expectedSize = depth < 8 ? Math.ceil(png.width * depth / 8) * png.height * channels : png.width * png.height * channels;
        if (png.data.length !== expectedSize) throw new RangeError(`wrong data size. Found ${png.data.length}, expected ${expectedSize}`);
        return png;
    }
}
function $205ab75bcf37547a$var$checkInteger(value, name) {
    if (Number.isInteger(value) && value > 0) return value;
    throw new TypeError(`${name} must be a positive integer`);
}
function $205ab75bcf37547a$var$getColorType(data, palette) {
    const { channels: channels = 4, depth: depth = 8 } = data;
    if (channels !== 4 && channels !== 3 && channels !== 2 && channels !== 1) throw new RangeError(`unsupported number of channels: ${channels}`);
    const returnValue = {
        channels: channels,
        depth: depth,
        colorType: (0, $12de0e4ca2f2f701$export$2cd82751acc0e609).UNKNOWN
    };
    switch(channels){
        case 4:
            returnValue.colorType = (0, $12de0e4ca2f2f701$export$2cd82751acc0e609).TRUECOLOUR_ALPHA;
            break;
        case 3:
            returnValue.colorType = (0, $12de0e4ca2f2f701$export$2cd82751acc0e609).TRUECOLOUR;
            break;
        case 1:
            if (palette) returnValue.colorType = (0, $12de0e4ca2f2f701$export$2cd82751acc0e609).INDEXED_COLOUR;
            else returnValue.colorType = (0, $12de0e4ca2f2f701$export$2cd82751acc0e609).GREYSCALE;
            break;
        case 2:
            returnValue.colorType = (0, $12de0e4ca2f2f701$export$2cd82751acc0e609).GREYSCALE_ALPHA;
            break;
        default:
            throw new Error('unsupported number of channels');
    }
    return returnValue;
}
function $205ab75bcf37547a$var$writeDataBytes(data, newData, slotsPerLine, offset) {
    for(let j = 0; j < slotsPerLine; j++)newData.writeByte(data[offset++]);
    return offset;
}
function $205ab75bcf37547a$var$writeDataInterlaced(imageData, data, newData, offset) {
    const passes = [
        {
            x: 0,
            y: 0,
            xStep: 8,
            yStep: 8
        },
        {
            x: 4,
            y: 0,
            xStep: 8,
            yStep: 8
        },
        {
            x: 0,
            y: 4,
            xStep: 4,
            yStep: 8
        },
        {
            x: 2,
            y: 0,
            xStep: 4,
            yStep: 4
        },
        {
            x: 0,
            y: 2,
            xStep: 2,
            yStep: 4
        },
        {
            x: 1,
            y: 0,
            xStep: 2,
            yStep: 2
        },
        {
            x: 0,
            y: 1,
            xStep: 1,
            yStep: 2
        }
    ];
    const { width: width, height: height, channels: channels, depth: depth } = imageData;
    let pixelSize = 0;
    if (depth === 16) pixelSize = channels * depth / 8 / 2;
    else pixelSize = channels * depth / 8;
    // Process each pass
    for(let passIndex = 0; passIndex < 7; passIndex++){
        const pass = passes[passIndex];
        const passWidth = Math.floor((width - pass.x + pass.xStep - 1) / pass.xStep);
        const passHeight = Math.floor((height - pass.y + pass.yStep - 1) / pass.yStep);
        if (passWidth <= 0 || passHeight <= 0) continue;
        const passLineBytes = passWidth * pixelSize;
        // For each scanline in this pass
        for(let y = 0; y < passHeight; y++){
            const imageY = pass.y + y * pass.yStep;
            // Extract raw scanline data
            const rawScanline = depth <= 8 ? new Uint8Array(passLineBytes) : new Uint16Array(passLineBytes);
            let rawOffset = 0;
            for(let x = 0; x < passWidth; x++){
                const imageX = pass.x + x * pass.xStep;
                if (imageX < width && imageY < height) {
                    const srcPos = (imageY * width + imageX) * pixelSize;
                    for(let i = 0; i < pixelSize; i++)rawScanline[rawOffset++] = data[srcPos + i];
                }
            }
            newData.writeByte(0); // no filter
            if (depth === 8) newData.writeBytes(rawScanline);
            else if (depth === 16) for (const value of rawScanline){
                newData.writeByte(value >> 8 & 0xff); // High byte
                newData.writeByte(value & 0xff);
            }
        }
    }
    return offset;
}
function $205ab75bcf37547a$var$writeDataUint16(data, newData, slotsPerLine, offset) {
    for(let j = 0; j < slotsPerLine; j++)newData.writeUint16(data[offset++]);
    return offset;
}



var $be35850c79bfde93$export$ba7e3928a2814288;
(function(ResolutionUnitSpecifier) {
    /**
     * Unit is unknown
     */ ResolutionUnitSpecifier[ResolutionUnitSpecifier["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * Unit is the metre
     */ ResolutionUnitSpecifier[ResolutionUnitSpecifier["METRE"] = 1] = "METRE";
})($be35850c79bfde93$export$ba7e3928a2814288 || ($be35850c79bfde93$export$ba7e3928a2814288 = {}));


/**
 * Converts indexed data into RGB/RGBA format
 * @param decodedImage - Image to decode data from.
 * @returns Uint8Array with RGB data.
 */ function $2a4aadf2419cea27$export$83c94b26563411c8(decodedImage) {
    const palette = decodedImage.palette;
    const depth = decodedImage.depth;
    if (!palette) throw new Error('Color palette is undefined.');
    $2a4aadf2419cea27$var$checkDataSize(decodedImage);
    const indexSize = decodedImage.width * decodedImage.height;
    const resSize = indexSize * palette[0].length;
    const res = new Uint8Array(resSize);
    let indexPos = 0;
    let offset = 0;
    const indexes = new Uint8Array(indexSize);
    let bit = 0xff;
    switch(depth){
        case 1:
            bit = 0x80;
            break;
        case 2:
            bit = 0xc0;
            break;
        case 4:
            bit = 0xf0;
            break;
        case 8:
            bit = 0xff;
            break;
        default:
            throw new Error('Incorrect depth value');
    }
    for (const byte of decodedImage.data){
        let bit2 = bit;
        let shift = 8;
        while(bit2){
            shift -= depth;
            indexes[indexPos++] = (byte & bit2) >> shift;
            bit2 = bit2 >> depth;
            if (indexPos % decodedImage.width === 0) break;
        }
    }
    if (decodedImage.palette) for (const index of indexes){
        const color = decodedImage.palette.at(index);
        if (!color) throw new Error('Incorrect index of palette color');
        res.set(color, offset);
        offset += color.length;
    }
    return res;
}
function $2a4aadf2419cea27$var$checkDataSize(image) {
    const expectedSize = image.depth < 8 ? Math.ceil(image.width * image.depth / 8) * image.height * image.channels : image.width * image.height * image.channels;
    if (image.data.length !== expectedSize) throw new RangeError(`wrong data size. Found ${image.data.length}, expected ${expectedSize}`);
}


function $dfd807573f842b61$export$2f872c0f2117be69(data, options) {
    const decoder = new (0, $3145a3311b7576e1$export$2e2bcd8739ae039)(data, options);
    return decoder.decode();
}
function $dfd807573f842b61$export$c564cdbbe6da493(png, options) {
    const encoder = new (0, $205ab75bcf37547a$export$2e2bcd8739ae039)(png, options);
    return encoder.encode();
}
function $dfd807573f842b61$export$2a608823614fb725(data, options) {
    const decoder = new (0, $3145a3311b7576e1$export$2e2bcd8739ae039)(data, options);
    return decoder.decodeApng();
}


var $ffaeb8e02004bf5e$var$i = function() {
    return "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : this;
}();
function $ffaeb8e02004bf5e$var$a() {
    $ffaeb8e02004bf5e$var$i.console && "function" == typeof $ffaeb8e02004bf5e$var$i.console.log && $ffaeb8e02004bf5e$var$i.console.log.apply($ffaeb8e02004bf5e$var$i.console, arguments);
}
var $ffaeb8e02004bf5e$var$o = {
    log: $ffaeb8e02004bf5e$var$a,
    warn: function(t) {
        $ffaeb8e02004bf5e$var$i.console && ("function" == typeof $ffaeb8e02004bf5e$var$i.console.warn ? $ffaeb8e02004bf5e$var$i.console.warn.apply($ffaeb8e02004bf5e$var$i.console, arguments) : $ffaeb8e02004bf5e$var$a.call(null, arguments));
    },
    error: function(t) {
        $ffaeb8e02004bf5e$var$i.console && ("function" == typeof $ffaeb8e02004bf5e$var$i.console.error ? $ffaeb8e02004bf5e$var$i.console.error.apply($ffaeb8e02004bf5e$var$i.console, arguments) : $ffaeb8e02004bf5e$var$a(t));
    }
};
function $ffaeb8e02004bf5e$var$s(t, e, n) {
    var r = new XMLHttpRequest;
    r.open("GET", t), r.responseType = "blob", r.onload = function() {
        $ffaeb8e02004bf5e$var$l(r.response, e, n);
    }, r.onerror = function() {
        $ffaeb8e02004bf5e$var$o.error("could not download file");
    }, r.send();
}
function $ffaeb8e02004bf5e$var$u(t) {
    var e = new XMLHttpRequest;
    e.open("HEAD", t, !1);
    try {
        e.send();
    } catch (n) {}
    return e.status >= 200 && e.status <= 299;
}
function $ffaeb8e02004bf5e$var$c(t) {
    try {
        t.dispatchEvent(new MouseEvent("click"));
    } catch (n) {
        var e = document.createEvent("MouseEvents");
        e.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), t.dispatchEvent(e);
    }
}
var $ffaeb8e02004bf5e$var$l = $ffaeb8e02004bf5e$var$i.saveAs || ("object" !== ("undefined" == typeof window ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(window)) || window !== $ffaeb8e02004bf5e$var$i ? function() {} : "undefined" != typeof HTMLAnchorElement && "download" in HTMLAnchorElement.prototype ? function(t, e, n) {
    var r = $ffaeb8e02004bf5e$var$i.URL || $ffaeb8e02004bf5e$var$i.webkitURL, a = document.createElement("a");
    e = e || t.name || "download", a.download = e, a.rel = "noopener", "string" == typeof t ? (a.href = t, a.origin !== location.origin ? $ffaeb8e02004bf5e$var$u(a.href) ? $ffaeb8e02004bf5e$var$s(t, e, n) : $ffaeb8e02004bf5e$var$c(a, a.target = "_blank") : $ffaeb8e02004bf5e$var$c(a)) : (a.href = r.createObjectURL(t), setTimeout(function() {
        r.revokeObjectURL(a.href);
    }, 4e4), setTimeout(function() {
        $ffaeb8e02004bf5e$var$c(a);
    }, 0));
} : "msSaveOrOpenBlob" in navigator ? function(e, n, r) {
    if (n = n || e.name || "download", "string" == typeof e) {
        if ($ffaeb8e02004bf5e$var$u(e)) $ffaeb8e02004bf5e$var$s(e, n, r);
        else {
            var i = document.createElement("a");
            i.href = e, i.target = "_blank", setTimeout(function() {
                $ffaeb8e02004bf5e$var$c(i);
            });
        }
    } else navigator.msSaveOrOpenBlob(function(e, n) {
        return void 0 === n ? n = {
            autoBom: !1
        } : "object" !== (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(n) && ($ffaeb8e02004bf5e$var$o.warn("Deprecated: Expected third argument to be a object"), n = {
            autoBom: !n
        }), n.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob([
            String.fromCharCode(65279),
            e
        ], {
            type: e.type
        }) : e;
    }(e, r), n);
} : function(e, n, r, a) {
    if ((a = a || open("", "_blank")) && (a.document.title = a.document.body.innerText = "downloading..."), "string" == typeof e) return $ffaeb8e02004bf5e$var$s(e, n, r);
    var o = "application/octet-stream" === e.type, u = /constructor/i.test($ffaeb8e02004bf5e$var$i.HTMLElement) || $ffaeb8e02004bf5e$var$i.safari, c = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((c || o && u) && "object" === ("undefined" == typeof FileReader ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(FileReader))) {
        var l = new FileReader;
        l.onloadend = function() {
            var t = l.result;
            t = c ? t : t.replace(/^data:[^;]*;/, "data:attachment/file;"), a ? a.location.href = t : location = t, a = null;
        }, l.readAsDataURL(e);
    } else {
        var h = $ffaeb8e02004bf5e$var$i.URL || $ffaeb8e02004bf5e$var$i.webkitURL, f = h.createObjectURL(e);
        a ? a.location = f : location.href = f, a = null, setTimeout(function() {
            h.revokeObjectURL(f);
        }, 4e4);
    }
});
/**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
 * @license Use it if you like it
 */ function $ffaeb8e02004bf5e$var$h(t) {
    var e;
    t = t || "", this.ok = !1, "#" == t.charAt(0) && (t = t.substr(1, 6)), t = ({
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "00ffff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000000",
        blanchedalmond: "ffebcd",
        blue: "0000ff",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "00ffff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dodgerblue: "1e90ff",
        feldspar: "d19275",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "ff00ff",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgrey: "d3d3d3",
        lightgreen: "90ee90",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslateblue: "8470ff",
        lightslategray: "778899",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "00ff00",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "ff00ff",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370d8",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "d87093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        red: "ff0000",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        violetred: "d02090",
        wheat: "f5deb3",
        white: "ffffff",
        whitesmoke: "f5f5f5",
        yellow: "ffff00",
        yellowgreen: "9acd32"
    })[t = (t = t.replace(/ /g, "")).toLowerCase()] || t;
    for(var n = [
        {
            re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
            example: [
                "rgb(123, 234, 45)",
                "rgb(255,234,245)"
            ],
            process: function(t) {
                return [
                    parseInt(t[1]),
                    parseInt(t[2]),
                    parseInt(t[3])
                ];
            }
        },
        {
            re: /^(\w{2})(\w{2})(\w{2})$/,
            example: [
                "#00ff00",
                "336699"
            ],
            process: function(t) {
                return [
                    parseInt(t[1], 16),
                    parseInt(t[2], 16),
                    parseInt(t[3], 16)
                ];
            }
        },
        {
            re: /^(\w{1})(\w{1})(\w{1})$/,
            example: [
                "#fb0",
                "f0f"
            ],
            process: function(t) {
                return [
                    parseInt(t[1] + t[1], 16),
                    parseInt(t[2] + t[2], 16),
                    parseInt(t[3] + t[3], 16)
                ];
            }
        }
    ], r = 0; r < n.length; r++){
        var i = n[r].re, a = n[r].process, o = i.exec(t);
        o && (e = a(o), this.r = e[0], this.g = e[1], this.b = e[2], this.ok = !0);
    }
    this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.toRGB = function() {
        return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
    }, this.toHex = function() {
        var t = this.r.toString(16), e = this.g.toString(16), n = this.b.toString(16);
        return 1 == t.length && (t = "0" + t), 1 == e.length && (e = "0" + e), 1 == n.length && (n = "0" + n), "#" + t + e + n;
    };
}
var $ffaeb8e02004bf5e$var$f = $ffaeb8e02004bf5e$var$i.atob.bind($ffaeb8e02004bf5e$var$i), $ffaeb8e02004bf5e$var$d = $ffaeb8e02004bf5e$var$i.btoa.bind($ffaeb8e02004bf5e$var$i);
/**
 * @license
 * Joseph Myers does not specify a particular license for his work.
 *
 * Author: Joseph Myers
 * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
 *
 * Modified by: Owen Leong
 */ function $ffaeb8e02004bf5e$var$p(t, e) {
    var n = t[0], r = t[1], i = t[2], a = t[3];
    n = $ffaeb8e02004bf5e$var$m(n, r, i, a, e[0], 7, -680876936), a = $ffaeb8e02004bf5e$var$m(a, n, r, i, e[1], 12, -389564586), i = $ffaeb8e02004bf5e$var$m(i, a, n, r, e[2], 17, 606105819), r = $ffaeb8e02004bf5e$var$m(r, i, a, n, e[3], 22, -1044525330), n = $ffaeb8e02004bf5e$var$m(n, r, i, a, e[4], 7, -176418897), a = $ffaeb8e02004bf5e$var$m(a, n, r, i, e[5], 12, 1200080426), i = $ffaeb8e02004bf5e$var$m(i, a, n, r, e[6], 17, -1473231341), r = $ffaeb8e02004bf5e$var$m(r, i, a, n, e[7], 22, -45705983), n = $ffaeb8e02004bf5e$var$m(n, r, i, a, e[8], 7, 1770035416), a = $ffaeb8e02004bf5e$var$m(a, n, r, i, e[9], 12, -1958414417), i = $ffaeb8e02004bf5e$var$m(i, a, n, r, e[10], 17, -42063), r = $ffaeb8e02004bf5e$var$m(r, i, a, n, e[11], 22, -1990404162), n = $ffaeb8e02004bf5e$var$m(n, r, i, a, e[12], 7, 1804603682), a = $ffaeb8e02004bf5e$var$m(a, n, r, i, e[13], 12, -40341101), i = $ffaeb8e02004bf5e$var$m(i, a, n, r, e[14], 17, -1502002290), n = $ffaeb8e02004bf5e$var$v(n, r = $ffaeb8e02004bf5e$var$m(r, i, a, n, e[15], 22, 1236535329), i, a, e[1], 5, -165796510), a = $ffaeb8e02004bf5e$var$v(a, n, r, i, e[6], 9, -1069501632), i = $ffaeb8e02004bf5e$var$v(i, a, n, r, e[11], 14, 643717713), r = $ffaeb8e02004bf5e$var$v(r, i, a, n, e[0], 20, -373897302), n = $ffaeb8e02004bf5e$var$v(n, r, i, a, e[5], 5, -701558691), a = $ffaeb8e02004bf5e$var$v(a, n, r, i, e[10], 9, 38016083), i = $ffaeb8e02004bf5e$var$v(i, a, n, r, e[15], 14, -660478335), r = $ffaeb8e02004bf5e$var$v(r, i, a, n, e[4], 20, -405537848), n = $ffaeb8e02004bf5e$var$v(n, r, i, a, e[9], 5, 568446438), a = $ffaeb8e02004bf5e$var$v(a, n, r, i, e[14], 9, -1019803690), i = $ffaeb8e02004bf5e$var$v(i, a, n, r, e[3], 14, -187363961), r = $ffaeb8e02004bf5e$var$v(r, i, a, n, e[8], 20, 1163531501), n = $ffaeb8e02004bf5e$var$v(n, r, i, a, e[13], 5, -1444681467), a = $ffaeb8e02004bf5e$var$v(a, n, r, i, e[2], 9, -51403784), i = $ffaeb8e02004bf5e$var$v(i, a, n, r, e[7], 14, 1735328473), n = $ffaeb8e02004bf5e$var$b(n, r = $ffaeb8e02004bf5e$var$v(r, i, a, n, e[12], 20, -1926607734), i, a, e[5], 4, -378558), a = $ffaeb8e02004bf5e$var$b(a, n, r, i, e[8], 11, -2022574463), i = $ffaeb8e02004bf5e$var$b(i, a, n, r, e[11], 16, 1839030562), r = $ffaeb8e02004bf5e$var$b(r, i, a, n, e[14], 23, -35309556), n = $ffaeb8e02004bf5e$var$b(n, r, i, a, e[1], 4, -1530992060), a = $ffaeb8e02004bf5e$var$b(a, n, r, i, e[4], 11, 1272893353), i = $ffaeb8e02004bf5e$var$b(i, a, n, r, e[7], 16, -155497632), r = $ffaeb8e02004bf5e$var$b(r, i, a, n, e[10], 23, -1094730640), n = $ffaeb8e02004bf5e$var$b(n, r, i, a, e[13], 4, 681279174), a = $ffaeb8e02004bf5e$var$b(a, n, r, i, e[0], 11, -358537222), i = $ffaeb8e02004bf5e$var$b(i, a, n, r, e[3], 16, -722521979), r = $ffaeb8e02004bf5e$var$b(r, i, a, n, e[6], 23, 76029189), n = $ffaeb8e02004bf5e$var$b(n, r, i, a, e[9], 4, -640364487), a = $ffaeb8e02004bf5e$var$b(a, n, r, i, e[12], 11, -421815835), i = $ffaeb8e02004bf5e$var$b(i, a, n, r, e[15], 16, 530742520), n = $ffaeb8e02004bf5e$var$y(n, r = $ffaeb8e02004bf5e$var$b(r, i, a, n, e[2], 23, -995338651), i, a, e[0], 6, -198630844), a = $ffaeb8e02004bf5e$var$y(a, n, r, i, e[7], 10, 1126891415), i = $ffaeb8e02004bf5e$var$y(i, a, n, r, e[14], 15, -1416354905), r = $ffaeb8e02004bf5e$var$y(r, i, a, n, e[5], 21, -57434055), n = $ffaeb8e02004bf5e$var$y(n, r, i, a, e[12], 6, 1700485571), a = $ffaeb8e02004bf5e$var$y(a, n, r, i, e[3], 10, -1894986606), i = $ffaeb8e02004bf5e$var$y(i, a, n, r, e[10], 15, -1051523), r = $ffaeb8e02004bf5e$var$y(r, i, a, n, e[1], 21, -2054922799), n = $ffaeb8e02004bf5e$var$y(n, r, i, a, e[8], 6, 1873313359), a = $ffaeb8e02004bf5e$var$y(a, n, r, i, e[15], 10, -30611744), i = $ffaeb8e02004bf5e$var$y(i, a, n, r, e[6], 15, -1560198380), r = $ffaeb8e02004bf5e$var$y(r, i, a, n, e[13], 21, 1309151649), n = $ffaeb8e02004bf5e$var$y(n, r, i, a, e[4], 6, -145523070), a = $ffaeb8e02004bf5e$var$y(a, n, r, i, e[11], 10, -1120210379), i = $ffaeb8e02004bf5e$var$y(i, a, n, r, e[2], 15, 718787259), r = $ffaeb8e02004bf5e$var$y(r, i, a, n, e[9], 21, -343485551), t[0] = $ffaeb8e02004bf5e$var$P(n, t[0]), t[1] = $ffaeb8e02004bf5e$var$P(r, t[1]), t[2] = $ffaeb8e02004bf5e$var$P(i, t[2]), t[3] = $ffaeb8e02004bf5e$var$P(a, t[3]);
}
function $ffaeb8e02004bf5e$var$g(t, e, n, r, i, a) {
    return e = $ffaeb8e02004bf5e$var$P($ffaeb8e02004bf5e$var$P(e, t), $ffaeb8e02004bf5e$var$P(r, a)), $ffaeb8e02004bf5e$var$P(e << i | e >>> 32 - i, n);
}
function $ffaeb8e02004bf5e$var$m(t, e, n, r, i, a, o) {
    return $ffaeb8e02004bf5e$var$g(e & n | ~e & r, t, e, i, a, o);
}
function $ffaeb8e02004bf5e$var$v(t, e, n, r, i, a, o) {
    return $ffaeb8e02004bf5e$var$g(e & r | n & ~r, t, e, i, a, o);
}
function $ffaeb8e02004bf5e$var$b(t, e, n, r, i, a, o) {
    return $ffaeb8e02004bf5e$var$g(e ^ n ^ r, t, e, i, a, o);
}
function $ffaeb8e02004bf5e$var$y(t, e, n, r, i, a, o) {
    return $ffaeb8e02004bf5e$var$g(n ^ (e | ~r), t, e, i, a, o);
}
function $ffaeb8e02004bf5e$var$w(t) {
    var e, n = t.length, r = [
        1732584193,
        -271733879,
        -1732584194,
        271733878
    ];
    for(e = 64; e <= t.length; e += 64)$ffaeb8e02004bf5e$var$p(r, $ffaeb8e02004bf5e$var$N(t.substring(e - 64, e)));
    t = t.substring(e - 64);
    var i = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    for(e = 0; e < t.length; e++)i[e >> 2] |= t.charCodeAt(e) << (e % 4 << 3);
    if (i[e >> 2] |= 128 << (e % 4 << 3), e > 55) for($ffaeb8e02004bf5e$var$p(r, i), e = 0; e < 16; e++)i[e] = 0;
    return i[14] = 8 * n, $ffaeb8e02004bf5e$var$p(r, i), r;
}
function $ffaeb8e02004bf5e$var$N(t) {
    var e, n = [];
    for(e = 0; e < 64; e += 4)n[e >> 2] = t.charCodeAt(e) + (t.charCodeAt(e + 1) << 8) + (t.charCodeAt(e + 2) << 16) + (t.charCodeAt(e + 3) << 24);
    return n;
}
var $ffaeb8e02004bf5e$var$L = "0123456789abcdef".split("");
function $ffaeb8e02004bf5e$var$x(t) {
    for(var e = "", n = 0; n < 4; n++)e += $ffaeb8e02004bf5e$var$L[t >> 8 * n + 4 & 15] + $ffaeb8e02004bf5e$var$L[t >> 8 * n & 15];
    return e;
}
function $ffaeb8e02004bf5e$var$A(t) {
    return String.fromCharCode(255 & t, (65280 & t) >> 8, (16711680 & t) >> 16, (4278190080 & t) >> 24);
}
function $ffaeb8e02004bf5e$var$S(t) {
    return $ffaeb8e02004bf5e$var$w(t).map($ffaeb8e02004bf5e$var$A).join("");
}
var $ffaeb8e02004bf5e$var$_ = "5d41402abc4b2a76b9719d911017c592" != function(t) {
    for(var e = 0; e < t.length; e++)t[e] = $ffaeb8e02004bf5e$var$x(t[e]);
    return t.join("");
}($ffaeb8e02004bf5e$var$w("hello"));
function $ffaeb8e02004bf5e$var$P(t, e) {
    if ($ffaeb8e02004bf5e$var$_) {
        var n = (65535 & t) + (65535 & e);
        return (t >> 16) + (e >> 16) + (n >> 16) << 16 | 65535 & n;
    }
    return t + e & 4294967295;
}
/**
 * @license
 * FPDF is released under a permissive license: there is no usage restriction.
 * You may embed it freely in your application (commercial or not), with or
 * without modifications.
 *
 * Reference: http://www.fpdf.org/en/script/script37.php
 */ function $ffaeb8e02004bf5e$var$k(t, e) {
    var n, r, i, a;
    if (t !== n) {
        for(var o = (i = t, a = 1 + (256 / t.length | 0), new Array(a + 1).join(i)), s = [], u = 0; u < 256; u++)s[u] = u;
        var c = 0;
        for(u = 0; u < 256; u++){
            var l = s[u];
            c = (c + l + o.charCodeAt(u)) % 256, s[u] = s[c], s[c] = l;
        }
        n = t, r = s;
    } else s = r;
    var h = e.length, f = 0, d = 0, p = "";
    for(u = 0; u < h; u++)d = (d + (l = s[f = (f + 1) % 256])) % 256, s[f] = s[d], s[d] = l, o = s[(s[f] + s[d]) % 256], p += String.fromCharCode(e.charCodeAt(u) ^ o);
    return p;
}
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * Author: Owen Leong (@owenl131)
 * Date: 15 Oct 2020
 * References:
 * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
 * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
 * http://www.fpdf.org/en/script/script37.php
 */ var $ffaeb8e02004bf5e$var$F = {
    print: 4,
    modify: 8,
    copy: 16,
    "annot-forms": 32
};
function $ffaeb8e02004bf5e$var$I(t, e, n, r) {
    this.v = 1, this.r = 2;
    var i = 192;
    t.forEach(function(t) {
        if (void 0 !== $ffaeb8e02004bf5e$var$F.perm) throw new Error("Invalid permission: " + t);
        i += $ffaeb8e02004bf5e$var$F[t];
    }), this.padding = "(\xbfN^Nu\x8aAd\0NV\xff\xfa\x01\b..\0\xb6\xd0h>\x80/\f\xa9\xfedSiz";
    var a = (e + this.padding).substr(0, 32), o = (n + this.padding).substr(0, 32);
    this.O = this.processOwnerPassword(a, o), this.P = -(1 + (255 ^ i)), this.encryptionKey = $ffaeb8e02004bf5e$var$S(a + this.O + this.lsbFirstWord(this.P) + this.hexToBytes(r)).substr(0, 5), this.U = $ffaeb8e02004bf5e$var$k(this.encryptionKey, this.padding);
}
function $ffaeb8e02004bf5e$var$j(t) {
    if (/[^\u0000-\u00ff]/.test(t)) throw new Error("Invalid PDF Name Object: " + t + ", Only accept ASCII characters.");
    for(var e = "", n = t.length, r = 0; r < n; r++){
        var i = t.charCodeAt(r);
        e += i < 33 || 35 === i || 37 === i || 40 === i || 41 === i || 47 === i || 60 === i || 62 === i || 91 === i || 93 === i || 123 === i || 125 === i || i > 126 ? "#" + ("0" + i.toString(16)).slice(-2) : t[r];
    }
    return e;
}
function $ffaeb8e02004bf5e$var$C(e) {
    if ("object" !== (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(e)) throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
    var n = {};
    this.subscribe = function(t, e, r) {
        if (r = r || !1, "string" != typeof t || "function" != typeof e || "boolean" != typeof r) throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
        n.hasOwnProperty(t) || (n[t] = {});
        var i = Math.random().toString(35);
        return n[t][i] = [
            e,
            !!r
        ], i;
    }, this.unsubscribe = function(t) {
        for(var e in n)if (n[e][t]) return delete n[e][t], 0 === Object.keys(n[e]).length && delete n[e], !0;
        return !1;
    }, this.publish = function(t) {
        if (n.hasOwnProperty(t)) {
            var r = Array.prototype.slice.call(arguments, 1), a = [];
            for(var s in n[t]){
                var u = n[t][s];
                try {
                    u[0].apply(e, r);
                } catch (c) {
                    $ffaeb8e02004bf5e$var$i.console && $ffaeb8e02004bf5e$var$o.error("jsPDF PubSub Error", c.message, c);
                }
                u[1] && a.push(s);
            }
            a.length && a.forEach(this.unsubscribe);
        }
    }, this.getTopics = function() {
        return n;
    };
}
function $ffaeb8e02004bf5e$export$1bc649ab427a02ba(t) {
    if (!(this instanceof $ffaeb8e02004bf5e$export$1bc649ab427a02ba)) return new $ffaeb8e02004bf5e$export$1bc649ab427a02ba(t);
    var e = "opacity,stroke-opacity".split(",");
    for(var n in t)t.hasOwnProperty(n) && e.indexOf(n) >= 0 && (this[n] = t[n]);
    this.id = "", this.objectNumber = -1;
}
function $ffaeb8e02004bf5e$var$B(t, e) {
    this.gState = t, this.matrix = e, this.id = "", this.objectNumber = -1;
}
function $ffaeb8e02004bf5e$export$7235f0ad083cb4c6(t, e, n, r, i) {
    if (!(this instanceof $ffaeb8e02004bf5e$export$7235f0ad083cb4c6)) return new $ffaeb8e02004bf5e$export$7235f0ad083cb4c6(t, e, n, r, i);
    this.type = "axial" === t ? 2 : 3, this.coords = e, this.colors = n, $ffaeb8e02004bf5e$var$B.call(this, r, i);
}
function $ffaeb8e02004bf5e$export$549f717800d2b57f(t, e, n, r, i) {
    if (!(this instanceof $ffaeb8e02004bf5e$export$549f717800d2b57f)) return new $ffaeb8e02004bf5e$export$549f717800d2b57f(t, e, n, r, i);
    this.boundingBox = t, this.xStep = e, this.yStep = n, this.stream = "", this.cloneIndex = 0, $ffaeb8e02004bf5e$var$B.call(this, r, i);
}
function $ffaeb8e02004bf5e$export$2e2bcd8739ae039(e) {
    var n, r = "string" == typeof arguments[0] ? arguments[0] : "p", a = arguments[1], s = arguments[2], u = arguments[3], c = [], f = 1, p = 16, g = "S", m = null;
    "object" === (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(e = e || {}) && (r = e.orientation, a = e.unit || a, s = e.format || s, u = e.compress || e.compressPdf || u, null !== (m = e.encryption || null) && (m.userPassword = m.userPassword || "", m.ownerPassword = m.ownerPassword || "", m.userPermissions = m.userPermissions || []), f = "number" == typeof e.userUnit ? Math.abs(e.userUnit) : 1, void 0 !== e.precision && (n = e.precision), void 0 !== e.floatPrecision && (p = e.floatPrecision), g = e.defaultPathOperation || "S"), c = e.filters || (!0 === u ? [
        "FlateEncode"
    ] : c), a = a || "mm", r = ("" + (r || "P")).toLowerCase();
    var v = e.putOnlyUsedFonts || !1, b = {}, y = {
        internal: {},
        __private__: {}
    };
    y.__private__.PubSub = $ffaeb8e02004bf5e$var$C;
    var w = "1.3", N = y.__private__.getPdfVersion = function() {
        return w;
    };
    y.__private__.setPdfVersion = function(t) {
        w = t;
    };
    var L = {
        a0: [
            2383.94,
            3370.39
        ],
        a1: [
            1683.78,
            2383.94
        ],
        a2: [
            1190.55,
            1683.78
        ],
        a3: [
            841.89,
            1190.55
        ],
        a4: [
            595.28,
            841.89
        ],
        a5: [
            419.53,
            595.28
        ],
        a6: [
            297.64,
            419.53
        ],
        a7: [
            209.76,
            297.64
        ],
        a8: [
            147.4,
            209.76
        ],
        a9: [
            104.88,
            147.4
        ],
        a10: [
            73.7,
            104.88
        ],
        b0: [
            2834.65,
            4008.19
        ],
        b1: [
            2004.09,
            2834.65
        ],
        b2: [
            1417.32,
            2004.09
        ],
        b3: [
            1000.63,
            1417.32
        ],
        b4: [
            708.66,
            1000.63
        ],
        b5: [
            498.9,
            708.66
        ],
        b6: [
            354.33,
            498.9
        ],
        b7: [
            249.45,
            354.33
        ],
        b8: [
            175.75,
            249.45
        ],
        b9: [
            124.72,
            175.75
        ],
        b10: [
            87.87,
            124.72
        ],
        c0: [
            2599.37,
            3676.54
        ],
        c1: [
            1836.85,
            2599.37
        ],
        c2: [
            1298.27,
            1836.85
        ],
        c3: [
            918.43,
            1298.27
        ],
        c4: [
            649.13,
            918.43
        ],
        c5: [
            459.21,
            649.13
        ],
        c6: [
            323.15,
            459.21
        ],
        c7: [
            229.61,
            323.15
        ],
        c8: [
            161.57,
            229.61
        ],
        c9: [
            113.39,
            161.57
        ],
        c10: [
            79.37,
            113.39
        ],
        dl: [
            311.81,
            623.62
        ],
        letter: [
            612,
            792
        ],
        "government-letter": [
            576,
            756
        ],
        legal: [
            612,
            1008
        ],
        "junior-legal": [
            576,
            360
        ],
        ledger: [
            1224,
            792
        ],
        tabloid: [
            792,
            1224
        ],
        "credit-card": [
            153,
            243
        ]
    };
    y.__private__.getPageFormats = function() {
        return L;
    };
    var x = y.__private__.getPageFormat = function(t) {
        return L[t];
    };
    s = s || "a4";
    var A = "compat", S = "advanced", _ = A;
    function P() {
        this.saveGraphicsState(), lt(new Wt(St, 0, 0, -St, 0, _n() * St).toString() + " cm"), this.setFontSize(this.getFontSize() / St), g = "n", _ = S;
    }
    function k() {
        this.restoreGraphicsState(), g = "S", _ = A;
    }
    var F = y.__private__.combineFontStyleAndFontWeight = function(t, e) {
        if ("bold" == t && "normal" == e || "bold" == t && 400 == e || "normal" == t && "italic" == e || "bold" == t && "italic" == e) throw new Error("Invalid Combination of fontweight and fontstyle");
        return e && (t = 400 == e || "normal" === e ? "italic" === t ? "italic" : "normal" : 700 != e && "bold" !== e || "normal" !== t ? (700 == e ? "bold" : e) + "" + t : "bold"), t;
    };
    y.advancedAPI = function(t) {
        var e = _ === A;
        return e && P.call(this), "function" != typeof t || (t(this), e && k.call(this)), this;
    }, y.compatAPI = function(t) {
        var e = _ === S;
        return e && k.call(this), "function" != typeof t || (t(this), e && P.call(this)), this;
    }, y.isAdvancedAPI = function() {
        return _ === S;
    };
    var B, R = function(t) {
        if (_ !== S) throw new Error(t + " is only available in 'advanced' API mode. You need to call advancedAPI() first.");
    }, D = y.roundToPrecision = y.__private__.roundToPrecision = function(t, e) {
        var r = n || e;
        if (isNaN(t) || isNaN(r)) throw new Error("Invalid argument passed to jsPDF.roundToPrecision");
        return t.toFixed(r).replace(/0+$/, "");
    };
    B = y.hpf = y.__private__.hpf = "number" == typeof p ? function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, p);
    } : "smart" === p ? function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, t > -1 && t < 1 ? 16 : 5);
    } : function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, 16);
    };
    var T = y.f2 = y.__private__.f2 = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f2");
        return D(t, 2);
    }, z = y.__private__.f3 = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f3");
        return D(t, 3);
    }, U = y.scale = y.__private__.scale = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.scale");
        return _ === A ? t * St : _ === S ? t : void 0;
    }, H = function(t) {
        return U(function(t) {
            return _ === A ? _n() - t : _ === S ? t : void 0;
        }(t));
    };
    y.__private__.setPrecision = y.setPrecision = function(t) {
        "number" == typeof parseInt(t, 10) && (n = parseInt(t, 10));
    };
    var W, V = "00000000000000000000000000000000", G = y.__private__.getFileId = function() {
        return V;
    }, Y = y.__private__.setFileId = function(t) {
        return V = void 0 !== t && /^[a-fA-F0-9]{32}$/.test(t) ? t.toUpperCase() : V.split("").map(function() {
            return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
        }).join(""), null !== m && (je = new $ffaeb8e02004bf5e$var$I(m.userPermissions, m.userPassword, m.ownerPassword, V)), V;
    };
    y.setFileId = function(t) {
        return Y(t), this;
    }, y.getFileId = function() {
        return G();
    };
    var J = y.__private__.convertDateToPDFDate = function(t) {
        var e = t.getTimezoneOffset(), n = e < 0 ? "+" : "-", r = Math.floor(Math.abs(e / 60)), i = Math.abs(e % 60), a = [
            n,
            Q(r),
            "'",
            Q(i),
            "'"
        ].join("");
        return [
            "D:",
            t.getFullYear(),
            Q(t.getMonth() + 1),
            Q(t.getDate()),
            Q(t.getHours()),
            Q(t.getMinutes()),
            Q(t.getSeconds()),
            a
        ].join("");
    }, X = y.__private__.convertPDFDateToDate = function(t) {
        var e = parseInt(t.substr(2, 4), 10), n = parseInt(t.substr(6, 2), 10) - 1, r = parseInt(t.substr(8, 2), 10), i = parseInt(t.substr(10, 2), 10), a = parseInt(t.substr(12, 2), 10), o = parseInt(t.substr(14, 2), 10);
        return new Date(e, n, r, i, a, o, 0);
    }, K = y.__private__.setCreationDate = function(t) {
        var e;
        if (void 0 === t && (t = new Date), t instanceof Date) e = J(t);
        else {
            if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(t)) throw new Error("Invalid argument passed to jsPDF.setCreationDate");
            e = t;
        }
        return W = e;
    }, Z = y.__private__.getCreationDate = function(t) {
        var e = W;
        return "jsDate" === t && (e = X(W)), e;
    };
    y.setCreationDate = function(t) {
        return K(t), this;
    }, y.getCreationDate = function(t) {
        return Z(t);
    };
    var $, Q = y.__private__.padd2 = function(t) {
        return ("0" + parseInt(t)).slice(-2);
    }, tt = y.__private__.padd2Hex = function(t) {
        return ("00" + (t = t.toString())).substr(t.length);
    }, et = 0, nt = [], rt = [], it = 0, at = [], ot = [], st = !1, ut = rt;
    y.__private__.setCustomOutputDestination = function(t) {
        st = !0, ut = t;
    };
    var ct = function(t) {
        st || (ut = t);
    };
    y.__private__.resetCustomOutputDestination = function() {
        st = !1, ut = rt;
    };
    var lt = y.__private__.out = function(t) {
        return t = t.toString(), it += t.length + 1, ut.push(t), ut;
    }, ht = y.__private__.write = function(t) {
        return lt(1 === arguments.length ? t.toString() : Array.prototype.join.call(arguments, " "));
    }, ft = y.__private__.getArrayBuffer = function(t) {
        for(var e = t.length, n = new ArrayBuffer(e), r = new Uint8Array(n); e--;)r[e] = t.charCodeAt(e);
        return n;
    }, dt = [
        [
            "Helvetica",
            "helvetica",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-Bold",
            "helvetica",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-Oblique",
            "helvetica",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-BoldOblique",
            "helvetica",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "Courier",
            "courier",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Courier-Bold",
            "courier",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Courier-Oblique",
            "courier",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Courier-BoldOblique",
            "courier",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "Times-Roman",
            "times",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Times-Bold",
            "times",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Times-Italic",
            "times",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Times-BoldItalic",
            "times",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "ZapfDingbats",
            "zapfdingbats",
            "normal",
            null
        ],
        [
            "Symbol",
            "symbol",
            "normal",
            null
        ]
    ];
    y.__private__.getStandardFonts = function() {
        return dt;
    };
    var pt = e.fontSize || 16;
    y.__private__.setFontSize = y.setFontSize = function(t) {
        return pt = _ === S ? t / St : t, this;
    };
    var gt, mt = y.__private__.getFontSize = y.getFontSize = function() {
        return _ === A ? pt : pt * St;
    }, vt = e.R2L || !1;
    y.__private__.setR2L = y.setR2L = function(t) {
        return vt = t, this;
    }, y.__private__.getR2L = y.getR2L = function() {
        return vt;
    };
    var bt, yt = y.__private__.setZoomMode = function(t) {
        if (/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(t)) gt = t;
        else if (isNaN(t)) {
            if (-1 === [
                void 0,
                null,
                "fullwidth",
                "fullheight",
                "fullpage",
                "original"
            ].indexOf(t)) throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + t + '" is not recognized.');
            gt = t;
        } else gt = parseInt(t, 10);
    };
    y.__private__.getZoomMode = function() {
        return gt;
    };
    var wt, Nt = y.__private__.setPageMode = function(t) {
        if (-1 == [
            void 0,
            null,
            "UseNone",
            "UseOutlines",
            "UseThumbs",
            "FullScreen"
        ].indexOf(t)) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + t + '" is not recognized.');
        bt = t;
    };
    y.__private__.getPageMode = function() {
        return bt;
    };
    var Lt = y.__private__.setLayoutMode = function(t) {
        if (-1 == [
            void 0,
            null,
            "continuous",
            "single",
            "twoleft",
            "tworight",
            "two"
        ].indexOf(t)) throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + t + '" is not recognized.');
        wt = t;
    };
    y.__private__.getLayoutMode = function() {
        return wt;
    }, y.__private__.setDisplayMode = y.setDisplayMode = function(t, e, n) {
        return yt(t), Lt(e), Nt(n), this;
    };
    var xt = {
        title: "",
        subject: "",
        author: "",
        keywords: "",
        creator: ""
    };
    y.__private__.getDocumentProperty = function(t) {
        if (-1 === Object.keys(xt).indexOf(t)) throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
        return xt[t];
    }, y.__private__.getDocumentProperties = function() {
        return xt;
    }, y.__private__.setDocumentProperties = y.setProperties = y.setDocumentProperties = function(t) {
        for(var e in xt)xt.hasOwnProperty(e) && t[e] && (xt[e] = t[e]);
        return this;
    }, y.__private__.setDocumentProperty = function(t, e) {
        if (-1 === Object.keys(xt).indexOf(t)) throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
        return xt[t] = e;
    };
    var At, St, _t, Pt, kt, Ft = {}, It = {}, jt = [], Ct = {}, Ot = {}, Bt = {}, Mt = {}, qt = null, Et = 0, Rt = [], Dt = new $ffaeb8e02004bf5e$var$C(y), Tt = e.hotfixes || [], zt = {}, Ut = {}, Ht = [], Wt = function t(e, n, r, i, a, o) {
        if (!(this instanceof t)) return new t(e, n, r, i, a, o);
        isNaN(e) && (e = 1), isNaN(n) && (n = 0), isNaN(r) && (r = 0), isNaN(i) && (i = 1), isNaN(a) && (a = 0), isNaN(o) && (o = 0), this._matrix = [
            e,
            n,
            r,
            i,
            a,
            o
        ];
    };
    Object.defineProperty(Wt.prototype, "sx", {
        get: function() {
            return this._matrix[0];
        },
        set: function(t) {
            this._matrix[0] = t;
        }
    }), Object.defineProperty(Wt.prototype, "shy", {
        get: function() {
            return this._matrix[1];
        },
        set: function(t) {
            this._matrix[1] = t;
        }
    }), Object.defineProperty(Wt.prototype, "shx", {
        get: function() {
            return this._matrix[2];
        },
        set: function(t) {
            this._matrix[2] = t;
        }
    }), Object.defineProperty(Wt.prototype, "sy", {
        get: function() {
            return this._matrix[3];
        },
        set: function(t) {
            this._matrix[3] = t;
        }
    }), Object.defineProperty(Wt.prototype, "tx", {
        get: function() {
            return this._matrix[4];
        },
        set: function(t) {
            this._matrix[4] = t;
        }
    }), Object.defineProperty(Wt.prototype, "ty", {
        get: function() {
            return this._matrix[5];
        },
        set: function(t) {
            this._matrix[5] = t;
        }
    }), Object.defineProperty(Wt.prototype, "a", {
        get: function() {
            return this._matrix[0];
        },
        set: function(t) {
            this._matrix[0] = t;
        }
    }), Object.defineProperty(Wt.prototype, "b", {
        get: function() {
            return this._matrix[1];
        },
        set: function(t) {
            this._matrix[1] = t;
        }
    }), Object.defineProperty(Wt.prototype, "c", {
        get: function() {
            return this._matrix[2];
        },
        set: function(t) {
            this._matrix[2] = t;
        }
    }), Object.defineProperty(Wt.prototype, "d", {
        get: function() {
            return this._matrix[3];
        },
        set: function(t) {
            this._matrix[3] = t;
        }
    }), Object.defineProperty(Wt.prototype, "e", {
        get: function() {
            return this._matrix[4];
        },
        set: function(t) {
            this._matrix[4] = t;
        }
    }), Object.defineProperty(Wt.prototype, "f", {
        get: function() {
            return this._matrix[5];
        },
        set: function(t) {
            this._matrix[5] = t;
        }
    }), Object.defineProperty(Wt.prototype, "rotation", {
        get: function() {
            return Math.atan2(this.shx, this.sx);
        }
    }), Object.defineProperty(Wt.prototype, "scaleX", {
        get: function() {
            return this.decompose().scale.sx;
        }
    }), Object.defineProperty(Wt.prototype, "scaleY", {
        get: function() {
            return this.decompose().scale.sy;
        }
    }), Object.defineProperty(Wt.prototype, "isIdentity", {
        get: function() {
            return 1 === this.sx && 0 === this.shy && 0 === this.shx && 1 === this.sy && 0 === this.tx && 0 === this.ty;
        }
    }), Wt.prototype.join = function(t) {
        return [
            this.sx,
            this.shy,
            this.shx,
            this.sy,
            this.tx,
            this.ty
        ].map(B).join(t);
    }, Wt.prototype.multiply = function(t) {
        var e = t.sx * this.sx + t.shy * this.shx, n = t.sx * this.shy + t.shy * this.sy, r = t.shx * this.sx + t.sy * this.shx, i = t.shx * this.shy + t.sy * this.sy, a = t.tx * this.sx + t.ty * this.shx + this.tx, o = t.tx * this.shy + t.ty * this.sy + this.ty;
        return new Wt(e, n, r, i, a, o);
    }, Wt.prototype.decompose = function() {
        var t = this.sx, e = this.shy, n = this.shx, r = this.sy, i = this.tx, a = this.ty, o = Math.sqrt(t * t + e * e), s = (t /= o) * n + (e /= o) * r;
        n -= t * s, r -= e * s;
        var u = Math.sqrt(n * n + r * r);
        return s /= u, t * (r /= u) < e * (n /= u) && (t = -t, e = -e, s = -s, o = -o), {
            scale: new Wt(o, 0, 0, u, 0, 0),
            translate: new Wt(1, 0, 0, 1, i, a),
            rotate: new Wt(t, e, -e, t, 0, 0),
            skew: new Wt(1, 0, s, 1, 0, 0)
        };
    }, Wt.prototype.toString = function(t) {
        return this.join(" ");
    }, Wt.prototype.inversed = function() {
        var t = this.sx, e = this.shy, n = this.shx, r = this.sy, i = this.tx, a = this.ty, o = 1 / (t * r - e * n), s = r * o, u = -e * o, c = -n * o, l = t * o;
        return new Wt(s, u, c, l, -s * i - c * a, -u * i - l * a);
    }, Wt.prototype.applyToPoint = function(t) {
        var e = t.x * this.sx + t.y * this.shx + this.tx, n = t.x * this.shy + t.y * this.sy + this.ty;
        return new gn(e, n);
    }, Wt.prototype.applyToRectangle = function(t) {
        var e = this.applyToPoint(t), n = this.applyToPoint(new gn(t.x + t.w, t.y + t.h));
        return new mn(e.x, e.y, n.x - e.x, n.y - e.y);
    }, Wt.prototype.clone = function() {
        var t = this.sx, e = this.shy, n = this.shx, r = this.sy, i = this.tx, a = this.ty;
        return new Wt(t, e, n, r, i, a);
    }, y.Matrix = Wt;
    var Vt = y.matrixMult = function(t, e) {
        return e.multiply(t);
    }, Gt = new Wt(1, 0, 0, 1, 0, 0);
    y.unitMatrix = y.identityMatrix = Gt;
    var Yt = function(t, e) {
        if (!Ot[t]) {
            var n = (e instanceof $ffaeb8e02004bf5e$export$7235f0ad083cb4c6 ? "Sh" : "P") + (Object.keys(Ct).length + 1).toString(10);
            e.id = n, Ot[t] = n, Ct[n] = e, Dt.publish("addPattern", e);
        }
    };
    y.ShadingPattern = $ffaeb8e02004bf5e$export$7235f0ad083cb4c6, y.TilingPattern = $ffaeb8e02004bf5e$export$549f717800d2b57f, y.addShadingPattern = function(t, e) {
        return R("addShadingPattern()"), Yt(t, e), this;
    }, y.beginTilingPattern = function(t) {
        R("beginTilingPattern()"), bn(t.boundingBox[0], t.boundingBox[1], t.boundingBox[2] - t.boundingBox[0], t.boundingBox[3] - t.boundingBox[1], t.matrix);
    }, y.endTilingPattern = function(t, e) {
        R("endTilingPattern()"), e.stream = ot[$].join("\n"), Yt(t, e), Dt.publish("endTilingPattern", e), Ht.pop().restore();
    };
    var Jt, Xt = y.__private__.newObject = function() {
        var t = Kt();
        return Zt(t, !0), t;
    }, Kt = y.__private__.newObjectDeferred = function() {
        return et++, nt[et] = function() {
            return it;
        }, et;
    }, Zt = function(t, e) {
        return e = "boolean" == typeof e && e, nt[t] = it, e && lt(t + " 0 obj"), t;
    }, $t = y.__private__.newAdditionalObject = function() {
        var t = {
            objId: Kt(),
            content: ""
        };
        return at.push(t), t;
    }, Qt = Kt(), te = Kt(), ee = y.__private__.decodeColorString = function(t) {
        var e = t.split(" ");
        if (2 !== e.length || "g" !== e[1] && "G" !== e[1]) 5 !== e.length || "k" !== e[4] && "K" !== e[4] || (e = [
            (1 - e[0]) * (1 - e[3]),
            (1 - e[1]) * (1 - e[3]),
            (1 - e[2]) * (1 - e[3]),
            "r"
        ]);
        else {
            var n = parseFloat(e[0]);
            e = [
                n,
                n,
                n,
                "r"
            ];
        }
        for(var r = "#", i = 0; i < 3; i++)r += ("0" + Math.floor(255 * parseFloat(e[i])).toString(16)).slice(-2);
        return r;
    }, ne = y.__private__.encodeColorString = function(e) {
        var n;
        "string" == typeof e && (e = {
            ch1: e
        });
        var r = e.ch1, i = e.ch2, a = e.ch3, o = e.ch4, s = "draw" === e.pdfColorType ? [
            "G",
            "RG",
            "K"
        ] : [
            "g",
            "rg",
            "k"
        ];
        if ("string" == typeof r && "#" !== r.charAt(0)) {
            var u = new $ffaeb8e02004bf5e$var$h(r);
            if (u.ok) r = u.toHex();
            else if (!/^\d*\.?\d*$/.test(r)) throw new Error('Invalid color "' + r + '" passed to jsPDF.encodeColorString.');
        }
        if ("string" == typeof r && /^#[0-9A-Fa-f]{3}$/.test(r) && (r = "#" + r[1] + r[1] + r[2] + r[2] + r[3] + r[3]), "string" == typeof r && /^#[0-9A-Fa-f]{6}$/.test(r)) {
            var c = parseInt(r.substr(1), 16);
            r = c >> 16 & 255, i = c >> 8 & 255, a = 255 & c;
        }
        if (void 0 === i || void 0 === o && r === i && i === a) n = "string" == typeof r ? r + " " + s[0] : 2 === e.precision ? T(r / 255) + " " + s[0] : z(r / 255) + " " + s[0];
        else if (void 0 === o || "object" === (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(o)) {
            if (o && !isNaN(o.a) && 0 === o.a) return [
                "1.",
                "1.",
                "1.",
                s[1]
            ].join(" ");
            n = "string" == typeof r ? [
                r,
                i,
                a,
                s[1]
            ].join(" ") : 2 === e.precision ? [
                T(r / 255),
                T(i / 255),
                T(a / 255),
                s[1]
            ].join(" ") : [
                z(r / 255),
                z(i / 255),
                z(a / 255),
                s[1]
            ].join(" ");
        } else n = "string" == typeof r ? [
            r,
            i,
            a,
            o,
            s[2]
        ].join(" ") : 2 === e.precision ? [
            T(r),
            T(i),
            T(a),
            T(o),
            s[2]
        ].join(" ") : [
            z(r),
            z(i),
            z(a),
            z(o),
            s[2]
        ].join(" ");
        return n;
    }, re = y.__private__.getFilters = function() {
        return c;
    }, ie = y.__private__.putStream = function(t) {
        var e = (t = t || {}).data || "", n = t.filters || re(), r = t.alreadyAppliedFilters || [], i = t.addLength1 || !1, a = e.length, o = t.objectId, s = function(t) {
            return t;
        };
        if (null !== m && void 0 === o) throw new Error("ObjectId must be passed to putStream for file encryption");
        null !== m && (s = je.encryptor(o, 0));
        var u = {};
        !0 === n && (n = [
            "FlateEncode"
        ]);
        var c = t.additionalKeyValues || [], l = (u = void 0 !== $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.processDataByFilters ? $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.processDataByFilters(e, n) : {
            data: e,
            reverseChain: []
        }).reverseChain + (Array.isArray(r) ? r.join(" ") : r.toString());
        if (0 !== u.data.length && (c.push({
            key: "Length",
            value: u.data.length
        }), !0 === i && c.push({
            key: "Length1",
            value: a
        })), 0 != l.length) {
            if (l.split("/").length - 1 == 1) c.push({
                key: "Filter",
                value: l
            });
            else {
                c.push({
                    key: "Filter",
                    value: "[" + l + "]"
                });
                for(var h = 0; h < c.length; h += 1)if ("DecodeParms" === c[h].key) {
                    for(var f = [], d = 0; d < u.reverseChain.split("/").length - 1; d += 1)f.push("null");
                    f.push(c[h].value), c[h].value = "[" + f.join(" ") + "]";
                }
            }
        }
        lt("<<");
        for(var p = 0; p < c.length; p++)lt("/" + c[p].key + " " + c[p].value);
        lt(">>"), 0 !== u.data.length && (lt("stream"), lt(s(u.data)), lt("endstream"));
    }, ae = y.__private__.putPage = function(t) {
        var e = t.number, n = t.data, r = t.objId, i = t.contentsObjId;
        Zt(r, !0), lt("<</Type /Page"), lt("/Parent " + t.rootDictionaryObjId + " 0 R"), lt("/Resources " + t.resourceDictionaryObjId + " 0 R"), lt("/MediaBox [" + parseFloat(B(t.mediaBox.bottomLeftX)) + " " + parseFloat(B(t.mediaBox.bottomLeftY)) + " " + B(t.mediaBox.topRightX) + " " + B(t.mediaBox.topRightY) + "]"), null !== t.cropBox && lt("/CropBox [" + B(t.cropBox.bottomLeftX) + " " + B(t.cropBox.bottomLeftY) + " " + B(t.cropBox.topRightX) + " " + B(t.cropBox.topRightY) + "]"), null !== t.bleedBox && lt("/BleedBox [" + B(t.bleedBox.bottomLeftX) + " " + B(t.bleedBox.bottomLeftY) + " " + B(t.bleedBox.topRightX) + " " + B(t.bleedBox.topRightY) + "]"), null !== t.trimBox && lt("/TrimBox [" + B(t.trimBox.bottomLeftX) + " " + B(t.trimBox.bottomLeftY) + " " + B(t.trimBox.topRightX) + " " + B(t.trimBox.topRightY) + "]"), null !== t.artBox && lt("/ArtBox [" + B(t.artBox.bottomLeftX) + " " + B(t.artBox.bottomLeftY) + " " + B(t.artBox.topRightX) + " " + B(t.artBox.topRightY) + "]"), "number" == typeof t.userUnit && 1 !== t.userUnit && lt("/UserUnit " + t.userUnit), Dt.publish("putPage", {
            objId: r,
            pageContext: Rt[e],
            pageNumber: e,
            page: n
        }), lt("/Contents " + i + " 0 R"), lt(">>"), lt("endobj");
        var a = n.join("\n");
        return _ === S && (a += "\nQ"), Zt(i, !0), ie({
            data: a,
            filters: re(),
            objectId: i
        }), lt("endobj"), r;
    }, oe = y.__private__.putPages = function() {
        var t, e, n = [];
        for(t = 1; t <= Et; t++)Rt[t].objId = Kt(), Rt[t].contentsObjId = Kt();
        for(t = 1; t <= Et; t++)n.push(ae({
            number: t,
            data: ot[t],
            objId: Rt[t].objId,
            contentsObjId: Rt[t].contentsObjId,
            mediaBox: Rt[t].mediaBox,
            cropBox: Rt[t].cropBox,
            bleedBox: Rt[t].bleedBox,
            trimBox: Rt[t].trimBox,
            artBox: Rt[t].artBox,
            userUnit: Rt[t].userUnit,
            rootDictionaryObjId: Qt,
            resourceDictionaryObjId: te
        }));
        Zt(Qt, !0), lt("<</Type /Pages");
        var r = "/Kids [";
        for(e = 0; e < Et; e++)r += n[e] + " 0 R ";
        lt(r + "]"), lt("/Count " + Et), lt(">>"), lt("endobj"), Dt.publish("postPutPages");
    }, se = function(t) {
        Dt.publish("putFont", {
            font: t,
            out: lt,
            newObject: Xt,
            putStream: ie
        }), !0 !== t.isAlreadyPutted && (t.objectNumber = Xt(), lt("<<"), lt("/Type /Font"), lt("/BaseFont /" + $ffaeb8e02004bf5e$var$j(t.postScriptName)), lt("/Subtype /Type1"), "string" == typeof t.encoding && lt("/Encoding /" + t.encoding), lt("/FirstChar 32"), lt("/LastChar 255"), lt(">>"), lt("endobj"));
    }, ue = function(t) {
        t.objectNumber = Xt();
        var e = [];
        e.push({
            key: "Type",
            value: "/XObject"
        }), e.push({
            key: "Subtype",
            value: "/Form"
        }), e.push({
            key: "BBox",
            value: "[" + [
                B(t.x),
                B(t.y),
                B(t.x + t.width),
                B(t.y + t.height)
            ].join(" ") + "]"
        }), e.push({
            key: "Matrix",
            value: "[" + t.matrix.toString() + "]"
        });
        var n = t.pages[1].join("\n");
        ie({
            data: n,
            additionalKeyValues: e,
            objectId: t.objectNumber
        }), lt("endobj");
    }, ce = function(t, e) {
        e || (e = 21);
        var n = Xt(), r = function(t, e) {
            var n, r = [], i = 1 / (e - 1);
            for(n = 0; n < 1; n += i)r.push(n);
            if (r.push(1), 0 != t[0].offset) {
                var a = {
                    offset: 0,
                    color: t[0].color
                };
                t.unshift(a);
            }
            if (1 != t[t.length - 1].offset) {
                var o = {
                    offset: 1,
                    color: t[t.length - 1].color
                };
                t.push(o);
            }
            for(var s = "", u = 0, c = 0; c < r.length; c++){
                for(n = r[c]; n > t[u + 1].offset;)u++;
                var l = t[u].offset, h = (n - l) / (t[u + 1].offset - l), f = t[u].color, d = t[u + 1].color;
                s += tt(Math.round((1 - h) * f[0] + h * d[0]).toString(16)) + tt(Math.round((1 - h) * f[1] + h * d[1]).toString(16)) + tt(Math.round((1 - h) * f[2] + h * d[2]).toString(16));
            }
            return s.trim();
        }(t.colors, e), i = [];
        i.push({
            key: "FunctionType",
            value: "0"
        }), i.push({
            key: "Domain",
            value: "[0.0 1.0]"
        }), i.push({
            key: "Size",
            value: "[" + e + "]"
        }), i.push({
            key: "BitsPerSample",
            value: "8"
        }), i.push({
            key: "Range",
            value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
        }), i.push({
            key: "Decode",
            value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
        }), ie({
            data: r,
            additionalKeyValues: i,
            alreadyAppliedFilters: [
                "/ASCIIHexDecode"
            ],
            objectId: n
        }), lt("endobj"), t.objectNumber = Xt(), lt("<< /ShadingType " + t.type), lt("/ColorSpace /DeviceRGB");
        var a = "/Coords [" + B(parseFloat(t.coords[0])) + " " + B(parseFloat(t.coords[1])) + " ";
        2 === t.type ? a += B(parseFloat(t.coords[2])) + " " + B(parseFloat(t.coords[3])) : a += B(parseFloat(t.coords[2])) + " " + B(parseFloat(t.coords[3])) + " " + B(parseFloat(t.coords[4])) + " " + B(parseFloat(t.coords[5])), lt(a += "]"), t.matrix && lt("/Matrix [" + t.matrix.toString() + "]"), lt("/Function " + n + " 0 R"), lt("/Extend [true true]"), lt(">>"), lt("endobj");
    }, le = function(t, e) {
        var n = Kt(), r = Xt();
        e.push({
            resourcesOid: n,
            objectOid: r
        }), t.objectNumber = r;
        var i = [];
        i.push({
            key: "Type",
            value: "/Pattern"
        }), i.push({
            key: "PatternType",
            value: "1"
        }), i.push({
            key: "PaintType",
            value: "1"
        }), i.push({
            key: "TilingType",
            value: "1"
        }), i.push({
            key: "BBox",
            value: "[" + t.boundingBox.map(B).join(" ") + "]"
        }), i.push({
            key: "XStep",
            value: B(t.xStep)
        }), i.push({
            key: "YStep",
            value: B(t.yStep)
        }), i.push({
            key: "Resources",
            value: n + " 0 R"
        }), t.matrix && i.push({
            key: "Matrix",
            value: "[" + t.matrix.toString() + "]"
        }), ie({
            data: t.stream,
            additionalKeyValues: i,
            objectId: t.objectNumber
        }), lt("endobj");
    }, he = function(t) {
        for(var e in t.objectNumber = Xt(), lt("<<"), t)switch(e){
            case "opacity":
                lt("/ca " + T(t[e]));
                break;
            case "stroke-opacity":
                lt("/CA " + T(t[e]));
        }
        lt(">>"), lt("endobj");
    }, fe = function(t) {
        Zt(t.resourcesOid, !0), lt("<<"), lt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), function() {
            for(var t in lt("/Font <<"), Ft)Ft.hasOwnProperty(t) && (!1 === v || !0 === v && b.hasOwnProperty(t)) && lt("/" + t + " " + Ft[t].objectNumber + " 0 R");
            lt(">>");
        }(), function() {
            if (Object.keys(Ct).length > 0) {
                for(var t in lt("/Shading <<"), Ct)Ct.hasOwnProperty(t) && Ct[t] instanceof $ffaeb8e02004bf5e$export$7235f0ad083cb4c6 && Ct[t].objectNumber >= 0 && lt("/" + t + " " + Ct[t].objectNumber + " 0 R");
                Dt.publish("putShadingPatternDict"), lt(">>");
            }
        }(), function(t) {
            if (Object.keys(Ct).length > 0) {
                for(var e in lt("/Pattern <<"), Ct)Ct.hasOwnProperty(e) && Ct[e] instanceof y.TilingPattern && Ct[e].objectNumber >= 0 && Ct[e].objectNumber < t && lt("/" + e + " " + Ct[e].objectNumber + " 0 R");
                Dt.publish("putTilingPatternDict"), lt(">>");
            }
        }(t.objectOid), function() {
            if (Object.keys(Bt).length > 0) {
                var t;
                for(t in lt("/ExtGState <<"), Bt)Bt.hasOwnProperty(t) && Bt[t].objectNumber >= 0 && lt("/" + t + " " + Bt[t].objectNumber + " 0 R");
                Dt.publish("putGStateDict"), lt(">>");
            }
        }(), function() {
            for(var t in lt("/XObject <<"), zt)zt.hasOwnProperty(t) && zt[t].objectNumber >= 0 && lt("/" + t + " " + zt[t].objectNumber + " 0 R");
            Dt.publish("putXobjectDict"), lt(">>");
        }(), lt(">>"), lt("endobj");
    }, de = function(t) {
        It[t.fontName] = It[t.fontName] || {}, It[t.fontName][t.fontStyle] = t.id;
    }, pe = function(t, e, n, r, i) {
        var a = {
            id: "F" + (Object.keys(Ft).length + 1).toString(10),
            postScriptName: t,
            fontName: e,
            fontStyle: n,
            encoding: r,
            isStandardFont: i || !1,
            metadata: {}
        };
        return Dt.publish("addFont", {
            font: a,
            instance: this
        }), Ft[a.id] = a, de(a), a.id;
    }, ge = y.__private__.pdfEscape = y.pdfEscape = function(t, e) {
        return (function(t, e) {
            var n, r, i, a, o, s, u, c, l;
            if (i = (e = e || {}).sourceEncoding || "Unicode", o = e.outputEncoding, (e.autoencode || o) && Ft[At].metadata && Ft[At].metadata[i] && Ft[At].metadata[i].encoding && (a = Ft[At].metadata[i].encoding, !o && Ft[At].encoding && (o = Ft[At].encoding), !o && a.codePages && (o = a.codePages[0]), "string" == typeof o && (o = a[o]), o)) {
                for(u = !1, s = [], n = 0, r = t.length; n < r; n++)(c = o[t.charCodeAt(n)]) ? s.push(String.fromCharCode(c)) : s.push(t[n]), s[n].charCodeAt(0) >> 8 && (u = !0);
                t = s.join("");
            }
            for(n = t.length; void 0 === u && 0 !== n;)t.charCodeAt(n - 1) >> 8 && (u = !0), n--;
            if (!u) return t;
            for(s = e.noBOM ? [] : [
                254,
                255
            ], n = 0, r = t.length; n < r; n++){
                if ((l = (c = t.charCodeAt(n)) >> 8) >> 8) throw new Error("Character at position " + n + " of string '" + t + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
                s.push(l), s.push(c - (l << 8));
            }
            return String.fromCharCode.apply(void 0, s);
        })(t, e).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
    }, me = y.__private__.beginPage = function(t) {
        ot[++Et] = [], Rt[Et] = {
            objId: 0,
            contentsObjId: 0,
            userUnit: Number(f),
            artBox: null,
            bleedBox: null,
            cropBox: null,
            trimBox: null,
            mediaBox: {
                bottomLeftX: 0,
                bottomLeftY: 0,
                topRightX: Number(t[0]),
                topRightY: Number(t[1])
            }
        }, ye(Et), ct(ot[$]);
    }, ve = function(t, e) {
        var n, i, a;
        switch(r = e || r, "string" == typeof t && (n = x(t.toLowerCase()), Array.isArray(n) && (i = n[0], a = n[1])), Array.isArray(t) && (i = t[0] * St, a = t[1] * St), isNaN(i) && (i = s[0], a = s[1]), (i > 14400 || a > 14400) && ($ffaeb8e02004bf5e$var$o.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), i = Math.min(14400, i), a = Math.min(14400, a)), s = [
            i,
            a
        ], r.substr(0, 1)){
            case "l":
                a > i && (s = [
                    a,
                    i
                ]);
                break;
            case "p":
                i > a && (s = [
                    a,
                    i
                ]);
        }
        me(s), Ze(Xe), lt(on), 0 !== fn && lt(fn + " J"), 0 !== dn && lt(dn + " j"), Dt.publish("addPage", {
            pageNumber: Et
        });
    }, be = function(t) {
        t > 0 && t <= Et && (ot.splice(t, 1), Rt.splice(t, 1), Et--, $ > Et && ($ = Et), this.setPage($));
    }, ye = function(t) {
        t > 0 && t <= Et && ($ = t);
    }, we = y.__private__.getNumberOfPages = y.getNumberOfPages = function() {
        return ot.length - 1;
    }, Ne = function(t, e, n) {
        var r, i = void 0;
        return n = n || {}, t = void 0 !== t ? t : Ft[At].fontName, e = void 0 !== e ? e : Ft[At].fontStyle, r = t.toLowerCase(), void 0 !== It[r] && void 0 !== It[r][e] ? i = It[r][e] : void 0 !== It[t] && void 0 !== It[t][e] ? i = It[t][e] : !1 === n.disableWarning && $ffaeb8e02004bf5e$var$o.warn("Unable to look up font label for font '" + t + "', '" + e + "'. Refer to getFontList() for available fonts."), i || n.noFallback || null == (i = It.times[e]) && (i = It.times.normal), i;
    }, Le = y.__private__.putInfo = function() {
        var t = Xt(), e = function(t) {
            return t;
        };
        for(var n in null !== m && (e = je.encryptor(t, 0)), lt("<<"), lt("/Producer (" + ge(e("jsPDF " + $ffaeb8e02004bf5e$export$2e2bcd8739ae039.version)) + ")"), xt)xt.hasOwnProperty(n) && xt[n] && lt("/" + n.substr(0, 1).toUpperCase() + n.substr(1) + " (" + ge(e(xt[n])) + ")");
        lt("/CreationDate (" + ge(e(W)) + ")"), lt(">>"), lt("endobj");
    }, xe = y.__private__.putCatalog = function(t) {
        var e = (t = t || {}).rootDictionaryObjId || Qt;
        switch(Xt(), lt("<<"), lt("/Type /Catalog"), lt("/Pages " + e + " 0 R"), gt || (gt = "fullwidth"), gt){
            case "fullwidth":
                lt("/OpenAction [3 0 R /FitH null]");
                break;
            case "fullheight":
                lt("/OpenAction [3 0 R /FitV null]");
                break;
            case "fullpage":
                lt("/OpenAction [3 0 R /Fit]");
                break;
            case "original":
                lt("/OpenAction [3 0 R /XYZ null null 1]");
                break;
            default:
                var n = "" + gt;
                "%" === n.substr(n.length - 1) && (gt = parseInt(gt) / 100), "number" == typeof gt && lt("/OpenAction [3 0 R /XYZ null null " + T(gt) + "]");
        }
        switch(wt || (wt = "continuous"), wt){
            case "continuous":
                lt("/PageLayout /OneColumn");
                break;
            case "single":
                lt("/PageLayout /SinglePage");
                break;
            case "two":
            case "twoleft":
                lt("/PageLayout /TwoColumnLeft");
                break;
            case "tworight":
                lt("/PageLayout /TwoColumnRight");
        }
        bt && lt("/PageMode /" + bt), Dt.publish("putCatalog"), lt(">>"), lt("endobj");
    }, Ae = y.__private__.putTrailer = function() {
        lt("trailer"), lt("<<"), lt("/Size " + (et + 1)), lt("/Root " + et + " 0 R"), lt("/Info " + (et - 1) + " 0 R"), null !== m && lt("/Encrypt " + je.oid + " 0 R"), lt("/ID [ <" + V + "> <" + V + "> ]"), lt(">>");
    }, Se = y.__private__.putHeader = function() {
        lt("%PDF-" + w), lt("%\xba\xdf\xac\xe0");
    }, _e = y.__private__.putXRef = function() {
        var t = "0000000000";
        lt("xref"), lt("0 " + (et + 1)), lt("0000000000 65535 f ");
        for(var e = 1; e <= et; e++)"function" == typeof nt[e] ? lt((t + nt[e]()).slice(-10) + " 00000 n ") : void 0 !== nt[e] ? lt((t + nt[e]).slice(-10) + " 00000 n ") : lt("0000000000 00000 n ");
    }, Pe = y.__private__.buildDocument = function() {
        var t;
        et = 0, it = 0, rt = [], nt = [], at = [], Qt = Kt(), te = Kt(), ct(rt), Dt.publish("buildDocument"), Se(), oe(), function() {
            Dt.publish("putAdditionalObjects");
            for(var t = 0; t < at.length; t++){
                var e = at[t];
                Zt(e.objId, !0), lt(e.content), lt("endobj");
            }
            Dt.publish("postPutAdditionalObjects");
        }(), t = [], function() {
            for(var t in Ft)Ft.hasOwnProperty(t) && (!1 === v || !0 === v && b.hasOwnProperty(t)) && se(Ft[t]);
        }(), function() {
            var t;
            for(t in Bt)Bt.hasOwnProperty(t) && he(Bt[t]);
        }(), function() {
            for(var t in zt)zt.hasOwnProperty(t) && ue(zt[t]);
        }(), function(t) {
            var e;
            for(e in Ct)Ct.hasOwnProperty(e) && (Ct[e] instanceof $ffaeb8e02004bf5e$export$7235f0ad083cb4c6 ? ce(Ct[e]) : Ct[e] instanceof $ffaeb8e02004bf5e$export$549f717800d2b57f && le(Ct[e], t));
        }(t), Dt.publish("putResources"), t.forEach(fe), fe({
            resourcesOid: te,
            objectOid: Number.MAX_SAFE_INTEGER
        }), Dt.publish("postPutResources"), null !== m && (je.oid = Xt(), lt("<<"), lt("/Filter /Standard"), lt("/V " + je.v), lt("/R " + je.r), lt("/U <" + je.toHexString(je.U) + ">"), lt("/O <" + je.toHexString(je.O) + ">"), lt("/P " + je.P), lt(">>"), lt("endobj")), Le(), xe();
        var e = it;
        return _e(), Ae(), lt("startxref"), lt("" + e), lt("%%EOF"), ct(ot[$]), rt.join("\n");
    }, ke = y.__private__.getBlob = function(t) {
        return new Blob([
            ft(t)
        ], {
            type: "application/pdf"
        });
    }, Fe = y.output = y.__private__.output = (Jt = function(t, e) {
        switch("string" == typeof (e = e || {}) ? e = {
            filename: e
        } : e.filename = e.filename || "generated.pdf", t){
            case void 0:
                return Pe();
            case "save":
                y.save(e.filename);
                break;
            case "arraybuffer":
                return ft(Pe());
            case "blob":
                return ke(Pe());
            case "bloburi":
            case "bloburl":
                if (void 0 !== $ffaeb8e02004bf5e$var$i.URL && "function" == typeof $ffaeb8e02004bf5e$var$i.URL.createObjectURL) return $ffaeb8e02004bf5e$var$i.URL && $ffaeb8e02004bf5e$var$i.URL.createObjectURL(ke(Pe())) || void 0;
                $ffaeb8e02004bf5e$var$o.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
                break;
            case "datauristring":
            case "dataurlstring":
                var n = "", r = Pe();
                try {
                    n = $ffaeb8e02004bf5e$var$d(r);
                } catch (m) {
                    n = $ffaeb8e02004bf5e$var$d(unescape(encodeURIComponent(r)));
                }
                return "data:application/pdf;filename=" + e.filename + ";base64," + n;
            case "pdfobjectnewwindow":
                if ("[object Window]" === Object.prototype.toString.call($ffaeb8e02004bf5e$var$i)) {
                    var a = "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js", s = ' integrity="sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==" crossorigin="anonymous"';
                    e.pdfObjectUrl && (a = e.pdfObjectUrl, s = "");
                    var u = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="' + a + '"' + s + '><\/script><script >PDFObject.embed("' + this.output("dataurlstring") + '", ' + JSON.stringify(e) + ");<\/script></body></html>", c = $ffaeb8e02004bf5e$var$i.open();
                    return null !== c && c.document.write(u), c;
                }
                throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");
            case "pdfjsnewwindow":
                if ("[object Window]" === Object.prototype.toString.call($ffaeb8e02004bf5e$var$i)) {
                    var l = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="' + (e.pdfJsUrl || "examples/PDF.js/web/viewer.html") + "?file=&downloadName=" + e.filename + '" width="500px" height="400px" /></body></html>', h = $ffaeb8e02004bf5e$var$i.open();
                    if (null !== h) {
                        h.document.write(l);
                        var f = this;
                        h.document.documentElement.querySelector("#pdfViewer").onload = function() {
                            h.document.title = e.filename, h.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(f.output("bloburl"));
                        };
                    }
                    return h;
                }
                throw new Error("The option pdfjsnewwindow just works in a browser-environment.");
            case "dataurlnewwindow":
                if ("[object Window]" !== Object.prototype.toString.call($ffaeb8e02004bf5e$var$i)) throw new Error("The option dataurlnewwindow just works in a browser-environment.");
                var p = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="' + this.output("datauristring", e) + '"></iframe></body></html>', g = $ffaeb8e02004bf5e$var$i.open();
                if (null !== g && (g.document.write(p), g.document.title = e.filename), g || "undefined" == typeof safari) return g;
                break;
            case "datauri":
            case "dataurl":
                return $ffaeb8e02004bf5e$var$i.document.location.href = this.output("datauristring", e);
            default:
                return null;
        }
    }, Jt.foo = function() {
        try {
            return Jt.apply(this, arguments);
        } catch (n) {
            var t = n.stack || "";
            ~t.indexOf(" at ") && (t = t.split(" at ")[1]);
            var e = "Error in function " + t.split("\n")[0].split("<")[0] + ": " + n.message;
            if (!$ffaeb8e02004bf5e$var$i.console) throw new Error(e);
            $ffaeb8e02004bf5e$var$i.console.error(e, n), $ffaeb8e02004bf5e$var$i.alert && alert(e);
        }
    }, Jt.foo.bar = Jt, Jt.foo), Ie = function(t) {
        return !0 === Array.isArray(Tt) && Tt.indexOf(t) > -1;
    };
    switch(a){
        case "pt":
            St = 1;
            break;
        case "mm":
            St = 72 / 25.4;
            break;
        case "cm":
            St = 72 / 2.54;
            break;
        case "in":
            St = 72;
            break;
        case "px":
            St = 1 == Ie("px_scaling") ? .75 : 96 / 72;
            break;
        case "pc":
        case "em":
            St = 12;
            break;
        case "ex":
            St = 6;
            break;
        default:
            if ("number" != typeof a) throw new Error("Invalid unit: " + a);
            St = a;
    }
    var je = null;
    K(), Y();
    var Ce = y.__private__.getPageInfo = y.getPageInfo = function(t) {
        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfo");
        return {
            objId: Rt[t].objId,
            pageNumber: t,
            pageContext: Rt[t]
        };
    }, Oe = y.__private__.getPageInfoByObjId = function(t) {
        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
        for(var e in Rt)if (Rt[e].objId === t) break;
        return Ce(e);
    }, Be = y.__private__.getCurrentPageInfo = y.getCurrentPageInfo = function() {
        return {
            objId: Rt[$].objId,
            pageNumber: $,
            pageContext: Rt[$]
        };
    };
    y.addPage = function() {
        return ve.apply(this, arguments), this;
    }, y.setPage = function() {
        return ye.apply(this, arguments), ct.call(this, ot[$]), this;
    }, y.insertPage = function(t) {
        return this.addPage(), this.movePage($, t), this;
    }, y.movePage = function(t, e) {
        var n, r;
        if (t > e) {
            n = ot[t], r = Rt[t];
            for(var i = t; i > e; i--)ot[i] = ot[i - 1], Rt[i] = Rt[i - 1];
            ot[e] = n, Rt[e] = r, this.setPage(e);
        } else if (t < e) {
            n = ot[t], r = Rt[t];
            for(var a = t; a < e; a++)ot[a] = ot[a + 1], Rt[a] = Rt[a + 1];
            ot[e] = n, Rt[e] = r, this.setPage(e);
        }
        return this;
    }, y.deletePage = function() {
        return be.apply(this, arguments), this;
    }, y.__private__.text = y.text = function(e, n, r, i, a) {
        var o, s, u, c, l, h, f, d, p, g = (i = i || {}).scope || this;
        if ("number" == typeof e && "number" == typeof n && ("string" == typeof r || Array.isArray(r))) {
            var m = r;
            r = n, n = e, e = m;
        }
        if (arguments[3] instanceof Wt == 0 ? (u = arguments[4], c = arguments[5], "object" === (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(f = arguments[3]) && null !== f || ("string" == typeof u && (c = u, u = null), "string" == typeof f && (c = f, f = null), "number" == typeof f && (u = f, f = null), i = {
            flags: f,
            angle: u,
            align: c
        })) : (R("The transform parameter of text() with a Matrix value"), p = a), isNaN(n) || isNaN(r) || null == e) throw new Error("Invalid arguments passed to jsPDF.text");
        if (0 === e.length) return g;
        var v, y = "", w = "number" == typeof i.lineHeightFactor ? i.lineHeightFactor : Je, N = g.internal.scaleFactor;
        function L(t) {
            return t = t.split("\t").join(Array(i.TabLen || 9).join(" ")), ge(t, f);
        }
        function x(t) {
            for(var e, n = t.concat(), r = [], i = n.length; i--;)"string" == typeof (e = n.shift()) ? r.push(e) : Array.isArray(t) && (1 === e.length || void 0 === e[1] && void 0 === e[2]) ? r.push(e[0]) : r.push([
                e[0],
                e[1],
                e[2]
            ]);
            return r;
        }
        function A(t, e) {
            var n;
            if ("string" == typeof t) n = e(t)[0];
            else if (Array.isArray(t)) {
                for(var r, i, a = t.concat(), o = [], s = a.length; s--;)"string" == typeof (r = a.shift()) ? o.push(e(r)[0]) : Array.isArray(r) && "string" == typeof r[0] && (i = e(r[0], r[1], r[2]), o.push([
                    i[0],
                    i[1],
                    i[2]
                ]));
                n = o;
            }
            return n;
        }
        var P = !1, k = !0;
        if ("string" == typeof e) P = !0;
        else if (Array.isArray(e)) {
            var F = e.concat();
            s = [];
            for(var I, j = F.length; j--;)("string" != typeof (I = F.shift()) || Array.isArray(I) && "string" != typeof I[0]) && (k = !1);
            P = k;
        }
        if (!1 === P) throw new Error('Type of text must be string or Array. "' + e + '" is not recognized.');
        "string" == typeof e && (e = e.match(/[\r?\n]/) ? e.split(/\r\n|\r|\n/g) : [
            e
        ]);
        var C = pt / g.internal.scaleFactor, O = C * (w - 1);
        switch(i.baseline){
            case "bottom":
                r -= O;
                break;
            case "top":
                r += C - O;
                break;
            case "hanging":
                r += C - 2 * O;
                break;
            case "middle":
                r += C / 2 - O;
        }
        if ((h = i.maxWidth || 0) > 0 && ("string" == typeof e ? e = g.splitTextToSize(e, h) : "[object Array]" === Object.prototype.toString.call(e) && (e = e.reduce(function(t, e) {
            return t.concat(g.splitTextToSize(e, h));
        }, []))), o = {
            text: e,
            x: n,
            y: r,
            options: i,
            mutex: {
                pdfEscape: ge,
                activeFontKey: At,
                fonts: Ft,
                activeFontSize: pt
            }
        }, Dt.publish("preProcessText", o), e = o.text, u = (i = o.options).angle, p instanceof Wt == 0 && u && "number" == typeof u) {
            u *= Math.PI / 180, 0 === i.rotationDirection && (u = -u), _ === S && (u = -u);
            var M = Math.cos(u), q = Math.sin(u);
            p = new Wt(M, q, -q, M, 0, 0);
        } else u && u instanceof Wt && (p = u);
        _ !== S || p || (p = Gt), void 0 !== (l = i.charSpace || ln) && (y += B(U(l)) + " Tc\n", this.setCharSpace(this.getCharSpace() || 0)), void 0 !== (d = i.horizontalScale) && (y += B(100 * d) + " Tz\n"), i.lang;
        var E = -1, D = void 0 !== i.renderingMode ? i.renderingMode : i.stroke, T = g.internal.getCurrentPageInfo().pageContext;
        switch(D){
            case 0:
            case !1:
            case "fill":
                E = 0;
                break;
            case 1:
            case !0:
            case "stroke":
                E = 1;
                break;
            case 2:
            case "fillThenStroke":
                E = 2;
                break;
            case 3:
            case "invisible":
                E = 3;
                break;
            case 4:
            case "fillAndAddForClipping":
                E = 4;
                break;
            case 5:
            case "strokeAndAddPathForClipping":
                E = 5;
                break;
            case 6:
            case "fillThenStrokeAndAddToPathForClipping":
                E = 6;
                break;
            case 7:
            case "addToPathForClipping":
                E = 7;
        }
        var z = void 0 !== T.usedRenderingMode ? T.usedRenderingMode : -1;
        -1 !== E ? y += E + " Tr\n" : -1 !== z && (y += "0 Tr\n"), -1 !== E && (T.usedRenderingMode = E), c = i.align || "left";
        var H, W = pt * w, V = g.internal.pageSize.getWidth(), G = Ft[At];
        l = i.charSpace || ln, h = i.maxWidth || 0, f = Object.assign({
            autoencode: !0,
            noBOM: !0
        }, i.flags);
        var Y = [], J = function(t) {
            return g.getStringUnitWidth(t, {
                font: G,
                charSpace: l,
                fontSize: pt,
                doKerning: !1
            }) * pt / N;
        };
        if ("[object Array]" === Object.prototype.toString.call(e)) {
            var X;
            s = x(e), "left" !== c && (H = s.map(J));
            var K, Z = 0;
            if ("right" === c) {
                n -= H[0], e = [], j = s.length;
                for(var $ = 0; $ < j; $++)0 === $ ? (K = en(n), X = nn(r)) : (K = U(Z - H[$]), X = -W), e.push([
                    s[$],
                    K,
                    X
                ]), Z = H[$];
            } else if ("center" === c) {
                n -= H[0] / 2, e = [], j = s.length;
                for(var Q = 0; Q < j; Q++)0 === Q ? (K = en(n), X = nn(r)) : (K = U((Z - H[Q]) / 2), X = -W), e.push([
                    s[Q],
                    K,
                    X
                ]), Z = H[Q];
            } else if ("left" === c) {
                e = [], j = s.length;
                for(var tt = 0; tt < j; tt++)e.push(s[tt]);
            } else if ("justify" === c && "Identity-H" === G.encoding) {
                e = [], j = s.length, h = 0 !== h ? h : V;
                for(var et = 0, nt = 0; nt < j; nt++)if (X = 0 === nt ? nn(r) : -W, K = 0 === nt ? en(n) : et, nt < j - 1) {
                    var rt = U((h - H[nt]) / (s[nt].split(" ").length - 1)), it = s[nt].split(" ");
                    e.push([
                        it[0] + " ",
                        K,
                        X
                    ]), et = 0;
                    for(var at = 1; at < it.length; at++){
                        var ot = (J(it[at - 1] + " " + it[at]) - J(it[at])) * N + rt;
                        at == it.length - 1 ? e.push([
                            it[at],
                            ot,
                            0
                        ]) : e.push([
                            it[at] + " ",
                            ot,
                            0
                        ]), et -= ot;
                    }
                } else e.push([
                    s[nt],
                    K,
                    X
                ]);
                e.push([
                    "",
                    et,
                    0
                ]);
            } else {
                if ("justify" !== c) throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
                for(e = [], j = s.length, h = 0 !== h ? h : V, nt = 0; nt < j; nt++){
                    X = 0 === nt ? nn(r) : -W, K = 0 === nt ? en(n) : 0;
                    var st = s[nt].split(" ").length - 1, ut = st > 0 ? (h - H[nt]) / st : 0;
                    nt < j - 1 ? Y.push(B(U(ut))) : Y.push(0), e.push([
                        s[nt],
                        K,
                        X
                    ]);
                }
            }
        }
        !0 === ("boolean" == typeof i.R2L ? i.R2L : vt) && (e = A(e, function(t, e, n) {
            return [
                t.split("").reverse().join(""),
                e,
                n
            ];
        })), o = {
            text: e,
            x: n,
            y: r,
            options: i,
            mutex: {
                pdfEscape: ge,
                activeFontKey: At,
                fonts: Ft,
                activeFontSize: pt
            }
        }, Dt.publish("postProcessText", o), e = o.text, v = o.mutex.isHex || !1;
        var ct = Ft[At].encoding;
        "WinAnsiEncoding" !== ct && "StandardEncoding" !== ct || (e = A(e, function(t, e, n) {
            return [
                L(t),
                e,
                n
            ];
        })), s = x(e), e = [];
        for(var ht, ft, dt, gt = Array.isArray(s[0]) ? 1 : 0, mt = "", bt = function(t, e, n) {
            var r = "";
            return n instanceof Wt ? (n = "number" == typeof i.angle ? Vt(n, new Wt(1, 0, 0, 1, t, e)) : Vt(new Wt(1, 0, 0, 1, t, e), n), _ === S && (n = Vt(new Wt(1, 0, 0, -1, 0, 0), n)), r = n.join(" ") + " Tm\n") : r = B(t) + " " + B(e) + " Td\n", r;
        }, yt = 0; yt < s.length; yt++){
            switch(mt = "", gt){
                case 1:
                    dt = (v ? "<" : "(") + s[yt][0] + (v ? ">" : ")"), ht = parseFloat(s[yt][1]), ft = parseFloat(s[yt][2]);
                    break;
                case 0:
                    dt = (v ? "<" : "(") + s[yt] + (v ? ">" : ")"), ht = en(n), ft = nn(r);
            }
            void 0 !== Y && void 0 !== Y[yt] && (mt = Y[yt] + " Tw\n"), 0 === yt ? e.push(mt + bt(ht, ft, p) + dt) : 0 === gt ? e.push(mt + dt) : 1 === gt && e.push(mt + bt(ht, ft, p) + dt);
        }
        e = 0 === gt ? e.join(" Tj\nT* ") : e.join(" Tj\n"), e += " Tj\n";
        var wt = "BT\n/";
        return wt += At + " " + pt + " Tf\n", wt += B(pt * w) + " TL\n", wt += un + "\n", wt += y, wt += e, lt(wt += "ET"), b[At] = !0, g;
    };
    var Me = y.__private__.clip = y.clip = function(t) {
        return lt("evenodd" === t ? "W*" : "W"), this;
    };
    y.clipEvenOdd = function() {
        return Me("evenodd");
    }, y.__private__.discardPath = y.discardPath = function() {
        return lt("n"), this;
    };
    var qe = y.__private__.isValidStyle = function(t) {
        var e = !1;
        return -1 !== [
            void 0,
            null,
            "S",
            "D",
            "F",
            "DF",
            "FD",
            "f",
            "f*",
            "B",
            "B*",
            "n"
        ].indexOf(t) && (e = !0), e;
    };
    y.__private__.setDefaultPathOperation = y.setDefaultPathOperation = function(t) {
        return qe(t) && (g = t), this;
    };
    var Ee = y.__private__.getStyle = y.getStyle = function(t) {
        var e = g;
        switch(t){
            case "D":
            case "S":
                e = "S";
                break;
            case "F":
                e = "f";
                break;
            case "FD":
            case "DF":
                e = "B";
                break;
            case "f":
            case "f*":
            case "B":
            case "B*":
                e = t;
        }
        return e;
    }, Re = y.close = function() {
        return lt("h"), this;
    };
    y.stroke = function() {
        return lt("S"), this;
    }, y.fill = function(t) {
        return De("f", t), this;
    }, y.fillEvenOdd = function(t) {
        return De("f*", t), this;
    }, y.fillStroke = function(t) {
        return De("B", t), this;
    }, y.fillStrokeEvenOdd = function(t) {
        return De("B*", t), this;
    };
    var De = function(e, n) {
        "object" === (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(n) ? Ue(n, e) : lt(e);
    }, Te = function(t) {
        null === t || _ === S && void 0 === t || (t = Ee(t), lt(t));
    };
    function ze(t, e, n, r, i) {
        var a = new $ffaeb8e02004bf5e$export$549f717800d2b57f(e || this.boundingBox, n || this.xStep, r || this.yStep, this.gState, i || this.matrix);
        a.stream = this.stream;
        var o = t + "$$" + this.cloneIndex++ + "$$";
        return Yt(o, a), a;
    }
    var Ue = function(t, e) {
        var n = Ot[t.key], r = Ct[n];
        if (r instanceof $ffaeb8e02004bf5e$export$7235f0ad083cb4c6) lt("q"), lt(He(e)), r.gState && y.setGState(r.gState), lt(t.matrix.toString() + " cm"), lt("/" + n + " sh"), lt("Q");
        else if (r instanceof $ffaeb8e02004bf5e$export$549f717800d2b57f) {
            var i = new Wt(1, 0, 0, -1, 0, _n());
            t.matrix && (i = i.multiply(t.matrix || Gt), n = ze.call(r, t.key, t.boundingBox, t.xStep, t.yStep, i).id), lt("q"), lt("/Pattern cs"), lt("/" + n + " scn"), r.gState && y.setGState(r.gState), lt(e), lt("Q");
        }
    }, He = function(t) {
        switch(t){
            case "f":
            case "F":
            case "n":
                return "W n";
            case "f*":
                return "W* n";
            case "B":
            case "S":
                return "W S";
            case "B*":
                return "W* S";
        }
    }, We = y.moveTo = function(t, e) {
        return lt(B(U(t)) + " " + B(H(e)) + " m"), this;
    }, Ve = y.lineTo = function(t, e) {
        return lt(B(U(t)) + " " + B(H(e)) + " l"), this;
    }, Ge = y.curveTo = function(t, e, n, r, i, a) {
        return lt([
            B(U(t)),
            B(H(e)),
            B(U(n)),
            B(H(r)),
            B(U(i)),
            B(H(a)),
            "c"
        ].join(" ")), this;
    };
    y.__private__.line = y.line = function(t, e, n, r, i) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || !qe(i)) throw new Error("Invalid arguments passed to jsPDF.line");
        return _ === A ? this.lines([
            [
                n - t,
                r - e
            ]
        ], t, e, [
            1,
            1
        ], i || "S") : this.lines([
            [
                n - t,
                r - e
            ]
        ], t, e, [
            1,
            1
        ]).stroke();
    }, y.__private__.lines = y.lines = function(t, e, n, r, i, a) {
        var o, s, u, c, l, h, f, d, p, g, m, v;
        if ("number" == typeof t && (v = n, n = e, e = t, t = v), r = r || [
            1,
            1
        ], a = a || !1, isNaN(e) || isNaN(n) || !Array.isArray(t) || !Array.isArray(r) || !qe(i) || "boolean" != typeof a) throw new Error("Invalid arguments passed to jsPDF.lines");
        for(We(e, n), o = r[0], s = r[1], c = t.length, g = e, m = n, u = 0; u < c; u++)2 === (l = t[u]).length ? (g = l[0] * o + g, m = l[1] * s + m, Ve(g, m)) : (h = l[0] * o + g, f = l[1] * s + m, d = l[2] * o + g, p = l[3] * s + m, g = l[4] * o + g, m = l[5] * s + m, Ge(h, f, d, p, g, m));
        return a && Re(), Te(i), this;
    }, y.path = function(t) {
        for(var e = 0; e < t.length; e++){
            var n = t[e], r = n.c;
            switch(n.op){
                case "m":
                    We(r[0], r[1]);
                    break;
                case "l":
                    Ve(r[0], r[1]);
                    break;
                case "c":
                    Ge.apply(this, r);
                    break;
                case "h":
                    Re();
            }
        }
        return this;
    }, y.__private__.rect = y.rect = function(t, e, n, r, i) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || !qe(i)) throw new Error("Invalid arguments passed to jsPDF.rect");
        return _ === A && (r = -r), lt([
            B(U(t)),
            B(H(e)),
            B(U(n)),
            B(U(r)),
            "re"
        ].join(" ")), Te(i), this;
    }, y.__private__.triangle = y.triangle = function(t, e, n, r, i, a, o) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || isNaN(i) || isNaN(a) || !qe(o)) throw new Error("Invalid arguments passed to jsPDF.triangle");
        return this.lines([
            [
                n - t,
                r - e
            ],
            [
                i - n,
                a - r
            ],
            [
                t - i,
                e - a
            ]
        ], t, e, [
            1,
            1
        ], o, !0), this;
    }, y.__private__.roundedRect = y.roundedRect = function(t, e, n, r, i, a, o) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || isNaN(i) || isNaN(a) || !qe(o)) throw new Error("Invalid arguments passed to jsPDF.roundedRect");
        var s = 4 / 3 * (Math.SQRT2 - 1);
        return i = Math.min(i, .5 * n), a = Math.min(a, .5 * r), this.lines([
            [
                n - 2 * i,
                0
            ],
            [
                i * s,
                0,
                i,
                a - a * s,
                i,
                a
            ],
            [
                0,
                r - 2 * a
            ],
            [
                0,
                a * s,
                -i * s,
                a,
                -i,
                a
            ],
            [
                2 * i - n,
                0
            ],
            [
                -i * s,
                0,
                -i,
                -a * s,
                -i,
                -a
            ],
            [
                0,
                2 * a - r
            ],
            [
                0,
                -a * s,
                i * s,
                -a,
                i,
                -a
            ]
        ], t + i, e, [
            1,
            1
        ], o, !0), this;
    }, y.__private__.ellipse = y.ellipse = function(t, e, n, r, i) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || !qe(i)) throw new Error("Invalid arguments passed to jsPDF.ellipse");
        var a = 4 / 3 * (Math.SQRT2 - 1) * n, o = 4 / 3 * (Math.SQRT2 - 1) * r;
        return We(t + n, e), Ge(t + n, e - o, t + a, e - r, t, e - r), Ge(t - a, e - r, t - n, e - o, t - n, e), Ge(t - n, e + o, t - a, e + r, t, e + r), Ge(t + a, e + r, t + n, e + o, t + n, e), Te(i), this;
    }, y.__private__.circle = y.circle = function(t, e, n, r) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || !qe(r)) throw new Error("Invalid arguments passed to jsPDF.circle");
        return this.ellipse(t, e, n, n, r);
    }, y.setFont = function(t, e, n) {
        return n && (e = F(e, n)), At = Ne(t, e, {
            disableWarning: !1
        }), this;
    };
    var Ye = y.__private__.getFont = y.getFont = function() {
        return Ft[Ne.apply(y, arguments)];
    };
    y.__private__.getFontList = y.getFontList = function() {
        var t, e, n = {};
        for(t in It)if (It.hasOwnProperty(t)) for(e in n[t] = [], It[t])It[t].hasOwnProperty(e) && n[t].push(e);
        return n;
    }, y.addFont = function(t, e, n, r, i) {
        var a = [
            "StandardEncoding",
            "MacRomanEncoding",
            "Identity-H",
            "WinAnsiEncoding"
        ];
        return arguments[3] && -1 !== a.indexOf(arguments[3]) ? i = arguments[3] : arguments[3] && -1 == a.indexOf(arguments[3]) && (n = F(n, r)), pe.call(this, t, e, n, i = i || "Identity-H");
    };
    var Je, Xe = e.lineWidth || .200025, Ke = y.__private__.getLineWidth = y.getLineWidth = function() {
        return Xe;
    }, Ze = y.__private__.setLineWidth = y.setLineWidth = function(t) {
        return Xe = t, lt(B(U(t)) + " w"), this;
    };
    y.__private__.setLineDash = $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.setLineDash = $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.setLineDashPattern = function(t, e) {
        if (t = t || [], e = e || 0, isNaN(e) || !Array.isArray(t)) throw new Error("Invalid arguments passed to jsPDF.setLineDash");
        return t = t.map(function(t) {
            return B(U(t));
        }).join(" "), e = B(U(e)), lt("[" + t + "] " + e + " d"), this;
    };
    var $e = y.__private__.getLineHeight = y.getLineHeight = function() {
        return pt * Je;
    };
    y.__private__.getLineHeight = y.getLineHeight = function() {
        return pt * Je;
    };
    var Qe = y.__private__.setLineHeightFactor = y.setLineHeightFactor = function(t) {
        return "number" == typeof (t = t || 1.15) && (Je = t), this;
    }, tn = y.__private__.getLineHeightFactor = y.getLineHeightFactor = function() {
        return Je;
    };
    Qe(e.lineHeight);
    var en = y.__private__.getHorizontalCoordinate = function(t) {
        return U(t);
    }, nn = y.__private__.getVerticalCoordinate = function(t) {
        return _ === S ? t : Rt[$].mediaBox.topRightY - Rt[$].mediaBox.bottomLeftY - U(t);
    }, rn = y.__private__.getHorizontalCoordinateString = y.getHorizontalCoordinateString = function(t) {
        return B(en(t));
    }, an = y.__private__.getVerticalCoordinateString = y.getVerticalCoordinateString = function(t) {
        return B(nn(t));
    }, on = e.strokeColor || "0 G";
    y.__private__.getStrokeColor = y.getDrawColor = function() {
        return ee(on);
    }, y.__private__.setStrokeColor = y.setDrawColor = function(t, e, n, r) {
        return on = ne({
            ch1: t,
            ch2: e,
            ch3: n,
            ch4: r,
            pdfColorType: "draw",
            precision: 2
        }), lt(on), this;
    };
    var sn = e.fillColor || "0 g";
    y.__private__.getFillColor = y.getFillColor = function() {
        return ee(sn);
    }, y.__private__.setFillColor = y.setFillColor = function(t, e, n, r) {
        return sn = ne({
            ch1: t,
            ch2: e,
            ch3: n,
            ch4: r,
            pdfColorType: "fill",
            precision: 2
        }), lt(sn), this;
    };
    var un = e.textColor || "0 g", cn = y.__private__.getTextColor = y.getTextColor = function() {
        return ee(un);
    };
    y.__private__.setTextColor = y.setTextColor = function(t, e, n, r) {
        return un = ne({
            ch1: t,
            ch2: e,
            ch3: n,
            ch4: r,
            pdfColorType: "text",
            precision: 3
        }), this;
    };
    var ln = e.charSpace, hn = y.__private__.getCharSpace = y.getCharSpace = function() {
        return parseFloat(ln || 0);
    };
    y.__private__.setCharSpace = y.setCharSpace = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setCharSpace");
        return ln = t, this;
    };
    var fn = 0;
    y.CapJoinStyles = {
        0: 0,
        butt: 0,
        but: 0,
        miter: 0,
        1: 1,
        round: 1,
        rounded: 1,
        circle: 1,
        2: 2,
        projecting: 2,
        project: 2,
        square: 2,
        bevel: 2
    }, y.__private__.setLineCap = y.setLineCap = function(t) {
        var e = y.CapJoinStyles[t];
        if (void 0 === e) throw new Error("Line cap style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
        return fn = e, lt(e + " J"), this;
    };
    var dn = 0;
    y.__private__.setLineJoin = y.setLineJoin = function(t) {
        var e = y.CapJoinStyles[t];
        if (void 0 === e) throw new Error("Line join style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
        return dn = e, lt(e + " j"), this;
    }, y.__private__.setLineMiterLimit = y.__private__.setMiterLimit = y.setLineMiterLimit = y.setMiterLimit = function(t) {
        if (t = t || 0, isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");
        return lt(B(U(t)) + " M"), this;
    }, y.GState = $ffaeb8e02004bf5e$export$1bc649ab427a02ba, y.setGState = function(t) {
        (t = "string" == typeof t ? Bt[Mt[t]] : pn(null, t)).equals(qt) || (lt("/" + t.id + " gs"), qt = t);
    };
    var pn = function(t, e) {
        if (!t || !Mt[t]) {
            var n = !1;
            for(var r in Bt)if (Bt.hasOwnProperty(r) && Bt[r].equals(e)) {
                n = !0;
                break;
            }
            if (n) e = Bt[r];
            else {
                var i = "GS" + (Object.keys(Bt).length + 1).toString(10);
                Bt[i] = e, e.id = i;
            }
            return t && (Mt[t] = e.id), Dt.publish("addGState", e), e;
        }
    };
    y.addGState = function(t, e) {
        return pn(t, e), this;
    }, y.saveGraphicsState = function() {
        return lt("q"), jt.push({
            key: At,
            size: pt,
            color: un
        }), this;
    }, y.restoreGraphicsState = function() {
        lt("Q");
        var t = jt.pop();
        return At = t.key, pt = t.size, un = t.color, qt = null, this;
    }, y.setCurrentTransformationMatrix = function(t) {
        return lt(t.toString() + " cm"), this;
    }, y.comment = function(t) {
        return lt("#" + t), this;
    };
    var gn = function(t, e) {
        var n = t || 0;
        Object.defineProperty(this, "x", {
            enumerable: !0,
            get: function() {
                return n;
            },
            set: function(t) {
                isNaN(t) || (n = parseFloat(t));
            }
        });
        var r = e || 0;
        Object.defineProperty(this, "y", {
            enumerable: !0,
            get: function() {
                return r;
            },
            set: function(t) {
                isNaN(t) || (r = parseFloat(t));
            }
        });
        var i = "pt";
        return Object.defineProperty(this, "type", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                i = t.toString();
            }
        }), this;
    }, mn = function(t, e, n, r) {
        gn.call(this, t, e), this.type = "rect";
        var i = n || 0;
        Object.defineProperty(this, "w", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                isNaN(t) || (i = parseFloat(t));
            }
        });
        var a = r || 0;
        return Object.defineProperty(this, "h", {
            enumerable: !0,
            get: function() {
                return a;
            },
            set: function(t) {
                isNaN(t) || (a = parseFloat(t));
            }
        }), this;
    }, vn = function() {
        this.page = Et, this.currentPage = $, this.pages = ot.slice(0), this.pagesContext = Rt.slice(0), this.x = _t, this.y = Pt, this.matrix = kt, this.width = wn($), this.height = Ln($), this.outputDestination = ut, this.id = "", this.objectNumber = -1;
    };
    vn.prototype.restore = function() {
        Et = this.page, $ = this.currentPage, Rt = this.pagesContext, ot = this.pages, _t = this.x, Pt = this.y, kt = this.matrix, Nn($, this.width), xn($, this.height), ut = this.outputDestination;
    };
    var bn = function(t, e, n, r, i) {
        Ht.push(new vn), Et = $ = 0, ot = [], _t = t, Pt = e, kt = i, me([
            n,
            r
        ]);
    };
    for(var yn in y.beginFormObject = function(t, e, n, r, i) {
        return bn(t, e, n, r, i), this;
    }, y.endFormObject = function(t) {
        return function(t) {
            if (Ut[t]) Ht.pop().restore();
            else {
                var e = new vn, n = "Xo" + (Object.keys(zt).length + 1).toString(10);
                e.id = n, Ut[t] = n, zt[n] = e, Dt.publish("addFormObject", e), Ht.pop().restore();
            }
        }(t), this;
    }, y.doFormObject = function(t, e) {
        var n = zt[Ut[t]];
        return lt("q"), lt(e.toString() + " cm"), lt("/" + n.id + " Do"), lt("Q"), this;
    }, y.getFormObject = function(t) {
        var e = zt[Ut[t]];
        return {
            x: e.x,
            y: e.y,
            width: e.width,
            height: e.height,
            matrix: e.matrix
        };
    }, y.save = function(t, e) {
        return t = t || "generated.pdf", (e = e || {}).returnPromise = e.returnPromise || !1, !1 === e.returnPromise ? ($ffaeb8e02004bf5e$var$l(ke(Pe()), t), "function" == typeof $ffaeb8e02004bf5e$var$l.unload && $ffaeb8e02004bf5e$var$i.setTimeout && setTimeout($ffaeb8e02004bf5e$var$l.unload, 911), this) : new Promise(function(e, n) {
            try {
                var r = $ffaeb8e02004bf5e$var$l(ke(Pe()), t);
                "function" == typeof $ffaeb8e02004bf5e$var$l.unload && $ffaeb8e02004bf5e$var$i.setTimeout && setTimeout($ffaeb8e02004bf5e$var$l.unload, 911), e(r);
            } catch (a) {
                n(a.message);
            }
        });
    }, $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API)$ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.hasOwnProperty(yn) && ("events" === yn && $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.events.length ? function(t, e) {
        var n, r, i;
        for(i = e.length - 1; -1 !== i; i--)n = e[i][0], r = e[i][1], t.subscribe.apply(t, [
            n
        ].concat("function" == typeof r ? [
            r
        ] : r));
    }(Dt, $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.events) : y[yn] = $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API[yn]);
    function wn(t) {
        return Rt[t].mediaBox.topRightX - Rt[t].mediaBox.bottomLeftX;
    }
    function Nn(t, e) {
        Rt[t].mediaBox.topRightX = e + Rt[t].mediaBox.bottomLeftX;
    }
    function Ln(t) {
        return Rt[t].mediaBox.topRightY - Rt[t].mediaBox.bottomLeftY;
    }
    function xn(t, e) {
        Rt[t].mediaBox.topRightY = e + Rt[t].mediaBox.bottomLeftY;
    }
    var An = y.getPageWidth = function(t) {
        return wn(t = t || $) / St;
    }, Sn = y.setPageWidth = function(t, e) {
        Nn(t, e * St);
    }, _n = y.getPageHeight = function(t) {
        return Ln(t = t || $) / St;
    }, Pn = y.setPageHeight = function(t, e) {
        xn(t, e * St);
    };
    return y.internal = {
        pdfEscape: ge,
        getStyle: Ee,
        getFont: Ye,
        getFontSize: mt,
        getCharSpace: hn,
        getTextColor: cn,
        getLineHeight: $e,
        getLineHeightFactor: tn,
        getLineWidth: Ke,
        write: ht,
        getHorizontalCoordinate: en,
        getVerticalCoordinate: nn,
        getCoordinateString: rn,
        getVerticalCoordinateString: an,
        collections: {},
        newObject: Xt,
        newAdditionalObject: $t,
        newObjectDeferred: Kt,
        newObjectDeferredBegin: Zt,
        getFilters: re,
        putStream: ie,
        events: Dt,
        scaleFactor: St,
        pageSize: {
            getWidth: function() {
                return An($);
            },
            setWidth: function(t) {
                Sn($, t);
            },
            getHeight: function() {
                return _n($);
            },
            setHeight: function(t) {
                Pn($, t);
            }
        },
        encryptionOptions: m,
        encryption: je,
        getEncryptor: function(t) {
            return null !== m ? je.encryptor(t, 0) : function(t) {
                return t;
            };
        },
        output: Fe,
        getNumberOfPages: we,
        get pages () {
            return ot;
        },
        out: lt,
        f2: T,
        f3: z,
        getPageInfo: Ce,
        getPageInfoByObjId: Oe,
        getCurrentPageInfo: Be,
        getPDFVersion: N,
        Point: gn,
        Rectangle: mn,
        Matrix: Wt,
        hasHotfix: Ie
    }, Object.defineProperty(y.internal.pageSize, "width", {
        get: function() {
            return An($);
        },
        set: function(t) {
            Sn($, t);
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(y.internal.pageSize, "height", {
        get: function() {
            return _n($);
        },
        set: function(t) {
            Pn($, t);
        },
        enumerable: !0,
        configurable: !0
    }), (function(t) {
        for(var e = 0, n = dt.length; e < n; e++){
            var r = pe.call(this, t[e][0], t[e][1], t[e][2], dt[e][3], !0);
            !1 === v && (b[r] = !0);
            var i = t[e][0].split("-");
            de({
                id: r,
                fontName: i[0],
                fontStyle: i[1] || ""
            });
        }
        Dt.publish("addFonts", {
            fonts: Ft,
            dictionary: It
        });
    }).call(y, dt), At = "F1", ve(s, r), Dt.publish("initialized"), y;
}
$ffaeb8e02004bf5e$var$I.prototype.lsbFirstWord = function(t) {
    return String.fromCharCode(255 & t, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255);
}, $ffaeb8e02004bf5e$var$I.prototype.toHexString = function(t) {
    return t.split("").map(function(t) {
        return ("0" + (255 & t.charCodeAt(0)).toString(16)).slice(-2);
    }).join("");
}, $ffaeb8e02004bf5e$var$I.prototype.hexToBytes = function(t) {
    for(var e = [], n = 0; n < t.length; n += 2)e.push(String.fromCharCode(parseInt(t.substr(n, 2), 16)));
    return e.join("");
}, $ffaeb8e02004bf5e$var$I.prototype.processOwnerPassword = function(t, e) {
    return $ffaeb8e02004bf5e$var$k($ffaeb8e02004bf5e$var$S(e).substr(0, 5), t);
}, $ffaeb8e02004bf5e$var$I.prototype.encryptor = function(t, e) {
    var n = $ffaeb8e02004bf5e$var$S(this.encryptionKey + String.fromCharCode(255 & t, t >> 8 & 255, t >> 16 & 255, 255 & e, e >> 8 & 255)).substr(0, 10);
    return function(t) {
        return $ffaeb8e02004bf5e$var$k(n, t);
    };
}, $ffaeb8e02004bf5e$export$1bc649ab427a02ba.prototype.equals = function(e) {
    var n, r = "id,objectNumber,equals";
    if (!e || (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(e) !== (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(this)) return !1;
    var i = 0;
    for(n in this)if (!(r.indexOf(n) >= 0)) {
        if (this.hasOwnProperty(n) && !e.hasOwnProperty(n)) return !1;
        if (this[n] !== e[n]) return !1;
        i++;
    }
    for(n in e)e.hasOwnProperty(n) && r.indexOf(n) < 0 && i--;
    return 0 === i;
}, $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API = {
    events: []
}, $ffaeb8e02004bf5e$export$2e2bcd8739ae039.version = "3.0.4";
var $ffaeb8e02004bf5e$var$R = $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API, $ffaeb8e02004bf5e$var$D = 1, $ffaeb8e02004bf5e$var$T = function(t) {
    return t.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
}, $ffaeb8e02004bf5e$var$z = function(t) {
    return t.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
}, $ffaeb8e02004bf5e$var$U = function(t) {
    return t.toFixed(2);
}, $ffaeb8e02004bf5e$var$H = function(t) {
    return t.toFixed(5);
};
$ffaeb8e02004bf5e$var$R.__acroform__ = {};
var $ffaeb8e02004bf5e$var$W = function(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t;
}, $ffaeb8e02004bf5e$var$V = function(t) {
    return t * $ffaeb8e02004bf5e$var$D;
}, $ffaeb8e02004bf5e$var$G = function(t) {
    var e = new $ffaeb8e02004bf5e$var$ct, n = $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getHeight(t) || 0, r = $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getWidth(t) || 0;
    return e.BBox = [
        0,
        0,
        Number($ffaeb8e02004bf5e$var$U(r)),
        Number($ffaeb8e02004bf5e$var$U(n))
    ], e;
}, $ffaeb8e02004bf5e$var$Y = $ffaeb8e02004bf5e$var$R.__acroform__.setBit = function(t, e) {
    if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
    return t | 1 << e;
}, $ffaeb8e02004bf5e$var$J = $ffaeb8e02004bf5e$var$R.__acroform__.clearBit = function(t, e) {
    if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
    return t & ~(1 << e);
}, $ffaeb8e02004bf5e$var$X = $ffaeb8e02004bf5e$var$R.__acroform__.getBit = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
    return t & 1 << e ? 1 : 0;
}, $ffaeb8e02004bf5e$var$K = $ffaeb8e02004bf5e$var$R.__acroform__.getBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
    return $ffaeb8e02004bf5e$var$X(t, e - 1);
}, $ffaeb8e02004bf5e$var$Z = $ffaeb8e02004bf5e$var$R.__acroform__.setBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
    return $ffaeb8e02004bf5e$var$Y(t, e - 1);
}, $ffaeb8e02004bf5e$var$$ = $ffaeb8e02004bf5e$var$R.__acroform__.clearBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
    return $ffaeb8e02004bf5e$var$J(t, e - 1);
}, $ffaeb8e02004bf5e$var$Q = $ffaeb8e02004bf5e$var$R.__acroform__.calculateCoordinates = function(t, e) {
    var n = e.internal.getHorizontalCoordinate, r = e.internal.getVerticalCoordinate, i = t[0], a = t[1], o = t[2], s = t[3], u = {};
    return u.lowerLeft_X = n(i) || 0, u.lowerLeft_Y = r(a + s) || 0, u.upperRight_X = n(i + o) || 0, u.upperRight_Y = r(a) || 0, [
        Number($ffaeb8e02004bf5e$var$U(u.lowerLeft_X)),
        Number($ffaeb8e02004bf5e$var$U(u.lowerLeft_Y)),
        Number($ffaeb8e02004bf5e$var$U(u.upperRight_X)),
        Number($ffaeb8e02004bf5e$var$U(u.upperRight_Y))
    ];
}, $ffaeb8e02004bf5e$var$tt = function(t) {
    if (t.appearanceStreamContent) return t.appearanceStreamContent;
    if (t.V || t.DV) {
        var e = [], n = t._V || t.DV, r = $ffaeb8e02004bf5e$var$et(t, n), i = t.scope.internal.getFont(t.fontName, t.fontStyle).id;
        e.push("/Tx BMC"), e.push("q"), e.push("BT"), e.push(t.scope.__private__.encodeColorString(t.color)), e.push("/" + i + " " + $ffaeb8e02004bf5e$var$U(r.fontSize) + " Tf"), e.push("1 0 0 1 0 0 Tm"), e.push(r.text), e.push("ET"), e.push("Q"), e.push("EMC");
        var a = $ffaeb8e02004bf5e$var$G(t);
        return a.scope = t.scope, a.stream = e.join("\n"), a;
    }
}, $ffaeb8e02004bf5e$var$et = function(t, e) {
    var n = 0 === t.fontSize ? t.maxFontSize : t.fontSize, r = {
        text: "",
        fontSize: ""
    }, i = (e = ")" == (e = "(" == e.substr(0, 1) ? e.substr(1) : e).substr(e.length - 1) ? e.substr(0, e.length - 1) : e).split(" ");
    i = t.multiline ? i.map(function(t) {
        return t.split("\n");
    }) : i.map(function(t) {
        return [
            t
        ];
    });
    var a = n, o = $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getHeight(t) || 0;
    o = o < 0 ? -o : o;
    var s = $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getWidth(t) || 0;
    s = s < 0 ? -s : s;
    var u = function(e, n, r) {
        if (e + 1 < i.length) {
            var a = n + " " + i[e + 1][0];
            return $ffaeb8e02004bf5e$var$nt(a, t, r).width <= s - 4;
        }
        return !1;
    };
    a++;
    t: for(; a > 0;){
        e = "", a--;
        var c, l, h = $ffaeb8e02004bf5e$var$nt("3", t, a).height, f = t.multiline ? o - a : (o - h) / 2, d = f += 2, p = 0, g = 0, m = 0;
        if (a <= 0) {
            e = "(...) Tj\n", e += "% Width of Text: " + $ffaeb8e02004bf5e$var$nt(e, t, a = 12).width + ", FieldWidth:" + s + "\n";
            break;
        }
        for(var v = "", b = 0, y = 0; y < i.length; y++)if (i.hasOwnProperty(y)) {
            var w = !1;
            if (1 !== i[y].length && m !== i[y].length - 1) {
                if ((h + 2) * (b + 2) + 2 > o) continue t;
                v += i[y][m], w = !0, g = y, y--;
            } else {
                v = " " == (v += i[y][m] + " ").substr(v.length - 1) ? v.substr(0, v.length - 1) : v;
                var N = parseInt(y), L = u(N, v, a), x = y >= i.length - 1;
                if (L && !x) {
                    v += " ", m = 0;
                    continue;
                }
                if (L || x) {
                    if (x) g = N;
                    else if (t.multiline && (h + 2) * (b + 2) + 2 > o) continue t;
                } else {
                    if (!t.multiline) continue t;
                    if ((h + 2) * (b + 2) + 2 > o) continue t;
                    g = N;
                }
            }
            for(var A = "", S = p; S <= g; S++){
                var _ = i[S];
                if (t.multiline) {
                    if (S === g) {
                        A += _[m] + " ", m = (m + 1) % _.length;
                        continue;
                    }
                    if (S === p) {
                        A += _[_.length - 1] + " ";
                        continue;
                    }
                }
                A += _[0] + " ";
            }
            switch(A = " " == A.substr(A.length - 1) ? A.substr(0, A.length - 1) : A, l = $ffaeb8e02004bf5e$var$nt(A, t, a).width, t.textAlign){
                case "right":
                    c = s - l - 2;
                    break;
                case "center":
                    c = (s - l) / 2;
                    break;
                default:
                    c = 2;
            }
            e += $ffaeb8e02004bf5e$var$U(c) + " " + $ffaeb8e02004bf5e$var$U(d) + " Td\n", e += "(" + $ffaeb8e02004bf5e$var$T(A) + ") Tj\n", e += -$ffaeb8e02004bf5e$var$U(c) + " 0 Td\n", d = -(a + 2), l = 0, p = w ? g : g + 1, b++, v = "";
        }
        break;
    }
    return r.text = e, r.fontSize = a, r;
}, $ffaeb8e02004bf5e$var$nt = function(t, e, n) {
    var r = e.scope.internal.getFont(e.fontName, e.fontStyle), i = e.scope.getStringUnitWidth(t, {
        font: r,
        fontSize: parseFloat(n),
        charSpace: 0
    }) * parseFloat(n);
    return {
        height: e.scope.getStringUnitWidth("3", {
            font: r,
            fontSize: parseFloat(n),
            charSpace: 0
        }) * parseFloat(n) * 1.5,
        width: i
    };
}, $ffaeb8e02004bf5e$var$rt = {
    fields: [],
    xForms: [],
    acroFormDictionaryRoot: null,
    printedOut: !1,
    internal: null,
    isInitialized: !1
}, $ffaeb8e02004bf5e$var$it = function(t, e) {
    var n = {
        type: "reference",
        object: t
    };
    void 0 === e.internal.getPageInfo(t.page).pageContext.annotations.find(function(t) {
        return t.type === n.type && t.object === n.object;
    }) && e.internal.getPageInfo(t.page).pageContext.annotations.push(n);
}, $ffaeb8e02004bf5e$var$at = function(e, n) {
    if (n.scope = e, void 0 !== e.internal && (void 0 === e.internal.acroformPlugin || !1 === e.internal.acroformPlugin.isInitialized)) {
        if ($ffaeb8e02004bf5e$var$ht.FieldNum = 0, e.internal.acroformPlugin = JSON.parse(JSON.stringify($ffaeb8e02004bf5e$var$rt)), e.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
        $ffaeb8e02004bf5e$var$D = e.internal.scaleFactor, e.internal.acroformPlugin.acroFormDictionaryRoot = new $ffaeb8e02004bf5e$var$lt, e.internal.acroformPlugin.acroFormDictionaryRoot.scope = e, e.internal.acroformPlugin.acroFormDictionaryRoot._eventID = e.internal.events.subscribe("postPutResources", function() {
            !function(t) {
                t.internal.events.unsubscribe(t.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete t.internal.acroformPlugin.acroFormDictionaryRoot._eventID, t.internal.acroformPlugin.printedOut = !0;
            }(e);
        }), e.internal.events.subscribe("buildDocument", function() {
            !function(t) {
                t.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
                var e = t.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
                for(var n in e)if (e.hasOwnProperty(n)) {
                    var r = e[n];
                    r.objId = void 0, r.hasAnnotation && $ffaeb8e02004bf5e$var$it(r, t);
                }
            }(e);
        }), e.internal.events.subscribe("putCatalog", function() {
            !function(t) {
                if (void 0 === t.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("putCatalogCallback: Root missing.");
                t.internal.write("/AcroForm " + t.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
            }(e);
        }), e.internal.events.subscribe("postPutPages", function(n) {
            !function(e, n) {
                var r = !e;
                for(var i in e || (n.internal.newObjectDeferredBegin(n.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), n.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), e = e || n.internal.acroformPlugin.acroFormDictionaryRoot.Kids)if (e.hasOwnProperty(i)) {
                    var a = e[i], o = [], s = a.Rect;
                    if (a.Rect && (a.Rect = $ffaeb8e02004bf5e$var$Q(a.Rect, n)), n.internal.newObjectDeferredBegin(a.objId, !0), a.DA = $ffaeb8e02004bf5e$export$7d753ad993606f45.createDefaultAppearanceStream(a), "object" === (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(a) && "function" == typeof a.getKeyValueListForStream && (o = a.getKeyValueListForStream()), a.Rect = s, a.hasAppearanceStream && !a.appearanceStreamContent) {
                        var u = $ffaeb8e02004bf5e$var$tt(a);
                        o.push({
                            key: "AP",
                            value: "<</N " + u + ">>"
                        }), n.internal.acroformPlugin.xForms.push(u);
                    }
                    if (a.appearanceStreamContent) {
                        var c = "";
                        for(var l in a.appearanceStreamContent)if (a.appearanceStreamContent.hasOwnProperty(l)) {
                            var h = a.appearanceStreamContent[l];
                            if (c += "/" + l + " ", c += "<<", Object.keys(h).length >= 1 || Array.isArray(h)) {
                                for(var i in h)if (h.hasOwnProperty(i)) {
                                    var f = h[i];
                                    "function" == typeof f && (f = f.call(n, a)), c += "/" + i + " " + f + " ", n.internal.acroformPlugin.xForms.indexOf(f) >= 0 || n.internal.acroformPlugin.xForms.push(f);
                                }
                            } else "function" == typeof (f = h) && (f = f.call(n, a)), c += "/" + i + " " + f, n.internal.acroformPlugin.xForms.indexOf(f) >= 0 || n.internal.acroformPlugin.xForms.push(f);
                            c += ">>";
                        }
                        o.push({
                            key: "AP",
                            value: "<<\n" + c + ">>"
                        });
                    }
                    n.internal.putStream({
                        additionalKeyValues: o,
                        objectId: a.objId
                    }), n.internal.out("endobj");
                }
                r && function(e, n) {
                    for(var r in e)if (e.hasOwnProperty(r)) {
                        var i = r, a = e[r];
                        n.internal.newObjectDeferredBegin(a.objId, !0), "object" === (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(a) && "function" == typeof a.putStream && a.putStream(), delete e[i];
                    }
                }(n.internal.acroformPlugin.xForms, n);
            }(n, e);
        }), e.internal.acroformPlugin.isInitialized = !0;
    }
}, $ffaeb8e02004bf5e$var$ot = $ffaeb8e02004bf5e$var$R.__acroform__.arrayToPdfArray = function(e, n, r) {
    var i = function(t) {
        return t;
    };
    if (Array.isArray(e)) {
        for(var a = "[", o = 0; o < e.length; o++)switch(0 !== o && (a += " "), (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(e[o])){
            case "boolean":
            case "number":
            case "object":
                a += e[o].toString();
                break;
            case "string":
                "/" !== e[o].substr(0, 1) ? (void 0 !== n && r && (i = r.internal.getEncryptor(n)), a += "(" + $ffaeb8e02004bf5e$var$T(i(e[o].toString())) + ")") : a += e[o].toString();
        }
        return a + "]";
    }
    throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
}, $ffaeb8e02004bf5e$var$st = function(t, e, n) {
    var r = function(t) {
        return t;
    };
    return void 0 !== e && n && (r = n.internal.getEncryptor(e)), (t = t || "").toString(), "(" + $ffaeb8e02004bf5e$var$T(r(t)) + ")";
}, $ffaeb8e02004bf5e$var$ut = function() {
    this._objId = void 0, this._scope = void 0, Object.defineProperty(this, "objId", {
        get: function() {
            if (void 0 === this._objId) {
                if (void 0 === this.scope) return;
                this._objId = this.scope.internal.newObjectDeferred();
            }
            return this._objId;
        },
        set: function(t) {
            this._objId = t;
        }
    }), Object.defineProperty(this, "scope", {
        value: this._scope,
        writable: !0
    });
};
$ffaeb8e02004bf5e$var$ut.prototype.toString = function() {
    return this.objId + " 0 R";
}, $ffaeb8e02004bf5e$var$ut.prototype.putStream = function() {
    var t = this.getKeyValueListForStream();
    this.scope.internal.putStream({
        data: this.stream,
        additionalKeyValues: t,
        objectId: this.objId
    }), this.scope.internal.out("endobj");
}, $ffaeb8e02004bf5e$var$ut.prototype.getKeyValueListForStream = function() {
    var t = [], e = Object.getOwnPropertyNames(this).filter(function(t) {
        return "content" != t && "appearanceStreamContent" != t && "scope" != t && "objId" != t && "_" != t.substring(0, 1);
    });
    for(var n in e)if (!1 === Object.getOwnPropertyDescriptor(this, e[n]).configurable) {
        var r = e[n], i = this[r];
        i && (Array.isArray(i) ? t.push({
            key: r,
            value: $ffaeb8e02004bf5e$var$ot(i, this.objId, this.scope)
        }) : i instanceof $ffaeb8e02004bf5e$var$ut ? (i.scope = this.scope, t.push({
            key: r,
            value: i.objId + " 0 R"
        })) : "function" != typeof i && t.push({
            key: r,
            value: i
        }));
    }
    return t;
};
var $ffaeb8e02004bf5e$var$ct = function() {
    $ffaeb8e02004bf5e$var$ut.call(this), Object.defineProperty(this, "Type", {
        value: "/XObject",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "Subtype", {
        value: "/Form",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "FormType", {
        value: 1,
        configurable: !1,
        writable: !0
    });
    var t, e = [];
    Object.defineProperty(this, "BBox", {
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "Resources", {
        value: "2 0 R",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "stream", {
        enumerable: !1,
        configurable: !0,
        set: function(e) {
            t = e.trim();
        },
        get: function() {
            return t || null;
        }
    });
};
$ffaeb8e02004bf5e$var$W($ffaeb8e02004bf5e$var$ct, $ffaeb8e02004bf5e$var$ut);
var $ffaeb8e02004bf5e$var$lt = function() {
    $ffaeb8e02004bf5e$var$ut.call(this);
    var t, e = [];
    Object.defineProperty(this, "Kids", {
        enumerable: !1,
        configurable: !0,
        get: function() {
            return e.length > 0 ? e : void 0;
        }
    }), Object.defineProperty(this, "Fields", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        }
    }), Object.defineProperty(this, "DA", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (t) {
                var e = function(t) {
                    return t;
                };
                return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + $ffaeb8e02004bf5e$var$T(e(t)) + ")";
            }
        },
        set: function(e) {
            t = e;
        }
    });
};
$ffaeb8e02004bf5e$var$W($ffaeb8e02004bf5e$var$lt, $ffaeb8e02004bf5e$var$ut);
var $ffaeb8e02004bf5e$var$ht = function t() {
    $ffaeb8e02004bf5e$var$ut.call(this);
    var e = 4;
    Object.defineProperty(this, "F", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute F supplied.');
            e = t;
        }
    }), Object.defineProperty(this, "showWhenPrinted", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($ffaeb8e02004bf5e$var$K(e, 3));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.F = $ffaeb8e02004bf5e$var$Z(e, 3) : this.F = $ffaeb8e02004bf5e$var$$(e, 3);
        }
    });
    var n = 0;
    Object.defineProperty(this, "Ff", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return n;
        },
        set: function(t) {
            if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute Ff supplied.');
            n = t;
        }
    });
    var r = [];
    Object.defineProperty(this, "Rect", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (0 !== r.length) return r;
        },
        set: function(t) {
            r = void 0 !== t ? t : [];
        }
    }), Object.defineProperty(this, "x", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !r || isNaN(r[0]) ? 0 : r[0];
        },
        set: function(t) {
            r[0] = t;
        }
    }), Object.defineProperty(this, "y", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !r || isNaN(r[1]) ? 0 : r[1];
        },
        set: function(t) {
            r[1] = t;
        }
    }), Object.defineProperty(this, "width", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !r || isNaN(r[2]) ? 0 : r[2];
        },
        set: function(t) {
            r[2] = t;
        }
    }), Object.defineProperty(this, "height", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !r || isNaN(r[3]) ? 0 : r[3];
        },
        set: function(t) {
            r[3] = t;
        }
    });
    var i = "";
    Object.defineProperty(this, "FT", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return i;
        },
        set: function(t) {
            switch(t){
                case "/Btn":
                case "/Tx":
                case "/Ch":
                case "/Sig":
                    i = t;
                    break;
                default:
                    throw new Error('Invalid value "' + t + '" for attribute FT supplied.');
            }
        }
    });
    var a = null;
    Object.defineProperty(this, "T", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (!a || a.length < 1) {
                if (this instanceof $ffaeb8e02004bf5e$var$yt) return;
                a = "FieldObject" + t.FieldNum++;
            }
            var e = function(t) {
                return t;
            };
            return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + $ffaeb8e02004bf5e$var$T(e(a)) + ")";
        },
        set: function(t) {
            a = t.toString();
        }
    }), Object.defineProperty(this, "fieldName", {
        configurable: !0,
        enumerable: !0,
        get: function() {
            return a;
        },
        set: function(t) {
            a = t;
        }
    });
    var o = "helvetica";
    Object.defineProperty(this, "fontName", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return o;
        },
        set: function(t) {
            o = t;
        }
    });
    var s = "normal";
    Object.defineProperty(this, "fontStyle", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return s;
        },
        set: function(t) {
            s = t;
        }
    });
    var u = 0;
    Object.defineProperty(this, "fontSize", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return u;
        },
        set: function(t) {
            u = t;
        }
    });
    var c = void 0;
    Object.defineProperty(this, "maxFontSize", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return void 0 === c ? 50 / $ffaeb8e02004bf5e$var$D : c;
        },
        set: function(t) {
            c = t;
        }
    });
    var l = "black";
    Object.defineProperty(this, "color", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return l;
        },
        set: function(t) {
            l = t;
        }
    });
    var h = "/F1 0 Tf 0 g";
    Object.defineProperty(this, "DA", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (!(!h || this instanceof $ffaeb8e02004bf5e$var$yt || this instanceof $ffaeb8e02004bf5e$export$9d1b52e7fab50c84)) return $ffaeb8e02004bf5e$var$st(h, this.objId, this.scope);
        },
        set: function(t) {
            t = t.toString(), h = t;
        }
    });
    var f = null;
    Object.defineProperty(this, "DV", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (f) return this instanceof $ffaeb8e02004bf5e$export$6aae594af76bbb7b == 0 ? $ffaeb8e02004bf5e$var$st(f, this.objId, this.scope) : f;
        },
        set: function(t) {
            t = t.toString(), f = this instanceof $ffaeb8e02004bf5e$export$6aae594af76bbb7b == 0 ? "(" === t.substr(0, 1) ? $ffaeb8e02004bf5e$var$z(t.substr(1, t.length - 2)) : $ffaeb8e02004bf5e$var$z(t) : t;
        }
    }), Object.defineProperty(this, "defaultValue", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this instanceof $ffaeb8e02004bf5e$export$6aae594af76bbb7b == 1 ? $ffaeb8e02004bf5e$var$z(f.substr(1, f.length - 1)) : f;
        },
        set: function(t) {
            t = t.toString(), f = this instanceof $ffaeb8e02004bf5e$export$6aae594af76bbb7b == 1 ? "/" + t : t;
        }
    });
    var d = null;
    Object.defineProperty(this, "_V", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (d) return d;
        },
        set: function(t) {
            this.V = t;
        }
    }), Object.defineProperty(this, "V", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (d) return this instanceof $ffaeb8e02004bf5e$export$6aae594af76bbb7b == 0 ? $ffaeb8e02004bf5e$var$st(d, this.objId, this.scope) : d;
        },
        set: function(t) {
            t = t.toString(), d = this instanceof $ffaeb8e02004bf5e$export$6aae594af76bbb7b == 0 ? "(" === t.substr(0, 1) ? $ffaeb8e02004bf5e$var$z(t.substr(1, t.length - 2)) : $ffaeb8e02004bf5e$var$z(t) : t;
        }
    }), Object.defineProperty(this, "value", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this instanceof $ffaeb8e02004bf5e$export$6aae594af76bbb7b == 1 ? $ffaeb8e02004bf5e$var$z(d.substr(1, d.length - 1)) : d;
        },
        set: function(t) {
            t = t.toString(), d = this instanceof $ffaeb8e02004bf5e$export$6aae594af76bbb7b == 1 ? "/" + t : t;
        }
    }), Object.defineProperty(this, "hasAnnotation", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this.Rect;
        }
    }), Object.defineProperty(this, "Type", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return this.hasAnnotation ? "/Annot" : null;
        }
    }), Object.defineProperty(this, "Subtype", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return this.hasAnnotation ? "/Widget" : null;
        }
    });
    var p, g = !1;
    Object.defineProperty(this, "hasAppearanceStream", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return g;
        },
        set: function(t) {
            t = Boolean(t), g = t;
        }
    }), Object.defineProperty(this, "page", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            if (p) return p;
        },
        set: function(t) {
            p = t;
        }
    }), Object.defineProperty(this, "readOnly", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($ffaeb8e02004bf5e$var$K(this.Ff, 1));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $ffaeb8e02004bf5e$var$Z(this.Ff, 1) : this.Ff = $ffaeb8e02004bf5e$var$$(this.Ff, 1);
        }
    }), Object.defineProperty(this, "required", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($ffaeb8e02004bf5e$var$K(this.Ff, 2));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $ffaeb8e02004bf5e$var$Z(this.Ff, 2) : this.Ff = $ffaeb8e02004bf5e$var$$(this.Ff, 2);
        }
    }), Object.defineProperty(this, "noExport", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($ffaeb8e02004bf5e$var$K(this.Ff, 3));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $ffaeb8e02004bf5e$var$Z(this.Ff, 3) : this.Ff = $ffaeb8e02004bf5e$var$$(this.Ff, 3);
        }
    });
    var m = null;
    Object.defineProperty(this, "Q", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (null !== m) return m;
        },
        set: function(t) {
            if (-1 === [
                0,
                1,
                2
            ].indexOf(t)) throw new Error('Invalid value "' + t + '" for attribute Q supplied.');
            m = t;
        }
    }), Object.defineProperty(this, "textAlign", {
        get: function() {
            var t;
            switch(m){
                case 0:
                default:
                    t = "left";
                    break;
                case 1:
                    t = "center";
                    break;
                case 2:
                    t = "right";
            }
            return t;
        },
        configurable: !0,
        enumerable: !0,
        set: function(t) {
            switch(t){
                case "right":
                case 2:
                    m = 2;
                    break;
                case "center":
                case 1:
                    m = 1;
                    break;
                default:
                    m = 0;
            }
        }
    });
};
$ffaeb8e02004bf5e$var$W($ffaeb8e02004bf5e$var$ht, $ffaeb8e02004bf5e$var$ut);
var $ffaeb8e02004bf5e$export$a47202eb3f827bb2 = function() {
    $ffaeb8e02004bf5e$var$ht.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
    var t = 0;
    Object.defineProperty(this, "TI", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    }), Object.defineProperty(this, "topIndex", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    });
    var e = [];
    Object.defineProperty(this, "Opt", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return $ffaeb8e02004bf5e$var$ot(e, this.objId, this.scope);
        },
        set: function(t) {
            var n, r;
            r = [], "string" == typeof (n = t) && (r = function(t, e, n) {
                n || (n = 1);
                for(var r, i = []; r = e.exec(t);)i.push(r[n]);
                return i;
            }(n, /\((.*?)\)/g)), e = r;
        }
    }), this.getOptions = function() {
        return e;
    }, this.setOptions = function(t) {
        e = t, this.sort && e.sort();
    }, this.addOption = function(t) {
        t = (t = t || "").toString(), e.push(t), this.sort && e.sort();
    }, this.removeOption = function(t, n) {
        for(n = n || !1, t = (t = t || "").toString(); -1 !== e.indexOf(t) && (e.splice(e.indexOf(t), 1), !1 !== n););
    }, Object.defineProperty(this, "combo", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($ffaeb8e02004bf5e$var$K(this.Ff, 18));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $ffaeb8e02004bf5e$var$Z(this.Ff, 18) : this.Ff = $ffaeb8e02004bf5e$var$$(this.Ff, 18);
        }
    }), Object.defineProperty(this, "edit", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($ffaeb8e02004bf5e$var$K(this.Ff, 19));
        },
        set: function(t) {
            !0 === this.combo && (!0 === Boolean(t) ? this.Ff = $ffaeb8e02004bf5e$var$Z(this.Ff, 19) : this.Ff = $ffaeb8e02004bf5e$var$$(this.Ff, 19));
        }
    }), Object.defineProperty(this, "sort", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($ffaeb8e02004bf5e$var$K(this.Ff, 20));
        },
        set: function(t) {
            !0 === Boolean(t) ? (this.Ff = $ffaeb8e02004bf5e$var$Z(this.Ff, 20), e.sort()) : this.Ff = $ffaeb8e02004bf5e$var$$(this.Ff, 20);
        }
    }), Object.defineProperty(this, "multiSelect", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($ffaeb8e02004bf5e$var$K(this.Ff, 22));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $ffaeb8e02004bf5e$var$Z(this.Ff, 22) : this.Ff = $ffaeb8e02004bf5e$var$$(this.Ff, 22);
        }
    }), Object.defineProperty(this, "doNotSpellCheck", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($ffaeb8e02004bf5e$var$K(this.Ff, 23));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $ffaeb8e02004bf5e$var$Z(this.Ff, 23) : this.Ff = $ffaeb8e02004bf5e$var$$(this.Ff, 23);
        }
    }), Object.defineProperty(this, "commitOnSelChange", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($ffaeb8e02004bf5e$var$K(this.Ff, 27));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $ffaeb8e02004bf5e$var$Z(this.Ff, 27) : this.Ff = $ffaeb8e02004bf5e$var$$(this.Ff, 27);
        }
    }), this.hasAppearanceStream = !1;
};
$ffaeb8e02004bf5e$var$W($ffaeb8e02004bf5e$export$a47202eb3f827bb2, $ffaeb8e02004bf5e$var$ht);
var $ffaeb8e02004bf5e$export$9e021dd9568dc486 = function() {
    $ffaeb8e02004bf5e$export$a47202eb3f827bb2.call(this), this.fontName = "helvetica", this.combo = !1;
};
$ffaeb8e02004bf5e$var$W($ffaeb8e02004bf5e$export$9e021dd9568dc486, $ffaeb8e02004bf5e$export$a47202eb3f827bb2);
var $ffaeb8e02004bf5e$export$f2239d28df5f43bd = function() {
    $ffaeb8e02004bf5e$export$9e021dd9568dc486.call(this), this.combo = !0;
};
$ffaeb8e02004bf5e$var$W($ffaeb8e02004bf5e$export$f2239d28df5f43bd, $ffaeb8e02004bf5e$export$9e021dd9568dc486);
var $ffaeb8e02004bf5e$export$4af052e7e598ad1a = function() {
    $ffaeb8e02004bf5e$export$f2239d28df5f43bd.call(this), this.edit = !0;
};
$ffaeb8e02004bf5e$var$W($ffaeb8e02004bf5e$export$4af052e7e598ad1a, $ffaeb8e02004bf5e$export$f2239d28df5f43bd);
var $ffaeb8e02004bf5e$export$6aae594af76bbb7b = function() {
    $ffaeb8e02004bf5e$var$ht.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($ffaeb8e02004bf5e$var$K(this.Ff, 15));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $ffaeb8e02004bf5e$var$Z(this.Ff, 15) : this.Ff = $ffaeb8e02004bf5e$var$$(this.Ff, 15);
        }
    }), Object.defineProperty(this, "radio", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($ffaeb8e02004bf5e$var$K(this.Ff, 16));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $ffaeb8e02004bf5e$var$Z(this.Ff, 16) : this.Ff = $ffaeb8e02004bf5e$var$$(this.Ff, 16);
        }
    }), Object.defineProperty(this, "pushButton", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($ffaeb8e02004bf5e$var$K(this.Ff, 17));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $ffaeb8e02004bf5e$var$Z(this.Ff, 17) : this.Ff = $ffaeb8e02004bf5e$var$$(this.Ff, 17);
        }
    }), Object.defineProperty(this, "radioIsUnison", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($ffaeb8e02004bf5e$var$K(this.Ff, 26));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $ffaeb8e02004bf5e$var$Z(this.Ff, 26) : this.Ff = $ffaeb8e02004bf5e$var$$(this.Ff, 26);
        }
    });
    var e, n = {};
    Object.defineProperty(this, "MK", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            var t = function(t) {
                return t;
            };
            if (this.scope && (t = this.scope.internal.getEncryptor(this.objId)), 0 !== Object.keys(n).length) {
                var e, r = [];
                for(e in r.push("<<"), n)r.push("/" + e + " (" + $ffaeb8e02004bf5e$var$T(t(n[e])) + ")");
                return r.push(">>"), r.join("\n");
            }
        },
        set: function(e) {
            "object" === (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(e) && (n = e);
        }
    }), Object.defineProperty(this, "caption", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return n.CA || "";
        },
        set: function(t) {
            "string" == typeof t && (n.CA = t);
        }
    }), Object.defineProperty(this, "AS", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "appearanceState", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return e.substr(1, e.length - 1);
        },
        set: function(t) {
            e = "/" + t;
        }
    });
};
$ffaeb8e02004bf5e$var$W($ffaeb8e02004bf5e$export$6aae594af76bbb7b, $ffaeb8e02004bf5e$var$ht);
var $ffaeb8e02004bf5e$export$98b7c3ef37465410 = function() {
    $ffaeb8e02004bf5e$export$6aae594af76bbb7b.call(this), this.pushButton = !0;
};
$ffaeb8e02004bf5e$var$W($ffaeb8e02004bf5e$export$98b7c3ef37465410, $ffaeb8e02004bf5e$export$6aae594af76bbb7b);
var $ffaeb8e02004bf5e$export$bc1318bc7e5f1315 = function() {
    $ffaeb8e02004bf5e$export$6aae594af76bbb7b.call(this), this.radio = !0, this.pushButton = !1;
    var t = [];
    Object.defineProperty(this, "Kids", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = void 0 !== e ? e : [];
        }
    });
};
$ffaeb8e02004bf5e$var$W($ffaeb8e02004bf5e$export$bc1318bc7e5f1315, $ffaeb8e02004bf5e$export$6aae594af76bbb7b);
var $ffaeb8e02004bf5e$var$yt = function() {
    var e, n;
    $ffaeb8e02004bf5e$var$ht.call(this), Object.defineProperty(this, "Parent", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "optionName", {
        enumerable: !1,
        configurable: !0,
        get: function() {
            return n;
        },
        set: function(t) {
            n = t;
        }
    });
    var r, i = {};
    Object.defineProperty(this, "MK", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            var t = function(t) {
                return t;
            };
            this.scope && (t = this.scope.internal.getEncryptor(this.objId));
            var e, n = [];
            for(e in n.push("<<"), i)n.push("/" + e + " (" + $ffaeb8e02004bf5e$var$T(t(i[e])) + ")");
            return n.push(">>"), n.join("\n");
        },
        set: function(e) {
            "object" === (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(e) && (i = e);
        }
    }), Object.defineProperty(this, "caption", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return i.CA || "";
        },
        set: function(t) {
            "string" == typeof t && (i.CA = t);
        }
    }), Object.defineProperty(this, "AS", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return r;
        },
        set: function(t) {
            r = t;
        }
    }), Object.defineProperty(this, "appearanceState", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return r.substr(1, r.length - 1);
        },
        set: function(t) {
            r = "/" + t;
        }
    }), this.caption = "l", this.appearanceState = "Off", this._AppearanceType = $ffaeb8e02004bf5e$export$7d753ad993606f45.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(this.optionName);
};
$ffaeb8e02004bf5e$var$W($ffaeb8e02004bf5e$var$yt, $ffaeb8e02004bf5e$var$ht), $ffaeb8e02004bf5e$export$bc1318bc7e5f1315.prototype.setAppearance = function(t) {
    if (!("createAppearanceStream" in t) || !("getCA" in t)) throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
    for(var e in this.Kids)if (this.Kids.hasOwnProperty(e)) {
        var n = this.Kids[e];
        n.appearanceStreamContent = t.createAppearanceStream(n.optionName), n.caption = t.getCA();
    }
}, $ffaeb8e02004bf5e$export$bc1318bc7e5f1315.prototype.createOption = function(t) {
    var e = new $ffaeb8e02004bf5e$var$yt;
    return e.Parent = this, e.optionName = t, this.Kids.push(e), $ffaeb8e02004bf5e$var$At.call(this.scope, e), e;
};
var $ffaeb8e02004bf5e$export$5fd5db01c4615478 = function() {
    $ffaeb8e02004bf5e$export$6aae594af76bbb7b.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = $ffaeb8e02004bf5e$export$7d753ad993606f45.CheckBox.createAppearanceStream();
};
$ffaeb8e02004bf5e$var$W($ffaeb8e02004bf5e$export$5fd5db01c4615478, $ffaeb8e02004bf5e$export$6aae594af76bbb7b);
var $ffaeb8e02004bf5e$export$9d1b52e7fab50c84 = function() {
    $ffaeb8e02004bf5e$var$ht.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($ffaeb8e02004bf5e$var$K(this.Ff, 13));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $ffaeb8e02004bf5e$var$Z(this.Ff, 13) : this.Ff = $ffaeb8e02004bf5e$var$$(this.Ff, 13);
        }
    }), Object.defineProperty(this, "fileSelect", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($ffaeb8e02004bf5e$var$K(this.Ff, 21));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $ffaeb8e02004bf5e$var$Z(this.Ff, 21) : this.Ff = $ffaeb8e02004bf5e$var$$(this.Ff, 21);
        }
    }), Object.defineProperty(this, "doNotSpellCheck", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($ffaeb8e02004bf5e$var$K(this.Ff, 23));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $ffaeb8e02004bf5e$var$Z(this.Ff, 23) : this.Ff = $ffaeb8e02004bf5e$var$$(this.Ff, 23);
        }
    }), Object.defineProperty(this, "doNotScroll", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($ffaeb8e02004bf5e$var$K(this.Ff, 24));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $ffaeb8e02004bf5e$var$Z(this.Ff, 24) : this.Ff = $ffaeb8e02004bf5e$var$$(this.Ff, 24);
        }
    }), Object.defineProperty(this, "comb", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($ffaeb8e02004bf5e$var$K(this.Ff, 25));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $ffaeb8e02004bf5e$var$Z(this.Ff, 25) : this.Ff = $ffaeb8e02004bf5e$var$$(this.Ff, 25);
        }
    }), Object.defineProperty(this, "richText", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($ffaeb8e02004bf5e$var$K(this.Ff, 26));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $ffaeb8e02004bf5e$var$Z(this.Ff, 26) : this.Ff = $ffaeb8e02004bf5e$var$$(this.Ff, 26);
        }
    });
    var t = null;
    Object.defineProperty(this, "MaxLen", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    }), Object.defineProperty(this, "maxLength", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return t;
        },
        set: function(e) {
            Number.isInteger(e) && (t = e);
        }
    }), Object.defineProperty(this, "hasAppearanceStream", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this.V || this.DV;
        }
    });
};
$ffaeb8e02004bf5e$var$W($ffaeb8e02004bf5e$export$9d1b52e7fab50c84, $ffaeb8e02004bf5e$var$ht);
var $ffaeb8e02004bf5e$export$c48d8668f8cea64d = function() {
    $ffaeb8e02004bf5e$export$9d1b52e7fab50c84.call(this), Object.defineProperty(this, "password", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($ffaeb8e02004bf5e$var$K(this.Ff, 14));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $ffaeb8e02004bf5e$var$Z(this.Ff, 14) : this.Ff = $ffaeb8e02004bf5e$var$$(this.Ff, 14);
        }
    }), this.password = !0;
};
$ffaeb8e02004bf5e$var$W($ffaeb8e02004bf5e$export$c48d8668f8cea64d, $ffaeb8e02004bf5e$export$9d1b52e7fab50c84);
var $ffaeb8e02004bf5e$export$7d753ad993606f45 = {
    CheckBox: {
        createAppearanceStream: function() {
            return {
                N: {
                    On: $ffaeb8e02004bf5e$export$7d753ad993606f45.CheckBox.YesNormal
                },
                D: {
                    On: $ffaeb8e02004bf5e$export$7d753ad993606f45.CheckBox.YesPushDown,
                    Off: $ffaeb8e02004bf5e$export$7d753ad993606f45.CheckBox.OffPushDown
                }
            };
        },
        YesPushDown: function(t) {
            var e = $ffaeb8e02004bf5e$var$G(t);
            e.scope = t.scope;
            var n = [], r = t.scope.internal.getFont(t.fontName, t.fontStyle).id, i = t.scope.__private__.encodeColorString(t.color), a = $ffaeb8e02004bf5e$var$et(t, t.caption);
            return n.push("0.749023 g"), n.push("0 0 " + $ffaeb8e02004bf5e$var$U($ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getWidth(t)) + " " + $ffaeb8e02004bf5e$var$U($ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getHeight(t)) + " re"), n.push("f"), n.push("BMC"), n.push("q"), n.push("0 0 1 rg"), n.push("/" + r + " " + $ffaeb8e02004bf5e$var$U(a.fontSize) + " Tf " + i), n.push("BT"), n.push(a.text), n.push("ET"), n.push("Q"), n.push("EMC"), e.stream = n.join("\n"), e;
        },
        YesNormal: function(t) {
            var e = $ffaeb8e02004bf5e$var$G(t);
            e.scope = t.scope;
            var n = t.scope.internal.getFont(t.fontName, t.fontStyle).id, r = t.scope.__private__.encodeColorString(t.color), i = [], a = $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getHeight(t), o = $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getWidth(t), s = $ffaeb8e02004bf5e$var$et(t, t.caption);
            return i.push("1 g"), i.push("0 0 " + $ffaeb8e02004bf5e$var$U(o) + " " + $ffaeb8e02004bf5e$var$U(a) + " re"), i.push("f"), i.push("q"), i.push("0 0 1 rg"), i.push("0 0 " + $ffaeb8e02004bf5e$var$U(o - 1) + " " + $ffaeb8e02004bf5e$var$U(a - 1) + " re"), i.push("W"), i.push("n"), i.push("0 g"), i.push("BT"), i.push("/" + n + " " + $ffaeb8e02004bf5e$var$U(s.fontSize) + " Tf " + r), i.push(s.text), i.push("ET"), i.push("Q"), e.stream = i.join("\n"), e;
        },
        OffPushDown: function(t) {
            var e = $ffaeb8e02004bf5e$var$G(t);
            e.scope = t.scope;
            var n = [];
            return n.push("0.749023 g"), n.push("0 0 " + $ffaeb8e02004bf5e$var$U($ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getWidth(t)) + " " + $ffaeb8e02004bf5e$var$U($ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getHeight(t)) + " re"), n.push("f"), e.stream = n.join("\n"), e;
        }
    },
    RadioButton: {
        Circle: {
            createAppearanceStream: function(t) {
                var e = {
                    D: {
                        Off: $ffaeb8e02004bf5e$export$7d753ad993606f45.RadioButton.Circle.OffPushDown
                    },
                    N: {}
                };
                return e.N[t] = $ffaeb8e02004bf5e$export$7d753ad993606f45.RadioButton.Circle.YesNormal, e.D[t] = $ffaeb8e02004bf5e$export$7d753ad993606f45.RadioButton.Circle.YesPushDown, e;
            },
            getCA: function() {
                return "l";
            },
            YesNormal: function(t) {
                var e = $ffaeb8e02004bf5e$var$G(t);
                e.scope = t.scope;
                var n = [], r = $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getWidth(t) <= $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getHeight(t) ? $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getWidth(t) / 4 : $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getHeight(t) / 4;
                r = Number((.9 * r).toFixed(5));
                var i = $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.Bezier_C, a = Number((r * i).toFixed(5));
                return n.push("q"), n.push("1 0 0 1 " + $ffaeb8e02004bf5e$var$H($ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $ffaeb8e02004bf5e$var$H($ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), n.push(r + " 0 m"), n.push(r + " " + a + " " + a + " " + r + " 0 " + r + " c"), n.push("-" + a + " " + r + " -" + r + " " + a + " -" + r + " 0 c"), n.push("-" + r + " -" + a + " -" + a + " -" + r + " 0 -" + r + " c"), n.push(a + " -" + r + " " + r + " -" + a + " " + r + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
            },
            YesPushDown: function(t) {
                var e = $ffaeb8e02004bf5e$var$G(t);
                e.scope = t.scope;
                var n = [], r = $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getWidth(t) <= $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getHeight(t) ? $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getWidth(t) / 4 : $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getHeight(t) / 4;
                r = Number((.9 * r).toFixed(5));
                var i = Number((2 * r).toFixed(5)), a = Number((i * $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.Bezier_C).toFixed(5)), o = Number((r * $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.Bezier_C).toFixed(5));
                return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + $ffaeb8e02004bf5e$var$H($ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $ffaeb8e02004bf5e$var$H($ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), n.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), n.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), n.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), n.push("f"), n.push("Q"), n.push("0 g"), n.push("q"), n.push("1 0 0 1 " + $ffaeb8e02004bf5e$var$H($ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $ffaeb8e02004bf5e$var$H($ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), n.push(r + " 0 m"), n.push(r + " " + o + " " + o + " " + r + " 0 " + r + " c"), n.push("-" + o + " " + r + " -" + r + " " + o + " -" + r + " 0 c"), n.push("-" + r + " -" + o + " -" + o + " -" + r + " 0 -" + r + " c"), n.push(o + " -" + r + " " + r + " -" + o + " " + r + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
            },
            OffPushDown: function(t) {
                var e = $ffaeb8e02004bf5e$var$G(t);
                e.scope = t.scope;
                var n = [], r = $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getWidth(t) <= $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getHeight(t) ? $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getWidth(t) / 4 : $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getHeight(t) / 4;
                r = Number((.9 * r).toFixed(5));
                var i = Number((2 * r).toFixed(5)), a = Number((i * $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.Bezier_C).toFixed(5));
                return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + $ffaeb8e02004bf5e$var$H($ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $ffaeb8e02004bf5e$var$H($ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), n.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), n.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), n.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
            }
        },
        Cross: {
            createAppearanceStream: function(t) {
                var e = {
                    D: {
                        Off: $ffaeb8e02004bf5e$export$7d753ad993606f45.RadioButton.Cross.OffPushDown
                    },
                    N: {}
                };
                return e.N[t] = $ffaeb8e02004bf5e$export$7d753ad993606f45.RadioButton.Cross.YesNormal, e.D[t] = $ffaeb8e02004bf5e$export$7d753ad993606f45.RadioButton.Cross.YesPushDown, e;
            },
            getCA: function() {
                return "8";
            },
            YesNormal: function(t) {
                var e = $ffaeb8e02004bf5e$var$G(t);
                e.scope = t.scope;
                var n = [], r = $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.calculateCross(t);
                return n.push("q"), n.push("1 1 " + $ffaeb8e02004bf5e$var$U($ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getWidth(t) - 2) + " " + $ffaeb8e02004bf5e$var$U($ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getHeight(t) - 2) + " re"), n.push("W"), n.push("n"), n.push($ffaeb8e02004bf5e$var$U(r.x1.x) + " " + $ffaeb8e02004bf5e$var$U(r.x1.y) + " m"), n.push($ffaeb8e02004bf5e$var$U(r.x2.x) + " " + $ffaeb8e02004bf5e$var$U(r.x2.y) + " l"), n.push($ffaeb8e02004bf5e$var$U(r.x4.x) + " " + $ffaeb8e02004bf5e$var$U(r.x4.y) + " m"), n.push($ffaeb8e02004bf5e$var$U(r.x3.x) + " " + $ffaeb8e02004bf5e$var$U(r.x3.y) + " l"), n.push("s"), n.push("Q"), e.stream = n.join("\n"), e;
            },
            YesPushDown: function(t) {
                var e = $ffaeb8e02004bf5e$var$G(t);
                e.scope = t.scope;
                var n = $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.calculateCross(t), r = [];
                return r.push("0.749023 g"), r.push("0 0 " + $ffaeb8e02004bf5e$var$U($ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getWidth(t)) + " " + $ffaeb8e02004bf5e$var$U($ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getHeight(t)) + " re"), r.push("f"), r.push("q"), r.push("1 1 " + $ffaeb8e02004bf5e$var$U($ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getWidth(t) - 2) + " " + $ffaeb8e02004bf5e$var$U($ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getHeight(t) - 2) + " re"), r.push("W"), r.push("n"), r.push($ffaeb8e02004bf5e$var$U(n.x1.x) + " " + $ffaeb8e02004bf5e$var$U(n.x1.y) + " m"), r.push($ffaeb8e02004bf5e$var$U(n.x2.x) + " " + $ffaeb8e02004bf5e$var$U(n.x2.y) + " l"), r.push($ffaeb8e02004bf5e$var$U(n.x4.x) + " " + $ffaeb8e02004bf5e$var$U(n.x4.y) + " m"), r.push($ffaeb8e02004bf5e$var$U(n.x3.x) + " " + $ffaeb8e02004bf5e$var$U(n.x3.y) + " l"), r.push("s"), r.push("Q"), e.stream = r.join("\n"), e;
            },
            OffPushDown: function(t) {
                var e = $ffaeb8e02004bf5e$var$G(t);
                e.scope = t.scope;
                var n = [];
                return n.push("0.749023 g"), n.push("0 0 " + $ffaeb8e02004bf5e$var$U($ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getWidth(t)) + " " + $ffaeb8e02004bf5e$var$U($ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getHeight(t)) + " re"), n.push("f"), e.stream = n.join("\n"), e;
            }
        }
    },
    createDefaultAppearanceStream: function(t) {
        var e = t.scope.internal.getFont(t.fontName, t.fontStyle).id, n = t.scope.__private__.encodeColorString(t.color);
        return "/" + e + " " + t.fontSize + " Tf " + n;
    }
};
$ffaeb8e02004bf5e$export$7d753ad993606f45.internal = {
    Bezier_C: .551915024494,
    calculateCross: function(t) {
        var e = $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getWidth(t), n = $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getHeight(t), r = Math.min(e, n);
        return {
            x1: {
                x: (e - r) / 2,
                y: (n - r) / 2 + r
            },
            x2: {
                x: (e - r) / 2 + r,
                y: (n - r) / 2
            },
            x3: {
                x: (e - r) / 2,
                y: (n - r) / 2
            },
            x4: {
                x: (e - r) / 2 + r,
                y: (n - r) / 2 + r
            }
        };
    }
}, $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getWidth = function(e) {
    var n = 0;
    return "object" === (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(e) && (n = $ffaeb8e02004bf5e$var$V(e.Rect[2])), n;
}, $ffaeb8e02004bf5e$export$7d753ad993606f45.internal.getHeight = function(e) {
    var n = 0;
    return "object" === (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(e) && (n = $ffaeb8e02004bf5e$var$V(e.Rect[3])), n;
};
var $ffaeb8e02004bf5e$var$At = $ffaeb8e02004bf5e$var$R.addField = function(t) {
    if ($ffaeb8e02004bf5e$var$at(this, t), !(t instanceof $ffaeb8e02004bf5e$var$ht)) throw new Error("Invalid argument passed to jsPDF.addField.");
    var e;
    return (e = t).scope.internal.acroformPlugin.printedOut && (e.scope.internal.acroformPlugin.printedOut = !1, e.scope.internal.acroformPlugin.acroFormDictionaryRoot = null), e.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(e), t.page = t.scope.internal.getCurrentPageInfo().pageNumber, this;
};
$ffaeb8e02004bf5e$var$R.AcroFormChoiceField = $ffaeb8e02004bf5e$export$a47202eb3f827bb2, $ffaeb8e02004bf5e$var$R.AcroFormListBox = $ffaeb8e02004bf5e$export$9e021dd9568dc486, $ffaeb8e02004bf5e$var$R.AcroFormComboBox = $ffaeb8e02004bf5e$export$f2239d28df5f43bd, $ffaeb8e02004bf5e$var$R.AcroFormEditBox = $ffaeb8e02004bf5e$export$4af052e7e598ad1a, $ffaeb8e02004bf5e$var$R.AcroFormButton = $ffaeb8e02004bf5e$export$6aae594af76bbb7b, $ffaeb8e02004bf5e$var$R.AcroFormPushButton = $ffaeb8e02004bf5e$export$98b7c3ef37465410, $ffaeb8e02004bf5e$var$R.AcroFormRadioButton = $ffaeb8e02004bf5e$export$bc1318bc7e5f1315, $ffaeb8e02004bf5e$var$R.AcroFormCheckBox = $ffaeb8e02004bf5e$export$5fd5db01c4615478, $ffaeb8e02004bf5e$var$R.AcroFormTextField = $ffaeb8e02004bf5e$export$9d1b52e7fab50c84, $ffaeb8e02004bf5e$var$R.AcroFormPasswordField = $ffaeb8e02004bf5e$export$c48d8668f8cea64d, $ffaeb8e02004bf5e$var$R.AcroFormAppearance = $ffaeb8e02004bf5e$export$7d753ad993606f45, $ffaeb8e02004bf5e$var$R.AcroForm = {
    ChoiceField: $ffaeb8e02004bf5e$export$a47202eb3f827bb2,
    ListBox: $ffaeb8e02004bf5e$export$9e021dd9568dc486,
    ComboBox: $ffaeb8e02004bf5e$export$f2239d28df5f43bd,
    EditBox: $ffaeb8e02004bf5e$export$4af052e7e598ad1a,
    Button: $ffaeb8e02004bf5e$export$6aae594af76bbb7b,
    PushButton: $ffaeb8e02004bf5e$export$98b7c3ef37465410,
    RadioButton: $ffaeb8e02004bf5e$export$bc1318bc7e5f1315,
    CheckBox: $ffaeb8e02004bf5e$export$5fd5db01c4615478,
    TextField: $ffaeb8e02004bf5e$export$9d1b52e7fab50c84,
    PasswordField: $ffaeb8e02004bf5e$export$c48d8668f8cea64d,
    Appearance: $ffaeb8e02004bf5e$export$7d753ad993606f45
}, $ffaeb8e02004bf5e$export$2e2bcd8739ae039.AcroForm = {
    ChoiceField: $ffaeb8e02004bf5e$export$a47202eb3f827bb2,
    ListBox: $ffaeb8e02004bf5e$export$9e021dd9568dc486,
    ComboBox: $ffaeb8e02004bf5e$export$f2239d28df5f43bd,
    EditBox: $ffaeb8e02004bf5e$export$4af052e7e598ad1a,
    Button: $ffaeb8e02004bf5e$export$6aae594af76bbb7b,
    PushButton: $ffaeb8e02004bf5e$export$98b7c3ef37465410,
    RadioButton: $ffaeb8e02004bf5e$export$bc1318bc7e5f1315,
    CheckBox: $ffaeb8e02004bf5e$export$5fd5db01c4615478,
    TextField: $ffaeb8e02004bf5e$export$9d1b52e7fab50c84,
    PasswordField: $ffaeb8e02004bf5e$export$c48d8668f8cea64d,
    Appearance: $ffaeb8e02004bf5e$export$7d753ad993606f45
};
var $ffaeb8e02004bf5e$export$9cf40f67b77f45f4 = $ffaeb8e02004bf5e$export$2e2bcd8739ae039.AcroForm;
function $ffaeb8e02004bf5e$var$_t(t) {
    return t.reduce(function(t, e, n) {
        return t[e] = n, t;
    }, {});
}
!function(e) {
    var n = "addImage_";
    e.__addimage__ = {};
    var r = "UNKNOWN", i = {
        PNG: [
            [
                137,
                80,
                78,
                71
            ]
        ],
        TIFF: [
            [
                77,
                77,
                0,
                42
            ],
            [
                73,
                73,
                42,
                0
            ]
        ],
        JPEG: [
            [
                255,
                216,
                255,
                224,
                void 0,
                void 0,
                74,
                70,
                73,
                70,
                0
            ],
            [
                255,
                216,
                255,
                225,
                void 0,
                void 0,
                69,
                120,
                105,
                102,
                0,
                0
            ],
            [
                255,
                216,
                255,
                219
            ],
            [
                255,
                216,
                255,
                238
            ]
        ],
        JPEG2000: [
            [
                0,
                0,
                0,
                12,
                106,
                80,
                32,
                32
            ]
        ],
        GIF87a: [
            [
                71,
                73,
                70,
                56,
                55,
                97
            ]
        ],
        GIF89a: [
            [
                71,
                73,
                70,
                56,
                57,
                97
            ]
        ],
        WEBP: [
            [
                82,
                73,
                70,
                70,
                void 0,
                void 0,
                void 0,
                void 0,
                87,
                69,
                66,
                80
            ]
        ],
        BMP: [
            [
                66,
                77
            ],
            [
                66,
                65
            ],
            [
                67,
                73
            ],
            [
                67,
                80
            ],
            [
                73,
                67
            ],
            [
                80,
                84
            ]
        ]
    }, a = e.__addimage__.getImageFileTypeByImageData = function(t, e) {
        var n, a, o, s, u, c = r;
        if ("RGBA" === (e = e || r) || void 0 !== t.data && t.data instanceof Uint8ClampedArray && "height" in t && "width" in t) return "RGBA";
        if (A(t)) for(u in i)for(o = i[u], n = 0; n < o.length; n += 1){
            for(s = !0, a = 0; a < o[n].length; a += 1)if (void 0 !== o[n][a] && o[n][a] !== t[a]) {
                s = !1;
                break;
            }
            if (!0 === s) {
                c = u;
                break;
            }
        }
        else for(u in i)for(o = i[u], n = 0; n < o.length; n += 1){
            for(s = !0, a = 0; a < o[n].length; a += 1)if (void 0 !== o[n][a] && o[n][a] !== t.charCodeAt(a)) {
                s = !1;
                break;
            }
            if (!0 === s) {
                c = u;
                break;
            }
        }
        return c === r && e !== r && (c = e), c;
    }, o = function t(e) {
        for(var n = this.internal.write, r = this.internal.putStream, i = (0, this.internal.getFilters)(); -1 !== i.indexOf("FlateEncode");)i.splice(i.indexOf("FlateEncode"), 1);
        e.objectId = this.internal.newObject();
        var a = [];
        if (a.push({
            key: "Type",
            value: "/XObject"
        }), a.push({
            key: "Subtype",
            value: "/Image"
        }), a.push({
            key: "Width",
            value: e.width
        }), a.push({
            key: "Height",
            value: e.height
        }), e.colorSpace === y.INDEXED ? a.push({
            key: "ColorSpace",
            value: "[/Indexed /DeviceRGB " + (e.palette.length / 3 - 1) + " " + ("sMask" in e && void 0 !== e.sMask ? e.objectId + 2 : e.objectId + 1) + " 0 R]"
        }) : (a.push({
            key: "ColorSpace",
            value: "/" + e.colorSpace
        }), e.colorSpace === y.DEVICE_CMYK && a.push({
            key: "Decode",
            value: "[1 0 1 0 1 0 1 0]"
        })), a.push({
            key: "BitsPerComponent",
            value: e.bitsPerComponent
        }), "decodeParameters" in e && void 0 !== e.decodeParameters && a.push({
            key: "DecodeParms",
            value: "<<" + e.decodeParameters + ">>"
        }), "transparency" in e && Array.isArray(e.transparency) && e.transparency.length > 0) {
            for(var o = "", s = 0, u = e.transparency.length; s < u; s++)o += e.transparency[s] + " " + e.transparency[s] + " ";
            a.push({
                key: "Mask",
                value: "[" + o + "]"
            });
        }
        void 0 !== e.sMask && a.push({
            key: "SMask",
            value: e.objectId + 1 + " 0 R"
        });
        var c = void 0 !== e.filter ? [
            "/" + e.filter
        ] : void 0;
        if (r({
            data: e.data,
            additionalKeyValues: a,
            alreadyAppliedFilters: c,
            objectId: e.objectId
        }), n("endobj"), "sMask" in e && void 0 !== e.sMask) {
            var l, h = null !== (l = e.sMaskBitsPerComponent) && void 0 !== l ? l : e.bitsPerComponent, f = {
                width: e.width,
                height: e.height,
                colorSpace: "DeviceGray",
                bitsPerComponent: h,
                data: e.sMask
            };
            "filter" in e && (f.decodeParameters = "/Predictor ".concat(e.predictor, " /Colors 1 /BitsPerComponent ").concat(h, " /Columns ").concat(e.width), f.filter = e.filter), t.call(this, f);
        }
        if (e.colorSpace === y.INDEXED) {
            var d = this.internal.newObject();
            r({
                data: _(new Uint8Array(e.palette)),
                objectId: d
            }), n("endobj");
        }
    }, s = function() {
        var t = this.internal.collections[n + "images"];
        for(var e in t)o.call(this, t[e]);
    }, u = function() {
        var t, e = this.internal.collections[n + "images"], r = this.internal.write;
        for(var i in e)r("/I" + (t = e[i]).index, t.objectId, "0", "R");
    }, c = function() {
        this.internal.collections[n + "images"] || (this.internal.collections[n + "images"] = {}, this.internal.events.subscribe("putResources", s), this.internal.events.subscribe("putXobjectDict", u));
    }, l = function() {
        var t = this.internal.collections[n + "images"];
        return c.call(this), t;
    }, h = function() {
        return Object.keys(this.internal.collections[n + "images"]).length;
    }, d = function(t) {
        return "function" == typeof e["process" + t.toUpperCase()];
    }, p = function(e) {
        return "object" === (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(e) && 1 === e.nodeType;
    }, g = function(t, n) {
        if ("IMG" === t.nodeName && t.hasAttribute("src")) {
            var r = "" + t.getAttribute("src");
            if (0 === r.indexOf("data:image/")) return $ffaeb8e02004bf5e$var$f(unescape(r).split("base64,").pop());
            var i = e.loadFile(r, !0);
            if (void 0 !== i) return i;
        }
        if ("CANVAS" === t.nodeName) {
            if (0 === t.width || 0 === t.height) throw new Error("Given canvas must have data. Canvas width: " + t.width + ", height: " + t.height);
            var a;
            switch(n){
                case "PNG":
                    a = "image/png";
                    break;
                case "WEBP":
                    a = "image/webp";
                    break;
                default:
                    a = "image/jpeg";
            }
            return $ffaeb8e02004bf5e$var$f(t.toDataURL(a, 1).split("base64,").pop());
        }
    }, m = function(t) {
        var e = this.internal.collections[n + "images"];
        if (e) {
            for(var r in e)if (t === e[r].alias) return e[r];
        }
    }, v = function(t, e, n) {
        return t || e || (t = -96, e = -96), t < 0 && (t = -1 * n.width * 72 / t / this.internal.scaleFactor), e < 0 && (e = -1 * n.height * 72 / e / this.internal.scaleFactor), 0 === t && (t = e * n.width / n.height), 0 === e && (e = t * n.height / n.width), [
            t,
            e
        ];
    }, b = function(t, e, n, r, i, a) {
        var o = v.call(this, n, r, i), s = this.internal.getCoordinateString, u = this.internal.getVerticalCoordinateString, c = l.call(this);
        if (n = o[0], r = o[1], c[i.index] = i, a) {
            a *= Math.PI / 180;
            var h = Math.cos(a), f = Math.sin(a), d = function(t) {
                return t.toFixed(4);
            }, p = [
                d(h),
                d(f),
                d(-1 * f),
                d(h),
                0,
                0,
                "cm"
            ];
        }
        this.internal.write("q"), a ? (this.internal.write([
            1,
            "0",
            "0",
            1,
            s(t),
            u(e + r),
            "cm"
        ].join(" ")), this.internal.write(p.join(" ")), this.internal.write([
            s(n),
            "0",
            "0",
            s(r),
            "0",
            "0",
            "cm"
        ].join(" "))) : this.internal.write([
            s(n),
            "0",
            "0",
            s(r),
            s(t),
            u(e + r),
            "cm"
        ].join(" ")), this.isAdvancedAPI() && this.internal.write([
            1,
            0,
            0,
            -1,
            0,
            0,
            "cm"
        ].join(" ")), this.internal.write("/I" + i.index + " Do"), this.internal.write("Q");
    }, y = e.color_spaces = {
        DEVICE_RGB: "DeviceRGB",
        DEVICE_GRAY: "DeviceGray",
        DEVICE_CMYK: "DeviceCMYK",
        CAL_GREY: "CalGray",
        CAL_RGB: "CalRGB",
        LAB: "Lab",
        ICC_BASED: "ICCBased",
        INDEXED: "Indexed",
        PATTERN: "Pattern",
        SEPARATION: "Separation",
        DEVICE_N: "DeviceN"
    };
    e.decode = {
        DCT_DECODE: "DCTDecode",
        FLATE_DECODE: "FlateDecode",
        LZW_DECODE: "LZWDecode",
        JPX_DECODE: "JPXDecode",
        JBIG2_DECODE: "JBIG2Decode",
        ASCII85_DECODE: "ASCII85Decode",
        ASCII_HEX_DECODE: "ASCIIHexDecode",
        RUN_LENGTH_DECODE: "RunLengthDecode",
        CCITT_FAX_DECODE: "CCITTFaxDecode"
    };
    var w = e.image_compression = {
        NONE: "NONE",
        FAST: "FAST",
        MEDIUM: "MEDIUM",
        SLOW: "SLOW"
    }, N = e.__addimage__.sHashCode = function(t) {
        var e, n, r = 0;
        if ("string" == typeof t) for(n = t.length, e = 0; e < n; e++)r = (r << 5) - r + t.charCodeAt(e), r |= 0;
        else if (A(t)) for(n = t.byteLength / 2, e = 0; e < n; e++)r = (r << 5) - r + t[e], r |= 0;
        return r;
    }, L = e.__addimage__.validateStringAsBase64 = function(t) {
        (t = t || "").toString().trim();
        var e = !0;
        return 0 === t.length && (e = !1), t.length % 4 != 0 && (e = !1), !1 === /^[A-Za-z0-9+/]+$/.test(t.substr(0, t.length - 2)) && (e = !1), !1 === /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(t.substr(-2)) && (e = !1), e;
    }, x = e.__addimage__.extractImageFromDataUrl = function(t) {
        if (null == t) return null;
        if (!(t = t.trim()).startsWith("data:")) return null;
        var e = t.indexOf(",");
        return e < 0 ? null : t.substring(0, e).trim().endsWith("base64") ? t.substring(e + 1) : null;
    };
    e.__addimage__.isArrayBuffer = function(t) {
        return t instanceof ArrayBuffer;
    };
    var A = e.__addimage__.isArrayBufferView = function(t) {
        return t instanceof Int8Array || t instanceof Uint8Array || t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array;
    }, S = e.__addimage__.binaryStringToUint8Array = function(t) {
        for(var e = t.length, n = new Uint8Array(e), r = 0; r < e; r++)n[r] = t.charCodeAt(r);
        return n;
    }, _ = e.__addimage__.arrayBufferToBinaryString = function(t) {
        for(var e = "", n = A(t) ? t : new Uint8Array(t), r = 0; r < n.length; r += 8192)e += String.fromCharCode.apply(null, n.subarray(r, r + 8192));
        return e;
    };
    e.addImage = function() {
        var e, n, i, a, o, s, u, l, h;
        if ("number" == typeof arguments[1] ? (n = r, i = arguments[1], a = arguments[2], o = arguments[3], s = arguments[4], u = arguments[5], l = arguments[6], h = arguments[7]) : (n = arguments[1], i = arguments[2], a = arguments[3], o = arguments[4], s = arguments[5], u = arguments[6], l = arguments[7], h = arguments[8]), "object" === (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(e = arguments[0]) && !p(e) && "imageData" in e) {
            var f = e;
            e = f.imageData, n = f.format || n || r, i = f.x || i || 0, a = f.y || a || 0, o = f.w || f.width || o, s = f.h || f.height || s, u = f.alias || u, l = f.compression || l, h = f.rotation || f.angle || h;
        }
        var d = this.internal.getFilters();
        if (void 0 === l && -1 !== d.indexOf("FlateEncode") && (l = "SLOW"), isNaN(i) || isNaN(a)) throw new Error("Invalid coordinates passed to jsPDF.addImage");
        c.call(this);
        var g = P.call(this, e, n, u, l);
        return b.call(this, i, a, o, s, g, h), this;
    };
    var P = function(t, n, i, o) {
        var s, u, c;
        if ("string" == typeof t && a(t) === r) {
            t = unescape(t);
            var l = k(t, !1);
            ("" !== l || void 0 !== (l = e.loadFile(t, !0))) && (t = l);
        }
        if (p(t) && (t = g(t, n)), n = a(t, n), !d(n)) throw new Error("addImage does not support files of type '" + n + "', please ensure that a plugin for '" + n + "' support is added.");
        if ((null == (c = i) || 0 === c.length) && (i = function(t) {
            return "string" == typeof t || A(t) ? N(t) : A(t.data) ? N(t.data) : null;
        }(t)), (s = m.call(this, i)) || (t instanceof Uint8Array || "RGBA" === n || (u = t, t = S(t)), s = this["process" + n.toUpperCase()](t, h.call(this), i, function(t) {
            return t && "string" == typeof t && (t = t.toUpperCase()), t in e.image_compression ? t : w.NONE;
        }(o), u)), !s) throw new Error("An unknown error occurred whilst processing the image.");
        return s;
    }, k = e.__addimage__.convertBase64ToBinaryString = function(t, e) {
        e = "boolean" != typeof e || e;
        var n, r = "";
        if ("string" == typeof t) {
            var i;
            n = null !== (i = x(t)) && void 0 !== i ? i : t;
            try {
                r = $ffaeb8e02004bf5e$var$f(n);
            } catch (a) {
                if (e) throw L(n) ? new Error("atob-Error in jsPDF.convertBase64ToBinaryString " + a.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ");
            }
        }
        return r;
    };
    e.getImageProperties = function(t) {
        var n, i, o = "";
        if (p(t) && (t = g(t)), "string" == typeof t && a(t) === r && ("" === (o = k(t, !1)) && (o = e.loadFile(t) || ""), t = o), i = a(t), !d(i)) throw new Error("addImage does not support files of type '" + i + "', please ensure that a plugin for '" + i + "' support is added.");
        if (t instanceof Uint8Array || (t = S(t)), !(n = this["process" + i.toUpperCase()](t))) throw new Error("An unknown error occurred whilst processing the image");
        return n.fileType = i, n;
    };
}($ffaeb8e02004bf5e$export$2e2bcd8739ae039.API), /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function(t) {
        if (void 0 !== t && "" != t) return !0;
    };
    $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.events.push([
        "addPage",
        function(t) {
            this.internal.getPageInfo(t.pageNumber).pageContext.annotations = [];
        }
    ]), t.events.push([
        "putPage",
        function(t) {
            for(var n, r, i, a = this.internal.getCoordinateString, o = this.internal.getVerticalCoordinateString, s = this.internal.getPageInfoByObjId(t.objId), u = t.pageContext.annotations, c = !1, l = 0; l < u.length && !c; l++)switch((n = u[l]).type){
                case "link":
                    (e(n.options.url) || e(n.options.pageNumber)) && (c = !0);
                    break;
                case "reference":
                case "text":
                case "freetext":
                    c = !0;
            }
            if (0 != c) {
                this.internal.write("/Annots [");
                for(var h = 0; h < u.length; h++){
                    n = u[h];
                    var f = this.internal.pdfEscape, d = this.internal.getEncryptor(t.objId);
                    switch(n.type){
                        case "reference":
                            this.internal.write(" " + n.object.objId + " 0 R ");
                            break;
                        case "text":
                            var p = this.internal.newAdditionalObject(), g = this.internal.newAdditionalObject(), m = this.internal.getEncryptor(p.objId), v = n.title || "Note";
                            i = "<</Type /Annot /Subtype /Text " + (r = "/Rect [" + a(n.bounds.x) + " " + o(n.bounds.y + n.bounds.h) + " " + a(n.bounds.x + n.bounds.w) + " " + o(n.bounds.y) + "] ") + "/Contents (" + f(m(n.contents)) + ")", i += " /Popup " + g.objId + " 0 R", i += " /P " + s.objId + " 0 R", i += " /T (" + f(m(v)) + ") >>", p.content = i;
                            var b = p.objId + " 0 R";
                            i = "<</Type /Annot /Subtype /Popup " + (r = "/Rect [" + a(n.bounds.x + 30) + " " + o(n.bounds.y + n.bounds.h) + " " + a(n.bounds.x + n.bounds.w + 30) + " " + o(n.bounds.y) + "] ") + " /Parent " + b, n.open && (i += " /Open true"), i += " >>", g.content = i, this.internal.write(p.objId, "0 R", g.objId, "0 R");
                            break;
                        case "freetext":
                            r = "/Rect [" + a(n.bounds.x) + " " + o(n.bounds.y) + " " + a(n.bounds.x + n.bounds.w) + " " + o(n.bounds.y + n.bounds.h) + "] ";
                            var y = n.color || "#000000";
                            i = "<</Type /Annot /Subtype /FreeText " + r + "/Contents (" + f(d(n.contents)) + ")", i += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + y + ")", i += " /Border [0 0 0]", i += " >>", this.internal.write(i);
                            break;
                        case "link":
                            if (n.options.name) {
                                var w = this.annotations._nameMap[n.options.name];
                                n.options.pageNumber = w.page, n.options.top = w.y;
                            } else n.options.top || (n.options.top = 0);
                            if (r = "/Rect [" + n.finalBounds.x + " " + n.finalBounds.y + " " + n.finalBounds.w + " " + n.finalBounds.h + "] ", i = "", n.options.url) i = "<</Type /Annot /Subtype /Link " + r + "/Border [0 0 0] /A <</S /URI /URI (" + f(d(n.options.url)) + ") >>";
                            else if (n.options.pageNumber) switch(i = "<</Type /Annot /Subtype /Link " + r + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(n.options.pageNumber).objId + " 0 R", n.options.magFactor = n.options.magFactor || "XYZ", n.options.magFactor){
                                case "Fit":
                                    i += " /Fit]";
                                    break;
                                case "FitH":
                                    i += " /FitH " + n.options.top + "]";
                                    break;
                                case "FitV":
                                    n.options.left = n.options.left || 0, i += " /FitV " + n.options.left + "]";
                                    break;
                                default:
                                    var N = o(n.options.top);
                                    n.options.left = n.options.left || 0, void 0 === n.options.zoom && (n.options.zoom = 0), i += " /XYZ " + n.options.left + " " + N + " " + n.options.zoom + "]";
                            }
                            "" != i && (i += " >>", this.internal.write(i));
                    }
                }
                this.internal.write("]");
            }
        }
    ]), t.createAnnotation = function(t) {
        var e = this.internal.getCurrentPageInfo();
        switch(t.type){
            case "link":
                this.link(t.bounds.x, t.bounds.y, t.bounds.w, t.bounds.h, t);
                break;
            case "text":
            case "freetext":
                e.pageContext.annotations.push(t);
        }
    }, t.link = function(t, e, n, r, i) {
        var a = this.internal.getCurrentPageInfo(), o = this.internal.getCoordinateString, s = this.internal.getVerticalCoordinateString;
        a.pageContext.annotations.push({
            finalBounds: {
                x: o(t),
                y: s(e),
                w: o(t + n),
                h: s(e + r)
            },
            options: i,
            type: "link"
        });
    }, t.textWithLink = function(t, e, n, r) {
        var i, a, o = this.getTextWidth(t), s = this.internal.getLineHeight() / this.internal.scaleFactor;
        if (void 0 !== r.maxWidth) {
            a = r.maxWidth;
            var u = this.splitTextToSize(t, a).length;
            i = Math.ceil(s * u);
        } else a = o, i = s;
        return this.text(t, e, n, r), n += .2 * s, "center" === r.align && (e -= o / 2), "right" === r.align && (e -= o), this.link(e, n - s, a, i, r), o;
    }, t.getTextWidth = function(t) {
        var e = this.internal.getFontSize();
        return this.getStringUnitWidth(t) * e / this.internal.scaleFactor;
    };
}($ffaeb8e02004bf5e$export$2e2bcd8739ae039.API), /**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = {
        1569: [
            65152
        ],
        1570: [
            65153,
            65154
        ],
        1571: [
            65155,
            65156
        ],
        1572: [
            65157,
            65158
        ],
        1573: [
            65159,
            65160
        ],
        1574: [
            65161,
            65162,
            65163,
            65164
        ],
        1575: [
            65165,
            65166
        ],
        1576: [
            65167,
            65168,
            65169,
            65170
        ],
        1577: [
            65171,
            65172
        ],
        1578: [
            65173,
            65174,
            65175,
            65176
        ],
        1579: [
            65177,
            65178,
            65179,
            65180
        ],
        1580: [
            65181,
            65182,
            65183,
            65184
        ],
        1581: [
            65185,
            65186,
            65187,
            65188
        ],
        1582: [
            65189,
            65190,
            65191,
            65192
        ],
        1583: [
            65193,
            65194
        ],
        1584: [
            65195,
            65196
        ],
        1585: [
            65197,
            65198
        ],
        1586: [
            65199,
            65200
        ],
        1587: [
            65201,
            65202,
            65203,
            65204
        ],
        1588: [
            65205,
            65206,
            65207,
            65208
        ],
        1589: [
            65209,
            65210,
            65211,
            65212
        ],
        1590: [
            65213,
            65214,
            65215,
            65216
        ],
        1591: [
            65217,
            65218,
            65219,
            65220
        ],
        1592: [
            65221,
            65222,
            65223,
            65224
        ],
        1593: [
            65225,
            65226,
            65227,
            65228
        ],
        1594: [
            65229,
            65230,
            65231,
            65232
        ],
        1601: [
            65233,
            65234,
            65235,
            65236
        ],
        1602: [
            65237,
            65238,
            65239,
            65240
        ],
        1603: [
            65241,
            65242,
            65243,
            65244
        ],
        1604: [
            65245,
            65246,
            65247,
            65248
        ],
        1605: [
            65249,
            65250,
            65251,
            65252
        ],
        1606: [
            65253,
            65254,
            65255,
            65256
        ],
        1607: [
            65257,
            65258,
            65259,
            65260
        ],
        1608: [
            65261,
            65262
        ],
        1609: [
            65263,
            65264,
            64488,
            64489
        ],
        1610: [
            65265,
            65266,
            65267,
            65268
        ],
        1649: [
            64336,
            64337
        ],
        1655: [
            64477
        ],
        1657: [
            64358,
            64359,
            64360,
            64361
        ],
        1658: [
            64350,
            64351,
            64352,
            64353
        ],
        1659: [
            64338,
            64339,
            64340,
            64341
        ],
        1662: [
            64342,
            64343,
            64344,
            64345
        ],
        1663: [
            64354,
            64355,
            64356,
            64357
        ],
        1664: [
            64346,
            64347,
            64348,
            64349
        ],
        1667: [
            64374,
            64375,
            64376,
            64377
        ],
        1668: [
            64370,
            64371,
            64372,
            64373
        ],
        1670: [
            64378,
            64379,
            64380,
            64381
        ],
        1671: [
            64382,
            64383,
            64384,
            64385
        ],
        1672: [
            64392,
            64393
        ],
        1676: [
            64388,
            64389
        ],
        1677: [
            64386,
            64387
        ],
        1678: [
            64390,
            64391
        ],
        1681: [
            64396,
            64397
        ],
        1688: [
            64394,
            64395
        ],
        1700: [
            64362,
            64363,
            64364,
            64365
        ],
        1702: [
            64366,
            64367,
            64368,
            64369
        ],
        1705: [
            64398,
            64399,
            64400,
            64401
        ],
        1709: [
            64467,
            64468,
            64469,
            64470
        ],
        1711: [
            64402,
            64403,
            64404,
            64405
        ],
        1713: [
            64410,
            64411,
            64412,
            64413
        ],
        1715: [
            64406,
            64407,
            64408,
            64409
        ],
        1722: [
            64414,
            64415
        ],
        1723: [
            64416,
            64417,
            64418,
            64419
        ],
        1726: [
            64426,
            64427,
            64428,
            64429
        ],
        1728: [
            64420,
            64421
        ],
        1729: [
            64422,
            64423,
            64424,
            64425
        ],
        1733: [
            64480,
            64481
        ],
        1734: [
            64473,
            64474
        ],
        1735: [
            64471,
            64472
        ],
        1736: [
            64475,
            64476
        ],
        1737: [
            64482,
            64483
        ],
        1739: [
            64478,
            64479
        ],
        1740: [
            64508,
            64509,
            64510,
            64511
        ],
        1744: [
            64484,
            64485,
            64486,
            64487
        ],
        1746: [
            64430,
            64431
        ],
        1747: [
            64432,
            64433
        ]
    }, n = {
        65247: {
            65154: 65269,
            65156: 65271,
            65160: 65273,
            65166: 65275
        },
        65248: {
            65154: 65270,
            65156: 65272,
            65160: 65274,
            65166: 65276
        },
        65165: {
            65247: {
                65248: {
                    65258: 65010
                }
            }
        },
        1617: {
            1612: 64606,
            1613: 64607,
            1614: 64608,
            1615: 64609,
            1616: 64610
        }
    }, r = {
        1612: 64606,
        1613: 64607,
        1614: 64608,
        1615: 64609,
        1616: 64610
    }, i = [
        1570,
        1571,
        1573,
        1575
    ];
    t.__arabicParser__ = {};
    var a = t.__arabicParser__.isInArabicSubstitutionA = function(t) {
        return void 0 !== e[t.charCodeAt(0)];
    }, o = t.__arabicParser__.isArabicLetter = function(t) {
        return "string" == typeof t && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t);
    }, s = t.__arabicParser__.isArabicEndLetter = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length <= 2;
    }, u = t.__arabicParser__.isArabicAlfLetter = function(t) {
        return o(t) && i.indexOf(t.charCodeAt(0)) >= 0;
    };
    t.__arabicParser__.arabicLetterHasIsolatedForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 1;
    };
    var c = t.__arabicParser__.arabicLetterHasFinalForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 2;
    };
    t.__arabicParser__.arabicLetterHasInitialForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 3;
    };
    var l = t.__arabicParser__.arabicLetterHasMedialForm = function(t) {
        return o(t) && a(t) && 4 == e[t.charCodeAt(0)].length;
    }, h = t.__arabicParser__.resolveLigatures = function(t) {
        var e = 0, r = n, i = "", a = 0;
        for(e = 0; e < t.length; e += 1)void 0 !== r[t.charCodeAt(e)] ? (a++, "number" == typeof (r = r[t.charCodeAt(e)]) && (i += String.fromCharCode(r), r = n, a = 0), e === t.length - 1 && (r = n, i += t.charAt(e - (a - 1)), e -= a - 1, a = 0)) : (r = n, i += t.charAt(e - a), e -= a, a = 0);
        return i;
    };
    t.__arabicParser__.isArabicDiacritic = function(t) {
        return void 0 !== t && void 0 !== r[t.charCodeAt(0)];
    };
    var f = t.__arabicParser__.getCorrectForm = function(t, e, n) {
        return o(t) ? !1 === a(t) ? -1 : !c(t) || !o(e) && !o(n) || !o(n) && s(e) || s(t) && !o(e) || s(t) && u(e) || s(t) && s(e) ? 0 : l(t) && o(e) && !s(e) && o(n) && c(n) ? 3 : s(t) || !o(n) ? 1 : 2 : -1;
    }, d = function(t) {
        var n = 0, r = 0, i = 0, a = "", s = "", u = "", c = (t = t || "").split("\\s+"), l = [];
        for(n = 0; n < c.length; n += 1){
            for(l.push(""), r = 0; r < c[n].length; r += 1)a = c[n][r], s = c[n][r - 1], u = c[n][r + 1], o(a) ? (i = f(a, s, u), l[n] += -1 !== i ? String.fromCharCode(e[a.charCodeAt(0)][i]) : a) : l[n] += a;
            l[n] = h(l[n]);
        }
        return l.join(" ");
    }, p = t.__arabicParser__.processArabic = t.processArabic = function() {
        var t, e = "string" == typeof arguments[0] ? arguments[0] : arguments[0].text, n = [];
        if (Array.isArray(e)) {
            var r = 0;
            for(n = [], r = 0; r < e.length; r += 1)Array.isArray(e[r]) ? n.push([
                d(e[r][0]),
                e[r][1],
                e[r][2]
            ]) : n.push([
                d(e[r])
            ]);
            t = n;
        } else t = d(e);
        return "string" == typeof arguments[0] ? t : (arguments[0].text = t, arguments[0]);
    };
    t.events.push([
        "preProcessText",
        p
    ]);
}($ffaeb8e02004bf5e$export$2e2bcd8739ae039.API), $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.autoPrint = function(t) {
    var e;
    return (t = t || {}).variant = t.variant || "non-conform", "javascript" === t.variant ? this.addJS("print({});") : (this.internal.events.subscribe("postPutResources", function() {
        e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
    }), this.internal.events.subscribe("putCatalog", function() {
        this.internal.out("/OpenAction " + e + " 0 R");
    })), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function() {
        var t = void 0;
        Object.defineProperty(this, "pdf", {
            get: function() {
                return t;
            },
            set: function(e) {
                t = e;
            }
        });
        var e = 150;
        Object.defineProperty(this, "width", {
            get: function() {
                return e;
            },
            set: function(t) {
                e = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 150 : t, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = e + 1);
            }
        });
        var n = 300;
        Object.defineProperty(this, "height", {
            get: function() {
                return n;
            },
            set: function(t) {
                n = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 300 : t, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = n + 1);
            }
        });
        var r = [];
        Object.defineProperty(this, "childNodes", {
            get: function() {
                return r;
            },
            set: function(t) {
                r = t;
            }
        });
        var i = {};
        Object.defineProperty(this, "style", {
            get: function() {
                return i;
            },
            set: function(t) {
                i = t;
            }
        }), Object.defineProperty(this, "parentNode", {});
    };
    e.prototype.getContext = function(t, e) {
        var n;
        if ("2d" !== (t = t || "2d")) return null;
        for(n in e)this.pdf.context2d.hasOwnProperty(n) && (this.pdf.context2d[n] = e[n]);
        return this.pdf.context2d._canvas = this, this.pdf.context2d;
    }, e.prototype.toDataURL = function() {
        throw new Error("toDataURL is not implemented.");
    }, t.events.push([
        "initialized",
        function() {
            this.canvas = new e, this.canvas.pdf = this;
        }
    ]);
}($ffaeb8e02004bf5e$export$2e2bcd8739ae039.API), function(e) {
    var n = {
        left: 0,
        top: 0,
        bottom: 0,
        right: 0
    }, r = !1, i = function() {
        void 0 === this.internal.__cell__ && (this.internal.__cell__ = {}, this.internal.__cell__.padding = 3, this.internal.__cell__.headerFunction = void 0, this.internal.__cell__.margins = Object.assign({}, n), this.internal.__cell__.margins.width = this.getPageWidth(), a.call(this));
    }, a = function() {
        this.internal.__cell__.lastCell = new o, this.internal.__cell__.pages = 1;
    }, o = function() {
        var t = arguments[0];
        Object.defineProperty(this, "x", {
            enumerable: !0,
            get: function() {
                return t;
            },
            set: function(e) {
                t = e;
            }
        });
        var e = arguments[1];
        Object.defineProperty(this, "y", {
            enumerable: !0,
            get: function() {
                return e;
            },
            set: function(t) {
                e = t;
            }
        });
        var n = arguments[2];
        Object.defineProperty(this, "width", {
            enumerable: !0,
            get: function() {
                return n;
            },
            set: function(t) {
                n = t;
            }
        });
        var r = arguments[3];
        Object.defineProperty(this, "height", {
            enumerable: !0,
            get: function() {
                return r;
            },
            set: function(t) {
                r = t;
            }
        });
        var i = arguments[4];
        Object.defineProperty(this, "text", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                i = t;
            }
        });
        var a = arguments[5];
        Object.defineProperty(this, "lineNumber", {
            enumerable: !0,
            get: function() {
                return a;
            },
            set: function(t) {
                a = t;
            }
        });
        var o = arguments[6];
        return Object.defineProperty(this, "align", {
            enumerable: !0,
            get: function() {
                return o;
            },
            set: function(t) {
                o = t;
            }
        }), this;
    };
    o.prototype.clone = function() {
        return new o(this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align);
    }, o.prototype.toArray = function() {
        return [
            this.x,
            this.y,
            this.width,
            this.height,
            this.text,
            this.lineNumber,
            this.align
        ];
    }, e.setHeaderFunction = function(t) {
        return i.call(this), this.internal.__cell__.headerFunction = "function" == typeof t ? t : void 0, this;
    }, e.getTextDimensions = function(t, e) {
        i.call(this);
        var n = (e = e || {}).fontSize || this.getFontSize(), r = e.font || this.getFont(), a = e.scaleFactor || this.internal.scaleFactor, o = 0, s = 0, u = 0, c = this;
        if (!Array.isArray(t) && "string" != typeof t) {
            if ("number" != typeof t) throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");
            t = String(t);
        }
        var l = e.maxWidth;
        l > 0 ? "string" == typeof t ? t = this.splitTextToSize(t, l) : "[object Array]" === Object.prototype.toString.call(t) && (t = t.reduce(function(t, e) {
            return t.concat(c.splitTextToSize(e, l));
        }, [])) : t = Array.isArray(t) ? t : [
            t
        ];
        for(var h = 0; h < t.length; h++)o < (u = this.getStringUnitWidth(t[h], {
            font: r
        }) * n) && (o = u);
        return 0 !== o && (s = t.length), {
            w: o /= a,
            h: Math.max((s * n * this.getLineHeightFactor() - n * (this.getLineHeightFactor() - 1)) / a, 0)
        };
    }, e.cellAddPage = function() {
        i.call(this), this.addPage();
        var t = this.internal.__cell__.margins || n;
        return this.internal.__cell__.lastCell = new o(t.left, t.top, void 0, void 0), this.internal.__cell__.pages += 1, this;
    };
    var s = e.cell = function() {
        var t;
        t = arguments[0] instanceof o ? arguments[0] : new o(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6]), i.call(this);
        var e = this.internal.__cell__.lastCell, a = this.internal.__cell__.padding, s = this.internal.__cell__.margins || n, u = this.internal.__cell__.tableHeaderRow, c = this.internal.__cell__.printHeaders;
        return void 0 !== e.lineNumber && (e.lineNumber === t.lineNumber ? (t.x = (e.x || 0) + (e.width || 0), t.y = e.y || 0) : e.y + e.height + t.height + s.bottom > this.getPageHeight() ? (this.cellAddPage(), t.y = s.top, c && u && (this.printHeaderRow(t.lineNumber, !0), t.y += u[0].height)) : t.y = e.y + e.height || t.y), void 0 !== t.text[0] && (this.rect(t.x, t.y, t.width, t.height, !0 === r ? "FD" : void 0), "right" === t.align ? this.text(t.text, t.x + t.width - a, t.y + a, {
            align: "right",
            baseline: "top"
        }) : "center" === t.align ? this.text(t.text, t.x + t.width / 2, t.y + a, {
            align: "center",
            baseline: "top",
            maxWidth: t.width - a - a
        }) : this.text(t.text, t.x + a, t.y + a, {
            align: "left",
            baseline: "top",
            maxWidth: t.width - a - a
        })), this.internal.__cell__.lastCell = t, this;
    };
    e.table = function(e, r, c, l, h) {
        if (i.call(this), !c) throw new Error("No data for PDF table.");
        var f, d, p, g, m = [], v = [], b = [], y = {}, w = {}, N = [], L = [], x = (h = h || {}).autoSize || !1, A = !1 !== h.printHeaders, S = h.css && void 0 !== h.css["font-size"] ? 16 * h.css["font-size"] : h.fontSize || 12, _ = h.margins || Object.assign({
            width: this.getPageWidth()
        }, n), P = "number" == typeof h.padding ? h.padding : 3, k = h.headerBackgroundColor || "#c8c8c8", F = h.headerTextColor || "#000";
        if (a.call(this), this.internal.__cell__.printHeaders = A, this.internal.__cell__.margins = _, this.internal.__cell__.table_font_size = S, this.internal.__cell__.padding = P, this.internal.__cell__.headerBackgroundColor = k, this.internal.__cell__.headerTextColor = F, this.setFontSize(S), null == l) v = m = Object.keys(c[0]), b = m.map(function() {
            return "left";
        });
        else if (Array.isArray(l) && "object" === (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(l[0])) for(m = l.map(function(t) {
            return t.name;
        }), v = l.map(function(t) {
            return t.prompt || t.name || "";
        }), b = l.map(function(t) {
            return t.align || "left";
        }), f = 0; f < l.length; f += 1)w[l[f].name] = .7499990551181103 * l[f].width;
        else Array.isArray(l) && "string" == typeof l[0] && (v = m = l, b = m.map(function() {
            return "left";
        }));
        if (x || Array.isArray(l) && "string" == typeof l[0]) for(f = 0; f < m.length; f += 1){
            for(y[g = m[f]] = c.map(function(t) {
                return t[g];
            }), this.setFont(void 0, "bold"), N.push(this.getTextDimensions(v[f], {
                fontSize: this.internal.__cell__.table_font_size,
                scaleFactor: this.internal.scaleFactor
            }).w), d = y[g], this.setFont(void 0, "normal"), p = 0; p < d.length; p += 1)N.push(this.getTextDimensions(d[p], {
                fontSize: this.internal.__cell__.table_font_size,
                scaleFactor: this.internal.scaleFactor
            }).w);
            w[g] = Math.max.apply(null, N) + P + P, N = [];
        }
        if (A) {
            var I = {};
            for(f = 0; f < m.length; f += 1)I[m[f]] = {}, I[m[f]].text = v[f], I[m[f]].align = b[f];
            var j = u.call(this, I, w);
            L = m.map(function(t) {
                return new o(e, r, w[t], j, I[t].text, void 0, I[t].align);
            }), this.setTableHeaderRow(L), this.printHeaderRow(1, !1);
        }
        var C = l.reduce(function(t, e) {
            return t[e.name] = e.align, t;
        }, {});
        for(f = 0; f < c.length; f += 1){
            "rowStart" in h && h.rowStart instanceof Function && h.rowStart({
                row: f,
                data: c[f]
            }, this);
            var O = u.call(this, c[f], w);
            for(p = 0; p < m.length; p += 1){
                var B = c[f][m[p]];
                "cellStart" in h && h.cellStart instanceof Function && h.cellStart({
                    row: f,
                    col: p,
                    data: B
                }, this), s.call(this, new o(e, r, w[m[p]], O, B, f + 2, C[m[p]]));
            }
        }
        return this.internal.__cell__.table_x = e, this.internal.__cell__.table_y = r, this;
    };
    var u = function(t, e) {
        var n = this.internal.__cell__.padding, r = this.internal.__cell__.table_font_size, i = this.internal.scaleFactor;
        return Object.keys(t).map(function(r) {
            var i = t[r];
            return this.splitTextToSize(i.hasOwnProperty("text") ? i.text : i, e[r] - n - n);
        }, this).map(function(t) {
            return this.getLineHeightFactor() * t.length * r / i + n + n;
        }, this).reduce(function(t, e) {
            return Math.max(t, e);
        }, 0);
    };
    e.setTableHeaderRow = function(t) {
        i.call(this), this.internal.__cell__.tableHeaderRow = t;
    }, e.printHeaderRow = function(t, e) {
        if (i.call(this), !this.internal.__cell__.tableHeaderRow) throw new Error("Property tableHeaderRow does not exist.");
        var n;
        if (r = !0, "function" == typeof this.internal.__cell__.headerFunction) {
            var a = this.internal.__cell__.headerFunction(this, this.internal.__cell__.pages);
            this.internal.__cell__.lastCell = new o(a[0], a[1], a[2], a[3], void 0, -1);
        }
        this.setFont(void 0, "bold");
        for(var u = [], c = 0; c < this.internal.__cell__.tableHeaderRow.length; c += 1){
            n = this.internal.__cell__.tableHeaderRow[c].clone(), e && (n.y = this.internal.__cell__.margins.top || 0, u.push(n)), n.lineNumber = t;
            var l = this.getTextColor();
            this.setTextColor(this.internal.__cell__.headerTextColor), this.setFillColor(this.internal.__cell__.headerBackgroundColor), s.call(this, n), this.setTextColor(l);
        }
        u.length > 0 && this.setTableHeaderRow(u), this.setFont(void 0, "normal"), r = !1;
    };
}($ffaeb8e02004bf5e$export$2e2bcd8739ae039.API);
var $ffaeb8e02004bf5e$var$Pt = {
    italic: [
        "italic",
        "oblique",
        "normal"
    ],
    oblique: [
        "oblique",
        "italic",
        "normal"
    ],
    normal: [
        "normal",
        "oblique",
        "italic"
    ]
}, $ffaeb8e02004bf5e$var$kt = [
    "ultra-condensed",
    "extra-condensed",
    "condensed",
    "semi-condensed",
    "normal",
    "semi-expanded",
    "expanded",
    "extra-expanded",
    "ultra-expanded"
], $ffaeb8e02004bf5e$var$Ft = $ffaeb8e02004bf5e$var$_t($ffaeb8e02004bf5e$var$kt), $ffaeb8e02004bf5e$var$It = [
    100,
    200,
    300,
    400,
    500,
    600,
    700,
    800,
    900
], $ffaeb8e02004bf5e$var$jt = $ffaeb8e02004bf5e$var$_t($ffaeb8e02004bf5e$var$It);
function $ffaeb8e02004bf5e$var$Ct(t) {
    var e = t.family.replace(/"|'/g, "").toLowerCase(), n = function(t) {
        return $ffaeb8e02004bf5e$var$Pt[t = t || "normal"] ? t : "normal";
    }(t.style), r = function(t) {
        return t ? "number" == typeof t ? t >= 100 && t <= 900 && t % 100 == 0 ? t : 400 : /^\d00$/.test(t) ? parseInt(t) : "bold" === t ? 700 : 400 : 400;
    }(t.weight), i = function(t) {
        return "number" == typeof $ffaeb8e02004bf5e$var$Ft[t = t || "normal"] ? t : "normal";
    }(t.stretch);
    return {
        family: e,
        style: n,
        weight: r,
        stretch: i,
        src: t.src || [],
        ref: t.ref || {
            name: e,
            style: [
                i,
                n,
                r
            ].join(" ")
        }
    };
}
function $ffaeb8e02004bf5e$var$Ot(t, e, n, r) {
    var i;
    for(i = n; i >= 0 && i < e.length; i += r)if (t[e[i]]) return t[e[i]];
    for(i = n; i >= 0 && i < e.length; i -= r)if (t[e[i]]) return t[e[i]];
}
var $ffaeb8e02004bf5e$var$Bt = {
    "sans-serif": "helvetica",
    fixed: "courier",
    monospace: "courier",
    terminal: "courier",
    cursive: "times",
    fantasy: "times",
    serif: "times"
}, $ffaeb8e02004bf5e$var$Mt = {
    caption: "times",
    icon: "times",
    menu: "times",
    "message-box": "times",
    "small-caption": "times",
    "status-bar": "times"
};
function $ffaeb8e02004bf5e$var$qt(t) {
    return [
        t.stretch,
        t.style,
        t.weight,
        t.family
    ].join(" ");
}
function $ffaeb8e02004bf5e$var$Et(t) {
    return t.trimLeft();
}
function $ffaeb8e02004bf5e$var$Rt(t, e) {
    for(var n = 0; n < t.length;){
        if (t.charAt(n) === e) return [
            t.substring(0, n),
            t.substring(n + 1)
        ];
        n += 1;
    }
    return null;
}
function $ffaeb8e02004bf5e$var$Dt(t) {
    var e = t.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);
    return null === e ? null : [
        e[0],
        t.substring(e[0].length)
    ];
}
var $ffaeb8e02004bf5e$var$Tt, $ffaeb8e02004bf5e$var$zt, $ffaeb8e02004bf5e$var$Ut, $ffaeb8e02004bf5e$var$Ht, $ffaeb8e02004bf5e$var$Wt, $ffaeb8e02004bf5e$var$Vt, $ffaeb8e02004bf5e$var$Gt, $ffaeb8e02004bf5e$var$Yt, $ffaeb8e02004bf5e$var$Jt = [
    "times"
];
function $ffaeb8e02004bf5e$var$Xt(t, n, r, i, a) {
    var o = 4, s = $ffaeb8e02004bf5e$var$$t;
    switch(a){
        case $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.image_compression.FAST:
            o = 1, s = $ffaeb8e02004bf5e$var$Zt;
            break;
        case $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.image_compression.MEDIUM:
            o = 6, s = $ffaeb8e02004bf5e$var$Qt;
            break;
        case $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.image_compression.SLOW:
            o = 9, s = $ffaeb8e02004bf5e$var$te;
    }
    t = function(t, e, n, r) {
        for(var i, a = t.length / e, o = new Uint8Array(t.length + a), s = [
            $ffaeb8e02004bf5e$var$Kt,
            $ffaeb8e02004bf5e$var$Zt,
            $ffaeb8e02004bf5e$var$$t,
            $ffaeb8e02004bf5e$var$Qt,
            $ffaeb8e02004bf5e$var$te
        ], u = 0; u < a; u += 1){
            var c = u * e, l = t.subarray(c, c + e);
            if (r) o.set(r(l, n, i), c + u);
            else {
                for(var h = s.length, f = [], d = 0; d < h; d += 1)f[d] = s[d](l, n, i);
                var p = $ffaeb8e02004bf5e$var$ne(f.concat());
                o.set(f[p], c + u);
            }
            i = l;
        }
        return o;
    }(t, n, Math.ceil(r * i / 8), s);
    var u = (0, $39aa643a4d3f17c3$export$f87121a6d50aff25)(t, {
        level: o
    });
    return $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.__addimage__.arrayBufferToBinaryString(u);
}
function $ffaeb8e02004bf5e$var$Kt(t) {
    var e = Array.apply([], t);
    return e.unshift(0), e;
}
function $ffaeb8e02004bf5e$var$Zt(t, e) {
    var n = t.length, r = [];
    r[0] = 1;
    for(var i = 0; i < n; i += 1){
        var a = t[i - e] || 0;
        r[i + 1] = t[i] - a + 256 & 255;
    }
    return r;
}
function $ffaeb8e02004bf5e$var$$t(t, e, n) {
    var r = t.length, i = [];
    i[0] = 2;
    for(var a = 0; a < r; a += 1){
        var o = n && n[a] || 0;
        i[a + 1] = t[a] - o + 256 & 255;
    }
    return i;
}
function $ffaeb8e02004bf5e$var$Qt(t, e, n) {
    var r = t.length, i = [];
    i[0] = 3;
    for(var a = 0; a < r; a += 1){
        var o = t[a - e] || 0, s = n && n[a] || 0;
        i[a + 1] = t[a] + 256 - (o + s >>> 1) & 255;
    }
    return i;
}
function $ffaeb8e02004bf5e$var$te(t, e, n) {
    var r = t.length, i = [];
    i[0] = 4;
    for(var a = 0; a < r; a += 1){
        var o = $ffaeb8e02004bf5e$var$ee(t[a - e] || 0, n && n[a] || 0, n && n[a - e] || 0);
        i[a + 1] = t[a] - o + 256 & 255;
    }
    return i;
}
function $ffaeb8e02004bf5e$var$ee(t, e, n) {
    if (t === e && e === n) return t;
    var r = Math.abs(e - n), i = Math.abs(t - n), a = Math.abs(t + e - n - n);
    return r <= i && r <= a ? t : i <= a ? e : n;
}
function $ffaeb8e02004bf5e$var$ne(t) {
    var e = t.map(function(t) {
        return t.reduce(function(t, e) {
            return t + Math.abs(e);
        }, 0);
    });
    return e.indexOf(Math.min.apply(null, e));
}
function $ffaeb8e02004bf5e$var$re(t, e, n) {
    var r = e * n, i = Math.floor(r / 8), a = 16 - (r - 8 * i + n), o = (1 << n) - 1;
    return $ffaeb8e02004bf5e$var$ae(t, i) >> a & o;
}
function $ffaeb8e02004bf5e$var$ie(t, e, n, r) {
    var i = n * r, a = Math.floor(i / 8), o = 16 - (i - 8 * a + r), s = (1 << r) - 1, u = (e & s) << o;
    !function(t, e, n) {
        if (e + 1 < t.byteLength) t.setUint16(e, n, !1);
        else {
            var r = n >> 8 & 255;
            t.setUint8(e, r);
        }
    }(t, a, $ffaeb8e02004bf5e$var$ae(t, a) & ~(s << o) & 65535 | u);
}
function $ffaeb8e02004bf5e$var$ae(t, e) {
    return e + 1 < t.byteLength ? t.getUint16(e, !1) : t.getUint8(e) << 8;
}
function $ffaeb8e02004bf5e$var$oe(t) {
    var e = 0;
    if (71 !== t[e++] || 73 !== t[e++] || 70 !== t[e++] || 56 !== t[e++] || 56 != (t[e++] + 1 & 253) || 97 !== t[e++]) throw new Error("Invalid GIF 87a/89a header.");
    var n = t[e++] | t[e++] << 8, r = t[e++] | t[e++] << 8, i = t[e++], a = i >> 7, o = 1 << 1 + (7 & i);
    t[e++], t[e++];
    var s = null, u = null;
    a && (s = e, u = o, e += 3 * o);
    var c = !0, l = [], h = 0, f = null, d = 0, p = null;
    for(this.width = n, this.height = r; c && e < t.length;)switch(t[e++]){
        case 33:
            switch(t[e++]){
                case 255:
                    if (11 !== t[e] || 78 == t[e + 1] && 69 == t[e + 2] && 84 == t[e + 3] && 83 == t[e + 4] && 67 == t[e + 5] && 65 == t[e + 6] && 80 == t[e + 7] && 69 == t[e + 8] && 50 == t[e + 9] && 46 == t[e + 10] && 48 == t[e + 11] && 3 == t[e + 12] && 1 == t[e + 13] && 0 == t[e + 16]) e += 14, p = t[e++] | t[e++] << 8, e++;
                    else for(e += 12;;){
                        if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                        if (0 === P) break;
                        e += P;
                    }
                    break;
                case 249:
                    if (4 !== t[e++] || 0 !== t[e + 4]) throw new Error("Invalid graphics extension block.");
                    var g = t[e++];
                    h = t[e++] | t[e++] << 8, f = t[e++], 1 & g || (f = null), d = g >> 2 & 7, e++;
                    break;
                case 254:
                    for(;;){
                        if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                        if (0 === P) break;
                        e += P;
                    }
                    break;
                default:
                    throw new Error("Unknown graphic control label: 0x" + t[e - 1].toString(16));
            }
            break;
        case 44:
            var m = t[e++] | t[e++] << 8, v = t[e++] | t[e++] << 8, b = t[e++] | t[e++] << 8, y = t[e++] | t[e++] << 8, w = t[e++], N = w >> 6 & 1, L = 1 << 1 + (7 & w), x = s, A = u, S = !1;
            w >> 7 && (S = !0, x = e, A = L, e += 3 * L);
            var _ = e;
            for(e++;;){
                var P;
                if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                if (0 === P) break;
                e += P;
            }
            l.push({
                x: m,
                y: v,
                width: b,
                height: y,
                has_local_palette: S,
                palette_offset: x,
                palette_size: A,
                data_offset: _,
                data_length: e - _,
                transparent_index: f,
                interlaced: !!N,
                delay: h,
                disposal: d
            });
            break;
        case 59:
            c = !1;
            break;
        default:
            throw new Error("Unknown gif block: 0x" + t[e - 1].toString(16));
    }
    this.numFrames = function() {
        return l.length;
    }, this.loopCount = function() {
        return p;
    }, this.frameInfo = function(t) {
        if (t < 0 || t >= l.length) throw new Error("Frame index out of range.");
        return l[t];
    }, this.decodeAndBlitFrameBGRA = function(e, r) {
        var i = this.frameInfo(e), a = i.width * i.height, o = new Uint8Array(a);
        $ffaeb8e02004bf5e$var$se(t, i.data_offset, o, a);
        var s = i.palette_offset, u = i.transparent_index;
        null === u && (u = 256);
        var c = i.width, l = n - c, h = c, f = 4 * (i.y * n + i.x), d = 4 * ((i.y + i.height) * n + i.x), p = f, g = 4 * l;
        !0 === i.interlaced && (g += 4 * n * 7);
        for(var m = 8, v = 0, b = o.length; v < b; ++v){
            var y = o[v];
            if (0 === h && (h = c, (p += g) >= d && (g = 4 * l + 4 * n * (m - 1), p = f + (c + l) * (m << 1), m >>= 1)), y === u) p += 4;
            else {
                var w = t[s + 3 * y], N = t[s + 3 * y + 1], L = t[s + 3 * y + 2];
                r[p++] = L, r[p++] = N, r[p++] = w, r[p++] = 255;
            }
            --h;
        }
    }, this.decodeAndBlitFrameRGBA = function(e, r) {
        var i = this.frameInfo(e), a = i.width * i.height, o = new Uint8Array(a);
        $ffaeb8e02004bf5e$var$se(t, i.data_offset, o, a);
        var s = i.palette_offset, u = i.transparent_index;
        null === u && (u = 256);
        var c = i.width, l = n - c, h = c, f = 4 * (i.y * n + i.x), d = 4 * ((i.y + i.height) * n + i.x), p = f, g = 4 * l;
        !0 === i.interlaced && (g += 4 * n * 7);
        for(var m = 8, v = 0, b = o.length; v < b; ++v){
            var y = o[v];
            if (0 === h && (h = c, (p += g) >= d && (g = 4 * l + 4 * n * (m - 1), p = f + (c + l) * (m << 1), m >>= 1)), y === u) p += 4;
            else {
                var w = t[s + 3 * y], N = t[s + 3 * y + 1], L = t[s + 3 * y + 2];
                r[p++] = w, r[p++] = N, r[p++] = L, r[p++] = 255;
            }
            --h;
        }
    };
}
function $ffaeb8e02004bf5e$var$se(t, e, n, r) {
    for(var i = t[e++], a = 1 << i, s = a + 1, u = s + 1, c = i + 1, l = (1 << c) - 1, h = 0, f = 0, d = 0, p = t[e++], g = new Int32Array(4096), m = null;;){
        for(; h < 16 && 0 !== p;)f |= t[e++] << h, h += 8, 1 === p ? p = t[e++] : --p;
        if (h < c) break;
        var v = f & l;
        if (f >>= c, h -= c, v !== a) {
            if (v === s) break;
            for(var b = v < u ? v : m, y = 0, w = b; w > a;)w = g[w] >> 8, ++y;
            var N = w;
            if (d + y + (b !== v ? 1 : 0) > r) return void $ffaeb8e02004bf5e$var$o.log("Warning, gif stream longer than expected.");
            n[d++] = N;
            var L = d += y;
            for(b !== v && (n[d++] = N), w = b; y--;)w = g[w], n[--L] = 255 & w, w >>= 8;
            null !== m && u < 4096 && (g[u++] = m << 8 | N, u >= l + 1 && c < 12 && (++c, l = l << 1 | 1)), m = v;
        } else u = s + 1, l = (1 << (c = i + 1)) - 1, m = null;
    }
    return d !== r && $ffaeb8e02004bf5e$var$o.log("Warning, gif stream shorter than expected."), n;
}
/**
 * @license
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ function $ffaeb8e02004bf5e$var$ue(t) {
    var e, n, r, i, a, o = Math.floor, s = new Array(64), u = new Array(64), c = new Array(64), l = new Array(64), h = new Array(65535), f = new Array(65535), d = new Array(64), p = new Array(64), g = [], m = 0, v = 7, b = new Array(64), y = new Array(64), w = new Array(64), N = new Array(256), L = new Array(2048), x = [
        0,
        1,
        5,
        6,
        14,
        15,
        27,
        28,
        2,
        4,
        7,
        13,
        16,
        26,
        29,
        42,
        3,
        8,
        12,
        17,
        25,
        30,
        41,
        43,
        9,
        11,
        18,
        24,
        31,
        40,
        44,
        53,
        10,
        19,
        23,
        32,
        39,
        45,
        52,
        54,
        20,
        22,
        33,
        38,
        46,
        51,
        55,
        60,
        21,
        34,
        37,
        47,
        50,
        56,
        59,
        61,
        35,
        36,
        48,
        49,
        57,
        58,
        62,
        63
    ], A = [
        0,
        0,
        1,
        5,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ], S = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ], _ = [
        0,
        0,
        2,
        1,
        3,
        3,
        2,
        4,
        3,
        5,
        5,
        4,
        4,
        0,
        0,
        1,
        125
    ], P = [
        1,
        2,
        3,
        0,
        4,
        17,
        5,
        18,
        33,
        49,
        65,
        6,
        19,
        81,
        97,
        7,
        34,
        113,
        20,
        50,
        129,
        145,
        161,
        8,
        35,
        66,
        177,
        193,
        21,
        82,
        209,
        240,
        36,
        51,
        98,
        114,
        130,
        9,
        10,
        22,
        23,
        24,
        25,
        26,
        37,
        38,
        39,
        40,
        41,
        42,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        225,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        241,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250
    ], k = [
        0,
        0,
        3,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0
    ], F = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ], I = [
        0,
        0,
        2,
        1,
        2,
        4,
        4,
        3,
        4,
        7,
        5,
        4,
        4,
        0,
        1,
        2,
        119
    ], j = [
        0,
        1,
        2,
        3,
        17,
        4,
        5,
        33,
        49,
        6,
        18,
        65,
        81,
        7,
        97,
        113,
        19,
        34,
        50,
        129,
        8,
        20,
        66,
        145,
        161,
        177,
        193,
        9,
        35,
        51,
        82,
        240,
        21,
        98,
        114,
        209,
        10,
        22,
        36,
        52,
        225,
        37,
        241,
        23,
        24,
        25,
        26,
        38,
        39,
        40,
        41,
        42,
        53,
        54,
        55,
        56,
        57,
        58,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250
    ];
    function C(t, e) {
        for(var n = 0, r = 0, i = new Array, a = 1; a <= 16; a++){
            for(var o = 1; o <= t[a]; o++)i[e[r]] = [], i[e[r]][0] = n, i[e[r]][1] = a, r++, n++;
            n *= 2;
        }
        return i;
    }
    function O(t) {
        for(var e = t[0], n = t[1] - 1; n >= 0;)e & 1 << n && (m |= 1 << v), n--, --v < 0 && (255 == m ? (B(255), B(0)) : B(m), v = 7, m = 0);
    }
    function B(t) {
        g.push(t);
    }
    function M(t) {
        B(t >> 8 & 255), B(255 & t);
    }
    function q(t, e, n, r, i) {
        for(var a, o = i[0], s = i[240], u = function(t, e) {
            var n, r, i, a, o, s, u, c, l, h, f = 0;
            for(l = 0; l < 8; ++l){
                n = t[f], r = t[f + 1], i = t[f + 2], a = t[f + 3], o = t[f + 4], s = t[f + 5], u = t[f + 6];
                var p = n + (c = t[f + 7]), g = n - c, m = r + u, v = r - u, b = i + s, y = i - s, w = a + o, N = a - o, L = p + w, x = p - w, A = m + b, S = m - b;
                t[f] = L + A, t[f + 4] = L - A;
                var _ = .707106781 * (S + x);
                t[f + 2] = x + _, t[f + 6] = x - _;
                var P = .382683433 * ((L = N + y) - (S = v + g)), k = .5411961 * L + P, F = 1.306562965 * S + P, I = .707106781 * (A = y + v), j = g + I, C = g - I;
                t[f + 5] = C + k, t[f + 3] = C - k, t[f + 1] = j + F, t[f + 7] = j - F, f += 8;
            }
            for(f = 0, l = 0; l < 8; ++l){
                n = t[f], r = t[f + 8], i = t[f + 16], a = t[f + 24], o = t[f + 32], s = t[f + 40], u = t[f + 48];
                var O = n + (c = t[f + 56]), B = n - c, M = r + u, q = r - u, E = i + s, R = i - s, D = a + o, T = a - o, z = O + D, U = O - D, H = M + E, W = M - E;
                t[f] = z + H, t[f + 32] = z - H;
                var V = .707106781 * (W + U);
                t[f + 16] = U + V, t[f + 48] = U - V;
                var G = .382683433 * ((z = T + R) - (W = q + B)), Y = .5411961 * z + G, J = 1.306562965 * W + G, X = .707106781 * (H = R + q), K = B + X, Z = B - X;
                t[f + 40] = Z + Y, t[f + 24] = Z - Y, t[f + 8] = K + J, t[f + 56] = K - J, f++;
            }
            for(l = 0; l < 64; ++l)h = t[l] * e[l], d[l] = h > 0 ? h + .5 | 0 : h - .5 | 0;
            return d;
        }(t, e), c = 0; c < 64; ++c)p[x[c]] = u[c];
        var l = p[0] - n;
        n = p[0], 0 == l ? O(r[0]) : (O(r[f[a = 32767 + l]]), O(h[a]));
        for(var g = 63; g > 0 && 0 == p[g];)g--;
        if (0 == g) return O(o), n;
        for(var m, v = 1; v <= g;){
            for(var b = v; 0 == p[v] && v <= g;)++v;
            var y = v - b;
            if (y >= 16) {
                m = y >> 4;
                for(var w = 1; w <= m; ++w)O(s);
                y &= 15;
            }
            a = 32767 + p[v], O(i[(y << 4) + f[a]]), O(h[a]), v++;
        }
        return 63 != g && O(o), n;
    }
    function E(t) {
        t = Math.min(Math.max(t, 1), 100), a != t && (function(t) {
            for(var e = [
                16,
                11,
                10,
                16,
                24,
                40,
                51,
                61,
                12,
                12,
                14,
                19,
                26,
                58,
                60,
                55,
                14,
                13,
                16,
                24,
                40,
                57,
                69,
                56,
                14,
                17,
                22,
                29,
                51,
                87,
                80,
                62,
                18,
                22,
                37,
                56,
                68,
                109,
                103,
                77,
                24,
                35,
                55,
                64,
                81,
                104,
                113,
                92,
                49,
                64,
                78,
                87,
                103,
                121,
                120,
                101,
                72,
                92,
                95,
                98,
                112,
                100,
                103,
                99
            ], n = 0; n < 64; n++){
                var r = o((e[n] * t + 50) / 100);
                r = Math.min(Math.max(r, 1), 255), s[x[n]] = r;
            }
            for(var i = [
                17,
                18,
                24,
                47,
                99,
                99,
                99,
                99,
                18,
                21,
                26,
                66,
                99,
                99,
                99,
                99,
                24,
                26,
                56,
                99,
                99,
                99,
                99,
                99,
                47,
                66,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99
            ], a = 0; a < 64; a++){
                var h = o((i[a] * t + 50) / 100);
                h = Math.min(Math.max(h, 1), 255), u[x[a]] = h;
            }
            for(var f = [
                1,
                1.387039845,
                1.306562965,
                1.175875602,
                1,
                .785694958,
                .5411961,
                .275899379
            ], d = 0, p = 0; p < 8; p++)for(var g = 0; g < 8; g++)c[d] = 1 / (s[x[d]] * f[p] * f[g] * 8), l[d] = 1 / (u[x[d]] * f[p] * f[g] * 8), d++;
        }(t < 50 ? Math.floor(5e3 / t) : Math.floor(200 - 2 * t)), a = t);
    }
    this.encode = function(t, a) {
        a && E(a), g = new Array, m = 0, v = 7, M(65496), M(65504), M(16), B(74), B(70), B(73), B(70), B(0), B(1), B(1), B(0), M(1), M(1), B(0), B(0), function() {
            M(65499), M(132), B(0);
            for(var t = 0; t < 64; t++)B(s[t]);
            B(1);
            for(var e = 0; e < 64; e++)B(u[e]);
        }(), function(t, e) {
            M(65472), M(17), B(8), M(e), M(t), B(3), B(1), B(17), B(0), B(2), B(17), B(1), B(3), B(17), B(1);
        }(t.width, t.height), function() {
            M(65476), M(418), B(0);
            for(var t = 0; t < 16; t++)B(A[t + 1]);
            for(var e = 0; e <= 11; e++)B(S[e]);
            B(16);
            for(var n = 0; n < 16; n++)B(_[n + 1]);
            for(var r = 0; r <= 161; r++)B(P[r]);
            B(1);
            for(var i = 0; i < 16; i++)B(k[i + 1]);
            for(var a = 0; a <= 11; a++)B(F[a]);
            B(17);
            for(var o = 0; o < 16; o++)B(I[o + 1]);
            for(var s = 0; s <= 161; s++)B(j[s]);
        }(), M(65498), M(12), B(3), B(1), B(0), B(2), B(17), B(3), B(17), B(0), B(63), B(0);
        var o = 0, h = 0, f = 0;
        m = 0, v = 7, this.encode.displayName = "_encode_";
        for(var d, p, N, x, C, R, D, T, z, U = t.data, H = t.width, W = t.height, V = 4 * H, G = 0; G < W;){
            for(d = 0; d < V;){
                for(C = V * G + d, D = -1, T = 0, z = 0; z < 64; z++)R = C + (T = z >> 3) * V + (D = 4 * (7 & z)), G + T >= W && (R -= V * (G + 1 + T - W)), d + D >= V && (R -= d + D - V + 4), p = U[R++], N = U[R++], x = U[R++], b[z] = (L[p] + L[N + 256 | 0] + L[x + 512 | 0] >> 16) - 128, y[z] = (L[p + 768 | 0] + L[N + 1024 | 0] + L[x + 1280 | 0] >> 16) - 128, w[z] = (L[p + 1280 | 0] + L[N + 1536 | 0] + L[x + 1792 | 0] >> 16) - 128;
                o = q(b, c, o, e, r), h = q(y, l, h, n, i), f = q(w, l, f, n, i), d += 32;
            }
            G += 8;
        }
        if (v >= 0) {
            var Y = [];
            Y[1] = v + 1, Y[0] = (1 << v + 1) - 1, O(Y);
        }
        return M(65497), new Uint8Array(g);
    }, t = t || 50, function() {
        for(var t = String.fromCharCode, e = 0; e < 256; e++)N[e] = t(e);
    }(), e = C(A, S), n = C(k, F), r = C(_, P), i = C(I, j), function() {
        for(var t = 1, e = 2, n = 1; n <= 15; n++){
            for(var r = t; r < e; r++)f[32767 + r] = n, h[32767 + r] = [], h[32767 + r][1] = n, h[32767 + r][0] = r;
            for(var i = -(e - 1); i <= -t; i++)f[32767 + i] = n, h[32767 + i] = [], h[32767 + i][1] = n, h[32767 + i][0] = e - 1 + i;
            t <<= 1, e <<= 1;
        }
    }(), function() {
        for(var t = 0; t < 256; t++)L[t] = 19595 * t, L[t + 256 | 0] = 38470 * t, L[t + 512 | 0] = 7471 * t + 32768, L[t + 768 | 0] = -11059 * t, L[t + 1024 | 0] = -21709 * t, L[t + 1280 | 0] = 32768 * t + 8421375, L[t + 1536 | 0] = -27439 * t, L[t + 1792 | 0] = -5329 * t;
    }(), E(t);
}
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function $ffaeb8e02004bf5e$var$ce(t, e) {
    if (this.pos = 0, this.buffer = t, this.datav = new DataView(t.buffer), this.is_with_alpha = !!e, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, -1 === [
        "BM",
        "BA",
        "CI",
        "CP",
        "IC",
        "PT"
    ].indexOf(this.flag)) throw new Error("Invalid BMP File");
    this.parseHeader(), this.parseBGR();
}
function $ffaeb8e02004bf5e$var$le(t) {
    function e(t) {
        if (!t) throw Error("assert :P");
    }
    function n(t, e, n) {
        for(var r = 0; 4 > r; r++)if (t[e + r] != n.charCodeAt(r)) return !0;
        return !1;
    }
    function r(t, e, n, r, i) {
        for(var a = 0; a < i; a++)t[e + a] = n[r + a];
    }
    function i(t, e, n, r) {
        for(var i = 0; i < r; i++)t[e + i] = n;
    }
    function a(t) {
        return new Int32Array(t);
    }
    function o(t, e) {
        for(var n = [], r = 0; r < t; r++)n.push(new e);
        return n;
    }
    function s(t, e) {
        var n = [];
        return function t(n, r, i) {
            for(var a = i[r], o = 0; o < a && (n.push(i.length > r + 1 ? [] : new e), !(i.length < r + 1)); o++)t(n[o], r + 1, i);
        }(n, 0, t), n;
    }
    var u = function() {
        var t = this;
        function u(t, e) {
            for(var n = 1 << e - 1 >>> 0; t & n;)n >>>= 1;
            return n ? (t & n - 1) + n : t;
        }
        function c(t, n, r, i, a) {
            e(!(i % r));
            do t[n + (i -= r)] = a;
            while (0 < i);
        }
        function l(t, n, r, i, o) {
            if (e(2328 >= o), 512 >= o) var s = a(512);
            else if (null == (s = a(o))) return 0;
            return function(t, n, r, i, o, s) {
                var l, f, d = n, p = 1 << r, g = a(16), m = a(16);
                for(e(0 != o), e(null != i), e(null != t), e(0 < r), f = 0; f < o; ++f){
                    if (15 < i[f]) return 0;
                    ++g[i[f]];
                }
                if (g[0] == o) return 0;
                for(m[1] = 0, l = 1; 15 > l; ++l){
                    if (g[l] > 1 << l) return 0;
                    m[l + 1] = m[l] + g[l];
                }
                for(f = 0; f < o; ++f)l = i[f], 0 < i[f] && (s[m[l]++] = f);
                if (1 == m[15]) return (i = new h).g = 0, i.value = s[0], c(t, d, 1, p, i), p;
                var v, b = -1, y = p - 1, w = 0, N = 1, L = 1, x = 1 << r;
                for(f = 0, l = 1, o = 2; l <= r; ++l, o <<= 1){
                    if (N += L <<= 1, 0 > (L -= g[l])) return 0;
                    for(; 0 < g[l]; --g[l])(i = new h).g = l, i.value = s[f++], c(t, d + w, o, x, i), w = u(w, l);
                }
                for(l = r + 1, o = 2; 15 >= l; ++l, o <<= 1){
                    if (N += L <<= 1, 0 > (L -= g[l])) return 0;
                    for(; 0 < g[l]; --g[l]){
                        if (i = new h, (w & y) != b) {
                            for(d += x, v = 1 << (b = l) - r; 15 > b && !(0 >= (v -= g[b]));)++b, v <<= 1;
                            p += x = 1 << (v = b - r), t[n + (b = w & y)].g = v + r, t[n + b].value = d - n - b;
                        }
                        i.g = l - r, i.value = s[f++], c(t, d + (w >> r), o, x, i), w = u(w, l);
                    }
                }
                return N != 2 * m[15] - 1 ? 0 : p;
            }(t, n, r, i, o, s);
        }
        function h() {
            this.value = this.g = 0;
        }
        function f() {
            this.value = this.g = 0;
        }
        function d() {
            this.G = o(5, h), this.H = a(5), this.jc = this.Qb = this.qb = this.nd = 0, this.pd = o(Rn, f);
        }
        function p(t, n, r, i) {
            e(null != t), e(null != n), e(2147483648 > i), t.Ca = 254, t.I = 0, t.b = -8, t.Ka = 0, t.oa = n, t.pa = r, t.Jd = n, t.Yc = r + i, t.Zc = 4 <= i ? r + i - 4 + 1 : r, _(t);
        }
        function g(t, e) {
            for(var n = 0; 0 < e--;)n |= k(t, 128) << e;
            return n;
        }
        function m(t, e) {
            var n = g(t, e);
            return P(t) ? -n : n;
        }
        function v(t, n, r, i) {
            var a, o = 0;
            for(e(null != t), e(null != n), e(4294967288 > i), t.Sb = i, t.Ra = 0, t.u = 0, t.h = 0, 4 < i && (i = 4), a = 0; a < i; ++a)o += n[r + a] << 8 * a;
            t.Ra = o, t.bb = i, t.oa = n, t.pa = r;
        }
        function b(t) {
            for(; 8 <= t.u && t.bb < t.Sb;)t.Ra >>>= 8, t.Ra += t.oa[t.pa + t.bb] << zn - 8 >>> 0, ++t.bb, t.u -= 8;
            x(t) && (t.h = 1, t.u = 0);
        }
        function y(t, n) {
            if (e(0 <= n), !t.h && n <= Tn) {
                var r = L(t) & Dn[n];
                return t.u += n, b(t), r;
            }
            return t.h = 1, t.u = 0;
        }
        function w() {
            this.b = this.Ca = this.I = 0, this.oa = [], this.pa = 0, this.Jd = [], this.Yc = 0, this.Zc = [], this.Ka = 0;
        }
        function N() {
            this.Ra = 0, this.oa = [], this.h = this.u = this.bb = this.Sb = this.pa = 0;
        }
        function L(t) {
            return t.Ra >>> (t.u & zn - 1) >>> 0;
        }
        function x(t) {
            return e(t.bb <= t.Sb), t.h || t.bb == t.Sb && t.u > zn;
        }
        function A(t, e) {
            t.u = e, t.h = x(t);
        }
        function S(t) {
            t.u >= Un && (e(t.u >= Un), b(t));
        }
        function _(t) {
            e(null != t && null != t.oa), t.pa < t.Zc ? (t.I = (t.oa[t.pa++] | t.I << 8) >>> 0, t.b += 8) : (e(null != t && null != t.oa), t.pa < t.Yc ? (t.b += 8, t.I = t.oa[t.pa++] | t.I << 8) : t.Ka ? t.b = 0 : (t.I <<= 8, t.b += 8, t.Ka = 1));
        }
        function P(t) {
            return g(t, 1);
        }
        function k(t, e) {
            var n = t.Ca;
            0 > t.b && _(t);
            var r = t.b, i = n * e >>> 8, a = (t.I >>> r > i) + 0;
            for(a ? (n -= i, t.I -= i + 1 << r >>> 0) : n = i + 1, r = n, i = 0; 256 <= r;)i += 8, r >>= 8;
            return r = 7 ^ i + Hn[r], t.b -= r, t.Ca = (n << r) - 1, a;
        }
        function F(t, e, n) {
            t[e + 0] = n >> 24 & 255, t[e + 1] = n >> 16 & 255, t[e + 2] = n >> 8 & 255, t[e + 3] = 255 & n;
        }
        function I(t, e) {
            return t[e + 0] | t[e + 1] << 8;
        }
        function j(t, e) {
            return I(t, e) | t[e + 2] << 16;
        }
        function C(t, e) {
            return I(t, e) | I(t, e + 2) << 16;
        }
        function O(t, n) {
            var r = 1 << n;
            return e(null != t), e(0 < n), t.X = a(r), null == t.X ? 0 : (t.Mb = 32 - n, t.Xa = n, 1);
        }
        function B(t, n) {
            e(null != t), e(null != n), e(t.Xa == n.Xa), r(n.X, 0, t.X, 0, 1 << n.Xa);
        }
        function M() {
            this.X = [], this.Xa = this.Mb = 0;
        }
        function q(t, n, r, i) {
            e(null != r), e(null != i);
            var a = r[0], o = i[0];
            return 0 == a && (a = (t * o + n / 2) / n), 0 == o && (o = (n * a + t / 2) / t), 0 >= a || 0 >= o ? 0 : (r[0] = a, i[0] = o, 1);
        }
        function E(t, e) {
            return t + (1 << e) - 1 >>> e;
        }
        function R(t, e) {
            return ((4278255360 & t) + (4278255360 & e) >>> 0 & 4278255360) + ((16711935 & t) + (16711935 & e) >>> 0 & 16711935) >>> 0;
        }
        function D(e, n) {
            t[n] = function(n, r, i, a, o, s, u) {
                var c;
                for(c = 0; c < o; ++c){
                    var l = t[e](s[u + c - 1], i, a + c);
                    s[u + c] = R(n[r + c], l);
                }
            };
        }
        function T() {
            this.ud = this.hd = this.jd = 0;
        }
        function z(t, e) {
            return ((4278124286 & (t ^ e)) >>> 1) + (t & e) >>> 0;
        }
        function U(t) {
            return 0 <= t && 256 > t ? t : 0 > t ? 0 : 255 < t ? 255 : void 0;
        }
        function H(t, e) {
            return U(t + (t - e + .5 >> 1));
        }
        function W(t, e, n) {
            return Math.abs(e - n) - Math.abs(t - n);
        }
        function V(t, e, n, r, i, a, o) {
            for(r = a[o - 1], n = 0; n < i; ++n)a[o + n] = r = R(t[e + n], r);
        }
        function G(t, e, n, r, i) {
            var a;
            for(a = 0; a < n; ++a){
                var o = t[e + a], s = o >> 8 & 255, u = 16711935 & (u = (u = 16711935 & o) + ((s << 16) + s));
                r[i + a] = (4278255360 & o) + u >>> 0;
            }
        }
        function Y(t, e) {
            e.jd = 255 & t, e.hd = t >> 8 & 255, e.ud = t >> 16 & 255;
        }
        function J(t, e, n, r, i, a) {
            var o;
            for(o = 0; o < r; ++o){
                var s = e[n + o], u = s >>> 8, c = s, l = 255 & (l = (l = s >>> 16) + ((t.jd << 24 >> 24) * (u << 24 >> 24) >>> 5));
                c = 255 & (c = (c += (t.hd << 24 >> 24) * (u << 24 >> 24) >>> 5) + ((t.ud << 24 >> 24) * (l << 24 >> 24) >>> 5)), i[a + o] = (4278255360 & s) + (l << 16) + c;
            }
        }
        function X(e, n, r, i, a) {
            t[n] = function(t, e, n, r, o, s, u, c, l) {
                for(r = u; r < c; ++r)for(u = 0; u < l; ++u)o[s++] = a(n[i(t[e++])]);
            }, t[e] = function(e, n, o, s, u, c, l) {
                var h = 8 >> e.b, f = e.Ea, d = e.K[0], p = e.w;
                if (8 > h) for(e = (1 << e.b) - 1, p = (1 << h) - 1; n < o; ++n){
                    var g, m = 0;
                    for(g = 0; g < f; ++g)g & e || (m = i(s[u++])), c[l++] = a(d[m & p]), m >>= h;
                }
                else t["VP8LMapColor" + r](s, u, d, p, c, l, n, o, f);
            };
        }
        function K(t, e, n, r, i) {
            for(n = e + n; e < n;){
                var a = t[e++];
                r[i++] = a >> 16 & 255, r[i++] = a >> 8 & 255, r[i++] = 255 & a;
            }
        }
        function Z(t, e, n, r, i) {
            for(n = e + n; e < n;){
                var a = t[e++];
                r[i++] = a >> 16 & 255, r[i++] = a >> 8 & 255, r[i++] = 255 & a, r[i++] = a >> 24 & 255;
            }
        }
        function $(t, e, n, r, i) {
            for(n = e + n; e < n;){
                var a = (o = t[e++]) >> 16 & 240 | o >> 12 & 15, o = 240 & o | o >> 28 & 15;
                r[i++] = a, r[i++] = o;
            }
        }
        function Q(t, e, n, r, i) {
            for(n = e + n; e < n;){
                var a = (o = t[e++]) >> 16 & 248 | o >> 13 & 7, o = o >> 5 & 224 | o >> 3 & 31;
                r[i++] = a, r[i++] = o;
            }
        }
        function tt(t, e, n, r, i) {
            for(n = e + n; e < n;){
                var a = t[e++];
                r[i++] = 255 & a, r[i++] = a >> 8 & 255, r[i++] = a >> 16 & 255;
            }
        }
        function et(t, e, n, i, a, o) {
            if (0 == o) for(n = e + n; e < n;)F(i, ((o = t[e++])[0] >> 24 | o[1] >> 8 & 65280 | o[2] << 8 & 16711680 | o[3] << 24) >>> 0), a += 32;
            else r(i, a, t, e, n);
        }
        function nt(e, n) {
            t[n][0] = t[e + "0"], t[n][1] = t[e + "1"], t[n][2] = t[e + "2"], t[n][3] = t[e + "3"], t[n][4] = t[e + "4"], t[n][5] = t[e + "5"], t[n][6] = t[e + "6"], t[n][7] = t[e + "7"], t[n][8] = t[e + "8"], t[n][9] = t[e + "9"], t[n][10] = t[e + "10"], t[n][11] = t[e + "11"], t[n][12] = t[e + "12"], t[n][13] = t[e + "13"], t[n][14] = t[e + "0"], t[n][15] = t[e + "0"];
        }
        function rt(t) {
            return t == Ur || t == Hr || t == Wr || t == Vr;
        }
        function it() {
            this.eb = [], this.size = this.A = this.fb = 0;
        }
        function at() {
            this.y = [], this.f = [], this.ea = [], this.F = [], this.Tc = this.Ed = this.Cd = this.Fd = this.lb = this.Db = this.Ab = this.fa = this.J = this.W = this.N = this.O = 0;
        }
        function ot() {
            this.Rd = this.height = this.width = this.S = 0, this.f = {}, this.f.RGBA = new it, this.f.kb = new at, this.sd = null;
        }
        function st() {
            this.width = [
                0
            ], this.height = [
                0
            ], this.Pd = [
                0
            ], this.Qd = [
                0
            ], this.format = [
                0
            ];
        }
        function ut() {
            this.Id = this.fd = this.Md = this.hb = this.ib = this.da = this.bd = this.cd = this.j = this.v = this.Da = this.Sd = this.ob = 0;
        }
        function ct(t) {
            return alert("todo:WebPSamplerProcessPlane"), t.T;
        }
        function lt(t, e) {
            var n = t.T, i = e.ba.f.RGBA, a = i.eb, o = i.fb + t.ka * i.A, s = mi[e.ba.S], u = t.y, c = t.O, l = t.f, h = t.N, f = t.ea, d = t.W, p = e.cc, g = e.dc, m = e.Mc, v = e.Nc, b = t.ka, y = t.ka + t.T, w = t.U, N = w + 1 >> 1;
            for(0 == b ? s(u, c, null, null, l, h, f, d, l, h, f, d, a, o, null, null, w) : (s(e.ec, e.fc, u, c, p, g, m, v, l, h, f, d, a, o - i.A, a, o, w), ++n); b + 2 < y; b += 2)p = l, g = h, m = f, v = d, h += t.Rc, d += t.Rc, o += 2 * i.A, s(u, (c += 2 * t.fa) - t.fa, u, c, p, g, m, v, l, h, f, d, a, o - i.A, a, o, w);
            return c += t.fa, t.j + y < t.o ? (r(e.ec, e.fc, u, c, w), r(e.cc, e.dc, l, h, N), r(e.Mc, e.Nc, f, d, N), n--) : 1 & y || s(u, c, null, null, l, h, f, d, l, h, f, d, a, o + i.A, null, null, w), n;
        }
        function ht(t, n, r) {
            var i = t.F, a = [
                t.J
            ];
            if (null != i) {
                var o = t.U, s = n.ba.S, u = s == Dr || s == Wr;
                n = n.ba.f.RGBA;
                var c = [
                    0
                ], l = t.ka;
                c[0] = t.T, t.Kb && (0 == l ? --c[0] : (--l, a[0] -= t.width), t.j + t.ka + t.T == t.o && (c[0] = t.o - t.j - l));
                var h = n.eb;
                l = n.fb + l * n.A, t = Ar(i, a[0], t.width, o, c, h, l + (u ? 0 : 3), n.A), e(r == c), t && rt(s) && Lr(h, l, u, o, c, n.A);
            }
            return 0;
        }
        function ft(t) {
            var e = t.ma, n = e.ba.S, r = 11 > n, i = n == qr || n == Rr || n == Dr || n == Tr || 12 == n || rt(n);
            if (e.memory = null, e.Ib = null, e.Jb = null, e.Nd = null, !Mn(e.Oa, t, i ? 11 : 12)) return 0;
            if (i && rt(n) && bn(), t.da) alert("todo:use_scaling");
            else {
                if (r) {
                    if (e.Ib = ct, t.Kb) {
                        if (n = t.U + 1 >> 1, e.memory = a(t.U + 2 * n), null == e.memory) return 0;
                        e.ec = e.memory, e.fc = 0, e.cc = e.ec, e.dc = e.fc + t.U, e.Mc = e.cc, e.Nc = e.dc + n, e.Ib = lt, bn();
                    }
                } else alert("todo:EmitYUV");
                i && (e.Jb = ht, r && mn());
            }
            if (r && !Ii) {
                for(t = 0; 256 > t; ++t)ji[t] = 89858 * (t - 128) + Si >> Ai, Bi[t] = -22014 * (t - 128) + Si, Oi[t] = -45773 * (t - 128), Ci[t] = 113618 * (t - 128) + Si >> Ai;
                for(t = _i; t < Pi; ++t)e = 76283 * (t - 16) + Si >> Ai, Mi[t - _i] = Vt(e, 255), qi[t - _i] = Vt(e + 8 >> 4, 15);
                Ii = 1;
            }
            return 1;
        }
        function dt(t) {
            var n = t.ma, r = t.U, i = t.T;
            return e(!(1 & t.ka)), 0 >= r || 0 >= i ? 0 : (r = n.Ib(t, n), null != n.Jb && n.Jb(t, n, r), n.Dc += r, 1);
        }
        function pt(t) {
            t.ma.memory = null;
        }
        function gt(t, e, n, r) {
            return 47 != y(t, 8) ? 0 : (e[0] = y(t, 14) + 1, n[0] = y(t, 14) + 1, r[0] = y(t, 1), 0 != y(t, 3) ? 0 : !t.h);
        }
        function mt(t, e) {
            if (4 > t) return t + 1;
            var n = t - 2 >> 1;
            return (2 + (1 & t) << n) + y(e, n) + 1;
        }
        function vt(t, e) {
            var n;
            return 120 < e ? e - 120 : 1 <= (n = ((n = Zr[e - 1]) >> 4) * t + (8 - (15 & n))) ? n : 1;
        }
        function bt(t, e, n) {
            var r = L(n), i = t[e += 255 & r].g - 8;
            return 0 < i && (A(n, n.u + 8), r = L(n), e += t[e].value, e += r & (1 << i) - 1), A(n, n.u + t[e].g), t[e].value;
        }
        function yt(t, n, r) {
            return r.g += t.g, r.value += t.value << n >>> 0, e(8 >= r.g), t.g;
        }
        function wt(t, n, r) {
            var i = t.xc;
            return e((n = 0 == i ? 0 : t.vc[t.md * (r >> i) + (n >> i)]) < t.Wb), t.Ya[n];
        }
        function Nt(t, n, i, a) {
            var o = t.ab, s = t.c * n, u = t.C;
            n = u + n;
            var c = i, l = a;
            for(a = t.Ta, i = t.Ua; 0 < o--;){
                var h = t.gc[o], f = u, d = n, p = c, g = l, m = (l = a, c = i, h.Ea);
                switch(e(f < d), e(d <= h.nc), h.hc){
                    case 2:
                        Gn(p, g, (d - f) * m, l, c);
                        break;
                    case 0:
                        var v = f, b = d, y = l, w = c, N = (_ = h).Ea;
                        0 == v && (Wn(p, g, null, null, 1, y, w), V(p, g + 1, 0, 0, N - 1, y, w + 1), g += N, w += N, ++v);
                        for(var L = 1 << _.b, x = L - 1, A = E(N, _.b), S = _.K, _ = _.w + (v >> _.b) * A; v < b;){
                            var P = S, k = _, F = 1;
                            for(Vn(p, g, y, w - N, 1, y, w); F < N;){
                                var I = (F & ~x) + L;
                                I > N && (I = N), (0, Zn[P[k++] >> 8 & 15])(p, g + +F, y, w + F - N, I - F, y, w + F), F = I;
                            }
                            g += N, w += N, ++v & x || (_ += A);
                        }
                        d != h.nc && r(l, c - m, l, c + (d - f - 1) * m, m);
                        break;
                    case 1:
                        for(m = p, b = g, N = (p = h.Ea) - (w = p & ~(y = (g = 1 << h.b) - 1)), v = E(p, h.b), L = h.K, h = h.w + (f >> h.b) * v; f < d;){
                            for(x = L, A = h, S = new T, _ = b + w, P = b + p; b < _;)Y(x[A++], S), $n(S, m, b, g, l, c), b += g, c += g;
                            b < P && (Y(x[A++], S), $n(S, m, b, N, l, c), b += N, c += N), ++f & y || (h += v);
                        }
                        break;
                    case 3:
                        if (p == l && g == c && 0 < h.b) {
                            for(b = l, p = m = c + (d - f) * m - (w = (d - f) * E(h.Ea, h.b)), g = l, y = c, v = [], w = (N = w) - 1; 0 <= w; --w)v[w] = g[y + w];
                            for(w = N - 1; 0 <= w; --w)b[p + w] = v[w];
                            Yn(h, f, d, l, m, l, c);
                        } else Yn(h, f, d, p, g, l, c);
                }
                c = a, l = i;
            }
            l != i && r(a, i, c, l, s);
        }
        function Lt(t, n) {
            var r = t.V, i = t.Ba + t.c * t.C, a = n - t.C;
            if (e(n <= t.l.o), e(16 >= a), 0 < a) {
                var o = t.l, s = t.Ta, u = t.Ua, c = o.width;
                if (Nt(t, a, r, i), a = u = [
                    u
                ], e((r = t.C) < (i = n)), e(o.v < o.va), i > o.o && (i = o.o), r < o.j) {
                    var l = o.j - r;
                    r = o.j, a[0] += l * c;
                }
                if (r >= i ? r = 0 : (a[0] += 4 * o.v, o.ka = r - o.j, o.U = o.va - o.v, o.T = i - r, r = 1), r) {
                    if (u = u[0], 11 > (r = t.ca).S) {
                        var h = r.f.RGBA, f = (i = r.S, a = o.U, o = o.T, l = h.eb, h.A), d = o;
                        for(h = h.fb + t.Ma * h.A; 0 < d--;){
                            var p = s, g = u, m = a, v = l, b = h;
                            switch(i){
                                case Mr:
                                    Qn(p, g, m, v, b);
                                    break;
                                case qr:
                                    tr(p, g, m, v, b);
                                    break;
                                case Ur:
                                    tr(p, g, m, v, b), Lr(v, b, 0, m, 1, 0);
                                    break;
                                case Er:
                                    rr(p, g, m, v, b);
                                    break;
                                case Rr:
                                    et(p, g, m, v, b, 1);
                                    break;
                                case Hr:
                                    et(p, g, m, v, b, 1), Lr(v, b, 0, m, 1, 0);
                                    break;
                                case Dr:
                                    et(p, g, m, v, b, 0);
                                    break;
                                case Wr:
                                    et(p, g, m, v, b, 0), Lr(v, b, 1, m, 1, 0);
                                    break;
                                case Tr:
                                    er(p, g, m, v, b);
                                    break;
                                case Vr:
                                    er(p, g, m, v, b), xr(v, b, m, 1, 0);
                                    break;
                                case zr:
                                    nr(p, g, m, v, b);
                                    break;
                                default:
                                    e(0);
                            }
                            u += c, h += f;
                        }
                        t.Ma += o;
                    } else alert("todo:EmitRescaledRowsYUVA");
                    e(t.Ma <= r.height);
                }
            }
            t.C = n, e(t.C <= t.i);
        }
        function xt(t) {
            var e;
            if (0 < t.ua) return 0;
            for(e = 0; e < t.Wb; ++e){
                var n = t.Ya[e].G, r = t.Ya[e].H;
                if (0 < n[1][r[1] + 0].g || 0 < n[2][r[2] + 0].g || 0 < n[3][r[3] + 0].g) return 0;
            }
            return 1;
        }
        function At(t, n, r, i, a, o) {
            if (0 != t.Z) {
                var s = t.qd, u = t.rd;
                for(e(null != gi[t.Z]); n < r; ++n)gi[t.Z](s, u, i, a, i, a, o), s = i, u = a, a += o;
                t.qd = s, t.rd = u;
            }
        }
        function St(t, n) {
            var r = t.l.ma, i = 0 == r.Z || 1 == r.Z ? t.l.j : t.C;
            if (i = t.C < i ? i : t.C, e(n <= t.l.o), n > i) {
                var a = t.l.width, o = r.ca, s = r.tb + a * i, u = t.V, c = t.Ba + t.c * i, l = t.gc;
                e(1 == t.ab), e(3 == l[0].hc), Xn(l[0], i, n, u, c, o, s), At(r, i, n, o, s, a);
            }
            t.C = t.Ma = n;
        }
        function _t(t, n, r, i, a, o, s) {
            var u = t.$ / i, c = t.$ % i, l = t.m, h = t.s, f = r + t.$, d = f;
            a = r + i * a;
            var p = r + i * o, g = 280 + h.ua, m = t.Pb ? u : 16777216, v = 0 < h.ua ? h.Wa : null, b = h.wc, y = f < p ? wt(h, c, u) : null;
            e(t.C < o), e(p <= a);
            var w = !1;
            t: for(;;){
                for(; w || f < p;){
                    var N = 0;
                    if (u >= m) {
                        var _ = f - r;
                        e((m = t).Pb), m.wd = m.m, m.xd = _, 0 < m.s.ua && B(m.s.Wa, m.s.vb), m = u + Qr;
                    }
                    if (c & b || (y = wt(h, c, u)), e(null != y), y.Qb && (n[f] = y.qb, w = !0), !w) {
                        if (S(l), y.jc) {
                            N = l, _ = n;
                            var P = f, k = y.pd[L(N) & Rn - 1];
                            e(y.jc), 256 > k.g ? (A(N, N.u + k.g), _[P] = k.value, N = 0) : (A(N, N.u + k.g - 256), e(256 <= k.value), N = k.value), 0 == N && (w = !0);
                        } else N = bt(y.G[0], y.H[0], l);
                    }
                    if (l.h) break;
                    if (w || 256 > N) {
                        if (!w) {
                            if (y.nd) n[f] = (y.qb | N << 8) >>> 0;
                            else {
                                if (S(l), w = bt(y.G[1], y.H[1], l), S(l), _ = bt(y.G[2], y.H[2], l), P = bt(y.G[3], y.H[3], l), l.h) break;
                                n[f] = (P << 24 | w << 16 | N << 8 | _) >>> 0;
                            }
                        }
                        if (w = !1, ++f, ++c >= i && (c = 0, ++u, null != s && u <= o && !(u % 16) && s(t, u), null != v)) for(; d < f;)N = n[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                    } else if (280 > N) {
                        if (N = mt(N - 256, l), _ = bt(y.G[4], y.H[4], l), S(l), _ = vt(i, _ = mt(_, l)), l.h) break;
                        if (f - r < _ || a - f < N) break t;
                        for(P = 0; P < N; ++P)n[f + P] = n[f + P - _];
                        for(f += N, c += N; c >= i;)c -= i, ++u, null != s && u <= o && !(u % 16) && s(t, u);
                        if (e(f <= a), c & b && (y = wt(h, c, u)), null != v) for(; d < f;)N = n[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                    } else {
                        if (!(N < g)) break t;
                        for(w = N - 280, e(null != v); d < f;)N = n[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                        N = f, e(!(w >>> (_ = v).Xa)), n[N] = _.X[w], w = !0;
                    }
                    w || e(l.h == x(l));
                }
                if (t.Pb && l.h && f < a) e(t.m.h), t.a = 5, t.m = t.wd, t.$ = t.xd, 0 < t.s.ua && B(t.s.vb, t.s.Wa);
                else {
                    if (l.h) break t;
                    null != s && s(t, u > o ? o : u), t.a = 0, t.$ = f - r;
                }
                return 1;
            }
            return t.a = 3, 0;
        }
        function Pt(t) {
            e(null != t), t.vc = null, t.yc = null, t.Ya = null;
            var n = t.Wa;
            null != n && (n.X = null), t.vb = null, e(null != t);
        }
        function kt() {
            var e = new on;
            return null == e ? null : (e.a = 0, e.xb = pi, nt("Predictor", "VP8LPredictors"), nt("Predictor", "VP8LPredictors_C"), nt("PredictorAdd", "VP8LPredictorsAdd"), nt("PredictorAdd", "VP8LPredictorsAdd_C"), Gn = G, $n = J, Qn = K, tr = Z, er = $, nr = Q, rr = tt, t.VP8LMapColor32b = Jn, t.VP8LMapColor8b = Kn, e);
        }
        function Ft(t, n, r, s, u) {
            var c = 1, f = [
                t
            ], p = [
                n
            ], g = s.m, m = s.s, v = null, b = 0;
            t: for(;;){
                if (r) for(; c && y(g, 1);){
                    var w = f, N = p, x = s, _ = 1, P = x.m, k = x.gc[x.ab], F = y(P, 2);
                    if (x.Oc & 1 << F) c = 0;
                    else {
                        switch(x.Oc |= 1 << F, k.hc = F, k.Ea = w[0], k.nc = N[0], k.K = [
                            null
                        ], ++x.ab, e(4 >= x.ab), F){
                            case 0:
                            case 1:
                                k.b = y(P, 3) + 2, _ = Ft(E(k.Ea, k.b), E(k.nc, k.b), 0, x, k.K), k.K = k.K[0];
                                break;
                            case 3:
                                var I, j = y(P, 8) + 1, C = 16 < j ? 0 : 4 < j ? 1 : 2 < j ? 2 : 3;
                                if (w[0] = E(k.Ea, C), k.b = C, I = _ = Ft(j, 1, 0, x, k.K)) {
                                    var B, M = j, q = k, D = 1 << (8 >> q.b), T = a(D);
                                    if (null == T) I = 0;
                                    else {
                                        var z = q.K[0], U = q.w;
                                        for(T[0] = q.K[0][0], B = 1; B < 1 * M; ++B)T[B] = R(z[U + B], T[B - 1]);
                                        for(; B < 4 * D; ++B)T[B] = 0;
                                        q.K[0] = null, q.K[0] = T, I = 1;
                                    }
                                }
                                _ = I;
                                break;
                            case 2:
                                break;
                            default:
                                e(0);
                        }
                        c = _;
                    }
                }
                if (f = f[0], p = p[0], c && y(g, 1) && !(c = 1 <= (b = y(g, 4)) && 11 >= b)) {
                    s.a = 3;
                    break t;
                }
                var H;
                if (H = c) e: {
                    var W, V, G, Y = s, J = f, X = p, K = b, Z = r, $ = Y.m, Q = Y.s, tt = [
                        null
                    ], et = 1, nt = 0, rt = $r[K];
                    n: for(;;){
                        if (Z && y($, 1)) {
                            var it = y($, 3) + 2, at = E(J, it), ot = E(X, it), st = at * ot;
                            if (!Ft(at, ot, 0, Y, tt)) break n;
                            for(tt = tt[0], Q.xc = it, W = 0; W < st; ++W){
                                var ut = tt[W] >> 8 & 65535;
                                tt[W] = ut, ut >= et && (et = ut + 1);
                            }
                        }
                        if ($.h) break n;
                        for(V = 0; 5 > V; ++V){
                            var ct = Jr[V];
                            !V && 0 < K && (ct += 1 << K), nt < ct && (nt = ct);
                        }
                        var lt = o(et * rt, h), ht = et, ft = o(ht, d);
                        if (null == ft) var dt = null;
                        else e(65536 >= ht), dt = ft;
                        var pt = a(nt);
                        if (null == dt || null == pt || null == lt) {
                            Y.a = 1;
                            break n;
                        }
                        var gt = lt;
                        for(W = G = 0; W < et; ++W){
                            var mt = dt[W], vt = mt.G, bt = mt.H, wt = 0, Nt = 1, Lt = 0;
                            for(V = 0; 5 > V; ++V){
                                ct = Jr[V], vt[V] = gt, bt[V] = G, !V && 0 < K && (ct += 1 << K);
                                r: {
                                    var xt, At = ct, St = Y, kt = pt, It = gt, jt = G, Ct = 0, Ot = St.m, Bt = y(Ot, 1);
                                    if (i(kt, 0, 0, At), Bt) {
                                        var Mt = y(Ot, 1) + 1, qt = y(Ot, 1), Et = y(Ot, 0 == qt ? 1 : 8);
                                        kt[Et] = 1, 2 == Mt && (kt[Et = y(Ot, 8)] = 1);
                                        var Rt = 1;
                                    } else {
                                        var Dt = a(19), Tt = y(Ot, 4) + 4;
                                        if (19 < Tt) {
                                            St.a = 3;
                                            var zt = 0;
                                            break r;
                                        }
                                        for(xt = 0; xt < Tt; ++xt)Dt[Kr[xt]] = y(Ot, 3);
                                        var Ut = void 0, Ht = void 0, Wt = St, Vt = Dt, Gt = At, Yt = kt, Jt = 0, Xt = Wt.m, Kt = 8, Zt = o(128, h);
                                        i: for(; l(Zt, 0, 7, Vt, 19);){
                                            if (y(Xt, 1)) {
                                                var $t = 2 + 2 * y(Xt, 3);
                                                if ((Ut = 2 + y(Xt, $t)) > Gt) break i;
                                            } else Ut = Gt;
                                            for(Ht = 0; Ht < Gt && Ut--;){
                                                S(Xt);
                                                var Qt = Zt[0 + (127 & L(Xt))];
                                                A(Xt, Xt.u + Qt.g);
                                                var te = Qt.value;
                                                if (16 > te) Yt[Ht++] = te, 0 != te && (Kt = te);
                                                else {
                                                    var ee = 16 == te, ne = te - 16, re = Yr[ne], ie = y(Xt, Gr[ne]) + re;
                                                    if (Ht + ie > Gt) break i;
                                                    for(var ae = ee ? Kt : 0; 0 < ie--;)Yt[Ht++] = ae;
                                                }
                                            }
                                            Jt = 1;
                                            break i;
                                        }
                                        Jt || (Wt.a = 3), Rt = Jt;
                                    }
                                    (Rt = Rt && !Ot.h) && (Ct = l(It, jt, 8, kt, At)), Rt && 0 != Ct ? zt = Ct : (St.a = 3, zt = 0);
                                }
                                if (0 == zt) break n;
                                if (Nt && 1 == Xr[V] && (Nt = 0 == gt[G].g), wt += gt[G].g, G += zt, 3 >= V) {
                                    var oe, se = pt[0];
                                    for(oe = 1; oe < ct; ++oe)pt[oe] > se && (se = pt[oe]);
                                    Lt += se;
                                }
                            }
                            if (mt.nd = Nt, mt.Qb = 0, Nt && (mt.qb = (vt[3][bt[3] + 0].value << 24 | vt[1][bt[1] + 0].value << 16 | vt[2][bt[2] + 0].value) >>> 0, 0 == wt && 256 > vt[0][bt[0] + 0].value && (mt.Qb = 1, mt.qb += vt[0][bt[0] + 0].value << 8)), mt.jc = !mt.Qb && 6 > Lt, mt.jc) {
                                var ue, ce = mt;
                                for(ue = 0; ue < Rn; ++ue){
                                    var le = ue, he = ce.pd[le], fe = ce.G[0][ce.H[0] + le];
                                    256 <= fe.value ? (he.g = fe.g + 256, he.value = fe.value) : (he.g = 0, he.value = 0, le >>= yt(fe, 8, he), le >>= yt(ce.G[1][ce.H[1] + le], 16, he), le >>= yt(ce.G[2][ce.H[2] + le], 0, he), yt(ce.G[3][ce.H[3] + le], 24, he));
                                }
                            }
                        }
                        Q.vc = tt, Q.Wb = et, Q.Ya = dt, Q.yc = lt, H = 1;
                        break e;
                    }
                    H = 0;
                }
                if (!(c = H)) {
                    s.a = 3;
                    break t;
                }
                if (0 < b) {
                    if (m.ua = 1 << b, !O(m.Wa, b)) {
                        s.a = 1, c = 0;
                        break t;
                    }
                } else m.ua = 0;
                var de = s, pe = f, ge = p, me = de.s, ve = me.xc;
                if (de.c = pe, de.i = ge, me.md = E(pe, ve), me.wc = 0 == ve ? -1 : (1 << ve) - 1, r) {
                    s.xb = di;
                    break t;
                }
                if (null == (v = a(f * p))) {
                    s.a = 1, c = 0;
                    break t;
                }
                c = (c = _t(s, v, 0, f, p, p, null)) && !g.h;
                break t;
            }
            return c ? (null != u ? u[0] = v : (e(null == v), e(r)), s.$ = 0, r || Pt(m)) : Pt(m), c;
        }
        function It(t, n) {
            var r = t.c * t.i, i = r + n + 16 * n;
            return e(t.c <= n), t.V = a(i), null == t.V ? (t.Ta = null, t.Ua = 0, t.a = 1, 0) : (t.Ta = t.V, t.Ua = t.Ba + r + n, 1);
        }
        function jt(t, n) {
            var r = t.C, i = n - r, a = t.V, o = t.Ba + t.c * r;
            for(e(n <= t.l.o); 0 < i;){
                var s = 16 < i ? 16 : i, u = t.l.ma, c = t.l.width, l = c * s, h = u.ca, f = u.tb + c * r, d = t.Ta, p = t.Ua;
                Nt(t, s, a, o), Sr(d, p, h, f, l), At(u, r, r + s, h, f, c), i -= s, a += s * t.c, r += s;
            }
            e(r == n), t.C = t.Ma = n;
        }
        function Ct() {
            this.ub = this.yd = this.td = this.Rb = 0;
        }
        function Ot() {
            this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
        }
        function Bt() {
            this.Fb = this.Bb = this.Cb = 0, this.Zb = a(4), this.Lb = a(4);
        }
        function Mt() {
            this.Yb = function() {
                var t = [];
                return function t(e, n, r) {
                    for(var i = r[n], a = 0; a < i && (e.push(r.length > n + 1 ? [] : 0), !(r.length < n + 1)); a++)t(e[a], n + 1, r);
                }(t, 0, [
                    3,
                    11
                ]), t;
            }();
        }
        function qt() {
            this.jb = a(3), this.Wc = s([
                4,
                8
            ], Mt), this.Xc = s([
                4,
                17
            ], Mt);
        }
        function Et() {
            this.Pc = this.wb = this.Tb = this.zd = 0, this.vd = new a(4), this.od = new a(4);
        }
        function Rt() {
            this.ld = this.La = this.dd = this.tc = 0;
        }
        function Dt() {
            this.Na = this.la = 0;
        }
        function Tt() {
            this.Sc = [
                0,
                0
            ], this.Eb = [
                0,
                0
            ], this.Qc = [
                0,
                0
            ], this.ia = this.lc = 0;
        }
        function zt() {
            this.ad = a(384), this.Za = 0, this.Ob = a(16), this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0;
        }
        function Ut() {
            this.uc = this.M = this.Nb = 0, this.wa = Array(new Rt), this.Y = 0, this.ya = Array(new zt), this.aa = 0, this.l = new Gt;
        }
        function Ht() {
            this.y = a(16), this.f = a(8), this.ea = a(8);
        }
        function Wt() {
            this.cb = this.a = 0, this.sc = "", this.m = new w, this.Od = new Ct, this.Kc = new Ot, this.ed = new Et, this.Qa = new Bt, this.Ic = this.$c = this.Aa = 0, this.D = new Ut, this.Xb = this.Va = this.Hb = this.zb = this.yb = this.Ub = this.za = 0, this.Jc = o(8, w), this.ia = 0, this.pb = o(4, Tt), this.Pa = new qt, this.Bd = this.kc = 0, this.Ac = [], this.Bc = 0, this.zc = [
                0,
                0,
                0,
                0
            ], this.Gd = Array(new Ht), this.Hd = 0, this.rb = Array(new Dt), this.sb = 0, this.wa = Array(new Rt), this.Y = 0, this.oc = [], this.pc = 0, this.sa = [], this.ta = 0, this.qa = [], this.ra = 0, this.Ha = [], this.B = this.R = this.Ia = 0, this.Ec = [], this.M = this.ja = this.Vb = this.Fc = 0, this.ya = Array(new zt), this.L = this.aa = 0, this.gd = s([
                4,
                2
            ], Rt), this.ga = null, this.Fa = [], this.Cc = this.qc = this.P = 0, this.Gb = [], this.Uc = 0, this.mb = [], this.nb = 0, this.rc = [], this.Ga = this.Vc = 0;
        }
        function Vt(t, e) {
            return 0 > t ? 0 : t > e ? e : t;
        }
        function Gt() {
            this.T = this.U = this.ka = this.height = this.width = 0, this.y = [], this.f = [], this.ea = [], this.Rc = this.fa = this.W = this.N = this.O = 0, this.ma = "void", this.put = "VP8IoPutHook", this.ac = "VP8IoSetupHook", this.bc = "VP8IoTeardownHook", this.ha = this.Kb = 0, this.data = [], this.hb = this.ib = this.da = this.o = this.j = this.va = this.v = this.Da = this.ob = this.w = 0, this.F = [], this.J = 0;
        }
        function Yt() {
            var t = new Wt;
            return null != t && (t.a = 0, t.sc = "OK", t.cb = 0, t.Xb = 0, ni || (ni = Zt)), t;
        }
        function Jt(t, e, n) {
            return 0 == t.a && (t.a = e, t.sc = n, t.cb = 0), 0;
        }
        function Xt(t, e, n) {
            return 3 <= n && 157 == t[e + 0] && 1 == t[e + 1] && 42 == t[e + 2];
        }
        function Kt(t, n) {
            if (null == t) return 0;
            if (t.a = 0, t.sc = "OK", null == n) return Jt(t, 2, "null VP8Io passed to VP8GetHeaders()");
            var r = n.data, a = n.w, o = n.ha;
            if (4 > o) return Jt(t, 7, "Truncated header.");
            var s = r[a + 0] | r[a + 1] << 8 | r[a + 2] << 16, u = t.Od;
            if (u.Rb = !(1 & s), u.td = s >> 1 & 7, u.yd = s >> 4 & 1, u.ub = s >> 5, 3 < u.td) return Jt(t, 3, "Incorrect keyframe parameters.");
            if (!u.yd) return Jt(t, 4, "Frame not displayable.");
            a += 3, o -= 3;
            var c = t.Kc;
            if (u.Rb) {
                if (7 > o) return Jt(t, 7, "cannot parse picture header");
                if (!Xt(r, a, o)) return Jt(t, 3, "Bad code word");
                c.c = 16383 & (r[a + 4] << 8 | r[a + 3]), c.Td = r[a + 4] >> 6, c.i = 16383 & (r[a + 6] << 8 | r[a + 5]), c.Ud = r[a + 6] >> 6, a += 7, o -= 7, t.za = c.c + 15 >> 4, t.Ub = c.i + 15 >> 4, n.width = c.c, n.height = c.i, n.Da = 0, n.j = 0, n.v = 0, n.va = n.width, n.o = n.height, n.da = 0, n.ib = n.width, n.hb = n.height, n.U = n.width, n.T = n.height, i((s = t.Pa).jb, 0, 255, s.jb.length), e(null != (s = t.Qa)), s.Cb = 0, s.Bb = 0, s.Fb = 1, i(s.Zb, 0, 0, s.Zb.length), i(s.Lb, 0, 0, s.Lb);
            }
            if (u.ub > o) return Jt(t, 7, "bad partition length");
            p(s = t.m, r, a, u.ub), a += u.ub, o -= u.ub, u.Rb && (c.Ld = P(s), c.Kd = P(s)), c = t.Qa;
            var l, h = t.Pa;
            if (e(null != s), e(null != c), c.Cb = P(s), c.Cb) {
                if (c.Bb = P(s), P(s)) {
                    for(c.Fb = P(s), l = 0; 4 > l; ++l)c.Zb[l] = P(s) ? m(s, 7) : 0;
                    for(l = 0; 4 > l; ++l)c.Lb[l] = P(s) ? m(s, 6) : 0;
                }
                if (c.Bb) for(l = 0; 3 > l; ++l)h.jb[l] = P(s) ? g(s, 8) : 255;
            } else c.Bb = 0;
            if (s.Ka) return Jt(t, 3, "cannot parse segment header");
            if ((c = t.ed).zd = P(s), c.Tb = g(s, 6), c.wb = g(s, 3), c.Pc = P(s), c.Pc && P(s)) {
                for(h = 0; 4 > h; ++h)P(s) && (c.vd[h] = m(s, 6));
                for(h = 0; 4 > h; ++h)P(s) && (c.od[h] = m(s, 6));
            }
            if (t.L = 0 == c.Tb ? 0 : c.zd ? 1 : 2, s.Ka) return Jt(t, 3, "cannot parse filter header");
            var f = o;
            if (o = l = a, a = l + f, c = f, t.Xb = (1 << g(t.m, 2)) - 1, f < 3 * (h = t.Xb)) r = 7;
            else {
                for(l += 3 * h, c -= 3 * h, f = 0; f < h; ++f){
                    var d = r[o + 0] | r[o + 1] << 8 | r[o + 2] << 16;
                    d > c && (d = c), p(t.Jc[+f], r, l, d), l += d, c -= d, o += 3;
                }
                p(t.Jc[+h], r, l, c), r = l < a ? 0 : 5;
            }
            if (0 != r) return Jt(t, r, "cannot parse partitions");
            for(r = g(l = t.m, 7), o = P(l) ? m(l, 4) : 0, a = P(l) ? m(l, 4) : 0, c = P(l) ? m(l, 4) : 0, h = P(l) ? m(l, 4) : 0, l = P(l) ? m(l, 4) : 0, f = t.Qa, d = 0; 4 > d; ++d){
                if (f.Cb) {
                    var v = f.Zb[d];
                    f.Fb || (v += r);
                } else {
                    if (0 < d) {
                        t.pb[d] = t.pb[0];
                        continue;
                    }
                    v = r;
                }
                var b = t.pb[d];
                b.Sc[0] = ti[Vt(v + o, 127)], b.Sc[1] = ei[Vt(v + 0, 127)], b.Eb[0] = 2 * ti[Vt(v + a, 127)], b.Eb[1] = 101581 * ei[Vt(v + c, 127)] >> 16, 8 > b.Eb[1] && (b.Eb[1] = 8), b.Qc[0] = ti[Vt(v + h, 117)], b.Qc[1] = ei[Vt(v + l, 127)], b.lc = v + l;
            }
            if (!u.Rb) return Jt(t, 4, "Not a key frame.");
            for(P(s), u = t.Pa, r = 0; 4 > r; ++r){
                for(o = 0; 8 > o; ++o)for(a = 0; 3 > a; ++a)for(c = 0; 11 > c; ++c)h = k(s, ui[r][o][a][c]) ? g(s, 8) : oi[r][o][a][c], u.Wc[r][o].Yb[a][c] = h;
                for(o = 0; 17 > o; ++o)u.Xc[r][o] = u.Wc[r][ci[o]];
            }
            return t.kc = P(s), t.kc && (t.Bd = g(s, 8)), t.cb = 1;
        }
        function Zt(t, e, n, r, i, a, o) {
            var s = e[i].Yb[n];
            for(n = 0; 16 > i; ++i){
                if (!k(t, s[n + 0])) return i;
                for(; !k(t, s[n + 1]);)if (s = e[++i].Yb[0], n = 0, 16 == i) return 16;
                var u = e[i + 1].Yb;
                if (k(t, s[n + 2])) {
                    var c = t, l = 0;
                    if (k(c, (f = s)[(h = n) + 3])) {
                        if (k(c, f[h + 6])) {
                            for(s = 0, h = 2 * (l = k(c, f[h + 8])) + (f = k(c, f[h + 9 + l])), l = 0, f = ri[h]; f[s]; ++s)l += l + k(c, f[s]);
                            l += 3 + (8 << h);
                        } else k(c, f[h + 7]) ? (l = 7 + 2 * k(c, 165), l += k(c, 145)) : l = 5 + k(c, 159);
                    } else l = k(c, f[h + 4]) ? 3 + k(c, f[h + 5]) : 2;
                    s = u[2];
                } else l = 1, s = u[1];
                u = o + ii[i], 0 > (c = t).b && _(c);
                var h, f = c.b, d = (h = c.Ca >> 1) - (c.I >> f) >> 31;
                --c.b, c.Ca += d, c.Ca |= 1, c.I -= (h + 1 & d) << f, a[u] = ((l ^ d) - d) * r[(0 < i) + 0];
            }
            return 16;
        }
        function $t(t) {
            var e = t.rb[t.sb - 1];
            e.la = 0, e.Na = 0, i(t.zc, 0, 0, t.zc.length), t.ja = 0;
        }
        function Qt(t, e, n, r, i) {
            i = t[e + n + 32 * r] + (i >> 3), t[e + n + 32 * r] = -256 & i ? 0 > i ? 0 : 255 : i;
        }
        function te(t, e, n, r, i, a) {
            Qt(t, e, 0, n, r + i), Qt(t, e, 1, n, r + a), Qt(t, e, 2, n, r - a), Qt(t, e, 3, n, r - i);
        }
        function ee(t) {
            return (20091 * t >> 16) + t;
        }
        function ne(t, e, n, r) {
            var i, o = 0, s = a(16);
            for(i = 0; 4 > i; ++i){
                var u = t[e + 0] + t[e + 8], c = t[e + 0] - t[e + 8], l = (35468 * t[e + 4] >> 16) - ee(t[e + 12]), h = ee(t[e + 4]) + (35468 * t[e + 12] >> 16);
                s[o + 0] = u + h, s[o + 1] = c + l, s[o + 2] = c - l, s[o + 3] = u - h, o += 4, e++;
            }
            for(i = o = 0; 4 > i; ++i)u = (t = s[o + 0] + 4) + s[o + 8], c = t - s[o + 8], l = (35468 * s[o + 4] >> 16) - ee(s[o + 12]), Qt(n, r, 0, 0, u + (h = ee(s[o + 4]) + (35468 * s[o + 12] >> 16))), Qt(n, r, 1, 0, c + l), Qt(n, r, 2, 0, c - l), Qt(n, r, 3, 0, u - h), o++, r += 32;
        }
        function re(t, e, n, r) {
            var i = t[e + 0] + 4, a = 35468 * t[e + 4] >> 16, o = ee(t[e + 4]), s = 35468 * t[e + 1] >> 16;
            te(n, r, 0, i + o, t = ee(t[e + 1]), s), te(n, r, 1, i + a, t, s), te(n, r, 2, i - a, t, s), te(n, r, 3, i - o, t, s);
        }
        function ie(t, e, n, r, i) {
            ne(t, e, n, r), i && ne(t, e + 16, n, r + 4);
        }
        function ae(t, e, n, r) {
            ar(t, e + 0, n, r, 1), ar(t, e + 32, n, r + 128, 1);
        }
        function oe(t, e, n, r) {
            var i;
            for(t = t[e + 0] + 4, i = 0; 4 > i; ++i)for(e = 0; 4 > e; ++e)Qt(n, r, e, i, t);
        }
        function se(t, e, n, r) {
            t[e + 0] && ur(t, e + 0, n, r), t[e + 16] && ur(t, e + 16, n, r + 4), t[e + 32] && ur(t, e + 32, n, r + 128), t[e + 48] && ur(t, e + 48, n, r + 128 + 4);
        }
        function ue(t, e, n, r) {
            var i, o = a(16);
            for(i = 0; 4 > i; ++i){
                var s = t[e + 0 + i] + t[e + 12 + i], u = t[e + 4 + i] + t[e + 8 + i], c = t[e + 4 + i] - t[e + 8 + i], l = t[e + 0 + i] - t[e + 12 + i];
                o[0 + i] = s + u, o[8 + i] = s - u, o[4 + i] = l + c, o[12 + i] = l - c;
            }
            for(i = 0; 4 > i; ++i)s = (t = o[0 + 4 * i] + 3) + o[3 + 4 * i], u = o[1 + 4 * i] + o[2 + 4 * i], c = o[1 + 4 * i] - o[2 + 4 * i], l = t - o[3 + 4 * i], n[r + 0] = s + u >> 3, n[r + 16] = l + c >> 3, n[r + 32] = s - u >> 3, n[r + 48] = l - c >> 3, r += 64;
        }
        function ce(t, e, n) {
            var r, i = e - 32, a = Or, o = 255 - t[i - 1];
            for(r = 0; r < n; ++r){
                var s, u = a, c = o + t[e - 1];
                for(s = 0; s < n; ++s)t[e + s] = u[c + t[i + s]];
                e += 32;
            }
        }
        function le(t, e) {
            ce(t, e, 4);
        }
        function he(t, e) {
            ce(t, e, 8);
        }
        function fe(t, e) {
            ce(t, e, 16);
        }
        function de(t, e) {
            var n;
            for(n = 0; 16 > n; ++n)r(t, e + 32 * n, t, e - 32, 16);
        }
        function pe(t, e) {
            var n;
            for(n = 16; 0 < n; --n)i(t, e, t[e - 1], 16), e += 32;
        }
        function ge(t, e, n) {
            var r;
            for(r = 0; 16 > r; ++r)i(e, n + 32 * r, t, 16);
        }
        function me(t, e) {
            var n, r = 16;
            for(n = 0; 16 > n; ++n)r += t[e - 1 + 32 * n] + t[e + n - 32];
            ge(r >> 5, t, e);
        }
        function ve(t, e) {
            var n, r = 8;
            for(n = 0; 16 > n; ++n)r += t[e - 1 + 32 * n];
            ge(r >> 4, t, e);
        }
        function be(t, e) {
            var n, r = 8;
            for(n = 0; 16 > n; ++n)r += t[e + n - 32];
            ge(r >> 4, t, e);
        }
        function ye(t, e) {
            ge(128, t, e);
        }
        function we(t, e, n) {
            return t + 2 * e + n + 2 >> 2;
        }
        function Ne(t, e) {
            var n, i = e - 32;
            for(i = new Uint8Array([
                we(t[i - 1], t[i + 0], t[i + 1]),
                we(t[i + 0], t[i + 1], t[i + 2]),
                we(t[i + 1], t[i + 2], t[i + 3]),
                we(t[i + 2], t[i + 3], t[i + 4])
            ]), n = 0; 4 > n; ++n)r(t, e + 32 * n, i, 0, i.length);
        }
        function Le(t, e) {
            var n = t[e - 1], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96];
            F(t, e + 0, 16843009 * we(t[e - 1 - 32], n, r)), F(t, e + 32, 16843009 * we(n, r, i)), F(t, e + 64, 16843009 * we(r, i, a)), F(t, e + 96, 16843009 * we(i, a, a));
        }
        function xe(t, e) {
            var n, r = 4;
            for(n = 0; 4 > n; ++n)r += t[e + n - 32] + t[e - 1 + 32 * n];
            for(r >>= 3, n = 0; 4 > n; ++n)i(t, e + 32 * n, r, 4);
        }
        function Ae(t, e) {
            var n = t[e - 1 + 0], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 - 32], o = t[e + 0 - 32], s = t[e + 1 - 32], u = t[e + 2 - 32], c = t[e + 3 - 32];
            t[e + 0 + 96] = we(r, i, t[e - 1 + 96]), t[e + 1 + 96] = t[e + 0 + 64] = we(n, r, i), t[e + 2 + 96] = t[e + 1 + 64] = t[e + 0 + 32] = we(a, n, r), t[e + 3 + 96] = t[e + 2 + 64] = t[e + 1 + 32] = t[e + 0 + 0] = we(o, a, n), t[e + 3 + 64] = t[e + 2 + 32] = t[e + 1 + 0] = we(s, o, a), t[e + 3 + 32] = t[e + 2 + 0] = we(u, s, o), t[e + 3 + 0] = we(c, u, s);
        }
        function Se(t, e) {
            var n = t[e + 1 - 32], r = t[e + 2 - 32], i = t[e + 3 - 32], a = t[e + 4 - 32], o = t[e + 5 - 32], s = t[e + 6 - 32], u = t[e + 7 - 32];
            t[e + 0 + 0] = we(t[e + 0 - 32], n, r), t[e + 1 + 0] = t[e + 0 + 32] = we(n, r, i), t[e + 2 + 0] = t[e + 1 + 32] = t[e + 0 + 64] = we(r, i, a), t[e + 3 + 0] = t[e + 2 + 32] = t[e + 1 + 64] = t[e + 0 + 96] = we(i, a, o), t[e + 3 + 32] = t[e + 2 + 64] = t[e + 1 + 96] = we(a, o, s), t[e + 3 + 64] = t[e + 2 + 96] = we(o, s, u), t[e + 3 + 96] = we(s, u, u);
        }
        function _e(t, e) {
            var n = t[e - 1 + 0], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 - 32], o = t[e + 0 - 32], s = t[e + 1 - 32], u = t[e + 2 - 32], c = t[e + 3 - 32];
            t[e + 0 + 0] = t[e + 1 + 64] = a + o + 1 >> 1, t[e + 1 + 0] = t[e + 2 + 64] = o + s + 1 >> 1, t[e + 2 + 0] = t[e + 3 + 64] = s + u + 1 >> 1, t[e + 3 + 0] = u + c + 1 >> 1, t[e + 0 + 96] = we(i, r, n), t[e + 0 + 64] = we(r, n, a), t[e + 0 + 32] = t[e + 1 + 96] = we(n, a, o), t[e + 1 + 32] = t[e + 2 + 96] = we(a, o, s), t[e + 2 + 32] = t[e + 3 + 96] = we(o, s, u), t[e + 3 + 32] = we(s, u, c);
        }
        function Pe(t, e) {
            var n = t[e + 0 - 32], r = t[e + 1 - 32], i = t[e + 2 - 32], a = t[e + 3 - 32], o = t[e + 4 - 32], s = t[e + 5 - 32], u = t[e + 6 - 32], c = t[e + 7 - 32];
            t[e + 0 + 0] = n + r + 1 >> 1, t[e + 1 + 0] = t[e + 0 + 64] = r + i + 1 >> 1, t[e + 2 + 0] = t[e + 1 + 64] = i + a + 1 >> 1, t[e + 3 + 0] = t[e + 2 + 64] = a + o + 1 >> 1, t[e + 0 + 32] = we(n, r, i), t[e + 1 + 32] = t[e + 0 + 96] = we(r, i, a), t[e + 2 + 32] = t[e + 1 + 96] = we(i, a, o), t[e + 3 + 32] = t[e + 2 + 96] = we(a, o, s), t[e + 3 + 64] = we(o, s, u), t[e + 3 + 96] = we(s, u, c);
        }
        function ke(t, e) {
            var n = t[e - 1 + 0], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96];
            t[e + 0 + 0] = n + r + 1 >> 1, t[e + 2 + 0] = t[e + 0 + 32] = r + i + 1 >> 1, t[e + 2 + 32] = t[e + 0 + 64] = i + a + 1 >> 1, t[e + 1 + 0] = we(n, r, i), t[e + 3 + 0] = t[e + 1 + 32] = we(r, i, a), t[e + 3 + 32] = t[e + 1 + 64] = we(i, a, a), t[e + 3 + 64] = t[e + 2 + 64] = t[e + 0 + 96] = t[e + 1 + 96] = t[e + 2 + 96] = t[e + 3 + 96] = a;
        }
        function Fe(t, e) {
            var n = t[e - 1 + 0], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96], o = t[e - 1 - 32], s = t[e + 0 - 32], u = t[e + 1 - 32], c = t[e + 2 - 32];
            t[e + 0 + 0] = t[e + 2 + 32] = n + o + 1 >> 1, t[e + 0 + 32] = t[e + 2 + 64] = r + n + 1 >> 1, t[e + 0 + 64] = t[e + 2 + 96] = i + r + 1 >> 1, t[e + 0 + 96] = a + i + 1 >> 1, t[e + 3 + 0] = we(s, u, c), t[e + 2 + 0] = we(o, s, u), t[e + 1 + 0] = t[e + 3 + 32] = we(n, o, s), t[e + 1 + 32] = t[e + 3 + 64] = we(r, n, o), t[e + 1 + 64] = t[e + 3 + 96] = we(i, r, n), t[e + 1 + 96] = we(a, i, r);
        }
        function Ie(t, e) {
            var n;
            for(n = 0; 8 > n; ++n)r(t, e + 32 * n, t, e - 32, 8);
        }
        function je(t, e) {
            var n;
            for(n = 0; 8 > n; ++n)i(t, e, t[e - 1], 8), e += 32;
        }
        function Ce(t, e, n) {
            var r;
            for(r = 0; 8 > r; ++r)i(e, n + 32 * r, t, 8);
        }
        function Oe(t, e) {
            var n, r = 8;
            for(n = 0; 8 > n; ++n)r += t[e + n - 32] + t[e - 1 + 32 * n];
            Ce(r >> 4, t, e);
        }
        function Be(t, e) {
            var n, r = 4;
            for(n = 0; 8 > n; ++n)r += t[e + n - 32];
            Ce(r >> 3, t, e);
        }
        function Me(t, e) {
            var n, r = 4;
            for(n = 0; 8 > n; ++n)r += t[e - 1 + 32 * n];
            Ce(r >> 3, t, e);
        }
        function qe(t, e) {
            Ce(128, t, e);
        }
        function Ee(t, e, n) {
            var r = t[e - n], i = t[e + 0], a = 3 * (i - r) + jr[1020 + t[e - 2 * n] - t[e + n]], o = Cr[112 + (a + 4 >> 3)];
            t[e - n] = Or[255 + r + Cr[112 + (a + 3 >> 3)]], t[e + 0] = Or[255 + i - o];
        }
        function Re(t, e, n, r) {
            var i = t[e + 0], a = t[e + n];
            return Br[255 + t[e - 2 * n] - t[e - n]] > r || Br[255 + a - i] > r;
        }
        function De(t, e, n, r) {
            return 4 * Br[255 + t[e - n] - t[e + 0]] + Br[255 + t[e - 2 * n] - t[e + n]] <= r;
        }
        function Te(t, e, n, r, i) {
            var a = t[e - 3 * n], o = t[e - 2 * n], s = t[e - n], u = t[e + 0], c = t[e + n], l = t[e + 2 * n], h = t[e + 3 * n];
            return 4 * Br[255 + s - u] + Br[255 + o - c] > r ? 0 : Br[255 + t[e - 4 * n] - a] <= i && Br[255 + a - o] <= i && Br[255 + o - s] <= i && Br[255 + h - l] <= i && Br[255 + l - c] <= i && Br[255 + c - u] <= i;
        }
        function ze(t, e, n, r) {
            var i = 2 * r + 1;
            for(r = 0; 16 > r; ++r)De(t, e + r, n, i) && Ee(t, e + r, n);
        }
        function Ue(t, e, n, r) {
            var i = 2 * r + 1;
            for(r = 0; 16 > r; ++r)De(t, e + r * n, 1, i) && Ee(t, e + r * n, 1);
        }
        function He(t, e, n, r) {
            var i;
            for(i = 3; 0 < i; --i)ze(t, e += 4 * n, n, r);
        }
        function We(t, e, n, r) {
            var i;
            for(i = 3; 0 < i; --i)Ue(t, e += 4, n, r);
        }
        function Ve(t, e, n, r, i, a, o, s) {
            for(a = 2 * a + 1; 0 < i--;){
                if (Te(t, e, n, a, o)) {
                    if (Re(t, e, n, s)) Ee(t, e, n);
                    else {
                        var u = t, c = e, l = n, h = u[c - 2 * l], f = u[c - l], d = u[c + 0], p = u[c + l], g = u[c + 2 * l], m = 27 * (b = jr[1020 + 3 * (d - f) + jr[1020 + h - p]]) + 63 >> 7, v = 18 * b + 63 >> 7, b = 9 * b + 63 >> 7;
                        u[c - 3 * l] = Or[255 + u[c - 3 * l] + b], u[c - 2 * l] = Or[255 + h + v], u[c - l] = Or[255 + f + m], u[c + 0] = Or[255 + d - m], u[c + l] = Or[255 + p - v], u[c + 2 * l] = Or[255 + g - b];
                    }
                }
                e += r;
            }
        }
        function Ge(t, e, n, r, i, a, o, s) {
            for(a = 2 * a + 1; 0 < i--;){
                if (Te(t, e, n, a, o)) {
                    if (Re(t, e, n, s)) Ee(t, e, n);
                    else {
                        var u = t, c = e, l = n, h = u[c - l], f = u[c + 0], d = u[c + l], p = Cr[112 + (4 + (g = 3 * (f - h)) >> 3)], g = Cr[112 + (g + 3 >> 3)], m = p + 1 >> 1;
                        u[c - 2 * l] = Or[255 + u[c - 2 * l] + m], u[c - l] = Or[255 + h + g], u[c + 0] = Or[255 + f - p], u[c + l] = Or[255 + d - m];
                    }
                }
                e += r;
            }
        }
        function Ye(t, e, n, r, i, a) {
            Ve(t, e, n, 1, 16, r, i, a);
        }
        function Je(t, e, n, r, i, a) {
            Ve(t, e, 1, n, 16, r, i, a);
        }
        function Xe(t, e, n, r, i, a) {
            var o;
            for(o = 3; 0 < o; --o)Ge(t, e += 4 * n, n, 1, 16, r, i, a);
        }
        function Ke(t, e, n, r, i, a) {
            var o;
            for(o = 3; 0 < o; --o)Ge(t, e += 4, 1, n, 16, r, i, a);
        }
        function Ze(t, e, n, r, i, a, o, s) {
            Ve(t, e, i, 1, 8, a, o, s), Ve(n, r, i, 1, 8, a, o, s);
        }
        function $e(t, e, n, r, i, a, o, s) {
            Ve(t, e, 1, i, 8, a, o, s), Ve(n, r, 1, i, 8, a, o, s);
        }
        function Qe(t, e, n, r, i, a, o, s) {
            Ge(t, e + 4 * i, i, 1, 8, a, o, s), Ge(n, r + 4 * i, i, 1, 8, a, o, s);
        }
        function tn(t, e, n, r, i, a, o, s) {
            Ge(t, e + 4, 1, i, 8, a, o, s), Ge(n, r + 4, 1, i, 8, a, o, s);
        }
        function en() {
            this.ba = new ot, this.ec = [], this.cc = [], this.Mc = [], this.Dc = this.Nc = this.dc = this.fc = 0, this.Oa = new ut, this.memory = 0, this.Ib = "OutputFunc", this.Jb = "OutputAlphaFunc", this.Nd = "OutputRowFunc";
        }
        function nn() {
            this.data = [], this.offset = this.kd = this.ha = this.w = 0, this.na = [], this.xa = this.gb = this.Ja = this.Sa = this.P = 0;
        }
        function rn() {
            this.nc = this.Ea = this.b = this.hc = 0, this.K = [], this.w = 0;
        }
        function an() {
            this.ua = 0, this.Wa = new M, this.vb = new M, this.md = this.xc = this.wc = 0, this.vc = [], this.Wb = 0, this.Ya = new d, this.yc = new h;
        }
        function on() {
            this.xb = this.a = 0, this.l = new Gt, this.ca = new ot, this.V = [], this.Ba = 0, this.Ta = [], this.Ua = 0, this.m = new N, this.Pb = 0, this.wd = new N, this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0, this.s = new an, this.ab = 0, this.gc = o(4, rn), this.Oc = 0;
        }
        function sn() {
            this.Lc = this.Z = this.$a = this.i = this.c = 0, this.l = new Gt, this.ic = 0, this.ca = [], this.tb = 0, this.qd = null, this.rd = 0;
        }
        function un(t, e, n, r, i, a, o) {
            for(t = null == t ? 0 : t[e + 0], e = 0; e < o; ++e)i[a + e] = t + n[r + e] & 255, t = i[a + e];
        }
        function cn(t, e, n, r, i, a, o) {
            var s;
            if (null == t) un(null, null, n, r, i, a, o);
            else for(s = 0; s < o; ++s)i[a + s] = t[e + s] + n[r + s] & 255;
        }
        function ln(t, e, n, r, i, a, o) {
            if (null == t) un(null, null, n, r, i, a, o);
            else {
                var s, u = t[e + 0], c = u, l = u;
                for(s = 0; s < o; ++s)c = l + (u = t[e + s]) - c, l = n[r + s] + (-256 & c ? 0 > c ? 0 : 255 : c) & 255, c = u, i[a + s] = l;
            }
        }
        function hn(t, n, i, o) {
            var s = n.width, u = n.o;
            if (e(null != t && null != n), 0 > i || 0 >= o || i + o > u) return null;
            if (!t.Cc) {
                if (null == t.ga) {
                    var c;
                    if (t.ga = new sn, (c = null == t.ga) || (c = n.width * n.o, e(0 == t.Gb.length), t.Gb = a(c), t.Uc = 0, null == t.Gb ? c = 0 : (t.mb = t.Gb, t.nb = t.Uc, t.rc = null, c = 1), c = !c), !c) {
                        c = t.ga;
                        var l = t.Fa, h = t.P, f = t.qc, d = t.mb, p = t.nb, g = h + 1, m = f - 1, b = c.l;
                        if (e(null != l && null != d && null != n), gi[0] = null, gi[1] = un, gi[2] = cn, gi[3] = ln, c.ca = d, c.tb = p, c.c = n.width, c.i = n.height, e(0 < c.c && 0 < c.i), 1 >= f) n = 0;
                        else if (c.$a = 3 & l[h + 0], c.Z = l[h + 0] >> 2 & 3, c.Lc = l[h + 0] >> 4 & 3, h = l[h + 0] >> 6 & 3, 0 > c.$a || 1 < c.$a || 4 <= c.Z || 1 < c.Lc || h) n = 0;
                        else if (b.put = dt, b.ac = ft, b.bc = pt, b.ma = c, b.width = n.width, b.height = n.height, b.Da = n.Da, b.v = n.v, b.va = n.va, b.j = n.j, b.o = n.o, c.$a) t: {
                            e(1 == c.$a), n = kt();
                            e: for(;;){
                                if (null == n) {
                                    n = 0;
                                    break t;
                                }
                                if (e(null != c), c.mc = n, n.c = c.c, n.i = c.i, n.l = c.l, n.l.ma = c, n.l.width = c.c, n.l.height = c.i, n.a = 0, v(n.m, l, g, m), !Ft(c.c, c.i, 1, n, null)) break e;
                                if (1 == n.ab && 3 == n.gc[0].hc && xt(n.s) ? (c.ic = 1, l = n.c * n.i, n.Ta = null, n.Ua = 0, n.V = a(l), n.Ba = 0, null == n.V ? (n.a = 1, n = 0) : n = 1) : (c.ic = 0, n = It(n, c.c)), !n) break e;
                                n = 1;
                                break t;
                            }
                            c.mc = null, n = 0;
                        }
                        else n = m >= c.c * c.i;
                        c = !n;
                    }
                    if (c) return null;
                    1 != t.ga.Lc ? t.Ga = 0 : o = u - i;
                }
                e(null != t.ga), e(i + o <= u);
                t: {
                    if (n = (l = t.ga).c, u = l.l.o, 0 == l.$a) {
                        if (g = t.rc, m = t.Vc, b = t.Fa, h = t.P + 1 + i * n, f = t.mb, d = t.nb + i * n, e(h <= t.P + t.qc), 0 != l.Z) for(e(null != gi[l.Z]), c = 0; c < o; ++c)gi[l.Z](g, m, b, h, f, d, n), g = f, m = d, d += n, h += n;
                        else for(c = 0; c < o; ++c)r(f, d, b, h, n), g = f, m = d, d += n, h += n;
                        t.rc = g, t.Vc = m;
                    } else {
                        if (e(null != l.mc), n = i + o, e(null != (c = l.mc)), e(n <= c.i), c.C >= n) n = 1;
                        else if (l.ic || mn(), l.ic) {
                            l = c.V, g = c.Ba, m = c.c;
                            var y = c.i, w = (b = 1, h = c.$ / m, f = c.$ % m, d = c.m, p = c.s, c.$), N = m * y, L = m * n, A = p.wc, _ = w < L ? wt(p, f, h) : null;
                            e(w <= N), e(n <= y), e(xt(p));
                            e: for(;;){
                                for(; !d.h && w < L;){
                                    if (f & A || (_ = wt(p, f, h)), e(null != _), S(d), 256 > (y = bt(_.G[0], _.H[0], d))) l[g + w] = y, ++w, ++f >= m && (f = 0, ++h <= n && !(h % 16) && St(c, h));
                                    else {
                                        if (!(280 > y)) {
                                            b = 0;
                                            break e;
                                        }
                                        y = mt(y - 256, d);
                                        var P, k = bt(_.G[4], _.H[4], d);
                                        if (S(d), !(w >= (k = vt(m, k = mt(k, d))) && N - w >= y)) {
                                            b = 0;
                                            break e;
                                        }
                                        for(P = 0; P < y; ++P)l[g + w + P] = l[g + w + P - k];
                                        for(w += y, f += y; f >= m;)f -= m, ++h <= n && !(h % 16) && St(c, h);
                                        w < L && f & A && (_ = wt(p, f, h));
                                    }
                                    e(d.h == x(d));
                                }
                                St(c, h > n ? n : h);
                                break e;
                            }
                            !b || d.h && w < N ? (b = 0, c.a = d.h ? 5 : 3) : c.$ = w, n = b;
                        } else n = _t(c, c.V, c.Ba, c.c, c.i, n, jt);
                        if (!n) {
                            o = 0;
                            break t;
                        }
                    }
                    i + o >= u && (t.Cc = 1), o = 1;
                }
                if (!o) return null;
                if (t.Cc && (null != (o = t.ga) && (o.mc = null), t.ga = null, 0 < t.Ga)) return alert("todo:WebPDequantizeLevels"), null;
            }
            return t.nb + i * s;
        }
        function fn(t, e, n, r, i, a) {
            for(; 0 < i--;){
                var o, s = t, u = e + (n ? 1 : 0), c = t, l = e + (n ? 0 : 3);
                for(o = 0; o < r; ++o){
                    var h = c[l + 4 * o];
                    255 != h && (h *= 32897, s[u + 4 * o + 0] = s[u + 4 * o + 0] * h >> 23, s[u + 4 * o + 1] = s[u + 4 * o + 1] * h >> 23, s[u + 4 * o + 2] = s[u + 4 * o + 2] * h >> 23);
                }
                e += a;
            }
        }
        function dn(t, e, n, r, i) {
            for(; 0 < r--;){
                var a;
                for(a = 0; a < n; ++a){
                    var o = t[e + 2 * a + 0], s = 15 & (c = t[e + 2 * a + 1]), u = 4369 * s, c = (240 & c | c >> 4) * u >> 16;
                    t[e + 2 * a + 0] = (240 & o | o >> 4) * u >> 16 & 240 | (15 & o | o << 4) * u >> 16 >> 4 & 15, t[e + 2 * a + 1] = 240 & c | s;
                }
                e += i;
            }
        }
        function pn(t, e, n, r, i, a, o, s) {
            var u, c, l = 255;
            for(c = 0; c < i; ++c){
                for(u = 0; u < r; ++u){
                    var h = t[e + u];
                    a[o + 4 * u] = h, l &= h;
                }
                e += n, o += s;
            }
            return 255 != l;
        }
        function gn(t, e, n, r, i) {
            var a;
            for(a = 0; a < i; ++a)n[r + a] = t[e + a] >> 8;
        }
        function mn() {
            Lr = fn, xr = dn, Ar = pn, Sr = gn;
        }
        function vn(n, r, i) {
            t[n] = function(t, n, a, o, s, u, c, l, h, f, d, p, g, m, v, b, y) {
                var w, N = y - 1 >> 1, L = s[u + 0] | c[l + 0] << 16, x = h[f + 0] | d[p + 0] << 16;
                e(null != t);
                var A = 3 * L + x + 131074 >> 2;
                for(r(t[n + 0], 255 & A, A >> 16, g, m), null != a && (A = 3 * x + L + 131074 >> 2, r(a[o + 0], 255 & A, A >> 16, v, b)), w = 1; w <= N; ++w){
                    var S = s[u + w] | c[l + w] << 16, _ = h[f + w] | d[p + w] << 16, P = L + S + x + _ + 524296, k = P + 2 * (S + x) >> 3;
                    A = k + L >> 1, L = (P = P + 2 * (L + _) >> 3) + S >> 1, r(t[n + 2 * w - 1], 255 & A, A >> 16, g, m + (2 * w - 1) * i), r(t[n + 2 * w - 0], 255 & L, L >> 16, g, m + (2 * w - 0) * i), null != a && (A = P + x >> 1, L = k + _ >> 1, r(a[o + 2 * w - 1], 255 & A, A >> 16, v, b + (2 * w - 1) * i), r(a[o + 2 * w + 0], 255 & L, L >> 16, v, b + (2 * w + 0) * i)), L = S, x = _;
                }
                1 & y || (A = 3 * L + x + 131074 >> 2, r(t[n + y - 1], 255 & A, A >> 16, g, m + (y - 1) * i), null != a && (A = 3 * x + L + 131074 >> 2, r(a[o + y - 1], 255 & A, A >> 16, v, b + (y - 1) * i)));
            };
        }
        function bn() {
            mi[Mr] = vi, mi[qr] = yi, mi[Er] = bi, mi[Rr] = wi, mi[Dr] = Ni, mi[Tr] = Li, mi[zr] = xi, mi[Ur] = yi, mi[Hr] = wi, mi[Wr] = Ni, mi[Vr] = Li;
        }
        function yn(t) {
            return t & ~Fi ? 0 > t ? 0 : 255 : t >> ki;
        }
        function wn(t, e) {
            return yn((19077 * t >> 8) + (26149 * e >> 8) - 14234);
        }
        function Nn(t, e, n) {
            return yn((19077 * t >> 8) - (6419 * e >> 8) - (13320 * n >> 8) + 8708);
        }
        function Ln(t, e) {
            return yn((19077 * t >> 8) + (33050 * e >> 8) - 17685);
        }
        function xn(t, e, n, r, i) {
            r[i + 0] = wn(t, n), r[i + 1] = Nn(t, e, n), r[i + 2] = Ln(t, e);
        }
        function An(t, e, n, r, i) {
            r[i + 0] = Ln(t, e), r[i + 1] = Nn(t, e, n), r[i + 2] = wn(t, n);
        }
        function Sn(t, e, n, r, i) {
            var a = Nn(t, e, n);
            e = a << 3 & 224 | Ln(t, e) >> 3, r[i + 0] = 248 & wn(t, n) | a >> 5, r[i + 1] = e;
        }
        function _n(t, e, n, r, i) {
            var a = 240 & Ln(t, e) | 15;
            r[i + 0] = 240 & wn(t, n) | Nn(t, e, n) >> 4, r[i + 1] = a;
        }
        function Pn(t, e, n, r, i) {
            r[i + 0] = 255, xn(t, e, n, r, i + 1);
        }
        function kn(t, e, n, r, i) {
            An(t, e, n, r, i), r[i + 3] = 255;
        }
        function Fn(t, e, n, r, i) {
            xn(t, e, n, r, i), r[i + 3] = 255;
        }
        function In(e, n, r) {
            t[e] = function(t, e, i, a, o, s, u, c, l) {
                for(var h = c + (-2 & l) * r; c != h;)n(t[e + 0], i[a + 0], o[s + 0], u, c), n(t[e + 1], i[a + 0], o[s + 0], u, c + r), e += 2, ++a, ++s, c += 2 * r;
                1 & l && n(t[e + 0], i[a + 0], o[s + 0], u, c);
            };
        }
        function jn(t, e, n) {
            return 0 == n ? 0 == t ? 0 == e ? 6 : 5 : 0 == e ? 4 : 0 : n;
        }
        function Cn(t, e, n, r, i) {
            switch(t >>> 30){
                case 3:
                    ar(e, n, r, i, 0);
                    break;
                case 2:
                    or(e, n, r, i);
                    break;
                case 1:
                    ur(e, n, r, i);
            }
        }
        function On(t, e) {
            var n, a, o = e.M, s = e.Nb, u = t.oc, c = t.pc + 40, l = t.oc, h = t.pc + 584, f = t.oc, d = t.pc + 600;
            for(n = 0; 16 > n; ++n)u[c + 32 * n - 1] = 129;
            for(n = 0; 8 > n; ++n)l[h + 32 * n - 1] = 129, f[d + 32 * n - 1] = 129;
            for(0 < o ? u[c - 1 - 32] = l[h - 1 - 32] = f[d - 1 - 32] = 129 : (i(u, c - 32 - 1, 127, 21), i(l, h - 32 - 1, 127, 9), i(f, d - 32 - 1, 127, 9)), a = 0; a < t.za; ++a){
                var p = e.ya[e.aa + a];
                if (0 < a) {
                    for(n = -1; 16 > n; ++n)r(u, c + 32 * n - 4, u, c + 32 * n + 12, 4);
                    for(n = -1; 8 > n; ++n)r(l, h + 32 * n - 4, l, h + 32 * n + 4, 4), r(f, d + 32 * n - 4, f, d + 32 * n + 4, 4);
                }
                var g = t.Gd, m = t.Hd + a, v = p.ad, b = p.Hc;
                if (0 < o && (r(u, c - 32, g[m].y, 0, 16), r(l, h - 32, g[m].f, 0, 8), r(f, d - 32, g[m].ea, 0, 8)), p.Za) {
                    var y = u, w = c - 32 + 16;
                    for(0 < o && (a >= t.za - 1 ? i(y, w, g[m].y[15], 4) : r(y, w, g[m + 1].y, 0, 4)), n = 0; 4 > n; n++)y[w + 128 + n] = y[w + 256 + n] = y[w + 384 + n] = y[w + 0 + n];
                    for(n = 0; 16 > n; ++n, b <<= 2)y = u, w = c + Ei[n], hi[p.Ob[n]](y, w), Cn(b, v, 16 * +n, y, w);
                } else if (y = jn(a, o, p.Ob[0]), li[y](u, c), 0 != b) for(n = 0; 16 > n; ++n, b <<= 2)Cn(b, v, 16 * +n, u, c + Ei[n]);
                for(n = p.Gc, y = jn(a, o, p.Dd), fi[y](l, h), fi[y](f, d), b = v, y = l, w = h, 255 & (p = 0 | n) && (170 & p ? sr(b, 256, y, w) : cr(b, 256, y, w)), p = f, b = d, 255 & (n >>= 8) && (170 & n ? sr(v, 320, p, b) : cr(v, 320, p, b)), o < t.Ub - 1 && (r(g[m].y, 0, u, c + 480, 16), r(g[m].f, 0, l, h + 224, 8), r(g[m].ea, 0, f, d + 224, 8)), n = 8 * s * t.B, g = t.sa, m = t.ta + 16 * a + 16 * s * t.R, v = t.qa, p = t.ra + 8 * a + n, b = t.Ha, y = t.Ia + 8 * a + n, n = 0; 16 > n; ++n)r(g, m + n * t.R, u, c + 32 * n, 16);
                for(n = 0; 8 > n; ++n)r(v, p + n * t.B, l, h + 32 * n, 8), r(b, y + n * t.B, f, d + 32 * n, 8);
            }
        }
        function Bn(t, r, i, a, o, s, u, c, l) {
            var h = [
                0
            ], f = [
                0
            ], d = 0, p = null != l ? l.kd : 0, g = null != l ? l : new nn;
            if (null == t || 12 > i) return 7;
            g.data = t, g.w = r, g.ha = i, r = [
                r
            ], i = [
                i
            ], g.gb = [
                g.gb
            ];
            t: {
                var m = r, b = i, y = g.gb;
                if (e(null != t), e(null != b), e(null != y), y[0] = 0, 12 <= b[0] && !n(t, m[0], "RIFF")) {
                    if (n(t, m[0] + 8, "WEBP")) {
                        y = 3;
                        break t;
                    }
                    var w = C(t, m[0] + 4);
                    if (12 > w || 4294967286 < w) {
                        y = 3;
                        break t;
                    }
                    if (p && w > b[0] - 8) {
                        y = 7;
                        break t;
                    }
                    y[0] = w, m[0] += 12, b[0] -= 12;
                }
                y = 0;
            }
            if (0 != y) return y;
            for(w = 0 < g.gb[0], i = i[0];;){
                t: {
                    var L = t;
                    b = r, y = i;
                    var x = h, A = f, S = m = [
                        0
                    ];
                    if ((k = d = [
                        d
                    ])[0] = 0, 8 > y[0]) y = 7;
                    else {
                        if (!n(L, b[0], "VP8X")) {
                            if (10 != C(L, b[0] + 4)) {
                                y = 3;
                                break t;
                            }
                            if (18 > y[0]) {
                                y = 7;
                                break t;
                            }
                            var _ = C(L, b[0] + 8), P = 1 + j(L, b[0] + 12);
                            if (2147483648 <= P * (L = 1 + j(L, b[0] + 15))) {
                                y = 3;
                                break t;
                            }
                            null != S && (S[0] = _), null != x && (x[0] = P), null != A && (A[0] = L), b[0] += 18, y[0] -= 18, k[0] = 1;
                        }
                        y = 0;
                    }
                }
                if (d = d[0], m = m[0], 0 != y) return y;
                if (b = !!(2 & m), !w && d) return 3;
                if (null != s && (s[0] = !!(16 & m)), null != u && (u[0] = b), null != c && (c[0] = 0), u = h[0], m = f[0], d && b && null == l) {
                    y = 0;
                    break;
                }
                if (4 > i) {
                    y = 7;
                    break;
                }
                if (w && d || !w && !d && !n(t, r[0], "ALPH")) {
                    i = [
                        i
                    ], g.na = [
                        g.na
                    ], g.P = [
                        g.P
                    ], g.Sa = [
                        g.Sa
                    ];
                    t: {
                        _ = t, y = r, w = i;
                        var k = g.gb;
                        x = g.na, A = g.P, S = g.Sa, P = 22, e(null != _), e(null != w), L = y[0];
                        var F = w[0];
                        for(e(null != x), e(null != S), x[0] = null, A[0] = null, S[0] = 0;;){
                            if (y[0] = L, w[0] = F, 8 > F) {
                                y = 7;
                                break t;
                            }
                            var I = C(_, L + 4);
                            if (4294967286 < I) {
                                y = 3;
                                break t;
                            }
                            var O = 8 + I + 1 & -2;
                            if (P += O, 0 < k && P > k) {
                                y = 3;
                                break t;
                            }
                            if (!n(_, L, "VP8 ") || !n(_, L, "VP8L")) {
                                y = 0;
                                break t;
                            }
                            if (F[0] < O) {
                                y = 7;
                                break t;
                            }
                            n(_, L, "ALPH") || (x[0] = _, A[0] = L + 8, S[0] = I), L += O, F -= O;
                        }
                    }
                    if (i = i[0], g.na = g.na[0], g.P = g.P[0], g.Sa = g.Sa[0], 0 != y) break;
                }
                i = [
                    i
                ], g.Ja = [
                    g.Ja
                ], g.xa = [
                    g.xa
                ];
                t: if (k = t, y = r, w = i, x = g.gb[0], A = g.Ja, S = g.xa, _ = y[0], L = !n(k, _, "VP8 "), P = !n(k, _, "VP8L"), e(null != k), e(null != w), e(null != A), e(null != S), 8 > w[0]) y = 7;
                else {
                    if (L || P) {
                        if (k = C(k, _ + 4), 12 <= x && k > x - 12) {
                            y = 3;
                            break t;
                        }
                        if (p && k > w[0] - 8) {
                            y = 7;
                            break t;
                        }
                        A[0] = k, y[0] += 8, w[0] -= 8, S[0] = P;
                    } else S[0] = 5 <= w[0] && 47 == k[_ + 0] && !(k[_ + 4] >> 5), A[0] = w[0];
                    y = 0;
                }
                if (i = i[0], g.Ja = g.Ja[0], g.xa = g.xa[0], r = r[0], 0 != y) break;
                if (4294967286 < g.Ja) return 3;
                if (null == c || b || (c[0] = g.xa ? 2 : 1), u = [
                    u
                ], m = [
                    m
                ], g.xa) {
                    if (5 > i) {
                        y = 7;
                        break;
                    }
                    c = u, p = m, b = s, null == t || 5 > i ? t = 0 : 5 <= i && 47 == t[r + 0] && !(t[r + 4] >> 5) ? (w = [
                        0
                    ], k = [
                        0
                    ], x = [
                        0
                    ], v(A = new N, t, r, i), gt(A, w, k, x) ? (null != c && (c[0] = w[0]), null != p && (p[0] = k[0]), null != b && (b[0] = x[0]), t = 1) : t = 0) : t = 0;
                } else {
                    if (10 > i) {
                        y = 7;
                        break;
                    }
                    c = m, null == t || 10 > i || !Xt(t, r + 3, i - 3) ? t = 0 : (p = t[r + 0] | t[r + 1] << 8 | t[r + 2] << 16, b = 16383 & (t[r + 7] << 8 | t[r + 6]), t = 16383 & (t[r + 9] << 8 | t[r + 8]), 1 & p || 3 < (p >> 1 & 7) || !(p >> 4 & 1) || p >> 5 >= g.Ja || !b || !t ? t = 0 : (u && (u[0] = b), c && (c[0] = t), t = 1));
                }
                if (!t) return 3;
                if (u = u[0], m = m[0], d && (h[0] != u || f[0] != m)) return 3;
                null != l && (l[0] = g, l.offset = r - l.w, e(4294967286 > r - l.w), e(l.offset == l.ha - i));
                break;
            }
            return 0 == y || 7 == y && d && null == l ? (null != s && (s[0] |= null != g.na && 0 < g.na.length), null != a && (a[0] = u), null != o && (o[0] = m), 0) : y;
        }
        function Mn(t, e, n) {
            var r = e.width, i = e.height, a = 0, o = 0, s = r, u = i;
            if (e.Da = null != t && 0 < t.Da, e.Da && (s = t.cd, u = t.bd, a = t.v, o = t.j, 11 > n || (a &= -2, o &= -2), 0 > a || 0 > o || 0 >= s || 0 >= u || a + s > r || o + u > i)) return 0;
            if (e.v = a, e.j = o, e.va = a + s, e.o = o + u, e.U = s, e.T = u, e.da = null != t && 0 < t.da, e.da) {
                if (!q(s, u, n = [
                    t.ib
                ], a = [
                    t.hb
                ])) return 0;
                e.ib = n[0], e.hb = a[0];
            }
            return e.ob = null != t && t.ob, e.Kb = null == t || !t.Sd, e.da && (e.ob = e.ib < 3 * r / 4 && e.hb < 3 * i / 4, e.Kb = 0), 1;
        }
        function qn(t) {
            if (null == t) return 2;
            if (11 > t.S) {
                var e = t.f.RGBA;
                e.fb += (t.height - 1) * e.A, e.A = -e.A;
            } else e = t.f.kb, t = t.height, e.O += (t - 1) * e.fa, e.fa = -e.fa, e.N += (t - 1 >> 1) * e.Ab, e.Ab = -e.Ab, e.W += (t - 1 >> 1) * e.Db, e.Db = -e.Db, null != e.F && (e.J += (t - 1) * e.lb, e.lb = -e.lb);
            return 0;
        }
        function En(t, e, n, r) {
            if (null == r || 0 >= t || 0 >= e) return 2;
            if (null != n) {
                if (n.Da) {
                    var i = n.cd, o = n.bd, s = -2 & n.v, u = -2 & n.j;
                    if (0 > s || 0 > u || 0 >= i || 0 >= o || s + i > t || u + o > e) return 2;
                    t = i, e = o;
                }
                if (n.da) {
                    if (!q(t, e, i = [
                        n.ib
                    ], o = [
                        n.hb
                    ])) return 2;
                    t = i[0], e = o[0];
                }
            }
            r.width = t, r.height = e;
            t: {
                var c = r.width, l = r.height;
                if (t = r.S, 0 >= c || 0 >= l || !(t >= Mr && 13 > t)) t = 2;
                else {
                    if (0 >= r.Rd && null == r.sd) {
                        s = o = i = e = 0;
                        var h = (u = c * zi[t]) * l;
                        if (11 > t || (o = (l + 1) / 2 * (e = (c + 1) / 2), 12 == t && (s = (i = c) * l)), null == (l = a(h + 2 * o + s))) {
                            t = 1;
                            break t;
                        }
                        r.sd = l, 11 > t ? ((c = r.f.RGBA).eb = l, c.fb = 0, c.A = u, c.size = h) : ((c = r.f.kb).y = l, c.O = 0, c.fa = u, c.Fd = h, c.f = l, c.N = 0 + h, c.Ab = e, c.Cd = o, c.ea = l, c.W = 0 + h + o, c.Db = e, c.Ed = o, 12 == t && (c.F = l, c.J = 0 + h + 2 * o), c.Tc = s, c.lb = i);
                    }
                    if (e = 1, i = r.S, o = r.width, s = r.height, i >= Mr && 13 > i) {
                        if (11 > i) t = r.f.RGBA, e &= (u = Math.abs(t.A)) * (s - 1) + o <= t.size, e &= u >= o * zi[i], e &= null != t.eb;
                        else {
                            t = r.f.kb, u = (o + 1) / 2, h = (s + 1) / 2, c = Math.abs(t.fa), l = Math.abs(t.Ab);
                            var f = Math.abs(t.Db), d = Math.abs(t.lb), p = d * (s - 1) + o;
                            e &= c * (s - 1) + o <= t.Fd, e &= l * (h - 1) + u <= t.Cd, e = (e &= f * (h - 1) + u <= t.Ed) & c >= o & l >= u & f >= u, e &= null != t.y, e &= null != t.f, e &= null != t.ea, 12 == i && (e &= d >= o, e &= p <= t.Tc, e &= null != t.F);
                        }
                    } else e = 0;
                    t = e ? 0 : 2;
                }
            }
            return 0 != t || null != n && n.fd && (t = qn(r)), t;
        }
        var Rn = 64, Dn = [
            0,
            1,
            3,
            7,
            15,
            31,
            63,
            127,
            255,
            511,
            1023,
            2047,
            4095,
            8191,
            16383,
            32767,
            65535,
            131071,
            262143,
            524287,
            1048575,
            2097151,
            4194303,
            8388607,
            16777215
        ], Tn = 24, zn = 32, Un = 8, Hn = [
            0,
            0,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7
        ];
        D("Predictor0", "PredictorAdd0"), t.Predictor0 = function() {
            return 4278190080;
        }, t.Predictor1 = function(t) {
            return t;
        }, t.Predictor2 = function(t, e, n) {
            return e[n + 0];
        }, t.Predictor3 = function(t, e, n) {
            return e[n + 1];
        }, t.Predictor4 = function(t, e, n) {
            return e[n - 1];
        }, t.Predictor5 = function(t, e, n) {
            return z(z(t, e[n + 1]), e[n + 0]);
        }, t.Predictor6 = function(t, e, n) {
            return z(t, e[n - 1]);
        }, t.Predictor7 = function(t, e, n) {
            return z(t, e[n + 0]);
        }, t.Predictor8 = function(t, e, n) {
            return z(e[n - 1], e[n + 0]);
        }, t.Predictor9 = function(t, e, n) {
            return z(e[n + 0], e[n + 1]);
        }, t.Predictor10 = function(t, e, n) {
            return z(z(t, e[n - 1]), z(e[n + 0], e[n + 1]));
        }, t.Predictor11 = function(t, e, n) {
            var r = e[n + 0];
            return 0 >= W(r >> 24 & 255, t >> 24 & 255, (e = e[n - 1]) >> 24 & 255) + W(r >> 16 & 255, t >> 16 & 255, e >> 16 & 255) + W(r >> 8 & 255, t >> 8 & 255, e >> 8 & 255) + W(255 & r, 255 & t, 255 & e) ? r : t;
        }, t.Predictor12 = function(t, e, n) {
            var r = e[n + 0];
            return (U((t >> 24 & 255) + (r >> 24 & 255) - ((e = e[n - 1]) >> 24 & 255)) << 24 | U((t >> 16 & 255) + (r >> 16 & 255) - (e >> 16 & 255)) << 16 | U((t >> 8 & 255) + (r >> 8 & 255) - (e >> 8 & 255)) << 8 | U((255 & t) + (255 & r) - (255 & e))) >>> 0;
        }, t.Predictor13 = function(t, e, n) {
            var r = e[n - 1];
            return (H((t = z(t, e[n + 0])) >> 24 & 255, r >> 24 & 255) << 24 | H(t >> 16 & 255, r >> 16 & 255) << 16 | H(t >> 8 & 255, r >> 8 & 255) << 8 | H(255 & t, 255 & r)) >>> 0;
        };
        var Wn = t.PredictorAdd0;
        t.PredictorAdd1 = V, D("Predictor2", "PredictorAdd2"), D("Predictor3", "PredictorAdd3"), D("Predictor4", "PredictorAdd4"), D("Predictor5", "PredictorAdd5"), D("Predictor6", "PredictorAdd6"), D("Predictor7", "PredictorAdd7"), D("Predictor8", "PredictorAdd8"), D("Predictor9", "PredictorAdd9"), D("Predictor10", "PredictorAdd10"), D("Predictor11", "PredictorAdd11"), D("Predictor12", "PredictorAdd12"), D("Predictor13", "PredictorAdd13");
        var Vn = t.PredictorAdd2;
        X("ColorIndexInverseTransform", "MapARGB", "32b", function(t) {
            return t >> 8 & 255;
        }, function(t) {
            return t;
        }), X("VP8LColorIndexInverseTransformAlpha", "MapAlpha", "8b", function(t) {
            return t;
        }, function(t) {
            return t >> 8 & 255;
        });
        var Gn, Yn = t.ColorIndexInverseTransform, Jn = t.MapARGB, Xn = t.VP8LColorIndexInverseTransformAlpha, Kn = t.MapAlpha, Zn = t.VP8LPredictorsAdd = [];
        Zn.length = 16, (t.VP8LPredictors = []).length = 16, (t.VP8LPredictorsAdd_C = []).length = 16, (t.VP8LPredictors_C = []).length = 16;
        var $n, Qn, tr, er, nr, rr, ir, ar, or, sr, ur, cr, lr, hr, fr, dr, pr, gr, mr, vr, br, yr, wr, Nr, Lr, xr, Ar, Sr, _r = a(511), Pr = a(2041), kr = a(225), Fr = a(767), Ir = 0, jr = Pr, Cr = kr, Or = Fr, Br = _r, Mr = 0, qr = 1, Er = 2, Rr = 3, Dr = 4, Tr = 5, zr = 6, Ur = 7, Hr = 8, Wr = 9, Vr = 10, Gr = [
            2,
            3,
            7
        ], Yr = [
            3,
            3,
            11
        ], Jr = [
            280,
            256,
            256,
            256,
            40
        ], Xr = [
            0,
            1,
            1,
            1,
            0
        ], Kr = [
            17,
            18,
            0,
            1,
            2,
            3,
            4,
            5,
            16,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15
        ], Zr = [
            24,
            7,
            23,
            25,
            40,
            6,
            39,
            41,
            22,
            26,
            38,
            42,
            56,
            5,
            55,
            57,
            21,
            27,
            54,
            58,
            37,
            43,
            72,
            4,
            71,
            73,
            20,
            28,
            53,
            59,
            70,
            74,
            36,
            44,
            88,
            69,
            75,
            52,
            60,
            3,
            87,
            89,
            19,
            29,
            86,
            90,
            35,
            45,
            68,
            76,
            85,
            91,
            51,
            61,
            104,
            2,
            103,
            105,
            18,
            30,
            102,
            106,
            34,
            46,
            84,
            92,
            67,
            77,
            101,
            107,
            50,
            62,
            120,
            1,
            119,
            121,
            83,
            93,
            17,
            31,
            100,
            108,
            66,
            78,
            118,
            122,
            33,
            47,
            117,
            123,
            49,
            63,
            99,
            109,
            82,
            94,
            0,
            116,
            124,
            65,
            79,
            16,
            32,
            98,
            110,
            48,
            115,
            125,
            81,
            95,
            64,
            114,
            126,
            97,
            111,
            80,
            113,
            127,
            96,
            112
        ], $r = [
            2954,
            2956,
            2958,
            2962,
            2970,
            2986,
            3018,
            3082,
            3212,
            3468,
            3980,
            5004
        ], Qr = 8, ti = [
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            17,
            18,
            19,
            20,
            20,
            21,
            21,
            22,
            22,
            23,
            23,
            24,
            25,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            91,
            93,
            95,
            96,
            98,
            100,
            101,
            102,
            104,
            106,
            108,
            110,
            112,
            114,
            116,
            118,
            122,
            124,
            126,
            128,
            130,
            132,
            134,
            136,
            138,
            140,
            143,
            145,
            148,
            151,
            154,
            157
        ], ei = [
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            60,
            62,
            64,
            66,
            68,
            70,
            72,
            74,
            76,
            78,
            80,
            82,
            84,
            86,
            88,
            90,
            92,
            94,
            96,
            98,
            100,
            102,
            104,
            106,
            108,
            110,
            112,
            114,
            116,
            119,
            122,
            125,
            128,
            131,
            134,
            137,
            140,
            143,
            146,
            149,
            152,
            155,
            158,
            161,
            164,
            167,
            170,
            173,
            177,
            181,
            185,
            189,
            193,
            197,
            201,
            205,
            209,
            213,
            217,
            221,
            225,
            229,
            234,
            239,
            245,
            249,
            254,
            259,
            264,
            269,
            274,
            279,
            284
        ], ni = null, ri = [
            [
                173,
                148,
                140,
                0
            ],
            [
                176,
                155,
                140,
                135,
                0
            ],
            [
                180,
                157,
                141,
                134,
                130,
                0
            ],
            [
                254,
                254,
                243,
                230,
                196,
                177,
                153,
                140,
                133,
                130,
                129,
                0
            ]
        ], ii = [
            0,
            1,
            4,
            8,
            5,
            2,
            3,
            6,
            9,
            12,
            13,
            10,
            7,
            11,
            14,
            15
        ], ai = [
            -0,
            1,
            -1,
            2,
            -2,
            3,
            4,
            6,
            -3,
            5,
            -4,
            -5,
            -6,
            7,
            -7,
            8,
            -8,
            -9
        ], oi = [
            [
                [
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        253,
                        136,
                        254,
                        255,
                        228,
                        219,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        189,
                        129,
                        242,
                        255,
                        227,
                        213,
                        255,
                        219,
                        128,
                        128,
                        128
                    ],
                    [
                        106,
                        126,
                        227,
                        252,
                        214,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        98,
                        248,
                        255,
                        236,
                        226,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        181,
                        133,
                        238,
                        254,
                        221,
                        234,
                        255,
                        154,
                        128,
                        128,
                        128
                    ],
                    [
                        78,
                        134,
                        202,
                        247,
                        198,
                        180,
                        255,
                        219,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        185,
                        249,
                        255,
                        243,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        184,
                        150,
                        247,
                        255,
                        236,
                        224,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        77,
                        110,
                        216,
                        255,
                        236,
                        230,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        101,
                        251,
                        255,
                        241,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        170,
                        139,
                        241,
                        252,
                        236,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        37,
                        116,
                        196,
                        243,
                        228,
                        255,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        204,
                        254,
                        255,
                        245,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        207,
                        160,
                        250,
                        255,
                        238,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        102,
                        103,
                        231,
                        255,
                        211,
                        171,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        152,
                        252,
                        255,
                        240,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        177,
                        135,
                        243,
                        255,
                        234,
                        225,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        80,
                        129,
                        211,
                        255,
                        194,
                        224,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        246,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        198,
                        35,
                        237,
                        223,
                        193,
                        187,
                        162,
                        160,
                        145,
                        155,
                        62
                    ],
                    [
                        131,
                        45,
                        198,
                        221,
                        172,
                        176,
                        220,
                        157,
                        252,
                        221,
                        1
                    ],
                    [
                        68,
                        47,
                        146,
                        208,
                        149,
                        167,
                        221,
                        162,
                        255,
                        223,
                        128
                    ]
                ],
                [
                    [
                        1,
                        149,
                        241,
                        255,
                        221,
                        224,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        184,
                        141,
                        234,
                        253,
                        222,
                        220,
                        255,
                        199,
                        128,
                        128,
                        128
                    ],
                    [
                        81,
                        99,
                        181,
                        242,
                        176,
                        190,
                        249,
                        202,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        129,
                        232,
                        253,
                        214,
                        197,
                        242,
                        196,
                        255,
                        255,
                        128
                    ],
                    [
                        99,
                        121,
                        210,
                        250,
                        201,
                        198,
                        255,
                        202,
                        128,
                        128,
                        128
                    ],
                    [
                        23,
                        91,
                        163,
                        242,
                        170,
                        187,
                        247,
                        210,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        200,
                        246,
                        255,
                        234,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        109,
                        178,
                        241,
                        255,
                        231,
                        245,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        44,
                        130,
                        201,
                        253,
                        205,
                        192,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        132,
                        239,
                        251,
                        219,
                        209,
                        255,
                        165,
                        128,
                        128,
                        128
                    ],
                    [
                        94,
                        136,
                        225,
                        251,
                        218,
                        190,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        22,
                        100,
                        174,
                        245,
                        186,
                        161,
                        255,
                        199,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        182,
                        249,
                        255,
                        232,
                        235,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        124,
                        143,
                        241,
                        255,
                        227,
                        234,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        35,
                        77,
                        181,
                        251,
                        193,
                        211,
                        255,
                        205,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        157,
                        247,
                        255,
                        236,
                        231,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        121,
                        141,
                        235,
                        255,
                        225,
                        227,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        45,
                        99,
                        188,
                        251,
                        195,
                        217,
                        255,
                        224,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        251,
                        255,
                        213,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        203,
                        1,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        137,
                        1,
                        177,
                        255,
                        224,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        253,
                        9,
                        248,
                        251,
                        207,
                        208,
                        255,
                        192,
                        128,
                        128,
                        128
                    ],
                    [
                        175,
                        13,
                        224,
                        243,
                        193,
                        185,
                        249,
                        198,
                        255,
                        255,
                        128
                    ],
                    [
                        73,
                        17,
                        171,
                        221,
                        161,
                        179,
                        236,
                        167,
                        255,
                        234,
                        128
                    ]
                ],
                [
                    [
                        1,
                        95,
                        247,
                        253,
                        212,
                        183,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        239,
                        90,
                        244,
                        250,
                        211,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        155,
                        77,
                        195,
                        248,
                        188,
                        195,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        24,
                        239,
                        251,
                        218,
                        219,
                        255,
                        205,
                        128,
                        128,
                        128
                    ],
                    [
                        201,
                        51,
                        219,
                        255,
                        196,
                        186,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        69,
                        46,
                        190,
                        239,
                        201,
                        218,
                        255,
                        228,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        191,
                        251,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        223,
                        165,
                        249,
                        255,
                        213,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        141,
                        124,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        16,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        190,
                        36,
                        230,
                        255,
                        236,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        149,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        226,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        247,
                        192,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        240,
                        128,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        134,
                        252,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        213,
                        62,
                        250,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        55,
                        93,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        202,
                        24,
                        213,
                        235,
                        186,
                        191,
                        220,
                        160,
                        240,
                        175,
                        255
                    ],
                    [
                        126,
                        38,
                        182,
                        232,
                        169,
                        184,
                        228,
                        174,
                        255,
                        187,
                        128
                    ],
                    [
                        61,
                        46,
                        138,
                        219,
                        151,
                        178,
                        240,
                        170,
                        255,
                        216,
                        128
                    ]
                ],
                [
                    [
                        1,
                        112,
                        230,
                        250,
                        199,
                        191,
                        247,
                        159,
                        255,
                        255,
                        128
                    ],
                    [
                        166,
                        109,
                        228,
                        252,
                        211,
                        215,
                        255,
                        174,
                        128,
                        128,
                        128
                    ],
                    [
                        39,
                        77,
                        162,
                        232,
                        172,
                        180,
                        245,
                        178,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        52,
                        220,
                        246,
                        198,
                        199,
                        249,
                        220,
                        255,
                        255,
                        128
                    ],
                    [
                        124,
                        74,
                        191,
                        243,
                        183,
                        193,
                        250,
                        221,
                        255,
                        255,
                        128
                    ],
                    [
                        24,
                        71,
                        130,
                        219,
                        154,
                        170,
                        243,
                        182,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        182,
                        225,
                        249,
                        219,
                        240,
                        255,
                        224,
                        128,
                        128,
                        128
                    ],
                    [
                        149,
                        150,
                        226,
                        252,
                        216,
                        205,
                        255,
                        171,
                        128,
                        128,
                        128
                    ],
                    [
                        28,
                        108,
                        170,
                        242,
                        183,
                        194,
                        254,
                        223,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        81,
                        230,
                        252,
                        204,
                        203,
                        255,
                        192,
                        128,
                        128,
                        128
                    ],
                    [
                        123,
                        102,
                        209,
                        247,
                        188,
                        196,
                        255,
                        233,
                        128,
                        128,
                        128
                    ],
                    [
                        20,
                        95,
                        153,
                        243,
                        164,
                        173,
                        255,
                        203,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        222,
                        248,
                        255,
                        216,
                        213,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        168,
                        175,
                        246,
                        252,
                        235,
                        205,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        47,
                        116,
                        215,
                        255,
                        211,
                        212,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        121,
                        236,
                        253,
                        212,
                        214,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        141,
                        84,
                        213,
                        252,
                        201,
                        202,
                        255,
                        219,
                        128,
                        128,
                        128
                    ],
                    [
                        42,
                        80,
                        160,
                        240,
                        162,
                        185,
                        255,
                        205,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        244,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        238,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ]
        ], si = [
            [
                [
                    231,
                    120,
                    48,
                    89,
                    115,
                    113,
                    120,
                    152,
                    112
                ],
                [
                    152,
                    179,
                    64,
                    126,
                    170,
                    118,
                    46,
                    70,
                    95
                ],
                [
                    175,
                    69,
                    143,
                    80,
                    85,
                    82,
                    72,
                    155,
                    103
                ],
                [
                    56,
                    58,
                    10,
                    171,
                    218,
                    189,
                    17,
                    13,
                    152
                ],
                [
                    114,
                    26,
                    17,
                    163,
                    44,
                    195,
                    21,
                    10,
                    173
                ],
                [
                    121,
                    24,
                    80,
                    195,
                    26,
                    62,
                    44,
                    64,
                    85
                ],
                [
                    144,
                    71,
                    10,
                    38,
                    171,
                    213,
                    144,
                    34,
                    26
                ],
                [
                    170,
                    46,
                    55,
                    19,
                    136,
                    160,
                    33,
                    206,
                    71
                ],
                [
                    63,
                    20,
                    8,
                    114,
                    114,
                    208,
                    12,
                    9,
                    226
                ],
                [
                    81,
                    40,
                    11,
                    96,
                    182,
                    84,
                    29,
                    16,
                    36
                ]
            ],
            [
                [
                    134,
                    183,
                    89,
                    137,
                    98,
                    101,
                    106,
                    165,
                    148
                ],
                [
                    72,
                    187,
                    100,
                    130,
                    157,
                    111,
                    32,
                    75,
                    80
                ],
                [
                    66,
                    102,
                    167,
                    99,
                    74,
                    62,
                    40,
                    234,
                    128
                ],
                [
                    41,
                    53,
                    9,
                    178,
                    241,
                    141,
                    26,
                    8,
                    107
                ],
                [
                    74,
                    43,
                    26,
                    146,
                    73,
                    166,
                    49,
                    23,
                    157
                ],
                [
                    65,
                    38,
                    105,
                    160,
                    51,
                    52,
                    31,
                    115,
                    128
                ],
                [
                    104,
                    79,
                    12,
                    27,
                    217,
                    255,
                    87,
                    17,
                    7
                ],
                [
                    87,
                    68,
                    71,
                    44,
                    114,
                    51,
                    15,
                    186,
                    23
                ],
                [
                    47,
                    41,
                    14,
                    110,
                    182,
                    183,
                    21,
                    17,
                    194
                ],
                [
                    66,
                    45,
                    25,
                    102,
                    197,
                    189,
                    23,
                    18,
                    22
                ]
            ],
            [
                [
                    88,
                    88,
                    147,
                    150,
                    42,
                    46,
                    45,
                    196,
                    205
                ],
                [
                    43,
                    97,
                    183,
                    117,
                    85,
                    38,
                    35,
                    179,
                    61
                ],
                [
                    39,
                    53,
                    200,
                    87,
                    26,
                    21,
                    43,
                    232,
                    171
                ],
                [
                    56,
                    34,
                    51,
                    104,
                    114,
                    102,
                    29,
                    93,
                    77
                ],
                [
                    39,
                    28,
                    85,
                    171,
                    58,
                    165,
                    90,
                    98,
                    64
                ],
                [
                    34,
                    22,
                    116,
                    206,
                    23,
                    34,
                    43,
                    166,
                    73
                ],
                [
                    107,
                    54,
                    32,
                    26,
                    51,
                    1,
                    81,
                    43,
                    31
                ],
                [
                    68,
                    25,
                    106,
                    22,
                    64,
                    171,
                    36,
                    225,
                    114
                ],
                [
                    34,
                    19,
                    21,
                    102,
                    132,
                    188,
                    16,
                    76,
                    124
                ],
                [
                    62,
                    18,
                    78,
                    95,
                    85,
                    57,
                    50,
                    48,
                    51
                ]
            ],
            [
                [
                    193,
                    101,
                    35,
                    159,
                    215,
                    111,
                    89,
                    46,
                    111
                ],
                [
                    60,
                    148,
                    31,
                    172,
                    219,
                    228,
                    21,
                    18,
                    111
                ],
                [
                    112,
                    113,
                    77,
                    85,
                    179,
                    255,
                    38,
                    120,
                    114
                ],
                [
                    40,
                    42,
                    1,
                    196,
                    245,
                    209,
                    10,
                    25,
                    109
                ],
                [
                    88,
                    43,
                    29,
                    140,
                    166,
                    213,
                    37,
                    43,
                    154
                ],
                [
                    61,
                    63,
                    30,
                    155,
                    67,
                    45,
                    68,
                    1,
                    209
                ],
                [
                    100,
                    80,
                    8,
                    43,
                    154,
                    1,
                    51,
                    26,
                    71
                ],
                [
                    142,
                    78,
                    78,
                    16,
                    255,
                    128,
                    34,
                    197,
                    171
                ],
                [
                    41,
                    40,
                    5,
                    102,
                    211,
                    183,
                    4,
                    1,
                    221
                ],
                [
                    51,
                    50,
                    17,
                    168,
                    209,
                    192,
                    23,
                    25,
                    82
                ]
            ],
            [
                [
                    138,
                    31,
                    36,
                    171,
                    27,
                    166,
                    38,
                    44,
                    229
                ],
                [
                    67,
                    87,
                    58,
                    169,
                    82,
                    115,
                    26,
                    59,
                    179
                ],
                [
                    63,
                    59,
                    90,
                    180,
                    59,
                    166,
                    93,
                    73,
                    154
                ],
                [
                    40,
                    40,
                    21,
                    116,
                    143,
                    209,
                    34,
                    39,
                    175
                ],
                [
                    47,
                    15,
                    16,
                    183,
                    34,
                    223,
                    49,
                    45,
                    183
                ],
                [
                    46,
                    17,
                    33,
                    183,
                    6,
                    98,
                    15,
                    32,
                    183
                ],
                [
                    57,
                    46,
                    22,
                    24,
                    128,
                    1,
                    54,
                    17,
                    37
                ],
                [
                    65,
                    32,
                    73,
                    115,
                    28,
                    128,
                    23,
                    128,
                    205
                ],
                [
                    40,
                    3,
                    9,
                    115,
                    51,
                    192,
                    18,
                    6,
                    223
                ],
                [
                    87,
                    37,
                    9,
                    115,
                    59,
                    77,
                    64,
                    21,
                    47
                ]
            ],
            [
                [
                    104,
                    55,
                    44,
                    218,
                    9,
                    54,
                    53,
                    130,
                    226
                ],
                [
                    64,
                    90,
                    70,
                    205,
                    40,
                    41,
                    23,
                    26,
                    57
                ],
                [
                    54,
                    57,
                    112,
                    184,
                    5,
                    41,
                    38,
                    166,
                    213
                ],
                [
                    30,
                    34,
                    26,
                    133,
                    152,
                    116,
                    10,
                    32,
                    134
                ],
                [
                    39,
                    19,
                    53,
                    221,
                    26,
                    114,
                    32,
                    73,
                    255
                ],
                [
                    31,
                    9,
                    65,
                    234,
                    2,
                    15,
                    1,
                    118,
                    73
                ],
                [
                    75,
                    32,
                    12,
                    51,
                    192,
                    255,
                    160,
                    43,
                    51
                ],
                [
                    88,
                    31,
                    35,
                    67,
                    102,
                    85,
                    55,
                    186,
                    85
                ],
                [
                    56,
                    21,
                    23,
                    111,
                    59,
                    205,
                    45,
                    37,
                    192
                ],
                [
                    55,
                    38,
                    70,
                    124,
                    73,
                    102,
                    1,
                    34,
                    98
                ]
            ],
            [
                [
                    125,
                    98,
                    42,
                    88,
                    104,
                    85,
                    117,
                    175,
                    82
                ],
                [
                    95,
                    84,
                    53,
                    89,
                    128,
                    100,
                    113,
                    101,
                    45
                ],
                [
                    75,
                    79,
                    123,
                    47,
                    51,
                    128,
                    81,
                    171,
                    1
                ],
                [
                    57,
                    17,
                    5,
                    71,
                    102,
                    57,
                    53,
                    41,
                    49
                ],
                [
                    38,
                    33,
                    13,
                    121,
                    57,
                    73,
                    26,
                    1,
                    85
                ],
                [
                    41,
                    10,
                    67,
                    138,
                    77,
                    110,
                    90,
                    47,
                    114
                ],
                [
                    115,
                    21,
                    2,
                    10,
                    102,
                    255,
                    166,
                    23,
                    6
                ],
                [
                    101,
                    29,
                    16,
                    10,
                    85,
                    128,
                    101,
                    196,
                    26
                ],
                [
                    57,
                    18,
                    10,
                    102,
                    102,
                    213,
                    34,
                    20,
                    43
                ],
                [
                    117,
                    20,
                    15,
                    36,
                    163,
                    128,
                    68,
                    1,
                    26
                ]
            ],
            [
                [
                    102,
                    61,
                    71,
                    37,
                    34,
                    53,
                    31,
                    243,
                    192
                ],
                [
                    69,
                    60,
                    71,
                    38,
                    73,
                    119,
                    28,
                    222,
                    37
                ],
                [
                    68,
                    45,
                    128,
                    34,
                    1,
                    47,
                    11,
                    245,
                    171
                ],
                [
                    62,
                    17,
                    19,
                    70,
                    146,
                    85,
                    55,
                    62,
                    70
                ],
                [
                    37,
                    43,
                    37,
                    154,
                    100,
                    163,
                    85,
                    160,
                    1
                ],
                [
                    63,
                    9,
                    92,
                    136,
                    28,
                    64,
                    32,
                    201,
                    85
                ],
                [
                    75,
                    15,
                    9,
                    9,
                    64,
                    255,
                    184,
                    119,
                    16
                ],
                [
                    86,
                    6,
                    28,
                    5,
                    64,
                    255,
                    25,
                    248,
                    1
                ],
                [
                    56,
                    8,
                    17,
                    132,
                    137,
                    255,
                    55,
                    116,
                    128
                ],
                [
                    58,
                    15,
                    20,
                    82,
                    135,
                    57,
                    26,
                    121,
                    40
                ]
            ],
            [
                [
                    164,
                    50,
                    31,
                    137,
                    154,
                    133,
                    25,
                    35,
                    218
                ],
                [
                    51,
                    103,
                    44,
                    131,
                    131,
                    123,
                    31,
                    6,
                    158
                ],
                [
                    86,
                    40,
                    64,
                    135,
                    148,
                    224,
                    45,
                    183,
                    128
                ],
                [
                    22,
                    26,
                    17,
                    131,
                    240,
                    154,
                    14,
                    1,
                    209
                ],
                [
                    45,
                    16,
                    21,
                    91,
                    64,
                    222,
                    7,
                    1,
                    197
                ],
                [
                    56,
                    21,
                    39,
                    155,
                    60,
                    138,
                    23,
                    102,
                    213
                ],
                [
                    83,
                    12,
                    13,
                    54,
                    192,
                    255,
                    68,
                    47,
                    28
                ],
                [
                    85,
                    26,
                    85,
                    85,
                    128,
                    128,
                    32,
                    146,
                    171
                ],
                [
                    18,
                    11,
                    7,
                    63,
                    144,
                    171,
                    4,
                    4,
                    246
                ],
                [
                    35,
                    27,
                    10,
                    146,
                    174,
                    171,
                    12,
                    26,
                    128
                ]
            ],
            [
                [
                    190,
                    80,
                    35,
                    99,
                    180,
                    80,
                    126,
                    54,
                    45
                ],
                [
                    85,
                    126,
                    47,
                    87,
                    176,
                    51,
                    41,
                    20,
                    32
                ],
                [
                    101,
                    75,
                    128,
                    139,
                    118,
                    146,
                    116,
                    128,
                    85
                ],
                [
                    56,
                    41,
                    15,
                    176,
                    236,
                    85,
                    37,
                    9,
                    62
                ],
                [
                    71,
                    30,
                    17,
                    119,
                    118,
                    255,
                    17,
                    18,
                    138
                ],
                [
                    101,
                    38,
                    60,
                    138,
                    55,
                    70,
                    43,
                    26,
                    142
                ],
                [
                    146,
                    36,
                    19,
                    30,
                    171,
                    255,
                    97,
                    27,
                    20
                ],
                [
                    138,
                    45,
                    61,
                    62,
                    219,
                    1,
                    81,
                    188,
                    64
                ],
                [
                    32,
                    41,
                    20,
                    117,
                    151,
                    142,
                    20,
                    21,
                    163
                ],
                [
                    112,
                    19,
                    12,
                    61,
                    195,
                    128,
                    48,
                    4,
                    24
                ]
            ]
        ], ui = [
            [
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        176,
                        246,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        223,
                        241,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        244,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        246,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        239,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        248,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        253,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        217,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        225,
                        252,
                        241,
                        253,
                        255,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        250,
                        241,
                        250,
                        253,
                        255,
                        253,
                        254,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        223,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        238,
                        253,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        248,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        247,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        186,
                        251,
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        251,
                        244,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        251,
                        243,
                        253,
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        236,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        253,
                        253,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        248,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        254,
                        252,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        248,
                        254,
                        249,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        246,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        254,
                        251,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        248,
                        254,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        251,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        245,
                        251,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        251,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ]
        ], ci = [
            0,
            1,
            2,
            3,
            6,
            4,
            5,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            7,
            0
        ], li = [], hi = [], fi = [], di = 1, pi = 2, gi = [], mi = [];
        vn("UpsampleRgbLinePair", xn, 3), vn("UpsampleBgrLinePair", An, 3), vn("UpsampleRgbaLinePair", Fn, 4), vn("UpsampleBgraLinePair", kn, 4), vn("UpsampleArgbLinePair", Pn, 4), vn("UpsampleRgba4444LinePair", _n, 2), vn("UpsampleRgb565LinePair", Sn, 2);
        var vi = t.UpsampleRgbLinePair, bi = t.UpsampleBgrLinePair, yi = t.UpsampleRgbaLinePair, wi = t.UpsampleBgraLinePair, Ni = t.UpsampleArgbLinePair, Li = t.UpsampleRgba4444LinePair, xi = t.UpsampleRgb565LinePair, Ai = 16, Si = 1 << Ai - 1, _i = -227, Pi = 482, ki = 6, Fi = (256 << ki) - 1, Ii = 0, ji = a(256), Ci = a(256), Oi = a(256), Bi = a(256), Mi = a(Pi - _i), qi = a(Pi - _i);
        In("YuvToRgbRow", xn, 3), In("YuvToBgrRow", An, 3), In("YuvToRgbaRow", Fn, 4), In("YuvToBgraRow", kn, 4), In("YuvToArgbRow", Pn, 4), In("YuvToRgba4444Row", _n, 2), In("YuvToRgb565Row", Sn, 2);
        var Ei = [
            0,
            4,
            8,
            12,
            128,
            132,
            136,
            140,
            256,
            260,
            264,
            268,
            384,
            388,
            392,
            396
        ], Ri = [
            0,
            2,
            8
        ], Di = [
            8,
            7,
            6,
            4,
            4,
            2,
            2,
            2,
            1,
            1,
            1,
            1
        ], Ti = 1;
        this.WebPDecodeRGBA = function(t, n, s, u, c) {
            var l = qr, h = new en, f = new ot;
            h.ba = f, f.S = l, f.width = [
                f.width
            ], f.height = [
                f.height
            ];
            var d = f.width, p = f.height, g = new st;
            if (null == g || null == t) var m = 2;
            else e(null != g), m = Bn(t, n, s, g.width, g.height, g.Pd, g.Qd, g.format, null);
            if (0 != m ? d = 0 : (null != d && (d[0] = g.width[0]), null != p && (p[0] = g.height[0]), d = 1), d) {
                f.width = f.width[0], f.height = f.height[0], null != u && (u[0] = f.width), null != c && (c[0] = f.height);
                t: {
                    if (u = new Gt, (c = new nn).data = t, c.w = n, c.ha = s, c.kd = 1, n = [
                        0
                    ], e(null != c), (0 == (t = Bn(c.data, c.w, c.ha, null, null, null, n, null, c)) || 7 == t) && n[0] && (t = 4), 0 == (n = t)) {
                        if (e(null != h), u.data = c.data, u.w = c.w + c.offset, u.ha = c.ha - c.offset, u.put = dt, u.ac = ft, u.bc = pt, u.ma = h, c.xa) {
                            if (null == (t = kt())) {
                                h = 1;
                                break t;
                            }
                            if (function(t, n) {
                                var r = [
                                    0
                                ], i = [
                                    0
                                ], a = [
                                    0
                                ];
                                e: for(;;){
                                    if (null == t) return 0;
                                    if (null == n) return t.a = 2, 0;
                                    if (t.l = n, t.a = 0, v(t.m, n.data, n.w, n.ha), !gt(t.m, r, i, a)) {
                                        t.a = 3;
                                        break e;
                                    }
                                    if (t.xb = pi, n.width = r[0], n.height = i[0], !Ft(r[0], i[0], 1, t, null)) break e;
                                    return 1;
                                }
                                return e(0 != t.a), 0;
                            }(t, u)) {
                                if (u = 0 == (n = En(u.width, u.height, h.Oa, h.ba))) {
                                    e: {
                                        u = t;
                                        n: for(;;){
                                            if (null == u) {
                                                u = 0;
                                                break e;
                                            }
                                            if (e(null != u.s.yc), e(null != u.s.Ya), e(0 < u.s.Wb), e(null != (s = u.l)), e(null != (c = s.ma)), 0 != u.xb) {
                                                if (u.ca = c.ba, u.tb = c.tb, e(null != u.ca), !Mn(c.Oa, s, Rr)) {
                                                    u.a = 2;
                                                    break n;
                                                }
                                                if (!It(u, s.width)) break n;
                                                if (s.da) break n;
                                                if ((s.da || rt(u.ca.S)) && mn(), 11 > u.ca.S || (alert("todo:WebPInitConvertARGBToYUV"), null != u.ca.f.kb.F && mn()), u.Pb && 0 < u.s.ua && null == u.s.vb.X && !O(u.s.vb, u.s.Wa.Xa)) {
                                                    u.a = 1;
                                                    break n;
                                                }
                                                u.xb = 0;
                                            }
                                            if (!_t(u, u.V, u.Ba, u.c, u.i, s.o, Lt)) break n;
                                            c.Dc = u.Ma, u = 1;
                                            break e;
                                        }
                                        e(0 != u.a), u = 0;
                                    }
                                    u = !u;
                                }
                                u && (n = t.a);
                            } else n = t.a;
                        } else {
                            t = new Yt;
                            if (t.Fa = c.na, t.P = c.P, t.qc = c.Sa, Kt(t, u)) {
                                if (0 == (n = En(u.width, u.height, h.Oa, h.ba))) {
                                    if (t.Aa = 0, s = h.Oa, e(null != (c = t)), null != s) {
                                        if (0 < (d = 0 > (d = s.Md) ? 0 : 100 < d ? 255 : 255 * d / 100)) {
                                            for(p = g = 0; 4 > p; ++p)12 > (m = c.pb[p]).lc && (m.ia = d * Di[0 > m.lc ? 0 : m.lc] >> 3), g |= m.ia;
                                            g && (alert("todo:VP8InitRandom"), c.ia = 1);
                                        }
                                        c.Ga = s.Id, 100 < c.Ga ? c.Ga = 100 : 0 > c.Ga && (c.Ga = 0);
                                    }
                                    (function(t, n) {
                                        if (null == t) return 0;
                                        if (null == n) return Jt(t, 2, "NULL VP8Io parameter in VP8Decode().");
                                        if (!t.cb && !Kt(t, n)) return 0;
                                        if (e(t.cb), null == n.ac || n.ac(n)) {
                                            n.ob && (t.L = 0);
                                            var s = Ri[t.L];
                                            if (2 == t.L ? (t.yb = 0, t.zb = 0) : (t.yb = n.v - s >> 4, t.zb = n.j - s >> 4, 0 > t.yb && (t.yb = 0), 0 > t.zb && (t.zb = 0)), t.Va = n.o + 15 + s >> 4, t.Hb = n.va + 15 + s >> 4, t.Hb > t.za && (t.Hb = t.za), t.Va > t.Ub && (t.Va = t.Ub), 0 < t.L) {
                                                var u = t.ed;
                                                for(s = 0; 4 > s; ++s){
                                                    var c;
                                                    if (t.Qa.Cb) {
                                                        var l = t.Qa.Lb[s];
                                                        t.Qa.Fb || (l += u.Tb);
                                                    } else l = u.Tb;
                                                    for(c = 0; 1 >= c; ++c){
                                                        var h = t.gd[s][c], f = l;
                                                        if (u.Pc && (f += u.vd[0], c && (f += u.od[0])), 0 < (f = 0 > f ? 0 : 63 < f ? 63 : f)) {
                                                            var d = f;
                                                            0 < u.wb && (d = 4 < u.wb ? d >> 2 : d >> 1) > 9 - u.wb && (d = 9 - u.wb), 1 > d && (d = 1), h.dd = d, h.tc = 2 * f + d, h.ld = 40 <= f ? 2 : 15 <= f ? 1 : 0;
                                                        } else h.tc = 0;
                                                        h.La = c;
                                                    }
                                                }
                                            }
                                            s = 0;
                                        } else Jt(t, 6, "Frame setup failed"), s = t.a;
                                        if (s = 0 == s) {
                                            if (s) {
                                                t.$c = 0, 0 < t.Aa || (t.Ic = Ti);
                                                e: {
                                                    s = t.Ic, u = 4 * (d = t.za);
                                                    var p = 32 * d, g = d + 1, m = 0 < t.L ? d * (0 < t.Aa ? 2 : 1) : 0, v = (2 == t.Aa ? 2 : 1) * d;
                                                    if ((h = u + 832 + (c = 3 * (16 * s + Ri[t.L]) / 2 * p) + (l = null != t.Fa && 0 < t.Fa.length ? t.Kc.c * t.Kc.i : 0)) != h) s = 0;
                                                    else {
                                                        if (h > t.Vb) {
                                                            if (t.Vb = 0, t.Ec = a(h), t.Fc = 0, null == t.Ec) {
                                                                s = Jt(t, 1, "no memory during frame initialization.");
                                                                break e;
                                                            }
                                                            t.Vb = h;
                                                        }
                                                        h = t.Ec, f = t.Fc, t.Ac = h, t.Bc = f, f += u, t.Gd = o(p, Ht), t.Hd = 0, t.rb = o(g + 1, Dt), t.sb = 1, t.wa = m ? o(m, Rt) : null, t.Y = 0, t.D.Nb = 0, t.D.wa = t.wa, t.D.Y = t.Y, 0 < t.Aa && (t.D.Y += d), e(!0), t.oc = h, t.pc = f, f += 832, t.ya = o(v, zt), t.aa = 0, t.D.ya = t.ya, t.D.aa = t.aa, 2 == t.Aa && (t.D.aa += d), t.R = 16 * d, t.B = 8 * d, d = (p = Ri[t.L]) * t.R, p = p / 2 * t.B, t.sa = h, t.ta = f + d, t.qa = t.sa, t.ra = t.ta + 16 * s * t.R + p, t.Ha = t.qa, t.Ia = t.ra + 8 * s * t.B + p, t.$c = 0, f += c, t.mb = l ? h : null, t.nb = l ? f : null, e(f + l <= t.Fc + t.Vb), $t(t), i(t.Ac, t.Bc, 0, u), s = 1;
                                                    }
                                                }
                                                if (s) {
                                                    if (n.ka = 0, n.y = t.sa, n.O = t.ta, n.f = t.qa, n.N = t.ra, n.ea = t.Ha, n.Vd = t.Ia, n.fa = t.R, n.Rc = t.B, n.F = null, n.J = 0, !Ir) {
                                                        for(s = -255; 255 >= s; ++s)_r[255 + s] = 0 > s ? -s : s;
                                                        for(s = -1020; 1020 >= s; ++s)Pr[1020 + s] = -128 > s ? -128 : 127 < s ? 127 : s;
                                                        for(s = -112; 112 >= s; ++s)kr[112 + s] = -16 > s ? -16 : 15 < s ? 15 : s;
                                                        for(s = -255; 510 >= s; ++s)Fr[255 + s] = 0 > s ? 0 : 255 < s ? 255 : s;
                                                        Ir = 1;
                                                    }
                                                    ir = ue, ar = ie, sr = ae, ur = oe, cr = se, or = re, lr = Ye, hr = Je, fr = Ze, dr = $e, pr = Xe, gr = Ke, mr = Qe, vr = tn, br = ze, yr = Ue, wr = He, Nr = We, hi[0] = xe, hi[1] = le, hi[2] = Ne, hi[3] = Le, hi[4] = Ae, hi[5] = _e, hi[6] = Se, hi[7] = Pe, hi[8] = Fe, hi[9] = ke, li[0] = me, li[1] = fe, li[2] = de, li[3] = pe, li[4] = ve, li[5] = be, li[6] = ye, fi[0] = Oe, fi[1] = he, fi[2] = Ie, fi[3] = je, fi[4] = Me, fi[5] = Be, fi[6] = qe, s = 1;
                                                } else s = 0;
                                            }
                                            s && (s = function(t, n) {
                                                for(t.M = 0; t.M < t.Va; ++t.M){
                                                    var o, s = t.Jc[t.M & t.Xb], u = t.m, c = t;
                                                    for(o = 0; o < c.za; ++o){
                                                        var l = u, h = c, f = h.Ac, d = h.Bc + 4 * o, p = h.zc, g = h.ya[h.aa + o];
                                                        if (h.Qa.Bb ? g.$b = k(l, h.Pa.jb[0]) ? 2 + k(l, h.Pa.jb[2]) : k(l, h.Pa.jb[1]) : g.$b = 0, h.kc && (g.Ad = k(l, h.Bd)), g.Za = !k(l, 145) + 0, g.Za) {
                                                            var m = g.Ob, v = 0;
                                                            for(h = 0; 4 > h; ++h){
                                                                var b, y = p[0 + h];
                                                                for(b = 0; 4 > b; ++b){
                                                                    y = si[f[d + b]][y];
                                                                    for(var w = ai[k(l, y[0])]; 0 < w;)w = ai[2 * w + k(l, y[w])];
                                                                    y = -w, f[d + b] = y;
                                                                }
                                                                r(m, v, f, d, 4), v += 4, p[0 + h] = y;
                                                            }
                                                        } else y = k(l, 156) ? k(l, 128) ? 1 : 3 : k(l, 163) ? 2 : 0, g.Ob[0] = y, i(f, d, y, 4), i(p, 0, y, 4);
                                                        g.Dd = k(l, 142) ? k(l, 114) ? k(l, 183) ? 1 : 3 : 2 : 0;
                                                    }
                                                    if (c.m.Ka) return Jt(t, 7, "Premature end-of-partition0 encountered.");
                                                    for(; t.ja < t.za; ++t.ja){
                                                        if (c = s, l = (u = t).rb[u.sb - 1], f = u.rb[u.sb + u.ja], o = u.ya[u.aa + u.ja], d = u.kc ? o.Ad : 0) l.la = f.la = 0, o.Za || (l.Na = f.Na = 0), o.Hc = 0, o.Gc = 0, o.ia = 0;
                                                        else {
                                                            var N, L;
                                                            if (l = f, f = c, d = u.Pa.Xc, p = u.ya[u.aa + u.ja], g = u.pb[p.$b], h = p.ad, m = 0, v = u.rb[u.sb - 1], y = b = 0, i(h, m, 0, 384), p.Za) var x = 0, A = d[3];
                                                            else {
                                                                w = a(16);
                                                                var S = l.Na + v.Na;
                                                                if (S = ni(f, d[1], S, g.Eb, 0, w, 0), l.Na = v.Na = (0 < S) + 0, 1 < S) ir(w, 0, h, m);
                                                                else {
                                                                    var _ = w[0] + 3 >> 3;
                                                                    for(w = 0; 256 > w; w += 16)h[m + w] = _;
                                                                }
                                                                x = 1, A = d[0];
                                                            }
                                                            var P = 15 & l.la, F = 15 & v.la;
                                                            for(w = 0; 4 > w; ++w){
                                                                var I = 1 & F;
                                                                for(_ = L = 0; 4 > _; ++_)P = P >> 1 | (I = (S = ni(f, A, S = I + (1 & P), g.Sc, x, h, m)) > x) << 7, L = L << 2 | (3 < S ? 3 : 1 < S ? 2 : 0 != h[m + 0]), m += 16;
                                                                P >>= 4, F = F >> 1 | I << 7, b = (b << 8 | L) >>> 0;
                                                            }
                                                            for(A = P, x = F >> 4, N = 0; 4 > N; N += 2){
                                                                for(L = 0, P = l.la >> 4 + N, F = v.la >> 4 + N, w = 0; 2 > w; ++w){
                                                                    for(I = 1 & F, _ = 0; 2 > _; ++_)S = I + (1 & P), P = P >> 1 | (I = 0 < (S = ni(f, d[2], S, g.Qc, 0, h, m))) << 3, L = L << 2 | (3 < S ? 3 : 1 < S ? 2 : 0 != h[m + 0]), m += 16;
                                                                    P >>= 2, F = F >> 1 | I << 5;
                                                                }
                                                                y |= L << 4 * N, A |= P << 4 << N, x |= (240 & F) << N;
                                                            }
                                                            l.la = A, v.la = x, p.Hc = b, p.Gc = y, p.ia = 43690 & y ? 0 : g.ia, d = !(b | y);
                                                        }
                                                        if (0 < u.L && (u.wa[u.Y + u.ja] = u.gd[o.$b][o.Za], u.wa[u.Y + u.ja].La |= !d), c.Ka) return Jt(t, 7, "Premature end-of-file encountered.");
                                                    }
                                                    if ($t(t), u = n, c = 1, o = (s = t).D, l = 0 < s.L && s.M >= s.zb && s.M <= s.Va, 0 == s.Aa) e: {
                                                        if (o.M = s.M, o.uc = l, On(s, o), c = 1, o = (L = s.D).Nb, l = (y = Ri[s.L]) * s.R, f = y / 2 * s.B, w = 16 * o * s.R, _ = 8 * o * s.B, d = s.sa, p = s.ta - l + w, g = s.qa, h = s.ra - f + _, m = s.Ha, v = s.Ia - f + _, F = 0 == (P = L.M), b = P >= s.Va - 1, 2 == s.Aa && On(s, L), L.uc) for(I = (S = s).D.M, e(S.D.uc), L = S.yb; L < S.Hb; ++L){
                                                            x = L, A = I;
                                                            var j = (C = (z = S).D).Nb;
                                                            N = z.R;
                                                            var C = C.wa[C.Y + x], O = z.sa, B = z.ta + 16 * j * N + 16 * x, M = C.dd, q = C.tc;
                                                            if (0 != q) {
                                                                if (e(3 <= q), 1 == z.L) 0 < x && yr(O, B, N, q + 4), C.La && Nr(O, B, N, q), 0 < A && br(O, B, N, q + 4), C.La && wr(O, B, N, q);
                                                                else {
                                                                    var E = z.B, R = z.qa, D = z.ra + 8 * j * E + 8 * x, T = z.Ha, z = z.Ia + 8 * j * E + 8 * x;
                                                                    j = C.ld, 0 < x && (hr(O, B, N, q + 4, M, j), dr(R, D, T, z, E, q + 4, M, j)), C.La && (gr(O, B, N, q, M, j), vr(R, D, T, z, E, q, M, j)), 0 < A && (lr(O, B, N, q + 4, M, j), fr(R, D, T, z, E, q + 4, M, j)), C.La && (pr(O, B, N, q, M, j), mr(R, D, T, z, E, q, M, j));
                                                                }
                                                            }
                                                        }
                                                        if (s.ia && alert("todo:DitherRow"), null != u.put) {
                                                            if (L = 16 * P, P = 16 * (P + 1), F ? (u.y = s.sa, u.O = s.ta + w, u.f = s.qa, u.N = s.ra + _, u.ea = s.Ha, u.W = s.Ia + _) : (L -= y, u.y = d, u.O = p, u.f = g, u.N = h, u.ea = m, u.W = v), b || (P -= y), P > u.o && (P = u.o), u.F = null, u.J = null, null != s.Fa && 0 < s.Fa.length && L < P && (u.J = hn(s, u, L, P - L), u.F = s.mb, null == u.F && 0 == u.F.length)) {
                                                                c = Jt(s, 3, "Could not decode alpha data.");
                                                                break e;
                                                            }
                                                            L < u.j && (y = u.j - L, L = u.j, e(!(1 & y)), u.O += s.R * y, u.N += s.B * (y >> 1), u.W += s.B * (y >> 1), null != u.F && (u.J += u.width * y)), L < P && (u.O += u.v, u.N += u.v >> 1, u.W += u.v >> 1, null != u.F && (u.J += u.v), u.ka = L - u.j, u.U = u.va - u.v, u.T = P - L, c = u.put(u));
                                                        }
                                                        o + 1 != s.Ic || b || (r(s.sa, s.ta - l, d, p + 16 * s.R, l), r(s.qa, s.ra - f, g, h + 8 * s.B, f), r(s.Ha, s.Ia - f, m, v + 8 * s.B, f));
                                                    }
                                                    if (!c) return Jt(t, 6, "Output aborted.");
                                                }
                                                return 1;
                                            }(t, n)), null != n.bc && n.bc(n), s &= 1;
                                        }
                                        return s ? (t.cb = 0, s) : 0;
                                    })(t, u) || (n = t.a);
                                }
                            } else n = t.a;
                        }
                        0 == n && null != h.Oa && h.Oa.fd && (n = qn(h.ba));
                    }
                    h = n;
                }
                l = 0 != h ? null : 11 > l ? f.f.RGBA.eb : f.f.kb.y;
            } else l = null;
            return l;
        };
        var zi = [
            3,
            4,
            3,
            4,
            4,
            2,
            2,
            4,
            4,
            4,
            2,
            1,
            1
        ];
    };
    function c(t, e) {
        for(var n = "", r = 0; r < 4; r++)n += String.fromCharCode(t[e++]);
        return n;
    }
    function l(t, e) {
        return t[e + 0] | t[e + 1] << 8;
    }
    function h(t, e) {
        return (t[e + 0] | t[e + 1] << 8 | t[e + 2] << 16) >>> 0;
    }
    function f(t, e) {
        return (t[e + 0] | t[e + 1] << 8 | t[e + 2] << 16 | t[e + 3] << 24) >>> 0;
    }
    new u;
    var d = [
        0
    ], p = [
        0
    ], g = [], m = new u, v = t, b = function(t, e) {
        var n = {}, r = 0, i = !1, a = 0, o = 0;
        if (n.frames = [], !/** @license
   * Copyright (c) 2017 Dominik Homberger
  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
  The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  https://webpjs.appspot.com
  WebPRiffParser dominikhlbg@gmail.com
  */ function(t, e) {
            for(var n = 0; n < 4; n++)if (t[e + n] != "RIFF".charCodeAt(n)) return !0;
            return !1;
        }(t, e)) {
            for(f(t, e += 4), e += 8; e < t.length;){
                var s = c(t, e), u = f(t, e += 4);
                e += 4;
                var d = u + (1 & u);
                switch(s){
                    case "VP8 ":
                    case "VP8L":
                        void 0 === n.frames[r] && (n.frames[r] = {}), (m = n.frames[r]).src_off = i ? o : e - 8, m.src_size = a + u + 8, r++, i && (i = !1, a = 0, o = 0);
                        break;
                    case "VP8X":
                        (m = n.header = {}).feature_flags = t[e];
                        var p = e + 4;
                        m.canvas_width = 1 + h(t, p), p += 3, m.canvas_height = 1 + h(t, p), p += 3;
                        break;
                    case "ALPH":
                        i = !0, a = d + 8, o = e - 8;
                        break;
                    case "ANIM":
                        (m = n.header).bgcolor = f(t, e), p = e + 4, m.loop_count = l(t, p), p += 2;
                        break;
                    case "ANMF":
                        var g, m;
                        (m = n.frames[r] = {}).offset_x = 2 * h(t, e), e += 3, m.offset_y = 2 * h(t, e), e += 3, m.width = 1 + h(t, e), e += 3, m.height = 1 + h(t, e), e += 3, m.duration = h(t, e), e += 3, g = t[e++], m.dispose = 1 & g, m.blend = g >> 1 & 1;
                }
                "ANMF" != s && (e += d);
            }
            return n;
        }
    }(v, 0);
    b.response = v, b.rgbaoutput = !0, b.dataurl = !1;
    var y = b.header ? b.header : null, w = b.frames ? b.frames : null;
    if (y) {
        y.loop_counter = y.loop_count, d = [
            y.canvas_height
        ], p = [
            y.canvas_width
        ];
        for(var N = 0; N < w.length && 0 != w[N].blend; N++);
    }
    var L = w[0], x = m.WebPDecodeRGBA(v, L.src_off, L.src_size, p, d);
    L.rgba = x, L.imgwidth = p[0], L.imgheight = d[0];
    for(var A = 0; A < p[0] * d[0] * 4; A++)g[A] = x[A];
    return this.width = p, this.height = d, this.data = g, this;
}



!function(e) {
    var n, r, i, a, s, u, c, l, f, d = function(t) {
        return t = t || {}, this.isStrokeTransparent = t.isStrokeTransparent || !1, this.strokeOpacity = t.strokeOpacity || 1, this.strokeStyle = t.strokeStyle || "#000000", this.fillStyle = t.fillStyle || "#000000", this.isFillTransparent = t.isFillTransparent || !1, this.fillOpacity = t.fillOpacity || 1, this.font = t.font || "10px sans-serif", this.textBaseline = t.textBaseline || "alphabetic", this.textAlign = t.textAlign || "left", this.lineWidth = t.lineWidth || 1, this.lineJoin = t.lineJoin || "miter", this.lineCap = t.lineCap || "butt", this.path = t.path || [], this.transform = void 0 !== t.transform ? t.transform.clone() : new l, this.globalCompositeOperation = t.globalCompositeOperation || "normal", this.globalAlpha = t.globalAlpha || 1, this.clip_path = t.clip_path || [], this.currentPoint = t.currentPoint || new u, this.miterLimit = t.miterLimit || 10, this.lastPoint = t.lastPoint || new u, this.lineDashOffset = t.lineDashOffset || 0, this.lineDash = t.lineDash || [], this.margin = t.margin || [
            0,
            0,
            0,
            0
        ], this.prevPageLastElemOffset = t.prevPageLastElemOffset || 0, this.ignoreClearRect = "boolean" != typeof t.ignoreClearRect || t.ignoreClearRect, this;
    };
    e.events.push([
        "initialized",
        function() {
            this.context2d = new p(this), n = this.internal.f2, r = this.internal.getCoordinateString, i = this.internal.getVerticalCoordinateString, a = this.internal.getHorizontalCoordinate, s = this.internal.getVerticalCoordinate, u = this.internal.Point, c = this.internal.Rectangle, l = this.internal.Matrix, f = new d;
        }
    ]);
    var p = function(t) {
        Object.defineProperty(this, "canvas", {
            get: function() {
                return {
                    parentNode: !1,
                    style: !1
                };
            }
        });
        var e = t;
        Object.defineProperty(this, "pdf", {
            get: function() {
                return e;
            }
        });
        var n = !1;
        Object.defineProperty(this, "pageWrapXEnabled", {
            get: function() {
                return n;
            },
            set: function(t) {
                n = Boolean(t);
            }
        });
        var r = !1;
        Object.defineProperty(this, "pageWrapYEnabled", {
            get: function() {
                return r;
            },
            set: function(t) {
                r = Boolean(t);
            }
        });
        var i = 0;
        Object.defineProperty(this, "posX", {
            get: function() {
                return i;
            },
            set: function(t) {
                isNaN(t) || (i = t);
            }
        });
        var a = 0;
        Object.defineProperty(this, "posY", {
            get: function() {
                return a;
            },
            set: function(t) {
                isNaN(t) || (a = t);
            }
        }), Object.defineProperty(this, "margin", {
            get: function() {
                return f.margin;
            },
            set: function(t) {
                var e;
                "number" == typeof t ? e = [
                    t,
                    t,
                    t,
                    t
                ] : ((e = new Array(4))[0] = t[0], e[1] = t.length >= 2 ? t[1] : e[0], e[2] = t.length >= 3 ? t[2] : e[0], e[3] = t.length >= 4 ? t[3] : e[1]), f.margin = e;
            }
        });
        var o = !1;
        Object.defineProperty(this, "autoPaging", {
            get: function() {
                return o;
            },
            set: function(t) {
                o = t;
            }
        });
        var s = 0;
        Object.defineProperty(this, "lastBreak", {
            get: function() {
                return s;
            },
            set: function(t) {
                s = t;
            }
        });
        var u = [];
        Object.defineProperty(this, "pageBreaks", {
            get: function() {
                return u;
            },
            set: function(t) {
                u = t;
            }
        }), Object.defineProperty(this, "ctx", {
            get: function() {
                return f;
            },
            set: function(t) {
                t instanceof d && (f = t);
            }
        }), Object.defineProperty(this, "path", {
            get: function() {
                return f.path;
            },
            set: function(t) {
                f.path = t;
            }
        });
        var c = [];
        Object.defineProperty(this, "ctxStack", {
            get: function() {
                return c;
            },
            set: function(t) {
                c = t;
            }
        }), Object.defineProperty(this, "fillStyle", {
            get: function() {
                return this.ctx.fillStyle;
            },
            set: function(t) {
                var e;
                e = g(t), this.ctx.fillStyle = e.style, this.ctx.isFillTransparent = 0 === e.a, this.ctx.fillOpacity = e.a, this.pdf.setFillColor(e.r, e.g, e.b, {
                    a: e.a
                }), this.pdf.setTextColor(e.r, e.g, e.b, {
                    a: e.a
                });
            }
        }), Object.defineProperty(this, "strokeStyle", {
            get: function() {
                return this.ctx.strokeStyle;
            },
            set: function(t) {
                var e = g(t);
                this.ctx.strokeStyle = e.style, this.ctx.isStrokeTransparent = 0 === e.a, this.ctx.strokeOpacity = e.a, 0 === e.a ? this.pdf.setDrawColor(255, 255, 255) : (e.a, this.pdf.setDrawColor(e.r, e.g, e.b));
            }
        }), Object.defineProperty(this, "lineCap", {
            get: function() {
                return this.ctx.lineCap;
            },
            set: function(t) {
                -1 !== [
                    "butt",
                    "round",
                    "square"
                ].indexOf(t) && (this.ctx.lineCap = t, this.pdf.setLineCap(t));
            }
        }), Object.defineProperty(this, "lineWidth", {
            get: function() {
                return this.ctx.lineWidth;
            },
            set: function(t) {
                isNaN(t) || (this.ctx.lineWidth = t, this.pdf.setLineWidth(t));
            }
        }), Object.defineProperty(this, "lineJoin", {
            get: function() {
                return this.ctx.lineJoin;
            },
            set: function(t) {
                -1 !== [
                    "bevel",
                    "round",
                    "miter"
                ].indexOf(t) && (this.ctx.lineJoin = t, this.pdf.setLineJoin(t));
            }
        }), Object.defineProperty(this, "miterLimit", {
            get: function() {
                return this.ctx.miterLimit;
            },
            set: function(t) {
                isNaN(t) || (this.ctx.miterLimit = t, this.pdf.setMiterLimit(t));
            }
        }), Object.defineProperty(this, "textBaseline", {
            get: function() {
                return this.ctx.textBaseline;
            },
            set: function(t) {
                this.ctx.textBaseline = t;
            }
        }), Object.defineProperty(this, "textAlign", {
            get: function() {
                return this.ctx.textAlign;
            },
            set: function(t) {
                -1 !== [
                    "right",
                    "end",
                    "center",
                    "left",
                    "start"
                ].indexOf(t) && (this.ctx.textAlign = t);
            }
        });
        var l = null, h = null;
        var p = null;
        Object.defineProperty(this, "fontFaces", {
            get: function() {
                return p;
            },
            set: function(t) {
                l = null, h = null, p = t;
            }
        }), Object.defineProperty(this, "font", {
            get: function() {
                return this.ctx.font;
            },
            set: function(t) {
                var e;
                if (this.ctx.font = t, null !== (e = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z0-9]+?)\s*$/i.exec(t))) {
                    var n = e[1];
                    e[2];
                    var r = e[3], i = e[4];
                    e[5];
                    var a = e[6], o = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(i)[2];
                    i = "px" === o ? Math.floor(parseFloat(i) * this.pdf.internal.scaleFactor) : "em" === o ? Math.floor(parseFloat(i) * this.pdf.getFontSize()) : Math.floor(parseFloat(i) * this.pdf.internal.scaleFactor), this.pdf.setFontSize(i);
                    var s = function(t) {
                        var e, n, r = [], i = t.trim();
                        if ("" === i) return $ffaeb8e02004bf5e$var$Jt;
                        if (i in $ffaeb8e02004bf5e$var$Mt) return [
                            $ffaeb8e02004bf5e$var$Mt[i]
                        ];
                        for(; "" !== i;){
                            switch(n = null, e = (i = $ffaeb8e02004bf5e$var$Et(i)).charAt(0)){
                                case '"':
                                case "'":
                                    n = $ffaeb8e02004bf5e$var$Rt(i.substring(1), e);
                                    break;
                                default:
                                    n = $ffaeb8e02004bf5e$var$Dt(i);
                            }
                            if (null === n) return $ffaeb8e02004bf5e$var$Jt;
                            if (r.push(n[0]), "" !== (i = $ffaeb8e02004bf5e$var$Et(n[1])) && "," !== i.charAt(0)) return $ffaeb8e02004bf5e$var$Jt;
                            i = i.replace(/^,/, "");
                        }
                        return r;
                    }(a);
                    if (this.fontFaces) {
                        var u = function(t, e) {
                            var n = t.getFontList(), r = JSON.stringify(n);
                            if (null === l || h !== r) {
                                var i = function(t) {
                                    var e = [];
                                    return Object.keys(t).forEach(function(n) {
                                        t[n].forEach(function(t) {
                                            var r = null;
                                            switch(t){
                                                case "bold":
                                                    r = {
                                                        family: n,
                                                        weight: "bold"
                                                    };
                                                    break;
                                                case "italic":
                                                    r = {
                                                        family: n,
                                                        style: "italic"
                                                    };
                                                    break;
                                                case "bolditalic":
                                                    r = {
                                                        family: n,
                                                        weight: "bold",
                                                        style: "italic"
                                                    };
                                                    break;
                                                case "":
                                                case "normal":
                                                    r = {
                                                        family: n
                                                    };
                                            }
                                            null !== r && (r.ref = {
                                                name: n,
                                                style: t
                                            }, e.push(r));
                                        });
                                    }), e;
                                }(n);
                                l = function(t) {
                                    for(var e = {}, n = 0; n < t.length; ++n){
                                        var r = $ffaeb8e02004bf5e$var$Ct(t[n]), i = r.family, a = r.stretch, o = r.style, s = r.weight;
                                        e[i] = e[i] || {}, e[i][a] = e[i][a] || {}, e[i][a][o] = e[i][a][o] || {}, e[i][a][o][s] = r;
                                    }
                                    return e;
                                }(i.concat(e)), h = r;
                            }
                            return l;
                        }(this.pdf, this.fontFaces), c = s.map(function(t) {
                            return {
                                family: t,
                                stretch: "normal",
                                weight: r,
                                style: n
                            };
                        }), f = function(t, e, n) {
                            for(var r = (n = n || {}).defaultFontFamily || "times", i = Object.assign({}, $ffaeb8e02004bf5e$var$Bt, n.genericFontFamilies || {}), a = null, o = null, s = 0; s < e.length; ++s)if (i[(a = $ffaeb8e02004bf5e$var$Ct(e[s])).family] && (a.family = i[a.family]), t.hasOwnProperty(a.family)) {
                                o = t[a.family];
                                break;
                            }
                            if (!(o = o || t[r])) throw new Error("Could not find a font-family for the rule '" + $ffaeb8e02004bf5e$var$qt(a) + "' and default family '" + r + "'.");
                            if (o = function(t, e) {
                                if (e[t]) return e[t];
                                var n = $ffaeb8e02004bf5e$var$Ft[t], r = n <= $ffaeb8e02004bf5e$var$Ft.normal ? -1 : 1, i = $ffaeb8e02004bf5e$var$Ot(e, $ffaeb8e02004bf5e$var$kt, n, r);
                                if (!i) throw new Error("Could not find a matching font-stretch value for " + t);
                                return i;
                            }(a.stretch, o), o = function(t, e) {
                                if (e[t]) return e[t];
                                for(var n = $ffaeb8e02004bf5e$var$Pt[t], r = 0; r < n.length; ++r)if (e[n[r]]) return e[n[r]];
                                throw new Error("Could not find a matching font-style for " + t);
                            }(a.style, o), !(o = function(t, e) {
                                if (e[t]) return e[t];
                                if (400 === t && e[500]) return e[500];
                                if (500 === t && e[400]) return e[400];
                                var n = $ffaeb8e02004bf5e$var$jt[t], r = $ffaeb8e02004bf5e$var$Ot(e, $ffaeb8e02004bf5e$var$It, n, t < 400 ? -1 : 1);
                                if (!r) throw new Error("Could not find a matching font-weight for value " + t);
                                return r;
                            }(a.weight, o))) throw new Error("Failed to resolve a font for the rule '" + $ffaeb8e02004bf5e$var$qt(a) + "'.");
                            return o;
                        }(u, c);
                        this.pdf.setFont(f.ref.name, f.ref.style);
                    } else {
                        var d = "";
                        ("bold" === r || parseInt(r, 10) >= 700 || "bold" === n) && (d = "bold"), "italic" === n && (d += "italic"), 0 === d.length && (d = "normal");
                        for(var p = "", g = {
                            arial: "Helvetica",
                            Arial: "Helvetica",
                            verdana: "Helvetica",
                            Verdana: "Helvetica",
                            helvetica: "Helvetica",
                            Helvetica: "Helvetica",
                            "sans-serif": "Helvetica",
                            fixed: "Courier",
                            monospace: "Courier",
                            terminal: "Courier",
                            cursive: "Times",
                            fantasy: "Times",
                            serif: "Times"
                        }, m = 0; m < s.length; m++){
                            if (void 0 !== this.pdf.internal.getFont(s[m], d, {
                                noFallback: !0,
                                disableWarning: !0
                            })) {
                                p = s[m];
                                break;
                            }
                            if ("bolditalic" === d && void 0 !== this.pdf.internal.getFont(s[m], "bold", {
                                noFallback: !0,
                                disableWarning: !0
                            })) p = s[m], d = "bold";
                            else if (void 0 !== this.pdf.internal.getFont(s[m], "normal", {
                                noFallback: !0,
                                disableWarning: !0
                            })) {
                                p = s[m], d = "normal";
                                break;
                            }
                        }
                        if ("" === p) {
                            for(var v = 0; v < s.length; v++)if (g[s[v]]) {
                                p = g[s[v]];
                                break;
                            }
                        }
                        p = "" === p ? "Times" : p, this.pdf.setFont(p, d);
                    }
                }
            }
        }), Object.defineProperty(this, "globalCompositeOperation", {
            get: function() {
                return this.ctx.globalCompositeOperation;
            },
            set: function(t) {
                this.ctx.globalCompositeOperation = t;
            }
        }), Object.defineProperty(this, "globalAlpha", {
            get: function() {
                return this.ctx.globalAlpha;
            },
            set: function(t) {
                this.ctx.globalAlpha = t;
            }
        }), Object.defineProperty(this, "lineDashOffset", {
            get: function() {
                return this.ctx.lineDashOffset;
            },
            set: function(t) {
                this.ctx.lineDashOffset = t, T.call(this);
            }
        }), Object.defineProperty(this, "lineDash", {
            get: function() {
                return this.ctx.lineDash;
            },
            set: function(t) {
                this.ctx.lineDash = t, T.call(this);
            }
        }), Object.defineProperty(this, "ignoreClearRect", {
            get: function() {
                return this.ctx.ignoreClearRect;
            },
            set: function(t) {
                this.ctx.ignoreClearRect = Boolean(t);
            }
        });
    };
    p.prototype.setLineDash = function(t) {
        this.lineDash = t;
    }, p.prototype.getLineDash = function() {
        return this.lineDash.length % 2 ? this.lineDash.concat(this.lineDash) : this.lineDash.slice();
    }, p.prototype.fill = function() {
        x.call(this, "fill", !1);
    }, p.prototype.stroke = function() {
        x.call(this, "stroke", !1);
    }, p.prototype.beginPath = function() {
        this.path = [
            {
                type: "begin"
            }
        ];
    }, p.prototype.moveTo = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $ffaeb8e02004bf5e$var$o.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
        var n = this.ctx.transform.applyToPoint(new u(t, e));
        this.path.push({
            type: "mt",
            x: n.x,
            y: n.y
        }), this.ctx.lastPoint = new u(t, e);
    }, p.prototype.closePath = function() {
        var e = new u(0, 0), n = 0;
        for(n = this.path.length - 1; -1 !== n; n--)if ("begin" === this.path[n].type && "object" === (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(this.path[n + 1]) && "number" == typeof this.path[n + 1].x) {
            e = new u(this.path[n + 1].x, this.path[n + 1].y);
            break;
        }
        this.path.push({
            type: "close"
        }), this.ctx.lastPoint = new u(e.x, e.y);
    }, p.prototype.lineTo = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $ffaeb8e02004bf5e$var$o.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
        var n = this.ctx.transform.applyToPoint(new u(t, e));
        this.path.push({
            type: "lt",
            x: n.x,
            y: n.y
        }), this.ctx.lastPoint = new u(n.x, n.y);
    }, p.prototype.clip = function() {
        this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), x.call(this, null, !0);
    }, p.prototype.quadraticCurveTo = function(t, e, n, r) {
        if (isNaN(n) || isNaN(r) || isNaN(t) || isNaN(e)) throw $ffaeb8e02004bf5e$var$o.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
        var i = this.ctx.transform.applyToPoint(new u(n, r)), a = this.ctx.transform.applyToPoint(new u(t, e));
        this.path.push({
            type: "qct",
            x1: a.x,
            y1: a.y,
            x: i.x,
            y: i.y
        }), this.ctx.lastPoint = new u(i.x, i.y);
    }, p.prototype.bezierCurveTo = function(t, e, n, r, i, a) {
        if (isNaN(i) || isNaN(a) || isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw $ffaeb8e02004bf5e$var$o.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
        var s = this.ctx.transform.applyToPoint(new u(i, a)), c = this.ctx.transform.applyToPoint(new u(t, e)), l = this.ctx.transform.applyToPoint(new u(n, r));
        this.path.push({
            type: "bct",
            x1: c.x,
            y1: c.y,
            x2: l.x,
            y2: l.y,
            x: s.x,
            y: s.y
        }), this.ctx.lastPoint = new u(s.x, s.y);
    }, p.prototype.arc = function(t, e, n, r, i, a) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || isNaN(i)) throw $ffaeb8e02004bf5e$var$o.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
        if (a = Boolean(a), !this.ctx.transform.isIdentity) {
            var s = this.ctx.transform.applyToPoint(new u(t, e));
            t = s.x, e = s.y;
            var c = this.ctx.transform.applyToPoint(new u(0, n)), l = this.ctx.transform.applyToPoint(new u(0, 0));
            n = Math.sqrt(Math.pow(c.x - l.x, 2) + Math.pow(c.y - l.y, 2));
        }
        Math.abs(i - r) >= 2 * Math.PI && (r = 0, i = 2 * Math.PI), this.path.push({
            type: "arc",
            x: t,
            y: e,
            radius: n,
            startAngle: r,
            endAngle: i,
            counterclockwise: a
        });
    }, p.prototype.arcTo = function(t, e, n, r, i) {
        throw new Error("arcTo not implemented.");
    }, p.prototype.rect = function(t, e, n, r) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw $ffaeb8e02004bf5e$var$o.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
        this.moveTo(t, e), this.lineTo(t + n, e), this.lineTo(t + n, e + r), this.lineTo(t, e + r), this.lineTo(t, e), this.lineTo(t + n, e), this.lineTo(t, e);
    }, p.prototype.fillRect = function(t, e, n, r) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw $ffaeb8e02004bf5e$var$o.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
        if (!m.call(this)) {
            var i = {};
            "butt" !== this.lineCap && (i.lineCap = this.lineCap, this.lineCap = "butt"), "miter" !== this.lineJoin && (i.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(t, e, n, r), this.fill(), i.hasOwnProperty("lineCap") && (this.lineCap = i.lineCap), i.hasOwnProperty("lineJoin") && (this.lineJoin = i.lineJoin);
        }
    }, p.prototype.strokeRect = function(t, e, n, r) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw $ffaeb8e02004bf5e$var$o.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
        v.call(this) || (this.beginPath(), this.rect(t, e, n, r), this.stroke());
    }, p.prototype.clearRect = function(t, e, n, r) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw $ffaeb8e02004bf5e$var$o.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
        this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(t, e, n, r));
    }, p.prototype.save = function(t) {
        t = "boolean" != typeof t || t;
        for(var e = this.pdf.internal.getCurrentPageInfo().pageNumber, n = 0; n < this.pdf.internal.getNumberOfPages(); n++)this.pdf.setPage(n + 1), this.pdf.internal.out("q");
        if (this.pdf.setPage(e), t) {
            this.ctx.fontSize = this.pdf.internal.getFontSize();
            var r = new d(this.ctx);
            this.ctxStack.push(this.ctx), this.ctx = r;
        }
    }, p.prototype.restore = function(t) {
        t = "boolean" != typeof t || t;
        for(var e = this.pdf.internal.getCurrentPageInfo().pageNumber, n = 0; n < this.pdf.internal.getNumberOfPages(); n++)this.pdf.setPage(n + 1), this.pdf.internal.out("Q");
        this.pdf.setPage(e), t && 0 !== this.ctxStack.length && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin, this.lineDash = this.ctx.lineDash, this.lineDashOffset = this.ctx.lineDashOffset);
    }, p.prototype.toDataURL = function() {
        throw new Error("toDataUrl not implemented.");
    };
    var g = function(t) {
        var e, n, r, i;
        if (!0 === t.isCanvasGradient && (t = t.getColor()), !t) return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            style: t
        };
        if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t)) e = 0, n = 0, r = 0, i = 0;
        else {
            var a = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);
            if (null !== a) e = parseInt(a[1]), n = parseInt(a[2]), r = parseInt(a[3]), i = 1;
            else if (null !== (a = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(t))) e = parseInt(a[1]), n = parseInt(a[2]), r = parseInt(a[3]), i = parseFloat(a[4]);
            else {
                if (i = 1, "string" == typeof t && "#" !== t.charAt(0)) {
                    var o = new $ffaeb8e02004bf5e$var$h(t);
                    t = o.ok ? o.toHex() : "#000000";
                }
                4 === t.length ? (e = t.substring(1, 2), e += e, n = t.substring(2, 3), n += n, r = t.substring(3, 4), r += r) : (e = t.substring(1, 3), n = t.substring(3, 5), r = t.substring(5, 7)), e = parseInt(e, 16), n = parseInt(n, 16), r = parseInt(r, 16);
            }
        }
        return {
            r: e,
            g: n,
            b: r,
            a: i,
            style: t
        };
    }, m = function() {
        return this.ctx.isFillTransparent || 0 == this.globalAlpha;
    }, v = function() {
        return Boolean(this.ctx.isStrokeTransparent || 0 == this.globalAlpha);
    };
    p.prototype.fillText = function(t, e, n, r) {
        if (isNaN(e) || isNaN(n) || "string" != typeof t) throw $ffaeb8e02004bf5e$var$o.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
        if (r = isNaN(r) ? void 0 : r, !m.call(this)) {
            var i = E(this.ctx.transform.rotation), a = this.ctx.transform.scaleX;
            j.call(this, {
                text: t,
                x: e,
                y: n,
                scale: a,
                angle: i,
                align: this.textAlign,
                maxWidth: r
            });
        }
    }, p.prototype.strokeText = function(t, e, n, r) {
        if (isNaN(e) || isNaN(n) || "string" != typeof t) throw $ffaeb8e02004bf5e$var$o.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
        if (!v.call(this)) {
            r = isNaN(r) ? void 0 : r;
            var i = E(this.ctx.transform.rotation), a = this.ctx.transform.scaleX;
            j.call(this, {
                text: t,
                x: e,
                y: n,
                scale: a,
                renderingMode: "stroke",
                angle: i,
                align: this.textAlign,
                maxWidth: r
            });
        }
    }, p.prototype.measureText = function(t) {
        if ("string" != typeof t) throw $ffaeb8e02004bf5e$var$o.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
        var e = this.pdf, n = this.pdf.internal.scaleFactor, r = e.internal.getFontSize(), i = e.getStringUnitWidth(t) * r / e.internal.scaleFactor;
        return new function(t) {
            var e = (t = t || {}).width || 0;
            return Object.defineProperty(this, "width", {
                get: function() {
                    return e;
                }
            }), this;
        }({
            width: i *= Math.round(96 * n / 72 * 1e4) / 1e4
        });
    }, p.prototype.scale = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $ffaeb8e02004bf5e$var$o.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
        var n = new l(t, 0, 0, e, 0, 0);
        this.ctx.transform = this.ctx.transform.multiply(n);
    }, p.prototype.rotate = function(t) {
        if (isNaN(t)) throw $ffaeb8e02004bf5e$var$o.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
        var e = new l(Math.cos(t), Math.sin(t), -Math.sin(t), Math.cos(t), 0, 0);
        this.ctx.transform = this.ctx.transform.multiply(e);
    }, p.prototype.translate = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $ffaeb8e02004bf5e$var$o.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
        var n = new l(1, 0, 0, 1, t, e);
        this.ctx.transform = this.ctx.transform.multiply(n);
    }, p.prototype.transform = function(t, e, n, r, i, a) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || isNaN(i) || isNaN(a)) throw $ffaeb8e02004bf5e$var$o.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
        var s = new l(t, e, n, r, i, a);
        this.ctx.transform = this.ctx.transform.multiply(s);
    }, p.prototype.setTransform = function(t, e, n, r, i, a) {
        t = isNaN(t) ? 1 : t, e = isNaN(e) ? 0 : e, n = isNaN(n) ? 0 : n, r = isNaN(r) ? 1 : r, i = isNaN(i) ? 0 : i, a = isNaN(a) ? 0 : a, this.ctx.transform = new l(t, e, n, r, i, a);
    };
    var b = function() {
        return this.margin[0] > 0 || this.margin[1] > 0 || this.margin[2] > 0 || this.margin[3] > 0;
    };
    p.prototype.drawImage = function(t, e, n, r, i, a, o, s, u) {
        var h = this.pdf.getImageProperties(t), f = 1, d = 1, p = 1, g = 1;
        void 0 !== r && void 0 !== s && (p = s / r, g = u / i, f = h.width / r * s / r, d = h.height / i * u / i), void 0 === a && (a = e, o = n, e = 0, n = 0), void 0 !== r && void 0 === s && (s = r, u = i), void 0 === r && void 0 === s && (s = h.width, u = h.height);
        var m = this.ctx.transform.decompose(), v = E(m.rotate.shx), w = new l, x = (w = (w = (w = w.multiply(m.translate)).multiply(m.skew)).multiply(m.scale)).applyToRectangle(new c(a - e * p, o - n * g, r * f, i * d));
        if (this.autoPaging) {
            for(var S, _ = y.call(this, x), P = [], k = 0; k < _.length; k += 1)-1 === P.indexOf(_[k]) && P.push(_[k]);
            L(P);
            for(var F = P[0], I = P[P.length - 1], j = F; j < I + 1; j++){
                this.pdf.setPage(j);
                var C = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], O = 1 === j ? this.posY + this.margin[0] : this.margin[0], B = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], M = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], q = 1 === j ? 0 : B + (j - 2) * M;
                if (0 !== this.ctx.clip_path.length) {
                    var R = this.path;
                    S = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(S, this.posX + this.margin[3], -q + O + this.ctx.prevPageLastElemOffset), A.call(this, "fill", !0), this.path = R;
                }
                var D = JSON.parse(JSON.stringify(x));
                D = N([
                    D
                ], this.posX + this.margin[3], -q + O + this.ctx.prevPageLastElemOffset)[0];
                var T = (j > F || j < I) && b.call(this);
                T && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], C, M, null).clip().discardPath()), this.pdf.addImage(t, "JPEG", D.x, D.y, D.w, D.h, null, null, v), T && this.pdf.restoreGraphicsState();
            }
        } else this.pdf.addImage(t, "JPEG", x.x, x.y, x.w, x.h, null, null, v);
    };
    var y = function(t, e, n) {
        var r = [];
        e = e || this.pdf.internal.pageSize.width, n = n || this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2];
        var i = this.posY + this.ctx.prevPageLastElemOffset;
        switch(t.type){
            default:
            case "mt":
            case "lt":
                r.push(Math.floor((t.y + i) / n) + 1);
                break;
            case "arc":
                r.push(Math.floor((t.y + i - t.radius) / n) + 1), r.push(Math.floor((t.y + i + t.radius) / n) + 1);
                break;
            case "qct":
                var a = R(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x, t.y);
                r.push(Math.floor((a.y + i) / n) + 1), r.push(Math.floor((a.y + a.h + i) / n) + 1);
                break;
            case "bct":
                var o = D(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x2, t.y2, t.x, t.y);
                r.push(Math.floor((o.y + i) / n) + 1), r.push(Math.floor((o.y + o.h + i) / n) + 1);
                break;
            case "rect":
                r.push(Math.floor((t.y + i) / n) + 1), r.push(Math.floor((t.y + t.h + i) / n) + 1);
        }
        for(var s = 0; s < r.length; s += 1)for(; this.pdf.internal.getNumberOfPages() < r[s];)w.call(this);
        return r;
    }, w = function() {
        var t = this.fillStyle, e = this.strokeStyle, n = this.font, r = this.lineCap, i = this.lineWidth, a = this.lineJoin;
        this.pdf.addPage(), this.fillStyle = t, this.strokeStyle = e, this.font = n, this.lineCap = r, this.lineWidth = i, this.lineJoin = a;
    }, N = function(t, e, n) {
        for(var r = 0; r < t.length; r++)switch(t[r].type){
            case "bct":
                t[r].x2 += e, t[r].y2 += n;
            case "qct":
                t[r].x1 += e, t[r].y1 += n;
            default:
                t[r].x += e, t[r].y += n;
        }
        return t;
    }, L = function(t) {
        return t.sort(function(t, e) {
            return t - e;
        });
    }, x = function(t, e) {
        var n = this.fillStyle, r = this.strokeStyle, i = this.lineCap, a = this.lineWidth, o = Math.abs(a * this.ctx.transform.scaleX), s = this.lineJoin;
        if (this.autoPaging) {
            for(var u, c, l = JSON.parse(JSON.stringify(this.path)), h = JSON.parse(JSON.stringify(this.path)), f = [], d = 0; d < h.length; d++)if (void 0 !== h[d].x) for(var p = y.call(this, h[d]), g = 0; g < p.length; g += 1)-1 === f.indexOf(p[g]) && f.push(p[g]);
            for(var m = 0; m < f.length; m++)for(; this.pdf.internal.getNumberOfPages() < f[m];)w.call(this);
            L(f);
            for(var v = f[0], x = f[f.length - 1], S = v; S < x + 1; S++){
                this.pdf.setPage(S), this.fillStyle = n, this.strokeStyle = r, this.lineCap = i, this.lineWidth = o, this.lineJoin = s;
                var _ = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], P = 1 === S ? this.posY + this.margin[0] : this.margin[0], k = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], F = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], I = 1 === S ? 0 : k + (S - 2) * F;
                if (0 !== this.ctx.clip_path.length) {
                    var j = this.path;
                    u = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(u, this.posX + this.margin[3], -I + P + this.ctx.prevPageLastElemOffset), A.call(this, t, !0), this.path = j;
                }
                if (c = JSON.parse(JSON.stringify(l)), this.path = N(c, this.posX + this.margin[3], -I + P + this.ctx.prevPageLastElemOffset), !1 === e || 0 === S) {
                    var C = (S > v || S < x) && b.call(this);
                    C && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], _, F, null).clip().discardPath()), A.call(this, t, e), C && this.pdf.restoreGraphicsState();
                }
                this.lineWidth = a;
            }
            this.path = l;
        } else this.lineWidth = o, A.call(this, t, e), this.lineWidth = a;
    }, A = function(t, e) {
        if (("stroke" !== t || e || !v.call(this)) && ("stroke" === t || e || !m.call(this))) {
            for(var n, r, i = [], a = this.path, o = 0; o < a.length; o++){
                var s = a[o];
                switch(s.type){
                    case "begin":
                        i.push({
                            begin: !0
                        });
                        break;
                    case "close":
                        i.push({
                            close: !0
                        });
                        break;
                    case "mt":
                        i.push({
                            start: s,
                            deltas: [],
                            abs: []
                        });
                        break;
                    case "lt":
                        var u = i.length;
                        if (a[o - 1] && !isNaN(a[o - 1].x) && (n = [
                            s.x - a[o - 1].x,
                            s.y - a[o - 1].y
                        ], u > 0)) {
                            for(; u >= 0; u--)if (!0 !== i[u - 1].close && !0 !== i[u - 1].begin) {
                                i[u - 1].deltas.push(n), i[u - 1].abs.push(s);
                                break;
                            }
                        }
                        break;
                    case "bct":
                        n = [
                            s.x1 - a[o - 1].x,
                            s.y1 - a[o - 1].y,
                            s.x2 - a[o - 1].x,
                            s.y2 - a[o - 1].y,
                            s.x - a[o - 1].x,
                            s.y - a[o - 1].y
                        ], i[i.length - 1].deltas.push(n);
                        break;
                    case "qct":
                        var c = a[o - 1].x + 2 / 3 * (s.x1 - a[o - 1].x), l = a[o - 1].y + 2 / 3 * (s.y1 - a[o - 1].y), h = s.x + 2 / 3 * (s.x1 - s.x), f = s.y + 2 / 3 * (s.y1 - s.y), d = s.x, p = s.y;
                        n = [
                            c - a[o - 1].x,
                            l - a[o - 1].y,
                            h - a[o - 1].x,
                            f - a[o - 1].y,
                            d - a[o - 1].x,
                            p - a[o - 1].y
                        ], i[i.length - 1].deltas.push(n);
                        break;
                    case "arc":
                        i.push({
                            deltas: [],
                            abs: [],
                            arc: !0
                        }), Array.isArray(i[i.length - 1].abs) && i[i.length - 1].abs.push(s);
                }
            }
            r = e ? null : "stroke" === t ? "stroke" : "fill";
            for(var g = !1, b = 0; b < i.length; b++)if (i[b].arc) for(var y = i[b].abs, w = 0; w < y.length; w++){
                var N = y[w];
                "arc" === N.type ? P.call(this, N.x, N.y, N.radius, N.startAngle, N.endAngle, N.counterclockwise, void 0, e, !g) : C.call(this, N.x, N.y), g = !0;
            }
            else if (!0 === i[b].close) this.pdf.internal.out("h"), g = !1;
            else if (!0 !== i[b].begin) {
                var L = i[b].start.x, x = i[b].start.y;
                O.call(this, i[b].deltas, L, x), g = !0;
            }
            r && k.call(this, r), e && F.call(this);
        }
    }, S = function(t) {
        var e = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor, n = e * (this.pdf.internal.getLineHeightFactor() - 1);
        switch(this.ctx.textBaseline){
            case "bottom":
                return t - n;
            case "top":
                return t + e - n;
            case "hanging":
                return t + e - 2 * n;
            case "middle":
                return t + e / 2 - n;
            default:
                return t;
        }
    }, _ = function(t) {
        return t + this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor * (this.pdf.internal.getLineHeightFactor() - 1);
    };
    p.prototype.createLinearGradient = function() {
        var t = function() {};
        return t.colorStops = [], t.addColorStop = function(t, e) {
            this.colorStops.push([
                t,
                e
            ]);
        }, t.getColor = function() {
            return 0 === this.colorStops.length ? "#000000" : this.colorStops[0][1];
        }, t.isCanvasGradient = !0, t;
    }, p.prototype.createPattern = function() {
        return this.createLinearGradient();
    }, p.prototype.createRadialGradient = function() {
        return this.createLinearGradient();
    };
    var P = function(t, e, n, r, i, a, o, s, u) {
        for(var c = M.call(this, n, r, i, a), l = 0; l < c.length; l++){
            var h = c[l];
            0 === l && (u ? I.call(this, h.x1 + t, h.y1 + e) : C.call(this, h.x1 + t, h.y1 + e)), B.call(this, t, e, h.x2, h.y2, h.x3, h.y3, h.x4, h.y4);
        }
        s ? F.call(this) : k.call(this, o);
    }, k = function(t) {
        switch(t){
            case "stroke":
                this.pdf.internal.out("S");
                break;
            case "fill":
                this.pdf.internal.out("f");
        }
    }, F = function() {
        this.pdf.clip(), this.pdf.discardPath();
    }, I = function(t, e) {
        this.pdf.internal.out(r(t) + " " + i(e) + " m");
    }, j = function(t) {
        var e;
        switch(t.align){
            case "right":
            case "end":
                e = "right";
                break;
            case "center":
                e = "center";
                break;
            default:
                e = "left";
        }
        var n, r, i, a = this.pdf.getTextDimensions(t.text), o = S.call(this, t.y), s = _.call(this, o) - a.h, h = this.ctx.transform.applyToPoint(new u(t.x, o));
        if (this.autoPaging) {
            var f = this.ctx.transform.decompose(), d = new l;
            d = (d = (d = d.multiply(f.translate)).multiply(f.skew)).multiply(f.scale);
            for(var p = this.ctx.transform.applyToRectangle(new c(t.x, o, a.w, a.h)), g = d.applyToRectangle(new c(t.x, s, a.w, a.h)), m = y.call(this, g), v = [], w = 0; w < m.length; w += 1)-1 === v.indexOf(m[w]) && v.push(m[w]);
            L(v);
            for(var x = v[0], P = v[v.length - 1], k = x; k < P + 1; k++){
                this.pdf.setPage(k);
                var F = 1 === k ? this.posY + this.margin[0] : this.margin[0], I = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], j = this.pdf.internal.pageSize.height - this.margin[2], C = j - this.margin[0], O = this.pdf.internal.pageSize.width - this.margin[1], B = O - this.margin[3], M = 1 === k ? 0 : I + (k - 2) * C;
                if (0 !== this.ctx.clip_path.length) {
                    var q = this.path;
                    n = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(n, this.posX + this.margin[3], -1 * M + F), A.call(this, "fill", !0), this.path = q;
                }
                var E = N([
                    JSON.parse(JSON.stringify(g))
                ], this.posX + this.margin[3], -M + F + this.ctx.prevPageLastElemOffset)[0];
                t.scale >= .01 && (r = this.pdf.internal.getFontSize(), this.pdf.setFontSize(r * t.scale), i = this.lineWidth, this.lineWidth = i * t.scale);
                var R = "text" !== this.autoPaging;
                if (R || E.y + E.h <= j) {
                    if (R || E.y >= F && E.x <= O) {
                        var D = R ? t.text : this.pdf.splitTextToSize(t.text, t.maxWidth || O - E.x)[0], T = N([
                            JSON.parse(JSON.stringify(p))
                        ], this.posX + this.margin[3], -M + F + this.ctx.prevPageLastElemOffset)[0], z = R && (k > x || k < P) && b.call(this);
                        z && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], B, C, null).clip().discardPath()), this.pdf.text(D, T.x, T.y, {
                            angle: t.angle,
                            align: e,
                            renderingMode: t.renderingMode
                        }), z && this.pdf.restoreGraphicsState();
                    }
                } else E.y < j && (this.ctx.prevPageLastElemOffset += j - E.y);
                t.scale >= .01 && (this.pdf.setFontSize(r), this.lineWidth = i);
            }
        } else t.scale >= .01 && (r = this.pdf.internal.getFontSize(), this.pdf.setFontSize(r * t.scale), i = this.lineWidth, this.lineWidth = i * t.scale), this.pdf.text(t.text, h.x + this.posX, h.y + this.posY, {
            angle: t.angle,
            align: e,
            renderingMode: t.renderingMode,
            maxWidth: t.maxWidth
        }), t.scale >= .01 && (this.pdf.setFontSize(r), this.lineWidth = i);
    }, C = function(t, e, n, a) {
        n = n || 0, a = a || 0, this.pdf.internal.out(r(t + n) + " " + i(e + a) + " l");
    }, O = function(t, e, n) {
        return this.pdf.lines(t, e, n, null, null);
    }, B = function(t, e, r, i, o, u, c, l) {
        this.pdf.internal.out([
            n(a(r + t)),
            n(s(i + e)),
            n(a(o + t)),
            n(s(u + e)),
            n(a(c + t)),
            n(s(l + e)),
            "c"
        ].join(" "));
    }, M = function(t, e, n, r) {
        for(var i = 2 * Math.PI, a = Math.PI / 2; e > n;)e -= i;
        var o = Math.abs(n - e);
        o < i && r && (o = i - o);
        for(var s = [], u = r ? -1 : 1, c = e; o > 1e-5;){
            var l = c + u * Math.min(o, a);
            s.push(q.call(this, t, c, l)), o -= Math.abs(l - c), c = l;
        }
        return s;
    }, q = function(t, e, n) {
        var r = (n - e) / 2, i = t * Math.cos(r), a = t * Math.sin(r), o = i, s = -a, u = o * o + s * s, c = u + o * i + s * a, l = 4 / 3 * (Math.sqrt(2 * u * c) - c) / (o * a - s * i), h = o - l * s, f = s + l * o, d = h, p = -f, g = r + e, m = Math.cos(g), v = Math.sin(g);
        return {
            x1: t * Math.cos(e),
            y1: t * Math.sin(e),
            x2: h * m - f * v,
            y2: h * v + f * m,
            x3: d * m - p * v,
            y3: d * v + p * m,
            x4: t * Math.cos(n),
            y4: t * Math.sin(n)
        };
    }, E = function(t) {
        return 180 * t / Math.PI;
    }, R = function(t, e, n, r, i, a) {
        var o = t + .5 * (n - t), s = e + .5 * (r - e), u = i + .5 * (n - i), l = a + .5 * (r - a), h = Math.min(t, i, o, u), f = Math.max(t, i, o, u), d = Math.min(e, a, s, l), p = Math.max(e, a, s, l);
        return new c(h, d, f - h, p - d);
    }, D = function(t, e, n, r, i, a, o, s) {
        var u, l, h, f, d, p, g, m, v, b, y, w, N, L, x = n - t, A = r - e, S = i - n, _ = a - r, P = o - i, k = s - a;
        for(l = 0; l < 41; l++)v = (g = (h = t + (u = l / 40) * x) + u * ((d = n + u * S) - h)) + u * (d + u * (i + u * P - d) - g), b = (m = (f = e + u * A) + u * ((p = r + u * _) - f)) + u * (p + u * (a + u * k - p) - m), 0 == l ? (y = v, w = b, N = v, L = b) : (y = Math.min(y, v), w = Math.min(w, b), N = Math.max(N, v), L = Math.max(L, b));
        return new c(Math.round(y), Math.round(w), Math.round(N - y), Math.round(L - w));
    }, T = function() {
        if (this.prevLineDash || this.ctx.lineDash.length || this.ctx.lineDashOffset) {
            var t, e, n = (t = this.ctx.lineDash, e = this.ctx.lineDashOffset, JSON.stringify({
                lineDash: t,
                lineDashOffset: e
            }));
            this.prevLineDash !== n && (this.pdf.setLineDash(this.ctx.lineDash, this.ctx.lineDashOffset), this.prevLineDash = n);
        }
    };
}($ffaeb8e02004bf5e$export$2e2bcd8739ae039.API), /**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var n = function(t) {
        var e, n, r, i, a, o, s, u, c, l;
        for(/[^\x00-\xFF]/.test(t), n = [], r = 0, i = (t += e = "\0\0\0\0".slice(t.length % 4 || 4)).length; i > r; r += 4)0 !== (a = (t.charCodeAt(r) << 24) + (t.charCodeAt(r + 1) << 16) + (t.charCodeAt(r + 2) << 8) + t.charCodeAt(r + 3)) ? (o = (a = ((a = ((a = ((a = (a - (l = a % 85)) / 85) - (c = a % 85)) / 85) - (u = a % 85)) / 85) - (s = a % 85)) / 85) % 85, n.push(o + 33, s + 33, u + 33, c + 33, l + 33)) : n.push(122);
        return function(t, e) {
            for(var n = e; n > 0; n--)t.pop();
        }(n, e.length), String.fromCharCode.apply(String, n) + "~>";
    }, r = function(t) {
        var e, n, r, i, a, o = String, s = "length", u = 255, c = "charCodeAt", l = "slice", h = "replace";
        for(t[l](-2), t = t[l](0, -2)[h](/\s/g, "")[h]("z", "!!!!!"), r = [], i = 0, a = (t += e = "uuuuu"[l](t[s] % 5 || 5))[s]; a > i; i += 5)n = 52200625 * (t[c](i) - 33) + 614125 * (t[c](i + 1) - 33) + 7225 * (t[c](i + 2) - 33) + 85 * (t[c](i + 3) - 33) + (t[c](i + 4) - 33), r.push(u & n >> 24, u & n >> 16, u & n >> 8, u & n);
        return function(t, e) {
            for(var n = e; n > 0; n--)t.pop();
        }(r, e[s]), o.fromCharCode.apply(o, r);
    }, i = function(t) {
        return t.split("").map(function(t) {
            return ("0" + t.charCodeAt().toString(16)).slice(-2);
        }).join("") + ">";
    }, a = function(t) {
        var e = new RegExp(/^([0-9A-Fa-f]{2})+$/);
        if (-1 !== (t = t.replace(/\s/g, "")).indexOf(">") && (t = t.substr(0, t.indexOf(">"))), t.length % 2 && (t += "0"), !1 === e.test(t)) return "";
        for(var n = "", r = 0; r < t.length; r += 2)n += String.fromCharCode("0x" + (t[r] + t[r + 1]));
        return n;
    }, o = function(t) {
        for(var n = new Uint8Array(t.length), r = t.length; r--;)n[r] = t.charCodeAt(r);
        return (n = (0, $39aa643a4d3f17c3$export$f87121a6d50aff25)(n)).reduce(function(t, e) {
            return t + String.fromCharCode(e);
        }, "");
    };
    t.processDataByFilters = function(t, e) {
        var s = 0, u = t || "", c = [];
        for("string" == typeof (e = e || []) && (e = [
            e
        ]), s = 0; s < e.length; s += 1)switch(e[s]){
            case "ASCII85Decode":
            case "/ASCII85Decode":
                u = r(u), c.push("/ASCII85Encode");
                break;
            case "ASCII85Encode":
            case "/ASCII85Encode":
                u = n(u), c.push("/ASCII85Decode");
                break;
            case "ASCIIHexDecode":
            case "/ASCIIHexDecode":
                u = a(u), c.push("/ASCIIHexEncode");
                break;
            case "ASCIIHexEncode":
            case "/ASCIIHexEncode":
                u = i(u), c.push("/ASCIIHexDecode");
                break;
            case "FlateEncode":
            case "/FlateEncode":
                u = o(u), c.push("/FlateDecode");
                break;
            default:
                throw new Error('The filter: "' + e[s] + '" is not implemented');
        }
        return {
            data: u,
            reverseChain: c.reverse().join(" ")
        };
    };
}($ffaeb8e02004bf5e$export$2e2bcd8739ae039.API), /**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.loadFile = function(t, e, n) {
        return function(t, e, n) {
            e = !1 !== e, n = "function" == typeof n ? n : function() {};
            var r = void 0;
            try {
                r = function(t, e, n) {
                    var r = new XMLHttpRequest, i = 0, a = function(t) {
                        var e = t.length, n = [], r = String.fromCharCode;
                        for(i = 0; i < e; i += 1)n.push(r(255 & t.charCodeAt(i)));
                        return n.join("");
                    };
                    if (r.open("GET", t, !e), r.overrideMimeType("text/plain; charset=x-user-defined"), !1 === e && (r.onload = function() {
                        200 === r.status ? n(a(this.responseText)) : n(void 0);
                    }), r.send(null), e && 200 === r.status) return a(r.responseText);
                }(t, e, n);
            } catch (i) {}
            return r;
        }(t, e, n);
    }, t.loadImageFile = t.loadFile;
}($ffaeb8e02004bf5e$export$2e2bcd8739ae039.API), function(e) {
    function n() {
        return ($ffaeb8e02004bf5e$var$i.html2canvas ? Promise.resolve($ffaeb8e02004bf5e$var$i.html2canvas) : Promise.resolve((parcelRequire("1hFlE")))).catch(function(t) {
            return Promise.reject(new Error("Could not load html2canvas: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    }
    function r() {
        return ($ffaeb8e02004bf5e$var$i.DOMPurify ? Promise.resolve($ffaeb8e02004bf5e$var$i.DOMPurify) : (parcelRequire("jZSRR"))).catch(function(t) {
            return Promise.reject(new Error("Could not load dompurify: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    }
    var a = function(e) {
        var n = (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(e);
        return "undefined" === n ? "undefined" : "string" === n || e instanceof String ? "string" : "number" === n || e instanceof Number ? "number" : "function" === n || e instanceof Function ? "function" : e && e.constructor === Array ? "array" : e && 1 === e.nodeType ? "element" : "object" === n ? "object" : "unknown";
    }, o = function(t, e) {
        var n = document.createElement(t);
        for(var r in e.className && (n.className = e.className), e.innerHTML && e.dompurify && (n.innerHTML = e.dompurify.sanitize(e.innerHTML)), e.style)n.style[r] = e.style[r];
        return n;
    }, s = function t(e, n) {
        for(var r = 3 === e.nodeType ? document.createTextNode(e.nodeValue) : e.cloneNode(!1), i = e.firstChild; i; i = i.nextSibling)!0 !== n && 1 === i.nodeType && "SCRIPT" === i.nodeName || r.appendChild(t(i, n));
        return 1 === e.nodeType && ("CANVAS" === e.nodeName ? (r.width = e.width, r.height = e.height, r.getContext("2d").drawImage(e, 0, 0)) : "TEXTAREA" !== e.nodeName && "SELECT" !== e.nodeName || (r.value = e.value), r.addEventListener("load", function() {
            r.scrollTop = e.scrollTop, r.scrollLeft = e.scrollLeft;
        }, !0)), r;
    }, u = function t(e) {
        var n = Object.assign(t.convert(Promise.resolve()), JSON.parse(JSON.stringify(t.template))), r = t.convert(Promise.resolve(), n);
        return (r = r.setProgress(1, t, 1, [
            t
        ])).set(e);
    };
    (u.prototype = Object.create(Promise.prototype)).constructor = u, u.convert = function(t, e) {
        return t.__proto__ = e || u.prototype, t;
    }, u.template = {
        prop: {
            src: null,
            container: null,
            overlay: null,
            canvas: null,
            img: null,
            pdf: null,
            pageSize: null,
            callback: function() {}
        },
        progress: {
            val: 0,
            state: null,
            n: 0,
            stack: []
        },
        opt: {
            filename: "file.pdf",
            margin: [
                0,
                0,
                0,
                0
            ],
            enableLinks: !0,
            x: 0,
            y: 0,
            html2canvas: {},
            jsPDF: {},
            backgroundColor: "transparent"
        }
    }, u.prototype.from = function(t, e) {
        return this.then(function() {
            switch(e = e || function(t) {
                switch(a(t)){
                    case "string":
                        return "string";
                    case "element":
                        return "canvas" === t.nodeName.toLowerCase() ? "canvas" : "element";
                    default:
                        return "unknown";
                }
            }(t), e){
                case "string":
                    return this.then(r).then(function(e) {
                        return this.set({
                            src: o("div", {
                                innerHTML: t,
                                dompurify: e
                            })
                        });
                    });
                case "element":
                    return this.set({
                        src: t
                    });
                case "canvas":
                    return this.set({
                        canvas: t
                    });
                case "img":
                    return this.set({
                        img: t
                    });
                default:
                    return this.error("Unknown source type.");
            }
        });
    }, u.prototype.to = function(t) {
        switch(t){
            case "container":
                return this.toContainer();
            case "canvas":
                return this.toCanvas();
            case "img":
                return this.toImg();
            case "pdf":
                return this.toPdf();
            default:
                return this.error("Invalid target.");
        }
    }, u.prototype.toContainer = function() {
        return this.thenList([
            function() {
                return this.prop.src || this.error("Cannot duplicate - no source HTML.");
            },
            function() {
                return this.prop.pageSize || this.setPageSize();
            }
        ]).then(function() {
            var t = {
                position: "relative",
                display: "inline-block",
                width: ("number" != typeof this.opt.width || isNaN(this.opt.width) || "number" != typeof this.opt.windowWidth || isNaN(this.opt.windowWidth) ? Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) : this.opt.windowWidth) + "px",
                left: 0,
                right: 0,
                top: 0,
                margin: "auto",
                backgroundColor: this.opt.backgroundColor
            }, e = s(this.prop.src, this.opt.html2canvas.javascriptEnabled);
            "BODY" === e.tagName && (t.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = o("div", {
                className: "html2pdf__overlay",
                style: {
                    position: "fixed",
                    overflow: "hidden",
                    zIndex: 1e3,
                    left: "-100000px",
                    right: 0,
                    bottom: 0,
                    top: 0
                }
            }), this.prop.container = o("div", {
                className: "html2pdf__container",
                style: t
            }), this.prop.container.appendChild(e), this.prop.container.firstChild.appendChild(o("div", {
                style: {
                    clear: "both",
                    border: "0 none transparent",
                    margin: 0,
                    padding: 0,
                    height: 0
                }
            })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
        });
    }, u.prototype.toCanvas = function() {
        var t = [
            function() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        return this.thenList(t).then(n).then(function(t) {
            var e = Object.assign({}, this.opt.html2canvas);
            return delete e.onrendered, t(this.prop.container, e);
        }).then(function(t) {
            (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
    }, u.prototype.toContext2d = function() {
        var t = [
            function() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        return this.thenList(t).then(n).then(function(t) {
            var e = this.opt.jsPDF, n = this.opt.fontFaces, r = "number" != typeof this.opt.width || isNaN(this.opt.width) || "number" != typeof this.opt.windowWidth || isNaN(this.opt.windowWidth) ? 1 : this.opt.width / this.opt.windowWidth, i = Object.assign({
                async: !0,
                allowTaint: !0,
                scale: r,
                scrollX: this.opt.scrollX || 0,
                scrollY: this.opt.scrollY || 0,
                backgroundColor: "#ffffff",
                imageTimeout: 15e3,
                logging: !0,
                proxy: null,
                removeContainer: !0,
                foreignObjectRendering: !1,
                useCORS: !1
            }, this.opt.html2canvas);
            if (delete i.onrendered, e.context2d.autoPaging = void 0 === this.opt.autoPaging || this.opt.autoPaging, e.context2d.posX = this.opt.x, e.context2d.posY = this.opt.y, e.context2d.margin = this.opt.margin, e.context2d.fontFaces = n, n) for(var a = 0; a < n.length; ++a){
                var o = n[a], s = o.src.find(function(t) {
                    return "truetype" === t.format;
                });
                s && e.addFont(s.url, o.ref.name, o.ref.style);
            }
            return i.windowHeight = i.windowHeight || 0, i.windowHeight = 0 == i.windowHeight ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : i.windowHeight, e.context2d.save(!0), t(this.prop.container, i);
        }).then(function(t) {
            this.opt.jsPDF.context2d.restore(!0), (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
    }, u.prototype.toImg = function() {
        return this.thenList([
            function() {
                return this.prop.canvas || this.toCanvas();
            }
        ]).then(function() {
            var t = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
            this.prop.img = document.createElement("img"), this.prop.img.src = t;
        });
    }, u.prototype.toPdf = function() {
        return this.thenList([
            function() {
                return this.toContext2d();
            }
        ]).then(function() {
            this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
        });
    }, u.prototype.output = function(t, e, n) {
        return "img" === (n = n || "pdf").toLowerCase() || "image" === n.toLowerCase() ? this.outputImg(t, e) : this.outputPdf(t, e);
    }, u.prototype.outputPdf = function(t, e) {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).then(function() {
            return this.prop.pdf.output(t, e);
        });
    }, u.prototype.outputImg = function(t) {
        return this.thenList([
            function() {
                return this.prop.img || this.toImg();
            }
        ]).then(function() {
            switch(t){
                case void 0:
                case "img":
                    return this.prop.img;
                case "datauristring":
                case "dataurlstring":
                    return this.prop.img.src;
                case "datauri":
                case "dataurl":
                    return document.location.href = this.prop.img.src;
                default:
                    throw 'Image output type "' + t + '" is not supported.';
            }
        });
    }, u.prototype.save = function(t) {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).set(t ? {
            filename: t
        } : null).then(function() {
            this.prop.pdf.save(this.opt.filename);
        });
    }, u.prototype.doCallback = function() {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).then(function() {
            this.prop.callback(this.prop.pdf);
        });
    }, u.prototype.set = function(t) {
        if ("object" !== a(t)) return this;
        var e = Object.keys(t || {}).map(function(e) {
            if (e in u.template.prop) return function() {
                this.prop[e] = t[e];
            };
            switch(e){
                case "margin":
                    return this.setMargin.bind(this, t.margin);
                case "jsPDF":
                    return function() {
                        return this.opt.jsPDF = t.jsPDF, this.setPageSize();
                    };
                case "pageSize":
                    return this.setPageSize.bind(this, t.pageSize);
                default:
                    return function() {
                        this.opt[e] = t[e];
                    };
            }
        }, this);
        return this.then(function() {
            return this.thenList(e);
        });
    }, u.prototype.get = function(t, e) {
        return this.then(function() {
            var n = t in u.template.prop ? this.prop[t] : this.opt[t];
            return e ? e(n) : n;
        });
    }, u.prototype.setMargin = function(t) {
        return this.then(function() {
            switch(a(t)){
                case "number":
                    t = [
                        t,
                        t,
                        t,
                        t
                    ];
                case "array":
                    if (2 === t.length && (t = [
                        t[0],
                        t[1],
                        t[0],
                        t[1]
                    ]), 4 === t.length) break;
                default:
                    return this.error("Invalid margin array.");
            }
            this.opt.margin = t;
        }).then(this.setPageSize);
    }, u.prototype.setPageSize = function(t) {
        function e(t, e) {
            return Math.floor(t * e / 72 * 96);
        }
        return this.then(function() {
            (t = t || $ffaeb8e02004bf5e$export$2e2bcd8739ae039.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (t.inner = {
                width: t.width - this.opt.margin[1] - this.opt.margin[3],
                height: t.height - this.opt.margin[0] - this.opt.margin[2]
            }, t.inner.px = {
                width: e(t.inner.width, t.k),
                height: e(t.inner.height, t.k)
            }, t.inner.ratio = t.inner.height / t.inner.width), this.prop.pageSize = t;
        });
    }, u.prototype.setProgress = function(t, e, n, r) {
        return null != t && (this.progress.val = t), null != e && (this.progress.state = e), null != n && (this.progress.n = n), null != r && (this.progress.stack = r), this.progress.ratio = this.progress.val / this.progress.state, this;
    }, u.prototype.updateProgress = function(t, e, n, r) {
        return this.setProgress(t ? this.progress.val + t : null, e || null, n ? this.progress.n + n : null, r ? this.progress.stack.concat(r) : null);
    }, u.prototype.then = function(t, e) {
        var n = this;
        return this.thenCore(t, e, function(t, e) {
            return n.updateProgress(null, null, 1, [
                t
            ]), Promise.prototype.then.call(this, function(e) {
                return n.updateProgress(null, t), e;
            }).then(t, e).then(function(t) {
                return n.updateProgress(1), t;
            });
        });
    }, u.prototype.thenCore = function(t, e, n) {
        n = n || Promise.prototype.then;
        var r = this;
        t && (t = t.bind(r)), e && (e = e.bind(r));
        var i = -1 !== Promise.toString().indexOf("[native code]") && "Promise" === Promise.name ? r : u.convert(Object.assign({}, r), Promise.prototype), a = n.call(i, t, e);
        return u.convert(a, r.__proto__);
    }, u.prototype.thenExternal = function(t, e) {
        return Promise.prototype.then.call(this, t, e);
    }, u.prototype.thenList = function(t) {
        var e = this;
        return t.forEach(function(t) {
            e = e.thenCore(t);
        }), e;
    }, u.prototype.catch = function(t) {
        t && (t = t.bind(this));
        var e = Promise.prototype.catch.call(this, t);
        return u.convert(e, this);
    }, u.prototype.catchExternal = function(t) {
        return Promise.prototype.catch.call(this, t);
    }, u.prototype.error = function(t) {
        return this.then(function() {
            throw new Error(t);
        });
    }, u.prototype.using = u.prototype.set, u.prototype.saveAs = u.prototype.save, u.prototype.export = u.prototype.output, u.prototype.run = u.prototype.then, $ffaeb8e02004bf5e$export$2e2bcd8739ae039.getPageSize = function(e, n, r) {
        if ("object" === (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(e)) {
            var i = e;
            e = i.orientation, n = i.unit || n, r = i.format || r;
        }
        n = n || "mm", r = r || "a4", e = ("" + (e || "P")).toLowerCase();
        var a, o = ("" + r).toLowerCase(), s = {
            a0: [
                2383.94,
                3370.39
            ],
            a1: [
                1683.78,
                2383.94
            ],
            a2: [
                1190.55,
                1683.78
            ],
            a3: [
                841.89,
                1190.55
            ],
            a4: [
                595.28,
                841.89
            ],
            a5: [
                419.53,
                595.28
            ],
            a6: [
                297.64,
                419.53
            ],
            a7: [
                209.76,
                297.64
            ],
            a8: [
                147.4,
                209.76
            ],
            a9: [
                104.88,
                147.4
            ],
            a10: [
                73.7,
                104.88
            ],
            b0: [
                2834.65,
                4008.19
            ],
            b1: [
                2004.09,
                2834.65
            ],
            b2: [
                1417.32,
                2004.09
            ],
            b3: [
                1000.63,
                1417.32
            ],
            b4: [
                708.66,
                1000.63
            ],
            b5: [
                498.9,
                708.66
            ],
            b6: [
                354.33,
                498.9
            ],
            b7: [
                249.45,
                354.33
            ],
            b8: [
                175.75,
                249.45
            ],
            b9: [
                124.72,
                175.75
            ],
            b10: [
                87.87,
                124.72
            ],
            c0: [
                2599.37,
                3676.54
            ],
            c1: [
                1836.85,
                2599.37
            ],
            c2: [
                1298.27,
                1836.85
            ],
            c3: [
                918.43,
                1298.27
            ],
            c4: [
                649.13,
                918.43
            ],
            c5: [
                459.21,
                649.13
            ],
            c6: [
                323.15,
                459.21
            ],
            c7: [
                229.61,
                323.15
            ],
            c8: [
                161.57,
                229.61
            ],
            c9: [
                113.39,
                161.57
            ],
            c10: [
                79.37,
                113.39
            ],
            dl: [
                311.81,
                623.62
            ],
            letter: [
                612,
                792
            ],
            "government-letter": [
                576,
                756
            ],
            legal: [
                612,
                1008
            ],
            "junior-legal": [
                576,
                360
            ],
            ledger: [
                1224,
                792
            ],
            tabloid: [
                792,
                1224
            ],
            "credit-card": [
                153,
                243
            ]
        };
        switch(n){
            case "pt":
                a = 1;
                break;
            case "mm":
                a = 72 / 25.4;
                break;
            case "cm":
                a = 72 / 2.54;
                break;
            case "in":
                a = 72;
                break;
            case "px":
                a = .75;
                break;
            case "pc":
            case "em":
                a = 12;
                break;
            case "ex":
                a = 6;
                break;
            default:
                throw "Invalid unit: " + n;
        }
        var u, c = 0, l = 0;
        if (s.hasOwnProperty(o)) c = s[o][1] / a, l = s[o][0] / a;
        else try {
            c = r[1], l = r[0];
        } catch (h) {
            throw new Error("Invalid format: " + r);
        }
        if ("p" === e || "portrait" === e) e = "p", l > c && (u = l, l = c, c = u);
        else {
            if ("l" !== e && "landscape" !== e) throw "Invalid orientation: " + e;
            e = "l", c > l && (u = l, l = c, c = u);
        }
        return {
            width: l,
            height: c,
            unit: n,
            k: a,
            orientation: e
        };
    }, e.html = function(t, e) {
        (e = e || {}).callback = e.callback || function() {}, e.html2canvas = e.html2canvas || {}, e.html2canvas.canvas = e.html2canvas.canvas || this.canvas, e.jsPDF = e.jsPDF || this, e.fontFaces = e.fontFaces ? e.fontFaces.map($ffaeb8e02004bf5e$var$Ct) : null;
        var n = new u(e);
        return e.worker ? n : n.from(t).doCallback();
    };
}($ffaeb8e02004bf5e$export$2e2bcd8739ae039.API), $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.addJS = function(t) {
    return $ffaeb8e02004bf5e$var$Ut = t, this.internal.events.subscribe("postPutResources", function() {
        $ffaeb8e02004bf5e$var$Tt = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + ($ffaeb8e02004bf5e$var$Tt + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), $ffaeb8e02004bf5e$var$zt = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + $ffaeb8e02004bf5e$var$Ut + ")"), this.internal.out(">>"), this.internal.out("endobj");
    }), this.internal.events.subscribe("putCatalog", function() {
        void 0 !== $ffaeb8e02004bf5e$var$Tt && void 0 !== $ffaeb8e02004bf5e$var$zt && this.internal.out("/Names <</JavaScript " + $ffaeb8e02004bf5e$var$Tt + " 0 R>>");
    }), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e;
    t.events.push([
        "postPutResources",
        function() {
            var t = this, n = /^(\d+) 0 obj$/;
            if (this.outline.root.children.length > 0) for(var r = t.outline.render().split(/\r\n/), i = 0; i < r.length; i++){
                var a = r[i], o = n.exec(a);
                if (null != o) {
                    var s = o[1];
                    t.internal.newObjectDeferredBegin(s, !1);
                }
                t.internal.write(a);
            }
            if (this.outline.createNamedDestinations) {
                var u = this.internal.pages.length, c = [];
                for(i = 0; i < u; i++){
                    var l = t.internal.newObject();
                    c.push(l);
                    var h = t.internal.getPageInfo(i + 1);
                    t.internal.write("<< /D[" + h.objId + " 0 R /XYZ null null null]>> endobj");
                }
                var f = t.internal.newObject();
                for(t.internal.write("<< /Names [ "), i = 0; i < c.length; i++)t.internal.write("(page_" + (i + 1) + ")" + c[i] + " 0 R");
                t.internal.write(" ] >>", "endobj"), e = t.internal.newObject(), t.internal.write("<< /Dests " + f + " 0 R"), t.internal.write(">>", "endobj");
            }
        }
    ]), t.events.push([
        "putCatalog",
        function() {
            var t = this;
            t.outline.root.children.length > 0 && (t.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && t.internal.write("/Names " + e + " 0 R"));
        }
    ]), t.events.push([
        "initialized",
        function() {
            var t = this;
            t.outline = {
                createNamedDestinations: !1,
                root: {
                    children: []
                }
            }, t.outline.add = function(t, e, n) {
                var r = {
                    title: e,
                    options: n,
                    children: []
                };
                return null == t && (t = this.root), t.children.push(r), r;
            }, t.outline.render = function() {
                return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = t, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
            }, t.outline.genIds_r = function(e) {
                e.id = t.internal.newObjectDeferred();
                for(var n = 0; n < e.children.length; n++)this.genIds_r(e.children[n]);
            }, t.outline.renderRoot = function(t) {
                this.objStart(t), this.line("/Type /Outlines"), t.children.length > 0 && (this.line("/First " + this.makeRef(t.children[0])), this.line("/Last " + this.makeRef(t.children[t.children.length - 1]))), this.line("/Count " + this.count_r({
                    count: 0
                }, t)), this.objEnd();
            }, t.outline.renderItems = function(e) {
                for(var n = this.ctx.pdf.internal.getVerticalCoordinateString, r = 0; r < e.children.length; r++){
                    var i = e.children[r];
                    this.objStart(i), this.line("/Title " + this.makeString(i.title)), this.line("/Parent " + this.makeRef(e)), r > 0 && this.line("/Prev " + this.makeRef(e.children[r - 1])), r < e.children.length - 1 && this.line("/Next " + this.makeRef(e.children[r + 1])), i.children.length > 0 && (this.line("/First " + this.makeRef(i.children[0])), this.line("/Last " + this.makeRef(i.children[i.children.length - 1])));
                    var a = this.count = this.count_r({
                        count: 0
                    }, i);
                    if (a > 0 && this.line("/Count " + a), i.options && i.options.pageNumber) {
                        var o = t.internal.getPageInfo(i.options.pageNumber);
                        this.line("/Dest [" + o.objId + " 0 R /XYZ 0 " + n(0) + " 0]");
                    }
                    this.objEnd();
                }
                for(var s = 0; s < e.children.length; s++)this.renderItems(e.children[s]);
            }, t.outline.line = function(t) {
                this.ctx.val += t + "\r\n";
            }, t.outline.makeRef = function(t) {
                return t.id + " 0 R";
            }, t.outline.makeString = function(e) {
                return "(" + t.internal.pdfEscape(e) + ")";
            }, t.outline.objStart = function(t) {
                this.ctx.val += "\r\n" + t.id + " 0 obj\r\n<<\r\n";
            }, t.outline.objEnd = function() {
                this.ctx.val += ">> \r\nendobj\r\n";
            }, t.outline.count_r = function(t, e) {
                for(var n = 0; n < e.children.length; n++)t.count++, this.count_r(t, e.children[n]);
                return t.count;
            };
        }
    ]);
}($ffaeb8e02004bf5e$export$2e2bcd8739ae039.API), /**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = [
        192,
        193,
        194,
        195,
        196,
        197,
        198,
        199
    ];
    t.processJPEG = function(t, n, r, i, a, o) {
        var s, u = this.decode.DCT_DECODE, c = null;
        if ("string" == typeof t || this.__addimage__.isArrayBuffer(t) || this.__addimage__.isArrayBufferView(t)) {
            switch(t = a || t, t = this.__addimage__.isArrayBuffer(t) ? new Uint8Array(t) : t, s = function(t) {
                for(var n, r = 256 * t.charCodeAt(4) + t.charCodeAt(5), i = t.length, a = {
                    width: 0,
                    height: 0,
                    numcomponents: 1
                }, o = 4; o < i; o += 2){
                    if (o += r, -1 !== e.indexOf(t.charCodeAt(o + 1))) {
                        n = 256 * t.charCodeAt(o + 5) + t.charCodeAt(o + 6), a = {
                            width: 256 * t.charCodeAt(o + 7) + t.charCodeAt(o + 8),
                            height: n,
                            numcomponents: t.charCodeAt(o + 9)
                        };
                        break;
                    }
                    r = 256 * t.charCodeAt(o + 2) + t.charCodeAt(o + 3);
                }
                return a;
            }(t = this.__addimage__.isArrayBufferView(t) ? this.__addimage__.arrayBufferToBinaryString(t) : t), s.numcomponents){
                case 1:
                    o = this.color_spaces.DEVICE_GRAY;
                    break;
                case 4:
                    o = this.color_spaces.DEVICE_CMYK;
                    break;
                case 3:
                    o = this.color_spaces.DEVICE_RGB;
            }
            c = {
                data: t,
                width: s.width,
                height: s.height,
                colorSpace: o,
                bitsPerComponent: 8,
                filter: u,
                index: n,
                alias: r
            };
        }
        return c;
    };
}($ffaeb8e02004bf5e$export$2e2bcd8739ae039.API), $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.processPNG = function(t, i, a, o) {
    if (this.__addimage__.isArrayBuffer(t) && (t = new Uint8Array(t)), this.__addimage__.isArrayBufferView(t)) {
        var s, u = (0, $dfd807573f842b61$export$2f872c0f2117be69)(t, {
            checkCrc: !0
        }), c = u.width, l = u.height, h = u.channels, f = u.palette, d = u.depth;
        s = f && 1 === h ? function(t) {
            for(var e = t.width, r = t.height, i = t.data, a = t.palette, o = t.depth, s = !1, u = [], c = [], l = void 0, h = !1, f = 0, d = 0; d < a.length; d++){
                var p = (0, (/*@__PURE__*/$parcel$interopDefault($66525ca70e76a405$exports)))(a[d], 4), g = p[0], m = p[1], v = p[2], b = p[3];
                u.push(g, m, v), null != b && (0 === b ? (f++, c.length < 1 && c.push(d)) : b < 255 && (h = !0));
            }
            if (h || f > 1) {
                s = !0, c = void 0;
                var y = e * r;
                l = new Uint8Array(y);
                for(var w = new DataView(i.buffer), N = 0; N < y; N++){
                    var L = $ffaeb8e02004bf5e$var$re(w, N, o), x = (0, (/*@__PURE__*/$parcel$interopDefault($66525ca70e76a405$exports)))(a[L], 4)[3];
                    l[N] = x;
                }
            } else 0 === f && (c = void 0);
            return {
                colorSpace: "Indexed",
                colorsPerPixel: 1,
                sMaskBitsPerComponent: s ? 8 : void 0,
                colorBytes: i,
                alphaBytes: l,
                needSMask: s,
                palette: u,
                mask: c
            };
        }(u) : 2 === h || 4 === h ? function(t) {
            for(var e = t.data, n = t.width, r = t.height, i = t.channels, a = t.depth, o = 2 === i ? "DeviceGray" : "DeviceRGB", s = i - 1, u = n * r, c = s, l = u * c, h = 1 * u, f = Math.ceil(l * a / 8), d = Math.ceil(h * a / 8), p = new Uint8Array(f), g = new Uint8Array(d), m = new DataView(e.buffer), v = new DataView(p.buffer), b = new DataView(g.buffer), y = !1, w = 0; w < u; w++){
                for(var N = w * i, L = 0; L < c; L++)$ffaeb8e02004bf5e$var$ie(v, $ffaeb8e02004bf5e$var$re(m, N + L, a), w * c + L, a);
                var x = $ffaeb8e02004bf5e$var$re(m, N + c, a);
                x < (1 << a) - 1 && (y = !0), $ffaeb8e02004bf5e$var$ie(b, x, 1 * w, a);
            }
            return {
                colorSpace: o,
                colorsPerPixel: s,
                sMaskBitsPerComponent: y ? a : void 0,
                colorBytes: p,
                alphaBytes: g,
                needSMask: y
            };
        }(u) : function(t) {
            var e = t.data, n = 1 === t.channels ? "DeviceGray" : "DeviceRGB";
            return {
                colorSpace: n,
                colorsPerPixel: "DeviceGray" === n ? 1 : 3,
                colorBytes: e instanceof Uint16Array ? function(t) {
                    for(var e = t.length, n = new Uint8Array(2 * e), r = new DataView(n.buffer, n.byteOffset, n.byteLength), i = 0; i < e; i++)r.setUint16(2 * i, t[i], !1);
                    return n;
                }(e) : e,
                needSMask: !1
            };
        }(u);
        var p, g, m, v = s, b = v.colorSpace, y = v.colorsPerPixel, w = v.sMaskBitsPerComponent, N = v.colorBytes, L = v.alphaBytes, x = v.needSMask, A = v.palette, S = v.mask, _ = null;
        return o !== $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.image_compression.NONE && "function" == typeof (0, $39aa643a4d3f17c3$export$f87121a6d50aff25) ? (_ = function(t) {
            var e;
            switch(t){
                case $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.image_compression.FAST:
                    e = 11;
                    break;
                case $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.image_compression.MEDIUM:
                    e = 13;
                    break;
                case $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.image_compression.SLOW:
                    e = 14;
                    break;
                default:
                    e = 12;
            }
            return e;
        }(o), p = this.decode.FLATE_DECODE, g = "/Predictor ".concat(_, " /Colors ").concat(y, " /BitsPerComponent ").concat(d, " /Columns ").concat(c), t = $ffaeb8e02004bf5e$var$Xt(N, Math.ceil(c * y * d / 8), y, d, o), x && (m = $ffaeb8e02004bf5e$var$Xt(L, Math.ceil(c * w / 8), 1, w, o))) : (p = void 0, g = void 0, t = N, x && (m = L)), (this.__addimage__.isArrayBuffer(t) || this.__addimage__.isArrayBufferView(t)) && (t = this.__addimage__.arrayBufferToBinaryString(t)), (m && this.__addimage__.isArrayBuffer(m) || this.__addimage__.isArrayBufferView(m)) && (m = this.__addimage__.arrayBufferToBinaryString(m)), {
            alias: a,
            data: t,
            index: i,
            filter: p,
            decodeParameters: g,
            transparency: S,
            palette: A,
            sMask: m,
            predictor: _,
            width: c,
            height: l,
            bitsPerComponent: d,
            sMaskBitsPerComponent: w,
            colorSpace: b
        };
    }
}, function(t) {
    t.processGIF89A = function(e, n, r, i) {
        var a = new $ffaeb8e02004bf5e$var$oe(e), o = a.width, s = a.height, u = [];
        a.decodeAndBlitFrameRGBA(0, u);
        var c = {
            data: u,
            width: o,
            height: s
        }, l = new $ffaeb8e02004bf5e$var$ue(100).encode(c, 100);
        return t.processJPEG.call(this, l, n, r, i);
    }, t.processGIF87A = t.processGIF89A;
}($ffaeb8e02004bf5e$export$2e2bcd8739ae039.API), $ffaeb8e02004bf5e$var$ce.prototype.parseHeader = function() {
    if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, 16 === this.bitPP && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
        var t = 0 === this.colors ? 1 << this.bitPP : this.colors;
        this.palette = new Array(t);
        for(var e = 0; e < t; e++){
            var n = this.datav.getUint8(this.pos++, !0), r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0);
            this.palette[e] = {
                red: i,
                green: r,
                blue: n,
                quad: a
            };
        }
    }
    this.height < 0 && (this.height *= -1, this.bottom_up = !1);
}, $ffaeb8e02004bf5e$var$ce.prototype.parseBGR = function() {
    this.pos = this.offset;
    try {
        var t = "bit" + this.bitPP, e = this.width * this.height * 4;
        this.data = new Uint8Array(e), this[t]();
    } catch (n) {
        $ffaeb8e02004bf5e$var$o.log("bit decode error:" + n);
    }
}, $ffaeb8e02004bf5e$var$ce.prototype.bit1 = function() {
    var t, e = Math.ceil(this.width / 8), n = e % 4;
    for(t = this.height - 1; t >= 0; t--){
        for(var r = this.bottom_up ? t : this.height - 1 - t, i = 0; i < e; i++)for(var a = this.datav.getUint8(this.pos++, !0), o = r * this.width * 4 + 8 * i * 4, s = 0; s < 8 && 8 * i + s < this.width; s++){
            var u = this.palette[a >> 7 - s & 1];
            this.data[o + 4 * s] = u.blue, this.data[o + 4 * s + 1] = u.green, this.data[o + 4 * s + 2] = u.red, this.data[o + 4 * s + 3] = 255;
        }
        0 !== n && (this.pos += 4 - n);
    }
}, $ffaeb8e02004bf5e$var$ce.prototype.bit4 = function() {
    for(var t = Math.ceil(this.width / 2), e = t % 4, n = this.height - 1; n >= 0; n--){
        for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < t; i++){
            var a = this.datav.getUint8(this.pos++, !0), o = r * this.width * 4 + 2 * i * 4, s = a >> 4, u = 15 & a, c = this.palette[s];
            if (this.data[o] = c.blue, this.data[o + 1] = c.green, this.data[o + 2] = c.red, this.data[o + 3] = 255, 2 * i + 1 >= this.width) break;
            c = this.palette[u], this.data[o + 4] = c.blue, this.data[o + 4 + 1] = c.green, this.data[o + 4 + 2] = c.red, this.data[o + 4 + 3] = 255;
        }
        0 !== e && (this.pos += 4 - e);
    }
}, $ffaeb8e02004bf5e$var$ce.prototype.bit8 = function() {
    for(var t = this.width % 4, e = this.height - 1; e >= 0; e--){
        for(var n = this.bottom_up ? e : this.height - 1 - e, r = 0; r < this.width; r++){
            var i = this.datav.getUint8(this.pos++, !0), a = n * this.width * 4 + 4 * r;
            if (i < this.palette.length) {
                var o = this.palette[i];
                this.data[a] = o.red, this.data[a + 1] = o.green, this.data[a + 2] = o.blue, this.data[a + 3] = 255;
            } else this.data[a] = 255, this.data[a + 1] = 255, this.data[a + 2] = 255, this.data[a + 3] = 255;
        }
        0 !== t && (this.pos += 4 - t);
    }
}, $ffaeb8e02004bf5e$var$ce.prototype.bit15 = function() {
    for(var t = this.width % 3, e = parseInt("11111", 2), n = this.height - 1; n >= 0; n--){
        for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < this.width; i++){
            var a = this.datav.getUint16(this.pos, !0);
            this.pos += 2;
            var o = (a & e) / e * 255 | 0, s = (a >> 5 & e) / e * 255 | 0, u = (a >> 10 & e) / e * 255 | 0, c = a >> 15 ? 255 : 0, l = r * this.width * 4 + 4 * i;
            this.data[l] = u, this.data[l + 1] = s, this.data[l + 2] = o, this.data[l + 3] = c;
        }
        this.pos += t;
    }
}, $ffaeb8e02004bf5e$var$ce.prototype.bit16 = function() {
    for(var t = this.width % 3, e = parseInt("11111", 2), n = parseInt("111111", 2), r = this.height - 1; r >= 0; r--){
        for(var i = this.bottom_up ? r : this.height - 1 - r, a = 0; a < this.width; a++){
            var o = this.datav.getUint16(this.pos, !0);
            this.pos += 2;
            var s = (o & e) / e * 255 | 0, u = (o >> 5 & n) / n * 255 | 0, c = (o >> 11) / e * 255 | 0, l = i * this.width * 4 + 4 * a;
            this.data[l] = c, this.data[l + 1] = u, this.data[l + 2] = s, this.data[l + 3] = 255;
        }
        this.pos += t;
    }
}, $ffaeb8e02004bf5e$var$ce.prototype.bit24 = function() {
    for(var t = this.height - 1; t >= 0; t--){
        for(var e = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++){
            var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = e * this.width * 4 + 4 * n;
            this.data[o] = a, this.data[o + 1] = i, this.data[o + 2] = r, this.data[o + 3] = 255;
        }
        this.pos += this.width % 4;
    }
}, $ffaeb8e02004bf5e$var$ce.prototype.bit32 = function() {
    for(var t = this.height - 1; t >= 0; t--)for(var e = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++){
        var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), s = e * this.width * 4 + 4 * n;
        this.data[s] = a, this.data[s + 1] = i, this.data[s + 2] = r, this.data[s + 3] = o;
    }
}, $ffaeb8e02004bf5e$var$ce.prototype.getData = function() {
    return this.data;
}, /**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.processBMP = function(e, n, r, i) {
        var a = new $ffaeb8e02004bf5e$var$ce(e, !1), o = a.width, s = a.height, u = {
            data: a.getData(),
            width: o,
            height: s
        }, c = new $ffaeb8e02004bf5e$var$ue(100).encode(u, 100);
        return t.processJPEG.call(this, c, n, r, i);
    };
}($ffaeb8e02004bf5e$export$2e2bcd8739ae039.API), $ffaeb8e02004bf5e$var$le.prototype.getData = function() {
    return this.data;
}, /**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.processWEBP = function(e, n, r, i) {
        var a = new $ffaeb8e02004bf5e$var$le(e), o = a.width, s = a.height, u = {
            data: a.getData(),
            width: o,
            height: s
        }, c = new $ffaeb8e02004bf5e$var$ue(100).encode(u, 100);
        return t.processJPEG.call(this, c, n, r, i);
    };
}($ffaeb8e02004bf5e$export$2e2bcd8739ae039.API), $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.processRGBA = function(t, e, n) {
    for(var r = t.data, i = r.length, a = new Uint8Array(i / 4 * 3), o = new Uint8Array(i / 4), s = 0, u = 0, c = 0; c < i; c += 4){
        var l = r[c], h = r[c + 1], f = r[c + 2], d = r[c + 3];
        a[s++] = l, a[s++] = h, a[s++] = f, o[u++] = d;
    }
    var p = this.__addimage__.arrayBufferToBinaryString(a);
    return {
        alpha: this.__addimage__.arrayBufferToBinaryString(o),
        data: p,
        index: e,
        alias: n,
        colorSpace: "DeviceRGB",
        bitsPerComponent: 8,
        width: t.width,
        height: t.height
    };
}, $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.setLanguage = function(t) {
    return void 0 === this.internal.languageSettings && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), void 0 !== ({
        af: "Afrikaans",
        sq: "Albanian",
        ar: "Arabic (Standard)",
        "ar-DZ": "Arabic (Algeria)",
        "ar-BH": "Arabic (Bahrain)",
        "ar-EG": "Arabic (Egypt)",
        "ar-IQ": "Arabic (Iraq)",
        "ar-JO": "Arabic (Jordan)",
        "ar-KW": "Arabic (Kuwait)",
        "ar-LB": "Arabic (Lebanon)",
        "ar-LY": "Arabic (Libya)",
        "ar-MA": "Arabic (Morocco)",
        "ar-OM": "Arabic (Oman)",
        "ar-QA": "Arabic (Qatar)",
        "ar-SA": "Arabic (Saudi Arabia)",
        "ar-SY": "Arabic (Syria)",
        "ar-TN": "Arabic (Tunisia)",
        "ar-AE": "Arabic (U.A.E.)",
        "ar-YE": "Arabic (Yemen)",
        an: "Aragonese",
        hy: "Armenian",
        as: "Assamese",
        ast: "Asturian",
        az: "Azerbaijani",
        eu: "Basque",
        be: "Belarusian",
        bn: "Bengali",
        bs: "Bosnian",
        br: "Breton",
        bg: "Bulgarian",
        my: "Burmese",
        ca: "Catalan",
        ch: "Chamorro",
        ce: "Chechen",
        zh: "Chinese",
        "zh-HK": "Chinese (Hong Kong)",
        "zh-CN": "Chinese (PRC)",
        "zh-SG": "Chinese (Singapore)",
        "zh-TW": "Chinese (Taiwan)",
        cv: "Chuvash",
        co: "Corsican",
        cr: "Cree",
        hr: "Croatian",
        cs: "Czech",
        da: "Danish",
        nl: "Dutch (Standard)",
        "nl-BE": "Dutch (Belgian)",
        en: "English",
        "en-AU": "English (Australia)",
        "en-BZ": "English (Belize)",
        "en-CA": "English (Canada)",
        "en-IE": "English (Ireland)",
        "en-JM": "English (Jamaica)",
        "en-NZ": "English (New Zealand)",
        "en-PH": "English (Philippines)",
        "en-ZA": "English (South Africa)",
        "en-TT": "English (Trinidad & Tobago)",
        "en-GB": "English (United Kingdom)",
        "en-US": "English (United States)",
        "en-ZW": "English (Zimbabwe)",
        eo: "Esperanto",
        et: "Estonian",
        fo: "Faeroese",
        fj: "Fijian",
        fi: "Finnish",
        fr: "French (Standard)",
        "fr-BE": "French (Belgium)",
        "fr-CA": "French (Canada)",
        "fr-FR": "French (France)",
        "fr-LU": "French (Luxembourg)",
        "fr-MC": "French (Monaco)",
        "fr-CH": "French (Switzerland)",
        fy: "Frisian",
        fur: "Friulian",
        gd: "Gaelic (Scots)",
        "gd-IE": "Gaelic (Irish)",
        gl: "Galacian",
        ka: "Georgian",
        de: "German (Standard)",
        "de-AT": "German (Austria)",
        "de-DE": "German (Germany)",
        "de-LI": "German (Liechtenstein)",
        "de-LU": "German (Luxembourg)",
        "de-CH": "German (Switzerland)",
        el: "Greek",
        gu: "Gujurati",
        ht: "Haitian",
        he: "Hebrew",
        hi: "Hindi",
        hu: "Hungarian",
        is: "Icelandic",
        id: "Indonesian",
        iu: "Inuktitut",
        ga: "Irish",
        it: "Italian (Standard)",
        "it-CH": "Italian (Switzerland)",
        ja: "Japanese",
        kn: "Kannada",
        ks: "Kashmiri",
        kk: "Kazakh",
        km: "Khmer",
        ky: "Kirghiz",
        tlh: "Klingon",
        ko: "Korean",
        "ko-KP": "Korean (North Korea)",
        "ko-KR": "Korean (South Korea)",
        la: "Latin",
        lv: "Latvian",
        lt: "Lithuanian",
        lb: "Luxembourgish",
        mk: "North Macedonia",
        ms: "Malay",
        ml: "Malayalam",
        mt: "Maltese",
        mi: "Maori",
        mr: "Marathi",
        mo: "Moldavian",
        nv: "Navajo",
        ng: "Ndonga",
        ne: "Nepali",
        no: "Norwegian",
        nb: "Norwegian (Bokmal)",
        nn: "Norwegian (Nynorsk)",
        oc: "Occitan",
        or: "Oriya",
        om: "Oromo",
        fa: "Persian",
        "fa-IR": "Persian/Iran",
        pl: "Polish",
        pt: "Portuguese",
        "pt-BR": "Portuguese (Brazil)",
        pa: "Punjabi",
        "pa-IN": "Punjabi (India)",
        "pa-PK": "Punjabi (Pakistan)",
        qu: "Quechua",
        rm: "Rhaeto-Romanic",
        ro: "Romanian",
        "ro-MO": "Romanian (Moldavia)",
        ru: "Russian",
        "ru-MO": "Russian (Moldavia)",
        sz: "Sami (Lappish)",
        sg: "Sango",
        sa: "Sanskrit",
        sc: "Sardinian",
        sd: "Sindhi",
        si: "Singhalese",
        sr: "Serbian",
        sk: "Slovak",
        sl: "Slovenian",
        so: "Somani",
        sb: "Sorbian",
        es: "Spanish",
        "es-AR": "Spanish (Argentina)",
        "es-BO": "Spanish (Bolivia)",
        "es-CL": "Spanish (Chile)",
        "es-CO": "Spanish (Colombia)",
        "es-CR": "Spanish (Costa Rica)",
        "es-DO": "Spanish (Dominican Republic)",
        "es-EC": "Spanish (Ecuador)",
        "es-SV": "Spanish (El Salvador)",
        "es-GT": "Spanish (Guatemala)",
        "es-HN": "Spanish (Honduras)",
        "es-MX": "Spanish (Mexico)",
        "es-NI": "Spanish (Nicaragua)",
        "es-PA": "Spanish (Panama)",
        "es-PY": "Spanish (Paraguay)",
        "es-PE": "Spanish (Peru)",
        "es-PR": "Spanish (Puerto Rico)",
        "es-ES": "Spanish (Spain)",
        "es-UY": "Spanish (Uruguay)",
        "es-VE": "Spanish (Venezuela)",
        sx: "Sutu",
        sw: "Swahili",
        sv: "Swedish",
        "sv-FI": "Swedish (Finland)",
        "sv-SV": "Swedish (Sweden)",
        ta: "Tamil",
        tt: "Tatar",
        te: "Teluga",
        th: "Thai",
        tig: "Tigre",
        ts: "Tsonga",
        tn: "Tswana",
        tr: "Turkish",
        tk: "Turkmen",
        uk: "Ukrainian",
        hsb: "Upper Sorbian",
        ur: "Urdu",
        ve: "Venda",
        vi: "Vietnamese",
        vo: "Volapuk",
        wa: "Walloon",
        cy: "Welsh",
        xh: "Xhosa",
        ji: "Yiddish",
        zu: "Zulu"
    })[t] && (this.internal.languageSettings.languageCode = t, !1 === this.internal.languageSettings.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
        this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
    }), this.internal.languageSettings.isSubscribed = !0)), this;
}, $ffaeb8e02004bf5e$var$Ht = $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API, $ffaeb8e02004bf5e$var$Wt = $ffaeb8e02004bf5e$var$Ht.getCharWidthsArray = function(e, n) {
    var r, i, a = (n = n || {}).font || this.internal.getFont(), o = n.fontSize || this.internal.getFontSize(), s = n.charSpace || this.internal.getCharSpace(), u = n.widths ? n.widths : a.metadata.Unicode.widths, c = u.fof ? u.fof : 1, l = n.kerning ? n.kerning : a.metadata.Unicode.kerning, h = l.fof ? l.fof : 1, f = !1 !== n.doKerning, d = 0, p = e.length, g = 0, m = u[0] || c, v = [];
    for(r = 0; r < p; r++)i = e.charCodeAt(r), "function" == typeof a.metadata.widthOfString ? v.push((a.metadata.widthOfGlyph(a.metadata.characterToGlyph(i)) + s * (1e3 / o) || 0) / 1e3) : (d = f && "object" === (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(l[i]) && !isNaN(parseInt(l[i][g], 10)) ? l[i][g] / h : 0, v.push((u[i] || m) / c + d)), g = i;
    return v;
}, $ffaeb8e02004bf5e$var$Vt = $ffaeb8e02004bf5e$var$Ht.getStringUnitWidth = function(t, e) {
    var n = (e = e || {}).fontSize || this.internal.getFontSize(), r = e.font || this.internal.getFont(), i = e.charSpace || this.internal.getCharSpace();
    return $ffaeb8e02004bf5e$var$Ht.processArabic && (t = $ffaeb8e02004bf5e$var$Ht.processArabic(t)), "function" == typeof r.metadata.widthOfString ? r.metadata.widthOfString(t, n, i) / n : $ffaeb8e02004bf5e$var$Wt.apply(this, arguments).reduce(function(t, e) {
        return t + e;
    }, 0);
}, $ffaeb8e02004bf5e$var$Gt = function(t, e, n, r) {
    for(var i = [], a = 0, o = t.length, s = 0; a !== o && s + e[a] < n;)s += e[a], a++;
    i.push(t.slice(0, a));
    var u = a;
    for(s = 0; a !== o;)s + e[a] > r && (i.push(t.slice(u, a)), s = 0, u = a), s += e[a], a++;
    return u !== a && i.push(t.slice(u, a)), i;
}, $ffaeb8e02004bf5e$var$Yt = function(t, e, n) {
    n || (n = {});
    var r, i, a, o, s, u, c, l = [], h = [
        l
    ], f = n.textIndent || 0, d = 0, p = 0, g = t.split(" "), m = $ffaeb8e02004bf5e$var$Wt.apply(this, [
        " ",
        n
    ])[0];
    if (u = -1 === n.lineIndent ? g[0].length + 2 : n.lineIndent || 0) {
        var v = Array(u).join(" "), b = [];
        g.map(function(t) {
            (t = t.split(/\s*\n/)).length > 1 ? b = b.concat(t.map(function(t, e) {
                return (e && t.length ? "\n" : "") + t;
            })) : b.push(t[0]);
        }), g = b, u = $ffaeb8e02004bf5e$var$Vt.apply(this, [
            v,
            n
        ]);
    }
    for(a = 0, o = g.length; a < o; a++){
        var y = 0;
        if (r = g[a], u && "\n" == r[0] && (r = r.substr(1), y = 1), f + d + (p = (i = $ffaeb8e02004bf5e$var$Wt.apply(this, [
            r,
            n
        ])).reduce(function(t, e) {
            return t + e;
        }, 0)) > e || y) {
            if (p > e) {
                for(s = $ffaeb8e02004bf5e$var$Gt.apply(this, [
                    r,
                    i,
                    e - (f + d),
                    e
                ]), l.push(s.shift()), l = [
                    s.pop()
                ]; s.length;)h.push([
                    s.shift()
                ]);
                p = i.slice(r.length - (l[0] ? l[0].length : 0)).reduce(function(t, e) {
                    return t + e;
                }, 0);
            } else l = [
                r
            ];
            h.push(l), f = p + u, d = m;
        } else l.push(r), f += d + p, d = m;
    }
    return c = u ? function(t, e) {
        return (e ? v : "") + t.join(" ");
    } : function(t) {
        return t.join(" ");
    }, h.map(c);
}, $ffaeb8e02004bf5e$var$Ht.splitTextToSize = function(t, e, n) {
    var r, i = (n = n || {}).fontSize || this.internal.getFontSize(), a = (function(t) {
        if (t.widths && t.kerning) return {
            widths: t.widths,
            kerning: t.kerning
        };
        var e = this.internal.getFont(t.fontName, t.fontStyle), n = "Unicode";
        return e.metadata[n] ? {
            widths: e.metadata[n].widths || {
                0: 1
            },
            kerning: e.metadata[n].kerning || {}
        } : {
            font: e.metadata,
            fontSize: this.internal.getFontSize(),
            charSpace: this.internal.getCharSpace()
        };
    }).call(this, n);
    r = Array.isArray(t) ? t : String(t).split(/\r?\n/);
    var o = 1 * this.internal.scaleFactor * e / i;
    a.textIndent = n.textIndent ? 1 * n.textIndent * this.internal.scaleFactor / i : 0, a.lineIndent = n.lineIndent;
    var s, u, c = [];
    for(s = 0, u = r.length; s < u; s++)c = c.concat($ffaeb8e02004bf5e$var$Yt.apply(this, [
        r[s],
        o,
        a
    ]));
    return c;
}, function(e) {
    e.__fontmetrics__ = e.__fontmetrics__ || {};
    for(var n = "0123456789abcdef", r = "klmnopqrstuvwxyz", i = {}, a = {}, o = 0; o < 16; o++)i[r[o]] = n[o], a[n[o]] = r[o];
    var s = function(t) {
        return "0x" + parseInt(t, 10).toString(16);
    }, u = e.__fontmetrics__.compress = function(e) {
        var n, r, i, o, c = [
            "{"
        ];
        for(var l in e){
            if (n = e[l], isNaN(parseInt(l, 10)) ? r = "'" + l + "'" : (l = parseInt(l, 10), r = (r = s(l).slice(2)).slice(0, -1) + a[r.slice(-1)]), "number" == typeof n) n < 0 ? (i = s(n).slice(3), o = "-") : (i = s(n).slice(2), o = ""), i = o + i.slice(0, -1) + a[i.slice(-1)];
            else {
                if ("object" !== (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(n)) throw new Error("Don't know what to do with value type " + (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(n) + ".");
                i = u(n);
            }
            c.push(r + i);
        }
        return c.push("}"), c.join("");
    }, c = e.__fontmetrics__.uncompress = function(t) {
        if ("string" != typeof t) throw new Error("Invalid argument passed to uncompress.");
        for(var e, n, r, a, o = {}, s = 1, u = o, c = [], l = "", h = "", f = t.length - 1, d = 1; d < f; d += 1)"'" == (a = t[d]) ? e ? (r = e.join(""), e = void 0) : e = [] : e ? e.push(a) : "{" == a ? (c.push([
            u,
            r
        ]), u = {}, r = void 0) : "}" == a ? ((n = c.pop())[0][n[1]] = u, r = void 0, u = n[0]) : "-" == a ? s = -1 : void 0 === r ? i.hasOwnProperty(a) ? (l += i[a], r = parseInt(l, 16) * s, s = 1, l = "") : l += a : i.hasOwnProperty(a) ? (h += i[a], u[r] = parseInt(h, 16) * s, s = 1, r = void 0, h = "") : h += a;
        return o;
    }, l = {
        codePages: [
            "WinAnsiEncoding"
        ],
        WinAnsiEncoding: c("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")
    }, h = {
        Unicode: {
            Courier: l,
            "Courier-Bold": l,
            "Courier-BoldOblique": l,
            "Courier-Oblique": l,
            Helvetica: l,
            "Helvetica-Bold": l,
            "Helvetica-BoldOblique": l,
            "Helvetica-Oblique": l,
            "Times-Roman": l,
            "Times-Bold": l,
            "Times-BoldItalic": l,
            "Times-Italic": l
        }
    }, f = {
        Unicode: {
            "Courier-Oblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-BoldItalic": c("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),
            "Helvetica-Bold": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            Courier: c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-BoldOblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Bold": c("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),
            Symbol: c("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),
            Helvetica: c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),
            "Helvetica-BoldOblique": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            ZapfDingbats: c("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-Bold": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Italic": c("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),
            "Times-Roman": c("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),
            "Helvetica-Oblique": c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")
        }
    };
    e.events.push([
        "addFont",
        function(t) {
            var e = t.font, n = f.Unicode[e.postScriptName];
            n && (e.metadata.Unicode = {}, e.metadata.Unicode.widths = n.widths, e.metadata.Unicode.kerning = n.kerning);
            var r = h.Unicode[e.postScriptName];
            r && (e.metadata.Unicode.encoding = r, e.encoding = r.codePages[0]);
        }
    ]);
}($ffaeb8e02004bf5e$export$2e2bcd8739ae039.API), /**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function(t) {
        for(var e = t.length, n = new Uint8Array(e), r = 0; r < e; r++)n[r] = t.charCodeAt(r);
        return n;
    };
    t.API.events.push([
        "addFont",
        function(n) {
            var r = void 0, i = n.font, a = n.instance;
            if (!i.isStandardFont) {
                if (void 0 === a) throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
                if ("string" != typeof (r = !1 === a.existsFileInVFS(i.postScriptName) ? a.loadFile(i.postScriptName) : a.getFileFromVFS(i.postScriptName))) throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
                !function(n, r) {
                    r = /^\x00\x01\x00\x00/.test(r) ? e(r) : e($ffaeb8e02004bf5e$var$f(r)), n.metadata = t.API.TTFFont.open(r), n.metadata.Unicode = n.metadata.Unicode || {
                        encoding: {},
                        kerning: {},
                        widths: []
                    }, n.metadata.glyIdsUsed = [
                        0
                    ];
                }(i, r);
            }
        }
    ]);
}($ffaeb8e02004bf5e$export$2e2bcd8739ae039), $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.addSvgAsImage = function(t, e, n, r, a, s, u, c) {
    if (isNaN(e) || isNaN(n)) throw $ffaeb8e02004bf5e$var$o.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
    if (isNaN(r) || isNaN(a)) throw $ffaeb8e02004bf5e$var$o.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
    var l = document.createElement("canvas");
    l.width = r, l.height = a;
    var h = l.getContext("2d");
    h.fillStyle = "#fff", h.fillRect(0, 0, l.width, l.height);
    var f = {
        ignoreMouse: !0,
        ignoreAnimation: !0,
        ignoreDimensions: !0
    }, d = this;
    return ($ffaeb8e02004bf5e$var$i.canvg ? Promise.resolve($ffaeb8e02004bf5e$var$i.canvg) : (parcelRequire("lTgs1"))).catch(function(t) {
        return Promise.reject(new Error("Could not load canvg: " + t));
    }).then(function(t) {
        return t.default ? t.default : t;
    }).then(function(e) {
        return e.fromString(h, t, f);
    }, function() {
        return Promise.reject(new Error("Could not load canvg."));
    }).then(function(t) {
        return t.render(f);
    }).then(function() {
        d.addImage(l.toDataURL("image/jpeg", 1), e, n, r, a, u, c);
    });
}, $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.putTotalPages = function(t) {
    var e, n = 0;
    parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (e = new RegExp(t, "g"), n = this.internal.getNumberOfPages()) : (e = new RegExp(this.pdfEscape16(t, this.internal.getFont()), "g"), n = this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
    for(var r = 1; r <= this.internal.getNumberOfPages(); r++)for(var i = 0; i < this.internal.pages[r].length; i++)this.internal.pages[r][i] = this.internal.pages[r][i].replace(e, n);
    return this;
}, $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.viewerPreferences = function(e, n) {
    var r;
    e = e || {}, n = n || !1;
    var i, a, o, s = {
        HideToolbar: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        HideMenubar: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        HideWindowUI: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        FitWindow: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        CenterWindow: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        DisplayDocTitle: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.4
        },
        NonFullScreenPageMode: {
            defaultValue: "UseNone",
            value: "UseNone",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "UseNone",
                "UseOutlines",
                "UseThumbs",
                "UseOC"
            ],
            pdfVersion: 1.3
        },
        Direction: {
            defaultValue: "L2R",
            value: "L2R",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "L2R",
                "R2L"
            ],
            pdfVersion: 1.3
        },
        ViewArea: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        ViewClip: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintArea: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintClip: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintScaling: {
            defaultValue: "AppDefault",
            value: "AppDefault",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "AppDefault",
                "None"
            ],
            pdfVersion: 1.6
        },
        Duplex: {
            defaultValue: "",
            value: "none",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "Simplex",
                "DuplexFlipShortEdge",
                "DuplexFlipLongEdge",
                "none"
            ],
            pdfVersion: 1.7
        },
        PickTrayByPDFSize: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.7
        },
        PrintPageRange: {
            defaultValue: "",
            value: "",
            type: "array",
            explicitSet: !1,
            valueSet: null,
            pdfVersion: 1.7
        },
        NumCopies: {
            defaultValue: 1,
            value: 1,
            type: "integer",
            explicitSet: !1,
            valueSet: null,
            pdfVersion: 1.7
        }
    }, u = Object.keys(s), c = [], l = 0, h = 0, f = 0;
    function d(t, e) {
        var n, r = !1;
        for(n = 0; n < t.length; n += 1)t[n] === e && (r = !0);
        return r;
    }
    if (void 0 === this.internal.viewerpreferences && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(s)), this.internal.viewerpreferences.isSubscribed = !1), r = this.internal.viewerpreferences.configuration, "reset" === e || !0 === n) {
        var p = u.length;
        for(f = 0; f < p; f += 1)r[u[f]].value = r[u[f]].defaultValue, r[u[f]].explicitSet = !1;
    }
    if ("object" === (0, (/*@__PURE__*/$parcel$interopDefault($12c96b00a8f2ac07$exports)))(e)) {
        for(a in e)if (o = e[a], d(u, a) && void 0 !== o) {
            if ("boolean" === r[a].type && "boolean" == typeof o) r[a].value = o;
            else if ("name" === r[a].type && d(r[a].valueSet, o)) r[a].value = o;
            else if ("integer" === r[a].type && Number.isInteger(o)) r[a].value = o;
            else if ("array" === r[a].type) {
                for(l = 0; l < o.length; l += 1)if (i = !0, 1 === o[l].length && "number" == typeof o[l][0]) c.push(String(o[l] - 1));
                else if (o[l].length > 1) {
                    for(h = 0; h < o[l].length; h += 1)"number" != typeof o[l][h] && (i = !1);
                    !0 === i && c.push([
                        o[l][0] - 1,
                        o[l][1] - 1
                    ].join(" "));
                }
                r[a].value = "[" + c.join(" ") + "]";
            } else r[a].value = r[a].defaultValue;
            r[a].explicitSet = !0;
        }
    }
    return !1 === this.internal.viewerpreferences.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
        var t, e = [];
        for(t in r)!0 === r[t].explicitSet && ("name" === r[t].type ? e.push("/" + t + " /" + r[t].value) : e.push("/" + t + " " + r[t].value));
        0 !== e.length && this.internal.write("/ViewerPreferences\n<<\n" + e.join("\n") + "\n>>");
    }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = r, this;
}, /** ====================================================================
 * @license
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ function(t) {
    var e = function() {
        var t = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + this.internal.__metadata__.namespaceuri + '"><jspdf:metadata>', e = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), n = unescape(encodeURIComponent(t)), r = unescape(encodeURIComponent(this.internal.__metadata__.metadata)), i = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), a = unescape(encodeURIComponent("</x:xmpmeta>")), o = n.length + r.length + i.length + e.length + a.length;
        this.internal.__metadata__.metadata_object_number = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + o + " >>"), this.internal.write("stream"), this.internal.write(e + n + r + i + a), this.internal.write("endstream"), this.internal.write("endobj");
    }, n = function() {
        this.internal.__metadata__.metadata_object_number && this.internal.write("/Metadata " + this.internal.__metadata__.metadata_object_number + " 0 R");
    };
    t.addMetadata = function(t, r) {
        return void 0 === this.internal.__metadata__ && (this.internal.__metadata__ = {
            metadata: t,
            namespaceuri: r || "http://jspdf.default.namespaceuri/"
        }, this.internal.events.subscribe("putCatalog", n), this.internal.events.subscribe("postPutResources", e)), this;
    };
}($ffaeb8e02004bf5e$export$2e2bcd8739ae039.API), function(t) {
    var e = t.API, n = e.pdfEscape16 = function(t, e) {
        for(var n, r = e.metadata.Unicode.widths, i = [
            "",
            "0",
            "00",
            "000",
            "0000"
        ], a = [
            ""
        ], o = 0, s = t.length; o < s; ++o){
            if (n = e.metadata.characterToGlyph(t.charCodeAt(o)), e.metadata.glyIdsUsed.push(n), e.metadata.toUnicode[n] = t.charCodeAt(o), -1 == r.indexOf(n) && (r.push(n), r.push([
                parseInt(e.metadata.widthOfGlyph(n), 10)
            ])), "0" == n) return a.join("");
            n = n.toString(16), a.push(i[4 - n.length], n);
        }
        return a.join("");
    }, r = function(t) {
        var e, n, r, i, a, o, s;
        for(a = "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange", r = [], o = 0, s = (n = Object.keys(t).sort(function(t, e) {
            return t - e;
        })).length; o < s; o++)e = n[o], r.length >= 100 && (a += "\n" + r.length + " beginbfchar\n" + r.join("\n") + "\nendbfchar", r = []), void 0 !== t[e] && null !== t[e] && "function" == typeof t[e].toString && (i = ("0000" + t[e].toString(16)).slice(-4), e = ("0000" + (+e).toString(16)).slice(-4), r.push("<" + e + "><" + i + ">"));
        return r.length && (a += "\n" + r.length + " beginbfchar\n" + r.join("\n") + "\nendbfchar\n"), a + "endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
    };
    e.events.push([
        "putFont",
        function(e) {
            !function(e) {
                var n = e.font, i = e.out, a = e.newObject, o = e.putStream;
                if (n.metadata instanceof t.API.TTFFont && "Identity-H" === n.encoding) {
                    for(var s = n.metadata.Unicode.widths, u = n.metadata.subset.encode(n.metadata.glyIdsUsed, 1), c = "", l = 0; l < u.length; l++)c += String.fromCharCode(u[l]);
                    var h = a();
                    o({
                        data: c,
                        addLength1: !0,
                        objectId: h
                    }), i("endobj");
                    var f = a();
                    o({
                        data: r(n.metadata.toUnicode),
                        addLength1: !0,
                        objectId: f
                    }), i("endobj");
                    var d = a();
                    i("<<"), i("/Type /FontDescriptor"), i("/FontName /" + $ffaeb8e02004bf5e$var$j(n.fontName)), i("/FontFile2 " + h + " 0 R"), i("/FontBBox " + t.API.PDFObject.convert(n.metadata.bbox)), i("/Flags " + n.metadata.flags), i("/StemV " + n.metadata.stemV), i("/ItalicAngle " + n.metadata.italicAngle), i("/Ascent " + n.metadata.ascender), i("/Descent " + n.metadata.decender), i("/CapHeight " + n.metadata.capHeight), i(">>"), i("endobj");
                    var p = a();
                    i("<<"), i("/Type /Font"), i("/BaseFont /" + $ffaeb8e02004bf5e$var$j(n.fontName)), i("/FontDescriptor " + d + " 0 R"), i("/W " + t.API.PDFObject.convert(s)), i("/CIDToGIDMap /Identity"), i("/DW 1000"), i("/Subtype /CIDFontType2"), i("/CIDSystemInfo"), i("<<"), i("/Supplement 0"), i("/Registry (Adobe)"), i("/Ordering (" + n.encoding + ")"), i(">>"), i(">>"), i("endobj"), n.objectNumber = a(), i("<<"), i("/Type /Font"), i("/Subtype /Type0"), i("/ToUnicode " + f + " 0 R"), i("/BaseFont /" + $ffaeb8e02004bf5e$var$j(n.fontName)), i("/Encoding /" + n.encoding), i("/DescendantFonts [" + p + " 0 R]"), i(">>"), i("endobj"), n.isAlreadyPutted = !0;
                }
            }(e);
        }
    ]), e.events.push([
        "putFont",
        function(e) {
            !function(e) {
                var n = e.font, i = e.out, a = e.newObject, o = e.putStream;
                if (n.metadata instanceof t.API.TTFFont && "WinAnsiEncoding" === n.encoding) {
                    for(var s = n.metadata.rawData, u = "", c = 0; c < s.length; c++)u += String.fromCharCode(s[c]);
                    var l = a();
                    o({
                        data: u,
                        addLength1: !0,
                        objectId: l
                    }), i("endobj");
                    var h = a();
                    o({
                        data: r(n.metadata.toUnicode),
                        addLength1: !0,
                        objectId: h
                    }), i("endobj");
                    var f = a();
                    i("<<"), i("/Descent " + n.metadata.decender), i("/CapHeight " + n.metadata.capHeight), i("/StemV " + n.metadata.stemV), i("/Type /FontDescriptor"), i("/FontFile2 " + l + " 0 R"), i("/Flags 96"), i("/FontBBox " + t.API.PDFObject.convert(n.metadata.bbox)), i("/FontName /" + $ffaeb8e02004bf5e$var$j(n.fontName)), i("/ItalicAngle " + n.metadata.italicAngle), i("/Ascent " + n.metadata.ascender), i(">>"), i("endobj"), n.objectNumber = a();
                    for(var d = 0; d < n.metadata.hmtx.widths.length; d++)n.metadata.hmtx.widths[d] = parseInt(n.metadata.hmtx.widths[d] * (1e3 / n.metadata.head.unitsPerEm));
                    i("<</Subtype/TrueType/Type/Font/ToUnicode " + h + " 0 R/BaseFont/" + $ffaeb8e02004bf5e$var$j(n.fontName) + "/FontDescriptor " + f + " 0 R/Encoding/" + n.encoding + " /FirstChar 29 /LastChar 255 /Widths " + t.API.PDFObject.convert(n.metadata.hmtx.widths) + ">>"), i("endobj"), n.isAlreadyPutted = !0;
                }
            }(e);
        }
    ]);
    var i = function(t) {
        var e, r = t.text || "", i = t.x, a = t.y, o = t.options || {}, s = t.mutex || {}, u = s.pdfEscape, c = s.activeFontKey, l = s.fonts, h = c, f = "", d = 0, p = "", g = l[h].encoding;
        if ("Identity-H" !== l[h].encoding) return {
            text: r,
            x: i,
            y: a,
            options: o,
            mutex: s
        };
        for(p = r, h = c, Array.isArray(r) && (p = r[0]), d = 0; d < p.length; d += 1)l[h].metadata.hasOwnProperty("cmap") && (e = l[h].metadata.cmap.unicode.codeMap[p[d].charCodeAt(0)]), e || p[d].charCodeAt(0) < 256 && l[h].metadata.hasOwnProperty("Unicode") ? f += p[d] : f += "";
        var m = "";
        return parseInt(h.slice(1)) < 14 || "WinAnsiEncoding" === g ? m = u(f, h).split("").map(function(t) {
            return t.charCodeAt(0).toString(16);
        }).join("") : "Identity-H" === g && (m = n(f, l[h])), s.isHex = !0, {
            text: m,
            x: i,
            y: a,
            options: o,
            mutex: s
        };
    };
    e.events.push([
        "postProcessText",
        function(t) {
            var e = t.text || "", n = [], r = {
                text: e,
                x: t.x,
                y: t.y,
                options: t.options,
                mutex: t.mutex
            };
            if (Array.isArray(e)) {
                var a = 0;
                for(a = 0; a < e.length; a += 1)Array.isArray(e[a]) && 3 === e[a].length ? n.push([
                    i(Object.assign({}, r, {
                        text: e[a][0]
                    })).text,
                    e[a][1],
                    e[a][2]
                ]) : n.push(i(Object.assign({}, r, {
                    text: e[a]
                })).text);
                t.text = n;
            } else t.text = i(Object.assign({}, r, {
                text: e
            })).text;
        }
    ]);
}($ffaeb8e02004bf5e$export$2e2bcd8739ae039), /**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function() {
        return void 0 === this.internal.vFS && (this.internal.vFS = {}), !0;
    };
    t.existsFileInVFS = function(t) {
        return e.call(this), void 0 !== this.internal.vFS[t];
    }, t.addFileToVFS = function(t, n) {
        return e.call(this), this.internal.vFS[t] = n, this;
    }, t.getFileFromVFS = function(t) {
        return e.call(this), void 0 !== this.internal.vFS[t] ? this.internal.vFS[t] : null;
    };
}($ffaeb8e02004bf5e$export$2e2bcd8739ae039.API), /**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */ function(t) {
    t.__bidiEngine__ = t.prototype.__bidiEngine__ = function(t) {
        var n, r, i, a, o, s, u, c = e, l = [
            [
                0,
                3,
                0,
                1,
                0,
                0,
                0
            ],
            [
                0,
                3,
                0,
                1,
                2,
                2,
                0
            ],
            [
                0,
                3,
                0,
                17,
                2,
                0,
                1
            ],
            [
                0,
                3,
                5,
                5,
                4,
                1,
                0
            ],
            [
                0,
                3,
                21,
                21,
                4,
                0,
                1
            ],
            [
                0,
                3,
                5,
                5,
                4,
                2,
                0
            ]
        ], h = [
            [
                2,
                0,
                1,
                1,
                0,
                1,
                0
            ],
            [
                2,
                0,
                1,
                1,
                0,
                2,
                0
            ],
            [
                2,
                0,
                2,
                1,
                3,
                2,
                0
            ],
            [
                2,
                0,
                2,
                33,
                3,
                1,
                1
            ]
        ], f = {
            L: 0,
            R: 1,
            EN: 2,
            AN: 3,
            N: 4,
            B: 5,
            S: 6
        }, d = {
            0: 0,
            5: 1,
            6: 2,
            7: 3,
            32: 4,
            251: 5,
            254: 6,
            255: 7
        }, p = [
            "(",
            ")",
            "(",
            "<",
            ">",
            "<",
            "[",
            "]",
            "[",
            "{",
            "}",
            "{",
            "\xab",
            "\xbb",
            "\xab",
            "\u2039",
            "\u203A",
            "\u2039",
            "\u2045",
            "\u2046",
            "\u2045",
            "\u207D",
            "\u207E",
            "\u207D",
            "\u208D",
            "\u208E",
            "\u208D",
            "\u2264",
            "\u2265",
            "\u2264",
            "\u2329",
            "\u232A",
            "\u2329",
            "\uFE59",
            "\uFE5A",
            "\uFE59",
            "\uFE5B",
            "\uFE5C",
            "\uFE5B",
            "\uFE5D",
            "\uFE5E",
            "\uFE5D",
            "\uFE64",
            "\uFE65",
            "\uFE64"
        ], g = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/), m = !1, v = 0;
        this.__bidiEngine__ = {};
        var b = function(t) {
            var e = t.charCodeAt(), n = e >> 8, r = d[n];
            return void 0 !== r ? c[256 * r + (255 & e)] : 252 === n || 253 === n ? "AL" : g.test(n) ? "L" : 8 === n ? "R" : "N";
        }, y = function(t) {
            for(var e, n = 0; n < t.length; n++){
                if ("L" === (e = b(t.charAt(n)))) return !1;
                if ("R" === e) return !0;
            }
            return !1;
        }, w = function(t, e, o, s) {
            var u, c, l, h, f = e[s];
            switch(f){
                case "L":
                case "R":
                case "LRE":
                case "RLE":
                case "LRO":
                case "RLO":
                case "PDF":
                    m = !1;
                    break;
                case "N":
                case "AN":
                    break;
                case "EN":
                    m && (f = "AN");
                    break;
                case "AL":
                    m = !0, f = "R";
                    break;
                case "WS":
                case "BN":
                    f = "N";
                    break;
                case "CS":
                    s < 1 || s + 1 >= e.length || "EN" !== (u = o[s - 1]) && "AN" !== u || "EN" !== (c = e[s + 1]) && "AN" !== c ? f = "N" : m && (c = "AN"), f = c === u ? c : "N";
                    break;
                case "ES":
                    f = "EN" === (u = s > 0 ? o[s - 1] : "B") && s + 1 < e.length && "EN" === e[s + 1] ? "EN" : "N";
                    break;
                case "ET":
                    if (s > 0 && "EN" === o[s - 1]) {
                        f = "EN";
                        break;
                    }
                    if (m) {
                        f = "N";
                        break;
                    }
                    for(l = s + 1, h = e.length; l < h && "ET" === e[l];)l++;
                    f = l < h && "EN" === e[l] ? "EN" : "N";
                    break;
                case "NSM":
                    if (i && !a) {
                        for(h = e.length, l = s + 1; l < h && "NSM" === e[l];)l++;
                        if (l < h) {
                            var d = t[s], p = d >= 1425 && d <= 2303 || 64286 === d;
                            if (u = e[l], p && ("R" === u || "AL" === u)) {
                                f = "R";
                                break;
                            }
                        }
                    }
                    f = s < 1 || "B" === (u = e[s - 1]) ? "N" : o[s - 1];
                    break;
                case "B":
                    m = !1, n = !0, f = v;
                    break;
                case "S":
                    r = !0, f = "N";
            }
            return f;
        }, N = function(t, e, n) {
            var r = t.split("");
            return n && L(r, n, {
                hiLevel: v
            }), r.reverse(), e && e.reverse(), r.join("");
        }, L = function(t, e, i) {
            var a, o, s, u, c, d = -1, p = t.length, g = 0, y = [], N = v ? h : l, L = [];
            for(m = !1, n = !1, r = !1, o = 0; o < p; o++)L[o] = b(t[o]);
            for(s = 0; s < p; s++){
                if (c = g, y[s] = w(t, L, y, s), a = 240 & (g = N[c][f[y[s]]]), g &= 15, e[s] = u = N[g][5], a > 0) {
                    if (16 === a) {
                        for(o = d; o < s; o++)e[o] = 1;
                        d = -1;
                    } else d = -1;
                }
                if (N[g][6]) -1 === d && (d = s);
                else if (d > -1) {
                    for(o = d; o < s; o++)e[o] = u;
                    d = -1;
                }
                "B" === L[s] && (e[s] = 0), i.hiLevel |= u;
            }
            r && function(t, e, n) {
                for(var r = 0; r < n; r++)if ("S" === t[r]) {
                    e[r] = v;
                    for(var i = r - 1; i >= 0 && "WS" === t[i]; i--)e[i] = v;
                }
            }(L, e, p);
        }, x = function(t, e, r, i, a) {
            if (!(a.hiLevel < t)) {
                if (1 === t && 1 === v && !n) return e.reverse(), void (r && r.reverse());
                for(var o, s, u, c, l = e.length, h = 0; h < l;){
                    if (i[h] >= t) {
                        for(u = h + 1; u < l && i[u] >= t;)u++;
                        for(c = h, s = u - 1; c < s; c++, s--)o = e[c], e[c] = e[s], e[s] = o, r && (o = r[c], r[c] = r[s], r[s] = o);
                        h = u;
                    }
                    h++;
                }
            }
        }, A = function(t, e, n) {
            var r = t.split(""), i = {
                hiLevel: v
            };
            return n || (n = []), L(r, n, i), function(t, e, n) {
                if (0 !== n.hiLevel && u) for(var r, i = 0; i < t.length; i++)1 === e[i] && (r = p.indexOf(t[i])) >= 0 && (t[i] = p[r + 1]);
            }(r, n, i), x(2, r, e, n, i), x(1, r, e, n, i), r.join("");
        };
        return this.__bidiEngine__.doBidiReorder = function(t, e, n) {
            if (function(t, e) {
                if (e) for(var n = 0; n < t.length; n++)e[n] = n;
                void 0 === a && (a = y(t)), void 0 === s && (s = y(t));
            }(t, e), i || !o || s) {
                if (i && o && a ^ s) v = a ? 1 : 0, t = N(t, e, n);
                else if (!i && o && s) v = a ? 1 : 0, t = A(t, e, n), t = N(t, e);
                else if (!i || a || o || s) {
                    if (i && !o && a ^ s) t = N(t, e), a ? (v = 0, t = A(t, e, n)) : (v = 1, t = A(t, e, n), t = N(t, e));
                    else if (i && a && !o && s) v = 1, t = A(t, e, n), t = N(t, e);
                    else if (!i && !o && a ^ s) {
                        var r = u;
                        a ? (v = 1, t = A(t, e, n), v = 0, u = !1, t = A(t, e, n), u = r) : (v = 0, t = A(t, e, n), t = N(t, e), v = 1, u = !1, t = A(t, e, n), u = r, t = N(t, e));
                    }
                } else v = 0, t = A(t, e, n);
            } else v = a ? 1 : 0, t = A(t, e, n);
            return t;
        }, this.__bidiEngine__.setOptions = function(t) {
            t && (i = t.isInputVisual, o = t.isOutputVisual, a = t.isInputRtl, s = t.isOutputRtl, u = t.isSymmetricSwapping);
        }, this.__bidiEngine__.setOptions(t), this.__bidiEngine__;
    };
    var e = [
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "S",
        "B",
        "S",
        "WS",
        "B",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "B",
        "B",
        "B",
        "S",
        "WS",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ES",
        "CS",
        "ES",
        "CS",
        "CS",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "B",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "CS",
        "N",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "L",
        "N",
        "N",
        "BN",
        "N",
        "N",
        "ET",
        "ET",
        "EN",
        "EN",
        "N",
        "L",
        "N",
        "N",
        "N",
        "EN",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "R",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "N",
        "N",
        "AL",
        "ET",
        "ET",
        "AL",
        "CS",
        "AL",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "ET",
        "AN",
        "AN",
        "AL",
        "AL",
        "AL",
        "NSM",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AN",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "NSM",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "BN",
        "BN",
        "BN",
        "L",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "B",
        "LRE",
        "RLE",
        "PDF",
        "LRO",
        "RLO",
        "CS",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "N",
        "LRI",
        "RLI",
        "FSI",
        "PDI",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "EN",
        "L",
        "N",
        "N",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "L",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "NSM",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "ES",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "R",
        "N",
        "R",
        "R",
        "N",
        "R",
        "R",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "CS",
        "N",
        "CS",
        "N",
        "N",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "N",
        "N",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "N",
        "BN",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ES",
        "CS",
        "ES",
        "CS",
        "CS",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N"
    ], n = new t.__bidiEngine__({
        isInputVisual: !0
    });
    t.API.events.push([
        "postProcessText",
        function(t) {
            var e = t.text;
            t.x, t.y;
            var r = t.options || {};
            t.mutex, r.lang;
            var i = [];
            if (r.isInputVisual = "boolean" != typeof r.isInputVisual || r.isInputVisual, n.setOptions(r), "[object Array]" === Object.prototype.toString.call(e)) {
                var a = 0;
                for(i = [], a = 0; a < e.length; a += 1)"[object Array]" === Object.prototype.toString.call(e[a]) ? i.push([
                    n.doBidiReorder(e[a][0]),
                    e[a][1],
                    e[a][2]
                ]) : i.push([
                    n.doBidiReorder(e[a])
                ]);
                t.text = i;
            } else t.text = n.doBidiReorder(e);
            n.setOptions({
                isInputVisual: !0
            });
        }
    ]);
}($ffaeb8e02004bf5e$export$2e2bcd8739ae039), $ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.TTFFont = function() {
    function t(t) {
        var e;
        if (this.rawData = t, e = this.contents = new $ffaeb8e02004bf5e$var$fe(t), this.contents.pos = 4, "ttcf" === e.readString(4)) throw new Error("TTCF not supported.");
        e.pos = 0, this.parse(), this.subset = new $ffaeb8e02004bf5e$var$je(this), this.registerTTF();
    }
    return t.open = function(e) {
        return new t(e);
    }, t.prototype.parse = function() {
        return this.directory = new $ffaeb8e02004bf5e$var$de(this.contents), this.head = new $ffaeb8e02004bf5e$var$me(this), this.name = new $ffaeb8e02004bf5e$var$xe(this), this.cmap = new $ffaeb8e02004bf5e$var$be(this), this.toUnicode = {}, this.hhea = new $ffaeb8e02004bf5e$var$ye(this), this.maxp = new $ffaeb8e02004bf5e$var$Ae(this), this.hmtx = new $ffaeb8e02004bf5e$var$Se(this), this.post = new $ffaeb8e02004bf5e$var$Ne(this), this.os2 = new $ffaeb8e02004bf5e$var$we(this), this.loca = new $ffaeb8e02004bf5e$var$Ie(this), this.glyf = new $ffaeb8e02004bf5e$var$Pe(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [
            this.head.xMin,
            this.head.yMin,
            this.head.xMax,
            this.head.yMax
        ];
    }, t.prototype.registerTTF = function() {
        var t, e, n, r, i;
        if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
            var e, n, r, i;
            for(i = [], e = 0, n = (r = this.bbox).length; e < n; e++)t = r[e], i.push(Math.round(t * this.scaleFactor));
            return i;
        }).call(this), this.stemV = 0, this.post.exists ? (n = 255 & (r = this.post.italic_angle), 32768 & (e = r >> 16) && (e = -(1 + (65535 ^ e))), this.italicAngle = +(e + "." + n)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = 1 === (i = this.familyClass) || 2 === i || 3 === i || 4 === i || 5 === i || 7 === i, this.isScript = 10 === this.familyClass, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), 0 !== this.italicAngle && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
    }, t.prototype.characterToGlyph = function(t) {
        var e;
        return (null != (e = this.cmap.unicode) ? e.codeMap[t] : void 0) || 0;
    }, t.prototype.widthOfGlyph = function(t) {
        var e;
        return e = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(t).advance * e;
    }, t.prototype.widthOfString = function(t, e, n) {
        var r, i, a, o;
        for(a = 0, i = 0, o = (t = "" + t).length; 0 <= o ? i < o : i > o; i = 0 <= o ? ++i : --i)r = t.charCodeAt(i), a += this.widthOfGlyph(this.characterToGlyph(r)) + n * (1e3 / e) || 0;
        return a * (e / 1e3);
    }, t.prototype.lineHeight = function(t, e) {
        var n;
        return null == e && (e = !1), n = e ? this.lineGap : 0, (this.ascender + n - this.decender) / 1e3 * t;
    }, t;
}();
var $ffaeb8e02004bf5e$var$he, $ffaeb8e02004bf5e$var$fe = function() {
    function t(t) {
        this.data = null != t ? t : [], this.pos = 0, this.length = this.data.length;
    }
    return t.prototype.readByte = function() {
        return this.data[this.pos++];
    }, t.prototype.writeByte = function(t) {
        return this.data[this.pos++] = t;
    }, t.prototype.readUInt32 = function() {
        return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
    }, t.prototype.writeUInt32 = function(t) {
        return this.writeByte(t >>> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
    }, t.prototype.readInt32 = function() {
        var t;
        return (t = this.readUInt32()) >= 2147483648 ? t - 4294967296 : t;
    }, t.prototype.writeInt32 = function(t) {
        return t < 0 && (t += 4294967296), this.writeUInt32(t);
    }, t.prototype.readUInt16 = function() {
        return this.readByte() << 8 | this.readByte();
    }, t.prototype.writeUInt16 = function(t) {
        return this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
    }, t.prototype.readInt16 = function() {
        var t;
        return (t = this.readUInt16()) >= 32768 ? t - 65536 : t;
    }, t.prototype.writeInt16 = function(t) {
        return t < 0 && (t += 65536), this.writeUInt16(t);
    }, t.prototype.readString = function(t) {
        var e, n;
        for(n = [], e = 0; 0 <= t ? e < t : e > t; e = 0 <= t ? ++e : --e)n[e] = String.fromCharCode(this.readByte());
        return n.join("");
    }, t.prototype.writeString = function(t) {
        var e, n, r;
        for(r = [], e = 0, n = t.length; 0 <= n ? e < n : e > n; e = 0 <= n ? ++e : --e)r.push(this.writeByte(t.charCodeAt(e)));
        return r;
    }, t.prototype.readShort = function() {
        return this.readInt16();
    }, t.prototype.writeShort = function(t) {
        return this.writeInt16(t);
    }, t.prototype.readLongLong = function() {
        var t, e, n, r, i, a, o, s;
        return t = this.readByte(), e = this.readByte(), n = this.readByte(), r = this.readByte(), i = this.readByte(), a = this.readByte(), o = this.readByte(), s = this.readByte(), 128 & t ? -1 * (72057594037927940 * (255 ^ t) + 281474976710656 * (255 ^ e) + 1099511627776 * (255 ^ n) + 4294967296 * (255 ^ r) + 16777216 * (255 ^ i) + 65536 * (255 ^ a) + 256 * (255 ^ o) + (255 ^ s) + 1) : 72057594037927940 * t + 281474976710656 * e + 1099511627776 * n + 4294967296 * r + 16777216 * i + 65536 * a + 256 * o + s;
    }, t.prototype.writeLongLong = function(t) {
        var e, n;
        return e = Math.floor(t / 4294967296), n = 4294967295 & t, this.writeByte(e >> 24 & 255), this.writeByte(e >> 16 & 255), this.writeByte(e >> 8 & 255), this.writeByte(255 & e), this.writeByte(n >> 24 & 255), this.writeByte(n >> 16 & 255), this.writeByte(n >> 8 & 255), this.writeByte(255 & n);
    }, t.prototype.readInt = function() {
        return this.readInt32();
    }, t.prototype.writeInt = function(t) {
        return this.writeInt32(t);
    }, t.prototype.read = function(t) {
        var e, n;
        for(e = [], n = 0; 0 <= t ? n < t : n > t; n = 0 <= t ? ++n : --n)e.push(this.readByte());
        return e;
    }, t.prototype.write = function(t) {
        var e, n, r, i;
        for(i = [], n = 0, r = t.length; n < r; n++)e = t[n], i.push(this.writeByte(e));
        return i;
    }, t;
}(), $ffaeb8e02004bf5e$var$de = function() {
    var t;
    function e(t) {
        var e, n, r;
        for(this.scalarType = t.readInt(), this.tableCount = t.readShort(), this.searchRange = t.readShort(), this.entrySelector = t.readShort(), this.rangeShift = t.readShort(), this.tables = {}, n = 0, r = this.tableCount; 0 <= r ? n < r : n > r; n = 0 <= r ? ++n : --n)e = {
            tag: t.readString(4),
            checksum: t.readInt(),
            offset: t.readInt(),
            length: t.readInt()
        }, this.tables[e.tag] = e;
    }
    return e.prototype.encode = function(e) {
        var n, r, i, a, o, s, u, c, l, h, f, d, p;
        for(p in f = Object.keys(e).length, s = Math.log(2), l = 16 * Math.floor(Math.log(f) / s), a = Math.floor(l / s), c = 16 * f - l, (r = new $ffaeb8e02004bf5e$var$fe).writeInt(this.scalarType), r.writeShort(f), r.writeShort(l), r.writeShort(a), r.writeShort(c), i = 16 * f, u = r.pos + i, o = null, d = [], e)for(h = e[p], r.writeString(p), r.writeInt(t(h)), r.writeInt(u), r.writeInt(h.length), d = d.concat(h), "head" === p && (o = u), u += h.length; u % 4;)d.push(0), u++;
        return r.write(d), n = 2981146554 - t(r.data), r.pos = o + 8, r.writeUInt32(n), r.data;
    }, t = function(t) {
        var e, n, r, i;
        for(t = $ffaeb8e02004bf5e$var$_e.call(t); t.length % 4;)t.push(0);
        for(r = new $ffaeb8e02004bf5e$var$fe(t), n = 0, e = 0, i = t.length; e < i; e = e += 4)n += r.readUInt32();
        return 4294967295 & n;
    }, e;
}(), $ffaeb8e02004bf5e$var$pe = {}.hasOwnProperty, $ffaeb8e02004bf5e$var$ge = function(t, e) {
    for(var n in e)$ffaeb8e02004bf5e$var$pe.call(e, n) && (t[n] = e[n]);
    function r() {
        this.constructor = t;
    }
    return r.prototype = e.prototype, t.prototype = new r, t.__super__ = e.prototype, t;
};
$ffaeb8e02004bf5e$var$he = function() {
    function t(t) {
        var e;
        this.file = t, e = this.file.directory.tables[this.tag], this.exists = !!e, e && (this.offset = e.offset, this.length = e.length, this.parse(this.file.contents));
    }
    return t.prototype.parse = function() {}, t.prototype.encode = function() {}, t.prototype.raw = function() {
        return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
    }, t;
}();
var $ffaeb8e02004bf5e$var$me = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $ffaeb8e02004bf5e$var$ge(t, $ffaeb8e02004bf5e$var$he), t.prototype.tag = "head", t.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.revision = t.readInt(), this.checkSumAdjustment = t.readInt(), this.magicNumber = t.readInt(), this.flags = t.readShort(), this.unitsPerEm = t.readShort(), this.created = t.readLongLong(), this.modified = t.readLongLong(), this.xMin = t.readShort(), this.yMin = t.readShort(), this.xMax = t.readShort(), this.yMax = t.readShort(), this.macStyle = t.readShort(), this.lowestRecPPEM = t.readShort(), this.fontDirectionHint = t.readShort(), this.indexToLocFormat = t.readShort(), this.glyphDataFormat = t.readShort();
    }, t.prototype.encode = function(t) {
        var e;
        return (e = new $ffaeb8e02004bf5e$var$fe).writeInt(this.version), e.writeInt(this.revision), e.writeInt(this.checkSumAdjustment), e.writeInt(this.magicNumber), e.writeShort(this.flags), e.writeShort(this.unitsPerEm), e.writeLongLong(this.created), e.writeLongLong(this.modified), e.writeShort(this.xMin), e.writeShort(this.yMin), e.writeShort(this.xMax), e.writeShort(this.yMax), e.writeShort(this.macStyle), e.writeShort(this.lowestRecPPEM), e.writeShort(this.fontDirectionHint), e.writeShort(t), e.writeShort(this.glyphDataFormat), e.data;
    }, t;
}(), $ffaeb8e02004bf5e$var$ve = function() {
    function t(t, e) {
        var n, r, i, a, o, s, u, c, l, h, f, d, p, g, m, v, b;
        switch(this.platformID = t.readUInt16(), this.encodingID = t.readShort(), this.offset = e + t.readInt(), l = t.pos, t.pos = this.offset, this.format = t.readUInt16(), this.length = t.readUInt16(), this.language = t.readUInt16(), this.isUnicode = 3 === this.platformID && 1 === this.encodingID && 4 === this.format || 0 === this.platformID && 4 === this.format, this.codeMap = {}, this.format){
            case 0:
                for(s = 0; s < 256; ++s)this.codeMap[s] = t.readByte();
                break;
            case 4:
                for(f = t.readUInt16(), h = f / 2, t.pos += 6, i = function() {
                    var e, n;
                    for(n = [], s = e = 0; 0 <= h ? e < h : e > h; s = 0 <= h ? ++e : --e)n.push(t.readUInt16());
                    return n;
                }(), t.pos += 2, p = function() {
                    var e, n;
                    for(n = [], s = e = 0; 0 <= h ? e < h : e > h; s = 0 <= h ? ++e : --e)n.push(t.readUInt16());
                    return n;
                }(), u = function() {
                    var e, n;
                    for(n = [], s = e = 0; 0 <= h ? e < h : e > h; s = 0 <= h ? ++e : --e)n.push(t.readUInt16());
                    return n;
                }(), c = function() {
                    var e, n;
                    for(n = [], s = e = 0; 0 <= h ? e < h : e > h; s = 0 <= h ? ++e : --e)n.push(t.readUInt16());
                    return n;
                }(), r = (this.length - t.pos + this.offset) / 2, o = function() {
                    var e, n;
                    for(n = [], s = e = 0; 0 <= r ? e < r : e > r; s = 0 <= r ? ++e : --e)n.push(t.readUInt16());
                    return n;
                }(), s = m = 0, b = i.length; m < b; s = ++m)for(g = i[s], n = v = d = p[s]; d <= g ? v <= g : v >= g; n = d <= g ? ++v : --v)0 === c[s] ? a = n + u[s] : 0 !== (a = o[c[s] / 2 + (n - d) - (h - s)] || 0) && (a += u[s]), this.codeMap[n] = 65535 & a;
        }
        t.pos = l;
    }
    return t.encode = function(t, e) {
        var n, r, i, a, o, s, u, c, l, h, f, d, p, g, m, v, b, y, w, N, L, x, A, S, _, P, k, F, I, j, C, O, B, M, q, E, R, D, T, z, U, H, W, V, G, Y;
        switch(F = new $ffaeb8e02004bf5e$var$fe, a = Object.keys(t).sort(function(t, e) {
            return t - e;
        }), e){
            case "macroman":
                for(p = 0, g = function() {
                    var t = [];
                    for(d = 0; d < 256; ++d)t.push(0);
                    return t;
                }(), v = {
                    0: 0
                }, i = {}, I = 0, B = a.length; I < B; I++)null == v[W = t[r = a[I]]] && (v[W] = ++p), i[r] = {
                    old: t[r],
                    new: v[t[r]]
                }, g[r] = v[t[r]];
                return F.writeUInt16(1), F.writeUInt16(0), F.writeUInt32(12), F.writeUInt16(0), F.writeUInt16(262), F.writeUInt16(0), F.write(g), {
                    charMap: i,
                    subtable: F.data,
                    maxGlyphID: p + 1
                };
            case "unicode":
                for(P = [], l = [], b = 0, v = {}, n = {}, m = u = null, j = 0, M = a.length; j < M; j++)null == v[w = t[r = a[j]]] && (v[w] = ++b), n[r] = {
                    old: w,
                    new: v[w]
                }, o = v[w] - r, null != m && o === u || (m && l.push(m), P.push(r), u = o), m = r;
                for(m && l.push(m), l.push(65535), P.push(65535), S = 2 * (A = P.length), x = 2 * Math.pow(Math.log(A) / Math.LN2, 2), h = Math.log(x / 2) / Math.LN2, L = 2 * A - x, s = [], N = [], f = [], d = C = 0, q = P.length; C < q; d = ++C){
                    if (_ = P[d], c = l[d], 65535 === _) {
                        s.push(0), N.push(0);
                        break;
                    }
                    if (_ - (k = n[_].new) >= 32768) for(s.push(0), N.push(2 * (f.length + A - d)), r = O = _; _ <= c ? O <= c : O >= c; r = _ <= c ? ++O : --O)f.push(n[r].new);
                    else s.push(k - _), N.push(0);
                }
                for(F.writeUInt16(3), F.writeUInt16(1), F.writeUInt32(12), F.writeUInt16(4), F.writeUInt16(16 + 8 * A + 2 * f.length), F.writeUInt16(0), F.writeUInt16(S), F.writeUInt16(x), F.writeUInt16(h), F.writeUInt16(L), U = 0, E = l.length; U < E; U++)r = l[U], F.writeUInt16(r);
                for(F.writeUInt16(0), H = 0, R = P.length; H < R; H++)r = P[H], F.writeUInt16(r);
                for(V = 0, D = s.length; V < D; V++)o = s[V], F.writeUInt16(o);
                for(G = 0, T = N.length; G < T; G++)y = N[G], F.writeUInt16(y);
                for(Y = 0, z = f.length; Y < z; Y++)p = f[Y], F.writeUInt16(p);
                return {
                    charMap: n,
                    subtable: F.data,
                    maxGlyphID: b + 1
                };
        }
    }, t;
}(), $ffaeb8e02004bf5e$var$be = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $ffaeb8e02004bf5e$var$ge(t, $ffaeb8e02004bf5e$var$he), t.prototype.tag = "cmap", t.prototype.parse = function(t) {
        var e, n, r;
        for(t.pos = this.offset, this.version = t.readUInt16(), r = t.readUInt16(), this.tables = [], this.unicode = null, n = 0; 0 <= r ? n < r : n > r; n = 0 <= r ? ++n : --n)e = new $ffaeb8e02004bf5e$var$ve(t, this.offset), this.tables.push(e), e.isUnicode && null == this.unicode && (this.unicode = e);
        return !0;
    }, t.encode = function(t, e) {
        var n, r;
        return null == e && (e = "macroman"), n = $ffaeb8e02004bf5e$var$ve.encode(t, e), (r = new $ffaeb8e02004bf5e$var$fe).writeUInt16(0), r.writeUInt16(1), n.table = r.data.concat(n.subtable), n;
    }, t;
}(), $ffaeb8e02004bf5e$var$ye = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $ffaeb8e02004bf5e$var$ge(t, $ffaeb8e02004bf5e$var$he), t.prototype.tag = "hhea", t.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.ascender = t.readShort(), this.decender = t.readShort(), this.lineGap = t.readShort(), this.advanceWidthMax = t.readShort(), this.minLeftSideBearing = t.readShort(), this.minRightSideBearing = t.readShort(), this.xMaxExtent = t.readShort(), this.caretSlopeRise = t.readShort(), this.caretSlopeRun = t.readShort(), this.caretOffset = t.readShort(), t.pos += 8, this.metricDataFormat = t.readShort(), this.numberOfMetrics = t.readUInt16();
    }, t;
}(), $ffaeb8e02004bf5e$var$we = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $ffaeb8e02004bf5e$var$ge(t, $ffaeb8e02004bf5e$var$he), t.prototype.tag = "OS/2", t.prototype.parse = function(t) {
        if (t.pos = this.offset, this.version = t.readUInt16(), this.averageCharWidth = t.readShort(), this.weightClass = t.readUInt16(), this.widthClass = t.readUInt16(), this.type = t.readShort(), this.ySubscriptXSize = t.readShort(), this.ySubscriptYSize = t.readShort(), this.ySubscriptXOffset = t.readShort(), this.ySubscriptYOffset = t.readShort(), this.ySuperscriptXSize = t.readShort(), this.ySuperscriptYSize = t.readShort(), this.ySuperscriptXOffset = t.readShort(), this.ySuperscriptYOffset = t.readShort(), this.yStrikeoutSize = t.readShort(), this.yStrikeoutPosition = t.readShort(), this.familyClass = t.readShort(), this.panose = function() {
            var e, n;
            for(n = [], e = 0; e < 10; ++e)n.push(t.readByte());
            return n;
        }(), this.charRange = function() {
            var e, n;
            for(n = [], e = 0; e < 4; ++e)n.push(t.readInt());
            return n;
        }(), this.vendorID = t.readString(4), this.selection = t.readShort(), this.firstCharIndex = t.readShort(), this.lastCharIndex = t.readShort(), this.version > 0 && (this.ascent = t.readShort(), this.descent = t.readShort(), this.lineGap = t.readShort(), this.winAscent = t.readShort(), this.winDescent = t.readShort(), this.codePageRange = function() {
            var e, n;
            for(n = [], e = 0; e < 2; e = ++e)n.push(t.readInt());
            return n;
        }(), this.version > 1)) return this.xHeight = t.readShort(), this.capHeight = t.readShort(), this.defaultChar = t.readShort(), this.breakChar = t.readShort(), this.maxContext = t.readShort();
    }, t;
}(), $ffaeb8e02004bf5e$var$Ne = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $ffaeb8e02004bf5e$var$ge(t, $ffaeb8e02004bf5e$var$he), t.prototype.tag = "post", t.prototype.parse = function(t) {
        var e, n, r;
        switch(t.pos = this.offset, this.format = t.readInt(), this.italicAngle = t.readInt(), this.underlinePosition = t.readShort(), this.underlineThickness = t.readShort(), this.isFixedPitch = t.readInt(), this.minMemType42 = t.readInt(), this.maxMemType42 = t.readInt(), this.minMemType1 = t.readInt(), this.maxMemType1 = t.readInt(), this.format){
            case 65536:
            case 196608:
                break;
            case 131072:
                var i;
                for(n = t.readUInt16(), this.glyphNameIndex = [], i = 0; 0 <= n ? i < n : i > n; i = 0 <= n ? ++i : --i)this.glyphNameIndex.push(t.readUInt16());
                for(this.names = [], r = []; t.pos < this.offset + this.length;)e = t.readByte(), r.push(this.names.push(t.readString(e)));
                return r;
            case 151552:
                return n = t.readUInt16(), this.offsets = t.read(n);
            case 262144:
                return this.map = (function() {
                    var e, n, r;
                    for(r = [], i = e = 0, n = this.file.maxp.numGlyphs; 0 <= n ? e < n : e > n; i = 0 <= n ? ++e : --e)r.push(t.readUInt32());
                    return r;
                }).call(this);
        }
    }, t;
}(), $ffaeb8e02004bf5e$var$Le = function(t, e) {
    this.raw = t, this.length = t.length, this.platformID = e.platformID, this.encodingID = e.encodingID, this.languageID = e.languageID;
}, $ffaeb8e02004bf5e$var$xe = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $ffaeb8e02004bf5e$var$ge(t, $ffaeb8e02004bf5e$var$he), t.prototype.tag = "name", t.prototype.parse = function(t) {
        var e, n, r, i, a, o, s, u, c, l, h;
        for(t.pos = this.offset, t.readShort(), e = t.readShort(), o = t.readShort(), n = [], i = 0; 0 <= e ? i < e : i > e; i = 0 <= e ? ++i : --i)n.push({
            platformID: t.readShort(),
            encodingID: t.readShort(),
            languageID: t.readShort(),
            nameID: t.readShort(),
            length: t.readShort(),
            offset: this.offset + o + t.readShort()
        });
        for(s = {}, i = c = 0, l = n.length; c < l; i = ++c)r = n[i], t.pos = r.offset, u = t.readString(r.length), a = new $ffaeb8e02004bf5e$var$Le(u, r), null == s[h = r.nameID] && (s[h] = []), s[r.nameID].push(a);
        this.strings = s, this.copyright = s[0], this.fontFamily = s[1], this.fontSubfamily = s[2], this.uniqueSubfamily = s[3], this.fontName = s[4], this.version = s[5];
        try {
            this.postscriptName = s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
        } catch (f) {
            this.postscriptName = s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
        }
        return this.trademark = s[7], this.manufacturer = s[8], this.designer = s[9], this.description = s[10], this.vendorUrl = s[11], this.designerUrl = s[12], this.license = s[13], this.licenseUrl = s[14], this.preferredFamily = s[15], this.preferredSubfamily = s[17], this.compatibleFull = s[18], this.sampleText = s[19];
    }, t;
}(), $ffaeb8e02004bf5e$var$Ae = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $ffaeb8e02004bf5e$var$ge(t, $ffaeb8e02004bf5e$var$he), t.prototype.tag = "maxp", t.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.numGlyphs = t.readUInt16(), this.maxPoints = t.readUInt16(), this.maxContours = t.readUInt16(), this.maxCompositePoints = t.readUInt16(), this.maxComponentContours = t.readUInt16(), this.maxZones = t.readUInt16(), this.maxTwilightPoints = t.readUInt16(), this.maxStorage = t.readUInt16(), this.maxFunctionDefs = t.readUInt16(), this.maxInstructionDefs = t.readUInt16(), this.maxStackElements = t.readUInt16(), this.maxSizeOfInstructions = t.readUInt16(), this.maxComponentElements = t.readUInt16(), this.maxComponentDepth = t.readUInt16();
    }, t;
}(), $ffaeb8e02004bf5e$var$Se = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $ffaeb8e02004bf5e$var$ge(t, $ffaeb8e02004bf5e$var$he), t.prototype.tag = "hmtx", t.prototype.parse = function(t) {
        var e, n, r, i, a, o, s;
        for(t.pos = this.offset, this.metrics = [], e = 0, o = this.file.hhea.numberOfMetrics; 0 <= o ? e < o : e > o; e = 0 <= o ? ++e : --e)this.metrics.push({
            advance: t.readUInt16(),
            lsb: t.readInt16()
        });
        for(r = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function() {
            var n, i;
            for(i = [], e = n = 0; 0 <= r ? n < r : n > r; e = 0 <= r ? ++n : --n)i.push(t.readInt16());
            return i;
        }(), this.widths = (function() {
            var t, e, n, r;
            for(r = [], t = 0, e = (n = this.metrics).length; t < e; t++)i = n[t], r.push(i.advance);
            return r;
        }).call(this), n = this.widths[this.widths.length - 1], s = [], e = a = 0; 0 <= r ? a < r : a > r; e = 0 <= r ? ++a : --a)s.push(this.widths.push(n));
        return s;
    }, t.prototype.forGlyph = function(t) {
        return t in this.metrics ? this.metrics[t] : {
            advance: this.metrics[this.metrics.length - 1].advance,
            lsb: this.leftSideBearings[t - this.metrics.length]
        };
    }, t;
}(), $ffaeb8e02004bf5e$var$_e = [].slice, $ffaeb8e02004bf5e$var$Pe = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $ffaeb8e02004bf5e$var$ge(t, $ffaeb8e02004bf5e$var$he), t.prototype.tag = "glyf", t.prototype.parse = function() {
        return this.cache = {};
    }, t.prototype.glyphFor = function(t) {
        var e, n, r, i, a, o, s, u, c, l;
        return t in this.cache ? this.cache[t] : (i = this.file.loca, e = this.file.contents, n = i.indexOf(t), 0 === (r = i.lengthOf(t)) ? this.cache[t] = null : (e.pos = this.offset + n, a = (o = new $ffaeb8e02004bf5e$var$fe(e.read(r))).readShort(), u = o.readShort(), l = o.readShort(), s = o.readShort(), c = o.readShort(), this.cache[t] = -1 === a ? new $ffaeb8e02004bf5e$var$Fe(o, u, l, s, c) : new $ffaeb8e02004bf5e$var$ke(o, a, u, l, s, c), this.cache[t]));
    }, t.prototype.encode = function(t, e, n) {
        var r, i, a, o, s;
        for(a = [], i = [], o = 0, s = e.length; o < s; o++)r = t[e[o]], i.push(a.length), r && (a = a.concat(r.encode(n)));
        return i.push(a.length), {
            table: a,
            offsets: i
        };
    }, t;
}(), $ffaeb8e02004bf5e$var$ke = function() {
    function t(t, e, n, r, i, a) {
        this.raw = t, this.numberOfContours = e, this.xMin = n, this.yMin = r, this.xMax = i, this.yMax = a, this.compound = !1;
    }
    return t.prototype.encode = function() {
        return this.raw.data;
    }, t;
}(), $ffaeb8e02004bf5e$var$Fe = function() {
    function t(t, e, n, r, i) {
        var a, o;
        for(this.raw = t, this.xMin = e, this.yMin = n, this.xMax = r, this.yMax = i, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], a = this.raw; o = a.readShort(), this.glyphOffsets.push(a.pos), this.glyphIDs.push(a.readUInt16()), 32 & o;)a.pos += 1 & o ? 4 : 2, 128 & o ? a.pos += 8 : 64 & o ? a.pos += 4 : 8 & o && (a.pos += 2);
    }
    return t.prototype.encode = function() {
        var t, e, n;
        for(e = new $ffaeb8e02004bf5e$var$fe($ffaeb8e02004bf5e$var$_e.call(this.raw.data)), t = 0, n = this.glyphIDs.length; t < n; ++t)e.pos = this.glyphOffsets[t];
        return e.data;
    }, t;
}(), $ffaeb8e02004bf5e$var$Ie = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $ffaeb8e02004bf5e$var$ge(t, $ffaeb8e02004bf5e$var$he), t.prototype.tag = "loca", t.prototype.parse = function(t) {
        var e, n;
        return t.pos = this.offset, e = this.file.head.indexToLocFormat, this.offsets = 0 === e ? (function() {
            var e, r;
            for(r = [], n = 0, e = this.length; n < e; n += 2)r.push(2 * t.readUInt16());
            return r;
        }).call(this) : (function() {
            var e, r;
            for(r = [], n = 0, e = this.length; n < e; n += 4)r.push(t.readUInt32());
            return r;
        }).call(this);
    }, t.prototype.indexOf = function(t) {
        return this.offsets[t];
    }, t.prototype.lengthOf = function(t) {
        return this.offsets[t + 1] - this.offsets[t];
    }, t.prototype.encode = function(t, e) {
        for(var n = new Uint32Array(this.offsets.length), r = 0, i = 0, a = 0; a < n.length; ++a)if (n[a] = r, i < e.length && e[i] == a) {
            ++i, n[a] = r;
            var o = this.offsets[a], s = this.offsets[a + 1] - o;
            s > 0 && (r += s);
        }
        for(var u = new Array(4 * n.length), c = 0; c < n.length; ++c)u[4 * c + 3] = 255 & n[c], u[4 * c + 2] = (65280 & n[c]) >> 8, u[4 * c + 1] = (16711680 & n[c]) >> 16, u[4 * c] = (4278190080 & n[c]) >> 24;
        return u;
    }, t;
}(), $ffaeb8e02004bf5e$var$je = function() {
    function t(t) {
        this.font = t, this.subset = {}, this.unicodes = {}, this.next = 33;
    }
    return t.prototype.generateCmap = function() {
        var t, e, n, r, i;
        for(e in r = this.font.cmap.tables[0].codeMap, t = {}, i = this.subset)n = i[e], t[e] = r[n];
        return t;
    }, t.prototype.glyphsFor = function(t) {
        var e, n, r, i, a, o, s;
        for(r = {}, a = 0, o = t.length; a < o; a++)r[i = t[a]] = this.font.glyf.glyphFor(i);
        for(i in e = [], r)(null != (n = r[i]) ? n.compound : void 0) && e.push.apply(e, n.glyphIDs);
        if (e.length > 0) for(i in s = this.glyphsFor(e))n = s[i], r[i] = n;
        return r;
    }, t.prototype.encode = function(t, e) {
        var n, r, i, a, o, s, u, c, l, h, f, d, p, g, m;
        for(r in n = $ffaeb8e02004bf5e$var$be.encode(this.generateCmap(), "unicode"), a = this.glyphsFor(t), f = {
            0: 0
        }, m = n.charMap)f[(s = m[r]).old] = s.new;
        for(d in h = n.maxGlyphID, a)d in f || (f[d] = h++);
        return c = function(t) {
            var e, n;
            for(e in n = {}, t)n[t[e]] = e;
            return n;
        }(f), l = Object.keys(c).sort(function(t, e) {
            return t - e;
        }), p = function() {
            var t, e, n;
            for(n = [], t = 0, e = l.length; t < e; t++)o = l[t], n.push(c[o]);
            return n;
        }(), i = this.font.glyf.encode(a, p, f), u = this.font.loca.encode(i.offsets, p), g = {
            cmap: this.font.cmap.raw(),
            glyf: i.table,
            loca: u,
            hmtx: this.font.hmtx.raw(),
            hhea: this.font.hhea.raw(),
            maxp: this.font.maxp.raw(),
            post: this.font.post.raw(),
            name: this.font.name.raw(),
            head: this.font.head.encode(e)
        }, this.font.os2.exists && (g["OS/2"] = this.font.os2.raw()), this.font.directory.encode(g);
    }, t;
}();
$ffaeb8e02004bf5e$export$2e2bcd8739ae039.API.PDFObject = function() {
    var t;
    function e() {}
    return t = function(t, e) {
        return (Array(e + 1).join("0") + t).slice(-e);
    }, e.convert = function(n) {
        var r, i, a, o;
        if (Array.isArray(n)) return "[" + (function() {
            var t, i, a;
            for(a = [], t = 0, i = n.length; t < i; t++)r = n[t], a.push(e.convert(r));
            return a;
        })().join(" ") + "]";
        if ("string" == typeof n) return "/" + n;
        if (null != n ? n.isString : void 0) return "(" + n + ")";
        if (n instanceof Date) return "(D:" + t(n.getUTCFullYear(), 4) + t(n.getUTCMonth(), 2) + t(n.getUTCDate(), 2) + t(n.getUTCHours(), 2) + t(n.getUTCMinutes(), 2) + t(n.getUTCSeconds(), 2) + "Z)";
        if ("[object Object]" === ({}).toString.call(n)) {
            for(i in a = [
                "<<"
            ], n)o = n[i], a.push("/" + i + " " + e.convert(o));
            return a.push(">>"), a.join("\n");
        }
        return "" + n;
    }, e;
}();








const $8606635b7d465052$var$formatAmount = (value, decimals)=>{
    const parsed = parseFloat(String(value ?? ''));
    return Number.isNaN(parsed) ? '-' : (0, $00658ccd6ec0135a$export$f5dd818bff069720)(value ?? '0', true, false, false, decimals);
};
const $8606635b7d465052$var$formatCost = (value, decimals)=>{
    const formatted = $8606635b7d465052$var$formatAmount(value, decimals);
    return formatted === '-' ? '-' : `(${formatted})`;
};
const $8606635b7d465052$var$formatCreditPrice = (value)=>{
    const parsed = parseFloat(String(value ?? ''));
    return Number.isNaN(parsed) ? 'N/A' : (0, $00658ccd6ec0135a$export$f5dd818bff069720)(value ?? '0', true, false, false, 2);
};
const $8606635b7d465052$var$escapeCsvValue = (value)=>{
    if (value.includes('"') || value.includes(',') || value.includes('\n') || value.includes('\r')) return `"${value.replace(/"/g, '""')}"`;
    return value;
};
const $8606635b7d465052$var$buildCsvString = (rows)=>rows.map((row)=>row.map((value)=>$8606635b7d465052$var$escapeCsvValue(value)).join(',')).join('\n');
const $8606635b7d465052$var$buildDataRowValues = (params)=>{
    const { programData: programData, facilityData: facilityData, categoryData: categoryData, totalsData: totalsData, t: t } = params;
    if (!facilityData && !totalsData && !programData && !categoryData) return null;
    const values = {};
    values.title = programData ? programData.name : facilityData ? facilityData.address : categoryData ? categoryData.name : t('statements:totals');
    const credits = programData?.credits ?? facilityData?.credits ?? categoryData?.credits ?? totalsData?.credits;
    values.credits = $8606635b7d465052$var$formatAmount(credits, 2);
    const creditPrice = programData?.credit_price ?? facilityData?.credit_price ?? categoryData?.credit_price;
    values.credit_price = $8606635b7d465052$var$formatCreditPrice(creditPrice);
    const totalValue = programData?.total_value ?? facilityData?.total_value ?? categoryData?.total_value ?? totalsData?.total_value;
    values.total_value = $8606635b7d465052$var$formatAmount(totalValue, 2);
    const recCost = programData?.rec_cost ?? facilityData?.rec_cost ?? categoryData?.rec_cost ?? totalsData?.rec_cost;
    values.rec_cost = $8606635b7d465052$var$formatCost(recCost, 2);
    const taxesOnCreditSale = programData?.taxes_on_credit_sale ?? facilityData?.taxes_on_credit_sale ?? categoryData?.taxes_on_credit_sale ?? totalsData?.taxes_on_credit_sale;
    values.taxes_on_credit_sale = $8606635b7d465052$var$formatAmount(taxesOnCreditSale, 2);
    const brokerCost = programData?.broker_cost ?? facilityData?.broker_cost ?? categoryData?.broker_cost ?? totalsData?.broker_cost;
    values.broker_cost = $8606635b7d465052$var$formatCost(brokerCost, 2);
    const taxesOnServices = programData?.taxes_on_services ?? facilityData?.taxes_on_services ?? categoryData?.taxes_on_services ?? totalsData?.taxes_on_services;
    values.taxes_on_services = $8606635b7d465052$var$formatCost(taxesOnServices, 2);
    const fuseServiceFee = programData?.fuse_service_fee ?? facilityData?.fuse_service_fee ?? categoryData?.fuse_service_fee ?? totalsData?.fuse_service_fee;
    values.fuse_service_fee = $8606635b7d465052$var$formatCost(fuseServiceFee, 2);
    const totalKwh = programData?.total_kwh ?? facilityData?.total_kwh ?? categoryData?.total_kwh ?? totalsData?.total_kwh;
    values.total_kwh = $8606635b7d465052$var$formatAmount(totalKwh, 0);
    const netIncentive = programData?.net_incentive ?? facilityData?.net_incentive ?? categoryData?.net_incentive ?? totalsData?.net_incentive;
    values.net_incentive = $8606635b7d465052$var$formatAmount(netIncentive, 2);
    return values;
};
const $8606635b7d465052$export$246b057af572648e = (options)=>{
    const { incentiveStatement: incentiveStatement, isSummary: isSummary, countryId: countryId, t: t } = options;
    const normalized = (0, $049b0cfdd8ac4942$export$e0c1ba76f119f8b1)(incentiveStatement);
    const infoRows = [
        [
            t('common:clientName'),
            normalized.client_name
        ],
        [
            t('common:reportingPeriod'),
            normalized.reporting_period
        ],
        []
    ];
    const isCanada = countryId === (0, $0badf5665deea2b2$export$b77c37614753bffb).Canada;
    const headers = [
        t('common:program'),
        t('common:totalKwh'),
        t('statements:credits'),
        t('statements:creditPrice'),
        t('statements:totalValue'),
        isCanada ? t('statements:taxesOnCreditSale') : t('statements:recCost'),
        isCanada ? t('statements:taxesOnServices') : t('statements:brokerCost'),
        t('statements:fuseServiceFee'),
        t('statements:netIncentive')
    ];
    const buildRow = (values)=>[
            values.title,
            values.total_kwh,
            values.credits,
            values.credit_price,
            values.total_value,
            isCanada ? values.taxes_on_credit_sale : values.rec_cost,
            isCanada ? values.taxes_on_services : values.broker_cost,
            values.fuse_service_fee,
            values.net_incentive
        ];
    const dataRows = [];
    normalized.programs.forEach((program)=>{
        const programRow = $8606635b7d465052$var$buildDataRowValues({
            programData: program,
            t: t
        });
        if (programRow) dataRows.push(buildRow(programRow));
        if (!isSummary) program.facilities.forEach((facility)=>{
            const facilityRow = $8606635b7d465052$var$buildDataRowValues({
                facilityData: facility,
                t: t
            });
            if (facilityRow) dataRows.push(buildRow(facilityRow));
            facility.equipment_categories?.forEach((category)=>{
                const categoryRow = $8606635b7d465052$var$buildDataRowValues({
                    categoryData: category,
                    t: t
                });
                if (categoryRow) dataRows.push(buildRow(categoryRow));
            });
        });
    });
    const totalsRow = $8606635b7d465052$var$buildDataRowValues({
        totalsData: normalized.totals,
        t: t
    });
    if (totalsRow) dataRows.push(buildRow(totalsRow));
    dataRows.push([
        t('statements:grandTotal'),
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        $8606635b7d465052$var$formatAmount(normalized.totals.net_incentive, 2)
    ]);
    return [
        ...infoRows,
        headers,
        ...dataRows
    ];
};
const $8606635b7d465052$export$c6d851d1877b46af = (rows, filename)=>{
    const csvString = $8606635b7d465052$var$buildCsvString(rows);
    const blob = new Blob([
        csvString
    ], {
        type: 'text/csv;charset=utf-8;'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
};







const $286fd38e6f3cdcf9$export$ed512ad00b41a13f = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** Query Params **/ const params = (0, $62d58f5c28b15c2e$export$99eaa27ddbbb95ef)();
    const clientId = parseInt(params.client_id ?? '');
    const incentiveStatementId = parseInt(params.incentive_statement_id ?? '');
    const reportingPeriodId = parseInt(params.reporting_period_id ?? '');
    const isInvalidParams = Number.isNaN(incentiveStatementId) && Number.isNaN(reportingPeriodId);
    /** State **/ const [isLoading, setIsLoading] = (0, $2xPiy.useState)(true);
    const [incentiveStatement, setIncentiveStatement] = (0, $2xPiy.useState)();
    const [countryId, setCountryId] = (0, $2xPiy.useState)();
    /** Refs **/ const contentRef = (0, $2xPiy.useRef)(null);
    /** Methods **/ const fetchPageData = async ()=>{
        try {
            setIsLoading(true);
            if (!Number.isNaN(reportingPeriodId)) {
                const data = await (0, $56a7168c8945bbf5$export$c90fd1a7cde0dffa).getIncentiveStatementReportingPeriod({
                    id: reportingPeriodId
                });
                setIncentiveStatement(data);
            } else if (!Number.isNaN(incentiveStatementId)) {
                const data = await (0, $56a7168c8945bbf5$export$c90fd1a7cde0dffa).getIncentiveStatement({
                    id: incentiveStatementId
                });
                setIncentiveStatement(data);
            }
            if (!Number.isNaN(clientId)) {
                const client = userStore.isClientUser || userStore.isFacilityUser ? userStore.user?.clients.find((c)=>c.id === clientId) : await (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).get({
                    id: clientId
                });
                setCountryId(client?.country_id);
            }
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).getIncentiveStatement.error);
        } finally{
            setIsLoading(false);
        }
    };
    const generatePDF = async ()=>{
        if (!contentRef.current || !incentiveStatement) return;
        const normalized = (0, $049b0cfdd8ac4942$export$e0c1ba76f119f8b1)(incentiveStatement);
        const originalElement = contentRef.current;
        const tempElement = originalElement.cloneNode(true);
        tempElement.style.width = '1200px';
        tempElement.style.padding = '20px';
        tempElement.style.backgroundColor = 'white';
        const tables = tempElement.querySelectorAll('table');
        tables.forEach((table)=>{
            table.style.width = '100%';
            table.style.borderCollapse = 'collapse';
            table.style.marginBottom = '30px';
            const cells = table.querySelectorAll('th, td');
            cells.forEach((cell)=>{
                const tableCell = cell;
                tableCell.style.padding = '8px';
                tableCell.style.fontSize = '14px';
            });
        });
        tempElement.style.position = 'absolute';
        tempElement.style.left = '-9999px';
        document.body.appendChild(tempElement);
        const contentWidth = tempElement.scrollWidth;
        const contentHeight = tempElement.scrollHeight;
        const canvas = await (0, (/*@__PURE__*/$parcel$interopDefault($1hFlE)))(tempElement, {
            scale: 3,
            logging: false,
            useCORS: true,
            allowTaint: true,
            width: contentWidth,
            height: contentHeight + 100
        });
        const pdf = new (0, $ffaeb8e02004bf5e$export$2e2bcd8739ae039)({
            orientation: 'landscape',
            unit: 'mm',
            format: 'a4'
        });
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const marginX = 10;
        const marginY = 10;
        const pageContentWidth = pageWidth - marginX * 2;
        const pageContentHeight = pageHeight - marginY * 2;
        const scale = pageContentWidth / canvas.width;
        const pageHeightPx = pageContentHeight / scale;
        let renderedHeightPx = 0;
        let pageIndex = 0;
        while(renderedHeightPx < canvas.height){
            const sliceHeightPx = Math.min(pageHeightPx, canvas.height - renderedHeightPx);
            const pageCanvas = document.createElement('canvas');
            pageCanvas.width = canvas.width;
            pageCanvas.height = sliceHeightPx;
            const pageContext = pageCanvas.getContext('2d');
            if (!pageContext) break;
            pageContext.drawImage(canvas, 0, renderedHeightPx, canvas.width, sliceHeightPx, 0, 0, canvas.width, sliceHeightPx);
            if (pageIndex > 0) pdf.addPage();
            const sliceHeightMm = sliceHeightPx * scale;
            pdf.addImage(pageCanvas.toDataURL('image/jpeg'), marginX, marginY, pageContentWidth, sliceHeightMm);
            renderedHeightPx += sliceHeightPx;
            pageIndex += 1;
        }
        const safeClientName = normalized.client_name.replace(/\s+/g, '-').toLowerCase();
        const fileId = !Number.isNaN(reportingPeriodId) ? `combined-${reportingPeriodId}` : incentiveStatementId;
        const fileName = `incentive-statement-details-${safeClientName}-${fileId}.pdf`;
        pdf.save(fileName);
        tempElement.remove();
    };
    const generateCsv = ()=>{
        if (!incentiveStatement) return;
        const normalized = (0, $049b0cfdd8ac4942$export$e0c1ba76f119f8b1)(incentiveStatement);
        const rows = (0, $8606635b7d465052$export$246b057af572648e)({
            incentiveStatement: incentiveStatement,
            countryId: countryId,
            t: t
        });
        const safeClientName = normalized.client_name.trim().replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_-]/g, '');
        const filename = `${safeClientName}_IncentiveStatementDetailed_${(0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))().format('YYYY-MM-DD')}.csv`;
        (0, $8606635b7d465052$export$c6d851d1877b46af)(rows, filename);
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (!Number.isNaN(incentiveStatementId) || !Number.isNaN(reportingPeriodId)) fetchPageData();
    }, [
        clientId,
        incentiveStatementId,
        reportingPeriodId
    ]);
    /** Render **/ return isInvalidParams ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8fedf23083f90239$export$2e2bcd8739ae039), {}) : !isLoading && incentiveStatement ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                direction: "row",
                justify: "center",
                gap: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('8px'),
                margin: {
                    top: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('16px'),
                    bottom: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('16px')
                },
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ad3dfa44adb42595$export$353f5b6fc5456de1), {
                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $400b12c0802e75f5$export$a7aaed3e118dd255), {
                            size: "small"
                        }),
                        label: t('statements:downloadPDF'),
                        onClick: generatePDF,
                        pad: {
                            horizontal: '0.5rem',
                            vertical: '0.25rem'
                        }
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ad3dfa44adb42595$export$353f5b6fc5456de1), {
                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $400b12c0802e75f5$export$a7aaed3e118dd255), {
                            size: "small"
                        }),
                        label: t('statements:downloadCSV'),
                        onClick: generateCsv,
                        pad: {
                            horizontal: '0.5rem',
                            vertical: '0.25rem'
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                fill: "horizontal",
                background: "brand",
                height: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('8px')
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                pad: {
                    horizontal: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('44px'),
                    vertical: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('24px')
                },
                fontFamily: "Lato, sans-serif",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)("div", {
                    ref: contentRef,
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            direction: "row",
                            align: "center",
                            justify: "between",
                            margin: {
                                bottom: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('16px')
                            },
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ff16ac31d7c036ca$export$ac4f8729c50d29aa), {}),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a19f59ee0120218$export$25895b921b7e775b), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            margin: {
                                bottom: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('16px')
                            },
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('30px'),
                                weight: 700,
                                letterSpacing: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('-0.4px'),
                                children: t('statements:incentiveStatement')
                            })
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c18f805a5ac844fb$export$da9a2709d1cb1ab4), {
                            incentiveStatement: incentiveStatement,
                            margin: {
                                bottom: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('4px')
                            },
                            pad: {
                                horizontal: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('4px')
                            }
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                            margin: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('14px'),
                            size: "xsmall",
                            color: "text"
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $78e0d7df04d75fa4$export$2a8f4302f71576bb), {
                            incentiveStatement: incentiveStatement,
                            countryId: countryId,
                            margin: {
                                bottom: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('24px')
                            }
                        })
                    ]
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {});
});




var $2xPiy = parcelRequire("2xPiy");





var $1hFlE = parcelRequire("1hFlE");










const $95122b286ffa2a2c$export$ba436cfe1bb8170d = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** Query Params **/ const params = (0, $62d58f5c28b15c2e$export$99eaa27ddbbb95ef)();
    const clientId = parseInt(params.client_id ?? '');
    const incentiveStatementId = parseInt(params.incentive_statement_id ?? '');
    const reportingPeriodId = parseInt(params.reporting_period_id ?? '');
    const isInvalidParams = Number.isNaN(incentiveStatementId) && Number.isNaN(reportingPeriodId);
    /** State **/ const [isLoading, setIsLoading] = (0, $2xPiy.useState)(true);
    const [incentiveStatement, setIncentiveStatement] = (0, $2xPiy.useState)();
    const [countryId, setCountryId] = (0, $2xPiy.useState)();
    /** Refs **/ const contentRef = (0, $2xPiy.useRef)(null);
    /** Methods **/ const fetchPageData = async ()=>{
        try {
            setIsLoading(true);
            if (!Number.isNaN(reportingPeriodId)) {
                const data = await (0, $56a7168c8945bbf5$export$c90fd1a7cde0dffa).getIncentiveStatementReportingPeriod({
                    id: reportingPeriodId
                });
                setIncentiveStatement(data);
            } else if (!Number.isNaN(incentiveStatementId)) {
                const data = await (0, $56a7168c8945bbf5$export$c90fd1a7cde0dffa).getIncentiveStatement({
                    id: incentiveStatementId
                });
                setIncentiveStatement(data);
            }
            if (!Number.isNaN(clientId)) {
                const client = userStore.isClientUser || userStore.isFacilityUser ? userStore.user?.clients.find((c)=>c.id === clientId) : await (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).get({
                    id: clientId
                });
                setCountryId(client?.country_id);
            }
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).getIncentiveStatement.error);
        } finally{
            setIsLoading(false);
        }
    };
    const generatePDF = async ()=>{
        if (!contentRef.current || !incentiveStatement) return;
        const normalized = (0, $049b0cfdd8ac4942$export$e0c1ba76f119f8b1)(incentiveStatement);
        const originalElement = contentRef.current;
        const tempElement = originalElement.cloneNode(true);
        tempElement.style.width = '1200px';
        tempElement.style.padding = '20px';
        tempElement.style.backgroundColor = 'white';
        const tables = tempElement.querySelectorAll('table');
        tables.forEach((table)=>{
            table.style.width = '100%';
            table.style.borderCollapse = 'collapse';
            table.style.marginBottom = '30px';
            const cells = table.querySelectorAll('th, td');
            cells.forEach((cell)=>{
                const tableCell = cell;
                tableCell.style.padding = '8px';
                tableCell.style.fontSize = '14px';
            });
        });
        tempElement.style.position = 'absolute';
        tempElement.style.left = '-9999px';
        document.body.appendChild(tempElement);
        const contentWidth = tempElement.scrollWidth;
        const contentHeight = tempElement.scrollHeight;
        const canvas = await (0, (/*@__PURE__*/$parcel$interopDefault($1hFlE)))(tempElement, {
            scale: 1.5,
            logging: false,
            useCORS: true,
            allowTaint: true,
            width: contentWidth,
            height: contentHeight + 100
        });
        const pdf = new (0, $ffaeb8e02004bf5e$export$2e2bcd8739ae039)({
            orientation: 'landscape',
            unit: 'mm',
            format: [
                310,
                235
            ]
        });
        const pageWidth = pdf.internal.pageSize.getWidth();
        const imgWidth = pageWidth - 20;
        const imgHeight = canvas.height * imgWidth / canvas.width;
        pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 10, 0, imgWidth, imgHeight);
        const safeClientName = normalized.client_name.replace(/\s+/g, '-').toLowerCase();
        const fileId = !Number.isNaN(reportingPeriodId) ? `combined-${reportingPeriodId}` : incentiveStatementId;
        const fileName = `incentive-statement-${safeClientName}-${fileId}.pdf`;
        pdf.save(fileName);
    };
    const generateCsv = ()=>{
        if (!incentiveStatement) return;
        const normalized = (0, $049b0cfdd8ac4942$export$e0c1ba76f119f8b1)(incentiveStatement);
        const rows = (0, $8606635b7d465052$export$246b057af572648e)({
            incentiveStatement: incentiveStatement,
            isSummary: true,
            countryId: countryId,
            t: t
        });
        const safeClientName = normalized.client_name.trim().replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_-]/g, '');
        const filename = `${safeClientName}_IncentiveStatementSummary_${(0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))().format('YYYY-MM-DD')}.csv`;
        (0, $8606635b7d465052$export$c6d851d1877b46af)(rows, filename);
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (!Number.isNaN(incentiveStatementId) || !Number.isNaN(reportingPeriodId)) fetchPageData();
    }, [
        clientId,
        incentiveStatementId,
        reportingPeriodId
    ]);
    /** Render **/ return isInvalidParams ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8fedf23083f90239$export$2e2bcd8739ae039), {}) : !isLoading && incentiveStatement ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                direction: "row",
                justify: "center",
                gap: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('8px'),
                margin: {
                    top: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('16px'),
                    bottom: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('16px')
                },
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ad3dfa44adb42595$export$353f5b6fc5456de1), {
                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $400b12c0802e75f5$export$a7aaed3e118dd255), {
                            size: "small"
                        }),
                        label: t('statements:downloadPDF'),
                        onClick: generatePDF,
                        pad: {
                            horizontal: '0.5rem',
                            vertical: '0.25rem'
                        }
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ad3dfa44adb42595$export$353f5b6fc5456de1), {
                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $400b12c0802e75f5$export$a7aaed3e118dd255), {
                            size: "small"
                        }),
                        label: t('statements:downloadCSV'),
                        onClick: generateCsv,
                        pad: {
                            horizontal: '0.5rem',
                            vertical: '0.25rem'
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                fill: "horizontal",
                background: "brand",
                height: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('8px')
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                pad: {
                    horizontal: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('44px'),
                    vertical: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('24px')
                },
                fontFamily: "Lato, sans-serif",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)("div", {
                    ref: contentRef,
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            direction: "row",
                            align: "center",
                            justify: "between",
                            margin: {
                                bottom: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('16px')
                            },
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ff16ac31d7c036ca$export$ac4f8729c50d29aa), {}),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a19f59ee0120218$export$25895b921b7e775b), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            margin: {
                                bottom: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('16px')
                            },
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                size: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('30px'),
                                letterSpacing: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('-0.4px'),
                                weight: 700,
                                children: t('statements:incentiveStatement')
                            })
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c18f805a5ac844fb$export$da9a2709d1cb1ab4), {
                            incentiveStatement: incentiveStatement,
                            margin: {
                                bottom: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('4px')
                            },
                            pad: {
                                horizontal: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('4px')
                            }
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                            margin: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('14px'),
                            size: "xsmall",
                            color: "text"
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $78e0d7df04d75fa4$export$2a8f4302f71576bb), {
                            incentiveStatement: incentiveStatement,
                            isSummary: true,
                            countryId: countryId,
                            margin: {
                                bottom: (0, $00658ccd6ec0135a$export$ed800035e096ef02)('24px')
                            }
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $4f34f15711532ac0$export$c5dc331420891764), {
                            countryId: countryId
                        })
                    ]
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {});
});






var $2xPiy = parcelRequire("2xPiy");










const $68b5f7e2197d6134$export$e5c7de443da6c3b9 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const params = (0, $62d58f5c28b15c2e$export$99eaa27ddbbb95ef)();
    /** State **/ const [clientName, setClientName] = (0, $2xPiy.useState)('');
    /** Computed **/ const clientId = parseInt(params.client_id ?? '');
    const isLoading = !clientName;
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (clientName) document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, clientName, 'Statements');
        else if (!clientName && userStore.user) {
            if (userStore.isFacilityUser) setClientName(userStore.user.clients.find((client)=>client.id === clientId)?.name ?? '');
            else (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).get({
                id: clientId
            }).then((client)=>setClientName(client.name)).catch((err)=>globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listIncentiveStatements.error));
        }
    }, [
        clientName
    ]);
    /* Product Tour */ (0, $ea039e16ca87cc85$export$28f524c77ee81092)({
        tourName: 'statements-tour',
        steps: (0, $3d0c747b3f894c98$export$5ae791509b33d09b),
        autoStart: true,
        showOnce: true
    });
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9057517707360bf5$export$9b7824917a0c851e), {
        title: clientName,
        pageHeader: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c61d91bfa75be0a1$export$53f1cd6809577fc5), {
            title: clientName
        }),
        breadcrumbNav: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e7dd63b10d4904e9$export$988959db72b892c3), {
            previousPages: [
                {
                    name: 'Clients',
                    link: !userStore.isClientUser && !userStore.isFacilityUser ? '/clients' : undefined
                },
                {
                    name: clientName,
                    link: !userStore.isFacilityUser ? `/clients/${clientId}` : undefined
                }
            ],
            currentPageName: "Statements"
        }),
        isLoading: isLoading,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $659efb5a52c8fd59$export$c2a262540e4917c2), {
            clientId: clientId,
            "data-tour": "statements-list"
        })
    });
});



const $874f8f08b8aec6cf$export$9dde37202ea57dd2 = [
    // Incentive Statement Summary
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/clients/:client_id/statements/incentive/:incentive_statement_id",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $95122b286ffa2a2c$export$ba436cfe1bb8170d), {})
            })
        })
    }),
    // Incentive Statement Details
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/clients/:client_id/statements/incentive/:incentive_statement_id/details",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $286fd38e6f3cdcf9$export$ed512ad00b41a13f), {})
            })
        })
    }),
    // Incentive Statement Summary (Combined Programs)
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/clients/:client_id/statements/reporting-period/:reporting_period_id",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $95122b286ffa2a2c$export$ba436cfe1bb8170d), {})
            })
        })
    }),
    // Incentive Statement Details (Combined Programs)
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/clients/:client_id/statements/reporting-period/:reporting_period_id/details",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $286fd38e6f3cdcf9$export$ed512ad00b41a13f), {})
            })
        })
    }),
    // Incentive Statements
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/clients/:client_id/statements",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $68b5f7e2197d6134$export$e5c7de443da6c3b9), {})
            })
        })
    })
];


const $d44804e75825a5af$export$a158435f6056802d = [
    // Client Details
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/clients/:client_id",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            allowedRoles: [
                ...(0, $a65473e9746b33bb$export$5d277a5d95a5046e),
                (0, $a65473e9746b33bb$export$2cb4a31baf73b247).ClientAdmin
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $1459dcf2d83e59a2$export$98997b5b698aaf10), {})
            })
        })
    }),
    // Create Client
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/clients/create",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            allowedRoles: [
                (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FuseAdmin
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9af6a02c74f839ab$export$2b805d58bbc86d8c), {})
            })
        })
    }),
    // List Clients
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/clients",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            allowedRoles: [
                ...(0, $a65473e9746b33bb$export$5d277a5d95a5046e),
                (0, $a65473e9746b33bb$export$2cb4a31baf73b247).ClientAdmin
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $4c3857ef80bdd58c$export$6dbd483c3ae79c29), {})
            })
        })
    })
];




var $2xPiy = parcelRequire("2xPiy");




var $2xPiy = parcelRequire("2xPiy");

function $fcb61b3305930380$var$_extends() {
    return $fcb61b3305930380$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fcb61b3305930380$var$_extends.apply(null, arguments);
}
var $fcb61b3305930380$export$3bc50e457b7f164b = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $fcb61b3305930380$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Globe"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 8s3.5 1 5 2 .564 2.42 1 3c.436.58 2-1 2 2s3 1 3 4 2.5 2.5 3 1 2.233-3.134 2-5c-.233-1.866-1-3-3-3s-3.5-.5-4-2 3-2 2-5 0-4 0-4m10 11c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11z"
    }));
});
$fcb61b3305930380$export$3bc50e457b7f164b.displayName = 'Globe';


var $2xPiy = parcelRequire("2xPiy");

function $1945a5c8d07968d7$var$_extends() {
    return $1945a5c8d07968d7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1945a5c8d07968d7$var$_extends.apply(null, arguments);
}
var $1945a5c8d07968d7$export$54d0e8420ac838ac = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $1945a5c8d07968d7$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "LineChart"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m1 16 7-7 5 5L23 4M0 22h23.999M16 4h7v7"
    }));
});
$1945a5c8d07968d7$export$54d0e8420ac838ac.displayName = 'LineChart';


var $2xPiy = parcelRequire("2xPiy");

function $e72bb2ac81e784e6$var$_extends() {
    return $e72bb2ac81e784e6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e72bb2ac81e784e6$var$_extends.apply(null, arguments);
}
var $e72bb2ac81e784e6$export$ac31625c0615bb80 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $e72bb2ac81e784e6$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Star"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        stroke: "#000",
        fill: "none",
        strokeWidth: "2",
        d: "M12.606 16.805 12 16.343l-.606.462L5.755 21.1l2.381-6.35.263-.701-.599-.45L3 10h6.72l.229-.684L12 3.162l2.051 6.154.228.684H21l-4.8 3.6-.6.45.264.701 2.38 6.35-5.638-4.296Z"
    }));
});
$e72bb2ac81e784e6$export$ac31625c0615bb80.displayName = 'StarOutline';



var $1hFlE = parcelRequire("1hFlE");












const $7e90f04af0cdf48d$var$Dashboard = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    /* Context */ const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const clientStore = (0, $116967e0234c3770$export$3b47afa599c78f61)();
    const dashboardStore = (0, $116967e0234c3770$export$176f58333fc13682)();
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /* State */ const [isLoading, setIsLoading] = (0, $2xPiy.useState)(false);
    const [isCanada, setIsCanada] = (0, $2xPiy.useState)(false);
    const [selectedCountry, setSelectedCountry] = (0, $2xPiy.useState)((0, $0badf5665deea2b2$export$bdfc9528aeaa6307).USA);
    const [focusedCountryTab, setFocusedCountryTab] = (0, $2xPiy.useState)('');
    const [searchParams] = (0, $79bcac94ca400be1$export$f1a78c17382fe22a)();
    /* Computed */ const isMobile = (0, $18588a518ac6fdc7$export$2ac00d7098bf223)(screenSize);
    const urlClientId = searchParams.get('client');
    const clientId = urlClientId ? parseInt(urlClientId) : userStore.isExternalUser ? clientStore.activeClientId : undefined;
    (0, $ea039e16ca87cc85$export$28f524c77ee81092)({
        tourName: 'dashboard-tour',
        steps: (0, $3d0c747b3f894c98$export$71960fd1648de88d),
        autoStart: true,
        showOnce: true
    });
    const isAdminDashboard = userStore.isFuseAdmin && !clientId;
    const isCombined = isAdminDashboard && selectedCountry === (0, $0badf5665deea2b2$export$bdfc9528aeaa6307).Combined;
    const countryTabs = [
        (0, $0badf5665deea2b2$export$bdfc9528aeaa6307).USA,
        (0, $0badf5665deea2b2$export$bdfc9528aeaa6307).Canada,
        (0, $0badf5665deea2b2$export$bdfc9528aeaa6307).Combined
    ];
    const countryTabTitles = [
        'United States',
        'Canada',
        'Combined'
    ];
    const getCountryName = (countryId)=>countryId === (0, $0badf5665deea2b2$export$b77c37614753bffb).Canada ? 'Canada' : 'United States';
    (0, $2xPiy.useEffect)(()=>{
        if (clientId !== undefined) clientStore.setSelectedClientId(clientId);
        else clientStore.setSelectedClientId(undefined);
    }, [
        searchParams
    ]);
    /* Methods */ const fetchDashboard = async ()=>{
        if (isLoading) return;
        setIsLoading(true);
        try {
            if (clientId) {
                await dashboardStore.getClientView(clientId);
                if (!userStore.isFacilityAdmin) {
                    const client = await (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).get({
                        id: clientId
                    });
                    setIsCanada(client.country_id === (0, $0badf5665deea2b2$export$b77c37614753bffb).Canada);
                }
            } else if (selectedCountry === (0, $0badf5665deea2b2$export$bdfc9528aeaa6307).Combined) {
                await dashboardStore.getCombinedAdminView();
                setIsCanada(false);
            } else {
                await dashboardStore.getAdminView(selectedCountry);
                setIsCanada(selectedCountry === (0, $0badf5665deea2b2$export$bdfc9528aeaa6307).Canada);
            }
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).fetchDashboard.error);
        } finally{
            setIsLoading(false);
        }
    };
    const handleExportPDF = async ()=>{
        const input = document.getElementById('dashboard-content');
        const facilityLocationsChart = document.getElementById('current_facility_locations');
        const exportButton = document.getElementById('export-pdf-button');
        if (input && facilityLocationsChart && exportButton) {
            facilityLocationsChart.style.display = 'none';
            exportButton.style.display = 'none';
            (0, (/*@__PURE__*/$parcel$interopDefault($1hFlE)))(input, {
                scale: 2
            }).then((canvas)=>{
                const imgData = canvas.toDataURL('image/png');
                const pdf = new (0, $ffaeb8e02004bf5e$export$2e2bcd8739ae039)('p', 'mm', 'a4');
                const imgWidth = 210;
                const imgHeight = canvas.height * imgWidth / canvas.width;
                pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
                pdf.save('DashboardSummary.pdf');
                facilityLocationsChart.style.display = '';
                exportButton.style.display = '';
            });
        }
    };
    /* Effects */ (0, $2xPiy.useEffect)(()=>{
        document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, 'Dashboard');
        return ()=>dashboardStore.clearDashboardData();
    }, []);
    (0, $2xPiy.useEffect)(()=>{
        if (urlClientId) {
            const clientId = parseInt(urlClientId);
            if (!isNaN(clientId) && clientId !== clientStore.selectedClientId) clientStore.setSelectedClientId(clientId);
        } else if (userStore.isFuseAdmin && clientStore.selectedClientId !== 0) {
            const currentClientId = userStore.isExternalUser ? clientStore.activeClientId : clientStore.selectedClientId;
            if (currentClientId !== 0) clientStore.setSelectedClientId(0);
        }
    }, [
        urlClientId,
        clientStore,
        userStore.isFuseAdmin,
        userStore.isExternalUser,
        clientStore.activeClientId,
        clientStore.selectedClientId
    ]);
    (0, $2xPiy.useEffect)(()=>{
        fetchDashboard();
    }, [
        clientId,
        selectedCountry
    ]);
    /* Render */ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $f068601a66842d6c$export$c1faa9c8f42906a), {
        children: [
            isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                flex: "grow",
                children: !isLoading && dashboardStore.dashboardData && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                    flex: "grow",
                    gap: "1rem",
                    pad: {
                        horizontal: isMobile ? '3.75rem' : '8rem',
                        vertical: isMobile ? '2.25rem' : '3rem'
                    },
                    animation: {
                        type: 'fadeIn',
                        duration: 300
                    },
                    id: "dashboard-content",
                    children: [
                        dashboardStore.dashboardData.client_name && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            direction: isMobile ? 'column' : 'row',
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $0bcf9ecd3b8ca51b$export$f35abaf34fd2d2bf), {
                                clientName: dashboardStore.dashboardData.client_name,
                                clientId: dashboardStore.dashboardData.client_id,
                                onExportPDF: handleExportPDF
                            })
                        }),
                        isAdminDashboard && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            direction: "row",
                            justify: "start",
                            border: {
                                side: 'bottom',
                                color: 'light-5',
                                size: 'small'
                            },
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b012ec9a92c56d14$export$b2539bed5023c21c), {
                                titles: countryTabTitles,
                                activeTab: countryTabs.indexOf(selectedCountry),
                                focusedTab: focusedCountryTab,
                                setActiveTab: (tabIndex)=>{
                                    if (isLoading) return;
                                    setSelectedCountry(countryTabs[tabIndex]);
                                },
                                setFocusedTab: setFocusedCountryTab,
                                flex: "shrink",
                                pad: "none",
                                background: "none"
                            })
                        }),
                        !isCombined && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            gap: "1rem",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    gap: "1rem",
                                    direction: isMobile ? 'column' : 'row',
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                            id: "kwh_consumed",
                                            title: "kwh_consumed",
                                            width: isMobile ? undefined : `${100 / 3}%`,
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $39bb42c1b38b91d9$export$22cc6ea4392b37fa), {
                                                value: dashboardStore.dashboardData.kwh_consumed ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(dashboardStore.dashboardData.kwh_consumed) : 0,
                                                title: t('dashboard:kwhConsumed'),
                                                description: t('dashboard:energyConsumption'),
                                                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $83fb0b085ee727c4$export$41fb9f06171c75f4), {
                                                    size: "38px",
                                                    color: "light-1"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                            id: "mt_co2e_displaced",
                                            width: isMobile ? undefined : `${100 / 3}%`,
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $39bb42c1b38b91d9$export$22cc6ea4392b37fa), {
                                                value: dashboardStore.dashboardData.mt_cO2e_displaced ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(dashboardStore.dashboardData.mt_cO2e_displaced) : 0,
                                                title: t('dashboard:mtCo2eDisplaced'),
                                                description: t('dashboard:equalToCreditsGeneratedToDate'),
                                                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $fcb61b3305930380$export$3bc50e457b7f164b), {
                                                    size: "38px",
                                                    color: "light-1"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                            id: "total_net_revenue_to_date",
                                            width: isMobile ? undefined : `${100 / 3}%`,
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $39bb42c1b38b91d9$export$22cc6ea4392b37fa), {
                                                value: dashboardStore.dashboardData.total_net_revenue ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(dashboardStore.dashboardData.total_net_revenue, true, true) : 0,
                                                title: t('dashboard:totalNetRevenueToDate'),
                                                description: t('dashboard:valueOfCreditsTransacted'),
                                                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $1945a5c8d07968d7$export$54d0e8420ac838ac), {
                                                    size: "38px",
                                                    color: "light-1"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    gap: "1rem",
                                    direction: isMobile ? 'column' : 'row',
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                            id: "avg_cost_per_kWh",
                                            width: isMobile ? undefined : isCanada ? '50%' : `${100 / 3}%`,
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $39bb42c1b38b91d9$export$22cc6ea4392b37fa), {
                                                value: dashboardStore.dashboardData.average_dollar_per_kwh ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(dashboardStore.dashboardData.average_dollar_per_kwh, true, true) : 0,
                                                title: t('dashboard:avgCostPerKwh'),
                                                subtitle: "/ kWh",
                                                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e72bb2ac81e784e6$export$ac31625c0615bb80), {
                                                    size: "38px",
                                                    color: "light-1"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                            id: "enrolled_vehicles_and_equipment",
                                            width: isMobile ? undefined : isCanada ? '50%' : `${100 / 3}%`,
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $39bb42c1b38b91d9$export$22cc6ea4392b37fa), {
                                                value: dashboardStore.dashboardData.num_enrolled_equipment ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(dashboardStore.dashboardData.num_enrolled_equipment) : 0,
                                                title: t('dashboard:enrolledVehiclesAndEquipment'),
                                                subtitle: "Units",
                                                description: t('dashboard:totalNumberOfAssetsProducingCredits'),
                                                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d23b039134f2e17$export$6d179221523bd367), {})
                                            })
                                        }),
                                        !isCanada && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                            id: "days_to_next_credit_minting",
                                            width: isMobile ? undefined : `${100 / 3}%`,
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $39bb42c1b38b91d9$export$22cc6ea4392b37fa), {
                                                value: dashboardStore.dashboardData.days_to_next_credit_minting ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(dashboardStore.dashboardData.days_to_next_credit_minting) : 0,
                                                title: t('dashboard:daysToNextCreditMinting'),
                                                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $52cab84bc22908ed$export$e1aef45b828286de), {
                                                    size: "38px",
                                                    color: "light-1"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        isCombined && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            gap: "1rem",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    gap: "1rem",
                                    direction: isMobile ? 'column' : 'row',
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                            id: "kwh_consumed",
                                            title: "kwh_consumed",
                                            width: isMobile ? undefined : `${100 / 3}%`,
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $39bb42c1b38b91d9$export$22cc6ea4392b37fa), {
                                                value: dashboardStore.dashboardData.kwh_consumed ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(dashboardStore.dashboardData.kwh_consumed) : 0,
                                                title: t('dashboard:kwhConsumed'),
                                                description: t('dashboard:energyConsumption'),
                                                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $83fb0b085ee727c4$export$41fb9f06171c75f4), {
                                                    size: "38px",
                                                    color: "light-1"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                            id: "mt_co2e_displaced",
                                            width: isMobile ? undefined : `${100 / 3}%`,
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $39bb42c1b38b91d9$export$22cc6ea4392b37fa), {
                                                value: dashboardStore.dashboardData.mt_cO2e_displaced ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(dashboardStore.dashboardData.mt_cO2e_displaced) : 0,
                                                title: t('dashboard:mtCo2eDisplaced'),
                                                description: t('dashboard:equalToCreditsGeneratedToDate'),
                                                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $fcb61b3305930380$export$3bc50e457b7f164b), {
                                                    size: "38px",
                                                    color: "light-1"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                            id: "enrolled_vehicles_and_equipment",
                                            width: isMobile ? undefined : `${100 / 3}%`,
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $39bb42c1b38b91d9$export$22cc6ea4392b37fa), {
                                                value: dashboardStore.dashboardData.num_enrolled_equipment ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(dashboardStore.dashboardData.num_enrolled_equipment) : 0,
                                                title: t('dashboard:enrolledVehiclesAndEquipment'),
                                                subtitle: "Units",
                                                description: t('dashboard:totalNumberOfAssetsProducingCredits'),
                                                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d23b039134f2e17$export$6d179221523bd367), {})
                                            })
                                        })
                                    ]
                                }),
                                dashboardStore.dashboardData.countries?.map((country)=>{
                                    const baseData = dashboardStore.dashboardData;
                                    if (!baseData) return null;
                                    const isUSA = country.country_id === (0, $0badf5665deea2b2$export$b77c37614753bffb).USA;
                                    const cardWidth = isMobile ? undefined : isUSA ? `${100 / 3}%` : '50%';
                                    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                        gap: "0.75rem",
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "large",
                                                children: [
                                                    getCountryName(country.country_id),
                                                    country.currency_code ? ` \xb7 ${country.currency_code}` : ''
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                gap: "1rem",
                                                direction: isMobile ? 'column' : 'row',
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                        width: cardWidth,
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $39bb42c1b38b91d9$export$22cc6ea4392b37fa), {
                                                            value: country.total_net_revenue ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(country.total_net_revenue, true, true) : 0,
                                                            title: t('dashboard:totalNetRevenueToDate'),
                                                            description: t('dashboard:valueOfCreditsTransacted'),
                                                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $1945a5c8d07968d7$export$54d0e8420ac838ac), {
                                                                size: "38px",
                                                                color: "light-1"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                        width: cardWidth,
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $39bb42c1b38b91d9$export$22cc6ea4392b37fa), {
                                                            value: country.average_dollar_per_kwh ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(country.average_dollar_per_kwh, true, true) : 0,
                                                            title: t('dashboard:avgCostPerKwh'),
                                                            subtitle: "/ kWh",
                                                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e72bb2ac81e784e6$export$ac31625c0615bb80), {
                                                                size: "38px",
                                                                color: "light-1"
                                                            })
                                                        })
                                                    }),
                                                    isUSA && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                        id: "days_to_next_credit_minting",
                                                        width: cardWidth,
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $39bb42c1b38b91d9$export$22cc6ea4392b37fa), {
                                                            value: baseData.days_to_next_credit_minting ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(baseData.days_to_next_credit_minting) : 0,
                                                            title: t('dashboard:daysToNextCreditMinting'),
                                                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $52cab84bc22908ed$export$e1aef45b828286de), {
                                                                size: "38px",
                                                                color: "light-1"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                gap: "1rem",
                                                direction: isMobile ? 'column' : 'row',
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                        width: isMobile ? undefined : '50%',
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e6edef7c6c6bd381$export$b5c0e79205a9b186), {
                                                            data: {
                                                                ...baseData,
                                                                percent_revenue_per_equipment_category: country.percent_revenue_per_equipment_category
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                        width: isMobile ? undefined : '50%',
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $1cd4ac24d8653a5d$export$db95aab8af762a3), {
                                                            data: {
                                                                ...baseData,
                                                                percent_revenue_per_program: country.percent_revenue_per_program
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, country.country_id);
                                })
                            ]
                        }),
                        !isCombined && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            gap: "1rem",
                            direction: isMobile ? 'column' : 'row',
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    id: "period_incentive_revenue",
                                    width: isMobile ? undefined : '50%',
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $fd4665cc6c98489d$export$27ae23542b46daac), {
                                        data: dashboardStore.dashboardData
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    id: "enrollment_trends",
                                    width: isMobile ? undefined : '50%',
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d5bd1c1beb7b51b0$export$5f6a353c197b2d41), {
                                        data: dashboardStore.dashboardData
                                    })
                                })
                            ]
                        }),
                        isAdminDashboard && !isCombined && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            gap: "1rem",
                            direction: isMobile ? 'column' : 'row',
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    id: "revenue_by_equipment_type",
                                    width: isMobile ? undefined : '50%',
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e6edef7c6c6bd381$export$b5c0e79205a9b186), {
                                        data: dashboardStore.dashboardData
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    id: "revenue_by_program",
                                    width: isMobile ? undefined : '50%',
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $1cd4ac24d8653a5d$export$db95aab8af762a3), {
                                        data: dashboardStore.dashboardData
                                    })
                                })
                            ]
                        }),
                        !isAdminDashboard && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            gap: "1rem",
                            direction: isMobile ? 'column' : 'row',
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    id: "revenue_by",
                                    width: isMobile ? undefined : '40%',
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $46a185d5f0c5c26e$export$5f86e2a9a667774f), {
                                        data: dashboardStore.dashboardData
                                    })
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                    id: "equipment_by_facility",
                                    width: isMobile ? undefined : '60%',
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $696adc961bb18b9f$export$3eb8726488fe45ba), {
                                        data: dashboardStore.dashboardData
                                    })
                                })
                            ]
                        }),
                        !isAdminDashboard && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            id: "current_facility_locations",
                            gap: "1rem",
                            direction: isMobile ? 'column' : 'row',
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c1eda6c593a061fe$export$7734226e1720827f), {
                                data: dashboardStore.dashboardData
                            })
                        })
                    ]
                })
            })
        ]
    });
});
var $7e90f04af0cdf48d$export$2e2bcd8739ae039 = $7e90f04af0cdf48d$var$Dashboard;






var $2xPiy = parcelRequire("2xPiy");




















const $97312f69a3fb1233$export$d93d97a3bf9621ab = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const equipmentStore = (0, $116967e0234c3770$export$728bc2cead7f2c5a)();
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const isMobile = (0, $18588a518ac6fdc7$export$2ac00d7098bf223)(screenSize);
    const location = (0, $62d58f5c28b15c2e$export$45d76561a5302f2b)();
    const queryClient = (0, $bccbe1b43ff3d0cc$export$22e77b9572c4fded)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** Params **/ const queryParams = (0, $00658ccd6ec0135a$export$e2de15bbd9edf9c6)(location.search);
    const categoryName = queryParams.category?.replace(/%20/g, ' ') ?? '';
    const facilityId = parseInt(queryParams.facility_id ?? '');
    const params = (0, $62d58f5c28b15c2e$export$99eaa27ddbbb95ef)();
    const clientId = parseInt(params.client_id ?? '');
    /** State **/ const [isLoading, setIsLoading] = (0, $2xPiy.useState)(true);
    const [isLoadingFacilities, setIsLoadingFacilities] = (0, $2xPiy.useState)(false);
    const [, setIsLoadingCategories] = (0, $2xPiy.useState)(false);
    const [isCreating, setIsCreating] = (0, $2xPiy.useState)(false);
    const [selectedFacility, setSelectedFacility] = (0, $2xPiy.useState)();
    const [currentFacilityPage, setCurrentFacilityPage] = (0, $2xPiy.useState)(1);
    const [isUserLocation, setIsUserLocation] = (0, $2xPiy.useState)(true);
    const [categories, setCategories] = (0, $2xPiy.useState)();
    const [fseRegistrationStatuses, setFSERegistrationStatuses] = (0, $2xPiy.useState)();
    const [chargingNetworks, setChargingNetworks] = (0, $2xPiy.useState)();
    const [forkliftClassification, setforkliftClassification] = (0, $2xPiy.useState)();
    const [equipmentUseCases, setEquipmentUseCases] = (0, $2xPiy.useState)();
    const [chargingTypes, setChargingTypes] = (0, $2xPiy.useState)();
    const [clientName, setClientName] = (0, $2xPiy.useState)('');
    const [isCanada, setIsCanada] = (0, $2xPiy.useState)(false);
    const [facilities, setFacilities] = (0, $2xPiy.useState)([]);
    const [facilityOptions, setFacilityOptions] = (0, $2xPiy.useState)([]);
    const [facilityMetadata, setFacilityMetadata] = (0, $2xPiy.useState)();
    const [breadcrumbNavItems, setBreadcrumbNavItems] = (0, $2xPiy.useState)();
    /** Computed **/ const programId = selectedFacility?.program?.id;
    const isOrWa = (0, $2e4d07611f552ce8$export$874b2b5637613a99)(selectedFacility);
    const isForklift = !!(equipmentStore.formValues.category_name ?? '').toLowerCase().includes('forklift');
    const isApproved = equipmentStore.formValues.fse_registration_status_id === 3;
    const isPending = !equipmentStore.formValues.fse_registration_status_id || equipmentStore.formValues.fse_registration_status_id === 1;
    const firstDayInServiceRange = (0, $2xPiy.useMemo)(()=>{
        if (!selectedFacility || !equipmentStore.formValues.first_active_reporting_quarter) return;
        const start = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(selectedFacility.first_active_reporting_quarter).toISOString();
        const end = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(equipmentStore.formValues.first_active_reporting_quarter).add(2, 'months').endOf('month').toISOString();
        return [
            start,
            end
        ];
    }, [
        selectedFacility,
        equipmentStore.formValues.first_active_reporting_quarter
    ]);
    const equipmentTypeOptions = categories?.find(({ name: name })=>name === equipmentStore.formValues.category_name)?.equipment_types?.filter((type)=>!(0, $de66c3e79d71b403$export$2f6e4edbc5428162).has(type.id))?.map((type)=>({
            label: type.name,
            value: type.id
        })) ?? [];
    /** Methods **/ const fetchPageData = async ()=>{
        try {
            const [{ data: facilitiesData, meta: facilitiesMeta }, registrationStatuses, chargingNetworks, forkliftClassification, equipmentUseCases, chargingTypes] = await Promise.all([
                (0, $2f95a0926656d8e2$export$c270777027a9c841).list({
                    client_id: clientId,
                    page: currentFacilityPage,
                    limit: 1000
                }),
                (0, $d6dddabef9527262$export$47f5a8b2675bf9f0).listFSERegistrationStatuses(),
                (0, $ab4a6d5758e27442$export$228f07cb35da672b).listChargingNetworks(),
                (0, $4d14ac2f251954cc$export$b155df3a3f128ba4).listForkliftClassifications(),
                (0, $cfcb3cb7def4b952$export$dfb92ceb222acf8e).listEquipmentUseCases(),
                (0, $2955a8122ceaa8f4$export$13b01c6196094ffc).listChargingTypes()
            ]);
            const client = userStore.isClientUser || userStore.isFacilityUser ? userStore.user?.clients.find((client)=>client.id === clientId) : await (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).get({
                id: clientId
            });
            const clientIsCanada = client?.country_id === (0, $0badf5665deea2b2$export$b77c37614753bffb).Canada;
            if (client) {
                setClientName(client.name);
                setIsCanada(clientIsCanada);
            }
            setFacilities(facilitiesData);
            setFacilityMetadata(facilitiesMeta);
            setFacilityOptions([
                ...facilityOptions,
                ...facilitiesData.map((facility)=>({
                        label: (0, $00658ccd6ec0135a$export$426d0e35b67696d3)(facility, true),
                        value: facility.id
                    }))
            ]);
            const facility = facilityId ? facilitiesData.find((facility)=>facility.id === facilityId) : selectedFacility;
            setSelectedFacility(facility);
            fetchNavItems(client?.name ?? '', facility);
            const programId = facility?.program?.id;
            setFSERegistrationStatuses(registrationStatuses);
            setChargingNetworks(chargingNetworks);
            setforkliftClassification(forkliftClassification);
            setEquipmentUseCases(equipmentUseCases);
            setChargingTypes(chargingTypes);
            let category;
            if (programId) {
                const categories = await (0, $d17911beca13351e$export$63e6e4d9a672e282).listEquipmentCategories({
                    program_id: programId
                });
                setCategories(categories);
                category = categories?.find((category)=>category.name === categoryName);
            }
            equipmentStore.setFormValues({
                ...equipmentStore.formValues,
                facility_id: facilityId,
                category_name: categoryName,
                equipment_category_id: category?.id ?? NaN,
                is_metered: clientIsCanada ? true : equipmentStore.formValues.is_metered
            });
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).generic.error);
        } finally{
            setIsLoading(false);
        }
    };
    const fetchCategories = async (programId)=>{
        setIsLoadingCategories(true);
        try {
            const categories = await (0, $d17911beca13351e$export$63e6e4d9a672e282).listEquipmentCategories({
                program_id: programId
            });
            setCategories(categories);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).generic.error);
        } finally{
            setIsLoadingCategories(false);
        }
    };
    const fetchNavItems = (clientName, facility)=>{
        const navItems = [
            {
                name: 'Clients',
                link: !userStore.isClientUser && !userStore.isFacilityUser ? '/clients' : undefined
            },
            {
                name: clientName,
                link: !userStore.isFacilityUser ? `/clients/${clientId}` : undefined
            }
        ];
        if (facility) {
            navItems.push({
                name: 'Facilities',
                link: `/clients/${clientId}/facilities`
            });
            navItems.push({
                name: (0, $00658ccd6ec0135a$export$426d0e35b67696d3)(facility),
                link: `/clients/${clientId}/facilities/${facility.id}`
            });
            navItems.push({
                name: 'Equipment',
                link: `/clients/${clientId}/facilities/${facility.id}/equipment`
            });
        } else navItems.push({
            name: 'Equipment'
        });
        setBreadcrumbNavItems(navItems);
    };
    const nextFacilityPage = async ()=>{
        if (isLoadingFacilities || facilityMetadata && currentFacilityPage + 1 > facilityMetadata.last_page) return;
        setIsLoadingFacilities(true);
        try {
            setCurrentFacilityPage(currentFacilityPage + 1);
            const { meta: meta, data: data } = await (0, $2f95a0926656d8e2$export$c270777027a9c841).list({
                client_id: clientId,
                page: currentFacilityPage + 1
            });
            setFacilities([
                ...facilities,
                ...data
            ]);
            setFacilityOptions([
                ...facilityOptions,
                ...data.map((facility)=>({
                        label: (0, $00658ccd6ec0135a$export$426d0e35b67696d3)(facility),
                        value: facility.id
                    }))
            ]);
            setFacilityMetadata(meta);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).fetchEquipment.error);
        } finally{
            setIsLoadingFacilities(false);
        }
    };
    const createEquipment = async ()=>{
        if (!selectedFacility) {
            (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).formValidation.requiredFields);
            return;
        }
        try {
            setIsCreating(true);
            equipmentStore.setFormErrors({});
            const equipment = await (userStore.isInternalUser ? equipmentStore.createEquipmentInternal(selectedFacility) : equipmentStore.createEquipmentExternal(selectedFacility));
            if (!equipment) {
                if (Object.keys(equipmentStore.formErrors).length > 0) (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).formValidation.requiredFields);
                return;
            }
            queryClient.invalidateQueries({
                queryKey: [
                    'equipment'
                ]
            });
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).createEquipment.success);
            navigate(`/clients/${clientId}/equipment/${equipment.id}`);
        } catch (err) {
            const error = err;
            let showToast = true;
            if (error.status === 400) {
                const body = error.body ?? {};
                if (body?.message?.toLowerCase().includes('first active reporting quarter')) {
                    equipmentStore.formErrors['first_active_reporting_quarter'] = body?.message;
                    showToast = false;
                }
            }
            if (showToast) globalStore.handleApiError(error, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).createEquipment.error);
        } finally{
            setIsCreating(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, 'Add Equipment');
        equipmentStore.resetForm();
    }, []);
    (0, $2xPiy.useEffect)(()=>{
        if (isLoading) fetchPageData();
    }, [
        isLoading
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (programId && equipmentStore.formValues.category_name) fetchCategories(programId);
    }, [
        programId,
        equipmentStore.formValues.category_name
    ]);
    // Auto-fill lat/long (if applicable)
    (0, $2xPiy.useEffect)(()=>{
        const latLongIsEmpty = !equipmentStore.formValues.latitude && !equipmentStore.formValues.longitude;
        if (isForklift && (latLongIsEmpty || !isUserLocation) && selectedFacility?.address_latitude && selectedFacility?.address_longitude) {
            equipmentStore.updateFormValue('latitude', selectedFacility.address_latitude);
            equipmentStore.updateFormValue('longitude', selectedFacility.address_longitude);
            setIsUserLocation(false);
        }
    }, [
        isForklift,
        equipmentStore.formValues.latitude,
        equipmentStore.formValues.longitude,
        isUserLocation,
        selectedFacility?.address_latitude,
        selectedFacility?.address_longitude
    ]);
    // Change Category
    (0, $2xPiy.useEffect)(()=>{
        if (!categories) return;
        const category = categories.find(({ name: name })=>name === equipmentStore.formValues.category_name);
        const newCategoryId = category?.id;
        equipmentStore.updateFormValue('equipment_category_id', newCategoryId);
        const equipmentTypes = category?.equipment_types?.filter((type)=>!(0, $de66c3e79d71b403$export$2f6e4edbc5428162).has(type.id) || type.id === equipmentStore.formValues.equipment_type_id) || [];
        const validTypeIds = equipmentTypes.map((type)=>type.id);
        if (equipmentTypes.length === 1) equipmentStore.updateFormValue('equipment_type_id', equipmentTypes[0].id);
        else if (!validTypeIds.includes(equipmentStore.formValues.equipment_type_id)) equipmentStore.updateFormValue('equipment_type_id', undefined);
        if (!(0, $acc57f855dc3e03c$export$e8efcaf51aaf349d)(newCategoryId)) equipmentStore.updateFormValue('nameplate_rating_kw', null);
        if (newCategoryId !== 5) equipmentStore.updateFormValue('forklift_classification_id', null);
    }, [
        categories,
        equipmentStore.formValues?.category_name
    ]);
    // Change Facility
    (0, $2xPiy.useEffect)(()=>{
        if (equipmentStore.formValues.facility_id && selectedFacility?.id !== equipmentStore.formValues.facility_id) {
            const facility = facilities.find((facility)=>facility.id === equipmentStore.formValues.facility_id);
            setSelectedFacility(facility);
            fetchNavItems(clientName, facility);
        }
    }, [
        equipmentStore.formValues.facility_id,
        selectedFacility,
        facilities,
        clientName
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $3d99c6153124a6ba$export$7234abc5d81adb58), {
        title: `${t('equipment:add')} ${equipmentStore.formValues.category_name ? equipmentStore.formValues.category_name === 'Electric Forklift' ? 'Electric Forklift' : `${equipmentStore.formValues.category_name} Charger` : 'Equipment'}`,
        breadcrumbNav: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e7dd63b10d4904e9$export$988959db72b892c3), {
            previousPages: breadcrumbNavItems ?? [],
            currentPageName: `${t('equipment:add')} ${equipmentStore.formValues.category_name || t('equipment:equipment')}`
        }),
        isLoading: isLoading,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $98b6153ed086d9bd$export$11154b700737b45e), {
            title: t('equipment:equipmentDetails'),
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $eabd1d040ee4804f$export$54c2e3dc7acea9f5), {
                size: "24px",
                color: "brand"
            }),
            isLoading: isLoading || isCreating,
            onSubmit: createEquipment,
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $04d59a1221f4208a$export$a7fed597f4b8afd8), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    direction: isMobile ? 'column' : 'row',
                    margin: {
                        bottom: '1rem'
                    },
                    gap: "1rem",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            width: isMobile ? '100%' : '60%',
                            gap: "1rem",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                    row: true,
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                            id: "category_name",
                                            label: t('equipment:equipmentCategory'),
                                            placeholder: "Choose...",
                                            value: equipmentStore.formValues.category_name,
                                            setValue: (value)=>equipmentStore.updateFormValue('category_name', value),
                                            options: categories?.map((category)=>category.name) ?? [],
                                            error: equipmentStore.formErrors['category_name'],
                                            emptySearchMessage: "No Facility selected.",
                                            required: true,
                                            flex: true
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                            id: "equipment_type_id",
                                            label: t('equipment:equipmentType'),
                                            placeholder: "Choose...",
                                            emptySearchMessage: "No Equipment Category selected.",
                                            value: equipmentStore.formValues.equipment_type_id,
                                            setValue: (value)=>equipmentStore.updateFormValue('equipment_type_id', value),
                                            options: equipmentTypeOptions,
                                            flex: true,
                                            error: equipmentStore.formErrors['equipment_type_id'],
                                            required: true
                                        }),
                                        selectedFacility?.program?.id === 1 && equipmentStore.formValues.equipment_category_id === 5 && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                            id: "forklift_classification",
                                            label: t('equipment:forkliftClassification'),
                                            placeholder: "Choose...",
                                            value: equipmentStore.formValues.forklift_classification_id,
                                            setValue: (value)=>equipmentStore.updateFormValue('forklift_classification_id', value),
                                            options: (forkliftClassification ?? []).map((s)=>({
                                                    label: s.name,
                                                    value: s.id
                                                })),
                                            error: equipmentStore.formErrors['forklift_classification_id'],
                                            required: selectedFacility?.program?.id === 1 && equipmentStore.formValues.equipment_category_id === 5,
                                            disabled: isCanada,
                                            flex: true
                                        }),
                                        (0, $acc57f855dc3e03c$export$e8efcaf51aaf349d)(equipmentStore.formValues.equipment_category_id) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                            id: "nameplate_rating_kw",
                                            label: t('equipment:nameplateRating'),
                                            value: equipmentStore.formValues.nameplate_rating_kw ?? '',
                                            setValue: (value)=>equipmentStore.updateFormValue('nameplate_rating_kw', value),
                                            error: equipmentStore.formErrors['nameplate_rating_kw'],
                                            onSubmit: createEquipment,
                                            flex: true,
                                            disabled: isCanada,
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                    margin: "0.5rem"
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            direction: isMobile ? 'column' : 'row',
                                            gap: "1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    id: "serial_number",
                                                    label: t('equipment:serialNumber'),
                                                    value: equipmentStore.formValues.serial_number,
                                                    setValue: (value)=>equipmentStore.updateFormValue('serial_number', value),
                                                    error: equipmentStore.formErrors['serial_number'],
                                                    onSubmit: createEquipment,
                                                    flex: true,
                                                    required: true
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    id: "unit_number",
                                                    label: t('equipment:unitNumber'),
                                                    value: equipmentStore.formValues.unit_number ?? '',
                                                    setValue: (value)=>equipmentStore.updateFormValue('unit_number', value),
                                                    error: equipmentStore.formErrors['unit_number'],
                                                    onSubmit: createEquipment,
                                                    flex: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            direction: isMobile ? 'column' : 'row',
                                            gap: "1rem",
                                            margin: {
                                                top: 'small'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    id: "model_year",
                                                    label: t('equipment:modelYear'),
                                                    value: equipmentStore.formValues.model_year,
                                                    setValue: (value)=>equipmentStore.updateFormValue('model_year', value),
                                                    error: equipmentStore.formErrors['model_year'],
                                                    onSubmit: createEquipment,
                                                    flex: true,
                                                    type: "number",
                                                    required: true
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    id: "manufacturer",
                                                    label: t('equipment:manufacturer'),
                                                    value: equipmentStore.formValues.manufacturer,
                                                    setValue: (value)=>equipmentStore.updateFormValue('manufacturer', value),
                                                    error: equipmentStore.formErrors['manufacturer'],
                                                    onSubmit: createEquipment,
                                                    flex: true,
                                                    required: true
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    id: "model_number",
                                                    label: t('equipment:modelNumber'),
                                                    value: equipmentStore.formValues.model_number,
                                                    setValue: (value)=>equipmentStore.updateFormValue('model_number', value),
                                                    error: equipmentStore.formErrors['model_number'],
                                                    onSubmit: createEquipment,
                                                    flex: true
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                    margin: "xsmall"
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            direction: isMobile ? 'column' : 'row',
                                            gap: "1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                    id: "is_metered",
                                                    label: t('equipment:metered'),
                                                    value: equipmentStore.formValues.is_metered ? 'Yes' : 'No',
                                                    setValue: (value)=>equipmentStore.updateFormValue('is_metered', value === 'Yes'),
                                                    options: [
                                                        'Yes',
                                                        'No'
                                                    ],
                                                    error: equipmentStore.formErrors['is_metered'],
                                                    required: true,
                                                    disabled: isCanada,
                                                    flex: true
                                                }),
                                                !isOrWa && equipmentStore.formValues.is_metered && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                    id: "charging_network",
                                                    label: t('equipment:chargingNetwork'),
                                                    placeholder: "Choose...",
                                                    value: equipmentStore.formValues.charging_network_id,
                                                    setValue: (value)=>equipmentStore.updateFormValue('charging_network_id', value),
                                                    options: (chargingNetworks ?? []).map((s)=>({
                                                            label: s.name,
                                                            value: s.id
                                                        })),
                                                    error: equipmentStore.formErrors['charging_network_id'],
                                                    required: true,
                                                    flex: true
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9623ddb5e8e2f680$export$c48527d0fea494d), {
                                                    id: "first_active_reporting_quarter",
                                                    label: t('equipment:firstActiveReportingPeriod'),
                                                    placeholder: "Select Period...",
                                                    value: equipmentStore.formValues.first_active_reporting_quarter ?? '',
                                                    setValue: (value)=>equipmentStore.updateFormValue('first_active_reporting_quarter', value),
                                                    clientId: selectedFacility?.client_id,
                                                    reportingPeriodTypeId: selectedFacility?.reporting_period_type_id,
                                                    firstActivePeriod: selectedFacility?.first_active_reporting_quarter,
                                                    programId: selectedFacility?.program?.id,
                                                    error: equipmentStore.formErrors['first_active_reporting_quarter'],
                                                    required: true
                                                })
                                            ]
                                        }),
                                        isOrWa && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            direction: isMobile ? 'column' : 'row',
                                            gap: "1rem",
                                            margin: {
                                                top: 'small'
                                            },
                                            children: [
                                                equipmentStore.formValues.is_metered && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                    id: "charging_network",
                                                    label: t('equipment:chargingNetwork'),
                                                    placeholder: "Choose...",
                                                    value: equipmentStore.formValues.charging_network_id,
                                                    setValue: (value)=>equipmentStore.updateFormValue('charging_network_id', value),
                                                    options: (chargingNetworks ?? []).map((s)=>({
                                                            label: s.name,
                                                            value: s.id
                                                        })),
                                                    error: equipmentStore.formErrors['charging_network_id'],
                                                    required: true,
                                                    flex: true
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    animation: {
                                                        type: 'slideRight'
                                                    },
                                                    id: "first_day_in_service",
                                                    label: t('equipment:firstDayInService'),
                                                    flex: true,
                                                    value: equipmentStore.formValues.first_day_in_service ?? '',
                                                    displayValue: (0, $00658ccd6ec0135a$export$25fe81f0e0c5bc4)(equipmentStore.formValues.first_day_in_service ?? '', isCanada),
                                                    dateBounds: firstDayInServiceRange,
                                                    setValue: (value)=>equipmentStore.updateFormValue('first_day_in_service', value),
                                                    error: equipmentStore.formErrors['first_day_in_service'],
                                                    onSubmit: createEquipment,
                                                    componentType: "date",
                                                    required: true,
                                                    disabled: !equipmentStore.formValues.first_active_reporting_quarter,
                                                    placeholder: !equipmentStore.formValues.first_active_reporting_quarter ? 'Select a First Reporting Period' : undefined
                                                })
                                            ]
                                        }),
                                        (selectedFacility?.program?.id === 4 || selectedFacility?.program?.id === 5) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            direction: isMobile ? 'column' : 'row',
                                            gap: "1rem",
                                            margin: {
                                                top: 'small'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                    id: "equipment_use_case",
                                                    label: t('equipment:equipmentUseCase'),
                                                    placeholder: "Choose...",
                                                    value: equipmentStore.formValues.equipment_use_case_id,
                                                    setValue: (value)=>equipmentStore.updateFormValue('equipment_use_case_id', value),
                                                    options: (equipmentUseCases ?? []).map((s)=>({
                                                            label: s.name,
                                                            value: s.id
                                                        })),
                                                    error: equipmentStore.formErrors['equipment_use_case_id'],
                                                    required: true,
                                                    flex: true
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                    id: "charging_type",
                                                    label: t('equipment:chargingType'),
                                                    placeholder: "Choose...",
                                                    value: equipmentStore.formValues.charging_type_id,
                                                    setValue: (value)=>equipmentStore.updateFormValue('charging_type_id', value),
                                                    options: (chargingTypes ?? []).map((s)=>({
                                                            label: s.name,
                                                            value: s.id
                                                        })),
                                                    error: equipmentStore.formErrors['charging_type_id'],
                                                    required: true,
                                                    flex: true
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                    margin: "xsmall"
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    flex: "grow",
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        id: "comments",
                                        label: t('common:comments'),
                                        value: equipmentStore.formValues.comments ?? '',
                                        setValue: (value)=>equipmentStore.updateFormValue('comments', value),
                                        error: equipmentStore.formErrors['comments'],
                                        onSubmit: createEquipment,
                                        height: userStore.isExternalUser ? '12rem' : '14rem',
                                        componentType: "textArea",
                                        centerLabel: false
                                    })
                                })
                            ]
                        }),
                        !isMobile && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                            direction: "vertical",
                            margin: "3rem"
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            gap: "1rem",
                            width: isMobile ? '100%' : '40%',
                            children: [
                                !isMobile && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                        id: "facility_id",
                                        label: t('common:facility'),
                                        value: equipmentStore.formValues.facility_id,
                                        setValue: (value)=>equipmentStore.updateFormValue('facility_id', value),
                                        onMore: nextFacilityPage,
                                        options: facilityOptions,
                                        error: equipmentStore.formErrors['facility_id'],
                                        required: true
                                    })
                                }),
                                !isMobile && userStore.isInternalUser && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                    margin: "0.5rem"
                                }),
                                userStore.isInternalUser && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
                                    children: [
                                        isMobile && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                            margin: "0.5rem"
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                            title: "FSE",
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                gap: "1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                        id: "fse_registration_status_id",
                                                        label: t('equipment:fseRegistrationStatus'),
                                                        placeholder: "Choose...",
                                                        value: equipmentStore.formValues.fse_registration_status_id,
                                                        setValue: (value)=>equipmentStore.updateFormValue('fse_registration_status_id', value),
                                                        options: (fseRegistrationStatuses ?? []).map((s)=>({
                                                                label: s.name,
                                                                value: s.id
                                                            })),
                                                        error: equipmentStore.formErrors['fse_registration_status_id'],
                                                        required: true
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                        id: "fse_id",
                                                        label: "FSE ID",
                                                        value: equipmentStore.formValues.fse_id ?? '',
                                                        setValue: (value)=>equipmentStore.updateFormValue('fse_id', value),
                                                        error: equipmentStore.formErrors['fse_id'],
                                                        onSubmit: createEquipment,
                                                        disabled: !isApproved,
                                                        required: equipmentStore.isApproved
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                        id: "fse_ru",
                                                        label: "FSE RU",
                                                        value: equipmentStore.formValues.fse_ru ?? '',
                                                        setValue: (value)=>equipmentStore.updateFormValue('fse_ru', value),
                                                        error: equipmentStore.formErrors['fse_ru'],
                                                        disabled: isPending,
                                                        onSubmit: createEquipment
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                    margin: "0.5rem"
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                    title: t('equipment:location'),
                                    children: [
                                        isMobile && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                id: "facility_id",
                                                label: t('common:facility'),
                                                value: equipmentStore.formValues.facility_id,
                                                setValue: (value)=>equipmentStore.updateFormValue('facility_id', value),
                                                onMore: nextFacilityPage,
                                                options: facilityOptions,
                                                error: equipmentStore.formErrors['facility_id'],
                                                required: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            direction: isMobile ? 'column' : 'row',
                                            gap: "1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    id: "latitude",
                                                    label: t('equipment:latitude'),
                                                    value: equipmentStore.formValues.latitude,
                                                    type: "number",
                                                    setValue: (value)=>{
                                                        equipmentStore.updateFormValue('latitude', value);
                                                        setIsUserLocation(true);
                                                    },
                                                    error: equipmentStore.formErrors['latitude'],
                                                    onSubmit: createEquipment,
                                                    flex: true,
                                                    placeholder: "DD.DDDDDD\xb0",
                                                    required: true
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    id: "longitude",
                                                    label: t('equipment:longitude'),
                                                    value: equipmentStore.formValues.longitude,
                                                    type: "number",
                                                    setValue: (value)=>{
                                                        equipmentStore.updateFormValue('longitude', value);
                                                        setIsUserLocation(true);
                                                    },
                                                    error: equipmentStore.formErrors['longitude'],
                                                    onSubmit: createEquipment,
                                                    flex: true,
                                                    placeholder: "DDD.DDDDDD\xb0",
                                                    required: true
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
});




var $2xPiy = parcelRequire("2xPiy");







var $2xPiy = parcelRequire("2xPiy");

function $a8356fcfdc571089$var$_extends() {
    return $a8356fcfdc571089$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a8356fcfdc571089$var$_extends.apply(null, arguments);
}
var $a8356fcfdc571089$export$3605b1b47e399b43 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $a8356fcfdc571089$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Validate"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M20 15c-1 1 1.25 3.75 0 5s-4-1-5 0-1.5 3-3 3-2-2-3-3-3.75 1.25-5 0 1-4 0-5-3-1.5-3-3 2-2 3-3-1.25-3.75 0-5 4 1 5 0 1.5-3 3-3 2 2 3 3 3.75-1.25 5 0-1 4 0 5 3 1.5 3 3-2 2-3 3zM7 12l3 3 7-7"
    }));
});
$a8356fcfdc571089$export$3605b1b47e399b43.displayName = 'Validate';


















const $5b13820843795053$export$e9c7e2fc242b5f37 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    /*** Context ***/ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const equipmentStore = (0, $116967e0234c3770$export$728bc2cead7f2c5a)();
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const queryClient = (0, $bccbe1b43ff3d0cc$export$22e77b9572c4fded)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /* Product Tour */ (0, $ea039e16ca87cc85$export$28f524c77ee81092)({
        tourName: 'equipment-details-tour',
        steps: (0, $3d0c747b3f894c98$export$647caee5d32955ba),
        autoStart: true,
        showOnce: true
    });
    /** URL Params **/ const params = (0, $62d58f5c28b15c2e$export$99eaa27ddbbb95ef)();
    const clientId = parseInt(params.client_id ?? '');
    const equipmentId = parseInt(params.equipment_id ?? '');
    /** State **/ const [isLoading, setIsLoading] = (0, $2xPiy.useState)(true);
    const [isLoadingFacilities, setIsLoadingFacilities] = (0, $2xPiy.useState)(false);
    const [isUpdating, setIsUpdating] = (0, $2xPiy.useState)(false);
    const [shouldRefresh, setShouldRefresh] = (0, $2xPiy.useState)(false);
    const [showRetireModal, setShowRetireModal] = (0, $2xPiy.useState)(false);
    const [showDeleteModal, setShowDeleteModal] = (0, $2xPiy.useState)(false);
    const [isRetired, setIsRetired] = (0, $2xPiy.useState)(false);
    const [selectedFacility, setSelectedFacility] = (0, $2xPiy.useState)();
    const [currentFacilityPage, setCurrentFacilityPage] = (0, $2xPiy.useState)(1);
    const [menuButtonItems, setMenuButtonItems] = (0, $2xPiy.useState)([]);
    const [originalFormValues, setOriginalFormValues] = (0, $2xPiy.useState)();
    const [categories, setCategories] = (0, $2xPiy.useState)();
    const [fseRegistrationStatuses, setFSERegistrationStatuses] = (0, $2xPiy.useState)();
    const [chargingNetworks, setChargingNetworks] = (0, $2xPiy.useState)();
    const [equipmentUseCases, setEquipmentUseCases] = (0, $2xPiy.useState)();
    const [chargingTypes, setChargingTypes] = (0, $2xPiy.useState)();
    const [forkliftClassification, setforkliftClassification] = (0, $2xPiy.useState)();
    const [clientName, setClientName] = (0, $2xPiy.useState)('');
    const [isDemoClient, setIsDemoClient] = (0, $2xPiy.useState)(false);
    const [equipment, setEquipment] = (0, $2xPiy.useState)();
    const [facilities, setFacilities] = (0, $2xPiy.useState)([]);
    const [facilityOptions, setFacilityOptions] = (0, $2xPiy.useState)();
    const [facilityMetadata, setFacilityMetadata] = (0, $2xPiy.useState)();
    const [isCanada, setIsCanada] = (0, $2xPiy.useState)(false);
    const [isInvalidParams, setIsInvalidParams] = (0, $2xPiy.useState)(false);
    const [previousFseId, setPreviousFseId] = (0, $2xPiy.useState)('');
    const [previousFseRu, setPreviousFseRu] = (0, $2xPiy.useState)('');
    /** Computed **/ const isMobile = screenSize === 'small' || screenSize === 'xsmall';
    const isOrWa = (0, $2e4d07611f552ce8$export$874b2b5637613a99)(selectedFacility);
    const isPending = equipment?.fse_registration_status.id === (0, $0badf5665deea2b2$export$2cc06ea48a9a0a41)['Pending Client Information'];
    const isFinalized = !!equipment?.is_finalized;
    const isEditable = !isRetired && (userStore.isInternalUser && equipment?.is_finalized === false || userStore.isExternalUser && isPending);
    const isMetered = equipmentStore.formValues.is_metered;
    const pageTitle = equipment?.name || (equipment?.manufacturer ? `${equipment?.manufacturer}: ${equipment?.serial_number}` : equipment?.serial_number) || '';
    const currentEquipmentTypeId = equipmentStore.formValues.equipment_type_id;
    const equipmentTypeOptions = categories?.find((category)=>category.id === equipmentStore.formValues.equipment_category_id)?.equipment_types?.filter((type)=>!(0, $de66c3e79d71b403$export$2f6e4edbc5428162).has(type.id) || type.id === currentEquipmentTypeId)?.map((type)=>({
            label: type.name,
            value: type.id
        })) ?? [];
    // const [firstDayInServiceRange, setFirstDayInServiceRange] = useState<[start: DateString, end: DateString]>();
    const firstDayInServiceRange = (0, $2xPiy.useMemo)(()=>{
        if (!selectedFacility || !equipmentStore.formValues.first_active_reporting_quarter) return;
        const start = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(selectedFacility.first_active_reporting_quarter).toISOString();
        const end = (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(equipmentStore.formValues.first_active_reporting_quarter).add(2, 'months').endOf('month').toISOString();
        return [
            start,
            end
        ];
    }, [
        selectedFacility,
        equipmentStore.formValues.first_active_reporting_quarter
    ]);
    const lastReportingPeriod = equipment?.last_active_reporting_quarter ? isCanada ? equipment?.last_active_reporting_quarter?.slice(0, 4) : (0, $00658ccd6ec0135a$export$6a2a5264dcc16b56)((0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(equipment?.last_active_reporting_quarter).toDate()) : undefined;
    const hasChanges = (0, $2xPiy.useMemo)(()=>{
        if (!originalFormValues) return false;
        return Object.keys(equipmentStore.formValues).some((key)=>{
            const original = originalFormValues[key];
            const current = equipmentStore.formValues[key];
            return original !== current;
        });
    }, [
        originalFormValues,
        equipmentStore.formValues
    ]);
    const titleBar = (0, $2xPiy.useMemo)(()=>{
        const badges = [];
        if (lastReportingPeriod) badges.push(/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
            pad: {
                horizontal: '0.5rem'
            },
            gap: "xsmall",
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                size: "0.95rem",
                weight: 600,
                toUpperCase: true,
                children: `${t('common:retired')}: ${lastReportingPeriod}`
            })
        }, "retired"));
        if (isFinalized) badges.push(/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
            pad: {
                horizontal: '0.5rem'
            },
            gap: "xsmall",
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $a8356fcfdc571089$export$3605b1b47e399b43), {
                    size: "16px"
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    size: "0.95rem",
                    weight: 600,
                    toUpperCase: true,
                    children: t('common:finalized')
                })
            ]
        }, "finalized"));
        if (isDemoClient) badges.push(/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
            pad: {
                horizontal: '0.5rem'
            },
            gap: "xsmall",
            background: {
                color: 'status-critical',
                opacity: 'medium'
            },
            border: {
                color: 'status-critical'
            },
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                size: "0.95rem",
                weight: 600,
                toUpperCase: true,
                children: "Demo Client"
            })
        }, "demo"));
        return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            gap: "small",
            direction: "row",
            children: badges
        });
    }, [
        isFinalized,
        lastReportingPeriod,
        t,
        isDemoClient
    ]);
    /** Methods **/ const fetchPageData = async (equipmentId)=>{
        setIsLoading(true);
        setEquipment(undefined);
        try {
            const [equipment, { data: facilitiesData, meta: facilitiesMeta }, fseRegistrationStatuses, chargingNetworks, forkliftClassification, equipmentUseCases, chargingTypes] = await Promise.all([
                (0, $64087c41a5036744$export$f3cdcae448e94402).get({
                    id: equipmentId
                }),
                (0, $2f95a0926656d8e2$export$c270777027a9c841).list({
                    client_id: clientId,
                    page: currentFacilityPage,
                    limit: 1000
                }),
                (0, $d6dddabef9527262$export$47f5a8b2675bf9f0).listFSERegistrationStatuses(),
                (0, $ab4a6d5758e27442$export$228f07cb35da672b).listChargingNetworks(),
                (0, $4d14ac2f251954cc$export$b155df3a3f128ba4).listForkliftClassifications(),
                (0, $cfcb3cb7def4b952$export$dfb92ceb222acf8e).listEquipmentUseCases(),
                (0, $2955a8122ceaa8f4$export$13b01c6196094ffc).listChargingTypes()
            ]);
            if (equipment.client_id !== clientId) {
                setIsInvalidParams(true);
                return;
            }
            const client = userStore.isClientUser || userStore.isFacilityUser ? userStore.user?.clients.find((client)=>client.id === clientId) : await (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).get({
                id: clientId
            });
            if (client) {
                setClientName(client.name);
                setIsCanada(client.country_id === (0, $0badf5665deea2b2$export$b77c37614753bffb).Canada);
                setIsDemoClient(client.is_demo || false);
            }
            setEquipment(equipment);
            const isRetired = (0, $2e4d07611f552ce8$export$d63e24584009432)(equipment);
            setIsRetired(isRetired);
            const userCanRetire = userStore.isClientAdmin || userStore.isFacilityAdmin ? !!userStore.user?.facilities.find((f)=>f.id === equipment?.facility_id) : userStore.isFuseAdmin;
            const userCanDelete = userStore.isFuseAdmin;
            const menuItems = [];
            if (!isRetired) {
                if (userCanRetire) menuItems.push({
                    label: t('equipment:retireEquipment'),
                    onClick: ()=>setShowRetireModal(true)
                });
                if (!equipment?.is_finalized && userCanDelete) menuItems.push({
                    label: t('equipment:deleteEquipment'),
                    onClick: ()=>setShowDeleteModal(true)
                });
            }
            setMenuButtonItems(menuItems);
            setFacilities(facilitiesData);
            setFacilityMetadata(facilitiesMeta);
            setFacilityOptions([
                ...facilityOptions ?? [],
                ...facilitiesData.map((facility)=>({
                        label: (0, $00658ccd6ec0135a$export$426d0e35b67696d3)(facility, true),
                        value: facility.id
                    }))
            ]);
            setSelectedFacility(equipment.facility);
            const programId = equipment.facility?.program?.id;
            setFSERegistrationStatuses(fseRegistrationStatuses);
            setChargingNetworks(chargingNetworks);
            setforkliftClassification(forkliftClassification);
            setEquipmentUseCases(equipmentUseCases);
            setChargingTypes(chargingTypes);
            const categories = await (0, $d17911beca13351e$export$63e6e4d9a672e282).listEquipmentCategories({
                program_id: programId
            });
            setCategories(categories);
            const populatedFormValues = {
                ...equipmentStore.formValues,
                facility_id: equipment.facility_id ?? NaN,
                category_name: equipment.equipment_type.equipment_category?.name ?? '',
                equipment_type_id: equipment.equipment_type_id ?? NaN,
                equipment_category_id: equipment.equipment_type.equipment_category_id ?? NaN,
                unit_number: equipment.unit_number ?? null,
                serial_number: equipment.serial_number ?? '',
                manufacturer: equipment.manufacturer ?? '',
                model_number: equipment.model_number ?? '',
                model_year: equipment.model_year?.toString() ?? '',
                is_metered: equipment.is_metered,
                first_day_in_service: equipment.first_day_in_service,
                first_active_reporting_quarter: equipment.first_active_reporting_quarter,
                last_active_reporting_quarter: equipment.last_active_reporting_quarter,
                latitude: equipment.latitude?.toString() ?? '',
                longitude: equipment.longitude?.toString() ?? '',
                fse_registration_status_id: equipment.fse_registration_status_id ?? NaN,
                fse_id: equipment.fse_id ?? '',
                fse_ru: equipment.fse_ru ?? '',
                comments: equipment.comments ?? '',
                charging_network_id: equipment.charging_network_id ?? '',
                forklift_classification_id: equipment.forklift_classification_id ?? null,
                equipment_use_case_id: equipment.equipment_use_case_id ?? '',
                charging_type_id: equipment.charging_type_id ?? '',
                nameplate_rating_kw: equipment.nameplate_rating_kw ?? null
            };
            equipmentStore.setFormValues(populatedFormValues);
            setOriginalFormValues(populatedFormValues);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).generic.error);
        } finally{
            setIsLoading(false);
        }
    };
    const nextFacilityPage = async ()=>{
        if (isLoadingFacilities || facilityMetadata && currentFacilityPage + 1 > facilityMetadata.last_page) return;
        setIsLoadingFacilities(true);
        try {
            setCurrentFacilityPage(currentFacilityPage + 1);
            const { meta: meta, data: data } = await (0, $2f95a0926656d8e2$export$c270777027a9c841).list({
                client_id: clientId,
                page: currentFacilityPage + 1
            });
            setFacilities([
                ...facilities,
                ...data
            ]);
            setFacilityOptions([
                ...facilityOptions ?? [],
                ...data.map((facility)=>({
                        label: (0, $00658ccd6ec0135a$export$426d0e35b67696d3)(facility),
                        value: facility.id
                    }))
            ]);
            setFacilityMetadata(meta);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).fetchEquipment.error);
        } finally{
            setIsLoadingFacilities(false);
        }
    };
    const updateEquipment = async ()=>{
        if (!equipment || !userStore.user) return;
        if (!isFinalized && selectedFacility?.program?.id === 1 && equipmentStore.formValues.equipment_category_id === 5 && !equipmentStore.formValues.forklift_classification_id) {
            equipmentStore.formErrors['forklift_classification_id'] = 'Forklift Classification is required.';
            return;
        } else delete equipmentStore.formErrors['forklift_classification_id'];
        try {
            setIsUpdating(true);
            let updatedEquipment;
            if (userStore.isInternalUser) updatedEquipment = isFinalized ? await equipmentStore.updateFinalizedInternal(equipment.id) : await equipmentStore.updateNonFinalizedInternal(equipment);
            else if (userStore.isExternalUser) updatedEquipment = isPending ? await equipmentStore.updatePendingExternal(equipment) : await equipmentStore.updateNonPendingExternal(equipment.id);
            if (updatedEquipment) {
                setEquipment(updatedEquipment);
                (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updateEquipment.success);
                setShouldRefresh(true);
            }
        } catch (err) {
            const error = err;
            let showToast = true;
            if (error?.status === 400) {
                const body = error.body ?? {};
                if (body?.message?.toLowerCase().includes('first active reporting quarter')) {
                    equipmentStore.formErrors['first_active_reporting_quarter'] = body.message;
                    showToast = false;
                }
            }
            if (showToast) globalStore.handleApiError(error, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updateEquipment.error);
        } finally{
            setIsUpdating(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        equipmentStore.resetForm();
    }, []);
    (0, $2xPiy.useEffect)(()=>{
        if (equipment) document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, equipment?.name ?? `${equipment?.manufacturer}: ${equipment?.serial_number}`);
    }, [
        equipment
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (equipmentId) fetchPageData(equipmentId);
    }, [
        equipmentId
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (equipmentId && shouldRefresh) {
            queryClient.invalidateQueries({
                queryKey: [
                    'equipment'
                ]
            });
            fetchPageData(equipmentId).finally(()=>setShouldRefresh(false));
        }
    }, [
        equipmentId,
        shouldRefresh
    ]);
    // Change Category
    (0, $2xPiy.useEffect)(()=>{
        if (!categories) return;
        const category = categories.find(({ name: name })=>name === equipmentStore.formValues.category_name);
        const newCategoryId = category?.id;
        equipmentStore.updateFormValue('equipment_category_id', newCategoryId);
        const equipmentTypes = category?.equipment_types?.filter((type)=>!(0, $de66c3e79d71b403$export$2f6e4edbc5428162).has(type.id) || type.id === equipmentStore.formValues.equipment_type_id) || [];
        const validTypeIds = equipmentTypes.map((type)=>type.id);
        if (equipmentTypes.length === 1) equipmentStore.updateFormValue('equipment_type_id', equipmentTypes[0].id);
        else if (!validTypeIds.includes(equipmentStore.formValues.equipment_type_id)) equipmentStore.updateFormValue('equipment_type_id', undefined);
        if (!(0, $acc57f855dc3e03c$export$e8efcaf51aaf349d)(newCategoryId)) equipmentStore.updateFormValue('nameplate_rating_kw', null);
        if (newCategoryId !== 5) equipmentStore.updateFormValue('forklift_classification_id', null);
    }, [
        categories,
        equipmentStore.formValues?.category_name
    ]);
    // Change Facility
    (0, $2xPiy.useEffect)(()=>{
        if (equipmentStore.formValues.facility_id && selectedFacility?.id !== equipmentStore.formValues.facility_id) {
            const facility = facilities.find((facility)=>facility.id === equipmentStore.formValues.facility_id);
            setSelectedFacility(facility);
        }
    }, [
        equipmentStore.formValues.facility_id,
        selectedFacility,
        facilities
    ]);
    // 404 Redirect
    (0, $2xPiy.useEffect)(()=>{
        if (isLoading) return;
        if (equipment && equipment.id !== equipmentId) return;
        setIsInvalidParams(Number.isNaN(clientId) || Number.isNaN(equipmentId) || equipment?.id === undefined);
    }, [
        clientId,
        equipmentId,
        equipment,
        isLoading
    ]);
    /** Render **/ const renderFirstReportingPeriod = ()=>{
        const firstReportingPeriod = equipmentStore.formValues['first_active_reporting_quarter'] ?? '';
        const value = isEditable ? firstReportingPeriod : (0, $00658ccd6ec0135a$export$f96ebb633255a704)(firstReportingPeriod, isCanada);
        return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9623ddb5e8e2f680$export$c48527d0fea494d), {
            id: "first_active_reporting_quarter",
            label: t('common:firstReportingPeriod'),
            placeholder: "Select Period...",
            value: value,
            setValue: (value)=>equipmentStore.updateFormValue('first_active_reporting_quarter', value),
            clientId: equipment?.client_id,
            programId: selectedFacility?.program?.id,
            reportingPeriodTypeId: equipment?.reporting_period_type_id,
            firstActivePeriod: selectedFacility?.first_active_reporting_quarter,
            error: equipmentStore.formErrors['first_active_reporting_quarter'],
            disabled: !isEditable,
            required: isEditable,
            fill: "horizontal",
            "data-tour": "reporting-period-selector"
        });
    };
    const renderFirstDayInService = ()=>{
        const firstDayInService = equipmentStore.formValues.first_day_in_service ?? '';
        const value = isEditable ? firstDayInService : (0, $00658ccd6ec0135a$export$25fe81f0e0c5bc4)(firstDayInService, isCanada);
        return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
            id: "first_day_in_service",
            label: "First Day in Service",
            fill: "horizontal",
            value: value,
            dateBounds: firstDayInServiceRange,
            setValue: (value)=>equipmentStore.updateFormValue('first_day_in_service', value),
            error: equipmentStore.formErrors['first_day_in_service'],
            onSubmit: updateEquipment,
            disabled: !isEditable,
            componentType: "date",
            required: isOrWa && isEditable
        });
    };
    return isInvalidParams ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8fedf23083f90239$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $3d99c6153124a6ba$export$7234abc5d81adb58), {
        title: pageTitle,
        breadcrumbNav: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e7dd63b10d4904e9$export$988959db72b892c3), {
            previousPages: [
                {
                    name: 'Clients',
                    link: !userStore.isClientUser && !userStore.isFacilityUser ? '/clients' : undefined
                },
                {
                    name: clientName,
                    link: !userStore.isFacilityUser ? `/clients/${clientId}` : undefined
                },
                {
                    name: 'Facilities',
                    link: `/clients/${clientId}/facilities`
                },
                {
                    name: (0, $00658ccd6ec0135a$export$426d0e35b67696d3)(selectedFacility),
                    link: `/clients/${clientId}/facilities/${selectedFacility?.id ?? ''}`
                },
                {
                    name: 'Equipment',
                    link: `/clients/${clientId}/facilities/${selectedFacility?.id ?? ''}/equipment`
                }
            ],
            currentPageName: pageTitle
        }),
        titleBar: titleBar,
        isLoading: isLoading,
        isDetailPage: true,
        hideMenuButton: !isLoading && equipment && !menuButtonItems.length,
        menuButtonItems: menuButtonItems,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $98b6153ed086d9bd$export$11154b700737b45e), {
                title: t('equipment:equipmentDetails'),
                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $eabd1d040ee4804f$export$54c2e3dc7acea9f5), {
                    size: "24px",
                    color: "brand"
                }),
                onSubmit: updateEquipment,
                isLoading: isLoading || isUpdating,
                hideSaveButton: true,
                saveButtonLabel: t('common:saveChanges'),
                "data-tour": "equipment-info",
                headerChildren: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $85ab7488c493b81c$export$6d88ebe453be59d7), {
                        label: t('equipment:returnToFacility'),
                        targetUrl: `/clients/${clientId}/facilities/${selectedFacility?.id}`
                    }, "return-to-facility")
                ],
                saveButton: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    direction: "row",
                    gap: "medium",
                    justify: "end",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7ac54c23a62de8c7$export$4ecda0163efe6d1d), {
                            type: "submit",
                            label: t('common:saveChanges'),
                            loadingLabel: "SAVING...",
                            isLoading: isLoading || isUpdating,
                            onClick: updateEquipment,
                            disabled: !userStore.isAdminUser || !hasChanges
                        }),
                        !isRetired && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7ac54c23a62de8c7$export$4ecda0163efe6d1d), {
                            label: t('equipment:addNewEquipment'),
                            onClick: ()=>navigate(`/clients/${clientId}/equipment/create?category=&facility_id=${selectedFacility?.id}`),
                            background: "neutral-1",
                            hoverBackground: "accent-7"
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $04d59a1221f4208a$export$a7fed597f4b8afd8), {
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        direction: isMobile ? 'column' : 'row',
                        margin: {
                            bottom: '1rem'
                        },
                        gap: "1rem",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                width: isMobile ? '100%' : '60%',
                                gap: "1rem",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                        row: true,
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                id: "category_name",
                                                label: t('equipment:equipmentCategory'),
                                                value: equipmentStore.formValues.category_name,
                                                setValue: (value)=>equipmentStore.updateFormValue('category_name', value),
                                                options: categories?.map((category)=>category.name) ?? [],
                                                error: equipmentStore.formErrors['category_name'],
                                                disabled: !isEditable,
                                                required: true,
                                                fill: "horizontal"
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                id: "equipment_type_id",
                                                label: t('equipment:equipmentType'),
                                                placeholder: "Choose...",
                                                value: equipmentTypeOptions.length === 1 && !equipmentStore.formValues.equipment_type_id ? equipmentTypeOptions[0].value : equipmentStore.formValues.equipment_type_id,
                                                setValue: (value)=>equipmentStore.updateFormValue('equipment_type_id', value),
                                                options: equipmentTypeOptions,
                                                fill: "horizontal",
                                                error: equipmentStore.formErrors['equipment_type_id'],
                                                required: true,
                                                disabled: !userStore.isAdminUser || !isEditable
                                            }),
                                            selectedFacility?.program?.id === 1 && equipmentStore.formValues.equipment_category_id === 5 && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                id: "forklift_classification",
                                                label: t('equipment:forkliftClassification'),
                                                placeholder: "Choose...",
                                                value: equipmentStore.formValues.forklift_classification_id,
                                                setValue: (value)=>{
                                                    equipmentStore.updateFormValue('forklift_classification_id', value);
                                                },
                                                options: (forkliftClassification ?? []).map((s)=>({
                                                        label: s.name,
                                                        value: s.id
                                                    })),
                                                error: equipmentStore.formErrors['forklift_classification_id'],
                                                disabled: !isEditable || isCanada,
                                                required: true,
                                                fill: "horizontal"
                                            }),
                                            (0, $acc57f855dc3e03c$export$e8efcaf51aaf349d)(equipmentStore.formValues.equipment_category_id) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                id: "nameplate_rating_kw",
                                                label: t('equipment:nameplateRating'),
                                                value: equipmentStore.formValues.nameplate_rating_kw ?? '',
                                                setValue: (value)=>equipmentStore.updateFormValue('nameplate_rating_kw', value),
                                                error: equipmentStore.formErrors['nameplate_rating_kw'],
                                                onSubmit: updateEquipment,
                                                fill: "horizontal",
                                                type: "number",
                                                disabled: !isEditable || isCanada,
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                        margin: "0.5rem"
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                direction: isMobile ? 'column' : 'row',
                                                gap: "1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                        id: "serial_number",
                                                        label: t('equipment:serialNumber'),
                                                        value: equipmentStore.formValues.serial_number,
                                                        setValue: (value)=>equipmentStore.updateFormValue('serial_number', value),
                                                        error: equipmentStore.formErrors['serial_number'],
                                                        onSubmit: updateEquipment,
                                                        fill: "horizontal",
                                                        required: true,
                                                        disabled: !userStore.isAdminUser || !isEditable
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                        id: "unit_number",
                                                        label: t('equipment:unitNumber'),
                                                        value: equipmentStore.formValues.unit_number ?? '',
                                                        setValue: (value)=>equipmentStore.updateFormValue('unit_number', value),
                                                        error: equipmentStore.formErrors['unit_number'],
                                                        onSubmit: updateEquipment,
                                                        fill: "horizontal",
                                                        disabled: !userStore.isAdminUser && !isEditable
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                direction: isMobile ? 'column' : 'row',
                                                gap: "1rem",
                                                margin: {
                                                    top: 'small'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                        id: "model_year",
                                                        label: t('equipment:modelYear'),
                                                        value: equipmentStore.formValues.model_year,
                                                        setValue: (value)=>equipmentStore.updateFormValue('model_year', value),
                                                        error: equipmentStore.formErrors['model_year'],
                                                        onSubmit: updateEquipment,
                                                        type: "number",
                                                        fill: "horizontal",
                                                        required: true,
                                                        disabled: !userStore.isAdminUser || !isEditable
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                        id: "manufacturer",
                                                        label: t('equipment:manufacturer'),
                                                        value: equipmentStore.formValues.manufacturer,
                                                        setValue: (value)=>equipmentStore.updateFormValue('manufacturer', value),
                                                        error: equipmentStore.formErrors['manufacturer'],
                                                        onSubmit: updateEquipment,
                                                        fill: "horizontal",
                                                        required: true,
                                                        disabled: !userStore.isAdminUser || !isEditable
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                        id: "model_number",
                                                        label: t('equipment:modelNumber'),
                                                        value: equipmentStore.formValues.model_number,
                                                        setValue: (value)=>equipmentStore.updateFormValue('model_number', value),
                                                        error: equipmentStore.formErrors['model_number'],
                                                        onSubmit: updateEquipment,
                                                        fill: "horizontal",
                                                        disabled: !userStore.isAdminUser || !isEditable
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                        margin: "xsmall"
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                direction: "row",
                                                gap: "1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                        id: "is_metered",
                                                        label: t('equipment:metered'),
                                                        value: equipmentStore.formValues.is_metered ? 'Yes' : 'No',
                                                        setValue: (value)=>equipmentStore.updateFormValue('is_metered', value === 'Yes'),
                                                        options: [
                                                            'Yes',
                                                            'No'
                                                        ],
                                                        error: equipmentStore.formErrors['is_metered'],
                                                        disabled: !isEditable || isCanada,
                                                        required: true,
                                                        fill: "horizontal"
                                                    }),
                                                    isMetered && !(isOrWa && !isRetired) && !(!isOrWa && isRetired) && !(isOrWa && isRetired) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                        id: "charging_network",
                                                        label: t('equipment:chargingNetwork'),
                                                        placeholder: "Choose...",
                                                        value: equipmentStore.formValues.charging_network_id,
                                                        setValue: (value)=>{
                                                            equipmentStore.updateFormValue('charging_network_id', value);
                                                        },
                                                        options: (chargingNetworks ?? []).map((s)=>({
                                                                label: s.name,
                                                                value: s.id
                                                            })),
                                                        error: equipmentStore.formErrors['charging_network_id'],
                                                        disabled: !isEditable,
                                                        required: true,
                                                        fill: "horizontal"
                                                    }),
                                                    renderFirstReportingPeriod()
                                                ]
                                            }),
                                            (selectedFacility?.program?.id === 4 || selectedFacility?.program?.id === 5) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                direction: isMobile ? 'column' : 'row',
                                                gap: "1rem",
                                                margin: {
                                                    top: 'small'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                        id: "equipment_use_case",
                                                        label: t('equipment:equipmentUseCase'),
                                                        placeholder: "Choose...",
                                                        value: equipmentStore.formValues.equipment_use_case_id,
                                                        setValue: (value)=>equipmentStore.updateFormValue('equipment_use_case_id', value),
                                                        options: (equipmentUseCases ?? []).map((s)=>({
                                                                label: s.name,
                                                                value: s.id
                                                            })),
                                                        error: equipmentStore.formErrors['equipment_use_case_id'],
                                                        disabled: !userStore.isAdminUser || !isEditable,
                                                        required: true,
                                                        flex: true
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                        id: "charging_type",
                                                        label: t('equipment:chargingType'),
                                                        placeholder: "Choose...",
                                                        value: equipmentStore.formValues.charging_type_id,
                                                        setValue: (value)=>equipmentStore.updateFormValue('charging_type_id', value),
                                                        options: (chargingTypes ?? []).map((s)=>({
                                                                label: s.name,
                                                                value: s.id
                                                            })),
                                                        error: equipmentStore.formErrors['charging_type_id'],
                                                        disabled: !userStore.isAdminUser || !isEditable,
                                                        required: true,
                                                        flex: true
                                                    })
                                                ]
                                            }),
                                            (isOrWa || isRetired && isMetered) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                direction: "row",
                                                gap: "1rem",
                                                margin: {
                                                    top: 'small'
                                                },
                                                children: [
                                                    isMetered && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                        id: "charging_network",
                                                        label: t('equipment:chargingNetwork'),
                                                        placeholder: "Choose...",
                                                        value: equipmentStore.formValues.charging_network_id,
                                                        setValue: (value)=>{
                                                            equipmentStore.updateFormValue('charging_network_id', value);
                                                        },
                                                        options: (chargingNetworks ?? []).map((s)=>({
                                                                label: s.name,
                                                                value: s.id
                                                            })),
                                                        error: equipmentStore.formErrors['charging_network_id'],
                                                        disabled: !isEditable,
                                                        required: true,
                                                        fill: "horizontal"
                                                    }),
                                                    isOrWa && !isRetired || isOrWa && isRetired ? renderFirstDayInService() : null
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                        margin: "0.5rem"
                                    }),
                                    isRetired && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        name: "equipment-retirement_reason",
                                        label: t('common:reasonForRetiring'),
                                        placeholder: "-",
                                        value: equipment?.retirement_reason_other || equipment?.retirement_reason?.name || '',
                                        disabled: true,
                                        componentType: "textArea",
                                        opacity: 1
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        flex: "grow",
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                            id: "comments",
                                            label: t('common:comments'),
                                            value: equipmentStore.formValues.comments ?? '',
                                            setValue: (value)=>equipmentStore.updateFormValue('comments', value),
                                            error: equipmentStore.formErrors['comments'],
                                            onSubmit: updateEquipment,
                                            componentType: "textArea",
                                            centerLabel: false,
                                            height: "12rem",
                                            disabled: !userStore.isAdminUser && !isEditable
                                        })
                                    })
                                ]
                            }),
                            !isMobile && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                direction: "vertical",
                                margin: "3rem"
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                gap: "1rem",
                                width: isMobile ? '100%' : '40%',
                                children: [
                                    !isMobile && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                    id: "facility_id",
                                                    label: t('common:facility'),
                                                    value: equipmentStore.formValues.facility_id,
                                                    setValue: (value)=>equipmentStore.updateFormValue('facility_id', value),
                                                    onMore: nextFacilityPage,
                                                    options: facilityOptions ?? [],
                                                    error: equipmentStore.formErrors['facility_id'],
                                                    required: true,
                                                    disabled: true
                                                })
                                            }),
                                            userStore.isInternalUser && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                                margin: "0.5rem"
                                            })
                                        ]
                                    }),
                                    isMobile && userStore.isInternalUser && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                        margin: "0.5rem"
                                    }),
                                    userStore.isInternalUser && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                        title: "FSE",
                                        "data-tour": "equipment-status",
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            gap: "1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                    label: t('equipment:fseRegistrationStatus'),
                                                    id: "fse_registration_status_id",
                                                    placeholder: "Choose...",
                                                    value: equipmentStore.formValues.fse_registration_status_id,
                                                    setValue: (value)=>{
                                                        if (value !== (0, $0badf5665deea2b2$export$2cc06ea48a9a0a41).Approved && equipmentStore.isApproved) {
                                                            setPreviousFseId(equipmentStore.formValues.fse_id ?? '');
                                                            equipmentStore.updateFormValue('fse_id', '');
                                                        } else if (value === (0, $0badf5665deea2b2$export$2cc06ea48a9a0a41).Approved && previousFseId) equipmentStore.updateFormValue('fse_id', previousFseId);
                                                        if (value === (0, $0badf5665deea2b2$export$2cc06ea48a9a0a41)['Pending Client Information']) {
                                                            setPreviousFseRu(equipmentStore.formValues.fse_ru ?? '');
                                                            equipmentStore.updateFormValue('fse_ru', '');
                                                        } else if (previousFseRu) equipmentStore.updateFormValue('fse_ru', previousFseRu);
                                                        equipmentStore.updateFormValue('fse_registration_status_id', value);
                                                    },
                                                    options: (fseRegistrationStatuses ?? []).map((s)=>({
                                                            label: s.name,
                                                            value: s.id
                                                        })),
                                                    error: equipmentStore.formErrors['fse_registration_status_id'],
                                                    required: true,
                                                    disabled: !userStore.isAdminUser || !isEditable
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    id: "fse_id",
                                                    label: "FSE ID",
                                                    value: equipmentStore.formValues.fse_id ?? '',
                                                    setValue: (value)=>{
                                                        equipmentStore.updateFormValue('fse_id', value);
                                                        setPreviousFseId(value);
                                                    },
                                                    error: equipmentStore.formErrors['fse_id'],
                                                    onSubmit: updateEquipment,
                                                    required: equipmentStore.isApproved,
                                                    disabled: !userStore.isAdminUser || !isEditable || !equipmentStore.isApproved
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    id: "fse_ru",
                                                    label: "FSE RU",
                                                    value: equipmentStore.formValues.fse_ru ?? '',
                                                    setValue: (value)=>{
                                                        equipmentStore.updateFormValue('fse_ru', value);
                                                        setPreviousFseRu(value);
                                                    },
                                                    error: equipmentStore.formErrors['fse_ru'],
                                                    onSubmit: updateEquipment,
                                                    disabled: !userStore.isAdminUser || !isEditable || equipmentStore.formValues.fse_registration_status_id === (0, $0badf5665deea2b2$export$2cc06ea48a9a0a41)['Pending Client Information']
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                        margin: "0.5rem"
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                        title: t('equipment:location'),
                                        children: [
                                            isMobile && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                    id: "facility_id",
                                                    label: t('common:facility'),
                                                    value: equipmentStore.formValues.facility_id,
                                                    setValue: (value)=>equipmentStore.updateFormValue('facility_id', value),
                                                    onMore: nextFacilityPage,
                                                    options: facilityOptions ?? [],
                                                    error: equipmentStore.formErrors['facility_id'],
                                                    required: true,
                                                    disabled: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                direction: isMobile ? 'column' : 'row',
                                                gap: "1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                        id: "latitude",
                                                        label: t('equipment:latitude'),
                                                        value: equipmentStore.formValues.latitude,
                                                        type: "number",
                                                        setValue: (value)=>equipmentStore.updateFormValue('latitude', value),
                                                        error: equipmentStore.formErrors['latitude'],
                                                        onSubmit: updateEquipment,
                                                        flex: true,
                                                        placeholder: "DDD.DDDDD\xb0",
                                                        required: true,
                                                        disabled: !isEditable || userStore.isExternalUser && !isPending
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                        id: "longitude",
                                                        label: t('equipment:longitude'),
                                                        value: equipmentStore.formValues.longitude,
                                                        type: "number",
                                                        setValue: (value)=>equipmentStore.updateFormValue('longitude', value),
                                                        error: equipmentStore.formErrors['longitude'],
                                                        onSubmit: updateEquipment,
                                                        flex: true,
                                                        placeholder: "DDD.DDDDD\xb0",
                                                        required: true,
                                                        disabled: !isEditable || userStore.isExternalUser && !isPending
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    equipment?.created_by_user_id && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                        margin: "0.5rem"
                                    }),
                                    equipment?.created_by_user_id && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                        title: t('equipment:creatorDetails'),
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            direction: isMobile ? 'column' : 'row',
                                            gap: "1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                    flex: "grow",
                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                        round: "6px",
                                                        background: "light-6",
                                                        height: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(58),
                                                        gap: "xsmall",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                pad: {
                                                                    top: 'xsmall',
                                                                    left: 'small'
                                                                },
                                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                    size: "small",
                                                                    color: "accent-1",
                                                                    children: t('equipment:createdBy')
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                                                                to: `/users/${equipment?.created_by_user_id}`,
                                                                textDecoration: "none",
                                                                style: {
                                                                    paddingLeft: '12px',
                                                                    paddingBottom: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(10),
                                                                    width: 'fit-content'
                                                                },
                                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                    color: "accent-1",
                                                                    fontFamily: "Lato, sans-serif",
                                                                    weight: "bold",
                                                                    children: equipment?.created_by_user?.name
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    id: "created_at",
                                                    label: t('equipment:createdAt'),
                                                    value: (0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(equipment?.created_at).format('MM/DD/YYYY'),
                                                    setValue: ()=>{},
                                                    flex: true,
                                                    disabled: true
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            equipment && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                id: "equipment-usage-data",
                animation: [
                    {
                        type: 'slideDown',
                        duration: 300,
                        size: 'xsmall'
                    }
                ],
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $72045821182f72ef$export$9f86c65c7386fe24), {
                    equipment: equipment
                })
            }),
            showRetireModal && !!equipment && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e44f10ba4a112641$export$de2fdb1e021e43cc), {
                equipment: equipment,
                setIsVisible: setShowRetireModal,
                setShouldRefresh: setShouldRefresh,
                isCanada: isCanada
            }),
            showDeleteModal && !!equipment && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $a839c87108bdeb6e$export$ef8bfc7c63f40c52), {
                equipment: equipment,
                setIsVisible: setShowDeleteModal
            })
        ]
    });
});




var $2xPiy = parcelRequire("2xPiy");














const $25c8916a80781102$export$89fcf498eb0506fa = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const equipmentStore = (0, $116967e0234c3770$export$728bc2cead7f2c5a)();
    const equipmentUsageStore = (0, $116967e0234c3770$export$f93886ff234de9d1)();
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const params = (0, $62d58f5c28b15c2e$export$99eaa27ddbbb95ef)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** State **/ const [isLoading, setIsLoading] = (0, $2xPiy.useState)(false);
    const [isUpdating, setIsUpdating] = (0, $2xPiy.useState)(false);
    const [clientName, setClientName] = (0, $2xPiy.useState)('');
    const [equipmentUsage, setEquipmentUsage] = (0, $2xPiy.useState)();
    const [equipment, setEquipment] = (0, $2xPiy.useState)();
    const [formValues, setFormValues] = (0, $2xPiy.useState)({
        fuel_pathway_id: undefined,
        is_book_and_claim_applied: false,
        battery_capacity_rating_ah: '',
        voltage: '',
        is_paused: false,
        total_kwh: null,
        charge_cycles_per_shift: '',
        shifts_per_day: '',
        work_days_per_quarter: '',
        percent_charger_efficiency_rating: '',
        percent_charge_return_factor: '',
        percent_depth_of_discharge: '',
        percent_uptime: '95',
        max_site_deliverability_kw: ''
    });
    const [initialFormValues, setInitialFormValues] = (0, $2xPiy.useState)();
    const [formErrors, setFormErrors] = (0, $2xPiy.useState)({});
    /** Computed **/ const isMobile = (0, $18588a518ac6fdc7$export$2ac00d7098bf223)(screenSize);
    const clientId = parseInt(params.client_id ?? '');
    const equipmentId = parseInt(params.equipment_id ?? '');
    const equipmentUsageId = parseInt(params.equipment_usage_id ?? '');
    const equipmentLabel = equipment ? (0, $00658ccd6ec0135a$export$83ca57d51225263a)(equipment, (0, $1132a1d774d1082e$export$8fde3cbed0ae03c0).Equipment) : undefined;
    const isInvalidParams = Number.isNaN(clientId) || Number.isNaN(equipmentId) || Number.isNaN(equipmentUsageId);
    const isCanada = equipmentUsage?.reporting_period_type_id === (0, $0badf5665deea2b2$export$a121e4a6c908fa8f).Yearly;
    const isMetered = equipment?.is_metered;
    const showFciFields = (0, $acc57f855dc3e03c$export$e8efcaf51aaf349d)(equipment?.equipment_type.equipment_category?.id);
    const reportingQuarter = equipmentUsage ? (0, $00658ccd6ec0135a$export$f96ebb633255a704)(equipmentUsage.start_reporting_quarter, isCanada) : undefined;
    const canEditQuarter = reportingQuarter && globalStore.currentQuarter && reportingQuarter === globalStore.currentQuarter;
    const hasErrors = !!Object.values(formErrors).filter((e)=>!!e).length;
    const hasChanges = !!initialFormValues && Object.keys(formValues).some((key)=>String(formValues[key] ?? '') !== String(initialFormValues[key] ?? ''));
    /** Methods **/ const updateFormValue = (key, value)=>{
        if (value !== null) {
            if (key === 'charge_cycles_per_shift' && value > 9.99) setFormErrors({
                ...formErrors,
                charge_cycles_per_shift: 'Value cannot exceed 9.99'
            });
            else if (key === 'shifts_per_day' && value > 9.99) setFormErrors({
                ...formErrors,
                shifts_per_day: 'Value cannot exceed 9.99'
            });
            else if (key === 'work_days_per_quarter' && value > 92) setFormErrors({
                ...formErrors,
                work_days_per_quarter: 'Value cannot exceed 92 days'
            });
            else if (key === 'charge_cycles_per_shift' && value < 0) setFormErrors({
                ...formErrors,
                charge_cycles_per_shift: 'Charge Cycles / Shift must be 0 or greater'
            });
            else if (key === 'work_days_per_quarter' && value < 0) setFormErrors({
                ...formErrors,
                work_days_per_quarter: 'Work Days / Quarter must be 0 or greater'
            });
            else if (key === 'shifts_per_day' && value < 0) setFormErrors({
                ...formErrors,
                shifts_per_day: 'Shifts / Day must be 0 or greater'
            });
            else if (key === 'percent_charger_efficiency_rating' && value < 0) setFormErrors({
                ...formErrors,
                percent_charger_efficiency_rating: 'Charger Efficiency Rating must be 0 or greater'
            });
            else if (key === 'percent_charge_return_factor' && value < 0) setFormErrors({
                ...formErrors,
                percent_charge_return_factor: 'Charge Return Factor must be 0 or greater'
            });
            else if (key === 'percent_depth_of_discharge' && value < 0) setFormErrors({
                ...formErrors,
                percent_depth_of_discharge: 'Depth of Discharge must be 0 or greater'
            });
            else if (key === 'total_kwh' && value < 0) setFormErrors({
                ...formErrors,
                total_kwh: 'Total kWh must be 0 or greater'
            });
        }
        setFormValues({
            ...formValues,
            [key]: value
        });
        if (formErrors[key]) setFormErrors({
            ...formErrors,
            [key]: ''
        });
    };
    const fetchEquipmentUsage = async ()=>{
        if (!equipmentUsageId) return;
        const equipmentUsage = await equipmentUsageStore.getEquipmentUsage({
            id: equipmentUsageId
        });
        setEquipmentUsage(equipmentUsage);
        const values = {
            fuel_pathway_id: equipmentUsage?.fuel_pathway_id,
            is_book_and_claim_applied: equipmentUsage?.is_book_and_claim_applied ?? false,
            battery_capacity_rating_ah: equipmentUsage?.battery_capacity_rating_ah?.toString() ?? '',
            voltage: equipmentUsage?.voltage?.toString() ?? '',
            is_paused: equipmentUsage?.is_paused ?? false,
            total_kwh: equipmentUsage?.total_kwh ?? null,
            charge_cycles_per_shift: equipmentUsage?.charge_cycles_per_shift ?? '',
            shifts_per_day: equipmentUsage?.shifts_per_day ?? '',
            work_days_per_quarter: equipmentUsage?.work_days_per_quarter ?? '',
            percent_charger_efficiency_rating: equipmentUsage?.percent_charger_efficiency_rating?.toString() ?? '',
            percent_charge_return_factor: equipmentUsage?.percent_charge_return_factor?.toString() ?? '',
            percent_depth_of_discharge: equipmentUsage?.percent_depth_of_discharge?.toString() ?? '',
            percent_uptime: equipmentUsage?.percent_uptime ?? '95',
            max_site_deliverability_kw: equipmentUsage?.max_site_deliverability_kw ?? null
        };
        setFormValues(values);
        setInitialFormValues(values);
    };
    const fetchPageData = async ()=>{
        if (isLoading || !clientId || !equipmentId || !equipmentUsageId) return;
        try {
            setIsLoading(true);
            const clientName = userStore.isClientUser || userStore.isFacilityUser ? userStore.user?.clients.find((client)=>client.id === clientId)?.name : (await (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).get({
                id: clientId
            }))?.name;
            setClientName(clientName ?? '');
            const equipment = await equipmentStore.fetchEquipment(equipmentId);
            setEquipment(equipment);
            await fetchEquipmentUsage();
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).fetchEquipmentUsage.error);
        } finally{
            setIsLoading(false);
        }
    };
    const updateMeteredUsage = async ()=>{
        if (!equipment || !equipmentUsage || !canEditQuarter) return false;
        const errors = (0, $084681c8221d0a24$export$5fafec8d1b047c0)({
            total_kwh: {
                label: 'Total kWh',
                required: true
            },
            percent_uptime: {
                label: 'Uptime',
                required: true
            },
            max_site_deliverability_kw: {
                label: 'Max Site Deliverability (kW)',
                required: false
            }
        }, formValues);
        if (errors) {
            setFormErrors(errors);
            return false;
        }
        await equipmentUsageStore.updateMeteredEquipmentUsage({
            equipment_usage_id: equipmentUsage.id,
            fuel_pathway_id: userStore.isInternalUser ? formValues.fuel_pathway_id ?? null : null,
            is_book_and_claim_applied: userStore.isInternalUser ? formValues.is_book_and_claim_applied ?? null : null,
            total_kwh: formValues.total_kwh ? parseFloat(parseFloat(formValues.total_kwh).toFixed(2)) : null,
            percent_uptime: formValues.percent_uptime ? parseInt(formValues.percent_uptime) : null,
            max_site_deliverability_kw: formValues.max_site_deliverability_kw ? parseInt(formValues.max_site_deliverability_kw) : null
        });
        return true;
    };
    const updateUnmeteredUsage = async ()=>{
        if (!equipment || !equipmentUsage || !canEditQuarter) return false;
        const errors = (0, $084681c8221d0a24$export$5fafec8d1b047c0)({
            charge_cycles_per_shift: {
                label: 'Charge Cycles / Shift',
                required: true,
                max: 9.99,
                nonZero: true
            },
            shifts_per_day: {
                label: 'Shifts / Day',
                required: true,
                max: 9.99,
                nonZero: true
            },
            work_days_per_quarter: {
                label: 'Work Days / Quarter',
                required: true,
                max: 92,
                nonZero: true
            },
            percent_charger_efficiency_rating: {
                label: 'Charger Efficiency Rating',
                required: true
            },
            percent_charge_return_factor: {
                label: 'Charge Return Factor',
                required: true
            },
            percent_depth_of_discharge: {
                label: 'Depth of Discharge',
                required: true
            },
            percent_uptime: {
                label: 'Uptime',
                required: true
            },
            max_site_deliverability_kw: {
                label: 'Max Site Deliverability (kW)',
                required: false
            }
        }, formValues);
        if (errors) {
            setFormErrors(errors);
            return false;
        }
        await equipmentUsageStore.updateUnmeteredEquipmentUsage({
            equipment_usage_id: equipmentUsage.id,
            fuel_pathway_id: userStore.isInternalUser ? formValues.fuel_pathway_id ?? null : null,
            is_book_and_claim_applied: userStore.isInternalUser ? formValues.is_book_and_claim_applied ?? null : null,
            battery_capacity_rating_ah: equipmentUsage?.battery_capacity_rating_ah ?? NaN,
            voltage: equipmentUsage?.voltage ?? NaN,
            is_paused: equipmentUsage?.is_paused ?? false,
            charge_cycles_per_shift: parseFloat(parseFloat(formValues.charge_cycles_per_shift).toFixed(2)),
            shifts_per_day: parseFloat(parseFloat(formValues.shifts_per_day).toFixed(2)),
            work_days_per_quarter: parseFloat(parseFloat(formValues.work_days_per_quarter).toFixed(2)),
            percent_charger_efficiency_rating: parseInt(formValues.percent_charger_efficiency_rating),
            percent_charge_return_factor: parseInt(formValues.percent_charge_return_factor),
            percent_depth_of_discharge: parseInt(formValues.percent_depth_of_discharge),
            percent_uptime: parseInt(formValues.percent_uptime),
            max_site_deliverability_kw: formValues.max_site_deliverability_kw ? parseInt(formValues.max_site_deliverability_kw) : null
        });
        return true;
    };
    const updateEquipmentUsage = async ()=>{
        if (isUpdating || !equipment || !hasChanges) return;
        try {
            setIsUpdating(true);
            const saved = isMetered ? await updateMeteredUsage() : await updateUnmeteredUsage();
            if (!saved) return;
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updateEquipmentUsage.success);
            await fetchEquipmentUsage();
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updateEquipmentUsage.error);
        } finally{
            setIsUpdating(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, equipment?.name ?? `${equipment?.manufacturer}: ${equipment?.serial_number}`, 'Usage');
    }, [
        equipment
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (clientId && equipmentId && equipmentUsageId) fetchPageData();
    }, [
        clientId,
        equipmentId,
        equipmentUsageId
    ]);
    /** Render **/ return isInvalidParams ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8fedf23083f90239$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $3d99c6153124a6ba$export$7234abc5d81adb58), {
        title: equipmentLabel,
        titleLinkUrl: `/clients/${clientId}/equipment/${equipmentId}`,
        titleLinkIconSize: "18px",
        breadcrumbNav: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e7dd63b10d4904e9$export$988959db72b892c3), {
            previousPages: [
                {
                    name: 'Clients',
                    link: !userStore.isClientUser && !userStore.isFacilityUser ? '/clients' : undefined
                },
                {
                    name: clientName,
                    link: !userStore.isFacilityUser ? `/clients/${clientId}` : undefined
                },
                {
                    name: 'Equipment',
                    link: equipment?.facility_id ? `/clients/${clientId}/facilities/${equipment?.facility_id}/equipment` : undefined
                },
                {
                    name: equipmentLabel ?? '',
                    link: `/clients/${clientId}/equipment/${equipmentId ?? ''}`
                },
                {
                    name: 'Usages '
                }
            ],
            currentPageName: (0, $00658ccd6ec0135a$export$f96ebb633255a704)(equipmentUsage?.start_reporting_quarter ?? '', isCanada)
        }),
        isLoading: isLoading,
        isDetailPage: true,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $04d59a1221f4208a$export$a7fed597f4b8afd8), {
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $98b6153ed086d9bd$export$11154b700737b45e), {
                title: `${reportingQuarter} ${t('equipment:usage')}`,
                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d8fcb0015cca0f72$export$825a3c81a577bf46), {
                    entityName: 'EquipmentUsage',
                    size: "24px",
                    color: "#EAAD47"
                }),
                onSubmit: updateEquipmentUsage,
                isLoading: isLoading || isUpdating,
                hideRequiredText: !canEditQuarter,
                hideSaveButton: !canEditQuarter,
                saveButtonLabel: t('common:saveChanges'),
                saveButtonDisabled: hasErrors || !hasChanges,
                children: equipment && equipmentUsage && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                    direction: isMobile ? 'column' : 'row',
                    margin: {
                        bottom: '1rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            width: "60%",
                            gap: "1rem",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                title: t('equipment:equipmentDetails'),
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                        direction: "row",
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                width: "25%",
                                                gap: "xsmall",
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        color: "accent-1",
                                                        size: "small",
                                                        toUpperCase: true,
                                                        children: t('equipment:category')
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        fontFamily: "Lato, sans-serif",
                                                        children: equipment.equipment_type.equipment_category?.name
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                width: "50%",
                                                gap: "xsmall",
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        color: "accent-1",
                                                        size: "small",
                                                        toUpperCase: true,
                                                        children: t('equipment:type')
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        fontFamily: "Lato, sans-serif",
                                                        children: equipment.equipment_type.name
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                width: "25%",
                                                gap: "xsmall",
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        color: "accent-1",
                                                        size: "small",
                                                        toUpperCase: true,
                                                        children: t('equipment:metered')
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        fontFamily: "Lato, sans-serif",
                                                        children: isMetered ? t('common:yes') : t('common:no')
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                        margin: "0.5rem"
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                        direction: "row",
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                width: "25%",
                                                gap: "xsmall",
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        color: "accent-1",
                                                        size: "small",
                                                        toUpperCase: true,
                                                        children: t('equipment:manufacturer')
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        fontFamily: "Lato, sans-serif",
                                                        children: equipment.manufacturer
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                width: "25%",
                                                gap: "xsmall",
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        color: "accent-1",
                                                        size: "small",
                                                        toUpperCase: true,
                                                        children: t('equipment:modelYear')
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        fontFamily: "Lato, sans-serif",
                                                        children: equipment.model_year
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                width: "25%",
                                                gap: "xsmall",
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        color: "accent-1",
                                                        size: "small",
                                                        toUpperCase: true,
                                                        children: t('equipment:serialNumber')
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        fontFamily: "Lato, sans-serif",
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ceab9ef72b825454$export$c92c6401b52a9298), {
                                                            content: equipment.serial_number,
                                                            children: equipment.serial_number.length >= 21 ? `${equipment.serial_number.slice(0, 4)}...${equipment.serial_number.slice(-4)}` : equipment.serial_number
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                width: "25%",
                                                gap: "xsmall",
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        color: "accent-1",
                                                        size: "small",
                                                        toUpperCase: true,
                                                        children: t('equipment:unitNo')
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        fontFamily: "Lato, sans-serif",
                                                        children: equipment.unit_number
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                        direction: "row",
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                width: "25%",
                                                gap: "xsmall",
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        color: "accent-1",
                                                        size: "small",
                                                        toUpperCase: true,
                                                        children: t('equipment:fuelPathwayCode')
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        fontFamily: "Lato, sans-serif",
                                                        children: equipmentUsage.fuel_pathway_id == null ? '' : equipmentUsageStore.fuelPathwayOptions.find((option)=>option.value === equipmentUsage.fuel_pathway_id)?.label || equipmentUsage.fuel_pathway_id
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                width: "25%",
                                                gap: "xsmall",
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        color: "accent-1",
                                                        size: "small",
                                                        toUpperCase: true,
                                                        children: t('equipment:bookAndClaim')
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        fontFamily: "Lato, sans-serif",
                                                        children: equipmentUsage.is_book_and_claim_applied === null || equipmentUsage.is_book_and_claim_applied === undefined ? '' : equipmentUsage.is_book_and_claim_applied ? t('equipment:applied') : t('equipment:notApplied')
                                                    })
                                                ]
                                            }),
                                            !isMetered && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                        width: "25%",
                                                        gap: "xsmall",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                color: "accent-1",
                                                                size: "small",
                                                                toUpperCase: true,
                                                                children: t('equipment:batteryCapacityAh')
                                                            }),
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                fontFamily: "Lato, sans-serif",
                                                                children: equipmentUsage.battery_capacity_rating_ah
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                        width: "25%",
                                                        gap: "xsmall",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                color: "accent-1",
                                                                size: "small",
                                                                toUpperCase: true,
                                                                children: t('equipment:voltage')
                                                            }),
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                fontFamily: "Lato, sans-serif",
                                                                children: equipmentUsage.voltage
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                            direction: "vertical"
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                            width: "40%",
                            gap: "1rem",
                            children: [
                                isMetered && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                    title: t('equipment:usageDetails'),
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                        direction: "column",
                                        gap: "1rem",
                                        children: [
                                            canEditQuarter ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                direction: "column",
                                                gap: "0.75rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                        direction: "row",
                                                        gap: "1rem",
                                                        wrap: false,
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                            basis: "0",
                                                            flex: {
                                                                grow: 1,
                                                                shrink: 1
                                                            },
                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                                name: "total_kwh",
                                                                label: t('common:totalKwh'),
                                                                value: formValues['total_kwh'] ? formValues['total_kwh'] : '',
                                                                setValue: (value)=>updateFormValue('total_kwh', value ? parseFloat(value) : null),
                                                                error: formErrors['total_kwh'],
                                                                onSubmit: updateEquipmentUsage,
                                                                required: true,
                                                                fill: "horizontal"
                                                            })
                                                        })
                                                    }),
                                                    showFciFields && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                        direction: "row",
                                                        gap: "1rem",
                                                        wrap: false,
                                                        children: [
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                basis: "0",
                                                                flex: {
                                                                    grow: 1,
                                                                    shrink: 1
                                                                },
                                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                                    label: t('equipment:percentUptime'),
                                                                    componentType: "percentage",
                                                                    value: formValues['percent_uptime'] ? formValues['percent_uptime'] : '',
                                                                    setValue: (value)=>updateFormValue('percent_uptime', value ? parseInt(value) : null),
                                                                    name: "percent_uptime",
                                                                    error: formErrors['percent_uptime'],
                                                                    onSubmit: updateEquipmentUsage,
                                                                    required: true,
                                                                    fill: "horizontal"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                basis: "0",
                                                                flex: {
                                                                    grow: 1,
                                                                    shrink: 1
                                                                },
                                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                                    label: t('equipment:maxSiteDeliverabilityKw'),
                                                                    value: formValues['max_site_deliverability_kw'] ? formValues['max_site_deliverability_kw'] : '',
                                                                    setValue: (value)=>updateFormValue('max_site_deliverability_kw', value ? parseInt(value) : null),
                                                                    name: "max_site_deliverability_kw",
                                                                    error: formErrors['max_site_deliverability_kw'],
                                                                    onSubmit: updateEquipmentUsage,
                                                                    fill: "horizontal"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                gap: "xsmall",
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                        fill: "horizontal",
                                                        gap: "xsmall",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                color: "accent-1",
                                                                size: "small",
                                                                toUpperCase: true,
                                                                children: t('common:totalKwh')
                                                            }),
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                fontFamily: "Lato, sans-serif",
                                                                children: equipmentUsage.total_kwh ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(equipmentUsage.total_kwh, true) : ''
                                                            })
                                                        ]
                                                    }),
                                                    showFciFields && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                fill: "horizontal",
                                                                gap: "xsmall",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                        color: "accent-1",
                                                                        size: "small",
                                                                        toUpperCase: true,
                                                                        children: t('equipment:percentUptime')
                                                                    }),
                                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                        fontFamily: "Lato, sans-serif",
                                                                        children: equipmentUsage.percent_uptime ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(equipmentUsage.percent_uptime, true) : ''
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                                fill: "horizontal",
                                                                gap: "xsmall",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                        color: "accent-1",
                                                                        size: "small",
                                                                        toUpperCase: true,
                                                                        children: t('equipment:maxSiteDeliverabilityKw')
                                                                    }),
                                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                        fontFamily: "Lato, sans-serif",
                                                                        children: equipmentUsage.max_site_deliverability_kw ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(equipmentUsage.max_site_deliverability_kw, true) : ''
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                fill: "horizontal",
                                                gap: "xsmall",
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        color: "accent-1",
                                                        size: "small",
                                                        toUpperCase: true,
                                                        children: t('equipment:recsRequired')
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        fontFamily: "Lato, sans-serif",
                                                        children: (0, $00658ccd6ec0135a$export$f5dd818bff069720)(equipmentUsage.recs_required, true) || '0.00'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                fill: "horizontal",
                                                gap: "xsmall",
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        color: "accent-1",
                                                        size: "small",
                                                        toUpperCase: true,
                                                        children: t('equipment:creditsGenerated')
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        fontFamily: "Lato, sans-serif",
                                                        children: (0, $00658ccd6ec0135a$export$f5dd818bff069720)(equipmentUsage.credits_generated, true) || '0.00'
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                !isMetered && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                    title: t('equipment:usageDetails'),
                                    children: [
                                        canEditQuarter && showFciFields ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                            direction: "row",
                                            gap: "1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    label: t('equipment:percentUptime'),
                                                    componentType: "percentage",
                                                    value: formValues['percent_uptime'] ? formValues['percent_uptime'] : '',
                                                    setValue: (value)=>updateFormValue('percent_uptime', value ? parseInt(value) : null),
                                                    name: "percent_uptime",
                                                    error: formErrors['percent_uptime'],
                                                    onSubmit: updateEquipmentUsage,
                                                    required: true,
                                                    fill: "horizontal"
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    label: t('equipment:maxSiteDeliverabilityKw'),
                                                    value: formValues['max_site_deliverability_kw'] ? formValues['max_site_deliverability_kw'] : '',
                                                    setValue: (value)=>updateFormValue('max_site_deliverability_kw', value ? parseInt(value) : null),
                                                    name: "max_site_deliverability_kw",
                                                    error: formErrors['max_site_deliverability_kw'],
                                                    onSubmit: updateEquipmentUsage,
                                                    fill: "horizontal"
                                                })
                                            ]
                                        }) : !canEditQuarter && showFciFields ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                            direction: "row",
                                            gap: "1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                    fill: "horizontal",
                                                    gap: "xsmall",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            color: "accent-1",
                                                            size: "small",
                                                            toUpperCase: true,
                                                            children: t('equipment:percentUptime')
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            fontFamily: "Lato, sans-serif",
                                                            children: (0, $00658ccd6ec0135a$export$f5dd818bff069720)(equipmentUsage.percent_uptime ?? '', true) || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                    fill: "horizontal",
                                                    gap: "xsmall",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            color: "accent-1",
                                                            size: "small",
                                                            toUpperCase: true,
                                                            children: t('equipment:maxSiteDeliverabilityKw')
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            fontFamily: "Lato, sans-serif",
                                                            children: equipmentUsage.max_site_deliverability_kw ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(equipmentUsage.max_site_deliverability_kw, true) : ''
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : [],
                                        canEditQuarter ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                            direction: "row",
                                            gap: "1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    label: t('equipment:chargeCyclesShift'),
                                                    value: formValues['charge_cycles_per_shift'],
                                                    setValue: (value)=>updateFormValue('charge_cycles_per_shift', value),
                                                    name: "charge_cycles_per_shift",
                                                    error: formErrors['charge_cycles_per_shift'],
                                                    onSubmit: updateEquipmentUsage,
                                                    required: true,
                                                    fill: "horizontal"
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    label: t('equipment:shiftsDay'),
                                                    value: formValues['shifts_per_day'],
                                                    setValue: (value)=>updateFormValue('shifts_per_day', value),
                                                    name: "shifts_per_day",
                                                    error: formErrors['shifts_per_day'],
                                                    onSubmit: updateEquipmentUsage,
                                                    required: true,
                                                    fill: "horizontal"
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    label: t('equipment:workDaysQuarter'),
                                                    value: formValues['work_days_per_quarter'],
                                                    setValue: (value)=>updateFormValue('work_days_per_quarter', value),
                                                    name: "work_days_per_quarter",
                                                    error: formErrors['work_days_per_quarter'],
                                                    onSubmit: updateEquipmentUsage,
                                                    required: true,
                                                    fill: "horizontal"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                            direction: "row",
                                            gap: "1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                    fill: "horizontal",
                                                    gap: "xsmall",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            color: "accent-1",
                                                            size: "small",
                                                            toUpperCase: true,
                                                            children: t('equipment:chargeCyclesShift')
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            fontFamily: "Lato, sans-serif",
                                                            children: (0, $00658ccd6ec0135a$export$f5dd818bff069720)(equipmentUsage.charge_cycles_per_shift ?? '', true) || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                    fill: "horizontal",
                                                    gap: "xsmall",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            color: "accent-1",
                                                            size: "small",
                                                            toUpperCase: true,
                                                            children: t('equipment:shiftsDay')
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            fontFamily: "Lato, sans-serif",
                                                            children: (0, $00658ccd6ec0135a$export$f5dd818bff069720)(equipmentUsage.shifts_per_day ?? '', true) || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                    fill: "horizontal",
                                                    gap: "xsmall",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            color: "accent-1",
                                                            size: "small",
                                                            toUpperCase: true,
                                                            children: t('equipment:workDaysQuarter')
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            fontFamily: "Lato, sans-serif",
                                                            children: (0, $00658ccd6ec0135a$export$f5dd818bff069720)(equipmentUsage.work_days_per_quarter ?? '', true) || '-'
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        canEditQuarter ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                            direction: "row",
                                            gap: "1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    label: t('equipment:chargerEfficiencyRating'),
                                                    value: formValues['percent_charger_efficiency_rating'] + (!canEditQuarter ? ' %' : ''),
                                                    setValue: (value)=>updateFormValue('percent_charger_efficiency_rating', value),
                                                    name: "percent_charger_efficiency_rating",
                                                    componentType: canEditQuarter ? 'percentage' : undefined,
                                                    error: formErrors['percent_charger_efficiency_rating'],
                                                    onSubmit: updateEquipmentUsage,
                                                    disabled: !canEditQuarter,
                                                    disabledBackground: "white",
                                                    required: true,
                                                    fill: "horizontal"
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    label: t('equipment:chargeReturnFactor'),
                                                    value: formValues['percent_charge_return_factor'] + (!canEditQuarter ? ' %' : ''),
                                                    setValue: (value)=>updateFormValue('percent_charge_return_factor', value),
                                                    name: "percent_charge_return_factor",
                                                    componentType: canEditQuarter ? 'percentage' : undefined,
                                                    error: formErrors['percent_charge_return_factor'],
                                                    onSubmit: updateEquipmentUsage,
                                                    disabled: !canEditQuarter,
                                                    disabledBackground: "white",
                                                    required: true,
                                                    fill: "horizontal"
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    label: t('equipment:depthOfDischarge'),
                                                    value: formValues['percent_depth_of_discharge'] + (!canEditQuarter ? ' %' : ''),
                                                    setValue: (value)=>updateFormValue('percent_depth_of_discharge', value),
                                                    name: "percent_depth_of_discharge",
                                                    componentType: canEditQuarter ? 'percentage' : undefined,
                                                    error: formErrors['percent_depth_of_discharge'],
                                                    onSubmit: updateEquipmentUsage,
                                                    disabled: !canEditQuarter,
                                                    disabledBackground: "white",
                                                    required: true,
                                                    fill: "horizontal"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                            direction: "row",
                                            gap: "1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                    fill: "horizontal",
                                                    gap: "xsmall",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            color: "accent-1",
                                                            size: "small",
                                                            toUpperCase: true,
                                                            children: t('equipment:chargerEfficiencyRating')
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            fontFamily: "Lato, sans-serif",
                                                            children: equipmentUsage.percent_charger_efficiency_rating ? `${(0, $00658ccd6ec0135a$export$f5dd818bff069720)(equipmentUsage.percent_charger_efficiency_rating, true)} %` : '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                    fill: "horizontal",
                                                    gap: "xsmall",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            color: "accent-1",
                                                            size: "small",
                                                            toUpperCase: true,
                                                            children: t('equipment:chargeReturnFactor')
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            fontFamily: "Lato, sans-serif",
                                                            children: equipmentUsage.percent_charge_return_factor ? `${(0, $00658ccd6ec0135a$export$f5dd818bff069720)(equipmentUsage.percent_charge_return_factor, true)} %` : '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                    fill: "horizontal",
                                                    gap: "xsmall",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            color: "accent-1",
                                                            size: "small",
                                                            toUpperCase: true,
                                                            children: t('equipment:depthOfDischarge')
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            fontFamily: "Lato, sans-serif",
                                                            children: equipmentUsage.percent_depth_of_discharge ? `${(0, $00658ccd6ec0135a$export$f5dd818bff069720)(equipmentUsage.percent_depth_of_discharge, true)} %` : '-'
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                            margin: "0.5rem"
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                            direction: "row",
                                            gap: "1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                    fill: "horizontal",
                                                    gap: "xsmall",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            color: "accent-1",
                                                            size: "small",
                                                            toUpperCase: true,
                                                            children: t('common:totalKwh')
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            fontFamily: "Lato, sans-serif",
                                                            children: equipmentUsage.total_kwh ? (0, $00658ccd6ec0135a$export$f5dd818bff069720)(equipmentUsage.total_kwh, true) : ''
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                    fill: "horizontal",
                                                    gap: "xsmall",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            color: "accent-1",
                                                            size: "small",
                                                            toUpperCase: true,
                                                            children: t('equipment:kwhPerChargeCycle')
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            fontFamily: "Lato, sans-serif",
                                                            children: (0, $00658ccd6ec0135a$export$f5dd818bff069720)(equipmentUsage.kwh_per_charge_cycle?.toFixed(2) ?? '', true) || '0.00'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
                                                    fill: "horizontal",
                                                    gap: "xsmall",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            color: "accent-1",
                                                            size: "small",
                                                            toUpperCase: true,
                                                            children: t('equipment:creditsGenerated')
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            fontFamily: "Lato, sans-serif",
                                                            children: (0, $00658ccd6ec0135a$export$f5dd818bff069720)(equipmentUsage.credits_generated, true) || '0.00'
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
});




var $2xPiy = parcelRequire("2xPiy");











const $297155b2261984c8$export$a89bbf0bc21144c0 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const params = (0, $62d58f5c28b15c2e$export$99eaa27ddbbb95ef)();
    /** State **/ const [showEquipmentModal, setShowEquipmentModal] = (0, $2xPiy.useState)(false);
    const [clientState, setClientState] = (0, $2xPiy.useState)();
    const [facility, setFacility] = (0, $2xPiy.useState)();
    /** Computed **/ const clientId = parseInt(params.client_id ?? '');
    const facilityId = parseInt(params.facility_id ?? '');
    const clientName = clientState?.clientId === clientId ? clientState.name : '';
    const isDemoClient = clientState?.clientId === clientId && clientState.isDemo;
    const isLoading = !(clientName && facility);
    const facilityName = facility ? (0, $00658ccd6ec0135a$export$426d0e35b67696d3)(facility) : '';
    const isCanada = facility?.reporting_period_type_id === (0, $0badf5665deea2b2$export$a121e4a6c908fa8f).Yearly;
    const titleBar = (0, $2xPiy.useMemo)(()=>{
        const badges = [];
        if (isDemoClient) badges.push(/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
            pad: {
                horizontal: '0.5rem'
            },
            gap: "xsmall",
            background: {
                color: 'status-critical',
                opacity: 'medium'
            },
            border: {
                color: 'status-critical'
            },
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                size: "0.95rem",
                weight: 600,
                toUpperCase: true,
                children: "Demo Client"
            })
        }, "demo"));
        return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            gap: "small",
            direction: "row",
            children: badges
        });
    }, [
        isDemoClient
    ]);
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (!userStore.user) return;
        if (userStore.isExternalUser) {
            const client = userStore.getUserClient(clientId);
            setClientState({
                clientId: clientId,
                name: client?.name ?? '',
                isDemo: client?.is_demo ?? false
            });
            return;
        }
        let isCurrent = true;
        (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).get({
            id: clientId
        }).then((client)=>{
            if (isCurrent) setClientState({
                clientId: clientId,
                name: client.name,
                isDemo: client.is_demo ?? false
            });
        }).catch((err)=>{
            if (isCurrent) globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listFacilities.error);
        });
        return ()=>{
            isCurrent = false;
        };
    }, [
        clientId,
        userStore.user,
        userStore.isExternalUser,
        userStore.getUserClient,
        globalStore
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (facilityName) document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, 'Equipment', facilityName);
    }, [
        facilityName
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (!facility) (0, $2f95a0926656d8e2$export$c270777027a9c841).get({
            id: facilityId
        }).then((facility)=>setFacility(facility)).catch((err)=>globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listFacilities.error));
    }, [
        facility
    ]);
    /* Product Tour */ (0, $ea039e16ca87cc85$export$28f524c77ee81092)({
        tourName: 'equipment-list-tour',
        steps: (0, $3d0c747b3f894c98$export$7c37f8ecad7b78ca),
        autoStart: true,
        showOnce: true
    });
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9057517707360bf5$export$9b7824917a0c851e), {
        title: facilityName,
        pageHeader: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c61d91bfa75be0a1$export$53f1cd6809577fc5), {
            title: facilityName,
            titleBar: titleBar,
            showAddButton: userStore.isAdminUser && facility?.is_active,
            addButtonLabel: "ADD EQUIPMENT",
            onAddButton: ()=>setShowEquipmentModal(true),
            dataTour: "add-equipment-button"
        }),
        breadcrumbNav: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e7dd63b10d4904e9$export$988959db72b892c3), {
            previousPages: [
                {
                    name: 'Clients',
                    link: !userStore.isClientUser && !userStore.isFacilityUser ? '/clients' : undefined
                },
                {
                    name: clientName,
                    link: !userStore.isFacilityUser ? `/clients/${clientId}` : undefined
                },
                {
                    name: 'Facilities',
                    link: `/clients/${clientId}/facilities`
                },
                {
                    name: facilityName,
                    link: `/clients/${clientId}/facilities/${facilityId}`
                }
            ],
            currentPageName: "Equipment"
        }),
        isLoading: isLoading,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                flex: "grow",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $5c08d54bb3238b41$export$ff2589847bbc6a39), {
                    id: "equipment_list",
                    title: "Asset List",
                    clientId: clientId,
                    facilityId: facilityId,
                    isCanada: isCanada,
                    firstReportingQuarter: facility?.first_active_reporting_quarter,
                    lastReportingQuarter: facility?.last_active_reporting_quarter,
                    showBulkUpdateButton: true,
                    showSearchInput: true,
                    standalone: true
                })
            }),
            showEquipmentModal && !!clientId && !!facilityId && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $48980c91a59d1811$export$87d8bfca539b26c), {
                clientId: clientId,
                facilityId: facilityId,
                setIsVisible: setShowEquipmentModal
            })
        ]
    });
});



const $3f4f35e0fca6a8e0$export$54cdcf02be6d6712 = [
    // Create Client Equipment
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/clients/:client_id/equipment/create",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $97312f69a3fb1233$export$d93d97a3bf9621ab), {})
            })
        })
    }),
    // Equipment Usage Details
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/clients/:client_id/equipment/:equipment_id/usages/:equipment_usage_id",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $25c8916a80781102$export$89fcf498eb0506fa), {})
            })
        })
    }),
    // Equipment Details
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/clients/:client_id/equipment/:equipment_id",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $5b13820843795053$export$e9c7e2fc242b5f37), {})
            })
        })
    }),
    // List Equipment by Facility
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/clients/:client_id/facilities/:facility_id/equipment",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $297155b2261984c8$export$a89bbf0bc21144c0), {})
            })
        })
    })
];






var $2xPiy = parcelRequire("2xPiy");














const $f0c813bb55be8cb0$export$b4519c5e6e32fb7e = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const queryClient = (0, $bccbe1b43ff3d0cc$export$22e77b9572c4fded)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const params = (0, $62d58f5c28b15c2e$export$99eaa27ddbbb95ef)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** Refs **/ const defaultFormData = (0, $2xPiy.useRef)({
        name: '',
        address_line1: '',
        address_line2: '',
        address_city: '',
        address_region_id: null,
        address_post_code: '',
        utility_id: null,
        program_id: null,
        first_active_reporting_quarter: '',
        last_active_reporting_quarter: null,
        comments: ''
    });
    /** State **/ const [isFetchingPrograms, setIsFetchingPrograms] = (0, $2xPiy.useState)(false);
    const [isCreating, setIsCreating] = (0, $2xPiy.useState)(false);
    const [client, setClient] = (0, $2xPiy.useState)();
    const [clientProgramOptions, setClientProgramOptions] = (0, $2xPiy.useState)();
    const [formValues, setFormValues] = (0, $2xPiy.useState)(defaultFormData.current);
    const [formErrors, setFormErrors] = (0, $2xPiy.useState)({});
    /** Computed **/ const clientId = parseInt(params.client_id ?? '');
    const isMobile = (0, $18588a518ac6fdc7$export$2ac00d7098bf223)(screenSize);
    const isCanada = client?.country_id === (0, $0badf5665deea2b2$export$b77c37614753bffb).Canada;
    const isTercProgram = formValues.program_id === 6;
    const regionType = isCanada ? 'province' : 'state';
    const programEmptyMessage = !formValues.address_region_id ? t('facility:chooseProgramHelp', {
        regionType: regionType
    }) : t('facility:noPrograms', {
        regionType: regionType
    });
    const regionOptions = (0, $2xPiy.useMemo)(()=>{
        if (client?.country_id && globalStore.regions) return globalStore.regions.filter((r)=>r.short_code && r.country_id === client.country_id).map((region)=>({
                label: `${region.name} (${region.short_code})`,
                value: region.id
            }));
        return [];
    }, [
        client?.country_id,
        globalStore.regions
    ]);
    const programName = (0, $2xPiy.useMemo)(()=>formValues.program_id ? clientProgramOptions?.find((o)=>o.value === formValues.program_id)?.label : '', [
        formValues.program_id,
        clientProgramOptions
    ]);
    const isLoading = !client;
    /** Methods **/ const updateFormValue = (key, value)=>{
        setFormValues((prev)=>({
                ...prev,
                [key]: key === 'program_id' ? Number(value) : value
            }));
        if (formErrors[key]) formErrors[key] = '';
    };
    const handlePlaceSelected = (place)=>{
        if (place.line2) updateFormValue('address_line2', place.line2);
        if (place.city) updateFormValue('address_city', place.city);
        if (place.postCode) updateFormValue('address_post_code', place.postCode);
        if (place.stateShortCode) {
            const region = globalStore.regions.find((r)=>r.short_code?.toLowerCase() === place.stateShortCode.toLowerCase());
            if (region) updateFormValue('address_region_id', region.id);
        }
    };
    /**
   * Fetches page data.
   */ const fetchPageData = async ()=>{
        try {
            const client = userStore.isClientUser || userStore.isFacilityUser ? userStore.user?.clients.find((client)=>client.id === clientId) : await (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).get({
                id: clientId
            });
            if (client) setClient(client);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).fetchClient.error);
        }
    };
    /**
   * Creates a Facility with the current form values.
   * @returns
   */ const createFacility = async ()=>{
        if (!client?.name || isCreating || isFetchingPrograms) {
            (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).formValidation.requiredFields);
            return;
        }
        const formFields = {
            name: {
                label: t('common:name'),
                max: 50
            },
            address_line1: {
                label: t('common:address'),
                max: 100,
                required: true
            },
            address_line2: {
                label: t('common:addressContinued'),
                max: 100
            },
            address_city: {
                label: t('common:city'),
                max: 50,
                required: true
            },
            address_region_id: {
                label: t('common:stateProvince'),
                required: true
            },
            address_post_code: {
                label: t('common:postalCode'),
                max: 20,
                required: true
            },
            program_id: {
                label: t('common:program'),
                required: true
            },
            utility_id: {
                label: t('facility:utility'),
                required: !isCanada && !isTercProgram
            },
            first_active_reporting_quarter: {
                label: t('common:firstReportingPeriod'),
                required: true
            },
            comments: {
                label: t('common:comments'),
                max: 500
            }
        };
        const errors = (0, $084681c8221d0a24$export$5fafec8d1b047c0)(formFields, formValues);
        if (errors) {
            setFormErrors(errors);
            (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).formValidation.requiredFields);
            return;
        }
        const newFacility = {
            client_id: clientId,
            name: formValues.name || null,
            address_line1: formValues.address_line1,
            address_line2: formValues.address_line2 || null,
            address_city: formValues.address_city,
            address_region_id: formValues.address_region_id ?? 0,
            address_post_code: formValues.address_post_code,
            program_id: formValues.program_id,
            utility_id: isCanada ? null : formValues.utility_id,
            first_active_reporting_quarter: formValues.first_active_reporting_quarter ?? '',
            comments: formValues.comments || null
        };
        try {
            setIsCreating(true);
            const facility = await (0, $2f95a0926656d8e2$export$c270777027a9c841).create(newFacility);
            queryClient.invalidateQueries({
                queryKey: [
                    'facilities'
                ]
            });
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).createFacility.success);
            navigate(`/clients/${clientId}/facilities/${facility.id}`);
        } catch (err) {
            const error = err;
            const errorBody = error.body;
            if (errorBody?.message?.toLowerCase() === 'facility already exists') globalStore.handleApiError(error, ()=>(0, $a75b88ce77ba4923$export$40fb018dd4c59f8).duplicateFacility.error({
                    ...error,
                    body: {
                        ...errorBody,
                        program_name: programName
                    }
                }));
            else if (errorBody?.errors?.some((e)=>e.rule === 'unique' && e.field === 'name')) globalStore.handleApiError(error, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).duplicateFacilityName.error);
            else globalStore.handleApiError(error, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).createFacility.error);
        } finally{
            setIsCreating(false);
        }
    };
    /**
   * Fetches a filtered list of available Programs.
   * @param client
   * @param regionId
   * @param startPeriod
   */ const fetchPrograms = async (client, regionId, startPeriod)=>{
        try {
            setIsFetchingPrograms(true);
            const request = {
                id: client.id,
                program_region_id: regionId
            };
            if (startPeriod) {
                request.reporting_period_type_id = client.reporting_period_type_id;
                request.start_reporting_quarter = startPeriod;
                request.end_reporting_quarter = startPeriod;
            }
            const response = await (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).listClientPrograms(request);
            const uniquePrograms = new Map();
            response.forEach((program)=>{
                if (!uniquePrograms.has(program.program_id)) uniquePrograms.set(program.program_id, {
                    label: program.program.name,
                    value: program.program_id,
                    rate: program.percent_rate || program.fixed_kwh_rate
                });
            });
            const options = Array.from(uniquePrograms.values());
            setClientProgramOptions(options);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listPrograms.error);
        } finally{
            setIsFetchingPrograms(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, t('facility:addFacility'));
    }, [
        t
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (isLoading) fetchPageData();
    }, [
        isLoading
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (client && formValues.address_region_id) fetchPrograms(client, formValues.address_region_id, formValues.first_active_reporting_quarter);
    }, [
        client,
        formValues.address_region_id
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (client && formValues.first_active_reporting_quarter && formValues.address_region_id) {
            const currentProgramId = formValues.program_id;
            fetchPrograms(client, formValues.address_region_id, formValues.first_active_reporting_quarter).then(()=>{
                if (currentProgramId) updateFormValue('program_id', currentProgramId);
            });
        }
    }, [
        formValues.first_active_reporting_quarter
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $3d99c6153124a6ba$export$7234abc5d81adb58), {
        title: t('facility:addFacility'),
        breadcrumbNav: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e7dd63b10d4904e9$export$988959db72b892c3), {
            previousPages: [
                {
                    name: t('navigation:clients'),
                    link: !userStore.isClientUser && !userStore.isFacilityUser ? '/clients' : undefined
                },
                {
                    name: client?.name ?? '',
                    link: !userStore.isFacilityUser ? `/clients/${clientId}` : undefined
                },
                {
                    name: t('navigation:facilities'),
                    link: `/clients/${clientId}/facilities`
                }
            ],
            currentPageName: t('facility:addFacility')
        }),
        isLoading: isLoading,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $98b6153ed086d9bd$export$11154b700737b45e), {
            title: t('common:generalInfo'),
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7dacb42a28be9c15$export$7036cd8426a1245b), {
                size: "24px",
                color: "brand"
            }),
            isLoading: isLoading || isCreating,
            onSubmit: createFacility,
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $04d59a1221f4208a$export$a7fed597f4b8afd8), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    direction: isMobile ? 'column' : 'row',
                    margin: {
                        bottom: '1rem'
                    },
                    gap: "1rem",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            width: isMobile ? '100%' : '60%',
                            gap: "1rem",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                    title: t('facility:facilityInfo'),
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            direction: isMobile ? 'column' : 'row',
                                            gap: "1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    id: "facility_name",
                                                    label: t('common:name'),
                                                    flex: true,
                                                    value: formValues.name ?? '',
                                                    setValue: (value)=>updateFormValue('name', value),
                                                    error: formErrors['name'],
                                                    onSubmit: createFacility
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9623ddb5e8e2f680$export$c48527d0fea494d), {
                                                    id: "first_active_reporting_quarter",
                                                    label: t('common:firstReportingPeriod'),
                                                    placeholder: t('common:selectPeriod'),
                                                    value: formValues.first_active_reporting_quarter ?? '',
                                                    setValue: (value)=>updateFormValue('first_active_reporting_quarter', value),
                                                    clientId: client?.id,
                                                    programId: formValues.program_id ?? undefined,
                                                    reportingPeriodTypeId: client?.reporting_period_type_id,
                                                    firstActivePeriod: client?.first_active_reporting_quarter,
                                                    error: formErrors['first_active_reporting_quarter'],
                                                    required: true,
                                                    flex: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d3e44ef4a726de02$export$db97b1df0d4d83fb), {
                                            name: "address_line1",
                                            label: t('common:address'),
                                            value: formValues.address_line1,
                                            setValue: (value)=>updateFormValue('address_line1', value),
                                            onPlaceSelected: handlePlaceSelected,
                                            error: formErrors['address_line1'],
                                            onSubmit: createFacility,
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                            id: "address_line2",
                                            autoComplete: "address_line2",
                                            label: t('common:addressContinued'),
                                            value: formValues.address_line2 ?? '',
                                            setValue: (value)=>updateFormValue('address_line2', value),
                                            error: formErrors['address_line2'],
                                            onSubmit: createFacility
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            direction: isMobile ? 'column' : 'row',
                                            gap: "1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    id: "address_city",
                                                    label: t('common:city'),
                                                    value: formValues.address_city,
                                                    setValue: (value)=>updateFormValue('address_city', value),
                                                    error: formErrors['address_city'],
                                                    onSubmit: createFacility,
                                                    flex: true,
                                                    required: true
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                    id: "address_region_id",
                                                    label: t('common:stateProvince'),
                                                    value: formValues.address_region_id,
                                                    setValue: (value)=>updateFormValue('address_region_id', value),
                                                    options: regionOptions,
                                                    error: formErrors['address_region_id'],
                                                    required: true,
                                                    flex: true
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    id: "address_post_code",
                                                    label: t('common:postalCode'),
                                                    value: formValues.address_post_code,
                                                    setValue: (value)=>updateFormValue('address_post_code', value),
                                                    error: formErrors['address_post_code'],
                                                    onSubmit: createFacility,
                                                    flex: true,
                                                    required: true
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                    margin: "0.5rem"
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    direction: isMobile ? 'column' : 'row',
                                    gap: "1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                            id: "program",
                                            name: "program",
                                            label: t('common:program'),
                                            placeholder: t('facility:chooseProgram'),
                                            emptySearchMessage: programEmptyMessage,
                                            value: formValues.program_id,
                                            setValue: (value)=>updateFormValue('program_id', value),
                                            error: formErrors['program_id'],
                                            options: clientProgramOptions ?? [],
                                            required: true,
                                            flex: true
                                        }),
                                        !isCanada && !isTercProgram && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cdb622057b5638fa$export$df14e2f55b34badd), {
                                            id: "utility",
                                            label: t('facility:utility'),
                                            placeholder: t('facility:chooseUtility'),
                                            emptySearchMessage: !formValues.address_region_id ? t('facility:chooseUtilityHelp') : t('facility:noUtilities'),
                                            value: formValues.utility_id,
                                            setValue: (value)=>updateFormValue('utility_id', value),
                                            error: formErrors['utility_id'],
                                            regionId: formValues.address_region_id,
                                            required: !isCanada && !isTercProgram
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                    margin: "0.5rem"
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    flex: "grow",
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        id: "comments",
                                        label: t('common:comments'),
                                        value: formValues.comments ?? '',
                                        setValue: (value)=>updateFormValue('comments', value),
                                        error: formErrors['comments'],
                                        onSubmit: createFacility,
                                        componentType: "textArea",
                                        centerLabel: false,
                                        height: "12rem",
                                        disabled: !userStore.isAdminUser
                                    })
                                })
                            ]
                        }),
                        isMobile && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                            margin: "1rem"
                        }),
                        !isMobile && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                            direction: "vertical",
                            margin: "3rem"
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            width: isMobile ? '100%' : '40%',
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8c584e3e17a0dda3$export$78c2aadc68a82149), {
                                isFacility: true
                            })
                        })
                    ]
                })
            })
        })
    });
});




var $2xPiy = parcelRequire("2xPiy");






var $2xPiy = parcelRequire("2xPiy");



var $iA1nz = parcelRequire("iA1nz");

var $472d30b03ba2af1b$var$disabledStyle = "\n  opacity: 0.3;\n  cursor: default;\n  text-decoration: none;\n";
var $472d30b03ba2af1b$var$sizeStyle = function sizeStyle(props) {
    if (props.size) {
        var size = props.size || 'medium';
        var data = props.theme.text[size];
        return (0, $iA1nz.css)([
            "font-size:",
            ";line-height:",
            ";"
        ], data ? data.size : size, data ? data.height : 'normal');
    }
    return (0, $iA1nz.css)([
        "font-size:inherit;line-height:inherit;"
    ]);
};
var $472d30b03ba2af1b$export$ec39d0bf2d6d1efb = (0, $iA1nz.default).a.withConfig((0, $73ba8e2d301b823f$export$373e75d802fd707)).withConfig({
    displayName: "StyledAnchor",
    componentId: "sc-1rp7lwl-0"
})([
    "box-sizing:border-box;display:inline-flex;",
    " color:",
    ";",
    " text-decoration:",
    ";cursor:pointer;",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return $472d30b03ba2af1b$var$sizeStyle(props);
}, function(props) {
    var _props$theme$anchor;
    return (0, $11317b0e49e0d157$export$4cde5df63f53f473)(props.colorProp || ((_props$theme$anchor = props.theme.anchor) == null || (_props$theme$anchor = _props$theme$anchor.size) == null || (_props$theme$anchor = _props$theme$anchor[props.size]) == null ? void 0 : _props$theme$anchor.color) || props.theme.anchor.color, props.theme);
}, function(props) {
    var _props$theme$anchor2, _props$theme$anchor3;
    return props.weight ? "font-weight: " + props.weight + ";" : (((_props$theme$anchor2 = props.theme.anchor) == null || (_props$theme$anchor2 = _props$theme$anchor2.size) == null || (_props$theme$anchor2 = _props$theme$anchor2[props.size]) == null ? void 0 : _props$theme$anchor2.fontWeight) || props.theme.anchor.fontWeight) && "font-weight: " + (((_props$theme$anchor3 = props.theme.anchor) == null || (_props$theme$anchor3 = _props$theme$anchor3.size) == null || (_props$theme$anchor3 = _props$theme$anchor3[props.size]) == null ? void 0 : _props$theme$anchor3.fontWeight) || props.theme.anchor.fontWeight) + ";";
}, function(props) {
    var _props$theme$anchor4;
    return props.hasIcon ? 'none' : ((_props$theme$anchor4 = props.theme.anchor) == null || (_props$theme$anchor4 = _props$theme$anchor4.size) == null || (_props$theme$anchor4 = _props$theme$anchor4[props.size]) == null ? void 0 : _props$theme$anchor4.textDecoration) || props.theme.anchor.textDecoration;
}, (0, $73ba8e2d301b823f$export$a157b298d219a801), function(props) {
    return !props.disabled && props.theme.anchor.hover && (0, $iA1nz.css)([
        "&:hover{",
        " ",
        " ",
        "}"
    ], props.theme.anchor.hover.textDecoration && "text-decoration: " + props.theme.anchor.hover.textDecoration + ";", props.theme.anchor.hover.fontWeight && "font-weight: " + props.theme.anchor.hover.fontWeight + ";", props.theme.anchor.hover.extend);
}, function(props) {
    return props.hasIcon && !props.hasLabel && (0, $73ba8e2d301b823f$export$944a9710f9445eee)('padding', props.theme.anchor.iconOnly.pad, false, props.theme.global.edgeSize.responsiveBreakpoint, props.theme);
}, function(props) {
    return props.disabled && $472d30b03ba2af1b$var$disabledStyle;
}, function(props) {
    return props.focus && (0, $73ba8e2d301b823f$export$efbff472cb39d8b)();
}, function(props) {
    return props.theme.anchor.extend;
});



var $dyr1f = parcelRequire("dyr1f");

function $d3f4d32ec79ce60b$var$_extends() {
    return $d3f4d32ec79ce60b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d3f4d32ec79ce60b$var$_extends.apply(null, arguments);
}
var $d3f4d32ec79ce60b$var$PropType = {};
$d3f4d32ec79ce60b$var$PropType = $d3f4d32ec79ce60b$var$_extends({}, (0, $ab32ce3df36aa105$export$ffe37ff34eeb9e21), {
    a11yTitle: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).elementType
    ]),
    color: (0, $ab32ce3df36aa105$export$fc4c368d97afb623),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    gap: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'none',
            'xxsmall',
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    href: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).element,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).node,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).func,
    reverse: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge',
            'xxlarge'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string
    ]),
    weight: (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).oneOf([
            'normal',
            'bold'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dyr1f))).number
    ])
});
var $d3f4d32ec79ce60b$export$503a586efc7a7ea1 = $d3f4d32ec79ce60b$var$PropType;





var $592323ca32c094be$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "children",
    "color",
    "disabled",
    "gap",
    "href",
    "icon",
    "label",
    "onBlur",
    "onClick",
    "onFocus",
    "reverse",
    "size"
];
function $592323ca32c094be$var$_extends() {
    return $592323ca32c094be$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $592323ca32c094be$var$_extends.apply(null, arguments);
}
function $592323ca32c094be$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $592323ca32c094be$export$b688253958b8dfe7 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(_ref, ref) {
    var _theme$anchor3, _theme$anchor4;
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], children = _ref.children, color = _ref.color, disabled = _ref.disabled, gap = _ref.gap, href = _ref.href, icon = _ref.icon, label = _ref.label, _onBlur = _ref.onBlur, onClickProp = _ref.onClick, onFocus = _ref.onFocus, reverse = _ref.reverse, sizeProp = _ref.size, rest = $592323ca32c094be$var$_objectWithoutPropertiesLoose(_ref, $592323ca32c094be$var$_excluded);
    var _useThemeValue = (0, $f360c61b32a63078$export$b86e7a765e389e8f)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useState = (0, $2xPiy.useState)(), focus = _useState[0], setFocus = _useState[1];
    var _useContext = (0, $2xPiy.useContext)((0, $fb9a4f68d412304d$export$9afb8bc826b033ea)), size = _useContext.size;
    var sendAnalytics = (0, $5bd12fcfcb46b8f6$export$e955abb82869dc84)();
    var onClick = (0, $2xPiy.useCallback)(function(event) {
        sendAnalytics({
            type: 'anchorClick',
            element: (0, $83f2052c15a18307$export$37a8984127440e55)(event.target),
            event: event,
            href: href,
            label: typeof label === 'string' ? label : undefined
        });
        if (onClickProp) onClickProp(event);
    }, [
        onClickProp,
        sendAnalytics,
        label,
        href
    ]);
    (0, $2xPiy.useEffect)(function() {
        if ((icon || label) && children) console.warn('Anchor should not have children if icon or label is provided');
    }, [
        children,
        icon,
        label
    ]);
    var coloredIcon = icon;
    if (icon && !icon.props.color) {
        var _theme$anchor, _theme$anchor2;
        coloredIcon = /*#__PURE__*/ (0, $2xPiy.cloneElement)(icon, {
            color: (0, $11317b0e49e0d157$export$4cde5df63f53f473)(color || ((_theme$anchor = theme.anchor) == null || (_theme$anchor = _theme$anchor.icon) == null ? void 0 : _theme$anchor.color) || ((_theme$anchor2 = theme.anchor) == null || (_theme$anchor2 = _theme$anchor2.size) == null || (_theme$anchor2 = _theme$anchor2[sizeProp || size]) == null ? void 0 : _theme$anchor2.color) || theme.anchor.color, theme)
        });
    }
    var anchorIcon = (0, $0a9f81b63fff2436$export$a123f939253731a8)(coloredIcon, sizeProp || size, theme);
    var first = reverse ? label : anchorIcon;
    var second = reverse ? anchorIcon : label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $472d30b03ba2af1b$export$ec39d0bf2d6d1efb), $592323ca32c094be$var$_extends({}, rest, {
        ref: ref,
        "aria-label": ariaLabel || a11yTitle,
        colorProp: color,
        disabled: disabled,
        hasIcon: !!icon,
        focus: focus,
        hasLabel: label,
        reverse: reverse,
        href: !disabled ? href : undefined,
        onClick: !disabled ? onClick : undefined,
        onFocus: !disabled ? function(event) {
            setFocus(true);
            if (onFocus) onFocus(event);
        } : undefined,
        onBlur: function onBlur(event) {
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        size: sizeProp || size
    }, passThemeFlag), first && second ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $18c0523379e5dd9d$export$e71c4d32a2263218), {
        as: "span",
        direction: "row",
        align: "center",
        gap: gap || ((_theme$anchor3 = theme.anchor) == null || (_theme$anchor3 = _theme$anchor3.size) == null || (_theme$anchor3 = _theme$anchor3[sizeProp]) == null ? void 0 : _theme$anchor3.gap) || ((_theme$anchor4 = theme.anchor) == null ? void 0 : _theme$anchor4.gap),
        responsive: false
    }, first, second) : first || second || children);
});
$592323ca32c094be$export$b688253958b8dfe7.displayName = 'Anchor';
$592323ca32c094be$export$b688253958b8dfe7.propTypes = (0, $d3f4d32ec79ce60b$export$503a586efc7a7ea1);















const $eb41e80c00ce11a5$export$eeb3f350778a7931 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const facilityStore = (0, $116967e0234c3770$export$1fa40d59fe105eba)();
    const clientStore = (0, $116967e0234c3770$export$3b47afa599c78f61)();
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const isMobile = screenSize === 'medium' || screenSize === 'small';
    const queryClient = (0, $bccbe1b43ff3d0cc$export$22e77b9572c4fded)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /* Query Params */ const params = (0, $62d58f5c28b15c2e$export$99eaa27ddbbb95ef)();
    const clientId = parseInt(params.client_id ?? '');
    const facilityId = parseInt(params.facility_id ?? '');
    /** Refs **/ const defaultFormData = (0, $2xPiy.useRef)({
        name: '',
        address_line1: '',
        address_line2: '',
        address_city: '',
        address_region_id: null,
        address_post_code: '',
        utility_id: null,
        program_id: null,
        last_active_reporting_quarter: null,
        comments: ''
    });
    /** State **/ const [isLoading, setIsLoading] = (0, $2xPiy.useState)(true);
    const [isUpdating, setIsUpdating] = (0, $2xPiy.useState)(false);
    const [facility, setFacility] = (0, $2xPiy.useState)();
    const [facilityClient, setFacilityClient] = (0, $2xPiy.useState)();
    const [facilityUsers, setFacilityUsers] = (0, $2xPiy.useState)([]);
    const [isRetired, setIsRetired] = (0, $2xPiy.useState)(false);
    const [showRetireModal, setShowRetireModal] = (0, $2xPiy.useState)(false);
    const [showDeleteModal, setShowDeleteModal] = (0, $2xPiy.useState)(false);
    const [shouldRefresh, setShouldRefresh] = (0, $2xPiy.useState)(false);
    const [menuButtonItems, setMenuButtonItems] = (0, $2xPiy.useState)([]);
    const [isInvalidParams, setIsInvalidParams] = (0, $2xPiy.useState)(false);
    const [formValues, setFormValues] = (0, $2xPiy.useState)(defaultFormData.current);
    const [originalFormValues, setOriginalFormValues] = (0, $2xPiy.useState)(defaultFormData.current);
    const [formErrors, setFormErrors] = (0, $2xPiy.useState)({});
    const [hasChanges, setHasChanges] = (0, $2xPiy.useState)(false);
    /*** Computed **/ const isCanada = (0, $2xPiy.useMemo)(()=>facility?.reporting_period_type_id === (0, $0badf5665deea2b2$export$a121e4a6c908fa8f).Yearly, [
        facility
    ]);
    const isFinalized = (0, $2xPiy.useMemo)(()=>facility?.is_finalized, [
        facility
    ]);
    const firstReportingPeriod = (0, $2xPiy.useMemo)(()=>isCanada ? facility?.first_active_reporting_quarter?.slice(0, 4) : (0, $00658ccd6ec0135a$export$6a2a5264dcc16b56)((0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(facility?.first_active_reporting_quarter).toDate()), [
        isCanada,
        facility
    ]);
    const lastReportingPeriod = (0, $2xPiy.useMemo)(()=>facility?.last_active_reporting_quarter ? isCanada ? facility.last_active_reporting_quarter?.slice(0, 4) : (0, $00658ccd6ec0135a$export$6a2a5264dcc16b56)((0, (/*@__PURE__*/$parcel$interopDefault($f755eb4d30815c93$exports)))(facility.last_active_reporting_quarter).toDate()) : undefined, [
        facility,
        isCanada
    ]);
    const titleBar = (0, $2xPiy.useMemo)(()=>{
        const badges = [];
        if (lastReportingPeriod) badges.push(/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
            pad: {
                horizontal: '0.5rem'
            },
            gap: "xsmall",
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                size: "0.95rem",
                weight: 600,
                toUpperCase: true,
                children: `${t('common:retired')}: ${lastReportingPeriod}`
            })
        }, "retired"));
        if (isFinalized) badges.push(/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
            pad: {
                horizontal: '0.5rem'
            },
            gap: "xsmall",
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $a8356fcfdc571089$export$3605b1b47e399b43), {
                    size: "16px"
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                    size: "0.95rem",
                    weight: 600,
                    toUpperCase: true,
                    children: t('common:finalized')
                })
            ]
        }, "finalized"));
        if (facilityClient?.is_demo) badges.push(/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
            pad: {
                horizontal: '0.5rem'
            },
            gap: "xsmall",
            background: {
                color: 'status-critical',
                opacity: 'medium'
            },
            border: {
                color: 'status-critical'
            },
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                size: "0.95rem",
                weight: 600,
                toUpperCase: true,
                children: "Demo Client"
            })
        }, "demo"));
        return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            gap: "small",
            direction: "row",
            children: badges
        });
    }, [
        isFinalized,
        lastReportingPeriod,
        t,
        facilityClient?.is_demo
    ]);
    /** Methods **/ const updateFormValue = (key, value)=>{
        setFormValues((prev)=>{
            const newFormValues = {
                ...prev,
                [key]: value
            };
            const changesExist = Object.keys(newFormValues).some((k)=>JSON.stringify(newFormValues[k]) !== JSON.stringify(originalFormValues[k]));
            setHasChanges(changesExist);
            return newFormValues;
        });
        if (formErrors[key]) setFormErrors((prev)=>({
                ...prev,
                [key]: ''
            }));
    };
    const handlePlaceSelected = (place)=>{
        if (place.line2) updateFormValue('address_line2', place.line2);
        if (place.city) updateFormValue('address_city', place.city);
        if (place.postCode) updateFormValue('address_post_code', place.postCode);
    };
    const fetchPageData = async (facilityId, clientId)=>{
        try {
            const [facility, client] = await Promise.all([
                facilityStore.fetchFacility(facilityId),
                userStore.isClientUser || userStore.isFacilityUser ? userStore.user?.clients.find((client)=>client.id === clientId) : (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).get({
                    id: clientId
                })
            ]);
            if (!facility) throw new (0, $0402375deeb915a2$export$f2e832acab1bdd79)({}, {}, 'Facility not found');
            if (facility.client_id !== clientId) {
                facilityStore.setFacility(undefined);
                setIsInvalidParams(true);
                return;
            }
            document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, (0, $00658ccd6ec0135a$export$426d0e35b67696d3)(facility));
            setFacility(facility);
            setFacilityClient(client);
            setFacilityUsers(facility.users.filter((u)=>u.is_active && (u.role.id === (0, $a65473e9746b33bb$export$2cb4a31baf73b247).ClientAdmin || u.role.id === (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FacilityAdmin)).sort((a, b)=>b.role_id - a.role_id));
            const isRetired = (0, $2e4d07611f552ce8$export$5fba76fc92fefb38)(facility);
            setIsRetired(isRetired);
            const menuItems = [];
            if (!isRetired && userStore.isFuseAdmin) {
                menuItems.push({
                    label: t('facility:retireFacility'),
                    onClick: ()=>setShowRetireModal(true)
                });
                if (!facility.is_finalized) menuItems.push({
                    label: t('facility:deleteFacility'),
                    onClick: ()=>setShowDeleteModal(true)
                });
            }
            setMenuButtonItems(menuItems);
            const initialFormValues = {
                ...formValues,
                name: facility.name ?? '',
                address_line1: facility.address_line1,
                address_line2: facility.address_line2 ?? '',
                address_city: facility.address_city,
                address_region: facility.address_region,
                address_post_code: facility.address_post_code,
                utility_id: facility.utility?.id,
                last_active_reporting_quarter: facility.last_active_reporting_quarter,
                comments: facility.comments
            };
            setFormValues(initialFormValues);
            setOriginalFormValues(initialFormValues);
            setHasChanges(false);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).fetchFacility.error);
        }
    };
    const validateForm = ()=>{
        const formFields = {
            name: {
                label: 'Name',
                max: 50
            },
            address_line1: {
                label: 'Address',
                max: 100,
                required: true
            },
            address_line2: {
                label: 'Address',
                max: 100
            },
            address_city: {
                label: 'City',
                max: 50,
                required: true
            },
            address_post_code: {
                label: 'Postal code',
                max: 20,
                required: true
            },
            utility_id: {
                label: 'Utility',
                required: !isCanada
            },
            comments: {
                label: 'Comments',
                max: 500
            }
        };
        const errors = (0, $084681c8221d0a24$export$5fafec8d1b047c0)(formFields, formValues);
        if (errors) setFormErrors(errors);
        return !errors;
    };
    const updateFacility = async ()=>{
        if (!facilityId || !clientId || !validateForm() || !hasChanges) return;
        try {
            setIsUpdating(true);
            if (isFinalized) {
                await (0, $2f95a0926656d8e2$export$c270777027a9c841).updateFinalized({
                    id: facilityId,
                    name: formValues.name || null,
                    utility_id: formValues.utility_id || null,
                    comments: formValues.comments || null
                });
                setOriginalFormValues({
                    ...formValues
                });
            } else {
                await (0, $2f95a0926656d8e2$export$c270777027a9c841).updateUnfinalized({
                    id: facilityId,
                    name: formValues.name || null,
                    address_line1: formValues.address_line1,
                    address_line2: formValues.address_line2 || null,
                    address_city: formValues.address_city,
                    address_post_code: formValues.address_post_code,
                    utility_id: isCanada ? null : formValues.utility_id,
                    comments: formValues.comments || null
                });
                setOriginalFormValues({
                    ...formValues
                });
            }
            queryClient.invalidateQueries({
                queryKey: [
                    'facilities'
                ]
            });
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updateFacility.success);
            setHasChanges(false);
        } catch (error) {
            const err = error;
            const errors = err.body?.errors ?? [];
            const uniqueNameError = errors.find((e)=>e.field === 'name' && e.rule === 'unique');
            if (uniqueNameError) setFormErrors((prev)=>({
                    ...prev,
                    name: (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updateFacility.error(err)
                }));
            else globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updateFacility.error);
        } finally{
            setIsUpdating(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        clientStore.setReportingPeriodOptions(undefined);
        clientStore.setReportingPeriods(undefined);
    }, []);
    (0, $2xPiy.useEffect)(()=>{
        if (facilityId) {
            setIsLoading(true);
            setFacility(undefined);
            fetchPageData(facilityId, clientId).finally(()=>setIsLoading(false));
        }
    }, [
        facilityId,
        clientId
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (facilityId && shouldRefresh) {
            queryClient.invalidateQueries({
                queryKey: [
                    'facilities'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'equipment'
                ]
            });
            fetchPageData(facilityId, clientId).finally(()=>setShouldRefresh(false));
        }
    }, [
        facilityId,
        clientId,
        shouldRefresh
    ]);
    //404 Redirect
    (0, $2xPiy.useEffect)(()=>{
        if (isLoading) return;
        if (facility && facility.id !== facilityId) return;
        setIsInvalidParams(Number.isNaN(clientId) || Number.isNaN(facilityId) || facility?.id === undefined);
    }, [
        facilityId,
        facility,
        clientId,
        isLoading
    ]);
    /* Product Tour */ (0, $ea039e16ca87cc85$export$28f524c77ee81092)({
        tourName: 'facility-details-tour',
        steps: (0, $3d0c747b3f894c98$export$f825ccf1ead67c47),
        autoStart: true,
        showOnce: true
    });
    /** Render **/ return isInvalidParams ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8fedf23083f90239$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $3d99c6153124a6ba$export$7234abc5d81adb58), {
        title: (0, $00658ccd6ec0135a$export$426d0e35b67696d3)(facility),
        breadcrumbNav: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e7dd63b10d4904e9$export$988959db72b892c3), {
            previousPages: [
                {
                    name: 'Clients',
                    link: !userStore.isClientUser && !userStore.isFacilityUser ? '/clients' : undefined
                },
                {
                    name: facilityClient?.name || '',
                    link: !userStore.isFacilityUser ? `/clients/${clientId}` : undefined
                },
                {
                    name: t('common:facilities'),
                    link: `/clients/${clientId}/facilities`
                }
            ],
            currentPageName: (0, $00658ccd6ec0135a$export$426d0e35b67696d3)(facility)
        }),
        titleBar: titleBar,
        isLoading: isLoading,
        isDetailPage: true,
        hideMenuButton: !isLoading && facility && !menuButtonItems.length,
        menuButtonItems: menuButtonItems,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $98b6153ed086d9bd$export$11154b700737b45e), {
                title: t('common:generalInfo'),
                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7dacb42a28be9c15$export$7036cd8426a1245b), {
                    size: "24px",
                    color: "brand"
                }),
                onSubmit: updateFacility,
                saveButtonLabel: t('common:saveChanges'),
                saveButtonDisabled: !hasChanges,
                isLoading: isLoading || isUpdating,
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $04d59a1221f4208a$export$a7fed597f4b8afd8), {
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        direction: isMobile ? 'column' : 'row',
                        gap: "1rem",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                title: t('facility:facilityInfo'),
                                width: isMobile ? '100%' : '55%',
                                margin: {
                                    bottom: isMobile ? 'medium' : 'none'
                                },
                                "data-tour": "facility-info",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        direction: isMobile ? 'column' : 'row',
                                        gap: "1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                width: "100%",
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    id: "facility_name",
                                                    label: t('common:name'),
                                                    value: formValues.name ?? '',
                                                    setValue: (value)=>updateFormValue('name', value),
                                                    error: formErrors['name'],
                                                    onSubmit: updateFacility,
                                                    disabled: isRetired
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                width: "100%",
                                                direction: isMobile ? 'column' : 'row',
                                                gap: "1rem",
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    id: "first_active_reporting_quarter",
                                                    label: t('common:firstReportingPeriod'),
                                                    value: firstReportingPeriod,
                                                    required: true,
                                                    disabled: true,
                                                    flex: true
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d3e44ef4a726de02$export$db97b1df0d4d83fb), {
                                        name: "address_line1",
                                        label: t('common:address'),
                                        value: formValues.address_line1,
                                        setValue: (value)=>updateFormValue('address_line1', value),
                                        onPlaceSelected: handlePlaceSelected,
                                        error: formErrors['address_line1'],
                                        onSubmit: updateFacility,
                                        required: true,
                                        disabled: isFinalized || isRetired
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        id: "address_line2",
                                        autoComplete: "address_line2",
                                        label: t('common:addressContinued'),
                                        value: formValues.address_line2 ?? '',
                                        setValue: (value)=>updateFormValue('address_line2', value),
                                        error: formErrors['address_line2'],
                                        onSubmit: updateFacility,
                                        disabled: isFinalized || isRetired
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        direction: isMobile ? 'column' : 'row',
                                        gap: "1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                id: "address_city",
                                                label: t('common:city'),
                                                value: formValues.address_city,
                                                setValue: (value)=>updateFormValue('address_city', value),
                                                error: formErrors['address_city'],
                                                onSubmit: updateFacility,
                                                required: true,
                                                disabled: isFinalized || isRetired,
                                                flex: true
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                id: "address_region.short_code",
                                                label: t('common:stateProvince'),
                                                value: formValues.address_region?.short_code ?? '',
                                                required: true,
                                                disabled: true,
                                                flex: true
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                id: "address_post_code",
                                                label: t('common:postalCode'),
                                                value: formValues.address_post_code,
                                                setValue: (value)=>updateFormValue('address_post_code', value),
                                                error: formErrors['address_post_code'],
                                                onSubmit: updateFacility,
                                                required: true,
                                                disabled: isFinalized || isRetired,
                                                flex: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                        margin: "0.5rem"
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        direction: isMobile ? 'column' : 'row',
                                        gap: "1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                id: "program_id",
                                                label: t('common:program'),
                                                value: facility?.program?.name,
                                                required: true,
                                                disabled: true,
                                                fill: "horizontal"
                                            }),
                                            !isCanada && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cdb622057b5638fa$export$df14e2f55b34badd), {
                                                id: "utility",
                                                label: t('facility:utility'),
                                                placeholder: t('facility:chooseUtility'),
                                                emptySearchMessage: !formValues.address_region?.id ? t('facility:chooseUtilityHelp') : t('facility:noUtilities'),
                                                value: formValues.utility_id,
                                                setValue: (value)=>updateFormValue('utility_id', value),
                                                error: formErrors['utility_id'],
                                                regionId: formValues.address_region?.id,
                                                required: !isCanada,
                                                disabled: isRetired,
                                                fill: "horizontal"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                        margin: "0.5rem"
                                    }),
                                    isRetired && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        name: "facility-retirement_reason",
                                        label: t('common:reasonForRetiring'),
                                        value: facility?.retirement_reason_other || facility?.retirement_reason?.name || '',
                                        disabled: true,
                                        placeholder: "-",
                                        componentType: "textArea",
                                        opacity: 1
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        flex: "grow",
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                            id: "comments",
                                            label: t('common:comments'),
                                            value: formValues.comments ?? '',
                                            setValue: (value)=>updateFormValue('comments', value),
                                            error: formErrors['comments'],
                                            onSubmit: updateFacility,
                                            componentType: "textArea",
                                            centerLabel: false,
                                            height: "12rem",
                                            disabled: !userStore.isAdminUser
                                        })
                                    })
                                ]
                            }),
                            !isMobile ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                direction: "vertical",
                                margin: "3rem"
                            }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                margin: "small"
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                width: isMobile ? '100%' : '40%',
                                pad: isMobile ? {
                                    top: 'medium',
                                    bottom: '75px'
                                } : undefined,
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9f4eedc32616d701$export$ccfabc72f6726f7e), {
                                    contacts: facilityUsers,
                                    isFacility: true,
                                    isUpdatePage: true
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $592323ca32c094be$export$b688253958b8dfe7), {
                id: "equipment"
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                "data-tour": "facility-equipment-list",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $5c08d54bb3238b41$export$ff2589847bbc6a39), {
                    id: "equipment_list",
                    title: t('facility:assetList'),
                    clientId: clientId,
                    facilityId: facilityId,
                    isCanada: isCanada,
                    firstReportingQuarter: facility?.first_active_reporting_quarter,
                    lastReportingQuarter: facility?.last_active_reporting_quarter,
                    showBulkUpdateButton: true,
                    showAddButton: true,
                    showShareButton: true,
                    showSearchInput: true
                })
            }),
            showRetireModal && !!facility && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $02d290c95d3f695d$export$3640d7be9c00e62d), {
                facility: facility,
                setIsVisible: setShowRetireModal,
                setShouldRefresh: setShouldRefresh
            }),
            showDeleteModal && !!facility && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $0f2d97cc23e8df8d$export$1e40880dc1d4b90b), {
                facility: facility,
                setIsVisible: setShowDeleteModal,
                setShouldRefresh: setShouldRefresh
            })
        ]
    });
});
var $eb41e80c00ce11a5$export$2e2bcd8739ae039 = $eb41e80c00ce11a5$export$eeb3f350778a7931;




var $2xPiy = parcelRequire("2xPiy");











const $f6ca9d6e4a26040e$export$1183479ded931076 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const params = (0, $62d58f5c28b15c2e$export$99eaa27ddbbb95ef)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** State **/ const [clientState, setClientState] = (0, $2xPiy.useState)();
    /** Computed **/ const clientId = parseInt(params.client_id ?? '');
    const client = clientState?.id === clientId ? clientState.client : null;
    const isLoading = !client;
    const titleBar = (0, $2xPiy.useMemo)(()=>{
        const badges = [];
        if (client?.is_demo) badges.push(/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
            pad: {
                horizontal: '0.5rem'
            },
            gap: "xsmall",
            background: {
                color: 'status-critical',
                opacity: 'medium'
            },
            border: {
                color: 'status-critical'
            },
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                size: "0.95rem",
                weight: 600,
                toUpperCase: true,
                children: "Demo Client"
            })
        }, "demo"));
        return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            gap: "small",
            direction: "row",
            children: badges
        });
    }, [
        client?.is_demo
    ]);
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        if (!userStore.user) return;
        if (userStore.isExternalUser) {
            setClientState({
                id: clientId,
                client: userStore.getUserClient(clientId) ?? null
            });
            return;
        }
        let isCurrent = true;
        (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).get({
            id: clientId
        }).then((client)=>{
            if (isCurrent) setClientState({
                id: clientId,
                client: client
            });
        }).catch((err)=>{
            if (isCurrent) globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listFacilities.error);
        });
        return ()=>{
            isCurrent = false;
        };
    }, [
        clientId,
        userStore.user,
        userStore.isExternalUser,
        userStore.getUserClient,
        globalStore
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (client) document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, 'Facilities', client.name);
    }, [
        client?.name
    ]);
    /* Product Tour */ (0, $ea039e16ca87cc85$export$28f524c77ee81092)({
        tourName: 'facilities-list-tour',
        steps: (0, $3d0c747b3f894c98$export$e5e01ff4ae0af8aa),
        autoStart: true
    });
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9057517707360bf5$export$9b7824917a0c851e), {
        title: client?.name || '',
        pageHeader: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c61d91bfa75be0a1$export$53f1cd6809577fc5), {
            title: client?.name || '',
            titleBar: titleBar,
            showAddButton: userStore.isAdminUser && !userStore.isFacilityUser,
            addButtonLabel: t('facility:addFacility'),
            addButtonUrl: `/clients/${clientId}/facilities/create`,
            dataTour: "add-facility-button"
        }),
        breadcrumbNav: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e7dd63b10d4904e9$export$988959db72b892c3), {
            previousPages: [
                {
                    name: 'Clients',
                    link: !userStore.isExternalUser ? '/clients' : undefined
                },
                {
                    name: client?.name || '',
                    link: !userStore.isFacilityUser ? `/clients/${clientId}` : undefined
                }
            ],
            currentPageName: "Facilities"
        }),
        isLoading: isLoading,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $93b56b8d4d0da6dd$export$9f76c3e28857a02f), {
            clientId: clientId,
            showSearchInput: true,
            standalone: true,
            "data-tour": "facilities-list"
        })
    });
});



const $adb002a716b62561$export$f7ef6de0a68edfe8 = [
    // Create Facility
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/clients/:client_id/facilities/create",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f0c813bb55be8cb0$export$b4519c5e6e32fb7e), {})
            })
        })
    }),
    // Facility Details
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/clients/:client_id/facilities/:facility_id",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $eb41e80c00ce11a5$export$eeb3f350778a7931), {})
            })
        })
    }),
    // List Facilities
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/clients/:client_id/facilities",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f6ca9d6e4a26040e$export$1183479ded931076), {})
            })
        })
    })
];




var $2xPiy = parcelRequire("2xPiy");











const $57ec1def7063bada$var$defaultFormData = {
    email: '',
    password: ''
};
const $57ec1def7063bada$var$Login = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const location = (0, $62d58f5c28b15c2e$export$45d76561a5302f2b)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** State **/ const [isLoggingIn, setIsLoggingIn] = (0, $2xPiy.useState)(false);
    const [showInactiveModal, setShowInactiveModal] = (0, $2xPiy.useState)(false);
    const [showPassword, setShowPassword] = (0, $2xPiy.useState)(false);
    // Form values
    const [formValues, setFormValues] = (0, $2xPiy.useState)($57ec1def7063bada$var$defaultFormData);
    const [formErrors, setFormErrors] = (0, $2xPiy.useState)({});
    /** Methods **/ const validateForm = ()=>{
        const errors = {};
        if (!formValues.email) errors['email'] = 'Email address is required';
        if (!formValues.password) errors['password'] = 'Password is required';
        if (Object.keys(errors).length) {
            setFormErrors(errors);
            return false;
        }
        return true;
    };
    const handleLogin = async ()=>{
        if (!validateForm()) return;
        try {
            setIsLoggingIn(true);
            const loginData = {
                email: formValues.email,
                password: formValues.password
            };
            const user = await userStore.login(loginData);
            await globalStore.fetchAll();
            const userName = user?.name;
            (0, $05d5739209a21833$export$b410431fab84fa58).success(`Welcome back, ${userName}!`);
            const fromLocation = location.state?.from?.pathname;
            const redirectPath = globalStore.previousPath || fromLocation;
            if (redirectPath) {
                globalStore.setPreviousPath('');
                navigate(redirectPath, {
                    replace: true
                });
            } else navigate(userStore.isInternalUser ? '/clients' : '/', {
                replace: true
            });
        } catch (err) {
            const error = err;
            if (error.body?.message?.toLowerCase() === 'inactive account') setShowInactiveModal(true);
            else globalStore.handleApiError(error, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).login.error);
        } finally{
            setIsLoggingIn(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, 'Login');
    }, []);
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $225251299c21678a$export$ef2184bd89960b14), {
        height: "100vh",
        rows: [
            'flex'
        ],
        columns: [
            'auto'
        ],
        areas: [
            {
                name: 'main',
                start: [
                    0,
                    0
                ],
                end: [
                    0,
                    0
                ]
            }
        ],
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d48fc541d96cd8f0$export$861edd1ccea2f746), {
            gridArea: "main",
            background: "light",
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    justify: "center",
                    flex: "grow",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            alignSelf: "center",
                            margin: {
                                bottom: '2rem'
                            },
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b693aeeca29ae7b2$export$2e2bcd8739ae039), {
                                width: "14rem",
                                height: "3.75rem"
                            })
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $724dfb7ecf65a151$export$60332b2344f7fe41), {
                            alignSelf: "center",
                            pad: "2rem",
                            width: "28rem",
                            flex: undefined,
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $04d59a1221f4208a$export$a7fed597f4b8afd8), {
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $fdccc762800a972d$export$851de33184ecdac4), {
                                    flex: "grow",
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            margin: {
                                                bottom: '0.5rem'
                                            },
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                size: "1.5rem",
                                                color: "dark-2",
                                                weight: 300,
                                                children: t('common:title')
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            children: [
                                                formErrors['email'] && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    color: "red",
                                                    size: "small",
                                                    children: formErrors['email']
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $168667f04da9206c$export$16e4d70cc375e707), {
                                                    onEnter: ()=>handleLogin(),
                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8c9c99ffe8765a99$export$c86715117507e8e5), {
                                                        name: "email",
                                                        type: "email",
                                                        placeholder: t('common:email'),
                                                        autoComplete: "username",
                                                        required: true,
                                                        value: formValues.email,
                                                        onChange: (e)=>setFormValues({
                                                                ...formValues,
                                                                email: e.target.value
                                                            }),
                                                        style: {
                                                            borderRadius: '0.375rem',
                                                            fontFamily: 'Lato, sans-serif'
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            children: [
                                                formErrors['password'] && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    color: "red",
                                                    size: "small",
                                                    children: formErrors['password']
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $168667f04da9206c$export$16e4d70cc375e707), {
                                                    onEnter: ()=>handleLogin(),
                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                        direction: "row",
                                                        align: "center",
                                                        style: {
                                                            position: 'relative'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8c9c99ffe8765a99$export$c86715117507e8e5), {
                                                                name: "password",
                                                                type: showPassword ? 'text' : 'password',
                                                                placeholder: t('common:password'),
                                                                autoComplete: "password",
                                                                required: true,
                                                                value: formValues.password,
                                                                onChange: (e)=>setFormValues({
                                                                        ...formValues,
                                                                        password: e.target.value
                                                                    }),
                                                                style: {
                                                                    borderRadius: '0.375rem',
                                                                    fontFamily: 'Lato, sans-serif',
                                                                    width: '100%'
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                                                icon: showPassword ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $4acda1c651d988fd$export$27a5bd065ad55220), {
                                                                    size: "medium"
                                                                }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $17615e8310fedcd7$export$bed28288a051538), {
                                                                    size: "medium"
                                                                }),
                                                                onClick: ()=>setShowPassword(!showPassword),
                                                                plain: true,
                                                                style: {
                                                                    position: 'absolute',
                                                                    right: '12px',
                                                                    background: 'transparent',
                                                                    border: 'none',
                                                                    padding: '0',
                                                                    cursor: 'pointer'
                                                                },
                                                                a11yTitle: showPassword ? 'Hide password' : 'Show password'
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                            type: "submit",
                                            disabled: !formValues.email || !formValues.password,
                                            onClick: ()=>handleLogin(),
                                            margin: {
                                                bottom: '1rem'
                                            },
                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                background: "accent-1",
                                                pad: {
                                                    horizontal: '1rem',
                                                    vertical: '0.5rem'
                                                },
                                                borderRadius: "0.5rem",
                                                children: [
                                                    !isLoggingIn && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        alignSelf: "center",
                                                        size: "1.25rem",
                                                        color: "white",
                                                        lineHeight: "1.875rem",
                                                        children: t('common:signIn')
                                                    }),
                                                    isLoggingIn && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8bec6e2e7dc53c4a$export$7f7cbe89f1eacd2), {
                                                        height: "1.875rem",
                                                        width: "1.875rem",
                                                        alignSelf: "center",
                                                        color: "white"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            direction: "row",
                            justify: "center",
                            margin: {
                                vertical: '1rem'
                            },
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                lineHeight: "1.5rem",
                                fontFamily: "Lato, sans-serif",
                                children: [
                                    t('common:troubleSigningIn'),
                                    ' ',
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                                        to: "/reset-password",
                                        style: {
                                            textDecoration: 'none'
                                        },
                                        children: t('common:resetPassword')
                                    })
                                ]
                            })
                        }),
                        showInactiveModal && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6645b887919d682a$export$6a279c7792150a9a), {
                            setIsVisible: setShowInactiveModal
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $605617a28ba64070$export$3210cca7a959581e), {
                    flex: "shrink"
                })
            ]
        })
    });
});
var $57ec1def7063bada$export$2e2bcd8739ae039 = $57ec1def7063bada$var$Login;




var $2xPiy = parcelRequire("2xPiy");






const $90034d9b075807b1$var$Logout = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const location = (0, $62d58f5c28b15c2e$export$45d76561a5302f2b)();
    const [isLoading, setIsLoading] = (0, $2xPiy.useState)(true);
    (0, $2xPiy.useEffect)(()=>{
        const wasSessionExpired = location.state?.reason === (0, $9c41c53e999a77b0$export$c37e141db7d79f56);
        if (!wasSessionExpired) globalStore.setPreviousPath('');
        userStore.logout();
        if (wasSessionExpired) (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).sessionExpired.success);
        else (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).logout.success);
        setIsLoading(false);
    }, []);
    return isLoading ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cb4cc5db45d03478$exports.Fragment), {}) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$444b3ab0cb9aec40), {
        to: "/login",
        replace: true
    });
});
var $90034d9b075807b1$export$2e2bcd8739ae039 = $90034d9b075807b1$var$Logout;




var $2xPiy = parcelRequire("2xPiy");











const $ac4967610aa7edb5$var$defaultFormData = {
    email: ''
};
const $ac4967610aa7edb5$var$RequestPasswordReset = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** State **/ const [isLoading, setIsLoading] = (0, $2xPiy.useState)(false);
    // Form values
    const [formValues, setFormValues] = (0, $2xPiy.useState)($ac4967610aa7edb5$var$defaultFormData);
    const [formErrors, setFormErrors] = (0, $2xPiy.useState)({});
    /** Methods **/ const validateForm = ()=>{
        const errors = {};
        if (!formValues.email) errors['email'] = 'Email address is required';
        if (Object.keys(errors).length) {
            setFormErrors(errors);
            return false;
        }
        return true;
    };
    const sendResetEmail = async ()=>{
        if (!validateForm()) return;
        try {
            setIsLoading(true);
            await (0, $1f30379e064ebff4$export$a81c579a392aa9d2).requestPasswordReset({
                email: formValues.email
            });
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).requestPasswordReset.success);
            navigate('/login');
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).requestPasswordReset.error);
        } finally{
            setIsLoading(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, 'Reset Password');
    }, []);
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $225251299c21678a$export$ef2184bd89960b14), {
        height: "100vh",
        rows: [
            'flex'
        ],
        columns: [
            'auto'
        ],
        areas: [
            {
                name: 'main',
                start: [
                    0,
                    0
                ],
                end: [
                    0,
                    0
                ]
            }
        ],
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d48fc541d96cd8f0$export$861edd1ccea2f746), {
            gridArea: "main",
            background: "light",
            children: [
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    justify: "center",
                    flex: "grow",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            alignSelf: "center",
                            margin: {
                                bottom: '2rem'
                            },
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b693aeeca29ae7b2$export$2e2bcd8739ae039), {
                                width: "14rem",
                                height: "3.75rem"
                            })
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $724dfb7ecf65a151$export$60332b2344f7fe41), {
                            alignSelf: "center",
                            pad: "2rem",
                            width: "28rem",
                            flex: undefined,
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $fdccc762800a972d$export$851de33184ecdac4), {
                                flex: "grow",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        margin: {
                                            bottom: '0.5rem'
                                        },
                                        align: "center",
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                            size: "xlarge",
                                            weight: 300,
                                            children: t('common:resetPassword')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        margin: {
                                            bottom: '0.5rem'
                                        },
                                        align: "center",
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                            textAlign: "center",
                                            fontFamily: "Lato, sans-serif",
                                            children: t('common:enterEmailAssociatedWithAccount')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                        children: [
                                            formErrors['email'] && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                color: "red",
                                                size: "small",
                                                children: formErrors['email']
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $168667f04da9206c$export$16e4d70cc375e707), {
                                                onEnter: ()=>sendResetEmail(),
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8c9c99ffe8765a99$export$c86715117507e8e5), {
                                                    name: "email",
                                                    type: "email",
                                                    placeholder: t('common:email'),
                                                    autoComplete: "username",
                                                    required: true,
                                                    value: formValues.email,
                                                    onChange: (e)=>setFormValues({
                                                            ...formValues,
                                                            email: e.target.value
                                                        }),
                                                    style: {
                                                        borderRadius: '0.375rem',
                                                        fontFamily: 'Lato, sans-serif'
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                        type: "submit",
                                        disabled: !formValues.email,
                                        onClick: ()=>sendResetEmail(),
                                        margin: {
                                            bottom: '1rem'
                                        },
                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            background: "accent-1",
                                            pad: {
                                                horizontal: '1rem',
                                                vertical: '0.5rem'
                                            },
                                            borderRadius: "0.5rem",
                                            children: [
                                                !isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    alignSelf: "center",
                                                    size: "1.25rem",
                                                    color: "white",
                                                    lineHeight: "1.875rem",
                                                    style: {
                                                        textTransform: 'uppercase'
                                                    },
                                                    children: t('common:resetPassword')
                                                }),
                                                isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8bec6e2e7dc53c4a$export$7f7cbe89f1eacd2), {
                                                    height: "1.875rem",
                                                    width: "1.875rem",
                                                    alignSelf: "center",
                                                    color: "white"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            direction: "row",
                            justify: "center",
                            margin: {
                                vertical: '1rem'
                            },
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                lineHeight: "1.5rem",
                                fontFamily: "Lato, sans-serif",
                                children: [
                                    t('common:alreadyHaveAccount'),
                                    ' ',
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                                        to: "/login",
                                        style: {
                                            textDecoration: 'none'
                                        },
                                        children: t('common:title')
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $605617a28ba64070$export$3210cca7a959581e), {
                    flex: "shrink"
                })
            ]
        })
    });
});
var $ac4967610aa7edb5$export$2e2bcd8739ae039 = $ac4967610aa7edb5$var$RequestPasswordReset;




var $2xPiy = parcelRequire("2xPiy");













const $fbba412005be5380$var$defaultFormData = {
    password: ''
};
const $fbba412005be5380$var$ResetPassword = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const params = (0, $62d58f5c28b15c2e$export$99eaa27ddbbb95ef)();
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const isMobile = (0, $18588a518ac6fdc7$export$2ac00d7098bf223)(screenSize);
    /** State **/ const [isLoading, setIsLoading] = (0, $2xPiy.useState)(false);
    const [isValid, setIsValid] = (0, $2xPiy.useState)(true);
    const [formValues, setFormValues] = (0, $2xPiy.useState)($fbba412005be5380$var$defaultFormData);
    const [formErrors, setFormErrors] = (0, $2xPiy.useState)({});
    /** Methods **/ const resetPassword = async ()=>{
        if (!params.token) return;
        setFormErrors({});
        const errors = {};
        if (!formValues.password) errors['password'] = 'Password is required';
        if (formValues.password && formValues.password.length < 16) errors['password'] = (0, $d0d6382a5bdf6377$export$d8bd0967cb58683).passwordMinLength;
        else if (formValues.password && !(0, $00658ccd6ec0135a$export$42dd1e93e775969e).test(formValues.password)) errors['password'] = (0, $d0d6382a5bdf6377$export$d8bd0967cb58683).passwordComplexityRequirements;
        if (Object.keys(errors).length) {
            setFormErrors(errors);
            return;
        }
        try {
            setIsLoading(true);
            await (0, $1f30379e064ebff4$export$a81c579a392aa9d2).resetPassword(params.token, {
                password: formValues.password
            });
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).resetPassword.success);
            navigate('/login');
        } catch (err) {
            const error = err;
            if (error.body?.message.toLowerCase() === 'invalid token') setIsValid(false);
            else globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).resetPassword.error);
        } finally{
            setIsLoading(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, 'Reset Password');
    }, []);
    /** Render **/ const renderErrorPage = ()=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f068601a66842d6c$export$c1faa9c8f42906a), {
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                flex: "grow",
                justify: "center",
                align: "center",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
                    flex: "shrink",
                    width: !isMobile ? '35%' : '80%',
                    margin: {
                        bottom: 'xlarge'
                    },
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                            title: "Invalid Token",
                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $11571e85aa9685ed$export$5a89edf87f611fb5), {
                                color: "brand"
                            })
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    fontFamily: "Lato, sans-serif",
                                    children: [
                                        "This token is invalid or has expired. ",
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2d2300e67aede872$export$a6c7ac8248d6e38a), {
                                            to: "/reset-password",
                                            children: "Click here"
                                        }),
                                        " to request a new token."
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        });
    const renderResetPage = ()=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $225251299c21678a$export$ef2184bd89960b14), {
            height: "100vh",
            rows: [
                'flex'
            ],
            columns: [
                'auto'
            ],
            areas: [
                {
                    name: 'main',
                    start: [
                        0,
                        0
                    ],
                    end: [
                        0,
                        0
                    ]
                }
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d48fc541d96cd8f0$export$861edd1ccea2f746), {
                gridArea: "main",
                background: "light",
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        justify: "center",
                        flex: "grow",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                alignSelf: "center",
                                margin: {
                                    bottom: '2rem'
                                },
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b693aeeca29ae7b2$export$2e2bcd8739ae039), {
                                    width: "14rem",
                                    height: "3.75rem"
                                })
                            }),
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
                                alignSelf: "center",
                                width: "32rem",
                                flex: undefined,
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $04d59a1221f4208a$export$a7fed597f4b8afd8), {
                                    noValidate: true,
                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                                        flex: "grow",
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                margin: {
                                                    bottom: '0.5rem'
                                                },
                                                align: "center",
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                    size: "xlarge",
                                                    weight: 300,
                                                    children: "Update Password"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                margin: {
                                                    bottom: '0.5rem'
                                                },
                                                align: "center",
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7dacb42a28be9c15$export$7036cd8426a1245b), {
                                                            size: "16px"
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            fontFamily: "Lato, sans-serif",
                                                            children: [
                                                                (0, $d0d6382a5bdf6377$export$d8bd0967cb58683).passwordMinLength,
                                                                " and must contain at least one uppercase letter, one lowercase letter, one number, and one special character (!@#$%^&*)"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                children: [
                                                    formErrors['password'] && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                        color: "red",
                                                        size: "small",
                                                        children: formErrors['password']
                                                    }),
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $168667f04da9206c$export$16e4d70cc375e707), {
                                                        onEnter: resetPassword,
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8c9c99ffe8765a99$export$c86715117507e8e5), {
                                                            name: "new_password",
                                                            type: "password",
                                                            placeholder: "Password",
                                                            autoComplete: "password",
                                                            required: true,
                                                            value: formValues.password,
                                                            onChange: (e)=>setFormValues({
                                                                    ...formValues,
                                                                    password: e.target.value
                                                                }),
                                                            style: {
                                                                borderRadius: '0.375rem',
                                                                fontFamily: 'Lato, sans-serif'
                                                            }
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                                type: "submit",
                                                disabled: !formValues.password,
                                                onClick: resetPassword,
                                                margin: {
                                                    bottom: '1rem'
                                                },
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                    background: "accent-1",
                                                    pad: {
                                                        horizontal: '1rem',
                                                        vertical: '0.5rem'
                                                    },
                                                    borderRadius: "0.5rem",
                                                    children: [
                                                        !isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            alignSelf: "center",
                                                            size: "1.25rem",
                                                            color: "white",
                                                            lineHeight: "1.875rem",
                                                            children: "UPDATE PASSWORD"
                                                        }),
                                                        isLoading && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8bec6e2e7dc53c4a$export$7f7cbe89f1eacd2), {
                                                            height: "1.875rem",
                                                            width: "1.875rem",
                                                            alignSelf: "center",
                                                            color: "white"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $605617a28ba64070$export$3210cca7a959581e), {
                        flex: "shrink"
                    })
                ]
            })
        });
    return isLoading ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}) : isValid ? renderResetPage() : renderErrorPage();
});
var $fbba412005be5380$export$2e2bcd8739ae039 = $fbba412005be5380$var$ResetPassword;




var $2xPiy = parcelRequire("2xPiy");






const $8f3a67a71a69506d$var$SearchPage = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const searchStore = (0, $116967e0234c3770$export$8992e2c9f8b2a805)();
    /** Computed **/ const isLoading = false;
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, 'Search');
    }, []);
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9057517707360bf5$export$9b7824917a0c851e), {
        title: "Search Results",
        pageHeader: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c61d91bfa75be0a1$export$53f1cd6809577fc5), {
            title: "Search"
        }),
        isLoading: isLoading,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
            fill: "horizontal",
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                    pad: {
                        horizontal: 'none',
                        top: 'medium'
                    },
                    gap: "medium",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            direction: "row",
                            pad: {
                                horizontal: 'medium'
                            },
                            gap: "small",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $3007114f05a3417c$export$c36d5511411110dc), {
                                    labelSize: "1rem",
                                    labelWeight: 400,
                                    fill: "horizontal"
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d8886d3505a9a12f$export$201222d15f223f41), {
                                    labelSize: "1rem",
                                    labelWeight: 400,
                                    fill: "horizontal"
                                })
                            ]
                        }),
                        !!searchStore.searchEntity && !!searchStore.searchField && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            animation: {
                                type: 'slideDown',
                                duration: 300
                            },
                            pad: {
                                horizontal: 'medium'
                            },
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ee22287e9c411205$export$4be43b7638517ea8), {
                                fill: "horizontal"
                            })
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $889e19f37a594124$export$f45fe4e6e757ea91), {
                            pad: {
                                horizontal: 'medium'
                            }
                        }),
                        !!searchStore.results && !searchStore.resultsMetadata?.total && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            pad: {
                                vertical: 'medium'
                            },
                            background: "light-6",
                            justify: "center",
                            border: {
                                side: 'top',
                                color: 'brand',
                                size: '3px'
                            },
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                alignSelf: "center",
                                size: "medium",
                                fontFamily: "Lato, sans-serif",
                                children: "No searchStore.results found."
                            })
                        }),
                        !!searchStore.results && !!searchStore.resultsMetadata?.total && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
                            children: [
                                searchStore.searchEntity === (0, $0badf5665deea2b2$export$dd8643a5f2fdbfa5).Clients && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2542f3c44047daf5$export$fb3600cebe42014a), {
                                    mode: "controlled",
                                    clients: searchStore.results,
                                    fetchClients: searchStore.search,
                                    metadata: searchStore.resultsMetadata,
                                    currentPage: searchStore.currentPage,
                                    setCurrentPage: searchStore.setCurrentPage,
                                    isLoading: searchStore.isSearching,
                                    hideHeader: true,
                                    border: {
                                        side: 'top',
                                        color: 'brand',
                                        size: '3px'
                                    },
                                    round: "0",
                                    elevation: "none"
                                }),
                                searchStore.searchEntity === (0, $0badf5665deea2b2$export$dd8643a5f2fdbfa5).Facilities && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $93b56b8d4d0da6dd$export$9f76c3e28857a02f), {
                                    mode: "controlled",
                                    clientId: NaN,
                                    facilities: searchStore.results,
                                    fetchFacilities: searchStore.search,
                                    metadata: searchStore.resultsMetadata,
                                    currentPage: searchStore.currentPage,
                                    setCurrentPage: searchStore.setCurrentPage,
                                    isLoading: searchStore.isSearching,
                                    hideHeader: true,
                                    boxProps: {
                                        border: {
                                            side: 'top',
                                            color: 'brand',
                                            size: '3px'
                                        },
                                        borderRadius: '0',
                                        elevation: 'none'
                                    }
                                }),
                                searchStore.searchEntity === (0, $0badf5665deea2b2$export$dd8643a5f2fdbfa5).Equipment && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $5c08d54bb3238b41$export$ff2589847bbc6a39), {
                                    mode: "controlled",
                                    clientId: NaN,
                                    facilityId: NaN,
                                    equipment: searchStore.results,
                                    fetchEquipment: searchStore.search,
                                    metadata: searchStore.resultsMetadata,
                                    currentPage: searchStore.currentPage,
                                    setCurrentPage: searchStore.setCurrentPage,
                                    isLoading: searchStore.isSearching,
                                    hideHeader: true,
                                    border: {
                                        side: 'top',
                                        color: 'brand',
                                        size: '3px'
                                    },
                                    round: "0",
                                    elevation: "none"
                                }),
                                searchStore.searchEntity === (0, $0badf5665deea2b2$export$dd8643a5f2fdbfa5).Users && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b8d120ccf98e8417$export$21b6143e6c635cfa), {
                                    mode: "controlled",
                                    users: searchStore.results,
                                    fetchUsers: searchStore.search,
                                    metadata: searchStore.resultsMetadata,
                                    currentPage: searchStore.currentPage,
                                    setCurrentPage: searchStore.setCurrentPage,
                                    isLoading: searchStore.isSearching,
                                    hideHeader: true,
                                    boxProps: {
                                        border: {
                                            side: 'top',
                                            color: 'brand',
                                            size: '3px'
                                        },
                                        borderRadius: '0',
                                        elevation: 'none'
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
});
var $8f3a67a71a69506d$export$2e2bcd8739ae039 = $8f3a67a71a69506d$var$SearchPage;






var $2xPiy = parcelRequire("2xPiy");















const $c4eb1774c938025c$export$b5faf749c56418c7 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const { search: search } = (0, $62d58f5c28b15c2e$export$45d76561a5302f2b)();
    const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const queryClient = (0, $bccbe1b43ff3d0cc$export$22e77b9572c4fded)();
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const queryParams = (0, $00658ccd6ec0135a$export$e2de15bbd9edf9c6)(search);
    const params = (0, $62d58f5c28b15c2e$export$99eaa27ddbbb95ef)();
    const clientId = (0, $2xPiy.useMemo)(()=>parseInt(queryParams.client_id ?? params.client_id), [
        queryParams,
        params
    ]);
    const facilityId = (0, $2xPiy.useMemo)(()=>parseInt(queryParams.facility_id ?? params.facility_id), [
        queryParams,
        params
    ]);
    const tooltips = (0, $d597772cdbe12609$export$4713da6aa4410043)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /** Refs **/ const defaultFormData = (0, $2xPiy.useRef)({
        name: '',
        email: '',
        phone: '',
        is_email_verified: true,
        role_id: NaN,
        client_ids: [],
        facility_ids: [],
        add_facility_ids: [],
        remove_facility_ids: []
    });
    /** State **/ const [isCreating, setIsCreating] = (0, $2xPiy.useState)(false);
    const [isPhoneFocused, setIsPhoneFocused] = (0, $2xPiy.useState)(false);
    const [breadcrumbNavItems, setBreadcrumbNavItems] = (0, $2xPiy.useState)([]);
    const [facilityOptions, setFacilityOptions] = (0, $2xPiy.useState)();
    const [showMultipleClients, setShowMultipleClients] = (0, $2xPiy.useState)(false);
    const [formValues, setFormValues] = (0, $2xPiy.useState)({
        ...defaultFormData.current,
        client_ids: clientId ? [
            clientId
        ] : [],
        role_id: facilityId ? (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FacilityAdmin : clientId ? (0, $a65473e9746b33bb$export$2cb4a31baf73b247).ClientAdmin : (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FuseAdmin,
        facility_ids: facilityId ? [
            facilityId
        ] : []
    });
    const [formErrors, setFormErrors] = (0, $2xPiy.useState)({});
    /** Computed **/ const isMobile = (0, $18588a518ac6fdc7$export$2ac00d7098bf223)(screenSize);
    const isLoading = !(breadcrumbNavItems && facilityOptions);
    const filteredRoleIdOptions = (0, $2xPiy.useMemo)(()=>{
        // filter out Sales Rep role for the time being
        const options = (0, $a65473e9746b33bb$export$2db3bb45591f9fdc).filter((option)=>option.value !== (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FuseSalesRep);
        return userStore.isClientUser ? options.filter((option)=>(0, $a65473e9746b33bb$export$39d571c105d2314f).includes(option.value)) : options;
    }, [
        userStore.isClientUser,
        (0, $a65473e9746b33bb$export$2db3bb45591f9fdc)
    ]);
    /** Methods **/ const updateFormValue = (key, value)=>{
        if (key === 'role_id' && value === (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FacilityAdmin && formValues.client_ids.length > 1) {
            setFormValues({
                ...formValues,
                [key]: value,
                client_ids: formValues.client_ids.slice(0, 1)
            });
            setShowMultipleClients(false);
        } else setFormValues({
            ...formValues,
            [key]: value
        });
        if (formErrors[key]) {
            const updatedErrors = {
                ...formErrors
            };
            updatedErrors[key] = '';
            setFormErrors(updatedErrors);
        }
    };
    const formatPhoneNumber = (value)=>{
        const [mainNumber, ...extensionParts] = value.toLowerCase().split(/(ext|x)/i);
        const extension = extensionParts.join('');
        if (mainNumber.match(/[a-zA-Z]/)) {
            const phoneMatch = mainNumber.match(/^\(\d{3}\) \d{3}-\d{4}/);
            return phoneMatch ? phoneMatch[0] + value.slice(phoneMatch[0].length) : value;
        }
        const digitsOnly = mainNumber.replace(/[^\d+]/g, '');
        if (!digitsOnly) return '';
        if (digitsOnly.startsWith('+')) return `+${digitsOnly.slice(1)}${extension}`;
        let formatted = '';
        if (digitsOnly.length >= 10) {
            formatted = `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6, 10)}`;
            if (digitsOnly.length > 10) formatted += ` ${digitsOnly.slice(10)}`;
            else if (mainNumber.endsWith(' ')) formatted += ' ';
        } else if (digitsOnly.length > 6) formatted = `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6)}`;
        else if (digitsOnly.length > 3) formatted = `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3)}`;
        else formatted = `(${digitsOnly}`;
        return formatted + extension;
    };
    const fetchPageData = async (clientId)=>{
        try {
            const client = userStore.isFacilityUser ? userStore.user?.clients.find((client)=>client.id === clientId) : await (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).get({
                id: clientId
            });
            const facilities = userStore.isFacilityUser ? userStore.user?.facilities : client?.facilities;
            if (!client || !facilities) return;
            setBreadcrumbNavItems([
                {
                    name: 'Clients',
                    link: userStore.isInternalUser ? '/clients' : undefined
                },
                {
                    name: client.name,
                    link: !userStore.isFacilityUser ? `/clients/${client.id}` : undefined
                },
                {
                    name: 'Users',
                    link: userStore.isExternalUser && client ? `/clients/${client.id}/users` : undefined
                }
            ]);
            setFacilityOptions(facilities.map((facility)=>{
                return {
                    label: (0, $00658ccd6ec0135a$export$426d0e35b67696d3)({
                        ...facility,
                        address_region: globalStore.getRegionById(facility.address_region_id)
                    }, true),
                    value: facility.id
                };
            }));
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).fetchClient.error);
        }
    };
    const createUser = async ()=>{
        try {
            setIsCreating(true);
            // Validate
            const errors = {};
            if (!formValues.name) errors['name'] = 'Name is required';
            else if (formValues.name.length > 50) errors['name'] = 'Name cannot be more than 50 characters';
            if (!formValues.email) errors['email'] = 'Email is required';
            else if (!(0, $2e4d07611f552ce8$export$371e338370561054)(formValues.email)) errors['email'] = 'Must be a valid email address';
            else if (formValues.email.length > 100) errors['email'] = 'Email cannot be more than 100 characters';
            if (formValues.phone && formValues.phone.length > 50) errors['phone'] = 'Phone number cannot be more than 50 characters';
            if (!formValues.role_id) errors['role_id'] = 'Role is required';
            if ((0, $a65473e9746b33bb$export$39d571c105d2314f).includes(formValues.role_id) && (!formValues.client_ids || formValues.client_ids.length === 0 || !formValues.client_ids[0])) errors['client_ids'] = 'Client is required';
            if (formValues.role_id === (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FacilityAdmin && !formValues.facility_ids.length) errors['facility_ids'] = 'Must select at least one Facility';
            if (Object.keys(errors).length) {
                setFormErrors(errors);
                (0, $05d5739209a21833$export$b410431fab84fa58).error((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).formValidation.requiredFields);
                return;
            }
            const newUser = {
                name: formValues.name,
                email: formValues.email,
                phone: formValues.phone || null,
                role_id: formValues.role_id,
                is_email_verified: formValues.is_email_verified
            };
            if ((0, $a65473e9746b33bb$export$39d571c105d2314f).includes(formValues.role_id) && formValues.client_ids.length > 0) newUser.client_ids = formValues.client_ids.filter((id)=>!isNaN(id));
            if (formValues.role_id === (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FacilityAdmin) newUser.facility_ids = formValues.facility_ids;
            const promises = [
                (0, $1f30379e064ebff4$export$a81c579a392aa9d2).create(newUser)
            ]; // eslint-disable-line @typescript-eslint/no-explicit-any
            const [user] = await Promise.all(promises);
            queryClient.invalidateQueries({
                queryKey: [
                    'users'
                ]
            });
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).createUser.success);
            navigate(`/users/${user.id}`);
        } catch (err) {
            const apiErrors = err.body?.errors || [];
            if (apiErrors.length > 0) {
                const errors = {
                    ...formErrors
                };
                for (const apiError of apiErrors){
                    const { field: field, rule: rule } = apiError;
                    if (rule === 'unique') {
                        if (field === 'email') errors[field] = 'This email address is already in use';
                        else errors[field] = `This ${field} is already in use`;
                    }
                }
                setFormErrors(errors);
            } else globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).createUser.error);
        } finally{
            setIsCreating(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, 'Add User');
    }, []);
    (0, $2xPiy.useEffect)(()=>{
        if (filteredRoleIdOptions && !formValues.role_id) setFormValues({
            ...formValues,
            role_id: filteredRoleIdOptions[0]?.value
        });
    }, [
        filteredRoleIdOptions,
        formValues.role_id
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (formValues.client_ids && formValues.client_ids[0]) fetchPageData(formValues.client_ids[0]);
        else {
            setBreadcrumbNavItems([
                {
                    name: 'Users',
                    link: userStore.isInternalUser ? '/users' : undefined
                }
            ]);
            setFacilityOptions([]);
        }
    }, [
        formValues.client_ids
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $3d99c6153124a6ba$export$7234abc5d81adb58), {
        title: t('user:addUser'),
        breadcrumbNav: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e7dd63b10d4904e9$export$988959db72b892c3), {
            previousPages: breadcrumbNavItems,
            currentPageName: "Add User"
        }),
        isLoading: isLoading,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $98b6153ed086d9bd$export$11154b700737b45e), {
            title: t('user:userInformation'),
            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7dacb42a28be9c15$export$7036cd8426a1245b), {
                width: "24px",
                height: "24px",
                color: "brand"
            }),
            isLoading: isLoading || isCreating,
            onSubmit: createUser,
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $04d59a1221f4208a$export$a7fed597f4b8afd8), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                    direction: isMobile ? 'column' : 'row',
                    gap: "1rem",
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            fill: "horizontal",
                            gap: "1rem",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                title: t('user:contactInformation'),
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        name: "user_name",
                                        label: t('common:name'),
                                        maxLength: 50,
                                        value: formValues.name,
                                        setValue: (value)=>updateFormValue('name', value),
                                        error: formErrors['name'],
                                        onSubmit: createUser,
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        name: "user_email",
                                        label: t('user:email'),
                                        maxLength: 100,
                                        value: formValues.email,
                                        setValue: (value)=>updateFormValue('email', value),
                                        error: formErrors['email'],
                                        onSubmit: createUser,
                                        type: "email",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        name: "user_phone",
                                        label: t('user:phone'),
                                        maxLength: 50,
                                        value: formValues.phone,
                                        setValue: (value)=>updateFormValue('phone', formatPhoneNumber(value)),
                                        error: formErrors['phone'],
                                        onSubmit: createUser,
                                        placeholder: isPhoneFocused ? '(555) 555-5555' : '',
                                        onFocus: ()=>setIsPhoneFocused(true),
                                        onBlur: ()=>setIsPhoneFocused(false)
                                    })
                                ]
                            })
                        }),
                        isMobile ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                            margin: "0.5rem"
                        }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                            direction: "vertical",
                            margin: "3rem"
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                            fill: "horizontal",
                            gap: "1rem",
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                title: t('user:userRole'),
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                        name: "role_id",
                                        label: t('user:userRole'),
                                        value: formValues.role_id,
                                        setValue: (value)=>updateFormValue('role_id', value),
                                        error: formErrors['role_id'],
                                        options: filteredRoleIdOptions ?? [],
                                        required: true
                                    }),
                                    (0, $a65473e9746b33bb$export$39d571c105d2314f).includes(formValues.role_id) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                direction: "row",
                                                align: "center",
                                                gap: "small",
                                                children: [
                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                        flex: "grow",
                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $209e44abb3ffd31f$export$c57133fe35f19a3e), {
                                                            selectedClientId: formValues.client_ids[0],
                                                            setSelectedClientId: (value)=>{
                                                                if (value) {
                                                                    const updatedClientIds = [
                                                                        ...formValues.client_ids
                                                                    ];
                                                                    updatedClientIds[0] = value;
                                                                    updateFormValue('client_ids', updatedClientIds);
                                                                }
                                                            },
                                                            error: formErrors['client_ids'],
                                                            disabled: userStore.isExternalUser,
                                                            required: true,
                                                            excludeClientIds: formValues.client_ids.filter((id)=>id !== formValues.client_ids[0])
                                                        })
                                                    }),
                                                    formValues.client_ids[0] && formValues.role_id !== (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FacilityAdmin && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b354176c7fc1b147$export$d0265b2c425512d6), {
                                                            size: "medium"
                                                        }),
                                                        onClick: ()=>{
                                                            const updatedClientIds = [
                                                                ...formValues.client_ids
                                                            ];
                                                            updatedClientIds.push(undefined);
                                                            updateFormValue('client_ids', updatedClientIds);
                                                            setShowMultipleClients(true);
                                                        },
                                                        plain: true,
                                                        disabled: userStore.isExternalUser,
                                                        tip: tooltips.addAnotherCompany
                                                    })
                                                ]
                                            }),
                                            showMultipleClients && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                margin: {
                                                    top: '1rem'
                                                },
                                                gap: "1rem",
                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                                    title: "Additional Companies",
                                                    children: (formValues.client_ids.slice(1).length > 0 ? formValues.client_ids.slice(1) : [
                                                        NaN
                                                    ]).map((clientId, index)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                            direction: "row",
                                                            align: "center",
                                                            gap: "small",
                                                            children: [
                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                    flex: "grow",
                                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $209e44abb3ffd31f$export$c57133fe35f19a3e), {
                                                                        name: `selected_client_${index + 2}`,
                                                                        label: `Company ${index + 2}`,
                                                                        selectedClientId: clientId,
                                                                        setSelectedClientId: (value)=>{
                                                                            if (value) {
                                                                                const updatedClientIds = [
                                                                                    ...formValues.client_ids
                                                                                ];
                                                                                updatedClientIds[index + 1] = value;
                                                                                updateFormValue('client_ids', updatedClientIds);
                                                                            }
                                                                        },
                                                                        error: formErrors['client_ids'],
                                                                        disabled: userStore.isExternalUser,
                                                                        excludeClientIds: formValues.client_ids.filter((id)=>id !== clientId)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                                                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c1da19823027de53$export$f39c2d165cd861fe), {}),
                                                                    onClick: ()=>{
                                                                        const updatedClientIds = [
                                                                            ...formValues.client_ids
                                                                        ];
                                                                        updatedClientIds.splice(index + 1, 1);
                                                                        updateFormValue('client_ids', updatedClientIds);
                                                                        if (updatedClientIds.length <= 1) setShowMultipleClients(false);
                                                                    },
                                                                    plain: true,
                                                                    disabled: userStore.isExternalUser
                                                                })
                                                            ]
                                                        }, `client-${index + 1}`))
                                                })
                                            })
                                        ]
                                    }),
                                    formValues.role_id === (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FacilityAdmin && !!facilityOptions?.length && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                        name: "facility_ids",
                                        multiple: true,
                                        label: t('common:facilities'),
                                        values: formValues.facility_ids,
                                        setValues: (value)=>updateFormValue('facility_ids', value),
                                        options: facilityOptions,
                                        error: formErrors['facility_ids'],
                                        required: true
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
});




var $2xPiy = parcelRequire("2xPiy");











const $0c15b61117139606$export$e396b9722e5a1ef5 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    /* Context */ const { user: currentUser, isAdminUser: isAdminUser, isInternalUser: isInternalUser, isFacilityUser: isFacilityUser } = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const { handleApiError: handleApiError } = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const params = (0, $62d58f5c28b15c2e$export$99eaa27ddbbb95ef)();
    const clientId = (0, $2xPiy.useMemo)(()=>parseInt(params.client_id ?? ''), [
        params.client_id
    ]);
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /* State */ const [clientName, setClientName] = (0, $2xPiy.useState)('');
    /* Computed */ const isLoading = clientId ? !clientName : false;
    /* Memos */ const addButtonUrl = (0, $2xPiy.useMemo)(()=>clientId ? `/clients/${clientId}/users/create` : '/users/create', [
        clientId
    ]);
    const breadcrumbNav = (0, $2xPiy.useMemo)(()=>clientId && clientName ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e7dd63b10d4904e9$export$988959db72b892c3), {
            previousPages: [
                {
                    name: 'Clients',
                    link: isInternalUser ? '/clients' : undefined
                },
                {
                    name: clientName,
                    link: !isFacilityUser ? `/clients/${clientId}` : undefined
                }
            ],
            currentPageName: "Users"
        }) : undefined, [
        clientId,
        clientName,
        isInternalUser,
        isFacilityUser
    ]);
    /* Methods */ const fetchPageData = (0, $2xPiy.useCallback)(async (clientId)=>{
        if (!currentUser) return;
        if (isFacilityUser) setClientName(currentUser.clients.find((client)=>client.id === clientId)?.name ?? '');
        else try {
            const client = await (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).get({
                id: clientId
            });
            setClientName(client.name);
        } catch (err) {
            handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).listUsers.error);
        }
    }, [
        currentUser,
        isFacilityUser
    ]);
    /* Effects */ (0, $2xPiy.useEffect)(()=>{
        document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, 'Users');
    }, []);
    (0, $2xPiy.useEffect)(()=>{
        if (clientId && !clientName) fetchPageData(clientId);
    }, [
        clientId,
        clientName
    ]);
    /* Product Tour */ (0, $ea039e16ca87cc85$export$28f524c77ee81092)({
        tourName: 'users-tour',
        steps: (0, $3d0c747b3f894c98$export$869d9546d6e0f9ad),
        autoStart: true,
        showOnce: true
    });
    /* Render */ return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9057517707360bf5$export$9b7824917a0c851e), {
        title: t('user:users'),
        breadcrumbNav: breadcrumbNav,
        pageHeader: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c61d91bfa75be0a1$export$53f1cd6809577fc5), {
            title: t('user:users'),
            showAddButton: isAdminUser && !isFacilityUser,
            addButtonLabel: t('user:addUser'),
            addButtonUrl: addButtonUrl,
            dataTour: "add-user-button"
        }),
        isLoading: isLoading,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b8d120ccf98e8417$export$21b6143e6c635cfa), {
            showSearchInput: true,
            showFilters: true,
            clientId: clientId,
            standalone: true,
            "data-tour": "users-list"
        })
    });
});




var $2xPiy = parcelRequire("2xPiy");






var $2xPiy = parcelRequire("2xPiy");

function $6b8bc0905d64141c$var$_extends() {
    return $6b8bc0905d64141c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6b8bc0905d64141c$var$_extends.apply(null, arguments);
}
var $6b8bc0905d64141c$export$92ce62e1201c4fc0 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $6b8bc0905d64141c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Copy"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M9 15h8-8zm0-4h10H9zm0-4h4-4zm7-6v6h6M6 5H2v18h16v-4m4 0H6V1h11l5 5v13z"
    }));
});
$6b8bc0905d64141c$export$92ce62e1201c4fc0.displayName = 'Copy';


var $2xPiy = parcelRequire("2xPiy");

function $9dbd97790657d539$var$_extends() {
    return $9dbd97790657d539$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9dbd97790657d539$var$_extends.apply(null, arguments);
}
var $9dbd97790657d539$export$5b9db7ce80343746 = /*#__PURE__*/ (0, $2xPiy.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement((0, $896826bebe64fe04$export$7c8f159da0dc916), $9dbd97790657d539$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Lock"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M19 23V11H5v12h14zm-7-8v4m5-8V7c0-3 0-6-5-6S7 4 7 7v4"
    }));
});
$9dbd97790657d539$export$5b9db7ce80343746.displayName = 'Lock';














const $1f80e0333df289c4$export$1c36a2cc17727340 = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    /* Context */ const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const clientStore = (0, $116967e0234c3770$export$3b47afa599c78f61)();
    const navigate = (0, $62d58f5c28b15c2e$export$9770f232ac06a008)();
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    const tooltips = (0, $d597772cdbe12609$export$4713da6aa4410043)();
    const queryClient = (0, $bccbe1b43ff3d0cc$export$22e77b9572c4fded)();
    const { t: t } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    /* Query Params */ const params = (0, $62d58f5c28b15c2e$export$99eaa27ddbbb95ef)();
    const userId = (0, $18588a518ac6fdc7$export$1bc9b22fe8fe3ea9)(params.user_id);
    const clientId = (0, $18588a518ac6fdc7$export$1bc9b22fe8fe3ea9)(params.client_id);
    /* Refs */ const defaultFormData = (0, $2xPiy.useRef)({
        name: '',
        email: '',
        phone: '',
        role_id: NaN,
        is_active: false,
        is_email_verified: true,
        client_ids: [],
        facility_ids: [],
        add_facility_ids: [],
        remove_facility_ids: []
    });
    /* State */ const [isLoading, setIsLoading] = (0, $2xPiy.useState)(true);
    const [isLoadingFacilities, setIsLoadingFacilities] = (0, $2xPiy.useState)(false);
    const [isLoadingPasswordResetUrl, setIsLoadingPasswordResetUrl] = (0, $2xPiy.useState)(false);
    const [isUpdating, setIsUpdating] = (0, $2xPiy.useState)(false);
    const [isUpdatingPassword, setIsUpdatingPassword] = (0, $2xPiy.useState)(false);
    const [hasChanges, setHasChanges] = (0, $2xPiy.useState)(false);
    const [user, setUser] = (0, $2xPiy.useState)();
    const [facilityOptions, setFacilityOptions] = (0, $2xPiy.useState)();
    const [breadcrumbNavItems, setBreadcrumbNavItems] = (0, $2xPiy.useState)([]);
    const [isChangingEmail, setIsChangingEmail] = (0, $2xPiy.useState)(false);
    const [passwordResetUrl, setPasswordResetUrl] = (0, $2xPiy.useState)('');
    const [isInvalidParams, setIsInvalidParams] = (0, $2xPiy.useState)(false);
    const [isPhoneFocused, setIsPhoneFocused] = (0, $2xPiy.useState)(false);
    const [showMultipleClients, setShowMultipleClients] = (0, $2xPiy.useState)(false);
    const [lastAdminWarning, setLastAdminWarning] = (0, $2xPiy.useState)(null);
    // Form Values
    const [formValues, setFormValues] = (0, $2xPiy.useState)(defaultFormData.current);
    const [originalFormValues, setOriginalFormValues] = (0, $2xPiy.useState)(defaultFormData.current);
    const [formErrors, setFormErrors] = (0, $2xPiy.useState)({});
    // Password Values
    const [oldPassword, setOldPassword] = (0, $2xPiy.useState)('');
    const [newPassword, setNewPassword] = (0, $2xPiy.useState)('');
    const [confirmPassword, setConfirmPassword] = (0, $2xPiy.useState)('');
    /* Computed */ const isMobile = (0, $18588a518ac6fdc7$export$2ac00d7098bf223)(screenSize);
    const isOwnUser = userStore.user?.id === userId;
    const ownClient = userStore.isExternalUser && clientId === clientStore.activeClientId ? clientStore.activeClient : undefined;
    const isMultiClientUser = (user?.clients.length ?? 0) > 1;
    const currentUserCanView = isOwnUser || userStore.isInternalUser || userStore.isClientAdmin && !!ownClient;
    const currentUserCanEdit = isOwnUser || userStore.isFuseAdmin || userStore.isClientAdmin && !!ownClient;
    const filteredRoleIdOptions = (0, $2xPiy.useMemo)(()=>{
        if (!user) return;
        // filter out Sales Rep role for the time being
        const options = (0, $a65473e9746b33bb$export$2db3bb45591f9fdc).filter((option)=>option.value !== (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FuseSalesRep);
        if ((user.clients.length > 1 || formValues.client_ids.length > 1) && !isOwnUser) return options.filter((option)=>option.value === (0, $a65473e9746b33bb$export$2cb4a31baf73b247).ClientAdmin);
        else if (userStore.isFuseAdmin) {
            if ((0, $a65473e9746b33bb$export$5d277a5d95a5046e).includes(user.role.id)) return options.filter((option)=>(0, $a65473e9746b33bb$export$5d277a5d95a5046e).includes(option.value));
            else return options.filter((option)=>(0, $a65473e9746b33bb$export$39d571c105d2314f).includes(option.value));
        } else if (userStore.isExternalUser) return options.filter((option)=>(0, $a65473e9746b33bb$export$39d571c105d2314f).includes(option.value));
    }, [
        user,
        userStore.isFuseAdmin,
        userStore.isExternalUser,
        (0, $a65473e9746b33bb$export$2db3bb45591f9fdc),
        formValues.client_ids.length
    ]);
    /* Methods */ const removeClientAtIndex = (index)=>{
        const updatedClientIds = [
            ...formValues.client_ids
        ];
        updatedClientIds.splice(index + 1, 1);
        updateFormValue('client_ids', updatedClientIds);
        if (updatedClientIds.length <= 1) setShowMultipleClients(false);
    };
    const checkLastAdminAndProceed = async (clientIdToCheck, onConfirm)=>{
        const isSavedClient = user?.clients.some((c)=>c.id === clientIdToCheck);
        if (!isSavedClient || formValues.role_id !== (0, $a65473e9746b33bb$export$2cb4a31baf73b247).ClientAdmin) {
            onConfirm();
            return;
        }
        try {
            const { data: data } = await (0, $5b927e2d9307efbc$export$15fb21390f08bb4c).listClientUsers({
                id: clientIdToCheck,
                role_id: (0, $a65473e9746b33bb$export$2cb4a31baf73b247).ClientAdmin,
                is_active: true
            });
            const isCurrentUserAdmin = data.some((u)=>u.id === userId);
            const otherAdminCount = data.filter((u)=>u.id !== userId).length;
            if (isCurrentUserAdmin && otherAdminCount === 0) setLastAdminWarning({
                clientId: clientIdToCheck,
                onConfirm: onConfirm
            });
            else onConfirm();
        } catch  {
            onConfirm();
        }
    };
    const updateFormValue = (key, value)=>{
        const newFormValues = {
            ...formValues,
            [key]: value
        };
        setFormValues(newFormValues);
        const changesExist = Object.keys(newFormValues).some((k)=>JSON.stringify(newFormValues[k]) !== JSON.stringify(originalFormValues[k]));
        setHasChanges(changesExist);
        if (formErrors[key]) setFormErrors((prev)=>({
                ...prev,
                [key]: ''
            }));
    };
    const copyToClipboard = async (text)=>{
        try {
            await navigator.clipboard.writeText(text);
        } catch (err) {
            console.warn("Couldn't copy to clipboard");
        }
    };
    const formatPhoneNumber = (value)=>{
        const [mainNumber, ...extensionParts] = value.toLowerCase().split(/(ext|x)/i);
        const extension = extensionParts.join('');
        if (mainNumber.match(/[a-zA-Z]/)) {
            const phoneMatch = mainNumber.match(/^\(\d{3}\) \d{3}-\d{4}/);
            return phoneMatch ? phoneMatch[0] + value.slice(phoneMatch[0].length) : value;
        }
        const digitsOnly = mainNumber.replace(/[^\d+]/g, '');
        if (!digitsOnly) return '';
        if (digitsOnly.startsWith('+')) return `+${digitsOnly.slice(1)}${extension}`;
        let formatted = '';
        if (digitsOnly.length >= 10) {
            formatted = `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6, 10)}`;
            if (digitsOnly.length > 10) formatted += ` ${digitsOnly.slice(10)}`;
            else if (mainNumber.endsWith(' ')) formatted += ' ';
        } else if (digitsOnly.length > 6) formatted = `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6)}`;
        else if (digitsOnly.length > 3) formatted = `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3)}`;
        else formatted = `(${digitsOnly}`;
        return formatted + extension;
    };
    const fetchPageData = async (userId)=>{
        try {
            const user = await (0, $1f30379e064ebff4$export$a81c579a392aa9d2).get({
                id: userId
            });
            if (!isOwnUser && !Number.isNaN(clientId) && !user.clients.some((c)=>c.id === clientId)) {
                setIsInvalidParams(true);
                return;
            }
            setUser(user);
            const userValues = {
                ...formValues,
                name: user.name,
                email: user.email,
                phone: user.phone ?? '',
                is_active: user.is_active,
                role_id: user.role.id
            };
            const client = userStore.isExternalUser ? clientStore.activeClient : user.clients?.[0];
            userValues.client_ids = user.clients.map((c)=>c.id);
            userValues.facility_ids = user.facilities.map((f)=>f.id);
            setFormValues(userValues);
            setOriginalFormValues(userValues);
            const navItems = client ? [
                {
                    name: 'Clients',
                    link: userStore.isInternalUser ? '/clients' : undefined
                },
                {
                    name: client.name,
                    link: !userStore.isFacilityUser ? `/clients/${client?.id}` : undefined
                },
                {
                    name: 'Users',
                    link: !userStore.isFacilityAdmin ? `/clients/${client.id}/users` : undefined
                }
            ] : [
                {
                    name: 'Users',
                    link: '/users'
                }
            ];
            setBreadcrumbNavItems(navItems);
            if (client) await fetchFacilityOptions(client.id);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).fetchUser.error);
        }
    };
    const fetchFacilityOptions = async (clientId)=>{
        if (isLoadingFacilities) return;
        try {
            setIsLoadingFacilities(true);
            const { data: facilities } = await (0, $2f95a0926656d8e2$export$c270777027a9c841).list({
                client_id: clientId
            });
            setFacilityOptions((facilities ?? []).map((facility)=>({
                    label: (0, $00658ccd6ec0135a$export$426d0e35b67696d3)(facility),
                    value: facility.id
                })));
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).fetchUser.error);
        } finally{
            setIsLoadingFacilities(false);
        }
    };
    const updateUser = async ()=>{
        if (!user || !user.id || !hasChanges) return;
        const errors = {};
        if (!formValues.name) errors['name'] = 'Name is required';
        else if (formValues.name.length > 50) errors['name'] = 'Name cannot be more than 50 characters';
        if (!formValues.email) errors['email'] = 'Email is required';
        else if (!(0, $2e4d07611f552ce8$export$371e338370561054)(formValues.email)) errors['email'] = 'Must be a valid email address';
        else if (formValues.email.length > 100) errors['email'] = 'Email cannot be more than 100 characters';
        if (formValues.phone && formValues.phone.length > 50) errors['phone'] = 'Phone number cannot be more than 50 characters';
        if (!formValues['role_id']) errors['role_id'] = 'Role is required';
        if ((0, $a65473e9746b33bb$export$39d571c105d2314f).includes(formValues.role_id) && (!formValues.client_ids || formValues.client_ids.length === 0)) errors['client_ids'] = 'Client is required';
        if (formValues.role_id === (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FacilityAdmin && !formValues.facility_ids.length) errors['facility_ids'] = 'Must select at least one Facility';
        if (Object.keys(errors).length) {
            setFormErrors(errors);
            return;
        }
        const updatePromises = []; // eslint-disable-line @typescript-eslint/no-explicit-any
        const updatedUser = {
            name: formValues.name,
            phone: formValues.phone || null
        };
        if ((userStore.isFuseAdmin || userStore.isClientAdmin && !!ownClient) && !isOwnUser) updatedUser.role_id = formValues.role_id;
        if (userStore.isFuseAdmin) {
            updatedUser.is_active = formValues.is_active;
            updatedUser.is_email_verified = formValues.is_email_verified;
        }
        if ((0, $a65473e9746b33bb$export$39d571c105d2314f).includes(formValues.role_id) && userStore.isFuseAdmin) {
            const newClientIds = formValues.client_ids.filter((client_id)=>!user.clients.find(({ id: id })=>id === client_id));
            if (newClientIds.length) updatedUser.add_client_ids = newClientIds;
            const oldClientIds = user.clients.filter(({ id: id })=>!formValues.client_ids.includes(id)).map((client)=>client.id);
            if (oldClientIds.length) updatedUser.remove_client_ids = oldClientIds;
        }
        // Facility Users
        if (formValues.role_id === (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FacilityAdmin) {
            const newFacilityIds = formValues.facility_ids.filter((facility_id)=>!user.facilities.find(({ id: id })=>id === facility_id));
            if (newFacilityIds.length) updatedUser.add_facility_ids = newFacilityIds;
            const oldFacilityIds = user.facilities.filter(({ id: id })=>!formValues.facility_ids.includes(id)).map((facility)=>facility.id);
            if (oldFacilityIds.length) updatedUser.remove_facility_ids = oldFacilityIds;
        }
        updatePromises.push((0, $1f30379e064ebff4$export$a81c579a392aa9d2).update(userId, updatedUser));
        // Update Email
        if (formValues.email !== user.email) {
            const updatedEmail = {
                email: formValues.email
            };
            updatePromises.push((0, $1f30379e064ebff4$export$a81c579a392aa9d2).updateEmail(userId, updatedEmail));
        }
        try {
            setIsUpdating(true);
            await Promise.all(updatePromises);
            queryClient.invalidateQueries({
                queryKey: [
                    'users'
                ]
            });
            setFormErrors({});
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updateUser.success);
            setOriginalFormValues({
                ...formValues
            });
            setHasChanges(false);
        } catch (error) {
            const err = error;
            const errors = err.body?.errors ?? [];
            const uniqueEmailError = errors.find((e)=>e.field === 'email' && e.rule === 'unique');
            if (uniqueEmailError) setFormErrors((prev)=>({
                    ...prev,
                    email: (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updateUser.error(err)
                }));
            else globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updateUser.error);
        } finally{
            setIsUpdating(false);
        }
    };
    const getPasswordResetUrl = async (userId)=>{
        if (isLoadingPasswordResetUrl) return;
        try {
            setIsLoadingPasswordResetUrl(true);
            const { password_reset_url: password_reset_url } = await (0, $1f30379e064ebff4$export$a81c579a392aa9d2).generatePasswordResetUrl(userId);
            setPasswordResetUrl(password_reset_url);
        } catch (err) {
            globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updateUser.error);
        } finally{
            setIsLoadingPasswordResetUrl(false);
        }
    };
    const updatePassword = async ()=>{
        if (!userId) return;
        const errors = {};
        if (!oldPassword) errors['old_password'] = (0, $d0d6382a5bdf6377$export$d8bd0967cb58683).notCurrentPassword;
        if (newPassword && !confirmPassword) errors['confirm_password'] = (0, $d0d6382a5bdf6377$export$d8bd0967cb58683).passwordNotConfirmed;
        else if (!newPassword && confirmPassword) errors['new_password'] = (0, $d0d6382a5bdf6377$export$d8bd0967cb58683).passwordNotEntered;
        if (newPassword && newPassword.length < 16) errors['new_password'] = (0, $d0d6382a5bdf6377$export$d8bd0967cb58683).passwordMinLength;
        else if (newPassword && !(0, $00658ccd6ec0135a$export$42dd1e93e775969e).test(newPassword)) errors['new_password'] = (0, $d0d6382a5bdf6377$export$d8bd0967cb58683).passwordComplexityRequirements;
        else if (newPassword !== confirmPassword) errors['confirm_password'] = (0, $d0d6382a5bdf6377$export$d8bd0967cb58683).passwordsNotMatch;
        if (Object.keys(errors).length) {
            setFormErrors(errors);
            return;
        }
        try {
            setIsUpdatingPassword(true);
            await (0, $1f30379e064ebff4$export$a81c579a392aa9d2).updatePassword(userId, {
                old_password: oldPassword,
                new_password: newPassword
            });
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updatePassword.success);
            setOldPassword('');
            setNewPassword('');
            setConfirmPassword('');
            setFormErrors({
                ...formErrors,
                old_password: '',
                new_password: '',
                confirm_password: ''
            });
        } catch (error) {
            const err = error;
            switch(err.status){
                case 401:
                    formErrors['old_password'] = (0, $d0d6382a5bdf6377$export$d8bd0967cb58683).invalidCurrentPassword;
                    break;
                case 422:
                    (err.body?.errors ?? []).forEach((e)=>{
                        if (e.field === 'password' && e.rule === 'minLength') setFormErrors({
                            ...formErrors,
                            new_password: e.args.minLength ? `Password must be at least ${e.args.minLength} characters` : (0, $d0d6382a5bdf6377$export$d8bd0967cb58683).passwordTooShortGeneric
                        });
                        else globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updatePassword.error);
                    });
                    break;
                default:
                    globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).updatePassword.error);
                    break;
            }
        } finally{
            setIsUpdatingPassword(false);
        }
    };
    /* Effects */ (0, $2xPiy.useEffect)(()=>{
        if (formValues.name) document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, formValues.name);
    }, [
        formValues.name
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (userStore.user && userId) {
            if (!currentUserCanView) navigate(clientStore.activeClientId ? `/clients/${clientStore.activeClientId}/users` : '/');
            else {
                setIsLoading(true);
                setUser(undefined);
                fetchPageData(userId).finally(()=>setIsLoading(false));
            }
        }
    }, [
        userStore.user,
        userId,
        currentUserCanView,
        clientStore.activeClientId
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (!!filteredRoleIdOptions?.length && !formValues.role_id) setFormValues({
            ...formValues,
            role_id: filteredRoleIdOptions[0].value
        });
    }, [
        filteredRoleIdOptions,
        formValues
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (!user?.email) return;
        if (formValues.email !== user.email && !isChangingEmail) setIsChangingEmail(true);
        else if (formValues.email === user.email && isChangingEmail) setIsChangingEmail(false);
    }, [
        formValues.email,
        user?.email,
        isChangingEmail
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (isMultiClientUser && formValues.client_ids[0]) fetchFacilityOptions(formValues.client_ids[0]);
    }, [
        isMultiClientUser,
        formValues.client_ids
    ]);
    (0, $2xPiy.useEffect)(()=>{
        if (user && user.clients.length > 1) setShowMultipleClients(true);
    }, [
        user
    ]);
    //404 Redirect
    (0, $2xPiy.useEffect)(()=>{
        if (isLoading) return;
        if (user && user.id !== userId) return;
        setIsInvalidParams(Number.isNaN(userId) || user?.id === undefined);
    }, [
        userId,
        user,
        isLoading
    ]);
    /* Render */ return isInvalidParams ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8fedf23083f90239$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $3d99c6153124a6ba$export$7234abc5d81adb58), {
        title: user?.name ?? '',
        breadcrumbNav: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e7dd63b10d4904e9$export$988959db72b892c3), {
            previousPages: breadcrumbNavItems,
            currentPageName: user?.name ?? ''
        }),
        userInfoBar: user && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c7da1bfa2f532a8b$export$99620e8a9a901b92), {
            user: user,
            isActive: !!formValues.is_active,
            setIsActive: (value)=>updateFormValue('is_active', value),
            userCanEdit: !!currentUserCanEdit
        }),
        isLoading: isLoading,
        isUserPage: true,
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                fill: "horizontal",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $04d59a1221f4208a$export$a7fed597f4b8afd8), {
                    noValidate: true,
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        direction: isOwnUser && !isMobile ? 'row' : 'column',
                        gap: "1rem",
                        children: [
                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $98b6153ed086d9bd$export$11154b700737b45e), {
                                title: t('user:userInformation'),
                                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7dacb42a28be9c15$export$7036cd8426a1245b), {
                                    size: "24px",
                                    color: "brand"
                                }),
                                isLoading: isLoading || isUpdating || isUpdatingPassword,
                                onSubmit: updateUser,
                                saveButtonLabel: t('common:saveChanges'),
                                saveButtonDisabled: !hasChanges,
                                hideRequiredText: false,
                                fill: isOwnUser && !isMobile ? undefined : 'horizontal',
                                width: isOwnUser && !isMobile ? '60%' : undefined,
                                hideSaveButton: !currentUserCanEdit,
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                    direction: !isOwnUser && !isMobile ? 'row' : 'column',
                                    gap: "1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                            title: t('user:contactInformation'),
                                            width: !isOwnUser && !isMobile ? '50%' : '100%',
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    name: "user_name",
                                                    label: t('common:name'),
                                                    value: formValues.name,
                                                    setValue: (value)=>updateFormValue('name', value),
                                                    error: formErrors['name'],
                                                    onSubmit: updateUser,
                                                    disabled: !currentUserCanEdit,
                                                    required: true
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    name: "user_email",
                                                    label: t('user:email'),
                                                    type: "email",
                                                    value: formValues.email,
                                                    setValue: (value)=>updateFormValue('email', value),
                                                    error: formErrors['email'],
                                                    onSubmit: updateUser,
                                                    disabled: !currentUserCanEdit,
                                                    required: true
                                                }),
                                                isChangingEmail && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7dacb42a28be9c15$export$7036cd8426a1245b), {
                                                            size: "16px"
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                            fontFamily: "Lato, sans-serif",
                                                            children: `A verification email will be sent to this email address. Until the new address is verified, ${isOwnUser ? 'you' : 'this User'} must continue using ${isOwnUser ? 'your' : 'their'} current email address to log in.`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                                    name: "user_phone",
                                                    label: t('user:phone'),
                                                    value: formValues.phone,
                                                    setValue: (value)=>updateFormValue('phone', formatPhoneNumber(value)),
                                                    error: formErrors['phone'],
                                                    onSubmit: updateUser,
                                                    disabled: !currentUserCanEdit,
                                                    placeholder: isPhoneFocused ? '(555) 555-5555' : '',
                                                    onFocus: ()=>setIsPhoneFocused(true),
                                                    onBlur: ()=>setIsPhoneFocused(false)
                                                })
                                            ]
                                        }),
                                        !isOwnUser && !isMobile ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                            direction: "vertical",
                                            margin: "3rem"
                                        }) : /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                            margin: "0.5rem"
                                        }),
                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                            width: !isOwnUser && !isMobile ? '50%' : '100%',
                                            gap: "1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                                    title: t('user:userRole'),
                                                    children: [
                                                        isMultiClientUser && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7dacb42a28be9c15$export$7036cd8426a1245b), {
                                                                    size: "16px"
                                                                }),
                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                    fontFamily: "Lato, sans-serif",
                                                                    children: [
                                                                        "User Role applies to all Companies ",
                                                                        isOwnUser ? 'you are' : 'this User is',
                                                                        " assigned to."
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                            name: "role_id",
                                                            label: t('user:userRole'),
                                                            value: formValues.role_id,
                                                            setValue: (value)=>updateFormValue('role_id', value),
                                                            error: formErrors['role_id'],
                                                            options: filteredRoleIdOptions ?? [],
                                                            required: true,
                                                            disabled: !currentUserCanEdit || isOwnUser
                                                        }),
                                                        (0, $a65473e9746b33bb$export$39d571c105d2314f).includes(formValues.role_id) && user && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $cb4cc5db45d03478$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                    direction: "row",
                                                                    align: "center",
                                                                    gap: "small",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                            flex: "grow",
                                                                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $209e44abb3ffd31f$export$c57133fe35f19a3e), {
                                                                                label: t('user:company'),
                                                                                selectedClientId: formValues.client_ids[0],
                                                                                setSelectedClientId: (value)=>{
                                                                                    if (value && value !== formValues.client_ids[0]) {
                                                                                        const oldClientId = formValues.client_ids[0];
                                                                                        const applyChange = ()=>{
                                                                                            const updatedClientIds = [
                                                                                                ...formValues.client_ids
                                                                                            ];
                                                                                            updatedClientIds[0] = value;
                                                                                            updateFormValue('client_ids', updatedClientIds);
                                                                                        };
                                                                                        if (oldClientId) checkLastAdminAndProceed(oldClientId, applyChange);
                                                                                        else applyChange();
                                                                                    }
                                                                                },
                                                                                options: !userStore.isFuseAdmin && user ? user.clients.map((c)=>({
                                                                                        label: c.name,
                                                                                        value: c.id
                                                                                    })) : undefined,
                                                                                excludeClientIds: formValues.client_ids.filter((id)=>id !== formValues.client_ids[0]),
                                                                                error: formErrors['client_ids'],
                                                                                disabled: !userStore.isFuseAdmin || isOwnUser || formValues.role_id === (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FacilityAdmin,
                                                                                required: true
                                                                            })
                                                                        }),
                                                                        formValues.client_ids[0] && formValues.role_id !== (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FacilityAdmin && userStore.isFuseAdmin && !isOwnUser && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                                                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b354176c7fc1b147$export$d0265b2c425512d6), {
                                                                                size: "medium"
                                                                            }),
                                                                            onClick: ()=>{
                                                                                const updatedClientIds = [
                                                                                    ...formValues.client_ids
                                                                                ];
                                                                                updatedClientIds.push(undefined);
                                                                                updateFormValue('client_ids', updatedClientIds);
                                                                                setShowMultipleClients(true);
                                                                            },
                                                                            plain: true,
                                                                            tip: tooltips.addAnotherCompany
                                                                        })
                                                                    ]
                                                                }),
                                                                showMultipleClients && formValues.client_ids.length > 1 && formValues.role_id !== (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FacilityAdmin && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                    margin: {
                                                                        top: '1rem'
                                                                    },
                                                                    gap: "1rem",
                                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ac0830614d9d3eb7$export$d306034f499f617e), {
                                                                        title: "Additional Companies",
                                                                        children: formValues.client_ids.slice(1).map((clientId, index)=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                                direction: "row",
                                                                                align: "center",
                                                                                gap: "small",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                                        flex: "grow",
                                                                                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $209e44abb3ffd31f$export$c57133fe35f19a3e), {
                                                                                            name: `selected_client_${index + 2}`,
                                                                                            label: `Company ${index + 2}`,
                                                                                            selectedClientId: clientId,
                                                                                            setSelectedClientId: (value)=>{
                                                                                                if (value) {
                                                                                                    const updatedClientIds = [
                                                                                                        ...formValues.client_ids
                                                                                                    ];
                                                                                                    updatedClientIds[index + 1] = value;
                                                                                                    updateFormValue('client_ids', updatedClientIds);
                                                                                                }
                                                                                            },
                                                                                            options: !userStore.isFuseAdmin && user ? user.clients.map((c)=>({
                                                                                                    label: c.name,
                                                                                                    value: c.id
                                                                                                })) : undefined,
                                                                                            excludeClientIds: formValues.client_ids.filter((id)=>id !== clientId),
                                                                                            error: formErrors['client_ids'],
                                                                                            disabled: !userStore.isFuseAdmin
                                                                                        })
                                                                                    }),
                                                                                    userStore.isFuseAdmin && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                                                                        icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c1da19823027de53$export$f39c2d165cd861fe), {}),
                                                                                        onClick: ()=>checkLastAdminAndProceed(clientId, ()=>removeClientAtIndex(index)),
                                                                                        plain: true
                                                                                    })
                                                                                ]
                                                                            }, `client-${index + 1}`))
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        formValues.role_id === (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FacilityAdmin && !isOwnUser && !!facilityOptions?.length && (isMultiClientUser ? !!formValues.client_ids[0] : true) && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $cc59cdc159c0357e$export$ef9b1a59e592288f), {
                                                            name: "facility_ids",
                                                            multiple: true,
                                                            label: t('common:facilities'),
                                                            values: formValues.facility_ids,
                                                            setValues: (value)=>updateFormValue('facility_ids', value),
                                                            options: facilityOptions,
                                                            error: formErrors['facility_ids'],
                                                            required: true,
                                                            disabled: isLoadingFacilities
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                                    margin: "0.5rem"
                                                }),
                                                user && userStore.isFuseAdmin && !isOwnUser && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                                                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                        gap: "1rem",
                                                        flex: "grow",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                color: "dark-1",
                                                                size: "large",
                                                                weight: 300,
                                                                children: "Password Reset URL"
                                                            }),
                                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                direction: !isOwnUser && !isMobile ? 'row' : 'column',
                                                                gap: "1rem",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ad3dfa44adb42595$export$353f5b6fc5456de1), {
                                                                        label: "Generate",
                                                                        height: (0, $00658ccd6ec0135a$export$dbd2438c8f5569e9)(45),
                                                                        toUpperCase: false,
                                                                        width: !isOwnUser && !isMobile ? '20%' : '100%',
                                                                        onClick: ()=>getPasswordResetUrl(user.id),
                                                                        disabled: isLoadingPasswordResetUrl
                                                                    }),
                                                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                        background: "white",
                                                                        direction: "row",
                                                                        flex: "grow",
                                                                        pad: {
                                                                            horizontal: '0.75rem',
                                                                            vertical: isMobile ? '0.5rem' : undefined
                                                                        },
                                                                        width: !isOwnUser && !isMobile ? '80%' : '100%',
                                                                        gap: "xsmall",
                                                                        border: {
                                                                            color: 'light-5',
                                                                            size: '0.8px'
                                                                        },
                                                                        borderRadius: "6px",
                                                                        align: "center",
                                                                        justify: "between",
                                                                        children: [
                                                                            !isLoadingPasswordResetUrl && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                                animation: {
                                                                                    type: 'fadeIn',
                                                                                    duration: 300
                                                                                },
                                                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                                                    truncate: true,
                                                                                    children: passwordResetUrl
                                                                                })
                                                                            }),
                                                                            isLoadingPasswordResetUrl && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                                align: "center",
                                                                                fill: "horizontal",
                                                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8bec6e2e7dc53c4a$export$7f7cbe89f1eacd2), {})
                                                                            }),
                                                                            !!passwordResetUrl && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                                                                animation: {
                                                                                    type: 'fadeIn',
                                                                                    duration: 300
                                                                                },
                                                                                align: "center",
                                                                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                                                                                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6b8bc0905d64141c$export$92ce62e1201c4fc0), {
                                                                                        size: "16px",
                                                                                        color: "light-3"
                                                                                    }),
                                                                                    tip: tooltips.copyToClipboard,
                                                                                    onClick: ()=>copyToClipboard(passwordResetUrl)
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            isOwnUser && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $98b6153ed086d9bd$export$11154b700737b45e), {
                                title: t('user:updatePassword'),
                                icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9dbd97790657d539$export$5b9db7ce80343746), {
                                    size: "24px",
                                    color: "brand"
                                }),
                                isLoading: isLoading,
                                onSubmit: updatePassword,
                                fill: "horizontal",
                                children: [
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                                        children: [
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7dacb42a28be9c15$export$7036cd8426a1245b), {
                                                size: "16px"
                                            }),
                                            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                                fontFamily: "Lato, sans-serif",
                                                children: t('user:passwordRegex')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        name: "old_password",
                                        label: t('user:currentPassword'),
                                        value: oldPassword,
                                        setValue: setOldPassword,
                                        error: formErrors['old_password'],
                                        onSubmit: updatePassword,
                                        componentType: "password",
                                        hideOptionalText: true
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $6007641569af9929$export$17d680238e50603e), {
                                        margin: "0.5rem"
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        name: "new_password",
                                        label: t('user:newPassword'),
                                        value: newPassword,
                                        setValue: setNewPassword,
                                        error: formErrors['new_password'],
                                        onSubmit: updatePassword,
                                        componentType: "password",
                                        hideOptionalText: true
                                    }),
                                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b86c1b08804a61b5$export$f5b8910cec6cf069), {
                                        name: "confirm_password",
                                        label: t('user:confirmNewPassword'),
                                        value: confirmPassword,
                                        setValue: setConfirmPassword,
                                        error: formErrors['confirm_password'],
                                        onSubmit: updatePassword,
                                        componentType: "password",
                                        hideOptionalText: true
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            lastAdminWarning && /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $2a0d64d499f7ed44$export$936d0764594b6eb3), {
                position: "center",
                onEsc: ()=>setLastAdminWarning(null),
                onClickOutside: ()=>setLastAdminWarning(null),
                responsive: false,
                style: {
                    width: 'auto',
                    minWidth: 'min(95vw, 400px)',
                    maxWidth: 'min(95vw, 500px)',
                    maxHeight: '95vh',
                    overflow: 'auto',
                    borderRadius: '8px'
                },
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $98b6153ed086d9bd$export$11154b700737b45e), {
                    width: "100%",
                    title: "Warning",
                    icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e23e190c1adfeb13$export$a2518b5310db22ab), {
                        size: "24px",
                        color: "status-warning"
                    }),
                    onSubmit: ()=>{
                        lastAdminWarning.onConfirm();
                        setLastAdminWarning(null);
                    },
                    hideRequiredText: true,
                    saveButtonLabel: "REMOVE USER",
                    headerChildren: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $102e2aa1ff54ae51$export$353f5b6fc5456de1), {
                            pad: "none",
                            onClick: ()=>setLastAdminWarning(null),
                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c1da19823027de53$export$f39c2d165cd861fe), {
                                size: "20px"
                            }),
                            tip: tooltips.close
                        }, "close")
                    ],
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                        pad: {
                            horizontal: 'medium',
                            bottom: 'medium'
                        },
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $ed228084f3add613$export$aff4fc93593c3bcf), {
                            gap: "1rem",
                            direction: "row",
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $e23e190c1adfeb13$export$a2518b5310db22ab), {
                                    size: "medium",
                                    color: "status-warning"
                                }),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    children: "This user is the last active Client Admin for this company. Removing them will leave the company without an admin."
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
});




const $4a9c3fa00366ebb2$export$24ec20f6ad296aab = [
    // List Users
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/users",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            allowedRoles: (0, $a65473e9746b33bb$export$5d277a5d95a5046e),
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $0c15b61117139606$export$e396b9722e5a1ef5), {})
            })
        })
    }),
    // User Details
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/users/:user_id",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            isUserRoute: true,
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $1f80e0333df289c4$export$1c36a2cc17727340), {})
            })
        })
    }),
    // Create User
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/users/create",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            allowedRoles: [
                ...(0, $a65473e9746b33bb$export$5d277a5d95a5046e),
                (0, $a65473e9746b33bb$export$2cb4a31baf73b247).ClientAdmin
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c4eb1774c938025c$export$b5faf749c56418c7), {})
            })
        })
    }),
    // Create Facility User
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/clients/:client_id/facilities/:facility_id/users/create",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            allowedRoles: [
                ...(0, $a65473e9746b33bb$export$5d277a5d95a5046e),
                (0, $a65473e9746b33bb$export$2cb4a31baf73b247).ClientAdmin
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c4eb1774c938025c$export$b5faf749c56418c7), {})
            })
        })
    }),
    // Client User Details
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/clients/:client_id/users/:user_id",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            isUserRoute: true,
            allowedRoles: (0, $a65473e9746b33bb$export$7853a174aac8e6fa),
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $1f80e0333df289c4$export$1c36a2cc17727340), {})
            })
        })
    }),
    // Create Client User
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/clients/:client_id/users/create",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            allowedRoles: [
                ...(0, $a65473e9746b33bb$export$5d277a5d95a5046e),
                (0, $a65473e9746b33bb$export$2cb4a31baf73b247).ClientAdmin
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $c4eb1774c938025c$export$b5faf749c56418c7), {})
            })
        })
    }),
    // List Client Users
    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
        path: "/clients/:client_id/users",
        element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
            allowedRoles: [
                ...(0, $a65473e9746b33bb$export$5d277a5d95a5046e),
                (0, $a65473e9746b33bb$export$2cb4a31baf73b247).ClientAdmin
            ],
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $0c15b61117139606$export$e396b9722e5a1ef5), {})
            })
        })
    })
];




var $2xPiy = parcelRequire("2xPiy");












const $b803fe191ba76d45$var$VerifyEmail = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const globalStore = (0, $116967e0234c3770$export$ea7f481060e2c12e)();
    const params = (0, $62d58f5c28b15c2e$export$99eaa27ddbbb95ef)();
    const screenSize = (0, $2xPiy.useContext)((0, $10007abd86899141$export$51e389dae84ec233));
    /** State **/ const [isLoading, setIsLoading] = (0, $2xPiy.useState)(true);
    const [isValid, setIsValid] = (0, $2xPiy.useState)(true);
    /** Computed **/ const isMobile = (0, $18588a518ac6fdc7$export$2ac00d7098bf223)(screenSize);
    /** Methods **/ const verifyEmail = async (token)=>{
        try {
            setIsLoading(true);
            await (0, $1f30379e064ebff4$export$a81c579a392aa9d2).verifyEmail(token);
            (0, $05d5739209a21833$export$b410431fab84fa58).success((0, $a75b88ce77ba4923$export$40fb018dd4c59f8).verifyEmail.success);
        } catch (err) {
            const error = err;
            if (error.body?.message.toLowerCase() === 'invalid token') setIsValid(false);
            else globalStore.handleApiError(err, (0, $a75b88ce77ba4923$export$40fb018dd4c59f8).verifyEmail.error);
        } finally{
            setIsLoading(false);
        }
    };
    /** Effects **/ (0, $2xPiy.useEffect)(()=>{
        document.title = (0, $00658ccd6ec0135a$export$23286240952da4c9)((0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.basePageTitle, 'Verify Email');
    }, []);
    (0, $2xPiy.useEffect)(()=>{
        if (params.token) verifyEmail(params.token);
    }, [
        params.token
    ]);
    /** Render **/ const renderErrorPage = ()=>/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f068601a66842d6c$export$c1faa9c8f42906a), {
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                flex: "grow",
                justify: "center",
                align: "center",
                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $d5c194f24ad1f021$export$60332b2344f7fe41), {
                    flex: "shrink",
                    width: !isMobile ? '35%' : '80%',
                    margin: {
                        bottom: 'xlarge'
                    },
                    children: [
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9bd8d23e517716cc$export$5665775b26e26c5d), {
                            title: "Invalid Token",
                            icon: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $11571e85aa9685ed$export$5a89edf87f611fb5), {
                                color: "brand"
                            })
                        }),
                        /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $9e4283f3707f7e0b$export$851de33184ecdac4), {
                            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7c6b91b494af203a$export$e71c4d32a2263218), {
                                children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7d936c80978f5831$export$5f1af8db9871e1d6), {
                                    fontFamily: "Lato, sans-serif",
                                    children: "This token is invalid or has expired. Please re-enter your new email address on your User Profile page to try again."
                                })
                            })
                        })
                    ]
                })
            })
        });
    return isLoading ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $edf5e45107627661$export$b08b517936747730), {}) : isValid ? /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$444b3ab0cb9aec40), {
        to: "/login",
        state: {
            didVerify: true
        }
    }) : renderErrorPage();
});
var $b803fe191ba76d45$export$2e2bcd8739ae039 = $b803fe191ba76d45$var$VerifyEmail;





const $3164dd25a1168b41$export$37d3279522fbf5e2 = ()=>{
    const location = (0, $62d58f5c28b15c2e$export$45d76561a5302f2b)();
    const userStore = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const hsq = window._hsq = window._hsq || [];
    (0, $2xPiy.useEffect)(()=>{
        if (userStore.user) {
            hsq.push([
                'identify',
                {
                    id: userStore.user.id,
                    email: userStore.user.email
                }
            ]);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const dataLayer = window.dataLayer = window.dataLayer || [];
            const analyticsData = {
                event: 'user_authenticated',
                user_role: userStore.user.role.name,
                user_role_id: userStore.user.role.id,
                traffic_type: userStore.user.is_internal ? 'internal' : 'external'
            };
            dataLayer.push(analyticsData);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (typeof window.gtag === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            window.gtag('config', 'G-FX79ZFCZF9', {
                traffic_type: userStore.user.is_internal ? 'internal' : 'external'
            });
        }
    }, [
        userStore.user
    ]);
    (0, $2xPiy.useEffect)(()=>{
        hsq.push([
            'setPath',
            location.pathname
        ]);
        hsq.push([
            'trackPageView'
        ]);
    }, [
        location
    ]);
    return /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $62d58f5c28b15c2e$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
                path: "*",
                element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8fedf23083f90239$export$2e2bcd8739ae039), {})
            }),
            ...(0, $4a9c3fa00366ebb2$export$24ec20f6ad296aab),
            ...(0, $d44804e75825a5af$export$a158435f6056802d),
            ...(0, $874f8f08b8aec6cf$export$9dde37202ea57dd2),
            ...(0, $3f4f35e0fca6a8e0$export$54cdcf02be6d6712),
            ...(0, $adb002a716b62561$export$f7ef6de0a68edfe8),
            ...(0, $3d825225a4fbdfd5$export$c8fb8863e470b0d1),
            ...(0, $ec5e163b64c585f7$export$b373742c5e146c8f),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
                path: "/search",
                element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $8f3a67a71a69506d$export$2e2bcd8739ae039), {})
                    })
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
                path: "/login",
                element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $57ec1def7063bada$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
                path: "/logout",
                element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $90034d9b075807b1$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
                path: "/reset-password",
                element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ac4967610aa7edb5$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
                path: "/reset-password/:token",
                element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $fbba412005be5380$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
                path: "/verify-email/:token",
                element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b803fe191ba76d45$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
                path: "/api-data",
                element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
                    allowedRoles: [
                        (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FuseAdmin
                    ],
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $506e53226ab4525a$export$2e2bcd8739ae039), {})
                    })
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
                path: "/api-data-old",
                element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
                    allowedRoles: [
                        (0, $a65473e9746b33bb$export$2cb4a31baf73b247).FuseAdmin
                    ],
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $ff6fd5b6568aef67$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $62d58f5c28b15c2e$export$e7b0ac011bb776c6), {
                path: "/",
                element: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $d82a1fe0d9d455d5$export$8ef2ed426dede42d), {
                    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $f2ed542b0753eadc$export$85c5a83f4045b2d2), {
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $7e90f04af0cdf48d$export$2e2bcd8739ae039), {})
                    })
                })
            })
        ]
    });
};



const $eef22ed386bfac5e$var$queryClient = new (0, $73c27837fee14e76$export$405d0624ed55a03f)({
    defaultOptions: {
        queries: {
            staleTime: 60000,
            gcTime: 600000,
            refetchOnWindowFocus: false
        }
    }
});
const $eef22ed386bfac5e$var$ScrollToTop = ()=>{
    const location = (0, $62d58f5c28b15c2e$export$45d76561a5302f2b)();
    const navigationType = (0, $62d58f5c28b15c2e$export$1b3f31771c5d07c)();
    const { listRestoreStore: listRestoreStore } = (0, $116967e0234c3770$export$5bc58655df8395ab)();
    (0, $2xPiy.useEffect)(()=>{
        if (navigationType === 'POP' && listRestoreStore.consumeRestore(location.pathname)) return;
        setTimeout(()=>{
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'auto'
            });
        }, 0);
    }, [
        location.pathname,
        navigationType
    ]);
    return null;
};
const $eef22ed386bfac5e$var$FuseAdminEffects = (0, $89048ae0dfc4e98d$export$b6ae1bc530f4c149)(()=>{
    const { isFuseAdmin: isFuseAdmin } = (0, $116967e0234c3770$export$cc885caaa8b7ab4e)();
    const { i18n: i18n } = (0, $10bacddb66d871e8$export$9fc83ad70ead8663)();
    (0, $2xPiy.useEffect)(()=>{
        const className = 'is-fuse-admin';
        if (isFuseAdmin) {
            document.body.classList.add(className);
            if (i18n.language !== 'en') i18n.changeLanguage('en');
        } else document.body.classList.remove(className);
        return ()=>{
            document.body.classList.remove(className);
        };
    }, [
        isFuseAdmin,
        i18n
    ]);
    return null;
});
const $eef22ed386bfac5e$var$rootElement = document.getElementById('app');
{
    const devFaviconUrl = new URL((0, (/*@__PURE__*/$parcel$interopDefault($111d14fdfd9806e4$exports))), (0, $861eff1f71c0dec6$export$e506a1d27d1eaa20).client.url).href;
    document.getElementById('favicon')?.setAttribute('href', devFaviconUrl);
}$eef22ed386bfac5e$var$rootElement && (0, (/*@__PURE__*/$parcel$interopDefault($e713b0fd8096c0fb$exports))).createRoot($eef22ed386bfac5e$var$rootElement).render(/*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2xPiy))).StrictMode, {
    children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $bccbe1b43ff3d0cc$export$45604f0cc8ae667b), {
        client: $eef22ed386bfac5e$var$queryClient,
        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $116967e0234c3770$export$773ef8ccef99e88a), {
            children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $79bcac94ca400be1$export$9ba4e89fdfa1fc54), {
                future: {
                    v7_startTransition: true,
                    v7_relativeSplatPath: true
                },
                children: [
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)($eef22ed386bfac5e$var$ScrollToTop, {}),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)($eef22ed386bfac5e$var$FuseAdminEffects, {}),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $b7bc42650fa26391$export$415798a788f40554), {}),
                    /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $df54d7f5d50e45c1$export$efa1b86658154a31), {
                        theme: (0, $edb3b666553e0b8a$export$2e2bcd8739ae039),
                        children: /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsxs)((0, $0a3e98ef9be0c428$export$b735bbab4dd866a3), {
                            children: [
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $3164dd25a1168b41$export$37d3279522fbf5e2), {}),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $44eeea64131db5d9$export$ddd501dda1f62236), {}),
                                /*#__PURE__*/ (0, $cb4cc5db45d03478$exports.jsx)((0, $05d5739209a21833$export$f2815235e76a62b9), {
                                    position: "top-right",
                                    autoClose: 1750,
                                    hideProgressBar: false,
                                    newestOnTop: false,
                                    pauseOnFocusLoss: false,
                                    draggable: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    closeButton: false,
                                    style: {
                                        top: '60px'
                                    }
                                })
                            ]
                        })
                    })
                ]
            })
        })
    })
}));


//# sourceMappingURL=public.2a256ce4.js.map
